/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7017);
	module.exports = __webpack_require__(7184);


/***/ },
/* 1 */
/***/ function(module, exports) {

	function _interopRequireDefault(e) {
	  return e && e.__esModule ? e : {
	    "default": e
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(7204);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSvgIcon;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(166));
	
	function createSvgIcon(path, displayName) {
	  var Component = _react.default.memo(_react.default.forwardRef(function (props, ref) {
	    return _react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
	      ref: ref
	    }, props), path);
	  }));
	
	  if (false) {
	    Component.displayName = "".concat(displayName, "Icon");
	  }
	
	  Component.muiName = _SvgIcon.default.muiName;
	  return Component;
	}

/***/ },
/* 4 */
/***/ function(module, exports) {

	function _extends() {
	  return module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
	    for (var e = 1; e < arguments.length; e++) {
	      var t = arguments[e];
	      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
	    }
	    return n;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
	}
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(6971)();
	}


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(6964)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(215)(module)))

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(55)["default"];
	function _interopRequireWildcard(e, t) {
	  if ("function" == typeof WeakMap) var r = new WeakMap(),
	    n = new WeakMap();
	  return (module.exports = _interopRequireWildcard = function _interopRequireWildcard(e, t) {
	    if (!t && e && e.__esModule) return e;
	    var o,
	      i,
	      f = {
	        __proto__: null,
	        "default": e
	      };
	    if (null === e || "object" != _typeof(e) && "function" != typeof e) return f;
	    if (o = t ? n : r) {
	      if (o.has(e)) return o.get(e);
	      o.set(e, f);
	    }
	    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
	    return f;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports)(e, t);
	}
	module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports = {
	  conexion: "https://www.athos.com.ve/api",
	  //conexion: "http://192.168.100.30:5030",
	  servidor: "https://www.athos.com.ve/api",
	  pyserver: "https://www.athos.com.ve/sistema",
	  titulo: "ATHOS",
	  reportes: "https://www.athos.com.ve/api2/athos",
	  //reportes: "http://192.168.100.30:4010/athos",
	  email: "http://3.141.30.169:5000",
	  validar: "https://sygreca.com.ve/api",
	  iframe: "https://iframe.athos.com.ve"
	};
	
	
	/* module.exports = {
	  conexion: "https://athos-erp.opensiap.com.ve/api",
	  servidor: "https://athos-erp.opensiap.com.ve/api",
	  pyserver: "https://athos-erp.opensiap.com.ve/sistema",
	  titulo: "ATHOS",
	  reportes: "https://athos-erp.opensiap.com.ve/api2/athos",
	  email: "http://3.141.30.169:5000",
	  validar: "https://sygreca.com.ve/api",
	}; */
	
	
	/* module.exports = {
	  conexion: "http://localhost:5030",
	  pyserver: "https://www.athos.com.ve/sistema",
	  titulo: "ATHOS",
	  //reportes: "https://www.athos.com.ve/api2/athos",
	  reportes: "http://localhost:4010/athos",
	  email: "http://3.141.30.169:5000",
	  iframe: "https://iframe.athos.com.ve"
	}  */


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AgregarProducto = exports.MensajeCapcha = exports.MensajeSiNo = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.Mensaje = Mensaje;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Button = __webpack_require__(6974);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _varios = __webpack_require__(14);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Mensaje(props) {
	    var btnAceptar = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)(''),
	        _useState2 = _slicedToArray(_useState, 2),
	        icono = _useState2[0],
	        setIcono = _useState2[1];
	
	    function icon(icono) {
	
	        switch (icono) {
	            case 'exito':
	                setIcono(_react2.default.createElement('i', { className: 'fas fa-check-double fa-5x text-center text-success' }));
	                break;
	            case 'error':
	                setIcono(_react2.default.createElement('i', { className: 'fas fa-exclamation-triangle fa-5x text-center text-danger' }));
	                break;
	            case 'informacion':
	                setIcono(_react2.default.createElement('i', { className: 'fas fa-exclamation fa-5x text-center text-info' }));
	                break;
	            default:
	                break;
	        }
	    }
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'md',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            backdrop: 'static',
	            animation: false,
	            keyboard: false,
	            show: props.mensaje.mostrar,
	            onShow: function onShow() {
	                icon(props.mensaje.icono);btnAceptar.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            { style: { backgroundColor: "#ffffff" } },
	            _react2.default.createElement(
	                'div',
	                { className: 'row col-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12 p-2' },
	                    _react2.default.createElement(
	                        'h2',
	                        { style: { textAlign: 'center', fontWeight: 'bold', color: "#595959" } },
	                        props.mensaje.titulo
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12 p-2 text-center' },
	                    icono
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12 p-2' },
	                    _react2.default.createElement(
	                        'p',
	                        { style: { textAlign: 'center' } },
	                        props.mensaje.texto
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12 p-2' },
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-sm rounded-pill btn-primary col-3', style: { marginLeft: '38%' }, ref: btnAceptar, onClick: props.onHide },
	                        'Aceptar'
	                    )
	                )
	            )
	        )
	    );
	}
	
	var MensajeSiNo = exports.MensajeSiNo = function MensajeSiNo(props) {
	    var btnSi = (0, _react.useRef)();
	    var btnNo = (0, _react.useRef)();
	
	    var _useState3 = (0, _react.useState)(''),
	        _useState4 = _slicedToArray(_useState3, 2),
	        icono = _useState4[0],
	        setIcono = _useState4[1];
	
	    function icon(icono) {
	
	        switch (icono) {
	            case 'exito':
	                setIcono(_react2.default.createElement('i', { className: 'fas fa-check-double fa-5x text-center text-success' }));
	                break;
	            case 'error':
	                setIcono(_react2.default.createElement('i', { className: 'fas fa-exclamation-triangle fa-5x text-center text-danger' }));
	                break;
	            case 'informacion':
	                setIcono(_react2.default.createElement('i', { className: 'fas fa-exclamation fa-5x text-center text-info' }));
	                break;
	            case 'confirmacion':
	                setIcono(_react2.default.createElement('i', { className: 'fas fa-question fa-5x text-center text-warning' }));
	                break;
	            default:
	                break;
	        }
	    }
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'md',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            backdrop: 'static',
	            animation: false,
	            keyboard: false,
	            show: props.mensaje.mostrar,
	            onShow: function onShow() {
	                icon(props.mensaje.icono);btnSi.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            { style: { backgroundColor: "#ffffff" } },
	            _react2.default.createElement(
	                'div',
	                { className: 'row col-12 mx-auto' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12 p-2' },
	                    _react2.default.createElement(
	                        'h2',
	                        { style: { textAlign: 'center', fontWeight: 'bold', color: "#595959" } },
	                        props.mensaje.titulo
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12 p-2 text-center' },
	                    icono
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12 p-2' },
	                    _react2.default.createElement(
	                        'p',
	                        { style: { textAlign: 'center' } },
	                        props.mensaje.texto
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row col-12 p-2 d-flex justify-content-center mx-auto' },
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-sm rounded-pill btn-success col-5 mx-2', ref: btnSi, onClick: props.onHideSi },
	                        'Si'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-sm rounded-pill btn-danger col-5 mx-2', ref: btnNo, onClick: props.onHideNo },
	                        'No'
	                    )
	                )
	            )
	        )
	    );
	};
	
	var MensajeCapcha = exports.MensajeCapcha = function MensajeCapcha(props) {
	    var btnCancela = (0, _react.useRef)();
	    var btnAcepta = (0, _react.useRef)();
	    var txtValor = (0, _react.useRef)();
	
	    var handleInputChange = function handleInputChange(event) {
	
	        if (event.which === 13) {
	            if (event.target.value.trim() === '') {
	                txtValor.current.focus();
	            } else {
	                btnAcepta.current.focus();
	            }
	        } else if (event.which === 46) {
	            return false;
	        } else if (event.which >= 48 && event.which <= 57) {
	            return true;
	        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	            return true;
	        } else return false; //alert(e.which);
	    };
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'sm',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                (0, _varios.Captcha)();txtValor.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            null,
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                null,
	                _react2.default.createElement(
	                    'i',
	                    null,
	                    'Confirmaci\xF3n'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Imagen de Seguridad:'
	                ),
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Introduzca el C\xF3digo de la Imagen:'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    null,
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('canvas', { id: 'captcha' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', { ref: txtValor, autoFocus: true, type: 'text', className: 'input-group', id: 'txtInput', onKeyUp: handleInputChange })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', { type: 'button', id: 'refresh', className: 'btn btn-success', defaultValue: 'actualizar', onClick: _varios.Captcha })
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, onClick: props.onHideAcepta, className: 'btn btn-primary col-md-2' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fa' },
	                    '  Aceptar'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: props.onHideCancela, className: 'btn btn-danger col-md-2' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fa' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	var AgregarProducto = exports.AgregarProducto = function AgregarProducto(props) {
	    var btnSi = (0, _react.useRef)();
	    var btnNo = (0, _react.useRef)();
	
	    var _useState5 = (0, _react.useState)(''),
	        _useState6 = _slicedToArray(_useState5, 2),
	        icono = _useState6[0],
	        setIcono = _useState6[1];
	
	    var txtUnidad = (0, _react.useRef)();
	    var txtTotalPagar = (0, _react.useRef)();
	    var txtPercioUni = (0, _react.useRef)();
	    var txtProducto = (0, _react.useRef)();
	    var txtCantAlm = (0, _react.useRef)();
	    var txtCantPed = (0, _react.useRef)();
	
	    var _useState7 = (0, _react.useState)(),
	        _useState8 = _slicedToArray(_useState7, 2),
	        operacion = _useState8[0],
	        setOperacion = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(),
	        _useState10 = _slicedToArray(_useState9, 2),
	        unidades = _useState10[0],
	        setUnidades = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(false),
	        _useState12 = _slicedToArray(_useState11, 2),
	        activate = _useState12[0],
	        setActivate = _useState12[1];
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	
	    var onChange = function onChange(e) {
	
	        if (e.target.name === 'cantidad') {
	            if (e.target.value !== '') {
	                var monto = parseFloat(txtPercioUni.current.value.trim().replace(/\./g, '').replace(',', '.')) * parseInt(e.target.value);
	                txtTotalPagar.current.value = (0, _varios.formatMoneda)(monto.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	            } else {
	                txtTotalPagar.current.value = parseFloat('0,00');
	            }
	        }
	    };
	
	    var agregar = function agregar() {
	        props.onHideProdSi(txtProducto.current.value, txtPercioUni.current.value, txtCantPed.current.value, txtTotalPagar.current.value, icono, txtUnidad.current.value);
	    };
	
	    var onChangeValidar = function onChangeValidar() {
	        var sigue = true;
	        if (txtUnidad.current.value === '') {
	            txtUnidad.current.focus();
	            sigue = false;
	        } else if (txtCantPed.current.value === '') {
	            txtCantPed.current.focus();
	            sigue = false;
	        }
	
	        if (sigue) {
	            agregar();
	        }
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = 'idunidadmedida, trim(descripcion) as descripcion';
	        var nomtab = 'unidadmedida';
	        var orden = 'idunidadmedida';
	
	        var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setUnidades(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            //setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	
	
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    (0, _react.useEffect)(function () {
	        seleccionarRegistros();
	    }, []);
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            backdrop: 'static',
	            animation: false,
	            keyboard: false,
	            show: props.mensaje.mostrar,
	            onShow: function onShow() {
	
	                setIcono(props.mensaje.icono);
	                setOperacion(props.mensaje.operacion);
	                txtTotalPagar.current.value = props.mensaje.operacion !== 1 ? props.mensaje.total : parseFloat('0,00');
	                btnSi.current.focus();
	
	                if (props.mensaje.operacion !== 1) {
	                    txtUnidad.current.value = props.mensaje.unidad;
	                }
	            }
	
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            { style: { backgroundColor: "#ffffff" } },
	            _react2.default.createElement(
	                'div',
	                { className: 'row col-12 mx-auto' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12 p-2' },
	                    _react2.default.createElement(
	                        'h2',
	                        { style: { textAlign: 'center', fontWeight: 'bold', color: "#595959" } },
	                        props.mensaje.titulo
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-12 p-2 text-center row mx-auto' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-5' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-12 d-flex justify-content-center' },
	                            _react2.default.createElement('input', { autoComplete: 'off', style: { fontSize: '15px' }, type: 'text', ref: txtProducto, className: 'form-control rounded col-md-7 bg-transparent border-0 text-center', value: props.mensaje.texto, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                        ),
	                        _react2.default.createElement('img', { className: 'img-fluid', src: op.conexion + '/imagen?img=' + icono })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-7' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-12  d-flex justify-content-between mt-5' },
	                            _react2.default.createElement(
	                                'label',
	                                { style: { fontSize: '15px' }, className: 'input-group-text bg-transparent border-0', id: 'inputGroup-sizing-sm' },
	                                'Unidad:'
	                            ),
	                            _react2.default.createElement(
	                                'select',
	                                { name: 'nacionalidad', ref: txtUnidad, style: { fontSize: '15px' }, className: 'form-select form-select-sm rounded col-md-5', 'aria-label': '.form-select-sm example', onChange: onChange },
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: '' },
	                                    '--'
	                                ),
	                                unidades && unidades.map(function (item, index) {
	                                    return _react2.default.createElement(
	                                        'option',
	                                        { key: index, value: item.idunidadmedida },
	                                        ' ',
	                                        item.descripcion,
	                                        ' '
	                                    );
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-12 d-flex justify-content-between' },
	                            _react2.default.createElement(
	                                'label',
	                                { style: { fontSize: '15px' }, className: 'input-group-text bg-transparent border-0', id: 'inputGroup-sizing-sm' },
	                                'Precio Unitario:'
	                            ),
	                            _react2.default.createElement('input', { autoComplete: 'off', style: { fontSize: '15px' }, type: 'text', ref: txtPercioUni, className: 'form-control rounded col-md-7 bg-transparent border-0 text-right', value: props.mensaje.precio, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-12 d-flex justify-content-between' },
	                            _react2.default.createElement(
	                                'label',
	                                { style: { fontSize: '15px' }, className: 'input-group-text bg-transparent border-0', id: 'inputGroup-sizing-sm' },
	                                'Cantidad Disponible:'
	                            ),
	                            _react2.default.createElement('input', { autoComplete: 'off', style: { fontSize: '15px' }, type: 'text', ref: txtCantAlm, className: 'form-control rounded col-md-7 bg-transparent border-0 text-right', value: props.mensaje.disponible, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-12 d-flex justify-content-between' },
	                            _react2.default.createElement(
	                                'label',
	                                { style: { fontSize: '15px' }, className: 'input-group-text bg-transparent border-0', id: 'inputGroup-sizing-sm' },
	                                'Cantidad de Pedido:'
	                            ),
	                            _react2.default.createElement('input', { autoComplete: 'off', style: { fontSize: '15px' }, type: 'text', ref: txtCantPed, className: 'form-control rounded col-md-4 text-right', 'aria-label': 'Sizing example input', defaultValue: props.mensaje ? props.mensaje.cantidad !== '' ? props.mensaje.cantidad : 1 : 1, 'aria-describedby': 'inputGroup-sizing-sm', name: 'cantidad', onChange: onChange })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-12 d-flex justify-content-between' },
	                            _react2.default.createElement(
	                                'label',
	                                { style: { fontSize: '15px' }, className: 'input-group-text bg-transparent border-0', id: 'inputGroup-sizing-sm' },
	                                'Total Pagar:'
	                            ),
	                            _react2.default.createElement('input', { autoComplete: 'off', style: { fontSize: '15px' }, type: 'text', ref: txtTotalPagar, className: 'form-control rounded col-md-7 bg-transparent border-0 text-right', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row col-12 p-2 d-flex justify-content-center mx-auto mt-2' },
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-sm rounded-pill btn-success col-md-2 mx-2', ref: btnSi, onClick: onChangeValidar },
	                        'Agregar'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-sm rounded-pill btn-danger col-md-2 mx-2', ref: btnNo, onClick: operacion === 1 || operacion === 3 ? props.onHideProdNo : agregar },
	                        'Cancelar'
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(6656);

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Ref", {
	  enumerable: true,
	  get: function get() {
	    return _reactComponentRef.Ref;
	  }
	});
	Object.defineProperty(exports, "Confirm", {
	  enumerable: true,
	  get: function get() {
	    return _Confirm2["default"];
	  }
	});
	Object.defineProperty(exports, "MountNode", {
	  enumerable: true,
	  get: function get() {
	    return _MountNode2["default"];
	  }
	});
	Object.defineProperty(exports, "Pagination", {
	  enumerable: true,
	  get: function get() {
	    return _Pagination2["default"];
	  }
	});
	Object.defineProperty(exports, "PaginationItem", {
	  enumerable: true,
	  get: function get() {
	    return _PaginationItem2["default"];
	  }
	});
	Object.defineProperty(exports, "Portal", {
	  enumerable: true,
	  get: function get() {
	    return _Portal2["default"];
	  }
	});
	Object.defineProperty(exports, "PortalInner", {
	  enumerable: true,
	  get: function get() {
	    return _PortalInner2["default"];
	  }
	});
	Object.defineProperty(exports, "Radio", {
	  enumerable: true,
	  get: function get() {
	    return _Radio2["default"];
	  }
	});
	Object.defineProperty(exports, "Responsive", {
	  enumerable: true,
	  get: function get() {
	    return _Responsive2["default"];
	  }
	});
	Object.defineProperty(exports, "Select", {
	  enumerable: true,
	  get: function get() {
	    return _Select2["default"];
	  }
	});
	Object.defineProperty(exports, "TextArea", {
	  enumerable: true,
	  get: function get() {
	    return _TextArea2["default"];
	  }
	});
	Object.defineProperty(exports, "TransitionablePortal", {
	  enumerable: true,
	  get: function get() {
	    return _TransitionablePortal2["default"];
	  }
	});
	Object.defineProperty(exports, "Visibility", {
	  enumerable: true,
	  get: function get() {
	    return _Visibility2["default"];
	  }
	});
	Object.defineProperty(exports, "Breadcrumb", {
	  enumerable: true,
	  get: function get() {
	    return _Breadcrumb2["default"];
	  }
	});
	Object.defineProperty(exports, "BreadcrumbDivider", {
	  enumerable: true,
	  get: function get() {
	    return _BreadcrumbDivider2["default"];
	  }
	});
	Object.defineProperty(exports, "BreadcrumbSection", {
	  enumerable: true,
	  get: function get() {
	    return _BreadcrumbSection2["default"];
	  }
	});
	Object.defineProperty(exports, "Form", {
	  enumerable: true,
	  get: function get() {
	    return _Form2["default"];
	  }
	});
	Object.defineProperty(exports, "FormButton", {
	  enumerable: true,
	  get: function get() {
	    return _FormButton2["default"];
	  }
	});
	Object.defineProperty(exports, "FormCheckbox", {
	  enumerable: true,
	  get: function get() {
	    return _FormCheckbox2["default"];
	  }
	});
	Object.defineProperty(exports, "FormDropdown", {
	  enumerable: true,
	  get: function get() {
	    return _FormDropdown2["default"];
	  }
	});
	Object.defineProperty(exports, "FormField", {
	  enumerable: true,
	  get: function get() {
	    return _FormField2["default"];
	  }
	});
	Object.defineProperty(exports, "FormGroup", {
	  enumerable: true,
	  get: function get() {
	    return _FormGroup2["default"];
	  }
	});
	Object.defineProperty(exports, "FormInput", {
	  enumerable: true,
	  get: function get() {
	    return _FormInput2["default"];
	  }
	});
	Object.defineProperty(exports, "FormRadio", {
	  enumerable: true,
	  get: function get() {
	    return _FormRadio2["default"];
	  }
	});
	Object.defineProperty(exports, "FormSelect", {
	  enumerable: true,
	  get: function get() {
	    return _FormSelect2["default"];
	  }
	});
	Object.defineProperty(exports, "FormTextArea", {
	  enumerable: true,
	  get: function get() {
	    return _FormTextArea2["default"];
	  }
	});
	Object.defineProperty(exports, "Grid", {
	  enumerable: true,
	  get: function get() {
	    return _Grid2["default"];
	  }
	});
	Object.defineProperty(exports, "GridColumn", {
	  enumerable: true,
	  get: function get() {
	    return _GridColumn2["default"];
	  }
	});
	Object.defineProperty(exports, "GridRow", {
	  enumerable: true,
	  get: function get() {
	    return _GridRow2["default"];
	  }
	});
	Object.defineProperty(exports, "Menu", {
	  enumerable: true,
	  get: function get() {
	    return _Menu2["default"];
	  }
	});
	Object.defineProperty(exports, "MenuHeader", {
	  enumerable: true,
	  get: function get() {
	    return _MenuHeader2["default"];
	  }
	});
	Object.defineProperty(exports, "MenuItem", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItem2["default"];
	  }
	});
	Object.defineProperty(exports, "MenuMenu", {
	  enumerable: true,
	  get: function get() {
	    return _MenuMenu2["default"];
	  }
	});
	Object.defineProperty(exports, "Message", {
	  enumerable: true,
	  get: function get() {
	    return _Message2["default"];
	  }
	});
	Object.defineProperty(exports, "MessageContent", {
	  enumerable: true,
	  get: function get() {
	    return _MessageContent2["default"];
	  }
	});
	Object.defineProperty(exports, "MessageHeader", {
	  enumerable: true,
	  get: function get() {
	    return _MessageHeader2["default"];
	  }
	});
	Object.defineProperty(exports, "MessageItem", {
	  enumerable: true,
	  get: function get() {
	    return _MessageItem2["default"];
	  }
	});
	Object.defineProperty(exports, "MessageList", {
	  enumerable: true,
	  get: function get() {
	    return _MessageList2["default"];
	  }
	});
	Object.defineProperty(exports, "Table", {
	  enumerable: true,
	  get: function get() {
	    return _Table2["default"];
	  }
	});
	Object.defineProperty(exports, "TableBody", {
	  enumerable: true,
	  get: function get() {
	    return _TableBody2["default"];
	  }
	});
	Object.defineProperty(exports, "TableCell", {
	  enumerable: true,
	  get: function get() {
	    return _TableCell2["default"];
	  }
	});
	Object.defineProperty(exports, "TableFooter", {
	  enumerable: true,
	  get: function get() {
	    return _TableFooter2["default"];
	  }
	});
	Object.defineProperty(exports, "TableHeader", {
	  enumerable: true,
	  get: function get() {
	    return _TableHeader2["default"];
	  }
	});
	Object.defineProperty(exports, "TableHeaderCell", {
	  enumerable: true,
	  get: function get() {
	    return _TableHeaderCell2["default"];
	  }
	});
	Object.defineProperty(exports, "TableRow", {
	  enumerable: true,
	  get: function get() {
	    return _TableRow2["default"];
	  }
	});
	Object.defineProperty(exports, "Button", {
	  enumerable: true,
	  get: function get() {
	    return _Button2["default"];
	  }
	});
	Object.defineProperty(exports, "ButtonContent", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonContent2["default"];
	  }
	});
	Object.defineProperty(exports, "ButtonGroup", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonGroup2["default"];
	  }
	});
	Object.defineProperty(exports, "ButtonOr", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonOr2["default"];
	  }
	});
	Object.defineProperty(exports, "Container", {
	  enumerable: true,
	  get: function get() {
	    return _Container2["default"];
	  }
	});
	Object.defineProperty(exports, "Divider", {
	  enumerable: true,
	  get: function get() {
	    return _Divider2["default"];
	  }
	});
	Object.defineProperty(exports, "Flag", {
	  enumerable: true,
	  get: function get() {
	    return _Flag2["default"];
	  }
	});
	Object.defineProperty(exports, "Header", {
	  enumerable: true,
	  get: function get() {
	    return _Header2["default"];
	  }
	});
	Object.defineProperty(exports, "HeaderContent", {
	  enumerable: true,
	  get: function get() {
	    return _HeaderContent2["default"];
	  }
	});
	Object.defineProperty(exports, "HeaderSubheader", {
	  enumerable: true,
	  get: function get() {
	    return _HeaderSubheader2["default"];
	  }
	});
	Object.defineProperty(exports, "Icon", {
	  enumerable: true,
	  get: function get() {
	    return _Icon2["default"];
	  }
	});
	Object.defineProperty(exports, "IconGroup", {
	  enumerable: true,
	  get: function get() {
	    return _IconGroup2["default"];
	  }
	});
	Object.defineProperty(exports, "Image", {
	  enumerable: true,
	  get: function get() {
	    return _Image2["default"];
	  }
	});
	Object.defineProperty(exports, "ImageGroup", {
	  enumerable: true,
	  get: function get() {
	    return _ImageGroup2["default"];
	  }
	});
	Object.defineProperty(exports, "Input", {
	  enumerable: true,
	  get: function get() {
	    return _Input2["default"];
	  }
	});
	Object.defineProperty(exports, "Label", {
	  enumerable: true,
	  get: function get() {
	    return _Label2["default"];
	  }
	});
	Object.defineProperty(exports, "LabelDetail", {
	  enumerable: true,
	  get: function get() {
	    return _LabelDetail2["default"];
	  }
	});
	Object.defineProperty(exports, "LabelGroup", {
	  enumerable: true,
	  get: function get() {
	    return _LabelGroup2["default"];
	  }
	});
	Object.defineProperty(exports, "List", {
	  enumerable: true,
	  get: function get() {
	    return _List2["default"];
	  }
	});
	Object.defineProperty(exports, "ListContent", {
	  enumerable: true,
	  get: function get() {
	    return _ListContent2["default"];
	  }
	});
	Object.defineProperty(exports, "ListDescription", {
	  enumerable: true,
	  get: function get() {
	    return _ListDescription2["default"];
	  }
	});
	Object.defineProperty(exports, "ListHeader", {
	  enumerable: true,
	  get: function get() {
	    return _ListHeader2["default"];
	  }
	});
	Object.defineProperty(exports, "ListIcon", {
	  enumerable: true,
	  get: function get() {
	    return _ListIcon2["default"];
	  }
	});
	Object.defineProperty(exports, "ListItem", {
	  enumerable: true,
	  get: function get() {
	    return _ListItem2["default"];
	  }
	});
	Object.defineProperty(exports, "ListList", {
	  enumerable: true,
	  get: function get() {
	    return _ListList2["default"];
	  }
	});
	Object.defineProperty(exports, "Loader", {
	  enumerable: true,
	  get: function get() {
	    return _Loader2["default"];
	  }
	});
	Object.defineProperty(exports, "Placeholder", {
	  enumerable: true,
	  get: function get() {
	    return _Placeholder2["default"];
	  }
	});
	Object.defineProperty(exports, "PlaceholderHeader", {
	  enumerable: true,
	  get: function get() {
	    return _PlaceholderHeader2["default"];
	  }
	});
	Object.defineProperty(exports, "PlaceholderImage", {
	  enumerable: true,
	  get: function get() {
	    return _PlaceholderImage2["default"];
	  }
	});
	Object.defineProperty(exports, "PlaceholderLine", {
	  enumerable: true,
	  get: function get() {
	    return _PlaceholderLine2["default"];
	  }
	});
	Object.defineProperty(exports, "PlaceholderParagraph", {
	  enumerable: true,
	  get: function get() {
	    return _PlaceholderParagraph2["default"];
	  }
	});
	Object.defineProperty(exports, "Rail", {
	  enumerable: true,
	  get: function get() {
	    return _Rail2["default"];
	  }
	});
	Object.defineProperty(exports, "Reveal", {
	  enumerable: true,
	  get: function get() {
	    return _Reveal2["default"];
	  }
	});
	Object.defineProperty(exports, "RevealContent", {
	  enumerable: true,
	  get: function get() {
	    return _RevealContent2["default"];
	  }
	});
	Object.defineProperty(exports, "Segment", {
	  enumerable: true,
	  get: function get() {
	    return _Segment2["default"];
	  }
	});
	Object.defineProperty(exports, "SegmentGroup", {
	  enumerable: true,
	  get: function get() {
	    return _SegmentGroup2["default"];
	  }
	});
	Object.defineProperty(exports, "SegmentInline", {
	  enumerable: true,
	  get: function get() {
	    return _SegmentInline2["default"];
	  }
	});
	Object.defineProperty(exports, "Step", {
	  enumerable: true,
	  get: function get() {
	    return _Step2["default"];
	  }
	});
	Object.defineProperty(exports, "StepContent", {
	  enumerable: true,
	  get: function get() {
	    return _StepContent2["default"];
	  }
	});
	Object.defineProperty(exports, "StepDescription", {
	  enumerable: true,
	  get: function get() {
	    return _StepDescription2["default"];
	  }
	});
	Object.defineProperty(exports, "StepGroup", {
	  enumerable: true,
	  get: function get() {
	    return _StepGroup2["default"];
	  }
	});
	Object.defineProperty(exports, "StepTitle", {
	  enumerable: true,
	  get: function get() {
	    return _StepTitle2["default"];
	  }
	});
	Object.defineProperty(exports, "Accordion", {
	  enumerable: true,
	  get: function get() {
	    return _Accordion2["default"];
	  }
	});
	Object.defineProperty(exports, "AccordionAccordion", {
	  enumerable: true,
	  get: function get() {
	    return _AccordionAccordion2["default"];
	  }
	});
	Object.defineProperty(exports, "AccordionContent", {
	  enumerable: true,
	  get: function get() {
	    return _AccordionContent2["default"];
	  }
	});
	Object.defineProperty(exports, "AccordionPanel", {
	  enumerable: true,
	  get: function get() {
	    return _AccordionPanel2["default"];
	  }
	});
	Object.defineProperty(exports, "AccordionTitle", {
	  enumerable: true,
	  get: function get() {
	    return _AccordionTitle2["default"];
	  }
	});
	Object.defineProperty(exports, "Checkbox", {
	  enumerable: true,
	  get: function get() {
	    return _Checkbox2["default"];
	  }
	});
	Object.defineProperty(exports, "Dimmer", {
	  enumerable: true,
	  get: function get() {
	    return _Dimmer2["default"];
	  }
	});
	Object.defineProperty(exports, "DimmerDimmable", {
	  enumerable: true,
	  get: function get() {
	    return _DimmerDimmable2["default"];
	  }
	});
	Object.defineProperty(exports, "DimmerInner", {
	  enumerable: true,
	  get: function get() {
	    return _DimmerInner2["default"];
	  }
	});
	Object.defineProperty(exports, "Dropdown", {
	  enumerable: true,
	  get: function get() {
	    return _Dropdown2["default"];
	  }
	});
	Object.defineProperty(exports, "DropdownDivider", {
	  enumerable: true,
	  get: function get() {
	    return _DropdownDivider2["default"];
	  }
	});
	Object.defineProperty(exports, "DropdownHeader", {
	  enumerable: true,
	  get: function get() {
	    return _DropdownHeader2["default"];
	  }
	});
	Object.defineProperty(exports, "DropdownItem", {
	  enumerable: true,
	  get: function get() {
	    return _DropdownItem2["default"];
	  }
	});
	Object.defineProperty(exports, "DropdownMenu", {
	  enumerable: true,
	  get: function get() {
	    return _DropdownMenu2["default"];
	  }
	});
	Object.defineProperty(exports, "DropdownSearchInput", {
	  enumerable: true,
	  get: function get() {
	    return _DropdownSearchInput2["default"];
	  }
	});
	Object.defineProperty(exports, "Embed", {
	  enumerable: true,
	  get: function get() {
	    return _Embed2["default"];
	  }
	});
	Object.defineProperty(exports, "Modal", {
	  enumerable: true,
	  get: function get() {
	    return _Modal2["default"];
	  }
	});
	Object.defineProperty(exports, "ModalActions", {
	  enumerable: true,
	  get: function get() {
	    return _ModalActions2["default"];
	  }
	});
	Object.defineProperty(exports, "ModalContent", {
	  enumerable: true,
	  get: function get() {
	    return _ModalContent2["default"];
	  }
	});
	Object.defineProperty(exports, "ModalDescription", {
	  enumerable: true,
	  get: function get() {
	    return _ModalDescription2["default"];
	  }
	});
	Object.defineProperty(exports, "ModalHeader", {
	  enumerable: true,
	  get: function get() {
	    return _ModalHeader2["default"];
	  }
	});
	Object.defineProperty(exports, "Popup", {
	  enumerable: true,
	  get: function get() {
	    return _Popup2["default"];
	  }
	});
	Object.defineProperty(exports, "PopupContent", {
	  enumerable: true,
	  get: function get() {
	    return _PopupContent2["default"];
	  }
	});
	Object.defineProperty(exports, "PopupHeader", {
	  enumerable: true,
	  get: function get() {
	    return _PopupHeader2["default"];
	  }
	});
	Object.defineProperty(exports, "Progress", {
	  enumerable: true,
	  get: function get() {
	    return _Progress2["default"];
	  }
	});
	Object.defineProperty(exports, "Rating", {
	  enumerable: true,
	  get: function get() {
	    return _Rating2["default"];
	  }
	});
	Object.defineProperty(exports, "RatingIcon", {
	  enumerable: true,
	  get: function get() {
	    return _RatingIcon2["default"];
	  }
	});
	Object.defineProperty(exports, "Search", {
	  enumerable: true,
	  get: function get() {
	    return _Search2["default"];
	  }
	});
	Object.defineProperty(exports, "SearchCategory", {
	  enumerable: true,
	  get: function get() {
	    return _SearchCategory2["default"];
	  }
	});
	Object.defineProperty(exports, "SearchResult", {
	  enumerable: true,
	  get: function get() {
	    return _SearchResult2["default"];
	  }
	});
	Object.defineProperty(exports, "SearchResults", {
	  enumerable: true,
	  get: function get() {
	    return _SearchResults2["default"];
	  }
	});
	Object.defineProperty(exports, "Sidebar", {
	  enumerable: true,
	  get: function get() {
	    return _Sidebar2["default"];
	  }
	});
	Object.defineProperty(exports, "SidebarPushable", {
	  enumerable: true,
	  get: function get() {
	    return _SidebarPushable2["default"];
	  }
	});
	Object.defineProperty(exports, "SidebarPusher", {
	  enumerable: true,
	  get: function get() {
	    return _SidebarPusher2["default"];
	  }
	});
	Object.defineProperty(exports, "Sticky", {
	  enumerable: true,
	  get: function get() {
	    return _Sticky2["default"];
	  }
	});
	Object.defineProperty(exports, "Tab", {
	  enumerable: true,
	  get: function get() {
	    return _Tab2["default"];
	  }
	});
	Object.defineProperty(exports, "TabPane", {
	  enumerable: true,
	  get: function get() {
	    return _TabPane2["default"];
	  }
	});
	Object.defineProperty(exports, "Transition", {
	  enumerable: true,
	  get: function get() {
	    return _Transition2["default"];
	  }
	});
	Object.defineProperty(exports, "TransitionGroup", {
	  enumerable: true,
	  get: function get() {
	    return _TransitionGroup2["default"];
	  }
	});
	Object.defineProperty(exports, "Advertisement", {
	  enumerable: true,
	  get: function get() {
	    return _Advertisement2["default"];
	  }
	});
	Object.defineProperty(exports, "Card", {
	  enumerable: true,
	  get: function get() {
	    return _Card2["default"];
	  }
	});
	Object.defineProperty(exports, "CardContent", {
	  enumerable: true,
	  get: function get() {
	    return _CardContent2["default"];
	  }
	});
	Object.defineProperty(exports, "CardDescription", {
	  enumerable: true,
	  get: function get() {
	    return _CardDescription2["default"];
	  }
	});
	Object.defineProperty(exports, "CardGroup", {
	  enumerable: true,
	  get: function get() {
	    return _CardGroup2["default"];
	  }
	});
	Object.defineProperty(exports, "CardHeader", {
	  enumerable: true,
	  get: function get() {
	    return _CardHeader2["default"];
	  }
	});
	Object.defineProperty(exports, "CardMeta", {
	  enumerable: true,
	  get: function get() {
	    return _CardMeta2["default"];
	  }
	});
	Object.defineProperty(exports, "Comment", {
	  enumerable: true,
	  get: function get() {
	    return _Comment2["default"];
	  }
	});
	Object.defineProperty(exports, "CommentAction", {
	  enumerable: true,
	  get: function get() {
	    return _CommentAction2["default"];
	  }
	});
	Object.defineProperty(exports, "CommentActions", {
	  enumerable: true,
	  get: function get() {
	    return _CommentActions2["default"];
	  }
	});
	Object.defineProperty(exports, "CommentAuthor", {
	  enumerable: true,
	  get: function get() {
	    return _CommentAuthor2["default"];
	  }
	});
	Object.defineProperty(exports, "CommentAvatar", {
	  enumerable: true,
	  get: function get() {
	    return _CommentAvatar2["default"];
	  }
	});
	Object.defineProperty(exports, "CommentContent", {
	  enumerable: true,
	  get: function get() {
	    return _CommentContent2["default"];
	  }
	});
	Object.defineProperty(exports, "CommentGroup", {
	  enumerable: true,
	  get: function get() {
	    return _CommentGroup2["default"];
	  }
	});
	Object.defineProperty(exports, "CommentMetadata", {
	  enumerable: true,
	  get: function get() {
	    return _CommentMetadata2["default"];
	  }
	});
	Object.defineProperty(exports, "CommentText", {
	  enumerable: true,
	  get: function get() {
	    return _CommentText2["default"];
	  }
	});
	Object.defineProperty(exports, "Feed", {
	  enumerable: true,
	  get: function get() {
	    return _Feed2["default"];
	  }
	});
	Object.defineProperty(exports, "FeedContent", {
	  enumerable: true,
	  get: function get() {
	    return _FeedContent2["default"];
	  }
	});
	Object.defineProperty(exports, "FeedDate", {
	  enumerable: true,
	  get: function get() {
	    return _FeedDate2["default"];
	  }
	});
	Object.defineProperty(exports, "FeedEvent", {
	  enumerable: true,
	  get: function get() {
	    return _FeedEvent2["default"];
	  }
	});
	Object.defineProperty(exports, "FeedExtra", {
	  enumerable: true,
	  get: function get() {
	    return _FeedExtra2["default"];
	  }
	});
	Object.defineProperty(exports, "FeedLabel", {
	  enumerable: true,
	  get: function get() {
	    return _FeedLabel2["default"];
	  }
	});
	Object.defineProperty(exports, "FeedLike", {
	  enumerable: true,
	  get: function get() {
	    return _FeedLike2["default"];
	  }
	});
	Object.defineProperty(exports, "FeedMeta", {
	  enumerable: true,
	  get: function get() {
	    return _FeedMeta2["default"];
	  }
	});
	Object.defineProperty(exports, "FeedSummary", {
	  enumerable: true,
	  get: function get() {
	    return _FeedSummary2["default"];
	  }
	});
	Object.defineProperty(exports, "FeedUser", {
	  enumerable: true,
	  get: function get() {
	    return _FeedUser2["default"];
	  }
	});
	Object.defineProperty(exports, "Item", {
	  enumerable: true,
	  get: function get() {
	    return _Item2["default"];
	  }
	});
	Object.defineProperty(exports, "ItemContent", {
	  enumerable: true,
	  get: function get() {
	    return _ItemContent2["default"];
	  }
	});
	Object.defineProperty(exports, "ItemDescription", {
	  enumerable: true,
	  get: function get() {
	    return _ItemDescription2["default"];
	  }
	});
	Object.defineProperty(exports, "ItemExtra", {
	  enumerable: true,
	  get: function get() {
	    return _ItemExtra2["default"];
	  }
	});
	Object.defineProperty(exports, "ItemGroup", {
	  enumerable: true,
	  get: function get() {
	    return _ItemGroup2["default"];
	  }
	});
	Object.defineProperty(exports, "ItemHeader", {
	  enumerable: true,
	  get: function get() {
	    return _ItemHeader2["default"];
	  }
	});
	Object.defineProperty(exports, "ItemImage", {
	  enumerable: true,
	  get: function get() {
	    return _ItemImage2["default"];
	  }
	});
	Object.defineProperty(exports, "ItemMeta", {
	  enumerable: true,
	  get: function get() {
	    return _ItemMeta2["default"];
	  }
	});
	Object.defineProperty(exports, "Statistic", {
	  enumerable: true,
	  get: function get() {
	    return _Statistic2["default"];
	  }
	});
	Object.defineProperty(exports, "StatisticGroup", {
	  enumerable: true,
	  get: function get() {
	    return _StatisticGroup2["default"];
	  }
	});
	Object.defineProperty(exports, "StatisticLabel", {
	  enumerable: true,
	  get: function get() {
	    return _StatisticLabel2["default"];
	  }
	});
	Object.defineProperty(exports, "StatisticValue", {
	  enumerable: true,
	  get: function get() {
	    return _StatisticValue2["default"];
	  }
	});
	
	var _reactComponentRef = __webpack_require__(52);
	
	var _Confirm2 = _interopRequireDefault(__webpack_require__(7219));
	
	var _MountNode2 = _interopRequireDefault(__webpack_require__(688));
	
	var _Pagination2 = _interopRequireDefault(__webpack_require__(7227));
	
	var _PaginationItem2 = _interopRequireDefault(__webpack_require__(689));
	
	var _Portal2 = _interopRequireDefault(__webpack_require__(158));
	
	var _PortalInner2 = _interopRequireDefault(__webpack_require__(690));
	
	var _Radio2 = _interopRequireDefault(__webpack_require__(307));
	
	var _Responsive2 = _interopRequireDefault(__webpack_require__(7231));
	
	var _Select2 = _interopRequireDefault(__webpack_require__(691));
	
	var _TextArea2 = _interopRequireDefault(__webpack_require__(692));
	
	var _TransitionablePortal2 = _interopRequireDefault(__webpack_require__(7236));
	
	var _Visibility2 = _interopRequireDefault(__webpack_require__(7238));
	
	var _Breadcrumb2 = _interopRequireDefault(__webpack_require__(7240));
	
	var _BreadcrumbDivider2 = _interopRequireDefault(__webpack_require__(693));
	
	var _BreadcrumbSection2 = _interopRequireDefault(__webpack_require__(694));
	
	var _Form2 = _interopRequireDefault(__webpack_require__(7242));
	
	var _FormButton2 = _interopRequireDefault(__webpack_require__(695));
	
	var _FormCheckbox2 = _interopRequireDefault(__webpack_require__(696));
	
	var _FormDropdown2 = _interopRequireDefault(__webpack_require__(697));
	
	var _FormField2 = _interopRequireDefault(__webpack_require__(84));
	
	var _FormGroup2 = _interopRequireDefault(__webpack_require__(698));
	
	var _FormInput2 = _interopRequireDefault(__webpack_require__(699));
	
	var _FormRadio2 = _interopRequireDefault(__webpack_require__(700));
	
	var _FormSelect2 = _interopRequireDefault(__webpack_require__(701));
	
	var _FormTextArea2 = _interopRequireDefault(__webpack_require__(702));
	
	var _Grid2 = _interopRequireDefault(__webpack_require__(7243));
	
	var _GridColumn2 = _interopRequireDefault(__webpack_require__(308));
	
	var _GridRow2 = _interopRequireDefault(__webpack_require__(704));
	
	var _Menu2 = _interopRequireDefault(__webpack_require__(708));
	
	var _MenuHeader2 = _interopRequireDefault(__webpack_require__(706));
	
	var _MenuItem2 = _interopRequireDefault(__webpack_require__(309));
	
	var _MenuMenu2 = _interopRequireDefault(__webpack_require__(707));
	
	var _Message2 = _interopRequireDefault(__webpack_require__(7245));
	
	var _MessageContent2 = _interopRequireDefault(__webpack_require__(709));
	
	var _MessageHeader2 = _interopRequireDefault(__webpack_require__(710));
	
	var _MessageItem2 = _interopRequireDefault(__webpack_require__(310));
	
	var _MessageList2 = _interopRequireDefault(__webpack_require__(711));
	
	var _Table2 = _interopRequireDefault(__webpack_require__(7247));
	
	var _TableBody2 = _interopRequireDefault(__webpack_require__(712));
	
	var _TableCell2 = _interopRequireDefault(__webpack_require__(218));
	
	var _TableFooter2 = _interopRequireDefault(__webpack_require__(713));
	
	var _TableHeader2 = _interopRequireDefault(__webpack_require__(311));
	
	var _TableHeaderCell2 = _interopRequireDefault(__webpack_require__(714));
	
	var _TableRow2 = _interopRequireDefault(__webpack_require__(715));
	
	var _Button2 = _interopRequireDefault(__webpack_require__(312));
	
	var _ButtonContent2 = _interopRequireDefault(__webpack_require__(716));
	
	var _ButtonGroup2 = _interopRequireDefault(__webpack_require__(717));
	
	var _ButtonOr2 = _interopRequireDefault(__webpack_require__(718));
	
	var _Container2 = _interopRequireDefault(__webpack_require__(7249));
	
	var _Divider2 = _interopRequireDefault(__webpack_require__(7251));
	
	var _Flag2 = _interopRequireDefault(__webpack_require__(719));
	
	var _Header2 = _interopRequireDefault(__webpack_require__(7254));
	
	var _HeaderContent2 = _interopRequireDefault(__webpack_require__(720));
	
	var _HeaderSubheader2 = _interopRequireDefault(__webpack_require__(721));
	
	var _Icon2 = _interopRequireDefault(__webpack_require__(54));
	
	var _IconGroup2 = _interopRequireDefault(__webpack_require__(722));
	
	var _Image2 = _interopRequireDefault(__webpack_require__(124));
	
	var _ImageGroup2 = _interopRequireDefault(__webpack_require__(724));
	
	var _Input2 = _interopRequireDefault(__webpack_require__(313));
	
	var _Label2 = _interopRequireDefault(__webpack_require__(159));
	
	var _LabelDetail2 = _interopRequireDefault(__webpack_require__(725));
	
	var _LabelGroup2 = _interopRequireDefault(__webpack_require__(726));
	
	var _List2 = _interopRequireDefault(__webpack_require__(7257));
	
	var _ListContent2 = _interopRequireDefault(__webpack_require__(315));
	
	var _ListDescription2 = _interopRequireDefault(__webpack_require__(221));
	
	var _ListHeader2 = _interopRequireDefault(__webpack_require__(222));
	
	var _ListIcon2 = _interopRequireDefault(__webpack_require__(316));
	
	var _ListItem2 = _interopRequireDefault(__webpack_require__(727));
	
	var _ListList2 = _interopRequireDefault(__webpack_require__(728));
	
	var _Loader2 = _interopRequireDefault(__webpack_require__(7259));
	
	var _Placeholder2 = _interopRequireDefault(__webpack_require__(7261));
	
	var _PlaceholderHeader2 = _interopRequireDefault(__webpack_require__(729));
	
	var _PlaceholderImage2 = _interopRequireDefault(__webpack_require__(730));
	
	var _PlaceholderLine2 = _interopRequireDefault(__webpack_require__(731));
	
	var _PlaceholderParagraph2 = _interopRequireDefault(__webpack_require__(732));
	
	var _Rail2 = _interopRequireDefault(__webpack_require__(7263));
	
	var _Reveal2 = _interopRequireDefault(__webpack_require__(7265));
	
	var _RevealContent2 = _interopRequireDefault(__webpack_require__(733));
	
	var _Segment2 = _interopRequireDefault(__webpack_require__(7266));
	
	var _SegmentGroup2 = _interopRequireDefault(__webpack_require__(735));
	
	var _SegmentInline2 = _interopRequireDefault(__webpack_require__(736));
	
	var _Step2 = _interopRequireDefault(__webpack_require__(7267));
	
	var _StepContent2 = _interopRequireDefault(__webpack_require__(738));
	
	var _StepDescription2 = _interopRequireDefault(__webpack_require__(317));
	
	var _StepGroup2 = _interopRequireDefault(__webpack_require__(739));
	
	var _StepTitle2 = _interopRequireDefault(__webpack_require__(318));
	
	var _Accordion2 = _interopRequireDefault(__webpack_require__(7289));
	
	var _AccordionAccordion2 = _interopRequireDefault(__webpack_require__(742));
	
	var _AccordionContent2 = _interopRequireDefault(__webpack_require__(320));
	
	var _AccordionPanel2 = _interopRequireDefault(__webpack_require__(321));
	
	var _AccordionTitle2 = _interopRequireDefault(__webpack_require__(322));
	
	var _Checkbox2 = _interopRequireDefault(__webpack_require__(223));
	
	var _Dimmer2 = _interopRequireDefault(__webpack_require__(745));
	
	var _DimmerDimmable2 = _interopRequireDefault(__webpack_require__(743));
	
	var _DimmerInner2 = _interopRequireDefault(__webpack_require__(744));
	
	var _Dropdown2 = _interopRequireDefault(__webpack_require__(224));
	
	var _DropdownDivider2 = _interopRequireDefault(__webpack_require__(746));
	
	var _DropdownHeader2 = _interopRequireDefault(__webpack_require__(747));
	
	var _DropdownItem2 = _interopRequireDefault(__webpack_require__(748));
	
	var _DropdownMenu2 = _interopRequireDefault(__webpack_require__(749));
	
	var _DropdownSearchInput2 = _interopRequireDefault(__webpack_require__(750));
	
	var _Embed2 = _interopRequireDefault(__webpack_require__(7294));
	
	var _Modal2 = _interopRequireDefault(__webpack_require__(755));
	
	var _ModalActions2 = _interopRequireDefault(__webpack_require__(751));
	
	var _ModalContent2 = _interopRequireDefault(__webpack_require__(752));
	
	var _ModalDescription2 = _interopRequireDefault(__webpack_require__(753));
	
	var _ModalHeader2 = _interopRequireDefault(__webpack_require__(754));
	
	var _Popup2 = _interopRequireDefault(__webpack_require__(7298));
	
	var _PopupContent2 = _interopRequireDefault(__webpack_require__(756));
	
	var _PopupHeader2 = _interopRequireDefault(__webpack_require__(757));
	
	var _Progress2 = _interopRequireDefault(__webpack_require__(7302));
	
	var _Rating2 = _interopRequireDefault(__webpack_require__(7304));
	
	var _RatingIcon2 = _interopRequireDefault(__webpack_require__(758));
	
	var _Search2 = _interopRequireDefault(__webpack_require__(7306));
	
	var _SearchCategory2 = _interopRequireDefault(__webpack_require__(759));
	
	var _SearchResult2 = _interopRequireDefault(__webpack_require__(760));
	
	var _SearchResults2 = _interopRequireDefault(__webpack_require__(761));
	
	var _Sidebar2 = _interopRequireDefault(__webpack_require__(7308));
	
	var _SidebarPushable2 = _interopRequireDefault(__webpack_require__(762));
	
	var _SidebarPusher2 = _interopRequireDefault(__webpack_require__(763));
	
	var _Sticky2 = _interopRequireDefault(__webpack_require__(7310));
	
	var _Tab2 = _interopRequireDefault(__webpack_require__(7312));
	
	var _TabPane2 = _interopRequireDefault(__webpack_require__(764));
	
	var _Transition2 = _interopRequireDefault(__webpack_require__(767));
	
	var _TransitionGroup2 = _interopRequireDefault(__webpack_require__(766));
	
	var _Advertisement2 = _interopRequireDefault(__webpack_require__(7314));
	
	var _Card2 = _interopRequireDefault(__webpack_require__(768));
	
	var _CardContent2 = _interopRequireDefault(__webpack_require__(769));
	
	var _CardDescription2 = _interopRequireDefault(__webpack_require__(323));
	
	var _CardGroup2 = _interopRequireDefault(__webpack_require__(770));
	
	var _CardHeader2 = _interopRequireDefault(__webpack_require__(324));
	
	var _CardMeta2 = _interopRequireDefault(__webpack_require__(325));
	
	var _Comment2 = _interopRequireDefault(__webpack_require__(7316));
	
	var _CommentAction2 = _interopRequireDefault(__webpack_require__(771));
	
	var _CommentActions2 = _interopRequireDefault(__webpack_require__(772));
	
	var _CommentAuthor2 = _interopRequireDefault(__webpack_require__(773));
	
	var _CommentAvatar2 = _interopRequireDefault(__webpack_require__(774));
	
	var _CommentContent2 = _interopRequireDefault(__webpack_require__(775));
	
	var _CommentGroup2 = _interopRequireDefault(__webpack_require__(776));
	
	var _CommentMetadata2 = _interopRequireDefault(__webpack_require__(777));
	
	var _CommentText2 = _interopRequireDefault(__webpack_require__(778));
	
	var _Feed2 = _interopRequireDefault(__webpack_require__(7318));
	
	var _FeedContent2 = _interopRequireDefault(__webpack_require__(326));
	
	var _FeedDate2 = _interopRequireDefault(__webpack_require__(225));
	
	var _FeedEvent2 = _interopRequireDefault(__webpack_require__(779));
	
	var _FeedExtra2 = _interopRequireDefault(__webpack_require__(327));
	
	var _FeedLabel2 = _interopRequireDefault(__webpack_require__(328));
	
	var _FeedLike2 = _interopRequireDefault(__webpack_require__(329));
	
	var _FeedMeta2 = _interopRequireDefault(__webpack_require__(330));
	
	var _FeedSummary2 = _interopRequireDefault(__webpack_require__(331));
	
	var _FeedUser2 = _interopRequireDefault(__webpack_require__(332));
	
	var _Item2 = _interopRequireDefault(__webpack_require__(7319));
	
	var _ItemContent2 = _interopRequireDefault(__webpack_require__(781));
	
	var _ItemDescription2 = _interopRequireDefault(__webpack_require__(333));
	
	var _ItemExtra2 = _interopRequireDefault(__webpack_require__(334));
	
	var _ItemGroup2 = _interopRequireDefault(__webpack_require__(782));
	
	var _ItemHeader2 = _interopRequireDefault(__webpack_require__(335));
	
	var _ItemImage2 = _interopRequireDefault(__webpack_require__(783));
	
	var _ItemMeta2 = _interopRequireDefault(__webpack_require__(336));
	
	var _Statistic2 = _interopRequireDefault(__webpack_require__(7320));
	
	var _StatisticGroup2 = _interopRequireDefault(__webpack_require__(785));
	
	var _StatisticLabel2 = _interopRequireDefault(__webpack_require__(786));
	
	var _StatisticValue2 = _interopRequireDefault(__webpack_require__(787));

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  AutoControlledComponent: true,
	  getChildMapping: true,
	  mergeChildMappings: true,
	  childrenUtils: true,
	  useKeyOnly: true,
	  useKeyOrValueAndKey: true,
	  useValueAndKey: true,
	  useMultipleProp: true,
	  useTextAlignProp: true,
	  useVerticalAlignProp: true,
	  useWidthProp: true,
	  customPropTypes: true,
	  eventStack: true,
	  getUnhandledProps: true,
	  getElementType: true,
	  htmlInputAttrs: true,
	  htmlInputEvents: true,
	  htmlInputProps: true,
	  htmlImageProps: true,
	  partitionHTMLProps: true,
	  isBrowser: true,
	  doesNodeContainClick: true,
	  leven: true,
	  createPaginationItems: true,
	  SUI: true,
	  numberToWordMap: true,
	  numberToWord: true,
	  normalizeOffset: true,
	  normalizeTransitionDuration: true,
	  objectDiff: true
	};
	Object.defineProperty(exports, "AutoControlledComponent", {
	  enumerable: true,
	  get: function get() {
	    return _AutoControlledComponent2["default"];
	  }
	});
	Object.defineProperty(exports, "getChildMapping", {
	  enumerable: true,
	  get: function get() {
	    return _childMapping.getChildMapping;
	  }
	});
	Object.defineProperty(exports, "mergeChildMappings", {
	  enumerable: true,
	  get: function get() {
	    return _childMapping.mergeChildMappings;
	  }
	});
	Object.defineProperty(exports, "useKeyOnly", {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useKeyOnly;
	  }
	});
	Object.defineProperty(exports, "useKeyOrValueAndKey", {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useKeyOrValueAndKey;
	  }
	});
	Object.defineProperty(exports, "useValueAndKey", {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useValueAndKey;
	  }
	});
	Object.defineProperty(exports, "useMultipleProp", {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useMultipleProp;
	  }
	});
	Object.defineProperty(exports, "useTextAlignProp", {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useTextAlignProp;
	  }
	});
	Object.defineProperty(exports, "useVerticalAlignProp", {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useVerticalAlignProp;
	  }
	});
	Object.defineProperty(exports, "useWidthProp", {
	  enumerable: true,
	  get: function get() {
	    return _classNameBuilders.useWidthProp;
	  }
	});
	Object.defineProperty(exports, "eventStack", {
	  enumerable: true,
	  get: function get() {
	    return _eventStack2["default"];
	  }
	});
	Object.defineProperty(exports, "getUnhandledProps", {
	  enumerable: true,
	  get: function get() {
	    return _getUnhandledProps2["default"];
	  }
	});
	Object.defineProperty(exports, "getElementType", {
	  enumerable: true,
	  get: function get() {
	    return _getElementType2["default"];
	  }
	});
	Object.defineProperty(exports, "htmlInputAttrs", {
	  enumerable: true,
	  get: function get() {
	    return _htmlPropsUtils.htmlInputAttrs;
	  }
	});
	Object.defineProperty(exports, "htmlInputEvents", {
	  enumerable: true,
	  get: function get() {
	    return _htmlPropsUtils.htmlInputEvents;
	  }
	});
	Object.defineProperty(exports, "htmlInputProps", {
	  enumerable: true,
	  get: function get() {
	    return _htmlPropsUtils.htmlInputProps;
	  }
	});
	Object.defineProperty(exports, "htmlImageProps", {
	  enumerable: true,
	  get: function get() {
	    return _htmlPropsUtils.htmlImageProps;
	  }
	});
	Object.defineProperty(exports, "partitionHTMLProps", {
	  enumerable: true,
	  get: function get() {
	    return _htmlPropsUtils.partitionHTMLProps;
	  }
	});
	Object.defineProperty(exports, "isBrowser", {
	  enumerable: true,
	  get: function get() {
	    return _isBrowser2["default"];
	  }
	});
	Object.defineProperty(exports, "doesNodeContainClick", {
	  enumerable: true,
	  get: function get() {
	    return _doesNodeContainClick2["default"];
	  }
	});
	Object.defineProperty(exports, "leven", {
	  enumerable: true,
	  get: function get() {
	    return _leven2["default"];
	  }
	});
	Object.defineProperty(exports, "createPaginationItems", {
	  enumerable: true,
	  get: function get() {
	    return _createPaginationItems2["default"];
	  }
	});
	Object.defineProperty(exports, "numberToWordMap", {
	  enumerable: true,
	  get: function get() {
	    return _numberToWord.numberToWordMap;
	  }
	});
	Object.defineProperty(exports, "numberToWord", {
	  enumerable: true,
	  get: function get() {
	    return _numberToWord.numberToWord;
	  }
	});
	Object.defineProperty(exports, "normalizeOffset", {
	  enumerable: true,
	  get: function get() {
	    return _normalizeOffset2["default"];
	  }
	});
	Object.defineProperty(exports, "normalizeTransitionDuration", {
	  enumerable: true,
	  get: function get() {
	    return _normalizeTransitionDuration2["default"];
	  }
	});
	Object.defineProperty(exports, "objectDiff", {
	  enumerable: true,
	  get: function get() {
	    return _objectDiff2["default"];
	  }
	});
	exports.SUI = exports.customPropTypes = exports.childrenUtils = void 0;
	
	var _AutoControlledComponent2 = _interopRequireDefault(__webpack_require__(7268));
	
	var _childMapping = __webpack_require__(7270);
	
	var _childrenUtils = _interopRequireWildcard(__webpack_require__(7271));
	
	exports.childrenUtils = _childrenUtils;
	
	var _classNameBuilders = __webpack_require__(7272);
	
	var _customPropTypes = _interopRequireWildcard(__webpack_require__(7278));
	
	exports.customPropTypes = _customPropTypes;
	
	var _eventStack2 = _interopRequireDefault(__webpack_require__(7280));
	
	var _factories = __webpack_require__(7281);
	
	Object.keys(_factories).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _factories[key];
	    }
	  });
	});
	
	var _getUnhandledProps2 = _interopRequireDefault(__webpack_require__(7283));
	
	var _getElementType2 = _interopRequireDefault(__webpack_require__(7282));
	
	var _htmlPropsUtils = __webpack_require__(7284);
	
	var _isBrowser2 = _interopRequireDefault(__webpack_require__(7285));
	
	var _doesNodeContainClick2 = _interopRequireDefault(__webpack_require__(7279));
	
	var _leven2 = _interopRequireDefault(__webpack_require__(741));
	
	var _createPaginationItems2 = _interopRequireDefault(__webpack_require__(7274));
	
	var _SUI = _interopRequireWildcard(__webpack_require__(7269));
	
	exports.SUI = _SUI;
	
	var _numberToWord = __webpack_require__(319);
	
	var _normalizeOffset2 = _interopRequireDefault(__webpack_require__(7286));
	
	var _normalizeTransitionDuration2 = _interopRequireDefault(__webpack_require__(7287));
	
	var _objectDiff2 = _interopRequireDefault(__webpack_require__(7288));

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = '';
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}
	
			return classes;
		}
	
		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}
	
			if (typeof arg !== 'object') {
				return '';
			}
	
			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}
	
			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}
	
			var classes = '';
	
			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}
	
			return classes;
		}
	
		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.usuarioAuditoria = exports.USUARIOS_AUDITORIA = exports.formatBytes = exports.comboprecios = exports.tipoprecio = exports.validarMontos = exports.validarPrecioMontos = exports.validarCantidadTres = exports.validarCantidaddos = exports.validarCantidaDos = exports.validarCantidadForPedido = exports.validarCantidad = exports.onCambioUnidadTres = exports.onCambioUnidadDos = exports.onCambioUnidad = exports.onCambioMoneda = exports.regla3 = exports.calculadora = exports.calcularTotales_Dos = exports.calcularTotalesDos = exports.calcularTotales = exports.modelos = exports.marcas = exports.tipoproducto = exports.unidadmedidas = exports.fabricantes = exports.round = exports.validarCantidadPedido = exports.detallePedido = exports.cmbCedula = exports.isResponseOk = exports.colores2 = exports.colores = exports.generar = exports.cargarCamposArchivo = exports.validarCamposArchivo = exports.validarArchivoRetencion = exports.validaNumRifSinGuion = exports.validaNumRif = exports.validarRif = exports.mascara = exports.removeSpaces = exports.ValidCaptcha = exports.Captcha = exports.habilitarcampo = exports.habilitarcampos = exports.validaEmail = exports.validaNumeroTelefono = exports.validarnumberguion = exports.validaSoloNumero = exports.validaMonto3 = exports.validaMonto = exports.seleccionarCampo = exports.formatMoneda = exports.nmes = exports.cmes = undefined;
	
	var _marcas, _modelos;
	
	exports.formatearMonto = formatearMonto;
	exports.lpad = lpad;
	exports.formatoMonto = formatoMonto;
	exports.formatoMonto3 = formatoMonto3;
	exports.timeout = timeout;
	exports.formatFecha = formatFecha;
	
	var _jquery = __webpack_require__(6745);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var respuesta = [];
	var cmes = exports.cmes = function cmes(m) {
	  var mes = "";
	  switch (m) {
	    case 1:
	      mes = "ENERO";
	      break;
	    case 2:
	      mes = "FEBRERO";
	      break;
	    case 3:
	      mes = "MARZO";
	      break;
	    case 4:
	      mes = "ABRIL";
	      break;
	    case 5:
	      mes = "MAYO";
	      break;
	    case 6:
	      mes = "JUNIO";
	      break;
	    case 7:
	      mes = "JULIO";
	      break;
	    case 8:
	      mes = "AGOSTO";
	      break;
	    case 9:
	      mes = "SEPTIEMBRE";
	      break;
	    case 10:
	      mes = "OCTUBRE";
	      break;
	    case 11:
	      mes = "NOVIEMBRE";
	      break;
	    case 12:
	      mes = "DICIEMBRE";
	      break;
	    default:
	      mes = "";
	      break;
	  }
	  return mes;
	};
	
	var nmes = exports.nmes = function nmes(m) {
	  var mes = "";
	  switch (m) {
	    case "ENERO":
	      mes = 1;
	      break;
	    case "FEBRERO":
	      mes = 2;
	      break;
	    case "MARZO":
	      mes = 3;
	      break;
	    case "ABRIL":
	      mes = 4;
	      break;
	    case "MAYO":
	      mes = 5;
	      break;
	    case "JUNIO":
	      mes = 6;
	      break;
	    case "JULIO":
	      mes = 7;
	      break;
	    case "AGOSTO":
	      mes = 8;
	      break;
	    case "SEPTIEMBRE":
	      mes = 9;
	      break;
	    case "OCTUBRE":
	      mes = 10;
	      break;
	    case "NOVIEMBRE":
	      mes = 11;
	      break;
	    case "DICIEMBRE":
	      mes = 12;
	      break;
	    default:
	      mes = "0";
	      break;
	  }
	  return mes;
	};
	
	var formatMoneda = exports.formatMoneda = function formatMoneda(num, decSep, thousandSep, decLength) {
	  var sign = "";
	  if (typeof parseFloat(num.replace(",", ".")) === "number" && parseFloat(num.replace(",", ".")) < 0) {
	    sign = "-";
	    // num = Math.abs(num);
	  }
	  if (num === "") return "";
	  var arg, entero, decLengthpow;
	  // sign = true;
	
	  cents = "";
	  if (typeof num === "undefined") return;
	  if (typeof decLength === "undefined") decLength = 2;
	  if (typeof decSep === "undefined") decSep = ",";
	  if (typeof thousandSep === "undefined") thousandSep = ".";
	  if (thousandSep === ".") arg = /\./g;else if (thousandSep === ",") arg = /\,/g;
	  if (typeof arg != "undefined") num = num.toString().replace(arg, "");
	  num = num.toString().replace(/,/g, ".");
	  if (num.indexOf(".") != 1) entero = num.substring(0, num.indexOf("."));else entero = num;
	  if (isNaN(num)) return "0";
	  if (decLength > 0) {
	    decLengthpow = Math.pow(10, decLength);
	    /// sign = num === (num = Math.abs(num));
	    num = Math.abs(num);
	    num = Math.round(num * decLengthpow);
	    var cents = num % decLengthpow;
	    num = Math.floor(num / decLengthpow).toString();
	    if (cents < 10) cents = "0" + cents;
	  }
	  if (thousandSep != "") for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
	    num = num.substring(0, num.length - (4 * i + 3)) + thousandSep + num.substring(num.length - (4 * i + 3));
	  } else for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
	    num = num.substring(0, num.length - (4 * i + 3)) + num.substring(num.length - (4 * i + 3));
	  }if (decLength > 0) return (sign ? sign : " ") + num + decSep + cents;else return (sign ? sign : " ") + num;
	};
	
	function formatearMonto(monto) {
	  var decimales = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	  var local = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "de-DE";
	
	  // Redondear el monto a tres decimales
	  var montoFormateado = parseFloat(monto).toFixed(decimales);
	
	  // Formatear el monto según la configuración regional actual del usuario
	  return parseFloat(montoFormateado).toLocaleString(local);
	}
	
	/* export const formatMoneda = (num, decSep, thousandSep, decLength) => {
	  if (num === "") return "";
	  var arg,
	    entero,
	    decLengthpow,
	    sign = true;
	  cents = "";
	  if (typeof num === "undefined") return;
	  if (typeof decLength === "undefined") decLength = 2;
	  if (typeof decSep === "undefined") decSep = ",";
	  if (typeof thousandSep === "undefined") thousandSep = ".";
	  if (thousandSep === ".") arg = /\./g;
	  else if (thousandSep === ",") arg = /\,/g;
	  if (typeof arg != "undefined") num = num.toString().replace(arg, "");
	  num = num.toString().replace(/,/g, ".");
	  if (num.indexOf(".") != 1) entero = num.substring(0, num.indexOf("."));
	  else entero = num;
	  if (isNaN(num)) return "0";
	  if (decLength > 0) {
	    decLengthpow = Math.pow(10, decLength);
	    sign = num === (num = Math.abs(num));
	    num = Math.round(num * decLengthpow);
	    var cents = num % decLengthpow;
	    num = Math.floor(num / decLengthpow).toString();
	    if (cents < 10) cents = "0" + cents;
	  }
	  if (thousandSep != "")
	    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
	      num =
	        num.substring(0, num.length - (4 * i + 3)) +
	        thousandSep +
	        num.substring(num.length - (4 * i + 3));
	  else
	    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
	      num =
	        num.substring(0, num.length - (4 * i + 3)) +
	        num.substring(num.length - (4 * i + 3));
	  if (decLength > 0) return (sign ? "" : " ") + num + decSep + cents;
	  else return (sign ? "" : " ") + num;
	}; */
	
	var seleccionarCampo = exports.seleccionarCampo = function seleccionarCampo(event) {
	  (0, _jquery2.default)(event.target).select();
	};
	
	var validaMonto = exports.validaMonto = function validaMonto(event) {
	  (0, _jquery2.default)(event.target).val(function (index, value) {
	    var sign = "";
	    if (value.indexOf("-") === 0) {
	      sign = "-";
	    }
	    return sign + value.replace(/\D/g, "").replace(/([0-9])([0-9]{2})$/, "$1,$2").replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ".");
	  });
	};
	
	var validaMonto3 = exports.validaMonto3 = function validaMonto3(event) {
	  (0, _jquery2.default)(event.target).val(function (index, value) {
	    return value.replace(/\D/g, "").replace(/([0-9])([0-9]{3})$/, "$1,$2").replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ".");
	  });
	};
	
	var validaSoloNumero = exports.validaSoloNumero = function validaSoloNumero(event) {
	  (0, _jquery2.default)(event.target).val(function (index, value) {
	    return value.replace(/\D/g, "");
	  });
	};
	
	var validarnumberguion = exports.validarnumberguion = function validarnumberguion(event) {
	  (0, _jquery2.default)(event.target).val(function (index, value) {
	    return value.replace(/[^A-Z\d-]/g, "");
	  });
	};
	
	var validaNumeroTelefono = exports.validaNumeroTelefono = function validaNumeroTelefono(inputtxt) {
	  //var tlfno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
	  var tlfno = /^\(?([0-9]{4})\)?[-. ]?([0-9]{7})$/;
	  if (inputtxt.match(tlfno)) {
	    return true;
	  } else {
	    return false;
	  }
	};
	
	var validaEmail = exports.validaEmail = function validaEmail(inputtxt) {
	  //var tlfno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
	  var email = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
	  if (inputtxt.match(email)) {
	    return true;
	  } else {
	    return false;
	  }
	};
	
	function lpad(str, padStr, length) {
	  return (padStr + str).slice(-length);
	}
	
	var habilitarcampos = exports.habilitarcampos = function habilitarcampos(frm) {
	  (0, _jquery2.default)("#" + frm + " input").removeAttr("readonly");
	  (0, _jquery2.default)("#" + frm + " input").removeAttr("disabled");
	  (0, _jquery2.default)("#" + frm + ' input[type="radio"]').removeAttr("disabled");
	  (0, _jquery2.default)("#" + frm + ' input[type="checkbox"]').removeAttr("disabled");
	  (0, _jquery2.default)("#" + frm + " textarea").removeAttr("readonly");
	  (0, _jquery2.default)("#" + frm + " textarea").removeAttr("disabled");
	  (0, _jquery2.default)("#" + frm + " select").removeAttr("disabled");
	  (0, _jquery2.default)("#" + frm + " .input-fecha").mask("99/99/9999");
	  (0, _jquery2.default)("#" + frm + " .input-fecha").attr("placeholder", "dd/mm/aaaa");
	  (0, _jquery2.default)("#" + frm + " .txtRif").mask("R-99999999-9");
	  (0, _jquery2.default)("#" + frm + " .txtRif").attr("placeholder", "J-99999999-9");
	};
	
	var habilitarcampo = exports.habilitarcampo = function habilitarcampo(campo) {
	  (0, _jquery2.default)("#" + campo).removeAttr("readonly");
	  (0, _jquery2.default)("#" + campo).removeAttr("disabled");
	};
	
	function formatoMonto(val) {
	  var valor = "";
	  var n = 3;
	  if (val.indexOf("-") === 0) {
	    n = 4;
	  }
	  if (val.length < n && val !== "") valor = val + ",00";else valor = val;
	  return valor;
	}
	
	function formatoMonto3(val) {
	  var valor = "";
	  if (val.length < 4 && val !== "") valor = val + ",000";else valor = val;
	  return valor;
	}
	
	function timeout(ms) {
	  return new Promise(function (resolve) {
	    return setTimeout(resolve, ms);
	  });
	}
	
	function formatFecha(fecha, format, sig) {
	  var anio = fecha.substring(0, 4);
	  var mes = fecha.substring(5, 7);
	  var dia = fecha.substring(8, 10);
	
	  if (format === "YYYY-MM-DD") {
	    return anio + sig + mes + sig + dia;
	  } else if (format === "DD-MM-YYYY") {
	    return dia + sig + mes + sig + anio;
	  } else if (format === "YYYY") {
	    return anio;
	  } else {
	    return anio + sig + mes + sig + dia;
	  }
	}
	
	var code;
	
	var Captcha = exports.Captcha = function Captcha() {
	  var alpha = new Array("A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z");
	  var alpha2 = new Array("1", "2", "3", "4", "5", "6", "7", "8", "9", "0");
	  var i;
	  for (i = 0; i < 6; i++) {
	    var a = alpha[Math.floor(Math.random() * alpha.length)];
	    var b = alpha2[Math.floor(Math.random() * alpha2.length)];
	    var c = alpha[Math.floor(Math.random() * alpha.length)];
	    var d = alpha2[Math.floor(Math.random() * alpha2.length)];
	    var e = alpha[Math.floor(Math.random() * alpha.length)];
	    var f = alpha2[Math.floor(Math.random() * alpha2.length)];
	    var g = alpha[Math.floor(Math.random() * alpha.length)];
	  }
	  var texto = a + " " + b + " " + " " + c + " " + d + " " + e + " " + f + " " + g;
	  //CreaIMG(code);
	
	  var ctxCanvas = document.getElementById("captcha").getContext("2d");
	  var fontSize = "30px";
	  var fontFamily = "Arial";
	  var width = 250;
	  var height = 50;
	  //tamaño
	  ctxCanvas.canvas.width = width;
	  ctxCanvas.canvas.height = height;
	  //color de fondo
	  ctxCanvas.fillStyle = "whitesmoke";
	  ctxCanvas.fillRect(0, 0, width, height);
	  //puntos de distorsion
	  ctxCanvas.setLineDash([7, 10]);
	  ctxCanvas.lineDashOffset = 5;
	  ctxCanvas.beginPath();
	  var line;
	  for (var i = 0; i < width; i++) {
	    line = i * 5;
	    ctxCanvas.moveTo(line, 0);
	    ctxCanvas.lineTo(0, line);
	  }
	  ctxCanvas.stroke();
	  //formato texto
	  ctxCanvas.direction = "ltr";
	  ctxCanvas.font = fontSize + " " + fontFamily;
	  //texto posicion
	  var x = width / 9;
	  var y = height / 3 * 2;
	  //color del borde del texto
	  ctxCanvas.strokeStyle = "yellow";
	  ctxCanvas.strokeText(texto, x, y);
	  //color del texto
	  ctxCanvas.fillStyle = "red";
	  ctxCanvas.fillText(texto, x, y);
	  //document.getElementById('mainCaptcha').value=texto;
	  code = texto;
	  document.getElementById("txtInput").value = ""; //linea cambiada llamando a la función para crear la imagen en un canvas
	};
	
	var ValidCaptcha = exports.ValidCaptcha = function ValidCaptcha() {
	  var string1 = removeSpaces(code);
	
	  var string2 = removeSpaces(document.getElementById("txtInput").value);
	
	  if (string1 === string2) {
	    document.getElementById("txtInput").value = "";
	    return true;
	  } else {
	    Captcha();
	    document.getElementById("txtInput").value = "";
	    return false;
	  }
	};
	var removeSpaces = exports.removeSpaces = function removeSpaces(string) {
	  return string.split(" ").join("");
	};
	
	var mascara = exports.mascara = function mascara(d, sep, pat, nums) {
	  //if (d.valant != d.value) {
	  var val = d.target.value;
	  var largo = val.length;
	  var val = val.split(sep);
	  var val2 = "";
	  for (var r = 0; r < val.length; r++) {
	    val2 += val[r];
	  }
	
	  if (nums) {
	    var letra = "";
	    for (var z = 0; z < val2.length; z++) {
	      if (isNaN(val2.charAt(z))) {
	        letra = new RegExp(val2.charAt(z), "g");
	        val2 = val2.replace(letra, "");
	      }
	    }
	  }
	
	  var val = "";
	  var val3 = new Array();
	
	  for (var s = 0; s < pat.length; s++) {
	    val3[s] = val2.substring(0, pat[s]);
	    val2 = val2.substr(pat[s]);
	  }
	
	  for (var q = 0; q < val3.length; q++) {
	    if (q === 0) {
	      val = val3[q];
	    } else {
	      if (val3[q] != "") {
	        val += sep + val3[q];
	      }
	    }
	  }
	  (0, _jquery2.default)(event.target).val(val);
	  //d.value = val;
	  //d.valant = val;
	  //}
	};
	
	var validarRif = exports.validarRif = function validarRif(d) {
	  //if (d.valant != d.value) {
	  var pat = new Array(1, 8, 1);
	  var val = d.target.value;
	  var largo = val.length;
	  var sep = "-";
	  var val = val.split(sep);
	  var val2 = "";
	  for (var r = 0; r < val.length; r++) {
	    val2 += val[r];
	  }
	
	  var val = "";
	  var val3 = new Array();
	
	  for (var s = 0; s < pat.length; s++) {
	    val3[s] = val2.substring(0, pat[s]);
	    val2 = val2.substr(pat[s]);
	  }
	
	  for (var q = 0; q < val3.length; q++) {
	    if (q === 0) {
	      val = val3[q];
	    } else {
	      if (val3[q] != "") {
	        val += sep + val3[q];
	      }
	    }
	  }
	  if (val.toUpperCase().substring(0, 1) !== "J" && val.toUpperCase().substring(0, 1) !== "P" && val.toUpperCase().substring(0, 1) !== "V" && val.toUpperCase().substring(0, 1) !== "E" && val.toUpperCase().substring(0, 1) !== "G") {
	    val = "";
	  }
	  if (val.length > 2) {
	    var letra = "";
	    var size = 0;
	    if (val.length > 10) {
	      size = 10;
	    } else {
	      size = val.length;
	    }
	    for (var z = 2; z < size; z++) {
	      if (isNaN(val.charAt(z))) {
	        letra = new RegExp(val.charAt(z), "g");
	        if (z === 2) {
	          val = val.replace(letra, "").replace("-", "");
	        } else {
	          val = val.replace(letra, "");
	        }
	      }
	    }
	  }
	  if (val.length > 10) {
	    for (var y = 11; y < val.length; y++) {
	      if (isNaN(val.charAt(y))) {
	        letra = new RegExp("-" + val.charAt(y), "g");
	        val = val.replace(letra, "");
	      }
	    }
	  }
	  (0, _jquery2.default)(event.target).val(val.toUpperCase());
	  //d.value = val;
	  //d.valant = val;
	  //}
	};
	
	var validaNumRif = exports.validaNumRif = function validaNumRif(inputtxt) {
	  var rif = /^([VEJPGvejpg]{1})-([0-9]{8})-([0-9]{1}$)/;
	  if (inputtxt.match(rif)) {
	    return true;
	  } else {
	    return false;
	  }
	};
	
	var validaNumRifSinGuion = exports.validaNumRifSinGuion = function validaNumRifSinGuion(inputtxt) {
	  var rif = /^([VEJPGvejpg]{1})([0-9]{8})([0-9]{1}$)/;
	  if (inputtxt.match(rif)) {
	    return true;
	  } else {
	    return false;
	  }
	};
	
	var validarArchivoRetencion = exports.validarArchivoRetencion = function validarArchivoRetencion(event) {
	  var archivo = event.target.files[0];
	  if (!archivo) {
	    return;
	  }
	  var lector = new FileReader();
	
	  lector.readAsText(archivo);
	  //lector.onload = cargarArchivo(event);
	  var resp = lector.onload = function (e) {
	    var contenido = e.target.result;
	    var lineas = contenido.split("\n");
	
	    respuesta = validarCamposArchivo(lineas);
	    return respuesta;
	    /*var cont = 0;
	    for (var linea of lineas) {
	      cont++;
	      alert('linea: ' + cont + ' ' + linea)
	    }*/
	  };
	  //lector.readAsText(archivo);
	  respuesta = resp;
	  return respuesta;
	};
	
	var validarCamposArchivo = exports.validarCamposArchivo = function validarCamposArchivo(datos) {
	  var fila = [];
	  var resp = [];
	  var msj = "";
	  var pat = "";
	  var mat = true;
	  var valido = true;
	  var filaLlena = -1;
	  var filaVacia = -1;
	  for (var i = 0; i < datos.length; i++) {
	    if (datos[i].toString().trim().length > 0) {
	      filaLlena = i;
	      if (filaLlena > filaVacia & filaVacia >= 0) {
	        //console.error("LA LINEA " + i + " ESTA VACIA");
	        //console.error("ARCHIVO INVALIDO");
	
	        valido = false;
	        msj = "LA LINEA " + i + " ESTA VACIA ARCHIVO INVALIDO";
	        resp.push(false);
	        resp.push(msj);
	        //respuesta.put("msj","LA LINEA " + i + " ESTA VACIA ARCHIVO INVALIDO");
	        //return false;
	        return resp;
	      }
	      //fila = datos[i].toString().split("\t");
	      fila = datos[i].toString().split("|");
	      for (var j = 0; j < fila.length; j++) {
	        switch (j) {
	          case 0:
	            /* if (fila[j].trim().replace("\uFEFF", "").length > 5 || !fila[j].trim().replace("\uFEFF", "").match("\\d{4,5}")) {
	              //console.error("CODIGO O NUMERO DE AGENTE DE RETENCION " + fila[j] + " INVALIDO LINEA " + (i + 1));
	              //console.error("ARCHIVO INVALIDO");
	               valido = false;
	              msj = "CODIGO O NUMERO DE AGENTE DE RETENCION " + fila[j] + " INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
	              resp.push(false);
	              resp.push(msj);
	              return resp;
	            } */
	            if (fila[j].trim().replace("\uFEFF", "").length > 4 || !fila[j].trim().replace("\uFEFF", "").match("\\d{4}")) {
	              //console.error("NUMERO DE OPERACION " + fila[j] + " INVALIDO LINEA " + (i + 1));
	
	              valido = false;
	              msj = "NUMERO DE OPERACION " + fila[j] + " INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
	              resp.push(false);
	              resp.push(msj);
	              return resp;
	            }
	
	            break;
	
	          case 1:
	            if (fila[j].trim() === "") {
	              //console.error("TIPO DE INSTRUMENTO '" + fila[j].trim() + "' INVALIDO LINEA " + (i + 1));
	              //console.error("ARCHIVO INVALIDO");
	              //msj= "NOMBRE DEL SUJETO RETENIDO '" + fila[j].trim() + "' INVALIDO LINEA " + (i+1) + "ARCHIVO INVALIDO";
	              valido = false;
	              msj = "TIPO DE INSTRUMENTO '" + fila[j].trim() + "' INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
	              resp.push(false);
	              resp.push(msj);
	              return resp;
	            }
	
	            break;
	
	          case 2:
	            pat = "(\\d{6,12})$";
	
	            // Asociar el string al patron
	            //mat = pat.matcher(fila[j].trim());
	            if (fila[j].trim().length < 6 || !fila[j].trim().match(pat)) {
	              //console.error("NUMERO DE INSTRUMENTO " + fila[j] + " INVALIDO LINEA " + (i + 1));
	              //console.error("ARCHIVO INVALIDO");
	              //msj="NUMERO DE COMPROBANTE DE RETENCION " + fila[j] + " INVALIDO LINEA " + (i+1) + "ARCHIVO INVALIDO";
	              valido = false;
	              msj = "NUMERO DE INSTRUMENTO " + fila[j] + " INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
	              resp.push(false);
	              resp.push(msj);
	              return resp;
	            }
	
	            break;
	
	          case 3:
	            pat = "^([0][1-9]|[12][0-9]|3[01])-([0][1-9]|[1][0-2])-(\\d{4})$";
	
	            // Asociar el string al patron
	            //mat = pat.matcher(fila[j].trim());
	            if (!fila[j].trim().match(pat)) {
	              //console.error("FECHA DE EMISION " + fila[j] + " INVALIDA LINEA " + (i + 1));
	              //console.error("ARCHIVO INVALIDO");
	              //msj= "FECHA DE FACTURA " + fila[j] + " INVALIDA LINEA " + (i+1) + "ARCHIVO INVALIDO";
	              valido = false;
	              msj = "FECHA DE EMISION " + fila[j] + " INVALIDA LINEA " + (i + 1) + " ARCHIVO INVALIDO";
	              resp.push(false);
	              resp.push(msj);
	              return resp;
	            }
	
	            break;
	
	          case 4:
	            if (fila[j].trim() === "") {
	              //console.error("NOMBRE O RAZON SOCIAL '" + fila[j].trim() + "' INVALIDO LINEA " + (i + 1));
	              //console.error("ARCHIVO INVALIDO");
	              //msj= "NOMBRE DEL SUJETO RETENIDO '" + fila[j].trim() + "' INVALIDO LINEA " + (i+1) + "ARCHIVO INVALIDO";
	              valido = false;
	              msj = "NOMBRE O RAZON SOCIAL '" + fila[j].trim() + "' INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
	              resp.push(false);
	              resp.push(msj);
	              return resp;
	            }
	
	            break;
	
	          case 5:
	            //pat = "^[JVGE]-\\d{8}-\\d{1}$";
	            pat = "^[JVGE]\\d{8}\\d{1}$";
	
	            // Asociar el string al patron
	
	            //mat = pat.matcher(fila[j].trim());
	            if (!fila[j].trim().match(pat)) {
	              //console.error("CEDULA O RIF " + fila[j] + " INVALIDO LINEA " + (i + 1));
	              //console.error("ARCHIVO INVALIDO");
	              //msj="RIF AGENTE DE RETENCION " + fila[j] + " INVALIDO LINEA " + (i+1)+ "ARCHIVO INVALIDO";
	              valido = false;
	              msj = "CEDULA O RIF " + fila[j] + " INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
	              resp.push(false);
	              resp.push(msj);
	              return resp;
	            }
	
	            break;
	
	          case 6:
	            //pat = "^-?\\d*\\,{0,1}\\d+$";
	            pat = "^-?\\d*\\.{0,1}\\d+$";
	
	            // Asociar el string al patron
	            //mat = pat.matcher(fila[j].trim());
	            if (!fila[j].trim().match(pat)) {
	              //console.error("MONTO BRUTO " + fila[j] + " INVALIDO LINEA " + (i + 1));
	              //console.error("ARCHIVO INVALIDO");
	              valido = false;
	              msj = "MONTO BRUTO " + fila[j] + " INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
	              resp.push(false);
	              resp.push(msj);
	              return resp;
	            }
	
	            break;
	
	          case 7:
	            //pat = "^-?\\d*\\,{0,1}\\d+$";
	            pat = "^-?\\d*\\.{0,1}\\d+$";
	
	            // Asociar el string al patron
	            //mat = pat.matcher(fila[j].trim());
	            if (!fila[j].trim().match(pat)) {
	              //console.error("IMPUESTO 1X500 " + fila[j] + " INVALIDO LINEA " + (i + 1));
	              //console.error("ARCHIVO INVALIDO");
	              valido = false;
	              msj = "IMPUESTO 1X500 " + fila[j] + " INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
	              resp.push(false);
	              resp.push(msj);
	              return resp;
	            }
	
	            break;
	
	          /*case 14:
	             pat = "\\d{1,3},\\d{1,2}%$";
	             // Asociar el string al patron
	            //mat = pat.matcher(fila[j].trim());
	            if (!fila[j].trim().match(pat)) {
	              //console.error("% DE ALICUOTA " + fila[j] + " INVALIDO LINEA " + (i + 1));
	              //console.error("ARCHIVO INVALIDO");
	              //msj="% DE ALICUOTA " + fila[j] + " INVALIDO LINEA " + (i+1) + "ARCHIVO INVALIDO";
	              valido = false;
	              msj = "% DE ALICUOTA " + fila[j] + " INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
	              resp.push(false);
	              resp.push(msj);
	              return resp;
	            }
	             break;
	           case 2:
	             pat = "^[DT]$";
	             // Asociar el string al patron
	            //mat = pat.matcher(fila[j].trim());
	            if (!fila[j].trim().match(pat)) {
	              //console.error("TIPO CONTRIBUYENTE '" + fila[j].trim() + "' INVALIDO LINEA " + (i + 1));
	              //console.error("ARCHIVO INVALIDO");
	              valido = false;
	              msj = "TIPO CONTRIBUYENTE '" + fila[j].trim() + "' INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
	              resp.push(false);
	              resp.push(msj);
	              return resp;
	            }
	             break;
	           case 3:
	            pat = "^\\d{4}$";
	             // Asociar el string al patron
	            //mat = pat.matcher(fila[j].trim());
	            if (!fila[j].trim().match(pat)) {
	              //console.error("AÑO DEL PERIODO IMPOSITIVO " + fila[j] + " INVALIDO LINEA " + (i + 1));
	              //console.error("ARCHIVO INVALIDO");
	              //msj= "AÑO DEL PERIODO IMPOSITIVO " + fila[j] + " INVALIDO LINEA " + (i+1) + "ARCHIVO INVALIDO";
	              valido = false;
	              msj = "AÑO DEL PERIODO IMPOSITIVO " + fila[j] + " INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
	              resp.push(false);
	              resp.push(msj);
	              return resp;
	            }
	             break;
	           case 4:
	             pat = "[0][1-9]|[1][0-2]$";
	             // Asociar el string al patron
	            //mat = pat.matcher(fila[j].trim());
	            if (!fila[j].trim().match(pat)) {
	              //console.error("MES DEL PERIODO IMPOSITIVO " + fila[j].trim() + " INVALIDO LINEA " + (i + 1));
	              //console.error("ARCHIVO INVALIDO");
	              //msj= "MES DEL PERIODO IMPOSITIVO " + fila[j].trim() + " INVALIDO LINEA " + (i+1) + "ARCHIVO INVALIDO";
	              valido = false;
	              msj = "MES DEL PERIODO IMPOSITIVO " + fila[j].trim() + " INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
	              resp.push(false);
	              resp.push(msj);
	              return resp;
	            }
	             break;
	           case 5:
	            if (fila[j].trim().length > 5 || !fila[j].match("\\d{4,5}[' ']*")) {
	              //console.error("CODIGO O NUMERO DE AGENTE RETENIDO " + fila[j] + " INVALIDO LINEA " + (i + 1));
	              //console.error("ARCHIVO INVALIDO");
	              //msj= "CODIGO O NUMERO DE AGENTE RETENIDO " + fila[j] + " INVALIDO LINEA " + (i+1) + "ARCHIVO INVALIDO";
	              valido = false;
	              msj = "CODIGO O NUMERO DE AGENTE RETENIDO " + fila[j] + " INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
	              resp.push(false);
	              resp.push(msj);
	              return resp;
	            }
	             break;
	           case 6:
	             pat = "^[JVGE]-\\d{8}-\\d{1}$";
	             // Asociar el string al patron
	            //mat = pat.matcher(fila[j].trim());
	            if (!fila[j].trim().match(pat)) {
	              //console.error("RIF DEL SUJETO RETENIDO " + fila[j] + " INVALIDO LINEA " + (i + 1));
	              //console.error("ARCHIVO INVALIDO");
	              //msj="RIF DEL SUJETO RETENIDO " + fila[j] + " INVALIDO LINEA " + (i+1) + "ARCHIVO INVALIDO";
	              valido = false;
	              msj = "RIF DEL SUJETO RETENIDO " + fila[j] + " INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
	              resp.push(false);
	              resp.push(msj);
	              return resp;
	            }
	             break;
	           case 8:
	             pat = "^([0][1-9]|[12][0-9]|3[01])/([0][1-9]|[1][0-2])/(\\d{4})$";
	             // Asociar el string al patron
	            //mat = pat.matcher(fila[j].trim());
	            if (!fila[j].trim().match(pat)) {
	              //console.error("FECHA DE FACTURA " + fila[j] + " INVALIDA LINEA " + (i + 1));
	              //console.error("ARCHIVO INVALIDO");
	              //msj= "FECHA DE FACTURA " + fila[j] + " INVALIDA LINEA " + (i+1) + "ARCHIVO INVALIDO";
	              valido = false;
	              msj = "FECHA DE FACTURA " + fila[j] + " INVALIDA LINEA " + (i + 1) + " ARCHIVO INVALIDO";
	              resp.push(false);
	              resp.push(msj);
	              return resp;
	            }
	             break;
	           case 11:
	             pat = "(\\d{4})([0][1-9]|[1][0-2])(\\d{1,14})$";
	             // Asociar el string al patron
	            //mat = pat.matcher(fila[j].trim());
	            if (fila[j].trim().length < 7 || !fila[j].trim().match(pat)) {
	              //console.error("NUMERO DE COMPROBANTE DE RETENCION " + fila[j] + " INVALIDO LINEA " + (i + 1));
	              //console.error("ARCHIVO INVALIDO");
	              //msj="NUMERO DE COMPROBANTE DE RETENCION " + fila[j] + " INVALIDO LINEA " + (i+1) + "ARCHIVO INVALIDO";
	              valido = false;
	              msj = "NUMERO DE COMPROBANTE DE RETENCION " + fila[j] + " INVALIDO LINEA " + (i + 1) + " ARCHIVO INVALIDO";
	              resp.push(false);
	              resp.push(msj);
	              return resp;
	            }
	             break;
	           case 12:
	             pat = "^([0][1-9]|[12][0-9]|3[01])/([0][1-9]|[1][0-2])/(\\d{4})$";
	             // Asociar el string al patron
	            //mat = pat.matcher(fila[j].trim());
	            if (!fila[j].trim().match(pat)) {
	              //console.error("FECHA DE RETENCIÓN " + fila[j] + " INVALIDA LINEA " + (i + 1));
	              //console.error("ARCHIVO INVALIDO");
	              //msj="FECHA DE RETENCIÓN " + fila[j] + " INVALIDA LINEA " + (i+1) + "ARCHIVO INVALIDO";
	              valido = false;
	              msj = "FECHA DE RETENCIÓN " + fila[j] + " INVALIDA LINEA " + (i + 1) + " ARCHIVO INVALIDO";
	              resp.push(false);
	              resp.push(msj);
	              return resp;
	            }
	             break;*/
	
	          /*case 16:
	             filaVacia = i;
	            if(filaLlena > filaVacia & filaVacia >= 0){
	              ////console.error("FILA " + i + " ESTA VACIA");
	              ////console.error("ARCHIVO INVALIDO");
	              respuesta.clear();
	                          respuesta.put("valido", false);
	                          respuesta.put("msj", "FILA " + i + " ESTA VACIA ARCHIVO INVALIDO");
	                        return false;
	            	
	            }
	            	
	            break;*/
	          default:
	            break;
	        }
	      }
	    } else {
	      filaVacia = i;
	      if (filaLlena > filaVacia & filaVacia >= 0) {
	        //console.error("FILA " + i + " ESTA VACIA");
	        //console.error("ARCHIVO INVALIDO");
	        //msj="FILA " + i + " ESTA VACIA ARCHIVO INVALIDO";
	        valido = false;
	        msj = "FILA " + i + " ESTA VACIA ARCHIVO INVALIDO";
	        resp.push(false);
	        resp.push(msj);
	        return resp;
	      }
	    }
	  }
	  if (valido) {
	    resp.push(true);
	    resp.push("ARCHIVO VALIDO");
	    return resp;
	  }
	};
	
	var cargarCamposArchivo = exports.cargarCamposArchivo = function cargarCamposArchivo(datos, tipoage) {
	  var fila = [];
	  var rete = [];
	  var txtNumOpe = "";
	  var txtNumIns = "";
	  var txtTipoIns = "";
	  var txtCedRif = "";
	  var txtRazonSoc = "";
	  var txtFecEmi = "";
	  var txtMonBruto = "";
	  var txtRete1x500 = "";
	
	  _moment2.default.locale("es");
	  for (var i = 0; i < datos.length; i++) {
	    if (datos[i].toString().trim().length > 0) {
	      fila = datos[i].toString().split("|");
	      for (var j = 0; j < fila.length; j++) {
	        switch (j) {
	          case 0:
	            txtNumOpe = fila[j].trim().replace("\uFEFF", "");
	            break;
	          case 1:
	            txtTipoIns = fila[j].trim();
	            break;
	
	          case 2:
	            txtNumIns = fila[j].trim();
	            break;
	
	          case 3:
	            txtFecEmi = fila[j].trim();
	            break;
	
	          case 4:
	            txtRazonSoc = fila[j].trim();
	            break;
	
	          case 5:
	            txtCedRif = fila[j].trim();
	            break;
	
	          case 6:
	            txtMonBruto = formatMoneda(fila[j].trim().replace(",", "").replace(".", ","), ",", ".", 2);
	            break;
	
	          case 7:
	            txtRete1x500 = formatMoneda(fila[j].trim().replace(",", "").replace(".", ","), ",", ".", 2);
	            break;
	
	          /*case 8:
	            //txtFecFactura = fila[j].trim();
	            fecha = fila[j].trim().split("/");
	            txtFecEmi = fecha[2].trim() + "-" + fecha[1].trim() + "-" + fecha[0].trim();
	             break;
	           case 9:
	            txtNumFactura = fila[j].trim();
	             break;
	           case 10:
	            txtRete1x500 = fila[j].trim();
	             break;
	           case 11:
	            txtNumComprobante = fila[j].trim();
	             break;
	           case 12:
	            //txtFecComprobante = fila[j].trim();
	            fecha = fila[j].trim().split("/");
	            txtFecComprobante = fecha[2].trim() + "-" + fecha[1].trim() + "-" + fecha[0].trim();
	             break;
	           case 13:
	            txtMonBruto = fila[j].trim();
	             break;
	           case 14:
	            txtAlicuota = fila[j].trim();
	             break;
	           case 15:
	            txtMonRete = fila[j].trim();
	             break;*/
	
	          default:
	            break;
	        }
	      }
	      rete.push({
	        numope: txtNumOpe,
	        tipoins: txtTipoIns,
	        numins: txtNumIns,
	        cedrif: txtCedRif,
	        nombre: txtRazonSoc,
	        //fecemi: moment(txtFecEmi.toString()).format('YYYY-MM-DD'),
	        fecemi: txtFecEmi,
	        monbruto: txtMonBruto,
	        monrete: txtRete1x500
	      });
	    }
	  }
	  return rete;
	};
	
	var generar = exports.generar = function generar(longitud) {
	  var long = parseInt(longitud);
	  var caracteres = "abcdefghijkmnpqrtuvwxyzABCDEFGHIJKLMNPQRTUVWXYZ2346789";
	  var contraseña = "";
	  for (var i = 0; i < long; i++) {
	    contraseña += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
	  }return contraseña;
	};
	
	var colores = exports.colores = ["#17a2b8", "#ffae00", "#dc3545", "#BDB76B", "#7B68EE", "#4B0082", "#00ffff", "#0080ff", "#0000ff", "#8000ff", "#ff00ff", "#ff0080", "#0099FF", "#00CC66", "#6600CC", "#CCFF00", "#FF66FF", "#00CCCC", "#996600", "#CC00CC", "#3399FF", "#990000", "#FFFF99", "#FF9900"];
	
	var colores2 = exports.colores2 = ["#0000FF", "#003300", "#006600", "#0066FF", "#0099FF", "#00CC66", "#00CCCC", "#00FF99", "#00FFCC", "#00FFFF", "#330099", "#333300", "#333366", "#3333FF", "#336600", "#336633", "#336666", "#336699", "#3366CC", "#3366FF", "#339900", "#339933", "#339966", "#339999", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#33FF00", "#33FF33", "#33FF66", "#33FF99", "#33FFCC", "#33FFFF", "#660000", "#660033", "#660066", "#660099", "#6600CC", "#6600FF", "#663300", "#663333", "#663366", "#663399", "#6633CC", "#6633FF", "#666600", "#666633", "#666666", "#666699", "#6666CC", "#6666FF", "#669900", "#669933", "#669966", "#669999", "#6699CC", "#6699FF", "#66CC00", "#66CC33", "#66CC66", "#66CC99", "#66CCCC", "#66CCFF", "#66FF00", "#66FF33", "#66FF66", "#66FF99", "#66FFCC", "#66FFFF", "#990000", "#990033", "#990066", "#990099", "#9900CC", "#9900FF", "#993300", "#993333", "#993366", "#993399", "#9933CC", "#9933FF", "#996600", "#996633", "#996666", "#996699", "#9966CC", "#9966FF", "#999900", "#999933", "#999966", "#999999", "#9999CC", "#9999FF", "#99CC00", "#99CC33", "#99CC66", "#99CC99", "#99CCCC", "#99CCFF", "#99FF00", "#99FF33", "#99FF66", "#99FF99", "#99FFCC", "#99FFFF", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC6666", "#CC6699", "#CC66CC", "#CC66FF", "#CC9900", "#CC9933", "#CC9966", "#CC9999", "#CC99CC", "#CC99FF", "#CCCC00", "#CCCC33", "#CCCC66", "#CCCC99", "#CCCCCC", "#CCCCFF", "#CCFF00", "#CCFF33", "#CCFF66", "#CCFF99", "#CCFFCC", "#CCFFFF", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF6666", "#FF6699", "#FF66CC", "#FF66FF", "#FF9900", "#FF9933", "#FF9966", "#FF9999", "#FF99CC", "#FF99FF", "#FFCC00", "#FFCC33", "#FFCC66", "#FFCC99", "#FFCCCC", "#FFCCFF", "#FFFF00", "#FFFF33", "#FFFF66", "#FFFF99", "#FFFFCC", "#FFFFFF"];
	
	var isResponseOk = exports.isResponseOk = function isResponseOk(response) {
	  if (!response.ok) throw new Error(response.status);
	  return response.text();
	};
	
	var cmbCedula = exports.cmbCedula = [{ value: "V" }, { value: "J" }, { value: "G" }, { value: "P" }, { value: "E" }];
	
	var detallePedido = exports.detallePedido = function detallePedido(data, operacion, estatus, moneda) {
	  var prod = [];
	  var uni = [];
	  var precio = 0.0;
	  var tasa = 0.0;
	
	  for (var i = 0; i < data.length; i++) {
	    if (parseInt(data[i].idunidadalterna) === 0 || data[i].idunidadalterna === null) {
	      uni = [{
	        idunidad: data[i].idunidadmedida,
	        descripcion: data[i].descripcionuni,
	        tipo: "medida"
	      }];
	      precio = data[i].costocalculado * (1 + data[i].utipreciomaxi / 100);
	      precio = Math.round(precio * 100) / 100;
	    } else {
	      if (parseInt(data[i].tipounidad) === parseInt(data[i].idunidadmedida)) {
	        precio = data[i].costocalculado * (1 + data[i].utipreciomaxi / 100);
	        precio = Math.round(precio * 100) / 100;
	        uni = [{
	          idunidad: data[i].idunidadmedida,
	          descripcion: data[i].descripcionuni,
	          tipo: "medida"
	        }, {
	          idunidad: data[i].idunidadalterna,
	          descripcion: data[i].descripcionunialt,
	          tipo: "alterna"
	        }];
	      } else {
	        precio = data[i].costocalculadoalter * (1 + data[i].utipreciomaxialter / 100);
	        precio = Math.round(precio * 100) / 100;
	        uni = [{
	          idunidad: data[i].idunidadalterna,
	          descripcion: data[i].descripcionunialt,
	          tipo: "alterna"
	        }, {
	          idunidad: data[i].idunidadmedida,
	          descripcion: data[i].descripcionuni,
	          tipo: "medida"
	        }];
	      }
	    }
	    if (data[i].idmoneda === moneda.idmoneda) {
	      tasa = data[i].valormoneda;
	    } else {
	      tasa = moneda.valormoneda;
	    }
	    if (!moneda.subpredeterminada) {
	      precio = precio * data[i].valormoneda;
	      precio = precio / tasa;
	      precio = Math.round(precio * 100) / 100;
	    } else {
	      precio = data[i].punitario;
	    }
	
	    precio = Math.round(precio * 100) / 100;
	    if (operacion === 4 && estatus === 1) {
	      if (moneda.subpredeterminada) {
	        precio = data[i].punitario;
	      } else {
	        precio = data[i].punitariobs;
	      }
	    }
	
	    var montoiva = precio * data[i].iva / 100;
	    montoiva = Math.round(montoiva * 100) / 100;
	
	    var cantie = data[i].cantidade;
	    var cantiea = 0.0;
	    if (data[i].tipounidad === 0) {
	      if (data[i].tipofactor === "1") {
	        cantie = parseFloat(data[i].cantidade / data[i].valorfactor);
	        cantie = Math.trunc(cantie);
	
	        cantiea = parseFloat(data[i].cantidad * data[i].valorfactor);
	        cantiea = Math.trunc(cantiea);
	      }
	    } else {
	      if (data[i].tipofactor === "0") {
	        cantie = parseFloat(data[i].cantidade / data[i].valorfactor);
	        cantie = Math.trunc(cantie);
	
	        cantiea = parseFloat(data[i].cantidad * data[i].valorfactor);
	        cantiea = Math.trunc(cantiea);
	      }
	    }
	
	    prod.push({
	      idproducto: data[i].idproducto,
	      codigo: data[i].codigo,
	      cantidad: data[i].cantidad,
	      cantidadE: parseFloat(cantie) + parseFloat(data[i].cantidad),
	      cantidadEA: parseFloat(data[i].cantidade) + parseFloat(cantiea),
	      nombrecorto: data[i].nombrecorto,
	      precio: precio,
	      precious: data[i].punitario,
	      preciobs: data[i].punitariobs,
	      iva: data[i].iva,
	      ivaventa: data[i].ivaventa,
	      montoiva: data[i].cantidad * montoiva,
	      descuento: data[i].descuento,
	      total: data[i].cantidad * precio,
	      unidad: uni,
	      idunidadmedida: data[i].idunidadmedida,
	      idunidadalterna: data[i].idunidadalterna,
	      costocalculado: data[i].costocalculado,
	      costocalculadoalter: data[i].costocalculadoalter,
	      utipreciomaxi: data[i].utipreciomaxi,
	      utipreciomaxialter: data[i].utipreciomaxialter,
	      tipounidad: data[i].tipounidad,
	      valormoneda: data[i].valormoneda,
	      idmoneda: data[i].idmoneda,
	      tipofactor: data[i].tipofactor,
	      valorfactor: data[i].valorfactor
	    });
	  }
	
	  return prod;
	};
	
	var validarCantidadPedido = exports.validarCantidadPedido = function validarCantidadPedido(event) {
	  validaMonto(event);
	  if (event.which === 13 || typeof event.which === "undefined") {
	    if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	      event.target.value = "1,00";
	    }
	    event.target.value = formatoMonto(event.target.value);
	    var char1 = event.target.value.substring(0, 1);
	    var char2 = event.target.value.substring(1, 2);
	    if (char1 === "0" && char2 !== ",") {
	      event.target.value = event.target.value.substring(1, event.target.value.length);
	    }
	    return event.target.value;
	  } else if (event.which === 46) {
	    return false;
	  } else if (event.which >= 48 && event.which <= 57) {
	    return true;
	  } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	    return true;
	  } else return false;
	};
	
	var round = exports.round = function round(num) {
	  var decimales = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	
	  var signo = num >= 0 ? 1 : -1;
	  num = num * signo;
	  if (decimales === 0)
	    //con 0 decimales
	    return signo * Math.round(num);
	  // round(x * 10 ^ decimales)
	  num = num.toString().split("e");
	  num = Math.round(+(num[0] + "e" + (num[1] ? +num[1] + decimales : decimales)));
	  // x * 10 ^ (-decimales)
	  num = num.toString().split("e");
	  return signo * (num[0] + "e" + (num[1] ? +num[1] - decimales : -decimales));
	};
	
	var fabricantes = exports.fabricantes = {
	  "CERVECERIA POLAR": "1",
	  "ALIMENTOS POLAR": "2",
	  "P&G": "3",
	  POMAR: "4",
	  PEPSI: "5"
	};
	
	var unidadmedidas = exports.unidadmedidas = {
	  "POR DEFINIR": "0",
	  "POR DEFINIR ALTER": "1",
	  LITROS: "91",
	  BULTO: "92",
	  SACOS: "93",
	  KILOS: "94",
	  PACAS: "95",
	  CAJAS: "96",
	  TONELADAS: "98",
	  PORRON: "99",
	  GRAMOS: "100",
	  UNIDAD: "101",
	  CC: "102"
	};
	
	var tipoproducto = exports.tipoproducto = {
	  "POR DEFINIR": "0",
	  BEBIDAS: "119",
	  ALIMENTOS: "120",
	  VINOS: "122",
	  VACIOS: "123",
	  "P&G": "124",
	  "USO PERSONAL": "125"
	};
	
	var marcas = exports.marcas = (_marcas = {
	  PEPSI: "2",
	  KIKER: "4",
	  PAN: "5",
	  SINDON: "6",
	  POLAR: "8",
	  POINTER: "9",
	  HP: "10",
	  MAVESA: "13",
	  NELLY: "14",
	  CHEF: "15",
	  PAMPERO: "16",
	  "LA VIENESA": "17",
	  RIKESA: "18"
	}, _defineProperty(_marcas, "PAN", "19"), _defineProperty(_marcas, "PRIMOR", "20"), _defineProperty(_marcas, "CORINA", "21"), _defineProperty(_marcas, "QUAKER", "22"), _defineProperty(_marcas, "DON PANCHO", "23"), _defineProperty(_marcas, "MAZEITE", "24"), _defineProperty(_marcas, "TODDY", "25"), _defineProperty(_marcas, "GOLDEN", "26"), _defineProperty(_marcas, "KONGA", "27"), _defineProperty(_marcas, "MARGARITA", "28"), _defineProperty(_marcas, "CALIFORNIA", "29"), _defineProperty(_marcas, "MIGURT", "30"), _defineProperty(_marcas, "LAS LLAVES", "31"), _defineProperty(_marcas, "MULTI CLEAN", "32"), _defineProperty(_marcas, "DOGOURMET", "33"), _defineProperty(_marcas, "SUPER CAN", "34"), _defineProperty(_marcas, "MALTIN", "35"), _defineProperty(_marcas, "PEPSI-COLA", "36"), _defineProperty(_marcas, "YUKY-PAK", "37"), _defineProperty(_marcas, "YUKERY", "38"), _defineProperty(_marcas, "TE LIPTON", "39"), _defineProperty(_marcas, "GATORADE", "40"), _defineProperty(_marcas, "MINALBA", "41"), _defineProperty(_marcas, "EVERVESS", "42"), _defineProperty(_marcas, "CARORE\xD1A", "43"), _defineProperty(_marcas, "POMAR", "44"), _defineProperty(_marcas, "POR DEFINIR", "0"), _defineProperty(_marcas, "KOLA", "46"), _defineProperty(_marcas, "VACIOS", "47"), _defineProperty(_marcas, "ACE", "48"), _defineProperty(_marcas, "ARIEL", "49"), _defineProperty(_marcas, "DOWNY", "50"), _defineProperty(_marcas, "PAMPERS", "51"), _defineProperty(_marcas, "ALWAYS", "52"), _defineProperty(_marcas, "OLD SPICE", "53"), _defineProperty(_marcas, "GILLETTE", "54"), _defineProperty(_marcas, "HS", "55"), _defineProperty(_marcas, "PTN", "56"), _defineProperty(_marcas, "VENUS", "57"), _defineProperty(_marcas, "POMAR", "58"), _marcas);
	
	var modelos = exports.modelos = (_modelos = {
	  "POR DEFINIR": "0",
	  LCD: "2",
	  "2 LITROS": "3",
	  LATA: "4",
	  "1 KILO": "5",
	  LITRO: "6",
	  "250 GRAMOS": "8",
	  "500 GRAMOS": "9",
	  "1000 GRAMOS": "10",
	  "400 GRAMOS": "11",
	  "5 KILOGRAMOS": "12",
	  "175 GRAMOS": "13",
	  "445G": "14",
	  "910 GRAMOS": "15",
	  "3,6 KILOGRAMO": "16",
	  "500 ML": "17",
	  "1 LITRO": "18",
	  "4 LITROS": "19",
	  "198 GRAMOS": "20",
	  "397 GRAMOS": "21",
	  "4,2 KILOGRAMOS": "22",
	  "240 GRAMOS": "23",
	  "200 GRAMOS": "24",
	  "300 GRAMOS": "25",
	  "220 GRAMOS": "26",
	  "225 GRAMOS": "27",
	  "450 GRAMOS": "28",
	  "900 GRAMOS": "29",
	  "100 GRAMOS": "30",
	  "800 GRAMOS": "31",
	  "18 LITROS": "32",
	  "2 KILOS": "33",
	  "24 GRAMOS": "34",
	  "125 GRAMOS": "35",
	  "96 GRAMOS": "36",
	  "30 GRAMOS": "37",
	  "140 GRAMOS": "38",
	  "170 GRAMOS": "39",
	  "750 GRAMOS": "40",
	  "510 ML": "41",
	  "160 GRAMOS": "42",
	  "500 CC": "43",
	  "130 GRAMOS": "44",
	  "950CC": "45",
	  "530CC": "46",
	  "4 KILOS": "47",
	  "10 KILOS": "48",
	  "18 KILOS": "49",
	  "222 ML": "51",
	  "4 GRAMOS": "73",
	  "250 ML": "52",
	  "330 ML": "50",
	  "50 ML": "53",
	  "0.250 ML": "54",
	  "350 ML": "55",
	  "1.25 LTS": "56",
	  "1.5 L": "57",
	  "355 ML": "58",
	  "600 ML": "59",
	  "5 LTS": "60",
	  "30 L": "61",
	  "295 ML": "62",
	  "300 ML": "63",
	  "0,75 LT": "64",
	  "1,75 LT": "65",
	  "800 CC": "67",
	  "1900 CC": "68",
	  "1800 CC": "69",
	  "850 GRAMOS": "70"
	}, _defineProperty(_modelos, "500 GRAMOS", "71"), _defineProperty(_modelos, "500 GRAMOS", "72"), _defineProperty(_modelos, "432 GRAMOS", "74"), _defineProperty(_modelos, "491 GRAMOS", "75"), _defineProperty(_modelos, "463 GRAMOS", "76"), _defineProperty(_modelos, "52 GRAMOS", "77"), _defineProperty(_modelos, "60 GRAMOS", "78"), _defineProperty(_modelos, "375 CC", "79"), _defineProperty(_modelos, "180 CC", "80"), _defineProperty(_modelos, "300 CC", "81"), _defineProperty(_modelos, "400 CC", "82"), _defineProperty(_modelos, "170 CC", "83"), _defineProperty(_modelos, "200 CC", "84"), _defineProperty(_modelos, "15 CC", "85"), _defineProperty(_modelos, "525 CC", "86"), _modelos);
	
	var calcularTotales = exports.calcularTotales = function calcularTotales(datos) {
	  var subtot = 0.0,
	      descu = 0.0,
	      montoiva = 0.0,
	      totiva = 0.0,
	      totexe = 0.0,
	      totsuje = 0.0,
	      ivapor = 0.0,
	      totalm = 0.0;
	
	  for (var i = 0; i < datos.length; i++) {
	    if (parseFloat(datos[i].iva) > 0.0) {
	      ivapor = parseFloat(datos[i].iva);
	      totsuje = totsuje + parseFloat(datos[i].total);
	      // IVA por producto: se suma el monto de iva ya calculado en el producto
	      // (montoiva). Si el producto no lo trae, se calcula con su propio
	      // porcentaje de iva sobre el total del producto.
	      if (typeof datos[i].montoiva !== "undefined" && datos[i].montoiva !== null && !isNaN(parseFloat(datos[i].montoiva))) {
	        totiva = totiva + parseFloat(datos[i].montoiva);
	      } else {
	        totiva = totiva + round(parseFloat(datos[i].total) * ivapor / 100, 2);
	      }
	    } else {
	      totexe = totexe + parseFloat(datos[i].total);
	    }
	    subtot = subtot + parseFloat(datos[i].total);
	  }
	
	  montoiva = round(totiva, 2);
	  totalm = round(totsuje + totexe + montoiva, 2);
	
	  return {
	    subtotal: round(subtot, 2),
	    descuento: descu,
	    exento: round(totexe, 2),
	    sujeto: round(totsuje, 2),
	    iva: ivapor,
	    totaliva: montoiva,
	    total: totalm
	  };
	};
	
	var calcularTotalesDos = exports.calcularTotalesDos = function calcularTotalesDos(datos) {
	  var subtot = 0.0,
	      descu = 0.0,
	      totiva = 0.0,
	      totexe = 0.0,
	      totsuje = 0.0,
	      iva = 0.0,
	      totalm = 0.0;
	
	  for (var i = 0; i < datos.length; i++) {
	    if (parseFloat(datos[i].iva) > 0.0) {
	      iva = parseFloat(datos[i].iva);
	      totsuje = totsuje + parseFloat(datos[i].totalsiniva);
	      totiva = totiva + parseFloat(datos[i].totalivas);
	    } else {
	      totexe = totexe + parseFloat(datos[i].totalsiniva);
	    }
	    subtot = totsuje + totexe;
	  }
	
	  totalm = round(totsuje + totexe + totiva, 2);
	
	  return {
	    subtotal: round(subtot, 2),
	    descuento: descu,
	    exento: round(totexe, 2),
	    sujeto: round(totsuje, 2),
	    iva: iva,
	    totaliva: round(totiva, 2),
	    total: totalm
	  };
	};
	
	var calcularTotales_Dos = exports.calcularTotales_Dos = function calcularTotales_Dos(datos) {
	  var mtotal = 0.0,
	      descu = 0.0,
	      totiva = 0.0,
	      totexe = 0.0,
	      totsuje = 0.0,
	      iva = 0.0,
	      totalm = 0.0;
	
	  for (var i = 0; i < datos.length; i++) {
	    var base = 0.0;
	    if (typeof datos[i].totalsiniva !== "undefined" && datos[i].totalsiniva !== null && !isNaN(parseFloat(datos[i].totalsiniva))) {
	      base = parseFloat(datos[i].totalsiniva);
	    } else {
	      base = parseFloat(datos[i].total);
	    }
	    if (isNaN(base)) base = 0.0;
	
	    if (parseFloat(datos[i].iva) > 0.0) {
	      iva = parseFloat(datos[i].iva);
	      totsuje = totsuje + base;
	      // IVA por producto: se suma el monto de iva ya calculado en la linea
	      var ivaLinea = 0.0;
	      if (typeof datos[i].totalivas !== "undefined" && datos[i].totalivas !== null && !isNaN(parseFloat(datos[i].totalivas))) {
	        ivaLinea = parseFloat(datos[i].totalivas);
	      } else {
	        ivaLinea = round(base * iva / 100, 2);
	      }
	      totiva = totiva + ivaLinea;
	    } else {
	      totexe = totexe + base;
	    }
	    mtotal = totsuje + totexe;
	  }
	
	  totalm = round(totsuje + totexe + totiva, 2);
	
	  return {
	    subtotal: round(mtotal, 2),
	    descuento: descu,
	    exento: round(totexe, 2),
	    sujeto: round(totsuje, 2),
	    iva: iva,
	    totaliva: round(totiva, 2),
	    total: totalm
	  };
	};
	
	var calculadora = exports.calculadora = function calculadora(num1, num2, operador) {
	  var resultado = 0.0;
	  if (operador === "+") {
	    resultado = num1 + num2;
	  }
	  if (operador === "-") {
	    resultado = num1 - num2;
	  }
	  if (operador === "*") {
	    resultado = num1 * num2;
	  }
	  if (operador === "/") {
	    resultado = num1 / num2;
	  }
	
	  return resultado;
	};
	
	var regla3 = exports.regla3 = function regla3(num1, num2) {
	  var resultado = num1 * num2 / 100 + num1;
	
	  return resultado;
	};
	
	var onCambioMoneda = exports.onCambioMoneda = function onCambioMoneda(_ref) {
	  var moneda = _ref.moneda,
	      productos = _ref.productos,
	      monedaPre = _ref.monedaPre,
	      monedaSub = _ref.monedaSub;
	
	  var data = [].concat(_toConsumableArray(productos));
	  var valormoneda = 1.0;
	  var monedacambio = void 0;
	
	  if (moneda.idmoneda === monedaSub.idmoneda) {
	    monedacambio = {
	      idmoneda: moneda.idmoneda,
	      descripcion: moneda.descripcion,
	      simbolo: moneda.simbolo,
	      predeterminada: moneda.predeterminada,
	      subpredeterminada: moneda.subpredeterminada,
	      valormoneda: 1.0
	    };
	  } else if (moneda.idmoneda === monedaPre.idmoneda) {
	    valormoneda = monedaSub.valormoneda;
	    monedacambio = {
	      idmoneda: moneda.idmoneda,
	      descripcion: moneda.descripcion,
	      simbolo: moneda.simbolo,
	      predeterminada: moneda.predeterminada,
	      subpredeterminada: moneda.subpredeterminada,
	      valormoneda: monedaSub.valormoneda
	    };
	  } else {
	    valormoneda = round(monedaSub.valormoneda / moneda.valormoneda);
	    monedacambio = {
	      idmoneda: moneda.idmoneda,
	      descripcion: moneda.descripcion,
	      simbolo: moneda.simbolo,
	      predeterminada: moneda.predeterminada,
	      subpredeterminada: moneda.subpredeterminada,
	      valormoneda: valormoneda
	    };
	  }
	
	  for (var i = 0; i < productos.length; i++) {
	    data[i].valormoneda = valormoneda;
	  }
	
	  return {
	    data: data,
	    monedacambio: monedacambio
	  };
	};
	
	var onCambioUnidad = exports.onCambioUnidad = function onCambioUnidad(_ref2) {
	  var idunidad = _ref2.idunidad,
	      index = _ref2.index,
	      productos = _ref2.productos;
	
	  var data = [].concat(_toConsumableArray(productos));
	  var precio = 0.0;
	  var montoiva = 0.0;
	  var tipounidad = 0;
	  var cantie = data[index].cantidadEA;
	  var totales = void 0;
	  var msm = {
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  };
	
	  if (parseInt(idunidad) === parseInt(data[index].idunidadalterna)) {
	    tipounidad = 1;
	    cantie = parseFloat(data[index].cantidadEA);
	    cantie = Math.trunc(cantie);
	
	    if (parseInt(data[index].tipoprecio) === 1) {
	      precio = parseFloat(data[index].preciomaxialter);
	    } else if (parseInt(data[index].tipoprecio) === 2) {
	      precio = parseFloat(data[index].precioofealter);
	    } else if (parseInt(data[index].tipoprecio) === 3) {
	      precio = parseFloat(data[index].preciomayoralter);
	    } else if (parseInt(data[index].tipoprecio) === 4) {
	      precio = parseFloat(data[index].preciominialter);
	    }
	  } else if (parseInt(idunidad) === parseInt(data[index].idunidadmedida)) {
	    tipounidad = 0;
	    cantie = parseFloat(data[index].cantidadEA / data[index].valorfactor);
	    cantie = Math.trunc(cantie);
	
	    if (parseInt(data[index].tipoprecio) === 1) {
	      precio = parseFloat(data[index].preciomaxi);
	    } else if (parseInt(data[index].tipoprecio) === 2) {
	      precio = parseFloat(data[index].precioofe);
	    } else if (parseInt(data[index].tipoprecio) === 3) {
	      precio = parseFloat(data[index].preciomayor);
	    } else if (parseInt(data[index].tipoprecio) === 4) {
	      precio = parseFloat(data[index].preciomini);
	    }
	  }
	
	  montoiva = precio * parseFloat(data[index].iva) / 100;
	
	  if (parseFloat(data[index].cantidad) > cantie) {
	    data[index].cantidad = 1.0;
	    msm = {
	      mostrar: true,
	      titulo: "Notificación",
	      texto: "La  cantidad no debe ser mayor a la cantidad existente",
	      icono: "informacion"
	    };
	  }
	
	  data[index].tipounidad = tipounidad;
	  data[index].precio = precio;
	  data[index].precioconiva = round(precio + montoiva, 2);
	  data[index].unidad = data[index].unidad.reverse();
	  data[index].total = precio * data[index].cantidad;
	  data[index].montoiva = round(montoiva * data[index].cantidad, 2);
	  data[index].cantidadE = cantie;
	
	  totales = calcularTotales(data);
	
	  return {
	    data: data,
	    msm: msm,
	    totales: totales
	  };
	};
	
	var onCambioUnidadDos = exports.onCambioUnidadDos = function onCambioUnidadDos(_ref3) {
	  var idunidad = _ref3.idunidad,
	      index = _ref3.index,
	      productos = _ref3.productos;
	
	  var data = [].concat(_toConsumableArray(productos));
	  var precio = 0.0;
	  var montoiva = 0.0;
	  var tipounidad = 0;
	  var totalp = 0.0;
	  var cantie = data[index].cantidadEA;
	  var totales = void 0;
	  var msm = {
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  };
	
	  if (parseInt(idunidad) === parseInt(data[index].idunidadalterna)) {
	    tipounidad = 1;
	    cantie = parseFloat(data[index].cantidadEA);
	    cantie = Math.trunc(cantie);
	
	    if (parseInt(data[index].tipoprecio) === 1) {
	      precio = parseFloat(data[index].precio) / data[index].valorfactor;
	    }
	  } else if (parseInt(idunidad) === parseInt(data[index].idunidadmedida)) {
	    tipounidad = 0;
	    cantie = parseFloat(data[index].cantidadEA / data[index].valorfactor);
	    cantie = Math.trunc(cantie);
	
	    if (parseInt(data[index].tipoprecio) === 1) {
	      precio = parseFloat(data[index].precio * data[index].valorfactor);
	    }
	  }
	
	  montoiva = precio * parseFloat(data[index].iva) / 100;
	  montoiva = round(montoiva, 2);
	
	  if (parseFloat(data[index].cantidad) > cantie) {
	    data[index].cantidad = 1.0;
	    msm = {
	      mostrar: true,
	      titulo: "Notificación",
	      texto: "La  cantidad no debe ser mayor a la cantidad existente",
	      icono: "informacion"
	    };
	  }
	
	  data[index].tipounidad = tipounidad;
	  data[index].precio = precio;
	  data[index].unidad = data[index].unidad.reverse();
	  data[index].total = precio * data[index].cantidad;
	  data[index].montoiva = montoiva * data[index].cantidad;
	  data[index].cantidadE = cantie;
	
	  totales = calcularTotales(data);
	
	  return {
	    data: data,
	    msm: msm,
	    totales: totales
	  };
	};
	
	var onCambioUnidadTres = exports.onCambioUnidadTres = function onCambioUnidadTres(_ref4) {
	  var idunidad = _ref4.idunidad,
	      index = _ref4.index,
	      productos = _ref4.productos;
	
	  var data = [].concat(_toConsumableArray(productos));
	  var cantie = data[index].cantidad;
	  var precio = 0.0;
	  var montoiva = 0.0;
	  var tipounidad = 0;
	  var totales = void 0;
	  var msm = {
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  };
	
	  if (parseInt(idunidad) === parseInt(data[index].idunidadalterna)) {
	    tipounidad = 1;
	    precio = data[index].precio / data[index].valorfactor;
	    cantie = parseFloat(data[index].cantidad);
	    cantie = Math.trunc(cantie);
	  } else if (parseInt(idunidad) === parseInt(data[index].idunidadmedida)) {
	    tipounidad = 0;
	    precio = data[index].precio * data[index].valorfactor;
	    cantie = parseFloat(data[index].cantidad);
	    cantie = Math.trunc(cantie);
	  }
	
	  montoiva = precio * parseFloat(data[index].iva) / 100;
	  montoiva = round(montoiva, 2);
	
	  data[index].tipounidad = tipounidad;
	  data[index].precio = round(precio, 3);
	  data[index].unidad = data[index].unidad.reverse();
	  data[index].cantidad = cantie;
	  data[index].totalsiniva = round(precio * cantie, 2);
	  data[index].totalivas = round(montoiva * cantie, 2);
	  data[index].totalmonto = round(precio * cantie + montoiva * cantie, 2);
	
	  totales = calcularTotalesDos(data);
	
	  return {
	    data: data,
	    msm: msm,
	    totales: totales
	  };
	};
	
	var validarCantidad = exports.validarCantidad = function validarCantidad(_ref5) {
	  var index = _ref5.index,
	      event = _ref5.event,
	      productos = _ref5.productos,
	      _ref5$tipo = _ref5.tipo,
	      tipo = _ref5$tipo === undefined ? 2 : _ref5$tipo;
	
	  var msm = {
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  };
	  var data = [].concat(_toConsumableArray(productos));
	  var totales = void 0;
	
	  if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	    event.target.value = "1,00";
	  }
	  event.target.value = formatoMonto(event.target.value);
	  var char1 = event.target.value.substring(0, 1);
	  var char2 = event.target.value.substring(1, 2);
	  if (char1 === "0" && char2 !== ",") {
	    event.target.value = event.target.value.substring(1, event.target.value.length);
	  }
	  var canti = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	  if (tipo !== 1 && data[index].servicio !== true) {
	    if (canti > data[index].cantidadE) {
	      data[index].cantidad = 1.0;
	      canti = 1.0;
	      if (data[index].cantidadE <= 0.0) {
	        event.target.value = "0,00";
	      } else {
	        event.target.value = "1,00";
	      }
	
	      if (data[index].servicio !== true) {
	        msm = {
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "La  cantidad no debe ser mayor a la cantidad existente",
	          icono: "informacion"
	        };
	      }
	    }
	  }
	
	  data[index].cantidad = canti;
	  data[index].total = data[index].precio * canti;
	  data[index].montoiva = data[index].precio * canti * data[index].iva / 100;
	  totales = calcularTotales(data);
	
	  return {
	    data: data,
	    msm: msm,
	    totales: totales
	  };
	};
	
	var validarCantidadForPedido = exports.validarCantidadForPedido = function validarCantidadForPedido(_ref6) {
	  var index = _ref6.index,
	      event = _ref6.event,
	      productos = _ref6.productos,
	      _ref6$tipo = _ref6.tipo,
	      tipo = _ref6$tipo === undefined ? 2 : _ref6$tipo;
	
	  var msm = {
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  };
	  var data = [].concat(_toConsumableArray(productos));
	  var totales = void 0;
	
	  if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	    event.target.value = "1,00";
	  }
	  event.target.value = formatoMonto(event.target.value);
	  var char1 = event.target.value.substring(0, 1);
	  var char2 = event.target.value.substring(1, 2);
	  if (char1 === "0" && char2 !== ",") {
	    event.target.value = event.target.value.substring(1, event.target.value.length);
	  }
	  var canti = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	  var moniv = data[index].precio * data[index].iva / 100;
	  data[index].cantidad = canti;
	  data[index].total = data[index].precio * canti;
	  data[index].montoiva = round(moniv * canti, 2);
	  totales = calcularTotales(data);
	
	  return {
	    data: data,
	    msm: msm,
	    totales: totales
	  };
	};
	
	var validarCantidaDos = exports.validarCantidaDos = function validarCantidaDos(_ref7) {
	  var index = _ref7.index,
	      event = _ref7.event,
	      productos = _ref7.productos,
	      _ref7$tipo = _ref7.tipo,
	      tipo = _ref7$tipo === undefined ? 2 : _ref7$tipo;
	
	  var msm = {
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  };
	  var data = [].concat(_toConsumableArray(productos));
	  var totales = void 0;
	
	  if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	    event.target.value = "1,00";
	  }
	  event.target.value = formatoMonto(event.target.value);
	  var char1 = event.target.value.substring(0, 1);
	  var char2 = event.target.value.substring(1, 2);
	  if (char1 === "0" && char2 !== ",") {
	    event.target.value = event.target.value.substring(1, event.target.value.length);
	  }
	  var canti = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	  if (tipo !== 1) {
	    if (canti > data[index].cantidadE) {
	      data[index].cantidad = 1.0;
	      canti = 1.0;
	      if (data[index].cantidadE <= 0.0) {
	        event.target.value = "0,00";
	      } else {
	        event.target.value = "1,00";
	      }
	
	      if (data[index].servicio !== true) {
	        msm = {
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "La  cantidad no debe ser mayor a la cantidad existente",
	          icono: "informacion"
	        };
	      }
	    }
	  }
	
	  data[index].cantidad = canti;
	  data[index].totalsiniva = round(data[index].precio * canti, 2);
	  data[index].totalivas = round(data[index].precio * parseFloat(data[index].iva) * canti / 100, 2);
	  data[index].totalmonto = round(data[index].totalsiniva + data[index].totalivas, 2);
	  data[index].total = data[index].totalsiniva;
	  data[index].totaldos = round(data[index].precioconiva * canti, 2);
	  totales = calcularTotales_Dos(data);
	
	  return {
	    data: data,
	    msm: msm,
	    totales: totales
	  };
	};
	
	var validarCantidaddos = exports.validarCantidaddos = function validarCantidaddos(_ref8) {
	  var index = _ref8.index,
	      event = _ref8.event,
	      vacios = _ref8.vacios,
	      _ref8$tipo = _ref8.tipo,
	      tipo = _ref8$tipo === undefined ? 2 : _ref8$tipo;
	
	  var msm = {
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  };
	  var data = [].concat(_toConsumableArray(vacios));
	  var totales = void 0;
	
	  if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	    event.target.value = "0,00";
	  }
	  event.target.value = formatoMonto(event.target.value);
	  var char1 = event.target.value.substring(0, 1);
	  var char2 = event.target.value.substring(1, 2);
	  if (char1 === "0" && char2 !== ",") {
	    event.target.value = event.target.value.substring(1, event.target.value.length);
	  }
	  var canti = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	  if (tipo !== 1) {
	    if (canti > data[index].cantidadE) {
	      data[index].cantidad = 1.0;
	      canti = 1.0;
	      if (data[index].cantidadE <= 0.0) {
	        event.target.value = "0,00";
	      } else {
	        event.target.value = "1,00";
	      }
	
	      msm = {
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La  cantidad no debe ser mayor a la cantidad existente",
	        icono: "informacion"
	      };
	    }
	  }
	
	  data[index].cantidad = canti;
	  data[index].total = data[index].precio * canti;
	  data[index].montoiva = data[index].precio * canti * data[index].iva / 100;
	  totales = calcularTotales(data);
	
	  return {
	    data: data,
	    msm: msm,
	    totales: totales
	  };
	};
	
	var validarCantidadTres = exports.validarCantidadTres = function validarCantidadTres(_ref9) {
	  var index = _ref9.index,
	      event = _ref9.event,
	      productos = _ref9.productos;
	
	  var msm = {
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  };
	  var data = [].concat(_toConsumableArray(productos));
	  var totales = void 0;
	  var montoiva = 0.0;
	  var totalivas = 0.0;
	
	  if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	    event.target.value = "1,00";
	  }
	
	  event.target.value = formatoMonto(event.target.value);
	  var char1 = event.target.value.substring(0, 1);
	  var char2 = event.target.value.substring(1, 2);
	  if (char1 === "0" && char2 !== ",") {
	    event.target.value = event.target.value.substring(1, event.target.value.length);
	  }
	  var canti = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	  montoiva = data[index].precio * parseFloat(data[index].iva) / 100;
	
	  var precio = round(data[index].precio, 2);
	
	  data[index].cantidad = canti;
	  data[index].totalsiniva = round(precio * canti, 2);
	  data[index].totalivas = round(montoiva * canti, 2);
	  data[index].totalmonto = round(data[index].totalsiniva + data[index].totalivas, 2);
	  totales = calcularTotalesDos(data);
	
	  return {
	    data: data,
	    msm: msm,
	    totales: totales
	  };
	};
	
	var validarPrecioMontos = exports.validarPrecioMontos = function validarPrecioMontos(_ref10) {
	  var index = _ref10.index,
	      event = _ref10.event,
	      productos = _ref10.productos,
	      _ref10$tipo = _ref10.tipo,
	      tipo = _ref10$tipo === undefined ? 2 : _ref10$tipo;
	
	  var msm = {
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  };
	  var data = [].concat(_toConsumableArray(productos));
	  var totales = void 0;
	  var montoiva = 0.0;
	
	  if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	    event.target.value = "1,00";
	  }
	
	  event.target.value = formatoMonto(event.target.value);
	  var char1 = event.target.value.substring(0, 1);
	  var char2 = event.target.value.substring(1, 2);
	  if (char1 === "0" && char2 !== ",") {
	    event.target.value = event.target.value.substring(1, event.target.value.length);
	  }
	  var preci = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	  montoiva = preci * parseFloat(data[index].iva) / 100;
	
	  var precio = round(preci, 2);
	
	  data[index].precio = preci;
	  data[index].totalmonto = round(precio * data[index].cantidad + montoiva * data[index].cantidad, 2);
	  data[index].totalivas = round(montoiva * data[index].cantidad, 2);
	  data[index].totalsiniva = precio * data[index].cantidad;
	  totales = calcularTotalesDos(data);
	
	  return {
	    data: data,
	    msm: msm,
	    totales: totales
	  };
	};
	
	var validarMontos = exports.validarMontos = function validarMontos(event) {
	  if (event.which === 13 || typeof event.which === "undefined") {
	    if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	      event.target.value = "1,00";
	    }
	    event.target.value = formatoMonto(event.target.value);
	    var char1 = event.target.value.substring(0, 1);
	    var char2 = event.target.value.substring(1, 2);
	    if (char1 === "0" && char2 !== ",") {
	      event.target.value = event.target.value.substring(1, event.target.value.length);
	    }
	    return event.target.value;
	  } else if (event.which === 46) {
	    return false;
	  } else if (event.which >= 48 && event.which <= 57) {
	    return true;
	  } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	    return true;
	  } else return false;
	};
	
	var tipoprecio = exports.tipoprecio = {
	  1: "MAXIMO",
	  2: "OFERTA",
	  3: "MAYOR",
	  4: "MINIMO"
	};
	
	var comboprecios = exports.comboprecios = [{ id: "1", nombre: "MAXIMO" }, { id: "2", nombre: "OFERTA" }, { id: "3", nombre: "MAYOR" }, { id: "4", nombre: "MINIMO" }];
	
	var formatBytes = exports.formatBytes = function formatBytes(bytes) {
	  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	
	  if (!+bytes) return "0 Bytes";
	
	  var k = 1024;
	  var dm = decimals < 0 ? 0 : decimals;
	  var sizes = ["Bytes", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
	
	  var i = Math.floor(Math.log(bytes) / Math.log(k));
	
	  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
	};
	
	/*
	 * Usuarios con acceso al modulo de Auditoria (Configuracion General).
	 * Se compara el login guardado en sessionStorage, igual que hace
	 * public/index.html para autorizar las herramientas del navegador.
	 */
	var USUARIOS_AUDITORIA = exports.USUARIOS_AUDITORIA = ["sistema", "gustavo"];
	
	var usuarioAuditoria = exports.usuarioAuditoria = function usuarioAuditoria() {
	  try {
	    var login = JSON.parse(sessionStorage.getItem("login") || "null");
	    if (login === null || login === undefined) {
	      return false;
	    }
	
	    return USUARIOS_AUDITORIA.indexOf(String(login).trim().toLowerCase()) >= 0;
	  } catch (error) {
	    return false;
	  }
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(92));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(435));
	
	var _canUseDOM = _interopRequireDefault(__webpack_require__(176));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(135));
	
	var _removeEventListener = _interopRequireDefault(__webpack_require__(438));
	
	var _scrollbarSize = _interopRequireDefault(__webpack_require__(258));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _Modal = _interopRequireDefault(__webpack_require__(7003));
	
	var _BootstrapModalManager = _interopRequireDefault(__webpack_require__(6973));
	
	var _Fade = _interopRequireDefault(__webpack_require__(6977));
	
	var _ModalBody = _interopRequireDefault(__webpack_require__(6989));
	
	var _ModalContext = _interopRequireDefault(__webpack_require__(647));
	
	var _ModalDialog = _interopRequireDefault(__webpack_require__(6990));
	
	var _ModalFooter = _interopRequireDefault(__webpack_require__(6991));
	
	var _ModalHeader = _interopRequireDefault(__webpack_require__(6992));
	
	var _ModalTitle = _interopRequireDefault(__webpack_require__(6993));
	
	var _ThemeProvider = __webpack_require__(48);
	
	var manager;
	var defaultProps = {
	  show: false,
	  backdrop: true,
	  keyboard: true,
	  autoFocus: true,
	  enforceFocus: true,
	  restoreFocus: true,
	  animation: true,
	  dialogAs: _ModalDialog.default
	};
	/* eslint-disable no-use-before-define, react/no-multi-comp */
	
	function DialogTransition(props) {
	  return /*#__PURE__*/_react.default.createElement(_Fade.default, props);
	}
	
	function BackdropTransition(props) {
	  return /*#__PURE__*/_react.default.createElement(_Fade.default, props);
	}
	/* eslint-enable no-use-before-define */
	
	
	var Modal = /*#__PURE__*/function (_React$Component) {
	  (0, _inheritsLoose2.default)(Modal, _React$Component);
	
	  function Modal() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	    _this.state = {
	      style: {}
	    };
	    _this.modalContext = {
	      onHide: function onHide() {
	        return _this.props.onHide();
	      }
	    };
	
	    _this.setModalRef = function (ref) {
	      _this._modal = ref;
	    };
	
	    _this.handleDialogMouseDown = function () {
	      _this._waitingForMouseUp = true;
	    };
	
	    _this.handleMouseUp = function (e) {
	      if (_this._waitingForMouseUp && e.target === _this._modal.dialog) {
	        _this._ignoreBackdropClick = true;
	      }
	
	      _this._waitingForMouseUp = false;
	    };
	
	    _this.handleClick = function (e) {
	      if (_this._ignoreBackdropClick || e.target !== e.currentTarget) {
	        _this._ignoreBackdropClick = false;
	        return;
	      }
	
	      _this.props.onHide();
	    };
	
	    _this.handleEnter = function (node) {
	      var _this$props;
	
	      if (node) {
	        node.style.display = 'block';
	
	        _this.updateDialogStyle(node);
	      }
	
	      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      if (_this.props.onEnter) (_this$props = _this.props).onEnter.apply(_this$props, [node].concat(args));
	    };
	
	    _this.handleEntering = function (node) {
	      var _this$props2;
	
	      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	        args[_key3 - 1] = arguments[_key3];
	      }
	
	      if (_this.props.onEntering) (_this$props2 = _this.props).onEntering.apply(_this$props2, [node].concat(args)); // FIXME: This should work even when animation is disabled.
	
	      (0, _addEventListener.default)(window, 'resize', _this.handleWindowResize);
	    };
	
	    _this.handleExited = function (node) {
	      var _this$props3;
	
	      if (node) node.style.display = ''; // RHL removes it sometimes
	
	      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	        args[_key4 - 1] = arguments[_key4];
	      }
	
	      if (_this.props.onExited) (_this$props3 = _this.props).onExited.apply(_this$props3, args); // FIXME: This should work even when animation is disabled.
	
	      (0, _removeEventListener.default)(window, 'resize', _this.handleWindowResize);
	    };
	
	    _this.handleWindowResize = function () {
	      _this.updateDialogStyle(_this._modal.dialog);
	    };
	
	    _this.getModalManager = function () {
	      if (_this.props.manager) {
	        return _this.props.manager;
	      }
	
	      if (!manager) {
	        manager = new _BootstrapModalManager.default();
	      }
	
	      return manager;
	    };
	
	    _this.renderBackdrop = function (props) {
	      var _this$props4 = _this.props,
	          bsPrefix = _this$props4.bsPrefix,
	          backdropClassName = _this$props4.backdropClassName,
	          animation = _this$props4.animation;
	      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
	        className: (0, _classnames.default)(bsPrefix + "-backdrop", backdropClassName, !animation && 'show')
	      }));
	    };
	
	    return _this;
	  }
	
	  var _proto = Modal.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    // Clean up the listener if we need to.
	    (0, _removeEventListener.default)(window, 'resize', this.handleWindowResize);
	  };
	
	  _proto.updateDialogStyle = function updateDialogStyle(node) {
	    if (!_canUseDOM.default) return;
	    var containerIsOverflowing = this.getModalManager().isContainerOverflowing(this._modal);
	    var modalIsOverflowing = node.scrollHeight > (0, _ownerDocument.default)(node).documentElement.clientHeight;
	    this.setState({
	      style: {
	        paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize.default)() : undefined,
	        paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize.default)() : undefined
	      }
	    });
	  };
	
	  _proto.render = function render() {
	    var _this$props5 = this.props,
	        bsPrefix = _this$props5.bsPrefix,
	        className = _this$props5.className,
	        style = _this$props5.style,
	        dialogClassName = _this$props5.dialogClassName,
	        children = _this$props5.children,
	        Dialog = _this$props5.dialogAs,
	        ariaLabelledby = _this$props5['aria-labelledby'],
	        show = _this$props5.show,
	        animation = _this$props5.animation,
	        backdrop = _this$props5.backdrop,
	        keyboard = _this$props5.keyboard,
	        onEscapeKeyDown = _this$props5.onEscapeKeyDown,
	        onShow = _this$props5.onShow,
	        onHide = _this$props5.onHide,
	        container = _this$props5.container,
	        autoFocus = _this$props5.autoFocus,
	        enforceFocus = _this$props5.enforceFocus,
	        restoreFocus = _this$props5.restoreFocus,
	        restoreFocusOptions = _this$props5.restoreFocusOptions,
	        onEntered = _this$props5.onEntered,
	        onExit = _this$props5.onExit,
	        onExiting = _this$props5.onExiting,
	        _ = _this$props5.onExited,
	        _1 = _this$props5.onEntering,
	        _6 = _this$props5.onEnter,
	        _4 = _this$props5.onEntering,
	        _2 = _this$props5.backdropClassName,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props5, ["bsPrefix", "className", "style", "dialogClassName", "children", "dialogAs", "aria-labelledby", "show", "animation", "backdrop", "keyboard", "onEscapeKeyDown", "onShow", "onHide", "container", "autoFocus", "enforceFocus", "restoreFocus", "restoreFocusOptions", "onEntered", "onExit", "onExiting", "onExited", "onEntering", "onEnter", "onEntering", "backdropClassName"]);
	    var clickHandler = backdrop === true ? this.handleClick : null;
	    var baseModalStyle = (0, _extends2.default)({}, style, {}, this.state.style); // Sets `display` always block when `animation` is false
	
	    if (!animation) baseModalStyle.display = 'block';
	    return /*#__PURE__*/_react.default.createElement(_ModalContext.default.Provider, {
	      value: this.modalContext
	    }, /*#__PURE__*/_react.default.createElement(_Modal.default, {
	      show: show,
	      backdrop: backdrop,
	      container: container,
	      keyboard: keyboard,
	      autoFocus: autoFocus,
	      enforceFocus: enforceFocus,
	      restoreFocus: restoreFocus,
	      restoreFocusOptions: restoreFocusOptions,
	      onEscapeKeyDown: onEscapeKeyDown,
	      onShow: onShow,
	      onHide: onHide,
	      onEntered: onEntered,
	      onExit: onExit,
	      onExiting: onExiting,
	      manager: this.getModalManager(),
	      ref: this.setModalRef,
	      style: baseModalStyle,
	      className: (0, _classnames.default)(className, bsPrefix),
	      containerClassName: bsPrefix + "-open",
	      transition: animation ? DialogTransition : undefined,
	      backdropTransition: animation ? BackdropTransition : undefined,
	      renderBackdrop: this.renderBackdrop,
	      onClick: clickHandler,
	      onMouseUp: this.handleMouseUp,
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onExited: this.handleExited,
	      'aria-labelledby': ariaLabelledby
	    }, /*#__PURE__*/_react.default.createElement(Dialog, (0, _extends2.default)({}, props, {
	      onMouseDown: this.handleDialogMouseDown,
	      className: dialogClassName
	    }), children)));
	  };
	
	  return Modal;
	}(_react.default.Component);
	
	Modal.defaultProps = defaultProps;
	var DecoratedModal = (0, _ThemeProvider.createBootstrapComponent)(Modal, 'modal');
	DecoratedModal.Body = _ModalBody.default;
	DecoratedModal.Header = _ModalHeader.default;
	DecoratedModal.Title = _ModalTitle.default;
	DecoratedModal.Footer = _ModalFooter.default;
	DecoratedModal.Dialog = _ModalDialog.default;
	DecoratedModal.TRANSITION_DURATION = 300;
	DecoratedModal.BACKDROP_TRANSITION_DURATION = 150;
	var _default = DecoratedModal;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var objectWithoutPropertiesLoose = __webpack_require__(36);
	function _objectWithoutProperties(e, t) {
	  if (null == e) return {};
	  var o,
	    r,
	    i = objectWithoutPropertiesLoose(e, t);
	  if (Object.getOwnPropertySymbols) {
	    var n = Object.getOwnPropertySymbols(e);
	    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
	  }
	  return i;
	}
	module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _styles = __webpack_require__(60);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(129));
	
	function withStyles(stylesOrCreator, options) {
	  return (0, _styles.withStyles)(stylesOrCreator, (0, _extends2.default)({
	    defaultTheme: _defaultTheme.default
	  }, options));
	}
	
	var _default = withStyles;
	exports.default = _default;

/***/ },
/* 18 */
/***/ function(module, exports) {

	function e(r){var o,t,f="";if("string"==typeof r||"number"==typeof r)f+=r;else if("object"==typeof r)if(Array.isArray(r))for(o=0;o<r.length;o++)r[o]&&(t=e(r[o]))&&(f&&(f+=" "),f+=t);else for(o in r)r[o]&&(f&&(f+=" "),f+=o);return f}function r(){for(var r,o,t=0,f="";t<arguments.length;)(r=arguments[t++])&&(o=e(r))&&(f&&(f+=" "),f+=o);return f}module.exports=r,module.exports.clsx=r;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.11.0
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  colors: true,
	  Accordion: true,
	  AccordionActions: true,
	  AccordionDetails: true,
	  AccordionSummary: true,
	  AppBar: true,
	  Avatar: true,
	  Backdrop: true,
	  Badge: true,
	  BottomNavigation: true,
	  BottomNavigationAction: true,
	  Box: true,
	  Breadcrumbs: true,
	  Button: true,
	  ButtonBase: true,
	  ButtonGroup: true,
	  Card: true,
	  CardActionArea: true,
	  CardActions: true,
	  CardContent: true,
	  CardHeader: true,
	  CardMedia: true,
	  Checkbox: true,
	  Chip: true,
	  CircularProgress: true,
	  ClickAwayListener: true,
	  Collapse: true,
	  Container: true,
	  CssBaseline: true,
	  Dialog: true,
	  DialogActions: true,
	  DialogContent: true,
	  DialogContentText: true,
	  DialogTitle: true,
	  Divider: true,
	  Drawer: true,
	  ExpansionPanel: true,
	  ExpansionPanelActions: true,
	  ExpansionPanelDetails: true,
	  ExpansionPanelSummary: true,
	  Fab: true,
	  Fade: true,
	  FilledInput: true,
	  FormControl: true,
	  FormControlLabel: true,
	  FormGroup: true,
	  FormHelperText: true,
	  FormLabel: true,
	  Grid: true,
	  GridList: true,
	  GridListTile: true,
	  GridListTileBar: true,
	  Grow: true,
	  Hidden: true,
	  Icon: true,
	  IconButton: true,
	  Input: true,
	  InputAdornment: true,
	  InputBase: true,
	  InputLabel: true,
	  LinearProgress: true,
	  Link: true,
	  List: true,
	  ListItem: true,
	  ListItemAvatar: true,
	  ListItemIcon: true,
	  ListItemSecondaryAction: true,
	  ListItemText: true,
	  ListSubheader: true,
	  Menu: true,
	  MenuItem: true,
	  MenuList: true,
	  MobileStepper: true,
	  Modal: true,
	  NativeSelect: true,
	  NoSsr: true,
	  OutlinedInput: true,
	  Paper: true,
	  Popover: true,
	  Popper: true,
	  Portal: true,
	  Radio: true,
	  RadioGroup: true,
	  RootRef: true,
	  Select: true,
	  Slide: true,
	  Slider: true,
	  Snackbar: true,
	  SnackbarContent: true,
	  Step: true,
	  StepButton: true,
	  StepConnector: true,
	  StepContent: true,
	  StepIcon: true,
	  StepLabel: true,
	  Stepper: true,
	  SvgIcon: true,
	  SwipeableDrawer: true,
	  Switch: true,
	  Tab: true,
	  Table: true,
	  TableBody: true,
	  TableCell: true,
	  TableContainer: true,
	  TableFooter: true,
	  TableHead: true,
	  TablePagination: true,
	  TableRow: true,
	  TableSortLabel: true,
	  Tabs: true,
	  TabScrollButton: true,
	  TextField: true,
	  TextareaAutosize: true,
	  Toolbar: true,
	  Tooltip: true,
	  Typography: true,
	  Unstable_TrapFocus: true,
	  useMediaQuery: true,
	  useScrollTrigger: true,
	  withMobileDialog: true,
	  withWidth: true,
	  Zoom: true
	};
	Object.defineProperty(exports, "Accordion", {
	  enumerable: true,
	  get: function get() {
	    return _Accordion.default;
	  }
	});
	Object.defineProperty(exports, "AccordionActions", {
	  enumerable: true,
	  get: function get() {
	    return _AccordionActions.default;
	  }
	});
	Object.defineProperty(exports, "AccordionDetails", {
	  enumerable: true,
	  get: function get() {
	    return _AccordionDetails.default;
	  }
	});
	Object.defineProperty(exports, "AccordionSummary", {
	  enumerable: true,
	  get: function get() {
	    return _AccordionSummary.default;
	  }
	});
	Object.defineProperty(exports, "AppBar", {
	  enumerable: true,
	  get: function get() {
	    return _AppBar.default;
	  }
	});
	Object.defineProperty(exports, "Avatar", {
	  enumerable: true,
	  get: function get() {
	    return _Avatar.default;
	  }
	});
	Object.defineProperty(exports, "Backdrop", {
	  enumerable: true,
	  get: function get() {
	    return _Backdrop.default;
	  }
	});
	Object.defineProperty(exports, "Badge", {
	  enumerable: true,
	  get: function get() {
	    return _Badge.default;
	  }
	});
	Object.defineProperty(exports, "BottomNavigation", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigation.default;
	  }
	});
	Object.defineProperty(exports, "BottomNavigationAction", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigationAction.default;
	  }
	});
	Object.defineProperty(exports, "Box", {
	  enumerable: true,
	  get: function get() {
	    return _Box.default;
	  }
	});
	Object.defineProperty(exports, "Breadcrumbs", {
	  enumerable: true,
	  get: function get() {
	    return _Breadcrumbs.default;
	  }
	});
	Object.defineProperty(exports, "Button", {
	  enumerable: true,
	  get: function get() {
	    return _Button.default;
	  }
	});
	Object.defineProperty(exports, "ButtonBase", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonBase.default;
	  }
	});
	Object.defineProperty(exports, "ButtonGroup", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonGroup.default;
	  }
	});
	Object.defineProperty(exports, "Card", {
	  enumerable: true,
	  get: function get() {
	    return _Card.default;
	  }
	});
	Object.defineProperty(exports, "CardActionArea", {
	  enumerable: true,
	  get: function get() {
	    return _CardActionArea.default;
	  }
	});
	Object.defineProperty(exports, "CardActions", {
	  enumerable: true,
	  get: function get() {
	    return _CardActions.default;
	  }
	});
	Object.defineProperty(exports, "CardContent", {
	  enumerable: true,
	  get: function get() {
	    return _CardContent.default;
	  }
	});
	Object.defineProperty(exports, "CardHeader", {
	  enumerable: true,
	  get: function get() {
	    return _CardHeader.default;
	  }
	});
	Object.defineProperty(exports, "CardMedia", {
	  enumerable: true,
	  get: function get() {
	    return _CardMedia.default;
	  }
	});
	Object.defineProperty(exports, "Checkbox", {
	  enumerable: true,
	  get: function get() {
	    return _Checkbox.default;
	  }
	});
	Object.defineProperty(exports, "Chip", {
	  enumerable: true,
	  get: function get() {
	    return _Chip.default;
	  }
	});
	Object.defineProperty(exports, "CircularProgress", {
	  enumerable: true,
	  get: function get() {
	    return _CircularProgress.default;
	  }
	});
	Object.defineProperty(exports, "ClickAwayListener", {
	  enumerable: true,
	  get: function get() {
	    return _ClickAwayListener.default;
	  }
	});
	Object.defineProperty(exports, "Collapse", {
	  enumerable: true,
	  get: function get() {
	    return _Collapse.default;
	  }
	});
	Object.defineProperty(exports, "Container", {
	  enumerable: true,
	  get: function get() {
	    return _Container.default;
	  }
	});
	Object.defineProperty(exports, "CssBaseline", {
	  enumerable: true,
	  get: function get() {
	    return _CssBaseline.default;
	  }
	});
	Object.defineProperty(exports, "Dialog", {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.default;
	  }
	});
	Object.defineProperty(exports, "DialogActions", {
	  enumerable: true,
	  get: function get() {
	    return _DialogActions.default;
	  }
	});
	Object.defineProperty(exports, "DialogContent", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContent.default;
	  }
	});
	Object.defineProperty(exports, "DialogContentText", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContentText.default;
	  }
	});
	Object.defineProperty(exports, "DialogTitle", {
	  enumerable: true,
	  get: function get() {
	    return _DialogTitle.default;
	  }
	});
	Object.defineProperty(exports, "Divider", {
	  enumerable: true,
	  get: function get() {
	    return _Divider.default;
	  }
	});
	Object.defineProperty(exports, "Drawer", {
	  enumerable: true,
	  get: function get() {
	    return _Drawer.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanel", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanel.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelActions", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelActions.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelDetails", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelDetails.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelSummary", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelSummary.default;
	  }
	});
	Object.defineProperty(exports, "Fab", {
	  enumerable: true,
	  get: function get() {
	    return _Fab.default;
	  }
	});
	Object.defineProperty(exports, "Fade", {
	  enumerable: true,
	  get: function get() {
	    return _Fade.default;
	  }
	});
	Object.defineProperty(exports, "FilledInput", {
	  enumerable: true,
	  get: function get() {
	    return _FilledInput.default;
	  }
	});
	Object.defineProperty(exports, "FormControl", {
	  enumerable: true,
	  get: function get() {
	    return _FormControl.default;
	  }
	});
	Object.defineProperty(exports, "FormControlLabel", {
	  enumerable: true,
	  get: function get() {
	    return _FormControlLabel.default;
	  }
	});
	Object.defineProperty(exports, "FormGroup", {
	  enumerable: true,
	  get: function get() {
	    return _FormGroup.default;
	  }
	});
	Object.defineProperty(exports, "FormHelperText", {
	  enumerable: true,
	  get: function get() {
	    return _FormHelperText.default;
	  }
	});
	Object.defineProperty(exports, "FormLabel", {
	  enumerable: true,
	  get: function get() {
	    return _FormLabel.default;
	  }
	});
	Object.defineProperty(exports, "Grid", {
	  enumerable: true,
	  get: function get() {
	    return _Grid.default;
	  }
	});
	Object.defineProperty(exports, "GridList", {
	  enumerable: true,
	  get: function get() {
	    return _GridList.default;
	  }
	});
	Object.defineProperty(exports, "GridListTile", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTile.default;
	  }
	});
	Object.defineProperty(exports, "GridListTileBar", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTileBar.default;
	  }
	});
	Object.defineProperty(exports, "Grow", {
	  enumerable: true,
	  get: function get() {
	    return _Grow.default;
	  }
	});
	Object.defineProperty(exports, "Hidden", {
	  enumerable: true,
	  get: function get() {
	    return _Hidden.default;
	  }
	});
	Object.defineProperty(exports, "Icon", {
	  enumerable: true,
	  get: function get() {
	    return _Icon.default;
	  }
	});
	Object.defineProperty(exports, "IconButton", {
	  enumerable: true,
	  get: function get() {
	    return _IconButton.default;
	  }
	});
	Object.defineProperty(exports, "Input", {
	  enumerable: true,
	  get: function get() {
	    return _Input.default;
	  }
	});
	Object.defineProperty(exports, "InputAdornment", {
	  enumerable: true,
	  get: function get() {
	    return _InputAdornment.default;
	  }
	});
	Object.defineProperty(exports, "InputBase", {
	  enumerable: true,
	  get: function get() {
	    return _InputBase.default;
	  }
	});
	Object.defineProperty(exports, "InputLabel", {
	  enumerable: true,
	  get: function get() {
	    return _InputLabel.default;
	  }
	});
	Object.defineProperty(exports, "LinearProgress", {
	  enumerable: true,
	  get: function get() {
	    return _LinearProgress.default;
	  }
	});
	Object.defineProperty(exports, "Link", {
	  enumerable: true,
	  get: function get() {
	    return _Link.default;
	  }
	});
	Object.defineProperty(exports, "List", {
	  enumerable: true,
	  get: function get() {
	    return _List.default;
	  }
	});
	Object.defineProperty(exports, "ListItem", {
	  enumerable: true,
	  get: function get() {
	    return _ListItem.default;
	  }
	});
	Object.defineProperty(exports, "ListItemAvatar", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemAvatar.default;
	  }
	});
	Object.defineProperty(exports, "ListItemIcon", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemIcon.default;
	  }
	});
	Object.defineProperty(exports, "ListItemSecondaryAction", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemSecondaryAction.default;
	  }
	});
	Object.defineProperty(exports, "ListItemText", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemText.default;
	  }
	});
	Object.defineProperty(exports, "ListSubheader", {
	  enumerable: true,
	  get: function get() {
	    return _ListSubheader.default;
	  }
	});
	Object.defineProperty(exports, "Menu", {
	  enumerable: true,
	  get: function get() {
	    return _Menu.default;
	  }
	});
	Object.defineProperty(exports, "MenuItem", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItem.default;
	  }
	});
	Object.defineProperty(exports, "MenuList", {
	  enumerable: true,
	  get: function get() {
	    return _MenuList.default;
	  }
	});
	Object.defineProperty(exports, "MobileStepper", {
	  enumerable: true,
	  get: function get() {
	    return _MobileStepper.default;
	  }
	});
	Object.defineProperty(exports, "Modal", {
	  enumerable: true,
	  get: function get() {
	    return _Modal.default;
	  }
	});
	Object.defineProperty(exports, "NativeSelect", {
	  enumerable: true,
	  get: function get() {
	    return _NativeSelect.default;
	  }
	});
	Object.defineProperty(exports, "NoSsr", {
	  enumerable: true,
	  get: function get() {
	    return _NoSsr.default;
	  }
	});
	Object.defineProperty(exports, "OutlinedInput", {
	  enumerable: true,
	  get: function get() {
	    return _OutlinedInput.default;
	  }
	});
	Object.defineProperty(exports, "Paper", {
	  enumerable: true,
	  get: function get() {
	    return _Paper.default;
	  }
	});
	Object.defineProperty(exports, "Popover", {
	  enumerable: true,
	  get: function get() {
	    return _Popover.default;
	  }
	});
	Object.defineProperty(exports, "Popper", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	Object.defineProperty(exports, "Portal", {
	  enumerable: true,
	  get: function get() {
	    return _Portal.default;
	  }
	});
	Object.defineProperty(exports, "Radio", {
	  enumerable: true,
	  get: function get() {
	    return _Radio.default;
	  }
	});
	Object.defineProperty(exports, "RadioGroup", {
	  enumerable: true,
	  get: function get() {
	    return _RadioGroup.default;
	  }
	});
	Object.defineProperty(exports, "RootRef", {
	  enumerable: true,
	  get: function get() {
	    return _RootRef.default;
	  }
	});
	Object.defineProperty(exports, "Select", {
	  enumerable: true,
	  get: function get() {
	    return _Select.default;
	  }
	});
	Object.defineProperty(exports, "Slide", {
	  enumerable: true,
	  get: function get() {
	    return _Slide.default;
	  }
	});
	Object.defineProperty(exports, "Slider", {
	  enumerable: true,
	  get: function get() {
	    return _Slider.default;
	  }
	});
	Object.defineProperty(exports, "Snackbar", {
	  enumerable: true,
	  get: function get() {
	    return _Snackbar.default;
	  }
	});
	Object.defineProperty(exports, "SnackbarContent", {
	  enumerable: true,
	  get: function get() {
	    return _SnackbarContent.default;
	  }
	});
	Object.defineProperty(exports, "Step", {
	  enumerable: true,
	  get: function get() {
	    return _Step.default;
	  }
	});
	Object.defineProperty(exports, "StepButton", {
	  enumerable: true,
	  get: function get() {
	    return _StepButton.default;
	  }
	});
	Object.defineProperty(exports, "StepConnector", {
	  enumerable: true,
	  get: function get() {
	    return _StepConnector.default;
	  }
	});
	Object.defineProperty(exports, "StepContent", {
	  enumerable: true,
	  get: function get() {
	    return _StepContent.default;
	  }
	});
	Object.defineProperty(exports, "StepIcon", {
	  enumerable: true,
	  get: function get() {
	    return _StepIcon.default;
	  }
	});
	Object.defineProperty(exports, "StepLabel", {
	  enumerable: true,
	  get: function get() {
	    return _StepLabel.default;
	  }
	});
	Object.defineProperty(exports, "Stepper", {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.default;
	  }
	});
	Object.defineProperty(exports, "SvgIcon", {
	  enumerable: true,
	  get: function get() {
	    return _SvgIcon.default;
	  }
	});
	Object.defineProperty(exports, "SwipeableDrawer", {
	  enumerable: true,
	  get: function get() {
	    return _SwipeableDrawer.default;
	  }
	});
	Object.defineProperty(exports, "Switch", {
	  enumerable: true,
	  get: function get() {
	    return _Switch.default;
	  }
	});
	Object.defineProperty(exports, "Tab", {
	  enumerable: true,
	  get: function get() {
	    return _Tab.default;
	  }
	});
	Object.defineProperty(exports, "Table", {
	  enumerable: true,
	  get: function get() {
	    return _Table.default;
	  }
	});
	Object.defineProperty(exports, "TableBody", {
	  enumerable: true,
	  get: function get() {
	    return _TableBody.default;
	  }
	});
	Object.defineProperty(exports, "TableCell", {
	  enumerable: true,
	  get: function get() {
	    return _TableCell.default;
	  }
	});
	Object.defineProperty(exports, "TableContainer", {
	  enumerable: true,
	  get: function get() {
	    return _TableContainer.default;
	  }
	});
	Object.defineProperty(exports, "TableFooter", {
	  enumerable: true,
	  get: function get() {
	    return _TableFooter.default;
	  }
	});
	Object.defineProperty(exports, "TableHead", {
	  enumerable: true,
	  get: function get() {
	    return _TableHead.default;
	  }
	});
	Object.defineProperty(exports, "TablePagination", {
	  enumerable: true,
	  get: function get() {
	    return _TablePagination.default;
	  }
	});
	Object.defineProperty(exports, "TableRow", {
	  enumerable: true,
	  get: function get() {
	    return _TableRow.default;
	  }
	});
	Object.defineProperty(exports, "TableSortLabel", {
	  enumerable: true,
	  get: function get() {
	    return _TableSortLabel.default;
	  }
	});
	Object.defineProperty(exports, "Tabs", {
	  enumerable: true,
	  get: function get() {
	    return _Tabs.default;
	  }
	});
	Object.defineProperty(exports, "TabScrollButton", {
	  enumerable: true,
	  get: function get() {
	    return _TabScrollButton.default;
	  }
	});
	Object.defineProperty(exports, "TextField", {
	  enumerable: true,
	  get: function get() {
	    return _TextField.default;
	  }
	});
	Object.defineProperty(exports, "TextareaAutosize", {
	  enumerable: true,
	  get: function get() {
	    return _TextareaAutosize.default;
	  }
	});
	Object.defineProperty(exports, "Toolbar", {
	  enumerable: true,
	  get: function get() {
	    return _Toolbar.default;
	  }
	});
	Object.defineProperty(exports, "Tooltip", {
	  enumerable: true,
	  get: function get() {
	    return _Tooltip.default;
	  }
	});
	Object.defineProperty(exports, "Typography", {
	  enumerable: true,
	  get: function get() {
	    return _Typography.default;
	  }
	});
	Object.defineProperty(exports, "Unstable_TrapFocus", {
	  enumerable: true,
	  get: function get() {
	    return _Unstable_TrapFocus.default;
	  }
	});
	Object.defineProperty(exports, "useMediaQuery", {
	  enumerable: true,
	  get: function get() {
	    return _useMediaQuery.default;
	  }
	});
	Object.defineProperty(exports, "useScrollTrigger", {
	  enumerable: true,
	  get: function get() {
	    return _useScrollTrigger.default;
	  }
	});
	Object.defineProperty(exports, "withMobileDialog", {
	  enumerable: true,
	  get: function get() {
	    return _withMobileDialog.default;
	  }
	});
	Object.defineProperty(exports, "withWidth", {
	  enumerable: true,
	  get: function get() {
	    return _withWidth.default;
	  }
	});
	Object.defineProperty(exports, "Zoom", {
	  enumerable: true,
	  get: function get() {
	    return _Zoom.default;
	  }
	});
	exports.colors = void 0;
	
	var colors = _interopRequireWildcard(__webpack_require__(1007));
	
	exports.colors = colors;
	
	var _styles = __webpack_require__(1035);
	
	Object.keys(_styles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _styles[key];
	    }
	  });
	});
	
	var _utils = __webpack_require__(397);
	
	Object.keys(_utils).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _utils[key];
	    }
	  });
	});
	
	var _Accordion = _interopRequireWildcard(__webpack_require__(799));
	
	Object.keys(_Accordion).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Accordion[key];
	    }
	  });
	});
	
	var _AccordionActions = _interopRequireWildcard(__webpack_require__(801));
	
	Object.keys(_AccordionActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _AccordionActions[key];
	    }
	  });
	});
	
	var _AccordionDetails = _interopRequireWildcard(__webpack_require__(803));
	
	Object.keys(_AccordionDetails).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _AccordionDetails[key];
	    }
	  });
	});
	
	var _AccordionSummary = _interopRequireWildcard(__webpack_require__(805));
	
	Object.keys(_AccordionSummary).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _AccordionSummary[key];
	    }
	  });
	});
	
	var _AppBar = _interopRequireWildcard(__webpack_require__(807));
	
	Object.keys(_AppBar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _AppBar[key];
	    }
	  });
	});
	
	var _Avatar = _interopRequireWildcard(__webpack_require__(809));
	
	Object.keys(_Avatar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Avatar[key];
	    }
	  });
	});
	
	var _Backdrop = _interopRequireWildcard(__webpack_require__(229));
	
	Object.keys(_Backdrop).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Backdrop[key];
	    }
	  });
	});
	
	var _Badge = _interopRequireWildcard(__webpack_require__(812));
	
	Object.keys(_Badge).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Badge[key];
	    }
	  });
	});
	
	var _BottomNavigation = _interopRequireWildcard(__webpack_require__(814));
	
	Object.keys(_BottomNavigation).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _BottomNavigation[key];
	    }
	  });
	});
	
	var _BottomNavigationAction = _interopRequireWildcard(__webpack_require__(816));
	
	Object.keys(_BottomNavigationAction).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _BottomNavigationAction[key];
	    }
	  });
	});
	
	var _Box = _interopRequireWildcard(__webpack_require__(818));
	
	Object.keys(_Box).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Box[key];
	    }
	  });
	});
	
	var _Breadcrumbs = _interopRequireWildcard(__webpack_require__(821));
	
	Object.keys(_Breadcrumbs).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Breadcrumbs[key];
	    }
	  });
	});
	
	var _Button = _interopRequireWildcard(__webpack_require__(349));
	
	Object.keys(_Button).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Button[key];
	    }
	  });
	});
	
	var _ButtonBase = _interopRequireWildcard(__webpack_require__(56));
	
	Object.keys(_ButtonBase).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ButtonBase[key];
	    }
	  });
	});
	
	var _ButtonGroup = _interopRequireWildcard(__webpack_require__(827));
	
	Object.keys(_ButtonGroup).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ButtonGroup[key];
	    }
	  });
	});
	
	var _Card = _interopRequireWildcard(__webpack_require__(829));
	
	Object.keys(_Card).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Card[key];
	    }
	  });
	});
	
	var _CardActionArea = _interopRequireWildcard(__webpack_require__(831));
	
	Object.keys(_CardActionArea).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardActionArea[key];
	    }
	  });
	});
	
	var _CardActions = _interopRequireWildcard(__webpack_require__(833));
	
	Object.keys(_CardActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardActions[key];
	    }
	  });
	});
	
	var _CardContent = _interopRequireWildcard(__webpack_require__(835));
	
	Object.keys(_CardContent).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardContent[key];
	    }
	  });
	});
	
	var _CardHeader = _interopRequireWildcard(__webpack_require__(837));
	
	Object.keys(_CardHeader).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardHeader[key];
	    }
	  });
	});
	
	var _CardMedia = _interopRequireWildcard(__webpack_require__(839));
	
	Object.keys(_CardMedia).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardMedia[key];
	    }
	  });
	});
	
	var _Checkbox = _interopRequireWildcard(__webpack_require__(841));
	
	Object.keys(_Checkbox).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Checkbox[key];
	    }
	  });
	});
	
	var _Chip = _interopRequireWildcard(__webpack_require__(843));
	
	Object.keys(_Chip).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Chip[key];
	    }
	  });
	});
	
	var _CircularProgress = _interopRequireWildcard(__webpack_require__(845));
	
	Object.keys(_CircularProgress).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CircularProgress[key];
	    }
	  });
	});
	
	var _ClickAwayListener = _interopRequireWildcard(__webpack_require__(350));
	
	Object.keys(_ClickAwayListener).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ClickAwayListener[key];
	    }
	  });
	});
	
	var _Collapse = _interopRequireWildcard(__webpack_require__(161));
	
	Object.keys(_Collapse).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Collapse[key];
	    }
	  });
	});
	
	var _Container = _interopRequireWildcard(__webpack_require__(849));
	
	Object.keys(_Container).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Container[key];
	    }
	  });
	});
	
	var _CssBaseline = _interopRequireWildcard(__webpack_require__(851));
	
	Object.keys(_CssBaseline).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CssBaseline[key];
	    }
	  });
	});
	
	var _Dialog = _interopRequireWildcard(__webpack_require__(853));
	
	Object.keys(_Dialog).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Dialog[key];
	    }
	  });
	});
	
	var _DialogActions = _interopRequireWildcard(__webpack_require__(855));
	
	Object.keys(_DialogActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogActions[key];
	    }
	  });
	});
	
	var _DialogContent = _interopRequireWildcard(__webpack_require__(857));
	
	Object.keys(_DialogContent).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogContent[key];
	    }
	  });
	});
	
	var _DialogContentText = _interopRequireWildcard(__webpack_require__(859));
	
	Object.keys(_DialogContentText).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogContentText[key];
	    }
	  });
	});
	
	var _DialogTitle = _interopRequireWildcard(__webpack_require__(861));
	
	Object.keys(_DialogTitle).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogTitle[key];
	    }
	  });
	});
	
	var _Divider = _interopRequireWildcard(__webpack_require__(863));
	
	Object.keys(_Divider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Divider[key];
	    }
	  });
	});
	
	var _Drawer = _interopRequireWildcard(__webpack_require__(864));
	
	Object.keys(_Drawer).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Drawer[key];
	    }
	  });
	});
	
	var _ExpansionPanel = _interopRequireWildcard(__webpack_require__(866));
	
	Object.keys(_ExpansionPanel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ExpansionPanel[key];
	    }
	  });
	});
	
	var _ExpansionPanelActions = _interopRequireWildcard(__webpack_require__(868));
	
	Object.keys(_ExpansionPanelActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ExpansionPanelActions[key];
	    }
	  });
	});
	
	var _ExpansionPanelDetails = _interopRequireWildcard(__webpack_require__(870));
	
	Object.keys(_ExpansionPanelDetails).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ExpansionPanelDetails[key];
	    }
	  });
	});
	
	var _ExpansionPanelSummary = _interopRequireWildcard(__webpack_require__(872));
	
	Object.keys(_ExpansionPanelSummary).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ExpansionPanelSummary[key];
	    }
	  });
	});
	
	var _Fab = _interopRequireWildcard(__webpack_require__(874));
	
	Object.keys(_Fab).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Fab[key];
	    }
	  });
	});
	
	var _Fade = _interopRequireWildcard(__webpack_require__(231));
	
	Object.keys(_Fade).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Fade[key];
	    }
	  });
	});
	
	var _FilledInput = _interopRequireWildcard(__webpack_require__(232));
	
	Object.keys(_FilledInput).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FilledInput[key];
	    }
	  });
	});
	
	var _FormControl = _interopRequireWildcard(__webpack_require__(233));
	
	Object.keys(_FormControl).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormControl[key];
	    }
	  });
	});
	
	var _FormControlLabel = _interopRequireWildcard(__webpack_require__(879));
	
	Object.keys(_FormControlLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormControlLabel[key];
	    }
	  });
	});
	
	var _FormGroup = _interopRequireWildcard(__webpack_require__(352));
	
	Object.keys(_FormGroup).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormGroup[key];
	    }
	  });
	});
	
	var _FormHelperText = _interopRequireWildcard(__webpack_require__(353));
	
	Object.keys(_FormHelperText).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormHelperText[key];
	    }
	  });
	});
	
	var _FormLabel = _interopRequireWildcard(__webpack_require__(354));
	
	Object.keys(_FormLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormLabel[key];
	    }
	  });
	});
	
	var _Grid = _interopRequireWildcard(__webpack_require__(884));
	
	Object.keys(_Grid).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Grid[key];
	    }
	  });
	});
	
	var _GridList = _interopRequireWildcard(__webpack_require__(886));
	
	Object.keys(_GridList).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _GridList[key];
	    }
	  });
	});
	
	var _GridListTile = _interopRequireWildcard(__webpack_require__(888));
	
	Object.keys(_GridListTile).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _GridListTile[key];
	    }
	  });
	});
	
	var _GridListTileBar = _interopRequireWildcard(__webpack_require__(890));
	
	Object.keys(_GridListTileBar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _GridListTileBar[key];
	    }
	  });
	});
	
	var _Grow = _interopRequireWildcard(__webpack_require__(163));
	
	Object.keys(_Grow).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Grow[key];
	    }
	  });
	});
	
	var _Hidden = _interopRequireWildcard(__webpack_require__(895));
	
	Object.keys(_Hidden).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Hidden[key];
	    }
	  });
	});
	
	var _Icon = _interopRequireWildcard(__webpack_require__(897));
	
	Object.keys(_Icon).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Icon[key];
	    }
	  });
	});
	
	var _IconButton = _interopRequireWildcard(__webpack_require__(125));
	
	Object.keys(_IconButton).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _IconButton[key];
	    }
	  });
	});
	
	var _Input = _interopRequireWildcard(__webpack_require__(164));
	
	Object.keys(_Input).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Input[key];
	    }
	  });
	});
	
	var _InputAdornment = _interopRequireWildcard(__webpack_require__(901));
	
	Object.keys(_InputAdornment).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _InputAdornment[key];
	    }
	  });
	});
	
	var _InputBase = _interopRequireWildcard(__webpack_require__(126));
	
	Object.keys(_InputBase).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _InputBase[key];
	    }
	  });
	});
	
	var _InputLabel = _interopRequireWildcard(__webpack_require__(355));
	
	Object.keys(_InputLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _InputLabel[key];
	    }
	  });
	});
	
	var _LinearProgress = _interopRequireWildcard(__webpack_require__(356));
	
	Object.keys(_LinearProgress).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _LinearProgress[key];
	    }
	  });
	});
	
	var _Link = _interopRequireWildcard(__webpack_require__(906));
	
	Object.keys(_Link).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Link[key];
	    }
	  });
	});
	
	var _List = _interopRequireWildcard(__webpack_require__(357));
	
	Object.keys(_List).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _List[key];
	    }
	  });
	});
	
	var _ListItem = _interopRequireWildcard(__webpack_require__(358));
	
	Object.keys(_ListItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListItem[key];
	    }
	  });
	});
	
	var _ListItemAvatar = _interopRequireWildcard(__webpack_require__(910));
	
	Object.keys(_ListItemAvatar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListItemAvatar[key];
	    }
	  });
	});
	
	var _ListItemIcon = _interopRequireWildcard(__webpack_require__(912));
	
	Object.keys(_ListItemIcon).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListItemIcon[key];
	    }
	  });
	});
	
	var _ListItemSecondaryAction = _interopRequireWildcard(__webpack_require__(914));
	
	Object.keys(_ListItemSecondaryAction).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListItemSecondaryAction[key];
	    }
	  });
	});
	
	var _ListItemText = _interopRequireWildcard(__webpack_require__(916));
	
	Object.keys(_ListItemText).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListItemText[key];
	    }
	  });
	});
	
	var _ListSubheader = _interopRequireWildcard(__webpack_require__(918));
	
	Object.keys(_ListSubheader).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListSubheader[key];
	    }
	  });
	});
	
	var _Menu = _interopRequireWildcard(__webpack_require__(919));
	
	Object.keys(_Menu).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Menu[key];
	    }
	  });
	});
	
	var _MenuItem = _interopRequireWildcard(__webpack_require__(360));
	
	Object.keys(_MenuItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _MenuItem[key];
	    }
	  });
	});
	
	var _MenuList = _interopRequireWildcard(__webpack_require__(361));
	
	Object.keys(_MenuList).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _MenuList[key];
	    }
	  });
	});
	
	var _MobileStepper = _interopRequireWildcard(__webpack_require__(923));
	
	Object.keys(_MobileStepper).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _MobileStepper[key];
	    }
	  });
	});
	
	var _Modal = _interopRequireWildcard(__webpack_require__(165));
	
	Object.keys(_Modal).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Modal[key];
	    }
	  });
	});
	
	var _NativeSelect = _interopRequireWildcard(__webpack_require__(926));
	
	Object.keys(_NativeSelect).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _NativeSelect[key];
	    }
	  });
	});
	
	var _NoSsr = _interopRequireWildcard(__webpack_require__(365));
	
	Object.keys(_NoSsr).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _NoSsr[key];
	    }
	  });
	});
	
	var _OutlinedInput = _interopRequireWildcard(__webpack_require__(235));
	
	Object.keys(_OutlinedInput).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _OutlinedInput[key];
	    }
	  });
	});
	
	var _Paper = _interopRequireWildcard(__webpack_require__(65));
	
	Object.keys(_Paper).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Paper[key];
	    }
	  });
	});
	
	var _Popover = _interopRequireWildcard(__webpack_require__(366));
	
	Object.keys(_Popover).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Popover[key];
	    }
	  });
	});
	
	var _Popper = _interopRequireWildcard(__webpack_require__(367));
	
	Object.keys(_Popper).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Popper[key];
	    }
	  });
	});
	
	var _Portal = _interopRequireWildcard(__webpack_require__(236));
	
	Object.keys(_Portal).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Portal[key];
	    }
	  });
	});
	
	var _Radio = _interopRequireWildcard(__webpack_require__(936));
	
	Object.keys(_Radio).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Radio[key];
	    }
	  });
	});
	
	var _RadioGroup = _interopRequireWildcard(__webpack_require__(938));
	
	Object.keys(_RadioGroup).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _RadioGroup[key];
	    }
	  });
	});
	
	var _RootRef = _interopRequireWildcard(__webpack_require__(940));
	
	Object.keys(_RootRef).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _RootRef[key];
	    }
	  });
	});
	
	var _Select = _interopRequireWildcard(__webpack_require__(237));
	
	Object.keys(_Select).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Select[key];
	    }
	  });
	});
	
	var _Slide = _interopRequireWildcard(__webpack_require__(370));
	
	Object.keys(_Slide).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Slide[key];
	    }
	  });
	});
	
	var _Slider = _interopRequireWildcard(__webpack_require__(946));
	
	Object.keys(_Slider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Slider[key];
	    }
	  });
	});
	
	var _Snackbar = _interopRequireWildcard(__webpack_require__(948));
	
	Object.keys(_Snackbar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Snackbar[key];
	    }
	  });
	});
	
	var _SnackbarContent = _interopRequireWildcard(__webpack_require__(371));
	
	Object.keys(_SnackbarContent).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SnackbarContent[key];
	    }
	  });
	});
	
	var _Step = _interopRequireWildcard(__webpack_require__(951));
	
	Object.keys(_Step).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Step[key];
	    }
	  });
	});
	
	var _StepButton = _interopRequireWildcard(__webpack_require__(953));
	
	Object.keys(_StepButton).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StepButton[key];
	    }
	  });
	});
	
	var _StepConnector = _interopRequireWildcard(__webpack_require__(372));
	
	Object.keys(_StepConnector).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StepConnector[key];
	    }
	  });
	});
	
	var _StepContent = _interopRequireWildcard(__webpack_require__(956));
	
	Object.keys(_StepContent).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StepContent[key];
	    }
	  });
	});
	
	var _StepIcon = _interopRequireWildcard(__webpack_require__(373));
	
	Object.keys(_StepIcon).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StepIcon[key];
	    }
	  });
	});
	
	var _StepLabel = _interopRequireWildcard(__webpack_require__(374));
	
	Object.keys(_StepLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StepLabel[key];
	    }
	  });
	});
	
	var _Stepper = _interopRequireWildcard(__webpack_require__(960));
	
	Object.keys(_Stepper).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Stepper[key];
	    }
	  });
	});
	
	var _SvgIcon = _interopRequireWildcard(__webpack_require__(166));
	
	Object.keys(_SvgIcon).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SvgIcon[key];
	    }
	  });
	});
	
	var _SwipeableDrawer = _interopRequireWildcard(__webpack_require__(964));
	
	Object.keys(_SwipeableDrawer).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SwipeableDrawer[key];
	    }
	  });
	});
	
	var _Switch = _interopRequireWildcard(__webpack_require__(966));
	
	Object.keys(_Switch).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Switch[key];
	    }
	  });
	});
	
	var _Tab = _interopRequireWildcard(__webpack_require__(968));
	
	Object.keys(_Tab).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Tab[key];
	    }
	  });
	});
	
	var _Table = _interopRequireWildcard(__webpack_require__(971));
	
	Object.keys(_Table).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Table[key];
	    }
	  });
	});
	
	var _TableBody = _interopRequireWildcard(__webpack_require__(973));
	
	Object.keys(_TableBody).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableBody[key];
	    }
	  });
	});
	
	var _TableCell = _interopRequireWildcard(__webpack_require__(377));
	
	Object.keys(_TableCell).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableCell[key];
	    }
	  });
	});
	
	var _TableContainer = _interopRequireWildcard(__webpack_require__(167));
	
	Object.keys(_TableContainer).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableContainer[key];
	    }
	  });
	});
	
	var _TableFooter = _interopRequireWildcard(__webpack_require__(977));
	
	Object.keys(_TableFooter).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableFooter[key];
	    }
	  });
	});
	
	var _TableHead = _interopRequireWildcard(__webpack_require__(979));
	
	Object.keys(_TableHead).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableHead[key];
	    }
	  });
	});
	
	var _TablePagination = _interopRequireWildcard(__webpack_require__(982));
	
	Object.keys(_TablePagination).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TablePagination[key];
	    }
	  });
	});
	
	var _TableRow = _interopRequireWildcard(__webpack_require__(984));
	
	Object.keys(_TableRow).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableRow[key];
	    }
	  });
	});
	
	var _TableSortLabel = _interopRequireWildcard(__webpack_require__(986));
	
	Object.keys(_TableSortLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableSortLabel[key];
	    }
	  });
	});
	
	var _Tabs = _interopRequireWildcard(__webpack_require__(990));
	
	Object.keys(_Tabs).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Tabs[key];
	    }
	  });
	});
	
	var _TabScrollButton = _interopRequireWildcard(__webpack_require__(375));
	
	Object.keys(_TabScrollButton).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TabScrollButton[key];
	    }
	  });
	});
	
	var _TextField = _interopRequireWildcard(__webpack_require__(992));
	
	Object.keys(_TextField).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TextField[key];
	    }
	  });
	});
	
	var _TextareaAutosize = _interopRequireWildcard(__webpack_require__(378));
	
	Object.keys(_TextareaAutosize).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TextareaAutosize[key];
	    }
	  });
	});
	
	var _Toolbar = _interopRequireWildcard(__webpack_require__(379));
	
	Object.keys(_Toolbar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Toolbar[key];
	    }
	  });
	});
	
	var _Tooltip = _interopRequireWildcard(__webpack_require__(996));
	
	Object.keys(_Tooltip).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Tooltip[key];
	    }
	  });
	});
	
	var _Typography = _interopRequireWildcard(__webpack_require__(66));
	
	Object.keys(_Typography).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Typography[key];
	    }
	  });
	});
	
	var _Unstable_TrapFocus = _interopRequireWildcard(__webpack_require__(380));
	
	Object.keys(_Unstable_TrapFocus).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Unstable_TrapFocus[key];
	    }
	  });
	});
	
	var _useMediaQuery = _interopRequireWildcard(__webpack_require__(395));
	
	Object.keys(_useMediaQuery).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _useMediaQuery[key];
	    }
	  });
	});
	
	var _useScrollTrigger = _interopRequireWildcard(__webpack_require__(1042));
	
	Object.keys(_useScrollTrigger).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _useScrollTrigger[key];
	    }
	  });
	});
	
	var _withMobileDialog = _interopRequireWildcard(__webpack_require__(1046));
	
	Object.keys(_withMobileDialog).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withMobileDialog[key];
	    }
	  });
	});
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(240));
	
	Object.keys(_withWidth).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withWidth[key];
	    }
	  });
	});
	
	var _Zoom = _interopRequireWildcard(__webpack_require__(1000));
	
	Object.keys(_Zoom).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Zoom[key];
	    }
	  });
	});

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = useTable;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(19);
	
	var _TableContainer = __webpack_require__(167);
	
	var _TableContainer2 = _interopRequireDefault(_TableContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useStyles = (0, _core.makeStyles)(function (theme) {
	  return {
	    table: {
	      marginTop: theme.spacing(3),
	      "& thead th": {
	        fontWeight: "600",
	        color: theme.palette.primary.main
	        /*    backgroundColor: theme.palette.primary.light, */
	      },
	      "& tbody td": {
	        fontWeight: "300"
	      },
	      "& tbody tr:hover": {
	        backgroundColor: "#fffbf2",
	        cursor: "pointer"
	      }
	    },
	    root: {
	      width: "100%"
	    },
	    container: {
	      maxHeight: 440
	    }
	  };
	});
	
	function useTable(records, headCells, filterFn) {
	  var classes = useStyles();
	
	  var pages = [5, 10, 25, records.length];
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      page = _useState2[0],
	      setPage = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(pages[page]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      rowsPerPage = _useState4[0],
	      setRowsPerPage = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(),
	      _useState6 = _slicedToArray(_useState5, 2),
	      order = _useState6[0],
	      setOrder = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(),
	      _useState8 = _slicedToArray(_useState7, 2),
	      orderBy = _useState8[0],
	      setOrderBy = _useState8[1];
	
	  var TblContainer = function TblContainer(props) {
	    return _react2.default.createElement(
	      _TableContainer2.default,
	      { className: classes.container },
	      _react2.default.createElement(
	        _core.Table
	        /* className={classes.table} */,
	        { className: "table table-striped table-hover table-sm border-table"
	        },
	        props.children
	      )
	    );
	  };
	
	  var TblHead = function TblHead(props) {
	    var handleSortRequest = function handleSortRequest(cellId) {
	      var isAsc = orderBy === cellId && order === "asc";
	      setOrder(isAsc ? "desc" : "asc");
	      setOrderBy(cellId);
	    };
	
	    return _react2.default.createElement(
	      _core.TableHead,
	      null,
	      _react2.default.createElement(
	        _core.TableRow,
	        null,
	        headCells.map(function (headCell, index) {
	          return _react2.default.createElement(
	            _core.TableCell,
	            {
	              key: index,
	              style: {
	                fontFamily: headCell.fontFamily,
	                textAlign: headCell.textAlign,
	                fontWeight: headCell.fontWeight,
	                backgroundColor: "rgba(5, 81, 130, 1)",
	                color: "#FFFFFF",
	                fontSize: headCell.fontSize,
	                padding: headCell.padding,
	                margin: headCell.margin
	              },
	              sortDirection: orderBy === index ? order : false
	            },
	            headCell.label
	          );
	        })
	      )
	    );
	  };
	
	  var handleChangePage = function handleChangePage(event, newPage) {
	    setPage(newPage);
	  };
	
	  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
	    setRowsPerPage(parseInt(event.target.value, 10));
	    setPage(0);
	  };
	
	  var TblPagination = function TblPagination() {
	    return _react2.default.createElement(_core.TablePagination, {
	      component: "div",
	      page: page,
	      rowsPerPageOptions: pages,
	      rowsPerPage: rowsPerPage,
	      labelRowsPerPage: "Filas",
	      count: records.length,
	      onChangePage: handleChangePage,
	      onChangeRowsPerPage: handleChangeRowsPerPage
	    });
	  };
	
	  function stableSort(array, comparator) {
	    var stabilizedThis = array.map(function (el, index) {
	      return [el, index];
	    });
	    stabilizedThis.sort(function (a, b) {
	      var order = comparator(a[0], b[0]);
	      if (order !== 0) return order;
	      return a[1] - b[1];
	    });
	    return stabilizedThis.map(function (el) {
	      return el[0];
	    });
	  }
	
	  function getComparator(order, orderBy) {
	    return order === "desc" ? function (a, b) {
	      return descendingComparator(a, b, orderBy);
	    } : function (a, b) {
	      return -descendingComparator(a, b, orderBy);
	    };
	  }
	
	  function descendingComparator(a, b, orderBy) {
	    if (b[orderBy] < a[orderBy]) {
	      return -1;
	    }
	    if (b[orderBy] > a[orderBy]) {
	      return 1;
	    }
	    return 0;
	  }
	
	  var recordsAfterPagingAndSorting = function recordsAfterPagingAndSorting() {
	    return stableSort(filterFn.fn(records), getComparator(order, orderBy)).slice(page * rowsPerPage, (page + 1) * rowsPerPage);
	  };
	
	  (0, _react.useEffect)(function () {
	    setPage(0);
	  }, [filterFn]);
	
	  return {
	    TblContainer: TblContainer,
	    TblHead: TblHead,
	    TblPagination: TblPagination,
	    recordsAfterPagingAndSorting: recordsAfterPagingAndSorting
	  };
	}

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var toPropertyKey = __webpack_require__(347);
	function _defineProperty(e, r, t) {
	  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
	    value: t,
	    enumerable: !0,
	    configurable: !0,
	    writable: !0
	  }) : e[r] = t, e;
	}
	module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.11.3
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "chainPropTypes", {
	  enumerable: true,
	  get: function get() {
	    return _chainPropTypes.default;
	  }
	});
	Object.defineProperty(exports, "deepmerge", {
	  enumerable: true,
	  get: function get() {
	    return _deepmerge.default;
	  }
	});
	Object.defineProperty(exports, "elementAcceptingRef", {
	  enumerable: true,
	  get: function get() {
	    return _elementAcceptingRef.default;
	  }
	});
	Object.defineProperty(exports, "elementTypeAcceptingRef", {
	  enumerable: true,
	  get: function get() {
	    return _elementTypeAcceptingRef.default;
	  }
	});
	Object.defineProperty(exports, "exactProp", {
	  enumerable: true,
	  get: function get() {
	    return _exactProp.default;
	  }
	});
	Object.defineProperty(exports, "formatMuiErrorMessage", {
	  enumerable: true,
	  get: function get() {
	    return _formatMuiErrorMessage.default;
	  }
	});
	Object.defineProperty(exports, "getDisplayName", {
	  enumerable: true,
	  get: function get() {
	    return _getDisplayName.default;
	  }
	});
	Object.defineProperty(exports, "HTMLElementType", {
	  enumerable: true,
	  get: function get() {
	    return _HTMLElementType.default;
	  }
	});
	Object.defineProperty(exports, "ponyfillGlobal", {
	  enumerable: true,
	  get: function get() {
	    return _ponyfillGlobal.default;
	  }
	});
	Object.defineProperty(exports, "refType", {
	  enumerable: true,
	  get: function get() {
	    return _refType.default;
	  }
	});
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(245));
	
	var _deepmerge = _interopRequireDefault(__webpack_require__(6630));
	
	var _elementAcceptingRef = _interopRequireDefault(__webpack_require__(6631));
	
	var _elementTypeAcceptingRef = _interopRequireDefault(__webpack_require__(6632));
	
	var _exactProp = _interopRequireDefault(__webpack_require__(6633));
	
	var _formatMuiErrorMessage = _interopRequireDefault(__webpack_require__(6634));
	
	var _getDisplayName = _interopRequireDefault(__webpack_require__(6635));
	
	var _HTMLElementType = _interopRequireDefault(__webpack_require__(6629));
	
	var _ponyfillGlobal = _interopRequireDefault(__webpack_require__(6638));
	
	var _refType = _interopRequireDefault(__webpack_require__(6639));

/***/ },
/* 23 */
/***/ function(module, exports) {

	function _classCallCheck(a, n) {
	  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
	}
	module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var toPropertyKey = __webpack_require__(347);
	function _defineProperties(e, r) {
	  for (var t = 0; t < r.length; t++) {
	    var o = r[t];
	    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
	  }
	}
	function _createClass(e, r, t) {
	  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
	    writable: !1
	  }), e;
	}
	module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 25 */
/***/ function(module, exports) {

	function _assertThisInitialized(e) {
	  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  return e;
	}
	module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 26 */
/***/ function(module, exports) {

	function _getPrototypeOf(t) {
	  return module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
	    return t.__proto__ || Object.getPrototypeOf(t);
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _getPrototypeOf(t);
	}
	module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(345);
	function _inherits(t, e) {
	  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
	  t.prototype = Object.create(e && e.prototype, {
	    constructor: {
	      value: t,
	      writable: !0,
	      configurable: !0
	    }
	  }), Object.defineProperty(t, "prototype", {
	    writable: !1
	  }), e && setPrototypeOf(t, e);
	}
	module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(55)["default"];
	var assertThisInitialized = __webpack_require__(25);
	function _possibleConstructorReturn(t, e) {
	  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
	  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
	  return assertThisInitialized(t);
	}
	module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = useTableScroll;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(19);
	
	var _TableContainer = __webpack_require__(167);
	
	var _TableContainer2 = _interopRequireDefault(_TableContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useTableScroll(headCells, opciones) {
	  // El segundo argumento tambien se usa historicamente para pasar un filtro.
	  // Solo se interpreta como opciones cuando es un objeto.
	  var config = opciones && (typeof opciones === "undefined" ? "undefined" : _typeof(opciones)) === "object" ? opciones : {};
	  var stickyHeader = config.stickyHeader !== false;
	
	  var TblContainer = function TblContainer(props) {
	    return _react2.default.createElement(
	      "div",
	      {
	        className: "table-sm border-table p-0 fixed rounded",
	        style: props.container
	      },
	      _react2.default.createElement(
	        "table",
	        { className: "table table-striped table-hover table-sm" },
	        props.children
	      )
	    );
	  };
	
	  var TblHead = function TblHead() {
	    return _react2.default.createElement(
	      "thead",
	      { style: { border: "none" } },
	      _react2.default.createElement(
	        "tr",
	        { style: { border: "none" } },
	        headCells.map(function (item, index) {
	          return _react2.default.createElement(
	            "th",
	            {
	              key: index,
	              className: "letra-tabla-th",
	              style: Object.assign({
	                backgroundColor: "rgba(5, 81, 130, 1)",
	                fontWeight: "bold",
	                width: item.width,
	                textAlign: item.textAlign,
	                fontSizeAdjust: '0.7',
	                zIndex: stickyHeader ? 999 : 'auto'
	              }, stickyHeader ? {} : {
	                position: 'static',
	                top: 'auto',
	                left: 'auto'
	              }, item.style || {})
	            },
	            item.label
	          );
	        })
	      )
	    );
	  };
	
	  return {
	    TblContainer: TblContainer,
	    TblHead: TblHead
	  };
	}

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var baseInvoke = __webpack_require__(6774),
	    baseRest = __webpack_require__(86);
	
	/**
	 * Invokes the method at `path` of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the method to invoke.
	 * @param {...*} [args] The arguments to invoke the method with.
	 * @returns {*} Returns the result of the invoked method.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	 *
	 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	 * // => [2, 3]
	 */
	var invoke = baseRest(baseInvoke);
	
	module.exports = invoke;


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalize;
	
	var _utils = __webpack_require__(22);
	
	// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
	//
	// A strict capitalization should uppercase the first letter of each word a the sentence.
	// We only handle the first word.
	function capitalize(string) {
	  if (typeof string !== 'string') {
	    throw new Error( false ? "Material-UI: capitalize(string) expects a string argument." : (0, _utils.formatMuiErrorMessage)(7));
	  }
	
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable = __webpack_require__(20);
	
	var _useTable2 = _interopRequireDefault(_useTable);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoCliente = function CatalogoCliente(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtCliente = (0, _react.useRef)([]);
	  var txtBuscar = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      listaClientes = _useState6[0],
	      setListaClientes = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      clientesTodos = _useState8[0],
	      setClientesTodos = _useState8[1];
	
	  var values = {
	    idagente: "",
	    rif: "",
	    nombre: "",
	    reprelegal: "",
	    tipoper: "",
	    idalmacen: "",
	    limitecredito: "",
	    montocredito: ""
	  };
	
	  var headCells = [{ label: "CODIGO", textAlign: "center" }, { label: "RIF", textAlign: "center" }, { label: "NOMBRE", textAlign: "center" }, { label: "CEDULA", textAlign: "center" }];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	    var lista = [];
	
	    if (target.value === "") {
	      lista = clientesTodos;
	    } else {
	      lista = clientesTodos.filter(function (x) {
	        if (x.idagente.includes(target.value) || x.rif.includes(target.value) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.reprelegal !== null && x.reprelegal.toLowerCase().includes(target.value.toLowerCase())) {
	          return x;
	        }
	      });
	    }
	
	    setListaClientes(lista);
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "";
	    var nomtab = "";
	    var nomid = "";
	    var condi = "";
	    var orden = "";
	    var endpoint = "";
	    if (props.nomid !== 'vacio') {
	      campos = "idagente, municipio, ciudad, trim(nombre) as nombre, trim(direccion) as direccion, rif, reprelegal, tipoper, idalmacen, celular, limitecredito, montocredito";
	      nomtab = "agente";
	      nomid = props.nomid;
	      orden = "idagente desc";
	      endpoint = op.conexion + "/api/consulta/modeliorder?campos=" + campos + "&id=true&nomtab=" + nomtab + "&nomid=" + nomid + "&orden=" + orden;
	    } else {
	      campos = "idagente, municipio, ciudad, trim(nombre) as nombre, trim(direccion) as direccion, rif, reprelegal, tipoper, idalmacen, celular";
	      nomtab = "agente";
	      condi = 'vendedor = false';
	      orden = "idagente";
	      endpoint = op.conexion + "/api/consulta/selecionarregistrocondi?campos=" + campos + "&nomtab=" + nomtab + "&condi=" + condi + "&orden=" + orden;
	    }
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setListaClientes(response.data);
	          setClientesTodos(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setListaClientes([]);
	    setClientesTodos([]);
	    values = {
	      idagente: "",
	      rif: "",
	      nombre: "",
	      reprelegal: "",
	      tipoper: "",
	      rifs: "",
	      municipio: "",
	      ciudad: "",
	      repre: "",
	      direccion: "",
	      idalmacen: "",
	      celular: "",
	      limitecredito: "",
	      montocredito: ""
	    };
	  };
	
	  var seleccionarFila = function seleccionarFila(item, index) {
	    values = {
	      idagente: item.idagente,
	      rif: item.rif,
	      nombre: item.nombre,
	      reprelegal: item.reprelegal !== null ? item.reprelegal : 'N/S',
	      tipoper: item.tipoper,
	      rifs: item.rif.substring(1, 11),
	      municipio: item.municipio,
	      ciudad: item.ciudad,
	      repre: item.reprelegal !== null ? item.reprelegal.substring(1, 9) : 'N/S',
	      direccion: item.direccion,
	      idalmacen: item.idalmacen,
	      celular: item.celular,
	      limitecredito: item.limitecredito,
	      montocredito: item.montocredito
	    };
	
	    for (var i = 0; i < txtCliente.current.length; i++) {
	      if (i === index) {
	        txtCliente.current[i].style.backgroundColor = "lightskyblue";
	      } else {
	        if (txtCliente.current[i]) {
	          txtCliente.current[i].style.backgroundColor = "white";
	        }
	      }
	    }
	
	    btnAcepta.current.focus();
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var seleccionarCliente = function seleccionarCliente() {
	    props.onHideAceptaCatalogo(values);
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        seleccionarRegistros();
	        txtBuscar.current.focus();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Seleccionar ",
	          props.nomid
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-6 input-group-sm mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control text-uppercase",
	              ref: txtBuscar
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          {
	            container: {
	              height: 200,
	              width: "100%",
	              overflow: "auto",
	              padding: "2px",
	              fontSizeAdjust: "0.6"
	            }
	          },
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            listaClientes && listaClientes.map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  ref: function ref(el) {
	                    return txtCliente.current[index] = el;
	                  },
	                  style: { backgroundColor: "white" },
	                  onClick: function onClick() {
	                    return seleccionarFila(item, index);
	                  }
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.idagente
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.rif
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.nombre
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.reprelegal !== null ? item.reprelegal : 'N/S'
	                )
	              );
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          style: { margin: "5px" },
	          onClick: seleccionarCliente
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoCliente;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory();
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define([], factory);
		}
		else {
			// Global (browser)
			root.CryptoJS = factory();
		}
	}(this, function () {
	
		/*globals window, global, require*/
	
		/**
		 * CryptoJS core components.
		 */
		var CryptoJS = CryptoJS || (function (Math, undefined) {
	
		    var crypto;
	
		    // Native crypto from window (Browser)
		    if (typeof window !== 'undefined' && window.crypto) {
		        crypto = window.crypto;
		    }
	
		    // Native (experimental IE 11) crypto from window (Browser)
		    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
		        crypto = window.msCrypto;
		    }
	
		    // Native crypto from global (NodeJS)
		    if (!crypto && typeof global !== 'undefined' && global.crypto) {
		        crypto = global.crypto;
		    }
	
		    // Native crypto import via require (NodeJS)
		    if (!crypto && "function" === 'function') {
		        try {
		            crypto = __webpack_require__(6682);
		        } catch (err) {}
		    }
	
		    /*
		     * Cryptographically secure pseudorandom number generator
		     *
		     * As Math.random() is cryptographically not safe to use
		     */
		    var cryptoSecureRandomInt = function () {
		        if (crypto) {
		            // Use getRandomValues method (Browser)
		            if (typeof crypto.getRandomValues === 'function') {
		                try {
		                    return crypto.getRandomValues(new Uint32Array(1))[0];
		                } catch (err) {}
		            }
	
		            // Use randomBytes method (NodeJS)
		            if (typeof crypto.randomBytes === 'function') {
		                try {
		                    return crypto.randomBytes(4).readInt32LE();
		                } catch (err) {}
		            }
		        }
	
		        throw new Error('Native crypto module could not be used to get secure random number.');
		    };
	
		    /*
		     * Local polyfill of Object.create
	
		     */
		    var create = Object.create || (function () {
		        function F() {}
	
		        return function (obj) {
		            var subtype;
	
		            F.prototype = obj;
	
		            subtype = new F();
	
		            F.prototype = null;
	
		            return subtype;
		        };
		    }())
	
		    /**
		     * CryptoJS namespace.
		     */
		    var C = {};
	
		    /**
		     * Library namespace.
		     */
		    var C_lib = C.lib = {};
	
		    /**
		     * Base object for prototypal inheritance.
		     */
		    var Base = C_lib.Base = (function () {
	
	
		        return {
		            /**
		             * Creates a new object that inherits from this object.
		             *
		             * @param {Object} overrides Properties to copy into the new object.
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         field: 'value',
		             *
		             *         method: function () {
		             *         }
		             *     });
		             */
		            extend: function (overrides) {
		                // Spawn
		                var subtype = create(this);
	
		                // Augment
		                if (overrides) {
		                    subtype.mixIn(overrides);
		                }
	
		                // Create default initializer
		                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
		                    subtype.init = function () {
		                        subtype.$super.init.apply(this, arguments);
		                    };
		                }
	
		                // Initializer's prototype is the subtype object
		                subtype.init.prototype = subtype;
	
		                // Reference supertype
		                subtype.$super = this;
	
		                return subtype;
		            },
	
		            /**
		             * Extends this object and runs the init method.
		             * Arguments to create() will be passed to init().
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var instance = MyType.create();
		             */
		            create: function () {
		                var instance = this.extend();
		                instance.init.apply(instance, arguments);
	
		                return instance;
		            },
	
		            /**
		             * Initializes a newly created object.
		             * Override this method to add some logic when your objects are created.
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         init: function () {
		             *             // ...
		             *         }
		             *     });
		             */
		            init: function () {
		            },
	
		            /**
		             * Copies properties into this object.
		             *
		             * @param {Object} properties The properties to mix in.
		             *
		             * @example
		             *
		             *     MyType.mixIn({
		             *         field: 'value'
		             *     });
		             */
		            mixIn: function (properties) {
		                for (var propertyName in properties) {
		                    if (properties.hasOwnProperty(propertyName)) {
		                        this[propertyName] = properties[propertyName];
		                    }
		                }
	
		                // IE won't copy toString using the loop above
		                if (properties.hasOwnProperty('toString')) {
		                    this.toString = properties.toString;
		                }
		            },
	
		            /**
		             * Creates a copy of this object.
		             *
		             * @return {Object} The clone.
		             *
		             * @example
		             *
		             *     var clone = instance.clone();
		             */
		            clone: function () {
		                return this.init.prototype.extend(this);
		            }
		        };
		    }());
	
		    /**
		     * An array of 32-bit words.
		     *
		     * @property {Array} words The array of 32-bit words.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */
		    var WordArray = C_lib.WordArray = Base.extend({
		        /**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of 32-bit words.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.create();
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
		         */
		        init: function (words, sigBytes) {
		            words = this.words = words || [];
	
		            if (sigBytes != undefined) {
		                this.sigBytes = sigBytes;
		            } else {
		                this.sigBytes = words.length * 4;
		            }
		        },
	
		        /**
		         * Converts this word array to a string.
		         *
		         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
		         *
		         * @return {string} The stringified word array.
		         *
		         * @example
		         *
		         *     var string = wordArray + '';
		         *     var string = wordArray.toString();
		         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
		         */
		        toString: function (encoder) {
		            return (encoder || Hex).stringify(this);
		        },
	
		        /**
		         * Concatenates a word array to this word array.
		         *
		         * @param {WordArray} wordArray The word array to append.
		         *
		         * @return {WordArray} This word array.
		         *
		         * @example
		         *
		         *     wordArray1.concat(wordArray2);
		         */
		        concat: function (wordArray) {
		            // Shortcuts
		            var thisWords = this.words;
		            var thatWords = wordArray.words;
		            var thisSigBytes = this.sigBytes;
		            var thatSigBytes = wordArray.sigBytes;
	
		            // Clamp excess bits
		            this.clamp();
	
		            // Concat
		            if (thisSigBytes % 4) {
		                // Copy one byte at a time
		                for (var i = 0; i < thatSigBytes; i++) {
		                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
		                }
		            } else {
		                // Copy one word at a time
		                for (var i = 0; i < thatSigBytes; i += 4) {
		                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
		                }
		            }
		            this.sigBytes += thatSigBytes;
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Removes insignificant bits.
		         *
		         * @example
		         *
		         *     wordArray.clamp();
		         */
		        clamp: function () {
		            // Shortcuts
		            var words = this.words;
		            var sigBytes = this.sigBytes;
	
		            // Clamp
		            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
		            words.length = Math.ceil(sigBytes / 4);
		        },
	
		        /**
		         * Creates a copy of this word array.
		         *
		         * @return {WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = wordArray.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone.words = this.words.slice(0);
	
		            return clone;
		        },
	
		        /**
		         * Creates a word array filled with random bytes.
		         *
		         * @param {number} nBytes The number of random bytes to generate.
		         *
		         * @return {WordArray} The random word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.random(16);
		         */
		        random: function (nBytes) {
		            var words = [];
	
		            for (var i = 0; i < nBytes; i += 4) {
		                words.push(cryptoSecureRandomInt());
		            }
	
		            return new WordArray.init(words, nBytes);
		        }
		    });
	
		    /**
		     * Encoder namespace.
		     */
		    var C_enc = C.enc = {};
	
		    /**
		     * Hex encoding strategy.
		     */
		    var Hex = C_enc.Hex = {
		        /**
		         * Converts a word array to a hex string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The hex string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var hexChars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                hexChars.push((bite >>> 4).toString(16));
		                hexChars.push((bite & 0x0f).toString(16));
		            }
	
		            return hexChars.join('');
		        },
	
		        /**
		         * Converts a hex string to a word array.
		         *
		         * @param {string} hexStr The hex string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
		         */
		        parse: function (hexStr) {
		            // Shortcut
		            var hexStrLength = hexStr.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < hexStrLength; i += 2) {
		                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
		            }
	
		            return new WordArray.init(words, hexStrLength / 2);
		        }
		    };
	
		    /**
		     * Latin1 encoding strategy.
		     */
		    var Latin1 = C_enc.Latin1 = {
		        /**
		         * Converts a word array to a Latin1 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Latin1 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var latin1Chars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                latin1Chars.push(String.fromCharCode(bite));
		            }
	
		            return latin1Chars.join('');
		        },
	
		        /**
		         * Converts a Latin1 string to a word array.
		         *
		         * @param {string} latin1Str The Latin1 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
		         */
		        parse: function (latin1Str) {
		            // Shortcut
		            var latin1StrLength = latin1Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < latin1StrLength; i++) {
		                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
		            }
	
		            return new WordArray.init(words, latin1StrLength);
		        }
		    };
	
		    /**
		     * UTF-8 encoding strategy.
		     */
		    var Utf8 = C_enc.Utf8 = {
		        /**
		         * Converts a word array to a UTF-8 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-8 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            try {
		                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
		            } catch (e) {
		                throw new Error('Malformed UTF-8 data');
		            }
		        },
	
		        /**
		         * Converts a UTF-8 string to a word array.
		         *
		         * @param {string} utf8Str The UTF-8 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
		         */
		        parse: function (utf8Str) {
		            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
		        }
		    };
	
		    /**
		     * Abstract buffered block algorithm template.
		     *
		     * The property blockSize must be implemented in a concrete subtype.
		     *
		     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
		     */
		    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
		        /**
		         * Resets this block algorithm's data buffer to its initial state.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm.reset();
		         */
		        reset: function () {
		            // Initial values
		            this._data = new WordArray.init();
		            this._nDataBytes = 0;
		        },
	
		        /**
		         * Adds new data to this block algorithm's buffer.
		         *
		         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm._append('data');
		         *     bufferedBlockAlgorithm._append(wordArray);
		         */
		        _append: function (data) {
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof data == 'string') {
		                data = Utf8.parse(data);
		            }
	
		            // Append
		            this._data.concat(data);
		            this._nDataBytes += data.sigBytes;
		        },
	
		        /**
		         * Processes available data blocks.
		         *
		         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
		         *
		         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
		         *
		         * @return {WordArray} The processed data.
		         *
		         * @example
		         *
		         *     var processedData = bufferedBlockAlgorithm._process();
		         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
		         */
		        _process: function (doFlush) {
		            var processedWords;
	
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
		            var dataSigBytes = data.sigBytes;
		            var blockSize = this.blockSize;
		            var blockSizeBytes = blockSize * 4;
	
		            // Count blocks ready
		            var nBlocksReady = dataSigBytes / blockSizeBytes;
		            if (doFlush) {
		                // Round up to include partial blocks
		                nBlocksReady = Math.ceil(nBlocksReady);
		            } else {
		                // Round down to include only full blocks,
		                // less the number of blocks that must remain in the buffer
		                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
		            }
	
		            // Count words ready
		            var nWordsReady = nBlocksReady * blockSize;
	
		            // Count bytes ready
		            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);
	
		            // Process blocks
		            if (nWordsReady) {
		                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
		                    // Perform concrete-algorithm logic
		                    this._doProcessBlock(dataWords, offset);
		                }
	
		                // Remove processed words
		                processedWords = dataWords.splice(0, nWordsReady);
		                data.sigBytes -= nBytesReady;
		            }
	
		            // Return processed words
		            return new WordArray.init(processedWords, nBytesReady);
		        },
	
		        /**
		         * Creates a copy of this object.
		         *
		         * @return {Object} The clone.
		         *
		         * @example
		         *
		         *     var clone = bufferedBlockAlgorithm.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone._data = this._data.clone();
	
		            return clone;
		        },
	
		        _minBufferSize: 0
		    });
	
		    /**
		     * Abstract hasher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
		     */
		    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
		        /**
		         * Configuration options.
		         */
		        cfg: Base.extend(),
	
		        /**
		         * Initializes a newly created hasher.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
		         *
		         * @example
		         *
		         *     var hasher = CryptoJS.algo.SHA256.create();
		         */
		        init: function (cfg) {
		            // Apply config defaults
		            this.cfg = this.cfg.extend(cfg);
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this hasher to its initial state.
		         *
		         * @example
		         *
		         *     hasher.reset();
		         */
		        reset: function () {
		            // Reset data buffer
		            BufferedBlockAlgorithm.reset.call(this);
	
		            // Perform concrete-hasher logic
		            this._doReset();
		        },
	
		        /**
		         * Updates this hasher with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {Hasher} This hasher.
		         *
		         * @example
		         *
		         *     hasher.update('message');
		         *     hasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            // Append
		            this._append(messageUpdate);
	
		            // Update the hash
		            this._process();
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Finalizes the hash computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The hash.
		         *
		         * @example
		         *
		         *     var hash = hasher.finalize();
		         *     var hash = hasher.finalize('message');
		         *     var hash = hasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Final message update
		            if (messageUpdate) {
		                this._append(messageUpdate);
		            }
	
		            // Perform concrete-hasher logic
		            var hash = this._doFinalize();
	
		            return hash;
		        },
	
		        blockSize: 512/32,
	
		        /**
		         * Creates a shortcut function to a hasher's object interface.
		         *
		         * @param {Hasher} hasher The hasher to create a helper for.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
		         */
		        _createHelper: function (hasher) {
		            return function (message, cfg) {
		                return new hasher.init(cfg).finalize(message);
		            };
		        },
	
		        /**
		         * Creates a shortcut function to the HMAC's object interface.
		         *
		         * @param {Hasher} hasher The hasher to use in this HMAC helper.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
		         */
		        _createHmacHelper: function (hasher) {
		            return function (message, key) {
		                return new C_algo.HMAC.init(hasher, key).finalize(message);
		            };
		        }
		    });
	
		    /**
		     * Algorithm namespace.
		     */
		    var C_algo = C.algo = {};
	
		    return C;
		}(Math));
	
	
		return CryptoJS;
	
	}));
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(462),
	    baseRest = __webpack_require__(86),
	    isArrayLikeObject = __webpack_require__(149);
	
	/**
	 * Creates an array excluding all given values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.pull`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.difference, _.xor
	 * @example
	 *
	 * _.without([2, 1, 2, 3], 1, 2);
	 * // => [3]
	 */
	var without = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ },
/* 35 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 36 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(r, e) {
	  if (null == r) return {};
	  var t = {};
	  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
	    if (-1 !== e.indexOf(n)) continue;
	    t[n] = r[n];
	  }
	  return t;
	}
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(21);
	function _objectSpread(e) {
	  for (var r = 1; r < arguments.length; r++) {
	    var t = null != arguments[r] ? Object(arguments[r]) : {},
	      o = Object.keys(t);
	    "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) {
	      return Object.getOwnPropertyDescriptor(t, e).enumerable;
	    })), o.forEach(function (r) {
	      defineProperty(e, r, t[r]);
	    });
	  }
	  return e;
	}
	module.exports = _objectSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 38 */
/***/ function(module, exports) {

	/**
	 * The default argument placeholder value for methods.
	 *
	 * @type {Object}
	 */
	module.exports = {};


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(6674)
	var ieee754 = __webpack_require__(6741)
	var isArray = __webpack_require__(450)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var baseConvert = __webpack_require__(6892),
	    util = __webpack_require__(6894);
	
	/**
	 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
	 * version with conversion `options` applied. If `name` is an object its methods
	 * will be converted.
	 *
	 * @param {string} name The name of the function to wrap.
	 * @param {Function} [func] The function to wrap.
	 * @param {Object} [options] The options object. See `baseConvert` for more details.
	 * @returns {Function|Object} Returns the converted function or object.
	 */
	function convert(name, func, options) {
	  return baseConvert(util, name, func, options);
	}
	
	module.exports = convert;


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(81),
	    baseIteratee = __webpack_require__(62),
	    baseMap = __webpack_require__(466),
	    isArray = __webpack_require__(35);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useForkRef;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _setRef = _interopRequireDefault(__webpack_require__(95));
	
	function useForkRef(refA, refB) {
	  /**
	   * This will create a new function if the ref props change and are defined.
	   * This means react will call the old forkRef with `null` and the new forkRef
	   * with the ref. Cleanup naturally emerges from this behavior
	   */
	  return React.useMemo(function () {
	    if (refA == null && refB == null) {
	      return null;
	    }
	
	    return function (refValue) {
	      (0, _setRef.default)(refA, refValue);
	      (0, _setRef.default)(refB, refValue);
	    };
	  }, [refA, refB]);
	}

/***/ },
/* 43 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithHoles = __webpack_require__(341);
	var iterableToArrayLimit = __webpack_require__(792);
	var unsupportedIterableToArray = __webpack_require__(228);
	var nonIterableRest = __webpack_require__(344);
	function _slicedToArray(r, e) {
	  return arrayWithHoles(r) || iterableToArrayLimit(r, e) || unsupportedIterableToArray(r, e) || nonIterableRest();
	}
	module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(7002);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithoutHoles = __webpack_require__(791);
	var iterableToArray = __webpack_require__(343);
	var unsupportedIterableToArray = __webpack_require__(228);
	var nonIterableSpread = __webpack_require__(793);
	function _toConsumableArray(r) {
	  return arrayWithoutHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableSpread();
	}
	module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useTheme;
	
	var _styles = __webpack_require__(60);
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(129));
	
	function useTheme() {
	  var theme = (0, _styles.useTheme)() || _defaultTheme.default;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    _react.default.useDebugValue(theme);
	  }
	
	  return theme;
	}

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.useBootstrapPrefix = useBootstrapPrefix;
	exports.createBootstrapComponent = createBootstrapComponent;
	exports.default = exports.ThemeConsumer = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _forwardRef = _interopRequireDefault(__webpack_require__(6640));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var ThemeContext = _react.default.createContext({});
	
	var Consumer = ThemeContext.Consumer,
	    Provider = ThemeContext.Provider;
	exports.ThemeConsumer = Consumer;
	
	function ThemeProvider(_ref) {
	  var prefixes = _ref.prefixes,
	      children = _ref.children;
	  var copiedPrefixes = (0, _react.useMemo)(function () {
	    return (0, _extends2.default)({}, prefixes);
	  }, [prefixes]);
	  return /*#__PURE__*/_react.default.createElement(Provider, {
	    value: copiedPrefixes
	  }, children);
	}
	
	function useBootstrapPrefix(prefix, defaultPrefix) {
	  var prefixes = (0, _react.useContext)(ThemeContext);
	  return prefix || prefixes[defaultPrefix] || defaultPrefix;
	}
	
	function createBootstrapComponent(Component, opts) {
	  if (typeof opts === 'string') opts = {
	    prefix: opts
	  };
	  var isClassy = Component.prototype && Component.prototype.isReactComponent; // If it's a functional component make sure we don't break it with a ref
	
	  var _opts = opts,
	      prefix = _opts.prefix,
	      _opts$forwardRefAs = _opts.forwardRefAs,
	      forwardRefAs = _opts$forwardRefAs === void 0 ? isClassy ? 'ref' : 'innerRef' : _opts$forwardRefAs;
	  return (0, _forwardRef.default)(function (_ref2, ref) {
	    var props = (0, _extends2.default)({}, _ref2);
	    props[forwardRefAs] = ref; // eslint-disable-next-line react/prop-types
	
	    var bsPrefix = useBootstrapPrefix(props.bsPrefix, prefix);
	    return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	      bsPrefix: bsPrefix
	    }));
	  }, {
	    displayName: "Bootstrap(" + (Component.displayName || Component.name) + ")"
	  });
	}
	
	var _default = ThemeProvider;
	exports.default = _default;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hexToRgb = hexToRgb;
	exports.rgbToHex = rgbToHex;
	exports.hslToRgb = hslToRgb;
	exports.decomposeColor = decomposeColor;
	exports.recomposeColor = recomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.darken = darken;
	exports.lighten = lighten;
	
	var _utils = __webpack_require__(22);
	
	/* eslint-disable no-use-before-define */
	
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value) {
	  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	  if (false) {
	    if (value < min || value > max) {
	      console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
	    }
	  }
	
	  return Math.min(Math.max(min, value), max);
	}
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 * @returns {string} A CSS rgb color string
	 */
	
	
	function hexToRgb(color) {
	  color = color.substr(1);
	  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
	  var colors = color.match(re);
	
	  if (colors && colors[0].length === 1) {
	    colors = colors.map(function (n) {
	      return n + n;
	    });
	  }
	
	  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
	    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
	  }).join(', '), ")") : '';
	}
	
	function intToHex(int) {
	  var hex = int.toString(16);
	  return hex.length === 1 ? "0".concat(hex) : hex;
	}
	/**
	 * Converts a color from CSS rgb format to CSS hex format.
	 *
	 * @param {string} color - RGB color, i.e. rgb(n, n, n)
	 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
	 */
	
	
	function rgbToHex(color) {
	  // Idempotent
	  if (color.indexOf('#') === 0) {
	    return color;
	  }
	
	  var _decomposeColor = decomposeColor(color),
	      values = _decomposeColor.values;
	
	  return "#".concat(values.map(function (n) {
	    return intToHex(n);
	  }).join(''));
	}
	/**
	 * Converts a color from hsl format to rgb format.
	 *
	 * @param {string} color - HSL color values
	 * @returns {string} rgb color values
	 */
	
	
	function hslToRgb(color) {
	  color = decomposeColor(color);
	  var _color = color,
	      values = _color.values;
	  var h = values[0];
	  var s = values[1] / 100;
	  var l = values[2] / 100;
	  var a = s * Math.min(l, 1 - l);
	
	  var f = function f(n) {
	    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
	    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
	  };
	
	  var type = 'rgb';
	  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
	
	  if (color.type === 'hsla') {
	    type += 'a';
	    rgb.push(values[3]);
	  }
	
	  return recomposeColor({
	    type: type,
	    values: rgb
	  });
	}
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {object} - A MUI color object: {type: string, values: number[]}
	 */
	
	
	function decomposeColor(color) {
	  // Idempotent
	  if (color.type) {
	    return color;
	  }
	
	  if (color.charAt(0) === '#') {
	    return decomposeColor(hexToRgb(color));
	  }
	
	  var marker = color.indexOf('(');
	  var type = color.substring(0, marker);
	
	  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
	    throw new Error( false ? "Material-UI: Unsupported `".concat(color, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : (0, _utils.formatMuiErrorMessage)(3, color));
	  }
	
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	  return {
	    type: type,
	    values: values
	  };
	}
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	
	
	function recomposeColor(color) {
	  var type = color.type;
	  var values = color.values;
	
	  if (type.indexOf('rgb') !== -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    values = values.map(function (n, i) {
	      return i < 3 ? parseInt(n, 10) : n;
	    });
	  } else if (type.indexOf('hsl') !== -1) {
	    values[1] = "".concat(values[1], "%");
	    values[2] = "".concat(values[2], "%");
	  }
	
	  return "".concat(type, "(").concat(values.join(', '), ")");
	}
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21.
	 */
	
	
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	}
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	
	
	function getLuminance(color) {
	  color = decomposeColor(color);
	  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
	  rgb = rgb.map(function (val) {
	    val /= 255; // normalized
	
	    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	  }); // Truncate at 3 digits
	
	  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
	}
	/**
	 * Darken or lighten a color, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function emphasize(color) {
	  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function fade(color, value) {
	  color = decomposeColor(color);
	  value = clamp(value);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	
	  color.values[3] = value;
	  return recomposeColor(color);
	}
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function darken(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient);
	
	  if (color.type.indexOf('hsl') !== -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') !== -1) {
	    for (var i = 0; i < 3; i += 1) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	
	  return recomposeColor(color);
	}
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function lighten(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient);
	
	  if (color.type.indexOf('hsl') !== -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') !== -1) {
	    for (var i = 0; i < 3; i += 1) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return recomposeColor(color);
	}

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(96));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./evpkdf"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Cipher core components.
		 */
		CryptoJS.lib.Cipher || (function (undefined) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var WordArray = C_lib.WordArray;
		    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
		    var C_enc = C.enc;
		    var Utf8 = C_enc.Utf8;
		    var Base64 = C_enc.Base64;
		    var C_algo = C.algo;
		    var EvpKDF = C_algo.EvpKDF;
	
		    /**
		     * Abstract base cipher template.
		     *
		     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
		     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
		     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
		     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
		     */
		    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {WordArray} iv The IV to use for this operation.
		         */
		        cfg: Base.extend(),
	
		        /**
		         * Creates this cipher in encryption mode.
		         *
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {Cipher} A cipher instance.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
		         */
		        createEncryptor: function (key, cfg) {
		            return this.create(this._ENC_XFORM_MODE, key, cfg);
		        },
	
		        /**
		         * Creates this cipher in decryption mode.
		         *
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {Cipher} A cipher instance.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
		         */
		        createDecryptor: function (key, cfg) {
		            return this.create(this._DEC_XFORM_MODE, key, cfg);
		        },
	
		        /**
		         * Initializes a newly created cipher.
		         *
		         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
		         */
		        init: function (xformMode, key, cfg) {
		            // Apply config defaults
		            this.cfg = this.cfg.extend(cfg);
	
		            // Store transform mode and key
		            this._xformMode = xformMode;
		            this._key = key;
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this cipher to its initial state.
		         *
		         * @example
		         *
		         *     cipher.reset();
		         */
		        reset: function () {
		            // Reset data buffer
		            BufferedBlockAlgorithm.reset.call(this);
	
		            // Perform concrete-cipher logic
		            this._doReset();
		        },
	
		        /**
		         * Adds data to be encrypted or decrypted.
		         *
		         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
		         *
		         * @return {WordArray} The data after processing.
		         *
		         * @example
		         *
		         *     var encrypted = cipher.process('data');
		         *     var encrypted = cipher.process(wordArray);
		         */
		        process: function (dataUpdate) {
		            // Append
		            this._append(dataUpdate);
	
		            // Process available blocks
		            return this._process();
		        },
	
		        /**
		         * Finalizes the encryption or decryption process.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
		         *
		         * @return {WordArray} The data after final processing.
		         *
		         * @example
		         *
		         *     var encrypted = cipher.finalize();
		         *     var encrypted = cipher.finalize('data');
		         *     var encrypted = cipher.finalize(wordArray);
		         */
		        finalize: function (dataUpdate) {
		            // Final data update
		            if (dataUpdate) {
		                this._append(dataUpdate);
		            }
	
		            // Perform concrete-cipher logic
		            var finalProcessedData = this._doFinalize();
	
		            return finalProcessedData;
		        },
	
		        keySize: 128/32,
	
		        ivSize: 128/32,
	
		        _ENC_XFORM_MODE: 1,
	
		        _DEC_XFORM_MODE: 2,
	
		        /**
		         * Creates shortcut functions to a cipher's object interface.
		         *
		         * @param {Cipher} cipher The cipher to create a helper for.
		         *
		         * @return {Object} An object with encrypt and decrypt shortcut functions.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
		         */
		        _createHelper: (function () {
		            function selectCipherStrategy(key) {
		                if (typeof key == 'string') {
		                    return PasswordBasedCipher;
		                } else {
		                    return SerializableCipher;
		                }
		            }
	
		            return function (cipher) {
		                return {
		                    encrypt: function (message, key, cfg) {
		                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
		                    },
	
		                    decrypt: function (ciphertext, key, cfg) {
		                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
		                    }
		                };
		            };
		        }())
		    });
	
		    /**
		     * Abstract base stream cipher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
		     */
		    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
		        _doFinalize: function () {
		            // Process partial blocks
		            var finalProcessedBlocks = this._process(!!'flush');
	
		            return finalProcessedBlocks;
		        },
	
		        blockSize: 1
		    });
	
		    /**
		     * Mode namespace.
		     */
		    var C_mode = C.mode = {};
	
		    /**
		     * Abstract base block cipher mode template.
		     */
		    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
		        /**
		         * Creates this mode for encryption.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
		         */
		        createEncryptor: function (cipher, iv) {
		            return this.Encryptor.create(cipher, iv);
		        },
	
		        /**
		         * Creates this mode for decryption.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
		         */
		        createDecryptor: function (cipher, iv) {
		            return this.Decryptor.create(cipher, iv);
		        },
	
		        /**
		         * Initializes a newly created mode.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
		         */
		        init: function (cipher, iv) {
		            this._cipher = cipher;
		            this._iv = iv;
		        }
		    });
	
		    /**
		     * Cipher Block Chaining mode.
		     */
		    var CBC = C_mode.CBC = (function () {
		        /**
		         * Abstract base CBC mode.
		         */
		        var CBC = BlockCipherMode.extend();
	
		        /**
		         * CBC encryptor.
		         */
		        CBC.Encryptor = CBC.extend({
		            /**
		             * Processes the data block at offset.
		             *
		             * @param {Array} words The data words to operate on.
		             * @param {number} offset The offset where the block starts.
		             *
		             * @example
		             *
		             *     mode.processBlock(data.words, offset);
		             */
		            processBlock: function (words, offset) {
		                // Shortcuts
		                var cipher = this._cipher;
		                var blockSize = cipher.blockSize;
	
		                // XOR and encrypt
		                xorBlock.call(this, words, offset, blockSize);
		                cipher.encryptBlock(words, offset);
	
		                // Remember this block to use with next block
		                this._prevBlock = words.slice(offset, offset + blockSize);
		            }
		        });
	
		        /**
		         * CBC decryptor.
		         */
		        CBC.Decryptor = CBC.extend({
		            /**
		             * Processes the data block at offset.
		             *
		             * @param {Array} words The data words to operate on.
		             * @param {number} offset The offset where the block starts.
		             *
		             * @example
		             *
		             *     mode.processBlock(data.words, offset);
		             */
		            processBlock: function (words, offset) {
		                // Shortcuts
		                var cipher = this._cipher;
		                var blockSize = cipher.blockSize;
	
		                // Remember this block to use with next block
		                var thisBlock = words.slice(offset, offset + blockSize);
	
		                // Decrypt and XOR
		                cipher.decryptBlock(words, offset);
		                xorBlock.call(this, words, offset, blockSize);
	
		                // This block becomes the previous block
		                this._prevBlock = thisBlock;
		            }
		        });
	
		        function xorBlock(words, offset, blockSize) {
		            var block;
	
		            // Shortcut
		            var iv = this._iv;
	
		            // Choose mixing block
		            if (iv) {
		                block = iv;
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            } else {
		                block = this._prevBlock;
		            }
	
		            // XOR blocks
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= block[i];
		            }
		        }
	
		        return CBC;
		    }());
	
		    /**
		     * Padding namespace.
		     */
		    var C_pad = C.pad = {};
	
		    /**
		     * PKCS #5/7 padding strategy.
		     */
		    var Pkcs7 = C_pad.Pkcs7 = {
		        /**
		         * Pads data using the algorithm defined in PKCS #5/7.
		         *
		         * @param {WordArray} data The data to pad.
		         * @param {number} blockSize The multiple that the data should be padded to.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
		         */
		        pad: function (data, blockSize) {
		            // Shortcut
		            var blockSizeBytes = blockSize * 4;
	
		            // Count padding bytes
		            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
	
		            // Create padding word
		            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;
	
		            // Create padding
		            var paddingWords = [];
		            for (var i = 0; i < nPaddingBytes; i += 4) {
		                paddingWords.push(paddingWord);
		            }
		            var padding = WordArray.create(paddingWords, nPaddingBytes);
	
		            // Add padding
		            data.concat(padding);
		        },
	
		        /**
		         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
		         *
		         * @param {WordArray} data The data to unpad.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
		         */
		        unpad: function (data) {
		            // Get number of padding bytes from last byte
		            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;
	
		            // Remove padding
		            data.sigBytes -= nPaddingBytes;
		        }
		    };
	
		    /**
		     * Abstract base block cipher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
		     */
		    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {Mode} mode The block mode to use. Default: CBC
		         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
		         */
		        cfg: Cipher.cfg.extend({
		            mode: CBC,
		            padding: Pkcs7
		        }),
	
		        reset: function () {
		            var modeCreator;
	
		            // Reset cipher
		            Cipher.reset.call(this);
	
		            // Shortcuts
		            var cfg = this.cfg;
		            var iv = cfg.iv;
		            var mode = cfg.mode;
	
		            // Reset block mode
		            if (this._xformMode == this._ENC_XFORM_MODE) {
		                modeCreator = mode.createEncryptor;
		            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
		                modeCreator = mode.createDecryptor;
		                // Keep at least one block in the buffer for unpadding
		                this._minBufferSize = 1;
		            }
	
		            if (this._mode && this._mode.__creator == modeCreator) {
		                this._mode.init(this, iv && iv.words);
		            } else {
		                this._mode = modeCreator.call(mode, this, iv && iv.words);
		                this._mode.__creator = modeCreator;
		            }
		        },
	
		        _doProcessBlock: function (words, offset) {
		            this._mode.processBlock(words, offset);
		        },
	
		        _doFinalize: function () {
		            var finalProcessedBlocks;
	
		            // Shortcut
		            var padding = this.cfg.padding;
	
		            // Finalize
		            if (this._xformMode == this._ENC_XFORM_MODE) {
		                // Pad data
		                padding.pad(this._data, this.blockSize);
	
		                // Process final blocks
		                finalProcessedBlocks = this._process(!!'flush');
		            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
		                // Process final blocks
		                finalProcessedBlocks = this._process(!!'flush');
	
		                // Unpad data
		                padding.unpad(finalProcessedBlocks);
		            }
	
		            return finalProcessedBlocks;
		        },
	
		        blockSize: 128/32
		    });
	
		    /**
		     * A collection of cipher parameters.
		     *
		     * @property {WordArray} ciphertext The raw ciphertext.
		     * @property {WordArray} key The key to this ciphertext.
		     * @property {WordArray} iv The IV used in the ciphering operation.
		     * @property {WordArray} salt The salt used with a key derivation function.
		     * @property {Cipher} algorithm The cipher algorithm.
		     * @property {Mode} mode The block mode used in the ciphering operation.
		     * @property {Padding} padding The padding scheme used in the ciphering operation.
		     * @property {number} blockSize The block size of the cipher.
		     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
		     */
		    var CipherParams = C_lib.CipherParams = Base.extend({
		        /**
		         * Initializes a newly created cipher params object.
		         *
		         * @param {Object} cipherParams An object with any of the possible cipher parameters.
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.lib.CipherParams.create({
		         *         ciphertext: ciphertextWordArray,
		         *         key: keyWordArray,
		         *         iv: ivWordArray,
		         *         salt: saltWordArray,
		         *         algorithm: CryptoJS.algo.AES,
		         *         mode: CryptoJS.mode.CBC,
		         *         padding: CryptoJS.pad.PKCS7,
		         *         blockSize: 4,
		         *         formatter: CryptoJS.format.OpenSSL
		         *     });
		         */
		        init: function (cipherParams) {
		            this.mixIn(cipherParams);
		        },
	
		        /**
		         * Converts this cipher params object to a string.
		         *
		         * @param {Format} formatter (Optional) The formatting strategy to use.
		         *
		         * @return {string} The stringified cipher params.
		         *
		         * @throws Error If neither the formatter nor the default formatter is set.
		         *
		         * @example
		         *
		         *     var string = cipherParams + '';
		         *     var string = cipherParams.toString();
		         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
		         */
		        toString: function (formatter) {
		            return (formatter || this.formatter).stringify(this);
		        }
		    });
	
		    /**
		     * Format namespace.
		     */
		    var C_format = C.format = {};
	
		    /**
		     * OpenSSL formatting strategy.
		     */
		    var OpenSSLFormatter = C_format.OpenSSL = {
		        /**
		         * Converts a cipher params object to an OpenSSL-compatible string.
		         *
		         * @param {CipherParams} cipherParams The cipher params object.
		         *
		         * @return {string} The OpenSSL-compatible string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
		         */
		        stringify: function (cipherParams) {
		            var wordArray;
	
		            // Shortcuts
		            var ciphertext = cipherParams.ciphertext;
		            var salt = cipherParams.salt;
	
		            // Format
		            if (salt) {
		                wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
		            } else {
		                wordArray = ciphertext;
		            }
	
		            return wordArray.toString(Base64);
		        },
	
		        /**
		         * Converts an OpenSSL-compatible string to a cipher params object.
		         *
		         * @param {string} openSSLStr The OpenSSL-compatible string.
		         *
		         * @return {CipherParams} The cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
		         */
		        parse: function (openSSLStr) {
		            var salt;
	
		            // Parse base64
		            var ciphertext = Base64.parse(openSSLStr);
	
		            // Shortcut
		            var ciphertextWords = ciphertext.words;
	
		            // Test for salt
		            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
		                // Extract salt
		                salt = WordArray.create(ciphertextWords.slice(2, 4));
	
		                // Remove salt from ciphertext
		                ciphertextWords.splice(0, 4);
		                ciphertext.sigBytes -= 16;
		            }
	
		            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
		        }
		    };
	
		    /**
		     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
		     */
		    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
		         */
		        cfg: Base.extend({
		            format: OpenSSLFormatter
		        }),
	
		        /**
		         * Encrypts a message.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {WordArray|string} message The message to encrypt.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {CipherParams} A cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         */
		        encrypt: function (cipher, message, key, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Encrypt
		            var encryptor = cipher.createEncryptor(key, cfg);
		            var ciphertext = encryptor.finalize(message);
	
		            // Shortcut
		            var cipherCfg = encryptor.cfg;
	
		            // Create and return serializable cipher params
		            return CipherParams.create({
		                ciphertext: ciphertext,
		                key: key,
		                iv: cipherCfg.iv,
		                algorithm: cipher,
		                mode: cipherCfg.mode,
		                padding: cipherCfg.padding,
		                blockSize: cipher.blockSize,
		                formatter: cfg.format
		            });
		        },
	
		        /**
		         * Decrypts serialized ciphertext.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {WordArray} The plaintext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         */
		        decrypt: function (cipher, ciphertext, key, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Convert string to CipherParams
		            ciphertext = this._parse(ciphertext, cfg.format);
	
		            // Decrypt
		            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
	
		            return plaintext;
		        },
	
		        /**
		         * Converts serialized ciphertext to CipherParams,
		         * else assumed CipherParams already and returns ciphertext unchanged.
		         *
		         * @param {CipherParams|string} ciphertext The ciphertext.
		         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
		         *
		         * @return {CipherParams} The unserialized ciphertext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
		         */
		        _parse: function (ciphertext, format) {
		            if (typeof ciphertext == 'string') {
		                return format.parse(ciphertext, this);
		            } else {
		                return ciphertext;
		            }
		        }
		    });
	
		    /**
		     * Key derivation function namespace.
		     */
		    var C_kdf = C.kdf = {};
	
		    /**
		     * OpenSSL key derivation function.
		     */
		    var OpenSSLKdf = C_kdf.OpenSSL = {
		        /**
		         * Derives a key and IV from a password.
		         *
		         * @param {string} password The password to derive from.
		         * @param {number} keySize The size in words of the key to generate.
		         * @param {number} ivSize The size in words of the IV to generate.
		         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
		         *
		         * @return {CipherParams} A cipher params object with the key, IV, and salt.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
		         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
		         */
		        execute: function (password, keySize, ivSize, salt) {
		            // Generate random salt
		            if (!salt) {
		                salt = WordArray.random(64/8);
		            }
	
		            // Derive key and IV
		            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);
	
		            // Separate key and IV
		            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
		            key.sigBytes = keySize * 4;
	
		            // Return params
		            return CipherParams.create({ key: key, iv: iv, salt: salt });
		        }
		    };
	
		    /**
		     * A serializable cipher wrapper that derives the key from a password,
		     * and returns ciphertext as a serializable cipher params object.
		     */
		    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
		         */
		        cfg: SerializableCipher.cfg.extend({
		            kdf: OpenSSLKdf
		        }),
	
		        /**
		         * Encrypts a message using a password.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {WordArray|string} message The message to encrypt.
		         * @param {string} password The password.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {CipherParams} A cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
		         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
		         */
		        encrypt: function (cipher, message, password, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Derive key and other params
		            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);
	
		            // Add IV to config
		            cfg.iv = derivedParams.iv;
	
		            // Encrypt
		            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
	
		            // Mix in derived params
		            ciphertext.mixIn(derivedParams);
	
		            return ciphertext;
		        },
	
		        /**
		         * Decrypts serialized ciphertext using a password.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
		         * @param {string} password The password.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {WordArray} The plaintext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
		         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
		         */
		        decrypt: function (cipher, ciphertext, password, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Convert string to CipherParams
		            ciphertext = this._parse(ciphertext, cfg.format);
	
		            // Derive key and other params
		            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);
	
		            // Add IV to config
		            cfg.iv = derivedParams.iv;
	
		            // Decrypt
		            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
	
		            return plaintext;
		        }
		    });
		}());
	
	
	}));

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoAlmacen = function CatalogoAlmacen(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	    var txtBuscar = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        records = _useState6[0],
	        setRecords = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({
	        idalmacen: '',
	        descripcion: '',
	        responsable: '',
	        ventas: false
	    }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        values = _useState8[0],
	        setValues = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(-1),
	        _useState10 = _slicedToArray(_useState9, 2),
	        itemSelect = _useState10[0],
	        setItemSelect = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filterFn = _useState12[0],
	        setFilterFn = _useState12[1];
	
	    var headCells = [{ label: 'CODIGO', textAlign: 'center' }, { label: 'DESCRIPCION', textAlign: 'center' }, { label: 'RESPONSABLE', textAlign: 'center' }, { label: 'VENTAS', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.idalmacen.includes(target.value) || x.descripcion.toLowerCase().includes(target.value.toLowerCase()) || x.responsable.toLowerCase().includes(target.value.toLowerCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = 'idalmacen, trim(descripcion) as descripcion, trim(responsable) as responsable, ventas';
	        var nomtab = 'almacen';
	        var orden = 'idalmacen';
	
	        var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setRecords([]);
	        setValues({
	            idalmacen: '',
	            descripcion: '',
	            responsable: '',
	            ventas: false
	        });
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var seleccionarAlmacen = function seleccionarAlmacen() {
	
	        props.onHideAceptaCatalogo(values);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	
	            setValues({
	                idalmacen: item.idalmacen,
	                descripcion: item.descripcion,
	                responsable: item.responsable,
	                ventas: item.ventas ? true : false
	            });
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	                txtBuscar.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Almacen'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group col-md-6 input-group-sm mb-3' },
	                        _react2.default.createElement('input', { type: 'text', ref: txtBuscar,
	                            onChange: handleSearch, className: 'form-control text-uppercase' }),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-info', style: { pointerEvents: 'none' } },
	                            _react2.default.createElement('i', { className: 'fa fa-search' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.idalmacen === item.idalmacen ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.idalmacen
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-start' },
	                                    item.descripcion
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.responsable
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.ventas ? _react2.default.createElement('i', { className: 'fas text-success fa-check-double' }) : _react2.default.createElement('i', { className: 'fas text-danger fa-exclamation-triangle' })
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: seleccionarAlmacen },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoAlmacen;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  handleRef: true,
	  isRefObject: true,
	  toRefObject: true,
	  Ref: true,
	  RefFindNode: true,
	  RefForward: true
	};
	Object.defineProperty(exports, "handleRef", {
	  enumerable: true,
	  get: function get() {
	    return _handleRef.default;
	  }
	});
	Object.defineProperty(exports, "isRefObject", {
	  enumerable: true,
	  get: function get() {
	    return _isRefObject.default;
	  }
	});
	Object.defineProperty(exports, "toRefObject", {
	  enumerable: true,
	  get: function get() {
	    return _toRefObject.default;
	  }
	});
	Object.defineProperty(exports, "Ref", {
	  enumerable: true,
	  get: function get() {
	    return _Ref.default;
	  }
	});
	Object.defineProperty(exports, "RefFindNode", {
	  enumerable: true,
	  get: function get() {
	    return _RefFindNode.default;
	  }
	});
	Object.defineProperty(exports, "RefForward", {
	  enumerable: true,
	  get: function get() {
	    return _RefForward.default;
	  }
	});
	
	var _handleRef = _interopRequireDefault(__webpack_require__(246));
	
	var _isRefObject = _interopRequireDefault(__webpack_require__(6651));
	
	var _toRefObject = _interopRequireDefault(__webpack_require__(6652));
	
	var _Ref = _interopRequireDefault(__webpack_require__(6650));
	
	var _RefFindNode = _interopRequireDefault(__webpack_require__(410));
	
	var _RefForward = _interopRequireDefault(__webpack_require__(411));
	
	var _types = __webpack_require__(173);
	
	Object.keys(_types).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _types[key];
	    }
	  });
	});

/***/ },
/* 53 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Icon["default"];
	  }
	});
	
	var _Icon = _interopRequireDefault(__webpack_require__(220));

/***/ },
/* 55 */
/***/ function(module, exports) {

	function _typeof(o) {
	  "@babel/helpers - typeof";
	
	  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
	    return typeof o;
	  } : function (o) {
	    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonBase.default;
	  }
	});
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(823));

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSvgIcon;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(166));
	
	/**
	 * Private module reserved for @material-ui/x packages.
	 */
	function createSvgIcon(path, displayName) {
	  var Component = function Component(props, ref) {
	    return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
	      ref: ref
	    }, props), path);
	  };
	
	  if (false) {
	    // Need to set `displayName` on the inner component for React.memo.
	    // React prior to 16.14 ignores `displayName` on the wrapper.
	    Component.displayName = "".concat(displayName, "Icon");
	  }
	
	  Component.muiName = _SvgIcon.default.muiName;
	  return /*#__PURE__*/_react.default.memo( /*#__PURE__*/_react.default.forwardRef(Component));
	}

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(483);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 59 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.11.5
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  createGenerateClassName: true,
	  createStyles: true,
	  getThemeProps: true,
	  jssPreset: true,
	  makeStyles: true,
	  mergeClasses: true,
	  ServerStyleSheets: true,
	  styled: true,
	  StylesProvider: true,
	  ThemeProvider: true,
	  useTheme: true,
	  withStyles: true,
	  withTheme: true
	};
	Object.defineProperty(exports, "createGenerateClassName", {
	  enumerable: true,
	  get: function get() {
	    return _createGenerateClassName.default;
	  }
	});
	Object.defineProperty(exports, "createStyles", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	Object.defineProperty(exports, "getThemeProps", {
	  enumerable: true,
	  get: function get() {
	    return _getThemeProps.default;
	  }
	});
	Object.defineProperty(exports, "jssPreset", {
	  enumerable: true,
	  get: function get() {
	    return _jssPreset.default;
	  }
	});
	Object.defineProperty(exports, "makeStyles", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	Object.defineProperty(exports, "mergeClasses", {
	  enumerable: true,
	  get: function get() {
	    return _mergeClasses.default;
	  }
	});
	Object.defineProperty(exports, "ServerStyleSheets", {
	  enumerable: true,
	  get: function get() {
	    return _ServerStyleSheets.default;
	  }
	});
	Object.defineProperty(exports, "styled", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	Object.defineProperty(exports, "StylesProvider", {
	  enumerable: true,
	  get: function get() {
	    return _StylesProvider.default;
	  }
	});
	Object.defineProperty(exports, "ThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _ThemeProvider.default;
	  }
	});
	Object.defineProperty(exports, "useTheme", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	Object.defineProperty(exports, "withStyles", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	Object.defineProperty(exports, "withTheme", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	
	var _utils = __webpack_require__(22);
	
	var _createGenerateClassName = _interopRequireWildcard(__webpack_require__(242));
	
	Object.keys(_createGenerateClassName).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _createGenerateClassName[key];
	    }
	  });
	});
	
	var _createStyles = _interopRequireWildcard(__webpack_require__(6601));
	
	Object.keys(_createStyles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _createStyles[key];
	    }
	  });
	});
	
	var _getThemeProps = _interopRequireWildcard(__webpack_require__(402));
	
	Object.keys(_getThemeProps).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _getThemeProps[key];
	    }
	  });
	});
	
	var _jssPreset = _interopRequireWildcard(__webpack_require__(403));
	
	Object.keys(_jssPreset).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _jssPreset[key];
	    }
	  });
	});
	
	var _makeStyles = _interopRequireWildcard(__webpack_require__(243));
	
	Object.keys(_makeStyles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _makeStyles[key];
	    }
	  });
	});
	
	var _mergeClasses = _interopRequireWildcard(__webpack_require__(404));
	
	Object.keys(_mergeClasses).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _mergeClasses[key];
	    }
	  });
	});
	
	var _ServerStyleSheets = _interopRequireWildcard(__webpack_require__(6595));
	
	Object.keys(_ServerStyleSheets).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ServerStyleSheets[key];
	    }
	  });
	});
	
	var _styled = _interopRequireWildcard(__webpack_require__(6610));
	
	Object.keys(_styled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _styled[key];
	    }
	  });
	});
	
	var _StylesProvider = _interopRequireWildcard(__webpack_require__(241));
	
	Object.keys(_StylesProvider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StylesProvider[key];
	    }
	  });
	});
	
	var _ThemeProvider = _interopRequireWildcard(__webpack_require__(6598));
	
	Object.keys(_ThemeProvider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ThemeProvider[key];
	    }
	  });
	});
	
	var _useTheme = _interopRequireWildcard(__webpack_require__(132));
	
	Object.keys(_useTheme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _useTheme[key];
	    }
	  });
	});
	
	var _withStyles = _interopRequireWildcard(__webpack_require__(6613));
	
	Object.keys(_withStyles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withStyles[key];
	    }
	  });
	});
	
	var _withTheme = _interopRequireWildcard(__webpack_require__(6615));
	
	Object.keys(_withTheme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withTheme[key];
	    }
	  });
	});
	
	/* eslint-disable import/export */
	
	/* Warning if there are several instances of @material-ui/styles */
	if (false) {
	  _utils.ponyfillGlobal['__@material-ui/styles-init__'] = _utils.ponyfillGlobal['__@material-ui/styles-init__'] || 0;
	
	  if (_utils.ponyfillGlobal['__@material-ui/styles-init__'] === 1) {
	    console.warn(['It looks like there are several instances of `@material-ui/styles` initialized in this application.', 'This may cause theme propagation issues, broken class names, ' + 'specificity issues, and makes your application bigger without a good reason.', '', 'See https://mui.com/r/styles-instance-warning for more info.'].join('\n'));
	  }
	
	  _utils.ponyfillGlobal['__@material-ui/styles-init__'] += 1;
	}

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(418);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is a Buffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Buffer, otherwise false
	 */
	function isBuffer(val) {
	  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
	    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a plain Object
	 *
	 * @param {Object} val The value to test
	 * @return {boolean} True if value is a plain Object, otherwise false
	 */
	function isPlainObject(val) {
	  if (toString.call(val) !== '[object Object]') {
	    return false;
	  }
	
	  var prototype = Object.getPrototypeOf(val);
	  return prototype === null || prototype === Object.prototype;
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
	                                           navigator.product === 'NativeScript' ||
	                                           navigator.product === 'NS')) {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (isPlainObject(result[key]) && isPlainObject(val)) {
	      result[key] = merge(result[key], val);
	    } else if (isPlainObject(val)) {
	      result[key] = merge({}, val);
	    } else if (isArray(val)) {
	      result[key] = val.slice();
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	/**
	 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
	 *
	 * @param {string} content with BOM
	 * @return {string} content value without BOM
	 */
	function stripBOM(content) {
	  if (content.charCodeAt(0) === 0xFEFF) {
	    content = content.slice(1);
	  }
	  return content;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isPlainObject: isPlainObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim,
	  stripBOM: stripBOM
	};


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(6786),
	    baseMatchesProperty = __webpack_require__(6787),
	    identity = __webpack_require__(77),
	    isArray = __webpack_require__(35),
	    property = __webpack_require__(6932);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(455),
	    baseKeys = __webpack_require__(186),
	    isArrayLike = __webpack_require__(73);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoPersona = function CatalogoPersona(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtPersona = (0, _react.useRef)([]);
	  var txtBuscar = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      activate = _useState2[0],
	      setActivate = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      records = _useState4[0],
	      setRecords = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mensaje = _useState6[0],
	      setMensaje = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      filterFn = _useState8[0],
	      setFilterFn = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({
	    cedPer: "",
	    nomPer: "",
	    apePer: "",
	    correoPer: "",
	    tlf1Per: "",
	    tlf2Per: "",
	    fnacPer: "",
	    nacPer: "",
	    sexoPer: "",
	    direPer: ""
	  }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      values = _useState10[0],
	      setValues = _useState10[1];
	
	  var headCells = [{ label: "CÉDULA", textAlign: "center" }, { label: "NOMBRES", textAlign: "center" }, { label: "APELLIDOS", textAlign: "center" }];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if ((x.nacionalidad + x.cedula).toLowerCase().includes(target.value) || x.apellidos.toLowerCase().includes(target.value.toLowerCase()) || x.nombres.toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarPersonasTodas = function seleccionarPersonasTodas() {
	    var endpoint = op.conexion + "/api/catalogo/personas";
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setActivate(false);
	        var perso = [];
	        for (var i = 0; i < response.data.length; i++) {
	          perso.push({
	            cedula: response.data[i].cedula,
	            nombres: response.data[i].nombres,
	            apellidos: response.data[i].apellidos,
	            correoe: response.data[i].correoe,
	            tlf1: response.data[i].tlf1,
	            tlf2: response.data[i].tlf2,
	            fnacimiento: response.data[i].fnacimiento,
	            nacionalidad: response.data[i].nacionalidad,
	            sexo: response.data[i].sexo,
	            direccion: response.data[i].direccion
	          });
	        }
	        setRecords(perso);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: "error al cargar los registros",
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setRecords([]);
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	    setValues({
	      cedPer: "",
	      nomPer: "",
	      apePer: "",
	      correoPer: "",
	      tlf1Per: "",
	      tlf2Per: "",
	      fnacPer: "",
	      nacPer: "",
	      sexoPer: "",
	      direPer: ""
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelaCatPer();
	  };
	
	  var seleccionarPersona = function seleccionarPersona() {
	    blanquear();
	    props.onHideAceptaCatPer(values);
	  };
	
	  var seleccionarFila = function seleccionarFila(item) {
	    return function (e) {
	      e.preventDefault();
	
	      setValues({
	        cedPer: item.cedula,
	        nomPer: item.nombres,
	        apePer: item.apellidos,
	        correoPer: item.correoe,
	        tlf1Per: item.tlf1,
	        tlf2Per: item.tlf2,
	        fnacPer: item.fnacimiento,
	        nacPer: item.nacionalidad,
	        sexoPer: item.sexo,
	        direPer: item.direccion
	      });
	      btnAcepta.current.focus();
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        seleccionarPersonasTodas();
	        txtBuscar.current.focus();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Seleccionar Persona"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-6 input-group-sm mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control text-uppercase",
	              ref: txtBuscar
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  style: {
	                    padding: "0",
	                    cursor: "pointer",
	                    background: values.cedPer === item.cedula ? "lightskyblue" : "white"
	                  },
	                  onClick: seleccionarFila(item)
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.nacionalidad + item.cedula
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.nombres
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.apellidos
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          style: { margin: "5px" },
	          onClick: seleccionarPersona
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoPersona;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Paper.default;
	  }
	});
	
	var _Paper = _interopRequireDefault(__webpack_require__(930));

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Typography.default;
	  }
	});
	
	var _Typography = _interopRequireDefault(__webpack_require__(997));

/***/ },
/* 67 */
[7344, 1027],
/* 68 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(6672);


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(98),
	    getRawTag = __webpack_require__(6832),
	    objectToString = __webpack_require__(6862);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 71 */
/***/ function(module, exports) {

	module.exports = {
	  'cap': false,
	  'curry': false,
	  'fixed': false,
	  'immutable': false,
	  'rearg': false
	};


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(143);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(89),
	    isLength = __webpack_require__(281);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.duration = exports.easing = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
	// to learn the context in which each easing should be used.
	var easing = {
	  // This is the most common easing curve.
	  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
	  // Objects enter the screen at full velocity from off-screen and
	  // slowly decelerate to a resting point.
	  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
	  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
	  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
	  // The sharp curve is used by objects that may return to the screen at any time.
	  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
	}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
	// to learn when use what timing
	
	exports.easing = easing;
	var duration = {
	  shortest: 150,
	  shorter: 200,
	  short: 250,
	  // most basic recommended timing
	  standard: 300,
	  // this is to be used in complex animations
	  complex: 375,
	  // recommended when something is entering screen
	  enteringScreen: 225,
	  // recommended when something is leaving screen
	  leavingScreen: 195
	};
	exports.duration = duration;
	
	function formatMs(milliseconds) {
	  return "".concat(Math.round(milliseconds), "ms");
	}
	/**
	 * @param {string|Array} props
	 * @param {object} param
	 * @param {string} param.prop
	 * @param {number} param.duration
	 * @param {string} param.easing
	 * @param {number} param.delay
	 */
	
	
	var _default = {
	  easing: easing,
	  duration: duration,
	  create: function create() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$duration = options.duration,
	        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
	        _options$easing = options.easing,
	        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
	        _options$delay = options.delay,
	        delay = _options$delay === void 0 ? 0 : _options$delay,
	        other = (0, _objectWithoutProperties2.default)(options, ["duration", "easing", "delay"]);
	
	    if (false) {
	      var isString = function isString(value) {
	        return typeof value === 'string';
	      };
	
	      var isNumber = function isNumber(value) {
	        return !isNaN(parseFloat(value));
	      };
	
	      if (!isString(props) && !Array.isArray(props)) {
	        console.error('Material-UI: Argument "props" must be a string or Array.');
	      }
	
	      if (!isNumber(durationOption) && !isString(durationOption)) {
	        console.error("Material-UI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
	      }
	
	      if (!isString(easingOption)) {
	        console.error('Material-UI: Argument "easing" must be a string.');
	      }
	
	      if (!isNumber(delay) && !isString(delay)) {
	        console.error('Material-UI: Argument "delay" must be a number or a string.');
	      }
	
	      if (Object.keys(other).length !== 0) {
	        console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
	      }
	    }
	
	    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
	      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
	    }).join(',');
	  },
	  getAutoHeightDuration: function getAutoHeightDuration(height) {
	    if (!height) {
	      return 0;
	    }
	
	    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
	
	    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
	  }
	};
	exports.default = _default;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _responsivePropType = _interopRequireDefault(__webpack_require__(407));
	
	var _breakpoints = __webpack_require__(244);
	
	function getPath(obj, path) {
	  if (!path || typeof path !== 'string') {
	    return null;
	  }
	
	  return path.split('.').reduce(function (acc, item) {
	    return acc && acc[item] ? acc[item] : null;
	  }, obj);
	}
	
	function style(options) {
	  var prop = options.prop,
	      _options$cssProperty = options.cssProperty,
	      cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty,
	      themeKey = options.themeKey,
	      transform = options.transform;
	
	  var fn = function fn(props) {
	    if (props[prop] == null) {
	      return null;
	    }
	
	    var propValue = props[prop];
	    var theme = props.theme;
	    var themeMapping = getPath(theme, themeKey) || {};
	
	    var styleFromPropValue = function styleFromPropValue(propValueFinal) {
	      var value;
	
	      if (typeof themeMapping === 'function') {
	        value = themeMapping(propValueFinal);
	      } else if (Array.isArray(themeMapping)) {
	        value = themeMapping[propValueFinal] || propValueFinal;
	      } else {
	        value = getPath(themeMapping, propValueFinal) || propValueFinal;
	
	        if (transform) {
	          value = transform(value);
	        }
	      }
	
	      if (cssProperty === false) {
	        return value;
	      }
	
	      return (0, _defineProperty2.default)({}, cssProperty, value);
	    };
	
	    return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
	  };
	
	  fn.propTypes =  false ? (0, _defineProperty2.default)({}, prop, _responsivePropType.default) : {};
	  fn.filterProps = [prop];
	  return fn;
	}
	
	var _default = style;
	exports.default = _default;

/***/ },
/* 76 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ },
/* 77 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(188);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useEventCallback;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	/**
	 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
	 *
	 * @param {function} fn
	 */
	
	function useEventCallback(fn) {
	  var ref = React.useRef(fn);
	  useEnhancedEffect(function () {
	    ref.current = fn;
	  });
	  return React.useCallback(function () {
	    return (0, ref.current).apply(void 0, arguments);
	  }, []);
	}

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _merge = _interopRequireDefault(__webpack_require__(171));
	
	function compose() {
	  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
	    styles[_key] = arguments[_key];
	  }
	
	  var fn = function fn(props) {
	    return styles.reduce(function (acc, style) {
	      var output = style(props);
	
	      if (output) {
	        return (0, _merge.default)(acc, output);
	      }
	
	      return acc;
	    }, {});
	  }; // Alternative approach that doesn't yield any performance gain.
	  // const handlers = styles.reduce((acc, style) => {
	  //   style.filterProps.forEach(prop => {
	  //     acc[prop] = style;
	  //   });
	  //   return acc;
	  // }, {});
	  // const fn = props => {
	  //   return Object.keys(props).reduce((acc, prop) => {
	  //     if (handlers[prop]) {
	  //       return merge(acc, handlers[prop](props));
	  //     }
	  //     return acc;
	  //   }, {});
	  // };
	
	
	  fn.propTypes =  false ? styles.reduce(function (acc, style) {
	    return (0, _extends2.default)(acc, style.propTypes);
	  }, {}) : {};
	  fn.filterProps = styles.reduce(function (acc, style) {
	    return acc.concat(style.filterProps);
	  }, []);
	  return fn;
	}
	
	var _default = compose;
	exports.default = _default;

/***/ },
/* 81 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(285);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var FormContext = _react.default.createContext({
	  controlId: undefined
	});
	
	var _default = FormContext;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(43));
	
	var _get2 = _interopRequireDefault(__webpack_require__(72));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Label = _interopRequireDefault(__webpack_require__(159));
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(223));
	
	var _Radio = _interopRequireDefault(__webpack_require__(307));
	
	/**
	 * A field is a form element containing a label and an input.
	 * @see Form
	 * @see Button
	 * @see Checkbox
	 * @see Dropdown
	 * @see Input
	 * @see Radio
	 * @see Select
	 * @see Visibility
	 */
	function FormField(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      control = props.control,
	      disabled = props.disabled,
	      error = props.error,
	      inline = props.inline,
	      label = props.label,
	      required = props.required,
	      type = props.type,
	      width = props.width;
	  var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(inline, 'inline'), (0, _lib.useKeyOnly)(required, 'required'), (0, _lib.useWidthProp)(width, 'wide'), 'field', className);
	  var rest = (0, _lib.getUnhandledProps)(FormField, props);
	  var ElementType = (0, _lib.getElementType)(FormField, props);
	  var errorPointing = (0, _get2["default"])(error, 'pointing', 'above');
	
	  var errorLabel = _Label["default"].create(error, {
	    autoGenerateKey: false,
	    defaultProps: {
	      prompt: true,
	      pointing: errorPointing
	    }
	  });
	
	  var errorLabelBefore = (errorPointing === 'below' || errorPointing === 'right') && errorLabel;
	  var errorLabelAfter = (errorPointing === 'above' || errorPointing === 'left') && errorLabel; // ----------------------------------------
	  // No Control
	  // ----------------------------------------
	
	  if ((0, _isNil2["default"])(control)) {
	    if ((0, _isNil2["default"])(label)) {
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes
	      }), _lib.childrenUtils.isNil(children) ? content : children);
	    }
	
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), errorLabelBefore, (0, _lib.createHTMLLabel)(label, {
	      autoGenerateKey: false
	    }), errorLabelAfter);
	  } // ----------------------------------------
	  // Checkbox/Radio Control
	  // ----------------------------------------
	
	
	  var controlProps = (0, _objectSpread2["default"])({}, rest, {
	    content: content,
	    children: children,
	    disabled: disabled,
	    required: required,
	    type: type // wrap HTML checkboxes/radios in the label
	
	  });
	
	  if (control === 'input' && (type === 'checkbox' || type === 'radio')) {
	    return _react["default"].createElement(ElementType, {
	      className: classes
	    }, _react["default"].createElement("label", null, errorLabelBefore, (0, _react.createElement)(control, controlProps), " ", label, errorLabelAfter));
	  } // pass label prop to controls that support it
	
	
	  if (control === _Checkbox["default"] || control === _Radio["default"]) {
	    return _react["default"].createElement(ElementType, {
	      className: classes
	    }, errorLabelBefore, (0, _react.createElement)(control, (0, _objectSpread2["default"])({}, controlProps, {
	      label: label
	    })), errorLabelAfter);
	  } // ----------------------------------------
	  // Other Control
	  // ----------------------------------------
	
	
	  return _react["default"].createElement(ElementType, {
	    className: classes
	  }, (0, _lib.createHTMLLabel)(label, {
	    defaultProps: {
	      htmlFor: (0, _get2["default"])(controlProps, 'id')
	    },
	    autoGenerateKey: false
	  }), errorLabelBefore, (0, _react.createElement)(control, controlProps), errorLabelAfter);
	}
	
	FormField.handledProps = ["as", "children", "className", "content", "control", "disabled", "error", "inline", "label", "required", "type", "width"];
	FormField.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /**
	   * A form control component (i.e. Dropdown) or HTML tagName (i.e. 'input').
	   * Extra FormField props are passed to the control component.
	   * Mutually exclusive with children.
	   */
	  control: _lib.customPropTypes.some([_propTypes["default"].func, _propTypes["default"].oneOf(['button', 'input', 'select', 'textarea'])]),
	
	  /** Individual fields may be disabled. */
	  disabled: _propTypes["default"].bool,
	
	  /** Individual fields may display an error state along with a message. */
	  error: _propTypes["default"].oneOfType([_propTypes["default"].bool, _lib.customPropTypes.itemShorthand]),
	
	  /** A field can have its label next to instead of above it. */
	  inline: _propTypes["default"].bool,
	  // Heads Up!
	  // Do not disallow children with `label` shorthand
	  // The `control` might accept a `label` prop and `children`
	
	  /** Mutually exclusive with children. */
	  label: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].object]),
	
	  /** A field can show that input is mandatory. */
	  required: _propTypes["default"].bool,
	
	  /** Passed to the control component (i.e. <input type='password' />) */
	  type: _lib.customPropTypes.every([_lib.customPropTypes.demand(['control'])]),
	
	  /** A field can specify its width in grid columns */
	  width: _propTypes["default"].oneOf(_lib.SUI.WIDTHS)
	} : {};
	var _default = FormField;
	exports["default"] = _default;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useControlled;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
	function useControlled(_ref) {
	  var controlled = _ref.controlled,
	      defaultProp = _ref.default,
	      name = _ref.name,
	      _ref$state = _ref.state,
	      state = _ref$state === void 0 ? 'value' : _ref$state;
	
	  var _React$useRef = React.useRef(controlled !== undefined),
	      isControlled = _React$useRef.current;
	
	  var _React$useState = React.useState(defaultProp),
	      valueState = _React$useState[0],
	      setValue = _React$useState[1];
	
	  var value = isControlled ? controlled : valueState;
	
	  if (false) {
	    React.useEffect(function () {
	      if (isControlled !== (controlled !== undefined)) {
	        console.error(["Material-UI: A component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.', "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
	      }
	    }, [controlled]);
	
	    var _React$useRef2 = React.useRef(defaultProp),
	        defaultValue = _React$useRef2.current;
	
	    React.useEffect(function () {
	      if (!isControlled && defaultValue !== defaultProp) {
	        console.error(["Material-UI: A component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
	      }
	    }, [JSON.stringify(defaultProp)]);
	  }
	
	  var setValueIfUncontrolled = React.useCallback(function (newValue) {
	    if (!isControlled) {
	      setValue(newValue);
	    }
	  }, []);
	  return [value, setValueIfUncontrolled];
	}

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(77),
	    overRest = __webpack_require__(496),
	    setToString = __webpack_require__(278);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(6756),
	    Map = __webpack_require__(264),
	    Promise = __webpack_require__(6758),
	    Set = __webpack_require__(451),
	    WeakMap = __webpack_require__(453),
	    baseGetTag = __webpack_require__(70),
	    toSource = __webpack_require__(502);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(185),
	    isArrayLike = __webpack_require__(73),
	    isString = __webpack_require__(203),
	    toInteger = __webpack_require__(82),
	    values = __webpack_require__(153);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(70),
	    isObject = __webpack_require__(59);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 90 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoProductosExistencias = function CatalogoProductosExistencias(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        records = _useState6[0],
	        setRecords = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({
	        idalmacen: '',
	        descripcion: '',
	        responsable: '',
	        ventas: false
	    }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        values = _useState8[0],
	        setValues = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(-1),
	        _useState10 = _slicedToArray(_useState9, 2),
	        itemSelect = _useState10[0],
	        setItemSelect = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filterFn = _useState12[0],
	        setFilterFn = _useState12[1];
	
	    var headCells = [{ label: 'CODIGO', textAlign: 'center' }, { label: 'DESCRIPCION', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.codigo.toLowerCase().includes(target.value.toLowerCase()) || x.nombrecorto.toLowerCase().includes(target.value.toLowerCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var endpoint = op.conexion + '/api/inventario/productosenexistencia';
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setRecords([]);
	        setValues({
	            codigo: '',
	            nombrecorto: '',
	            idproducto: ''
	        });
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var seleccionarAlmacen = function seleccionarAlmacen() {
	
	        props.onHideAceptaCatalogo(values);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	
	            setValues({
	                codigo: item.codigo,
	                nombrecorto: item.nombrecorto,
	                idproducto: item.idproducto
	            });
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Producto'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row m-0 px-0 col-7' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group input-group-sm mb-1 px-0' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text border-azul', id: 'inputGroup-sizing-sm' },
	                                'BUSCAR:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', className: 'form-control text-uppercase border-azul', onChange: handleSearch, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.codigo === item.codigo ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.codigo
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-start' },
	                                    item.nombrecorto
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: seleccionarAlmacen },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoProductosExistencias;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(345);
	function _inheritsLoose(t, o) {
	  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, setPrototypeOf(t, o);
	}
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useFormControl;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _FormControlContext = _interopRequireDefault(__webpack_require__(162));
	
	function useFormControl() {
	  return React.useContext(_FormControlContext.default);
	}

/***/ },
/* 94 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	
	// Corresponds to 10 frames at 60 Hz.
	// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
	function debounce(func) {
	  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
	  var timeout;
	
	  function debounced() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    // eslint-disable-next-line consistent-this
	    var that = this;
	
	    var later = function later() {
	      func.apply(that, args);
	    };
	
	    clearTimeout(timeout);
	    timeout = setTimeout(later, wait);
	  }
	
	  debounced.clear = function () {
	    clearTimeout(timeout);
	  };
	
	  return debounced;
	}

/***/ },
/* 95 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setRef;
	
	// TODO v5: consider to make it private
	function setRef(ref, value) {
	  if (typeof ref === 'function') {
	    ref(value);
	  } else if (ref) {
	    ref.current = value;
	  }
	}

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(255), __webpack_require__(254));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./sha1", "./hmac"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var WordArray = C_lib.WordArray;
		    var C_algo = C.algo;
		    var MD5 = C_algo.MD5;
	
		    /**
		     * This key derivation function is meant to conform with EVP_BytesToKey.
		     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
		     */
		    var EvpKDF = C_algo.EvpKDF = Base.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
		         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
		         * @property {number} iterations The number of iterations to perform. Default: 1
		         */
		        cfg: Base.extend({
		            keySize: 128/32,
		            hasher: MD5,
		            iterations: 1
		        }),
	
		        /**
		         * Initializes a newly created key derivation function.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
		         *
		         * @example
		         *
		         *     var kdf = CryptoJS.algo.EvpKDF.create();
		         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
		         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
		         */
		        init: function (cfg) {
		            this.cfg = this.cfg.extend(cfg);
		        },
	
		        /**
		         * Derives a key from a password.
		         *
		         * @param {WordArray|string} password The password.
		         * @param {WordArray|string} salt A salt.
		         *
		         * @return {WordArray} The derived key.
		         *
		         * @example
		         *
		         *     var key = kdf.compute(password, salt);
		         */
		        compute: function (password, salt) {
		            var block;
	
		            // Shortcut
		            var cfg = this.cfg;
	
		            // Init hasher
		            var hasher = cfg.hasher.create();
	
		            // Initial values
		            var derivedKey = WordArray.create();
	
		            // Shortcuts
		            var derivedKeyWords = derivedKey.words;
		            var keySize = cfg.keySize;
		            var iterations = cfg.iterations;
	
		            // Generate key
		            while (derivedKeyWords.length < keySize) {
		                if (block) {
		                    hasher.update(block);
		                }
		                block = hasher.update(password).finalize(salt);
		                hasher.reset();
	
		                // Iterations
		                for (var i = 1; i < iterations; i++) {
		                    block = hasher.finalize(block);
		                    hasher.reset();
		                }
	
		                derivedKey.concat(block);
		            }
		            derivedKey.sigBytes = keySize * 4;
	
		            return derivedKey;
		        }
		    });
	
		    /**
		     * Derives a key from a password.
		     *
		     * @param {WordArray|string} password The password.
		     * @param {WordArray|string} salt A salt.
		     * @param {Object} cfg (Optional) The configuration options to use for this computation.
		     *
		     * @return {WordArray} The derived key.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var key = CryptoJS.EvpKDF(password, salt);
		     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
		     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
		     */
		    C.EvpKDF = function (password, salt, cfg) {
		        return EvpKDF.create(cfg).compute(password, salt);
		    };
		}());
	
	
		return CryptoJS.EvpKDF;
	
	}));

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _extends = __webpack_require__(4);
	var isInBrowser = __webpack_require__(449);
	var warning = __webpack_require__(108);
	var _createClass = __webpack_require__(24);
	var _inheritsLoose = __webpack_require__(92);
	var _assertThisInitialized = __webpack_require__(25);
	var _objectWithoutPropertiesLoose = __webpack_require__(36);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	var isInBrowser__default = /*#__PURE__*/_interopDefaultLegacy(isInBrowser);
	var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
	var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
	var _inheritsLoose__default = /*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);
	var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
	var _objectWithoutPropertiesLoose__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutPropertiesLoose);
	
	var plainObjectConstrurctor = {}.constructor;
	function cloneStyle(style) {
	  if (style == null || typeof style !== 'object') return style;
	  if (Array.isArray(style)) return style.map(cloneStyle);
	  if (style.constructor !== plainObjectConstrurctor) return style;
	  var newStyle = {};
	
	  for (var name in style) {
	    newStyle[name] = cloneStyle(style[name]);
	  }
	
	  return newStyle;
	}
	
	/**
	 * Create a rule instance.
	 */
	
	function createRule(name, decl, options) {
	  if (name === void 0) {
	    name = 'unnamed';
	  }
	
	  var jss = options.jss;
	  var declCopy = cloneStyle(decl);
	  var rule = jss.plugins.onCreateRule(name, declCopy, options);
	  if (rule) return rule; // It is an at-rule and it has no instance.
	
	  if (name[0] === '@') {
	     false ? warning__default['default'](false, "[JSS] Unknown rule " + name) : void 0;
	  }
	
	  return null;
	}
	
	var join = function join(value, by) {
	  var result = '';
	
	  for (var i = 0; i < value.length; i++) {
	    // Remove !important from the value, it will be readded later.
	    if (value[i] === '!important') break;
	    if (result) result += by;
	    result += value[i];
	  }
	
	  return result;
	};
	/**
	 * Converts JSS array value to a CSS string.
	 *
	 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
	 * `border: ['1px', '2px']` > `border: 1px, 2px;`
	 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
	 * `color: ['red', !important]` > `color: red !important;`
	 */
	
	
	var toCssValue = function toCssValue(value) {
	  if (!Array.isArray(value)) return value;
	  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
	
	  if (Array.isArray(value[0])) {
	    for (var i = 0; i < value.length; i++) {
	      if (value[i] === '!important') break;
	      if (cssValue) cssValue += ', ';
	      cssValue += join(value[i], ' ');
	    }
	  } else cssValue = join(value, ', '); // Add !important, because it was ignored.
	
	
	  if (value[value.length - 1] === '!important') {
	    cssValue += ' !important';
	  }
	
	  return cssValue;
	};
	
	function getWhitespaceSymbols(options) {
	  if (options && options.format === false) {
	    return {
	      linebreak: '',
	      space: ''
	    };
	  }
	
	  return {
	    linebreak: '\n',
	    space: ' '
	  };
	}
	
	/**
	 * Indent a string.
	 * http://jsperf.com/array-join-vs-for
	 */
	
	function indentStr(str, indent) {
	  var result = '';
	
	  for (var index = 0; index < indent; index++) {
	    result += '  ';
	  }
	
	  return result + str;
	}
	/**
	 * Converts a Rule to CSS string.
	 */
	
	
	function toCss(selector, style, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var result = '';
	  if (!style) return result;
	  var _options = options,
	      _options$indent = _options.indent,
	      indent = _options$indent === void 0 ? 0 : _options$indent;
	  var fallbacks = style.fallbacks;
	
	  if (options.format === false) {
	    indent = -Infinity;
	  }
	
	  var _getWhitespaceSymbols = getWhitespaceSymbols(options),
	      linebreak = _getWhitespaceSymbols.linebreak,
	      space = _getWhitespaceSymbols.space;
	
	  if (selector) indent++; // Apply fallbacks first.
	
	  if (fallbacks) {
	    // Array syntax {fallbacks: [{prop: value}]}
	    if (Array.isArray(fallbacks)) {
	      for (var index = 0; index < fallbacks.length; index++) {
	        var fallback = fallbacks[index];
	
	        for (var prop in fallback) {
	          var value = fallback[prop];
	
	          if (value != null) {
	            if (result) result += linebreak;
	            result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
	          }
	        }
	      }
	    } else {
	      // Object syntax {fallbacks: {prop: value}}
	      for (var _prop in fallbacks) {
	        var _value = fallbacks[_prop];
	
	        if (_value != null) {
	          if (result) result += linebreak;
	          result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
	        }
	      }
	    }
	  }
	
	  for (var _prop2 in style) {
	    var _value2 = style[_prop2];
	
	    if (_value2 != null && _prop2 !== 'fallbacks') {
	      if (result) result += linebreak;
	      result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
	    }
	  } // Allow empty style in this case, because properties will be added dynamically.
	
	
	  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
	
	  if (!selector) return result;
	  indent--;
	  if (result) result = "" + linebreak + result + linebreak;
	  return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
	}
	
	var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
	var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
	var escape = (function (str) {
	  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
	});
	
	var BaseStyleRule =
	/*#__PURE__*/
	function () {
	  function BaseStyleRule(key, style, options) {
	    this.type = 'style';
	    this.isProcessed = false;
	    var sheet = options.sheet,
	        Renderer = options.Renderer;
	    this.key = key;
	    this.options = options;
	    this.style = style;
	    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
	  }
	  /**
	   * Get or set a style property.
	   */
	
	
	  var _proto = BaseStyleRule.prototype;
	
	  _proto.prop = function prop(name, value, options) {
	    // It's a getter.
	    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
	
	    var force = options ? options.force : false;
	    if (!force && this.style[name] === value) return this;
	    var newValue = value;
	
	    if (!options || options.process !== false) {
	      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
	    }
	
	    var isEmpty = newValue == null || newValue === false;
	    var isDefined = name in this.style; // Value is empty and wasn't defined before.
	
	    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
	
	    var remove = isEmpty && isDefined;
	    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
	
	    if (this.renderable && this.renderer) {
	      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
	      return this;
	    }
	
	    var sheet = this.options.sheet;
	
	    if (sheet && sheet.attached) {
	       false ? warning__default['default'](false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
	    }
	
	    return this;
	  };
	
	  return BaseStyleRule;
	}();
	var StyleRule =
	/*#__PURE__*/
	function (_BaseStyleRule) {
	  _inheritsLoose__default['default'](StyleRule, _BaseStyleRule);
	
	  function StyleRule(key, style, options) {
	    var _this;
	
	    _this = _BaseStyleRule.call(this, key, style, options) || this;
	    var selector = options.selector,
	        scoped = options.scoped,
	        sheet = options.sheet,
	        generateId = options.generateId;
	
	    if (selector) {
	      _this.selectorText = selector;
	    } else if (scoped !== false) {
	      _this.id = generateId(_assertThisInitialized__default['default'](_assertThisInitialized__default['default'](_this)), sheet);
	      _this.selectorText = "." + escape(_this.id);
	    }
	
	    return _this;
	  }
	  /**
	   * Set selector string.
	   * Attention: use this with caution. Most browsers didn't implement
	   * selectorText setter, so this may result in rerendering of entire Style Sheet.
	   */
	
	
	  var _proto2 = StyleRule.prototype;
	
	  /**
	   * Apply rule to an element inline.
	   */
	  _proto2.applyTo = function applyTo(renderable) {
	    var renderer = this.renderer;
	
	    if (renderer) {
	      var json = this.toJSON();
	
	      for (var prop in json) {
	        renderer.setProperty(renderable, prop, json[prop]);
	      }
	    }
	
	    return this;
	  }
	  /**
	   * Returns JSON representation of the rule.
	   * Fallbacks are not supported.
	   * Useful for inline styles.
	   */
	  ;
	
	  _proto2.toJSON = function toJSON() {
	    var json = {};
	
	    for (var prop in this.style) {
	      var value = this.style[prop];
	      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
	    }
	
	    return json;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto2.toString = function toString(options) {
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	    var opts = link ? _extends__default['default']({}, options, {
	      allowEmpty: true
	    }) : options;
	    return toCss(this.selectorText, this.style, opts);
	  };
	
	  _createClass__default['default'](StyleRule, [{
	    key: "selector",
	    set: function set(selector) {
	      if (selector === this.selectorText) return;
	      this.selectorText = selector;
	      var renderer = this.renderer,
	          renderable = this.renderable;
	      if (!renderable || !renderer) return;
	      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
	
	      if (!hasChanged) {
	        renderer.replaceRule(renderable, this);
	      }
	    }
	    /**
	     * Get selector string.
	     */
	    ,
	    get: function get() {
	      return this.selectorText;
	    }
	  }]);
	
	  return StyleRule;
	}(BaseStyleRule);
	var pluginStyleRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') {
	      return null;
	    }
	
	    return new StyleRule(key, style, options);
	  }
	};
	
	var defaultToStringOptions = {
	  indent: 1,
	  children: true
	};
	var atRegExp = /@([\w-]+)/;
	/**
	 * Conditional rule for @media, @supports
	 */
	
	var ConditionalRule =
	/*#__PURE__*/
	function () {
	  function ConditionalRule(key, styles, options) {
	    this.type = 'conditional';
	    this.isProcessed = false;
	    this.key = key;
	    var atMatch = key.match(atRegExp);
	    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
	
	    this.query = options.name || "@" + this.at;
	    this.options = options;
	    this.rules = new RuleList(_extends__default['default']({}, options, {
	      parent: this
	    }));
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Get a rule.
	   */
	
	
	  var _proto = ConditionalRule.prototype;
	
	  _proto.getRule = function getRule(name) {
	    return this.rules.get(name);
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Create and register rule, run plugins.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, style, options) {
	    var rule = this.rules.add(name, style, options);
	    if (!rule) return null;
	    this.options.jss.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Replace rule, run plugins.
	   */
	  ;
	
	  _proto.replaceRule = function replaceRule(name, style, options) {
	    var newRule = this.rules.replace(name, style, options);
	    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
	    return newRule;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    if (options === void 0) {
	      options = defaultToStringOptions;
	    }
	
	    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
	        linebreak = _getWhitespaceSymbols.linebreak;
	
	    if (options.indent == null) options.indent = defaultToStringOptions.indent;
	    if (options.children == null) options.children = defaultToStringOptions.children;
	
	    if (options.children === false) {
	      return this.query + " {}";
	    }
	
	    var children = this.rules.toString(options);
	    return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
	  };
	
	  return ConditionalRule;
	}();
	var keyRegExp = /@container|@media|@supports\s+/;
	var pluginConditionalRule = {
	  onCreateRule: function onCreateRule(key, styles, options) {
	    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
	  }
	};
	
	var defaultToStringOptions$1 = {
	  indent: 1,
	  children: true
	};
	var nameRegExp = /@keyframes\s+([\w-]+)/;
	/**
	 * Rule for @keyframes
	 */
	
	var KeyframesRule =
	/*#__PURE__*/
	function () {
	  function KeyframesRule(key, frames, options) {
	    this.type = 'keyframes';
	    this.at = '@keyframes';
	    this.isProcessed = false;
	    var nameMatch = key.match(nameRegExp);
	
	    if (nameMatch && nameMatch[1]) {
	      this.name = nameMatch[1];
	    } else {
	      this.name = 'noname';
	       false ? warning__default['default'](false, "[JSS] Bad keyframes name " + key) : void 0;
	    }
	
	    this.key = this.type + "-" + this.name;
	    this.options = options;
	    var scoped = options.scoped,
	        sheet = options.sheet,
	        generateId = options.generateId;
	    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
	    this.rules = new RuleList(_extends__default['default']({}, options, {
	      parent: this
	    }));
	
	    for (var name in frames) {
	      this.rules.add(name, frames[name], _extends__default['default']({}, options, {
	        parent: this
	      }));
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = KeyframesRule.prototype;
	
	  _proto.toString = function toString(options) {
	    if (options === void 0) {
	      options = defaultToStringOptions$1;
	    }
	
	    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
	        linebreak = _getWhitespaceSymbols.linebreak;
	
	    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
	    if (options.children == null) options.children = defaultToStringOptions$1.children;
	
	    if (options.children === false) {
	      return this.at + " " + this.id + " {}";
	    }
	
	    var children = this.rules.toString(options);
	    if (children) children = "" + linebreak + children + linebreak;
	    return this.at + " " + this.id + " {" + children + "}";
	  };
	
	  return KeyframesRule;
	}();
	var keyRegExp$1 = /@keyframes\s+/;
	var refRegExp = /\$([\w-]+)/g;
	
	var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
	  if (typeof val === 'string') {
	    return val.replace(refRegExp, function (match, name) {
	      if (name in keyframes) {
	        return keyframes[name];
	      }
	
	       false ? warning__default['default'](false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
	      return match;
	    });
	  }
	
	  return val;
	};
	/**
	 * Replace the reference for a animation name.
	 */
	
	
	var replaceRef = function replaceRef(style, prop, keyframes) {
	  var value = style[prop];
	  var refKeyframe = findReferencedKeyframe(value, keyframes);
	
	  if (refKeyframe !== value) {
	    style[prop] = refKeyframe;
	  }
	};
	
	var pluginKeyframesRule = {
	  onCreateRule: function onCreateRule(key, frames, options) {
	    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
	  },
	  // Animation name ref replacer.
	  onProcessStyle: function onProcessStyle(style, rule, sheet) {
	    if (rule.type !== 'style' || !sheet) return style;
	    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
	    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
	    return style;
	  },
	  onChangeValue: function onChangeValue(val, prop, rule) {
	    var sheet = rule.options.sheet;
	
	    if (!sheet) {
	      return val;
	    }
	
	    switch (prop) {
	      case 'animation':
	        return findReferencedKeyframe(val, sheet.keyframes);
	
	      case 'animation-name':
	        return findReferencedKeyframe(val, sheet.keyframes);
	
	      default:
	        return val;
	    }
	  }
	};
	
	var KeyframeRule =
	/*#__PURE__*/
	function (_BaseStyleRule) {
	  _inheritsLoose__default['default'](KeyframeRule, _BaseStyleRule);
	
	  function KeyframeRule() {
	    return _BaseStyleRule.apply(this, arguments) || this;
	  }
	
	  var _proto = KeyframeRule.prototype;
	
	  /**
	   * Generates a CSS string.
	   */
	  _proto.toString = function toString(options) {
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	    var opts = link ? _extends__default['default']({}, options, {
	      allowEmpty: true
	    }) : options;
	    return toCss(this.key, this.style, opts);
	  };
	
	  return KeyframeRule;
	}(BaseStyleRule);
	var pluginKeyframeRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    if (options.parent && options.parent.type === 'keyframes') {
	      return new KeyframeRule(key, style, options);
	    }
	
	    return null;
	  }
	};
	
	var FontFaceRule =
	/*#__PURE__*/
	function () {
	  function FontFaceRule(key, style, options) {
	    this.type = 'font-face';
	    this.at = '@font-face';
	    this.isProcessed = false;
	    this.key = key;
	    this.style = style;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = FontFaceRule.prototype;
	
	  _proto.toString = function toString(options) {
	    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
	        linebreak = _getWhitespaceSymbols.linebreak;
	
	    if (Array.isArray(this.style)) {
	      var str = '';
	
	      for (var index = 0; index < this.style.length; index++) {
	        str += toCss(this.at, this.style[index]);
	        if (this.style[index + 1]) str += linebreak;
	      }
	
	      return str;
	    }
	
	    return toCss(this.at, this.style, options);
	  };
	
	  return FontFaceRule;
	}();
	var keyRegExp$2 = /@font-face/;
	var pluginFontFaceRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
	  }
	};
	
	var ViewportRule =
	/*#__PURE__*/
	function () {
	  function ViewportRule(key, style, options) {
	    this.type = 'viewport';
	    this.at = '@viewport';
	    this.isProcessed = false;
	    this.key = key;
	    this.style = style;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = ViewportRule.prototype;
	
	  _proto.toString = function toString(options) {
	    return toCss(this.key, this.style, options);
	  };
	
	  return ViewportRule;
	}();
	var pluginViewportRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
	  }
	};
	
	var SimpleRule =
	/*#__PURE__*/
	function () {
	  function SimpleRule(key, value, options) {
	    this.type = 'simple';
	    this.isProcessed = false;
	    this.key = key;
	    this.value = value;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  // eslint-disable-next-line no-unused-vars
	
	
	  var _proto = SimpleRule.prototype;
	
	  _proto.toString = function toString(options) {
	    if (Array.isArray(this.value)) {
	      var str = '';
	
	      for (var index = 0; index < this.value.length; index++) {
	        str += this.key + " " + this.value[index] + ";";
	        if (this.value[index + 1]) str += '\n';
	      }
	
	      return str;
	    }
	
	    return this.key + " " + this.value + ";";
	  };
	
	  return SimpleRule;
	}();
	var keysMap = {
	  '@charset': true,
	  '@import': true,
	  '@namespace': true
	};
	var pluginSimpleRule = {
	  onCreateRule: function onCreateRule(key, value, options) {
	    return key in keysMap ? new SimpleRule(key, value, options) : null;
	  }
	};
	
	var plugins = [pluginStyleRule, pluginConditionalRule, pluginKeyframesRule, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];
	
	var defaultUpdateOptions = {
	  process: true
	};
	var forceUpdateOptions = {
	  force: true,
	  process: true
	  /**
	   * Contains rules objects and allows adding/removing etc.
	   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
	   */
	
	};
	
	var RuleList =
	/*#__PURE__*/
	function () {
	  // Rules registry for access by .get() method.
	  // It contains the same rule registered by name and by selector.
	  // Original styles object.
	  // Used to ensure correct rules order.
	  function RuleList(options) {
	    this.map = {};
	    this.raw = {};
	    this.index = [];
	    this.counter = 0;
	    this.options = options;
	    this.classes = options.classes;
	    this.keyframes = options.keyframes;
	  }
	  /**
	   * Create and register rule.
	   *
	   * Will not render after Style Sheet was rendered the first time.
	   */
	
	
	  var _proto = RuleList.prototype;
	
	  _proto.add = function add(name, decl, ruleOptions) {
	    var _this$options = this.options,
	        parent = _this$options.parent,
	        sheet = _this$options.sheet,
	        jss = _this$options.jss,
	        Renderer = _this$options.Renderer,
	        generateId = _this$options.generateId,
	        scoped = _this$options.scoped;
	
	    var options = _extends__default['default']({
	      classes: this.classes,
	      parent: parent,
	      sheet: sheet,
	      jss: jss,
	      Renderer: Renderer,
	      generateId: generateId,
	      scoped: scoped,
	      name: name,
	      keyframes: this.keyframes,
	      selector: undefined
	    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
	    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
	    // we need to make the key unique within this RuleList instance scope.
	
	
	    var key = name;
	
	    if (name in this.raw) {
	      key = name + "-d" + this.counter++;
	    } // We need to save the original decl before creating the rule
	    // because cache plugin needs to use it as a key to return a cached rule.
	
	
	    this.raw[key] = decl;
	
	    if (key in this.classes) {
	      // E.g. rules inside of @media container
	      options.selector = "." + escape(this.classes[key]);
	    }
	
	    var rule = createRule(key, decl, options);
	    if (!rule) return null;
	    this.register(rule);
	    var index = options.index === undefined ? this.index.length : options.index;
	    this.index.splice(index, 0, rule);
	    return rule;
	  }
	  /**
	   * Replace rule.
	   * Create a new rule and remove old one instead of overwriting
	   * because we want to invoke onCreateRule hook to make plugins work.
	   */
	  ;
	
	  _proto.replace = function replace(name, decl, ruleOptions) {
	    var oldRule = this.get(name);
	    var oldIndex = this.index.indexOf(oldRule);
	
	    if (oldRule) {
	      this.remove(oldRule);
	    }
	
	    var options = ruleOptions;
	    if (oldIndex !== -1) options = _extends__default['default']({}, ruleOptions, {
	      index: oldIndex
	    });
	    return this.add(name, decl, options);
	  }
	  /**
	   * Get a rule by name or selector.
	   */
	  ;
	
	  _proto.get = function get(nameOrSelector) {
	    return this.map[nameOrSelector];
	  }
	  /**
	   * Delete a rule.
	   */
	  ;
	
	  _proto.remove = function remove(rule) {
	    this.unregister(rule);
	    delete this.raw[rule.key];
	    this.index.splice(this.index.indexOf(rule), 1);
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.index.indexOf(rule);
	  }
	  /**
	   * Run `onProcessRule()` plugins on every rule.
	   */
	  ;
	
	  _proto.process = function process() {
	    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
	    // we end up with very hard-to-track-down side effects.
	
	    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
	  }
	  /**
	   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
	   */
	  ;
	
	  _proto.register = function register(rule) {
	    this.map[rule.key] = rule;
	
	    if (rule instanceof StyleRule) {
	      this.map[rule.selector] = rule;
	      if (rule.id) this.classes[rule.key] = rule.id;
	    } else if (rule instanceof KeyframesRule && this.keyframes) {
	      this.keyframes[rule.name] = rule.id;
	    }
	  }
	  /**
	   * Unregister a rule.
	   */
	  ;
	
	  _proto.unregister = function unregister(rule) {
	    delete this.map[rule.key];
	
	    if (rule instanceof StyleRule) {
	      delete this.map[rule.selector];
	      delete this.classes[rule.key];
	    } else if (rule instanceof KeyframesRule) {
	      delete this.keyframes[rule.name];
	    }
	  }
	  /**
	   * Update the function values with a new data.
	   */
	  ;
	
	  _proto.update = function update() {
	    var name;
	    var data;
	    var options;
	
	    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
	      name = arguments.length <= 0 ? undefined : arguments[0];
	      data = arguments.length <= 1 ? undefined : arguments[1];
	      options = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      data = arguments.length <= 0 ? undefined : arguments[0];
	      options = arguments.length <= 1 ? undefined : arguments[1];
	      name = null;
	    }
	
	    if (name) {
	      this.updateOne(this.get(name), data, options);
	    } else {
	      for (var index = 0; index < this.index.length; index++) {
	        this.updateOne(this.index[index], data, options);
	      }
	    }
	  }
	  /**
	   * Execute plugins, update rule props.
	   */
	  ;
	
	  _proto.updateOne = function updateOne(rule, data, options) {
	    if (options === void 0) {
	      options = defaultUpdateOptions;
	    }
	
	    var _this$options2 = this.options,
	        plugins = _this$options2.jss.plugins,
	        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
	
	    if (rule.rules instanceof RuleList) {
	      rule.rules.update(data, options);
	      return;
	    }
	
	    var style = rule.style;
	    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
	
	    if (options.process && style && style !== rule.style) {
	      // We need to run the plugins in case new `style` relies on syntax plugins.
	      plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
	
	      for (var prop in rule.style) {
	        var nextValue = rule.style[prop];
	        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
	        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
	
	        if (nextValue !== prevValue) {
	          rule.prop(prop, nextValue, forceUpdateOptions);
	        }
	      } // Remove props.
	
	
	      for (var _prop in style) {
	        var _nextValue = rule.style[_prop];
	        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
	        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
	
	        if (_nextValue == null && _nextValue !== _prevValue) {
	          rule.prop(_prop, null, forceUpdateOptions);
	        }
	      }
	    }
	  }
	  /**
	   * Convert rules to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    var str = '';
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	
	    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
	        linebreak = _getWhitespaceSymbols.linebreak;
	
	    for (var index = 0; index < this.index.length; index++) {
	      var rule = this.index[index];
	      var css = rule.toString(options); // No need to render an empty rule.
	
	      if (!css && !link) continue;
	      if (str) str += linebreak;
	      str += css;
	    }
	
	    return str;
	  };
	
	  return RuleList;
	}();
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(styles, options) {
	    this.attached = false;
	    this.deployed = false;
	    this.classes = {};
	    this.keyframes = {};
	    this.options = _extends__default['default']({}, options, {
	      sheet: this,
	      parent: this,
	      classes: this.classes,
	      keyframes: this.keyframes
	    });
	
	    if (options.Renderer) {
	      this.renderer = new options.Renderer(this);
	    }
	
	    this.rules = new RuleList(this.options);
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Attach renderable to the render tree.
	   */
	
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.attach = function attach() {
	    if (this.attached) return this;
	    if (this.renderer) this.renderer.attach();
	    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
	
	    if (!this.deployed) this.deploy();
	    return this;
	  }
	  /**
	   * Remove renderable from render tree.
	   */
	  ;
	
	  _proto.detach = function detach() {
	    if (!this.attached) return this;
	    if (this.renderer) this.renderer.detach();
	    this.attached = false;
	    return this;
	  }
	  /**
	   * Add a rule to the current stylesheet.
	   * Will insert a rule also after the stylesheet has been rendered first time.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, decl, options) {
	    var queue = this.queue; // Plugins can create rules.
	    // In order to preserve the right order, we need to queue all `.addRule` calls,
	    // which happen after the first `rules.add()` call.
	
	    if (this.attached && !queue) this.queue = [];
	    var rule = this.rules.add(name, decl, options);
	    if (!rule) return null;
	    this.options.jss.plugins.onProcessRule(rule);
	
	    if (this.attached) {
	      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
	      // It will be inserted all together when .attach is called.
	
	      if (queue) queue.push(rule);else {
	        this.insertRule(rule);
	
	        if (this.queue) {
	          this.queue.forEach(this.insertRule, this);
	          this.queue = undefined;
	        }
	      }
	      return rule;
	    } // We can't add rules to a detached style node.
	    // We will redeploy the sheet once user will attach it.
	
	
	    this.deployed = false;
	    return rule;
	  }
	  /**
	   * Replace a rule in the current stylesheet.
	   */
	  ;
	
	  _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
	    var oldRule = this.rules.get(nameOrSelector);
	    if (!oldRule) return this.addRule(nameOrSelector, decl, options);
	    var newRule = this.rules.replace(nameOrSelector, decl, options);
	
	    if (newRule) {
	      this.options.jss.plugins.onProcessRule(newRule);
	    }
	
	    if (this.attached) {
	      if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
	      // It will be inserted all together when .attach is called.
	
	      if (this.renderer) {
	        if (!newRule) {
	          this.renderer.deleteRule(oldRule);
	        } else if (oldRule.renderable) {
	          this.renderer.replaceRule(oldRule.renderable, newRule);
	        }
	      }
	
	      return newRule;
	    } // We can't replace rules to a detached style node.
	    // We will redeploy the sheet once user will attach it.
	
	
	    this.deployed = false;
	    return newRule;
	  }
	  /**
	   * Insert rule into the StyleSheet
	   */
	  ;
	
	  _proto.insertRule = function insertRule(rule) {
	    if (this.renderer) {
	      this.renderer.insertRule(rule);
	    }
	  }
	  /**
	   * Create and add rules.
	   * Will render also after Style Sheet was rendered the first time.
	   */
	  ;
	
	  _proto.addRules = function addRules(styles, options) {
	    var added = [];
	
	    for (var name in styles) {
	      var rule = this.addRule(name, styles[name], options);
	      if (rule) added.push(rule);
	    }
	
	    return added;
	  }
	  /**
	   * Get a rule by name or selector.
	   */
	  ;
	
	  _proto.getRule = function getRule(nameOrSelector) {
	    return this.rules.get(nameOrSelector);
	  }
	  /**
	   * Delete a rule by name.
	   * Returns `true`: if rule has been deleted from the DOM.
	   */
	  ;
	
	  _proto.deleteRule = function deleteRule(name) {
	    var rule = typeof name === 'object' ? name : this.rules.get(name);
	
	    if (!rule || // Style sheet was created without link: true and attached, in this case we
	    // won't be able to remove the CSS rule from the DOM.
	    this.attached && !rule.renderable) {
	      return false;
	    }
	
	    this.rules.remove(rule);
	
	    if (this.attached && rule.renderable && this.renderer) {
	      return this.renderer.deleteRule(rule.renderable);
	    }
	
	    return true;
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Deploy pure CSS string to a renderable.
	   */
	  ;
	
	  _proto.deploy = function deploy() {
	    if (this.renderer) this.renderer.deploy();
	    this.deployed = true;
	    return this;
	  }
	  /**
	   * Update the function values with a new data.
	   */
	  ;
	
	  _proto.update = function update() {
	    var _this$rules;
	
	    (_this$rules = this.rules).update.apply(_this$rules, arguments);
	
	    return this;
	  }
	  /**
	   * Updates a single rule.
	   */
	  ;
	
	  _proto.updateOne = function updateOne(rule, data, options) {
	    this.rules.updateOne(rule, data, options);
	    return this;
	  }
	  /**
	   * Convert rules to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    return this.rules.toString(options);
	  };
	
	  return StyleSheet;
	}();
	
	var PluginsRegistry =
	/*#__PURE__*/
	function () {
	  function PluginsRegistry() {
	    this.plugins = {
	      internal: [],
	      external: []
	    };
	    this.registry = {};
	  }
	
	  var _proto = PluginsRegistry.prototype;
	
	  /**
	   * Call `onCreateRule` hooks and return an object if returned by a hook.
	   */
	  _proto.onCreateRule = function onCreateRule(name, decl, options) {
	    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
	      var rule = this.registry.onCreateRule[i](name, decl, options);
	      if (rule) return rule;
	    }
	
	    return null;
	  }
	  /**
	   * Call `onProcessRule` hooks.
	   */
	  ;
	
	  _proto.onProcessRule = function onProcessRule(rule) {
	    if (rule.isProcessed) return;
	    var sheet = rule.options.sheet;
	
	    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
	      this.registry.onProcessRule[i](rule, sheet);
	    }
	
	    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
	    rule.isProcessed = true;
	  }
	  /**
	   * Call `onProcessStyle` hooks.
	   */
	  ;
	
	  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
	    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
	      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
	    }
	  }
	  /**
	   * Call `onProcessSheet` hooks.
	   */
	  ;
	
	  _proto.onProcessSheet = function onProcessSheet(sheet) {
	    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
	      this.registry.onProcessSheet[i](sheet);
	    }
	  }
	  /**
	   * Call `onUpdate` hooks.
	   */
	  ;
	
	  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
	    for (var i = 0; i < this.registry.onUpdate.length; i++) {
	      this.registry.onUpdate[i](data, rule, sheet, options);
	    }
	  }
	  /**
	   * Call `onChangeValue` hooks.
	   */
	  ;
	
	  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
	    var processedValue = value;
	
	    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
	      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
	    }
	
	    return processedValue;
	  }
	  /**
	   * Register a plugin.
	   */
	  ;
	
	  _proto.use = function use(newPlugin, options) {
	    if (options === void 0) {
	      options = {
	        queue: 'external'
	      };
	    }
	
	    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
	
	    if (plugins.indexOf(newPlugin) !== -1) {
	      return;
	    }
	
	    plugins.push(newPlugin);
	    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
	      for (var name in plugin) {
	        if (name in registry) {
	          registry[name].push(plugin[name]);
	        } else {
	           false ? warning__default['default'](false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
	        }
	      }
	
	      return registry;
	    }, {
	      onCreateRule: [],
	      onProcessRule: [],
	      onProcessStyle: [],
	      onProcessSheet: [],
	      onChangeValue: [],
	      onUpdate: []
	    });
	  };
	
	  return PluginsRegistry;
	}();
	
	/**
	 * Sheets registry to access all instances in one place.
	 */
	
	var SheetsRegistry =
	/*#__PURE__*/
	function () {
	  function SheetsRegistry() {
	    this.registry = [];
	  }
	
	  var _proto = SheetsRegistry.prototype;
	
	  /**
	   * Register a Style Sheet.
	   */
	  _proto.add = function add(sheet) {
	    var registry = this.registry;
	    var index = sheet.options.index;
	    if (registry.indexOf(sheet) !== -1) return;
	
	    if (registry.length === 0 || index >= this.index) {
	      registry.push(sheet);
	      return;
	    } // Find a position.
	
	
	    for (var i = 0; i < registry.length; i++) {
	      if (registry[i].options.index > index) {
	        registry.splice(i, 0, sheet);
	        return;
	      }
	    }
	  }
	  /**
	   * Reset the registry.
	   */
	  ;
	
	  _proto.reset = function reset() {
	    this.registry = [];
	  }
	  /**
	   * Remove a Style Sheet.
	   */
	  ;
	
	  _proto.remove = function remove(sheet) {
	    var index = this.registry.indexOf(sheet);
	    this.registry.splice(index, 1);
	  }
	  /**
	   * Convert all attached sheets to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(_temp) {
	    var _ref = _temp === void 0 ? {} : _temp,
	        attached = _ref.attached,
	        options = _objectWithoutPropertiesLoose__default['default'](_ref, ["attached"]);
	
	    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
	        linebreak = _getWhitespaceSymbols.linebreak;
	
	    var css = '';
	
	    for (var i = 0; i < this.registry.length; i++) {
	      var sheet = this.registry[i];
	
	      if (attached != null && sheet.attached !== attached) {
	        continue;
	      }
	
	      if (css) css += linebreak;
	      css += sheet.toString(options);
	    }
	
	    return css;
	  };
	
	  _createClass__default['default'](SheetsRegistry, [{
	    key: "index",
	
	    /**
	     * Current highest index number.
	     */
	    get: function get() {
	      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
	    }
	  }]);
	
	  return SheetsRegistry;
	}();
	
	/**
	 * This is a global sheets registry. Only DomRenderer will add sheets to it.
	 * On the server one should use an own SheetsRegistry instance and add the
	 * sheets to it, because you need to make sure to create a new registry for
	 * each request in order to not leak sheets across requests.
	 */
	
	var sheets = new SheetsRegistry();
	
	/* eslint-disable */
	
	/**
	 * Now that `globalThis` is available on most platforms
	 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
	 * we check for `globalThis` first. `globalThis` is necessary for jss
	 * to run in Agoric's secure version of JavaScript (SES). Under SES,
	 * `globalThis` exists, but `window`, `self`, and `Function('return
	 * this')()` are all undefined for security reasons.
	 *
	 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	 */
	var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();
	
	var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
	if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
	// the current version with just one short number and use it for classes generation
	// we use a counter. Also it is more accurate, because user can manually reevaluate
	// the module.
	
	var moduleId = globalThis$1[ns]++;
	
	var maxRules = 1e10;
	/**
	 * Returns a function which generates unique class names based on counters.
	 * When new generator function is created, rule counter is reseted.
	 * We need to reset the rule counter for SSR for each request.
	 */
	
	var createGenerateId = function createGenerateId(options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var ruleCounter = 0;
	
	  var generateId = function generateId(rule, sheet) {
	    ruleCounter += 1;
	
	    if (ruleCounter > maxRules) {
	       false ? warning__default['default'](false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
	    }
	
	    var jssId = '';
	    var prefix = '';
	
	    if (sheet) {
	      if (sheet.options.classNamePrefix) {
	        prefix = sheet.options.classNamePrefix;
	      }
	
	      if (sheet.options.jss.id != null) {
	        jssId = String(sheet.options.jss.id);
	      }
	    }
	
	    if (options.minify) {
	      // Using "c" because a number can't be the first char in a class name.
	      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
	    }
	
	    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
	  };
	
	  return generateId;
	};
	
	/**
	 * Cache the value from the first time a function is called.
	 */
	
	var memoize = function memoize(fn) {
	  var value;
	  return function () {
	    if (!value) value = fn();
	    return value;
	  };
	};
	/**
	 * Get a style property value.
	 */
	
	
	var getPropertyValue = function getPropertyValue(cssRule, prop) {
	  try {
	    // Support CSSTOM.
	    if (cssRule.attributeStyleMap) {
	      return cssRule.attributeStyleMap.get(prop);
	    }
	
	    return cssRule.style.getPropertyValue(prop);
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return '';
	  }
	};
	/**
	 * Set a style property.
	 */
	
	
	var setProperty = function setProperty(cssRule, prop, value) {
	  try {
	    var cssValue = value;
	
	    if (Array.isArray(value)) {
	      cssValue = toCssValue(value);
	    } // Support CSSTOM.
	
	
	    if (cssRule.attributeStyleMap) {
	      cssRule.attributeStyleMap.set(prop, cssValue);
	    } else {
	      var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
	      var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
	      cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
	    }
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return false;
	  }
	
	  return true;
	};
	/**
	 * Remove a style property.
	 */
	
	
	var removeProperty = function removeProperty(cssRule, prop) {
	  try {
	    // Support CSSTOM.
	    if (cssRule.attributeStyleMap) {
	      cssRule.attributeStyleMap.delete(prop);
	    } else {
	      cssRule.style.removeProperty(prop);
	    }
	  } catch (err) {
	     false ? warning__default['default'](false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
	  }
	};
	/**
	 * Set the selector.
	 */
	
	
	var setSelector = function setSelector(cssRule, selectorText) {
	  cssRule.selectorText = selectorText; // Return false if setter was not successful.
	  // Currently works in chrome only.
	
	  return cssRule.selectorText === selectorText;
	};
	/**
	 * Gets the `head` element upon the first call and caches it.
	 * We assume it can't be null.
	 */
	
	
	var getHead = memoize(function () {
	  return document.querySelector('head');
	});
	/**
	 * Find attached sheet with an index higher than the passed one.
	 */
	
	function findHigherSheet(registry, options) {
	  for (var i = 0; i < registry.length; i++) {
	    var sheet = registry[i];
	
	    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	
	  return null;
	}
	/**
	 * Find attached sheet with the highest index.
	 */
	
	
	function findHighestSheet(registry, options) {
	  for (var i = registry.length - 1; i >= 0; i--) {
	    var sheet = registry[i];
	
	    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	
	  return null;
	}
	/**
	 * Find a comment with "jss" inside.
	 */
	
	
	function findCommentNode(text) {
	  var head = getHead();
	
	  for (var i = 0; i < head.childNodes.length; i++) {
	    var node = head.childNodes[i];
	
	    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
	      return node;
	    }
	  }
	
	  return null;
	}
	/**
	 * Find a node before which we can insert the sheet.
	 */
	
	
	function findPrevNode(options) {
	  var registry = sheets.registry;
	
	  if (registry.length > 0) {
	    // Try to insert before the next higher sheet.
	    var sheet = findHigherSheet(registry, options);
	
	    if (sheet && sheet.renderer) {
	      return {
	        parent: sheet.renderer.element.parentNode,
	        node: sheet.renderer.element
	      };
	    } // Otherwise insert after the last attached.
	
	
	    sheet = findHighestSheet(registry, options);
	
	    if (sheet && sheet.renderer) {
	      return {
	        parent: sheet.renderer.element.parentNode,
	        node: sheet.renderer.element.nextSibling
	      };
	    }
	  } // Try to find a comment placeholder if registry is empty.
	
	
	  var insertionPoint = options.insertionPoint;
	
	  if (insertionPoint && typeof insertionPoint === 'string') {
	    var comment = findCommentNode(insertionPoint);
	
	    if (comment) {
	      return {
	        parent: comment.parentNode,
	        node: comment.nextSibling
	      };
	    } // If user specifies an insertion point and it can't be found in the document -
	    // bad specificity issues may appear.
	
	
	     false ? warning__default['default'](false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
	  }
	
	  return false;
	}
	/**
	 * Insert style element into the DOM.
	 */
	
	
	function insertStyle(style, options) {
	  var insertionPoint = options.insertionPoint;
	  var nextNode = findPrevNode(options);
	
	  if (nextNode !== false && nextNode.parent) {
	    nextNode.parent.insertBefore(style, nextNode.node);
	    return;
	  } // Works with iframes and any node types.
	
	
	  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
	    var insertionPointElement = insertionPoint;
	    var parentNode = insertionPointElement.parentNode;
	    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else  false ? warning__default['default'](false, '[JSS] Insertion point is not in the DOM.') : void 0;
	    return;
	  }
	
	  getHead().appendChild(style);
	}
	/**
	 * Read jss nonce setting from the page if the user has set it.
	 */
	
	
	var getNonce = memoize(function () {
	  var node = document.querySelector('meta[property="csp-nonce"]');
	  return node ? node.getAttribute('content') : null;
	});
	
	var _insertRule = function insertRule(container, rule, index) {
	  try {
	    if ('insertRule' in container) {
	      container.insertRule(rule, index);
	    } // Keyframes rule.
	    else if ('appendRule' in container) {
	        container.appendRule(rule);
	      }
	  } catch (err) {
	     false ? warning__default['default'](false, "[JSS] " + err.message) : void 0;
	    return false;
	  }
	
	  return container.cssRules[index];
	};
	
	var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
	  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
	
	  if (index === undefined || index > maxIndex) {
	    // eslint-disable-next-line no-param-reassign
	    return maxIndex;
	  }
	
	  return index;
	};
	
	var createStyle = function createStyle() {
	  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
	  // insert rules after we insert the style tag.
	  // It seems to kick-off the source order specificity algorithm.
	
	  el.textContent = '\n';
	  return el;
	};
	
	var DomRenderer =
	/*#__PURE__*/
	function () {
	  // Will be empty if link: true option is not set, because
	  // it is only for use together with insertRule API.
	  function DomRenderer(sheet) {
	    this.getPropertyValue = getPropertyValue;
	    this.setProperty = setProperty;
	    this.removeProperty = removeProperty;
	    this.setSelector = setSelector;
	    this.hasInsertedRules = false;
	    this.cssRules = [];
	    // There is no sheet when the renderer is used from a standalone StyleRule.
	    if (sheet) sheets.add(sheet);
	    this.sheet = sheet;
	
	    var _ref = this.sheet ? this.sheet.options : {},
	        media = _ref.media,
	        meta = _ref.meta,
	        element = _ref.element;
	
	    this.element = element || createStyle();
	    this.element.setAttribute('data-jss', '');
	    if (media) this.element.setAttribute('media', media);
	    if (meta) this.element.setAttribute('data-meta', meta);
	    var nonce = getNonce();
	    if (nonce) this.element.setAttribute('nonce', nonce);
	  }
	  /**
	   * Insert style element into render tree.
	   */
	
	
	  var _proto = DomRenderer.prototype;
	
	  _proto.attach = function attach() {
	    // In the case the element node is external and it is already in the DOM.
	    if (this.element.parentNode || !this.sheet) return;
	    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
	    // most browsers create a new CSSStyleSheet, except of all IEs.
	
	    var deployed = Boolean(this.sheet && this.sheet.deployed);
	
	    if (this.hasInsertedRules && deployed) {
	      this.hasInsertedRules = false;
	      this.deploy();
	    }
	  }
	  /**
	   * Remove style element from render tree.
	   */
	  ;
	
	  _proto.detach = function detach() {
	    if (!this.sheet) return;
	    var parentNode = this.element.parentNode;
	    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
	    // Though IE will keep them and we need a consistent behavior.
	
	    if (this.sheet.options.link) {
	      this.cssRules = [];
	      this.element.textContent = '\n';
	    }
	  }
	  /**
	   * Inject CSS string into element.
	   */
	  ;
	
	  _proto.deploy = function deploy() {
	    var sheet = this.sheet;
	    if (!sheet) return;
	
	    if (sheet.options.link) {
	      this.insertRules(sheet.rules);
	      return;
	    }
	
	    this.element.textContent = "\n" + sheet.toString() + "\n";
	  }
	  /**
	   * Insert RuleList into an element.
	   */
	  ;
	
	  _proto.insertRules = function insertRules(rules, nativeParent) {
	    for (var i = 0; i < rules.index.length; i++) {
	      this.insertRule(rules.index[i], i, nativeParent);
	    }
	  }
	  /**
	   * Insert a rule into element.
	   */
	  ;
	
	  _proto.insertRule = function insertRule(rule, index, nativeParent) {
	    if (nativeParent === void 0) {
	      nativeParent = this.element.sheet;
	    }
	
	    if (rule.rules) {
	      var parent = rule;
	      var latestNativeParent = nativeParent;
	
	      if (rule.type === 'conditional' || rule.type === 'keyframes') {
	        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
	
	
	        latestNativeParent = _insertRule(nativeParent, parent.toString({
	          children: false
	        }), _insertionIndex);
	
	        if (latestNativeParent === false) {
	          return false;
	        }
	
	        this.refCssRule(rule, _insertionIndex, latestNativeParent);
	      }
	
	      this.insertRules(parent.rules, latestNativeParent);
	      return latestNativeParent;
	    }
	
	    var ruleStr = rule.toString();
	    if (!ruleStr) return false;
	    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
	
	    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
	
	    if (nativeRule === false) {
	      return false;
	    }
	
	    this.hasInsertedRules = true;
	    this.refCssRule(rule, insertionIndex, nativeRule);
	    return nativeRule;
	  };
	
	  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
	    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
	    // like rules inside media queries or keyframes
	
	    if (rule.options.parent instanceof StyleSheet) {
	      this.cssRules.splice(index, 0, cssRule);
	    }
	  }
	  /**
	   * Delete a rule.
	   */
	  ;
	
	  _proto.deleteRule = function deleteRule(cssRule) {
	    var sheet = this.element.sheet;
	    var index = this.indexOf(cssRule);
	    if (index === -1) return false;
	    sheet.deleteRule(index);
	    this.cssRules.splice(index, 1);
	    return true;
	  }
	  /**
	   * Get index of a CSS Rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(cssRule) {
	    return this.cssRules.indexOf(cssRule);
	  }
	  /**
	   * Generate a new CSS rule and replace the existing one.
	   */
	  ;
	
	  _proto.replaceRule = function replaceRule(cssRule, rule) {
	    var index = this.indexOf(cssRule);
	    if (index === -1) return false;
	    this.element.sheet.deleteRule(index);
	    this.cssRules.splice(index, 1);
	    return this.insertRule(rule, index);
	  }
	  /**
	   * Get all rules elements.
	   */
	  ;
	
	  _proto.getRules = function getRules() {
	    return this.element.sheet.cssRules;
	  };
	
	  return DomRenderer;
	}();
	
	var instanceCounter = 0;
	
	var Jss =
	/*#__PURE__*/
	function () {
	  function Jss(options) {
	    this.id = instanceCounter++;
	    this.version = "10.10.0";
	    this.plugins = new PluginsRegistry();
	    this.options = {
	      id: {
	        minify: false
	      },
	      createGenerateId: createGenerateId,
	      Renderer: isInBrowser__default['default'] ? DomRenderer : null,
	      plugins: []
	    };
	    this.generateId = createGenerateId({
	      minify: false
	    });
	
	    for (var i = 0; i < plugins.length; i++) {
	      this.plugins.use(plugins[i], {
	        queue: 'internal'
	      });
	    }
	
	    this.setup(options);
	  }
	  /**
	   * Prepares various options, applies plugins.
	   * Should not be used twice on the same instance, because there is no plugins
	   * deduplication logic.
	   */
	
	
	  var _proto = Jss.prototype;
	
	  _proto.setup = function setup(options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (options.createGenerateId) {
	      this.options.createGenerateId = options.createGenerateId;
	    }
	
	    if (options.id) {
	      this.options.id = _extends__default['default']({}, this.options.id, options.id);
	    }
	
	    if (options.createGenerateId || options.id) {
	      this.generateId = this.options.createGenerateId(this.options.id);
	    }
	
	    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
	
	    if ('Renderer' in options) {
	      this.options.Renderer = options.Renderer;
	    } // eslint-disable-next-line prefer-spread
	
	
	    if (options.plugins) this.use.apply(this, options.plugins);
	    return this;
	  }
	  /**
	   * Create a Style Sheet.
	   */
	  ;
	
	  _proto.createStyleSheet = function createStyleSheet(styles, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var _options = options,
	        index = _options.index;
	
	    if (typeof index !== 'number') {
	      index = sheets.index === 0 ? 0 : sheets.index + 1;
	    }
	
	    var sheet = new StyleSheet(styles, _extends__default['default']({}, options, {
	      jss: this,
	      generateId: options.generateId || this.generateId,
	      insertionPoint: this.options.insertionPoint,
	      Renderer: this.options.Renderer,
	      index: index
	    }));
	    this.plugins.onProcessSheet(sheet);
	    return sheet;
	  }
	  /**
	   * Detach the Style Sheet and remove it from the registry.
	   */
	  ;
	
	  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
	    sheet.detach();
	    sheets.remove(sheet);
	    return this;
	  }
	  /**
	   * Create a rule without a Style Sheet.
	   * [Deprecated] will be removed in the next major version.
	   */
	  ;
	
	  _proto.createRule = function createRule$1(name, style, options) {
	    if (style === void 0) {
	      style = {};
	    }
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    // Enable rule without name for inline styles.
	    if (typeof name === 'object') {
	      return this.createRule(undefined, name, style);
	    }
	
	    var ruleOptions = _extends__default['default']({}, options, {
	      name: name,
	      jss: this,
	      Renderer: this.options.Renderer
	    });
	
	    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
	    if (!ruleOptions.classes) ruleOptions.classes = {};
	    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
	
	    var rule = createRule(name, style, ruleOptions);
	
	    if (rule) this.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Register plugin. Passed function will be invoked with a rule instance.
	   */
	  ;
	
	  _proto.use = function use() {
	    var _this = this;
	
	    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
	      plugins[_key] = arguments[_key];
	    }
	
	    plugins.forEach(function (plugin) {
	      _this.plugins.use(plugin);
	    });
	    return this;
	  };
	
	  return Jss;
	}();
	
	var createJss = function createJss(options) {
	  return new Jss(options);
	};
	
	/**
	 * SheetsManager is like a WeakMap which is designed to count StyleSheet
	 * instances and attach/detach automatically.
	 * Used in react-jss.
	 */
	
	var SheetsManager =
	/*#__PURE__*/
	function () {
	  function SheetsManager() {
	    this.length = 0;
	    this.sheets = new WeakMap();
	  }
	
	  var _proto = SheetsManager.prototype;
	
	  _proto.get = function get(key) {
	    var entry = this.sheets.get(key);
	    return entry && entry.sheet;
	  };
	
	  _proto.add = function add(key, sheet) {
	    if (this.sheets.has(key)) return;
	    this.length++;
	    this.sheets.set(key, {
	      sheet: sheet,
	      refs: 0
	    });
	  };
	
	  _proto.manage = function manage(key) {
	    var entry = this.sheets.get(key);
	
	    if (entry) {
	      if (entry.refs === 0) {
	        entry.sheet.attach();
	      }
	
	      entry.refs++;
	      return entry.sheet;
	    }
	
	    warning__default['default'](false, "[JSS] SheetsManager: can't find sheet to manage");
	    return undefined;
	  };
	
	  _proto.unmanage = function unmanage(key) {
	    var entry = this.sheets.get(key);
	
	    if (entry) {
	      if (entry.refs > 0) {
	        entry.refs--;
	        if (entry.refs === 0) entry.sheet.detach();
	      }
	    } else {
	      warning__default['default'](false, "SheetsManager: can't find sheet to unmanage");
	    }
	  };
	
	  _createClass__default['default'](SheetsManager, [{
	    key: "size",
	    get: function get() {
	      return this.length;
	    }
	  }]);
	
	  return SheetsManager;
	}();
	
	/**
	* Export a constant indicating if this browser has CSSTOM support.
	* https://developers.google.com/web/updates/2018/03/cssom
	*/
	var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
	
	/**
	 * Extracts a styles object with only props that contain function values.
	 */
	function getDynamicStyles(styles) {
	  var to = null;
	
	  for (var key in styles) {
	    var value = styles[key];
	    var type = typeof value;
	
	    if (type === 'function') {
	      if (!to) to = {};
	      to[key] = value;
	    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
	      var extracted = getDynamicStyles(value);
	
	      if (extracted) {
	        if (!to) to = {};
	        to[key] = extracted;
	      }
	    }
	  }
	
	  return to;
	}
	
	/**
	 * A better abstraction over CSS.
	 *
	 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
	 * @website https://github.com/cssinjs/jss
	 * @license MIT
	 */
	var index = createJss();
	
	exports.RuleList = RuleList;
	exports.SheetsManager = SheetsManager;
	exports.SheetsRegistry = SheetsRegistry;
	exports.create = createJss;
	exports.createGenerateId = createGenerateId;
	exports.createRule = createRule;
	exports.default = index;
	exports.getDynamicStyles = getDynamicStyles;
	exports.hasCSSTOMSupport = hasCSSTOMSupport;
	exports.sheets = sheets;
	exports.toCssValue = toCssValue;


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(58);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(184),
	    createBaseEach = __webpack_require__(6815);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 100 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(6780),
	    getValue = __webpack_require__(6833);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(103);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(70),
	    isObjectLike = __webpack_require__(53);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoProducto = function CatalogoProducto(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtBuscar = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      records = _useState6[0],
	      setRecords = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    idproducto: "",
	    codigo: "",
	    nombre: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      values = _useState8[0],
	      setValues = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(-1),
	      _useState10 = _slicedToArray(_useState9, 2),
	      itemSelect = _useState10[0],
	      setItemSelect = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      filterFn = _useState12[0],
	      setFilterFn = _useState12[1];
	
	  var headCells = [{ label: "CODIGO", textAlign: "center" }, { label: "DESCRIPCION", textAlign: "center" }];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if ((x.codigo || "").toLowerCase().includes(target.value.toLowerCase()) || (x.nombre || "").toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "idproducto, codigo, trim(nombre) as nombre, trim(nombrecorto) as nombrecorto, ivaventa, utipreciomaxi, idunidadalterna, idunidadmedida";
	    var nomtab = "producto";
	    var nomid2 = "activo";
	    var nomid = "servicio";
	    var endpoint = void 0;
	
	    if (props.esservicio === "1") {
	      endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + true;
	    } else {
	      endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid2 + "&id=" + true;
	    }
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setItemSelect("");
	    setActivate(false);
	    setRecords([]);
	    setValues({
	      idproducto: "",
	      codigo: "",
	      nombre: "",
	      preciomax: "",
	      unidadalterna: "",
	      unidadmedida: ""
	    });
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var seleccionarProducto = function seleccionarProducto() {
	    if (values.codigo === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "Debe Seleccionar un Producto.",
	        icono: "informacion"
	      });
	    } else {
	      props.onHideAceptaCatalogo(values);
	    }
	  };
	
	  var seleccionarFila = function seleccionarFila(item) {
	    return function (e) {
	      e.preventDefault();
	
	      setValues({
	        idproducto: item.idproducto,
	        codigo: item.codigo,
	        nombre: item.nombre,
	        ivaventa: item.ivaventa,
	        nombrecorto: item.nombrecorto,
	        preciomax: item.utipreciomaxi,
	        unidadalterna: item.idunidadalterna,
	        unidadmedida: item.idunidadmedida
	      });
	      btnAcepta.current.focus();
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        seleccionarRegistros();
	        txtBuscar.current.focus();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          props.esservicio === "1" ? "Seleccionar Servicio" : "Seleccionar Producto"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-6 mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control fs-5 h-100 text-uppercase",
	              ref: txtBuscar
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  style: {
	                    padding: "0",
	                    cursor: "pointer",
	                    background: values.idproducto === item.idproducto ? "lightskyblue" : "white"
	                  },
	                  onClick: seleccionarFila(item)
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.codigo
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.nombre
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          style: { margin: "5px" },
	          onClick: seleccionarProducto
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoProducto;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoProductoExistencia = function CatalogoProductoExistencia(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtBuscar = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      records = _useState6[0],
	      setRecords = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    idproducto: "",
	    nombre: "",
	    idalmacen: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      values = _useState8[0],
	      setValues = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(-1),
	      _useState10 = _slicedToArray(_useState9, 2),
	      itemSelect = _useState10[0],
	      setItemSelect = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      filterFn = _useState12[0],
	      setFilterFn = _useState12[1];
	
	  var headCells = [{ label: "CODIGO", textAlign: "center" }, { label: "NOMBRE", textAlign: "center" }, { label: "ALMACEN", textAlign: "center" }, { label: "EXISTENCIA", textAlign: "center" }];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.idproducto.includes(target.value) || x.codigo.toLowerCase().includes(target.value.toLowerCase()) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.descripcion.toLowerCase().includes(target.value.toLowerCase()) || (0, _varios.formatMoneda)(x.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2).toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var endpoint = op.conexion + "/api/inventario/productoexisselectubi?idalmacen=" + props.idalmacen;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setItemSelect("");
	    setActivate(false);
	    setRecords([]);
	    setValues({
	      idproducto: "",
	      nombre: "",
	      idalmacen: ""
	    });
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var seleccionarProducto = function seleccionarProducto() {
	    props.onHideAceptaCatalogo(values);
	  };
	
	  var seleccionarFila = function seleccionarFila(item) {
	    return function (e) {
	      e.preventDefault();
	
	      setValues({
	        idproducto: item.idproducto,
	        codigo: item.codigo,
	        nombre: item.nombre,
	        idalmacen: item.idalmacen
	      });
	      btnAcepta.current.focus();
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        seleccionarRegistros();
	        txtBuscar.current.focus();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Seleccionar Productos"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-8 input-group-sm mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control border-azul border-2 text-uppercase",
	              ref: txtBuscar
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  style: {
	                    padding: "0",
	                    cursor: "pointer",
	                    background: values.idproducto + values.idalmacen === item.idproducto + item.idalmacen ? "lightskyblue" : "white"
	                  },
	                  onClick: seleccionarFila(item)
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.codigo
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.nombre
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.descripcion
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-right" },
	                  (0, _varios.formatMoneda)(item.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          onClick: seleccionarProducto
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoProductoExistencia;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AuthProvider = exports.AuthContext = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jwtDecode = __webpack_require__(6755);
	
	var _jwtDecode2 = _interopRequireDefault(_jwtDecode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  user: null
	};
	
	if (sessionStorage.getItem('jwtToken')) {
	  var decodedToken = (0, _jwtDecode2.default)(sessionStorage.getItem('jwtToken'));
	
	  if (decodedToken.exp * 1000 < Date.now()) {
	    sessionStorage.clear();
	  } else {
	    initialState.user = decodedToken;
	  }
	}
	
	var AuthContext = (0, _react.createContext)({
	  user: null,
	  login: function login(userData) {},
	  logout: function logout() {}
	});
	
	function authReducer(state, action) {
	  switch (action.type) {
	    case 'LOGIN':
	      return Object.assign({}, state, {
	        user: action.payload
	      });
	    case 'LOGOUT':
	      return Object.assign({}, state, {
	        user: null
	      });
	    default:
	      return state;
	  }
	}
	
	function AuthProvider(props) {
	  var _useReducer = (0, _react.useReducer)(authReducer, initialState),
	      _useReducer2 = _slicedToArray(_useReducer, 2),
	      state = _useReducer2[0],
	      dispatch = _useReducer2[1];
	
	  function login(userData) {
	    if (userData === null) {
	      sessionStorage.clear();
	      dispatch({ type: 'LOGOUT' });
	    } else {
	      sessionStorage.setItem('jwtToken', userData);
	
	      dispatch({
	        type: 'LOGIN',
	        payload: userData
	      });
	    }
	  }
	
	  function logout() {
	    sessionStorage.clear();
	    dispatch({ type: 'LOGOUT' });
	  }
	
	  return _react2.default.createElement(AuthContext.Provider, Object.assign({
	    value: { user: state.user, login: login, logout: logout }
	  }, props));
	}
	
	exports.AuthContext = AuthContext;
	exports.AuthProvider = AuthProvider;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(208);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(133));
	util.inherits = __webpack_require__(76);
	/*</replacement>*/
	
	var Readable = __webpack_require__(682);
	var Writable = __webpack_require__(305);
	
	util.inherits(Duplex, Readable);
	
	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  pna.nextTick(cb, err);
	};

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 109 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formControlState;
	
	function formControlState(_ref) {
	  var props = _ref.props,
	      states = _ref.states,
	      muiFormControl = _ref.muiFormControl;
	  return states.reduce(function (acc, state) {
	    acc[state] = props[state];
	
	    if (muiFormControl) {
	      if (typeof props[state] === 'undefined') {
	        acc[state] = muiFormControl[state];
	      }
	    }
	
	    return acc;
	  }, {});
	}

/***/ },
/* 110 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransitionProps = getTransitionProps;
	exports.reflow = void 0;
	
	var reflow = function reflow(node) {
	  return node.scrollTop;
	};
	
	exports.reflow = reflow;
	
	function getTransitionProps(props, options) {
	  var timeout = props.timeout,
	      _props$style = props.style,
	      style = _props$style === void 0 ? {} : _props$style;
	  return {
	    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
	    delay: style.transitionDelay
	  };
	}

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createChainedFunction;
	
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.reduce(function (acc, func) {
	    if (func == null) {
	      return acc;
	    }
	
	    if (false) {
	      if (typeof func !== 'function') {
	        console.error('Material-UI: Invalid Argument Type, must only provide functions, undefined, or null.');
	      }
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      func.apply(this, args);
	    };
	  }, function () {});
	}

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_enc = C.enc;
	
		    /**
		     * Base64 encoding strategy.
		     */
		    var Base64 = C_enc.Base64 = {
		        /**
		         * Converts a word array to a Base64 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Base64 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
		            var map = this._map;
	
		            // Clamp excess bits
		            wordArray.clamp();
	
		            // Convert
		            var base64Chars = [];
		            for (var i = 0; i < sigBytes; i += 3) {
		                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
		                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
		                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;
	
		                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;
	
		                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
		                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
		                }
		            }
	
		            // Add padding
		            var paddingChar = map.charAt(64);
		            if (paddingChar) {
		                while (base64Chars.length % 4) {
		                    base64Chars.push(paddingChar);
		                }
		            }
	
		            return base64Chars.join('');
		        },
	
		        /**
		         * Converts a Base64 string to a word array.
		         *
		         * @param {string} base64Str The Base64 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
		         */
		        parse: function (base64Str) {
		            // Shortcuts
		            var base64StrLength = base64Str.length;
		            var map = this._map;
		            var reverseMap = this._reverseMap;
	
		            if (!reverseMap) {
		                    reverseMap = this._reverseMap = [];
		                    for (var j = 0; j < map.length; j++) {
		                        reverseMap[map.charCodeAt(j)] = j;
		                    }
		            }
	
		            // Ignore padding
		            var paddingChar = map.charAt(64);
		            if (paddingChar) {
		                var paddingIndex = base64Str.indexOf(paddingChar);
		                if (paddingIndex !== -1) {
		                    base64StrLength = paddingIndex;
		                }
		            }
	
		            // Convert
		            return parseLoop(base64Str, base64StrLength, reverseMap);
	
		        },
	
		        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
		    };
	
		    function parseLoop(base64Str, base64StrLength, reverseMap) {
		      var words = [];
		      var nBytes = 0;
		      for (var i = 0; i < base64StrLength; i++) {
		          if (i % 4) {
		              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
		              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
		              var bitsCombined = bits1 | bits2;
		              words[nBytes >>> 2] |= bitsCombined << (24 - (nBytes % 4) * 8);
		              nBytes++;
		          }
		      }
		      return WordArray.create(words, nBytes);
		    }
		}());
	
	
		return CryptoJS.enc.Base64;
	
	}));

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Constants table
		    var T = [];
	
		    // Compute constants
		    (function () {
		        for (var i = 0; i < 64; i++) {
		            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
		        }
		    }());
	
		    /**
		     * MD5 hash algorithm.
		     */
		    var MD5 = C_algo.MD5 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0x67452301, 0xefcdab89,
		                0x98badcfe, 0x10325476
		            ]);
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Swap endian
		            for (var i = 0; i < 16; i++) {
		                // Shortcuts
		                var offset_i = offset + i;
		                var M_offset_i = M[offset_i];
	
		                M[offset_i] = (
		                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
		                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
		                );
		            }
	
		            // Shortcuts
		            var H = this._hash.words;
	
		            var M_offset_0  = M[offset + 0];
		            var M_offset_1  = M[offset + 1];
		            var M_offset_2  = M[offset + 2];
		            var M_offset_3  = M[offset + 3];
		            var M_offset_4  = M[offset + 4];
		            var M_offset_5  = M[offset + 5];
		            var M_offset_6  = M[offset + 6];
		            var M_offset_7  = M[offset + 7];
		            var M_offset_8  = M[offset + 8];
		            var M_offset_9  = M[offset + 9];
		            var M_offset_10 = M[offset + 10];
		            var M_offset_11 = M[offset + 11];
		            var M_offset_12 = M[offset + 12];
		            var M_offset_13 = M[offset + 13];
		            var M_offset_14 = M[offset + 14];
		            var M_offset_15 = M[offset + 15];
	
		            // Working varialbes
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
	
		            // Computation
		            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
		            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
		            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
		            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
		            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
		            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
		            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
		            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
		            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
		            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
		            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
		            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
		            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
		            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
		            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
		            b = FF(b, c, d, a, M_offset_15, 22, T[15]);
	
		            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
		            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
		            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
		            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
		            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
		            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
		            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
		            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
		            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
		            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
		            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
		            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
		            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
		            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
		            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
		            b = GG(b, c, d, a, M_offset_12, 20, T[31]);
	
		            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
		            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
		            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
		            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
		            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
		            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
		            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
		            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
		            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
		            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
		            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
		            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
		            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
		            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
		            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
		            b = HH(b, c, d, a, M_offset_2,  23, T[47]);
	
		            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
		            d = II(d, a, b, c, M_offset_7,  10, T[49]);
		            c = II(c, d, a, b, M_offset_14, 15, T[50]);
		            b = II(b, c, d, a, M_offset_5,  21, T[51]);
		            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
		            d = II(d, a, b, c, M_offset_3,  10, T[53]);
		            c = II(c, d, a, b, M_offset_10, 15, T[54]);
		            b = II(b, c, d, a, M_offset_1,  21, T[55]);
		            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
		            d = II(d, a, b, c, M_offset_15, 10, T[57]);
		            c = II(c, d, a, b, M_offset_6,  15, T[58]);
		            b = II(b, c, d, a, M_offset_13, 21, T[59]);
		            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
		            d = II(d, a, b, c, M_offset_11, 10, T[61]);
		            c = II(c, d, a, b, M_offset_2,  15, T[62]);
		            b = II(b, c, d, a, M_offset_9,  21, T[63]);
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	
		            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
		            var nBitsTotalL = nBitsTotal;
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
		                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
		            );
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
		                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
		            );
	
		            data.sigBytes = (dataWords.length + 1) * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Shortcuts
		            var hash = this._hash;
		            var H = hash.words;
	
		            // Swap endian
		            for (var i = 0; i < 4; i++) {
		                // Shortcut
		                var H_i = H[i];
	
		                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
		                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
		            }
	
		            // Return final computed hash
		            return hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    function FF(a, b, c, d, x, s, t) {
		        var n = a + ((b & c) | (~b & d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function GG(a, b, c, d, x, s, t) {
		        var n = a + ((b & d) | (c & ~d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function HH(a, b, c, d, x, s, t) {
		        var n = a + (b ^ c ^ d) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function II(a, b, c, d, x, s, t) {
		        var n = a + (c ^ (b | ~d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.MD5('message');
		     *     var hash = CryptoJS.MD5(wordArray);
		     */
		    C.MD5 = Hasher._createHelper(MD5);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacMD5(message, key);
		     */
		    C.HmacMD5 = Hasher._createHmacHelper(MD5);
		}(Math));
	
	
		return CryptoJS.MD5;
	
	}));

/***/ },
/* 114 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./type')} */
	module.exports = TypeError;


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/** @type {import('.')} */
	var $gOPD = __webpack_require__(6734);
	
	if ($gOPD) {
		try {
			$gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			$gOPD = null;
		}
	}
	
	module.exports = $gOPD;


/***/ },
/* 116 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(147),
	    isArrayLike = __webpack_require__(73),
	    isIndex = __webpack_require__(146),
	    isObject = __webpack_require__(59);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(139),
	    baseEach = __webpack_require__(99),
	    castFunction = __webpack_require__(474),
	    isArray = __webpack_require__(35);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(6769),
	    hasPath = __webpack_require__(488);
	
	/**
	 * Checks if `path` is a direct property of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = { 'a': { 'b': 2 } };
	 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.has(object, 'a');
	 * // => true
	 *
	 * _.has(object, 'a.b');
	 * // => true
	 *
	 * _.has(object, ['a', 'b']);
	 * // => true
	 *
	 * _.has(other, 'a');
	 * // => false
	 */
	function has(object, path) {
	  return object != null && hasPath(object, path, baseHas);
	}
	
	module.exports = has;


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(58),
	    stubFalse = __webpack_require__(6942);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(215)(module)))

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Chart", {
	  enumerable: true,
	  get: function get() {
	    return _chart["default"];
	  }
	});
	exports.defaults = exports.Scatter = exports.Bubble = exports.Polar = exports.Radar = exports.HorizontalBar = exports.Bar = exports.Line = exports.Pie = exports.Doughnut = exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _chart = _interopRequireDefault(__webpack_require__(430));
	
	var _isEqual = _interopRequireDefault(__webpack_require__(280));
	
	var _keyBy = _interopRequireDefault(__webpack_require__(513));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NODE_ENV = typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production");
	
	var ChartComponent = /*#__PURE__*/function (_React$Component) {
	  _inherits(ChartComponent, _React$Component);
	
	  var _super = _createSuper(ChartComponent);
	
	  function ChartComponent() {
	    var _this;
	
	    _classCallCheck(this, ChartComponent);
	
	    _this = _super.call(this);
	
	    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (event) {
	      var instance = _this.chartInstance;
	      var _this$props = _this.props,
	          getDatasetAtEvent = _this$props.getDatasetAtEvent,
	          getElementAtEvent = _this$props.getElementAtEvent,
	          getElementsAtEvent = _this$props.getElementsAtEvent,
	          onElementsClick = _this$props.onElementsClick;
	      getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
	      getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
	      getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
	      onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ref", function (element) {
	      _this.element = element;
	    });
	
	    _this.chartInstance = undefined;
	    return _this;
	  }
	
	  _createClass(ChartComponent, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.renderChart();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.props.redraw) {
	        this.destroyChart();
	        this.renderChart();
	        return;
	      }
	
	      this.updateChart();
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var _this$props2 = this.props,
	          redraw = _this$props2.redraw,
	          type = _this$props2.type,
	          options = _this$props2.options,
	          plugins = _this$props2.plugins,
	          legend = _this$props2.legend,
	          height = _this$props2.height,
	          width = _this$props2.width;
	
	      if (nextProps.redraw === true) {
	        return true;
	      }
	
	      if (height !== nextProps.height || width !== nextProps.width) {
	        return true;
	      }
	
	      if (type !== nextProps.type) {
	        return true;
	      }
	
	      if (!(0, _isEqual["default"])(legend, nextProps.legend)) {
	        return true;
	      }
	
	      if (!(0, _isEqual["default"])(options, nextProps.options)) {
	        return true;
	      }
	
	      var nextData = this.transformDataProp(nextProps);
	
	      if (!(0, _isEqual["default"])(this.shadowDataProp, nextData)) {
	        return true;
	      }
	
	      return !(0, _isEqual["default"])(plugins, nextProps.plugins);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.destroyChart();
	    }
	  }, {
	    key: "transformDataProp",
	    value: function transformDataProp(props) {
	      var data = props.data;
	
	      if (typeof data == 'function') {
	        var node = this.element;
	        return data(node);
	      } else {
	        return data;
	      }
	    } // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
	    // this makes impossible to compare the current and next data changes
	    // therefore we memoize the data prop while sending a fake to Chart.js for mutation.
	    // see https://github.com/chartjs/Chart.js/blob/master/src/core/core.controller.js#L615-L617
	
	  }, {
	    key: "memoizeDataProps",
	    value: function memoizeDataProps() {
	      if (!this.props.data) {
	        return;
	      }
	
	      var data = this.transformDataProp(this.props);
	      this.shadowDataProp = _objectSpread(_objectSpread({}, data), {}, {
	        datasets: data.datasets && data.datasets.map(function (set) {
	          return _objectSpread({}, set);
	        })
	      });
	      this.saveCurrentDatasets(); // to remove the dataset metadata from this chart when the chart is destroyed
	
	      return data;
	    }
	  }, {
	    key: "checkDatasets",
	    value: function checkDatasets(datasets) {
	      var isDev = NODE_ENV !== 'production' && NODE_ENV !== 'prod';
	      var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
	      var multipleDatasets = datasets.length > 1;
	
	      if (isDev && multipleDatasets && !usingCustomKeyProvider) {
	        var shouldWarn = false;
	        datasets.forEach(function (dataset) {
	          if (!dataset.label) {
	            shouldWarn = true;
	          }
	        });
	
	        if (shouldWarn) {
	          console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
	        }
	      }
	    }
	  }, {
	    key: "getCurrentDatasets",
	    value: function getCurrentDatasets() {
	      return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
	    }
	  }, {
	    key: "saveCurrentDatasets",
	    value: function saveCurrentDatasets() {
	      var _this2 = this;
	
	      this.datasets = this.datasets || {};
	      var currentDatasets = this.getCurrentDatasets();
	      currentDatasets.forEach(function (d) {
	        _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
	      });
	    }
	  }, {
	    key: "updateChart",
	    value: function updateChart() {
	      var _this3 = this;
	
	      var options = this.props.options;
	      var data = this.memoizeDataProps(this.props);
	      if (!this.chartInstance) return;
	
	      if (options) {
	        this.chartInstance.options = _chart["default"].helpers.configMerge(this.chartInstance.options, options);
	      } // Pipe datasets to chart instance datasets enabling
	      // seamless transitions
	
	
	      var currentDatasets = this.getCurrentDatasets();
	      var nextDatasets = data.datasets || [];
	      this.checkDatasets(currentDatasets);
	      var currentDatasetsIndexed = (0, _keyBy["default"])(currentDatasets, this.props.datasetKeyProvider); // We can safely replace the dataset array, as long as we retain the _meta property
	      // on each dataset.
	
	      this.chartInstance.config.data.datasets = nextDatasets.map(function (next) {
	        var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];
	
	        if (current && current.type === next.type && next.data) {
	          // Be robust to no data. Relevant for other update mechanisms as in chartjs-plugin-streaming.
	          // The data array must be edited in place. As chart.js adds listeners to it.
	          current.data.splice(next.data.length);
	          next.data.forEach(function (point, pid) {
	            current.data[pid] = next.data[pid];
	          });
	
	          var _data = next.data,
	              otherProps = _objectWithoutProperties(next, ["data"]); // Merge properties. Notice a weakness here. If a property is removed
	          // from next, it will be retained by current and never disappears.
	          // Workaround is to set value to null or undefined in next.
	
	
	          return _objectSpread(_objectSpread({}, current), otherProps);
	        } else {
	          return next;
	        }
	      });
	
	      var datasets = data.datasets,
	          rest = _objectWithoutProperties(data, ["datasets"]);
	
	      this.chartInstance.config.data = _objectSpread(_objectSpread({}, this.chartInstance.config.data), rest);
	      this.chartInstance.update();
	    }
	  }, {
	    key: "renderChart",
	    value: function renderChart() {
	      var _this$props3 = this.props,
	          options = _this$props3.options,
	          legend = _this$props3.legend,
	          type = _this$props3.type,
	          plugins = _this$props3.plugins;
	      var node = this.element;
	      var data = this.memoizeDataProps();
	
	      if (typeof legend !== 'undefined' && !(0, _isEqual["default"])(ChartComponent.defaultProps.legend, legend)) {
	        options.legend = legend;
	      }
	
	      this.chartInstance = new _chart["default"](node, {
	        type: type,
	        data: data,
	        options: options,
	        plugins: plugins
	      });
	    }
	  }, {
	    key: "destroyChart",
	    value: function destroyChart() {
	      if (!this.chartInstance) {
	        return;
	      } // Put all of the datasets that have existed in the chart back on the chart
	      // so that the metadata associated with this chart get destroyed.
	      // This allows the datasets to be used in another chart. This can happen,
	      // for example, in a tabbed UI where the chart gets created each time the
	      // tab gets switched to the chart and uses the same data).
	
	
	      this.saveCurrentDatasets();
	      var datasets = Object.values(this.datasets);
	      this.chartInstance.config.data.datasets = datasets;
	      this.chartInstance.destroy();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          height = _this$props4.height,
	          width = _this$props4.width,
	          id = _this$props4.id;
	      return /*#__PURE__*/_react["default"].createElement("canvas", {
	        ref: this.ref,
	        height: height,
	        width: width,
	        id: id,
	        onClick: this.handleOnClick
	      });
	    }
	  }]);
	
	  return ChartComponent;
	}(_react["default"].Component);
	
	_defineProperty(ChartComponent, "getLabelAsKey", function (d) {
	  return d.label;
	});
	
	_defineProperty(ChartComponent, "propTypes", {
	  data: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]).isRequired,
	  getDatasetAtEvent: _propTypes["default"].func,
	  getElementAtEvent: _propTypes["default"].func,
	  getElementsAtEvent: _propTypes["default"].func,
	  height: _propTypes["default"].number,
	  legend: _propTypes["default"].object,
	  onElementsClick: _propTypes["default"].func,
	  options: _propTypes["default"].object,
	  plugins: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  redraw: _propTypes["default"].bool,
	  type: function type(props, propName, componentName) {
	    if (!_chart["default"].controllers[props[propName]]) {
	      return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
	    }
	  },
	  width: _propTypes["default"].number,
	  datasetKeyProvider: _propTypes["default"].func
	});
	
	_defineProperty(ChartComponent, "defaultProps", {
	  legend: {
	    display: true,
	    position: 'bottom'
	  },
	  type: 'doughnut',
	  height: 150,
	  width: 300,
	  redraw: false,
	  options: {},
	  datasetKeyProvider: ChartComponent.getLabelAsKey
	});
	
	var _default = ChartComponent;
	exports["default"] = _default;
	
	var Doughnut = /*#__PURE__*/function (_React$Component2) {
	  _inherits(Doughnut, _React$Component2);
	
	  var _super2 = _createSuper(Doughnut);
	
	  function Doughnut() {
	    _classCallCheck(this, Doughnut);
	
	    return _super2.apply(this, arguments);
	  }
	
	  _createClass(Doughnut, [{
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref) {
	          return _this4.chartInstance = _ref && _ref.chartInstance;
	        },
	        type: "doughnut"
	      }));
	    }
	  }]);
	
	  return Doughnut;
	}(_react["default"].Component);
	
	exports.Doughnut = Doughnut;
	
	var Pie = /*#__PURE__*/function (_React$Component3) {
	  _inherits(Pie, _React$Component3);
	
	  var _super3 = _createSuper(Pie);
	
	  function Pie() {
	    _classCallCheck(this, Pie);
	
	    return _super3.apply(this, arguments);
	  }
	
	  _createClass(Pie, [{
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref2) {
	          return _this5.chartInstance = _ref2 && _ref2.chartInstance;
	        },
	        type: "pie"
	      }));
	    }
	  }]);
	
	  return Pie;
	}(_react["default"].Component);
	
	exports.Pie = Pie;
	
	var Line = /*#__PURE__*/function (_React$Component4) {
	  _inherits(Line, _React$Component4);
	
	  var _super4 = _createSuper(Line);
	
	  function Line() {
	    _classCallCheck(this, Line);
	
	    return _super4.apply(this, arguments);
	  }
	
	  _createClass(Line, [{
	    key: "render",
	    value: function render() {
	      var _this6 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref3) {
	          return _this6.chartInstance = _ref3 && _ref3.chartInstance;
	        },
	        type: "line"
	      }));
	    }
	  }]);
	
	  return Line;
	}(_react["default"].Component);
	
	exports.Line = Line;
	
	var Bar = /*#__PURE__*/function (_React$Component5) {
	  _inherits(Bar, _React$Component5);
	
	  var _super5 = _createSuper(Bar);
	
	  function Bar() {
	    _classCallCheck(this, Bar);
	
	    return _super5.apply(this, arguments);
	  }
	
	  _createClass(Bar, [{
	    key: "render",
	    value: function render() {
	      var _this7 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref4) {
	          return _this7.chartInstance = _ref4 && _ref4.chartInstance;
	        },
	        type: "bar"
	      }));
	    }
	  }]);
	
	  return Bar;
	}(_react["default"].Component);
	
	exports.Bar = Bar;
	
	var HorizontalBar = /*#__PURE__*/function (_React$Component6) {
	  _inherits(HorizontalBar, _React$Component6);
	
	  var _super6 = _createSuper(HorizontalBar);
	
	  function HorizontalBar() {
	    _classCallCheck(this, HorizontalBar);
	
	    return _super6.apply(this, arguments);
	  }
	
	  _createClass(HorizontalBar, [{
	    key: "render",
	    value: function render() {
	      var _this8 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref5) {
	          return _this8.chartInstance = _ref5 && _ref5.chartInstance;
	        },
	        type: "horizontalBar"
	      }));
	    }
	  }]);
	
	  return HorizontalBar;
	}(_react["default"].Component);
	
	exports.HorizontalBar = HorizontalBar;
	
	var Radar = /*#__PURE__*/function (_React$Component7) {
	  _inherits(Radar, _React$Component7);
	
	  var _super7 = _createSuper(Radar);
	
	  function Radar() {
	    _classCallCheck(this, Radar);
	
	    return _super7.apply(this, arguments);
	  }
	
	  _createClass(Radar, [{
	    key: "render",
	    value: function render() {
	      var _this9 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref6) {
	          return _this9.chartInstance = _ref6 && _ref6.chartInstance;
	        },
	        type: "radar"
	      }));
	    }
	  }]);
	
	  return Radar;
	}(_react["default"].Component);
	
	exports.Radar = Radar;
	
	var Polar = /*#__PURE__*/function (_React$Component8) {
	  _inherits(Polar, _React$Component8);
	
	  var _super8 = _createSuper(Polar);
	
	  function Polar() {
	    _classCallCheck(this, Polar);
	
	    return _super8.apply(this, arguments);
	  }
	
	  _createClass(Polar, [{
	    key: "render",
	    value: function render() {
	      var _this10 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref7) {
	          return _this10.chartInstance = _ref7 && _ref7.chartInstance;
	        },
	        type: "polarArea"
	      }));
	    }
	  }]);
	
	  return Polar;
	}(_react["default"].Component);
	
	exports.Polar = Polar;
	
	var Bubble = /*#__PURE__*/function (_React$Component9) {
	  _inherits(Bubble, _React$Component9);
	
	  var _super9 = _createSuper(Bubble);
	
	  function Bubble() {
	    _classCallCheck(this, Bubble);
	
	    return _super9.apply(this, arguments);
	  }
	
	  _createClass(Bubble, [{
	    key: "render",
	    value: function render() {
	      var _this11 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref8) {
	          return _this11.chartInstance = _ref8 && _ref8.chartInstance;
	        },
	        type: "bubble"
	      }));
	    }
	  }]);
	
	  return Bubble;
	}(_react["default"].Component);
	
	exports.Bubble = Bubble;
	
	var Scatter = /*#__PURE__*/function (_React$Component10) {
	  _inherits(Scatter, _React$Component10);
	
	  var _super10 = _createSuper(Scatter);
	
	  function Scatter() {
	    _classCallCheck(this, Scatter);
	
	    return _super10.apply(this, arguments);
	  }
	
	  _createClass(Scatter, [{
	    key: "render",
	    value: function render() {
	      var _this12 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref9) {
	          return _this12.chartInstance = _ref9 && _ref9.chartInstance;
	        },
	        type: "scatter"
	      }));
	    }
	  }]);
	
	  return Scatter;
	}(_react["default"].Component);
	
	exports.Scatter = Scatter;
	var defaults = _chart["default"].defaults;
	exports.defaults = defaults;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoListAnticipos = function CatalogoListAnticipos(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtBuscar = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      records = _useState6[0],
	      setRecords = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    idpago: "",
	    numpago: "",
	    monto: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      values = _useState8[0],
	      setValues = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(-1),
	      _useState10 = _slicedToArray(_useState9, 2),
	      itemSelect = _useState10[0],
	      setItemSelect = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      filterFn = _useState12[0],
	      setFilterFn = _useState12[1];
	
	  var headCells = [{ label: "FECHA", textAlign: "center" }, { label: "NÙMERO", textAlign: "center" }, { label: "CEDULA/RIF", textAlign: "center" }, { label: "NOMBRE", textAlign: "center" }, { label: "MONTO", textAlign: "center" }, { label: "ESTATUS", textAlign: "center" }];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.idpago.includes(target.value) || x.numpago.toLowerCase().includes(target.value.toLowerCase()) || (0, _moment2.default)(x.fecha).format("DD/MM/YYYY").toLowerCase().includes(target.value.toLowerCase()) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.rif.toLowerCase().includes(target.value.toLowerCase()) || status(x.status, x.statusreverso).toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var status = function status(value, reversado) {
	    var estatus = "Disponible";
	    if (reversado === 1) {
	      estatus = "Reversado";
	    } else {
	      if (value === 0) {
	        estatus = "Disponible";
	      } else if (value === 1) {
	        estatus = "Utilizado";
	      } else if (value === 4) {
	        estatus = "Anulado";
	      }
	    }
	    return estatus;
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var endpoint = "";
	    var id = props.idcliente;
	    var tipo = props.tipo;
	    var status = props.estatus;
	
	    endpoint = op.conexion + "/api/consulta/seleccionaranticipo?idcliente=" + id + "&tipo=" + tipo + "&estatus=" + status;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setItemSelect("");
	    setActivate(false);
	    setRecords([]);
	    setValues({
	      idpago: "",
	      numpago: "",
	      monto: ""
	    });
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var seleccionarAnticipo = function seleccionarAnticipo() {
	    props.onHideAceptaCatalogo(values);
	  };
	
	  var seleccionarFila = function seleccionarFila(item) {
	    return function (e) {
	      e.preventDefault();
	      setValues({
	        idpago: item.idpago,
	        numpago: item.numpago,
	        monto: item.total
	      });
	      btnAcepta.current.focus();
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        seleccionarRegistros();
	        txtBuscar.current.focus();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Seleccionar Anticipo"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-6 input-group-sm mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control text-uppercase",
	              ref: txtBuscar
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  style: {
	                    padding: "0",
	                    cursor: "pointer",
	                    background: values.idpago === item.idpago ? "lightskyblue" : "white"
	                  },
	                  onClick: seleccionarFila(item)
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  (0, _moment2.default)(item.fecharegistro).format("DD/MM/YYYY")
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.numpago
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.rif
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.nombre
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-right" },
	                  (0, _varios.formatMoneda)(item.total.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  status(item.status, item.statusreverso)
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          onClick: seleccionarAnticipo
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoListAnticipos;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.config = exports.Transition = exports.TransitionGroup = exports.SwitchTransition = exports.ReplaceTransition = exports.CSSTransition = void 0;
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(7200));
	
	exports.CSSTransition = _CSSTransition.default;
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(7201));
	
	exports.ReplaceTransition = _ReplaceTransition.default;
	
	var _SwitchTransition = _interopRequireDefault(__webpack_require__(7202));
	
	exports.SwitchTransition = _SwitchTransition.default;
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(678));
	
	exports.TransitionGroup = _TransitionGroup.default;
	
	var _Transition = _interopRequireDefault(__webpack_require__(216));
	
	exports.Transition = _Transition.default;
	
	var _config = _interopRequireDefault(__webpack_require__(679));
	
	exports.config = _config.default;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Image["default"];
	  }
	});
	
	var _Image = _interopRequireDefault(__webpack_require__(723));

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _IconButton.default;
	  }
	});
	
	var _IconButton = _interopRequireDefault(__webpack_require__(898));

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _InputBase.default;
	  }
	});
	
	var _InputBase = _interopRequireDefault(__webpack_require__(902));

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var ListContext = /*#__PURE__*/React.createContext({});
	
	if (false) {
	  ListContext.displayName = 'ListContext';
	}
	
	var _default = ListContext;
	exports.default = _default;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var Tablelvl2Context = /*#__PURE__*/React.createContext();
	
	if (false) {
	  Tablelvl2Context.displayName = 'Tablelvl2Context';
	}
	
	var _default = Tablelvl2Context;
	exports.default = _default;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(239));
	
	var defaultTheme = (0, _createMuiTheme.default)();
	var _default = defaultTheme;
	exports.default = _default;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMuiElement;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	function isMuiElement(element, muiNames) {
	  return /*#__PURE__*/React.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
	}

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.teardown = teardown;
	exports.default = useIsFocusVisible;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(45));
	
	// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
	var hadKeyboardEvent = true;
	var hadFocusVisibleRecently = false;
	var hadFocusVisibleRecentlyTimeout = null;
	var inputTypesWhitelist = {
	  text: true,
	  search: true,
	  url: true,
	  tel: true,
	  email: true,
	  password: true,
	  number: true,
	  date: true,
	  month: true,
	  week: true,
	  time: true,
	  datetime: true,
	  'datetime-local': true
	};
	/**
	 * Computes whether the given element should automatically trigger the
	 * `focus-visible` class being added, i.e. whether it should always match
	 * `:focus-visible` when focused.
	 * @param {Element} node
	 * @return {boolean}
	 */
	
	function focusTriggersKeyboardModality(node) {
	  var type = node.type,
	      tagName = node.tagName;
	
	  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
	    return true;
	  }
	
	  if (tagName === 'TEXTAREA' && !node.readOnly) {
	    return true;
	  }
	
	  if (node.isContentEditable) {
	    return true;
	  }
	
	  return false;
	}
	/**
	 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
	 * If the most recent user interaction was via the keyboard;
	 * and the key press did not include a meta, alt/option, or control key;
	 * then the modality is keyboard. Otherwise, the modality is not keyboard.
	 * @param {KeyboardEvent} event
	 */
	
	
	function handleKeyDown(event) {
	  if (event.metaKey || event.altKey || event.ctrlKey) {
	    return;
	  }
	
	  hadKeyboardEvent = true;
	}
	/**
	 * If at any point a user clicks with a pointing device, ensure that we change
	 * the modality away from keyboard.
	 * This avoids the situation where a user presses a key on an already focused
	 * element, and then clicks on a different element, focusing it with a
	 * pointing device, while we still think we're in keyboard modality.
	 */
	
	
	function handlePointerDown() {
	  hadKeyboardEvent = false;
	}
	
	function handleVisibilityChange() {
	  if (this.visibilityState === 'hidden') {
	    // If the tab becomes active again, the browser will handle calling focus
	    // on the element (Safari actually calls it twice).
	    // If this tab change caused a blur on an element with focus-visible,
	    // re-apply the class when the user switches back to the tab.
	    if (hadFocusVisibleRecently) {
	      hadKeyboardEvent = true;
	    }
	  }
	}
	
	function prepare(doc) {
	  doc.addEventListener('keydown', handleKeyDown, true);
	  doc.addEventListener('mousedown', handlePointerDown, true);
	  doc.addEventListener('pointerdown', handlePointerDown, true);
	  doc.addEventListener('touchstart', handlePointerDown, true);
	  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
	}
	
	function teardown(doc) {
	  doc.removeEventListener('keydown', handleKeyDown, true);
	  doc.removeEventListener('mousedown', handlePointerDown, true);
	  doc.removeEventListener('pointerdown', handlePointerDown, true);
	  doc.removeEventListener('touchstart', handlePointerDown, true);
	  doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
	}
	
	function isFocusVisible(event) {
	  var target = event.target;
	
	  try {
	    return target.matches(':focus-visible');
	  } catch (error) {// browsers not implementing :focus-visible will throw a SyntaxError
	    // we use our own heuristic for those browsers
	    // rethrow might be better if it's not the expected error but do we really
	    // want to crash if focus-visible malfunctioned?
	  } // no need for validFocusTarget check. the user does that by attaching it to
	  // focusable events only
	
	
	  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
	}
	/**
	 * Should be called if a blur event is fired on a focus-visible element
	 */
	
	
	function handleBlurVisible() {
	  // To detect a tab/window switch, we look for a blur event followed
	  // rapidly by a visibility change.
	  // If we don't see a visibility change within 100ms, it's probably a
	  // regular focus change.
	  hadFocusVisibleRecently = true;
	  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
	  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
	    hadFocusVisibleRecently = false;
	  }, 100);
	}
	
	function useIsFocusVisible() {
	  var ref = React.useCallback(function (instance) {
	    var node = ReactDOM.findDOMNode(instance);
	
	    if (node != null) {
	      prepare(node.ownerDocument);
	    }
	  }, []);
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useDebugValue(isFocusVisible);
	  }
	
	  return {
	    isFocusVisible: isFocusVisible,
	    onBlurVisible: handleBlurVisible,
	    ref: ref
	  };
	}

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	
	var _useTheme = _interopRequireDefault(__webpack_require__(6612));

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(39).Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(644);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var defineDataProperty = __webpack_require__(256);
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var supportsDescriptors = __webpack_require__(260)();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object) {
			if (predicate === true) {
				if (object[name] === value) {
					return;
				}
			} else if (!isFunction(predicate) || !predicate()) {
				return;
			}
		}
	
		if (supportsDescriptors) {
			defineDataProperty(object, name, value, true);
		} else {
			defineDataProperty(object, name, value);
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ },
/* 135 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownerDocument;
	
	/**
	 * Returns the owner document of a given element.
	 * 
	 * @param node the element
	 */
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(6732);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(6739);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 138 */
/***/ function(module, exports) {

	'use strict'
	
	var isObject = function isObject(val) {
	  return val !== null && !Array.isArray(val) && typeof val === 'object'
	}
	
	var codes = {
	  // ----------------------------------------
	  // By Code
	  // ----------------------------------------
	  3: 'Cancel',
	  6: 'Help',
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  28: 'Convert',
	  29: 'NonConvert',
	  30: 'Accept',
	  31: 'ModeChange',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  41: 'Select',
	  42: 'Print',
	  43: 'Execute',
	  44: 'PrintScreen',
	  45: 'Insert',
	  46: 'Delete',
	  48: ['0', ')'],
	  49: ['1', '!'],
	  50: ['2', '@'],
	  51: ['3', '#'],
	  52: ['4', '$'],
	  53: ['5', '%'],
	  54: ['6', '^'],
	  55: ['7', '&'],
	  56: ['8', '*'],
	  57: ['9', '('],
	  91: 'OS',
	  93: 'ContextMenu',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  181: 'VolumeMute',
	  182: 'VolumeDown',
	  183: 'VolumeUp',
	  186: [';', ':'],
	  187: ['=', '+'],
	  188: [',', '<'],
	  189: ['-', '_'],
	  190: ['.', '>'],
	  191: ['/', '?'],
	  192: ['`', '~'],
	  219: ['[', '{'],
	  220: ['\\', '|'],
	  221: [']', '}'],
	  222: ["'", '"'],
	  224: 'Meta',
	  225: 'AltGraph',
	  246: 'Attn',
	  247: 'CrSel',
	  248: 'ExSel',
	  249: 'EraseEof',
	  250: 'Play',
	  251: 'ZoomOut',
	}
	
	// Function Keys (F1-24)
	for (var i = 0; i < 24; i += 1) {
	  codes[112 + i] = 'F' + (i + 1)
	}
	
	// Alphabet (a-Z)
	for (var j = 0; j < 26; j += 1) {
	  var n = j + 65
	  codes[n] = [String.fromCharCode(n + 32), String.fromCharCode(n)]
	}
	
	var keyboardKey = {
	  codes: codes,
	
	  /**
	   * Get the `keyCode` or `which` value from a keyboard event or `key` name.
	   * @param {string|object} eventOrKey A keyboard event-like object or `key` name.
	   * @param {string} [eventOrKey.key] If object, it must have one of these keys.
	   * @param {number} [eventOrKey.keyCode] If object, it must have one of these keys.
	   * @param {number} [eventOrKey.which] If object, it must have one of these keys.
	   * @returns {number|undefined}
	   */
	  getCode: function getCode(eventOrKey) {
	    if (isObject(eventOrKey)) {
	      return eventOrKey.keyCode || eventOrKey.which || this[eventOrKey.key]
	    }
	    return this[eventOrKey]
	  },
	
	  /**
	   * Get the key name from a keyboard event, `keyCode`, or `which` value.
	   * @param {number|object} eventOrCode A keyboard event-like object or key code.
	   * @param {string} [eventOrCode.key] If object with a `key` name, it will be returned.
	   * @param {number} [eventOrCode.keyCode] If object, it must have one of these keys.
	   * @param {number} [eventOrCode.which] If object, it must have one of these keys.
	   * @param {boolean} [eventOrCode.shiftKey] If object, it must have one of these keys.
	   * @returns {string|undefined}
	   */
	  getKey: function getKey(eventOrCode) {
	    var isEvent = isObject(eventOrCode)
	
	    // handle events with a `key` already defined
	    if (isEvent && eventOrCode.key) {
	      return eventOrCode.key
	    }
	
	    var name = codes[isEvent ? eventOrCode.keyCode || eventOrCode.which : eventOrCode]
	
	    if (Array.isArray(name)) {
	      if (isEvent) {
	        name = name[eventOrCode.shiftKey ? 1 : 0]
	      } else {
	        name = name[0]
	      }
	    }
	
	    return name
	  },
	
	  // ----------------------------------------
	  // By Name
	  // ----------------------------------------
	  // declare these manually for static analysis
	  Cancel: 3,
	  Help: 6,
	  Backspace: 8,
	  Tab: 9,
	  Clear: 12,
	  Enter: 13,
	  Shift: 16,
	  Control: 17,
	  Alt: 18,
	  Pause: 19,
	  CapsLock: 20,
	  Escape: 27,
	  Convert: 28,
	  NonConvert: 29,
	  Accept: 30,
	  ModeChange: 31,
	  ' ': 32,
	  PageUp: 33,
	  PageDown: 34,
	  End: 35,
	  Home: 36,
	  ArrowLeft: 37,
	  ArrowUp: 38,
	  ArrowRight: 39,
	  ArrowDown: 40,
	  Select: 41,
	  Print: 42,
	  Execute: 43,
	  PrintScreen: 44,
	  Insert: 45,
	  Delete: 46,
	  0: 48,
	  ')': 48,
	  1: 49,
	  '!': 49,
	  2: 50,
	  '@': 50,
	  3: 51,
	  '#': 51,
	  4: 52,
	  $: 52,
	  5: 53,
	  '%': 53,
	  6: 54,
	  '^': 54,
	  7: 55,
	  '&': 55,
	  8: 56,
	  '*': 56,
	  9: 57,
	  '(': 57,
	  a: 65,
	  A: 65,
	  b: 66,
	  B: 66,
	  c: 67,
	  C: 67,
	  d: 68,
	  D: 68,
	  e: 69,
	  E: 69,
	  f: 70,
	  F: 70,
	  g: 71,
	  G: 71,
	  h: 72,
	  H: 72,
	  i: 73,
	  I: 73,
	  j: 74,
	  J: 74,
	  k: 75,
	  K: 75,
	  l: 76,
	  L: 76,
	  m: 77,
	  M: 77,
	  n: 78,
	  N: 78,
	  o: 79,
	  O: 79,
	  p: 80,
	  P: 80,
	  q: 81,
	  Q: 81,
	  r: 82,
	  R: 82,
	  s: 83,
	  S: 83,
	  t: 84,
	  T: 84,
	  u: 85,
	  U: 85,
	  v: 86,
	  V: 86,
	  w: 87,
	  W: 87,
	  x: 88,
	  X: 88,
	  y: 89,
	  Y: 89,
	  z: 90,
	  Z: 90,
	  OS: 91,
	  ContextMenu: 93,
	  F1: 112,
	  F2: 113,
	  F3: 114,
	  F4: 115,
	  F5: 116,
	  F6: 117,
	  F7: 118,
	  F8: 119,
	  F9: 120,
	  F10: 121,
	  F11: 122,
	  F12: 123,
	  F13: 124,
	  F14: 125,
	  F15: 126,
	  F16: 127,
	  F17: 128,
	  F18: 129,
	  F19: 130,
	  F20: 131,
	  F21: 132,
	  F22: 133,
	  F23: 134,
	  F24: 135,
	  NumLock: 144,
	  ScrollLock: 145,
	  VolumeMute: 181,
	  VolumeDown: 182,
	  VolumeUp: 183,
	  ';': 186,
	  ':': 186,
	  '=': 187,
	  '+': 187,
	  ',': 188,
	  '<': 188,
	  '-': 189,
	  _: 189,
	  '.': 190,
	  '>': 190,
	  '/': 191,
	  '?': 191,
	  '`': 192,
	  '~': 192,
	  '[': 219,
	  '{': 219,
	  '\\': 220,
	  '|': 220,
	  ']': 221,
	  '}': 221,
	  "'": 222,
	  '"': 222,
	  Meta: 224,
	  AltGraph: 225,
	  Attn: 246,
	  CrSel: 247,
	  ExSel: 248,
	  EraseEof: 249,
	  Play: 250,
	  ZoomOut: 251,
	}
	
	// ----------------------------------------
	// By Alias
	// ----------------------------------------
	// provide dot-notation accessible keys for all key names
	keyboardKey.Spacebar = keyboardKey[' ']
	keyboardKey.Digit0 = keyboardKey['0']
	keyboardKey.Digit1 = keyboardKey['1']
	keyboardKey.Digit2 = keyboardKey['2']
	keyboardKey.Digit3 = keyboardKey['3']
	keyboardKey.Digit4 = keyboardKey['4']
	keyboardKey.Digit5 = keyboardKey['5']
	keyboardKey.Digit6 = keyboardKey['6']
	keyboardKey.Digit7 = keyboardKey['7']
	keyboardKey.Digit8 = keyboardKey['8']
	keyboardKey.Digit9 = keyboardKey['9']
	keyboardKey.Tilde = keyboardKey['~']
	keyboardKey.GraveAccent = keyboardKey['`']
	keyboardKey.ExclamationPoint = keyboardKey['!']
	keyboardKey.AtSign = keyboardKey['@']
	keyboardKey.PoundSign = keyboardKey['#']
	keyboardKey.PercentSign = keyboardKey['%']
	keyboardKey.Caret = keyboardKey['^']
	keyboardKey.Ampersand = keyboardKey['&']
	keyboardKey.PlusSign = keyboardKey['+']
	keyboardKey.MinusSign = keyboardKey['-']
	keyboardKey.EqualsSign = keyboardKey['=']
	keyboardKey.DivisionSign = keyboardKey['/']
	keyboardKey.MultiplicationSign = keyboardKey['*']
	keyboardKey.Comma = keyboardKey[',']
	keyboardKey.Decimal = keyboardKey['.']
	keyboardKey.Colon = keyboardKey[':']
	keyboardKey.Semicolon = keyboardKey[';']
	keyboardKey.Pipe = keyboardKey['|']
	keyboardKey.BackSlash = keyboardKey['\\']
	keyboardKey.QuestionMark = keyboardKey['?']
	keyboardKey.SingleQuote = keyboardKey["'"]
	keyboardKey.DoubleQuote = keyboardKey['"']
	keyboardKey.LeftCurlyBrace = keyboardKey['{']
	keyboardKey.RightCurlyBrace = keyboardKey['}']
	keyboardKey.LeftParenthesis = keyboardKey['(']
	keyboardKey.RightParenthesis = keyboardKey[')']
	keyboardKey.LeftAngleBracket = keyboardKey['<']
	keyboardKey.RightAngleBracket = keyboardKey['>']
	keyboardKey.LeftSquareBracket = keyboardKey['[']
	keyboardKey.RightSquareBracket = keyboardKey[']']
	
	module.exports = keyboardKey


/***/ },
/* 139 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(481);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(59);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(267),
	    isFlattenable = __webpack_require__(6844);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(144),
	    toKey = __webpack_require__(102);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(35),
	    isKey = __webpack_require__(277),
	    stringToPath = __webpack_require__(501),
	    toString = __webpack_require__(78);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(268),
	    baseAssignValue = __webpack_require__(140);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 146 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 147 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(6775),
	    isObjectLike = __webpack_require__(53);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(73),
	    isObjectLike = __webpack_require__(53);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(70),
	    getPrototype = __webpack_require__(193),
	    isObjectLike = __webpack_require__(53);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(6783),
	    baseUnary = __webpack_require__(100),
	    nodeUtil = __webpack_require__(197);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(455),
	    baseKeysIn = __webpack_require__(6784),
	    isArrayLike = __webpack_require__(73);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(6800),
	    keys = __webpack_require__(63);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = createWithBsPrefix;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _camelize = _interopRequireDefault(__webpack_require__(6713));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(48);
	
	var pascalCase = function pascalCase(str) {
	  return str[0].toUpperCase() + (0, _camelize.default)(str).slice(1);
	};
	
	function createWithBsPrefix(prefix, _temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$displayName = _ref.displayName,
	      displayName = _ref$displayName === void 0 ? pascalCase(prefix) : _ref$displayName,
	      _ref$Component = _ref.Component,
	      Component = _ref$Component === void 0 ? 'div' : _ref$Component,
	      defaultProps = _ref.defaultProps;
	
	  var BsComponent = _react.default.forwardRef( // eslint-disable-next-line react/prop-types
	  function (_ref2, ref) {
	    var className = _ref2.className,
	        bsPrefix = _ref2.bsPrefix,
	        _ref2$as = _ref2.as,
	        Tag = _ref2$as === void 0 ? Component : _ref2$as,
	        props = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["className", "bsPrefix", "as"]);
	    var resolvedPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, prefix);
	    return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({
	      ref: ref,
	      className: (0, _classnames.default)(className, resolvedPrefix)
	    }, props));
	  });
	
	  BsComponent.defaultProps = defaultProps;
	  BsComponent.displayName = displayName;
	  return BsComponent;
	}
	
	module.exports = exports["default"];

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(7010);
	} else {
	  module.exports = require("./cjs/react-router-dom.js");
	}


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoCuentaBancaria = function CatalogoCuentaBancaria(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	    var txtBuscar = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        records = _useState6[0],
	        setRecords = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({}),
	        _useState8 = _slicedToArray(_useState7, 2),
	        values = _useState8[0],
	        setValues = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(-1),
	        _useState10 = _slicedToArray(_useState9, 2),
	        itemSelect = _useState10[0],
	        setItemSelect = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filterFn = _useState12[0],
	        setFilterFn = _useState12[1];
	
	    var headCells = [{ label: 'CODIGO', textAlign: 'center' }, { label: 'DESCRIPCION', textAlign: 'center' }, { label: 'N° CUENTA', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.idcuentabancaria.includes(target.value) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.cuentabancaria.includes(target.value)) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = '*';
	        var nomtab = 'cuentabancaria';
	        var orden = 'idcuentabancaria';
	
	        var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setRecords([]);
	        setValues({});
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var seleccionarMarca = function seleccionarMarca() {
	
	        props.onHideAceptaCatalogo(values);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	
	            setValues(item);
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	                txtBuscar.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Banco'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group col-md-6 input-group-sm mb-3' },
	                        _react2.default.createElement('input', { type: 'text',
	                            onChange: handleSearch, className: 'form-control text-uppercase', ref: txtBuscar }),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-info', style: { pointerEvents: 'none' } },
	                            _react2.default.createElement('i', { className: 'fa fa-search' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.idcuentabancaria === item.idcuentabancaria ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.idcuentabancaria
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-start' },
	                                    item.nombre
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-start' },
	                                    item.cuentabancaria
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: seleccionarMarca },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoCuentaBancaria;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoNotaCredito = function CatalogoNotaCredito(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      records = _useState6[0],
	      setRecords = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    idnotaentrega: "",
	    numnotaentrega: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      values = _useState8[0],
	      setValues = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(-1),
	      _useState10 = _slicedToArray(_useState9, 2),
	      itemSelect = _useState10[0],
	      setItemSelect = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      filterFn = _useState12[0],
	      setFilterFn = _useState12[1];
	
	  var headCells = [{ label: "ID", textAlign: "center" }, { label: "NÙMERO", textAlign: "center" }, { label: "CEDULA/RIF", textAlign: "center" }, { label: "NOMBRE", textAlign: "center" }, { label: "MONTO", textAlign: "center" }, { label: "FECHA", textAlign: "center" }];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.idnotaentrega.includes(target.value) || x.numnotaentrega.toLowerCase().includes(target.value.toLowerCase()) || (0, _moment2.default)(x.fecha).format("DD/MM/YYYY").toLowerCase().includes(target.value.toLowerCase()) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.cedularif.toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	
	    var endpoint = "";
	    var id = props.idcliente;
	
	    endpoint = op.conexion + "/api/consulta/seleccionarcredito?idcliente=" + id;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setItemSelect("");
	    setActivate(false);
	    setRecords([]);
	    setValues({
	      idnotaentrega: "",
	      numnotaentrega: ""
	    });
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var seleccionarProducto = function seleccionarProducto() {
	    props.onHideAceptaCatalogo(values);
	  };
	
	  var seleccionarFila = function seleccionarFila(item) {
	    return function (e) {
	      e.preventDefault();
	
	      setValues({
	        idnotaentrega: item.idnotaentrega,
	        numnotaentrega: item.numnotaentrega,
	        monto: item.totalmonto
	      });
	      btnAcepta.current.focus();
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        seleccionarRegistros();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Seleccionar Nota de Credito"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-2 input-group-sm mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control"
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  style: {
	                    padding: "0",
	                    cursor: "pointer",
	                    background: values.idnotaentrega === item.idnotaentrega ? "lightskyblue" : "white"
	                  },
	                  onClick: seleccionarFila(item)
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.idnotaentrega
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.numnotaentrega
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.cedularif
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.nombre
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-right" },
	                  (0, _varios.formatMoneda)(item.totalmonto.toString().replace(',', '').replace('.', ','), ',', '.', 2)
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  (0, _moment2.default)(item.fecha).format("DD/MM/YYYY")
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          style: { margin: "5px" },
	          onClick: seleccionarProducto
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoNotaCredito;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Portal["default"];
	  }
	});
	
	var _Portal = _interopRequireDefault(__webpack_require__(7228));

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Label["default"];
	  }
	});
	
	var _Label = _interopRequireDefault(__webpack_require__(314));

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, process) {/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*exported XLSX */
	/*global exports, module, require:false, process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false */
	var XLSX = {};
	function make_xlsx_lib(XLSX){
	XLSX.version = '0.18.5';
	var current_codepage = 1200, current_ansi = 1252;
	/*global cptable:true, window */
	var $cptable;
	if(typeof cptable !== 'undefined') $cptable = cptable;
	else if(true) {
		$cptable = __webpack_require__(7339);
	}
	
	var VALID_ANSI = [ 874, 932, 936, 949, 950, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1258, 10000 ];
	/* ECMA-376 Part I 18.4.1 charset to codepage mapping */
	var CS2CP = ({
	0:    1252, /* ANSI */
	1:   65001, /* DEFAULT */
	2:   65001, /* SYMBOL */
	77:  10000, /* MAC */
	128:   932, /* SHIFTJIS */
	129:   949, /* HANGUL */
	130:  1361, /* JOHAB */
	134:   936, /* GB2312 */
	136:   950, /* CHINESEBIG5 */
	161:  1253, /* GREEK */
	162:  1254, /* TURKISH */
	163:  1258, /* VIETNAMESE */
	177:  1255, /* HEBREW */
	178:  1256, /* ARABIC */
	186:  1257, /* BALTIC */
	204:  1251, /* RUSSIAN */
	222:   874, /* THAI */
	238:  1250, /* EASTEUROPE */
	255:  1252, /* OEM */
	69:   6969  /* MISC */
	});
	
	var set_ansi = function(cp) { if(VALID_ANSI.indexOf(cp) == -1) return; current_ansi = CS2CP[0] = cp; };
	function reset_ansi() { set_ansi(1252); }
	
	var set_cp = function(cp) { current_codepage = cp; set_ansi(cp); };
	function reset_cp() { set_cp(1200); reset_ansi(); }
	
	function char_codes(data) { var o = []; for(var i = 0, len = data.length; i < len; ++i) o[i] = data.charCodeAt(i); return o; }
	
	function utf16leread(data) {
		var o = [];
		for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i) + (data.charCodeAt(2*i+1)<<8));
		return o.join("");
	}
	function utf16beread(data) {
		var o = [];
		for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i+1) + (data.charCodeAt(2*i)<<8));
		return o.join("");
	}
	
	var debom = function(data) {
		var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
		if(c1 == 0xFF && c2 == 0xFE) return utf16leread(data.slice(2));
		if(c1 == 0xFE && c2 == 0xFF) return utf16beread(data.slice(2));
		if(c1 == 0xFEFF) return data.slice(1);
		return data;
	};
	
	var _getchar = function _gc1(x) { return String.fromCharCode(x); };
	var _getansi = function _ga1(x) { return String.fromCharCode(x); };
	if(typeof $cptable !== 'undefined') {
		set_cp = function(cp) { current_codepage = cp; set_ansi(cp); };
		debom = function(data) {
			if(data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) { return $cptable.utils.decode(1200, char_codes(data.slice(2))); }
			return data;
		};
		_getchar = function _gc2(x) {
			if(current_codepage === 1200) return String.fromCharCode(x);
			return $cptable.utils.decode(current_codepage, [x&255,x>>8])[0];
		};
		_getansi = function _ga2(x) {
			return $cptable.utils.decode(current_ansi, [x])[0];
		};
	}
	var DENSE = null;
	var DIF_XL = true;
	var Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	function Base64_encode(input) {
	  var o = "";
	  var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
	  for (var i = 0; i < input.length; ) {
	    c1 = input.charCodeAt(i++);
	    e1 = c1 >> 2;
	    c2 = input.charCodeAt(i++);
	    e2 = (c1 & 3) << 4 | c2 >> 4;
	    c3 = input.charCodeAt(i++);
	    e3 = (c2 & 15) << 2 | c3 >> 6;
	    e4 = c3 & 63;
	    if (isNaN(c2)) {
	      e3 = e4 = 64;
	    } else if (isNaN(c3)) {
	      e4 = 64;
	    }
	    o += Base64_map.charAt(e1) + Base64_map.charAt(e2) + Base64_map.charAt(e3) + Base64_map.charAt(e4);
	  }
	  return o;
	}
	function Base64_decode(input) {
	  var o = "";
	  var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
	  input = input.replace(/[^\w\+\/\=]/g, "");
	  for (var i = 0; i < input.length; ) {
	    e1 = Base64_map.indexOf(input.charAt(i++));
	    e2 = Base64_map.indexOf(input.charAt(i++));
	    c1 = e1 << 2 | e2 >> 4;
	    o += String.fromCharCode(c1);
	    e3 = Base64_map.indexOf(input.charAt(i++));
	    c2 = (e2 & 15) << 4 | e3 >> 2;
	    if (e3 !== 64) {
	      o += String.fromCharCode(c2);
	    }
	    e4 = Base64_map.indexOf(input.charAt(i++));
	    c3 = (e3 & 3) << 6 | e4;
	    if (e4 !== 64) {
	      o += String.fromCharCode(c3);
	    }
	  }
	  return o;
	}
	var has_buf = (function() { return typeof Buffer !== 'undefined' && typeof process !== 'undefined' && typeof process.versions !== 'undefined' && !!process.versions.node; })();
	
	var Buffer_from = (function() {
		if(typeof Buffer !== 'undefined') {
			var nbfs = !Buffer.from;
			if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
			return nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
		}
		return function() {};
	})();
	
	
	function new_raw_buf(len) {
		/* jshint -W056 */
		if(has_buf) return Buffer.alloc ? Buffer.alloc(len) : new Buffer(len);
		return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
		/* jshint +W056 */
	}
	
	function new_unsafe_buf(len) {
		/* jshint -W056 */
		if(has_buf) return Buffer.allocUnsafe ? Buffer.allocUnsafe(len) : new Buffer(len);
		return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
		/* jshint +W056 */
	}
	
	var s2a = function s2a(s) {
		if(has_buf) return Buffer_from(s, "binary");
		return s.split("").map(function(x){ return x.charCodeAt(0) & 0xff; });
	};
	
	function s2ab(s) {
		if(typeof ArrayBuffer === 'undefined') return s2a(s);
		var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
		for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
		return buf;
	}
	
	function a2s(data) {
		if(Array.isArray(data)) return data.map(function(c) { return String.fromCharCode(c); }).join("");
		var o = []; for(var i = 0; i < data.length; ++i) o[i] = String.fromCharCode(data[i]); return o.join("");
	}
	
	function a2u(data) {
		if(typeof Uint8Array === 'undefined') throw new Error("Unsupported");
		return new Uint8Array(data);
	}
	
	function ab2a(data) {
		if(typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
		if(data instanceof ArrayBuffer) return ab2a(new Uint8Array(data));
	var o = new Array(data.length);
		for(var i = 0; i < data.length; ++i) o[i] = data[i];
		return o;
	}
	
	var bconcat = has_buf ? function(bufs) { return Buffer.concat(bufs.map(function(buf) { return Buffer.isBuffer(buf) ? buf : Buffer_from(buf); })); } : function(bufs) {
		if(typeof Uint8Array !== "undefined") {
			var i = 0, maxlen = 0;
			for(i = 0; i < bufs.length; ++i) maxlen += bufs[i].length;
			var o = new Uint8Array(maxlen);
			var len = 0;
			for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i) {
				len = bufs[i].length;
				if(bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
				else if(typeof bufs[i] == "string") { throw "wtf"; }
				else o.set(new Uint8Array(bufs[i]), maxlen);
			}
			return o;
		}
		return [].concat.apply([], bufs.map(function(buf) { return Array.isArray(buf) ? buf : [].slice.call(buf); }));
	};
	
	function utf8decode(content) {
		var out = [], widx = 0, L = content.length + 250;
		var o = new_raw_buf(content.length + 255);
		for(var ridx = 0; ridx < content.length; ++ridx) {
			var c = content.charCodeAt(ridx);
			if(c < 0x80) o[widx++] = c;
			else if(c < 0x800) {
				o[widx++] = (192|((c>>6)&31));
				o[widx++] = (128|(c&63));
			} else if(c >= 0xD800 && c < 0xE000) {
				c = (c&1023)+64;
				var d = content.charCodeAt(++ridx)&1023;
				o[widx++] = (240|((c>>8)&7));
				o[widx++] = (128|((c>>2)&63));
				o[widx++] = (128|((d>>6)&15)|((c&3)<<4));
				o[widx++] = (128|(d&63));
			} else {
				o[widx++] = (224|((c>>12)&15));
				o[widx++] = (128|((c>>6)&63));
				o[widx++] = (128|(c&63));
			}
			if(widx > L) {
				out.push(o.slice(0, widx));
				widx = 0;
				o = new_raw_buf(65535);
				L = 65530;
			}
		}
		out.push(o.slice(0, widx));
		return bconcat(out);
	}
	
	var chr0 = /\u0000/g, chr1 = /[\u0001-\u0006]/g;
	/* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/*jshint -W041 */
	function _strrev(x) { var o = "", i = x.length-1; while(i>=0) o += x.charAt(i--); return o; }
	function pad0(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
	function pad_(v,d){var t=""+v;return t.length>=d?t:fill(' ',d-t.length)+t;}
	function rpad_(v,d){var t=""+v; return t.length>=d?t:t+fill(' ',d-t.length);}
	function pad0r1(v,d){var t=""+Math.round(v); return t.length>=d?t:fill('0',d-t.length)+t;}
	function pad0r2(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
	var p2_32 = Math.pow(2,32);
	function pad0r(v,d){if(v>p2_32||v<-p2_32) return pad0r1(v,d); var i = Math.round(v); return pad0r2(i,d); }
	/* yes, in 2022 this is still faster than string compare */
	function SSF_isgeneral(s, i) { i = i || 0; return s.length >= 7 + i && (s.charCodeAt(i)|32) === 103 && (s.charCodeAt(i+1)|32) === 101 && (s.charCodeAt(i+2)|32) === 110 && (s.charCodeAt(i+3)|32) === 101 && (s.charCodeAt(i+4)|32) === 114 && (s.charCodeAt(i+5)|32) === 97 && (s.charCodeAt(i+6)|32) === 108; }
	var days = [
		['Sun', 'Sunday'],
		['Mon', 'Monday'],
		['Tue', 'Tuesday'],
		['Wed', 'Wednesday'],
		['Thu', 'Thursday'],
		['Fri', 'Friday'],
		['Sat', 'Saturday']
	];
	var months = [
		['J', 'Jan', 'January'],
		['F', 'Feb', 'February'],
		['M', 'Mar', 'March'],
		['A', 'Apr', 'April'],
		['M', 'May', 'May'],
		['J', 'Jun', 'June'],
		['J', 'Jul', 'July'],
		['A', 'Aug', 'August'],
		['S', 'Sep', 'September'],
		['O', 'Oct', 'October'],
		['N', 'Nov', 'November'],
		['D', 'Dec', 'December']
	];
	function SSF_init_table(t) {
		if(!t) t = {};
		t[0]=  'General';
		t[1]=  '0';
		t[2]=  '0.00';
		t[3]=  '#,##0';
		t[4]=  '#,##0.00';
		t[9]=  '0%';
		t[10]= '0.00%';
		t[11]= '0.00E+00';
		t[12]= '# ?/?';
		t[13]= '# ??/??';
		t[14]= 'm/d/yy';
		t[15]= 'd-mmm-yy';
		t[16]= 'd-mmm';
		t[17]= 'mmm-yy';
		t[18]= 'h:mm AM/PM';
		t[19]= 'h:mm:ss AM/PM';
		t[20]= 'h:mm';
		t[21]= 'h:mm:ss';
		t[22]= 'm/d/yy h:mm';
		t[37]= '#,##0 ;(#,##0)';
		t[38]= '#,##0 ;[Red](#,##0)';
		t[39]= '#,##0.00;(#,##0.00)';
		t[40]= '#,##0.00;[Red](#,##0.00)';
		t[45]= 'mm:ss';
		t[46]= '[h]:mm:ss';
		t[47]= 'mmss.0';
		t[48]= '##0.0E+0';
		t[49]= '@';
		t[56]= '"上午/下午 "hh"時"mm"分"ss"秒 "';
		return t;
	}
	/* repeated to satiate webpack */
	var table_fmt = {
		0:  'General',
		1:  '0',
		2:  '0.00',
		3:  '#,##0',
		4:  '#,##0.00',
		9:  '0%',
		10: '0.00%',
		11: '0.00E+00',
		12: '# ?/?',
		13: '# ??/??',
		14: 'm/d/yy',
		15: 'd-mmm-yy',
		16: 'd-mmm',
		17: 'mmm-yy',
		18: 'h:mm AM/PM',
		19: 'h:mm:ss AM/PM',
		20: 'h:mm',
		21: 'h:mm:ss',
		22: 'm/d/yy h:mm',
		37: '#,##0 ;(#,##0)',
		38: '#,##0 ;[Red](#,##0)',
		39: '#,##0.00;(#,##0.00)',
		40: '#,##0.00;[Red](#,##0.00)',
		45: 'mm:ss',
		46: '[h]:mm:ss',
		47: 'mmss.0',
		48: '##0.0E+0',
		49: '@',
		56: '"上午/下午 "hh"時"mm"分"ss"秒 "'
	};
	
	/* Defaults determined by systematically testing in Excel 2019 */
	
	/* These formats appear to default to other formats in the table */
	var SSF_default_map = {
		5:  37, 6:  38, 7:  39, 8:  40,         //  5 -> 37 ...  8 -> 40
	
		23:  0, 24:  0, 25:  0, 26:  0,         // 23 ->  0 ... 26 ->  0
	
		27: 14, 28: 14, 29: 14, 30: 14, 31: 14, // 27 -> 14 ... 31 -> 14
	
		50: 14, 51: 14, 52: 14, 53: 14, 54: 14, // 50 -> 14 ... 58 -> 14
		55: 14, 56: 14, 57: 14, 58: 14,
		59:  1, 60:  2, 61:  3, 62:  4,         // 59 ->  1 ... 62 ->  4
	
		67:  9, 68: 10,                         // 67 ->  9 ... 68 -> 10
		69: 12, 70: 13, 71: 14,                 // 69 -> 12 ... 71 -> 14
		72: 14, 73: 15, 74: 16, 75: 17,         // 72 -> 14 ... 75 -> 17
		76: 20, 77: 21, 78: 22,                 // 76 -> 20 ... 78 -> 22
		79: 45, 80: 46, 81: 47,                 // 79 -> 45 ... 81 -> 47
		82: 0                                   // 82 ->  0 ... 65536 -> 0 (omitted)
	};
	
	
	/* These formats technically refer to Accounting formats with no equivalent */
	var SSF_default_str = {
		//  5 -- Currency,   0 decimal, black negative
		5:  '"$"#,##0_);\\("$"#,##0\\)',
		63: '"$"#,##0_);\\("$"#,##0\\)',
	
		//  6 -- Currency,   0 decimal, red   negative
		6:  '"$"#,##0_);[Red]\\("$"#,##0\\)',
		64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
	
		//  7 -- Currency,   2 decimal, black negative
		7:  '"$"#,##0.00_);\\("$"#,##0.00\\)',
		65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
	
		//  8 -- Currency,   2 decimal, red   negative
		8:  '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
	
		// 41 -- Accounting, 0 decimal, No Symbol
		41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
	
		// 42 -- Accounting, 0 decimal, $  Symbol
		42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
	
		// 43 -- Accounting, 2 decimal, No Symbol
		43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
	
		// 44 -- Accounting, 2 decimal, $  Symbol
		44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
	};
	
	function SSF_frac(x, D, mixed) {
		var sgn = x < 0 ? -1 : 1;
		var B = x * sgn;
		var P_2 = 0, P_1 = 1, P = 0;
		var Q_2 = 1, Q_1 = 0, Q = 0;
		var A = Math.floor(B);
		while(Q_1 < D) {
			A = Math.floor(B);
			P = A * P_1 + P_2;
			Q = A * Q_1 + Q_2;
			if((B - A) < 0.00000005) break;
			B = 1 / (B - A);
			P_2 = P_1; P_1 = P;
			Q_2 = Q_1; Q_1 = Q;
		}
		if(Q > D) { if(Q_1 > D) { Q = Q_2; P = P_2; } else { Q = Q_1; P = P_1; } }
		if(!mixed) return [0, sgn * P, Q];
		var q = Math.floor(sgn * P/Q);
		return [q, sgn*P - q*Q, Q];
	}
	function SSF_parse_date_code(v,opts,b2) {
		if(v > 2958465 || v < 0) return null;
		var date = (v|0), time = Math.floor(86400 * (v - date)), dow=0;
		var dout=[];
		var out={D:date, T:time, u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};
		if(Math.abs(out.u) < 1e-6) out.u = 0;
		if(opts && opts.date1904) date += 1462;
		if(out.u > 0.9999) {
			out.u = 0;
			if(++time == 86400) { out.T = time = 0; ++date; ++out.D; }
		}
		if(date === 60) {dout = b2 ? [1317,10,29] : [1900,2,29]; dow=3;}
		else if(date === 0) {dout = b2 ? [1317,8,29] : [1900,1,0]; dow=6;}
		else {
			if(date > 60) --date;
			/* 1 = Jan 1 1900 in Gregorian */
			var d = new Date(1900, 0, 1);
			d.setDate(d.getDate() + date - 1);
			dout = [d.getFullYear(), d.getMonth()+1,d.getDate()];
			dow = d.getDay();
			if(date < 60) dow = (dow + 6) % 7;
			if(b2) dow = SSF_fix_hijri(d, dout);
		}
		out.y = dout[0]; out.m = dout[1]; out.d = dout[2];
		out.S = time % 60; time = Math.floor(time / 60);
		out.M = time % 60; time = Math.floor(time / 60);
		out.H = time;
		out.q = dow;
		return out;
	}
	var SSFbasedate = new Date(1899, 11, 31, 0, 0, 0);
	var SSFdnthresh = SSFbasedate.getTime();
	var SSFbase1904 = new Date(1900, 2, 1, 0, 0, 0);
	function datenum_local(v, date1904) {
		var epoch = v.getTime();
		if(date1904) epoch -= 1461*24*60*60*1000;
		else if(v >= SSFbase1904) epoch += 24*60*60*1000;
		return (epoch - (SSFdnthresh + (v.getTimezoneOffset() - SSFbasedate.getTimezoneOffset()) * 60000)) / (24 * 60 * 60 * 1000);
	}
	/* ECMA-376 18.8.30 numFmt*/
	/* Note: `toPrecision` uses standard form when prec > E and E >= -6 */
	/* exponent >= -9 and <= 9 */
	function SSF_strip_decimal(o) {
		return (o.indexOf(".") == -1) ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
	}
	
	/* General Exponential always shows 2 digits exp and trims the mantissa */
	function SSF_normalize_exp(o) {
		if(o.indexOf("E") == -1) return o;
		return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/,"$1E").replace(/(E[+-])(\d)$/,"$10$2");
	}
	
	/* exponent >= -9 and <= 9 */
	function SSF_small_exp(v) {
		var w = (v<0?12:11);
		var o = SSF_strip_decimal(v.toFixed(12)); if(o.length <= w) return o;
		o = v.toPrecision(10); if(o.length <= w) return o;
		return v.toExponential(5);
	}
	
	/* exponent >= 11 or <= -10 likely exponential */
	function SSF_large_exp(v) {
		var o = SSF_strip_decimal(v.toFixed(11));
		return (o.length > (v<0?12:11) || o === "0" || o === "-0") ? v.toPrecision(6) : o;
	}
	
	function SSF_general_num(v) {
		var V = Math.floor(Math.log(Math.abs(v))*Math.LOG10E), o;
	
		if(V >= -4 && V <= -1) o = v.toPrecision(10+V);
		else if(Math.abs(V) <= 9) o = SSF_small_exp(v);
		else if(V === 10) o = v.toFixed(10).substr(0,12);
		else o = SSF_large_exp(v);
	
		return SSF_strip_decimal(SSF_normalize_exp(o.toUpperCase()));
	}
	
	
	/*
		"General" rules:
		- text is passed through ("@")
		- booleans are rendered as TRUE/FALSE
		- "up to 11 characters" displayed for numbers
		- Default date format (code 14) used for Dates
	
		The longest 32-bit integer text is "-2147483648", exactly 11 chars
		TODO: technically the display depends on the width of the cell
	*/
	function SSF_general(v, opts) {
		switch(typeof v) {
			case 'string': return v;
			case 'boolean': return v ? "TRUE" : "FALSE";
			case 'number': return (v|0) === v ? v.toString(10) : SSF_general_num(v);
			case 'undefined': return "";
			case 'object':
				if(v == null) return "";
				if(v instanceof Date) return SSF_format(14, datenum_local(v, opts && opts.date1904), opts);
		}
		throw new Error("unsupported value in General format: " + v);
	}
	
	function SSF_fix_hijri(date, o) {
	  /* TODO: properly adjust y/m/d and  */
	  o[0] -= 581;
	  var dow = date.getDay();
	  if(date < 60) dow = (dow + 6) % 7;
	  return dow;
	}
	//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
	function SSF_write_date(type, fmt, val, ss0) {
		var o="", ss=0, tt=0, y = val.y, out, outl = 0;
		switch(type) {
			case 98: /* 'b' buddhist year */
				y = val.y + 543;
				/* falls through */
			case 121: /* 'y' year */
			switch(fmt.length) {
				case 1: case 2: out = y % 100; outl = 2; break;
				default: out = y % 10000; outl = 4; break;
			} break;
			case 109: /* 'm' month */
			switch(fmt.length) {
				case 1: case 2: out = val.m; outl = fmt.length; break;
				case 3: return months[val.m-1][1];
				case 5: return months[val.m-1][0];
				default: return months[val.m-1][2];
			} break;
			case 100: /* 'd' day */
			switch(fmt.length) {
				case 1: case 2: out = val.d; outl = fmt.length; break;
				case 3: return days[val.q][0];
				default: return days[val.q][1];
			} break;
			case 104: /* 'h' 12-hour */
			switch(fmt.length) {
				case 1: case 2: out = 1+(val.H+11)%12; outl = fmt.length; break;
				default: throw 'bad hour format: ' + fmt;
			} break;
			case 72: /* 'H' 24-hour */
			switch(fmt.length) {
				case 1: case 2: out = val.H; outl = fmt.length; break;
				default: throw 'bad hour format: ' + fmt;
			} break;
			case 77: /* 'M' minutes */
			switch(fmt.length) {
				case 1: case 2: out = val.M; outl = fmt.length; break;
				default: throw 'bad minute format: ' + fmt;
			} break;
			case 115: /* 's' seconds */
				if(fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
				if(val.u === 0 && (fmt == "s" || fmt == "ss")) return pad0(val.S, fmt.length);
	if(ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
				else tt = ss0 === 1 ? 10 : 1;
				ss = Math.round((tt)*(val.S + val.u));
				if(ss >= 60*tt) ss = 0;
				if(fmt === 's') return ss === 0 ? "0" : ""+ss/tt;
				o = pad0(ss,2 + ss0);
				if(fmt === 'ss') return o.substr(0,2);
				return "." + o.substr(2,fmt.length-1);
			case 90: /* 'Z' absolute time */
			switch(fmt) {
				case '[h]': case '[hh]': out = val.D*24+val.H; break;
				case '[m]': case '[mm]': out = (val.D*24+val.H)*60+val.M; break;
				case '[s]': case '[ss]': out = ((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u); break;
				default: throw 'bad abstime format: ' + fmt;
			} outl = fmt.length === 3 ? 1 : 2; break;
			case 101: /* 'e' era */
				out = y; outl = 1; break;
		}
		var outstr = outl > 0 ? pad0(out, outl) : "";
		return outstr;
	}
	
	
	/*jshint -W086 */
	/*jshint +W086 */
	function commaify(s) {
		var w = 3;
		if(s.length <= w) return s;
		var j = (s.length % w), o = s.substr(0,j);
		for(; j!=s.length; j+=w) o+=(o.length > 0 ? "," : "") + s.substr(j,w);
		return o;
	}
	var pct1 = /%/g;
	function write_num_pct(type, fmt, val){
		var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
		return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
	}
	
	function write_num_cm(type, fmt, val){
		var idx = fmt.length - 1;
		while(fmt.charCodeAt(idx-1) === 44) --idx;
		return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
	}
	
	function write_num_exp(fmt, val){
		var o;
		var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
		if(fmt.match(/^#+0.0E\+0$/)) {
			if(val == 0) return "0.0E+0";
			else if(val < 0) return "-" + write_num_exp(fmt, -val);
			var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
			var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
			if(ee < 0) ee += period;
			o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
			if(o.indexOf("e") === -1) {
				var fakee = Math.floor(Math.log(val)*Math.LOG10E);
				if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
				else o += "E+" + (fakee - ee);
				while(o.substr(0,2) === "0.") {
					o = o.charAt(0) + o.substr(2,period) + "." + o.substr(2+period);
					o = o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");
				}
				o = o.replace(/\+-/,"-");
			}
			o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
		} else o = val.toExponential(idx);
		if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
		if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
		return o.replace("e","E");
	}
	var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
	function write_num_f1(r, aval, sign) {
		var den = parseInt(r[4],10), rr = Math.round(aval * den), base = Math.floor(rr/den);
		var myn = (rr - base*den), myd = den;
		return sign + (base === 0 ? "" : ""+base) + " " + (myn === 0 ? fill(" ", r[1].length + 1 + r[4].length) : pad_(myn,r[1].length) + r[2] + "/" + r[3] + pad0(myd,r[4].length));
	}
	function write_num_f2(r, aval, sign) {
		return sign + (aval === 0 ? "" : ""+aval) + fill(" ", r[1].length + 2 + r[4].length);
	}
	var dec1 = /^#*0*\.([0#]+)/;
	var closeparen = /\).*[0#]/;
	var phone = /\(###\) ###\\?-####/;
	function hashq(str) {
		var o = "", cc;
		for(var i = 0; i != str.length; ++i) switch((cc=str.charCodeAt(i))) {
			case 35: break;
			case 63: o+= " "; break;
			case 48: o+= "0"; break;
			default: o+= String.fromCharCode(cc);
		}
		return o;
	}
	function rnd(val, d) { var dd = Math.pow(10,d); return ""+(Math.round(val * dd)/dd); }
	function dec(val, d) {
		var _frac = val - Math.floor(val), dd = Math.pow(10,d);
		if (d < ('' + Math.round(_frac * dd)).length) return 0;
		return Math.round(_frac * dd);
	}
	function carry(val, d) {
		if (d < ('' + Math.round((val-Math.floor(val))*Math.pow(10,d))).length) {
			return 1;
		}
		return 0;
	}
	function flr(val) {
		if(val < 2147483647 && val > -2147483648) return ""+(val >= 0 ? (val|0) : (val-1|0));
		return ""+Math.floor(val);
	}
	function write_num_flt(type, fmt, val) {
		if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
			var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
			if(val >= 0) return write_num_flt('n', ffmt, val);
			return '(' + write_num_flt('n', ffmt, -val) + ')';
		}
		if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm(type, fmt, val);
		if(fmt.indexOf('%') !== -1) return write_num_pct(type, fmt, val);
		if(fmt.indexOf('E') !== -1) return write_num_exp(fmt, val);
		if(fmt.charCodeAt(0) === 36) return "$"+write_num_flt(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
		var o;
		var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
		if(fmt.match(/^00+$/)) return sign + pad0r(aval,fmt.length);
		if(fmt.match(/^[#?]+$/)) {
			o = pad0r(val,0); if(o === "0") o = "";
			return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(frac1))) return write_num_f1(r, aval, sign);
		if(fmt.match(/^#+0+$/)) return sign + pad0r(aval,fmt.length - fmt.indexOf("0"));
		if((r = fmt.match(dec1))) {
			o = rnd(val, r[1].length).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1])).replace(/\.(\d*)$/,function($$, $1) { return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
			return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
		}
		fmt = fmt.replace(/^#+([0.])/, "$1");
		if((r = fmt.match(/^(0*)\.(#*)$/))) {
			return sign + rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
		}
		if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify(pad0r(aval,0));
		if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(""+(Math.floor(val) + carry(val, r[1].length))) + "." + pad0(dec(val, r[1].length),r[1].length);
		}
		if((r = fmt.match(/^#,#*,#0/))) return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);
		if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
			o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g,""), val));
			ri = 0;
			return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
		}
		if(fmt.match(phone)) {
			o = write_num_flt(type, "##########", val);
			return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
		}
		var oa = "";
		if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(r[4].length,7);
			ff = SSF_frac(aval, Math.pow(10,ri)-1, false);
			o = "" + sign;
			oa = write_num("n", r[1], ff[1]);
			if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
			o += oa + r[2] + "/" + r[3];
			oa = rpad_(ff[2],ri);
			if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
			o += oa;
			return o;
		}
		if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(Math.max(r[1].length, r[4].length),7);
			ff = SSF_frac(aval, Math.pow(10,ri)-1, true);
			return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
		}
		if((r = fmt.match(/^[#0?]+$/))) {
			o = pad0r(val, 0);
			if(fmt.length <= o.length) return o;
			return hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(/^([#0?]+)\.([#0]+)$/))) {
			o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
			ri = o.indexOf(".");
			var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
			return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
		}
		if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
			ri = dec(val, r[1].length);
			return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(ri,r[1].length);
		}
		switch(fmt) {
			case "###,##0.00": return write_num_flt(type, "#,##0.00", val);
			case "###,###":
			case "##,###":
			case "#,###": var x = commaify(pad0r(aval,0)); return x !== "0" ? sign + x : "";
			case "###,###.00": return write_num_flt(type, "###,##0.00",val).replace(/^0\./,".");
			case "#,###.00": return write_num_flt(type, "#,##0.00",val).replace(/^0\./,".");
			default:
		}
		throw new Error("unsupported format |" + fmt + "|");
	}
	function write_num_cm2(type, fmt, val){
		var idx = fmt.length - 1;
		while(fmt.charCodeAt(idx-1) === 44) --idx;
		return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
	}
	function write_num_pct2(type, fmt, val){
		var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
		return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
	}
	function write_num_exp2(fmt, val){
		var o;
		var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
		if(fmt.match(/^#+0.0E\+0$/)) {
			if(val == 0) return "0.0E+0";
			else if(val < 0) return "-" + write_num_exp2(fmt, -val);
			var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
			var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
			if(ee < 0) ee += period;
			o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
			if(!o.match(/[Ee]/)) {
				var fakee = Math.floor(Math.log(val)*Math.LOG10E);
				if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
				else o += "E+" + (fakee - ee);
				o = o.replace(/\+-/,"-");
			}
			o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
		} else o = val.toExponential(idx);
		if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
		if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
		return o.replace("e","E");
	}
	function write_num_int(type, fmt, val) {
		if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
			var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
			if(val >= 0) return write_num_int('n', ffmt, val);
			return '(' + write_num_int('n', ffmt, -val) + ')';
		}
		if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm2(type, fmt, val);
		if(fmt.indexOf('%') !== -1) return write_num_pct2(type, fmt, val);
		if(fmt.indexOf('E') !== -1) return write_num_exp2(fmt, val);
		if(fmt.charCodeAt(0) === 36) return "$"+write_num_int(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
		var o;
		var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
		if(fmt.match(/^00+$/)) return sign + pad0(aval,fmt.length);
		if(fmt.match(/^[#?]+$/)) {
			o = (""+val); if(val === 0) o = "";
			return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(frac1))) return write_num_f2(r, aval, sign);
		if(fmt.match(/^#+0+$/)) return sign + pad0(aval,fmt.length - fmt.indexOf("0"));
		if((r = fmt.match(dec1))) {
	o = (""+val).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1]));
			o = o.replace(/\.(\d*)$/,function($$, $1) {
	return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
			return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
		}
		fmt = fmt.replace(/^#+([0.])/, "$1");
		if((r = fmt.match(/^(0*)\.(#*)$/))) {
			return sign + (""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
		}
		if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify((""+aval));
		if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify((""+val)) + "." + fill('0',r[1].length);
		}
		if((r = fmt.match(/^#,#*,#0/))) return write_num_int(type,fmt.replace(/^#,#*,/,""),val);
		if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
			o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g,""), val));
			ri = 0;
			return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
		}
		if(fmt.match(phone)) {
			o = write_num_int(type, "##########", val);
			return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
		}
		var oa = "";
		if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(r[4].length,7);
			ff = SSF_frac(aval, Math.pow(10,ri)-1, false);
			o = "" + sign;
			oa = write_num("n", r[1], ff[1]);
			if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
			o += oa + r[2] + "/" + r[3];
			oa = rpad_(ff[2],ri);
			if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
			o += oa;
			return o;
		}
		if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(Math.max(r[1].length, r[4].length),7);
			ff = SSF_frac(aval, Math.pow(10,ri)-1, true);
			return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
		}
		if((r = fmt.match(/^[#0?]+$/))) {
			o = "" + val;
			if(fmt.length <= o.length) return o;
			return hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(/^([#0]+)\.([#0]+)$/))) {
			o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
			ri = o.indexOf(".");
			var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
			return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
		}
		if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(0,r[1].length);
		}
		switch(fmt) {
			case "###,###":
			case "##,###":
			case "#,###": var x = commaify(""+aval); return x !== "0" ? sign + x : "";
			default:
				if(fmt.match(/\.[0#?]*$/)) return write_num_int(type, fmt.slice(0,fmt.lastIndexOf(".")), val) + hashq(fmt.slice(fmt.lastIndexOf(".")));
		}
		throw new Error("unsupported format |" + fmt + "|");
	}
	function write_num(type, fmt, val) {
		return (val|0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val);
	}
	function SSF_split_fmt(fmt) {
		var out = [];
		var in_str = false/*, cc*/;
		for(var i = 0, j = 0; i < fmt.length; ++i) switch((/*cc=*/fmt.charCodeAt(i))) {
			case 34: /* '"' */
				in_str = !in_str; break;
			case 95: case 42: case 92: /* '_' '*' '\\' */
				++i; break;
			case 59: /* ';' */
				out[out.length] = fmt.substr(j,i-j);
				j = i+1;
		}
		out[out.length] = fmt.substr(j);
		if(in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
		return out;
	}
	
	var SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
	function fmt_is_date(fmt) {
		var i = 0, /*cc = 0,*/ c = "", o = "";
		while(i < fmt.length) {
			switch((c = fmt.charAt(i))) {
				case 'G': if(SSF_isgeneral(fmt, i)) i+= 6; i++; break;
				case '"': for(;(/*cc=*/fmt.charCodeAt(++i)) !== 34 && i < fmt.length;){/*empty*/} ++i; break;
				case '\\': i+=2; break;
				case '_': i+=2; break;
				case '@': ++i; break;
				case 'B': case 'b':
					if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") return true;
					/* falls through */
				case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
					/* falls through */
				case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g': return true;
				case 'A': case 'a': case '上':
					if(fmt.substr(i, 3).toUpperCase() === "A/P") return true;
					if(fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
					if(fmt.substr(i, 5).toUpperCase() === "上午/下午") return true;
					++i; break;
				case '[':
					o = c;
					while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
					if(o.match(SSF_abstime)) return true;
					break;
				case '.':
					/* falls through */
				case '0': case '#':
					while(i < fmt.length && ("0#?.,E+-%".indexOf(c=fmt.charAt(++i)) > -1 || (c=='\\' && fmt.charAt(i+1) == "-" && "0#".indexOf(fmt.charAt(i+2))>-1))){/* empty */}
					break;
				case '?': while(fmt.charAt(++i) === c){/* empty */} break;
				case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break;
				case '(': case ')': ++i; break;
				case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
					while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1){/* empty */} break;
				case ' ': ++i; break;
				default: ++i; break;
			}
		}
		return false;
	}
	
	function eval_fmt(fmt, v, opts, flen) {
		var out = [], o = "", i = 0, c = "", lst='t', dt, j, cc;
		var hr='H';
		/* Tokenize */
		while(i < fmt.length) {
			switch((c = fmt.charAt(i))) {
				case 'G': /* General */
					if(!SSF_isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' +fmt);
					out[out.length] = {t:'G', v:'General'}; i+=7; break;
				case '"': /* Literal text */
					for(o="";(cc=fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) o += String.fromCharCode(cc);
					out[out.length] = {t:'t', v:o}; ++i; break;
				case '\\': var w = fmt.charAt(++i), t = (w === "(" || w === ")") ? w : 't';
					out[out.length] = {t:t, v:w}; ++i; break;
				case '_': out[out.length] = {t:'t', v:" "}; i+=2; break;
				case '@': /* Text Placeholder */
					out[out.length] = {t:'T', v:v}; ++i; break;
				case 'B': case 'b':
					if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") {
						if(dt==null) { dt=SSF_parse_date_code(v, opts, fmt.charAt(i+1) === "2"); if(dt==null) return ""; }
						out[out.length] = {t:'X', v:fmt.substr(i,2)}; lst = c; i+=2; break;
					}
					/* falls through */
				case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
					c = c.toLowerCase();
					/* falls through */
				case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g':
					if(v < 0) return "";
					if(dt==null) { dt=SSF_parse_date_code(v, opts); if(dt==null) return ""; }
					o = c; while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c) o+=c;
					if(c === 'm' && lst.toLowerCase() === 'h') c = 'M';
					if(c === 'h') c = hr;
					out[out.length] = {t:c, v:o}; lst = c; break;
				case 'A': case 'a': case '上':
					var q={t:c, v:c};
					if(dt==null) dt=SSF_parse_date_code(v, opts);
					if(fmt.substr(i, 3).toUpperCase() === "A/P") { if(dt!=null) q.v = dt.H >= 12 ? "P" : "A"; q.t = 'T'; hr='h';i+=3;}
					else if(fmt.substr(i,5).toUpperCase() === "AM/PM") { if(dt!=null) q.v = dt.H >= 12 ? "PM" : "AM"; q.t = 'T'; i+=5; hr='h'; }
					else if(fmt.substr(i,5).toUpperCase() === "上午/下午") { if(dt!=null) q.v = dt.H >= 12 ? "下午" : "上午"; q.t = 'T'; i+=5; hr='h'; }
					else { q.t = "t"; ++i; }
					if(dt==null && q.t === 'T') return "";
					out[out.length] = q; lst = c; break;
				case '[':
					o = c;
					while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
					if(o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
					if(o.match(SSF_abstime)) {
						if(dt==null) { dt=SSF_parse_date_code(v, opts); if(dt==null) return ""; }
						out[out.length] = {t:'Z', v:o.toLowerCase()};
						lst = o.charAt(1);
					} else if(o.indexOf("$") > -1) {
						o = (o.match(/\$([^-\[\]]*)/)||[])[1]||"$";
						if(!fmt_is_date(fmt)) out[out.length] = {t:'t',v:o};
					}
					break;
				/* Numbers */
				case '.':
					if(dt != null) {
						o = c; while(++i < fmt.length && (c=fmt.charAt(i)) === "0") o += c;
						out[out.length] = {t:'s', v:o}; break;
					}
					/* falls through */
				case '0': case '#':
					o = c; while(++i < fmt.length && "0#?.,E+-%".indexOf(c=fmt.charAt(i)) > -1) o += c;
					out[out.length] = {t:'n', v:o}; break;
				case '?':
					o = c; while(fmt.charAt(++i) === c) o+=c;
					out[out.length] = {t:c, v:o}; lst = c; break;
				case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break; // **
				case '(': case ')': out[out.length] = {t:(flen===1?'t':c), v:c}; ++i; break;
				case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
					o = c; while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1) o+=fmt.charAt(i);
					out[out.length] = {t:'D', v:o}; break;
				case ' ': out[out.length] = {t:c, v:c}; ++i; break;
				case '$': out[out.length] = {t:'t', v:'$'}; ++i; break;
				default:
					if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
					out[out.length] = {t:'t', v:c}; ++i; break;
			}
		}
	
		/* Scan for date/time parts */
		var bt = 0, ss0 = 0, ssm;
		for(i=out.length-1, lst='t'; i >= 0; --i) {
			switch(out[i].t) {
				case 'h': case 'H': out[i].t = hr; lst='h'; if(bt < 1) bt = 1; break;
				case 's':
					if((ssm=out[i].v.match(/\.0+$/))) ss0=Math.max(ss0,ssm[0].length-1);
					if(bt < 3) bt = 3;
				/* falls through */
				case 'd': case 'y': case 'M': case 'e': lst=out[i].t; break;
				case 'm': if(lst === 's') { out[i].t = 'M'; if(bt < 2) bt = 2; } break;
				case 'X': /*if(out[i].v === "B2");*/
					break;
				case 'Z':
					if(bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
					if(bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
					if(bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
			}
		}
		/* time rounding depends on presence of minute / second / usec fields */
		switch(bt) {
			case 0: break;
			case 1:
	if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
				if(dt.S >=  60) { dt.S = 0; ++dt.M; }
				if(dt.M >=  60) { dt.M = 0; ++dt.H; }
				break;
			case 2:
	if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
				if(dt.S >=  60) { dt.S = 0; ++dt.M; }
				break;
		}
	
		/* replace fields */
		var nstr = "", jj;
		for(i=0; i < out.length; ++i) {
			switch(out[i].t) {
				case 't': case 'T': case ' ': case 'D': break;
				case 'X': out[i].v = ""; out[i].t = ";"; break;
				case 'd': case 'm': case 'y': case 'h': case 'H': case 'M': case 's': case 'e': case 'b': case 'Z':
	out[i].v = SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
					out[i].t = 't'; break;
				case 'n': case '?':
					jj = i+1;
					while(out[jj] != null && (
						(c=out[jj].t) === "?" || c === "D" ||
						((c === " " || c === "t") && out[jj+1] != null && (out[jj+1].t === '?' || out[jj+1].t === "t" && out[jj+1].v === '/')) ||
						(out[i].t === '(' && (c === ' ' || c === 'n' || c === ')')) ||
						(c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj+1] != null && out[jj+1].t == '?'))
					)) {
						out[i].v += out[jj].v;
						out[jj] = {v:"", t:";"}; ++jj;
					}
					nstr += out[i].v;
					i = jj-1; break;
				case 'G': out[i].t = 't'; out[i].v = SSF_general(v,opts); break;
			}
		}
		var vv = "", myv, ostr;
		if(nstr.length > 0) {
			if(nstr.charCodeAt(0) == 40) /* '(' */ {
				myv = (v<0&&nstr.charCodeAt(0) === 45 ? -v : v);
				ostr = write_num('n', nstr, myv);
			} else {
				myv = (v<0 && flen > 1 ? -v : v);
				ostr = write_num('n', nstr, myv);
				if(myv < 0 && out[0] && out[0].t == 't') {
					ostr = ostr.substr(1);
					out[0].v = "-" + out[0].v;
				}
			}
			jj=ostr.length-1;
			var decpt = out.length;
			for(i=0; i < out.length; ++i) if(out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) { decpt = i; break; }
			var lasti=out.length;
			if(decpt === out.length && ostr.indexOf("E") === -1) {
				for(i=out.length-1; i>= 0;--i) {
					if(out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
					if(jj>=out[i].v.length-1) { jj -= out[i].v.length; out[i].v = ostr.substr(jj+1, out[i].v.length); }
					else if(jj < 0) out[i].v = "";
					else { out[i].v = ostr.substr(0, jj+1); jj = -1; }
					out[i].t = 't';
					lasti = i;
				}
				if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
			}
			else if(decpt !== out.length && ostr.indexOf("E") === -1) {
				jj = ostr.indexOf(".")-1;
				for(i=decpt; i>= 0; --i) {
					if(out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
					j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;
					vv = out[i].v.substr(j+1);
					for(; j>=0; --j) {
						if(jj>=0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
					}
					out[i].v = vv;
					out[i].t = 't';
					lasti = i;
				}
				if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
				jj = ostr.indexOf(".")+1;
				for(i=decpt; i<out.length; ++i) {
					if(out[i] == null || ('n?('.indexOf(out[i].t) === -1 && i !== decpt)) continue;
					j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;
					vv = out[i].v.substr(0,j);
					for(; j<out[i].v.length; ++j) {
						if(jj<ostr.length) vv += ostr.charAt(jj++);
					}
					out[i].v = vv;
					out[i].t = 't';
					lasti = i;
				}
			}
		}
		for(i=0; i<out.length; ++i) if(out[i] != null && 'n?'.indexOf(out[i].t)>-1) {
			myv = (flen >1 && v < 0 && i>0 && out[i-1].v === "-" ? -v:v);
			out[i].v = write_num(out[i].t, out[i].v, myv);
			out[i].t = 't';
		}
		var retval = "";
		for(i=0; i !== out.length; ++i) if(out[i] != null) retval += out[i].v;
		return retval;
	}
	
	var cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
	function chkcond(v, rr) {
		if(rr == null) return false;
		var thresh = parseFloat(rr[2]);
		switch(rr[1]) {
			case "=":  if(v == thresh) return true; break;
			case ">":  if(v >  thresh) return true; break;
			case "<":  if(v <  thresh) return true; break;
			case "<>": if(v != thresh) return true; break;
			case ">=": if(v >= thresh) return true; break;
			case "<=": if(v <= thresh) return true; break;
		}
		return false;
	}
	function choose_fmt(f, v) {
		var fmt = SSF_split_fmt(f);
		var l = fmt.length, lat = fmt[l-1].indexOf("@");
		if(l<4 && lat>-1) --l;
		if(fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
		if(typeof v !== "number") return [4, fmt.length === 4 || lat>-1?fmt[fmt.length-1]:"@"];
		switch(fmt.length) {
			case 1: fmt = lat>-1 ? ["General", "General", "General", fmt[0]] : [fmt[0], fmt[0], fmt[0], "@"]; break;
			case 2: fmt = lat>-1 ? [fmt[0], fmt[0], fmt[0], fmt[1]] : [fmt[0], fmt[1], fmt[0], "@"]; break;
			case 3: fmt = lat>-1 ? [fmt[0], fmt[1], fmt[0], fmt[2]] : [fmt[0], fmt[1], fmt[2], "@"]; break;
			case 4: break;
		}
		var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
		if(fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [l, ff];
		if(fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
			var m1 = fmt[0].match(cfregex2);
			var m2 = fmt[1].match(cfregex2);
			return chkcond(v, m1) ? [l, fmt[0]] : chkcond(v, m2) ? [l, fmt[1]] : [l, fmt[m1 != null && m2 != null ? 2 : 1]];
		}
		return [l, ff];
	}
	function SSF_format(fmt,v,o) {
		if(o == null) o = {};
		var sfmt = "";
		switch(typeof fmt) {
			case "string":
				if(fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
				else sfmt = fmt;
				break;
			case "number":
				if(fmt == 14 && o.dateNF) sfmt = o.dateNF;
				else sfmt = (o.table != null ? (o.table) : table_fmt)[fmt];
				if(sfmt == null) sfmt = (o.table && o.table[SSF_default_map[fmt]]) || table_fmt[SSF_default_map[fmt]];
				if(sfmt == null) sfmt = SSF_default_str[fmt] || "General";
				break;
		}
		if(SSF_isgeneral(sfmt,0)) return SSF_general(v, o);
		if(v instanceof Date) v = datenum_local(v, o.date1904);
		var f = choose_fmt(sfmt, v);
		if(SSF_isgeneral(f[1])) return SSF_general(v, o);
		if(v === true) v = "TRUE"; else if(v === false) v = "FALSE";
		else if(v === "" || v == null) return "";
		return eval_fmt(f[1], v, o, f[0]);
	}
	function SSF_load(fmt, idx) {
		if(typeof idx != 'number') {
			idx = +idx || -1;
	for(var i = 0; i < 0x0188; ++i) {
	if(table_fmt[i] == undefined) { if(idx < 0) idx = i; continue; }
				if(table_fmt[i] == fmt) { idx = i; break; }
			}
	if(idx < 0) idx = 0x187;
		}
	table_fmt[idx] = fmt;
		return idx;
	}
	function SSF_load_table(tbl) {
		for(var i=0; i!=0x0188; ++i)
			if(tbl[i] !== undefined) SSF_load(tbl[i], i);
	}
	
	function make_ssf() {
		table_fmt = SSF_init_table();
	}
	
	var SSF = {
		format: SSF_format,
		load: SSF_load,
		_table: table_fmt,
		load_table: SSF_load_table,
		parse_date_code: SSF_parse_date_code,
		is_date: fmt_is_date,
		get_table: function get_table() { return SSF._table = table_fmt; }
	};
	
	var SSFImplicit/*{[number]:string}*/ = ({
		"5": '"$"#,##0_);\\("$"#,##0\\)',
		"6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
		"7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
		"8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		"23": 'General', "24": 'General', "25": 'General', "26": 'General',
		"27": 'm/d/yy', "28": 'm/d/yy', "29": 'm/d/yy', "30": 'm/d/yy', "31": 'm/d/yy',
		"32": 'h:mm:ss', "33": 'h:mm:ss', "34": 'h:mm:ss', "35": 'h:mm:ss',
		"36": 'm/d/yy',
		"41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
		"42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
		"43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
		"44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
		"50": 'm/d/yy', "51": 'm/d/yy', "52": 'm/d/yy', "53": 'm/d/yy', "54": 'm/d/yy',
		"55": 'm/d/yy', "56": 'm/d/yy', "57": 'm/d/yy', "58": 'm/d/yy',
		"59": '0',
		"60": '0.00',
		"61": '#,##0',
		"62": '#,##0.00',
		"63": '"$"#,##0_);\\("$"#,##0\\)',
		"64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
		"65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
		"66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		"67": '0%',
		"68": '0.00%',
		"69": '# ?/?',
		"70": '# ??/??',
		"71": 'm/d/yy',
		"72": 'm/d/yy',
		"73": 'd-mmm-yy',
		"74": 'd-mmm',
		"75": 'mmm-yy',
		"76": 'h:mm',
		"77": 'h:mm:ss',
		"78": 'm/d/yy h:mm',
		"79": 'mm:ss',
		"80": '[h]:mm:ss',
		"81": 'mmss.0'
	});
	
	/* dateNF parse TODO: move to SSF */
	var dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
	function dateNF_regex(dateNF) {
		var fmt = typeof dateNF == "number" ? table_fmt[dateNF] : dateNF;
		fmt = fmt.replace(dateNFregex, "(\\d+)");
		return new RegExp("^" + fmt + "$");
	}
	function dateNF_fix(str, dateNF, match) {
		var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
		(dateNF.match(dateNFregex)||[]).forEach(function(n, i) {
			var v = parseInt(match[i+1], 10);
			switch(n.toLowerCase().charAt(0)) {
				case 'y': Y = v; break; case 'd': d = v; break;
				case 'h': H = v; break; case 's': S = v; break;
				case 'm': if(H >= 0) M = v; else m = v; break;
			}
		});
		if(S >= 0 && M == -1 && m >= 0) { M = m; m = -1; }
		var datestr = (("" + (Y>=0?Y: new Date().getFullYear())).slice(-4) + "-" + ("00" + (m>=1?m:1)).slice(-2) + "-" + ("00" + (d>=1?d:1)).slice(-2));
		if(datestr.length == 7) datestr = "0" + datestr;
		if(datestr.length == 8) datestr = "20" + datestr;
		var timestr = (("00" + (H>=0?H:0)).slice(-2) + ":" + ("00" + (M>=0?M:0)).slice(-2) + ":" + ("00" + (S>=0?S:0)).slice(-2));
		if(H == -1 && M == -1 && S == -1) return datestr;
		if(Y == -1 && m == -1 && d == -1) return timestr;
		return datestr + "T" + timestr;
	}
	
	/* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*jshint eqnull:true */
	/*exported CFB */
	/*global Uint8Array:false, Uint16Array:false */
	
	/* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*exported CRC32 */
	var CRC32 = (function() {
	var CRC32 = {};
	CRC32.version = '1.2.0';
	/* see perf/crc32table.js */
	/*global Int32Array */
	function signed_crc_table() {
		var c = 0, table = new Array(256);
	
		for(var n =0; n != 256; ++n){
			c = n;
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			table[n] = c;
		}
	
		return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
	}
	
	var T0 = signed_crc_table();
	function slice_by_16_tables(T) {
		var c = 0, v = 0, n = 0, table = typeof Int32Array !== 'undefined' ? new Int32Array(4096) : new Array(4096) ;
	
		for(n = 0; n != 256; ++n) table[n] = T[n];
		for(n = 0; n != 256; ++n) {
			v = T[n];
			for(c = 256 + n; c < 4096; c += 256) v = table[c] = (v >>> 8) ^ T[v & 0xFF];
		}
		var out = [];
		for(n = 1; n != 16; ++n) out[n - 1] = typeof Int32Array !== 'undefined' ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
		return out;
	}
	var TT = slice_by_16_tables(T0);
	var T1 = TT[0],  T2 = TT[1],  T3 = TT[2],  T4 = TT[3],  T5 = TT[4];
	var T6 = TT[5],  T7 = TT[6],  T8 = TT[7],  T9 = TT[8],  Ta = TT[9];
	var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
	function crc32_bstr(bstr, seed) {
		var C = seed ^ -1;
		for(var i = 0, L = bstr.length; i < L;) C = (C>>>8) ^ T0[(C^bstr.charCodeAt(i++))&0xFF];
		return ~C;
	}
	
	function crc32_buf(B, seed) {
		var C = seed ^ -1, L = B.length - 15, i = 0;
		for(; i < L;) C =
			Tf[B[i++] ^ (C & 255)] ^
			Te[B[i++] ^ ((C >> 8) & 255)] ^
			Td[B[i++] ^ ((C >> 16) & 255)] ^
			Tc[B[i++] ^ (C >>> 24)] ^
			Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^
			T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^
			T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
		L += 15;
		while(i < L) C = (C>>>8) ^ T0[(C^B[i++])&0xFF];
		return ~C;
	}
	
	function crc32_str(str, seed) {
		var C = seed ^ -1;
		for(var i = 0, L = str.length, c = 0, d = 0; i < L;) {
			c = str.charCodeAt(i++);
			if(c < 0x80) {
				C = (C>>>8) ^ T0[(C^c)&0xFF];
			} else if(c < 0x800) {
				C = (C>>>8) ^ T0[(C ^ (192|((c>>6)&31)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|(c&63)))&0xFF];
			} else if(c >= 0xD800 && c < 0xE000) {
				c = (c&1023)+64; d = str.charCodeAt(i++)&1023;
				C = (C>>>8) ^ T0[(C ^ (240|((c>>8)&7)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|((c>>2)&63)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|((d>>6)&15)|((c&3)<<4)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|(d&63)))&0xFF];
			} else {
				C = (C>>>8) ^ T0[(C ^ (224|((c>>12)&15)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|((c>>6)&63)))&0xFF];
				C = (C>>>8) ^ T0[(C ^ (128|(c&63)))&0xFF];
			}
		}
		return ~C;
	}
	CRC32.table = T0;
	CRC32.bstr = crc32_bstr;
	CRC32.buf = crc32_buf;
	CRC32.str = crc32_str;
	return CRC32;
	})();
	/* [MS-CFB] v20171201 */
	var CFB = (function _CFB(){
	var exports = {};
	exports.version = '1.2.1';
	/* [MS-CFB] 2.6.4 */
	function namecmp(l, r) {
		var L = l.split("/"), R = r.split("/");
		for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i) {
			if((c = L[i].length - R[i].length)) return c;
			if(L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
		}
		return L.length - R.length;
	}
	function dirname(p) {
		if(p.charAt(p.length - 1) == "/") return (p.slice(0,-1).indexOf("/") === -1) ? p : dirname(p.slice(0, -1));
		var c = p.lastIndexOf("/");
		return (c === -1) ? p : p.slice(0, c+1);
	}
	
	function filename(p) {
		if(p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
		var c = p.lastIndexOf("/");
		return (c === -1) ? p : p.slice(c+1);
	}
	/* -------------------------------------------------------------------------- */
	/* DOS Date format:
	   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
	   add 1980 to stored year
	   stored second should be doubled
	*/
	
	/* write JS date to buf as a DOS date */
	function write_dos_date(buf, date) {
		if(typeof date === "string") date = new Date(date);
		var hms = date.getHours();
		hms = hms << 6 | date.getMinutes();
		hms = hms << 5 | (date.getSeconds()>>>1);
		buf.write_shift(2, hms);
		var ymd = (date.getFullYear() - 1980);
		ymd = ymd << 4 | (date.getMonth()+1);
		ymd = ymd << 5 | date.getDate();
		buf.write_shift(2, ymd);
	}
	
	/* read four bytes from buf and interpret as a DOS date */
	function parse_dos_date(buf) {
		var hms = buf.read_shift(2) & 0xFFFF;
		var ymd = buf.read_shift(2) & 0xFFFF;
		var val = new Date();
		var d = ymd & 0x1F; ymd >>>= 5;
		var m = ymd & 0x0F; ymd >>>= 4;
		val.setMilliseconds(0);
		val.setFullYear(ymd + 1980);
		val.setMonth(m-1);
		val.setDate(d);
		var S = hms & 0x1F; hms >>>= 5;
		var M = hms & 0x3F; hms >>>= 6;
		val.setHours(hms);
		val.setMinutes(M);
		val.setSeconds(S<<1);
		return val;
	}
	function parse_extra_field(blob) {
		prep_blob(blob, 0);
		var o = {};
		var flags = 0;
		while(blob.l <= blob.length - 4) {
			var type = blob.read_shift(2);
			var sz = blob.read_shift(2), tgt = blob.l + sz;
			var p = {};
			switch(type) {
				/* UNIX-style Timestamps */
				case 0x5455: {
					flags = blob.read_shift(1);
					if(flags & 1) p.mtime = blob.read_shift(4);
					/* for some reason, CD flag corresponds to LFH */
					if(sz > 5) {
						if(flags & 2) p.atime = blob.read_shift(4);
						if(flags & 4) p.ctime = blob.read_shift(4);
					}
					if(p.mtime) p.mt = new Date(p.mtime*1000);
				}
				break;
			}
			blob.l = tgt;
			o[type] = p;
		}
		return o;
	}
	var fs;
	function get_fs() { return fs || (fs = __webpack_require__(790)); }
	function parse(file, options) {
	if(file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
	if((file[0] | 0x20) == 0x6d && (file[1]|0x20) == 0x69) return parse_mad(file, options);
	if(file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
	var mver = 3;
	var ssz = 512;
	var nmfs = 0; // number of mini FAT sectors
	var difat_sec_cnt = 0;
	var dir_start = 0;
	var minifat_start = 0;
	var difat_start = 0;
	
	var fat_addrs = []; // locations of FAT sectors
	
	/* [MS-CFB] 2.2 Compound File Header */
	var blob = file.slice(0,512);
	prep_blob(blob, 0);
	
	/* major version */
	var mv = check_get_mver(blob);
	mver = mv[0];
	switch(mver) {
		case 3: ssz = 512; break; case 4: ssz = 4096; break;
		case 0: if(mv[1] == 0) return parse_zip(file, options);
		/* falls through */
		default: throw new Error("Major Version: Expected 3 or 4 saw " + mver);
	}
	
	/* reprocess header */
	if(ssz !== 512) { blob = file.slice(0,ssz); prep_blob(blob, 28 /* blob.l */); }
	/* Save header for final object */
	var header = file.slice(0,ssz);
	
	check_shifts(blob, mver);
	
	// Number of Directory Sectors
	var dir_cnt = blob.read_shift(4, 'i');
	if(mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);
	
	// Number of FAT Sectors
	blob.l += 4;
	
	// First Directory Sector Location
	dir_start = blob.read_shift(4, 'i');
	
	// Transaction Signature
	blob.l += 4;
	
	// Mini Stream Cutoff Size
	blob.chk('00100000', 'Mini Stream Cutoff Size: ');
	
	// First Mini FAT Sector Location
	minifat_start = blob.read_shift(4, 'i');
	
	// Number of Mini FAT Sectors
	nmfs = blob.read_shift(4, 'i');
	
	// First DIFAT sector location
	difat_start = blob.read_shift(4, 'i');
	
	// Number of DIFAT Sectors
	difat_sec_cnt = blob.read_shift(4, 'i');
	
	// Grab FAT Sector Locations
	for(var q = -1, j = 0; j < 109; ++j) { /* 109 = (512 - blob.l)>>>2; */
		q = blob.read_shift(4, 'i');
		if(q<0) break;
		fat_addrs[j] = q;
	}
	
	/** Break the file up into sectors */
	var sectors = sectorify(file, ssz);
	
	sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
	
	/** Chains */
	var sector_list = make_sector_list(sectors, dir_start, fat_addrs, ssz);
	
	sector_list[dir_start].name = "!Directory";
	if(nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
	sector_list[fat_addrs[0]].name = "!FAT";
	sector_list.fat_addrs = fat_addrs;
	sector_list.ssz = ssz;
	
	/* [MS-CFB] 2.6.1 Compound File Directory Entry */
	var files = {}, Paths = [], FileIndex = [], FullPaths = [];
	read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
	
	build_full_paths(FileIndex, FullPaths, Paths);
	Paths.shift();
	
	var o = {
		FileIndex: FileIndex,
		FullPaths: FullPaths
	};
	
	// $FlowIgnore
	if(options && options.raw) o.raw = {header: header, sectors: sectors};
	return o;
	} // parse
	
	/* [MS-CFB] 2.2 Compound File Header -- read up to major version */
	function check_get_mver(blob) {
		if(blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [0, 0];
		// header signature 8
		blob.chk(HEADER_SIGNATURE, 'Header Signature: ');
	
		// clsid 16
		//blob.chk(HEADER_CLSID, 'CLSID: ');
		blob.l += 16;
	
		// minor version 2
		var mver = blob.read_shift(2, 'u');
	
		return [blob.read_shift(2,'u'), mver];
	}
	function check_shifts(blob, mver) {
		var shift = 0x09;
	
		// Byte Order
		//blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
		blob.l += 2;
	
		// Sector Shift
		switch((shift = blob.read_shift(2))) {
			case 0x09: if(mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift); break;
			case 0x0c: if(mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift); break;
			default: throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
		}
	
		// Mini Sector Shift
		blob.chk('0600', 'Mini Sector Shift: ');
	
		// Reserved
		blob.chk('000000000000', 'Reserved: ');
	}
	
	/** Break the file up into sectors */
	function sectorify(file, ssz) {
		var nsectors = Math.ceil(file.length/ssz)-1;
		var sectors = [];
		for(var i=1; i < nsectors; ++i) sectors[i-1] = file.slice(i*ssz,(i+1)*ssz);
		sectors[nsectors-1] = file.slice(nsectors*ssz);
		return sectors;
	}
	
	/* [MS-CFB] 2.6.4 Red-Black Tree */
	function build_full_paths(FI, FP, Paths) {
		var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
		var dad = [], q = [];
	
		for(; i < pl; ++i) { dad[i]=q[i]=i; FP[i]=Paths[i]; }
	
		for(; j < q.length; ++j) {
			i = q[j];
			L = FI[i].L; R = FI[i].R; C = FI[i].C;
			if(dad[i] === i) {
				if(L !== -1 /*NOSTREAM*/ && dad[L] !== L) dad[i] = dad[L];
				if(R !== -1 && dad[R] !== R) dad[i] = dad[R];
			}
			if(C !== -1 /*NOSTREAM*/) dad[C] = i;
			if(L !== -1 && i != dad[i]) { dad[L] = dad[i]; if(q.lastIndexOf(L) < j) q.push(L); }
			if(R !== -1 && i != dad[i]) { dad[R] = dad[i]; if(q.lastIndexOf(R) < j) q.push(R); }
		}
		for(i=1; i < pl; ++i) if(dad[i] === i) {
			if(R !== -1 /*NOSTREAM*/ && dad[R] !== R) dad[i] = dad[R];
			else if(L !== -1 && dad[L] !== L) dad[i] = dad[L];
		}
	
		for(i=1; i < pl; ++i) {
			if(FI[i].type === 0 /* unknown */) continue;
			j = i;
			if(j != dad[j]) do {
				j = dad[j];
				FP[i] = FP[j] + "/" + FP[i];
			} while (j !== 0 && -1 !== dad[j] && j != dad[j]);
			dad[i] = -1;
		}
	
		FP[0] += "/";
		for(i=1; i < pl; ++i) {
			if(FI[i].type !== 2 /* stream */) FP[i] += "/";
		}
	}
	
	function get_mfat_entry(entry, payload, mini) {
		var start = entry.start, size = entry.size;
		//return (payload.slice(start*MSSZ, start*MSSZ + size));
		var o = [];
		var idx = start;
		while(mini && size > 0 && idx >= 0) {
			o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
			size -= MSSZ;
			idx = __readInt32LE(mini, idx * 4);
		}
		if(o.length === 0) return (new_buf(0));
		return (bconcat(o).slice(0, entry.size));
	}
	
	/** Chase down the rest of the DIFAT chain to build a comprehensive list
	    DIFAT chains by storing the next sector number as the last 32 bits */
	function sleuth_fat(idx, cnt, sectors, ssz, fat_addrs) {
		var q = ENDOFCHAIN;
		if(idx === ENDOFCHAIN) {
			if(cnt !== 0) throw new Error("DIFAT chain shorter than expected");
		} else if(idx !== -1 /*FREESECT*/) {
			var sector = sectors[idx], m = (ssz>>>2)-1;
			if(!sector) return;
			for(var i = 0; i < m; ++i) {
				if((q = __readInt32LE(sector,i*4)) === ENDOFCHAIN) break;
				fat_addrs.push(q);
			}
			sleuth_fat(__readInt32LE(sector,ssz-4),cnt - 1, sectors, ssz, fat_addrs);
		}
	}
	
	/** Follow the linked list of sectors for a given starting point */
	function get_sector_list(sectors, start, fat_addrs, ssz, chkd) {
		var buf = [], buf_chain = [];
		if(!chkd) chkd = [];
		var modulus = ssz - 1, j = 0, jj = 0;
		for(j=start; j>=0;) {
			chkd[j] = true;
			buf[buf.length] = j;
			buf_chain.push(sectors[j]);
			var addr = fat_addrs[Math.floor(j*4/ssz)];
			jj = ((j*4) & modulus);
			if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
			if(!sectors[addr]) break;
			j = __readInt32LE(sectors[addr], jj);
		}
		return {nodes: buf, data:__toBuffer([buf_chain])};
	}
	
	/** Chase down the sector linked lists */
	function make_sector_list(sectors, dir_start, fat_addrs, ssz) {
		var sl = sectors.length, sector_list = ([]);
		var chkd = [], buf = [], buf_chain = [];
		var modulus = ssz - 1, i=0, j=0, k=0, jj=0;
		for(i=0; i < sl; ++i) {
			buf = ([]);
			k = (i + dir_start); if(k >= sl) k-=sl;
			if(chkd[k]) continue;
			buf_chain = [];
			var seen = [];
			for(j=k; j>=0;) {
				seen[j] = true;
				chkd[j] = true;
				buf[buf.length] = j;
				buf_chain.push(sectors[j]);
				var addr = fat_addrs[Math.floor(j*4/ssz)];
				jj = ((j*4) & modulus);
				if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
				if(!sectors[addr]) break;
				j = __readInt32LE(sectors[addr], jj);
				if(seen[j]) break;
			}
			sector_list[k] = ({nodes: buf, data:__toBuffer([buf_chain])});
		}
		return sector_list;
	}
	
	/* [MS-CFB] 2.6.1 Compound File Directory Entry */
	function read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, mini) {
		var minifat_store = 0, pl = (Paths.length?2:0);
		var sector = sector_list[dir_start].data;
		var i = 0, namelen = 0, name;
		for(; i < sector.length; i+= 128) {
			var blob = sector.slice(i, i+128);
			prep_blob(blob, 64);
			namelen = blob.read_shift(2);
			name = __utf16le(blob,0,namelen-pl);
			Paths.push(name);
			var o = ({
				name:  name,
				type:  blob.read_shift(1),
				color: blob.read_shift(1),
				L:     blob.read_shift(4, 'i'),
				R:     blob.read_shift(4, 'i'),
				C:     blob.read_shift(4, 'i'),
				clsid: blob.read_shift(16),
				state: blob.read_shift(4, 'i'),
				start: 0,
				size: 0
			});
			var ctime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
			if(ctime !== 0) o.ct = read_date(blob, blob.l-8);
			var mtime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
			if(mtime !== 0) o.mt = read_date(blob, blob.l-8);
			o.start = blob.read_shift(4, 'i');
			o.size = blob.read_shift(4, 'i');
			if(o.size < 0 && o.start < 0) { o.size = o.type = 0; o.start = ENDOFCHAIN; o.name = ""; }
			if(o.type === 5) { /* root */
				minifat_store = o.start;
				if(nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
				/*minifat_size = o.size;*/
			} else if(o.size >= 4096 /* MSCSZ */) {
				o.storage = 'fat';
				if(sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
				sector_list[o.start].name = o.name;
				o.content = (sector_list[o.start].data.slice(0,o.size));
			} else {
				o.storage = 'minifat';
				if(o.size < 0) o.size = 0;
				else if(minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) {
					o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini]||{}).data);
				}
			}
			if(o.content) prep_blob(o.content, 0);
			files[name] = o;
			FileIndex.push(o);
		}
	}
	
	function read_date(blob, offset) {
		return new Date(( ( (__readUInt32LE(blob,offset+4)/1e7)*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7 ) - 11644473600)*1000);
	}
	
	function read_file(filename, options) {
		get_fs();
		return parse(fs.readFileSync(filename), options);
	}
	
	function read(blob, options) {
		var type = options && options.type;
		if(!type) {
			if(has_buf && Buffer.isBuffer(blob)) type = "buffer";
		}
		switch(type || "base64") {
			case "file": return read_file(blob, options);
			case "base64": return parse(s2a(Base64_decode(blob)), options);
			case "binary": return parse(s2a(blob), options);
		}
		return parse(blob, options);
	}
	
	function init_cfb(cfb, opts) {
		var o = opts || {}, root = o.root || "Root Entry";
		if(!cfb.FullPaths) cfb.FullPaths = [];
		if(!cfb.FileIndex) cfb.FileIndex = [];
		if(cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
		if(cfb.FullPaths.length === 0) {
			cfb.FullPaths[0] = root + "/";
			cfb.FileIndex[0] = ({ name: root, type: 5 });
		}
		if(o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
		seed_cfb(cfb);
	}
	function seed_cfb(cfb) {
		var nm = "\u0001Sh33tJ5";
		if(CFB.find(cfb, "/" + nm)) return;
		var p = new_buf(4); p[0] = 55; p[1] = p[3] = 50; p[2] = 54;
		cfb.FileIndex.push(({ name: nm, type: 2, content:p, size:4, L:69, R:69, C:69 }));
		cfb.FullPaths.push(cfb.FullPaths[0] + nm);
		rebuild_cfb(cfb);
	}
	function rebuild_cfb(cfb, f) {
		init_cfb(cfb);
		var gc = false, s = false;
		for(var i = cfb.FullPaths.length - 1; i >= 0; --i) {
			var _file = cfb.FileIndex[i];
			switch(_file.type) {
				case 0:
					if(s) gc = true;
					else { cfb.FileIndex.pop(); cfb.FullPaths.pop(); }
					break;
				case 1: case 2: case 5:
					s = true;
					if(isNaN(_file.R * _file.L * _file.C)) gc = true;
					if(_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
					break;
				default: gc = true; break;
			}
		}
		if(!gc && !f) return;
	
		var now = new Date(1987, 1, 19), j = 0;
		// Track which names exist
		var fullPaths = Object.create ? Object.create(null) : {};
		var data = [];
		for(i = 0; i < cfb.FullPaths.length; ++i) {
			fullPaths[cfb.FullPaths[i]] = true;
			if(cfb.FileIndex[i].type === 0) continue;
			data.push([cfb.FullPaths[i], cfb.FileIndex[i]]);
		}
		for(i = 0; i < data.length; ++i) {
			var dad = dirname(data[i][0]);
			s = fullPaths[dad];
			if(!s) {
				data.push([dad, ({
					name: filename(dad).replace("/",""),
					type: 1,
					clsid: HEADER_CLSID,
					ct: now, mt: now,
					content: null
				})]);
				// Add name to set
				fullPaths[dad] = true;
			}
		}
	
		data.sort(function(x,y) { return namecmp(x[0], y[0]); });
		cfb.FullPaths = []; cfb.FileIndex = [];
		for(i = 0; i < data.length; ++i) { cfb.FullPaths[i] = data[i][0]; cfb.FileIndex[i] = data[i][1]; }
		for(i = 0; i < data.length; ++i) {
			var elt = cfb.FileIndex[i];
			var nm = cfb.FullPaths[i];
	
			elt.name =  filename(nm).replace("/","");
			elt.L = elt.R = elt.C = -(elt.color = 1);
			elt.size = elt.content ? elt.content.length : 0;
			elt.start = 0;
			elt.clsid = (elt.clsid || HEADER_CLSID);
			if(i === 0) {
				elt.C = data.length > 1 ? 1 : -1;
				elt.size = 0;
				elt.type = 5;
			} else if(nm.slice(-1) == "/") {
				for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==nm) break;
				elt.C = j >= data.length ? -1 : j;
				for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==dirname(nm)) break;
				elt.R = j >= data.length ? -1 : j;
				elt.type = 1;
			} else {
				if(dirname(cfb.FullPaths[i+1]||"") == dirname(nm)) elt.R = i + 1;
				elt.type = 2;
			}
		}
	
	}
	
	function _write(cfb, options) {
		var _opts = options || {};
		/* MAD is order-sensitive, skip rebuild and sort */
		if(_opts.fileType == 'mad') return write_mad(cfb, _opts);
		rebuild_cfb(cfb);
		switch(_opts.fileType) {
			case 'zip': return write_zip(cfb, _opts);
			//case 'mad': return write_mad(cfb, _opts);
		}
		var L = (function(cfb){
			var mini_size = 0, fat_size = 0;
			for(var i = 0; i < cfb.FileIndex.length; ++i) {
				var file = cfb.FileIndex[i];
				if(!file.content) continue;
	var flen = file.content.length;
				if(flen > 0){
					if(flen < 0x1000) mini_size += (flen + 0x3F) >> 6;
					else fat_size += (flen + 0x01FF) >> 9;
				}
			}
			var dir_cnt = (cfb.FullPaths.length +3) >> 2;
			var mini_cnt = (mini_size + 7) >> 3;
			var mfat_cnt = (mini_size + 0x7F) >> 7;
			var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
			var fat_cnt = (fat_base + 0x7F) >> 7;
			var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
			while(((fat_base + fat_cnt + difat_cnt + 0x7F) >> 7) > fat_cnt) difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
			var L =  [1, difat_cnt, fat_cnt, mfat_cnt, dir_cnt, fat_size, mini_size, 0];
			cfb.FileIndex[0].size = mini_size << 6;
			L[7] = (cfb.FileIndex[0].start=L[0]+L[1]+L[2]+L[3]+L[4]+L[5])+((L[6]+7) >> 3);
			return L;
		})(cfb);
		var o = new_buf(L[7] << 9);
		var i = 0, T = 0;
		{
			for(i = 0; i < 8; ++i) o.write_shift(1, HEADER_SIG[i]);
			for(i = 0; i < 8; ++i) o.write_shift(2, 0);
			o.write_shift(2, 0x003E);
			o.write_shift(2, 0x0003);
			o.write_shift(2, 0xFFFE);
			o.write_shift(2, 0x0009);
			o.write_shift(2, 0x0006);
			for(i = 0; i < 3; ++i) o.write_shift(2, 0);
			o.write_shift(4, 0);
			o.write_shift(4, L[2]);
			o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
			o.write_shift(4, 0);
			o.write_shift(4, 1<<12);
			o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1: ENDOFCHAIN);
			o.write_shift(4, L[3]);
			o.write_shift(-4, L[1] ? L[0] - 1: ENDOFCHAIN);
			o.write_shift(4, L[1]);
			for(i = 0; i < 109; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
		}
		if(L[1]) {
			for(T = 0; T < L[1]; ++T) {
				for(; i < 236 + T * 127; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
				o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
			}
		}
		var chainit = function(w) {
			for(T += w; i<T-1; ++i) o.write_shift(-4, i+1);
			if(w) { ++i; o.write_shift(-4, ENDOFCHAIN); }
		};
		T = i = 0;
		for(T+=L[1]; i<T; ++i) o.write_shift(-4, consts.DIFSECT);
		for(T+=L[2]; i<T; ++i) o.write_shift(-4, consts.FATSECT);
		chainit(L[3]);
		chainit(L[4]);
		var j = 0, flen = 0;
		var file = cfb.FileIndex[0];
		for(; j < cfb.FileIndex.length; ++j) {
			file = cfb.FileIndex[j];
			if(!file.content) continue;
	flen = file.content.length;
			if(flen < 0x1000) continue;
			file.start = T;
			chainit((flen + 0x01FF) >> 9);
		}
		chainit((L[6] + 7) >> 3);
		while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
		T = i = 0;
		for(j = 0; j < cfb.FileIndex.length; ++j) {
			file = cfb.FileIndex[j];
			if(!file.content) continue;
	flen = file.content.length;
			if(!flen || flen >= 0x1000) continue;
			file.start = T;
			chainit((flen + 0x3F) >> 6);
		}
		while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
		for(i = 0; i < L[4]<<2; ++i) {
			var nm = cfb.FullPaths[i];
			if(!nm || nm.length === 0) {
				for(j = 0; j < 17; ++j) o.write_shift(4, 0);
				for(j = 0; j < 3; ++j) o.write_shift(4, -1);
				for(j = 0; j < 12; ++j) o.write_shift(4, 0);
				continue;
			}
			file = cfb.FileIndex[i];
			if(i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
			var _nm = (i === 0 && _opts.root) || file.name;
			flen = 2*(_nm.length+1);
			o.write_shift(64, _nm, "utf16le");
			o.write_shift(2, flen);
			o.write_shift(1, file.type);
			o.write_shift(1, file.color);
			o.write_shift(-4, file.L);
			o.write_shift(-4, file.R);
			o.write_shift(-4, file.C);
			if(!file.clsid) for(j = 0; j < 4; ++j) o.write_shift(4, 0);
			else o.write_shift(16, file.clsid, "hex");
			o.write_shift(4, file.state || 0);
			o.write_shift(4, 0); o.write_shift(4, 0);
			o.write_shift(4, 0); o.write_shift(4, 0);
			o.write_shift(4, file.start);
			o.write_shift(4, file.size); o.write_shift(4, 0);
		}
		for(i = 1; i < cfb.FileIndex.length; ++i) {
			file = cfb.FileIndex[i];
	if(file.size >= 0x1000) {
				o.l = (file.start+1) << 9;
				if (has_buf && Buffer.isBuffer(file.content)) {
					file.content.copy(o, o.l, 0, file.size);
					// o is a 0-filled Buffer so just set next offset
					o.l += (file.size + 511) & -512;
				} else {
					for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
					for(; j & 0x1FF; ++j) o.write_shift(1, 0);
				}
			}
		}
		for(i = 1; i < cfb.FileIndex.length; ++i) {
			file = cfb.FileIndex[i];
	if(file.size > 0 && file.size < 0x1000) {
				if (has_buf && Buffer.isBuffer(file.content)) {
					file.content.copy(o, o.l, 0, file.size);
					// o is a 0-filled Buffer so just set next offset
					o.l += (file.size + 63) & -64;
				} else {
					for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
					for(; j & 0x3F; ++j) o.write_shift(1, 0);
				}
			}
		}
		if (has_buf) {
			o.l = o.length;
		} else {
			// When using Buffer, already 0-filled
			while(o.l < o.length) o.write_shift(1, 0);
		}
		return o;
	}
	/* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */
	function find(cfb, path) {
		var UCFullPaths = cfb.FullPaths.map(function(x) { return x.toUpperCase(); });
		var UCPaths = UCFullPaths.map(function(x) { var y = x.split("/"); return y[y.length - (x.slice(-1) == "/" ? 2 : 1)]; });
		var k = false;
		if(path.charCodeAt(0) === 47 /* "/" */) { k = true; path = UCFullPaths[0].slice(0, -1) + path; }
		else k = path.indexOf("/") !== -1;
		var UCPath = path.toUpperCase();
		var w = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
		if(w !== -1) return cfb.FileIndex[w];
	
		var m = !UCPath.match(chr1);
		UCPath = UCPath.replace(chr0,'');
		if(m) UCPath = UCPath.replace(chr1,'!');
		for(w = 0; w < UCFullPaths.length; ++w) {
			if((m ? UCFullPaths[w].replace(chr1,'!') : UCFullPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
			if((m ? UCPaths[w].replace(chr1,'!') : UCPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
		}
		return null;
	}
	/** CFB Constants */
	var MSSZ = 64; /* Mini Sector Size = 1<<6 */
	//var MSCSZ = 4096; /* Mini Stream Cutoff Size */
	/* 2.1 Compound File Sector Numbers and Types */
	var ENDOFCHAIN = -2;
	/* 2.2 Compound File Header */
	var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
	var HEADER_SIG = [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1];
	var HEADER_CLSID = '00000000000000000000000000000000';
	var consts = {
		/* 2.1 Compund File Sector Numbers and Types */
		MAXREGSECT: -6,
		DIFSECT: -4,
		FATSECT: -3,
		ENDOFCHAIN: ENDOFCHAIN,
		FREESECT: -1,
		/* 2.2 Compound File Header */
		HEADER_SIGNATURE: HEADER_SIGNATURE,
		HEADER_MINOR_VERSION: '3e00',
		MAXREGSID: -6,
		NOSTREAM: -1,
		HEADER_CLSID: HEADER_CLSID,
		/* 2.6.1 Compound File Directory Entry */
		EntryTypes: ['unknown','storage','stream','lockbytes','property','root']
	};
	
	function write_file(cfb, filename, options) {
		get_fs();
		var o = _write(cfb, options);
	fs.writeFileSync(filename, o);
	}
	
	function a2s(o) {
		var out = new Array(o.length);
		for(var i = 0; i < o.length; ++i) out[i] = String.fromCharCode(o[i]);
		return out.join("");
	}
	
	function write(cfb, options) {
		var o = _write(cfb, options);
		switch(options && options.type || "buffer") {
			case "file": get_fs(); fs.writeFileSync(options.filename, (o)); return o;
			case "binary": return typeof o == "string" ? o : a2s(o);
			case "base64": return Base64_encode(typeof o == "string" ? o : a2s(o));
			case "buffer": if(has_buf) return Buffer.isBuffer(o) ? o : Buffer_from(o);
				/* falls through */
			case "array": return typeof o == "string" ? s2a(o) : o;
		}
		return o;
	}
	/* node < 8.1 zlib does not expose bytesRead, so default to pure JS */
	var _zlib;
	function use_zlib(zlib) { try {
		var InflateRaw = zlib.InflateRaw;
		var InflRaw = new InflateRaw();
		InflRaw._processChunk(new Uint8Array([3, 0]), InflRaw._finishFlushFlag);
		if(InflRaw.bytesRead) _zlib = zlib;
		else throw new Error("zlib does not expose bytesRead");
	} catch(e) {console.error("cannot use native zlib: " + (e.message || e)); } }
	
	function _inflateRawSync(payload, usz) {
		if(!_zlib) return _inflate(payload, usz);
		var InflateRaw = _zlib.InflateRaw;
		var InflRaw = new InflateRaw();
		var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
		payload.l += InflRaw.bytesRead;
		return out;
	}
	
	function _deflateRawSync(payload) {
		return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
	}
	var CLEN_ORDER = [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	/*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */
	var LEN_LN = [   3,   4,   5,   6,   7,   8,   9,  10,  11,  13 , 15,  17,  19,  23,  27,  31,  35,  43,  51,  59,  67,  83,  99, 115, 131, 163, 195, 227, 258 ];
	
	/*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */
	var DST_LN = [  1,  2,  3,  4,  5,  7,  9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577 ];
	
	function bit_swap_8(n) { var t = (((((n<<1)|(n<<11)) & 0x22110) | (((n<<5)|(n<<15)) & 0x88440))); return ((t>>16) | (t>>8) |t)&0xFF; }
	
	var use_typed_arrays = typeof Uint8Array !== 'undefined';
	
	var bitswap8 = use_typed_arrays ? new Uint8Array(1<<8) : [];
	for(var q = 0; q < (1<<8); ++q) bitswap8[q] = bit_swap_8(q);
	
	function bit_swap_n(n, b) {
		var rev = bitswap8[n & 0xFF];
		if(b <= 8) return rev >>> (8-b);
		rev = (rev << 8) | bitswap8[(n>>8)&0xFF];
		if(b <= 16) return rev >>> (16-b);
		rev = (rev << 8) | bitswap8[(n>>16)&0xFF];
		return rev >>> (24-b);
	}
	
	/* helpers for unaligned bit reads */
	function read_bits_2(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 6 ? 0 : buf[h+1]<<8))>>>w)& 0x03; }
	function read_bits_3(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 5 ? 0 : buf[h+1]<<8))>>>w)& 0x07; }
	function read_bits_4(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 4 ? 0 : buf[h+1]<<8))>>>w)& 0x0F; }
	function read_bits_5(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 3 ? 0 : buf[h+1]<<8))>>>w)& 0x1F; }
	function read_bits_7(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 1 ? 0 : buf[h+1]<<8))>>>w)& 0x7F; }
	
	/* works up to n = 3 * 8 + 1 = 25 */
	function read_bits_n(buf, bl, n) {
		var w = (bl&7), h = (bl>>>3), f = ((1<<n)-1);
		var v = buf[h] >>> w;
		if(n < 8 - w) return v & f;
		v |= buf[h+1]<<(8-w);
		if(n < 16 - w) return v & f;
		v |= buf[h+2]<<(16-w);
		if(n < 24 - w) return v & f;
		v |= buf[h+3]<<(24-w);
		return v & f;
	}
	
	/* helpers for unaligned bit writes */
	function write_bits_3(buf, bl, v) { var w = bl & 7, h = bl >>> 3;
		if(w <= 5) buf[h] |= (v & 7) << w;
		else {
			buf[h] |= (v << w) & 0xFF;
			buf[h+1] = (v&7) >> (8-w);
		}
		return bl + 3;
	}
	
	function write_bits_1(buf, bl, v) {
		var w = bl & 7, h = bl >>> 3;
		v = (v&1) << w;
		buf[h] |= v;
		return bl + 1;
	}
	function write_bits_8(buf, bl, v) {
		var w = bl & 7, h = bl >>> 3;
		v <<= w;
		buf[h] |=  v & 0xFF; v >>>= 8;
		buf[h+1] = v;
		return bl + 8;
	}
	function write_bits_16(buf, bl, v) {
		var w = bl & 7, h = bl >>> 3;
		v <<= w;
		buf[h] |=  v & 0xFF; v >>>= 8;
		buf[h+1] = v & 0xFF;
		buf[h+2] = v >>> 8;
		return bl + 16;
	}
	
	/* until ArrayBuffer#realloc is a thing, fake a realloc */
	function realloc(b, sz) {
		var L = b.length, M = 2*L > sz ? 2*L : sz + 5, i = 0;
		if(L >= sz) return b;
		if(has_buf) {
			var o = new_unsafe_buf(M);
			// $FlowIgnore
			if(b.copy) b.copy(o);
			else for(; i < b.length; ++i) o[i] = b[i];
			return o;
		} else if(use_typed_arrays) {
			var a = new Uint8Array(M);
			if(a.set) a.set(b);
			else for(; i < L; ++i) a[i] = b[i];
			return a;
		}
		b.length = M;
		return b;
	}
	
	/* zero-filled arrays for older browsers */
	function zero_fill_array(n) {
		var o = new Array(n);
		for(var i = 0; i < n; ++i) o[i] = 0;
		return o;
	}
	
	/* build tree (used for literals and lengths) */
	function build_tree(clens, cmap, MAX) {
		var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
	
		var bl_count  = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
		for(i = 0; i < 32; ++i) bl_count[i] = 0;
	
		for(i = L; i < MAX; ++i) clens[i] = 0;
		L = clens.length;
	
		var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
	
		/* build code tree */
		for(i = 0; i < L; ++i) {
			bl_count[(w = clens[i])]++;
			if(maxlen < w) maxlen = w;
			ctree[i] = 0;
		}
		bl_count[0] = 0;
		for(i = 1; i <= maxlen; ++i) bl_count[i+16] = (ccode = (ccode + bl_count[i-1])<<1);
		for(i = 0; i < L; ++i) {
			ccode = clens[i];
			if(ccode != 0) ctree[i] = bl_count[ccode+16]++;
		}
	
		/* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */
		var cleni = 0;
		for(i = 0; i < L; ++i) {
			cleni = clens[i];
			if(cleni != 0) {
				ccode = bit_swap_n(ctree[i], maxlen)>>(maxlen-cleni);
				for(j = (1<<(maxlen + 4 - cleni)) - 1; j>=0; --j)
					cmap[ccode|(j<<cleni)] = (cleni&15) | (i<<4);
			}
		}
		return maxlen;
	}
	
	/* Fixed Huffman */
	var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
	var fix_dmap = use_typed_arrays ? new Uint16Array(32)  : zero_fill_array(32);
	if(!use_typed_arrays) {
		for(var i = 0; i < 512; ++i) fix_lmap[i] = 0;
		for(i = 0; i < 32; ++i) fix_dmap[i] = 0;
	}
	(function() {
		var dlens = [];
		var i = 0;
		for(;i<32; i++) dlens.push(5);
		build_tree(dlens, fix_dmap, 32);
	
		var clens = [];
		i = 0;
		for(; i<=143; i++) clens.push(8);
		for(; i<=255; i++) clens.push(9);
		for(; i<=279; i++) clens.push(7);
		for(; i<=287; i++) clens.push(8);
		build_tree(clens, fix_lmap, 288);
	})();var _deflateRaw = (function _deflateRawIIFE() {
		var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
		var j = 0, k = 0;
		for(; j < DST_LN.length - 1; ++j) {
			for(; k < DST_LN[j+1]; ++k) DST_LN_RE[k] = j;
		}
		for(;k < 32768; ++k) DST_LN_RE[k] = 29;
	
		var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
		for(j = 0, k = 0; j < LEN_LN.length - 1; ++j) {
			for(; k < LEN_LN[j+1]; ++k) LEN_LN_RE[k] = j;
		}
	
		function write_stored(data, out) {
			var boff = 0;
			while(boff < data.length) {
				var L = Math.min(0xFFFF, data.length - boff);
				var h = boff + L == data.length;
				out.write_shift(1, +h);
				out.write_shift(2, L);
				out.write_shift(2, (~L) & 0xFFFF);
				while(L-- > 0) out[out.l++] = data[boff++];
			}
			return out.l;
		}
	
		/* Fixed Huffman */
		function write_huff_fixed(data, out) {
			var bl = 0;
			var boff = 0;
			var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
			while(boff < data.length) {
				var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);
	
				/* write a stored block for short data */
				if(L < 10) {
					bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
					if(bl & 7) bl += 8 - (bl & 7);
					out.l = (bl / 8) | 0;
					out.write_shift(2, L);
					out.write_shift(2, (~L) & 0xFFFF);
					while(L-- > 0) out[out.l++] = data[boff++];
					bl = out.l * 8;
					continue;
				}
	
				bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
				var hash = 0;
				while(L-- > 0) {
					var d = data[boff];
					hash = ((hash << 5) ^ d) & 0x7FFF;
	
					var match = -1, mlen = 0;
	
					if((match = addrs[hash])) {
						match |= boff & ~0x7FFF;
						if(match > boff) match -= 0x8000;
						if(match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250) ++mlen;
					}
	
					if(mlen > 2) {
						/* Copy Token  */
						d = LEN_LN_RE[mlen];
						if(d <= 22) bl = write_bits_8(out, bl, bitswap8[d+1]>>1) - 1;
						else {
							write_bits_8(out, bl, 3);
							bl += 5;
							write_bits_8(out, bl, bitswap8[d-23]>>5);
							bl += 3;
						}
						var len_eb = (d < 8) ? 0 : ((d - 4)>>2);
						if(len_eb > 0) {
							write_bits_16(out, bl, mlen - LEN_LN[d]);
							bl += len_eb;
						}
	
						d = DST_LN_RE[boff - match];
						bl = write_bits_8(out, bl, bitswap8[d]>>3);
						bl -= 3;
	
						var dst_eb = d < 4 ? 0 : (d-2)>>1;
						if(dst_eb > 0) {
							write_bits_16(out, bl, boff - match - DST_LN[d]);
							bl += dst_eb;
						}
						for(var q = 0; q < mlen; ++q) {
							addrs[hash] = boff & 0x7FFF;
							hash = ((hash << 5) ^ data[boff]) & 0x7FFF;
							++boff;
						}
						L-= mlen - 1;
					} else {
						/* Literal Token */
						if(d <= 143) d = d + 48;
						else bl = write_bits_1(out, bl, 1);
						bl = write_bits_8(out, bl, bitswap8[d]);
						addrs[hash] = boff & 0x7FFF;
						++boff;
					}
				}
	
				bl = write_bits_8(out, bl, 0) - 1;
			}
			out.l = ((bl + 7)/8)|0;
			return out.l;
		}
		return function _deflateRaw(data, out) {
			if(data.length < 8) return write_stored(data, out);
			return write_huff_fixed(data, out);
		};
	})();
	
	function _deflate(data) {
		var buf = new_buf(50+Math.floor(data.length*1.1));
		var off = _deflateRaw(data, buf);
		return buf.slice(0, off);
	}
	/* modified inflate function also moves original read head */
	
	var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
	var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
	var dyn_cmap = use_typed_arrays ? new Uint16Array(128)   : zero_fill_array(128);
	var dyn_len_1 = 1, dyn_len_2 = 1;
	
	/* 5.5.3 Expanding Huffman Codes */
	function dyn(data, boff) {
		/* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */
		var _HLIT = read_bits_5(data, boff) + 257; boff += 5;
		var _HDIST = read_bits_5(data, boff) + 1; boff += 5;
		var _HCLEN = read_bits_4(data, boff) + 4; boff += 4;
		var w = 0;
	
		/* grab and store code lengths */
		var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
		var ctree = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ];
		var maxlen = 1;
		var bl_count =  use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
		var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
		var L = clens.length; /* 19 */
		for(var i = 0; i < _HCLEN; ++i) {
			clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
			if(maxlen < w) maxlen = w;
			bl_count[w]++;
			boff += 3;
		}
	
		/* build code tree */
		var ccode = 0;
		bl_count[0] = 0;
		for(i = 1; i <= maxlen; ++i) next_code[i] = ccode = (ccode + bl_count[i-1])<<1;
		for(i = 0; i < L; ++i) if((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
		/* cmap[7 bits from stream] = (off&7) + (lit<<3) */
		var cleni = 0;
		for(i = 0; i < L; ++i) {
			cleni = clens[i];
			if(cleni != 0) {
				ccode = bitswap8[ctree[i]]>>(8-cleni);
				for(var j = (1<<(7-cleni))-1; j>=0; --j) dyn_cmap[ccode|(j<<cleni)] = (cleni&7) | (i<<3);
			}
		}
	
		/* read literal and dist codes at once */
		var hcodes = [];
		maxlen = 1;
		for(; hcodes.length < _HLIT + _HDIST;) {
			ccode = dyn_cmap[read_bits_7(data, boff)];
			boff += ccode & 7;
			switch((ccode >>>= 3)) {
				case 16:
					w = 3 + read_bits_2(data, boff); boff += 2;
					ccode = hcodes[hcodes.length - 1];
					while(w-- > 0) hcodes.push(ccode);
					break;
				case 17:
					w = 3 + read_bits_3(data, boff); boff += 3;
					while(w-- > 0) hcodes.push(0);
					break;
				case 18:
					w = 11 + read_bits_7(data, boff); boff += 7;
					while(w -- > 0) hcodes.push(0);
					break;
				default:
					hcodes.push(ccode);
					if(maxlen < ccode) maxlen = ccode;
					break;
			}
		}
	
		/* build literal / length trees */
		var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
		for(i = _HLIT; i < 286; ++i) h1[i] = 0;
		for(i = _HDIST; i < 30; ++i) h2[i] = 0;
		dyn_len_1 = build_tree(h1, dyn_lmap, 286);
		dyn_len_2 = build_tree(h2, dyn_dmap, 30);
		return boff;
	}
	
	/* return [ data, bytesRead ] */
	function inflate(data, usz) {
		/* shortcircuit for empty buffer [0x03, 0x00] */
		if(data[0] == 3 && !(data[1] & 0x3)) { return [new_raw_buf(usz), 2]; }
	
		/* bit offset */
		var boff = 0;
	
		/* header includes final bit and type bits */
		var header = 0;
	
		var outbuf = new_unsafe_buf(usz ? usz : (1<<18));
		var woff = 0;
		var OL = outbuf.length>>>0;
		var max_len_1 = 0, max_len_2 = 0;
	
		while((header&1) == 0) {
			header = read_bits_3(data, boff); boff += 3;
			if((header >>> 1) == 0) {
				/* Stored block */
				if(boff & 7) boff += 8 - (boff&7);
				/* 2 bytes sz, 2 bytes bit inverse */
				var sz = data[boff>>>3] | data[(boff>>>3)+1]<<8;
				boff += 32;
				/* push sz bytes */
				if(sz > 0) {
					if(!usz && OL < woff + sz) { outbuf = realloc(outbuf, woff + sz); OL = outbuf.length; }
					while(sz-- > 0) { outbuf[woff++] = data[boff>>>3]; boff += 8; }
				}
				continue;
			} else if((header >> 1) == 1) {
				/* Fixed Huffman */
				max_len_1 = 9; max_len_2 = 5;
			} else {
				/* Dynamic Huffman */
				boff = dyn(data, boff);
				max_len_1 = dyn_len_1; max_len_2 = dyn_len_2;
			}
			for(;;) { // while(true) is apparently out of vogue in modern JS circles
				if(!usz && (OL < woff + 32767)) { outbuf = realloc(outbuf, woff + 32767); OL = outbuf.length; }
				/* ingest code and move read head */
				var bits = read_bits_n(data, boff, max_len_1);
				var code = (header>>>1) == 1 ? fix_lmap[bits] : dyn_lmap[bits];
				boff += code & 15; code >>>= 4;
				/* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */
				if(((code>>>8)&0xFF) === 0) outbuf[woff++] = code;
				else if(code == 256) break;
				else {
					code -= 257;
					var len_eb = (code < 8) ? 0 : ((code-4)>>2); if(len_eb > 5) len_eb = 0;
					var tgt = woff + LEN_LN[code];
					/* length extra bits */
					if(len_eb > 0) {
						tgt += read_bits_n(data, boff, len_eb);
						boff += len_eb;
					}
	
					/* dist code */
					bits = read_bits_n(data, boff, max_len_2);
					code = (header>>>1) == 1 ? fix_dmap[bits] : dyn_dmap[bits];
					boff += code & 15; code >>>= 4;
					var dst_eb = (code < 4 ? 0 : (code-2)>>1);
					var dst = DST_LN[code];
					/* dist extra bits */
					if(dst_eb > 0) {
						dst += read_bits_n(data, boff, dst_eb);
						boff += dst_eb;
					}
	
					/* in the common case, manual byte copy is faster than TA set / Buffer copy */
					if(!usz && OL < tgt) { outbuf = realloc(outbuf, tgt + 100); OL = outbuf.length; }
					while(woff < tgt) { outbuf[woff] = outbuf[woff - dst]; ++woff; }
				}
			}
		}
		if(usz) return [outbuf, (boff+7)>>>3];
		return [outbuf.slice(0, woff), (boff+7)>>>3];
	}
	
	function _inflate(payload, usz) {
		var data = payload.slice(payload.l||0);
		var out = inflate(data, usz);
		payload.l += out[1];
		return out[0];
	}
	
	function warn_or_throw(wrn, msg) {
		if(wrn) { if(typeof console !== 'undefined') console.error(msg); }
		else throw new Error(msg);
	}
	
	function parse_zip(file, options) {
		var blob = file;
		prep_blob(blob, 0);
	
		var FileIndex = [], FullPaths = [];
		var o = {
			FileIndex: FileIndex,
			FullPaths: FullPaths
		};
		init_cfb(o, { root: options.root });
	
		/* find end of central directory, start just after signature */
		var i = blob.length - 4;
		while((blob[i] != 0x50 || blob[i+1] != 0x4b || blob[i+2] != 0x05 || blob[i+3] != 0x06) && i >= 0) --i;
		blob.l = i + 4;
	
		/* parse end of central directory */
		blob.l += 4;
		var fcnt = blob.read_shift(2);
		blob.l += 6;
		var start_cd = blob.read_shift(4);
	
		/* parse central directory */
		blob.l = start_cd;
	
		for(i = 0; i < fcnt; ++i) {
			/* trust local file header instead of CD entry */
			blob.l += 20;
			var csz = blob.read_shift(4);
			var usz = blob.read_shift(4);
			var namelen = blob.read_shift(2);
			var efsz = blob.read_shift(2);
			var fcsz = blob.read_shift(2);
			blob.l += 8;
			var offset = blob.read_shift(4);
			var EF = parse_extra_field(blob.slice(blob.l+namelen, blob.l+namelen+efsz));
			blob.l += namelen + efsz + fcsz;
	
			var L = blob.l;
			blob.l = offset + 4;
			parse_local_file(blob, csz, usz, o, EF);
			blob.l = L;
		}
		return o;
	}
	
	
	/* head starts just after local file header signature */
	function parse_local_file(blob, csz, usz, o, EF) {
		/* [local file header] */
		blob.l += 2;
		var flags = blob.read_shift(2);
		var meth = blob.read_shift(2);
		var date = parse_dos_date(blob);
	
		if(flags & 0x2041) throw new Error("Unsupported ZIP encryption");
		var crc32 = blob.read_shift(4);
		var _csz = blob.read_shift(4);
		var _usz = blob.read_shift(4);
	
		var namelen = blob.read_shift(2);
		var efsz = blob.read_shift(2);
	
		// TODO: flags & (1<<11) // UTF8
		var name = ""; for(var i = 0; i < namelen; ++i) name += String.fromCharCode(blob[blob.l++]);
		if(efsz) {
			var ef = parse_extra_field(blob.slice(blob.l, blob.l + efsz));
			if((ef[0x5455]||{}).mt) date = ef[0x5455].mt;
			if(((EF||{})[0x5455]||{}).mt) date = EF[0x5455].mt;
		}
		blob.l += efsz;
	
		/* [encryption header] */
	
		/* [file data] */
		var data = blob.slice(blob.l, blob.l + _csz);
		switch(meth) {
			case 8: data = _inflateRawSync(blob, _usz); break;
			case 0: break; // TODO: scan for magic number
			default: throw new Error("Unsupported ZIP Compression method " + meth);
		}
	
		/* [data descriptor] */
		var wrn = false;
		if(flags & 8) {
			crc32 = blob.read_shift(4);
			if(crc32 == 0x08074b50) { crc32 = blob.read_shift(4); wrn = true; }
			_csz = blob.read_shift(4);
			_usz = blob.read_shift(4);
		}
	
		if(_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
		if(_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
		//var _crc32 = CRC32.buf(data, 0);
		//if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
		cfb_add(o, name, data, {unsafe: true, mt: date});
	}
	function write_zip(cfb, options) {
		var _opts = options || {};
		var out = [], cdirs = [];
		var o = new_buf(1);
		var method = (_opts.compression ? 8 : 0), flags = 0;
		var desc = false;
		if(desc) flags |= 8;
		var i = 0, j = 0;
	
		var start_cd = 0, fcnt = 0;
		var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
		var crcs = [];
		var sz_cd = 0;
	
		for(i = 1; i < cfb.FullPaths.length; ++i) {
			fp = cfb.FullPaths[i].slice(root.length); fi = cfb.FileIndex[i];
			if(!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
			var start = start_cd;
	
			/* TODO: CP437 filename */
			var namebuf = new_buf(fp.length);
			for(j = 0; j < fp.length; ++j) namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
			namebuf = namebuf.slice(0, namebuf.l);
			crcs[fcnt] = CRC32.buf(fi.content, 0);
	
			var outbuf = fi.content;
			if(method == 8) outbuf = _deflateRawSync(outbuf);
	
			/* local file header */
			o = new_buf(30);
			o.write_shift(4, 0x04034b50);
			o.write_shift(2, 20);
			o.write_shift(2, flags);
			o.write_shift(2, method);
			/* TODO: last mod file time/date */
			if(fi.mt) write_dos_date(o, fi.mt);
			else o.write_shift(4, 0);
			o.write_shift(-4, (flags & 8) ? 0 : crcs[fcnt]);
			o.write_shift(4,  (flags & 8) ? 0 : outbuf.length);
			o.write_shift(4,  (flags & 8) ? 0 : fi.content.length);
			o.write_shift(2, namebuf.length);
			o.write_shift(2, 0);
	
			start_cd += o.length;
			out.push(o);
			start_cd += namebuf.length;
			out.push(namebuf);
	
			/* TODO: extra fields? */
	
			/* TODO: encryption header ? */
	
			start_cd += outbuf.length;
			out.push(outbuf);
	
			/* data descriptor */
			if(flags & 8) {
				o = new_buf(12);
				o.write_shift(-4, crcs[fcnt]);
				o.write_shift(4, outbuf.length);
				o.write_shift(4, fi.content.length);
				start_cd += o.l;
				out.push(o);
			}
	
			/* central directory */
			o = new_buf(46);
			o.write_shift(4, 0x02014b50);
			o.write_shift(2, 0);
			o.write_shift(2, 20);
			o.write_shift(2, flags);
			o.write_shift(2, method);
			o.write_shift(4, 0); /* TODO: last mod file time/date */
			o.write_shift(-4, crcs[fcnt]);
	
			o.write_shift(4, outbuf.length);
			o.write_shift(4, fi.content.length);
			o.write_shift(2, namebuf.length);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(4, 0);
			o.write_shift(4, start);
	
			sz_cd += o.l;
			cdirs.push(o);
			sz_cd += namebuf.length;
			cdirs.push(namebuf);
			++fcnt;
		}
	
		/* end of central directory */
		o = new_buf(22);
		o.write_shift(4, 0x06054b50);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, fcnt);
		o.write_shift(2, fcnt);
		o.write_shift(4, sz_cd);
		o.write_shift(4, start_cd);
		o.write_shift(2, 0);
	
		return bconcat(([bconcat((out)), bconcat(cdirs), o]));
	}
	var ContentTypeMap = ({
		"htm": "text/html",
		"xml": "text/xml",
	
		"gif": "image/gif",
		"jpg": "image/jpeg",
		"png": "image/png",
	
		"mso": "application/x-mso",
		"thmx": "application/vnd.ms-officetheme",
		"sh33tj5": "application/octet-stream"
	});
	
	function get_content_type(fi, fp) {
		if(fi.ctype) return fi.ctype;
	
		var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
		if(m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
	
		if(fp) {
			m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
			if(m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
		}
	
		return "application/octet-stream";
	}
	
	/* 76 character chunks TODO: intertwine encoding */
	function write_base64_76(bstr) {
		var data = Base64_encode(bstr);
		var o = [];
		for(var i = 0; i < data.length; i+= 76) o.push(data.slice(i, i+76));
		return o.join("\r\n") + "\r\n";
	}
	
	/*
	Rules for QP:
		- escape =## applies for all non-display characters and literal "="
		- space or tab at end of line must be encoded
		- \r\n newlines can be preserved, but bare \r and \n must be escaped
		- lines must not exceed 76 characters, use soft breaks =\r\n
	
	TODO: Some files from word appear to write line extensions with bare equals:
	
	```
	<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
	="70%"
	```
	*/
	function write_quoted_printable(text) {
		var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
			var w = c.charCodeAt(0).toString(16).toUpperCase();
			return "=" + (w.length == 1 ? "0" + w : w);
		});
	
		encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");
	
		if(encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
		encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");
	
		var o = [], split = encoded.split("\r\n");
		for(var si = 0; si < split.length; ++si) {
			var str = split[si];
			if(str.length == 0) { o.push(""); continue; }
			for(var i = 0; i < str.length;) {
				var end = 76;
				var tmp = str.slice(i, i + end);
				if(tmp.charAt(end - 1) == "=") end --;
				else if(tmp.charAt(end - 2) == "=") end -= 2;
				else if(tmp.charAt(end - 3) == "=") end -= 3;
				tmp = str.slice(i, i + end);
				i += end;
				if(i < str.length) tmp += "=";
				o.push(tmp);
			}
		}
	
		return o.join("\r\n");
	}
	function parse_quoted_printable(data) {
		var o = [];
	
		/* unify long lines */
		for(var di = 0; di < data.length; ++di) {
			var line = data[di];
			while(di <= data.length && line.charAt(line.length - 1) == "=") line = line.slice(0, line.length - 1) + data[++di];
			o.push(line);
		}
	
		/* decode */
		for(var oi = 0; oi < o.length; ++oi) o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) { return String.fromCharCode(parseInt($$.slice(1), 16)); });
		return s2a(o.join("\r\n"));
	}
	
	
	function parse_mime(cfb, data, root) {
		var fname = "", cte = "", ctype = "", fdata;
		var di = 0;
		for(;di < 10; ++di) {
			var line = data[di];
			if(!line || line.match(/^\s*$/)) break;
			var m = line.match(/^(.*?):\s*([^\s].*)$/);
			if(m) switch(m[1].toLowerCase()) {
				case "content-location": fname = m[2].trim(); break;
				case "content-type": ctype = m[2].trim(); break;
				case "content-transfer-encoding": cte = m[2].trim(); break;
			}
		}
		++di;
		switch(cte.toLowerCase()) {
			case 'base64': fdata = s2a(Base64_decode(data.slice(di).join(""))); break;
			case 'quoted-printable': fdata = parse_quoted_printable(data.slice(di)); break;
			default: throw new Error("Unsupported Content-Transfer-Encoding " + cte);
		}
		var file = cfb_add(cfb, fname.slice(root.length), fdata, {unsafe: true});
		if(ctype) file.ctype = ctype;
	}
	
	function parse_mad(file, options) {
		if(a2s(file.slice(0,13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
		var root = (options && options.root || "");
		// $FlowIgnore
		var data = (has_buf && Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
		var di = 0, row = "";
	
		/* if root is not specified, scan for the common prefix */
		for(di = 0; di < data.length; ++di) {
			row = data[di];
			if(!/^Content-Location:/i.test(row)) continue;
			row = row.slice(row.indexOf("file"));
			if(!root) root = row.slice(0, row.lastIndexOf("/") + 1);
			if(row.slice(0, root.length) == root) continue;
			while(root.length > 0) {
				root = root.slice(0, root.length - 1);
				root = root.slice(0, root.lastIndexOf("/") + 1);
				if(row.slice(0,root.length) == root) break;
			}
		}
	
		var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
		if(!mboundary) throw new Error("MAD cannot find boundary");
		var boundary = "--" + (mboundary[1] || "");
	
		var FileIndex = [], FullPaths = [];
		var o = {
			FileIndex: FileIndex,
			FullPaths: FullPaths
		};
		init_cfb(o);
		var start_di, fcnt = 0;
		for(di = 0; di < data.length; ++di) {
			var line = data[di];
			if(line !== boundary && line !== boundary + "--") continue;
			if(fcnt++) parse_mime(o, data.slice(start_di, di), root);
			start_di = di;
		}
		return o;
	}
	
	function write_mad(cfb, options) {
		var opts = options || {};
		var boundary = opts.boundary || "SheetJS";
		boundary = '------=' + boundary;
	
		var out = [
			'MIME-Version: 1.0',
			'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
			'',
			'',
			''
		];
	
		var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
		for(var i = 1; i < cfb.FullPaths.length; ++i) {
			fp = cfb.FullPaths[i].slice(root.length);
			fi = cfb.FileIndex[i];
			if(!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
	
			/* Normalize filename */
			fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
				return "_x" + c.charCodeAt(0).toString(16) + "_";
			}).replace(/[\u0080-\uFFFF]/g, function(u) {
				return "_u" + u.charCodeAt(0).toString(16) + "_";
			});
	
			/* Extract content as binary string */
			var ca = fi.content;
			// $FlowIgnore
			var cstr = has_buf && Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);
	
			/* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */
			var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
			for(var csl = 0; csl <= L; ++csl) if((cc=cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
			var qp = dispcnt >= L * 4 / 5;
	
			out.push(boundary);
			out.push('Content-Location: ' + (opts.root || 'file:///C:/SheetJS/') + fp);
			out.push('Content-Transfer-Encoding: ' + (qp ? 'quoted-printable' : 'base64'));
			out.push('Content-Type: ' + get_content_type(fi, fp));
			out.push('');
	
			out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
		}
		out.push(boundary + '--\r\n');
		return out.join("\r\n");
	}
	function cfb_new(opts) {
		var o = ({});
		init_cfb(o, opts);
		return o;
	}
	
	function cfb_add(cfb, name, content, opts) {
		var unsafe = opts && opts.unsafe;
		if(!unsafe) init_cfb(cfb);
		var file = !unsafe && CFB.find(cfb, name);
		if(!file) {
			var fpath = cfb.FullPaths[0];
			if(name.slice(0, fpath.length) == fpath) fpath = name;
			else {
				if(fpath.slice(-1) != "/") fpath += "/";
				fpath = (fpath + name).replace("//","/");
			}
			file = ({name: filename(name), type: 2});
			cfb.FileIndex.push(file);
			cfb.FullPaths.push(fpath);
			if(!unsafe) CFB.utils.cfb_gc(cfb);
		}
	file.content = (content);
		file.size = content ? content.length : 0;
		if(opts) {
			if(opts.CLSID) file.clsid = opts.CLSID;
			if(opts.mt) file.mt = opts.mt;
			if(opts.ct) file.ct = opts.ct;
		}
		return file;
	}
	
	function cfb_del(cfb, name) {
		init_cfb(cfb);
		var file = CFB.find(cfb, name);
		if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
			cfb.FileIndex.splice(j, 1);
			cfb.FullPaths.splice(j, 1);
			return true;
		}
		return false;
	}
	
	function cfb_mov(cfb, old_name, new_name) {
		init_cfb(cfb);
		var file = CFB.find(cfb, old_name);
		if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
			cfb.FileIndex[j].name = filename(new_name);
			cfb.FullPaths[j] = new_name;
			return true;
		}
		return false;
	}
	
	function cfb_gc(cfb) { rebuild_cfb(cfb, true); }
	
	exports.find = find;
	exports.read = read;
	exports.parse = parse;
	exports.write = write;
	exports.writeFile = write_file;
	exports.utils = {
		cfb_new: cfb_new,
		cfb_add: cfb_add,
		cfb_del: cfb_del,
		cfb_mov: cfb_mov,
		cfb_gc: cfb_gc,
		ReadShift: ReadShift,
		CheckField: CheckField,
		prep_blob: prep_blob,
		bconcat: bconcat,
		use_zlib: use_zlib,
		_deflateRaw: _deflate,
		_inflateRaw: _inflate,
		consts: consts
	};
	
	return exports;
	})();
	
	var _fs;
	if(true) try { _fs = __webpack_require__(790); } catch(e) {}
	
	/* normalize data for blob ctor */
	function blobify(data) {
		if(typeof data === "string") return s2ab(data);
		if(Array.isArray(data)) return a2u(data);
		return data;
	}
	/* write or download file */
	function write_dl(fname, payload, enc) {
		/*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */
		if(typeof _fs !== 'undefined' && _fs.writeFileSync) return enc ? _fs.writeFileSync(fname, payload, enc) : _fs.writeFileSync(fname, payload);
		if(typeof Deno !== 'undefined') {
			/* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */
			if(enc && typeof payload == "string") switch(enc) {
				case "utf8": payload = new TextEncoder(enc).encode(payload); break;
				case "binary": payload = s2ab(payload); break;
				/* TODO: binary equivalent */
				default: throw new Error("Unsupported encoding " + enc);
			}
			return Deno.writeFileSync(fname, payload);
		}
		var data = (enc == "utf8") ? utf8write(payload) : payload;
	if(typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
		if(typeof Blob !== 'undefined') {
			var blob = new Blob([blobify(data)], {type:"application/octet-stream"});
	if(typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
	if(typeof saveAs !== 'undefined') return saveAs(blob, fname);
			if(typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
				var url = URL.createObjectURL(blob);
	if(typeof chrome === 'object' && typeof (chrome.downloads||{}).download == "function") {
					if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
					return chrome.downloads.download({ url: url, filename: fname, saveAs: true});
				}
				var a = document.createElement("a");
				if(a.download != null) {
	a.download = fname; a.href = url; document.body.appendChild(a); a.click();
	document.body.removeChild(a);
					if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
					return url;
				}
			}
		}
		// $FlowIgnore
		if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
			// $FlowIgnore
			var out = File(fname); out.open("w"); out.encoding = "binary";
			if(Array.isArray(payload)) payload = a2s(payload);
			out.write(payload); out.close(); return payload;
		} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
		throw new Error("cannot save file " + fname);
	}
	
	/* read binary data from file */
	function read_binary(path) {
		if(typeof _fs !== 'undefined') return _fs.readFileSync(path);
		if(typeof Deno !== 'undefined') return Deno.readFileSync(path);
		// $FlowIgnore
		if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
			// $FlowIgnore
			var infile = File(path); infile.open("r"); infile.encoding = "binary";
			var data = infile.read(); infile.close();
			return data;
		} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
		throw new Error("Cannot access file " + path);
	}
	function keys(o) {
		var ks = Object.keys(o), o2 = [];
		for(var i = 0; i < ks.length; ++i) if(Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
		return o2;
	}
	
	function evert_key(obj, key) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) if(o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
		return o;
	}
	
	function evert(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = K[i];
		return o;
	}
	
	function evert_num(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = parseInt(K[i],10);
		return o;
	}
	
	function evert_arr(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) {
			if(o[obj[K[i]]] == null) o[obj[K[i]]] = [];
			o[obj[K[i]]].push(K[i]);
		}
		return o;
	}
	
	var basedate = new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
	function datenum(v, date1904) {
		var epoch = v.getTime();
		if(date1904) epoch -= 1462*24*60*60*1000;
		var dnthresh = basedate.getTime() + (v.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
		return (epoch - dnthresh) / (24 * 60 * 60 * 1000);
	}
	var refdate = new Date();
	var dnthresh = basedate.getTime() + (refdate.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
	var refoffset = refdate.getTimezoneOffset();
	function numdate(v) {
		var out = new Date();
		out.setTime(v * 24 * 60 * 60 * 1000 + dnthresh);
		if (out.getTimezoneOffset() !== refoffset) {
			out.setTime(out.getTime() + (out.getTimezoneOffset() - refoffset) * 60000);
		}
		return out;
	}
	
	/* ISO 8601 Duration */
	function parse_isodur(s) {
		var sec = 0, mt = 0, time = false;
		var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
		if(!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
		for(var i = 1; i != m.length; ++i) {
			if(!m[i]) continue;
			mt = 1;
			if(i > 3) time = true;
			switch(m[i].slice(m[i].length-1)) {
				case 'Y':
					throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length-1));
				case 'D': mt *= 24;
					/* falls through */
				case 'H': mt *= 60;
					/* falls through */
				case 'M':
					if(!time) throw new Error("Unsupported ISO Duration Field: M");
					else mt *= 60;
					/* falls through */
				case 'S': break;
			}
			sec += mt * parseInt(m[i], 10);
		}
		return sec;
	}
	
	var good_pd_date_1 = new Date('2017-02-19T19:06:09.000Z');
	var good_pd_date = isNaN(good_pd_date_1.getFullYear()) ? new Date('2/19/17') : good_pd_date_1;
	var good_pd = good_pd_date.getFullYear() == 2017;
	/* parses a date as a local date */
	function parseDate(str, fixdate) {
		var d = new Date(str);
		if(good_pd) {
	if(fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000);
			else if(fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
			return d;
		}
		if(str instanceof Date) return str;
		if(good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
			var s = d.getFullYear();
			if(str.indexOf("" + s) > -1) return d;
			d.setFullYear(d.getFullYear() + 100); return d;
		}
		var n = str.match(/\d+/g)||["2017","2","19","0","0","0"];
		var out = new Date(+n[0], +n[1] - 1, +n[2], (+n[3]||0), (+n[4]||0), (+n[5]||0));
		if(str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60 * 1000);
		return out;
	}
	
	function cc2str(arr, debomit) {
		if(has_buf && Buffer.isBuffer(arr)) {
			if(debomit) {
				if(arr[0] == 0xFF && arr[1] == 0xFE) return utf8write(arr.slice(2).toString("utf16le"));
				if(arr[1] == 0xFE && arr[2] == 0xFF) return utf8write(utf16beread(arr.slice(2).toString("binary")));
			}
			return arr.toString("binary");
		}
	
		if(typeof TextDecoder !== "undefined") try {
			if(debomit) {
				if(arr[0] == 0xFF && arr[1] == 0xFE) return utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
				if(arr[0] == 0xFE && arr[1] == 0xFF) return utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
			}
			var rev = {
				"\u20ac": "\x80", "\u201a": "\x82", "\u0192": "\x83", "\u201e": "\x84",
				"\u2026": "\x85", "\u2020": "\x86", "\u2021": "\x87", "\u02c6": "\x88",
				"\u2030": "\x89", "\u0160": "\x8a", "\u2039": "\x8b", "\u0152": "\x8c",
				"\u017d": "\x8e", "\u2018": "\x91", "\u2019": "\x92", "\u201c": "\x93",
				"\u201d": "\x94", "\u2022": "\x95", "\u2013": "\x96", "\u2014": "\x97",
				"\u02dc": "\x98", "\u2122": "\x99", "\u0161": "\x9a", "\u203a": "\x9b",
				"\u0153": "\x9c", "\u017e": "\x9e", "\u0178": "\x9f"
			};
			if(Array.isArray(arr)) arr = new Uint8Array(arr);
			return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) { return rev[c] || c; });
		} catch(e) {}
	
		var o = [];
		for(var i = 0; i != arr.length; ++i) o.push(String.fromCharCode(arr[i]));
		return o.join("");
	}
	
	function dup(o) {
		if(typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
		if(typeof o != 'object' || o == null) return o;
		if(o instanceof Date) return new Date(o.getTime());
		var out = {};
		for(var k in o) if(Object.prototype.hasOwnProperty.call(o, k)) out[k] = dup(o[k]);
		return out;
	}
	
	function fill(c,l) { var o = ""; while(o.length < l) o+=c; return o; }
	
	/* TODO: stress test */
	function fuzzynum(s) {
		var v = Number(s);
		if(!isNaN(v)) return isFinite(v) ? v : NaN;
		if(!/\d/.test(s)) return v;
		var wt = 1;
		var ss = s.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g, function() { wt *= 100; return "";});
		if(!isNaN(v = Number(ss))) return v / wt;
		ss = ss.replace(/[(](.*)[)]/,function($$, $1) { wt = -wt; return $1;});
		if(!isNaN(v = Number(ss))) return v / wt;
		return v;
	}
	var lower_months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
	function fuzzydate(s) {
		var o = new Date(s), n = new Date(NaN);
		var y = o.getYear(), m = o.getMonth(), d = o.getDate();
		if(isNaN(d)) return n;
		var lower = s.toLowerCase();
		if(lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
			lower = lower.replace(/[^a-z]/g,"").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/,"");
			if(lower.length > 3 && lower_months.indexOf(lower) == -1) return n;
		} else if(lower.match(/[a-z]/)) return n;
		if(y < 0 || y > 8099) return n;
		if((m > 0 || d > 1) && y != 101) return o;
		if(s.match(/[^-0-9:,\/\\]/)) return n;
		return o;
	}
	
	var split_regex = (function() {
		var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
		return function split_regex(str, re, def) {
			if(safe_split_regex || typeof re == "string") return str.split(re);
			var p = str.split(re), o = [p[0]];
			for(var i = 1; i < p.length; ++i) { o.push(def); o.push(p[i]); }
			return o;
		};
	})();
	function getdatastr(data) {
		if(!data) return null;
		if(data.content && data.type) return cc2str(data.content, true);
		if(data.data) return debom(data.data);
		if(data.asNodeBuffer && has_buf) return debom(data.asNodeBuffer().toString('binary'));
		if(data.asBinary) return debom(data.asBinary());
		if(data._data && data._data.getContent) return debom(cc2str(Array.prototype.slice.call(data._data.getContent(),0)));
		return null;
	}
	
	function getdatabin(data) {
		if(!data) return null;
		if(data.data) return char_codes(data.data);
		if(data.asNodeBuffer && has_buf) return data.asNodeBuffer();
		if(data._data && data._data.getContent) {
			var o = data._data.getContent();
			if(typeof o == "string") return char_codes(o);
			return Array.prototype.slice.call(o);
		}
		if(data.content && data.type) return data.content;
		return null;
	}
	
	function getdata(data) { return (data && data.name.slice(-4) === ".bin") ? getdatabin(data) : getdatastr(data); }
	
	/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */
	/* OASIS does not comment on filename case sensitivity */
	function safegetzipfile(zip, file) {
		var k = zip.FullPaths || keys(zip.files);
		var f = file.toLowerCase().replace(/[\/]/g, '\\'), g = f.replace(/\\/g,'\/');
		for(var i=0; i<k.length; ++i) {
			var n = k[i].replace(/^Root Entry[\/]/,"").toLowerCase();
			if(f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
		}
		return null;
	}
	
	function getzipfile(zip, file) {
		var o = safegetzipfile(zip, file);
		if(o == null) throw new Error("Cannot find file " + file + " in zip");
		return o;
	}
	
	function getzipdata(zip, file, safe) {
		if(!safe) return getdata(getzipfile(zip, file));
		if(!file) return null;
		try { return getzipdata(zip, file); } catch(e) { return null; }
	}
	
	function getzipstr(zip, file, safe) {
		if(!safe) return getdatastr(getzipfile(zip, file));
		if(!file) return null;
		try { return getzipstr(zip, file); } catch(e) { return null; }
	}
	
	function getzipbin(zip, file, safe) {
		if(!safe) return getdatabin(getzipfile(zip, file));
		if(!file) return null;
		try { return getzipbin(zip, file); } catch(e) { return null; }
	}
	
	function zipentries(zip) {
		var k = zip.FullPaths || keys(zip.files), o = [];
		for(var i = 0; i < k.length; ++i) if(k[i].slice(-1) != '/') o.push(k[i].replace(/^Root Entry[\/]/, ""));
		return o.sort();
	}
	
	function zip_add_file(zip, path, content) {
		if(zip.FullPaths) {
			if(typeof content == "string") {
				var res;
				if(has_buf) res = Buffer_from(content);
				/* TODO: investigate performance in Edge 13 */
				//else if(typeof TextEncoder !== "undefined") res = new TextEncoder().encode(content);
				else res = utf8decode(content);
				return CFB.utils.cfb_add(zip, path, res);
			}
			CFB.utils.cfb_add(zip, path, content);
		}
		else zip.file(path, content);
	}
	
	function zip_new() { return CFB.utils.cfb_new(); }
	
	function zip_read(d, o) {
		switch(o.type) {
			case "base64": return CFB.read(d, { type: "base64" });
			case "binary": return CFB.read(d, { type: "binary" });
			case "buffer": case "array": return CFB.read(d, { type: "buffer" });
		}
		throw new Error("Unrecognized type " + o.type);
	}
	
	function resolve_path(path, base) {
		if(path.charAt(0) == "/") return path.slice(1);
		var result = base.split('/');
		if(base.slice(-1) != "/") result.pop(); // folder path
		var target = path.split('/');
		while (target.length !== 0) {
			var step = target.shift();
			if (step === '..') result.pop();
			else if (step !== '.') result.push(step);
		}
		return result.join('/');
	}
	var XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
	var attregexg=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
	var tagregex1=/<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg, tagregex2 = /<[^>]*>/g;
	var tagregex = XML_HEADER.match(tagregex1) ? tagregex1 : tagregex2;
	var nsregex=/<\w*:/, nsregex2 = /<(\/?)\w+:/;
	function parsexmltag(tag, skip_root, skip_LC) {
		var z = ({});
		var eq = 0, c = 0;
		for(; eq !== tag.length; ++eq) if((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
		if(!skip_root) z[0] = tag.slice(0, eq);
		if(eq === tag.length) return z;
		var m = tag.match(attregexg), j=0, v="", i=0, q="", cc="", quot = 1;
		if(m) for(i = 0; i != m.length; ++i) {
			cc = m[i];
			for(c=0; c != cc.length; ++c) if(cc.charCodeAt(c) === 61) break;
			q = cc.slice(0,c).trim();
			while(cc.charCodeAt(c+1) == 32) ++c;
			quot = ((eq=cc.charCodeAt(c+1)) == 34 || eq == 39) ? 1 : 0;
			v = cc.slice(c+1+quot, cc.length-quot);
			for(j=0;j!=q.length;++j) if(q.charCodeAt(j) === 58) break;
			if(j===q.length) {
				if(q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
				z[q] = v;
				if(!skip_LC) z[q.toLowerCase()] = v;
			}
			else {
				var k = (j===5 && q.slice(0,5)==="xmlns"?"xmlns":"")+q.slice(j+1);
				if(z[k] && q.slice(j-3,j) == "ext") continue; // from ods
				z[k] = v;
				if(!skip_LC) z[k.toLowerCase()] = v;
			}
		}
		return z;
	}
	function strip_ns(x) { return x.replace(nsregex2, "<$1"); }
	
	var encodings = {
		'&quot;': '"',
		'&apos;': "'",
		'&gt;': '>',
		'&lt;': '<',
		'&amp;': '&'
	};
	var rencoding = evert(encodings);
	//var rencstr = "&<>'\"".split("");
	
	// TODO: CP remap (need to read file version to determine OS)
	var unescapexml = (function() {
		/* 22.4.2.4 bstr (Basic String) */
		var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
		return function unescapexml(text) {
			var s = text + '', i = s.indexOf("<![CDATA[");
			if(i == -1) return s.replace(encregex, function($$, $1) { return encodings[$$]||String.fromCharCode(parseInt($1,$$.indexOf("x")>-1?16:10))||$$; }).replace(coderegex,function(m,c) {return String.fromCharCode(parseInt(c,16));});
			var j = s.indexOf("]]>");
			return unescapexml(s.slice(0, i)) + s.slice(i+9,j) + unescapexml(s.slice(j+3));
		};
	})();
	
	var decregex=/[&<>'"]/g, charegex = /[\u0000-\u0008\u000b-\u001f]/g;
	function escapexml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(charegex,function(s) { return "_x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + "_";});
	}
	function escapexmltag(text){ return escapexml(text).replace(/ /g,"_x0020_"); }
	
	var htmlcharegex = /[\u0000-\u001f]/g;
	function escapehtml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(/\n/g, "<br/>").replace(htmlcharegex,function(s) { return "&#x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + ";"; });
	}
	
	function escapexlml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(htmlcharegex,function(s) { return "&#x" + (s.charCodeAt(0).toString(16)).toUpperCase() + ";"; });
	}
	
	/* TODO: handle codepages */
	var xlml_fixstr = (function() {
		var entregex = /&#(\d+);/g;
		function entrepl($$,$1) { return String.fromCharCode(parseInt($1,10)); }
		return function xlml_fixstr(str) { return str.replace(entregex,entrepl); };
	})();
	function xlml_unfixstr(str) { return str.replace(/(\r\n|[\r\n])/g,"\&#10;"); }
	
	function parsexmlbool(value) {
		switch(value) {
			case 1: case true: case '1': case 'true': case 'TRUE': return true;
			/* case '0': case 'false': case 'FALSE':*/
			default: return false;
		}
	}
	
	function utf8reada(orig) {
		var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
		while (i < orig.length) {
			c = orig.charCodeAt(i++);
			if (c < 128) { out += String.fromCharCode(c); continue; }
			d = orig.charCodeAt(i++);
			if (c>191 && c<224) { f = ((c & 31) << 6); f |= (d & 63); out += String.fromCharCode(f); continue; }
			e = orig.charCodeAt(i++);
			if (c < 240) { out += String.fromCharCode(((c & 15) << 12) | ((d & 63) << 6) | (e & 63)); continue; }
			f = orig.charCodeAt(i++);
			w = (((c & 7) << 18) | ((d & 63) << 12) | ((e & 63) << 6) | (f & 63))-65536;
			out += String.fromCharCode(0xD800 + ((w>>>10)&1023));
			out += String.fromCharCode(0xDC00 + (w&1023));
		}
		return out;
	}
	
	function utf8readb(data) {
		var out = new_raw_buf(2*data.length), w, i, j = 1, k = 0, ww=0, c;
		for(i = 0; i < data.length; i+=j) {
			j = 1;
			if((c=data.charCodeAt(i)) < 128) w = c;
			else if(c < 224) { w = (c&31)*64+(data.charCodeAt(i+1)&63); j=2; }
			else if(c < 240) { w=(c&15)*4096+(data.charCodeAt(i+1)&63)*64+(data.charCodeAt(i+2)&63); j=3; }
			else { j = 4;
				w = (c & 7)*262144+(data.charCodeAt(i+1)&63)*4096+(data.charCodeAt(i+2)&63)*64+(data.charCodeAt(i+3)&63);
				w -= 65536; ww = 0xD800 + ((w>>>10)&1023); w = 0xDC00 + (w&1023);
			}
			if(ww !== 0) { out[k++] = ww&255; out[k++] = ww>>>8; ww = 0; }
			out[k++] = w%256; out[k++] = w>>>8;
		}
		return out.slice(0,k).toString('ucs2');
	}
	
	function utf8readc(data) { return Buffer_from(data, 'binary').toString('utf8'); }
	
	var utf8corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
	var utf8read = has_buf && (utf8readc(utf8corpus) == utf8reada(utf8corpus) && utf8readc || utf8readb(utf8corpus) == utf8reada(utf8corpus) && utf8readb) || utf8reada;
	
	var utf8write = has_buf ? function(data) { return Buffer_from(data, 'utf8').toString("binary"); } : function(orig) {
		var out = [], i = 0, c = 0, d = 0;
		while(i < orig.length) {
			c = orig.charCodeAt(i++);
			switch(true) {
				case c < 128: out.push(String.fromCharCode(c)); break;
				case c < 2048:
					out.push(String.fromCharCode(192 + (c >> 6)));
					out.push(String.fromCharCode(128 + (c & 63)));
					break;
				case c >= 55296 && c < 57344:
					c -= 55296; d = orig.charCodeAt(i++) - 56320 + (c<<10);
					out.push(String.fromCharCode(240 + ((d >>18) & 7)));
					out.push(String.fromCharCode(144 + ((d >>12) & 63)));
					out.push(String.fromCharCode(128 + ((d >> 6) & 63)));
					out.push(String.fromCharCode(128 + (d & 63)));
					break;
				default:
					out.push(String.fromCharCode(224 + (c >> 12)));
					out.push(String.fromCharCode(128 + ((c >> 6) & 63)));
					out.push(String.fromCharCode(128 + (c & 63)));
			}
		}
		return out.join("");
	};
	
	// matches <foo>...</foo> extracts content
	var matchtag = (function() {
		var mtcache = ({});
		return function matchtag(f,g) {
			var t = f+"|"+(g||"");
			if(mtcache[t]) return mtcache[t];
			return (mtcache[t] = new RegExp('<(?:\\w+:)?'+f+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+f+'>',((g||""))));
		};
	})();
	
	var htmldecode = (function() {
		var entities = [
			['nbsp', ' '], ['middot', '·'],
			['quot', '"'], ['apos', "'"], ['gt',   '>'], ['lt',   '<'], ['amp',  '&']
		].map(function(x) { return [new RegExp('&' + x[0] + ';', "ig"), x[1]]; });
		return function htmldecode(str) {
			var o = str
					// Remove new lines and spaces from start of content
					.replace(/^[\t\n\r ]+/, "")
					// Remove new lines and spaces from end of content
					.replace(/[\t\n\r ]+$/,"")
					// Added line which removes any white space characters after and before html tags
					.replace(/>\s+/g,">").replace(/\s+</g,"<")
					// Replace remaining new lines and spaces with space
					.replace(/[\t\n\r ]+/g, " ")
					// Replace <br> tags with new lines
					.replace(/<\s*[bB][rR]\s*\/?>/g,"\n")
					// Strip HTML elements
					.replace(/<[^>]*>/g,"");
			for(var i = 0; i < entities.length; ++i) o = o.replace(entities[i][0], entities[i][1]);
			return o;
		};
	})();
	
	var vtregex = (function(){ var vt_cache = {};
		return function vt_regex(bt) {
			if(vt_cache[bt] !== undefined) return vt_cache[bt];
			return (vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", 'g') );
	};})();
	var vtvregex = /<\/?(?:vt:)?variant>/g, vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
	function parseVector(data, opts) {
		var h = parsexmltag(data);
	
		var matches = data.match(vtregex(h.baseType))||[];
		var res = [];
		if(matches.length != h.size) {
			if(opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
			return res;
		}
		matches.forEach(function(x) {
			var v = x.replace(vtvregex,"").match(vtmregex);
			if(v) res.push({v:utf8read(v[2]), t:v[1]});
		});
		return res;
	}
	
	var wtregex = /(^\s|\s$|\n)/;
	function writetag(f,g) { return '<' + f + (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f + '>'; }
	
	function wxt_helper(h) { return keys(h).map(function(k) { return " " + k + '="' + h[k] + '"';}).join(""); }
	function writextag(f,g,h) { return '<' + f + ((h != null) ? wxt_helper(h) : "") + ((g != null) ? (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';}
	
	function write_w3cdtf(d, t) { try { return d.toISOString().replace(/\.\d*/,""); } catch(e) { if(t) throw e; } return ""; }
	
	function write_vt(s, xlsx) {
		switch(typeof s) {
			case 'string':
				var o = writextag('vt:lpwstr', escapexml(s));
				if(xlsx) o = o.replace(/&quot;/g, "_x0022_");
				return o;
			case 'number': return writextag((s|0)==s?'vt:i4':'vt:r8', escapexml(String(s)));
			case 'boolean': return writextag('vt:bool',s?'true':'false');
		}
		if(s instanceof Date) return writextag('vt:filetime', write_w3cdtf(s));
		throw new Error("Unable to serialize " + s);
	}
	
	function xlml_normalize(d) {
		if(has_buf && Buffer.isBuffer(d)) return d.toString('utf8');
		if(typeof d === 'string') return d;
		/* duktape */
		if(typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return utf8read(a2s(ab2a(d)));
		throw new Error("Bad input format: expected Buffer or string");
	}
	/* UOS uses CJK in tags */
	var xlmlregex = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg;
	//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
	
	var XMLNS = ({
		CORE_PROPS: 'http://schemas.openxmlformats.org/package/2006/metadata/core-properties',
		CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
		EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
		CT: 'http://schemas.openxmlformats.org/package/2006/content-types',
		RELS: 'http://schemas.openxmlformats.org/package/2006/relationships',
		TCMNT: 'http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments',
		'dc': 'http://purl.org/dc/elements/1.1/',
		'dcterms': 'http://purl.org/dc/terms/',
		'dcmitype': 'http://purl.org/dc/dcmitype/',
		'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
		'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
		'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
		'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
		'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
		'xsd': 'http://www.w3.org/2001/XMLSchema'
	});
	
	var XMLNS_main = [
		'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
		'http://purl.oclc.org/ooxml/spreadsheetml/main',
		'http://schemas.microsoft.com/office/excel/2006/main',
		'http://schemas.microsoft.com/office/excel/2006/2'
	];
	
	var XLMLNS = ({
		'o':    'urn:schemas-microsoft-com:office:office',
		'x':    'urn:schemas-microsoft-com:office:excel',
		'ss':   'urn:schemas-microsoft-com:office:spreadsheet',
		'dt':   'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
		'mv':   'http://macVmlSchemaUri',
		'v':    'urn:schemas-microsoft-com:vml',
		'html': 'http://www.w3.org/TR/REC-html40'
	});
	function read_double_le(b, idx) {
		var s = 1 - 2 * (b[idx + 7] >>> 7);
		var e = ((b[idx + 7] & 0x7f) << 4) + ((b[idx + 6] >>> 4) & 0x0f);
		var m = (b[idx+6]&0x0f);
		for(var i = 5; i >= 0; --i) m = m * 256 + b[idx + i];
		if(e == 0x7ff) return m == 0 ? (s * Infinity) : NaN;
		if(e == 0) e = -1022;
		else { e -= 1023; m += Math.pow(2,52); }
		return s * Math.pow(2, e - 52) * m;
	}
	
	function write_double_le(b, v, idx) {
		var bs = ((((v < 0) || (1/v == -Infinity)) ? 1 : 0) << 7), e = 0, m = 0;
		var av = bs ? (-v) : v;
		if(!isFinite(av)) { e = 0x7ff; m = isNaN(v) ? 0x6969 : 0; }
		else if(av == 0) e = m = 0;
		else {
			e = Math.floor(Math.log(av) / Math.LN2);
			m = av * Math.pow(2, 52 - e);
			if((e <= -1023) && (!isFinite(m) || (m < Math.pow(2,52)))) { e = -1022; }
			else { m -= Math.pow(2,52); e+=1023; }
		}
		for(var i = 0; i <= 5; ++i, m/=256) b[idx + i] = m & 0xff;
		b[idx + 6] = ((e & 0x0f) << 4) | (m & 0xf);
		b[idx + 7] = (e >> 4) | bs;
	}
	
	var ___toBuffer = function(bufs) { var x=[],w=10240; for(var i=0;i<bufs[0].length;++i) if(bufs[0][i]) for(var j=0,L=bufs[0][i].length;j<L;j+=w) x.push.apply(x, bufs[0][i].slice(j,j+w)); return x; };
	var __toBuffer = has_buf ? function(bufs) { return (bufs[0].length > 0 && Buffer.isBuffer(bufs[0][0])) ? Buffer.concat(bufs[0].map(function(x) { return Buffer.isBuffer(x) ? x : Buffer_from(x); })) : ___toBuffer(bufs);} : ___toBuffer;
	
	var ___utf16le = function(b,s,e) { var ss=[]; for(var i=s; i<e; i+=2) ss.push(String.fromCharCode(__readUInt16LE(b,i))); return ss.join("").replace(chr0,''); };
	var __utf16le = has_buf ? function(b,s,e) { if(!Buffer.isBuffer(b)) return ___utf16le(b,s,e); return b.toString('utf16le',s,e).replace(chr0,'')/*.replace(chr1,'!')*/; } : ___utf16le;
	
	var ___hexlify = function(b,s,l) { var ss=[]; for(var i=s; i<s+l; ++i) ss.push(("0" + b[i].toString(16)).slice(-2)); return ss.join(""); };
	var __hexlify = has_buf ? function(b,s,l) { return Buffer.isBuffer(b) ? b.toString('hex',s,s+l) : ___hexlify(b,s,l); } : ___hexlify;
	
	var ___utf8 = function(b,s,e) { var ss=[]; for(var i=s; i<e; i++) ss.push(String.fromCharCode(__readUInt8(b,i))); return ss.join(""); };
	var __utf8 = has_buf ? function utf8_b(b, s, e) { return (Buffer.isBuffer(b)) ? b.toString('utf8',s,e) : ___utf8(b,s,e); } : ___utf8;
	
	var ___lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var __lpstr = ___lpstr;
	
	var ___cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var __cpstr = ___cpstr;
	
	var ___lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var __lpwstr = ___lpwstr;
	
	var ___lpp4 = function lpp4_(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf16le(b, i+4,i+4+len) : "";};
	var __lpp4 = ___lpp4;
	
	var ___8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len) : "";};
	var __8lpp4 = ___8lpp4;
	
	var ___double = function(b, idx) { return read_double_le(b, idx);};
	var __double = ___double;
	
	var is_buf = function is_buf_a(a) { return Array.isArray(a) || (typeof Uint8Array !== "undefined" && a instanceof Uint8Array); };
	
	if(has_buf) {
		__lpstr = function lpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
		__cpstr = function cpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___cpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
		__lpwstr = function lpwstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpwstr(b, i); var len = 2*b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len-1);};
		__lpp4 = function lpp4_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len);};
		__8lpp4 = function lpp4_8b(b, i) { if(!Buffer.isBuffer(b)) return ___8lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf8',i+4,i+4+len);};
		__double = function double_(b, i) { if(Buffer.isBuffer(b)) return b.readDoubleLE(i); return ___double(b,i); };
		is_buf = function is_buf_b(a) { return Buffer.isBuffer(a) || Array.isArray(a) || (typeof Uint8Array !== "undefined" && a instanceof Uint8Array); };
	}
	
	/* from js-xls */
	function cpdoit() {
		__utf16le = function(b,s,e) { return $cptable.utils.decode(1200, b.slice(s,e)).replace(chr0, ''); };
		__utf8 = function(b,s,e) { return $cptable.utils.decode(65001, b.slice(s,e)); };
		__lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(current_ansi, b.slice(i+4, i+4+len-1)) : "";};
		__cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(current_codepage, b.slice(i+4, i+4+len-1)) : "";};
		__lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(1200, b.slice(i+4,i+4+len-1)) : "";};
		__lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(1200, b.slice(i+4,i+4+len)) : "";};
		__8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? $cptable.utils.decode(65001, b.slice(i+4,i+4+len)) : "";};
	}
	if(typeof $cptable !== 'undefined') cpdoit();
	
	var __readUInt8 = function(b, idx) { return b[idx]; };
	var __readUInt16LE = function(b, idx) { return (b[idx+1]*(1<<8))+b[idx]; };
	var __readInt16LE = function(b, idx) { var u = (b[idx+1]*(1<<8))+b[idx]; return (u < 0x8000) ? u : ((0xffff - u + 1) * -1); };
	var __readUInt32LE = function(b, idx) { return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx]; };
	var __readInt32LE = function(b, idx) { return (b[idx+3]<<24)|(b[idx+2]<<16)|(b[idx+1]<<8)|b[idx]; };
	var __readInt32BE = function(b, idx) { return (b[idx]<<24)|(b[idx+1]<<16)|(b[idx+2]<<8)|b[idx+3]; };
	
	function ReadShift(size, t) {
		var o="", oI, oR, oo=[], w, vv, i, loc;
		switch(t) {
			case 'dbcs':
				loc = this.l;
				if(has_buf && Buffer.isBuffer(this)) o = this.slice(this.l, this.l+2*size).toString("utf16le");
				else for(i = 0; i < size; ++i) { o+=String.fromCharCode(__readUInt16LE(this, loc)); loc+=2; }
				size *= 2;
				break;
	
			case 'utf8': o = __utf8(this, this.l, this.l + size); break;
			case 'utf16le': size *= 2; o = __utf16le(this, this.l, this.l + size); break;
	
			case 'wstr':
				if(typeof $cptable !== 'undefined') o = $cptable.utils.decode(current_codepage, this.slice(this.l, this.l+2*size));
				else return ReadShift.call(this, size, 'dbcs');
				size = 2 * size; break;
	
			/* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */
			case 'lpstr-ansi': o = __lpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
			case 'lpstr-cp': o = __cpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
			/* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */
			case 'lpwstr': o = __lpwstr(this, this.l); size = 4 + 2 * __readUInt32LE(this, this.l); break;
			/* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */
			case 'lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __lpp4(this, this.l); if(size & 0x02) size += 2; break;
			/* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */
			case '8lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __8lpp4(this, this.l); if(size & 0x03) size += 4 - (size & 0x03); break;
	
			case 'cstr': size = 0; o = "";
				while((w=__readUInt8(this, this.l + size++))!==0) oo.push(_getchar(w));
				o = oo.join(""); break;
			case '_wstr': size = 0; o = "";
				while((w=__readUInt16LE(this,this.l +size))!==0){oo.push(_getchar(w));size+=2;}
				size+=2; o = oo.join(""); break;
	
			/* sbcs and dbcs support continue records in the SST way TODO codepages */
			case 'dbcs-cont': o = ""; loc = this.l;
				for(i = 0; i < size; ++i) {
					if(this.lens && this.lens.indexOf(loc) !== -1) {
						w = __readUInt8(this, loc);
						this.l = loc + 1;
						vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
						return oo.join("") + vv;
					}
					oo.push(_getchar(__readUInt16LE(this, loc)));
					loc+=2;
				} o = oo.join(""); size *= 2; break;
	
			case 'cpstr':
				if(typeof $cptable !== 'undefined') {
					o = $cptable.utils.decode(current_codepage, this.slice(this.l, this.l + size));
					break;
				}
			/* falls through */
			case 'sbcs-cont': o = ""; loc = this.l;
				for(i = 0; i != size; ++i) {
					if(this.lens && this.lens.indexOf(loc) !== -1) {
						w = __readUInt8(this, loc);
						this.l = loc + 1;
						vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
						return oo.join("") + vv;
					}
					oo.push(_getchar(__readUInt8(this, loc)));
					loc+=1;
				} o = oo.join(""); break;
	
			default:
		switch(size) {
			case 1: oI = __readUInt8(this, this.l); this.l++; return oI;
			case 2: oI = (t === 'i' ? __readInt16LE : __readUInt16LE)(this, this.l); this.l += 2; return oI;
			case 4: case -4:
				if(t === 'i' || ((this[this.l+3] & 0x80)===0)) { oI = ((size > 0) ? __readInt32LE : __readInt32BE)(this, this.l); this.l += 4; return oI; }
				else { oR = __readUInt32LE(this, this.l); this.l += 4; } return oR;
			case 8: case -8:
				if(t === 'f') {
					if(size == 8) oR = __double(this, this.l);
					else oR = __double([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]], 0);
					this.l += 8; return oR;
				} else size = 8;
			/* falls through */
			case 16: o = __hexlify(this, this.l, size); break;
		}}
		this.l+=size; return o;
	}
	
	var __writeUInt32LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); b[idx+2] = ((val >>> 16) & 0xFF); b[idx+3] = ((val >>> 24) & 0xFF); };
	var __writeInt32LE  = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >> 8) & 0xFF); b[idx+2] = ((val >> 16) & 0xFF); b[idx+3] = ((val >> 24) & 0xFF); };
	var __writeUInt16LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); };
	
	function WriteShift(t, val, f) {
		var size = 0, i = 0;
		if(f === 'dbcs') {
	for(i = 0; i != val.length; ++i) __writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
			size = 2 * val.length;
		} else if(f === 'sbcs') {
			if(typeof $cptable !== 'undefined' && current_ansi == 874) {
				/* TODO: use tables directly, don't encode */
	for(i = 0; i != val.length; ++i) {
					var cppayload = $cptable.utils.encode(current_ansi, val.charAt(i));
					this[this.l + i] = cppayload[0];
				}
			} else {
	val = val.replace(/[^\x00-\x7F]/g, "_");
	for(i = 0; i != val.length; ++i) this[this.l + i] = (val.charCodeAt(i) & 0xFF);
			}
			size = val.length;
		} else if(f === 'hex') {
			for(; i < t; ++i) {
	this[this.l++] = (parseInt(val.slice(2*i, 2*i+2), 16)||0);
			} return this;
		} else if(f === 'utf16le') {
	var end = Math.min(this.l + t, this.length);
				for(i = 0; i < Math.min(val.length, t); ++i) {
					var cc = val.charCodeAt(i);
					this[this.l++] = (cc & 0xff);
					this[this.l++] = (cc >> 8);
				}
				while(this.l < end) this[this.l++] = 0;
				return this;
		} else  switch(t) {
			case  1: size = 1; this[this.l] = val&0xFF; break;
			case  2: size = 2; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; break;
			case  3: size = 3; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; val >>>= 8; this[this.l+2] = val&0xFF; break;
			case  4: size = 4; __writeUInt32LE(this, val, this.l); break;
			case  8: size = 8; if(f === 'f') { write_double_le(this, val, this.l); break; }
			/* falls through */
			case 16: break;
			case -4: size = 4; __writeInt32LE(this, val, this.l); break;
		}
		this.l += size; return this;
	}
	
	function CheckField(hexstr, fld) {
		var m = __hexlify(this,this.l,hexstr.length>>1);
		if(m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
		this.l += hexstr.length>>1;
	}
	
	function prep_blob(blob, pos) {
		blob.l = pos;
		blob.read_shift = ReadShift;
		blob.chk = CheckField;
		blob.write_shift = WriteShift;
	}
	
	function parsenoop(blob, length) { blob.l += length; }
	
	function new_buf(sz) {
		var o = new_raw_buf(sz);
		prep_blob(o, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.1.4 Record */
	function recordhopper(data, cb, opts) {
		if(!data) return;
		var tmpbyte, cntbyte, length;
		prep_blob(data, data.l || 0);
		var L = data.length, RT = 0, tgt = 0;
		while(data.l < L) {
			RT = data.read_shift(1);
			if(RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F)<<7);
			var R = XLSBRecordEnum[RT] || XLSBRecordEnum[0xFFFF];
			tmpbyte = data.read_shift(1);
			length = tmpbyte & 0x7F;
			for(cntbyte = 1; cntbyte <4 && (tmpbyte & 0x80); ++cntbyte) length += ((tmpbyte = data.read_shift(1)) & 0x7F)<<(7*cntbyte);
			tgt = data.l + length;
			var d = R.f && R.f(data, length, opts);
			data.l = tgt;
			if(cb(d, R, RT)) return;
		}
	}
	
	/* control buffer usage for fixed-length buffers */
	function buf_array() {
		var bufs = [], blksz = has_buf ? 256 : 2048;
		var newblk = function ba_newblk(sz) {
			var o = (new_buf(sz));
			prep_blob(o, 0);
			return o;
		};
	
		var curbuf = newblk(blksz);
	
		var endbuf = function ba_endbuf() {
			if(!curbuf) return;
			if(curbuf.length > curbuf.l) { curbuf = curbuf.slice(0, curbuf.l); curbuf.l = curbuf.length; }
			if(curbuf.length > 0) bufs.push(curbuf);
			curbuf = null;
		};
	
		var next = function ba_next(sz) {
			if(curbuf && (sz < (curbuf.length - curbuf.l))) return curbuf;
			endbuf();
			return (curbuf = newblk(Math.max(sz+1, blksz)));
		};
	
		var end = function ba_end() {
			endbuf();
			return bconcat(bufs);
		};
	
		var push = function ba_push(buf) { endbuf(); curbuf = buf; if(curbuf.l == null) curbuf.l = curbuf.length; next(blksz); };
	
		return ({ next:next, push:push, end:end, _bufs:bufs });
	}
	
	function write_record(ba, type, payload, length) {
		var t = +type, l;
		if(isNaN(t)) return; // TODO: throw something here?
		if(!length) length = XLSBRecordEnum[t].p || (payload||[]).length || 0;
		l = 1 + (t >= 0x80 ? 1 : 0) + 1/* + length*/;
		if(length >= 0x80) ++l; if(length >= 0x4000) ++l; if(length >= 0x200000) ++l;
		var o = ba.next(l);
		if(t <= 0x7F) o.write_shift(1, t);
		else {
			o.write_shift(1, (t & 0x7F) + 0x80);
			o.write_shift(1, (t >> 7));
		}
		for(var i = 0; i != 4; ++i) {
			if(length >= 0x80) { o.write_shift(1, (length & 0x7F)+0x80); length >>= 7; }
			else { o.write_shift(1, length); break; }
		}
		if(length > 0 && is_buf(payload)) ba.push(payload);
	}
	/* XLS ranges enforced */
	function shift_cell_xls(cell, tgt, opts) {
		var out = dup(cell);
		if(tgt.s) {
			if(out.cRel) out.c += tgt.s.c;
			if(out.rRel) out.r += tgt.s.r;
		} else {
			if(out.cRel) out.c += tgt.c;
			if(out.rRel) out.r += tgt.r;
		}
		if(!opts || opts.biff < 12) {
			while(out.c >= 0x100) out.c -= 0x100;
			while(out.r >= 0x10000) out.r -= 0x10000;
		}
		return out;
	}
	
	function shift_range_xls(cell, range, opts) {
		var out = dup(cell);
		out.s = shift_cell_xls(out.s, range.s, opts);
		out.e = shift_cell_xls(out.e, range.s, opts);
		return out;
	}
	
	function encode_cell_xls(c, biff) {
		if(c.cRel && c.c < 0) { c = dup(c); while(c.c < 0) c.c += (biff > 8) ? 0x4000 : 0x100; }
		if(c.rRel && c.r < 0) { c = dup(c); while(c.r < 0) c.r += (biff > 8) ? 0x100000 : ((biff > 5) ? 0x10000 : 0x4000); }
		var s = encode_cell(c);
		if(!c.cRel && c.cRel != null) s = fix_col(s);
		if(!c.rRel && c.rRel != null) s = fix_row(s);
		return s;
	}
	
	function encode_range_xls(r, opts) {
		if(r.s.r == 0 && !r.s.rRel) {
			if(r.e.r == (opts.biff >= 12 ? 0xFFFFF : (opts.biff >= 8 ? 0x10000 : 0x4000)) && !r.e.rRel) {
				return (r.s.cRel ? "" : "$") + encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + encode_col(r.e.c);
			}
		}
		if(r.s.c == 0 && !r.s.cRel) {
			if(r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) {
				return (r.s.rRel ? "" : "$") + encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + encode_row(r.e.r);
			}
		}
		return encode_cell_xls(r.s, opts.biff) + ":" + encode_cell_xls(r.e, opts.biff);
	}
	function decode_row(rowstr) { return parseInt(unfix_row(rowstr),10) - 1; }
	function encode_row(row) { return "" + (row + 1); }
	function fix_row(cstr) { return cstr.replace(/([A-Z]|^)(\d+)$/,"$1$$$2"); }
	function unfix_row(cstr) { return cstr.replace(/\$(\d+)$/,"$1"); }
	
	function decode_col(colstr) { var c = unfix_col(colstr), d = 0, i = 0; for(; i !== c.length; ++i) d = 26*d + c.charCodeAt(i) - 64; return d - 1; }
	function encode_col(col) { if(col < 0) throw new Error("invalid column " + col); var s=""; for(++col; col; col=Math.floor((col-1)/26)) s = String.fromCharCode(((col-1)%26) + 65) + s; return s; }
	function fix_col(cstr) { return cstr.replace(/^([A-Z])/,"$$$1"); }
	function unfix_col(cstr) { return cstr.replace(/^\$([A-Z])/,"$1"); }
	
	function split_cell(cstr) { return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(","); }
	//function decode_cell(cstr) { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
	function decode_cell(cstr) {
		var R = 0, C = 0;
		for(var i = 0; i < cstr.length; ++i) {
			var cc = cstr.charCodeAt(i);
			if(cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
			else if(cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
		}
		return { c: C - 1, r:R - 1 };
	}
	//function encode_cell(cell) { return encode_col(cell.c) + encode_row(cell.r); }
	function encode_cell(cell) {
		var col = cell.c + 1;
		var s="";
		for(; col; col=((col-1)/26)|0) s = String.fromCharCode(((col-1)%26) + 65) + s;
		return s + (cell.r + 1);
	}
	function decode_range(range) {
		var idx = range.indexOf(":");
		if(idx == -1) return { s: decode_cell(range), e: decode_cell(range) };
		return { s: decode_cell(range.slice(0, idx)), e: decode_cell(range.slice(idx + 1)) };
	}
	function encode_range(cs,ce) {
		if(typeof ce === 'undefined' || typeof ce === 'number') {
	return encode_range(cs.s, cs.e);
		}
	if(typeof cs !== 'string') cs = encode_cell((cs));
		if(typeof ce !== 'string') ce = encode_cell((ce));
	return cs == ce ? cs : cs + ":" + ce;
	}
	
	function safe_decode_range(range) {
		var o = {s:{c:0,r:0},e:{c:0,r:0}};
		var idx = 0, i = 0, cc = 0;
		var len = range.length;
		for(idx = 0; i < len; ++i) {
			if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
			idx = 26*idx + cc;
		}
		o.s.c = --idx;
	
		for(idx = 0; i < len; ++i) {
			if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
			idx = 10*idx + cc;
		}
		o.s.r = --idx;
	
		if(i === len || cc != 10) { o.e.c=o.s.c; o.e.r=o.s.r; return o; }
		++i;
	
		for(idx = 0; i != len; ++i) {
			if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
			idx = 26*idx + cc;
		}
		o.e.c = --idx;
	
		for(idx = 0; i != len; ++i) {
			if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
			idx = 10*idx + cc;
		}
		o.e.r = --idx;
		return o;
	}
	
	function safe_format_cell(cell, v) {
		var q = (cell.t == 'd' && v instanceof Date);
		if(cell.z != null) try { return (cell.w = SSF_format(cell.z, q ? datenum(v) : v)); } catch(e) { }
		try { return (cell.w = SSF_format((cell.XF||{}).numFmtId||(q ? 14 : 0),  q ? datenum(v) : v)); } catch(e) { return ''+v; }
	}
	
	function format_cell(cell, v, o) {
		if(cell == null || cell.t == null || cell.t == 'z') return "";
		if(cell.w !== undefined) return cell.w;
		if(cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
		if(cell.t == "e") return BErr[cell.v] || cell.v;
		if(v == undefined) return safe_format_cell(cell, cell.v);
		return safe_format_cell(cell, v);
	}
	
	function sheet_to_workbook(sheet, opts) {
		var n = opts && opts.sheet ? opts.sheet : "Sheet1";
		var sheets = {}; sheets[n] = sheet;
		return { SheetNames: [n], Sheets: sheets };
	}
	
	function sheet_add_aoa(_ws, data, opts) {
		var o = opts || {};
		var dense = _ws ? Array.isArray(_ws) : o.dense;
		if(DENSE != null && dense == null) dense = DENSE;
		var ws = _ws || (dense ? ([]) : ({}));
		var _R = 0, _C = 0;
		if(ws && o.origin != null) {
			if(typeof o.origin == 'number') _R = o.origin;
			else {
				var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
				_R = _origin.r; _C = _origin.c;
			}
			if(!ws["!ref"]) ws["!ref"] = "A1:A1";
		}
		var range = ({s: {c:10000000, r:10000000}, e: {c:0, r:0}});
		if(ws['!ref']) {
			var _range = safe_decode_range(ws['!ref']);
			range.s.c = _range.s.c;
			range.s.r = _range.s.r;
			range.e.c = Math.max(range.e.c, _range.e.c);
			range.e.r = Math.max(range.e.r, _range.e.r);
			if(_R == -1) range.e.r = _R = _range.e.r + 1;
		}
		for(var R = 0; R != data.length; ++R) {
			if(!data[R]) continue;
			if(!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
			for(var C = 0; C != data[R].length; ++C) {
				if(typeof data[R][C] === 'undefined') continue;
				var cell = ({v: data[R][C] });
				var __R = _R + R, __C = _C + C;
				if(range.s.r > __R) range.s.r = __R;
				if(range.s.c > __C) range.s.c = __C;
				if(range.e.r < __R) range.e.r = __R;
				if(range.e.c < __C) range.e.c = __C;
				if(data[R][C] && typeof data[R][C] === 'object' && !Array.isArray(data[R][C]) && !(data[R][C] instanceof Date)) cell = data[R][C];
				else {
					if(Array.isArray(cell.v)) { cell.f = data[R][C][1]; cell.v = cell.v[0]; }
					if(cell.v === null) {
						if(cell.f) cell.t = 'n';
						else if(o.nullError) { cell.t = 'e'; cell.v = 0; }
						else if(!o.sheetStubs) continue;
						else cell.t = 'z';
					}
					else if(typeof cell.v === 'number') cell.t = 'n';
					else if(typeof cell.v === 'boolean') cell.t = 'b';
					else if(cell.v instanceof Date) {
						cell.z = o.dateNF || table_fmt[14];
						if(o.cellDates) { cell.t = 'd'; cell.w = SSF_format(cell.z, datenum(cell.v)); }
						else { cell.t = 'n'; cell.v = datenum(cell.v); cell.w = SSF_format(cell.z, cell.v); }
					}
					else cell.t = 's';
				}
				if(dense) {
					if(!ws[__R]) ws[__R] = [];
					if(ws[__R][__C] && ws[__R][__C].z) cell.z = ws[__R][__C].z;
					ws[__R][__C] = cell;
				} else {
					var cell_ref = encode_cell(({c:__C,r:__R}));
					if(ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
					ws[cell_ref] = cell;
				}
			}
		}
		if(range.s.c < 10000000) ws['!ref'] = encode_range(range);
		return ws;
	}
	function aoa_to_sheet(data, opts) { return sheet_add_aoa(null, data, opts); }
	
	function parse_Int32LE(data) {
		return data.read_shift(4, 'i');
	}
	function write_UInt32LE(x, o) {
		if (!o) o = new_buf(4);
		o.write_shift(4, x);
		return o;
	}
	
	/* [MS-XLSB] 2.5.168 */
	function parse_XLWideString(data) {
		var cchCharacters = data.read_shift(4);
		return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
	}
	function write_XLWideString(data, o) {
		var _null = false; if (o == null) { _null = true; o = new_buf(4 + 2 * data.length); }
		o.write_shift(4, data.length);
		if (data.length > 0) o.write_shift(0, data, 'dbcs');
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.91 */
	//function parse_LPWideString(data) {
	//	var cchCharacters = data.read_shift(2);
	//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
	//}
	
	/* [MS-XLSB] 2.5.143 */
	function parse_StrRun(data) {
		return { ich: data.read_shift(2), ifnt: data.read_shift(2) };
	}
	function write_StrRun(run, o) {
		if (!o) o = new_buf(4);
		o.write_shift(2, run.ich || 0);
		o.write_shift(2, run.ifnt || 0);
		return o;
	}
	
	/* [MS-XLSB] 2.5.121 */
	function parse_RichStr(data, length) {
		var start = data.l;
		var flags = data.read_shift(1);
		var str = parse_XLWideString(data);
		var rgsStrRun = [];
		var z = ({ t: str, h: str });
		if ((flags & 1) !== 0) { /* fRichStr */
			/* TODO: formatted string */
			var dwSizeStrRun = data.read_shift(4);
			for (var i = 0; i != dwSizeStrRun; ++i) rgsStrRun.push(parse_StrRun(data));
			z.r = rgsStrRun;
		}
		else z.r = [{ ich: 0, ifnt: 0 }];
		//if((flags & 2) !== 0) { /* fExtStr */
		//	/* TODO: phonetic string */
		//}
		data.l = start + length;
		return z;
	}
	function write_RichStr(str, o) {
		/* TODO: formatted string */
		var _null = false; if (o == null) { _null = true; o = new_buf(15 + 4 * str.t.length); }
		o.write_shift(1, 0);
		write_XLWideString(str.t, o);
		return _null ? o.slice(0, o.l) : o;
	}
	/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */
	var parse_BrtCommentText = parse_RichStr;
	function write_BrtCommentText(str, o) {
		/* TODO: formatted string */
		var _null = false; if (o == null) { _null = true; o = new_buf(23 + 4 * str.t.length); }
		o.write_shift(1, 1);
		write_XLWideString(str.t, o);
		o.write_shift(4, 1);
		write_StrRun({ ich: 0, ifnt: 0 }, o);
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.9 */
	function parse_XLSBCell(data) {
		var col = data.read_shift(4);
		var iStyleRef = data.read_shift(2);
		iStyleRef += data.read_shift(1) << 16;
		data.l++; //var fPhShow = data.read_shift(1);
		return { c: col, iStyleRef: iStyleRef };
	}
	function write_XLSBCell(cell, o) {
		if (o == null) o = new_buf(8);
		o.write_shift(-4, cell.c);
		o.write_shift(3, cell.iStyleRef || cell.s);
		o.write_shift(1, 0); /* fPhShow */
		return o;
	}
	
	/* Short XLSB Cell does not include column */
	function parse_XLSBShortCell(data) {
		var iStyleRef = data.read_shift(2);
		iStyleRef += data.read_shift(1) <<16;
		data.l++; //var fPhShow = data.read_shift(1);
		return { c:-1, iStyleRef: iStyleRef };
	}
	function write_XLSBShortCell(cell, o) {
		if(o == null) o = new_buf(4);
		o.write_shift(3, cell.iStyleRef || cell.s);
		o.write_shift(1, 0); /* fPhShow */
		return o;
	}
	
	/* [MS-XLSB] 2.5.21 */
	var parse_XLSBCodeName = parse_XLWideString;
	var write_XLSBCodeName = write_XLWideString;
	
	/* [MS-XLSB] 2.5.166 */
	function parse_XLNullableWideString(data) {
		var cchCharacters = data.read_shift(4);
		return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
	}
	function write_XLNullableWideString(data, o) {
		var _null = false; if (o == null) { _null = true; o = new_buf(127); }
		o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
		if (data.length > 0) o.write_shift(0, data, 'dbcs');
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.165 */
	var parse_XLNameWideString = parse_XLWideString;
	//var write_XLNameWideString = write_XLWideString;
	
	/* [MS-XLSB] 2.5.114 */
	var parse_RelID = parse_XLNullableWideString;
	var write_RelID = write_XLNullableWideString;
	
	
	/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */
	function parse_RkNumber(data) {
		var b = data.slice(data.l, data.l + 4);
		var fX100 = (b[0] & 1), fInt = (b[0] & 2);
		data.l += 4;
		var RK = fInt === 0 ? __double([0, 0, 0, 0, (b[0] & 0xFC), b[1], b[2], b[3]], 0) : __readInt32LE(b, 0) >> 2;
		return fX100 ? (RK / 100) : RK;
	}
	function write_RkNumber(data, o) {
		if (o == null) o = new_buf(4);
		var fX100 = 0, fInt = 0, d100 = data * 100;
		if ((data == (data | 0)) && (data >= -(1 << 29)) && (data < (1 << 29))) { fInt = 1; }
		else if ((d100 == (d100 | 0)) && (d100 >= -(1 << 29)) && (d100 < (1 << 29))) { fInt = 1; fX100 = 1; }
		if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
		else throw new Error("unsupported RkNumber " + data); // TODO
	}
	
	
	/* [MS-XLSB] 2.5.117 RfX */
	function parse_RfX(data ) {
		var cell = ({ s: {}, e: {} });
		cell.s.r = data.read_shift(4);
		cell.e.r = data.read_shift(4);
		cell.s.c = data.read_shift(4);
		cell.e.c = data.read_shift(4);
		return cell;
	}
	function write_RfX(r, o) {
		if (!o) o = new_buf(16);
		o.write_shift(4, r.s.r);
		o.write_shift(4, r.e.r);
		o.write_shift(4, r.s.c);
		o.write_shift(4, r.e.c);
		return o;
	}
	
	/* [MS-XLSB] 2.5.153 UncheckedRfX */
	var parse_UncheckedRfX = parse_RfX;
	var write_UncheckedRfX = write_RfX;
	
	/* [MS-XLSB] 2.5.155 UncheckedSqRfX */
	//function parse_UncheckedSqRfX(data) {
	//	var cnt = data.read_shift(4);
	//	var out = [];
	//	for(var i = 0; i < cnt; ++i) {
	//		var rng = parse_UncheckedRfX(data);
	//		out.push(encode_range(rng));
	//	}
	//	return out.join(",");
	//}
	//function write_UncheckedSqRfX(sqrfx) {
	//	var parts = sqrfx.split(/\s*,\s*/);
	//	var o = new_buf(4); o.write_shift(4, parts.length);
	//	var out = [o];
	//	parts.forEach(function(rng) {
	//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
	//	});
	//	return bconcat(out);
	//}
	
	/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */
	/* TODO: error checking, NaN and Infinity values are not valid Xnum */
	function parse_Xnum(data) {
		if(data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
		return data.read_shift(8, 'f');
	}
	function write_Xnum(data, o) { return (o || new_buf(8)).write_shift(8, data, 'f'); }
	
	/* [MS-XLSB] 2.4.324 BrtColor */
	function parse_BrtColor(data) {
		var out = {};
		var d = data.read_shift(1);
	
		//var fValidRGB = d & 1;
		var xColorType = d >>> 1;
	
		var index = data.read_shift(1);
		var nTS = data.read_shift(2, 'i');
		var bR = data.read_shift(1);
		var bG = data.read_shift(1);
		var bB = data.read_shift(1);
		data.l++; //var bAlpha = data.read_shift(1);
	
		switch (xColorType) {
			case 0: out.auto = 1; break;
			case 1:
				out.index = index;
				var icv = XLSIcv[index];
				/* automatic pseudo index 81 */
				if (icv) out.rgb = rgb2Hex(icv);
				break;
			case 2:
				/* if(!fValidRGB) throw new Error("invalid"); */
				out.rgb = rgb2Hex([bR, bG, bB]);
				break;
			case 3: out.theme = index; break;
		}
		if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
	
		return out;
	}
	function write_BrtColor(color, o) {
		if (!o) o = new_buf(8);
		if (!color || color.auto) { o.write_shift(4, 0); o.write_shift(4, 0); return o; }
		if (color.index != null) {
			o.write_shift(1, 0x02);
			o.write_shift(1, color.index);
		} else if (color.theme != null) {
			o.write_shift(1, 0x06);
			o.write_shift(1, color.theme);
		} else {
			o.write_shift(1, 0x05);
			o.write_shift(1, 0);
		}
		var nTS = color.tint || 0;
		if (nTS > 0) nTS *= 32767;
		else if (nTS < 0) nTS *= 32768;
		o.write_shift(2, nTS);
		if (!color.rgb || color.theme != null) {
			o.write_shift(2, 0);
			o.write_shift(1, 0);
			o.write_shift(1, 0);
		} else {
			var rgb = (color.rgb || 'FFFFFF');
			if (typeof rgb == 'number') rgb = ("000000" + rgb.toString(16)).slice(-6);
			o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
			o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
			o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
			o.write_shift(1, 0xFF);
		}
		return o;
	}
	
	/* [MS-XLSB] 2.5.52 */
	function parse_FontFlags(data) {
		var d = data.read_shift(1);
		data.l++;
		var out = {
			fBold: d & 0x01,
			fItalic: d & 0x02,
			fUnderline: d & 0x04,
			fStrikeout: d & 0x08,
			fOutline: d & 0x10,
			fShadow: d & 0x20,
			fCondense: d & 0x40,
			fExtend: d & 0x80
		};
		return out;
	}
	function write_FontFlags(font, o) {
		if (!o) o = new_buf(2);
		var grbit =
			(font.italic ? 0x02 : 0) |
			(font.strike ? 0x08 : 0) |
			(font.outline ? 0x10 : 0) |
			(font.shadow ? 0x20 : 0) |
			(font.condense ? 0x40 : 0) |
			(font.extend ? 0x80 : 0);
		o.write_shift(1, grbit);
		o.write_shift(1, 0);
		return o;
	}
	
	/* [MS-OLEDS] 2.3.1 and 2.3.2 */
	function parse_ClipboardFormatOrString(o, w) {
		// $FlowIgnore
		var ClipFmt = { 2: "BITMAP", 3: "METAFILEPICT", 8: "DIB", 14: "ENHMETAFILE" };
		var m = o.read_shift(4);
		switch (m) {
			case 0x00000000: return "";
			case 0xffffffff: case 0xfffffffe: return ClipFmt[o.read_shift(4)] || "";
		}
		if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
		o.l -= 4;
		return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
	}
	function parse_ClipboardFormatOrAnsiString(o) { return parse_ClipboardFormatOrString(o, 1); }
	function parse_ClipboardFormatOrUnicodeString(o) { return parse_ClipboardFormatOrString(o, 2); }
	
	/* [MS-OLEPS] 2.2 PropertyType */
	// Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
	//var VT_EMPTY    = 0x0000;
	//var VT_NULL     = 0x0001;
	var VT_I2       = 0x0002;
	var VT_I4       = 0x0003;
	//var VT_R4       = 0x0004;
	//var VT_R8       = 0x0005;
	//var VT_CY       = 0x0006;
	//var VT_DATE     = 0x0007;
	//var VT_BSTR     = 0x0008;
	//var VT_ERROR    = 0x000A;
	var VT_BOOL     = 0x000B;
	var VT_VARIANT  = 0x000C;
	//var VT_DECIMAL  = 0x000E;
	//var VT_I1       = 0x0010;
	//var VT_UI1      = 0x0011;
	//var VT_UI2      = 0x0012;
	var VT_UI4      = 0x0013;
	//var VT_I8       = 0x0014;
	//var VT_UI8      = 0x0015;
	//var VT_INT      = 0x0016;
	//var VT_UINT     = 0x0017;
	var VT_LPSTR    = 0x001E;
	//var VT_LPWSTR   = 0x001F;
	var VT_FILETIME = 0x0040;
	var VT_BLOB     = 0x0041;
	//var VT_STREAM   = 0x0042;
	//var VT_STORAGE  = 0x0043;
	//var VT_STREAMED_Object  = 0x0044;
	//var VT_STORED_Object    = 0x0045;
	//var VT_BLOB_Object      = 0x0046;
	var VT_CF       = 0x0047;
	//var VT_CLSID    = 0x0048;
	//var VT_VERSIONED_STREAM = 0x0049;
	var VT_VECTOR   = 0x1000;
	var VT_VECTOR_VARIANT = 0x100C;
	var VT_VECTOR_LPSTR   = 0x101E;
	//var VT_ARRAY    = 0x2000;
	
	var VT_STRING   = 0x0050; // 2.3.3.1.11 VtString
	var VT_USTR     = 0x0051; // 2.3.3.1.12 VtUnalignedString
	var VT_CUSTOM   = [VT_STRING, VT_USTR];
	
	/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */
	var DocSummaryPIDDSI = {
	0x01: { n: 'CodePage', t: VT_I2 },
	0x02: { n: 'Category', t: VT_STRING },
	0x03: { n: 'PresentationFormat', t: VT_STRING },
	0x04: { n: 'ByteCount', t: VT_I4 },
	0x05: { n: 'LineCount', t: VT_I4 },
	0x06: { n: 'ParagraphCount', t: VT_I4 },
	0x07: { n: 'SlideCount', t: VT_I4 },
	0x08: { n: 'NoteCount', t: VT_I4 },
	0x09: { n: 'HiddenCount', t: VT_I4 },
	0x0a: { n: 'MultimediaClipCount', t: VT_I4 },
	0x0b: { n: 'ScaleCrop', t: VT_BOOL },
	0x0c: { n: 'HeadingPairs', t: VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ },
	0x0d: { n: 'TitlesOfParts', t: VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ },
	0x0e: { n: 'Manager', t: VT_STRING },
	0x0f: { n: 'Company', t: VT_STRING },
	0x10: { n: 'LinksUpToDate', t: VT_BOOL },
	0x11: { n: 'CharacterCount', t: VT_I4 },
	0x13: { n: 'SharedDoc', t: VT_BOOL },
	0x16: { n: 'HyperlinksChanged', t: VT_BOOL },
	0x17: { n: 'AppVersion', t: VT_I4, p: 'version' },
	0x18: { n: 'DigSig', t: VT_BLOB },
	0x1A: { n: 'ContentType', t: VT_STRING },
	0x1B: { n: 'ContentStatus', t: VT_STRING },
	0x1C: { n: 'Language', t: VT_STRING },
	0x1D: { n: 'Version', t: VT_STRING },
	0xFF: {},
		/* [MS-OLEPS] 2.18 */
	0x80000000: { n: 'Locale', t: VT_UI4 },
	0x80000003: { n: 'Behavior', t: VT_UI4 },
	0x72627262: {}
	};
	
	/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */
	var SummaryPIDSI = {
	0x01: { n: 'CodePage', t: VT_I2 },
	0x02: { n: 'Title', t: VT_STRING },
	0x03: { n: 'Subject', t: VT_STRING },
	0x04: { n: 'Author', t: VT_STRING },
	0x05: { n: 'Keywords', t: VT_STRING },
	0x06: { n: 'Comments', t: VT_STRING },
	0x07: { n: 'Template', t: VT_STRING },
	0x08: { n: 'LastAuthor', t: VT_STRING },
	0x09: { n: 'RevNumber', t: VT_STRING },
	0x0A: { n: 'EditTime', t: VT_FILETIME },
	0x0B: { n: 'LastPrinted', t: VT_FILETIME },
	0x0C: { n: 'CreatedDate', t: VT_FILETIME },
	0x0D: { n: 'ModifiedDate', t: VT_FILETIME },
	0x0E: { n: 'PageCount', t: VT_I4 },
	0x0F: { n: 'WordCount', t: VT_I4 },
	0x10: { n: 'CharCount', t: VT_I4 },
	0x11: { n: 'Thumbnail', t: VT_CF },
	0x12: { n: 'Application', t: VT_STRING },
	0x13: { n: 'DocSecurity', t: VT_I4 },
	0xFF: {},
		/* [MS-OLEPS] 2.18 */
	0x80000000: { n: 'Locale', t: VT_UI4 },
	0x80000003: { n: 'Behavior', t: VT_UI4 },
	0x72627262: {}
	};
	
	/* [MS-XLS] 2.4.63 Country/Region codes */
	var CountryEnum = {
	0x0001: "US", // United States
	0x0002: "CA", // Canada
	0x0003: "", // Latin America (except Brazil)
	0x0007: "RU", // Russia
	0x0014: "EG", // Egypt
	0x001E: "GR", // Greece
	0x001F: "NL", // Netherlands
	0x0020: "BE", // Belgium
	0x0021: "FR", // France
	0x0022: "ES", // Spain
	0x0024: "HU", // Hungary
	0x0027: "IT", // Italy
	0x0029: "CH", // Switzerland
	0x002B: "AT", // Austria
	0x002C: "GB", // United Kingdom
	0x002D: "DK", // Denmark
	0x002E: "SE", // Sweden
	0x002F: "NO", // Norway
	0x0030: "PL", // Poland
	0x0031: "DE", // Germany
	0x0034: "MX", // Mexico
	0x0037: "BR", // Brazil
	0x003d: "AU", // Australia
	0x0040: "NZ", // New Zealand
	0x0042: "TH", // Thailand
	0x0051: "JP", // Japan
	0x0052: "KR", // Korea
	0x0054: "VN", // Viet Nam
	0x0056: "CN", // China
	0x005A: "TR", // Turkey
	0x0069: "JS", // Ramastan
	0x00D5: "DZ", // Algeria
	0x00D8: "MA", // Morocco
	0x00DA: "LY", // Libya
	0x015F: "PT", // Portugal
	0x0162: "IS", // Iceland
	0x0166: "FI", // Finland
	0x01A4: "CZ", // Czech Republic
	0x0376: "TW", // Taiwan
	0x03C1: "LB", // Lebanon
	0x03C2: "JO", // Jordan
	0x03C3: "SY", // Syria
	0x03C4: "IQ", // Iraq
	0x03C5: "KW", // Kuwait
	0x03C6: "SA", // Saudi Arabia
	0x03CB: "AE", // United Arab Emirates
	0x03CC: "IL", // Israel
	0x03CE: "QA", // Qatar
	0x03D5: "IR", // Iran
	0xFFFF: "US"  // United States
	};
	
	/* [MS-XLS] 2.5.127 */
	var XLSFillPattern = [
		null,
		'solid',
		'mediumGray',
		'darkGray',
		'lightGray',
		'darkHorizontal',
		'darkVertical',
		'darkDown',
		'darkUp',
		'darkGrid',
		'darkTrellis',
		'lightHorizontal',
		'lightVertical',
		'lightDown',
		'lightUp',
		'lightGrid',
		'lightTrellis',
		'gray125',
		'gray0625'
	];
	
	function rgbify(arr) { return arr.map(function(x) { return [(x>>16)&255,(x>>8)&255,x&255]; }); }
	
	/* [MS-XLS] 2.5.161 */
	/* [MS-XLSB] 2.5.75 Icv */
	var _XLSIcv =  rgbify([
		/* Color Constants */
		0x000000,
		0xFFFFFF,
		0xFF0000,
		0x00FF00,
		0x0000FF,
		0xFFFF00,
		0xFF00FF,
		0x00FFFF,
	
		/* Overridable Defaults */
		0x000000,
		0xFFFFFF,
		0xFF0000,
		0x00FF00,
		0x0000FF,
		0xFFFF00,
		0xFF00FF,
		0x00FFFF,
	
		0x800000,
		0x008000,
		0x000080,
		0x808000,
		0x800080,
		0x008080,
		0xC0C0C0,
		0x808080,
		0x9999FF,
		0x993366,
		0xFFFFCC,
		0xCCFFFF,
		0x660066,
		0xFF8080,
		0x0066CC,
		0xCCCCFF,
	
		0x000080,
		0xFF00FF,
		0xFFFF00,
		0x00FFFF,
		0x800080,
		0x800000,
		0x008080,
		0x0000FF,
		0x00CCFF,
		0xCCFFFF,
		0xCCFFCC,
		0xFFFF99,
		0x99CCFF,
		0xFF99CC,
		0xCC99FF,
		0xFFCC99,
	
		0x3366FF,
		0x33CCCC,
		0x99CC00,
		0xFFCC00,
		0xFF9900,
		0xFF6600,
		0x666699,
		0x969696,
		0x003366,
		0x339966,
		0x003300,
		0x333300,
		0x993300,
		0x993366,
		0x333399,
		0x333333,
	
		/* Other entries to appease BIFF8/12 */
		0xFFFFFF, /* 0x40 icvForeground ?? */
		0x000000, /* 0x41 icvBackground ?? */
		0x000000, /* 0x42 icvFrame ?? */
		0x000000, /* 0x43 icv3D ?? */
		0x000000, /* 0x44 icv3DText ?? */
		0x000000, /* 0x45 icv3DHilite ?? */
		0x000000, /* 0x46 icv3DShadow ?? */
		0x000000, /* 0x47 icvHilite ?? */
		0x000000, /* 0x48 icvCtlText ?? */
		0x000000, /* 0x49 icvCtlScrl ?? */
		0x000000, /* 0x4A icvCtlInv ?? */
		0x000000, /* 0x4B icvCtlBody ?? */
		0x000000, /* 0x4C icvCtlFrame ?? */
		0x000000, /* 0x4D icvCtlFore ?? */
		0x000000, /* 0x4E icvCtlBack ?? */
		0x000000, /* 0x4F icvCtlNeutral */
		0x000000, /* 0x50 icvInfoBk ?? */
		0x000000 /* 0x51 icvInfoText ?? */
	]);
	var XLSIcv = dup(_XLSIcv);
	
	/* [MS-XLSB] 2.5.97.2 */
	var BErr = {
	0x00: "#NULL!",
	0x07: "#DIV/0!",
	0x0F: "#VALUE!",
	0x17: "#REF!",
	0x1D: "#NAME?",
	0x24: "#NUM!",
	0x2A: "#N/A",
	0x2B: "#GETTING_DATA",
	0xFF: "#WTF?"
	};
	//var RBErr = evert_num(BErr);
	var RBErr = {
		"#NULL!":        0x00,
		"#DIV/0!":       0x07,
		"#VALUE!":       0x0F,
		"#REF!":         0x17,
		"#NAME?":        0x1D,
		"#NUM!":         0x24,
		"#N/A":          0x2A,
		"#GETTING_DATA": 0x2B,
		"#WTF?":         0xFF
	};
	
	/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */
	/* 12.3 Part Summary <SpreadsheetML> */
	/* 14.2 Part Summary <DrawingML> */
	/* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */
	var ct2type/*{[string]:string}*/ = ({
		/* Workbook */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
		"application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
		"application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
		"application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
	
		/* Worksheet */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
		"application/vnd.ms-excel.worksheet": "sheets",
		"application/vnd.ms-excel.binIndexWs": "TODO", /* Binary Index */
	
		/* Chartsheet */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
		"application/vnd.ms-excel.chartsheet": "charts",
	
		/* Macrosheet */
		"application/vnd.ms-excel.macrosheet+xml": "macros",
		"application/vnd.ms-excel.macrosheet": "macros",
		"application/vnd.ms-excel.intlmacrosheet": "TODO",
		"application/vnd.ms-excel.binIndexMs": "TODO", /* Binary Index */
	
		/* Dialogsheet */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
		"application/vnd.ms-excel.dialogsheet": "dialogs",
	
		/* Shared Strings */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
		"application/vnd.ms-excel.sharedStrings": "strs",
	
		/* Styles */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
		"application/vnd.ms-excel.styles": "styles",
	
		/* File Properties */
		"application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
		"application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
		"application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
	
		/* Custom Data Properties */
		"application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
	
		/* Comments */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
		"application/vnd.ms-excel.comments": "comments",
		"application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
		"application/vnd.ms-excel.person+xml": "people",
	
		/* Metadata (Stock/Geography and Dynamic Array) */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
		"application/vnd.ms-excel.sheetMetadata": "metadata",
	
		/* PivotTable */
		"application/vnd.ms-excel.pivotTable": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
	
		/* Chart Objects */
		"application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
	
		/* Chart Colors */
		"application/vnd.ms-office.chartcolorstyle+xml": "TODO",
	
		/* Chart Style */
		"application/vnd.ms-office.chartstyle+xml": "TODO",
	
		/* Chart Advanced */
		"application/vnd.ms-office.chartex+xml": "TODO",
	
		/* Calculation Chain */
		"application/vnd.ms-excel.calcChain": "calcchains",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
	
		/* Printer Settings */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
	
		/* ActiveX */
		"application/vnd.ms-office.activeX": "TODO",
		"application/vnd.ms-office.activeX+xml": "TODO",
	
		/* Custom Toolbars */
		"application/vnd.ms-excel.attachedToolbars": "TODO",
	
		/* External Data Connections */
		"application/vnd.ms-excel.connections": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
	
		/* External Links */
		"application/vnd.ms-excel.externalLink": "links",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
	
		/* PivotCache */
		"application/vnd.ms-excel.pivotCacheDefinition": "TODO",
		"application/vnd.ms-excel.pivotCacheRecords": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
	
		/* Query Table */
		"application/vnd.ms-excel.queryTable": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
	
		/* Shared Workbook */
		"application/vnd.ms-excel.userNames": "TODO",
		"application/vnd.ms-excel.revisionHeaders": "TODO",
		"application/vnd.ms-excel.revisionLog": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
	
		/* Single Cell Table */
		"application/vnd.ms-excel.tableSingleCells": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
	
		/* Slicer */
		"application/vnd.ms-excel.slicer": "TODO",
		"application/vnd.ms-excel.slicerCache": "TODO",
		"application/vnd.ms-excel.slicer+xml": "TODO",
		"application/vnd.ms-excel.slicerCache+xml": "TODO",
	
		/* Sort Map */
		"application/vnd.ms-excel.wsSortMap": "TODO",
	
		/* Table */
		"application/vnd.ms-excel.table": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
	
		/* Themes */
		"application/vnd.openxmlformats-officedocument.theme+xml": "themes",
	
		/* Theme Override */
		"application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
	
		/* Timeline */
		"application/vnd.ms-excel.Timeline+xml": "TODO", /* verify */
		"application/vnd.ms-excel.TimelineCache+xml": "TODO", /* verify */
	
		/* VBA */
		"application/vnd.ms-office.vbaProject": "vba",
		"application/vnd.ms-office.vbaProjectSignature": "TODO",
	
		/* Volatile Dependencies */
		"application/vnd.ms-office.volatileDependencies": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
	
		/* Control Properties */
		"application/vnd.ms-excel.controlproperties+xml": "TODO",
	
		/* Data Model */
		"application/vnd.openxmlformats-officedocument.model+data": "TODO",
	
		/* Survey */
		"application/vnd.ms-excel.Survey+xml": "TODO",
	
		/* Drawing */
		"application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
		"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
	
		/* VML */
		"application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
	
		"application/vnd.openxmlformats-package.relationships+xml": "rels",
		"application/vnd.openxmlformats-officedocument.oleObject": "TODO",
	
		/* Image */
		"image/png": "TODO",
	
		"sheet": "js"
	});
	
	var CT_LIST = {
			workbooks: {
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
				xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
				xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
				xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
				xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
			},
			strs: { /* Shared Strings */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
				xlsb: "application/vnd.ms-excel.sharedStrings"
			},
			comments: { /* Comments */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
				xlsb: "application/vnd.ms-excel.comments"
			},
			sheets: { /* Worksheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
				xlsb: "application/vnd.ms-excel.worksheet"
			},
			charts: { /* Chartsheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
				xlsb: "application/vnd.ms-excel.chartsheet"
			},
			dialogs: { /* Dialogsheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
				xlsb: "application/vnd.ms-excel.dialogsheet"
			},
			macros: { /* Macrosheet (Excel 4.0 Macros) */
				xlsx: "application/vnd.ms-excel.macrosheet+xml",
				xlsb: "application/vnd.ms-excel.macrosheet"
			},
			metadata: { /* Metadata (Stock/Geography and Dynamic Array) */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
				xlsb: "application/vnd.ms-excel.sheetMetadata"
			},
			styles: { /* Styles */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
				xlsb: "application/vnd.ms-excel.styles"
			}
	};
	
	function new_ct() {
		return ({
			workbooks:[], sheets:[], charts:[], dialogs:[], macros:[],
			rels:[], strs:[], comments:[], threadedcomments:[], links:[],
			coreprops:[], extprops:[], custprops:[], themes:[], styles:[],
			calcchains:[], vba: [], drawings: [], metadata: [], people:[],
			TODO:[], xmlns: "" });
	}
	
	function parse_ct(data) {
		var ct = new_ct();
		if(!data || !data.match) return ct;
		var ctext = {};
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0].replace(nsregex,"<")) {
				case '<?xml': break;
				case '<Types': ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/)||["",""])[1] ]; break;
				case '<Default': ctext[y.Extension] = y.ContentType; break;
				case '<Override':
					if(ct[ct2type[y.ContentType]] !== undefined) ct[ct2type[y.ContentType]].push(y.PartName);
					break;
			}
		});
		if(ct.xmlns !== XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
		ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
		ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
		ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
		ct.defaults = ctext;
		delete ct.calcchains;
		return ct;
	}
	
	function write_ct(ct, opts) {
		var type2ct/*{[string]:Array<string>}*/ = evert_arr(ct2type);
	
		var o = [], v;
		o[o.length] = (XML_HEADER);
		o[o.length] = writextag('Types', null, {
			'xmlns': XMLNS.CT,
			'xmlns:xsd': XMLNS.xsd,
			'xmlns:xsi': XMLNS.xsi
		});
	
		o = o.concat([
			['xml', 'application/xml'],
			['bin', 'application/vnd.ms-excel.sheet.binary.macroEnabled.main'],
			['vml', 'application/vnd.openxmlformats-officedocument.vmlDrawing'],
			['data', 'application/vnd.openxmlformats-officedocument.model+data'],
			/* from test files */
			['bmp', 'image/bmp'],
			['png', 'image/png'],
			['gif', 'image/gif'],
			['emf', 'image/x-emf'],
			['wmf', 'image/x-wmf'],
			['jpg', 'image/jpeg'], ['jpeg', 'image/jpeg'],
			['tif', 'image/tiff'], ['tiff', 'image/tiff'],
			['pdf', 'application/pdf'],
			['rels', 'application/vnd.openxmlformats-package.relationships+xml']
		].map(function(x) {
			return writextag('Default', null, {'Extension':x[0], 'ContentType': x[1]});
		}));
	
		/* only write first instance */
		var f1 = function(w) {
			if(ct[w] && ct[w].length > 0) {
				v = ct[w][0];
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': CT_LIST[w][opts.bookType] || CT_LIST[w]['xlsx']
				}));
			}
		};
	
		/* book type-specific */
		var f2 = function(w) {
			(ct[w]||[]).forEach(function(v) {
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': CT_LIST[w][opts.bookType] || CT_LIST[w]['xlsx']
				}));
			});
		};
	
		/* standard type */
		var f3 = function(t) {
			(ct[t]||[]).forEach(function(v) {
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': type2ct[t][0]
				}));
			});
		};
	
		f1('workbooks');
		f2('sheets');
		f2('charts');
		f3('themes');
		['strs', 'styles'].forEach(f1);
		['coreprops', 'extprops', 'custprops'].forEach(f3);
		f3('vba');
		f3('comments');
		f3('threadedcomments');
		f3('drawings');
		f2('metadata');
		f3('people');
		if(o.length>2){ o[o.length] = ('</Types>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 9.3 Relationships */
	var RELS = ({
		WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
		SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
		HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
		VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
		XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
		XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
		XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
		CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
		CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
		CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
		CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
		EXT_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties',
		CUST_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties',
		SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
		STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
		THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
		CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
		CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
		CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
		WS: [
			"http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
			"http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
		],
		DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
		MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
		IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
		DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
		XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
		TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
		PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
		VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
	});
	
	
	/* 9.3.3 Representing Relationships */
	function get_rels_path(file) {
		var n = file.lastIndexOf("/");
		return file.slice(0,n+1) + '_rels/' + file.slice(n+1) + ".rels";
	}
	
	function parse_rels(data, currentFilePath) {
		var rels = {"!id":{}};
		if (!data) return rels;
		if (currentFilePath.charAt(0) !== '/') {
			currentFilePath = '/'+currentFilePath;
		}
		var hash = {};
	
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			/* 9.3.2.2 OPC_Relationships */
			if (y[0] === '<Relationship') {
				var rel = {}; rel.Type = y.Type; rel.Target = y.Target; rel.Id = y.Id; if(y.TargetMode) rel.TargetMode = y.TargetMode;
				var canonictarget = y.TargetMode === 'External' ? y.Target : resolve_path(y.Target, currentFilePath);
				rels[canonictarget] = rel;
				hash[y.Id] = rel;
			}
		});
		rels["!id"] = hash;
		return rels;
	}
	
	
	/* TODO */
	function write_rels(rels) {
		var o = [XML_HEADER, writextag('Relationships', null, {
			//'xmlns:ns0': XMLNS.RELS,
			'xmlns': XMLNS.RELS
		})];
		keys(rels['!id']).forEach(function(rid) {
			o[o.length] = (writextag('Relationship', null, rels['!id'][rid]));
		});
		if(o.length>2){ o[o.length] = ('</Relationships>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	function add_rels(rels, rId, f, type, relobj, targetmode) {
		if(!relobj) relobj = {};
		if(!rels['!id']) rels['!id'] = {};
		if(!rels['!idx']) rels['!idx'] = 1;
		if(rId < 0) for(rId = rels['!idx']; rels['!id']['rId' + rId]; ++rId){/* empty */}
		rels['!idx'] = rId + 1;
		relobj.Id = 'rId' + rId;
		relobj.Type = type;
		relobj.Target = f;
		if(targetmode) relobj.TargetMode = targetmode;
		else if([RELS.HLINK, RELS.XPATH, RELS.XMISS].indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
		if(rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
		rels['!id'][relobj.Id] = relobj;
		rels[('/' + relobj.Target).replace("//","/")] = relobj;
		return rId;
	}
	/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */
	/* Part 3 Section 4 Manifest File */
	var CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
	function parse_manifest(d, opts) {
		var str = xlml_normalize(d);
		var Rn;
		var FEtag;
		while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
			case 'manifest': break; // 4.2 <manifest:manifest>
			case 'file-entry': // 4.3 <manifest:file-entry>
				FEtag = parsexmltag(Rn[0], false);
				if(FEtag.path == '/' && FEtag.type !== CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
				break;
			case 'encryption-data': // 4.4 <manifest:encryption-data>
			case 'algorithm': // 4.5 <manifest:algorithm>
			case 'start-key-generation': // 4.6 <manifest:start-key-generation>
			case 'key-derivation': // 4.7 <manifest:key-derivation>
				throw new Error("Unsupported ODS Encryption");
			default: if(opts && opts.WTF) throw Rn;
		}
	}
	
	function write_manifest(manifest) {
		var o = [XML_HEADER];
		o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
		o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
		for(var i = 0; i < manifest.length; ++i) o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
		o.push('</manifest:manifest>');
		return o.join("");
	}
	
	/* Part 3 Section 6 Metadata Manifest File */
	function write_rdf_type(file, res, tag) {
		return [
			'  <rdf:Description rdf:about="' + file + '">\n',
			'    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + '#' + res + '"/>\n',
			'  </rdf:Description>\n'
		].join("");
	}
	function write_rdf_has(base, file) {
		return [
			'  <rdf:Description rdf:about="' + base + '">\n',
			'    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
			'  </rdf:Description>\n'
		].join("");
	}
	function write_rdf(rdf) {
		var o = [XML_HEADER];
		o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
		for(var i = 0; i != rdf.length; ++i) {
			o.push(write_rdf_type(rdf[i][0], rdf[i][1]));
			o.push(write_rdf_has("",rdf[i][0]));
		}
		o.push(write_rdf_type("","Document", "pkg"));
		o.push('</rdf:RDF>');
		return o.join("");
	}
	/* TODO: pull properties */
	function write_meta_ods() {
		return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet' + 'JS ' + XLSX.version + '</meta:generator></office:meta></office:document-meta>';
	}
	
	/* ECMA-376 Part II 11.1 Core Properties Part */
	/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
	var CORE_PROPS = [
		["cp:category", "Category"],
		["cp:contentStatus", "ContentStatus"],
		["cp:keywords", "Keywords"],
		["cp:lastModifiedBy", "LastAuthor"],
		["cp:lastPrinted", "LastPrinted"],
		["cp:revision", "RevNumber"],
		["cp:version", "Version"],
		["dc:creator", "Author"],
		["dc:description", "Comments"],
		["dc:identifier", "Identifier"],
		["dc:language", "Language"],
		["dc:subject", "Subject"],
		["dc:title", "Title"],
		["dcterms:created", "CreatedDate", 'date'],
		["dcterms:modified", "ModifiedDate", 'date']
	];
	
	var CORE_PROPS_REGEX = (function() {
		var r = new Array(CORE_PROPS.length);
		for(var i = 0; i < CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i];
			var g = "(?:"+ f[0].slice(0,f[0].indexOf(":")) +":)"+ f[0].slice(f[0].indexOf(":")+1);
			r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)<\/" + g + ">");
		}
		return r;
	})();
	
	function parse_core_props(data) {
		var p = {};
		data = utf8read(data);
	
		for(var i = 0; i < CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i], cur = data.match(CORE_PROPS_REGEX[i]);
			if(cur != null && cur.length > 0) p[f[1]] = unescapexml(cur[1]);
			if(f[2] === 'date' && p[f[1]]) p[f[1]] = parseDate(p[f[1]]);
		}
	
		return p;
	}
	
	function cp_doit(f, g, h, o, p) {
		if(p[f] != null || g == null || g === "") return;
		p[f] = g;
		g = escapexml(g);
		o[o.length] = (h ? writextag(f,g,h) : writetag(f,g));
	}
	
	function write_core_props(cp, _opts) {
		var opts = _opts || {};
		var o = [XML_HEADER, writextag('cp:coreProperties', null, {
			//'xmlns': XMLNS.CORE_PROPS,
			'xmlns:cp': XMLNS.CORE_PROPS,
			'xmlns:dc': XMLNS.dc,
			'xmlns:dcterms': XMLNS.dcterms,
			'xmlns:dcmitype': XMLNS.dcmitype,
			'xmlns:xsi': XMLNS.xsi
		})], p = {};
		if(!cp && !opts.Props) return o.join("");
	
		if(cp) {
			if(cp.CreatedDate != null) cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : write_w3cdtf(cp.CreatedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
			if(cp.ModifiedDate != null) cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : write_w3cdtf(cp.ModifiedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
		}
	
		for(var i = 0; i != CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i];
			var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
			if(v === true) v = "1";
			else if(v === false) v = "0";
			else if(typeof v == "number") v = String(v);
			if(v != null) cp_doit(f[0], v, null, o, p);
		}
		if(o.length>2){ o[o.length] = ('</cp:coreProperties>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 15.2.12.3 Extended File Properties Part */
	/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
	var EXT_PROPS = [
		["Application", "Application", "string"],
		["AppVersion", "AppVersion", "string"],
		["Company", "Company", "string"],
		["DocSecurity", "DocSecurity", "string"],
		["Manager", "Manager", "string"],
		["HyperlinksChanged", "HyperlinksChanged", "bool"],
		["SharedDoc", "SharedDoc", "bool"],
		["LinksUpToDate", "LinksUpToDate", "bool"],
		["ScaleCrop", "ScaleCrop", "bool"],
		["HeadingPairs", "HeadingPairs", "raw"],
		["TitlesOfParts", "TitlesOfParts", "raw"]
	];
	
	var PseudoPropsPairs = [
		"Worksheets",  "SheetNames",
		"NamedRanges", "DefinedNames",
		"Chartsheets", "ChartNames"
	];
	function load_props_pairs(HP, TOP, props, opts) {
		var v = [];
		if(typeof HP == "string") v = parseVector(HP, opts);
		else for(var j = 0; j < HP.length; ++j) v = v.concat(HP[j].map(function(hp) { return {v:hp}; }));
		var parts = (typeof TOP == "string") ? parseVector(TOP, opts).map(function (x) { return x.v; }) : TOP;
		var idx = 0, len = 0;
		if(parts.length > 0) for(var i = 0; i !== v.length; i += 2) {
			len = +(v[i+1].v);
			switch(v[i].v) {
				case "Worksheets":
				case "工作表":
				case "Листы":
				case "أوراق العمل":
				case "ワークシート":
				case "גליונות עבודה":
				case "Arbeitsblätter":
				case "Çalışma Sayfaları":
				case "Feuilles de calcul":
				case "Fogli di lavoro":
				case "Folhas de cálculo":
				case "Planilhas":
				case "Regneark":
				case "Hojas de cálculo":
				case "Werkbladen":
					props.Worksheets = len;
					props.SheetNames = parts.slice(idx, idx + len);
					break;
	
				case "Named Ranges":
				case "Rangos con nombre":
				case "名前付き一覧":
				case "Benannte Bereiche":
				case "Navngivne områder":
					props.NamedRanges = len;
					props.DefinedNames = parts.slice(idx, idx + len);
					break;
	
				case "Charts":
				case "Diagramme":
					props.Chartsheets = len;
					props.ChartNames = parts.slice(idx, idx + len);
					break;
			}
			idx += len;
		}
	}
	
	function parse_ext_props(data, p, opts) {
		var q = {}; if(!p) p = {};
		data = utf8read(data);
	
		EXT_PROPS.forEach(function(f) {
			var xml = (data.match(matchtag(f[0]))||[])[1];
			switch(f[2]) {
				case "string": if(xml) p[f[1]] = unescapexml(xml); break;
				case "bool": p[f[1]] = xml === "true"; break;
				case "raw":
					var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)<\/" + f[0] + ">"));
					if(cur && cur.length > 0) q[f[1]] = cur[1];
					break;
			}
		});
	
		if(q.HeadingPairs && q.TitlesOfParts) load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
	
		return p;
	}
	
	function write_ext_props(cp) {
		var o = [], W = writextag;
		if(!cp) cp = {};
		cp.Application = "SheetJS";
		o[o.length] = (XML_HEADER);
		o[o.length] = (writextag('Properties', null, {
			'xmlns': XMLNS.EXT_PROPS,
			'xmlns:vt': XMLNS.vt
		}));
	
		EXT_PROPS.forEach(function(f) {
			if(cp[f[1]] === undefined) return;
			var v;
			switch(f[2]) {
				case 'string': v = escapexml(String(cp[f[1]])); break;
				case 'bool': v = cp[f[1]] ? 'true' : 'false'; break;
			}
			if(v !== undefined) o[o.length] = (W(f[0], v));
		});
	
		/* TODO: HeadingPairs, TitlesOfParts */
		o[o.length] = (W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>')+W('vt:variant', W('vt:i4', String(cp.Worksheets))), {size:2, baseType:"variant"})));
		o[o.length] = (W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) { return "<vt:lpstr>" + escapexml(s) + "</vt:lpstr>"; }).join(""), {size: cp.Worksheets, baseType:"lpstr"})));
		if(o.length>2){ o[o.length] = ('</Properties>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 15.2.12.2 Custom File Properties Part */
	var custregex = /<[^>]+>[^<]*/g;
	function parse_cust_props(data, opts) {
		var p = {}, name = "";
		var m = data.match(custregex);
		if(m) for(var i = 0; i != m.length; ++i) {
			var x = m[i], y = parsexmltag(x);
			switch(y[0]) {
				case '<?xml': break;
				case '<Properties': break;
				case '<property': name = unescapexml(y.name); break;
				case '</property>': name = null; break;
				default: if (x.indexOf('<vt:') === 0) {
					var toks = x.split('>');
					var type = toks[0].slice(4), text = toks[1];
					/* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */
					switch(type) {
						case 'lpstr': case 'bstr': case 'lpwstr':
							p[name] = unescapexml(text);
							break;
						case 'bool':
							p[name] = parsexmlbool(text);
							break;
						case 'i1': case 'i2': case 'i4': case 'i8': case 'int': case 'uint':
							p[name] = parseInt(text, 10);
							break;
						case 'r4': case 'r8': case 'decimal':
							p[name] = parseFloat(text);
							break;
						case 'filetime': case 'date':
							p[name] = parseDate(text);
							break;
						case 'cy': case 'error':
							p[name] = unescapexml(text);
							break;
						default:
							if(type.slice(-1) == '/') break;
							if(opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
					}
				} else if(x.slice(0,2) === "</") {/* empty */
				} else if(opts.WTF) throw new Error(x);
			}
		}
		return p;
	}
	
	function write_cust_props(cp) {
		var o = [XML_HEADER, writextag('Properties', null, {
			'xmlns': XMLNS.CUST_PROPS,
			'xmlns:vt': XMLNS.vt
		})];
		if(!cp) return o.join("");
		var pid = 1;
		keys(cp).forEach(function custprop(k) { ++pid;
			o[o.length] = (writextag('property', write_vt(cp[k], true), {
				'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
				'pid': pid,
				'name': escapexml(k)
			}));
		});
		if(o.length>2){ o[o.length] = '</Properties>'; o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* Common Name -> XLML Name */
	var XLMLDocPropsMap = {
		Title: 'Title',
		Subject: 'Subject',
		Author: 'Author',
		Keywords: 'Keywords',
		Comments: 'Description',
		LastAuthor: 'LastAuthor',
		RevNumber: 'Revision',
		Application: 'AppName',
		/* TotalTime: 'TotalTime', */
		LastPrinted: 'LastPrinted',
		CreatedDate: 'Created',
		ModifiedDate: 'LastSaved',
		/* Pages */
		/* Words */
		/* Characters */
		Category: 'Category',
		/* PresentationFormat */
		Manager: 'Manager',
		Company: 'Company',
		/* Guid */
		/* HyperlinkBase */
		/* Bytes */
		/* Lines */
		/* Paragraphs */
		/* CharactersWithSpaces */
		AppVersion: 'Version',
	
		ContentStatus: 'ContentStatus', /* NOTE: missing from schema */
		Identifier: 'Identifier', /* NOTE: missing from schema */
		Language: 'Language' /* NOTE: missing from schema */
	};
	var evert_XLMLDPM;
	
	function xlml_set_prop(Props, tag, val) {
		if(!evert_XLMLDPM) evert_XLMLDPM = evert(XLMLDocPropsMap);
		tag = evert_XLMLDPM[tag] || tag;
		Props[tag] = val;
	}
	
	function xlml_write_docprops(Props, opts) {
		var o = [];
		keys(XLMLDocPropsMap).map(function(m) {
			for(var i = 0; i < CORE_PROPS.length; ++i) if(CORE_PROPS[i][1] == m) return CORE_PROPS[i];
			for(i = 0; i < EXT_PROPS.length; ++i) if(EXT_PROPS[i][1] == m) return EXT_PROPS[i];
			throw m;
		}).forEach(function(p) {
			if(Props[p[1]] == null) return;
			var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
			switch(p[2]) {
				case 'date': m = new Date(m).toISOString().replace(/\.\d*Z/,"Z"); break;
			}
			if(typeof m == 'number') m = String(m);
			else if(m === true || m === false) { m = m ? "1" : "0"; }
			else if(m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/,"");
			o.push(writetag(XLMLDocPropsMap[p[1]] || p[1], m));
		});
		return writextag('DocumentProperties', o.join(""), {xmlns:XLMLNS.o });
	}
	function xlml_write_custprops(Props, Custprops) {
		var BLACKLIST = ["Worksheets","SheetNames"];
		var T = 'CustomDocumentProperties';
		var o = [];
		if(Props) keys(Props).forEach(function(k) {
	if(!Object.prototype.hasOwnProperty.call(Props, k)) return;
			for(var i = 0; i < CORE_PROPS.length; ++i) if(k == CORE_PROPS[i][1]) return;
			for(i = 0; i < EXT_PROPS.length; ++i) if(k == EXT_PROPS[i][1]) return;
			for(i = 0; i < BLACKLIST.length; ++i) if(k == BLACKLIST[i]) return;
	
			var m = Props[k];
			var t = "string";
			if(typeof m == 'number') { t = "float"; m = String(m); }
			else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
			else m = String(m);
			o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
		});
		if(Custprops) keys(Custprops).forEach(function(k) {
	if(!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
			if(Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
			var m = Custprops[k];
			var t = "string";
			if(typeof m == 'number') { t = "float"; m = String(m); }
			else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
			else if(m instanceof Date) { t = "dateTime.tz"; m = m.toISOString(); }
			else m = String(m);
			o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
		});
		return '<' + T + ' xmlns="' + XLMLNS.o + '">' + o.join("") + '</' + T + '>';
	}
	/* [MS-DTYP] 2.3.3 FILETIME */
	/* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */
	/* [MS-OLEPS] 2.8 FILETIME (Packet Version) */
	function parse_FILETIME(blob) {
		var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
		return new Date(((dwHighDateTime/1e7*Math.pow(2,32) + dwLowDateTime/1e7) - 11644473600)*1000).toISOString().replace(/\.000/,"");
	}
	function write_FILETIME(time) {
		var date = (typeof time == "string") ? new Date(Date.parse(time)) : time;
		var t = date.getTime() / 1000 + 11644473600;
		var l = t % Math.pow(2,32), h = (t - l) / Math.pow(2,32);
		l *= 1e7; h *= 1e7;
		var w = (l / Math.pow(2,32)) | 0;
		if(w > 0) { l = l % Math.pow(2,32); h += w; }
		var o = new_buf(8); o.write_shift(4, l); o.write_shift(4, h); return o;
	}
	
	/* [MS-OSHARED] 2.3.3.1.4 Lpstr */
	function parse_lpstr(blob, type, pad) {
		var start = blob.l;
		var str = blob.read_shift(0, 'lpstr-cp');
		if(pad) while((blob.l - start) & 3) ++blob.l;
		return str;
	}
	
	/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */
	function parse_lpwstr(blob, type, pad) {
		var str = blob.read_shift(0, 'lpwstr');
		if(pad) blob.l += (4 - ((str.length+1) & 3)) & 3;
		return str;
	}
	
	
	/* [MS-OSHARED] 2.3.3.1.11 VtString */
	/* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */
	function parse_VtStringBase(blob, stringType, pad) {
		if(stringType === 0x1F /*VT_LPWSTR*/) return parse_lpwstr(blob);
		return parse_lpstr(blob, stringType, pad);
	}
	
	function parse_VtString(blob, t, pad) { return parse_VtStringBase(blob, t, pad === false ? 0: 4); }
	function parse_VtUnalignedString(blob, t) { if(!t) throw new Error("VtUnalignedString must have positive length"); return parse_VtStringBase(blob, t, 0); }
	
	/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */
	function parse_VtVecLpwstrValue(blob) {
		var length = blob.read_shift(4);
		var ret = [];
		for(var i = 0; i != length; ++i) {
			var start = blob.l;
			ret[i] = blob.read_shift(0, 'lpwstr').replace(chr0,'');
			if((blob.l - start) & 0x02) blob.l += 2;
		}
		return ret;
	}
	
	/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */
	function parse_VtVecUnalignedLpstrValue(blob) {
		var length = blob.read_shift(4);
		var ret = [];
		for(var i = 0; i != length; ++i) ret[i] = blob.read_shift(0, 'lpstr-cp').replace(chr0,'');
		return ret;
	}
	
	
	/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */
	function parse_VtHeadingPair(blob) {
		var start = blob.l;
		var headingString = parse_TypedPropertyValue(blob, VT_USTR);
		if(blob[blob.l] == 0x00 && blob[blob.l+1] == 0x00 && ((blob.l - start) & 0x02)) blob.l += 2;
		var headerParts = parse_TypedPropertyValue(blob, VT_I4);
		return [headingString, headerParts];
	}
	
	/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */
	function parse_VtVecHeadingPairValue(blob) {
		var cElements = blob.read_shift(4);
		var out = [];
		for(var i = 0; i < cElements / 2; ++i) out.push(parse_VtHeadingPair(blob));
		return out;
	}
	
	/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */
	function parse_dictionary(blob,CodePage) {
		var cnt = blob.read_shift(4);
		var dict = ({});
		for(var j = 0; j != cnt; ++j) {
			var pid = blob.read_shift(4);
			var len = blob.read_shift(4);
			dict[pid] = blob.read_shift(len, (CodePage === 0x4B0 ?'utf16le':'utf8')).replace(chr0,'').replace(chr1,'!');
			if(CodePage === 0x4B0 && (len % 2)) blob.l += 2;
		}
		if(blob.l & 3) blob.l = (blob.l>>2+1)<<2;
		return dict;
	}
	
	/* [MS-OLEPS] 2.9 BLOB */
	function parse_BLOB(blob) {
		var size = blob.read_shift(4);
		var bytes = blob.slice(blob.l,blob.l+size);
		blob.l += size;
		if((size & 3) > 0) blob.l += (4 - (size & 3)) & 3;
		return bytes;
	}
	
	/* [MS-OLEPS] 2.11 ClipboardData */
	function parse_ClipboardData(blob) {
		// TODO
		var o = {};
		o.Size = blob.read_shift(4);
		//o.Format = blob.read_shift(4);
		blob.l += o.Size + 3 - (o.Size - 1) % 4;
		return o;
	}
	
	/* [MS-OLEPS] 2.15 TypedPropertyValue */
	function parse_TypedPropertyValue(blob, type, _opts) {
		var t = blob.read_shift(2), ret, opts = _opts||{};
		blob.l += 2;
		if(type !== VT_VARIANT)
		if(t !== type && VT_CUSTOM.indexOf(type)===-1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error('Expected type ' + type + ' saw ' + t);
		switch(type === VT_VARIANT ? t : type) {
			case 0x02 /*VT_I2*/: ret = blob.read_shift(2, 'i'); if(!opts.raw) blob.l += 2; return ret;
			case 0x03 /*VT_I4*/: ret = blob.read_shift(4, 'i'); return ret;
			case 0x0B /*VT_BOOL*/: return blob.read_shift(4) !== 0x0;
			case 0x13 /*VT_UI4*/: ret = blob.read_shift(4); return ret;
			case 0x1E /*VT_LPSTR*/: return parse_lpstr(blob, t, 4).replace(chr0,'');
			case 0x1F /*VT_LPWSTR*/: return parse_lpwstr(blob);
			case 0x40 /*VT_FILETIME*/: return parse_FILETIME(blob);
			case 0x41 /*VT_BLOB*/: return parse_BLOB(blob);
			case 0x47 /*VT_CF*/: return parse_ClipboardData(blob);
			case 0x50 /*VT_STRING*/: return parse_VtString(blob, t, !opts.raw).replace(chr0,'');
			case 0x51 /*VT_USTR*/: return parse_VtUnalignedString(blob, t/*, 4*/).replace(chr0,'');
			case 0x100C /*VT_VECTOR|VT_VARIANT*/: return parse_VtVecHeadingPairValue(blob);
			case 0x101E /*VT_VECTOR|VT_LPSTR*/:
			case 0x101F /*VT_VECTOR|VT_LPWSTR*/:
				return t == 0x101F ? parse_VtVecLpwstrValue(blob) : parse_VtVecUnalignedLpstrValue(blob);
			default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
		}
	}
	function write_TypedPropertyValue(type, value) {
		var o = new_buf(4), p = new_buf(4);
		o.write_shift(4, type == 0x50 ? 0x1F : type);
		switch(type) {
			case 0x03 /*VT_I4*/: p.write_shift(-4, value); break;
			case 0x05 /*VT_I4*/: p = new_buf(8); p.write_shift(8, value, 'f'); break;
			case 0x0B /*VT_BOOL*/: p.write_shift(4, value ? 0x01 : 0x00); break;
			case 0x40 /*VT_FILETIME*/:  p = write_FILETIME(value); break;
			case 0x1F /*VT_LPWSTR*/:
			case 0x50 /*VT_STRING*/:
	p = new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
				p.write_shift(4, value.length + 1);
				p.write_shift(0, value, "dbcs");
				while(p.l != p.length) p.write_shift(1, 0);
				break;
			default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
		}
		return bconcat([o, p]);
	}
	
	/* [MS-OLEPS] 2.20 PropertySet */
	function parse_PropertySet(blob, PIDSI) {
		var start_addr = blob.l;
		var size = blob.read_shift(4);
		var NumProps = blob.read_shift(4);
		var Props = [], i = 0;
		var CodePage = 0;
		var Dictionary = -1, DictObj = ({});
		for(i = 0; i != NumProps; ++i) {
			var PropID = blob.read_shift(4);
			var Offset = blob.read_shift(4);
			Props[i] = [PropID, Offset + start_addr];
		}
		Props.sort(function(x,y) { return x[1] - y[1]; });
		var PropH = {};
		for(i = 0; i != NumProps; ++i) {
			if(blob.l !== Props[i][1]) {
				var fail = true;
				if(i>0 && PIDSI) switch(PIDSI[Props[i-1][0]].t) {
					case 0x02 /*VT_I2*/: if(blob.l+2 === Props[i][1]) { blob.l+=2; fail = false; } break;
					case 0x50 /*VT_STRING*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
					case 0x100C /*VT_VECTOR|VT_VARIANT*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
				}
				if((!PIDSI||i==0) && blob.l <= Props[i][1]) { fail=false; blob.l = Props[i][1]; }
				if(fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
			}
			if(PIDSI) {
				var piddsi = PIDSI[Props[i][0]];
				PropH[piddsi.n] = parse_TypedPropertyValue(blob, piddsi.t, {raw:true});
				if(piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
				if(piddsi.n == "CodePage") switch(PropH[piddsi.n]) {
					case 0: PropH[piddsi.n] = 1252;
						/* falls through */
					case 874:
					case 932:
					case 936:
					case 949:
					case 950:
					case 1250:
					case 1251:
					case 1253:
					case 1254:
					case 1255:
					case 1256:
					case 1257:
					case 1258:
					case 10000:
					case 1200:
					case 1201:
					case 1252:
					case 65000: case -536:
					case 65001: case -535:
						set_cp(CodePage = (PropH[piddsi.n]>>>0) & 0xFFFF); break;
					default: throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
				}
			} else {
				if(Props[i][0] === 0x1) {
					CodePage = PropH.CodePage = (parse_TypedPropertyValue(blob, VT_I2));
					set_cp(CodePage);
					if(Dictionary !== -1) {
						var oldpos = blob.l;
						blob.l = Props[Dictionary][1];
						DictObj = parse_dictionary(blob,CodePage);
						blob.l = oldpos;
					}
				} else if(Props[i][0] === 0) {
					if(CodePage === 0) { Dictionary = i; blob.l = Props[i+1][1]; continue; }
					DictObj = parse_dictionary(blob,CodePage);
				} else {
					var name = DictObj[Props[i][0]];
					var val;
					/* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */
					switch(blob[blob.l]) {
						case 0x41 /*VT_BLOB*/: blob.l += 4; val = parse_BLOB(blob); break;
						case 0x1E /*VT_LPSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
						case 0x1F /*VT_LPWSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
						case 0x03 /*VT_I4*/: blob.l += 4; val = blob.read_shift(4, 'i'); break;
						case 0x13 /*VT_UI4*/: blob.l += 4; val = blob.read_shift(4); break;
						case 0x05 /*VT_R8*/: blob.l += 4; val = blob.read_shift(8, 'f'); break;
						case 0x0B /*VT_BOOL*/: blob.l += 4; val = parsebool(blob, 4); break;
						case 0x40 /*VT_FILETIME*/: blob.l += 4; val = parseDate(parse_FILETIME(blob)); break;
						default: throw new Error("unparsed value: " + blob[blob.l]);
					}
					PropH[name] = val;
				}
			}
		}
		blob.l = start_addr + size; /* step ahead to skip padding */
		return PropH;
	}
	var XLSPSSkip = [ "CodePage", "Thumbnail", "_PID_LINKBASE", "_PID_HLINKS", "SystemIdentifier", "FMTID" ]; //.concat(PseudoPropsPairs);
	function guess_property_type(val) {
		switch(typeof val) {
			case "boolean": return 0x0B;
			case "number": return ((val|0)==val) ? 0x03 : 0x05;
			case "string": return 0x1F;
			case "object": if(val instanceof Date) return 0x40; break;
		}
		return -1;
	}
	function write_PropertySet(entries, RE, PIDSI) {
		var hdr = new_buf(8), piao = [], prop = [];
		var sz = 8, i = 0;
	
		var pr = new_buf(8), pio = new_buf(8);
		pr.write_shift(4, 0x0002);
		pr.write_shift(4, 0x04B0);
		pio.write_shift(4, 0x0001);
		prop.push(pr); piao.push(pio);
		sz += 8 + pr.length;
	
		if(!RE) {
			pio = new_buf(8);
			pio.write_shift(4, 0);
			piao.unshift(pio);
	
			var bufs = [new_buf(4)];
			bufs[0].write_shift(4, entries.length);
			for(i = 0; i < entries.length; ++i) {
				var value = entries[i][0];
				pr = new_buf(4 + 4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
				pr.write_shift(4, i+2);
				pr.write_shift(4, value.length + 1);
				pr.write_shift(0, value, "dbcs");
				while(pr.l != pr.length) pr.write_shift(1, 0);
				bufs.push(pr);
			}
			pr = bconcat(bufs);
			prop.unshift(pr);
			sz += 8 + pr.length;
		}
	
		for(i = 0; i < entries.length; ++i) {
			if(RE && !RE[entries[i][0]]) continue;
			if(XLSPSSkip.indexOf(entries[i][0]) > -1 || PseudoPropsPairs.indexOf(entries[i][0]) > -1) continue;
			if(entries[i][1] == null) continue;
	
			var val = entries[i][1], idx = 0;
			if(RE) {
				idx = +RE[entries[i][0]];
				var pinfo = (PIDSI)[idx];
				if(pinfo.p == "version" && typeof val == "string") {
	var arr = val.split(".");
					val = ((+arr[0])<<16) + ((+arr[1])||0);
				}
				pr = write_TypedPropertyValue(pinfo.t, val);
			} else {
				var T = guess_property_type(val);
				if(T == -1) { T = 0x1F; val = String(val); }
				pr = write_TypedPropertyValue(T, val);
			}
			prop.push(pr);
	
			pio = new_buf(8);
			pio.write_shift(4, !RE ? 2+i : idx);
			piao.push(pio);
	
			sz += 8 + pr.length;
		}
	
		var w = 8 * (prop.length + 1);
		for(i = 0; i < prop.length; ++i) { piao[i].write_shift(4, w); w += prop[i].length; }
		hdr.write_shift(4, sz);
		hdr.write_shift(4, prop.length);
		return bconcat([hdr].concat(piao).concat(prop));
	}
	
	/* [MS-OLEPS] 2.21 PropertySetStream */
	function parse_PropertySetStream(file, PIDSI, clsid) {
		var blob = file.content;
		if(!blob) return ({});
		prep_blob(blob, 0);
	
		var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
		blob.chk('feff', 'Byte Order: ');
	
		/*var vers = */blob.read_shift(2); // TODO: check version
		var SystemIdentifier = blob.read_shift(4);
		var CLSID = blob.read_shift(16);
		if(CLSID !== CFB.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
		NumSets = blob.read_shift(4);
		if(NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
		FMTID0 = blob.read_shift(16); Offset0 = blob.read_shift(4);
	
		if(NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
		else if(NumSets === 2) { FMTID1 = blob.read_shift(16); Offset1 = blob.read_shift(4); }
		var PSet0 = parse_PropertySet(blob, PIDSI);
	
		var rval = ({ SystemIdentifier: SystemIdentifier });
		for(var y in PSet0) rval[y] = PSet0[y];
		//rval.blob = blob;
		rval.FMTID = FMTID0;
		//rval.PSet0 = PSet0;
		if(NumSets === 1) return rval;
		if(Offset1 - blob.l == 2) blob.l += 2;
		if(blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
		var PSet1;
		try { PSet1 = parse_PropertySet(blob, null); } catch(e) {/* empty */}
		for(y in PSet1) rval[y] = PSet1[y];
		rval.FMTID = [FMTID0, FMTID1]; // TODO: verify FMTID0/1
		return rval;
	}
	function write_PropertySetStream(entries, clsid, RE, PIDSI, entries2, clsid2) {
		var hdr = new_buf(entries2 ? 68 : 48);
		var bufs = [hdr];
		hdr.write_shift(2, 0xFFFE);
		hdr.write_shift(2, 0x0000); /* TODO: type 1 props */
		hdr.write_shift(4, 0x32363237);
		hdr.write_shift(16, CFB.utils.consts.HEADER_CLSID, "hex");
		hdr.write_shift(4, (entries2 ? 2 : 1));
		hdr.write_shift(16, clsid, "hex");
		hdr.write_shift(4, (entries2 ? 68 : 48));
		var ps0 = write_PropertySet(entries, RE, PIDSI);
		bufs.push(ps0);
	
		if(entries2) {
			var ps1 = write_PropertySet(entries2, null, null);
			hdr.write_shift(16, clsid2, "hex");
			hdr.write_shift(4, 68 + ps0.length);
			bufs.push(ps1);
		}
		return bconcat(bufs);
	}
	
	function parsenoop2(blob, length) { blob.read_shift(length); return null; }
	function writezeroes(n, o) { if(!o) o=new_buf(n); for(var j=0; j<n; ++j) o.write_shift(1, 0); return o; }
	
	function parslurp(blob, length, cb) {
		var arr = [], target = blob.l + length;
		while(blob.l < target) arr.push(cb(blob, target - blob.l));
		if(target !== blob.l) throw new Error("Slurp error");
		return arr;
	}
	
	function parsebool(blob, length) { return blob.read_shift(length) === 0x1; }
	function writebool(v, o) { if(!o) o=new_buf(2); o.write_shift(2, +!!v); return o; }
	
	function parseuint16(blob) { return blob.read_shift(2, 'u'); }
	function writeuint16(v, o) { if(!o) o=new_buf(2); o.write_shift(2, v); return o; }
	function parseuint16a(blob, length) { return parslurp(blob,length,parseuint16);}
	
	/* --- 2.5 Structures --- */
	
	/* [MS-XLS] 2.5.10 Bes (boolean or error) */
	function parse_Bes(blob) {
		var v = blob.read_shift(1), t = blob.read_shift(1);
		return t === 0x01 ? v : v === 0x01;
	}
	function write_Bes(v, t, o) {
		if(!o) o = new_buf(2);
		o.write_shift(1, ((t == 'e') ? +v : +!!v));
		o.write_shift(1, ((t == 'e') ? 1 : 0));
		return o;
	}
	
	/* [MS-XLS] 2.5.240 ShortXLUnicodeString */
	function parse_ShortXLUnicodeString(blob, length, opts) {
		var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
		var encoding = 'sbcs-cont';
		var cp = current_codepage;
		if(opts && opts.biff >= 8) current_codepage = 1200;
		if(!opts || opts.biff == 8 ) {
			var fHighByte = blob.read_shift(1);
			if(fHighByte) { encoding = 'dbcs-cont'; }
		} else if(opts.biff == 12) {
			encoding = 'wstr';
		}
		if(opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
		var o = cch ? blob.read_shift(cch, encoding) : "";
		current_codepage = cp;
		return o;
	}
	
	/* 2.5.293 XLUnicodeRichExtendedString */
	function parse_XLUnicodeRichExtendedString(blob) {
		var cp = current_codepage;
		current_codepage = 1200;
		var cch = blob.read_shift(2), flags = blob.read_shift(1);
		var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
		var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
		var cRun = 0, cbExtRst;
		var z = {};
		if(fRichSt) cRun = blob.read_shift(2);
		if(fExtSt) cbExtRst = blob.read_shift(4);
		var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
		var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
		if(fRichSt) blob.l += 4 * cRun; //TODO: parse this
		if(fExtSt) blob.l += cbExtRst; //TODO: parse this
		z.t = msg;
		if(!fRichSt) { z.raw = "<t>" + z.t + "</t>"; z.r = z.t; }
		current_codepage = cp;
		return z;
	}
	function write_XLUnicodeRichExtendedString(xlstr) {
		var str = (xlstr.t||""), nfmts = 1;
	
		var hdr = new_buf(3 + (nfmts > 1 ? 2 : 0));
		hdr.write_shift(2, str.length);
		hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
		if(nfmts > 1) hdr.write_shift(2, nfmts);
	
		var otext = new_buf(2 * str.length);
		otext.write_shift(2 * str.length, str, 'utf16le');
	
		var out = [hdr, otext];
	
		return bconcat(out);
	}
	
	/* 2.5.296 XLUnicodeStringNoCch */
	function parse_XLUnicodeStringNoCch(blob, cch, opts) {
		var retval;
		if(opts) {
			if(opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
			if(opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
		}
		var fHighByte = blob.read_shift(1);
		if(fHighByte===0) { retval = blob.read_shift(cch, 'sbcs-cont'); }
		else { retval = blob.read_shift(cch, 'dbcs-cont'); }
		return retval;
	}
	
	/* 2.5.294 XLUnicodeString */
	function parse_XLUnicodeString(blob, length, opts) {
		var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		if(cch === 0) { blob.l++; return ""; }
		return parse_XLUnicodeStringNoCch(blob, cch, opts);
	}
	/* BIFF5 override */
	function parse_XLUnicodeString2(blob, length, opts) {
		if(opts.biff > 5) return parse_XLUnicodeString(blob, length, opts);
		var cch = blob.read_shift(1);
		if(cch === 0) { blob.l++; return ""; }
		return blob.read_shift(cch, (opts.biff <= 4 || !blob.lens ) ? 'cpstr' : 'sbcs-cont');
	}
	/* TODO: BIFF5 and lower, codepage awareness */
	function write_XLUnicodeString(str, opts, o) {
		if(!o) o = new_buf(3 + 2 * str.length);
		o.write_shift(2, str.length);
		o.write_shift(1, 1);
		o.write_shift(31, str, 'utf16le');
		return o;
	}
	
	/* [MS-XLS] 2.5.61 ControlInfo */
	function parse_ControlInfo(blob) {
		var flags = blob.read_shift(1);
		blob.l++;
		var accel = blob.read_shift(2);
		blob.l += 2;
		return [flags, accel];
	}
	
	/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */
	function parse_URLMoniker(blob) {
		var len = blob.read_shift(4), start = blob.l;
		var extra = false;
		if(len > 24) {
			/* look ahead */
			blob.l += len - 24;
			if(blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
			blob.l = start;
		}
		var url = blob.read_shift((extra?len-24:len)>>1, 'utf16le').replace(chr0,"");
		if(extra) blob.l += 24;
		return url;
	}
	
	/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */
	function parse_FileMoniker(blob) {
		var cAnti = blob.read_shift(2);
		var preamble = ""; while(cAnti-- > 0) preamble += "../";
		var ansiPath = blob.read_shift(0, 'lpstr-ansi');
		blob.l += 2; //var endServer = blob.read_shift(2);
		if(blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
		var sz = blob.read_shift(4);
		if(sz === 0) return preamble + ansiPath.replace(/\\/g,"/");
		var bytes = blob.read_shift(4);
		if(blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
		var unicodePath = blob.read_shift(bytes>>1, 'utf16le').replace(chr0,"");
		return preamble + unicodePath;
	}
	
	/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */
	function parse_HyperlinkMoniker(blob, length) {
		var clsid = blob.read_shift(16); length -= 16;
		switch(clsid) {
			case "e0c9ea79f9bace118c8200aa004ba90b": return parse_URLMoniker(blob, length);
			case "0303000000000000c000000000000046": return parse_FileMoniker(blob, length);
			default: throw new Error("Unsupported Moniker " + clsid);
		}
	}
	
	/* [MS-OSHARED] 2.3.7.9 HyperlinkString */
	function parse_HyperlinkString(blob) {
		var len = blob.read_shift(4);
		var o = len > 0 ? blob.read_shift(len, 'utf16le').replace(chr0, "") : "";
		return o;
	}
	function write_HyperlinkString(str, o) {
		if(!o) o = new_buf(6 + str.length * 2);
		o.write_shift(4, 1 + str.length);
		for(var i = 0; i < str.length; ++i) o.write_shift(2, str.charCodeAt(i));
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */
	function parse_Hyperlink(blob, length) {
		var end = blob.l + length;
		var sVer = blob.read_shift(4);
		if(sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
		var flags = blob.read_shift(2);
		blob.l += 2;
		var displayName, targetFrameName, moniker, oleMoniker, Loc="", guid, fileTime;
		if(flags & 0x0010) displayName = parse_HyperlinkString(blob, end - blob.l);
		if(flags & 0x0080) targetFrameName = parse_HyperlinkString(blob, end - blob.l);
		if((flags & 0x0101) === 0x0101) moniker = parse_HyperlinkString(blob, end - blob.l);
		if((flags & 0x0101) === 0x0001) oleMoniker = parse_HyperlinkMoniker(blob, end - blob.l);
		if(flags & 0x0008) Loc = parse_HyperlinkString(blob, end - blob.l);
		if(flags & 0x0020) guid = blob.read_shift(16);
		if(flags & 0x0040) fileTime = parse_FILETIME(blob/*, 8*/);
		blob.l = end;
		var target = targetFrameName||moniker||oleMoniker||"";
		if(target && Loc) target+="#"+Loc;
		if(!target) target = "#" + Loc;
		if((flags & 0x0002) && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
		var out = ({Target:target});
		if(guid) out.guid = guid;
		if(fileTime) out.time = fileTime;
		if(displayName) out.Tooltip = displayName;
		return out;
	}
	function write_Hyperlink(hl) {
		var out = new_buf(512), i = 0;
		var Target = hl.Target;
		if(Target.slice(0,7) == "file://") Target = Target.slice(7);
		var hashidx = Target.indexOf("#");
		var F = hashidx > -1 ? 0x1f : 0x17;
		switch(Target.charAt(0)) { case "#": F=0x1c; break; case ".": F&=~2; break; }
		out.write_shift(4,2); out.write_shift(4, F);
		var data = [8,6815827,6619237,4849780,83]; for(i = 0; i < data.length; ++i) out.write_shift(4, data[i]);
		if(F == 0x1C) {
			Target = Target.slice(1);
			write_HyperlinkString(Target, out);
		} else if(F & 0x02) {
			data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
			for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
			var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
			out.write_shift(4, 2*(Pretarget.length + 1));
			for(i = 0; i < Pretarget.length; ++i) out.write_shift(2, Pretarget.charCodeAt(i));
			out.write_shift(2, 0);
			if(F & 0x08) write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx+1): "", out);
		} else {
			data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
			for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
			var P = 0;
			while(Target.slice(P*3,P*3+3)=="../"||Target.slice(P*3,P*3+3)=="..\\") ++P;
			out.write_shift(2, P);
			out.write_shift(4, Target.length - 3 * P + 1);
			for(i = 0; i < Target.length - 3 * P; ++i) out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
			out.write_shift(1, 0);
			out.write_shift(2, 0xFFFF);
			out.write_shift(2, 0xDEAD);
			for(i = 0; i < 6; ++i) out.write_shift(4, 0);
		}
		return out.slice(0, out.l);
	}
	
	/* 2.5.178 LongRGBA */
	function parse_LongRGBA(blob) { var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1); return [r,g,b,a]; }
	
	/* 2.5.177 LongRGB */
	function parse_LongRGB(blob, length) { var x = parse_LongRGBA(blob, length); x[3] = 0; return x; }
	
	
	/* [MS-XLS] 2.5.19 */
	function parse_XLSCell(blob) {
		var rw = blob.read_shift(2); // 0-indexed
		var col = blob.read_shift(2);
		var ixfe = blob.read_shift(2);
		return ({r:rw, c:col, ixfe:ixfe});
	}
	function write_XLSCell(R, C, ixfe, o) {
		if(!o) o = new_buf(6);
		o.write_shift(2, R);
		o.write_shift(2, C);
		o.write_shift(2, ixfe||0);
		return o;
	}
	
	/* [MS-XLS] 2.5.134 */
	function parse_frtHeader(blob) {
		var rt = blob.read_shift(2);
		var flags = blob.read_shift(2); // TODO: parse these flags
		blob.l += 8;
		return {type: rt, flags: flags};
	}
	
	
	
	function parse_OptXLUnicodeString(blob, length, opts) { return length === 0 ? "" : parse_XLUnicodeString2(blob, length, opts); }
	
	/* [MS-XLS] 2.5.344 */
	function parse_XTI(blob, length, opts) {
		var w = opts.biff > 8 ? 4 : 2;
		var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w,'i'), itabLast = blob.read_shift(w,'i');
		return [iSupBook, itabFirst, itabLast];
	}
	
	/* [MS-XLS] 2.5.218 */
	function parse_RkRec(blob) {
		var ixfe = blob.read_shift(2);
		var RK = parse_RkNumber(blob);
		return [ixfe, RK];
	}
	
	/* [MS-XLS] 2.5.1 */
	function parse_AddinUdf(blob, length, opts) {
		blob.l += 4; length -= 4;
		var l = blob.l + length;
		var udfName = parse_ShortXLUnicodeString(blob, length, opts);
		var cb = blob.read_shift(2);
		l -= blob.l;
		if(cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
		blob.l += cb;
		return udfName;
	}
	
	/* [MS-XLS] 2.5.209 TODO: Check sizes */
	function parse_Ref8U(blob) {
		var rwFirst = blob.read_shift(2);
		var rwLast = blob.read_shift(2);
		var colFirst = blob.read_shift(2);
		var colLast = blob.read_shift(2);
		return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
	}
	function write_Ref8U(r, o) {
		if(!o) o = new_buf(8);
		o.write_shift(2, r.s.r);
		o.write_shift(2, r.e.r);
		o.write_shift(2, r.s.c);
		o.write_shift(2, r.e.c);
		return o;
	}
	
	/* [MS-XLS] 2.5.211 */
	function parse_RefU(blob) {
		var rwFirst = blob.read_shift(2);
		var rwLast = blob.read_shift(2);
		var colFirst = blob.read_shift(1);
		var colLast = blob.read_shift(1);
		return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
	}
	
	/* [MS-XLS] 2.5.207 */
	var parse_Ref = parse_RefU;
	
	/* [MS-XLS] 2.5.143 */
	function parse_FtCmo(blob) {
		blob.l += 4;
		var ot = blob.read_shift(2);
		var id = blob.read_shift(2);
		var flags = blob.read_shift(2);
		blob.l+=12;
		return [id, ot, flags];
	}
	
	/* [MS-XLS] 2.5.149 */
	function parse_FtNts(blob) {
		var out = {};
		blob.l += 4;
		blob.l += 16; // GUID TODO
		out.fSharedNote = blob.read_shift(2);
		blob.l += 4;
		return out;
	}
	
	/* [MS-XLS] 2.5.142 */
	function parse_FtCf(blob) {
		var out = {};
		blob.l += 4;
		blob.cf = blob.read_shift(2);
		return out;
	}
	
	/* [MS-XLS] 2.5.140 - 2.5.154 and friends */
	function parse_FtSkip(blob) { blob.l += 2; blob.l += blob.read_shift(2); }
	var FtTab = {
	0x00: parse_FtSkip,      /* FtEnd */
	0x04: parse_FtSkip,      /* FtMacro */
	0x05: parse_FtSkip,      /* FtButton */
	0x06: parse_FtSkip,      /* FtGmo */
	0x07: parse_FtCf,        /* FtCf */
	0x08: parse_FtSkip,      /* FtPioGrbit */
	0x09: parse_FtSkip,      /* FtPictFmla */
	0x0A: parse_FtSkip,      /* FtCbls */
	0x0B: parse_FtSkip,      /* FtRbo */
	0x0C: parse_FtSkip,      /* FtSbs */
	0x0D: parse_FtNts,       /* FtNts */
	0x0E: parse_FtSkip,      /* FtSbsFmla */
	0x0F: parse_FtSkip,      /* FtGboData */
	0x10: parse_FtSkip,      /* FtEdoData */
	0x11: parse_FtSkip,      /* FtRboData */
	0x12: parse_FtSkip,      /* FtCblsData */
	0x13: parse_FtSkip,      /* FtLbsData */
	0x14: parse_FtSkip,      /* FtCblsFmla */
	0x15: parse_FtCmo
	};
	function parse_FtArray(blob, length) {
		var tgt = blob.l + length;
		var fts = [];
		while(blob.l < tgt) {
			var ft = blob.read_shift(2);
			blob.l-=2;
			try {
				fts.push(FtTab[ft](blob, tgt - blob.l));
			} catch(e) { blob.l = tgt; return fts; }
		}
		if(blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
		return fts;
	}
	
	/* --- 2.4 Records --- */
	
	/* [MS-XLS] 2.4.21 */
	function parse_BOF(blob, length) {
		var o = {BIFFVer:0, dt:0};
		o.BIFFVer = blob.read_shift(2); length -= 2;
		if(length >= 2) { o.dt = blob.read_shift(2); blob.l -= 2; }
		switch(o.BIFFVer) {
			case 0x0600: /* BIFF8 */
			case 0x0500: /* BIFF5 */
			case 0x0400: /* BIFF4 */
			case 0x0300: /* BIFF3 */
			case 0x0200: /* BIFF2 */
			case 0x0002: case 0x0007: /* BIFF2 */
				break;
			default: if(length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
		}
	
		blob.read_shift(length);
		return o;
	}
	function write_BOF(wb, t, o) {
		var h = 0x0600, w = 16;
		switch(o.bookType) {
			case 'biff8': break;
			case 'biff5': h = 0x0500; w = 8; break;
			case 'biff4': h = 0x0004; w = 6; break;
			case 'biff3': h = 0x0003; w = 6; break;
			case 'biff2': h = 0x0002; w = 4; break;
			case 'xla': break;
			default: throw new Error("unsupported BIFF version");
		}
		var out = new_buf(w);
		out.write_shift(2, h);
		out.write_shift(2, t);
		if(w > 4) out.write_shift(2, 0x7262);
		if(w > 6) out.write_shift(2, 0x07CD);
		if(w > 8) {
			out.write_shift(2, 0xC009);
			out.write_shift(2, 0x0001);
			out.write_shift(2, 0x0706);
			out.write_shift(2, 0x0000);
		}
		return out;
	}
	
	
	/* [MS-XLS] 2.4.146 */
	function parse_InterfaceHdr(blob, length) {
		if(length === 0) return 0x04b0;
		if((blob.read_shift(2))!==0x04b0){/* empty */}
		return 0x04b0;
	}
	
	
	/* [MS-XLS] 2.4.349 */
	function parse_WriteAccess(blob, length, opts) {
		if(opts.enc) { blob.l += length; return ""; }
		var l = blob.l;
		// TODO: make sure XLUnicodeString doesnt overrun
		var UserName = parse_XLUnicodeString2(blob, 0, opts);
		blob.read_shift(length + l - blob.l);
		return UserName;
	}
	function write_WriteAccess(s, opts) {
		var b8 = !opts || opts.biff == 8;
		var o = new_buf(b8 ? 112 : 54);
		o.write_shift(opts.biff == 8 ? 2 : 1, 7);
		if(b8) o.write_shift(1, 0);
		o.write_shift(4, 0x33336853);
		o.write_shift(4, (0x00534A74 | (b8 ? 0 : 0x20000000)));
		while(o.l < o.length) o.write_shift(1, (b8 ? 0 : 32));
		return o;
	}
	
	/* [MS-XLS] 2.4.351 */
	function parse_WsBool(blob, length, opts) {
		var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
		return { fDialog: flags & 0x10, fBelow: flags & 0x40, fRight: flags & 0x80 };
	}
	
	/* [MS-XLS] 2.4.28 */
	function parse_BoundSheet8(blob, length, opts) {
		var pos = blob.read_shift(4);
		var hidden = blob.read_shift(1) & 0x03;
		var dt = blob.read_shift(1);
		switch(dt) {
			case 0: dt = 'Worksheet'; break;
			case 1: dt = 'Macrosheet'; break;
			case 2: dt = 'Chartsheet'; break;
			case 6: dt = 'VBAModule'; break;
		}
		var name = parse_ShortXLUnicodeString(blob, 0, opts);
		if(name.length === 0) name = "Sheet1";
		return { pos:pos, hs:hidden, dt:dt, name:name };
	}
	function write_BoundSheet8(data, opts) {
		var w = (!opts || opts.biff >= 8 ? 2 : 1);
		var o = new_buf(8 + w * data.name.length);
		o.write_shift(4, data.pos);
		o.write_shift(1, data.hs || 0);
		o.write_shift(1, data.dt);
		o.write_shift(1, data.name.length);
		if(opts.biff >= 8) o.write_shift(1, 1);
		o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
		var out = o.slice(0, o.l);
		out.l = o.l; return out;
	}
	
	/* [MS-XLS] 2.4.265 TODO */
	function parse_SST(blob, length) {
		var end = blob.l + length;
		var cnt = blob.read_shift(4);
		var ucnt = blob.read_shift(4);
		var strs = ([]);
		for(var i = 0; i != ucnt && blob.l < end; ++i) {
			strs.push(parse_XLUnicodeRichExtendedString(blob));
		}
		strs.Count = cnt; strs.Unique = ucnt;
		return strs;
	}
	function write_SST(sst, opts) {
		var header = new_buf(8);
		header.write_shift(4, sst.Count);
		header.write_shift(4, sst.Unique);
		var strs = [];
		for(var j = 0; j < sst.length; ++j) strs[j] = write_XLUnicodeRichExtendedString(sst[j], opts);
		var o = bconcat([header].concat(strs));
	o.parts = [header.length].concat(strs.map(function(str) { return str.length; }));
		return o;
	}
	
	/* [MS-XLS] 2.4.107 */
	function parse_ExtSST(blob, length) {
		var extsst = {};
		extsst.dsst = blob.read_shift(2);
		blob.l += length-2;
		return extsst;
	}
	
	
	/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */
	function parse_Row(blob) {
		var z = ({});
		z.r = blob.read_shift(2);
		z.c = blob.read_shift(2);
		z.cnt = blob.read_shift(2) - z.c;
		var miyRw = blob.read_shift(2);
		blob.l += 4; // reserved(2), unused(2)
		var flags = blob.read_shift(1); // various flags
		blob.l += 3; // reserved(8), ixfe(12), flags(4)
		if(flags & 0x07) z.level = flags & 0x07;
		// collapsed: flags & 0x10
		if(flags & 0x20) z.hidden = true;
		if(flags & 0x40) z.hpt = miyRw / 20;
		return z;
	}
	
	
	/* [MS-XLS] 2.4.125 */
	function parse_ForceFullCalculation(blob) {
		var header = parse_frtHeader(blob);
		if(header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
		var fullcalc = blob.read_shift(4);
		return fullcalc !== 0x0;
	}
	
	
	
	
	
	/* [MS-XLS] 2.4.215 rt */
	function parse_RecalcId(blob) {
		blob.read_shift(2);
		return blob.read_shift(4);
	}
	
	/* [MS-XLS] 2.4.87 */
	function parse_DefaultRowHeight(blob, length, opts) {
		var f = 0;
		if(!(opts && opts.biff == 2)) {
			f = blob.read_shift(2);
		}
		var miyRw = blob.read_shift(2);
		if((opts && opts.biff == 2)) {
			f = 1 - (miyRw >> 15); miyRw &= 0x7fff;
		}
		var fl = {Unsynced:f&1,DyZero:(f&2)>>1,ExAsc:(f&4)>>2,ExDsc:(f&8)>>3};
		return [fl, miyRw];
	}
	
	/* [MS-XLS] 2.4.345 TODO */
	function parse_Window1(blob) {
		var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
		var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
		var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
		return { Pos: [xWn, yWn], Dim: [dxWn, dyWn], Flags: flags, CurTab: iTabCur,
			FirstTab: iTabFirst, Selected: ctabSel, TabRatio: wTabRatio };
	}
	function write_Window1() {
		var o = new_buf(18);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0x7260);
		o.write_shift(2, 0x44c0);
		o.write_shift(2, 0x38);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 1);
		o.write_shift(2, 0x01f4);
		return o;
	}
	/* [MS-XLS] 2.4.346 TODO */
	function parse_Window2(blob, length, opts) {
		if(opts && opts.biff >= 2 && opts.biff < 5) return {};
		var f = blob.read_shift(2);
		return { RTL: f & 0x40 };
	}
	function write_Window2(view) {
		var o = new_buf(18), f = 0x6b6;
		if(view && view.RTL) f |= 0x40;
		o.write_shift(2, f);
		o.write_shift(4, 0);
		o.write_shift(4, 64);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.189 TODO */
	function parse_Pane(/*blob, length, opts*/) {
	}
	
	/* [MS-XLS] 2.4.122 TODO */
	function parse_Font(blob, length, opts) {
		var o = {
			dyHeight: blob.read_shift(2),
			fl: blob.read_shift(2)
		};
		switch((opts && opts.biff) || 8) {
			case 2: break;
			case 3: case 4: blob.l += 2; break;
			default: blob.l += 10; break;
		}
		o.name = parse_ShortXLUnicodeString(blob, 0, opts);
		return o;
	}
	function write_Font(data, opts) {
		var name = data.name || "Arial";
		var b5 = (opts && (opts.biff == 5)), w = (b5 ? (15 + name.length) : (16 + 2 * name.length));
		var o = new_buf(w);
		o.write_shift(2, (data.sz || 12) * 20);
		o.write_shift(4, 0);
		o.write_shift(2, 400);
		o.write_shift(4, 0);
		o.write_shift(2, 0);
		o.write_shift(1, name.length);
		if(!b5) o.write_shift(1, 1);
		o.write_shift((b5 ? 1 : 2) * name.length, name, (b5 ? "sbcs" : "utf16le"));
		return o;
	}
	
	/* [MS-XLS] 2.4.149 */
	function parse_LabelSst(blob) {
		var cell = parse_XLSCell(blob);
		cell.isst = blob.read_shift(4);
		return cell;
	}
	function write_LabelSst(R, C, v, os ) {
		var o = new_buf(10);
		write_XLSCell(R, C, os, o);
		o.write_shift(4, v);
		return o;
	}
	
	/* [MS-XLS] 2.4.148 */
	function parse_Label(blob, length, opts) {
		if(opts.biffguess && opts.biff == 2) opts.biff = 5;
		var target = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2) blob.l++;
		var str = parse_XLUnicodeString(blob, target - blob.l, opts);
		cell.val = str;
		return cell;
	}
	function write_Label(R, C, v, os, opts) {
		var b8 = !opts || opts.biff == 8;
		var o = new_buf(6 + 2 + (+b8) + (1 + b8) * v.length);
		write_XLSCell(R, C, os, o);
		o.write_shift(2, v.length);
		if(b8) o.write_shift(1, 1);
		o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
		return o;
	}
	
	
	/* [MS-XLS] 2.4.126 Number Formats */
	function parse_Format(blob, length, opts) {
		var numFmtId = blob.read_shift(2);
		var fmtstr = parse_XLUnicodeString2(blob, 0, opts);
		return [numFmtId, fmtstr];
	}
	function write_Format(i, f, opts, o) {
		var b5 = (opts && (opts.biff == 5));
		if(!o) o = new_buf(b5 ? (3 + f.length) : (5 + 2 * f.length));
		o.write_shift(2, i);
		o.write_shift((b5 ? 1 : 2), f.length);
		if(!b5) o.write_shift(1, 1);
		o.write_shift((b5 ? 1 : 2) * f.length, f, (b5 ? 'sbcs' : 'utf16le'));
		var out = (o.length > o.l) ? o.slice(0, o.l) : o;
		if(out.l == null) out.l = out.length;
		return out;
	}
	var parse_BIFF2Format = parse_XLUnicodeString2;
	
	/* [MS-XLS] 2.4.90 */
	function parse_Dimensions(blob, length, opts) {
		var end = blob.l + length;
		var w = opts.biff == 8 || !opts.biff ? 4 : 2;
		var r = blob.read_shift(w), R = blob.read_shift(w);
		var c = blob.read_shift(2), C = blob.read_shift(2);
		blob.l = end;
		return {s: {r:r, c:c}, e: {r:R, c:C}};
	}
	function write_Dimensions(range, opts) {
		var w = opts.biff == 8 || !opts.biff ? 4 : 2;
		var o = new_buf(2*w + 6);
		o.write_shift(w, range.s.r);
		o.write_shift(w, range.e.r + 1);
		o.write_shift(2, range.s.c);
		o.write_shift(2, range.e.c + 1);
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.220 */
	function parse_RK(blob) {
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var rkrec = parse_RkRec(blob);
		return {r:rw, c:col, ixfe:rkrec[0], rknum:rkrec[1]};
	}
	
	/* [MS-XLS] 2.4.175 */
	function parse_MulRk(blob, length) {
		var target = blob.l + length - 2;
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var rkrecs = [];
		while(blob.l < target) rkrecs.push(parse_RkRec(blob));
		if(blob.l !== target) throw new Error("MulRK read error");
		var lastcol = blob.read_shift(2);
		if(rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
		return {r:rw, c:col, C:lastcol, rkrec:rkrecs};
	}
	/* [MS-XLS] 2.4.174 */
	function parse_MulBlank(blob, length) {
		var target = blob.l + length - 2;
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var ixfes = [];
		while(blob.l < target) ixfes.push(blob.read_shift(2));
		if(blob.l !== target) throw new Error("MulBlank read error");
		var lastcol = blob.read_shift(2);
		if(ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
		return {r:rw, c:col, C:lastcol, ixfe:ixfes};
	}
	
	/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */
	function parse_CellStyleXF(blob, length, style, opts) {
		var o = {};
		var a = blob.read_shift(4), b = blob.read_shift(4);
		var c = blob.read_shift(4), d = blob.read_shift(2);
		o.patternType = XLSFillPattern[c >> 26];
	
		if(!opts.cellStyles) return o;
		o.alc = a & 0x07;
		o.fWrap = (a >> 3) & 0x01;
		o.alcV = (a >> 4) & 0x07;
		o.fJustLast = (a >> 7) & 0x01;
		o.trot = (a >> 8) & 0xFF;
		o.cIndent = (a >> 16) & 0x0F;
		o.fShrinkToFit = (a >> 20) & 0x01;
		o.iReadOrder = (a >> 22) & 0x02;
		o.fAtrNum = (a >> 26) & 0x01;
		o.fAtrFnt = (a >> 27) & 0x01;
		o.fAtrAlc = (a >> 28) & 0x01;
		o.fAtrBdr = (a >> 29) & 0x01;
		o.fAtrPat = (a >> 30) & 0x01;
		o.fAtrProt = (a >> 31) & 0x01;
	
		o.dgLeft = b & 0x0F;
		o.dgRight = (b >> 4) & 0x0F;
		o.dgTop = (b >> 8) & 0x0F;
		o.dgBottom = (b >> 12) & 0x0F;
		o.icvLeft = (b >> 16) & 0x7F;
		o.icvRight = (b >> 23) & 0x7F;
		o.grbitDiag = (b >> 30) & 0x03;
	
		o.icvTop = c & 0x7F;
		o.icvBottom = (c >> 7) & 0x7F;
		o.icvDiag = (c >> 14) & 0x7F;
		o.dgDiag = (c >> 21) & 0x0F;
	
		o.icvFore = d & 0x7F;
		o.icvBack = (d >> 7) & 0x7F;
		o.fsxButton = (d >> 14) & 0x01;
		return o;
	}
	//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
	//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
	
	/* [MS-XLS] 2.4.353 TODO: actually do this right */
	function parse_XF(blob, length, opts) {
		var o = {};
		o.ifnt = blob.read_shift(2); o.numFmtId = blob.read_shift(2); o.flags = blob.read_shift(2);
		o.fStyle = (o.flags >> 2) & 0x01;
		length -= 6;
		o.data = parse_CellStyleXF(blob, length, o.fStyle, opts);
		return o;
	}
	function write_XF(data, ixfeP, opts, o) {
		var b5 = (opts && (opts.biff == 5));
		if(!o) o = new_buf(b5 ? 16 : 20);
		o.write_shift(2, 0);
		if(data.style) {
			o.write_shift(2, (data.numFmtId||0));
			o.write_shift(2, 0xFFF4);
		} else {
			o.write_shift(2, (data.numFmtId||0));
			o.write_shift(2, (ixfeP<<4));
		}
		var f = 0;
		if(data.numFmtId > 0 && b5) f |= 0x0400;
		o.write_shift(4, f);
		o.write_shift(4, 0);
		if(!b5) o.write_shift(4, 0);
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.134 */
	function parse_Guts(blob) {
		blob.l += 4;
		var out = [blob.read_shift(2), blob.read_shift(2)];
		if(out[0] !== 0) out[0]--;
		if(out[1] !== 0) out[1]--;
		if(out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
		return out;
	}
	function write_Guts(guts) {
		var o = new_buf(8);
		o.write_shift(4, 0);
		o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
		o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.24 */
	function parse_BoolErr(blob, length, opts) {
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2 || length == 9) ++blob.l;
		var val = parse_Bes(blob, 2);
		cell.val = val;
		cell.t = (val === true || val === false) ? 'b' : 'e';
		return cell;
	}
	function write_BoolErr(R, C, v, os, opts, t) {
		var o = new_buf(8);
		write_XLSCell(R, C, os, o);
		write_Bes(v, t, o);
		return o;
	}
	
	/* [MS-XLS] 2.4.180 Number */
	function parse_Number(blob, length, opts) {
		if(opts.biffguess && opts.biff == 2) opts.biff = 5;
		var cell = parse_XLSCell(blob, 6);
		var xnum = parse_Xnum(blob, 8);
		cell.val = xnum;
		return cell;
	}
	function write_Number(R, C, v, os) {
		var o = new_buf(14);
		write_XLSCell(R, C, os, o);
		write_Xnum(v, o);
		return o;
	}
	
	var parse_XLHeaderFooter = parse_OptXLUnicodeString; // TODO: parse 2.4.136
	
	/* [MS-XLS] 2.4.271 */
	function parse_SupBook(blob, length, opts) {
		var end = blob.l + length;
		var ctab = blob.read_shift(2);
		var cch = blob.read_shift(2);
		opts.sbcch = cch;
		if(cch == 0x0401 || cch == 0x3A01) return [cch, ctab];
		if(cch < 0x01 || cch >0xff) throw new Error("Unexpected SupBook type: "+cch);
		var virtPath = parse_XLUnicodeStringNoCch(blob, cch);
		/* TODO: 2.5.277 Virtual Path */
		var rgst = [];
		while(end > blob.l) rgst.push(parse_XLUnicodeString(blob));
		return [cch, ctab, virtPath, rgst];
	}
	
	/* [MS-XLS] 2.4.105 TODO */
	function parse_ExternName(blob, length, opts) {
		var flags = blob.read_shift(2);
		var body;
		var o = ({
			fBuiltIn: flags & 0x01,
			fWantAdvise: (flags >>> 1) & 0x01,
			fWantPict: (flags >>> 2) & 0x01,
			fOle: (flags >>> 3) & 0x01,
			fOleLink: (flags >>> 4) & 0x01,
			cf: (flags >>> 5) & 0x3FF,
			fIcon: flags >>> 15 & 0x01
		});
		if(opts.sbcch === 0x3A01) body = parse_AddinUdf(blob, length-2, opts);
		//else throw new Error("unsupported SupBook cch: " + opts.sbcch);
		o.body = body || blob.read_shift(length-2);
		if(typeof body === "string") o.Name = body;
		return o;
	}
	
	/* [MS-XLS] 2.4.150 TODO */
	var XLSLblBuiltIn = [
		"_xlnm.Consolidate_Area",
		"_xlnm.Auto_Open",
		"_xlnm.Auto_Close",
		"_xlnm.Extract",
		"_xlnm.Database",
		"_xlnm.Criteria",
		"_xlnm.Print_Area",
		"_xlnm.Print_Titles",
		"_xlnm.Recorder",
		"_xlnm.Data_Form",
		"_xlnm.Auto_Activate",
		"_xlnm.Auto_Deactivate",
		"_xlnm.Sheet_Title",
		"_xlnm._FilterDatabase"
	];
	function parse_Lbl(blob, length, opts) {
		var target = blob.l + length;
		var flags = blob.read_shift(2);
		var chKey = blob.read_shift(1);
		var cch = blob.read_shift(1);
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		var itab = 0;
		if(!opts || opts.biff >= 5) {
			if(opts.biff != 5) blob.l += 2;
			itab = blob.read_shift(2);
			if(opts.biff == 5) blob.l += 2;
			blob.l += 4;
		}
		var name = parse_XLUnicodeStringNoCch(blob, cch, opts);
		if(flags & 0x20) name = XLSLblBuiltIn[name.charCodeAt(0)];
		var npflen = target - blob.l; if(opts && opts.biff == 2) --npflen;
		/*jshint -W018 */
		var rgce = (target == blob.l || cce === 0 || !(npflen > 0)) ? [] : parse_NameParsedFormula(blob, npflen, opts, cce);
		/*jshint +W018 */
		return {
			chKey: chKey,
			Name: name,
			itab: itab,
			rgce: rgce
		};
	}
	
	/* [MS-XLS] 2.4.106 TODO: verify filename encoding */
	function parse_ExternSheet(blob, length, opts) {
		if(opts.biff < 8) return parse_BIFF5ExternSheet(blob, length, opts);
		var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
		while(len-- !== 0) o.push(parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
			// [iSupBook, itabFirst, itabLast];
		if(blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
		return o;
	}
	function parse_BIFF5ExternSheet(blob, length, opts) {
		if(blob[blob.l + 1] == 0x03) blob[blob.l]++;
		var o = parse_ShortXLUnicodeString(blob, length, opts);
		return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
	}
	
	/* [MS-XLS] 2.4.176 TODO: check older biff */
	function parse_NameCmt(blob, length, opts) {
		if(opts.biff < 8) { blob.l += length; return; }
		var cchName = blob.read_shift(2);
		var cchComment = blob.read_shift(2);
		var name = parse_XLUnicodeStringNoCch(blob, cchName, opts);
		var comment = parse_XLUnicodeStringNoCch(blob, cchComment, opts);
		return [name, comment];
	}
	
	/* [MS-XLS] 2.4.260 */
	function parse_ShrFmla(blob, length, opts) {
		var ref = parse_RefU(blob, 6);
		blob.l++;
		var cUse = blob.read_shift(1);
		length -= 8;
		return [parse_SharedParsedFormula(blob, length, opts), cUse, ref];
	}
	
	/* [MS-XLS] 2.4.4 TODO */
	function parse_Array(blob, length, opts) {
		var ref = parse_Ref(blob, 6);
		/* TODO: fAlwaysCalc */
		switch(opts.biff) {
			case 2: blob.l ++; length -= 7; break;
			case 3: case 4: blob.l += 2; length -= 8; break;
			default: blob.l += 6; length -= 12;
		}
		return [ref, parse_ArrayParsedFormula(blob, length, opts, ref)];
	}
	
	/* [MS-XLS] 2.4.173 */
	function parse_MTRSettings(blob) {
		var fMTREnabled = blob.read_shift(4) !== 0x00;
		var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
		var cUserThreadCount = blob.read_shift(4);
		return [fMTREnabled, fUserSetThreadCount, cUserThreadCount];
	}
	
	/* [MS-XLS] 2.5.186 TODO: BIFF5 */
	function parse_NoteSh(blob, length, opts) {
		if(opts.biff < 8) return;
		var row = blob.read_shift(2), col = blob.read_shift(2);
		var flags = blob.read_shift(2), idObj = blob.read_shift(2);
		var stAuthor = parse_XLUnicodeString2(blob, 0, opts);
		if(opts.biff < 8) blob.read_shift(1);
		return [{r:row,c:col}, stAuthor, idObj, flags];
	}
	
	/* [MS-XLS] 2.4.179 */
	function parse_Note(blob, length, opts) {
		/* TODO: Support revisions */
		return parse_NoteSh(blob, length, opts);
	}
	
	/* [MS-XLS] 2.4.168 */
	function parse_MergeCells(blob, length) {
		var merges = [];
		var cmcs = blob.read_shift(2);
		while (cmcs--) merges.push(parse_Ref8U(blob,length));
		return merges;
	}
	function write_MergeCells(merges) {
		var o = new_buf(2 + merges.length * 8);
		o.write_shift(2, merges.length);
		for(var i = 0; i < merges.length; ++i) write_Ref8U(merges[i], o);
		return o;
	}
	
	/* [MS-XLS] 2.4.181 TODO: parse all the things! */
	function parse_Obj(blob, length, opts) {
		if(opts && opts.biff < 8) return parse_BIFF5Obj(blob, length, opts);
		var cmo = parse_FtCmo(blob, 22); // id, ot, flags
		var fts = parse_FtArray(blob, length-22, cmo[1]);
		return { cmo: cmo, ft:fts };
	}
	/* from older spec */
	var parse_BIFF5OT = {
	0x08: function(blob, length) {
		var tgt = blob.l + length;
		blob.l += 10; // todo
		var cf = blob.read_shift(2);
		blob.l += 4;
		blob.l += 2; //var cbPictFmla = blob.read_shift(2);
		blob.l += 2;
		blob.l += 2; //var grbit = blob.read_shift(2);
		blob.l += 4;
		var cchName = blob.read_shift(1);
		blob.l += cchName; // TODO: stName
		blob.l = tgt; // TODO: fmla
		return { fmt:cf };
	}
	};
	
	function parse_BIFF5Obj(blob, length, opts) {
		blob.l += 4; //var cnt = blob.read_shift(4);
		var ot = blob.read_shift(2);
		var id = blob.read_shift(2);
		var grbit = blob.read_shift(2);
		blob.l += 2; //var colL = blob.read_shift(2);
		blob.l += 2; //var dxL = blob.read_shift(2);
		blob.l += 2; //var rwT = blob.read_shift(2);
		blob.l += 2; //var dyT = blob.read_shift(2);
		blob.l += 2; //var colR = blob.read_shift(2);
		blob.l += 2; //var dxR = blob.read_shift(2);
		blob.l += 2; //var rwB = blob.read_shift(2);
		blob.l += 2; //var dyB = blob.read_shift(2);
		blob.l += 2; //var cbMacro = blob.read_shift(2);
		blob.l += 6;
		length -= 36;
		var fts = [];
		fts.push((parse_BIFF5OT[ot]||parsenoop)(blob, length, opts));
		return { cmo: [id, ot, grbit], ft:fts };
	}
	
	/* [MS-XLS] 2.4.329 TODO: parse properly */
	function parse_TxO(blob, length, opts) {
		var s = blob.l;
		var texts = "";
	try {
		blob.l += 4;
		var ot = (opts.lastobj||{cmo:[0,0]}).cmo[1];
		var controlInfo; // eslint-disable-line no-unused-vars
		if([0,5,7,11,12,14].indexOf(ot) == -1) blob.l += 6;
		else controlInfo = parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
		var cchText = blob.read_shift(2);
		/*var cbRuns = */blob.read_shift(2);
		/*var ifntEmpty = */parseuint16(blob, 2);
		var len = blob.read_shift(2);
		blob.l += len;
		//var fmla = parse_ObjFmla(blob, s + length - blob.l);
	
		for(var i = 1; i < blob.lens.length-1; ++i) {
			if(blob.l-s != blob.lens[i]) throw new Error("TxO: bad continue record");
			var hdr = blob[blob.l];
			var t = parse_XLUnicodeStringNoCch(blob, blob.lens[i+1]-blob.lens[i]-1);
			texts += t;
			if(texts.length >= (hdr ? cchText : 2*cchText)) break;
		}
		if(texts.length !== cchText && texts.length !== cchText*2) {
			throw new Error("cchText: " + cchText + " != " + texts.length);
		}
	
		blob.l = s + length;
		/* [MS-XLS] 2.5.272 TxORuns */
	//	var rgTxoRuns = [];
	//	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
	//	var cchText2 = blob.read_shift(2);
	//	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
	//	blob.l += 6;
	//	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
		return { t: texts };
	} catch(e) { blob.l = s + length; return { t: texts }; }
	}
	
	/* [MS-XLS] 2.4.140 */
	function parse_HLink(blob, length) {
		var ref = parse_Ref8U(blob, 8);
		blob.l += 16; /* CLSID */
		var hlink = parse_Hyperlink(blob, length-24);
		return [ref, hlink];
	}
	function write_HLink(hl) {
		var O = new_buf(24);
		var ref = decode_cell(hl[0]);
		O.write_shift(2, ref.r); O.write_shift(2, ref.r);
		O.write_shift(2, ref.c); O.write_shift(2, ref.c);
		var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
		for(var i = 0; i < 16; ++i) O.write_shift(1, parseInt(clsid[i], 16));
		return bconcat([O, write_Hyperlink(hl[1])]);
	}
	
	
	/* [MS-XLS] 2.4.141 */
	function parse_HLinkTooltip(blob, length) {
		blob.read_shift(2);
		var ref = parse_Ref8U(blob, 8);
		var wzTooltip = blob.read_shift((length-10)/2, 'dbcs-cont');
		wzTooltip = wzTooltip.replace(chr0,"");
		return [ref, wzTooltip];
	}
	function write_HLinkTooltip(hl) {
		var TT = hl[1].Tooltip;
		var O = new_buf(10 + 2 * (TT.length + 1));
		O.write_shift(2, 0x0800);
		var ref = decode_cell(hl[0]);
		O.write_shift(2, ref.r); O.write_shift(2, ref.r);
		O.write_shift(2, ref.c); O.write_shift(2, ref.c);
		for(var i = 0; i < TT.length; ++i) O.write_shift(2, TT.charCodeAt(i));
		O.write_shift(2, 0);
		return O;
	}
	
	/* [MS-XLS] 2.4.63 */
	function parse_Country(blob) {
		var o = [0,0], d;
		d = blob.read_shift(2); o[0] = CountryEnum[d] || d;
		d = blob.read_shift(2); o[1] = CountryEnum[d] || d;
		return o;
	}
	function write_Country(o) {
		if(!o) o = new_buf(4);
		o.write_shift(2, 0x01);
		o.write_shift(2, 0x01);
		return o;
	}
	
	/* [MS-XLS] 2.4.50 ClrtClient */
	function parse_ClrtClient(blob) {
		var ccv = blob.read_shift(2);
		var o = [];
		while(ccv-->0) o.push(parse_LongRGB(blob, 8));
		return o;
	}
	
	/* [MS-XLS] 2.4.188 */
	function parse_Palette(blob) {
		var ccv = blob.read_shift(2);
		var o = [];
		while(ccv-->0) o.push(parse_LongRGB(blob, 8));
		return o;
	}
	
	/* [MS-XLS] 2.4.354 */
	function parse_XFCRC(blob) {
		blob.l += 2;
		var o = {cxfs:0, crc:0};
		o.cxfs = blob.read_shift(2);
		o.crc = blob.read_shift(4);
		return o;
	}
	
	/* [MS-XLS] 2.4.53 TODO: parse flags */
	/* [MS-XLSB] 2.4.323 TODO: parse flags */
	function parse_ColInfo(blob, length, opts) {
		if(!opts.cellStyles) return parsenoop(blob, length);
		var w = opts && opts.biff >= 12 ? 4 : 2;
		var colFirst = blob.read_shift(w);
		var colLast = blob.read_shift(w);
		var coldx = blob.read_shift(w);
		var ixfe = blob.read_shift(w);
		var flags = blob.read_shift(2);
		if(w == 2) blob.l += 2;
		var o = ({s:colFirst, e:colLast, w:coldx, ixfe:ixfe, flags:flags});
		if(opts.biff >= 5 || !opts.biff) o.level = (flags >> 8) & 0x7;
		return o;
	}
	function write_ColInfo(col, idx) {
		var o = new_buf(12);
		o.write_shift(2, idx);
		o.write_shift(2, idx);
		o.write_shift(2, col.width * 256);
		o.write_shift(2, 0);
		var f = 0;
		if(col.hidden) f |= 1;
		o.write_shift(1, f);
		f = col.level || 0;
		o.write_shift(1, f);
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.257 */
	function parse_Setup(blob, length) {
		var o = {};
		if(length < 32) return o;
		blob.l += 16;
		o.header = parse_Xnum(blob, 8);
		o.footer = parse_Xnum(blob, 8);
		blob.l += 2;
		return o;
	}
	
	/* [MS-XLS] 2.4.261 */
	function parse_ShtProps(blob, length, opts) {
		var def = {area:false};
		if(opts.biff != 5) { blob.l += length; return def; }
		var d = blob.read_shift(1); blob.l += 3;
		if((d & 0x10)) def.area = true;
		return def;
	}
	
	/* [MS-XLS] 2.4.241 */
	function write_RRTabId(n) {
		var out = new_buf(2 * n);
		for(var i = 0; i < n; ++i) out.write_shift(2, i+1);
		return out;
	}
	
	var parse_Blank = parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */
	var parse_Scl = parseuint16a; /* [MS-XLS] 2.4.247 num, den */
	var parse_String = parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */
	
	/* --- Specific to versions before BIFF8 --- */
	function parse_ImData(blob) {
		var cf = blob.read_shift(2);
		var env = blob.read_shift(2);
		var lcb = blob.read_shift(4);
		var o = {fmt:cf, env:env, len:lcb, data:blob.slice(blob.l,blob.l+lcb)};
		blob.l += lcb;
		return o;
	}
	
	/* BIFF2_??? where ??? is the name from [XLS] */
	function parse_BIFF2STR(blob, length, opts) {
		if(opts.biffguess && opts.biff == 5) opts.biff = 2;
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var str = parse_XLUnicodeString2(blob, length-7, opts);
		cell.t = 'str';
		cell.val = str;
		return cell;
	}
	
	function parse_BIFF2NUM(blob) {
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var num = parse_Xnum(blob, 8);
		cell.t = 'n';
		cell.val = num;
		return cell;
	}
	function write_BIFF2NUM(r, c, val) {
		var out = new_buf(15);
		write_BIFF2Cell(out, r, c);
		out.write_shift(8, val, 'f');
		return out;
	}
	
	function parse_BIFF2INT(blob) {
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var num = blob.read_shift(2);
		cell.t = 'n';
		cell.val = num;
		return cell;
	}
	function write_BIFF2INT(r, c, val) {
		var out = new_buf(9);
		write_BIFF2Cell(out, r, c);
		out.write_shift(2, val);
		return out;
	}
	
	function parse_BIFF2STRING(blob) {
		var cch = blob.read_shift(1);
		if(cch === 0) { blob.l++; return ""; }
		return blob.read_shift(cch, 'sbcs-cont');
	}
	
	/* TODO: convert to BIFF8 font struct */
	function parse_BIFF2FONTXTRA(blob, length) {
		blob.l += 6; // unknown
		blob.l += 2; // font weight "bls"
		blob.l += 1; // charset
		blob.l += 3; // unknown
		blob.l += 1; // font family
		blob.l += length - 13;
	}
	
	/* TODO: parse rich text runs */
	function parse_RString(blob, length, opts) {
		var end = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		var cch = blob.read_shift(2);
		var str = parse_XLUnicodeStringNoCch(blob, cch, opts);
		blob.l = end;
		cell.t = 'str';
		cell.val = str;
		return cell;
	}
	/* from js-harb (C) 2014-present  SheetJS */
	var DBF_SUPPORTED_VERSIONS = [0x02, 0x03, 0x30, 0x31, 0x83, 0x8B, 0x8C, 0xF5];
	var DBF = (function() {
	var dbf_codepage_map = {
		/* Code Pages Supported by Visual FoxPro */
	0x01:   437,           0x02:   850,
	0x03:  1252,           0x04: 10000,
	0x64:   852,           0x65:   866,
	0x66:   865,           0x67:   861,
	0x68:   895,           0x69:   620,
	0x6A:   737,           0x6B:   857,
	0x78:   950,           0x79:   949,
	0x7A:   936,           0x7B:   932,
	0x7C:   874,           0x7D:  1255,
	0x7E:  1256,           0x96: 10007,
	0x97: 10029,           0x98: 10006,
	0xC8:  1250,           0xC9:  1251,
	0xCA:  1254,           0xCB:  1253,
	
		/* shapefile DBF extension */
	0x00: 20127,           0x08:   865,
	0x09:   437,           0x0A:   850,
	0x0B:   437,           0x0D:   437,
	0x0E:   850,           0x0F:   437,
	0x10:   850,           0x11:   437,
	0x12:   850,           0x13:   932,
	0x14:   850,           0x15:   437,
	0x16:   850,           0x17:   865,
	0x18:   437,           0x19:   437,
	0x1A:   850,           0x1B:   437,
	0x1C:   863,           0x1D:   850,
	0x1F:   852,           0x22:   852,
	0x23:   852,           0x24:   860,
	0x25:   850,           0x26:   866,
	0x37:   850,           0x40:   852,
	0x4D:   936,           0x4E:   949,
	0x4F:   950,           0x50:   874,
	0x57:  1252,           0x58:  1252,
	0x59:  1252,           0x6C:   863,
	0x86:   737,           0x87:   852,
	0x88:   857,           0xCC:  1257,
	
	0xFF: 16969
	};
	var dbf_reverse_map = evert({
	0x01:   437,           0x02:   850,
	0x03:  1252,           0x04: 10000,
	0x64:   852,           0x65:   866,
	0x66:   865,           0x67:   861,
	0x68:   895,           0x69:   620,
	0x6A:   737,           0x6B:   857,
	0x78:   950,           0x79:   949,
	0x7A:   936,           0x7B:   932,
	0x7C:   874,           0x7D:  1255,
	0x7E:  1256,           0x96: 10007,
	0x97: 10029,           0x98: 10006,
	0xC8:  1250,           0xC9:  1251,
	0xCA:  1254,           0xCB:  1253,
	0x00: 20127
	});
	/* TODO: find an actual specification */
	function dbf_to_aoa(buf, opts) {
		var out = [];
		var d = (new_raw_buf(1));
		switch(opts.type) {
			case 'base64': d = s2a(Base64_decode(buf)); break;
			case 'binary': d = s2a(buf); break;
			case 'buffer':
			case 'array': d = buf; break;
		}
		prep_blob(d, 0);
	
		/* header */
		var ft = d.read_shift(1);
		var memo = !!(ft & 0x88);
		var vfp = false, l7 = false;
		switch(ft) {
			case 0x02: break; // dBASE II
			case 0x03: break; // dBASE III
			case 0x30: vfp = true; memo = true; break; // VFP
			case 0x31: vfp = true; memo = true; break; // VFP with autoincrement
			// 0x43 dBASE IV SQL table files
			// 0x63 dBASE IV SQL system files
			case 0x83: break; // dBASE III with memo
			case 0x8B: break; // dBASE IV with memo
			case 0x8C: l7 = true; break; // dBASE Level 7 with memo
			// case 0xCB dBASE IV SQL table files with memo
			case 0xF5: break; // FoxPro 2.x with memo
			// case 0xFB FoxBASE
			default: throw new Error("DBF Unsupported Version: " + ft.toString(16));
		}
	
		var nrow = 0, fpos = 0x0209;
		if(ft == 0x02) nrow = d.read_shift(2);
		d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
		if(ft != 0x02) nrow = d.read_shift(4);
		if(nrow > 1048576) nrow = 1e6;
	
		if(ft != 0x02) fpos = d.read_shift(2); // header length
		var rlen = d.read_shift(2); // record length
	
		var /*flags = 0,*/ current_cp = opts.codepage || 1252;
		if(ft != 0x02) { // 20 reserved bytes
			d.l+=16;
			/*flags = */d.read_shift(1);
			//if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
	
			/* codepage present in FoxPro and dBASE Level 7 */
			if(d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
			d.l+=1;
	
			d.l+=2;
		}
		if(l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved
	
	var fields = [], field = ({});
		var hend = Math.min(d.length, (ft == 0x02 ? 0x209 : (fpos - 10 - (vfp ? 264 : 0))));
		var ww = l7 ? 32 : 11;
		while(d.l < hend && d[d.l] != 0x0d) {
			field = ({});
			field.name = $cptable.utils.decode(current_cp, d.slice(d.l, d.l+ww)).replace(/[\u0000\r\n].*$/g,"");
			d.l += ww;
			field.type = String.fromCharCode(d.read_shift(1));
			if(ft != 0x02 && !l7) field.offset = d.read_shift(4);
			field.len = d.read_shift(1);
			if(ft == 0x02) field.offset = d.read_shift(2);
			field.dec = d.read_shift(1);
			if(field.name.length) fields.push(field);
			if(ft != 0x02) d.l += l7 ? 13 : 14;
			switch(field.type) {
				case 'B': // Double (VFP) / Binary (dBASE L7)
					if((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
					break;
				case 'G': // General (FoxPro and dBASE L7)
				case 'P': // Picture (FoxPro and dBASE L7)
					if(opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
					break;
				case '+': // Autoincrement (dBASE L7 only)
				case '0': // _NullFlags (VFP only)
				case '@': // Timestamp (dBASE L7 only)
				case 'C': // Character (dBASE II)
				case 'D': // Date (dBASE III)
				case 'F': // Float (dBASE IV)
				case 'I': // Long (VFP and dBASE L7)
				case 'L': // Logical (dBASE II)
				case 'M': // Memo (dBASE III)
				case 'N': // Number (dBASE II)
				case 'O': // Double (dBASE L7 only)
				case 'T': // Datetime (VFP only)
				case 'Y': // Currency (VFP only)
					break;
				default: throw new Error('Unknown Field Type: ' + field.type);
			}
		}
	
		if(d[d.l] !== 0x0D) d.l = fpos-1;
		if(d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
		d.l = fpos;
	
		/* data */
		var R = 0, C = 0;
		out[0] = [];
		for(C = 0; C != fields.length; ++C) out[0][C] = fields[C].name;
		while(nrow-- > 0) {
			if(d[d.l] === 0x2A) {
				// TODO: record marked as deleted -- create a hidden row?
				d.l+=rlen;
				continue;
			}
			++d.l;
			out[++R] = []; C = 0;
			for(C = 0; C != fields.length; ++C) {
				var dd = d.slice(d.l, d.l+fields[C].len); d.l+=fields[C].len;
				prep_blob(dd, 0);
				var s = $cptable.utils.decode(current_cp, dd);
				switch(fields[C].type) {
					case 'C':
						// NOTE: it is conventional to write '  /  /  ' for empty dates
						if(s.trim().length) out[R][C] = s.replace(/\s+$/,"");
						break;
					case 'D':
						if(s.length === 8) out[R][C] = new Date(+s.slice(0,4), +s.slice(4,6)-1, +s.slice(6,8));
						else out[R][C] = s;
						break;
					case 'F': out[R][C] = parseFloat(s.trim()); break;
					case '+': case 'I': out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i'); break;
					case 'L': switch(s.trim().toUpperCase()) {
						case 'Y': case 'T': out[R][C] = true; break;
						case 'N': case 'F': out[R][C] = false; break;
						case '': case '?': break;
						default: throw new Error("DBF Unrecognized L:|" + s + "|");
						} break;
					case 'M': /* TODO: handle memo files */
						if(!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
						out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10): dd.read_shift(4));
						break;
					case 'N':
						s = s.replace(/\u0000/g,"").trim();
						// NOTE: dBASE II interprets "  .  " as 0
						if(s && s != ".") out[R][C] = +s || 0; break;
					case '@':
						// NOTE: dBASE specs appear to be incorrect
						out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400);
						break;
					case 'T': out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4)); break;
					case 'Y': out[R][C] = dd.read_shift(4,'i')/1e4 + (dd.read_shift(4, 'i')/1e4)*Math.pow(2,32); break;
					case 'O': out[R][C] = -dd.read_shift(-8, 'f'); break;
					case 'B': if(vfp && fields[C].len == 8) { out[R][C] = dd.read_shift(8,'f'); break; }
						/* falls through */
					case 'G': case 'P': dd.l += fields[C].len; break;
					case '0':
						if(fields[C].name === '_NullFlags') break;
						/* falls through */
					default: throw new Error("DBF Unsupported data type " + fields[C].type);
				}
			}
		}
		if(ft != 0x02) if(d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l-1) + " of " + d.length + " " + d[d.l-1].toString(16));
		if(opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
		opts.DBF = fields;
		return out;
	}
	
	function dbf_to_sheet(buf, opts) {
		var o = opts || {};
		if(!o.dateNF) o.dateNF = "yyyymmdd";
		var ws = aoa_to_sheet(dbf_to_aoa(buf, o), o);
		ws["!cols"] = o.DBF.map(function(field) { return {
			wch: field.len,
			DBF: field
		};});
		delete o.DBF;
		return ws;
	}
	
	function dbf_to_workbook(buf, opts) {
		try { return sheet_to_workbook(dbf_to_sheet(buf, opts), opts); }
		catch(e) { if(opts && opts.WTF) throw e; }
		return ({SheetNames:[],Sheets:{}});
	}
	
	var _RLEN = { 'B': 8, 'C': 250, 'L': 1, 'D': 8, '?': 0, '': 0 };
	function sheet_to_dbf(ws, opts) {
		var o = opts || {};
		if(+o.codepage >= 0) set_cp(+o.codepage);
		if(o.type == "string") throw new Error("Cannot write DBF to JS string");
		var ba = buf_array();
		var aoa = sheet_to_json(ws, {header:1, raw:true, cellDates:true});
		var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
		var i = 0, j = 0, hcnt = 0, rlen = 1;
		for(i = 0; i < headers.length; ++i) {
			if(((cols[i]||{}).DBF||{}).name) { headers[i] = cols[i].DBF.name; ++hcnt; continue; }
			if(headers[i] == null) continue;
			++hcnt;
			if(typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
			if(typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + (typeof headers[i]) + "|");
			if(headers.indexOf(headers[i]) !== i) for(j=0; j<1024;++j)
				if(headers.indexOf(headers[i] + "_" + j) == -1) { headers[i] += "_" + j; break; }
		}
		var range = safe_decode_range(ws['!ref']);
		var coltypes = [];
		var colwidths = [];
		var coldecimals = [];
		for(i = 0; i <= range.e.c - range.s.c; ++i) {
			var guess = '', _guess = '', maxlen = 0;
			var col = [];
			for(j=0; j < data.length; ++j) {
				if(data[j][i] != null) col.push(data[j][i]);
			}
			if(col.length == 0 || headers[i] == null) { coltypes[i] = '?'; continue; }
			for(j = 0; j < col.length; ++j) {
				switch(typeof col[j]) {
					/* TODO: check if L2 compat is desired */
					case 'number': _guess = 'B'; break;
					case 'string': _guess = 'C'; break;
					case 'boolean': _guess = 'L'; break;
					case 'object': _guess = col[j] instanceof Date ? 'D' : 'C'; break;
					default: _guess = 'C';
				}
				maxlen = Math.max(maxlen, String(col[j]).length);
				guess = guess && guess != _guess ? 'C' : _guess;
				//if(guess == 'C') break;
			}
			if(maxlen > 250) maxlen = 250;
			_guess = ((cols[i]||{}).DBF||{}).type;
			/* TODO: more fine grained control over DBF type resolution */
			if(_guess == 'C') {
				if(cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
			}
			if(guess == 'B' && _guess == 'N') {
				guess = 'N';
				coldecimals[i] = cols[i].DBF.dec;
				maxlen = cols[i].DBF.len;
			}
			colwidths[i] = guess == 'C' || _guess == 'N' ? maxlen : (_RLEN[guess] || 0);
			rlen += colwidths[i];
			coltypes[i] = guess;
		}
	
		var h = ba.next(32);
		h.write_shift(4, 0x13021130);
		h.write_shift(4, data.length);
		h.write_shift(2, 296 + 32 * hcnt);
		h.write_shift(2, rlen);
		for(i=0; i < 4; ++i) h.write_shift(4, 0);
		h.write_shift(4, 0x00000000 | ((+dbf_reverse_map[current_ansi] || 0x03)<<8));
	
		for(i = 0, j = 0; i < headers.length; ++i) {
			if(headers[i] == null) continue;
			var hf = ba.next(32);
			var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
			hf.write_shift(1, _f, "sbcs");
			hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
			hf.write_shift(4, j);
			hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
			hf.write_shift(1, coldecimals[i] || 0);
			hf.write_shift(1, 0x02);
			hf.write_shift(4, 0);
			hf.write_shift(1, 0);
			hf.write_shift(4, 0);
			hf.write_shift(4, 0);
			j += (colwidths[i] || _RLEN[coltypes[i]] || 0);
		}
	
		var hb = ba.next(264);
		hb.write_shift(4, 0x0000000D);
		for(i=0; i < 65;++i) hb.write_shift(4, 0x00000000);
		for(i=0; i < data.length; ++i) {
			var rout = ba.next(rlen);
			rout.write_shift(1, 0);
			for(j=0; j<headers.length; ++j) {
				if(headers[j] == null) continue;
				switch(coltypes[j]) {
					case 'L': rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46); break;
					case 'B': rout.write_shift(8, data[i][j]||0, 'f'); break;
					case 'N':
						var _n = "0";
						if(typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j]||0);
						for(hcnt=0; hcnt < colwidths[j]-_n.length; ++hcnt) rout.write_shift(1, 0x20);
						rout.write_shift(1, _n, "sbcs");
						break;
					case 'D':
						if(!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
						else {
							rout.write_shift(4, ("0000"+data[i][j].getFullYear()).slice(-4), "sbcs");
							rout.write_shift(2, ("00"+(data[i][j].getMonth()+1)).slice(-2), "sbcs");
							rout.write_shift(2, ("00"+data[i][j].getDate()).slice(-2), "sbcs");
						} break;
					case 'C':
						var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
						rout.write_shift(1, _s, "sbcs");
						for(hcnt=0; hcnt < colwidths[j]-_s.length; ++hcnt) rout.write_shift(1, 0x20); break;
				}
			}
			// data
		}
		ba.next(1).write_shift(1, 0x1A);
		return ba.end();
	}
		return {
			to_workbook: dbf_to_workbook,
			to_sheet: dbf_to_sheet,
			from_sheet: sheet_to_dbf
		};
	})();
	
	var SYLK = (function() {
		/* TODO: stress test sequences */
		var sylk_escapes = ({
			AA:'À', BA:'Á', CA:'Â', DA:195, HA:'Ä', JA:197,
			AE:'È', BE:'É', CE:'Ê',         HE:'Ë',
			AI:'Ì', BI:'Í', CI:'Î',         HI:'Ï',
			AO:'Ò', BO:'Ó', CO:'Ô', DO:213, HO:'Ö',
			AU:'Ù', BU:'Ú', CU:'Û',         HU:'Ü',
			Aa:'à', Ba:'á', Ca:'â', Da:227, Ha:'ä', Ja:229,
			Ae:'è', Be:'é', Ce:'ê',         He:'ë',
			Ai:'ì', Bi:'í', Ci:'î',         Hi:'ï',
			Ao:'ò', Bo:'ó', Co:'ô', Do:245, Ho:'ö',
			Au:'ù', Bu:'ú', Cu:'û',         Hu:'ü',
			KC:'Ç', Kc:'ç', q:'æ',  z:'œ',  a:'Æ',  j:'Œ',
			DN:209, Dn:241, Hy:255,
			S:169,  c:170,  R:174,  "B ":180,
	0:176,    1:177,  2:178,
	3:179,    5:181,  6:182,
	7:183,    Q:185,  k:186,  b:208,  i:216,  l:222,  s:240,  y:248,
			"!":161, '"':162, "#":163, "(":164, "%":165, "'":167, "H ":168,
			"+":171, ";":187, "<":188, "=":189, ">":190, "?":191, "{":223
		});
		var sylk_char_regex = new RegExp("\u001BN(" + keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g,"\\$1") + "|\\|)", "gm");
		var sylk_char_fn = function(_, $1){ var o = sylk_escapes[$1]; return typeof o == "number" ? _getansi(o) : o; };
		var decode_sylk_char = function($$, $1, $2) { var newcc = (($1.charCodeAt(0) - 0x20)<<4) | ($2.charCodeAt(0) - 0x30); return newcc == 59 ? $$ : _getansi(newcc); };
		sylk_escapes["|"] = 254;
		/* TODO: find an actual specification */
		function sylk_to_aoa(d, opts) {
			switch(opts.type) {
				case 'base64': return sylk_to_aoa_str(Base64_decode(d), opts);
				case 'binary': return sylk_to_aoa_str(d, opts);
				case 'buffer': return sylk_to_aoa_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
				case 'array': return sylk_to_aoa_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
		function sylk_to_aoa_str(str, opts) {
			var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr = [];
			var formats = [];
			var next_cell_format = null;
			var sht = {}, rowinfo = [], colinfo = [], cw = [];
			var Mval = 0, j;
			if(+opts.codepage >= 0) set_cp(+opts.codepage);
			for (; ri !== records.length; ++ri) {
				Mval = 0;
				var rstr=records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
				var record=rstr.replace(/;;/g, "\u0000").split(";").map(function(x) { return x.replace(/\u0000/g, ";"); });
				var RT=record[0], val;
				if(rstr.length > 0) switch(RT) {
				case 'ID': break; /* header */
				case 'E': break; /* EOF */
				case 'B': break; /* dimensions */
				case 'O': break; /* options? */
				case 'W': break; /* window? */
				case 'P':
					if(record[1].charAt(0) == 'P')
						formats.push(rstr.slice(3).replace(/;;/g, ";"));
					break;
				case 'C':
				var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1;
				for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
					case 'A': break; // TODO: comment
					case 'X': C = parseInt(record[rj].slice(1))-1; C_seen_X = true; break;
					case 'Y':
						R = parseInt(record[rj].slice(1))-1; if(!C_seen_X) C = 0;
						for(j = arr.length; j <= R; ++j) arr[j] = [];
						break;
					case 'K':
						val = record[rj].slice(1);
						if(val.charAt(0) === '"') val = val.slice(1,val.length - 1);
						else if(val === 'TRUE') val = true;
						else if(val === 'FALSE') val = false;
						else if(!isNaN(fuzzynum(val))) {
							val = fuzzynum(val);
							if(next_cell_format !== null && fmt_is_date(next_cell_format)) val = numdate(val);
						} else if(!isNaN(fuzzydate(val).getDate())) {
							val = parseDate(val);
						}
						if(typeof $cptable !== 'undefined' && typeof val == "string" && ((opts||{}).type != "string") && (opts||{}).codepage) val = $cptable.utils.decode(opts.codepage, val);
						C_seen_K = true;
						break;
					case 'E':
						C_seen_E = true;
						var formula = rc_to_a1(record[rj].slice(1), {r:R,c:C});
						arr[R][C] = [arr[R][C], formula];
						break;
					case 'S':
						C_seen_S = true;
						arr[R][C] = [arr[R][C], "S5S"];
						break;
					case 'G': break; // unknown
					case 'R': _R = parseInt(record[rj].slice(1))-1; break;
					case 'C': _C = parseInt(record[rj].slice(1))-1; break;
					default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				}
				if(C_seen_K) {
					if(arr[R][C] && arr[R][C].length == 2) arr[R][C][0] = val;
					else arr[R][C] = val;
					next_cell_format = null;
				}
				if(C_seen_S) {
					if(C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
					var shrbase = _R > -1 && arr[_R][_C];
					if(!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
					arr[R][C][1] = shift_formula_str(shrbase[1], {r: R - _R, c: C - _C});
				}
				break;
				case 'F':
				var F_seen = 0;
				for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
					case 'X': C = parseInt(record[rj].slice(1))-1; ++F_seen; break;
					case 'Y':
						R = parseInt(record[rj].slice(1))-1; /*C = 0;*/
						for(j = arr.length; j <= R; ++j) arr[j] = [];
						break;
					case 'M': Mval = parseInt(record[rj].slice(1)) / 20; break;
					case 'F': break; /* ??? */
					case 'G': break; /* hide grid */
					case 'P':
						next_cell_format = formats[parseInt(record[rj].slice(1))];
						break;
					case 'S': break; /* cell style */
					case 'D': break; /* column */
					case 'N': break; /* font */
					case 'W':
						cw = record[rj].slice(1).split(" ");
						for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j) {
							Mval = parseInt(cw[2], 10);
							colinfo[j-1] = Mval === 0 ? {hidden:true}: {wch:Mval}; process_col(colinfo[j-1]);
						} break;
					case 'C': /* default column format */
						C = parseInt(record[rj].slice(1))-1;
						if(!colinfo[C]) colinfo[C] = {};
						break;
					case 'R': /* row properties */
						R = parseInt(record[rj].slice(1))-1;
						if(!rowinfo[R]) rowinfo[R] = {};
						if(Mval > 0) { rowinfo[R].hpt = Mval; rowinfo[R].hpx = pt2px(Mval); }
						else if(Mval === 0) rowinfo[R].hidden = true;
						break;
					default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				}
				if(F_seen < 1) next_cell_format = null; break;
				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				}
			}
			if(rowinfo.length > 0) sht['!rows'] = rowinfo;
			if(colinfo.length > 0) sht['!cols'] = colinfo;
			if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
			return [arr, sht];
		}
	
		function sylk_to_sheet(d, opts) {
			var aoasht = sylk_to_aoa(d, opts);
			var aoa = aoasht[0], ws = aoasht[1];
			var o = aoa_to_sheet(aoa, opts);
			keys(ws).forEach(function(k) { o[k] = ws[k]; });
			return o;
		}
	
		function sylk_to_workbook(d, opts) { return sheet_to_workbook(sylk_to_sheet(d, opts), opts); }
	
		function write_ws_cell_sylk(cell, ws, R, C) {
			var o = "C;Y" + (R+1) + ";X" + (C+1) + ";K";
			switch(cell.t) {
				case 'n':
					o += (cell.v||0);
					if(cell.f && !cell.F) o += ";E" + a1_to_rc(cell.f, {r:R, c:C}); break;
				case 'b': o += cell.v ? "TRUE" : "FALSE"; break;
				case 'e': o += cell.w || cell.v; break;
				case 'd': o += '"' + (cell.w || cell.v) + '"'; break;
				case 's': o += '"' + cell.v.replace(/"/g,"").replace(/;/g, ";;") + '"'; break;
			}
			return o;
		}
	
		function write_ws_cols_sylk(out, cols) {
			cols.forEach(function(col, i) {
				var rec = "F;W" + (i+1) + " " + (i+1) + " ";
				if(col.hidden) rec += "0";
				else {
					if(typeof col.width == 'number' && !col.wpx) col.wpx = width2px(col.width);
					if(typeof col.wpx == 'number' && !col.wch) col.wch = px2char(col.wpx);
					if(typeof col.wch == 'number') rec += Math.round(col.wch);
				}
				if(rec.charAt(rec.length - 1) != " ") out.push(rec);
			});
		}
	
		function write_ws_rows_sylk(out, rows) {
			rows.forEach(function(row, i) {
				var rec = "F;";
				if(row.hidden) rec += "M0;";
				else if(row.hpt) rec += "M" + 20 * row.hpt + ";";
				else if(row.hpx) rec += "M" + 20 * px2pt(row.hpx) + ";";
				if(rec.length > 2) out.push(rec + "R" + (i+1));
			});
		}
	
		function sheet_to_sylk(ws, opts) {
			var preamble = ["ID;PWXL;N;E"], o = [];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			var RS = "\r\n";
	
			preamble.push("P;PGeneral");
			preamble.push("F;P0;DG0G8;M255");
			if(ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
			if(ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);
	
			preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [r.s.c,r.s.r,r.e.c,r.e.r].join(" "));
			for(var R = r.s.r; R <= r.e.r; ++R) {
				for(var C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C]: ws[coord];
					if(!cell || (cell.v == null && (!cell.f || cell.F))) continue;
					o.push(write_ws_cell_sylk(cell, ws, R, C, opts));
				}
			}
			return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
		}
	
		return {
			to_workbook: sylk_to_workbook,
			to_sheet: sylk_to_sheet,
			from_sheet: sheet_to_sylk
		};
	})();
	
	var DIF = (function() {
		function dif_to_aoa(d, opts) {
			switch(opts.type) {
				case 'base64': return dif_to_aoa_str(Base64_decode(d), opts);
				case 'binary': return dif_to_aoa_str(d, opts);
				case 'buffer': return dif_to_aoa_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
				case 'array': return dif_to_aoa_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
		function dif_to_aoa_str(str, opts) {
			var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
			for (; ri !== records.length; ++ri) {
				if (records[ri].trim() === 'BOT') { arr[++R] = []; C = 0; continue; }
				if (R < 0) continue;
				var metadata = records[ri].trim().split(",");
				var type = metadata[0], value = metadata[1];
				++ri;
				var data = records[ri] || "";
				while(((data.match(/["]/g)||[]).length & 1) && ri < records.length - 1) data += "\n" + records[++ri];
				data = data.trim();
				switch (+type) {
					case -1:
						if (data === 'BOT') { arr[++R] = []; C = 0; continue; }
						else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
						break;
					case 0:
						if(data === 'TRUE') arr[R][C] = true;
						else if(data === 'FALSE') arr[R][C] = false;
						else if(!isNaN(fuzzynum(value))) arr[R][C] = fuzzynum(value);
						else if(!isNaN(fuzzydate(value).getDate())) arr[R][C] = parseDate(value);
						else arr[R][C] = value;
						++C; break;
					case 1:
						data = data.slice(1,data.length-1);
						data = data.replace(/""/g, '"');
						if(DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
						arr[R][C++] = data !== '' ? data : null;
						break;
				}
				if (data === 'EOD') break;
			}
			if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
			return arr;
		}
	
		function dif_to_sheet(str, opts) { return aoa_to_sheet(dif_to_aoa(str, opts), opts); }
		function dif_to_workbook(str, opts) { return sheet_to_workbook(dif_to_sheet(str, opts), opts); }
	
		var sheet_to_dif = (function() {
			var push_field = function pf(o, topic, v, n, s) {
				o.push(topic);
				o.push(v + "," + n);
				o.push('"' + s.replace(/"/g,'""') + '"');
			};
			var push_value = function po(o, type, v, s) {
				o.push(type + "," + v);
				o.push(type == 1 ? '"' + s.replace(/"/g,'""') + '"' : s);
			};
			return function sheet_to_dif(ws) {
				var o = [];
				var r = safe_decode_range(ws['!ref']), cell;
				var dense = Array.isArray(ws);
				push_field(o, "TABLE", 0, 1, "sheetjs");
				push_field(o, "VECTORS", 0, r.e.r - r.s.r + 1,"");
				push_field(o, "TUPLES", 0, r.e.c - r.s.c + 1,"");
				push_field(o, "DATA", 0, 0,"");
				for(var R = r.s.r; R <= r.e.r; ++R) {
					push_value(o, -1, 0, "BOT");
					for(var C = r.s.c; C <= r.e.c; ++C) {
						var coord = encode_cell({r:R,c:C});
						cell = dense ? (ws[R]||[])[C] : ws[coord];
						if(!cell) { push_value(o, 1, 0, ""); continue;}
						switch(cell.t) {
							case 'n':
								var val = DIF_XL ? cell.w : cell.v;
								if(!val && cell.v != null) val = cell.v;
								if(val == null) {
									if(DIF_XL && cell.f && !cell.F) push_value(o, 1, 0, "=" + cell.f);
									else push_value(o, 1, 0, "");
								}
								else push_value(o, 0, val, "V");
								break;
							case 'b':
								push_value(o, 0, cell.v ? 1 : 0, cell.v ? "TRUE" : "FALSE");
								break;
							case 's':
								push_value(o, 1, 0, (!DIF_XL || isNaN(cell.v)) ? cell.v : '="' + cell.v + '"');
								break;
							case 'd':
								if(!cell.w) cell.w = SSF_format(cell.z || table_fmt[14], datenum(parseDate(cell.v)));
								if(DIF_XL) push_value(o, 0, cell.w, "V");
								else push_value(o, 1, 0, cell.w);
								break;
							default: push_value(o, 1, 0, "");
						}
					}
				}
				push_value(o, -1, 0, "EOD");
				var RS = "\r\n";
				var oo = o.join(RS);
				//while((oo.length & 0x7F) != 0) oo += "\0";
				return oo;
			};
		})();
		return {
			to_workbook: dif_to_workbook,
			to_sheet: dif_to_sheet,
			from_sheet: sheet_to_dif
		};
	})();
	
	var ETH = (function() {
		function decode(s) { return s.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n"); }
		function encode(s) { return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g,"\\n"); }
	
		function eth_to_aoa(str, opts) {
			var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
			for (; ri !== records.length; ++ri) {
				var record = records[ri].trim().split(":");
				if(record[0] !== 'cell') continue;
				var addr = decode_cell(record[1]);
				if(arr.length <= addr.r) for(R = arr.length; R <= addr.r; ++R) if(!arr[R]) arr[R] = [];
				R = addr.r; C = addr.c;
				switch(record[2]) {
					case 't': arr[R][C] = decode(record[3]); break;
					case 'v': arr[R][C] = +record[3]; break;
					case 'vtf': var _f = record[record.length - 1];
						/* falls through */
					case 'vtc':
						switch(record[3]) {
							case 'nl': arr[R][C] = +record[4] ? true : false; break;
							default: arr[R][C] = +record[4]; break;
						}
						if(record[2] == 'vtf') arr[R][C] = [arr[R][C], _f];
				}
			}
			if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
			return arr;
		}
	
		function eth_to_sheet(d, opts) { return aoa_to_sheet(eth_to_aoa(d, opts), opts); }
		function eth_to_workbook(d, opts) { return sheet_to_workbook(eth_to_sheet(d, opts), opts); }
	
		var header = [
			"socialcalc:version:1.5",
			"MIME-Version: 1.0",
			"Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
		].join("\n");
	
		var sep = [
			"--SocialCalcSpreadsheetControlSave",
			"Content-type: text/plain; charset=UTF-8"
		].join("\n") + "\n";
	
		/* TODO: the other parts */
		var meta = [
			"# SocialCalc Spreadsheet Control Save",
			"part:sheet"
		].join("\n");
	
		var end = "--SocialCalcSpreadsheetControlSave--";
	
		function sheet_to_eth_data(ws) {
			if(!ws || !ws['!ref']) return "";
			var o = [], oo = [], cell, coord = "";
			var r = decode_range(ws['!ref']);
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				for(var C = r.s.c; C <= r.e.c; ++C) {
					coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C] : ws[coord];
					if(!cell || cell.v == null || cell.t === 'z') continue;
					oo = ["cell", coord, 't'];
					switch(cell.t) {
						case 's': case 'str': oo.push(encode(cell.v)); break;
						case 'n':
							if(!cell.f) { oo[2]='v'; oo[3]=cell.v; }
							else { oo[2]='vtf'; oo[3]='n'; oo[4]=cell.v; oo[5]=encode(cell.f); }
							break;
						case 'b':
							oo[2] = 'vt'+(cell.f?'f':'c'); oo[3]='nl'; oo[4]=cell.v?"1":"0";
							oo[5] = encode(cell.f||(cell.v?'TRUE':'FALSE'));
							break;
						case 'd':
							var t = datenum(parseDate(cell.v));
							oo[2] = 'vtc'; oo[3] = 'nd'; oo[4] = ""+t;
							oo[5] = cell.w || SSF_format(cell.z || table_fmt[14], t);
							break;
						case 'e': continue;
					}
					o.push(oo.join(":"));
				}
			}
			o.push("sheet:c:" + (r.e.c-r.s.c+1) + ":r:" + (r.e.r-r.s.r+1) + ":tvf:1");
			o.push("valueformat:1:text-wiki");
			//o.push("copiedfrom:" + ws['!ref']); // clipboard only
			return o.join("\n");
		}
	
		function sheet_to_eth(ws) {
			return [header, sep, meta, sep, sheet_to_eth_data(ws), end].join("\n");
			// return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
		}
	
		return {
			to_workbook: eth_to_workbook,
			to_sheet: eth_to_sheet,
			from_sheet: sheet_to_eth
		};
	})();
	
	var PRN = (function() {
		function set_text_arr(data, arr, R, C, o) {
			if(o.raw) arr[R][C] = data;
			else if(data === ""){/* empty */}
			else if(data === 'TRUE') arr[R][C] = true;
			else if(data === 'FALSE') arr[R][C] = false;
			else if(!isNaN(fuzzynum(data))) arr[R][C] = fuzzynum(data);
			else if(!isNaN(fuzzydate(data).getDate())) arr[R][C] = parseDate(data);
			else arr[R][C] = data;
		}
	
		function prn_to_aoa_str(f, opts) {
			var o = opts || {};
			var arr = ([]);
			if(!f || f.length === 0) return arr;
			var lines = f.split(/[\r\n]/);
			var L = lines.length - 1;
			while(L >= 0 && lines[L].length === 0) --L;
			var start = 10, idx = 0;
			var R = 0;
			for(; R <= L; ++R) {
				idx = lines[R].indexOf(" ");
				if(idx == -1) idx = lines[R].length; else idx++;
				start = Math.max(start, idx);
			}
			for(R = 0; R <= L; ++R) {
				arr[R] = [];
				/* TODO: confirm that widths are always 10 */
				var C = 0;
				set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
				for(C = 1; C <= (lines[R].length - start)/10 + 1; ++C)
					set_text_arr(lines[R].slice(start+(C-1)*10,start+C*10).trim(),arr,R,C,o);
			}
			if(o.sheetRows) arr = arr.slice(0, o.sheetRows);
			return arr;
		}
	
		// List of accepted CSV separators
		var guess_seps = {
	0x2C: ',',
	0x09: "\t",
	0x3B: ';',
	0x7C: '|'
		};
	
		// CSV separator weights to be used in case of equal numbers
		var guess_sep_weights = {
	0x2C: 3,
	0x09: 2,
	0x3B: 1,
	0x7C: 0
		};
	
		function guess_sep(str) {
			var cnt = {}, instr = false, end = 0, cc = 0;
			for(;end < str.length;++end) {
				if((cc=str.charCodeAt(end)) == 0x22) instr = !instr;
				else if(!instr && cc in guess_seps) cnt[cc] = (cnt[cc]||0)+1;
			}
	
			cc = [];
			for(end in cnt) if ( Object.prototype.hasOwnProperty.call(cnt, end) ) {
				cc.push([ cnt[end], end ]);
			}
	
			if ( !cc.length ) {
				cnt = guess_sep_weights;
				for(end in cnt) if ( Object.prototype.hasOwnProperty.call(cnt, end) ) {
					cc.push([ cnt[end], end ]);
				}
			}
	
			cc.sort(function(a, b) { return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]]; });
	
			return guess_seps[cc.pop()[1]] || 0x2C;
		}
	
		function dsv_to_sheet_str(str, opts) {
			var o = opts || {};
			var sep = "";
			if(DENSE != null && o.dense == null) o.dense = DENSE;
			var ws = o.dense ? ([]) : ({});
			var range = ({s: {c:0, r:0}, e: {c:0, r:0}});
	
			if(str.slice(0,4) == "sep=") {
				// If the line ends in \r\n
				if(str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10 ) {
					sep = str.charAt(4); str = str.slice(7);
				}
				// If line ends in \r OR \n
				else if(str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10 ) {
					sep = str.charAt(4); str = str.slice(6);
				}
				else sep = guess_sep(str.slice(0,1024));
			}
			else if(o && o.FS) sep = o.FS;
			else sep = guess_sep(str.slice(0,1024));
			var R = 0, C = 0, v = 0;
			var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc=0, startcc=str.charCodeAt(0);
			str = str.replace(/\r\n/mg, "\n");
			var _re = o.dateNF != null ? dateNF_regex(o.dateNF) : null;
			function finish_cell() {
				var s = str.slice(start, end);
				var cell = ({});
				if(s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1,-1).replace(/""/g,'"');
				if(s.length === 0) cell.t = 'z';
				else if(o.raw) { cell.t = 's'; cell.v = s; }
				else if(s.trim().length === 0) { cell.t = 's'; cell.v = s; }
				else if(s.charCodeAt(0) == 0x3D) {
					if(s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) { cell.t = 's'; cell.v = s.slice(2,-1).replace(/""/g,'"'); }
					else if(fuzzyfmla(s)) { cell.t = 'n'; cell.f = s.slice(1); }
					else { cell.t = 's'; cell.v = s; } }
				else if(s == "TRUE") { cell.t = 'b'; cell.v = true; }
				else if(s == "FALSE") { cell.t = 'b'; cell.v = false; }
				else if(!isNaN(v = fuzzynum(s))) { cell.t = 'n'; if(o.cellText !== false) cell.w = s; cell.v = v; }
				else if(!isNaN(fuzzydate(s).getDate()) || _re && s.match(_re)) {
					cell.z = o.dateNF || table_fmt[14];
					var k = 0;
					if(_re && s.match(_re)){ s=dateNF_fix(s, o.dateNF, (s.match(_re)||[])); k=1; }
					if(o.cellDates) { cell.t = 'd'; cell.v = parseDate(s, k); }
					else { cell.t = 'n'; cell.v = datenum(parseDate(s, k)); }
					if(o.cellText !== false) cell.w = SSF_format(cell.z, cell.v instanceof Date ? datenum(cell.v):cell.v);
					if(!o.cellNF) delete cell.z;
				} else {
					cell.t = 's';
					cell.v = s;
				}
				if(cell.t == 'z'){}
				else if(o.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = cell; }
				else ws[encode_cell({c:C,r:R})] = cell;
				start = end+1; startcc = str.charCodeAt(start);
				if(range.e.c < C) range.e.c = C;
				if(range.e.r < R) range.e.r = R;
				if(cc == sepcc) ++C; else { C = 0; ++R; if(o.sheetRows && o.sheetRows <= R) return true; }
			}
			outer: for(;end < str.length;++end) switch((cc=str.charCodeAt(end))) {
				case 0x22: if(startcc === 0x22) instr = !instr; break;
				case sepcc: case 0x0a: case 0x0d: if(!instr && finish_cell()) break outer; break;
				default: break;
			}
			if(end - start > 0) finish_cell();
	
			ws['!ref'] = encode_range(range);
			return ws;
		}
	
		function prn_to_sheet_str(str, opts) {
			if(!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
			if(opts.FS) return dsv_to_sheet_str(str, opts);
			if(str.slice(0,4) == "sep=") return dsv_to_sheet_str(str, opts);
			if(str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
			return aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
		}
	
		function prn_to_sheet(d, opts) {
			var str = "", bytes = opts.type == 'string' ? [0,0,0,0] : firstbyte(d, opts);
			switch(opts.type) {
				case 'base64': str = Base64_decode(d); break;
				case 'binary': str = d; break;
				case 'buffer':
					if(opts.codepage == 65001) str = d.toString('utf8'); // TODO: test if buf
					else if(opts.codepage && typeof $cptable !== 'undefined') str = $cptable.utils.decode(opts.codepage, d);
					else str = has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d);
					break;
				case 'array': str = cc2str(d); break;
				case 'string': str = d; break;
				default: throw new Error("Unrecognized type " + opts.type);
			}
			if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str.slice(3));
			else if(opts.type != 'string' && opts.type != 'buffer' && opts.codepage == 65001) str = utf8read(str);
			else if((opts.type == 'binary') && typeof $cptable !== 'undefined' && opts.codepage)  str = $cptable.utils.decode(opts.codepage, $cptable.utils.encode(28591,str));
			if(str.slice(0,19) == "socialcalc:version:") return ETH.to_sheet(opts.type == 'string' ? str : utf8read(str), opts);
			return prn_to_sheet_str(str, opts);
		}
	
		function prn_to_workbook(d, opts) { return sheet_to_workbook(prn_to_sheet(d, opts), opts); }
	
		function sheet_to_prn(ws) {
			var o = [];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				var oo = [];
				for(var C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C] : ws[coord];
					if(!cell || cell.v == null) { oo.push("          "); continue; }
					var w = (cell.w || (format_cell(cell), cell.w) || "").slice(0,10);
					while(w.length < 10) w += " ";
					oo.push(w + (C === 0 ? " " : ""));
				}
				o.push(oo.join(""));
			}
			return o.join("\n");
		}
	
		return {
			to_workbook: prn_to_workbook,
			to_sheet: prn_to_sheet,
			from_sheet: sheet_to_prn
		};
	})();
	
	/* Excel defaults to SYLK but warns if data is not valid */
	function read_wb_ID(d, opts) {
		var o = opts || {}, OLD_WTF = !!o.WTF; o.WTF = true;
		try {
			var out = SYLK.to_workbook(d, o);
			o.WTF = OLD_WTF;
			return out;
		} catch(e) {
			o.WTF = OLD_WTF;
			if(!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
			return PRN.to_workbook(d, opts);
		}
	}
	
	var WK_ = (function() {
		function lotushopper(data, cb, opts) {
			if(!data) return;
			prep_blob(data, data.l || 0);
			var Enum = opts.Enum || WK1Enum;
			while(data.l < data.length) {
				var RT = data.read_shift(2);
				var R = Enum[RT] || Enum[0xFFFF];
				var length = data.read_shift(2);
				var tgt = data.l + length;
				var d = R.f && R.f(data, length, opts);
				data.l = tgt;
				if(cb(d, R, RT)) return;
			}
		}
	
		function lotus_to_workbook(d, opts) {
			switch(opts.type) {
				case 'base64': return lotus_to_workbook_buf(s2a(Base64_decode(d)), opts);
				case 'binary': return lotus_to_workbook_buf(s2a(d), opts);
				case 'buffer':
				case 'array': return lotus_to_workbook_buf(d, opts);
			}
			throw "Unsupported type " + opts.type;
		}
	
		function lotus_to_workbook_buf(d, opts) {
			if(!d) return d;
			var o = opts || {};
			if(DENSE != null && o.dense == null) o.dense = DENSE;
			var s = ((o.dense ? [] : {})), n = "Sheet1", next_n = "", sidx = 0;
			var sheets = {}, snames = [], realnames = [];
	
			var refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
			var sheetRows = o.sheetRows || 0;
	
			if(d[2] == 0x00) {
				if(d[3] == 0x08 || d[3] == 0x09) {
					if(d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
				}
			}
	
			if(d[2] == 0x02) {
				o.Enum = WK1Enum;
				lotushopper(d, function(val, R, RT) { switch(RT) {
					case 0x00: /* BOF */
						o.vers = val;
						if(val >= 0x1000) o.qpro = true;
						break;
					case 0x06: refguess = val; break; /* RANGE */
					case 0xCC: if(val) next_n = val; break; /* SHEETNAMECS */
					case 0xDE: next_n = val; break; /* SHEETNAMELP */
					case 0x0F: /* LABEL */
					case 0x33: /* STRING */
						if(!o.qpro) val[1].v = val[1].v.slice(1);
						/* falls through */
					case 0x0D: /* INTEGER */
					case 0x0E: /* NUMBER */
					case 0x10: /* FORMULA */
						/* TODO: actual translation of the format code */
						if(RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
							val[1].z = o.dateNF || table_fmt[14];
							if(o.cellDates) { val[1].t = 'd'; val[1].v = numdate(val[1].v); }
						}
	
						if(o.qpro) {
							if(val[3] > sidx) {
								s["!ref"] = encode_range(refguess);
								sheets[n] = s;
								snames.push(n);
								s = (o.dense ? [] : {});
								refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
								sidx = val[3]; n = next_n || "Sheet" + (sidx + 1); next_n = "";
							}
						}
	
						var tmpcell = o.dense ? (s[val[0].r]||[])[val[0].c] : s[encode_cell(val[0])];
						if(tmpcell) {
							tmpcell.t = val[1].t; tmpcell.v = val[1].v;
							if(val[1].z != null) tmpcell.z = val[1].z;
							if(val[1].f != null) tmpcell.f = val[1].f;
							break;
						}
						if(o.dense) {
							if(!s[val[0].r]) s[val[0].r] = [];
							s[val[0].r][val[0].c] = val[1];
						} else s[encode_cell(val[0])] = val[1];
						break;
					default:
				}}, o);
			} else if(d[2] == 0x1A || d[2] == 0x0E) {
				o.Enum = WK3Enum;
				if(d[2] == 0x0E) { o.qpro = true; d.l = 0; }
				lotushopper(d, function(val, R, RT) { switch(RT) {
					case 0xCC: n = val; break; /* SHEETNAMECS */
					case 0x16: /* LABEL16 */
						val[1].v = val[1].v.slice(1);
						/* falls through */
					case 0x17: /* NUMBER17 */
					case 0x18: /* NUMBER18 */
					case 0x19: /* FORMULA19 */
					case 0x25: /* NUMBER25 */
					case 0x27: /* NUMBER27 */
					case 0x28: /* FORMULA28 */
						if(val[3] > sidx) {
							s["!ref"] = encode_range(refguess);
							sheets[n] = s;
							snames.push(n);
							s = (o.dense ? [] : {});
							refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
							sidx = val[3]; n = "Sheet" + (sidx + 1);
						}
						if(sheetRows > 0 && val[0].r >= sheetRows) break;
						if(o.dense) {
							if(!s[val[0].r]) s[val[0].r] = [];
							s[val[0].r][val[0].c] = val[1];
						} else s[encode_cell(val[0])] = val[1];
						if(refguess.e.c < val[0].c) refguess.e.c = val[0].c;
						if(refguess.e.r < val[0].r) refguess.e.r = val[0].r;
						break;
					case 0x1B: /* XFORMAT */
						if(val[0x36b0]) realnames[val[0x36b0][0]] = val[0x36b0][1];
						break;
					case 0x0601: /* SHEETINFOQP */
						realnames[val[0]] = val[1]; if(val[0] == sidx) n = val[1]; break;
					default: break;
				}}, o);
			} else throw new Error("Unrecognized LOTUS BOF " + d[2]);
			s["!ref"] = encode_range(refguess);
			sheets[next_n || n] = s;
			snames.push(next_n || n);
			if(!realnames.length) return { SheetNames: snames, Sheets: sheets };
			var osheets = {}, rnames = [];
			/* TODO: verify no collisions */
			for(var i = 0; i < realnames.length; ++i) if(sheets[snames[i]]) {
				rnames.push(realnames[i] || snames[i]);
				osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
			} else {
				rnames.push(realnames[i]);
				osheets[realnames[i]] = ({ "!ref": "A1" });
			}
			return { SheetNames: rnames, Sheets: osheets };
		}
	
		function sheet_to_wk1(ws, opts) {
			var o = opts || {};
			if(+o.codepage >= 0) set_cp(+o.codepage);
			if(o.type == "string") throw new Error("Cannot write WK1 to JS string");
			var ba = buf_array();
			var range = safe_decode_range(ws["!ref"]);
			var dense = Array.isArray(ws);
			var cols = [];
	
			write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
			write_biff_rec(ba, 0x06, write_RANGE(range));
			var max_R = Math.min(range.e.r, 8191);
			for(var R = range.s.r; R <= max_R; ++R) {
				var rr = encode_row(R);
				for(var C = range.s.c; C <= range.e.c; ++C) {
					if(R === range.s.r) cols[C] = encode_col(C);
					var ref = cols[C] + rr;
					var cell = dense ? (ws[R]||[])[C] : ws[ref];
					if(!cell || cell.t == "z") continue;
					/* TODO: formula records */
					if(cell.t == "n") {
						if((cell.v|0)==cell.v && cell.v >= -32768 && cell.v <= 32767) write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell.v));
						else write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell.v));
					} else {
						var str = format_cell(cell);
						write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
					}
				}
			}
	
			write_biff_rec(ba, 0x01);
			return ba.end();
		}
	
		function book_to_wk3(wb, opts) {
			var o = opts || {};
			if(+o.codepage >= 0) set_cp(+o.codepage);
			if(o.type == "string") throw new Error("Cannot write WK3 to JS string");
			var ba = buf_array();
	
			write_biff_rec(ba, 0x00, write_BOF_WK3(wb));
	
			for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i) if((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));
	
			var wsidx = 0;
			for(i = 0; i < wb.SheetNames.length; ++i) {
				var ws = wb.Sheets[wb.SheetNames[i]];
				if(!ws || !ws["!ref"]) continue;
				var range = safe_decode_range(ws["!ref"]);
				var dense = Array.isArray(ws);
				var cols = [];
				var max_R = Math.min(range.e.r, 8191);
				for(var R = range.s.r; R <= max_R; ++R) {
					var rr = encode_row(R);
					for(var C = range.s.c; C <= range.e.c; ++C) {
						if(R === range.s.r) cols[C] = encode_col(C);
						var ref = cols[C] + rr;
						var cell = dense ? (ws[R]||[])[C] : ws[ref];
						if(!cell || cell.t == "z") continue;
						/* TODO: FORMULA19 NUMBER18 records */
						if(cell.t == "n") {
							write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
						} else {
							var str = format_cell(cell);
							/* TODO: max len? */
							write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
						}
					}
				}
				++wsidx;
			}
	
			write_biff_rec(ba, 0x01);
			return ba.end();
		}
	
	
		function write_BOF_WK1(v) {
			var out = new_buf(2);
			out.write_shift(2, v);
			return out;
		}
	
		function write_BOF_WK3(wb) {
			var out = new_buf(26);
			out.write_shift(2, 0x1000);
			out.write_shift(2, 0x0004);
			out.write_shift(4, 0x0000);
			var rows = 0, cols = 0, wscnt = 0;
			for(var i = 0; i < wb.SheetNames.length; ++i) {
				var name = wb.SheetNames[i];
				var ws = wb.Sheets[name];
				if(!ws || !ws["!ref"]) continue;
				++wscnt;
				var range = decode_range(ws["!ref"]);
				if(rows < range.e.r) rows = range.e.r;
				if(cols < range.e.c) cols = range.e.c;
			}
			if(rows > 8191) rows = 8191;
			out.write_shift(2, rows);
			out.write_shift(1, wscnt);
			out.write_shift(1, cols);
			out.write_shift(2, 0x00);
			out.write_shift(2, 0x00);
			out.write_shift(1, 0x01);
			out.write_shift(1, 0x02);
			out.write_shift(4, 0);
			out.write_shift(4, 0);
			return out;
		}
	
		function parse_RANGE(blob, length, opts) {
			var o = {s:{c:0,r:0},e:{c:0,r:0}};
			if(length == 8 && opts.qpro) {
				o.s.c = blob.read_shift(1);
				blob.l++;
				o.s.r = blob.read_shift(2);
				o.e.c = blob.read_shift(1);
				blob.l++;
				o.e.r = blob.read_shift(2);
				return o;
			}
			o.s.c = blob.read_shift(2);
			o.s.r = blob.read_shift(2);
			if(length == 12 && opts.qpro) blob.l += 2;
			o.e.c = blob.read_shift(2);
			o.e.r = blob.read_shift(2);
			if(length == 12 && opts.qpro) blob.l += 2;
			if(o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
			return o;
		}
		function write_RANGE(range) {
			var out = new_buf(8);
			out.write_shift(2, range.s.c);
			out.write_shift(2, range.s.r);
			out.write_shift(2, range.e.c);
			out.write_shift(2, range.e.r);
			return out;
		}
	
		function parse_cell(blob, length, opts) {
			var o = [{c:0,r:0}, {t:'n',v:0}, 0, 0];
			if(opts.qpro && opts.vers != 0x5120) {
				o[0].c = blob.read_shift(1);
				o[3] = blob.read_shift(1);
				o[0].r = blob.read_shift(2);
				blob.l+=2;
			} else {
				o[2] = blob.read_shift(1);
				o[0].c = blob.read_shift(2); o[0].r = blob.read_shift(2);
			}
			return o;
		}
	
		function parse_LABEL(blob, length, opts) {
			var tgt = blob.l + length;
			var o = parse_cell(blob, length, opts);
			o[1].t = 's';
			if(opts.vers == 0x5120) {
				blob.l++;
				var len = blob.read_shift(1);
				o[1].v = blob.read_shift(len, 'utf8');
				return o;
			}
			if(opts.qpro) blob.l++;
			o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
			return o;
		}
		function write_LABEL(R, C, s) {
			/* TODO: encoding */
			var o = new_buf(7 + s.length);
			o.write_shift(1, 0xFF);
			o.write_shift(2, C);
			o.write_shift(2, R);
			o.write_shift(1, 0x27); // ??
			for(var i = 0; i < o.length; ++i) {
				var cc = s.charCodeAt(i);
				o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
			}
			o.write_shift(1, 0);
			return o;
		}
	
		function parse_INTEGER(blob, length, opts) {
			var o = parse_cell(blob, length, opts);
			o[1].v = blob.read_shift(2, 'i');
			return o;
		}
		function write_INTEGER(R, C, v) {
			var o = new_buf(7);
			o.write_shift(1, 0xFF);
			o.write_shift(2, C);
			o.write_shift(2, R);
			o.write_shift(2, v, 'i');
			return o;
		}
	
		function parse_NUMBER(blob, length, opts) {
			var o = parse_cell(blob, length, opts);
			o[1].v = blob.read_shift(8, 'f');
			return o;
		}
		function write_NUMBER(R, C, v) {
			var o = new_buf(13);
			o.write_shift(1, 0xFF);
			o.write_shift(2, C);
			o.write_shift(2, R);
			o.write_shift(8, v, 'f');
			return o;
		}
	
		function parse_FORMULA(blob, length, opts) {
			var tgt = blob.l + length;
			var o = parse_cell(blob, length, opts);
			/* TODO: formula */
			o[1].v = blob.read_shift(8, 'f');
			if(opts.qpro) blob.l = tgt;
			else {
				var flen = blob.read_shift(2);
				wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
				blob.l += flen;
			}
			return o;
		}
	
		function wk1_parse_rc(B, V, col) {
			var rel = V & 0x8000;
			V &= ~0x8000;
			V = (rel ? B : 0) + ((V >= 0x2000) ? V - 0x4000 : V);
			return (rel ? "" : "$") + (col ? encode_col(V) : encode_row(V));
		}
		/* var oprec = [
			8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
			3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
		]; */
		/* TODO: flesh out */
		var FuncTab = {
			0x33: ["FALSE", 0],
			0x34: ["TRUE", 0],
			0x46: ["LEN", 1],
			0x50: ["SUM", 69],
			0x51: ["AVERAGEA", 69],
			0x52: ["COUNTA", 69],
			0x53: ["MINA", 69],
			0x54: ["MAXA", 69],
			0x6F: ["T", 1]
		};
		var BinOpTab = [
			  "",   "",   "",   "",   "",   "",   "",   "", // eslint-disable-line no-mixed-spaces-and-tabs
			  "",  "+",  "-",  "*",  "/",  "^",  "=", "<>", // eslint-disable-line no-mixed-spaces-and-tabs
			"<=", ">=",  "<",  ">",   "",   "",   "",   "", // eslint-disable-line no-mixed-spaces-and-tabs
			 "&",   "",   "",   "",   "",   "",   "",   ""  // eslint-disable-line no-mixed-spaces-and-tabs
		];
	
		function wk1_fmla_to_csf(blob, o) {
			prep_blob(blob, 0);
			var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
			while(blob.l < blob.length) {
				var cc = blob[blob.l++];
				switch(cc) {
					case 0x00: out.push(blob.read_shift(8, 'f')); break;
					case 0x01: {
						C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
						R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
						out.push(C + R);
					} break;
					case 0x02: {
						var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
						var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
						C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
						R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
						out.push(c + r + ":" + C + R);
					} break;
					case 0x03:
						if(blob.l < blob.length) { console.error("WK1 premature formula end"); return; }
						break;
					case 0x04: out.push("(" + out.pop() + ")"); break;
					case 0x05: out.push(blob.read_shift(2)); break;
					case 0x06: {
						/* TODO: text encoding */
						var Z = ""; while((cc = blob[blob.l++])) Z += String.fromCharCode(cc);
						out.push('"' + Z.replace(/"/g, '""') + '"');
					} break;
	
					case 0x08: out.push("-" + out.pop()); break;
					case 0x17: out.push("+" + out.pop()); break;
					case 0x16: out.push("NOT(" + out.pop() + ")"); break;
	
					case 0x14: case 0x15: {
						argR = out.pop(); argL = out.pop();
						out.push(["AND", "OR"][cc - 0x14] + "(" + argL + "," + argR + ")");
					} break;
	
					default:
						if(cc < 0x20 && BinOpTab[cc]) {
							argR = out.pop(); argL = out.pop();
							out.push(argL + BinOpTab[cc] + argR);
						} else if(FuncTab[cc]) {
							argc = FuncTab[cc][1];
							if(argc == 69) argc = blob[blob.l++];
							if(argc > out.length) { console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|"); return; }
							var args = out.slice(-argc);
							out.length -= argc;
							out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
						}
						else if(cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
						else if(cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
						else if(cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
						else if(cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
						// possible future functions ??
						else return console.error("WK1 unrecognized opcode " + cc.toString(16));
				}
			}
			if(out.length == 1) o[1].f = "" + out[0];
			else console.error("WK1 bad formula parse |" + out.join("|") + "|");
		}
	
	
		function parse_cell_3(blob) {
			var o = [{c:0,r:0}, {t:'n',v:0}, 0];
			o[0].r = blob.read_shift(2); o[3] = blob[blob.l++]; o[0].c = blob[blob.l++];
			return o;
		}
	
		function parse_LABEL_16(blob, length) {
			var o = parse_cell_3(blob, length);
			o[1].t = 's';
			o[1].v = blob.read_shift(length - 4, 'cstr');
			return o;
		}
		function write_LABEL_16(R, C, wsidx, s) {
			/* TODO: encoding */
			var o = new_buf(6 + s.length);
			o.write_shift(2, R);
			o.write_shift(1, wsidx);
			o.write_shift(1, C);
			o.write_shift(1, 0x27);
			for(var i = 0; i < s.length; ++i) {
				var cc = s.charCodeAt(i);
				o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
			}
			o.write_shift(1, 0);
			return o;
		}
	
		function parse_NUMBER_18(blob, length) {
			var o = parse_cell_3(blob, length);
			o[1].v = blob.read_shift(2);
			var v = o[1].v >> 1;
			if(o[1].v & 0x1) {
				switch(v & 0x07) {
					case 0: v = (v >> 3) * 5000; break;
					case 1: v = (v >> 3) * 500; break;
					case 2: v = (v >> 3) / 20; break;
					case 3: v = (v >> 3) / 200; break;
					case 4: v = (v >> 3) / 2000; break;
					case 5: v = (v >> 3) / 20000; break;
					case 6: v = (v >> 3) / 16; break;
					case 7: v = (v >> 3) / 64; break;
				}
			}
			o[1].v = v;
			return o;
		}
	
		function parse_NUMBER_17(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(4);
			var v2 = blob.read_shift(4);
			var e = blob.read_shift(2);
			if(e == 0xFFFF) {
				if(v1 === 0 && v2 === 0xC0000000) { o[1].t = "e"; o[1].v = 0x0F; } // ERR -> #VALUE!
				else if(v1 === 0 && v2 === 0xD0000000) { o[1].t = "e"; o[1].v = 0x2A; } // NA -> #N/A
				else o[1].v = 0;
				return o;
			}
			var s = e & 0x8000; e = (e&0x7FFF) - 16446;
			o[1].v = (1 - s*2) * (v2 * Math.pow(2, e+32) + v1 * Math.pow(2, e));
			return o;
		}
		function write_NUMBER_17(R, C, wsidx, v) {
			var o = new_buf(14);
			o.write_shift(2, R);
			o.write_shift(1, wsidx);
			o.write_shift(1, C);
			if(v == 0) {
				o.write_shift(4, 0);
				o.write_shift(4, 0);
				o.write_shift(2, 0xFFFF);
				return o;
			}
			var s = 0, e = 0, v1 = 0, v2 = 0;
			if(v < 0) { s = 1; v = -v; }
			e = Math.log2(v) | 0;
			v /= Math.pow(2, e-31);
			v2 = (v)>>>0;
			if((v2&0x80000000) == 0) { v/=2; ++e; v2 = v >>> 0; }
			v -= v2;
			v2 |= 0x80000000;
			v2 >>>= 0;
			v *= Math.pow(2, 32);
			v1 = v>>>0;
			o.write_shift(4, v1);
			o.write_shift(4, v2);
			e += 0x3FFF + (s ? 0x8000 : 0);
			o.write_shift(2, e);
			return o;
		}
	
		function parse_FORMULA_19(blob, length) {
			var o = parse_NUMBER_17(blob, 14);
			blob.l += length - 14; /* TODO: WK3 formula */
			return o;
		}
	
		function parse_NUMBER_25(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(4);
			o[1].v = v1 >> 6;
			return o;
		}
	
		function parse_NUMBER_27(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(8,'f');
			o[1].v = v1;
			return o;
		}
	
		function parse_FORMULA_28(blob, length) {
			var o = parse_NUMBER_27(blob, 14);
			blob.l += length - 10; /* TODO: formula */
			return o;
		}
	
		function parse_SHEETNAMECS(blob, length) {
			return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, 'cstr') : "";
		}
	
		function parse_SHEETNAMELP(blob, length) {
			var len = blob[blob.l++];
			if(len > length - 1) len = length - 1;
			var o = ""; while(o.length < len) o += String.fromCharCode(blob[blob.l++]);
			return o;
		}
	
		function parse_SHEETINFOQP(blob, length, opts) {
			if(!opts.qpro || length < 21) return;
			var id = blob.read_shift(1);
			blob.l += 17;
			blob.l += 1; //var len = blob.read_shift(1);
			blob.l += 2;
			var nm = blob.read_shift(length - 21, 'cstr');
			return [id, nm];
		}
	
		function parse_XFORMAT(blob, length) {
			var o = {}, tgt = blob.l + length;
			while(blob.l < tgt) {
				var dt = blob.read_shift(2);
				if(dt == 0x36b0) {
					o[dt] = [0, ""];
					o[dt][0] = blob.read_shift(2);
					while(blob[blob.l]) { o[dt][1] += String.fromCharCode(blob[blob.l]); blob.l++; } blob.l++;
				}
				// TODO: 0x3a99 ??
			}
			return o;
		}
		function write_XFORMAT_SHEETNAME(name, wsidx) {
			var out = new_buf(5 + name.length);
			out.write_shift(2, 0x36b0);
			out.write_shift(2, wsidx);
			for(var i = 0; i < name.length; ++i) {
				var cc = name.charCodeAt(i);
				out[out.l++] = cc > 0x7F ? 0x5F : cc;
			}
			out[out.l++] = 0;
			return out;
		}
	
		var WK1Enum = {
	0x0000: { n:"BOF", f:parseuint16 },
	0x0001: { n:"EOF" },
	0x0002: { n:"CALCMODE" },
	0x0003: { n:"CALCORDER" },
	0x0004: { n:"SPLIT" },
	0x0005: { n:"SYNC" },
	0x0006: { n:"RANGE", f:parse_RANGE },
	0x0007: { n:"WINDOW1" },
	0x0008: { n:"COLW1" },
	0x0009: { n:"WINTWO" },
	0x000A: { n:"COLW2" },
	0x000B: { n:"NAME" },
	0x000C: { n:"BLANK" },
	0x000D: { n:"INTEGER", f:parse_INTEGER },
	0x000E: { n:"NUMBER", f:parse_NUMBER },
	0x000F: { n:"LABEL", f:parse_LABEL },
	0x0010: { n:"FORMULA", f:parse_FORMULA },
	0x0018: { n:"TABLE" },
	0x0019: { n:"ORANGE" },
	0x001A: { n:"PRANGE" },
	0x001B: { n:"SRANGE" },
	0x001C: { n:"FRANGE" },
	0x001D: { n:"KRANGE1" },
	0x0020: { n:"HRANGE" },
	0x0023: { n:"KRANGE2" },
	0x0024: { n:"PROTEC" },
	0x0025: { n:"FOOTER" },
	0x0026: { n:"HEADER" },
	0x0027: { n:"SETUP" },
	0x0028: { n:"MARGINS" },
	0x0029: { n:"LABELFMT" },
	0x002A: { n:"TITLES" },
	0x002B: { n:"SHEETJS" },
	0x002D: { n:"GRAPH" },
	0x002E: { n:"NGRAPH" },
	0x002F: { n:"CALCCOUNT" },
	0x0030: { n:"UNFORMATTED" },
	0x0031: { n:"CURSORW12" },
	0x0032: { n:"WINDOW" },
	0x0033: { n:"STRING", f:parse_LABEL },
	0x0037: { n:"PASSWORD" },
	0x0038: { n:"LOCKED" },
	0x003C: { n:"QUERY" },
	0x003D: { n:"QUERYNAME" },
	0x003E: { n:"PRINT" },
	0x003F: { n:"PRINTNAME" },
	0x0040: { n:"GRAPH2" },
	0x0041: { n:"GRAPHNAME" },
	0x0042: { n:"ZOOM" },
	0x0043: { n:"SYMSPLIT" },
	0x0044: { n:"NSROWS" },
	0x0045: { n:"NSCOLS" },
	0x0046: { n:"RULER" },
	0x0047: { n:"NNAME" },
	0x0048: { n:"ACOMM" },
	0x0049: { n:"AMACRO" },
	0x004A: { n:"PARSE" },
	0x0066: { n:"PRANGES??" },
	0x0067: { n:"RRANGES??" },
	0x0068: { n:"FNAME??" },
	0x0069: { n:"MRANGES??" },
	0x00CC: { n:"SHEETNAMECS", f:parse_SHEETNAMECS },
	0x00DE: { n:"SHEETNAMELP", f:parse_SHEETNAMELP },
	0xFFFF: { n:"" }
		};
	
		var WK3Enum = {
	0x0000: { n:"BOF" },
	0x0001: { n:"EOF" },
	0x0002: { n:"PASSWORD" },
	0x0003: { n:"CALCSET" },
	0x0004: { n:"WINDOWSET" },
	0x0005: { n:"SHEETCELLPTR" },
	0x0006: { n:"SHEETLAYOUT" },
	0x0007: { n:"COLUMNWIDTH" },
	0x0008: { n:"HIDDENCOLUMN" },
	0x0009: { n:"USERRANGE" },
	0x000A: { n:"SYSTEMRANGE" },
	0x000B: { n:"ZEROFORCE" },
	0x000C: { n:"SORTKEYDIR" },
	0x000D: { n:"FILESEAL" },
	0x000E: { n:"DATAFILLNUMS" },
	0x000F: { n:"PRINTMAIN" },
	0x0010: { n:"PRINTSTRING" },
	0x0011: { n:"GRAPHMAIN" },
	0x0012: { n:"GRAPHSTRING" },
	0x0013: { n:"??" },
	0x0014: { n:"ERRCELL" },
	0x0015: { n:"NACELL" },
	0x0016: { n:"LABEL16", f:parse_LABEL_16},
	0x0017: { n:"NUMBER17", f:parse_NUMBER_17 },
	0x0018: { n:"NUMBER18", f:parse_NUMBER_18 },
	0x0019: { n:"FORMULA19", f:parse_FORMULA_19},
	0x001A: { n:"FORMULA1A" },
	0x001B: { n:"XFORMAT", f:parse_XFORMAT },
	0x001C: { n:"DTLABELMISC" },
	0x001D: { n:"DTLABELCELL" },
	0x001E: { n:"GRAPHWINDOW" },
	0x001F: { n:"CPA" },
	0x0020: { n:"LPLAUTO" },
	0x0021: { n:"QUERY" },
	0x0022: { n:"HIDDENSHEET" },
	0x0023: { n:"??" },
	0x0025: { n:"NUMBER25", f:parse_NUMBER_25 },
	0x0026: { n:"??" },
	0x0027: { n:"NUMBER27", f:parse_NUMBER_27 },
	0x0028: { n:"FORMULA28", f:parse_FORMULA_28 },
	0x008E: { n:"??" },
	0x0093: { n:"??" },
	0x0096: { n:"??" },
	0x0097: { n:"??" },
	0x0098: { n:"??" },
	0x0099: { n:"??" },
	0x009A: { n:"??" },
	0x009B: { n:"??" },
	0x009C: { n:"??" },
	0x00A3: { n:"??" },
	0x00AE: { n:"??" },
	0x00AF: { n:"??" },
	0x00B0: { n:"??" },
	0x00B1: { n:"??" },
	0x00B8: { n:"??" },
	0x00B9: { n:"??" },
	0x00BA: { n:"??" },
	0x00BB: { n:"??" },
	0x00BC: { n:"??" },
	0x00C3: { n:"??" },
	0x00C9: { n:"??" },
	0x00CC: { n:"SHEETNAMECS", f:parse_SHEETNAMECS },
	0x00CD: { n:"??" },
	0x00CE: { n:"??" },
	0x00CF: { n:"??" },
	0x00D0: { n:"??" },
	0x0100: { n:"??" },
	0x0103: { n:"??" },
	0x0104: { n:"??" },
	0x0105: { n:"??" },
	0x0106: { n:"??" },
	0x0107: { n:"??" },
	0x0109: { n:"??" },
	0x010A: { n:"??" },
	0x010B: { n:"??" },
	0x010C: { n:"??" },
	0x010E: { n:"??" },
	0x010F: { n:"??" },
	0x0180: { n:"??" },
	0x0185: { n:"??" },
	0x0186: { n:"??" },
	0x0189: { n:"??" },
	0x018C: { n:"??" },
	0x0200: { n:"??" },
	0x0202: { n:"??" },
	0x0201: { n:"??" },
	0x0204: { n:"??" },
	0x0205: { n:"??" },
	0x0280: { n:"??" },
	0x0281: { n:"??" },
	0x0282: { n:"??" },
	0x0283: { n:"??" },
	0x0284: { n:"??" },
	0x0285: { n:"??" },
	0x0286: { n:"??" },
	0x0287: { n:"??" },
	0x0288: { n:"??" },
	0x0292: { n:"??" },
	0x0293: { n:"??" },
	0x0294: { n:"??" },
	0x0295: { n:"??" },
	0x0296: { n:"??" },
	0x0299: { n:"??" },
	0x029A: { n:"??" },
	0x0300: { n:"??" },
	0x0304: { n:"??" },
	0x0601: { n:"SHEETINFOQP", f:parse_SHEETINFOQP },
	0x0640: { n:"??" },
	0x0642: { n:"??" },
	0x0701: { n:"??" },
	0x0702: { n:"??" },
	0x0703: { n:"??" },
	0x0704: { n:"??" },
	0x0780: { n:"??" },
	0x0800: { n:"??" },
	0x0801: { n:"??" },
	0x0804: { n:"??" },
	0x0A80: { n:"??" },
	0x2AF6: { n:"??" },
	0x3231: { n:"??" },
	0x6E49: { n:"??" },
	0x6F44: { n:"??" },
	0xFFFF: { n:"" }
		};
		return {
			sheet_to_wk1: sheet_to_wk1,
			book_to_wk3: book_to_wk3,
			to_workbook: lotus_to_workbook
		};
	})();
	/* 18.4.7 rPr CT_RPrElt */
	function parse_rpr(rpr) {
		var font = {}, m = rpr.match(tagregex), i = 0;
		var pass = false;
		if(m) for(;i!=m.length; ++i) {
			var y = parsexmltag(m[i]);
			switch(y[0].replace(/\w*:/g,"")) {
				/* 18.8.12 condense CT_BooleanProperty */
				/* ** not required . */
				case '<condense': break;
				/* 18.8.17 extend CT_BooleanProperty */
				/* ** not required . */
				case '<extend': break;
				/* 18.8.36 shadow CT_BooleanProperty */
				/* ** not required . */
				case '<shadow':
					if(!y.val) break;
					/* falls through */
				case '<shadow>':
				case '<shadow/>': font.shadow = 1; break;
				case '</shadow>': break;
	
				/* 18.4.1 charset CT_IntProperty TODO */
				case '<charset':
					if(y.val == '1') break;
					font.cp = CS2CP[parseInt(y.val, 10)];
					break;
	
				/* 18.4.2 outline CT_BooleanProperty TODO */
				case '<outline':
					if(!y.val) break;
					/* falls through */
				case '<outline>':
				case '<outline/>': font.outline = 1; break;
				case '</outline>': break;
	
				/* 18.4.5 rFont CT_FontName */
				case '<rFont': font.name = y.val; break;
	
				/* 18.4.11 sz CT_FontSize */
				case '<sz': font.sz = y.val; break;
	
				/* 18.4.10 strike CT_BooleanProperty */
				case '<strike':
					if(!y.val) break;
					/* falls through */
				case '<strike>':
				case '<strike/>': font.strike = 1; break;
				case '</strike>': break;
	
				/* 18.4.13 u CT_UnderlineProperty */
				case '<u':
					if(!y.val) break;
					switch(y.val) {
						case 'double': font.uval = "double"; break;
						case 'singleAccounting': font.uval = "single-accounting"; break;
						case 'doubleAccounting': font.uval = "double-accounting"; break;
					}
					/* falls through */
				case '<u>':
				case '<u/>': font.u = 1; break;
				case '</u>': break;
	
				/* 18.8.2 b */
				case '<b':
					if(y.val == '0') break;
					/* falls through */
				case '<b>':
				case '<b/>': font.b = 1; break;
				case '</b>': break;
	
				/* 18.8.26 i */
				case '<i':
					if(y.val == '0') break;
					/* falls through */
				case '<i>':
				case '<i/>': font.i = 1; break;
				case '</i>': break;
	
				/* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */
				case '<color':
					if(y.rgb) font.color = y.rgb.slice(2,8);
					break;
				case '<color>': case '<color/>': case '</color>': break;
	
				/* 18.8.18 family ST_FontFamily */
				case '<family': font.family = y.val; break;
				case '<family>': case '<family/>': case '</family>': break;
	
				/* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */
				case '<vertAlign': font.valign = y.val; break;
				case '<vertAlign>': case '<vertAlign/>': case '</vertAlign>': break;
	
				/* 18.8.35 scheme CT_FontScheme TODO */
				case '<scheme': break;
				case '<scheme>': case '<scheme/>': case '</scheme>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default:
					if(y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
			}
		}
		return font;
	}
	
	var parse_rs = (function() {
		var tregex = matchtag("t"), rpregex = matchtag("rPr");
		/* 18.4.4 r CT_RElt */
		function parse_r(r) {
			/* 18.4.12 t ST_Xstring */
			var t = r.match(tregex)/*, cp = 65001*/;
			if(!t) return {t:"s", v:""};
	
			var o = ({t:'s', v:unescapexml(t[1])});
			var rpr = r.match(rpregex);
			if(rpr) o.s = parse_rpr(rpr[1]);
			return o;
		}
		var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
		return function parse_rs(rs) {
			return rs.replace(rregex,"").split(rend).map(parse_r).filter(function(r) { return r.v; });
		};
	})();
	
	
	/* Parse a list of <r> tags */
	var rs_to_html = (function parse_rs_factory() {
		var nlregex = /(\r\n|\n)/g;
		function parse_rpr2(font, intro, outro) {
			var style = [];
	
			if(font.u) style.push("text-decoration: underline;");
			if(font.uval) style.push("text-underline-style:" + font.uval + ";");
			if(font.sz) style.push("font-size:" + font.sz + "pt;");
			if(font.outline) style.push("text-effect: outline;");
			if(font.shadow) style.push("text-shadow: auto;");
			intro.push('<span style="' + style.join("") + '">');
	
			if(font.b) { intro.push("<b>"); outro.push("</b>"); }
			if(font.i) { intro.push("<i>"); outro.push("</i>"); }
			if(font.strike) { intro.push("<s>"); outro.push("</s>"); }
	
			var align = font.valign || "";
			if(align == "superscript" || align == "super") align = "sup";
			else if(align == "subscript") align = "sub";
			if(align != "") { intro.push("<" + align + ">"); outro.push("</" + align + ">"); }
	
			outro.push("</span>");
			return font;
		}
	
		/* 18.4.4 r CT_RElt */
		function r_to_html(r) {
			var terms = [[],r.v,[]];
			if(!r.v) return "";
	
			if(r.s) parse_rpr2(r.s, terms[0], terms[2]);
	
			return terms[0].join("") + terms[1].replace(nlregex,'<br/>') + terms[2].join("");
		}
	
		return function parse_rs(rs) {
			return rs.map(r_to_html).join("");
		};
	})();
	
	/* 18.4.8 si CT_Rst */
	var sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, sirregex = /<(?:\w+:)?r>/;
	var sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
	function parse_si(x, opts) {
		var html = opts ? opts.cellHTML : true;
		var z = {};
		if(!x) return { t: "" };
		//var y;
		/* 18.4.12 t ST_Xstring (Plaintext String) */
		// TODO: is whitespace actually valid here?
		if(x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
			z.t = unescapexml(utf8read(x.slice(x.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));
			z.r = utf8read(x);
			if(html) z.h = escapehtml(z.t);
		}
		/* 18.4.4 r CT_RElt (Rich Text Run) */
		else if((/*y = */x.match(sirregex))) {
			z.r = utf8read(x);
			z.t = unescapexml(utf8read((x.replace(sirphregex, '').match(sitregex)||[]).join("").replace(tagregex,"")));
			if(html) z.h = rs_to_html(parse_rs(z.r));
		}
		/* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */
		/* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */
		return z;
	}
	
	/* 18.4 Shared String Table */
	var sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
	var sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
	var sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
	function parse_sst_xml(data, opts) {
		var s = ([]), ss = "";
		if(!data) return s;
		/* 18.4.9 sst CT_Sst */
		var sst = data.match(sstr0);
		if(sst) {
			ss = sst[2].replace(sstr1,"").split(sstr2);
			for(var i = 0; i != ss.length; ++i) {
				var o = parse_si(ss[i].trim(), opts);
				if(o != null) s[s.length] = o;
			}
			sst = parsexmltag(sst[1]); s.Count = sst.count; s.Unique = sst.uniqueCount;
		}
		return s;
	}
	
	var straywsregex = /^\s|\s$|[\t\n\r]/;
	function write_sst_xml(sst, opts) {
		if(!opts.bookSST) return "";
		var o = [XML_HEADER];
		o[o.length] = (writextag('sst', null, {
			xmlns: XMLNS_main[0],
			count: sst.Count,
			uniqueCount: sst.Unique
		}));
		for(var i = 0; i != sst.length; ++i) { if(sst[i] == null) continue;
			var s = sst[i];
			var sitag = "<si>";
			if(s.r) sitag += s.r;
			else {
				sitag += "<t";
				if(!s.t) s.t = "";
				if(s.t.match(straywsregex)) sitag += ' xml:space="preserve"';
				sitag += ">" + escapexml(s.t) + "</t>";
			}
			sitag += "</si>";
			o[o.length] = (sitag);
		}
		if(o.length>2){ o[o.length] = ('</sst>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.221 BrtBeginSst */
	function parse_BrtBeginSst(data) {
		return [data.read_shift(4), data.read_shift(4)];
	}
	
	/* [MS-XLSB] 2.1.7.45 Shared Strings */
	function parse_sst_bin(data, opts) {
		var s = ([]);
		var pass = false;
		recordhopper(data, function hopper_sst(val, R, RT) {
			switch(RT) {
				case 0x009F: /* BrtBeginSst */
					s.Count = val[0]; s.Unique = val[1]; break;
				case 0x0013: /* BrtSSTItem */
					s.push(val); break;
				case 0x00A0: /* BrtEndSst */
					return true;
	
				case 0x0023: /* BrtFRTBegin */
					pass = true; break;
				case 0x0024: /* BrtFRTEnd */
					pass = false; break;
	
				default:
					if(R.T){}
					if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		});
		return s;
	}
	
	function write_BrtBeginSst(sst, o) {
		if(!o) o = new_buf(8);
		o.write_shift(4, sst.Count);
		o.write_shift(4, sst.Unique);
		return o;
	}
	
	var write_BrtSSTItem = write_RichStr;
	
	function write_sst_bin(sst) {
		var ba = buf_array();
		write_record(ba, 0x009F /* BrtBeginSst */, write_BrtBeginSst(sst));
		for(var i = 0; i < sst.length; ++i) write_record(ba, 0x0013 /* BrtSSTItem */, write_BrtSSTItem(sst[i]));
		/* FRTSST */
		write_record(ba, 0x00A0 /* BrtEndSst */);
		return ba.end();
	}
	function _JS2ANSI(str) {
		if(typeof $cptable !== 'undefined') return $cptable.utils.encode(current_ansi, str);
		var o = [], oo = str.split("");
		for(var i = 0; i < oo.length; ++i) o[i] = oo[i].charCodeAt(0);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.4 Version */
	function parse_CRYPTOVersion(blob, length) {
		var o = {};
		o.Major = blob.read_shift(2);
		o.Minor = blob.read_shift(2);
	if(length >= 4) blob.l += length - 4;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */
	function parse_DataSpaceVersionInfo(blob) {
		var o = {};
		o.id = blob.read_shift(0, 'lpp4');
		o.R = parse_CRYPTOVersion(blob, 4);
		o.U = parse_CRYPTOVersion(blob, 4);
		o.W = parse_CRYPTOVersion(blob, 4);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */
	function parse_DataSpaceMapEntry(blob) {
		var len = blob.read_shift(4);
		var end = blob.l + len - 4;
		var o = {};
		var cnt = blob.read_shift(4);
		var comps = [];
		/* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */
		while(cnt-- > 0) comps.push({ t: blob.read_shift(4), v: blob.read_shift(0, 'lpp4') });
		o.name = blob.read_shift(0, 'lpp4');
		o.comps = comps;
		if(blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */
	function parse_DataSpaceMap(blob) {
		var o = [];
		blob.l += 4; // must be 0x8
		var cnt = blob.read_shift(4);
		while(cnt-- > 0) o.push(parse_DataSpaceMapEntry(blob));
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */
	function parse_DataSpaceDefinition(blob) {
		var o = [];
		blob.l += 4; // must be 0x8
		var cnt = blob.read_shift(4);
		while(cnt-- > 0) o.push(blob.read_shift(0, 'lpp4'));
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */
	function parse_TransformInfoHeader(blob) {
		var o = {};
		/*var len = */blob.read_shift(4);
		blob.l += 4; // must be 0x1
		o.id = blob.read_shift(0, 'lpp4');
		o.name = blob.read_shift(0, 'lpp4');
		o.R = parse_CRYPTOVersion(blob, 4);
		o.U = parse_CRYPTOVersion(blob, 4);
		o.W = parse_CRYPTOVersion(blob, 4);
		return o;
	}
	
	function parse_Primary(blob) {
		/* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */
		var hdr = parse_TransformInfoHeader(blob);
		/* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */
		hdr.ename = blob.read_shift(0, '8lpp4');
		hdr.blksz = blob.read_shift(4);
		hdr.cmode = blob.read_shift(4);
		if(blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
		return hdr;
	}
	
	/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */
	function parse_EncryptionHeader(blob, length) {
		var tgt = blob.l + length;
		var o = {};
		o.Flags = (blob.read_shift(4) & 0x3F);
		blob.l += 4;
		o.AlgID = blob.read_shift(4);
		var valid = false;
		switch(o.AlgID) {
			case 0x660E: case 0x660F: case 0x6610: valid = (o.Flags == 0x24); break;
			case 0x6801: valid = (o.Flags == 0x04); break;
			case 0: valid = (o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24); break;
			default: throw 'Unrecognized encryption algorithm: ' + o.AlgID;
		}
		if(!valid) throw new Error("Encryption Flags/AlgID mismatch");
		o.AlgIDHash = blob.read_shift(4);
		o.KeySize = blob.read_shift(4);
		o.ProviderType = blob.read_shift(4);
		blob.l += 8;
		o.CSPName = blob.read_shift((tgt-blob.l)>>1, 'utf16le');
		blob.l = tgt;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */
	function parse_EncryptionVerifier(blob, length) {
		var o = {}, tgt = blob.l + length;
		blob.l += 4; // SaltSize must be 0x10
		o.Salt = blob.slice(blob.l, blob.l+16); blob.l += 16;
		o.Verifier = blob.slice(blob.l, blob.l+16); blob.l += 16;
		/*var sz = */blob.read_shift(4);
		o.VerifierHash = blob.slice(blob.l, tgt); blob.l = tgt;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */
	function parse_EncryptionInfo(blob) {
		var vers = parse_CRYPTOVersion(blob);
		switch(vers.Minor) {
			case 0x02: return [vers.Minor, parse_EncInfoStd(blob, vers)];
			case 0x03: return [vers.Minor, parse_EncInfoExt(blob, vers)];
			case 0x04: return [vers.Minor, parse_EncInfoAgl(blob, vers)];
		}
		throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
	}
	
	/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */
	function parse_EncInfoStd(blob) {
		var flags = blob.read_shift(4);
		if((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
		var sz = blob.read_shift(4);
		//var tgt = blob.l + sz;
		var hdr = parse_EncryptionHeader(blob, sz);
		var verifier = parse_EncryptionVerifier(blob, blob.length - blob.l);
		return { t:"Std", h:hdr, v:verifier };
	}
	/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */
	function parse_EncInfoExt() { throw new Error("File is password-protected: ECMA-376 Extensible"); }
	/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */
	function parse_EncInfoAgl(blob) {
		var KeyData = ["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];
		blob.l+=4;
		var xml = blob.read_shift(blob.length - blob.l, 'utf8');
		var o = {};
		xml.replace(tagregex, function xml_agile(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
				case '<encryption': case '</encryption>': break;
				case '<keyData': KeyData.forEach(function(k) { o[k] = y[k]; }); break;
				case '<dataIntegrity': o.encryptedHmacKey = y.encryptedHmacKey; o.encryptedHmacValue = y.encryptedHmacValue; break;
				case '<keyEncryptors>': case '<keyEncryptors': o.encs = []; break;
				case '</keyEncryptors>': break;
	
				case '<keyEncryptor': o.uri = y.uri; break;
				case '</keyEncryptor>': break;
				case '<encryptedKey': o.encs.push(y); break;
				default: throw y[0];
			}
		});
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */
	function parse_RC4CryptoHeader(blob, length) {
		var o = {};
		var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4); length -= 4;
		if(vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
		if(vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
		o.Flags = blob.read_shift(4); length -= 4;
		var sz = blob.read_shift(4); length -= 4;
		o.EncryptionHeader = parse_EncryptionHeader(blob, sz); length -= sz;
		o.EncryptionVerifier = parse_EncryptionVerifier(blob, length);
		return o;
	}
	/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */
	function parse_RC4Header(blob) {
		var o = {};
		var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4);
		if(vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
		o.Salt = blob.read_shift(16);
		o.EncryptedVerifier = blob.read_shift(16);
		o.EncryptedVerifierHash = blob.read_shift(16);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */
	function crypto_CreatePasswordVerifier_Method1(Password) {
		var Verifier = 0x0000, PasswordArray;
		var PasswordDecoded = _JS2ANSI(Password);
		var len = PasswordDecoded.length + 1, i, PasswordByte;
		var Intermediate1, Intermediate2, Intermediate3;
		PasswordArray = new_raw_buf(len);
		PasswordArray[0] = PasswordDecoded.length;
		for(i = 1; i != len; ++i) PasswordArray[i] = PasswordDecoded[i-1];
		for(i = len-1; i >= 0; --i) {
			PasswordByte = PasswordArray[i];
			Intermediate1 = ((Verifier & 0x4000) === 0x0000) ? 0 : 1;
			Intermediate2 = (Verifier << 1) & 0x7FFF;
			Intermediate3 = Intermediate1 | Intermediate2;
			Verifier = Intermediate3 ^ PasswordByte;
		}
		return Verifier ^ 0xCE4B;
	}
	
	/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */
	var crypto_CreateXorArray_Method1 = (function() {
		var PadArray = [0xBB, 0xFF, 0xFF, 0xBA, 0xFF, 0xFF, 0xB9, 0x80, 0x00, 0xBE, 0x0F, 0x00, 0xBF, 0x0F, 0x00];
		var InitialCode = [0xE1F0, 0x1D0F, 0xCC9C, 0x84C0, 0x110C, 0x0E10, 0xF1CE, 0x313E, 0x1872, 0xE139, 0xD40F, 0x84F9, 0x280C, 0xA96A, 0x4EC3];
		var XorMatrix = [0xAEFC, 0x4DD9, 0x9BB2, 0x2745, 0x4E8A, 0x9D14, 0x2A09, 0x7B61, 0xF6C2, 0xFDA5, 0xEB6B, 0xC6F7, 0x9DCF, 0x2BBF, 0x4563, 0x8AC6, 0x05AD, 0x0B5A, 0x16B4, 0x2D68, 0x5AD0, 0x0375, 0x06EA, 0x0DD4, 0x1BA8, 0x3750, 0x6EA0, 0xDD40, 0xD849, 0xA0B3, 0x5147, 0xA28E, 0x553D, 0xAA7A, 0x44D5, 0x6F45, 0xDE8A, 0xAD35, 0x4A4B, 0x9496, 0x390D, 0x721A, 0xEB23, 0xC667, 0x9CEF, 0x29FF, 0x53FE, 0xA7FC, 0x5FD9, 0x47D3, 0x8FA6, 0x0F6D, 0x1EDA, 0x3DB4, 0x7B68, 0xF6D0, 0xB861, 0x60E3, 0xC1C6, 0x93AD, 0x377B, 0x6EF6, 0xDDEC, 0x45A0, 0x8B40, 0x06A1, 0x0D42, 0x1A84, 0x3508, 0x6A10, 0xAA51, 0x4483, 0x8906, 0x022D, 0x045A, 0x08B4, 0x1168, 0x76B4, 0xED68, 0xCAF1, 0x85C3, 0x1BA7, 0x374E, 0x6E9C, 0x3730, 0x6E60, 0xDCC0, 0xA9A1, 0x4363, 0x86C6, 0x1DAD, 0x3331, 0x6662, 0xCCC4, 0x89A9, 0x0373, 0x06E6, 0x0DCC, 0x1021, 0x2042, 0x4084, 0x8108, 0x1231, 0x2462, 0x48C4];
		var Ror = function(Byte) { return ((Byte/2) | (Byte*128)) & 0xFF; };
		var XorRor = function(byte1, byte2) { return Ror(byte1 ^ byte2); };
		var CreateXorKey_Method1 = function(Password) {
			var XorKey = InitialCode[Password.length - 1];
			var CurrentElement = 0x68;
			for(var i = Password.length-1; i >= 0; --i) {
				var Char = Password[i];
				for(var j = 0; j != 7; ++j) {
					if(Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
					Char *= 2; --CurrentElement;
				}
			}
			return XorKey;
		};
		return function(password) {
			var Password = _JS2ANSI(password);
			var XorKey = CreateXorKey_Method1(Password);
			var Index = Password.length;
			var ObfuscationArray = new_raw_buf(16);
			for(var i = 0; i != 16; ++i) ObfuscationArray[i] = 0x00;
			var Temp, PasswordLastChar, PadIndex;
			if((Index & 1) === 1) {
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
				--Index;
				Temp = XorKey & 0xFF;
				PasswordLastChar = Password[Password.length - 1];
				ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
			}
			while(Index > 0) {
				--Index;
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
				--Index;
				Temp = XorKey & 0xFF;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
			}
			Index = 15;
			PadIndex = 15 - Password.length;
			while(PadIndex > 0) {
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
				--Index;
				--PadIndex;
				Temp = XorKey & 0xFF;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
				--Index;
				--PadIndex;
			}
			return ObfuscationArray;
		};
	})();
	
	/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */
	var crypto_DecryptData_Method1 = function(password, Data, XorArrayIndex, XorArray, O) {
		/* If XorArray is set, use it; if O is not set, make changes in-place */
		if(!O) O = Data;
		if(!XorArray) XorArray = crypto_CreateXorArray_Method1(password);
		var Index, Value;
		for(Index = 0; Index != Data.length; ++Index) {
			Value = Data[Index];
			Value ^= XorArray[XorArrayIndex];
			Value = ((Value>>5) | (Value<<3)) & 0xFF;
			O[Index] = Value;
			++XorArrayIndex;
		}
		return [O, XorArrayIndex, XorArray];
	};
	
	var crypto_MakeXorDecryptor = function(password) {
		var XorArrayIndex = 0, XorArray = crypto_CreateXorArray_Method1(password);
		return function(Data) {
			var O = crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
			XorArrayIndex = O[1];
			return O[0];
		};
	};
	
	/* 2.5.343 */
	function parse_XORObfuscation(blob, length, opts, out) {
		var o = ({ key: parseuint16(blob), verificationBytes: parseuint16(blob) });
		if(opts.password) o.verifier = crypto_CreatePasswordVerifier_Method1(opts.password);
		out.valid = o.verificationBytes === o.verifier;
		if(out.valid) out.insitu = crypto_MakeXorDecryptor(opts.password);
		return o;
	}
	
	/* 2.4.117 */
	function parse_FilePassHeader(blob, length, oo) {
		var o = oo || {}; o.Info = blob.read_shift(2); blob.l -= 2;
		if(o.Info === 1) o.Data = parse_RC4Header(blob, length);
		else o.Data = parse_RC4CryptoHeader(blob, length);
		return o;
	}
	function parse_FilePass(blob, length, opts) {
		var o = ({ Type: opts.biff >= 8 ? blob.read_shift(2) : 0 }); /* wEncryptionType */
		if(o.Type) parse_FilePassHeader(blob, length-2, o);
		else parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
		return o;
	}
	
	
	var RTF = (function() {
		function rtf_to_sheet(d, opts) {
			switch(opts.type) {
				case 'base64': return rtf_to_sheet_str(Base64_decode(d), opts);
				case 'binary': return rtf_to_sheet_str(d, opts);
				case 'buffer': return rtf_to_sheet_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
				case 'array':  return rtf_to_sheet_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
	
		/* TODO: this is a stub */
		function rtf_to_sheet_str(str, opts) {
			var o = opts || {};
			var ws = o.dense ? ([]) : ({});
	
			var rows = str.match(/\\trowd.*?\\row\b/g);
			if(!rows.length) throw new Error("RTF missing table");
			var range = ({s: {c:0, r:0}, e: {c:0, r:rows.length - 1}});
			rows.forEach(function(rowtf, R) {
				if(Array.isArray(ws)) ws[R] = [];
				var rtfre = /\\\w+\b/g;
				var last_index = 0;
				var res;
				var C = -1;
				while((res = rtfre.exec(rowtf))) {
					switch(res[0]) {
						case "\\cell":
							var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
							if(data[0] == " ") data = data.slice(1);
							++C;
							if(data.length) {
								// TODO: value parsing, including codepage adjustments
								var cell = {v: data, t:"s"};
								if(Array.isArray(ws)) ws[R][C] = cell;
								else ws[encode_cell({r:R, c:C})] = cell;
							}
							break;
					}
					last_index = rtfre.lastIndex;
				}
				if(C > range.e.c) range.e.c = C;
			});
			ws['!ref'] = encode_range(range);
			return ws;
		}
	
		function rtf_to_workbook(d, opts) { return sheet_to_workbook(rtf_to_sheet(d, opts), opts); }
	
		/* TODO: this is a stub */
		function sheet_to_rtf(ws) {
			var o = ["{\\rtf1\\ansi"];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				o.push("\\trowd\\trautofit1");
				for(var C = r.s.c; C <= r.e.c; ++C) o.push("\\cellx" + (C+1));
				o.push("\\pard\\intbl");
				for(C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C]: ws[coord];
					if(!cell || cell.v == null && (!cell.f || cell.F)) continue;
					o.push(" " + (cell.w || (format_cell(cell), cell.w)));
					o.push("\\cell");
				}
				o.push("\\pard\\intbl\\row");
			}
			return o.join("") + "}";
		}
	
		return {
			to_workbook: rtf_to_workbook,
			to_sheet: rtf_to_sheet,
			from_sheet: sheet_to_rtf
		};
	})();
	function hex2RGB(h) {
		var o = h.slice(h[0]==="#"?1:0).slice(0,6);
		return [parseInt(o.slice(0,2),16),parseInt(o.slice(2,4),16),parseInt(o.slice(4,6),16)];
	}
	function rgb2Hex(rgb) {
		for(var i=0,o=1; i!=3; ++i) o = o*256 + (rgb[i]>255?255:rgb[i]<0?0:rgb[i]);
		return o.toString(16).toUpperCase().slice(1);
	}
	
	function rgb2HSL(rgb) {
		var R = rgb[0]/255, G = rgb[1]/255, B=rgb[2]/255;
		var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
		if(C === 0) return [0, 0, R];
	
		var H6 = 0, S = 0, L2 = (M + m);
		S = C / (L2 > 1 ? 2 - L2 : L2);
		switch(M){
			case R: H6 = ((G - B) / C + 6)%6; break;
			case G: H6 = ((B - R) / C + 2); break;
			case B: H6 = ((R - G) / C + 4); break;
		}
		return [H6 / 6, S, L2 / 2];
	}
	
	function hsl2RGB(hsl){
		var H = hsl[0], S = hsl[1], L = hsl[2];
		var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C/2;
		var rgb = [m,m,m], h6 = 6*H;
	
		var X;
		if(S !== 0) switch(h6|0) {
			case 0: case 6: X = C * h6; rgb[0] += C; rgb[1] += X; break;
			case 1: X = C * (2 - h6);   rgb[0] += X; rgb[1] += C; break;
			case 2: X = C * (h6 - 2);   rgb[1] += C; rgb[2] += X; break;
			case 3: X = C * (4 - h6);   rgb[1] += X; rgb[2] += C; break;
			case 4: X = C * (h6 - 4);   rgb[2] += C; rgb[0] += X; break;
			case 5: X = C * (6 - h6);   rgb[2] += X; rgb[0] += C; break;
		}
		for(var i = 0; i != 3; ++i) rgb[i] = Math.round(rgb[i]*255);
		return rgb;
	}
	
	/* 18.8.3 bgColor tint algorithm */
	function rgb_tint(hex, tint) {
		if(tint === 0) return hex;
		var hsl = rgb2HSL(hex2RGB(hex));
		if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
		else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
		return rgb2Hex(hsl2RGB(hsl));
	}
	
	/* 18.3.1.13 width calculations */
	/* [MS-OI29500] 2.1.595 Column Width & Formatting */
	var DEF_MDW = 6, MAX_MDW = 15, MIN_MDW = 1, MDW = DEF_MDW;
	function width2px(width) { return Math.floor(( width + (Math.round(128/MDW))/256 )* MDW ); }
	function px2char(px) { return (Math.floor((px - 5)/MDW * 100 + 0.5))/100; }
	function char2width(chr) { return (Math.round((chr * MDW + 5)/MDW*256))/256; }
	//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
	//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
	function cycle_width(collw) { return char2width(px2char(width2px(collw))); }
	/* XLSX/XLSB/XLS specify width in units of MDW */
	function find_mdw_colw(collw) {
		var delta = Math.abs(collw - cycle_width(collw)), _MDW = MDW;
		if(delta > 0.005) for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) if(Math.abs(collw - cycle_width(collw)) <= delta) { delta = Math.abs(collw - cycle_width(collw)); _MDW = MDW; }
		MDW = _MDW;
	}
	/* XLML specifies width in terms of pixels */
	/*function find_mdw_wpx(wpx) {
		var delta = Infinity, guess = 0, _MDW = MIN_MDW;
		for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
			guess = char2width_(px2char_(wpx))*256;
			guess = (guess) % 1;
			if(guess > 0.5) guess--;
			if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
		}
		MDW = _MDW;
	}*/
	
	function process_col(coll) {
		if(coll.width) {
			coll.wpx = width2px(coll.width);
			coll.wch = px2char(coll.wpx);
			coll.MDW = MDW;
		} else if(coll.wpx) {
			coll.wch = px2char(coll.wpx);
			coll.width = char2width(coll.wch);
			coll.MDW = MDW;
		} else if(typeof coll.wch == 'number') {
			coll.width = char2width(coll.wch);
			coll.wpx = width2px(coll.width);
			coll.MDW = MDW;
		}
		if(coll.customWidth) delete coll.customWidth;
	}
	
	var DEF_PPI = 96, PPI = DEF_PPI;
	function px2pt(px) { return px * 96 / PPI; }
	function pt2px(pt) { return pt * PPI / 96; }
	
	/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */
	var XLMLPatternTypeMap = {
		"None": "none",
		"Solid": "solid",
		"Gray50": "mediumGray",
		"Gray75": "darkGray",
		"Gray25": "lightGray",
		"HorzStripe": "darkHorizontal",
		"VertStripe": "darkVertical",
		"ReverseDiagStripe": "darkDown",
		"DiagStripe": "darkUp",
		"DiagCross": "darkGrid",
		"ThickDiagCross": "darkTrellis",
		"ThinHorzStripe": "lightHorizontal",
		"ThinVertStripe": "lightVertical",
		"ThinReverseDiagStripe": "lightDown",
		"ThinHorzCross": "lightGrid"
	};
	
	/* 18.8.5 borders CT_Borders */
	function parse_borders(t, styles, themes, opts) {
		styles.Borders = [];
		var border = {};
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<borders': case '<borders>': case '</borders>': break;
	
				/* 18.8.4 border CT_Border */
				case '<border': case '<border>': case '<border/>':
					border = {};
					if(y.diagonalUp) border.diagonalUp = parsexmlbool(y.diagonalUp);
					if(y.diagonalDown) border.diagonalDown = parsexmlbool(y.diagonalDown);
					styles.Borders.push(border);
					break;
				case '</border>': break;
	
				/* note: not in spec, appears to be CT_BorderPr */
				case '<left/>': break;
				case '<left': case '<left>': break;
				case '</left>': break;
	
				/* note: not in spec, appears to be CT_BorderPr */
				case '<right/>': break;
				case '<right': case '<right>': break;
				case '</right>': break;
	
				/* 18.8.43 top CT_BorderPr */
				case '<top/>': break;
				case '<top': case '<top>': break;
				case '</top>': break;
	
				/* 18.8.6 bottom CT_BorderPr */
				case '<bottom/>': break;
				case '<bottom': case '<bottom>': break;
				case '</bottom>': break;
	
				/* 18.8.13 diagonal CT_BorderPr */
				case '<diagonal': case '<diagonal>': case '<diagonal/>': break;
				case '</diagonal>': break;
	
				/* 18.8.25 horizontal CT_BorderPr */
				case '<horizontal': case '<horizontal>': case '<horizontal/>': break;
				case '</horizontal>': break;
	
				/* 18.8.44 vertical CT_BorderPr */
				case '<vertical': case '<vertical>': case '<vertical/>': break;
				case '</vertical>': break;
	
				/* 18.8.37 start CT_BorderPr */
				case '<start': case '<start>': case '<start/>': break;
				case '</start>': break;
	
				/* 18.8.16 end CT_BorderPr */
				case '<end': case '<end>': case '<end/>': break;
				case '</end>': break;
	
				/* 18.8.? color CT_Color */
				case '<color': case '<color>':
					break;
				case '<color/>': case '</color>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
				}
			}
		});
	}
	
	/* 18.8.21 fills CT_Fills */
	function parse_fills(t, styles, themes, opts) {
		styles.Fills = [];
		var fill = {};
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<fills': case '<fills>': case '</fills>': break;
	
				/* 18.8.20 fill CT_Fill */
				case '<fill>': case '<fill': case '<fill/>':
					fill = {}; styles.Fills.push(fill); break;
				case '</fill>': break;
	
				/* 18.8.24 gradientFill CT_GradientFill */
				case '<gradientFill>': break;
				case '<gradientFill':
				case '</gradientFill>': styles.Fills.push(fill); fill = {}; break;
	
				/* 18.8.32 patternFill CT_PatternFill */
				case '<patternFill': case '<patternFill>':
					if(y.patternType) fill.patternType = y.patternType;
					break;
				case '<patternFill/>': case '</patternFill>': break;
	
				/* 18.8.3 bgColor CT_Color */
				case '<bgColor':
					if(!fill.bgColor) fill.bgColor = {};
					if(y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
					if(y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
					if(y.tint) fill.bgColor.tint = parseFloat(y.tint);
					/* Excel uses ARGB strings */
					if(y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
					break;
				case '<bgColor/>': case '</bgColor>': break;
	
				/* 18.8.19 fgColor CT_Color */
				case '<fgColor':
					if(!fill.fgColor) fill.fgColor = {};
					if(y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
					if(y.tint) fill.fgColor.tint = parseFloat(y.tint);
					/* Excel uses ARGB strings */
					if(y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
					break;
				case '<fgColor/>': case '</fgColor>': break;
	
				/* 18.8.38 stop CT_GradientStop */
				case '<stop': case '<stop/>': break;
				case '</stop>': break;
	
				/* 18.8.? color CT_Color */
				case '<color': case '<color/>': break;
				case '</color>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
				}
			}
		});
	}
	
	/* 18.8.23 fonts CT_Fonts */
	function parse_fonts(t, styles, themes, opts) {
		styles.Fonts = [];
		var font = {};
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<fonts': case '<fonts>': case '</fonts>': break;
	
				/* 18.8.22 font CT_Font */
				case '<font': case '<font>': break;
				case '</font>': case '<font/>':
					styles.Fonts.push(font);
					font = {};
					break;
	
				/* 18.8.29 name CT_FontName */
				case '<name': if(y.val) font.name = utf8read(y.val); break;
				case '<name/>': case '</name>': break;
	
				/* 18.8.2  b CT_BooleanProperty */
				case '<b': font.bold = y.val ? parsexmlbool(y.val) : 1; break;
				case '<b/>': font.bold = 1; break;
	
				/* 18.8.26 i CT_BooleanProperty */
				case '<i': font.italic = y.val ? parsexmlbool(y.val) : 1; break;
				case '<i/>': font.italic = 1; break;
	
				/* 18.4.13 u CT_UnderlineProperty */
				case '<u':
					switch(y.val) {
						case "none": font.underline = 0x00; break;
						case "single": font.underline = 0x01; break;
						case "double": font.underline = 0x02; break;
						case "singleAccounting": font.underline = 0x21; break;
						case "doubleAccounting": font.underline = 0x22; break;
					} break;
				case '<u/>': font.underline = 1; break;
	
				/* 18.4.10 strike CT_BooleanProperty */
				case '<strike': font.strike = y.val ? parsexmlbool(y.val) : 1; break;
				case '<strike/>': font.strike = 1; break;
	
				/* 18.4.2  outline CT_BooleanProperty */
				case '<outline': font.outline = y.val ? parsexmlbool(y.val) : 1; break;
				case '<outline/>': font.outline = 1; break;
	
				/* 18.8.36 shadow CT_BooleanProperty */
				case '<shadow': font.shadow = y.val ? parsexmlbool(y.val) : 1; break;
				case '<shadow/>': font.shadow = 1; break;
	
				/* 18.8.12 condense CT_BooleanProperty */
				case '<condense': font.condense = y.val ? parsexmlbool(y.val) : 1; break;
				case '<condense/>': font.condense = 1; break;
	
				/* 18.8.17 extend CT_BooleanProperty */
				case '<extend': font.extend = y.val ? parsexmlbool(y.val) : 1; break;
				case '<extend/>': font.extend = 1; break;
	
				/* 18.4.11 sz CT_FontSize */
				case '<sz': if(y.val) font.sz = +y.val; break;
				case '<sz/>': case '</sz>': break;
	
				/* 18.4.14 vertAlign CT_VerticalAlignFontProperty */
				case '<vertAlign': if(y.val) font.vertAlign = y.val; break;
				case '<vertAlign/>': case '</vertAlign>': break;
	
				/* 18.8.18 family CT_FontFamily */
				case '<family': if(y.val) font.family = parseInt(y.val,10); break;
				case '<family/>': case '</family>': break;
	
				/* 18.8.35 scheme CT_FontScheme */
				case '<scheme': if(y.val) font.scheme = y.val; break;
				case '<scheme/>': case '</scheme>': break;
	
				/* 18.4.1 charset CT_IntProperty */
				case '<charset':
					if(y.val == '1') break;
					y.codepage = CS2CP[parseInt(y.val, 10)];
					break;
	
				/* 18.?.? color CT_Color */
				case '<color':
					if(!font.color) font.color = {};
					if(y.auto) font.color.auto = parsexmlbool(y.auto);
	
					if(y.rgb) font.color.rgb = y.rgb.slice(-6);
					else if(y.indexed) {
						font.color.index = parseInt(y.indexed, 10);
						var icv = XLSIcv[font.color.index];
						if(font.color.index == 81) icv = XLSIcv[1];
						if(!icv) icv = XLSIcv[1]; //throw new Error(x); // note: 206 is valid
						font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
					} else if(y.theme) {
						font.color.theme = parseInt(y.theme, 10);
						if(y.tint) font.color.tint = parseFloat(y.tint);
						if(y.theme && themes.themeElements && themes.themeElements.clrScheme) {
							font.color.rgb = rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
						}
					}
	
					break;
				case '<color/>': case '</color>': break;
	
				/* note: sometimes mc:AlternateContent appears bare */
				case '<AlternateContent': pass = true; break;
				case '</AlternateContent>': pass = false; break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
				}
			}
		});
	}
	
	/* 18.8.31 numFmts CT_NumFmts */
	function parse_numFmts(t, styles, opts) {
		styles.NumberFmt = [];
		var k/*Array<number>*/ = (keys(table_fmt));
		for(var i=0; i < k.length; ++i) styles.NumberFmt[k[i]] = table_fmt[k[i]];
		var m = t[0].match(tagregex);
		if(!m) return;
		for(i=0; i < m.length; ++i) {
			var y = parsexmltag(m[i]);
			switch(strip_ns(y[0])) {
				case '<numFmts': case '</numFmts>': case '<numFmts/>': case '<numFmts>': break;
				case '<numFmt': {
					var f=unescapexml(utf8read(y.formatCode)), j=parseInt(y.numFmtId,10);
					styles.NumberFmt[j] = f;
					if(j>0) {
						if(j > 0x188) {
							for(j = 0x188; j > 0x3c; --j) if(styles.NumberFmt[j] == null) break;
							styles.NumberFmt[j] = f;
						}
						SSF_load(f,j);
					}
				} break;
				case '</numFmt>': break;
				default: if(opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
			}
		}
	}
	
	function write_numFmts(NF) {
		var o = ["<numFmts>"];
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
			for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) o[o.length] = (writextag('numFmt',null,{numFmtId:i,formatCode:escapexml(NF[i])}));
		});
		if(o.length === 1) return "";
		o[o.length] = ("</numFmts>");
		o[0] = writextag('numFmts', null, { count:o.length-2 }).replace("/>", ">");
		return o.join("");
	}
	
	/* 18.8.10 cellXfs CT_CellXfs */
	var cellXF_uint = [ "numFmtId", "fillId", "fontId", "borderId", "xfId" ];
	var cellXF_bool = [ "applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix" ];
	function parse_cellXfs(t, styles, opts) {
		styles.CellXf = [];
		var xf;
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x), i = 0;
			switch(strip_ns(y[0])) {
				case '<cellXfs': case '<cellXfs>': case '<cellXfs/>': case '</cellXfs>': break;
	
				/* 18.8.45 xf CT_Xf */
				case '<xf': case '<xf/>':
					xf = y;
					delete xf[0];
					for(i = 0; i < cellXF_uint.length; ++i) if(xf[cellXF_uint[i]])
						xf[cellXF_uint[i]] = parseInt(xf[cellXF_uint[i]], 10);
					for(i = 0; i < cellXF_bool.length; ++i) if(xf[cellXF_bool[i]])
						xf[cellXF_bool[i]] = parsexmlbool(xf[cellXF_bool[i]]);
					if(styles.NumberFmt && xf.numFmtId > 0x188) {
						for(i = 0x188; i > 0x3c; --i) if(styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) { xf.numFmtId = i; break; }
					}
					styles.CellXf.push(xf); break;
				case '</xf>': break;
	
				/* 18.8.1 alignment CT_CellAlignment */
				case '<alignment': case '<alignment/>':
					var alignment = {};
					if(y.vertical) alignment.vertical = y.vertical;
					if(y.horizontal) alignment.horizontal = y.horizontal;
					if(y.textRotation != null) alignment.textRotation = y.textRotation;
					if(y.indent) alignment.indent = y.indent;
					if(y.wrapText) alignment.wrapText = parsexmlbool(y.wrapText);
					xf.alignment = alignment;
					break;
				case '</alignment>': break;
	
				/* 18.8.33 protection CT_CellProtection */
				case '<protection':
					break;
				case '</protection>': case '<protection/>': break;
	
				/* note: sometimes mc:AlternateContent appears bare */
				case '<AlternateContent': pass = true; break;
				case '</AlternateContent>': pass = false; break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
				}
			}
		});
	}
	
	function write_cellXfs(cellXfs) {
		var o = [];
		o[o.length] = (writextag('cellXfs',null));
		cellXfs.forEach(function(c) {
			o[o.length] = (writextag('xf', null, c));
		});
		o[o.length] = ("</cellXfs>");
		if(o.length === 2) return "";
		o[0] = writextag('cellXfs',null, {count:o.length-2}).replace("/>",">");
		return o.join("");
	}
	
	/* 18.8 Styles CT_Stylesheet*/
	var parse_sty_xml= (function make_pstyx() {
	var numFmtRegex = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;
	var cellXfRegex = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;
	var fillsRegex = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;
	var fontsRegex = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;
	var bordersRegex = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
	
	return function parse_sty_xml(data, themes, opts) {
		var styles = {};
		if(!data) return styles;
		data = data.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
		/* 18.8.39 styleSheet CT_Stylesheet */
		var t;
	
		/* 18.8.31 numFmts CT_NumFmts ? */
		if((t=data.match(numFmtRegex))) parse_numFmts(t, styles, opts);
	
		/* 18.8.23 fonts CT_Fonts ? */
		if((t=data.match(fontsRegex))) parse_fonts(t, styles, themes, opts);
	
		/* 18.8.21 fills CT_Fills ? */
		if((t=data.match(fillsRegex))) parse_fills(t, styles, themes, opts);
	
		/* 18.8.5  borders CT_Borders ? */
		if((t=data.match(bordersRegex))) parse_borders(t, styles, themes, opts);
	
		/* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */
		/* 18.8.8  cellStyles CT_CellStyles ? */
	
		/* 18.8.10 cellXfs CT_CellXfs ? */
		if((t=data.match(cellXfRegex))) parse_cellXfs(t, styles, opts);
	
		/* 18.8.15 dxfs CT_Dxfs ? */
		/* 18.8.42 tableStyles CT_TableStyles ? */
		/* 18.8.11 colors CT_Colors ? */
		/* 18.2.10 extLst CT_ExtensionList ? */
	
		return styles;
	};
	})();
	
	function write_sty_xml(wb, opts) {
		var o = [XML_HEADER, writextag('styleSheet', null, {
			'xmlns': XMLNS_main[0],
			'xmlns:vt': XMLNS.vt
		})], w;
		if(wb.SSF && (w = write_numFmts(wb.SSF)) != null) o[o.length] = w;
		o[o.length] = ('<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>');
		o[o.length] = ('<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>');
		o[o.length] = ('<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>');
		o[o.length] = ('<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>');
		if((w = write_cellXfs(opts.cellXfs))) o[o.length] = (w);
		o[o.length] = ('<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>');
		o[o.length] = ('<dxfs count="0"/>');
		o[o.length] = ('<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>');
	
		if(o.length>2){ o[o.length] = ('</styleSheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.657 BrtFmt */
	function parse_BrtFmt(data, length) {
		var numFmtId = data.read_shift(2);
		var stFmtCode = parse_XLWideString(data,length-2);
		return [numFmtId, stFmtCode];
	}
	function write_BrtFmt(i, f, o) {
		if(!o) o = new_buf(6 + 4 * f.length);
		o.write_shift(2, i);
		write_XLWideString(f, o);
		var out = (o.length > o.l) ? o.slice(0, o.l) : o;
		if(o.l == null) o.l = o.length;
		return out;
	}
	
	/* [MS-XLSB] 2.4.659 BrtFont TODO */
	function parse_BrtFont(data, length, opts) {
		var out = ({});
	
		out.sz = data.read_shift(2) / 20;
	
		var grbit = parse_FontFlags(data, 2, opts);
		if(grbit.fItalic) out.italic = 1;
		if(grbit.fCondense) out.condense = 1;
		if(grbit.fExtend) out.extend = 1;
		if(grbit.fShadow) out.shadow = 1;
		if(grbit.fOutline) out.outline = 1;
		if(grbit.fStrikeout) out.strike = 1;
	
		var bls = data.read_shift(2);
		if(bls === 0x02BC) out.bold = 1;
	
		switch(data.read_shift(2)) {
			/* case 0: out.vertAlign = "baseline"; break; */
			case 1: out.vertAlign = "superscript"; break;
			case 2: out.vertAlign = "subscript"; break;
		}
	
		var underline = data.read_shift(1);
		if(underline != 0) out.underline = underline;
	
		var family = data.read_shift(1);
		if(family > 0) out.family = family;
	
		var bCharSet = data.read_shift(1);
		if(bCharSet > 0) out.charset = bCharSet;
	
		data.l++;
		out.color = parse_BrtColor(data, 8);
	
		switch(data.read_shift(1)) {
			/* case 0: out.scheme = "none": break; */
			case 1: out.scheme = "major"; break;
			case 2: out.scheme = "minor"; break;
		}
	
		out.name = parse_XLWideString(data, length - 21);
	
		return out;
	}
	function write_BrtFont(font, o) {
		if(!o) o = new_buf(25+4*32);
		o.write_shift(2, font.sz * 20);
		write_FontFlags(font, o);
		o.write_shift(2, font.bold ? 0x02BC : 0x0190);
		var sss = 0;
		if(font.vertAlign == "superscript") sss = 1;
		else if(font.vertAlign == "subscript") sss = 2;
		o.write_shift(2, sss);
		o.write_shift(1, font.underline || 0);
		o.write_shift(1, font.family || 0);
		o.write_shift(1, font.charset || 0);
		o.write_shift(1, 0);
		write_BrtColor(font.color, o);
		var scheme = 0;
		if(font.scheme == "major") scheme = 1;
		if(font.scheme == "minor") scheme = 2;
		o.write_shift(1, scheme);
		write_XLWideString(font.name, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.650 BrtFill */
	var XLSBFillPTNames = [
		"none",
		"solid",
		"mediumGray",
		"darkGray",
		"lightGray",
		"darkHorizontal",
		"darkVertical",
		"darkDown",
		"darkUp",
		"darkGrid",
		"darkTrellis",
		"lightHorizontal",
		"lightVertical",
		"lightDown",
		"lightUp",
		"lightGrid",
		"lightTrellis",
		"gray125",
		"gray0625"
	];
	var rev_XLSBFillPTNames;
	/* TODO: gradient fill representation */
	var parse_BrtFill = parsenoop;
	function write_BrtFill(fill, o) {
		if(!o) o = new_buf(4*3 + 8*7 + 16*1);
		if(!rev_XLSBFillPTNames) rev_XLSBFillPTNames = (evert(XLSBFillPTNames));
		var fls = rev_XLSBFillPTNames[fill.patternType];
		if(fls == null) fls = 0x28;
		o.write_shift(4, fls);
		var j = 0;
		if(fls != 0x28) {
			/* TODO: custom FG Color */
			write_BrtColor({auto:1}, o);
			/* TODO: custom BG Color */
			write_BrtColor({auto:1}, o);
	
			for(; j < 12; ++j) o.write_shift(4, 0);
		} else {
			for(; j < 4; ++j) o.write_shift(4, 0);
	
			for(; j < 12; ++j) o.write_shift(4, 0); /* TODO */
			/* iGradientType */
			/* xnumDegree */
			/* xnumFillToLeft */
			/* xnumFillToRight */
			/* xnumFillToTop */
			/* xnumFillToBottom */
			/* cNumStop */
			/* xfillGradientStop */
		}
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.824 BrtXF */
	function parse_BrtXF(data, length) {
		var tgt = data.l + length;
		var ixfeParent = data.read_shift(2);
		var ifmt = data.read_shift(2);
		data.l = tgt;
		return {ixfe:ixfeParent, numFmtId:ifmt };
	}
	function write_BrtXF(data, ixfeP, o) {
		if(!o) o = new_buf(16);
		o.write_shift(2, ixfeP||0);
		o.write_shift(2, data.numFmtId||0);
		o.write_shift(2, 0); /* iFont */
		o.write_shift(2, 0); /* iFill */
		o.write_shift(2, 0); /* ixBorder */
		o.write_shift(1, 0); /* trot */
		o.write_shift(1, 0); /* indent */
		var flow = 0;
		o.write_shift(1, flow); /* flags */
		o.write_shift(1, 0); /* flags */
		o.write_shift(1, 0); /* xfGrbitAtr */
		o.write_shift(1, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.5.4 Blxf TODO */
	function write_Blxf(data, o) {
		if(!o) o = new_buf(10);
		o.write_shift(1, 0); /* dg */
		o.write_shift(1, 0);
		o.write_shift(4, 0); /* color */
		o.write_shift(4, 0); /* color */
		return o;
	}
	/* [MS-XLSB] 2.4.302 BrtBorder TODO */
	var parse_BrtBorder = parsenoop;
	function write_BrtBorder(border, o) {
		if(!o) o = new_buf(51);
		o.write_shift(1, 0); /* diagonal */
		write_Blxf(null, o); /* top */
		write_Blxf(null, o); /* bottom */
		write_Blxf(null, o); /* left */
		write_Blxf(null, o); /* right */
		write_Blxf(null, o); /* diag */
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.763 BrtStyle TODO */
	function write_BrtStyle(style, o) {
		if(!o) o = new_buf(12+4*10);
		o.write_shift(4, style.xfId);
		o.write_shift(2, 1);
		o.write_shift(1, +style.builtinId);
		o.write_shift(1, 0); /* iLevel */
		write_XLNullableWideString(style.name || "", o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */
	function write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
		var o = new_buf(4+256*2*4);
		o.write_shift(4, cnt);
		write_XLNullableWideString(defTableStyle, o);
		write_XLNullableWideString(defPivotStyle, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.1.7.50 Styles */
	function parse_sty_bin(data, themes, opts) {
		var styles = {};
		styles.NumberFmt = ([]);
		for(var y in table_fmt) styles.NumberFmt[y] = table_fmt[y];
	
		styles.CellXf = [];
		styles.Fonts = [];
		var state = [];
		var pass = false;
		recordhopper(data, function hopper_sty(val, R, RT) {
			switch(RT) {
				case 0x002C: /* BrtFmt */
					styles.NumberFmt[val[0]] = val[1]; SSF_load(val[1], val[0]);
					break;
				case 0x002B: /* BrtFont */
					styles.Fonts.push(val);
					if(val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) {
						val.color.rgb = rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
					}
					break;
				case 0x0401: /* BrtKnownFonts */ break;
				case 0x002D: /* BrtFill */
					break;
				case 0x002E: /* BrtBorder */
					break;
				case 0x002F: /* BrtXF */
					if(state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */) {
						styles.CellXf.push(val);
					}
					break;
				case 0x0030: /* BrtStyle */
				case 0x01FB: /* BrtDXF */
				case 0x023C: /* BrtMRUColor */
				case 0x01DB: /* BrtIndexedColor */
					break;
	
				case 0x0493: /* BrtDXF14 */
				case 0x0836: /* BrtDXF15 */
				case 0x046A: /* BrtSlicerStyleElement */
				case 0x0200: /* BrtTableStyleElement */
				case 0x082F: /* BrtTimelineStyleElement */
				case 0x0C00: /* BrtUid */
					break;
	
				case 0x0023: /* BrtFRTBegin */
					pass = true; break;
				case 0x0024: /* BrtFRTEnd */
					pass = false; break;
				case 0x0025: /* BrtACBegin */
					state.push(RT); pass = true; break;
				case 0x0026: /* BrtACEnd */
					state.pop(); pass = false; break;
	
				default:
					if(R.T > 0) state.push(RT);
					else if(R.T < 0) state.pop();
					else if(!pass || (opts.WTF && state[state.length-1] != 0x0025 /* BrtACBegin */)) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		});
		return styles;
	}
	
	function write_FMTS_bin(ba, NF) {
		if(!NF) return;
		var cnt = 0;
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
	for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) ++cnt;
		});
	
		if(cnt == 0) return;
		write_record(ba, 0x0267 /* BrtBeginFmts */, write_UInt32LE(cnt));
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
	for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_record(ba, 0x002C /* BrtFmt */, write_BrtFmt(i, NF[i]));
		});
		write_record(ba, 0x0268 /* BrtEndFmts */);
	}
	
	function write_FONTS_bin(ba) {
		var cnt = 1;
	
		if(cnt == 0) return;
		write_record(ba, 0x0263 /* BrtBeginFonts */, write_UInt32LE(cnt));
		write_record(ba, 0x002B /* BrtFont */, write_BrtFont({
			sz:12,
			color: {theme:1},
			name: "Calibri",
			family: 2,
			scheme: "minor"
		}));
		/* 1*65491BrtFont [ACFONTS] */
		write_record(ba, 0x0264 /* BrtEndFonts */);
	}
	
	function write_FILLS_bin(ba) {
		var cnt = 2;
	
		if(cnt == 0) return;
		write_record(ba, 0x025B /* BrtBeginFills */, write_UInt32LE(cnt));
		write_record(ba, 0x002D /* BrtFill */, write_BrtFill({patternType:"none"}));
		write_record(ba, 0x002D /* BrtFill */, write_BrtFill({patternType:"gray125"}));
		/* 1*65431BrtFill */
		write_record(ba, 0x025C /* BrtEndFills */);
	}
	
	function write_BORDERS_bin(ba) {
		var cnt = 1;
	
		if(cnt == 0) return;
		write_record(ba, 0x0265 /* BrtBeginBorders */, write_UInt32LE(cnt));
		write_record(ba, 0x002E /* BrtBorder */, write_BrtBorder({}));
		/* 1*65430BrtBorder */
		write_record(ba, 0x0266 /* BrtEndBorders */);
	}
	
	function write_CELLSTYLEXFS_bin(ba) {
		var cnt = 1;
		write_record(ba, 0x0272 /* BrtBeginCellStyleXFs */, write_UInt32LE(cnt));
		write_record(ba, 0x002F /* BrtXF */, write_BrtXF({
			numFmtId: 0,
			fontId:   0,
			fillId:   0,
			borderId: 0
		}, 0xFFFF));
		/* 1*65430(BrtXF *FRT) */
		write_record(ba, 0x0273 /* BrtEndCellStyleXFs */);
	}
	
	function write_CELLXFS_bin(ba, data) {
		write_record(ba, 0x0269 /* BrtBeginCellXFs */, write_UInt32LE(data.length));
		data.forEach(function(c) { write_record(ba, 0x002F /* BrtXF */, write_BrtXF(c,0)); });
		/* 1*65430(BrtXF *FRT) */
		write_record(ba, 0x026A /* BrtEndCellXFs */);
	}
	
	function write_STYLES_bin(ba) {
		var cnt = 1;
	
		write_record(ba, 0x026B /* BrtBeginStyles */, write_UInt32LE(cnt));
		write_record(ba, 0x0030 /* BrtStyle */, write_BrtStyle({
			xfId:0,
			builtinId:0,
			name:"Normal"
		}));
		/* 1*65430(BrtStyle *FRT) */
		write_record(ba, 0x026C /* BrtEndStyles */);
	}
	
	function write_DXFS_bin(ba) {
		var cnt = 0;
	
		write_record(ba, 0x01F9 /* BrtBeginDXFs */, write_UInt32LE(cnt));
		/* *2147483647(BrtDXF *FRT) */
		write_record(ba, 0x01FA /* BrtEndDXFs */);
	}
	
	function write_TABLESTYLES_bin(ba) {
		var cnt = 0;
	
		write_record(ba, 0x01FC /* BrtBeginTableStyles */, write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
		/* *TABLESTYLE */
		write_record(ba, 0x01FD /* BrtEndTableStyles */);
	}
	
	function write_COLORPALETTE_bin() {
		return;
		/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */
	}
	
	/* [MS-XLSB] 2.1.7.50 Styles */
	function write_sty_bin(wb, opts) {
		var ba = buf_array();
		write_record(ba, 0x0116 /* BrtBeginStyleSheet */);
		write_FMTS_bin(ba, wb.SSF);
		write_FONTS_bin(ba, wb);
		write_FILLS_bin(ba, wb);
		write_BORDERS_bin(ba, wb);
		write_CELLSTYLEXFS_bin(ba, wb);
		write_CELLXFS_bin(ba, opts.cellXfs);
		write_STYLES_bin(ba, wb);
		write_DXFS_bin(ba, wb);
		write_TABLESTYLES_bin(ba, wb);
		write_COLORPALETTE_bin(ba, wb);
		/* FRTSTYLESHEET*/
		write_record(ba, 0x0117 /* BrtEndStyleSheet */);
		return ba.end();
	}
	/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */
	var XLSXThemeClrScheme = [
		'</a:lt1>', '</a:dk1>', '</a:lt2>', '</a:dk2>',
		'</a:accent1>', '</a:accent2>', '</a:accent3>',
		'</a:accent4>', '</a:accent5>', '</a:accent6>',
		'</a:hlink>', '</a:folHlink>'
	];
	/* 20.1.6.2 clrScheme CT_ColorScheme */
	function parse_clrScheme(t, themes, opts) {
		themes.themeElements.clrScheme = [];
		var color = {};
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0]) {
				/* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */
				case '<a:clrScheme': case '</a:clrScheme>': break;
	
				/* 20.1.2.3.32 srgbClr CT_SRgbColor */
				case '<a:srgbClr':
					color.rgb = y.val; break;
	
				/* 20.1.2.3.33 sysClr CT_SystemColor */
				case '<a:sysClr':
					color.rgb = y.lastClr; break;
	
				/* 20.1.4.1.1 accent1 (Accent 1) */
				/* 20.1.4.1.2 accent2 (Accent 2) */
				/* 20.1.4.1.3 accent3 (Accent 3) */
				/* 20.1.4.1.4 accent4 (Accent 4) */
				/* 20.1.4.1.5 accent5 (Accent 5) */
				/* 20.1.4.1.6 accent6 (Accent 6) */
				/* 20.1.4.1.9 dk1 (Dark 1) */
				/* 20.1.4.1.10 dk2 (Dark 2) */
				/* 20.1.4.1.15 folHlink (Followed Hyperlink) */
				/* 20.1.4.1.19 hlink (Hyperlink) */
				/* 20.1.4.1.22 lt1 (Light 1) */
				/* 20.1.4.1.23 lt2 (Light 2) */
				case '<a:dk1>': case '</a:dk1>':
				case '<a:lt1>': case '</a:lt1>':
				case '<a:dk2>': case '</a:dk2>':
				case '<a:lt2>': case '</a:lt2>':
				case '<a:accent1>': case '</a:accent1>':
				case '<a:accent2>': case '</a:accent2>':
				case '<a:accent3>': case '</a:accent3>':
				case '<a:accent4>': case '</a:accent4>':
				case '<a:accent5>': case '</a:accent5>':
				case '<a:accent6>': case '</a:accent6>':
				case '<a:hlink>': case '</a:hlink>':
				case '<a:folHlink>': case '</a:folHlink>':
					if (y[0].charAt(1) === '/') {
						themes.themeElements.clrScheme[XLSXThemeClrScheme.indexOf(y[0])] = color;
						color = {};
					} else {
						color.name = y[0].slice(3, y[0].length - 1);
					}
					break;
	
				default: if(opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
			}
		});
	}
	
	/* 20.1.4.1.18 fontScheme CT_FontScheme */
	function parse_fontScheme() { }
	
	/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */
	function parse_fmtScheme() { }
	
	var clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
	var fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
	var fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
	
	/* 20.1.6.10 themeElements CT_BaseStyles */
	function parse_themeElements(data, themes, opts) {
		themes.themeElements = {};
	
		var t;
	
		[
			/* clrScheme CT_ColorScheme */
			['clrScheme', clrsregex, parse_clrScheme],
			/* fontScheme CT_FontScheme */
			['fontScheme', fntsregex, parse_fontScheme],
			/* fmtScheme CT_StyleMatrix */
			['fmtScheme', fmtsregex, parse_fmtScheme]
		].forEach(function(m) {
			if(!(t=data.match(m[1]))) throw new Error(m[0] + ' not found in themeElements');
			m[2](t, themes, opts);
		});
	}
	
	var themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
	
	/* 14.2.7 Theme Part */
	function parse_theme_xml(data, opts) {
		/* 20.1.6.9 theme CT_OfficeStyleSheet */
		if(!data || data.length === 0) data = write_theme();
	
		var t;
		var themes = {};
	
		/* themeElements CT_BaseStyles */
		if(!(t=data.match(themeltregex))) throw new Error('themeElements not found in theme');
		parse_themeElements(t[0], themes, opts);
		themes.raw = data;
		return themes;
	}
	
	function write_theme(Themes, opts) {
		if(opts && opts.themeXLSX) return opts.themeXLSX;
		if(Themes && typeof Themes.raw == "string") return Themes.raw;
		var o = [XML_HEADER];
		o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
		o[o.length] =  '<a:themeElements>';
	
		o[o.length] =   '<a:clrScheme name="Office">';
		o[o.length] =    '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
		o[o.length] =    '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
		o[o.length] =    '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
		o[o.length] =    '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
		o[o.length] =    '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
		o[o.length] =    '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
		o[o.length] =    '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
		o[o.length] =    '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
		o[o.length] =    '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
		o[o.length] =    '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
		o[o.length] =    '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
		o[o.length] =    '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
		o[o.length] =   '</a:clrScheme>';
	
		o[o.length] =   '<a:fontScheme name="Office">';
		o[o.length] =    '<a:majorFont>';
		o[o.length] =     '<a:latin typeface="Cambria"/>';
		o[o.length] =     '<a:ea typeface=""/>';
		o[o.length] =     '<a:cs typeface=""/>';
		o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
		o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
		o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
		o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
		o[o.length] =     '<a:font script="Arab" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Hebr" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
		o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
		o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
		o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
		o[o.length] =     '<a:font script="Khmr" typeface="MoolBoran"/>';
		o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
		o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
		o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
		o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
		o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
		o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
		o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
		o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
		o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
		o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
		o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
		o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
		o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
		o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
		o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
		o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
		o[o.length] =     '<a:font script="Viet" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
		o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
		o[o.length] =    '</a:majorFont>';
		o[o.length] =    '<a:minorFont>';
		o[o.length] =     '<a:latin typeface="Calibri"/>';
		o[o.length] =     '<a:ea typeface=""/>';
		o[o.length] =     '<a:cs typeface=""/>';
		o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
		o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
		o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
		o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
		o[o.length] =     '<a:font script="Arab" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Hebr" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
		o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
		o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
		o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
		o[o.length] =     '<a:font script="Khmr" typeface="DaunPenh"/>';
		o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
		o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
		o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
		o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
		o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
		o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
		o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
		o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
		o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
		o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
		o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
		o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
		o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
		o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
		o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
		o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
		o[o.length] =     '<a:font script="Viet" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
		o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
		o[o.length] =    '</a:minorFont>';
		o[o.length] =   '</a:fontScheme>';
	
		o[o.length] =   '<a:fmtScheme name="Office">';
		o[o.length] =    '<a:fillStyleLst>';
		o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:lin ang="16200000" scaled="1"/>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:lin ang="16200000" scaled="0"/>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =    '</a:fillStyleLst>';
		o[o.length] =    '<a:lnStyleLst>';
		o[o.length] =     '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =     '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =     '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =    '</a:lnStyleLst>';
		o[o.length] =    '<a:effectStyleLst>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =      '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
		o[o.length] =      '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =    '</a:effectStyleLst>';
		o[o.length] =    '<a:bgFillStyleLst>';
		o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =    '</a:bgFillStyleLst>';
		o[o.length] =   '</a:fmtScheme>';
		o[o.length] =  '</a:themeElements>';
	
		o[o.length] =  '<a:objectDefaults>';
		o[o.length] =   '<a:spDef>';
		o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
		o[o.length] =   '</a:spDef>';
		o[o.length] =   '<a:lnDef>';
		o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
		o[o.length] =   '</a:lnDef>';
		o[o.length] =  '</a:objectDefaults>';
		o[o.length] =  '<a:extraClrSchemeLst/>';
		o[o.length] = '</a:theme>';
		return o.join("");
	}
	/* [MS-XLS] 2.4.326 TODO: payload is a zip file */
	function parse_Theme(blob, length, opts) {
		var end = blob.l + length;
		var dwThemeVersion = blob.read_shift(4);
		if(dwThemeVersion === 124226) return;
		if(!opts.cellStyles) { blob.l = end; return; }
		var data = blob.slice(blob.l);
		blob.l = end;
		var zip; try { zip = zip_read(data, {type: "array"}); } catch(e) { return; }
		var themeXML = getzipstr(zip, "theme/theme/theme1.xml", true);
		if(!themeXML) return;
		return parse_theme_xml(themeXML, opts);
	}
	
	/* 2.5.49 */
	function parse_ColorTheme(blob) { return blob.read_shift(4); }
	
	/* 2.5.155 */
	function parse_FullColorExt(blob) {
		var o = {};
		o.xclrType = blob.read_shift(2);
		o.nTintShade = blob.read_shift(2);
		switch(o.xclrType) {
			case 0: blob.l += 4; break;
			case 1: o.xclrValue = parse_IcvXF(blob, 4); break;
			case 2: o.xclrValue = parse_LongRGBA(blob, 4); break;
			case 3: o.xclrValue = parse_ColorTheme(blob, 4); break;
			case 4: blob.l += 4; break;
		}
		blob.l += 8;
		return o;
	}
	
	/* 2.5.164 TODO: read 7 bits*/
	function parse_IcvXF(blob, length) {
		return parsenoop(blob, length);
	}
	
	/* 2.5.280 */
	function parse_XFExtGradient(blob, length) {
		return parsenoop(blob, length);
	}
	
	/* [MS-XLS] 2.5.108 */
	function parse_ExtProp(blob) {
		var extType = blob.read_shift(2);
		var cb = blob.read_shift(2) - 4;
		var o = [extType];
		switch(extType) {
			case 0x04: case 0x05: case 0x07: case 0x08:
			case 0x09: case 0x0A: case 0x0B: case 0x0D:
				o[1] = parse_FullColorExt(blob, cb); break;
			case 0x06: o[1] = parse_XFExtGradient(blob, cb); break;
			case 0x0E: case 0x0F: o[1] = blob.read_shift(cb === 1 ? 1 : 2); break;
			default: throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
		}
		return o;
	}
	
	/* 2.4.355 */
	function parse_XFExt(blob, length) {
		var end = blob.l + length;
		blob.l += 2;
		var ixfe = blob.read_shift(2);
		blob.l += 2;
		var cexts = blob.read_shift(2);
		var ext = [];
		while(cexts-- > 0) ext.push(parse_ExtProp(blob, end-blob.l));
		return {ixfe:ixfe, ext:ext};
	}
	
	/* xf is an XF, see parse_XFExt for xfext */
	function update_xfext(xf, xfext) {
		xfext.forEach(function(xfe) {
			switch(xfe[0]) { /* 2.5.108 extPropData */
				case 0x04: break; /* foreground color */
				case 0x05: break; /* background color */
				case 0x06: break; /* gradient fill */
				case 0x07: break; /* top cell border color */
				case 0x08: break; /* bottom cell border color */
				case 0x09: break; /* left cell border color */
				case 0x0a: break; /* right cell border color */
				case 0x0b: break; /* diagonal cell border color */
				case 0x0d: /* text color */
					break;
				case 0x0e: break; /* font scheme */
				case 0x0f: break; /* indentation level */
			}
		});
	}
	
	function parse_BrtMdtinfo(data, length) {
	  return {
	    flags: data.read_shift(4),
	    version: data.read_shift(4),
	    name: parse_XLWideString(data, length - 8)
	  };
	}
	function write_BrtMdtinfo(data) {
	  var o = new_buf(12 + 2 * data.name.length);
	  o.write_shift(4, data.flags);
	  o.write_shift(4, data.version);
	  write_XLWideString(data.name, o);
	  return o.slice(0, o.l);
	}
	function parse_BrtMdb(data) {
	  var out = [];
	  var cnt = data.read_shift(4);
	  while (cnt-- > 0)
	    out.push([data.read_shift(4), data.read_shift(4)]);
	  return out;
	}
	function write_BrtMdb(mdb) {
	  var o = new_buf(4 + 8 * mdb.length);
	  o.write_shift(4, mdb.length);
	  for (var i = 0; i < mdb.length; ++i) {
	    o.write_shift(4, mdb[i][0]);
	    o.write_shift(4, mdb[i][1]);
	  }
	  return o;
	}
	function write_BrtBeginEsfmd(cnt, name) {
	  var o = new_buf(8 + 2 * name.length);
	  o.write_shift(4, cnt);
	  write_XLWideString(name, o);
	  return o.slice(0, o.l);
	}
	function parse_BrtBeginEsmdb(data) {
	  data.l += 4;
	  return data.read_shift(4) != 0;
	}
	function write_BrtBeginEsmdb(cnt, cm) {
	  var o = new_buf(8);
	  o.write_shift(4, cnt);
	  o.write_shift(4, cm ? 1 : 0);
	  return o;
	}
	function parse_xlmeta_bin(data, name, _opts) {
	  var out = { Types: [], Cell: [], Value: [] };
	  var opts = _opts || {};
	  var state = [];
	  var pass = false;
	  var metatype = 2;
	  recordhopper(data, function(val, R, RT) {
	    switch (RT) {
	      case 335:
	        out.Types.push({ name: val.name });
	        break;
	      case 51:
	        val.forEach(function(r) {
	          if (metatype == 1)
	            out.Cell.push({ type: out.Types[r[0] - 1].name, index: r[1] });
	          else if (metatype == 0)
	            out.Value.push({ type: out.Types[r[0] - 1].name, index: r[1] });
	        });
	        break;
	      case 337:
	        metatype = val ? 1 : 0;
	        break;
	      case 338:
	        metatype = 2;
	        break;
	      case 35:
	        state.push(RT);
	        pass = true;
	        break;
	      case 36:
	        state.pop();
	        pass = false;
	        break;
	      default:
	        if (R.T) {
	        } else if (!pass || opts.WTF && state[state.length - 1] != 35)
	          throw new Error("Unexpected record 0x" + RT.toString(16));
	    }
	  });
	  return out;
	}
	function write_xlmeta_bin() {
	  var ba = buf_array();
	  write_record(ba, 332);
	  write_record(ba, 334, write_UInt32LE(1));
	  write_record(ba, 335, write_BrtMdtinfo({
	    name: "XLDAPR",
	    version: 12e4,
	    flags: 3496657072
	  }));
	  write_record(ba, 336);
	  write_record(ba, 339, write_BrtBeginEsfmd(1, "XLDAPR"));
	  write_record(ba, 52);
	  write_record(ba, 35, write_UInt32LE(514));
	  write_record(ba, 4096, write_UInt32LE(0));
	  write_record(ba, 4097, writeuint16(1));
	  write_record(ba, 36);
	  write_record(ba, 53);
	  write_record(ba, 340);
	  write_record(ba, 337, write_BrtBeginEsmdb(1, true));
	  write_record(ba, 51, write_BrtMdb([[1, 0]]));
	  write_record(ba, 338);
	  write_record(ba, 333);
	  return ba.end();
	}
	function parse_xlmeta_xml(data, name, opts) {
	  var out = { Types: [], Cell: [], Value: [] };
	  if (!data)
	    return out;
	  var pass = false;
	  var metatype = 2;
	  var lastmeta;
	  data.replace(tagregex, function(x) {
	    var y = parsexmltag(x);
	    switch (strip_ns(y[0])) {
	      case "<?xml":
	        break;
	      case "<metadata":
	      case "</metadata>":
	        break;
	      case "<metadataTypes":
	      case "</metadataTypes>":
	        break;
	      case "<metadataType":
	        out.Types.push({ name: y.name });
	        break;
	      case "</metadataType>":
	        break;
	      case "<futureMetadata":
	        for (var j = 0; j < out.Types.length; ++j)
	          if (out.Types[j].name == y.name)
	            lastmeta = out.Types[j];
	        break;
	      case "</futureMetadata>":
	        break;
	      case "<bk>":
	        break;
	      case "</bk>":
	        break;
	      case "<rc":
	        if (metatype == 1)
	          out.Cell.push({ type: out.Types[y.t - 1].name, index: +y.v });
	        else if (metatype == 0)
	          out.Value.push({ type: out.Types[y.t - 1].name, index: +y.v });
	        break;
	      case "</rc>":
	        break;
	      case "<cellMetadata":
	        metatype = 1;
	        break;
	      case "</cellMetadata>":
	        metatype = 2;
	        break;
	      case "<valueMetadata":
	        metatype = 0;
	        break;
	      case "</valueMetadata>":
	        metatype = 2;
	        break;
	      case "<extLst":
	      case "<extLst>":
	      case "</extLst>":
	      case "<extLst/>":
	        break;
	      case "<ext":
	        pass = true;
	        break;
	      case "</ext>":
	        pass = false;
	        break;
	      case "<rvb":
	        if (!lastmeta)
	          break;
	        if (!lastmeta.offsets)
	          lastmeta.offsets = [];
	        lastmeta.offsets.push(+y.i);
	        break;
	      default:
	        if (!pass && opts.WTF)
	          throw new Error("unrecognized " + y[0] + " in metadata");
	    }
	    return x;
	  });
	  return out;
	}
	function write_xlmeta_xml() {
	  var o = [XML_HEADER];
	  o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');
	  return o.join("");
	}
	/* 18.6 Calculation Chain */
	function parse_cc_xml(data) {
		var d = [];
		if(!data) return d;
		var i = 1;
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0]) {
				case '<?xml': break;
				/* 18.6.2  calcChain CT_CalcChain 1 */
				case '<calcChain': case '<calcChain>': case '</calcChain>': break;
				/* 18.6.1  c CT_CalcCell 1 */
				case '<c': delete y[0]; if(y.i) i = y.i; else y.i = i; d.push(y); break;
			}
		});
		return d;
	}
	
	//function write_cc_xml(data, opts) { }
	
	/* [MS-XLSB] 2.6.4.1 */
	function parse_BrtCalcChainItem$(data) {
		var out = {};
		out.i = data.read_shift(4);
		var cell = {};
		cell.r = data.read_shift(4);
		cell.c = data.read_shift(4);
		out.r = encode_cell(cell);
		var flags = data.read_shift(1);
		if(flags & 0x2) out.l = '1';
		if(flags & 0x8) out.a = '1';
		return out;
	}
	
	/* 18.6 Calculation Chain */
	function parse_cc_bin(data, name, opts) {
		var out = [];
		var pass = false;
		recordhopper(data, function hopper_cc(val, R, RT) {
			switch(RT) {
				case 0x003F: /* 'BrtCalcChainItem$' */
					out.push(val); break;
	
				default:
					if(R.T){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		});
		return out;
	}
	
	//function write_cc_bin(data, opts) { }
	/* 18.14 Supplementary Workbook Data */
	function parse_xlink_xml() {
		//var opts = _opts || {};
		//if(opts.WTF) throw "XLSX External Link";
	}
	
	/* [MS-XLSB] 2.1.7.25 External Link */
	function parse_xlink_bin(data, rel, name, _opts) {
		if(!data) return data;
		var opts = _opts || {};
	
		var pass = false, end = false;
	
		recordhopper(data, function xlink_parse(val, R, RT) {
			if(end) return;
			switch(RT) {
				case 0x0167: /* 'BrtSupTabs' */
				case 0x016B: /* 'BrtExternTableStart' */
				case 0x016C: /* 'BrtExternTableEnd' */
				case 0x016E: /* 'BrtExternRowHdr' */
				case 0x016F: /* 'BrtExternCellBlank' */
				case 0x0170: /* 'BrtExternCellReal' */
				case 0x0171: /* 'BrtExternCellBool' */
				case 0x0172: /* 'BrtExternCellError' */
				case 0x0173: /* 'BrtExternCellString' */
				case 0x01D8: /* 'BrtExternValueMeta' */
				case 0x0241: /* 'BrtSupNameStart' */
				case 0x0242: /* 'BrtSupNameValueStart' */
				case 0x0243: /* 'BrtSupNameValueEnd' */
				case 0x0244: /* 'BrtSupNameNum' */
				case 0x0245: /* 'BrtSupNameErr' */
				case 0x0246: /* 'BrtSupNameSt' */
				case 0x0247: /* 'BrtSupNameNil' */
				case 0x0248: /* 'BrtSupNameBool' */
				case 0x0249: /* 'BrtSupNameFmla' */
				case 0x024A: /* 'BrtSupNameBits' */
				case 0x024B: /* 'BrtSupNameEnd' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
	
				default:
					if(R.T){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		}, opts);
	}
	/* 20.5 DrawingML - SpreadsheetML Drawing */
	/* 20.5.2.35 wsDr CT_Drawing */
	function parse_drawing(data, rels) {
		if(!data) return "??";
		/*
		  Chartsheet Drawing:
		   - 20.5.2.35 wsDr CT_Drawing
		    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
		     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
		      - 20.1.2.2.16 graphic CT_GraphicalObject
		       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
	          - chart reference
		   the actual type is based on the URI of the graphicData
			TODO: handle embedded charts and other types of graphics
		*/
		var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];
	
		return rels['!id'][id].Target;
	}
	
	/* L.5.5.2 SpreadsheetML Comments + VML Schema */
	var _shapeid = 1024;
	function write_comments_vml(rId, comments) {
		var csize = [21600, 21600];
		/* L.5.2.1.2 Path Attribute */
		var bbox = ["m0,0l0",csize[1],csize[0],csize[1],csize[0],"0xe"].join(",");
		var o = [
			writextag("xml", null, { 'xmlns:v': XLMLNS.v, 'xmlns:o': XLMLNS.o, 'xmlns:x': XLMLNS.x, 'xmlns:mv': XLMLNS.mv }).replace(/\/>/,">"),
			writextag("o:shapelayout", writextag("o:idmap", null, {'v:ext':"edit", 'data':rId}), {'v:ext':"edit"}),
			writextag("v:shapetype", [
				writextag("v:stroke", null, {joinstyle:"miter"}),
				writextag("v:path", null, {gradientshapeok:"t", 'o:connecttype':"rect"})
			].join(""), {id:"_x0000_t202", 'o:spt':202, coordsize:csize.join(","),path:bbox})
		];
		while(_shapeid < rId * 1000) _shapeid += 1000;
	
		comments.forEach(function(x) {
		var c = decode_cell(x[0]);
		var fillopts = {'color2':"#BEFF82", 'type':"gradient"};
		if(fillopts.type == "gradient") fillopts.angle = "-180";
		var fillparm = fillopts.type == "gradient" ? writextag("o:fill", null, {type:"gradientUnscaled", 'v:ext':"view"}) : null;
		var fillxml = writextag('v:fill', fillparm, fillopts);
	
		var shadata = ({on:"t", 'obscured':"t"});
		++_shapeid;
	
		o = o.concat([
		'<v:shape' + wxt_helper({
			id:'_x0000_s' + _shapeid,
			type:"#_x0000_t202",
			style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : "") ,
			fillcolor:"#ECFAD4",
			strokecolor:"#edeaa1"
		}) + '>',
			fillxml,
			writextag("v:shadow", null, shadata),
			writextag("v:path", null, {'o:connecttype':"none"}),
			'<v:textbox><div style="text-align:left"></div></v:textbox>',
			'<x:ClientData ObjectType="Note">',
				'<x:MoveWithCells/>',
				'<x:SizeWithCells/>',
				/* Part 4 19.4.2.3 Anchor (Anchor) */
				writetag('x:Anchor', [c.c+1, 0, c.r+1, 0, c.c+3, 20, c.r+5, 20].join(",")),
				writetag('x:AutoFill', "False"),
				writetag('x:Row', String(c.r)),
				writetag('x:Column', String(c.c)),
				x[1].hidden ? '' : '<x:Visible/>',
			'</x:ClientData>',
		'</v:shape>'
		]); });
		o.push('</xml>');
		return o.join("");
	}
	function sheet_insert_comments(sheet, comments, threaded, people) {
		var dense = Array.isArray(sheet);
		var cell;
		comments.forEach(function(comment) {
			var r = decode_cell(comment.ref);
			if(dense) {
				if(!sheet[r.r]) sheet[r.r] = [];
				cell = sheet[r.r][r.c];
			} else cell = sheet[comment.ref];
			if (!cell) {
				cell = ({t:"z"});
				if(dense) sheet[r.r][r.c] = cell;
				else sheet[comment.ref] = cell;
				var range = safe_decode_range(sheet["!ref"]||"BDWGO1000001:A1");
				if(range.s.r > r.r) range.s.r = r.r;
				if(range.e.r < r.r) range.e.r = r.r;
				if(range.s.c > r.c) range.s.c = r.c;
				if(range.e.c < r.c) range.e.c = r.c;
				var encoded = encode_range(range);
				if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded;
			}
	
			if (!cell.c) cell.c = [];
			var o = ({a: comment.author, t: comment.t, r: comment.r, T: threaded});
			if(comment.h) o.h = comment.h;
	
			/* threaded comments always override */
			for(var i = cell.c.length - 1; i >= 0; --i) {
				if(!threaded && cell.c[i].T) return;
				if(threaded && !cell.c[i].T) cell.c.splice(i, 1);
			}
			if(threaded && people) for(i = 0; i < people.length; ++i) {
				if(o.a == people[i].id) { o.a = people[i].name || o.a; break; }
			}
			cell.c.push(o);
		});
	}
	
	/* 18.7 Comments */
	function parse_comments_xml(data, opts) {
		/* 18.7.6 CT_Comments */
		if(data.match(/<(?:\w+:)?comments *\/>/)) return [];
		var authors = [];
		var commentList = [];
		var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
		if(authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
			if(x === "" || x.trim() === "") return;
			var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
			if(a) authors.push(a[1]);
		});
		var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
		if(cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
			if(x === "" || x.trim() === "") return;
			var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
			if(!cm) return;
			var y = parsexmltag(cm[0]);
			var comment = ({ author: y.authorId && authors[y.authorId] || "sheetjsghost", ref: y.ref, guid: y.guid });
			var cell = decode_cell(y.ref);
			if(opts.sheetRows && opts.sheetRows <= cell.r) return;
			var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
			var rt = !!textMatch && !!textMatch[1] && parse_si(textMatch[1]) || {r:"",t:"",h:""};
			comment.r = rt.r;
			if(rt.r == "<t></t>") rt.t = rt.h = "";
			comment.t = (rt.t||"").replace(/\r\n/g,"\n").replace(/\r/g,"\n");
			if(opts.cellHTML) comment.h = rt.h;
			commentList.push(comment);
		});
		return commentList;
	}
	
	function write_comments_xml(data) {
		var o = [XML_HEADER, writextag('comments', null, { 'xmlns': XMLNS_main[0] })];
	
		var iauthor = [];
		o.push("<authors>");
		data.forEach(function(x) { x[1].forEach(function(w) { var a = escapexml(w.a);
			if(iauthor.indexOf(a) == -1) {
				iauthor.push(a);
				o.push("<author>" + a + "</author>");
			}
			if(w.T && w.ID && iauthor.indexOf("tc=" + w.ID) == -1) {
				iauthor.push("tc=" + w.ID);
				o.push("<author>" + "tc=" + w.ID + "</author>");
			}
		}); });
		if(iauthor.length == 0) { iauthor.push("SheetJ5"); o.push("<author>SheetJ5</author>"); }
		o.push("</authors>");
		o.push("<commentList>");
		data.forEach(function(d) {
			/* 18.7.3 CT_Comment */
			var lastauthor = 0, ts = [];
			if(d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
			else d[1].forEach(function(c) {
				if(c.a) lastauthor = iauthor.indexOf(escapexml(c.a));
				ts.push(c.t||"");
			});
			o.push('<comment ref="' + d[0] + '" authorId="' + lastauthor + '"><text>');
			if(ts.length <= 1) o.push(writetag("t", escapexml(ts[0]||"")));
			else {
				/* based on Threaded Comments -> Comments projection */
				var t = "Comment:\n    " + (ts[0]) + "\n";
				for(var i = 1; i < ts.length; ++i) t += "Reply:\n    " + ts[i] + "\n";
				o.push(writetag("t", escapexml(t)));
			}
			o.push('</text></comment>');
		});
		o.push("</commentList>");
		if(o.length>2) { o[o.length] = ('</comments>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	/* [MS-XLSX] 2.1.17 */
	function parse_tcmnt_xml(data, opts) {
		var out = [];
		var pass = false, comment = {}, tidx = 0;
		data.replace(tagregex, function xml_tcmnt(x, idx) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
	
				/* 2.6.207 ThreadedComments CT_ThreadedComments */
				case '<ThreadedComments': break;
				case '</ThreadedComments>': break;
	
				/* 2.6.205 threadedComment CT_ThreadedComment */
				case '<threadedComment': comment = {author: y.personId, guid: y.id, ref: y.ref, T: 1}; break;
				case '</threadedComment>': if(comment.t != null) out.push(comment); break;
	
				case '<text>': case '<text': tidx = idx + x.length; break;
				case '</text>': comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n"); break;
	
				/* 2.6.206 mentions CT_ThreadedCommentMentions TODO */
				case '<mentions': case '<mentions>': pass = true; break;
				case '</mentions>': pass = false; break;
	
				/* 2.6.202 mention CT_Mention TODO */
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
				/* 18.2.7  ext CT_Extension + */
				case '<ext': pass=true; break;
				case '</ext>': pass=false; break;
	
				default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
			}
			return x;
		});
		return out;
	}
	
	function write_tcmnt_xml(comments, people, opts) {
		var o = [XML_HEADER, writextag('ThreadedComments', null, { 'xmlns': XMLNS.TCMNT }).replace(/[\/]>/, ">")];
		comments.forEach(function(carr) {
			var rootid = "";
			(carr[1] || []).forEach(function(c, idx) {
				if(!c.T) { delete c.ID; return; }
				if(c.a && people.indexOf(c.a) == -1) people.push(c.a);
				var tcopts = {
					ref: carr[0],
					id: "{54EE7951-7262-4200-6969-" + ("000000000000" + opts.tcid++).slice(-12) + "}"
				};
				if(idx == 0) rootid = tcopts.id;
				else tcopts.parentId = rootid;
				c.ID = tcopts.id;
				if(c.a) tcopts.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + people.indexOf(c.a)).slice(-12) + "}";
				o.push(writextag('threadedComment', writetag('text', c.t||""), tcopts));
			});
		});
		o.push('</ThreadedComments>');
		return o.join("");
	}
	
	/* [MS-XLSX] 2.1.18 */
	function parse_people_xml(data, opts) {
		var out = [];
		var pass = false;
		data.replace(tagregex, function xml_tcmnt(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
	
				/* 2.4.85 personList CT_PersonList */
				case '<personList': break;
				case '</personList>': break;
	
				/* 2.6.203 person CT_Person TODO: providers */
				case '<person': out.push({name: y.displayname, id: y.id }); break;
				case '</person>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
				/* 18.2.7  ext CT_Extension + */
				case '<ext': pass=true; break;
				case '</ext>': pass=false; break;
	
				default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
			}
			return x;
		});
		return out;
	}
	function write_people_xml(people/*, opts*/) {
		var o = [XML_HEADER, writextag('personList', null, {
			'xmlns': XMLNS.TCMNT,
			'xmlns:x': XMLNS_main[0]
		}).replace(/[\/]>/, ">")];
		people.forEach(function(person, idx) {
			o.push(writextag('person', null, {
				displayName: person,
				id: "{54EE7950-7262-4200-6969-" + ("000000000000" + idx).slice(-12) + "}",
				userId: person,
				providerId: "None"
			}));
		});
		o.push("</personList>");
		return o.join("");
	}
	/* [MS-XLSB] 2.4.28 BrtBeginComment */
	function parse_BrtBeginComment(data) {
		var out = {};
		out.iauthor = data.read_shift(4);
		var rfx = parse_UncheckedRfX(data, 16);
		out.rfx = rfx.s;
		out.ref = encode_cell(rfx.s);
		data.l += 16; /*var guid = parse_GUID(data); */
		return out;
	}
	function write_BrtBeginComment(data, o) {
		if(o == null) o = new_buf(36);
		o.write_shift(4, data[1].iauthor);
		write_UncheckedRfX((data[0]), o);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.4.327 BrtCommentAuthor */
	var parse_BrtCommentAuthor = parse_XLWideString;
	function write_BrtCommentAuthor(data) { return write_XLWideString(data.slice(0, 54)); }
	
	/* [MS-XLSB] 2.1.7.8 Comments */
	function parse_comments_bin(data, opts) {
		var out = [];
		var authors = [];
		var c = {};
		var pass = false;
		recordhopper(data, function hopper_cmnt(val, R, RT) {
			switch(RT) {
				case 0x0278: /* 'BrtCommentAuthor' */
					authors.push(val); break;
				case 0x027B: /* 'BrtBeginComment' */
					c = val; break;
				case 0x027D: /* 'BrtCommentText' */
					c.t = val.t; c.h = val.h; c.r = val.r; break;
				case 0x027C: /* 'BrtEndComment' */
					c.author = authors[c.iauthor];
					delete (c).iauthor;
					if(opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
					if(!c.t) c.t = "";
					delete c.rfx; out.push(c); break;
	
				case 0x0C00: /* 'BrtUid' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */ break;
				case 0x0026: /* 'BrtACEnd' */ break;
	
	
				default:
					if(R.T){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		});
		return out;
	}
	
	function write_comments_bin(data) {
		var ba = buf_array();
		var iauthor = [];
		write_record(ba, 0x0274 /* BrtBeginComments */);
	
		write_record(ba, 0x0276 /* BrtBeginCommentAuthors */);
		data.forEach(function(comment) {
			comment[1].forEach(function(c) {
				if(iauthor.indexOf(c.a) > -1) return;
				iauthor.push(c.a.slice(0,54));
				write_record(ba, 0x0278 /* BrtCommentAuthor */, write_BrtCommentAuthor(c.a));
			});
		});
		write_record(ba, 0x0277 /* BrtEndCommentAuthors */);
	
		write_record(ba, 0x0279 /* BrtBeginCommentList */);
		data.forEach(function(comment) {
			comment[1].forEach(function(c) {
				c.iauthor = iauthor.indexOf(c.a);
				var range = {s:decode_cell(comment[0]),e:decode_cell(comment[0])};
				write_record(ba, 0x027B /* BrtBeginComment */, write_BrtBeginComment([range, c]));
				if(c.t && c.t.length > 0) write_record(ba, 0x027D /* BrtCommentText */, write_BrtCommentText(c));
				write_record(ba, 0x027C /* BrtEndComment */);
				delete c.iauthor;
			});
		});
		write_record(ba, 0x027A /* BrtEndCommentList */);
	
		write_record(ba, 0x0275 /* BrtEndComments */);
		return ba.end();
	}
	var CT_VBA = "application/vnd.ms-office.vbaProject";
	function make_vba_xls(cfb) {
	  var newcfb = CFB.utils.cfb_new({ root: "R" });
	  cfb.FullPaths.forEach(function(p, i) {
	    if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/))
	      return;
	    var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
	    CFB.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
	  });
	  return CFB.write(newcfb);
	}
	function fill_vba_xls(cfb, vba) {
	  vba.FullPaths.forEach(function(p, i) {
	    if (i == 0)
	      return;
	    var newpath = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
	    if (newpath.slice(-1) !== "/")
	      CFB.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
	  });
	}
	var VBAFMTS = ["xlsb", "xlsm", "xlam", "biff8", "xla"];
	/* macro and dialog sheet stubs */
	function parse_ds_bin() { return {'!type':'dialog'}; }
	function parse_ds_xml() { return {'!type':'dialog'}; }
	function parse_ms_bin() { return {'!type':'macro'}; }
	function parse_ms_xml() { return {'!type':'macro'}; }
	/* TODO: it will be useful to parse the function str */
	var rc_to_a1 = (function(){
		var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
		var rcbase = ({r:0,c:0});
		function rcfunc($$,$1,$2,$3) {
			var cRel = false, rRel = false;
	
			if($2.length == 0) rRel = true;
			else if($2.charAt(0) == "[") { rRel = true; $2 = $2.slice(1, -1); }
	
			if($3.length == 0) cRel = true;
			else if($3.charAt(0) == "[") { cRel = true; $3 = $3.slice(1, -1); }
	
			var R = $2.length>0?parseInt($2,10)|0:0, C = $3.length>0?parseInt($3,10)|0:0;
	
			if(cRel) C += rcbase.c; else --C;
			if(rRel) R += rcbase.r; else --R;
			return $1 + (cRel ? "" : "$") + encode_col(C) + (rRel ? "" : "$") + encode_row(R);
		}
		return function rc_to_a1(fstr, base) {
			rcbase = base;
			return fstr.replace(rcregex, rcfunc);
		};
	})();
	
	var crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
	var a1_to_rc = (function(){
		return function a1_to_rc(fstr, base) {
			return fstr.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
				var c = decode_col($3) - ($2 ? 0 : base.c);
				var r = decode_row($5) - ($4 ? 0 : base.r);
				var R = (r == 0 ? "" : !$4 ? "[" + r + "]" : (r+1));
				var C = (c == 0 ? "" : !$2 ? "[" + c + "]" : (c+1));
				return $1 + "R" + R + "C" + C;
			});
		};
	})();
	
	/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */
	function shift_formula_str(f, delta) {
		return f.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
			return $1+($2=="$" ? $2+$3 : encode_col(decode_col($3)+delta.c))+($4=="$" ? $4+$5 : encode_row(decode_row($5) + delta.r));
		});
	}
	
	function shift_formula_xlsx(f, range, cell) {
		var r = decode_range(range), s = r.s, c = decode_cell(cell);
		var delta = {r:c.r - s.r, c:c.c - s.c};
		return shift_formula_str(f, delta);
	}
	
	/* TODO: parse formula */
	function fuzzyfmla(f) {
		if(f.length == 1) return false;
		return true;
	}
	
	function _xlfn(f) {
		return f.replace(/_xlfn\./g,"");
	}
	function parseread1(blob) { blob.l+=1; return; }
	
	/* [MS-XLS] 2.5.51 */
	function parse_ColRelU(blob, length) {
		var c = blob.read_shift(length == 1 ? 1 : 2);
		return [c & 0x3FFF, (c >> 14) & 1, (c >> 15) & 1];
	}
	
	/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */
	function parse_RgceArea(blob, length, opts) {
		var w = 2;
		if(opts) {
			if(opts.biff >= 2 && opts.biff <= 5) return parse_RgceArea_BIFF2(blob, length, opts);
			else if(opts.biff == 12) w = 4;
		}
		var r=blob.read_shift(w), R=blob.read_shift(w);
		var c=parse_ColRelU(blob, 2);
		var C=parse_ColRelU(blob, 2);
		return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
	}
	/* BIFF 2-5 encodes flags in the row field */
	function parse_RgceArea_BIFF2(blob) {
		var r=parse_ColRelU(blob, 2), R=parse_ColRelU(blob, 2);
		var c=blob.read_shift(1);
		var C=blob.read_shift(1);
		return { s:{r:r[0], c:c, cRel:r[1], rRel:r[2]}, e:{r:R[0], c:C, cRel:R[1], rRel:R[2]} };
	}
	
	/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */
	function parse_RgceAreaRel(blob, length, opts) {
		if(opts.biff < 8) return parse_RgceArea_BIFF2(blob, length, opts);
		var r=blob.read_shift(opts.biff == 12 ? 4 : 2), R=blob.read_shift(opts.biff == 12 ? 4 : 2);
		var c=parse_ColRelU(blob, 2);
		var C=parse_ColRelU(blob, 2);
		return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
	}
	
	/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */
	function parse_RgceLoc(blob, length, opts) {
		if(opts && opts.biff >= 2 && opts.biff <= 5) return parse_RgceLoc_BIFF2(blob, length, opts);
		var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
		var c = parse_ColRelU(blob, 2);
		return {r:r, c:c[0], cRel:c[1], rRel:c[2]};
	}
	function parse_RgceLoc_BIFF2(blob) {
		var r = parse_ColRelU(blob, 2);
		var c = blob.read_shift(1);
		return {r:r[0], c:c, cRel:r[1], rRel:r[2]};
	}
	
	/* [MS-XLS] 2.5.198.107, 2.5.47 */
	function parse_RgceElfLoc(blob) {
		var r = blob.read_shift(2);
		var c = blob.read_shift(2);
		return {r:r, c:c & 0xFF, fQuoted:!!(c & 0x4000), cRel:c>>15, rRel:c>>15 };
	}
	
	/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */
	function parse_RgceLocRel(blob, length, opts) {
		var biff = opts && opts.biff ? opts.biff : 8;
		if(biff >= 2 && biff <= 5) return parse_RgceLocRel_BIFF2(blob, length, opts);
		var r = blob.read_shift(biff >= 12 ? 4 : 2);
		var cl = blob.read_shift(2);
		var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
		cl &= 0x3FFF;
		if(rRel == 1) while(r > 0x7FFFF) r -= 0x100000;
		if(cRel == 1) while(cl > 0x1FFF) cl = cl - 0x4000;
		return {r:r,c:cl,cRel:cRel,rRel:rRel};
	}
	function parse_RgceLocRel_BIFF2(blob) {
		var rl = blob.read_shift(2);
		var c = blob.read_shift(1);
		var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
		rl &= 0x3FFF;
		if(rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
		if(cRel == 1 && c >= 0x80) c = c - 0x100;
		return {r:rl,c:c,cRel:cRel,rRel:rRel};
	}
	
	/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */
	function parse_PtgArea(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var area = parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
		return [type, area];
	}
	
	/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */
	function parse_PtgArea3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2, 'i');
		var w = 8;
		if(opts) switch(opts.biff) {
			case 5: blob.l += 12; w = 6; break;
			case 12: w = 12; break;
		}
		var area = parse_RgceArea(blob, w, opts);
		return [type, ixti, area];
	}
	
	/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */
	function parse_PtgAreaErr(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		blob.l += opts && (opts.biff > 8) ? 12 : (opts.biff < 8 ? 6 : 8);
		return [type];
	}
	/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */
	function parse_PtgAreaErr3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2);
		var w = 8;
		if(opts) switch(opts.biff) {
			case 5: blob.l += 12; w = 6; break;
			case 12: w = 12; break;
		}
		blob.l += w;
		return [type, ixti];
	}
	
	/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */
	function parse_PtgAreaN(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var area = parse_RgceAreaRel(blob, length - 1, opts);
		return [type, area];
	}
	
	/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */
	function parse_PtgArray(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
		return [type];
	}
	
	/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */
	function parse_PtgAttrBaxcel(blob) {
		var bitSemi = blob[blob.l+1] & 0x01; /* 1 = volatile */
		var bitBaxcel = 1;
		blob.l += 4;
		return [bitSemi, bitBaxcel];
	}
	
	/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */
	function parse_PtgAttrChoose(blob, length, opts) {
		blob.l +=2;
		var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		var o = [];
		/* offset is 1 less than the number of elements */
		for(var i = 0; i <= offset; ++i) o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
		return o;
	}
	
	/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */
	function parse_PtgAttrGoto(blob, length, opts) {
		var bitGoto = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitGoto, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
	}
	
	/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */
	function parse_PtgAttrIf(blob, length, opts) {
		var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitIf, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
	}
	
	/* [MS-XLSB] 2.5.97.28 */
	function parse_PtgAttrIfError(blob) {
		var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitIf, blob.read_shift(2)];
	}
	
	/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */
	function parse_PtgAttrSemi(blob, length, opts) {
		var bitSemi = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += opts && opts.biff == 2 ? 3 : 4;
		return [bitSemi];
	}
	
	/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */
	function parse_PtgAttrSpaceType(blob) {
		var type = blob.read_shift(1), cch = blob.read_shift(1);
		return [type, cch];
	}
	
	/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */
	function parse_PtgAttrSpace(blob) {
		blob.read_shift(2);
		return parse_PtgAttrSpaceType(blob, 2);
	}
	
	/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */
	function parse_PtgAttrSpaceSemi(blob) {
		blob.read_shift(2);
		return parse_PtgAttrSpaceType(blob, 2);
	}
	
	/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */
	function parse_PtgRef(blob, length, opts) {
		//var ptg = blob[blob.l] & 0x1F;
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var loc = parse_RgceLoc(blob, 0, opts);
		return [type, loc];
	}
	
	/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */
	function parse_PtgRefN(blob, length, opts) {
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var loc = parse_RgceLocRel(blob, 0, opts);
		return [type, loc];
	}
	
	/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */
	function parse_PtgRef3d(blob, length, opts) {
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var ixti = blob.read_shift(2); // XtiIndex
		if(opts && opts.biff == 5) blob.l += 12;
		var loc = parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
		return [type, ixti, loc];
	}
	
	
	/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */
	function parse_PtgFunc(blob, length, opts) {
		//var ptg = blob[blob.l] & 0x1F;
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
		return [FtabArgc[iftab], Ftab[iftab], type];
	}
	/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */
	function parse_PtgFuncVar(blob, length, opts) {
		var type = blob[blob.l++];
		var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [(type == 0x58 ? -1 : 0), blob.read_shift(1)]: parsetab(blob);
		return [cparams, (tab[0] === 0 ? Ftab : Cetab)[tab[1]]];
	}
	
	function parsetab(blob) {
		return [blob[blob.l+1]>>7, blob.read_shift(2) & 0x7FFF];
	}
	
	/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */
	function parse_PtgAttrSum(blob, length, opts) {
		blob.l += opts && opts.biff == 2 ? 3 : 4; return;
	}
	
	/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */
	function parse_PtgExp(blob, length, opts) {
		blob.l++;
		if(opts && opts.biff == 12) return [blob.read_shift(4, 'i'), 0];
		var row = blob.read_shift(2);
		var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [row, col];
	}
	
	/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */
	function parse_PtgErr(blob) { blob.l++; return BErr[blob.read_shift(1)]; }
	
	/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */
	function parse_PtgInt(blob) { blob.l++; return blob.read_shift(2); }
	
	/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */
	function parse_PtgBool(blob) { blob.l++; return blob.read_shift(1)!==0;}
	
	/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */
	function parse_PtgNum(blob) { blob.l++; return parse_Xnum(blob, 8); }
	
	/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */
	function parse_PtgStr(blob, length, opts) { blob.l++; return parse_ShortXLUnicodeString(blob, length-1, opts); }
	
	/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */
	/* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */
	function parse_SerAr(blob, biff) {
		var val = [blob.read_shift(1)];
		if(biff == 12) switch(val[0]) {
			case 0x02: val[0] = 0x04; break; /* SerBool */
			case 0x04: val[0] = 0x10; break; /* SerErr */
			case 0x00: val[0] = 0x01; break; /* SerNum */
			case 0x01: val[0] = 0x02; break; /* SerStr */
		}
		switch(val[0]) {
			case 0x04: /* SerBool -- boolean */
				val[1] = parsebool(blob, 1) ? 'TRUE' : 'FALSE';
				if(biff != 12) blob.l += 7; break;
			case 0x25: /* appears to be an alias */
			case 0x10: /* SerErr -- error */
				val[1] = BErr[blob[blob.l]];
				blob.l += ((biff == 12) ? 4 : 8); break;
			case 0x00: /* SerNil -- honestly, I'm not sure how to reproduce this */
				blob.l += 8; break;
			case 0x01: /* SerNum -- Xnum */
				val[1] = parse_Xnum(blob, 8); break;
			case 0x02: /* SerStr -- XLUnicodeString (<256 chars) */
				val[1] = parse_XLUnicodeString2(blob, 0, {biff:biff > 0 && biff < 8 ? 2 : biff}); break;
			default: throw new Error("Bad SerAr: " + val[0]); /* Unreachable */
		}
		return val;
	}
	
	/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */
	function parse_PtgExtraMem(blob, cce, opts) {
		var count = blob.read_shift((opts.biff == 12) ? 4 : 2);
		var out = [];
		for(var i = 0; i != count; ++i) out.push(((opts.biff == 12) ? parse_UncheckedRfX : parse_Ref8U)(blob, 8));
		return out;
	}
	
	/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */
	function parse_PtgExtraArray(blob, length, opts) {
		var rows = 0, cols = 0;
		if(opts.biff == 12) {
			rows = blob.read_shift(4); // DRw
			cols = blob.read_shift(4); // DCol
		} else {
			cols = 1 + blob.read_shift(1); //DColByteU
			rows = 1 + blob.read_shift(2); //DRw
		}
		if(opts.biff >= 2 && opts.biff < 8) { --rows; if(--cols == 0) cols = 0x100; }
		// $FlowIgnore
		for(var i = 0, o = []; i != rows && (o[i] = []); ++i)
			for(var j = 0; j != cols; ++j) o[i][j] = parse_SerAr(blob, opts.biff);
		return o;
	}
	
	/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */
	function parse_PtgName(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var w = (!opts || (opts.biff >= 8)) ? 4 : 2;
		var nameindex = blob.read_shift(w);
		switch(opts.biff) {
			case 2: blob.l += 5; break;
			case 3: case 4: blob.l += 8; break;
			case 5: blob.l += 12; break;
		}
		return [type, 0, nameindex];
	}
	
	/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */
	function parse_PtgNameX(blob, length, opts) {
		if(opts.biff == 5) return parse_PtgNameX_BIFF5(blob, length, opts);
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var ixti = blob.read_shift(2); // XtiIndex
		var nameindex = blob.read_shift(4);
		return [type, ixti, nameindex];
	}
	function parse_PtgNameX_BIFF5(blob) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var ixti = blob.read_shift(2, 'i'); // XtiIndex
		blob.l += 8;
		var nameindex = blob.read_shift(2);
		blob.l += 12;
		return [type, ixti, nameindex];
	}
	
	/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */
	function parse_PtgMemArea(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		blob.l += (opts && opts.biff == 2 ? 3 : 4);
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [type, cce];
	}
	
	/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */
	function parse_PtgMemFunc(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [type, cce];
	}
	
	
	/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */
	function parse_PtgRefErr(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		blob.l += 4;
		if(opts.biff < 8) blob.l--;
		if(opts.biff == 12) blob.l += 2;
		return [type];
	}
	
	/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */
	function parse_PtgRefErr3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2);
		var w = 4;
		if(opts) switch(opts.biff) {
			case 5: w = 15; break;
			case 12: w = 6; break;
		}
		blob.l += w;
		return [type, ixti];
	}
	
	/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */
	var parse_PtgMemErr = parsenoop;
	/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */
	var parse_PtgMemNoMem = parsenoop;
	/* [MS-XLS] 2.5.198.92 */
	var parse_PtgTbl = parsenoop;
	
	function parse_PtgElfLoc(blob, length, opts) {
		blob.l += 2;
		return [parse_RgceElfLoc(blob, 4, opts)];
	}
	function parse_PtgElfNoop(blob) {
		blob.l += 6;
		return [];
	}
	/* [MS-XLS] 2.5.198.46 */
	var parse_PtgElfCol = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.47 */
	var parse_PtgElfColS = parse_PtgElfNoop;
	/* [MS-XLS] 2.5.198.48 */
	var parse_PtgElfColSV = parse_PtgElfNoop;
	/* [MS-XLS] 2.5.198.49 */
	var parse_PtgElfColV = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.50 */
	function parse_PtgElfLel(blob) {
		blob.l += 2;
		return [parseuint16(blob), blob.read_shift(2) & 0x01];
	}
	/* [MS-XLS] 2.5.198.51 */
	var parse_PtgElfRadical = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.52 */
	var parse_PtgElfRadicalLel = parse_PtgElfLel;
	/* [MS-XLS] 2.5.198.53 */
	var parse_PtgElfRadicalS = parse_PtgElfNoop;
	/* [MS-XLS] 2.5.198.54 */
	var parse_PtgElfRw = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.55 */
	var parse_PtgElfRwV = parse_PtgElfLoc;
	
	/* [MS-XLSB] 2.5.97.52 TODO */
	var PtgListRT = [
		"Data",
		"All",
		"Headers",
		"??",
		"?Data2",
		"??",
		"?DataHeaders",
		"??",
		"Totals",
		"??",
		"??",
		"??",
		"?DataTotals",
		"??",
		"??",
		"??",
		"?Current"
	];
	function parse_PtgList(blob) {
		blob.l += 2;
		var ixti = blob.read_shift(2);
		var flags = blob.read_shift(2);
		var idx = blob.read_shift(4);
		var c = blob.read_shift(2);
		var C = blob.read_shift(2);
		var rt = PtgListRT[(flags >> 2) & 0x1F];
		return {ixti: ixti, coltype:(flags&0x3), rt:rt, idx:idx, c:c, C:C};
	}
	/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */
	function parse_PtgSxName(blob) {
		blob.l += 2;
		return [blob.read_shift(4)];
	}
	
	/* [XLS] old spec */
	function parse_PtgSheet(blob, length, opts) {
		blob.l += 5;
		blob.l += 2;
		blob.l += (opts.biff == 2 ? 1 : 4);
		return ["PTGSHEET"];
	}
	function parse_PtgEndSheet(blob, length, opts) {
		blob.l += (opts.biff == 2 ? 4 : 5);
		return ["PTGENDSHEET"];
	}
	function parse_PtgMemAreaN(blob) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var cce = blob.read_shift(2);
		return [type, cce];
	}
	function parse_PtgMemNoMemN(blob) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var cce = blob.read_shift(2);
		return [type, cce];
	}
	function parse_PtgAttrNoop(blob) {
		blob.l += 4;
		return [0, 0];
	}
	
	/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */
	var PtgTypes = {
	0x01: { n:'PtgExp', f:parse_PtgExp },
	0x02: { n:'PtgTbl', f:parse_PtgTbl },
	0x03: { n:'PtgAdd', f:parseread1 },
	0x04: { n:'PtgSub', f:parseread1 },
	0x05: { n:'PtgMul', f:parseread1 },
	0x06: { n:'PtgDiv', f:parseread1 },
	0x07: { n:'PtgPower', f:parseread1 },
	0x08: { n:'PtgConcat', f:parseread1 },
	0x09: { n:'PtgLt', f:parseread1 },
	0x0A: { n:'PtgLe', f:parseread1 },
	0x0B: { n:'PtgEq', f:parseread1 },
	0x0C: { n:'PtgGe', f:parseread1 },
	0x0D: { n:'PtgGt', f:parseread1 },
	0x0E: { n:'PtgNe', f:parseread1 },
	0x0F: { n:'PtgIsect', f:parseread1 },
	0x10: { n:'PtgUnion', f:parseread1 },
	0x11: { n:'PtgRange', f:parseread1 },
	0x12: { n:'PtgUplus', f:parseread1 },
	0x13: { n:'PtgUminus', f:parseread1 },
	0x14: { n:'PtgPercent', f:parseread1 },
	0x15: { n:'PtgParen', f:parseread1 },
	0x16: { n:'PtgMissArg', f:parseread1 },
	0x17: { n:'PtgStr', f:parse_PtgStr },
	0x1A: { n:'PtgSheet', f:parse_PtgSheet },
	0x1B: { n:'PtgEndSheet', f:parse_PtgEndSheet },
	0x1C: { n:'PtgErr', f:parse_PtgErr },
	0x1D: { n:'PtgBool', f:parse_PtgBool },
	0x1E: { n:'PtgInt', f:parse_PtgInt },
	0x1F: { n:'PtgNum', f:parse_PtgNum },
	0x20: { n:'PtgArray', f:parse_PtgArray },
	0x21: { n:'PtgFunc', f:parse_PtgFunc },
	0x22: { n:'PtgFuncVar', f:parse_PtgFuncVar },
	0x23: { n:'PtgName', f:parse_PtgName },
	0x24: { n:'PtgRef', f:parse_PtgRef },
	0x25: { n:'PtgArea', f:parse_PtgArea },
	0x26: { n:'PtgMemArea', f:parse_PtgMemArea },
	0x27: { n:'PtgMemErr', f:parse_PtgMemErr },
	0x28: { n:'PtgMemNoMem', f:parse_PtgMemNoMem },
	0x29: { n:'PtgMemFunc', f:parse_PtgMemFunc },
	0x2A: { n:'PtgRefErr', f:parse_PtgRefErr },
	0x2B: { n:'PtgAreaErr', f:parse_PtgAreaErr },
	0x2C: { n:'PtgRefN', f:parse_PtgRefN },
	0x2D: { n:'PtgAreaN', f:parse_PtgAreaN },
	0x2E: { n:'PtgMemAreaN', f:parse_PtgMemAreaN },
	0x2F: { n:'PtgMemNoMemN', f:parse_PtgMemNoMemN },
	0x39: { n:'PtgNameX', f:parse_PtgNameX },
	0x3A: { n:'PtgRef3d', f:parse_PtgRef3d },
	0x3B: { n:'PtgArea3d', f:parse_PtgArea3d },
	0x3C: { n:'PtgRefErr3d', f:parse_PtgRefErr3d },
	0x3D: { n:'PtgAreaErr3d', f:parse_PtgAreaErr3d },
	0xFF: {}
	};
	/* These are duplicated in the PtgTypes table */
	var PtgDupes = {
	0x40: 0x20, 0x60: 0x20,
	0x41: 0x21, 0x61: 0x21,
	0x42: 0x22, 0x62: 0x22,
	0x43: 0x23, 0x63: 0x23,
	0x44: 0x24, 0x64: 0x24,
	0x45: 0x25, 0x65: 0x25,
	0x46: 0x26, 0x66: 0x26,
	0x47: 0x27, 0x67: 0x27,
	0x48: 0x28, 0x68: 0x28,
	0x49: 0x29, 0x69: 0x29,
	0x4A: 0x2A, 0x6A: 0x2A,
	0x4B: 0x2B, 0x6B: 0x2B,
	0x4C: 0x2C, 0x6C: 0x2C,
	0x4D: 0x2D, 0x6D: 0x2D,
	0x4E: 0x2E, 0x6E: 0x2E,
	0x4F: 0x2F, 0x6F: 0x2F,
	0x58: 0x22, 0x78: 0x22,
	0x59: 0x39, 0x79: 0x39,
	0x5A: 0x3A, 0x7A: 0x3A,
	0x5B: 0x3B, 0x7B: 0x3B,
	0x5C: 0x3C, 0x7C: 0x3C,
	0x5D: 0x3D, 0x7D: 0x3D
	};
	
	var Ptg18 = {
	0x01: { n:'PtgElfLel', f:parse_PtgElfLel },
	0x02: { n:'PtgElfRw', f:parse_PtgElfRw },
	0x03: { n:'PtgElfCol', f:parse_PtgElfCol },
	0x06: { n:'PtgElfRwV', f:parse_PtgElfRwV },
	0x07: { n:'PtgElfColV', f:parse_PtgElfColV },
	0x0A: { n:'PtgElfRadical', f:parse_PtgElfRadical },
	0x0B: { n:'PtgElfRadicalS', f:parse_PtgElfRadicalS },
	0x0D: { n:'PtgElfColS', f:parse_PtgElfColS },
	0x0F: { n:'PtgElfColSV', f:parse_PtgElfColSV },
	0x10: { n:'PtgElfRadicalLel', f:parse_PtgElfRadicalLel },
	0x19: { n:'PtgList', f:parse_PtgList },
	0x1D: { n:'PtgSxName', f:parse_PtgSxName },
	0xFF: {}
	};
	var Ptg19 = {
	0x00: { n:'PtgAttrNoop', f:parse_PtgAttrNoop },
	0x01: { n:'PtgAttrSemi', f:parse_PtgAttrSemi },
	0x02: { n:'PtgAttrIf', f:parse_PtgAttrIf },
	0x04: { n:'PtgAttrChoose', f:parse_PtgAttrChoose },
	0x08: { n:'PtgAttrGoto', f:parse_PtgAttrGoto },
	0x10: { n:'PtgAttrSum', f:parse_PtgAttrSum },
	0x20: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
	0x21: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
	0x40: { n:'PtgAttrSpace', f:parse_PtgAttrSpace },
	0x41: { n:'PtgAttrSpaceSemi', f:parse_PtgAttrSpaceSemi },
	0x80: { n:'PtgAttrIfError', f:parse_PtgAttrIfError },
	0xFF: {}
	};
	
	/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */
	function parse_RgbExtra(blob, length, rgce, opts) {
		if(opts.biff < 8) return parsenoop(blob, length);
		var target = blob.l + length;
		var o = [];
		for(var i = 0; i !== rgce.length; ++i) {
			switch(rgce[i][0]) {
				case 'PtgArray': /* PtgArray -> PtgExtraArray */
					rgce[i][1] = parse_PtgExtraArray(blob, 0, opts);
					o.push(rgce[i][1]);
					break;
				case 'PtgMemArea': /* PtgMemArea -> PtgExtraMem */
					rgce[i][2] = parse_PtgExtraMem(blob, rgce[i][1], opts);
					o.push(rgce[i][2]);
					break;
				case 'PtgExp': /* PtgExp -> PtgExtraCol */
					if(opts && opts.biff == 12) {
						rgce[i][1][1] = blob.read_shift(4);
						o.push(rgce[i][1]);
					} break;
				case 'PtgList': /* TODO: PtgList -> PtgExtraList */
				case 'PtgElfRadicalS': /* TODO: PtgElfRadicalS -> PtgExtraElf */
				case 'PtgElfColS': /* TODO: PtgElfColS -> PtgExtraElf */
				case 'PtgElfColSV': /* TODO: PtgElfColSV -> PtgExtraElf */
					throw "Unsupported " + rgce[i][0];
				default: break;
			}
		}
		length = target - blob.l;
		/* note: this is technically an error but Excel disregards */
		//if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
		if(length !== 0) o.push(parsenoop(blob, length));
		return o;
	}
	
	/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */
	function parse_Rgce(blob, length, opts) {
		var target = blob.l + length;
		var R, id, ptgs = [];
		while(target != blob.l) {
			length = target - blob.l;
			id = blob[blob.l];
			R = PtgTypes[id] || PtgTypes[PtgDupes[id]];
			if(id === 0x18 || id === 0x19) R = (id === 0x18 ? Ptg18 : Ptg19)[blob[blob.l + 1]];
			if(!R || !R.f) { /*ptgs.push*/(parsenoop(blob, length)); }
			else { ptgs.push([R.n, R.f(blob, length, opts)]); }
		}
		return ptgs;
	}
	
	function stringify_array(f) {
		var o = [];
		for(var i = 0; i < f.length; ++i) {
			var x = f[i], r = [];
			for(var j = 0; j < x.length; ++j) {
				var y = x[j];
				if(y) switch(y[0]) {
					// TODO: handle embedded quotes
					case 0x02:
	r.push('"' + y[1].replace(/"/g,'""') + '"'); break;
					default: r.push(y[1]);
				} else r.push("");
			}
			o.push(r.join(","));
		}
		return o.join(";");
	}
	
	/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */
	var PtgBinOp = {
		PtgAdd: "+",
		PtgConcat: "&",
		PtgDiv: "/",
		PtgEq: "=",
		PtgGe: ">=",
		PtgGt: ">",
		PtgLe: "<=",
		PtgLt: "<",
		PtgMul: "*",
		PtgNe: "<>",
		PtgPower: "^",
		PtgSub: "-"
	};
	
	// List of invalid characters needs to be tested further
	function formula_quote_sheet_name(sname, opts) {
		if(!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
		if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname + "'";
		return sname;
	}
	function get_ixti_raw(supbooks, ixti, opts) {
		if(!supbooks) return "SH33TJSERR0";
		if(opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
		if(!supbooks.XTI) return "SH33TJSERR6";
		var XTI = supbooks.XTI[ixti];
		if(opts.biff < 8) {
			if(ixti > 10000) ixti-= 65536;
			if(ixti < 0) ixti = -ixti;
			return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
		}
		if(!XTI) return "SH33TJSERR1";
		var o = "";
		if(opts.biff > 8) switch(supbooks[XTI[0]][0]) {
			case 0x0165: /* 'BrtSupSelf' */
				o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
			case 0x0166: /* 'BrtSupSame' */
				if(opts.SID != null) return supbooks.SheetNames[opts.SID];
				return "SH33TJSSAME" + supbooks[XTI[0]][0];
			case 0x0163: /* 'BrtSupBookSrc' */
				/* falls through */
			default: return "SH33TJSSRC" + supbooks[XTI[0]][0];
		}
		switch(supbooks[XTI[0]][0][0]) {
			case 0x0401:
				o = XTI[1] == -1 ? "#REF" : (supbooks.SheetNames[XTI[1]] || "SH33TJSERR3");
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
			case 0x3A01: return supbooks[XTI[0]].slice(1).map(function(name) { return name.Name; }).join(";;"); //return "SH33TJSERR8";
			default:
				if(!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
				o = XTI[1] == -1 ? "#REF" : (supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4");
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
		}
	}
	function get_ixti(supbooks, ixti, opts) {
		var ixtiraw = get_ixti_raw(supbooks, ixti, opts);
		return ixtiraw == "#REF" ? ixtiraw : formula_quote_sheet_name(ixtiraw, opts);
	}
	function stringify_formula(formula/*Array<any>*/, range, cell, supbooks, opts) {
		var biff = (opts && opts.biff) || 8;
		var _range = /*range != null ? range :*/ {s:{c:0, r:0},e:{c:0, r:0}};
		var stack = [], e1, e2,  c, ixti=0, nameidx=0, r, sname="";
		if(!formula[0] || !formula[0][0]) return "";
		var last_sp = -1, sp = "";
		for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff) {
			var f = formula[0][ff];
			switch(f[0]) {
				case 'PtgUminus': /* [MS-XLS] 2.5.198.93 */
					stack.push("-" + stack.pop()); break;
				case 'PtgUplus': /* [MS-XLS] 2.5.198.95 */
					stack.push("+" + stack.pop()); break;
				case 'PtgPercent': /* [MS-XLS] 2.5.198.81 */
					stack.push(stack.pop() + "%"); break;
	
				case 'PtgAdd':    /* [MS-XLS] 2.5.198.26 */
				case 'PtgConcat': /* [MS-XLS] 2.5.198.43 */
				case 'PtgDiv':    /* [MS-XLS] 2.5.198.45 */
				case 'PtgEq':     /* [MS-XLS] 2.5.198.56 */
				case 'PtgGe':     /* [MS-XLS] 2.5.198.64 */
				case 'PtgGt':     /* [MS-XLS] 2.5.198.65 */
				case 'PtgLe':     /* [MS-XLS] 2.5.198.68 */
				case 'PtgLt':     /* [MS-XLS] 2.5.198.69 */
				case 'PtgMul':    /* [MS-XLS] 2.5.198.75 */
				case 'PtgNe':     /* [MS-XLS] 2.5.198.78 */
				case 'PtgPower':  /* [MS-XLS] 2.5.198.82 */
				case 'PtgSub':    /* [MS-XLS] 2.5.198.90 */
					e1 = stack.pop(); e2 = stack.pop();
					if(last_sp >= 0) {
						switch(formula[0][last_sp][1][0]) {
							case 0:
								// $FlowIgnore
								sp = fill(" ", formula[0][last_sp][1][1]); break;
							case 1:
								// $FlowIgnore
								sp = fill("\r", formula[0][last_sp][1][1]); break;
							default:
								sp = "";
								// $FlowIgnore
								if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
						}
						e2 = e2 + sp;
						last_sp = -1;
					}
					stack.push(e2+PtgBinOp[f[0]]+e1);
					break;
	
				case 'PtgIsect': /* [MS-XLS] 2.5.198.67 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+" "+e1);
					break;
				case 'PtgUnion': /* [MS-XLS] 2.5.198.94 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+","+e1);
					break;
				case 'PtgRange': /* [MS-XLS] 2.5.198.83 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+":"+e1);
					break;
	
				case 'PtgAttrChoose': /* [MS-XLS] 2.5.198.34 */
					break;
				case 'PtgAttrGoto': /* [MS-XLS] 2.5.198.35 */
					break;
				case 'PtgAttrIf': /* [MS-XLS] 2.5.198.36 */
					break;
				case 'PtgAttrIfError': /* [MS-XLSB] 2.5.97.28 */
					break;
	
	
				case 'PtgRef': /* [MS-XLS] 2.5.198.84 */
	c = shift_cell_xls((f[1][1]), _range, opts);
					stack.push(encode_cell_xls(c, biff));
					break;
				case 'PtgRefN': /* [MS-XLS] 2.5.198.88 */
	c = cell ? shift_cell_xls((f[1][1]), cell, opts) : (f[1][1]);
					stack.push(encode_cell_xls(c, biff));
					break;
				case 'PtgRef3d': /* [MS-XLS] 2.5.198.85 */
	ixti = f[1][1]; c = shift_cell_xls((f[1][2]), _range, opts);
					sname = get_ixti(supbooks, ixti, opts);
					var w = sname; /* IE9 fails on defined names */ // eslint-disable-line no-unused-vars
					stack.push(sname + "!" + encode_cell_xls(c, biff));
					break;
	
				case 'PtgFunc': /* [MS-XLS] 2.5.198.62 */
				case 'PtgFuncVar': /* [MS-XLS] 2.5.198.63 */
					/* f[1] = [argc, func, type] */
					var argc = (f[1][0]), func = (f[1][1]);
					if(!argc) argc = 0;
					argc &= 0x7F;
					var args = argc == 0 ? [] : stack.slice(-argc);
					stack.length -= argc;
					if(func === 'User') func = args.shift();
					stack.push(func + "(" + args.join(",") + ")");
					break;
	
				case 'PtgBool': /* [MS-XLS] 2.5.198.42 */
					stack.push(f[1] ? "TRUE" : "FALSE"); break;
				case 'PtgInt': /* [MS-XLS] 2.5.198.66 */
					stack.push(f[1]); break;
				case 'PtgNum': /* [MS-XLS] 2.5.198.79 TODO: precision? */
					stack.push(String(f[1])); break;
				case 'PtgStr': /* [MS-XLS] 2.5.198.89 */
					// $FlowIgnore
					stack.push('"' + f[1].replace(/"/g, '""') + '"'); break;
				case 'PtgErr': /* [MS-XLS] 2.5.198.57 */
					stack.push(f[1]); break;
				case 'PtgAreaN': /* [MS-XLS] 2.5.198.31 TODO */
	r = shift_range_xls(f[1][1], cell ? {s:cell} : _range, opts);
					stack.push(encode_range_xls((r), opts));
					break;
				case 'PtgArea': /* [MS-XLS] 2.5.198.27 TODO: fixed points */
	r = shift_range_xls(f[1][1], _range, opts);
					stack.push(encode_range_xls((r), opts));
					break;
				case 'PtgArea3d': /* [MS-XLS] 2.5.198.28 TODO */
	ixti = f[1][1]; r = f[1][2];
					sname = get_ixti(supbooks, ixti, opts);
					stack.push(sname + "!" + encode_range_xls((r), opts));
					break;
				case 'PtgAttrSum': /* [MS-XLS] 2.5.198.41 */
					stack.push("SUM(" + stack.pop() + ")");
					break;
	
				case 'PtgAttrBaxcel': /* [MS-XLS] 2.5.198.33 */
				case 'PtgAttrSemi': /* [MS-XLS] 2.5.198.37 */
					break;
	
				case 'PtgName': /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */
					/* f[1] = type, 0, nameindex */
					nameidx = (f[1][2]);
					var lbl = (supbooks.names||[])[nameidx-1] || (supbooks[0]||[])[nameidx];
					var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
					/* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */
					if(name && name.slice(0,6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
					stack.push(name);
					break;
	
				case 'PtgNameX': /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */
					/* f[1] = type, ixti, nameindex */
					var bookidx = (f[1][1]); nameidx = (f[1][2]); var externbook;
					/* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */
					if(opts.biff <= 5) {
						if(bookidx < 0) bookidx = -bookidx;
						if(supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
					} else {
						var o = "";
						if(((supbooks[bookidx]||[])[0]||[])[0] == 0x3A01){/* empty */}
						else if(((supbooks[bookidx]||[])[0]||[])[0] == 0x0401){
							if(supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) {
								o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab-1] + "!";
							}
						}
						else o = supbooks.SheetNames[nameidx-1]+ "!";
						if(supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
						else if(supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
						else {
							var ixtidata = (get_ixti_raw(supbooks, bookidx, opts)||"").split(";;");
							if(ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
							else o += "SH33TJSERRX";
						}
						stack.push(o);
						break;
					}
					if(!externbook) externbook = {Name: "SH33TJSERRY"};
					stack.push(externbook.Name);
					break;
	
				case 'PtgParen': /* [MS-XLS] 2.5.198.80 */
					var lp = '(', rp = ')';
					if(last_sp >= 0) {
						sp = "";
						switch(formula[0][last_sp][1][0]) {
							// $FlowIgnore
							case 2: lp = fill(" ", formula[0][last_sp][1][1]) + lp; break;
							// $FlowIgnore
							case 3: lp = fill("\r", formula[0][last_sp][1][1]) + lp; break;
							// $FlowIgnore
							case 4: rp = fill(" ", formula[0][last_sp][1][1]) + rp; break;
							// $FlowIgnore
							case 5: rp = fill("\r", formula[0][last_sp][1][1]) + rp; break;
							default:
								// $FlowIgnore
								if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
						}
						last_sp = -1;
					}
					stack.push(lp + stack.pop() + rp); break;
	
				case 'PtgRefErr': /* [MS-XLS] 2.5.198.86 */
					stack.push('#REF!'); break;
	
				case 'PtgRefErr3d': /* [MS-XLS] 2.5.198.87 */
					stack.push('#REF!'); break;
	
				case 'PtgExp': /* [MS-XLS] 2.5.198.58 TODO */
					c = {c:(f[1][1]),r:(f[1][0])};
					var q = ({c: cell.c, r:cell.r});
					if(supbooks.sharedf[encode_cell(c)]) {
						var parsedf = (supbooks.sharedf[encode_cell(c)]);
						stack.push(stringify_formula(parsedf, _range, q, supbooks, opts));
					} else {
						var fnd = false;
						for(e1=0;e1!=supbooks.arrayf.length; ++e1) {
							/* TODO: should be something like range_has */
							e2 = supbooks.arrayf[e1];
							if(c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
							if(c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
							stack.push(stringify_formula(e2[1], _range, q, supbooks, opts));
							fnd = true;
							break;
						}
						if(!fnd) stack.push(f[1]);
					}
					break;
	
				case 'PtgArray': /* [MS-XLS] 2.5.198.32 TODO */
					stack.push("{" + stringify_array(f[1]) + "}");
					break;
	
				case 'PtgMemArea': /* [MS-XLS] 2.5.198.70 TODO: confirm this is a non-display */
					//stack.push("(" + f[2].map(encode_range).join(",") + ")");
					break;
	
				case 'PtgAttrSpace': /* [MS-XLS] 2.5.198.38 */
				case 'PtgAttrSpaceSemi': /* [MS-XLS] 2.5.198.39 */
					last_sp = ff;
					break;
	
				case 'PtgTbl': /* [MS-XLS] 2.5.198.92 TODO */
					break;
	
				case 'PtgMemErr': /* [MS-XLS] 2.5.198.71 */
					break;
	
				case 'PtgMissArg': /* [MS-XLS] 2.5.198.74 */
					stack.push("");
					break;
	
				case 'PtgAreaErr': /* [MS-XLS] 2.5.198.29 */
					stack.push("#REF!"); break;
	
				case 'PtgAreaErr3d': /* [MS-XLS] 2.5.198.30 */
					stack.push("#REF!"); break;
	
				case 'PtgList': /* [MS-XLSB] 2.5.97.52 */
					// $FlowIgnore
					stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
					break;
	
				case 'PtgMemAreaN':
				case 'PtgMemNoMemN':
				case 'PtgAttrNoop':
				case 'PtgSheet':
				case 'PtgEndSheet':
					break;
	
				case 'PtgMemFunc': /* [MS-XLS] 2.5.198.72 TODO */
					break;
				case 'PtgMemNoMem': /* [MS-XLS] 2.5.198.73 TODO */
					break;
	
				case 'PtgElfCol': /* [MS-XLS] 2.5.198.46 */
				case 'PtgElfColS': /* [MS-XLS] 2.5.198.47 */
				case 'PtgElfColSV': /* [MS-XLS] 2.5.198.48 */
				case 'PtgElfColV': /* [MS-XLS] 2.5.198.49 */
				case 'PtgElfLel': /* [MS-XLS] 2.5.198.50 */
				case 'PtgElfRadical': /* [MS-XLS] 2.5.198.51 */
				case 'PtgElfRadicalLel': /* [MS-XLS] 2.5.198.52 */
				case 'PtgElfRadicalS': /* [MS-XLS] 2.5.198.53 */
				case 'PtgElfRw': /* [MS-XLS] 2.5.198.54 */
				case 'PtgElfRwV': /* [MS-XLS] 2.5.198.55 */
					throw new Error("Unsupported ELFs");
	
				case 'PtgSxName': /* [MS-XLS] 2.5.198.91 TODO -- find a test case */
					throw new Error('Unrecognized Formula Token: ' + String(f));
				default: throw new Error('Unrecognized Formula Token: ' + String(f));
			}
			var PtgNonDisp = ['PtgAttrSpace', 'PtgAttrSpaceSemi', 'PtgAttrGoto'];
			if(opts.biff != 3) if(last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
				f = formula[0][last_sp];
				var _left = true;
				switch(f[1][0]) {
					/* note: some bad XLSB files omit the PtgParen */
					case 4: _left = false;
					/* falls through */
					case 0:
						// $FlowIgnore
						sp = fill(" ", f[1][1]); break;
					case 5: _left = false;
					/* falls through */
					case 1:
						// $FlowIgnore
						sp = fill("\r", f[1][1]); break;
					default:
						sp = "";
						// $FlowIgnore
						if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
				}
				stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
				last_sp = -1;
			}
		}
		if(stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
		return stack[0];
	}
	
	/* [MS-XLS] 2.5.198.1 TODO */
	function parse_ArrayParsedFormula(blob, length, opts) {
		var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
		var rgcb, cce = blob.read_shift(len); // length of rgce
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		var rgce = parse_Rgce(blob, cce, opts);
		if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
		blob.l = target;
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.3 TODO */
	function parse_XLSCellParsedFormula(blob, length, opts) {
		var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
		var rgcb, cce = blob.read_shift(len); // length of rgce
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		var rgce = parse_Rgce(blob, cce, opts);
		if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
		blob.l = target;
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.21 */
	function parse_NameParsedFormula(blob, length, opts, cce) {
		var target = blob.l + length;
		var rgce = parse_Rgce(blob, cce, opts);
		var rgcb;
		if(target !== blob.l) rgcb = parse_RgbExtra(blob, target - blob.l, rgce, opts);
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.118 TODO */
	function parse_SharedParsedFormula(blob, length, opts) {
		var target = blob.l + length;
		var rgcb, cce = blob.read_shift(2); // length of rgce
		var rgce = parse_Rgce(blob, cce, opts);
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		if(length !== cce + 2) rgcb = parse_RgbExtra(blob, target - cce - 2, rgce, opts);
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */
	function parse_FormulaValue(blob) {
		var b;
		if(__readUInt16LE(blob,blob.l + 6) !== 0xFFFF) return [parse_Xnum(blob),'n'];
		switch(blob[blob.l]) {
			case 0x00: blob.l += 8; return ["String", 's'];
			case 0x01: b = blob[blob.l+2] === 0x1; blob.l += 8; return [b,'b'];
			case 0x02: b = blob[blob.l+2]; blob.l += 8; return [b,'e'];
			case 0x03: blob.l += 8; return ["",'s'];
		}
		return [];
	}
	function write_FormulaValue(value) {
		if(value == null) {
			// Blank String Value
			var o = new_buf(8);
			o.write_shift(1, 0x03);
			o.write_shift(1, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0xFFFF);
			return o;
		} else if(typeof value == "number") return write_Xnum(value);
		return write_Xnum(0);
	}
	
	/* [MS-XLS] 2.4.127 TODO */
	function parse_Formula(blob, length, opts) {
		var end = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2) ++blob.l;
		var val = parse_FormulaValue(blob,8);
		var flags = blob.read_shift(1);
		if(opts.biff != 2) {
			blob.read_shift(1);
			if(opts.biff >= 5) {
				/*var chn = */blob.read_shift(4);
			}
		}
		var cbf = parse_XLSCellParsedFormula(blob, end - blob.l, opts);
		return {cell:cell, val:val[0], formula:cbf, shared: (flags >> 3) & 1, tt:val[1]};
	}
	function write_Formula(cell, R, C, opts, os) {
		// Cell
		var o1 = write_XLSCell(R, C, os);
	
		// FormulaValue
		var o2 = write_FormulaValue(cell.v);
	
		// flags + cache
		var o3 = new_buf(6);
		var flags = 0x01 | 0x20;
		o3.write_shift(2, flags);
		o3.write_shift(4, 0);
	
		// CellParsedFormula
		var bf = new_buf(cell.bf.length);
		for(var i = 0; i < cell.bf.length; ++i) bf[i] = cell.bf[i];
	
		var out = bconcat([o1, o2, o3, bf]);
		return out;
	}
	
	
	/* XLSB Parsed Formula records have the same shape */
	function parse_XLSBParsedFormula(data, length, opts) {
		var cce = data.read_shift(4);
		var rgce = parse_Rgce(data, cce, opts);
		var cb = data.read_shift(4);
		var rgcb = cb > 0 ? parse_RgbExtra(data, cb, rgce, opts) : null;
		return [rgce, rgcb];
	}
	
	/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */
	var parse_XLSBArrayParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.4 CellParsedFormula */
	var parse_XLSBCellParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.8 DVParsedFormula */
	//var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */
	//var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
	/* [MS-XLSB] 2.5.97.12 NameParsedFormula */
	var parse_XLSBNameParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */
	var parse_XLSBSharedParsedFormula = parse_XLSBParsedFormula;
	var Cetab = {
	  0: "BEEP",
	  1: "OPEN",
	  2: "OPEN.LINKS",
	  3: "CLOSE.ALL",
	  4: "SAVE",
	  5: "SAVE.AS",
	  6: "FILE.DELETE",
	  7: "PAGE.SETUP",
	  8: "PRINT",
	  9: "PRINTER.SETUP",
	  10: "QUIT",
	  11: "NEW.WINDOW",
	  12: "ARRANGE.ALL",
	  13: "WINDOW.SIZE",
	  14: "WINDOW.MOVE",
	  15: "FULL",
	  16: "CLOSE",
	  17: "RUN",
	  22: "SET.PRINT.AREA",
	  23: "SET.PRINT.TITLES",
	  24: "SET.PAGE.BREAK",
	  25: "REMOVE.PAGE.BREAK",
	  26: "FONT",
	  27: "DISPLAY",
	  28: "PROTECT.DOCUMENT",
	  29: "PRECISION",
	  30: "A1.R1C1",
	  31: "CALCULATE.NOW",
	  32: "CALCULATION",
	  34: "DATA.FIND",
	  35: "EXTRACT",
	  36: "DATA.DELETE",
	  37: "SET.DATABASE",
	  38: "SET.CRITERIA",
	  39: "SORT",
	  40: "DATA.SERIES",
	  41: "TABLE",
	  42: "FORMAT.NUMBER",
	  43: "ALIGNMENT",
	  44: "STYLE",
	  45: "BORDER",
	  46: "CELL.PROTECTION",
	  47: "COLUMN.WIDTH",
	  48: "UNDO",
	  49: "CUT",
	  50: "COPY",
	  51: "PASTE",
	  52: "CLEAR",
	  53: "PASTE.SPECIAL",
	  54: "EDIT.DELETE",
	  55: "INSERT",
	  56: "FILL.RIGHT",
	  57: "FILL.DOWN",
	  61: "DEFINE.NAME",
	  62: "CREATE.NAMES",
	  63: "FORMULA.GOTO",
	  64: "FORMULA.FIND",
	  65: "SELECT.LAST.CELL",
	  66: "SHOW.ACTIVE.CELL",
	  67: "GALLERY.AREA",
	  68: "GALLERY.BAR",
	  69: "GALLERY.COLUMN",
	  70: "GALLERY.LINE",
	  71: "GALLERY.PIE",
	  72: "GALLERY.SCATTER",
	  73: "COMBINATION",
	  74: "PREFERRED",
	  75: "ADD.OVERLAY",
	  76: "GRIDLINES",
	  77: "SET.PREFERRED",
	  78: "AXES",
	  79: "LEGEND",
	  80: "ATTACH.TEXT",
	  81: "ADD.ARROW",
	  82: "SELECT.CHART",
	  83: "SELECT.PLOT.AREA",
	  84: "PATTERNS",
	  85: "MAIN.CHART",
	  86: "OVERLAY",
	  87: "SCALE",
	  88: "FORMAT.LEGEND",
	  89: "FORMAT.TEXT",
	  90: "EDIT.REPEAT",
	  91: "PARSE",
	  92: "JUSTIFY",
	  93: "HIDE",
	  94: "UNHIDE",
	  95: "WORKSPACE",
	  96: "FORMULA",
	  97: "FORMULA.FILL",
	  98: "FORMULA.ARRAY",
	  99: "DATA.FIND.NEXT",
	  100: "DATA.FIND.PREV",
	  101: "FORMULA.FIND.NEXT",
	  102: "FORMULA.FIND.PREV",
	  103: "ACTIVATE",
	  104: "ACTIVATE.NEXT",
	  105: "ACTIVATE.PREV",
	  106: "UNLOCKED.NEXT",
	  107: "UNLOCKED.PREV",
	  108: "COPY.PICTURE",
	  109: "SELECT",
	  110: "DELETE.NAME",
	  111: "DELETE.FORMAT",
	  112: "VLINE",
	  113: "HLINE",
	  114: "VPAGE",
	  115: "HPAGE",
	  116: "VSCROLL",
	  117: "HSCROLL",
	  118: "ALERT",
	  119: "NEW",
	  120: "CANCEL.COPY",
	  121: "SHOW.CLIPBOARD",
	  122: "MESSAGE",
	  124: "PASTE.LINK",
	  125: "APP.ACTIVATE",
	  126: "DELETE.ARROW",
	  127: "ROW.HEIGHT",
	  128: "FORMAT.MOVE",
	  129: "FORMAT.SIZE",
	  130: "FORMULA.REPLACE",
	  131: "SEND.KEYS",
	  132: "SELECT.SPECIAL",
	  133: "APPLY.NAMES",
	  134: "REPLACE.FONT",
	  135: "FREEZE.PANES",
	  136: "SHOW.INFO",
	  137: "SPLIT",
	  138: "ON.WINDOW",
	  139: "ON.DATA",
	  140: "DISABLE.INPUT",
	  142: "OUTLINE",
	  143: "LIST.NAMES",
	  144: "FILE.CLOSE",
	  145: "SAVE.WORKBOOK",
	  146: "DATA.FORM",
	  147: "COPY.CHART",
	  148: "ON.TIME",
	  149: "WAIT",
	  150: "FORMAT.FONT",
	  151: "FILL.UP",
	  152: "FILL.LEFT",
	  153: "DELETE.OVERLAY",
	  155: "SHORT.MENUS",
	  159: "SET.UPDATE.STATUS",
	  161: "COLOR.PALETTE",
	  162: "DELETE.STYLE",
	  163: "WINDOW.RESTORE",
	  164: "WINDOW.MAXIMIZE",
	  166: "CHANGE.LINK",
	  167: "CALCULATE.DOCUMENT",
	  168: "ON.KEY",
	  169: "APP.RESTORE",
	  170: "APP.MOVE",
	  171: "APP.SIZE",
	  172: "APP.MINIMIZE",
	  173: "APP.MAXIMIZE",
	  174: "BRING.TO.FRONT",
	  175: "SEND.TO.BACK",
	  185: "MAIN.CHART.TYPE",
	  186: "OVERLAY.CHART.TYPE",
	  187: "SELECT.END",
	  188: "OPEN.MAIL",
	  189: "SEND.MAIL",
	  190: "STANDARD.FONT",
	  191: "CONSOLIDATE",
	  192: "SORT.SPECIAL",
	  193: "GALLERY.3D.AREA",
	  194: "GALLERY.3D.COLUMN",
	  195: "GALLERY.3D.LINE",
	  196: "GALLERY.3D.PIE",
	  197: "VIEW.3D",
	  198: "GOAL.SEEK",
	  199: "WORKGROUP",
	  200: "FILL.GROUP",
	  201: "UPDATE.LINK",
	  202: "PROMOTE",
	  203: "DEMOTE",
	  204: "SHOW.DETAIL",
	  206: "UNGROUP",
	  207: "OBJECT.PROPERTIES",
	  208: "SAVE.NEW.OBJECT",
	  209: "SHARE",
	  210: "SHARE.NAME",
	  211: "DUPLICATE",
	  212: "APPLY.STYLE",
	  213: "ASSIGN.TO.OBJECT",
	  214: "OBJECT.PROTECTION",
	  215: "HIDE.OBJECT",
	  216: "SET.EXTRACT",
	  217: "CREATE.PUBLISHER",
	  218: "SUBSCRIBE.TO",
	  219: "ATTRIBUTES",
	  220: "SHOW.TOOLBAR",
	  222: "PRINT.PREVIEW",
	  223: "EDIT.COLOR",
	  224: "SHOW.LEVELS",
	  225: "FORMAT.MAIN",
	  226: "FORMAT.OVERLAY",
	  227: "ON.RECALC",
	  228: "EDIT.SERIES",
	  229: "DEFINE.STYLE",
	  240: "LINE.PRINT",
	  243: "ENTER.DATA",
	  249: "GALLERY.RADAR",
	  250: "MERGE.STYLES",
	  251: "EDITION.OPTIONS",
	  252: "PASTE.PICTURE",
	  253: "PASTE.PICTURE.LINK",
	  254: "SPELLING",
	  256: "ZOOM",
	  259: "INSERT.OBJECT",
	  260: "WINDOW.MINIMIZE",
	  265: "SOUND.NOTE",
	  266: "SOUND.PLAY",
	  267: "FORMAT.SHAPE",
	  268: "EXTEND.POLYGON",
	  269: "FORMAT.AUTO",
	  272: "GALLERY.3D.BAR",
	  273: "GALLERY.3D.SURFACE",
	  274: "FILL.AUTO",
	  276: "CUSTOMIZE.TOOLBAR",
	  277: "ADD.TOOL",
	  278: "EDIT.OBJECT",
	  279: "ON.DOUBLECLICK",
	  280: "ON.ENTRY",
	  281: "WORKBOOK.ADD",
	  282: "WORKBOOK.MOVE",
	  283: "WORKBOOK.COPY",
	  284: "WORKBOOK.OPTIONS",
	  285: "SAVE.WORKSPACE",
	  288: "CHART.WIZARD",
	  289: "DELETE.TOOL",
	  290: "MOVE.TOOL",
	  291: "WORKBOOK.SELECT",
	  292: "WORKBOOK.ACTIVATE",
	  293: "ASSIGN.TO.TOOL",
	  295: "COPY.TOOL",
	  296: "RESET.TOOL",
	  297: "CONSTRAIN.NUMERIC",
	  298: "PASTE.TOOL",
	  302: "WORKBOOK.NEW",
	  305: "SCENARIO.CELLS",
	  306: "SCENARIO.DELETE",
	  307: "SCENARIO.ADD",
	  308: "SCENARIO.EDIT",
	  309: "SCENARIO.SHOW",
	  310: "SCENARIO.SHOW.NEXT",
	  311: "SCENARIO.SUMMARY",
	  312: "PIVOT.TABLE.WIZARD",
	  313: "PIVOT.FIELD.PROPERTIES",
	  314: "PIVOT.FIELD",
	  315: "PIVOT.ITEM",
	  316: "PIVOT.ADD.FIELDS",
	  318: "OPTIONS.CALCULATION",
	  319: "OPTIONS.EDIT",
	  320: "OPTIONS.VIEW",
	  321: "ADDIN.MANAGER",
	  322: "MENU.EDITOR",
	  323: "ATTACH.TOOLBARS",
	  324: "VBAActivate",
	  325: "OPTIONS.CHART",
	  328: "VBA.INSERT.FILE",
	  330: "VBA.PROCEDURE.DEFINITION",
	  336: "ROUTING.SLIP",
	  338: "ROUTE.DOCUMENT",
	  339: "MAIL.LOGON",
	  342: "INSERT.PICTURE",
	  343: "EDIT.TOOL",
	  344: "GALLERY.DOUGHNUT",
	  350: "CHART.TREND",
	  352: "PIVOT.ITEM.PROPERTIES",
	  354: "WORKBOOK.INSERT",
	  355: "OPTIONS.TRANSITION",
	  356: "OPTIONS.GENERAL",
	  370: "FILTER.ADVANCED",
	  373: "MAIL.ADD.MAILER",
	  374: "MAIL.DELETE.MAILER",
	  375: "MAIL.REPLY",
	  376: "MAIL.REPLY.ALL",
	  377: "MAIL.FORWARD",
	  378: "MAIL.NEXT.LETTER",
	  379: "DATA.LABEL",
	  380: "INSERT.TITLE",
	  381: "FONT.PROPERTIES",
	  382: "MACRO.OPTIONS",
	  383: "WORKBOOK.HIDE",
	  384: "WORKBOOK.UNHIDE",
	  385: "WORKBOOK.DELETE",
	  386: "WORKBOOK.NAME",
	  388: "GALLERY.CUSTOM",
	  390: "ADD.CHART.AUTOFORMAT",
	  391: "DELETE.CHART.AUTOFORMAT",
	  392: "CHART.ADD.DATA",
	  393: "AUTO.OUTLINE",
	  394: "TAB.ORDER",
	  395: "SHOW.DIALOG",
	  396: "SELECT.ALL",
	  397: "UNGROUP.SHEETS",
	  398: "SUBTOTAL.CREATE",
	  399: "SUBTOTAL.REMOVE",
	  400: "RENAME.OBJECT",
	  412: "WORKBOOK.SCROLL",
	  413: "WORKBOOK.NEXT",
	  414: "WORKBOOK.PREV",
	  415: "WORKBOOK.TAB.SPLIT",
	  416: "FULL.SCREEN",
	  417: "WORKBOOK.PROTECT",
	  420: "SCROLLBAR.PROPERTIES",
	  421: "PIVOT.SHOW.PAGES",
	  422: "TEXT.TO.COLUMNS",
	  423: "FORMAT.CHARTTYPE",
	  424: "LINK.FORMAT",
	  425: "TRACER.DISPLAY",
	  430: "TRACER.NAVIGATE",
	  431: "TRACER.CLEAR",
	  432: "TRACER.ERROR",
	  433: "PIVOT.FIELD.GROUP",
	  434: "PIVOT.FIELD.UNGROUP",
	  435: "CHECKBOX.PROPERTIES",
	  436: "LABEL.PROPERTIES",
	  437: "LISTBOX.PROPERTIES",
	  438: "EDITBOX.PROPERTIES",
	  439: "PIVOT.REFRESH",
	  440: "LINK.COMBO",
	  441: "OPEN.TEXT",
	  442: "HIDE.DIALOG",
	  443: "SET.DIALOG.FOCUS",
	  444: "ENABLE.OBJECT",
	  445: "PUSHBUTTON.PROPERTIES",
	  446: "SET.DIALOG.DEFAULT",
	  447: "FILTER",
	  448: "FILTER.SHOW.ALL",
	  449: "CLEAR.OUTLINE",
	  450: "FUNCTION.WIZARD",
	  451: "ADD.LIST.ITEM",
	  452: "SET.LIST.ITEM",
	  453: "REMOVE.LIST.ITEM",
	  454: "SELECT.LIST.ITEM",
	  455: "SET.CONTROL.VALUE",
	  456: "SAVE.COPY.AS",
	  458: "OPTIONS.LISTS.ADD",
	  459: "OPTIONS.LISTS.DELETE",
	  460: "SERIES.AXES",
	  461: "SERIES.X",
	  462: "SERIES.Y",
	  463: "ERRORBAR.X",
	  464: "ERRORBAR.Y",
	  465: "FORMAT.CHART",
	  466: "SERIES.ORDER",
	  467: "MAIL.LOGOFF",
	  468: "CLEAR.ROUTING.SLIP",
	  469: "APP.ACTIVATE.MICROSOFT",
	  470: "MAIL.EDIT.MAILER",
	  471: "ON.SHEET",
	  472: "STANDARD.WIDTH",
	  473: "SCENARIO.MERGE",
	  474: "SUMMARY.INFO",
	  475: "FIND.FILE",
	  476: "ACTIVE.CELL.FONT",
	  477: "ENABLE.TIPWIZARD",
	  478: "VBA.MAKE.ADDIN",
	  480: "INSERTDATATABLE",
	  481: "WORKGROUP.OPTIONS",
	  482: "MAIL.SEND.MAILER",
	  485: "AUTOCORRECT",
	  489: "POST.DOCUMENT",
	  491: "PICKLIST",
	  493: "VIEW.SHOW",
	  494: "VIEW.DEFINE",
	  495: "VIEW.DELETE",
	  509: "SHEET.BACKGROUND",
	  510: "INSERT.MAP.OBJECT",
	  511: "OPTIONS.MENONO",
	  517: "MSOCHECKS",
	  518: "NORMAL",
	  519: "LAYOUT",
	  520: "RM.PRINT.AREA",
	  521: "CLEAR.PRINT.AREA",
	  522: "ADD.PRINT.AREA",
	  523: "MOVE.BRK",
	  545: "HIDECURR.NOTE",
	  546: "HIDEALL.NOTES",
	  547: "DELETE.NOTE",
	  548: "TRAVERSE.NOTES",
	  549: "ACTIVATE.NOTES",
	  620: "PROTECT.REVISIONS",
	  621: "UNPROTECT.REVISIONS",
	  647: "OPTIONS.ME",
	  653: "WEB.PUBLISH",
	  667: "NEWWEBQUERY",
	  673: "PIVOT.TABLE.CHART",
	  753: "OPTIONS.SAVE",
	  755: "OPTIONS.SPELL",
	  808: "HIDEALL.INKANNOTS"
	};
	var Ftab = {
	  0: "COUNT",
	  1: "IF",
	  2: "ISNA",
	  3: "ISERROR",
	  4: "SUM",
	  5: "AVERAGE",
	  6: "MIN",
	  7: "MAX",
	  8: "ROW",
	  9: "COLUMN",
	  10: "NA",
	  11: "NPV",
	  12: "STDEV",
	  13: "DOLLAR",
	  14: "FIXED",
	  15: "SIN",
	  16: "COS",
	  17: "TAN",
	  18: "ATAN",
	  19: "PI",
	  20: "SQRT",
	  21: "EXP",
	  22: "LN",
	  23: "LOG10",
	  24: "ABS",
	  25: "INT",
	  26: "SIGN",
	  27: "ROUND",
	  28: "LOOKUP",
	  29: "INDEX",
	  30: "REPT",
	  31: "MID",
	  32: "LEN",
	  33: "VALUE",
	  34: "TRUE",
	  35: "FALSE",
	  36: "AND",
	  37: "OR",
	  38: "NOT",
	  39: "MOD",
	  40: "DCOUNT",
	  41: "DSUM",
	  42: "DAVERAGE",
	  43: "DMIN",
	  44: "DMAX",
	  45: "DSTDEV",
	  46: "VAR",
	  47: "DVAR",
	  48: "TEXT",
	  49: "LINEST",
	  50: "TREND",
	  51: "LOGEST",
	  52: "GROWTH",
	  53: "GOTO",
	  54: "HALT",
	  55: "RETURN",
	  56: "PV",
	  57: "FV",
	  58: "NPER",
	  59: "PMT",
	  60: "RATE",
	  61: "MIRR",
	  62: "IRR",
	  63: "RAND",
	  64: "MATCH",
	  65: "DATE",
	  66: "TIME",
	  67: "DAY",
	  68: "MONTH",
	  69: "YEAR",
	  70: "WEEKDAY",
	  71: "HOUR",
	  72: "MINUTE",
	  73: "SECOND",
	  74: "NOW",
	  75: "AREAS",
	  76: "ROWS",
	  77: "COLUMNS",
	  78: "OFFSET",
	  79: "ABSREF",
	  80: "RELREF",
	  81: "ARGUMENT",
	  82: "SEARCH",
	  83: "TRANSPOSE",
	  84: "ERROR",
	  85: "STEP",
	  86: "TYPE",
	  87: "ECHO",
	  88: "SET.NAME",
	  89: "CALLER",
	  90: "DEREF",
	  91: "WINDOWS",
	  92: "SERIES",
	  93: "DOCUMENTS",
	  94: "ACTIVE.CELL",
	  95: "SELECTION",
	  96: "RESULT",
	  97: "ATAN2",
	  98: "ASIN",
	  99: "ACOS",
	  100: "CHOOSE",
	  101: "HLOOKUP",
	  102: "VLOOKUP",
	  103: "LINKS",
	  104: "INPUT",
	  105: "ISREF",
	  106: "GET.FORMULA",
	  107: "GET.NAME",
	  108: "SET.VALUE",
	  109: "LOG",
	  110: "EXEC",
	  111: "CHAR",
	  112: "LOWER",
	  113: "UPPER",
	  114: "PROPER",
	  115: "LEFT",
	  116: "RIGHT",
	  117: "EXACT",
	  118: "TRIM",
	  119: "REPLACE",
	  120: "SUBSTITUTE",
	  121: "CODE",
	  122: "NAMES",
	  123: "DIRECTORY",
	  124: "FIND",
	  125: "CELL",
	  126: "ISERR",
	  127: "ISTEXT",
	  128: "ISNUMBER",
	  129: "ISBLANK",
	  130: "T",
	  131: "N",
	  132: "FOPEN",
	  133: "FCLOSE",
	  134: "FSIZE",
	  135: "FREADLN",
	  136: "FREAD",
	  137: "FWRITELN",
	  138: "FWRITE",
	  139: "FPOS",
	  140: "DATEVALUE",
	  141: "TIMEVALUE",
	  142: "SLN",
	  143: "SYD",
	  144: "DDB",
	  145: "GET.DEF",
	  146: "REFTEXT",
	  147: "TEXTREF",
	  148: "INDIRECT",
	  149: "REGISTER",
	  150: "CALL",
	  151: "ADD.BAR",
	  152: "ADD.MENU",
	  153: "ADD.COMMAND",
	  154: "ENABLE.COMMAND",
	  155: "CHECK.COMMAND",
	  156: "RENAME.COMMAND",
	  157: "SHOW.BAR",
	  158: "DELETE.MENU",
	  159: "DELETE.COMMAND",
	  160: "GET.CHART.ITEM",
	  161: "DIALOG.BOX",
	  162: "CLEAN",
	  163: "MDETERM",
	  164: "MINVERSE",
	  165: "MMULT",
	  166: "FILES",
	  167: "IPMT",
	  168: "PPMT",
	  169: "COUNTA",
	  170: "CANCEL.KEY",
	  171: "FOR",
	  172: "WHILE",
	  173: "BREAK",
	  174: "NEXT",
	  175: "INITIATE",
	  176: "REQUEST",
	  177: "POKE",
	  178: "EXECUTE",
	  179: "TERMINATE",
	  180: "RESTART",
	  181: "HELP",
	  182: "GET.BAR",
	  183: "PRODUCT",
	  184: "FACT",
	  185: "GET.CELL",
	  186: "GET.WORKSPACE",
	  187: "GET.WINDOW",
	  188: "GET.DOCUMENT",
	  189: "DPRODUCT",
	  190: "ISNONTEXT",
	  191: "GET.NOTE",
	  192: "NOTE",
	  193: "STDEVP",
	  194: "VARP",
	  195: "DSTDEVP",
	  196: "DVARP",
	  197: "TRUNC",
	  198: "ISLOGICAL",
	  199: "DCOUNTA",
	  200: "DELETE.BAR",
	  201: "UNREGISTER",
	  204: "USDOLLAR",
	  205: "FINDB",
	  206: "SEARCHB",
	  207: "REPLACEB",
	  208: "LEFTB",
	  209: "RIGHTB",
	  210: "MIDB",
	  211: "LENB",
	  212: "ROUNDUP",
	  213: "ROUNDDOWN",
	  214: "ASC",
	  215: "DBCS",
	  216: "RANK",
	  219: "ADDRESS",
	  220: "DAYS360",
	  221: "TODAY",
	  222: "VDB",
	  223: "ELSE",
	  224: "ELSE.IF",
	  225: "END.IF",
	  226: "FOR.CELL",
	  227: "MEDIAN",
	  228: "SUMPRODUCT",
	  229: "SINH",
	  230: "COSH",
	  231: "TANH",
	  232: "ASINH",
	  233: "ACOSH",
	  234: "ATANH",
	  235: "DGET",
	  236: "CREATE.OBJECT",
	  237: "VOLATILE",
	  238: "LAST.ERROR",
	  239: "CUSTOM.UNDO",
	  240: "CUSTOM.REPEAT",
	  241: "FORMULA.CONVERT",
	  242: "GET.LINK.INFO",
	  243: "TEXT.BOX",
	  244: "INFO",
	  245: "GROUP",
	  246: "GET.OBJECT",
	  247: "DB",
	  248: "PAUSE",
	  251: "RESUME",
	  252: "FREQUENCY",
	  253: "ADD.TOOLBAR",
	  254: "DELETE.TOOLBAR",
	  255: "User",
	  256: "RESET.TOOLBAR",
	  257: "EVALUATE",
	  258: "GET.TOOLBAR",
	  259: "GET.TOOL",
	  260: "SPELLING.CHECK",
	  261: "ERROR.TYPE",
	  262: "APP.TITLE",
	  263: "WINDOW.TITLE",
	  264: "SAVE.TOOLBAR",
	  265: "ENABLE.TOOL",
	  266: "PRESS.TOOL",
	  267: "REGISTER.ID",
	  268: "GET.WORKBOOK",
	  269: "AVEDEV",
	  270: "BETADIST",
	  271: "GAMMALN",
	  272: "BETAINV",
	  273: "BINOMDIST",
	  274: "CHIDIST",
	  275: "CHIINV",
	  276: "COMBIN",
	  277: "CONFIDENCE",
	  278: "CRITBINOM",
	  279: "EVEN",
	  280: "EXPONDIST",
	  281: "FDIST",
	  282: "FINV",
	  283: "FISHER",
	  284: "FISHERINV",
	  285: "FLOOR",
	  286: "GAMMADIST",
	  287: "GAMMAINV",
	  288: "CEILING",
	  289: "HYPGEOMDIST",
	  290: "LOGNORMDIST",
	  291: "LOGINV",
	  292: "NEGBINOMDIST",
	  293: "NORMDIST",
	  294: "NORMSDIST",
	  295: "NORMINV",
	  296: "NORMSINV",
	  297: "STANDARDIZE",
	  298: "ODD",
	  299: "PERMUT",
	  300: "POISSON",
	  301: "TDIST",
	  302: "WEIBULL",
	  303: "SUMXMY2",
	  304: "SUMX2MY2",
	  305: "SUMX2PY2",
	  306: "CHITEST",
	  307: "CORREL",
	  308: "COVAR",
	  309: "FORECAST",
	  310: "FTEST",
	  311: "INTERCEPT",
	  312: "PEARSON",
	  313: "RSQ",
	  314: "STEYX",
	  315: "SLOPE",
	  316: "TTEST",
	  317: "PROB",
	  318: "DEVSQ",
	  319: "GEOMEAN",
	  320: "HARMEAN",
	  321: "SUMSQ",
	  322: "KURT",
	  323: "SKEW",
	  324: "ZTEST",
	  325: "LARGE",
	  326: "SMALL",
	  327: "QUARTILE",
	  328: "PERCENTILE",
	  329: "PERCENTRANK",
	  330: "MODE",
	  331: "TRIMMEAN",
	  332: "TINV",
	  334: "MOVIE.COMMAND",
	  335: "GET.MOVIE",
	  336: "CONCATENATE",
	  337: "POWER",
	  338: "PIVOT.ADD.DATA",
	  339: "GET.PIVOT.TABLE",
	  340: "GET.PIVOT.FIELD",
	  341: "GET.PIVOT.ITEM",
	  342: "RADIANS",
	  343: "DEGREES",
	  344: "SUBTOTAL",
	  345: "SUMIF",
	  346: "COUNTIF",
	  347: "COUNTBLANK",
	  348: "SCENARIO.GET",
	  349: "OPTIONS.LISTS.GET",
	  350: "ISPMT",
	  351: "DATEDIF",
	  352: "DATESTRING",
	  353: "NUMBERSTRING",
	  354: "ROMAN",
	  355: "OPEN.DIALOG",
	  356: "SAVE.DIALOG",
	  357: "VIEW.GET",
	  358: "GETPIVOTDATA",
	  359: "HYPERLINK",
	  360: "PHONETIC",
	  361: "AVERAGEA",
	  362: "MAXA",
	  363: "MINA",
	  364: "STDEVPA",
	  365: "VARPA",
	  366: "STDEVA",
	  367: "VARA",
	  368: "BAHTTEXT",
	  369: "THAIDAYOFWEEK",
	  370: "THAIDIGIT",
	  371: "THAIMONTHOFYEAR",
	  372: "THAINUMSOUND",
	  373: "THAINUMSTRING",
	  374: "THAISTRINGLENGTH",
	  375: "ISTHAIDIGIT",
	  376: "ROUNDBAHTDOWN",
	  377: "ROUNDBAHTUP",
	  378: "THAIYEAR",
	  379: "RTD",
	  380: "CUBEVALUE",
	  381: "CUBEMEMBER",
	  382: "CUBEMEMBERPROPERTY",
	  383: "CUBERANKEDMEMBER",
	  384: "HEX2BIN",
	  385: "HEX2DEC",
	  386: "HEX2OCT",
	  387: "DEC2BIN",
	  388: "DEC2HEX",
	  389: "DEC2OCT",
	  390: "OCT2BIN",
	  391: "OCT2HEX",
	  392: "OCT2DEC",
	  393: "BIN2DEC",
	  394: "BIN2OCT",
	  395: "BIN2HEX",
	  396: "IMSUB",
	  397: "IMDIV",
	  398: "IMPOWER",
	  399: "IMABS",
	  400: "IMSQRT",
	  401: "IMLN",
	  402: "IMLOG2",
	  403: "IMLOG10",
	  404: "IMSIN",
	  405: "IMCOS",
	  406: "IMEXP",
	  407: "IMARGUMENT",
	  408: "IMCONJUGATE",
	  409: "IMAGINARY",
	  410: "IMREAL",
	  411: "COMPLEX",
	  412: "IMSUM",
	  413: "IMPRODUCT",
	  414: "SERIESSUM",
	  415: "FACTDOUBLE",
	  416: "SQRTPI",
	  417: "QUOTIENT",
	  418: "DELTA",
	  419: "GESTEP",
	  420: "ISEVEN",
	  421: "ISODD",
	  422: "MROUND",
	  423: "ERF",
	  424: "ERFC",
	  425: "BESSELJ",
	  426: "BESSELK",
	  427: "BESSELY",
	  428: "BESSELI",
	  429: "XIRR",
	  430: "XNPV",
	  431: "PRICEMAT",
	  432: "YIELDMAT",
	  433: "INTRATE",
	  434: "RECEIVED",
	  435: "DISC",
	  436: "PRICEDISC",
	  437: "YIELDDISC",
	  438: "TBILLEQ",
	  439: "TBILLPRICE",
	  440: "TBILLYIELD",
	  441: "PRICE",
	  442: "YIELD",
	  443: "DOLLARDE",
	  444: "DOLLARFR",
	  445: "NOMINAL",
	  446: "EFFECT",
	  447: "CUMPRINC",
	  448: "CUMIPMT",
	  449: "EDATE",
	  450: "EOMONTH",
	  451: "YEARFRAC",
	  452: "COUPDAYBS",
	  453: "COUPDAYS",
	  454: "COUPDAYSNC",
	  455: "COUPNCD",
	  456: "COUPNUM",
	  457: "COUPPCD",
	  458: "DURATION",
	  459: "MDURATION",
	  460: "ODDLPRICE",
	  461: "ODDLYIELD",
	  462: "ODDFPRICE",
	  463: "ODDFYIELD",
	  464: "RANDBETWEEN",
	  465: "WEEKNUM",
	  466: "AMORDEGRC",
	  467: "AMORLINC",
	  468: "CONVERT",
	  724: "SHEETJS",
	  469: "ACCRINT",
	  470: "ACCRINTM",
	  471: "WORKDAY",
	  472: "NETWORKDAYS",
	  473: "GCD",
	  474: "MULTINOMIAL",
	  475: "LCM",
	  476: "FVSCHEDULE",
	  477: "CUBEKPIMEMBER",
	  478: "CUBESET",
	  479: "CUBESETCOUNT",
	  480: "IFERROR",
	  481: "COUNTIFS",
	  482: "SUMIFS",
	  483: "AVERAGEIF",
	  484: "AVERAGEIFS"
	};
	var FtabArgc = {
	  2: 1,
	  3: 1,
	  10: 0,
	  15: 1,
	  16: 1,
	  17: 1,
	  18: 1,
	  19: 0,
	  20: 1,
	  21: 1,
	  22: 1,
	  23: 1,
	  24: 1,
	  25: 1,
	  26: 1,
	  27: 2,
	  30: 2,
	  31: 3,
	  32: 1,
	  33: 1,
	  34: 0,
	  35: 0,
	  38: 1,
	  39: 2,
	  40: 3,
	  41: 3,
	  42: 3,
	  43: 3,
	  44: 3,
	  45: 3,
	  47: 3,
	  48: 2,
	  53: 1,
	  61: 3,
	  63: 0,
	  65: 3,
	  66: 3,
	  67: 1,
	  68: 1,
	  69: 1,
	  70: 1,
	  71: 1,
	  72: 1,
	  73: 1,
	  74: 0,
	  75: 1,
	  76: 1,
	  77: 1,
	  79: 2,
	  80: 2,
	  83: 1,
	  85: 0,
	  86: 1,
	  89: 0,
	  90: 1,
	  94: 0,
	  95: 0,
	  97: 2,
	  98: 1,
	  99: 1,
	  101: 3,
	  102: 3,
	  105: 1,
	  106: 1,
	  108: 2,
	  111: 1,
	  112: 1,
	  113: 1,
	  114: 1,
	  117: 2,
	  118: 1,
	  119: 4,
	  121: 1,
	  126: 1,
	  127: 1,
	  128: 1,
	  129: 1,
	  130: 1,
	  131: 1,
	  133: 1,
	  134: 1,
	  135: 1,
	  136: 2,
	  137: 2,
	  138: 2,
	  140: 1,
	  141: 1,
	  142: 3,
	  143: 4,
	  144: 4,
	  161: 1,
	  162: 1,
	  163: 1,
	  164: 1,
	  165: 2,
	  172: 1,
	  175: 2,
	  176: 2,
	  177: 3,
	  178: 2,
	  179: 1,
	  184: 1,
	  186: 1,
	  189: 3,
	  190: 1,
	  195: 3,
	  196: 3,
	  197: 1,
	  198: 1,
	  199: 3,
	  201: 1,
	  207: 4,
	  210: 3,
	  211: 1,
	  212: 2,
	  213: 2,
	  214: 1,
	  215: 1,
	  225: 0,
	  229: 1,
	  230: 1,
	  231: 1,
	  232: 1,
	  233: 1,
	  234: 1,
	  235: 3,
	  244: 1,
	  247: 4,
	  252: 2,
	  257: 1,
	  261: 1,
	  271: 1,
	  273: 4,
	  274: 2,
	  275: 2,
	  276: 2,
	  277: 3,
	  278: 3,
	  279: 1,
	  280: 3,
	  281: 3,
	  282: 3,
	  283: 1,
	  284: 1,
	  285: 2,
	  286: 4,
	  287: 3,
	  288: 2,
	  289: 4,
	  290: 3,
	  291: 3,
	  292: 3,
	  293: 4,
	  294: 1,
	  295: 3,
	  296: 1,
	  297: 3,
	  298: 1,
	  299: 2,
	  300: 3,
	  301: 3,
	  302: 4,
	  303: 2,
	  304: 2,
	  305: 2,
	  306: 2,
	  307: 2,
	  308: 2,
	  309: 3,
	  310: 2,
	  311: 2,
	  312: 2,
	  313: 2,
	  314: 2,
	  315: 2,
	  316: 4,
	  325: 2,
	  326: 2,
	  327: 2,
	  328: 2,
	  331: 2,
	  332: 2,
	  337: 2,
	  342: 1,
	  343: 1,
	  346: 2,
	  347: 1,
	  350: 4,
	  351: 3,
	  352: 1,
	  353: 2,
	  360: 1,
	  368: 1,
	  369: 1,
	  370: 1,
	  371: 1,
	  372: 1,
	  373: 1,
	  374: 1,
	  375: 1,
	  376: 1,
	  377: 1,
	  378: 1,
	  382: 3,
	  385: 1,
	  392: 1,
	  393: 1,
	  396: 2,
	  397: 2,
	  398: 2,
	  399: 1,
	  400: 1,
	  401: 1,
	  402: 1,
	  403: 1,
	  404: 1,
	  405: 1,
	  406: 1,
	  407: 1,
	  408: 1,
	  409: 1,
	  410: 1,
	  414: 4,
	  415: 1,
	  416: 1,
	  417: 2,
	  420: 1,
	  421: 1,
	  422: 2,
	  424: 1,
	  425: 2,
	  426: 2,
	  427: 2,
	  428: 2,
	  430: 3,
	  438: 3,
	  439: 3,
	  440: 3,
	  443: 2,
	  444: 2,
	  445: 2,
	  446: 2,
	  447: 6,
	  448: 6,
	  449: 2,
	  450: 2,
	  464: 2,
	  468: 3,
	  476: 2,
	  479: 1,
	  480: 2,
	  65535: 0
	};
	/* Part 3 TODO: actually parse formulae */
	function ods_to_csf_formula(f) {
		if(f.slice(0,3) == "of:") f = f.slice(3);
		/* 5.2 Basic Expressions */
		if(f.charCodeAt(0) == 61) {
			f = f.slice(1);
			if(f.charCodeAt(0) == 61) f = f.slice(1);
		}
		f = f.replace(/COM\.MICROSOFT\./g, "");
		/* Part 3 Section 5.8 References */
		f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) { return $1.replace(/\./g,""); });
		/* TODO: something other than this */
		f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
		return f.replace(/[;~]/g,",").replace(/\|/g,";");
	}
	
	function csf_to_ods_formula(f) {
		var o = "of:=" + f.replace(crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g,":");
		/* TODO: something other than this */
		return o.replace(/;/g, "|").replace(/,/g,";");
	}
	
	function ods_to_csf_3D(r) {
		var a = r.split(":");
		var s = a[0].split(".")[0];
		return [s, a[0].split(".")[1] + (a.length > 1 ? (":" + (a[1].split(".")[1] || a[1].split(".")[0])) : "")];
	}
	
	function csf_to_ods_3D(r) {
		return r.replace(/\./,"!");
	}
	
	var strs = {}; // shared strings
	var _ssfopts = {}; // spreadsheet formatting options
	
	
	/*global Map */
	var browser_has_Map = typeof Map !== 'undefined';
	
	function get_sst_id(sst, str, rev) {
		var i = 0, len = sst.length;
		if(rev) {
			if(browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
				var revarr = browser_has_Map ? rev.get(str) : rev[str];
				for(; i < revarr.length; ++i) {
					if(sst[revarr[i]].t === str) { sst.Count ++; return revarr[i]; }
				}
			}
		} else for(; i < len; ++i) {
			if(sst[i].t === str) { sst.Count ++; return i; }
		}
		sst[len] = ({t:str}); sst.Count ++; sst.Unique ++;
		if(rev) {
			if(browser_has_Map) {
				if(!rev.has(str)) rev.set(str, []);
				rev.get(str).push(len);
			} else {
				if(!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
				rev[str].push(len);
			}
		}
		return len;
	}
	
	function col_obj_w(C, col) {
		var p = ({min:C+1,max:C+1});
		/* wch (chars), wpx (pixels) */
		var wch = -1;
		if(col.MDW) MDW = col.MDW;
		if(col.width != null) p.customWidth = 1;
		else if(col.wpx != null) wch = px2char(col.wpx);
		else if(col.wch != null) wch = col.wch;
		if(wch > -1) { p.width = char2width(wch); p.customWidth = 1; }
		else if(col.width != null) p.width = col.width;
		if(col.hidden) p.hidden = true;
		if(col.level != null) { p.outlineLevel = p.level = col.level; }
		return p;
	}
	
	function default_margins(margins, mode) {
		if(!margins) return;
		var defs = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
		if(mode == 'xlml') defs = [1, 1, 1, 1, 0.5, 0.5];
		if(margins.left   == null) margins.left   = defs[0];
		if(margins.right  == null) margins.right  = defs[1];
		if(margins.top    == null) margins.top    = defs[2];
		if(margins.bottom == null) margins.bottom = defs[3];
		if(margins.header == null) margins.header = defs[4];
		if(margins.footer == null) margins.footer = defs[5];
	}
	
	function get_cell_style(styles, cell, opts) {
		var z = opts.revssf[cell.z != null ? cell.z : "General"];
		var i = 0x3c, len = styles.length;
		if(z == null && opts.ssf) {
			for(; i < 0x188; ++i) if(opts.ssf[i] == null) {
				SSF_load(cell.z, i);
				// $FlowIgnore
				opts.ssf[i] = cell.z;
				opts.revssf[cell.z] = z = i;
				break;
			}
		}
		for(i = 0; i != len; ++i) if(styles[i].numFmtId === z) return i;
		styles[len] = {
			numFmtId:z,
			fontId:0,
			fillId:0,
			borderId:0,
			xfId:0,
			applyNumberFormat:1
		};
		return len;
	}
	
	function safe_format(p, fmtid, fillid, opts, themes, styles) {
		try {
			if(opts.cellNF) p.z = table_fmt[fmtid];
		} catch(e) { if(opts.WTF) throw e; }
		if(p.t === 'z' && !opts.cellStyles) return;
		if(p.t === 'd' && typeof p.v === 'string') p.v = parseDate(p.v);
		if((!opts || opts.cellText !== false) && p.t !== 'z') try {
			if(table_fmt[fmtid] == null) SSF_load(SSFImplicit[fmtid] || "General", fmtid);
			if(p.t === 'e') p.w = p.w || BErr[p.v];
			else if(fmtid === 0) {
				if(p.t === 'n') {
					if((p.v|0) === p.v) p.w = p.v.toString(10);
					else p.w = SSF_general_num(p.v);
				}
				else if(p.t === 'd') {
					var dd = datenum(p.v);
					if((dd|0) === dd) p.w = dd.toString(10);
					else p.w = SSF_general_num(dd);
				}
				else if(p.v === undefined) return "";
				else p.w = SSF_general(p.v,_ssfopts);
			}
			else if(p.t === 'd') p.w = SSF_format(fmtid,datenum(p.v),_ssfopts);
			else p.w = SSF_format(fmtid,p.v,_ssfopts);
		} catch(e) { if(opts.WTF) throw e; }
		if(!opts.cellStyles) return;
		if(fillid != null) try {
			p.s = styles.Fills[fillid];
			if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
				p.s.fgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
				if(opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
			}
			if (p.s.bgColor && p.s.bgColor.theme) {
				p.s.bgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
				if(opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
			}
		} catch(e) { if(opts.WTF && styles.Fills) throw e; }
	}
	
	function check_ws(ws, sname, i) {
		if(ws && ws['!ref']) {
			var range = safe_decode_range(ws['!ref']);
			if(range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
		}
	}
	function parse_ws_xml_dim(ws, s) {
		var d = safe_decode_range(s);
		if(d.s.r<=d.e.r && d.s.c<=d.e.c && d.s.r>=0 && d.s.c>=0) ws["!ref"] = encode_range(d);
	}
	var mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
	var sheetdataregex = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;
	var hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
	var dimregex = /"(\w*:\w*)"/;
	var colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g;
	var afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
	var marginregex= /<(?:\w:)?pageMargins[^>]*\/>/g;
	var sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;
	var sheetprregex2= /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/;
	var svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
	
	/* 18.3 Worksheets */
	function parse_ws_xml(data, opts, idx, rels, wb, themes, styles) {
		if(!data) return data;
		if(!rels) rels = {'!id':{}};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
	
		/* 18.3.1.99 worksheet CT_Worksheet */
		var s = opts.dense ? ([]) : ({});
		var refguess = ({s: {r:2000000, c:2000000}, e: {r:0, c:0} });
	
		var data1 = "", data2 = "";
		var mtch = data.match(sheetdataregex);
		if(mtch) {
			data1 = data.slice(0, mtch.index);
			data2 = data.slice(mtch.index + mtch[0].length);
		} else data1 = data2 = data;
	
		/* 18.3.1.82 sheetPr CT_SheetPr */
		var sheetPr = data1.match(sheetprregex);
		if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
		else if((sheetPr = data1.match(sheetprregex2))) parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1]||"", s, wb, idx, styles, themes);
	
		/* 18.3.1.35 dimension CT_SheetDimension */
		var ridx = (data1.match(/<(?:\w*:)?dimension/)||{index:-1}).index;
		if(ridx > 0) {
			var ref = data1.slice(ridx,ridx+50).match(dimregex);
			if(ref) parse_ws_xml_dim(s, ref[1]);
		}
	
		/* 18.3.1.88 sheetViews CT_SheetViews */
		var svs = data1.match(svsregex);
		if(svs && svs[1]) parse_ws_xml_sheetviews(svs[1], wb);
	
		/* 18.3.1.17 cols CT_Cols */
		var columns = [];
		if(opts.cellStyles) {
			/* 18.3.1.13 col CT_Col */
			var cols = data1.match(colregex);
			if(cols) parse_ws_xml_cols(columns, cols);
		}
	
		/* 18.3.1.80 sheetData CT_SheetData ? */
		if(mtch) parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);
	
		/* 18.3.1.2  autoFilter CT_AutoFilter */
		var afilter = data2.match(afregex);
		if(afilter) s['!autofilter'] = parse_ws_xml_autofilter(afilter[0]);
	
		/* 18.3.1.55 mergeCells CT_MergeCells */
		var merges = [];
		var _merge = data2.match(mergecregex);
		if(_merge) for(ridx = 0; ridx != _merge.length; ++ridx)
			merges[ridx] = safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"")+1));
	
		/* 18.3.1.48 hyperlinks CT_Hyperlinks */
		var hlink = data2.match(hlinkregex);
		if(hlink) parse_ws_xml_hlinks(s, hlink, rels);
	
		/* 18.3.1.62 pageMargins CT_PageMargins */
		var margins = data2.match(marginregex);
		if(margins) s['!margins'] = parse_ws_xml_margins(parsexmltag(margins[0]));
	
		if(!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = encode_range(refguess);
		if(opts.sheetRows > 0 && s["!ref"]) {
			var tmpref = safe_decode_range(s["!ref"]);
			if(opts.sheetRows <= +tmpref.e.r) {
				tmpref.e.r = opts.sheetRows - 1;
				if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
				if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
				if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
				if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
				s["!fullref"] = s["!ref"];
				s["!ref"] = encode_range(tmpref);
			}
		}
		if(columns.length > 0) s["!cols"] = columns;
		if(merges.length > 0) s["!merges"] = merges;
		return s;
	}
	
	function write_ws_xml_merges(merges) {
		if(merges.length === 0) return "";
		var o = '<mergeCells count="' + merges.length + '">';
		for(var i = 0; i != merges.length; ++i) o += '<mergeCell ref="' + encode_range(merges[i]) + '"/>';
		return o + '</mergeCells>';
	}
	
	/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */
	function parse_ws_xml_sheetpr(sheetPr, s, wb, idx) {
		var data = parsexmltag(sheetPr);
		if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
		if(data.codeName) wb.Sheets[idx].CodeName = unescapexml(utf8read(data.codeName));
	}
	function parse_ws_xml_sheetpr2(sheetPr, body, s, wb, idx) {
		parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
	}
	function write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
		var needed = false;
		var props = {}, payload = null;
		if(opts.bookType !== 'xlsx' && wb.vbaraw) {
			var cname = wb.SheetNames[idx];
			try { if(wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname; } catch(e) {}
			needed = true;
			props.codeName = utf8write(escapexml(cname));
		}
	
		if(ws && ws["!outline"]) {
			var outlineprops = {summaryBelow:1, summaryRight:1};
			if(ws["!outline"].above) outlineprops.summaryBelow = 0;
			if(ws["!outline"].left) outlineprops.summaryRight = 0;
			payload = (payload||"") + writextag('outlinePr', null, outlineprops);
		}
	
		if(!needed && !payload) return;
		o[o.length] = (writextag('sheetPr', payload, props));
	}
	
	/* 18.3.1.85 sheetProtection CT_SheetProtection */
	var sheetprot_deffalse = ["objects", "scenarios", "selectLockedCells", "selectUnlockedCells"];
	var sheetprot_deftrue = [
		"formatColumns", "formatRows", "formatCells",
		"insertColumns", "insertRows", "insertHyperlinks",
		"deleteColumns", "deleteRows",
		"sort", "autoFilter", "pivotTables"
	];
	function write_ws_xml_protection(sp) {
		// algorithmName, hashValue, saltValue, spinCount
		var o = ({sheet:1});
		sheetprot_deffalse.forEach(function(n) { if(sp[n] != null && sp[n]) o[n] = "1"; });
		sheetprot_deftrue.forEach(function(n) { if(sp[n] != null && !sp[n]) o[n] = "0"; });
		/* TODO: algorithm */
		if(sp.password) o.password = crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
		return writextag('sheetProtection', null, o);
	}
	
	function parse_ws_xml_hlinks(s, data, rels) {
		var dense = Array.isArray(s);
		for(var i = 0; i != data.length; ++i) {
			var val = parsexmltag(utf8read(data[i]), true);
			if(!val.ref) return;
			var rel = ((rels || {})['!id']||[])[val.id];
			if(rel) {
				val.Target = rel.Target;
				if(val.location) val.Target += "#"+unescapexml(val.location);
			} else {
				val.Target = "#" + unescapexml(val.location);
				rel = {Target: val.Target, TargetMode: 'Internal'};
			}
			val.Rel = rel;
			if(val.tooltip) { val.Tooltip = val.tooltip; delete val.tooltip; }
			var rng = safe_decode_range(val.ref);
			for(var R=rng.s.r;R<=rng.e.r;++R) for(var C=rng.s.c;C<=rng.e.c;++C) {
				var addr = encode_cell({c:C,r:R});
				if(dense) {
					if(!s[R]) s[R] = [];
					if(!s[R][C]) s[R][C] = {t:"z",v:undefined};
					s[R][C].l = val;
				} else {
					if(!s[addr]) s[addr] = {t:"z",v:undefined};
					s[addr].l = val;
				}
			}
		}
	}
	
	function parse_ws_xml_margins(margin) {
		var o = {};
		["left", "right", "top", "bottom", "header", "footer"].forEach(function(k) {
			if(margin[k]) o[k] = parseFloat(margin[k]);
		});
		return o;
	}
	function write_ws_xml_margins(margin) {
		default_margins(margin);
		return writextag('pageMargins', null, margin);
	}
	
	function parse_ws_xml_cols(columns, cols) {
		var seencol = false;
		for(var coli = 0; coli != cols.length; ++coli) {
			var coll = parsexmltag(cols[coli], true);
			if(coll.hidden) coll.hidden = parsexmlbool(coll.hidden);
			var colm=parseInt(coll.min, 10)-1, colM=parseInt(coll.max,10)-1;
			if(coll.outlineLevel) coll.level = (+coll.outlineLevel || 0);
			delete coll.min; delete coll.max; coll.width = +coll.width;
			if(!seencol && coll.width) { seencol = true; find_mdw_colw(coll.width); }
			process_col(coll);
			while(colm <= colM) columns[colm++] = dup(coll);
		}
	}
	function write_ws_xml_cols(ws, cols) {
		var o = ["<cols>"], col;
		for(var i = 0; i != cols.length; ++i) {
			if(!(col = cols[i])) continue;
			o[o.length] = (writextag('col', null, col_obj_w(i, col)));
		}
		o[o.length] = "</cols>";
		return o.join("");
	}
	
	function parse_ws_xml_autofilter(data) {
		var o = { ref: (data.match(/ref="([^"]*)"/)||[])[1]};
		return o;
	}
	function write_ws_xml_autofilter(data, ws, wb, idx) {
		var ref = typeof data.ref == "string" ? data.ref : encode_range(data.ref);
		if(!wb.Workbook) wb.Workbook = ({Sheets:[]});
		if(!wb.Workbook.Names) wb.Workbook.Names = [];
		var names = wb.Workbook.Names;
		var range = decode_range(ref);
		if(range.s.r == range.e.r) { range.e.r = decode_range(ws["!ref"]).e.r; ref = encode_range(range); }
		for(var i = 0; i < names.length; ++i) {
			var name = names[i];
			if(name.Name != '_xlnm._FilterDatabase') continue;
			if(name.Sheet != idx) continue;
			name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref; break;
		}
		if(i == names.length) names.push({ Name: '_xlnm._FilterDatabase', Sheet: idx, Ref: "'" + wb.SheetNames[idx] + "'!" + ref  });
		return writextag("autoFilter", null, {ref:ref});
	}
	
	/* 18.3.1.88 sheetViews CT_SheetViews */
	/* 18.3.1.87 sheetView CT_SheetView */
	var sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
	function parse_ws_xml_sheetviews(data, wb) {
		if(!wb.Views) wb.Views = [{}];
		(data.match(sviewregex)||[]).forEach(function(r, i) {
			var tag = parsexmltag(r);
			// $FlowIgnore
			if(!wb.Views[i]) wb.Views[i] = {};
			// $FlowIgnore
			if(+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
			// $FlowIgnore
			if(parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
		});
	}
	function write_ws_xml_sheetviews(ws, opts, idx, wb) {
		var sview = ({workbookViewId:"0"});
		// $FlowIgnore
		if((((wb||{}).Workbook||{}).Views||[])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
		return writextag("sheetViews", writextag("sheetView", null, sview), {});
	}
	
	function write_ws_xml_cell(cell, ref, ws, opts) {
		if(cell.c) ws['!comments'].push([ref, cell.c]);
		if(cell.v === undefined && typeof cell.f !== "string" || cell.t === 'z' && !cell.f) return "";
		var vv = "";
		var oldt = cell.t, oldv = cell.v;
		if(cell.t !== "z") switch(cell.t) {
			case 'b': vv = cell.v ? "1" : "0"; break;
			case 'n': vv = ''+cell.v; break;
			case 'e': vv = BErr[cell.v]; break;
			case 'd':
				if(opts && opts.cellDates) vv = parseDate(cell.v, -1).toISOString();
				else {
					cell = dup(cell);
					cell.t = 'n';
					vv = ''+(cell.v = datenum(parseDate(cell.v)));
				}
				if(typeof cell.z === 'undefined') cell.z = table_fmt[14];
				break;
			default: vv = cell.v; break;
		}
		var v = writetag('v', escapexml(vv)), o = ({r:ref});
		/* TODO: cell style */
		var os = get_cell_style(opts.cellXfs, cell, opts);
		if(os !== 0) o.s = os;
		switch(cell.t) {
			case 'n': break;
			case 'd': o.t = "d"; break;
			case 'b': o.t = "b"; break;
			case 'e': o.t = "e"; break;
			case 'z': break;
			default: if(cell.v == null) { delete cell.t; break; }
				if(cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
				if(opts && opts.bookSST) {
					v = writetag('v', ''+get_sst_id(opts.Strings, cell.v, opts.revStrings));
					o.t = "s"; break;
				}
				o.t = "str"; break;
		}
		if(cell.t != oldt) { cell.t = oldt; cell.v = oldv; }
		if(typeof cell.f == "string" && cell.f) {
			var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {t:"array", ref:cell.F} : null;
			v = writextag('f', escapexml(cell.f), ff) + (cell.v != null ? v : "");
		}
		if(cell.l) ws['!links'].push([ref, cell.l]);
		if(cell.D) o.cm = 1;
		return writextag('c', v, o);
	}
	
	var parse_ws_xml_data = (function() {
		var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
		var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
		var refregex = /ref=["']([^"']*)["']/;
		var match_v = matchtag("v"), match_f = matchtag("f");
	
	return function parse_ws_xml_data(sdata, s, opts, guess, themes, styles) {
		var ri = 0, x = "", cells = [], cref = [], idx=0, i=0, cc=0, d="", p;
		var tag, tagr = 0, tagc = 0;
		var sstr, ftag;
		var fmtid = 0, fillid = 0;
		var do_format = Array.isArray(styles.CellXf), cf;
		var arrayf = [];
		var sharedf = [];
		var dense = Array.isArray(s);
		var rows = [], rowobj = {}, rowrite = false;
		var sheetStubs = !!opts.sheetStubs;
		for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt) {
			x = marr[mt].trim();
			var xlen = x.length;
			if(xlen === 0) continue;
	
			/* 18.3.1.73 row CT_Row */
			var rstarti = 0;
			outa: for(ri = 0; ri < xlen; ++ri) switch(/*x.charCodeAt(ri)*/x[ri]) {
				case ">" /*62*/:
					if(/*x.charCodeAt(ri-1) != 47*/x[ri-1] != "/") { ++ri; break outa; }
					if(opts && opts.cellStyles) {
						// TODO: avoid duplication
						tag = parsexmltag(x.slice(rstarti,ri), true);
						tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
						if(opts.sheetRows && opts.sheetRows < tagr) continue;
						rowobj = {}; rowrite = false;
						if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
						if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
						if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
						if(rowrite) rows[tagr-1] = rowobj;
					}
					break;
				case "<" /*60*/: rstarti = ri; break;
			}
			if(rstarti >= ri) break;
			tag = parsexmltag(x.slice(rstarti,ri), true);
			tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
			if(opts.sheetRows && opts.sheetRows < tagr) continue;
			if(guess.s.r > tagr - 1) guess.s.r = tagr - 1;
			if(guess.e.r < tagr - 1) guess.e.r = tagr - 1;
	
			if(opts && opts.cellStyles) {
				rowobj = {}; rowrite = false;
				if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
				if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
				if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
				if(rowrite) rows[tagr-1] = rowobj;
			}
	
			/* 18.3.1.4 c CT_Cell */
			cells = x.slice(ri).split(cellregex);
			for(var rslice = 0; rslice != cells.length; ++rslice) if(cells[rslice].trim().charAt(0) != "<") break;
			cells = cells.slice(rslice);
			for(ri = 0; ri != cells.length; ++ri) {
				x = cells[ri].trim();
				if(x.length === 0) continue;
				cref = x.match(rregex); idx = ri; i=0; cc=0;
				x = "<c " + (x.slice(0,1)=="<"?">":"") + x;
				if(cref != null && cref.length === 2) {
					idx = 0; d=cref[1];
					for(i=0; i != d.length; ++i) {
						if((cc=d.charCodeAt(i)-64) < 1 || cc > 26) break;
						idx = 26*idx + cc;
					}
					--idx;
					tagc = idx;
				} else ++tagc;
				for(i = 0; i != x.length; ++i) if(x.charCodeAt(i) === 62) break; ++i;
				tag = parsexmltag(x.slice(0,i), true);
				if(!tag.r) tag.r = encode_cell({r:tagr-1, c:tagc});
				d = x.slice(i);
				p = ({t:""});
	
				if((cref=d.match(match_v))!= null && cref[1] !== '') p.v=unescapexml(cref[1]);
				if(opts.cellFormula) {
					if((cref=d.match(match_f))!= null && cref[1] !== '') {
						/* TODO: match against XLSXFutureFunctions */
						p.f=unescapexml(utf8read(cref[1])).replace(/\r\n/g, "\n");
						if(!opts.xlfn) p.f = _xlfn(p.f);
						if(cref[0].indexOf('t="array"') > -1) {
							p.F = (d.match(refregex)||[])[1];
							if(p.F.indexOf(":") > -1) arrayf.push([safe_decode_range(p.F), p.F]);
						} else if(cref[0].indexOf('t="shared"') > -1) {
							// TODO: parse formula
							ftag = parsexmltag(cref[0]);
							var ___f = unescapexml(utf8read(cref[1]));
							if(!opts.xlfn) ___f = _xlfn(___f);
							sharedf[parseInt(ftag.si, 10)] = [ftag, ___f, tag.r];
						}
					} else if((cref=d.match(/<f[^>]*\/>/))) {
						ftag = parsexmltag(cref[0]);
						if(sharedf[ftag.si]) p.f = shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2]/*[0].ref*/, tag.r);
					}
					/* TODO: factor out contains logic */
					var _tag = decode_cell(tag.r);
					for(i = 0; i < arrayf.length; ++i)
						if(_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r)
							if(_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c)
								p.F = arrayf[i][1];
				}
	
				if(tag.t == null && p.v === undefined) {
					if(p.f || p.F) {
						p.v = 0; p.t = "n";
					} else if(!sheetStubs) continue;
					else p.t = "z";
				}
				else p.t = tag.t || "n";
				if(guess.s.c > tagc) guess.s.c = tagc;
				if(guess.e.c < tagc) guess.e.c = tagc;
				/* 18.18.11 t ST_CellType */
				switch(p.t) {
					case 'n':
						if(p.v == "" || p.v == null) {
							if(!sheetStubs) continue;
							p.t = 'z';
						} else p.v = parseFloat(p.v);
						break;
					case 's':
						if(typeof p.v == 'undefined') {
							if(!sheetStubs) continue;
							p.t = 'z';
						} else {
							sstr = strs[parseInt(p.v, 10)];
							p.v = sstr.t;
							p.r = sstr.r;
							if(opts.cellHTML) p.h = sstr.h;
						}
						break;
					case 'str':
						p.t = "s";
						p.v = (p.v!=null) ? utf8read(p.v) : '';
						if(opts.cellHTML) p.h = escapehtml(p.v);
						break;
					case 'inlineStr':
						cref = d.match(isregex);
						p.t = 's';
						if(cref != null && (sstr = parse_si(cref[1]))) {
							p.v = sstr.t;
							if(opts.cellHTML) p.h = sstr.h;
						} else p.v = "";
						break;
					case 'b': p.v = parsexmlbool(p.v); break;
					case 'd':
						if(opts.cellDates) p.v = parseDate(p.v, 1);
						else { p.v = datenum(parseDate(p.v, 1)); p.t = 'n'; }
						break;
					/* error string in .w, number in .v */
					case 'e':
						if(!opts || opts.cellText !== false) p.w = p.v;
						p.v = RBErr[p.v]; break;
				}
				/* formatting */
				fmtid = fillid = 0;
				cf = null;
				if(do_format && tag.s !== undefined) {
					cf = styles.CellXf[tag.s];
					if(cf != null) {
						if(cf.numFmtId != null) fmtid = cf.numFmtId;
						if(opts.cellStyles) {
							if(cf.fillId != null) fillid = cf.fillId;
						}
					}
				}
				safe_format(p, fmtid, fillid, opts, themes, styles);
				if(opts.cellDates && do_format && p.t == 'n' && fmt_is_date(table_fmt[fmtid])) { p.t = 'd'; p.v = numdate(p.v); }
				if(tag.cm && opts.xlmeta) {
					var cm = (opts.xlmeta.Cell||[])[+tag.cm-1];
					if(cm && cm.type == 'XLDAPR') p.D = true;
				}
				if(dense) {
					var _r = decode_cell(tag.r);
					if(!s[_r.r]) s[_r.r] = [];
					s[_r.r][_r.c] = p;
				} else s[tag.r] = p;
			}
		}
		if(rows.length > 0) s['!rows'] = rows;
	}; })();
	
	function write_ws_xml_data(ws, opts, idx, wb) {
		var o = [], r = [], range = safe_decode_range(ws['!ref']), cell="", ref, rr = "", cols = [], R=0, C=0, rows = ws['!rows'];
		var dense = Array.isArray(ws);
		var params = ({r:rr}), row, height = -1;
		for(C = range.s.c; C <= range.e.c; ++C) cols[C] = encode_col(C);
		for(R = range.s.r; R <= range.e.r; ++R) {
			r = [];
			rr = encode_row(R);
			for(C = range.s.c; C <= range.e.c; ++C) {
				ref = cols[C] + rr;
				var _cell = dense ? (ws[R]||[])[C]: ws[ref];
				if(_cell === undefined) continue;
				if((cell = write_ws_xml_cell(_cell, ref, ws, opts, idx, wb)) != null) r.push(cell);
			}
			if(r.length > 0 || (rows && rows[R])) {
				params = ({r:rr});
				if(rows && rows[R]) {
					row = rows[R];
					if(row.hidden) params.hidden = 1;
					height = -1;
					if(row.hpx) height = px2pt(row.hpx);
					else if(row.hpt) height = row.hpt;
					if(height > -1) { params.ht = height; params.customHeight = 1; }
					if(row.level) { params.outlineLevel = row.level; }
				}
				o[o.length] = (writextag('row', r.join(""), params));
			}
		}
		if(rows) for(; R < rows.length; ++R) {
			if(rows && rows[R]) {
				params = ({r:R+1});
				row = rows[R];
				if(row.hidden) params.hidden = 1;
				height = -1;
				if (row.hpx) height = px2pt(row.hpx);
				else if (row.hpt) height = row.hpt;
				if (height > -1) { params.ht = height; params.customHeight = 1; }
				if (row.level) { params.outlineLevel = row.level; }
				o[o.length] = (writextag('row', "", params));
			}
		}
		return o.join("");
	}
	
	function write_ws_xml(idx, opts, wb, rels) {
		var o = [XML_HEADER, writextag('worksheet', null, {
			'xmlns': XMLNS_main[0],
			'xmlns:r': XMLNS.r
		})];
		var s = wb.SheetNames[idx], sidx = 0, rdata = "";
		var ws = wb.Sheets[s];
		if(ws == null) ws = {};
		var ref = ws['!ref'] || 'A1';
		var range = safe_decode_range(ref);
		if(range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
			if(opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
			range.e.c = Math.min(range.e.c, 0x3FFF);
			range.e.r = Math.min(range.e.c, 0xFFFFF);
			ref = encode_range(range);
		}
		if(!rels) rels = {};
		ws['!comments'] = [];
		var _drawing = [];
	
		write_ws_xml_sheetpr(ws, wb, idx, opts, o);
	
		o[o.length] = (writextag('dimension', null, {'ref': ref}));
	
		o[o.length] = write_ws_xml_sheetviews(ws, opts, idx, wb);
	
		/* TODO: store in WB, process styles */
		if(opts.sheetFormat) o[o.length] = (writextag('sheetFormatPr', null, {
			defaultRowHeight:opts.sheetFormat.defaultRowHeight||'16',
			baseColWidth:opts.sheetFormat.baseColWidth||'10',
			outlineLevelRow:opts.sheetFormat.outlineLevelRow||'7'
		}));
	
		if(ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = (write_ws_xml_cols(ws, ws['!cols']));
	
		o[sidx = o.length] = '<sheetData/>';
		ws['!links'] = [];
		if(ws['!ref'] != null) {
			rdata = write_ws_xml_data(ws, opts, idx, wb, rels);
			if(rdata.length > 0) o[o.length] = (rdata);
		}
		if(o.length>sidx+1) { o[o.length] = ('</sheetData>'); o[sidx]=o[sidx].replace("/>",">"); }
	
		/* sheetCalcPr */
	
		if(ws['!protect']) o[o.length] = write_ws_xml_protection(ws['!protect']);
	
		/* protectedRanges */
		/* scenarios */
	
		if(ws['!autofilter'] != null) o[o.length] = write_ws_xml_autofilter(ws['!autofilter'], ws, wb, idx);
	
		/* sortState */
		/* dataConsolidate */
		/* customSheetViews */
	
		if(ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = (write_ws_xml_merges(ws['!merges']));
	
		/* phoneticPr */
		/* conditionalFormatting */
		/* dataValidations */
	
		var relc = -1, rel, rId = -1;
		if(ws['!links'].length > 0) {
			o[o.length] = "<hyperlinks>";
	ws['!links'].forEach(function(l) {
				if(!l[1].Target) return;
				rel = ({"ref":l[0]});
				if(l[1].Target.charAt(0) != "#") {
					rId = add_rels(rels, -1, escapexml(l[1].Target).replace(/#.*$/, ""), RELS.HLINK);
					rel["r:id"] = "rId"+rId;
				}
				if((relc = l[1].Target.indexOf("#")) > -1) rel.location = escapexml(l[1].Target.slice(relc+1));
				if(l[1].Tooltip) rel.tooltip = escapexml(l[1].Tooltip);
				o[o.length] = writextag("hyperlink",null,rel);
			});
			o[o.length] = "</hyperlinks>";
		}
		delete ws['!links'];
	
		/* printOptions */
	
		if(ws['!margins'] != null) o[o.length] =  write_ws_xml_margins(ws['!margins']);
	
		/* pageSetup */
		/* headerFooter */
		/* rowBreaks */
		/* colBreaks */
		/* customProperties */
		/* cellWatches */
	
		if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) o[o.length] = writetag("ignoredErrors", writextag("ignoredError", null, {numberStoredAsText:1, sqref:ref}));
	
		/* smartTags */
	
		if(_drawing.length > 0) {
			rId = add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
			o[o.length] = writextag("drawing", null, {"r:id":"rId" + rId});
			ws['!drawing'] = _drawing;
		}
	
		if(ws['!comments'].length > 0) {
			rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
			o[o.length] = writextag("legacyDrawing", null, {"r:id":"rId" + rId});
			ws['!legacy'] = rId;
		}
	
		/* legacyDrawingHF */
		/* picture */
		/* oleObjects */
		/* controls */
		/* webPublishItems */
		/* tableParts */
		/* extLst */
	
		if(o.length>1) { o[o.length] = ('</worksheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	/* [MS-XLSB] 2.4.726 BrtRowHdr */
	function parse_BrtRowHdr(data, length) {
		var z = ({});
		var tgt = data.l + length;
		z.r = data.read_shift(4);
		data.l += 4; // TODO: ixfe
		var miyRw = data.read_shift(2);
		data.l += 1; // TODO: top/bot padding
		var flags = data.read_shift(1);
		data.l = tgt;
		if(flags & 0x07) z.level = flags & 0x07;
		if(flags & 0x10) z.hidden = true;
		if(flags & 0x20) z.hpt = miyRw / 20;
		return z;
	}
	function write_BrtRowHdr(R, range, ws) {
		var o = new_buf(17+8*16);
		var row = (ws['!rows']||[])[R]||{};
		o.write_shift(4, R);
	
		o.write_shift(4, 0); /* TODO: ixfe */
	
		var miyRw = 0x0140;
		if(row.hpx) miyRw = px2pt(row.hpx) * 20;
		else if(row.hpt) miyRw = row.hpt * 20;
		o.write_shift(2, miyRw);
	
		o.write_shift(1, 0); /* top/bot padding */
	
		var flags = 0x0;
		if(row.level) flags |= row.level;
		if(row.hidden) flags |= 0x10;
		if(row.hpx || row.hpt) flags |= 0x20;
		o.write_shift(1, flags);
	
		o.write_shift(1, 0); /* phonetic guide */
	
		/* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */
		var ncolspan = 0, lcs = o.l;
		o.l += 4;
	
		var caddr = {r:R, c:0};
		for(var i = 0; i < 16; ++i) {
			if((range.s.c > ((i+1) << 10)) || (range.e.c < (i << 10))) continue;
			var first = -1, last = -1;
			for(var j = (i<<10); j < ((i+1)<<10); ++j) {
				caddr.c = j;
				var cell = Array.isArray(ws) ? (ws[caddr.r]||[])[caddr.c] : ws[encode_cell(caddr)];
				if(cell) { if(first < 0) first = j; last = j; }
			}
			if(first < 0) continue;
			++ncolspan;
			o.write_shift(4, first);
			o.write_shift(4, last);
		}
	
		var l = o.l;
		o.l = lcs;
		o.write_shift(4, ncolspan);
		o.l = l;
	
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	function write_row_header(ba, ws, range, R) {
		var o = write_BrtRowHdr(R, range, ws);
		if((o.length > 17) || (ws['!rows']||[])[R]) write_record(ba, 0x0000 /* BrtRowHdr */, o);
	}
	
	/* [MS-XLSB] 2.4.820 BrtWsDim */
	var parse_BrtWsDim = parse_UncheckedRfX;
	var write_BrtWsDim = write_UncheckedRfX;
	
	/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */
	function parse_BrtWsFmtInfo() {
	}
	//function write_BrtWsFmtInfo(ws, o) { }
	
	/* [MS-XLSB] 2.4.823 BrtWsProp */
	function parse_BrtWsProp(data, length) {
		var z = {};
		var f = data[data.l]; ++data.l;
		z.above = !(f & 0x40);
		z.left  = !(f & 0x80);
		/* TODO: pull flags */
		data.l += 18;
		z.name = parse_XLSBCodeName(data, length - 19);
		return z;
	}
	function write_BrtWsProp(str, outl, o) {
		if(o == null) o = new_buf(84+4*str.length);
		var f = 0xC0;
		if(outl) {
			if(outl.above) f &= ~0x40;
			if(outl.left)  f &= ~0x80;
		}
		o.write_shift(1, f);
		for(var i = 1; i < 3; ++i) o.write_shift(1,0);
		write_BrtColor({auto:1}, o);
		o.write_shift(-4,-1);
		o.write_shift(-4,-1);
		write_XLSBCodeName(str, o);
		return o.slice(0, o.l);
	}
	
	/* [MS-XLSB] 2.4.306 BrtCellBlank */
	function parse_BrtCellBlank(data) {
		var cell = parse_XLSBCell(data);
		return [cell];
	}
	function write_BrtCellBlank(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		return write_XLSBCell(ncell, o);
	}
	function parse_BrtShortBlank(data) {
		var cell = parse_XLSBShortCell(data);
		return [cell];
	}
	function write_BrtShortBlank(cell, ncell, o) {
		if(o == null) o = new_buf(4);
		return write_XLSBShortCell(ncell, o);
	}
	
	/* [MS-XLSB] 2.4.307 BrtCellBool */
	function parse_BrtCellBool(data) {
		var cell = parse_XLSBCell(data);
		var fBool = data.read_shift(1);
		return [cell, fBool, 'b'];
	}
	function write_BrtCellBool(cell, ncell, o) {
		if(o == null) o = new_buf(9);
		write_XLSBCell(ncell, o);
		o.write_shift(1, cell.v ? 1 : 0);
		return o;
	}
	function parse_BrtShortBool(data) {
		var cell = parse_XLSBShortCell(data);
		var fBool = data.read_shift(1);
		return [cell, fBool, 'b'];
	}
	function write_BrtShortBool(cell, ncell, o) {
		if(o == null) o = new_buf(5);
		write_XLSBShortCell(ncell, o);
		o.write_shift(1, cell.v ? 1 : 0);
		return o;
	}
	
	/* [MS-XLSB] 2.4.308 BrtCellError */
	function parse_BrtCellError(data) {
		var cell = parse_XLSBCell(data);
		var bError = data.read_shift(1);
		return [cell, bError, 'e'];
	}
	function write_BrtCellError(cell, ncell, o) {
		if(o == null) o = new_buf(9);
		write_XLSBCell(ncell, o);
		o.write_shift(1, cell.v);
		return o;
	}
	function parse_BrtShortError(data) {
		var cell = parse_XLSBShortCell(data);
		var bError = data.read_shift(1);
		return [cell, bError, 'e'];
	}
	function write_BrtShortError(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		write_XLSBShortCell(ncell, o);
		o.write_shift(1, cell.v);
		o.write_shift(2, 0);
		o.write_shift(1, 0);
		return o;
	}
	
	
	/* [MS-XLSB] 2.4.311 BrtCellIsst */
	function parse_BrtCellIsst(data) {
		var cell = parse_XLSBCell(data);
		var isst = data.read_shift(4);
		return [cell, isst, 's'];
	}
	function write_BrtCellIsst(cell, ncell, o) {
		if(o == null) o = new_buf(12);
		write_XLSBCell(ncell, o);
		o.write_shift(4, ncell.v);
		return o;
	}
	function parse_BrtShortIsst(data) {
		var cell = parse_XLSBShortCell(data);
		var isst = data.read_shift(4);
		return [cell, isst, 's'];
	}
	function write_BrtShortIsst(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		write_XLSBShortCell(ncell, o);
		o.write_shift(4, ncell.v);
		return o;
	}
	
	/* [MS-XLSB] 2.4.313 BrtCellReal */
	function parse_BrtCellReal(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_Xnum(data);
		return [cell, value, 'n'];
	}
	function write_BrtCellReal(cell, ncell, o) {
		if(o == null) o = new_buf(16);
		write_XLSBCell(ncell, o);
		write_Xnum(cell.v, o);
		return o;
	}
	function parse_BrtShortReal(data) {
		var cell = parse_XLSBShortCell(data);
		var value = parse_Xnum(data);
		return [cell, value, 'n'];
	}
	function write_BrtShortReal(cell, ncell, o) {
		if(o == null) o = new_buf(12);
		write_XLSBShortCell(ncell, o);
		write_Xnum(cell.v, o);
		return o;
	}
	
	/* [MS-XLSB] 2.4.314 BrtCellRk */
	function parse_BrtCellRk(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_RkNumber(data);
		return [cell, value, 'n'];
	}
	function write_BrtCellRk(cell, ncell, o) {
		if(o == null) o = new_buf(12);
		write_XLSBCell(ncell, o);
		write_RkNumber(cell.v, o);
		return o;
	}
	function parse_BrtShortRk(data) {
		var cell = parse_XLSBShortCell(data);
		var value = parse_RkNumber(data);
		return [cell, value, 'n'];
	}
	function write_BrtShortRk(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		write_XLSBShortCell(ncell, o);
		write_RkNumber(cell.v, o);
		return o;
	}
	
	/* [MS-XLSB] 2.4.323 BrtCellRString */
	function parse_BrtCellRString(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_RichStr(data);
		return [cell, value, 'is'];
	}
	
	/* [MS-XLSB] 2.4.317 BrtCellSt */
	function parse_BrtCellSt(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_XLWideString(data);
		return [cell, value, 'str'];
	}
	function write_BrtCellSt(cell, ncell, o) {
		if(o == null) o = new_buf(12 + 4 * cell.v.length);
		write_XLSBCell(ncell, o);
		write_XLWideString(cell.v, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	function parse_BrtShortSt(data) {
		var cell = parse_XLSBShortCell(data);
		var value = parse_XLWideString(data);
		return [cell, value, 'str'];
	}
	function write_BrtShortSt(cell, ncell, o) {
		if(o == null) o = new_buf(8 + 4 * cell.v.length);
		write_XLSBShortCell(ncell, o);
		write_XLWideString(cell.v, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.653 BrtFmlaBool */
	function parse_BrtFmlaBool(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = data.read_shift(1);
		var o = [cell, value, 'b'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.654 BrtFmlaError */
	function parse_BrtFmlaError(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = data.read_shift(1);
		var o = [cell, value, 'e'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.655 BrtFmlaNum */
	function parse_BrtFmlaNum(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = parse_Xnum(data);
		var o = [cell, value, 'n'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.656 BrtFmlaString */
	function parse_BrtFmlaString(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = parse_XLWideString(data);
		var o = [cell, value, 'str'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.682 BrtMergeCell */
	var parse_BrtMergeCell = parse_UncheckedRfX;
	var write_BrtMergeCell = write_UncheckedRfX;
	/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */
	function write_BrtBeginMergeCells(cnt, o) {
		if(o == null) o = new_buf(4);
		o.write_shift(4, cnt);
		return o;
	}
	
	/* [MS-XLSB] 2.4.662 BrtHLink */
	function parse_BrtHLink(data, length) {
		var end = data.l + length;
		var rfx = parse_UncheckedRfX(data, 16);
		var relId = parse_XLNullableWideString(data);
		var loc = parse_XLWideString(data);
		var tooltip = parse_XLWideString(data);
		var display = parse_XLWideString(data);
		data.l = end;
		var o = ({rfx:rfx, relId:relId, loc:loc, display:display});
		if(tooltip) o.Tooltip = tooltip;
		return o;
	}
	function write_BrtHLink(l, rId) {
		var o = new_buf(50+4*(l[1].Target.length + (l[1].Tooltip || "").length));
		write_UncheckedRfX({s:decode_cell(l[0]), e:decode_cell(l[0])}, o);
		write_RelID("rId" + rId, o);
		var locidx = l[1].Target.indexOf("#");
		var loc = locidx == -1 ? "" : l[1].Target.slice(locidx+1);
		write_XLWideString(loc || "", o);
		write_XLWideString(l[1].Tooltip || "", o);
		write_XLWideString("", o);
		return o.slice(0, o.l);
	}
	
	/* [MS-XLSB] 2.4.692 BrtPane */
	function parse_BrtPane(/*data, length, opts*/) {
	}
	
	/* [MS-XLSB] 2.4.6 BrtArrFmla */
	function parse_BrtArrFmla(data, length, opts) {
		var end = data.l + length;
		var rfx = parse_RfX(data, 16);
		var fAlwaysCalc = data.read_shift(1);
		var o = [rfx]; o[2] = fAlwaysCalc;
		if(opts.cellFormula) {
			var formula = parse_XLSBArrayParsedFormula(data, end - data.l, opts);
			o[1] = formula;
		} else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.750 BrtShrFmla */
	function parse_BrtShrFmla(data, length, opts) {
		var end = data.l + length;
		var rfx = parse_UncheckedRfX(data, 16);
		var o = [rfx];
		if(opts.cellFormula) {
			var formula = parse_XLSBSharedParsedFormula(data, end - data.l, opts);
			o[1] = formula;
			data.l = end;
		} else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.323 BrtColInfo */
	/* TODO: once XLS ColInfo is set, combine the functions */
	function write_BrtColInfo(C, col, o) {
		if(o == null) o = new_buf(18);
		var p = col_obj_w(C, col);
		o.write_shift(-4, C);
		o.write_shift(-4, C);
		o.write_shift(4, (p.width || 10) * 256);
		o.write_shift(4, 0/*ixfe*/); // style
		var flags = 0;
		if(col.hidden) flags |= 0x01;
		if(typeof p.width == 'number') flags |= 0x02;
		if(col.level) flags |= (col.level << 8);
		o.write_shift(2, flags); // bit flag
		return o;
	}
	
	/* [MS-XLSB] 2.4.678 BrtMargins */
	var BrtMarginKeys = ["left","right","top","bottom","header","footer"];
	function parse_BrtMargins(data) {
		var margins = ({});
		BrtMarginKeys.forEach(function(k) { margins[k] = parse_Xnum(data, 8); });
		return margins;
	}
	function write_BrtMargins(margins, o) {
		if(o == null) o = new_buf(6*8);
		default_margins(margins);
		BrtMarginKeys.forEach(function(k) { write_Xnum((margins)[k], o); });
		return o;
	}
	
	/* [MS-XLSB] 2.4.299 BrtBeginWsView */
	function parse_BrtBeginWsView(data) {
		var f = data.read_shift(2);
		data.l += 28;
		return { RTL: f & 0x20 };
	}
	function write_BrtBeginWsView(ws, Workbook, o) {
		if(o == null) o = new_buf(30);
		var f = 0x39c;
		if((((Workbook||{}).Views||[])[0]||{}).RTL) f |= 0x20;
		o.write_shift(2, f); // bit flag
		o.write_shift(4, 0);
		o.write_shift(4, 0); // view first row
		o.write_shift(4, 0); // view first col
		o.write_shift(1, 0); // gridline color ICV
		o.write_shift(1, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 100); // zoom scale
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(4, 0); // workbook view id
		return o;
	}
	
	/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */
	function write_BrtCellIgnoreEC(ref) {
		var o = new_buf(24);
		o.write_shift(4, 4);
		o.write_shift(4, 1);
		write_UncheckedRfX(ref, o);
		return o;
	}
	
	/* [MS-XLSB] 2.4.748 BrtSheetProtection */
	function write_BrtSheetProtection(sp, o) {
		if(o == null) o = new_buf(16*4+2);
		o.write_shift(2, sp.password ? crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
		o.write_shift(4, 1); // this record should not be written if no protection
		[
			["objects",             false], // fObjects
			["scenarios",           false], // fScenarios
			["formatCells",          true], // fFormatCells
			["formatColumns",        true], // fFormatColumns
			["formatRows",           true], // fFormatRows
			["insertColumns",        true], // fInsertColumns
			["insertRows",           true], // fInsertRows
			["insertHyperlinks",     true], // fInsertHyperlinks
			["deleteColumns",        true], // fDeleteColumns
			["deleteRows",           true], // fDeleteRows
			["selectLockedCells",   false], // fSelLockedCells
			["sort",                 true], // fSort
			["autoFilter",           true], // fAutoFilter
			["pivotTables",          true], // fPivotTables
			["selectUnlockedCells", false]  // fSelUnlockedCells
		].forEach(function(n) {
	if(n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
			else      o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
		});
		return o;
	}
	
	function parse_BrtDVal(/*data, length, opts*/) {
	}
	function parse_BrtDVal14(/*data, length, opts*/) {
	}
	/* [MS-XLSB] 2.1.7.61 Worksheet */
	function parse_ws_bin(data, _opts, idx, rels, wb, themes, styles) {
		if(!data) return data;
		var opts = _opts || {};
		if(!rels) rels = {'!id':{}};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var s = (opts.dense ? [] : {});
	
		var ref;
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	
		var state = [];
		var pass = false, end = false;
		var row, p, cf, R, C, addr, sstr, rr, cell;
		var merges = [];
		opts.biff = 12;
		opts['!row'] = 0;
	
		var ai = 0, af = false;
	
		var arrayf = [];
		var sharedf = {};
		var supbooks = opts.supbooks || wb.supbooks || ([[]]);
		supbooks.sharedf = sharedf;
		supbooks.arrayf = arrayf;
		supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) { return x.name; });
		if(!opts.supbooks) {
			opts.supbooks = supbooks;
			if(wb.Names) for(var i = 0; i < wb.Names.length; ++i) supbooks[0][i+1] = wb.Names[i];
		}
	
		var colinfo = [], rowinfo = [];
		var seencol = false;
	
		XLSBRecordEnum[0x0010] = { n:"BrtShortReal", f:parse_BrtShortReal };
	
		var cm, vm;
	
		recordhopper(data, function ws_parse(val, RR, RT) {
			if(end) return;
			switch(RT) {
				case 0x0094: /* 'BrtWsDim' */
					ref = val; break;
				case 0x0000: /* 'BrtRowHdr' */
					row = val;
					if(opts.sheetRows && opts.sheetRows <= row.r) end=true;
					rr = encode_row(R = row.r);
					opts['!row'] = row.r;
					if(val.hidden || val.hpt || val.level != null) {
						if(val.hpt) val.hpx = pt2px(val.hpt);
						rowinfo[val.r] = val;
					}
					break;
	
				case 0x0002: /* 'BrtCellRk' */
				case 0x0003: /* 'BrtCellError' */
				case 0x0004: /* 'BrtCellBool' */
				case 0x0005: /* 'BrtCellReal' */
				case 0x0006: /* 'BrtCellSt' */
				case 0x0007: /* 'BrtCellIsst' */
				case 0x0008: /* 'BrtFmlaString' */
				case 0x0009: /* 'BrtFmlaNum' */
				case 0x000A: /* 'BrtFmlaBool' */
				case 0x000B: /* 'BrtFmlaError' */
				case 0x000D: /* 'BrtShortRk' */
				case 0x000E: /* 'BrtShortError' */
				case 0x000F: /* 'BrtShortBool' */
				case 0x0010: /* 'BrtShortReal' */
				case 0x0011: /* 'BrtShortSt' */
				case 0x0012: /* 'BrtShortIsst' */
				case 0x003E: /* 'BrtCellRString' */
					p = ({t:val[2]});
					switch(val[2]) {
						case 'n': p.v = val[1]; break;
						case 's': sstr = strs[val[1]]; p.v = sstr.t; p.r = sstr.r; break;
						case 'b': p.v = val[1] ? true : false; break;
						case 'e': p.v = val[1]; if(opts.cellText !== false) p.w = BErr[p.v]; break;
						case 'str': p.t = 's'; p.v = val[1]; break;
						case 'is': p.t = 's'; p.v = val[1].t; break;
					}
					if((cf = styles.CellXf[val[0].iStyleRef])) safe_format(p,cf.numFmtId,null,opts, themes, styles);
					C = val[0].c == -1 ? C + 1 : val[0].c;
					if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
					else s[encode_col(C) + rr] = p;
					if(opts.cellFormula) {
						af = false;
						for(ai = 0; ai < arrayf.length; ++ai) {
							var aii = arrayf[ai];
							if(row.r >= aii[0].s.r && row.r <= aii[0].e.r)
								if(C >= aii[0].s.c && C <= aii[0].e.c) {
									p.F = encode_range(aii[0]); af = true;
								}
						}
						if(!af && val.length > 3) p.f = val[3];
					}
	
					if(refguess.s.r > row.r) refguess.s.r = row.r;
					if(refguess.s.c > C) refguess.s.c = C;
					if(refguess.e.r < row.r) refguess.e.r = row.r;
					if(refguess.e.c < C) refguess.e.c = C;
					if(opts.cellDates && cf && p.t == 'n' && fmt_is_date(table_fmt[cf.numFmtId])) {
						var _d = SSF_parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
					}
					if(cm) {
						if(cm.type == 'XLDAPR') p.D = true;
						cm = void 0;
					}
					if(vm) vm = void 0;
					break;
	
				case 0x0001: /* 'BrtCellBlank' */
				case 0x000C: /* 'BrtShortBlank' */
					if(!opts.sheetStubs || pass) break;
					p = ({t:'z',v:void 0});
					C = val[0].c == -1 ? C + 1 : val[0].c;
					if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
					else s[encode_col(C) + rr] = p;
					if(refguess.s.r > row.r) refguess.s.r = row.r;
					if(refguess.s.c > C) refguess.s.c = C;
					if(refguess.e.r < row.r) refguess.e.r = row.r;
					if(refguess.e.c < C) refguess.e.c = C;
					if(cm) {
						if(cm.type == 'XLDAPR') p.D = true;
						cm = void 0;
					}
					if(vm) vm = void 0;
					break;
	
				case 0x00B0: /* 'BrtMergeCell' */
					merges.push(val); break;
	
				case 0x0031: { /* 'BrtCellMeta' */
					cm = ((opts.xlmeta||{}).Cell||[])[val-1];
				} break;
	
				case 0x01EE: /* 'BrtHLink' */
					var rel = rels['!id'][val.relId];
					if(rel) {
						val.Target = rel.Target;
						if(val.loc) val.Target += "#"+val.loc;
						val.Rel = rel;
					} else if(val.relId == '') {
						val.Target = "#" + val.loc;
					}
					for(R=val.rfx.s.r;R<=val.rfx.e.r;++R) for(C=val.rfx.s.c;C<=val.rfx.e.c;++C) {
						if(opts.dense) {
							if(!s[R]) s[R] = [];
							if(!s[R][C]) s[R][C] = {t:'z',v:undefined};
							s[R][C].l = val;
						} else {
							addr = encode_cell({c:C,r:R});
							if(!s[addr]) s[addr] = {t:'z',v:undefined};
							s[addr].l = val;
						}
					}
					break;
	
				case 0x01AA: /* 'BrtArrFmla' */
					if(!opts.cellFormula) break;
					arrayf.push(val);
					cell = ((opts.dense ? s[R][C] : s[encode_col(C) + rr]));
					cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
					cell.F = encode_range(val[0]);
					break;
				case 0x01AB: /* 'BrtShrFmla' */
					if(!opts.cellFormula) break;
					sharedf[encode_cell(val[0].s)] = val[1];
					cell = (opts.dense ? s[R][C] : s[encode_col(C) + rr]);
					cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
					break;
	
				/* identical to 'ColInfo' in XLS */
				case 0x003C: /* 'BrtColInfo' */
					if(!opts.cellStyles) break;
					while(val.e >= val.s) {
						colinfo[val.e--] = { width: val.w/256, hidden: !!(val.flags & 0x01), level: val.level };
						if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
						process_col(colinfo[val.e+1]);
					}
					break;
	
				case 0x00A1: /* 'BrtBeginAFilter' */
					s['!autofilter'] = { ref:encode_range(val) };
					break;
	
				case 0x01DC: /* 'BrtMargins' */
					s['!margins'] = val;
					break;
	
				case 0x0093: /* 'BrtWsProp' */
					if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
					if(val.name) wb.Sheets[idx].CodeName = val.name;
					if(val.above || val.left) s['!outline'] = { above: val.above, left: val.left };
					break;
	
				case 0x0089: /* 'BrtBeginWsView' */
					if(!wb.Views) wb.Views = [{}];
					if(!wb.Views[0]) wb.Views[0] = {};
					if(val.RTL) wb.Views[0].RTL = true;
					break;
	
				case 0x01E5: /* 'BrtWsFmtInfo' */
					break;
	
				case 0x0040: /* 'BrtDVal' */
				case 0x041D: /* 'BrtDVal14' */
					break;
	
				case 0x0097: /* 'BrtPane' */
					break;
				case 0x0098: /* 'BrtSel' */
				case 0x00AF: /* 'BrtAFilterDateGroupItem' */
				case 0x0284: /* 'BrtActiveX' */
				case 0x0271: /* 'BrtBigName' */
				case 0x0232: /* 'BrtBkHim' */
				case 0x018C: /* 'BrtBrk' */
				case 0x0458: /* 'BrtCFIcon' */
				case 0x047A: /* 'BrtCFRuleExt' */
				case 0x01D7: /* 'BrtCFVO' */
				case 0x041A: /* 'BrtCFVO14' */
				case 0x0289: /* 'BrtCellIgnoreEC' */
				case 0x0451: /* 'BrtCellIgnoreEC14' */
				case 0x024D: /* 'BrtCellSmartTagProperty' */
				case 0x025F: /* 'BrtCellWatch' */
				case 0x0234: /* 'BrtColor' */
				case 0x041F: /* 'BrtColor14' */
				case 0x00A8: /* 'BrtColorFilter' */
				case 0x00AE: /* 'BrtCustomFilter' */
				case 0x049C: /* 'BrtCustomFilter14' */
				case 0x01F3: /* 'BrtDRef' */
				case 0x01FB: /* 'BrtDXF' */
				case 0x0226: /* 'BrtDrawing' */
				case 0x00AB: /* 'BrtDynamicFilter' */
				case 0x00A7: /* 'BrtFilter' */
				case 0x0499: /* 'BrtFilter14' */
				case 0x00A9: /* 'BrtIconFilter' */
				case 0x049D: /* 'BrtIconFilter14' */
				case 0x0227: /* 'BrtLegacyDrawing' */
				case 0x0228: /* 'BrtLegacyDrawingHF' */
				case 0x0295: /* 'BrtListPart' */
				case 0x027F: /* 'BrtOleObject' */
				case 0x01DE: /* 'BrtPageSetup' */
				case 0x0219: /* 'BrtPhoneticInfo' */
				case 0x01DD: /* 'BrtPrintOptions' */
				case 0x0218: /* 'BrtRangeProtection' */
				case 0x044F: /* 'BrtRangeProtection14' */
				case 0x02A8: /* 'BrtRangeProtectionIso' */
				case 0x0450: /* 'BrtRangeProtectionIso14' */
				case 0x0400: /* 'BrtRwDescent' */
				case 0x0297: /* 'BrtSheetCalcProp' */
				case 0x0217: /* 'BrtSheetProtection' */
				case 0x02A6: /* 'BrtSheetProtectionIso' */
				case 0x01F8: /* 'BrtSlc' */
				case 0x0413: /* 'BrtSparkline' */
				case 0x01AC: /* 'BrtTable' */
				case 0x00AA: /* 'BrtTop10Filter' */
				case 0x0C00: /* 'BrtUid' */
				case 0x0032: /* 'BrtValueMeta' */
				case 0x0816: /* 'BrtWebExtension' */
				case 0x0415: /* 'BrtWsFmtInfoEx14' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(RT); pass = true; break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); pass = false; break;
	
				default:
					if(RR.T){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		}, opts);
	
		delete opts.supbooks;
		delete opts['!row'];
	
		if(!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = encode_range(ref || refguess);
		if(opts.sheetRows && s["!ref"]) {
			var tmpref = safe_decode_range(s["!ref"]);
			if(opts.sheetRows <= +tmpref.e.r) {
				tmpref.e.r = opts.sheetRows - 1;
				if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
				if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
				if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
				if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
				s["!fullref"] = s["!ref"];
				s["!ref"] = encode_range(tmpref);
			}
		}
		if(merges.length > 0) s["!merges"] = merges;
		if(colinfo.length > 0) s["!cols"] = colinfo;
		if(rowinfo.length > 0) s["!rows"] = rowinfo;
		return s;
	}
	
	/* TODO: something useful -- this is a stub */
	function write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen) {
		if(cell.v === undefined) return false;
		var vv = "";
		switch(cell.t) {
			case 'b': vv = cell.v ? "1" : "0"; break;
			case 'd': // no BrtCellDate :(
				cell = dup(cell);
				cell.z = cell.z || table_fmt[14];
				cell.v = datenum(parseDate(cell.v)); cell.t = 'n';
				break;
			/* falls through */
			case 'n': case 'e': vv = ''+cell.v; break;
			default: vv = cell.v; break;
		}
		var o = ({r:R, c:C});
		/* TODO: cell style */
		o.s = get_cell_style(opts.cellXfs, cell, opts);
		if(cell.l) ws['!links'].push([encode_cell(o), cell.l]);
		if(cell.c) ws['!comments'].push([encode_cell(o), cell.c]);
		switch(cell.t) {
			case 's': case 'str':
				if(opts.bookSST) {
					vv = get_sst_id(opts.Strings, (cell.v), opts.revStrings);
					o.t = "s"; o.v = vv;
					if(last_seen) write_record(ba, 0x0012 /* BrtShortIsst */, write_BrtShortIsst(cell, o));
					else write_record(ba, 0x0007 /* BrtCellIsst */, write_BrtCellIsst(cell, o));
				} else {
					o.t = "str";
					if(last_seen) write_record(ba, 0x0011 /* BrtShortSt */, write_BrtShortSt(cell, o));
					else write_record(ba, 0x0006 /* BrtCellSt */, write_BrtCellSt(cell, o));
				}
				return true;
			case 'n':
				/* TODO: determine threshold for Real vs RK */
				if(cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
					if(last_seen) write_record(ba, 0x000D /* BrtShortRk */, write_BrtShortRk(cell, o));
					else write_record(ba, 0x0002 /* BrtCellRk */, write_BrtCellRk(cell, o));
				} else {
					if(last_seen) write_record(ba, 0x0010 /* BrtShortReal */, write_BrtShortReal(cell, o));
					else write_record(ba, 0x0005 /* BrtCellReal */, write_BrtCellReal(cell, o));
				} return true;
			case 'b':
				o.t = "b";
				if(last_seen) write_record(ba, 0x000F /* BrtShortBool */, write_BrtShortBool(cell, o));
				else write_record(ba, 0x0004 /* BrtCellBool */, write_BrtCellBool(cell, o));
				return true;
			case 'e':
				o.t = "e";
				if(last_seen) write_record(ba, 0x000E /* BrtShortError */, write_BrtShortError(cell, o));
				else write_record(ba, 0x0003 /* BrtCellError */, write_BrtCellError(cell, o));
				return true;
		}
		if(last_seen) write_record(ba, 0x000C /* BrtShortBlank */, write_BrtShortBlank(cell, o));
		else write_record(ba, 0x0001 /* BrtCellBlank */, write_BrtCellBlank(cell, o));
		return true;
	}
	
	function write_CELLTABLE(ba, ws, idx, opts) {
		var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
		write_record(ba, 0x0091 /* BrtBeginSheetData */);
		var dense = Array.isArray(ws);
		var cap = range.e.r;
		if(ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
		for(var R = range.s.r; R <= cap; ++R) {
			rr = encode_row(R);
			/* [ACCELLTABLE] */
			/* BrtRowHdr */
			write_row_header(ba, ws, range, R);
			var last_seen = false;
			if(R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C) {
				/* *16384CELL */
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) { last_seen = false; continue; }
				/* write cell */
				last_seen = write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen);
			}
		}
		write_record(ba, 0x0092 /* BrtEndSheetData */);
	}
	
	function write_MERGECELLS(ba, ws) {
		if(!ws || !ws['!merges']) return;
		write_record(ba, 0x00B1 /* BrtBeginMergeCells */, write_BrtBeginMergeCells(ws['!merges'].length));
		ws['!merges'].forEach(function(m) { write_record(ba, 0x00B0 /* BrtMergeCell */, write_BrtMergeCell(m)); });
		write_record(ba, 0x00B2 /* BrtEndMergeCells */);
	}
	
	function write_COLINFOS(ba, ws) {
		if(!ws || !ws['!cols']) return;
		write_record(ba, 0x0186 /* BrtBeginColInfos */);
		ws['!cols'].forEach(function(m, i) { if(m) write_record(ba, 0x003C /* 'BrtColInfo' */, write_BrtColInfo(i, m)); });
		write_record(ba, 0x0187 /* BrtEndColInfos */);
	}
	
	function write_IGNOREECS(ba, ws) {
		if(!ws || !ws['!ref']) return;
		write_record(ba, 0x0288 /* BrtBeginCellIgnoreECs */);
		write_record(ba, 0x0289 /* BrtCellIgnoreEC */, write_BrtCellIgnoreEC(safe_decode_range(ws['!ref'])));
		write_record(ba, 0x028A /* BrtEndCellIgnoreECs */);
	}
	
	function write_HLINKS(ba, ws, rels) {
		/* *BrtHLink */
		ws['!links'].forEach(function(l) {
			if(!l[1].Target) return;
			var rId = add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), RELS.HLINK);
			write_record(ba, 0x01EE /* BrtHLink */, write_BrtHLink(l, rId));
		});
		delete ws['!links'];
	}
	function write_LEGACYDRAWING(ba, ws, idx, rels) {
		/* [BrtLegacyDrawing] */
		if(ws['!comments'].length > 0) {
			var rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
			write_record(ba, 0x0227 /* BrtLegacyDrawing */, write_RelID("rId" + rId));
			ws['!legacy'] = rId;
		}
	}
	
	function write_AUTOFILTER(ba, ws, wb, idx) {
		if(!ws['!autofilter']) return;
		var data = ws['!autofilter'];
		var ref = typeof data.ref === "string" ? data.ref : encode_range(data.ref);
	
		/* Update FilterDatabase defined name for the worksheet */
		if(!wb.Workbook) wb.Workbook = ({Sheets:[]});
		if(!wb.Workbook.Names) wb.Workbook.Names = [];
		var names = wb.Workbook.Names;
		var range = decode_range(ref);
		if(range.s.r == range.e.r) { range.e.r = decode_range(ws["!ref"]).e.r; ref = encode_range(range); }
		for(var i = 0; i < names.length; ++i) {
			var name = names[i];
			if(name.Name != '_xlnm._FilterDatabase') continue;
			if(name.Sheet != idx) continue;
			name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref; break;
		}
		if(i == names.length) names.push({ Name: '_xlnm._FilterDatabase', Sheet: idx, Ref: "'" + wb.SheetNames[idx] + "'!" + ref  });
	
		write_record(ba, 0x00A1 /* BrtBeginAFilter */, write_UncheckedRfX(safe_decode_range(ref)));
		/* *FILTERCOLUMN */
		/* [SORTSTATE] */
		/* BrtEndAFilter */
		write_record(ba, 0x00A2 /* BrtEndAFilter */);
	}
	
	function write_WSVIEWS2(ba, ws, Workbook) {
		write_record(ba, 0x0085 /* BrtBeginWsViews */);
		{ /* 1*WSVIEW2 */
			/* [ACUID] */
			write_record(ba, 0x0089 /* BrtBeginWsView */, write_BrtBeginWsView(ws, Workbook));
			/* [BrtPane] */
			/* *4BrtSel */
			/* *4SXSELECT */
			/* *FRT */
			write_record(ba, 0x008A /* BrtEndWsView */);
		}
		/* *FRT */
		write_record(ba, 0x0086 /* BrtEndWsViews */);
	}
	
	function write_WSFMTINFO() {
		/* [ACWSFMTINFO] */
		// write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
	}
	
	function write_SHEETPROTECT(ba, ws) {
		if(!ws['!protect']) return;
		/* [BrtSheetProtectionIso] */
		write_record(ba, 0x0217 /* BrtSheetProtection */, write_BrtSheetProtection(ws['!protect']));
	}
	
	function write_ws_bin(idx, opts, wb, rels) {
		var ba = buf_array();
		var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
		var c = s; try { if(wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c; } catch(e) {}
		var r = safe_decode_range(ws['!ref'] || "A1");
		if(r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
			if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
			r.e.c = Math.min(r.e.c, 0x3FFF);
			r.e.r = Math.min(r.e.c, 0xFFFFF);
		}
		ws['!links'] = [];
		/* passed back to write_zip and removed there */
		ws['!comments'] = [];
		write_record(ba, 0x0081 /* BrtBeginSheet */);
		if(wb.vbaraw || ws['!outline']) write_record(ba, 0x0093 /* BrtWsProp */, write_BrtWsProp(c, ws['!outline']));
		write_record(ba, 0x0094 /* BrtWsDim */, write_BrtWsDim(r));
		write_WSVIEWS2(ba, ws, wb.Workbook);
		write_WSFMTINFO(ba, ws);
		write_COLINFOS(ba, ws, idx, opts, wb);
		write_CELLTABLE(ba, ws, idx, opts, wb);
		/* [BrtSheetCalcProp] */
		write_SHEETPROTECT(ba, ws);
		/* *([BrtRangeProtectionIso] BrtRangeProtection) */
		/* [SCENMAN] */
		write_AUTOFILTER(ba, ws, wb, idx);
		/* [SORTSTATE] */
		/* [DCON] */
		/* [USERSHVIEWS] */
		write_MERGECELLS(ba, ws);
		/* [BrtPhoneticInfo] */
		/* *CONDITIONALFORMATTING */
		/* [DVALS] */
		write_HLINKS(ba, ws, rels);
		/* [BrtPrintOptions] */
		if(ws['!margins']) write_record(ba, 0x01DC /* BrtMargins */, write_BrtMargins(ws['!margins']));
		/* [BrtPageSetup] */
		/* [HEADERFOOTER] */
		/* [RWBRK] */
		/* [COLBRK] */
		/* *BrtBigName */
		/* [CELLWATCHES] */
		if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) write_IGNOREECS(ba, ws);
		/* [SMARTTAGS] */
		/* [BrtDrawing] */
		write_LEGACYDRAWING(ba, ws, idx, rels);
		/* [BrtLegacyDrawingHF] */
		/* [BrtBkHim] */
		/* [OLEOBJECTS] */
		/* [ACTIVEXCONTROLS] */
		/* [WEBPUBITEMS] */
		/* [LISTPARTS] */
		/* FRTWORKSHEET */
		write_record(ba, 0x0082 /* BrtEndSheet */);
		return ba.end();
	}
	function parse_Cache(data) {
		var col = [];
		var num = data.match(/^<c:numCache>/);
		var f;
	
		/* 21.2.2.150 pt CT_NumVal */
		(data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg)||[]).forEach(function(pt) {
			var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
			if(!q) return;
			col[+q[1]] = num ? +q[2] : q[2];
		});
	
		/* 21.2.2.71 formatCode CT_Xstring */
		var nf = unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["","General"])[1]);
	
		(data.match(/<c:f>(.*?)<\/c:f>/mg)||[]).forEach(function(F) { f = F.replace(/<.*?>/g,""); });
	
		return [col, nf, f];
	}
	
	/* 21.2 DrawingML - Charts */
	function parse_chart(data, name, opts, rels, wb, csheet) {
		var cs = ((csheet || {"!type":"chart"}));
		if(!data) return csheet;
		/* 21.2.2.27 chart CT_Chart */
	
		var C = 0, R = 0, col = "A";
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	
		/* 21.2.2.120 numCache CT_NumData */
		(data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(nc) {
			var cache = parse_Cache(nc);
			refguess.s.r = refguess.s.c = 0;
			refguess.e.c = C;
			col = encode_col(C);
			cache[0].forEach(function(n,i) {
				cs[col + encode_row(i)] = {t:'n', v:n, z:cache[1] };
				R = i;
			});
			if(refguess.e.r < R) refguess.e.r = R;
			++C;
		});
		if(C > 0) cs["!ref"] = encode_range(refguess);
		return cs;
	}
	/* 18.3 Worksheets also covers Chartsheets */
	function parse_cs_xml(data, opts, idx, rels, wb) {
		if(!data) return data;
		/* 18.3.1.12 chartsheet CT_ChartSheet */
		if(!rels) rels = {'!id':{}};
		var s = ({'!type':"chart", '!drawel':null, '!rel':""});
		var m;
	
		/* 18.3.1.83 sheetPr CT_ChartsheetPr */
		var sheetPr = data.match(sheetprregex);
		if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
	
		/* 18.3.1.36 drawing CT_Drawing */
		if((m = data.match(/drawing r:id="(.*?)"/))) s['!rel'] = m[1];
	
		if(rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
		return s;
	}
	function write_cs_xml(idx, opts, wb, rels) {
		var o = [XML_HEADER, writextag('chartsheet', null, {
			'xmlns': XMLNS_main[0],
			'xmlns:r': XMLNS.r
		})];
		o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
		add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
		if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	/* [MS-XLSB] 2.4.331 BrtCsProp */
	function parse_BrtCsProp(data, length) {
		data.l += 10;
		var name = parse_XLWideString(data, length - 10);
		return { name: name };
	}
	
	/* [MS-XLSB] 2.1.7.7 Chart Sheet */
	function parse_cs_bin(data, opts, idx, rels, wb) {
		if(!data) return data;
		if(!rels) rels = {'!id':{}};
		var s = {'!type':"chart", '!drawel':null, '!rel':""};
		var state = [];
		var pass = false;
		recordhopper(data, function cs_parse(val, R, RT) {
			switch(RT) {
	
				case 0x0226: /* 'BrtDrawing' */
					s['!rel'] = val; break;
	
				case 0x028B: /* 'BrtCsProp' */
					if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
					if(val.name) wb.Sheets[idx].CodeName = val.name;
					break;
	
				case 0x0232: /* 'BrtBkHim' */
				case 0x028C: /* 'BrtCsPageSetup' */
				case 0x029D: /* 'BrtCsProtection' */
				case 0x02A7: /* 'BrtCsProtectionIso' */
				case 0x0227: /* 'BrtLegacyDrawing' */
				case 0x0228: /* 'BrtLegacyDrawingHF' */
				case 0x01DC: /* 'BrtMargins' */
				case 0x0C00: /* 'BrtUid' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(RT); break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); break;
	
				default:
					if(R.T > 0) state.push(RT);
					else if(R.T < 0) state.pop();
					else if(!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		}, opts);
	
		if(rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
		return s;
	}
	function write_cs_bin() {
		var ba = buf_array();
		write_record(ba, 0x0081 /* BrtBeginSheet */);
		/* [BrtCsProp] */
		/* CSVIEWS */
		/* [[BrtCsProtectionIso] BrtCsProtection] */
		/* [USERCSVIEWS] */
		/* [BrtMargins] */
		/* [BrtCsPageSetup] */
		/* [HEADERFOOTER] */
		/* BrtDrawing */
		/* [BrtLegacyDrawing] */
		/* [BrtLegacyDrawingHF] */
		/* [BrtBkHim] */
		/* [WEBPUBITEMS] */
		/* FRTCHARTSHEET */
		write_record(ba, 0x0082 /* BrtEndSheet */);
		return ba.end();
	}
	/* 18.2.28 (CT_WorkbookProtection) Defaults */
	var WBPropsDef = [
		['allowRefreshQuery',           false, "bool"],
		['autoCompressPictures',        true,  "bool"],
		['backupFile',                  false, "bool"],
		['checkCompatibility',          false, "bool"],
		['CodeName',                    ''],
		['date1904',                    false, "bool"],
		['defaultThemeVersion',         0,      "int"],
		['filterPrivacy',               false, "bool"],
		['hidePivotFieldList',          false, "bool"],
		['promptedSolutions',           false, "bool"],
		['publishItems',                false, "bool"],
		['refreshAllConnections',       false, "bool"],
		['saveExternalLinkValues',      true,  "bool"],
		['showBorderUnselectedTables',  true,  "bool"],
		['showInkAnnotation',           true,  "bool"],
		['showObjects',                 'all'],
		['showPivotChartFilter',        false, "bool"],
		['updateLinks', 'userSet']
	];
	
	/* 18.2.30 (CT_BookView) Defaults */
	var WBViewDef = [
		['activeTab',                   0,      "int"],
		['autoFilterDateGrouping',      true,  "bool"],
		['firstSheet',                  0,      "int"],
		['minimized',                   false, "bool"],
		['showHorizontalScroll',        true,  "bool"],
		['showSheetTabs',               true,  "bool"],
		['showVerticalScroll',          true,  "bool"],
		['tabRatio',                    600,    "int"],
		['visibility',                  'visible']
		//window{Height,Width}, {x,y}Window
	];
	
	/* 18.2.19 (CT_Sheet) Defaults */
	var SheetDef = [
		//['state', 'visible']
	];
	
	/* 18.2.2  (CT_CalcPr) Defaults */
	var CalcPrDef = [
		['calcCompleted', 'true'],
		['calcMode', 'auto'],
		['calcOnSave', 'true'],
		['concurrentCalc', 'true'],
		['fullCalcOnLoad', 'false'],
		['fullPrecision', 'true'],
		['iterate', 'false'],
		['iterateCount', '100'],
		['iterateDelta', '0.001'],
		['refMode', 'A1']
	];
	
	/* 18.2.3 (CT_CustomWorkbookView) Defaults */
	/*var CustomWBViewDef = [
		['autoUpdate', 'false'],
		['changesSavedWin', 'false'],
		['includeHiddenRowCol', 'true'],
		['includePrintSettings', 'true'],
		['maximized', 'false'],
		['minimized', 'false'],
		['onlySync', 'false'],
		['personalView', 'false'],
		['showComments', 'commIndicator'],
		['showFormulaBar', 'true'],
		['showHorizontalScroll', 'true'],
		['showObjects', 'all'],
		['showSheetTabs', 'true'],
		['showStatusbar', 'true'],
		['showVerticalScroll', 'true'],
		['tabRatio', '600'],
		['xWindow', '0'],
		['yWindow', '0']
	];*/
	
	function push_defaults_array(target, defaults) {
		for(var j = 0; j != target.length; ++j) { var w = target[j];
			for(var i=0; i != defaults.length; ++i) { var z = defaults[i];
				if(w[z[0]] == null) w[z[0]] = z[1];
				else switch(z[2]) {
				case "bool": if(typeof w[z[0]] == "string") w[z[0]] = parsexmlbool(w[z[0]]); break;
				case "int": if(typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10); break;
				}
			}
		}
	}
	function push_defaults(target, defaults) {
		for(var i = 0; i != defaults.length; ++i) { var z = defaults[i];
			if(target[z[0]] == null) target[z[0]] = z[1];
			else switch(z[2]) {
				case "bool": if(typeof target[z[0]] == "string") target[z[0]] = parsexmlbool(target[z[0]]); break;
				case "int": if(typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10); break;
			}
		}
	}
	
	function parse_wb_defaults(wb) {
		push_defaults(wb.WBProps, WBPropsDef);
		push_defaults(wb.CalcPr, CalcPrDef);
	
		push_defaults_array(wb.WBView, WBViewDef);
		push_defaults_array(wb.Sheets, SheetDef);
	
		_ssfopts.date1904 = parsexmlbool(wb.WBProps.date1904);
	}
	
	function safe1904(wb) {
		/* TODO: store date1904 somewhere else */
		if(!wb.Workbook) return "false";
		if(!wb.Workbook.WBProps) return "false";
		return parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
	}
	
	var badchars = "][*?\/\\".split("");
	function check_ws_name(n, safe) {
		if(n.length > 31) { if(safe) return false; throw new Error("Sheet names cannot exceed 31 chars"); }
		var _good = true;
		badchars.forEach(function(c) {
			if(n.indexOf(c) == -1) return;
			if(!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
			_good = false;
		});
		return _good;
	}
	function check_wb_names(N, S, codes) {
		N.forEach(function(n,i) {
			check_ws_name(n);
			for(var j = 0; j < i; ++j) if(n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
			if(codes) {
				var cn = (S && S[i] && S[i].CodeName) || n;
				if(cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
			}
		});
	}
	function check_wb(wb) {
		if(!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
		if(!wb.SheetNames.length) throw new Error("Workbook is empty");
		var Sheets = (wb.Workbook && wb.Workbook.Sheets) || [];
		check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
		for(var i = 0; i < wb.SheetNames.length; ++i) check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
		/* TODO: validate workbook */
	}
	/* 18.2 Workbook */
	var wbnsregex = /<\w+:workbook/;
	function parse_wb_xml(data, opts) {
		if(!data) throw new Error("Could not find file");
		var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, Names:[], xmlns: "" };
		var pass = false, xmlns = "xmlns";
		var dname = {}, dnstart = 0;
		data.replace(tagregex, function xml_wb(x, idx) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
	
				/* 18.2.27 workbook CT_Workbook 1 */
				case '<workbook':
					if(x.match(wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
					wb.xmlns = y[xmlns];
					break;
				case '</workbook>': break;
	
				/* 18.2.13 fileVersion CT_FileVersion ? */
				case '<fileVersion': delete y[0]; wb.AppVersion = y; break;
				case '<fileVersion/>': case '</fileVersion>': break;
	
				/* 18.2.12 fileSharing CT_FileSharing ? */
				case '<fileSharing':
					break;
				case '<fileSharing/>': break;
	
				/* 18.2.28 workbookPr CT_WorkbookPr ? */
				case '<workbookPr':
				case '<workbookPr/>':
					WBPropsDef.forEach(function(w) {
						if(y[w[0]] == null) return;
						switch(w[2]) {
							case "bool": wb.WBProps[w[0]] = parsexmlbool(y[w[0]]); break;
							case "int": wb.WBProps[w[0]] = parseInt(y[w[0]], 10); break;
							default: wb.WBProps[w[0]] = y[w[0]];
						}
					});
					if(y.codeName) wb.WBProps.CodeName = utf8read(y.codeName);
					break;
				case '</workbookPr>': break;
	
				/* 18.2.29 workbookProtection CT_WorkbookProtection ? */
				case '<workbookProtection':
					break;
				case '<workbookProtection/>': break;
	
				/* 18.2.1  bookViews CT_BookViews ? */
				case '<bookViews': case '<bookViews>': case '</bookViews>': break;
				/* 18.2.30   workbookView CT_BookView + */
				case '<workbookView': case '<workbookView/>': delete y[0]; wb.WBView.push(y); break;
				case '</workbookView>': break;
	
				/* 18.2.20 sheets CT_Sheets 1 */
				case '<sheets': case '<sheets>': case '</sheets>': break; // aggregate sheet
				/* 18.2.19   sheet CT_Sheet + */
				case '<sheet':
					switch(y.state) {
						case "hidden": y.Hidden = 1; break;
						case "veryHidden": y.Hidden = 2; break;
						default: y.Hidden = 0;
					}
					delete y.state;
					y.name = unescapexml(utf8read(y.name));
					delete y[0]; wb.Sheets.push(y); break;
				case '</sheet>': break;
	
				/* 18.2.15 functionGroups CT_FunctionGroups ? */
				case '<functionGroups': case '<functionGroups/>': break;
				/* 18.2.14   functionGroup CT_FunctionGroup + */
				case '<functionGroup': break;
	
				/* 18.2.9  externalReferences CT_ExternalReferences ? */
				case '<externalReferences': case '</externalReferences>': case '<externalReferences>': break;
				/* 18.2.8    externalReference CT_ExternalReference + */
				case '<externalReference': break;
	
				/* 18.2.6  definedNames CT_DefinedNames ? */
				case '<definedNames/>': break;
				case '<definedNames>': case '<definedNames': pass=true; break;
				case '</definedNames>': pass=false; break;
				/* 18.2.5    definedName CT_DefinedName + */
				case '<definedName': {
					dname = {};
					dname.Name = utf8read(y.name);
					if(y.comment) dname.Comment = y.comment;
					if(y.localSheetId) dname.Sheet = +y.localSheetId;
					if(parsexmlbool(y.hidden||"0")) dname.Hidden = true;
					dnstart = idx + x.length;
				}	break;
				case '</definedName>': {
					dname.Ref = unescapexml(utf8read(data.slice(dnstart, idx)));
					wb.Names.push(dname);
				} break;
				case '<definedName/>': break;
	
				/* 18.2.2  calcPr CT_CalcPr ? */
				case '<calcPr': delete y[0]; wb.CalcPr = y; break;
				case '<calcPr/>': delete y[0]; wb.CalcPr = y; break;
				case '</calcPr>': break;
	
				/* 18.2.16 oleSize CT_OleSize ? (ref required) */
				case '<oleSize': break;
	
				/* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */
				case '<customWorkbookViews>': case '</customWorkbookViews>': case '<customWorkbookViews': break;
				/* 18.2.3  customWorkbookView CT_CustomWorkbookView + */
				case '<customWorkbookView': case '</customWorkbookView>': break;
	
				/* 18.2.18 pivotCaches CT_PivotCaches ? */
				case '<pivotCaches>': case '</pivotCaches>': case '<pivotCaches': break;
				/* 18.2.17 pivotCache CT_PivotCache ? */
				case '<pivotCache': break;
	
				/* 18.2.21 smartTagPr CT_SmartTagPr ? */
				case '<smartTagPr': case '<smartTagPr/>': break;
	
				/* 18.2.23 smartTagTypes CT_SmartTagTypes ? */
				case '<smartTagTypes': case '<smartTagTypes>': case '</smartTagTypes>': break;
				/* 18.2.22 smartTagType CT_SmartTagType ? */
				case '<smartTagType': break;
	
				/* 18.2.24 webPublishing CT_WebPublishing ? */
				case '<webPublishing': case '<webPublishing/>': break;
	
				/* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */
				case '<fileRecoveryPr': case '<fileRecoveryPr/>': break;
	
				/* 18.2.26 webPublishObjects CT_WebPublishObjects ? */
				case '<webPublishObjects>': case '<webPublishObjects': case '</webPublishObjects>': break;
				/* 18.2.25 webPublishObject CT_WebPublishObject ? */
				case '<webPublishObject': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
				/* 18.2.7  ext CT_Extension + */
				case '<ext': pass=true; break; //TODO: check with versions of excel
				case '</ext>': pass=false; break;
	
				/* Others */
				case '<ArchID': break;
				case '<AlternateContent':
				case '<AlternateContent>': pass=true; break;
				case '</AlternateContent>': pass=false; break;
	
				/* TODO */
				case '<revisionPtr': break;
	
				default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
			}
			return x;
		});
		if(XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
	
		parse_wb_defaults(wb);
	
		return wb;
	}
	
	function write_wb_xml(wb) {
		var o = [XML_HEADER];
		o[o.length] = writextag('workbook', null, {
			'xmlns': XMLNS_main[0],
			//'xmlns:mx': XMLNS.mx,
			//'xmlns:s': XMLNS_main[0],
			'xmlns:r': XMLNS.r
		});
	
		var write_names = (wb.Workbook && (wb.Workbook.Names||[]).length > 0);
	
		/* fileVersion */
		/* fileSharing */
	
		var workbookPr = ({codeName:"ThisWorkbook"});
		if(wb.Workbook && wb.Workbook.WBProps) {
			WBPropsDef.forEach(function(x) {
	if((wb.Workbook.WBProps[x[0]]) == null) return;
				if((wb.Workbook.WBProps[x[0]]) == x[1]) return;
				workbookPr[x[0]] = (wb.Workbook.WBProps[x[0]]);
			});
	if(wb.Workbook.WBProps.CodeName) { workbookPr.codeName = wb.Workbook.WBProps.CodeName; delete workbookPr.CodeName; }
		}
		o[o.length] = (writextag('workbookPr', null, workbookPr));
	
		/* workbookProtection */
	
		var sheets = wb.Workbook && wb.Workbook.Sheets || [];
		var i = 0;
	
		/* bookViews only written if first worksheet is hidden */
		if(sheets && sheets[0] && !!sheets[0].Hidden) {
			o[o.length] = "<bookViews>";
			for(i = 0; i != wb.SheetNames.length; ++i) {
				if(!sheets[i]) break;
				if(!sheets[i].Hidden) break;
			}
			if(i == wb.SheetNames.length) i = 0;
			o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
			o[o.length] = "</bookViews>";
		}
	
		o[o.length] = "<sheets>";
		for(i = 0; i != wb.SheetNames.length; ++i) {
			var sht = ({name:escapexml(wb.SheetNames[i].slice(0,31))});
			sht.sheetId = ""+(i+1);
			sht["r:id"] = "rId"+(i+1);
			if(sheets[i]) switch(sheets[i].Hidden) {
				case 1: sht.state = "hidden"; break;
				case 2: sht.state = "veryHidden"; break;
			}
			o[o.length] = (writextag('sheet',null,sht));
		}
		o[o.length] = "</sheets>";
	
		/* functionGroups */
		/* externalReferences */
	
		if(write_names) {
			o[o.length] = "<definedNames>";
			if(wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
				var d = {name:n.Name};
				if(n.Comment) d.comment = n.Comment;
				if(n.Sheet != null) d.localSheetId = ""+n.Sheet;
				if(n.Hidden) d.hidden = "1";
				if(!n.Ref) return;
				o[o.length] = writextag('definedName', escapexml(n.Ref), d);
			});
			o[o.length] = "</definedNames>";
		}
	
		/* calcPr */
		/* oleSize */
		/* customWorkbookViews */
		/* pivotCaches */
		/* smartTagPr */
		/* smartTagTypes */
		/* webPublishing */
		/* fileRecoveryPr */
		/* webPublishObjects */
		/* extLst */
	
		if(o.length>2){ o[o.length] = '</workbook>'; o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.304 BrtBundleSh */
	function parse_BrtBundleSh(data, length) {
		var z = {};
		z.Hidden = data.read_shift(4); //hsState ST_SheetState
		z.iTabID = data.read_shift(4);
		z.strRelID = parse_RelID(data,length-8);
		z.name = parse_XLWideString(data);
		return z;
	}
	function write_BrtBundleSh(data, o) {
		if(!o) o = new_buf(127);
		o.write_shift(4, data.Hidden);
		o.write_shift(4, data.iTabID);
		write_RelID(data.strRelID, o);
		write_XLWideString(data.name.slice(0,31), o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.815 BrtWbProp */
	function parse_BrtWbProp(data, length) {
		var o = ({});
		var flags = data.read_shift(4);
		o.defaultThemeVersion = data.read_shift(4);
		var strName = (length > 8) ? parse_XLWideString(data) : "";
		if(strName.length > 0) o.CodeName = strName;
		o.autoCompressPictures = !!(flags & 0x10000);
		o.backupFile = !!(flags & 0x40);
		o.checkCompatibility = !!(flags & 0x1000);
		o.date1904 = !!(flags & 0x01);
		o.filterPrivacy = !!(flags & 0x08);
		o.hidePivotFieldList = !!(flags & 0x400);
		o.promptedSolutions = !!(flags & 0x10);
		o.publishItems = !!(flags & 0x800);
		o.refreshAllConnections = !!(flags & 0x40000);
		o.saveExternalLinkValues = !!(flags & 0x80);
		o.showBorderUnselectedTables = !!(flags & 0x04);
		o.showInkAnnotation = !!(flags & 0x20);
		o.showObjects = ["all", "placeholders", "none"][(flags >> 13) & 0x03];
		o.showPivotChartFilter = !!(flags & 0x8000);
		o.updateLinks = ["userSet", "never", "always"][(flags >> 8) & 0x03];
		return o;
	}
	function write_BrtWbProp(data, o) {
		if(!o) o = new_buf(72);
		var flags = 0;
		if(data) {
			/* TODO: mirror parse_BrtWbProp fields */
			if(data.filterPrivacy) flags |= 0x08;
		}
		o.write_shift(4, flags);
		o.write_shift(4, 0);
		write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
		return o.slice(0, o.l);
	}
	
	function parse_BrtFRTArchID$(data, length) {
		var o = {};
		data.read_shift(4);
		o.ArchID = data.read_shift(4);
		data.l += length - 8;
		return o;
	}
	
	/* [MS-XLSB] 2.4.687 BrtName */
	function parse_BrtName(data, length, opts) {
		var end = data.l + length;
		data.l += 4; //var flags = data.read_shift(4);
		data.l += 1; //var chKey = data.read_shift(1);
		var itab = data.read_shift(4);
		var name = parse_XLNameWideString(data);
		var formula = parse_XLSBNameParsedFormula(data, 0, opts);
		var comment = parse_XLNullableWideString(data);
		//if(0 /* fProc */) {
			// unusedstring1: XLNullableWideString
			// description: XLNullableWideString
			// helpTopic: XLNullableWideString
			// unusedstring2: XLNullableWideString
		//}
		data.l = end;
		var out = ({Name:name, Ptg:formula});
		if(itab < 0xFFFFFFF) out.Sheet = itab;
		if(comment) out.Comment = comment;
		return out;
	}
	
	/* [MS-XLSB] 2.1.7.61 Workbook */
	function parse_wb_bin(data, opts) {
		var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, xmlns: "" };
		var state = [];
		var pass = false;
	
		if(!opts) opts = {};
		opts.biff = 12;
	
		var Names = [];
		var supbooks = ([[]]);
		supbooks.SheetNames = [];
		supbooks.XTI = [];
	
		XLSBRecordEnum[0x0010] = { n:"BrtFRTArchID$", f:parse_BrtFRTArchID$ };
	
		recordhopper(data, function hopper_wb(val, R, RT) {
			switch(RT) {
				case 0x009C: /* 'BrtBundleSh' */
					supbooks.SheetNames.push(val.name);
					wb.Sheets.push(val); break;
	
				case 0x0099: /* 'BrtWbProp' */
					wb.WBProps = val; break;
	
				case 0x0027: /* 'BrtName' */
					if(val.Sheet != null) opts.SID = val.Sheet;
					val.Ref = stringify_formula(val.Ptg, null, null, supbooks, opts);
					delete opts.SID;
					delete val.Ptg;
					Names.push(val);
					break;
				case 0x040C: /* 'BrtNameExt' */ break;
	
				case 0x0165: /* 'BrtSupSelf' */
				case 0x0166: /* 'BrtSupSame' */
				case 0x0163: /* 'BrtSupBookSrc' */
				case 0x029B: /* 'BrtSupAddin' */
					if(!supbooks[0].length) supbooks[0] = [RT, val];
					else supbooks.push([RT, val]);
					supbooks[supbooks.length - 1].XTI = [];
					break;
				case 0x016A: /* 'BrtExternSheet' */
					if(supbooks.length === 0) { supbooks[0] = []; supbooks[0].XTI = []; }
					supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
					supbooks.XTI = supbooks.XTI.concat(val);
					break;
				case 0x0169: /* 'BrtPlaceholderName' */
					break;
	
				case 0x0817: /* 'BrtAbsPath15' */
				case 0x009E: /* 'BrtBookView' */
				case 0x008F: /* 'BrtBeginBundleShs' */
				case 0x0298: /* 'BrtBeginFnGroup' */
				case 0x0161: /* 'BrtBeginExternals' */
					break;
	
				/* case 'BrtModelTimeGroupingCalcCol' */
				case 0x0C00: /* 'BrtUid' */
				case 0x0C01: /* 'BrtRevisionPtr' */
				case 0x0216: /* 'BrtBookProtection' */
				case 0x02A5: /* 'BrtBookProtectionIso' */
				case 0x009D: /* 'BrtCalcProp' */
				case 0x0262: /* 'BrtCrashRecErr' */
				case 0x0802: /* 'BrtDecoupledPivotCacheID' */
				case 0x009B: /* 'BrtFileRecover' */
				case 0x0224: /* 'BrtFileSharing' */
				case 0x02A4: /* 'BrtFileSharingIso' */
				case 0x0080: /* 'BrtFileVersion' */
				case 0x0299: /* 'BrtFnGroup' */
				case 0x0850: /* 'BrtModelRelationship' */
				case 0x084D: /* 'BrtModelTable' */
				case 0x0225: /* 'BrtOleSize' */
				case 0x0805: /* 'BrtPivotTableRef' */
				case 0x0254: /* 'BrtSmartTagType' */
				case 0x081C: /* 'BrtTableSlicerCacheID' */
				case 0x081B: /* 'BrtTableSlicerCacheIDs' */
				case 0x0822: /* 'BrtTimelineCachePivotCacheID' */
				case 0x018D: /* 'BrtUserBookView' */
				case 0x009A: /* 'BrtWbFactoid' */
				case 0x045D: /* 'BrtWbProp14' */
				case 0x0229: /* 'BrtWebOpt' */
				case 0x082B: /* 'BrtWorkBookPr15' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					state.push(RT); pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					state.pop(); pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(RT); pass = true; break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); pass = false; break;
	
				case 0x0010: /* 'BrtFRTArchID$' */ break;
	
				default:
					if(R.T){/* empty */}
					else if(!pass || (opts.WTF && state[state.length-1] != 0x0025 /* BrtACBegin */ && state[state.length-1] != 0x0023 /* BrtFRTBegin */)) throw new Error("Unexpected record 0x" + RT.toString(16));
			}
		}, opts);
	
		parse_wb_defaults(wb);
	
		// $FlowIgnore
		wb.Names = Names;
	
		(wb).supbooks = supbooks;
		return wb;
	}
	
	function write_BUNDLESHS(ba, wb) {
		write_record(ba, 0x008F /* BrtBeginBundleShs */);
		for(var idx = 0; idx != wb.SheetNames.length; ++idx) {
			var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
			var d = { Hidden: viz, iTabID: idx+1, strRelID: 'rId' + (idx+1), name: wb.SheetNames[idx] };
			write_record(ba, 0x009C /* BrtBundleSh */, write_BrtBundleSh(d));
		}
		write_record(ba, 0x0090 /* BrtEndBundleShs */);
	}
	
	/* [MS-XLSB] 2.4.649 BrtFileVersion */
	function write_BrtFileVersion(data, o) {
		if(!o) o = new_buf(127);
		for(var i = 0; i != 4; ++i) o.write_shift(4, 0);
		write_XLWideString("SheetJS", o);
		write_XLWideString(XLSX.version, o);
		write_XLWideString(XLSX.version, o);
		write_XLWideString("7262", o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.301 BrtBookView */
	function write_BrtBookView(idx, o) {
		if(!o) o = new_buf(29);
		o.write_shift(-4, 0);
		o.write_shift(-4, 460);
		o.write_shift(4,  28800);
		o.write_shift(4,  17600);
		o.write_shift(4,  500);
		o.write_shift(4,  idx);
		o.write_shift(4,  idx);
		var flags = 0x78;
		o.write_shift(1,  flags);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	function write_BOOKVIEWS(ba, wb) {
		/* required if hidden tab appears before visible tab */
		if(!wb.Workbook || !wb.Workbook.Sheets) return;
		var sheets = wb.Workbook.Sheets;
		var i = 0, vistab = -1, hidden = -1;
		for(; i < sheets.length; ++i) {
			if(!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
			else if(sheets[i].Hidden == 1 && hidden == -1) hidden = i;
		}
		if(hidden > vistab) return;
		write_record(ba, 0x0087 /* BrtBeginBookViews */);
		write_record(ba, 0x009E /* BrtBookView */, write_BrtBookView(vistab));
		/* 1*(BrtBookView *FRT) */
		write_record(ba, 0x0088 /* BrtEndBookViews */);
	}
	
	/* [MS-XLSB] 2.4.305 BrtCalcProp */
	/*function write_BrtCalcProp(data, o) {
		if(!o) o = new_buf(26);
		o.write_shift(4,0); // force recalc
		o.write_shift(4,1);
		o.write_shift(4,0);
		write_Xnum(0, o);
		o.write_shift(-4, 1023);
		o.write_shift(1, 0x33);
		o.write_shift(1, 0x00);
		return o;
	}*/
	
	/* [MS-XLSB] 2.4.646 BrtFileRecover */
	/*function write_BrtFileRecover(data, o) {
		if(!o) o = new_buf(1);
		o.write_shift(1,0);
		return o;
	}*/
	
	/* [MS-XLSB] 2.1.7.61 Workbook */
	function write_wb_bin(wb, opts) {
		var ba = buf_array();
		write_record(ba, 0x0083 /* BrtBeginBook */);
		write_record(ba, 0x0080 /* BrtFileVersion */, write_BrtFileVersion());
		/* [[BrtFileSharingIso] BrtFileSharing] */
		write_record(ba, 0x0099 /* BrtWbProp */, write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
		/* [ACABSPATH] */
		/* [[BrtBookProtectionIso] BrtBookProtection] */
		write_BOOKVIEWS(ba, wb, opts);
		write_BUNDLESHS(ba, wb, opts);
		/* [FNGROUP] */
		/* [EXTERNALS] */
		/* *BrtName */
		/* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); */
		/* [BrtOleSize] */
		/* *(BrtUserBookView *FRT) */
		/* [PIVOTCACHEIDS] */
		/* [BrtWbFactoid] */
		/* [SMARTTAGTYPES] */
		/* [BrtWebOpt] */
		/* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); */
		/* [WEBPUBITEMS] */
		/* [CRERRS] */
		/* FRTWORKBOOK */
		write_record(ba, 0x0084 /* BrtEndBook */);
	
		return ba.end();
	}
	function parse_wb(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_wb_bin((data), opts);
		return parse_wb_xml((data), opts);
	}
	
	function parse_ws(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ws_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ws_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_cs(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_cs_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_cs_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_ms(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ms_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ms_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_ds(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ds_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ds_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_sty(data, name, themes, opts) {
		if(name.slice(-4)===".bin") return parse_sty_bin((data), themes, opts);
		return parse_sty_xml((data), themes, opts);
	}
	
	function parse_theme(data, name, opts) {
		return parse_theme_xml(data, opts);
	}
	
	function parse_sst(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_sst_bin((data), opts);
		return parse_sst_xml((data), opts);
	}
	
	function parse_cmnt(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_comments_bin((data), opts);
		return parse_comments_xml((data), opts);
	}
	
	function parse_cc(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_cc_bin((data), name, opts);
		return parse_cc_xml((data), name, opts);
	}
	
	function parse_xlink(data, rel, name, opts) {
		if(name.slice(-4)===".bin") return parse_xlink_bin((data), rel, name, opts);
		return parse_xlink_xml((data), rel, name, opts);
	}
	
	function parse_xlmeta(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_xlmeta_bin((data), name, opts);
		return parse_xlmeta_xml((data), name, opts);
	}
	
	function write_wb(wb, name, opts) {
		return (name.slice(-4)===".bin" ? write_wb_bin : write_wb_xml)(wb, opts);
	}
	
	function write_ws(data, name, opts, wb, rels) {
		return (name.slice(-4)===".bin" ? write_ws_bin : write_ws_xml)(data, opts, wb, rels);
	}
	
	// eslint-disable-next-line no-unused-vars
	function write_cs(data, name, opts, wb, rels) {
		return (name.slice(-4)===".bin" ? write_cs_bin : write_cs_xml)(data, opts, wb, rels);
	}
	
	function write_sty(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_sty_bin : write_sty_xml)(data, opts);
	}
	
	function write_sst(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_sst_bin : write_sst_xml)(data, opts);
	}
	
	function write_cmnt(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_comments_bin : write_comments_xml)(data, opts);
	}
	/*
	function write_cc(data, name:string, opts) {
		return (name.slice(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
	}
	*/
	
	function write_xlmeta(name) {
		return (name.slice(-4)===".bin" ? write_xlmeta_bin : write_xlmeta_xml)();
	}
	var attregexg2=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
	var attregex2=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
	function xlml_parsexmltag(tag, skip_root) {
		var words = tag.split(/\s+/);
		var z = ([]); if(!skip_root) z[0] = words[0];
		if(words.length === 1) return z;
		var m = tag.match(attregexg2), y, j, w, i;
		if(m) for(i = 0; i != m.length; ++i) {
			y = m[i].match(attregex2);
	if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
			else {
				if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
				else w = y[1].slice(j+1);
				z[w] = y[2].slice(1,y[2].length-1);
			}
		}
		return z;
	}
	function xlml_parsexmltagobj(tag) {
		var words = tag.split(/\s+/);
		var z = {};
		if(words.length === 1) return z;
		var m = tag.match(attregexg2), y, j, w, i;
		if(m) for(i = 0; i != m.length; ++i) {
			y = m[i].match(attregex2);
	if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
			else {
				if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
				else w = y[1].slice(j+1);
				z[w] = y[2].slice(1,y[2].length-1);
			}
		}
		return z;
	}
	
	// ----
	
	/* map from xlml named formats to SSF TODO: localize */
	var XLMLFormatMap;
	
	function xlml_format(format, value) {
		var fmt = XLMLFormatMap[format] || unescapexml(format);
		if(fmt === "General") return SSF_general(value);
		return SSF_format(fmt, value);
	}
	
	function xlml_set_custprop(Custprops, key, cp, val) {
		var oval = val;
		switch((cp[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]) {
			case "boolean": oval = parsexmlbool(val); break;
			case "i2": case "int": oval = parseInt(val, 10); break;
			case "r4": case "float": oval = parseFloat(val); break;
			case "date": case "dateTime.tz": oval = parseDate(val); break;
			case "i8": case "string": case "fixed": case "uuid": case "bin.base64": break;
			default: throw new Error("bad custprop:" + cp[0]);
		}
		Custprops[unescapexml(key)] = oval;
	}
	
	function safe_format_xlml(cell, nf, o) {
		if(cell.t === 'z') return;
		if(!o || o.cellText !== false) try {
			if(cell.t === 'e') { cell.w = cell.w || BErr[cell.v]; }
			else if(nf === "General") {
				if(cell.t === 'n') {
					if((cell.v|0) === cell.v) cell.w = cell.v.toString(10);
					else cell.w = SSF_general_num(cell.v);
				}
				else cell.w = SSF_general(cell.v);
			}
			else cell.w = xlml_format(nf||"General", cell.v);
		} catch(e) { if(o.WTF) throw e; }
		try {
			var z = XLMLFormatMap[nf]||nf||"General";
			if(o.cellNF) cell.z = z;
			if(o.cellDates && cell.t == 'n' && fmt_is_date(z)) {
				var _d = SSF_parse_date_code(cell.v); if(_d) { cell.t = 'd'; cell.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
			}
		} catch(e) { if(o.WTF) throw e; }
	}
	
	function process_style_xlml(styles, stag, opts) {
		if(opts.cellStyles) {
			if(stag.Interior) {
				var I = stag.Interior;
				if(I.Pattern) I.patternType = XLMLPatternTypeMap[I.Pattern] || I.Pattern;
			}
		}
		styles[stag.ID] = stag;
	}
	
	/* TODO: there must exist some form of OSP-blessed spec */
	function parse_xlml_data(xml, ss, data, cell, base, styles, csty, row, arrayf, o) {
		var nf = "General", sid = cell.StyleID, S = {}; o = o || {};
		var interiors = [];
		var i = 0;
		if(sid === undefined && row) sid = row.StyleID;
		if(sid === undefined && csty) sid = csty.StyleID;
		while(styles[sid] !== undefined) {
			if(styles[sid].nf) nf = styles[sid].nf;
			if(styles[sid].Interior) interiors.push(styles[sid].Interior);
			if(!styles[sid].Parent) break;
			sid = styles[sid].Parent;
		}
		switch(data.Type) {
			case 'Boolean':
				cell.t = 'b';
				cell.v = parsexmlbool(xml);
				break;
			case 'String':
				cell.t = 's'; cell.r = xlml_fixstr(unescapexml(xml));
				cell.v = (xml.indexOf("<") > -1 ? unescapexml(ss||xml).replace(/<.*?>/g, "") : cell.r); // todo: BR etc
				break;
			case 'DateTime':
				if(xml.slice(-1) != "Z") xml += "Z";
				cell.v = (parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
				if(cell.v !== cell.v) cell.v = unescapexml(xml);
				else if(cell.v<60) cell.v = cell.v -1;
				if(!nf || nf == "General") nf = "yyyy-mm-dd";
				/* falls through */
			case 'Number':
				if(cell.v === undefined) cell.v=+xml;
				if(!cell.t) cell.t = 'n';
				break;
			case 'Error': cell.t = 'e'; cell.v = RBErr[xml]; if(o.cellText !== false) cell.w = xml; break;
			default:
				if(xml == "" && ss == "") { cell.t = 'z'; }
				else { cell.t = 's'; cell.v = xlml_fixstr(ss||xml); }
				break;
		}
		safe_format_xlml(cell, nf, o);
		if(o.cellFormula !== false) {
			if(cell.Formula) {
				var fstr = unescapexml(cell.Formula);
				/* strictly speaking, the leading = is required but some writers omit */
				if(fstr.charCodeAt(0) == 61 /* = */) fstr = fstr.slice(1);
				cell.f = rc_to_a1(fstr, base);
				delete cell.Formula;
				if(cell.ArrayRange == "RC") cell.F = rc_to_a1("RC:RC", base);
				else if(cell.ArrayRange) {
					cell.F = rc_to_a1(cell.ArrayRange, base);
					arrayf.push([safe_decode_range(cell.F), cell.F]);
				}
			} else {
				for(i = 0; i < arrayf.length; ++i)
					if(base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r)
						if(base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c)
							cell.F = arrayf[i][1];
			}
		}
		if(o.cellStyles) {
			interiors.forEach(function(x) {
				if(!S.patternType && x.patternType) S.patternType = x.patternType;
			});
			cell.s = S;
		}
		if(cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
	}
	
	function xlml_clean_comment(comment) {
		comment.t = comment.v || "";
		comment.t = comment.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
		comment.v = comment.w = comment.ixfe = undefined;
	}
	
	/* TODO: Everything */
	function parse_xlml_xml(d, _opts) {
		var opts = _opts || {};
		make_ssf();
		var str = debom(xlml_normalize(d));
		if(opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
			if(typeof $cptable !== 'undefined') str = $cptable.utils.decode(65001, char_codes(str));
			else str = utf8read(str);
		}
		var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
		opening = opening.replace(/".*?"/g, "");
		if((opening.indexOf(">") & 1023) > Math.min((opening.indexOf(",") & 1023), (opening.indexOf(";")&1023))) { var _o = dup(opts); _o.type = "string"; return PRN.to_workbook(str, _o); }
		if(opening.indexOf("<?xml") == -1) ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(tag) { if(opening.indexOf("<" + tag) >= 0) ishtml = true; });
		if(ishtml) return html_to_workbook(str, opts);
	
		XLMLFormatMap = ({
			"General Number": "General",
			"General Date": table_fmt[22],
			"Long Date": "dddd, mmmm dd, yyyy",
			"Medium Date": table_fmt[15],
			"Short Date": table_fmt[14],
			"Long Time": table_fmt[19],
			"Medium Time": table_fmt[18],
			"Short Time": table_fmt[20],
			"Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
			"Fixed": table_fmt[2],
			"Standard": table_fmt[4],
			"Percent": table_fmt[10],
			"Scientific": table_fmt[11],
			"Yes/No": '"Yes";"Yes";"No";@',
			"True/False": '"True";"True";"False";@',
			"On/Off": '"Yes";"Yes";"No";@'
		});
	
	
		var Rn;
		var state = [], tmp;
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var sheets = {}, sheetnames = [], cursheet = (opts.dense ? [] : {}), sheetname = "";
		var cell = ({}), row = {};// eslint-disable-line no-unused-vars
		var dtag = xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
		var c = 0, r = 0;
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
		var styles = {}, stag = {};
		var ss = "", fidx = 0;
		var merges = [];
		var Props = {}, Custprops = {}, pidx = 0, cp = [];
		var comments = [], comment = ({});
		var cstys = [], csty, seencol = false;
		var arrayf = [];
		var rowinfo = [], rowobj = {}, cc = 0, rr = 0;
		var Workbook = ({ Sheets:[], WBProps:{date1904:false} }), wsprops = {};
		xlmlregex.lastIndex = 0;
		str = str.replace(/<!--([\s\S]*?)-->/mg,"");
		var raw_Rn3 = "";
		while((Rn = xlmlregex.exec(str))) switch((Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase())) {
			case 'data' /*case 'Data'*/:
				if(raw_Rn3 == "data") {
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
					break;
				}
				if(state[state.length-1][1]) break;
				if(Rn[1]==='/') parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length-1][0]==/*"Comment"*/"comment"?comment:cell, {c:c,r:r}, styles, cstys[c], row, arrayf, opts);
				else { ss = ""; dtag = xlml_parsexmltag(Rn[0]); didx = Rn.index + Rn[0].length; }
				break;
			case 'cell' /*case 'Cell'*/:
				if(Rn[1]==='/'){
					if(comments.length > 0) cell.c = comments;
					if((!opts.sheetRows || opts.sheetRows > r) && cell.v !== undefined) {
						if(opts.dense) {
							if(!cursheet[r]) cursheet[r] = [];
							cursheet[r][c] = cell;
						} else cursheet[encode_col(c) + encode_row(r)] = cell;
					}
					if(cell.HRef) {
						cell.l = ({Target:unescapexml(cell.HRef)});
						if(cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
						delete cell.HRef; delete cell.HRefScreenTip;
					}
					if(cell.MergeAcross || cell.MergeDown) {
						cc = c + (parseInt(cell.MergeAcross,10)|0);
						rr = r + (parseInt(cell.MergeDown,10)|0);
						merges.push({s:{c:c,r:r},e:{c:cc,r:rr}});
					}
					if(!opts.sheetStubs) { if(cell.MergeAcross) c = cc + 1; else ++c; }
					else if(cell.MergeAcross || cell.MergeDown) {
	for(var cma = c; cma <= cc; ++cma) {
							for(var cmd = r; cmd <= rr; ++cmd) {
								if(cma > c || cmd > r) {
									if(opts.dense) {
										if(!cursheet[cmd]) cursheet[cmd] = [];
										cursheet[cmd][cma] = {t:'z'};
									} else cursheet[encode_col(cma) + encode_row(cmd)] = {t:'z'};
								}
							}
						}
						c = cc + 1;
					}
					else ++c;
				} else {
					cell = xlml_parsexmltagobj(Rn[0]);
					if(cell.Index) c = +cell.Index - 1;
					if(c < refguess.s.c) refguess.s.c = c;
					if(c > refguess.e.c) refguess.e.c = c;
					if(Rn[0].slice(-2) === "/>") ++c;
					comments = [];
				}
				break;
			case 'row' /*case 'Row'*/:
				if(Rn[1]==='/' || Rn[0].slice(-2) === "/>") {
					if(r < refguess.s.r) refguess.s.r = r;
					if(r > refguess.e.r) refguess.e.r = r;
					if(Rn[0].slice(-2) === "/>") {
						row = xlml_parsexmltag(Rn[0]);
						if(row.Index) r = +row.Index - 1;
					}
					c = 0; ++r;
				} else {
					row = xlml_parsexmltag(Rn[0]);
					if(row.Index) r = +row.Index - 1;
					rowobj = {};
					if(row.AutoFitHeight == "0" || row.Height) {
						rowobj.hpx = parseInt(row.Height, 10); rowobj.hpt = px2pt(rowobj.hpx);
						rowinfo[r] = rowobj;
					}
					if(row.Hidden == "1") { rowobj.hidden = true; rowinfo[r] = rowobj; }
				}
				break;
			case 'worksheet' /*case 'Worksheet'*/: /* TODO: read range from FullRows/FullColumns */
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
					sheetnames.push(sheetname);
					if(refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
						cursheet["!ref"] = encode_range(refguess);
						if(opts.sheetRows && opts.sheetRows <= refguess.e.r) {
							cursheet["!fullref"] = cursheet["!ref"];
							refguess.e.r = opts.sheetRows - 1;
							cursheet["!ref"] = encode_range(refguess);
						}
					}
					if(merges.length) cursheet["!merges"] = merges;
					if(cstys.length > 0) cursheet["!cols"] = cstys;
					if(rowinfo.length > 0) cursheet["!rows"] = rowinfo;
					sheets[sheetname] = cursheet;
				} else {
					refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
					r = c = 0;
					state.push([Rn[3], false]);
					tmp = xlml_parsexmltag(Rn[0]);
					sheetname = unescapexml(tmp.Name);
					cursheet = (opts.dense ? [] : {});
					merges = [];
					arrayf = [];
					rowinfo = [];
					wsprops = {name:sheetname, Hidden:0};
					Workbook.Sheets.push(wsprops);
				}
				break;
			case 'table' /*case 'Table'*/:
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].slice(-2) == "/>") break;
				else {
					state.push([Rn[3], false]);
					cstys = []; seencol = false;
				}
				break;
	
			case 'style' /*case 'Style'*/:
				if(Rn[1]==='/') process_style_xlml(styles, stag, opts);
				else stag = xlml_parsexmltag(Rn[0]);
				break;
	
			case 'numberformat' /*case 'NumberFormat'*/:
				stag.nf = unescapexml(xlml_parsexmltag(Rn[0]).Format || "General");
				if(XLMLFormatMap[stag.nf]) stag.nf = XLMLFormatMap[stag.nf];
				for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx) if(table_fmt[ssfidx] == stag.nf) break;
				if(ssfidx == 0x188) for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx) if(table_fmt[ssfidx] == null) { SSF_load(stag.nf, ssfidx); break; }
				break;
	
			case 'column' /*case 'Column'*/:
				if(state[state.length-1][0] !== /*'Table'*/'table') break;
				csty = xlml_parsexmltag(Rn[0]);
				if(csty.Hidden) { csty.hidden = true; delete csty.Hidden; }
				if(csty.Width) csty.wpx = parseInt(csty.Width, 10);
				if(!seencol && csty.wpx > 10) {
					seencol = true; MDW = DEF_MDW; //find_mdw_wpx(csty.wpx);
					for(var _col = 0; _col < cstys.length; ++_col) if(cstys[_col]) process_col(cstys[_col]);
				}
				if(seencol) process_col(csty);
				cstys[(csty.Index-1||cstys.length)] = csty;
				for(var i = 0; i < +csty.Span; ++i) cstys[cstys.length] = dup(csty);
				break;
	
			case 'namedrange' /*case 'NamedRange'*/:
				if(Rn[1]==='/') break;
				if(!Workbook.Names) Workbook.Names = [];
				var _NamedRange = parsexmltag(Rn[0]);
				var _DefinedName = ({
					Name: _NamedRange.Name,
					Ref: rc_to_a1(_NamedRange.RefersTo.slice(1), {r:0, c:0})
				});
				if(Workbook.Sheets.length>0) _DefinedName.Sheet=Workbook.Sheets.length-1;
	Workbook.Names.push(_DefinedName);
				break;
	
			case 'namedcell' /*case 'NamedCell'*/: break;
			case 'b' /*case 'B'*/: break;
			case 'i' /*case 'I'*/: break;
			case 'u' /*case 'U'*/: break;
			case 's' /*case 'S'*/: break;
			case 'em' /*case 'EM'*/: break;
			case 'h2' /*case 'H2'*/: break;
			case 'h3' /*case 'H3'*/: break;
			case 'sub' /*case 'Sub'*/: break;
			case 'sup' /*case 'Sup'*/: break;
			case 'span' /*case 'Span'*/: break;
			case 'alignment' /*case 'Alignment'*/:
				break;
			case 'borders' /*case 'Borders'*/: break;
			case 'border' /*case 'Border'*/: break;
			case 'font' /*case 'Font'*/:
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") ss += str.slice(fidx, Rn.index);
				else fidx = Rn.index + Rn[0].length;
				break;
			case 'interior' /*case 'Interior'*/:
				if(!opts.cellStyles) break;
				stag.Interior = xlml_parsexmltag(Rn[0]);
				break;
			case 'protection' /*case 'Protection'*/: break;
	
			case 'author' /*case 'Author'*/:
			case 'title' /*case 'Title'*/:
			case 'description' /*case 'Description'*/:
			case 'created' /*case 'Created'*/:
			case 'keywords' /*case 'Keywords'*/:
			case 'subject' /*case 'Subject'*/:
			case 'category' /*case 'Category'*/:
			case 'company' /*case 'Company'*/:
			case 'lastauthor' /*case 'LastAuthor'*/:
			case 'lastsaved' /*case 'LastSaved'*/:
			case 'lastprinted' /*case 'LastPrinted'*/:
			case 'version' /*case 'Version'*/:
			case 'revision' /*case 'Revision'*/:
			case 'totaltime' /*case 'TotalTime'*/:
			case 'hyperlinkbase' /*case 'HyperlinkBase'*/:
			case 'manager' /*case 'Manager'*/:
			case 'contentstatus' /*case 'ContentStatus'*/:
			case 'identifier' /*case 'Identifier'*/:
			case 'language' /*case 'Language'*/:
			case 'appname' /*case 'AppName'*/:
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
				else pidx = Rn.index + Rn[0].length;
				break;
			case 'paragraphs' /*case 'Paragraphs'*/: break;
	
			case 'styles' /*case 'Styles'*/:
			case 'workbook' /*case 'Workbook'*/:
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else state.push([Rn[3], false]);
				break;
	
			case 'comment' /*case 'Comment'*/:
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
					xlml_clean_comment(comment);
					comments.push(comment);
				} else {
					state.push([Rn[3], false]);
					tmp = xlml_parsexmltag(Rn[0]);
					comment = ({a:tmp.Author});
				}
				break;
	
			case 'autofilter' /*case 'AutoFilter'*/:
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
					var AutoFilter = xlml_parsexmltag(Rn[0]);
					cursheet['!autofilter'] = { ref:rc_to_a1(AutoFilter.Range).replace(/\$/g,"") };
					state.push([Rn[3], true]);
				}
				break;
	
			case 'name' /*case 'Name'*/: break;
	
			case 'datavalidation' /*case 'DataValidation'*/:
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
				} else {
					if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				}
				break;
	
			case 'pixelsperinch' /*case 'PixelsPerInch'*/:
				break;
			case 'componentoptions' /*case 'ComponentOptions'*/:
			case 'documentproperties' /*case 'DocumentProperties'*/:
			case 'customdocumentproperties' /*case 'CustomDocumentProperties'*/:
			case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/:
			case 'pivottable' /*case 'PivotTable'*/:
			case 'pivotcache' /*case 'PivotCache'*/:
			case 'names' /*case 'Names'*/:
			case 'mapinfo' /*case 'MapInfo'*/:
			case 'pagebreaks' /*case 'PageBreaks'*/:
			case 'querytable' /*case 'QueryTable'*/:
			case 'sorting' /*case 'Sorting'*/:
			case 'schema' /*case 'Schema'*/: //case 'data' /*case 'data'*/:
			case 'conditionalformatting' /*case 'ConditionalFormatting'*/:
			case 'smarttagtype' /*case 'SmartTagType'*/:
			case 'smarttags' /*case 'SmartTags'*/:
			case 'excelworkbook' /*case 'ExcelWorkbook'*/:
			case 'workbookoptions' /*case 'WorkbookOptions'*/:
			case 'worksheetoptions' /*case 'WorksheetOptions'*/:
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				break;
	
			case 'null' /*case 'Null'*/: break;
	
			default:
				/* FODS file root is <office:document> */
				if(state.length == 0 && Rn[3] == "document") return parse_fods(str, opts);
				/* UOS file root is <uof:UOF> */
				if(state.length == 0 && Rn[3] == "uof"/*"UOF"*/) return parse_fods(str, opts);
	
				var seen = true;
				switch(state[state.length-1][0]) {
					/* OfficeDocumentSettings */
					case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/: switch(Rn[3]) {
						case 'allowpng' /*case 'AllowPNG'*/: break;
						case 'removepersonalinformation' /*case 'RemovePersonalInformation'*/: break;
						case 'downloadcomponents' /*case 'DownloadComponents'*/: break;
						case 'locationofcomponents' /*case 'LocationOfComponents'*/: break;
						case 'colors' /*case 'Colors'*/: break;
						case 'color' /*case 'Color'*/: break;
						case 'index' /*case 'Index'*/: break;
						case 'rgb' /*case 'RGB'*/: break;
						case 'targetscreensize' /*case 'TargetScreenSize'*/: break;
						case 'readonlyrecommended' /*case 'ReadOnlyRecommended'*/: break;
						default: seen = false;
					} break;
	
					/* ComponentOptions */
					case 'componentoptions' /*case 'ComponentOptions'*/: switch(Rn[3]) {
						case 'toolbar' /*case 'Toolbar'*/: break;
						case 'hideofficelogo' /*case 'HideOfficeLogo'*/: break;
						case 'spreadsheetautofit' /*case 'SpreadsheetAutoFit'*/: break;
						case 'label' /*case 'Label'*/: break;
						case 'caption' /*case 'Caption'*/: break;
						case 'maxheight' /*case 'MaxHeight'*/: break;
						case 'maxwidth' /*case 'MaxWidth'*/: break;
						case 'nextsheetnumber' /*case 'NextSheetNumber'*/: break;
						default: seen = false;
					} break;
	
					/* ExcelWorkbook */
					case 'excelworkbook' /*case 'ExcelWorkbook'*/: switch(Rn[3]) {
						case 'date1904' /*case 'Date1904'*/:
	Workbook.WBProps.date1904 = true;
							break;
						case 'windowheight' /*case 'WindowHeight'*/: break;
						case 'windowwidth' /*case 'WindowWidth'*/: break;
						case 'windowtopx' /*case 'WindowTopX'*/: break;
						case 'windowtopy' /*case 'WindowTopY'*/: break;
						case 'tabratio' /*case 'TabRatio'*/: break;
						case 'protectstructure' /*case 'ProtectStructure'*/: break;
						case 'protectwindow' /*case 'ProtectWindow'*/: break;
						case 'protectwindows' /*case 'ProtectWindows'*/: break;
						case 'activesheet' /*case 'ActiveSheet'*/: break;
						case 'displayinknotes' /*case 'DisplayInkNotes'*/: break;
						case 'firstvisiblesheet' /*case 'FirstVisibleSheet'*/: break;
						case 'supbook' /*case 'SupBook'*/: break;
						case 'sheetname' /*case 'SheetName'*/: break;
						case 'sheetindex' /*case 'SheetIndex'*/: break;
						case 'sheetindexfirst' /*case 'SheetIndexFirst'*/: break;
						case 'sheetindexlast' /*case 'SheetIndexLast'*/: break;
						case 'dll' /*case 'Dll'*/: break;
						case 'acceptlabelsinformulas' /*case 'AcceptLabelsInFormulas'*/: break;
						case 'donotsavelinkvalues' /*case 'DoNotSaveLinkValues'*/: break;
						case 'iteration' /*case 'Iteration'*/: break;
						case 'maxiterations' /*case 'MaxIterations'*/: break;
						case 'maxchange' /*case 'MaxChange'*/: break;
						case 'path' /*case 'Path'*/: break;
						case 'xct' /*case 'Xct'*/: break;
						case 'count' /*case 'Count'*/: break;
						case 'selectedsheets' /*case 'SelectedSheets'*/: break;
						case 'calculation' /*case 'Calculation'*/: break;
						case 'uncalced' /*case 'Uncalced'*/: break;
						case 'startupprompt' /*case 'StartupPrompt'*/: break;
						case 'crn' /*case 'Crn'*/: break;
						case 'externname' /*case 'ExternName'*/: break;
						case 'formula' /*case 'Formula'*/: break;
						case 'colfirst' /*case 'ColFirst'*/: break;
						case 'collast' /*case 'ColLast'*/: break;
						case 'wantadvise' /*case 'WantAdvise'*/: break;
						case 'boolean' /*case 'Boolean'*/: break;
						case 'error' /*case 'Error'*/: break;
						case 'text' /*case 'Text'*/: break;
						case 'ole' /*case 'OLE'*/: break;
						case 'noautorecover' /*case 'NoAutoRecover'*/: break;
						case 'publishobjects' /*case 'PublishObjects'*/: break;
						case 'donotcalculatebeforesave' /*case 'DoNotCalculateBeforeSave'*/: break;
						case 'number' /*case 'Number'*/: break;
						case 'refmoder1c1' /*case 'RefModeR1C1'*/: break;
						case 'embedsavesmarttags' /*case 'EmbedSaveSmartTags'*/: break;
						default: seen = false;
					} break;
	
					/* WorkbookOptions */
					case 'workbookoptions' /*case 'WorkbookOptions'*/: switch(Rn[3]) {
						case 'owcversion' /*case 'OWCVersion'*/: break;
						case 'height' /*case 'Height'*/: break;
						case 'width' /*case 'Width'*/: break;
						default: seen = false;
					} break;
	
					/* WorksheetOptions */
					case 'worksheetoptions' /*case 'WorksheetOptions'*/: switch(Rn[3]) {
						case 'visible' /*case 'Visible'*/:
							if(Rn[0].slice(-2) === "/>"){/* empty */}
							else if(Rn[1]==="/") switch(str.slice(pidx, Rn.index)) {
								case "SheetHidden": wsprops.Hidden = 1; break;
								case "SheetVeryHidden": wsprops.Hidden = 2; break;
							}
							else pidx = Rn.index + Rn[0].length;
							break;
						case 'header' /*case 'Header'*/:
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
							if(!isNaN(+parsexmltag(Rn[0]).Margin)) cursheet['!margins'].header = +parsexmltag(Rn[0]).Margin;
							break;
						case 'footer' /*case 'Footer'*/:
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
							if(!isNaN(+parsexmltag(Rn[0]).Margin)) cursheet['!margins'].footer = +parsexmltag(Rn[0]).Margin;
							break;
						case 'pagemargins' /*case 'PageMargins'*/:
							var pagemargins = parsexmltag(Rn[0]);
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={},'xlml');
							if(!isNaN(+pagemargins.Top)) cursheet['!margins'].top = +pagemargins.Top;
							if(!isNaN(+pagemargins.Left)) cursheet['!margins'].left = +pagemargins.Left;
							if(!isNaN(+pagemargins.Right)) cursheet['!margins'].right = +pagemargins.Right;
							if(!isNaN(+pagemargins.Bottom)) cursheet['!margins'].bottom = +pagemargins.Bottom;
							break;
						case 'displayrighttoleft' /*case 'DisplayRightToLeft'*/:
							if(!Workbook.Views) Workbook.Views = [];
							if(!Workbook.Views[0]) Workbook.Views[0] = {};
							Workbook.Views[0].RTL = true;
							break;
	
						case 'freezepanes' /*case 'FreezePanes'*/: break;
						case 'frozennosplit' /*case 'FrozenNoSplit'*/: break;
	
						case 'splithorizontal' /*case 'SplitHorizontal'*/:
						case 'splitvertical' /*case 'SplitVertical'*/:
							break;
	
						case 'donotdisplaygridlines' /*case 'DoNotDisplayGridlines'*/:
							break;
	
						case 'activerow' /*case 'ActiveRow'*/: break;
						case 'activecol' /*case 'ActiveCol'*/: break;
						case 'toprowbottompane' /*case 'TopRowBottomPane'*/: break;
						case 'leftcolumnrightpane' /*case 'LeftColumnRightPane'*/: break;
	
						case 'unsynced' /*case 'Unsynced'*/: break;
						case 'print' /*case 'Print'*/: break;
						case 'printerrors' /*case 'PrintErrors'*/: break;
						case 'panes' /*case 'Panes'*/: break;
						case 'scale' /*case 'Scale'*/: break;
						case 'pane' /*case 'Pane'*/: break;
						case 'number' /*case 'Number'*/: break;
						case 'layout' /*case 'Layout'*/: break;
						case 'pagesetup' /*case 'PageSetup'*/: break;
						case 'selected' /*case 'Selected'*/: break;
						case 'protectobjects' /*case 'ProtectObjects'*/: break;
						case 'enableselection' /*case 'EnableSelection'*/: break;
						case 'protectscenarios' /*case 'ProtectScenarios'*/: break;
						case 'validprinterinfo' /*case 'ValidPrinterInfo'*/: break;
						case 'horizontalresolution' /*case 'HorizontalResolution'*/: break;
						case 'verticalresolution' /*case 'VerticalResolution'*/: break;
						case 'numberofcopies' /*case 'NumberofCopies'*/: break;
						case 'activepane' /*case 'ActivePane'*/: break;
						case 'toprowvisible' /*case 'TopRowVisible'*/: break;
						case 'leftcolumnvisible' /*case 'LeftColumnVisible'*/: break;
						case 'fittopage' /*case 'FitToPage'*/: break;
						case 'rangeselection' /*case 'RangeSelection'*/: break;
						case 'papersizeindex' /*case 'PaperSizeIndex'*/: break;
						case 'pagelayoutzoom' /*case 'PageLayoutZoom'*/: break;
						case 'pagebreakzoom' /*case 'PageBreakZoom'*/: break;
						case 'filteron' /*case 'FilterOn'*/: break;
						case 'fitwidth' /*case 'FitWidth'*/: break;
						case 'fitheight' /*case 'FitHeight'*/: break;
						case 'commentslayout' /*case 'CommentsLayout'*/: break;
						case 'zoom' /*case 'Zoom'*/: break;
						case 'lefttoright' /*case 'LeftToRight'*/: break;
						case 'gridlines' /*case 'Gridlines'*/: break;
						case 'allowsort' /*case 'AllowSort'*/: break;
						case 'allowfilter' /*case 'AllowFilter'*/: break;
						case 'allowinsertrows' /*case 'AllowInsertRows'*/: break;
						case 'allowdeleterows' /*case 'AllowDeleteRows'*/: break;
						case 'allowinsertcols' /*case 'AllowInsertCols'*/: break;
						case 'allowdeletecols' /*case 'AllowDeleteCols'*/: break;
						case 'allowinserthyperlinks' /*case 'AllowInsertHyperlinks'*/: break;
						case 'allowformatcells' /*case 'AllowFormatCells'*/: break;
						case 'allowsizecols' /*case 'AllowSizeCols'*/: break;
						case 'allowsizerows' /*case 'AllowSizeRows'*/: break;
						case 'nosummaryrowsbelowdetail' /*case 'NoSummaryRowsBelowDetail'*/:
							if(!cursheet["!outline"]) cursheet["!outline"] = {};
							cursheet["!outline"].above = true;
							break;
						case 'tabcolorindex' /*case 'TabColorIndex'*/: break;
						case 'donotdisplayheadings' /*case 'DoNotDisplayHeadings'*/: break;
						case 'showpagelayoutzoom' /*case 'ShowPageLayoutZoom'*/: break;
						case 'nosummarycolumnsrightdetail' /*case 'NoSummaryColumnsRightDetail'*/:
							if(!cursheet["!outline"]) cursheet["!outline"] = {};
							cursheet["!outline"].left = true;
							break;
						case 'blackandwhite' /*case 'BlackAndWhite'*/: break;
						case 'donotdisplayzeros' /*case 'DoNotDisplayZeros'*/: break;
						case 'displaypagebreak' /*case 'DisplayPageBreak'*/: break;
						case 'rowcolheadings' /*case 'RowColHeadings'*/: break;
						case 'donotdisplayoutline' /*case 'DoNotDisplayOutline'*/: break;
						case 'noorientation' /*case 'NoOrientation'*/: break;
						case 'allowusepivottables' /*case 'AllowUsePivotTables'*/: break;
						case 'zeroheight' /*case 'ZeroHeight'*/: break;
						case 'viewablerange' /*case 'ViewableRange'*/: break;
						case 'selection' /*case 'Selection'*/: break;
						case 'protectcontents' /*case 'ProtectContents'*/: break;
						default: seen = false;
					} break;
	
					/* PivotTable */
					case 'pivottable' /*case 'PivotTable'*/: case 'pivotcache' /*case 'PivotCache'*/: switch(Rn[3]) {
						case 'immediateitemsondrop' /*case 'ImmediateItemsOnDrop'*/: break;
						case 'showpagemultipleitemlabel' /*case 'ShowPageMultipleItemLabel'*/: break;
						case 'compactrowindent' /*case 'CompactRowIndent'*/: break;
						case 'location' /*case 'Location'*/: break;
						case 'pivotfield' /*case 'PivotField'*/: break;
						case 'orientation' /*case 'Orientation'*/: break;
						case 'layoutform' /*case 'LayoutForm'*/: break;
						case 'layoutsubtotallocation' /*case 'LayoutSubtotalLocation'*/: break;
						case 'layoutcompactrow' /*case 'LayoutCompactRow'*/: break;
						case 'position' /*case 'Position'*/: break;
						case 'pivotitem' /*case 'PivotItem'*/: break;
						case 'datatype' /*case 'DataType'*/: break;
						case 'datafield' /*case 'DataField'*/: break;
						case 'sourcename' /*case 'SourceName'*/: break;
						case 'parentfield' /*case 'ParentField'*/: break;
						case 'ptlineitems' /*case 'PTLineItems'*/: break;
						case 'ptlineitem' /*case 'PTLineItem'*/: break;
						case 'countofsameitems' /*case 'CountOfSameItems'*/: break;
						case 'item' /*case 'Item'*/: break;
						case 'itemtype' /*case 'ItemType'*/: break;
						case 'ptsource' /*case 'PTSource'*/: break;
						case 'cacheindex' /*case 'CacheIndex'*/: break;
						case 'consolidationreference' /*case 'ConsolidationReference'*/: break;
						case 'filename' /*case 'FileName'*/: break;
						case 'reference' /*case 'Reference'*/: break;
						case 'nocolumngrand' /*case 'NoColumnGrand'*/: break;
						case 'norowgrand' /*case 'NoRowGrand'*/: break;
						case 'blanklineafteritems' /*case 'BlankLineAfterItems'*/: break;
						case 'hidden' /*case 'Hidden'*/: break;
						case 'subtotal' /*case 'Subtotal'*/: break;
						case 'basefield' /*case 'BaseField'*/: break;
						case 'mapchilditems' /*case 'MapChildItems'*/: break;
						case 'function' /*case 'Function'*/: break;
						case 'refreshonfileopen' /*case 'RefreshOnFileOpen'*/: break;
						case 'printsettitles' /*case 'PrintSetTitles'*/: break;
						case 'mergelabels' /*case 'MergeLabels'*/: break;
						case 'defaultversion' /*case 'DefaultVersion'*/: break;
						case 'refreshname' /*case 'RefreshName'*/: break;
						case 'refreshdate' /*case 'RefreshDate'*/: break;
						case 'refreshdatecopy' /*case 'RefreshDateCopy'*/: break;
						case 'versionlastrefresh' /*case 'VersionLastRefresh'*/: break;
						case 'versionlastupdate' /*case 'VersionLastUpdate'*/: break;
						case 'versionupdateablemin' /*case 'VersionUpdateableMin'*/: break;
						case 'versionrefreshablemin' /*case 'VersionRefreshableMin'*/: break;
						case 'calculation' /*case 'Calculation'*/: break;
						default: seen = false;
					} break;
	
					/* PageBreaks */
					case 'pagebreaks' /*case 'PageBreaks'*/: switch(Rn[3]) {
						case 'colbreaks' /*case 'ColBreaks'*/: break;
						case 'colbreak' /*case 'ColBreak'*/: break;
						case 'rowbreaks' /*case 'RowBreaks'*/: break;
						case 'rowbreak' /*case 'RowBreak'*/: break;
						case 'colstart' /*case 'ColStart'*/: break;
						case 'colend' /*case 'ColEnd'*/: break;
						case 'rowend' /*case 'RowEnd'*/: break;
						default: seen = false;
					} break;
	
					/* AutoFilter */
					case 'autofilter' /*case 'AutoFilter'*/: switch(Rn[3]) {
						case 'autofiltercolumn' /*case 'AutoFilterColumn'*/: break;
						case 'autofiltercondition' /*case 'AutoFilterCondition'*/: break;
						case 'autofilterand' /*case 'AutoFilterAnd'*/: break;
						case 'autofilteror' /*case 'AutoFilterOr'*/: break;
						default: seen = false;
					} break;
	
					/* QueryTable */
					case 'querytable' /*case 'QueryTable'*/: switch(Rn[3]) {
						case 'id' /*case 'Id'*/: break;
						case 'autoformatfont' /*case 'AutoFormatFont'*/: break;
						case 'autoformatpattern' /*case 'AutoFormatPattern'*/: break;
						case 'querysource' /*case 'QuerySource'*/: break;
						case 'querytype' /*case 'QueryType'*/: break;
						case 'enableredirections' /*case 'EnableRedirections'*/: break;
						case 'refreshedinxl9' /*case 'RefreshedInXl9'*/: break;
						case 'urlstring' /*case 'URLString'*/: break;
						case 'htmltables' /*case 'HTMLTables'*/: break;
						case 'connection' /*case 'Connection'*/: break;
						case 'commandtext' /*case 'CommandText'*/: break;
						case 'refreshinfo' /*case 'RefreshInfo'*/: break;
						case 'notitles' /*case 'NoTitles'*/: break;
						case 'nextid' /*case 'NextId'*/: break;
						case 'columninfo' /*case 'ColumnInfo'*/: break;
						case 'overwritecells' /*case 'OverwriteCells'*/: break;
						case 'donotpromptforfile' /*case 'DoNotPromptForFile'*/: break;
						case 'textwizardsettings' /*case 'TextWizardSettings'*/: break;
						case 'source' /*case 'Source'*/: break;
						case 'number' /*case 'Number'*/: break;
						case 'decimal' /*case 'Decimal'*/: break;
						case 'thousandseparator' /*case 'ThousandSeparator'*/: break;
						case 'trailingminusnumbers' /*case 'TrailingMinusNumbers'*/: break;
						case 'formatsettings' /*case 'FormatSettings'*/: break;
						case 'fieldtype' /*case 'FieldType'*/: break;
						case 'delimiters' /*case 'Delimiters'*/: break;
						case 'tab' /*case 'Tab'*/: break;
						case 'comma' /*case 'Comma'*/: break;
						case 'autoformatname' /*case 'AutoFormatName'*/: break;
						case 'versionlastedit' /*case 'VersionLastEdit'*/: break;
						case 'versionlastrefresh' /*case 'VersionLastRefresh'*/: break;
						default: seen = false;
					} break;
	
					case 'datavalidation' /*case 'DataValidation'*/:
					switch(Rn[3]) {
						case 'range' /*case 'Range'*/: break;
	
						case 'type' /*case 'Type'*/: break;
						case 'min' /*case 'Min'*/: break;
						case 'max' /*case 'Max'*/: break;
						case 'sort' /*case 'Sort'*/: break;
						case 'descending' /*case 'Descending'*/: break;
						case 'order' /*case 'Order'*/: break;
						case 'casesensitive' /*case 'CaseSensitive'*/: break;
						case 'value' /*case 'Value'*/: break;
						case 'errorstyle' /*case 'ErrorStyle'*/: break;
						case 'errormessage' /*case 'ErrorMessage'*/: break;
						case 'errortitle' /*case 'ErrorTitle'*/: break;
						case 'inputmessage' /*case 'InputMessage'*/: break;
						case 'inputtitle' /*case 'InputTitle'*/: break;
						case 'combohide' /*case 'ComboHide'*/: break;
						case 'inputhide' /*case 'InputHide'*/: break;
						case 'condition' /*case 'Condition'*/: break;
						case 'qualifier' /*case 'Qualifier'*/: break;
						case 'useblank' /*case 'UseBlank'*/: break;
						case 'value1' /*case 'Value1'*/: break;
						case 'value2' /*case 'Value2'*/: break;
						case 'format' /*case 'Format'*/: break;
	
						case 'cellrangelist' /*case 'CellRangeList'*/: break;
						default: seen = false;
					} break;
	
					case 'sorting' /*case 'Sorting'*/:
					case 'conditionalformatting' /*case 'ConditionalFormatting'*/:
					switch(Rn[3]) {
						case 'range' /*case 'Range'*/: break;
						case 'type' /*case 'Type'*/: break;
						case 'min' /*case 'Min'*/: break;
						case 'max' /*case 'Max'*/: break;
						case 'sort' /*case 'Sort'*/: break;
						case 'descending' /*case 'Descending'*/: break;
						case 'order' /*case 'Order'*/: break;
						case 'casesensitive' /*case 'CaseSensitive'*/: break;
						case 'value' /*case 'Value'*/: break;
						case 'errorstyle' /*case 'ErrorStyle'*/: break;
						case 'errormessage' /*case 'ErrorMessage'*/: break;
						case 'errortitle' /*case 'ErrorTitle'*/: break;
						case 'cellrangelist' /*case 'CellRangeList'*/: break;
						case 'inputmessage' /*case 'InputMessage'*/: break;
						case 'inputtitle' /*case 'InputTitle'*/: break;
						case 'combohide' /*case 'ComboHide'*/: break;
						case 'inputhide' /*case 'InputHide'*/: break;
						case 'condition' /*case 'Condition'*/: break;
						case 'qualifier' /*case 'Qualifier'*/: break;
						case 'useblank' /*case 'UseBlank'*/: break;
						case 'value1' /*case 'Value1'*/: break;
						case 'value2' /*case 'Value2'*/: break;
						case 'format' /*case 'Format'*/: break;
						default: seen = false;
					} break;
	
					/* MapInfo (schema) */
					case 'mapinfo' /*case 'MapInfo'*/: case 'schema' /*case 'Schema'*/: case 'data' /*case 'data'*/: switch(Rn[3]) {
						case 'map' /*case 'Map'*/: break;
						case 'entry' /*case 'Entry'*/: break;
						case 'range' /*case 'Range'*/: break;
						case 'xpath' /*case 'XPath'*/: break;
						case 'field' /*case 'Field'*/: break;
						case 'xsdtype' /*case 'XSDType'*/: break;
						case 'filteron' /*case 'FilterOn'*/: break;
						case 'aggregate' /*case 'Aggregate'*/: break;
						case 'elementtype' /*case 'ElementType'*/: break;
						case 'attributetype' /*case 'AttributeType'*/: break;
					/* These are from xsd (XML Schema Definition) */
						case 'schema' /*case 'schema'*/:
						case 'element' /*case 'element'*/:
						case 'complextype' /*case 'complexType'*/:
						case 'datatype' /*case 'datatype'*/:
						case 'all' /*case 'all'*/:
						case 'attribute' /*case 'attribute'*/:
						case 'extends' /*case 'extends'*/: break;
	
						case 'row' /*case 'row'*/: break;
						default: seen = false;
					} break;
	
					/* SmartTags (can be anything) */
					case 'smarttags' /*case 'SmartTags'*/: break;
	
					default: seen = false; break;
				}
				if(seen) break;
				/* CustomDocumentProperties */
				if(Rn[3].match(/!\[CDATA/)) break;
				if(!state[state.length-1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
				if(state[state.length-1][0]===/*'CustomDocumentProperties'*/'customdocumentproperties') {
					if(Rn[0].slice(-2) === "/>") break;
					else if(Rn[1]==="/") xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
					else { cp = Rn; pidx = Rn.index + Rn[0].length; }
					break;
				}
				if(opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
		}
		var out = ({});
		if(!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
		out.SheetNames = sheetnames;
		out.Workbook = Workbook;
		out.SSF = dup(table_fmt);
		out.Props = Props;
		out.Custprops = Custprops;
		return out;
	}
	
	function parse_xlml(data, opts) {
		fix_read_opts(opts=opts||{});
		switch(opts.type||"base64") {
			case "base64": return parse_xlml_xml(Base64_decode(data), opts);
			case "binary": case "buffer": case "file": return parse_xlml_xml(data, opts);
			case "array": return parse_xlml_xml(a2s(data), opts);
		}
	}
	
	/* TODO */
	function write_props_xlml(wb, opts) {
		var o = [];
		/* DocumentProperties */
		if(wb.Props) o.push(xlml_write_docprops(wb.Props, opts));
		/* CustomDocumentProperties */
		if(wb.Custprops) o.push(xlml_write_custprops(wb.Props, wb.Custprops, opts));
		return o.join("");
	}
	/* TODO */
	function write_wb_xlml() {
		/* OfficeDocumentSettings */
		/* ExcelWorkbook */
		return "";
	}
	/* TODO */
	function write_sty_xlml(wb, opts) {
		/* Styles */
		var styles = ['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];
		opts.cellXfs.forEach(function(xf, id) {
			var payload = [];
			payload.push(writextag('NumberFormat', null, {"ss:Format": escapexml(table_fmt[xf.numFmtId])}));
	
			var o = {"ss:ID": "s" + (21+id)};
			styles.push(writextag('Style', payload.join(""), o));
		});
		return writextag("Styles", styles.join(""));
	}
	function write_name_xlml(n) { return writextag("NamedRange", null, {"ss:Name": n.Name, "ss:RefersTo":"=" + a1_to_rc(n.Ref, {r:0,c:0})}); }
	function write_names_xlml(wb) {
		if(!((wb||{}).Workbook||{}).Names) return "";
	var names = wb.Workbook.Names;
		var out = [];
		for(var i = 0; i < names.length; ++i) {
			var n = names[i];
			if(n.Sheet != null) continue;
			if(n.Name.match(/^_xlfn\./)) continue;
			out.push(write_name_xlml(n));
		}
		return writextag("Names", out.join(""));
	}
	function write_ws_xlml_names(ws, opts, idx, wb) {
		if(!ws) return "";
		if(!((wb||{}).Workbook||{}).Names) return "";
	var names = wb.Workbook.Names;
		var out = [];
		for(var i = 0; i < names.length; ++i) {
			var n = names[i];
			if(n.Sheet != idx) continue;
			/*switch(n.Name) {
				case "_": continue;
			}*/
			if(n.Name.match(/^_xlfn\./)) continue;
			out.push(write_name_xlml(n));
		}
		return out.join("");
	}
	/* WorksheetOptions */
	function write_ws_xlml_wsopts(ws, opts, idx, wb) {
		if(!ws) return "";
		var o = [];
		/* NOTE: spec technically allows any order, but stick with implied order */
	
		/* FitToPage */
		/* DoNotDisplayColHeaders */
		/* DoNotDisplayRowHeaders */
		/* ViewableRange */
		/* Selection */
		/* GridlineColor */
		/* Name */
		/* ExcelWorksheetType */
		/* IntlMacro */
		/* Unsynced */
		/* Selected */
		/* CodeName */
	
		if(ws['!margins']) {
			o.push("<PageSetup>");
			if(ws['!margins'].header) o.push(writextag("Header", null, {'x:Margin':ws['!margins'].header}));
			if(ws['!margins'].footer) o.push(writextag("Footer", null, {'x:Margin':ws['!margins'].footer}));
			o.push(writextag("PageMargins", null, {
				'x:Bottom': ws['!margins'].bottom || "0.75",
				'x:Left': ws['!margins'].left || "0.7",
				'x:Right': ws['!margins'].right || "0.7",
				'x:Top': ws['!margins'].top || "0.75"
			}));
			o.push("</PageSetup>");
		}
	
		/* PageSetup */
		/* DisplayPageBreak */
		/* TransitionExpressionEvaluation */
		/* TransitionFormulaEntry */
		/* Print */
		/* Zoom */
		/* PageLayoutZoom */
		/* PageBreakZoom */
		/* ShowPageBreakZoom */
		/* DefaultRowHeight */
		/* DefaultColumnWidth */
		/* StandardWidth */
	
		if(wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
			/* Visible */
			if(wb.Workbook.Sheets[idx].Hidden) o.push(writextag("Visible", (wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden"), {}));
			else {
				/* Selected */
				for(var i = 0; i < idx; ++i) if(wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
				if(i == idx) o.push("<Selected/>");
			}
		}
	
		/* LeftColumnVisible */
	
		if(((((wb||{}).Workbook||{}).Views||[])[0]||{}).RTL) o.push("<DisplayRightToLeft/>");
	
		/* GridlineColorIndex */
		/* DisplayFormulas */
		/* DoNotDisplayGridlines */
		/* DoNotDisplayHeadings */
		/* DoNotDisplayOutline */
		/* ApplyAutomaticOutlineStyles */
		/* NoSummaryRowsBelowDetail */
		/* NoSummaryColumnsRightDetail */
		/* DoNotDisplayZeros */
		/* ActiveRow */
		/* ActiveColumn */
		/* FilterOn */
		/* RangeSelection */
		/* TopRowVisible */
		/* TopRowBottomPane */
		/* LeftColumnRightPane */
		/* ActivePane */
		/* SplitHorizontal */
		/* SplitVertical */
		/* FreezePanes */
		/* FrozenNoSplit */
		/* TabColorIndex */
		/* Panes */
	
		/* NOTE: Password not supported in XLML Format */
		if(ws['!protect']) {
			o.push(writetag("ProtectContents", "True"));
			if(ws['!protect'].objects) o.push(writetag("ProtectObjects", "True"));
			if(ws['!protect'].scenarios) o.push(writetag("ProtectScenarios", "True"));
			if(ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push(writetag("EnableSelection", "NoSelection"));
			else if(ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push(writetag("EnableSelection", "UnlockedCells"));
		[
			[ "formatCells", "AllowFormatCells" ],
			[ "formatColumns", "AllowSizeCols" ],
			[ "formatRows", "AllowSizeRows" ],
			[ "insertColumns", "AllowInsertCols" ],
			[ "insertRows", "AllowInsertRows" ],
			[ "insertHyperlinks", "AllowInsertHyperlinks" ],
			[ "deleteColumns", "AllowDeleteCols" ],
			[ "deleteRows", "AllowDeleteRows" ],
			[ "sort", "AllowSort" ],
			[ "autoFilter", "AllowFilter" ],
			[ "pivotTables", "AllowUsePivotTables" ]
		].forEach(function(x) { if(ws['!protect'][x[0]]) o.push("<"+x[1]+"/>"); });
		}
	
		if(o.length == 0) return "";
		return writextag("WorksheetOptions", o.join(""), {xmlns:XLMLNS.x});
	}
	function write_ws_xlml_comment(comments) {
		return comments.map(function(c) {
			// TODO: formatted text
			var t = xlml_unfixstr(c.t||"");
			var d =writextag("ss:Data", t, {"xmlns":"http://www.w3.org/TR/REC-html40"});
			return writextag("Comment", d, {"ss:Author":c.a});
		}).join("");
	}
	function write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr){
		if(!cell || (cell.v == undefined && cell.f == undefined)) return "";
	
		var attr = {};
		if(cell.f) attr["ss:Formula"] = "=" + escapexml(a1_to_rc(cell.f, addr));
		if(cell.F && cell.F.slice(0, ref.length) == ref) {
			var end = decode_cell(cell.F.slice(ref.length + 1));
			attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
		}
	
		if(cell.l && cell.l.Target) {
			attr["ss:HRef"] = escapexml(cell.l.Target);
			if(cell.l.Tooltip) attr["x:HRefScreenTip"] = escapexml(cell.l.Tooltip);
		}
	
		if(ws['!merges']) {
			var marr = ws['!merges'];
			for(var mi = 0; mi != marr.length; ++mi) {
				if(marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
				if(marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
				if(marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
			}
		}
	
		var t = "", p = "";
		switch(cell.t) {
			case 'z': if(!opts.sheetStubs) return ""; break;
			case 'n': t = 'Number'; p = String(cell.v); break;
			case 'b': t = 'Boolean'; p = (cell.v ? "1" : "0"); break;
			case 'e': t = 'Error'; p = BErr[cell.v]; break;
			case 'd': t = 'DateTime'; p = new Date(cell.v).toISOString(); if(cell.z == null) cell.z = cell.z || table_fmt[14]; break;
			case 's': t = 'String'; p = escapexlml(cell.v||""); break;
		}
		/* TODO: cell style */
		var os = get_cell_style(opts.cellXfs, cell, opts);
		attr["ss:StyleID"] = "s" + (21+os);
		attr["ss:Index"] = addr.c + 1;
		var _v = (cell.v != null ? p : "");
		var m = cell.t == 'z' ? "" : ('<Data ss:Type="' + t + '">' + _v + '</Data>');
	
		if((cell.c||[]).length > 0) m += write_ws_xlml_comment(cell.c);
	
		return writextag("Cell", m, attr);
	}
	function write_ws_xlml_row(R, row) {
		var o = '<Row ss:Index="' + (R+1) + '"';
		if(row) {
			if(row.hpt && !row.hpx) row.hpx = pt2px(row.hpt);
			if(row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
			if(row.hidden) o += ' ss:Hidden="1"';
		}
		return o + '>';
	}
	/* TODO */
	function write_ws_xlml_table(ws, opts, idx, wb) {
		if(!ws['!ref']) return "";
		var range = safe_decode_range(ws['!ref']);
		var marr = ws['!merges'] || [], mi = 0;
		var o = [];
		if(ws['!cols']) ws['!cols'].forEach(function(n, i) {
			process_col(n);
			var w = !!n.width;
			var p = col_obj_w(i, n);
			var k = {"ss:Index":i+1};
			if(w) k['ss:Width'] = width2px(p.width);
			if(n.hidden) k['ss:Hidden']="1";
			o.push(writextag("Column",null,k));
		});
		var dense = Array.isArray(ws);
		for(var R = range.s.r; R <= range.e.r; ++R) {
			var row = [write_ws_xlml_row(R, (ws['!rows']||[])[R])];
			for(var C = range.s.c; C <= range.e.c; ++C) {
				var skip = false;
				for(mi = 0; mi != marr.length; ++mi) {
					if(marr[mi].s.c > C) continue;
					if(marr[mi].s.r > R) continue;
					if(marr[mi].e.c < C) continue;
					if(marr[mi].e.r < R) continue;
					if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
					break;
				}
				if(skip) continue;
				var addr = {r:R,c:C};
				var ref = encode_cell(addr), cell = dense ? (ws[R]||[])[C] : ws[ref];
				row.push(write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
			}
			row.push("</Row>");
			if(row.length > 2) o.push(row.join(""));
		}
		return o.join("");
	}
	function write_ws_xlml(idx, opts, wb) {
		var o = [];
		var s = wb.SheetNames[idx];
		var ws = wb.Sheets[s];
	
		var t = ws ? write_ws_xlml_names(ws, opts, idx, wb) : "";
		if(t.length > 0) o.push("<Names>" + t + "</Names>");
	
		/* Table */
		t = ws ? write_ws_xlml_table(ws, opts, idx, wb) : "";
		if(t.length > 0) o.push("<Table>" + t + "</Table>");
	
		/* WorksheetOptions */
		o.push(write_ws_xlml_wsopts(ws, opts, idx, wb));
	
		return o.join("");
	}
	function write_xlml(wb, opts) {
		if(!opts) opts = {};
		if(!wb.SSF) wb.SSF = dup(table_fmt);
		if(wb.SSF) {
			make_ssf(); SSF_load_table(wb.SSF);
			// $FlowIgnore
			opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
			opts.ssf = wb.SSF;
			opts.cellXfs = [];
			get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
		}
		var d = [];
		d.push(write_props_xlml(wb, opts));
		d.push(write_wb_xlml(wb, opts));
		d.push("");
		d.push("");
		for(var i = 0; i < wb.SheetNames.length; ++i)
			d.push(writextag("Worksheet", write_ws_xlml(i, opts, wb), {"ss:Name":escapexml(wb.SheetNames[i])}));
		d[2] = write_sty_xlml(wb, opts);
		d[3] = write_names_xlml(wb, opts);
		return XML_HEADER + writextag("Workbook", d.join(""), {
			'xmlns':      XLMLNS.ss,
			'xmlns:o':    XLMLNS.o,
			'xmlns:x':    XLMLNS.x,
			'xmlns:ss':   XLMLNS.ss,
			'xmlns:dt':   XLMLNS.dt,
			'xmlns:html': XLMLNS.html
		});
	}
	/* [MS-OLEDS] 2.3.8 CompObjStream */
	function parse_compobj(obj) {
		var v = {};
		var o = obj.content;
	/* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */
		o.l = 28;
	
		v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
		v.AnsiClipboardFormat = parse_ClipboardFormatOrAnsiString(o);
	
		if(o.length - o.l <= 4) return v;
	
		var m = o.read_shift(4);
		if(m == 0 || m > 40) return v;
		o.l-=4; v.Reserved1 = o.read_shift(0, "lpstr-ansi");
	
		if(o.length - o.l <= 4) return v;
		m = o.read_shift(4);
		if(m !== 0x71b239f4) return v;
		v.UnicodeClipboardFormat = parse_ClipboardFormatOrUnicodeString(o);
	
		m = o.read_shift(4);
		if(m == 0 || m > 40) return v;
		o.l-=4; v.Reserved2 = o.read_shift(0, "lpwstr");
	}
	
	/*
		Continue logic for:
		- 2.4.58 Continue          0x003c
		- 2.4.59 ContinueBigName   0x043c
		- 2.4.60 ContinueFrt       0x0812
		- 2.4.61 ContinueFrt11     0x0875
		- 2.4.62 ContinueFrt12     0x087f
	*/
	var CONTINUE_RT = [ 0x003c, 0x043c, 0x0812, 0x0875, 0x087f ];
	function slurp(RecordType, R, blob, length, opts) {
		var l = length;
		var bufs = [];
		var d = blob.slice(blob.l,blob.l+l);
		if(opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType) {
		case 0x0009: case 0x0209: case 0x0409: case 0x0809/* BOF */: case 0x002f /* FilePass */: case 0x0195 /* FileLock */: case 0x00e1 /* InterfaceHdr */: case 0x0196 /* RRDInfo */: case 0x0138 /* RRDHead */: case 0x0194 /* UsrExcl */: case 0x000a /* EOF */:
			break;
		case 0x0085 /* BoundSheet8 */:
			break;
		default:
			opts.enc.insitu(d);
		}
		bufs.push(d);
		blob.l += l;
		var nextrt = __readUInt16LE(blob,blob.l), next = XLSRecordEnum[nextrt];
		var start = 0;
		while(next != null && CONTINUE_RT.indexOf(nextrt) > -1) {
			l = __readUInt16LE(blob,blob.l+2);
			start = blob.l + 4;
			if(nextrt == 0x0812 /* ContinueFrt */) start += 4;
			else if(nextrt == 0x0875 || nextrt == 0x087f) {
				start += 12;
			}
			d = blob.slice(start,blob.l+4+l);
			bufs.push(d);
			blob.l += 4+l;
			next = (XLSRecordEnum[nextrt = __readUInt16LE(blob, blob.l)]);
		}
		var b = (bconcat(bufs));
		prep_blob(b, 0);
		var ll = 0; b.lens = [];
		for(var j = 0; j < bufs.length; ++j) { b.lens.push(ll); ll += bufs[j].length; }
		if(b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
		return R.f(b, b.length, opts);
	}
	
	function safe_format_xf(p, opts, date1904) {
		if(p.t === 'z') return;
		if(!p.XF) return;
		var fmtid = 0;
		try {
			fmtid = p.z || p.XF.numFmtId || 0;
			if(opts.cellNF) p.z = table_fmt[fmtid];
		} catch(e) { if(opts.WTF) throw e; }
		if(!opts || opts.cellText !== false) try {
			if(p.t === 'e') { p.w = p.w || BErr[p.v]; }
			else if(fmtid === 0 || fmtid == "General") {
				if(p.t === 'n') {
					if((p.v|0) === p.v) p.w = p.v.toString(10);
					else p.w = SSF_general_num(p.v);
				}
				else p.w = SSF_general(p.v);
			}
			else p.w = SSF_format(fmtid,p.v, {date1904:!!date1904, dateNF: opts && opts.dateNF});
		} catch(e) { if(opts.WTF) throw e; }
		if(opts.cellDates && fmtid && p.t == 'n' && fmt_is_date(table_fmt[fmtid] || String(fmtid))) {
			var _d = SSF_parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
		}
	}
	
	function make_cell(val, ixfe, t) {
		return ({v:val, ixfe:ixfe, t:t});
	}
	
	// 2.3.2
	function parse_workbook(blob, options) {
		var wb = ({opts:{}});
		var Sheets = {};
		if(DENSE != null && options.dense == null) options.dense = DENSE;
		var out = ((options.dense ? [] : {}));
		var Directory = {};
		var range = ({});
		var last_formula = null;
		var sst = ([]);
		var cur_sheet = "";
		var Preamble = {};
		var lastcell, last_cell = "", cc, cmnt, rngC, rngR;
		var sharedf = {};
		var arrayf = [];
		var temp_val;
		var country;
		var XFs = []; /* XF records */
		var palette = [];
		var Workbook = ({ Sheets:[], WBProps:{date1904:false}, Views:[{}] }), wsprops = {};
		var get_rgb = function getrgb(icv) {
			if(icv < 8) return XLSIcv[icv];
			if(icv < 64) return palette[icv-8] || XLSIcv[icv];
			return XLSIcv[icv];
		};
		var process_cell_style = function pcs(cell, line, options) {
			var xfd = line.XF.data;
			if(!xfd || !xfd.patternType || !options || !options.cellStyles) return;
			line.s = ({});
			line.s.patternType = xfd.patternType;
			var t;
			if((t = rgb2Hex(get_rgb(xfd.icvFore)))) { line.s.fgColor = {rgb:t}; }
			if((t = rgb2Hex(get_rgb(xfd.icvBack)))) { line.s.bgColor = {rgb:t}; }
		};
		var addcell = function addcell(cell, line, options) {
			if(file_depth > 1) return;
			if(options.sheetRows && cell.r >= options.sheetRows) return;
			if(options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
			delete line.ixfe; delete line.XF;
			lastcell = cell;
			last_cell = encode_cell(cell);
			if(!range || !range.s || !range.e) range = {s:{r:0,c:0},e:{r:0,c:0}};
			if(cell.r < range.s.r) range.s.r = cell.r;
			if(cell.c < range.s.c) range.s.c = cell.c;
			if(cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
			if(cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
			if(options.cellFormula && line.f) {
				for(var afi = 0; afi < arrayf.length; ++afi) {
					if(arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
					if(arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
					line.F = encode_range(arrayf[afi][0]);
					if(arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
					if(line.f) line.f = "" + stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
					break;
				}
			}
			{
				if(options.dense) {
					if(!out[cell.r]) out[cell.r] = [];
					out[cell.r][cell.c] = line;
				} else out[last_cell] = line;
			}
		};
		var opts = ({
			enc: false, // encrypted
			sbcch: 0, // cch in the preceding SupBook
			snames: [], // sheetnames
			sharedf: sharedf, // shared formulae by address
			arrayf: arrayf, // array formulae array
			rrtabid: [], // RRTabId
			lastuser: "", // Last User from WriteAccess
			biff: 8, // BIFF version
			codepage: 0, // CP from CodePage record
			winlocked: 0, // fLockWn from WinProtect
			cellStyles: !!options && !!options.cellStyles,
			WTF: !!options && !!options.wtf
		});
		if(options.password) opts.password = options.password;
		var themes;
		var merges = [];
		var objects = [];
		var colinfo = [], rowinfo = [];
		var seencol = false;
		var supbooks = ([]); // 1-indexed, will hold extern names
		supbooks.SheetNames = opts.snames;
		supbooks.sharedf = opts.sharedf;
		supbooks.arrayf = opts.arrayf;
		supbooks.names = [];
		supbooks.XTI = [];
		var last_RT = 0;
		var file_depth = 0; /* TODO: make a real stack */
		var BIFF2Fmt = 0, BIFF2FmtTable = [];
		var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */
		var last_lbl;
	
		/* explicit override for some broken writers */
		opts.codepage = 1200;
		set_cp(1200);
		var seen_codepage = false;
		while(blob.l < blob.length - 1) {
			var s = blob.l;
			var RecordType = blob.read_shift(2);
			if(RecordType === 0 && last_RT === 0x000a /* EOF */) break;
			var length = (blob.l === blob.length ? 0 : blob.read_shift(2));
			var R = XLSRecordEnum[RecordType];
			//console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
			//if(!R) console.log(blob.slice(blob.l, blob.l + length));
			if(R && R.f) {
				if(options.bookSheets) {
					if(last_RT === 0x0085 /* BoundSheet8 */ && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */) break;
				}
				last_RT = RecordType;
				if(R.r === 2 || R.r == 12) {
					var rt = blob.read_shift(2); length -= 2;
					if(!opts.enc && rt !== RecordType && (((rt&0xFF)<<8)|(rt>>8)) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
					if(R.r == 12){
						blob.l += 10; length -= 10;
					} // skip FRT
				}
				//console.error(R,blob.l,length,blob.length);
				var val = ({});
				if(RecordType === 0x000a /* EOF */) val = R.f(blob, length, opts);
				else val = slurp(RecordType, R, blob, length, opts);
	if(file_depth == 0 && [0x0009, 0x0209, 0x0409, 0x0809].indexOf(last_RT) === -1 /* 'BOF' */) continue;
				switch(RecordType) {
					case 0x0022 /* Date1904 */:
	wb.opts.Date1904 = Workbook.WBProps.date1904 = val; break;
					case 0x0086 /* WriteProtect */: wb.opts.WriteProtect = true; break;
					case 0x002f /* FilePass */:
						if(!opts.enc) blob.l = 0;
						opts.enc = val;
						if(!options.password) throw new Error("File is password-protected");
						if(val.valid == null) throw new Error("Encryption scheme unsupported");
						if(!val.valid) throw new Error("Password is incorrect");
						break;
					case 0x005c /* WriteAccess */: opts.lastuser = val; break;
					case 0x0042 /* CodePage */:
						var cpval = Number(val);
						/* overrides based on test cases */
						switch(cpval) {
							case 0x5212: cpval =  1200; break;
							case 0x8000: cpval = 10000; break;
							case 0x8001: cpval =  1252; break;
						}
						set_cp(opts.codepage = cpval);
						seen_codepage = true;
						break;
					case 0x013d /* RRTabId */: opts.rrtabid = val; break;
					case 0x0019 /* WinProtect */: opts.winlocked = val; break;
					case 0x01b7 /* RefreshAll */: wb.opts["RefreshAll"] = val; break;
					case 0x000c /* CalcCount */: wb.opts["CalcCount"] = val; break;
					case 0x0010 /* CalcDelta */: wb.opts["CalcDelta"] = val; break;
					case 0x0011 /* CalcIter */: wb.opts["CalcIter"] = val; break;
					case 0x000d /* CalcMode */: wb.opts["CalcMode"] = val; break;
					case 0x000e /* CalcPrecision */: wb.opts["CalcPrecision"] = val; break;
					case 0x005f /* CalcSaveRecalc */: wb.opts["CalcSaveRecalc"] = val; break;
					case 0x000f /* CalcRefMode */: opts.CalcRefMode = val; break; // TODO: implement R1C1
					case 0x08a3 /* ForceFullCalculation */: wb.opts.FullCalc = val; break;
					case 0x0081 /* WsBool */:
						if(val.fDialog) out["!type"] = "dialog";
						if(!val.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
						if(!val.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
						break; // TODO
					case 0x00e0 /* XF */:
						XFs.push(val); break;
					case 0x01ae /* SupBook */:
						supbooks.push([val]);
						supbooks[supbooks.length-1].XTI = [];
						break;
					case 0x0023: case 0x0223 /* ExternName */:
						supbooks[supbooks.length-1].push(val);
						break;
					case 0x0018: case 0x0218 /* Lbl */:
						last_lbl = ({
							Name: val.Name,
							Ref: stringify_formula(val.rgce,range,null,supbooks,opts)
						});
						if(val.itab > 0) last_lbl.Sheet = val.itab - 1;
						supbooks.names.push(last_lbl);
						if(!supbooks[0]) { supbooks[0] = []; supbooks[0].XTI = []; }
						supbooks[supbooks.length-1].push(val);
						if(val.Name == "_xlnm._FilterDatabase" && val.itab > 0)
							if(val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == 'PtgArea3d')
								FilterDatabases[val.itab - 1] = { ref: encode_range(val.rgce[0][0][1][2]) };
						break;
					case 0x0016 /* ExternCount */: opts.ExternCount = val; break;
					case 0x0017 /* ExternSheet */:
						if(supbooks.length == 0) { supbooks[0] = []; supbooks[0].XTI = []; }
						supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val); supbooks.XTI = supbooks.XTI.concat(val); break;
					case 0x0894 /* NameCmt */:
						/* TODO: search for correct name */
						if(opts.biff < 8) break;
						if(last_lbl != null) last_lbl.Comment = val[1];
						break;
					case 0x0012 /* Protect */: out["!protect"] = val; break; /* for sheet or book */
					case 0x0013 /* Password */: if(val !== 0 && opts.WTF) console.error("Password verifier: " + val); break;
					case 0x0085 /* BoundSheet8 */: {
						Directory[val.pos] = val;
						opts.snames.push(val.name);
					} break;
					case 0x000a /* EOF */: {
						if(--file_depth) break;
						if(range.e) {
							if(range.e.r > 0 && range.e.c > 0) {
								range.e.r--; range.e.c--;
								out["!ref"] = encode_range(range);
								if(options.sheetRows && options.sheetRows <= range.e.r) {
									var tmpri = range.e.r;
									range.e.r = options.sheetRows - 1;
									out["!fullref"] = out["!ref"];
									out["!ref"] = encode_range(range);
									range.e.r = tmpri;
								}
								range.e.r++; range.e.c++;
							}
							if(merges.length > 0) out["!merges"] = merges;
							if(objects.length > 0) out["!objects"] = objects;
							if(colinfo.length > 0) out["!cols"] = colinfo;
							if(rowinfo.length > 0) out["!rows"] = rowinfo;
							Workbook.Sheets.push(wsprops);
						}
						if(cur_sheet === "") Preamble = out; else Sheets[cur_sheet] = out;
						out = ((options.dense ? [] : {}));
					} break;
					case 0x0009: case 0x0209: case 0x0409: case 0x0809 /* BOF */: {
						if(opts.biff === 8) opts.biff = {
	0x0009:2,
	0x0209:3,
	0x0409:4
						}[RecordType] || {
	0x0200:2,
	0x0300:3,
	0x0400:4,
	0x0500:5,
	0x0600:8,
	0x0002:2,
	0x0007:2
						}[val.BIFFVer] || 8;
						opts.biffguess = val.BIFFVer == 0;
						if(val.BIFFVer == 0 && val.dt == 0x1000) { opts.biff = 5; seen_codepage = true; set_cp(opts.codepage = 28591); }
						if(opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
						if(file_depth++) break;
						out = ((options.dense ? [] : {}));
	
						if(opts.biff < 8 && !seen_codepage) { seen_codepage = true; set_cp(opts.codepage = options.codepage || 1252); }
	
						if(opts.biff < 5 || val.BIFFVer == 0 && val.dt == 0x1000) {
							if(cur_sheet === "") cur_sheet = "Sheet1";
							range = {s:{r:0,c:0},e:{r:0,c:0}};
							/* fake BoundSheet8 */
							var fakebs8 = {pos: blob.l - length, name:cur_sheet};
							Directory[fakebs8.pos] = fakebs8;
							opts.snames.push(cur_sheet);
						}
						else cur_sheet = (Directory[s] || {name:""}).name;
						if(val.dt == 0x20) out["!type"] = "chart";
						if(val.dt == 0x40) out["!type"] = "macro";
						merges = [];
						objects = [];
						opts.arrayf = arrayf = [];
						colinfo = []; rowinfo = [];
						seencol = false;
						wsprops = {Hidden:(Directory[s]||{hs:0}).hs, name:cur_sheet };
					} break;
					case 0x0203 /* Number */: case 0x0003 /* BIFF2NUM */: case 0x0002 /* BIFF2INT */: {
						if(out["!type"] == "chart") if(options.dense ? (out[val.r]||[])[val.c]: out[encode_cell({c:val.c, r:val.r})]) ++val.c;
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe]||{}, v:val.val, t:'n'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 0x0005: case 0x0205 /* BoolErr */: {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.val, t:val.t});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 0x027e /* RK */: {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.rknum, t:'n'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 0x00bd /* MulRk */: {
						for(var j = val.c; j <= val.C; ++j) {
							var ixfe = val.rkrec[j-val.c][0];
							temp_val= ({ixfe:ixfe, XF:XFs[ixfe], v:val.rkrec[j-val.c][1], t:'n'});
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell({c:j, r:val.r}, temp_val, options);
						}
					} break;
					case 0x0006: case 0x0206: case 0x0406 /* Formula */: {
						if(val.val == 'String') { last_formula = val; break; }
						temp_val = make_cell(val.val, val.cell.ixfe, val.tt);
						temp_val.XF = XFs[temp_val.ixfe];
						if(options.cellFormula) {
							var _f = val.formula;
							if(_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
								var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
								var _fe = encode_cell({r:_fr, c:_fc});
								if(sharedf[_fe]) temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
								else temp_val.F = ((options.dense ? (out[_fr]||[])[_fc]: out[_fe]) || {}).F;
							} else temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
						}
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell(val.cell, temp_val, options);
						last_formula = val;
					} break;
					case 0x0007: case 0x0207 /* String */: {
						if(last_formula) { /* technically always true */
							last_formula.val = val;
							temp_val = make_cell(val, last_formula.cell.ixfe, 's');
							temp_val.XF = XFs[temp_val.ixfe];
							if(options.cellFormula) {
								temp_val.f = ""+stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
							}
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell(last_formula.cell, temp_val, options);
							last_formula = null;
						} else throw new Error("String record expects Formula");
					} break;
					case 0x0021: case 0x0221 /* Array */: {
						arrayf.push(val);
						var _arraystart = encode_cell(val[0].s);
						cc = options.dense ? (out[val[0].s.r]||[])[val[0].s.c] : out[_arraystart];
						if(options.cellFormula && cc) {
							if(!last_formula) break; /* technically unreachable */
							if(!_arraystart || !cc) break;
							cc.f = ""+stringify_formula(val[1], range, val[0], supbooks, opts);
							cc.F = encode_range(val[0]);
						}
					} break;
					case 0x04bc /* ShrFmla */: {
						if(!options.cellFormula) break;
						if(last_cell) {
							/* TODO: capture range */
							if(!last_formula) break; /* technically unreachable */
							sharedf[encode_cell(last_formula.cell)]= val[0];
							cc = options.dense ? (out[last_formula.cell.r]||[])[last_formula.cell.c] : out[encode_cell(last_formula.cell)];
							(cc||{}).f = ""+stringify_formula(val[0], range, lastcell, supbooks, opts);
						}
					} break;
					case 0x00fd /* LabelSst */:
						temp_val=make_cell(sst[val.isst].t, val.ixfe, 's');
						if(sst[val.isst].h) temp_val.h = sst[val.isst].h;
						temp_val.XF = XFs[temp_val.ixfe];
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
						break;
					case 0x0201 /* Blank */: if(options.sheetStubs) {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], t:'z'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 0x00be /* MulBlank */: if(options.sheetStubs) {
						for(var _j = val.c; _j <= val.C; ++_j) {
							var _ixfe = val.ixfe[_j-val.c];
							temp_val= ({ixfe:_ixfe, XF:XFs[_ixfe], t:'z'});
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell({c:_j, r:val.r}, temp_val, options);
						}
					} break;
					case 0x00d6 /* RString */:
					case 0x0204 /* Label */: case 0x0004 /* BIFF2STR */:
						temp_val=make_cell(val.val, val.ixfe, 's');
						temp_val.XF = XFs[temp_val.ixfe];
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
						break;
	
					case 0x0000: case 0x0200 /* Dimensions */: {
						if(file_depth === 1) range = val; /* TODO: stack */
					} break;
					case 0x00fc /* SST */: {
						sst = val;
					} break;
					case 0x041e /* Format */: { /* val = [id, fmt] */
						if(opts.biff == 4) {
							BIFF2FmtTable[BIFF2Fmt++] = val[1];
							for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx) if(table_fmt[b4idx] == val[1]) break;
							if(b4idx >= 163) SSF_load(val[1], BIFF2Fmt + 163);
						}
						else SSF_load(val[1], val[0]);
					} break;
					case 0x001e /* BIFF2FORMAT */: {
						BIFF2FmtTable[BIFF2Fmt++] = val;
						for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx) if(table_fmt[b2idx] == val) break;
						if(b2idx >= 163) SSF_load(val, BIFF2Fmt + 163);
					} break;
	
					case 0x00e5 /* MergeCells */: merges = merges.concat(val); break;
	
					case 0x005d /* Obj */: objects[val.cmo[0]] = opts.lastobj = val; break;
					case 0x01b6 /* TxO */: opts.lastobj.TxO = val; break;
					case 0x007f /* ImData */: opts.lastobj.ImData = val; break;
	
					case 0x01b8 /* HLink */: {
						for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
							for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
								cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
								if(cc) cc.l = val[1];
							}
					} break;
					case 0x0800 /* HLinkTooltip */: {
						for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
							for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
								cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
								if(cc && cc.l) cc.l.Tooltip = val[1];
								}
					} break;
					case 0x001c /* Note */: {
						if(opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */
						cc = options.dense ? (out[val[0].r]||[])[val[0].c] : out[encode_cell(val[0])];
						var noteobj = objects[val[2]];
						if(!cc) {
							if(options.dense) {
								if(!out[val[0].r]) out[val[0].r] = [];
								cc = out[val[0].r][val[0].c] = ({t:"z"});
							} else {
								cc = out[encode_cell(val[0])] = ({t:"z"});
							}
							range.e.r = Math.max(range.e.r, val[0].r);
							range.s.r = Math.min(range.s.r, val[0].r);
							range.e.c = Math.max(range.e.c, val[0].c);
							range.s.c = Math.min(range.s.c, val[0].c);
						}
						if(!cc.c) cc.c = [];
						cmnt = {a:val[1],t:noteobj.TxO.t};
						cc.c.push(cmnt);
					} break;
					case 0x087d /* XFExt */: update_xfext(XFs[val.ixfe], val.ext); break;
					case 0x007d /* ColInfo */: {
						if(!opts.cellStyles) break;
						while(val.e >= val.s) {
							colinfo[val.e--] = { width: val.w/256, level: (val.level || 0), hidden: !!(val.flags & 1) };
							if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
							process_col(colinfo[val.e+1]);
						}
					} break;
					case 0x0208 /* Row */: {
						var rowobj = {};
						if(val.level != null) { rowinfo[val.r] = rowobj; rowobj.level = val.level; }
						if(val.hidden) { rowinfo[val.r] = rowobj; rowobj.hidden = true; }
						if(val.hpt) {
							rowinfo[val.r] = rowobj;
							rowobj.hpt = val.hpt; rowobj.hpx = pt2px(val.hpt);
						}
					} break;
					case 0x0026 /* LeftMargin */:
					case 0x0027 /* RightMargin */:
					case 0x0028 /* TopMargin */:
					case 0x0029 /* BottomMargin */:
						if(!out['!margins']) default_margins(out['!margins'] = {});
						out['!margins'][({0x26: "left", 0x27:"right", 0x28:"top", 0x29:"bottom"})[RecordType]] = val;
						break;
					case 0x00a1 /* Setup */: // TODO
						if(!out['!margins']) default_margins(out['!margins'] = {});
						out['!margins'].header = val.header;
						out['!margins'].footer = val.footer;
						break;
					case 0x023e /* Window2 */: // TODO
						// $FlowIgnore
						if(val.RTL) Workbook.Views[0].RTL = true;
						break;
					case 0x0092 /* Palette */: palette = val; break;
					case 0x0896 /* Theme */: themes = val; break;
					case 0x008c /* Country */: country = val; break;
					case 0x01ba /* CodeName */: {
	if(!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
						else wsprops.CodeName = val || wsprops.name;
					} break;
				}
			} else {
				if(!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
				blob.l += length;
			}
		}
		wb.SheetNames=keys(Directory).sort(function(a,b) { return Number(a) - Number(b); }).map(function(x){return Directory[x].name;});
		if(!options.bookSheets) wb.Sheets=Sheets;
		if(!wb.SheetNames.length && Preamble["!ref"]) {
			wb.SheetNames.push("Sheet1");
			/*jshint -W069 */
			if(wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
			/*jshint +W069 */
		} else wb.Preamble=Preamble;
		if(wb.Sheets) FilterDatabases.forEach(function(r,i) { wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r; });
		wb.Strings = sst;
		wb.SSF = dup(table_fmt);
		if(opts.enc) wb.Encryption = opts.enc;
		if(themes) wb.Themes = themes;
		wb.Metadata = {};
		if(country !== undefined) wb.Metadata.Country = country;
		if(supbooks.names.length > 0) Workbook.Names = supbooks.names;
		wb.Workbook = Workbook;
		return wb;
	}
	
	/* TODO: split props*/
	var PSCLSID = {
		SI: "e0859ff2f94f6810ab9108002b27b3d9",
		DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
		UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
	};
	function parse_xls_props(cfb, props, o) {
		/* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */
		var DSI = CFB.find(cfb, '/!DocumentSummaryInformation');
		if(DSI && DSI.size > 0) try {
			var DocSummary = parse_PropertySetStream(DSI, DocSummaryPIDDSI, PSCLSID.DSI);
			for(var d in DocSummary) props[d] = DocSummary[d];
		} catch(e) {if(o.WTF) throw e;/* empty */}
	
		/* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/
		var SI = CFB.find(cfb, '/!SummaryInformation');
		if(SI && SI.size > 0) try {
			var Summary = parse_PropertySetStream(SI, SummaryPIDSI, PSCLSID.SI);
			for(var s in Summary) if(props[s] == null) props[s] = Summary[s];
		} catch(e) {if(o.WTF) throw e;/* empty */}
	
		if(props.HeadingPairs && props.TitlesOfParts) {
			load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
			delete props.HeadingPairs; delete props.TitlesOfParts;
		}
	}
	function write_xls_props(wb, cfb) {
		var DSEntries = [], SEntries = [], CEntries = [];
		var i = 0, Keys;
		var DocSummaryRE = evert_key(DocSummaryPIDDSI, "n");
		var SummaryRE = evert_key(SummaryPIDSI, "n");
		if(wb.Props) {
			Keys = keys(wb.Props);
			// $FlowIgnore
			for(i = 0; i < Keys.length; ++i) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Props[Keys[i]]]);
		}
		if(wb.Custprops) {
			Keys = keys(wb.Custprops);
			// $FlowIgnore
			for(i = 0; i < Keys.length; ++i) if(!Object.prototype.hasOwnProperty.call((wb.Props||{}), Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Custprops[Keys[i]]]);
		}
		var CEntries2 = [];
		for(i = 0; i < CEntries.length; ++i) {
			if(XLSPSSkip.indexOf(CEntries[i][0]) > -1 || PseudoPropsPairs.indexOf(CEntries[i][0]) > -1) continue;
			if(CEntries[i][1] == null) continue;
			CEntries2.push(CEntries[i]);
		}
		if(SEntries.length) CFB.utils.cfb_add(cfb, "/\u0005SummaryInformation", write_PropertySetStream(SEntries, PSCLSID.SI, SummaryRE, SummaryPIDSI));
		if(DSEntries.length || CEntries2.length) CFB.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", write_PropertySetStream(DSEntries, PSCLSID.DSI, DocSummaryRE, DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, PSCLSID.UDI));
	}
	
	function parse_xlscfb(cfb, options) {
	if(!options) options = {};
	fix_read_opts(options);
	reset_cp();
	if(options.codepage) set_ansi(options.codepage);
	var CompObj, WB;
	if(cfb.FullPaths) {
		if(CFB.find(cfb, '/encryption')) throw new Error("File is password-protected");
		CompObj = CFB.find(cfb, '!CompObj');
		WB = CFB.find(cfb, '/Workbook') || CFB.find(cfb, '/Book');
	} else {
		switch(options.type) {
			case 'base64': cfb = s2a(Base64_decode(cfb)); break;
			case 'binary': cfb = s2a(cfb); break;
			case 'buffer': break;
			case 'array': if(!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb); break;
		}
		prep_blob(cfb, 0);
		WB = ({content: cfb});
	}
	var WorkbookP;
	
	var _data;
	if(CompObj) parse_compobj(CompObj);
	if(options.bookProps && !options.bookSheets) WorkbookP = ({});
	else {
		var T = has_buf ? 'buffer' : 'array';
		if(WB && WB.content) WorkbookP = parse_workbook(WB.content, options);
		/* Quattro Pro 7-8 */
		else if((_data=CFB.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
		/* Quattro Pro 9 */
		else if((_data=CFB.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
		/* Works 4 for Mac */
		else if((_data=CFB.find(cfb, 'MN0')) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
		else throw new Error("Cannot find Workbook stream");
		if(options.bookVBA && cfb.FullPaths && CFB.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = make_vba_xls(cfb);
	}
	
	var props = {};
	if(cfb.FullPaths) parse_xls_props(cfb, props, options);
	
	WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */
	if(options.bookFiles) WorkbookP.cfb = cfb;
	/*WorkbookP.CompObjP = CompObjP; // TODO: storage? */
	return WorkbookP;
	}
	
	
	function write_xlscfb(wb, opts) {
		var o = opts || {};
		var cfb = CFB.utils.cfb_new({root:"R"});
		var wbpath = "/Workbook";
		switch(o.bookType || "xls") {
			case "xls": o.bookType = "biff8";
			/* falls through */
			case "xla": if(!o.bookType) o.bookType = "xla";
			/* falls through */
			case "biff8": wbpath = "/Workbook"; o.biff = 8; break;
			case "biff5": wbpath = "/Book"; o.biff = 5; break;
			default: throw new Error("invalid type " + o.bookType + " for XLS CFB");
		}
		CFB.utils.cfb_add(cfb, wbpath, write_biff_buf(wb, o));
		if(o.biff == 8 && (wb.Props || wb.Custprops)) write_xls_props(wb, cfb);
		// TODO: SI, DSI, CO
		if(o.biff == 8 && wb.vbaraw) fill_vba_xls(cfb, CFB.read(wb.vbaraw, {type: typeof wb.vbaraw == "string" ? "binary" : "buffer"}));
		return cfb;
	}
	/* [MS-XLSB] 2.3 Record Enumeration */
	var XLSBRecordEnum = {
	0x0000: { /* n:"BrtRowHdr", */ f:parse_BrtRowHdr },
	0x0001: { /* n:"BrtCellBlank", */ f:parse_BrtCellBlank },
	0x0002: { /* n:"BrtCellRk", */ f:parse_BrtCellRk },
	0x0003: { /* n:"BrtCellError", */ f:parse_BrtCellError },
	0x0004: { /* n:"BrtCellBool", */ f:parse_BrtCellBool },
	0x0005: { /* n:"BrtCellReal", */ f:parse_BrtCellReal },
	0x0006: { /* n:"BrtCellSt", */ f:parse_BrtCellSt },
	0x0007: { /* n:"BrtCellIsst", */ f:parse_BrtCellIsst },
	0x0008: { /* n:"BrtFmlaString", */ f:parse_BrtFmlaString },
	0x0009: { /* n:"BrtFmlaNum", */ f:parse_BrtFmlaNum },
	0x000A: { /* n:"BrtFmlaBool", */ f:parse_BrtFmlaBool },
	0x000B: { /* n:"BrtFmlaError", */ f:parse_BrtFmlaError },
	0x000C: { /* n:"BrtShortBlank", */ f:parse_BrtShortBlank },
	0x000D: { /* n:"BrtShortRk", */ f:parse_BrtShortRk },
	0x000E: { /* n:"BrtShortError", */ f:parse_BrtShortError },
	0x000F: { /* n:"BrtShortBool", */ f:parse_BrtShortBool },
	0x0010: { /* n:"BrtShortReal", */ f:parse_BrtShortReal },
	0x0011: { /* n:"BrtShortSt", */ f:parse_BrtShortSt },
	0x0012: { /* n:"BrtShortIsst", */ f:parse_BrtShortIsst },
	0x0013: { /* n:"BrtSSTItem", */ f:parse_RichStr },
	0x0014: { /* n:"BrtPCDIMissing" */ },
	0x0015: { /* n:"BrtPCDINumber" */ },
	0x0016: { /* n:"BrtPCDIBoolean" */ },
	0x0017: { /* n:"BrtPCDIError" */ },
	0x0018: { /* n:"BrtPCDIString" */ },
	0x0019: { /* n:"BrtPCDIDatetime" */ },
	0x001A: { /* n:"BrtPCDIIndex" */ },
	0x001B: { /* n:"BrtPCDIAMissing" */ },
	0x001C: { /* n:"BrtPCDIANumber" */ },
	0x001D: { /* n:"BrtPCDIABoolean" */ },
	0x001E: { /* n:"BrtPCDIAError" */ },
	0x001F: { /* n:"BrtPCDIAString" */ },
	0x0020: { /* n:"BrtPCDIADatetime" */ },
	0x0021: { /* n:"BrtPCRRecord" */ },
	0x0022: { /* n:"BrtPCRRecordDt" */ },
	0x0023: { /* n:"BrtFRTBegin", */ T:1 },
	0x0024: { /* n:"BrtFRTEnd", */ T:-1 },
	0x0025: { /* n:"BrtACBegin", */ T:1 },
	0x0026: { /* n:"BrtACEnd", */ T:-1 },
	0x0027: { /* n:"BrtName", */ f:parse_BrtName },
	0x0028: { /* n:"BrtIndexRowBlock" */ },
	0x002A: { /* n:"BrtIndexBlock" */ },
	0x002B: { /* n:"BrtFont", */ f:parse_BrtFont },
	0x002C: { /* n:"BrtFmt", */ f:parse_BrtFmt },
	0x002D: { /* n:"BrtFill", */ f:parse_BrtFill },
	0x002E: { /* n:"BrtBorder", */ f:parse_BrtBorder },
	0x002F: { /* n:"BrtXF", */ f:parse_BrtXF },
	0x0030: { /* n:"BrtStyle" */ },
	0x0031: { /* n:"BrtCellMeta", */ f:parse_Int32LE },
	0x0032: { /* n:"BrtValueMeta" */ },
	0x0033: { /* n:"BrtMdb" */ f:parse_BrtMdb },
	0x0034: { /* n:"BrtBeginFmd", */ T:1 },
	0x0035: { /* n:"BrtEndFmd", */ T:-1 },
	0x0036: { /* n:"BrtBeginMdx", */ T:1 },
	0x0037: { /* n:"BrtEndMdx", */ T:-1 },
	0x0038: { /* n:"BrtBeginMdxTuple", */ T:1 },
	0x0039: { /* n:"BrtEndMdxTuple", */ T:-1 },
	0x003A: { /* n:"BrtMdxMbrIstr" */ },
	0x003B: { /* n:"BrtStr" */ },
	0x003C: { /* n:"BrtColInfo", */ f:parse_ColInfo },
	0x003E: { /* n:"BrtCellRString", */ f:parse_BrtCellRString },
	0x003F: { /* n:"BrtCalcChainItem$", */ f:parse_BrtCalcChainItem$ },
	0x0040: { /* n:"BrtDVal", */ f:parse_BrtDVal },
	0x0041: { /* n:"BrtSxvcellNum" */ },
	0x0042: { /* n:"BrtSxvcellStr" */ },
	0x0043: { /* n:"BrtSxvcellBool" */ },
	0x0044: { /* n:"BrtSxvcellErr" */ },
	0x0045: { /* n:"BrtSxvcellDate" */ },
	0x0046: { /* n:"BrtSxvcellNil" */ },
	0x0080: { /* n:"BrtFileVersion" */ },
	0x0081: { /* n:"BrtBeginSheet", */ T:1 },
	0x0082: { /* n:"BrtEndSheet", */ T:-1 },
	0x0083: { /* n:"BrtBeginBook", */ T:1, f:parsenoop, p:0 },
	0x0084: { /* n:"BrtEndBook", */ T:-1 },
	0x0085: { /* n:"BrtBeginWsViews", */ T:1 },
	0x0086: { /* n:"BrtEndWsViews", */ T:-1 },
	0x0087: { /* n:"BrtBeginBookViews", */ T:1 },
	0x0088: { /* n:"BrtEndBookViews", */ T:-1 },
	0x0089: { /* n:"BrtBeginWsView", */ T:1, f:parse_BrtBeginWsView },
	0x008A: { /* n:"BrtEndWsView", */ T:-1 },
	0x008B: { /* n:"BrtBeginCsViews", */ T:1 },
	0x008C: { /* n:"BrtEndCsViews", */ T:-1 },
	0x008D: { /* n:"BrtBeginCsView", */ T:1 },
	0x008E: { /* n:"BrtEndCsView", */ T:-1 },
	0x008F: { /* n:"BrtBeginBundleShs", */ T:1 },
	0x0090: { /* n:"BrtEndBundleShs", */ T:-1 },
	0x0091: { /* n:"BrtBeginSheetData", */ T:1 },
	0x0092: { /* n:"BrtEndSheetData", */ T:-1 },
	0x0093: { /* n:"BrtWsProp", */ f:parse_BrtWsProp },
	0x0094: { /* n:"BrtWsDim", */ f:parse_BrtWsDim, p:16 },
	0x0097: { /* n:"BrtPane", */ f:parse_BrtPane },
	0x0098: { /* n:"BrtSel" */ },
	0x0099: { /* n:"BrtWbProp", */ f:parse_BrtWbProp },
	0x009A: { /* n:"BrtWbFactoid" */ },
	0x009B: { /* n:"BrtFileRecover" */ },
	0x009C: { /* n:"BrtBundleSh", */ f:parse_BrtBundleSh },
	0x009D: { /* n:"BrtCalcProp" */ },
	0x009E: { /* n:"BrtBookView" */ },
	0x009F: { /* n:"BrtBeginSst", */ T:1, f:parse_BrtBeginSst },
	0x00A0: { /* n:"BrtEndSst", */ T:-1 },
	0x00A1: { /* n:"BrtBeginAFilter", */ T:1, f:parse_UncheckedRfX },
	0x00A2: { /* n:"BrtEndAFilter", */ T:-1 },
	0x00A3: { /* n:"BrtBeginFilterColumn", */ T:1 },
	0x00A4: { /* n:"BrtEndFilterColumn", */ T:-1 },
	0x00A5: { /* n:"BrtBeginFilters", */ T:1 },
	0x00A6: { /* n:"BrtEndFilters", */ T:-1 },
	0x00A7: { /* n:"BrtFilter" */ },
	0x00A8: { /* n:"BrtColorFilter" */ },
	0x00A9: { /* n:"BrtIconFilter" */ },
	0x00AA: { /* n:"BrtTop10Filter" */ },
	0x00AB: { /* n:"BrtDynamicFilter" */ },
	0x00AC: { /* n:"BrtBeginCustomFilters", */ T:1 },
	0x00AD: { /* n:"BrtEndCustomFilters", */ T:-1 },
	0x00AE: { /* n:"BrtCustomFilter" */ },
	0x00AF: { /* n:"BrtAFilterDateGroupItem" */ },
	0x00B0: { /* n:"BrtMergeCell", */ f:parse_BrtMergeCell },
	0x00B1: { /* n:"BrtBeginMergeCells", */ T:1 },
	0x00B2: { /* n:"BrtEndMergeCells", */ T:-1 },
	0x00B3: { /* n:"BrtBeginPivotCacheDef", */ T:1 },
	0x00B4: { /* n:"BrtEndPivotCacheDef", */ T:-1 },
	0x00B5: { /* n:"BrtBeginPCDFields", */ T:1 },
	0x00B6: { /* n:"BrtEndPCDFields", */ T:-1 },
	0x00B7: { /* n:"BrtBeginPCDField", */ T:1 },
	0x00B8: { /* n:"BrtEndPCDField", */ T:-1 },
	0x00B9: { /* n:"BrtBeginPCDSource", */ T:1 },
	0x00BA: { /* n:"BrtEndPCDSource", */ T:-1 },
	0x00BB: { /* n:"BrtBeginPCDSRange", */ T:1 },
	0x00BC: { /* n:"BrtEndPCDSRange", */ T:-1 },
	0x00BD: { /* n:"BrtBeginPCDFAtbl", */ T:1 },
	0x00BE: { /* n:"BrtEndPCDFAtbl", */ T:-1 },
	0x00BF: { /* n:"BrtBeginPCDIRun", */ T:1 },
	0x00C0: { /* n:"BrtEndPCDIRun", */ T:-1 },
	0x00C1: { /* n:"BrtBeginPivotCacheRecords", */ T:1 },
	0x00C2: { /* n:"BrtEndPivotCacheRecords", */ T:-1 },
	0x00C3: { /* n:"BrtBeginPCDHierarchies", */ T:1 },
	0x00C4: { /* n:"BrtEndPCDHierarchies", */ T:-1 },
	0x00C5: { /* n:"BrtBeginPCDHierarchy", */ T:1 },
	0x00C6: { /* n:"BrtEndPCDHierarchy", */ T:-1 },
	0x00C7: { /* n:"BrtBeginPCDHFieldsUsage", */ T:1 },
	0x00C8: { /* n:"BrtEndPCDHFieldsUsage", */ T:-1 },
	0x00C9: { /* n:"BrtBeginExtConnection", */ T:1 },
	0x00CA: { /* n:"BrtEndExtConnection", */ T:-1 },
	0x00CB: { /* n:"BrtBeginECDbProps", */ T:1 },
	0x00CC: { /* n:"BrtEndECDbProps", */ T:-1 },
	0x00CD: { /* n:"BrtBeginECOlapProps", */ T:1 },
	0x00CE: { /* n:"BrtEndECOlapProps", */ T:-1 },
	0x00CF: { /* n:"BrtBeginPCDSConsol", */ T:1 },
	0x00D0: { /* n:"BrtEndPCDSConsol", */ T:-1 },
	0x00D1: { /* n:"BrtBeginPCDSCPages", */ T:1 },
	0x00D2: { /* n:"BrtEndPCDSCPages", */ T:-1 },
	0x00D3: { /* n:"BrtBeginPCDSCPage", */ T:1 },
	0x00D4: { /* n:"BrtEndPCDSCPage", */ T:-1 },
	0x00D5: { /* n:"BrtBeginPCDSCPItem", */ T:1 },
	0x00D6: { /* n:"BrtEndPCDSCPItem", */ T:-1 },
	0x00D7: { /* n:"BrtBeginPCDSCSets", */ T:1 },
	0x00D8: { /* n:"BrtEndPCDSCSets", */ T:-1 },
	0x00D9: { /* n:"BrtBeginPCDSCSet", */ T:1 },
	0x00DA: { /* n:"BrtEndPCDSCSet", */ T:-1 },
	0x00DB: { /* n:"BrtBeginPCDFGroup", */ T:1 },
	0x00DC: { /* n:"BrtEndPCDFGroup", */ T:-1 },
	0x00DD: { /* n:"BrtBeginPCDFGItems", */ T:1 },
	0x00DE: { /* n:"BrtEndPCDFGItems", */ T:-1 },
	0x00DF: { /* n:"BrtBeginPCDFGRange", */ T:1 },
	0x00E0: { /* n:"BrtEndPCDFGRange", */ T:-1 },
	0x00E1: { /* n:"BrtBeginPCDFGDiscrete", */ T:1 },
	0x00E2: { /* n:"BrtEndPCDFGDiscrete", */ T:-1 },
	0x00E3: { /* n:"BrtBeginPCDSDTupleCache", */ T:1 },
	0x00E4: { /* n:"BrtEndPCDSDTupleCache", */ T:-1 },
	0x00E5: { /* n:"BrtBeginPCDSDTCEntries", */ T:1 },
	0x00E6: { /* n:"BrtEndPCDSDTCEntries", */ T:-1 },
	0x00E7: { /* n:"BrtBeginPCDSDTCEMembers", */ T:1 },
	0x00E8: { /* n:"BrtEndPCDSDTCEMembers", */ T:-1 },
	0x00E9: { /* n:"BrtBeginPCDSDTCEMember", */ T:1 },
	0x00EA: { /* n:"BrtEndPCDSDTCEMember", */ T:-1 },
	0x00EB: { /* n:"BrtBeginPCDSDTCQueries", */ T:1 },
	0x00EC: { /* n:"BrtEndPCDSDTCQueries", */ T:-1 },
	0x00ED: { /* n:"BrtBeginPCDSDTCQuery", */ T:1 },
	0x00EE: { /* n:"BrtEndPCDSDTCQuery", */ T:-1 },
	0x00EF: { /* n:"BrtBeginPCDSDTCSets", */ T:1 },
	0x00F0: { /* n:"BrtEndPCDSDTCSets", */ T:-1 },
	0x00F1: { /* n:"BrtBeginPCDSDTCSet", */ T:1 },
	0x00F2: { /* n:"BrtEndPCDSDTCSet", */ T:-1 },
	0x00F3: { /* n:"BrtBeginPCDCalcItems", */ T:1 },
	0x00F4: { /* n:"BrtEndPCDCalcItems", */ T:-1 },
	0x00F5: { /* n:"BrtBeginPCDCalcItem", */ T:1 },
	0x00F6: { /* n:"BrtEndPCDCalcItem", */ T:-1 },
	0x00F7: { /* n:"BrtBeginPRule", */ T:1 },
	0x00F8: { /* n:"BrtEndPRule", */ T:-1 },
	0x00F9: { /* n:"BrtBeginPRFilters", */ T:1 },
	0x00FA: { /* n:"BrtEndPRFilters", */ T:-1 },
	0x00FB: { /* n:"BrtBeginPRFilter", */ T:1 },
	0x00FC: { /* n:"BrtEndPRFilter", */ T:-1 },
	0x00FD: { /* n:"BrtBeginPNames", */ T:1 },
	0x00FE: { /* n:"BrtEndPNames", */ T:-1 },
	0x00FF: { /* n:"BrtBeginPName", */ T:1 },
	0x0100: { /* n:"BrtEndPName", */ T:-1 },
	0x0101: { /* n:"BrtBeginPNPairs", */ T:1 },
	0x0102: { /* n:"BrtEndPNPairs", */ T:-1 },
	0x0103: { /* n:"BrtBeginPNPair", */ T:1 },
	0x0104: { /* n:"BrtEndPNPair", */ T:-1 },
	0x0105: { /* n:"BrtBeginECWebProps", */ T:1 },
	0x0106: { /* n:"BrtEndECWebProps", */ T:-1 },
	0x0107: { /* n:"BrtBeginEcWpTables", */ T:1 },
	0x0108: { /* n:"BrtEndECWPTables", */ T:-1 },
	0x0109: { /* n:"BrtBeginECParams", */ T:1 },
	0x010A: { /* n:"BrtEndECParams", */ T:-1 },
	0x010B: { /* n:"BrtBeginECParam", */ T:1 },
	0x010C: { /* n:"BrtEndECParam", */ T:-1 },
	0x010D: { /* n:"BrtBeginPCDKPIs", */ T:1 },
	0x010E: { /* n:"BrtEndPCDKPIs", */ T:-1 },
	0x010F: { /* n:"BrtBeginPCDKPI", */ T:1 },
	0x0110: { /* n:"BrtEndPCDKPI", */ T:-1 },
	0x0111: { /* n:"BrtBeginDims", */ T:1 },
	0x0112: { /* n:"BrtEndDims", */ T:-1 },
	0x0113: { /* n:"BrtBeginDim", */ T:1 },
	0x0114: { /* n:"BrtEndDim", */ T:-1 },
	0x0115: { /* n:"BrtIndexPartEnd" */ },
	0x0116: { /* n:"BrtBeginStyleSheet", */ T:1 },
	0x0117: { /* n:"BrtEndStyleSheet", */ T:-1 },
	0x0118: { /* n:"BrtBeginSXView", */ T:1 },
	0x0119: { /* n:"BrtEndSXVI", */ T:-1 },
	0x011A: { /* n:"BrtBeginSXVI", */ T:1 },
	0x011B: { /* n:"BrtBeginSXVIs", */ T:1 },
	0x011C: { /* n:"BrtEndSXVIs", */ T:-1 },
	0x011D: { /* n:"BrtBeginSXVD", */ T:1 },
	0x011E: { /* n:"BrtEndSXVD", */ T:-1 },
	0x011F: { /* n:"BrtBeginSXVDs", */ T:1 },
	0x0120: { /* n:"BrtEndSXVDs", */ T:-1 },
	0x0121: { /* n:"BrtBeginSXPI", */ T:1 },
	0x0122: { /* n:"BrtEndSXPI", */ T:-1 },
	0x0123: { /* n:"BrtBeginSXPIs", */ T:1 },
	0x0124: { /* n:"BrtEndSXPIs", */ T:-1 },
	0x0125: { /* n:"BrtBeginSXDI", */ T:1 },
	0x0126: { /* n:"BrtEndSXDI", */ T:-1 },
	0x0127: { /* n:"BrtBeginSXDIs", */ T:1 },
	0x0128: { /* n:"BrtEndSXDIs", */ T:-1 },
	0x0129: { /* n:"BrtBeginSXLI", */ T:1 },
	0x012A: { /* n:"BrtEndSXLI", */ T:-1 },
	0x012B: { /* n:"BrtBeginSXLIRws", */ T:1 },
	0x012C: { /* n:"BrtEndSXLIRws", */ T:-1 },
	0x012D: { /* n:"BrtBeginSXLICols", */ T:1 },
	0x012E: { /* n:"BrtEndSXLICols", */ T:-1 },
	0x012F: { /* n:"BrtBeginSXFormat", */ T:1 },
	0x0130: { /* n:"BrtEndSXFormat", */ T:-1 },
	0x0131: { /* n:"BrtBeginSXFormats", */ T:1 },
	0x0132: { /* n:"BrtEndSxFormats", */ T:-1 },
	0x0133: { /* n:"BrtBeginSxSelect", */ T:1 },
	0x0134: { /* n:"BrtEndSxSelect", */ T:-1 },
	0x0135: { /* n:"BrtBeginISXVDRws", */ T:1 },
	0x0136: { /* n:"BrtEndISXVDRws", */ T:-1 },
	0x0137: { /* n:"BrtBeginISXVDCols", */ T:1 },
	0x0138: { /* n:"BrtEndISXVDCols", */ T:-1 },
	0x0139: { /* n:"BrtEndSXLocation", */ T:-1 },
	0x013A: { /* n:"BrtBeginSXLocation", */ T:1 },
	0x013B: { /* n:"BrtEndSXView", */ T:-1 },
	0x013C: { /* n:"BrtBeginSXTHs", */ T:1 },
	0x013D: { /* n:"BrtEndSXTHs", */ T:-1 },
	0x013E: { /* n:"BrtBeginSXTH", */ T:1 },
	0x013F: { /* n:"BrtEndSXTH", */ T:-1 },
	0x0140: { /* n:"BrtBeginISXTHRws", */ T:1 },
	0x0141: { /* n:"BrtEndISXTHRws", */ T:-1 },
	0x0142: { /* n:"BrtBeginISXTHCols", */ T:1 },
	0x0143: { /* n:"BrtEndISXTHCols", */ T:-1 },
	0x0144: { /* n:"BrtBeginSXTDMPS", */ T:1 },
	0x0145: { /* n:"BrtEndSXTDMPs", */ T:-1 },
	0x0146: { /* n:"BrtBeginSXTDMP", */ T:1 },
	0x0147: { /* n:"BrtEndSXTDMP", */ T:-1 },
	0x0148: { /* n:"BrtBeginSXTHItems", */ T:1 },
	0x0149: { /* n:"BrtEndSXTHItems", */ T:-1 },
	0x014A: { /* n:"BrtBeginSXTHItem", */ T:1 },
	0x014B: { /* n:"BrtEndSXTHItem", */ T:-1 },
	0x014C: { /* n:"BrtBeginMetadata", */ T:1 },
	0x014D: { /* n:"BrtEndMetadata", */ T:-1 },
	0x014E: { /* n:"BrtBeginEsmdtinfo", */ T:1 },
	0x014F: { /* n:"BrtMdtinfo", */ f:parse_BrtMdtinfo },
	0x0150: { /* n:"BrtEndEsmdtinfo", */ T:-1 },
	0x0151: { /* n:"BrtBeginEsmdb", */ f:parse_BrtBeginEsmdb, T:1 },
	0x0152: { /* n:"BrtEndEsmdb", */ T:-1 },
	0x0153: { /* n:"BrtBeginEsfmd", */ T:1 },
	0x0154: { /* n:"BrtEndEsfmd", */ T:-1 },
	0x0155: { /* n:"BrtBeginSingleCells", */ T:1 },
	0x0156: { /* n:"BrtEndSingleCells", */ T:-1 },
	0x0157: { /* n:"BrtBeginList", */ T:1 },
	0x0158: { /* n:"BrtEndList", */ T:-1 },
	0x0159: { /* n:"BrtBeginListCols", */ T:1 },
	0x015A: { /* n:"BrtEndListCols", */ T:-1 },
	0x015B: { /* n:"BrtBeginListCol", */ T:1 },
	0x015C: { /* n:"BrtEndListCol", */ T:-1 },
	0x015D: { /* n:"BrtBeginListXmlCPr", */ T:1 },
	0x015E: { /* n:"BrtEndListXmlCPr", */ T:-1 },
	0x015F: { /* n:"BrtListCCFmla" */ },
	0x0160: { /* n:"BrtListTrFmla" */ },
	0x0161: { /* n:"BrtBeginExternals", */ T:1 },
	0x0162: { /* n:"BrtEndExternals", */ T:-1 },
	0x0163: { /* n:"BrtSupBookSrc", */ f:parse_RelID},
	0x0165: { /* n:"BrtSupSelf" */ },
	0x0166: { /* n:"BrtSupSame" */ },
	0x0167: { /* n:"BrtSupTabs" */ },
	0x0168: { /* n:"BrtBeginSupBook", */ T:1 },
	0x0169: { /* n:"BrtPlaceholderName" */ },
	0x016A: { /* n:"BrtExternSheet", */ f:parse_ExternSheet },
	0x016B: { /* n:"BrtExternTableStart" */ },
	0x016C: { /* n:"BrtExternTableEnd" */ },
	0x016E: { /* n:"BrtExternRowHdr" */ },
	0x016F: { /* n:"BrtExternCellBlank" */ },
	0x0170: { /* n:"BrtExternCellReal" */ },
	0x0171: { /* n:"BrtExternCellBool" */ },
	0x0172: { /* n:"BrtExternCellError" */ },
	0x0173: { /* n:"BrtExternCellString" */ },
	0x0174: { /* n:"BrtBeginEsmdx", */ T:1 },
	0x0175: { /* n:"BrtEndEsmdx", */ T:-1 },
	0x0176: { /* n:"BrtBeginMdxSet", */ T:1 },
	0x0177: { /* n:"BrtEndMdxSet", */ T:-1 },
	0x0178: { /* n:"BrtBeginMdxMbrProp", */ T:1 },
	0x0179: { /* n:"BrtEndMdxMbrProp", */ T:-1 },
	0x017A: { /* n:"BrtBeginMdxKPI", */ T:1 },
	0x017B: { /* n:"BrtEndMdxKPI", */ T:-1 },
	0x017C: { /* n:"BrtBeginEsstr", */ T:1 },
	0x017D: { /* n:"BrtEndEsstr", */ T:-1 },
	0x017E: { /* n:"BrtBeginPRFItem", */ T:1 },
	0x017F: { /* n:"BrtEndPRFItem", */ T:-1 },
	0x0180: { /* n:"BrtBeginPivotCacheIDs", */ T:1 },
	0x0181: { /* n:"BrtEndPivotCacheIDs", */ T:-1 },
	0x0182: { /* n:"BrtBeginPivotCacheID", */ T:1 },
	0x0183: { /* n:"BrtEndPivotCacheID", */ T:-1 },
	0x0184: { /* n:"BrtBeginISXVIs", */ T:1 },
	0x0185: { /* n:"BrtEndISXVIs", */ T:-1 },
	0x0186: { /* n:"BrtBeginColInfos", */ T:1 },
	0x0187: { /* n:"BrtEndColInfos", */ T:-1 },
	0x0188: { /* n:"BrtBeginRwBrk", */ T:1 },
	0x0189: { /* n:"BrtEndRwBrk", */ T:-1 },
	0x018A: { /* n:"BrtBeginColBrk", */ T:1 },
	0x018B: { /* n:"BrtEndColBrk", */ T:-1 },
	0x018C: { /* n:"BrtBrk" */ },
	0x018D: { /* n:"BrtUserBookView" */ },
	0x018E: { /* n:"BrtInfo" */ },
	0x018F: { /* n:"BrtCUsr" */ },
	0x0190: { /* n:"BrtUsr" */ },
	0x0191: { /* n:"BrtBeginUsers", */ T:1 },
	0x0193: { /* n:"BrtEOF" */ },
	0x0194: { /* n:"BrtUCR" */ },
	0x0195: { /* n:"BrtRRInsDel" */ },
	0x0196: { /* n:"BrtRREndInsDel" */ },
	0x0197: { /* n:"BrtRRMove" */ },
	0x0198: { /* n:"BrtRREndMove" */ },
	0x0199: { /* n:"BrtRRChgCell" */ },
	0x019A: { /* n:"BrtRREndChgCell" */ },
	0x019B: { /* n:"BrtRRHeader" */ },
	0x019C: { /* n:"BrtRRUserView" */ },
	0x019D: { /* n:"BrtRRRenSheet" */ },
	0x019E: { /* n:"BrtRRInsertSh" */ },
	0x019F: { /* n:"BrtRRDefName" */ },
	0x01A0: { /* n:"BrtRRNote" */ },
	0x01A1: { /* n:"BrtRRConflict" */ },
	0x01A2: { /* n:"BrtRRTQSIF" */ },
	0x01A3: { /* n:"BrtRRFormat" */ },
	0x01A4: { /* n:"BrtRREndFormat" */ },
	0x01A5: { /* n:"BrtRRAutoFmt" */ },
	0x01A6: { /* n:"BrtBeginUserShViews", */ T:1 },
	0x01A7: { /* n:"BrtBeginUserShView", */ T:1 },
	0x01A8: { /* n:"BrtEndUserShView", */ T:-1 },
	0x01A9: { /* n:"BrtEndUserShViews", */ T:-1 },
	0x01AA: { /* n:"BrtArrFmla", */ f:parse_BrtArrFmla },
	0x01AB: { /* n:"BrtShrFmla", */ f:parse_BrtShrFmla },
	0x01AC: { /* n:"BrtTable" */ },
	0x01AD: { /* n:"BrtBeginExtConnections", */ T:1 },
	0x01AE: { /* n:"BrtEndExtConnections", */ T:-1 },
	0x01AF: { /* n:"BrtBeginPCDCalcMems", */ T:1 },
	0x01B0: { /* n:"BrtEndPCDCalcMems", */ T:-1 },
	0x01B1: { /* n:"BrtBeginPCDCalcMem", */ T:1 },
	0x01B2: { /* n:"BrtEndPCDCalcMem", */ T:-1 },
	0x01B3: { /* n:"BrtBeginPCDHGLevels", */ T:1 },
	0x01B4: { /* n:"BrtEndPCDHGLevels", */ T:-1 },
	0x01B5: { /* n:"BrtBeginPCDHGLevel", */ T:1 },
	0x01B6: { /* n:"BrtEndPCDHGLevel", */ T:-1 },
	0x01B7: { /* n:"BrtBeginPCDHGLGroups", */ T:1 },
	0x01B8: { /* n:"BrtEndPCDHGLGroups", */ T:-1 },
	0x01B9: { /* n:"BrtBeginPCDHGLGroup", */ T:1 },
	0x01BA: { /* n:"BrtEndPCDHGLGroup", */ T:-1 },
	0x01BB: { /* n:"BrtBeginPCDHGLGMembers", */ T:1 },
	0x01BC: { /* n:"BrtEndPCDHGLGMembers", */ T:-1 },
	0x01BD: { /* n:"BrtBeginPCDHGLGMember", */ T:1 },
	0x01BE: { /* n:"BrtEndPCDHGLGMember", */ T:-1 },
	0x01BF: { /* n:"BrtBeginQSI", */ T:1 },
	0x01C0: { /* n:"BrtEndQSI", */ T:-1 },
	0x01C1: { /* n:"BrtBeginQSIR", */ T:1 },
	0x01C2: { /* n:"BrtEndQSIR", */ T:-1 },
	0x01C3: { /* n:"BrtBeginDeletedNames", */ T:1 },
	0x01C4: { /* n:"BrtEndDeletedNames", */ T:-1 },
	0x01C5: { /* n:"BrtBeginDeletedName", */ T:1 },
	0x01C6: { /* n:"BrtEndDeletedName", */ T:-1 },
	0x01C7: { /* n:"BrtBeginQSIFs", */ T:1 },
	0x01C8: { /* n:"BrtEndQSIFs", */ T:-1 },
	0x01C9: { /* n:"BrtBeginQSIF", */ T:1 },
	0x01CA: { /* n:"BrtEndQSIF", */ T:-1 },
	0x01CB: { /* n:"BrtBeginAutoSortScope", */ T:1 },
	0x01CC: { /* n:"BrtEndAutoSortScope", */ T:-1 },
	0x01CD: { /* n:"BrtBeginConditionalFormatting", */ T:1 },
	0x01CE: { /* n:"BrtEndConditionalFormatting", */ T:-1 },
	0x01CF: { /* n:"BrtBeginCFRule", */ T:1 },
	0x01D0: { /* n:"BrtEndCFRule", */ T:-1 },
	0x01D1: { /* n:"BrtBeginIconSet", */ T:1 },
	0x01D2: { /* n:"BrtEndIconSet", */ T:-1 },
	0x01D3: { /* n:"BrtBeginDatabar", */ T:1 },
	0x01D4: { /* n:"BrtEndDatabar", */ T:-1 },
	0x01D5: { /* n:"BrtBeginColorScale", */ T:1 },
	0x01D6: { /* n:"BrtEndColorScale", */ T:-1 },
	0x01D7: { /* n:"BrtCFVO" */ },
	0x01D8: { /* n:"BrtExternValueMeta" */ },
	0x01D9: { /* n:"BrtBeginColorPalette", */ T:1 },
	0x01DA: { /* n:"BrtEndColorPalette", */ T:-1 },
	0x01DB: { /* n:"BrtIndexedColor" */ },
	0x01DC: { /* n:"BrtMargins", */ f:parse_BrtMargins },
	0x01DD: { /* n:"BrtPrintOptions" */ },
	0x01DE: { /* n:"BrtPageSetup" */ },
	0x01DF: { /* n:"BrtBeginHeaderFooter", */ T:1 },
	0x01E0: { /* n:"BrtEndHeaderFooter", */ T:-1 },
	0x01E1: { /* n:"BrtBeginSXCrtFormat", */ T:1 },
	0x01E2: { /* n:"BrtEndSXCrtFormat", */ T:-1 },
	0x01E3: { /* n:"BrtBeginSXCrtFormats", */ T:1 },
	0x01E4: { /* n:"BrtEndSXCrtFormats", */ T:-1 },
	0x01E5: { /* n:"BrtWsFmtInfo", */ f:parse_BrtWsFmtInfo },
	0x01E6: { /* n:"BrtBeginMgs", */ T:1 },
	0x01E7: { /* n:"BrtEndMGs", */ T:-1 },
	0x01E8: { /* n:"BrtBeginMGMaps", */ T:1 },
	0x01E9: { /* n:"BrtEndMGMaps", */ T:-1 },
	0x01EA: { /* n:"BrtBeginMG", */ T:1 },
	0x01EB: { /* n:"BrtEndMG", */ T:-1 },
	0x01EC: { /* n:"BrtBeginMap", */ T:1 },
	0x01ED: { /* n:"BrtEndMap", */ T:-1 },
	0x01EE: { /* n:"BrtHLink", */ f:parse_BrtHLink },
	0x01EF: { /* n:"BrtBeginDCon", */ T:1 },
	0x01F0: { /* n:"BrtEndDCon", */ T:-1 },
	0x01F1: { /* n:"BrtBeginDRefs", */ T:1 },
	0x01F2: { /* n:"BrtEndDRefs", */ T:-1 },
	0x01F3: { /* n:"BrtDRef" */ },
	0x01F4: { /* n:"BrtBeginScenMan", */ T:1 },
	0x01F5: { /* n:"BrtEndScenMan", */ T:-1 },
	0x01F6: { /* n:"BrtBeginSct", */ T:1 },
	0x01F7: { /* n:"BrtEndSct", */ T:-1 },
	0x01F8: { /* n:"BrtSlc" */ },
	0x01F9: { /* n:"BrtBeginDXFs", */ T:1 },
	0x01FA: { /* n:"BrtEndDXFs", */ T:-1 },
	0x01FB: { /* n:"BrtDXF" */ },
	0x01FC: { /* n:"BrtBeginTableStyles", */ T:1 },
	0x01FD: { /* n:"BrtEndTableStyles", */ T:-1 },
	0x01FE: { /* n:"BrtBeginTableStyle", */ T:1 },
	0x01FF: { /* n:"BrtEndTableStyle", */ T:-1 },
	0x0200: { /* n:"BrtTableStyleElement" */ },
	0x0201: { /* n:"BrtTableStyleClient" */ },
	0x0202: { /* n:"BrtBeginVolDeps", */ T:1 },
	0x0203: { /* n:"BrtEndVolDeps", */ T:-1 },
	0x0204: { /* n:"BrtBeginVolType", */ T:1 },
	0x0205: { /* n:"BrtEndVolType", */ T:-1 },
	0x0206: { /* n:"BrtBeginVolMain", */ T:1 },
	0x0207: { /* n:"BrtEndVolMain", */ T:-1 },
	0x0208: { /* n:"BrtBeginVolTopic", */ T:1 },
	0x0209: { /* n:"BrtEndVolTopic", */ T:-1 },
	0x020A: { /* n:"BrtVolSubtopic" */ },
	0x020B: { /* n:"BrtVolRef" */ },
	0x020C: { /* n:"BrtVolNum" */ },
	0x020D: { /* n:"BrtVolErr" */ },
	0x020E: { /* n:"BrtVolStr" */ },
	0x020F: { /* n:"BrtVolBool" */ },
	0x0210: { /* n:"BrtBeginCalcChain$", */ T:1 },
	0x0211: { /* n:"BrtEndCalcChain$", */ T:-1 },
	0x0212: { /* n:"BrtBeginSortState", */ T:1 },
	0x0213: { /* n:"BrtEndSortState", */ T:-1 },
	0x0214: { /* n:"BrtBeginSortCond", */ T:1 },
	0x0215: { /* n:"BrtEndSortCond", */ T:-1 },
	0x0216: { /* n:"BrtBookProtection" */ },
	0x0217: { /* n:"BrtSheetProtection" */ },
	0x0218: { /* n:"BrtRangeProtection" */ },
	0x0219: { /* n:"BrtPhoneticInfo" */ },
	0x021A: { /* n:"BrtBeginECTxtWiz", */ T:1 },
	0x021B: { /* n:"BrtEndECTxtWiz", */ T:-1 },
	0x021C: { /* n:"BrtBeginECTWFldInfoLst", */ T:1 },
	0x021D: { /* n:"BrtEndECTWFldInfoLst", */ T:-1 },
	0x021E: { /* n:"BrtBeginECTwFldInfo", */ T:1 },
	0x0224: { /* n:"BrtFileSharing" */ },
	0x0225: { /* n:"BrtOleSize" */ },
	0x0226: { /* n:"BrtDrawing", */ f:parse_RelID },
	0x0227: { /* n:"BrtLegacyDrawing" */ },
	0x0228: { /* n:"BrtLegacyDrawingHF" */ },
	0x0229: { /* n:"BrtWebOpt" */ },
	0x022A: { /* n:"BrtBeginWebPubItems", */ T:1 },
	0x022B: { /* n:"BrtEndWebPubItems", */ T:-1 },
	0x022C: { /* n:"BrtBeginWebPubItem", */ T:1 },
	0x022D: { /* n:"BrtEndWebPubItem", */ T:-1 },
	0x022E: { /* n:"BrtBeginSXCondFmt", */ T:1 },
	0x022F: { /* n:"BrtEndSXCondFmt", */ T:-1 },
	0x0230: { /* n:"BrtBeginSXCondFmts", */ T:1 },
	0x0231: { /* n:"BrtEndSXCondFmts", */ T:-1 },
	0x0232: { /* n:"BrtBkHim" */ },
	0x0234: { /* n:"BrtColor" */ },
	0x0235: { /* n:"BrtBeginIndexedColors", */ T:1 },
	0x0236: { /* n:"BrtEndIndexedColors", */ T:-1 },
	0x0239: { /* n:"BrtBeginMRUColors", */ T:1 },
	0x023A: { /* n:"BrtEndMRUColors", */ T:-1 },
	0x023C: { /* n:"BrtMRUColor" */ },
	0x023D: { /* n:"BrtBeginDVals", */ T:1 },
	0x023E: { /* n:"BrtEndDVals", */ T:-1 },
	0x0241: { /* n:"BrtSupNameStart" */ },
	0x0242: { /* n:"BrtSupNameValueStart" */ },
	0x0243: { /* n:"BrtSupNameValueEnd" */ },
	0x0244: { /* n:"BrtSupNameNum" */ },
	0x0245: { /* n:"BrtSupNameErr" */ },
	0x0246: { /* n:"BrtSupNameSt" */ },
	0x0247: { /* n:"BrtSupNameNil" */ },
	0x0248: { /* n:"BrtSupNameBool" */ },
	0x0249: { /* n:"BrtSupNameFmla" */ },
	0x024A: { /* n:"BrtSupNameBits" */ },
	0x024B: { /* n:"BrtSupNameEnd" */ },
	0x024C: { /* n:"BrtEndSupBook", */ T:-1 },
	0x024D: { /* n:"BrtCellSmartTagProperty" */ },
	0x024E: { /* n:"BrtBeginCellSmartTag", */ T:1 },
	0x024F: { /* n:"BrtEndCellSmartTag", */ T:-1 },
	0x0250: { /* n:"BrtBeginCellSmartTags", */ T:1 },
	0x0251: { /* n:"BrtEndCellSmartTags", */ T:-1 },
	0x0252: { /* n:"BrtBeginSmartTags", */ T:1 },
	0x0253: { /* n:"BrtEndSmartTags", */ T:-1 },
	0x0254: { /* n:"BrtSmartTagType" */ },
	0x0255: { /* n:"BrtBeginSmartTagTypes", */ T:1 },
	0x0256: { /* n:"BrtEndSmartTagTypes", */ T:-1 },
	0x0257: { /* n:"BrtBeginSXFilters", */ T:1 },
	0x0258: { /* n:"BrtEndSXFilters", */ T:-1 },
	0x0259: { /* n:"BrtBeginSXFILTER", */ T:1 },
	0x025A: { /* n:"BrtEndSXFilter", */ T:-1 },
	0x025B: { /* n:"BrtBeginFills", */ T:1 },
	0x025C: { /* n:"BrtEndFills", */ T:-1 },
	0x025D: { /* n:"BrtBeginCellWatches", */ T:1 },
	0x025E: { /* n:"BrtEndCellWatches", */ T:-1 },
	0x025F: { /* n:"BrtCellWatch" */ },
	0x0260: { /* n:"BrtBeginCRErrs", */ T:1 },
	0x0261: { /* n:"BrtEndCRErrs", */ T:-1 },
	0x0262: { /* n:"BrtCrashRecErr" */ },
	0x0263: { /* n:"BrtBeginFonts", */ T:1 },
	0x0264: { /* n:"BrtEndFonts", */ T:-1 },
	0x0265: { /* n:"BrtBeginBorders", */ T:1 },
	0x0266: { /* n:"BrtEndBorders", */ T:-1 },
	0x0267: { /* n:"BrtBeginFmts", */ T:1 },
	0x0268: { /* n:"BrtEndFmts", */ T:-1 },
	0x0269: { /* n:"BrtBeginCellXFs", */ T:1 },
	0x026A: { /* n:"BrtEndCellXFs", */ T:-1 },
	0x026B: { /* n:"BrtBeginStyles", */ T:1 },
	0x026C: { /* n:"BrtEndStyles", */ T:-1 },
	0x0271: { /* n:"BrtBigName" */ },
	0x0272: { /* n:"BrtBeginCellStyleXFs", */ T:1 },
	0x0273: { /* n:"BrtEndCellStyleXFs", */ T:-1 },
	0x0274: { /* n:"BrtBeginComments", */ T:1 },
	0x0275: { /* n:"BrtEndComments", */ T:-1 },
	0x0276: { /* n:"BrtBeginCommentAuthors", */ T:1 },
	0x0277: { /* n:"BrtEndCommentAuthors", */ T:-1 },
	0x0278: { /* n:"BrtCommentAuthor", */ f:parse_BrtCommentAuthor },
	0x0279: { /* n:"BrtBeginCommentList", */ T:1 },
	0x027A: { /* n:"BrtEndCommentList", */ T:-1 },
	0x027B: { /* n:"BrtBeginComment", */ T:1, f:parse_BrtBeginComment},
	0x027C: { /* n:"BrtEndComment", */ T:-1 },
	0x027D: { /* n:"BrtCommentText", */ f:parse_BrtCommentText },
	0x027E: { /* n:"BrtBeginOleObjects", */ T:1 },
	0x027F: { /* n:"BrtOleObject" */ },
	0x0280: { /* n:"BrtEndOleObjects", */ T:-1 },
	0x0281: { /* n:"BrtBeginSxrules", */ T:1 },
	0x0282: { /* n:"BrtEndSxRules", */ T:-1 },
	0x0283: { /* n:"BrtBeginActiveXControls", */ T:1 },
	0x0284: { /* n:"BrtActiveX" */ },
	0x0285: { /* n:"BrtEndActiveXControls", */ T:-1 },
	0x0286: { /* n:"BrtBeginPCDSDTCEMembersSortBy", */ T:1 },
	0x0288: { /* n:"BrtBeginCellIgnoreECs", */ T:1 },
	0x0289: { /* n:"BrtCellIgnoreEC" */ },
	0x028A: { /* n:"BrtEndCellIgnoreECs", */ T:-1 },
	0x028B: { /* n:"BrtCsProp", */ f:parse_BrtCsProp },
	0x028C: { /* n:"BrtCsPageSetup" */ },
	0x028D: { /* n:"BrtBeginUserCsViews", */ T:1 },
	0x028E: { /* n:"BrtEndUserCsViews", */ T:-1 },
	0x028F: { /* n:"BrtBeginUserCsView", */ T:1 },
	0x0290: { /* n:"BrtEndUserCsView", */ T:-1 },
	0x0291: { /* n:"BrtBeginPcdSFCIEntries", */ T:1 },
	0x0292: { /* n:"BrtEndPCDSFCIEntries", */ T:-1 },
	0x0293: { /* n:"BrtPCDSFCIEntry" */ },
	0x0294: { /* n:"BrtBeginListParts", */ T:1 },
	0x0295: { /* n:"BrtListPart" */ },
	0x0296: { /* n:"BrtEndListParts", */ T:-1 },
	0x0297: { /* n:"BrtSheetCalcProp" */ },
	0x0298: { /* n:"BrtBeginFnGroup", */ T:1 },
	0x0299: { /* n:"BrtFnGroup" */ },
	0x029A: { /* n:"BrtEndFnGroup", */ T:-1 },
	0x029B: { /* n:"BrtSupAddin" */ },
	0x029C: { /* n:"BrtSXTDMPOrder" */ },
	0x029D: { /* n:"BrtCsProtection" */ },
	0x029F: { /* n:"BrtBeginWsSortMap", */ T:1 },
	0x02A0: { /* n:"BrtEndWsSortMap", */ T:-1 },
	0x02A1: { /* n:"BrtBeginRRSort", */ T:1 },
	0x02A2: { /* n:"BrtEndRRSort", */ T:-1 },
	0x02A3: { /* n:"BrtRRSortItem" */ },
	0x02A4: { /* n:"BrtFileSharingIso" */ },
	0x02A5: { /* n:"BrtBookProtectionIso" */ },
	0x02A6: { /* n:"BrtSheetProtectionIso" */ },
	0x02A7: { /* n:"BrtCsProtectionIso" */ },
	0x02A8: { /* n:"BrtRangeProtectionIso" */ },
	0x02A9: { /* n:"BrtDValList" */ },
	0x0400: { /* n:"BrtRwDescent" */ },
	0x0401: { /* n:"BrtKnownFonts" */ },
	0x0402: { /* n:"BrtBeginSXTupleSet", */ T:1 },
	0x0403: { /* n:"BrtEndSXTupleSet", */ T:-1 },
	0x0404: { /* n:"BrtBeginSXTupleSetHeader", */ T:1 },
	0x0405: { /* n:"BrtEndSXTupleSetHeader", */ T:-1 },
	0x0406: { /* n:"BrtSXTupleSetHeaderItem" */ },
	0x0407: { /* n:"BrtBeginSXTupleSetData", */ T:1 },
	0x0408: { /* n:"BrtEndSXTupleSetData", */ T:-1 },
	0x0409: { /* n:"BrtBeginSXTupleSetRow", */ T:1 },
	0x040A: { /* n:"BrtEndSXTupleSetRow", */ T:-1 },
	0x040B: { /* n:"BrtSXTupleSetRowItem" */ },
	0x040C: { /* n:"BrtNameExt" */ },
	0x040D: { /* n:"BrtPCDH14" */ },
	0x040E: { /* n:"BrtBeginPCDCalcMem14", */ T:1 },
	0x040F: { /* n:"BrtEndPCDCalcMem14", */ T:-1 },
	0x0410: { /* n:"BrtSXTH14" */ },
	0x0411: { /* n:"BrtBeginSparklineGroup", */ T:1 },
	0x0412: { /* n:"BrtEndSparklineGroup", */ T:-1 },
	0x0413: { /* n:"BrtSparkline" */ },
	0x0414: { /* n:"BrtSXDI14" */ },
	0x0415: { /* n:"BrtWsFmtInfoEx14" */ },
	0x0416: { /* n:"BrtBeginConditionalFormatting14", */ T:1 },
	0x0417: { /* n:"BrtEndConditionalFormatting14", */ T:-1 },
	0x0418: { /* n:"BrtBeginCFRule14", */ T:1 },
	0x0419: { /* n:"BrtEndCFRule14", */ T:-1 },
	0x041A: { /* n:"BrtCFVO14" */ },
	0x041B: { /* n:"BrtBeginDatabar14", */ T:1 },
	0x041C: { /* n:"BrtBeginIconSet14", */ T:1 },
	0x041D: { /* n:"BrtDVal14", */ f: parse_BrtDVal14 },
	0x041E: { /* n:"BrtBeginDVals14", */ T:1 },
	0x041F: { /* n:"BrtColor14" */ },
	0x0420: { /* n:"BrtBeginSparklines", */ T:1 },
	0x0421: { /* n:"BrtEndSparklines", */ T:-1 },
	0x0422: { /* n:"BrtBeginSparklineGroups", */ T:1 },
	0x0423: { /* n:"BrtEndSparklineGroups", */ T:-1 },
	0x0425: { /* n:"BrtSXVD14" */ },
	0x0426: { /* n:"BrtBeginSXView14", */ T:1 },
	0x0427: { /* n:"BrtEndSXView14", */ T:-1 },
	0x0428: { /* n:"BrtBeginSXView16", */ T:1 },
	0x0429: { /* n:"BrtEndSXView16", */ T:-1 },
	0x042A: { /* n:"BrtBeginPCD14", */ T:1 },
	0x042B: { /* n:"BrtEndPCD14", */ T:-1 },
	0x042C: { /* n:"BrtBeginExtConn14", */ T:1 },
	0x042D: { /* n:"BrtEndExtConn14", */ T:-1 },
	0x042E: { /* n:"BrtBeginSlicerCacheIDs", */ T:1 },
	0x042F: { /* n:"BrtEndSlicerCacheIDs", */ T:-1 },
	0x0430: { /* n:"BrtBeginSlicerCacheID", */ T:1 },
	0x0431: { /* n:"BrtEndSlicerCacheID", */ T:-1 },
	0x0433: { /* n:"BrtBeginSlicerCache", */ T:1 },
	0x0434: { /* n:"BrtEndSlicerCache", */ T:-1 },
	0x0435: { /* n:"BrtBeginSlicerCacheDef", */ T:1 },
	0x0436: { /* n:"BrtEndSlicerCacheDef", */ T:-1 },
	0x0437: { /* n:"BrtBeginSlicersEx", */ T:1 },
	0x0438: { /* n:"BrtEndSlicersEx", */ T:-1 },
	0x0439: { /* n:"BrtBeginSlicerEx", */ T:1 },
	0x043A: { /* n:"BrtEndSlicerEx", */ T:-1 },
	0x043B: { /* n:"BrtBeginSlicer", */ T:1 },
	0x043C: { /* n:"BrtEndSlicer", */ T:-1 },
	0x043D: { /* n:"BrtSlicerCachePivotTables" */ },
	0x043E: { /* n:"BrtBeginSlicerCacheOlapImpl", */ T:1 },
	0x043F: { /* n:"BrtEndSlicerCacheOlapImpl", */ T:-1 },
	0x0440: { /* n:"BrtBeginSlicerCacheLevelsData", */ T:1 },
	0x0441: { /* n:"BrtEndSlicerCacheLevelsData", */ T:-1 },
	0x0442: { /* n:"BrtBeginSlicerCacheLevelData", */ T:1 },
	0x0443: { /* n:"BrtEndSlicerCacheLevelData", */ T:-1 },
	0x0444: { /* n:"BrtBeginSlicerCacheSiRanges", */ T:1 },
	0x0445: { /* n:"BrtEndSlicerCacheSiRanges", */ T:-1 },
	0x0446: { /* n:"BrtBeginSlicerCacheSiRange", */ T:1 },
	0x0447: { /* n:"BrtEndSlicerCacheSiRange", */ T:-1 },
	0x0448: { /* n:"BrtSlicerCacheOlapItem" */ },
	0x0449: { /* n:"BrtBeginSlicerCacheSelections", */ T:1 },
	0x044A: { /* n:"BrtSlicerCacheSelection" */ },
	0x044B: { /* n:"BrtEndSlicerCacheSelections", */ T:-1 },
	0x044C: { /* n:"BrtBeginSlicerCacheNative", */ T:1 },
	0x044D: { /* n:"BrtEndSlicerCacheNative", */ T:-1 },
	0x044E: { /* n:"BrtSlicerCacheNativeItem" */ },
	0x044F: { /* n:"BrtRangeProtection14" */ },
	0x0450: { /* n:"BrtRangeProtectionIso14" */ },
	0x0451: { /* n:"BrtCellIgnoreEC14" */ },
	0x0457: { /* n:"BrtList14" */ },
	0x0458: { /* n:"BrtCFIcon" */ },
	0x0459: { /* n:"BrtBeginSlicerCachesPivotCacheIDs", */ T:1 },
	0x045A: { /* n:"BrtEndSlicerCachesPivotCacheIDs", */ T:-1 },
	0x045B: { /* n:"BrtBeginSlicers", */ T:1 },
	0x045C: { /* n:"BrtEndSlicers", */ T:-1 },
	0x045D: { /* n:"BrtWbProp14" */ },
	0x045E: { /* n:"BrtBeginSXEdit", */ T:1 },
	0x045F: { /* n:"BrtEndSXEdit", */ T:-1 },
	0x0460: { /* n:"BrtBeginSXEdits", */ T:1 },
	0x0461: { /* n:"BrtEndSXEdits", */ T:-1 },
	0x0462: { /* n:"BrtBeginSXChange", */ T:1 },
	0x0463: { /* n:"BrtEndSXChange", */ T:-1 },
	0x0464: { /* n:"BrtBeginSXChanges", */ T:1 },
	0x0465: { /* n:"BrtEndSXChanges", */ T:-1 },
	0x0466: { /* n:"BrtSXTupleItems" */ },
	0x0468: { /* n:"BrtBeginSlicerStyle", */ T:1 },
	0x0469: { /* n:"BrtEndSlicerStyle", */ T:-1 },
	0x046A: { /* n:"BrtSlicerStyleElement" */ },
	0x046B: { /* n:"BrtBeginStyleSheetExt14", */ T:1 },
	0x046C: { /* n:"BrtEndStyleSheetExt14", */ T:-1 },
	0x046D: { /* n:"BrtBeginSlicerCachesPivotCacheID", */ T:1 },
	0x046E: { /* n:"BrtEndSlicerCachesPivotCacheID", */ T:-1 },
	0x046F: { /* n:"BrtBeginConditionalFormattings", */ T:1 },
	0x0470: { /* n:"BrtEndConditionalFormattings", */ T:-1 },
	0x0471: { /* n:"BrtBeginPCDCalcMemExt", */ T:1 },
	0x0472: { /* n:"BrtEndPCDCalcMemExt", */ T:-1 },
	0x0473: { /* n:"BrtBeginPCDCalcMemsExt", */ T:1 },
	0x0474: { /* n:"BrtEndPCDCalcMemsExt", */ T:-1 },
	0x0475: { /* n:"BrtPCDField14" */ },
	0x0476: { /* n:"BrtBeginSlicerStyles", */ T:1 },
	0x0477: { /* n:"BrtEndSlicerStyles", */ T:-1 },
	0x0478: { /* n:"BrtBeginSlicerStyleElements", */ T:1 },
	0x0479: { /* n:"BrtEndSlicerStyleElements", */ T:-1 },
	0x047A: { /* n:"BrtCFRuleExt" */ },
	0x047B: { /* n:"BrtBeginSXCondFmt14", */ T:1 },
	0x047C: { /* n:"BrtEndSXCondFmt14", */ T:-1 },
	0x047D: { /* n:"BrtBeginSXCondFmts14", */ T:1 },
	0x047E: { /* n:"BrtEndSXCondFmts14", */ T:-1 },
	0x0480: { /* n:"BrtBeginSortCond14", */ T:1 },
	0x0481: { /* n:"BrtEndSortCond14", */ T:-1 },
	0x0482: { /* n:"BrtEndDVals14", */ T:-1 },
	0x0483: { /* n:"BrtEndIconSet14", */ T:-1 },
	0x0484: { /* n:"BrtEndDatabar14", */ T:-1 },
	0x0485: { /* n:"BrtBeginColorScale14", */ T:1 },
	0x0486: { /* n:"BrtEndColorScale14", */ T:-1 },
	0x0487: { /* n:"BrtBeginSxrules14", */ T:1 },
	0x0488: { /* n:"BrtEndSxrules14", */ T:-1 },
	0x0489: { /* n:"BrtBeginPRule14", */ T:1 },
	0x048A: { /* n:"BrtEndPRule14", */ T:-1 },
	0x048B: { /* n:"BrtBeginPRFilters14", */ T:1 },
	0x048C: { /* n:"BrtEndPRFilters14", */ T:-1 },
	0x048D: { /* n:"BrtBeginPRFilter14", */ T:1 },
	0x048E: { /* n:"BrtEndPRFilter14", */ T:-1 },
	0x048F: { /* n:"BrtBeginPRFItem14", */ T:1 },
	0x0490: { /* n:"BrtEndPRFItem14", */ T:-1 },
	0x0491: { /* n:"BrtBeginCellIgnoreECs14", */ T:1 },
	0x0492: { /* n:"BrtEndCellIgnoreECs14", */ T:-1 },
	0x0493: { /* n:"BrtDxf14" */ },
	0x0494: { /* n:"BrtBeginDxF14s", */ T:1 },
	0x0495: { /* n:"BrtEndDxf14s", */ T:-1 },
	0x0499: { /* n:"BrtFilter14" */ },
	0x049A: { /* n:"BrtBeginCustomFilters14", */ T:1 },
	0x049C: { /* n:"BrtCustomFilter14" */ },
	0x049D: { /* n:"BrtIconFilter14" */ },
	0x049E: { /* n:"BrtPivotCacheConnectionName" */ },
	0x0800: { /* n:"BrtBeginDecoupledPivotCacheIDs", */ T:1 },
	0x0801: { /* n:"BrtEndDecoupledPivotCacheIDs", */ T:-1 },
	0x0802: { /* n:"BrtDecoupledPivotCacheID" */ },
	0x0803: { /* n:"BrtBeginPivotTableRefs", */ T:1 },
	0x0804: { /* n:"BrtEndPivotTableRefs", */ T:-1 },
	0x0805: { /* n:"BrtPivotTableRef" */ },
	0x0806: { /* n:"BrtSlicerCacheBookPivotTables" */ },
	0x0807: { /* n:"BrtBeginSxvcells", */ T:1 },
	0x0808: { /* n:"BrtEndSxvcells", */ T:-1 },
	0x0809: { /* n:"BrtBeginSxRow", */ T:1 },
	0x080A: { /* n:"BrtEndSxRow", */ T:-1 },
	0x080C: { /* n:"BrtPcdCalcMem15" */ },
	0x0813: { /* n:"BrtQsi15" */ },
	0x0814: { /* n:"BrtBeginWebExtensions", */ T:1 },
	0x0815: { /* n:"BrtEndWebExtensions", */ T:-1 },
	0x0816: { /* n:"BrtWebExtension" */ },
	0x0817: { /* n:"BrtAbsPath15" */ },
	0x0818: { /* n:"BrtBeginPivotTableUISettings", */ T:1 },
	0x0819: { /* n:"BrtEndPivotTableUISettings", */ T:-1 },
	0x081B: { /* n:"BrtTableSlicerCacheIDs" */ },
	0x081C: { /* n:"BrtTableSlicerCacheID" */ },
	0x081D: { /* n:"BrtBeginTableSlicerCache", */ T:1 },
	0x081E: { /* n:"BrtEndTableSlicerCache", */ T:-1 },
	0x081F: { /* n:"BrtSxFilter15" */ },
	0x0820: { /* n:"BrtBeginTimelineCachePivotCacheIDs", */ T:1 },
	0x0821: { /* n:"BrtEndTimelineCachePivotCacheIDs", */ T:-1 },
	0x0822: { /* n:"BrtTimelineCachePivotCacheID" */ },
	0x0823: { /* n:"BrtBeginTimelineCacheIDs", */ T:1 },
	0x0824: { /* n:"BrtEndTimelineCacheIDs", */ T:-1 },
	0x0825: { /* n:"BrtBeginTimelineCacheID", */ T:1 },
	0x0826: { /* n:"BrtEndTimelineCacheID", */ T:-1 },
	0x0827: { /* n:"BrtBeginTimelinesEx", */ T:1 },
	0x0828: { /* n:"BrtEndTimelinesEx", */ T:-1 },
	0x0829: { /* n:"BrtBeginTimelineEx", */ T:1 },
	0x082A: { /* n:"BrtEndTimelineEx", */ T:-1 },
	0x082B: { /* n:"BrtWorkBookPr15" */ },
	0x082C: { /* n:"BrtPCDH15" */ },
	0x082D: { /* n:"BrtBeginTimelineStyle", */ T:1 },
	0x082E: { /* n:"BrtEndTimelineStyle", */ T:-1 },
	0x082F: { /* n:"BrtTimelineStyleElement" */ },
	0x0830: { /* n:"BrtBeginTimelineStylesheetExt15", */ T:1 },
	0x0831: { /* n:"BrtEndTimelineStylesheetExt15", */ T:-1 },
	0x0832: { /* n:"BrtBeginTimelineStyles", */ T:1 },
	0x0833: { /* n:"BrtEndTimelineStyles", */ T:-1 },
	0x0834: { /* n:"BrtBeginTimelineStyleElements", */ T:1 },
	0x0835: { /* n:"BrtEndTimelineStyleElements", */ T:-1 },
	0x0836: { /* n:"BrtDxf15" */ },
	0x0837: { /* n:"BrtBeginDxfs15", */ T:1 },
	0x0838: { /* n:"BrtEndDxfs15", */ T:-1 },
	0x0839: { /* n:"BrtSlicerCacheHideItemsWithNoData" */ },
	0x083A: { /* n:"BrtBeginItemUniqueNames", */ T:1 },
	0x083B: { /* n:"BrtEndItemUniqueNames", */ T:-1 },
	0x083C: { /* n:"BrtItemUniqueName" */ },
	0x083D: { /* n:"BrtBeginExtConn15", */ T:1 },
	0x083E: { /* n:"BrtEndExtConn15", */ T:-1 },
	0x083F: { /* n:"BrtBeginOledbPr15", */ T:1 },
	0x0840: { /* n:"BrtEndOledbPr15", */ T:-1 },
	0x0841: { /* n:"BrtBeginDataFeedPr15", */ T:1 },
	0x0842: { /* n:"BrtEndDataFeedPr15", */ T:-1 },
	0x0843: { /* n:"BrtTextPr15" */ },
	0x0844: { /* n:"BrtRangePr15" */ },
	0x0845: { /* n:"BrtDbCommand15" */ },
	0x0846: { /* n:"BrtBeginDbTables15", */ T:1 },
	0x0847: { /* n:"BrtEndDbTables15", */ T:-1 },
	0x0848: { /* n:"BrtDbTable15" */ },
	0x0849: { /* n:"BrtBeginDataModel", */ T:1 },
	0x084A: { /* n:"BrtEndDataModel", */ T:-1 },
	0x084B: { /* n:"BrtBeginModelTables", */ T:1 },
	0x084C: { /* n:"BrtEndModelTables", */ T:-1 },
	0x084D: { /* n:"BrtModelTable" */ },
	0x084E: { /* n:"BrtBeginModelRelationships", */ T:1 },
	0x084F: { /* n:"BrtEndModelRelationships", */ T:-1 },
	0x0850: { /* n:"BrtModelRelationship" */ },
	0x0851: { /* n:"BrtBeginECTxtWiz15", */ T:1 },
	0x0852: { /* n:"BrtEndECTxtWiz15", */ T:-1 },
	0x0853: { /* n:"BrtBeginECTWFldInfoLst15", */ T:1 },
	0x0854: { /* n:"BrtEndECTWFldInfoLst15", */ T:-1 },
	0x0855: { /* n:"BrtBeginECTWFldInfo15", */ T:1 },
	0x0856: { /* n:"BrtFieldListActiveItem" */ },
	0x0857: { /* n:"BrtPivotCacheIdVersion" */ },
	0x0858: { /* n:"BrtSXDI15" */ },
	0x0859: { /* n:"BrtBeginModelTimeGroupings", */ T:1 },
	0x085A: { /* n:"BrtEndModelTimeGroupings", */ T:-1 },
	0x085B: { /* n:"BrtBeginModelTimeGrouping", */ T:1 },
	0x085C: { /* n:"BrtEndModelTimeGrouping", */ T:-1 },
	0x085D: { /* n:"BrtModelTimeGroupingCalcCol" */ },
	0x0C00: { /* n:"BrtUid" */ },
	0x0C01: { /* n:"BrtRevisionPtr" */ },
	0x1000: { /* n:"BrtBeginDynamicArrayPr", */ T:1 },
	0x1001: { /* n:"BrtEndDynamicArrayPr", */ T:-1 },
	0x138A: { /* n:"BrtBeginRichValueBlock", */ T:1 },
	0x138B: { /* n:"BrtEndRichValueBlock", */ T:-1 },
	0x13D9: { /* n:"BrtBeginRichFilters", */ T:1 },
	0x13DA: { /* n:"BrtEndRichFilters", */ T:-1 },
	0x13DB: { /* n:"BrtRichFilter" */ },
	0x13DC: { /* n:"BrtBeginRichFilterColumn", */ T:1 },
	0x13DD: { /* n:"BrtEndRichFilterColumn", */ T:-1 },
	0x13DE: { /* n:"BrtBeginCustomRichFilters", */ T:1 },
	0x13DF: { /* n:"BrtEndCustomRichFilters", */ T:-1 },
	0x13E0: { /* n:"BrtCustomRichFilter" */ },
	0x13E1: { /* n:"BrtTop10RichFilter" */ },
	0x13E2: { /* n:"BrtDynamicRichFilter" */ },
	0x13E4: { /* n:"BrtBeginRichSortCondition", */ T:1 },
	0x13E5: { /* n:"BrtEndRichSortCondition", */ T:-1 },
	0x13E6: { /* n:"BrtRichFilterDateGroupItem" */ },
	0x13E7: { /* n:"BrtBeginCalcFeatures", */ T:1 },
	0x13E8: { /* n:"BrtEndCalcFeatures", */ T:-1 },
	0x13E9: { /* n:"BrtCalcFeature" */ },
	0x13EB: { /* n:"BrtExternalLinksPr" */ },
	0xFFFF: { n:"" }
	};
	
	/* [MS-XLS] 2.3 Record Enumeration (and other sources) */
	var XLSRecordEnum = {
		/* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */
	0x0006: { /* n:"Formula", */ f:parse_Formula },
	0x000a: { /* n:"EOF", */ f:parsenoop2 },
	0x000c: { /* n:"CalcCount", */ f:parseuint16 }, //
	0x000d: { /* n:"CalcMode", */ f:parseuint16 }, //
	0x000e: { /* n:"CalcPrecision", */ f:parsebool }, //
	0x000f: { /* n:"CalcRefMode", */ f:parsebool }, //
	0x0010: { /* n:"CalcDelta", */ f:parse_Xnum }, //
	0x0011: { /* n:"CalcIter", */ f:parsebool }, //
	0x0012: { /* n:"Protect", */ f:parsebool },
	0x0013: { /* n:"Password", */ f:parseuint16 },
	0x0014: { /* n:"Header", */ f:parse_XLHeaderFooter },
	0x0015: { /* n:"Footer", */ f:parse_XLHeaderFooter },
	0x0017: { /* n:"ExternSheet", */ f:parse_ExternSheet },
	0x0018: { /* n:"Lbl", */ f:parse_Lbl },
	0x0019: { /* n:"WinProtect", */ f:parsebool },
	0x001a: { /* n:"VerticalPageBreaks", */ },
	0x001b: { /* n:"HorizontalPageBreaks", */ },
	0x001c: { /* n:"Note", */ f:parse_Note },
	0x001d: { /* n:"Selection", */ },
	0x0022: { /* n:"Date1904", */ f:parsebool },
	0x0023: { /* n:"ExternName", */ f:parse_ExternName },
	0x0026: { /* n:"LeftMargin", */ f:parse_Xnum }, // *
	0x0027: { /* n:"RightMargin", */ f:parse_Xnum }, // *
	0x0028: { /* n:"TopMargin", */ f:parse_Xnum }, // *
	0x0029: { /* n:"BottomMargin", */ f:parse_Xnum }, // *
	0x002a: { /* n:"PrintRowCol", */ f:parsebool },
	0x002b: { /* n:"PrintGrid", */ f:parsebool },
	0x002f: { /* n:"FilePass", */ f:parse_FilePass },
	0x0031: { /* n:"Font", */ f:parse_Font },
	0x0033: { /* n:"PrintSize", */ f:parseuint16 },
	0x003c: { /* n:"Continue", */ },
	0x003d: { /* n:"Window1", */ f:parse_Window1 },
	0x0040: { /* n:"Backup", */ f:parsebool },
	0x0041: { /* n:"Pane", */ f:parse_Pane },
	0x0042: { /* n:"CodePage", */ f:parseuint16 },
	0x004d: { /* n:"Pls", */ },
	0x0050: { /* n:"DCon", */ },
	0x0051: { /* n:"DConRef", */ },
	0x0052: { /* n:"DConName", */ },
	0x0055: { /* n:"DefColWidth", */ f:parseuint16 },
	0x0059: { /* n:"XCT", */ },
	0x005a: { /* n:"CRN", */ },
	0x005b: { /* n:"FileSharing", */ },
	0x005c: { /* n:"WriteAccess", */ f:parse_WriteAccess },
	0x005d: { /* n:"Obj", */ f:parse_Obj },
	0x005e: { /* n:"Uncalced", */ },
	0x005f: { /* n:"CalcSaveRecalc", */ f:parsebool }, //
	0x0060: { /* n:"Template", */ },
	0x0061: { /* n:"Intl", */ },
	0x0063: { /* n:"ObjProtect", */ f:parsebool },
	0x007d: { /* n:"ColInfo", */ f:parse_ColInfo },
	0x0080: { /* n:"Guts", */ f:parse_Guts },
	0x0081: { /* n:"WsBool", */ f:parse_WsBool },
	0x0082: { /* n:"GridSet", */ f:parseuint16 },
	0x0083: { /* n:"HCenter", */ f:parsebool },
	0x0084: { /* n:"VCenter", */ f:parsebool },
	0x0085: { /* n:"BoundSheet8", */ f:parse_BoundSheet8 },
	0x0086: { /* n:"WriteProtect", */ },
	0x008c: { /* n:"Country", */ f:parse_Country },
	0x008d: { /* n:"HideObj", */ f:parseuint16 },
	0x0090: { /* n:"Sort", */ },
	0x0092: { /* n:"Palette", */ f:parse_Palette },
	0x0097: { /* n:"Sync", */ },
	0x0098: { /* n:"LPr", */ },
	0x0099: { /* n:"DxGCol", */ },
	0x009a: { /* n:"FnGroupName", */ },
	0x009b: { /* n:"FilterMode", */ },
	0x009c: { /* n:"BuiltInFnGroupCount", */ f:parseuint16 },
	0x009d: { /* n:"AutoFilterInfo", */ },
	0x009e: { /* n:"AutoFilter", */ },
	0x00a0: { /* n:"Scl", */ f:parse_Scl },
	0x00a1: { /* n:"Setup", */ f:parse_Setup },
	0x00ae: { /* n:"ScenMan", */ },
	0x00af: { /* n:"SCENARIO", */ },
	0x00b0: { /* n:"SxView", */ },
	0x00b1: { /* n:"Sxvd", */ },
	0x00b2: { /* n:"SXVI", */ },
	0x00b4: { /* n:"SxIvd", */ },
	0x00b5: { /* n:"SXLI", */ },
	0x00b6: { /* n:"SXPI", */ },
	0x00b8: { /* n:"DocRoute", */ },
	0x00b9: { /* n:"RecipName", */ },
	0x00bd: { /* n:"MulRk", */ f:parse_MulRk },
	0x00be: { /* n:"MulBlank", */ f:parse_MulBlank },
	0x00c1: { /* n:"Mms", */ f:parsenoop2 },
	0x00c5: { /* n:"SXDI", */ },
	0x00c6: { /* n:"SXDB", */ },
	0x00c7: { /* n:"SXFDB", */ },
	0x00c8: { /* n:"SXDBB", */ },
	0x00c9: { /* n:"SXNum", */ },
	0x00ca: { /* n:"SxBool", */ f:parsebool },
	0x00cb: { /* n:"SxErr", */ },
	0x00cc: { /* n:"SXInt", */ },
	0x00cd: { /* n:"SXString", */ },
	0x00ce: { /* n:"SXDtr", */ },
	0x00cf: { /* n:"SxNil", */ },
	0x00d0: { /* n:"SXTbl", */ },
	0x00d1: { /* n:"SXTBRGIITM", */ },
	0x00d2: { /* n:"SxTbpg", */ },
	0x00d3: { /* n:"ObProj", */ },
	0x00d5: { /* n:"SXStreamID", */ },
	0x00d7: { /* n:"DBCell", */ },
	0x00d8: { /* n:"SXRng", */ },
	0x00d9: { /* n:"SxIsxoper", */ },
	0x00da: { /* n:"BookBool", */ f:parseuint16 },
	0x00dc: { /* n:"DbOrParamQry", */ },
	0x00dd: { /* n:"ScenarioProtect", */ f:parsebool },
	0x00de: { /* n:"OleObjectSize", */ },
	0x00e0: { /* n:"XF", */ f:parse_XF },
	0x00e1: { /* n:"InterfaceHdr", */ f:parse_InterfaceHdr },
	0x00e2: { /* n:"InterfaceEnd", */ f:parsenoop2 },
	0x00e3: { /* n:"SXVS", */ },
	0x00e5: { /* n:"MergeCells", */ f:parse_MergeCells },
	0x00e9: { /* n:"BkHim", */ },
	0x00eb: { /* n:"MsoDrawingGroup", */ },
	0x00ec: { /* n:"MsoDrawing", */ },
	0x00ed: { /* n:"MsoDrawingSelection", */ },
	0x00ef: { /* n:"PhoneticInfo", */ },
	0x00f0: { /* n:"SxRule", */ },
	0x00f1: { /* n:"SXEx", */ },
	0x00f2: { /* n:"SxFilt", */ },
	0x00f4: { /* n:"SxDXF", */ },
	0x00f5: { /* n:"SxItm", */ },
	0x00f6: { /* n:"SxName", */ },
	0x00f7: { /* n:"SxSelect", */ },
	0x00f8: { /* n:"SXPair", */ },
	0x00f9: { /* n:"SxFmla", */ },
	0x00fb: { /* n:"SxFormat", */ },
	0x00fc: { /* n:"SST", */ f:parse_SST },
	0x00fd: { /* n:"LabelSst", */ f:parse_LabelSst },
	0x00ff: { /* n:"ExtSST", */ f:parse_ExtSST },
	0x0100: { /* n:"SXVDEx", */ },
	0x0103: { /* n:"SXFormula", */ },
	0x0122: { /* n:"SXDBEx", */ },
	0x0137: { /* n:"RRDInsDel", */ },
	0x0138: { /* n:"RRDHead", */ },
	0x013b: { /* n:"RRDChgCell", */ },
	0x013d: { /* n:"RRTabId", */ f:parseuint16a },
	0x013e: { /* n:"RRDRenSheet", */ },
	0x013f: { /* n:"RRSort", */ },
	0x0140: { /* n:"RRDMove", */ },
	0x014a: { /* n:"RRFormat", */ },
	0x014b: { /* n:"RRAutoFmt", */ },
	0x014d: { /* n:"RRInsertSh", */ },
	0x014e: { /* n:"RRDMoveBegin", */ },
	0x014f: { /* n:"RRDMoveEnd", */ },
	0x0150: { /* n:"RRDInsDelBegin", */ },
	0x0151: { /* n:"RRDInsDelEnd", */ },
	0x0152: { /* n:"RRDConflict", */ },
	0x0153: { /* n:"RRDDefName", */ },
	0x0154: { /* n:"RRDRstEtxp", */ },
	0x015f: { /* n:"LRng", */ },
	0x0160: { /* n:"UsesELFs", */ f:parsebool },
	0x0161: { /* n:"DSF", */ f:parsenoop2 },
	0x0191: { /* n:"CUsr", */ },
	0x0192: { /* n:"CbUsr", */ },
	0x0193: { /* n:"UsrInfo", */ },
	0x0194: { /* n:"UsrExcl", */ },
	0x0195: { /* n:"FileLock", */ },
	0x0196: { /* n:"RRDInfo", */ },
	0x0197: { /* n:"BCUsrs", */ },
	0x0198: { /* n:"UsrChk", */ },
	0x01a9: { /* n:"UserBView", */ },
	0x01aa: { /* n:"UserSViewBegin", */ },
	0x01ab: { /* n:"UserSViewEnd", */ },
	0x01ac: { /* n:"RRDUserView", */ },
	0x01ad: { /* n:"Qsi", */ },
	0x01ae: { /* n:"SupBook", */ f:parse_SupBook },
	0x01af: { /* n:"Prot4Rev", */ f:parsebool },
	0x01b0: { /* n:"CondFmt", */ },
	0x01b1: { /* n:"CF", */ },
	0x01b2: { /* n:"DVal", */ },
	0x01b5: { /* n:"DConBin", */ },
	0x01b6: { /* n:"TxO", */ f:parse_TxO },
	0x01b7: { /* n:"RefreshAll", */ f:parsebool }, //
	0x01b8: { /* n:"HLink", */ f:parse_HLink },
	0x01b9: { /* n:"Lel", */ },
	0x01ba: { /* n:"CodeName", */ f:parse_XLUnicodeString },
	0x01bb: { /* n:"SXFDBType", */ },
	0x01bc: { /* n:"Prot4RevPass", */ f:parseuint16 },
	0x01bd: { /* n:"ObNoMacros", */ },
	0x01be: { /* n:"Dv", */ },
	0x01c0: { /* n:"Excel9File", */ f:parsenoop2 },
	0x01c1: { /* n:"RecalcId", */ f:parse_RecalcId, r:2},
	0x01c2: { /* n:"EntExU2", */ f:parsenoop2 },
	0x0200: { /* n:"Dimensions", */ f:parse_Dimensions },
	0x0201: { /* n:"Blank", */ f:parse_Blank },
	0x0203: { /* n:"Number", */ f:parse_Number },
	0x0204: { /* n:"Label", */ f:parse_Label },
	0x0205: { /* n:"BoolErr", */ f:parse_BoolErr },
	0x0207: { /* n:"String", */ f:parse_String },
	0x0208: { /* n:"Row", */ f:parse_Row },
	0x020b: { /* n:"Index", */ },
	0x0221: { /* n:"Array", */ f:parse_Array },
	0x0225: { /* n:"DefaultRowHeight", */ f:parse_DefaultRowHeight },
	0x0236: { /* n:"Table", */ },
	0x023e: { /* n:"Window2", */ f:parse_Window2 },
	0x027e: { /* n:"RK", */ f:parse_RK },
	0x0293: { /* n:"Style", */ },
	0x0418: { /* n:"BigName", */ },
	0x041e: { /* n:"Format", */ f:parse_Format },
	0x043c: { /* n:"ContinueBigName", */ },
	0x04bc: { /* n:"ShrFmla", */ f:parse_ShrFmla },
	0x0800: { /* n:"HLinkTooltip", */ f:parse_HLinkTooltip },
	0x0801: { /* n:"WebPub", */ },
	0x0802: { /* n:"QsiSXTag", */ },
	0x0803: { /* n:"DBQueryExt", */ },
	0x0804: { /* n:"ExtString", */ },
	0x0805: { /* n:"TxtQry", */ },
	0x0806: { /* n:"Qsir", */ },
	0x0807: { /* n:"Qsif", */ },
	0x0808: { /* n:"RRDTQSIF", */ },
	0x0809: { /* n:"BOF", */ f:parse_BOF },
	0x080a: { /* n:"OleDbConn", */ },
	0x080b: { /* n:"WOpt", */ },
	0x080c: { /* n:"SXViewEx", */ },
	0x080d: { /* n:"SXTH", */ },
	0x080e: { /* n:"SXPIEx", */ },
	0x080f: { /* n:"SXVDTEx", */ },
	0x0810: { /* n:"SXViewEx9", */ },
	0x0812: { /* n:"ContinueFrt", */ },
	0x0813: { /* n:"RealTimeData", */ },
	0x0850: { /* n:"ChartFrtInfo", */ },
	0x0851: { /* n:"FrtWrapper", */ },
	0x0852: { /* n:"StartBlock", */ },
	0x0853: { /* n:"EndBlock", */ },
	0x0854: { /* n:"StartObject", */ },
	0x0855: { /* n:"EndObject", */ },
	0x0856: { /* n:"CatLab", */ },
	0x0857: { /* n:"YMult", */ },
	0x0858: { /* n:"SXViewLink", */ },
	0x0859: { /* n:"PivotChartBits", */ },
	0x085a: { /* n:"FrtFontList", */ },
	0x0862: { /* n:"SheetExt", */ },
	0x0863: { /* n:"BookExt", */ r:12},
	0x0864: { /* n:"SXAddl", */ },
	0x0865: { /* n:"CrErr", */ },
	0x0866: { /* n:"HFPicture", */ },
	0x0867: { /* n:"FeatHdr", */ f:parsenoop2 },
	0x0868: { /* n:"Feat", */ },
	0x086a: { /* n:"DataLabExt", */ },
	0x086b: { /* n:"DataLabExtContents", */ },
	0x086c: { /* n:"CellWatch", */ },
	0x0871: { /* n:"FeatHdr11", */ },
	0x0872: { /* n:"Feature11", */ },
	0x0874: { /* n:"DropDownObjIds", */ },
	0x0875: { /* n:"ContinueFrt11", */ },
	0x0876: { /* n:"DConn", */ },
	0x0877: { /* n:"List12", */ },
	0x0878: { /* n:"Feature12", */ },
	0x0879: { /* n:"CondFmt12", */ },
	0x087a: { /* n:"CF12", */ },
	0x087b: { /* n:"CFEx", */ },
	0x087c: { /* n:"XFCRC", */ f:parse_XFCRC, r:12 },
	0x087d: { /* n:"XFExt", */ f:parse_XFExt, r:12 },
	0x087e: { /* n:"AutoFilter12", */ },
	0x087f: { /* n:"ContinueFrt12", */ },
	0x0884: { /* n:"MDTInfo", */ },
	0x0885: { /* n:"MDXStr", */ },
	0x0886: { /* n:"MDXTuple", */ },
	0x0887: { /* n:"MDXSet", */ },
	0x0888: { /* n:"MDXProp", */ },
	0x0889: { /* n:"MDXKPI", */ },
	0x088a: { /* n:"MDB", */ },
	0x088b: { /* n:"PLV", */ },
	0x088c: { /* n:"Compat12", */ f:parsebool, r:12 },
	0x088d: { /* n:"DXF", */ },
	0x088e: { /* n:"TableStyles", */ r:12 },
	0x088f: { /* n:"TableStyle", */ },
	0x0890: { /* n:"TableStyleElement", */ },
	0x0892: { /* n:"StyleExt", */ },
	0x0893: { /* n:"NamePublish", */ },
	0x0894: { /* n:"NameCmt", */ f:parse_NameCmt, r:12 },
	0x0895: { /* n:"SortData", */ },
	0x0896: { /* n:"Theme", */ f:parse_Theme, r:12 },
	0x0897: { /* n:"GUIDTypeLib", */ },
	0x0898: { /* n:"FnGrp12", */ },
	0x0899: { /* n:"NameFnGrp12", */ },
	0x089a: { /* n:"MTRSettings", */ f:parse_MTRSettings, r:12 },
	0x089b: { /* n:"CompressPictures", */ f:parsenoop2 },
	0x089c: { /* n:"HeaderFooter", */ },
	0x089d: { /* n:"CrtLayout12", */ },
	0x089e: { /* n:"CrtMlFrt", */ },
	0x089f: { /* n:"CrtMlFrtContinue", */ },
	0x08a3: { /* n:"ForceFullCalculation", */ f:parse_ForceFullCalculation },
	0x08a4: { /* n:"ShapePropsStream", */ },
	0x08a5: { /* n:"TextPropsStream", */ },
	0x08a6: { /* n:"RichTextStream", */ },
	0x08a7: { /* n:"CrtLayout12A", */ },
	0x1001: { /* n:"Units", */ },
	0x1002: { /* n:"Chart", */ },
	0x1003: { /* n:"Series", */ },
	0x1006: { /* n:"DataFormat", */ },
	0x1007: { /* n:"LineFormat", */ },
	0x1009: { /* n:"MarkerFormat", */ },
	0x100a: { /* n:"AreaFormat", */ },
	0x100b: { /* n:"PieFormat", */ },
	0x100c: { /* n:"AttachedLabel", */ },
	0x100d: { /* n:"SeriesText", */ },
	0x1014: { /* n:"ChartFormat", */ },
	0x1015: { /* n:"Legend", */ },
	0x1016: { /* n:"SeriesList", */ },
	0x1017: { /* n:"Bar", */ },
	0x1018: { /* n:"Line", */ },
	0x1019: { /* n:"Pie", */ },
	0x101a: { /* n:"Area", */ },
	0x101b: { /* n:"Scatter", */ },
	0x101c: { /* n:"CrtLine", */ },
	0x101d: { /* n:"Axis", */ },
	0x101e: { /* n:"Tick", */ },
	0x101f: { /* n:"ValueRange", */ },
	0x1020: { /* n:"CatSerRange", */ },
	0x1021: { /* n:"AxisLine", */ },
	0x1022: { /* n:"CrtLink", */ },
	0x1024: { /* n:"DefaultText", */ },
	0x1025: { /* n:"Text", */ },
	0x1026: { /* n:"FontX", */ f:parseuint16 },
	0x1027: { /* n:"ObjectLink", */ },
	0x1032: { /* n:"Frame", */ },
	0x1033: { /* n:"Begin", */ },
	0x1034: { /* n:"End", */ },
	0x1035: { /* n:"PlotArea", */ },
	0x103a: { /* n:"Chart3d", */ },
	0x103c: { /* n:"PicF", */ },
	0x103d: { /* n:"DropBar", */ },
	0x103e: { /* n:"Radar", */ },
	0x103f: { /* n:"Surf", */ },
	0x1040: { /* n:"RadarArea", */ },
	0x1041: { /* n:"AxisParent", */ },
	0x1043: { /* n:"LegendException", */ },
	0x1044: { /* n:"ShtProps", */ f:parse_ShtProps },
	0x1045: { /* n:"SerToCrt", */ },
	0x1046: { /* n:"AxesUsed", */ },
	0x1048: { /* n:"SBaseRef", */ },
	0x104a: { /* n:"SerParent", */ },
	0x104b: { /* n:"SerAuxTrend", */ },
	0x104e: { /* n:"IFmtRecord", */ },
	0x104f: { /* n:"Pos", */ },
	0x1050: { /* n:"AlRuns", */ },
	0x1051: { /* n:"BRAI", */ },
	0x105b: { /* n:"SerAuxErrBar", */ },
	0x105c: { /* n:"ClrtClient", */ f:parse_ClrtClient },
	0x105d: { /* n:"SerFmt", */ },
	0x105f: { /* n:"Chart3DBarShape", */ },
	0x1060: { /* n:"Fbi", */ },
	0x1061: { /* n:"BopPop", */ },
	0x1062: { /* n:"AxcExt", */ },
	0x1063: { /* n:"Dat", */ },
	0x1064: { /* n:"PlotGrowth", */ },
	0x1065: { /* n:"SIIndex", */ },
	0x1066: { /* n:"GelFrame", */ },
	0x1067: { /* n:"BopPopCustom", */ },
	0x1068: { /* n:"Fbi2", */ },
	
	0x0000: { /* n:"Dimensions", */ f:parse_Dimensions },
	0x0001: { /* n:"BIFF2BLANK", */ },
	0x0002: { /* n:"BIFF2INT", */ f:parse_BIFF2INT },
	0x0003: { /* n:"BIFF2NUM", */ f:parse_BIFF2NUM },
	0x0004: { /* n:"BIFF2STR", */ f:parse_BIFF2STR },
	0x0005: { /* n:"BoolErr", */ f:parse_BoolErr },
	0x0007: { /* n:"String", */ f:parse_BIFF2STRING },
	0x0008: { /* n:"BIFF2ROW", */ },
	0x0009: { /* n:"BOF", */ f:parse_BOF },
	0x000b: { /* n:"Index", */ },
	0x0016: { /* n:"ExternCount", */ f:parseuint16 },
	0x001e: { /* n:"BIFF2FORMAT", */ f:parse_BIFF2Format },
	0x001f: { /* n:"BIFF2FMTCNT", */ }, /* 16-bit cnt of BIFF2FORMAT records */
	0x0020: { /* n:"BIFF2COLINFO", */ },
	0x0021: { /* n:"Array", */ f:parse_Array },
	0x0024: { /* n:"COLWIDTH", */ },
	0x0025: { /* n:"DefaultRowHeight", */ f:parse_DefaultRowHeight },
		// 0x2c ??
		// 0x2d ??
		// 0x2e ??
		// 0x30 FONTCOUNT: number of fonts
	0x0032: { /* n:"BIFF2FONTXTRA", */ f:parse_BIFF2FONTXTRA },
		// 0x35: INFOOPTS
		// 0x36: TABLE (BIFF2 only)
		// 0x37: TABLE2 (BIFF2 only)
		// 0x38: WNDESK
		// 0x39 ??
		// 0x3a: BEGINPREF
		// 0x3b: ENDPREF
	0x003e: { /* n:"BIFF2WINDOW2", */ },
		// 0x3f ??
		// 0x46: SHOWSCROLL
		// 0x47: SHOWFORMULA
		// 0x48: STATUSBAR
		// 0x49: SHORTMENUS
		// 0x4A:
		// 0x4B:
		// 0x4C:
		// 0x4E:
		// 0x4F:
		// 0x58: TOOLBAR (BIFF3)
	
		/* - - - */
	0x0034: { /* n:"DDEObjName", */ },
	0x0043: { /* n:"BIFF2XF", */ },
	0x0044: { /* n:"BIFF2XFINDEX", */ f:parseuint16 },
	0x0045: { /* n:"BIFF2FONTCLR", */ },
	0x0056: { /* n:"BIFF4FMTCNT", */ }, /* 16-bit cnt, similar to BIFF2 */
	0x007e: { /* n:"RK", */ }, /* Not necessarily same as 0x027e */
	0x007f: { /* n:"ImData", */ f:parse_ImData },
	0x0087: { /* n:"Addin", */ },
	0x0088: { /* n:"Edg", */ },
	0x0089: { /* n:"Pub", */ },
		// 0x8A
		// 0x8B LH: alternate menu key flag (BIFF3/4)
		// 0x8E
		// 0x8F
	0x0091: { /* n:"Sub", */ },
		// 0x93 STYLE
	0x0094: { /* n:"LHRecord", */ },
	0x0095: { /* n:"LHNGraph", */ },
	0x0096: { /* n:"Sound", */ },
		// 0xA2 FNPROTO: function prototypes (BIFF4)
		// 0xA3
		// 0xA8
	0x00a9: { /* n:"CoordList", */ },
	0x00ab: { /* n:"GCW", */ },
	0x00bc: { /* n:"ShrFmla", */ }, /* Not necessarily same as 0x04bc */
	0x00bf: { /* n:"ToolbarHdr", */ },
	0x00c0: { /* n:"ToolbarEnd", */ },
	0x00c2: { /* n:"AddMenu", */ },
	0x00c3: { /* n:"DelMenu", */ },
	0x00d6: { /* n:"RString", */ f:parse_RString },
	0x00df: { /* n:"UDDesc", */ },
	0x00ea: { /* n:"TabIdConf", */ },
	0x0162: { /* n:"XL5Modify", */ },
	0x01a5: { /* n:"FileSharing2", */ },
	0x0206: { /* n:"Formula", */ f:parse_Formula },
	0x0209: { /* n:"BOF", */ f:parse_BOF },
	0x0218: { /* n:"Lbl", */ f:parse_Lbl },
	0x0223: { /* n:"ExternName", */ f:parse_ExternName },
	0x0231: { /* n:"Font", */ },
	0x0243: { /* n:"BIFF3XF", */ },
	0x0406: { /* n:"Formula", */ f:parse_Formula },
	0x0409: { /* n:"BOF", */ f:parse_BOF },
	0x0443: { /* n:"BIFF4XF", */ },
	0x086d: { /* n:"FeatInfo", */ },
	0x0873: { /* n:"FeatInfo11", */ },
	0x0881: { /* n:"SXAddl12", */ },
	0x08c0: { /* n:"AutoWebPub", */ },
	0x08c1: { /* n:"ListObj", */ },
	0x08c2: { /* n:"ListField", */ },
	0x08c3: { /* n:"ListDV", */ },
	0x08c4: { /* n:"ListCondFmt", */ },
	0x08c5: { /* n:"ListCF", */ },
	0x08c6: { /* n:"FMQry", */ },
	0x08c7: { /* n:"FMSQry", */ },
	0x08c8: { /* n:"PLV", */ },
	0x08c9: { /* n:"LnExt", */ },
	0x08ca: { /* n:"MkrExt", */ },
	0x08cb: { /* n:"CrtCoopt", */ },
	0x08d6: { /* n:"FRTArchId$", */ r:12 },
	
	0x7262: {}
	};
	
	function write_biff_rec(ba, type, payload, length) {
		var t = type;
		if(isNaN(t)) return;
		var len = length || (payload||[]).length || 0;
		var o = ba.next(4);
		o.write_shift(2, t);
		o.write_shift(2, len);
		if(len > 0 && is_buf(payload)) ba.push(payload);
	}
	
	function write_biff_continue(ba, type, payload, length) {
		var len = length || (payload||[]).length || 0;
		if(len <= 8224) return write_biff_rec(ba, type, payload, len);
		var t = type;
		if(isNaN(t)) return;
		var parts = payload.parts || [], sidx = 0;
		var i = 0, w = 0;
		while(w + (parts[sidx] || 8224) <= 8224) { w+= (parts[sidx] || 8224); sidx++; }
		var o = ba.next(4);
		o.write_shift(2, t);
		o.write_shift(2, w);
		ba.push(payload.slice(i, i + w));
		i += w;
		while(i < len) {
			o = ba.next(4);
			o.write_shift(2, 0x3c); // TODO: figure out correct continue type
			w = 0;
			while(w + (parts[sidx] || 8224) <= 8224) { w+= (parts[sidx] || 8224); sidx++; }
			o.write_shift(2, w);
			ba.push(payload.slice(i, i+w)); i+= w;
		}
	}
	
	function write_BIFF2Cell(out, r, c) {
		if(!out) out = new_buf(7);
		out.write_shift(2, r);
		out.write_shift(2, c);
		out.write_shift(2, 0);
		out.write_shift(1, 0);
		return out;
	}
	
	function write_BIFF2BERR(r, c, val, t) {
		var out = new_buf(9);
		write_BIFF2Cell(out, r, c);
		write_Bes(val, t || 'b', out);
		return out;
	}
	
	/* TODO: codepage, large strings */
	function write_BIFF2LABEL(r, c, val) {
		var out = new_buf(8 + 2*val.length);
		write_BIFF2Cell(out, r, c);
		out.write_shift(1, val.length);
		out.write_shift(val.length, val, 'sbcs');
		return out.l < out.length ? out.slice(0, out.l) : out;
	}
	
	function write_ws_biff2_cell(ba, cell, R, C) {
		if(cell.v != null) switch(cell.t) {
			case 'd': case 'n':
				var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
				if((v == (v|0)) && (v >= 0) && (v < 65536))
					write_biff_rec(ba, 0x0002, write_BIFF2INT(R, C, v));
				else
					write_biff_rec(ba, 0x0003, write_BIFF2NUM(R,C, v));
				return;
			case 'b': case 'e': write_biff_rec(ba, 0x0005, write_BIFF2BERR(R, C, cell.v, cell.t)); return;
			/* TODO: codepage, sst */
			case 's': case 'str':
				write_biff_rec(ba, 0x0004, write_BIFF2LABEL(R, C, (cell.v||"").slice(0,255)));
				return;
		}
		write_biff_rec(ba, 0x0001, write_BIFF2Cell(null, R, C));
	}
	
	function write_ws_biff2(ba, ws, idx, opts) {
		var dense = Array.isArray(ws);
		var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
		if(range.e.c > 0xFF || range.e.r > 0x3FFF) {
			if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
			range.e.c = Math.min(range.e.c, 0xFF);
			range.e.r = Math.min(range.e.c, 0x3FFF);
			ref = encode_range(range);
		}
		for(var R = range.s.r; R <= range.e.r; ++R) {
			rr = encode_row(R);
			for(var C = range.s.c; C <= range.e.c; ++C) {
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) continue;
				/* write cell */
				write_ws_biff2_cell(ba, cell, R, C, opts);
			}
		}
	}
	
	/* Based on test files */
	function write_biff2_buf(wb, opts) {
		var o = opts || {};
		if(DENSE != null && o.dense == null) o.dense = DENSE;
		var ba = buf_array();
		var idx = 0;
		for(var i=0;i<wb.SheetNames.length;++i) if(wb.SheetNames[i] == o.sheet) idx=i;
		if(idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
		write_biff_rec(ba, (o.biff == 4 ? 0x0409 : (o.biff == 3 ? 0x0209 : 0x0009)), write_BOF(wb, 0x10, o));
		/* ... */
		write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
		/* ... */
		write_biff_rec(ba, 0x000A);
		return ba.end();
	}
	
	function write_FONTS_biff8(ba, data, opts) {
		write_biff_rec(ba, 0x0031 /* Font */, write_Font({
			sz:12,
			color: {theme:1},
			name: "Arial",
			family: 2,
			scheme: "minor"
		}, opts));
	}
	
	
	function write_FMTS_biff8(ba, NF, opts) {
		if(!NF) return;
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
	for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_biff_rec(ba, 0x041E /* Format */, write_Format(i, NF[i], opts));
		});
	}
	
	function write_FEAT(ba, ws) {
		/* [MS-XLS] 2.4.112 */
		var o = new_buf(19);
		o.write_shift(4, 0x867); o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(2, 3); o.write_shift(1, 1); o.write_shift(4, 0);
		write_biff_rec(ba, 0x0867 /* FeatHdr */, o);
		/* [MS-XLS] 2.4.111 */
		o = new_buf(39);
		o.write_shift(4, 0x868); o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(2, 3); o.write_shift(1, 0); o.write_shift(4, 0);
		o.write_shift(2, 1); o.write_shift(4, 4); o.write_shift(2, 0);
		write_Ref8U(safe_decode_range(ws['!ref']||"A1"), o);
		o.write_shift(4, 4);
		write_biff_rec(ba, 0x0868 /* Feat */, o);
	}
	
	function write_CELLXFS_biff8(ba, opts) {
		for(var i = 0; i < 16; ++i) write_biff_rec(ba, 0x00e0 /* XF */, write_XF({numFmtId:0, style:true}, 0, opts));
		opts.cellXfs.forEach(function(c) {
			write_biff_rec(ba, 0x00e0 /* XF */, write_XF(c, 0, opts));
		});
	}
	
	function write_ws_biff8_hlinks(ba, ws) {
		for(var R=0; R<ws['!links'].length; ++R) {
			var HL = ws['!links'][R];
			write_biff_rec(ba, 0x01b8 /* HLink */, write_HLink(HL));
			if(HL[1].Tooltip) write_biff_rec(ba, 0x0800 /* HLinkTooltip */, write_HLinkTooltip(HL));
		}
		delete ws['!links'];
	}
	
	function write_ws_cols_biff8(ba, cols) {
		if(!cols) return;
		var cnt = 0;
		cols.forEach(function(col, idx) {
			if(++cnt <= 256 && col) {
				write_biff_rec(ba, 0x007d /* ColInfo */, write_ColInfo(col_obj_w(idx, col), idx));
			}
		});
	}
	
	function write_ws_biff8_cell(ba, cell, R, C, opts) {
		var os = 16 + get_cell_style(opts.cellXfs, cell, opts);
		if(cell.v == null && !cell.bf) {
			write_biff_rec(ba, 0x0201 /* Blank */, write_XLSCell(R, C, os));
			return;
		}
		if(cell.bf) write_biff_rec(ba, 0x0006 /* Formula */, write_Formula(cell, R, C, opts, os));
		else switch(cell.t) {
			case 'd': case 'n':
				var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
				/* TODO: emit RK as appropriate */
				write_biff_rec(ba, 0x0203 /* Number */, write_Number(R, C, v, os, opts));
				break;
			case 'b': case 'e':
				write_biff_rec(ba, 0x0205 /* BoolErr */, write_BoolErr(R, C, cell.v, os, opts, cell.t));
				break;
			/* TODO: codepage, sst */
			case 's': case 'str':
				if(opts.bookSST) {
					var isst = get_sst_id(opts.Strings, cell.v, opts.revStrings);
					write_biff_rec(ba, 0x00fd /* LabelSst */, write_LabelSst(R, C, isst, os, opts));
				} else write_biff_rec(ba, 0x0204 /* Label */, write_Label(R, C, (cell.v||"").slice(0,255), os, opts));
				break;
			default:
				write_biff_rec(ba, 0x0201 /* Blank */, write_XLSCell(R, C, os));
		}
	}
	
	/* [MS-XLS] 2.1.7.20.5 */
	function write_ws_biff8(idx, opts, wb) {
		var ba = buf_array();
		var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
		var _WB = ((wb||{}).Workbook||{});
		var _sheet = ((_WB.Sheets||[])[idx]||{});
		var dense = Array.isArray(ws);
		var b8 = opts.biff == 8;
		var ref, rr = "", cols = [];
		var range = safe_decode_range(ws['!ref'] || "A1");
		var MAX_ROWS = b8 ? 65536 : 16384;
		if(range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
			if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
			range.e.c = Math.min(range.e.c, 0xFF);
			range.e.r = Math.min(range.e.c, MAX_ROWS-1);
		}
	
		write_biff_rec(ba, 0x0809, write_BOF(wb, 0x10, opts));
		/* [Uncalced] Index */
		write_biff_rec(ba, 0x000d /* CalcMode */, writeuint16(1));
		write_biff_rec(ba, 0x000c /* CalcCount */, writeuint16(100));
		write_biff_rec(ba, 0x000f /* CalcRefMode */, writebool(true));
		write_biff_rec(ba, 0x0011 /* CalcIter */, writebool(false));
		write_biff_rec(ba, 0x0010 /* CalcDelta */, write_Xnum(0.001));
		write_biff_rec(ba, 0x005f /* CalcSaveRecalc */, writebool(true));
		write_biff_rec(ba, 0x002a /* PrintRowCol */, writebool(false));
		write_biff_rec(ba, 0x002b /* PrintGrid */, writebool(false));
		write_biff_rec(ba, 0x0082 /* GridSet */, writeuint16(1));
		write_biff_rec(ba, 0x0080 /* Guts */, write_Guts([0,0]));
		/* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */
		/* Header (string) */
		/* Footer (string) */
		write_biff_rec(ba, 0x0083 /* HCenter */, writebool(false));
		write_biff_rec(ba, 0x0084 /* VCenter */, writebool(false));
		/* ... */
		if(b8) write_ws_cols_biff8(ba, ws["!cols"]);
		/* ... */
		write_biff_rec(ba, 0x200, write_Dimensions(range, opts));
		/* ... */
	
		if(b8) ws['!links'] = [];
		for(var R = range.s.r; R <= range.e.r; ++R) {
			rr = encode_row(R);
			for(var C = range.s.c; C <= range.e.c; ++C) {
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) continue;
				/* write cell */
				write_ws_biff8_cell(ba, cell, R, C, opts);
				if(b8 && cell.l) ws['!links'].push([ref, cell.l]);
			}
		}
		var cname = _sheet.CodeName || _sheet.name || s;
		/* ... */
		if(b8) write_biff_rec(ba, 0x023e /* Window2 */, write_Window2((_WB.Views||[])[0]));
		/* ... */
		if(b8 && (ws['!merges']||[]).length) write_biff_rec(ba, 0x00e5 /* MergeCells */, write_MergeCells(ws['!merges']));
		/* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */
		if(b8) write_ws_biff8_hlinks(ba, ws);
		/* [DVAL] */
		write_biff_rec(ba, 0x01ba /* CodeName */, write_XLUnicodeString(cname, opts));
		/* *WebPub *CellWatch [SheetExt] */
		if(b8) write_FEAT(ba, ws);
		/* *FEAT11 *RECORD12 */
		write_biff_rec(ba, 0x000a /* EOF */);
		return ba.end();
	}
	
	/* [MS-XLS] 2.1.7.20.3 */
	function write_biff8_global(wb, bufs, opts) {
		var A = buf_array();
		var _WB = ((wb||{}).Workbook||{});
		var _sheets = (_WB.Sheets||[]);
		var _wb = _WB.WBProps||{};
		var b8 = opts.biff == 8, b5 = opts.biff == 5;
		write_biff_rec(A, 0x0809, write_BOF(wb, 0x05, opts));
		if(opts.bookType == "xla") write_biff_rec(A, 0x0087 /* Addin */);
		write_biff_rec(A, 0x00e1 /* InterfaceHdr */, b8 ? writeuint16(0x04b0) : null);
		write_biff_rec(A, 0x00c1 /* Mms */, writezeroes(2));
		if(b5) write_biff_rec(A, 0x00bf /* ToolbarHdr */);
		if(b5) write_biff_rec(A, 0x00c0 /* ToolbarEnd */);
		write_biff_rec(A, 0x00e2 /* InterfaceEnd */);
		write_biff_rec(A, 0x005c /* WriteAccess */, write_WriteAccess("SheetJS", opts));
		/* [FileSharing] */
		write_biff_rec(A, 0x0042 /* CodePage */, writeuint16(b8 ? 0x04b0 : 0x04E4));
		/* *2047 Lel */
		if(b8) write_biff_rec(A, 0x0161 /* DSF */, writeuint16(0));
		if(b8) write_biff_rec(A, 0x01c0 /* Excel9File */);
		write_biff_rec(A, 0x013d /* RRTabId */, write_RRTabId(wb.SheetNames.length));
		if(b8 && wb.vbaraw) write_biff_rec(A, 0x00d3 /* ObProj */);
		/* [ObNoMacros] */
		if(b8 && wb.vbaraw) {
			var cname = _wb.CodeName || "ThisWorkbook";
			write_biff_rec(A, 0x01ba /* CodeName */, write_XLUnicodeString(cname, opts));
		}
		write_biff_rec(A, 0x009c /* BuiltInFnGroupCount */, writeuint16(0x11));
		/* *FnGroupName *FnGrp12 */
		/* *Lbl */
		/* [OleObjectSize] */
		write_biff_rec(A, 0x0019 /* WinProtect */, writebool(false));
		write_biff_rec(A, 0x0012 /* Protect */, writebool(false));
		write_biff_rec(A, 0x0013 /* Password */, writeuint16(0));
		if(b8) write_biff_rec(A, 0x01af /* Prot4Rev */, writebool(false));
		if(b8) write_biff_rec(A, 0x01bc /* Prot4RevPass */, writeuint16(0));
		write_biff_rec(A, 0x003d /* Window1 */, write_Window1(opts));
		write_biff_rec(A, 0x0040 /* Backup */, writebool(false));
		write_biff_rec(A, 0x008d /* HideObj */, writeuint16(0));
		write_biff_rec(A, 0x0022 /* Date1904 */, writebool(safe1904(wb)=="true"));
		write_biff_rec(A, 0x000e /* CalcPrecision */, writebool(true));
		if(b8) write_biff_rec(A, 0x01b7 /* RefreshAll */, writebool(false));
		write_biff_rec(A, 0x00DA /* BookBool */, writeuint16(0));
		/* ... */
		write_FONTS_biff8(A, wb, opts);
		write_FMTS_biff8(A, wb.SSF, opts);
		write_CELLXFS_biff8(A, opts);
		/* ... */
		if(b8) write_biff_rec(A, 0x0160 /* UsesELFs */, writebool(false));
		var a = A.end();
	
		var C = buf_array();
		/* METADATA [MTRSettings] [ForceFullCalculation] */
		if(b8) write_biff_rec(C, 0x008C, write_Country());
		/* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture *MSODRAWINGGROUP */
	
		/* BIFF8: [SST *Continue] ExtSST */
		if(b8 && opts.Strings) write_biff_continue(C, 0x00FC, write_SST(opts.Strings, opts));
	
		/* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */
		write_biff_rec(C, 0x000A /* EOF */);
		var c = C.end();
	
		var B = buf_array();
		var blen = 0, j = 0;
		for(j = 0; j < wb.SheetNames.length; ++j) blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
		var start = a.length + blen + c.length;
		for(j = 0; j < wb.SheetNames.length; ++j) {
			var _sheet = _sheets[j] || ({});
			write_biff_rec(B, 0x0085 /* BoundSheet8 */, write_BoundSheet8({pos:start, hs:_sheet.Hidden||0, dt:0, name:wb.SheetNames[j]}, opts));
			start += bufs[j].length;
		}
		/* 1*BoundSheet8 */
		var b = B.end();
		if(blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
	
		var out = [];
		if(a.length) out.push(a);
		if(b.length) out.push(b);
		if(c.length) out.push(c);
		return bconcat(out);
	}
	
	/* [MS-XLS] 2.1.7.20 Workbook Stream */
	function write_biff8_buf(wb, opts) {
		var o = opts || {};
		var bufs = [];
	
		if(wb && !wb.SSF) {
			wb.SSF = dup(table_fmt);
		}
		if(wb && wb.SSF) {
			make_ssf(); SSF_load_table(wb.SSF);
			// $FlowIgnore
			o.revssf = evert_num(wb.SSF); o.revssf[wb.SSF[65535]] = 0;
			o.ssf = wb.SSF;
		}
	
		o.Strings = []; o.Strings.Count = 0; o.Strings.Unique = 0;
		fix_write_opts(o);
	
		o.cellXfs = [];
		get_cell_style(o.cellXfs, {}, {revssf:{"General":0}});
	
		if(!wb.Props) wb.Props = {};
	
		for(var i = 0; i < wb.SheetNames.length; ++i) bufs[bufs.length] = write_ws_biff8(i, o, wb);
		bufs.unshift(write_biff8_global(wb, bufs, o));
		return bconcat(bufs);
	}
	
	function write_biff_buf(wb, opts) {
		for(var i = 0; i <= wb.SheetNames.length; ++i) {
			var ws = wb.Sheets[wb.SheetNames[i]];
			if(!ws || !ws["!ref"]) continue;
			var range = decode_range(ws["!ref"]);
			if(range.e.c > 255) { // note: 255 is IV
			if(typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
			}
		}
	
		var o = opts || {};
		switch(o.biff || 2) {
			case 8: case 5: return write_biff8_buf(wb, opts);
			case 4: case 3: case 2: return write_biff2_buf(wb, opts);
		}
		throw new Error("invalid type " + o.bookType + " for BIFF");
	}
	/* note: browser DOM element cannot see mso- style attrs, must parse */
	function html_to_sheet(str, _opts) {
		var opts = _opts || {};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var ws = opts.dense ? ([]) : ({});
		str = str.replace(/<!--.*?-->/g, "");
		var mtch = str.match(/<table/i);
		if(!mtch) throw new Error("Invalid HTML: could not find <table>");
		var mtch2 = str.match(/<\/table/i);
		var i = mtch.index, j = mtch2 && mtch2.index || str.length;
		var rows = split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
		var R = -1, C = 0, RS = 0, CS = 0;
		var range = {s:{r:10000000, c:10000000},e:{r:0,c:0}};
		var merges = [];
		for(i = 0; i < rows.length; ++i) {
			var row = rows[i].trim();
			var hd = row.slice(0,3).toLowerCase();
			if(hd == "<tr") { ++R; if(opts.sheetRows && opts.sheetRows <= R) { --R; break; } C = 0; continue; }
			if(hd != "<td" && hd != "<th") continue;
			var cells = row.split(/<\/t[dh]>/i);
			for(j = 0; j < cells.length; ++j) {
				var cell = cells[j].trim();
				if(!cell.match(/<t[dh]/i)) continue;
				var m = cell, cc = 0;
				/* TODO: parse styles etc */
				while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1) m = m.slice(cc+1);
				for(var midx = 0; midx < merges.length; ++midx) {
					var _merge = merges[midx];
					if(_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) { C = _merge.e.c + 1; midx = -1; }
				}
				var tag = parsexmltag(cell.slice(0, cell.indexOf(">")));
				CS = tag.colspan ? +tag.colspan : 1;
				if((RS = +tag.rowspan)>1 || CS>1) merges.push({s:{r:R,c:C},e:{r:R + (RS||1) - 1, c:C + CS - 1}});
				var _t = tag.t || tag["data-t"] || "";
				/* TODO: generate stub cells */
				if(!m.length) { C += CS; continue; }
				m = htmldecode(m);
				if(range.s.r > R) range.s.r = R; if(range.e.r < R) range.e.r = R;
				if(range.s.c > C) range.s.c = C; if(range.e.c < C) range.e.c = C;
				if(!m.length) { C += CS; continue; }
				var o = {t:'s', v:m};
				if(opts.raw || !m.trim().length || _t == 's'){}
				else if(m === 'TRUE') o = {t:'b', v:true};
				else if(m === 'FALSE') o = {t:'b', v:false};
				else if(!isNaN(fuzzynum(m))) o = {t:'n', v:fuzzynum(m)};
				else if(!isNaN(fuzzydate(m).getDate())) {
					o = ({t:'d', v:parseDate(m)});
					if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
					o.z = opts.dateNF || table_fmt[14];
				}
				if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = o; }
				else ws[encode_cell({r:R, c:C})] = o;
				C += CS;
			}
		}
		ws['!ref'] = encode_range(range);
		if(merges.length) ws["!merges"] = merges;
		return ws;
	}
	function make_html_row(ws, r, R, o) {
		var M = (ws['!merges'] ||[]);
		var oo = [];
		for(var C = r.s.c; C <= r.e.c; ++C) {
			var RS = 0, CS = 0;
			for(var j = 0; j < M.length; ++j) {
				if(M[j].s.r > R || M[j].s.c > C) continue;
				if(M[j].e.r < R || M[j].e.c < C) continue;
				if(M[j].s.r < R || M[j].s.c < C) { RS = -1; break; }
				RS = M[j].e.r - M[j].s.r + 1; CS = M[j].e.c - M[j].s.c + 1; break;
			}
			if(RS < 0) continue;
			var coord = encode_cell({r:R,c:C});
			var cell = o.dense ? (ws[R]||[])[C] : ws[coord];
			/* TODO: html entities */
			var w = (cell && cell.v != null) && (cell.h || escapehtml(cell.w || (format_cell(cell), cell.w) || "")) || "";
			var sp = ({});
			if(RS > 1) sp.rowspan = RS;
			if(CS > 1) sp.colspan = CS;
			if(o.editable) w = '<span contenteditable="true">' + w + '</span>';
			else if(cell) {
				sp["data-t"] = cell && cell.t || 'z';
				if(cell.v != null) sp["data-v"] = cell.v;
				if(cell.z != null) sp["data-z"] = cell.z;
				if(cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + cell.l.Target +'">' + w + '</a>';
			}
			sp.id = (o.id || "sjs") + "-" + coord;
			oo.push(writextag('td', w, sp));
		}
		var preamble = "<tr>";
		return preamble + oo.join("") + "</tr>";
	}
	
	var HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
	var HTML_END = '</body></html>';
	
	function html_to_workbook(str, opts) {
		var mtch = str.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
		if(!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
		if(mtch.length == 1) return sheet_to_workbook(html_to_sheet(mtch[0], opts), opts);
		var wb = book_new();
		mtch.forEach(function(s, idx) { book_append_sheet(wb, html_to_sheet(s, opts), "Sheet" + (idx+1)); });
		return wb;
	}
	
	function make_html_preamble(ws, R, o) {
		var out = [];
		return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
	}
	
	function sheet_to_html(ws, opts/*, wb:?Workbook*/) {
		var o = opts || {};
		var header = o.header != null ? o.header : HTML_BEGIN;
		var footer = o.footer != null ? o.footer : HTML_END;
		var out = [header];
		var r = decode_range(ws['!ref']);
		o.dense = Array.isArray(ws);
		out.push(make_html_preamble(ws, r, o));
		for(var R = r.s.r; R <= r.e.r; ++R) out.push(make_html_row(ws, r, R, o));
		out.push("</table>" + footer);
		return out.join("");
	}
	
	function sheet_add_dom(ws, table, _opts) {
		var opts = _opts || {};
		if(DENSE != null) opts.dense = DENSE;
		var or_R = 0, or_C = 0;
		if(opts.origin != null) {
			if(typeof opts.origin == 'number') or_R = opts.origin;
			else {
				var _origin = typeof opts.origin == "string" ? decode_cell(opts.origin) : opts.origin;
				or_R = _origin.r; or_C = _origin.c;
			}
		}
	
		var rows = table.getElementsByTagName('tr');
		var sheetRows = Math.min(opts.sheetRows||10000000, rows.length);
		var range = {s:{r:0,c:0},e:{r:or_R,c:or_C}};
		if(ws["!ref"]) {
			var _range = decode_range(ws["!ref"]);
			range.s.r = Math.min(range.s.r, _range.s.r);
			range.s.c = Math.min(range.s.c, _range.s.c);
			range.e.r = Math.max(range.e.r, _range.e.r);
			range.e.c = Math.max(range.e.c, _range.e.c);
			if(or_R == -1) range.e.r = or_R = _range.e.r + 1;
		}
		var merges = [], midx = 0;
		var rowinfo = ws["!rows"] || (ws["!rows"] = []);
		var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
		if(!ws["!cols"]) ws['!cols'] = [];
		for(; _R < rows.length && R < sheetRows; ++_R) {
			var row = rows[_R];
			if (is_dom_element_hidden(row)) {
				if (opts.display) continue;
				rowinfo[R] = {hidden: true};
			}
			var elts = (row.children);
			for(_C = C = 0; _C < elts.length; ++_C) {
				var elt = elts[_C];
				if (opts.display && is_dom_element_hidden(elt)) continue;
				var v = elt.hasAttribute('data-v') ? elt.getAttribute('data-v') : elt.hasAttribute('v') ? elt.getAttribute('v') : htmldecode(elt.innerHTML);
				var z = elt.getAttribute('data-z') || elt.getAttribute('z');
				for(midx = 0; midx < merges.length; ++midx) {
					var m = merges[midx];
					if(m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) { C = m.e.c+1 - or_C; midx = -1; }
				}
				/* TODO: figure out how to extract nonstandard mso- style */
				CS = +elt.getAttribute("colspan") || 1;
				if( ((RS = (+elt.getAttribute("rowspan") || 1)))>1 || CS>1) merges.push({s:{r:R + or_R,c:C + or_C},e:{r:R + or_R + (RS||1) - 1, c:C + or_C + (CS||1) - 1}});
				var o = {t:'s', v:v};
				var _t = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
				if(v != null) {
					if(v.length == 0) o.t = _t || 'z';
					else if(opts.raw || v.trim().length == 0 || _t == "s"){}
					else if(v === 'TRUE') o = {t:'b', v:true};
					else if(v === 'FALSE') o = {t:'b', v:false};
					else if(!isNaN(fuzzynum(v))) o = {t:'n', v:fuzzynum(v)};
					else if(!isNaN(fuzzydate(v).getDate())) {
						o = ({t:'d', v:parseDate(v)});
						if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
						o.z = opts.dateNF || table_fmt[14];
					}
				}
				if(o.z === undefined && z != null) o.z = z;
				/* The first link is used.  Links are assumed to be fully specified.
				 * TODO: The right way to process relative links is to make a new <a> */
				var l = "", Aelts = elt.getElementsByTagName("A");
				if(Aelts && Aelts.length) for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)	if(Aelts[Aelti].hasAttribute("href")) {
					l = Aelts[Aelti].getAttribute("href"); if(l.charAt(0) != "#") break;
				}
				if(l && l.charAt(0) != "#") o.l = ({ Target: l });
				if(opts.dense) { if(!ws[R + or_R]) ws[R + or_R] = []; ws[R + or_R][C + or_C] = o; }
				else ws[encode_cell({c:C + or_C, r:R + or_R})] = o;
				if(range.e.c < C + or_C) range.e.c = C + or_C;
				C += CS;
			}
			++R;
		}
		if(merges.length) ws['!merges'] = (ws["!merges"] || []).concat(merges);
		range.e.r = Math.max(range.e.r, R - 1 + or_R);
		ws['!ref'] = encode_range(range);
		if(R >= sheetRows) ws['!fullref'] = encode_range((range.e.r = rows.length-_R+R-1 + or_R,range)); // We can count the real number of rows to parse but we don't to improve the performance
		return ws;
	}
	
	function parse_dom_table(table, _opts) {
		var opts = _opts || {};
		var ws = opts.dense ? ([]) : ({});
		return sheet_add_dom(ws, table, _opts);
	}
	
	function table_to_book(table, opts) {
		return sheet_to_workbook(parse_dom_table(table, opts), opts);
	}
	
	function is_dom_element_hidden(element) {
		var display = '';
		var get_computed_style = get_get_computed_style_function(element);
		if(get_computed_style) display = get_computed_style(element).getPropertyValue('display');
		if(!display) display = element.style && element.style.display;
		return display === 'none';
	}
	
	/* global getComputedStyle */
	function get_get_computed_style_function(element) {
		// The proper getComputedStyle implementation is the one defined in the element window
		if(element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
		// If it is not available, try to get one from the global namespace
		if(typeof getComputedStyle === 'function') return getComputedStyle;
		return null;
	}
	/* OpenDocument */
	function parse_text_p(text) {
		/* 6.1.2 White Space Characters */
		var fixed = text
			.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ")
			.replace(/<text:s\/>/g," ")
			.replace(/<text:s text:c="(\d+)"\/>/g, function($$,$1) { return Array(parseInt($1,10)+1).join(" "); })
			.replace(/<text:tab[^>]*\/>/g,"\t")
			.replace(/<text:line-break\/>/g,"\n");
		var v = unescapexml(fixed.replace(/<[^>]*>/g,""));
	
		return [v];
	}
	
	var number_formats_ods = {
		/* ods name: [short ssf fmt, long ssf fmt] */
		day:           ["d",   "dd"],
		month:         ["m",   "mm"],
		year:          ["y",   "yy"],
		hours:         ["h",   "hh"],
		minutes:       ["m",   "mm"],
		seconds:       ["s",   "ss"],
		"am-pm":       ["A/P", "AM/PM"],
		"day-of-week": ["ddd", "dddd"],
		era:           ["e",   "ee"],
		/* there is no native representation of LO "Q" format */
		quarter:       ["\\Qm", "m\\\"th quarter\""]
	};
	
	
	function parse_content_xml(d, _opts) {
			var opts = _opts || {};
			if(DENSE != null && opts.dense == null) opts.dense = DENSE;
			var str = xlml_normalize(d);
			var state = [], tmp;
			var tag;
			var NFtag = {name:""}, NF = "", pidx = 0;
			var sheetag;
			var rowtag;
			var Sheets = {}, SheetNames = [];
			var ws = opts.dense ? ([]) : ({});
			var Rn, q;
			var ctag = ({value:""});
			var textp = "", textpidx = 0, textptag;
			var textR = [];
			var R = -1, C = -1, range = {s: {r:1000000,c:10000000}, e: {r:0, c:0}};
			var row_ol = 0;
			var number_format_map = {};
			var merges = [], mrange = {}, mR = 0, mC = 0;
			var rowinfo = [], rowpeat = 1, colpeat = 1;
			var arrayf = [];
			var WB = {Names:[]};
			var atag = ({});
			var _Ref = ["", ""];
			var comments = [], comment = ({});
			var creator = "", creatoridx = 0;
			var isstub = false, intable = false;
			var i = 0;
			xlmlregex.lastIndex = 0;
			str = str.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
			while((Rn = xlmlregex.exec(str))) switch((Rn[3]=Rn[3].replace(/_.*$/,""))) {
	
				case 'table': case '工作表': // 9.1.2 <table:table>
					if(Rn[1]==='/') {
						if(range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = encode_range(range);
						else ws['!ref'] = "A1:A1";
						if(opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
							ws['!fullref'] = ws['!ref'];
							range.e.r = opts.sheetRows - 1;
							ws['!ref'] = encode_range(range);
						}
						if(merges.length) ws['!merges'] = merges;
						if(rowinfo.length) ws["!rows"] = rowinfo;
						sheetag.name = sheetag['名称'] || sheetag.name;
						if(typeof JSON !== 'undefined') JSON.stringify(sheetag);
						SheetNames.push(sheetag.name);
						Sheets[sheetag.name] = ws;
						intable = false;
					}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
						sheetag = parsexmltag(Rn[0], false);
						R = C = -1;
						range.s.r = range.s.c = 10000000; range.e.r = range.e.c = 0;
						ws = opts.dense ? ([]) : ({}); merges = [];
						rowinfo = [];
						intable = true;
					}
					break;
	
				case 'table-row-group': // 9.1.9 <table:table-row-group>
					if(Rn[1] === "/") --row_ol; else ++row_ol;
					break;
				case 'table-row': case '行': // 9.1.3 <table:table-row>
					if(Rn[1] === '/') { R+=rowpeat; rowpeat = 1; break; }
					rowtag = parsexmltag(Rn[0], false);
					if(rowtag['行号']) R = rowtag['行号'] - 1; else if(R == -1) R = 0;
					rowpeat = +rowtag['number-rows-repeated'] || 1;
					/* TODO: remove magic */
					if(rowpeat < 10) for(i = 0; i < rowpeat; ++i) if(row_ol > 0) rowinfo[R + i] = {level: row_ol};
					C = -1; break;
				case 'covered-table-cell': // 9.1.5 <table:covered-table-cell>
					if(Rn[1] !== '/') ++C;
					if(opts.sheetStubs) {
						if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = {t:'z'}; }
						else ws[encode_cell({r:R,c:C})] = {t:'z'};
					}
					textp = ""; textR = [];
					break; /* stub */
				case 'table-cell': case '数据':
					if(Rn[0].charAt(Rn[0].length-2) === '/') {
						++C;
						ctag = parsexmltag(Rn[0], false);
						colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
						q = ({t:'z', v:null});
						if(ctag.formula && opts.cellFormula != false) q.f = ods_to_csf_formula(unescapexml(ctag.formula));
						if((ctag['数据类型'] || ctag['value-type']) == "string") {
							q.t = "s"; q.v = unescapexml(ctag['string-value'] || "");
							if(opts.dense) {
								if(!ws[R]) ws[R] = [];
								ws[R][C] = q;
							} else {
								ws[encode_cell({r:R,c:C})] = q;
							}
						}
						C+= colpeat-1;
					} else if(Rn[1]!=='/') {
						++C;
						textp = ""; textpidx = 0; textR = [];
						colpeat = 1;
						var rptR = rowpeat ? R + rowpeat - 1 : R;
						if(C > range.e.c) range.e.c = C;
						if(C < range.s.c) range.s.c = C;
						if(R < range.s.r) range.s.r = R;
						if(rptR > range.e.r) range.e.r = rptR;
						ctag = parsexmltag(Rn[0], false);
						comments = []; comment = ({});
						q = ({t:ctag['数据类型'] || ctag['value-type'], v:null});
						if(opts.cellFormula) {
							if(ctag.formula) ctag.formula = unescapexml(ctag.formula);
							if(ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
								mR = parseInt(ctag['number-matrix-rows-spanned'],10) || 0;
								mC = parseInt(ctag['number-matrix-columns-spanned'],10) || 0;
								mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
								q.F = encode_range(mrange);
								arrayf.push([mrange, q.F]);
							}
							if(ctag.formula) q.f = ods_to_csf_formula(ctag.formula);
							else for(i = 0; i < arrayf.length; ++i)
								if(R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r)
									if(C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c)
										q.F = arrayf[i][1];
						}
						if(ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
							mR = parseInt(ctag['number-rows-spanned'],10) || 0;
							mC = parseInt(ctag['number-columns-spanned'],10) || 0;
							mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
							merges.push(mrange);
						}
	
						/* 19.675.2 table:number-columns-repeated */
						if(ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);
	
						/* 19.385 office:value-type */
						switch(q.t) {
							case 'boolean': q.t = 'b'; q.v = parsexmlbool(ctag['boolean-value']); break;
							case 'float': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'percentage': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'currency': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'date': q.t = 'd'; q.v = parseDate(ctag['date-value']);
								if(!opts.cellDates) { q.t = 'n'; q.v = datenum(q.v); }
								q.z = 'm/d/yy'; break;
							case 'time': q.t = 'n'; q.v = parse_isodur(ctag['time-value'])/86400;
								if(opts.cellDates) { q.t = 'd'; q.v = numdate(q.v); }
								q.z = 'HH:MM:SS'; break;
							case 'number': q.t = 'n'; q.v = parseFloat(ctag['数据数值']); break;
							default:
								if(q.t === 'string' || q.t === 'text' || !q.t) {
									q.t = 's';
									if(ctag['string-value'] != null) { textp = unescapexml(ctag['string-value']); textR = []; }
								} else throw new Error('Unsupported value type ' + q.t);
						}
					} else {
						isstub = false;
						if(q.t === 's') {
							q.v = textp || '';
							if(textR.length) q.R = textR;
							isstub = textpidx == 0;
						}
						if(atag.Target) q.l = atag;
						if(comments.length > 0) { q.c = comments; comments = []; }
						if(textp && opts.cellText !== false) q.w = textp;
						if(isstub) { q.t = "z"; delete q.v; }
						if(!isstub || opts.sheetStubs) {
							if(!(opts.sheetRows && opts.sheetRows <= R)) {
								for(var rpt = 0; rpt < rowpeat; ++rpt) {
									colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
									if(opts.dense) {
										if(!ws[R + rpt]) ws[R + rpt] = [];
										ws[R + rpt][C] = rpt == 0 ? q : dup(q);
										while(--colpeat > 0) ws[R + rpt][C + colpeat] = dup(q);
									} else {
										ws[encode_cell({r:R + rpt,c:C})] = q;
										while(--colpeat > 0) ws[encode_cell({r:R + rpt,c:C + colpeat})] = dup(q);
									}
									if(range.e.c <= C) range.e.c = C;
								}
							}
						}
						colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
						C += colpeat-1; colpeat = 0;
						q = {};
						textp = ""; textR = [];
					}
					atag = ({});
					break; // 9.1.4 <table:table-cell>
	
				/* pure state */
				case 'document': // TODO: <office:document> is the root for FODS
				case 'document-content': case '电子表格文档': // 3.1.3.2 <office:document-content>
				case 'spreadsheet': case '主体': // 3.7 <office:spreadsheet>
				case 'scripts': // 3.12 <office:scripts>
				case 'styles': // TODO <office:styles>
				case 'font-face-decls': // 3.14 <office:font-face-decls>
				case 'master-styles': // 3.15.4 <office:master-styles> -- relevant for FODS
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
					break;
	
				case 'annotation': // 14.1 <office:annotation>
					if(Rn[1]==='/'){
						if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
						comment.t = textp;
						if(textR.length) comment.R = textR;
						comment.a = creator;
						comments.push(comment);
					}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') {state.push([Rn[3], false]);}
					creator = ""; creatoridx = 0;
					textp = ""; textpidx = 0; textR = [];
					break;
	
				case 'creator': // 4.3.2.7 <dc:creator>
					if(Rn[1]==='/') { creator = str.slice(creatoridx,Rn.index); }
					else creatoridx = Rn.index + Rn[0].length;
					break;
	
				/* ignore state */
				case 'meta': case '元数据': // TODO: <office:meta> <uof:元数据> FODS/UOF
				case 'settings': // TODO: <office:settings>
				case 'config-item-set': // TODO: <office:config-item-set>
				case 'config-item-map-indexed': // TODO: <office:config-item-map-indexed>
				case 'config-item-map-entry': // TODO: <office:config-item-map-entry>
				case 'config-item-map-named': // TODO: <office:config-item-map-entry>
				case 'shapes': // 9.2.8 <table:shapes>
				case 'frame': // 10.4.2 <draw:frame>
				case 'text-box': // 10.4.3 <draw:text-box>
				case 'image': // 10.4.4 <draw:image>
				case 'data-pilot-tables': // 9.6.2 <table:data-pilot-tables>
				case 'list-style': // 16.30 <text:list-style>
				case 'form': // 13.13 <form:form>
				case 'dde-links': // 9.8 <table:dde-links>
				case 'event-listeners': // TODO
				case 'chart': // TODO
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], false]);
					textp = ""; textpidx = 0; textR = [];
					break;
	
				case 'scientific-number': // TODO: <number:scientific-number>
					break;
				case 'currency-symbol': // TODO: <number:currency-symbol>
					break;
				case 'currency-style': // TODO: <number:currency-style>
					break;
				case 'number-style': // 16.27.2 <number:number-style>
				case 'percentage-style': // 16.27.9 <number:percentage-style>
				case 'date-style': // 16.27.10 <number:date-style>
				case 'time-style': // 16.27.18 <number:time-style>
					if(Rn[1]==='/'){
						number_format_map[NFtag.name] = NF;
						if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
					} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
						NF = "";
						NFtag = parsexmltag(Rn[0], false);
						state.push([Rn[3], true]);
					} break;
	
				case 'script': break; // 3.13 <office:script>
				case 'libraries': break; // TODO: <ooo:libraries>
				case 'automatic-styles': break; // 3.15.3 <office:automatic-styles>
	
				case 'default-style': // TODO: <style:default-style>
				case 'page-layout': break; // TODO: <style:page-layout>
				case 'style': // 16.2 <style:style>
					break;
				case 'map': break; // 16.3 <style:map>
				case 'font-face': break; // 16.21 <style:font-face>
	
				case 'paragraph-properties': break; // 17.6 <style:paragraph-properties>
				case 'table-properties': break; // 17.15 <style:table-properties>
				case 'table-column-properties': break; // 17.16 <style:table-column-properties>
				case 'table-row-properties': break; // 17.17 <style:table-row-properties>
				case 'table-cell-properties': break; // 17.18 <style:table-cell-properties>
	
				case 'number': // 16.27.3 <number:number>
					switch(state[state.length-1][0]) {
						case 'time-style':
						case 'date-style':
							tag = parsexmltag(Rn[0], false);
							NF += number_formats_ods[Rn[3]][tag.style==='long'?1:0]; break;
					} break;
	
				case 'fraction': break; // TODO 16.27.6 <number:fraction>
	
				case 'day': // 16.27.11 <number:day>
				case 'month': // 16.27.12 <number:month>
				case 'year': // 16.27.13 <number:year>
				case 'era': // 16.27.14 <number:era>
				case 'day-of-week': // 16.27.15 <number:day-of-week>
				case 'week-of-year': // 16.27.16 <number:week-of-year>
				case 'quarter': // 16.27.17 <number:quarter>
				case 'hours': // 16.27.19 <number:hours>
				case 'minutes': // 16.27.20 <number:minutes>
				case 'seconds': // 16.27.21 <number:seconds>
				case 'am-pm': // 16.27.22 <number:am-pm>
					switch(state[state.length-1][0]) {
						case 'time-style':
						case 'date-style':
							tag = parsexmltag(Rn[0], false);
							NF += number_formats_ods[Rn[3]][tag.style==='long'?1:0]; break;
					} break;
	
				case 'boolean-style': break; // 16.27.23 <number:boolean-style>
				case 'boolean': break; // 16.27.24 <number:boolean>
				case 'text-style': break; // 16.27.25 <number:text-style>
				case 'text': // 16.27.26 <number:text>
					if(Rn[0].slice(-2) === "/>") break;
					else if(Rn[1]==="/") switch(state[state.length-1][0]) {
						case 'number-style':
						case 'date-style':
						case 'time-style':
							NF += str.slice(pidx, Rn.index);
							break;
					}
					else pidx = Rn.index + Rn[0].length;
					break;
	
				case 'named-range': // 9.4.12 <table:named-range>
					tag = parsexmltag(Rn[0], false);
					_Ref = ods_to_csf_3D(tag['cell-range-address']);
					var nrange = ({Name:tag.name, Ref:_Ref[0] + '!' + _Ref[1]});
					if(intable) nrange.Sheet = SheetNames.length;
					WB.Names.push(nrange);
					break;
	
				case 'text-content': break; // 16.27.27 <number:text-content>
				case 'text-properties': break; // 16.27.27 <style:text-properties>
				case 'embedded-text': break; // 16.27.4 <number:embedded-text>
	
				case 'body': case '电子表格': break; // 3.3 16.9.6 19.726.3
	
				case 'forms': break; // 12.25.2 13.2
				case 'table-column': break; // 9.1.6 <table:table-column>
				case 'table-header-rows': break; // 9.1.7 <table:table-header-rows>
				case 'table-rows': break; // 9.1.12 <table:table-rows>
				/* TODO: outline levels */
				case 'table-column-group': break; // 9.1.10 <table:table-column-group>
				case 'table-header-columns': break; // 9.1.11 <table:table-header-columns>
				case 'table-columns': break; // 9.1.12 <table:table-columns>
	
				case 'null-date': break; // 9.4.2 <table:null-date> TODO: date1904
	
				case 'graphic-properties': break; // 17.21 <style:graphic-properties>
				case 'calculation-settings': break; // 9.4.1 <table:calculation-settings>
				case 'named-expressions': break; // 9.4.11 <table:named-expressions>
				case 'label-range': break; // 9.4.9 <table:label-range>
				case 'label-ranges': break; // 9.4.10 <table:label-ranges>
				case 'named-expression': break; // 9.4.13 <table:named-expression>
				case 'sort': break; // 9.4.19 <table:sort>
				case 'sort-by': break; // 9.4.20 <table:sort-by>
				case 'sort-groups': break; // 9.4.22 <table:sort-groups>
	
				case 'tab': break; // 6.1.4 <text:tab>
				case 'line-break': break; // 6.1.5 <text:line-break>
				case 'span': break; // 6.1.7 <text:span>
				case 'p': case '文本串': // 5.1.3 <text:p>
					if(['master-styles'].indexOf(state[state.length-1][0]) > -1) break;
					if(Rn[1]==='/' && (!ctag || !ctag['string-value'])) {
						var ptp = parse_text_p(str.slice(textpidx,Rn.index), textptag);
						textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
					} else { textptag = parsexmltag(Rn[0], false); textpidx = Rn.index + Rn[0].length; }
					break; // <text:p>
				case 's': break; // <text:s>
	
				case 'database-range': // 9.4.15 <table:database-range>
					if(Rn[1]==='/') break;
					try {
						_Ref = ods_to_csf_3D(parsexmltag(Rn[0])['target-range-address']);
						Sheets[_Ref[0]]['!autofilter'] = { ref:_Ref[1] };
					} catch(e) {/* empty */}
					break;
	
				case 'date': break; // <*:date>
	
				case 'object': break; // 10.4.6.2 <draw:object>
				case 'title': case '标题': break; // <*:title> OR <uof:标题>
				case 'desc': break; // <*:desc>
				case 'binary-data': break; // 10.4.5 TODO: b64 blob
	
				/* 9.2 Advanced Tables */
				case 'table-source': break; // 9.2.6
				case 'scenario': break; // 9.2.6
	
				case 'iteration': break; // 9.4.3 <table:iteration>
				case 'content-validations': break; // 9.4.4 <table:
				case 'content-validation': break; // 9.4.5 <table:
				case 'help-message': break; // 9.4.6 <table:
				case 'error-message': break; // 9.4.7 <table:
				case 'database-ranges': break; // 9.4.14 <table:database-ranges>
				case 'filter': break; // 9.5.2 <table:filter>
				case 'filter-and': break; // 9.5.3 <table:filter-and>
				case 'filter-or': break; // 9.5.4 <table:filter-or>
				case 'filter-condition': break; // 9.5.5 <table:filter-condition>
	
				case 'list-level-style-bullet': break; // 16.31 <text:
				case 'list-level-style-number': break; // 16.32 <text:
				case 'list-level-properties': break; // 17.19 <style:
	
				/* 7.3 Document Fields */
				case 'sender-firstname': // 7.3.6.2
				case 'sender-lastname': // 7.3.6.3
				case 'sender-initials': // 7.3.6.4
				case 'sender-title': // 7.3.6.5
				case 'sender-position': // 7.3.6.6
				case 'sender-email': // 7.3.6.7
				case 'sender-phone-private': // 7.3.6.8
				case 'sender-fax': // 7.3.6.9
				case 'sender-company': // 7.3.6.10
				case 'sender-phone-work': // 7.3.6.11
				case 'sender-street': // 7.3.6.12
				case 'sender-city': // 7.3.6.13
				case 'sender-postal-code': // 7.3.6.14
				case 'sender-country': // 7.3.6.15
				case 'sender-state-or-province': // 7.3.6.16
				case 'author-name': // 7.3.7.1
				case 'author-initials': // 7.3.7.2
				case 'chapter': // 7.3.8
				case 'file-name': // 7.3.9
				case 'template-name': // 7.3.9
				case 'sheet-name': // 7.3.9
					break;
	
				case 'event-listener':
					break;
				/* TODO: FODS Properties */
				case 'initial-creator':
				case 'creation-date':
				case 'print-date':
				case 'generator':
				case 'document-statistic':
				case 'user-defined':
				case 'editing-duration':
				case 'editing-cycles':
					break;
	
				/* TODO: FODS Config */
				case 'config-item':
					break;
	
				/* TODO: style tokens */
				case 'page-number': break; // TODO <text:page-number>
				case 'page-count': break; // TODO <text:page-count>
				case 'time': break; // TODO <text:time>
	
				/* 9.3 Advanced Table Cells */
				case 'cell-range-source': break; // 9.3.1 <table:
				case 'detective': break; // 9.3.2 <table:
				case 'operation': break; // 9.3.3 <table:
				case 'highlighted-range': break; // 9.3.4 <table:
	
				/* 9.6 Data Pilot Tables <table: */
				case 'data-pilot-table': // 9.6.3
				case 'source-cell-range': // 9.6.5
				case 'source-service': // 9.6.6
				case 'data-pilot-field': // 9.6.7
				case 'data-pilot-level': // 9.6.8
				case 'data-pilot-subtotals': // 9.6.9
				case 'data-pilot-subtotal': // 9.6.10
				case 'data-pilot-members': // 9.6.11
				case 'data-pilot-member': // 9.6.12
				case 'data-pilot-display-info': // 9.6.13
				case 'data-pilot-sort-info': // 9.6.14
				case 'data-pilot-layout-info': // 9.6.15
				case 'data-pilot-field-reference': // 9.6.16
				case 'data-pilot-groups': // 9.6.17
				case 'data-pilot-group': // 9.6.18
				case 'data-pilot-group-member': // 9.6.19
					break;
	
				/* 10.3 Drawing Shapes */
				case 'rect': // 10.3.2
					break;
	
				/* 14.6 DDE Connections */
				case 'dde-connection-decls': // 14.6.2 <text:
				case 'dde-connection-decl': // 14.6.3 <text:
				case 'dde-link': // 14.6.4 <table:
				case 'dde-source': // 14.6.5 <office:
					break;
	
				case 'properties': break; // 13.7 <form:properties>
				case 'property': break; // 13.8 <form:property>
	
				case 'a': // 6.1.8 hyperlink
					if(Rn[1]!== '/') {
						atag = parsexmltag(Rn[0], false);
						if(!atag.href) break;
						atag.Target = unescapexml(atag.href); delete atag.href;
						if(atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
							_Ref = ods_to_csf_3D(atag.Target.slice(1));
							atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
						} else if(atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
					}
					break;
	
				/* non-standard */
				case 'table-protection': break;
				case 'data-pilot-grand-total': break; // <table:
				case 'office-document-common-attrs': break; // bare
				default: switch(Rn[2]) {
					case 'dc:':       // TODO: properties
					case 'calcext:':  // ignore undocumented extensions
					case 'loext:':    // ignore undocumented extensions
					case 'ooo:':      // ignore undocumented extensions
					case 'chartooo:': // ignore undocumented extensions
					case 'draw:':     // TODO: drawing
					case 'style:':    // TODO: styles
					case 'chart:':    // TODO: charts
					case 'form:':     // TODO: forms
					case 'uof:':      // TODO: uof
					case '表:':       // TODO: uof
					case '字:':       // TODO: uof
						break;
					default: if(opts.WTF) throw new Error(Rn);
				}
			}
			var out = ({
				Sheets: Sheets,
				SheetNames: SheetNames,
				Workbook: WB
			});
			if(opts.bookSheets) delete out.Sheets;
			return out;
	}
	
	function parse_ods(zip, opts) {
		opts = opts || ({});
		if(safegetzipfile(zip, 'META-INF/manifest.xml')) parse_manifest(getzipdata(zip, 'META-INF/manifest.xml'), opts);
		var content = getzipstr(zip, 'content.xml');
		if(!content) throw new Error("Missing content.xml in ODS / UOF file");
		var wb = parse_content_xml(utf8read(content), opts);
		if(safegetzipfile(zip, 'meta.xml')) wb.Props = parse_core_props(getzipdata(zip, 'meta.xml'));
		return wb;
	}
	function parse_fods(data, opts) {
		return parse_content_xml(data, opts);
	}
	
	/* OpenDocument */
	var write_styles_ods = /* @__PURE__ */(function() {
		var master_styles = [
			'<office:master-styles>',
				'<style:master-page style:name="mp1" style:page-layout-name="mp1">',
					'<style:header/>',
					'<style:header-left style:display="false"/>',
					'<style:footer/>',
					'<style:footer-left style:display="false"/>',
				'</style:master-page>',
			'</office:master-styles>'
		].join("");
	
		var payload = '<office:document-styles ' + wxt_helper({
			'xmlns:office':   "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
			'xmlns:table':    "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
			'xmlns:style':    "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
			'xmlns:text':     "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
			'xmlns:draw':     "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
			'xmlns:fo':       "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
			'xmlns:xlink':    "http://www.w3.org/1999/xlink",
			'xmlns:dc':       "http://purl.org/dc/elements/1.1/",
			'xmlns:number':   "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
			'xmlns:svg':      "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
			'xmlns:of':       "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
			'office:version': "1.2"
		}) + '>' + master_styles + '</office:document-styles>';
	
		return function wso() {
			return XML_HEADER + payload;
		};
	})();
	var write_content_ods = /* @__PURE__ */(function() {
		/* 6.1.2 White Space Characters */
		var write_text_p = function(text) {
			return escapexml(text)
				.replace(/  +/g, function($$){return '<text:s text:c="'+$$.length+'"/>';})
				.replace(/\t/g, "<text:tab/>")
				.replace(/\n/g, "</text:p><text:p>")
				.replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
		};
	
		var null_cell_xml = '          <table:table-cell />\n';
		var covered_cell_xml = '          <table:covered-table-cell/>\n';
		var write_ws = function(ws, wb, i) {
			/* Section 9 Tables */
			var o = [];
			o.push('      <table:table table:name="' + escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
			var R=0,C=0, range = decode_range(ws['!ref']||"A1");
			var marr = ws['!merges'] || [], mi = 0;
			var dense = Array.isArray(ws);
			if(ws["!cols"]) {
				for(C = 0; C <= range.e.c; ++C) o.push('        <table:table-column' + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : '') + '></table:table-column>\n');
			}
			var H = "", ROWS = ws["!rows"]||[];
			for(R = 0; R < range.s.r; ++R) {
				H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
				o.push('        <table:table-row' + H + '></table:table-row>\n');
			}
			for(; R <= range.e.r; ++R) {
				H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
				o.push('        <table:table-row' + H + '>\n');
				for(C=0; C < range.s.c; ++C) o.push(null_cell_xml);
				for(; C <= range.e.c; ++C) {
					var skip = false, ct = {}, textp = "";
					for(mi = 0; mi != marr.length; ++mi) {
						if(marr[mi].s.c > C) continue;
						if(marr[mi].s.r > R) continue;
						if(marr[mi].e.c < C) continue;
						if(marr[mi].e.r < R) continue;
						if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
						ct['table:number-columns-spanned'] = (marr[mi].e.c - marr[mi].s.c + 1);
						ct['table:number-rows-spanned'] =    (marr[mi].e.r - marr[mi].s.r + 1);
						break;
					}
					if(skip) { o.push(covered_cell_xml); continue; }
					var ref = encode_cell({r:R, c:C}), cell = dense ? (ws[R]||[])[C]: ws[ref];
					if(cell && cell.f) {
						ct['table:formula'] = escapexml(csf_to_ods_formula(cell.f));
						if(cell.F) {
							if(cell.F.slice(0, ref.length) == ref) {
								var _Fref = decode_range(cell.F);
								ct['table:number-matrix-columns-spanned'] = (_Fref.e.c - _Fref.s.c + 1);
								ct['table:number-matrix-rows-spanned'] =    (_Fref.e.r - _Fref.s.r + 1);
							}
						}
					}
					if(!cell) { o.push(null_cell_xml); continue; }
					switch(cell.t) {
						case 'b':
							textp = (cell.v ? 'TRUE' : 'FALSE');
							ct['office:value-type'] = "boolean";
							ct['office:boolean-value'] = (cell.v ? 'true' : 'false');
							break;
						case 'n':
							textp = (cell.w||String(cell.v||0));
							ct['office:value-type'] = "float";
							ct['office:value'] = (cell.v||0);
							break;
						case 's': case 'str':
							textp = cell.v == null ? "" : cell.v;
							ct['office:value-type'] = "string";
							break;
						case 'd':
							textp = (cell.w||(parseDate(cell.v).toISOString()));
							ct['office:value-type'] = "date";
							ct['office:date-value'] = (parseDate(cell.v).toISOString());
							ct['table:style-name'] = "ce1";
							break;
						//case 'e':
						default: o.push(null_cell_xml); continue;
					}
					var text_p = write_text_p(textp);
					if(cell.l && cell.l.Target) {
						var _tgt = cell.l.Target;
						_tgt = _tgt.charAt(0) == "#" ? "#" + csf_to_ods_3D(_tgt.slice(1)) : _tgt;
						// TODO: choose correct parent path format based on link delimiters
						if(_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = '../' + _tgt;
						text_p = writextag('text:a', text_p, {'xlink:href': _tgt.replace(/&/g, "&amp;")});
					}
					o.push('          ' + writextag('table:table-cell', writextag('text:p', text_p, {}), ct) + '\n');
				}
				o.push('        </table:table-row>\n');
			}
			o.push('      </table:table>\n');
			return o.join("");
		};
	
		var write_automatic_styles_ods = function(o, wb) {
			o.push(' <office:automatic-styles>\n');
	
			o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
			o.push('   <number:month number:style="long"/>\n');
			o.push('   <number:text>/</number:text>\n');
			o.push('   <number:day number:style="long"/>\n');
			o.push('   <number:text>/</number:text>\n');
			o.push('   <number:year/>\n');
			o.push('  </number:date-style>\n');
	
			/* column styles */
			var cidx = 0;
			wb.SheetNames.map(function(n) { return wb.Sheets[n]; }).forEach(function(ws) {
				if(!ws) return;
				if(ws["!cols"]) {
					for(var C = 0; C < ws["!cols"].length; ++C) if(ws["!cols"][C]) {
						var colobj = ws["!cols"][C];
						if(colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
						process_col(colobj);
						colobj.ods = cidx;
						var w = ws["!cols"][C].wpx + "px";
						o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
						o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
						o.push('  </style:style>\n');
						++cidx;
					}
				}
			});
	
			/* row styles */
			var ridx = 0;
			wb.SheetNames.map(function(n) { return wb.Sheets[n]; }).forEach(function(ws) {
				if(!ws) return;
				if(ws["!rows"]) {
					for(var R = 0; R < ws["!rows"].length; ++R) if(ws["!rows"][R]) {
						ws["!rows"][R].ods = ridx;
						var h = ws["!rows"][R].hpx + "px";
						o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
						o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
						o.push('  </style:style>\n');
						++ridx;
					}
				}
			});
	
			/* table */
			o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
			o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
			o.push('  </style:style>\n');
	
			/* table cells, text */
			o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
	
			/* page-layout */
	
			o.push(' </office:automatic-styles>\n');
		};
	
		return function wcx(wb, opts) {
			var o = [XML_HEADER];
			/* 3.1.3.2 */
			var attr = wxt_helper({
				'xmlns:office':       "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
				'xmlns:table':        "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
				'xmlns:style':        "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
				'xmlns:text':         "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
				'xmlns:draw':         "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
				'xmlns:fo':           "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
				'xmlns:xlink':        "http://www.w3.org/1999/xlink",
				'xmlns:dc':           "http://purl.org/dc/elements/1.1/",
				'xmlns:meta':         "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
				'xmlns:number':       "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
				'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
				'xmlns:svg':          "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
				'xmlns:chart':        "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
				'xmlns:dr3d':         "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
				'xmlns:math':         "http://www.w3.org/1998/Math/MathML",
				'xmlns:form':         "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
				'xmlns:script':       "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
				'xmlns:ooo':          "http://openoffice.org/2004/office",
				'xmlns:ooow':         "http://openoffice.org/2004/writer",
				'xmlns:oooc':         "http://openoffice.org/2004/calc",
				'xmlns:dom':          "http://www.w3.org/2001/xml-events",
				'xmlns:xforms':       "http://www.w3.org/2002/xforms",
				'xmlns:xsd':          "http://www.w3.org/2001/XMLSchema",
				'xmlns:xsi':          "http://www.w3.org/2001/XMLSchema-instance",
				'xmlns:sheet':        "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
				'xmlns:rpt':          "http://openoffice.org/2005/report",
				'xmlns:of':           "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
				'xmlns:xhtml':        "http://www.w3.org/1999/xhtml",
				'xmlns:grddl':        "http://www.w3.org/2003/g/data-view#",
				'xmlns:tableooo':     "http://openoffice.org/2009/table",
				'xmlns:drawooo':      "http://openoffice.org/2010/draw",
				'xmlns:calcext':      "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
				'xmlns:loext':        "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
				'xmlns:field':        "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
				'xmlns:formx':        "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
				'xmlns:css3t':        "http://www.w3.org/TR/css3-text/",
				'office:version':     "1.2"
			});
	
			var fods = wxt_helper({
				'xmlns:config':    "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
				'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
			});
	
			if(opts.bookType == "fods") {
				o.push('<office:document' + attr + fods + '>\n');
				o.push(write_meta_ods().replace(/office:document-meta/g, "office:meta"));
				// TODO: settings (equiv of settings.xml for ODS)
			} else o.push('<office:document-content' + attr  + '>\n');
			// o.push('  <office:scripts/>\n');
			write_automatic_styles_ods(o, wb);
			o.push('  <office:body>\n');
			o.push('    <office:spreadsheet>\n');
			for(var i = 0; i != wb.SheetNames.length; ++i) o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts));
			o.push('    </office:spreadsheet>\n');
			o.push('  </office:body>\n');
			if(opts.bookType == "fods") o.push('</office:document>');
			else o.push('</office:document-content>');
			return o.join("");
		};
	})();
	
	function write_ods(wb, opts) {
		if(opts.bookType == "fods") return write_content_ods(wb, opts);
	
		var zip = zip_new();
		var f = "";
	
		var manifest = [];
		var rdf = [];
	
		/* Part 3 Section 3.3 MIME Media Type */
		f = "mimetype";
		zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
	
		/* Part 1 Section 2.2 Documents */
		f = "content.xml";
		zip_add_file(zip, f, write_content_ods(wb, opts));
		manifest.push([f, "text/xml"]);
		rdf.push([f, "ContentFile"]);
	
		/* TODO: these are hard-coded styles to satiate excel */
		f = "styles.xml";
		zip_add_file(zip, f, write_styles_ods(wb, opts));
		manifest.push([f, "text/xml"]);
		rdf.push([f, "StylesFile"]);
	
		/* TODO: this is hard-coded to satiate excel */
		f = "meta.xml";
		zip_add_file(zip, f, XML_HEADER + write_meta_ods());
		manifest.push([f, "text/xml"]);
		rdf.push([f, "MetadataFile"]);
	
		/* Part 3 Section 6 Metadata Manifest File */
		f = "manifest.rdf";
		zip_add_file(zip, f, write_rdf(rdf/*, opts*/));
		manifest.push([f, "application/rdf+xml"]);
	
		/* Part 3 Section 4 Manifest File */
		f = "META-INF/manifest.xml";
		zip_add_file(zip, f, write_manifest(manifest/*, opts*/));
	
		return zip;
	}
	
	/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */
	function u8_to_dataview(array) {
	  return new DataView(array.buffer, array.byteOffset, array.byteLength);
	}
	function u8str(u8) {
	  return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : utf8read(a2s(u8));
	}
	function stru8(str) {
	  return typeof TextEncoder != "undefined" ? new TextEncoder().encode(str) : s2a(utf8write(str));
	}
	function u8contains(body, search) {
	  outer:
	    for (var L = 0; L <= body.length - search.length; ++L) {
	      for (var j = 0; j < search.length; ++j)
	        if (body[L + j] != search[j])
	          continue outer;
	      return true;
	    }
	  return false;
	}
	function u8concat(u8a) {
	  var len = u8a.reduce(function(acc, x) {
	    return acc + x.length;
	  }, 0);
	  var out = new Uint8Array(len);
	  var off = 0;
	  u8a.forEach(function(u8) {
	    out.set(u8, off);
	    off += u8.length;
	  });
	  return out;
	}
	function popcnt(x) {
	  x -= x >> 1 & 1431655765;
	  x = (x & 858993459) + (x >> 2 & 858993459);
	  return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
	}
	function readDecimal128LE(buf, offset) {
	  var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
	  var mantissa = buf[offset + 14] & 1;
	  for (var j = offset + 13; j >= offset; --j)
	    mantissa = mantissa * 256 + buf[j];
	  return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
	}
	function writeDecimal128LE(buf, offset, value) {
	  var exp = Math.floor(value == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(value))) + 6176 - 20;
	  var mantissa = value / Math.pow(10, exp - 6176);
	  buf[offset + 15] |= exp >> 7;
	  buf[offset + 14] |= (exp & 127) << 1;
	  for (var i = 0; mantissa >= 1; ++i, mantissa /= 256)
	    buf[offset + i] = mantissa & 255;
	  buf[offset + 15] |= value >= 0 ? 0 : 128;
	}
	function parse_varint49(buf, ptr) {
	  var l = ptr ? ptr[0] : 0;
	  var usz = buf[l] & 127;
	  varint:
	    if (buf[l++] >= 128) {
	      usz |= (buf[l] & 127) << 7;
	      if (buf[l++] < 128)
	        break varint;
	      usz |= (buf[l] & 127) << 14;
	      if (buf[l++] < 128)
	        break varint;
	      usz |= (buf[l] & 127) << 21;
	      if (buf[l++] < 128)
	        break varint;
	      usz += (buf[l] & 127) * Math.pow(2, 28);
	      ++l;
	      if (buf[l++] < 128)
	        break varint;
	      usz += (buf[l] & 127) * Math.pow(2, 35);
	      ++l;
	      if (buf[l++] < 128)
	        break varint;
	      usz += (buf[l] & 127) * Math.pow(2, 42);
	      ++l;
	      if (buf[l++] < 128)
	        break varint;
	    }
	  if (ptr)
	    ptr[0] = l;
	  return usz;
	}
	function write_varint49(v) {
	  var usz = new Uint8Array(7);
	  usz[0] = v & 127;
	  var L = 1;
	  sz:
	    if (v > 127) {
	      usz[L - 1] |= 128;
	      usz[L] = v >> 7 & 127;
	      ++L;
	      if (v <= 16383)
	        break sz;
	      usz[L - 1] |= 128;
	      usz[L] = v >> 14 & 127;
	      ++L;
	      if (v <= 2097151)
	        break sz;
	      usz[L - 1] |= 128;
	      usz[L] = v >> 21 & 127;
	      ++L;
	      if (v <= 268435455)
	        break sz;
	      usz[L - 1] |= 128;
	      usz[L] = v / 256 >>> 21 & 127;
	      ++L;
	      if (v <= 34359738367)
	        break sz;
	      usz[L - 1] |= 128;
	      usz[L] = v / 65536 >>> 21 & 127;
	      ++L;
	      if (v <= 4398046511103)
	        break sz;
	      usz[L - 1] |= 128;
	      usz[L] = v / 16777216 >>> 21 & 127;
	      ++L;
	    }
	  return usz.slice(0, L);
	}
	function varint_to_i32(buf) {
	  var l = 0, i32 = buf[l] & 127;
	  varint:
	    if (buf[l++] >= 128) {
	      i32 |= (buf[l] & 127) << 7;
	      if (buf[l++] < 128)
	        break varint;
	      i32 |= (buf[l] & 127) << 14;
	      if (buf[l++] < 128)
	        break varint;
	      i32 |= (buf[l] & 127) << 21;
	      if (buf[l++] < 128)
	        break varint;
	      i32 |= (buf[l] & 127) << 28;
	    }
	  return i32;
	}
	function parse_shallow(buf) {
	  var out = [], ptr = [0];
	  while (ptr[0] < buf.length) {
	    var off = ptr[0];
	    var num = parse_varint49(buf, ptr);
	    var type = num & 7;
	    num = Math.floor(num / 8);
	    var len = 0;
	    var res;
	    if (num == 0)
	      break;
	    switch (type) {
	      case 0:
	        {
	          var l = ptr[0];
	          while (buf[ptr[0]++] >= 128)
	            ;
	          res = buf.slice(l, ptr[0]);
	        }
	        break;
	      case 5:
	        len = 4;
	        res = buf.slice(ptr[0], ptr[0] + len);
	        ptr[0] += len;
	        break;
	      case 1:
	        len = 8;
	        res = buf.slice(ptr[0], ptr[0] + len);
	        ptr[0] += len;
	        break;
	      case 2:
	        len = parse_varint49(buf, ptr);
	        res = buf.slice(ptr[0], ptr[0] + len);
	        ptr[0] += len;
	        break;
	      case 3:
	      case 4:
	      default:
	        throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
	    }
	    var v = { data: res, type: type };
	    if (out[num] == null)
	      out[num] = [v];
	    else
	      out[num].push(v);
	  }
	  return out;
	}
	function write_shallow(proto) {
	  var out = [];
	  proto.forEach(function(field, idx) {
	    field.forEach(function(item) {
	      if (!item.data)
	        return;
	      out.push(write_varint49(idx * 8 + item.type));
	      if (item.type == 2)
	        out.push(write_varint49(item.data.length));
	      out.push(item.data);
	    });
	  });
	  return u8concat(out);
	}
	function mappa(data, cb) {
	  return (data == null ? void 0 : data.map(function(d) {
	    return cb(d.data);
	  })) || [];
	}
	function parse_iwa_file(buf) {
	  var _a;
	  var out = [], ptr = [0];
	  while (ptr[0] < buf.length) {
	    var len = parse_varint49(buf, ptr);
	    var ai = parse_shallow(buf.slice(ptr[0], ptr[0] + len));
	    ptr[0] += len;
	    var res = {
	      id: varint_to_i32(ai[1][0].data),
	      messages: []
	    };
	    ai[2].forEach(function(b) {
	      var mi = parse_shallow(b.data);
	      var fl = varint_to_i32(mi[3][0].data);
	      res.messages.push({
	        meta: mi,
	        data: buf.slice(ptr[0], ptr[0] + fl)
	      });
	      ptr[0] += fl;
	    });
	    if ((_a = ai[3]) == null ? void 0 : _a[0])
	      res.merge = varint_to_i32(ai[3][0].data) >>> 0 > 0;
	    out.push(res);
	  }
	  return out;
	}
	function write_iwa_file(ias) {
	  var bufs = [];
	  ias.forEach(function(ia) {
	    var ai = [];
	    ai[1] = [{ data: write_varint49(ia.id), type: 0 }];
	    ai[2] = [];
	    if (ia.merge != null)
	      ai[3] = [{ data: write_varint49(+!!ia.merge), type: 0 }];
	    var midata = [];
	    ia.messages.forEach(function(mi) {
	      midata.push(mi.data);
	      mi.meta[3] = [{ type: 0, data: write_varint49(mi.data.length) }];
	      ai[2].push({ data: write_shallow(mi.meta), type: 2 });
	    });
	    var aipayload = write_shallow(ai);
	    bufs.push(write_varint49(aipayload.length));
	    bufs.push(aipayload);
	    midata.forEach(function(mid) {
	      return bufs.push(mid);
	    });
	  });
	  return u8concat(bufs);
	}
	function parse_snappy_chunk(type, buf) {
	  if (type != 0)
	    throw new Error("Unexpected Snappy chunk type ".concat(type));
	  var ptr = [0];
	  var usz = parse_varint49(buf, ptr);
	  var chunks = [];
	  while (ptr[0] < buf.length) {
	    var tag = buf[ptr[0]] & 3;
	    if (tag == 0) {
	      var len = buf[ptr[0]++] >> 2;
	      if (len < 60)
	        ++len;
	      else {
	        var c = len - 59;
	        len = buf[ptr[0]];
	        if (c > 1)
	          len |= buf[ptr[0] + 1] << 8;
	        if (c > 2)
	          len |= buf[ptr[0] + 2] << 16;
	        if (c > 3)
	          len |= buf[ptr[0] + 3] << 24;
	        len >>>= 0;
	        len++;
	        ptr[0] += c;
	      }
	      chunks.push(buf.slice(ptr[0], ptr[0] + len));
	      ptr[0] += len;
	      continue;
	    } else {
	      var offset = 0, length = 0;
	      if (tag == 1) {
	        length = (buf[ptr[0]] >> 2 & 7) + 4;
	        offset = (buf[ptr[0]++] & 224) << 3;
	        offset |= buf[ptr[0]++];
	      } else {
	        length = (buf[ptr[0]++] >> 2) + 1;
	        if (tag == 2) {
	          offset = buf[ptr[0]] | buf[ptr[0] + 1] << 8;
	          ptr[0] += 2;
	        } else {
	          offset = (buf[ptr[0]] | buf[ptr[0] + 1] << 8 | buf[ptr[0] + 2] << 16 | buf[ptr[0] + 3] << 24) >>> 0;
	          ptr[0] += 4;
	        }
	      }
	      chunks = [u8concat(chunks)];
	      if (offset == 0)
	        throw new Error("Invalid offset 0");
	      if (offset > chunks[0].length)
	        throw new Error("Invalid offset beyond length");
	      if (length >= offset) {
	        chunks.push(chunks[0].slice(-offset));
	        length -= offset;
	        while (length >= chunks[chunks.length - 1].length) {
	          chunks.push(chunks[chunks.length - 1]);
	          length -= chunks[chunks.length - 1].length;
	        }
	      }
	      chunks.push(chunks[0].slice(-offset, -offset + length));
	    }
	  }
	  var o = u8concat(chunks);
	  if (o.length != usz)
	    throw new Error("Unexpected length: ".concat(o.length, " != ").concat(usz));
	  return o;
	}
	function decompress_iwa_file(buf) {
	  var out = [];
	  var l = 0;
	  while (l < buf.length) {
	    var t = buf[l++];
	    var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
	    l += 3;
	    out.push(parse_snappy_chunk(t, buf.slice(l, l + len)));
	    l += len;
	  }
	  if (l !== buf.length)
	    throw new Error("data is not a valid framed stream!");
	  return u8concat(out);
	}
	function compress_iwa_file(buf) {
	  var out = [];
	  var l = 0;
	  while (l < buf.length) {
	    var c = Math.min(buf.length - l, 268435455);
	    var frame = new Uint8Array(4);
	    out.push(frame);
	    var usz = write_varint49(c);
	    var L = usz.length;
	    out.push(usz);
	    if (c <= 60) {
	      L++;
	      out.push(new Uint8Array([c - 1 << 2]));
	    } else if (c <= 256) {
	      L += 2;
	      out.push(new Uint8Array([240, c - 1 & 255]));
	    } else if (c <= 65536) {
	      L += 3;
	      out.push(new Uint8Array([244, c - 1 & 255, c - 1 >> 8 & 255]));
	    } else if (c <= 16777216) {
	      L += 4;
	      out.push(new Uint8Array([248, c - 1 & 255, c - 1 >> 8 & 255, c - 1 >> 16 & 255]));
	    } else if (c <= 4294967296) {
	      L += 5;
	      out.push(new Uint8Array([252, c - 1 & 255, c - 1 >> 8 & 255, c - 1 >> 16 & 255, c - 1 >>> 24 & 255]));
	    }
	    out.push(buf.slice(l, l + c));
	    L += c;
	    frame[0] = 0;
	    frame[1] = L & 255;
	    frame[2] = L >> 8 & 255;
	    frame[3] = L >> 16 & 255;
	    l += c;
	  }
	  return u8concat(out);
	}
	function parse_old_storage(buf, sst, rsst, v) {
	  var dv = u8_to_dataview(buf);
	  var flags = dv.getUint32(4, true);
	  var data_offset = (v > 1 ? 12 : 8) + popcnt(flags & (v > 1 ? 3470 : 398)) * 4;
	  var ridx = -1, sidx = -1, ieee = NaN, dt = new Date(2001, 0, 1);
	  if (flags & 512) {
	    ridx = dv.getUint32(data_offset, true);
	    data_offset += 4;
	  }
	  data_offset += popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
	  if (flags & 16) {
	    sidx = dv.getUint32(data_offset, true);
	    data_offset += 4;
	  }
	  if (flags & 32) {
	    ieee = dv.getFloat64(data_offset, true);
	    data_offset += 8;
	  }
	  if (flags & 64) {
	    dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
	    data_offset += 8;
	  }
	  var ret;
	  switch (buf[2]) {
	    case 0:
	      break;
	    case 2:
	      ret = { t: "n", v: ieee };
	      break;
	    case 3:
	      ret = { t: "s", v: sst[sidx] };
	      break;
	    case 5:
	      ret = { t: "d", v: dt };
	      break;
	    case 6:
	      ret = { t: "b", v: ieee > 0 };
	      break;
	    case 7:
	      ret = { t: "n", v: ieee / 86400 };
	      break;
	    case 8:
	      ret = { t: "e", v: 0 };
	      break;
	    case 9:
	      {
	        if (ridx > -1)
	          ret = { t: "s", v: rsst[ridx] };
	        else if (sidx > -1)
	          ret = { t: "s", v: sst[sidx] };
	        else if (!isNaN(ieee))
	          ret = { t: "n", v: ieee };
	        else
	          throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
	      }
	      break;
	    default:
	      throw new Error("Unsupported cell type ".concat(buf.slice(0, 4)));
	  }
	  return ret;
	}
	function parse_new_storage(buf, sst, rsst) {
	  var dv = u8_to_dataview(buf);
	  var flags = dv.getUint32(8, true);
	  var data_offset = 12;
	  var ridx = -1, sidx = -1, d128 = NaN, ieee = NaN, dt = new Date(2001, 0, 1);
	  if (flags & 1) {
	    d128 = readDecimal128LE(buf, data_offset);
	    data_offset += 16;
	  }
	  if (flags & 2) {
	    ieee = dv.getFloat64(data_offset, true);
	    data_offset += 8;
	  }
	  if (flags & 4) {
	    dt.setTime(dt.getTime() + dv.getFloat64(data_offset, true) * 1e3);
	    data_offset += 8;
	  }
	  if (flags & 8) {
	    sidx = dv.getUint32(data_offset, true);
	    data_offset += 4;
	  }
	  if (flags & 16) {
	    ridx = dv.getUint32(data_offset, true);
	    data_offset += 4;
	  }
	  var ret;
	  switch (buf[1]) {
	    case 0:
	      break;
	    case 2:
	      ret = { t: "n", v: d128 };
	      break;
	    case 3:
	      ret = { t: "s", v: sst[sidx] };
	      break;
	    case 5:
	      ret = { t: "d", v: dt };
	      break;
	    case 6:
	      ret = { t: "b", v: ieee > 0 };
	      break;
	    case 7:
	      ret = { t: "n", v: ieee / 86400 };
	      break;
	    case 8:
	      ret = { t: "e", v: 0 };
	      break;
	    case 9:
	      {
	        if (ridx > -1)
	          ret = { t: "s", v: rsst[ridx] };
	        else
	          throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
	      }
	      break;
	    case 10:
	      ret = { t: "n", v: d128 };
	      break;
	    default:
	      throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(flags & 31, " : ").concat(buf.slice(0, 4)));
	  }
	  return ret;
	}
	function write_new_storage(cell, sst) {
	  var out = new Uint8Array(32), dv = u8_to_dataview(out), l = 12, flags = 0;
	  out[0] = 5;
	  switch (cell.t) {
	    case "n":
	      out[1] = 2;
	      writeDecimal128LE(out, l, cell.v);
	      flags |= 1;
	      l += 16;
	      break;
	    case "b":
	      out[1] = 6;
	      dv.setFloat64(l, cell.v ? 1 : 0, true);
	      flags |= 2;
	      l += 8;
	      break;
	    case "s":
	      if (sst.indexOf(cell.v) == -1)
	        throw new Error("Value ".concat(cell.v, " missing from SST!"));
	      out[1] = 3;
	      dv.setUint32(l, sst.indexOf(cell.v), true);
	      flags |= 8;
	      l += 4;
	      break;
	    default:
	      throw "unsupported cell type " + cell.t;
	  }
	  dv.setUint32(8, flags, true);
	  return out.slice(0, l);
	}
	function write_old_storage(cell, sst) {
	  var out = new Uint8Array(32), dv = u8_to_dataview(out), l = 12, flags = 0;
	  out[0] = 3;
	  switch (cell.t) {
	    case "n":
	      out[2] = 2;
	      dv.setFloat64(l, cell.v, true);
	      flags |= 32;
	      l += 8;
	      break;
	    case "b":
	      out[2] = 6;
	      dv.setFloat64(l, cell.v ? 1 : 0, true);
	      flags |= 32;
	      l += 8;
	      break;
	    case "s":
	      if (sst.indexOf(cell.v) == -1)
	        throw new Error("Value ".concat(cell.v, " missing from SST!"));
	      out[2] = 3;
	      dv.setUint32(l, sst.indexOf(cell.v), true);
	      flags |= 16;
	      l += 4;
	      break;
	    default:
	      throw "unsupported cell type " + cell.t;
	  }
	  dv.setUint32(4, flags, true);
	  return out.slice(0, l);
	}
	function parse_cell_storage(buf, sst, rsst) {
	  switch (buf[0]) {
	    case 0:
	    case 1:
	    case 2:
	    case 3:
	      return parse_old_storage(buf, sst, rsst, buf[0]);
	    case 5:
	      return parse_new_storage(buf, sst, rsst);
	    default:
	      throw new Error("Unsupported payload version ".concat(buf[0]));
	  }
	}
	function parse_TSP_Reference(buf) {
	  var pb = parse_shallow(buf);
	  return parse_varint49(pb[1][0].data);
	}
	function write_TSP_Reference(idx) {
	  var out = [];
	  out[1] = [{ type: 0, data: write_varint49(idx) }];
	  return write_shallow(out);
	}
	function parse_TST_TableDataList(M, root) {
	  var pb = parse_shallow(root.data);
	  var type = varint_to_i32(pb[1][0].data);
	  var entries = pb[3];
	  var data = [];
	  (entries || []).forEach(function(entry) {
	    var le = parse_shallow(entry.data);
	    var key = varint_to_i32(le[1][0].data) >>> 0;
	    switch (type) {
	      case 1:
	        data[key] = u8str(le[3][0].data);
	        break;
	      case 8:
	        {
	          var rt = M[parse_TSP_Reference(le[9][0].data)][0];
	          var rtp = parse_shallow(rt.data);
	          var rtpref = M[parse_TSP_Reference(rtp[1][0].data)][0];
	          var mtype = varint_to_i32(rtpref.meta[1][0].data);
	          if (mtype != 2001)
	            throw new Error("2000 unexpected reference to ".concat(mtype));
	          var tswpsa = parse_shallow(rtpref.data);
	          data[key] = tswpsa[3].map(function(x) {
	            return u8str(x.data);
	          }).join("");
	        }
	        break;
	    }
	  });
	  return data;
	}
	function parse_TST_TileRowInfo(u8, type) {
	  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
	  var pb = parse_shallow(u8);
	  var R = varint_to_i32(pb[1][0].data) >>> 0;
	  var cnt = varint_to_i32(pb[2][0].data) >>> 0;
	  var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && varint_to_i32(pb[8][0].data) > 0 || false;
	  var used_storage_u8, used_storage;
	  if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
	    used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
	    used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
	  } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
	    used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
	    used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
	  } else
	    throw "NUMBERS Tile missing ".concat(type, " cell storage");
	  var width = wide_offsets ? 4 : 1;
	  var used_storage_offsets = u8_to_dataview(used_storage_u8);
	  var offsets = [];
	  for (var C = 0; C < used_storage_u8.length / 2; ++C) {
	    var off = used_storage_offsets.getUint16(C * 2, true);
	    if (off < 65535)
	      offsets.push([C, off]);
	  }
	  if (offsets.length != cnt)
	    throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
	  var cells = [];
	  for (C = 0; C < offsets.length - 1; ++C)
	    cells[offsets[C][0]] = used_storage.subarray(offsets[C][1] * width, offsets[C + 1][1] * width);
	  if (offsets.length >= 1)
	    cells[offsets[offsets.length - 1][0]] = used_storage.subarray(offsets[offsets.length - 1][1] * width);
	  return { R: R, cells: cells };
	}
	function parse_TST_Tile(M, root) {
	  var _a;
	  var pb = parse_shallow(root.data);
	  var storage = ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) ? varint_to_i32(pb[7][0].data) >>> 0 > 0 ? 1 : 0 : -1;
	  var ri = mappa(pb[5], function(u8) {
	    return parse_TST_TileRowInfo(u8, storage);
	  });
	  return {
	    nrows: varint_to_i32(pb[4][0].data) >>> 0,
	    data: ri.reduce(function(acc, x) {
	      if (!acc[x.R])
	        acc[x.R] = [];
	      x.cells.forEach(function(cell, C) {
	        if (acc[x.R][C])
	          throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
	        acc[x.R][C] = cell;
	      });
	      return acc;
	    }, [])
	  };
	}
	function parse_TST_TableModelArchive(M, root, ws) {
	  var _a;
	  var pb = parse_shallow(root.data);
	  var range = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
	  range.e.r = (varint_to_i32(pb[6][0].data) >>> 0) - 1;
	  if (range.e.r < 0)
	    throw new Error("Invalid row varint ".concat(pb[6][0].data));
	  range.e.c = (varint_to_i32(pb[7][0].data) >>> 0) - 1;
	  if (range.e.c < 0)
	    throw new Error("Invalid col varint ".concat(pb[7][0].data));
	  ws["!ref"] = encode_range(range);
	  var store = parse_shallow(pb[4][0].data);
	  var sst = parse_TST_TableDataList(M, M[parse_TSP_Reference(store[4][0].data)][0]);
	  var rsst = ((_a = store[17]) == null ? void 0 : _a[0]) ? parse_TST_TableDataList(M, M[parse_TSP_Reference(store[17][0].data)][0]) : [];
	  var tile = parse_shallow(store[3][0].data);
	  var _R = 0;
	  tile[1].forEach(function(t) {
	    var tl = parse_shallow(t.data);
	    var ref = M[parse_TSP_Reference(tl[2][0].data)][0];
	    var mtype = varint_to_i32(ref.meta[1][0].data);
	    if (mtype != 6002)
	      throw new Error("6001 unexpected reference to ".concat(mtype));
	    var _tile = parse_TST_Tile(M, ref);
	    _tile.data.forEach(function(row, R) {
	      row.forEach(function(buf, C) {
	        var addr = encode_cell({ r: _R + R, c: C });
	        var res = parse_cell_storage(buf, sst, rsst);
	        if (res)
	          ws[addr] = res;
	      });
	    });
	    _R += _tile.nrows;
	  });
	}
	function parse_TST_TableInfoArchive(M, root) {
	  var pb = parse_shallow(root.data);
	  var out = { "!ref": "A1" };
	  var tableref = M[parse_TSP_Reference(pb[2][0].data)];
	  var mtype = varint_to_i32(tableref[0].meta[1][0].data);
	  if (mtype != 6001)
	    throw new Error("6000 unexpected reference to ".concat(mtype));
	  parse_TST_TableModelArchive(M, tableref[0], out);
	  return out;
	}
	function parse_TN_SheetArchive(M, root) {
	  var _a;
	  var pb = parse_shallow(root.data);
	  var out = {
	    name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? u8str(pb[1][0].data) : "",
	    sheets: []
	  };
	  var shapeoffs = mappa(pb[2], parse_TSP_Reference);
	  shapeoffs.forEach(function(off) {
	    M[off].forEach(function(m) {
	      var mtype = varint_to_i32(m.meta[1][0].data);
	      if (mtype == 6e3)
	        out.sheets.push(parse_TST_TableInfoArchive(M, m));
	    });
	  });
	  return out;
	}
	function parse_TN_DocumentArchive(M, root) {
	  var out = book_new();
	  var pb = parse_shallow(root.data);
	  var sheetoffs = mappa(pb[1], parse_TSP_Reference);
	  sheetoffs.forEach(function(off) {
	    M[off].forEach(function(m) {
	      var mtype = varint_to_i32(m.meta[1][0].data);
	      if (mtype == 2) {
	        var root2 = parse_TN_SheetArchive(M, m);
	        root2.sheets.forEach(function(sheet, idx) {
	          book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
	        });
	      }
	    });
	  });
	  if (out.SheetNames.length == 0)
	    throw new Error("Empty NUMBERS file");
	  return out;
	}
	function parse_numbers_iwa(cfb) {
	  var _a, _b, _c, _d;
	  var M = {}, indices = [];
	  cfb.FullPaths.forEach(function(p) {
	    if (p.match(/\.iwpv2/))
	      throw new Error("Unsupported password protection");
	  });
	  cfb.FileIndex.forEach(function(s) {
	    if (!s.name.match(/\.iwa$/))
	      return;
	    var o;
	    try {
	      o = decompress_iwa_file(s.content);
	    } catch (e) {
	      return console.log("?? " + s.content.length + " " + (e.message || e));
	    }
	    var packets;
	    try {
	      packets = parse_iwa_file(o);
	    } catch (e) {
	      return console.log("## " + (e.message || e));
	    }
	    packets.forEach(function(packet) {
	      M[packet.id] = packet.messages;
	      indices.push(packet.id);
	    });
	  });
	  if (!indices.length)
	    throw new Error("File has no messages");
	  var docroot = ((_d = (_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0]) == null ? void 0 : _b.meta) == null ? void 0 : _c[1]) == null ? void 0 : _d[0].data) && varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
	  if (!docroot)
	    indices.forEach(function(idx) {
	      M[idx].forEach(function(iwam) {
	        var mtype = varint_to_i32(iwam.meta[1][0].data) >>> 0;
	        if (mtype == 1) {
	          if (!docroot)
	            docroot = iwam;
	          else
	            throw new Error("Document has multiple roots");
	        }
	      });
	    });
	  if (!docroot)
	    throw new Error("Cannot find Document root");
	  return parse_TN_DocumentArchive(M, docroot);
	}
	function write_tile_row(tri, data, SST) {
	  var _a, _b, _c, _d;
	  if (!((_a = tri[6]) == null ? void 0 : _a[0]) || !((_b = tri[7]) == null ? void 0 : _b[0]))
	    throw "Mutation only works on post-BNC storages!";
	  var wide_offsets = ((_d = (_c = tri[8]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && varint_to_i32(tri[8][0].data) > 0 || false;
	  if (wide_offsets)
	    throw "Math only works with normal offsets";
	  var cnt = 0;
	  var dv = u8_to_dataview(tri[7][0].data), last_offset = 0, cell_storage = [];
	  var _dv = u8_to_dataview(tri[4][0].data), _last_offset = 0, _cell_storage = [];
	  for (var C = 0; C < data.length; ++C) {
	    if (data[C] == null) {
	      dv.setUint16(C * 2, 65535, true);
	      _dv.setUint16(C * 2, 65535);
	      continue;
	    }
	    dv.setUint16(C * 2, last_offset, true);
	    _dv.setUint16(C * 2, _last_offset, true);
	    var celload, _celload;
	    switch (typeof data[C]) {
	      case "string":
	        celload = write_new_storage({ t: "s", v: data[C] }, SST);
	        _celload = write_old_storage({ t: "s", v: data[C] }, SST);
	        break;
	      case "number":
	        celload = write_new_storage({ t: "n", v: data[C] }, SST);
	        _celload = write_old_storage({ t: "n", v: data[C] }, SST);
	        break;
	      case "boolean":
	        celload = write_new_storage({ t: "b", v: data[C] }, SST);
	        _celload = write_old_storage({ t: "b", v: data[C] }, SST);
	        break;
	      default:
	        throw new Error("Unsupported value " + data[C]);
	    }
	    cell_storage.push(celload);
	    last_offset += celload.length;
	    _cell_storage.push(_celload);
	    _last_offset += _celload.length;
	    ++cnt;
	  }
	  tri[2][0].data = write_varint49(cnt);
	  for (; C < tri[7][0].data.length / 2; ++C) {
	    dv.setUint16(C * 2, 65535, true);
	    _dv.setUint16(C * 2, 65535, true);
	  }
	  tri[6][0].data = u8concat(cell_storage);
	  tri[3][0].data = u8concat(_cell_storage);
	  return cnt;
	}
	function write_numbers_iwa(wb, opts) {
	  if (!opts || !opts.numbers)
	    throw new Error("Must pass a `numbers` option -- check the README");
	  var ws = wb.Sheets[wb.SheetNames[0]];
	  if (wb.SheetNames.length > 1)
	    console.error("The Numbers writer currently writes only the first table");
	  var range = decode_range(ws["!ref"]);
	  range.s.r = range.s.c = 0;
	  var trunc = false;
	  if (range.e.c > 9) {
	    trunc = true;
	    range.e.c = 9;
	  }
	  if (range.e.r > 49) {
	    trunc = true;
	    range.e.r = 49;
	  }
	  if (trunc)
	    console.error("The Numbers writer is currently limited to ".concat(encode_range(range)));
	  var data = sheet_to_json(ws, { range: range, header: 1 });
	  var SST = ["~Sh33tJ5~"];
	  data.forEach(function(row) {
	    return row.forEach(function(cell) {
	      if (typeof cell == "string")
	        SST.push(cell);
	    });
	  });
	  var dependents = {};
	  var indices = [];
	  var cfb = CFB.read(opts.numbers, { type: "base64" });
	  cfb.FileIndex.map(function(fi, idx) {
	    return [fi, cfb.FullPaths[idx]];
	  }).forEach(function(row) {
	    var fi = row[0], fp = row[1];
	    if (fi.type != 2)
	      return;
	    if (!fi.name.match(/\.iwa/))
	      return;
	    var old_content = fi.content;
	    var raw1 = decompress_iwa_file(old_content);
	    var x2 = parse_iwa_file(raw1);
	    x2.forEach(function(packet2) {
	      indices.push(packet2.id);
	      dependents[packet2.id] = { deps: [], location: fp, type: varint_to_i32(packet2.messages[0].meta[1][0].data) };
	    });
	  });
	  indices.sort(function(x2, y2) {
	    return x2 - y2;
	  });
	  var indices_varint = indices.filter(function(x2) {
	    return x2 > 1;
	  }).map(function(x2) {
	    return [x2, write_varint49(x2)];
	  });
	  cfb.FileIndex.map(function(fi, idx) {
	    return [fi, cfb.FullPaths[idx]];
	  }).forEach(function(row) {
	    var fi = row[0], fp = row[1];
	    if (!fi.name.match(/\.iwa/))
	      return;
	    var x2 = parse_iwa_file(decompress_iwa_file(fi.content));
	    x2.forEach(function(ia) {
	      ia.messages.forEach(function(m) {
	        indices_varint.forEach(function(ivi) {
	          if (ia.messages.some(function(mess) {
	            return varint_to_i32(mess.meta[1][0].data) != 11006 && u8contains(mess.data, ivi[1]);
	          })) {
	            dependents[ivi[0]].deps.push(ia.id);
	          }
	        });
	      });
	    });
	  });
	  function get_unique_msgid() {
	    for (var i = 927262; i < 2e6; ++i)
	      if (!dependents[i])
	        return i;
	    throw new Error("Too many messages");
	  }
	  var entry = CFB.find(cfb, dependents[1].location);
	  var x = parse_iwa_file(decompress_iwa_file(entry.content));
	  var docroot;
	  for (var xi = 0; xi < x.length; ++xi) {
	    var packet = x[xi];
	    if (packet.id == 1)
	      docroot = packet;
	  }
	  var sheetrootref = parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[1][0].data);
	  entry = CFB.find(cfb, dependents[sheetrootref].location);
	  x = parse_iwa_file(decompress_iwa_file(entry.content));
	  for (xi = 0; xi < x.length; ++xi) {
	    packet = x[xi];
	    if (packet.id == sheetrootref)
	      docroot = packet;
	  }
	  sheetrootref = parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[2][0].data);
	  entry = CFB.find(cfb, dependents[sheetrootref].location);
	  x = parse_iwa_file(decompress_iwa_file(entry.content));
	  for (xi = 0; xi < x.length; ++xi) {
	    packet = x[xi];
	    if (packet.id == sheetrootref)
	      docroot = packet;
	  }
	  sheetrootref = parse_TSP_Reference(parse_shallow(docroot.messages[0].data)[2][0].data);
	  entry = CFB.find(cfb, dependents[sheetrootref].location);
	  x = parse_iwa_file(decompress_iwa_file(entry.content));
	  for (xi = 0; xi < x.length; ++xi) {
	    packet = x[xi];
	    if (packet.id == sheetrootref)
	      docroot = packet;
	  }
	  var pb = parse_shallow(docroot.messages[0].data);
	  {
	    pb[6][0].data = write_varint49(range.e.r + 1);
	    pb[7][0].data = write_varint49(range.e.c + 1);
	    var cruidsref = parse_TSP_Reference(pb[46][0].data);
	    var oldbucket = CFB.find(cfb, dependents[cruidsref].location);
	    var _x = parse_iwa_file(decompress_iwa_file(oldbucket.content));
	    {
	      for (var j = 0; j < _x.length; ++j) {
	        if (_x[j].id == cruidsref)
	          break;
	      }
	      if (_x[j].id != cruidsref)
	        throw "Bad ColumnRowUIDMapArchive";
	      var cruids = parse_shallow(_x[j].messages[0].data);
	      cruids[1] = [];
	      cruids[2] = [], cruids[3] = [];
	      for (var C = 0; C <= range.e.c; ++C) {
	        var uuid = [];
	        uuid[1] = uuid[2] = [{ type: 0, data: write_varint49(C + 420690) }];
	        cruids[1].push({ type: 2, data: write_shallow(uuid) });
	        cruids[2].push({ type: 0, data: write_varint49(C) });
	        cruids[3].push({ type: 0, data: write_varint49(C) });
	      }
	      cruids[4] = [];
	      cruids[5] = [], cruids[6] = [];
	      for (var R = 0; R <= range.e.r; ++R) {
	        uuid = [];
	        uuid[1] = uuid[2] = [{ type: 0, data: write_varint49(R + 726270) }];
	        cruids[4].push({ type: 2, data: write_shallow(uuid) });
	        cruids[5].push({ type: 0, data: write_varint49(R) });
	        cruids[6].push({ type: 0, data: write_varint49(R) });
	      }
	      _x[j].messages[0].data = write_shallow(cruids);
	    }
	    oldbucket.content = compress_iwa_file(write_iwa_file(_x));
	    oldbucket.size = oldbucket.content.length;
	    delete pb[46];
	    var store = parse_shallow(pb[4][0].data);
	    {
	      store[7][0].data = write_varint49(range.e.r + 1);
	      var row_headers = parse_shallow(store[1][0].data);
	      var row_header_ref = parse_TSP_Reference(row_headers[2][0].data);
	      oldbucket = CFB.find(cfb, dependents[row_header_ref].location);
	      _x = parse_iwa_file(decompress_iwa_file(oldbucket.content));
	      {
	        if (_x[0].id != row_header_ref)
	          throw "Bad HeaderStorageBucket";
	        var base_bucket = parse_shallow(_x[0].messages[0].data);
	        for (R = 0; R < data.length; ++R) {
	          var _bucket = parse_shallow(base_bucket[2][0].data);
	          _bucket[1][0].data = write_varint49(R);
	          _bucket[4][0].data = write_varint49(data[R].length);
	          base_bucket[2][R] = { type: base_bucket[2][0].type, data: write_shallow(_bucket) };
	        }
	        _x[0].messages[0].data = write_shallow(base_bucket);
	      }
	      oldbucket.content = compress_iwa_file(write_iwa_file(_x));
	      oldbucket.size = oldbucket.content.length;
	      var col_header_ref = parse_TSP_Reference(store[2][0].data);
	      oldbucket = CFB.find(cfb, dependents[col_header_ref].location);
	      _x = parse_iwa_file(decompress_iwa_file(oldbucket.content));
	      {
	        if (_x[0].id != col_header_ref)
	          throw "Bad HeaderStorageBucket";
	        base_bucket = parse_shallow(_x[0].messages[0].data);
	        for (C = 0; C <= range.e.c; ++C) {
	          _bucket = parse_shallow(base_bucket[2][0].data);
	          _bucket[1][0].data = write_varint49(C);
	          _bucket[4][0].data = write_varint49(range.e.r + 1);
	          base_bucket[2][C] = { type: base_bucket[2][0].type, data: write_shallow(_bucket) };
	        }
	        _x[0].messages[0].data = write_shallow(base_bucket);
	      }
	      oldbucket.content = compress_iwa_file(write_iwa_file(_x));
	      oldbucket.size = oldbucket.content.length;
	      var sstref = parse_TSP_Reference(store[4][0].data);
	      (function() {
	        var sentry = CFB.find(cfb, dependents[sstref].location);
	        var sx = parse_iwa_file(decompress_iwa_file(sentry.content));
	        var sstroot;
	        for (var sxi = 0; sxi < sx.length; ++sxi) {
	          var packet2 = sx[sxi];
	          if (packet2.id == sstref)
	            sstroot = packet2;
	        }
	        var sstdata = parse_shallow(sstroot.messages[0].data);
	        {
	          sstdata[3] = [];
	          var newsst = [];
	          SST.forEach(function(str, i) {
	            newsst[1] = [{ type: 0, data: write_varint49(i) }];
	            newsst[2] = [{ type: 0, data: write_varint49(1) }];
	            newsst[3] = [{ type: 2, data: stru8(str) }];
	            sstdata[3].push({ type: 2, data: write_shallow(newsst) });
	          });
	        }
	        sstroot.messages[0].data = write_shallow(sstdata);
	        var sy = write_iwa_file(sx);
	        var raw32 = compress_iwa_file(sy);
	        sentry.content = raw32;
	        sentry.size = sentry.content.length;
	      })();
	      var tile = parse_shallow(store[3][0].data);
	      {
	        var t = tile[1][0];
	        delete tile[2];
	        var tl = parse_shallow(t.data);
	        {
	          var tileref = parse_TSP_Reference(tl[2][0].data);
	          (function() {
	            var tentry = CFB.find(cfb, dependents[tileref].location);
	            var tx = parse_iwa_file(decompress_iwa_file(tentry.content));
	            var tileroot;
	            for (var sxi = 0; sxi < tx.length; ++sxi) {
	              var packet2 = tx[sxi];
	              if (packet2.id == tileref)
	                tileroot = packet2;
	            }
	            var tiledata = parse_shallow(tileroot.messages[0].data);
	            {
	              delete tiledata[6];
	              delete tile[7];
	              var rowload = new Uint8Array(tiledata[5][0].data);
	              tiledata[5] = [];
	              var cnt = 0;
	              for (var R2 = 0; R2 <= range.e.r; ++R2) {
	                var tilerow = parse_shallow(rowload);
	                cnt += write_tile_row(tilerow, data[R2], SST);
	                tilerow[1][0].data = write_varint49(R2);
	                tiledata[5].push({ data: write_shallow(tilerow), type: 2 });
	              }
	              tiledata[1] = [{ type: 0, data: write_varint49(range.e.c + 1) }];
	              tiledata[2] = [{ type: 0, data: write_varint49(range.e.r + 1) }];
	              tiledata[3] = [{ type: 0, data: write_varint49(cnt) }];
	              tiledata[4] = [{ type: 0, data: write_varint49(range.e.r + 1) }];
	            }
	            tileroot.messages[0].data = write_shallow(tiledata);
	            var ty = write_iwa_file(tx);
	            var raw32 = compress_iwa_file(ty);
	            tentry.content = raw32;
	            tentry.size = tentry.content.length;
	          })();
	        }
	        t.data = write_shallow(tl);
	      }
	      store[3][0].data = write_shallow(tile);
	    }
	    pb[4][0].data = write_shallow(store);
	  }
	  docroot.messages[0].data = write_shallow(pb);
	  var y = write_iwa_file(x);
	  var raw3 = compress_iwa_file(y);
	  entry.content = raw3;
	  entry.size = entry.content.length;
	  return cfb;
	}
	function fix_opts_func(defaults) {
		return function fix_opts(opts) {
			for(var i = 0; i != defaults.length; ++i) {
				var d = defaults[i];
				if(opts[d[0]] === undefined) opts[d[0]] = d[1];
				if(d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
			}
		};
	}
	
	function fix_read_opts(opts) {
	fix_opts_func([
		['cellNF', false], /* emit cell number format string as .z */
		['cellHTML', true], /* emit html string as .h */
		['cellFormula', true], /* emit formulae as .f */
		['cellStyles', false], /* emits style/theme as .s */
		['cellText', true], /* emit formatted text as .w */
		['cellDates', false], /* emit date cells with type `d` */
	
		['sheetStubs', false], /* emit empty cells */
		['sheetRows', 0, 'n'], /* read n rows (0 = read all rows) */
	
		['bookDeps', false], /* parse calculation chains */
		['bookSheets', false], /* only try to get sheet names (no Sheets) */
		['bookProps', false], /* only try to get properties (no Sheets) */
		['bookFiles', false], /* include raw file structure (keys, files, cfb) */
		['bookVBA', false], /* include vba raw data (vbaraw) */
	
		['password',''], /* password */
		['WTF', false] /* WTF mode (throws errors) */
	])(opts);
	}
	
	function fix_write_opts(opts) {
	fix_opts_func([
		['cellDates', false], /* write date cells with type `d` */
	
		['bookSST', false], /* Generate Shared String Table */
	
		['bookType', 'xlsx'], /* Type of workbook (xlsx/m/b) */
	
		['compression', false], /* Use file compression */
	
		['WTF', false] /* WTF mode (throws errors) */
	])(opts);
	}
	function get_sheet_type(n) {
		if(RELS.WS.indexOf(n) > -1) return "sheet";
		if(RELS.CS && n == RELS.CS) return "chart";
		if(RELS.DS && n == RELS.DS) return "dialog";
		if(RELS.MS && n == RELS.MS) return "macro";
		return (n && n.length) ? n : "sheet";
	}
	function safe_parse_wbrels(wbrels, sheets) {
		if(!wbrels) return 0;
		try {
			wbrels = sheets.map(function pwbr(w) { if(!w.id) w.id = w.strRelID; return [w.name, wbrels['!id'][w.id].Target, get_sheet_type(wbrels['!id'][w.id].Type)]; });
		} catch(e) { return null; }
		return !wbrels || wbrels.length === 0 ? null : wbrels;
	}
	
	function safe_parse_sheet(zip, path, relsPath, sheet, idx, sheetRels, sheets, stype, opts, wb, themes, styles) {
		try {
			sheetRels[sheet]=parse_rels(getzipstr(zip, relsPath, true), path);
			var data = getzipdata(zip, path);
			var _ws;
			switch(stype) {
				case 'sheet':  _ws = parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
				case 'chart':  _ws = parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
					if(!_ws || !_ws['!drawel']) break;
					var dfile = resolve_path(_ws['!drawel'].Target, path);
					var drelsp = get_rels_path(dfile);
					var draw = parse_drawing(getzipstr(zip, dfile, true), parse_rels(getzipstr(zip, drelsp, true), dfile));
					var chartp = resolve_path(draw, dfile);
					var crelsp = get_rels_path(chartp);
					_ws = parse_chart(getzipstr(zip, chartp, true), chartp, opts, parse_rels(getzipstr(zip, crelsp, true), chartp), wb, _ws);
					break;
				case 'macro':  _ws = parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
				case 'dialog': _ws = parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
				default: throw new Error("Unrecognized sheet type " + stype);
			}
			sheets[sheet] = _ws;
	
			/* scan rels for comments and threaded comments */
			var tcomments = [];
			if(sheetRels && sheetRels[sheet]) keys(sheetRels[sheet]).forEach(function(n) {
				var dfile = "";
				if(sheetRels[sheet][n].Type == RELS.CMNT) {
					dfile = resolve_path(sheetRels[sheet][n].Target, path);
					var comments = parse_cmnt(getzipdata(zip, dfile, true), dfile, opts);
					if(!comments || !comments.length) return;
					sheet_insert_comments(_ws, comments, false);
				}
				if(sheetRels[sheet][n].Type == RELS.TCMNT) {
					dfile = resolve_path(sheetRels[sheet][n].Target, path);
					tcomments = tcomments.concat(parse_tcmnt_xml(getzipdata(zip, dfile, true), opts));
				}
			});
			if(tcomments && tcomments.length) sheet_insert_comments(_ws, tcomments, true, opts.people || []);
		} catch(e) { if(opts.WTF) throw e; }
	}
	
	function strip_front_slash(x) { return x.charAt(0) == '/' ? x.slice(1) : x; }
	
	function parse_zip(zip, opts) {
		make_ssf();
		opts = opts || {};
		fix_read_opts(opts);
	
		/* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */
		if(safegetzipfile(zip, 'META-INF/manifest.xml')) return parse_ods(zip, opts);
		/* UOC */
		if(safegetzipfile(zip, 'objectdata.xml')) return parse_ods(zip, opts);
		/* Numbers */
		if(safegetzipfile(zip, 'Index/Document.iwa')) {
			if(typeof Uint8Array == "undefined") throw new Error('NUMBERS file parsing requires Uint8Array support');
			if(typeof parse_numbers_iwa != "undefined") {
				if(zip.FileIndex) return parse_numbers_iwa(zip);
				var _zip = CFB.utils.cfb_new();
				zipentries(zip).forEach(function(e) { zip_add_file(_zip, e, getzipbin(zip, e)); });
				return parse_numbers_iwa(_zip);
			}
			throw new Error('Unsupported NUMBERS file');
		}
		if(!safegetzipfile(zip, '[Content_Types].xml')) {
			if(safegetzipfile(zip, 'index.xml.gz')) throw new Error('Unsupported NUMBERS 08 file');
			if(safegetzipfile(zip, 'index.xml')) throw new Error('Unsupported NUMBERS 09 file');
			throw new Error('Unsupported ZIP file');
		}
	
		var entries = zipentries(zip);
		var dir = parse_ct((getzipstr(zip, '[Content_Types].xml')));
		var xlsb = false;
		var sheets, binname;
		if(dir.workbooks.length === 0) {
			binname = "xl/workbook.xml";
			if(getzipdata(zip,binname, true)) dir.workbooks.push(binname);
		}
		if(dir.workbooks.length === 0) {
			binname = "xl/workbook.bin";
			if(!getzipdata(zip,binname,true)) throw new Error("Could not find workbook");
			dir.workbooks.push(binname);
			xlsb = true;
		}
		if(dir.workbooks[0].slice(-3) == "bin") xlsb = true;
	
		var themes = ({});
		var styles = ({});
		if(!opts.bookSheets && !opts.bookProps) {
			strs = [];
			if(dir.sst) try { strs=parse_sst(getzipdata(zip, strip_front_slash(dir.sst)), dir.sst, opts); } catch(e) { if(opts.WTF) throw e; }
	
			if(opts.cellStyles && dir.themes.length) themes = parse_theme(getzipstr(zip, dir.themes[0].replace(/^\//,''), true)||"",dir.themes[0], opts);
	
			if(dir.style) styles = parse_sty(getzipdata(zip, strip_front_slash(dir.style)), dir.style, themes, opts);
		}
	
		/*var externbooks = */dir.links.map(function(link) {
			try {
				var rels = parse_rels(getzipstr(zip, get_rels_path(strip_front_slash(link))), link);
				return parse_xlink(getzipdata(zip, strip_front_slash(link)), rels, link, opts);
			} catch(e) {}
		});
	
		var wb = parse_wb(getzipdata(zip, strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
	
		var props = {}, propdata = "";
	
		if(dir.coreprops.length) {
			propdata = getzipdata(zip, strip_front_slash(dir.coreprops[0]), true);
			if(propdata) props = parse_core_props(propdata);
			if(dir.extprops.length !== 0) {
				propdata = getzipdata(zip, strip_front_slash(dir.extprops[0]), true);
				if(propdata) parse_ext_props(propdata, props, opts);
			}
		}
	
		var custprops = {};
		if(!opts.bookSheets || opts.bookProps) {
			if (dir.custprops.length !== 0) {
				propdata = getzipstr(zip, strip_front_slash(dir.custprops[0]), true);
				if(propdata) custprops = parse_cust_props(propdata, opts);
			}
		}
	
		var out = ({});
		if(opts.bookSheets || opts.bookProps) {
			if(wb.Sheets) sheets = wb.Sheets.map(function pluck(x){ return x.name; });
			else if(props.Worksheets && props.SheetNames.length > 0) sheets=props.SheetNames;
			if(opts.bookProps) { out.Props = props; out.Custprops = custprops; }
			if(opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
			if(opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
		}
		sheets = {};
	
		var deps = {};
		if(opts.bookDeps && dir.calcchain) deps=parse_cc(getzipdata(zip, strip_front_slash(dir.calcchain)),dir.calcchain,opts);
	
		var i=0;
		var sheetRels = ({});
		var path, relsPath;
	
		{
			var wbsheets = wb.Sheets;
			props.Worksheets = wbsheets.length;
			props.SheetNames = [];
			for(var j = 0; j != wbsheets.length; ++j) {
				props.SheetNames[j] = wbsheets[j].name;
			}
		}
	
		var wbext = xlsb ? "bin" : "xml";
		var wbrelsi = dir.workbooks[0].lastIndexOf("/");
		var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi+1) + "_rels/" + dir.workbooks[0].slice(wbrelsi+1) + ".rels").replace(/^\//,"");
		if(!safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
		var wbrels = parse_rels(getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));
	
		if((dir.metadata || []).length >= 1) {
			/* TODO: MDX and other types of metadata */
			opts.xlmeta = parse_xlmeta(getzipdata(zip, strip_front_slash(dir.metadata[0])),dir.metadata[0],opts);
		}
	
		if((dir.people || []).length >= 1) {
			opts.people = parse_people_xml(getzipdata(zip, strip_front_slash(dir.people[0])),opts);
		}
	
		if(wbrels) wbrels = safe_parse_wbrels(wbrels, wb.Sheets);
	
		/* Numbers iOS hack */
		var nmode = (getzipdata(zip,"xl/worksheets/sheet.xml",true))?1:0;
		wsloop: for(i = 0; i != props.Worksheets; ++i) {
			var stype = "sheet";
			if(wbrels && wbrels[i]) {
				path = 'xl/' + (wbrels[i][1]).replace(/[\/]?xl\//, "");
				if(!safegetzipfile(zip, path)) path = wbrels[i][1];
				if(!safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/,"") + wbrels[i][1];
				stype = wbrels[i][2];
			} else {
				path = 'xl/worksheets/sheet'+(i+1-nmode)+"." + wbext;
				path = path.replace(/sheet0\./,"sheet.");
			}
			relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
			if(opts && opts.sheets != null) switch(typeof opts.sheets) {
				case "number": if(i != opts.sheets) continue wsloop; break;
				case "string": if(props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop; break;
				default: if(Array.isArray && Array.isArray(opts.sheets)) {
					var snjseen = false;
					for(var snj = 0; snj != opts.sheets.length; ++snj) {
						if(typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen=1;
						if(typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
					}
					if(!snjseen) continue wsloop;
				}
			}
			safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
		}
	
		out = ({
			Directory: dir,
			Workbook: wb,
			Props: props,
			Custprops: custprops,
			Deps: deps,
			Sheets: sheets,
			SheetNames: props.SheetNames,
			Strings: strs,
			Styles: styles,
			Themes: themes,
			SSF: dup(table_fmt)
		});
		if(opts && opts.bookFiles) {
			if(zip.files) {
				out.keys = entries;
				out.files = zip.files;
			} else {
				out.keys = [];
				out.files = {};
				zip.FullPaths.forEach(function(p, idx) {
					p = p.replace(/^Root Entry[\/]/, "");
					out.keys.push(p);
					out.files[p] = zip.FileIndex[idx];
				});
			}
		}
		if(opts && opts.bookVBA) {
			if(dir.vba.length > 0) out.vbaraw = getzipdata(zip,strip_front_slash(dir.vba[0]),true);
			else if(dir.defaults && dir.defaults.bin === CT_VBA) out.vbaraw = getzipdata(zip, 'xl/vbaProject.bin',true);
		}
		return out;
	}
	
	/* [MS-OFFCRYPTO] 2.1.1 */
	function parse_xlsxcfb(cfb, _opts) {
		var opts = _opts || {};
		var f = 'Workbook', data = CFB.find(cfb, f);
		try {
		f = '/!DataSpaces/Version';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		/*var version = */parse_DataSpaceVersionInfo(data.content);
	
		/* 2.3.4.1 */
		f = '/!DataSpaces/DataSpaceMap';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var dsm = parse_DataSpaceMap(data.content);
		if(dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage")
			throw new Error("ECMA-376 Encrypted file bad " + f);
	
		/* 2.3.4.2 */
		f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var seds = parse_DataSpaceDefinition(data.content);
		if(seds.length != 1 || seds[0] != "StrongEncryptionTransform")
			throw new Error("ECMA-376 Encrypted file bad " + f);
	
		/* 2.3.4.3 */
		f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		/*var hdr = */parse_Primary(data.content);
		} catch(e) {}
	
		f = '/EncryptionInfo';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var einfo = parse_EncryptionInfo(data.content);
	
		/* 2.3.4.4 */
		f = '/EncryptedPackage';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	
	/*global decrypt_agile */
	if(einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
	/*global decrypt_std76 */
	if(einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
		throw new Error("File is password-protected");
	}
	
	function write_zip(wb, opts) {
		if(opts.bookType == "ods") return write_ods(wb, opts);
		if(opts.bookType == "numbers") return write_numbers_iwa(wb, opts);
		if(opts.bookType == "xlsb") return write_zip_xlsxb(wb, opts);
		return write_zip_xlsx(wb, opts);
	}
	
	/* XLSX and XLSB writing are very similar.  Originally they were unified in one
	   export function.  This is horrible for tree shaking in the common case (most
	   applications need to export files in one format) so this function supports
	   both formats while write_zip_xlsx only handles XLSX */
	function write_zip_xlsxb(wb, opts) {
		_shapeid = 1024;
		if(wb && !wb.SSF) {
			wb.SSF = dup(table_fmt);
		}
		if(wb && wb.SSF) {
			make_ssf(); SSF_load_table(wb.SSF);
			// $FlowIgnore
			opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
			opts.ssf = wb.SSF;
		}
		opts.rels = {}; opts.wbrels = {};
		opts.Strings = []; opts.Strings.Count = 0; opts.Strings.Unique = 0;
		if(browser_has_Map) opts.revStrings = new Map();
		else { opts.revStrings = {}; opts.revStrings.foo = []; delete opts.revStrings.foo; }
		var wbext = opts.bookType == "xlsb" ? "bin" : "xml";
		var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
		var ct = new_ct();
		fix_write_opts(opts = opts || {});
		var zip = zip_new();
		var f = "", rId = 0;
	
		opts.cellXfs = [];
		get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
	
		if(!wb.Props) wb.Props = {};
	
		f = "docProps/core.xml";
		zip_add_file(zip, f, write_core_props(wb.Props, opts));
		ct.coreprops.push(f);
		add_rels(opts.rels, 2, f, RELS.CORE_PROPS);
	
	f = "docProps/app.xml";
		if(wb.Props && wb.Props.SheetNames){/* empty */}
		else if(!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
		else {
			var _sn = [];
			for(var _i = 0; _i < wb.SheetNames.length; ++_i)
				if((wb.Workbook.Sheets[_i]||{}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
			wb.Props.SheetNames = _sn;
		}
		wb.Props.Worksheets = wb.Props.SheetNames.length;
		zip_add_file(zip, f, write_ext_props(wb.Props, opts));
		ct.extprops.push(f);
		add_rels(opts.rels, 3, f, RELS.EXT_PROPS);
	
		if(wb.Custprops !== wb.Props && keys(wb.Custprops||{}).length > 0) {
			f = "docProps/custom.xml";
			zip_add_file(zip, f, write_cust_props(wb.Custprops, opts));
			ct.custprops.push(f);
			add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
		}
	
		for(rId=1;rId <= wb.SheetNames.length; ++rId) {
			var wsrels = {'!id':{}};
			var ws = wb.Sheets[wb.SheetNames[rId-1]];
			var _type = (ws || {})["!type"] || "sheet";
			switch(_type) {
			case "chart":
				/* falls through */
			default:
				f = "xl/worksheets/sheet" + rId + "." + wbext;
				zip_add_file(zip, f, write_ws(rId-1, f, opts, wb, wsrels));
				ct.sheets.push(f);
				add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
			}
	
			if(ws) {
				var comments = ws['!comments'];
				var need_vml = false;
				var cf = "";
				if(comments && comments.length > 0) {
					cf = "xl/comments" + rId + "." + wbext;
					zip_add_file(zip, cf, write_cmnt(comments, cf, opts));
					ct.comments.push(cf);
					add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
					need_vml = true;
				}
				if(ws['!legacy']) {
					if(need_vml) zip_add_file(zip, "xl/drawings/vmlDrawing" + (rId) + ".vml", write_comments_vml(rId, ws['!comments']));
				}
				delete ws['!comments'];
				delete ws['!legacy'];
			}
	
			if(wsrels['!id'].rId1) zip_add_file(zip, get_rels_path(f), write_rels(wsrels));
		}
	
		if(opts.Strings != null && opts.Strings.length > 0) {
			f = "xl/sharedStrings." + wbext;
			zip_add_file(zip, f, write_sst(opts.Strings, f, opts));
			ct.strs.push(f);
			add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
		}
	
		f = "xl/workbook." + wbext;
		zip_add_file(zip, f, write_wb(wb, f, opts));
		ct.workbooks.push(f);
		add_rels(opts.rels, 1, f, RELS.WB);
	
		/* TODO: something more intelligent with themes */
	
		f = "xl/theme/theme1.xml";
		zip_add_file(zip, f, write_theme(wb.Themes, opts));
		ct.themes.push(f);
		add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);
	
		/* TODO: something more intelligent with styles */
	
		f = "xl/styles." + wbext;
		zip_add_file(zip, f, write_sty(wb, f, opts));
		ct.styles.push(f);
		add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);
	
		if(wb.vbaraw && vbafmt) {
			f = "xl/vbaProject.bin";
			zip_add_file(zip, f, wb.vbaraw);
			ct.vba.push(f);
			add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
		}
	
		f = "xl/metadata." + wbext;
		zip_add_file(zip, f, write_xlmeta(f));
		ct.metadata.push(f);
		add_rels(opts.wbrels, -1, "metadata." + wbext, RELS.XLMETA);
	
		zip_add_file(zip, "[Content_Types].xml", write_ct(ct, opts));
		zip_add_file(zip, '_rels/.rels', write_rels(opts.rels));
		zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));
	
		delete opts.revssf; delete opts.ssf;
		return zip;
	}
	
	function write_zip_xlsx(wb, opts) {
		_shapeid = 1024;
		if(wb && !wb.SSF) {
			wb.SSF = dup(table_fmt);
		}
		if(wb && wb.SSF) {
			make_ssf(); SSF_load_table(wb.SSF);
			// $FlowIgnore
			opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
			opts.ssf = wb.SSF;
		}
		opts.rels = {}; opts.wbrels = {};
		opts.Strings = []; opts.Strings.Count = 0; opts.Strings.Unique = 0;
		if(browser_has_Map) opts.revStrings = new Map();
		else { opts.revStrings = {}; opts.revStrings.foo = []; delete opts.revStrings.foo; }
		var wbext = "xml";
		var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
		var ct = new_ct();
		fix_write_opts(opts = opts || {});
		var zip = zip_new();
		var f = "", rId = 0;
	
		opts.cellXfs = [];
		get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
	
		if(!wb.Props) wb.Props = {};
	
		f = "docProps/core.xml";
		zip_add_file(zip, f, write_core_props(wb.Props, opts));
		ct.coreprops.push(f);
		add_rels(opts.rels, 2, f, RELS.CORE_PROPS);
	
	f = "docProps/app.xml";
		if(wb.Props && wb.Props.SheetNames){/* empty */}
		else if(!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
		else {
			var _sn = [];
			for(var _i = 0; _i < wb.SheetNames.length; ++_i)
				if((wb.Workbook.Sheets[_i]||{}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
			wb.Props.SheetNames = _sn;
		}
		wb.Props.Worksheets = wb.Props.SheetNames.length;
		zip_add_file(zip, f, write_ext_props(wb.Props, opts));
		ct.extprops.push(f);
		add_rels(opts.rels, 3, f, RELS.EXT_PROPS);
	
		if(wb.Custprops !== wb.Props && keys(wb.Custprops||{}).length > 0) {
			f = "docProps/custom.xml";
			zip_add_file(zip, f, write_cust_props(wb.Custprops, opts));
			ct.custprops.push(f);
			add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
		}
	
		var people = ["SheetJ5"];
		opts.tcid = 0;
	
		for(rId=1;rId <= wb.SheetNames.length; ++rId) {
			var wsrels = {'!id':{}};
			var ws = wb.Sheets[wb.SheetNames[rId-1]];
			var _type = (ws || {})["!type"] || "sheet";
			switch(_type) {
			case "chart":
				/* falls through */
			default:
				f = "xl/worksheets/sheet" + rId + "." + wbext;
				zip_add_file(zip, f, write_ws_xml(rId-1, opts, wb, wsrels));
				ct.sheets.push(f);
				add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
			}
	
			if(ws) {
				var comments = ws['!comments'];
				var need_vml = false;
				var cf = "";
				if(comments && comments.length > 0) {
					var needtc = false;
					comments.forEach(function(carr) {
						carr[1].forEach(function(c) { if(c.T == true) needtc = true; });
					});
					if(needtc) {
						cf = "xl/threadedComments/threadedComment" + rId + "." + wbext;
						zip_add_file(zip, cf, write_tcmnt_xml(comments, people, opts));
						ct.threadedcomments.push(cf);
						add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + "." + wbext, RELS.TCMNT);
					}
	
					cf = "xl/comments" + rId + "." + wbext;
					zip_add_file(zip, cf, write_comments_xml(comments, opts));
					ct.comments.push(cf);
					add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
					need_vml = true;
				}
				if(ws['!legacy']) {
					if(need_vml) zip_add_file(zip, "xl/drawings/vmlDrawing" + (rId) + ".vml", write_comments_vml(rId, ws['!comments']));
				}
				delete ws['!comments'];
				delete ws['!legacy'];
			}
	
			if(wsrels['!id'].rId1) zip_add_file(zip, get_rels_path(f), write_rels(wsrels));
		}
	
		if(opts.Strings != null && opts.Strings.length > 0) {
			f = "xl/sharedStrings." + wbext;
			zip_add_file(zip, f, write_sst_xml(opts.Strings, opts));
			ct.strs.push(f);
			add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
		}
	
		f = "xl/workbook." + wbext;
		zip_add_file(zip, f, write_wb_xml(wb, opts));
		ct.workbooks.push(f);
		add_rels(opts.rels, 1, f, RELS.WB);
	
		/* TODO: something more intelligent with themes */
	
		f = "xl/theme/theme1.xml";
		zip_add_file(zip, f, write_theme(wb.Themes, opts));
		ct.themes.push(f);
		add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);
	
		/* TODO: something more intelligent with styles */
	
		f = "xl/styles." + wbext;
		zip_add_file(zip, f, write_sty_xml(wb, opts));
		ct.styles.push(f);
		add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);
	
		if(wb.vbaraw && vbafmt) {
			f = "xl/vbaProject.bin";
			zip_add_file(zip, f, wb.vbaraw);
			ct.vba.push(f);
			add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
		}
	
		f = "xl/metadata." + wbext;
		zip_add_file(zip, f, write_xlmeta_xml());
		ct.metadata.push(f);
		add_rels(opts.wbrels, -1, "metadata." + wbext, RELS.XLMETA);
	
		if(people.length > 1) {
			f = "xl/persons/person.xml";
			zip_add_file(zip, f, write_people_xml(people, opts));
			ct.people.push(f);
			add_rels(opts.wbrels, -1, "persons/person.xml", RELS.PEOPLE);
		}
	
		zip_add_file(zip, "[Content_Types].xml", write_ct(ct, opts));
		zip_add_file(zip, '_rels/.rels', write_rels(opts.rels));
		zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));
	
		delete opts.revssf; delete opts.ssf;
		return zip;
	}
	
	function firstbyte(f,o) {
		var x = "";
		switch((o||{}).type || "base64") {
			case 'buffer': return [f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7]];
			case 'base64': x = Base64_decode(f.slice(0,12)); break;
			case 'binary': x = f; break;
			case 'array':  return [f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7]];
			default: throw new Error("Unrecognized type " + (o && o.type || "undefined"));
		}
		return [x.charCodeAt(0), x.charCodeAt(1), x.charCodeAt(2), x.charCodeAt(3), x.charCodeAt(4), x.charCodeAt(5), x.charCodeAt(6), x.charCodeAt(7)];
	}
	
	function read_cfb(cfb, opts) {
		if(CFB.find(cfb, "EncryptedPackage")) return parse_xlsxcfb(cfb, opts);
		return parse_xlscfb(cfb, opts);
	}
	
	function read_zip(data, opts) {
		var zip, d = data;
		var o = opts||{};
		if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
		zip = zip_read(d, o);
		return parse_zip(zip, o);
	}
	
	function read_plaintext(data, o) {
		var i = 0;
		main: while(i < data.length) switch(data.charCodeAt(i)) {
			case 0x0A: case 0x0D: case 0x20: ++i; break;
			case 0x3C: return parse_xlml(data.slice(i),o);
			default: break main;
		}
		return PRN.to_workbook(data, o);
	}
	
	function read_plaintext_raw(data, o) {
		var str = "", bytes = firstbyte(data, o);
		switch(o.type) {
			case 'base64': str = Base64_decode(data); break;
			case 'binary': str = data; break;
			case 'buffer': str = data.toString('binary'); break;
			case 'array': str = cc2str(data); break;
			default: throw new Error("Unrecognized type " + o.type);
		}
		if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str);
		o.type = "binary";
		return read_plaintext(str, o);
	}
	
	function read_utf16(data, o) {
		var d = data;
		if(o.type == 'base64') d = Base64_decode(d);
		d = $cptable.utils.decode(1200, d.slice(2), 'str');
		o.type = "binary";
		return read_plaintext(d, o);
	}
	
	function bstrify(data) {
		return !data.match(/[^\x00-\x7F]/) ? data : utf8write(data);
	}
	
	function read_prn(data, d, o, str) {
		if(str) { o.type = "string"; return PRN.to_workbook(data, o); }
		return PRN.to_workbook(d, o);
	}
	
	function readSync(data, opts) {
		reset_cp();
		var o = opts||{};
		if(typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return readSync(new Uint8Array(data), (o = dup(o), o.type = "array", o));
		if(typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
		var d = data, n = [0,0,0,0], str = false;
		if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
		_ssfopts = {};
		if(o.dateNF) _ssfopts.dateNF = o.dateNF;
		if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
		if(o.type == "file") { o.type = has_buf ? "buffer" : "binary"; d = read_binary(data); if(typeof Uint8Array !== 'undefined' && !has_buf) o.type = "array"; }
		if(o.type == "string") { str = true; o.type = "binary"; o.codepage = 65001; d = bstrify(data); }
		if(o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
			// $FlowIgnore
			var ab=new ArrayBuffer(3), vu=new Uint8Array(ab); vu.foo="bar";
			// $FlowIgnore
			if(!vu.foo) {o=dup(o); o.type='array'; return readSync(ab2a(d), o);}
		}
		switch((n = firstbyte(d, o))[0]) {
			case 0xD0: if(n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return read_cfb(CFB.read(d, o), o); break;
			case 0x09: if(n[1] <= 0x08) return parse_xlscfb(d, o); break;
			case 0x3C: return parse_xlml(d, o);
			case 0x49:
				if(n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
				if(n[1] === 0x44) return read_wb_ID(d, o);
				break;
			case 0x54: if(n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return DIF.to_workbook(d, o); break;
			case 0x50: return (n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09) ? read_zip(d, o) : read_prn(data, d, o, str);
			case 0xEF: return n[3] === 0x3C ? parse_xlml(d, o) : read_prn(data, d, o, str);
			case 0xFF:
				if(n[1] === 0xFE) { return read_utf16(d, o); }
				else if(n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
				break;
			case 0x00:
				if(n[1] === 0x00) {
					if(n[2] >= 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
					if(n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return WK_.to_workbook(d, o);
				}
				break;
			case 0x03: case 0x83: case 0x8B: case 0x8C: return DBF.to_workbook(d, o);
			case 0x7B: if(n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return RTF.to_workbook(d, o); break;
			case 0x0A: case 0x0D: case 0x20: return read_plaintext_raw(d, o);
			case 0x89: if(n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet"); break;
		}
		if(DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return DBF.to_workbook(d, o);
		return read_prn(data, d, o, str);
	}
	
	function readFileSync(filename, opts) {
		var o = opts||{}; o.type = 'file';
		return readSync(filename, o);
	}
	function write_cfb_ctr(cfb, o) {
		switch(o.type) {
			case "base64": case "binary": break;
			case "buffer": case "array": o.type = ""; break;
			case "file": return write_dl(o.file, CFB.write(cfb, {type:has_buf ? 'buffer' : ""}));
			case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
			default: throw new Error("Unrecognized type " + o.type);
		}
		return CFB.write(cfb, o);
	}
	
	function write_zip_type(wb, opts) {
		var o = dup(opts||{});
		var z = write_zip(wb, o);
		return write_zip_denouement(z, o);
	}
	function write_zip_typeXLSX(wb, opts) {
		var o = dup(opts||{});
		var z = write_zip_xlsx(wb, o);
		return write_zip_denouement(z, o);
	}
	function write_zip_denouement(z, o) {
		var oopts = {};
		var ftype = has_buf ? "nodebuffer" : (typeof Uint8Array !== "undefined" ? "array" : "string");
		if(o.compression) oopts.compression = 'DEFLATE';
		if(o.password) oopts.type = ftype;
		else switch(o.type) {
			case "base64": oopts.type = "base64"; break;
			case "binary": oopts.type = "string"; break;
			case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
			case "buffer":
			case "file": oopts.type = ftype; break;
			default: throw new Error("Unrecognized type " + o.type);
		}
		var out = z.FullPaths ? CFB.write(z, {fileType:"zip", type: {"nodebuffer": "buffer", "string": "binary"}[oopts.type] || oopts.type, compression: !!o.compression}) : z.generate(oopts);
		if(typeof Deno !== "undefined") {
			if(typeof out == "string") {
				if(o.type == "binary" || o.type == "base64") return out;
				out = new Uint8Array(s2ab(out));
			}
		}
	/*jshint -W083 */
		if(o.password && typeof encrypt_agile !== 'undefined') return write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
	/*jshint +W083 */
		if(o.type === "file") return write_dl(o.file, out);
		return o.type == "string" ? utf8read(out) : out;
	}
	
	function write_cfb_type(wb, opts) {
		var o = opts||{};
		var cfb = write_xlscfb(wb, o);
		return write_cfb_ctr(cfb, o);
	}
	
	function write_string_type(out, opts, bom) {
		if(!bom) bom = "";
		var o = bom + out;
		switch(opts.type) {
			case "base64": return Base64_encode(utf8write(o));
			case "binary": return utf8write(o);
			case "string": return out;
			case "file": return write_dl(opts.file, o, 'utf8');
			case "buffer": {
				if(has_buf) return Buffer_from(o, 'utf8');
				else if(typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
				else return write_string_type(o, {type:'binary'}).split("").map(function(c) { return c.charCodeAt(0); });
			}
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	
	function write_stxt_type(out, opts) {
		switch(opts.type) {
			case "base64": return Base64_encode(out);
			case "binary": return out;
			case "string": return out; /* override in sheet_to_txt */
			case "file": return write_dl(opts.file, out, 'binary');
			case "buffer": {
				if(has_buf) return Buffer_from(out, 'binary');
				else return out.split("").map(function(c) { return c.charCodeAt(0); });
			}
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	
	/* TODO: test consistency */
	function write_binary_type(out, opts) {
		switch(opts.type) {
			case "string":
			case "base64":
			case "binary":
				var bstr = "";
				// $FlowIgnore
				for(var i = 0; i < out.length; ++i) bstr += String.fromCharCode(out[i]);
				return opts.type == 'base64' ? Base64_encode(bstr) : opts.type == 'string' ? utf8read(bstr) : bstr;
			case "file": return write_dl(opts.file, out);
			case "buffer": return out;
			default: throw new Error("Unrecognized type " + opts.type);
		}
	}
	
	function writeSyncXLSX(wb, opts) {
		reset_cp();
		check_wb(wb);
		var o = dup(opts||{});
		if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
		if(o.type == "array") { o.type = "binary"; var out = (writeSyncXLSX(wb, o)); o.type = "array"; return s2ab(out); }
		return write_zip_typeXLSX(wb, o);
	}
	
	function writeSync(wb, opts) {
		reset_cp();
		check_wb(wb);
		var o = dup(opts||{});
		if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
		if(o.type == "array") { o.type = "binary"; var out = (writeSync(wb, o)); o.type = "array"; return s2ab(out); }
		var idx = 0;
		if(o.sheet) {
			if(typeof o.sheet == "number") idx = o.sheet;
			else idx = wb.SheetNames.indexOf(o.sheet);
			if(!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + (typeof o.sheet));
		}
		switch(o.bookType || 'xlsb') {
			case 'xml':
			case 'xlml': return write_string_type(write_xlml(wb, o), o);
			case 'slk':
			case 'sylk': return write_string_type(SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'htm':
			case 'html': return write_string_type(sheet_to_html(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'txt': return write_stxt_type(sheet_to_txt(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'csv': return write_string_type(sheet_to_csv(wb.Sheets[wb.SheetNames[idx]], o), o, "\ufeff");
			case 'dif': return write_string_type(DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'dbf': return write_binary_type(DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'prn': return write_string_type(PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'rtf': return write_string_type(RTF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'eth': return write_string_type(ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'fods': return write_string_type(write_ods(wb, o), o);
			case 'wk1': return write_binary_type(WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]], o), o);
			case 'wk3': return write_binary_type(WK_.book_to_wk3(wb, o), o);
			case 'biff2': if(!o.biff) o.biff = 2; /* falls through */
			case 'biff3': if(!o.biff) o.biff = 3; /* falls through */
			case 'biff4': if(!o.biff) o.biff = 4; return write_binary_type(write_biff_buf(wb, o), o);
			case 'biff5': if(!o.biff) o.biff = 5; /* falls through */
			case 'biff8':
			case 'xla':
			case 'xls': if(!o.biff) o.biff = 8; return write_cfb_type(wb, o);
			case 'xlsx':
			case 'xlsm':
			case 'xlam':
			case 'xlsb':
			case 'numbers':
			case 'ods': return write_zip_type(wb, o);
			default: throw new Error ("Unrecognized bookType |" + o.bookType + "|");
		}
	}
	
	function resolve_book_type(o) {
		if(o.bookType) return;
		var _BT = {
			"xls": "biff8",
			"htm": "html",
			"slk": "sylk",
			"socialcalc": "eth",
			"Sh33tJS": "WTF"
		};
		var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
		if(ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
		o.bookType = _BT[o.bookType] || o.bookType;
	}
	
	function writeFileSync(wb, filename, opts) {
		var o = opts||{}; o.type = 'file';
		o.file = filename;
		resolve_book_type(o);
		return writeSync(wb, o);
	}
	
	function writeFileSyncXLSX(wb, filename, opts) {
		var o = opts||{}; o.type = 'file';
		o.file = filename;
		resolve_book_type(o);
		return writeSyncXLSX(wb, o);
	}
	
	
	function writeFileAsync(filename, wb, opts, cb) {
		var o = opts||{}; o.type = 'file';
		o.file = filename;
		resolve_book_type(o);
		o.type = 'buffer';
		var _cb = cb; if(!(_cb instanceof Function)) _cb = (opts);
		return _fs.writeFile(filename, writeSync(wb, o), _cb);
	}
	function make_json_row(sheet, r, R, cols, header, hdr, dense, o) {
		var rr = encode_row(R);
		var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
		var isempty = true;
		var row = (header === 1) ? [] : {};
		if(header !== 1) {
			if(Object.defineProperty) try { Object.defineProperty(row, '__rowNum__', {value:R, enumerable:false}); } catch(e) { row.__rowNum__ = R; }
			else row.__rowNum__ = R;
		}
		if(!dense || sheet[R]) for (var C = r.s.c; C <= r.e.c; ++C) {
			var val = dense ? sheet[R][C] : sheet[cols[C] + rr];
			if(val === undefined || val.t === undefined) {
				if(defval === undefined) continue;
				if(hdr[C] != null) { row[hdr[C]] = defval; }
				continue;
			}
			var v = val.v;
			switch(val.t){
				case 'z': if(v == null) break; continue;
				case 'e': v = (v == 0 ? null : void 0); break;
				case 's': case 'd': case 'b': case 'n': break;
				default: throw new Error('unrecognized type ' + val.t);
			}
			if(hdr[C] != null) {
				if(v == null) {
					if(val.t == "e" && v === null) row[hdr[C]] = null;
					else if(defval !== undefined) row[hdr[C]] = defval;
					else if(raw && v === null) row[hdr[C]] = null;
					else continue;
				} else {
					row[hdr[C]] = raw && (val.t !== "n" || (val.t === "n" && o.rawNumbers !== false)) ? v : format_cell(val,v,o);
				}
				if(v != null) isempty = false;
			}
		}
		return { row: row, isempty: isempty };
	}
	
	
	function sheet_to_json(sheet, opts) {
		if(sheet == null || sheet["!ref"] == null) return [];
		var val = {t:'n',v:0}, header = 0, offset = 1, hdr = [], v=0, vv="";
		var r = {s:{r:0,c:0},e:{r:0,c:0}};
		var o = opts || {};
		var range = o.range != null ? o.range : sheet["!ref"];
		if(o.header === 1) header = 1;
		else if(o.header === "A") header = 2;
		else if(Array.isArray(o.header)) header = 3;
		else if(o.header == null) header = 0;
		switch(typeof range) {
			case 'string': r = safe_decode_range(range); break;
			case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
			default: r = range;
		}
		if(header > 0) offset = 0;
		var rr = encode_row(r.s.r);
		var cols = [];
		var out = [];
		var outi = 0, counter = 0;
		var dense = Array.isArray(sheet);
		var R = r.s.r, C = 0;
		var header_cnt = {};
		if(dense && !sheet[R]) sheet[R] = [];
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(C = r.s.c; C <= r.e.c; ++C) {
			if(((colinfo[C]||{}).hidden)) continue;
			cols[C] = encode_col(C);
			val = dense ? sheet[R][C] : sheet[cols[C] + rr];
			switch(header) {
				case 1: hdr[C] = C - r.s.c; break;
				case 2: hdr[C] = cols[C]; break;
				case 3: hdr[C] = o.header[C - r.s.c]; break;
				default:
					if(val == null) val = {w: "__EMPTY", t: "s"};
					vv = v = format_cell(val, null, o);
					counter = header_cnt[v] || 0;
					if(!counter) header_cnt[v] = 1;
					else {
						do { vv = v + "_" + (counter++); } while(header_cnt[vv]); header_cnt[v] = counter;
						header_cnt[vv] = 1;
					}
					hdr[C] = vv;
			}
		}
		for (R = r.s.r + offset; R <= r.e.r; ++R) {
			if ((rowinfo[R]||{}).hidden) continue;
			var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
			if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
		}
		out.length = outi;
		return out;
	}
	
	var qreg = /"/g;
	function make_csv_row(sheet, r, R, cols, fs, rs, FS, o) {
		var isempty = true;
		var row = [], txt = "", rr = encode_row(R);
		for(var C = r.s.c; C <= r.e.c; ++C) {
			if (!cols[C]) continue;
			var val = o.dense ? (sheet[R]||[])[C]: sheet[cols[C] + rr];
			if(val == null) txt = "";
			else if(val.v != null) {
				isempty = false;
				txt = ''+(o.rawNumbers && val.t == "n" ? val.v : format_cell(val, null, o));
				for(var i = 0, cc = 0; i !== txt.length; ++i) if((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {txt = "\"" + txt.replace(qreg, '""') + "\""; break; }
				if(txt == "ID") txt = '"ID"';
			} else if(val.f != null && !val.F) {
				isempty = false;
				txt = '=' + val.f; if(txt.indexOf(",") >= 0) txt = '"' + txt.replace(qreg, '""') + '"';
			} else txt = "";
			/* NOTE: Excel CSV does not support array formulae */
			row.push(txt);
		}
		if(o.blankrows === false && isempty) return null;
		return row.join(FS);
	}
	
	function sheet_to_csv(sheet, opts) {
		var out = [];
		var o = opts == null ? {} : opts;
		if(sheet == null || sheet["!ref"] == null) return "";
		var r = safe_decode_range(sheet["!ref"]);
		var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
		var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
		var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
		var row = "", cols = [];
		o.dense = Array.isArray(sheet);
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
		var w = 0;
		for(var R = r.s.r; R <= r.e.r; ++R) {
			if ((rowinfo[R]||{}).hidden) continue;
			row = make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
			if(row == null) { continue; }
			if(o.strip) row = row.replace(endregex,"");
			if(row || (o.blankrows !== false)) out.push((w++ ? RS : "") + row);
		}
		delete o.dense;
		return out.join("");
	}
	
	function sheet_to_txt(sheet, opts) {
		if(!opts) opts = {}; opts.FS = "\t"; opts.RS = "\n";
		var s = sheet_to_csv(sheet, opts);
		if(typeof $cptable == 'undefined' || opts.type == 'string') return s;
		var o = $cptable.utils.encode(1200, s, 'str');
		return String.fromCharCode(255) + String.fromCharCode(254) + o;
	}
	
	function sheet_to_formulae(sheet) {
		var y = "", x, val="";
		if(sheet == null || sheet["!ref"] == null) return [];
		var r = safe_decode_range(sheet['!ref']), rr = "", cols = [], C;
		var cmds = [];
		var dense = Array.isArray(sheet);
		for(C = r.s.c; C <= r.e.c; ++C) cols[C] = encode_col(C);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			rr = encode_row(R);
			for(C = r.s.c; C <= r.e.c; ++C) {
				y = cols[C] + rr;
				x = dense ? (sheet[R]||[])[C] : sheet[y];
				val = "";
				if(x === undefined) continue;
				else if(x.F != null) {
					y = x.F;
					if(!x.f) continue;
					val = x.f;
					if(y.indexOf(":") == -1) y = y + ":" + y;
				}
				if(x.f != null) val = x.f;
				else if(x.t == 'z') continue;
				else if(x.t == 'n' && x.v != null) val = "" + x.v;
				else if(x.t == 'b') val = x.v ? "TRUE" : "FALSE";
				else if(x.w !== undefined) val = "'" + x.w;
				else if(x.v === undefined) continue;
				else if(x.t == 's') val = "'" + x.v;
				else val = ""+x.v;
				cmds[cmds.length] = y + "=" + val;
			}
		}
		return cmds;
	}
	
	function sheet_add_json(_ws, js, opts) {
		var o = opts || {};
		var offset = +!o.skipHeader;
		var ws = _ws || ({});
		var _R = 0, _C = 0;
		if(ws && o.origin != null) {
			if(typeof o.origin == 'number') _R = o.origin;
			else {
				var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
				_R = _origin.r; _C = _origin.c;
			}
		}
		var cell;
		var range = ({s: {c:0, r:0}, e: {c:_C, r:_R + js.length - 1 + offset}});
		if(ws['!ref']) {
			var _range = safe_decode_range(ws['!ref']);
			range.e.c = Math.max(range.e.c, _range.e.c);
			range.e.r = Math.max(range.e.r, _range.e.r);
			if(_R == -1) { _R = _range.e.r + 1; range.e.r = _R + js.length - 1 + offset; }
		} else {
			if(_R == -1) { _R = 0; range.e.r = js.length - 1 + offset; }
		}
		var hdr = o.header || [], C = 0;
	
		js.forEach(function (JS, R) {
			keys(JS).forEach(function(k) {
				if((C=hdr.indexOf(k)) == -1) hdr[C=hdr.length] = k;
				var v = JS[k];
				var t = 'z';
				var z = "";
				var ref = encode_cell({c:_C + C,r:_R + R + offset});
				cell = ws_get_cell_stub(ws, ref);
				if(v && typeof v === 'object' && !(v instanceof Date)){
					ws[ref] = v;
				} else {
					if(typeof v == 'number') t = 'n';
					else if(typeof v == 'boolean') t = 'b';
					else if(typeof v == 'string') t = 's';
					else if(v instanceof Date) {
						t = 'd';
						if(!o.cellDates) { t = 'n'; v = datenum(v); }
						z = (o.dateNF || table_fmt[14]);
					}
					else if(v === null && o.nullError) { t = 'e'; v = 0; }
					if(!cell) ws[ref] = cell = ({t:t, v:v});
					else {
						cell.t = t; cell.v = v;
						delete cell.w; delete cell.R;
						if(z) cell.z = z;
					}
					if(z) cell.z = z;
				}
			});
		});
		range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
		var __R = encode_row(_R);
		if(offset) for(C = 0; C < hdr.length; ++C) ws[encode_col(C + _C) + __R] = {t:'s', v:hdr[C]};
		ws['!ref'] = encode_range(range);
		return ws;
	}
	function json_to_sheet(js, opts) { return sheet_add_json(null, js, opts); }
	
	/* get cell, creating a stub if necessary */
	function ws_get_cell_stub(ws, R, C) {
		/* A1 cell address */
		if(typeof R == "string") {
			/* dense */
			if(Array.isArray(ws)) {
				var RC = decode_cell(R);
				if(!ws[RC.r]) ws[RC.r] = [];
				return ws[RC.r][RC.c] || (ws[RC.r][RC.c] = {t:'z'});
			}
			return ws[R] || (ws[R] = {t:'z'});
		}
		/* cell address object */
		if(typeof R != "number") return ws_get_cell_stub(ws, encode_cell(R));
		/* R and C are 0-based indices */
		return ws_get_cell_stub(ws, encode_cell({r:R,c:C||0}));
	}
	
	/* find sheet index for given name / validate index */
	function wb_sheet_idx(wb, sh) {
		if(typeof sh == "number") {
			if(sh >= 0 && wb.SheetNames.length > sh) return sh;
			throw new Error("Cannot find sheet # " + sh);
		} else if(typeof sh == "string") {
			var idx = wb.SheetNames.indexOf(sh);
			if(idx > -1) return idx;
			throw new Error("Cannot find sheet name |" + sh + "|");
		} else throw new Error("Cannot find sheet |" + sh + "|");
	}
	
	/* simple blank workbook object */
	function book_new() {
		return { SheetNames: [], Sheets: {} };
	}
	
	/* add a worksheet to the end of a given workbook */
	function book_append_sheet(wb, ws, name, roll) {
		var i = 1;
		if(!name) for(; i <= 0xFFFF; ++i, name = undefined) if(wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
		if(!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
		if(roll && wb.SheetNames.indexOf(name) >= 0) {
			var m = name.match(/(^.*?)(\d+)$/);
			i = m && +m[2] || 0;
			var root = m && m[1] || name;
			for(++i; i <= 0xFFFF; ++i) if(wb.SheetNames.indexOf(name = root + i) == -1) break;
		}
		check_ws_name(name);
		if(wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
	
		wb.SheetNames.push(name);
		wb.Sheets[name] = ws;
		return name;
	}
	
	/* set sheet visibility (visible/hidden/very hidden) */
	function book_set_sheet_visibility(wb, sh, vis) {
		if(!wb.Workbook) wb.Workbook = {};
		if(!wb.Workbook.Sheets) wb.Workbook.Sheets = [];
	
		var idx = wb_sheet_idx(wb, sh);
		// $FlowIgnore
		if(!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};
	
		switch(vis) {
			case 0: case 1: case 2: break;
			default: throw new Error("Bad sheet visibility setting " + vis);
		}
		// $FlowIgnore
		wb.Workbook.Sheets[idx].Hidden = vis;
	}
	
	/* set number format */
	function cell_set_number_format(cell, fmt) {
		cell.z = fmt;
		return cell;
	}
	
	/* set cell hyperlink */
	function cell_set_hyperlink(cell, target, tooltip) {
		if(!target) {
			delete cell.l;
		} else {
			cell.l = ({ Target: target });
			if(tooltip) cell.l.Tooltip = tooltip;
		}
		return cell;
	}
	function cell_set_internal_link(cell, range, tooltip) { return cell_set_hyperlink(cell, "#" + range, tooltip); }
	
	/* add to cell comments */
	function cell_add_comment(cell, text, author) {
		if(!cell.c) cell.c = [];
		cell.c.push({t:text, a:author||"SheetJS"});
	}
	
	/* set array formula and flush related cells */
	function sheet_set_array_formula(ws, range, formula, dynamic) {
		var rng = typeof range != "string" ? range : safe_decode_range(range);
		var rngstr = typeof range == "string" ? range : encode_range(range);
		for(var R = rng.s.r; R <= rng.e.r; ++R) for(var C = rng.s.c; C <= rng.e.c; ++C) {
			var cell = ws_get_cell_stub(ws, R, C);
			cell.t = 'n';
			cell.F = rngstr;
			delete cell.v;
			if(R == rng.s.r && C == rng.s.c) {
				cell.f = formula;
				if(dynamic) cell.D = true;
			}
		}
		return ws;
	}
	
	var utils = {
		encode_col: encode_col,
		encode_row: encode_row,
		encode_cell: encode_cell,
		encode_range: encode_range,
		decode_col: decode_col,
		decode_row: decode_row,
		split_cell: split_cell,
		decode_cell: decode_cell,
		decode_range: decode_range,
		format_cell: format_cell,
		sheet_add_aoa: sheet_add_aoa,
		sheet_add_json: sheet_add_json,
		sheet_add_dom: sheet_add_dom,
		aoa_to_sheet: aoa_to_sheet,
		json_to_sheet: json_to_sheet,
		table_to_sheet: parse_dom_table,
		table_to_book: table_to_book,
		sheet_to_csv: sheet_to_csv,
		sheet_to_txt: sheet_to_txt,
		sheet_to_json: sheet_to_json,
		sheet_to_html: sheet_to_html,
		sheet_to_formulae: sheet_to_formulae,
		sheet_to_row_object_array: sheet_to_json,
		sheet_get_cell: ws_get_cell_stub,
		book_new: book_new,
		book_append_sheet: book_append_sheet,
		book_set_sheet_visibility: book_set_sheet_visibility,
		cell_set_number_format: cell_set_number_format,
		cell_set_hyperlink: cell_set_hyperlink,
		cell_set_internal_link: cell_set_internal_link,
		cell_add_comment: cell_add_comment,
		sheet_set_array_formula: sheet_set_array_formula,
		consts: {
			SHEET_VISIBLE: 0,
			SHEET_HIDDEN: 1,
			SHEET_VERY_HIDDEN: 2
		}
	};
	
	var _Readable;
	function set_readable(R) { _Readable = R; }
	
	function write_csv_stream(sheet, opts) {
		var stream = _Readable();
		var o = opts == null ? {} : opts;
		if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
		var r = safe_decode_range(sheet["!ref"]);
		var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
		var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
		var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
		var row = "", cols = [];
		o.dense = Array.isArray(sheet);
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
		var R = r.s.r;
		var BOM = false, w = 0;
		stream._read = function() {
			if(!BOM) { BOM = true; return stream.push("\uFEFF"); }
			while(R <= r.e.r) {
				++R;
				if ((rowinfo[R-1]||{}).hidden) continue;
				row = make_csv_row(sheet, r, R-1, cols, fs, rs, FS, o);
				if(row != null) {
					if(o.strip) row = row.replace(endregex,"");
					if(row || (o.blankrows !== false)) return stream.push((w++ ? RS : "") + row);
				}
			}
			return stream.push(null);
		};
		return stream;
	}
	
	function write_html_stream(ws, opts) {
		var stream = _Readable();
	
		var o = opts || {};
		var header = o.header != null ? o.header : HTML_BEGIN;
		var footer = o.footer != null ? o.footer : HTML_END;
		stream.push(header);
		var r = decode_range(ws['!ref']);
		o.dense = Array.isArray(ws);
		stream.push(make_html_preamble(ws, r, o));
		var R = r.s.r;
		var end = false;
		stream._read = function() {
			if(R > r.e.r) {
				if(!end) { end = true; stream.push("</table>" + footer); }
				return stream.push(null);
			}
			while(R <= r.e.r) {
				stream.push(make_html_row(ws, r, R, o));
				++R;
				break;
			}
		};
		return stream;
	}
	
	function write_json_stream(sheet, opts) {
		var stream = _Readable({objectMode:true});
	
		if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
		var val = {t:'n',v:0}, header = 0, offset = 1, hdr = [], v=0, vv="";
		var r = {s:{r:0,c:0},e:{r:0,c:0}};
		var o = opts || {};
		var range = o.range != null ? o.range : sheet["!ref"];
		if(o.header === 1) header = 1;
		else if(o.header === "A") header = 2;
		else if(Array.isArray(o.header)) header = 3;
		switch(typeof range) {
			case 'string': r = safe_decode_range(range); break;
			case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
			default: r = range;
		}
		if(header > 0) offset = 0;
		var rr = encode_row(r.s.r);
		var cols = [];
		var counter = 0;
		var dense = Array.isArray(sheet);
		var R = r.s.r, C = 0;
		var header_cnt = {};
		if(dense && !sheet[R]) sheet[R] = [];
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(C = r.s.c; C <= r.e.c; ++C) {
			if(((colinfo[C]||{}).hidden)) continue;
			cols[C] = encode_col(C);
			val = dense ? sheet[R][C] : sheet[cols[C] + rr];
			switch(header) {
				case 1: hdr[C] = C - r.s.c; break;
				case 2: hdr[C] = cols[C]; break;
				case 3: hdr[C] = o.header[C - r.s.c]; break;
				default:
					if(val == null) val = {w: "__EMPTY", t: "s"};
					vv = v = format_cell(val, null, o);
					counter = header_cnt[v] || 0;
					if(!counter) header_cnt[v] = 1;
					else {
						do { vv = v + "_" + (counter++); } while(header_cnt[vv]); header_cnt[v] = counter;
						header_cnt[vv] = 1;
					}
					hdr[C] = vv;
			}
		}
		R = r.s.r + offset;
		stream._read = function() {
			while(R <= r.e.r) {
				if ((rowinfo[R-1]||{}).hidden) continue;
				var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
				++R;
				if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
					stream.push(row.row);
					return;
				}
			}
			return stream.push(null);
		};
		return stream;
	}
	
	var __stream = {
		to_json: write_json_stream,
		to_html: write_html_stream,
		to_csv: write_csv_stream,
	  set_readable: set_readable
	};
	if(typeof parse_xlscfb !== "undefined") XLSX.parse_xlscfb = parse_xlscfb;
	XLSX.parse_zip = parse_zip;
	XLSX.read = readSync; //xlsread
	XLSX.readFile = readFileSync; //readFile
	XLSX.readFileSync = readFileSync;
	XLSX.write = writeSync;
	XLSX.writeFile = writeFileSync;
	XLSX.writeFileSync = writeFileSync;
	XLSX.writeFileAsync = writeFileAsync;
	XLSX.utils = utils;
	XLSX.writeXLSX = writeSyncXLSX;
	XLSX.writeFileXLSX = writeFileSyncXLSX;
	XLSX.SSF = SSF;
	if(typeof __stream !== "undefined") XLSX.stream = __stream;
	if(typeof CFB !== "undefined") XLSX.CFB = CFB;
	if(true) {
	  var strmod = __webpack_require__(7343);
	  if((strmod||{}).Readable) set_readable(strmod.Readable);
	}
	}
	/*global define */
	if(true) make_xlsx_lib(exports);
	else if(typeof module !== 'undefined' && module.exports) make_xlsx_lib(module.exports);
	else if(typeof define === 'function' && define.amd) define('xlsx', function() { if(!XLSX.version) make_xlsx_lib(XLSX); return XLSX; });
	else make_xlsx_lib(XLSX);
	/* NOTE: the following extra line is needed for "Lightning Locker Service" */
	if(typeof window !== 'undefined' && !window.XLSX) try { window.XLSX = XLSX; } catch(e) {}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39).Buffer, __webpack_require__(90)))

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Collapse.default;
	  }
	});
	
	var _Collapse = _interopRequireDefault(__webpack_require__(847));

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useFormControl = useFormControl;
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var FormControlContext = /*#__PURE__*/React.createContext();
	
	if (false) {
	  FormControlContext.displayName = 'FormControlContext';
	}
	
	function useFormControl() {
	  return React.useContext(FormControlContext);
	}
	
	var _default = FormControlContext;
	exports.default = _default;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Grow.default;
	  }
	});
	
	var _Grow = _interopRequireDefault(__webpack_require__(891));

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Input.default;
	  }
	});
	
	var _Input = _interopRequireDefault(__webpack_require__(899));

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Modal.default;
	  }
	});
	Object.defineProperty(exports, "ModalManager", {
	  enumerable: true,
	  get: function get() {
	    return _ModalManager.default;
	  }
	});
	
	var _Modal = _interopRequireDefault(__webpack_require__(924));
	
	var _ModalManager = _interopRequireDefault(__webpack_require__(362));

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SvgIcon.default;
	  }
	});
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(961));

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableContainer.default;
	  }
	});
	
	var _TableContainer = _interopRequireDefault(__webpack_require__(975));

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownerWindow;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(68));
	
	function ownerWindow(node) {
	  var doc = (0, _ownerDocument.default)(node);
	  return doc.defaultView || window;
	}

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useId;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * Private module reserved for @material-ui/x packages.
	 */
	function useId(idOverride) {
	  var _React$useState = React.useState(idOverride),
	      defaultId = _React$useState[0],
	      setDefaultId = _React$useState[1];
	
	  var id = idOverride || defaultId;
	  React.useEffect(function () {
	    if (defaultId == null) {
	      // Fallback to this default id when possible.
	      // Use the random value for client-side rendering only.
	      // We can't use it server-side.
	      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
	    }
	  }, [defaultId]);
	  return id;
	}

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = unsupportedProp;
	
	function unsupportedProp(props, propName, componentName, location, propFullName) {
	  if (true) {
	    return null;
	  }
	
	  var propFullNameSafe = propFullName || propName;
	
	  if (typeof props[propName] !== 'undefined') {
	    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
	  }
	
	  return null;
	}

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _utils = __webpack_require__(22);
	
	function merge(acc, item) {
	  if (!item) {
	    return acc;
	  }
	
	  return (0, _utils.deepmerge)(acc, item, {
	    clone: false // No need to clone deep, it's way faster.
	
	  });
	}
	
	var _default = merge;
	exports.default = _default;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	
	'use strict';
	
	var stack;
	
	if (true) {
	  stack = __webpack_require__(6646);
	} else {
	  stack = require('./cjs/event-stack.development.js');
	}
	
	module.exports = stack.default;
	module.exports.instance = stack.instance;


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.refPropType = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(5));
	
	/** A checker that matches the React.Ref type. */
	var refPropType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
	exports.refPropType = refPropType;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = xor;
	function xor(a, b) {
	  var len = Math.min(a.length, b.length);
	  var out = new Buffer(len);
	  var i = -1;
	  while (++i < len) {
	    out.writeUInt8(a[i] ^ b[i], i);
	  }
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39).Buffer))

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (undefined) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var X32WordArray = C_lib.WordArray;
	
		    /**
		     * x64 namespace.
		     */
		    var C_x64 = C.x64 = {};
	
		    /**
		     * A 64-bit word.
		     */
		    var X64Word = C_x64.Word = Base.extend({
		        /**
		         * Initializes a newly created 64-bit word.
		         *
		         * @param {number} high The high 32 bits.
		         * @param {number} low The low 32 bits.
		         *
		         * @example
		         *
		         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
		         */
		        init: function (high, low) {
		            this.high = high;
		            this.low = low;
		        }
	
		        /**
		         * Bitwise NOTs this word.
		         *
		         * @return {X64Word} A new x64-Word object after negating.
		         *
		         * @example
		         *
		         *     var negated = x64Word.not();
		         */
		        // not: function () {
		            // var high = ~this.high;
		            // var low = ~this.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Bitwise ANDs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to AND with this word.
		         *
		         * @return {X64Word} A new x64-Word object after ANDing.
		         *
		         * @example
		         *
		         *     var anded = x64Word.and(anotherX64Word);
		         */
		        // and: function (word) {
		            // var high = this.high & word.high;
		            // var low = this.low & word.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Bitwise ORs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to OR with this word.
		         *
		         * @return {X64Word} A new x64-Word object after ORing.
		         *
		         * @example
		         *
		         *     var ored = x64Word.or(anotherX64Word);
		         */
		        // or: function (word) {
		            // var high = this.high | word.high;
		            // var low = this.low | word.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Bitwise XORs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to XOR with this word.
		         *
		         * @return {X64Word} A new x64-Word object after XORing.
		         *
		         * @example
		         *
		         *     var xored = x64Word.xor(anotherX64Word);
		         */
		        // xor: function (word) {
		            // var high = this.high ^ word.high;
		            // var low = this.low ^ word.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Shifts this word n bits to the left.
		         *
		         * @param {number} n The number of bits to shift.
		         *
		         * @return {X64Word} A new x64-Word object after shifting.
		         *
		         * @example
		         *
		         *     var shifted = x64Word.shiftL(25);
		         */
		        // shiftL: function (n) {
		            // if (n < 32) {
		                // var high = (this.high << n) | (this.low >>> (32 - n));
		                // var low = this.low << n;
		            // } else {
		                // var high = this.low << (n - 32);
		                // var low = 0;
		            // }
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Shifts this word n bits to the right.
		         *
		         * @param {number} n The number of bits to shift.
		         *
		         * @return {X64Word} A new x64-Word object after shifting.
		         *
		         * @example
		         *
		         *     var shifted = x64Word.shiftR(7);
		         */
		        // shiftR: function (n) {
		            // if (n < 32) {
		                // var low = (this.low >>> n) | (this.high << (32 - n));
		                // var high = this.high >>> n;
		            // } else {
		                // var low = this.high >>> (n - 32);
		                // var high = 0;
		            // }
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Rotates this word n bits to the left.
		         *
		         * @param {number} n The number of bits to rotate.
		         *
		         * @return {X64Word} A new x64-Word object after rotating.
		         *
		         * @example
		         *
		         *     var rotated = x64Word.rotL(25);
		         */
		        // rotL: function (n) {
		            // return this.shiftL(n).or(this.shiftR(64 - n));
		        // },
	
		        /**
		         * Rotates this word n bits to the right.
		         *
		         * @param {number} n The number of bits to rotate.
		         *
		         * @return {X64Word} A new x64-Word object after rotating.
		         *
		         * @example
		         *
		         *     var rotated = x64Word.rotR(7);
		         */
		        // rotR: function (n) {
		            // return this.shiftR(n).or(this.shiftL(64 - n));
		        // },
	
		        /**
		         * Adds this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to add with this word.
		         *
		         * @return {X64Word} A new x64-Word object after adding.
		         *
		         * @example
		         *
		         *     var added = x64Word.add(anotherX64Word);
		         */
		        // add: function (word) {
		            // var low = (this.low + word.low) | 0;
		            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
		            // var high = (this.high + word.high + carry) | 0;
	
		            // return X64Word.create(high, low);
		        // }
		    });
	
		    /**
		     * An array of 64-bit words.
		     *
		     * @property {Array} words The array of CryptoJS.x64.Word objects.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */
		    var X64WordArray = C_x64.WordArray = Base.extend({
		        /**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create();
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create([
		         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
		         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
		         *     ]);
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create([
		         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
		         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
		         *     ], 10);
		         */
		        init: function (words, sigBytes) {
		            words = this.words = words || [];
	
		            if (sigBytes != undefined) {
		                this.sigBytes = sigBytes;
		            } else {
		                this.sigBytes = words.length * 8;
		            }
		        },
	
		        /**
		         * Converts this 64-bit word array to a 32-bit word array.
		         *
		         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
		         *
		         * @example
		         *
		         *     var x32WordArray = x64WordArray.toX32();
		         */
		        toX32: function () {
		            // Shortcuts
		            var x64Words = this.words;
		            var x64WordsLength = x64Words.length;
	
		            // Convert
		            var x32Words = [];
		            for (var i = 0; i < x64WordsLength; i++) {
		                var x64Word = x64Words[i];
		                x32Words.push(x64Word.high);
		                x32Words.push(x64Word.low);
		            }
	
		            return X32WordArray.create(x32Words, this.sigBytes);
		        },
	
		        /**
		         * Creates a copy of this word array.
		         *
		         * @return {X64WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = x64WordArray.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
	
		            // Clone "words" array
		            var words = clone.words = this.words.slice(0);
	
		            // Clone each X64Word object
		            var wordsLength = words.length;
		            for (var i = 0; i < wordsLength; i++) {
		                words[i] = words[i].clone();
		            }
	
		            return clone;
		        }
		    });
		}());
	
	
		return CryptoJS;
	
	}));

/***/ },
/* 176 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 177 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	var $defineProperty = Object.defineProperty || false;
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = false;
		}
	}
	
	module.exports = $defineProperty;


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(6848),
	    listCacheDelete = __webpack_require__(6849),
	    listCacheGet = __webpack_require__(6850),
	    listCacheHas = __webpack_require__(6851),
	    listCacheSet = __webpack_require__(6852);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(265),
	    setCacheAdd = __webpack_require__(6866),
	    setCacheHas = __webpack_require__(6867);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(178),
	    stackClear = __webpack_require__(6868),
	    stackDelete = __webpack_require__(6869),
	    stackGet = __webpack_require__(6870),
	    stackHas = __webpack_require__(6871),
	    stackSet = __webpack_require__(6872);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 181 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(185);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(147);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(464),
	    keys = __webpack_require__(63);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(463),
	    baseIsNaN = __webpack_require__(6779),
	    strictIndexOf = __webpack_require__(6873);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(195),
	    nativeKeys = __webpack_require__(6860);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 187 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(98),
	    arrayMap = __webpack_require__(81),
	    isArray = __webpack_require__(35),
	    isSymbol = __webpack_require__(103);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 189 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(141),
	    isObject = __webpack_require__(59);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtor;


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(470),
	    createBind = __webpack_require__(6817),
	    createCurry = __webpack_require__(6820),
	    createHybrid = __webpack_require__(479),
	    createPartial = __webpack_require__(6824),
	    getData = __webpack_require__(274),
	    mergeData = __webpack_require__(6859),
	    setData = __webpack_require__(498),
	    setWrapToString = __webpack_require__(499),
	    toInteger = __webpack_require__(82);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *    1 - `_.bind`
	 *    2 - `_.bindKey`
	 *    4 - `_.curry` or `_.curryRight` of a bound function
	 *    8 - `_.curry`
	 *   16 - `_.curryRight`
	 *   32 - `_.partial`
	 *   64 - `_.partialRight`
	 *  128 - `_.rearg`
	 *  256 - `_.ary`
	 *  512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func);
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  if (data) {
	    mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] === undefined
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setWrapToString(setter(result, newData), func, bitmask);
	}
	
	module.exports = createWrap;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(6845);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(495);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 194 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ },
/* 195 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(101);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(483);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(215)(module)))

/***/ },
/* 198 */
/***/ function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ },
/* 199 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(6762),
	    hasUnicode = __webpack_require__(194),
	    unicodeToArray = __webpack_require__(6877);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(454),
	    baseFilter = __webpack_require__(6768),
	    baseIteratee = __webpack_require__(62),
	    isArray = __webpack_require__(35);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 *
	 * // Combining several predicates using `_.overEvery` or `_.overSome`.
	 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	 * // => objects for ['fred', 'barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(186),
	    getTag = __webpack_require__(87),
	    isArguments = __webpack_require__(148),
	    isArray = __webpack_require__(35),
	    isArrayLike = __webpack_require__(73),
	    isBuffer = __webpack_require__(120),
	    isPrototype = __webpack_require__(195),
	    isTypedArray = __webpack_require__(151);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(70),
	    isArray = __webpack_require__(35),
	    isObjectLike = __webpack_require__(53);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 204 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var basePick = __webpack_require__(6791),
	    flatRest = __webpack_require__(273);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, paths) {
	  return object == null ? {} : basePick(object, paths);
	});
	
	module.exports = pick;


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(456),
	    baseEach = __webpack_require__(99),
	    baseIteratee = __webpack_require__(62),
	    baseReduce = __webpack_require__(6795),
	    isArray = __webpack_require__(35);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(472),
	    isObject = __webpack_require__(59),
	    isSymbol = __webpack_require__(103);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (typeof process === 'undefined' ||
	    !process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoNotaEntrega = function CatalogoNotaEntrega(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtBuscar = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      records = _useState6[0],
	      setRecords = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    idnotaentrega: "",
	    numnotaentrega: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      values = _useState8[0],
	      setValues = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(-1),
	      _useState10 = _slicedToArray(_useState9, 2),
	      itemSelect = _useState10[0],
	      setItemSelect = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      filterFn = _useState12[0],
	      setFilterFn = _useState12[1];
	
	  var headCells = [{ label: "FECHA", textAlign: "center" }, { label: "NÙMERO", textAlign: "center" }, { label: "CEDULA/RIF", textAlign: "center" }, { label: "NOMBRE", textAlign: "center" }, { label: "MONTO", textAlign: "center" }, { label: "ESTATUS", textAlign: "center" }];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.numnotaentrega.toLowerCase().includes(target.value.toLowerCase()) || (0, _moment2.default)(x.fecha).format("DD/MM/YYYY").toLowerCase().includes(target.value.toLowerCase()) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.cedularif.toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var endpoint = "";
	    if (props.tip === "FA") {
	      var campos = "*, agente.nombre";
	      var nomtab = "notaentrega inner join agente on agente.idagente=idcliente";
	      var nomid = "tipo";
	      var id = props.tipo;
	      endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	    } else if (props.tip === "ND") {
	      var _campos = "*, agente.nombre";
	      var _nomtab = "notaentrega inner join agente on agente.idagente=idcliente";
	      var _nomid = "tipo";
	      var _id = props.tipo;
	      endpoint = op.conexion + "/api/consulta/modelirows?campos=" + _campos + "&nomtab=" + _nomtab + "&nomid=" + _nomid + "&id=" + _id;
	    } else if (props.tip === "NE" && props.val === 'ORDEN') {
	      endpoint = op.conexion + "/api/inventario/seleccionarnotaentregadetordenescat";
	    } else {
	      endpoint = op.conexion + "/api/consulta/seleccionarnotaentrega";
	    }
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setItemSelect("");
	    setActivate(false);
	    setRecords([]);
	    setValues({
	      idnotaentrega: "",
	      numnotaentrega: ""
	    });
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var seleccionarProducto = function seleccionarProducto() {
	    props.onHideAceptaCatalogo(values);
	  };
	
	  var seleccionarFila = function seleccionarFila(item) {
	    return function (e) {
	      e.preventDefault();
	
	      setValues({
	        idnotaentrega: item.idnotaentrega,
	        numnotaentrega: item.numnotaentrega
	      });
	      btnAcepta.current.focus();
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        seleccionarRegistros();
	        txtBuscar.current.focus();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Seleccionar Nota de ",
	          props.tipo === "ND" ? "Debito" : "Entrega"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-6 input-group-sm mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control text-uppercase",
	              ref: txtBuscar
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  style: {
	                    padding: "0",
	                    cursor: "pointer",
	                    background: values.idnotaentrega === item.idnotaentrega ? "lightskyblue" : "white"
	                  },
	                  onClick: seleccionarFila(item)
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center align-middle" },
	                  (0, _moment2.default)(item.fecha).format("DD/MM/YYYY")
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center align-middle" },
	                  item.numnotaentrega
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center align-middle" },
	                  item.cedularif
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start align-middle" },
	                  item.nombre
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-end align-middle" },
	                  (0, _varios.formatMoneda)(item.totalmonto.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center align-middle" },
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      style: {
	                        fontWeight: "bold",
	                        color: item.status === 0 ? "#007bff" : item.status === 1 ? "#28a745" : item.status === 4 ? "#dc3545" : "#000000"
	                      },
	                      disabled: true,
	                      defaultValue: item.status,
	                      className: "form-select-sm text-uppercase px-1",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "0" },
	                      "PENDIENTE"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "PROCESADO"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "4" },
	                      "ANULADO"
	                    )
	                  )
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          onClick: seleccionarProducto
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoNotaEntrega;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoPedido = function CatalogoPedido(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtBuscar = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      records = _useState6[0],
	      setRecords = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    idpedido: "",
	    numpedido: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      values = _useState8[0],
	      setValues = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(-1),
	      _useState10 = _slicedToArray(_useState9, 2),
	      itemSelect = _useState10[0],
	      setItemSelect = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      filterFn = _useState12[0],
	      setFilterFn = _useState12[1];
	
	  var headCells = [{ label: "FECHA", textAlign: "center" }, { label: "NÙMERO", textAlign: "center" }, { label: "CEDULA/RIF", textAlign: "center" }, { label: "NOMBRE", textAlign: "center" }, { label: "MONTO TOTAL", textAlign: "center" }, { label: "ESTATUS", textAlign: "center" }];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.numpedido.toLowerCase().includes(target.value.toLowerCase()) || (0, _moment2.default)(x.fecha).format("DD/MM/YYYY").toLowerCase().includes(target.value.toLowerCase()) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.cedularif.toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "idpedido, numpedido, fecha, (case when n.generico then n.nombre ELSE a.nombre END) as nombre, cedularif, totalmonto, (case when status = 0 then 'PENDIENTE' when status = 1 then 'PROCESADO' when status = 4 then 'ANULADA' ELSE '' END) as status";
	    var condicion = props.condicion;
	    var nomtab = "pedido";
	    var endpoint = op.conexion + "/api/inventario/catalogonotaentrega?campos=" + campos + "&condicion=" + condicion + "&nomtab=" + nomtab;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setItemSelect("");
	    setActivate(false);
	    setRecords([]);
	    setValues({
	      idpedido: "",
	      numpedido: ""
	    });
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var seleccionarProducto = function seleccionarProducto() {
	    props.onHideAceptaCatalogo(values);
	  };
	
	  var seleccionarFila = function seleccionarFila(item) {
	    return function (e) {
	      e.preventDefault();
	
	      setValues({
	        idpedido: item.idpedido,
	        numpedido: item.numpedido
	      });
	      btnAcepta.current.focus();
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        seleccionarRegistros();
	        txtBuscar.current.focus();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Seleccionar Pedido"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-6 input-group-sm mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control text-uppercase",
	              ref: txtBuscar
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  style: {
	                    padding: "0",
	                    cursor: "pointer",
	                    background: values.idpedido === item.idpedido ? "lightskyblue" : "white"
	                  },
	                  onClick: seleccionarFila(item)
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  (0, _moment2.default)(item.fecha).format("DD/MM/YYYY")
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.numpedido
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.cedularif
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.nombre
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-end" },
	                  (0, _varios.formatMoneda)(item.totalmonto.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  _react2.default.createElement(
	                    "p",
	                    {
	                      style: {
	                        fontWeight: "bold",
	                        color: item.status === "PENDIENTE" ? "#007bff" : item.status === "PROCESADO" ? "#28a745" : item.status === "ANULADA" ? "#dc3545" : "#000000"
	                      }
	                    },
	                    item.status
	                  )
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          onClick: seleccionarProducto
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoPedido;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GestionarMarca = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _useTable = __webpack_require__(20);
	
	var _useTable2 = _interopRequireDefault(_useTable);
	
	var _core = __webpack_require__(19);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoMarca = __webpack_require__(7029);
	
	var _catalogoMarca2 = _interopRequireDefault(_catalogoMarca);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GestionarMarca = exports.GestionarMarca = function GestionarMarca(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var accbtnmarca = JSON.parse(sessionStorage.getItem('accbtnmarcac'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtIdMarca = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)('Gestion Marca.'),
	      _useState2 = _slicedToArray(_useState, 2),
	      tituloHeader = _useState2[0],
	      setTituloHeader = _useState2[1];
	
	  var _useState3 = (0, _react.useState)('visible'),
	      _useState4 = _slicedToArray(_useState3, 2),
	      visibleBtn = _useState4[0],
	      setVisibleBtn = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      operacion = _useState6[0],
	      setOperacion = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      body = _useState8[0],
	      setBody = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      activate = _useState10[0],
	      setActivate = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(true),
	      _useState12 = _slicedToArray(_useState11, 2),
	      habilitado = _useState12[0],
	      setHabilitado = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensaje = _useState14[0],
	      setMensaje = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mensajesino = _useState16[0],
	      setMensajesino = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      catalogoMarca = _useState18[0],
	      setCatalogoMarca = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      botones = _useState20[0],
	      setBotones = _useState20[1];
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'descripcion') {
	      if (e.target.value === '') {
	        setBotones(Object.assign({}, botones, { aceptar: true }));
	      } else {
	        setBotones(Object.assign({}, botones, { aceptar: false }));
	      }
	
	      e.target.value = e.target.value;
	    } else {
	      e.target.value = e.target.value;
	    }
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = 'idmarca, trim(descripcion) as descripcion';
	    var nomtab = 'marca';
	    var nomid = 'idmarca';
	    var id = txtIdMarca.current.value;
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        if (response.data !== '') {
	          txtIdMarca.current.setAttribute("disabled", true);
	          txtDescripcion.current.value = response.data.descripcion.trim();
	          if (operacion === 2) {
	            setHabilitado(false);
	            txtDescripcion.current.focus();
	          } else {
	            btnCancela.current.focus();
	          }
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: operacion === 4 ? true : false,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una marca con este codigo', icono: 'informacion' });
	          txtIdMarca.current.value = '';
	          txtIdMarca.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var validarMarca = function validarMarca(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value !== '') {
	
	        seleccionarRegistro();
	      }
	    }
	  };
	
	  var onCatalogoMarca = function onCatalogoMarca(values) {
	    setCatalogoMarca(false);
	    txtIdMarca.current.value = values.idmarca;
	    txtIdMarca.current.setAttribute("disabled", true);
	    txtDescripcion.current.value = values.descripcion;
	    setBotones({
	      incluir: true,
	      consultar: true,
	      modificar: false,
	      eliminar: true,
	      aceptar: operacion === 4 ? true : false,
	      cancelar: false,
	      catalogo: true,
	      salir: true
	    });
	    if (operacion === 2) {
	      setHabilitado(false);
	      setTimeout(function () {
	        return txtDescripcion.current.focus();
	      }, 200);
	      //txtDescripcion.current.focus();
	    } else {
	      setTimeout(function () {
	        return btnCancela.current.focus();
	      }, 200);
	      //btnCancela.current.focus();
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	
	    var sigue = true;
	    if (!botones.incluir || !botones.modificar) {
	
	      if (txtDescripcion.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar una descripción', icono: 'informacion' });
	        txtDescripcion.current.focus();
	        sigue = false;
	      }
	    }
	
	    if (sigue) {
	
	      var marca = [];
	      marca.push({
	        idmarca: txtIdMarca.current.value === '' ? 0 : txtIdMarca.current.value,
	        descripcion: txtDescripcion.current.value.toUpperCase().trim()
	      });
	
	      setBody({
	        marca: marca
	      });
	
	      var msg = '';
	      if (operacion === 1) {
	        msg = 'Esta Seguro de Registrar estos Datos.';
	      } else if (operacion === 2) {
	        msg = 'Esta Seguro de Modificar estos Datos.';
	      } else if (operacion === 3) {
	        msg = 'Esta Seguro de Eliminar estos Datos.';
	      }
	
	      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + '/api/marca/actualizar/' + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
	        } else if (operacion === 2) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
	        } else if (operacion === 3) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = '';
	      if (error.response === undefined) {
	        mensaje = 'Error de Conexion';
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
	          mensaje = 'Ya existe un Registro con este rif';
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    if (mensajesino.texto === 'Seguro de Descartar Cambios?' && props.llamado === 2) {
	      cancelar();
	    } else {
	      procesarRegistro();
	    }
	  };
	
	  var blanquear = function blanquear() {
	    setTituloHeader('Gestionar Marca.');
	    setActivate(false);
	    setBody(null);
	    setHabilitado(true);
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      salir: false
	    });
	    txtIdMarca.current.setAttribute("disabled", true);
	    txtIdMarca.current.value = '';
	    txtDescripcion.current.value = '';
	    setVisibleBtn('visible');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var onBotones = function onBotones(opera) {
	    return function (e) {
	
	      e.preventDefault();
	
	      if (opera === 1) {
	
	        if (accbtnmarca && accbtnmarca.toString().substring(0, 1) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Incluir Marca.');
	          setOperacion(opera);
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	          txtIdMarca.current.setAttribute("disabled", true);
	          setTimeout(function () {
	            return txtDescripcion.current.focus();
	          }, 200);
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (opera === 2) {
	
	        if (accbtnmarca && accbtnmarca.toString().substring(1, 2) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Editar Marca.');
	          setOperacion(opera);
	          txtIdMarca.current.removeAttribute("disabled");
	          //setHabilitado(false);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdMarca.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (opera === 3) {
	
	        if (accbtnmarca && accbtnmarca.toString().substring(3, 4) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Eliminar Marca.');
	          setOperacion(opera);
	          txtIdMarca.current.removeAttribute("disabled");
	          //setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdMarca.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (opera === 4) {
	
	        if (accbtnmarca && accbtnmarca.toString().substring(2, 3) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Consultar Marca.');
	          setOperacion(opera);
	          txtIdMarca.current.removeAttribute("disabled");
	          //setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdMarca.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (opera === 5) {
	        onChangeValidar();
	      } else if (opera === 6) {
	        if (props.llamado === 2) {
	
	          if (txtDescripcion.current.value === '') {
	            blanquear();
	            props.onHideCancela();
	          } else {
	
	            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Seguro de Descartar Cambios?', icono: 'confirmacion' });
	          }
	        } else {
	          blanquear();
	        }
	      } else if (opera === 7) {
	        setVisibleBtn('visible');
	        cancelar();
	      }
	    };
	  };
	
	  var cerrarModal = function cerrarModal() {
	    if (props.llamado === 2) {
	      props.onHideRenderizar();
	      props.onHideCancela();
	    }
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var imprimirMarca = function imprimirMarca() {
	
	    if (accbtnmarca && accbtnmarca.toString().substring(4, 5) === '1') {
	      window.open(op.reportes + '/almacen?afiliado=' + afiliado + '&reporte=ListMarca', "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      //window.open(op.reportes + "reporte=listMarca", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	    } else {
	      setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	        setHabilitado(true);
	        if (props.llamado === 2) {
	          setTituloHeader('Incluir Marca.');
	          setOperacion(1);
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	          txtIdMarca.current.setAttribute("disabled", true);
	          setTimeout(function () {
	            return txtDescripcion.current.focus();
	          }, 200);
	          setVisibleBtn('collapse');
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        _Modal2.default.Title,
	        { style: { color: "#fff" } },
	        tituloHeader,
	        ' '
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: onBotones(7), className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 mx-auto px-0' },
	          _react2.default.createElement(
	            'div',
	            { className: 'mb-3 col-pd-140 ml-auto' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'FECHA: ',
	              _react2.default.createElement(
	                'span',
	                { className: 'fw-bold fs-6' },
	                (0, _moment2.default)(fechasistema).format('DD-MM-YYYY'),
	                ' '
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'border-azul col-md-12 py-3 rounded mx-1', style: { fontSizeAdjust: '0.6' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'row col-md-12 rounded mx-auto' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-3 col-md-6' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'CODIGO:'
	              ),
	              _react2.default.createElement('input', { type: 'text', ref: txtIdMarca, disabled: true, onKeyUp: validarMarca, onBlur: validarMarca, className: 'form-control fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	              _react2.default.createElement(
	                'button',
	                { disabled: botones.catalogo, type: 'button', onClick: function onClick() {
	                    return setCatalogoMarca(true);
	                  }, className: 'btn btn-success' },
	                _react2.default.createElement('i', { className: 'fas fa-search' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-1 ml-auto px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn btn-primary btn-sm rounded ', onClick: imprimirMarca },
	                  _react2.default.createElement('i', { className: 'fas fa-print' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm col-md-12' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'DESCRIPCION:'
	              ),
	              _react2.default.createElement('input', { type: 'text', ref: txtDescripcion, name: 'descripcion', autoComplete: 'off', disabled: habilitado, className: 'form-control text-uppercase fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onChange: onChange })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 mx-auto' },
	        visibleBtn === 'visible' ? _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 mx-auto row justify-content-between', style: { visibility: props.llamado === 2 ? 'collapse' : props.llamado !== 2 ? visibleBtn : 'visible' } },
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.incluir, onClick: onBotones(1), className: 'btn btn-sm mx-1 my-1 col btn-primary rounded-pill', title: 'Incluir Marca' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-plus' },
	              ' Incluir '
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.consultar, onClick: onBotones(4), className: 'btn btn-sm mx-1 my-1 col btn-info rounded-pill', title: 'Consultar Marca' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-eye' },
	              'Consultar'
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.modificar, onClick: onBotones(2), className: 'btn btn-sm mx-1 my-1 col btn-warning rounded-pill', title: 'Modificar Marca' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fa fa-edit' },
	              'Modificar'
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.eliminar, onClick: onBotones(3), className: 'btn btn-sm mx-1 my-1 col btn-danger rounded-pill', title: 'Eliminar Marca' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fa fa-trash' },
	              'Eliminar'
	            ),
	            ' '
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 row mx-auto justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: botones.aceptar, onClick: onBotones(5), className: 'btn col-md-3 mx-1 my-1 btn-sm rounded-pill btn-success ' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check-circle' },
	              '  Aceptar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, disabled: botones.cancelar, onClick: onBotones(6), className: 'btn col-md-3 mx-1 my-1 btn-danger btn-sm rounded-pill ' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoMarca2.default, {
	      show: catalogoMarca,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoMarca(false);
	      },
	      onHideAceptaCatalogo: onCatalogoMarca
	    })
	  );
	};

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GestionarModelo = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoModelo = __webpack_require__(652);
	
	var _catalogoModelo2 = _interopRequireDefault(_catalogoModelo);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GestionarModelo = exports.GestionarModelo = function GestionarModelo(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var accbtnmodelo = JSON.parse(sessionStorage.getItem('accbtnmodeloc'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtIdModelo = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)('Gestion Modelo.'),
	      _useState2 = _slicedToArray(_useState, 2),
	      tituloHeader = _useState2[0],
	      setTituloHeader = _useState2[1];
	
	  var _useState3 = (0, _react.useState)('visible'),
	      _useState4 = _slicedToArray(_useState3, 2),
	      visibleBtn = _useState4[0],
	      setVisibleBtn = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      operacion = _useState6[0],
	      setOperacion = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      body = _useState8[0],
	      setBody = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      activate = _useState10[0],
	      setActivate = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(true),
	      _useState12 = _slicedToArray(_useState11, 2),
	      habilitado = _useState12[0],
	      setHabilitado = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensaje = _useState14[0],
	      setMensaje = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mensajesino = _useState16[0],
	      setMensajesino = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      catalogoModelo = _useState18[0],
	      setCatalogoModelo = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      botones = _useState20[0],
	      setBotones = _useState20[1];
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'descripcion') {
	      if (e.target.value === '') {
	        setBotones(Object.assign({}, botones, { aceptar: true }));
	      } else {
	        setBotones(Object.assign({}, botones, { aceptar: false }));
	      }
	      e.target.value = e.target.value;
	    } else {
	      e.target.value = e.target.value;
	    }
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = 'idmodelo, trim(descripcion) as descripcion';
	    var nomtab = 'modelo';
	    var nomid = 'idmodelo';
	    var id = txtIdModelo.current.value;
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        if (response.data !== '') {
	          txtIdModelo.current.setAttribute("disabled", true);
	          txtDescripcion.current.value = response.data.descripcion.trim();
	          if (operacion === 2) {
	            setHabilitado(false);
	            txtDescripcion.current.focus();
	          } else {
	            btnCancela.current.focus();
	          }
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: operacion === 4 ? true : false,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	        } else {
	          txtIdModelo.current.value = '';
	          txtIdModelo.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var validarMarca = function validarMarca(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value !== '') {
	
	        seleccionarRegistro();
	      }
	    }
	  };
	
	  var onCatalogoModelo = function onCatalogoModelo(values) {
	    setCatalogoModelo(false);
	    txtIdModelo.current.setAttribute("disabled", true);
	    txtIdModelo.current.value = values.idmodelo;
	    txtDescripcion.current.value = values.descripcion;
	    setBotones({
	      incluir: true,
	      consultar: true,
	      modificar: false,
	      eliminar: true,
	      aceptar: operacion === 4 ? true : false,
	      cancelar: false,
	      catalogo: true,
	      salir: true
	    });
	    if (operacion === 2) {
	      setHabilitado(false);
	      setTimeout(function () {
	        return txtDescripcion.current.focus();
	      }, 200);
	      //txtDescripcion.current.focus();
	    } else {
	      setTimeout(function () {
	        return btnCancela.current.focus();
	      }, 200);
	      //btnCancela.current.focus();
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	
	    var sigue = true;
	    if (!botones.incluir || !botones.modificar) {
	
	      if (txtDescripcion.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar una descripción', icono: 'informacion' });
	        txtDescripcion.current.focus();
	        sigue = false;
	      }
	    }
	
	    if (sigue) {
	
	      var modelo = [];
	      modelo.push({
	        idmodelo: txtIdModelo.current.value === '' ? 0 : txtIdModelo.current.value,
	        descripcion: txtDescripcion.current.value.toUpperCase().trim()
	      });
	
	      setBody({
	        modelo: modelo
	      });
	
	      var msg = '';
	      if (operacion === 1) {
	        msg = 'Esta Seguro de Registrar estos Datos.';
	      } else if (operacion === 2) {
	        msg = 'Esta Seguro de Modificar estos Datos.';
	      } else if (operacion === 3) {
	        msg = 'Esta Seguro de Eliminar estos Datos.';
	      }
	
	      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + '/api/modelo/actualizar/' + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
	        } else if (operacion === 2) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
	        } else if (operacion === 3) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = '';
	      if (error.response === undefined) {
	        mensaje = 'Error de Conexion';
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
	          mensaje = 'Ya existe un Registro con este rif';
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    if (mensajesino.texto === 'Seguro de Descartar Cambios?' && props.llamado === 2) {
	      cancelar();
	    } else {
	      procesarRegistro();
	    }
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setTituloHeader('Gestionar Modelo.');
	    setBody(null);
	    setHabilitado(true);
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      salir: false
	    });
	    txtIdModelo.current.setAttribute("disabled", true);
	    txtIdModelo.current.value = '';
	    txtDescripcion.current.value = '';
	    setVisibleBtn('visible');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	
	      e.preventDefault();
	
	      if (op === 1) {
	
	        if (accbtnmodelo && accbtnmodelo.toString().substring(0, 1) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Incluir Modelo.');
	          setOperacion(op);
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	          txtIdModelo.current.setAttribute("disabled", true);
	          setTimeout(function () {
	            return txtDescripcion.current.focus();
	          }, 200);
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 2) {
	
	        if (accbtnmodelo && accbtnmodelo.toString().substring(1, 2) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Editar Modelo.');
	          setOperacion(op);
	          txtIdModelo.current.removeAttribute("disabled");
	          //setHabilitado(false);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdModelo.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 3) {
	
	        if (accbtnmodelo && accbtnmodelo.toString().substring(3, 4) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Eliminar Modelo.');
	          setOperacion(op);
	          txtIdModelo.current.removeAttribute("disabled");
	          //setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdModelo.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 4) {
	
	        if (accbtnmodelo && accbtnmodelo.toString().substring(2, 3) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Consultar Modelo.');
	          setOperacion(op);
	          txtIdModelo.current.removeAttribute("disabled");
	          //setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdModelo.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        if (props.llamado === 2) {
	
	          if (txtDescripcion.current.value === '') {
	            blanquear();
	            props.onHideCancela();
	          } else {
	
	            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Seguro de Descartar Cambios?', icono: 'confirmacion' });
	          }
	        } else {
	          blanquear();
	        }
	      } else if (op === 7) {
	        setVisibleBtn('visible');
	        cancelar();
	      }
	    };
	  };
	
	  var cerrarModal = function cerrarModal() {
	    if (props.llamado === 2) {
	      props.onHideRenderizar();
	      props.onHideCancela();
	    }
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var imprimirModelo = function imprimirModelo() {
	
	    if (accbtnmodelo && accbtnmodelo.toString().substring(4, 5) === '1') {
	      window.open(op.reportes + '/almacen?afiliado=' + afiliado + '&reporte=ListModelo', "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	    } else {
	      setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	        setHabilitado(true);
	        if (props.llamado === 2) {
	          setOperacion(1);
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	          txtIdModelo.current.setAttribute("disabled", true);
	          setTimeout(function () {
	            return txtDescripcion.current.focus();
	          }, 200);
	          setVisibleBtn('collapse');
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        _Modal2.default.Title,
	        { style: { color: "#fff" } },
	        tituloHeader,
	        ' '
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: onBotones(7), className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 mx-auto px-0' },
	          _react2.default.createElement(
	            'div',
	            { className: 'mb-3 col-pd-140 ml-auto' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'FECHA: ',
	              _react2.default.createElement(
	                'span',
	                { className: 'fw-bold fs-6' },
	                (0, _moment2.default)(fechasistema).format('DD-MM-YYYY'),
	                ' '
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'border-azul col-md-12 py-3 rounded mx-1', style: { fontSizeAdjust: '0.6' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'row col-md-12 rounded mx-auto' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-3 col-md-6' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'CODIGO:'
	              ),
	              _react2.default.createElement('input', { type: 'text', ref: txtIdModelo, disabled: true, onKeyUp: validarMarca, onBlur: validarMarca, className: 'form-control fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	              _react2.default.createElement(
	                'button',
	                { disabled: botones.catalogo, type: 'button', onClick: function onClick() {
	                    return setCatalogoModelo(true);
	                  }, className: 'btn btn-success' },
	                _react2.default.createElement('i', { className: 'fas fa-search' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-1 ml-auto px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn btn-primary btn-sm rounded ', onClick: imprimirModelo },
	                  _react2.default.createElement('i', { className: 'fas fa-print' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm col-md-12' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'DESCRIPCION:'
	              ),
	              _react2.default.createElement('input', { type: 'text', ref: txtDescripcion, name: 'descripcion', autoComplete: 'off', disabled: habilitado, className: 'form-control text-uppercase fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onChange: onChange })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 mx-auto' },
	        visibleBtn === 'visible' ? _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 mx-auto row justify-content-between', style: { visibility: props.llamado === 2 ? 'collapse' : props.llamado !== 2 ? visibleBtn : 'visible' } },
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.incluir, onClick: onBotones(1), className: 'btn btn-sm mx-1 my-1 col btn-primary rounded-pill', title: 'Incluir Modelo' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-plus' },
	              ' Incluir '
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.consultar, onClick: onBotones(4), className: 'btn btn-sm mx-1 my-1 col btn-info rounded-pill', title: 'Consultar Modelo' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-eye' },
	              'Consultar'
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.modificar, onClick: onBotones(2), className: 'btn btn-sm mx-1 my-1 col btn-warning rounded-pill', title: 'Modificar Modelo' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fa fa-edit' },
	              'Modificar'
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.eliminar, onClick: onBotones(3), className: 'btn btn-sm mx-1 my-1 col btn-danger rounded-pill', title: 'Eliminar Modelo' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fa fa-trash' },
	              'Eliminar'
	            ),
	            ' '
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 row mx-auto justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: botones.aceptar, onClick: onBotones(5), className: 'btn col-md-3 mx-1 my-1 btn-sm rounded-pill btn-success ' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check-circle' },
	              '  Aceptar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, disabled: botones.cancelar, onClick: onBotones(6), className: 'btn col-md-3 mx-1 my-1 btn-danger btn-sm rounded-pill ' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoModelo2.default, {
	      show: catalogoModelo,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoModelo(false);
	      },
	      onHideAceptaCatalogo: onCatalogoModelo
	    })
	  );
	};

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GestionarMedida = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoUnidadMedida = __webpack_require__(7040);
	
	var _catalogoUnidadMedida2 = _interopRequireDefault(_catalogoUnidadMedida);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GestionarMedida = exports.GestionarMedida = function GestionarMedida(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var accbtnumedida = JSON.parse(sessionStorage.getItem('accbtnumedidac'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtUnidadMedida = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)('Gestion Unidades de Medidas.'),
	      _useState2 = _slicedToArray(_useState, 2),
	      tituloHeader = _useState2[0],
	      setTituloHeader = _useState2[1];
	
	  var _useState3 = (0, _react.useState)('visible'),
	      _useState4 = _slicedToArray(_useState3, 2),
	      visibleBtn = _useState4[0],
	      setVisibleBtn = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      body = _useState6[0],
	      setBody = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      activate = _useState8[0],
	      setActivate = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(true),
	      _useState10 = _slicedToArray(_useState9, 2),
	      habilitado = _useState10[0],
	      setHabilitado = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mensaje = _useState12[0],
	      setMensaje = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensajesino = _useState14[0],
	      setMensajesino = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      catalogoUnidadMedida = _useState16[0],
	      setCatalogoUnidadMedida = _useState16[1];
	
	  var _useState17 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState18 = _slicedToArray(_useState17, 2),
	      botones = _useState18[0],
	      setBotones = _useState18[1];
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'descripcion') {
	      if (e.target.value === '') {
	        setBotones(Object.assign({}, botones, { aceptar: true }));
	      } else {
	        setBotones(Object.assign({}, botones, { aceptar: false }));
	      }
	      e.target.value = e.target.value;
	    } else {
	      e.target.value = e.target.value;
	    }
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = 'idunidadmedida, trim(descripcion) as descripcion';
	    var nomtab = 'unidadmedida';
	    var nomid = 'idunidadmedida';
	    var id = txtUnidadMedida.current.value;
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        txtDescripcion.current.value = '';
	
	        if (response.data !== '') {
	
	          txtDescripcion.current.value = response.data.descripcion.trim();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una unidad de medida con este codigo', icono: 'informacion' });
	          txtDescripcion.current.value = '';
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var validarUnidadMedida = function validarUnidadMedida(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value !== '') {
	
	        seleccionarRegistro();
	      }
	    }
	  };
	
	  var onCatalogoUnidadMedida = function onCatalogoUnidadMedida(values) {
	    setCatalogoUnidadMedida(false);
	    txtUnidadMedida.current.value = values.idunidadmedida;
	    txtDescripcion.current.value = values.descripcion;
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	
	    var sigue = true;
	    if (!botones.incluir || !botones.modificar) {
	
	      if (txtDescripcion.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar una descripción', icono: 'informacion' });
	        txtDescripcion.current.focus();
	        sigue = false;
	      }
	    }
	
	    if (sigue) {
	
	      var unidadmedida = [];
	      unidadmedida.push({
	        idunidadmedida: txtUnidadMedida.current.value === '' ? 0 : txtUnidadMedida.current.value,
	        descripcion: txtDescripcion.current.value.toUpperCase().trim()
	      });
	
	      setBody({
	        unidadmedida: unidadmedida
	      });
	
	      var msg = '';
	      if (!botones.incluir) {
	        msg = 'Esta Seguro de Registrar estos Datos.';
	      } else if (!botones.modificar) {
	        msg = 'Esta Seguro de Modificar estos Datos.';
	      } else if (!botones.eliminar) {
	        msg = 'Esta Seguro de Eliminar estos Datos.';
	      }
	
	      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + '/api/unidadmedida/actualizar/' + ope;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (ope === 1) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
	        } else if (ope === 2) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
	        } else if (ope === 3) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = '';
	      if (error.response === undefined) {
	        mensaje = 'Error de Conexion';
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
	          mensaje = 'Ya existe un Registro con este rif';
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    if (mensajesino.texto === 'Seguro de Descartar Cambios?' && props.llamado === 2) {
	      cancelar();
	    } else {
	      procesarRegistro();
	    }
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setTituloHeader('Gestion Unidades de Medidas.');
	    setBody(null);
	    setHabilitado(true);
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      salir: false
	    });
	    txtUnidadMedida.current.setAttribute("disabled", true);
	    txtUnidadMedida.current.value = '';
	    txtDescripcion.current.value = '';
	    setVisibleBtn('visible');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var imprimirUnidades = function imprimirUnidades() {
	
	    if (accbtnumedida && accbtnumedida.toString().substring(4, 5) === '1') {
	      window.open(op.reportes + '/almacen?afiliado=' + afiliado + '&reporte=ListUnidadMedida', "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	    } else {
	      setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	    }
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	
	      e.preventDefault();
	
	      if (op === 1) {
	
	        if (accbtnumedida && accbtnumedida.toString().substring(0, 1) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Incluir Unidades de Medidas.');
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	          txtUnidadMedida.current.setAttribute("disabled", true);
	          setTimeout(function () {
	            return txtDescripcion.current.focus();
	          }, 200);
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 2) {
	
	        if (accbtnumedida && accbtnumedida.toString().substring(1, 2) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Editar Unidades de Medidas.');
	          txtUnidadMedida.current.removeAttribute("disabled");
	          setHabilitado(false);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtUnidadMedida.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 3) {
	
	        if (accbtnumedida && accbtnumedida.toString().substring(3, 4) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Eliminar Unidades de Medidas.');
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtUnidadMedida.current.removeAttribute("disabled");
	          txtUnidadMedida.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 4) {
	
	        if (accbtnumedida && accbtnumedida.toString().substring(2, 3) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Consultar Unidades de Medidas.');
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtUnidadMedida.current.removeAttribute("disabled");
	          txtUnidadMedida.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        if (props.llamado === 2) {
	
	          if (txtDescripcion.current.value === '') {
	            blanquear();
	            props.onHideCancela();
	          } else {
	
	            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Seguro de Descartar Cambios?', icono: 'confirmacion' });
	          }
	        } else {
	          blanquear();
	        }
	      } else if (op === 7) {
	        setVisibleBtn('visible');
	        cancelar();
	      }
	    };
	  };
	
	  var cerrarModal = function cerrarModal() {
	
	    if (props.llamado === 2) {
	      props.onHideRenderizar();
	      props.onHideCancela();
	    }
	
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	        setHabilitado(true);
	        if (props.llamado === 2) {
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	          txtUnidadMedida.current.setAttribute("disabled", true);
	          setTimeout(function () {
	            return txtDescripcion.current.focus();
	          }, 200);
	          setVisibleBtn('collapse');
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        _Modal2.default.Title,
	        { style: { color: "#fff" } },
	        tituloHeader,
	        ' '
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: onBotones(7), className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 mx-auto px-0' },
	          _react2.default.createElement(
	            'div',
	            { className: 'mb-3 col-pd-140 ml-auto' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'FECHA: ',
	              _react2.default.createElement(
	                'span',
	                { className: 'fw-bold fs-6' },
	                (0, _moment2.default)(fechasistema).format('DD-MM-YYYY'),
	                ' '
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'border-azul col-md-12 py-3 rounded mx-auto', style: { fontSizeAdjust: '0.6' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'row col-md-12 rounded mx-auto' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-3 col-md-6' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'CODIGO:'
	              ),
	              _react2.default.createElement('input', { type: 'text', ref: txtUnidadMedida, disabled: true, onKeyUp: validarUnidadMedida, onBlur: validarUnidadMedida, className: 'form-control fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	              _react2.default.createElement(
	                'button',
	                { disabled: botones.catalogo, type: 'button', onClick: function onClick() {
	                    return setCatalogoUnidadMedida(true);
	                  }, className: 'btn btn-success' },
	                _react2.default.createElement('i', { className: 'fas fa-search' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-1 ml-auto px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn btn-primary btn-sm rounded ', onClick: imprimirUnidades },
	                  _react2.default.createElement('i', { className: 'fas fa-print' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm col-md-12' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'DESCRIPCION:'
	              ),
	              _react2.default.createElement('input', { type: 'text', ref: txtDescripcion, name: 'descripcion', autoComplete: 'off', disabled: habilitado, className: 'form-control text-uppercase fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onChange: onChange })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 mx-auto' },
	        visibleBtn === 'visible' ? _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 mx-auto row justify-content-between', style: { visibility: props.llamado === 2 ? 'collapse' : props.llamado !== 2 ? visibleBtn : 'visible' } },
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.incluir, onClick: onBotones(1), className: 'btn btn-sm mx-1 my-1 col btn-primary rounded-pill', title: 'Incluir Medida' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-plus' },
	              ' Incluir '
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.consultar, onClick: onBotones(4), className: 'btn btn-sm mx-1 my-1 col btn-info rounded-pill', title: 'Consultar Medida' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-eye' },
	              'Consultar'
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.modificar, onClick: onBotones(2), className: 'btn btn-sm mx-1 my-1 col btn-warning rounded-pill', title: 'Modificar Medida' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fa fa-edit' },
	              'Modificar'
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.eliminar, onClick: onBotones(3), className: 'btn btn-sm mx-1 my-1 col btn-danger rounded-pill', title: 'Eliminar Medida' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fa fa-trash' },
	              'Eliminar'
	            ),
	            ' '
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 row mx-auto justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: botones.aceptar, onClick: onBotones(5), className: 'btn col-md-3 mx-1 my-1 btn-sm rounded-pill btn-success ' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check-circle' },
	              '  Aceptar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, disabled: botones.cancelar, onClick: onBotones(6), className: 'btn col-md-3 mx-1 my-1 btn-danger btn-sm rounded-pill ' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoUnidadMedida2.default, {
	      show: catalogoUnidadMedida,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoUnidadMedida(false);
	      },
	      onHideAceptaCatalogo: onCatalogoUnidadMedida
	    })
	  );
	};

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CartasFinanza(props) {
	
	  return _react2.default.createElement(
	    "div",
	    { className: "row d-flex justify-content-between" },
	    _react2.default.createElement(
	      "div",
	      { className: "col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mb-3" },
	      _react2.default.createElement(
	        "div",
	        { className: "card bg-card-info mx-auto", style: { height: '90%', width: '80%' } },
	        _react2.default.createElement(
	          "div",
	          { className: "card-header", style: { height: '80%' } },
	          props.titulo1
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "card-body bg-light mx-1 mb-1" },
	          _react2.default.createElement(
	            "div",
	            { className: "d-flex justify-content-center px-md-1" },
	            _react2.default.createElement(
	              "span",
	              { className: "fw-bold text-center fs-4" },
	              props.total1
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mb-3" },
	      _react2.default.createElement(
	        "div",
	        { className: "card bg-card-info mx-auto", style: { height: '90%', width: '80%' } },
	        _react2.default.createElement(
	          "div",
	          { className: "card-header", style: { height: '80%' } },
	          "Almacen"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "card-body bg-light mx-1 mb-1" },
	          _react2.default.createElement("div", { className: "d-flex justify-content-between px-md-1" })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mb-3" },
	      _react2.default.createElement(
	        "div",
	        { className: "card bg-card-info mx-auto", style: { height: '90%', width: '80%' } },
	        _react2.default.createElement(
	          "div",
	          { className: "card-header", style: { height: '80%' } },
	          "Almacen"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "card-body bg-light mx-1 mb-1" },
	          _react2.default.createElement("div", { className: "d-flex justify-content-between px-md-1" })
	        )
	      )
	    )
	  );
	}
	
	exports.default = CartasFinanza;

/***/ },
/* 215 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(45));
	
	var _config = _interopRequireDefault(__webpack_require__(679));
	
	var _PropTypes = __webpack_require__(680);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(304));
	
	var _reflow = __webpack_require__(681);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 1 },
	 *   entered:  { opacity: 1 },
	 *   exiting:  { opacity: 0 },
	 *   exited:  { opacity: 0 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  } // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	  ;
	
	  var _proto = Transition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      if (nextStatus === ENTERING) {
	        if (this.props.unmountOnExit || this.props.mountOnEnter) {
	          var node = this.props.nodeRef ? this.props.nodeRef.current : _reactDom.default.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
	          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
	          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
	
	          if (node) (0, _reflow.forceReflow)(node);
	        }
	
	        this.performEnter(mounting);
	      } else {
	        this.performExit();
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context ? this.context.isMounting : mounting;
	
	    var _ref2 = this.props.nodeRef ? [appearing] : [_reactDom.default.findDOMNode(this), appearing],
	        maybeNode = _ref2[0],
	        maybeAppearing = _ref2[1];
	
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter || _config.default.disabled) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(maybeNode);
	      });
	      return;
	    }
	
	    this.props.onEnter(maybeNode, maybeAppearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(maybeNode, maybeAppearing);
	
	      _this2.onTransitionEnd(enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(maybeNode, maybeAppearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit() {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts();
	    var maybeNode = this.props.nodeRef ? undefined : _reactDom.default.findDOMNode(this); // no exit animation skip right to EXITED
	
	    if (!exit || _config.default.disabled) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(maybeNode);
	      });
	      return;
	    }
	
	    this.props.onExit(maybeNode);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(maybeNode);
	
	      _this3.onTransitionEnd(timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(maybeNode);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
	    this.setNextCallback(handler);
	    var node = this.props.nodeRef ? this.props.nodeRef.current : _reactDom.default.findDOMNode(this);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
	          maybeNode = _ref3[0],
	          maybeNextCallback = _ref3[1];
	
	      this.props.addEndListener(maybeNode, maybeNextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        _in = _this$props.in,
	        _mountOnEnter = _this$props.mountOnEnter,
	        _unmountOnExit = _this$props.unmountOnExit,
	        _appear = _this$props.appear,
	        _enter = _this$props.enter,
	        _exit = _this$props.exit,
	        _timeout = _this$props.timeout,
	        _addEndListener = _this$props.addEndListener,
	        _onEnter = _this$props.onEnter,
	        _onEntering = _this$props.onEntering,
	        _onEntered = _this$props.onEntered,
	        _onExit = _this$props.onExit,
	        _onExiting = _this$props.onExiting,
	        _onExited = _this$props.onExited,
	        _nodeRef = _this$props.nodeRef,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
	
	    return (
	      /*#__PURE__*/
	      // allows for nested Transitions
	      _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, typeof children === 'function' ? children(status, childProps) : _react.default.cloneElement(_react.default.Children.only(children), childProps))
	    );
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextType = _TransitionGroupContext.default;
	Transition.propTypes =  false ? {
	  /**
	   * A React reference to DOM element that need to transition:
	   * https://stackoverflow.com/a/51127130/4671932
	   *
	   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
	   *      (e.g. `onEnter`) because user already has direct access to the node.
	   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
	   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
	   *     (see
	   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
	   */
	  nodeRef: _propTypes.default.shape({
	    current: typeof Element === 'undefined' ? _propTypes.default.any : function (propValue, key, componentName, location, propFullName, secret) {
	      var value = propValue[key];
	      return _propTypes.default.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
	    }
	  }),
	
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.func.isRequired, _propTypes.default.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: _propTypes.default.bool,
	
	  /**
	   * By default the child component does not perform the enter transition when
	   * it first mounts, regardless of the value of `in`. If you want this
	   * behavior, set both `appear` and `in` to `true`.
	   *
	   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
	   * > only adds an additional enter transition. However, in the
	   * > `<CSSTransition>` component that first enter transition does result in
	   * > additional `.appear-*` classes, that way you can choose to style it
	   * > differently.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. Timeouts are still used as a fallback if provided.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: _propTypes.default.func
	} : {}; // Name the function so it is clearer in the documentation
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = UNMOUNTED;
	Transition.EXITED = EXITED;
	Transition.ENTERING = ENTERING;
	Transition.ENTERED = ENTERED;
	Transition.EXITING = EXITING;
	var _default = Transition;
	exports.default = _default;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(39)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Icon = _interopRequireDefault(__webpack_require__(54));
	
	/**
	 * A table row can have cells.
	 */
	function TableCell(props) {
	  var active = props.active,
	      children = props.children,
	      className = props.className,
	      collapsing = props.collapsing,
	      content = props.content,
	      disabled = props.disabled,
	      error = props.error,
	      icon = props.icon,
	      negative = props.negative,
	      positive = props.positive,
	      selectable = props.selectable,
	      singleLine = props.singleLine,
	      textAlign = props.textAlign,
	      verticalAlign = props.verticalAlign,
	      warning = props.warning,
	      width = props.width;
	  var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(collapsing, 'collapsing'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(negative, 'negative'), (0, _lib.useKeyOnly)(positive, 'positive'), (0, _lib.useKeyOnly)(selectable, 'selectable'), (0, _lib.useKeyOnly)(singleLine, 'single line'), (0, _lib.useKeyOnly)(warning, 'warning'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(width, 'wide'), className);
	  var rest = (0, _lib.getUnhandledProps)(TableCell, props);
	  var ElementType = (0, _lib.getElementType)(TableCell, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _Icon["default"].create(icon), content);
	}
	
	TableCell.handledProps = ["active", "as", "children", "className", "collapsing", "content", "disabled", "error", "icon", "negative", "positive", "selectable", "singleLine", "textAlign", "verticalAlign", "warning", "width"];
	TableCell.defaultProps = {
	  as: 'td'
	};
	TableCell.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A cell can be active or selected by a user. */
	  active: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** A cell can be collapsing so that it only uses as much space as required. */
	  collapsing: _propTypes["default"].bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A cell can be disabled. */
	  disabled: _propTypes["default"].bool,
	
	  /** A cell may call attention to an error or a negative value. */
	  error: _propTypes["default"].bool,
	
	  /** Add an Icon by name, props object, or pass an <Icon /> */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** A cell may let a user know whether a value is bad. */
	  negative: _propTypes["default"].bool,
	
	  /** A cell may let a user know whether a value is good. */
	  positive: _propTypes["default"].bool,
	
	  /** A cell can be selectable. */
	  selectable: _propTypes["default"].bool,
	
	  /** A cell can specify that its contents should remain on a single line and not wrap. */
	  singleLine: _propTypes["default"].bool,
	
	  /** A table cell can adjust its text alignment. */
	  textAlign: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.TEXT_ALIGNMENTS, 'justified')),
	
	  /** A table cell can adjust its text alignment. */
	  verticalAlign: _propTypes["default"].oneOf(_lib.SUI.VERTICAL_ALIGNMENTS),
	
	  /** A cell may warn a user. */
	  warning: _propTypes["default"].bool,
	
	  /** A table can specify the width of individual columns independently. */
	  width: _propTypes["default"].oneOf(_lib.SUI.WIDTHS)
	} : {};
	TableCell.create = (0, _lib.createShorthandFactory)(TableCell, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = TableCell;
	exports["default"] = _default;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Button["default"];
	  }
	});
	
	var _Button = _interopRequireDefault(__webpack_require__(312));

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(43));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _IconGroup = _interopRequireDefault(__webpack_require__(722));
	
	/**
	 * An icon is a glyph used to represent something else.
	 * @see Image
	 */
	var Icon =
	/*#__PURE__*/
	function (_PureComponent) {
	  (0, _inherits2["default"])(Icon, _PureComponent);
	
	  function Icon() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Icon);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Icon)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (e) {
	      var disabled = _this.props.disabled;
	
	      if (disabled) {
	        e.preventDefault();
	        return;
	      }
	
	      (0, _invoke2["default"])(_this.props, 'onClick', e, _this.props);
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Icon, [{
	    key: "getIconAriaOptions",
	    value: function getIconAriaOptions() {
	      var ariaOptions = {};
	      var _this$props = this.props,
	          ariaLabel = _this$props['aria-label'],
	          ariaHidden = _this$props['aria-hidden'];
	
	      if ((0, _isNil2["default"])(ariaLabel)) {
	        ariaOptions['aria-hidden'] = 'true';
	      } else {
	        ariaOptions['aria-label'] = ariaLabel;
	      }
	
	      if (!(0, _isNil2["default"])(ariaHidden)) {
	        ariaOptions['aria-hidden'] = ariaHidden;
	      }
	
	      return ariaOptions;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          bordered = _this$props2.bordered,
	          circular = _this$props2.circular,
	          className = _this$props2.className,
	          color = _this$props2.color,
	          corner = _this$props2.corner,
	          disabled = _this$props2.disabled,
	          fitted = _this$props2.fitted,
	          flipped = _this$props2.flipped,
	          inverted = _this$props2.inverted,
	          link = _this$props2.link,
	          loading = _this$props2.loading,
	          name = _this$props2.name,
	          rotated = _this$props2.rotated,
	          size = _this$props2.size;
	      var classes = (0, _classnames["default"])(color, name, size, (0, _lib.useKeyOnly)(bordered, 'bordered'), (0, _lib.useKeyOnly)(circular, 'circular'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(fitted, 'fitted'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(link, 'link'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useKeyOrValueAndKey)(corner, 'corner'), (0, _lib.useValueAndKey)(flipped, 'flipped'), (0, _lib.useValueAndKey)(rotated, 'rotated'), 'icon', className);
	      var rest = (0, _lib.getUnhandledProps)(Icon, this.props);
	      var ElementType = (0, _lib.getElementType)(Icon, this.props);
	      var ariaOptions = this.getIconAriaOptions();
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, ariaOptions, {
	        className: classes,
	        onClick: this.handleClick
	      }));
	    }
	  }]);
	  return Icon;
	}(_react.PureComponent);
	
	(0, _defineProperty2["default"])(Icon, "defaultProps", {
	  as: 'i'
	});
	(0, _defineProperty2["default"])(Icon, "Group", _IconGroup["default"]);
	(0, _defineProperty2["default"])(Icon, "handledProps", ["aria-hidden", "aria-label", "as", "bordered", "circular", "className", "color", "corner", "disabled", "fitted", "flipped", "inverted", "link", "loading", "name", "rotated", "size"]);
	Icon.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Formatted to appear bordered. */
	  bordered: _propTypes["default"].bool,
	
	  /** Icon can formatted to appear circular. */
	  circular: _propTypes["default"].bool,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Color of the icon. */
	  color: _propTypes["default"].oneOf(_lib.SUI.COLORS),
	
	  /** Icons can display a smaller corner icon. */
	  corner: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['top left', 'top right', 'bottom left', 'bottom right'])]),
	
	  /** Show that the icon is inactive. */
	  disabled: _propTypes["default"].bool,
	
	  /** Fitted, without space to left or right of Icon. */
	  fitted: _propTypes["default"].bool,
	
	  /** Icon can be flipped. */
	  flipped: _propTypes["default"].oneOf(['horizontally', 'vertically']),
	
	  /** Formatted to have its colors inverted for contrast. */
	  inverted: _propTypes["default"].bool,
	
	  /** Icon can be formatted as a link. */
	  link: _propTypes["default"].bool,
	
	  /** Icon can be used as a simple loader. */
	  loading: _propTypes["default"].bool,
	
	  /** Name of the icon. */
	  name: _lib.customPropTypes.suggest(_lib.SUI.ALL_ICONS_IN_ALL_CONTEXTS),
	
	  /** Icon can rotated. */
	  rotated: _propTypes["default"].oneOf(['clockwise', 'counterclockwise']),
	
	  /** Size of the icon. */
	  size: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.SIZES, 'medium')),
	
	  /** Icon can have an aria label. */
	  'aria-hidden': _propTypes["default"].string,
	
	  /** Icon can have an aria label. */
	  'aria-label': _propTypes["default"].string
	} : {};
	Icon.create = (0, _lib.createShorthandFactory)(Icon, function (value) {
	  return {
	    name: value
	  };
	});
	var _default = Icon;
	exports["default"] = _default;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A list item can contain a description.
	 */
	function ListDescription(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])(className, 'description');
	  var rest = (0, _lib.getUnhandledProps)(ListDescription, props);
	  var ElementType = (0, _lib.getElementType)(ListDescription, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	ListDescription.handledProps = ["as", "children", "className", "content"];
	ListDescription.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	ListDescription.create = (0, _lib.createShorthandFactory)(ListDescription, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = ListDescription;
	exports["default"] = _default;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A list item can contain a header.
	 */
	function ListHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('header', className);
	  var rest = (0, _lib.getUnhandledProps)(ListHeader, props);
	  var ElementType = (0, _lib.getElementType)(ListHeader, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	ListHeader.handledProps = ["as", "children", "className", "content"];
	ListHeader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	ListHeader.create = (0, _lib.createShorthandFactory)(ListHeader, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = ListHeader;
	exports["default"] = _default;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Checkbox["default"];
	  }
	});
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(7290));

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Dropdown["default"];
	  }
	});
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(7292));

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * An event or an event summary can contain a date.
	 */
	function FeedDate(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('date', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedDate, props);
	  var ElementType = (0, _lib.getElementType)(FeedDate, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	FeedDate.handledProps = ["as", "children", "className", "content"];
	FeedDate.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	var _default = FeedDate;
	exports["default"] = _default;

/***/ },
/* 226 */
/***/ function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeToArray = __webpack_require__(340);
	function _unsupportedIterableToArray(r, a) {
	  if (r) {
	    if ("string" == typeof r) return arrayLikeToArray(r, a);
	    var t = {}.toString.call(r).slice(8, -1);
	    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
	  }
	}
	module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Backdrop.default;
	  }
	});
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(810));

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isHorizontal = isHorizontal;
	exports.getAnchor = getAnchor;
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _Modal = _interopRequireDefault(__webpack_require__(165));
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(229));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Slide = _interopRequireDefault(__webpack_require__(370));
	
	var _Paper = _interopRequireDefault(__webpack_require__(65));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _transitions = __webpack_require__(74);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(47));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {},
	
	    /* Styles applied to the root element if `variant="permanent or persistent"`. */
	    docked: {
	      flex: '0 0 auto'
	    },
	
	    /* Styles applied to the `Paper` component. */
	    paper: {
	      overflowY: 'auto',
	      display: 'flex',
	      flexDirection: 'column',
	      height: '100%',
	      flex: '1 0 auto',
	      zIndex: theme.zIndex.drawer,
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      // temporary style
	      position: 'fixed',
	      top: 0,
	      // We disable the focus ring for mouse, touch and keyboard users.
	      // At some point, it would be better to keep it for keyboard users.
	      // :focus-ring CSS pseudo-class will help.
	      outline: 0
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="left"`. */
	    paperAnchorLeft: {
	      left: 0,
	      right: 'auto'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="right"`. */
	    paperAnchorRight: {
	      left: 'auto',
	      right: 0
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="top"`. */
	    paperAnchorTop: {
	      top: 0,
	      left: 0,
	      bottom: 'auto',
	      right: 0,
	      height: 'auto',
	      maxHeight: '100%'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="bottom"`. */
	    paperAnchorBottom: {
	      top: 'auto',
	      left: 0,
	      bottom: 0,
	      right: 0,
	      height: 'auto',
	      maxHeight: '100%'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="left"` and `variant` is not "temporary". */
	    paperAnchorDockedLeft: {
	      borderRight: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="top"` and `variant` is not "temporary". */
	    paperAnchorDockedTop: {
	      borderBottom: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="right"` and `variant` is not "temporary". */
	    paperAnchorDockedRight: {
	      borderLeft: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="bottom"` and `variant` is not "temporary". */
	    paperAnchorDockedBottom: {
	      borderTop: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Modal` component. */
	    modal: {}
	  };
	};
	
	exports.styles = styles;
	var oppositeDirection = {
	  left: 'right',
	  right: 'left',
	  top: 'down',
	  bottom: 'up'
	};
	
	function isHorizontal(anchor) {
	  return ['left', 'right'].indexOf(anchor) !== -1;
	}
	
	function getAnchor(theme, anchor) {
	  return theme.direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
	}
	
	var defaultTransitionDuration = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The props of the [Modal](/api/modal/) component are available
	 * when `variant="temporary"` is set.
	 */
	
	var Drawer = /*#__PURE__*/React.forwardRef(function Drawer(props, ref) {
	  var _props$anchor = props.anchor,
	      anchorProp = _props$anchor === void 0 ? 'left' : _props$anchor,
	      BackdropProps = props.BackdropProps,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$elevation = props.elevation,
	      elevation = _props$elevation === void 0 ? 16 : _props$elevation,
	      _props$ModalProps = props.ModalProps;
	  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
	  var BackdropPropsProp = _props$ModalProps.BackdropProps,
	      ModalProps = (0, _objectWithoutProperties2.default)(_props$ModalProps, ["BackdropProps"]),
	      onClose = props.onClose,
	      _props$open = props.open,
	      open = _props$open === void 0 ? false : _props$open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      SlideProps = props.SlideProps,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Slide.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'temporary' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchor", "BackdropProps", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"]);
	  var theme = (0, _useTheme.default)(); // Let's assume that the Drawer will always be rendered on user space.
	  // We use this state is order to skip the appear transition during the
	  // initial mount of the component.
	
	  var mounted = React.useRef(false);
	  React.useEffect(function () {
	    mounted.current = true;
	  }, []);
	  var anchor = getAnchor(theme, anchorProp);
	  var drawer = /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    elevation: variant === 'temporary' ? elevation : 0,
	    square: true
	  }, PaperProps, {
	    className: (0, _clsx.default)(classes.paper, classes["paperAnchor".concat((0, _capitalize.default)(anchor))], PaperProps.className, variant !== 'temporary' && classes["paperAnchorDocked".concat((0, _capitalize.default)(anchor))])
	  }), children);
	
	  if (variant === 'permanent') {
	    return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.root, classes.docked, className),
	      ref: ref
	    }, other), drawer);
	  }
	
	  var slidingDrawer = /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    in: open,
	    direction: oppositeDirection[anchor],
	    timeout: transitionDuration,
	    appear: mounted.current
	  }, SlideProps), drawer);
	
	  if (variant === 'persistent') {
	    return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.root, classes.docked, className),
	      ref: ref
	    }, other), slidingDrawer);
	  } // variant === temporary
	
	
	  return /*#__PURE__*/React.createElement(_Modal.default, (0, _extends2.default)({
	    BackdropProps: (0, _extends2.default)({}, BackdropProps, BackdropPropsProp, {
	      transitionDuration: transitionDuration
	    }),
	    BackdropComponent: _Backdrop.default,
	    className: (0, _clsx.default)(classes.root, classes.modal, className),
	    open: open,
	    onClose: onClose,
	    ref: ref
	  }, other, ModalProps), slidingDrawer);
	});
	 false ? Drawer.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Side from which the drawer will appear.
	   */
	  anchor: _propTypes.default.oneOf(['bottom', 'left', 'right', 'top']),
	
	  /**
	   * @ignore
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * The contents of the drawer.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The elevation of the drawer.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * Props applied to the [`Modal`](/api/modal/) element.
	   */
	  ModalProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * If `true`, the drawer is open.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`Paper`](/api/paper/) element.
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * Props applied to the [`Slide`](/api/slide/) element.
	   */
	  SlideProps: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDrawer',
	  flip: false
	})(Drawer);
	
	exports.default = _default;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Fade.default;
	  }
	});
	
	var _Fade = _interopRequireDefault(__webpack_require__(875));

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FilledInput.default;
	  }
	});
	
	var _FilledInput = _interopRequireDefault(__webpack_require__(876));

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormControl.default;
	  }
	});
	Object.defineProperty(exports, "useFormControl", {
	  enumerable: true,
	  get: function get() {
	    return _useFormControl.default;
	  }
	});
	
	var _FormControl = _interopRequireDefault(__webpack_require__(877));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(93));

/***/ },
/* 234 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasValue = hasValue;
	exports.isFilled = isFilled;
	exports.isAdornedStart = isAdornedStart;
	
	// Supports determination of isControlled().
	// Controlled input accepts its current value as a prop.
	//
	// @see https://facebook.github.io/react/docs/forms.html#controlled-components
	// @param value
	// @returns {boolean} true if string (including '') or number (including zero)
	function hasValue(value) {
	  return value != null && !(Array.isArray(value) && value.length === 0);
	} // Determine if field is empty or filled.
	// Response determines if label is presented above field or as placeholder.
	//
	// @param obj
	// @param SSR
	// @returns {boolean} False when not present or empty string.
	//                    True when any number or string with length.
	
	
	function isFilled(obj) {
	  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
	} // Determine if an Input is adorned on start.
	// It's corresponding to the left with LTR.
	//
	// @param obj
	// @returns {boolean} False when no adornments.
	//                    True when adorned at the start.
	
	
	function isAdornedStart(obj) {
	  return obj.startAdornment;
	}

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _OutlinedInput.default;
	  }
	});
	
	var _OutlinedInput = _interopRequireDefault(__webpack_require__(929));

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Portal.default;
	  }
	});
	
	var _Portal = _interopRequireDefault(__webpack_require__(933));

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Select.default;
	  }
	});
	
	var _Select = _interopRequireDefault(__webpack_require__(941));

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(85));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(93));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(125));
	
	var styles = {
	  root: {
	    padding: 9
	  },
	  checked: {},
	  disabled: {},
	  input: {
	    cursor: 'inherit',
	    position: 'absolute',
	    opacity: 0,
	    width: '100%',
	    height: '100%',
	    top: 0,
	    left: 0,
	    margin: 0,
	    padding: 0,
	    zIndex: 1
	  }
	};
	/**
	 * @ignore - internal component.
	 */
	
	exports.styles = styles;
	var SwitchBase = /*#__PURE__*/React.forwardRef(function SwitchBase(props, ref) {
	  var autoFocus = props.autoFocus,
	      checkedProp = props.checked,
	      checkedIcon = props.checkedIcon,
	      classes = props.classes,
	      className = props.className,
	      defaultChecked = props.defaultChecked,
	      disabledProp = props.disabled,
	      icon = props.icon,
	      id = props.id,
	      inputProps = props.inputProps,
	      inputRef = props.inputRef,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onFocus = props.onFocus,
	      readOnly = props.readOnly,
	      required = props.required,
	      tabIndex = props.tabIndex,
	      type = props.type,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: checkedProp,
	    default: Boolean(defaultChecked),
	    name: 'SwitchBase',
	    state: 'checked'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      checked = _useControlled2[0],
	      setCheckedState = _useControlled2[1];
	
	  var muiFormControl = (0, _useFormControl.default)();
	
	  var handleFocus = function handleFocus(event) {
	    if (onFocus) {
	      onFocus(event);
	    }
	
	    if (muiFormControl && muiFormControl.onFocus) {
	      muiFormControl.onFocus(event);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    if (onBlur) {
	      onBlur(event);
	    }
	
	    if (muiFormControl && muiFormControl.onBlur) {
	      muiFormControl.onBlur(event);
	    }
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    var newChecked = event.target.checked;
	    setCheckedState(newChecked);
	
	    if (onChange) {
	      // TODO v5: remove the second argument.
	      onChange(event, newChecked);
	    }
	  };
	
	  var disabled = disabledProp;
	
	  if (muiFormControl) {
	    if (typeof disabled === 'undefined') {
	      disabled = muiFormControl.disabled;
	    }
	  }
	
	  var hasLabelFor = type === 'checkbox' || type === 'radio';
	  return /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({
	    component: "span",
	    className: (0, _clsx.default)(classes.root, className, checked && classes.checked, disabled && classes.disabled),
	    disabled: disabled,
	    tabIndex: null,
	    role: undefined,
	    onFocus: handleFocus,
	    onBlur: handleBlur,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("input", (0, _extends2.default)({
	    autoFocus: autoFocus,
	    checked: checkedProp,
	    defaultChecked: defaultChecked,
	    className: classes.input,
	    disabled: disabled,
	    id: hasLabelFor && id,
	    name: name,
	    onChange: handleInputChange,
	    readOnly: readOnly,
	    ref: inputRef,
	    required: required,
	    tabIndex: tabIndex,
	    type: type,
	    value: value
	  }, inputProps)), checked ? checkedIcon : icon);
	}); // NB: If changed, please update Checkbox, Switch and Radio
	// so that the API documentation is updated.
	
	 false ? SwitchBase.propTypes = {
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  defaultChecked: _propTypes.default.bool,
	
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node.isRequired,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /*
	   * @ignore
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The input component prop `type`.
	   */
	  type: _propTypes.default.string.isRequired,
	
	  /**
	   * The value of the component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateSwitchBase'
	})(SwitchBase);
	
	exports.default = _default;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _utils = __webpack_require__(22);
	
	var _createBreakpoints = _interopRequireDefault(__webpack_require__(392));
	
	var _createMixins = _interopRequireDefault(__webpack_require__(1028));
	
	var _createPalette = _interopRequireDefault(__webpack_require__(1030));
	
	var _createTypography = _interopRequireDefault(__webpack_require__(1033));
	
	var _shadows = _interopRequireDefault(__webpack_require__(1038));
	
	var _shape = _interopRequireDefault(__webpack_require__(1039));
	
	var _createSpacing = _interopRequireDefault(__webpack_require__(1031));
	
	var _transitions = _interopRequireDefault(__webpack_require__(74));
	
	var _zIndex = _interopRequireDefault(__webpack_require__(394));
	
	function createMuiTheme() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$breakpoints = options.breakpoints,
	      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
	      _options$mixins = options.mixins,
	      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
	      _options$palette = options.palette,
	      paletteInput = _options$palette === void 0 ? {} : _options$palette,
	      spacingInput = options.spacing,
	      _options$typography = options.typography,
	      typographyInput = _options$typography === void 0 ? {} : _options$typography,
	      other = (0, _objectWithoutProperties2.default)(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);
	  var palette = (0, _createPalette.default)(paletteInput);
	  var breakpoints = (0, _createBreakpoints.default)(breakpointsInput);
	  var spacing = (0, _createSpacing.default)(spacingInput);
	  var muiTheme = (0, _utils.deepmerge)({
	    breakpoints: breakpoints,
	    direction: 'ltr',
	    mixins: (0, _createMixins.default)(breakpoints, spacing, mixinsInput),
	    overrides: {},
	    // Inject custom styles
	    palette: palette,
	    props: {},
	    // Provide default props
	    shadows: _shadows.default,
	    typography: (0, _createTypography.default)(palette, typographyInput),
	    spacing: spacing,
	    shape: _shape.default,
	    transitions: _transitions.default,
	    zIndex: _zIndex.default
	  }, other);
	
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  muiTheme = args.reduce(function (acc, argument) {
	    return (0, _utils.deepmerge)(acc, argument);
	  }, muiTheme);
	
	  if (false) {
	    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];
	
	    var traverse = function traverse(node, parentKey) {
	      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax
	
	      for (key in node) {
	        var child = node[key];
	
	        if (depth === 1) {
	          if (key.indexOf('Mui') === 0 && child) {
	            traverse(child, key, depth + 1);
	          }
	        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
	          if (process.env.NODE_ENV !== 'production') {
	            console.error(["Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
	              root: (0, _defineProperty2.default)({}, "&$".concat(key), child)
	            }, null, 2), '', 'https://material-ui.com/r/pseudo-classes-guide'].join('\n'));
	          } // Remove the style to prevent global conflicts.
	
	
	          node[key] = {};
	        }
	      }
	    };
	
	    traverse(muiTheme.overrides);
	  }
	
	  return muiTheme;
	}
	
	var _default = createMuiTheme;
	exports.default = _default;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withWidth.default;
	  }
	});
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(1048));
	
	Object.keys(_withWidth).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withWidth[key];
	    }
	  });
	});

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StylesProvider.default;
	  }
	});
	
	var _StylesProvider = _interopRequireWildcard(__webpack_require__(6596));
	
	Object.keys(_StylesProvider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StylesProvider[key];
	    }
	  });
	});

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _createGenerateClassName.default;
	  }
	});
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(6599));

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(6607));

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleBreakpoints = handleBreakpoints;
	exports.default = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(46));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(55));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _merge = _interopRequireDefault(__webpack_require__(171));
	
	// The breakpoint **start** at this value.
	// For instance with the first breakpoint xs: [xs, sm[.
	var values = {
	  xs: 0,
	  sm: 600,
	  md: 960,
	  lg: 1280,
	  xl: 1920
	};
	var defaultBreakpoints = {
	  // Sorted ASC by size. That's important.
	  // It can't be configured as it's used statically for propTypes.
	  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
	  up: function up(key) {
	    return "@media (min-width:".concat(values[key], "px)");
	  }
	};
	
	function handleBreakpoints(props, propValue, styleFromPropValue) {
	  if (false) {
	    if (!props.theme) {
	      console.error('Material-UI: You are calling a style function without a theme value.');
	    }
	  }
	
	  if (Array.isArray(propValue)) {
	    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
	    return propValue.reduce(function (acc, item, index) {
	      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
	      return acc;
	    }, {});
	  }
	
	  if ((0, _typeof2.default)(propValue) === 'object') {
	    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
	
	    return Object.keys(propValue).reduce(function (acc, breakpoint) {
	      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
	      return acc;
	    }, {});
	  }
	
	  var output = styleFromPropValue(propValue);
	  return output;
	}
	
	function breakpoints(styleFunction) {
	  var newStyleFunction = function newStyleFunction(props) {
	    var base = styleFunction(props);
	    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
	    var extended = themeBreakpoints.keys.reduce(function (acc, key) {
	      if (props[key]) {
	        acc = acc || {};
	        acc[themeBreakpoints.up(key)] = styleFunction((0, _extends2.default)({
	          theme: props.theme
	        }, props[key]));
	      }
	
	      return acc;
	    }, null);
	    return (0, _merge.default)(base, extended);
	  };
	
	  newStyleFunction.propTypes =  false ? (0, _extends2.default)({}, styleFunction.propTypes, {
	    xs: _propTypes.default.object,
	    sm: _propTypes.default.object,
	    md: _propTypes.default.object,
	    lg: _propTypes.default.object,
	    xl: _propTypes.default.object
	  }) : {};
	  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl'].concat((0, _toConsumableArray2.default)(styleFunction.filterProps));
	  return newStyleFunction;
	}
	
	var _default = breakpoints;
	exports.default = _default;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = chainPropTypes;
	
	function chainPropTypes(propType1, propType2) {
	  if (true) {
	    return function () {
	      return null;
	    };
	  }
	
	  return function validate() {
	    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
	  };
	}

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(55));
	
	/**
	 * The function that correctly handles passing refs.
	 *
	 * @param ref An ref object or function
	 * @param node A node that should be passed by ref
	 */
	var handleRef = function handleRef(ref, node) {
	  if (false) {
	    if (typeof ref === 'string') {
	      throw new Error('We do not support refs as string, this is a legacy API and will be likely to be removed in one of the future releases of React.');
	    }
	  }
	
	  if (typeof ref === 'function') {
	    ref(node);
	    return;
	  }
	
	  if (ref !== null && (0, _typeof2.default)(ref) === 'object') {
	    // The `current` property is defined as readonly, however it's a valid way because
	    // `ref` is a mutable object
	    ;
	    ref.current = node;
	  }
	};
	
	var _default = handleRef;
	exports.default = _default;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var uint_max = Math.pow(2, 32);
	function fixup_uint32(x) {
	    var ret, x_pos;
	    ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x;
	    return ret;
	}
	function scrub_vec(v) {
	  var i, _i, _ref;
	  for (i = _i = 0, _ref = v.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
	    v[i] = 0;
	  }
	  return false;
	}
	
	function Global() {
	  var i;
	  this.SBOX = [];
	  this.INV_SBOX = [];
	  this.SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.INV_SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.init();
	  this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	}
	
	Global.prototype.init = function() {
	  var d, i, sx, t, x, x2, x4, x8, xi, _i;
	  d = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 256; i = ++_i) {
	      if (i < 128) {
	        _results.push(i << 1);
	      } else {
	        _results.push((i << 1) ^ 0x11b);
	      }
	    }
	    return _results;
	  })();
	  x = 0;
	  xi = 0;
	  for (i = _i = 0; _i < 256; i = ++_i) {
	    sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	    this.SBOX[x] = sx;
	    this.INV_SBOX[sx] = x;
	    x2 = d[x];
	    x4 = d[x2];
	    x8 = d[x4];
	    t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	    this.SUB_MIX[0][x] = (t << 24) | (t >>> 8);
	    this.SUB_MIX[1][x] = (t << 16) | (t >>> 16);
	    this.SUB_MIX[2][x] = (t << 8) | (t >>> 24);
	    this.SUB_MIX[3][x] = t;
	    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	    this.INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8);
	    this.INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16);
	    this.INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24);
	    this.INV_SUB_MIX[3][sx] = t;
	    if (x === 0) {
	      x = xi = 1;
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]];
	      xi ^= d[d[xi]];
	    }
	  }
	  return true;
	};
	
	var G = new Global();
	
	
	AES.blockSize = 4 * 4;
	
	AES.prototype.blockSize = AES.blockSize;
	
	AES.keySize = 256 / 8;
	
	AES.prototype.keySize = AES.keySize;
	
	AES.ivSize = AES.blockSize;
	
	AES.prototype.ivSize = AES.ivSize;
	
	 function bufferToArray(buf) {
	  var len = buf.length/4;
	  var out = new Array(len);
	  var i = -1;
	  while (++i < len) {
	    out[i] = buf.readUInt32BE(i * 4);
	  }
	  return out;
	 }
	function AES(key) {
	  this._key = bufferToArray(key);
	  this._doReset();
	}
	
	AES.prototype._doReset = function() {
	  var invKsRow, keySize, keyWords, ksRow, ksRows, t, _i, _j;
	  keyWords = this._key;
	  keySize = keyWords.length;
	  this._nRounds = keySize + 6;
	  ksRows = (this._nRounds + 1) * 4;
	  this._keySchedule = [];
	  for (ksRow = _i = 0; 0 <= ksRows ? _i < ksRows : _i > ksRows; ksRow = 0 <= ksRows ? ++_i : --_i) {
	    this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], (ksRow % keySize) === 0 ? (t = (t << 8) | (t >>> 24), t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff], t ^= G.RCON[(ksRow / keySize) | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t);
	  }
	  this._invKeySchedule = [];
	  for (invKsRow = _j = 0; 0 <= ksRows ? _j < ksRows : _j > ksRows; invKsRow = 0 <= ksRows ? ++_j : --_j) {
	    ksRow = ksRows - invKsRow;
	    t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)];
	    this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[(t >>> 16) & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[(t >>> 8) & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]];
	  }
	  return true;
	};
	
	AES.prototype.encryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[1], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[3], 12);
	  return buf;
	};
	
	AES.prototype.decryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var temp = [M[3], M[1]];
	  M[1] = temp[0];
	  M[3] = temp[1];
	  var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[3], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[1], 12);
	  return buf;
	};
	
	AES.prototype.scrub = function() {
	  scrub_vec(this._keySchedule);
	  scrub_vec(this._invKeySchedule);
	  scrub_vec(this._key);
	};
	
	AES.prototype._doCryptBlock = function(M, keySchedule, SUB_MIX, SBOX) {
	  var ksRow, round, s0, s1, s2, s3, t0, t1, t2, t3, _i, _ref;
	
	  s0 = M[0] ^ keySchedule[0];
	  s1 = M[1] ^ keySchedule[1];
	  s2 = M[2] ^ keySchedule[2];
	  s3 = M[3] ^ keySchedule[3];
	  ksRow = 4;
	  for (round = _i = 1, _ref = this._nRounds; 1 <= _ref ? _i < _ref : _i > _ref; round = 1 <= _ref ? ++_i : --_i) {
	    t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][(s1 >>> 16) & 0xff] ^ SUB_MIX[2][(s2 >>> 8) & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++];
	    t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][(s2 >>> 16) & 0xff] ^ SUB_MIX[2][(s3 >>> 8) & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++];
	    t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][(s3 >>> 16) & 0xff] ^ SUB_MIX[2][(s0 >>> 8) & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++];
	    t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][(s0 >>> 16) & 0xff] ^ SUB_MIX[2][(s1 >>> 8) & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++];
	    s0 = t0;
	    s1 = t1;
	    s2 = t2;
	    s3 = t3;
	  }
	  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	  return [
	    fixup_uint32(t0),
	    fixup_uint32(t1),
	    fixup_uint32(t2),
	    fixup_uint32(t3)
	  ];
	
	};
	
	
	
	
	  exports.AES = AES;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39).Buffer))

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var Transform = __webpack_require__(7332).Transform;
	var inherits = __webpack_require__(76);
	
	module.exports = CipherBase;
	inherits(CipherBase, Transform);
	function CipherBase() {
	  Transform.call(this);
	}
	CipherBase.prototype.update = function (data, inputEnd, outputEnc) {
	  this.write(data, inputEnd);
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	CipherBase.prototype.final = function (outputEnc) {
	  this.end();
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39).Buffer))

/***/ },
/* 249 */
/***/ function(module, exports) {

	exports['aes-128-ecb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-192-ecb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-256-ecb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-128-cbc'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-192-cbc'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-256-cbc'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes128'] = exports['aes-128-cbc'];
	exports['aes192'] = exports['aes-192-cbc'];
	exports['aes256'] = exports['aes-256-cbc'];
	exports['aes-128-cfb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-192-cfb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-256-cfb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-128-ofb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-192-ofb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-256-ofb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-128-ctr'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-192-ctr'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-256-ctr'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};

/***/ },
/* 250 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./functionApply')} */
	module.exports = Function.prototype.apply;


/***/ },
/* 251 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./functionCall')} */
	module.exports = Function.prototype.call;


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(136);
	var $TypeError = __webpack_require__(114);
	
	var $call = __webpack_require__(251);
	var $actualApply = __webpack_require__(427);
	
	/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
	module.exports = function callBindBasic(args) {
		if (args.length < 1 || typeof args[0] !== 'function') {
			throw new $TypeError('a function is required');
		}
		return $actualApply(bind, $call, args);
	};


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(442);
	
	var callBindBasic = __webpack_require__(252);
	
	/** @type {(thisArg: string, searchString: string, position?: number) => number} */
	var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);
	
	/** @type {import('.')} */
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		/* eslint no-extra-parens: 0 */
	
		var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBindBasic(/** @type {const} */ ([intrinsic]));
		}
		return intrinsic;
	};


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var C_enc = C.enc;
		    var Utf8 = C_enc.Utf8;
		    var C_algo = C.algo;
	
		    /**
		     * HMAC algorithm.
		     */
		    var HMAC = C_algo.HMAC = Base.extend({
		        /**
		         * Initializes a newly created HMAC.
		         *
		         * @param {Hasher} hasher The hash algorithm to use.
		         * @param {WordArray|string} key The secret key.
		         *
		         * @example
		         *
		         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
		         */
		        init: function (hasher, key) {
		            // Init hasher
		            hasher = this._hasher = new hasher.init();
	
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof key == 'string') {
		                key = Utf8.parse(key);
		            }
	
		            // Shortcuts
		            var hasherBlockSize = hasher.blockSize;
		            var hasherBlockSizeBytes = hasherBlockSize * 4;
	
		            // Allow arbitrary length keys
		            if (key.sigBytes > hasherBlockSizeBytes) {
		                key = hasher.finalize(key);
		            }
	
		            // Clamp excess bits
		            key.clamp();
	
		            // Clone key for inner and outer pads
		            var oKey = this._oKey = key.clone();
		            var iKey = this._iKey = key.clone();
	
		            // Shortcuts
		            var oKeyWords = oKey.words;
		            var iKeyWords = iKey.words;
	
		            // XOR keys with pad constants
		            for (var i = 0; i < hasherBlockSize; i++) {
		                oKeyWords[i] ^= 0x5c5c5c5c;
		                iKeyWords[i] ^= 0x36363636;
		            }
		            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this HMAC to its initial state.
		         *
		         * @example
		         *
		         *     hmacHasher.reset();
		         */
		        reset: function () {
		            // Shortcut
		            var hasher = this._hasher;
	
		            // Reset
		            hasher.reset();
		            hasher.update(this._iKey);
		        },
	
		        /**
		         * Updates this HMAC with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {HMAC} This HMAC instance.
		         *
		         * @example
		         *
		         *     hmacHasher.update('message');
		         *     hmacHasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            this._hasher.update(messageUpdate);
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Finalizes the HMAC computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The HMAC.
		         *
		         * @example
		         *
		         *     var hmac = hmacHasher.finalize();
		         *     var hmac = hmacHasher.finalize('message');
		         *     var hmac = hmacHasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Shortcut
		            var hasher = this._hasher;
	
		            // Compute HMAC
		            var innerHash = hasher.finalize(messageUpdate);
		            hasher.reset();
		            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
	
		            return hmac;
		        }
		    });
		}());
	
	
	}));

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Reusable object
		    var W = [];
	
		    /**
		     * SHA-1 hash algorithm.
		     */
		    var SHA1 = C_algo.SHA1 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0x67452301, 0xefcdab89,
		                0x98badcfe, 0x10325476,
		                0xc3d2e1f0
		            ]);
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var H = this._hash.words;
	
		            // Working variables
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
		            var e = H[4];
	
		            // Computation
		            for (var i = 0; i < 80; i++) {
		                if (i < 16) {
		                    W[i] = M[offset + i] | 0;
		                } else {
		                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
		                    W[i] = (n << 1) | (n >>> 31);
		                }
	
		                var t = ((a << 5) | (a >>> 27)) + e + W[i];
		                if (i < 20) {
		                    t += ((b & c) | (~b & d)) + 0x5a827999;
		                } else if (i < 40) {
		                    t += (b ^ c ^ d) + 0x6ed9eba1;
		                } else if (i < 60) {
		                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
		                } else /* if (i < 80) */ {
		                    t += (b ^ c ^ d) - 0x359d3e2a;
		                }
	
		                e = d;
		                d = c;
		                c = (b << 30) | (b >>> 2);
		                b = a;
		                a = t;
		            }
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		            H[4] = (H[4] + e) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Return final computed hash
		            return this._hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA1('message');
		     *     var hash = CryptoJS.SHA1(wordArray);
		     */
		    C.SHA1 = Hasher._createHelper(SHA1);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA1(message, key);
		     */
		    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
		}());
	
	
		return CryptoJS.SHA1;
	
	}));

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(177);
	
	var $SyntaxError = __webpack_require__(440);
	var $TypeError = __webpack_require__(114);
	
	var gopd = __webpack_require__(115);
	
	/** @type {import('.')} */
	module.exports = function defineDataProperty(
		obj,
		property,
		value
	) {
		if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
			throw new $TypeError('`obj` must be an object or a function`');
		}
		if (typeof property !== 'string' && typeof property !== 'symbol') {
			throw new $TypeError('`property` must be a string or a symbol`');
		}
		if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
			throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
			throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
			throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
			throw new $TypeError('`loose`, if provided, must be a boolean');
		}
	
		var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
		var nonWritable = arguments.length > 4 ? arguments[4] : null;
		var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
		var loose = arguments.length > 6 ? arguments[6] : false;
	
		/* @type {false | TypedPropertyDescriptor<unknown>} */
		var desc = !!gopd && gopd(obj, property);
	
		if ($defineProperty) {
			$defineProperty(obj, property, {
				configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
				enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
				value: value,
				writable: nonWritable === null && desc ? desc.writable : !nonWritable
			});
		} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
			// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
			obj[property] = value; // eslint-disable-line no-param-reassign
		} else {
			throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
		}
	};


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _getComputedStyle = _interopRequireDefault(__webpack_require__(6715));
	
	var _hyphenateStyle = _interopRequireDefault(__webpack_require__(6718));
	
	var _isTransform = _interopRequireDefault(__webpack_require__(6720));
	
	function style(node, property) {
	  var css = '';
	  var transforms = '';
	
	  if (typeof property === 'string') {
	    return node.style.getPropertyValue((0, _hyphenateStyle.default)(property)) || (0, _getComputedStyle.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	  }
	
	  Object.keys(property).forEach(function (key) {
	    var value = property[key];
	
	    if (!value && value !== 0) {
	      node.style.removeProperty((0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });
	
	  if (transforms) {
	    css += "transform: " + transforms + ";";
	  }
	
	  node.style.cssText += ";" + css;
	}
	
	var _default = style;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _canUseDOM = _interopRequireDefault(__webpack_require__(176));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_canUseDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ },
/* 259 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var R = typeof Reflect === 'object' ? Reflect : null
	var ReflectApply = R && typeof R.apply === 'function'
	  ? R.apply
	  : function ReflectApply(target, receiver, args) {
	    return Function.prototype.apply.call(target, receiver, args);
	  }
	
	var ReflectOwnKeys
	if (R && typeof R.ownKeys === 'function') {
	  ReflectOwnKeys = R.ownKeys
	} else if (Object.getOwnPropertySymbols) {
	  ReflectOwnKeys = function ReflectOwnKeys(target) {
	    return Object.getOwnPropertyNames(target)
	      .concat(Object.getOwnPropertySymbols(target));
	  };
	} else {
	  ReflectOwnKeys = function ReflectOwnKeys(target) {
	    return Object.getOwnPropertyNames(target);
	  };
	}
	
	function ProcessEmitWarning(warning) {
	  if (console && console.warn) console.warn(warning);
	}
	
	var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
	  return value !== value;
	}
	
	function EventEmitter() {
	  EventEmitter.init.call(this);
	}
	module.exports = EventEmitter;
	module.exports.once = once;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._eventsCount = 0;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	var defaultMaxListeners = 10;
	
	function checkListener(listener) {
	  if (typeof listener !== 'function') {
	    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
	  }
	}
	
	Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
	  enumerable: true,
	  get: function() {
	    return defaultMaxListeners;
	  },
	  set: function(arg) {
	    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
	      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
	    }
	    defaultMaxListeners = arg;
	  }
	});
	
	EventEmitter.init = function() {
	
	  if (this._events === undefined ||
	      this._events === Object.getPrototypeOf(this)._events) {
	    this._events = Object.create(null);
	    this._eventsCount = 0;
	  }
	
	  this._maxListeners = this._maxListeners || undefined;
	};
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
	  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
	    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
	  }
	  this._maxListeners = n;
	  return this;
	};
	
	function _getMaxListeners(that) {
	  if (that._maxListeners === undefined)
	    return EventEmitter.defaultMaxListeners;
	  return that._maxListeners;
	}
	
	EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
	  return _getMaxListeners(this);
	};
	
	EventEmitter.prototype.emit = function emit(type) {
	  var args = [];
	  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
	  var doError = (type === 'error');
	
	  var events = this._events;
	  if (events !== undefined)
	    doError = (doError && events.error === undefined);
	  else if (!doError)
	    return false;
	
	  // If there is no 'error' event listener then throw.
	  if (doError) {
	    var er;
	    if (args.length > 0)
	      er = args[0];
	    if (er instanceof Error) {
	      // Note: The comments on the `throw` lines are intentional, they show
	      // up in Node's output if this results in an unhandled exception.
	      throw er; // Unhandled 'error' event
	    }
	    // At least give some kind of context to the user
	    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
	    err.context = er;
	    throw err; // Unhandled 'error' event
	  }
	
	  var handler = events[type];
	
	  if (handler === undefined)
	    return false;
	
	  if (typeof handler === 'function') {
	    ReflectApply(handler, this, args);
	  } else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      ReflectApply(listeners[i], this, args);
	  }
	
	  return true;
	};
	
	function _addListener(target, type, listener, prepend) {
	  var m;
	  var events;
	  var existing;
	
	  checkListener(listener);
	
	  events = target._events;
	  if (events === undefined) {
	    events = target._events = Object.create(null);
	    target._eventsCount = 0;
	  } else {
	    // To avoid recursion in the case that type === "newListener"! Before
	    // adding it to the listeners, first emit "newListener".
	    if (events.newListener !== undefined) {
	      target.emit('newListener', type,
	                  listener.listener ? listener.listener : listener);
	
	      // Re-assign `events` because a newListener handler could have caused the
	      // this._events to be assigned to a new object
	      events = target._events;
	    }
	    existing = events[type];
	  }
	
	  if (existing === undefined) {
	    // Optimize the case of one listener. Don't need the extra array object.
	    existing = events[type] = listener;
	    ++target._eventsCount;
	  } else {
	    if (typeof existing === 'function') {
	      // Adding the second element, need to change to array.
	      existing = events[type] =
	        prepend ? [listener, existing] : [existing, listener];
	      // If we've already got an array, just append.
	    } else if (prepend) {
	      existing.unshift(listener);
	    } else {
	      existing.push(listener);
	    }
	
	    // Check for listener leak
	    m = _getMaxListeners(target);
	    if (m > 0 && existing.length > m && !existing.warned) {
	      existing.warned = true;
	      // No error code for this since it is a Warning
	      // eslint-disable-next-line no-restricted-syntax
	      var w = new Error('Possible EventEmitter memory leak detected. ' +
	                          existing.length + ' ' + String(type) + ' listeners ' +
	                          'added. Use emitter.setMaxListeners() to ' +
	                          'increase limit');
	      w.name = 'MaxListenersExceededWarning';
	      w.emitter = target;
	      w.type = type;
	      w.count = existing.length;
	      ProcessEmitWarning(w);
	    }
	  }
	
	  return target;
	}
	
	EventEmitter.prototype.addListener = function addListener(type, listener) {
	  return _addListener(this, type, listener, false);
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.prependListener =
	    function prependListener(type, listener) {
	      return _addListener(this, type, listener, true);
	    };
	
	function onceWrapper() {
	  if (!this.fired) {
	    this.target.removeListener(this.type, this.wrapFn);
	    this.fired = true;
	    if (arguments.length === 0)
	      return this.listener.call(this.target);
	    return this.listener.apply(this.target, arguments);
	  }
	}
	
	function _onceWrap(target, type, listener) {
	  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
	  var wrapped = onceWrapper.bind(state);
	  wrapped.listener = listener;
	  state.wrapFn = wrapped;
	  return wrapped;
	}
	
	EventEmitter.prototype.once = function once(type, listener) {
	  checkListener(listener);
	  this.on(type, _onceWrap(this, type, listener));
	  return this;
	};
	
	EventEmitter.prototype.prependOnceListener =
	    function prependOnceListener(type, listener) {
	      checkListener(listener);
	      this.prependListener(type, _onceWrap(this, type, listener));
	      return this;
	    };
	
	// Emits a 'removeListener' event if and only if the listener was removed.
	EventEmitter.prototype.removeListener =
	    function removeListener(type, listener) {
	      var list, events, position, i, originalListener;
	
	      checkListener(listener);
	
	      events = this._events;
	      if (events === undefined)
	        return this;
	
	      list = events[type];
	      if (list === undefined)
	        return this;
	
	      if (list === listener || list.listener === listener) {
	        if (--this._eventsCount === 0)
	          this._events = Object.create(null);
	        else {
	          delete events[type];
	          if (events.removeListener)
	            this.emit('removeListener', type, list.listener || listener);
	        }
	      } else if (typeof list !== 'function') {
	        position = -1;
	
	        for (i = list.length - 1; i >= 0; i--) {
	          if (list[i] === listener || list[i].listener === listener) {
	            originalListener = list[i].listener;
	            position = i;
	            break;
	          }
	        }
	
	        if (position < 0)
	          return this;
	
	        if (position === 0)
	          list.shift();
	        else {
	          spliceOne(list, position);
	        }
	
	        if (list.length === 1)
	          events[type] = list[0];
	
	        if (events.removeListener !== undefined)
	          this.emit('removeListener', type, originalListener || listener);
	      }
	
	      return this;
	    };
	
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	
	EventEmitter.prototype.removeAllListeners =
	    function removeAllListeners(type) {
	      var listeners, events, i;
	
	      events = this._events;
	      if (events === undefined)
	        return this;
	
	      // not listening for removeListener, no need to emit
	      if (events.removeListener === undefined) {
	        if (arguments.length === 0) {
	          this._events = Object.create(null);
	          this._eventsCount = 0;
	        } else if (events[type] !== undefined) {
	          if (--this._eventsCount === 0)
	            this._events = Object.create(null);
	          else
	            delete events[type];
	        }
	        return this;
	      }
	
	      // emit removeListener for all listeners on all events
	      if (arguments.length === 0) {
	        var keys = Object.keys(events);
	        var key;
	        for (i = 0; i < keys.length; ++i) {
	          key = keys[i];
	          if (key === 'removeListener') continue;
	          this.removeAllListeners(key);
	        }
	        this.removeAllListeners('removeListener');
	        this._events = Object.create(null);
	        this._eventsCount = 0;
	        return this;
	      }
	
	      listeners = events[type];
	
	      if (typeof listeners === 'function') {
	        this.removeListener(type, listeners);
	      } else if (listeners !== undefined) {
	        // LIFO order
	        for (i = listeners.length - 1; i >= 0; i--) {
	          this.removeListener(type, listeners[i]);
	        }
	      }
	
	      return this;
	    };
	
	function _listeners(target, type, unwrap) {
	  var events = target._events;
	
	  if (events === undefined)
	    return [];
	
	  var evlistener = events[type];
	  if (evlistener === undefined)
	    return [];
	
	  if (typeof evlistener === 'function')
	    return unwrap ? [evlistener.listener || evlistener] : [evlistener];
	
	  return unwrap ?
	    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
	}
	
	EventEmitter.prototype.listeners = function listeners(type) {
	  return _listeners(this, type, true);
	};
	
	EventEmitter.prototype.rawListeners = function rawListeners(type) {
	  return _listeners(this, type, false);
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  if (typeof emitter.listenerCount === 'function') {
	    return emitter.listenerCount(type);
	  } else {
	    return listenerCount.call(emitter, type);
	  }
	};
	
	EventEmitter.prototype.listenerCount = listenerCount;
	function listenerCount(type) {
	  var events = this._events;
	
	  if (events !== undefined) {
	    var evlistener = events[type];
	
	    if (typeof evlistener === 'function') {
	      return 1;
	    } else if (evlistener !== undefined) {
	      return evlistener.length;
	    }
	  }
	
	  return 0;
	}
	
	EventEmitter.prototype.eventNames = function eventNames() {
	  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
	};
	
	function arrayClone(arr, n) {
	  var copy = new Array(n);
	  for (var i = 0; i < n; ++i)
	    copy[i] = arr[i];
	  return copy;
	}
	
	function spliceOne(list, index) {
	  for (; index + 1 < list.length; index++)
	    list[index] = list[index + 1];
	  list.pop();
	}
	
	function unwrapListeners(arr) {
	  var ret = new Array(arr.length);
	  for (var i = 0; i < ret.length; ++i) {
	    ret[i] = arr[i].listener || arr[i];
	  }
	  return ret;
	}
	
	function once(emitter, name) {
	  return new Promise(function (resolve, reject) {
	    function errorListener(err) {
	      emitter.removeListener(name, resolver);
	      reject(err);
	    }
	
	    function resolver() {
	      if (typeof emitter.removeListener === 'function') {
	        emitter.removeListener('error', errorListener);
	      }
	      resolve([].slice.call(arguments));
	    };
	
	    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
	    if (name !== 'error') {
	      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
	    }
	  });
	}
	
	function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
	  if (typeof emitter.on === 'function') {
	    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
	  }
	}
	
	function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
	  if (typeof emitter.on === 'function') {
	    if (flags.once) {
	      emitter.once(name, listener);
	    } else {
	      emitter.on(name, listener);
	    }
	  } else if (typeof emitter.addEventListener === 'function') {
	    // EventTarget does not have `error` event semantics like Node
	    // EventEmitters, we do not listen for `error` events here.
	    emitter.addEventListener(name, function wrapListener(arg) {
	      // IE does not have builtin `{ once: true }` support so we
	      // have to do it manually.
	      if (flags.once) {
	        emitter.removeEventListener(name, wrapListener);
	      }
	      listener(arg);
	    });
	  } else {
	    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
	  }
	}


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(177);
	
	var hasPropertyDescriptors = function hasPropertyDescriptors() {
		return !!$defineProperty;
	};
	
	hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
		// node v0.6 has a bug where array lengths can be Set but not Defined
		if (!$defineProperty) {
			return null;
		}
		try {
			return $defineProperty([], 'length', { value: 1 }).length !== 1;
		} catch (e) {
			// In Firefox 4-22, defining length on an array throws an exception.
			return true;
		}
	};
	
	module.exports = hasPropertyDescriptors;


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = __webpack_require__(446);
	
	/** @type {import('.')} */
	module.exports = function hasToStringTagShams() {
		return hasSymbols() && !!Symbol.toStringTag;
	};


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(141),
	    baseLodash = __webpack_require__(270);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(141),
	    baseLodash = __webpack_require__(270);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(101),
	    root = __webpack_require__(58);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(6853),
	    mapCacheDelete = __webpack_require__(6854),
	    mapCacheGet = __webpack_require__(6855),
	    mapCacheHas = __webpack_require__(6856),
	    mapCacheSet = __webpack_require__(6857);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 266 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 267 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(140),
	    eq = __webpack_require__(147);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(6776),
	    isObjectLike = __webpack_require__(53);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 270 */
/***/ function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(187);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(452);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(6890),
	    overRest = __webpack_require__(496),
	    setToString = __webpack_require__(278);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(494),
	    noop = __webpack_require__(283);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ },
/* 275 */
/***/ function(module, exports) {

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	module.exports = getHolder;


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(454),
	    stubArray = __webpack_require__(514);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(35),
	    isSymbol = __webpack_require__(103);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(6796),
	    shortOut = __webpack_require__(500);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(462),
	    baseFlatten = __webpack_require__(142),
	    baseRest = __webpack_require__(86),
	    isArrayLikeObject = __webpack_require__(149);
	
	/**
	 * Creates an array of `array` values not included in the other given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * **Note:** Unlike `_.pullAll`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.without, _.xor
	 * @example
	 *
	 * _.difference([2, 1], [2, 3]);
	 * // => [1]
	 */
	var difference = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	    : [];
	});
	
	module.exports = difference;


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(269);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 281 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(265);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 283 */
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(457),
	    baseIteratee = __webpack_require__(62),
	    baseSome = __webpack_require__(6797),
	    isArray = __webpack_require__(35),
	    isIterateeCall = __webpack_require__(117);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(207);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var baseUniq = __webpack_require__(473);
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurrence of each element
	 * is kept. The order of result values is determined by the order they occur
	 * in the array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 */
	function uniq(array) {
	  return (array && array.length) ? baseUniq(array) : [];
	}
	
	module.exports = uniq;


/***/ },
/* 287 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = all;
	
	var _createChainableTypeChecker = __webpack_require__(6970);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function all() {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  function allPropTypes() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var error = null;
	
	    validators.forEach(function (validator) {
	      if (error != null) {
	        return;
	      }
	
	      var result = validator.apply(undefined, args);
	      if (result != null) {
	        error = result;
	      }
	    });
	
	    return error;
	  }
	
	  return (0, _createChainableTypeChecker2.default)(allPropTypes);
	}
	module.exports = exports['default'];

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var propTypes = {
	  /**
	   * Specify whether the feedback is for valid or invalid fields
	   *
	   * @type {('valid'|'invalid')}
	   */
	  type: _propTypes.default.string.isRequired,
	  as: _propTypes.default.elementType
	};
	var defaultProps = {
	  type: 'valid'
	};
	
	var Feedback = _react.default.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
	function (_ref, ref) {
	  var _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      className = _ref.className,
	      type = _ref.type,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["as", "className", "type"]);
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    ref: ref,
	    className: (0, _classnames.default)(className, type && type + "-feedback")
	  }));
	});
	
	Feedback.displayName = 'Feedback';
	Feedback.propTypes = propTypes;
	Feedback.defaultProps = defaultProps;
	var _default = Feedback;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 290 */
/***/ function(module, exports) {

	"use strict";function insertRule(e){try{return sheet.insertRule(e,sheet.cssRules.length)}catch(e){console.warn("react-reveal - animation failed")}}function cascade(e,n,t,o,r){var s=Math.log(o),i=Math.log(r),a=(i-s)/(t-n);return Math.exp(s+a*(e-n))}function animation(e){if(!sheet)return"";var n="@keyframes "+(name+counter)+"{"+e+"}",t=effectMap[e];return t?""+name+t:(sheet.insertRule(n,sheet.cssRules.length),effectMap[e]=counter,""+name+counter++)}function hideAll(){globalHide||(exports.globalHide=globalHide=!0,window.removeEventListener("scroll",hideAll,!0),insertRule("."+namespace+" { opacity: 0; }"),window.removeEventListener("orientationchange",hideAll,!0),window.document.removeEventListener("visibilitychange",hideAll))}function config(e){var n=e.ssrFadeout;exports.fadeOutEnabled=fadeOutEnabled=n}Object.defineProperty(exports,"__esModule",{value:!0}),exports.insertRule=insertRule,exports.cascade=cascade,exports.animation=animation,exports.hideAll=hideAll,exports.default=config;var namespace=exports.namespace="react-reveal",defaults=exports.defaults={duration:1e3,delay:0,count:1},ssr=exports.ssr=!0,observerMode=exports.observerMode=!1,raf=exports.raf=function(e){return window.setTimeout(e,66)},disableSsr=exports.disableSsr=function(){return exports.ssr=ssr=!1},fadeOutEnabled=exports.fadeOutEnabled=!1,ssrFadeout=exports.ssrFadeout=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];return exports.fadeOutEnabled=fadeOutEnabled=e},globalHide=exports.globalHide=!1,ie10=exports.ie10=!1,collapseend=exports.collapseend=void 0,counter=1,effectMap={},sheet=!1,name=namespace+"-"+Math.floor(1e15*Math.random())+"-";if("undefined"!=typeof window&&"nodejs"!==window.name&&window.document&&"undefined"!=typeof navigator){exports.observerMode=observerMode="IntersectionObserver"in window&&"IntersectionObserverEntry"in window&&"intersectionRatio"in window.IntersectionObserverEntry.prototype&&/\{\s*\[native code\]\s*\}/.test(""+IntersectionObserver),exports.raf=raf=window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||raf,exports.ssr=ssr=window.document.querySelectorAll("div[data-reactroot]").length>0,-1!==navigator.appVersion.indexOf("MSIE 10")&&(exports.ie10=ie10=!0),ssr&&"performance"in window&&"timing"in window.performance&&"domContentLoadedEventEnd"in window.performance.timing&&window.performance.timing.domLoading&&Date.now()-window.performance.timing.domLoading<300&&(exports.ssr=ssr=!1),ssr&&window.setTimeout(disableSsr,1500),observerMode||(exports.collapseend=collapseend=document.createEvent("Event"),collapseend.initEvent("collapseend",!0,!0));var element=document.createElement("style");document.head.appendChild(element),element.sheet&&element.sheet.cssRules&&element.sheet.insertRule&&(sheet=element.sheet,window.addEventListener("scroll",hideAll,!0),window.addEventListener("orientationchange",hideAll,!0),window.document.addEventListener("visibilitychange",hideAll))}

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _catalogoPersona = __webpack_require__(64);
	
	var _catalogoPersona2 = _interopRequireDefault(_catalogoPersona);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegistrarProveedor = function RegistrarProveedor(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var anio = JSON.parse(sessionStorage.getItem('anioactu'));
	    var fechaTope = (0, _moment2.default)(JSON.parse(sessionStorage.getItem('fechasistema'))).format('YYYY-MM-DD').replace(anio.toString(), (anio - 18).toString());
	    var registrado = false;
	    var muni = '';
	    var ciu = '';
	
	    var btnCancela = (0, _react.useRef)();
	    var btnAcepta = (0, _react.useRef)();
	    var chkNatural = (0, _react.useRef)();
	    var chkJuridico = (0, _react.useRef)();
	    var txtId = (0, _react.useRef)();
	    var cmbRif = (0, _react.useRef)();
	    var txtRif = (0, _react.useRef)();
	    var txtRazon = (0, _react.useRef)();
	    var txtDirClient = (0, _react.useRef)();
	    var txtEmailClient = (0, _react.useRef)();
	    var txtTlf1Client = (0, _react.useRef)();
	    var txtTlf2Client = (0, _react.useRef)();
	    var txtEstado = (0, _react.useRef)();
	    var txtMunicipio = (0, _react.useRef)();
	    var txtCiudad = (0, _react.useRef)();
	    var txtStatus = (0, _react.useRef)();
	
	    var cmbNacionalidad = (0, _react.useRef)();
	    var txtCedRes = (0, _react.useRef)();
	    var cmbSexo = (0, _react.useRef)();
	    var txtFechaNac = (0, _react.useRef)();
	    var txtNomResp = (0, _react.useRef)();
	    var txtApeResp = (0, _react.useRef)();
	    var txtDireccion = (0, _react.useRef)();
	    var txtEmail = (0, _react.useRef)();
	    var txtTlf1 = (0, _react.useRef)();
	    var txtTlf2 = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        body = _useState2[0],
	        setBody = _useState2[1];
	
	    var _useState3 = (0, _react.useState)('visible'),
	        _useState4 = _slicedToArray(_useState3, 2),
	        visibleBtn = _useState4[0],
	        setVisibleBtn = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(0),
	        _useState6 = _slicedToArray(_useState5, 2),
	        ops = _useState6[0],
	        setOps = _useState6[1];
	
	    var _useState7 = (0, _react.useState)('Gestionar Proveedores.'),
	        _useState8 = _slicedToArray(_useState7, 2),
	        tituloHeader = _useState8[0],
	        setTituloHeader = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(false),
	        _useState10 = _slicedToArray(_useState9, 2),
	        catalogoPersona = _useState10[0],
	        setCatalogoPersona = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(0),
	        _useState12 = _slicedToArray(_useState11, 2),
	        operacionPer = _useState12[0],
	        setOperacionPer = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(true),
	        _useState14 = _slicedToArray(_useState13, 2),
	        activob = _useState14[0],
	        setActivob = _useState14[1];
	
	    var _useState15 = (0, _react.useState)([]),
	        _useState16 = _slicedToArray(_useState15, 2),
	        estados = _useState16[0],
	        setEstados = _useState16[1];
	
	    var _useState17 = (0, _react.useState)([]),
	        _useState18 = _slicedToArray(_useState17, 2),
	        municipios = _useState18[0],
	        setMunicipios = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(),
	        _useState20 = _slicedToArray(_useState19, 2),
	        nacnalidad = _useState20[0],
	        setNacnalidad = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(0),
	        _useState22 = _slicedToArray(_useState21, 2),
	        valrif = _useState22[0],
	        setValrif = _useState22[1];
	
	    var _useState23 = (0, _react.useState)([]),
	        _useState24 = _slicedToArray(_useState23, 2),
	        ciudades = _useState24[0],
	        setCiudades = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(false),
	        _useState26 = _slicedToArray(_useState25, 2),
	        catalogoCliente = _useState26[0],
	        setCatalogoCliente = _useState26[1];
	
	    var _useState27 = (0, _react.useState)(true),
	        _useState28 = _slicedToArray(_useState27, 2),
	        habilitado = _useState28[0],
	        setHabilitado = _useState28[1];
	
	    var _useState29 = (0, _react.useState)(true),
	        _useState30 = _slicedToArray(_useState29, 2),
	        habilitadoNU = _useState30[0],
	        setHabilitadoNU = _useState30[1];
	
	    var _useState31 = (0, _react.useState)(1),
	        _useState32 = _slicedToArray(_useState31, 2),
	        select = _useState32[0],
	        setSelect = _useState32[1];
	
	    var _useState33 = (0, _react.useState)(false),
	        _useState34 = _slicedToArray(_useState33, 2),
	        activo = _useState34[0],
	        setActivo = _useState34[1];
	
	    var _useState35 = (0, _react.useState)(false),
	        _useState36 = _slicedToArray(_useState35, 2),
	        activate = _useState36[0],
	        setActivate = _useState36[1];
	
	    var _useState37 = (0, _react.useState)({
	        incluir: false,
	        consultar: false,
	        modificar: false,
	        eliminar: false,
	        aceptar: true,
	        cancelar: true,
	        catalogo: true,
	        catalogoper: true
	    }),
	        _useState38 = _slicedToArray(_useState37, 2),
	        botones = _useState38[0],
	        setBotones = _useState38[1];
	
	    var _useState39 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState40 = _slicedToArray(_useState39, 2),
	        mensaje = _useState40[0],
	        setMensaje = _useState40[1];
	
	    var _useState41 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState42 = _slicedToArray(_useState41, 2),
	        mensajesino = _useState42[0],
	        setMensajesino = _useState42[1];
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = '*';
	        var nomtab = 'estado';
	        var orden = 'idestado';
	
	        var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setEstados(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var selectMunicipios = function selectMunicipios(id) {
	        var campos = '*';
	        var nomtab = 'municipio';
	        var nomid = 'idestado';
	        var endpoint = op.conexion + '/api/consulta/modelirows?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid;
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                setMunicipios(response.data);
	                if (registrado || !botones.consultar || !botones.modificar || !botones.eliminar) {
	                    txtMunicipio.current.value = muni;
	                }
	            }
	        }).catch(function (error) {
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	        });
	    };
	
	    var selectCiudad = function selectCiudad(id) {
	        var campos = '*';
	        var nomtab = 'ciudad';
	        var nomid = 'idmunicipio';
	        var endpoint = op.conexion + '/api/consulta/modelirows?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid;
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                setCiudades(response.data);
	                if (registrado || !botones.consultar || !botones.modificar || !botones.eliminar) {
	                    txtCiudad.current.value = ciu;
	                }
	            }
	        }).catch(function (error) {
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setTituloHeader('Gestionar Proveedores.');
	
	        setVisibleBtn('visible');
	        setActivate(false);
	        setActivo(true);
	        setActivob(true);
	        setBody(null);
	        setOperacionPer(0);
	        setHabilitado(true);
	        setHabilitadoNU(true);
	        setMunicipios([]);
	        setValrif(0);
	        setCiudades([]);
	        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        setBotones({
	            incluir: false,
	            consultar: false,
	            modificar: false,
	            eliminar: false,
	            aceptar: true,
	            cancelar: true,
	            catalogo: true,
	            catalogoper: true
	        });
	        chkJuridico.current.checked = true;
	        cmbRif.current.value = '';
	        txtRif.current.value = '';
	        txtId.current.value = 0;
	        txtRazon.current.value = '';
	        txtDirClient.current.value = '';
	        txtTlf1Client.current.value = '';
	        txtTlf2Client.current.value = '';
	        txtEmailClient.current.value = '';
	        txtStatus.current.value = '';
	        txtEstado.current.value = '';
	        txtMunicipio.current.value = '';
	        txtCiudad.current.value = '';
	
	        cmbNacionalidad.current.value = '';
	        txtCedRes.current.value = '';
	        cmbSexo.current.value = '';
	        txtFechaNac.current.value = '';
	        txtNomResp.current.value = '';
	        txtApeResp.current.value = '';
	        txtDireccion.current.value = '';
	        txtEmail.current.value = '';
	        txtTlf1.current.value = '';
	        txtTlf2.current.value = '';
	
	        setSelect(1);
	        setNacnalidad();
	    };
	
	    var onChangeValidar = function onChangeValidar() {
	
	        var sigue = true;
	        if (ops === 1) {
	
	            var nom = void 0;
	            nom = select === 1 ? 'Nombre/Razón Social' : 'Nombres y Apellidos';
	
	            var ced = void 0;
	            ced = select === 1 ? 'R.I.F' : 'Cédula';
	
	            if (txtStatus.current.value === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione el Estatus del Proveedor', icono: 'informacion' });
	                txtStatus.current.focus();
	                sigue = false;
	            } else if (txtRazon.current.value === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El campo' + ' ' + nom + ' ' + 'no debe ir Vacio', icono: 'informacion' });
	                txtRazon.current.focus();
	                sigue = false;
	            } else if (txtDirClient.current.value === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Describa la Dirección del Proveedor', icono: 'informacion' });
	                txtDirClient.current.focus();
	                sigue = false;
	            } else if (txtEmailClient.current.value === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Describa el Correo del Proveedor', icono: 'informacion' });
	                txtEmailClient.current.focus();
	                sigue = false;
	            } else if (txtEstado.current.value === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione el Estado del Proveedor', icono: 'informacion' });
	                txtEstado.current.focus();
	                sigue = false;
	            } else if (txtMunicipio.current.value === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione el Municipio del Proveedor', icono: 'informacion' });
	                txtMunicipio.current.focus();
	                sigue = false;
	            } else if (txtCiudad.current.value === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione la Ciudad del Proveedor', icono: 'informacion' });
	                txtCiudad.current.focus();
	                sigue = false;
	            } else if (txtCedRes.current.value === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar el Responsable', icono: 'informacion' });
	                txtCedRes.current.focus();
	                sigue = false;
	            }
	        }
	
	        if (sigue) {
	
	            var cliente = [];
	            var repre = [];
	            cliente.push({
	                idagente: !botones.incluir ? 0 : txtId.current.value,
	                nombre: txtRazon.current.value.toUpperCase().trim(),
	                direccion: txtDirClient.current.value.toUpperCase().trim(),
	                tipoper: chkNatural.current.checked ? 0 : 1,
	                rif: nacnalidad + txtRif.current.value,
	                reprelegal: cmbNacionalidad.current.value + txtCedRes.current.value,
	                telefono: txtTlf1Client.current.value,
	                celular: txtTlf2Client.current.value,
	                email: txtEmailClient.current.value.toUpperCase().trim(),
	                proveedor: true,
	                statusproveedor: txtStatus.current.value.trim(),
	                estado: txtEstado.current.value.trim(),
	                municipio: txtMunicipio.current.value.trim(),
	                ciudad: txtCiudad.current.value.trim()
	            });
	            repre.push({
	                cedula: parseInt(txtCedRes.current.value),
	                correoe: txtEmail.current.value.toUpperCase().trim(),
	                tlf1: txtTlf1.current.value.trim(),
	                tlf2: txtTlf2.current.value.trim(),
	                apellidos: txtApeResp.current.value.toUpperCase().trim(),
	                direccion: txtDireccion.current.value.toUpperCase().trim(),
	                fnacimiento: txtFechaNac.current.value.trim(),
	                nacionalidad: cmbNacionalidad.current.value.trim(),
	                nombres: txtNomResp.current.value.toUpperCase().trim(),
	                sexo: cmbSexo.current.value.trim()
	            });
	
	            setBody({
	                operacionper: operacionPer,
	                agente: cliente,
	                repre: repre,
	                client: []
	            });
	
	            var msg = '';
	            if (!botones.incluir) {
	                msg = 'Esta Seguro de Registrar estos Datos.';
	            } else if (!botones.modificar) {
	                msg = 'Esta Seguro de Modificar estos Datos.';
	            } else if (!botones.eliminar) {
	                msg = 'Esta Seguro de Eliminar estos Datos.';
	            }
	
	            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	        }
	    };
	
	    var procesarRegistro = function procesarRegistro() {
	        setActivate(true);
	        var endpoint = op.conexion + '/api/agente/actualizar/' + ops;
	        _axios2.default.post(endpoint, body, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	
	                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Creado Correctamente', icono: 'exito' });
	
	                setActivate(false);
	            }
	        }).catch(function (error) {
	            var mensaje = '';
	            if (error.response === undefined) {
	                mensaje = 'Error de Conexion';
	            } else {
	                if (error.response.data.message === 'duplicate key value violates unique constraint "agente_rif_key"') {
	                    mensaje = 'Ya existe un Registro con este rif';
	                } else if (error.response.data.message === 'duplicate key value violates unique constraint "agente_email_key"') {
	                    mensaje = 'Ya existe un Registro con este correo';
	                } else {
	                    mensaje = error.response.data.message;
	                }
	            }
	            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	            setActivate(false);
	        });
	    };
	
	    var handleCloseSi = function handleCloseSi() {
	        setActivate(false);
	        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        procesarRegistro();
	    };
	
	    var handleInputNumChange = function handleInputNumChange(event) {
	        event.preventDefault();
	        (0, _varios.validaSoloNumero)(event);
	
	        if (event.which === 46) {
	            return false;
	        } else if (event.which >= 48 && event.which <= 57) {
	            return true;
	        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	            return true;
	        } else return false;
	    };
	
	    var datosRes = function datosRes() {
	        var campos = '*';
	        var nomtab = 'persona';
	        var nomid = 'cedula';
	        var nomid2 = 'nacionalidad';
	        var id = txtCedRes.current.value;
	        var id2 = cmbNacionalidad.current.value;
	        var endpoint = op.conexion + '/api/consulta/modeli2?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id + '&nomid2=' + nomid2 + '&id2=' + id2;
	
	        setActivate(true);
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	
	                cmbSexo.current.value = '';
	                txtFechaNac.current.value = '';
	                txtNomResp.current.value = '';
	                txtApeResp.current.value = '';
	                txtDireccion.current.value = '';
	                txtEmail.current.value = '';
	                txtTlf1.current.value = '';
	                txtTlf2.current.value = '';
	
	                if (response.data !== '') {
	                    setHabilitadoNU(true);
	                    setOperacionPer(0);
	                    cmbSexo.current.value = response.data.sexo;
	                    txtFechaNac.current.value = (0, _moment2.default)(response.data.fnacimiento).format('YYYY-MM-DD');
	                    txtNomResp.current.value = response.data.nombres;
	                    txtApeResp.current.value = response.data.apellidos;
	                    txtDireccion.current.value = response.data.direccion;
	                    txtEmail.current.value = response.data.correoe;
	                    txtTlf1.current.value = response.data.tlf1;
	                    txtTlf2.current.value = response.data.tlf2;
	                } else {
	                    txtNomResp.current.focus();
	                    setOperacionPer(1);
	                    setHabilitadoNU(false);
	                }
	            }
	            setActivate(false);
	        }).catch(function (error) {
	            setActivate(false);
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	        });
	    };
	
	    var datosPro = function datosPro(rif) {
	
	        var campos = '*';
	        var nomtab = 'agente';
	        var nomid = 'rif';
	        var id = rif;
	        var endpoint = '';
	
	        endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status == 200) {
	
	                if (response.data !== '') {
	
	                    if (response.data.proveedor === true && response.data.rif === valrif) {
	
	                        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡El Proveedor con el N° de Cédula o RIF' + ' ' + response.data.rif + ' ' + 'ya Existe!', icono: 'informacion' });
	                        setOps(2);
	                        setActivo(true);
	                        txtId.current.value = '';
	                        txtStatus.current.value = '';
	                        txtRazon.current.value = '';
	                        txtDirClient.current.value = '';
	                        txtEmailClient.current.value = '';
	                        txtTlf1Client.current.value = '';
	                        txtTlf2Client.current.value = '';
	                        txtEstado.current.value = '';
	                        txtMunicipio.current.value = '';
	                        txtCiudad.current.value = '';
	                        txtRif.current.value = '';
	                        cmbRif.current.value = '--';
	
	                        cmbNacionalidad.current.value = '';
	                        txtCedRes.current.value = '';
	
	                        muni = '';
	                        ciu = '';
	
	                        cmbSexo.current.value = '';
	                        txtFechaNac.current.value = '';
	                        txtNomResp.current.value = '';
	                        txtApeResp.current.value = '';
	                        txtDireccion.current.value = '';
	                        txtEmail.current.value = '';
	                        txtTlf1.current.value = '';
	                        txtTlf2.current.value = '';
	                    } else {
	                        txtId.current.value = response.data.idagente;
	                        txtStatus.current.value = response.data.statusproveedor;
	                        txtRazon.current.value = response.data.nombre;
	                        txtDirClient.current.value = response.data.direccion;
	                        txtEmailClient.current.value = response.data.email;
	                        txtTlf1Client.current.value = response.data.telefono;
	                        txtTlf2Client.current.value = response.data.celular;
	                        txtEstado.current.value = response.data.estado;
	                        txtMunicipio.current.value = response.data.municipio;
	                        txtCiudad.current.value = response.data.ciudad;
	
	                        cmbNacionalidad.current.value = response.data.reprelegal.substring(0, 1);
	                        txtCedRes.current.value = response.data.reprelegal.substring(1, 9);
	
	                        muni = response.data.municipio.trim();
	                        ciu = response.data.ciudad.trim();
	
	                        selectMunicipios(response.data.estado.trim());
	                        selectCiudad(response.data.municipio.trim());
	                        datosRes();
	                        setNacnalidad(response.data.rif.substring(0, 1));
	                        setActivo(false);
	                        setOps(1);
	
	                        var tip = response.data.tipoper;
	                        if (tip === 1) {
	                            chkJuridico.current.checked = true;
	                            chkNatural.current.checked = false;
	                        } else {
	                            chkNatural.current.checked = true;
	                            chkJuridico.current.checked = false;
	                        }
	
	                        setSelect(response.data.tipoper);
	                    }
	                } else {
	                    setActivo(false);
	                    setOps(1);
	                    txtRazon.current.focus();
	                }
	            }
	
	            setActivate(false);
	        }).catch(function (error) {
	
	            setActivate(false);
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	        });
	    };
	
	    var validarPersona = function validarPersona(event) {
	        event.preventDefault();
	        (0, _varios.validaSoloNumero)(event);
	        if (event.which === 13 || typeof event.which === 'undefined') {
	            if (event.target.value !== '') {
	                if (cmbNacionalidad.current.value !== '') {
	                    datosRes();
	                } else {
	                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'debe seleccionar la nacionalidad', icono: 'informacion' });
	                    cmbNacionalidad.current.focus();
	                }
	            } else {
	                cmbNacionalidad.current.value = '';
	                cmbSexo.current.value = '';
	                txtFechaNac.current.value = '';
	                txtNomResp.current.value = '';
	                txtApeResp.current.value = '';
	                txtDireccion.current.value = '';
	                txtEmail.current.value = '';
	                txtTlf1.current.value = '';
	                txtTlf2.current.value = '';
	                setHabilitadoNU(true);
	            }
	        }
	    };
	
	    var validarCliente = function validarCliente(event) {
	        event.preventDefault();
	        if (event.which === 13 || typeof event.which === 'undefined') {
	            if (event.target.value !== '') {
	                if (cmbRif.current.value !== "") {
	                    datosPro(nacnalidad + event.target.value);
	                } else {
	                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar el Tipo de Nacionalidad', icono: 'informacion' });
	                    cmbRif.current.focus();
	                }
	            }
	        }
	    };
	
	    var cancelar = function cancelar() {
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var onChangeCliente = function onChangeCliente(e) {
	
	        var n = void 0;
	        var r = void 0;
	
	        if (e.target.name === 'estado') {
	            setMunicipios([]);
	            setCiudades([]);
	            if (e.target.value !== '') {
	                selectMunicipios(e.target.value);
	            }
	        } else if (e.target.name === 'municipio') {
	            setCiudades([]);
	            if (e.target.value !== '') {
	                selectCiudad(e.target.value);
	            }
	        } else if (e.target.name === 'tipoper') {
	            if (chkNatural.current.checked) {
	                setSelect(0);
	            } else if (chkJuridico.current.checked) {
	                setSelect(1);
	            }
	        } else if (e.target.name === 'cmbrif') {
	            var nac = cmbRif.current.value;
	            txtRif.current.value = '';
	            setNacnalidad(nac);
	        } else if (e.target.name === 'cedula') {
	            n = cmbRif.current.value;
	            r = txtRif.current.value;
	        }
	        setValrif(n + r);
	    };
	
	    var onChange = function onChange(e) {
	
	        if (e.target.name === 'correoe' || e.target.name === 'apellidos' || e.target.name === 'direccion' || e.target.name === 'nombres' || e.target.name === 'descripcion') {
	            e.target.value = e.target.value;
	        } else if (e.target.name === 'nacionalidad' && txtCedRes.current.value !== '') {
	            if (e.target.value !== '') {
	                datosRes();
	            } else {
	                txtCedRes.current.value = '';
	                cmbSexo.current.value = '';
	                txtFechaNac.current.value = '';
	                txtNomResp.current.value = '';
	                txtApeResp.current.value = '';
	                txtDireccion.current.value = '';
	                txtEmail.current.value = '';
	                txtTlf1.current.value = '';
	                txtTlf2.current.value = '';
	            }
	        }
	    };
	
	    var onCatalogoCliente = function onCatalogoCliente(values) {
	        setCatalogoCliente(false);
	
	        txtRazon.current.value = values.nombre;
	        cmbRif.current.value = values.rif.substring(0, 1);
	        txtRif.current.value = values.rifs;
	        cmbNacionalidad.current.value = values.reprelegal.substring(0, 1);
	        txtCedRes.current.value = values.repre;
	        setNacnalidad(values.rif.substring(0, 1));
	        datosPro(values.rif);
	        if (!botones.modificar) {
	            setBotones(Object.assign({}, botones, { catalogoper: false }));
	        }
	    };
	
	    var onCatalogoPersona = function onCatalogoPersona(values) {
	        setCatalogoPersona(false);
	        setHabilitadoNU(true);
	        setOperacionPer(0);
	        cmbNacionalidad.current.value = values.nacPer;
	        txtCedRes.current.value = values.cedPer;
	        cmbSexo.current.value = values.sexoPer;
	        txtFechaNac.current.value = (0, _moment2.default)(values.fnacPer).format('YYYY-MM-DD');
	        txtNomResp.current.value = values.nomPer;
	        txtApeResp.current.value = values.apePer;
	        txtDireccion.current.value = values.direPer;
	        txtEmail.current.value = values.correoPer;
	        txtTlf1.current.value = values.tlf1Per;
	        txtTlf2.current.value = values.tlf2Per;
	    };
	
	    (0, _react.useEffect)(function () {
	        seleccionarRegistros();
	    }, []);
	
	    var cerrarModal = function cerrarModal() {
	        props.onHideCancelar();
	        blanquear();
	        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            size: 'xl',
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                setOps(props.op);
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Registrar Proveedor'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'row col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'fieldset',
	                        { className: ' row col-sm-12 mx-auto border-azul rounded' },
	                        _react2.default.createElement(
	                            'legend',
	                            { className: 'float-none w-auto fw-bold m-0', style: { fontSize: '15px' } },
	                            'Datos del Proveedor'
	                        ),
	                        _react2.default.createElement('input', { ref: txtId, autoComplete: 'off', type: 'hidden', className: 'form-control', name: 'idagente', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-pd-280 mb-3' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'input-group input-group-sm' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                    select === 1 ? "R.I.F" : "Cédula",
	                                    ' '
	                                ),
	                                select === 1 ? _react2.default.createElement(
	                                    'select',
	                                    { ref: cmbRif, name: 'cmbrif', onChange: onChangeCliente, value: nacnalidad, className: 'col-sm-3 col-3 form-select form-control-sm' },
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '' },
	                                        '-'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { key: '0', value: 'V' },
	                                        'V'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { key: '1', value: 'J' },
	                                        'J'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { key: '2', value: 'G' },
	                                        'G'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { key: '3', value: 'P' },
	                                        'P'
	                                    )
	                                ) : _react2.default.createElement(
	                                    'select',
	                                    { ref: cmbRif, name: 'cmbrif', onChange: onChangeCliente, value: nacnalidad, className: 'col-sm-3 col-3 form-select form-control-sm' },
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '' },
	                                        '-'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { key: '0', value: 'V' },
	                                        'V'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { key: '1', value: 'E' },
	                                        'E'
	                                    )
	                                ),
	                                _react2.default.createElement('input', { ref: txtRif, onChangeCapture: onChangeCliente, autoComplete: 'off', maxLength: 9, type: 'text', className: 'form-control col-4 px-1', name: 'cedula', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: validarCliente, onBlur: validarCliente, onChange: onChange })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-pd-220 mt-15m ml-auto' },
	                            _react2.default.createElement(
	                                'fieldset',
	                                { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	                                _react2.default.createElement(
	                                    'legend',
	                                    { className: 'float-none m-0 w-auto', style: { fontSize: '14px' } },
	                                    'Tipo Persona:'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-5' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-check' },
	                                        _react2.default.createElement('input', { className: 'form-check-input', disabled: ops === 1 ? false : true, name: 'tipoper', value: '1', ref: chkNatural, onChange: onChangeCliente, id: 'tipoper', type: 'radio' }),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'form-check-label', 'for': 'exampleRadi4' },
	                                            'Natural'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-5 ml-auto' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-check' },
	                                        _react2.default.createElement('input', { className: 'form-check-input', disabled: ops === 1 ? false : true, name: 'tipoper', value: '2', ref: chkJuridico, onChange: onChangeCliente, id: 'tipoper', defaultChecked: true, type: 'radio' }),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'form-check-label', 'for': 'exampleRadi5' },
	                                            'Juridico'
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-pd-180 ml-auto' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'input-group input-group-sm' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                    'Estatus:'
	                                ),
	                                _react2.default.createElement(
	                                    'select',
	                                    { ref: txtStatus, disabled: ops === 1 ? false : true, className: 'form-select form-select-sm', 'aria-label': '.form-select-sm example' },
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '' },
	                                        'Seleccione'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '51' },
	                                        'Activo'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '52' },
	                                        'Inactivo'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-12 py-1' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                select === 1 ? "Nombre/Razón Social" : "Nombres y Apellidos"
	                            ),
	                            _react2.default.createElement('input', { type: 'text', autoComplete: 'off', ref: txtRazon, disabled: ops === 1 ? false : true, name: 'nombres', className: 'form-control text-uppercase', onChange: onChange, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-12' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Direcci\xF3n:'
	                            ),
	                            _react2.default.createElement('textarea', { type: 'area', autoComplete: 'off', ref: txtDirClient, disabled: ops === 1 ? false : true, name: 'direccion', className: 'form-control text-uppercase', onChange: onChange, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', style: { height: 40 } })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-4' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Email:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', autoComplete: 'off', ref: txtEmailClient, disabled: ops === 1 ? false : true, className: 'form-control text-uppercase', name: 'correoe', 'aria-label': 'Sizing example input', onChange: onChange, 'aria-describedby': 'inputGroup-sizing-sm' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-4' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Telefono:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', autoComplete: 'off', maxLength: 12, ref: txtTlf1Client, disabled: ops === 1 ? false : true, className: 'form-control', name: 'tlf1', 'aria-label': 'Sizing example input', onChange: onChange, 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: handleInputNumChange })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-4' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Celular:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', autoComplete: 'off', maxLength: 12, ref: txtTlf2Client, disabled: ops === 1 ? false : true, className: 'form-control', name: 'tlf2', 'aria-label': 'Sizing example input', onChange: onChange, 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: handleInputNumChange })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-4' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Estado:'
	                            ),
	                            _react2.default.createElement(
	                                'select',
	                                { ref: txtEstado, disabled: ops === 1 ? false : true, onChange: onChangeCliente, name: 'estado', idciudad: 'estado', className: 'form-select form-select-sm', 'aria-label': '.form-select-sm example' },
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: '' },
	                                    'seleccione'
	                                ),
	                                estados && estados.map(function (item, index) {
	                                    return _react2.default.createElement(
	                                        'option',
	                                        { key: index, value: item.idestado },
	                                        item.nombre
	                                    );
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-4' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Municipio:'
	                            ),
	                            _react2.default.createElement(
	                                'select',
	                                { ref: txtMunicipio, disabled: ops === 1 ? false : true, onChange: onChangeCliente, name: 'municipio', id: 'municipio', className: 'form-select form-select-sm', 'aria-label': '.form-select-sm example' },
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: '' },
	                                    'seleccione'
	                                ),
	                                municipios && municipios.map(function (item, index) {
	                                    return _react2.default.createElement(
	                                        'option',
	                                        { key: index, value: item.idmunicipio },
	                                        item.nombre
	                                    );
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-4' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Ciudad:'
	                            ),
	                            _react2.default.createElement(
	                                'select',
	                                { ref: txtCiudad, disabled: ops === 1 ? false : true, name: 'ciudad', id: 'ciudad', className: 'form-select form-select-sm', 'aria-label': '.form-select-sm example' },
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: '' },
	                                    'seleccione'
	                                ),
	                                ciudades && ciudades.map(function (item, index) {
	                                    return _react2.default.createElement(
	                                        'option',
	                                        { key: index, value: item.idciudad },
	                                        item.nombre
	                                    );
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'fieldset',
	                        { className: ' row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between' },
	                        _react2.default.createElement(
	                            'legend',
	                            { className: 'float-none w-auto fw-bold', style: { fontSize: '15px' } },
	                            'Responsable'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-p-26' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'input-group input-group-sm mb-2' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                    'Cedula:'
	                                ),
	                                _react2.default.createElement(
	                                    'select',
	                                    { ref: cmbNacionalidad, name: 'nacionalidad', className: 'form-select form-select-sm col-md-3', disabled: ops === 1 ? false : true, 'aria-label': '.form-select-sm example', onChange: onChange },
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '' },
	                                        '--'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: 'V' },
	                                        'V'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: 'E' },
	                                        'E'
	                                    )
	                                ),
	                                _react2.default.createElement('input', { ref: txtCedRes, maxLength: 8, autoComplete: 'off', type: 'text', disabled: ops === 1 ? false : true, className: 'form-control col-4 px-1', name: 'cedula', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: validarPersona, onBlur: validarPersona, onChange: onChange }),
	                                _react2.default.createElement(
	                                    'button',
	                                    { disabled: ops === 1 ? false : true, type: 'button', onClick: function onClick() {
	                                            return setCatalogoPersona(true);
	                                        }, className: 'btn btn-success' },
	                                    _react2.default.createElement('i', { className: 'fas fa-search' })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-p-2 ml-auto' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'input-group input-group-sm mb-2' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                    'Sexo:'
	                                ),
	                                _react2.default.createElement(
	                                    'select',
	                                    { ref: cmbSexo, className: 'form-select form-select-sm col-8', name: 'sexo', disabled: habilitadoNU, onChange: onChange, 'aria-label': '.form-select-sm example' },
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '' },
	                                        '--'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: 'M' },
	                                        'M'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: 'F' },
	                                        'F'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-p-26 ml-auto' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'input-group input-group-sm mb-2' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                    'Fecha de Nacimiento'
	                                ),
	                                _react2.default.createElement('input', { type: 'date', ref: txtFechaNac, max: fechaTope, className: 'form-control', name: 'fnacimiento', 'aria-label': 'Sizing example input', onChange: onChange, disabled: habilitadoNU, 'aria-describedby': 'inputGroup-sizing-sm' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-6' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Nombres:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', autoComplete: 'off', ref: txtNomResp, name: 'nombres', className: 'form-control text-uppercase', onChange: onChange, 'aria-label': 'Sizing example input', disabled: habilitadoNU, 'aria-describedby': 'inputGroup-sizing-sm' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-6' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Apellidos:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', autoComplete: 'off', ref: txtApeResp, name: 'apellidos', className: 'form-control text-uppercase', onChange: onChange, 'aria-label': 'Sizing example input', disabled: habilitadoNU, 'aria-describedby': 'inputGroup-sizing-sm' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-12' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Direcci\xF3n:'
	                            ),
	                            _react2.default.createElement('textarea', { type: 'area', autoComplete: 'off', ref: txtDireccion, name: 'direccion', className: 'form-control text-uppercase', onChange: onChange, 'aria-label': 'Sizing example input', disabled: habilitadoNU, 'aria-describedby': 'inputGroup-sizing-sm', style: { height: 40 } })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-4' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Email:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', autoComplete: 'off', ref: txtEmail, className: 'form-control text-uppercase', name: 'correoe', 'aria-label': 'Sizing example input', onChange: onChange, disabled: habilitadoNU, 'aria-describedby': 'inputGroup-sizing-sm' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-4' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Telefono:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', autoComplete: 'off', maxLength: 12, ref: txtTlf1, className: 'form-control', name: 'tlf1', 'aria-label': 'Sizing example input', onChange: onChange, disabled: habilitadoNU, 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: handleInputNumChange })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-4' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Celular:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', autoComplete: 'off', maxLength: 12, ref: txtTlf2, className: 'form-control', name: 'tlf2', 'aria-label': 'Sizing example input', onChange: onChange, disabled: habilitadoNU, 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: handleInputNumChange })
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { className: 'btn btn-sm btn-success rounded-pill', disabled: activo, onClick: onChangeValidar, style: { margin: "5px" } },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        ),
	        _react2.default.createElement(_catalogoCliente2.default, {
	            show: catalogoCliente,
	            nomid: 'cliente',
	            onHideCancelar: function onHideCancelar() {
	                return setCatalogoCliente(false);
	            },
	            onHideAceptaCatalogo: onCatalogoCliente
	        }),
	        _react2.default.createElement(_catalogoPersona2.default, {
	            show: catalogoPersona,
	            onHideCancelaCatPer: function onHideCancelaCatPer() {
	                return setCatalogoPersona(false);
	            },
	            onHideAceptaCatPer: onCatalogoPersona
	        }),
	        _react2.default.createElement(
	            _semanticUiReact.Dimmer,
	            { active: activate, inverted: true },
	            _react2.default.createElement(
	                _semanticUiReact.Loader,
	                { inverted: true },
	                'Cargando...'
	            )
	        ),
	        _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	            onHide: function onHide() {
	                mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	            } }),
	        _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	            onHideNo: function onHideNo() {
	                return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	            }, onHideSi: handleCloseSi })
	    );
	};
	exports.default = RegistrarProveedor;

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoClassVacios = function CatalogoClassVacios(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtBuscar = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      records = _useState6[0],
	      setRecords = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    idclasevacio: "",
	    idproducto: "",
	    descripcion: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      values = _useState8[0],
	      setValues = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(-1),
	      _useState10 = _slicedToArray(_useState9, 2),
	      itemSelect = _useState10[0],
	      setItemSelect = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      filterFn = _useState12[0],
	      setFilterFn = _useState12[1];
	
	  var headCells = [{ label: "CODIGO", textAlign: "center" }, { label: "DESCRIPCION", textAlign: "center" }, props.idalmacen !== null && { label: "EXISTENCIA", textAlign: "center" }];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.idclasevacio.includes(target.value) || x.descripcion.toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "c.idclasevacio, trim(c.descripcion) as descripcion, (select p.idproducto from producto p where p.idclasevacio = c.idclasevacio LIMIT 1) as idproduct";
	    var nomtab = "clasevacio c";
	    var orden = "c.idclasevacio";
	    var nomid = "";
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    if (props.idalmacen !== null) {
	      campos = "x.idclasevacio, trim(cv.descripcion) as descripcion, x.cantidad, (select p.idproducto from producto p where p.idclasevacio = x.idclasevacio) as idproduct";
	      nomtab = "clasevacio as cv inner join existenciavacio as x on cv.idclasevacio=x.idclasevacio";
	      orden = "x.idclasevacio asc";
	      nomid = "x.idalmacen";
	      endpoint = op.conexion + "/api/consulta/modeliorder?campos=" + campos + "&id=" + props.idalmacen + "&nomtab=" + nomtab + "&nomid=" + nomid + "&orden=" + orden;
	    }
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setItemSelect("");
	    setActivate(false);
	    setRecords([]);
	    setValues({
	      idclasevacio: "",
	      idproducto: "",
	      descripcion: ""
	    });
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var seleccionarModelo = function seleccionarModelo() {
	    props.onHideAceptaCatalogo(values);
	  };
	
	  var seleccionarFila = function seleccionarFila(item) {
	    return function (e) {
	      e.preventDefault();
	
	      setValues({
	        idclasevacio: item.idclasevacio,
	        idproducto: item.idproduct,
	        descripcion: item.descripcion
	      });
	      btnAcepta.current.focus();
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        seleccionarRegistros();
	        txtBuscar.current.focus();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Seleccionar Clasificador de Vacio"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-6 input-group-sm mb-3" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group input-group-sm" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "BUSCAR:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                onChange: handleSearch,
	                ref: txtBuscar,
	                className: "form-control text-uppercase",
	                autoComplete: "off",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-sm"
	              })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  style: {
	                    padding: "0",
	                    cursor: "pointer",
	                    background: values.idclasevacio === item.idclasevacio ? "lightskyblue" : "white"
	                  },
	                  onClick: seleccionarFila(item)
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.idclasevacio
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.descripcion
	                ),
	                props.idalmacen !== null && _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-end" },
	                  (0, _varios.formatMoneda)(item.cantidad.toString().replace(".", ","), ",", ".", 2)
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          style: { margin: "5px" },
	          onClick: seleccionarModelo
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoClassVacios;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoOrdenes = function CatalogoOrdenes(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	    var txtBuscar = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(true),
	        _useState6 = _slicedToArray(_useState5, 2),
	        activo = _useState6[0],
	        setActivo = _useState6[1];
	
	    var _useState7 = (0, _react.useState)([]),
	        _useState8 = _slicedToArray(_useState7, 2),
	        records = _useState8[0],
	        setRecords = _useState8[1];
	
	    var _useState9 = (0, _react.useState)({
	        idpedido: '',
	        numpedido: ''
	    }),
	        _useState10 = _slicedToArray(_useState9, 2),
	        values = _useState10[0],
	        setValues = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(-1),
	        _useState12 = _slicedToArray(_useState11, 2),
	        itemSelect = _useState12[0],
	        setItemSelect = _useState12[1];
	
	    var _useState13 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState14 = _slicedToArray(_useState13, 2),
	        filterFn = _useState14[0],
	        setFilterFn = _useState14[1];
	
	    var headCells = [{ label: 'N° ORDEN', textAlign: 'center' }, { label: 'CEDULA/RIF', textAlign: 'center' }, { label: 'NOMBRE', textAlign: 'center' }, { label: 'FECHA', textAlign: 'center' }, { label: 'STATUS', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.numorden.toLowerCase().includes(target.value.toLowerCase()) || (0, _moment2.default)(x.fecha).format('DD/MM/YYYY').toLowerCase().includes(target.value.toLowerCase()) || x.cliente.toLowerCase().includes(target.value.toLowerCase()) || x.cedularif.toLowerCase().includes(target.value.toLowerCase()) || x.status.toLowerCase().includes(target.value.toLowerCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var status = "";
	
	        if (props.ope !== 4) {
	            status = 'and status != 1';
	        } else {
	            status = '';
	        }
	
	        var endpoint = op.conexion + '/api/servicios/consultarordenescatalogo?status=' + status;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setActivo(true);
	        setRecords([]);
	        setValues({
	            idorden: '',
	            numorden: ''
	        });
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var seleccionarProducto = function seleccionarProducto() {
	
	        props.onHideAceptaCatalogo(values);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	            setActivo(false);
	            setValues({
	                idorden: item.idorden,
	                numorden: item.numorden
	            });
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	                txtBuscar.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Orden (VENTA/SERVICIO)'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group col-md-6 input-group-sm mb-3' },
	                        _react2.default.createElement('input', { type: 'text', ref: txtBuscar,
	                            onChange: handleSearch, className: 'form-control text-uppercase' }),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-info', style: { pointerEvents: 'none' } },
	                            _react2.default.createElement('i', { className: 'fa fa-search' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.idorden === item.idorden ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.numorden
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.cedularif
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-start' },
	                                    item.cliente
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    (0, _moment2.default)(item.fecha).format('DD/MM/YYYY')
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.status === 0 && item.numorden.substring(0, 2) === 'OS' ? _react2.default.createElement(
	                                        'p',
	                                        { className: 'fw-bold', style: { color: '#e26015' } },
	                                        'ORDEN ABIERTA'
	                                    ) : item.status === 1 && item.numorden.substring(0, 2) === 'OS' ? _react2.default.createElement(
	                                        'p',
	                                        { className: 'text-success fw-bold' },
	                                        'PROCESADA'
	                                    ) : item.status === 0 && item.numorden.substring(0, 2) === 'OV' ? _react2.default.createElement(
	                                        'p',
	                                        { className: 'fw-bold', style: { color: '#055182' } },
	                                        'VENTA (ABIERTA)'
	                                    ) : item.status === 1 && item.numorden.substring(0, 2) === 'OV' ? _react2.default.createElement(
	                                        'p',
	                                        { className: 'text-success fw-bold' },
	                                        'VENTA (PROCESADA)'
	                                    ) : _react2.default.createElement(
	                                        'p',
	                                        { className: 'text-danger fw-bold' },
	                                        'ANULADA'
	                                    )
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, disabled: activo, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: seleccionarProducto },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoOrdenes;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoTipoRetenciones = function CatalogoTipoRetenciones(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	    var txtBuscar = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        records = _useState6[0],
	        setRecords = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({
	        idbanco: '',
	        nombre: '' }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        values = _useState8[0],
	        setValues = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(-1),
	        _useState10 = _slicedToArray(_useState9, 2),
	        itemSelect = _useState10[0],
	        setItemSelect = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filterFn = _useState12[0],
	        setFilterFn = _useState12[1];
	
	    var headCells = [{ label: 'CODIGO', textAlign: 'center' }, { label: 'DESCRIPCION', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.idbanco.includes(target.value) || x.nombre.toLowerCase().includes(target.value.toLowerCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = 'tiporetencion.*, agente.nombre, agente.idagente';
	        var nomtab = 'tiporetencion, agente';
	        var condi = "agente.idagente = tiporetencion.idagente";
	        var orden = 'idtiporetencion';
	
	        var endpoint = op.conexion + '/api/consulta/selecionarregistrocondi?&campos=' + campos + '&nomtab=' + nomtab + '&condi=' + condi + '&orden=' + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setRecords([]);
	        setValues({
	            idmarca: '',
	            descripcion: ''
	        });
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var seleccionarMarca = function seleccionarMarca() {
	
	        props.onHideAceptaCatalogo(values);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	
	            setValues(item);
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	                txtBuscar.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Tipo de Retenci\xF3n'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group col-md-6 input-group-sm mb-3' },
	                        _react2.default.createElement('input', { type: 'text', ref: txtBuscar,
	                            onChange: handleSearch, className: 'form-control' }),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-info', style: { pointerEvents: 'none' } },
	                            _react2.default.createElement('i', { className: 'fa fa-search' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.idtiporetencion === item.idtiporetencion ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.idtiporetencion
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.descripcion
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: seleccionarMarca },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoTipoRetenciones;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoValorMonedasdos = function CatalogoValorMonedasdos(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      records = _useState6[0],
	      setRecords = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    idpago: "",
	    numpago: "",
	    monto: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      values = _useState8[0],
	      setValues = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      filterFn = _useState10[0],
	      setFilterFn = _useState10[1];
	
	  var headCells = [{ label: "FECHAS", textAlign: "center" }, { label: "VALOR MONEDA", textAlign: "center" }];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.valormoneda.toString().includes(target.value) || (0, _moment2.default)(x.fecha).format("DD/MM/YYYY").toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var endpoint = op.conexion + "/api/moneda/catalogovalormoneda?condicion=md.subpredeterminada = true";
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        } else {
	          setRecords([]);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setRecords([]);
	    setValues({
	      idmoneda: "",
	      idmonedadetalle: "",
	      valor: ""
	    });
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var seleccionarAnticipo = function seleccionarAnticipo() {
	    props.onHideAceptaCatalogo(values);
	  };
	
	  var seleccionarFila = function seleccionarFila(item) {
	    return function (e) {
	      e.preventDefault();
	      setValues({
	        idmoneda: item.idmoneda,
	        idmonedadetalle: item.idmonedadetalle,
	        valor: item.valormoneda
	      });
	      btnAcepta.current.focus();
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "md",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        seleccionarRegistros();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Seleccionar Valor Moneda"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-6 input-group-sm mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control"
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  style: {
	                    padding: "0",
	                    cursor: "pointer",
	                    background: values.idmonedadetalle === item.idmonedadetalle ? "lightskyblue" : "white"
	                  },
	                  onClick: seleccionarFila(item)
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  (0, _moment2.default)(item.fecha).format("DD/MM/YYYY")
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-right" },
	                  (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          style: { margin: "5px" },
	          onClick: seleccionarAnticipo
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoValorMonedasdos;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GestionarFabricantes = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoFabricantes = __webpack_require__(7027);
	
	var _catalogoFabricantes2 = _interopRequireDefault(_catalogoFabricantes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GestionarFabricantes = exports.GestionarFabricantes = function GestionarFabricantes(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var accbtnmodelo = JSON.parse(sessionStorage.getItem('accbtnmodeloc'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtIdfabricante = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)('Gestionar Fabricantes.'),
	      _useState2 = _slicedToArray(_useState, 2),
	      tituloHeader = _useState2[0],
	      setTituloHeader = _useState2[1];
	
	  var _useState3 = (0, _react.useState)('visible'),
	      _useState4 = _slicedToArray(_useState3, 2),
	      visibleBtn = _useState4[0],
	      setVisibleBtn = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      operacion = _useState6[0],
	      setOperacion = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      body = _useState8[0],
	      setBody = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      activate = _useState10[0],
	      setActivate = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(true),
	      _useState12 = _slicedToArray(_useState11, 2),
	      habilitado = _useState12[0],
	      setHabilitado = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensaje = _useState14[0],
	      setMensaje = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mensajesino = _useState16[0],
	      setMensajesino = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      catalogoModelo = _useState18[0],
	      setCatalogoModelo = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      botones = _useState20[0],
	      setBotones = _useState20[1];
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'descripcion') {
	      if (e.target.value === '') {
	        setBotones(Object.assign({}, botones, { aceptar: true }));
	      } else {
	        setBotones(Object.assign({}, botones, { aceptar: false }));
	      }
	      e.target.value = e.target.value;
	    } else {
	      e.target.value = e.target.value;
	    }
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro(id) {
	    var campos = 'idfabricante, trim(descripcion) as descripcion';
	    var nomtab = 'fabricante';
	    var nomid = 'idfabricante';
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        if (response.data !== '') {
	          txtIdfabricante.current.setAttribute("disabled", true);
	          txtDescripcion.current.value = response.data.descripcion.trim();
	          if (operacion === 2) {
	            setHabilitado(false);
	            txtDescripcion.current.focus();
	          } else {
	            btnCancela.current.focus();
	          }
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: operacion === 4 ? true : false,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	        } else {
	          txtIdfabricante.current.value = '';
	          txtIdfabricante.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var validarfabricante = function validarfabricante(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value !== '') {
	
	        seleccionarRegistro(event.target.value);
	      }
	    }
	  };
	
	  var onCatalogoFabricante = function onCatalogoFabricante(values) {
	    setCatalogoModelo(false);
	    txtIdfabricante.current.setAttribute("disabled", true);
	    txtIdfabricante.current.value = values.idfabricante;
	    txtDescripcion.current.value = values.descripcion;
	    setBotones({
	      incluir: true,
	      consultar: true,
	      modificar: false,
	      eliminar: true,
	      aceptar: operacion === 4 ? true : false,
	      cancelar: false,
	      catalogo: true,
	      salir: true
	    });
	    if (operacion === 2) {
	      setHabilitado(false);
	      setTimeout(function () {
	        return txtDescripcion.current.focus();
	      }, 200);
	      //txtDescripcion.current.focus();
	    } else {
	      setTimeout(function () {
	        return btnCancela.current.focus();
	      }, 200);
	      //btnCancela.current.focus();
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	
	    var sigue = true;
	    if (!botones.incluir || !botones.modificar) {
	
	      if (txtDescripcion.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar una descripción', icono: 'informacion' });
	        txtDescripcion.current.focus();
	        sigue = false;
	      }
	    }
	
	    if (sigue) {
	
	      var fabricante = [];
	      fabricante.push({
	        idfabricante: txtIdfabricante.current.value === '' ? 0 : txtIdfabricante.current.value,
	        descripcion: txtDescripcion.current.value.toUpperCase().trim()
	      });
	
	      setBody({
	        fabricante: fabricante
	      });
	
	      var msg = '';
	      if (operacion === 1) {
	        msg = 'Esta Seguro de Registrar estos Datos.';
	      } else if (operacion === 2) {
	        msg = 'Esta Seguro de Modificar estos Datos.';
	      } else if (operacion === 3) {
	        msg = 'Esta Seguro de Eliminar estos Datos.';
	      }
	
	      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + '/api/modelo/actualizarfabricante/' + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Creado Correctamente', icono: 'exito' });
	        } else if (operacion === 2) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Modificado Correctamente', icono: 'exito' });
	        } else if (operacion === 3) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Eliminado Correctamente', icono: 'exito' });
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = '';
	      if (error.response === undefined) {
	        mensaje = 'Error de Conexion';
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
	          mensaje = 'Ya existe un Registro con este rif';
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    if (mensajesino.texto === 'Seguro de Descartar Cambios?' && props.llamado === 2) {
	      cancelar();
	    } else {
	      procesarRegistro();
	    }
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setTituloHeader('Gestionar Fabricantes.');
	    setBody(null);
	    setHabilitado(true);
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      salir: false
	    });
	    txtIdfabricante.current.setAttribute("disabled", true);
	    txtIdfabricante.current.value = '';
	    txtDescripcion.current.value = '';
	    setVisibleBtn('visible');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	
	      e.preventDefault();
	
	      if (op === 1) {
	
	        if (accbtnmodelo && accbtnmodelo.toString().substring(0, 1) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Incluir Fabricantes.');
	          setOperacion(op);
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	          txtIdfabricante.current.setAttribute("disabled", true);
	          setTimeout(function () {
	            return txtDescripcion.current.focus();
	          }, 200);
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 2) {
	
	        if (accbtnmodelo && accbtnmodelo.toString().substring(1, 2) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Editar Fabricantes.');
	          setOperacion(op);
	          txtIdfabricante.current.removeAttribute("disabled");
	          //setHabilitado(false);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdfabricante.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 3) {
	
	        if (accbtnmodelo && accbtnmodelo.toString().substring(3, 4) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Eliminar Fabricantes.');
	          setOperacion(op);
	          txtIdfabricante.current.removeAttribute("disabled");
	          //setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdfabricante.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 4) {
	
	        if (accbtnmodelo && accbtnmodelo.toString().substring(2, 3) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Consultar Fabricantes.');
	          setOperacion(op);
	          txtIdfabricante.current.removeAttribute("disabled");
	          //setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdfabricante.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        if (props.llamado === 2) {
	
	          if (txtDescripcion.current.value === '') {
	            blanquear();
	            props.onHideCancela();
	          } else {
	
	            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Seguro de Descartar Cambios?', icono: 'confirmacion' });
	          }
	        } else {
	          blanquear();
	        }
	      } else if (op === 7) {
	        setVisibleBtn('visible');
	        cancelar();
	      }
	    };
	  };
	
	  var cerrarModal = function cerrarModal() {
	    if (props.llamado === 2) {
	      props.onHideRenderizar();
	      props.onHideCancela();
	    }
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var imprimirFabricantes = function imprimirFabricantes() {
	
	    window.open(op.reportes + '/almacen?afiliado=' + afiliado + '&reporte=ListFabricantes', "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	        setHabilitado(true);
	        if (props.llamado === 2) {
	          setOperacion(1);
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	          txtIdfabricante.current.setAttribute("disabled", true);
	          setTimeout(function () {
	            return txtDescripcion.current.focus();
	          }, 200);
	          setVisibleBtn('collapse');
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        _Modal2.default.Title,
	        { style: { color: "#fff" } },
	        tituloHeader,
	        ' '
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: onBotones(7), className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 mx-auto px-0' },
	          _react2.default.createElement(
	            'div',
	            { className: 'mb-3 col-pd-140 ml-auto' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'FECHA: ',
	              _react2.default.createElement(
	                'span',
	                { className: 'fw-bold fs-6' },
	                (0, _moment2.default)(fechasistema).format('DD-MM-YYYY'),
	                ' '
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'border-azul col-md-12 py-3 rounded mx-1', style: { fontSizeAdjust: '0.6' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'row col-md-12 rounded mx-auto' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-3 col-md-6 px-0' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'CODIGO:'
	              ),
	              _react2.default.createElement('input', { type: 'text', ref: txtIdfabricante, disabled: true, onKeyUp: validarfabricante, onBlur: validarfabricante, className: 'form-control fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	              _react2.default.createElement(
	                'button',
	                { disabled: botones.catalogo, type: 'button', onClick: function onClick() {
	                    return setCatalogoModelo(true);
	                  }, className: 'btn btn-success' },
	                _react2.default.createElement('i', { className: 'fas fa-search' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-1 ml-auto px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn btn-primary btn-sm rounded ', onClick: imprimirFabricantes },
	                  _react2.default.createElement('i', { className: 'fas fa-print' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm col-md-12 px-0' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'DESCRIPCION:'
	              ),
	              _react2.default.createElement('input', { type: 'text', ref: txtDescripcion, name: 'descripcion', autoComplete: 'off', disabled: habilitado, className: 'form-control text-uppercase fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onChange: onChange })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 mx-auto' },
	        visibleBtn === 'visible' ? _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 mx-auto row justify-content-between px-0' },
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.incluir, onClick: onBotones(1), className: 'btn btn-sm mx-1 my-1 col btn-primary rounded-pill', title: 'Incluir Modelo' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-plus' },
	              ' Incluir '
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.consultar, onClick: onBotones(4), className: 'btn btn-sm mx-1 my-1 col btn-info rounded-pill', title: 'Consultar Modelo' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-eye' },
	              'Consultar'
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.modificar, onClick: onBotones(2), className: 'btn btn-sm mx-1 my-1 col btn-warning rounded-pill', title: 'Modificar Modelo' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fa fa-edit' },
	              'Modificar'
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.eliminar, onClick: onBotones(3), className: 'btn btn-sm mx-1 my-1 col btn-danger rounded-pill', title: 'Eliminar Modelo' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fa fa-trash' },
	              'Eliminar'
	            ),
	            ' '
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 row mx-auto justify-content-end px-0' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: botones.aceptar, onClick: onBotones(5), className: 'btn col-md-3 mx-1 my-1 btn-sm rounded-pill btn-success ' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check-circle' },
	              '  Aceptar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, disabled: botones.cancelar, onClick: onBotones(6), className: 'btn col-md-3 mx-1 my-1 btn-danger btn-sm rounded-pill ' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoFabricantes2.default, {
	      show: catalogoModelo,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoModelo(false);
	      },
	      onHideAceptaCatalogo: onCatalogoFabricante
	    })
	  );
	};

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GestionarTipoProducto = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoTipoProducto = __webpack_require__(7039);
	
	var _catalogoTipoProducto2 = _interopRequireDefault(_catalogoTipoProducto);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GestionarTipoProducto = exports.GestionarTipoProducto = function GestionarTipoProducto(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var accbtntproducto = JSON.parse(sessionStorage.getItem('accbtntproductoc'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtIdTipoProducto = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	  var txtInformatica1 = (0, _react.useRef)();
	  var txtInformatica2 = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)('Gestionar Tipo Producto.'),
	      _useState2 = _slicedToArray(_useState, 2),
	      tituloHeader = _useState2[0],
	      setTituloHeader = _useState2[1];
	
	  var _useState3 = (0, _react.useState)('visible'),
	      _useState4 = _slicedToArray(_useState3, 2),
	      visibleBtn = _useState4[0],
	      setVisibleBtn = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      operacion = _useState6[0],
	      setOperacion = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      body = _useState8[0],
	      setBody = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      activate = _useState10[0],
	      setActivate = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(true),
	      _useState12 = _slicedToArray(_useState11, 2),
	      habilitado = _useState12[0],
	      setHabilitado = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensaje = _useState14[0],
	      setMensaje = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mensajesino = _useState16[0],
	      setMensajesino = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      catalogoTipoProducto = _useState18[0],
	      setCatalogoTipoProducto = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      botones = _useState20[0],
	      setBotones = _useState20[1];
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'descripcion') {
	      if (e.target.value === '') {
	        setBotones(Object.assign({}, botones, { aceptar: true }));
	      } else {
	        setBotones(Object.assign({}, botones, { aceptar: false }));
	      }
	
	      e.target.value = e.target.value;
	    } else {
	      e.target.value = e.target.value;
	    }
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = 'idtipoproducto, trim(descripcion) as descripcion, informatica';
	    var nomtab = 'tipoproducto';
	    var nomid = 'idtipoproducto';
	    var id = txtIdTipoProducto.current.value;
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        txtDescripcion.current.value = '';
	
	        if (response.data !== '') {
	          txtIdTipoProducto.current.setAttribute("disabled", true);
	          txtDescripcion.current.value = response.data.descripcion.trim();
	          if (response.data.informatica) {
	            txtInformatica1.current.checked = true;
	          } else {
	            txtInformatica2.current.checked = true;
	          }
	          if (operacion === 2) {
	            setHabilitado(false);
	            txtDescripcion.current.focus();
	          } else {
	            btnCancela.current.focus();
	          }
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: operacion === 4 ? true : false,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una marca con este codigo', icono: 'informacion' });
	          txtIdTipoProducto.current.value = '';
	          txtIdTipoProducto.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var validarTipoProducto = function validarTipoProducto(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value !== '') {
	
	        seleccionarRegistro();
	      }
	    }
	  };
	
	  var onCatalogoTipoProducto = function onCatalogoTipoProducto(values) {
	    setCatalogoTipoProducto(false);
	    txtIdTipoProducto.current.value = values.idtipoproducto;
	    txtIdTipoProducto.current.setAttribute("disabled", true);
	    txtDescripcion.current.value = values.descripcion;
	
	    setBotones({
	      incluir: true,
	      consultar: true,
	      modificar: false,
	      eliminar: true,
	      aceptar: operacion === 4 ? true : false,
	      cancelar: false,
	      catalogo: true,
	      salir: true
	    });
	    if (operacion === 2) {
	      setHabilitado(false);
	      setTimeout(function () {
	        return txtDescripcion.current.focus();
	      }, 200);
	      //txtDescripcion.current.focus();
	    } else {
	      setTimeout(function () {
	        return btnCancela.current.focus();
	      }, 200);
	      //btnCancela.current.focus();
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	
	    var sigue = true;
	    if (!botones.incluir || !botones.modificar) {
	
	      if (txtDescripcion.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar una descripción', icono: 'informacion' });
	        txtDescripcion.current.focus();
	        sigue = false;
	      }
	    }
	
	    if (sigue) {
	
	      var tipoproducto = [];
	      tipoproducto.push({
	        idtipoproducto: txtIdTipoProducto.current.value === '' ? 0 : txtIdTipoProducto.current.value,
	        descripcion: txtDescripcion.current.value.toUpperCase().trim(),
	        informatica: false
	      });
	
	      setBody({
	        tipoproducto: tipoproducto
	      });
	
	      var msg = '';
	      if (operacion === 1) {
	        msg = 'Esta Seguro de Registrar estos Datos.';
	      } else if (operacion === 2) {
	        msg = 'Esta Seguro de Modificar estos Datos.';
	      } else if (operacion === 3) {
	        msg = 'Esta Seguro de Eliminar estos Datos.';
	      }
	
	      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + '/api/tipoproducto/actualizar/' + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
	        } else if (operacion === 2) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
	        } else if (operacion === 3) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = '';
	      if (error.response === undefined) {
	        mensaje = 'Error de Conexion';
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
	          mensaje = 'Ya existe un Registro con este rif';
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    if (mensajesino.texto === 'Seguro de Descartar Cambios?' && props.llamado === 2) {
	      cancelar();
	    } else {
	      procesarRegistro();
	    }
	  };
	
	  var blanquear = function blanquear() {
	    setTituloHeader('Gestionar Tipo Producto.');
	
	    setActivate(false);
	    setBody(null);
	    setHabilitado(true);
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      salir: false
	    });
	    txtIdTipoProducto.current.setAttribute("disabled", true);
	    txtIdTipoProducto.current.value = '';
	    txtDescripcion.current.value = '';
	    /* txtInformatica1.current.checked = false;
	    txtInformatica2.current.checked = false; */
	    setVisibleBtn('visible');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	
	      e.preventDefault();
	
	      if (op === 1) {
	
	        if (accbtntproducto && accbtntproducto.toString().substring(0, 1) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Incluir Tipo Producto.');
	          setOperacion(op);
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	          txtIdTipoProducto.current.setAttribute("disabled", true);
	          setTimeout(function () {
	            return txtDescripcion.current.focus();
	          }, 200);
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 2) {
	
	        if (accbtntproducto && accbtntproducto.toString().substring(1, 2) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Editar Tipo Producto.');
	          setOperacion(op);
	          txtIdTipoProducto.current.removeAttribute("disabled");
	          //setHabilitado(false);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdTipoProducto.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 3) {
	
	        if (accbtntproducto && accbtntproducto.toString().substring(3, 4) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Eliminar Tipo Producto.');
	          setOperacion(op);
	          txtIdTipoProducto.current.removeAttribute("disabled");
	          //setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdTipoProducto.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 4) {
	
	        if (accbtntproducto && accbtntproducto.toString().substring(2, 3) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Consultar Tipo Producto.');
	          setOperacion(op);
	          txtIdTipoProducto.current.removeAttribute("disabled");
	          //setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdTipoProducto.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        if (props.llamado === 2) {
	
	          if (txtDescripcion.current.value === '') {
	            blanquear();
	            props.onHideCancela();
	          } else {
	
	            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Seguro de Descartar Cambios?', icono: 'confirmacion' });
	          }
	        } else {
	          blanquear();
	        }
	      } else if (op === 7) {
	        setVisibleBtn('visible');
	        cancelar();
	      }
	    };
	  };
	
	  var cerrarModal = function cerrarModal() {
	    if (props.llamado === 2) {
	      props.onHideRenderizar();
	      props.onHideCancela();
	    }
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var imprimirTipopro = function imprimirTipopro() {
	
	    if (accbtntproducto && accbtntproducto.toString().substring(4, 5) === '1') {
	      window.open(op.reportes + '/almacen?afiliado=' + afiliado + '&reporte=ListTipoProductos', "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	    } else {
	      setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	        setHabilitado(true);
	        if (props.llamado === 2) {
	          setTituloHeader('Incluir Tipo Producto.');
	          setOperacion(1);
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	          txtIdTipoProducto.current.setAttribute("disabled", true);
	          setTimeout(function () {
	            return txtDescripcion.current.focus();
	          }, 200);
	          setVisibleBtn('collapse');
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        _Modal2.default.Title,
	        { style: { color: "#fff" } },
	        tituloHeader,
	        ' '
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: onBotones(7), className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 mx-auto px-0' },
	          _react2.default.createElement(
	            'div',
	            { className: 'mb-3 col-pd-140 ml-auto' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'FECHA: ',
	              _react2.default.createElement(
	                'span',
	                { className: 'fw-bold fs-6' },
	                (0, _moment2.default)(fechasistema).format('DD-MM-YYYY'),
	                ' '
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'border-azul col-md-12 py-3 rounded mx-1', style: { fontSizeAdjust: '0.6' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'row col-md-12 rounded mx-auto' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-3 col-md-6' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'CODIGO:'
	              ),
	              _react2.default.createElement('input', { type: 'text', ref: txtIdTipoProducto, disabled: true, onKeyUp: validarTipoProducto, onBlur: validarTipoProducto, className: 'form-control fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	              _react2.default.createElement(
	                'button',
	                { disabled: botones.catalogo, type: 'button', onClick: function onClick() {
	                    return setCatalogoTipoProducto(true);
	                  }, className: 'btn btn-success' },
	                _react2.default.createElement('i', { className: 'fas fa-search' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-1 ml-auto px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn btn-primary btn-sm rounded', onClick: imprimirTipopro },
	                  _react2.default.createElement('i', { className: 'fas fa-print' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm col-md-12 ' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'DESCRIPCION:'
	              ),
	              _react2.default.createElement('input', { type: 'text', ref: txtDescripcion, name: 'descripcion', autoComplete: 'off', disabled: habilitado, className: 'form-control text-uppercase fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onChange: onChange })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 mx-auto' },
	        visibleBtn === 'visible' ? _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 mx-auto row justify-content-between', style: { visibility: props.llamado === 2 ? 'collapse' : props.llamado !== 2 ? visibleBtn : 'visible' } },
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.incluir, onClick: onBotones(1), className: 'btn btn-sm mx-1 my-1 col btn-primary rounded-pill', title: 'Incluir Tipo Producto' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-plus' },
	              ' Incluir '
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.consultar, onClick: onBotones(4), className: 'btn btn-sm mx-1 my-1 col btn-info rounded-pill', title: 'Consultar Tipo Producto' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-eye' },
	              'Consultar'
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.modificar, onClick: onBotones(2), className: 'btn btn-sm mx-1 my-1 col btn-warning rounded-pill', title: 'Modificar Tipo Producto' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fa fa-edit' },
	              'Modificar'
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.eliminar, onClick: onBotones(3), className: 'btn btn-sm mx-1 my-1 col btn-danger rounded-pill', title: 'Eliminar Tipo Producto' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fa fa-trash' },
	              'Eliminar'
	            ),
	            ' '
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 row mx-auto justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: botones.aceptar, onClick: onBotones(5), className: 'btn col-md-3 mx-1 my-1 btn-sm rounded-pill btn-success ' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check-circle' },
	              '  Aceptar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, disabled: botones.cancelar, onClick: onBotones(6), className: 'btn col-md-3 mx-1 my-1 btn-danger btn-sm rounded-pill ' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoTipoProducto2.default, {
	      show: catalogoTipoProducto,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoTipoProducto(false);
	      },
	      onHideAceptaCatalogo: onCatalogoTipoProducto
	    })
	  );
	};

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.celdaTexto = exports.detalleTicket = exports.filaTicket = exports.camposCabeceraNota = exports.parsearDetalle = exports.formatearCantidad = exports.formatearMonto = exports.COLUMNAS_DETALLE = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Helpers para mostrar el detalle (renglones) de una nota de entrega en forma
	 * de "ticket": una linea por producto con su codigo, nombre, cantidad, precio
	 * unitario, IVA e importe, mas los totales.
	 *
	 * Se reutiliza tanto en el modal de auditoria (TablaDetalleNota) como en el
	 * reporte PDF (reporteNotaEntregaRespaldoPDF), por eso vive en su propio
	 * modulo y no contiene JSX.
	 */
	
	/* Etiquetas amigables de los campos de la cabecera de la nota */
	var ETIQUETAS_NOTA = {
	  numnotaentrega: "N° Nota",
	  fecha: "Fecha",
	  hora: "Hora",
	  cedularif: "Cédula / RIF",
	  idcliente: "Cliente",
	  idvendedor: "Vendedor",
	  idalmacen: "Almacén",
	  idmoneda: "Moneda",
	  idpedido: "Pedido",
	  idcaja: "Caja",
	  idoperacioninventario: "Operación inventario",
	  totalmonto: "Total",
	  totaliva: "IVA",
	  totaldescuento: "Descuento",
	  status: "Status"
	};
	
	/* Orden en que se muestran los campos de la cabecera (solo los que existan) */
	var ORDEN_NOTA = ["numnotaentrega", "fecha", "hora", "cedularif", "idcliente", "idvendedor", "idalmacen", "idmoneda", "idpedido", "idcaja", "idoperacioninventario", "totalmonto", "totaliva", "totaldescuento", "status"];
	
	/* Campos de cabecera que se formatean como monto */
	var CAMPOS_MONTO = ["totalmonto", "totaliva", "totaldescuento"];
	
	/* Columnas del ticket (una linea por producto) */
	var COLUMNAS_DETALLE = exports.COLUMNAS_DETALLE = [{ key: "codigo", label: "Código", align: "left", flex: 1.3 }, { key: "producto", label: "Producto", align: "left", flex: 3.4 }, { key: "cantidad", label: "Cant.", align: "right", flex: 0.9, tipo: "cantidad" }, { key: "punitario", label: "P. Unit.", align: "right", flex: 1.3, tipo: "monto" }, { key: "iva", label: "IVA %", align: "right", flex: 0.8, tipo: "cantidad" }, { key: "importe", label: "Importe", align: "right", flex: 1.4, tipo: "monto" }];
	
	var numero = function numero(valor) {
	  if (valor === null || valor === undefined || valor === "") {
	    return null;
	  }
	  var n = typeof valor === "number" ? valor : parseFloat(String(valor).replace(",", "."));
	  return isNaN(n) ? null : n;
	};
	
	/* Da formato de monto (2 decimales) a un valor numerico */
	var formatearMonto = exports.formatearMonto = function formatearMonto(valor) {
	  var n = numero(valor);
	  if (n === null) {
	    return valor === null || valor === undefined || valor === "" ? "-" : String(valor);
	  }
	  return n.toLocaleString("es-VE", {
	    minimumFractionDigits: 2,
	    maximumFractionDigits: 2
	  });
	};
	
	/* Da formato de cantidad (entera sin decimales, con decimales si aplica) */
	var formatearCantidad = exports.formatearCantidad = function formatearCantidad(valor) {
	  var n = numero(valor);
	  if (n === null) {
	    return valor === null || valor === undefined || valor === "" ? "-" : String(valor);
	  }
	  if (Number.isInteger(n)) {
	    return String(n);
	  }
	  return n.toLocaleString("es-VE", {
	    minimumFractionDigits: 2,
	    maximumFractionDigits: 2
	  });
	};
	
	var formatearFecha = function formatearFecha(valor) {
	  if (!valor) {
	    return valor;
	  }
	  var m = (0, _moment2.default)(valor);
	  return m.isValid() ? m.format("DD-MM-YYYY") : String(valor);
	};
	
	/* Convierte el detalle (arreglo o texto JSON) en un arreglo de objetos */
	var parsearDetalle = exports.parsearDetalle = function parsearDetalle(valor) {
	  if (Array.isArray(valor)) {
	    return valor;
	  }
	  if (typeof valor === "string" && valor.trim() !== "") {
	    try {
	      var parseado = JSON.parse(valor);
	      return Array.isArray(parseado) ? parseado : [];
	    } catch (error) {
	      return [];
	    }
	  }
	  return [];
	};
	
	/* Toma el primer valor no vacio de la lista de claves */
	var tomar = function tomar(objeto, claves) {
	  for (var i = 0; i < claves.length; i++) {
	    var valor = objeto[claves[i]];
	    if (valor !== undefined && valor !== null && valor !== "") {
	      return valor;
	    }
	  }
	  return "";
	};
	
	/* Campos de cabecera de la nota listos para mostrar [{ label, valor }] */
	var camposCabeceraNota = exports.camposCabeceraNota = function camposCabeceraNota(nota) {
	  var objeto = nota && (typeof nota === "undefined" ? "undefined" : _typeof(nota)) === "object" ? nota : {};
	  var usadas = {};
	  var campos = [];
	
	  ORDEN_NOTA.forEach(function (clave) {
	    if (objeto[clave] === undefined || objeto[clave] === null) {
	      return;
	    }
	    usadas[clave] = true;
	    var valor = objeto[clave];
	    if (clave === "fecha") {
	      valor = formatearFecha(valor);
	    } else if (CAMPOS_MONTO.indexOf(clave) >= 0) {
	      valor = formatearMonto(valor);
	    }
	    campos.push({ label: ETIQUETAS_NOTA[clave], valor: valor });
	  });
	
	  /* Campos que no estén en la lista se muestran al final (nombre tecnico) */
	  Object.keys(objeto).forEach(function (clave) {
	    if (usadas[clave]) {
	      return;
	    }
	    var valor = objeto[clave];
	    if (valor === null || valor === undefined) {
	      return;
	    }
	    campos.push({ label: clave, valor: valor });
	  });
	
	  return campos;
	};
	
	/* Convierte un renglon del detalle a la fila del ticket */
	var filaTicket = exports.filaTicket = function filaTicket(item) {
	  var row = item && (typeof item === "undefined" ? "undefined" : _typeof(item)) === "object" ? item : {};
	  var cantidad = numero(row.cantidad) || 0;
	  var punitario = numero(row.punitario) || 0;
	
	  return {
	    idproducto: row.idproducto,
	    codigo: tomar(row, ["codigo", "codigoproducto", "codigoprod"]),
	    producto: tomar(row, ["producto", "nombre", "nombrecorto", "descripcion"]) || "Producto " + (row.idproducto !== undefined ? row.idproducto : ""),
	    unidad: tomar(row, ["unidad", "descripcionunidad", "descripcionuni"]),
	    cantidad: cantidad,
	    punitario: punitario,
	    iva: tomar(row, ["iva"]),
	    importe: cantidad * punitario
	  };
	};
	
	/*
	 * Arma las filas y los totales del ticket a partir del detalle (arreglo o
	 * texto JSON). Devuelve { filas, totales }.
	 */
	var detalleTicket = exports.detalleTicket = function detalleTicket(valor) {
	  var filas = parsearDetalle(valor).map(filaTicket);
	
	  var totales = filas.reduce(function (acc, fila) {
	    acc.cantidad += fila.cantidad;
	    acc.importe += fila.importe;
	    return acc;
	  }, { cantidad: 0, importe: 0 });
	
	  return { filas: filas, totales: totales };
	};
	
	/* Texto de una celda segun el tipo de columna */
	var celdaTexto = exports.celdaTexto = function celdaTexto(columna, fila) {
	  var valor = fila[columna.key];
	  if (columna.tipo === "monto") {
	    return formatearMonto(valor);
	  }
	  if (columna.tipo === "cantidad") {
	    return formatearCantidad(valor);
	  }
	  return valor === null || valor === undefined || valor === "" ? "-" : String(valor);
	};

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CambiarClave = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _varios = __webpack_require__(14);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CambiarClave = exports.CambiarClave = function CambiarClave(props) {
	
	    var btnCancela = (0, _react.useRef)();
	    var btnAcepta = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        mostrar = _useState2[0],
	        setMostrar = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(true),
	        _useState4 = _slicedToArray(_useState3, 2),
	        deshabilitado = _useState4[0],
	        setDeshabilitado = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(false),
	        _useState6 = _slicedToArray(_useState5, 2),
	        deshabilitadoL = _useState6[0],
	        setDeshabilitadoL = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(),
	        _useState8 = _slicedToArray(_useState7, 2),
	        titulo = _useState8[0],
	        setTitulo = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(),
	        _useState10 = _slicedToArray(_useState9, 2),
	        idUsuario = _useState10[0],
	        setIdUsuario = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(),
	        _useState12 = _slicedToArray(_useState11, 2),
	        msg = _useState12[0],
	        setMsg = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(false),
	        _useState14 = _slicedToArray(_useState13, 2),
	        mostrar1 = _useState14[0],
	        setMostrar1 = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(false),
	        _useState16 = _slicedToArray(_useState15, 2),
	        mostrar2 = _useState16[0],
	        setMostrar2 = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(false),
	        _useState18 = _slicedToArray(_useState17, 2),
	        mostrar3 = _useState18[0],
	        setMostrar3 = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(false),
	        _useState20 = _slicedToArray(_useState19, 2),
	        mostrar4 = _useState20[0],
	        setMostrar4 = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(),
	        _useState22 = _slicedToArray(_useState21, 2),
	        titulo2 = _useState22[0],
	        setTitulo2 = _useState22[1];
	
	    var _useState23 = (0, _react.useState)(),
	        _useState24 = _slicedToArray(_useState23, 2),
	        msg2 = _useState24[0],
	        setMsg2 = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(false),
	        _useState26 = _slicedToArray(_useState25, 2),
	        activate = _useState26[0],
	        setActivate = _useState26[1];
	
	    var _useState27 = (0, _react.useState)(0),
	        _useState28 = _slicedToArray(_useState27, 2),
	        contar = _useState28[0],
	        setContar = _useState28[1];
	
	    var _useState29 = (0, _react.useState)(0),
	        _useState30 = _slicedToArray(_useState29, 2),
	        contar3 = _useState30[0],
	        setContar3 = _useState30[1];
	
	    var _useState31 = (0, _react.useState)(0),
	        _useState32 = _slicedToArray(_useState31, 2),
	        contar4 = _useState32[0],
	        setContar4 = _useState32[1];
	
	    var _useState33 = (0, _react.useState)([]),
	        _useState34 = _slicedToArray(_useState33, 2),
	        datosEfis = _useState34[0],
	        setDatosEfis = _useState34[1];
	
	    var _useState35 = (0, _react.useState)(false),
	        _useState36 = _slicedToArray(_useState35, 2),
	        mostrarClave = _useState36[0],
	        setMostrarClave = _useState36[1];
	
	    var _useState37 = (0, _react.useState)(false),
	        _useState38 = _slicedToArray(_useState37, 2),
	        mostrarClave1 = _useState38[0],
	        setMostrarClave1 = _useState38[1];
	
	    var _useState39 = (0, _react.useState)(),
	        _useState40 = _slicedToArray(_useState39, 2),
	        titulo1 = _useState40[0],
	        setTitulo1 = _useState40[1];
	
	    var _useState41 = (0, _react.useState)(),
	        _useState42 = _slicedToArray(_useState41, 2),
	        msg1 = _useState42[0],
	        setMsg1 = _useState42[1];
	
	    var _useState43 = (0, _react.useState)(),
	        _useState44 = _slicedToArray(_useState43, 2),
	        tecla = _useState44[0],
	        setTecla = _useState44[1];
	
	    var _useState45 = (0, _react.useState)(0),
	        _useState46 = _slicedToArray(_useState45, 2),
	        desde = _useState46[0],
	        setDesde = _useState46[1];
	
	    var _useState47 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState48 = _slicedToArray(_useState47, 2),
	        mensaje = _useState48[0],
	        setMensaje = _useState48[1];
	
	    var _useState49 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState50 = _slicedToArray(_useState49, 2),
	        mensajesino = _useState50[0],
	        setMensajesino = _useState50[1];
	
	    var txtLogin = (0, _react.useRef)();
	    var txtPassword = (0, _react.useRef)();
	    var txtConfirmPassword = (0, _react.useRef)();
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	
	    var procesarRegistro = function procesarRegistro() {
	
	        var endpoint = op.conexion + '/api/athos/usuario/cambiarclave';
	
	        var body = {
	            usuario: txtLogin.current.value,
	            clave: txtPassword.current.value
	
	        };
	
	        _axios2.default.post(endpoint, body, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status == 200) {
	                setActivate(false);
	                setMensaje({ mostrar: true, titulo: 'Cambiar Contraseña', texto: 'La Contraseña fue cambiada.', icono: 'exito' });
	            }
	        }).catch(function (error) {
	
	            setActivate(false);
	            setMensaje({ mostrar: true, titulo: 'Cambiar Contraseña', texto: error.response.data.message, icono: 'error' });
	        });
	    };
	
	    var SelectUsuario = function SelectUsuario(login) {
	
	        var endpoint = op.conexion + '/api/comun/selectusuariologin?login=' + login;
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status == 200) {
	                setActivate(false);
	                if (response.data.idusuario > 0) {
	                    setDeshabilitado(false);
	                    setDeshabilitadoL(true);
	                    txtLogin.current.value = response.data.login;
	                    setIdUsuario(response.data.idusuario);
	                    if (tecla === 13) {
	                        setTimeout(function () {
	                            txtPassword.current.focus();
	                        }, 100);
	                    }
	                } else {
	                    setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'error al cargar el usuario', icono: 'informacion' });
	                    setActivate(false);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        });
	    };
	
	    (0, _react.useEffect)(function () {
	        var obj = JSON.parse(sessionStorage.getItem('post'));
	    }, []);
	
	    var blanquear = function blanquear() {
	
	        setMostrar(false);
	        setTitulo('');
	        setMsg('');
	        setMostrar1(false);
	        setTitulo2('');
	        setMsg2('');
	        setActivate(false);
	        setContar(0);
	        setIdUsuario(0);
	    };
	
	    var cancelar = function cancelar() {
	        blanquear();
	        props.onHide();
	    };
	
	    var validarCapcha = function validarCapcha() {
	        var valido = (0, _varios.ValidCaptcha)();
	        if (valido) {
	
	            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: "Esta seguro de registrar el ejercicio fiscal con estos datos?", icono: 'confirmacion' });
	            setMostrar4(false);
	        }
	    };
	
	    var handleCancelaCapcha = function handleCancelaCapcha() {
	        setMostrar4(false);
	    };
	
	    var handleCloseSi = function handleCloseSi() {
	        procesarRegistro();
	        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    };
	
	    var seleccionarUsuario = function seleccionarUsuario() {
	        setContar(0);
	        setActivate(true);
	        SelectUsuario(txtLogin.current.value);
	    };
	
	    var onChangeValidar = function onChangeValidar(e) {
	        e.preventDefault();
	        var sigue = true;
	        if (txtLogin.current.value.trim() === '') {
	            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'El Usuario no debe estar vacio', icono: 'informacion' });
	            sigue = false;
	            txtLogin.current.focus();
	        } else if (txtPassword.current.value.trim() === '') {
	            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'La Contraseña no debe estar vacia', icono: 'informacion' });
	            sigue = false;
	            txtPassword.current.focus();
	        } else if (txtConfirmPassword.current.value.trim() === '') {
	            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'La Confirmación de la Contraseña no debe estar vacia', icono: 'informacion' });
	            sigue = false;
	            txtConfirmPassword.current.focus();
	        } else if (txtPassword.current.value.trim() !== txtConfirmPassword.current.value.trim()) {
	            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Las Contraseñas no coinciden', icono: 'informacion' });
	            sigue = false;
	            txtConfirmPassword.current.focus();
	        }
	        if (sigue) {
	            setActivate(true);
	            setContar(0);
	            var _msg = '';
	            if (props.operacion === 1) {
	                _msg = 'Esta Seguro de Registrar estos Datos.';
	            } else if (props.operacion === 2) {
	                _msg = 'Esta Seguro de Modificar estos Datos.';
	            } else if (props.operacion === 3) {
	                _msg = 'Esta Seguro de Eliminar estos Datos.';
	            }
	
	            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Esta Seguro de Cambiar la contrasena.', icono: 'confirmacion' });
	        }
	    };
	
	    var handleInputChange = function handleInputChange(event) {
	        setTecla(event.which);
	        if (event.which === 13) {
	            var valido;
	            if (event.target.id === 'inputLogin') {
	                seleccionarUsuario();
	            } else if (event.target.id === 'inputPassword') {
	                if (txtConfirmPassword.current.value !== '' && txtPassword.current.value !== txtConfirmPassword.current.value) {
	                    setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Las Contraseñas no coinciden', icono: 'informacion' });
	                    txtPassword.current.focus();
	                } else {
	                    txtConfirmPassword.current.focus();
	                }
	            } else if (event.target.id === 'inputConfirmPassword') {
	                if (txtConfirmPassword.current.value !== '' && txtPassword.current.value !== txtConfirmPassword.current.value) {
	                    setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Las Contraseñas no coinciden', icono: 'informacion' });
	                    txtConfirmPassword.current.focus();
	                } else {
	                    btnAcepta.current.focus();
	                }
	            }
	        } else if (typeof event.which === 'undefined') {
	            if (event.target.id === 'inputPassword') {
	                if (txtConfirmPassword.current.value !== '' && txtPassword.current.value !== txtConfirmPassword.current.value) {
	                    setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Las Contraseñas no coinciden', icono: 'informacion' });
	                }
	            } else if (event.target.id === 'inputConfirmPassword') {
	                if (txtConfirmPassword.current.value !== '' && txtPassword.current.value !== txtConfirmPassword.current.value) {
	                    setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Las Contraseñas no coinciden', icono: 'informacion' });
	                }
	            }
	        } else if (event.which === 46) {
	            return false;
	        } else if (event.which >= 48 && event.which <= 57) {
	            return true;
	        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	            return true;
	        } else return false;
	    };
	
	    var cerrarModal = function cerrarModal() {
	        props.onHide();
	        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	    };
	
	    var mostrarPassword = function mostrarPassword() {
	        return setMostrarClave(!mostrarClave);
	    };
	    var mostrarPassword1 = function mostrarPassword1() {
	        return setMostrarClave1(!mostrarClave1);
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'sm',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                /*   txtLogin.current.value = props.usuario; */
	                setDeshabilitado(false);
	                setDeshabilitadoL(false);
	                setDesde(0);
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Cambio de Contrase\xF1a.'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.MensajeCapcha, {
	                show: mostrar4,
	                onHideAcepta: validarCapcha, onHideCancela: handleCancelaCapcha }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: { height: "auto", overflow: "auto" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'border-azul rounded' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 py-1' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { htmlFor: 'validationTooltipUsername' },
	                                    'Usuario: '
	                                ),
	                                _react2.default.createElement('input', { type: 'text', autocomplete: 'off', disabled: true, ref: txtLogin, className: 'form-control form-control-sm', defaultValue: props.usuario ? props.usuario !== '' ? props.usuario : '' : '', id: 'inputLogin', onKeyUp: handleInputChange })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 py-1' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { htmlFor: 'validationTooltip02' },
	                                    'Contrase\xF1a: '
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'input-group input-group-sm' },
	                                    _react2.default.createElement('input', { type: mostrarClave ? 'text' : 'password', disabled: deshabilitado, ref: txtPassword, className: 'form-control form-control-sm', id: 'inputPassword', onKeyUp: handleInputChange }),
	                                    _react2.default.createElement(
	                                        'button',
	                                        { style: { textAlign: "center", color: "white" }, disabled: deshabilitado, onClick: mostrarPassword, className: 'btn btn-sm btn-info' },
	                                        _react2.default.createElement('i', { className: 'fa fa-eye-slash' }),
	                                        ' '
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 py-1' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { htmlFor: 'validationTooltip03' },
	                                    'Confirmar Contrase\xF1a: '
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'input-group input-group-sm' },
	                                    _react2.default.createElement('input', { type: mostrarClave1 ? 'text' : 'password', disabled: deshabilitado, ref: txtConfirmPassword, className: 'form-control form-control-sm', id: 'inputConfirmPassword', onKeyUp: handleInputChange }),
	                                    _react2.default.createElement(
	                                        'button',
	                                        { style: { textAlign: "center", color: "white" }, disabled: deshabilitado, onClick: mostrarPassword1, className: 'btn btn-sm btn-info' },
	                                        _react2.default.createElement('i', { className: 'fa fa-eye-slash' }),
	                                        ' '
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement('div', { className: 'col-md-12 py-1' })
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                    'button',
	                    { ref: btnAcepta, onClick: onChangeValidar, className: 'btn btn-success col-md-6 btn-sm rounded-pill' },
	                    _react2.default.createElement(
	                        'i',
	                        { className: 'fas fa-check-circle' },
	                        '  Aceptar'
	                    )
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger col-md-6 btn-sm rounded-pill' },
	                    _react2.default.createElement(
	                        'i',
	                        { className: 'fas fa-window-close' },
	                        ' Cancelar'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	            onHide: function onHide() {
	                mensaje.titulo === 'Cambiar Contraseña' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	            } }),
	        _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	            onHideNo: function onHideNo() {
	                return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	            }, onHideSi: handleCloseSi })
	    );
	};
	
	//export default CambiarClave;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CartasContabilidad(props) {
	
	  return _react2.default.createElement(
	    "div",
	    { className: "row d-flex justify-content-between" },
	    _react2.default.createElement(
	      "div",
	      { className: "col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mb-3" },
	      _react2.default.createElement(
	        "div",
	        { className: "card bg-card-info mx-auto", style: { height: '90%', width: '80%' } },
	        _react2.default.createElement(
	          "div",
	          { className: "card-header", style: { height: '80%' } },
	          "Almacen"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "card-body bg-light mx-1 mb-1" },
	          _react2.default.createElement("div", { className: "d-flex justify-content-between px-md-1" })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mb-3" },
	      _react2.default.createElement(
	        "div",
	        { className: "card bg-card-info mx-auto", style: { height: '90%', width: '80%' } },
	        _react2.default.createElement(
	          "div",
	          { className: "card-header", style: { height: '80%' } },
	          "Almacen"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "card-body bg-light mx-1 mb-1" },
	          _react2.default.createElement("div", { className: "d-flex justify-content-between px-md-1" })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mb-3" },
	      _react2.default.createElement(
	        "div",
	        { className: "card bg-card-info mx-auto", style: { height: '90%', width: '80%' } },
	        _react2.default.createElement(
	          "div",
	          { className: "card-header", style: { height: '80%' } },
	          "Almacen"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "card-body bg-light mx-1 mb-1" },
	          _react2.default.createElement("div", { className: "d-flex justify-content-between px-md-1" })
	        )
	      )
	    )
	  );
	}
	
	exports.default = CartasContabilidad;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dona = Dona;
	exports.Torta = Torta;
	exports.TortaMoneda = TortaMoneda;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Dona(props) {
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactChartjs.Doughnut, { data: props.data }),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-xl-4 col-sm-4 col-12 mb-4' },
	      _react2.default.createElement(
	        'div',
	        { className: 'card' },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-body bg-card-info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'd-flex justify-content-between px-md-1' },
	            _react2.default.createElement(
	              'div',
	              { className: 'align-self-center' },
	              _react2.default.createElement('i', { className: 'fas fa-users  fa-3x' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'text-end' },
	              _react2.default.createElement(
	                'p',
	                { className: 'mb-0 fw-bold' },
	                'Total Expendedores'
	              ),
	              _react2.default.createElement(
	                'h2',
	                null,
	                props.total
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	function Torta(props) {
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'row col-md-12', style: { margin: 0 } },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-md-12 mb-4' },
	      _react2.default.createElement(_reactChartjs.Pie, { legend: props.legend, height: props.height, options: props.options, data: props.data })
	    ),
	    _react2.default.createElement(
	      'table',
	      { className: 'table tablet-responsive table-striped' },
	      _react2.default.createElement(
	        'tbody',
	        null,
	        props.datos && props.datos.map(function (item, index) {
	          return _react2.default.createElement(
	            'tr',
	            { key: index },
	            _react2.default.createElement('td', { style: { backgroundColor: item.color, border: '#000000 1px solid', width: '20px', fontSize: '10px', margin: 0, padding: 0 } }),
	            _react2.default.createElement(
	              'td',
	              { style: { border: '#000000 1px solid', fontSize: '10px', margin: 0, padding: 0, paddingLeft: '3px' } },
	              item.nombre
	            ),
	            _react2.default.createElement(
	              'td',
	              { style: { border: '#000000 1px solid', textAlign: 'end', fontSize: '10px', margin: 0, padding: 0, paddingRight: '3px' } },
	              item.valor
	            )
	          );
	        })
	      )
	    )
	  );
	}
	
	function TortaMoneda(props) {
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'row col-md-12 m-0', style: { margin: 0 } },
	    _react2.default.createElement(
	      'div',
	      { className: 'col-md-8' },
	      _react2.default.createElement(_reactChartjs.Pie, { legend: props.legend, height: props.height, options: props.options, data: props.data })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'col-md-4' },
	      _react2.default.createElement(
	        'table',
	        { className: 'table tablet-responsive table-striped' },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          props.datos && props.datos.map(function (item, index) {
	            return _react2.default.createElement(
	              'tr',
	              { key: index },
	              _react2.default.createElement('td', { style: { backgroundColor: item.color, border: '#000000 1px solid', width: '20px', fontSize: '10px', margin: 0, padding: 0 } }),
	              _react2.default.createElement(
	                'td',
	                { style: { border: '#000000 1px solid', fontSize: '10px', margin: 0, padding: 0, paddingLeft: '3px' } },
	                item.nombre
	              ),
	              _react2.default.createElement(
	                'td',
	                { style: { border: '#000000 1px solid', textAlign: 'end', fontSize: '10px', margin: 0, padding: 0, paddingRight: '3px' } },
	                item.valor
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	}

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GestionarClasificadorVacios = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoClassVacios = __webpack_require__(292);
	
	var _catalogoClassVacios2 = _interopRequireDefault(_catalogoClassVacios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GestionarClasificadorVacios = exports.GestionarClasificadorVacios = function GestionarClasificadorVacios(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var btnclasvacios = JSON.parse(sessionStorage.getItem("btnclasvaciosc"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtIdclassvacio = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)("Gestionar Clasificador de Vacios."),
	      _useState2 = _slicedToArray(_useState, 2),
	      tituloHeader = _useState2[0],
	      setTituloHeader = _useState2[1];
	
	  var _useState3 = (0, _react.useState)("visible"),
	      _useState4 = _slicedToArray(_useState3, 2),
	      visibleBtn = _useState4[0],
	      setVisibleBtn = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      operacion = _useState6[0],
	      setOperacion = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      body = _useState8[0],
	      setBody = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      activate = _useState10[0],
	      setActivate = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(true),
	      _useState12 = _slicedToArray(_useState11, 2),
	      habilitado = _useState12[0],
	      setHabilitado = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensaje = _useState14[0],
	      setMensaje = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mensajesino = _useState16[0],
	      setMensajesino = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      catalogoModelo = _useState18[0],
	      setCatalogoModelo = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      botones = _useState20[0],
	      setBotones = _useState20[1];
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "descripcion") {
	      if (e.target.value === "") {
	        setBotones(Object.assign({}, botones, { aceptar: true }));
	      } else {
	        setBotones(Object.assign({}, botones, { aceptar: false }));
	      }
	      e.target.value = e.target.value;
	    } else {
	      e.target.value = e.target.value;
	    }
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = "idclasevacio, trim(descripcion) as descripcion";
	    var nomtab = "clasevacio";
	    var nomid = "idclasevacio";
	    var id = txtIdclassvacio.current.value;
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtIdclassvacio.current.setAttribute("disabled", true);
	          txtDescripcion.current.value = response.data.descripcion.trim();
	          if (operacion === 2) {
	            setHabilitado(false);
	            txtDescripcion.current.focus();
	          } else {
	            btnCancela.current.focus();
	          }
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: operacion === 4 ? true : false,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	        } else {
	          txtIdclassvacio.current.value = "";
	          txtIdclassvacio.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var validarMarca = function validarMarca(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        seleccionarRegistro();
	      }
	    }
	  };
	
	  var onCatalogoFabricante = function onCatalogoFabricante(values) {
	    setCatalogoModelo(false);
	    txtIdclassvacio.current.setAttribute("disabled", true);
	    txtIdclassvacio.current.value = values.idclasevacio;
	    txtDescripcion.current.value = values.descripcion;
	    setBotones({
	      incluir: true,
	      consultar: true,
	      modificar: false,
	      eliminar: true,
	      aceptar: operacion === 4 ? true : false,
	      cancelar: false,
	      catalogo: true,
	      salir: true
	    });
	    if (operacion === 2) {
	      setHabilitado(false);
	      setTimeout(function () {
	        return txtDescripcion.current.focus();
	      }, 200);
	      //txtDescripcion.current.focus();
	    } else {
	      setTimeout(function () {
	        return btnCancela.current.focus();
	      }, 200);
	      //btnCancela.current.focus();
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	    if (!botones.incluir || !botones.modificar) {
	      if (txtDescripcion.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Debe ingresar una descripción",
	          icono: "informacion"
	        });
	        txtDescripcion.current.focus();
	        sigue = false;
	      }
	    }
	
	    if (sigue) {
	      var classvacios = [];
	      classvacios.push({
	        idclasevacio: txtIdclassvacio.current.value === "" ? 0 : txtIdclassvacio.current.value,
	        descripcion: txtDescripcion.current.value.toUpperCase().trim()
	      });
	
	      setBody({
	        classvacios: classvacios
	      });
	
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + "/api/inventariovacio/actualizarclassvacios/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Registro Creado Correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Registro Modificado Correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Registro Eliminado Correctamente",
	            icono: "exito"
	          });
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = "";
	      if (error.response === undefined) {
	        mensaje = "Error de Conexion";
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
	          mensaje = "Ya existe un Registro con este rif";
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    if (mensajesino.texto === "Seguro de Descartar Cambios?" && props.llamado === 2) {
	      cancelar();
	    } else {
	      procesarRegistro();
	    }
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setTituloHeader("Gestionar Clasificador de Vacios.");
	    setBody(null);
	    setHabilitado(true);
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      salir: false
	    });
	    txtIdclassvacio.current.setAttribute("disabled", true);
	    txtIdclassvacio.current.value = "";
	    txtDescripcion.current.value = "";
	    setVisibleBtn("visible");
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (btnclasvacios && btnclasvacios.toString().substring(0, 1) === "1") {
	          setVisibleBtn("collapse");
	          setTituloHeader("Incluir Clasificador de Vacio.");
	          setOperacion(op);
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	          txtIdclassvacio.current.setAttribute("disabled", true);
	          setTimeout(function () {
	            return txtDescripcion.current.focus();
	          }, 200);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (btnclasvacios && btnclasvacios.toString().substring(1, 2) === "1") {
	          setVisibleBtn("collapse");
	          setTituloHeader("Editar Clasificador de Vacio.");
	          setOperacion(op);
	          txtIdclassvacio.current.removeAttribute("disabled");
	          //setHabilitado(false);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdclassvacio.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (btnclasvacios && btnclasvacios.toString().substring(3, 4) === "1") {
	          setVisibleBtn("collapse");
	          setTituloHeader("Eliminar Clasificador de Vacio.");
	          setOperacion(op);
	          txtIdclassvacio.current.removeAttribute("disabled");
	          //setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdclassvacio.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (btnclasvacios && btnclasvacios.toString().substring(2, 3) === "1") {
	          setVisibleBtn("collapse");
	          setTituloHeader("Consultar Clasificador de Vacio.");
	          setOperacion(op);
	          txtIdclassvacio.current.removeAttribute("disabled");
	          //setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdclassvacio.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        if (props.llamado === 2) {
	          if (txtDescripcion.current.value === "") {
	            blanquear();
	            props.onHideCancela();
	          } else {
	            setMensajesino({
	              mostrar: true,
	              titulo: "Confirmación.",
	              texto: "Seguro de Descartar Cambios?",
	              icono: "confirmacion"
	            });
	          }
	        } else {
	          blanquear();
	        }
	      } else if (op === 7) {
	        setVisibleBtn("visible");
	        cancelar();
	      }
	    };
	  };
	
	  var cerrarModal = function cerrarModal() {
	    if (props.llamado === 2) {
	      props.onHideRenderizar();
	      props.onHideCancela();
	    }
	    blanquear();
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var imprimirFabricantes = function imprimirFabricantes() {
	    /* window.open(
	      `${op.reportes}/almacen?afiliado=${afiliado}&reporte=ListFabricantes`,
	      "Planilla",
	      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
	    ); */
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        setHabilitado(true);
	        if (props.llamado === 2) {
	          setOperacion(1);
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	          txtIdclassvacio.current.setAttribute("disabled", true);
	          setTimeout(function () {
	            return txtDescripcion.current.focus();
	          }, 200);
	          setVisibleBtn("collapse");
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        _Modal2.default.Title,
	        { style: { color: "#fff" } },
	        tituloHeader,
	        " "
	      ),
	      _react2.default.createElement(
	        "a",
	        {
	          href: "#",
	          ref: btnSalir,
	          disabled: botones.salir,
	          onClick: onBotones(7),
	          className: "text-light"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-times fa-1x shadow" },
	          " "
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({
	            mostrar: false,
	            titulo: "",
	            texto: "",
	            icono: ""
	          });
	        }
	      }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, {
	        mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	        },
	        onHideSi: handleCloseSi
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12 row mx-auto px-0" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12 mx-auto px-0" },
	          _react2.default.createElement(
	            "div",
	            { className: "mb-3 col-pd-140 ml-auto" },
	            _react2.default.createElement(
	              "span",
	              null,
	              "FECHA:",
	              " ",
	              _react2.default.createElement(
	                "span",
	                { className: "fw-bold fs-6" },
	                (0, _moment2.default)(fechasistema).format("DD-MM-YYYY"),
	                " "
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "border-azul col-md-12 py-3 rounded mx-1",
	            style: { fontSizeAdjust: "0.6" }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "row col-md-12 rounded mx-auto" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group input-group-sm mb-3 col-md-6 px-0" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "CODIGO:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                ref: txtIdclassvacio,
	                disabled: true,
	                onKeyUp: validarMarca,
	                onBlur: validarMarca,
	                className: "form-control fs-6",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-sm"
	              }),
	              _react2.default.createElement(
	                "button",
	                {
	                  disabled: botones.catalogo,
	                  type: "button",
	                  onClick: function onClick() {
	                    return setCatalogoModelo(true);
	                  },
	                  className: "btn btn-success"
	                },
	                _react2.default.createElement("i", { className: "fas fa-search" })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-1 ml-auto px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    className: "btn btn-primary btn-sm rounded ",
	                    onClick: imprimirFabricantes
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-print" })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group input-group-sm col-md-12 px-0" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "DESCRIPCION:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                ref: txtDescripcion,
	                name: "descripcion",
	                autoComplete: "off",
	                disabled: habilitado,
	                className: "form-control text-uppercase fs-6",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-sm",
	                onChange: onChange
	              })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12 mx-auto" },
	        visibleBtn === "visible" ? _react2.default.createElement(
	          "div",
	          { className: "col-md-12 mx-auto row justify-content-between px-0" },
	          _react2.default.createElement(
	            "button",
	            {
	              disabled: botones.incluir,
	              onClick: onBotones(1),
	              className: "btn btn-sm mx-1 my-1 col btn-primary rounded-pill",
	              title: "Incluir Modelo"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-plus" },
	              " Incluir "
	            ),
	            " "
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              disabled: botones.consultar,
	              onClick: onBotones(4),
	              className: "btn btn-sm mx-1 my-1 col btn-info rounded-pill",
	              title: "Consultar Modelo"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-eye" },
	              "Consultar"
	            ),
	            " "
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              disabled: botones.modificar,
	              onClick: onBotones(2),
	              className: "btn btn-sm mx-1 my-1 col btn-warning rounded-pill",
	              title: "Modificar Modelo"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fa fa-edit" },
	              "Modificar"
	            ),
	            " "
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              disabled: botones.eliminar,
	              onClick: onBotones(3),
	              className: "btn btn-sm mx-1 my-1 col btn-danger rounded-pill",
	              title: "Eliminar Modelo"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fa fa-trash" },
	              "Eliminar"
	            ),
	            " "
	          )
	        ) : _react2.default.createElement(
	          "div",
	          { className: "col-md-12 row mx-auto justify-content-end px-0" },
	          _react2.default.createElement(
	            "button",
	            {
	              ref: btnAcepta,
	              disabled: botones.aceptar,
	              onClick: onBotones(5),
	              className: "btn col-md-3 mx-1 my-1 btn-sm rounded-pill btn-success "
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-check-circle" },
	              " Aceptar"
	            )
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              ref: btnCancela,
	              disabled: botones.cancelar,
	              onClick: onBotones(6),
	              className: "btn col-md-3 mx-1 my-1 btn-danger btn-sm rounded-pill "
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-window-close" },
	              " Cancelar"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoClassVacios2.default, {
	      show: catalogoModelo,
	      idalmacen: null,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoModelo(false);
	      },
	      onHideAceptaCatalogo: onCatalogoFabricante
	    })
	  );
	};

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _modalEstadosdeCuentaClientes = __webpack_require__(7162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CartasProveedores(props) {
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      activate = _useState2[0],
	      setActivate = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      mensaje = _useState4[0],
	      setMensaje = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      totalnotas = _useState6[0],
	      setTotalnotas = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      totaldeudas = _useState8[0],
	      setTotaldeudas = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      totalpagadas = _useState10[0],
	      setTotalpagadas = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      conteo = _useState12[0],
	      setConteo = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      opera = _useState14[0],
	      setOpera = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mostrar = _useState16[0],
	      setMostrar = _useState16[1];
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var accbtnclientes = JSON.parse(sessionStorage.getItem("accbtnclientesc"));
	
	  var seleccionarTotalesClientesPagos = function seleccionarTotalesClientesPagos(id) {
	
	    var endpoint = op.conexion + '/api/agente/totalespagos?id=' + id;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setTotalnotas(response.data.totalnotas);
	        setTotaldeudas(response.data.todeudas);
	        setTotalpagadas(response.data.tocanceladas);
	        setConteo(response.data.idagente);
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	
	    if (props.valida === 1 && parseInt(props.idcliente) !== parseInt(conteo)) {
	      seleccionarTotalesClientesPagos(props.idcliente);
	    } else {
	      seleccionarTotalesClientesPagos(props.idcliente);
	    }
	  }, [props.idcliente]);
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        setMostrar(true);
	        setOpera(op);
	      } else if (op === 2) {
	        setMostrar(true);
	        setOpera(op);
	      } else if (op === 3) {
	        setMostrar(true);
	        setOpera(op);
	      }
	    };
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'container' },
	    props.valida === 1 ? _react2.default.createElement(
	      'button',
	      { className: 'col-md-10 mx-auto bg-transparent border-0 d-flex justify-content-center', onClick: onBotones(3),
	        disabled: totalnotas > 0 && accbtnclientes && accbtnclientes.toString().substring(4, 5) === "1" ? false : true },
	      _react2.default.createElement(
	        'div',
	        { className: 'card bg-card-info', style: { height: '120px', width: '80%' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-header text-center m-0 px-0', style: { height: '60%' } },
	          'Notas de Entregas Emitidas'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-body bg-light mx-1 mb-1 text-center' },
	          _react2.default.createElement(
	            'label',
	            { className: 'fw-bold fs-4' },
	            totalnotas > 0 ? totalnotas : 0
	          )
	        )
	      )
	    ) : _react2.default.createElement(
	      'div',
	      { className: 'col-md-10 mx-auto' },
	      _react2.default.createElement(
	        'div',
	        { className: 'card bg-card-info', style: { height: '120px', width: '80%' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-header text-center m-0 px-0', style: { height: '60%' } },
	          'Total ',
	          props.titulo,
	          ' Registrados'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-body bg-light mx-1 mb-1 text-center' },
	          _react2.default.createElement(
	            'label',
	            { className: 'fw-bold fs-4' },
	            props.totalr
	          )
	        )
	      )
	    ),
	    props.valida === 1 ? _react2.default.createElement(
	      'button',
	      { className: 'col-md-10 mx-auto bg-transparent border-0 d-flex justify-content-center', onClick: onBotones(1),
	        disabled: totaldeudas > 0 && accbtnclientes && accbtnclientes.toString().substring(4, 5) === "1" ? false : true },
	      _react2.default.createElement(
	        'div',
	        { className: 'card bg-danger', style: { height: '120px', width: '80%' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-header text-center', style: { height: '60%' } },
	          'Notas de Entrega por Pagar'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-body bg-light mx-1 mb-1 text-center' },
	          _react2.default.createElement(
	            'label',
	            { className: 'fw-bold fs-4' },
	            totaldeudas > 0 ? totaldeudas : 0
	          )
	        )
	      )
	    ) : _react2.default.createElement(
	      'div',
	      { className: 'col-md-10 mx-auto' },
	      _react2.default.createElement(
	        'div',
	        { className: 'card bg-card-success', style: { height: '120px', width: '80%' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-header text-center', style: { height: '60%' } },
	          'Total ',
	          props.titulo,
	          ' Activos'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-body bg-light mx-1 mb-1 text-center' },
	          _react2.default.createElement(
	            'label',
	            { className: 'fw-bold fs-4' },
	            props.totalact
	          )
	        )
	      )
	    ),
	    props.valida === 1 ? _react2.default.createElement(
	      'button',
	      { className: 'col-md-10 mx-auto bg-transparent border-0 d-flex justify-content-center', onClick: onBotones(2),
	        disabled: totalpagadas > 0 && accbtnclientes && accbtnclientes.toString().substring(4, 5) === "1" ? false : true },
	      _react2.default.createElement(
	        'div',
	        { className: 'card bg-card-success', style: { height: '120px', width: '80%' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-header text-center', style: { height: '60%' } },
	          'Notas de Entrega Pagadas'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-body bg-light mx-1 mb-1 text-center' },
	          _react2.default.createElement(
	            'label',
	            { className: 'fw-bold fs-4' },
	            totalpagadas > 0 ? totalpagadas : 0
	          )
	        )
	      )
	    ) : _react2.default.createElement(
	      'div',
	      { className: 'col-md-10 mx-auto' },
	      _react2.default.createElement(
	        'div',
	        { className: 'card bg-danger', style: { height: '120px', width: '80%' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'card-header text-center', style: { height: '60%' } },
	          'Total ',
	          props.titulo,
	          ' Inactivos'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-body bg-light mx-1 mb-1 text-center' },
	          _react2.default.createElement(
	            'label',
	            { className: 'fw-bold fs-4' },
	            props.totalinc
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_modalEstadosdeCuentaClientes.EstadosdeCuentaClientes, {
	      show: mostrar,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar(false);
	      },
	      op: opera,
	      client: props.idcliente,
	      rif: props.rifclient
	    })
	  );
	}
	
	exports.default = CartasProveedores;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _react.default.createContext(null);
	
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(208);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(133));
	util.inherits = __webpack_require__(76);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(7334)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(685);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(217).Buffer;
	var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(684);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(107);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(107);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	
	  // reuse the free corkReq.
	  state.corkedRequestsFree.next = corkReq;
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90), __webpack_require__(7333).setImmediate, (function() { return this; }())))

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(682);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(305);
	exports.Duplex = __webpack_require__(107);
	exports.Transform = __webpack_require__(683);
	exports.PassThrough = __webpack_require__(7206);


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Radio["default"];
	  }
	});
	
	var _Radio = _interopRequireDefault(__webpack_require__(7229));

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A column sub-component for Grid.
	 */
	function GridColumn(props) {
	  var children = props.children,
	      className = props.className,
	      computer = props.computer,
	      color = props.color,
	      floated = props.floated,
	      largeScreen = props.largeScreen,
	      mobile = props.mobile,
	      only = props.only,
	      stretched = props.stretched,
	      tablet = props.tablet,
	      textAlign = props.textAlign,
	      verticalAlign = props.verticalAlign,
	      widescreen = props.widescreen,
	      width = props.width;
	  var classes = (0, _classnames["default"])(color, (0, _lib.useKeyOnly)(stretched, 'stretched'), (0, _lib.useMultipleProp)(only, 'only'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(computer, 'wide computer'), (0, _lib.useWidthProp)(largeScreen, 'wide large screen'), (0, _lib.useWidthProp)(mobile, 'wide mobile'), (0, _lib.useWidthProp)(tablet, 'wide tablet'), (0, _lib.useWidthProp)(widescreen, 'wide widescreen'), (0, _lib.useWidthProp)(width, 'wide'), 'column', className);
	  var rest = (0, _lib.getUnhandledProps)(GridColumn, props);
	  var ElementType = (0, _lib.getElementType)(GridColumn, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), children);
	}
	
	GridColumn.handledProps = ["as", "children", "className", "color", "computer", "floated", "largeScreen", "mobile", "only", "stretched", "tablet", "textAlign", "verticalAlign", "widescreen", "width"];
	GridColumn.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** A grid column can be colored. */
	  color: _propTypes["default"].oneOf(_lib.SUI.COLORS),
	
	  /** A column can specify a width for a computer. */
	  computer: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['width']), _propTypes["default"].oneOf(_lib.SUI.WIDTHS)]),
	
	  /** A column can sit flush against the left or right edge of a row. */
	  floated: _propTypes["default"].oneOf(_lib.SUI.FLOATS),
	
	  /** A column can specify a width for a large screen device. */
	  largeScreen: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['width']), _propTypes["default"].oneOf(_lib.SUI.WIDTHS)]),
	
	  /** A column can specify a width for a mobile device. */
	  mobile: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['width']), _propTypes["default"].oneOf(_lib.SUI.WIDTHS)]),
	
	  /** A column can appear only for a specific device, or screen sizes. */
	  only: _lib.customPropTypes.multipleProp(_lib.SUI.VISIBILITY),
	
	  /** A column can stretch its contents to take up the entire grid or row height. */
	  stretched: _propTypes["default"].bool,
	
	  /** A column can specify a width for a tablet device. */
	  tablet: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['width']), _propTypes["default"].oneOf(_lib.SUI.WIDTHS)]),
	
	  /** A column can specify its text alignment. */
	  textAlign: _propTypes["default"].oneOf(_lib.SUI.TEXT_ALIGNMENTS),
	
	  /** A column can specify its vertical alignment to have all its columns vertically centered. */
	  verticalAlign: _propTypes["default"].oneOf(_lib.SUI.VERTICAL_ALIGNMENTS),
	
	  /** A column can specify a width for a wide screen device. */
	  widescreen: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['width']), _propTypes["default"].oneOf(_lib.SUI.WIDTHS)]),
	
	  /** Represents width of column. */
	  width: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['computer', 'largeScreen', 'mobile', 'tablet', 'widescreen']), _propTypes["default"].oneOf(_lib.SUI.WIDTHS)])
	} : {};
	GridColumn.create = (0, _lib.createShorthandFactory)(GridColumn, function (children) {
	  return {
	    children: children
	  };
	});
	var _default = GridColumn;
	exports["default"] = _default;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _startCase2 = _interopRequireDefault(__webpack_require__(6940));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Icon = _interopRequireDefault(__webpack_require__(54));
	
	/**
	 * A menu can contain an item.
	 */
	var MenuItem =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(MenuItem, _Component);
	
	  function MenuItem() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, MenuItem);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(MenuItem)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (e) {
	      var disabled = _this.props.disabled;
	      if (!disabled) (0, _invoke2["default"])(_this.props, 'onClick', e, _this.props);
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(MenuItem, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          active = _this$props.active,
	          children = _this$props.children,
	          className = _this$props.className,
	          color = _this$props.color,
	          content = _this$props.content,
	          disabled = _this$props.disabled,
	          fitted = _this$props.fitted,
	          header = _this$props.header,
	          icon = _this$props.icon,
	          link = _this$props.link,
	          name = _this$props.name,
	          onClick = _this$props.onClick,
	          position = _this$props.position;
	      var classes = (0, _classnames["default"])(color, position, (0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(icon === true || icon && !(name || content), 'icon'), (0, _lib.useKeyOnly)(header, 'header'), (0, _lib.useKeyOnly)(link, 'link'), (0, _lib.useKeyOrValueAndKey)(fitted, 'fitted'), 'item', className);
	      var ElementType = (0, _lib.getElementType)(MenuItem, this.props, function () {
	        if (onClick) return 'a';
	      });
	      var rest = (0, _lib.getUnhandledProps)(MenuItem, this.props);
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	          className: classes,
	          onClick: this.handleClick
	        }), children);
	      }
	
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes,
	        onClick: this.handleClick
	      }), _Icon["default"].create(icon, {
	        autoGenerateKey: false
	      }), _lib.childrenUtils.isNil(content) ? (0, _startCase2["default"])(name) : content);
	    }
	  }]);
	  return MenuItem;
	}(_react.Component);
	
	exports["default"] = MenuItem;
	(0, _defineProperty2["default"])(MenuItem, "handledProps", ["active", "as", "children", "className", "color", "content", "disabled", "fitted", "header", "icon", "index", "link", "name", "onClick", "position"]);
	MenuItem.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A menu item can be active. */
	  active: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Additional colors can be specified. */
	  color: _propTypes["default"].oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A menu item can be disabled. */
	  disabled: _propTypes["default"].bool,
	
	  /** A menu item or menu can remove element padding, vertically or horizontally. */
	  fitted: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['horizontally', 'vertically'])]),
	
	  /** A menu item may include a header or may itself be a header. */
	  header: _propTypes["default"].bool,
	
	  /** MenuItem can be only icon. */
	  icon: _propTypes["default"].oneOfType([_propTypes["default"].bool, _lib.customPropTypes.itemShorthand]),
	
	  /** MenuItem index inside Menu. */
	  index: _propTypes["default"].number,
	
	  /** A menu item can be link. */
	  link: _propTypes["default"].bool,
	
	  /** Internal name of the MenuItem. */
	  name: _propTypes["default"].string,
	
	  /**
	   * Called on click. When passed, the component will render as an `a`
	   * tag by default instead of a `div`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes["default"].func,
	
	  /** A menu item can take left or right position. */
	  position: _propTypes["default"].oneOf(['left', 'right'])
	} : {};
	MenuItem.create = (0, _lib.createShorthandFactory)(MenuItem, function (val) {
	  return {
	    content: val,
	    name: val
	  };
	});

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A message list can contain an item.
	 */
	function MessageItem(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('content', className);
	  var rest = (0, _lib.getUnhandledProps)(MessageItem, props);
	  var ElementType = (0, _lib.getElementType)(MessageItem, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	MessageItem.handledProps = ["as", "children", "className", "content"];
	MessageItem.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	MessageItem.defaultProps = {
	  as: 'li'
	};
	MessageItem.create = (0, _lib.createShorthandFactory)(MessageItem, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = MessageItem;
	exports["default"] = _default;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A table can have a header.
	 */
	function TableHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      fullWidth = props.fullWidth;
	  var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(fullWidth, 'full-width'), className);
	  var rest = (0, _lib.getUnhandledProps)(TableHeader, props);
	  var ElementType = (0, _lib.getElementType)(TableHeader, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	TableHeader.handledProps = ["as", "children", "className", "content", "fullWidth"];
	TableHeader.defaultProps = {
	  as: 'thead'
	};
	TableHeader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A definition table can have a full width header or footer, filling in the gap left by the first column. */
	  fullWidth: _propTypes["default"].bool
	} : {};
	var _default = TableHeader;
	exports["default"] = _default;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(46));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(43));
	
	var _reactComponentRef = __webpack_require__(52);
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Icon = _interopRequireDefault(__webpack_require__(220));
	
	var _Label = _interopRequireDefault(__webpack_require__(314));
	
	var _ButtonContent = _interopRequireDefault(__webpack_require__(716));
	
	var _ButtonGroup = _interopRequireDefault(__webpack_require__(717));
	
	var _ButtonOr = _interopRequireDefault(__webpack_require__(718));
	
	/**
	 * A Button indicates a possible user action.
	 * @see Form
	 * @see Icon
	 * @see Label
	 */
	var Button =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Button, _Component);
	
	  function Button() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Button);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Button)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "ref", (0, _react.createRef)());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "computeElementType", function () {
	      var _this$props = _this.props,
	          attached = _this$props.attached,
	          label = _this$props.label;
	      if (!(0, _isNil2["default"])(attached) || !(0, _isNil2["default"])(label)) return 'div';
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "computeTabIndex", function (ElementType) {
	      var _this$props2 = _this.props,
	          disabled = _this$props2.disabled,
	          tabIndex = _this$props2.tabIndex;
	      if (!(0, _isNil2["default"])(tabIndex)) return tabIndex;
	      if (disabled) return -1;
	      if (ElementType === 'div') return 0;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focus", function () {
	      return (0, _invoke2["default"])(_this.ref.current, 'focus');
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (e) {
	      var disabled = _this.props.disabled;
	
	      if (disabled) {
	        e.preventDefault();
	        return;
	      }
	
	      (0, _invoke2["default"])(_this.props, 'onClick', e, _this.props);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "hasIconClass", function () {
	      var _this$props3 = _this.props,
	          labelPosition = _this$props3.labelPosition,
	          children = _this$props3.children,
	          content = _this$props3.content,
	          icon = _this$props3.icon;
	      if (icon === true) return true;
	      return icon && (labelPosition || _lib.childrenUtils.isNil(children) && (0, _isNil2["default"])(content));
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Button, [{
	    key: "computeButtonAriaRole",
	    value: function computeButtonAriaRole(ElementType) {
	      var role = this.props.role;
	      if (!(0, _isNil2["default"])(role)) return role;
	      if (ElementType !== 'button') return 'button';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          active = _this$props4.active,
	          animated = _this$props4.animated,
	          attached = _this$props4.attached,
	          basic = _this$props4.basic,
	          children = _this$props4.children,
	          circular = _this$props4.circular,
	          className = _this$props4.className,
	          color = _this$props4.color,
	          compact = _this$props4.compact,
	          content = _this$props4.content,
	          disabled = _this$props4.disabled,
	          floated = _this$props4.floated,
	          fluid = _this$props4.fluid,
	          icon = _this$props4.icon,
	          inverted = _this$props4.inverted,
	          label = _this$props4.label,
	          labelPosition = _this$props4.labelPosition,
	          loading = _this$props4.loading,
	          negative = _this$props4.negative,
	          positive = _this$props4.positive,
	          primary = _this$props4.primary,
	          secondary = _this$props4.secondary,
	          size = _this$props4.size,
	          toggle = _this$props4.toggle;
	      var baseClasses = (0, _classnames["default"])(color, size, (0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(circular, 'circular'), (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(this.hasIconClass(), 'icon'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useKeyOnly)(negative, 'negative'), (0, _lib.useKeyOnly)(positive, 'positive'), (0, _lib.useKeyOnly)(primary, 'primary'), (0, _lib.useKeyOnly)(secondary, 'secondary'), (0, _lib.useKeyOnly)(toggle, 'toggle'), (0, _lib.useKeyOrValueAndKey)(animated, 'animated'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'));
	      var labeledClasses = (0, _classnames["default"])((0, _lib.useKeyOrValueAndKey)(labelPosition || !!label, 'labeled'));
	      var wrapperClasses = (0, _classnames["default"])((0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useValueAndKey)(floated, 'floated'));
	      var rest = (0, _lib.getUnhandledProps)(Button, this.props);
	      var ElementType = (0, _lib.getElementType)(Button, this.props, this.computeElementType);
	      var tabIndex = this.computeTabIndex(ElementType);
	
	      if (!(0, _isNil2["default"])(label)) {
	        var buttonClasses = (0, _classnames["default"])('ui', baseClasses, 'button', className);
	        var containerClasses = (0, _classnames["default"])('ui', labeledClasses, 'button', className, wrapperClasses);
	
	        var labelElement = _Label["default"].create(label, {
	          defaultProps: {
	            basic: true,
	            pointing: labelPosition === 'left' ? 'right' : 'left'
	          },
	          autoGenerateKey: false
	        });
	
	        return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	          className: containerClasses,
	          onClick: this.handleClick
	        }), labelPosition === 'left' && labelElement, _react["default"].createElement(_reactComponentRef.Ref, {
	          innerRef: this.ref
	        }, _react["default"].createElement("button", {
	          className: buttonClasses,
	          "aria-pressed": toggle ? !!active : undefined,
	          disabled: disabled,
	          tabIndex: tabIndex
	        }, _Icon["default"].create(icon, {
	          autoGenerateKey: false
	        }), " ", content)), (labelPosition === 'right' || !labelPosition) && labelElement);
	      }
	
	      var classes = (0, _classnames["default"])('ui', baseClasses, wrapperClasses, labeledClasses, 'button', className);
	      var hasChildren = !_lib.childrenUtils.isNil(children);
	      var role = this.computeButtonAriaRole(ElementType);
	      return _react["default"].createElement(_reactComponentRef.Ref, {
	        innerRef: this.ref
	      }, _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes,
	        "aria-pressed": toggle ? !!active : undefined,
	        disabled: disabled && ElementType === 'button' || undefined,
	        onClick: this.handleClick,
	        role: role,
	        tabIndex: tabIndex
	      }), hasChildren && children, !hasChildren && _Icon["default"].create(icon, {
	        autoGenerateKey: false
	      }), !hasChildren && content));
	    }
	  }]);
	  return Button;
	}(_react.Component);
	
	(0, _defineProperty2["default"])(Button, "defaultProps", {
	  as: 'button'
	});
	(0, _defineProperty2["default"])(Button, "Content", _ButtonContent["default"]);
	(0, _defineProperty2["default"])(Button, "Group", _ButtonGroup["default"]);
	(0, _defineProperty2["default"])(Button, "Or", _ButtonOr["default"]);
	(0, _defineProperty2["default"])(Button, "handledProps", ["active", "animated", "as", "attached", "basic", "children", "circular", "className", "color", "compact", "content", "disabled", "floated", "fluid", "icon", "inverted", "label", "labelPosition", "loading", "negative", "onClick", "positive", "primary", "role", "secondary", "size", "tabIndex", "toggle"]);
	Button.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A button can show it is currently the active user selection. */
	  active: _propTypes["default"].bool,
	
	  /** A button can animate to show hidden content. */
	  animated: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['fade', 'vertical'])]),
	
	  /** A button can be attached to other content. */
	  attached: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['left', 'right', 'top', 'bottom'])]),
	
	  /** A basic button is less pronounced. */
	  basic: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _lib.customPropTypes.every([_propTypes["default"].node, _lib.customPropTypes.disallow(['label']), _lib.customPropTypes.givenProps({
	    icon: _propTypes["default"].oneOfType([_propTypes["default"].string.isRequired, _propTypes["default"].object.isRequired, _propTypes["default"].element.isRequired])
	  }, _lib.customPropTypes.disallow(['icon']))]),
	
	  /** A button can be circular. */
	  circular: _propTypes["default"].bool,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** A button can have different colors */
	  color: _propTypes["default"].oneOf([].concat((0, _toConsumableArray2["default"])(_lib.SUI.COLORS), ['facebook', 'google plus', 'instagram', 'linkedin', 'twitter', 'vk', 'youtube'])),
	
	  /** A button can reduce its padding to fit into tighter spaces. */
	  compact: _propTypes["default"].bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A button can show it is currently unable to be interacted with. */
	  disabled: _propTypes["default"].bool,
	
	  /** A button can be aligned to the left or right of its container. */
	  floated: _propTypes["default"].oneOf(_lib.SUI.FLOATS),
	
	  /** A button can take the width of its container. */
	  fluid: _propTypes["default"].bool,
	
	  /** Add an Icon by name, props object, or pass an <Icon />. */
	  icon: _lib.customPropTypes.some([_propTypes["default"].bool, _propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].element]),
	
	  /** A button can be formatted to appear on dark backgrounds. */
	  inverted: _propTypes["default"].bool,
	
	  /** Add a Label by text, props object, or pass a <Label />. */
	  label: _lib.customPropTypes.some([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].element]),
	
	  /** A labeled button can format a Label or Icon to appear on the left or right. */
	  labelPosition: _propTypes["default"].oneOf(['right', 'left']),
	
	  /** A button can show a loading indicator. */
	  loading: _propTypes["default"].bool,
	
	  /** A button can hint towards a negative consequence. */
	  negative: _propTypes["default"].bool,
	
	  /**
	   * Called after user's click.
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes["default"].func,
	
	  /** A button can hint towards a positive consequence. */
	  positive: _propTypes["default"].bool,
	
	  /** A button can be formatted to show different levels of emphasis. */
	  primary: _propTypes["default"].bool,
	
	  /** The role of the HTML element. */
	  role: _propTypes["default"].string,
	
	  /** A button can be formatted to show different levels of emphasis. */
	  secondary: _propTypes["default"].bool,
	
	  /** A button can have different sizes. */
	  size: _propTypes["default"].oneOf(_lib.SUI.SIZES),
	
	  /** A button can receive focus. */
	  tabIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /** A button can be formatted to toggle on and off. */
	  toggle: _propTypes["default"].bool
	} : {};
	Button.create = (0, _lib.createShorthandFactory)(Button, function (value) {
	  return {
	    content: value
	  };
	});
	var _default = Button;
	exports["default"] = _default;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Input["default"];
	  }
	});
	
	var _Input = _interopRequireDefault(__webpack_require__(7255));

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _isUndefined2 = _interopRequireDefault(__webpack_require__(204));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Icon = _interopRequireDefault(__webpack_require__(220));
	
	var _Image = _interopRequireDefault(__webpack_require__(723));
	
	var _LabelDetail = _interopRequireDefault(__webpack_require__(725));
	
	var _LabelGroup = _interopRequireDefault(__webpack_require__(726));
	
	/**
	 * A label displays content classification.
	 */
	var Label =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Label, _Component);
	
	  function Label() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Label);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Label)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (e) {
	      var onClick = _this.props.onClick;
	      if (onClick) onClick(e, _this.props);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleIconOverrides", function (predefinedProps) {
	      return {
	        onClick: function onClick(e) {
	          (0, _invoke2["default"])(predefinedProps, 'onClick', e);
	          (0, _invoke2["default"])(_this.props, 'onRemove', e, _this.props);
	        }
	      };
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Label, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          active = _this$props.active,
	          attached = _this$props.attached,
	          basic = _this$props.basic,
	          children = _this$props.children,
	          circular = _this$props.circular,
	          className = _this$props.className,
	          color = _this$props.color,
	          content = _this$props.content,
	          corner = _this$props.corner,
	          detail = _this$props.detail,
	          empty = _this$props.empty,
	          floating = _this$props.floating,
	          horizontal = _this$props.horizontal,
	          icon = _this$props.icon,
	          image = _this$props.image,
	          onRemove = _this$props.onRemove,
	          pointing = _this$props.pointing,
	          prompt = _this$props.prompt,
	          removeIcon = _this$props.removeIcon,
	          ribbon = _this$props.ribbon,
	          size = _this$props.size,
	          tag = _this$props.tag;
	      var pointingClass = pointing === true && 'pointing' || (pointing === 'left' || pointing === 'right') && "".concat(pointing, " pointing") || (pointing === 'above' || pointing === 'below') && "pointing ".concat(pointing);
	      var classes = (0, _classnames["default"])('ui', color, pointingClass, size, (0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(circular, 'circular'), (0, _lib.useKeyOnly)(empty, 'empty'), (0, _lib.useKeyOnly)(floating, 'floating'), (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(image === true, 'image'), (0, _lib.useKeyOnly)(prompt, 'prompt'), (0, _lib.useKeyOnly)(tag, 'tag'), (0, _lib.useKeyOrValueAndKey)(corner, 'corner'), (0, _lib.useKeyOrValueAndKey)(ribbon, 'ribbon'), (0, _lib.useValueAndKey)(attached, 'attached'), 'label', className);
	      var rest = (0, _lib.getUnhandledProps)(Label, this.props);
	      var ElementType = (0, _lib.getElementType)(Label, this.props);
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	          className: classes,
	          onClick: this.handleClick
	        }), children);
	      }
	
	      var removeIconShorthand = (0, _isUndefined2["default"])(removeIcon) ? 'delete' : removeIcon;
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({
	        className: classes,
	        onClick: this.handleClick
	      }, rest), _Icon["default"].create(icon, {
	        autoGenerateKey: false
	      }), typeof image !== 'boolean' && _Image["default"].create(image, {
	        autoGenerateKey: false
	      }), content, _LabelDetail["default"].create(detail, {
	        autoGenerateKey: false
	      }), onRemove && _Icon["default"].create(removeIconShorthand, {
	        autoGenerateKey: false,
	        overrideProps: this.handleIconOverrides
	      }));
	    }
	  }]);
	  return Label;
	}(_react.Component);
	
	exports["default"] = Label;
	(0, _defineProperty2["default"])(Label, "Detail", _LabelDetail["default"]);
	(0, _defineProperty2["default"])(Label, "Group", _LabelGroup["default"]);
	(0, _defineProperty2["default"])(Label, "handledProps", ["active", "as", "attached", "basic", "children", "circular", "className", "color", "content", "corner", "detail", "empty", "floating", "horizontal", "icon", "image", "onClick", "onRemove", "pointing", "prompt", "removeIcon", "ribbon", "size", "tag"]);
	Label.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A label can be active. */
	  active: _propTypes["default"].bool,
	
	  /** A label can attach to a content segment. */
	  attached: _propTypes["default"].oneOf(['top', 'bottom', 'top right', 'top left', 'bottom left', 'bottom right']),
	
	  /** A label can reduce its complexity. */
	  basic: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** A label can be circular. */
	  circular: _propTypes["default"].bool,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Color of the label. */
	  color: _propTypes["default"].oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A label can position itself in the corner of an element. */
	  corner: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['left', 'right'])]),
	
	  /** Shorthand for LabelDetail. */
	  detail: _lib.customPropTypes.itemShorthand,
	
	  /** Formats the label as a dot. */
	  empty: _lib.customPropTypes.every([_propTypes["default"].bool, _lib.customPropTypes.demand(['circular'])]),
	
	  /** Float above another element in the upper right corner. */
	  floating: _propTypes["default"].bool,
	
	  /** A horizontal label is formatted to label content along-side it horizontally. */
	  horizontal: _propTypes["default"].bool,
	
	  /** Shorthand for Icon. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** A label can be formatted to emphasize an image or prop can be used as shorthand for Image. */
	  image: _propTypes["default"].oneOfType([_propTypes["default"].bool, _lib.customPropTypes.itemShorthand]),
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes["default"].func,
	
	  /**
	   * Adds an "x" icon, called when "x" is clicked.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onRemove: _propTypes["default"].func,
	
	  /** A label can point to content next to it. */
	  pointing: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['above', 'below', 'left', 'right'])]),
	
	  /** A label can prompt for an error in your forms. */
	  prompt: _propTypes["default"].bool,
	
	  /** Shorthand for Icon to appear as the last child and trigger onRemove. */
	  removeIcon: _lib.customPropTypes.itemShorthand,
	
	  /** A label can appear as a ribbon attaching itself to an element. */
	  ribbon: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['right'])]),
	
	  /** A label can have different sizes. */
	  size: _propTypes["default"].oneOf(_lib.SUI.SIZES),
	
	  /** A label can appear as a tag. */
	  tag: _propTypes["default"].bool
	} : {};
	Label.create = (0, _lib.createShorthandFactory)(Label, function (value) {
	  return {
	    content: value
	  };
	});

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _ListDescription = _interopRequireDefault(__webpack_require__(221));
	
	var _ListHeader = _interopRequireDefault(__webpack_require__(222));
	
	/**
	 * A list item can contain a content.
	 */
	function ListContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      description = props.description,
	      floated = props.floated,
	      header = props.header,
	      verticalAlign = props.verticalAlign;
	  var classes = (0, _classnames["default"])((0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useVerticalAlignProp)(verticalAlign), 'content', className);
	  var rest = (0, _lib.getUnhandledProps)(ListContent, props);
	  var ElementType = (0, _lib.getElementType)(ListContent, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _ListHeader["default"].create(header), _ListDescription["default"].create(description), content);
	}
	
	ListContent.handledProps = ["as", "children", "className", "content", "description", "floated", "header", "verticalAlign"];
	ListContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for ListDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** An list content can be floated left or right. */
	  floated: _propTypes["default"].oneOf(_lib.SUI.FLOATS),
	
	  /** Shorthand for ListHeader. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** An element inside a list can be vertically aligned. */
	  verticalAlign: _propTypes["default"].oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : {};
	ListContent.create = (0, _lib.createShorthandFactory)(ListContent, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = ListContent;
	exports["default"] = _default;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Icon = _interopRequireDefault(__webpack_require__(220));
	
	/**
	 * A list item can contain an icon.
	 */
	function ListIcon(props) {
	  var className = props.className,
	      verticalAlign = props.verticalAlign;
	  var classes = (0, _classnames["default"])((0, _lib.useVerticalAlignProp)(verticalAlign), className);
	  var rest = (0, _lib.getUnhandledProps)(ListIcon, props);
	  return _react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, rest, {
	    className: classes
	  }));
	}
	
	ListIcon.handledProps = ["className", "verticalAlign"];
	ListIcon.propTypes =  false ? {
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** An element inside a list can be vertically aligned. */
	  verticalAlign: _propTypes["default"].oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : {};
	ListIcon.create = (0, _lib.createShorthandFactory)(ListIcon, function (name) {
	  return {
	    name: name
	  };
	});
	var _default = ListIcon;
	exports["default"] = _default;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	function StepDescription(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('description', className);
	  var rest = (0, _lib.getUnhandledProps)(StepDescription, props);
	  var ElementType = (0, _lib.getElementType)(StepDescription, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	StepDescription.handledProps = ["as", "children", "className", "content"];
	StepDescription.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	StepDescription.create = (0, _lib.createShorthandFactory)(StepDescription, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = StepDescription;
	exports["default"] = _default;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A step can contain a title.
	 */
	function StepTitle(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('title', className);
	  var rest = (0, _lib.getUnhandledProps)(StepTitle, props);
	  var ElementType = (0, _lib.getElementType)(StepTitle, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	StepTitle.handledProps = ["as", "children", "className", "content"];
	StepTitle.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	StepTitle.create = (0, _lib.createShorthandFactory)(StepTitle, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = StepTitle;
	exports["default"] = _default;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.numberToWord = numberToWord;
	exports.numberToWordMap = void 0;
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(55));
	
	var numberToWordMap = {
	  1: 'one',
	  2: 'two',
	  3: 'three',
	  4: 'four',
	  5: 'five',
	  6: 'six',
	  7: 'seven',
	  8: 'eight',
	  9: 'nine',
	  10: 'ten',
	  11: 'eleven',
	  12: 'twelve',
	  13: 'thirteen',
	  14: 'fourteen',
	  15: 'fifteen',
	  16: 'sixteen'
	  /**
	   * Return the number word for numbers 1-16.
	   * Returns strings or numbers as is if there is no corresponding word.
	   * Returns an empty string if value is not a string or number.
	   * @param {string|number} value The value to convert to a word.
	   * @returns {string}
	   */
	
	};
	exports.numberToWordMap = numberToWordMap;
	
	function numberToWord(value) {
	  var type = (0, _typeof2["default"])(value);
	
	  if (type === 'string' || type === 'number') {
	    return numberToWordMap[value] || value;
	  }
	
	  return '';
	}

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A content sub-component for Accordion component.
	 */
	function AccordionContent(props) {
	  var active = props.active,
	      children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('content', (0, _lib.useKeyOnly)(active, 'active'), className);
	  var rest = (0, _lib.getUnhandledProps)(AccordionContent, props);
	  var ElementType = (0, _lib.getElementType)(AccordionContent, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	AccordionContent.handledProps = ["active", "as", "children", "className", "content"];
	AccordionContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Whether or not the content is visible. */
	  active: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	AccordionContent.create = (0, _lib.createShorthandFactory)(AccordionContent, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = AccordionContent;
	exports["default"] = _default;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _AccordionTitle = _interopRequireDefault(__webpack_require__(322));
	
	var _AccordionContent = _interopRequireDefault(__webpack_require__(320));
	
	/**
	 * A panel sub-component for Accordion component.
	 */
	var AccordionPanel =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(AccordionPanel, _Component);
	
	  function AccordionPanel() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, AccordionPanel);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(AccordionPanel)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTitleOverrides", function (predefinedProps) {
	      return {
	        onClick: function onClick(e, titleProps) {
	          (0, _invoke2["default"])(predefinedProps, 'onClick', e, titleProps);
	          (0, _invoke2["default"])(_this.props, 'onTitleClick', e, titleProps);
	        }
	      };
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(AccordionPanel, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          active = _this$props.active,
	          content = _this$props.content,
	          index = _this$props.index,
	          title = _this$props.title;
	      return _react["default"].createElement(_react.Fragment, null, _AccordionTitle["default"].create(title, {
	        autoGenerateKey: false,
	        defaultProps: {
	          active: active,
	          index: index
	        },
	        overrideProps: this.handleTitleOverrides
	      }), _AccordionContent["default"].create(content, {
	        autoGenerateKey: false,
	        defaultProps: {
	          active: active
	        }
	      }));
	    }
	  }]);
	  return AccordionPanel;
	}(_react.Component);
	
	(0, _defineProperty2["default"])(AccordionPanel, "handledProps", ["active", "content", "index", "onTitleClick", "title"]);
	AccordionPanel.propTypes =  false ? {
	  /** Whether or not the title is in the open state. */
	  active: _propTypes["default"].bool,
	
	  /** A shorthand for Accordion.Content. */
	  content: _lib.customPropTypes.itemShorthand,
	
	  /** A panel index. */
	  index: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /**
	   * Called when a panel title is clicked.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All item props.
	   */
	  onTitleClick: _propTypes["default"].func,
	
	  /** A shorthand for Accordion.Title. */
	  title: _lib.customPropTypes.itemShorthand
	} : {};
	AccordionPanel.create = (0, _lib.createShorthandFactory)(AccordionPanel, null);
	var _default = AccordionPanel;
	exports["default"] = _default;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(43));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Icon = _interopRequireDefault(__webpack_require__(54));
	
	/**
	 * A title sub-component for Accordion component.
	 */
	var AccordionTitle =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(AccordionTitle, _Component);
	
	  function AccordionTitle() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, AccordionTitle);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(AccordionTitle)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (e) {
	      return (0, _invoke2["default"])(_this.props, 'onClick', e, _this.props);
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(AccordionTitle, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          active = _this$props.active,
	          children = _this$props.children,
	          className = _this$props.className,
	          content = _this$props.content,
	          icon = _this$props.icon;
	      var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(active, 'active'), 'title', className);
	      var rest = (0, _lib.getUnhandledProps)(AccordionTitle, this.props);
	      var ElementType = (0, _lib.getElementType)(AccordionTitle, this.props);
	      var iconValue = (0, _isNil2["default"])(icon) ? 'dropdown' : icon;
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	          className: classes,
	          onClick: this.handleClick
	        }), children);
	      }
	
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes,
	        onClick: this.handleClick
	      }), _Icon["default"].create(iconValue, {
	        autoGenerateKey: false
	      }), content);
	    }
	  }]);
	  return AccordionTitle;
	}(_react.Component);
	
	exports["default"] = AccordionTitle;
	(0, _defineProperty2["default"])(AccordionTitle, "handledProps", ["active", "as", "children", "className", "content", "icon", "index", "onClick"]);
	AccordionTitle.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Whether or not the title is in the open state. */
	  active: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for Icon. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** AccordionTitle index inside Accordion. */
	  index: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes["default"].func
	} : {};
	AccordionTitle.create = (0, _lib.createShorthandFactory)(AccordionTitle, function (content) {
	  return {
	    content: content
	  };
	});

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A card can contain a description with one or more paragraphs.
	 */
	function CardDescription(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      textAlign = props.textAlign;
	  var classes = (0, _classnames["default"])((0, _lib.useTextAlignProp)(textAlign), 'description', className);
	  var rest = (0, _lib.getUnhandledProps)(CardDescription, props);
	  var ElementType = (0, _lib.getElementType)(CardDescription, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	CardDescription.handledProps = ["as", "children", "className", "content", "textAlign"];
	CardDescription.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A card content can adjust its text alignment. */
	  textAlign: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.TEXT_ALIGNMENTS, 'justified'))
	} : {};
	var _default = CardDescription;
	exports["default"] = _default;

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A card can contain a header.
	 */
	function CardHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      textAlign = props.textAlign;
	  var classes = (0, _classnames["default"])((0, _lib.useTextAlignProp)(textAlign), 'header', className);
	  var rest = (0, _lib.getUnhandledProps)(CardHeader, props);
	  var ElementType = (0, _lib.getElementType)(CardHeader, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	CardHeader.handledProps = ["as", "children", "className", "content", "textAlign"];
	CardHeader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A card header can adjust its text alignment. */
	  textAlign: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.TEXT_ALIGNMENTS, 'justified'))
	} : {};
	var _default = CardHeader;
	exports["default"] = _default;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A card can contain content metadata.
	 */
	function CardMeta(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      textAlign = props.textAlign;
	  var classes = (0, _classnames["default"])((0, _lib.useTextAlignProp)(textAlign), 'meta', className);
	  var rest = (0, _lib.getUnhandledProps)(CardMeta, props);
	  var ElementType = (0, _lib.getElementType)(CardMeta, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	CardMeta.handledProps = ["as", "children", "className", "content", "textAlign"];
	CardMeta.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A card meta can adjust its text alignment. */
	  textAlign: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.TEXT_ALIGNMENTS, 'justified'))
	} : {};
	var _default = CardMeta;
	exports["default"] = _default;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _FeedDate = _interopRequireDefault(__webpack_require__(225));
	
	var _FeedExtra = _interopRequireDefault(__webpack_require__(327));
	
	var _FeedMeta = _interopRequireDefault(__webpack_require__(330));
	
	var _FeedSummary = _interopRequireDefault(__webpack_require__(331));
	
	function FeedContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      extraImages = props.extraImages,
	      extraText = props.extraText,
	      date = props.date,
	      meta = props.meta,
	      summary = props.summary;
	  var classes = (0, _classnames["default"])('content', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedContent, props);
	  var ElementType = (0, _lib.getElementType)(FeedContent, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), (0, _lib.createShorthand)(_FeedDate["default"], function (val) {
	    return {
	      content: val
	    };
	  }, date, {
	    autoGenerateKey: false
	  }), (0, _lib.createShorthand)(_FeedSummary["default"], function (val) {
	    return {
	      content: val
	    };
	  }, summary, {
	    autoGenerateKey: false
	  }), content, (0, _lib.createShorthand)(_FeedExtra["default"], function (val) {
	    return {
	      text: true,
	      content: val
	    };
	  }, extraText, {
	    autoGenerateKey: false
	  }), (0, _lib.createShorthand)(_FeedExtra["default"], function (val) {
	    return {
	      images: val
	    };
	  }, extraImages, {
	    autoGenerateKey: false
	  }), (0, _lib.createShorthand)(_FeedMeta["default"], function (val) {
	    return {
	      content: val
	    };
	  }, meta, {
	    autoGenerateKey: false
	  }));
	}
	
	FeedContent.handledProps = ["as", "children", "className", "content", "date", "extraImages", "extraText", "meta", "summary"];
	FeedContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** An event can contain a date. */
	  date: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedExtra with images. */
	  extraImages: _FeedExtra["default"].propTypes.images,
	
	  /** Shorthand for FeedExtra with text. */
	  extraText: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedMeta. */
	  meta: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedSummary. */
	  summary: _lib.customPropTypes.itemShorthand
	} : {};
	var _default = FeedContent;
	exports["default"] = _default;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _map2 = _interopRequireDefault(__webpack_require__(41));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A feed can contain an extra content.
	 */
	function FeedExtra(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      images = props.images,
	      text = props.text;
	  var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(images, 'images'), (0, _lib.useKeyOnly)(content || text, 'text'), 'extra', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedExtra, props);
	  var ElementType = (0, _lib.getElementType)(FeedExtra, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  } // TODO need a "collection factory" to handle creating multiple image elements and their keys
	
	
	  var imageElements = (0, _map2["default"])(images, function (image, index) {
	    var key = [index, image].join('-');
	    return (0, _lib.createHTMLImage)(image, {
	      key: key
	    });
	  });
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), content, imageElements);
	}
	
	FeedExtra.handledProps = ["as", "children", "className", "content", "images", "text"];
	FeedExtra.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** An event can contain additional information like a set of images. */
	  images: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['text']), _propTypes["default"].oneOfType([_propTypes["default"].bool, _lib.customPropTypes.collectionShorthand])]),
	
	  /** An event can contain additional text information. */
	  text: _propTypes["default"].bool
	} : {};
	var _default = FeedExtra;
	exports["default"] = _default;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Icon = _interopRequireDefault(__webpack_require__(54));
	
	/**
	 * An event can contain an image or icon label.
	 */
	function FeedLabel(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      icon = props.icon,
	      image = props.image;
	  var classes = (0, _classnames["default"])('label', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedLabel, props);
	  var ElementType = (0, _lib.getElementType)(FeedLabel, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), content, _Icon["default"].create(icon, {
	    autoGenerateKey: false
	  }), (0, _lib.createHTMLImage)(image));
	}
	
	FeedLabel.handledProps = ["as", "children", "className", "content", "icon", "image"];
	FeedLabel.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** An event can contain icon label. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** An event can contain image label. */
	  image: _lib.customPropTypes.itemShorthand
	} : {};
	var _default = FeedLabel;
	exports["default"] = _default;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Icon = _interopRequireDefault(__webpack_require__(54));
	
	/**
	 * A feed can contain a like element.
	 */
	function FeedLike(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      icon = props.icon;
	  var classes = (0, _classnames["default"])('like', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedLike, props);
	  var ElementType = (0, _lib.getElementType)(FeedLike, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _Icon["default"].create(icon, {
	    autoGenerateKey: false
	  }), content);
	}
	
	FeedLike.handledProps = ["as", "children", "className", "content", "icon"];
	FeedLike.defaultProps = {
	  as: 'a'
	};
	FeedLike.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for icon. Mutually exclusive with children. */
	  icon: _lib.customPropTypes.itemShorthand
	} : {};
	var _default = FeedLike;
	exports["default"] = _default;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _FeedLike = _interopRequireDefault(__webpack_require__(329));
	
	/**
	 * A feed can contain a meta.
	 */
	function FeedMeta(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      like = props.like;
	  var classes = (0, _classnames["default"])('meta', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedMeta, props);
	  var ElementType = (0, _lib.getElementType)(FeedMeta, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), (0, _lib.createShorthand)(_FeedLike["default"], function (val) {
	    return {
	      content: val
	    };
	  }, like, {
	    autoGenerateKey: false
	  }), content);
	}
	
	FeedMeta.handledProps = ["as", "children", "className", "content", "like"];
	FeedMeta.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for FeedLike. */
	  like: _lib.customPropTypes.itemShorthand
	} : {};
	var _default = FeedMeta;
	exports["default"] = _default;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _FeedDate = _interopRequireDefault(__webpack_require__(225));
	
	var _FeedUser = _interopRequireDefault(__webpack_require__(332));
	
	/**
	 * A feed can contain a summary.
	 */
	function FeedSummary(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      date = props.date,
	      user = props.user;
	  var classes = (0, _classnames["default"])('summary', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedSummary, props);
	  var ElementType = (0, _lib.getElementType)(FeedSummary, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), (0, _lib.createShorthand)(_FeedUser["default"], function (val) {
	    return {
	      content: val
	    };
	  }, user, {
	    autoGenerateKey: false
	  }), content, (0, _lib.createShorthand)(_FeedDate["default"], function (val) {
	    return {
	      content: val
	    };
	  }, date, {
	    autoGenerateKey: false
	  }));
	}
	
	FeedSummary.handledProps = ["as", "children", "className", "content", "date", "user"];
	FeedSummary.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for FeedDate. */
	  date: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedUser. */
	  user: _lib.customPropTypes.itemShorthand
	} : {};
	var _default = FeedSummary;
	exports["default"] = _default;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A feed can contain a user element.
	 */
	function FeedUser(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('user', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedUser, props);
	  var ElementType = (0, _lib.getElementType)(FeedUser, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	FeedUser.handledProps = ["as", "children", "className", "content"];
	FeedUser.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	FeedUser.defaultProps = {
	  as: 'a'
	};
	var _default = FeedUser;
	exports["default"] = _default;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * An item can contain a description with a single or multiple paragraphs.
	 */
	function ItemDescription(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('description', className);
	  var rest = (0, _lib.getUnhandledProps)(ItemDescription, props);
	  var ElementType = (0, _lib.getElementType)(ItemDescription, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	ItemDescription.handledProps = ["as", "children", "className", "content"];
	ItemDescription.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	ItemDescription.create = (0, _lib.createShorthandFactory)(ItemDescription, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = ItemDescription;
	exports["default"] = _default;

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * An item can contain extra content meant to be formatted separately from the main content.
	 */
	function ItemExtra(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('extra', className);
	  var rest = (0, _lib.getUnhandledProps)(ItemExtra, props);
	  var ElementType = (0, _lib.getElementType)(ItemExtra, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	ItemExtra.handledProps = ["as", "children", "className", "content"];
	ItemExtra.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	ItemExtra.create = (0, _lib.createShorthandFactory)(ItemExtra, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = ItemExtra;
	exports["default"] = _default;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * An item can contain a header.
	 */
	function ItemHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('header', className);
	  var rest = (0, _lib.getUnhandledProps)(ItemHeader, props);
	  var ElementType = (0, _lib.getElementType)(ItemHeader, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	ItemHeader.handledProps = ["as", "children", "className", "content"];
	ItemHeader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	ItemHeader.create = (0, _lib.createShorthandFactory)(ItemHeader, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = ItemHeader;
	exports["default"] = _default;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * An item can contain content metadata.
	 */
	function ItemMeta(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('meta', className);
	  var rest = (0, _lib.getUnhandledProps)(ItemMeta, props);
	  var ElementType = (0, _lib.getElementType)(ItemMeta, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	ItemMeta.handledProps = ["as", "children", "className", "content"];
	ItemMeta.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	ItemMeta.create = (0, _lib.createShorthandFactory)(ItemMeta, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = ItemMeta;
	exports["default"] = _default;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ManagerReferenceNodeSetterContext = exports.ManagerReferenceNodeContext = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(92));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(797));
	
	var ManagerReferenceNodeContext = (0, _createReactContext.default)();
	exports.ManagerReferenceNodeContext = ManagerReferenceNodeContext;
	var ManagerReferenceNodeSetterContext = (0, _createReactContext.default)();
	exports.ManagerReferenceNodeSetterContext = ManagerReferenceNodeSetterContext;
	
	var Manager =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Manager, _React$Component);
	
	  function Manager() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "referenceNode", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setReferenceNode", function (newReferenceNode) {
	      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
	        _this.referenceNode = newReferenceNode;
	
	        _this.forceUpdate();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = Manager.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.referenceNode = null;
	  };
	
	  _proto.render = function render() {
	    return React.createElement(ManagerReferenceNodeContext.Provider, {
	      value: this.referenceNode
	    }, React.createElement(ManagerReferenceNodeSetterContext.Provider, {
	      value: this.setReferenceNode
	    }, this.props.children));
	  };
	
	  return Manager;
	}(React.Component);
	
	exports.default = Manager;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    var provided = typeof message === 'function' ? message() : message;
	    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
	    throw new Error(value);
	}
	
	module.exports = invariant;


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production","PUBLIC_URL":""}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(7336);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(7335);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(90)))

/***/ },
/* 340 */
/***/ function(module, exports) {

	function _arrayLikeToArray(r, a) {
	  (null == a || a > r.length) && (a = r.length);
	  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
	  return n;
	}
	module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 341 */
/***/ function(module, exports) {

	function _arrayWithHoles(r) {
	  if (Array.isArray(r)) return r;
	}
	module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	var superPropBase = __webpack_require__(794);
	function _get() {
	  return module.exports = _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
	    var p = superPropBase(e, t);
	    if (p) {
	      var n = Object.getOwnPropertyDescriptor(p, t);
	      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
	    }
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _get.apply(null, arguments);
	}
	module.exports = _get, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 343 */
/***/ function(module, exports) {

	function _iterableToArray(r) {
	  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
	}
	module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 344 */
/***/ function(module, exports) {

	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 345 */
/***/ function(module, exports) {

	function _setPrototypeOf(t, e) {
	  return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
	    return t.__proto__ = e, t;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithHoles = __webpack_require__(341);
	var iterableToArray = __webpack_require__(343);
	var unsupportedIterableToArray = __webpack_require__(228);
	var nonIterableRest = __webpack_require__(344);
	function _toArray(r) {
	  return arrayWithHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableRest();
	}
	module.exports = _toArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(55)["default"];
	var toPrimitive = __webpack_require__(795);
	function toPropertyKey(t) {
	  var i = toPrimitive(t, "string");
	  return "symbol" == _typeof(i) ? i : i + "";
	}
	module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
	 */
	var AccordionContext = /*#__PURE__*/React.createContext({});
	
	if (false) {
	  AccordionContext.displayName = 'AccordionContext';
	}
	
	var _default = AccordionContext;
	exports.default = _default;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Button.default;
	  }
	});
	
	var _Button = _interopRequireDefault(__webpack_require__(822));

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ClickAwayListener.default;
	  }
	});
	
	var _ClickAwayListener = _interopRequireDefault(__webpack_require__(846));

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
	 */
	var ExpansionPanelContext = /*#__PURE__*/React.createContext({});
	
	if (false) {
	  ExpansionPanelContext.displayName = 'ExpansionPanelContext';
	}
	
	var _default = ExpansionPanelContext;
	exports.default = _default;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormGroup.default;
	  }
	});
	
	var _FormGroup = _interopRequireDefault(__webpack_require__(880));

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormHelperText.default;
	  }
	});
	
	var _FormHelperText = _interopRequireDefault(__webpack_require__(881));

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormLabel.default;
	  }
	});
	
	var _FormLabel = _interopRequireDefault(__webpack_require__(882));

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _InputLabel.default;
	  }
	});
	
	var _InputLabel = _interopRequireDefault(__webpack_require__(903));

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _LinearProgress.default;
	  }
	});
	
	var _LinearProgress = _interopRequireDefault(__webpack_require__(904));

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _List.default;
	  }
	});
	
	var _List = _interopRequireDefault(__webpack_require__(907));

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItem.default;
	  }
	});
	
	var _ListItem = _interopRequireDefault(__webpack_require__(908));

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(67);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Popover = _interopRequireDefault(__webpack_require__(366));
	
	var _MenuList = _interopRequireDefault(__webpack_require__(361));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(45));
	
	var _setRef = _interopRequireDefault(__webpack_require__(95));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(47));
	
	var RTL_ORIGIN = {
	  vertical: 'top',
	  horizontal: 'right'
	};
	var LTR_ORIGIN = {
	  vertical: 'top',
	  horizontal: 'left'
	};
	var styles = {
	  /* Styles applied to the `Paper` component. */
	  paper: {
	    // specZ: The maximum height of a simple menu should be one or more rows less than the view
	    // height. This ensures a tapable area outside of the simple menu with which to dismiss
	    // the menu.
	    maxHeight: 'calc(100% - 96px)',
	    // Add iOS momentum scrolling.
	    WebkitOverflowScrolling: 'touch'
	  },
	
	  /* Styles applied to the `List` component via `MenuList`. */
	  list: {
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0
	  }
	};
	exports.styles = styles;
	var Menu = /*#__PURE__*/React.forwardRef(function Menu(props, ref) {
	  var _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
	      children = props.children,
	      classes = props.classes,
	      _props$disableAutoFoc = props.disableAutoFocusItem,
	      disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
	      _props$MenuListProps = props.MenuListProps,
	      MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps,
	      onClose = props.onClose,
	      onEntering = props.onEntering,
	      open = props.open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      PopoverClasses = props.PopoverClasses,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "variant"]);
	  var theme = (0, _useTheme.default)();
	  var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
	  var menuListActionsRef = React.useRef(null);
	  var contentAnchorRef = React.useRef(null);
	
	  var getContentAnchorEl = function getContentAnchorEl() {
	    return contentAnchorRef.current;
	  };
	
	  var handleEntering = function handleEntering(element, isAppearing) {
	    if (menuListActionsRef.current) {
	      menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
	    }
	
	    if (onEntering) {
	      onEntering(element, isAppearing);
	    }
	  };
	
	  var handleListKeyDown = function handleListKeyDown(event) {
	    if (event.key === 'Tab') {
	      event.preventDefault();
	
	      if (onClose) {
	        onClose(event, 'tabKeyDown');
	      }
	    }
	  };
	  /**
	   * the index of the item should receive focus
	   * in a `variant="selectedMenu"` it's the first `selected` item
	   * otherwise it's the very first item.
	   */
	
	
	  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
	  // to check if there is a `selected` item. We're looking for the last `selected`
	  // item and use the first valid item as a fallback
	
	  React.Children.map(children, function (child, index) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    if (!child.props.disabled) {
	      if (variant !== "menu" && child.props.selected) {
	        activeItemIndex = index;
	      } else if (activeItemIndex === -1) {
	        activeItemIndex = index;
	      }
	    }
	  });
	  var items = React.Children.map(children, function (child, index) {
	    if (index === activeItemIndex) {
	      return /*#__PURE__*/React.cloneElement(child, {
	        ref: function ref(instance) {
	          // #StrictMode ready
	          contentAnchorRef.current = ReactDOM.findDOMNode(instance);
	          (0, _setRef.default)(child.ref, instance);
	        }
	      });
	    }
	
	    return child;
	  });
	  return /*#__PURE__*/React.createElement(_Popover.default, (0, _extends2.default)({
	    getContentAnchorEl: getContentAnchorEl,
	    classes: PopoverClasses,
	    onClose: onClose,
	    onEntering: handleEntering,
	    anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
	    transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
	    PaperProps: (0, _extends2.default)({}, PaperProps, {
	      classes: (0, _extends2.default)({}, PaperProps.classes, {
	        root: classes.paper
	      })
	    }),
	    open: open,
	    ref: ref,
	    transitionDuration: transitionDuration
	  }, other), /*#__PURE__*/React.createElement(_MenuList.default, (0, _extends2.default)({
	    onKeyDown: handleListKeyDown,
	    actions: menuListActionsRef,
	    autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
	    autoFocusItem: autoFocusItem,
	    variant: variant
	  }, MenuListProps, {
	    className: (0, _clsx.default)(classes.list, MenuListProps.className)
	  }), items));
	});
	 false ? Menu.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A HTML element, or a function that returns it.
	   * It's used to set the position of the menu.
	   */
	  anchorEl: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_utils.HTMLElementType, _propTypes.default.func]),
	
	  /**
	   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
	   * children are not focusable. If you set this prop to `false` focus will be placed
	   * on the parent modal container. This has severe accessibility implications
	   * and should only be considered if you manage focus otherwise.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Menu contents, normally `MenuItem`s.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * When opening the menu will not focus the active item but the `[role="menu"]`
	   * unless `autoFocus` is also set to `false`. Not using the default means not
	   * following WAI-ARIA authoring practices. Please be considerate about possible
	   * accessibility implications.
	   */
	  disableAutoFocusItem: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`MenuList`](/api/menu-list/) element.
	   */
	  MenuListProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the Menu enters.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired before the Menu exits.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * If `true`, the menu is visible.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * @ignore
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * `classes` prop applied to the [`Popover`](/api/popover/) element.
	   */
	  PopoverClasses: _propTypes.default.object,
	
	  /**
	   * The length of the transition in `ms`, or 'auto'
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
	   * and the vertical alignment relative to the anchor element.
	   */
	  variant: _propTypes.default.oneOf(['menu', 'selectedMenu'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMenu'
	})(Menu);
	
	exports.default = _default;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItem.default;
	  }
	});
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(920));

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MenuList.default;
	  }
	});
	
	var _MenuList = _interopRequireDefault(__webpack_require__(921));

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(46));
	
	var _getScrollbarSize = _interopRequireDefault(__webpack_require__(396));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(68));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(168));
	
	// Is a vertical scrollbar displayed?
	function isOverflowing(container) {
	  var doc = (0, _ownerDocument.default)(container);
	
	  if (doc.body === container) {
	    return (0, _ownerWindow.default)(doc).innerWidth > doc.documentElement.clientWidth;
	  }
	
	  return container.scrollHeight > container.clientHeight;
	}
	
	function ariaHidden(node, show) {
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function getPaddingRight(node) {
	  return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
	}
	
	function ariaHiddenSiblings(container, mountNode, currentNode) {
	  var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	  var show = arguments.length > 4 ? arguments[4] : undefined;
	  var blacklist = [mountNode, currentNode].concat((0, _toConsumableArray2.default)(nodesToExclude));
	  var blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
	  [].forEach.call(container.children, function (node) {
	    if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) {
	      ariaHidden(node, show);
	    }
	  });
	}
	
	function findIndexOf(containerInfo, callback) {
	  var idx = -1;
	  containerInfo.some(function (item, index) {
	    if (callback(item)) {
	      idx = index;
	      return true;
	    }
	
	    return false;
	  });
	  return idx;
	}
	
	function handleContainer(containerInfo, props) {
	  var restoreStyle = [];
	  var restorePaddings = [];
	  var container = containerInfo.container;
	  var fixedNodes;
	
	  if (!props.disableScrollLock) {
	    if (isOverflowing(container)) {
	      // Compute the size before applying overflow hidden to avoid any scroll jumps.
	      var scrollbarSize = (0, _getScrollbarSize.default)();
	      restoreStyle.push({
	        value: container.style.paddingRight,
	        key: 'padding-right',
	        el: container
	      }); // Use computed style, here to get the real padding to add our scrollbar width.
	
	      container.style['padding-right'] = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
	
	      fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');
	      [].forEach.call(fixedNodes, function (node) {
	        restorePaddings.push(node.style.paddingRight);
	        node.style.paddingRight = "".concat(getPaddingRight(node) + scrollbarSize, "px");
	      });
	    } // Improve Gatsby support
	    // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
	
	
	    var parent = container.parentElement;
	    var scrollContainer = parent.nodeName === 'HTML' && window.getComputedStyle(parent)['overflow-y'] === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
	    // screensize shrink.
	
	    restoreStyle.push({
	      value: scrollContainer.style.overflow,
	      key: 'overflow',
	      el: scrollContainer
	    });
	    scrollContainer.style.overflow = 'hidden';
	  }
	
	  var restore = function restore() {
	    if (fixedNodes) {
	      [].forEach.call(fixedNodes, function (node, i) {
	        if (restorePaddings[i]) {
	          node.style.paddingRight = restorePaddings[i];
	        } else {
	          node.style.removeProperty('padding-right');
	        }
	      });
	    }
	
	    restoreStyle.forEach(function (_ref) {
	      var value = _ref.value,
	          el = _ref.el,
	          key = _ref.key;
	
	      if (value) {
	        el.style.setProperty(key, value);
	      } else {
	        el.style.removeProperty(key);
	      }
	    });
	  };
	
	  return restore;
	}
	
	function getHiddenSiblings(container) {
	  var hiddenSiblings = [];
	  [].forEach.call(container.children, function (node) {
	    if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
	      hiddenSiblings.push(node);
	    }
	  });
	  return hiddenSiblings;
	}
	/**
	 * @ignore - do not document.
	 *
	 * Proper state management for containers and the modals in those containers.
	 * Simplified, but inspired by react-overlay's ModalManager class.
	 * Used by the Modal to ensure proper styling of containers.
	 */
	
	
	var ModalManager = /*#__PURE__*/function () {
	  function ModalManager() {
	    (0, _classCallCheck2.default)(this, ModalManager);
	    // this.modals[modalIndex] = modal
	    this.modals = []; // this.containers[containerIndex] = {
	    //   modals: [],
	    //   container,
	    //   restore: null,
	    // }
	
	    this.containers = [];
	  }
	
	  (0, _createClass2.default)(ModalManager, [{
	    key: "add",
	    value: function add(modal, container) {
	      var modalIndex = this.modals.indexOf(modal);
	
	      if (modalIndex !== -1) {
	        return modalIndex;
	      }
	
	      modalIndex = this.modals.length;
	      this.modals.push(modal); // If the modal we are adding is already in the DOM.
	
	      if (modal.modalRef) {
	        ariaHidden(modal.modalRef, false);
	      }
	
	      var hiddenSiblingNodes = getHiddenSiblings(container);
	      ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.container === container;
	      });
	
	      if (containerIndex !== -1) {
	        this.containers[containerIndex].modals.push(modal);
	        return modalIndex;
	      }
	
	      this.containers.push({
	        modals: [modal],
	        container: container,
	        restore: null,
	        hiddenSiblingNodes: hiddenSiblingNodes
	      });
	      return modalIndex;
	    }
	  }, {
	    key: "mount",
	    value: function mount(modal, props) {
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.modals.indexOf(modal) !== -1;
	      });
	      var containerInfo = this.containers[containerIndex];
	
	      if (!containerInfo.restore) {
	        containerInfo.restore = handleContainer(containerInfo, props);
	      }
	    }
	  }, {
	    key: "remove",
	    value: function remove(modal) {
	      var modalIndex = this.modals.indexOf(modal);
	
	      if (modalIndex === -1) {
	        return modalIndex;
	      }
	
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.modals.indexOf(modal) !== -1;
	      });
	      var containerInfo = this.containers[containerIndex];
	      containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
	      this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
	
	      if (containerInfo.modals.length === 0) {
	        // The modal might be closed before it had the chance to be mounted in the DOM.
	        if (containerInfo.restore) {
	          containerInfo.restore();
	        }
	
	        if (modal.modalRef) {
	          // In case the modal wasn't in the DOM yet.
	          ariaHidden(modal.modalRef, true);
	        }
	
	        ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
	        this.containers.splice(containerIndex, 1);
	      } else {
	        // Otherwise make sure the next top modal is visible to a screen reader.
	        var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
	        // aria-hidden because the dom element doesn't exist either
	        // when modal was unmounted before modalRef gets null
	
	        if (nextTop.modalRef) {
	          ariaHidden(nextTop.modalRef, false);
	        }
	      }
	
	      return modalIndex;
	    }
	  }, {
	    key: "isTopModal",
	    value: function isTopModal(modal) {
	      return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	  return ModalManager;
	}();
	
	exports.default = ModalManager;

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _NativeSelectInput = _interopRequireDefault(__webpack_require__(364));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(109));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(93));
	
	var _ArrowDropDown = _interopRequireDefault(__webpack_require__(389));
	
	var _Input = _interopRequireDefault(__webpack_require__(164));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the select component `root` class. */
	    root: {},
	
	    /* Styles applied to the select component `select` class. */
	    select: {
	      '-moz-appearance': 'none',
	      // Reset
	      '-webkit-appearance': 'none',
	      // Reset
	      // When interacting quickly, the text can end up selected.
	      // Native select can't be selected either.
	      userSelect: 'none',
	      borderRadius: 0,
	      // Reset
	      minWidth: 16,
	      // So it doesn't collapse.
	      cursor: 'pointer',
	      '&:focus': {
	        // Show that it's not an text input
	        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
	        borderRadius: 0 // Reset Chrome style
	
	      },
	      // Remove IE 11 arrow
	      '&::-ms-expand': {
	        display: 'none'
	      },
	      '&$disabled': {
	        cursor: 'default'
	      },
	      '&[multiple]': {
	        height: 'auto'
	      },
	      '&:not([multiple]) option, &:not([multiple]) optgroup': {
	        backgroundColor: theme.palette.background.paper
	      },
	      '&&': {
	        paddingRight: 24
	      }
	    },
	
	    /* Styles applied to the select component if `variant="filled"`. */
	    filled: {
	      '&&': {
	        paddingRight: 32
	      }
	    },
	
	    /* Styles applied to the select component if `variant="outlined"`. */
	    outlined: {
	      borderRadius: theme.shape.borderRadius,
	      '&&': {
	        paddingRight: 32
	      }
	    },
	
	    /* Styles applied to the select component `selectMenu` class. */
	    selectMenu: {
	      height: 'auto',
	      // Resets for multpile select with chips
	      minHeight: '1.1876em',
	      // Required for select\text-field height consistency
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden'
	    },
	
	    /* Pseudo-class applied to the select component `disabled` class. */
	    disabled: {},
	
	    /* Styles applied to the icon component. */
	    icon: {
	      // We use a position absolute over a flexbox in order to forward the pointer events
	      // to the input and to support wrapping tags..
	      position: 'absolute',
	      right: 0,
	      top: 'calc(50% - 12px)',
	      // Center vertically
	      pointerEvents: 'none',
	      // Don't block pointer events on the select under the icon.
	      color: theme.palette.action.active,
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the icon component if the popup is open. */
	    iconOpen: {
	      transform: 'rotate(180deg)'
	    },
	
	    /* Styles applied to the icon component if `variant="filled"`. */
	    iconFilled: {
	      right: 7
	    },
	
	    /* Styles applied to the icon component if `variant="outlined"`. */
	    iconOutlined: {
	      right: 7
	    },
	
	    /* Styles applied to the underlying native input component. */
	    nativeInput: {
	      bottom: 0,
	      left: 0,
	      position: 'absolute',
	      opacity: 0,
	      pointerEvents: 'none',
	      width: '100%'
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultInput = /*#__PURE__*/React.createElement(_Input.default, null);
	/**
	 * An alternative to `<Select native />` with a much smaller bundle size footprint.
	 */
	
	var NativeSelect = /*#__PURE__*/React.forwardRef(function NativeSelect(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      _props$IconComponent = props.IconComponent,
	      IconComponent = _props$IconComponent === void 0 ? _ArrowDropDown.default : _props$IconComponent,
	      _props$input = props.input,
	      input = _props$input === void 0 ? defaultInput : _props$input,
	      inputProps = props.inputProps,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['variant']
	  });
	  return /*#__PURE__*/React.cloneElement(input, (0, _extends2.default)({
	    // Most of the logic is implemented in `NativeSelectInput`.
	    // The `Select` component is a simple API wrapper to expose something better to play with.
	    inputComponent: _NativeSelectInput.default,
	    inputProps: (0, _extends2.default)({
	      children: children,
	      classes: classes,
	      IconComponent: IconComponent,
	      variant: fcs.variant,
	      type: undefined
	    }, inputProps, input ? input.props.inputProps : {}),
	    ref: ref
	  }, other));
	});
	 false ? NativeSelect.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The option elements to populate the select with.
	   * Can be some `<option>` elements.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType,
	
	  /**
	   * An `Input` element; does not have to be a material-ui specific `Input`.
	   */
	  input: _propTypes.default.element,
	
	  /**
	   * Attributes applied to the `select` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The input value. The DOM API casts this to a string.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	NativeSelect.muiName = 'Select';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiNativeSelect'
	})(NativeSelect);
	
	exports.default = _default;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	/**
	 * @ignore - internal component.
	 */
	var NativeSelectInput = /*#__PURE__*/React.forwardRef(function NativeSelectInput(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      disabled = props.disabled,
	      IconComponent = props.IconComponent,
	      inputRef = props.inputRef,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("select", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, // TODO v5: merge root and select
	    classes.select, classes[variant], className, disabled && classes.disabled),
	    disabled: disabled,
	    ref: inputRef || ref
	  }, other)), props.multiple ? null : /*#__PURE__*/React.createElement(IconComponent, {
	    className: (0, _clsx.default)(classes.icon, classes["icon".concat((0, _capitalize.default)(variant))], disabled && classes.disabled)
	  }));
	});
	 false ? NativeSelectInput.propTypes = {
	  /**
	   * The option elements to populate the select with.
	   * Can be some `<option>` elements.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The CSS class name of the select element.
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the select will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType.isRequired,
	
	  /**
	   * Use that prop to pass a ref to the native select element.
	   * @deprecated
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * @ignore
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `select` or hidden `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The input value.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	var _default = NativeSelectInput;
	exports.default = _default;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _NoSsr.default;
	  }
	});
	
	var _NoSsr = _interopRequireDefault(__webpack_require__(927));

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Popover.default;
	  }
	});
	
	var _Popover = _interopRequireDefault(__webpack_require__(931));

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	
	var _Popper = _interopRequireDefault(__webpack_require__(932));

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var RadioGroupContext = /*#__PURE__*/React.createContext();
	
	if (false) {
	  RadioGroupContext.displayName = 'RadioGroupContext';
	}
	
	var _default = RadioGroupContext;
	exports.default = _default;

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useRadioGroup;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _RadioGroupContext = _interopRequireDefault(__webpack_require__(368));
	
	function useRadioGroup() {
	  return React.useContext(_RadioGroupContext.default);
	}

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Slide.default;
	  }
	});
	
	var _Slide = _interopRequireDefault(__webpack_require__(943));

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SnackbarContent.default;
	  }
	});
	
	var _SnackbarContent = _interopRequireDefault(__webpack_require__(949));

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepConnector.default;
	  }
	});
	
	var _StepConnector = _interopRequireDefault(__webpack_require__(954));

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepIcon.default;
	  }
	});
	
	var _StepIcon = _interopRequireDefault(__webpack_require__(957));

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepLabel.default;
	  }
	});
	
	var _StepLabel = _interopRequireDefault(__webpack_require__(958));

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TabScrollButton.default;
	  }
	});
	
	var _TabScrollButton = _interopRequireDefault(__webpack_require__(969));

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var TableContext = /*#__PURE__*/React.createContext();
	
	if (false) {
	  TableContext.displayName = 'TableContext';
	}
	
	var _default = TableContext;
	exports.default = _default;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableCell.default;
	  }
	});
	
	var _TableCell = _interopRequireDefault(__webpack_require__(974));

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TextareaAutosize.default;
	  }
	});
	
	var _TextareaAutosize = _interopRequireDefault(__webpack_require__(993));

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Toolbar.default;
	  }
	});
	
	var _Toolbar = _interopRequireDefault(__webpack_require__(994));

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Unstable_TrapFocus.default;
	  }
	});
	
	var _Unstable_TrapFocus = _interopRequireDefault(__webpack_require__(998));

/***/ },
/* 381 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var blue = {
	  50: '#e3f2fd',
	  100: '#bbdefb',
	  200: '#90caf9',
	  300: '#64b5f6',
	  400: '#42a5f5',
	  500: '#2196f3',
	  600: '#1e88e5',
	  700: '#1976d2',
	  800: '#1565c0',
	  900: '#0d47a1',
	  A100: '#82b1ff',
	  A200: '#448aff',
	  A400: '#2979ff',
	  A700: '#2962ff'
	};
	var _default = blue;
	exports.default = _default;

/***/ },
/* 382 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var common = {
	  black: '#000',
	  white: '#fff'
	};
	var _default = common;
	exports.default = _default;

/***/ },
/* 383 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var green = {
	  50: '#e8f5e9',
	  100: '#c8e6c9',
	  200: '#a5d6a7',
	  300: '#81c784',
	  400: '#66bb6a',
	  500: '#4caf50',
	  600: '#43a047',
	  700: '#388e3c',
	  800: '#2e7d32',
	  900: '#1b5e20',
	  A100: '#b9f6ca',
	  A200: '#69f0ae',
	  A400: '#00e676',
	  A700: '#00c853'
	};
	var _default = green;
	exports.default = _default;

/***/ },
/* 384 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var grey = {
	  50: '#fafafa',
	  100: '#f5f5f5',
	  200: '#eeeeee',
	  300: '#e0e0e0',
	  400: '#bdbdbd',
	  500: '#9e9e9e',
	  600: '#757575',
	  700: '#616161',
	  800: '#424242',
	  900: '#212121',
	  A100: '#d5d5d5',
	  A200: '#aaaaaa',
	  A400: '#303030',
	  A700: '#616161'
	};
	var _default = grey;
	exports.default = _default;

/***/ },
/* 385 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var indigo = {
	  50: '#e8eaf6',
	  100: '#c5cae9',
	  200: '#9fa8da',
	  300: '#7986cb',
	  400: '#5c6bc0',
	  500: '#3f51b5',
	  600: '#3949ab',
	  700: '#303f9f',
	  800: '#283593',
	  900: '#1a237e',
	  A100: '#8c9eff',
	  A200: '#536dfe',
	  A400: '#3d5afe',
	  A700: '#304ffe'
	};
	var _default = indigo;
	exports.default = _default;

/***/ },
/* 386 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var orange = {
	  50: '#fff3e0',
	  100: '#ffe0b2',
	  200: '#ffcc80',
	  300: '#ffb74d',
	  400: '#ffa726',
	  500: '#ff9800',
	  600: '#fb8c00',
	  700: '#f57c00',
	  800: '#ef6c00',
	  900: '#e65100',
	  A100: '#ffd180',
	  A200: '#ffab40',
	  A400: '#ff9100',
	  A700: '#ff6d00'
	};
	var _default = orange;
	exports.default = _default;

/***/ },
/* 387 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var pink = {
	  50: '#fce4ec',
	  100: '#f8bbd0',
	  200: '#f48fb1',
	  300: '#f06292',
	  400: '#ec407a',
	  500: '#e91e63',
	  600: '#d81b60',
	  700: '#c2185b',
	  800: '#ad1457',
	  900: '#880e4f',
	  A100: '#ff80ab',
	  A200: '#ff4081',
	  A400: '#f50057',
	  A700: '#c51162'
	};
	var _default = pink;
	exports.default = _default;

/***/ },
/* 388 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var red = {
	  50: '#ffebee',
	  100: '#ffcdd2',
	  200: '#ef9a9a',
	  300: '#e57373',
	  400: '#ef5350',
	  500: '#f44336',
	  600: '#e53935',
	  700: '#d32f2f',
	  800: '#c62828',
	  900: '#b71c1c',
	  A100: '#ff8a80',
	  A200: '#ff5252',
	  A400: '#ff1744',
	  A700: '#d50000'
	};
	var _default = red;
	exports.default = _default;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(57));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M7 10l5 5 5-5z"
	}), 'ArrowDropDown');
	
	exports.default = _default;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(57));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
	}), 'KeyboardArrowLeft');
	
	exports.default = _default;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(57));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
	}), 'KeyboardArrowRight');
	
	exports.default = _default;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createBreakpoints;
	exports.keys = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	// Sorted ASC by size. That's important.
	// It can't be configured as it's used statically for propTypes.
	var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.
	
	exports.keys = keys;
	
	function createBreakpoints(breakpoints) {
	  var _breakpoints$values = breakpoints.values,
	      values = _breakpoints$values === void 0 ? {
	    xs: 0,
	    sm: 600,
	    md: 960,
	    lg: 1280,
	    xl: 1920
	  } : _breakpoints$values,
	      _breakpoints$unit = breakpoints.unit,
	      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
	      _breakpoints$step = breakpoints.step,
	      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
	      other = (0, _objectWithoutProperties2.default)(breakpoints, ["values", "unit", "step"]);
	
	  function up(key) {
	    var value = typeof values[key] === 'number' ? values[key] : key;
	    return "@media (min-width:".concat(value).concat(unit, ")");
	  }
	
	  function down(key) {
	    var endIndex = keys.indexOf(key) + 1;
	    var upperbound = values[keys[endIndex]];
	
	    if (endIndex === keys.length) {
	      // xl down applies to all sizes
	      return up('xs');
	    }
	
	    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
	    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
	  }
	
	  function between(start, end) {
	    var endIndex = keys.indexOf(end);
	
	    if (endIndex === keys.length - 1) {
	      return up(start);
	    }
	
	    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
	  }
	
	  function only(key) {
	    return between(key, key);
	  }
	
	  function width(key) {
	    return values[key];
	  }
	
	  return (0, _extends2.default)({
	    keys: keys,
	    values: values,
	    up: up,
	    down: down,
	    between: between,
	    only: only,
	    width: width
	  }, other);
	}

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _styles = __webpack_require__(60);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(129));
	
	var styled = function styled(Component) {
	  var componentCreator = (0, _styles.styled)(Component);
	  return function (style, options) {
	    return componentCreator(style, (0, _extends2.default)({
	      defaultTheme: _defaultTheme.default
	    }, options));
	  };
	};
	
	var _default = styled;
	exports.default = _default;

/***/ },
/* 394 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// We need to centralize the zIndex definitions as they work
	// like global values in the browser.
	var zIndex = {
	  mobileStepper: 1000,
	  speedDial: 1050,
	  appBar: 1100,
	  drawer: 1200,
	  modal: 1300,
	  snackbar: 1400,
	  tooltip: 1500
	};
	var _default = zIndex;
	exports.default = _default;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _useMediaQuery.default;
	  }
	});
	
	var _useMediaQuery = _interopRequireDefault(__webpack_require__(1041));

/***/ },
/* 396 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getScrollbarSize;
	
	// A change of the browser zoom change the scrollbar size.
	// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
	function getScrollbarSize() {
	  var scrollDiv = document.createElement('div');
	  scrollDiv.style.width = '99px';
	  scrollDiv.style.height = '99px';
	  scrollDiv.style.position = 'absolute';
	  scrollDiv.style.top = '-9999px';
	  scrollDiv.style.overflow = 'scroll';
	  document.body.appendChild(scrollDiv);
	  var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	  document.body.removeChild(scrollDiv);
	  return scrollbarSize;
	}

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "capitalize", {
	  enumerable: true,
	  get: function get() {
	    return _capitalize.default;
	  }
	});
	Object.defineProperty(exports, "createChainedFunction", {
	  enumerable: true,
	  get: function get() {
	    return _createChainedFunction.default;
	  }
	});
	Object.defineProperty(exports, "createSvgIcon", {
	  enumerable: true,
	  get: function get() {
	    return _createSvgIcon.default;
	  }
	});
	Object.defineProperty(exports, "debounce", {
	  enumerable: true,
	  get: function get() {
	    return _debounce.default;
	  }
	});
	Object.defineProperty(exports, "deprecatedPropType", {
	  enumerable: true,
	  get: function get() {
	    return _deprecatedPropType.default;
	  }
	});
	Object.defineProperty(exports, "isMuiElement", {
	  enumerable: true,
	  get: function get() {
	    return _isMuiElement.default;
	  }
	});
	Object.defineProperty(exports, "ownerDocument", {
	  enumerable: true,
	  get: function get() {
	    return _ownerDocument.default;
	  }
	});
	Object.defineProperty(exports, "ownerWindow", {
	  enumerable: true,
	  get: function get() {
	    return _ownerWindow.default;
	  }
	});
	Object.defineProperty(exports, "requirePropFactory", {
	  enumerable: true,
	  get: function get() {
	    return _requirePropFactory.default;
	  }
	});
	Object.defineProperty(exports, "setRef", {
	  enumerable: true,
	  get: function get() {
	    return _setRef.default;
	  }
	});
	Object.defineProperty(exports, "unsupportedProp", {
	  enumerable: true,
	  get: function get() {
	    return _unsupportedProp.default;
	  }
	});
	Object.defineProperty(exports, "useControlled", {
	  enumerable: true,
	  get: function get() {
	    return _useControlled.default;
	  }
	});
	Object.defineProperty(exports, "useEventCallback", {
	  enumerable: true,
	  get: function get() {
	    return _useEventCallback.default;
	  }
	});
	Object.defineProperty(exports, "useForkRef", {
	  enumerable: true,
	  get: function get() {
	    return _useForkRef.default;
	  }
	});
	Object.defineProperty(exports, "unstable_useId", {
	  enumerable: true,
	  get: function get() {
	    return _unstable_useId.default;
	  }
	});
	Object.defineProperty(exports, "useIsFocusVisible", {
	  enumerable: true,
	  get: function get() {
	    return _useIsFocusVisible.default;
	  }
	});
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(111));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(57));
	
	var _debounce = _interopRequireDefault(__webpack_require__(94));
	
	var _deprecatedPropType = _interopRequireDefault(__webpack_require__(1044));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(130));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(68));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(168));
	
	var _requirePropFactory = _interopRequireDefault(__webpack_require__(398));
	
	var _setRef = _interopRequireDefault(__webpack_require__(95));
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(170));
	
	var _useControlled = _interopRequireDefault(__webpack_require__(85));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(79));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	var _unstable_useId = _interopRequireDefault(__webpack_require__(169));
	
	var _useIsFocusVisible = _interopRequireDefault(__webpack_require__(131));

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = requirePropFactory;
	
	function requirePropFactory(componentNameInError) {
	  if (true) {
	    return function () {
	      return null;
	    };
	  }
	
	  var requireProp = function requireProp(requiredProp) {
	    return function (props, propName, componentName, location, propFullName) {
	      var propFullNameSafe = propFullName || propName;
	
	      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
	        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
	      }
	
	      return null;
	    };
	  };
	
	  return requireProp;
	}

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.9.1
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "AccessAlarm", {
	  enumerable: true,
	  get: function get() {
	    return _AccessAlarm.default;
	  }
	});
	Object.defineProperty(exports, "AccessAlarmOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AccessAlarmOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AccessAlarmRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AccessAlarmRounded.default;
	  }
	});
	Object.defineProperty(exports, "AccessAlarms", {
	  enumerable: true,
	  get: function get() {
	    return _AccessAlarms.default;
	  }
	});
	Object.defineProperty(exports, "AccessAlarmSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AccessAlarmSharp.default;
	  }
	});
	Object.defineProperty(exports, "AccessAlarmsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AccessAlarmsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AccessAlarmsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AccessAlarmsRounded.default;
	  }
	});
	Object.defineProperty(exports, "AccessAlarmsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AccessAlarmsSharp.default;
	  }
	});
	Object.defineProperty(exports, "AccessAlarmsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AccessAlarmsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AccessAlarmTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AccessAlarmTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Accessibility", {
	  enumerable: true,
	  get: function get() {
	    return _Accessibility.default;
	  }
	});
	Object.defineProperty(exports, "AccessibilityNew", {
	  enumerable: true,
	  get: function get() {
	    return _AccessibilityNew.default;
	  }
	});
	Object.defineProperty(exports, "AccessibilityNewOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AccessibilityNewOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AccessibilityNewRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AccessibilityNewRounded.default;
	  }
	});
	Object.defineProperty(exports, "AccessibilityNewSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AccessibilityNewSharp.default;
	  }
	});
	Object.defineProperty(exports, "AccessibilityNewTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AccessibilityNewTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AccessibilityOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AccessibilityOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AccessibilityRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AccessibilityRounded.default;
	  }
	});
	Object.defineProperty(exports, "AccessibilitySharp", {
	  enumerable: true,
	  get: function get() {
	    return _AccessibilitySharp.default;
	  }
	});
	Object.defineProperty(exports, "AccessibilityTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AccessibilityTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Accessible", {
	  enumerable: true,
	  get: function get() {
	    return _Accessible.default;
	  }
	});
	Object.defineProperty(exports, "AccessibleForward", {
	  enumerable: true,
	  get: function get() {
	    return _AccessibleForward.default;
	  }
	});
	Object.defineProperty(exports, "AccessibleForwardOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AccessibleForwardOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AccessibleForwardRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AccessibleForwardRounded.default;
	  }
	});
	Object.defineProperty(exports, "AccessibleForwardSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AccessibleForwardSharp.default;
	  }
	});
	Object.defineProperty(exports, "AccessibleForwardTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AccessibleForwardTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AccessibleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AccessibleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AccessibleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AccessibleRounded.default;
	  }
	});
	Object.defineProperty(exports, "AccessibleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AccessibleSharp.default;
	  }
	});
	Object.defineProperty(exports, "AccessibleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AccessibleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AccessTime", {
	  enumerable: true,
	  get: function get() {
	    return _AccessTime.default;
	  }
	});
	Object.defineProperty(exports, "AccessTimeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AccessTimeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AccessTimeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AccessTimeRounded.default;
	  }
	});
	Object.defineProperty(exports, "AccessTimeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AccessTimeSharp.default;
	  }
	});
	Object.defineProperty(exports, "AccessTimeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AccessTimeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AccountBalance", {
	  enumerable: true,
	  get: function get() {
	    return _AccountBalance.default;
	  }
	});
	Object.defineProperty(exports, "AccountBalanceOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AccountBalanceOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AccountBalanceRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AccountBalanceRounded.default;
	  }
	});
	Object.defineProperty(exports, "AccountBalanceSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AccountBalanceSharp.default;
	  }
	});
	Object.defineProperty(exports, "AccountBalanceTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AccountBalanceTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AccountBalanceWallet", {
	  enumerable: true,
	  get: function get() {
	    return _AccountBalanceWallet.default;
	  }
	});
	Object.defineProperty(exports, "AccountBalanceWalletOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AccountBalanceWalletOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AccountBalanceWalletRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AccountBalanceWalletRounded.default;
	  }
	});
	Object.defineProperty(exports, "AccountBalanceWalletSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AccountBalanceWalletSharp.default;
	  }
	});
	Object.defineProperty(exports, "AccountBalanceWalletTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AccountBalanceWalletTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AccountBox", {
	  enumerable: true,
	  get: function get() {
	    return _AccountBox.default;
	  }
	});
	Object.defineProperty(exports, "AccountBoxOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AccountBoxOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AccountBoxRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AccountBoxRounded.default;
	  }
	});
	Object.defineProperty(exports, "AccountBoxSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AccountBoxSharp.default;
	  }
	});
	Object.defineProperty(exports, "AccountBoxTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AccountBoxTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AccountCircle", {
	  enumerable: true,
	  get: function get() {
	    return _AccountCircle.default;
	  }
	});
	Object.defineProperty(exports, "AccountCircleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AccountCircleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AccountCircleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AccountCircleRounded.default;
	  }
	});
	Object.defineProperty(exports, "AccountCircleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AccountCircleSharp.default;
	  }
	});
	Object.defineProperty(exports, "AccountCircleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AccountCircleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AccountTree", {
	  enumerable: true,
	  get: function get() {
	    return _AccountTree.default;
	  }
	});
	Object.defineProperty(exports, "AccountTreeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AccountTreeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AccountTreeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AccountTreeRounded.default;
	  }
	});
	Object.defineProperty(exports, "AccountTreeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AccountTreeSharp.default;
	  }
	});
	Object.defineProperty(exports, "AccountTreeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AccountTreeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AcUnit", {
	  enumerable: true,
	  get: function get() {
	    return _AcUnit.default;
	  }
	});
	Object.defineProperty(exports, "AcUnitOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AcUnitOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AcUnitRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AcUnitRounded.default;
	  }
	});
	Object.defineProperty(exports, "AcUnitSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AcUnitSharp.default;
	  }
	});
	Object.defineProperty(exports, "AcUnitTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AcUnitTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Adb", {
	  enumerable: true,
	  get: function get() {
	    return _Adb.default;
	  }
	});
	Object.defineProperty(exports, "AdbOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AdbOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AdbRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AdbRounded.default;
	  }
	});
	Object.defineProperty(exports, "AdbSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AdbSharp.default;
	  }
	});
	Object.defineProperty(exports, "AdbTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AdbTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Add", {
	  enumerable: true,
	  get: function get() {
	    return _Add.default;
	  }
	});
	Object.defineProperty(exports, "AddAlarm", {
	  enumerable: true,
	  get: function get() {
	    return _AddAlarm.default;
	  }
	});
	Object.defineProperty(exports, "AddAlarmOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AddAlarmOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AddAlarmRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AddAlarmRounded.default;
	  }
	});
	Object.defineProperty(exports, "AddAlarmSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AddAlarmSharp.default;
	  }
	});
	Object.defineProperty(exports, "AddAlarmTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AddAlarmTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AddAlert", {
	  enumerable: true,
	  get: function get() {
	    return _AddAlert.default;
	  }
	});
	Object.defineProperty(exports, "AddAlertOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AddAlertOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AddAlertRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AddAlertRounded.default;
	  }
	});
	Object.defineProperty(exports, "AddAlertSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AddAlertSharp.default;
	  }
	});
	Object.defineProperty(exports, "AddAlertTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AddAlertTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AddAPhoto", {
	  enumerable: true,
	  get: function get() {
	    return _AddAPhoto.default;
	  }
	});
	Object.defineProperty(exports, "AddAPhotoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AddAPhotoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AddAPhotoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AddAPhotoRounded.default;
	  }
	});
	Object.defineProperty(exports, "AddAPhotoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AddAPhotoSharp.default;
	  }
	});
	Object.defineProperty(exports, "AddAPhotoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AddAPhotoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AddBox", {
	  enumerable: true,
	  get: function get() {
	    return _AddBox.default;
	  }
	});
	Object.defineProperty(exports, "AddBoxOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AddBoxOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AddBoxRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AddBoxRounded.default;
	  }
	});
	Object.defineProperty(exports, "AddBoxSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AddBoxSharp.default;
	  }
	});
	Object.defineProperty(exports, "AddBoxTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AddBoxTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AddCircle", {
	  enumerable: true,
	  get: function get() {
	    return _AddCircle.default;
	  }
	});
	Object.defineProperty(exports, "AddCircleOutline", {
	  enumerable: true,
	  get: function get() {
	    return _AddCircleOutline.default;
	  }
	});
	Object.defineProperty(exports, "AddCircleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AddCircleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AddCircleOutlineOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AddCircleOutlineOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AddCircleOutlineRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AddCircleOutlineRounded.default;
	  }
	});
	Object.defineProperty(exports, "AddCircleOutlineSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AddCircleOutlineSharp.default;
	  }
	});
	Object.defineProperty(exports, "AddCircleOutlineTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AddCircleOutlineTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AddCircleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AddCircleRounded.default;
	  }
	});
	Object.defineProperty(exports, "AddCircleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AddCircleSharp.default;
	  }
	});
	Object.defineProperty(exports, "AddCircleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AddCircleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AddComment", {
	  enumerable: true,
	  get: function get() {
	    return _AddComment.default;
	  }
	});
	Object.defineProperty(exports, "AddCommentOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AddCommentOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AddCommentRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AddCommentRounded.default;
	  }
	});
	Object.defineProperty(exports, "AddCommentSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AddCommentSharp.default;
	  }
	});
	Object.defineProperty(exports, "AddCommentTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AddCommentTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AddIcCall", {
	  enumerable: true,
	  get: function get() {
	    return _AddIcCall.default;
	  }
	});
	Object.defineProperty(exports, "AddIcCallOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AddIcCallOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AddIcCallRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AddIcCallRounded.default;
	  }
	});
	Object.defineProperty(exports, "AddIcCallSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AddIcCallSharp.default;
	  }
	});
	Object.defineProperty(exports, "AddIcCallTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AddIcCallTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AddLocation", {
	  enumerable: true,
	  get: function get() {
	    return _AddLocation.default;
	  }
	});
	Object.defineProperty(exports, "AddLocationOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AddLocationOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AddLocationRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AddLocationRounded.default;
	  }
	});
	Object.defineProperty(exports, "AddLocationSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AddLocationSharp.default;
	  }
	});
	Object.defineProperty(exports, "AddLocationTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AddLocationTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AddOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AddOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AddPhotoAlternate", {
	  enumerable: true,
	  get: function get() {
	    return _AddPhotoAlternate.default;
	  }
	});
	Object.defineProperty(exports, "AddPhotoAlternateOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AddPhotoAlternateOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AddPhotoAlternateRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AddPhotoAlternateRounded.default;
	  }
	});
	Object.defineProperty(exports, "AddPhotoAlternateSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AddPhotoAlternateSharp.default;
	  }
	});
	Object.defineProperty(exports, "AddPhotoAlternateTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AddPhotoAlternateTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AddRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AddRounded.default;
	  }
	});
	Object.defineProperty(exports, "AddSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AddSharp.default;
	  }
	});
	Object.defineProperty(exports, "AddShoppingCart", {
	  enumerable: true,
	  get: function get() {
	    return _AddShoppingCart.default;
	  }
	});
	Object.defineProperty(exports, "AddShoppingCartOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AddShoppingCartOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AddShoppingCartRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AddShoppingCartRounded.default;
	  }
	});
	Object.defineProperty(exports, "AddShoppingCartSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AddShoppingCartSharp.default;
	  }
	});
	Object.defineProperty(exports, "AddShoppingCartTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AddShoppingCartTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AddToHomeScreen", {
	  enumerable: true,
	  get: function get() {
	    return _AddToHomeScreen.default;
	  }
	});
	Object.defineProperty(exports, "AddToHomeScreenOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AddToHomeScreenOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AddToHomeScreenRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AddToHomeScreenRounded.default;
	  }
	});
	Object.defineProperty(exports, "AddToHomeScreenSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AddToHomeScreenSharp.default;
	  }
	});
	Object.defineProperty(exports, "AddToHomeScreenTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AddToHomeScreenTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AddToPhotos", {
	  enumerable: true,
	  get: function get() {
	    return _AddToPhotos.default;
	  }
	});
	Object.defineProperty(exports, "AddToPhotosOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AddToPhotosOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AddToPhotosRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AddToPhotosRounded.default;
	  }
	});
	Object.defineProperty(exports, "AddToPhotosSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AddToPhotosSharp.default;
	  }
	});
	Object.defineProperty(exports, "AddToPhotosTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AddToPhotosTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AddToQueue", {
	  enumerable: true,
	  get: function get() {
	    return _AddToQueue.default;
	  }
	});
	Object.defineProperty(exports, "AddToQueueOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AddToQueueOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AddToQueueRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AddToQueueRounded.default;
	  }
	});
	Object.defineProperty(exports, "AddToQueueSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AddToQueueSharp.default;
	  }
	});
	Object.defineProperty(exports, "AddToQueueTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AddToQueueTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AddTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AddTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Adjust", {
	  enumerable: true,
	  get: function get() {
	    return _Adjust.default;
	  }
	});
	Object.defineProperty(exports, "AdjustOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AdjustOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AdjustRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AdjustRounded.default;
	  }
	});
	Object.defineProperty(exports, "AdjustSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AdjustSharp.default;
	  }
	});
	Object.defineProperty(exports, "AdjustTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AdjustTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatFlat", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatFlat.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatFlatAngled", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatFlatAngled.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatFlatAngledOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatFlatAngledOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatFlatAngledRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatFlatAngledRounded.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatFlatAngledSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatFlatAngledSharp.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatFlatAngledTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatFlatAngledTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatFlatOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatFlatOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatFlatRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatFlatRounded.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatFlatSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatFlatSharp.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatFlatTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatFlatTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatIndividualSuite", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatIndividualSuite.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatIndividualSuiteOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatIndividualSuiteOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatIndividualSuiteRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatIndividualSuiteRounded.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatIndividualSuiteSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatIndividualSuiteSharp.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatIndividualSuiteTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatIndividualSuiteTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatLegroomExtra", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatLegroomExtra.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatLegroomExtraOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatLegroomExtraOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatLegroomExtraRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatLegroomExtraRounded.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatLegroomExtraSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatLegroomExtraSharp.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatLegroomExtraTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatLegroomExtraTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatLegroomNormal", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatLegroomNormal.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatLegroomNormalOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatLegroomNormalOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatLegroomNormalRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatLegroomNormalRounded.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatLegroomNormalSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatLegroomNormalSharp.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatLegroomNormalTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatLegroomNormalTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatLegroomReduced", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatLegroomReduced.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatLegroomReducedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatLegroomReducedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatLegroomReducedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatLegroomReducedRounded.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatLegroomReducedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatLegroomReducedSharp.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatLegroomReducedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatLegroomReducedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatReclineExtra", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatReclineExtra.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatReclineExtraOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatReclineExtraOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatReclineExtraRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatReclineExtraRounded.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatReclineExtraSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatReclineExtraSharp.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatReclineExtraTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatReclineExtraTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatReclineNormal", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatReclineNormal.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatReclineNormalOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatReclineNormalOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatReclineNormalRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatReclineNormalRounded.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatReclineNormalSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatReclineNormalSharp.default;
	  }
	});
	Object.defineProperty(exports, "AirlineSeatReclineNormalTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AirlineSeatReclineNormalTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AirplanemodeActive", {
	  enumerable: true,
	  get: function get() {
	    return _AirplanemodeActive.default;
	  }
	});
	Object.defineProperty(exports, "AirplanemodeActiveOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AirplanemodeActiveOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AirplanemodeActiveRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AirplanemodeActiveRounded.default;
	  }
	});
	Object.defineProperty(exports, "AirplanemodeActiveSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AirplanemodeActiveSharp.default;
	  }
	});
	Object.defineProperty(exports, "AirplanemodeActiveTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AirplanemodeActiveTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AirplanemodeInactive", {
	  enumerable: true,
	  get: function get() {
	    return _AirplanemodeInactive.default;
	  }
	});
	Object.defineProperty(exports, "AirplanemodeInactiveOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AirplanemodeInactiveOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AirplanemodeInactiveRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AirplanemodeInactiveRounded.default;
	  }
	});
	Object.defineProperty(exports, "AirplanemodeInactiveSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AirplanemodeInactiveSharp.default;
	  }
	});
	Object.defineProperty(exports, "AirplanemodeInactiveTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AirplanemodeInactiveTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Airplay", {
	  enumerable: true,
	  get: function get() {
	    return _Airplay.default;
	  }
	});
	Object.defineProperty(exports, "AirplayOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AirplayOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AirplayRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AirplayRounded.default;
	  }
	});
	Object.defineProperty(exports, "AirplaySharp", {
	  enumerable: true,
	  get: function get() {
	    return _AirplaySharp.default;
	  }
	});
	Object.defineProperty(exports, "AirplayTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AirplayTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AirportShuttle", {
	  enumerable: true,
	  get: function get() {
	    return _AirportShuttle.default;
	  }
	});
	Object.defineProperty(exports, "AirportShuttleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AirportShuttleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AirportShuttleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AirportShuttleRounded.default;
	  }
	});
	Object.defineProperty(exports, "AirportShuttleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AirportShuttleSharp.default;
	  }
	});
	Object.defineProperty(exports, "AirportShuttleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AirportShuttleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Alarm", {
	  enumerable: true,
	  get: function get() {
	    return _Alarm.default;
	  }
	});
	Object.defineProperty(exports, "AlarmAdd", {
	  enumerable: true,
	  get: function get() {
	    return _AlarmAdd.default;
	  }
	});
	Object.defineProperty(exports, "AlarmAddOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AlarmAddOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AlarmAddRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AlarmAddRounded.default;
	  }
	});
	Object.defineProperty(exports, "AlarmAddSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AlarmAddSharp.default;
	  }
	});
	Object.defineProperty(exports, "AlarmAddTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AlarmAddTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AlarmOff", {
	  enumerable: true,
	  get: function get() {
	    return _AlarmOff.default;
	  }
	});
	Object.defineProperty(exports, "AlarmOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AlarmOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AlarmOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AlarmOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "AlarmOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AlarmOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "AlarmOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AlarmOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AlarmOn", {
	  enumerable: true,
	  get: function get() {
	    return _AlarmOn.default;
	  }
	});
	Object.defineProperty(exports, "AlarmOnOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AlarmOnOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AlarmOnRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AlarmOnRounded.default;
	  }
	});
	Object.defineProperty(exports, "AlarmOnSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AlarmOnSharp.default;
	  }
	});
	Object.defineProperty(exports, "AlarmOnTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AlarmOnTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AlarmOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AlarmOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AlarmRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AlarmRounded.default;
	  }
	});
	Object.defineProperty(exports, "AlarmSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AlarmSharp.default;
	  }
	});
	Object.defineProperty(exports, "AlarmTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AlarmTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Album", {
	  enumerable: true,
	  get: function get() {
	    return _Album.default;
	  }
	});
	Object.defineProperty(exports, "AlbumOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AlbumOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AlbumRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AlbumRounded.default;
	  }
	});
	Object.defineProperty(exports, "AlbumSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AlbumSharp.default;
	  }
	});
	Object.defineProperty(exports, "AlbumTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AlbumTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AllInbox", {
	  enumerable: true,
	  get: function get() {
	    return _AllInbox.default;
	  }
	});
	Object.defineProperty(exports, "AllInboxOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AllInboxOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AllInboxRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AllInboxRounded.default;
	  }
	});
	Object.defineProperty(exports, "AllInboxSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AllInboxSharp.default;
	  }
	});
	Object.defineProperty(exports, "AllInboxTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AllInboxTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AllInclusive", {
	  enumerable: true,
	  get: function get() {
	    return _AllInclusive.default;
	  }
	});
	Object.defineProperty(exports, "AllInclusiveOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AllInclusiveOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AllInclusiveRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AllInclusiveRounded.default;
	  }
	});
	Object.defineProperty(exports, "AllInclusiveSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AllInclusiveSharp.default;
	  }
	});
	Object.defineProperty(exports, "AllInclusiveTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AllInclusiveTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AllOut", {
	  enumerable: true,
	  get: function get() {
	    return _AllOut.default;
	  }
	});
	Object.defineProperty(exports, "AllOutOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AllOutOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AllOutRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AllOutRounded.default;
	  }
	});
	Object.defineProperty(exports, "AllOutSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AllOutSharp.default;
	  }
	});
	Object.defineProperty(exports, "AllOutTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AllOutTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AlternateEmail", {
	  enumerable: true,
	  get: function get() {
	    return _AlternateEmail.default;
	  }
	});
	Object.defineProperty(exports, "AlternateEmailOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AlternateEmailOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AlternateEmailRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AlternateEmailRounded.default;
	  }
	});
	Object.defineProperty(exports, "AlternateEmailSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AlternateEmailSharp.default;
	  }
	});
	Object.defineProperty(exports, "AlternateEmailTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AlternateEmailTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AmpStories", {
	  enumerable: true,
	  get: function get() {
	    return _AmpStories.default;
	  }
	});
	Object.defineProperty(exports, "AmpStoriesOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AmpStoriesOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AmpStoriesRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AmpStoriesRounded.default;
	  }
	});
	Object.defineProperty(exports, "AmpStoriesSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AmpStoriesSharp.default;
	  }
	});
	Object.defineProperty(exports, "AmpStoriesTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AmpStoriesTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Android", {
	  enumerable: true,
	  get: function get() {
	    return _Android.default;
	  }
	});
	Object.defineProperty(exports, "AndroidOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AndroidOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AndroidRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AndroidRounded.default;
	  }
	});
	Object.defineProperty(exports, "AndroidSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AndroidSharp.default;
	  }
	});
	Object.defineProperty(exports, "AndroidTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AndroidTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Announcement", {
	  enumerable: true,
	  get: function get() {
	    return _Announcement.default;
	  }
	});
	Object.defineProperty(exports, "AnnouncementOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AnnouncementOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AnnouncementRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AnnouncementRounded.default;
	  }
	});
	Object.defineProperty(exports, "AnnouncementSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AnnouncementSharp.default;
	  }
	});
	Object.defineProperty(exports, "AnnouncementTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AnnouncementTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Apartment", {
	  enumerable: true,
	  get: function get() {
	    return _Apartment.default;
	  }
	});
	Object.defineProperty(exports, "ApartmentOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ApartmentOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ApartmentRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ApartmentRounded.default;
	  }
	});
	Object.defineProperty(exports, "ApartmentSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ApartmentSharp.default;
	  }
	});
	Object.defineProperty(exports, "ApartmentTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ApartmentTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Apple", {
	  enumerable: true,
	  get: function get() {
	    return _Apple.default;
	  }
	});
	Object.defineProperty(exports, "Apps", {
	  enumerable: true,
	  get: function get() {
	    return _Apps.default;
	  }
	});
	Object.defineProperty(exports, "AppsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AppsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AppsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AppsRounded.default;
	  }
	});
	Object.defineProperty(exports, "AppsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AppsSharp.default;
	  }
	});
	Object.defineProperty(exports, "AppsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AppsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Archive", {
	  enumerable: true,
	  get: function get() {
	    return _Archive.default;
	  }
	});
	Object.defineProperty(exports, "ArchiveOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ArchiveOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ArchiveRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ArchiveRounded.default;
	  }
	});
	Object.defineProperty(exports, "ArchiveSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ArchiveSharp.default;
	  }
	});
	Object.defineProperty(exports, "ArchiveTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ArchiveTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ArrowBack", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowBack.default;
	  }
	});
	Object.defineProperty(exports, "ArrowBackIos", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowBackIos.default;
	  }
	});
	Object.defineProperty(exports, "ArrowBackIosOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowBackIosOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ArrowBackIosRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowBackIosRounded.default;
	  }
	});
	Object.defineProperty(exports, "ArrowBackIosSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowBackIosSharp.default;
	  }
	});
	Object.defineProperty(exports, "ArrowBackIosTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowBackIosTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ArrowBackOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowBackOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ArrowBackRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowBackRounded.default;
	  }
	});
	Object.defineProperty(exports, "ArrowBackSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowBackSharp.default;
	  }
	});
	Object.defineProperty(exports, "ArrowBackTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowBackTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ArrowDownward", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowDownward.default;
	  }
	});
	Object.defineProperty(exports, "ArrowDownwardOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowDownwardOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ArrowDownwardRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowDownwardRounded.default;
	  }
	});
	Object.defineProperty(exports, "ArrowDownwardSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowDownwardSharp.default;
	  }
	});
	Object.defineProperty(exports, "ArrowDownwardTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowDownwardTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ArrowDropDown", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowDropDown.default;
	  }
	});
	Object.defineProperty(exports, "ArrowDropDownCircle", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowDropDownCircle.default;
	  }
	});
	Object.defineProperty(exports, "ArrowDropDownCircleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowDropDownCircleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ArrowDropDownCircleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowDropDownCircleRounded.default;
	  }
	});
	Object.defineProperty(exports, "ArrowDropDownCircleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowDropDownCircleSharp.default;
	  }
	});
	Object.defineProperty(exports, "ArrowDropDownCircleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowDropDownCircleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ArrowDropDownOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowDropDownOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ArrowDropDownRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowDropDownRounded.default;
	  }
	});
	Object.defineProperty(exports, "ArrowDropDownSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowDropDownSharp.default;
	  }
	});
	Object.defineProperty(exports, "ArrowDropDownTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowDropDownTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ArrowDropUp", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowDropUp.default;
	  }
	});
	Object.defineProperty(exports, "ArrowDropUpOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowDropUpOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ArrowDropUpRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowDropUpRounded.default;
	  }
	});
	Object.defineProperty(exports, "ArrowDropUpSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowDropUpSharp.default;
	  }
	});
	Object.defineProperty(exports, "ArrowDropUpTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowDropUpTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ArrowForward", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowForward.default;
	  }
	});
	Object.defineProperty(exports, "ArrowForwardIos", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowForwardIos.default;
	  }
	});
	Object.defineProperty(exports, "ArrowForwardIosOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowForwardIosOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ArrowForwardIosRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowForwardIosRounded.default;
	  }
	});
	Object.defineProperty(exports, "ArrowForwardIosSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowForwardIosSharp.default;
	  }
	});
	Object.defineProperty(exports, "ArrowForwardIosTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowForwardIosTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ArrowForwardOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowForwardOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ArrowForwardRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowForwardRounded.default;
	  }
	});
	Object.defineProperty(exports, "ArrowForwardSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowForwardSharp.default;
	  }
	});
	Object.defineProperty(exports, "ArrowForwardTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowForwardTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ArrowLeft", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowLeft.default;
	  }
	});
	Object.defineProperty(exports, "ArrowLeftOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowLeftOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ArrowLeftRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowLeftRounded.default;
	  }
	});
	Object.defineProperty(exports, "ArrowLeftSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowLeftSharp.default;
	  }
	});
	Object.defineProperty(exports, "ArrowLeftTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowLeftTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ArrowRight", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowRight.default;
	  }
	});
	Object.defineProperty(exports, "ArrowRightAlt", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowRightAlt.default;
	  }
	});
	Object.defineProperty(exports, "ArrowRightAltOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowRightAltOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ArrowRightAltRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowRightAltRounded.default;
	  }
	});
	Object.defineProperty(exports, "ArrowRightAltSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowRightAltSharp.default;
	  }
	});
	Object.defineProperty(exports, "ArrowRightAltTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowRightAltTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ArrowRightOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowRightOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ArrowRightRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowRightRounded.default;
	  }
	});
	Object.defineProperty(exports, "ArrowRightSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowRightSharp.default;
	  }
	});
	Object.defineProperty(exports, "ArrowRightTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowRightTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ArrowUpward", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowUpward.default;
	  }
	});
	Object.defineProperty(exports, "ArrowUpwardOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowUpwardOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ArrowUpwardRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowUpwardRounded.default;
	  }
	});
	Object.defineProperty(exports, "ArrowUpwardSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowUpwardSharp.default;
	  }
	});
	Object.defineProperty(exports, "ArrowUpwardTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ArrowUpwardTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ArtTrack", {
	  enumerable: true,
	  get: function get() {
	    return _ArtTrack.default;
	  }
	});
	Object.defineProperty(exports, "ArtTrackOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ArtTrackOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ArtTrackRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ArtTrackRounded.default;
	  }
	});
	Object.defineProperty(exports, "ArtTrackSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ArtTrackSharp.default;
	  }
	});
	Object.defineProperty(exports, "ArtTrackTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ArtTrackTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AspectRatio", {
	  enumerable: true,
	  get: function get() {
	    return _AspectRatio.default;
	  }
	});
	Object.defineProperty(exports, "AspectRatioOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AspectRatioOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AspectRatioRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AspectRatioRounded.default;
	  }
	});
	Object.defineProperty(exports, "AspectRatioSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AspectRatioSharp.default;
	  }
	});
	Object.defineProperty(exports, "AspectRatioTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AspectRatioTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Assessment", {
	  enumerable: true,
	  get: function get() {
	    return _Assessment.default;
	  }
	});
	Object.defineProperty(exports, "AssessmentOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AssessmentOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AssessmentRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AssessmentRounded.default;
	  }
	});
	Object.defineProperty(exports, "AssessmentSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AssessmentSharp.default;
	  }
	});
	Object.defineProperty(exports, "AssessmentTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AssessmentTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Assignment", {
	  enumerable: true,
	  get: function get() {
	    return _Assignment.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentInd", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentInd.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentIndOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentIndOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentIndRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentIndRounded.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentIndSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentIndSharp.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentIndTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentIndTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentLate", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentLate.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentLateOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentLateOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentLateRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentLateRounded.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentLateSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentLateSharp.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentLateTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentLateTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentReturn", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentReturn.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentReturned", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentReturned.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentReturnedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentReturnedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentReturnedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentReturnedRounded.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentReturnedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentReturnedSharp.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentReturnedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentReturnedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentReturnOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentReturnOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentReturnRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentReturnRounded.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentReturnSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentReturnSharp.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentReturnTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentReturnTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentRounded.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentSharp.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentTurnedIn", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentTurnedIn.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentTurnedInOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentTurnedInOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentTurnedInRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentTurnedInRounded.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentTurnedInSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentTurnedInSharp.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentTurnedInTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentTurnedInTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AssignmentTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AssignmentTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Assistant", {
	  enumerable: true,
	  get: function get() {
	    return _Assistant.default;
	  }
	});
	Object.defineProperty(exports, "AssistantOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AssistantOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AssistantPhoto", {
	  enumerable: true,
	  get: function get() {
	    return _AssistantPhoto.default;
	  }
	});
	Object.defineProperty(exports, "AssistantPhotoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AssistantPhotoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AssistantPhotoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AssistantPhotoRounded.default;
	  }
	});
	Object.defineProperty(exports, "AssistantPhotoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AssistantPhotoSharp.default;
	  }
	});
	Object.defineProperty(exports, "AssistantPhotoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AssistantPhotoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AssistantRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AssistantRounded.default;
	  }
	});
	Object.defineProperty(exports, "AssistantSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AssistantSharp.default;
	  }
	});
	Object.defineProperty(exports, "AssistantTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AssistantTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Atm", {
	  enumerable: true,
	  get: function get() {
	    return _Atm.default;
	  }
	});
	Object.defineProperty(exports, "AtmOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AtmOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AtmRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AtmRounded.default;
	  }
	});
	Object.defineProperty(exports, "AtmSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AtmSharp.default;
	  }
	});
	Object.defineProperty(exports, "AtmTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AtmTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AttachFile", {
	  enumerable: true,
	  get: function get() {
	    return _AttachFile.default;
	  }
	});
	Object.defineProperty(exports, "AttachFileOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AttachFileOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AttachFileRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AttachFileRounded.default;
	  }
	});
	Object.defineProperty(exports, "AttachFileSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AttachFileSharp.default;
	  }
	});
	Object.defineProperty(exports, "AttachFileTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AttachFileTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Attachment", {
	  enumerable: true,
	  get: function get() {
	    return _Attachment.default;
	  }
	});
	Object.defineProperty(exports, "AttachmentOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AttachmentOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AttachmentRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AttachmentRounded.default;
	  }
	});
	Object.defineProperty(exports, "AttachmentSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AttachmentSharp.default;
	  }
	});
	Object.defineProperty(exports, "AttachmentTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AttachmentTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AttachMoney", {
	  enumerable: true,
	  get: function get() {
	    return _AttachMoney.default;
	  }
	});
	Object.defineProperty(exports, "AttachMoneyOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AttachMoneyOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AttachMoneyRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AttachMoneyRounded.default;
	  }
	});
	Object.defineProperty(exports, "AttachMoneySharp", {
	  enumerable: true,
	  get: function get() {
	    return _AttachMoneySharp.default;
	  }
	});
	Object.defineProperty(exports, "AttachMoneyTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AttachMoneyTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Audiotrack", {
	  enumerable: true,
	  get: function get() {
	    return _Audiotrack.default;
	  }
	});
	Object.defineProperty(exports, "AudiotrackOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AudiotrackOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AudiotrackRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AudiotrackRounded.default;
	  }
	});
	Object.defineProperty(exports, "AudiotrackSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AudiotrackSharp.default;
	  }
	});
	Object.defineProperty(exports, "AudiotrackTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AudiotrackTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Autorenew", {
	  enumerable: true,
	  get: function get() {
	    return _Autorenew.default;
	  }
	});
	Object.defineProperty(exports, "AutorenewOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AutorenewOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AutorenewRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AutorenewRounded.default;
	  }
	});
	Object.defineProperty(exports, "AutorenewSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AutorenewSharp.default;
	  }
	});
	Object.defineProperty(exports, "AutorenewTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AutorenewTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "AvTimer", {
	  enumerable: true,
	  get: function get() {
	    return _AvTimer.default;
	  }
	});
	Object.defineProperty(exports, "AvTimerOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _AvTimerOutlined.default;
	  }
	});
	Object.defineProperty(exports, "AvTimerRounded", {
	  enumerable: true,
	  get: function get() {
	    return _AvTimerRounded.default;
	  }
	});
	Object.defineProperty(exports, "AvTimerSharp", {
	  enumerable: true,
	  get: function get() {
	    return _AvTimerSharp.default;
	  }
	});
	Object.defineProperty(exports, "AvTimerTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _AvTimerTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Backspace", {
	  enumerable: true,
	  get: function get() {
	    return _Backspace.default;
	  }
	});
	Object.defineProperty(exports, "BackspaceOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BackspaceOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BackspaceRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BackspaceRounded.default;
	  }
	});
	Object.defineProperty(exports, "BackspaceSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BackspaceSharp.default;
	  }
	});
	Object.defineProperty(exports, "BackspaceTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BackspaceTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Backup", {
	  enumerable: true,
	  get: function get() {
	    return _Backup.default;
	  }
	});
	Object.defineProperty(exports, "BackupOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BackupOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BackupRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BackupRounded.default;
	  }
	});
	Object.defineProperty(exports, "BackupSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BackupSharp.default;
	  }
	});
	Object.defineProperty(exports, "BackupTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BackupTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Ballot", {
	  enumerable: true,
	  get: function get() {
	    return _Ballot.default;
	  }
	});
	Object.defineProperty(exports, "BallotOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BallotOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BallotRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BallotRounded.default;
	  }
	});
	Object.defineProperty(exports, "BallotSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BallotSharp.default;
	  }
	});
	Object.defineProperty(exports, "BallotTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BallotTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BarChart", {
	  enumerable: true,
	  get: function get() {
	    return _BarChart.default;
	  }
	});
	Object.defineProperty(exports, "BarChartOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BarChartOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BarChartRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BarChartRounded.default;
	  }
	});
	Object.defineProperty(exports, "BarChartSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BarChartSharp.default;
	  }
	});
	Object.defineProperty(exports, "BarChartTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BarChartTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Bathtub", {
	  enumerable: true,
	  get: function get() {
	    return _Bathtub.default;
	  }
	});
	Object.defineProperty(exports, "BathtubOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BathtubOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BathtubRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BathtubRounded.default;
	  }
	});
	Object.defineProperty(exports, "BathtubSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BathtubSharp.default;
	  }
	});
	Object.defineProperty(exports, "BathtubTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BathtubTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Battery20", {
	  enumerable: true,
	  get: function get() {
	    return _Battery.default;
	  }
	});
	Object.defineProperty(exports, "Battery20Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Battery20Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Battery20Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Battery20Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Battery20Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Battery20Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Battery20TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Battery20TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Battery30", {
	  enumerable: true,
	  get: function get() {
	    return _Battery2.default;
	  }
	});
	Object.defineProperty(exports, "Battery30Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Battery30Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Battery30Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Battery30Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Battery30Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Battery30Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Battery30TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Battery30TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Battery50", {
	  enumerable: true,
	  get: function get() {
	    return _Battery3.default;
	  }
	});
	Object.defineProperty(exports, "Battery50Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Battery50Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Battery50Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Battery50Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Battery50Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Battery50Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Battery50TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Battery50TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Battery60", {
	  enumerable: true,
	  get: function get() {
	    return _Battery4.default;
	  }
	});
	Object.defineProperty(exports, "Battery60Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Battery60Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Battery60Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Battery60Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Battery60Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Battery60Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Battery60TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Battery60TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Battery80", {
	  enumerable: true,
	  get: function get() {
	    return _Battery5.default;
	  }
	});
	Object.defineProperty(exports, "Battery80Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Battery80Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Battery80Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Battery80Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Battery80Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Battery80Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Battery80TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Battery80TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Battery90", {
	  enumerable: true,
	  get: function get() {
	    return _Battery6.default;
	  }
	});
	Object.defineProperty(exports, "Battery90Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Battery90Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Battery90Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Battery90Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Battery90Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Battery90Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Battery90TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Battery90TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BatteryAlert", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryAlert.default;
	  }
	});
	Object.defineProperty(exports, "BatteryAlertOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryAlertOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BatteryAlertRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryAlertRounded.default;
	  }
	});
	Object.defineProperty(exports, "BatteryAlertSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryAlertSharp.default;
	  }
	});
	Object.defineProperty(exports, "BatteryAlertTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryAlertTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging20", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging20Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging20Outlined.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging20Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging20Rounded.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging20Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging20Sharp.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging20TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging20TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging30", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging2.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging30Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging30Outlined.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging30Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging30Rounded.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging30Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging30Sharp.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging30TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging30TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging50", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging3.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging50Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging50Outlined.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging50Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging50Rounded.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging50Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging50Sharp.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging50TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging50TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging60", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging4.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging60Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging60Outlined.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging60Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging60Rounded.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging60Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging60Sharp.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging60TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging60TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging80", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging5.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging80Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging80Outlined.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging80Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging80Rounded.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging80Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging80Sharp.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging80TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging80TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging90", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging6.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging90Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging90Outlined.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging90Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging90Rounded.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging90Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging90Sharp.default;
	  }
	});
	Object.defineProperty(exports, "BatteryCharging90TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryCharging90TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BatteryChargingFull", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryChargingFull.default;
	  }
	});
	Object.defineProperty(exports, "BatteryChargingFullOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryChargingFullOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BatteryChargingFullRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryChargingFullRounded.default;
	  }
	});
	Object.defineProperty(exports, "BatteryChargingFullSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryChargingFullSharp.default;
	  }
	});
	Object.defineProperty(exports, "BatteryChargingFullTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryChargingFullTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BatteryFull", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryFull.default;
	  }
	});
	Object.defineProperty(exports, "BatteryFullOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryFullOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BatteryFullRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryFullRounded.default;
	  }
	});
	Object.defineProperty(exports, "BatteryFullSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryFullSharp.default;
	  }
	});
	Object.defineProperty(exports, "BatteryFullTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryFullTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BatteryStd", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryStd.default;
	  }
	});
	Object.defineProperty(exports, "BatteryStdOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryStdOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BatteryStdRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryStdRounded.default;
	  }
	});
	Object.defineProperty(exports, "BatteryStdSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryStdSharp.default;
	  }
	});
	Object.defineProperty(exports, "BatteryStdTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryStdTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BatteryUnknown", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryUnknown.default;
	  }
	});
	Object.defineProperty(exports, "BatteryUnknownOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryUnknownOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BatteryUnknownRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryUnknownRounded.default;
	  }
	});
	Object.defineProperty(exports, "BatteryUnknownSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryUnknownSharp.default;
	  }
	});
	Object.defineProperty(exports, "BatteryUnknownTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BatteryUnknownTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BeachAccess", {
	  enumerable: true,
	  get: function get() {
	    return _BeachAccess.default;
	  }
	});
	Object.defineProperty(exports, "BeachAccessOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BeachAccessOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BeachAccessRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BeachAccessRounded.default;
	  }
	});
	Object.defineProperty(exports, "BeachAccessSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BeachAccessSharp.default;
	  }
	});
	Object.defineProperty(exports, "BeachAccessTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BeachAccessTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Beenhere", {
	  enumerable: true,
	  get: function get() {
	    return _Beenhere.default;
	  }
	});
	Object.defineProperty(exports, "BeenhereOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BeenhereOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BeenhereRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BeenhereRounded.default;
	  }
	});
	Object.defineProperty(exports, "BeenhereSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BeenhereSharp.default;
	  }
	});
	Object.defineProperty(exports, "BeenhereTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BeenhereTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Block", {
	  enumerable: true,
	  get: function get() {
	    return _Block.default;
	  }
	});
	Object.defineProperty(exports, "BlockOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BlockOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BlockRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BlockRounded.default;
	  }
	});
	Object.defineProperty(exports, "BlockSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BlockSharp.default;
	  }
	});
	Object.defineProperty(exports, "BlockTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BlockTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Bluetooth", {
	  enumerable: true,
	  get: function get() {
	    return _Bluetooth.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothAudio", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothAudio.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothAudioOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothAudioOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothAudioRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothAudioRounded.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothAudioSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothAudioSharp.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothAudioTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothAudioTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothConnected", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothConnected.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothConnectedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothConnectedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothConnectedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothConnectedRounded.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothConnectedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothConnectedSharp.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothConnectedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothConnectedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothDisabled", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothDisabled.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothDisabledOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothDisabledOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothDisabledRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothDisabledRounded.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothDisabledSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothDisabledSharp.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothDisabledTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothDisabledTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothRounded.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothSearching", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothSearching.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothSearchingOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothSearchingOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothSearchingRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothSearchingRounded.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothSearchingSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothSearchingSharp.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothSearchingTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothSearchingTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothSharp.default;
	  }
	});
	Object.defineProperty(exports, "BluetoothTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BluetoothTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BlurCircular", {
	  enumerable: true,
	  get: function get() {
	    return _BlurCircular.default;
	  }
	});
	Object.defineProperty(exports, "BlurCircularOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BlurCircularOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BlurCircularRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BlurCircularRounded.default;
	  }
	});
	Object.defineProperty(exports, "BlurCircularSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BlurCircularSharp.default;
	  }
	});
	Object.defineProperty(exports, "BlurCircularTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BlurCircularTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BlurLinear", {
	  enumerable: true,
	  get: function get() {
	    return _BlurLinear.default;
	  }
	});
	Object.defineProperty(exports, "BlurLinearOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BlurLinearOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BlurLinearRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BlurLinearRounded.default;
	  }
	});
	Object.defineProperty(exports, "BlurLinearSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BlurLinearSharp.default;
	  }
	});
	Object.defineProperty(exports, "BlurLinearTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BlurLinearTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BlurOff", {
	  enumerable: true,
	  get: function get() {
	    return _BlurOff.default;
	  }
	});
	Object.defineProperty(exports, "BlurOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BlurOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BlurOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BlurOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "BlurOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BlurOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "BlurOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BlurOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BlurOn", {
	  enumerable: true,
	  get: function get() {
	    return _BlurOn.default;
	  }
	});
	Object.defineProperty(exports, "BlurOnOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BlurOnOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BlurOnRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BlurOnRounded.default;
	  }
	});
	Object.defineProperty(exports, "BlurOnSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BlurOnSharp.default;
	  }
	});
	Object.defineProperty(exports, "BlurOnTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BlurOnTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Book", {
	  enumerable: true,
	  get: function get() {
	    return _Book.default;
	  }
	});
	Object.defineProperty(exports, "Bookmark", {
	  enumerable: true,
	  get: function get() {
	    return _Bookmark.default;
	  }
	});
	Object.defineProperty(exports, "BookmarkBorder", {
	  enumerable: true,
	  get: function get() {
	    return _BookmarkBorder.default;
	  }
	});
	Object.defineProperty(exports, "BookmarkBorderOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BookmarkBorderOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BookmarkBorderRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BookmarkBorderRounded.default;
	  }
	});
	Object.defineProperty(exports, "BookmarkBorderSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BookmarkBorderSharp.default;
	  }
	});
	Object.defineProperty(exports, "BookmarkBorderTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BookmarkBorderTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BookmarkOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BookmarkOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BookmarkRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BookmarkRounded.default;
	  }
	});
	Object.defineProperty(exports, "Bookmarks", {
	  enumerable: true,
	  get: function get() {
	    return _Bookmarks.default;
	  }
	});
	Object.defineProperty(exports, "BookmarkSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BookmarkSharp.default;
	  }
	});
	Object.defineProperty(exports, "BookmarksOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BookmarksOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BookmarksRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BookmarksRounded.default;
	  }
	});
	Object.defineProperty(exports, "BookmarksSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BookmarksSharp.default;
	  }
	});
	Object.defineProperty(exports, "BookmarksTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BookmarksTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BookmarkTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BookmarkTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BookOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BookOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BookRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BookRounded.default;
	  }
	});
	Object.defineProperty(exports, "BookSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BookSharp.default;
	  }
	});
	Object.defineProperty(exports, "BookTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BookTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BorderAll", {
	  enumerable: true,
	  get: function get() {
	    return _BorderAll.default;
	  }
	});
	Object.defineProperty(exports, "BorderAllOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BorderAllOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BorderAllRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BorderAllRounded.default;
	  }
	});
	Object.defineProperty(exports, "BorderAllSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BorderAllSharp.default;
	  }
	});
	Object.defineProperty(exports, "BorderAllTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BorderAllTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BorderBottom", {
	  enumerable: true,
	  get: function get() {
	    return _BorderBottom.default;
	  }
	});
	Object.defineProperty(exports, "BorderBottomOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BorderBottomOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BorderBottomRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BorderBottomRounded.default;
	  }
	});
	Object.defineProperty(exports, "BorderBottomSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BorderBottomSharp.default;
	  }
	});
	Object.defineProperty(exports, "BorderBottomTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BorderBottomTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BorderClear", {
	  enumerable: true,
	  get: function get() {
	    return _BorderClear.default;
	  }
	});
	Object.defineProperty(exports, "BorderClearOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BorderClearOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BorderClearRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BorderClearRounded.default;
	  }
	});
	Object.defineProperty(exports, "BorderClearSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BorderClearSharp.default;
	  }
	});
	Object.defineProperty(exports, "BorderClearTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BorderClearTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BorderColor", {
	  enumerable: true,
	  get: function get() {
	    return _BorderColor.default;
	  }
	});
	Object.defineProperty(exports, "BorderColorOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BorderColorOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BorderColorRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BorderColorRounded.default;
	  }
	});
	Object.defineProperty(exports, "BorderColorSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BorderColorSharp.default;
	  }
	});
	Object.defineProperty(exports, "BorderColorTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BorderColorTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BorderHorizontal", {
	  enumerable: true,
	  get: function get() {
	    return _BorderHorizontal.default;
	  }
	});
	Object.defineProperty(exports, "BorderHorizontalOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BorderHorizontalOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BorderHorizontalRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BorderHorizontalRounded.default;
	  }
	});
	Object.defineProperty(exports, "BorderHorizontalSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BorderHorizontalSharp.default;
	  }
	});
	Object.defineProperty(exports, "BorderHorizontalTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BorderHorizontalTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BorderInner", {
	  enumerable: true,
	  get: function get() {
	    return _BorderInner.default;
	  }
	});
	Object.defineProperty(exports, "BorderInnerOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BorderInnerOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BorderInnerRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BorderInnerRounded.default;
	  }
	});
	Object.defineProperty(exports, "BorderInnerSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BorderInnerSharp.default;
	  }
	});
	Object.defineProperty(exports, "BorderInnerTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BorderInnerTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BorderLeft", {
	  enumerable: true,
	  get: function get() {
	    return _BorderLeft.default;
	  }
	});
	Object.defineProperty(exports, "BorderLeftOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BorderLeftOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BorderLeftRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BorderLeftRounded.default;
	  }
	});
	Object.defineProperty(exports, "BorderLeftSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BorderLeftSharp.default;
	  }
	});
	Object.defineProperty(exports, "BorderLeftTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BorderLeftTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BorderOuter", {
	  enumerable: true,
	  get: function get() {
	    return _BorderOuter.default;
	  }
	});
	Object.defineProperty(exports, "BorderOuterOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BorderOuterOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BorderOuterRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BorderOuterRounded.default;
	  }
	});
	Object.defineProperty(exports, "BorderOuterSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BorderOuterSharp.default;
	  }
	});
	Object.defineProperty(exports, "BorderOuterTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BorderOuterTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BorderRight", {
	  enumerable: true,
	  get: function get() {
	    return _BorderRight.default;
	  }
	});
	Object.defineProperty(exports, "BorderRightOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BorderRightOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BorderRightRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BorderRightRounded.default;
	  }
	});
	Object.defineProperty(exports, "BorderRightSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BorderRightSharp.default;
	  }
	});
	Object.defineProperty(exports, "BorderRightTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BorderRightTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BorderStyle", {
	  enumerable: true,
	  get: function get() {
	    return _BorderStyle.default;
	  }
	});
	Object.defineProperty(exports, "BorderStyleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BorderStyleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BorderStyleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BorderStyleRounded.default;
	  }
	});
	Object.defineProperty(exports, "BorderStyleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BorderStyleSharp.default;
	  }
	});
	Object.defineProperty(exports, "BorderStyleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BorderStyleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BorderTop", {
	  enumerable: true,
	  get: function get() {
	    return _BorderTop.default;
	  }
	});
	Object.defineProperty(exports, "BorderTopOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BorderTopOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BorderTopRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BorderTopRounded.default;
	  }
	});
	Object.defineProperty(exports, "BorderTopSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BorderTopSharp.default;
	  }
	});
	Object.defineProperty(exports, "BorderTopTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BorderTopTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BorderVertical", {
	  enumerable: true,
	  get: function get() {
	    return _BorderVertical.default;
	  }
	});
	Object.defineProperty(exports, "BorderVerticalOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BorderVerticalOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BorderVerticalRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BorderVerticalRounded.default;
	  }
	});
	Object.defineProperty(exports, "BorderVerticalSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BorderVerticalSharp.default;
	  }
	});
	Object.defineProperty(exports, "BorderVerticalTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BorderVerticalTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BrandingWatermark", {
	  enumerable: true,
	  get: function get() {
	    return _BrandingWatermark.default;
	  }
	});
	Object.defineProperty(exports, "BrandingWatermarkOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BrandingWatermarkOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BrandingWatermarkRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BrandingWatermarkRounded.default;
	  }
	});
	Object.defineProperty(exports, "BrandingWatermarkSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BrandingWatermarkSharp.default;
	  }
	});
	Object.defineProperty(exports, "BrandingWatermarkTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BrandingWatermarkTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Brightness1", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness.default;
	  }
	});
	Object.defineProperty(exports, "Brightness1Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness1Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Brightness1Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness1Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Brightness1Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness1Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Brightness1TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness1TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Brightness2", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness2.default;
	  }
	});
	Object.defineProperty(exports, "Brightness2Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness2Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Brightness2Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness2Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Brightness2Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness2Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Brightness2TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness2TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Brightness3", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness3.default;
	  }
	});
	Object.defineProperty(exports, "Brightness3Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness3Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Brightness3Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness3Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Brightness3Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness3Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Brightness3TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness3TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Brightness4", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness4.default;
	  }
	});
	Object.defineProperty(exports, "Brightness4Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness4Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Brightness4Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness4Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Brightness4Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness4Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Brightness4TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness4TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Brightness5", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness5.default;
	  }
	});
	Object.defineProperty(exports, "Brightness5Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness5Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Brightness5Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness5Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Brightness5Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness5Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Brightness5TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness5TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Brightness6", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness6.default;
	  }
	});
	Object.defineProperty(exports, "Brightness6Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness6Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Brightness6Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness6Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Brightness6Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness6Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Brightness6TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness6TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Brightness7", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness7.default;
	  }
	});
	Object.defineProperty(exports, "Brightness7Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness7Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Brightness7Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness7Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Brightness7Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness7Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Brightness7TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Brightness7TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BrightnessAuto", {
	  enumerable: true,
	  get: function get() {
	    return _BrightnessAuto.default;
	  }
	});
	Object.defineProperty(exports, "BrightnessAutoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BrightnessAutoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BrightnessAutoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BrightnessAutoRounded.default;
	  }
	});
	Object.defineProperty(exports, "BrightnessAutoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BrightnessAutoSharp.default;
	  }
	});
	Object.defineProperty(exports, "BrightnessAutoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BrightnessAutoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BrightnessHigh", {
	  enumerable: true,
	  get: function get() {
	    return _BrightnessHigh.default;
	  }
	});
	Object.defineProperty(exports, "BrightnessHighOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BrightnessHighOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BrightnessHighRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BrightnessHighRounded.default;
	  }
	});
	Object.defineProperty(exports, "BrightnessHighSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BrightnessHighSharp.default;
	  }
	});
	Object.defineProperty(exports, "BrightnessHighTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BrightnessHighTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BrightnessLow", {
	  enumerable: true,
	  get: function get() {
	    return _BrightnessLow.default;
	  }
	});
	Object.defineProperty(exports, "BrightnessLowOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BrightnessLowOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BrightnessLowRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BrightnessLowRounded.default;
	  }
	});
	Object.defineProperty(exports, "BrightnessLowSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BrightnessLowSharp.default;
	  }
	});
	Object.defineProperty(exports, "BrightnessLowTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BrightnessLowTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BrightnessMedium", {
	  enumerable: true,
	  get: function get() {
	    return _BrightnessMedium.default;
	  }
	});
	Object.defineProperty(exports, "BrightnessMediumOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BrightnessMediumOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BrightnessMediumRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BrightnessMediumRounded.default;
	  }
	});
	Object.defineProperty(exports, "BrightnessMediumSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BrightnessMediumSharp.default;
	  }
	});
	Object.defineProperty(exports, "BrightnessMediumTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BrightnessMediumTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BrokenImage", {
	  enumerable: true,
	  get: function get() {
	    return _BrokenImage.default;
	  }
	});
	Object.defineProperty(exports, "BrokenImageOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BrokenImageOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BrokenImageRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BrokenImageRounded.default;
	  }
	});
	Object.defineProperty(exports, "BrokenImageSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BrokenImageSharp.default;
	  }
	});
	Object.defineProperty(exports, "BrokenImageTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BrokenImageTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Brush", {
	  enumerable: true,
	  get: function get() {
	    return _Brush.default;
	  }
	});
	Object.defineProperty(exports, "BrushOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BrushOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BrushRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BrushRounded.default;
	  }
	});
	Object.defineProperty(exports, "BrushSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BrushSharp.default;
	  }
	});
	Object.defineProperty(exports, "BrushTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BrushTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BubbleChart", {
	  enumerable: true,
	  get: function get() {
	    return _BubbleChart.default;
	  }
	});
	Object.defineProperty(exports, "BubbleChartOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BubbleChartOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BubbleChartRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BubbleChartRounded.default;
	  }
	});
	Object.defineProperty(exports, "BubbleChartSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BubbleChartSharp.default;
	  }
	});
	Object.defineProperty(exports, "BubbleChartTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BubbleChartTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BugReport", {
	  enumerable: true,
	  get: function get() {
	    return _BugReport.default;
	  }
	});
	Object.defineProperty(exports, "BugReportOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BugReportOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BugReportRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BugReportRounded.default;
	  }
	});
	Object.defineProperty(exports, "BugReportSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BugReportSharp.default;
	  }
	});
	Object.defineProperty(exports, "BugReportTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BugReportTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Build", {
	  enumerable: true,
	  get: function get() {
	    return _Build.default;
	  }
	});
	Object.defineProperty(exports, "BuildOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BuildOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BuildRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BuildRounded.default;
	  }
	});
	Object.defineProperty(exports, "BuildSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BuildSharp.default;
	  }
	});
	Object.defineProperty(exports, "BuildTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BuildTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BurstMode", {
	  enumerable: true,
	  get: function get() {
	    return _BurstMode.default;
	  }
	});
	Object.defineProperty(exports, "BurstModeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BurstModeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BurstModeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BurstModeRounded.default;
	  }
	});
	Object.defineProperty(exports, "BurstModeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BurstModeSharp.default;
	  }
	});
	Object.defineProperty(exports, "BurstModeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BurstModeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Business", {
	  enumerable: true,
	  get: function get() {
	    return _Business.default;
	  }
	});
	Object.defineProperty(exports, "BusinessCenter", {
	  enumerable: true,
	  get: function get() {
	    return _BusinessCenter.default;
	  }
	});
	Object.defineProperty(exports, "BusinessCenterOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BusinessCenterOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BusinessCenterRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BusinessCenterRounded.default;
	  }
	});
	Object.defineProperty(exports, "BusinessCenterSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BusinessCenterSharp.default;
	  }
	});
	Object.defineProperty(exports, "BusinessCenterTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BusinessCenterTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "BusinessOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _BusinessOutlined.default;
	  }
	});
	Object.defineProperty(exports, "BusinessRounded", {
	  enumerable: true,
	  get: function get() {
	    return _BusinessRounded.default;
	  }
	});
	Object.defineProperty(exports, "BusinessSharp", {
	  enumerable: true,
	  get: function get() {
	    return _BusinessSharp.default;
	  }
	});
	Object.defineProperty(exports, "BusinessTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _BusinessTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Cached", {
	  enumerable: true,
	  get: function get() {
	    return _Cached.default;
	  }
	});
	Object.defineProperty(exports, "CachedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CachedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CachedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CachedRounded.default;
	  }
	});
	Object.defineProperty(exports, "CachedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CachedSharp.default;
	  }
	});
	Object.defineProperty(exports, "CachedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CachedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Cake", {
	  enumerable: true,
	  get: function get() {
	    return _Cake.default;
	  }
	});
	Object.defineProperty(exports, "CakeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CakeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CakeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CakeRounded.default;
	  }
	});
	Object.defineProperty(exports, "CakeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CakeSharp.default;
	  }
	});
	Object.defineProperty(exports, "CakeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CakeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CalendarToday", {
	  enumerable: true,
	  get: function get() {
	    return _CalendarToday.default;
	  }
	});
	Object.defineProperty(exports, "CalendarTodayOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CalendarTodayOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CalendarTodayRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CalendarTodayRounded.default;
	  }
	});
	Object.defineProperty(exports, "CalendarTodaySharp", {
	  enumerable: true,
	  get: function get() {
	    return _CalendarTodaySharp.default;
	  }
	});
	Object.defineProperty(exports, "CalendarTodayTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CalendarTodayTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CalendarViewDay", {
	  enumerable: true,
	  get: function get() {
	    return _CalendarViewDay.default;
	  }
	});
	Object.defineProperty(exports, "CalendarViewDayOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CalendarViewDayOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CalendarViewDayRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CalendarViewDayRounded.default;
	  }
	});
	Object.defineProperty(exports, "CalendarViewDaySharp", {
	  enumerable: true,
	  get: function get() {
	    return _CalendarViewDaySharp.default;
	  }
	});
	Object.defineProperty(exports, "CalendarViewDayTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CalendarViewDayTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Call", {
	  enumerable: true,
	  get: function get() {
	    return _Call.default;
	  }
	});
	Object.defineProperty(exports, "CallEnd", {
	  enumerable: true,
	  get: function get() {
	    return _CallEnd.default;
	  }
	});
	Object.defineProperty(exports, "CallEndOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CallEndOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CallEndRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CallEndRounded.default;
	  }
	});
	Object.defineProperty(exports, "CallEndSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CallEndSharp.default;
	  }
	});
	Object.defineProperty(exports, "CallEndTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CallEndTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CallMade", {
	  enumerable: true,
	  get: function get() {
	    return _CallMade.default;
	  }
	});
	Object.defineProperty(exports, "CallMadeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CallMadeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CallMadeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CallMadeRounded.default;
	  }
	});
	Object.defineProperty(exports, "CallMadeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CallMadeSharp.default;
	  }
	});
	Object.defineProperty(exports, "CallMadeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CallMadeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CallMerge", {
	  enumerable: true,
	  get: function get() {
	    return _CallMerge.default;
	  }
	});
	Object.defineProperty(exports, "CallMergeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CallMergeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CallMergeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CallMergeRounded.default;
	  }
	});
	Object.defineProperty(exports, "CallMergeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CallMergeSharp.default;
	  }
	});
	Object.defineProperty(exports, "CallMergeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CallMergeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CallMissed", {
	  enumerable: true,
	  get: function get() {
	    return _CallMissed.default;
	  }
	});
	Object.defineProperty(exports, "CallMissedOutgoing", {
	  enumerable: true,
	  get: function get() {
	    return _CallMissedOutgoing.default;
	  }
	});
	Object.defineProperty(exports, "CallMissedOutgoingOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CallMissedOutgoingOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CallMissedOutgoingRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CallMissedOutgoingRounded.default;
	  }
	});
	Object.defineProperty(exports, "CallMissedOutgoingSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CallMissedOutgoingSharp.default;
	  }
	});
	Object.defineProperty(exports, "CallMissedOutgoingTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CallMissedOutgoingTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CallMissedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CallMissedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CallMissedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CallMissedRounded.default;
	  }
	});
	Object.defineProperty(exports, "CallMissedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CallMissedSharp.default;
	  }
	});
	Object.defineProperty(exports, "CallMissedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CallMissedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CallOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CallOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CallReceived", {
	  enumerable: true,
	  get: function get() {
	    return _CallReceived.default;
	  }
	});
	Object.defineProperty(exports, "CallReceivedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CallReceivedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CallReceivedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CallReceivedRounded.default;
	  }
	});
	Object.defineProperty(exports, "CallReceivedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CallReceivedSharp.default;
	  }
	});
	Object.defineProperty(exports, "CallReceivedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CallReceivedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CallRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CallRounded.default;
	  }
	});
	Object.defineProperty(exports, "CallSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CallSharp.default;
	  }
	});
	Object.defineProperty(exports, "CallSplit", {
	  enumerable: true,
	  get: function get() {
	    return _CallSplit.default;
	  }
	});
	Object.defineProperty(exports, "CallSplitOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CallSplitOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CallSplitRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CallSplitRounded.default;
	  }
	});
	Object.defineProperty(exports, "CallSplitSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CallSplitSharp.default;
	  }
	});
	Object.defineProperty(exports, "CallSplitTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CallSplitTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CallToAction", {
	  enumerable: true,
	  get: function get() {
	    return _CallToAction.default;
	  }
	});
	Object.defineProperty(exports, "CallToActionOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CallToActionOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CallToActionRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CallToActionRounded.default;
	  }
	});
	Object.defineProperty(exports, "CallToActionSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CallToActionSharp.default;
	  }
	});
	Object.defineProperty(exports, "CallToActionTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CallToActionTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CallTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CallTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Camera", {
	  enumerable: true,
	  get: function get() {
	    return _Camera.default;
	  }
	});
	Object.defineProperty(exports, "CameraAlt", {
	  enumerable: true,
	  get: function get() {
	    return _CameraAlt.default;
	  }
	});
	Object.defineProperty(exports, "CameraAltOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CameraAltOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CameraAltRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CameraAltRounded.default;
	  }
	});
	Object.defineProperty(exports, "CameraAltSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CameraAltSharp.default;
	  }
	});
	Object.defineProperty(exports, "CameraAltTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CameraAltTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CameraEnhance", {
	  enumerable: true,
	  get: function get() {
	    return _CameraEnhance.default;
	  }
	});
	Object.defineProperty(exports, "CameraEnhanceOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CameraEnhanceOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CameraEnhanceRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CameraEnhanceRounded.default;
	  }
	});
	Object.defineProperty(exports, "CameraEnhanceSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CameraEnhanceSharp.default;
	  }
	});
	Object.defineProperty(exports, "CameraEnhanceTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CameraEnhanceTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CameraFront", {
	  enumerable: true,
	  get: function get() {
	    return _CameraFront.default;
	  }
	});
	Object.defineProperty(exports, "CameraFrontOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CameraFrontOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CameraFrontRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CameraFrontRounded.default;
	  }
	});
	Object.defineProperty(exports, "CameraFrontSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CameraFrontSharp.default;
	  }
	});
	Object.defineProperty(exports, "CameraFrontTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CameraFrontTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CameraOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CameraOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CameraRear", {
	  enumerable: true,
	  get: function get() {
	    return _CameraRear.default;
	  }
	});
	Object.defineProperty(exports, "CameraRearOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CameraRearOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CameraRearRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CameraRearRounded.default;
	  }
	});
	Object.defineProperty(exports, "CameraRearSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CameraRearSharp.default;
	  }
	});
	Object.defineProperty(exports, "CameraRearTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CameraRearTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CameraRoll", {
	  enumerable: true,
	  get: function get() {
	    return _CameraRoll.default;
	  }
	});
	Object.defineProperty(exports, "CameraRollOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CameraRollOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CameraRollRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CameraRollRounded.default;
	  }
	});
	Object.defineProperty(exports, "CameraRollSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CameraRollSharp.default;
	  }
	});
	Object.defineProperty(exports, "CameraRollTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CameraRollTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CameraRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CameraRounded.default;
	  }
	});
	Object.defineProperty(exports, "CameraSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CameraSharp.default;
	  }
	});
	Object.defineProperty(exports, "CameraTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CameraTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Cancel", {
	  enumerable: true,
	  get: function get() {
	    return _Cancel.default;
	  }
	});
	Object.defineProperty(exports, "CancelOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CancelOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CancelPresentation", {
	  enumerable: true,
	  get: function get() {
	    return _CancelPresentation.default;
	  }
	});
	Object.defineProperty(exports, "CancelPresentationOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CancelPresentationOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CancelPresentationRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CancelPresentationRounded.default;
	  }
	});
	Object.defineProperty(exports, "CancelPresentationSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CancelPresentationSharp.default;
	  }
	});
	Object.defineProperty(exports, "CancelPresentationTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CancelPresentationTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CancelRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CancelRounded.default;
	  }
	});
	Object.defineProperty(exports, "CancelScheduleSend", {
	  enumerable: true,
	  get: function get() {
	    return _CancelScheduleSend.default;
	  }
	});
	Object.defineProperty(exports, "CancelScheduleSendOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CancelScheduleSendOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CancelScheduleSendRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CancelScheduleSendRounded.default;
	  }
	});
	Object.defineProperty(exports, "CancelScheduleSendSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CancelScheduleSendSharp.default;
	  }
	});
	Object.defineProperty(exports, "CancelScheduleSendTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CancelScheduleSendTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CancelSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CancelSharp.default;
	  }
	});
	Object.defineProperty(exports, "CancelTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CancelTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CardGiftcard", {
	  enumerable: true,
	  get: function get() {
	    return _CardGiftcard.default;
	  }
	});
	Object.defineProperty(exports, "CardGiftcardOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CardGiftcardOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CardGiftcardRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CardGiftcardRounded.default;
	  }
	});
	Object.defineProperty(exports, "CardGiftcardSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CardGiftcardSharp.default;
	  }
	});
	Object.defineProperty(exports, "CardGiftcardTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CardGiftcardTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CardMembership", {
	  enumerable: true,
	  get: function get() {
	    return _CardMembership.default;
	  }
	});
	Object.defineProperty(exports, "CardMembershipOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CardMembershipOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CardMembershipRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CardMembershipRounded.default;
	  }
	});
	Object.defineProperty(exports, "CardMembershipSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CardMembershipSharp.default;
	  }
	});
	Object.defineProperty(exports, "CardMembershipTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CardMembershipTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CardTravel", {
	  enumerable: true,
	  get: function get() {
	    return _CardTravel.default;
	  }
	});
	Object.defineProperty(exports, "CardTravelOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CardTravelOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CardTravelRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CardTravelRounded.default;
	  }
	});
	Object.defineProperty(exports, "CardTravelSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CardTravelSharp.default;
	  }
	});
	Object.defineProperty(exports, "CardTravelTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CardTravelTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Casino", {
	  enumerable: true,
	  get: function get() {
	    return _Casino.default;
	  }
	});
	Object.defineProperty(exports, "CasinoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CasinoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CasinoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CasinoRounded.default;
	  }
	});
	Object.defineProperty(exports, "CasinoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CasinoSharp.default;
	  }
	});
	Object.defineProperty(exports, "CasinoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CasinoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Cast", {
	  enumerable: true,
	  get: function get() {
	    return _Cast.default;
	  }
	});
	Object.defineProperty(exports, "CastConnected", {
	  enumerable: true,
	  get: function get() {
	    return _CastConnected.default;
	  }
	});
	Object.defineProperty(exports, "CastConnectedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CastConnectedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CastConnectedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CastConnectedRounded.default;
	  }
	});
	Object.defineProperty(exports, "CastConnectedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CastConnectedSharp.default;
	  }
	});
	Object.defineProperty(exports, "CastConnectedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CastConnectedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CastForEducation", {
	  enumerable: true,
	  get: function get() {
	    return _CastForEducation.default;
	  }
	});
	Object.defineProperty(exports, "CastForEducationOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CastForEducationOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CastForEducationRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CastForEducationRounded.default;
	  }
	});
	Object.defineProperty(exports, "CastForEducationSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CastForEducationSharp.default;
	  }
	});
	Object.defineProperty(exports, "CastForEducationTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CastForEducationTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CastOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CastOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CastRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CastRounded.default;
	  }
	});
	Object.defineProperty(exports, "CastSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CastSharp.default;
	  }
	});
	Object.defineProperty(exports, "CastTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CastTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Category", {
	  enumerable: true,
	  get: function get() {
	    return _Category.default;
	  }
	});
	Object.defineProperty(exports, "CategoryOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CategoryOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CategoryRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CategoryRounded.default;
	  }
	});
	Object.defineProperty(exports, "CategorySharp", {
	  enumerable: true,
	  get: function get() {
	    return _CategorySharp.default;
	  }
	});
	Object.defineProperty(exports, "CategoryTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CategoryTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CellWifi", {
	  enumerable: true,
	  get: function get() {
	    return _CellWifi.default;
	  }
	});
	Object.defineProperty(exports, "CellWifiOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CellWifiOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CellWifiRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CellWifiRounded.default;
	  }
	});
	Object.defineProperty(exports, "CellWifiSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CellWifiSharp.default;
	  }
	});
	Object.defineProperty(exports, "CellWifiTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CellWifiTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CenterFocusStrong", {
	  enumerable: true,
	  get: function get() {
	    return _CenterFocusStrong.default;
	  }
	});
	Object.defineProperty(exports, "CenterFocusStrongOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CenterFocusStrongOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CenterFocusStrongRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CenterFocusStrongRounded.default;
	  }
	});
	Object.defineProperty(exports, "CenterFocusStrongSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CenterFocusStrongSharp.default;
	  }
	});
	Object.defineProperty(exports, "CenterFocusStrongTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CenterFocusStrongTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CenterFocusWeak", {
	  enumerable: true,
	  get: function get() {
	    return _CenterFocusWeak.default;
	  }
	});
	Object.defineProperty(exports, "CenterFocusWeakOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CenterFocusWeakOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CenterFocusWeakRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CenterFocusWeakRounded.default;
	  }
	});
	Object.defineProperty(exports, "CenterFocusWeakSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CenterFocusWeakSharp.default;
	  }
	});
	Object.defineProperty(exports, "CenterFocusWeakTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CenterFocusWeakTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ChangeHistory", {
	  enumerable: true,
	  get: function get() {
	    return _ChangeHistory.default;
	  }
	});
	Object.defineProperty(exports, "ChangeHistoryOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ChangeHistoryOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ChangeHistoryRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ChangeHistoryRounded.default;
	  }
	});
	Object.defineProperty(exports, "ChangeHistorySharp", {
	  enumerable: true,
	  get: function get() {
	    return _ChangeHistorySharp.default;
	  }
	});
	Object.defineProperty(exports, "ChangeHistoryTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ChangeHistoryTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Chat", {
	  enumerable: true,
	  get: function get() {
	    return _Chat.default;
	  }
	});
	Object.defineProperty(exports, "ChatBubble", {
	  enumerable: true,
	  get: function get() {
	    return _ChatBubble.default;
	  }
	});
	Object.defineProperty(exports, "ChatBubbleOutline", {
	  enumerable: true,
	  get: function get() {
	    return _ChatBubbleOutline.default;
	  }
	});
	Object.defineProperty(exports, "ChatBubbleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ChatBubbleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ChatBubbleOutlineOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ChatBubbleOutlineOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ChatBubbleOutlineRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ChatBubbleOutlineRounded.default;
	  }
	});
	Object.defineProperty(exports, "ChatBubbleOutlineSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ChatBubbleOutlineSharp.default;
	  }
	});
	Object.defineProperty(exports, "ChatBubbleOutlineTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ChatBubbleOutlineTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ChatBubbleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ChatBubbleRounded.default;
	  }
	});
	Object.defineProperty(exports, "ChatBubbleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ChatBubbleSharp.default;
	  }
	});
	Object.defineProperty(exports, "ChatBubbleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ChatBubbleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ChatOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ChatOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ChatRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ChatRounded.default;
	  }
	});
	Object.defineProperty(exports, "ChatSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ChatSharp.default;
	  }
	});
	Object.defineProperty(exports, "ChatTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ChatTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Check", {
	  enumerable: true,
	  get: function get() {
	    return _Check.default;
	  }
	});
	Object.defineProperty(exports, "CheckBox", {
	  enumerable: true,
	  get: function get() {
	    return _CheckBox.default;
	  }
	});
	Object.defineProperty(exports, "CheckBoxOutlineBlank", {
	  enumerable: true,
	  get: function get() {
	    return _CheckBoxOutlineBlank.default;
	  }
	});
	Object.defineProperty(exports, "CheckBoxOutlineBlankOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CheckBoxOutlineBlankOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CheckBoxOutlineBlankRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CheckBoxOutlineBlankRounded.default;
	  }
	});
	Object.defineProperty(exports, "CheckBoxOutlineBlankSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CheckBoxOutlineBlankSharp.default;
	  }
	});
	Object.defineProperty(exports, "CheckBoxOutlineBlankTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CheckBoxOutlineBlankTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CheckBoxOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CheckBoxOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CheckBoxRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CheckBoxRounded.default;
	  }
	});
	Object.defineProperty(exports, "CheckBoxSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CheckBoxSharp.default;
	  }
	});
	Object.defineProperty(exports, "CheckBoxTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CheckBoxTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CheckCircle", {
	  enumerable: true,
	  get: function get() {
	    return _CheckCircle.default;
	  }
	});
	Object.defineProperty(exports, "CheckCircleOutline", {
	  enumerable: true,
	  get: function get() {
	    return _CheckCircleOutline.default;
	  }
	});
	Object.defineProperty(exports, "CheckCircleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CheckCircleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CheckCircleOutlineOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CheckCircleOutlineOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CheckCircleOutlineRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CheckCircleOutlineRounded.default;
	  }
	});
	Object.defineProperty(exports, "CheckCircleOutlineSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CheckCircleOutlineSharp.default;
	  }
	});
	Object.defineProperty(exports, "CheckCircleOutlineTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CheckCircleOutlineTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CheckCircleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CheckCircleRounded.default;
	  }
	});
	Object.defineProperty(exports, "CheckCircleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CheckCircleSharp.default;
	  }
	});
	Object.defineProperty(exports, "CheckCircleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CheckCircleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CheckOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CheckOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CheckRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CheckRounded.default;
	  }
	});
	Object.defineProperty(exports, "CheckSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CheckSharp.default;
	  }
	});
	Object.defineProperty(exports, "CheckTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CheckTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ChevronLeft", {
	  enumerable: true,
	  get: function get() {
	    return _ChevronLeft.default;
	  }
	});
	Object.defineProperty(exports, "ChevronLeftOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ChevronLeftOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ChevronLeftRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ChevronLeftRounded.default;
	  }
	});
	Object.defineProperty(exports, "ChevronLeftSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ChevronLeftSharp.default;
	  }
	});
	Object.defineProperty(exports, "ChevronLeftTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ChevronLeftTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ChevronRight", {
	  enumerable: true,
	  get: function get() {
	    return _ChevronRight.default;
	  }
	});
	Object.defineProperty(exports, "ChevronRightOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ChevronRightOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ChevronRightRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ChevronRightRounded.default;
	  }
	});
	Object.defineProperty(exports, "ChevronRightSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ChevronRightSharp.default;
	  }
	});
	Object.defineProperty(exports, "ChevronRightTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ChevronRightTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ChildCare", {
	  enumerable: true,
	  get: function get() {
	    return _ChildCare.default;
	  }
	});
	Object.defineProperty(exports, "ChildCareOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ChildCareOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ChildCareRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ChildCareRounded.default;
	  }
	});
	Object.defineProperty(exports, "ChildCareSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ChildCareSharp.default;
	  }
	});
	Object.defineProperty(exports, "ChildCareTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ChildCareTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ChildFriendly", {
	  enumerable: true,
	  get: function get() {
	    return _ChildFriendly.default;
	  }
	});
	Object.defineProperty(exports, "ChildFriendlyOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ChildFriendlyOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ChildFriendlyRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ChildFriendlyRounded.default;
	  }
	});
	Object.defineProperty(exports, "ChildFriendlySharp", {
	  enumerable: true,
	  get: function get() {
	    return _ChildFriendlySharp.default;
	  }
	});
	Object.defineProperty(exports, "ChildFriendlyTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ChildFriendlyTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ChromeReaderMode", {
	  enumerable: true,
	  get: function get() {
	    return _ChromeReaderMode.default;
	  }
	});
	Object.defineProperty(exports, "ChromeReaderModeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ChromeReaderModeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ChromeReaderModeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ChromeReaderModeRounded.default;
	  }
	});
	Object.defineProperty(exports, "ChromeReaderModeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ChromeReaderModeSharp.default;
	  }
	});
	Object.defineProperty(exports, "ChromeReaderModeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ChromeReaderModeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Class", {
	  enumerable: true,
	  get: function get() {
	    return _Class.default;
	  }
	});
	Object.defineProperty(exports, "ClassOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ClassOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ClassRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ClassRounded.default;
	  }
	});
	Object.defineProperty(exports, "ClassSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ClassSharp.default;
	  }
	});
	Object.defineProperty(exports, "ClassTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ClassTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Clear", {
	  enumerable: true,
	  get: function get() {
	    return _Clear.default;
	  }
	});
	Object.defineProperty(exports, "ClearAll", {
	  enumerable: true,
	  get: function get() {
	    return _ClearAll.default;
	  }
	});
	Object.defineProperty(exports, "ClearAllOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ClearAllOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ClearAllRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ClearAllRounded.default;
	  }
	});
	Object.defineProperty(exports, "ClearAllSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ClearAllSharp.default;
	  }
	});
	Object.defineProperty(exports, "ClearAllTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ClearAllTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ClearOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ClearOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ClearRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ClearRounded.default;
	  }
	});
	Object.defineProperty(exports, "ClearSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ClearSharp.default;
	  }
	});
	Object.defineProperty(exports, "ClearTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ClearTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Close", {
	  enumerable: true,
	  get: function get() {
	    return _Close.default;
	  }
	});
	Object.defineProperty(exports, "ClosedCaption", {
	  enumerable: true,
	  get: function get() {
	    return _ClosedCaption.default;
	  }
	});
	Object.defineProperty(exports, "ClosedCaptionOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ClosedCaptionOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ClosedCaptionRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ClosedCaptionRounded.default;
	  }
	});
	Object.defineProperty(exports, "ClosedCaptionSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ClosedCaptionSharp.default;
	  }
	});
	Object.defineProperty(exports, "ClosedCaptionTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ClosedCaptionTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CloseOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CloseOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CloseRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CloseRounded.default;
	  }
	});
	Object.defineProperty(exports, "CloseSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CloseSharp.default;
	  }
	});
	Object.defineProperty(exports, "CloseTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CloseTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Cloud", {
	  enumerable: true,
	  get: function get() {
	    return _Cloud.default;
	  }
	});
	Object.defineProperty(exports, "CloudCircle", {
	  enumerable: true,
	  get: function get() {
	    return _CloudCircle.default;
	  }
	});
	Object.defineProperty(exports, "CloudCircleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CloudCircleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CloudCircleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CloudCircleRounded.default;
	  }
	});
	Object.defineProperty(exports, "CloudCircleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CloudCircleSharp.default;
	  }
	});
	Object.defineProperty(exports, "CloudCircleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CloudCircleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CloudDone", {
	  enumerable: true,
	  get: function get() {
	    return _CloudDone.default;
	  }
	});
	Object.defineProperty(exports, "CloudDoneOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CloudDoneOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CloudDoneRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CloudDoneRounded.default;
	  }
	});
	Object.defineProperty(exports, "CloudDoneSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CloudDoneSharp.default;
	  }
	});
	Object.defineProperty(exports, "CloudDoneTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CloudDoneTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CloudDownload", {
	  enumerable: true,
	  get: function get() {
	    return _CloudDownload.default;
	  }
	});
	Object.defineProperty(exports, "CloudDownloadOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CloudDownloadOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CloudDownloadRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CloudDownloadRounded.default;
	  }
	});
	Object.defineProperty(exports, "CloudDownloadSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CloudDownloadSharp.default;
	  }
	});
	Object.defineProperty(exports, "CloudDownloadTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CloudDownloadTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CloudOff", {
	  enumerable: true,
	  get: function get() {
	    return _CloudOff.default;
	  }
	});
	Object.defineProperty(exports, "CloudOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CloudOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CloudOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CloudOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "CloudOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CloudOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "CloudOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CloudOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CloudOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CloudOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CloudQueue", {
	  enumerable: true,
	  get: function get() {
	    return _CloudQueue.default;
	  }
	});
	Object.defineProperty(exports, "CloudQueueOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CloudQueueOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CloudQueueRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CloudQueueRounded.default;
	  }
	});
	Object.defineProperty(exports, "CloudQueueSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CloudQueueSharp.default;
	  }
	});
	Object.defineProperty(exports, "CloudQueueTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CloudQueueTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CloudRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CloudRounded.default;
	  }
	});
	Object.defineProperty(exports, "CloudSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CloudSharp.default;
	  }
	});
	Object.defineProperty(exports, "CloudTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CloudTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CloudUpload", {
	  enumerable: true,
	  get: function get() {
	    return _CloudUpload.default;
	  }
	});
	Object.defineProperty(exports, "CloudUploadOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CloudUploadOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CloudUploadRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CloudUploadRounded.default;
	  }
	});
	Object.defineProperty(exports, "CloudUploadSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CloudUploadSharp.default;
	  }
	});
	Object.defineProperty(exports, "CloudUploadTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CloudUploadTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Code", {
	  enumerable: true,
	  get: function get() {
	    return _Code.default;
	  }
	});
	Object.defineProperty(exports, "CodeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CodeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CodeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CodeRounded.default;
	  }
	});
	Object.defineProperty(exports, "CodeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CodeSharp.default;
	  }
	});
	Object.defineProperty(exports, "CodeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CodeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Collections", {
	  enumerable: true,
	  get: function get() {
	    return _Collections.default;
	  }
	});
	Object.defineProperty(exports, "CollectionsBookmark", {
	  enumerable: true,
	  get: function get() {
	    return _CollectionsBookmark.default;
	  }
	});
	Object.defineProperty(exports, "CollectionsBookmarkOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CollectionsBookmarkOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CollectionsBookmarkRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CollectionsBookmarkRounded.default;
	  }
	});
	Object.defineProperty(exports, "CollectionsBookmarkSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CollectionsBookmarkSharp.default;
	  }
	});
	Object.defineProperty(exports, "CollectionsBookmarkTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CollectionsBookmarkTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CollectionsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CollectionsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CollectionsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CollectionsRounded.default;
	  }
	});
	Object.defineProperty(exports, "CollectionsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CollectionsSharp.default;
	  }
	});
	Object.defineProperty(exports, "CollectionsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CollectionsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Colorize", {
	  enumerable: true,
	  get: function get() {
	    return _Colorize.default;
	  }
	});
	Object.defineProperty(exports, "ColorizeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ColorizeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ColorizeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ColorizeRounded.default;
	  }
	});
	Object.defineProperty(exports, "ColorizeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ColorizeSharp.default;
	  }
	});
	Object.defineProperty(exports, "ColorizeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ColorizeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ColorLens", {
	  enumerable: true,
	  get: function get() {
	    return _ColorLens.default;
	  }
	});
	Object.defineProperty(exports, "ColorLensOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ColorLensOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ColorLensRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ColorLensRounded.default;
	  }
	});
	Object.defineProperty(exports, "ColorLensSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ColorLensSharp.default;
	  }
	});
	Object.defineProperty(exports, "ColorLensTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ColorLensTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Comment", {
	  enumerable: true,
	  get: function get() {
	    return _Comment.default;
	  }
	});
	Object.defineProperty(exports, "CommentOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CommentOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CommentRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CommentRounded.default;
	  }
	});
	Object.defineProperty(exports, "CommentSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CommentSharp.default;
	  }
	});
	Object.defineProperty(exports, "CommentTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CommentTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Commute", {
	  enumerable: true,
	  get: function get() {
	    return _Commute.default;
	  }
	});
	Object.defineProperty(exports, "CommuteOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CommuteOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CommuteRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CommuteRounded.default;
	  }
	});
	Object.defineProperty(exports, "CommuteSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CommuteSharp.default;
	  }
	});
	Object.defineProperty(exports, "CommuteTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CommuteTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Compare", {
	  enumerable: true,
	  get: function get() {
	    return _Compare.default;
	  }
	});
	Object.defineProperty(exports, "CompareArrows", {
	  enumerable: true,
	  get: function get() {
	    return _CompareArrows.default;
	  }
	});
	Object.defineProperty(exports, "CompareArrowsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CompareArrowsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CompareArrowsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CompareArrowsRounded.default;
	  }
	});
	Object.defineProperty(exports, "CompareArrowsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CompareArrowsSharp.default;
	  }
	});
	Object.defineProperty(exports, "CompareArrowsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CompareArrowsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CompareOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CompareOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CompareRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CompareRounded.default;
	  }
	});
	Object.defineProperty(exports, "CompareSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CompareSharp.default;
	  }
	});
	Object.defineProperty(exports, "CompareTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CompareTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CompassCalibration", {
	  enumerable: true,
	  get: function get() {
	    return _CompassCalibration.default;
	  }
	});
	Object.defineProperty(exports, "CompassCalibrationOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CompassCalibrationOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CompassCalibrationRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CompassCalibrationRounded.default;
	  }
	});
	Object.defineProperty(exports, "CompassCalibrationSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CompassCalibrationSharp.default;
	  }
	});
	Object.defineProperty(exports, "CompassCalibrationTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CompassCalibrationTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Computer", {
	  enumerable: true,
	  get: function get() {
	    return _Computer.default;
	  }
	});
	Object.defineProperty(exports, "ComputerOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ComputerOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ComputerRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ComputerRounded.default;
	  }
	});
	Object.defineProperty(exports, "ComputerSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ComputerSharp.default;
	  }
	});
	Object.defineProperty(exports, "ComputerTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ComputerTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ConfirmationNumber", {
	  enumerable: true,
	  get: function get() {
	    return _ConfirmationNumber.default;
	  }
	});
	Object.defineProperty(exports, "ConfirmationNumberOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ConfirmationNumberOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ConfirmationNumberRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ConfirmationNumberRounded.default;
	  }
	});
	Object.defineProperty(exports, "ConfirmationNumberSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ConfirmationNumberSharp.default;
	  }
	});
	Object.defineProperty(exports, "ConfirmationNumberTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ConfirmationNumberTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Contactless", {
	  enumerable: true,
	  get: function get() {
	    return _Contactless.default;
	  }
	});
	Object.defineProperty(exports, "ContactlessOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ContactlessOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ContactlessRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ContactlessRounded.default;
	  }
	});
	Object.defineProperty(exports, "ContactlessSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ContactlessSharp.default;
	  }
	});
	Object.defineProperty(exports, "ContactlessTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ContactlessTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ContactMail", {
	  enumerable: true,
	  get: function get() {
	    return _ContactMail.default;
	  }
	});
	Object.defineProperty(exports, "ContactMailOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ContactMailOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ContactMailRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ContactMailRounded.default;
	  }
	});
	Object.defineProperty(exports, "ContactMailSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ContactMailSharp.default;
	  }
	});
	Object.defineProperty(exports, "ContactMailTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ContactMailTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ContactPhone", {
	  enumerable: true,
	  get: function get() {
	    return _ContactPhone.default;
	  }
	});
	Object.defineProperty(exports, "ContactPhoneOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ContactPhoneOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ContactPhoneRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ContactPhoneRounded.default;
	  }
	});
	Object.defineProperty(exports, "ContactPhoneSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ContactPhoneSharp.default;
	  }
	});
	Object.defineProperty(exports, "ContactPhoneTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ContactPhoneTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Contacts", {
	  enumerable: true,
	  get: function get() {
	    return _Contacts.default;
	  }
	});
	Object.defineProperty(exports, "ContactsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ContactsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ContactsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ContactsRounded.default;
	  }
	});
	Object.defineProperty(exports, "ContactsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ContactsSharp.default;
	  }
	});
	Object.defineProperty(exports, "ContactsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ContactsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ContactSupport", {
	  enumerable: true,
	  get: function get() {
	    return _ContactSupport.default;
	  }
	});
	Object.defineProperty(exports, "ContactSupportOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ContactSupportOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ContactSupportRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ContactSupportRounded.default;
	  }
	});
	Object.defineProperty(exports, "ContactSupportSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ContactSupportSharp.default;
	  }
	});
	Object.defineProperty(exports, "ContactSupportTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ContactSupportTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ControlCamera", {
	  enumerable: true,
	  get: function get() {
	    return _ControlCamera.default;
	  }
	});
	Object.defineProperty(exports, "ControlCameraOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ControlCameraOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ControlCameraRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ControlCameraRounded.default;
	  }
	});
	Object.defineProperty(exports, "ControlCameraSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ControlCameraSharp.default;
	  }
	});
	Object.defineProperty(exports, "ControlCameraTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ControlCameraTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ControlPoint", {
	  enumerable: true,
	  get: function get() {
	    return _ControlPoint.default;
	  }
	});
	Object.defineProperty(exports, "ControlPointDuplicate", {
	  enumerable: true,
	  get: function get() {
	    return _ControlPointDuplicate.default;
	  }
	});
	Object.defineProperty(exports, "ControlPointDuplicateOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ControlPointDuplicateOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ControlPointDuplicateRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ControlPointDuplicateRounded.default;
	  }
	});
	Object.defineProperty(exports, "ControlPointDuplicateSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ControlPointDuplicateSharp.default;
	  }
	});
	Object.defineProperty(exports, "ControlPointDuplicateTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ControlPointDuplicateTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ControlPointOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ControlPointOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ControlPointRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ControlPointRounded.default;
	  }
	});
	Object.defineProperty(exports, "ControlPointSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ControlPointSharp.default;
	  }
	});
	Object.defineProperty(exports, "ControlPointTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ControlPointTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Copyright", {
	  enumerable: true,
	  get: function get() {
	    return _Copyright.default;
	  }
	});
	Object.defineProperty(exports, "CopyrightOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CopyrightOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CopyrightRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CopyrightRounded.default;
	  }
	});
	Object.defineProperty(exports, "CopyrightSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CopyrightSharp.default;
	  }
	});
	Object.defineProperty(exports, "CopyrightTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CopyrightTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Create", {
	  enumerable: true,
	  get: function get() {
	    return _Create.default;
	  }
	});
	Object.defineProperty(exports, "CreateNewFolder", {
	  enumerable: true,
	  get: function get() {
	    return _CreateNewFolder.default;
	  }
	});
	Object.defineProperty(exports, "CreateNewFolderOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CreateNewFolderOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CreateNewFolderRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CreateNewFolderRounded.default;
	  }
	});
	Object.defineProperty(exports, "CreateNewFolderSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CreateNewFolderSharp.default;
	  }
	});
	Object.defineProperty(exports, "CreateNewFolderTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CreateNewFolderTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CreateOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CreateOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CreateRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CreateRounded.default;
	  }
	});
	Object.defineProperty(exports, "CreateSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CreateSharp.default;
	  }
	});
	Object.defineProperty(exports, "CreateTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CreateTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CreditCard", {
	  enumerable: true,
	  get: function get() {
	    return _CreditCard.default;
	  }
	});
	Object.defineProperty(exports, "CreditCardOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CreditCardOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CreditCardRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CreditCardRounded.default;
	  }
	});
	Object.defineProperty(exports, "CreditCardSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CreditCardSharp.default;
	  }
	});
	Object.defineProperty(exports, "CreditCardTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CreditCardTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Crop", {
	  enumerable: true,
	  get: function get() {
	    return _Crop.default;
	  }
	});
	Object.defineProperty(exports, "Crop169", {
	  enumerable: true,
	  get: function get() {
	    return _Crop2.default;
	  }
	});
	Object.defineProperty(exports, "Crop169Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Crop169Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Crop169Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Crop169Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Crop169Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Crop169Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Crop169TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Crop169TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Crop32", {
	  enumerable: true,
	  get: function get() {
	    return _Crop3.default;
	  }
	});
	Object.defineProperty(exports, "Crop32Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Crop32Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Crop32Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Crop32Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Crop32Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Crop32Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Crop32TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Crop32TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Crop54", {
	  enumerable: true,
	  get: function get() {
	    return _Crop4.default;
	  }
	});
	Object.defineProperty(exports, "Crop54Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Crop54Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Crop54Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Crop54Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Crop54Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Crop54Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Crop54TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Crop54TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Crop75", {
	  enumerable: true,
	  get: function get() {
	    return _Crop5.default;
	  }
	});
	Object.defineProperty(exports, "Crop75Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Crop75Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Crop75Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Crop75Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Crop75Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Crop75Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Crop75TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Crop75TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CropDin", {
	  enumerable: true,
	  get: function get() {
	    return _CropDin.default;
	  }
	});
	Object.defineProperty(exports, "CropDinOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CropDinOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CropDinRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CropDinRounded.default;
	  }
	});
	Object.defineProperty(exports, "CropDinSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CropDinSharp.default;
	  }
	});
	Object.defineProperty(exports, "CropDinTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CropDinTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CropFree", {
	  enumerable: true,
	  get: function get() {
	    return _CropFree.default;
	  }
	});
	Object.defineProperty(exports, "CropFreeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CropFreeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CropFreeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CropFreeRounded.default;
	  }
	});
	Object.defineProperty(exports, "CropFreeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CropFreeSharp.default;
	  }
	});
	Object.defineProperty(exports, "CropFreeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CropFreeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CropLandscape", {
	  enumerable: true,
	  get: function get() {
	    return _CropLandscape.default;
	  }
	});
	Object.defineProperty(exports, "CropLandscapeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CropLandscapeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CropLandscapeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CropLandscapeRounded.default;
	  }
	});
	Object.defineProperty(exports, "CropLandscapeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CropLandscapeSharp.default;
	  }
	});
	Object.defineProperty(exports, "CropLandscapeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CropLandscapeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CropOriginal", {
	  enumerable: true,
	  get: function get() {
	    return _CropOriginal.default;
	  }
	});
	Object.defineProperty(exports, "CropOriginalOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CropOriginalOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CropOriginalRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CropOriginalRounded.default;
	  }
	});
	Object.defineProperty(exports, "CropOriginalSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CropOriginalSharp.default;
	  }
	});
	Object.defineProperty(exports, "CropOriginalTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CropOriginalTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CropOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CropOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CropPortrait", {
	  enumerable: true,
	  get: function get() {
	    return _CropPortrait.default;
	  }
	});
	Object.defineProperty(exports, "CropPortraitOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CropPortraitOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CropPortraitRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CropPortraitRounded.default;
	  }
	});
	Object.defineProperty(exports, "CropPortraitSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CropPortraitSharp.default;
	  }
	});
	Object.defineProperty(exports, "CropPortraitTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CropPortraitTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CropRotate", {
	  enumerable: true,
	  get: function get() {
	    return _CropRotate.default;
	  }
	});
	Object.defineProperty(exports, "CropRotateOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CropRotateOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CropRotateRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CropRotateRounded.default;
	  }
	});
	Object.defineProperty(exports, "CropRotateSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CropRotateSharp.default;
	  }
	});
	Object.defineProperty(exports, "CropRotateTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CropRotateTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CropRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CropRounded.default;
	  }
	});
	Object.defineProperty(exports, "CropSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CropSharp.default;
	  }
	});
	Object.defineProperty(exports, "CropSquare", {
	  enumerable: true,
	  get: function get() {
	    return _CropSquare.default;
	  }
	});
	Object.defineProperty(exports, "CropSquareOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _CropSquareOutlined.default;
	  }
	});
	Object.defineProperty(exports, "CropSquareRounded", {
	  enumerable: true,
	  get: function get() {
	    return _CropSquareRounded.default;
	  }
	});
	Object.defineProperty(exports, "CropSquareSharp", {
	  enumerable: true,
	  get: function get() {
	    return _CropSquareSharp.default;
	  }
	});
	Object.defineProperty(exports, "CropSquareTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CropSquareTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "CropTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _CropTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Dashboard", {
	  enumerable: true,
	  get: function get() {
	    return _Dashboard.default;
	  }
	});
	Object.defineProperty(exports, "DashboardOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DashboardOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DashboardRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DashboardRounded.default;
	  }
	});
	Object.defineProperty(exports, "DashboardSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DashboardSharp.default;
	  }
	});
	Object.defineProperty(exports, "DashboardTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DashboardTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DataUsage", {
	  enumerable: true,
	  get: function get() {
	    return _DataUsage.default;
	  }
	});
	Object.defineProperty(exports, "DataUsageOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DataUsageOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DataUsageRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DataUsageRounded.default;
	  }
	});
	Object.defineProperty(exports, "DataUsageSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DataUsageSharp.default;
	  }
	});
	Object.defineProperty(exports, "DataUsageTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DataUsageTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DateRange", {
	  enumerable: true,
	  get: function get() {
	    return _DateRange.default;
	  }
	});
	Object.defineProperty(exports, "DateRangeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DateRangeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DateRangeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DateRangeRounded.default;
	  }
	});
	Object.defineProperty(exports, "DateRangeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DateRangeSharp.default;
	  }
	});
	Object.defineProperty(exports, "DateRangeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DateRangeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Deck", {
	  enumerable: true,
	  get: function get() {
	    return _Deck.default;
	  }
	});
	Object.defineProperty(exports, "DeckOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DeckOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DeckRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DeckRounded.default;
	  }
	});
	Object.defineProperty(exports, "DeckSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DeckSharp.default;
	  }
	});
	Object.defineProperty(exports, "DeckTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DeckTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Dehaze", {
	  enumerable: true,
	  get: function get() {
	    return _Dehaze.default;
	  }
	});
	Object.defineProperty(exports, "DehazeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DehazeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DehazeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DehazeRounded.default;
	  }
	});
	Object.defineProperty(exports, "DehazeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DehazeSharp.default;
	  }
	});
	Object.defineProperty(exports, "DehazeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DehazeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Delete", {
	  enumerable: true,
	  get: function get() {
	    return _Delete.default;
	  }
	});
	Object.defineProperty(exports, "DeleteForever", {
	  enumerable: true,
	  get: function get() {
	    return _DeleteForever.default;
	  }
	});
	Object.defineProperty(exports, "DeleteForeverOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DeleteForeverOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DeleteForeverRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DeleteForeverRounded.default;
	  }
	});
	Object.defineProperty(exports, "DeleteForeverSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DeleteForeverSharp.default;
	  }
	});
	Object.defineProperty(exports, "DeleteForeverTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DeleteForeverTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DeleteOutline", {
	  enumerable: true,
	  get: function get() {
	    return _DeleteOutline.default;
	  }
	});
	Object.defineProperty(exports, "DeleteOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DeleteOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DeleteOutlineOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DeleteOutlineOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DeleteOutlineRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DeleteOutlineRounded.default;
	  }
	});
	Object.defineProperty(exports, "DeleteOutlineSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DeleteOutlineSharp.default;
	  }
	});
	Object.defineProperty(exports, "DeleteOutlineTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DeleteOutlineTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DeleteRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DeleteRounded.default;
	  }
	});
	Object.defineProperty(exports, "DeleteSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DeleteSharp.default;
	  }
	});
	Object.defineProperty(exports, "DeleteSweep", {
	  enumerable: true,
	  get: function get() {
	    return _DeleteSweep.default;
	  }
	});
	Object.defineProperty(exports, "DeleteSweepOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DeleteSweepOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DeleteSweepRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DeleteSweepRounded.default;
	  }
	});
	Object.defineProperty(exports, "DeleteSweepSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DeleteSweepSharp.default;
	  }
	});
	Object.defineProperty(exports, "DeleteSweepTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DeleteSweepTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DeleteTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DeleteTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DepartureBoard", {
	  enumerable: true,
	  get: function get() {
	    return _DepartureBoard.default;
	  }
	});
	Object.defineProperty(exports, "DepartureBoardOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DepartureBoardOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DepartureBoardRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DepartureBoardRounded.default;
	  }
	});
	Object.defineProperty(exports, "DepartureBoardSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DepartureBoardSharp.default;
	  }
	});
	Object.defineProperty(exports, "DepartureBoardTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DepartureBoardTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Description", {
	  enumerable: true,
	  get: function get() {
	    return _Description.default;
	  }
	});
	Object.defineProperty(exports, "DescriptionOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DescriptionOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DescriptionRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DescriptionRounded.default;
	  }
	});
	Object.defineProperty(exports, "DescriptionSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DescriptionSharp.default;
	  }
	});
	Object.defineProperty(exports, "DescriptionTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DescriptionTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DesktopAccessDisabled", {
	  enumerable: true,
	  get: function get() {
	    return _DesktopAccessDisabled.default;
	  }
	});
	Object.defineProperty(exports, "DesktopAccessDisabledOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DesktopAccessDisabledOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DesktopAccessDisabledRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DesktopAccessDisabledRounded.default;
	  }
	});
	Object.defineProperty(exports, "DesktopAccessDisabledSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DesktopAccessDisabledSharp.default;
	  }
	});
	Object.defineProperty(exports, "DesktopAccessDisabledTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DesktopAccessDisabledTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DesktopMac", {
	  enumerable: true,
	  get: function get() {
	    return _DesktopMac.default;
	  }
	});
	Object.defineProperty(exports, "DesktopMacOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DesktopMacOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DesktopMacRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DesktopMacRounded.default;
	  }
	});
	Object.defineProperty(exports, "DesktopMacSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DesktopMacSharp.default;
	  }
	});
	Object.defineProperty(exports, "DesktopMacTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DesktopMacTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DesktopWindows", {
	  enumerable: true,
	  get: function get() {
	    return _DesktopWindows.default;
	  }
	});
	Object.defineProperty(exports, "DesktopWindowsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DesktopWindowsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DesktopWindowsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DesktopWindowsRounded.default;
	  }
	});
	Object.defineProperty(exports, "DesktopWindowsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DesktopWindowsSharp.default;
	  }
	});
	Object.defineProperty(exports, "DesktopWindowsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DesktopWindowsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Details", {
	  enumerable: true,
	  get: function get() {
	    return _Details.default;
	  }
	});
	Object.defineProperty(exports, "DetailsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DetailsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DetailsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DetailsRounded.default;
	  }
	});
	Object.defineProperty(exports, "DetailsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DetailsSharp.default;
	  }
	});
	Object.defineProperty(exports, "DetailsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DetailsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DeveloperBoard", {
	  enumerable: true,
	  get: function get() {
	    return _DeveloperBoard.default;
	  }
	});
	Object.defineProperty(exports, "DeveloperBoardOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DeveloperBoardOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DeveloperBoardRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DeveloperBoardRounded.default;
	  }
	});
	Object.defineProperty(exports, "DeveloperBoardSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DeveloperBoardSharp.default;
	  }
	});
	Object.defineProperty(exports, "DeveloperBoardTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DeveloperBoardTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DeveloperMode", {
	  enumerable: true,
	  get: function get() {
	    return _DeveloperMode.default;
	  }
	});
	Object.defineProperty(exports, "DeveloperModeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DeveloperModeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DeveloperModeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DeveloperModeRounded.default;
	  }
	});
	Object.defineProperty(exports, "DeveloperModeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DeveloperModeSharp.default;
	  }
	});
	Object.defineProperty(exports, "DeveloperModeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DeveloperModeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DeviceHub", {
	  enumerable: true,
	  get: function get() {
	    return _DeviceHub.default;
	  }
	});
	Object.defineProperty(exports, "DeviceHubOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DeviceHubOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DeviceHubRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DeviceHubRounded.default;
	  }
	});
	Object.defineProperty(exports, "DeviceHubSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DeviceHubSharp.default;
	  }
	});
	Object.defineProperty(exports, "DeviceHubTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DeviceHubTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Devices", {
	  enumerable: true,
	  get: function get() {
	    return _Devices.default;
	  }
	});
	Object.defineProperty(exports, "DevicesOther", {
	  enumerable: true,
	  get: function get() {
	    return _DevicesOther.default;
	  }
	});
	Object.defineProperty(exports, "DevicesOtherOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DevicesOtherOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DevicesOtherRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DevicesOtherRounded.default;
	  }
	});
	Object.defineProperty(exports, "DevicesOtherSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DevicesOtherSharp.default;
	  }
	});
	Object.defineProperty(exports, "DevicesOtherTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DevicesOtherTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DevicesOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DevicesOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DevicesRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DevicesRounded.default;
	  }
	});
	Object.defineProperty(exports, "DevicesSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DevicesSharp.default;
	  }
	});
	Object.defineProperty(exports, "DevicesTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DevicesTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DeviceUnknown", {
	  enumerable: true,
	  get: function get() {
	    return _DeviceUnknown.default;
	  }
	});
	Object.defineProperty(exports, "DeviceUnknownOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DeviceUnknownOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DeviceUnknownRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DeviceUnknownRounded.default;
	  }
	});
	Object.defineProperty(exports, "DeviceUnknownSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DeviceUnknownSharp.default;
	  }
	});
	Object.defineProperty(exports, "DeviceUnknownTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DeviceUnknownTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DialerSip", {
	  enumerable: true,
	  get: function get() {
	    return _DialerSip.default;
	  }
	});
	Object.defineProperty(exports, "DialerSipOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DialerSipOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DialerSipRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DialerSipRounded.default;
	  }
	});
	Object.defineProperty(exports, "DialerSipSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DialerSipSharp.default;
	  }
	});
	Object.defineProperty(exports, "DialerSipTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DialerSipTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Dialpad", {
	  enumerable: true,
	  get: function get() {
	    return _Dialpad.default;
	  }
	});
	Object.defineProperty(exports, "DialpadOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DialpadOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DialpadRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DialpadRounded.default;
	  }
	});
	Object.defineProperty(exports, "DialpadSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DialpadSharp.default;
	  }
	});
	Object.defineProperty(exports, "DialpadTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DialpadTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Directions", {
	  enumerable: true,
	  get: function get() {
	    return _Directions.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsBike", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsBike.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsBikeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsBikeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsBikeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsBikeRounded.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsBikeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsBikeSharp.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsBikeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsBikeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsBoat", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsBoat.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsBoatOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsBoatOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsBoatRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsBoatRounded.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsBoatSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsBoatSharp.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsBoatTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsBoatTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsBus", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsBus.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsBusOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsBusOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsBusRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsBusRounded.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsBusSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsBusSharp.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsBusTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsBusTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsCar", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsCar.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsCarOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsCarOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsCarRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsCarRounded.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsCarSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsCarSharp.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsCarTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsCarTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsRailway", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsRailway.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsRailwayOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsRailwayOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsRailwayRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsRailwayRounded.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsRailwaySharp", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsRailwaySharp.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsRailwayTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsRailwayTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsRounded.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsRun", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsRun.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsRunOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsRunOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsRunRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsRunRounded.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsRunSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsRunSharp.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsRunTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsRunTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsSharp.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsSubway", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsSubway.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsSubwayOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsSubwayOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsSubwayRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsSubwayRounded.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsSubwaySharp", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsSubwaySharp.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsSubwayTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsSubwayTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsTransit", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsTransit.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsTransitOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsTransitOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsTransitRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsTransitRounded.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsTransitSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsTransitSharp.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsTransitTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsTransitTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsWalk", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsWalk.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsWalkOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsWalkOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsWalkRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsWalkRounded.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsWalkSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsWalkSharp.default;
	  }
	});
	Object.defineProperty(exports, "DirectionsWalkTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DirectionsWalkTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DiscFull", {
	  enumerable: true,
	  get: function get() {
	    return _DiscFull.default;
	  }
	});
	Object.defineProperty(exports, "DiscFullOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DiscFullOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DiscFullRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DiscFullRounded.default;
	  }
	});
	Object.defineProperty(exports, "DiscFullSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DiscFullSharp.default;
	  }
	});
	Object.defineProperty(exports, "DiscFullTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DiscFullTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Dns", {
	  enumerable: true,
	  get: function get() {
	    return _Dns.default;
	  }
	});
	Object.defineProperty(exports, "DnsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DnsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DnsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DnsRounded.default;
	  }
	});
	Object.defineProperty(exports, "DnsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DnsSharp.default;
	  }
	});
	Object.defineProperty(exports, "DnsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DnsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Dock", {
	  enumerable: true,
	  get: function get() {
	    return _Dock.default;
	  }
	});
	Object.defineProperty(exports, "DockOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DockOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DockRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DockRounded.default;
	  }
	});
	Object.defineProperty(exports, "DockSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DockSharp.default;
	  }
	});
	Object.defineProperty(exports, "DockTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DockTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Domain", {
	  enumerable: true,
	  get: function get() {
	    return _Domain.default;
	  }
	});
	Object.defineProperty(exports, "DomainDisabled", {
	  enumerable: true,
	  get: function get() {
	    return _DomainDisabled.default;
	  }
	});
	Object.defineProperty(exports, "DomainDisabledOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DomainDisabledOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DomainDisabledRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DomainDisabledRounded.default;
	  }
	});
	Object.defineProperty(exports, "DomainDisabledSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DomainDisabledSharp.default;
	  }
	});
	Object.defineProperty(exports, "DomainDisabledTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DomainDisabledTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DomainOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DomainOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DomainRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DomainRounded.default;
	  }
	});
	Object.defineProperty(exports, "DomainSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DomainSharp.default;
	  }
	});
	Object.defineProperty(exports, "DomainTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DomainTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Done", {
	  enumerable: true,
	  get: function get() {
	    return _Done.default;
	  }
	});
	Object.defineProperty(exports, "DoneAll", {
	  enumerable: true,
	  get: function get() {
	    return _DoneAll.default;
	  }
	});
	Object.defineProperty(exports, "DoneAllOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DoneAllOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DoneAllRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DoneAllRounded.default;
	  }
	});
	Object.defineProperty(exports, "DoneAllSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DoneAllSharp.default;
	  }
	});
	Object.defineProperty(exports, "DoneAllTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DoneAllTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DoneOutline", {
	  enumerable: true,
	  get: function get() {
	    return _DoneOutline.default;
	  }
	});
	Object.defineProperty(exports, "DoneOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DoneOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DoneOutlineOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DoneOutlineOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DoneOutlineRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DoneOutlineRounded.default;
	  }
	});
	Object.defineProperty(exports, "DoneOutlineSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DoneOutlineSharp.default;
	  }
	});
	Object.defineProperty(exports, "DoneOutlineTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DoneOutlineTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DoneRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DoneRounded.default;
	  }
	});
	Object.defineProperty(exports, "DoneSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DoneSharp.default;
	  }
	});
	Object.defineProperty(exports, "DoneTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DoneTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DonutLarge", {
	  enumerable: true,
	  get: function get() {
	    return _DonutLarge.default;
	  }
	});
	Object.defineProperty(exports, "DonutLargeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DonutLargeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DonutLargeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DonutLargeRounded.default;
	  }
	});
	Object.defineProperty(exports, "DonutLargeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DonutLargeSharp.default;
	  }
	});
	Object.defineProperty(exports, "DonutLargeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DonutLargeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DonutSmall", {
	  enumerable: true,
	  get: function get() {
	    return _DonutSmall.default;
	  }
	});
	Object.defineProperty(exports, "DonutSmallOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DonutSmallOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DonutSmallRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DonutSmallRounded.default;
	  }
	});
	Object.defineProperty(exports, "DonutSmallSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DonutSmallSharp.default;
	  }
	});
	Object.defineProperty(exports, "DonutSmallTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DonutSmallTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DoubleArrow", {
	  enumerable: true,
	  get: function get() {
	    return _DoubleArrow.default;
	  }
	});
	Object.defineProperty(exports, "DoubleArrowOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DoubleArrowOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DoubleArrowRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DoubleArrowRounded.default;
	  }
	});
	Object.defineProperty(exports, "DoubleArrowSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DoubleArrowSharp.default;
	  }
	});
	Object.defineProperty(exports, "DoubleArrowTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DoubleArrowTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Drafts", {
	  enumerable: true,
	  get: function get() {
	    return _Drafts.default;
	  }
	});
	Object.defineProperty(exports, "DraftsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DraftsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DraftsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DraftsRounded.default;
	  }
	});
	Object.defineProperty(exports, "DraftsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DraftsSharp.default;
	  }
	});
	Object.defineProperty(exports, "DraftsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DraftsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DragHandle", {
	  enumerable: true,
	  get: function get() {
	    return _DragHandle.default;
	  }
	});
	Object.defineProperty(exports, "DragHandleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DragHandleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DragHandleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DragHandleRounded.default;
	  }
	});
	Object.defineProperty(exports, "DragHandleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DragHandleSharp.default;
	  }
	});
	Object.defineProperty(exports, "DragHandleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DragHandleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DragIndicator", {
	  enumerable: true,
	  get: function get() {
	    return _DragIndicator.default;
	  }
	});
	Object.defineProperty(exports, "DragIndicatorOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DragIndicatorOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DragIndicatorRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DragIndicatorRounded.default;
	  }
	});
	Object.defineProperty(exports, "DragIndicatorSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DragIndicatorSharp.default;
	  }
	});
	Object.defineProperty(exports, "DragIndicatorTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DragIndicatorTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DriveEta", {
	  enumerable: true,
	  get: function get() {
	    return _DriveEta.default;
	  }
	});
	Object.defineProperty(exports, "DriveEtaOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DriveEtaOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DriveEtaRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DriveEtaRounded.default;
	  }
	});
	Object.defineProperty(exports, "DriveEtaSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DriveEtaSharp.default;
	  }
	});
	Object.defineProperty(exports, "DriveEtaTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DriveEtaTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Duo", {
	  enumerable: true,
	  get: function get() {
	    return _Duo.default;
	  }
	});
	Object.defineProperty(exports, "DuoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DuoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DuoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DuoRounded.default;
	  }
	});
	Object.defineProperty(exports, "DuoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DuoSharp.default;
	  }
	});
	Object.defineProperty(exports, "DuoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DuoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Dvr", {
	  enumerable: true,
	  get: function get() {
	    return _Dvr.default;
	  }
	});
	Object.defineProperty(exports, "DvrOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DvrOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DvrRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DvrRounded.default;
	  }
	});
	Object.defineProperty(exports, "DvrSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DvrSharp.default;
	  }
	});
	Object.defineProperty(exports, "DvrTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DvrTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "DynamicFeed", {
	  enumerable: true,
	  get: function get() {
	    return _DynamicFeed.default;
	  }
	});
	Object.defineProperty(exports, "DynamicFeedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _DynamicFeedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "DynamicFeedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _DynamicFeedRounded.default;
	  }
	});
	Object.defineProperty(exports, "DynamicFeedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _DynamicFeedSharp.default;
	  }
	});
	Object.defineProperty(exports, "DynamicFeedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _DynamicFeedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Eco", {
	  enumerable: true,
	  get: function get() {
	    return _Eco.default;
	  }
	});
	Object.defineProperty(exports, "EcoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EcoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EcoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EcoRounded.default;
	  }
	});
	Object.defineProperty(exports, "EcoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EcoSharp.default;
	  }
	});
	Object.defineProperty(exports, "EcoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EcoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Edit", {
	  enumerable: true,
	  get: function get() {
	    return _Edit.default;
	  }
	});
	Object.defineProperty(exports, "EditAttributes", {
	  enumerable: true,
	  get: function get() {
	    return _EditAttributes.default;
	  }
	});
	Object.defineProperty(exports, "EditAttributesOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EditAttributesOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EditAttributesRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EditAttributesRounded.default;
	  }
	});
	Object.defineProperty(exports, "EditAttributesSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EditAttributesSharp.default;
	  }
	});
	Object.defineProperty(exports, "EditAttributesTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EditAttributesTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "EditLocation", {
	  enumerable: true,
	  get: function get() {
	    return _EditLocation.default;
	  }
	});
	Object.defineProperty(exports, "EditLocationOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EditLocationOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EditLocationRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EditLocationRounded.default;
	  }
	});
	Object.defineProperty(exports, "EditLocationSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EditLocationSharp.default;
	  }
	});
	Object.defineProperty(exports, "EditLocationTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EditLocationTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "EditOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EditOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EditRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EditRounded.default;
	  }
	});
	Object.defineProperty(exports, "EditSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EditSharp.default;
	  }
	});
	Object.defineProperty(exports, "EditTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EditTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Eject", {
	  enumerable: true,
	  get: function get() {
	    return _Eject.default;
	  }
	});
	Object.defineProperty(exports, "EjectOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EjectOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EjectRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EjectRounded.default;
	  }
	});
	Object.defineProperty(exports, "EjectSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EjectSharp.default;
	  }
	});
	Object.defineProperty(exports, "EjectTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EjectTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Email", {
	  enumerable: true,
	  get: function get() {
	    return _Email.default;
	  }
	});
	Object.defineProperty(exports, "EmailOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EmailOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EmailRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EmailRounded.default;
	  }
	});
	Object.defineProperty(exports, "EmailSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EmailSharp.default;
	  }
	});
	Object.defineProperty(exports, "EmailTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EmailTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "EmojiEmotions", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiEmotions.default;
	  }
	});
	Object.defineProperty(exports, "EmojiEmotionsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiEmotionsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EmojiEmotionsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiEmotionsRounded.default;
	  }
	});
	Object.defineProperty(exports, "EmojiEmotionsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiEmotionsSharp.default;
	  }
	});
	Object.defineProperty(exports, "EmojiEmotionsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiEmotionsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "EmojiEvents", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiEvents.default;
	  }
	});
	Object.defineProperty(exports, "EmojiEventsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiEventsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EmojiEventsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiEventsRounded.default;
	  }
	});
	Object.defineProperty(exports, "EmojiEventsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiEventsSharp.default;
	  }
	});
	Object.defineProperty(exports, "EmojiEventsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiEventsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "EmojiFlags", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiFlags.default;
	  }
	});
	Object.defineProperty(exports, "EmojiFlagsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiFlagsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EmojiFlagsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiFlagsRounded.default;
	  }
	});
	Object.defineProperty(exports, "EmojiFlagsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiFlagsSharp.default;
	  }
	});
	Object.defineProperty(exports, "EmojiFlagsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiFlagsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "EmojiFoodBeverage", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiFoodBeverage.default;
	  }
	});
	Object.defineProperty(exports, "EmojiFoodBeverageOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiFoodBeverageOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EmojiFoodBeverageRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiFoodBeverageRounded.default;
	  }
	});
	Object.defineProperty(exports, "EmojiFoodBeverageSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiFoodBeverageSharp.default;
	  }
	});
	Object.defineProperty(exports, "EmojiFoodBeverageTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiFoodBeverageTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "EmojiNature", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiNature.default;
	  }
	});
	Object.defineProperty(exports, "EmojiNatureOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiNatureOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EmojiNatureRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiNatureRounded.default;
	  }
	});
	Object.defineProperty(exports, "EmojiNatureSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiNatureSharp.default;
	  }
	});
	Object.defineProperty(exports, "EmojiNatureTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiNatureTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "EmojiObjects", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiObjects.default;
	  }
	});
	Object.defineProperty(exports, "EmojiObjectsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiObjectsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EmojiObjectsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiObjectsRounded.default;
	  }
	});
	Object.defineProperty(exports, "EmojiObjectsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiObjectsSharp.default;
	  }
	});
	Object.defineProperty(exports, "EmojiObjectsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiObjectsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "EmojiPeople", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiPeople.default;
	  }
	});
	Object.defineProperty(exports, "EmojiPeopleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiPeopleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EmojiPeopleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiPeopleRounded.default;
	  }
	});
	Object.defineProperty(exports, "EmojiPeopleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiPeopleSharp.default;
	  }
	});
	Object.defineProperty(exports, "EmojiPeopleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiPeopleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "EmojiSymbols", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiSymbols.default;
	  }
	});
	Object.defineProperty(exports, "EmojiSymbolsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiSymbolsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EmojiSymbolsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiSymbolsRounded.default;
	  }
	});
	Object.defineProperty(exports, "EmojiSymbolsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiSymbolsSharp.default;
	  }
	});
	Object.defineProperty(exports, "EmojiSymbolsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiSymbolsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "EmojiTransportation", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiTransportation.default;
	  }
	});
	Object.defineProperty(exports, "EmojiTransportationOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiTransportationOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EmojiTransportationRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiTransportationRounded.default;
	  }
	});
	Object.defineProperty(exports, "EmojiTransportationSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiTransportationSharp.default;
	  }
	});
	Object.defineProperty(exports, "EmojiTransportationTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EmojiTransportationTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "EnhancedEncryption", {
	  enumerable: true,
	  get: function get() {
	    return _EnhancedEncryption.default;
	  }
	});
	Object.defineProperty(exports, "EnhancedEncryptionOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EnhancedEncryptionOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EnhancedEncryptionRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EnhancedEncryptionRounded.default;
	  }
	});
	Object.defineProperty(exports, "EnhancedEncryptionSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EnhancedEncryptionSharp.default;
	  }
	});
	Object.defineProperty(exports, "EnhancedEncryptionTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EnhancedEncryptionTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Equalizer", {
	  enumerable: true,
	  get: function get() {
	    return _Equalizer.default;
	  }
	});
	Object.defineProperty(exports, "EqualizerOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EqualizerOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EqualizerRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EqualizerRounded.default;
	  }
	});
	Object.defineProperty(exports, "EqualizerSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EqualizerSharp.default;
	  }
	});
	Object.defineProperty(exports, "EqualizerTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EqualizerTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Error", {
	  enumerable: true,
	  get: function get() {
	    return _Error.default;
	  }
	});
	Object.defineProperty(exports, "ErrorOutline", {
	  enumerable: true,
	  get: function get() {
	    return _ErrorOutline.default;
	  }
	});
	Object.defineProperty(exports, "ErrorOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ErrorOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ErrorOutlineOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ErrorOutlineOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ErrorOutlineRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ErrorOutlineRounded.default;
	  }
	});
	Object.defineProperty(exports, "ErrorOutlineSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ErrorOutlineSharp.default;
	  }
	});
	Object.defineProperty(exports, "ErrorOutlineTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ErrorOutlineTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ErrorRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ErrorRounded.default;
	  }
	});
	Object.defineProperty(exports, "ErrorSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ErrorSharp.default;
	  }
	});
	Object.defineProperty(exports, "ErrorTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ErrorTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Euro", {
	  enumerable: true,
	  get: function get() {
	    return _Euro.default;
	  }
	});
	Object.defineProperty(exports, "EuroOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EuroOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EuroRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EuroRounded.default;
	  }
	});
	Object.defineProperty(exports, "EuroSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EuroSharp.default;
	  }
	});
	Object.defineProperty(exports, "EuroSymbol", {
	  enumerable: true,
	  get: function get() {
	    return _EuroSymbol.default;
	  }
	});
	Object.defineProperty(exports, "EuroSymbolOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EuroSymbolOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EuroSymbolRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EuroSymbolRounded.default;
	  }
	});
	Object.defineProperty(exports, "EuroSymbolSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EuroSymbolSharp.default;
	  }
	});
	Object.defineProperty(exports, "EuroSymbolTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EuroSymbolTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "EuroTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EuroTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Event", {
	  enumerable: true,
	  get: function get() {
	    return _Event.default;
	  }
	});
	Object.defineProperty(exports, "EventAvailable", {
	  enumerable: true,
	  get: function get() {
	    return _EventAvailable.default;
	  }
	});
	Object.defineProperty(exports, "EventAvailableOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EventAvailableOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EventAvailableRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EventAvailableRounded.default;
	  }
	});
	Object.defineProperty(exports, "EventAvailableSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EventAvailableSharp.default;
	  }
	});
	Object.defineProperty(exports, "EventAvailableTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EventAvailableTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "EventBusy", {
	  enumerable: true,
	  get: function get() {
	    return _EventBusy.default;
	  }
	});
	Object.defineProperty(exports, "EventBusyOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EventBusyOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EventBusyRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EventBusyRounded.default;
	  }
	});
	Object.defineProperty(exports, "EventBusySharp", {
	  enumerable: true,
	  get: function get() {
	    return _EventBusySharp.default;
	  }
	});
	Object.defineProperty(exports, "EventBusyTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EventBusyTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "EventNote", {
	  enumerable: true,
	  get: function get() {
	    return _EventNote.default;
	  }
	});
	Object.defineProperty(exports, "EventNoteOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EventNoteOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EventNoteRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EventNoteRounded.default;
	  }
	});
	Object.defineProperty(exports, "EventNoteSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EventNoteSharp.default;
	  }
	});
	Object.defineProperty(exports, "EventNoteTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EventNoteTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "EventOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EventOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EventRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EventRounded.default;
	  }
	});
	Object.defineProperty(exports, "EventSeat", {
	  enumerable: true,
	  get: function get() {
	    return _EventSeat.default;
	  }
	});
	Object.defineProperty(exports, "EventSeatOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EventSeatOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EventSeatRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EventSeatRounded.default;
	  }
	});
	Object.defineProperty(exports, "EventSeatSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EventSeatSharp.default;
	  }
	});
	Object.defineProperty(exports, "EventSeatTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EventSeatTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "EventSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EventSharp.default;
	  }
	});
	Object.defineProperty(exports, "EventTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EventTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "EvStation", {
	  enumerable: true,
	  get: function get() {
	    return _EvStation.default;
	  }
	});
	Object.defineProperty(exports, "EvStationOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _EvStationOutlined.default;
	  }
	});
	Object.defineProperty(exports, "EvStationRounded", {
	  enumerable: true,
	  get: function get() {
	    return _EvStationRounded.default;
	  }
	});
	Object.defineProperty(exports, "EvStationSharp", {
	  enumerable: true,
	  get: function get() {
	    return _EvStationSharp.default;
	  }
	});
	Object.defineProperty(exports, "EvStationTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _EvStationTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ExitToApp", {
	  enumerable: true,
	  get: function get() {
	    return _ExitToApp.default;
	  }
	});
	Object.defineProperty(exports, "ExitToAppOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ExitToAppOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ExitToAppRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ExitToAppRounded.default;
	  }
	});
	Object.defineProperty(exports, "ExitToAppSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ExitToAppSharp.default;
	  }
	});
	Object.defineProperty(exports, "ExitToAppTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ExitToAppTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ExpandLess", {
	  enumerable: true,
	  get: function get() {
	    return _ExpandLess.default;
	  }
	});
	Object.defineProperty(exports, "ExpandLessOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ExpandLessOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ExpandLessRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ExpandLessRounded.default;
	  }
	});
	Object.defineProperty(exports, "ExpandLessSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ExpandLessSharp.default;
	  }
	});
	Object.defineProperty(exports, "ExpandLessTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ExpandLessTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ExpandMore", {
	  enumerable: true,
	  get: function get() {
	    return _ExpandMore.default;
	  }
	});
	Object.defineProperty(exports, "ExpandMoreOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ExpandMoreOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ExpandMoreRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ExpandMoreRounded.default;
	  }
	});
	Object.defineProperty(exports, "ExpandMoreSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ExpandMoreSharp.default;
	  }
	});
	Object.defineProperty(exports, "ExpandMoreTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ExpandMoreTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Explicit", {
	  enumerable: true,
	  get: function get() {
	    return _Explicit.default;
	  }
	});
	Object.defineProperty(exports, "ExplicitOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ExplicitOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ExplicitRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ExplicitRounded.default;
	  }
	});
	Object.defineProperty(exports, "ExplicitSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ExplicitSharp.default;
	  }
	});
	Object.defineProperty(exports, "ExplicitTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ExplicitTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Explore", {
	  enumerable: true,
	  get: function get() {
	    return _Explore.default;
	  }
	});
	Object.defineProperty(exports, "ExploreOff", {
	  enumerable: true,
	  get: function get() {
	    return _ExploreOff.default;
	  }
	});
	Object.defineProperty(exports, "ExploreOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ExploreOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ExploreOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ExploreOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "ExploreOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ExploreOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "ExploreOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ExploreOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ExploreOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ExploreOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ExploreRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ExploreRounded.default;
	  }
	});
	Object.defineProperty(exports, "ExploreSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ExploreSharp.default;
	  }
	});
	Object.defineProperty(exports, "ExploreTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ExploreTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Exposure", {
	  enumerable: true,
	  get: function get() {
	    return _Exposure.default;
	  }
	});
	Object.defineProperty(exports, "ExposureNeg1", {
	  enumerable: true,
	  get: function get() {
	    return _ExposureNeg.default;
	  }
	});
	Object.defineProperty(exports, "ExposureNeg1Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _ExposureNeg1Outlined.default;
	  }
	});
	Object.defineProperty(exports, "ExposureNeg1Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _ExposureNeg1Rounded.default;
	  }
	});
	Object.defineProperty(exports, "ExposureNeg1Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _ExposureNeg1Sharp.default;
	  }
	});
	Object.defineProperty(exports, "ExposureNeg1TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ExposureNeg1TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ExposureNeg2", {
	  enumerable: true,
	  get: function get() {
	    return _ExposureNeg2.default;
	  }
	});
	Object.defineProperty(exports, "ExposureNeg2Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _ExposureNeg2Outlined.default;
	  }
	});
	Object.defineProperty(exports, "ExposureNeg2Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _ExposureNeg2Rounded.default;
	  }
	});
	Object.defineProperty(exports, "ExposureNeg2Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _ExposureNeg2Sharp.default;
	  }
	});
	Object.defineProperty(exports, "ExposureNeg2TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ExposureNeg2TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ExposureOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ExposureOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ExposurePlus1", {
	  enumerable: true,
	  get: function get() {
	    return _ExposurePlus.default;
	  }
	});
	Object.defineProperty(exports, "ExposurePlus1Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _ExposurePlus1Outlined.default;
	  }
	});
	Object.defineProperty(exports, "ExposurePlus1Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _ExposurePlus1Rounded.default;
	  }
	});
	Object.defineProperty(exports, "ExposurePlus1Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _ExposurePlus1Sharp.default;
	  }
	});
	Object.defineProperty(exports, "ExposurePlus1TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ExposurePlus1TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ExposurePlus2", {
	  enumerable: true,
	  get: function get() {
	    return _ExposurePlus2.default;
	  }
	});
	Object.defineProperty(exports, "ExposurePlus2Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _ExposurePlus2Outlined.default;
	  }
	});
	Object.defineProperty(exports, "ExposurePlus2Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _ExposurePlus2Rounded.default;
	  }
	});
	Object.defineProperty(exports, "ExposurePlus2Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _ExposurePlus2Sharp.default;
	  }
	});
	Object.defineProperty(exports, "ExposurePlus2TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ExposurePlus2TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ExposureRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ExposureRounded.default;
	  }
	});
	Object.defineProperty(exports, "ExposureSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ExposureSharp.default;
	  }
	});
	Object.defineProperty(exports, "ExposureTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ExposureTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ExposureZero", {
	  enumerable: true,
	  get: function get() {
	    return _ExposureZero.default;
	  }
	});
	Object.defineProperty(exports, "ExposureZeroOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ExposureZeroOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ExposureZeroRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ExposureZeroRounded.default;
	  }
	});
	Object.defineProperty(exports, "ExposureZeroSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ExposureZeroSharp.default;
	  }
	});
	Object.defineProperty(exports, "ExposureZeroTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ExposureZeroTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Extension", {
	  enumerable: true,
	  get: function get() {
	    return _Extension.default;
	  }
	});
	Object.defineProperty(exports, "ExtensionOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ExtensionOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ExtensionRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ExtensionRounded.default;
	  }
	});
	Object.defineProperty(exports, "ExtensionSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ExtensionSharp.default;
	  }
	});
	Object.defineProperty(exports, "ExtensionTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ExtensionTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Face", {
	  enumerable: true,
	  get: function get() {
	    return _Face.default;
	  }
	});
	Object.defineProperty(exports, "Facebook", {
	  enumerable: true,
	  get: function get() {
	    return _Facebook.default;
	  }
	});
	Object.defineProperty(exports, "FaceOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FaceOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FaceRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FaceRounded.default;
	  }
	});
	Object.defineProperty(exports, "FaceSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FaceSharp.default;
	  }
	});
	Object.defineProperty(exports, "FaceTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FaceTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Fastfood", {
	  enumerable: true,
	  get: function get() {
	    return _Fastfood.default;
	  }
	});
	Object.defineProperty(exports, "FastfoodOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FastfoodOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FastfoodRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FastfoodRounded.default;
	  }
	});
	Object.defineProperty(exports, "FastfoodSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FastfoodSharp.default;
	  }
	});
	Object.defineProperty(exports, "FastfoodTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FastfoodTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FastForward", {
	  enumerable: true,
	  get: function get() {
	    return _FastForward.default;
	  }
	});
	Object.defineProperty(exports, "FastForwardOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FastForwardOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FastForwardRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FastForwardRounded.default;
	  }
	});
	Object.defineProperty(exports, "FastForwardSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FastForwardSharp.default;
	  }
	});
	Object.defineProperty(exports, "FastForwardTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FastForwardTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FastRewind", {
	  enumerable: true,
	  get: function get() {
	    return _FastRewind.default;
	  }
	});
	Object.defineProperty(exports, "FastRewindOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FastRewindOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FastRewindRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FastRewindRounded.default;
	  }
	});
	Object.defineProperty(exports, "FastRewindSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FastRewindSharp.default;
	  }
	});
	Object.defineProperty(exports, "FastRewindTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FastRewindTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Favorite", {
	  enumerable: true,
	  get: function get() {
	    return _Favorite.default;
	  }
	});
	Object.defineProperty(exports, "FavoriteBorder", {
	  enumerable: true,
	  get: function get() {
	    return _FavoriteBorder.default;
	  }
	});
	Object.defineProperty(exports, "FavoriteBorderOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FavoriteBorderOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FavoriteBorderRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FavoriteBorderRounded.default;
	  }
	});
	Object.defineProperty(exports, "FavoriteBorderSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FavoriteBorderSharp.default;
	  }
	});
	Object.defineProperty(exports, "FavoriteBorderTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FavoriteBorderTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FavoriteOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FavoriteOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FavoriteRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FavoriteRounded.default;
	  }
	});
	Object.defineProperty(exports, "FavoriteSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FavoriteSharp.default;
	  }
	});
	Object.defineProperty(exports, "FavoriteTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FavoriteTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FeaturedPlayList", {
	  enumerable: true,
	  get: function get() {
	    return _FeaturedPlayList.default;
	  }
	});
	Object.defineProperty(exports, "FeaturedPlayListOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FeaturedPlayListOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FeaturedPlayListRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FeaturedPlayListRounded.default;
	  }
	});
	Object.defineProperty(exports, "FeaturedPlayListSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FeaturedPlayListSharp.default;
	  }
	});
	Object.defineProperty(exports, "FeaturedPlayListTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FeaturedPlayListTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FeaturedVideo", {
	  enumerable: true,
	  get: function get() {
	    return _FeaturedVideo.default;
	  }
	});
	Object.defineProperty(exports, "FeaturedVideoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FeaturedVideoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FeaturedVideoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FeaturedVideoRounded.default;
	  }
	});
	Object.defineProperty(exports, "FeaturedVideoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FeaturedVideoSharp.default;
	  }
	});
	Object.defineProperty(exports, "FeaturedVideoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FeaturedVideoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Feedback", {
	  enumerable: true,
	  get: function get() {
	    return _Feedback.default;
	  }
	});
	Object.defineProperty(exports, "FeedbackOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FeedbackOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FeedbackRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FeedbackRounded.default;
	  }
	});
	Object.defineProperty(exports, "FeedbackSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FeedbackSharp.default;
	  }
	});
	Object.defineProperty(exports, "FeedbackTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FeedbackTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FiberDvr", {
	  enumerable: true,
	  get: function get() {
	    return _FiberDvr.default;
	  }
	});
	Object.defineProperty(exports, "FiberDvrOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FiberDvrOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FiberDvrRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FiberDvrRounded.default;
	  }
	});
	Object.defineProperty(exports, "FiberDvrSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FiberDvrSharp.default;
	  }
	});
	Object.defineProperty(exports, "FiberDvrTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FiberDvrTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FiberManualRecord", {
	  enumerable: true,
	  get: function get() {
	    return _FiberManualRecord.default;
	  }
	});
	Object.defineProperty(exports, "FiberManualRecordOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FiberManualRecordOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FiberManualRecordRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FiberManualRecordRounded.default;
	  }
	});
	Object.defineProperty(exports, "FiberManualRecordSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FiberManualRecordSharp.default;
	  }
	});
	Object.defineProperty(exports, "FiberManualRecordTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FiberManualRecordTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FiberNew", {
	  enumerable: true,
	  get: function get() {
	    return _FiberNew.default;
	  }
	});
	Object.defineProperty(exports, "FiberNewOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FiberNewOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FiberNewRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FiberNewRounded.default;
	  }
	});
	Object.defineProperty(exports, "FiberNewSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FiberNewSharp.default;
	  }
	});
	Object.defineProperty(exports, "FiberNewTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FiberNewTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FiberPin", {
	  enumerable: true,
	  get: function get() {
	    return _FiberPin.default;
	  }
	});
	Object.defineProperty(exports, "FiberPinOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FiberPinOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FiberPinRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FiberPinRounded.default;
	  }
	});
	Object.defineProperty(exports, "FiberPinSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FiberPinSharp.default;
	  }
	});
	Object.defineProperty(exports, "FiberPinTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FiberPinTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FiberSmartRecord", {
	  enumerable: true,
	  get: function get() {
	    return _FiberSmartRecord.default;
	  }
	});
	Object.defineProperty(exports, "FiberSmartRecordOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FiberSmartRecordOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FiberSmartRecordRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FiberSmartRecordRounded.default;
	  }
	});
	Object.defineProperty(exports, "FiberSmartRecordSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FiberSmartRecordSharp.default;
	  }
	});
	Object.defineProperty(exports, "FiberSmartRecordTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FiberSmartRecordTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FileCopy", {
	  enumerable: true,
	  get: function get() {
	    return _FileCopy.default;
	  }
	});
	Object.defineProperty(exports, "FileCopyOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FileCopyOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FileCopyRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FileCopyRounded.default;
	  }
	});
	Object.defineProperty(exports, "FileCopySharp", {
	  enumerable: true,
	  get: function get() {
	    return _FileCopySharp.default;
	  }
	});
	Object.defineProperty(exports, "FileCopyTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FileCopyTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Filter", {
	  enumerable: true,
	  get: function get() {
	    return _Filter.default;
	  }
	});
	Object.defineProperty(exports, "Filter1", {
	  enumerable: true,
	  get: function get() {
	    return _Filter2.default;
	  }
	});
	Object.defineProperty(exports, "Filter1Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Filter1Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Filter1Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Filter1Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Filter1Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Filter1Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Filter1TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Filter1TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Filter2", {
	  enumerable: true,
	  get: function get() {
	    return _Filter3.default;
	  }
	});
	Object.defineProperty(exports, "Filter2Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Filter2Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Filter2Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Filter2Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Filter2Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Filter2Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Filter2TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Filter2TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Filter3", {
	  enumerable: true,
	  get: function get() {
	    return _Filter4.default;
	  }
	});
	Object.defineProperty(exports, "Filter3Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Filter3Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Filter3Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Filter3Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Filter3Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Filter3Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Filter3TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Filter3TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Filter4", {
	  enumerable: true,
	  get: function get() {
	    return _Filter5.default;
	  }
	});
	Object.defineProperty(exports, "Filter4Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Filter4Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Filter4Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Filter4Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Filter4Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Filter4Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Filter4TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Filter4TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Filter5", {
	  enumerable: true,
	  get: function get() {
	    return _Filter6.default;
	  }
	});
	Object.defineProperty(exports, "Filter5Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Filter5Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Filter5Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Filter5Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Filter5Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Filter5Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Filter5TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Filter5TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Filter6", {
	  enumerable: true,
	  get: function get() {
	    return _Filter7.default;
	  }
	});
	Object.defineProperty(exports, "Filter6Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Filter6Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Filter6Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Filter6Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Filter6Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Filter6Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Filter6TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Filter6TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Filter7", {
	  enumerable: true,
	  get: function get() {
	    return _Filter8.default;
	  }
	});
	Object.defineProperty(exports, "Filter7Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Filter7Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Filter7Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Filter7Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Filter7Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Filter7Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Filter7TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Filter7TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Filter8", {
	  enumerable: true,
	  get: function get() {
	    return _Filter9.default;
	  }
	});
	Object.defineProperty(exports, "Filter8Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Filter8Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Filter8Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Filter8Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Filter8Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Filter8Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Filter8TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Filter8TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Filter9", {
	  enumerable: true,
	  get: function get() {
	    return _Filter10.default;
	  }
	});
	Object.defineProperty(exports, "Filter9Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Filter9Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Filter9Plus", {
	  enumerable: true,
	  get: function get() {
	    return _Filter9Plus.default;
	  }
	});
	Object.defineProperty(exports, "Filter9PlusOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _Filter9PlusOutlined.default;
	  }
	});
	Object.defineProperty(exports, "Filter9PlusRounded", {
	  enumerable: true,
	  get: function get() {
	    return _Filter9PlusRounded.default;
	  }
	});
	Object.defineProperty(exports, "Filter9PlusSharp", {
	  enumerable: true,
	  get: function get() {
	    return _Filter9PlusSharp.default;
	  }
	});
	Object.defineProperty(exports, "Filter9PlusTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Filter9PlusTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Filter9Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Filter9Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Filter9Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Filter9Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Filter9TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Filter9TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FilterBAndW", {
	  enumerable: true,
	  get: function get() {
	    return _FilterBAndW.default;
	  }
	});
	Object.defineProperty(exports, "FilterBAndWOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FilterBAndWOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FilterBAndWRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FilterBAndWRounded.default;
	  }
	});
	Object.defineProperty(exports, "FilterBAndWSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FilterBAndWSharp.default;
	  }
	});
	Object.defineProperty(exports, "FilterBAndWTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FilterBAndWTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FilterCenterFocus", {
	  enumerable: true,
	  get: function get() {
	    return _FilterCenterFocus.default;
	  }
	});
	Object.defineProperty(exports, "FilterCenterFocusOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FilterCenterFocusOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FilterCenterFocusRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FilterCenterFocusRounded.default;
	  }
	});
	Object.defineProperty(exports, "FilterCenterFocusSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FilterCenterFocusSharp.default;
	  }
	});
	Object.defineProperty(exports, "FilterCenterFocusTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FilterCenterFocusTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FilterDrama", {
	  enumerable: true,
	  get: function get() {
	    return _FilterDrama.default;
	  }
	});
	Object.defineProperty(exports, "FilterDramaOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FilterDramaOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FilterDramaRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FilterDramaRounded.default;
	  }
	});
	Object.defineProperty(exports, "FilterDramaSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FilterDramaSharp.default;
	  }
	});
	Object.defineProperty(exports, "FilterDramaTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FilterDramaTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FilterFrames", {
	  enumerable: true,
	  get: function get() {
	    return _FilterFrames.default;
	  }
	});
	Object.defineProperty(exports, "FilterFramesOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FilterFramesOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FilterFramesRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FilterFramesRounded.default;
	  }
	});
	Object.defineProperty(exports, "FilterFramesSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FilterFramesSharp.default;
	  }
	});
	Object.defineProperty(exports, "FilterFramesTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FilterFramesTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FilterHdr", {
	  enumerable: true,
	  get: function get() {
	    return _FilterHdr.default;
	  }
	});
	Object.defineProperty(exports, "FilterHdrOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FilterHdrOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FilterHdrRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FilterHdrRounded.default;
	  }
	});
	Object.defineProperty(exports, "FilterHdrSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FilterHdrSharp.default;
	  }
	});
	Object.defineProperty(exports, "FilterHdrTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FilterHdrTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FilterList", {
	  enumerable: true,
	  get: function get() {
	    return _FilterList.default;
	  }
	});
	Object.defineProperty(exports, "FilterListOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FilterListOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FilterListRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FilterListRounded.default;
	  }
	});
	Object.defineProperty(exports, "FilterListSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FilterListSharp.default;
	  }
	});
	Object.defineProperty(exports, "FilterListTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FilterListTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FilterNone", {
	  enumerable: true,
	  get: function get() {
	    return _FilterNone.default;
	  }
	});
	Object.defineProperty(exports, "FilterNoneOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FilterNoneOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FilterNoneRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FilterNoneRounded.default;
	  }
	});
	Object.defineProperty(exports, "FilterNoneSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FilterNoneSharp.default;
	  }
	});
	Object.defineProperty(exports, "FilterNoneTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FilterNoneTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FilterOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FilterOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FilterRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FilterRounded.default;
	  }
	});
	Object.defineProperty(exports, "FilterSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FilterSharp.default;
	  }
	});
	Object.defineProperty(exports, "FilterTiltShift", {
	  enumerable: true,
	  get: function get() {
	    return _FilterTiltShift.default;
	  }
	});
	Object.defineProperty(exports, "FilterTiltShiftOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FilterTiltShiftOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FilterTiltShiftRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FilterTiltShiftRounded.default;
	  }
	});
	Object.defineProperty(exports, "FilterTiltShiftSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FilterTiltShiftSharp.default;
	  }
	});
	Object.defineProperty(exports, "FilterTiltShiftTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FilterTiltShiftTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FilterTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FilterTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FilterVintage", {
	  enumerable: true,
	  get: function get() {
	    return _FilterVintage.default;
	  }
	});
	Object.defineProperty(exports, "FilterVintageOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FilterVintageOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FilterVintageRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FilterVintageRounded.default;
	  }
	});
	Object.defineProperty(exports, "FilterVintageSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FilterVintageSharp.default;
	  }
	});
	Object.defineProperty(exports, "FilterVintageTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FilterVintageTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FindInPage", {
	  enumerable: true,
	  get: function get() {
	    return _FindInPage.default;
	  }
	});
	Object.defineProperty(exports, "FindInPageOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FindInPageOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FindInPageRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FindInPageRounded.default;
	  }
	});
	Object.defineProperty(exports, "FindInPageSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FindInPageSharp.default;
	  }
	});
	Object.defineProperty(exports, "FindInPageTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FindInPageTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FindReplace", {
	  enumerable: true,
	  get: function get() {
	    return _FindReplace.default;
	  }
	});
	Object.defineProperty(exports, "FindReplaceOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FindReplaceOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FindReplaceRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FindReplaceRounded.default;
	  }
	});
	Object.defineProperty(exports, "FindReplaceSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FindReplaceSharp.default;
	  }
	});
	Object.defineProperty(exports, "FindReplaceTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FindReplaceTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Fingerprint", {
	  enumerable: true,
	  get: function get() {
	    return _Fingerprint.default;
	  }
	});
	Object.defineProperty(exports, "FingerprintOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FingerprintOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FingerprintRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FingerprintRounded.default;
	  }
	});
	Object.defineProperty(exports, "FingerprintSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FingerprintSharp.default;
	  }
	});
	Object.defineProperty(exports, "FingerprintTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FingerprintTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Fireplace", {
	  enumerable: true,
	  get: function get() {
	    return _Fireplace.default;
	  }
	});
	Object.defineProperty(exports, "FireplaceOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FireplaceOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FireplaceRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FireplaceRounded.default;
	  }
	});
	Object.defineProperty(exports, "FireplaceSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FireplaceSharp.default;
	  }
	});
	Object.defineProperty(exports, "FireplaceTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FireplaceTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FirstPage", {
	  enumerable: true,
	  get: function get() {
	    return _FirstPage.default;
	  }
	});
	Object.defineProperty(exports, "FirstPageOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FirstPageOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FirstPageRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FirstPageRounded.default;
	  }
	});
	Object.defineProperty(exports, "FirstPageSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FirstPageSharp.default;
	  }
	});
	Object.defineProperty(exports, "FirstPageTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FirstPageTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FitnessCenter", {
	  enumerable: true,
	  get: function get() {
	    return _FitnessCenter.default;
	  }
	});
	Object.defineProperty(exports, "FitnessCenterOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FitnessCenterOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FitnessCenterRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FitnessCenterRounded.default;
	  }
	});
	Object.defineProperty(exports, "FitnessCenterSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FitnessCenterSharp.default;
	  }
	});
	Object.defineProperty(exports, "FitnessCenterTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FitnessCenterTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Flag", {
	  enumerable: true,
	  get: function get() {
	    return _Flag.default;
	  }
	});
	Object.defineProperty(exports, "FlagOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FlagOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FlagRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FlagRounded.default;
	  }
	});
	Object.defineProperty(exports, "FlagSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FlagSharp.default;
	  }
	});
	Object.defineProperty(exports, "FlagTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FlagTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Flare", {
	  enumerable: true,
	  get: function get() {
	    return _Flare.default;
	  }
	});
	Object.defineProperty(exports, "FlareOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FlareOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FlareRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FlareRounded.default;
	  }
	});
	Object.defineProperty(exports, "FlareSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FlareSharp.default;
	  }
	});
	Object.defineProperty(exports, "FlareTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FlareTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FlashAuto", {
	  enumerable: true,
	  get: function get() {
	    return _FlashAuto.default;
	  }
	});
	Object.defineProperty(exports, "FlashAutoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FlashAutoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FlashAutoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FlashAutoRounded.default;
	  }
	});
	Object.defineProperty(exports, "FlashAutoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FlashAutoSharp.default;
	  }
	});
	Object.defineProperty(exports, "FlashAutoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FlashAutoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FlashOff", {
	  enumerable: true,
	  get: function get() {
	    return _FlashOff.default;
	  }
	});
	Object.defineProperty(exports, "FlashOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FlashOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FlashOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FlashOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "FlashOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FlashOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "FlashOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FlashOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FlashOn", {
	  enumerable: true,
	  get: function get() {
	    return _FlashOn.default;
	  }
	});
	Object.defineProperty(exports, "FlashOnOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FlashOnOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FlashOnRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FlashOnRounded.default;
	  }
	});
	Object.defineProperty(exports, "FlashOnSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FlashOnSharp.default;
	  }
	});
	Object.defineProperty(exports, "FlashOnTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FlashOnTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Flight", {
	  enumerable: true,
	  get: function get() {
	    return _Flight.default;
	  }
	});
	Object.defineProperty(exports, "FlightLand", {
	  enumerable: true,
	  get: function get() {
	    return _FlightLand.default;
	  }
	});
	Object.defineProperty(exports, "FlightLandOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FlightLandOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FlightLandRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FlightLandRounded.default;
	  }
	});
	Object.defineProperty(exports, "FlightLandSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FlightLandSharp.default;
	  }
	});
	Object.defineProperty(exports, "FlightLandTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FlightLandTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FlightOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FlightOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FlightRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FlightRounded.default;
	  }
	});
	Object.defineProperty(exports, "FlightSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FlightSharp.default;
	  }
	});
	Object.defineProperty(exports, "FlightTakeoff", {
	  enumerable: true,
	  get: function get() {
	    return _FlightTakeoff.default;
	  }
	});
	Object.defineProperty(exports, "FlightTakeoffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FlightTakeoffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FlightTakeoffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FlightTakeoffRounded.default;
	  }
	});
	Object.defineProperty(exports, "FlightTakeoffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FlightTakeoffSharp.default;
	  }
	});
	Object.defineProperty(exports, "FlightTakeoffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FlightTakeoffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FlightTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FlightTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Flip", {
	  enumerable: true,
	  get: function get() {
	    return _Flip.default;
	  }
	});
	Object.defineProperty(exports, "FlipCameraAndroid", {
	  enumerable: true,
	  get: function get() {
	    return _FlipCameraAndroid.default;
	  }
	});
	Object.defineProperty(exports, "FlipCameraAndroidOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FlipCameraAndroidOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FlipCameraAndroidRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FlipCameraAndroidRounded.default;
	  }
	});
	Object.defineProperty(exports, "FlipCameraAndroidSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FlipCameraAndroidSharp.default;
	  }
	});
	Object.defineProperty(exports, "FlipCameraAndroidTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FlipCameraAndroidTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FlipCameraIos", {
	  enumerable: true,
	  get: function get() {
	    return _FlipCameraIos.default;
	  }
	});
	Object.defineProperty(exports, "FlipCameraIosOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FlipCameraIosOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FlipCameraIosRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FlipCameraIosRounded.default;
	  }
	});
	Object.defineProperty(exports, "FlipCameraIosSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FlipCameraIosSharp.default;
	  }
	});
	Object.defineProperty(exports, "FlipCameraIosTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FlipCameraIosTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FlipOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FlipOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FlipRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FlipRounded.default;
	  }
	});
	Object.defineProperty(exports, "FlipSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FlipSharp.default;
	  }
	});
	Object.defineProperty(exports, "FlipToBack", {
	  enumerable: true,
	  get: function get() {
	    return _FlipToBack.default;
	  }
	});
	Object.defineProperty(exports, "FlipToBackOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FlipToBackOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FlipToBackRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FlipToBackRounded.default;
	  }
	});
	Object.defineProperty(exports, "FlipToBackSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FlipToBackSharp.default;
	  }
	});
	Object.defineProperty(exports, "FlipToBackTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FlipToBackTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FlipToFront", {
	  enumerable: true,
	  get: function get() {
	    return _FlipToFront.default;
	  }
	});
	Object.defineProperty(exports, "FlipToFrontOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FlipToFrontOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FlipToFrontRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FlipToFrontRounded.default;
	  }
	});
	Object.defineProperty(exports, "FlipToFrontSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FlipToFrontSharp.default;
	  }
	});
	Object.defineProperty(exports, "FlipToFrontTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FlipToFrontTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FlipTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FlipTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Folder", {
	  enumerable: true,
	  get: function get() {
	    return _Folder.default;
	  }
	});
	Object.defineProperty(exports, "FolderOpen", {
	  enumerable: true,
	  get: function get() {
	    return _FolderOpen.default;
	  }
	});
	Object.defineProperty(exports, "FolderOpenOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FolderOpenOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FolderOpenRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FolderOpenRounded.default;
	  }
	});
	Object.defineProperty(exports, "FolderOpenSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FolderOpenSharp.default;
	  }
	});
	Object.defineProperty(exports, "FolderOpenTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FolderOpenTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FolderOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FolderOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FolderRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FolderRounded.default;
	  }
	});
	Object.defineProperty(exports, "FolderShared", {
	  enumerable: true,
	  get: function get() {
	    return _FolderShared.default;
	  }
	});
	Object.defineProperty(exports, "FolderSharedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FolderSharedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FolderSharedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FolderSharedRounded.default;
	  }
	});
	Object.defineProperty(exports, "FolderSharedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FolderSharedSharp.default;
	  }
	});
	Object.defineProperty(exports, "FolderSharedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FolderSharedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FolderSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FolderSharp.default;
	  }
	});
	Object.defineProperty(exports, "FolderSpecial", {
	  enumerable: true,
	  get: function get() {
	    return _FolderSpecial.default;
	  }
	});
	Object.defineProperty(exports, "FolderSpecialOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FolderSpecialOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FolderSpecialRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FolderSpecialRounded.default;
	  }
	});
	Object.defineProperty(exports, "FolderSpecialSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FolderSpecialSharp.default;
	  }
	});
	Object.defineProperty(exports, "FolderSpecialTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FolderSpecialTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FolderTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FolderTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FontDownload", {
	  enumerable: true,
	  get: function get() {
	    return _FontDownload.default;
	  }
	});
	Object.defineProperty(exports, "FontDownloadOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FontDownloadOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FontDownloadRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FontDownloadRounded.default;
	  }
	});
	Object.defineProperty(exports, "FontDownloadSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FontDownloadSharp.default;
	  }
	});
	Object.defineProperty(exports, "FontDownloadTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FontDownloadTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatAlignCenter", {
	  enumerable: true,
	  get: function get() {
	    return _FormatAlignCenter.default;
	  }
	});
	Object.defineProperty(exports, "FormatAlignCenterOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatAlignCenterOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatAlignCenterRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatAlignCenterRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatAlignCenterSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatAlignCenterSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatAlignCenterTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatAlignCenterTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatAlignJustify", {
	  enumerable: true,
	  get: function get() {
	    return _FormatAlignJustify.default;
	  }
	});
	Object.defineProperty(exports, "FormatAlignJustifyOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatAlignJustifyOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatAlignJustifyRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatAlignJustifyRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatAlignJustifySharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatAlignJustifySharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatAlignJustifyTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatAlignJustifyTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatAlignLeft", {
	  enumerable: true,
	  get: function get() {
	    return _FormatAlignLeft.default;
	  }
	});
	Object.defineProperty(exports, "FormatAlignLeftOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatAlignLeftOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatAlignLeftRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatAlignLeftRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatAlignLeftSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatAlignLeftSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatAlignLeftTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatAlignLeftTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatAlignRight", {
	  enumerable: true,
	  get: function get() {
	    return _FormatAlignRight.default;
	  }
	});
	Object.defineProperty(exports, "FormatAlignRightOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatAlignRightOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatAlignRightRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatAlignRightRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatAlignRightSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatAlignRightSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatAlignRightTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatAlignRightTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatBold", {
	  enumerable: true,
	  get: function get() {
	    return _FormatBold.default;
	  }
	});
	Object.defineProperty(exports, "FormatBoldOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatBoldOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatBoldRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatBoldRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatBoldSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatBoldSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatBoldTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatBoldTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatClear", {
	  enumerable: true,
	  get: function get() {
	    return _FormatClear.default;
	  }
	});
	Object.defineProperty(exports, "FormatClearOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatClearOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatClearRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatClearRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatClearSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatClearSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatClearTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatClearTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatColorFill", {
	  enumerable: true,
	  get: function get() {
	    return _FormatColorFill.default;
	  }
	});
	Object.defineProperty(exports, "FormatColorFillOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatColorFillOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatColorFillRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatColorFillRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatColorFillSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatColorFillSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatColorFillTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatColorFillTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatColorReset", {
	  enumerable: true,
	  get: function get() {
	    return _FormatColorReset.default;
	  }
	});
	Object.defineProperty(exports, "FormatColorResetOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatColorResetOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatColorResetRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatColorResetRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatColorResetSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatColorResetSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatColorResetTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatColorResetTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatColorText", {
	  enumerable: true,
	  get: function get() {
	    return _FormatColorText.default;
	  }
	});
	Object.defineProperty(exports, "FormatColorTextOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatColorTextOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatColorTextRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatColorTextRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatColorTextSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatColorTextSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatColorTextTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatColorTextTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatIndentDecrease", {
	  enumerable: true,
	  get: function get() {
	    return _FormatIndentDecrease.default;
	  }
	});
	Object.defineProperty(exports, "FormatIndentDecreaseOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatIndentDecreaseOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatIndentDecreaseRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatIndentDecreaseRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatIndentDecreaseSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatIndentDecreaseSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatIndentDecreaseTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatIndentDecreaseTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatIndentIncrease", {
	  enumerable: true,
	  get: function get() {
	    return _FormatIndentIncrease.default;
	  }
	});
	Object.defineProperty(exports, "FormatIndentIncreaseOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatIndentIncreaseOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatIndentIncreaseRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatIndentIncreaseRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatIndentIncreaseSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatIndentIncreaseSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatIndentIncreaseTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatIndentIncreaseTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatItalic", {
	  enumerable: true,
	  get: function get() {
	    return _FormatItalic.default;
	  }
	});
	Object.defineProperty(exports, "FormatItalicOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatItalicOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatItalicRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatItalicRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatItalicSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatItalicSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatItalicTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatItalicTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatLineSpacing", {
	  enumerable: true,
	  get: function get() {
	    return _FormatLineSpacing.default;
	  }
	});
	Object.defineProperty(exports, "FormatLineSpacingOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatLineSpacingOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatLineSpacingRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatLineSpacingRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatLineSpacingSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatLineSpacingSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatLineSpacingTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatLineSpacingTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatListBulleted", {
	  enumerable: true,
	  get: function get() {
	    return _FormatListBulleted.default;
	  }
	});
	Object.defineProperty(exports, "FormatListBulletedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatListBulletedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatListBulletedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatListBulletedRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatListBulletedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatListBulletedSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatListBulletedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatListBulletedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatListNumbered", {
	  enumerable: true,
	  get: function get() {
	    return _FormatListNumbered.default;
	  }
	});
	Object.defineProperty(exports, "FormatListNumberedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatListNumberedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatListNumberedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatListNumberedRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatListNumberedRtl", {
	  enumerable: true,
	  get: function get() {
	    return _FormatListNumberedRtl.default;
	  }
	});
	Object.defineProperty(exports, "FormatListNumberedRtlOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatListNumberedRtlOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatListNumberedRtlRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatListNumberedRtlRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatListNumberedRtlSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatListNumberedRtlSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatListNumberedRtlTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatListNumberedRtlTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatListNumberedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatListNumberedSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatListNumberedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatListNumberedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatPaint", {
	  enumerable: true,
	  get: function get() {
	    return _FormatPaint.default;
	  }
	});
	Object.defineProperty(exports, "FormatPaintOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatPaintOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatPaintRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatPaintRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatPaintSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatPaintSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatPaintTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatPaintTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatQuote", {
	  enumerable: true,
	  get: function get() {
	    return _FormatQuote.default;
	  }
	});
	Object.defineProperty(exports, "FormatQuoteOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatQuoteOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatQuoteRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatQuoteRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatQuoteSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatQuoteSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatQuoteTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatQuoteTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatShapes", {
	  enumerable: true,
	  get: function get() {
	    return _FormatShapes.default;
	  }
	});
	Object.defineProperty(exports, "FormatShapesOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatShapesOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatShapesRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatShapesRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatShapesSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatShapesSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatShapesTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatShapesTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatSize", {
	  enumerable: true,
	  get: function get() {
	    return _FormatSize.default;
	  }
	});
	Object.defineProperty(exports, "FormatSizeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatSizeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatSizeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatSizeRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatSizeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatSizeSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatSizeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatSizeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatStrikethrough", {
	  enumerable: true,
	  get: function get() {
	    return _FormatStrikethrough.default;
	  }
	});
	Object.defineProperty(exports, "FormatStrikethroughOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatStrikethroughOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatStrikethroughRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatStrikethroughRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatStrikethroughSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatStrikethroughSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatStrikethroughTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatStrikethroughTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatTextdirectionLToR", {
	  enumerable: true,
	  get: function get() {
	    return _FormatTextdirectionLToR.default;
	  }
	});
	Object.defineProperty(exports, "FormatTextdirectionLToROutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatTextdirectionLToROutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatTextdirectionLToRRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatTextdirectionLToRRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatTextdirectionLToRSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatTextdirectionLToRSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatTextdirectionLToRTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatTextdirectionLToRTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatTextdirectionRToL", {
	  enumerable: true,
	  get: function get() {
	    return _FormatTextdirectionRToL.default;
	  }
	});
	Object.defineProperty(exports, "FormatTextdirectionRToLOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatTextdirectionRToLOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatTextdirectionRToLRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatTextdirectionRToLRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatTextdirectionRToLSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatTextdirectionRToLSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatTextdirectionRToLTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatTextdirectionRToLTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FormatUnderlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatUnderlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatUnderlinedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FormatUnderlinedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FormatUnderlinedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FormatUnderlinedRounded.default;
	  }
	});
	Object.defineProperty(exports, "FormatUnderlinedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FormatUnderlinedSharp.default;
	  }
	});
	Object.defineProperty(exports, "FormatUnderlinedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FormatUnderlinedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Forum", {
	  enumerable: true,
	  get: function get() {
	    return _Forum.default;
	  }
	});
	Object.defineProperty(exports, "ForumOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ForumOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ForumRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ForumRounded.default;
	  }
	});
	Object.defineProperty(exports, "ForumSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ForumSharp.default;
	  }
	});
	Object.defineProperty(exports, "ForumTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ForumTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Forward", {
	  enumerable: true,
	  get: function get() {
	    return _Forward.default;
	  }
	});
	Object.defineProperty(exports, "Forward10", {
	  enumerable: true,
	  get: function get() {
	    return _Forward2.default;
	  }
	});
	Object.defineProperty(exports, "Forward10Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Forward10Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Forward10Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Forward10Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Forward10Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Forward10Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Forward10TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Forward10TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Forward30", {
	  enumerable: true,
	  get: function get() {
	    return _Forward3.default;
	  }
	});
	Object.defineProperty(exports, "Forward30Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Forward30Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Forward30Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Forward30Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Forward30Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Forward30Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Forward30TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Forward30TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Forward5", {
	  enumerable: true,
	  get: function get() {
	    return _Forward4.default;
	  }
	});
	Object.defineProperty(exports, "Forward5Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Forward5Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Forward5Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Forward5Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Forward5Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Forward5Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Forward5TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Forward5TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ForwardOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ForwardOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ForwardRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ForwardRounded.default;
	  }
	});
	Object.defineProperty(exports, "ForwardSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ForwardSharp.default;
	  }
	});
	Object.defineProperty(exports, "ForwardTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ForwardTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FourK", {
	  enumerable: true,
	  get: function get() {
	    return _FourK.default;
	  }
	});
	Object.defineProperty(exports, "FourKOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FourKOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FourKRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FourKRounded.default;
	  }
	});
	Object.defineProperty(exports, "FourKSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FourKSharp.default;
	  }
	});
	Object.defineProperty(exports, "FourKTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FourKTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FreeBreakfast", {
	  enumerable: true,
	  get: function get() {
	    return _FreeBreakfast.default;
	  }
	});
	Object.defineProperty(exports, "FreeBreakfastOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FreeBreakfastOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FreeBreakfastRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FreeBreakfastRounded.default;
	  }
	});
	Object.defineProperty(exports, "FreeBreakfastSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FreeBreakfastSharp.default;
	  }
	});
	Object.defineProperty(exports, "FreeBreakfastTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FreeBreakfastTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Fullscreen", {
	  enumerable: true,
	  get: function get() {
	    return _Fullscreen.default;
	  }
	});
	Object.defineProperty(exports, "FullscreenExit", {
	  enumerable: true,
	  get: function get() {
	    return _FullscreenExit.default;
	  }
	});
	Object.defineProperty(exports, "FullscreenExitOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FullscreenExitOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FullscreenExitRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FullscreenExitRounded.default;
	  }
	});
	Object.defineProperty(exports, "FullscreenExitSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FullscreenExitSharp.default;
	  }
	});
	Object.defineProperty(exports, "FullscreenExitTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FullscreenExitTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "FullscreenOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FullscreenOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FullscreenRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FullscreenRounded.default;
	  }
	});
	Object.defineProperty(exports, "FullscreenSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FullscreenSharp.default;
	  }
	});
	Object.defineProperty(exports, "FullscreenTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FullscreenTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Functions", {
	  enumerable: true,
	  get: function get() {
	    return _Functions.default;
	  }
	});
	Object.defineProperty(exports, "FunctionsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _FunctionsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "FunctionsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _FunctionsRounded.default;
	  }
	});
	Object.defineProperty(exports, "FunctionsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _FunctionsSharp.default;
	  }
	});
	Object.defineProperty(exports, "FunctionsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _FunctionsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Gamepad", {
	  enumerable: true,
	  get: function get() {
	    return _Gamepad.default;
	  }
	});
	Object.defineProperty(exports, "GamepadOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _GamepadOutlined.default;
	  }
	});
	Object.defineProperty(exports, "GamepadRounded", {
	  enumerable: true,
	  get: function get() {
	    return _GamepadRounded.default;
	  }
	});
	Object.defineProperty(exports, "GamepadSharp", {
	  enumerable: true,
	  get: function get() {
	    return _GamepadSharp.default;
	  }
	});
	Object.defineProperty(exports, "GamepadTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _GamepadTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Games", {
	  enumerable: true,
	  get: function get() {
	    return _Games.default;
	  }
	});
	Object.defineProperty(exports, "GamesOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _GamesOutlined.default;
	  }
	});
	Object.defineProperty(exports, "GamesRounded", {
	  enumerable: true,
	  get: function get() {
	    return _GamesRounded.default;
	  }
	});
	Object.defineProperty(exports, "GamesSharp", {
	  enumerable: true,
	  get: function get() {
	    return _GamesSharp.default;
	  }
	});
	Object.defineProperty(exports, "GamesTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _GamesTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Gavel", {
	  enumerable: true,
	  get: function get() {
	    return _Gavel.default;
	  }
	});
	Object.defineProperty(exports, "GavelOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _GavelOutlined.default;
	  }
	});
	Object.defineProperty(exports, "GavelRounded", {
	  enumerable: true,
	  get: function get() {
	    return _GavelRounded.default;
	  }
	});
	Object.defineProperty(exports, "GavelSharp", {
	  enumerable: true,
	  get: function get() {
	    return _GavelSharp.default;
	  }
	});
	Object.defineProperty(exports, "GavelTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _GavelTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Gesture", {
	  enumerable: true,
	  get: function get() {
	    return _Gesture.default;
	  }
	});
	Object.defineProperty(exports, "GestureOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _GestureOutlined.default;
	  }
	});
	Object.defineProperty(exports, "GestureRounded", {
	  enumerable: true,
	  get: function get() {
	    return _GestureRounded.default;
	  }
	});
	Object.defineProperty(exports, "GestureSharp", {
	  enumerable: true,
	  get: function get() {
	    return _GestureSharp.default;
	  }
	});
	Object.defineProperty(exports, "GestureTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _GestureTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "GetApp", {
	  enumerable: true,
	  get: function get() {
	    return _GetApp.default;
	  }
	});
	Object.defineProperty(exports, "GetAppOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _GetAppOutlined.default;
	  }
	});
	Object.defineProperty(exports, "GetAppRounded", {
	  enumerable: true,
	  get: function get() {
	    return _GetAppRounded.default;
	  }
	});
	Object.defineProperty(exports, "GetAppSharp", {
	  enumerable: true,
	  get: function get() {
	    return _GetAppSharp.default;
	  }
	});
	Object.defineProperty(exports, "GetAppTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _GetAppTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Gif", {
	  enumerable: true,
	  get: function get() {
	    return _Gif.default;
	  }
	});
	Object.defineProperty(exports, "GifOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _GifOutlined.default;
	  }
	});
	Object.defineProperty(exports, "GifRounded", {
	  enumerable: true,
	  get: function get() {
	    return _GifRounded.default;
	  }
	});
	Object.defineProperty(exports, "GifSharp", {
	  enumerable: true,
	  get: function get() {
	    return _GifSharp.default;
	  }
	});
	Object.defineProperty(exports, "GifTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _GifTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "GitHub", {
	  enumerable: true,
	  get: function get() {
	    return _GitHub.default;
	  }
	});
	Object.defineProperty(exports, "GolfCourse", {
	  enumerable: true,
	  get: function get() {
	    return _GolfCourse.default;
	  }
	});
	Object.defineProperty(exports, "GolfCourseOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _GolfCourseOutlined.default;
	  }
	});
	Object.defineProperty(exports, "GolfCourseRounded", {
	  enumerable: true,
	  get: function get() {
	    return _GolfCourseRounded.default;
	  }
	});
	Object.defineProperty(exports, "GolfCourseSharp", {
	  enumerable: true,
	  get: function get() {
	    return _GolfCourseSharp.default;
	  }
	});
	Object.defineProperty(exports, "GolfCourseTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _GolfCourseTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "GpsFixed", {
	  enumerable: true,
	  get: function get() {
	    return _GpsFixed.default;
	  }
	});
	Object.defineProperty(exports, "GpsFixedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _GpsFixedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "GpsFixedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _GpsFixedRounded.default;
	  }
	});
	Object.defineProperty(exports, "GpsFixedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _GpsFixedSharp.default;
	  }
	});
	Object.defineProperty(exports, "GpsFixedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _GpsFixedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "GpsNotFixed", {
	  enumerable: true,
	  get: function get() {
	    return _GpsNotFixed.default;
	  }
	});
	Object.defineProperty(exports, "GpsNotFixedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _GpsNotFixedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "GpsNotFixedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _GpsNotFixedRounded.default;
	  }
	});
	Object.defineProperty(exports, "GpsNotFixedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _GpsNotFixedSharp.default;
	  }
	});
	Object.defineProperty(exports, "GpsNotFixedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _GpsNotFixedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "GpsOff", {
	  enumerable: true,
	  get: function get() {
	    return _GpsOff.default;
	  }
	});
	Object.defineProperty(exports, "GpsOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _GpsOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "GpsOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _GpsOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "GpsOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _GpsOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "GpsOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _GpsOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Grade", {
	  enumerable: true,
	  get: function get() {
	    return _Grade.default;
	  }
	});
	Object.defineProperty(exports, "GradeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _GradeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "GradeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _GradeRounded.default;
	  }
	});
	Object.defineProperty(exports, "GradeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _GradeSharp.default;
	  }
	});
	Object.defineProperty(exports, "GradeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _GradeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Gradient", {
	  enumerable: true,
	  get: function get() {
	    return _Gradient.default;
	  }
	});
	Object.defineProperty(exports, "GradientOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _GradientOutlined.default;
	  }
	});
	Object.defineProperty(exports, "GradientRounded", {
	  enumerable: true,
	  get: function get() {
	    return _GradientRounded.default;
	  }
	});
	Object.defineProperty(exports, "GradientSharp", {
	  enumerable: true,
	  get: function get() {
	    return _GradientSharp.default;
	  }
	});
	Object.defineProperty(exports, "GradientTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _GradientTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Grain", {
	  enumerable: true,
	  get: function get() {
	    return _Grain.default;
	  }
	});
	Object.defineProperty(exports, "GrainOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _GrainOutlined.default;
	  }
	});
	Object.defineProperty(exports, "GrainRounded", {
	  enumerable: true,
	  get: function get() {
	    return _GrainRounded.default;
	  }
	});
	Object.defineProperty(exports, "GrainSharp", {
	  enumerable: true,
	  get: function get() {
	    return _GrainSharp.default;
	  }
	});
	Object.defineProperty(exports, "GrainTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _GrainTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "GraphicEq", {
	  enumerable: true,
	  get: function get() {
	    return _GraphicEq.default;
	  }
	});
	Object.defineProperty(exports, "GraphicEqOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _GraphicEqOutlined.default;
	  }
	});
	Object.defineProperty(exports, "GraphicEqRounded", {
	  enumerable: true,
	  get: function get() {
	    return _GraphicEqRounded.default;
	  }
	});
	Object.defineProperty(exports, "GraphicEqSharp", {
	  enumerable: true,
	  get: function get() {
	    return _GraphicEqSharp.default;
	  }
	});
	Object.defineProperty(exports, "GraphicEqTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _GraphicEqTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "GridOff", {
	  enumerable: true,
	  get: function get() {
	    return _GridOff.default;
	  }
	});
	Object.defineProperty(exports, "GridOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _GridOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "GridOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _GridOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "GridOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _GridOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "GridOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _GridOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "GridOn", {
	  enumerable: true,
	  get: function get() {
	    return _GridOn.default;
	  }
	});
	Object.defineProperty(exports, "GridOnOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _GridOnOutlined.default;
	  }
	});
	Object.defineProperty(exports, "GridOnRounded", {
	  enumerable: true,
	  get: function get() {
	    return _GridOnRounded.default;
	  }
	});
	Object.defineProperty(exports, "GridOnSharp", {
	  enumerable: true,
	  get: function get() {
	    return _GridOnSharp.default;
	  }
	});
	Object.defineProperty(exports, "GridOnTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _GridOnTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Group", {
	  enumerable: true,
	  get: function get() {
	    return _Group.default;
	  }
	});
	Object.defineProperty(exports, "GroupAdd", {
	  enumerable: true,
	  get: function get() {
	    return _GroupAdd.default;
	  }
	});
	Object.defineProperty(exports, "GroupAddOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _GroupAddOutlined.default;
	  }
	});
	Object.defineProperty(exports, "GroupAddRounded", {
	  enumerable: true,
	  get: function get() {
	    return _GroupAddRounded.default;
	  }
	});
	Object.defineProperty(exports, "GroupAddSharp", {
	  enumerable: true,
	  get: function get() {
	    return _GroupAddSharp.default;
	  }
	});
	Object.defineProperty(exports, "GroupAddTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _GroupAddTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "GroupOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _GroupOutlined.default;
	  }
	});
	Object.defineProperty(exports, "GroupRounded", {
	  enumerable: true,
	  get: function get() {
	    return _GroupRounded.default;
	  }
	});
	Object.defineProperty(exports, "GroupSharp", {
	  enumerable: true,
	  get: function get() {
	    return _GroupSharp.default;
	  }
	});
	Object.defineProperty(exports, "GroupTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _GroupTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "GroupWork", {
	  enumerable: true,
	  get: function get() {
	    return _GroupWork.default;
	  }
	});
	Object.defineProperty(exports, "GroupWorkOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _GroupWorkOutlined.default;
	  }
	});
	Object.defineProperty(exports, "GroupWorkRounded", {
	  enumerable: true,
	  get: function get() {
	    return _GroupWorkRounded.default;
	  }
	});
	Object.defineProperty(exports, "GroupWorkSharp", {
	  enumerable: true,
	  get: function get() {
	    return _GroupWorkSharp.default;
	  }
	});
	Object.defineProperty(exports, "GroupWorkTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _GroupWorkTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "GTranslate", {
	  enumerable: true,
	  get: function get() {
	    return _GTranslate.default;
	  }
	});
	Object.defineProperty(exports, "GTranslateOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _GTranslateOutlined.default;
	  }
	});
	Object.defineProperty(exports, "GTranslateRounded", {
	  enumerable: true,
	  get: function get() {
	    return _GTranslateRounded.default;
	  }
	});
	Object.defineProperty(exports, "GTranslateSharp", {
	  enumerable: true,
	  get: function get() {
	    return _GTranslateSharp.default;
	  }
	});
	Object.defineProperty(exports, "GTranslateTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _GTranslateTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Hd", {
	  enumerable: true,
	  get: function get() {
	    return _Hd.default;
	  }
	});
	Object.defineProperty(exports, "HdOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HdOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HdrOff", {
	  enumerable: true,
	  get: function get() {
	    return _HdrOff.default;
	  }
	});
	Object.defineProperty(exports, "HdrOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HdrOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HdrOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HdrOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "HdrOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HdrOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "HdrOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HdrOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "HdrOn", {
	  enumerable: true,
	  get: function get() {
	    return _HdrOn.default;
	  }
	});
	Object.defineProperty(exports, "HdrOnOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HdrOnOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HdrOnRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HdrOnRounded.default;
	  }
	});
	Object.defineProperty(exports, "HdrOnSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HdrOnSharp.default;
	  }
	});
	Object.defineProperty(exports, "HdrOnTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HdrOnTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "HdRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HdRounded.default;
	  }
	});
	Object.defineProperty(exports, "HdrStrong", {
	  enumerable: true,
	  get: function get() {
	    return _HdrStrong.default;
	  }
	});
	Object.defineProperty(exports, "HdrStrongOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HdrStrongOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HdrStrongRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HdrStrongRounded.default;
	  }
	});
	Object.defineProperty(exports, "HdrStrongSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HdrStrongSharp.default;
	  }
	});
	Object.defineProperty(exports, "HdrStrongTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HdrStrongTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "HdrWeak", {
	  enumerable: true,
	  get: function get() {
	    return _HdrWeak.default;
	  }
	});
	Object.defineProperty(exports, "HdrWeakOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HdrWeakOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HdrWeakRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HdrWeakRounded.default;
	  }
	});
	Object.defineProperty(exports, "HdrWeakSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HdrWeakSharp.default;
	  }
	});
	Object.defineProperty(exports, "HdrWeakTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HdrWeakTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "HdSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HdSharp.default;
	  }
	});
	Object.defineProperty(exports, "HdTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HdTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Headset", {
	  enumerable: true,
	  get: function get() {
	    return _Headset.default;
	  }
	});
	Object.defineProperty(exports, "HeadsetMic", {
	  enumerable: true,
	  get: function get() {
	    return _HeadsetMic.default;
	  }
	});
	Object.defineProperty(exports, "HeadsetMicOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HeadsetMicOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HeadsetMicRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HeadsetMicRounded.default;
	  }
	});
	Object.defineProperty(exports, "HeadsetMicSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HeadsetMicSharp.default;
	  }
	});
	Object.defineProperty(exports, "HeadsetMicTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HeadsetMicTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "HeadsetOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HeadsetOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HeadsetRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HeadsetRounded.default;
	  }
	});
	Object.defineProperty(exports, "HeadsetSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HeadsetSharp.default;
	  }
	});
	Object.defineProperty(exports, "HeadsetTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HeadsetTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Healing", {
	  enumerable: true,
	  get: function get() {
	    return _Healing.default;
	  }
	});
	Object.defineProperty(exports, "HealingOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HealingOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HealingRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HealingRounded.default;
	  }
	});
	Object.defineProperty(exports, "HealingSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HealingSharp.default;
	  }
	});
	Object.defineProperty(exports, "HealingTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HealingTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Hearing", {
	  enumerable: true,
	  get: function get() {
	    return _Hearing.default;
	  }
	});
	Object.defineProperty(exports, "HearingOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HearingOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HearingRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HearingRounded.default;
	  }
	});
	Object.defineProperty(exports, "HearingSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HearingSharp.default;
	  }
	});
	Object.defineProperty(exports, "HearingTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HearingTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Height", {
	  enumerable: true,
	  get: function get() {
	    return _Height.default;
	  }
	});
	Object.defineProperty(exports, "HeightOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HeightOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HeightRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HeightRounded.default;
	  }
	});
	Object.defineProperty(exports, "HeightSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HeightSharp.default;
	  }
	});
	Object.defineProperty(exports, "HeightTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HeightTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Help", {
	  enumerable: true,
	  get: function get() {
	    return _Help.default;
	  }
	});
	Object.defineProperty(exports, "HelpOutline", {
	  enumerable: true,
	  get: function get() {
	    return _HelpOutline.default;
	  }
	});
	Object.defineProperty(exports, "HelpOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HelpOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HelpOutlineOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HelpOutlineOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HelpOutlineRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HelpOutlineRounded.default;
	  }
	});
	Object.defineProperty(exports, "HelpOutlineSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HelpOutlineSharp.default;
	  }
	});
	Object.defineProperty(exports, "HelpOutlineTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HelpOutlineTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "HelpRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HelpRounded.default;
	  }
	});
	Object.defineProperty(exports, "HelpSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HelpSharp.default;
	  }
	});
	Object.defineProperty(exports, "HelpTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HelpTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Highlight", {
	  enumerable: true,
	  get: function get() {
	    return _Highlight.default;
	  }
	});
	Object.defineProperty(exports, "HighlightOff", {
	  enumerable: true,
	  get: function get() {
	    return _HighlightOff.default;
	  }
	});
	Object.defineProperty(exports, "HighlightOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HighlightOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HighlightOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HighlightOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "HighlightOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HighlightOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "HighlightOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HighlightOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "HighlightOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HighlightOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HighlightRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HighlightRounded.default;
	  }
	});
	Object.defineProperty(exports, "HighlightSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HighlightSharp.default;
	  }
	});
	Object.defineProperty(exports, "HighlightTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HighlightTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "HighQuality", {
	  enumerable: true,
	  get: function get() {
	    return _HighQuality.default;
	  }
	});
	Object.defineProperty(exports, "HighQualityOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HighQualityOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HighQualityRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HighQualityRounded.default;
	  }
	});
	Object.defineProperty(exports, "HighQualitySharp", {
	  enumerable: true,
	  get: function get() {
	    return _HighQualitySharp.default;
	  }
	});
	Object.defineProperty(exports, "HighQualityTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HighQualityTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "History", {
	  enumerable: true,
	  get: function get() {
	    return _History.default;
	  }
	});
	Object.defineProperty(exports, "HistoryOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HistoryOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HistoryRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HistoryRounded.default;
	  }
	});
	Object.defineProperty(exports, "HistorySharp", {
	  enumerable: true,
	  get: function get() {
	    return _HistorySharp.default;
	  }
	});
	Object.defineProperty(exports, "HistoryTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HistoryTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Home", {
	  enumerable: true,
	  get: function get() {
	    return _Home.default;
	  }
	});
	Object.defineProperty(exports, "HomeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HomeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HomeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HomeRounded.default;
	  }
	});
	Object.defineProperty(exports, "HomeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HomeSharp.default;
	  }
	});
	Object.defineProperty(exports, "HomeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HomeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "HomeWork", {
	  enumerable: true,
	  get: function get() {
	    return _HomeWork.default;
	  }
	});
	Object.defineProperty(exports, "HomeWorkOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HomeWorkOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HomeWorkRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HomeWorkRounded.default;
	  }
	});
	Object.defineProperty(exports, "HomeWorkSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HomeWorkSharp.default;
	  }
	});
	Object.defineProperty(exports, "HomeWorkTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HomeWorkTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "HorizontalSplit", {
	  enumerable: true,
	  get: function get() {
	    return _HorizontalSplit.default;
	  }
	});
	Object.defineProperty(exports, "HorizontalSplitOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HorizontalSplitOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HorizontalSplitRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HorizontalSplitRounded.default;
	  }
	});
	Object.defineProperty(exports, "HorizontalSplitSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HorizontalSplitSharp.default;
	  }
	});
	Object.defineProperty(exports, "HorizontalSplitTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HorizontalSplitTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Hotel", {
	  enumerable: true,
	  get: function get() {
	    return _Hotel.default;
	  }
	});
	Object.defineProperty(exports, "HotelOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HotelOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HotelRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HotelRounded.default;
	  }
	});
	Object.defineProperty(exports, "HotelSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HotelSharp.default;
	  }
	});
	Object.defineProperty(exports, "HotelTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HotelTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "HotTub", {
	  enumerable: true,
	  get: function get() {
	    return _HotTub.default;
	  }
	});
	Object.defineProperty(exports, "HotTubOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HotTubOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HotTubRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HotTubRounded.default;
	  }
	});
	Object.defineProperty(exports, "HotTubSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HotTubSharp.default;
	  }
	});
	Object.defineProperty(exports, "HotTubTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HotTubTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "HourglassEmpty", {
	  enumerable: true,
	  get: function get() {
	    return _HourglassEmpty.default;
	  }
	});
	Object.defineProperty(exports, "HourglassEmptyOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HourglassEmptyOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HourglassEmptyRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HourglassEmptyRounded.default;
	  }
	});
	Object.defineProperty(exports, "HourglassEmptySharp", {
	  enumerable: true,
	  get: function get() {
	    return _HourglassEmptySharp.default;
	  }
	});
	Object.defineProperty(exports, "HourglassEmptyTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HourglassEmptyTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "HourglassFull", {
	  enumerable: true,
	  get: function get() {
	    return _HourglassFull.default;
	  }
	});
	Object.defineProperty(exports, "HourglassFullOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HourglassFullOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HourglassFullRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HourglassFullRounded.default;
	  }
	});
	Object.defineProperty(exports, "HourglassFullSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HourglassFullSharp.default;
	  }
	});
	Object.defineProperty(exports, "HourglassFullTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HourglassFullTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "House", {
	  enumerable: true,
	  get: function get() {
	    return _House.default;
	  }
	});
	Object.defineProperty(exports, "HouseOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HouseOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HouseRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HouseRounded.default;
	  }
	});
	Object.defineProperty(exports, "HouseSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HouseSharp.default;
	  }
	});
	Object.defineProperty(exports, "HouseTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HouseTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "HowToReg", {
	  enumerable: true,
	  get: function get() {
	    return _HowToReg.default;
	  }
	});
	Object.defineProperty(exports, "HowToRegOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HowToRegOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HowToRegRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HowToRegRounded.default;
	  }
	});
	Object.defineProperty(exports, "HowToRegSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HowToRegSharp.default;
	  }
	});
	Object.defineProperty(exports, "HowToRegTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HowToRegTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "HowToVote", {
	  enumerable: true,
	  get: function get() {
	    return _HowToVote.default;
	  }
	});
	Object.defineProperty(exports, "HowToVoteOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HowToVoteOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HowToVoteRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HowToVoteRounded.default;
	  }
	});
	Object.defineProperty(exports, "HowToVoteSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HowToVoteSharp.default;
	  }
	});
	Object.defineProperty(exports, "HowToVoteTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HowToVoteTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Http", {
	  enumerable: true,
	  get: function get() {
	    return _Http.default;
	  }
	});
	Object.defineProperty(exports, "HttpOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HttpOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HttpRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HttpRounded.default;
	  }
	});
	Object.defineProperty(exports, "Https", {
	  enumerable: true,
	  get: function get() {
	    return _Https.default;
	  }
	});
	Object.defineProperty(exports, "HttpSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HttpSharp.default;
	  }
	});
	Object.defineProperty(exports, "HttpsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _HttpsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "HttpsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _HttpsRounded.default;
	  }
	});
	Object.defineProperty(exports, "HttpsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _HttpsSharp.default;
	  }
	});
	Object.defineProperty(exports, "HttpsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HttpsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "HttpTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _HttpTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Image", {
	  enumerable: true,
	  get: function get() {
	    return _Image.default;
	  }
	});
	Object.defineProperty(exports, "ImageAspectRatio", {
	  enumerable: true,
	  get: function get() {
	    return _ImageAspectRatio.default;
	  }
	});
	Object.defineProperty(exports, "ImageAspectRatioOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ImageAspectRatioOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ImageAspectRatioRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ImageAspectRatioRounded.default;
	  }
	});
	Object.defineProperty(exports, "ImageAspectRatioSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ImageAspectRatioSharp.default;
	  }
	});
	Object.defineProperty(exports, "ImageAspectRatioTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ImageAspectRatioTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ImageOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ImageOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ImageRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ImageRounded.default;
	  }
	});
	Object.defineProperty(exports, "ImageSearch", {
	  enumerable: true,
	  get: function get() {
	    return _ImageSearch.default;
	  }
	});
	Object.defineProperty(exports, "ImageSearchOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ImageSearchOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ImageSearchRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ImageSearchRounded.default;
	  }
	});
	Object.defineProperty(exports, "ImageSearchSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ImageSearchSharp.default;
	  }
	});
	Object.defineProperty(exports, "ImageSearchTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ImageSearchTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ImageSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ImageSharp.default;
	  }
	});
	Object.defineProperty(exports, "ImageTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ImageTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ImportantDevices", {
	  enumerable: true,
	  get: function get() {
	    return _ImportantDevices.default;
	  }
	});
	Object.defineProperty(exports, "ImportantDevicesOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ImportantDevicesOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ImportantDevicesRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ImportantDevicesRounded.default;
	  }
	});
	Object.defineProperty(exports, "ImportantDevicesSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ImportantDevicesSharp.default;
	  }
	});
	Object.defineProperty(exports, "ImportantDevicesTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ImportantDevicesTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ImportContacts", {
	  enumerable: true,
	  get: function get() {
	    return _ImportContacts.default;
	  }
	});
	Object.defineProperty(exports, "ImportContactsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ImportContactsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ImportContactsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ImportContactsRounded.default;
	  }
	});
	Object.defineProperty(exports, "ImportContactsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ImportContactsSharp.default;
	  }
	});
	Object.defineProperty(exports, "ImportContactsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ImportContactsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ImportExport", {
	  enumerable: true,
	  get: function get() {
	    return _ImportExport.default;
	  }
	});
	Object.defineProperty(exports, "ImportExportOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ImportExportOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ImportExportRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ImportExportRounded.default;
	  }
	});
	Object.defineProperty(exports, "ImportExportSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ImportExportSharp.default;
	  }
	});
	Object.defineProperty(exports, "ImportExportTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ImportExportTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Inbox", {
	  enumerable: true,
	  get: function get() {
	    return _Inbox.default;
	  }
	});
	Object.defineProperty(exports, "InboxOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _InboxOutlined.default;
	  }
	});
	Object.defineProperty(exports, "InboxRounded", {
	  enumerable: true,
	  get: function get() {
	    return _InboxRounded.default;
	  }
	});
	Object.defineProperty(exports, "InboxSharp", {
	  enumerable: true,
	  get: function get() {
	    return _InboxSharp.default;
	  }
	});
	Object.defineProperty(exports, "InboxTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _InboxTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "IndeterminateCheckBox", {
	  enumerable: true,
	  get: function get() {
	    return _IndeterminateCheckBox.default;
	  }
	});
	Object.defineProperty(exports, "IndeterminateCheckBoxOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _IndeterminateCheckBoxOutlined.default;
	  }
	});
	Object.defineProperty(exports, "IndeterminateCheckBoxRounded", {
	  enumerable: true,
	  get: function get() {
	    return _IndeterminateCheckBoxRounded.default;
	  }
	});
	Object.defineProperty(exports, "IndeterminateCheckBoxSharp", {
	  enumerable: true,
	  get: function get() {
	    return _IndeterminateCheckBoxSharp.default;
	  }
	});
	Object.defineProperty(exports, "IndeterminateCheckBoxTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _IndeterminateCheckBoxTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Info", {
	  enumerable: true,
	  get: function get() {
	    return _Info.default;
	  }
	});
	Object.defineProperty(exports, "InfoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _InfoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "InfoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _InfoRounded.default;
	  }
	});
	Object.defineProperty(exports, "InfoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _InfoSharp.default;
	  }
	});
	Object.defineProperty(exports, "InfoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _InfoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Input", {
	  enumerable: true,
	  get: function get() {
	    return _Input.default;
	  }
	});
	Object.defineProperty(exports, "InputOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _InputOutlined.default;
	  }
	});
	Object.defineProperty(exports, "InputRounded", {
	  enumerable: true,
	  get: function get() {
	    return _InputRounded.default;
	  }
	});
	Object.defineProperty(exports, "InputSharp", {
	  enumerable: true,
	  get: function get() {
	    return _InputSharp.default;
	  }
	});
	Object.defineProperty(exports, "InputTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _InputTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "InsertChart", {
	  enumerable: true,
	  get: function get() {
	    return _InsertChart.default;
	  }
	});
	Object.defineProperty(exports, "InsertChartOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _InsertChartOutlined.default;
	  }
	});
	Object.defineProperty(exports, "InsertChartOutlinedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _InsertChartOutlinedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "InsertChartOutlinedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _InsertChartOutlinedRounded.default;
	  }
	});
	Object.defineProperty(exports, "InsertChartOutlinedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _InsertChartOutlinedSharp.default;
	  }
	});
	Object.defineProperty(exports, "InsertChartOutlinedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _InsertChartOutlinedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "InsertChartRounded", {
	  enumerable: true,
	  get: function get() {
	    return _InsertChartRounded.default;
	  }
	});
	Object.defineProperty(exports, "InsertChartSharp", {
	  enumerable: true,
	  get: function get() {
	    return _InsertChartSharp.default;
	  }
	});
	Object.defineProperty(exports, "InsertChartTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _InsertChartTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "InsertComment", {
	  enumerable: true,
	  get: function get() {
	    return _InsertComment.default;
	  }
	});
	Object.defineProperty(exports, "InsertCommentOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _InsertCommentOutlined.default;
	  }
	});
	Object.defineProperty(exports, "InsertCommentRounded", {
	  enumerable: true,
	  get: function get() {
	    return _InsertCommentRounded.default;
	  }
	});
	Object.defineProperty(exports, "InsertCommentSharp", {
	  enumerable: true,
	  get: function get() {
	    return _InsertCommentSharp.default;
	  }
	});
	Object.defineProperty(exports, "InsertCommentTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _InsertCommentTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "InsertDriveFile", {
	  enumerable: true,
	  get: function get() {
	    return _InsertDriveFile.default;
	  }
	});
	Object.defineProperty(exports, "InsertDriveFileOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _InsertDriveFileOutlined.default;
	  }
	});
	Object.defineProperty(exports, "InsertDriveFileRounded", {
	  enumerable: true,
	  get: function get() {
	    return _InsertDriveFileRounded.default;
	  }
	});
	Object.defineProperty(exports, "InsertDriveFileSharp", {
	  enumerable: true,
	  get: function get() {
	    return _InsertDriveFileSharp.default;
	  }
	});
	Object.defineProperty(exports, "InsertDriveFileTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _InsertDriveFileTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "InsertEmoticon", {
	  enumerable: true,
	  get: function get() {
	    return _InsertEmoticon.default;
	  }
	});
	Object.defineProperty(exports, "InsertEmoticonOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _InsertEmoticonOutlined.default;
	  }
	});
	Object.defineProperty(exports, "InsertEmoticonRounded", {
	  enumerable: true,
	  get: function get() {
	    return _InsertEmoticonRounded.default;
	  }
	});
	Object.defineProperty(exports, "InsertEmoticonSharp", {
	  enumerable: true,
	  get: function get() {
	    return _InsertEmoticonSharp.default;
	  }
	});
	Object.defineProperty(exports, "InsertEmoticonTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _InsertEmoticonTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "InsertInvitation", {
	  enumerable: true,
	  get: function get() {
	    return _InsertInvitation.default;
	  }
	});
	Object.defineProperty(exports, "InsertInvitationOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _InsertInvitationOutlined.default;
	  }
	});
	Object.defineProperty(exports, "InsertInvitationRounded", {
	  enumerable: true,
	  get: function get() {
	    return _InsertInvitationRounded.default;
	  }
	});
	Object.defineProperty(exports, "InsertInvitationSharp", {
	  enumerable: true,
	  get: function get() {
	    return _InsertInvitationSharp.default;
	  }
	});
	Object.defineProperty(exports, "InsertInvitationTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _InsertInvitationTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "InsertLink", {
	  enumerable: true,
	  get: function get() {
	    return _InsertLink.default;
	  }
	});
	Object.defineProperty(exports, "InsertLinkOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _InsertLinkOutlined.default;
	  }
	});
	Object.defineProperty(exports, "InsertLinkRounded", {
	  enumerable: true,
	  get: function get() {
	    return _InsertLinkRounded.default;
	  }
	});
	Object.defineProperty(exports, "InsertLinkSharp", {
	  enumerable: true,
	  get: function get() {
	    return _InsertLinkSharp.default;
	  }
	});
	Object.defineProperty(exports, "InsertLinkTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _InsertLinkTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "InsertPhoto", {
	  enumerable: true,
	  get: function get() {
	    return _InsertPhoto.default;
	  }
	});
	Object.defineProperty(exports, "InsertPhotoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _InsertPhotoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "InsertPhotoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _InsertPhotoRounded.default;
	  }
	});
	Object.defineProperty(exports, "InsertPhotoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _InsertPhotoSharp.default;
	  }
	});
	Object.defineProperty(exports, "InsertPhotoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _InsertPhotoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Instagram", {
	  enumerable: true,
	  get: function get() {
	    return _Instagram.default;
	  }
	});
	Object.defineProperty(exports, "InvertColors", {
	  enumerable: true,
	  get: function get() {
	    return _InvertColors.default;
	  }
	});
	Object.defineProperty(exports, "InvertColorsOff", {
	  enumerable: true,
	  get: function get() {
	    return _InvertColorsOff.default;
	  }
	});
	Object.defineProperty(exports, "InvertColorsOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _InvertColorsOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "InvertColorsOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _InvertColorsOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "InvertColorsOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _InvertColorsOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "InvertColorsOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _InvertColorsOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "InvertColorsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _InvertColorsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "InvertColorsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _InvertColorsRounded.default;
	  }
	});
	Object.defineProperty(exports, "InvertColorsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _InvertColorsSharp.default;
	  }
	});
	Object.defineProperty(exports, "InvertColorsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _InvertColorsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Iso", {
	  enumerable: true,
	  get: function get() {
	    return _Iso.default;
	  }
	});
	Object.defineProperty(exports, "IsoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _IsoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "IsoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _IsoRounded.default;
	  }
	});
	Object.defineProperty(exports, "IsoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _IsoSharp.default;
	  }
	});
	Object.defineProperty(exports, "IsoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _IsoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Keyboard", {
	  enumerable: true,
	  get: function get() {
	    return _Keyboard.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardArrowDown", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardArrowDown.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardArrowDownOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardArrowDownOutlined.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardArrowDownRounded", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardArrowDownRounded.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardArrowDownSharp", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardArrowDownSharp.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardArrowDownTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardArrowDownTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardArrowLeft", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardArrowLeft.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardArrowLeftOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardArrowLeftOutlined.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardArrowLeftRounded", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardArrowLeftRounded.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardArrowLeftSharp", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardArrowLeftSharp.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardArrowLeftTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardArrowLeftTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardArrowRight", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardArrowRight.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardArrowRightOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardArrowRightOutlined.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardArrowRightRounded", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardArrowRightRounded.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardArrowRightSharp", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardArrowRightSharp.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardArrowRightTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardArrowRightTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardArrowUp", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardArrowUp.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardArrowUpOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardArrowUpOutlined.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardArrowUpRounded", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardArrowUpRounded.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardArrowUpSharp", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardArrowUpSharp.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardArrowUpTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardArrowUpTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardBackspace", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardBackspace.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardBackspaceOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardBackspaceOutlined.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardBackspaceRounded", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardBackspaceRounded.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardBackspaceSharp", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardBackspaceSharp.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardBackspaceTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardBackspaceTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardCapslock", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardCapslock.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardCapslockOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardCapslockOutlined.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardCapslockRounded", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardCapslockRounded.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardCapslockSharp", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardCapslockSharp.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardCapslockTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardCapslockTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardHide", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardHide.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardHideOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardHideOutlined.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardHideRounded", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardHideRounded.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardHideSharp", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardHideSharp.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardHideTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardHideTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardOutlined.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardReturn", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardReturn.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardReturnOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardReturnOutlined.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardReturnRounded", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardReturnRounded.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardReturnSharp", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardReturnSharp.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardReturnTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardReturnTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardRounded", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardRounded.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardSharp", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardSharp.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardTab", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardTab.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardTabOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardTabOutlined.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardTabRounded", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardTabRounded.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardTabSharp", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardTabSharp.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardTabTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardTabTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardVoice", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardVoice.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardVoiceOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardVoiceOutlined.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardVoiceRounded", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardVoiceRounded.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardVoiceSharp", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardVoiceSharp.default;
	  }
	});
	Object.defineProperty(exports, "KeyboardVoiceTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _KeyboardVoiceTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "KingBed", {
	  enumerable: true,
	  get: function get() {
	    return _KingBed.default;
	  }
	});
	Object.defineProperty(exports, "KingBedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _KingBedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "KingBedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _KingBedRounded.default;
	  }
	});
	Object.defineProperty(exports, "KingBedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _KingBedSharp.default;
	  }
	});
	Object.defineProperty(exports, "KingBedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _KingBedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Kitchen", {
	  enumerable: true,
	  get: function get() {
	    return _Kitchen.default;
	  }
	});
	Object.defineProperty(exports, "KitchenOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _KitchenOutlined.default;
	  }
	});
	Object.defineProperty(exports, "KitchenRounded", {
	  enumerable: true,
	  get: function get() {
	    return _KitchenRounded.default;
	  }
	});
	Object.defineProperty(exports, "KitchenSharp", {
	  enumerable: true,
	  get: function get() {
	    return _KitchenSharp.default;
	  }
	});
	Object.defineProperty(exports, "KitchenTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _KitchenTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Label", {
	  enumerable: true,
	  get: function get() {
	    return _Label.default;
	  }
	});
	Object.defineProperty(exports, "LabelImportant", {
	  enumerable: true,
	  get: function get() {
	    return _LabelImportant.default;
	  }
	});
	Object.defineProperty(exports, "LabelImportantOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LabelImportantOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LabelImportantRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LabelImportantRounded.default;
	  }
	});
	Object.defineProperty(exports, "LabelImportantSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LabelImportantSharp.default;
	  }
	});
	Object.defineProperty(exports, "LabelImportantTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LabelImportantTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LabelOff", {
	  enumerable: true,
	  get: function get() {
	    return _LabelOff.default;
	  }
	});
	Object.defineProperty(exports, "LabelOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LabelOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LabelOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LabelOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "LabelOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LabelOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "LabelOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LabelOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LabelOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LabelOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LabelRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LabelRounded.default;
	  }
	});
	Object.defineProperty(exports, "LabelSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LabelSharp.default;
	  }
	});
	Object.defineProperty(exports, "LabelTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LabelTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Landscape", {
	  enumerable: true,
	  get: function get() {
	    return _Landscape.default;
	  }
	});
	Object.defineProperty(exports, "LandscapeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LandscapeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LandscapeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LandscapeRounded.default;
	  }
	});
	Object.defineProperty(exports, "LandscapeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LandscapeSharp.default;
	  }
	});
	Object.defineProperty(exports, "LandscapeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LandscapeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Language", {
	  enumerable: true,
	  get: function get() {
	    return _Language.default;
	  }
	});
	Object.defineProperty(exports, "LanguageOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LanguageOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LanguageRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LanguageRounded.default;
	  }
	});
	Object.defineProperty(exports, "LanguageSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LanguageSharp.default;
	  }
	});
	Object.defineProperty(exports, "LanguageTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LanguageTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Laptop", {
	  enumerable: true,
	  get: function get() {
	    return _Laptop.default;
	  }
	});
	Object.defineProperty(exports, "LaptopChromebook", {
	  enumerable: true,
	  get: function get() {
	    return _LaptopChromebook.default;
	  }
	});
	Object.defineProperty(exports, "LaptopChromebookOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LaptopChromebookOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LaptopChromebookRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LaptopChromebookRounded.default;
	  }
	});
	Object.defineProperty(exports, "LaptopChromebookSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LaptopChromebookSharp.default;
	  }
	});
	Object.defineProperty(exports, "LaptopChromebookTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LaptopChromebookTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LaptopMac", {
	  enumerable: true,
	  get: function get() {
	    return _LaptopMac.default;
	  }
	});
	Object.defineProperty(exports, "LaptopMacOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LaptopMacOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LaptopMacRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LaptopMacRounded.default;
	  }
	});
	Object.defineProperty(exports, "LaptopMacSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LaptopMacSharp.default;
	  }
	});
	Object.defineProperty(exports, "LaptopMacTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LaptopMacTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LaptopOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LaptopOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LaptopRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LaptopRounded.default;
	  }
	});
	Object.defineProperty(exports, "LaptopSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LaptopSharp.default;
	  }
	});
	Object.defineProperty(exports, "LaptopTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LaptopTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LaptopWindows", {
	  enumerable: true,
	  get: function get() {
	    return _LaptopWindows.default;
	  }
	});
	Object.defineProperty(exports, "LaptopWindowsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LaptopWindowsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LaptopWindowsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LaptopWindowsRounded.default;
	  }
	});
	Object.defineProperty(exports, "LaptopWindowsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LaptopWindowsSharp.default;
	  }
	});
	Object.defineProperty(exports, "LaptopWindowsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LaptopWindowsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LastPage", {
	  enumerable: true,
	  get: function get() {
	    return _LastPage.default;
	  }
	});
	Object.defineProperty(exports, "LastPageOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LastPageOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LastPageRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LastPageRounded.default;
	  }
	});
	Object.defineProperty(exports, "LastPageSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LastPageSharp.default;
	  }
	});
	Object.defineProperty(exports, "LastPageTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LastPageTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Launch", {
	  enumerable: true,
	  get: function get() {
	    return _Launch.default;
	  }
	});
	Object.defineProperty(exports, "LaunchOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LaunchOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LaunchRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LaunchRounded.default;
	  }
	});
	Object.defineProperty(exports, "LaunchSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LaunchSharp.default;
	  }
	});
	Object.defineProperty(exports, "LaunchTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LaunchTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Layers", {
	  enumerable: true,
	  get: function get() {
	    return _Layers.default;
	  }
	});
	Object.defineProperty(exports, "LayersClear", {
	  enumerable: true,
	  get: function get() {
	    return _LayersClear.default;
	  }
	});
	Object.defineProperty(exports, "LayersClearOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LayersClearOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LayersClearRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LayersClearRounded.default;
	  }
	});
	Object.defineProperty(exports, "LayersClearSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LayersClearSharp.default;
	  }
	});
	Object.defineProperty(exports, "LayersClearTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LayersClearTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LayersOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LayersOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LayersRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LayersRounded.default;
	  }
	});
	Object.defineProperty(exports, "LayersSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LayersSharp.default;
	  }
	});
	Object.defineProperty(exports, "LayersTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LayersTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LeakAdd", {
	  enumerable: true,
	  get: function get() {
	    return _LeakAdd.default;
	  }
	});
	Object.defineProperty(exports, "LeakAddOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LeakAddOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LeakAddRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LeakAddRounded.default;
	  }
	});
	Object.defineProperty(exports, "LeakAddSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LeakAddSharp.default;
	  }
	});
	Object.defineProperty(exports, "LeakAddTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LeakAddTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LeakRemove", {
	  enumerable: true,
	  get: function get() {
	    return _LeakRemove.default;
	  }
	});
	Object.defineProperty(exports, "LeakRemoveOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LeakRemoveOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LeakRemoveRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LeakRemoveRounded.default;
	  }
	});
	Object.defineProperty(exports, "LeakRemoveSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LeakRemoveSharp.default;
	  }
	});
	Object.defineProperty(exports, "LeakRemoveTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LeakRemoveTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Lens", {
	  enumerable: true,
	  get: function get() {
	    return _Lens.default;
	  }
	});
	Object.defineProperty(exports, "LensOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LensOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LensRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LensRounded.default;
	  }
	});
	Object.defineProperty(exports, "LensSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LensSharp.default;
	  }
	});
	Object.defineProperty(exports, "LensTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LensTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LibraryAdd", {
	  enumerable: true,
	  get: function get() {
	    return _LibraryAdd.default;
	  }
	});
	Object.defineProperty(exports, "LibraryAddCheck", {
	  enumerable: true,
	  get: function get() {
	    return _LibraryAddCheck.default;
	  }
	});
	Object.defineProperty(exports, "LibraryAddCheckOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LibraryAddCheckOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LibraryAddCheckRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LibraryAddCheckRounded.default;
	  }
	});
	Object.defineProperty(exports, "LibraryAddCheckSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LibraryAddCheckSharp.default;
	  }
	});
	Object.defineProperty(exports, "LibraryAddCheckTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LibraryAddCheckTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LibraryAddOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LibraryAddOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LibraryAddRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LibraryAddRounded.default;
	  }
	});
	Object.defineProperty(exports, "LibraryAddSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LibraryAddSharp.default;
	  }
	});
	Object.defineProperty(exports, "LibraryAddTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LibraryAddTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LibraryBooks", {
	  enumerable: true,
	  get: function get() {
	    return _LibraryBooks.default;
	  }
	});
	Object.defineProperty(exports, "LibraryBooksOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LibraryBooksOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LibraryBooksRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LibraryBooksRounded.default;
	  }
	});
	Object.defineProperty(exports, "LibraryBooksSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LibraryBooksSharp.default;
	  }
	});
	Object.defineProperty(exports, "LibraryBooksTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LibraryBooksTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LibraryMusic", {
	  enumerable: true,
	  get: function get() {
	    return _LibraryMusic.default;
	  }
	});
	Object.defineProperty(exports, "LibraryMusicOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LibraryMusicOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LibraryMusicRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LibraryMusicRounded.default;
	  }
	});
	Object.defineProperty(exports, "LibraryMusicSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LibraryMusicSharp.default;
	  }
	});
	Object.defineProperty(exports, "LibraryMusicTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LibraryMusicTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LinearScale", {
	  enumerable: true,
	  get: function get() {
	    return _LinearScale.default;
	  }
	});
	Object.defineProperty(exports, "LinearScaleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LinearScaleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LinearScaleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LinearScaleRounded.default;
	  }
	});
	Object.defineProperty(exports, "LinearScaleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LinearScaleSharp.default;
	  }
	});
	Object.defineProperty(exports, "LinearScaleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LinearScaleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LineStyle", {
	  enumerable: true,
	  get: function get() {
	    return _LineStyle.default;
	  }
	});
	Object.defineProperty(exports, "LineStyleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LineStyleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LineStyleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LineStyleRounded.default;
	  }
	});
	Object.defineProperty(exports, "LineStyleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LineStyleSharp.default;
	  }
	});
	Object.defineProperty(exports, "LineStyleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LineStyleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LineWeight", {
	  enumerable: true,
	  get: function get() {
	    return _LineWeight.default;
	  }
	});
	Object.defineProperty(exports, "LineWeightOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LineWeightOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LineWeightRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LineWeightRounded.default;
	  }
	});
	Object.defineProperty(exports, "LineWeightSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LineWeightSharp.default;
	  }
	});
	Object.defineProperty(exports, "LineWeightTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LineWeightTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Link", {
	  enumerable: true,
	  get: function get() {
	    return _Link.default;
	  }
	});
	Object.defineProperty(exports, "LinkedCamera", {
	  enumerable: true,
	  get: function get() {
	    return _LinkedCamera.default;
	  }
	});
	Object.defineProperty(exports, "LinkedCameraOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LinkedCameraOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LinkedCameraRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LinkedCameraRounded.default;
	  }
	});
	Object.defineProperty(exports, "LinkedCameraSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LinkedCameraSharp.default;
	  }
	});
	Object.defineProperty(exports, "LinkedCameraTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LinkedCameraTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LinkedIn", {
	  enumerable: true,
	  get: function get() {
	    return _LinkedIn.default;
	  }
	});
	Object.defineProperty(exports, "LinkOff", {
	  enumerable: true,
	  get: function get() {
	    return _LinkOff.default;
	  }
	});
	Object.defineProperty(exports, "LinkOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LinkOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LinkOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LinkOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "LinkOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LinkOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "LinkOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LinkOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LinkOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LinkOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LinkRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LinkRounded.default;
	  }
	});
	Object.defineProperty(exports, "LinkSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LinkSharp.default;
	  }
	});
	Object.defineProperty(exports, "LinkTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LinkTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "List", {
	  enumerable: true,
	  get: function get() {
	    return _List.default;
	  }
	});
	Object.defineProperty(exports, "ListAlt", {
	  enumerable: true,
	  get: function get() {
	    return _ListAlt.default;
	  }
	});
	Object.defineProperty(exports, "ListAltOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ListAltOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ListAltRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ListAltRounded.default;
	  }
	});
	Object.defineProperty(exports, "ListAltSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ListAltSharp.default;
	  }
	});
	Object.defineProperty(exports, "ListAltTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ListAltTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ListOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ListOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ListRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ListRounded.default;
	  }
	});
	Object.defineProperty(exports, "ListSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ListSharp.default;
	  }
	});
	Object.defineProperty(exports, "ListTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ListTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LiveHelp", {
	  enumerable: true,
	  get: function get() {
	    return _LiveHelp.default;
	  }
	});
	Object.defineProperty(exports, "LiveHelpOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LiveHelpOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LiveHelpRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LiveHelpRounded.default;
	  }
	});
	Object.defineProperty(exports, "LiveHelpSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LiveHelpSharp.default;
	  }
	});
	Object.defineProperty(exports, "LiveHelpTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LiveHelpTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LiveTv", {
	  enumerable: true,
	  get: function get() {
	    return _LiveTv.default;
	  }
	});
	Object.defineProperty(exports, "LiveTvOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LiveTvOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LiveTvRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LiveTvRounded.default;
	  }
	});
	Object.defineProperty(exports, "LiveTvSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LiveTvSharp.default;
	  }
	});
	Object.defineProperty(exports, "LiveTvTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LiveTvTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalActivity", {
	  enumerable: true,
	  get: function get() {
	    return _LocalActivity.default;
	  }
	});
	Object.defineProperty(exports, "LocalActivityOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalActivityOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalActivityRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalActivityRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalActivitySharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalActivitySharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalActivityTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalActivityTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalAirport", {
	  enumerable: true,
	  get: function get() {
	    return _LocalAirport.default;
	  }
	});
	Object.defineProperty(exports, "LocalAirportOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalAirportOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalAirportRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalAirportRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalAirportSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalAirportSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalAirportTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalAirportTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalAtm", {
	  enumerable: true,
	  get: function get() {
	    return _LocalAtm.default;
	  }
	});
	Object.defineProperty(exports, "LocalAtmOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalAtmOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalAtmRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalAtmRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalAtmSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalAtmSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalAtmTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalAtmTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalBar", {
	  enumerable: true,
	  get: function get() {
	    return _LocalBar.default;
	  }
	});
	Object.defineProperty(exports, "LocalBarOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalBarOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalBarRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalBarRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalBarSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalBarSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalBarTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalBarTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalCafe", {
	  enumerable: true,
	  get: function get() {
	    return _LocalCafe.default;
	  }
	});
	Object.defineProperty(exports, "LocalCafeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalCafeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalCafeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalCafeRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalCafeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalCafeSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalCafeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalCafeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalCarWash", {
	  enumerable: true,
	  get: function get() {
	    return _LocalCarWash.default;
	  }
	});
	Object.defineProperty(exports, "LocalCarWashOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalCarWashOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalCarWashRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalCarWashRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalCarWashSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalCarWashSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalCarWashTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalCarWashTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalConvenienceStore", {
	  enumerable: true,
	  get: function get() {
	    return _LocalConvenienceStore.default;
	  }
	});
	Object.defineProperty(exports, "LocalConvenienceStoreOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalConvenienceStoreOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalConvenienceStoreRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalConvenienceStoreRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalConvenienceStoreSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalConvenienceStoreSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalConvenienceStoreTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalConvenienceStoreTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalDining", {
	  enumerable: true,
	  get: function get() {
	    return _LocalDining.default;
	  }
	});
	Object.defineProperty(exports, "LocalDiningOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalDiningOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalDiningRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalDiningRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalDiningSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalDiningSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalDiningTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalDiningTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalDrink", {
	  enumerable: true,
	  get: function get() {
	    return _LocalDrink.default;
	  }
	});
	Object.defineProperty(exports, "LocalDrinkOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalDrinkOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalDrinkRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalDrinkRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalDrinkSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalDrinkSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalDrinkTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalDrinkTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalFlorist", {
	  enumerable: true,
	  get: function get() {
	    return _LocalFlorist.default;
	  }
	});
	Object.defineProperty(exports, "LocalFloristOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalFloristOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalFloristRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalFloristRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalFloristSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalFloristSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalFloristTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalFloristTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalGasStation", {
	  enumerable: true,
	  get: function get() {
	    return _LocalGasStation.default;
	  }
	});
	Object.defineProperty(exports, "LocalGasStationOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalGasStationOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalGasStationRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalGasStationRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalGasStationSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalGasStationSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalGasStationTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalGasStationTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalGroceryStore", {
	  enumerable: true,
	  get: function get() {
	    return _LocalGroceryStore.default;
	  }
	});
	Object.defineProperty(exports, "LocalGroceryStoreOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalGroceryStoreOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalGroceryStoreRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalGroceryStoreRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalGroceryStoreSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalGroceryStoreSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalGroceryStoreTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalGroceryStoreTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalHospital", {
	  enumerable: true,
	  get: function get() {
	    return _LocalHospital.default;
	  }
	});
	Object.defineProperty(exports, "LocalHospitalOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalHospitalOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalHospitalRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalHospitalRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalHospitalSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalHospitalSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalHospitalTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalHospitalTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalHotel", {
	  enumerable: true,
	  get: function get() {
	    return _LocalHotel.default;
	  }
	});
	Object.defineProperty(exports, "LocalHotelOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalHotelOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalHotelRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalHotelRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalHotelSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalHotelSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalHotelTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalHotelTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalLaundryService", {
	  enumerable: true,
	  get: function get() {
	    return _LocalLaundryService.default;
	  }
	});
	Object.defineProperty(exports, "LocalLaundryServiceOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalLaundryServiceOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalLaundryServiceRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalLaundryServiceRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalLaundryServiceSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalLaundryServiceSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalLaundryServiceTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalLaundryServiceTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalLibrary", {
	  enumerable: true,
	  get: function get() {
	    return _LocalLibrary.default;
	  }
	});
	Object.defineProperty(exports, "LocalLibraryOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalLibraryOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalLibraryRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalLibraryRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalLibrarySharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalLibrarySharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalLibraryTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalLibraryTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalMall", {
	  enumerable: true,
	  get: function get() {
	    return _LocalMall.default;
	  }
	});
	Object.defineProperty(exports, "LocalMallOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalMallOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalMallRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalMallRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalMallSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalMallSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalMallTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalMallTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalMovies", {
	  enumerable: true,
	  get: function get() {
	    return _LocalMovies.default;
	  }
	});
	Object.defineProperty(exports, "LocalMoviesOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalMoviesOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalMoviesRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalMoviesRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalMoviesSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalMoviesSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalMoviesTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalMoviesTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalOffer", {
	  enumerable: true,
	  get: function get() {
	    return _LocalOffer.default;
	  }
	});
	Object.defineProperty(exports, "LocalOfferOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalOfferOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalOfferRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalOfferRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalOfferSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalOfferSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalOfferTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalOfferTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalParking", {
	  enumerable: true,
	  get: function get() {
	    return _LocalParking.default;
	  }
	});
	Object.defineProperty(exports, "LocalParkingOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalParkingOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalParkingRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalParkingRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalParkingSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalParkingSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalParkingTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalParkingTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalPharmacy", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPharmacy.default;
	  }
	});
	Object.defineProperty(exports, "LocalPharmacyOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPharmacyOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalPharmacyRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPharmacyRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalPharmacySharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPharmacySharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalPharmacyTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPharmacyTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalPhone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPhone.default;
	  }
	});
	Object.defineProperty(exports, "LocalPhoneOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPhoneOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalPhoneRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPhoneRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalPhoneSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPhoneSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalPhoneTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPhoneTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalPizza", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPizza.default;
	  }
	});
	Object.defineProperty(exports, "LocalPizzaOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPizzaOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalPizzaRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPizzaRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalPizzaSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPizzaSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalPizzaTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPizzaTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalPlay", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPlay.default;
	  }
	});
	Object.defineProperty(exports, "LocalPlayOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPlayOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalPlayRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPlayRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalPlaySharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPlaySharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalPlayTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPlayTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalPostOffice", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPostOffice.default;
	  }
	});
	Object.defineProperty(exports, "LocalPostOfficeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPostOfficeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalPostOfficeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPostOfficeRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalPostOfficeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPostOfficeSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalPostOfficeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPostOfficeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalPrintshop", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPrintshop.default;
	  }
	});
	Object.defineProperty(exports, "LocalPrintshopOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPrintshopOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalPrintshopRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPrintshopRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalPrintshopSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPrintshopSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalPrintshopTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalPrintshopTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalSee", {
	  enumerable: true,
	  get: function get() {
	    return _LocalSee.default;
	  }
	});
	Object.defineProperty(exports, "LocalSeeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalSeeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalSeeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalSeeRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalSeeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalSeeSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalSeeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalSeeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalShipping", {
	  enumerable: true,
	  get: function get() {
	    return _LocalShipping.default;
	  }
	});
	Object.defineProperty(exports, "LocalShippingOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalShippingOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalShippingRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalShippingRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalShippingSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalShippingSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalShippingTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalShippingTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocalTaxi", {
	  enumerable: true,
	  get: function get() {
	    return _LocalTaxi.default;
	  }
	});
	Object.defineProperty(exports, "LocalTaxiOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocalTaxiOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocalTaxiRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocalTaxiRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocalTaxiSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocalTaxiSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocalTaxiTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocalTaxiTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocationCity", {
	  enumerable: true,
	  get: function get() {
	    return _LocationCity.default;
	  }
	});
	Object.defineProperty(exports, "LocationCityOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocationCityOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocationCityRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocationCityRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocationCitySharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocationCitySharp.default;
	  }
	});
	Object.defineProperty(exports, "LocationCityTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocationCityTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocationDisabled", {
	  enumerable: true,
	  get: function get() {
	    return _LocationDisabled.default;
	  }
	});
	Object.defineProperty(exports, "LocationDisabledOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocationDisabledOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocationDisabledRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocationDisabledRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocationDisabledSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocationDisabledSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocationDisabledTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocationDisabledTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocationOff", {
	  enumerable: true,
	  get: function get() {
	    return _LocationOff.default;
	  }
	});
	Object.defineProperty(exports, "LocationOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocationOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocationOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocationOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocationOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocationOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocationOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocationOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocationOn", {
	  enumerable: true,
	  get: function get() {
	    return _LocationOn.default;
	  }
	});
	Object.defineProperty(exports, "LocationOnOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocationOnOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocationOnRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocationOnRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocationOnSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocationOnSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocationOnTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocationOnTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LocationSearching", {
	  enumerable: true,
	  get: function get() {
	    return _LocationSearching.default;
	  }
	});
	Object.defineProperty(exports, "LocationSearchingOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LocationSearchingOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LocationSearchingRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LocationSearchingRounded.default;
	  }
	});
	Object.defineProperty(exports, "LocationSearchingSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LocationSearchingSharp.default;
	  }
	});
	Object.defineProperty(exports, "LocationSearchingTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LocationSearchingTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Lock", {
	  enumerable: true,
	  get: function get() {
	    return _Lock.default;
	  }
	});
	Object.defineProperty(exports, "LockOpen", {
	  enumerable: true,
	  get: function get() {
	    return _LockOpen.default;
	  }
	});
	Object.defineProperty(exports, "LockOpenOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LockOpenOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LockOpenRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LockOpenRounded.default;
	  }
	});
	Object.defineProperty(exports, "LockOpenSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LockOpenSharp.default;
	  }
	});
	Object.defineProperty(exports, "LockOpenTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LockOpenTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LockOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LockOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LockRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LockRounded.default;
	  }
	});
	Object.defineProperty(exports, "LockSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LockSharp.default;
	  }
	});
	Object.defineProperty(exports, "LockTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LockTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Looks", {
	  enumerable: true,
	  get: function get() {
	    return _Looks.default;
	  }
	});
	Object.defineProperty(exports, "Looks3", {
	  enumerable: true,
	  get: function get() {
	    return _Looks2.default;
	  }
	});
	Object.defineProperty(exports, "Looks3Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Looks3Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Looks3Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Looks3Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Looks3Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Looks3Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Looks3TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Looks3TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Looks4", {
	  enumerable: true,
	  get: function get() {
	    return _Looks3.default;
	  }
	});
	Object.defineProperty(exports, "Looks4Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Looks4Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Looks4Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Looks4Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Looks4Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Looks4Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Looks4TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Looks4TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Looks5", {
	  enumerable: true,
	  get: function get() {
	    return _Looks4.default;
	  }
	});
	Object.defineProperty(exports, "Looks5Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Looks5Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Looks5Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Looks5Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Looks5Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Looks5Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Looks5TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Looks5TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Looks6", {
	  enumerable: true,
	  get: function get() {
	    return _Looks5.default;
	  }
	});
	Object.defineProperty(exports, "Looks6Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Looks6Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Looks6Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Looks6Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Looks6Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Looks6Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Looks6TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Looks6TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LooksOne", {
	  enumerable: true,
	  get: function get() {
	    return _LooksOne.default;
	  }
	});
	Object.defineProperty(exports, "LooksOneOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LooksOneOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LooksOneRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LooksOneRounded.default;
	  }
	});
	Object.defineProperty(exports, "LooksOneSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LooksOneSharp.default;
	  }
	});
	Object.defineProperty(exports, "LooksOneTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LooksOneTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LooksOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LooksOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LooksRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LooksRounded.default;
	  }
	});
	Object.defineProperty(exports, "LooksSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LooksSharp.default;
	  }
	});
	Object.defineProperty(exports, "LooksTwo", {
	  enumerable: true,
	  get: function get() {
	    return _LooksTwo.default;
	  }
	});
	Object.defineProperty(exports, "LooksTwoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LooksTwoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LooksTwoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LooksTwoRounded.default;
	  }
	});
	Object.defineProperty(exports, "LooksTwoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LooksTwoSharp.default;
	  }
	});
	Object.defineProperty(exports, "LooksTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LooksTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LooksTwoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LooksTwoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Loop", {
	  enumerable: true,
	  get: function get() {
	    return _Loop.default;
	  }
	});
	Object.defineProperty(exports, "LoopOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LoopOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LoopRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LoopRounded.default;
	  }
	});
	Object.defineProperty(exports, "LoopSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LoopSharp.default;
	  }
	});
	Object.defineProperty(exports, "LoopTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LoopTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Loupe", {
	  enumerable: true,
	  get: function get() {
	    return _Loupe.default;
	  }
	});
	Object.defineProperty(exports, "LoupeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LoupeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LoupeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LoupeRounded.default;
	  }
	});
	Object.defineProperty(exports, "LoupeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _LoupeSharp.default;
	  }
	});
	Object.defineProperty(exports, "LoupeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LoupeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "LowPriority", {
	  enumerable: true,
	  get: function get() {
	    return _LowPriority.default;
	  }
	});
	Object.defineProperty(exports, "LowPriorityOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LowPriorityOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LowPriorityRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LowPriorityRounded.default;
	  }
	});
	Object.defineProperty(exports, "LowPrioritySharp", {
	  enumerable: true,
	  get: function get() {
	    return _LowPrioritySharp.default;
	  }
	});
	Object.defineProperty(exports, "LowPriorityTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LowPriorityTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Loyalty", {
	  enumerable: true,
	  get: function get() {
	    return _Loyalty.default;
	  }
	});
	Object.defineProperty(exports, "LoyaltyOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _LoyaltyOutlined.default;
	  }
	});
	Object.defineProperty(exports, "LoyaltyRounded", {
	  enumerable: true,
	  get: function get() {
	    return _LoyaltyRounded.default;
	  }
	});
	Object.defineProperty(exports, "LoyaltySharp", {
	  enumerable: true,
	  get: function get() {
	    return _LoyaltySharp.default;
	  }
	});
	Object.defineProperty(exports, "LoyaltyTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _LoyaltyTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Mail", {
	  enumerable: true,
	  get: function get() {
	    return _Mail.default;
	  }
	});
	Object.defineProperty(exports, "MailOutline", {
	  enumerable: true,
	  get: function get() {
	    return _MailOutline.default;
	  }
	});
	Object.defineProperty(exports, "MailOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MailOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MailOutlineOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MailOutlineOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MailOutlineRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MailOutlineRounded.default;
	  }
	});
	Object.defineProperty(exports, "MailOutlineSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MailOutlineSharp.default;
	  }
	});
	Object.defineProperty(exports, "MailOutlineTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MailOutlineTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MailRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MailRounded.default;
	  }
	});
	Object.defineProperty(exports, "MailSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MailSharp.default;
	  }
	});
	Object.defineProperty(exports, "MailTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MailTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Map", {
	  enumerable: true,
	  get: function get() {
	    return _Map.default;
	  }
	});
	Object.defineProperty(exports, "MapOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MapOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MapRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MapRounded.default;
	  }
	});
	Object.defineProperty(exports, "MapSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MapSharp.default;
	  }
	});
	Object.defineProperty(exports, "MapTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MapTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Markunread", {
	  enumerable: true,
	  get: function get() {
	    return _Markunread.default;
	  }
	});
	Object.defineProperty(exports, "MarkunreadMailbox", {
	  enumerable: true,
	  get: function get() {
	    return _MarkunreadMailbox.default;
	  }
	});
	Object.defineProperty(exports, "MarkunreadMailboxOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MarkunreadMailboxOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MarkunreadMailboxRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MarkunreadMailboxRounded.default;
	  }
	});
	Object.defineProperty(exports, "MarkunreadMailboxSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MarkunreadMailboxSharp.default;
	  }
	});
	Object.defineProperty(exports, "MarkunreadMailboxTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MarkunreadMailboxTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MarkunreadOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MarkunreadOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MarkunreadRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MarkunreadRounded.default;
	  }
	});
	Object.defineProperty(exports, "MarkunreadSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MarkunreadSharp.default;
	  }
	});
	Object.defineProperty(exports, "MarkunreadTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MarkunreadTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Maximize", {
	  enumerable: true,
	  get: function get() {
	    return _Maximize.default;
	  }
	});
	Object.defineProperty(exports, "MaximizeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MaximizeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MaximizeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MaximizeRounded.default;
	  }
	});
	Object.defineProperty(exports, "MaximizeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MaximizeSharp.default;
	  }
	});
	Object.defineProperty(exports, "MaximizeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MaximizeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MeetingRoom", {
	  enumerable: true,
	  get: function get() {
	    return _MeetingRoom.default;
	  }
	});
	Object.defineProperty(exports, "MeetingRoomOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MeetingRoomOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MeetingRoomRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MeetingRoomRounded.default;
	  }
	});
	Object.defineProperty(exports, "MeetingRoomSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MeetingRoomSharp.default;
	  }
	});
	Object.defineProperty(exports, "MeetingRoomTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MeetingRoomTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Memory", {
	  enumerable: true,
	  get: function get() {
	    return _Memory.default;
	  }
	});
	Object.defineProperty(exports, "MemoryOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MemoryOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MemoryRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MemoryRounded.default;
	  }
	});
	Object.defineProperty(exports, "MemorySharp", {
	  enumerable: true,
	  get: function get() {
	    return _MemorySharp.default;
	  }
	});
	Object.defineProperty(exports, "MemoryTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MemoryTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Menu", {
	  enumerable: true,
	  get: function get() {
	    return _Menu.default;
	  }
	});
	Object.defineProperty(exports, "MenuBook", {
	  enumerable: true,
	  get: function get() {
	    return _MenuBook.default;
	  }
	});
	Object.defineProperty(exports, "MenuBookOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MenuBookOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MenuBookRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MenuBookRounded.default;
	  }
	});
	Object.defineProperty(exports, "MenuBookSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MenuBookSharp.default;
	  }
	});
	Object.defineProperty(exports, "MenuBookTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MenuBookTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MenuOpen", {
	  enumerable: true,
	  get: function get() {
	    return _MenuOpen.default;
	  }
	});
	Object.defineProperty(exports, "MenuOpenOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MenuOpenOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MenuOpenRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MenuOpenRounded.default;
	  }
	});
	Object.defineProperty(exports, "MenuOpenSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MenuOpenSharp.default;
	  }
	});
	Object.defineProperty(exports, "MenuOpenTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MenuOpenTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MenuOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MenuOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MenuRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MenuRounded.default;
	  }
	});
	Object.defineProperty(exports, "MenuSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MenuSharp.default;
	  }
	});
	Object.defineProperty(exports, "MenuTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MenuTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MergeType", {
	  enumerable: true,
	  get: function get() {
	    return _MergeType.default;
	  }
	});
	Object.defineProperty(exports, "MergeTypeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MergeTypeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MergeTypeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MergeTypeRounded.default;
	  }
	});
	Object.defineProperty(exports, "MergeTypeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MergeTypeSharp.default;
	  }
	});
	Object.defineProperty(exports, "MergeTypeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MergeTypeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Message", {
	  enumerable: true,
	  get: function get() {
	    return _Message.default;
	  }
	});
	Object.defineProperty(exports, "MessageOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MessageOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MessageRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MessageRounded.default;
	  }
	});
	Object.defineProperty(exports, "MessageSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MessageSharp.default;
	  }
	});
	Object.defineProperty(exports, "MessageTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MessageTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Mic", {
	  enumerable: true,
	  get: function get() {
	    return _Mic.default;
	  }
	});
	Object.defineProperty(exports, "MicNone", {
	  enumerable: true,
	  get: function get() {
	    return _MicNone.default;
	  }
	});
	Object.defineProperty(exports, "MicNoneOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MicNoneOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MicNoneRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MicNoneRounded.default;
	  }
	});
	Object.defineProperty(exports, "MicNoneSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MicNoneSharp.default;
	  }
	});
	Object.defineProperty(exports, "MicNoneTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MicNoneTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MicOff", {
	  enumerable: true,
	  get: function get() {
	    return _MicOff.default;
	  }
	});
	Object.defineProperty(exports, "MicOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MicOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MicOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MicOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "MicOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MicOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "MicOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MicOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MicOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MicOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MicRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MicRounded.default;
	  }
	});
	Object.defineProperty(exports, "MicSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MicSharp.default;
	  }
	});
	Object.defineProperty(exports, "MicTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MicTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Minimize", {
	  enumerable: true,
	  get: function get() {
	    return _Minimize.default;
	  }
	});
	Object.defineProperty(exports, "MinimizeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MinimizeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MinimizeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MinimizeRounded.default;
	  }
	});
	Object.defineProperty(exports, "MinimizeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MinimizeSharp.default;
	  }
	});
	Object.defineProperty(exports, "MinimizeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MinimizeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MissedVideoCall", {
	  enumerable: true,
	  get: function get() {
	    return _MissedVideoCall.default;
	  }
	});
	Object.defineProperty(exports, "MissedVideoCallOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MissedVideoCallOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MissedVideoCallRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MissedVideoCallRounded.default;
	  }
	});
	Object.defineProperty(exports, "MissedVideoCallSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MissedVideoCallSharp.default;
	  }
	});
	Object.defineProperty(exports, "MissedVideoCallTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MissedVideoCallTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Mms", {
	  enumerable: true,
	  get: function get() {
	    return _Mms.default;
	  }
	});
	Object.defineProperty(exports, "MmsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MmsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MmsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MmsRounded.default;
	  }
	});
	Object.defineProperty(exports, "MmsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MmsSharp.default;
	  }
	});
	Object.defineProperty(exports, "MmsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MmsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MobileFriendly", {
	  enumerable: true,
	  get: function get() {
	    return _MobileFriendly.default;
	  }
	});
	Object.defineProperty(exports, "MobileFriendlyOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MobileFriendlyOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MobileFriendlyRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MobileFriendlyRounded.default;
	  }
	});
	Object.defineProperty(exports, "MobileFriendlySharp", {
	  enumerable: true,
	  get: function get() {
	    return _MobileFriendlySharp.default;
	  }
	});
	Object.defineProperty(exports, "MobileFriendlyTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MobileFriendlyTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MobileOff", {
	  enumerable: true,
	  get: function get() {
	    return _MobileOff.default;
	  }
	});
	Object.defineProperty(exports, "MobileOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MobileOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MobileOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MobileOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "MobileOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MobileOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "MobileOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MobileOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MobileScreenShare", {
	  enumerable: true,
	  get: function get() {
	    return _MobileScreenShare.default;
	  }
	});
	Object.defineProperty(exports, "MobileScreenShareOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MobileScreenShareOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MobileScreenShareRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MobileScreenShareRounded.default;
	  }
	});
	Object.defineProperty(exports, "MobileScreenShareSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MobileScreenShareSharp.default;
	  }
	});
	Object.defineProperty(exports, "MobileScreenShareTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MobileScreenShareTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ModeComment", {
	  enumerable: true,
	  get: function get() {
	    return _ModeComment.default;
	  }
	});
	Object.defineProperty(exports, "ModeCommentOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ModeCommentOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ModeCommentRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ModeCommentRounded.default;
	  }
	});
	Object.defineProperty(exports, "ModeCommentSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ModeCommentSharp.default;
	  }
	});
	Object.defineProperty(exports, "ModeCommentTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ModeCommentTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MonetizationOn", {
	  enumerable: true,
	  get: function get() {
	    return _MonetizationOn.default;
	  }
	});
	Object.defineProperty(exports, "MonetizationOnOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MonetizationOnOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MonetizationOnRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MonetizationOnRounded.default;
	  }
	});
	Object.defineProperty(exports, "MonetizationOnSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MonetizationOnSharp.default;
	  }
	});
	Object.defineProperty(exports, "MonetizationOnTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MonetizationOnTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Money", {
	  enumerable: true,
	  get: function get() {
	    return _Money.default;
	  }
	});
	Object.defineProperty(exports, "MoneyOff", {
	  enumerable: true,
	  get: function get() {
	    return _MoneyOff.default;
	  }
	});
	Object.defineProperty(exports, "MoneyOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MoneyOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MoneyOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MoneyOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "MoneyOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MoneyOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "MoneyOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MoneyOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MoneyOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MoneyOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MoneyRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MoneyRounded.default;
	  }
	});
	Object.defineProperty(exports, "MoneySharp", {
	  enumerable: true,
	  get: function get() {
	    return _MoneySharp.default;
	  }
	});
	Object.defineProperty(exports, "MoneyTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MoneyTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MonochromePhotos", {
	  enumerable: true,
	  get: function get() {
	    return _MonochromePhotos.default;
	  }
	});
	Object.defineProperty(exports, "MonochromePhotosOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MonochromePhotosOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MonochromePhotosRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MonochromePhotosRounded.default;
	  }
	});
	Object.defineProperty(exports, "MonochromePhotosSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MonochromePhotosSharp.default;
	  }
	});
	Object.defineProperty(exports, "MonochromePhotosTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MonochromePhotosTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Mood", {
	  enumerable: true,
	  get: function get() {
	    return _Mood.default;
	  }
	});
	Object.defineProperty(exports, "MoodBad", {
	  enumerable: true,
	  get: function get() {
	    return _MoodBad.default;
	  }
	});
	Object.defineProperty(exports, "MoodBadOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MoodBadOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MoodBadRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MoodBadRounded.default;
	  }
	});
	Object.defineProperty(exports, "MoodBadSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MoodBadSharp.default;
	  }
	});
	Object.defineProperty(exports, "MoodBadTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MoodBadTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MoodOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MoodOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MoodRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MoodRounded.default;
	  }
	});
	Object.defineProperty(exports, "MoodSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MoodSharp.default;
	  }
	});
	Object.defineProperty(exports, "MoodTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MoodTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "More", {
	  enumerable: true,
	  get: function get() {
	    return _More.default;
	  }
	});
	Object.defineProperty(exports, "MoreHoriz", {
	  enumerable: true,
	  get: function get() {
	    return _MoreHoriz.default;
	  }
	});
	Object.defineProperty(exports, "MoreHorizOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MoreHorizOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MoreHorizRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MoreHorizRounded.default;
	  }
	});
	Object.defineProperty(exports, "MoreHorizSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MoreHorizSharp.default;
	  }
	});
	Object.defineProperty(exports, "MoreHorizTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MoreHorizTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MoreOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MoreOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MoreRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MoreRounded.default;
	  }
	});
	Object.defineProperty(exports, "MoreSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MoreSharp.default;
	  }
	});
	Object.defineProperty(exports, "MoreTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MoreTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MoreVert", {
	  enumerable: true,
	  get: function get() {
	    return _MoreVert.default;
	  }
	});
	Object.defineProperty(exports, "MoreVertOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MoreVertOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MoreVertRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MoreVertRounded.default;
	  }
	});
	Object.defineProperty(exports, "MoreVertSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MoreVertSharp.default;
	  }
	});
	Object.defineProperty(exports, "MoreVertTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MoreVertTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Motorcycle", {
	  enumerable: true,
	  get: function get() {
	    return _Motorcycle.default;
	  }
	});
	Object.defineProperty(exports, "MotorcycleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MotorcycleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MotorcycleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MotorcycleRounded.default;
	  }
	});
	Object.defineProperty(exports, "MotorcycleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MotorcycleSharp.default;
	  }
	});
	Object.defineProperty(exports, "MotorcycleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MotorcycleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Mouse", {
	  enumerable: true,
	  get: function get() {
	    return _Mouse.default;
	  }
	});
	Object.defineProperty(exports, "MouseOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MouseOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MouseRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MouseRounded.default;
	  }
	});
	Object.defineProperty(exports, "MouseSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MouseSharp.default;
	  }
	});
	Object.defineProperty(exports, "MouseTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MouseTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MoveToInbox", {
	  enumerable: true,
	  get: function get() {
	    return _MoveToInbox.default;
	  }
	});
	Object.defineProperty(exports, "MoveToInboxOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MoveToInboxOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MoveToInboxRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MoveToInboxRounded.default;
	  }
	});
	Object.defineProperty(exports, "MoveToInboxSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MoveToInboxSharp.default;
	  }
	});
	Object.defineProperty(exports, "MoveToInboxTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MoveToInboxTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Movie", {
	  enumerable: true,
	  get: function get() {
	    return _Movie.default;
	  }
	});
	Object.defineProperty(exports, "MovieCreation", {
	  enumerable: true,
	  get: function get() {
	    return _MovieCreation.default;
	  }
	});
	Object.defineProperty(exports, "MovieCreationOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MovieCreationOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MovieCreationRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MovieCreationRounded.default;
	  }
	});
	Object.defineProperty(exports, "MovieCreationSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MovieCreationSharp.default;
	  }
	});
	Object.defineProperty(exports, "MovieCreationTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MovieCreationTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MovieFilter", {
	  enumerable: true,
	  get: function get() {
	    return _MovieFilter.default;
	  }
	});
	Object.defineProperty(exports, "MovieFilterOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MovieFilterOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MovieFilterRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MovieFilterRounded.default;
	  }
	});
	Object.defineProperty(exports, "MovieFilterSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MovieFilterSharp.default;
	  }
	});
	Object.defineProperty(exports, "MovieFilterTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MovieFilterTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MovieOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MovieOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MovieRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MovieRounded.default;
	  }
	});
	Object.defineProperty(exports, "MovieSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MovieSharp.default;
	  }
	});
	Object.defineProperty(exports, "MovieTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MovieTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MultilineChart", {
	  enumerable: true,
	  get: function get() {
	    return _MultilineChart.default;
	  }
	});
	Object.defineProperty(exports, "MultilineChartOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MultilineChartOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MultilineChartRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MultilineChartRounded.default;
	  }
	});
	Object.defineProperty(exports, "MultilineChartSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MultilineChartSharp.default;
	  }
	});
	Object.defineProperty(exports, "MultilineChartTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MultilineChartTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Museum", {
	  enumerable: true,
	  get: function get() {
	    return _Museum.default;
	  }
	});
	Object.defineProperty(exports, "MuseumOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MuseumOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MuseumRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MuseumRounded.default;
	  }
	});
	Object.defineProperty(exports, "MuseumSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MuseumSharp.default;
	  }
	});
	Object.defineProperty(exports, "MuseumTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MuseumTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MusicNote", {
	  enumerable: true,
	  get: function get() {
	    return _MusicNote.default;
	  }
	});
	Object.defineProperty(exports, "MusicNoteOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MusicNoteOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MusicNoteRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MusicNoteRounded.default;
	  }
	});
	Object.defineProperty(exports, "MusicNoteSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MusicNoteSharp.default;
	  }
	});
	Object.defineProperty(exports, "MusicNoteTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MusicNoteTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MusicOff", {
	  enumerable: true,
	  get: function get() {
	    return _MusicOff.default;
	  }
	});
	Object.defineProperty(exports, "MusicOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MusicOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MusicOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MusicOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "MusicOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MusicOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "MusicOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MusicOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MusicVideo", {
	  enumerable: true,
	  get: function get() {
	    return _MusicVideo.default;
	  }
	});
	Object.defineProperty(exports, "MusicVideoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MusicVideoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MusicVideoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MusicVideoRounded.default;
	  }
	});
	Object.defineProperty(exports, "MusicVideoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MusicVideoSharp.default;
	  }
	});
	Object.defineProperty(exports, "MusicVideoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MusicVideoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "MyLocation", {
	  enumerable: true,
	  get: function get() {
	    return _MyLocation.default;
	  }
	});
	Object.defineProperty(exports, "MyLocationOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _MyLocationOutlined.default;
	  }
	});
	Object.defineProperty(exports, "MyLocationRounded", {
	  enumerable: true,
	  get: function get() {
	    return _MyLocationRounded.default;
	  }
	});
	Object.defineProperty(exports, "MyLocationSharp", {
	  enumerable: true,
	  get: function get() {
	    return _MyLocationSharp.default;
	  }
	});
	Object.defineProperty(exports, "MyLocationTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _MyLocationTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Nature", {
	  enumerable: true,
	  get: function get() {
	    return _Nature.default;
	  }
	});
	Object.defineProperty(exports, "NatureOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NatureOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NaturePeople", {
	  enumerable: true,
	  get: function get() {
	    return _NaturePeople.default;
	  }
	});
	Object.defineProperty(exports, "NaturePeopleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NaturePeopleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NaturePeopleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NaturePeopleRounded.default;
	  }
	});
	Object.defineProperty(exports, "NaturePeopleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NaturePeopleSharp.default;
	  }
	});
	Object.defineProperty(exports, "NaturePeopleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NaturePeopleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NatureRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NatureRounded.default;
	  }
	});
	Object.defineProperty(exports, "NatureSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NatureSharp.default;
	  }
	});
	Object.defineProperty(exports, "NatureTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NatureTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NavigateBefore", {
	  enumerable: true,
	  get: function get() {
	    return _NavigateBefore.default;
	  }
	});
	Object.defineProperty(exports, "NavigateBeforeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NavigateBeforeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NavigateBeforeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NavigateBeforeRounded.default;
	  }
	});
	Object.defineProperty(exports, "NavigateBeforeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NavigateBeforeSharp.default;
	  }
	});
	Object.defineProperty(exports, "NavigateBeforeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NavigateBeforeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NavigateNext", {
	  enumerable: true,
	  get: function get() {
	    return _NavigateNext.default;
	  }
	});
	Object.defineProperty(exports, "NavigateNextOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NavigateNextOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NavigateNextRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NavigateNextRounded.default;
	  }
	});
	Object.defineProperty(exports, "NavigateNextSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NavigateNextSharp.default;
	  }
	});
	Object.defineProperty(exports, "NavigateNextTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NavigateNextTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Navigation", {
	  enumerable: true,
	  get: function get() {
	    return _Navigation.default;
	  }
	});
	Object.defineProperty(exports, "NavigationOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NavigationOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NavigationRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NavigationRounded.default;
	  }
	});
	Object.defineProperty(exports, "NavigationSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NavigationSharp.default;
	  }
	});
	Object.defineProperty(exports, "NavigationTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NavigationTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NearMe", {
	  enumerable: true,
	  get: function get() {
	    return _NearMe.default;
	  }
	});
	Object.defineProperty(exports, "NearMeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NearMeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NearMeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NearMeRounded.default;
	  }
	});
	Object.defineProperty(exports, "NearMeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NearMeSharp.default;
	  }
	});
	Object.defineProperty(exports, "NearMeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NearMeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NetworkCell", {
	  enumerable: true,
	  get: function get() {
	    return _NetworkCell.default;
	  }
	});
	Object.defineProperty(exports, "NetworkCellOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NetworkCellOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NetworkCellRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NetworkCellRounded.default;
	  }
	});
	Object.defineProperty(exports, "NetworkCellSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NetworkCellSharp.default;
	  }
	});
	Object.defineProperty(exports, "NetworkCellTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NetworkCellTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NetworkCheck", {
	  enumerable: true,
	  get: function get() {
	    return _NetworkCheck.default;
	  }
	});
	Object.defineProperty(exports, "NetworkCheckOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NetworkCheckOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NetworkCheckRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NetworkCheckRounded.default;
	  }
	});
	Object.defineProperty(exports, "NetworkCheckSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NetworkCheckSharp.default;
	  }
	});
	Object.defineProperty(exports, "NetworkCheckTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NetworkCheckTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NetworkLocked", {
	  enumerable: true,
	  get: function get() {
	    return _NetworkLocked.default;
	  }
	});
	Object.defineProperty(exports, "NetworkLockedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NetworkLockedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NetworkLockedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NetworkLockedRounded.default;
	  }
	});
	Object.defineProperty(exports, "NetworkLockedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NetworkLockedSharp.default;
	  }
	});
	Object.defineProperty(exports, "NetworkLockedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NetworkLockedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NetworkWifi", {
	  enumerable: true,
	  get: function get() {
	    return _NetworkWifi.default;
	  }
	});
	Object.defineProperty(exports, "NetworkWifiOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NetworkWifiOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NetworkWifiRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NetworkWifiRounded.default;
	  }
	});
	Object.defineProperty(exports, "NetworkWifiSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NetworkWifiSharp.default;
	  }
	});
	Object.defineProperty(exports, "NetworkWifiTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NetworkWifiTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NewReleases", {
	  enumerable: true,
	  get: function get() {
	    return _NewReleases.default;
	  }
	});
	Object.defineProperty(exports, "NewReleasesOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NewReleasesOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NewReleasesRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NewReleasesRounded.default;
	  }
	});
	Object.defineProperty(exports, "NewReleasesSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NewReleasesSharp.default;
	  }
	});
	Object.defineProperty(exports, "NewReleasesTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NewReleasesTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NextWeek", {
	  enumerable: true,
	  get: function get() {
	    return _NextWeek.default;
	  }
	});
	Object.defineProperty(exports, "NextWeekOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NextWeekOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NextWeekRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NextWeekRounded.default;
	  }
	});
	Object.defineProperty(exports, "NextWeekSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NextWeekSharp.default;
	  }
	});
	Object.defineProperty(exports, "NextWeekTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NextWeekTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Nfc", {
	  enumerable: true,
	  get: function get() {
	    return _Nfc.default;
	  }
	});
	Object.defineProperty(exports, "NfcOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NfcOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NfcRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NfcRounded.default;
	  }
	});
	Object.defineProperty(exports, "NfcSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NfcSharp.default;
	  }
	});
	Object.defineProperty(exports, "NfcTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NfcTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NightsStay", {
	  enumerable: true,
	  get: function get() {
	    return _NightsStay.default;
	  }
	});
	Object.defineProperty(exports, "NightsStayOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NightsStayOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NightsStayRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NightsStayRounded.default;
	  }
	});
	Object.defineProperty(exports, "NightsStaySharp", {
	  enumerable: true,
	  get: function get() {
	    return _NightsStaySharp.default;
	  }
	});
	Object.defineProperty(exports, "NightsStayTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NightsStayTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NoEncryption", {
	  enumerable: true,
	  get: function get() {
	    return _NoEncryption.default;
	  }
	});
	Object.defineProperty(exports, "NoEncryptionOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NoEncryptionOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NoEncryptionRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NoEncryptionRounded.default;
	  }
	});
	Object.defineProperty(exports, "NoEncryptionSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NoEncryptionSharp.default;
	  }
	});
	Object.defineProperty(exports, "NoEncryptionTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NoEncryptionTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NoMeetingRoom", {
	  enumerable: true,
	  get: function get() {
	    return _NoMeetingRoom.default;
	  }
	});
	Object.defineProperty(exports, "NoMeetingRoomOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NoMeetingRoomOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NoMeetingRoomRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NoMeetingRoomRounded.default;
	  }
	});
	Object.defineProperty(exports, "NoMeetingRoomSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NoMeetingRoomSharp.default;
	  }
	});
	Object.defineProperty(exports, "NoMeetingRoomTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NoMeetingRoomTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NoSim", {
	  enumerable: true,
	  get: function get() {
	    return _NoSim.default;
	  }
	});
	Object.defineProperty(exports, "NoSimOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NoSimOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NoSimRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NoSimRounded.default;
	  }
	});
	Object.defineProperty(exports, "NoSimSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NoSimSharp.default;
	  }
	});
	Object.defineProperty(exports, "NoSimTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NoSimTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Note", {
	  enumerable: true,
	  get: function get() {
	    return _Note.default;
	  }
	});
	Object.defineProperty(exports, "NoteAdd", {
	  enumerable: true,
	  get: function get() {
	    return _NoteAdd.default;
	  }
	});
	Object.defineProperty(exports, "NoteAddOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NoteAddOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NoteAddRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NoteAddRounded.default;
	  }
	});
	Object.defineProperty(exports, "NoteAddSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NoteAddSharp.default;
	  }
	});
	Object.defineProperty(exports, "NoteAddTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NoteAddTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NoteOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NoteOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NoteRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NoteRounded.default;
	  }
	});
	Object.defineProperty(exports, "Notes", {
	  enumerable: true,
	  get: function get() {
	    return _Notes.default;
	  }
	});
	Object.defineProperty(exports, "NoteSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NoteSharp.default;
	  }
	});
	Object.defineProperty(exports, "NotesOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NotesOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NotesRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NotesRounded.default;
	  }
	});
	Object.defineProperty(exports, "NotesSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NotesSharp.default;
	  }
	});
	Object.defineProperty(exports, "NotesTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NotesTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NoteTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NoteTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NotificationImportant", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationImportant.default;
	  }
	});
	Object.defineProperty(exports, "NotificationImportantOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationImportantOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NotificationImportantRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationImportantRounded.default;
	  }
	});
	Object.defineProperty(exports, "NotificationImportantSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationImportantSharp.default;
	  }
	});
	Object.defineProperty(exports, "NotificationImportantTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationImportantTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Notifications", {
	  enumerable: true,
	  get: function get() {
	    return _Notifications.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsActive", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsActive.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsActiveOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsActiveOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsActiveRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsActiveRounded.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsActiveSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsActiveSharp.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsActiveTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsActiveTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsNone", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsNone.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsNoneOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsNoneOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsNoneRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsNoneRounded.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsNoneSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsNoneSharp.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsNoneTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsNoneTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsOff", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsOff.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsPaused", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsPaused.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsPausedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsPausedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsPausedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsPausedRounded.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsPausedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsPausedSharp.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsPausedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsPausedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsRounded.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsSharp.default;
	  }
	});
	Object.defineProperty(exports, "NotificationsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NotificationsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NotInterested", {
	  enumerable: true,
	  get: function get() {
	    return _NotInterested.default;
	  }
	});
	Object.defineProperty(exports, "NotInterestedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NotInterestedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NotInterestedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NotInterestedRounded.default;
	  }
	});
	Object.defineProperty(exports, "NotInterestedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NotInterestedSharp.default;
	  }
	});
	Object.defineProperty(exports, "NotInterestedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NotInterestedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "NotListedLocation", {
	  enumerable: true,
	  get: function get() {
	    return _NotListedLocation.default;
	  }
	});
	Object.defineProperty(exports, "NotListedLocationOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _NotListedLocationOutlined.default;
	  }
	});
	Object.defineProperty(exports, "NotListedLocationRounded", {
	  enumerable: true,
	  get: function get() {
	    return _NotListedLocationRounded.default;
	  }
	});
	Object.defineProperty(exports, "NotListedLocationSharp", {
	  enumerable: true,
	  get: function get() {
	    return _NotListedLocationSharp.default;
	  }
	});
	Object.defineProperty(exports, "NotListedLocationTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _NotListedLocationTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "OfflineBolt", {
	  enumerable: true,
	  get: function get() {
	    return _OfflineBolt.default;
	  }
	});
	Object.defineProperty(exports, "OfflineBoltOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _OfflineBoltOutlined.default;
	  }
	});
	Object.defineProperty(exports, "OfflineBoltRounded", {
	  enumerable: true,
	  get: function get() {
	    return _OfflineBoltRounded.default;
	  }
	});
	Object.defineProperty(exports, "OfflineBoltSharp", {
	  enumerable: true,
	  get: function get() {
	    return _OfflineBoltSharp.default;
	  }
	});
	Object.defineProperty(exports, "OfflineBoltTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _OfflineBoltTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "OfflinePin", {
	  enumerable: true,
	  get: function get() {
	    return _OfflinePin.default;
	  }
	});
	Object.defineProperty(exports, "OfflinePinOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _OfflinePinOutlined.default;
	  }
	});
	Object.defineProperty(exports, "OfflinePinRounded", {
	  enumerable: true,
	  get: function get() {
	    return _OfflinePinRounded.default;
	  }
	});
	Object.defineProperty(exports, "OfflinePinSharp", {
	  enumerable: true,
	  get: function get() {
	    return _OfflinePinSharp.default;
	  }
	});
	Object.defineProperty(exports, "OfflinePinTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _OfflinePinTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "OndemandVideo", {
	  enumerable: true,
	  get: function get() {
	    return _OndemandVideo.default;
	  }
	});
	Object.defineProperty(exports, "OndemandVideoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _OndemandVideoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "OndemandVideoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _OndemandVideoRounded.default;
	  }
	});
	Object.defineProperty(exports, "OndemandVideoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _OndemandVideoSharp.default;
	  }
	});
	Object.defineProperty(exports, "OndemandVideoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _OndemandVideoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Opacity", {
	  enumerable: true,
	  get: function get() {
	    return _Opacity.default;
	  }
	});
	Object.defineProperty(exports, "OpacityOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _OpacityOutlined.default;
	  }
	});
	Object.defineProperty(exports, "OpacityRounded", {
	  enumerable: true,
	  get: function get() {
	    return _OpacityRounded.default;
	  }
	});
	Object.defineProperty(exports, "OpacitySharp", {
	  enumerable: true,
	  get: function get() {
	    return _OpacitySharp.default;
	  }
	});
	Object.defineProperty(exports, "OpacityTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _OpacityTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "OpenInBrowser", {
	  enumerable: true,
	  get: function get() {
	    return _OpenInBrowser.default;
	  }
	});
	Object.defineProperty(exports, "OpenInBrowserOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _OpenInBrowserOutlined.default;
	  }
	});
	Object.defineProperty(exports, "OpenInBrowserRounded", {
	  enumerable: true,
	  get: function get() {
	    return _OpenInBrowserRounded.default;
	  }
	});
	Object.defineProperty(exports, "OpenInBrowserSharp", {
	  enumerable: true,
	  get: function get() {
	    return _OpenInBrowserSharp.default;
	  }
	});
	Object.defineProperty(exports, "OpenInBrowserTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _OpenInBrowserTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "OpenInNew", {
	  enumerable: true,
	  get: function get() {
	    return _OpenInNew.default;
	  }
	});
	Object.defineProperty(exports, "OpenInNewOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _OpenInNewOutlined.default;
	  }
	});
	Object.defineProperty(exports, "OpenInNewRounded", {
	  enumerable: true,
	  get: function get() {
	    return _OpenInNewRounded.default;
	  }
	});
	Object.defineProperty(exports, "OpenInNewSharp", {
	  enumerable: true,
	  get: function get() {
	    return _OpenInNewSharp.default;
	  }
	});
	Object.defineProperty(exports, "OpenInNewTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _OpenInNewTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "OpenWith", {
	  enumerable: true,
	  get: function get() {
	    return _OpenWith.default;
	  }
	});
	Object.defineProperty(exports, "OpenWithOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _OpenWithOutlined.default;
	  }
	});
	Object.defineProperty(exports, "OpenWithRounded", {
	  enumerable: true,
	  get: function get() {
	    return _OpenWithRounded.default;
	  }
	});
	Object.defineProperty(exports, "OpenWithSharp", {
	  enumerable: true,
	  get: function get() {
	    return _OpenWithSharp.default;
	  }
	});
	Object.defineProperty(exports, "OpenWithTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _OpenWithTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "OutdoorGrill", {
	  enumerable: true,
	  get: function get() {
	    return _OutdoorGrill.default;
	  }
	});
	Object.defineProperty(exports, "OutdoorGrillOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _OutdoorGrillOutlined.default;
	  }
	});
	Object.defineProperty(exports, "OutdoorGrillRounded", {
	  enumerable: true,
	  get: function get() {
	    return _OutdoorGrillRounded.default;
	  }
	});
	Object.defineProperty(exports, "OutdoorGrillSharp", {
	  enumerable: true,
	  get: function get() {
	    return _OutdoorGrillSharp.default;
	  }
	});
	Object.defineProperty(exports, "OutdoorGrillTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _OutdoorGrillTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "OutlinedFlag", {
	  enumerable: true,
	  get: function get() {
	    return _OutlinedFlag.default;
	  }
	});
	Object.defineProperty(exports, "OutlinedFlagOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _OutlinedFlagOutlined.default;
	  }
	});
	Object.defineProperty(exports, "OutlinedFlagRounded", {
	  enumerable: true,
	  get: function get() {
	    return _OutlinedFlagRounded.default;
	  }
	});
	Object.defineProperty(exports, "OutlinedFlagSharp", {
	  enumerable: true,
	  get: function get() {
	    return _OutlinedFlagSharp.default;
	  }
	});
	Object.defineProperty(exports, "OutlinedFlagTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _OutlinedFlagTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Pages", {
	  enumerable: true,
	  get: function get() {
	    return _Pages.default;
	  }
	});
	Object.defineProperty(exports, "PagesOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PagesOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PagesRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PagesRounded.default;
	  }
	});
	Object.defineProperty(exports, "PagesSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PagesSharp.default;
	  }
	});
	Object.defineProperty(exports, "PagesTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PagesTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Pageview", {
	  enumerable: true,
	  get: function get() {
	    return _Pageview.default;
	  }
	});
	Object.defineProperty(exports, "PageviewOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PageviewOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PageviewRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PageviewRounded.default;
	  }
	});
	Object.defineProperty(exports, "PageviewSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PageviewSharp.default;
	  }
	});
	Object.defineProperty(exports, "PageviewTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PageviewTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Palette", {
	  enumerable: true,
	  get: function get() {
	    return _Palette.default;
	  }
	});
	Object.defineProperty(exports, "PaletteOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PaletteOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PaletteRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PaletteRounded.default;
	  }
	});
	Object.defineProperty(exports, "PaletteSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PaletteSharp.default;
	  }
	});
	Object.defineProperty(exports, "PaletteTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PaletteTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Panorama", {
	  enumerable: true,
	  get: function get() {
	    return _Panorama.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaFishEye", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaFishEye.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaFishEyeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaFishEyeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaFishEyeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaFishEyeRounded.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaFishEyeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaFishEyeSharp.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaFishEyeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaFishEyeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaHorizontal", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaHorizontal.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaHorizontalOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaHorizontalOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaHorizontalRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaHorizontalRounded.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaHorizontalSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaHorizontalSharp.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaHorizontalTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaHorizontalTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaRounded.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaSharp.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaVertical", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaVertical.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaVerticalOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaVerticalOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaVerticalRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaVerticalRounded.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaVerticalSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaVerticalSharp.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaVerticalTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaVerticalTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaWideAngle", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaWideAngle.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaWideAngleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaWideAngleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaWideAngleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaWideAngleRounded.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaWideAngleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaWideAngleSharp.default;
	  }
	});
	Object.defineProperty(exports, "PanoramaWideAngleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PanoramaWideAngleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PanTool", {
	  enumerable: true,
	  get: function get() {
	    return _PanTool.default;
	  }
	});
	Object.defineProperty(exports, "PanToolOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PanToolOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PanToolRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PanToolRounded.default;
	  }
	});
	Object.defineProperty(exports, "PanToolSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PanToolSharp.default;
	  }
	});
	Object.defineProperty(exports, "PanToolTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PanToolTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PartyMode", {
	  enumerable: true,
	  get: function get() {
	    return _PartyMode.default;
	  }
	});
	Object.defineProperty(exports, "PartyModeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PartyModeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PartyModeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PartyModeRounded.default;
	  }
	});
	Object.defineProperty(exports, "PartyModeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PartyModeSharp.default;
	  }
	});
	Object.defineProperty(exports, "PartyModeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PartyModeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Pause", {
	  enumerable: true,
	  get: function get() {
	    return _Pause.default;
	  }
	});
	Object.defineProperty(exports, "PauseCircleFilled", {
	  enumerable: true,
	  get: function get() {
	    return _PauseCircleFilled.default;
	  }
	});
	Object.defineProperty(exports, "PauseCircleFilledOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PauseCircleFilledOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PauseCircleFilledRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PauseCircleFilledRounded.default;
	  }
	});
	Object.defineProperty(exports, "PauseCircleFilledSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PauseCircleFilledSharp.default;
	  }
	});
	Object.defineProperty(exports, "PauseCircleFilledTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PauseCircleFilledTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PauseCircleOutline", {
	  enumerable: true,
	  get: function get() {
	    return _PauseCircleOutline.default;
	  }
	});
	Object.defineProperty(exports, "PauseCircleOutlineOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PauseCircleOutlineOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PauseCircleOutlineRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PauseCircleOutlineRounded.default;
	  }
	});
	Object.defineProperty(exports, "PauseCircleOutlineSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PauseCircleOutlineSharp.default;
	  }
	});
	Object.defineProperty(exports, "PauseCircleOutlineTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PauseCircleOutlineTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PauseOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PauseOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PausePresentation", {
	  enumerable: true,
	  get: function get() {
	    return _PausePresentation.default;
	  }
	});
	Object.defineProperty(exports, "PausePresentationOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PausePresentationOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PausePresentationRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PausePresentationRounded.default;
	  }
	});
	Object.defineProperty(exports, "PausePresentationSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PausePresentationSharp.default;
	  }
	});
	Object.defineProperty(exports, "PausePresentationTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PausePresentationTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PauseRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PauseRounded.default;
	  }
	});
	Object.defineProperty(exports, "PauseSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PauseSharp.default;
	  }
	});
	Object.defineProperty(exports, "PauseTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PauseTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Payment", {
	  enumerable: true,
	  get: function get() {
	    return _Payment.default;
	  }
	});
	Object.defineProperty(exports, "PaymentOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PaymentOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PaymentRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PaymentRounded.default;
	  }
	});
	Object.defineProperty(exports, "PaymentSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PaymentSharp.default;
	  }
	});
	Object.defineProperty(exports, "PaymentTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PaymentTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "People", {
	  enumerable: true,
	  get: function get() {
	    return _People.default;
	  }
	});
	Object.defineProperty(exports, "PeopleAlt", {
	  enumerable: true,
	  get: function get() {
	    return _PeopleAlt.default;
	  }
	});
	Object.defineProperty(exports, "PeopleAltOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PeopleAltOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PeopleAltRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PeopleAltRounded.default;
	  }
	});
	Object.defineProperty(exports, "PeopleAltSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PeopleAltSharp.default;
	  }
	});
	Object.defineProperty(exports, "PeopleAltTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PeopleAltTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PeopleOutline", {
	  enumerable: true,
	  get: function get() {
	    return _PeopleOutline.default;
	  }
	});
	Object.defineProperty(exports, "PeopleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PeopleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PeopleOutlineOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PeopleOutlineOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PeopleOutlineRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PeopleOutlineRounded.default;
	  }
	});
	Object.defineProperty(exports, "PeopleOutlineSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PeopleOutlineSharp.default;
	  }
	});
	Object.defineProperty(exports, "PeopleOutlineTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PeopleOutlineTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PeopleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PeopleRounded.default;
	  }
	});
	Object.defineProperty(exports, "PeopleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PeopleSharp.default;
	  }
	});
	Object.defineProperty(exports, "PeopleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PeopleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PermCameraMic", {
	  enumerable: true,
	  get: function get() {
	    return _PermCameraMic.default;
	  }
	});
	Object.defineProperty(exports, "PermCameraMicOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PermCameraMicOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PermCameraMicRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PermCameraMicRounded.default;
	  }
	});
	Object.defineProperty(exports, "PermCameraMicSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PermCameraMicSharp.default;
	  }
	});
	Object.defineProperty(exports, "PermCameraMicTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PermCameraMicTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PermContactCalendar", {
	  enumerable: true,
	  get: function get() {
	    return _PermContactCalendar.default;
	  }
	});
	Object.defineProperty(exports, "PermContactCalendarOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PermContactCalendarOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PermContactCalendarRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PermContactCalendarRounded.default;
	  }
	});
	Object.defineProperty(exports, "PermContactCalendarSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PermContactCalendarSharp.default;
	  }
	});
	Object.defineProperty(exports, "PermContactCalendarTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PermContactCalendarTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PermDataSetting", {
	  enumerable: true,
	  get: function get() {
	    return _PermDataSetting.default;
	  }
	});
	Object.defineProperty(exports, "PermDataSettingOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PermDataSettingOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PermDataSettingRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PermDataSettingRounded.default;
	  }
	});
	Object.defineProperty(exports, "PermDataSettingSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PermDataSettingSharp.default;
	  }
	});
	Object.defineProperty(exports, "PermDataSettingTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PermDataSettingTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PermDeviceInformation", {
	  enumerable: true,
	  get: function get() {
	    return _PermDeviceInformation.default;
	  }
	});
	Object.defineProperty(exports, "PermDeviceInformationOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PermDeviceInformationOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PermDeviceInformationRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PermDeviceInformationRounded.default;
	  }
	});
	Object.defineProperty(exports, "PermDeviceInformationSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PermDeviceInformationSharp.default;
	  }
	});
	Object.defineProperty(exports, "PermDeviceInformationTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PermDeviceInformationTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PermIdentity", {
	  enumerable: true,
	  get: function get() {
	    return _PermIdentity.default;
	  }
	});
	Object.defineProperty(exports, "PermIdentityOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PermIdentityOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PermIdentityRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PermIdentityRounded.default;
	  }
	});
	Object.defineProperty(exports, "PermIdentitySharp", {
	  enumerable: true,
	  get: function get() {
	    return _PermIdentitySharp.default;
	  }
	});
	Object.defineProperty(exports, "PermIdentityTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PermIdentityTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PermMedia", {
	  enumerable: true,
	  get: function get() {
	    return _PermMedia.default;
	  }
	});
	Object.defineProperty(exports, "PermMediaOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PermMediaOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PermMediaRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PermMediaRounded.default;
	  }
	});
	Object.defineProperty(exports, "PermMediaSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PermMediaSharp.default;
	  }
	});
	Object.defineProperty(exports, "PermMediaTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PermMediaTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PermPhoneMsg", {
	  enumerable: true,
	  get: function get() {
	    return _PermPhoneMsg.default;
	  }
	});
	Object.defineProperty(exports, "PermPhoneMsgOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PermPhoneMsgOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PermPhoneMsgRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PermPhoneMsgRounded.default;
	  }
	});
	Object.defineProperty(exports, "PermPhoneMsgSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PermPhoneMsgSharp.default;
	  }
	});
	Object.defineProperty(exports, "PermPhoneMsgTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PermPhoneMsgTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PermScanWifi", {
	  enumerable: true,
	  get: function get() {
	    return _PermScanWifi.default;
	  }
	});
	Object.defineProperty(exports, "PermScanWifiOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PermScanWifiOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PermScanWifiRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PermScanWifiRounded.default;
	  }
	});
	Object.defineProperty(exports, "PermScanWifiSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PermScanWifiSharp.default;
	  }
	});
	Object.defineProperty(exports, "PermScanWifiTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PermScanWifiTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Person", {
	  enumerable: true,
	  get: function get() {
	    return _Person.default;
	  }
	});
	Object.defineProperty(exports, "PersonAdd", {
	  enumerable: true,
	  get: function get() {
	    return _PersonAdd.default;
	  }
	});
	Object.defineProperty(exports, "PersonAddDisabled", {
	  enumerable: true,
	  get: function get() {
	    return _PersonAddDisabled.default;
	  }
	});
	Object.defineProperty(exports, "PersonAddDisabledOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PersonAddDisabledOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PersonAddDisabledRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PersonAddDisabledRounded.default;
	  }
	});
	Object.defineProperty(exports, "PersonAddDisabledSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PersonAddDisabledSharp.default;
	  }
	});
	Object.defineProperty(exports, "PersonAddDisabledTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PersonAddDisabledTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PersonAddOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PersonAddOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PersonAddRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PersonAddRounded.default;
	  }
	});
	Object.defineProperty(exports, "PersonAddSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PersonAddSharp.default;
	  }
	});
	Object.defineProperty(exports, "PersonAddTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PersonAddTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PersonalVideo", {
	  enumerable: true,
	  get: function get() {
	    return _PersonalVideo.default;
	  }
	});
	Object.defineProperty(exports, "PersonalVideoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PersonalVideoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PersonalVideoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PersonalVideoRounded.default;
	  }
	});
	Object.defineProperty(exports, "PersonalVideoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PersonalVideoSharp.default;
	  }
	});
	Object.defineProperty(exports, "PersonalVideoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PersonalVideoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PersonOutline", {
	  enumerable: true,
	  get: function get() {
	    return _PersonOutline.default;
	  }
	});
	Object.defineProperty(exports, "PersonOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PersonOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PersonOutlineOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PersonOutlineOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PersonOutlineRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PersonOutlineRounded.default;
	  }
	});
	Object.defineProperty(exports, "PersonOutlineSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PersonOutlineSharp.default;
	  }
	});
	Object.defineProperty(exports, "PersonOutlineTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PersonOutlineTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PersonPin", {
	  enumerable: true,
	  get: function get() {
	    return _PersonPin.default;
	  }
	});
	Object.defineProperty(exports, "PersonPinCircle", {
	  enumerable: true,
	  get: function get() {
	    return _PersonPinCircle.default;
	  }
	});
	Object.defineProperty(exports, "PersonPinCircleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PersonPinCircleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PersonPinCircleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PersonPinCircleRounded.default;
	  }
	});
	Object.defineProperty(exports, "PersonPinCircleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PersonPinCircleSharp.default;
	  }
	});
	Object.defineProperty(exports, "PersonPinCircleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PersonPinCircleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PersonPinOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PersonPinOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PersonPinRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PersonPinRounded.default;
	  }
	});
	Object.defineProperty(exports, "PersonPinSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PersonPinSharp.default;
	  }
	});
	Object.defineProperty(exports, "PersonPinTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PersonPinTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PersonRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PersonRounded.default;
	  }
	});
	Object.defineProperty(exports, "PersonSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PersonSharp.default;
	  }
	});
	Object.defineProperty(exports, "PersonTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PersonTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Pets", {
	  enumerable: true,
	  get: function get() {
	    return _Pets.default;
	  }
	});
	Object.defineProperty(exports, "PetsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PetsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PetsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PetsRounded.default;
	  }
	});
	Object.defineProperty(exports, "PetsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PetsSharp.default;
	  }
	});
	Object.defineProperty(exports, "PetsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PetsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Phone", {
	  enumerable: true,
	  get: function get() {
	    return _Phone.default;
	  }
	});
	Object.defineProperty(exports, "PhoneAndroid", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneAndroid.default;
	  }
	});
	Object.defineProperty(exports, "PhoneAndroidOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneAndroidOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhoneAndroidRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneAndroidRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhoneAndroidSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneAndroidSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhoneAndroidTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneAndroidTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhoneBluetoothSpeaker", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneBluetoothSpeaker.default;
	  }
	});
	Object.defineProperty(exports, "PhoneBluetoothSpeakerOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneBluetoothSpeakerOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhoneBluetoothSpeakerRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneBluetoothSpeakerRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhoneBluetoothSpeakerSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneBluetoothSpeakerSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhoneBluetoothSpeakerTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneBluetoothSpeakerTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhoneCallback", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneCallback.default;
	  }
	});
	Object.defineProperty(exports, "PhoneCallbackOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneCallbackOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhoneCallbackRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneCallbackRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhoneCallbackSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneCallbackSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhoneCallbackTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneCallbackTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhoneDisabled", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneDisabled.default;
	  }
	});
	Object.defineProperty(exports, "PhoneDisabledOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneDisabledOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhoneDisabledRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneDisabledRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhoneDisabledSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneDisabledSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhoneDisabledTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneDisabledTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhoneEnabled", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneEnabled.default;
	  }
	});
	Object.defineProperty(exports, "PhoneEnabledOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneEnabledOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhoneEnabledRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneEnabledRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhoneEnabledSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneEnabledSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhoneEnabledTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneEnabledTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhoneForwarded", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneForwarded.default;
	  }
	});
	Object.defineProperty(exports, "PhoneForwardedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneForwardedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhoneForwardedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneForwardedRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhoneForwardedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneForwardedSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhoneForwardedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneForwardedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhoneInTalk", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneInTalk.default;
	  }
	});
	Object.defineProperty(exports, "PhoneInTalkOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneInTalkOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhoneInTalkRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneInTalkRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhoneInTalkSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneInTalkSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhoneInTalkTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneInTalkTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhoneIphone", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneIphone.default;
	  }
	});
	Object.defineProperty(exports, "PhoneIphoneOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneIphoneOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhoneIphoneRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneIphoneRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhoneIphoneSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneIphoneSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhoneIphoneTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneIphoneTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Phonelink", {
	  enumerable: true,
	  get: function get() {
	    return _Phonelink.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkErase", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkErase.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkEraseOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkEraseOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkEraseRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkEraseRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkEraseSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkEraseSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkEraseTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkEraseTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkLock", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkLock.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkLockOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkLockOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkLockRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkLockRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkLockSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkLockSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkLockTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkLockTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkOff", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkOff.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkRing", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkRing.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkRingOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkRingOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkRingRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkRingRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkRingSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkRingSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkRingTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkRingTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkSetup", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkSetup.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkSetupOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkSetupOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkSetupRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkSetupRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkSetupSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkSetupSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkSetupTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkSetupTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhonelinkTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhonelinkTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhoneLocked", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneLocked.default;
	  }
	});
	Object.defineProperty(exports, "PhoneLockedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneLockedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhoneLockedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneLockedRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhoneLockedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneLockedSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhoneLockedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneLockedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhoneMissed", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneMissed.default;
	  }
	});
	Object.defineProperty(exports, "PhoneMissedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneMissedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhoneMissedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneMissedRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhoneMissedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneMissedSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhoneMissedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneMissedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhoneOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhonePaused", {
	  enumerable: true,
	  get: function get() {
	    return _PhonePaused.default;
	  }
	});
	Object.defineProperty(exports, "PhonePausedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhonePausedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhonePausedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhonePausedRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhonePausedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhonePausedSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhonePausedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhonePausedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhoneRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhoneSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhoneTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhoneTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Photo", {
	  enumerable: true,
	  get: function get() {
	    return _Photo.default;
	  }
	});
	Object.defineProperty(exports, "PhotoAlbum", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoAlbum.default;
	  }
	});
	Object.defineProperty(exports, "PhotoAlbumOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoAlbumOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhotoAlbumRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoAlbumRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhotoAlbumSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoAlbumSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhotoAlbumTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoAlbumTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhotoCamera", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoCamera.default;
	  }
	});
	Object.defineProperty(exports, "PhotoCameraOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoCameraOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhotoCameraRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoCameraRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhotoCameraSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoCameraSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhotoCameraTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoCameraTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhotoFilter", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoFilter.default;
	  }
	});
	Object.defineProperty(exports, "PhotoFilterOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoFilterOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhotoFilterRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoFilterRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhotoFilterSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoFilterSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhotoFilterTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoFilterTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhotoLibrary", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoLibrary.default;
	  }
	});
	Object.defineProperty(exports, "PhotoLibraryOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoLibraryOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhotoLibraryRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoLibraryRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhotoLibrarySharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoLibrarySharp.default;
	  }
	});
	Object.defineProperty(exports, "PhotoLibraryTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoLibraryTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhotoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhotoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhotoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhotoSizeSelectActual", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoSizeSelectActual.default;
	  }
	});
	Object.defineProperty(exports, "PhotoSizeSelectActualOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoSizeSelectActualOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhotoSizeSelectActualRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoSizeSelectActualRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhotoSizeSelectActualSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoSizeSelectActualSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhotoSizeSelectActualTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoSizeSelectActualTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhotoSizeSelectLarge", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoSizeSelectLarge.default;
	  }
	});
	Object.defineProperty(exports, "PhotoSizeSelectLargeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoSizeSelectLargeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhotoSizeSelectLargeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoSizeSelectLargeRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhotoSizeSelectLargeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoSizeSelectLargeSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhotoSizeSelectLargeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoSizeSelectLargeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhotoSizeSelectSmall", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoSizeSelectSmall.default;
	  }
	});
	Object.defineProperty(exports, "PhotoSizeSelectSmallOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoSizeSelectSmallOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PhotoSizeSelectSmallRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoSizeSelectSmallRounded.default;
	  }
	});
	Object.defineProperty(exports, "PhotoSizeSelectSmallSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoSizeSelectSmallSharp.default;
	  }
	});
	Object.defineProperty(exports, "PhotoSizeSelectSmallTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoSizeSelectSmallTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PhotoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PhotoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PictureAsPdf", {
	  enumerable: true,
	  get: function get() {
	    return _PictureAsPdf.default;
	  }
	});
	Object.defineProperty(exports, "PictureAsPdfOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PictureAsPdfOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PictureAsPdfRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PictureAsPdfRounded.default;
	  }
	});
	Object.defineProperty(exports, "PictureAsPdfSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PictureAsPdfSharp.default;
	  }
	});
	Object.defineProperty(exports, "PictureAsPdfTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PictureAsPdfTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PictureInPicture", {
	  enumerable: true,
	  get: function get() {
	    return _PictureInPicture.default;
	  }
	});
	Object.defineProperty(exports, "PictureInPictureAlt", {
	  enumerable: true,
	  get: function get() {
	    return _PictureInPictureAlt.default;
	  }
	});
	Object.defineProperty(exports, "PictureInPictureAltOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PictureInPictureAltOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PictureInPictureAltRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PictureInPictureAltRounded.default;
	  }
	});
	Object.defineProperty(exports, "PictureInPictureAltSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PictureInPictureAltSharp.default;
	  }
	});
	Object.defineProperty(exports, "PictureInPictureAltTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PictureInPictureAltTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PictureInPictureOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PictureInPictureOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PictureInPictureRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PictureInPictureRounded.default;
	  }
	});
	Object.defineProperty(exports, "PictureInPictureSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PictureInPictureSharp.default;
	  }
	});
	Object.defineProperty(exports, "PictureInPictureTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PictureInPictureTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PieChart", {
	  enumerable: true,
	  get: function get() {
	    return _PieChart.default;
	  }
	});
	Object.defineProperty(exports, "PieChartOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PieChartOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PieChartRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PieChartRounded.default;
	  }
	});
	Object.defineProperty(exports, "PieChartSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PieChartSharp.default;
	  }
	});
	Object.defineProperty(exports, "PieChartTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PieChartTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PinDrop", {
	  enumerable: true,
	  get: function get() {
	    return _PinDrop.default;
	  }
	});
	Object.defineProperty(exports, "PinDropOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PinDropOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PinDropRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PinDropRounded.default;
	  }
	});
	Object.defineProperty(exports, "PinDropSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PinDropSharp.default;
	  }
	});
	Object.defineProperty(exports, "PinDropTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PinDropTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Pinterest", {
	  enumerable: true,
	  get: function get() {
	    return _Pinterest.default;
	  }
	});
	Object.defineProperty(exports, "Place", {
	  enumerable: true,
	  get: function get() {
	    return _Place.default;
	  }
	});
	Object.defineProperty(exports, "PlaceOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PlaceOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PlaceRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PlaceRounded.default;
	  }
	});
	Object.defineProperty(exports, "PlaceSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PlaceSharp.default;
	  }
	});
	Object.defineProperty(exports, "PlaceTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PlaceTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PlayArrow", {
	  enumerable: true,
	  get: function get() {
	    return _PlayArrow.default;
	  }
	});
	Object.defineProperty(exports, "PlayArrowOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PlayArrowOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PlayArrowRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PlayArrowRounded.default;
	  }
	});
	Object.defineProperty(exports, "PlayArrowSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PlayArrowSharp.default;
	  }
	});
	Object.defineProperty(exports, "PlayArrowTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PlayArrowTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PlayCircleFilled", {
	  enumerable: true,
	  get: function get() {
	    return _PlayCircleFilled.default;
	  }
	});
	Object.defineProperty(exports, "PlayCircleFilledOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PlayCircleFilledOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PlayCircleFilledRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PlayCircleFilledRounded.default;
	  }
	});
	Object.defineProperty(exports, "PlayCircleFilledSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PlayCircleFilledSharp.default;
	  }
	});
	Object.defineProperty(exports, "PlayCircleFilledTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PlayCircleFilledTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PlayCircleFilledWhite", {
	  enumerable: true,
	  get: function get() {
	    return _PlayCircleFilledWhite.default;
	  }
	});
	Object.defineProperty(exports, "PlayCircleFilledWhiteOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PlayCircleFilledWhiteOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PlayCircleFilledWhiteRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PlayCircleFilledWhiteRounded.default;
	  }
	});
	Object.defineProperty(exports, "PlayCircleFilledWhiteSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PlayCircleFilledWhiteSharp.default;
	  }
	});
	Object.defineProperty(exports, "PlayCircleFilledWhiteTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PlayCircleFilledWhiteTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PlayCircleOutline", {
	  enumerable: true,
	  get: function get() {
	    return _PlayCircleOutline.default;
	  }
	});
	Object.defineProperty(exports, "PlayCircleOutlineOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PlayCircleOutlineOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PlayCircleOutlineRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PlayCircleOutlineRounded.default;
	  }
	});
	Object.defineProperty(exports, "PlayCircleOutlineSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PlayCircleOutlineSharp.default;
	  }
	});
	Object.defineProperty(exports, "PlayCircleOutlineTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PlayCircleOutlineTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PlayForWork", {
	  enumerable: true,
	  get: function get() {
	    return _PlayForWork.default;
	  }
	});
	Object.defineProperty(exports, "PlayForWorkOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PlayForWorkOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PlayForWorkRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PlayForWorkRounded.default;
	  }
	});
	Object.defineProperty(exports, "PlayForWorkSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PlayForWorkSharp.default;
	  }
	});
	Object.defineProperty(exports, "PlayForWorkTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PlayForWorkTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PlaylistAdd", {
	  enumerable: true,
	  get: function get() {
	    return _PlaylistAdd.default;
	  }
	});
	Object.defineProperty(exports, "PlaylistAddCheck", {
	  enumerable: true,
	  get: function get() {
	    return _PlaylistAddCheck.default;
	  }
	});
	Object.defineProperty(exports, "PlaylistAddCheckOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PlaylistAddCheckOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PlaylistAddCheckRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PlaylistAddCheckRounded.default;
	  }
	});
	Object.defineProperty(exports, "PlaylistAddCheckSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PlaylistAddCheckSharp.default;
	  }
	});
	Object.defineProperty(exports, "PlaylistAddCheckTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PlaylistAddCheckTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PlaylistAddOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PlaylistAddOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PlaylistAddRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PlaylistAddRounded.default;
	  }
	});
	Object.defineProperty(exports, "PlaylistAddSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PlaylistAddSharp.default;
	  }
	});
	Object.defineProperty(exports, "PlaylistAddTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PlaylistAddTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PlaylistPlay", {
	  enumerable: true,
	  get: function get() {
	    return _PlaylistPlay.default;
	  }
	});
	Object.defineProperty(exports, "PlaylistPlayOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PlaylistPlayOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PlaylistPlayRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PlaylistPlayRounded.default;
	  }
	});
	Object.defineProperty(exports, "PlaylistPlaySharp", {
	  enumerable: true,
	  get: function get() {
	    return _PlaylistPlaySharp.default;
	  }
	});
	Object.defineProperty(exports, "PlaylistPlayTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PlaylistPlayTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PlusOne", {
	  enumerable: true,
	  get: function get() {
	    return _PlusOne.default;
	  }
	});
	Object.defineProperty(exports, "PlusOneOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PlusOneOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PlusOneRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PlusOneRounded.default;
	  }
	});
	Object.defineProperty(exports, "PlusOneSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PlusOneSharp.default;
	  }
	});
	Object.defineProperty(exports, "PlusOneTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PlusOneTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Policy", {
	  enumerable: true,
	  get: function get() {
	    return _Policy.default;
	  }
	});
	Object.defineProperty(exports, "PolicyOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PolicyOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PolicyRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PolicyRounded.default;
	  }
	});
	Object.defineProperty(exports, "PolicySharp", {
	  enumerable: true,
	  get: function get() {
	    return _PolicySharp.default;
	  }
	});
	Object.defineProperty(exports, "PolicyTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PolicyTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Poll", {
	  enumerable: true,
	  get: function get() {
	    return _Poll.default;
	  }
	});
	Object.defineProperty(exports, "PollOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PollOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PollRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PollRounded.default;
	  }
	});
	Object.defineProperty(exports, "PollSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PollSharp.default;
	  }
	});
	Object.defineProperty(exports, "PollTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PollTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Polymer", {
	  enumerable: true,
	  get: function get() {
	    return _Polymer.default;
	  }
	});
	Object.defineProperty(exports, "PolymerOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PolymerOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PolymerRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PolymerRounded.default;
	  }
	});
	Object.defineProperty(exports, "PolymerSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PolymerSharp.default;
	  }
	});
	Object.defineProperty(exports, "PolymerTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PolymerTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Pool", {
	  enumerable: true,
	  get: function get() {
	    return _Pool.default;
	  }
	});
	Object.defineProperty(exports, "PoolOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PoolOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PoolRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PoolRounded.default;
	  }
	});
	Object.defineProperty(exports, "PoolSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PoolSharp.default;
	  }
	});
	Object.defineProperty(exports, "PoolTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PoolTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PortableWifiOff", {
	  enumerable: true,
	  get: function get() {
	    return _PortableWifiOff.default;
	  }
	});
	Object.defineProperty(exports, "PortableWifiOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PortableWifiOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PortableWifiOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PortableWifiOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "PortableWifiOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PortableWifiOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "PortableWifiOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PortableWifiOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Portrait", {
	  enumerable: true,
	  get: function get() {
	    return _Portrait.default;
	  }
	});
	Object.defineProperty(exports, "PortraitOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PortraitOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PortraitRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PortraitRounded.default;
	  }
	});
	Object.defineProperty(exports, "PortraitSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PortraitSharp.default;
	  }
	});
	Object.defineProperty(exports, "PortraitTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PortraitTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PostAdd", {
	  enumerable: true,
	  get: function get() {
	    return _PostAdd.default;
	  }
	});
	Object.defineProperty(exports, "PostAddOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PostAddOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PostAddRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PostAddRounded.default;
	  }
	});
	Object.defineProperty(exports, "PostAddSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PostAddSharp.default;
	  }
	});
	Object.defineProperty(exports, "PostAddTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PostAddTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Power", {
	  enumerable: true,
	  get: function get() {
	    return _Power.default;
	  }
	});
	Object.defineProperty(exports, "PowerInput", {
	  enumerable: true,
	  get: function get() {
	    return _PowerInput.default;
	  }
	});
	Object.defineProperty(exports, "PowerInputOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PowerInputOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PowerInputRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PowerInputRounded.default;
	  }
	});
	Object.defineProperty(exports, "PowerInputSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PowerInputSharp.default;
	  }
	});
	Object.defineProperty(exports, "PowerInputTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PowerInputTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PowerOff", {
	  enumerable: true,
	  get: function get() {
	    return _PowerOff.default;
	  }
	});
	Object.defineProperty(exports, "PowerOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PowerOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PowerOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PowerOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "PowerOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PowerOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "PowerOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PowerOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PowerOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PowerOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PowerRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PowerRounded.default;
	  }
	});
	Object.defineProperty(exports, "PowerSettingsNew", {
	  enumerable: true,
	  get: function get() {
	    return _PowerSettingsNew.default;
	  }
	});
	Object.defineProperty(exports, "PowerSettingsNewOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PowerSettingsNewOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PowerSettingsNewRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PowerSettingsNewRounded.default;
	  }
	});
	Object.defineProperty(exports, "PowerSettingsNewSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PowerSettingsNewSharp.default;
	  }
	});
	Object.defineProperty(exports, "PowerSettingsNewTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PowerSettingsNewTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PowerSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PowerSharp.default;
	  }
	});
	Object.defineProperty(exports, "PowerTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PowerTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PregnantWoman", {
	  enumerable: true,
	  get: function get() {
	    return _PregnantWoman.default;
	  }
	});
	Object.defineProperty(exports, "PregnantWomanOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PregnantWomanOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PregnantWomanRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PregnantWomanRounded.default;
	  }
	});
	Object.defineProperty(exports, "PregnantWomanSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PregnantWomanSharp.default;
	  }
	});
	Object.defineProperty(exports, "PregnantWomanTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PregnantWomanTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PresentToAll", {
	  enumerable: true,
	  get: function get() {
	    return _PresentToAll.default;
	  }
	});
	Object.defineProperty(exports, "PresentToAllOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PresentToAllOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PresentToAllRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PresentToAllRounded.default;
	  }
	});
	Object.defineProperty(exports, "PresentToAllSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PresentToAllSharp.default;
	  }
	});
	Object.defineProperty(exports, "PresentToAllTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PresentToAllTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Print", {
	  enumerable: true,
	  get: function get() {
	    return _Print.default;
	  }
	});
	Object.defineProperty(exports, "PrintDisabled", {
	  enumerable: true,
	  get: function get() {
	    return _PrintDisabled.default;
	  }
	});
	Object.defineProperty(exports, "PrintDisabledOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PrintDisabledOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PrintDisabledRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PrintDisabledRounded.default;
	  }
	});
	Object.defineProperty(exports, "PrintDisabledSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PrintDisabledSharp.default;
	  }
	});
	Object.defineProperty(exports, "PrintDisabledTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PrintDisabledTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PrintOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PrintOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PrintRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PrintRounded.default;
	  }
	});
	Object.defineProperty(exports, "PrintSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PrintSharp.default;
	  }
	});
	Object.defineProperty(exports, "PrintTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PrintTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "PriorityHigh", {
	  enumerable: true,
	  get: function get() {
	    return _PriorityHigh.default;
	  }
	});
	Object.defineProperty(exports, "PriorityHighOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PriorityHighOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PriorityHighRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PriorityHighRounded.default;
	  }
	});
	Object.defineProperty(exports, "PriorityHighSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PriorityHighSharp.default;
	  }
	});
	Object.defineProperty(exports, "PriorityHighTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PriorityHighTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Public", {
	  enumerable: true,
	  get: function get() {
	    return _Public.default;
	  }
	});
	Object.defineProperty(exports, "PublicOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PublicOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PublicRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PublicRounded.default;
	  }
	});
	Object.defineProperty(exports, "PublicSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PublicSharp.default;
	  }
	});
	Object.defineProperty(exports, "PublicTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PublicTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Publish", {
	  enumerable: true,
	  get: function get() {
	    return _Publish.default;
	  }
	});
	Object.defineProperty(exports, "PublishOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _PublishOutlined.default;
	  }
	});
	Object.defineProperty(exports, "PublishRounded", {
	  enumerable: true,
	  get: function get() {
	    return _PublishRounded.default;
	  }
	});
	Object.defineProperty(exports, "PublishSharp", {
	  enumerable: true,
	  get: function get() {
	    return _PublishSharp.default;
	  }
	});
	Object.defineProperty(exports, "PublishTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _PublishTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "QueryBuilder", {
	  enumerable: true,
	  get: function get() {
	    return _QueryBuilder.default;
	  }
	});
	Object.defineProperty(exports, "QueryBuilderOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _QueryBuilderOutlined.default;
	  }
	});
	Object.defineProperty(exports, "QueryBuilderRounded", {
	  enumerable: true,
	  get: function get() {
	    return _QueryBuilderRounded.default;
	  }
	});
	Object.defineProperty(exports, "QueryBuilderSharp", {
	  enumerable: true,
	  get: function get() {
	    return _QueryBuilderSharp.default;
	  }
	});
	Object.defineProperty(exports, "QueryBuilderTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _QueryBuilderTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "QuestionAnswer", {
	  enumerable: true,
	  get: function get() {
	    return _QuestionAnswer.default;
	  }
	});
	Object.defineProperty(exports, "QuestionAnswerOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _QuestionAnswerOutlined.default;
	  }
	});
	Object.defineProperty(exports, "QuestionAnswerRounded", {
	  enumerable: true,
	  get: function get() {
	    return _QuestionAnswerRounded.default;
	  }
	});
	Object.defineProperty(exports, "QuestionAnswerSharp", {
	  enumerable: true,
	  get: function get() {
	    return _QuestionAnswerSharp.default;
	  }
	});
	Object.defineProperty(exports, "QuestionAnswerTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _QuestionAnswerTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Queue", {
	  enumerable: true,
	  get: function get() {
	    return _Queue.default;
	  }
	});
	Object.defineProperty(exports, "QueueMusic", {
	  enumerable: true,
	  get: function get() {
	    return _QueueMusic.default;
	  }
	});
	Object.defineProperty(exports, "QueueMusicOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _QueueMusicOutlined.default;
	  }
	});
	Object.defineProperty(exports, "QueueMusicRounded", {
	  enumerable: true,
	  get: function get() {
	    return _QueueMusicRounded.default;
	  }
	});
	Object.defineProperty(exports, "QueueMusicSharp", {
	  enumerable: true,
	  get: function get() {
	    return _QueueMusicSharp.default;
	  }
	});
	Object.defineProperty(exports, "QueueMusicTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _QueueMusicTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "QueueOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _QueueOutlined.default;
	  }
	});
	Object.defineProperty(exports, "QueuePlayNext", {
	  enumerable: true,
	  get: function get() {
	    return _QueuePlayNext.default;
	  }
	});
	Object.defineProperty(exports, "QueuePlayNextOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _QueuePlayNextOutlined.default;
	  }
	});
	Object.defineProperty(exports, "QueuePlayNextRounded", {
	  enumerable: true,
	  get: function get() {
	    return _QueuePlayNextRounded.default;
	  }
	});
	Object.defineProperty(exports, "QueuePlayNextSharp", {
	  enumerable: true,
	  get: function get() {
	    return _QueuePlayNextSharp.default;
	  }
	});
	Object.defineProperty(exports, "QueuePlayNextTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _QueuePlayNextTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "QueueRounded", {
	  enumerable: true,
	  get: function get() {
	    return _QueueRounded.default;
	  }
	});
	Object.defineProperty(exports, "QueueSharp", {
	  enumerable: true,
	  get: function get() {
	    return _QueueSharp.default;
	  }
	});
	Object.defineProperty(exports, "QueueTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _QueueTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Radio", {
	  enumerable: true,
	  get: function get() {
	    return _Radio.default;
	  }
	});
	Object.defineProperty(exports, "RadioButtonChecked", {
	  enumerable: true,
	  get: function get() {
	    return _RadioButtonChecked.default;
	  }
	});
	Object.defineProperty(exports, "RadioButtonCheckedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RadioButtonCheckedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RadioButtonCheckedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RadioButtonCheckedRounded.default;
	  }
	});
	Object.defineProperty(exports, "RadioButtonCheckedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RadioButtonCheckedSharp.default;
	  }
	});
	Object.defineProperty(exports, "RadioButtonCheckedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RadioButtonCheckedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RadioButtonUnchecked", {
	  enumerable: true,
	  get: function get() {
	    return _RadioButtonUnchecked.default;
	  }
	});
	Object.defineProperty(exports, "RadioButtonUncheckedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RadioButtonUncheckedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RadioButtonUncheckedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RadioButtonUncheckedRounded.default;
	  }
	});
	Object.defineProperty(exports, "RadioButtonUncheckedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RadioButtonUncheckedSharp.default;
	  }
	});
	Object.defineProperty(exports, "RadioButtonUncheckedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RadioButtonUncheckedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RadioOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RadioOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RadioRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RadioRounded.default;
	  }
	});
	Object.defineProperty(exports, "RadioSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RadioSharp.default;
	  }
	});
	Object.defineProperty(exports, "RadioTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RadioTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RateReview", {
	  enumerable: true,
	  get: function get() {
	    return _RateReview.default;
	  }
	});
	Object.defineProperty(exports, "RateReviewOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RateReviewOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RateReviewRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RateReviewRounded.default;
	  }
	});
	Object.defineProperty(exports, "RateReviewSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RateReviewSharp.default;
	  }
	});
	Object.defineProperty(exports, "RateReviewTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RateReviewTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Receipt", {
	  enumerable: true,
	  get: function get() {
	    return _Receipt.default;
	  }
	});
	Object.defineProperty(exports, "ReceiptOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ReceiptOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ReceiptRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ReceiptRounded.default;
	  }
	});
	Object.defineProperty(exports, "ReceiptSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ReceiptSharp.default;
	  }
	});
	Object.defineProperty(exports, "ReceiptTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ReceiptTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RecentActors", {
	  enumerable: true,
	  get: function get() {
	    return _RecentActors.default;
	  }
	});
	Object.defineProperty(exports, "RecentActorsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RecentActorsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RecentActorsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RecentActorsRounded.default;
	  }
	});
	Object.defineProperty(exports, "RecentActorsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RecentActorsSharp.default;
	  }
	});
	Object.defineProperty(exports, "RecentActorsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RecentActorsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RecordVoiceOver", {
	  enumerable: true,
	  get: function get() {
	    return _RecordVoiceOver.default;
	  }
	});
	Object.defineProperty(exports, "RecordVoiceOverOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RecordVoiceOverOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RecordVoiceOverRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RecordVoiceOverRounded.default;
	  }
	});
	Object.defineProperty(exports, "RecordVoiceOverSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RecordVoiceOverSharp.default;
	  }
	});
	Object.defineProperty(exports, "RecordVoiceOverTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RecordVoiceOverTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Reddit", {
	  enumerable: true,
	  get: function get() {
	    return _Reddit.default;
	  }
	});
	Object.defineProperty(exports, "Redeem", {
	  enumerable: true,
	  get: function get() {
	    return _Redeem.default;
	  }
	});
	Object.defineProperty(exports, "RedeemOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RedeemOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RedeemRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RedeemRounded.default;
	  }
	});
	Object.defineProperty(exports, "RedeemSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RedeemSharp.default;
	  }
	});
	Object.defineProperty(exports, "RedeemTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RedeemTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Redo", {
	  enumerable: true,
	  get: function get() {
	    return _Redo.default;
	  }
	});
	Object.defineProperty(exports, "RedoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RedoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RedoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RedoRounded.default;
	  }
	});
	Object.defineProperty(exports, "RedoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RedoSharp.default;
	  }
	});
	Object.defineProperty(exports, "RedoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RedoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Refresh", {
	  enumerable: true,
	  get: function get() {
	    return _Refresh.default;
	  }
	});
	Object.defineProperty(exports, "RefreshOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RefreshOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RefreshRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RefreshRounded.default;
	  }
	});
	Object.defineProperty(exports, "RefreshSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RefreshSharp.default;
	  }
	});
	Object.defineProperty(exports, "RefreshTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RefreshTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Remove", {
	  enumerable: true,
	  get: function get() {
	    return _Remove.default;
	  }
	});
	Object.defineProperty(exports, "RemoveCircle", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveCircle.default;
	  }
	});
	Object.defineProperty(exports, "RemoveCircleOutline", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveCircleOutline.default;
	  }
	});
	Object.defineProperty(exports, "RemoveCircleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveCircleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RemoveCircleOutlineOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveCircleOutlineOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RemoveCircleOutlineRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveCircleOutlineRounded.default;
	  }
	});
	Object.defineProperty(exports, "RemoveCircleOutlineSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveCircleOutlineSharp.default;
	  }
	});
	Object.defineProperty(exports, "RemoveCircleOutlineTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveCircleOutlineTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RemoveCircleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveCircleRounded.default;
	  }
	});
	Object.defineProperty(exports, "RemoveCircleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveCircleSharp.default;
	  }
	});
	Object.defineProperty(exports, "RemoveCircleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveCircleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RemoveFromQueue", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveFromQueue.default;
	  }
	});
	Object.defineProperty(exports, "RemoveFromQueueOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveFromQueueOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RemoveFromQueueRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveFromQueueRounded.default;
	  }
	});
	Object.defineProperty(exports, "RemoveFromQueueSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveFromQueueSharp.default;
	  }
	});
	Object.defineProperty(exports, "RemoveFromQueueTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveFromQueueTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RemoveOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RemoveRedEye", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveRedEye.default;
	  }
	});
	Object.defineProperty(exports, "RemoveRedEyeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveRedEyeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RemoveRedEyeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveRedEyeRounded.default;
	  }
	});
	Object.defineProperty(exports, "RemoveRedEyeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveRedEyeSharp.default;
	  }
	});
	Object.defineProperty(exports, "RemoveRedEyeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveRedEyeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RemoveRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveRounded.default;
	  }
	});
	Object.defineProperty(exports, "RemoveSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveSharp.default;
	  }
	});
	Object.defineProperty(exports, "RemoveShoppingCart", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveShoppingCart.default;
	  }
	});
	Object.defineProperty(exports, "RemoveShoppingCartOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveShoppingCartOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RemoveShoppingCartRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveShoppingCartRounded.default;
	  }
	});
	Object.defineProperty(exports, "RemoveShoppingCartSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveShoppingCartSharp.default;
	  }
	});
	Object.defineProperty(exports, "RemoveShoppingCartTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveShoppingCartTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RemoveTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RemoveTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Reorder", {
	  enumerable: true,
	  get: function get() {
	    return _Reorder.default;
	  }
	});
	Object.defineProperty(exports, "ReorderOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ReorderOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ReorderRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ReorderRounded.default;
	  }
	});
	Object.defineProperty(exports, "ReorderSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ReorderSharp.default;
	  }
	});
	Object.defineProperty(exports, "ReorderTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ReorderTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Repeat", {
	  enumerable: true,
	  get: function get() {
	    return _Repeat.default;
	  }
	});
	Object.defineProperty(exports, "RepeatOne", {
	  enumerable: true,
	  get: function get() {
	    return _RepeatOne.default;
	  }
	});
	Object.defineProperty(exports, "RepeatOneOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RepeatOneOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RepeatOneRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RepeatOneRounded.default;
	  }
	});
	Object.defineProperty(exports, "RepeatOneSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RepeatOneSharp.default;
	  }
	});
	Object.defineProperty(exports, "RepeatOneTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RepeatOneTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RepeatOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RepeatOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RepeatRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RepeatRounded.default;
	  }
	});
	Object.defineProperty(exports, "RepeatSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RepeatSharp.default;
	  }
	});
	Object.defineProperty(exports, "RepeatTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RepeatTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Replay", {
	  enumerable: true,
	  get: function get() {
	    return _Replay.default;
	  }
	});
	Object.defineProperty(exports, "Replay10", {
	  enumerable: true,
	  get: function get() {
	    return _Replay2.default;
	  }
	});
	Object.defineProperty(exports, "Replay10Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Replay10Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Replay10Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Replay10Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Replay10Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Replay10Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Replay10TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Replay10TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Replay30", {
	  enumerable: true,
	  get: function get() {
	    return _Replay3.default;
	  }
	});
	Object.defineProperty(exports, "Replay30Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Replay30Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Replay30Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Replay30Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Replay30Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Replay30Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Replay30TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Replay30TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Replay5", {
	  enumerable: true,
	  get: function get() {
	    return _Replay4.default;
	  }
	});
	Object.defineProperty(exports, "Replay5Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Replay5Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Replay5Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Replay5Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Replay5Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Replay5Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Replay5TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Replay5TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ReplayOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ReplayOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ReplayRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ReplayRounded.default;
	  }
	});
	Object.defineProperty(exports, "ReplaySharp", {
	  enumerable: true,
	  get: function get() {
	    return _ReplaySharp.default;
	  }
	});
	Object.defineProperty(exports, "ReplayTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ReplayTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Reply", {
	  enumerable: true,
	  get: function get() {
	    return _Reply.default;
	  }
	});
	Object.defineProperty(exports, "ReplyAll", {
	  enumerable: true,
	  get: function get() {
	    return _ReplyAll.default;
	  }
	});
	Object.defineProperty(exports, "ReplyAllOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ReplyAllOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ReplyAllRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ReplyAllRounded.default;
	  }
	});
	Object.defineProperty(exports, "ReplyAllSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ReplyAllSharp.default;
	  }
	});
	Object.defineProperty(exports, "ReplyAllTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ReplyAllTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ReplyOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ReplyOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ReplyRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ReplyRounded.default;
	  }
	});
	Object.defineProperty(exports, "ReplySharp", {
	  enumerable: true,
	  get: function get() {
	    return _ReplySharp.default;
	  }
	});
	Object.defineProperty(exports, "ReplyTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ReplyTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Report", {
	  enumerable: true,
	  get: function get() {
	    return _Report.default;
	  }
	});
	Object.defineProperty(exports, "ReportOff", {
	  enumerable: true,
	  get: function get() {
	    return _ReportOff.default;
	  }
	});
	Object.defineProperty(exports, "ReportOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ReportOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ReportOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ReportOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "ReportOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ReportOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "ReportOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ReportOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ReportOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ReportOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ReportProblem", {
	  enumerable: true,
	  get: function get() {
	    return _ReportProblem.default;
	  }
	});
	Object.defineProperty(exports, "ReportProblemOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ReportProblemOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ReportProblemRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ReportProblemRounded.default;
	  }
	});
	Object.defineProperty(exports, "ReportProblemSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ReportProblemSharp.default;
	  }
	});
	Object.defineProperty(exports, "ReportProblemTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ReportProblemTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ReportRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ReportRounded.default;
	  }
	});
	Object.defineProperty(exports, "ReportSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ReportSharp.default;
	  }
	});
	Object.defineProperty(exports, "ReportTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ReportTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Restaurant", {
	  enumerable: true,
	  get: function get() {
	    return _Restaurant.default;
	  }
	});
	Object.defineProperty(exports, "RestaurantMenu", {
	  enumerable: true,
	  get: function get() {
	    return _RestaurantMenu.default;
	  }
	});
	Object.defineProperty(exports, "RestaurantMenuOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RestaurantMenuOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RestaurantMenuRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RestaurantMenuRounded.default;
	  }
	});
	Object.defineProperty(exports, "RestaurantMenuSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RestaurantMenuSharp.default;
	  }
	});
	Object.defineProperty(exports, "RestaurantMenuTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RestaurantMenuTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RestaurantOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RestaurantOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RestaurantRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RestaurantRounded.default;
	  }
	});
	Object.defineProperty(exports, "RestaurantSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RestaurantSharp.default;
	  }
	});
	Object.defineProperty(exports, "RestaurantTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RestaurantTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Restore", {
	  enumerable: true,
	  get: function get() {
	    return _Restore.default;
	  }
	});
	Object.defineProperty(exports, "RestoreFromTrash", {
	  enumerable: true,
	  get: function get() {
	    return _RestoreFromTrash.default;
	  }
	});
	Object.defineProperty(exports, "RestoreFromTrashOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RestoreFromTrashOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RestoreFromTrashRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RestoreFromTrashRounded.default;
	  }
	});
	Object.defineProperty(exports, "RestoreFromTrashSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RestoreFromTrashSharp.default;
	  }
	});
	Object.defineProperty(exports, "RestoreFromTrashTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RestoreFromTrashTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RestoreOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RestoreOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RestorePage", {
	  enumerable: true,
	  get: function get() {
	    return _RestorePage.default;
	  }
	});
	Object.defineProperty(exports, "RestorePageOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RestorePageOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RestorePageRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RestorePageRounded.default;
	  }
	});
	Object.defineProperty(exports, "RestorePageSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RestorePageSharp.default;
	  }
	});
	Object.defineProperty(exports, "RestorePageTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RestorePageTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RestoreRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RestoreRounded.default;
	  }
	});
	Object.defineProperty(exports, "RestoreSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RestoreSharp.default;
	  }
	});
	Object.defineProperty(exports, "RestoreTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RestoreTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RingVolume", {
	  enumerable: true,
	  get: function get() {
	    return _RingVolume.default;
	  }
	});
	Object.defineProperty(exports, "RingVolumeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RingVolumeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RingVolumeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RingVolumeRounded.default;
	  }
	});
	Object.defineProperty(exports, "RingVolumeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RingVolumeSharp.default;
	  }
	});
	Object.defineProperty(exports, "RingVolumeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RingVolumeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Room", {
	  enumerable: true,
	  get: function get() {
	    return _Room.default;
	  }
	});
	Object.defineProperty(exports, "RoomOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RoomOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RoomRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RoomRounded.default;
	  }
	});
	Object.defineProperty(exports, "RoomService", {
	  enumerable: true,
	  get: function get() {
	    return _RoomService.default;
	  }
	});
	Object.defineProperty(exports, "RoomServiceOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RoomServiceOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RoomServiceRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RoomServiceRounded.default;
	  }
	});
	Object.defineProperty(exports, "RoomServiceSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RoomServiceSharp.default;
	  }
	});
	Object.defineProperty(exports, "RoomServiceTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RoomServiceTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RoomSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RoomSharp.default;
	  }
	});
	Object.defineProperty(exports, "RoomTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RoomTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Rotate90DegreesCcw", {
	  enumerable: true,
	  get: function get() {
	    return _Rotate90DegreesCcw.default;
	  }
	});
	Object.defineProperty(exports, "Rotate90DegreesCcwOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _Rotate90DegreesCcwOutlined.default;
	  }
	});
	Object.defineProperty(exports, "Rotate90DegreesCcwRounded", {
	  enumerable: true,
	  get: function get() {
	    return _Rotate90DegreesCcwRounded.default;
	  }
	});
	Object.defineProperty(exports, "Rotate90DegreesCcwSharp", {
	  enumerable: true,
	  get: function get() {
	    return _Rotate90DegreesCcwSharp.default;
	  }
	});
	Object.defineProperty(exports, "Rotate90DegreesCcwTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Rotate90DegreesCcwTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RotateLeft", {
	  enumerable: true,
	  get: function get() {
	    return _RotateLeft.default;
	  }
	});
	Object.defineProperty(exports, "RotateLeftOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RotateLeftOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RotateLeftRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RotateLeftRounded.default;
	  }
	});
	Object.defineProperty(exports, "RotateLeftSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RotateLeftSharp.default;
	  }
	});
	Object.defineProperty(exports, "RotateLeftTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RotateLeftTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RotateRight", {
	  enumerable: true,
	  get: function get() {
	    return _RotateRight.default;
	  }
	});
	Object.defineProperty(exports, "RotateRightOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RotateRightOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RotateRightRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RotateRightRounded.default;
	  }
	});
	Object.defineProperty(exports, "RotateRightSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RotateRightSharp.default;
	  }
	});
	Object.defineProperty(exports, "RotateRightTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RotateRightTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RoundedCorner", {
	  enumerable: true,
	  get: function get() {
	    return _RoundedCorner.default;
	  }
	});
	Object.defineProperty(exports, "RoundedCornerOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RoundedCornerOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RoundedCornerRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RoundedCornerRounded.default;
	  }
	});
	Object.defineProperty(exports, "RoundedCornerSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RoundedCornerSharp.default;
	  }
	});
	Object.defineProperty(exports, "RoundedCornerTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RoundedCornerTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Router", {
	  enumerable: true,
	  get: function get() {
	    return _Router.default;
	  }
	});
	Object.defineProperty(exports, "RouterOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RouterOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RouterRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RouterRounded.default;
	  }
	});
	Object.defineProperty(exports, "RouterSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RouterSharp.default;
	  }
	});
	Object.defineProperty(exports, "RouterTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RouterTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Rowing", {
	  enumerable: true,
	  get: function get() {
	    return _Rowing.default;
	  }
	});
	Object.defineProperty(exports, "RowingOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RowingOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RowingRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RowingRounded.default;
	  }
	});
	Object.defineProperty(exports, "RowingSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RowingSharp.default;
	  }
	});
	Object.defineProperty(exports, "RowingTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RowingTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RssFeed", {
	  enumerable: true,
	  get: function get() {
	    return _RssFeed.default;
	  }
	});
	Object.defineProperty(exports, "RssFeedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RssFeedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RssFeedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RssFeedRounded.default;
	  }
	});
	Object.defineProperty(exports, "RssFeedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RssFeedSharp.default;
	  }
	});
	Object.defineProperty(exports, "RssFeedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RssFeedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "RvHookup", {
	  enumerable: true,
	  get: function get() {
	    return _RvHookup.default;
	  }
	});
	Object.defineProperty(exports, "RvHookupOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _RvHookupOutlined.default;
	  }
	});
	Object.defineProperty(exports, "RvHookupRounded", {
	  enumerable: true,
	  get: function get() {
	    return _RvHookupRounded.default;
	  }
	});
	Object.defineProperty(exports, "RvHookupSharp", {
	  enumerable: true,
	  get: function get() {
	    return _RvHookupSharp.default;
	  }
	});
	Object.defineProperty(exports, "RvHookupTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _RvHookupTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Satellite", {
	  enumerable: true,
	  get: function get() {
	    return _Satellite.default;
	  }
	});
	Object.defineProperty(exports, "SatelliteOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SatelliteOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SatelliteRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SatelliteRounded.default;
	  }
	});
	Object.defineProperty(exports, "SatelliteSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SatelliteSharp.default;
	  }
	});
	Object.defineProperty(exports, "SatelliteTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SatelliteTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Save", {
	  enumerable: true,
	  get: function get() {
	    return _Save.default;
	  }
	});
	Object.defineProperty(exports, "SaveAlt", {
	  enumerable: true,
	  get: function get() {
	    return _SaveAlt.default;
	  }
	});
	Object.defineProperty(exports, "SaveAltOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SaveAltOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SaveAltRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SaveAltRounded.default;
	  }
	});
	Object.defineProperty(exports, "SaveAltSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SaveAltSharp.default;
	  }
	});
	Object.defineProperty(exports, "SaveAltTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SaveAltTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SaveOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SaveOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SaveRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SaveRounded.default;
	  }
	});
	Object.defineProperty(exports, "SaveSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SaveSharp.default;
	  }
	});
	Object.defineProperty(exports, "SaveTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SaveTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Scanner", {
	  enumerable: true,
	  get: function get() {
	    return _Scanner.default;
	  }
	});
	Object.defineProperty(exports, "ScannerOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ScannerOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ScannerRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ScannerRounded.default;
	  }
	});
	Object.defineProperty(exports, "ScannerSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ScannerSharp.default;
	  }
	});
	Object.defineProperty(exports, "ScannerTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ScannerTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ScatterPlot", {
	  enumerable: true,
	  get: function get() {
	    return _ScatterPlot.default;
	  }
	});
	Object.defineProperty(exports, "ScatterPlotOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ScatterPlotOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ScatterPlotRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ScatterPlotRounded.default;
	  }
	});
	Object.defineProperty(exports, "ScatterPlotSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ScatterPlotSharp.default;
	  }
	});
	Object.defineProperty(exports, "ScatterPlotTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ScatterPlotTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Schedule", {
	  enumerable: true,
	  get: function get() {
	    return _Schedule.default;
	  }
	});
	Object.defineProperty(exports, "ScheduleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ScheduleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ScheduleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ScheduleRounded.default;
	  }
	});
	Object.defineProperty(exports, "ScheduleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ScheduleSharp.default;
	  }
	});
	Object.defineProperty(exports, "ScheduleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ScheduleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "School", {
	  enumerable: true,
	  get: function get() {
	    return _School.default;
	  }
	});
	Object.defineProperty(exports, "SchoolOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SchoolOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SchoolRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SchoolRounded.default;
	  }
	});
	Object.defineProperty(exports, "SchoolSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SchoolSharp.default;
	  }
	});
	Object.defineProperty(exports, "SchoolTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SchoolTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Score", {
	  enumerable: true,
	  get: function get() {
	    return _Score.default;
	  }
	});
	Object.defineProperty(exports, "ScoreOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ScoreOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ScoreRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ScoreRounded.default;
	  }
	});
	Object.defineProperty(exports, "ScoreSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ScoreSharp.default;
	  }
	});
	Object.defineProperty(exports, "ScoreTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ScoreTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ScreenLockLandscape", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenLockLandscape.default;
	  }
	});
	Object.defineProperty(exports, "ScreenLockLandscapeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenLockLandscapeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ScreenLockLandscapeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenLockLandscapeRounded.default;
	  }
	});
	Object.defineProperty(exports, "ScreenLockLandscapeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenLockLandscapeSharp.default;
	  }
	});
	Object.defineProperty(exports, "ScreenLockLandscapeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenLockLandscapeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ScreenLockPortrait", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenLockPortrait.default;
	  }
	});
	Object.defineProperty(exports, "ScreenLockPortraitOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenLockPortraitOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ScreenLockPortraitRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenLockPortraitRounded.default;
	  }
	});
	Object.defineProperty(exports, "ScreenLockPortraitSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenLockPortraitSharp.default;
	  }
	});
	Object.defineProperty(exports, "ScreenLockPortraitTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenLockPortraitTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ScreenLockRotation", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenLockRotation.default;
	  }
	});
	Object.defineProperty(exports, "ScreenLockRotationOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenLockRotationOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ScreenLockRotationRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenLockRotationRounded.default;
	  }
	});
	Object.defineProperty(exports, "ScreenLockRotationSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenLockRotationSharp.default;
	  }
	});
	Object.defineProperty(exports, "ScreenLockRotationTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenLockRotationTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ScreenRotation", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenRotation.default;
	  }
	});
	Object.defineProperty(exports, "ScreenRotationOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenRotationOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ScreenRotationRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenRotationRounded.default;
	  }
	});
	Object.defineProperty(exports, "ScreenRotationSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenRotationSharp.default;
	  }
	});
	Object.defineProperty(exports, "ScreenRotationTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenRotationTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ScreenShare", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenShare.default;
	  }
	});
	Object.defineProperty(exports, "ScreenShareOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenShareOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ScreenShareRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenShareRounded.default;
	  }
	});
	Object.defineProperty(exports, "ScreenShareSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenShareSharp.default;
	  }
	});
	Object.defineProperty(exports, "ScreenShareTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ScreenShareTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SdCard", {
	  enumerable: true,
	  get: function get() {
	    return _SdCard.default;
	  }
	});
	Object.defineProperty(exports, "SdCardOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SdCardOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SdCardRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SdCardRounded.default;
	  }
	});
	Object.defineProperty(exports, "SdCardSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SdCardSharp.default;
	  }
	});
	Object.defineProperty(exports, "SdCardTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SdCardTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SdStorage", {
	  enumerable: true,
	  get: function get() {
	    return _SdStorage.default;
	  }
	});
	Object.defineProperty(exports, "SdStorageOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SdStorageOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SdStorageRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SdStorageRounded.default;
	  }
	});
	Object.defineProperty(exports, "SdStorageSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SdStorageSharp.default;
	  }
	});
	Object.defineProperty(exports, "SdStorageTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SdStorageTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Search", {
	  enumerable: true,
	  get: function get() {
	    return _Search.default;
	  }
	});
	Object.defineProperty(exports, "SearchOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SearchOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SearchRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SearchRounded.default;
	  }
	});
	Object.defineProperty(exports, "SearchSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SearchSharp.default;
	  }
	});
	Object.defineProperty(exports, "SearchTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SearchTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Security", {
	  enumerable: true,
	  get: function get() {
	    return _Security.default;
	  }
	});
	Object.defineProperty(exports, "SecurityOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SecurityOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SecurityRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SecurityRounded.default;
	  }
	});
	Object.defineProperty(exports, "SecuritySharp", {
	  enumerable: true,
	  get: function get() {
	    return _SecuritySharp.default;
	  }
	});
	Object.defineProperty(exports, "SecurityTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SecurityTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SelectAll", {
	  enumerable: true,
	  get: function get() {
	    return _SelectAll.default;
	  }
	});
	Object.defineProperty(exports, "SelectAllOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SelectAllOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SelectAllRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SelectAllRounded.default;
	  }
	});
	Object.defineProperty(exports, "SelectAllSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SelectAllSharp.default;
	  }
	});
	Object.defineProperty(exports, "SelectAllTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SelectAllTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Send", {
	  enumerable: true,
	  get: function get() {
	    return _Send.default;
	  }
	});
	Object.defineProperty(exports, "SendOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SendOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SendRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SendRounded.default;
	  }
	});
	Object.defineProperty(exports, "SendSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SendSharp.default;
	  }
	});
	Object.defineProperty(exports, "SendTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SendTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SentimentDissatisfied", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentDissatisfied.default;
	  }
	});
	Object.defineProperty(exports, "SentimentDissatisfiedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentDissatisfiedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SentimentDissatisfiedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentDissatisfiedRounded.default;
	  }
	});
	Object.defineProperty(exports, "SentimentDissatisfiedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentDissatisfiedSharp.default;
	  }
	});
	Object.defineProperty(exports, "SentimentDissatisfiedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentDissatisfiedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SentimentSatisfied", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentSatisfied.default;
	  }
	});
	Object.defineProperty(exports, "SentimentSatisfiedAlt", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentSatisfiedAlt.default;
	  }
	});
	Object.defineProperty(exports, "SentimentSatisfiedAltOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentSatisfiedAltOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SentimentSatisfiedAltRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentSatisfiedAltRounded.default;
	  }
	});
	Object.defineProperty(exports, "SentimentSatisfiedAltSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentSatisfiedAltSharp.default;
	  }
	});
	Object.defineProperty(exports, "SentimentSatisfiedAltTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentSatisfiedAltTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SentimentSatisfiedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentSatisfiedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SentimentSatisfiedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentSatisfiedRounded.default;
	  }
	});
	Object.defineProperty(exports, "SentimentSatisfiedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentSatisfiedSharp.default;
	  }
	});
	Object.defineProperty(exports, "SentimentSatisfiedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentSatisfiedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SentimentVeryDissatisfied", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentVeryDissatisfied.default;
	  }
	});
	Object.defineProperty(exports, "SentimentVeryDissatisfiedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentVeryDissatisfiedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SentimentVeryDissatisfiedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentVeryDissatisfiedRounded.default;
	  }
	});
	Object.defineProperty(exports, "SentimentVeryDissatisfiedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentVeryDissatisfiedSharp.default;
	  }
	});
	Object.defineProperty(exports, "SentimentVeryDissatisfiedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentVeryDissatisfiedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SentimentVerySatisfied", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentVerySatisfied.default;
	  }
	});
	Object.defineProperty(exports, "SentimentVerySatisfiedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentVerySatisfiedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SentimentVerySatisfiedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentVerySatisfiedRounded.default;
	  }
	});
	Object.defineProperty(exports, "SentimentVerySatisfiedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentVerySatisfiedSharp.default;
	  }
	});
	Object.defineProperty(exports, "SentimentVerySatisfiedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SentimentVerySatisfiedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Settings", {
	  enumerable: true,
	  get: function get() {
	    return _Settings.default;
	  }
	});
	Object.defineProperty(exports, "SettingsApplications", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsApplications.default;
	  }
	});
	Object.defineProperty(exports, "SettingsApplicationsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsApplicationsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SettingsApplicationsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsApplicationsRounded.default;
	  }
	});
	Object.defineProperty(exports, "SettingsApplicationsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsApplicationsSharp.default;
	  }
	});
	Object.defineProperty(exports, "SettingsApplicationsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsApplicationsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SettingsBackupRestore", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsBackupRestore.default;
	  }
	});
	Object.defineProperty(exports, "SettingsBackupRestoreOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsBackupRestoreOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SettingsBackupRestoreRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsBackupRestoreRounded.default;
	  }
	});
	Object.defineProperty(exports, "SettingsBackupRestoreSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsBackupRestoreSharp.default;
	  }
	});
	Object.defineProperty(exports, "SettingsBackupRestoreTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsBackupRestoreTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SettingsBluetooth", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsBluetooth.default;
	  }
	});
	Object.defineProperty(exports, "SettingsBluetoothOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsBluetoothOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SettingsBluetoothRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsBluetoothRounded.default;
	  }
	});
	Object.defineProperty(exports, "SettingsBluetoothSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsBluetoothSharp.default;
	  }
	});
	Object.defineProperty(exports, "SettingsBluetoothTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsBluetoothTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SettingsBrightness", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsBrightness.default;
	  }
	});
	Object.defineProperty(exports, "SettingsBrightnessOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsBrightnessOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SettingsBrightnessRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsBrightnessRounded.default;
	  }
	});
	Object.defineProperty(exports, "SettingsBrightnessSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsBrightnessSharp.default;
	  }
	});
	Object.defineProperty(exports, "SettingsBrightnessTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsBrightnessTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SettingsCell", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsCell.default;
	  }
	});
	Object.defineProperty(exports, "SettingsCellOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsCellOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SettingsCellRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsCellRounded.default;
	  }
	});
	Object.defineProperty(exports, "SettingsCellSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsCellSharp.default;
	  }
	});
	Object.defineProperty(exports, "SettingsCellTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsCellTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SettingsEthernet", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsEthernet.default;
	  }
	});
	Object.defineProperty(exports, "SettingsEthernetOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsEthernetOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SettingsEthernetRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsEthernetRounded.default;
	  }
	});
	Object.defineProperty(exports, "SettingsEthernetSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsEthernetSharp.default;
	  }
	});
	Object.defineProperty(exports, "SettingsEthernetTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsEthernetTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputAntenna", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputAntenna.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputAntennaOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputAntennaOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputAntennaRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputAntennaRounded.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputAntennaSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputAntennaSharp.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputAntennaTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputAntennaTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputComponent", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputComponent.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputComponentOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputComponentOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputComponentRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputComponentRounded.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputComponentSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputComponentSharp.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputComponentTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputComponentTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputComposite", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputComposite.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputCompositeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputCompositeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputCompositeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputCompositeRounded.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputCompositeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputCompositeSharp.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputCompositeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputCompositeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputHdmi", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputHdmi.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputHdmiOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputHdmiOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputHdmiRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputHdmiRounded.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputHdmiSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputHdmiSharp.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputHdmiTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputHdmiTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputSvideo", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputSvideo.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputSvideoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputSvideoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputSvideoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputSvideoRounded.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputSvideoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputSvideoSharp.default;
	  }
	});
	Object.defineProperty(exports, "SettingsInputSvideoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsInputSvideoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SettingsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SettingsOverscan", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsOverscan.default;
	  }
	});
	Object.defineProperty(exports, "SettingsOverscanOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsOverscanOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SettingsOverscanRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsOverscanRounded.default;
	  }
	});
	Object.defineProperty(exports, "SettingsOverscanSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsOverscanSharp.default;
	  }
	});
	Object.defineProperty(exports, "SettingsOverscanTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsOverscanTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SettingsPhone", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsPhone.default;
	  }
	});
	Object.defineProperty(exports, "SettingsPhoneOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsPhoneOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SettingsPhoneRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsPhoneRounded.default;
	  }
	});
	Object.defineProperty(exports, "SettingsPhoneSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsPhoneSharp.default;
	  }
	});
	Object.defineProperty(exports, "SettingsPhoneTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsPhoneTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SettingsPower", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsPower.default;
	  }
	});
	Object.defineProperty(exports, "SettingsPowerOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsPowerOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SettingsPowerRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsPowerRounded.default;
	  }
	});
	Object.defineProperty(exports, "SettingsPowerSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsPowerSharp.default;
	  }
	});
	Object.defineProperty(exports, "SettingsPowerTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsPowerTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SettingsRemote", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsRemote.default;
	  }
	});
	Object.defineProperty(exports, "SettingsRemoteOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsRemoteOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SettingsRemoteRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsRemoteRounded.default;
	  }
	});
	Object.defineProperty(exports, "SettingsRemoteSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsRemoteSharp.default;
	  }
	});
	Object.defineProperty(exports, "SettingsRemoteTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsRemoteTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SettingsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsRounded.default;
	  }
	});
	Object.defineProperty(exports, "SettingsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsSharp.default;
	  }
	});
	Object.defineProperty(exports, "SettingsSystemDaydream", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsSystemDaydream.default;
	  }
	});
	Object.defineProperty(exports, "SettingsSystemDaydreamOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsSystemDaydreamOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SettingsSystemDaydreamRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsSystemDaydreamRounded.default;
	  }
	});
	Object.defineProperty(exports, "SettingsSystemDaydreamSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsSystemDaydreamSharp.default;
	  }
	});
	Object.defineProperty(exports, "SettingsSystemDaydreamTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsSystemDaydreamTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SettingsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SettingsVoice", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsVoice.default;
	  }
	});
	Object.defineProperty(exports, "SettingsVoiceOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsVoiceOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SettingsVoiceRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsVoiceRounded.default;
	  }
	});
	Object.defineProperty(exports, "SettingsVoiceSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsVoiceSharp.default;
	  }
	});
	Object.defineProperty(exports, "SettingsVoiceTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SettingsVoiceTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Share", {
	  enumerable: true,
	  get: function get() {
	    return _Share.default;
	  }
	});
	Object.defineProperty(exports, "ShareOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ShareOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ShareRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ShareRounded.default;
	  }
	});
	Object.defineProperty(exports, "ShareSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ShareSharp.default;
	  }
	});
	Object.defineProperty(exports, "ShareTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ShareTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Shop", {
	  enumerable: true,
	  get: function get() {
	    return _Shop.default;
	  }
	});
	Object.defineProperty(exports, "ShopOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ShopOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ShoppingBasket", {
	  enumerable: true,
	  get: function get() {
	    return _ShoppingBasket.default;
	  }
	});
	Object.defineProperty(exports, "ShoppingBasketOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ShoppingBasketOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ShoppingBasketRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ShoppingBasketRounded.default;
	  }
	});
	Object.defineProperty(exports, "ShoppingBasketSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ShoppingBasketSharp.default;
	  }
	});
	Object.defineProperty(exports, "ShoppingBasketTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ShoppingBasketTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ShoppingCart", {
	  enumerable: true,
	  get: function get() {
	    return _ShoppingCart.default;
	  }
	});
	Object.defineProperty(exports, "ShoppingCartOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ShoppingCartOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ShoppingCartRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ShoppingCartRounded.default;
	  }
	});
	Object.defineProperty(exports, "ShoppingCartSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ShoppingCartSharp.default;
	  }
	});
	Object.defineProperty(exports, "ShoppingCartTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ShoppingCartTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ShopRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ShopRounded.default;
	  }
	});
	Object.defineProperty(exports, "ShopSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ShopSharp.default;
	  }
	});
	Object.defineProperty(exports, "ShopTwo", {
	  enumerable: true,
	  get: function get() {
	    return _ShopTwo.default;
	  }
	});
	Object.defineProperty(exports, "ShopTwoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ShopTwoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ShopTwoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ShopTwoRounded.default;
	  }
	});
	Object.defineProperty(exports, "ShopTwoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ShopTwoSharp.default;
	  }
	});
	Object.defineProperty(exports, "ShopTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ShopTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ShopTwoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ShopTwoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ShortText", {
	  enumerable: true,
	  get: function get() {
	    return _ShortText.default;
	  }
	});
	Object.defineProperty(exports, "ShortTextOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ShortTextOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ShortTextRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ShortTextRounded.default;
	  }
	});
	Object.defineProperty(exports, "ShortTextSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ShortTextSharp.default;
	  }
	});
	Object.defineProperty(exports, "ShortTextTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ShortTextTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ShowChart", {
	  enumerable: true,
	  get: function get() {
	    return _ShowChart.default;
	  }
	});
	Object.defineProperty(exports, "ShowChartOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ShowChartOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ShowChartRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ShowChartRounded.default;
	  }
	});
	Object.defineProperty(exports, "ShowChartSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ShowChartSharp.default;
	  }
	});
	Object.defineProperty(exports, "ShowChartTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ShowChartTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Shuffle", {
	  enumerable: true,
	  get: function get() {
	    return _Shuffle.default;
	  }
	});
	Object.defineProperty(exports, "ShuffleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ShuffleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ShuffleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ShuffleRounded.default;
	  }
	});
	Object.defineProperty(exports, "ShuffleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ShuffleSharp.default;
	  }
	});
	Object.defineProperty(exports, "ShuffleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ShuffleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ShutterSpeed", {
	  enumerable: true,
	  get: function get() {
	    return _ShutterSpeed.default;
	  }
	});
	Object.defineProperty(exports, "ShutterSpeedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ShutterSpeedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ShutterSpeedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ShutterSpeedRounded.default;
	  }
	});
	Object.defineProperty(exports, "ShutterSpeedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ShutterSpeedSharp.default;
	  }
	});
	Object.defineProperty(exports, "ShutterSpeedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ShutterSpeedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular0Bar", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular0Bar.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular0BarOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular0BarOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular0BarRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular0BarRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular0BarSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular0BarSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular0BarTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular0BarTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular1Bar", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular1Bar.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular1BarOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular1BarOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular1BarRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular1BarRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular1BarSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular1BarSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular1BarTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular1BarTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular2Bar", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular2Bar.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular2BarOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular2BarOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular2BarRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular2BarRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular2BarSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular2BarSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular2BarTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular2BarTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular3Bar", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular3Bar.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular3BarOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular3BarOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular3BarRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular3BarRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular3BarSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular3BarSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular3BarTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular3BarTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular4Bar", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular4Bar.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular4BarOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular4BarOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular4BarRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular4BarRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular4BarSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular4BarSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellular4BarTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellular4BarTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularAlt", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularAlt.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularAltOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularAltOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularAltRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularAltRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularAltSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularAltSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularAltTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularAltTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet0Bar", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet0Bar.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet0BarOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet0BarOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet0BarRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet0BarRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet0BarSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet0BarSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet0BarTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet0BarTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet1Bar", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet1Bar.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet1BarOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet1BarOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet1BarRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet1BarRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet1BarSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet1BarSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet1BarTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet1BarTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet2Bar", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet2Bar.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet2BarOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet2BarOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet2BarRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet2BarRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet2BarSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet2BarSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet2BarTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet2BarTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet3Bar", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet3Bar.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet3BarOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet3BarOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet3BarRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet3BarRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet3BarSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet3BarSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet3BarTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet3BarTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet4Bar", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet4Bar.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet4BarOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet4BarOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet4BarRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet4BarRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet4BarSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet4BarSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularConnectedNoInternet4BarTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularConnectedNoInternet4BarTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularNoSim", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularNoSim.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularNoSimOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularNoSimOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularNoSimRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularNoSimRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularNoSimSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularNoSimSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularNoSimTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularNoSimTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularNull", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularNull.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularNullOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularNullOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularNullRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularNullRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularNullSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularNullSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularNullTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularNullTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularOff", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularOff.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalCellularOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalCellularOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi0Bar", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi0Bar.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi0BarOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi0BarOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi0BarRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi0BarRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi0BarSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi0BarSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi0BarTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi0BarTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi1Bar", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi1Bar.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi1BarLock", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi1BarLock.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi1BarLockOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi1BarLockOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi1BarLockRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi1BarLockRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi1BarLockSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi1BarLockSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi1BarLockTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi1BarLockTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi1BarOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi1BarOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi1BarRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi1BarRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi1BarSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi1BarSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi1BarTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi1BarTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi2Bar", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi2Bar.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi2BarLock", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi2BarLock.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi2BarLockOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi2BarLockOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi2BarLockRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi2BarLockRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi2BarLockSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi2BarLockSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi2BarLockTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi2BarLockTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi2BarOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi2BarOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi2BarRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi2BarRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi2BarSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi2BarSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi2BarTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi2BarTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi3Bar", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi3Bar.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi3BarLock", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi3BarLock.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi3BarLockOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi3BarLockOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi3BarLockRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi3BarLockRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi3BarLockSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi3BarLockSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi3BarLockTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi3BarLockTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi3BarOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi3BarOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi3BarRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi3BarRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi3BarSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi3BarSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi3BarTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi3BarTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi4Bar", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi4Bar.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi4BarLock", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi4BarLock.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi4BarLockOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi4BarLockOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi4BarLockRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi4BarLockRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi4BarLockSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi4BarLockSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi4BarLockTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi4BarLockTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi4BarOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi4BarOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi4BarRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi4BarRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi4BarSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi4BarSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifi4BarTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifi4BarTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifiOff", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifiOff.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifiOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifiOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifiOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifiOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifiOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifiOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "SignalWifiOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SignalWifiOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SimCard", {
	  enumerable: true,
	  get: function get() {
	    return _SimCard.default;
	  }
	});
	Object.defineProperty(exports, "SimCardOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SimCardOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SimCardRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SimCardRounded.default;
	  }
	});
	Object.defineProperty(exports, "SimCardSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SimCardSharp.default;
	  }
	});
	Object.defineProperty(exports, "SimCardTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SimCardTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SingleBed", {
	  enumerable: true,
	  get: function get() {
	    return _SingleBed.default;
	  }
	});
	Object.defineProperty(exports, "SingleBedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SingleBedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SingleBedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SingleBedRounded.default;
	  }
	});
	Object.defineProperty(exports, "SingleBedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SingleBedSharp.default;
	  }
	});
	Object.defineProperty(exports, "SingleBedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SingleBedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SkipNext", {
	  enumerable: true,
	  get: function get() {
	    return _SkipNext.default;
	  }
	});
	Object.defineProperty(exports, "SkipNextOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SkipNextOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SkipNextRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SkipNextRounded.default;
	  }
	});
	Object.defineProperty(exports, "SkipNextSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SkipNextSharp.default;
	  }
	});
	Object.defineProperty(exports, "SkipNextTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SkipNextTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SkipPrevious", {
	  enumerable: true,
	  get: function get() {
	    return _SkipPrevious.default;
	  }
	});
	Object.defineProperty(exports, "SkipPreviousOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SkipPreviousOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SkipPreviousRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SkipPreviousRounded.default;
	  }
	});
	Object.defineProperty(exports, "SkipPreviousSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SkipPreviousSharp.default;
	  }
	});
	Object.defineProperty(exports, "SkipPreviousTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SkipPreviousTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Slideshow", {
	  enumerable: true,
	  get: function get() {
	    return _Slideshow.default;
	  }
	});
	Object.defineProperty(exports, "SlideshowOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SlideshowOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SlideshowRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SlideshowRounded.default;
	  }
	});
	Object.defineProperty(exports, "SlideshowSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SlideshowSharp.default;
	  }
	});
	Object.defineProperty(exports, "SlideshowTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SlideshowTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SlowMotionVideo", {
	  enumerable: true,
	  get: function get() {
	    return _SlowMotionVideo.default;
	  }
	});
	Object.defineProperty(exports, "SlowMotionVideoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SlowMotionVideoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SlowMotionVideoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SlowMotionVideoRounded.default;
	  }
	});
	Object.defineProperty(exports, "SlowMotionVideoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SlowMotionVideoSharp.default;
	  }
	});
	Object.defineProperty(exports, "SlowMotionVideoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SlowMotionVideoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Smartphone", {
	  enumerable: true,
	  get: function get() {
	    return _Smartphone.default;
	  }
	});
	Object.defineProperty(exports, "SmartphoneOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SmartphoneOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SmartphoneRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SmartphoneRounded.default;
	  }
	});
	Object.defineProperty(exports, "SmartphoneSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SmartphoneSharp.default;
	  }
	});
	Object.defineProperty(exports, "SmartphoneTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SmartphoneTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SmokeFree", {
	  enumerable: true,
	  get: function get() {
	    return _SmokeFree.default;
	  }
	});
	Object.defineProperty(exports, "SmokeFreeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SmokeFreeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SmokeFreeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SmokeFreeRounded.default;
	  }
	});
	Object.defineProperty(exports, "SmokeFreeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SmokeFreeSharp.default;
	  }
	});
	Object.defineProperty(exports, "SmokeFreeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SmokeFreeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SmokingRooms", {
	  enumerable: true,
	  get: function get() {
	    return _SmokingRooms.default;
	  }
	});
	Object.defineProperty(exports, "SmokingRoomsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SmokingRoomsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SmokingRoomsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SmokingRoomsRounded.default;
	  }
	});
	Object.defineProperty(exports, "SmokingRoomsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SmokingRoomsSharp.default;
	  }
	});
	Object.defineProperty(exports, "SmokingRoomsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SmokingRoomsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Sms", {
	  enumerable: true,
	  get: function get() {
	    return _Sms.default;
	  }
	});
	Object.defineProperty(exports, "SmsFailed", {
	  enumerable: true,
	  get: function get() {
	    return _SmsFailed.default;
	  }
	});
	Object.defineProperty(exports, "SmsFailedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SmsFailedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SmsFailedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SmsFailedRounded.default;
	  }
	});
	Object.defineProperty(exports, "SmsFailedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SmsFailedSharp.default;
	  }
	});
	Object.defineProperty(exports, "SmsFailedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SmsFailedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SmsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SmsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SmsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SmsRounded.default;
	  }
	});
	Object.defineProperty(exports, "SmsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SmsSharp.default;
	  }
	});
	Object.defineProperty(exports, "SmsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SmsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Snooze", {
	  enumerable: true,
	  get: function get() {
	    return _Snooze.default;
	  }
	});
	Object.defineProperty(exports, "SnoozeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SnoozeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SnoozeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SnoozeRounded.default;
	  }
	});
	Object.defineProperty(exports, "SnoozeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SnoozeSharp.default;
	  }
	});
	Object.defineProperty(exports, "SnoozeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SnoozeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Sort", {
	  enumerable: true,
	  get: function get() {
	    return _Sort.default;
	  }
	});
	Object.defineProperty(exports, "SortByAlpha", {
	  enumerable: true,
	  get: function get() {
	    return _SortByAlpha.default;
	  }
	});
	Object.defineProperty(exports, "SortByAlphaOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SortByAlphaOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SortByAlphaRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SortByAlphaRounded.default;
	  }
	});
	Object.defineProperty(exports, "SortByAlphaSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SortByAlphaSharp.default;
	  }
	});
	Object.defineProperty(exports, "SortByAlphaTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SortByAlphaTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SortOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SortOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SortRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SortRounded.default;
	  }
	});
	Object.defineProperty(exports, "SortSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SortSharp.default;
	  }
	});
	Object.defineProperty(exports, "SortTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SortTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Spa", {
	  enumerable: true,
	  get: function get() {
	    return _Spa.default;
	  }
	});
	Object.defineProperty(exports, "SpaceBar", {
	  enumerable: true,
	  get: function get() {
	    return _SpaceBar.default;
	  }
	});
	Object.defineProperty(exports, "SpaceBarOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SpaceBarOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SpaceBarRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SpaceBarRounded.default;
	  }
	});
	Object.defineProperty(exports, "SpaceBarSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SpaceBarSharp.default;
	  }
	});
	Object.defineProperty(exports, "SpaceBarTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SpaceBarTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SpaOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SpaOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SpaRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SpaRounded.default;
	  }
	});
	Object.defineProperty(exports, "SpaSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SpaSharp.default;
	  }
	});
	Object.defineProperty(exports, "SpaTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SpaTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Speaker", {
	  enumerable: true,
	  get: function get() {
	    return _Speaker.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerGroup", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerGroup.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerGroupOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerGroupOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerGroupRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerGroupRounded.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerGroupSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerGroupSharp.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerGroupTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerGroupTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerNotes", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerNotes.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerNotesOff", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerNotesOff.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerNotesOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerNotesOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerNotesOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerNotesOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerNotesOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerNotesOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerNotesOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerNotesOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerNotesOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerNotesOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerNotesRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerNotesRounded.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerNotesSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerNotesSharp.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerNotesTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerNotesTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerPhone", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerPhone.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerPhoneOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerPhoneOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerPhoneRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerPhoneRounded.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerPhoneSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerPhoneSharp.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerPhoneTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerPhoneTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerRounded.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerSharp.default;
	  }
	});
	Object.defineProperty(exports, "SpeakerTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SpeakerTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Speed", {
	  enumerable: true,
	  get: function get() {
	    return _Speed.default;
	  }
	});
	Object.defineProperty(exports, "SpeedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SpeedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SpeedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SpeedRounded.default;
	  }
	});
	Object.defineProperty(exports, "SpeedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SpeedSharp.default;
	  }
	});
	Object.defineProperty(exports, "SpeedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SpeedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Spellcheck", {
	  enumerable: true,
	  get: function get() {
	    return _Spellcheck.default;
	  }
	});
	Object.defineProperty(exports, "SpellcheckOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SpellcheckOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SpellcheckRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SpellcheckRounded.default;
	  }
	});
	Object.defineProperty(exports, "SpellcheckSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SpellcheckSharp.default;
	  }
	});
	Object.defineProperty(exports, "SpellcheckTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SpellcheckTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Sports", {
	  enumerable: true,
	  get: function get() {
	    return _Sports.default;
	  }
	});
	Object.defineProperty(exports, "SportsBaseball", {
	  enumerable: true,
	  get: function get() {
	    return _SportsBaseball.default;
	  }
	});
	Object.defineProperty(exports, "SportsBaseballOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SportsBaseballOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SportsBaseballRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SportsBaseballRounded.default;
	  }
	});
	Object.defineProperty(exports, "SportsBaseballSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SportsBaseballSharp.default;
	  }
	});
	Object.defineProperty(exports, "SportsBaseballTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SportsBaseballTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SportsBasketball", {
	  enumerable: true,
	  get: function get() {
	    return _SportsBasketball.default;
	  }
	});
	Object.defineProperty(exports, "SportsBasketballOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SportsBasketballOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SportsBasketballRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SportsBasketballRounded.default;
	  }
	});
	Object.defineProperty(exports, "SportsBasketballSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SportsBasketballSharp.default;
	  }
	});
	Object.defineProperty(exports, "SportsBasketballTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SportsBasketballTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SportsCricket", {
	  enumerable: true,
	  get: function get() {
	    return _SportsCricket.default;
	  }
	});
	Object.defineProperty(exports, "SportsCricketOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SportsCricketOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SportsCricketRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SportsCricketRounded.default;
	  }
	});
	Object.defineProperty(exports, "SportsCricketSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SportsCricketSharp.default;
	  }
	});
	Object.defineProperty(exports, "SportsCricketTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SportsCricketTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SportsEsports", {
	  enumerable: true,
	  get: function get() {
	    return _SportsEsports.default;
	  }
	});
	Object.defineProperty(exports, "SportsEsportsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SportsEsportsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SportsEsportsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SportsEsportsRounded.default;
	  }
	});
	Object.defineProperty(exports, "SportsEsportsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SportsEsportsSharp.default;
	  }
	});
	Object.defineProperty(exports, "SportsEsportsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SportsEsportsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SportsFootball", {
	  enumerable: true,
	  get: function get() {
	    return _SportsFootball.default;
	  }
	});
	Object.defineProperty(exports, "SportsFootballOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SportsFootballOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SportsFootballRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SportsFootballRounded.default;
	  }
	});
	Object.defineProperty(exports, "SportsFootballSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SportsFootballSharp.default;
	  }
	});
	Object.defineProperty(exports, "SportsFootballTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SportsFootballTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SportsGolf", {
	  enumerable: true,
	  get: function get() {
	    return _SportsGolf.default;
	  }
	});
	Object.defineProperty(exports, "SportsGolfOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SportsGolfOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SportsGolfRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SportsGolfRounded.default;
	  }
	});
	Object.defineProperty(exports, "SportsGolfSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SportsGolfSharp.default;
	  }
	});
	Object.defineProperty(exports, "SportsGolfTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SportsGolfTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SportsHandball", {
	  enumerable: true,
	  get: function get() {
	    return _SportsHandball.default;
	  }
	});
	Object.defineProperty(exports, "SportsHandballOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SportsHandballOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SportsHandballRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SportsHandballRounded.default;
	  }
	});
	Object.defineProperty(exports, "SportsHandballSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SportsHandballSharp.default;
	  }
	});
	Object.defineProperty(exports, "SportsHandballTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SportsHandballTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SportsHockey", {
	  enumerable: true,
	  get: function get() {
	    return _SportsHockey.default;
	  }
	});
	Object.defineProperty(exports, "SportsHockeyOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SportsHockeyOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SportsHockeyRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SportsHockeyRounded.default;
	  }
	});
	Object.defineProperty(exports, "SportsHockeySharp", {
	  enumerable: true,
	  get: function get() {
	    return _SportsHockeySharp.default;
	  }
	});
	Object.defineProperty(exports, "SportsHockeyTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SportsHockeyTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SportsKabaddi", {
	  enumerable: true,
	  get: function get() {
	    return _SportsKabaddi.default;
	  }
	});
	Object.defineProperty(exports, "SportsKabaddiOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SportsKabaddiOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SportsKabaddiRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SportsKabaddiRounded.default;
	  }
	});
	Object.defineProperty(exports, "SportsKabaddiSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SportsKabaddiSharp.default;
	  }
	});
	Object.defineProperty(exports, "SportsKabaddiTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SportsKabaddiTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SportsMma", {
	  enumerable: true,
	  get: function get() {
	    return _SportsMma.default;
	  }
	});
	Object.defineProperty(exports, "SportsMmaOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SportsMmaOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SportsMmaRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SportsMmaRounded.default;
	  }
	});
	Object.defineProperty(exports, "SportsMmaSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SportsMmaSharp.default;
	  }
	});
	Object.defineProperty(exports, "SportsMmaTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SportsMmaTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SportsMotorsports", {
	  enumerable: true,
	  get: function get() {
	    return _SportsMotorsports.default;
	  }
	});
	Object.defineProperty(exports, "SportsMotorsportsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SportsMotorsportsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SportsMotorsportsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SportsMotorsportsRounded.default;
	  }
	});
	Object.defineProperty(exports, "SportsMotorsportsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SportsMotorsportsSharp.default;
	  }
	});
	Object.defineProperty(exports, "SportsMotorsportsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SportsMotorsportsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SportsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SportsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SportsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SportsRounded.default;
	  }
	});
	Object.defineProperty(exports, "SportsRugby", {
	  enumerable: true,
	  get: function get() {
	    return _SportsRugby.default;
	  }
	});
	Object.defineProperty(exports, "SportsRugbyOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SportsRugbyOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SportsRugbyRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SportsRugbyRounded.default;
	  }
	});
	Object.defineProperty(exports, "SportsRugbySharp", {
	  enumerable: true,
	  get: function get() {
	    return _SportsRugbySharp.default;
	  }
	});
	Object.defineProperty(exports, "SportsRugbyTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SportsRugbyTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SportsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SportsSharp.default;
	  }
	});
	Object.defineProperty(exports, "SportsSoccer", {
	  enumerable: true,
	  get: function get() {
	    return _SportsSoccer.default;
	  }
	});
	Object.defineProperty(exports, "SportsSoccerOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SportsSoccerOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SportsSoccerRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SportsSoccerRounded.default;
	  }
	});
	Object.defineProperty(exports, "SportsSoccerSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SportsSoccerSharp.default;
	  }
	});
	Object.defineProperty(exports, "SportsSoccerTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SportsSoccerTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SportsTennis", {
	  enumerable: true,
	  get: function get() {
	    return _SportsTennis.default;
	  }
	});
	Object.defineProperty(exports, "SportsTennisOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SportsTennisOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SportsTennisRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SportsTennisRounded.default;
	  }
	});
	Object.defineProperty(exports, "SportsTennisSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SportsTennisSharp.default;
	  }
	});
	Object.defineProperty(exports, "SportsTennisTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SportsTennisTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SportsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SportsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SportsVolleyball", {
	  enumerable: true,
	  get: function get() {
	    return _SportsVolleyball.default;
	  }
	});
	Object.defineProperty(exports, "SportsVolleyballOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SportsVolleyballOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SportsVolleyballRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SportsVolleyballRounded.default;
	  }
	});
	Object.defineProperty(exports, "SportsVolleyballSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SportsVolleyballSharp.default;
	  }
	});
	Object.defineProperty(exports, "SportsVolleyballTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SportsVolleyballTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SquareFoot", {
	  enumerable: true,
	  get: function get() {
	    return _SquareFoot.default;
	  }
	});
	Object.defineProperty(exports, "SquareFootOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SquareFootOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SquareFootRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SquareFootRounded.default;
	  }
	});
	Object.defineProperty(exports, "SquareFootSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SquareFootSharp.default;
	  }
	});
	Object.defineProperty(exports, "SquareFootTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SquareFootTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Star", {
	  enumerable: true,
	  get: function get() {
	    return _Star.default;
	  }
	});
	Object.defineProperty(exports, "StarBorder", {
	  enumerable: true,
	  get: function get() {
	    return _StarBorder.default;
	  }
	});
	Object.defineProperty(exports, "StarBorderOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _StarBorderOutlined.default;
	  }
	});
	Object.defineProperty(exports, "StarBorderRounded", {
	  enumerable: true,
	  get: function get() {
	    return _StarBorderRounded.default;
	  }
	});
	Object.defineProperty(exports, "StarBorderSharp", {
	  enumerable: true,
	  get: function get() {
	    return _StarBorderSharp.default;
	  }
	});
	Object.defineProperty(exports, "StarBorderTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _StarBorderTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "StarHalf", {
	  enumerable: true,
	  get: function get() {
	    return _StarHalf.default;
	  }
	});
	Object.defineProperty(exports, "StarHalfOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _StarHalfOutlined.default;
	  }
	});
	Object.defineProperty(exports, "StarHalfRounded", {
	  enumerable: true,
	  get: function get() {
	    return _StarHalfRounded.default;
	  }
	});
	Object.defineProperty(exports, "StarHalfSharp", {
	  enumerable: true,
	  get: function get() {
	    return _StarHalfSharp.default;
	  }
	});
	Object.defineProperty(exports, "StarHalfTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _StarHalfTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "StarOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _StarOutlined.default;
	  }
	});
	Object.defineProperty(exports, "StarRate", {
	  enumerable: true,
	  get: function get() {
	    return _StarRate.default;
	  }
	});
	Object.defineProperty(exports, "StarRateOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _StarRateOutlined.default;
	  }
	});
	Object.defineProperty(exports, "StarRateRounded", {
	  enumerable: true,
	  get: function get() {
	    return _StarRateRounded.default;
	  }
	});
	Object.defineProperty(exports, "StarRateSharp", {
	  enumerable: true,
	  get: function get() {
	    return _StarRateSharp.default;
	  }
	});
	Object.defineProperty(exports, "StarRateTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _StarRateTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "StarRounded", {
	  enumerable: true,
	  get: function get() {
	    return _StarRounded.default;
	  }
	});
	Object.defineProperty(exports, "Stars", {
	  enumerable: true,
	  get: function get() {
	    return _Stars.default;
	  }
	});
	Object.defineProperty(exports, "StarSharp", {
	  enumerable: true,
	  get: function get() {
	    return _StarSharp.default;
	  }
	});
	Object.defineProperty(exports, "StarsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _StarsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "StarsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _StarsRounded.default;
	  }
	});
	Object.defineProperty(exports, "StarsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _StarsSharp.default;
	  }
	});
	Object.defineProperty(exports, "StarsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _StarsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "StarTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _StarTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "StayCurrentLandscape", {
	  enumerable: true,
	  get: function get() {
	    return _StayCurrentLandscape.default;
	  }
	});
	Object.defineProperty(exports, "StayCurrentLandscapeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _StayCurrentLandscapeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "StayCurrentLandscapeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _StayCurrentLandscapeRounded.default;
	  }
	});
	Object.defineProperty(exports, "StayCurrentLandscapeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _StayCurrentLandscapeSharp.default;
	  }
	});
	Object.defineProperty(exports, "StayCurrentLandscapeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _StayCurrentLandscapeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "StayCurrentPortrait", {
	  enumerable: true,
	  get: function get() {
	    return _StayCurrentPortrait.default;
	  }
	});
	Object.defineProperty(exports, "StayCurrentPortraitOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _StayCurrentPortraitOutlined.default;
	  }
	});
	Object.defineProperty(exports, "StayCurrentPortraitRounded", {
	  enumerable: true,
	  get: function get() {
	    return _StayCurrentPortraitRounded.default;
	  }
	});
	Object.defineProperty(exports, "StayCurrentPortraitSharp", {
	  enumerable: true,
	  get: function get() {
	    return _StayCurrentPortraitSharp.default;
	  }
	});
	Object.defineProperty(exports, "StayCurrentPortraitTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _StayCurrentPortraitTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "StayPrimaryLandscape", {
	  enumerable: true,
	  get: function get() {
	    return _StayPrimaryLandscape.default;
	  }
	});
	Object.defineProperty(exports, "StayPrimaryLandscapeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _StayPrimaryLandscapeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "StayPrimaryLandscapeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _StayPrimaryLandscapeRounded.default;
	  }
	});
	Object.defineProperty(exports, "StayPrimaryLandscapeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _StayPrimaryLandscapeSharp.default;
	  }
	});
	Object.defineProperty(exports, "StayPrimaryLandscapeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _StayPrimaryLandscapeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "StayPrimaryPortrait", {
	  enumerable: true,
	  get: function get() {
	    return _StayPrimaryPortrait.default;
	  }
	});
	Object.defineProperty(exports, "StayPrimaryPortraitOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _StayPrimaryPortraitOutlined.default;
	  }
	});
	Object.defineProperty(exports, "StayPrimaryPortraitRounded", {
	  enumerable: true,
	  get: function get() {
	    return _StayPrimaryPortraitRounded.default;
	  }
	});
	Object.defineProperty(exports, "StayPrimaryPortraitSharp", {
	  enumerable: true,
	  get: function get() {
	    return _StayPrimaryPortraitSharp.default;
	  }
	});
	Object.defineProperty(exports, "StayPrimaryPortraitTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _StayPrimaryPortraitTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Stop", {
	  enumerable: true,
	  get: function get() {
	    return _Stop.default;
	  }
	});
	Object.defineProperty(exports, "StopOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _StopOutlined.default;
	  }
	});
	Object.defineProperty(exports, "StopRounded", {
	  enumerable: true,
	  get: function get() {
	    return _StopRounded.default;
	  }
	});
	Object.defineProperty(exports, "StopScreenShare", {
	  enumerable: true,
	  get: function get() {
	    return _StopScreenShare.default;
	  }
	});
	Object.defineProperty(exports, "StopScreenShareOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _StopScreenShareOutlined.default;
	  }
	});
	Object.defineProperty(exports, "StopScreenShareRounded", {
	  enumerable: true,
	  get: function get() {
	    return _StopScreenShareRounded.default;
	  }
	});
	Object.defineProperty(exports, "StopScreenShareSharp", {
	  enumerable: true,
	  get: function get() {
	    return _StopScreenShareSharp.default;
	  }
	});
	Object.defineProperty(exports, "StopScreenShareTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _StopScreenShareTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "StopSharp", {
	  enumerable: true,
	  get: function get() {
	    return _StopSharp.default;
	  }
	});
	Object.defineProperty(exports, "StopTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _StopTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Storage", {
	  enumerable: true,
	  get: function get() {
	    return _Storage.default;
	  }
	});
	Object.defineProperty(exports, "StorageOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _StorageOutlined.default;
	  }
	});
	Object.defineProperty(exports, "StorageRounded", {
	  enumerable: true,
	  get: function get() {
	    return _StorageRounded.default;
	  }
	});
	Object.defineProperty(exports, "StorageSharp", {
	  enumerable: true,
	  get: function get() {
	    return _StorageSharp.default;
	  }
	});
	Object.defineProperty(exports, "StorageTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _StorageTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Store", {
	  enumerable: true,
	  get: function get() {
	    return _Store.default;
	  }
	});
	Object.defineProperty(exports, "Storefront", {
	  enumerable: true,
	  get: function get() {
	    return _Storefront.default;
	  }
	});
	Object.defineProperty(exports, "StorefrontOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _StorefrontOutlined.default;
	  }
	});
	Object.defineProperty(exports, "StorefrontRounded", {
	  enumerable: true,
	  get: function get() {
	    return _StorefrontRounded.default;
	  }
	});
	Object.defineProperty(exports, "StorefrontSharp", {
	  enumerable: true,
	  get: function get() {
	    return _StorefrontSharp.default;
	  }
	});
	Object.defineProperty(exports, "StorefrontTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _StorefrontTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "StoreMallDirectory", {
	  enumerable: true,
	  get: function get() {
	    return _StoreMallDirectory.default;
	  }
	});
	Object.defineProperty(exports, "StoreMallDirectoryOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _StoreMallDirectoryOutlined.default;
	  }
	});
	Object.defineProperty(exports, "StoreMallDirectoryRounded", {
	  enumerable: true,
	  get: function get() {
	    return _StoreMallDirectoryRounded.default;
	  }
	});
	Object.defineProperty(exports, "StoreMallDirectorySharp", {
	  enumerable: true,
	  get: function get() {
	    return _StoreMallDirectorySharp.default;
	  }
	});
	Object.defineProperty(exports, "StoreMallDirectoryTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _StoreMallDirectoryTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "StoreOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _StoreOutlined.default;
	  }
	});
	Object.defineProperty(exports, "StoreRounded", {
	  enumerable: true,
	  get: function get() {
	    return _StoreRounded.default;
	  }
	});
	Object.defineProperty(exports, "StoreSharp", {
	  enumerable: true,
	  get: function get() {
	    return _StoreSharp.default;
	  }
	});
	Object.defineProperty(exports, "StoreTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _StoreTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Straighten", {
	  enumerable: true,
	  get: function get() {
	    return _Straighten.default;
	  }
	});
	Object.defineProperty(exports, "StraightenOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _StraightenOutlined.default;
	  }
	});
	Object.defineProperty(exports, "StraightenRounded", {
	  enumerable: true,
	  get: function get() {
	    return _StraightenRounded.default;
	  }
	});
	Object.defineProperty(exports, "StraightenSharp", {
	  enumerable: true,
	  get: function get() {
	    return _StraightenSharp.default;
	  }
	});
	Object.defineProperty(exports, "StraightenTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _StraightenTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Streetview", {
	  enumerable: true,
	  get: function get() {
	    return _Streetview.default;
	  }
	});
	Object.defineProperty(exports, "StreetviewOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _StreetviewOutlined.default;
	  }
	});
	Object.defineProperty(exports, "StreetviewRounded", {
	  enumerable: true,
	  get: function get() {
	    return _StreetviewRounded.default;
	  }
	});
	Object.defineProperty(exports, "StreetviewSharp", {
	  enumerable: true,
	  get: function get() {
	    return _StreetviewSharp.default;
	  }
	});
	Object.defineProperty(exports, "StreetviewTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _StreetviewTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "StrikethroughS", {
	  enumerable: true,
	  get: function get() {
	    return _StrikethroughS.default;
	  }
	});
	Object.defineProperty(exports, "StrikethroughSOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _StrikethroughSOutlined.default;
	  }
	});
	Object.defineProperty(exports, "StrikethroughSRounded", {
	  enumerable: true,
	  get: function get() {
	    return _StrikethroughSRounded.default;
	  }
	});
	Object.defineProperty(exports, "StrikethroughSSharp", {
	  enumerable: true,
	  get: function get() {
	    return _StrikethroughSSharp.default;
	  }
	});
	Object.defineProperty(exports, "StrikethroughSTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _StrikethroughSTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Style", {
	  enumerable: true,
	  get: function get() {
	    return _Style.default;
	  }
	});
	Object.defineProperty(exports, "StyleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _StyleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "StyleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _StyleRounded.default;
	  }
	});
	Object.defineProperty(exports, "StyleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _StyleSharp.default;
	  }
	});
	Object.defineProperty(exports, "StyleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _StyleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SubdirectoryArrowLeft", {
	  enumerable: true,
	  get: function get() {
	    return _SubdirectoryArrowLeft.default;
	  }
	});
	Object.defineProperty(exports, "SubdirectoryArrowLeftOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SubdirectoryArrowLeftOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SubdirectoryArrowLeftRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SubdirectoryArrowLeftRounded.default;
	  }
	});
	Object.defineProperty(exports, "SubdirectoryArrowLeftSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SubdirectoryArrowLeftSharp.default;
	  }
	});
	Object.defineProperty(exports, "SubdirectoryArrowLeftTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SubdirectoryArrowLeftTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SubdirectoryArrowRight", {
	  enumerable: true,
	  get: function get() {
	    return _SubdirectoryArrowRight.default;
	  }
	});
	Object.defineProperty(exports, "SubdirectoryArrowRightOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SubdirectoryArrowRightOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SubdirectoryArrowRightRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SubdirectoryArrowRightRounded.default;
	  }
	});
	Object.defineProperty(exports, "SubdirectoryArrowRightSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SubdirectoryArrowRightSharp.default;
	  }
	});
	Object.defineProperty(exports, "SubdirectoryArrowRightTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SubdirectoryArrowRightTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Subject", {
	  enumerable: true,
	  get: function get() {
	    return _Subject.default;
	  }
	});
	Object.defineProperty(exports, "SubjectOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SubjectOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SubjectRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SubjectRounded.default;
	  }
	});
	Object.defineProperty(exports, "SubjectSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SubjectSharp.default;
	  }
	});
	Object.defineProperty(exports, "SubjectTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SubjectTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Subscriptions", {
	  enumerable: true,
	  get: function get() {
	    return _Subscriptions.default;
	  }
	});
	Object.defineProperty(exports, "SubscriptionsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SubscriptionsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SubscriptionsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SubscriptionsRounded.default;
	  }
	});
	Object.defineProperty(exports, "SubscriptionsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SubscriptionsSharp.default;
	  }
	});
	Object.defineProperty(exports, "SubscriptionsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SubscriptionsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Subtitles", {
	  enumerable: true,
	  get: function get() {
	    return _Subtitles.default;
	  }
	});
	Object.defineProperty(exports, "SubtitlesOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SubtitlesOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SubtitlesRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SubtitlesRounded.default;
	  }
	});
	Object.defineProperty(exports, "SubtitlesSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SubtitlesSharp.default;
	  }
	});
	Object.defineProperty(exports, "SubtitlesTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SubtitlesTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Subway", {
	  enumerable: true,
	  get: function get() {
	    return _Subway.default;
	  }
	});
	Object.defineProperty(exports, "SubwayOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SubwayOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SubwayRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SubwayRounded.default;
	  }
	});
	Object.defineProperty(exports, "SubwaySharp", {
	  enumerable: true,
	  get: function get() {
	    return _SubwaySharp.default;
	  }
	});
	Object.defineProperty(exports, "SubwayTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SubwayTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SupervisedUserCircle", {
	  enumerable: true,
	  get: function get() {
	    return _SupervisedUserCircle.default;
	  }
	});
	Object.defineProperty(exports, "SupervisedUserCircleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SupervisedUserCircleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SupervisedUserCircleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SupervisedUserCircleRounded.default;
	  }
	});
	Object.defineProperty(exports, "SupervisedUserCircleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SupervisedUserCircleSharp.default;
	  }
	});
	Object.defineProperty(exports, "SupervisedUserCircleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SupervisedUserCircleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SupervisorAccount", {
	  enumerable: true,
	  get: function get() {
	    return _SupervisorAccount.default;
	  }
	});
	Object.defineProperty(exports, "SupervisorAccountOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SupervisorAccountOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SupervisorAccountRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SupervisorAccountRounded.default;
	  }
	});
	Object.defineProperty(exports, "SupervisorAccountSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SupervisorAccountSharp.default;
	  }
	});
	Object.defineProperty(exports, "SupervisorAccountTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SupervisorAccountTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SurroundSound", {
	  enumerable: true,
	  get: function get() {
	    return _SurroundSound.default;
	  }
	});
	Object.defineProperty(exports, "SurroundSoundOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SurroundSoundOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SurroundSoundRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SurroundSoundRounded.default;
	  }
	});
	Object.defineProperty(exports, "SurroundSoundSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SurroundSoundSharp.default;
	  }
	});
	Object.defineProperty(exports, "SurroundSoundTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SurroundSoundTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SwapCalls", {
	  enumerable: true,
	  get: function get() {
	    return _SwapCalls.default;
	  }
	});
	Object.defineProperty(exports, "SwapCallsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SwapCallsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SwapCallsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SwapCallsRounded.default;
	  }
	});
	Object.defineProperty(exports, "SwapCallsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SwapCallsSharp.default;
	  }
	});
	Object.defineProperty(exports, "SwapCallsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SwapCallsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SwapHoriz", {
	  enumerable: true,
	  get: function get() {
	    return _SwapHoriz.default;
	  }
	});
	Object.defineProperty(exports, "SwapHorizontalCircle", {
	  enumerable: true,
	  get: function get() {
	    return _SwapHorizontalCircle.default;
	  }
	});
	Object.defineProperty(exports, "SwapHorizontalCircleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SwapHorizontalCircleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SwapHorizontalCircleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SwapHorizontalCircleRounded.default;
	  }
	});
	Object.defineProperty(exports, "SwapHorizontalCircleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SwapHorizontalCircleSharp.default;
	  }
	});
	Object.defineProperty(exports, "SwapHorizontalCircleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SwapHorizontalCircleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SwapHorizOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SwapHorizOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SwapHorizRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SwapHorizRounded.default;
	  }
	});
	Object.defineProperty(exports, "SwapHorizSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SwapHorizSharp.default;
	  }
	});
	Object.defineProperty(exports, "SwapHorizTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SwapHorizTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SwapVert", {
	  enumerable: true,
	  get: function get() {
	    return _SwapVert.default;
	  }
	});
	Object.defineProperty(exports, "SwapVerticalCircle", {
	  enumerable: true,
	  get: function get() {
	    return _SwapVerticalCircle.default;
	  }
	});
	Object.defineProperty(exports, "SwapVerticalCircleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SwapVerticalCircleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SwapVerticalCircleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SwapVerticalCircleRounded.default;
	  }
	});
	Object.defineProperty(exports, "SwapVerticalCircleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SwapVerticalCircleSharp.default;
	  }
	});
	Object.defineProperty(exports, "SwapVerticalCircleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SwapVerticalCircleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SwapVertOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SwapVertOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SwapVertRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SwapVertRounded.default;
	  }
	});
	Object.defineProperty(exports, "SwapVertSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SwapVertSharp.default;
	  }
	});
	Object.defineProperty(exports, "SwapVertTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SwapVertTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SwitchCamera", {
	  enumerable: true,
	  get: function get() {
	    return _SwitchCamera.default;
	  }
	});
	Object.defineProperty(exports, "SwitchCameraOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SwitchCameraOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SwitchCameraRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SwitchCameraRounded.default;
	  }
	});
	Object.defineProperty(exports, "SwitchCameraSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SwitchCameraSharp.default;
	  }
	});
	Object.defineProperty(exports, "SwitchCameraTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SwitchCameraTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SwitchVideo", {
	  enumerable: true,
	  get: function get() {
	    return _SwitchVideo.default;
	  }
	});
	Object.defineProperty(exports, "SwitchVideoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SwitchVideoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SwitchVideoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SwitchVideoRounded.default;
	  }
	});
	Object.defineProperty(exports, "SwitchVideoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SwitchVideoSharp.default;
	  }
	});
	Object.defineProperty(exports, "SwitchVideoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SwitchVideoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Sync", {
	  enumerable: true,
	  get: function get() {
	    return _Sync.default;
	  }
	});
	Object.defineProperty(exports, "SyncAlt", {
	  enumerable: true,
	  get: function get() {
	    return _SyncAlt.default;
	  }
	});
	Object.defineProperty(exports, "SyncAltOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SyncAltOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SyncAltRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SyncAltRounded.default;
	  }
	});
	Object.defineProperty(exports, "SyncAltSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SyncAltSharp.default;
	  }
	});
	Object.defineProperty(exports, "SyncAltTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SyncAltTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SyncDisabled", {
	  enumerable: true,
	  get: function get() {
	    return _SyncDisabled.default;
	  }
	});
	Object.defineProperty(exports, "SyncDisabledOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SyncDisabledOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SyncDisabledRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SyncDisabledRounded.default;
	  }
	});
	Object.defineProperty(exports, "SyncDisabledSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SyncDisabledSharp.default;
	  }
	});
	Object.defineProperty(exports, "SyncDisabledTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SyncDisabledTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SyncOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SyncOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SyncProblem", {
	  enumerable: true,
	  get: function get() {
	    return _SyncProblem.default;
	  }
	});
	Object.defineProperty(exports, "SyncProblemOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SyncProblemOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SyncProblemRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SyncProblemRounded.default;
	  }
	});
	Object.defineProperty(exports, "SyncProblemSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SyncProblemSharp.default;
	  }
	});
	Object.defineProperty(exports, "SyncProblemTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SyncProblemTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SyncRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SyncRounded.default;
	  }
	});
	Object.defineProperty(exports, "SyncSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SyncSharp.default;
	  }
	});
	Object.defineProperty(exports, "SyncTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SyncTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SystemUpdate", {
	  enumerable: true,
	  get: function get() {
	    return _SystemUpdate.default;
	  }
	});
	Object.defineProperty(exports, "SystemUpdateAlt", {
	  enumerable: true,
	  get: function get() {
	    return _SystemUpdateAlt.default;
	  }
	});
	Object.defineProperty(exports, "SystemUpdateAltOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SystemUpdateAltOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SystemUpdateAltRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SystemUpdateAltRounded.default;
	  }
	});
	Object.defineProperty(exports, "SystemUpdateAltSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SystemUpdateAltSharp.default;
	  }
	});
	Object.defineProperty(exports, "SystemUpdateAltTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SystemUpdateAltTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "SystemUpdateOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _SystemUpdateOutlined.default;
	  }
	});
	Object.defineProperty(exports, "SystemUpdateRounded", {
	  enumerable: true,
	  get: function get() {
	    return _SystemUpdateRounded.default;
	  }
	});
	Object.defineProperty(exports, "SystemUpdateSharp", {
	  enumerable: true,
	  get: function get() {
	    return _SystemUpdateSharp.default;
	  }
	});
	Object.defineProperty(exports, "SystemUpdateTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _SystemUpdateTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Tab", {
	  enumerable: true,
	  get: function get() {
	    return _Tab.default;
	  }
	});
	Object.defineProperty(exports, "TableChart", {
	  enumerable: true,
	  get: function get() {
	    return _TableChart.default;
	  }
	});
	Object.defineProperty(exports, "TableChartOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TableChartOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TableChartRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TableChartRounded.default;
	  }
	});
	Object.defineProperty(exports, "TableChartSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TableChartSharp.default;
	  }
	});
	Object.defineProperty(exports, "TableChartTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TableChartTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Tablet", {
	  enumerable: true,
	  get: function get() {
	    return _Tablet.default;
	  }
	});
	Object.defineProperty(exports, "TabletAndroid", {
	  enumerable: true,
	  get: function get() {
	    return _TabletAndroid.default;
	  }
	});
	Object.defineProperty(exports, "TabletAndroidOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TabletAndroidOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TabletAndroidRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TabletAndroidRounded.default;
	  }
	});
	Object.defineProperty(exports, "TabletAndroidSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TabletAndroidSharp.default;
	  }
	});
	Object.defineProperty(exports, "TabletAndroidTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TabletAndroidTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TabletMac", {
	  enumerable: true,
	  get: function get() {
	    return _TabletMac.default;
	  }
	});
	Object.defineProperty(exports, "TabletMacOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TabletMacOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TabletMacRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TabletMacRounded.default;
	  }
	});
	Object.defineProperty(exports, "TabletMacSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TabletMacSharp.default;
	  }
	});
	Object.defineProperty(exports, "TabletMacTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TabletMacTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TabletOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TabletOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TabletRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TabletRounded.default;
	  }
	});
	Object.defineProperty(exports, "TabletSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TabletSharp.default;
	  }
	});
	Object.defineProperty(exports, "TabletTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TabletTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TabOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TabOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TabRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TabRounded.default;
	  }
	});
	Object.defineProperty(exports, "TabSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TabSharp.default;
	  }
	});
	Object.defineProperty(exports, "TabTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TabTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TabUnselected", {
	  enumerable: true,
	  get: function get() {
	    return _TabUnselected.default;
	  }
	});
	Object.defineProperty(exports, "TabUnselectedOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TabUnselectedOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TabUnselectedRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TabUnselectedRounded.default;
	  }
	});
	Object.defineProperty(exports, "TabUnselectedSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TabUnselectedSharp.default;
	  }
	});
	Object.defineProperty(exports, "TabUnselectedTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TabUnselectedTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TagFaces", {
	  enumerable: true,
	  get: function get() {
	    return _TagFaces.default;
	  }
	});
	Object.defineProperty(exports, "TagFacesOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TagFacesOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TagFacesRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TagFacesRounded.default;
	  }
	});
	Object.defineProperty(exports, "TagFacesSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TagFacesSharp.default;
	  }
	});
	Object.defineProperty(exports, "TagFacesTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TagFacesTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TapAndPlay", {
	  enumerable: true,
	  get: function get() {
	    return _TapAndPlay.default;
	  }
	});
	Object.defineProperty(exports, "TapAndPlayOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TapAndPlayOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TapAndPlayRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TapAndPlayRounded.default;
	  }
	});
	Object.defineProperty(exports, "TapAndPlaySharp", {
	  enumerable: true,
	  get: function get() {
	    return _TapAndPlaySharp.default;
	  }
	});
	Object.defineProperty(exports, "TapAndPlayTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TapAndPlayTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Telegram", {
	  enumerable: true,
	  get: function get() {
	    return _Telegram.default;
	  }
	});
	Object.defineProperty(exports, "Terrain", {
	  enumerable: true,
	  get: function get() {
	    return _Terrain.default;
	  }
	});
	Object.defineProperty(exports, "TerrainOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TerrainOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TerrainRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TerrainRounded.default;
	  }
	});
	Object.defineProperty(exports, "TerrainSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TerrainSharp.default;
	  }
	});
	Object.defineProperty(exports, "TerrainTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TerrainTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TextFields", {
	  enumerable: true,
	  get: function get() {
	    return _TextFields.default;
	  }
	});
	Object.defineProperty(exports, "TextFieldsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TextFieldsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TextFieldsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TextFieldsRounded.default;
	  }
	});
	Object.defineProperty(exports, "TextFieldsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TextFieldsSharp.default;
	  }
	});
	Object.defineProperty(exports, "TextFieldsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TextFieldsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TextFormat", {
	  enumerable: true,
	  get: function get() {
	    return _TextFormat.default;
	  }
	});
	Object.defineProperty(exports, "TextFormatOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TextFormatOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TextFormatRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TextFormatRounded.default;
	  }
	});
	Object.defineProperty(exports, "TextFormatSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TextFormatSharp.default;
	  }
	});
	Object.defineProperty(exports, "TextFormatTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TextFormatTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TextRotateUp", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotateUp.default;
	  }
	});
	Object.defineProperty(exports, "TextRotateUpOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotateUpOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TextRotateUpRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotateUpRounded.default;
	  }
	});
	Object.defineProperty(exports, "TextRotateUpSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotateUpSharp.default;
	  }
	});
	Object.defineProperty(exports, "TextRotateUpTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotateUpTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TextRotateVertical", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotateVertical.default;
	  }
	});
	Object.defineProperty(exports, "TextRotateVerticalOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotateVerticalOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TextRotateVerticalRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotateVerticalRounded.default;
	  }
	});
	Object.defineProperty(exports, "TextRotateVerticalSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotateVerticalSharp.default;
	  }
	});
	Object.defineProperty(exports, "TextRotateVerticalTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotateVerticalTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TextRotationAngledown", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotationAngledown.default;
	  }
	});
	Object.defineProperty(exports, "TextRotationAngledownOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotationAngledownOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TextRotationAngledownRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotationAngledownRounded.default;
	  }
	});
	Object.defineProperty(exports, "TextRotationAngledownSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotationAngledownSharp.default;
	  }
	});
	Object.defineProperty(exports, "TextRotationAngledownTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotationAngledownTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TextRotationAngleup", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotationAngleup.default;
	  }
	});
	Object.defineProperty(exports, "TextRotationAngleupOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotationAngleupOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TextRotationAngleupRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotationAngleupRounded.default;
	  }
	});
	Object.defineProperty(exports, "TextRotationAngleupSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotationAngleupSharp.default;
	  }
	});
	Object.defineProperty(exports, "TextRotationAngleupTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotationAngleupTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TextRotationDown", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotationDown.default;
	  }
	});
	Object.defineProperty(exports, "TextRotationDownOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotationDownOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TextRotationDownRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotationDownRounded.default;
	  }
	});
	Object.defineProperty(exports, "TextRotationDownSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotationDownSharp.default;
	  }
	});
	Object.defineProperty(exports, "TextRotationDownTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotationDownTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TextRotationNone", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotationNone.default;
	  }
	});
	Object.defineProperty(exports, "TextRotationNoneOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotationNoneOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TextRotationNoneRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotationNoneRounded.default;
	  }
	});
	Object.defineProperty(exports, "TextRotationNoneSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotationNoneSharp.default;
	  }
	});
	Object.defineProperty(exports, "TextRotationNoneTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TextRotationNoneTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Textsms", {
	  enumerable: true,
	  get: function get() {
	    return _Textsms.default;
	  }
	});
	Object.defineProperty(exports, "TextsmsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TextsmsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TextsmsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TextsmsRounded.default;
	  }
	});
	Object.defineProperty(exports, "TextsmsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TextsmsSharp.default;
	  }
	});
	Object.defineProperty(exports, "TextsmsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TextsmsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Texture", {
	  enumerable: true,
	  get: function get() {
	    return _Texture.default;
	  }
	});
	Object.defineProperty(exports, "TextureOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TextureOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TextureRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TextureRounded.default;
	  }
	});
	Object.defineProperty(exports, "TextureSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TextureSharp.default;
	  }
	});
	Object.defineProperty(exports, "TextureTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TextureTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Theaters", {
	  enumerable: true,
	  get: function get() {
	    return _Theaters.default;
	  }
	});
	Object.defineProperty(exports, "TheatersOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TheatersOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TheatersRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TheatersRounded.default;
	  }
	});
	Object.defineProperty(exports, "TheatersSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TheatersSharp.default;
	  }
	});
	Object.defineProperty(exports, "TheatersTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TheatersTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ThreeDRotation", {
	  enumerable: true,
	  get: function get() {
	    return _ThreeDRotation.default;
	  }
	});
	Object.defineProperty(exports, "ThreeDRotationOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ThreeDRotationOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ThreeDRotationRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ThreeDRotationRounded.default;
	  }
	});
	Object.defineProperty(exports, "ThreeDRotationSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ThreeDRotationSharp.default;
	  }
	});
	Object.defineProperty(exports, "ThreeDRotationTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ThreeDRotationTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ThreeSixty", {
	  enumerable: true,
	  get: function get() {
	    return _ThreeSixty.default;
	  }
	});
	Object.defineProperty(exports, "ThreeSixtyOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ThreeSixtyOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ThreeSixtyRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ThreeSixtyRounded.default;
	  }
	});
	Object.defineProperty(exports, "ThreeSixtySharp", {
	  enumerable: true,
	  get: function get() {
	    return _ThreeSixtySharp.default;
	  }
	});
	Object.defineProperty(exports, "ThreeSixtyTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ThreeSixtyTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ThumbDown", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbDown.default;
	  }
	});
	Object.defineProperty(exports, "ThumbDownAlt", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbDownAlt.default;
	  }
	});
	Object.defineProperty(exports, "ThumbDownAltOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbDownAltOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ThumbDownAltRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbDownAltRounded.default;
	  }
	});
	Object.defineProperty(exports, "ThumbDownAltSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbDownAltSharp.default;
	  }
	});
	Object.defineProperty(exports, "ThumbDownAltTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbDownAltTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ThumbDownOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbDownOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ThumbDownRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbDownRounded.default;
	  }
	});
	Object.defineProperty(exports, "ThumbDownSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbDownSharp.default;
	  }
	});
	Object.defineProperty(exports, "ThumbDownTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbDownTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ThumbsUpDown", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbsUpDown.default;
	  }
	});
	Object.defineProperty(exports, "ThumbsUpDownOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbsUpDownOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ThumbsUpDownRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbsUpDownRounded.default;
	  }
	});
	Object.defineProperty(exports, "ThumbsUpDownSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbsUpDownSharp.default;
	  }
	});
	Object.defineProperty(exports, "ThumbsUpDownTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbsUpDownTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ThumbUp", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbUp.default;
	  }
	});
	Object.defineProperty(exports, "ThumbUpAlt", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbUpAlt.default;
	  }
	});
	Object.defineProperty(exports, "ThumbUpAltOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbUpAltOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ThumbUpAltRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbUpAltRounded.default;
	  }
	});
	Object.defineProperty(exports, "ThumbUpAltSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbUpAltSharp.default;
	  }
	});
	Object.defineProperty(exports, "ThumbUpAltTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbUpAltTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ThumbUpOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbUpOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ThumbUpRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbUpRounded.default;
	  }
	});
	Object.defineProperty(exports, "ThumbUpSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbUpSharp.default;
	  }
	});
	Object.defineProperty(exports, "ThumbUpTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ThumbUpTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Timelapse", {
	  enumerable: true,
	  get: function get() {
	    return _Timelapse.default;
	  }
	});
	Object.defineProperty(exports, "TimelapseOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TimelapseOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TimelapseRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TimelapseRounded.default;
	  }
	});
	Object.defineProperty(exports, "TimelapseSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TimelapseSharp.default;
	  }
	});
	Object.defineProperty(exports, "TimelapseTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TimelapseTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Timeline", {
	  enumerable: true,
	  get: function get() {
	    return _Timeline.default;
	  }
	});
	Object.defineProperty(exports, "TimelineOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TimelineOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TimelineRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TimelineRounded.default;
	  }
	});
	Object.defineProperty(exports, "TimelineSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TimelineSharp.default;
	  }
	});
	Object.defineProperty(exports, "TimelineTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TimelineTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Timer", {
	  enumerable: true,
	  get: function get() {
	    return _Timer.default;
	  }
	});
	Object.defineProperty(exports, "Timer10", {
	  enumerable: true,
	  get: function get() {
	    return _Timer2.default;
	  }
	});
	Object.defineProperty(exports, "Timer10Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Timer10Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Timer10Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Timer10Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Timer10Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Timer10Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Timer10TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Timer10TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Timer3", {
	  enumerable: true,
	  get: function get() {
	    return _Timer3.default;
	  }
	});
	Object.defineProperty(exports, "Timer3Outlined", {
	  enumerable: true,
	  get: function get() {
	    return _Timer3Outlined.default;
	  }
	});
	Object.defineProperty(exports, "Timer3Rounded", {
	  enumerable: true,
	  get: function get() {
	    return _Timer3Rounded.default;
	  }
	});
	Object.defineProperty(exports, "Timer3Sharp", {
	  enumerable: true,
	  get: function get() {
	    return _Timer3Sharp.default;
	  }
	});
	Object.defineProperty(exports, "Timer3TwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _Timer3TwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TimerOff", {
	  enumerable: true,
	  get: function get() {
	    return _TimerOff.default;
	  }
	});
	Object.defineProperty(exports, "TimerOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TimerOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TimerOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TimerOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "TimerOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TimerOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "TimerOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TimerOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TimerOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TimerOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TimerRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TimerRounded.default;
	  }
	});
	Object.defineProperty(exports, "TimerSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TimerSharp.default;
	  }
	});
	Object.defineProperty(exports, "TimerTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TimerTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TimeToLeave", {
	  enumerable: true,
	  get: function get() {
	    return _TimeToLeave.default;
	  }
	});
	Object.defineProperty(exports, "TimeToLeaveOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TimeToLeaveOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TimeToLeaveRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TimeToLeaveRounded.default;
	  }
	});
	Object.defineProperty(exports, "TimeToLeaveSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TimeToLeaveSharp.default;
	  }
	});
	Object.defineProperty(exports, "TimeToLeaveTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TimeToLeaveTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Title", {
	  enumerable: true,
	  get: function get() {
	    return _Title.default;
	  }
	});
	Object.defineProperty(exports, "TitleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TitleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TitleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TitleRounded.default;
	  }
	});
	Object.defineProperty(exports, "TitleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TitleSharp.default;
	  }
	});
	Object.defineProperty(exports, "TitleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TitleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Toc", {
	  enumerable: true,
	  get: function get() {
	    return _Toc.default;
	  }
	});
	Object.defineProperty(exports, "TocOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TocOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TocRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TocRounded.default;
	  }
	});
	Object.defineProperty(exports, "TocSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TocSharp.default;
	  }
	});
	Object.defineProperty(exports, "TocTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TocTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Today", {
	  enumerable: true,
	  get: function get() {
	    return _Today.default;
	  }
	});
	Object.defineProperty(exports, "TodayOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TodayOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TodayRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TodayRounded.default;
	  }
	});
	Object.defineProperty(exports, "TodaySharp", {
	  enumerable: true,
	  get: function get() {
	    return _TodaySharp.default;
	  }
	});
	Object.defineProperty(exports, "TodayTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TodayTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ToggleOff", {
	  enumerable: true,
	  get: function get() {
	    return _ToggleOff.default;
	  }
	});
	Object.defineProperty(exports, "ToggleOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ToggleOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ToggleOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ToggleOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "ToggleOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ToggleOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "ToggleOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ToggleOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ToggleOn", {
	  enumerable: true,
	  get: function get() {
	    return _ToggleOn.default;
	  }
	});
	Object.defineProperty(exports, "ToggleOnOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ToggleOnOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ToggleOnRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ToggleOnRounded.default;
	  }
	});
	Object.defineProperty(exports, "ToggleOnSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ToggleOnSharp.default;
	  }
	});
	Object.defineProperty(exports, "ToggleOnTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ToggleOnTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Toll", {
	  enumerable: true,
	  get: function get() {
	    return _Toll.default;
	  }
	});
	Object.defineProperty(exports, "TollOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TollOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TollRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TollRounded.default;
	  }
	});
	Object.defineProperty(exports, "TollSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TollSharp.default;
	  }
	});
	Object.defineProperty(exports, "TollTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TollTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Tonality", {
	  enumerable: true,
	  get: function get() {
	    return _Tonality.default;
	  }
	});
	Object.defineProperty(exports, "TonalityOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TonalityOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TonalityRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TonalityRounded.default;
	  }
	});
	Object.defineProperty(exports, "TonalitySharp", {
	  enumerable: true,
	  get: function get() {
	    return _TonalitySharp.default;
	  }
	});
	Object.defineProperty(exports, "TonalityTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TonalityTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TouchApp", {
	  enumerable: true,
	  get: function get() {
	    return _TouchApp.default;
	  }
	});
	Object.defineProperty(exports, "TouchAppOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TouchAppOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TouchAppRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TouchAppRounded.default;
	  }
	});
	Object.defineProperty(exports, "TouchAppSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TouchAppSharp.default;
	  }
	});
	Object.defineProperty(exports, "TouchAppTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TouchAppTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Toys", {
	  enumerable: true,
	  get: function get() {
	    return _Toys.default;
	  }
	});
	Object.defineProperty(exports, "ToysOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ToysOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ToysRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ToysRounded.default;
	  }
	});
	Object.defineProperty(exports, "ToysSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ToysSharp.default;
	  }
	});
	Object.defineProperty(exports, "ToysTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ToysTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TrackChanges", {
	  enumerable: true,
	  get: function get() {
	    return _TrackChanges.default;
	  }
	});
	Object.defineProperty(exports, "TrackChangesOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TrackChangesOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TrackChangesRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TrackChangesRounded.default;
	  }
	});
	Object.defineProperty(exports, "TrackChangesSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TrackChangesSharp.default;
	  }
	});
	Object.defineProperty(exports, "TrackChangesTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TrackChangesTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Traffic", {
	  enumerable: true,
	  get: function get() {
	    return _Traffic.default;
	  }
	});
	Object.defineProperty(exports, "TrafficOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TrafficOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TrafficRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TrafficRounded.default;
	  }
	});
	Object.defineProperty(exports, "TrafficSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TrafficSharp.default;
	  }
	});
	Object.defineProperty(exports, "TrafficTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TrafficTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Train", {
	  enumerable: true,
	  get: function get() {
	    return _Train.default;
	  }
	});
	Object.defineProperty(exports, "TrainOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TrainOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TrainRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TrainRounded.default;
	  }
	});
	Object.defineProperty(exports, "TrainSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TrainSharp.default;
	  }
	});
	Object.defineProperty(exports, "TrainTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TrainTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Tram", {
	  enumerable: true,
	  get: function get() {
	    return _Tram.default;
	  }
	});
	Object.defineProperty(exports, "TramOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TramOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TramRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TramRounded.default;
	  }
	});
	Object.defineProperty(exports, "TramSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TramSharp.default;
	  }
	});
	Object.defineProperty(exports, "TramTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TramTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TransferWithinAStation", {
	  enumerable: true,
	  get: function get() {
	    return _TransferWithinAStation.default;
	  }
	});
	Object.defineProperty(exports, "TransferWithinAStationOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TransferWithinAStationOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TransferWithinAStationRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TransferWithinAStationRounded.default;
	  }
	});
	Object.defineProperty(exports, "TransferWithinAStationSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TransferWithinAStationSharp.default;
	  }
	});
	Object.defineProperty(exports, "TransferWithinAStationTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TransferWithinAStationTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Transform", {
	  enumerable: true,
	  get: function get() {
	    return _Transform.default;
	  }
	});
	Object.defineProperty(exports, "TransformOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TransformOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TransformRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TransformRounded.default;
	  }
	});
	Object.defineProperty(exports, "TransformSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TransformSharp.default;
	  }
	});
	Object.defineProperty(exports, "TransformTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TransformTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TransitEnterexit", {
	  enumerable: true,
	  get: function get() {
	    return _TransitEnterexit.default;
	  }
	});
	Object.defineProperty(exports, "TransitEnterexitOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TransitEnterexitOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TransitEnterexitRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TransitEnterexitRounded.default;
	  }
	});
	Object.defineProperty(exports, "TransitEnterexitSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TransitEnterexitSharp.default;
	  }
	});
	Object.defineProperty(exports, "TransitEnterexitTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TransitEnterexitTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Translate", {
	  enumerable: true,
	  get: function get() {
	    return _Translate.default;
	  }
	});
	Object.defineProperty(exports, "TranslateOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TranslateOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TranslateRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TranslateRounded.default;
	  }
	});
	Object.defineProperty(exports, "TranslateSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TranslateSharp.default;
	  }
	});
	Object.defineProperty(exports, "TranslateTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TranslateTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TrendingDown", {
	  enumerable: true,
	  get: function get() {
	    return _TrendingDown.default;
	  }
	});
	Object.defineProperty(exports, "TrendingDownOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TrendingDownOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TrendingDownRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TrendingDownRounded.default;
	  }
	});
	Object.defineProperty(exports, "TrendingDownSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TrendingDownSharp.default;
	  }
	});
	Object.defineProperty(exports, "TrendingDownTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TrendingDownTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TrendingFlat", {
	  enumerable: true,
	  get: function get() {
	    return _TrendingFlat.default;
	  }
	});
	Object.defineProperty(exports, "TrendingFlatOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TrendingFlatOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TrendingFlatRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TrendingFlatRounded.default;
	  }
	});
	Object.defineProperty(exports, "TrendingFlatSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TrendingFlatSharp.default;
	  }
	});
	Object.defineProperty(exports, "TrendingFlatTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TrendingFlatTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TrendingUp", {
	  enumerable: true,
	  get: function get() {
	    return _TrendingUp.default;
	  }
	});
	Object.defineProperty(exports, "TrendingUpOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TrendingUpOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TrendingUpRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TrendingUpRounded.default;
	  }
	});
	Object.defineProperty(exports, "TrendingUpSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TrendingUpSharp.default;
	  }
	});
	Object.defineProperty(exports, "TrendingUpTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TrendingUpTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TripOrigin", {
	  enumerable: true,
	  get: function get() {
	    return _TripOrigin.default;
	  }
	});
	Object.defineProperty(exports, "TripOriginOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TripOriginOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TripOriginRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TripOriginRounded.default;
	  }
	});
	Object.defineProperty(exports, "TripOriginSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TripOriginSharp.default;
	  }
	});
	Object.defineProperty(exports, "TripOriginTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TripOriginTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Tune", {
	  enumerable: true,
	  get: function get() {
	    return _Tune.default;
	  }
	});
	Object.defineProperty(exports, "TuneOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TuneOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TuneRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TuneRounded.default;
	  }
	});
	Object.defineProperty(exports, "TuneSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TuneSharp.default;
	  }
	});
	Object.defineProperty(exports, "TuneTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TuneTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TurnedIn", {
	  enumerable: true,
	  get: function get() {
	    return _TurnedIn.default;
	  }
	});
	Object.defineProperty(exports, "TurnedInNot", {
	  enumerable: true,
	  get: function get() {
	    return _TurnedInNot.default;
	  }
	});
	Object.defineProperty(exports, "TurnedInNotOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TurnedInNotOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TurnedInNotRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TurnedInNotRounded.default;
	  }
	});
	Object.defineProperty(exports, "TurnedInNotSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TurnedInNotSharp.default;
	  }
	});
	Object.defineProperty(exports, "TurnedInNotTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TurnedInNotTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TurnedInOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TurnedInOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TurnedInRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TurnedInRounded.default;
	  }
	});
	Object.defineProperty(exports, "TurnedInSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TurnedInSharp.default;
	  }
	});
	Object.defineProperty(exports, "TurnedInTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TurnedInTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Tv", {
	  enumerable: true,
	  get: function get() {
	    return _Tv.default;
	  }
	});
	Object.defineProperty(exports, "TvOff", {
	  enumerable: true,
	  get: function get() {
	    return _TvOff.default;
	  }
	});
	Object.defineProperty(exports, "TvOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TvOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TvOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TvOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "TvOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TvOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "TvOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TvOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "TvOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _TvOutlined.default;
	  }
	});
	Object.defineProperty(exports, "TvRounded", {
	  enumerable: true,
	  get: function get() {
	    return _TvRounded.default;
	  }
	});
	Object.defineProperty(exports, "TvSharp", {
	  enumerable: true,
	  get: function get() {
	    return _TvSharp.default;
	  }
	});
	Object.defineProperty(exports, "TvTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _TvTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Twitter", {
	  enumerable: true,
	  get: function get() {
	    return _Twitter.default;
	  }
	});
	Object.defineProperty(exports, "Unarchive", {
	  enumerable: true,
	  get: function get() {
	    return _Unarchive.default;
	  }
	});
	Object.defineProperty(exports, "UnarchiveOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _UnarchiveOutlined.default;
	  }
	});
	Object.defineProperty(exports, "UnarchiveRounded", {
	  enumerable: true,
	  get: function get() {
	    return _UnarchiveRounded.default;
	  }
	});
	Object.defineProperty(exports, "UnarchiveSharp", {
	  enumerable: true,
	  get: function get() {
	    return _UnarchiveSharp.default;
	  }
	});
	Object.defineProperty(exports, "UnarchiveTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _UnarchiveTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Undo", {
	  enumerable: true,
	  get: function get() {
	    return _Undo.default;
	  }
	});
	Object.defineProperty(exports, "UndoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _UndoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "UndoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _UndoRounded.default;
	  }
	});
	Object.defineProperty(exports, "UndoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _UndoSharp.default;
	  }
	});
	Object.defineProperty(exports, "UndoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _UndoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "UnfoldLess", {
	  enumerable: true,
	  get: function get() {
	    return _UnfoldLess.default;
	  }
	});
	Object.defineProperty(exports, "UnfoldLessOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _UnfoldLessOutlined.default;
	  }
	});
	Object.defineProperty(exports, "UnfoldLessRounded", {
	  enumerable: true,
	  get: function get() {
	    return _UnfoldLessRounded.default;
	  }
	});
	Object.defineProperty(exports, "UnfoldLessSharp", {
	  enumerable: true,
	  get: function get() {
	    return _UnfoldLessSharp.default;
	  }
	});
	Object.defineProperty(exports, "UnfoldLessTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _UnfoldLessTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "UnfoldMore", {
	  enumerable: true,
	  get: function get() {
	    return _UnfoldMore.default;
	  }
	});
	Object.defineProperty(exports, "UnfoldMoreOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _UnfoldMoreOutlined.default;
	  }
	});
	Object.defineProperty(exports, "UnfoldMoreRounded", {
	  enumerable: true,
	  get: function get() {
	    return _UnfoldMoreRounded.default;
	  }
	});
	Object.defineProperty(exports, "UnfoldMoreSharp", {
	  enumerable: true,
	  get: function get() {
	    return _UnfoldMoreSharp.default;
	  }
	});
	Object.defineProperty(exports, "UnfoldMoreTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _UnfoldMoreTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Unsubscribe", {
	  enumerable: true,
	  get: function get() {
	    return _Unsubscribe.default;
	  }
	});
	Object.defineProperty(exports, "UnsubscribeOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _UnsubscribeOutlined.default;
	  }
	});
	Object.defineProperty(exports, "UnsubscribeRounded", {
	  enumerable: true,
	  get: function get() {
	    return _UnsubscribeRounded.default;
	  }
	});
	Object.defineProperty(exports, "UnsubscribeSharp", {
	  enumerable: true,
	  get: function get() {
	    return _UnsubscribeSharp.default;
	  }
	});
	Object.defineProperty(exports, "UnsubscribeTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _UnsubscribeTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Update", {
	  enumerable: true,
	  get: function get() {
	    return _Update.default;
	  }
	});
	Object.defineProperty(exports, "UpdateOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _UpdateOutlined.default;
	  }
	});
	Object.defineProperty(exports, "UpdateRounded", {
	  enumerable: true,
	  get: function get() {
	    return _UpdateRounded.default;
	  }
	});
	Object.defineProperty(exports, "UpdateSharp", {
	  enumerable: true,
	  get: function get() {
	    return _UpdateSharp.default;
	  }
	});
	Object.defineProperty(exports, "UpdateTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _UpdateTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Usb", {
	  enumerable: true,
	  get: function get() {
	    return _Usb.default;
	  }
	});
	Object.defineProperty(exports, "UsbOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _UsbOutlined.default;
	  }
	});
	Object.defineProperty(exports, "UsbRounded", {
	  enumerable: true,
	  get: function get() {
	    return _UsbRounded.default;
	  }
	});
	Object.defineProperty(exports, "UsbSharp", {
	  enumerable: true,
	  get: function get() {
	    return _UsbSharp.default;
	  }
	});
	Object.defineProperty(exports, "UsbTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _UsbTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "VerifiedUser", {
	  enumerable: true,
	  get: function get() {
	    return _VerifiedUser.default;
	  }
	});
	Object.defineProperty(exports, "VerifiedUserOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VerifiedUserOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VerifiedUserRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VerifiedUserRounded.default;
	  }
	});
	Object.defineProperty(exports, "VerifiedUserSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VerifiedUserSharp.default;
	  }
	});
	Object.defineProperty(exports, "VerifiedUserTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VerifiedUserTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "VerticalAlignBottom", {
	  enumerable: true,
	  get: function get() {
	    return _VerticalAlignBottom.default;
	  }
	});
	Object.defineProperty(exports, "VerticalAlignBottomOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VerticalAlignBottomOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VerticalAlignBottomRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VerticalAlignBottomRounded.default;
	  }
	});
	Object.defineProperty(exports, "VerticalAlignBottomSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VerticalAlignBottomSharp.default;
	  }
	});
	Object.defineProperty(exports, "VerticalAlignBottomTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VerticalAlignBottomTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "VerticalAlignCenter", {
	  enumerable: true,
	  get: function get() {
	    return _VerticalAlignCenter.default;
	  }
	});
	Object.defineProperty(exports, "VerticalAlignCenterOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VerticalAlignCenterOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VerticalAlignCenterRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VerticalAlignCenterRounded.default;
	  }
	});
	Object.defineProperty(exports, "VerticalAlignCenterSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VerticalAlignCenterSharp.default;
	  }
	});
	Object.defineProperty(exports, "VerticalAlignCenterTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VerticalAlignCenterTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "VerticalAlignTop", {
	  enumerable: true,
	  get: function get() {
	    return _VerticalAlignTop.default;
	  }
	});
	Object.defineProperty(exports, "VerticalAlignTopOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VerticalAlignTopOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VerticalAlignTopRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VerticalAlignTopRounded.default;
	  }
	});
	Object.defineProperty(exports, "VerticalAlignTopSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VerticalAlignTopSharp.default;
	  }
	});
	Object.defineProperty(exports, "VerticalAlignTopTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VerticalAlignTopTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "VerticalSplit", {
	  enumerable: true,
	  get: function get() {
	    return _VerticalSplit.default;
	  }
	});
	Object.defineProperty(exports, "VerticalSplitOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VerticalSplitOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VerticalSplitRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VerticalSplitRounded.default;
	  }
	});
	Object.defineProperty(exports, "VerticalSplitSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VerticalSplitSharp.default;
	  }
	});
	Object.defineProperty(exports, "VerticalSplitTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VerticalSplitTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Vibration", {
	  enumerable: true,
	  get: function get() {
	    return _Vibration.default;
	  }
	});
	Object.defineProperty(exports, "VibrationOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VibrationOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VibrationRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VibrationRounded.default;
	  }
	});
	Object.defineProperty(exports, "VibrationSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VibrationSharp.default;
	  }
	});
	Object.defineProperty(exports, "VibrationTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VibrationTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "VideoCall", {
	  enumerable: true,
	  get: function get() {
	    return _VideoCall.default;
	  }
	});
	Object.defineProperty(exports, "VideoCallOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VideoCallOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VideoCallRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VideoCallRounded.default;
	  }
	});
	Object.defineProperty(exports, "VideoCallSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VideoCallSharp.default;
	  }
	});
	Object.defineProperty(exports, "VideoCallTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VideoCallTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Videocam", {
	  enumerable: true,
	  get: function get() {
	    return _Videocam.default;
	  }
	});
	Object.defineProperty(exports, "VideocamOff", {
	  enumerable: true,
	  get: function get() {
	    return _VideocamOff.default;
	  }
	});
	Object.defineProperty(exports, "VideocamOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VideocamOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VideocamOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VideocamOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "VideocamOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VideocamOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "VideocamOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VideocamOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "VideocamOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VideocamOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VideocamRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VideocamRounded.default;
	  }
	});
	Object.defineProperty(exports, "VideocamSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VideocamSharp.default;
	  }
	});
	Object.defineProperty(exports, "VideocamTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VideocamTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "VideogameAsset", {
	  enumerable: true,
	  get: function get() {
	    return _VideogameAsset.default;
	  }
	});
	Object.defineProperty(exports, "VideogameAssetOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VideogameAssetOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VideogameAssetRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VideogameAssetRounded.default;
	  }
	});
	Object.defineProperty(exports, "VideogameAssetSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VideogameAssetSharp.default;
	  }
	});
	Object.defineProperty(exports, "VideogameAssetTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VideogameAssetTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "VideoLabel", {
	  enumerable: true,
	  get: function get() {
	    return _VideoLabel.default;
	  }
	});
	Object.defineProperty(exports, "VideoLabelOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VideoLabelOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VideoLabelRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VideoLabelRounded.default;
	  }
	});
	Object.defineProperty(exports, "VideoLabelSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VideoLabelSharp.default;
	  }
	});
	Object.defineProperty(exports, "VideoLabelTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VideoLabelTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "VideoLibrary", {
	  enumerable: true,
	  get: function get() {
	    return _VideoLibrary.default;
	  }
	});
	Object.defineProperty(exports, "VideoLibraryOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VideoLibraryOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VideoLibraryRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VideoLibraryRounded.default;
	  }
	});
	Object.defineProperty(exports, "VideoLibrarySharp", {
	  enumerable: true,
	  get: function get() {
	    return _VideoLibrarySharp.default;
	  }
	});
	Object.defineProperty(exports, "VideoLibraryTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VideoLibraryTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ViewAgenda", {
	  enumerable: true,
	  get: function get() {
	    return _ViewAgenda.default;
	  }
	});
	Object.defineProperty(exports, "ViewAgendaOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ViewAgendaOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ViewAgendaRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ViewAgendaRounded.default;
	  }
	});
	Object.defineProperty(exports, "ViewAgendaSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ViewAgendaSharp.default;
	  }
	});
	Object.defineProperty(exports, "ViewAgendaTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ViewAgendaTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ViewArray", {
	  enumerable: true,
	  get: function get() {
	    return _ViewArray.default;
	  }
	});
	Object.defineProperty(exports, "ViewArrayOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ViewArrayOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ViewArrayRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ViewArrayRounded.default;
	  }
	});
	Object.defineProperty(exports, "ViewArraySharp", {
	  enumerable: true,
	  get: function get() {
	    return _ViewArraySharp.default;
	  }
	});
	Object.defineProperty(exports, "ViewArrayTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ViewArrayTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ViewCarousel", {
	  enumerable: true,
	  get: function get() {
	    return _ViewCarousel.default;
	  }
	});
	Object.defineProperty(exports, "ViewCarouselOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ViewCarouselOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ViewCarouselRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ViewCarouselRounded.default;
	  }
	});
	Object.defineProperty(exports, "ViewCarouselSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ViewCarouselSharp.default;
	  }
	});
	Object.defineProperty(exports, "ViewCarouselTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ViewCarouselTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ViewColumn", {
	  enumerable: true,
	  get: function get() {
	    return _ViewColumn.default;
	  }
	});
	Object.defineProperty(exports, "ViewColumnOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ViewColumnOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ViewColumnRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ViewColumnRounded.default;
	  }
	});
	Object.defineProperty(exports, "ViewColumnSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ViewColumnSharp.default;
	  }
	});
	Object.defineProperty(exports, "ViewColumnTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ViewColumnTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ViewComfy", {
	  enumerable: true,
	  get: function get() {
	    return _ViewComfy.default;
	  }
	});
	Object.defineProperty(exports, "ViewComfyOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ViewComfyOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ViewComfyRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ViewComfyRounded.default;
	  }
	});
	Object.defineProperty(exports, "ViewComfySharp", {
	  enumerable: true,
	  get: function get() {
	    return _ViewComfySharp.default;
	  }
	});
	Object.defineProperty(exports, "ViewComfyTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ViewComfyTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ViewCompact", {
	  enumerable: true,
	  get: function get() {
	    return _ViewCompact.default;
	  }
	});
	Object.defineProperty(exports, "ViewCompactOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ViewCompactOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ViewCompactRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ViewCompactRounded.default;
	  }
	});
	Object.defineProperty(exports, "ViewCompactSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ViewCompactSharp.default;
	  }
	});
	Object.defineProperty(exports, "ViewCompactTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ViewCompactTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ViewDay", {
	  enumerable: true,
	  get: function get() {
	    return _ViewDay.default;
	  }
	});
	Object.defineProperty(exports, "ViewDayOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ViewDayOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ViewDayRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ViewDayRounded.default;
	  }
	});
	Object.defineProperty(exports, "ViewDaySharp", {
	  enumerable: true,
	  get: function get() {
	    return _ViewDaySharp.default;
	  }
	});
	Object.defineProperty(exports, "ViewDayTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ViewDayTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ViewHeadline", {
	  enumerable: true,
	  get: function get() {
	    return _ViewHeadline.default;
	  }
	});
	Object.defineProperty(exports, "ViewHeadlineOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ViewHeadlineOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ViewHeadlineRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ViewHeadlineRounded.default;
	  }
	});
	Object.defineProperty(exports, "ViewHeadlineSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ViewHeadlineSharp.default;
	  }
	});
	Object.defineProperty(exports, "ViewHeadlineTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ViewHeadlineTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ViewList", {
	  enumerable: true,
	  get: function get() {
	    return _ViewList.default;
	  }
	});
	Object.defineProperty(exports, "ViewListOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ViewListOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ViewListRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ViewListRounded.default;
	  }
	});
	Object.defineProperty(exports, "ViewListSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ViewListSharp.default;
	  }
	});
	Object.defineProperty(exports, "ViewListTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ViewListTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ViewModule", {
	  enumerable: true,
	  get: function get() {
	    return _ViewModule.default;
	  }
	});
	Object.defineProperty(exports, "ViewModuleOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ViewModuleOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ViewModuleRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ViewModuleRounded.default;
	  }
	});
	Object.defineProperty(exports, "ViewModuleSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ViewModuleSharp.default;
	  }
	});
	Object.defineProperty(exports, "ViewModuleTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ViewModuleTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ViewQuilt", {
	  enumerable: true,
	  get: function get() {
	    return _ViewQuilt.default;
	  }
	});
	Object.defineProperty(exports, "ViewQuiltOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ViewQuiltOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ViewQuiltRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ViewQuiltRounded.default;
	  }
	});
	Object.defineProperty(exports, "ViewQuiltSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ViewQuiltSharp.default;
	  }
	});
	Object.defineProperty(exports, "ViewQuiltTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ViewQuiltTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ViewStream", {
	  enumerable: true,
	  get: function get() {
	    return _ViewStream.default;
	  }
	});
	Object.defineProperty(exports, "ViewStreamOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ViewStreamOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ViewStreamRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ViewStreamRounded.default;
	  }
	});
	Object.defineProperty(exports, "ViewStreamSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ViewStreamSharp.default;
	  }
	});
	Object.defineProperty(exports, "ViewStreamTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ViewStreamTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ViewWeek", {
	  enumerable: true,
	  get: function get() {
	    return _ViewWeek.default;
	  }
	});
	Object.defineProperty(exports, "ViewWeekOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ViewWeekOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ViewWeekRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ViewWeekRounded.default;
	  }
	});
	Object.defineProperty(exports, "ViewWeekSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ViewWeekSharp.default;
	  }
	});
	Object.defineProperty(exports, "ViewWeekTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ViewWeekTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Vignette", {
	  enumerable: true,
	  get: function get() {
	    return _Vignette.default;
	  }
	});
	Object.defineProperty(exports, "VignetteOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VignetteOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VignetteRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VignetteRounded.default;
	  }
	});
	Object.defineProperty(exports, "VignetteSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VignetteSharp.default;
	  }
	});
	Object.defineProperty(exports, "VignetteTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VignetteTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Visibility", {
	  enumerable: true,
	  get: function get() {
	    return _Visibility.default;
	  }
	});
	Object.defineProperty(exports, "VisibilityOff", {
	  enumerable: true,
	  get: function get() {
	    return _VisibilityOff.default;
	  }
	});
	Object.defineProperty(exports, "VisibilityOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VisibilityOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VisibilityOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VisibilityOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "VisibilityOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VisibilityOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "VisibilityOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VisibilityOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "VisibilityOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VisibilityOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VisibilityRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VisibilityRounded.default;
	  }
	});
	Object.defineProperty(exports, "VisibilitySharp", {
	  enumerable: true,
	  get: function get() {
	    return _VisibilitySharp.default;
	  }
	});
	Object.defineProperty(exports, "VisibilityTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VisibilityTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "VoiceChat", {
	  enumerable: true,
	  get: function get() {
	    return _VoiceChat.default;
	  }
	});
	Object.defineProperty(exports, "VoiceChatOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VoiceChatOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VoiceChatRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VoiceChatRounded.default;
	  }
	});
	Object.defineProperty(exports, "VoiceChatSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VoiceChatSharp.default;
	  }
	});
	Object.defineProperty(exports, "VoiceChatTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VoiceChatTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Voicemail", {
	  enumerable: true,
	  get: function get() {
	    return _Voicemail.default;
	  }
	});
	Object.defineProperty(exports, "VoicemailOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VoicemailOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VoicemailRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VoicemailRounded.default;
	  }
	});
	Object.defineProperty(exports, "VoicemailSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VoicemailSharp.default;
	  }
	});
	Object.defineProperty(exports, "VoicemailTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VoicemailTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "VoiceOverOff", {
	  enumerable: true,
	  get: function get() {
	    return _VoiceOverOff.default;
	  }
	});
	Object.defineProperty(exports, "VoiceOverOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VoiceOverOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VoiceOverOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VoiceOverOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "VoiceOverOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VoiceOverOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "VoiceOverOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VoiceOverOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "VolumeDown", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeDown.default;
	  }
	});
	Object.defineProperty(exports, "VolumeDownOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeDownOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VolumeDownRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeDownRounded.default;
	  }
	});
	Object.defineProperty(exports, "VolumeDownSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeDownSharp.default;
	  }
	});
	Object.defineProperty(exports, "VolumeDownTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeDownTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "VolumeMute", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeMute.default;
	  }
	});
	Object.defineProperty(exports, "VolumeMuteOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeMuteOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VolumeMuteRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeMuteRounded.default;
	  }
	});
	Object.defineProperty(exports, "VolumeMuteSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeMuteSharp.default;
	  }
	});
	Object.defineProperty(exports, "VolumeMuteTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeMuteTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "VolumeOff", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeOff.default;
	  }
	});
	Object.defineProperty(exports, "VolumeOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VolumeOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "VolumeOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "VolumeOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "VolumeUp", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeUp.default;
	  }
	});
	Object.defineProperty(exports, "VolumeUpOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeUpOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VolumeUpRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeUpRounded.default;
	  }
	});
	Object.defineProperty(exports, "VolumeUpSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeUpSharp.default;
	  }
	});
	Object.defineProperty(exports, "VolumeUpTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VolumeUpTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "VpnKey", {
	  enumerable: true,
	  get: function get() {
	    return _VpnKey.default;
	  }
	});
	Object.defineProperty(exports, "VpnKeyOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VpnKeyOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VpnKeyRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VpnKeyRounded.default;
	  }
	});
	Object.defineProperty(exports, "VpnKeySharp", {
	  enumerable: true,
	  get: function get() {
	    return _VpnKeySharp.default;
	  }
	});
	Object.defineProperty(exports, "VpnKeyTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VpnKeyTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "VpnLock", {
	  enumerable: true,
	  get: function get() {
	    return _VpnLock.default;
	  }
	});
	Object.defineProperty(exports, "VpnLockOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _VpnLockOutlined.default;
	  }
	});
	Object.defineProperty(exports, "VpnLockRounded", {
	  enumerable: true,
	  get: function get() {
	    return _VpnLockRounded.default;
	  }
	});
	Object.defineProperty(exports, "VpnLockSharp", {
	  enumerable: true,
	  get: function get() {
	    return _VpnLockSharp.default;
	  }
	});
	Object.defineProperty(exports, "VpnLockTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _VpnLockTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Wallpaper", {
	  enumerable: true,
	  get: function get() {
	    return _Wallpaper.default;
	  }
	});
	Object.defineProperty(exports, "WallpaperOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WallpaperOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WallpaperRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WallpaperRounded.default;
	  }
	});
	Object.defineProperty(exports, "WallpaperSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WallpaperSharp.default;
	  }
	});
	Object.defineProperty(exports, "WallpaperTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WallpaperTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Warning", {
	  enumerable: true,
	  get: function get() {
	    return _Warning.default;
	  }
	});
	Object.defineProperty(exports, "WarningOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WarningOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WarningRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WarningRounded.default;
	  }
	});
	Object.defineProperty(exports, "WarningSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WarningSharp.default;
	  }
	});
	Object.defineProperty(exports, "WarningTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WarningTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Watch", {
	  enumerable: true,
	  get: function get() {
	    return _Watch.default;
	  }
	});
	Object.defineProperty(exports, "WatchLater", {
	  enumerable: true,
	  get: function get() {
	    return _WatchLater.default;
	  }
	});
	Object.defineProperty(exports, "WatchLaterOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WatchLaterOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WatchLaterRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WatchLaterRounded.default;
	  }
	});
	Object.defineProperty(exports, "WatchLaterSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WatchLaterSharp.default;
	  }
	});
	Object.defineProperty(exports, "WatchLaterTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WatchLaterTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "WatchOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WatchOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WatchRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WatchRounded.default;
	  }
	});
	Object.defineProperty(exports, "WatchSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WatchSharp.default;
	  }
	});
	Object.defineProperty(exports, "WatchTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WatchTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Waves", {
	  enumerable: true,
	  get: function get() {
	    return _Waves.default;
	  }
	});
	Object.defineProperty(exports, "WavesOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WavesOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WavesRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WavesRounded.default;
	  }
	});
	Object.defineProperty(exports, "WavesSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WavesSharp.default;
	  }
	});
	Object.defineProperty(exports, "WavesTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WavesTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "WbAuto", {
	  enumerable: true,
	  get: function get() {
	    return _WbAuto.default;
	  }
	});
	Object.defineProperty(exports, "WbAutoOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WbAutoOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WbAutoRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WbAutoRounded.default;
	  }
	});
	Object.defineProperty(exports, "WbAutoSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WbAutoSharp.default;
	  }
	});
	Object.defineProperty(exports, "WbAutoTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WbAutoTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "WbCloudy", {
	  enumerable: true,
	  get: function get() {
	    return _WbCloudy.default;
	  }
	});
	Object.defineProperty(exports, "WbCloudyOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WbCloudyOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WbCloudyRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WbCloudyRounded.default;
	  }
	});
	Object.defineProperty(exports, "WbCloudySharp", {
	  enumerable: true,
	  get: function get() {
	    return _WbCloudySharp.default;
	  }
	});
	Object.defineProperty(exports, "WbCloudyTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WbCloudyTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "WbIncandescent", {
	  enumerable: true,
	  get: function get() {
	    return _WbIncandescent.default;
	  }
	});
	Object.defineProperty(exports, "WbIncandescentOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WbIncandescentOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WbIncandescentRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WbIncandescentRounded.default;
	  }
	});
	Object.defineProperty(exports, "WbIncandescentSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WbIncandescentSharp.default;
	  }
	});
	Object.defineProperty(exports, "WbIncandescentTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WbIncandescentTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "WbIridescent", {
	  enumerable: true,
	  get: function get() {
	    return _WbIridescent.default;
	  }
	});
	Object.defineProperty(exports, "WbIridescentOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WbIridescentOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WbIridescentRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WbIridescentRounded.default;
	  }
	});
	Object.defineProperty(exports, "WbIridescentSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WbIridescentSharp.default;
	  }
	});
	Object.defineProperty(exports, "WbIridescentTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WbIridescentTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "WbSunny", {
	  enumerable: true,
	  get: function get() {
	    return _WbSunny.default;
	  }
	});
	Object.defineProperty(exports, "WbSunnyOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WbSunnyOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WbSunnyRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WbSunnyRounded.default;
	  }
	});
	Object.defineProperty(exports, "WbSunnySharp", {
	  enumerable: true,
	  get: function get() {
	    return _WbSunnySharp.default;
	  }
	});
	Object.defineProperty(exports, "WbSunnyTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WbSunnyTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Wc", {
	  enumerable: true,
	  get: function get() {
	    return _Wc.default;
	  }
	});
	Object.defineProperty(exports, "WcOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WcOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WcRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WcRounded.default;
	  }
	});
	Object.defineProperty(exports, "WcSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WcSharp.default;
	  }
	});
	Object.defineProperty(exports, "WcTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WcTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Web", {
	  enumerable: true,
	  get: function get() {
	    return _Web.default;
	  }
	});
	Object.defineProperty(exports, "WebAsset", {
	  enumerable: true,
	  get: function get() {
	    return _WebAsset.default;
	  }
	});
	Object.defineProperty(exports, "WebAssetOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WebAssetOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WebAssetRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WebAssetRounded.default;
	  }
	});
	Object.defineProperty(exports, "WebAssetSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WebAssetSharp.default;
	  }
	});
	Object.defineProperty(exports, "WebAssetTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WebAssetTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "WebOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WebOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WebRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WebRounded.default;
	  }
	});
	Object.defineProperty(exports, "WebSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WebSharp.default;
	  }
	});
	Object.defineProperty(exports, "WebTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WebTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Weekend", {
	  enumerable: true,
	  get: function get() {
	    return _Weekend.default;
	  }
	});
	Object.defineProperty(exports, "WeekendOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WeekendOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WeekendRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WeekendRounded.default;
	  }
	});
	Object.defineProperty(exports, "WeekendSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WeekendSharp.default;
	  }
	});
	Object.defineProperty(exports, "WeekendTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WeekendTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "WhatsApp", {
	  enumerable: true,
	  get: function get() {
	    return _WhatsApp.default;
	  }
	});
	Object.defineProperty(exports, "Whatshot", {
	  enumerable: true,
	  get: function get() {
	    return _Whatshot.default;
	  }
	});
	Object.defineProperty(exports, "WhatshotOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WhatshotOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WhatshotRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WhatshotRounded.default;
	  }
	});
	Object.defineProperty(exports, "WhatshotSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WhatshotSharp.default;
	  }
	});
	Object.defineProperty(exports, "WhatshotTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WhatshotTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "WhereToVote", {
	  enumerable: true,
	  get: function get() {
	    return _WhereToVote.default;
	  }
	});
	Object.defineProperty(exports, "WhereToVoteOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WhereToVoteOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WhereToVoteRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WhereToVoteRounded.default;
	  }
	});
	Object.defineProperty(exports, "WhereToVoteSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WhereToVoteSharp.default;
	  }
	});
	Object.defineProperty(exports, "WhereToVoteTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WhereToVoteTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Widgets", {
	  enumerable: true,
	  get: function get() {
	    return _Widgets.default;
	  }
	});
	Object.defineProperty(exports, "WidgetsOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WidgetsOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WidgetsRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WidgetsRounded.default;
	  }
	});
	Object.defineProperty(exports, "WidgetsSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WidgetsSharp.default;
	  }
	});
	Object.defineProperty(exports, "WidgetsTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WidgetsTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Wifi", {
	  enumerable: true,
	  get: function get() {
	    return _Wifi.default;
	  }
	});
	Object.defineProperty(exports, "WifiLock", {
	  enumerable: true,
	  get: function get() {
	    return _WifiLock.default;
	  }
	});
	Object.defineProperty(exports, "WifiLockOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WifiLockOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WifiLockRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WifiLockRounded.default;
	  }
	});
	Object.defineProperty(exports, "WifiLockSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WifiLockSharp.default;
	  }
	});
	Object.defineProperty(exports, "WifiLockTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WifiLockTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "WifiOff", {
	  enumerable: true,
	  get: function get() {
	    return _WifiOff.default;
	  }
	});
	Object.defineProperty(exports, "WifiOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WifiOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WifiOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WifiOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "WifiOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WifiOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "WifiOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WifiOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "WifiOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WifiOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WifiRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WifiRounded.default;
	  }
	});
	Object.defineProperty(exports, "WifiSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WifiSharp.default;
	  }
	});
	Object.defineProperty(exports, "WifiTethering", {
	  enumerable: true,
	  get: function get() {
	    return _WifiTethering.default;
	  }
	});
	Object.defineProperty(exports, "WifiTetheringOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WifiTetheringOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WifiTetheringRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WifiTetheringRounded.default;
	  }
	});
	Object.defineProperty(exports, "WifiTetheringSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WifiTetheringSharp.default;
	  }
	});
	Object.defineProperty(exports, "WifiTetheringTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WifiTetheringTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "WifiTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WifiTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "Work", {
	  enumerable: true,
	  get: function get() {
	    return _Work.default;
	  }
	});
	Object.defineProperty(exports, "WorkOff", {
	  enumerable: true,
	  get: function get() {
	    return _WorkOff.default;
	  }
	});
	Object.defineProperty(exports, "WorkOffOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WorkOffOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WorkOffRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WorkOffRounded.default;
	  }
	});
	Object.defineProperty(exports, "WorkOffSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WorkOffSharp.default;
	  }
	});
	Object.defineProperty(exports, "WorkOffTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WorkOffTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "WorkOutline", {
	  enumerable: true,
	  get: function get() {
	    return _WorkOutline.default;
	  }
	});
	Object.defineProperty(exports, "WorkOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WorkOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WorkOutlineOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WorkOutlineOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WorkOutlineRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WorkOutlineRounded.default;
	  }
	});
	Object.defineProperty(exports, "WorkOutlineSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WorkOutlineSharp.default;
	  }
	});
	Object.defineProperty(exports, "WorkOutlineTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WorkOutlineTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "WorkRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WorkRounded.default;
	  }
	});
	Object.defineProperty(exports, "WorkSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WorkSharp.default;
	  }
	});
	Object.defineProperty(exports, "WorkTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WorkTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "WrapText", {
	  enumerable: true,
	  get: function get() {
	    return _WrapText.default;
	  }
	});
	Object.defineProperty(exports, "WrapTextOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _WrapTextOutlined.default;
	  }
	});
	Object.defineProperty(exports, "WrapTextRounded", {
	  enumerable: true,
	  get: function get() {
	    return _WrapTextRounded.default;
	  }
	});
	Object.defineProperty(exports, "WrapTextSharp", {
	  enumerable: true,
	  get: function get() {
	    return _WrapTextSharp.default;
	  }
	});
	Object.defineProperty(exports, "WrapTextTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _WrapTextTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "YouTube", {
	  enumerable: true,
	  get: function get() {
	    return _YouTube.default;
	  }
	});
	Object.defineProperty(exports, "YoutubeSearchedFor", {
	  enumerable: true,
	  get: function get() {
	    return _YoutubeSearchedFor.default;
	  }
	});
	Object.defineProperty(exports, "YoutubeSearchedForOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _YoutubeSearchedForOutlined.default;
	  }
	});
	Object.defineProperty(exports, "YoutubeSearchedForRounded", {
	  enumerable: true,
	  get: function get() {
	    return _YoutubeSearchedForRounded.default;
	  }
	});
	Object.defineProperty(exports, "YoutubeSearchedForSharp", {
	  enumerable: true,
	  get: function get() {
	    return _YoutubeSearchedForSharp.default;
	  }
	});
	Object.defineProperty(exports, "YoutubeSearchedForTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _YoutubeSearchedForTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ZoomIn", {
	  enumerable: true,
	  get: function get() {
	    return _ZoomIn.default;
	  }
	});
	Object.defineProperty(exports, "ZoomInOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ZoomInOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ZoomInRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ZoomInRounded.default;
	  }
	});
	Object.defineProperty(exports, "ZoomInSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ZoomInSharp.default;
	  }
	});
	Object.defineProperty(exports, "ZoomInTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ZoomInTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ZoomOut", {
	  enumerable: true,
	  get: function get() {
	    return _ZoomOut.default;
	  }
	});
	Object.defineProperty(exports, "ZoomOutMap", {
	  enumerable: true,
	  get: function get() {
	    return _ZoomOutMap.default;
	  }
	});
	Object.defineProperty(exports, "ZoomOutMapOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ZoomOutMapOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ZoomOutMapRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ZoomOutMapRounded.default;
	  }
	});
	Object.defineProperty(exports, "ZoomOutMapSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ZoomOutMapSharp.default;
	  }
	});
	Object.defineProperty(exports, "ZoomOutMapTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ZoomOutMapTwoTone.default;
	  }
	});
	Object.defineProperty(exports, "ZoomOutOutlined", {
	  enumerable: true,
	  get: function get() {
	    return _ZoomOutOutlined.default;
	  }
	});
	Object.defineProperty(exports, "ZoomOutRounded", {
	  enumerable: true,
	  get: function get() {
	    return _ZoomOutRounded.default;
	  }
	});
	Object.defineProperty(exports, "ZoomOutSharp", {
	  enumerable: true,
	  get: function get() {
	    return _ZoomOutSharp.default;
	  }
	});
	Object.defineProperty(exports, "ZoomOutTwoTone", {
	  enumerable: true,
	  get: function get() {
	    return _ZoomOutTwoTone.default;
	  }
	});
	
	var _AccessAlarm = _interopRequireDefault(__webpack_require__(1054));
	
	var _AccessAlarmOutlined = _interopRequireDefault(__webpack_require__(1055));
	
	var _AccessAlarmRounded = _interopRequireDefault(__webpack_require__(1056));
	
	var _AccessAlarms = _interopRequireDefault(__webpack_require__(1059));
	
	var _AccessAlarmSharp = _interopRequireDefault(__webpack_require__(1057));
	
	var _AccessAlarmsOutlined = _interopRequireDefault(__webpack_require__(1060));
	
	var _AccessAlarmsRounded = _interopRequireDefault(__webpack_require__(1061));
	
	var _AccessAlarmsSharp = _interopRequireDefault(__webpack_require__(1062));
	
	var _AccessAlarmsTwoTone = _interopRequireDefault(__webpack_require__(1063));
	
	var _AccessAlarmTwoTone = _interopRequireDefault(__webpack_require__(1058));
	
	var _Accessibility = _interopRequireDefault(__webpack_require__(1069));
	
	var _AccessibilityNew = _interopRequireDefault(__webpack_require__(1070));
	
	var _AccessibilityNewOutlined = _interopRequireDefault(__webpack_require__(1071));
	
	var _AccessibilityNewRounded = _interopRequireDefault(__webpack_require__(1072));
	
	var _AccessibilityNewSharp = _interopRequireDefault(__webpack_require__(1073));
	
	var _AccessibilityNewTwoTone = _interopRequireDefault(__webpack_require__(1074));
	
	var _AccessibilityOutlined = _interopRequireDefault(__webpack_require__(1075));
	
	var _AccessibilityRounded = _interopRequireDefault(__webpack_require__(1076));
	
	var _AccessibilitySharp = _interopRequireDefault(__webpack_require__(1077));
	
	var _AccessibilityTwoTone = _interopRequireDefault(__webpack_require__(1078));
	
	var _Accessible = _interopRequireDefault(__webpack_require__(1079));
	
	var _AccessibleForward = _interopRequireDefault(__webpack_require__(1080));
	
	var _AccessibleForwardOutlined = _interopRequireDefault(__webpack_require__(1081));
	
	var _AccessibleForwardRounded = _interopRequireDefault(__webpack_require__(1082));
	
	var _AccessibleForwardSharp = _interopRequireDefault(__webpack_require__(1083));
	
	var _AccessibleForwardTwoTone = _interopRequireDefault(__webpack_require__(1084));
	
	var _AccessibleOutlined = _interopRequireDefault(__webpack_require__(1085));
	
	var _AccessibleRounded = _interopRequireDefault(__webpack_require__(1086));
	
	var _AccessibleSharp = _interopRequireDefault(__webpack_require__(1087));
	
	var _AccessibleTwoTone = _interopRequireDefault(__webpack_require__(1088));
	
	var _AccessTime = _interopRequireDefault(__webpack_require__(1064));
	
	var _AccessTimeOutlined = _interopRequireDefault(__webpack_require__(1065));
	
	var _AccessTimeRounded = _interopRequireDefault(__webpack_require__(1066));
	
	var _AccessTimeSharp = _interopRequireDefault(__webpack_require__(1067));
	
	var _AccessTimeTwoTone = _interopRequireDefault(__webpack_require__(1068));
	
	var _AccountBalance = _interopRequireDefault(__webpack_require__(1089));
	
	var _AccountBalanceOutlined = _interopRequireDefault(__webpack_require__(1090));
	
	var _AccountBalanceRounded = _interopRequireDefault(__webpack_require__(1091));
	
	var _AccountBalanceSharp = _interopRequireDefault(__webpack_require__(1092));
	
	var _AccountBalanceTwoTone = _interopRequireDefault(__webpack_require__(1093));
	
	var _AccountBalanceWallet = _interopRequireDefault(__webpack_require__(1094));
	
	var _AccountBalanceWalletOutlined = _interopRequireDefault(__webpack_require__(1095));
	
	var _AccountBalanceWalletRounded = _interopRequireDefault(__webpack_require__(1096));
	
	var _AccountBalanceWalletSharp = _interopRequireDefault(__webpack_require__(1097));
	
	var _AccountBalanceWalletTwoTone = _interopRequireDefault(__webpack_require__(1098));
	
	var _AccountBox = _interopRequireDefault(__webpack_require__(1099));
	
	var _AccountBoxOutlined = _interopRequireDefault(__webpack_require__(1100));
	
	var _AccountBoxRounded = _interopRequireDefault(__webpack_require__(1101));
	
	var _AccountBoxSharp = _interopRequireDefault(__webpack_require__(1102));
	
	var _AccountBoxTwoTone = _interopRequireDefault(__webpack_require__(1103));
	
	var _AccountCircle = _interopRequireDefault(__webpack_require__(1104));
	
	var _AccountCircleOutlined = _interopRequireDefault(__webpack_require__(1105));
	
	var _AccountCircleRounded = _interopRequireDefault(__webpack_require__(1106));
	
	var _AccountCircleSharp = _interopRequireDefault(__webpack_require__(1107));
	
	var _AccountCircleTwoTone = _interopRequireDefault(__webpack_require__(1108));
	
	var _AccountTree = _interopRequireDefault(__webpack_require__(1109));
	
	var _AccountTreeOutlined = _interopRequireDefault(__webpack_require__(1110));
	
	var _AccountTreeRounded = _interopRequireDefault(__webpack_require__(1111));
	
	var _AccountTreeSharp = _interopRequireDefault(__webpack_require__(1112));
	
	var _AccountTreeTwoTone = _interopRequireDefault(__webpack_require__(1113));
	
	var _AcUnit = _interopRequireDefault(__webpack_require__(1049));
	
	var _AcUnitOutlined = _interopRequireDefault(__webpack_require__(1050));
	
	var _AcUnitRounded = _interopRequireDefault(__webpack_require__(1051));
	
	var _AcUnitSharp = _interopRequireDefault(__webpack_require__(1052));
	
	var _AcUnitTwoTone = _interopRequireDefault(__webpack_require__(1053));
	
	var _Adb = _interopRequireDefault(__webpack_require__(1114));
	
	var _AdbOutlined = _interopRequireDefault(__webpack_require__(1115));
	
	var _AdbRounded = _interopRequireDefault(__webpack_require__(1116));
	
	var _AdbSharp = _interopRequireDefault(__webpack_require__(1117));
	
	var _AdbTwoTone = _interopRequireDefault(__webpack_require__(1118));
	
	var _Add = _interopRequireDefault(__webpack_require__(1119));
	
	var _AddAlarm = _interopRequireDefault(__webpack_require__(1125));
	
	var _AddAlarmOutlined = _interopRequireDefault(__webpack_require__(1126));
	
	var _AddAlarmRounded = _interopRequireDefault(__webpack_require__(1127));
	
	var _AddAlarmSharp = _interopRequireDefault(__webpack_require__(1128));
	
	var _AddAlarmTwoTone = _interopRequireDefault(__webpack_require__(1129));
	
	var _AddAlert = _interopRequireDefault(__webpack_require__(1130));
	
	var _AddAlertOutlined = _interopRequireDefault(__webpack_require__(1131));
	
	var _AddAlertRounded = _interopRequireDefault(__webpack_require__(1132));
	
	var _AddAlertSharp = _interopRequireDefault(__webpack_require__(1133));
	
	var _AddAlertTwoTone = _interopRequireDefault(__webpack_require__(1134));
	
	var _AddAPhoto = _interopRequireDefault(__webpack_require__(1120));
	
	var _AddAPhotoOutlined = _interopRequireDefault(__webpack_require__(1121));
	
	var _AddAPhotoRounded = _interopRequireDefault(__webpack_require__(1122));
	
	var _AddAPhotoSharp = _interopRequireDefault(__webpack_require__(1123));
	
	var _AddAPhotoTwoTone = _interopRequireDefault(__webpack_require__(1124));
	
	var _AddBox = _interopRequireDefault(__webpack_require__(1135));
	
	var _AddBoxOutlined = _interopRequireDefault(__webpack_require__(1136));
	
	var _AddBoxRounded = _interopRequireDefault(__webpack_require__(1137));
	
	var _AddBoxSharp = _interopRequireDefault(__webpack_require__(1138));
	
	var _AddBoxTwoTone = _interopRequireDefault(__webpack_require__(1139));
	
	var _AddCircle = _interopRequireDefault(__webpack_require__(1140));
	
	var _AddCircleOutline = _interopRequireDefault(__webpack_require__(1141));
	
	var _AddCircleOutlined = _interopRequireDefault(__webpack_require__(1146));
	
	var _AddCircleOutlineOutlined = _interopRequireDefault(__webpack_require__(1142));
	
	var _AddCircleOutlineRounded = _interopRequireDefault(__webpack_require__(1143));
	
	var _AddCircleOutlineSharp = _interopRequireDefault(__webpack_require__(1144));
	
	var _AddCircleOutlineTwoTone = _interopRequireDefault(__webpack_require__(1145));
	
	var _AddCircleRounded = _interopRequireDefault(__webpack_require__(1147));
	
	var _AddCircleSharp = _interopRequireDefault(__webpack_require__(1148));
	
	var _AddCircleTwoTone = _interopRequireDefault(__webpack_require__(1149));
	
	var _AddComment = _interopRequireDefault(__webpack_require__(1150));
	
	var _AddCommentOutlined = _interopRequireDefault(__webpack_require__(1151));
	
	var _AddCommentRounded = _interopRequireDefault(__webpack_require__(1152));
	
	var _AddCommentSharp = _interopRequireDefault(__webpack_require__(1153));
	
	var _AddCommentTwoTone = _interopRequireDefault(__webpack_require__(1154));
	
	var _AddIcCall = _interopRequireDefault(__webpack_require__(1155));
	
	var _AddIcCallOutlined = _interopRequireDefault(__webpack_require__(1156));
	
	var _AddIcCallRounded = _interopRequireDefault(__webpack_require__(1157));
	
	var _AddIcCallSharp = _interopRequireDefault(__webpack_require__(1158));
	
	var _AddIcCallTwoTone = _interopRequireDefault(__webpack_require__(1159));
	
	var _AddLocation = _interopRequireDefault(__webpack_require__(1160));
	
	var _AddLocationOutlined = _interopRequireDefault(__webpack_require__(1161));
	
	var _AddLocationRounded = _interopRequireDefault(__webpack_require__(1162));
	
	var _AddLocationSharp = _interopRequireDefault(__webpack_require__(1163));
	
	var _AddLocationTwoTone = _interopRequireDefault(__webpack_require__(1164));
	
	var _AddOutlined = _interopRequireDefault(__webpack_require__(1165));
	
	var _AddPhotoAlternate = _interopRequireDefault(__webpack_require__(1166));
	
	var _AddPhotoAlternateOutlined = _interopRequireDefault(__webpack_require__(1167));
	
	var _AddPhotoAlternateRounded = _interopRequireDefault(__webpack_require__(1168));
	
	var _AddPhotoAlternateSharp = _interopRequireDefault(__webpack_require__(1169));
	
	var _AddPhotoAlternateTwoTone = _interopRequireDefault(__webpack_require__(1170));
	
	var _AddRounded = _interopRequireDefault(__webpack_require__(1171));
	
	var _AddSharp = _interopRequireDefault(__webpack_require__(1172));
	
	var _AddShoppingCart = _interopRequireDefault(__webpack_require__(1173));
	
	var _AddShoppingCartOutlined = _interopRequireDefault(__webpack_require__(1174));
	
	var _AddShoppingCartRounded = _interopRequireDefault(__webpack_require__(1175));
	
	var _AddShoppingCartSharp = _interopRequireDefault(__webpack_require__(1176));
	
	var _AddShoppingCartTwoTone = _interopRequireDefault(__webpack_require__(1177));
	
	var _AddToHomeScreen = _interopRequireDefault(__webpack_require__(1178));
	
	var _AddToHomeScreenOutlined = _interopRequireDefault(__webpack_require__(1179));
	
	var _AddToHomeScreenRounded = _interopRequireDefault(__webpack_require__(1180));
	
	var _AddToHomeScreenSharp = _interopRequireDefault(__webpack_require__(1181));
	
	var _AddToHomeScreenTwoTone = _interopRequireDefault(__webpack_require__(1182));
	
	var _AddToPhotos = _interopRequireDefault(__webpack_require__(1183));
	
	var _AddToPhotosOutlined = _interopRequireDefault(__webpack_require__(1184));
	
	var _AddToPhotosRounded = _interopRequireDefault(__webpack_require__(1185));
	
	var _AddToPhotosSharp = _interopRequireDefault(__webpack_require__(1186));
	
	var _AddToPhotosTwoTone = _interopRequireDefault(__webpack_require__(1187));
	
	var _AddToQueue = _interopRequireDefault(__webpack_require__(1188));
	
	var _AddToQueueOutlined = _interopRequireDefault(__webpack_require__(1189));
	
	var _AddToQueueRounded = _interopRequireDefault(__webpack_require__(1190));
	
	var _AddToQueueSharp = _interopRequireDefault(__webpack_require__(1191));
	
	var _AddToQueueTwoTone = _interopRequireDefault(__webpack_require__(1192));
	
	var _AddTwoTone = _interopRequireDefault(__webpack_require__(1193));
	
	var _Adjust = _interopRequireDefault(__webpack_require__(1194));
	
	var _AdjustOutlined = _interopRequireDefault(__webpack_require__(1195));
	
	var _AdjustRounded = _interopRequireDefault(__webpack_require__(1196));
	
	var _AdjustSharp = _interopRequireDefault(__webpack_require__(1197));
	
	var _AdjustTwoTone = _interopRequireDefault(__webpack_require__(1198));
	
	var _AirlineSeatFlat = _interopRequireDefault(__webpack_require__(1199));
	
	var _AirlineSeatFlatAngled = _interopRequireDefault(__webpack_require__(1200));
	
	var _AirlineSeatFlatAngledOutlined = _interopRequireDefault(__webpack_require__(1201));
	
	var _AirlineSeatFlatAngledRounded = _interopRequireDefault(__webpack_require__(1202));
	
	var _AirlineSeatFlatAngledSharp = _interopRequireDefault(__webpack_require__(1203));
	
	var _AirlineSeatFlatAngledTwoTone = _interopRequireDefault(__webpack_require__(1204));
	
	var _AirlineSeatFlatOutlined = _interopRequireDefault(__webpack_require__(1205));
	
	var _AirlineSeatFlatRounded = _interopRequireDefault(__webpack_require__(1206));
	
	var _AirlineSeatFlatSharp = _interopRequireDefault(__webpack_require__(1207));
	
	var _AirlineSeatFlatTwoTone = _interopRequireDefault(__webpack_require__(1208));
	
	var _AirlineSeatIndividualSuite = _interopRequireDefault(__webpack_require__(1209));
	
	var _AirlineSeatIndividualSuiteOutlined = _interopRequireDefault(__webpack_require__(1210));
	
	var _AirlineSeatIndividualSuiteRounded = _interopRequireDefault(__webpack_require__(1211));
	
	var _AirlineSeatIndividualSuiteSharp = _interopRequireDefault(__webpack_require__(1212));
	
	var _AirlineSeatIndividualSuiteTwoTone = _interopRequireDefault(__webpack_require__(1213));
	
	var _AirlineSeatLegroomExtra = _interopRequireDefault(__webpack_require__(1214));
	
	var _AirlineSeatLegroomExtraOutlined = _interopRequireDefault(__webpack_require__(1215));
	
	var _AirlineSeatLegroomExtraRounded = _interopRequireDefault(__webpack_require__(1216));
	
	var _AirlineSeatLegroomExtraSharp = _interopRequireDefault(__webpack_require__(1217));
	
	var _AirlineSeatLegroomExtraTwoTone = _interopRequireDefault(__webpack_require__(1218));
	
	var _AirlineSeatLegroomNormal = _interopRequireDefault(__webpack_require__(1219));
	
	var _AirlineSeatLegroomNormalOutlined = _interopRequireDefault(__webpack_require__(1220));
	
	var _AirlineSeatLegroomNormalRounded = _interopRequireDefault(__webpack_require__(1221));
	
	var _AirlineSeatLegroomNormalSharp = _interopRequireDefault(__webpack_require__(1222));
	
	var _AirlineSeatLegroomNormalTwoTone = _interopRequireDefault(__webpack_require__(1223));
	
	var _AirlineSeatLegroomReduced = _interopRequireDefault(__webpack_require__(1224));
	
	var _AirlineSeatLegroomReducedOutlined = _interopRequireDefault(__webpack_require__(1225));
	
	var _AirlineSeatLegroomReducedRounded = _interopRequireDefault(__webpack_require__(1226));
	
	var _AirlineSeatLegroomReducedSharp = _interopRequireDefault(__webpack_require__(1227));
	
	var _AirlineSeatLegroomReducedTwoTone = _interopRequireDefault(__webpack_require__(1228));
	
	var _AirlineSeatReclineExtra = _interopRequireDefault(__webpack_require__(1229));
	
	var _AirlineSeatReclineExtraOutlined = _interopRequireDefault(__webpack_require__(1230));
	
	var _AirlineSeatReclineExtraRounded = _interopRequireDefault(__webpack_require__(1231));
	
	var _AirlineSeatReclineExtraSharp = _interopRequireDefault(__webpack_require__(1232));
	
	var _AirlineSeatReclineExtraTwoTone = _interopRequireDefault(__webpack_require__(1233));
	
	var _AirlineSeatReclineNormal = _interopRequireDefault(__webpack_require__(1234));
	
	var _AirlineSeatReclineNormalOutlined = _interopRequireDefault(__webpack_require__(1235));
	
	var _AirlineSeatReclineNormalRounded = _interopRequireDefault(__webpack_require__(1236));
	
	var _AirlineSeatReclineNormalSharp = _interopRequireDefault(__webpack_require__(1237));
	
	var _AirlineSeatReclineNormalTwoTone = _interopRequireDefault(__webpack_require__(1238));
	
	var _AirplanemodeActive = _interopRequireDefault(__webpack_require__(1239));
	
	var _AirplanemodeActiveOutlined = _interopRequireDefault(__webpack_require__(1240));
	
	var _AirplanemodeActiveRounded = _interopRequireDefault(__webpack_require__(1241));
	
	var _AirplanemodeActiveSharp = _interopRequireDefault(__webpack_require__(1242));
	
	var _AirplanemodeActiveTwoTone = _interopRequireDefault(__webpack_require__(1243));
	
	var _AirplanemodeInactive = _interopRequireDefault(__webpack_require__(1244));
	
	var _AirplanemodeInactiveOutlined = _interopRequireDefault(__webpack_require__(1245));
	
	var _AirplanemodeInactiveRounded = _interopRequireDefault(__webpack_require__(1246));
	
	var _AirplanemodeInactiveSharp = _interopRequireDefault(__webpack_require__(1247));
	
	var _AirplanemodeInactiveTwoTone = _interopRequireDefault(__webpack_require__(1248));
	
	var _Airplay = _interopRequireDefault(__webpack_require__(1249));
	
	var _AirplayOutlined = _interopRequireDefault(__webpack_require__(1250));
	
	var _AirplayRounded = _interopRequireDefault(__webpack_require__(1251));
	
	var _AirplaySharp = _interopRequireDefault(__webpack_require__(1252));
	
	var _AirplayTwoTone = _interopRequireDefault(__webpack_require__(1253));
	
	var _AirportShuttle = _interopRequireDefault(__webpack_require__(1254));
	
	var _AirportShuttleOutlined = _interopRequireDefault(__webpack_require__(1255));
	
	var _AirportShuttleRounded = _interopRequireDefault(__webpack_require__(1256));
	
	var _AirportShuttleSharp = _interopRequireDefault(__webpack_require__(1257));
	
	var _AirportShuttleTwoTone = _interopRequireDefault(__webpack_require__(1258));
	
	var _Alarm = _interopRequireDefault(__webpack_require__(1259));
	
	var _AlarmAdd = _interopRequireDefault(__webpack_require__(1260));
	
	var _AlarmAddOutlined = _interopRequireDefault(__webpack_require__(1261));
	
	var _AlarmAddRounded = _interopRequireDefault(__webpack_require__(1262));
	
	var _AlarmAddSharp = _interopRequireDefault(__webpack_require__(1263));
	
	var _AlarmAddTwoTone = _interopRequireDefault(__webpack_require__(1264));
	
	var _AlarmOff = _interopRequireDefault(__webpack_require__(1265));
	
	var _AlarmOffOutlined = _interopRequireDefault(__webpack_require__(1266));
	
	var _AlarmOffRounded = _interopRequireDefault(__webpack_require__(1267));
	
	var _AlarmOffSharp = _interopRequireDefault(__webpack_require__(1268));
	
	var _AlarmOffTwoTone = _interopRequireDefault(__webpack_require__(1269));
	
	var _AlarmOn = _interopRequireDefault(__webpack_require__(1270));
	
	var _AlarmOnOutlined = _interopRequireDefault(__webpack_require__(1271));
	
	var _AlarmOnRounded = _interopRequireDefault(__webpack_require__(1272));
	
	var _AlarmOnSharp = _interopRequireDefault(__webpack_require__(1273));
	
	var _AlarmOnTwoTone = _interopRequireDefault(__webpack_require__(1274));
	
	var _AlarmOutlined = _interopRequireDefault(__webpack_require__(1275));
	
	var _AlarmRounded = _interopRequireDefault(__webpack_require__(1276));
	
	var _AlarmSharp = _interopRequireDefault(__webpack_require__(1277));
	
	var _AlarmTwoTone = _interopRequireDefault(__webpack_require__(1278));
	
	var _Album = _interopRequireDefault(__webpack_require__(1279));
	
	var _AlbumOutlined = _interopRequireDefault(__webpack_require__(1280));
	
	var _AlbumRounded = _interopRequireDefault(__webpack_require__(1281));
	
	var _AlbumSharp = _interopRequireDefault(__webpack_require__(1282));
	
	var _AlbumTwoTone = _interopRequireDefault(__webpack_require__(1283));
	
	var _AllInbox = _interopRequireDefault(__webpack_require__(1284));
	
	var _AllInboxOutlined = _interopRequireDefault(__webpack_require__(1285));
	
	var _AllInboxRounded = _interopRequireDefault(__webpack_require__(1286));
	
	var _AllInboxSharp = _interopRequireDefault(__webpack_require__(1287));
	
	var _AllInboxTwoTone = _interopRequireDefault(__webpack_require__(1288));
	
	var _AllInclusive = _interopRequireDefault(__webpack_require__(1289));
	
	var _AllInclusiveOutlined = _interopRequireDefault(__webpack_require__(1290));
	
	var _AllInclusiveRounded = _interopRequireDefault(__webpack_require__(1291));
	
	var _AllInclusiveSharp = _interopRequireDefault(__webpack_require__(1292));
	
	var _AllInclusiveTwoTone = _interopRequireDefault(__webpack_require__(1293));
	
	var _AllOut = _interopRequireDefault(__webpack_require__(1294));
	
	var _AllOutOutlined = _interopRequireDefault(__webpack_require__(1295));
	
	var _AllOutRounded = _interopRequireDefault(__webpack_require__(1296));
	
	var _AllOutSharp = _interopRequireDefault(__webpack_require__(1297));
	
	var _AllOutTwoTone = _interopRequireDefault(__webpack_require__(1298));
	
	var _AlternateEmail = _interopRequireDefault(__webpack_require__(1299));
	
	var _AlternateEmailOutlined = _interopRequireDefault(__webpack_require__(1300));
	
	var _AlternateEmailRounded = _interopRequireDefault(__webpack_require__(1301));
	
	var _AlternateEmailSharp = _interopRequireDefault(__webpack_require__(1302));
	
	var _AlternateEmailTwoTone = _interopRequireDefault(__webpack_require__(1303));
	
	var _AmpStories = _interopRequireDefault(__webpack_require__(1304));
	
	var _AmpStoriesOutlined = _interopRequireDefault(__webpack_require__(1305));
	
	var _AmpStoriesRounded = _interopRequireDefault(__webpack_require__(1306));
	
	var _AmpStoriesSharp = _interopRequireDefault(__webpack_require__(1307));
	
	var _AmpStoriesTwoTone = _interopRequireDefault(__webpack_require__(1308));
	
	var _Android = _interopRequireDefault(__webpack_require__(1309));
	
	var _AndroidOutlined = _interopRequireDefault(__webpack_require__(1310));
	
	var _AndroidRounded = _interopRequireDefault(__webpack_require__(1311));
	
	var _AndroidSharp = _interopRequireDefault(__webpack_require__(1312));
	
	var _AndroidTwoTone = _interopRequireDefault(__webpack_require__(1313));
	
	var _Announcement = _interopRequireDefault(__webpack_require__(1314));
	
	var _AnnouncementOutlined = _interopRequireDefault(__webpack_require__(1315));
	
	var _AnnouncementRounded = _interopRequireDefault(__webpack_require__(1316));
	
	var _AnnouncementSharp = _interopRequireDefault(__webpack_require__(1317));
	
	var _AnnouncementTwoTone = _interopRequireDefault(__webpack_require__(1318));
	
	var _Apartment = _interopRequireDefault(__webpack_require__(1319));
	
	var _ApartmentOutlined = _interopRequireDefault(__webpack_require__(1320));
	
	var _ApartmentRounded = _interopRequireDefault(__webpack_require__(1321));
	
	var _ApartmentSharp = _interopRequireDefault(__webpack_require__(1322));
	
	var _ApartmentTwoTone = _interopRequireDefault(__webpack_require__(1323));
	
	var _Apple = _interopRequireDefault(__webpack_require__(1324));
	
	var _Apps = _interopRequireDefault(__webpack_require__(1325));
	
	var _AppsOutlined = _interopRequireDefault(__webpack_require__(1326));
	
	var _AppsRounded = _interopRequireDefault(__webpack_require__(1327));
	
	var _AppsSharp = _interopRequireDefault(__webpack_require__(1328));
	
	var _AppsTwoTone = _interopRequireDefault(__webpack_require__(1329));
	
	var _Archive = _interopRequireDefault(__webpack_require__(1330));
	
	var _ArchiveOutlined = _interopRequireDefault(__webpack_require__(1331));
	
	var _ArchiveRounded = _interopRequireDefault(__webpack_require__(1332));
	
	var _ArchiveSharp = _interopRequireDefault(__webpack_require__(1333));
	
	var _ArchiveTwoTone = _interopRequireDefault(__webpack_require__(1334));
	
	var _ArrowBack = _interopRequireDefault(__webpack_require__(1335));
	
	var _ArrowBackIos = _interopRequireDefault(__webpack_require__(1336));
	
	var _ArrowBackIosOutlined = _interopRequireDefault(__webpack_require__(1337));
	
	var _ArrowBackIosRounded = _interopRequireDefault(__webpack_require__(1338));
	
	var _ArrowBackIosSharp = _interopRequireDefault(__webpack_require__(1339));
	
	var _ArrowBackIosTwoTone = _interopRequireDefault(__webpack_require__(1340));
	
	var _ArrowBackOutlined = _interopRequireDefault(__webpack_require__(1341));
	
	var _ArrowBackRounded = _interopRequireDefault(__webpack_require__(1342));
	
	var _ArrowBackSharp = _interopRequireDefault(__webpack_require__(1343));
	
	var _ArrowBackTwoTone = _interopRequireDefault(__webpack_require__(1344));
	
	var _ArrowDownward = _interopRequireDefault(__webpack_require__(1345));
	
	var _ArrowDownwardOutlined = _interopRequireDefault(__webpack_require__(1346));
	
	var _ArrowDownwardRounded = _interopRequireDefault(__webpack_require__(1347));
	
	var _ArrowDownwardSharp = _interopRequireDefault(__webpack_require__(1348));
	
	var _ArrowDownwardTwoTone = _interopRequireDefault(__webpack_require__(1349));
	
	var _ArrowDropDown = _interopRequireDefault(__webpack_require__(1350));
	
	var _ArrowDropDownCircle = _interopRequireDefault(__webpack_require__(1351));
	
	var _ArrowDropDownCircleOutlined = _interopRequireDefault(__webpack_require__(1352));
	
	var _ArrowDropDownCircleRounded = _interopRequireDefault(__webpack_require__(1353));
	
	var _ArrowDropDownCircleSharp = _interopRequireDefault(__webpack_require__(1354));
	
	var _ArrowDropDownCircleTwoTone = _interopRequireDefault(__webpack_require__(1355));
	
	var _ArrowDropDownOutlined = _interopRequireDefault(__webpack_require__(1356));
	
	var _ArrowDropDownRounded = _interopRequireDefault(__webpack_require__(1357));
	
	var _ArrowDropDownSharp = _interopRequireDefault(__webpack_require__(1358));
	
	var _ArrowDropDownTwoTone = _interopRequireDefault(__webpack_require__(1359));
	
	var _ArrowDropUp = _interopRequireDefault(__webpack_require__(1360));
	
	var _ArrowDropUpOutlined = _interopRequireDefault(__webpack_require__(1361));
	
	var _ArrowDropUpRounded = _interopRequireDefault(__webpack_require__(1362));
	
	var _ArrowDropUpSharp = _interopRequireDefault(__webpack_require__(1363));
	
	var _ArrowDropUpTwoTone = _interopRequireDefault(__webpack_require__(1364));
	
	var _ArrowForward = _interopRequireDefault(__webpack_require__(1365));
	
	var _ArrowForwardIos = _interopRequireDefault(__webpack_require__(1366));
	
	var _ArrowForwardIosOutlined = _interopRequireDefault(__webpack_require__(1367));
	
	var _ArrowForwardIosRounded = _interopRequireDefault(__webpack_require__(1368));
	
	var _ArrowForwardIosSharp = _interopRequireDefault(__webpack_require__(1369));
	
	var _ArrowForwardIosTwoTone = _interopRequireDefault(__webpack_require__(1370));
	
	var _ArrowForwardOutlined = _interopRequireDefault(__webpack_require__(1371));
	
	var _ArrowForwardRounded = _interopRequireDefault(__webpack_require__(1372));
	
	var _ArrowForwardSharp = _interopRequireDefault(__webpack_require__(1373));
	
	var _ArrowForwardTwoTone = _interopRequireDefault(__webpack_require__(1374));
	
	var _ArrowLeft = _interopRequireDefault(__webpack_require__(1375));
	
	var _ArrowLeftOutlined = _interopRequireDefault(__webpack_require__(1376));
	
	var _ArrowLeftRounded = _interopRequireDefault(__webpack_require__(1377));
	
	var _ArrowLeftSharp = _interopRequireDefault(__webpack_require__(1378));
	
	var _ArrowLeftTwoTone = _interopRequireDefault(__webpack_require__(1379));
	
	var _ArrowRight = _interopRequireDefault(__webpack_require__(1380));
	
	var _ArrowRightAlt = _interopRequireDefault(__webpack_require__(1381));
	
	var _ArrowRightAltOutlined = _interopRequireDefault(__webpack_require__(1382));
	
	var _ArrowRightAltRounded = _interopRequireDefault(__webpack_require__(1383));
	
	var _ArrowRightAltSharp = _interopRequireDefault(__webpack_require__(1384));
	
	var _ArrowRightAltTwoTone = _interopRequireDefault(__webpack_require__(1385));
	
	var _ArrowRightOutlined = _interopRequireDefault(__webpack_require__(1386));
	
	var _ArrowRightRounded = _interopRequireDefault(__webpack_require__(1387));
	
	var _ArrowRightSharp = _interopRequireDefault(__webpack_require__(1388));
	
	var _ArrowRightTwoTone = _interopRequireDefault(__webpack_require__(1389));
	
	var _ArrowUpward = _interopRequireDefault(__webpack_require__(1390));
	
	var _ArrowUpwardOutlined = _interopRequireDefault(__webpack_require__(1391));
	
	var _ArrowUpwardRounded = _interopRequireDefault(__webpack_require__(1392));
	
	var _ArrowUpwardSharp = _interopRequireDefault(__webpack_require__(1393));
	
	var _ArrowUpwardTwoTone = _interopRequireDefault(__webpack_require__(1394));
	
	var _ArtTrack = _interopRequireDefault(__webpack_require__(1395));
	
	var _ArtTrackOutlined = _interopRequireDefault(__webpack_require__(1396));
	
	var _ArtTrackRounded = _interopRequireDefault(__webpack_require__(1397));
	
	var _ArtTrackSharp = _interopRequireDefault(__webpack_require__(1398));
	
	var _ArtTrackTwoTone = _interopRequireDefault(__webpack_require__(1399));
	
	var _AspectRatio = _interopRequireDefault(__webpack_require__(1400));
	
	var _AspectRatioOutlined = _interopRequireDefault(__webpack_require__(1401));
	
	var _AspectRatioRounded = _interopRequireDefault(__webpack_require__(1402));
	
	var _AspectRatioSharp = _interopRequireDefault(__webpack_require__(1403));
	
	var _AspectRatioTwoTone = _interopRequireDefault(__webpack_require__(1404));
	
	var _Assessment = _interopRequireDefault(__webpack_require__(1405));
	
	var _AssessmentOutlined = _interopRequireDefault(__webpack_require__(1406));
	
	var _AssessmentRounded = _interopRequireDefault(__webpack_require__(1407));
	
	var _AssessmentSharp = _interopRequireDefault(__webpack_require__(1408));
	
	var _AssessmentTwoTone = _interopRequireDefault(__webpack_require__(1409));
	
	var _Assignment = _interopRequireDefault(__webpack_require__(1410));
	
	var _AssignmentInd = _interopRequireDefault(__webpack_require__(1411));
	
	var _AssignmentIndOutlined = _interopRequireDefault(__webpack_require__(1412));
	
	var _AssignmentIndRounded = _interopRequireDefault(__webpack_require__(1413));
	
	var _AssignmentIndSharp = _interopRequireDefault(__webpack_require__(1414));
	
	var _AssignmentIndTwoTone = _interopRequireDefault(__webpack_require__(1415));
	
	var _AssignmentLate = _interopRequireDefault(__webpack_require__(1416));
	
	var _AssignmentLateOutlined = _interopRequireDefault(__webpack_require__(1417));
	
	var _AssignmentLateRounded = _interopRequireDefault(__webpack_require__(1418));
	
	var _AssignmentLateSharp = _interopRequireDefault(__webpack_require__(1419));
	
	var _AssignmentLateTwoTone = _interopRequireDefault(__webpack_require__(1420));
	
	var _AssignmentOutlined = _interopRequireDefault(__webpack_require__(1421));
	
	var _AssignmentReturn = _interopRequireDefault(__webpack_require__(1422));
	
	var _AssignmentReturned = _interopRequireDefault(__webpack_require__(1427));
	
	var _AssignmentReturnedOutlined = _interopRequireDefault(__webpack_require__(1428));
	
	var _AssignmentReturnedRounded = _interopRequireDefault(__webpack_require__(1429));
	
	var _AssignmentReturnedSharp = _interopRequireDefault(__webpack_require__(1430));
	
	var _AssignmentReturnedTwoTone = _interopRequireDefault(__webpack_require__(1431));
	
	var _AssignmentReturnOutlined = _interopRequireDefault(__webpack_require__(1423));
	
	var _AssignmentReturnRounded = _interopRequireDefault(__webpack_require__(1424));
	
	var _AssignmentReturnSharp = _interopRequireDefault(__webpack_require__(1425));
	
	var _AssignmentReturnTwoTone = _interopRequireDefault(__webpack_require__(1426));
	
	var _AssignmentRounded = _interopRequireDefault(__webpack_require__(1432));
	
	var _AssignmentSharp = _interopRequireDefault(__webpack_require__(1433));
	
	var _AssignmentTurnedIn = _interopRequireDefault(__webpack_require__(1434));
	
	var _AssignmentTurnedInOutlined = _interopRequireDefault(__webpack_require__(1435));
	
	var _AssignmentTurnedInRounded = _interopRequireDefault(__webpack_require__(1436));
	
	var _AssignmentTurnedInSharp = _interopRequireDefault(__webpack_require__(1437));
	
	var _AssignmentTurnedInTwoTone = _interopRequireDefault(__webpack_require__(1438));
	
	var _AssignmentTwoTone = _interopRequireDefault(__webpack_require__(1439));
	
	var _Assistant = _interopRequireDefault(__webpack_require__(1440));
	
	var _AssistantOutlined = _interopRequireDefault(__webpack_require__(1441));
	
	var _AssistantPhoto = _interopRequireDefault(__webpack_require__(1442));
	
	var _AssistantPhotoOutlined = _interopRequireDefault(__webpack_require__(1443));
	
	var _AssistantPhotoRounded = _interopRequireDefault(__webpack_require__(1444));
	
	var _AssistantPhotoSharp = _interopRequireDefault(__webpack_require__(1445));
	
	var _AssistantPhotoTwoTone = _interopRequireDefault(__webpack_require__(1446));
	
	var _AssistantRounded = _interopRequireDefault(__webpack_require__(1447));
	
	var _AssistantSharp = _interopRequireDefault(__webpack_require__(1448));
	
	var _AssistantTwoTone = _interopRequireDefault(__webpack_require__(1449));
	
	var _Atm = _interopRequireDefault(__webpack_require__(1450));
	
	var _AtmOutlined = _interopRequireDefault(__webpack_require__(1451));
	
	var _AtmRounded = _interopRequireDefault(__webpack_require__(1452));
	
	var _AtmSharp = _interopRequireDefault(__webpack_require__(1453));
	
	var _AtmTwoTone = _interopRequireDefault(__webpack_require__(1454));
	
	var _AttachFile = _interopRequireDefault(__webpack_require__(1455));
	
	var _AttachFileOutlined = _interopRequireDefault(__webpack_require__(1456));
	
	var _AttachFileRounded = _interopRequireDefault(__webpack_require__(1457));
	
	var _AttachFileSharp = _interopRequireDefault(__webpack_require__(1458));
	
	var _AttachFileTwoTone = _interopRequireDefault(__webpack_require__(1459));
	
	var _Attachment = _interopRequireDefault(__webpack_require__(1465));
	
	var _AttachmentOutlined = _interopRequireDefault(__webpack_require__(1466));
	
	var _AttachmentRounded = _interopRequireDefault(__webpack_require__(1467));
	
	var _AttachmentSharp = _interopRequireDefault(__webpack_require__(1468));
	
	var _AttachmentTwoTone = _interopRequireDefault(__webpack_require__(1469));
	
	var _AttachMoney = _interopRequireDefault(__webpack_require__(1460));
	
	var _AttachMoneyOutlined = _interopRequireDefault(__webpack_require__(1461));
	
	var _AttachMoneyRounded = _interopRequireDefault(__webpack_require__(1462));
	
	var _AttachMoneySharp = _interopRequireDefault(__webpack_require__(1463));
	
	var _AttachMoneyTwoTone = _interopRequireDefault(__webpack_require__(1464));
	
	var _Audiotrack = _interopRequireDefault(__webpack_require__(1470));
	
	var _AudiotrackOutlined = _interopRequireDefault(__webpack_require__(1471));
	
	var _AudiotrackRounded = _interopRequireDefault(__webpack_require__(1472));
	
	var _AudiotrackSharp = _interopRequireDefault(__webpack_require__(1473));
	
	var _AudiotrackTwoTone = _interopRequireDefault(__webpack_require__(1474));
	
	var _Autorenew = _interopRequireDefault(__webpack_require__(1475));
	
	var _AutorenewOutlined = _interopRequireDefault(__webpack_require__(1476));
	
	var _AutorenewRounded = _interopRequireDefault(__webpack_require__(1477));
	
	var _AutorenewSharp = _interopRequireDefault(__webpack_require__(1478));
	
	var _AutorenewTwoTone = _interopRequireDefault(__webpack_require__(1479));
	
	var _AvTimer = _interopRequireDefault(__webpack_require__(1480));
	
	var _AvTimerOutlined = _interopRequireDefault(__webpack_require__(1481));
	
	var _AvTimerRounded = _interopRequireDefault(__webpack_require__(1482));
	
	var _AvTimerSharp = _interopRequireDefault(__webpack_require__(1483));
	
	var _AvTimerTwoTone = _interopRequireDefault(__webpack_require__(1484));
	
	var _Backspace = _interopRequireDefault(__webpack_require__(1485));
	
	var _BackspaceOutlined = _interopRequireDefault(__webpack_require__(1486));
	
	var _BackspaceRounded = _interopRequireDefault(__webpack_require__(1487));
	
	var _BackspaceSharp = _interopRequireDefault(__webpack_require__(1488));
	
	var _BackspaceTwoTone = _interopRequireDefault(__webpack_require__(1489));
	
	var _Backup = _interopRequireDefault(__webpack_require__(1490));
	
	var _BackupOutlined = _interopRequireDefault(__webpack_require__(1491));
	
	var _BackupRounded = _interopRequireDefault(__webpack_require__(1492));
	
	var _BackupSharp = _interopRequireDefault(__webpack_require__(1493));
	
	var _BackupTwoTone = _interopRequireDefault(__webpack_require__(1494));
	
	var _Ballot = _interopRequireDefault(__webpack_require__(1495));
	
	var _BallotOutlined = _interopRequireDefault(__webpack_require__(1496));
	
	var _BallotRounded = _interopRequireDefault(__webpack_require__(1497));
	
	var _BallotSharp = _interopRequireDefault(__webpack_require__(1498));
	
	var _BallotTwoTone = _interopRequireDefault(__webpack_require__(1499));
	
	var _BarChart = _interopRequireDefault(__webpack_require__(1500));
	
	var _BarChartOutlined = _interopRequireDefault(__webpack_require__(1501));
	
	var _BarChartRounded = _interopRequireDefault(__webpack_require__(1502));
	
	var _BarChartSharp = _interopRequireDefault(__webpack_require__(1503));
	
	var _BarChartTwoTone = _interopRequireDefault(__webpack_require__(1504));
	
	var _Bathtub = _interopRequireDefault(__webpack_require__(1505));
	
	var _BathtubOutlined = _interopRequireDefault(__webpack_require__(1506));
	
	var _BathtubRounded = _interopRequireDefault(__webpack_require__(1507));
	
	var _BathtubSharp = _interopRequireDefault(__webpack_require__(1508));
	
	var _BathtubTwoTone = _interopRequireDefault(__webpack_require__(1509));
	
	var _Battery = _interopRequireDefault(__webpack_require__(1510));
	
	var _Battery20Outlined = _interopRequireDefault(__webpack_require__(1511));
	
	var _Battery20Rounded = _interopRequireDefault(__webpack_require__(1512));
	
	var _Battery20Sharp = _interopRequireDefault(__webpack_require__(1513));
	
	var _Battery20TwoTone = _interopRequireDefault(__webpack_require__(1514));
	
	var _Battery2 = _interopRequireDefault(__webpack_require__(1515));
	
	var _Battery30Outlined = _interopRequireDefault(__webpack_require__(1516));
	
	var _Battery30Rounded = _interopRequireDefault(__webpack_require__(1517));
	
	var _Battery30Sharp = _interopRequireDefault(__webpack_require__(1518));
	
	var _Battery30TwoTone = _interopRequireDefault(__webpack_require__(1519));
	
	var _Battery3 = _interopRequireDefault(__webpack_require__(1520));
	
	var _Battery50Outlined = _interopRequireDefault(__webpack_require__(1521));
	
	var _Battery50Rounded = _interopRequireDefault(__webpack_require__(1522));
	
	var _Battery50Sharp = _interopRequireDefault(__webpack_require__(1523));
	
	var _Battery50TwoTone = _interopRequireDefault(__webpack_require__(1524));
	
	var _Battery4 = _interopRequireDefault(__webpack_require__(1525));
	
	var _Battery60Outlined = _interopRequireDefault(__webpack_require__(1526));
	
	var _Battery60Rounded = _interopRequireDefault(__webpack_require__(1527));
	
	var _Battery60Sharp = _interopRequireDefault(__webpack_require__(1528));
	
	var _Battery60TwoTone = _interopRequireDefault(__webpack_require__(1529));
	
	var _Battery5 = _interopRequireDefault(__webpack_require__(1530));
	
	var _Battery80Outlined = _interopRequireDefault(__webpack_require__(1531));
	
	var _Battery80Rounded = _interopRequireDefault(__webpack_require__(1532));
	
	var _Battery80Sharp = _interopRequireDefault(__webpack_require__(1533));
	
	var _Battery80TwoTone = _interopRequireDefault(__webpack_require__(1534));
	
	var _Battery6 = _interopRequireDefault(__webpack_require__(1535));
	
	var _Battery90Outlined = _interopRequireDefault(__webpack_require__(1536));
	
	var _Battery90Rounded = _interopRequireDefault(__webpack_require__(1537));
	
	var _Battery90Sharp = _interopRequireDefault(__webpack_require__(1538));
	
	var _Battery90TwoTone = _interopRequireDefault(__webpack_require__(1539));
	
	var _BatteryAlert = _interopRequireDefault(__webpack_require__(1540));
	
	var _BatteryAlertOutlined = _interopRequireDefault(__webpack_require__(1541));
	
	var _BatteryAlertRounded = _interopRequireDefault(__webpack_require__(1542));
	
	var _BatteryAlertSharp = _interopRequireDefault(__webpack_require__(1543));
	
	var _BatteryAlertTwoTone = _interopRequireDefault(__webpack_require__(1544));
	
	var _BatteryCharging = _interopRequireDefault(__webpack_require__(1545));
	
	var _BatteryCharging20Outlined = _interopRequireDefault(__webpack_require__(1546));
	
	var _BatteryCharging20Rounded = _interopRequireDefault(__webpack_require__(1547));
	
	var _BatteryCharging20Sharp = _interopRequireDefault(__webpack_require__(1548));
	
	var _BatteryCharging20TwoTone = _interopRequireDefault(__webpack_require__(1549));
	
	var _BatteryCharging2 = _interopRequireDefault(__webpack_require__(1550));
	
	var _BatteryCharging30Outlined = _interopRequireDefault(__webpack_require__(1551));
	
	var _BatteryCharging30Rounded = _interopRequireDefault(__webpack_require__(1552));
	
	var _BatteryCharging30Sharp = _interopRequireDefault(__webpack_require__(1553));
	
	var _BatteryCharging30TwoTone = _interopRequireDefault(__webpack_require__(1554));
	
	var _BatteryCharging3 = _interopRequireDefault(__webpack_require__(1555));
	
	var _BatteryCharging50Outlined = _interopRequireDefault(__webpack_require__(1556));
	
	var _BatteryCharging50Rounded = _interopRequireDefault(__webpack_require__(1557));
	
	var _BatteryCharging50Sharp = _interopRequireDefault(__webpack_require__(1558));
	
	var _BatteryCharging50TwoTone = _interopRequireDefault(__webpack_require__(1559));
	
	var _BatteryCharging4 = _interopRequireDefault(__webpack_require__(1560));
	
	var _BatteryCharging60Outlined = _interopRequireDefault(__webpack_require__(1561));
	
	var _BatteryCharging60Rounded = _interopRequireDefault(__webpack_require__(1562));
	
	var _BatteryCharging60Sharp = _interopRequireDefault(__webpack_require__(1563));
	
	var _BatteryCharging60TwoTone = _interopRequireDefault(__webpack_require__(1564));
	
	var _BatteryCharging5 = _interopRequireDefault(__webpack_require__(1565));
	
	var _BatteryCharging80Outlined = _interopRequireDefault(__webpack_require__(1566));
	
	var _BatteryCharging80Rounded = _interopRequireDefault(__webpack_require__(1567));
	
	var _BatteryCharging80Sharp = _interopRequireDefault(__webpack_require__(1568));
	
	var _BatteryCharging80TwoTone = _interopRequireDefault(__webpack_require__(1569));
	
	var _BatteryCharging6 = _interopRequireDefault(__webpack_require__(1570));
	
	var _BatteryCharging90Outlined = _interopRequireDefault(__webpack_require__(1571));
	
	var _BatteryCharging90Rounded = _interopRequireDefault(__webpack_require__(1572));
	
	var _BatteryCharging90Sharp = _interopRequireDefault(__webpack_require__(1573));
	
	var _BatteryCharging90TwoTone = _interopRequireDefault(__webpack_require__(1574));
	
	var _BatteryChargingFull = _interopRequireDefault(__webpack_require__(1575));
	
	var _BatteryChargingFullOutlined = _interopRequireDefault(__webpack_require__(1576));
	
	var _BatteryChargingFullRounded = _interopRequireDefault(__webpack_require__(1577));
	
	var _BatteryChargingFullSharp = _interopRequireDefault(__webpack_require__(1578));
	
	var _BatteryChargingFullTwoTone = _interopRequireDefault(__webpack_require__(1579));
	
	var _BatteryFull = _interopRequireDefault(__webpack_require__(1580));
	
	var _BatteryFullOutlined = _interopRequireDefault(__webpack_require__(1581));
	
	var _BatteryFullRounded = _interopRequireDefault(__webpack_require__(1582));
	
	var _BatteryFullSharp = _interopRequireDefault(__webpack_require__(1583));
	
	var _BatteryFullTwoTone = _interopRequireDefault(__webpack_require__(1584));
	
	var _BatteryStd = _interopRequireDefault(__webpack_require__(1585));
	
	var _BatteryStdOutlined = _interopRequireDefault(__webpack_require__(1586));
	
	var _BatteryStdRounded = _interopRequireDefault(__webpack_require__(1587));
	
	var _BatteryStdSharp = _interopRequireDefault(__webpack_require__(1588));
	
	var _BatteryStdTwoTone = _interopRequireDefault(__webpack_require__(1589));
	
	var _BatteryUnknown = _interopRequireDefault(__webpack_require__(1590));
	
	var _BatteryUnknownOutlined = _interopRequireDefault(__webpack_require__(1591));
	
	var _BatteryUnknownRounded = _interopRequireDefault(__webpack_require__(1592));
	
	var _BatteryUnknownSharp = _interopRequireDefault(__webpack_require__(1593));
	
	var _BatteryUnknownTwoTone = _interopRequireDefault(__webpack_require__(1594));
	
	var _BeachAccess = _interopRequireDefault(__webpack_require__(1595));
	
	var _BeachAccessOutlined = _interopRequireDefault(__webpack_require__(1596));
	
	var _BeachAccessRounded = _interopRequireDefault(__webpack_require__(1597));
	
	var _BeachAccessSharp = _interopRequireDefault(__webpack_require__(1598));
	
	var _BeachAccessTwoTone = _interopRequireDefault(__webpack_require__(1599));
	
	var _Beenhere = _interopRequireDefault(__webpack_require__(1600));
	
	var _BeenhereOutlined = _interopRequireDefault(__webpack_require__(1601));
	
	var _BeenhereRounded = _interopRequireDefault(__webpack_require__(1602));
	
	var _BeenhereSharp = _interopRequireDefault(__webpack_require__(1603));
	
	var _BeenhereTwoTone = _interopRequireDefault(__webpack_require__(1604));
	
	var _Block = _interopRequireDefault(__webpack_require__(1605));
	
	var _BlockOutlined = _interopRequireDefault(__webpack_require__(1606));
	
	var _BlockRounded = _interopRequireDefault(__webpack_require__(1607));
	
	var _BlockSharp = _interopRequireDefault(__webpack_require__(1608));
	
	var _BlockTwoTone = _interopRequireDefault(__webpack_require__(1609));
	
	var _Bluetooth = _interopRequireDefault(__webpack_require__(1610));
	
	var _BluetoothAudio = _interopRequireDefault(__webpack_require__(1611));
	
	var _BluetoothAudioOutlined = _interopRequireDefault(__webpack_require__(1612));
	
	var _BluetoothAudioRounded = _interopRequireDefault(__webpack_require__(1613));
	
	var _BluetoothAudioSharp = _interopRequireDefault(__webpack_require__(1614));
	
	var _BluetoothAudioTwoTone = _interopRequireDefault(__webpack_require__(1615));
	
	var _BluetoothConnected = _interopRequireDefault(__webpack_require__(1616));
	
	var _BluetoothConnectedOutlined = _interopRequireDefault(__webpack_require__(1617));
	
	var _BluetoothConnectedRounded = _interopRequireDefault(__webpack_require__(1618));
	
	var _BluetoothConnectedSharp = _interopRequireDefault(__webpack_require__(1619));
	
	var _BluetoothConnectedTwoTone = _interopRequireDefault(__webpack_require__(1620));
	
	var _BluetoothDisabled = _interopRequireDefault(__webpack_require__(1621));
	
	var _BluetoothDisabledOutlined = _interopRequireDefault(__webpack_require__(1622));
	
	var _BluetoothDisabledRounded = _interopRequireDefault(__webpack_require__(1623));
	
	var _BluetoothDisabledSharp = _interopRequireDefault(__webpack_require__(1624));
	
	var _BluetoothDisabledTwoTone = _interopRequireDefault(__webpack_require__(1625));
	
	var _BluetoothOutlined = _interopRequireDefault(__webpack_require__(1626));
	
	var _BluetoothRounded = _interopRequireDefault(__webpack_require__(1627));
	
	var _BluetoothSearching = _interopRequireDefault(__webpack_require__(1628));
	
	var _BluetoothSearchingOutlined = _interopRequireDefault(__webpack_require__(1629));
	
	var _BluetoothSearchingRounded = _interopRequireDefault(__webpack_require__(1630));
	
	var _BluetoothSearchingSharp = _interopRequireDefault(__webpack_require__(1631));
	
	var _BluetoothSearchingTwoTone = _interopRequireDefault(__webpack_require__(1632));
	
	var _BluetoothSharp = _interopRequireDefault(__webpack_require__(1633));
	
	var _BluetoothTwoTone = _interopRequireDefault(__webpack_require__(1634));
	
	var _BlurCircular = _interopRequireDefault(__webpack_require__(1635));
	
	var _BlurCircularOutlined = _interopRequireDefault(__webpack_require__(1636));
	
	var _BlurCircularRounded = _interopRequireDefault(__webpack_require__(1637));
	
	var _BlurCircularSharp = _interopRequireDefault(__webpack_require__(1638));
	
	var _BlurCircularTwoTone = _interopRequireDefault(__webpack_require__(1639));
	
	var _BlurLinear = _interopRequireDefault(__webpack_require__(1640));
	
	var _BlurLinearOutlined = _interopRequireDefault(__webpack_require__(1641));
	
	var _BlurLinearRounded = _interopRequireDefault(__webpack_require__(1642));
	
	var _BlurLinearSharp = _interopRequireDefault(__webpack_require__(1643));
	
	var _BlurLinearTwoTone = _interopRequireDefault(__webpack_require__(1644));
	
	var _BlurOff = _interopRequireDefault(__webpack_require__(1645));
	
	var _BlurOffOutlined = _interopRequireDefault(__webpack_require__(1646));
	
	var _BlurOffRounded = _interopRequireDefault(__webpack_require__(1647));
	
	var _BlurOffSharp = _interopRequireDefault(__webpack_require__(1648));
	
	var _BlurOffTwoTone = _interopRequireDefault(__webpack_require__(1649));
	
	var _BlurOn = _interopRequireDefault(__webpack_require__(1650));
	
	var _BlurOnOutlined = _interopRequireDefault(__webpack_require__(1651));
	
	var _BlurOnRounded = _interopRequireDefault(__webpack_require__(1652));
	
	var _BlurOnSharp = _interopRequireDefault(__webpack_require__(1653));
	
	var _BlurOnTwoTone = _interopRequireDefault(__webpack_require__(1654));
	
	var _Book = _interopRequireDefault(__webpack_require__(1655));
	
	var _Bookmark = _interopRequireDefault(__webpack_require__(1660));
	
	var _BookmarkBorder = _interopRequireDefault(__webpack_require__(1661));
	
	var _BookmarkBorderOutlined = _interopRequireDefault(__webpack_require__(1662));
	
	var _BookmarkBorderRounded = _interopRequireDefault(__webpack_require__(1663));
	
	var _BookmarkBorderSharp = _interopRequireDefault(__webpack_require__(1664));
	
	var _BookmarkBorderTwoTone = _interopRequireDefault(__webpack_require__(1665));
	
	var _BookmarkOutlined = _interopRequireDefault(__webpack_require__(1666));
	
	var _BookmarkRounded = _interopRequireDefault(__webpack_require__(1667));
	
	var _Bookmarks = _interopRequireDefault(__webpack_require__(1670));
	
	var _BookmarkSharp = _interopRequireDefault(__webpack_require__(1668));
	
	var _BookmarksOutlined = _interopRequireDefault(__webpack_require__(1671));
	
	var _BookmarksRounded = _interopRequireDefault(__webpack_require__(1672));
	
	var _BookmarksSharp = _interopRequireDefault(__webpack_require__(1673));
	
	var _BookmarksTwoTone = _interopRequireDefault(__webpack_require__(1674));
	
	var _BookmarkTwoTone = _interopRequireDefault(__webpack_require__(1669));
	
	var _BookOutlined = _interopRequireDefault(__webpack_require__(1656));
	
	var _BookRounded = _interopRequireDefault(__webpack_require__(1657));
	
	var _BookSharp = _interopRequireDefault(__webpack_require__(1658));
	
	var _BookTwoTone = _interopRequireDefault(__webpack_require__(1659));
	
	var _BorderAll = _interopRequireDefault(__webpack_require__(1675));
	
	var _BorderAllOutlined = _interopRequireDefault(__webpack_require__(1676));
	
	var _BorderAllRounded = _interopRequireDefault(__webpack_require__(1677));
	
	var _BorderAllSharp = _interopRequireDefault(__webpack_require__(1678));
	
	var _BorderAllTwoTone = _interopRequireDefault(__webpack_require__(1679));
	
	var _BorderBottom = _interopRequireDefault(__webpack_require__(1680));
	
	var _BorderBottomOutlined = _interopRequireDefault(__webpack_require__(1681));
	
	var _BorderBottomRounded = _interopRequireDefault(__webpack_require__(1682));
	
	var _BorderBottomSharp = _interopRequireDefault(__webpack_require__(1683));
	
	var _BorderBottomTwoTone = _interopRequireDefault(__webpack_require__(1684));
	
	var _BorderClear = _interopRequireDefault(__webpack_require__(1685));
	
	var _BorderClearOutlined = _interopRequireDefault(__webpack_require__(1686));
	
	var _BorderClearRounded = _interopRequireDefault(__webpack_require__(1687));
	
	var _BorderClearSharp = _interopRequireDefault(__webpack_require__(1688));
	
	var _BorderClearTwoTone = _interopRequireDefault(__webpack_require__(1689));
	
	var _BorderColor = _interopRequireDefault(__webpack_require__(1690));
	
	var _BorderColorOutlined = _interopRequireDefault(__webpack_require__(1691));
	
	var _BorderColorRounded = _interopRequireDefault(__webpack_require__(1692));
	
	var _BorderColorSharp = _interopRequireDefault(__webpack_require__(1693));
	
	var _BorderColorTwoTone = _interopRequireDefault(__webpack_require__(1694));
	
	var _BorderHorizontal = _interopRequireDefault(__webpack_require__(1695));
	
	var _BorderHorizontalOutlined = _interopRequireDefault(__webpack_require__(1696));
	
	var _BorderHorizontalRounded = _interopRequireDefault(__webpack_require__(1697));
	
	var _BorderHorizontalSharp = _interopRequireDefault(__webpack_require__(1698));
	
	var _BorderHorizontalTwoTone = _interopRequireDefault(__webpack_require__(1699));
	
	var _BorderInner = _interopRequireDefault(__webpack_require__(1700));
	
	var _BorderInnerOutlined = _interopRequireDefault(__webpack_require__(1701));
	
	var _BorderInnerRounded = _interopRequireDefault(__webpack_require__(1702));
	
	var _BorderInnerSharp = _interopRequireDefault(__webpack_require__(1703));
	
	var _BorderInnerTwoTone = _interopRequireDefault(__webpack_require__(1704));
	
	var _BorderLeft = _interopRequireDefault(__webpack_require__(1705));
	
	var _BorderLeftOutlined = _interopRequireDefault(__webpack_require__(1706));
	
	var _BorderLeftRounded = _interopRequireDefault(__webpack_require__(1707));
	
	var _BorderLeftSharp = _interopRequireDefault(__webpack_require__(1708));
	
	var _BorderLeftTwoTone = _interopRequireDefault(__webpack_require__(1709));
	
	var _BorderOuter = _interopRequireDefault(__webpack_require__(1710));
	
	var _BorderOuterOutlined = _interopRequireDefault(__webpack_require__(1711));
	
	var _BorderOuterRounded = _interopRequireDefault(__webpack_require__(1712));
	
	var _BorderOuterSharp = _interopRequireDefault(__webpack_require__(1713));
	
	var _BorderOuterTwoTone = _interopRequireDefault(__webpack_require__(1714));
	
	var _BorderRight = _interopRequireDefault(__webpack_require__(1715));
	
	var _BorderRightOutlined = _interopRequireDefault(__webpack_require__(1716));
	
	var _BorderRightRounded = _interopRequireDefault(__webpack_require__(1717));
	
	var _BorderRightSharp = _interopRequireDefault(__webpack_require__(1718));
	
	var _BorderRightTwoTone = _interopRequireDefault(__webpack_require__(1719));
	
	var _BorderStyle = _interopRequireDefault(__webpack_require__(1720));
	
	var _BorderStyleOutlined = _interopRequireDefault(__webpack_require__(1721));
	
	var _BorderStyleRounded = _interopRequireDefault(__webpack_require__(1722));
	
	var _BorderStyleSharp = _interopRequireDefault(__webpack_require__(1723));
	
	var _BorderStyleTwoTone = _interopRequireDefault(__webpack_require__(1724));
	
	var _BorderTop = _interopRequireDefault(__webpack_require__(1725));
	
	var _BorderTopOutlined = _interopRequireDefault(__webpack_require__(1726));
	
	var _BorderTopRounded = _interopRequireDefault(__webpack_require__(1727));
	
	var _BorderTopSharp = _interopRequireDefault(__webpack_require__(1728));
	
	var _BorderTopTwoTone = _interopRequireDefault(__webpack_require__(1729));
	
	var _BorderVertical = _interopRequireDefault(__webpack_require__(1730));
	
	var _BorderVerticalOutlined = _interopRequireDefault(__webpack_require__(1731));
	
	var _BorderVerticalRounded = _interopRequireDefault(__webpack_require__(1732));
	
	var _BorderVerticalSharp = _interopRequireDefault(__webpack_require__(1733));
	
	var _BorderVerticalTwoTone = _interopRequireDefault(__webpack_require__(1734));
	
	var _BrandingWatermark = _interopRequireDefault(__webpack_require__(1735));
	
	var _BrandingWatermarkOutlined = _interopRequireDefault(__webpack_require__(1736));
	
	var _BrandingWatermarkRounded = _interopRequireDefault(__webpack_require__(1737));
	
	var _BrandingWatermarkSharp = _interopRequireDefault(__webpack_require__(1738));
	
	var _BrandingWatermarkTwoTone = _interopRequireDefault(__webpack_require__(1739));
	
	var _Brightness = _interopRequireDefault(__webpack_require__(1740));
	
	var _Brightness1Outlined = _interopRequireDefault(__webpack_require__(1741));
	
	var _Brightness1Rounded = _interopRequireDefault(__webpack_require__(1742));
	
	var _Brightness1Sharp = _interopRequireDefault(__webpack_require__(1743));
	
	var _Brightness1TwoTone = _interopRequireDefault(__webpack_require__(1744));
	
	var _Brightness2 = _interopRequireDefault(__webpack_require__(1745));
	
	var _Brightness2Outlined = _interopRequireDefault(__webpack_require__(1746));
	
	var _Brightness2Rounded = _interopRequireDefault(__webpack_require__(1747));
	
	var _Brightness2Sharp = _interopRequireDefault(__webpack_require__(1748));
	
	var _Brightness2TwoTone = _interopRequireDefault(__webpack_require__(1749));
	
	var _Brightness3 = _interopRequireDefault(__webpack_require__(1750));
	
	var _Brightness3Outlined = _interopRequireDefault(__webpack_require__(1751));
	
	var _Brightness3Rounded = _interopRequireDefault(__webpack_require__(1752));
	
	var _Brightness3Sharp = _interopRequireDefault(__webpack_require__(1753));
	
	var _Brightness3TwoTone = _interopRequireDefault(__webpack_require__(1754));
	
	var _Brightness4 = _interopRequireDefault(__webpack_require__(1755));
	
	var _Brightness4Outlined = _interopRequireDefault(__webpack_require__(1756));
	
	var _Brightness4Rounded = _interopRequireDefault(__webpack_require__(1757));
	
	var _Brightness4Sharp = _interopRequireDefault(__webpack_require__(1758));
	
	var _Brightness4TwoTone = _interopRequireDefault(__webpack_require__(1759));
	
	var _Brightness5 = _interopRequireDefault(__webpack_require__(1760));
	
	var _Brightness5Outlined = _interopRequireDefault(__webpack_require__(1761));
	
	var _Brightness5Rounded = _interopRequireDefault(__webpack_require__(1762));
	
	var _Brightness5Sharp = _interopRequireDefault(__webpack_require__(1763));
	
	var _Brightness5TwoTone = _interopRequireDefault(__webpack_require__(1764));
	
	var _Brightness6 = _interopRequireDefault(__webpack_require__(1765));
	
	var _Brightness6Outlined = _interopRequireDefault(__webpack_require__(1766));
	
	var _Brightness6Rounded = _interopRequireDefault(__webpack_require__(1767));
	
	var _Brightness6Sharp = _interopRequireDefault(__webpack_require__(1768));
	
	var _Brightness6TwoTone = _interopRequireDefault(__webpack_require__(1769));
	
	var _Brightness7 = _interopRequireDefault(__webpack_require__(1770));
	
	var _Brightness7Outlined = _interopRequireDefault(__webpack_require__(1771));
	
	var _Brightness7Rounded = _interopRequireDefault(__webpack_require__(1772));
	
	var _Brightness7Sharp = _interopRequireDefault(__webpack_require__(1773));
	
	var _Brightness7TwoTone = _interopRequireDefault(__webpack_require__(1774));
	
	var _BrightnessAuto = _interopRequireDefault(__webpack_require__(1775));
	
	var _BrightnessAutoOutlined = _interopRequireDefault(__webpack_require__(1776));
	
	var _BrightnessAutoRounded = _interopRequireDefault(__webpack_require__(1777));
	
	var _BrightnessAutoSharp = _interopRequireDefault(__webpack_require__(1778));
	
	var _BrightnessAutoTwoTone = _interopRequireDefault(__webpack_require__(1779));
	
	var _BrightnessHigh = _interopRequireDefault(__webpack_require__(1780));
	
	var _BrightnessHighOutlined = _interopRequireDefault(__webpack_require__(1781));
	
	var _BrightnessHighRounded = _interopRequireDefault(__webpack_require__(1782));
	
	var _BrightnessHighSharp = _interopRequireDefault(__webpack_require__(1783));
	
	var _BrightnessHighTwoTone = _interopRequireDefault(__webpack_require__(1784));
	
	var _BrightnessLow = _interopRequireDefault(__webpack_require__(1785));
	
	var _BrightnessLowOutlined = _interopRequireDefault(__webpack_require__(1786));
	
	var _BrightnessLowRounded = _interopRequireDefault(__webpack_require__(1787));
	
	var _BrightnessLowSharp = _interopRequireDefault(__webpack_require__(1788));
	
	var _BrightnessLowTwoTone = _interopRequireDefault(__webpack_require__(1789));
	
	var _BrightnessMedium = _interopRequireDefault(__webpack_require__(1790));
	
	var _BrightnessMediumOutlined = _interopRequireDefault(__webpack_require__(1791));
	
	var _BrightnessMediumRounded = _interopRequireDefault(__webpack_require__(1792));
	
	var _BrightnessMediumSharp = _interopRequireDefault(__webpack_require__(1793));
	
	var _BrightnessMediumTwoTone = _interopRequireDefault(__webpack_require__(1794));
	
	var _BrokenImage = _interopRequireDefault(__webpack_require__(1795));
	
	var _BrokenImageOutlined = _interopRequireDefault(__webpack_require__(1796));
	
	var _BrokenImageRounded = _interopRequireDefault(__webpack_require__(1797));
	
	var _BrokenImageSharp = _interopRequireDefault(__webpack_require__(1798));
	
	var _BrokenImageTwoTone = _interopRequireDefault(__webpack_require__(1799));
	
	var _Brush = _interopRequireDefault(__webpack_require__(1800));
	
	var _BrushOutlined = _interopRequireDefault(__webpack_require__(1801));
	
	var _BrushRounded = _interopRequireDefault(__webpack_require__(1802));
	
	var _BrushSharp = _interopRequireDefault(__webpack_require__(1803));
	
	var _BrushTwoTone = _interopRequireDefault(__webpack_require__(1804));
	
	var _BubbleChart = _interopRequireDefault(__webpack_require__(1805));
	
	var _BubbleChartOutlined = _interopRequireDefault(__webpack_require__(1806));
	
	var _BubbleChartRounded = _interopRequireDefault(__webpack_require__(1807));
	
	var _BubbleChartSharp = _interopRequireDefault(__webpack_require__(1808));
	
	var _BubbleChartTwoTone = _interopRequireDefault(__webpack_require__(1809));
	
	var _BugReport = _interopRequireDefault(__webpack_require__(1810));
	
	var _BugReportOutlined = _interopRequireDefault(__webpack_require__(1811));
	
	var _BugReportRounded = _interopRequireDefault(__webpack_require__(1812));
	
	var _BugReportSharp = _interopRequireDefault(__webpack_require__(1813));
	
	var _BugReportTwoTone = _interopRequireDefault(__webpack_require__(1814));
	
	var _Build = _interopRequireDefault(__webpack_require__(1815));
	
	var _BuildOutlined = _interopRequireDefault(__webpack_require__(1816));
	
	var _BuildRounded = _interopRequireDefault(__webpack_require__(1817));
	
	var _BuildSharp = _interopRequireDefault(__webpack_require__(1818));
	
	var _BuildTwoTone = _interopRequireDefault(__webpack_require__(1819));
	
	var _BurstMode = _interopRequireDefault(__webpack_require__(1820));
	
	var _BurstModeOutlined = _interopRequireDefault(__webpack_require__(1821));
	
	var _BurstModeRounded = _interopRequireDefault(__webpack_require__(1822));
	
	var _BurstModeSharp = _interopRequireDefault(__webpack_require__(1823));
	
	var _BurstModeTwoTone = _interopRequireDefault(__webpack_require__(1824));
	
	var _Business = _interopRequireDefault(__webpack_require__(1825));
	
	var _BusinessCenter = _interopRequireDefault(__webpack_require__(1826));
	
	var _BusinessCenterOutlined = _interopRequireDefault(__webpack_require__(1827));
	
	var _BusinessCenterRounded = _interopRequireDefault(__webpack_require__(1828));
	
	var _BusinessCenterSharp = _interopRequireDefault(__webpack_require__(1829));
	
	var _BusinessCenterTwoTone = _interopRequireDefault(__webpack_require__(1830));
	
	var _BusinessOutlined = _interopRequireDefault(__webpack_require__(1831));
	
	var _BusinessRounded = _interopRequireDefault(__webpack_require__(1832));
	
	var _BusinessSharp = _interopRequireDefault(__webpack_require__(1833));
	
	var _BusinessTwoTone = _interopRequireDefault(__webpack_require__(1834));
	
	var _Cached = _interopRequireDefault(__webpack_require__(1835));
	
	var _CachedOutlined = _interopRequireDefault(__webpack_require__(1836));
	
	var _CachedRounded = _interopRequireDefault(__webpack_require__(1837));
	
	var _CachedSharp = _interopRequireDefault(__webpack_require__(1838));
	
	var _CachedTwoTone = _interopRequireDefault(__webpack_require__(1839));
	
	var _Cake = _interopRequireDefault(__webpack_require__(1840));
	
	var _CakeOutlined = _interopRequireDefault(__webpack_require__(1841));
	
	var _CakeRounded = _interopRequireDefault(__webpack_require__(1842));
	
	var _CakeSharp = _interopRequireDefault(__webpack_require__(1843));
	
	var _CakeTwoTone = _interopRequireDefault(__webpack_require__(1844));
	
	var _CalendarToday = _interopRequireDefault(__webpack_require__(1845));
	
	var _CalendarTodayOutlined = _interopRequireDefault(__webpack_require__(1846));
	
	var _CalendarTodayRounded = _interopRequireDefault(__webpack_require__(1847));
	
	var _CalendarTodaySharp = _interopRequireDefault(__webpack_require__(1848));
	
	var _CalendarTodayTwoTone = _interopRequireDefault(__webpack_require__(1849));
	
	var _CalendarViewDay = _interopRequireDefault(__webpack_require__(1850));
	
	var _CalendarViewDayOutlined = _interopRequireDefault(__webpack_require__(1851));
	
	var _CalendarViewDayRounded = _interopRequireDefault(__webpack_require__(1852));
	
	var _CalendarViewDaySharp = _interopRequireDefault(__webpack_require__(1853));
	
	var _CalendarViewDayTwoTone = _interopRequireDefault(__webpack_require__(1854));
	
	var _Call = _interopRequireDefault(__webpack_require__(1855));
	
	var _CallEnd = _interopRequireDefault(__webpack_require__(1856));
	
	var _CallEndOutlined = _interopRequireDefault(__webpack_require__(1857));
	
	var _CallEndRounded = _interopRequireDefault(__webpack_require__(1858));
	
	var _CallEndSharp = _interopRequireDefault(__webpack_require__(1859));
	
	var _CallEndTwoTone = _interopRequireDefault(__webpack_require__(1860));
	
	var _CallMade = _interopRequireDefault(__webpack_require__(1861));
	
	var _CallMadeOutlined = _interopRequireDefault(__webpack_require__(1862));
	
	var _CallMadeRounded = _interopRequireDefault(__webpack_require__(1863));
	
	var _CallMadeSharp = _interopRequireDefault(__webpack_require__(1864));
	
	var _CallMadeTwoTone = _interopRequireDefault(__webpack_require__(1865));
	
	var _CallMerge = _interopRequireDefault(__webpack_require__(1866));
	
	var _CallMergeOutlined = _interopRequireDefault(__webpack_require__(1867));
	
	var _CallMergeRounded = _interopRequireDefault(__webpack_require__(1868));
	
	var _CallMergeSharp = _interopRequireDefault(__webpack_require__(1869));
	
	var _CallMergeTwoTone = _interopRequireDefault(__webpack_require__(1870));
	
	var _CallMissed = _interopRequireDefault(__webpack_require__(1871));
	
	var _CallMissedOutgoing = _interopRequireDefault(__webpack_require__(1872));
	
	var _CallMissedOutgoingOutlined = _interopRequireDefault(__webpack_require__(1873));
	
	var _CallMissedOutgoingRounded = _interopRequireDefault(__webpack_require__(1874));
	
	var _CallMissedOutgoingSharp = _interopRequireDefault(__webpack_require__(1875));
	
	var _CallMissedOutgoingTwoTone = _interopRequireDefault(__webpack_require__(1876));
	
	var _CallMissedOutlined = _interopRequireDefault(__webpack_require__(1877));
	
	var _CallMissedRounded = _interopRequireDefault(__webpack_require__(1878));
	
	var _CallMissedSharp = _interopRequireDefault(__webpack_require__(1879));
	
	var _CallMissedTwoTone = _interopRequireDefault(__webpack_require__(1880));
	
	var _CallOutlined = _interopRequireDefault(__webpack_require__(1881));
	
	var _CallReceived = _interopRequireDefault(__webpack_require__(1882));
	
	var _CallReceivedOutlined = _interopRequireDefault(__webpack_require__(1883));
	
	var _CallReceivedRounded = _interopRequireDefault(__webpack_require__(1884));
	
	var _CallReceivedSharp = _interopRequireDefault(__webpack_require__(1885));
	
	var _CallReceivedTwoTone = _interopRequireDefault(__webpack_require__(1886));
	
	var _CallRounded = _interopRequireDefault(__webpack_require__(1887));
	
	var _CallSharp = _interopRequireDefault(__webpack_require__(1888));
	
	var _CallSplit = _interopRequireDefault(__webpack_require__(1889));
	
	var _CallSplitOutlined = _interopRequireDefault(__webpack_require__(1890));
	
	var _CallSplitRounded = _interopRequireDefault(__webpack_require__(1891));
	
	var _CallSplitSharp = _interopRequireDefault(__webpack_require__(1892));
	
	var _CallSplitTwoTone = _interopRequireDefault(__webpack_require__(1893));
	
	var _CallToAction = _interopRequireDefault(__webpack_require__(1894));
	
	var _CallToActionOutlined = _interopRequireDefault(__webpack_require__(1895));
	
	var _CallToActionRounded = _interopRequireDefault(__webpack_require__(1896));
	
	var _CallToActionSharp = _interopRequireDefault(__webpack_require__(1897));
	
	var _CallToActionTwoTone = _interopRequireDefault(__webpack_require__(1898));
	
	var _CallTwoTone = _interopRequireDefault(__webpack_require__(1899));
	
	var _Camera = _interopRequireDefault(__webpack_require__(1900));
	
	var _CameraAlt = _interopRequireDefault(__webpack_require__(1901));
	
	var _CameraAltOutlined = _interopRequireDefault(__webpack_require__(1902));
	
	var _CameraAltRounded = _interopRequireDefault(__webpack_require__(1903));
	
	var _CameraAltSharp = _interopRequireDefault(__webpack_require__(1904));
	
	var _CameraAltTwoTone = _interopRequireDefault(__webpack_require__(1905));
	
	var _CameraEnhance = _interopRequireDefault(__webpack_require__(1906));
	
	var _CameraEnhanceOutlined = _interopRequireDefault(__webpack_require__(1907));
	
	var _CameraEnhanceRounded = _interopRequireDefault(__webpack_require__(1908));
	
	var _CameraEnhanceSharp = _interopRequireDefault(__webpack_require__(1909));
	
	var _CameraEnhanceTwoTone = _interopRequireDefault(__webpack_require__(1910));
	
	var _CameraFront = _interopRequireDefault(__webpack_require__(1911));
	
	var _CameraFrontOutlined = _interopRequireDefault(__webpack_require__(1912));
	
	var _CameraFrontRounded = _interopRequireDefault(__webpack_require__(1913));
	
	var _CameraFrontSharp = _interopRequireDefault(__webpack_require__(1914));
	
	var _CameraFrontTwoTone = _interopRequireDefault(__webpack_require__(1915));
	
	var _CameraOutlined = _interopRequireDefault(__webpack_require__(1916));
	
	var _CameraRear = _interopRequireDefault(__webpack_require__(1917));
	
	var _CameraRearOutlined = _interopRequireDefault(__webpack_require__(1918));
	
	var _CameraRearRounded = _interopRequireDefault(__webpack_require__(1919));
	
	var _CameraRearSharp = _interopRequireDefault(__webpack_require__(1920));
	
	var _CameraRearTwoTone = _interopRequireDefault(__webpack_require__(1921));
	
	var _CameraRoll = _interopRequireDefault(__webpack_require__(1922));
	
	var _CameraRollOutlined = _interopRequireDefault(__webpack_require__(1923));
	
	var _CameraRollRounded = _interopRequireDefault(__webpack_require__(1924));
	
	var _CameraRollSharp = _interopRequireDefault(__webpack_require__(1925));
	
	var _CameraRollTwoTone = _interopRequireDefault(__webpack_require__(1926));
	
	var _CameraRounded = _interopRequireDefault(__webpack_require__(1927));
	
	var _CameraSharp = _interopRequireDefault(__webpack_require__(1928));
	
	var _CameraTwoTone = _interopRequireDefault(__webpack_require__(1929));
	
	var _Cancel = _interopRequireDefault(__webpack_require__(1930));
	
	var _CancelOutlined = _interopRequireDefault(__webpack_require__(1931));
	
	var _CancelPresentation = _interopRequireDefault(__webpack_require__(1932));
	
	var _CancelPresentationOutlined = _interopRequireDefault(__webpack_require__(1933));
	
	var _CancelPresentationRounded = _interopRequireDefault(__webpack_require__(1934));
	
	var _CancelPresentationSharp = _interopRequireDefault(__webpack_require__(1935));
	
	var _CancelPresentationTwoTone = _interopRequireDefault(__webpack_require__(1936));
	
	var _CancelRounded = _interopRequireDefault(__webpack_require__(1937));
	
	var _CancelScheduleSend = _interopRequireDefault(__webpack_require__(1938));
	
	var _CancelScheduleSendOutlined = _interopRequireDefault(__webpack_require__(1939));
	
	var _CancelScheduleSendRounded = _interopRequireDefault(__webpack_require__(1940));
	
	var _CancelScheduleSendSharp = _interopRequireDefault(__webpack_require__(1941));
	
	var _CancelScheduleSendTwoTone = _interopRequireDefault(__webpack_require__(1942));
	
	var _CancelSharp = _interopRequireDefault(__webpack_require__(1943));
	
	var _CancelTwoTone = _interopRequireDefault(__webpack_require__(1944));
	
	var _CardGiftcard = _interopRequireDefault(__webpack_require__(1945));
	
	var _CardGiftcardOutlined = _interopRequireDefault(__webpack_require__(1946));
	
	var _CardGiftcardRounded = _interopRequireDefault(__webpack_require__(1947));
	
	var _CardGiftcardSharp = _interopRequireDefault(__webpack_require__(1948));
	
	var _CardGiftcardTwoTone = _interopRequireDefault(__webpack_require__(1949));
	
	var _CardMembership = _interopRequireDefault(__webpack_require__(1950));
	
	var _CardMembershipOutlined = _interopRequireDefault(__webpack_require__(1951));
	
	var _CardMembershipRounded = _interopRequireDefault(__webpack_require__(1952));
	
	var _CardMembershipSharp = _interopRequireDefault(__webpack_require__(1953));
	
	var _CardMembershipTwoTone = _interopRequireDefault(__webpack_require__(1954));
	
	var _CardTravel = _interopRequireDefault(__webpack_require__(1955));
	
	var _CardTravelOutlined = _interopRequireDefault(__webpack_require__(1956));
	
	var _CardTravelRounded = _interopRequireDefault(__webpack_require__(1957));
	
	var _CardTravelSharp = _interopRequireDefault(__webpack_require__(1958));
	
	var _CardTravelTwoTone = _interopRequireDefault(__webpack_require__(1959));
	
	var _Casino = _interopRequireDefault(__webpack_require__(1960));
	
	var _CasinoOutlined = _interopRequireDefault(__webpack_require__(1961));
	
	var _CasinoRounded = _interopRequireDefault(__webpack_require__(1962));
	
	var _CasinoSharp = _interopRequireDefault(__webpack_require__(1963));
	
	var _CasinoTwoTone = _interopRequireDefault(__webpack_require__(1964));
	
	var _Cast = _interopRequireDefault(__webpack_require__(1965));
	
	var _CastConnected = _interopRequireDefault(__webpack_require__(1966));
	
	var _CastConnectedOutlined = _interopRequireDefault(__webpack_require__(1967));
	
	var _CastConnectedRounded = _interopRequireDefault(__webpack_require__(1968));
	
	var _CastConnectedSharp = _interopRequireDefault(__webpack_require__(1969));
	
	var _CastConnectedTwoTone = _interopRequireDefault(__webpack_require__(1970));
	
	var _CastForEducation = _interopRequireDefault(__webpack_require__(1971));
	
	var _CastForEducationOutlined = _interopRequireDefault(__webpack_require__(1972));
	
	var _CastForEducationRounded = _interopRequireDefault(__webpack_require__(1973));
	
	var _CastForEducationSharp = _interopRequireDefault(__webpack_require__(1974));
	
	var _CastForEducationTwoTone = _interopRequireDefault(__webpack_require__(1975));
	
	var _CastOutlined = _interopRequireDefault(__webpack_require__(1976));
	
	var _CastRounded = _interopRequireDefault(__webpack_require__(1977));
	
	var _CastSharp = _interopRequireDefault(__webpack_require__(1978));
	
	var _CastTwoTone = _interopRequireDefault(__webpack_require__(1979));
	
	var _Category = _interopRequireDefault(__webpack_require__(1980));
	
	var _CategoryOutlined = _interopRequireDefault(__webpack_require__(1981));
	
	var _CategoryRounded = _interopRequireDefault(__webpack_require__(1982));
	
	var _CategorySharp = _interopRequireDefault(__webpack_require__(1983));
	
	var _CategoryTwoTone = _interopRequireDefault(__webpack_require__(1984));
	
	var _CellWifi = _interopRequireDefault(__webpack_require__(1985));
	
	var _CellWifiOutlined = _interopRequireDefault(__webpack_require__(1986));
	
	var _CellWifiRounded = _interopRequireDefault(__webpack_require__(1987));
	
	var _CellWifiSharp = _interopRequireDefault(__webpack_require__(1988));
	
	var _CellWifiTwoTone = _interopRequireDefault(__webpack_require__(1989));
	
	var _CenterFocusStrong = _interopRequireDefault(__webpack_require__(1990));
	
	var _CenterFocusStrongOutlined = _interopRequireDefault(__webpack_require__(1991));
	
	var _CenterFocusStrongRounded = _interopRequireDefault(__webpack_require__(1992));
	
	var _CenterFocusStrongSharp = _interopRequireDefault(__webpack_require__(1993));
	
	var _CenterFocusStrongTwoTone = _interopRequireDefault(__webpack_require__(1994));
	
	var _CenterFocusWeak = _interopRequireDefault(__webpack_require__(1995));
	
	var _CenterFocusWeakOutlined = _interopRequireDefault(__webpack_require__(1996));
	
	var _CenterFocusWeakRounded = _interopRequireDefault(__webpack_require__(1997));
	
	var _CenterFocusWeakSharp = _interopRequireDefault(__webpack_require__(1998));
	
	var _CenterFocusWeakTwoTone = _interopRequireDefault(__webpack_require__(1999));
	
	var _ChangeHistory = _interopRequireDefault(__webpack_require__(2000));
	
	var _ChangeHistoryOutlined = _interopRequireDefault(__webpack_require__(2001));
	
	var _ChangeHistoryRounded = _interopRequireDefault(__webpack_require__(2002));
	
	var _ChangeHistorySharp = _interopRequireDefault(__webpack_require__(2003));
	
	var _ChangeHistoryTwoTone = _interopRequireDefault(__webpack_require__(2004));
	
	var _Chat = _interopRequireDefault(__webpack_require__(2005));
	
	var _ChatBubble = _interopRequireDefault(__webpack_require__(2006));
	
	var _ChatBubbleOutline = _interopRequireDefault(__webpack_require__(2007));
	
	var _ChatBubbleOutlined = _interopRequireDefault(__webpack_require__(2012));
	
	var _ChatBubbleOutlineOutlined = _interopRequireDefault(__webpack_require__(2008));
	
	var _ChatBubbleOutlineRounded = _interopRequireDefault(__webpack_require__(2009));
	
	var _ChatBubbleOutlineSharp = _interopRequireDefault(__webpack_require__(2010));
	
	var _ChatBubbleOutlineTwoTone = _interopRequireDefault(__webpack_require__(2011));
	
	var _ChatBubbleRounded = _interopRequireDefault(__webpack_require__(2013));
	
	var _ChatBubbleSharp = _interopRequireDefault(__webpack_require__(2014));
	
	var _ChatBubbleTwoTone = _interopRequireDefault(__webpack_require__(2015));
	
	var _ChatOutlined = _interopRequireDefault(__webpack_require__(2016));
	
	var _ChatRounded = _interopRequireDefault(__webpack_require__(2017));
	
	var _ChatSharp = _interopRequireDefault(__webpack_require__(2018));
	
	var _ChatTwoTone = _interopRequireDefault(__webpack_require__(2019));
	
	var _Check = _interopRequireDefault(__webpack_require__(2020));
	
	var _CheckBox = _interopRequireDefault(__webpack_require__(2021));
	
	var _CheckBoxOutlineBlank = _interopRequireDefault(__webpack_require__(2022));
	
	var _CheckBoxOutlineBlankOutlined = _interopRequireDefault(__webpack_require__(2023));
	
	var _CheckBoxOutlineBlankRounded = _interopRequireDefault(__webpack_require__(2024));
	
	var _CheckBoxOutlineBlankSharp = _interopRequireDefault(__webpack_require__(2025));
	
	var _CheckBoxOutlineBlankTwoTone = _interopRequireDefault(__webpack_require__(2026));
	
	var _CheckBoxOutlined = _interopRequireDefault(__webpack_require__(2027));
	
	var _CheckBoxRounded = _interopRequireDefault(__webpack_require__(2028));
	
	var _CheckBoxSharp = _interopRequireDefault(__webpack_require__(2029));
	
	var _CheckBoxTwoTone = _interopRequireDefault(__webpack_require__(2030));
	
	var _CheckCircle = _interopRequireDefault(__webpack_require__(2031));
	
	var _CheckCircleOutline = _interopRequireDefault(__webpack_require__(2032));
	
	var _CheckCircleOutlined = _interopRequireDefault(__webpack_require__(2037));
	
	var _CheckCircleOutlineOutlined = _interopRequireDefault(__webpack_require__(2033));
	
	var _CheckCircleOutlineRounded = _interopRequireDefault(__webpack_require__(2034));
	
	var _CheckCircleOutlineSharp = _interopRequireDefault(__webpack_require__(2035));
	
	var _CheckCircleOutlineTwoTone = _interopRequireDefault(__webpack_require__(2036));
	
	var _CheckCircleRounded = _interopRequireDefault(__webpack_require__(2038));
	
	var _CheckCircleSharp = _interopRequireDefault(__webpack_require__(2039));
	
	var _CheckCircleTwoTone = _interopRequireDefault(__webpack_require__(2040));
	
	var _CheckOutlined = _interopRequireDefault(__webpack_require__(2041));
	
	var _CheckRounded = _interopRequireDefault(__webpack_require__(2042));
	
	var _CheckSharp = _interopRequireDefault(__webpack_require__(2043));
	
	var _CheckTwoTone = _interopRequireDefault(__webpack_require__(2044));
	
	var _ChevronLeft = _interopRequireDefault(__webpack_require__(2045));
	
	var _ChevronLeftOutlined = _interopRequireDefault(__webpack_require__(2046));
	
	var _ChevronLeftRounded = _interopRequireDefault(__webpack_require__(2047));
	
	var _ChevronLeftSharp = _interopRequireDefault(__webpack_require__(2048));
	
	var _ChevronLeftTwoTone = _interopRequireDefault(__webpack_require__(2049));
	
	var _ChevronRight = _interopRequireDefault(__webpack_require__(2050));
	
	var _ChevronRightOutlined = _interopRequireDefault(__webpack_require__(2051));
	
	var _ChevronRightRounded = _interopRequireDefault(__webpack_require__(2052));
	
	var _ChevronRightSharp = _interopRequireDefault(__webpack_require__(2053));
	
	var _ChevronRightTwoTone = _interopRequireDefault(__webpack_require__(2054));
	
	var _ChildCare = _interopRequireDefault(__webpack_require__(2055));
	
	var _ChildCareOutlined = _interopRequireDefault(__webpack_require__(2056));
	
	var _ChildCareRounded = _interopRequireDefault(__webpack_require__(2057));
	
	var _ChildCareSharp = _interopRequireDefault(__webpack_require__(2058));
	
	var _ChildCareTwoTone = _interopRequireDefault(__webpack_require__(2059));
	
	var _ChildFriendly = _interopRequireDefault(__webpack_require__(2060));
	
	var _ChildFriendlyOutlined = _interopRequireDefault(__webpack_require__(2061));
	
	var _ChildFriendlyRounded = _interopRequireDefault(__webpack_require__(2062));
	
	var _ChildFriendlySharp = _interopRequireDefault(__webpack_require__(2063));
	
	var _ChildFriendlyTwoTone = _interopRequireDefault(__webpack_require__(2064));
	
	var _ChromeReaderMode = _interopRequireDefault(__webpack_require__(2065));
	
	var _ChromeReaderModeOutlined = _interopRequireDefault(__webpack_require__(2066));
	
	var _ChromeReaderModeRounded = _interopRequireDefault(__webpack_require__(2067));
	
	var _ChromeReaderModeSharp = _interopRequireDefault(__webpack_require__(2068));
	
	var _ChromeReaderModeTwoTone = _interopRequireDefault(__webpack_require__(2069));
	
	var _Class = _interopRequireDefault(__webpack_require__(2070));
	
	var _ClassOutlined = _interopRequireDefault(__webpack_require__(2071));
	
	var _ClassRounded = _interopRequireDefault(__webpack_require__(2072));
	
	var _ClassSharp = _interopRequireDefault(__webpack_require__(2073));
	
	var _ClassTwoTone = _interopRequireDefault(__webpack_require__(2074));
	
	var _Clear = _interopRequireDefault(__webpack_require__(2075));
	
	var _ClearAll = _interopRequireDefault(__webpack_require__(2076));
	
	var _ClearAllOutlined = _interopRequireDefault(__webpack_require__(2077));
	
	var _ClearAllRounded = _interopRequireDefault(__webpack_require__(2078));
	
	var _ClearAllSharp = _interopRequireDefault(__webpack_require__(2079));
	
	var _ClearAllTwoTone = _interopRequireDefault(__webpack_require__(2080));
	
	var _ClearOutlined = _interopRequireDefault(__webpack_require__(2081));
	
	var _ClearRounded = _interopRequireDefault(__webpack_require__(2082));
	
	var _ClearSharp = _interopRequireDefault(__webpack_require__(2083));
	
	var _ClearTwoTone = _interopRequireDefault(__webpack_require__(2084));
	
	var _Close = _interopRequireDefault(__webpack_require__(2085));
	
	var _ClosedCaption = _interopRequireDefault(__webpack_require__(2090));
	
	var _ClosedCaptionOutlined = _interopRequireDefault(__webpack_require__(2091));
	
	var _ClosedCaptionRounded = _interopRequireDefault(__webpack_require__(2092));
	
	var _ClosedCaptionSharp = _interopRequireDefault(__webpack_require__(2093));
	
	var _ClosedCaptionTwoTone = _interopRequireDefault(__webpack_require__(2094));
	
	var _CloseOutlined = _interopRequireDefault(__webpack_require__(2086));
	
	var _CloseRounded = _interopRequireDefault(__webpack_require__(2087));
	
	var _CloseSharp = _interopRequireDefault(__webpack_require__(2088));
	
	var _CloseTwoTone = _interopRequireDefault(__webpack_require__(2089));
	
	var _Cloud = _interopRequireDefault(__webpack_require__(2095));
	
	var _CloudCircle = _interopRequireDefault(__webpack_require__(2096));
	
	var _CloudCircleOutlined = _interopRequireDefault(__webpack_require__(2097));
	
	var _CloudCircleRounded = _interopRequireDefault(__webpack_require__(2098));
	
	var _CloudCircleSharp = _interopRequireDefault(__webpack_require__(2099));
	
	var _CloudCircleTwoTone = _interopRequireDefault(__webpack_require__(2100));
	
	var _CloudDone = _interopRequireDefault(__webpack_require__(2101));
	
	var _CloudDoneOutlined = _interopRequireDefault(__webpack_require__(2102));
	
	var _CloudDoneRounded = _interopRequireDefault(__webpack_require__(2103));
	
	var _CloudDoneSharp = _interopRequireDefault(__webpack_require__(2104));
	
	var _CloudDoneTwoTone = _interopRequireDefault(__webpack_require__(2105));
	
	var _CloudDownload = _interopRequireDefault(__webpack_require__(2106));
	
	var _CloudDownloadOutlined = _interopRequireDefault(__webpack_require__(2107));
	
	var _CloudDownloadRounded = _interopRequireDefault(__webpack_require__(2108));
	
	var _CloudDownloadSharp = _interopRequireDefault(__webpack_require__(2109));
	
	var _CloudDownloadTwoTone = _interopRequireDefault(__webpack_require__(2110));
	
	var _CloudOff = _interopRequireDefault(__webpack_require__(2111));
	
	var _CloudOffOutlined = _interopRequireDefault(__webpack_require__(2112));
	
	var _CloudOffRounded = _interopRequireDefault(__webpack_require__(2113));
	
	var _CloudOffSharp = _interopRequireDefault(__webpack_require__(2114));
	
	var _CloudOffTwoTone = _interopRequireDefault(__webpack_require__(2115));
	
	var _CloudOutlined = _interopRequireDefault(__webpack_require__(2116));
	
	var _CloudQueue = _interopRequireDefault(__webpack_require__(2117));
	
	var _CloudQueueOutlined = _interopRequireDefault(__webpack_require__(2118));
	
	var _CloudQueueRounded = _interopRequireDefault(__webpack_require__(2119));
	
	var _CloudQueueSharp = _interopRequireDefault(__webpack_require__(2120));
	
	var _CloudQueueTwoTone = _interopRequireDefault(__webpack_require__(2121));
	
	var _CloudRounded = _interopRequireDefault(__webpack_require__(2122));
	
	var _CloudSharp = _interopRequireDefault(__webpack_require__(2123));
	
	var _CloudTwoTone = _interopRequireDefault(__webpack_require__(2124));
	
	var _CloudUpload = _interopRequireDefault(__webpack_require__(2125));
	
	var _CloudUploadOutlined = _interopRequireDefault(__webpack_require__(2126));
	
	var _CloudUploadRounded = _interopRequireDefault(__webpack_require__(2127));
	
	var _CloudUploadSharp = _interopRequireDefault(__webpack_require__(2128));
	
	var _CloudUploadTwoTone = _interopRequireDefault(__webpack_require__(2129));
	
	var _Code = _interopRequireDefault(__webpack_require__(2130));
	
	var _CodeOutlined = _interopRequireDefault(__webpack_require__(2131));
	
	var _CodeRounded = _interopRequireDefault(__webpack_require__(2132));
	
	var _CodeSharp = _interopRequireDefault(__webpack_require__(2133));
	
	var _CodeTwoTone = _interopRequireDefault(__webpack_require__(2134));
	
	var _Collections = _interopRequireDefault(__webpack_require__(2135));
	
	var _CollectionsBookmark = _interopRequireDefault(__webpack_require__(2136));
	
	var _CollectionsBookmarkOutlined = _interopRequireDefault(__webpack_require__(2137));
	
	var _CollectionsBookmarkRounded = _interopRequireDefault(__webpack_require__(2138));
	
	var _CollectionsBookmarkSharp = _interopRequireDefault(__webpack_require__(2139));
	
	var _CollectionsBookmarkTwoTone = _interopRequireDefault(__webpack_require__(2140));
	
	var _CollectionsOutlined = _interopRequireDefault(__webpack_require__(2141));
	
	var _CollectionsRounded = _interopRequireDefault(__webpack_require__(2142));
	
	var _CollectionsSharp = _interopRequireDefault(__webpack_require__(2143));
	
	var _CollectionsTwoTone = _interopRequireDefault(__webpack_require__(2144));
	
	var _Colorize = _interopRequireDefault(__webpack_require__(2150));
	
	var _ColorizeOutlined = _interopRequireDefault(__webpack_require__(2151));
	
	var _ColorizeRounded = _interopRequireDefault(__webpack_require__(2152));
	
	var _ColorizeSharp = _interopRequireDefault(__webpack_require__(2153));
	
	var _ColorizeTwoTone = _interopRequireDefault(__webpack_require__(2154));
	
	var _ColorLens = _interopRequireDefault(__webpack_require__(2145));
	
	var _ColorLensOutlined = _interopRequireDefault(__webpack_require__(2146));
	
	var _ColorLensRounded = _interopRequireDefault(__webpack_require__(2147));
	
	var _ColorLensSharp = _interopRequireDefault(__webpack_require__(2148));
	
	var _ColorLensTwoTone = _interopRequireDefault(__webpack_require__(2149));
	
	var _Comment = _interopRequireDefault(__webpack_require__(2155));
	
	var _CommentOutlined = _interopRequireDefault(__webpack_require__(2156));
	
	var _CommentRounded = _interopRequireDefault(__webpack_require__(2157));
	
	var _CommentSharp = _interopRequireDefault(__webpack_require__(2158));
	
	var _CommentTwoTone = _interopRequireDefault(__webpack_require__(2159));
	
	var _Commute = _interopRequireDefault(__webpack_require__(2160));
	
	var _CommuteOutlined = _interopRequireDefault(__webpack_require__(2161));
	
	var _CommuteRounded = _interopRequireDefault(__webpack_require__(2162));
	
	var _CommuteSharp = _interopRequireDefault(__webpack_require__(2163));
	
	var _CommuteTwoTone = _interopRequireDefault(__webpack_require__(2164));
	
	var _Compare = _interopRequireDefault(__webpack_require__(2165));
	
	var _CompareArrows = _interopRequireDefault(__webpack_require__(2166));
	
	var _CompareArrowsOutlined = _interopRequireDefault(__webpack_require__(2167));
	
	var _CompareArrowsRounded = _interopRequireDefault(__webpack_require__(2168));
	
	var _CompareArrowsSharp = _interopRequireDefault(__webpack_require__(2169));
	
	var _CompareArrowsTwoTone = _interopRequireDefault(__webpack_require__(2170));
	
	var _CompareOutlined = _interopRequireDefault(__webpack_require__(2171));
	
	var _CompareRounded = _interopRequireDefault(__webpack_require__(2172));
	
	var _CompareSharp = _interopRequireDefault(__webpack_require__(2173));
	
	var _CompareTwoTone = _interopRequireDefault(__webpack_require__(2174));
	
	var _CompassCalibration = _interopRequireDefault(__webpack_require__(2175));
	
	var _CompassCalibrationOutlined = _interopRequireDefault(__webpack_require__(2176));
	
	var _CompassCalibrationRounded = _interopRequireDefault(__webpack_require__(2177));
	
	var _CompassCalibrationSharp = _interopRequireDefault(__webpack_require__(2178));
	
	var _CompassCalibrationTwoTone = _interopRequireDefault(__webpack_require__(2179));
	
	var _Computer = _interopRequireDefault(__webpack_require__(2180));
	
	var _ComputerOutlined = _interopRequireDefault(__webpack_require__(2181));
	
	var _ComputerRounded = _interopRequireDefault(__webpack_require__(2182));
	
	var _ComputerSharp = _interopRequireDefault(__webpack_require__(2183));
	
	var _ComputerTwoTone = _interopRequireDefault(__webpack_require__(2184));
	
	var _ConfirmationNumber = _interopRequireDefault(__webpack_require__(2185));
	
	var _ConfirmationNumberOutlined = _interopRequireDefault(__webpack_require__(2186));
	
	var _ConfirmationNumberRounded = _interopRequireDefault(__webpack_require__(2187));
	
	var _ConfirmationNumberSharp = _interopRequireDefault(__webpack_require__(2188));
	
	var _ConfirmationNumberTwoTone = _interopRequireDefault(__webpack_require__(2189));
	
	var _Contactless = _interopRequireDefault(__webpack_require__(2205));
	
	var _ContactlessOutlined = _interopRequireDefault(__webpack_require__(2206));
	
	var _ContactlessRounded = _interopRequireDefault(__webpack_require__(2207));
	
	var _ContactlessSharp = _interopRequireDefault(__webpack_require__(2208));
	
	var _ContactlessTwoTone = _interopRequireDefault(__webpack_require__(2209));
	
	var _ContactMail = _interopRequireDefault(__webpack_require__(2190));
	
	var _ContactMailOutlined = _interopRequireDefault(__webpack_require__(2191));
	
	var _ContactMailRounded = _interopRequireDefault(__webpack_require__(2192));
	
	var _ContactMailSharp = _interopRequireDefault(__webpack_require__(2193));
	
	var _ContactMailTwoTone = _interopRequireDefault(__webpack_require__(2194));
	
	var _ContactPhone = _interopRequireDefault(__webpack_require__(2195));
	
	var _ContactPhoneOutlined = _interopRequireDefault(__webpack_require__(2196));
	
	var _ContactPhoneRounded = _interopRequireDefault(__webpack_require__(2197));
	
	var _ContactPhoneSharp = _interopRequireDefault(__webpack_require__(2198));
	
	var _ContactPhoneTwoTone = _interopRequireDefault(__webpack_require__(2199));
	
	var _Contacts = _interopRequireDefault(__webpack_require__(2210));
	
	var _ContactsOutlined = _interopRequireDefault(__webpack_require__(2211));
	
	var _ContactsRounded = _interopRequireDefault(__webpack_require__(2212));
	
	var _ContactsSharp = _interopRequireDefault(__webpack_require__(2213));
	
	var _ContactsTwoTone = _interopRequireDefault(__webpack_require__(2214));
	
	var _ContactSupport = _interopRequireDefault(__webpack_require__(2200));
	
	var _ContactSupportOutlined = _interopRequireDefault(__webpack_require__(2201));
	
	var _ContactSupportRounded = _interopRequireDefault(__webpack_require__(2202));
	
	var _ContactSupportSharp = _interopRequireDefault(__webpack_require__(2203));
	
	var _ContactSupportTwoTone = _interopRequireDefault(__webpack_require__(2204));
	
	var _ControlCamera = _interopRequireDefault(__webpack_require__(2215));
	
	var _ControlCameraOutlined = _interopRequireDefault(__webpack_require__(2216));
	
	var _ControlCameraRounded = _interopRequireDefault(__webpack_require__(2217));
	
	var _ControlCameraSharp = _interopRequireDefault(__webpack_require__(2218));
	
	var _ControlCameraTwoTone = _interopRequireDefault(__webpack_require__(2219));
	
	var _ControlPoint = _interopRequireDefault(__webpack_require__(2220));
	
	var _ControlPointDuplicate = _interopRequireDefault(__webpack_require__(2221));
	
	var _ControlPointDuplicateOutlined = _interopRequireDefault(__webpack_require__(2222));
	
	var _ControlPointDuplicateRounded = _interopRequireDefault(__webpack_require__(2223));
	
	var _ControlPointDuplicateSharp = _interopRequireDefault(__webpack_require__(2224));
	
	var _ControlPointDuplicateTwoTone = _interopRequireDefault(__webpack_require__(2225));
	
	var _ControlPointOutlined = _interopRequireDefault(__webpack_require__(2226));
	
	var _ControlPointRounded = _interopRequireDefault(__webpack_require__(2227));
	
	var _ControlPointSharp = _interopRequireDefault(__webpack_require__(2228));
	
	var _ControlPointTwoTone = _interopRequireDefault(__webpack_require__(2229));
	
	var _Copyright = _interopRequireDefault(__webpack_require__(2230));
	
	var _CopyrightOutlined = _interopRequireDefault(__webpack_require__(2231));
	
	var _CopyrightRounded = _interopRequireDefault(__webpack_require__(2232));
	
	var _CopyrightSharp = _interopRequireDefault(__webpack_require__(2233));
	
	var _CopyrightTwoTone = _interopRequireDefault(__webpack_require__(2234));
	
	var _Create = _interopRequireDefault(__webpack_require__(2235));
	
	var _CreateNewFolder = _interopRequireDefault(__webpack_require__(2236));
	
	var _CreateNewFolderOutlined = _interopRequireDefault(__webpack_require__(2237));
	
	var _CreateNewFolderRounded = _interopRequireDefault(__webpack_require__(2238));
	
	var _CreateNewFolderSharp = _interopRequireDefault(__webpack_require__(2239));
	
	var _CreateNewFolderTwoTone = _interopRequireDefault(__webpack_require__(2240));
	
	var _CreateOutlined = _interopRequireDefault(__webpack_require__(2241));
	
	var _CreateRounded = _interopRequireDefault(__webpack_require__(2242));
	
	var _CreateSharp = _interopRequireDefault(__webpack_require__(2243));
	
	var _CreateTwoTone = _interopRequireDefault(__webpack_require__(2244));
	
	var _CreditCard = _interopRequireDefault(__webpack_require__(2245));
	
	var _CreditCardOutlined = _interopRequireDefault(__webpack_require__(2246));
	
	var _CreditCardRounded = _interopRequireDefault(__webpack_require__(2247));
	
	var _CreditCardSharp = _interopRequireDefault(__webpack_require__(2248));
	
	var _CreditCardTwoTone = _interopRequireDefault(__webpack_require__(2249));
	
	var _Crop = _interopRequireDefault(__webpack_require__(2250));
	
	var _Crop2 = _interopRequireDefault(__webpack_require__(2251));
	
	var _Crop169Outlined = _interopRequireDefault(__webpack_require__(2252));
	
	var _Crop169Rounded = _interopRequireDefault(__webpack_require__(2253));
	
	var _Crop169Sharp = _interopRequireDefault(__webpack_require__(2254));
	
	var _Crop169TwoTone = _interopRequireDefault(__webpack_require__(2255));
	
	var _Crop3 = _interopRequireDefault(__webpack_require__(2256));
	
	var _Crop32Outlined = _interopRequireDefault(__webpack_require__(2257));
	
	var _Crop32Rounded = _interopRequireDefault(__webpack_require__(2258));
	
	var _Crop32Sharp = _interopRequireDefault(__webpack_require__(2259));
	
	var _Crop32TwoTone = _interopRequireDefault(__webpack_require__(2260));
	
	var _Crop4 = _interopRequireDefault(__webpack_require__(2261));
	
	var _Crop54Outlined = _interopRequireDefault(__webpack_require__(2262));
	
	var _Crop54Rounded = _interopRequireDefault(__webpack_require__(2263));
	
	var _Crop54Sharp = _interopRequireDefault(__webpack_require__(2264));
	
	var _Crop54TwoTone = _interopRequireDefault(__webpack_require__(2265));
	
	var _Crop5 = _interopRequireDefault(__webpack_require__(2266));
	
	var _Crop75Outlined = _interopRequireDefault(__webpack_require__(2267));
	
	var _Crop75Rounded = _interopRequireDefault(__webpack_require__(2268));
	
	var _Crop75Sharp = _interopRequireDefault(__webpack_require__(2269));
	
	var _Crop75TwoTone = _interopRequireDefault(__webpack_require__(2270));
	
	var _CropDin = _interopRequireDefault(__webpack_require__(2271));
	
	var _CropDinOutlined = _interopRequireDefault(__webpack_require__(2272));
	
	var _CropDinRounded = _interopRequireDefault(__webpack_require__(2273));
	
	var _CropDinSharp = _interopRequireDefault(__webpack_require__(2274));
	
	var _CropDinTwoTone = _interopRequireDefault(__webpack_require__(2275));
	
	var _CropFree = _interopRequireDefault(__webpack_require__(2276));
	
	var _CropFreeOutlined = _interopRequireDefault(__webpack_require__(2277));
	
	var _CropFreeRounded = _interopRequireDefault(__webpack_require__(2278));
	
	var _CropFreeSharp = _interopRequireDefault(__webpack_require__(2279));
	
	var _CropFreeTwoTone = _interopRequireDefault(__webpack_require__(2280));
	
	var _CropLandscape = _interopRequireDefault(__webpack_require__(2281));
	
	var _CropLandscapeOutlined = _interopRequireDefault(__webpack_require__(2282));
	
	var _CropLandscapeRounded = _interopRequireDefault(__webpack_require__(2283));
	
	var _CropLandscapeSharp = _interopRequireDefault(__webpack_require__(2284));
	
	var _CropLandscapeTwoTone = _interopRequireDefault(__webpack_require__(2285));
	
	var _CropOriginal = _interopRequireDefault(__webpack_require__(2286));
	
	var _CropOriginalOutlined = _interopRequireDefault(__webpack_require__(2287));
	
	var _CropOriginalRounded = _interopRequireDefault(__webpack_require__(2288));
	
	var _CropOriginalSharp = _interopRequireDefault(__webpack_require__(2289));
	
	var _CropOriginalTwoTone = _interopRequireDefault(__webpack_require__(2290));
	
	var _CropOutlined = _interopRequireDefault(__webpack_require__(2291));
	
	var _CropPortrait = _interopRequireDefault(__webpack_require__(2292));
	
	var _CropPortraitOutlined = _interopRequireDefault(__webpack_require__(2293));
	
	var _CropPortraitRounded = _interopRequireDefault(__webpack_require__(2294));
	
	var _CropPortraitSharp = _interopRequireDefault(__webpack_require__(2295));
	
	var _CropPortraitTwoTone = _interopRequireDefault(__webpack_require__(2296));
	
	var _CropRotate = _interopRequireDefault(__webpack_require__(2297));
	
	var _CropRotateOutlined = _interopRequireDefault(__webpack_require__(2298));
	
	var _CropRotateRounded = _interopRequireDefault(__webpack_require__(2299));
	
	var _CropRotateSharp = _interopRequireDefault(__webpack_require__(2300));
	
	var _CropRotateTwoTone = _interopRequireDefault(__webpack_require__(2301));
	
	var _CropRounded = _interopRequireDefault(__webpack_require__(2302));
	
	var _CropSharp = _interopRequireDefault(__webpack_require__(2303));
	
	var _CropSquare = _interopRequireDefault(__webpack_require__(2304));
	
	var _CropSquareOutlined = _interopRequireDefault(__webpack_require__(2305));
	
	var _CropSquareRounded = _interopRequireDefault(__webpack_require__(2306));
	
	var _CropSquareSharp = _interopRequireDefault(__webpack_require__(2307));
	
	var _CropSquareTwoTone = _interopRequireDefault(__webpack_require__(2308));
	
	var _CropTwoTone = _interopRequireDefault(__webpack_require__(2309));
	
	var _Dashboard = _interopRequireDefault(__webpack_require__(2310));
	
	var _DashboardOutlined = _interopRequireDefault(__webpack_require__(2311));
	
	var _DashboardRounded = _interopRequireDefault(__webpack_require__(2312));
	
	var _DashboardSharp = _interopRequireDefault(__webpack_require__(2313));
	
	var _DashboardTwoTone = _interopRequireDefault(__webpack_require__(2314));
	
	var _DataUsage = _interopRequireDefault(__webpack_require__(2315));
	
	var _DataUsageOutlined = _interopRequireDefault(__webpack_require__(2316));
	
	var _DataUsageRounded = _interopRequireDefault(__webpack_require__(2317));
	
	var _DataUsageSharp = _interopRequireDefault(__webpack_require__(2318));
	
	var _DataUsageTwoTone = _interopRequireDefault(__webpack_require__(2319));
	
	var _DateRange = _interopRequireDefault(__webpack_require__(2320));
	
	var _DateRangeOutlined = _interopRequireDefault(__webpack_require__(2321));
	
	var _DateRangeRounded = _interopRequireDefault(__webpack_require__(2322));
	
	var _DateRangeSharp = _interopRequireDefault(__webpack_require__(2323));
	
	var _DateRangeTwoTone = _interopRequireDefault(__webpack_require__(2324));
	
	var _Deck = _interopRequireDefault(__webpack_require__(2325));
	
	var _DeckOutlined = _interopRequireDefault(__webpack_require__(2326));
	
	var _DeckRounded = _interopRequireDefault(__webpack_require__(2327));
	
	var _DeckSharp = _interopRequireDefault(__webpack_require__(2328));
	
	var _DeckTwoTone = _interopRequireDefault(__webpack_require__(2329));
	
	var _Dehaze = _interopRequireDefault(__webpack_require__(2330));
	
	var _DehazeOutlined = _interopRequireDefault(__webpack_require__(2331));
	
	var _DehazeRounded = _interopRequireDefault(__webpack_require__(2332));
	
	var _DehazeSharp = _interopRequireDefault(__webpack_require__(2333));
	
	var _DehazeTwoTone = _interopRequireDefault(__webpack_require__(2334));
	
	var _Delete = _interopRequireDefault(__webpack_require__(2335));
	
	var _DeleteForever = _interopRequireDefault(__webpack_require__(2336));
	
	var _DeleteForeverOutlined = _interopRequireDefault(__webpack_require__(2337));
	
	var _DeleteForeverRounded = _interopRequireDefault(__webpack_require__(2338));
	
	var _DeleteForeverSharp = _interopRequireDefault(__webpack_require__(2339));
	
	var _DeleteForeverTwoTone = _interopRequireDefault(__webpack_require__(2340));
	
	var _DeleteOutline = _interopRequireDefault(__webpack_require__(2341));
	
	var _DeleteOutlined = _interopRequireDefault(__webpack_require__(2346));
	
	var _DeleteOutlineOutlined = _interopRequireDefault(__webpack_require__(2342));
	
	var _DeleteOutlineRounded = _interopRequireDefault(__webpack_require__(2343));
	
	var _DeleteOutlineSharp = _interopRequireDefault(__webpack_require__(2344));
	
	var _DeleteOutlineTwoTone = _interopRequireDefault(__webpack_require__(2345));
	
	var _DeleteRounded = _interopRequireDefault(__webpack_require__(2347));
	
	var _DeleteSharp = _interopRequireDefault(__webpack_require__(2348));
	
	var _DeleteSweep = _interopRequireDefault(__webpack_require__(2349));
	
	var _DeleteSweepOutlined = _interopRequireDefault(__webpack_require__(2350));
	
	var _DeleteSweepRounded = _interopRequireDefault(__webpack_require__(2351));
	
	var _DeleteSweepSharp = _interopRequireDefault(__webpack_require__(2352));
	
	var _DeleteSweepTwoTone = _interopRequireDefault(__webpack_require__(2353));
	
	var _DeleteTwoTone = _interopRequireDefault(__webpack_require__(2354));
	
	var _DepartureBoard = _interopRequireDefault(__webpack_require__(2355));
	
	var _DepartureBoardOutlined = _interopRequireDefault(__webpack_require__(2356));
	
	var _DepartureBoardRounded = _interopRequireDefault(__webpack_require__(2357));
	
	var _DepartureBoardSharp = _interopRequireDefault(__webpack_require__(2358));
	
	var _DepartureBoardTwoTone = _interopRequireDefault(__webpack_require__(2359));
	
	var _Description = _interopRequireDefault(__webpack_require__(2360));
	
	var _DescriptionOutlined = _interopRequireDefault(__webpack_require__(2361));
	
	var _DescriptionRounded = _interopRequireDefault(__webpack_require__(2362));
	
	var _DescriptionSharp = _interopRequireDefault(__webpack_require__(2363));
	
	var _DescriptionTwoTone = _interopRequireDefault(__webpack_require__(2364));
	
	var _DesktopAccessDisabled = _interopRequireDefault(__webpack_require__(2365));
	
	var _DesktopAccessDisabledOutlined = _interopRequireDefault(__webpack_require__(2366));
	
	var _DesktopAccessDisabledRounded = _interopRequireDefault(__webpack_require__(2367));
	
	var _DesktopAccessDisabledSharp = _interopRequireDefault(__webpack_require__(2368));
	
	var _DesktopAccessDisabledTwoTone = _interopRequireDefault(__webpack_require__(2369));
	
	var _DesktopMac = _interopRequireDefault(__webpack_require__(2370));
	
	var _DesktopMacOutlined = _interopRequireDefault(__webpack_require__(2371));
	
	var _DesktopMacRounded = _interopRequireDefault(__webpack_require__(2372));
	
	var _DesktopMacSharp = _interopRequireDefault(__webpack_require__(2373));
	
	var _DesktopMacTwoTone = _interopRequireDefault(__webpack_require__(2374));
	
	var _DesktopWindows = _interopRequireDefault(__webpack_require__(2375));
	
	var _DesktopWindowsOutlined = _interopRequireDefault(__webpack_require__(2376));
	
	var _DesktopWindowsRounded = _interopRequireDefault(__webpack_require__(2377));
	
	var _DesktopWindowsSharp = _interopRequireDefault(__webpack_require__(2378));
	
	var _DesktopWindowsTwoTone = _interopRequireDefault(__webpack_require__(2379));
	
	var _Details = _interopRequireDefault(__webpack_require__(2380));
	
	var _DetailsOutlined = _interopRequireDefault(__webpack_require__(2381));
	
	var _DetailsRounded = _interopRequireDefault(__webpack_require__(2382));
	
	var _DetailsSharp = _interopRequireDefault(__webpack_require__(2383));
	
	var _DetailsTwoTone = _interopRequireDefault(__webpack_require__(2384));
	
	var _DeveloperBoard = _interopRequireDefault(__webpack_require__(2385));
	
	var _DeveloperBoardOutlined = _interopRequireDefault(__webpack_require__(2386));
	
	var _DeveloperBoardRounded = _interopRequireDefault(__webpack_require__(2387));
	
	var _DeveloperBoardSharp = _interopRequireDefault(__webpack_require__(2388));
	
	var _DeveloperBoardTwoTone = _interopRequireDefault(__webpack_require__(2389));
	
	var _DeveloperMode = _interopRequireDefault(__webpack_require__(2390));
	
	var _DeveloperModeOutlined = _interopRequireDefault(__webpack_require__(2391));
	
	var _DeveloperModeRounded = _interopRequireDefault(__webpack_require__(2392));
	
	var _DeveloperModeSharp = _interopRequireDefault(__webpack_require__(2393));
	
	var _DeveloperModeTwoTone = _interopRequireDefault(__webpack_require__(2394));
	
	var _DeviceHub = _interopRequireDefault(__webpack_require__(2395));
	
	var _DeviceHubOutlined = _interopRequireDefault(__webpack_require__(2396));
	
	var _DeviceHubRounded = _interopRequireDefault(__webpack_require__(2397));
	
	var _DeviceHubSharp = _interopRequireDefault(__webpack_require__(2398));
	
	var _DeviceHubTwoTone = _interopRequireDefault(__webpack_require__(2399));
	
	var _Devices = _interopRequireDefault(__webpack_require__(2405));
	
	var _DevicesOther = _interopRequireDefault(__webpack_require__(2406));
	
	var _DevicesOtherOutlined = _interopRequireDefault(__webpack_require__(2407));
	
	var _DevicesOtherRounded = _interopRequireDefault(__webpack_require__(2408));
	
	var _DevicesOtherSharp = _interopRequireDefault(__webpack_require__(2409));
	
	var _DevicesOtherTwoTone = _interopRequireDefault(__webpack_require__(2410));
	
	var _DevicesOutlined = _interopRequireDefault(__webpack_require__(2411));
	
	var _DevicesRounded = _interopRequireDefault(__webpack_require__(2412));
	
	var _DevicesSharp = _interopRequireDefault(__webpack_require__(2413));
	
	var _DevicesTwoTone = _interopRequireDefault(__webpack_require__(2414));
	
	var _DeviceUnknown = _interopRequireDefault(__webpack_require__(2400));
	
	var _DeviceUnknownOutlined = _interopRequireDefault(__webpack_require__(2401));
	
	var _DeviceUnknownRounded = _interopRequireDefault(__webpack_require__(2402));
	
	var _DeviceUnknownSharp = _interopRequireDefault(__webpack_require__(2403));
	
	var _DeviceUnknownTwoTone = _interopRequireDefault(__webpack_require__(2404));
	
	var _DialerSip = _interopRequireDefault(__webpack_require__(2415));
	
	var _DialerSipOutlined = _interopRequireDefault(__webpack_require__(2416));
	
	var _DialerSipRounded = _interopRequireDefault(__webpack_require__(2417));
	
	var _DialerSipSharp = _interopRequireDefault(__webpack_require__(2418));
	
	var _DialerSipTwoTone = _interopRequireDefault(__webpack_require__(2419));
	
	var _Dialpad = _interopRequireDefault(__webpack_require__(2420));
	
	var _DialpadOutlined = _interopRequireDefault(__webpack_require__(2421));
	
	var _DialpadRounded = _interopRequireDefault(__webpack_require__(2422));
	
	var _DialpadSharp = _interopRequireDefault(__webpack_require__(2423));
	
	var _DialpadTwoTone = _interopRequireDefault(__webpack_require__(2424));
	
	var _Directions = _interopRequireDefault(__webpack_require__(2425));
	
	var _DirectionsBike = _interopRequireDefault(__webpack_require__(2426));
	
	var _DirectionsBikeOutlined = _interopRequireDefault(__webpack_require__(2427));
	
	var _DirectionsBikeRounded = _interopRequireDefault(__webpack_require__(2428));
	
	var _DirectionsBikeSharp = _interopRequireDefault(__webpack_require__(2429));
	
	var _DirectionsBikeTwoTone = _interopRequireDefault(__webpack_require__(2430));
	
	var _DirectionsBoat = _interopRequireDefault(__webpack_require__(2431));
	
	var _DirectionsBoatOutlined = _interopRequireDefault(__webpack_require__(2432));
	
	var _DirectionsBoatRounded = _interopRequireDefault(__webpack_require__(2433));
	
	var _DirectionsBoatSharp = _interopRequireDefault(__webpack_require__(2434));
	
	var _DirectionsBoatTwoTone = _interopRequireDefault(__webpack_require__(2435));
	
	var _DirectionsBus = _interopRequireDefault(__webpack_require__(2436));
	
	var _DirectionsBusOutlined = _interopRequireDefault(__webpack_require__(2437));
	
	var _DirectionsBusRounded = _interopRequireDefault(__webpack_require__(2438));
	
	var _DirectionsBusSharp = _interopRequireDefault(__webpack_require__(2439));
	
	var _DirectionsBusTwoTone = _interopRequireDefault(__webpack_require__(2440));
	
	var _DirectionsCar = _interopRequireDefault(__webpack_require__(2441));
	
	var _DirectionsCarOutlined = _interopRequireDefault(__webpack_require__(2442));
	
	var _DirectionsCarRounded = _interopRequireDefault(__webpack_require__(2443));
	
	var _DirectionsCarSharp = _interopRequireDefault(__webpack_require__(2444));
	
	var _DirectionsCarTwoTone = _interopRequireDefault(__webpack_require__(2445));
	
	var _DirectionsOutlined = _interopRequireDefault(__webpack_require__(2446));
	
	var _DirectionsRailway = _interopRequireDefault(__webpack_require__(2447));
	
	var _DirectionsRailwayOutlined = _interopRequireDefault(__webpack_require__(2448));
	
	var _DirectionsRailwayRounded = _interopRequireDefault(__webpack_require__(2449));
	
	var _DirectionsRailwaySharp = _interopRequireDefault(__webpack_require__(2450));
	
	var _DirectionsRailwayTwoTone = _interopRequireDefault(__webpack_require__(2451));
	
	var _DirectionsRounded = _interopRequireDefault(__webpack_require__(2452));
	
	var _DirectionsRun = _interopRequireDefault(__webpack_require__(2453));
	
	var _DirectionsRunOutlined = _interopRequireDefault(__webpack_require__(2454));
	
	var _DirectionsRunRounded = _interopRequireDefault(__webpack_require__(2455));
	
	var _DirectionsRunSharp = _interopRequireDefault(__webpack_require__(2456));
	
	var _DirectionsRunTwoTone = _interopRequireDefault(__webpack_require__(2457));
	
	var _DirectionsSharp = _interopRequireDefault(__webpack_require__(2458));
	
	var _DirectionsSubway = _interopRequireDefault(__webpack_require__(2459));
	
	var _DirectionsSubwayOutlined = _interopRequireDefault(__webpack_require__(2460));
	
	var _DirectionsSubwayRounded = _interopRequireDefault(__webpack_require__(2461));
	
	var _DirectionsSubwaySharp = _interopRequireDefault(__webpack_require__(2462));
	
	var _DirectionsSubwayTwoTone = _interopRequireDefault(__webpack_require__(2463));
	
	var _DirectionsTransit = _interopRequireDefault(__webpack_require__(2464));
	
	var _DirectionsTransitOutlined = _interopRequireDefault(__webpack_require__(2465));
	
	var _DirectionsTransitRounded = _interopRequireDefault(__webpack_require__(2466));
	
	var _DirectionsTransitSharp = _interopRequireDefault(__webpack_require__(2467));
	
	var _DirectionsTransitTwoTone = _interopRequireDefault(__webpack_require__(2468));
	
	var _DirectionsTwoTone = _interopRequireDefault(__webpack_require__(2469));
	
	var _DirectionsWalk = _interopRequireDefault(__webpack_require__(2470));
	
	var _DirectionsWalkOutlined = _interopRequireDefault(__webpack_require__(2471));
	
	var _DirectionsWalkRounded = _interopRequireDefault(__webpack_require__(2472));
	
	var _DirectionsWalkSharp = _interopRequireDefault(__webpack_require__(2473));
	
	var _DirectionsWalkTwoTone = _interopRequireDefault(__webpack_require__(2474));
	
	var _DiscFull = _interopRequireDefault(__webpack_require__(2475));
	
	var _DiscFullOutlined = _interopRequireDefault(__webpack_require__(2476));
	
	var _DiscFullRounded = _interopRequireDefault(__webpack_require__(2477));
	
	var _DiscFullSharp = _interopRequireDefault(__webpack_require__(2478));
	
	var _DiscFullTwoTone = _interopRequireDefault(__webpack_require__(2479));
	
	var _Dns = _interopRequireDefault(__webpack_require__(2480));
	
	var _DnsOutlined = _interopRequireDefault(__webpack_require__(2481));
	
	var _DnsRounded = _interopRequireDefault(__webpack_require__(2482));
	
	var _DnsSharp = _interopRequireDefault(__webpack_require__(2483));
	
	var _DnsTwoTone = _interopRequireDefault(__webpack_require__(2484));
	
	var _Dock = _interopRequireDefault(__webpack_require__(2485));
	
	var _DockOutlined = _interopRequireDefault(__webpack_require__(2486));
	
	var _DockRounded = _interopRequireDefault(__webpack_require__(2487));
	
	var _DockSharp = _interopRequireDefault(__webpack_require__(2488));
	
	var _DockTwoTone = _interopRequireDefault(__webpack_require__(2489));
	
	var _Domain = _interopRequireDefault(__webpack_require__(2490));
	
	var _DomainDisabled = _interopRequireDefault(__webpack_require__(2491));
	
	var _DomainDisabledOutlined = _interopRequireDefault(__webpack_require__(2492));
	
	var _DomainDisabledRounded = _interopRequireDefault(__webpack_require__(2493));
	
	var _DomainDisabledSharp = _interopRequireDefault(__webpack_require__(2494));
	
	var _DomainDisabledTwoTone = _interopRequireDefault(__webpack_require__(2495));
	
	var _DomainOutlined = _interopRequireDefault(__webpack_require__(2496));
	
	var _DomainRounded = _interopRequireDefault(__webpack_require__(2497));
	
	var _DomainSharp = _interopRequireDefault(__webpack_require__(2498));
	
	var _DomainTwoTone = _interopRequireDefault(__webpack_require__(2499));
	
	var _Done = _interopRequireDefault(__webpack_require__(2500));
	
	var _DoneAll = _interopRequireDefault(__webpack_require__(2501));
	
	var _DoneAllOutlined = _interopRequireDefault(__webpack_require__(2502));
	
	var _DoneAllRounded = _interopRequireDefault(__webpack_require__(2503));
	
	var _DoneAllSharp = _interopRequireDefault(__webpack_require__(2504));
	
	var _DoneAllTwoTone = _interopRequireDefault(__webpack_require__(2505));
	
	var _DoneOutline = _interopRequireDefault(__webpack_require__(2506));
	
	var _DoneOutlined = _interopRequireDefault(__webpack_require__(2511));
	
	var _DoneOutlineOutlined = _interopRequireDefault(__webpack_require__(2507));
	
	var _DoneOutlineRounded = _interopRequireDefault(__webpack_require__(2508));
	
	var _DoneOutlineSharp = _interopRequireDefault(__webpack_require__(2509));
	
	var _DoneOutlineTwoTone = _interopRequireDefault(__webpack_require__(2510));
	
	var _DoneRounded = _interopRequireDefault(__webpack_require__(2512));
	
	var _DoneSharp = _interopRequireDefault(__webpack_require__(2513));
	
	var _DoneTwoTone = _interopRequireDefault(__webpack_require__(2514));
	
	var _DonutLarge = _interopRequireDefault(__webpack_require__(2515));
	
	var _DonutLargeOutlined = _interopRequireDefault(__webpack_require__(2516));
	
	var _DonutLargeRounded = _interopRequireDefault(__webpack_require__(2517));
	
	var _DonutLargeSharp = _interopRequireDefault(__webpack_require__(2518));
	
	var _DonutLargeTwoTone = _interopRequireDefault(__webpack_require__(2519));
	
	var _DonutSmall = _interopRequireDefault(__webpack_require__(2520));
	
	var _DonutSmallOutlined = _interopRequireDefault(__webpack_require__(2521));
	
	var _DonutSmallRounded = _interopRequireDefault(__webpack_require__(2522));
	
	var _DonutSmallSharp = _interopRequireDefault(__webpack_require__(2523));
	
	var _DonutSmallTwoTone = _interopRequireDefault(__webpack_require__(2524));
	
	var _DoubleArrow = _interopRequireDefault(__webpack_require__(2525));
	
	var _DoubleArrowOutlined = _interopRequireDefault(__webpack_require__(2526));
	
	var _DoubleArrowRounded = _interopRequireDefault(__webpack_require__(2527));
	
	var _DoubleArrowSharp = _interopRequireDefault(__webpack_require__(2528));
	
	var _DoubleArrowTwoTone = _interopRequireDefault(__webpack_require__(2529));
	
	var _Drafts = _interopRequireDefault(__webpack_require__(2530));
	
	var _DraftsOutlined = _interopRequireDefault(__webpack_require__(2531));
	
	var _DraftsRounded = _interopRequireDefault(__webpack_require__(2532));
	
	var _DraftsSharp = _interopRequireDefault(__webpack_require__(2533));
	
	var _DraftsTwoTone = _interopRequireDefault(__webpack_require__(2534));
	
	var _DragHandle = _interopRequireDefault(__webpack_require__(2535));
	
	var _DragHandleOutlined = _interopRequireDefault(__webpack_require__(2536));
	
	var _DragHandleRounded = _interopRequireDefault(__webpack_require__(2537));
	
	var _DragHandleSharp = _interopRequireDefault(__webpack_require__(2538));
	
	var _DragHandleTwoTone = _interopRequireDefault(__webpack_require__(2539));
	
	var _DragIndicator = _interopRequireDefault(__webpack_require__(2540));
	
	var _DragIndicatorOutlined = _interopRequireDefault(__webpack_require__(2541));
	
	var _DragIndicatorRounded = _interopRequireDefault(__webpack_require__(2542));
	
	var _DragIndicatorSharp = _interopRequireDefault(__webpack_require__(2543));
	
	var _DragIndicatorTwoTone = _interopRequireDefault(__webpack_require__(2544));
	
	var _DriveEta = _interopRequireDefault(__webpack_require__(2545));
	
	var _DriveEtaOutlined = _interopRequireDefault(__webpack_require__(2546));
	
	var _DriveEtaRounded = _interopRequireDefault(__webpack_require__(2547));
	
	var _DriveEtaSharp = _interopRequireDefault(__webpack_require__(2548));
	
	var _DriveEtaTwoTone = _interopRequireDefault(__webpack_require__(2549));
	
	var _Duo = _interopRequireDefault(__webpack_require__(2550));
	
	var _DuoOutlined = _interopRequireDefault(__webpack_require__(2551));
	
	var _DuoRounded = _interopRequireDefault(__webpack_require__(2552));
	
	var _DuoSharp = _interopRequireDefault(__webpack_require__(2553));
	
	var _DuoTwoTone = _interopRequireDefault(__webpack_require__(2554));
	
	var _Dvr = _interopRequireDefault(__webpack_require__(2555));
	
	var _DvrOutlined = _interopRequireDefault(__webpack_require__(2556));
	
	var _DvrRounded = _interopRequireDefault(__webpack_require__(2557));
	
	var _DvrSharp = _interopRequireDefault(__webpack_require__(2558));
	
	var _DvrTwoTone = _interopRequireDefault(__webpack_require__(2559));
	
	var _DynamicFeed = _interopRequireDefault(__webpack_require__(2560));
	
	var _DynamicFeedOutlined = _interopRequireDefault(__webpack_require__(2561));
	
	var _DynamicFeedRounded = _interopRequireDefault(__webpack_require__(2562));
	
	var _DynamicFeedSharp = _interopRequireDefault(__webpack_require__(2563));
	
	var _DynamicFeedTwoTone = _interopRequireDefault(__webpack_require__(2564));
	
	var _Eco = _interopRequireDefault(__webpack_require__(2565));
	
	var _EcoOutlined = _interopRequireDefault(__webpack_require__(2566));
	
	var _EcoRounded = _interopRequireDefault(__webpack_require__(2567));
	
	var _EcoSharp = _interopRequireDefault(__webpack_require__(2568));
	
	var _EcoTwoTone = _interopRequireDefault(__webpack_require__(2569));
	
	var _Edit = _interopRequireDefault(__webpack_require__(2570));
	
	var _EditAttributes = _interopRequireDefault(__webpack_require__(2571));
	
	var _EditAttributesOutlined = _interopRequireDefault(__webpack_require__(2572));
	
	var _EditAttributesRounded = _interopRequireDefault(__webpack_require__(2573));
	
	var _EditAttributesSharp = _interopRequireDefault(__webpack_require__(2574));
	
	var _EditAttributesTwoTone = _interopRequireDefault(__webpack_require__(2575));
	
	var _EditLocation = _interopRequireDefault(__webpack_require__(2576));
	
	var _EditLocationOutlined = _interopRequireDefault(__webpack_require__(2577));
	
	var _EditLocationRounded = _interopRequireDefault(__webpack_require__(2578));
	
	var _EditLocationSharp = _interopRequireDefault(__webpack_require__(2579));
	
	var _EditLocationTwoTone = _interopRequireDefault(__webpack_require__(2580));
	
	var _EditOutlined = _interopRequireDefault(__webpack_require__(2581));
	
	var _EditRounded = _interopRequireDefault(__webpack_require__(2582));
	
	var _EditSharp = _interopRequireDefault(__webpack_require__(2583));
	
	var _EditTwoTone = _interopRequireDefault(__webpack_require__(2584));
	
	var _Eject = _interopRequireDefault(__webpack_require__(2585));
	
	var _EjectOutlined = _interopRequireDefault(__webpack_require__(2586));
	
	var _EjectRounded = _interopRequireDefault(__webpack_require__(2587));
	
	var _EjectSharp = _interopRequireDefault(__webpack_require__(2588));
	
	var _EjectTwoTone = _interopRequireDefault(__webpack_require__(2589));
	
	var _Email = _interopRequireDefault(__webpack_require__(2590));
	
	var _EmailOutlined = _interopRequireDefault(__webpack_require__(2591));
	
	var _EmailRounded = _interopRequireDefault(__webpack_require__(2592));
	
	var _EmailSharp = _interopRequireDefault(__webpack_require__(2593));
	
	var _EmailTwoTone = _interopRequireDefault(__webpack_require__(2594));
	
	var _EmojiEmotions = _interopRequireDefault(__webpack_require__(2595));
	
	var _EmojiEmotionsOutlined = _interopRequireDefault(__webpack_require__(2596));
	
	var _EmojiEmotionsRounded = _interopRequireDefault(__webpack_require__(2597));
	
	var _EmojiEmotionsSharp = _interopRequireDefault(__webpack_require__(2598));
	
	var _EmojiEmotionsTwoTone = _interopRequireDefault(__webpack_require__(2599));
	
	var _EmojiEvents = _interopRequireDefault(__webpack_require__(2600));
	
	var _EmojiEventsOutlined = _interopRequireDefault(__webpack_require__(2601));
	
	var _EmojiEventsRounded = _interopRequireDefault(__webpack_require__(2602));
	
	var _EmojiEventsSharp = _interopRequireDefault(__webpack_require__(2603));
	
	var _EmojiEventsTwoTone = _interopRequireDefault(__webpack_require__(2604));
	
	var _EmojiFlags = _interopRequireDefault(__webpack_require__(2605));
	
	var _EmojiFlagsOutlined = _interopRequireDefault(__webpack_require__(2606));
	
	var _EmojiFlagsRounded = _interopRequireDefault(__webpack_require__(2607));
	
	var _EmojiFlagsSharp = _interopRequireDefault(__webpack_require__(2608));
	
	var _EmojiFlagsTwoTone = _interopRequireDefault(__webpack_require__(2609));
	
	var _EmojiFoodBeverage = _interopRequireDefault(__webpack_require__(2610));
	
	var _EmojiFoodBeverageOutlined = _interopRequireDefault(__webpack_require__(2611));
	
	var _EmojiFoodBeverageRounded = _interopRequireDefault(__webpack_require__(2612));
	
	var _EmojiFoodBeverageSharp = _interopRequireDefault(__webpack_require__(2613));
	
	var _EmojiFoodBeverageTwoTone = _interopRequireDefault(__webpack_require__(2614));
	
	var _EmojiNature = _interopRequireDefault(__webpack_require__(2615));
	
	var _EmojiNatureOutlined = _interopRequireDefault(__webpack_require__(2616));
	
	var _EmojiNatureRounded = _interopRequireDefault(__webpack_require__(2617));
	
	var _EmojiNatureSharp = _interopRequireDefault(__webpack_require__(2618));
	
	var _EmojiNatureTwoTone = _interopRequireDefault(__webpack_require__(2619));
	
	var _EmojiObjects = _interopRequireDefault(__webpack_require__(2620));
	
	var _EmojiObjectsOutlined = _interopRequireDefault(__webpack_require__(2621));
	
	var _EmojiObjectsRounded = _interopRequireDefault(__webpack_require__(2622));
	
	var _EmojiObjectsSharp = _interopRequireDefault(__webpack_require__(2623));
	
	var _EmojiObjectsTwoTone = _interopRequireDefault(__webpack_require__(2624));
	
	var _EmojiPeople = _interopRequireDefault(__webpack_require__(2625));
	
	var _EmojiPeopleOutlined = _interopRequireDefault(__webpack_require__(2626));
	
	var _EmojiPeopleRounded = _interopRequireDefault(__webpack_require__(2627));
	
	var _EmojiPeopleSharp = _interopRequireDefault(__webpack_require__(2628));
	
	var _EmojiPeopleTwoTone = _interopRequireDefault(__webpack_require__(2629));
	
	var _EmojiSymbols = _interopRequireDefault(__webpack_require__(2630));
	
	var _EmojiSymbolsOutlined = _interopRequireDefault(__webpack_require__(2631));
	
	var _EmojiSymbolsRounded = _interopRequireDefault(__webpack_require__(2632));
	
	var _EmojiSymbolsSharp = _interopRequireDefault(__webpack_require__(2633));
	
	var _EmojiSymbolsTwoTone = _interopRequireDefault(__webpack_require__(2634));
	
	var _EmojiTransportation = _interopRequireDefault(__webpack_require__(2635));
	
	var _EmojiTransportationOutlined = _interopRequireDefault(__webpack_require__(2636));
	
	var _EmojiTransportationRounded = _interopRequireDefault(__webpack_require__(2637));
	
	var _EmojiTransportationSharp = _interopRequireDefault(__webpack_require__(2638));
	
	var _EmojiTransportationTwoTone = _interopRequireDefault(__webpack_require__(2639));
	
	var _EnhancedEncryption = _interopRequireDefault(__webpack_require__(2640));
	
	var _EnhancedEncryptionOutlined = _interopRequireDefault(__webpack_require__(2641));
	
	var _EnhancedEncryptionRounded = _interopRequireDefault(__webpack_require__(2642));
	
	var _EnhancedEncryptionSharp = _interopRequireDefault(__webpack_require__(2643));
	
	var _EnhancedEncryptionTwoTone = _interopRequireDefault(__webpack_require__(2644));
	
	var _Equalizer = _interopRequireDefault(__webpack_require__(2645));
	
	var _EqualizerOutlined = _interopRequireDefault(__webpack_require__(2646));
	
	var _EqualizerRounded = _interopRequireDefault(__webpack_require__(2647));
	
	var _EqualizerSharp = _interopRequireDefault(__webpack_require__(2648));
	
	var _EqualizerTwoTone = _interopRequireDefault(__webpack_require__(2649));
	
	var _Error = _interopRequireDefault(__webpack_require__(2650));
	
	var _ErrorOutline = _interopRequireDefault(__webpack_require__(2651));
	
	var _ErrorOutlined = _interopRequireDefault(__webpack_require__(2656));
	
	var _ErrorOutlineOutlined = _interopRequireDefault(__webpack_require__(2652));
	
	var _ErrorOutlineRounded = _interopRequireDefault(__webpack_require__(2653));
	
	var _ErrorOutlineSharp = _interopRequireDefault(__webpack_require__(2654));
	
	var _ErrorOutlineTwoTone = _interopRequireDefault(__webpack_require__(2655));
	
	var _ErrorRounded = _interopRequireDefault(__webpack_require__(2657));
	
	var _ErrorSharp = _interopRequireDefault(__webpack_require__(2658));
	
	var _ErrorTwoTone = _interopRequireDefault(__webpack_require__(2659));
	
	var _Euro = _interopRequireDefault(__webpack_require__(2660));
	
	var _EuroOutlined = _interopRequireDefault(__webpack_require__(2661));
	
	var _EuroRounded = _interopRequireDefault(__webpack_require__(2662));
	
	var _EuroSharp = _interopRequireDefault(__webpack_require__(2663));
	
	var _EuroSymbol = _interopRequireDefault(__webpack_require__(2664));
	
	var _EuroSymbolOutlined = _interopRequireDefault(__webpack_require__(2665));
	
	var _EuroSymbolRounded = _interopRequireDefault(__webpack_require__(2666));
	
	var _EuroSymbolSharp = _interopRequireDefault(__webpack_require__(2667));
	
	var _EuroSymbolTwoTone = _interopRequireDefault(__webpack_require__(2668));
	
	var _EuroTwoTone = _interopRequireDefault(__webpack_require__(2669));
	
	var _Event = _interopRequireDefault(__webpack_require__(2675));
	
	var _EventAvailable = _interopRequireDefault(__webpack_require__(2676));
	
	var _EventAvailableOutlined = _interopRequireDefault(__webpack_require__(2677));
	
	var _EventAvailableRounded = _interopRequireDefault(__webpack_require__(2678));
	
	var _EventAvailableSharp = _interopRequireDefault(__webpack_require__(2679));
	
	var _EventAvailableTwoTone = _interopRequireDefault(__webpack_require__(2680));
	
	var _EventBusy = _interopRequireDefault(__webpack_require__(2681));
	
	var _EventBusyOutlined = _interopRequireDefault(__webpack_require__(2682));
	
	var _EventBusyRounded = _interopRequireDefault(__webpack_require__(2683));
	
	var _EventBusySharp = _interopRequireDefault(__webpack_require__(2684));
	
	var _EventBusyTwoTone = _interopRequireDefault(__webpack_require__(2685));
	
	var _EventNote = _interopRequireDefault(__webpack_require__(2686));
	
	var _EventNoteOutlined = _interopRequireDefault(__webpack_require__(2687));
	
	var _EventNoteRounded = _interopRequireDefault(__webpack_require__(2688));
	
	var _EventNoteSharp = _interopRequireDefault(__webpack_require__(2689));
	
	var _EventNoteTwoTone = _interopRequireDefault(__webpack_require__(2690));
	
	var _EventOutlined = _interopRequireDefault(__webpack_require__(2691));
	
	var _EventRounded = _interopRequireDefault(__webpack_require__(2692));
	
	var _EventSeat = _interopRequireDefault(__webpack_require__(2693));
	
	var _EventSeatOutlined = _interopRequireDefault(__webpack_require__(2694));
	
	var _EventSeatRounded = _interopRequireDefault(__webpack_require__(2695));
	
	var _EventSeatSharp = _interopRequireDefault(__webpack_require__(2696));
	
	var _EventSeatTwoTone = _interopRequireDefault(__webpack_require__(2697));
	
	var _EventSharp = _interopRequireDefault(__webpack_require__(2698));
	
	var _EventTwoTone = _interopRequireDefault(__webpack_require__(2699));
	
	var _EvStation = _interopRequireDefault(__webpack_require__(2670));
	
	var _EvStationOutlined = _interopRequireDefault(__webpack_require__(2671));
	
	var _EvStationRounded = _interopRequireDefault(__webpack_require__(2672));
	
	var _EvStationSharp = _interopRequireDefault(__webpack_require__(2673));
	
	var _EvStationTwoTone = _interopRequireDefault(__webpack_require__(2674));
	
	var _ExitToApp = _interopRequireDefault(__webpack_require__(2700));
	
	var _ExitToAppOutlined = _interopRequireDefault(__webpack_require__(2701));
	
	var _ExitToAppRounded = _interopRequireDefault(__webpack_require__(2702));
	
	var _ExitToAppSharp = _interopRequireDefault(__webpack_require__(2703));
	
	var _ExitToAppTwoTone = _interopRequireDefault(__webpack_require__(2704));
	
	var _ExpandLess = _interopRequireDefault(__webpack_require__(2705));
	
	var _ExpandLessOutlined = _interopRequireDefault(__webpack_require__(2706));
	
	var _ExpandLessRounded = _interopRequireDefault(__webpack_require__(2707));
	
	var _ExpandLessSharp = _interopRequireDefault(__webpack_require__(2708));
	
	var _ExpandLessTwoTone = _interopRequireDefault(__webpack_require__(2709));
	
	var _ExpandMore = _interopRequireDefault(__webpack_require__(2710));
	
	var _ExpandMoreOutlined = _interopRequireDefault(__webpack_require__(2711));
	
	var _ExpandMoreRounded = _interopRequireDefault(__webpack_require__(2712));
	
	var _ExpandMoreSharp = _interopRequireDefault(__webpack_require__(2713));
	
	var _ExpandMoreTwoTone = _interopRequireDefault(__webpack_require__(2714));
	
	var _Explicit = _interopRequireDefault(__webpack_require__(2715));
	
	var _ExplicitOutlined = _interopRequireDefault(__webpack_require__(2716));
	
	var _ExplicitRounded = _interopRequireDefault(__webpack_require__(2717));
	
	var _ExplicitSharp = _interopRequireDefault(__webpack_require__(2718));
	
	var _ExplicitTwoTone = _interopRequireDefault(__webpack_require__(2719));
	
	var _Explore = _interopRequireDefault(__webpack_require__(2720));
	
	var _ExploreOff = _interopRequireDefault(__webpack_require__(2721));
	
	var _ExploreOffOutlined = _interopRequireDefault(__webpack_require__(2722));
	
	var _ExploreOffRounded = _interopRequireDefault(__webpack_require__(2723));
	
	var _ExploreOffSharp = _interopRequireDefault(__webpack_require__(2724));
	
	var _ExploreOffTwoTone = _interopRequireDefault(__webpack_require__(2725));
	
	var _ExploreOutlined = _interopRequireDefault(__webpack_require__(2726));
	
	var _ExploreRounded = _interopRequireDefault(__webpack_require__(2727));
	
	var _ExploreSharp = _interopRequireDefault(__webpack_require__(2728));
	
	var _ExploreTwoTone = _interopRequireDefault(__webpack_require__(2729));
	
	var _Exposure = _interopRequireDefault(__webpack_require__(2730));
	
	var _ExposureNeg = _interopRequireDefault(__webpack_require__(2731));
	
	var _ExposureNeg1Outlined = _interopRequireDefault(__webpack_require__(2732));
	
	var _ExposureNeg1Rounded = _interopRequireDefault(__webpack_require__(2733));
	
	var _ExposureNeg1Sharp = _interopRequireDefault(__webpack_require__(2734));
	
	var _ExposureNeg1TwoTone = _interopRequireDefault(__webpack_require__(2735));
	
	var _ExposureNeg2 = _interopRequireDefault(__webpack_require__(2736));
	
	var _ExposureNeg2Outlined = _interopRequireDefault(__webpack_require__(2737));
	
	var _ExposureNeg2Rounded = _interopRequireDefault(__webpack_require__(2738));
	
	var _ExposureNeg2Sharp = _interopRequireDefault(__webpack_require__(2739));
	
	var _ExposureNeg2TwoTone = _interopRequireDefault(__webpack_require__(2740));
	
	var _ExposureOutlined = _interopRequireDefault(__webpack_require__(2741));
	
	var _ExposurePlus = _interopRequireDefault(__webpack_require__(2742));
	
	var _ExposurePlus1Outlined = _interopRequireDefault(__webpack_require__(2743));
	
	var _ExposurePlus1Rounded = _interopRequireDefault(__webpack_require__(2744));
	
	var _ExposurePlus1Sharp = _interopRequireDefault(__webpack_require__(2745));
	
	var _ExposurePlus1TwoTone = _interopRequireDefault(__webpack_require__(2746));
	
	var _ExposurePlus2 = _interopRequireDefault(__webpack_require__(2747));
	
	var _ExposurePlus2Outlined = _interopRequireDefault(__webpack_require__(2748));
	
	var _ExposurePlus2Rounded = _interopRequireDefault(__webpack_require__(2749));
	
	var _ExposurePlus2Sharp = _interopRequireDefault(__webpack_require__(2750));
	
	var _ExposurePlus2TwoTone = _interopRequireDefault(__webpack_require__(2751));
	
	var _ExposureRounded = _interopRequireDefault(__webpack_require__(2752));
	
	var _ExposureSharp = _interopRequireDefault(__webpack_require__(2753));
	
	var _ExposureTwoTone = _interopRequireDefault(__webpack_require__(2754));
	
	var _ExposureZero = _interopRequireDefault(__webpack_require__(2755));
	
	var _ExposureZeroOutlined = _interopRequireDefault(__webpack_require__(2756));
	
	var _ExposureZeroRounded = _interopRequireDefault(__webpack_require__(2757));
	
	var _ExposureZeroSharp = _interopRequireDefault(__webpack_require__(2758));
	
	var _ExposureZeroTwoTone = _interopRequireDefault(__webpack_require__(2759));
	
	var _Extension = _interopRequireDefault(__webpack_require__(2760));
	
	var _ExtensionOutlined = _interopRequireDefault(__webpack_require__(2761));
	
	var _ExtensionRounded = _interopRequireDefault(__webpack_require__(2762));
	
	var _ExtensionSharp = _interopRequireDefault(__webpack_require__(2763));
	
	var _ExtensionTwoTone = _interopRequireDefault(__webpack_require__(2764));
	
	var _Face = _interopRequireDefault(__webpack_require__(2765));
	
	var _Facebook = _interopRequireDefault(__webpack_require__(2770));
	
	var _FaceOutlined = _interopRequireDefault(__webpack_require__(2766));
	
	var _FaceRounded = _interopRequireDefault(__webpack_require__(2767));
	
	var _FaceSharp = _interopRequireDefault(__webpack_require__(2768));
	
	var _FaceTwoTone = _interopRequireDefault(__webpack_require__(2769));
	
	var _Fastfood = _interopRequireDefault(__webpack_require__(2781));
	
	var _FastfoodOutlined = _interopRequireDefault(__webpack_require__(2782));
	
	var _FastfoodRounded = _interopRequireDefault(__webpack_require__(2783));
	
	var _FastfoodSharp = _interopRequireDefault(__webpack_require__(2784));
	
	var _FastfoodTwoTone = _interopRequireDefault(__webpack_require__(2785));
	
	var _FastForward = _interopRequireDefault(__webpack_require__(2771));
	
	var _FastForwardOutlined = _interopRequireDefault(__webpack_require__(2772));
	
	var _FastForwardRounded = _interopRequireDefault(__webpack_require__(2773));
	
	var _FastForwardSharp = _interopRequireDefault(__webpack_require__(2774));
	
	var _FastForwardTwoTone = _interopRequireDefault(__webpack_require__(2775));
	
	var _FastRewind = _interopRequireDefault(__webpack_require__(2776));
	
	var _FastRewindOutlined = _interopRequireDefault(__webpack_require__(2777));
	
	var _FastRewindRounded = _interopRequireDefault(__webpack_require__(2778));
	
	var _FastRewindSharp = _interopRequireDefault(__webpack_require__(2779));
	
	var _FastRewindTwoTone = _interopRequireDefault(__webpack_require__(2780));
	
	var _Favorite = _interopRequireDefault(__webpack_require__(2786));
	
	var _FavoriteBorder = _interopRequireDefault(__webpack_require__(2787));
	
	var _FavoriteBorderOutlined = _interopRequireDefault(__webpack_require__(2788));
	
	var _FavoriteBorderRounded = _interopRequireDefault(__webpack_require__(2789));
	
	var _FavoriteBorderSharp = _interopRequireDefault(__webpack_require__(2790));
	
	var _FavoriteBorderTwoTone = _interopRequireDefault(__webpack_require__(2791));
	
	var _FavoriteOutlined = _interopRequireDefault(__webpack_require__(2792));
	
	var _FavoriteRounded = _interopRequireDefault(__webpack_require__(2793));
	
	var _FavoriteSharp = _interopRequireDefault(__webpack_require__(2794));
	
	var _FavoriteTwoTone = _interopRequireDefault(__webpack_require__(2795));
	
	var _FeaturedPlayList = _interopRequireDefault(__webpack_require__(2796));
	
	var _FeaturedPlayListOutlined = _interopRequireDefault(__webpack_require__(2797));
	
	var _FeaturedPlayListRounded = _interopRequireDefault(__webpack_require__(2798));
	
	var _FeaturedPlayListSharp = _interopRequireDefault(__webpack_require__(2799));
	
	var _FeaturedPlayListTwoTone = _interopRequireDefault(__webpack_require__(2800));
	
	var _FeaturedVideo = _interopRequireDefault(__webpack_require__(2801));
	
	var _FeaturedVideoOutlined = _interopRequireDefault(__webpack_require__(2802));
	
	var _FeaturedVideoRounded = _interopRequireDefault(__webpack_require__(2803));
	
	var _FeaturedVideoSharp = _interopRequireDefault(__webpack_require__(2804));
	
	var _FeaturedVideoTwoTone = _interopRequireDefault(__webpack_require__(2805));
	
	var _Feedback = _interopRequireDefault(__webpack_require__(2806));
	
	var _FeedbackOutlined = _interopRequireDefault(__webpack_require__(2807));
	
	var _FeedbackRounded = _interopRequireDefault(__webpack_require__(2808));
	
	var _FeedbackSharp = _interopRequireDefault(__webpack_require__(2809));
	
	var _FeedbackTwoTone = _interopRequireDefault(__webpack_require__(2810));
	
	var _FiberDvr = _interopRequireDefault(__webpack_require__(2811));
	
	var _FiberDvrOutlined = _interopRequireDefault(__webpack_require__(2812));
	
	var _FiberDvrRounded = _interopRequireDefault(__webpack_require__(2813));
	
	var _FiberDvrSharp = _interopRequireDefault(__webpack_require__(2814));
	
	var _FiberDvrTwoTone = _interopRequireDefault(__webpack_require__(2815));
	
	var _FiberManualRecord = _interopRequireDefault(__webpack_require__(2816));
	
	var _FiberManualRecordOutlined = _interopRequireDefault(__webpack_require__(2817));
	
	var _FiberManualRecordRounded = _interopRequireDefault(__webpack_require__(2818));
	
	var _FiberManualRecordSharp = _interopRequireDefault(__webpack_require__(2819));
	
	var _FiberManualRecordTwoTone = _interopRequireDefault(__webpack_require__(2820));
	
	var _FiberNew = _interopRequireDefault(__webpack_require__(2821));
	
	var _FiberNewOutlined = _interopRequireDefault(__webpack_require__(2822));
	
	var _FiberNewRounded = _interopRequireDefault(__webpack_require__(2823));
	
	var _FiberNewSharp = _interopRequireDefault(__webpack_require__(2824));
	
	var _FiberNewTwoTone = _interopRequireDefault(__webpack_require__(2825));
	
	var _FiberPin = _interopRequireDefault(__webpack_require__(2826));
	
	var _FiberPinOutlined = _interopRequireDefault(__webpack_require__(2827));
	
	var _FiberPinRounded = _interopRequireDefault(__webpack_require__(2828));
	
	var _FiberPinSharp = _interopRequireDefault(__webpack_require__(2829));
	
	var _FiberPinTwoTone = _interopRequireDefault(__webpack_require__(2830));
	
	var _FiberSmartRecord = _interopRequireDefault(__webpack_require__(2831));
	
	var _FiberSmartRecordOutlined = _interopRequireDefault(__webpack_require__(2832));
	
	var _FiberSmartRecordRounded = _interopRequireDefault(__webpack_require__(2833));
	
	var _FiberSmartRecordSharp = _interopRequireDefault(__webpack_require__(2834));
	
	var _FiberSmartRecordTwoTone = _interopRequireDefault(__webpack_require__(2835));
	
	var _FileCopy = _interopRequireDefault(__webpack_require__(2836));
	
	var _FileCopyOutlined = _interopRequireDefault(__webpack_require__(2837));
	
	var _FileCopyRounded = _interopRequireDefault(__webpack_require__(2838));
	
	var _FileCopySharp = _interopRequireDefault(__webpack_require__(2839));
	
	var _FileCopyTwoTone = _interopRequireDefault(__webpack_require__(2840));
	
	var _Filter = _interopRequireDefault(__webpack_require__(2841));
	
	var _Filter2 = _interopRequireDefault(__webpack_require__(2842));
	
	var _Filter1Outlined = _interopRequireDefault(__webpack_require__(2843));
	
	var _Filter1Rounded = _interopRequireDefault(__webpack_require__(2844));
	
	var _Filter1Sharp = _interopRequireDefault(__webpack_require__(2845));
	
	var _Filter1TwoTone = _interopRequireDefault(__webpack_require__(2846));
	
	var _Filter3 = _interopRequireDefault(__webpack_require__(2847));
	
	var _Filter2Outlined = _interopRequireDefault(__webpack_require__(2848));
	
	var _Filter2Rounded = _interopRequireDefault(__webpack_require__(2849));
	
	var _Filter2Sharp = _interopRequireDefault(__webpack_require__(2850));
	
	var _Filter2TwoTone = _interopRequireDefault(__webpack_require__(2851));
	
	var _Filter4 = _interopRequireDefault(__webpack_require__(2852));
	
	var _Filter3Outlined = _interopRequireDefault(__webpack_require__(2853));
	
	var _Filter3Rounded = _interopRequireDefault(__webpack_require__(2854));
	
	var _Filter3Sharp = _interopRequireDefault(__webpack_require__(2855));
	
	var _Filter3TwoTone = _interopRequireDefault(__webpack_require__(2856));
	
	var _Filter5 = _interopRequireDefault(__webpack_require__(2857));
	
	var _Filter4Outlined = _interopRequireDefault(__webpack_require__(2858));
	
	var _Filter4Rounded = _interopRequireDefault(__webpack_require__(2859));
	
	var _Filter4Sharp = _interopRequireDefault(__webpack_require__(2860));
	
	var _Filter4TwoTone = _interopRequireDefault(__webpack_require__(2861));
	
	var _Filter6 = _interopRequireDefault(__webpack_require__(2862));
	
	var _Filter5Outlined = _interopRequireDefault(__webpack_require__(2863));
	
	var _Filter5Rounded = _interopRequireDefault(__webpack_require__(2864));
	
	var _Filter5Sharp = _interopRequireDefault(__webpack_require__(2865));
	
	var _Filter5TwoTone = _interopRequireDefault(__webpack_require__(2866));
	
	var _Filter7 = _interopRequireDefault(__webpack_require__(2867));
	
	var _Filter6Outlined = _interopRequireDefault(__webpack_require__(2868));
	
	var _Filter6Rounded = _interopRequireDefault(__webpack_require__(2869));
	
	var _Filter6Sharp = _interopRequireDefault(__webpack_require__(2870));
	
	var _Filter6TwoTone = _interopRequireDefault(__webpack_require__(2871));
	
	var _Filter8 = _interopRequireDefault(__webpack_require__(2872));
	
	var _Filter7Outlined = _interopRequireDefault(__webpack_require__(2873));
	
	var _Filter7Rounded = _interopRequireDefault(__webpack_require__(2874));
	
	var _Filter7Sharp = _interopRequireDefault(__webpack_require__(2875));
	
	var _Filter7TwoTone = _interopRequireDefault(__webpack_require__(2876));
	
	var _Filter9 = _interopRequireDefault(__webpack_require__(2877));
	
	var _Filter8Outlined = _interopRequireDefault(__webpack_require__(2878));
	
	var _Filter8Rounded = _interopRequireDefault(__webpack_require__(2879));
	
	var _Filter8Sharp = _interopRequireDefault(__webpack_require__(2880));
	
	var _Filter8TwoTone = _interopRequireDefault(__webpack_require__(2881));
	
	var _Filter10 = _interopRequireDefault(__webpack_require__(2882));
	
	var _Filter9Outlined = _interopRequireDefault(__webpack_require__(2883));
	
	var _Filter9Plus = _interopRequireDefault(__webpack_require__(2884));
	
	var _Filter9PlusOutlined = _interopRequireDefault(__webpack_require__(2885));
	
	var _Filter9PlusRounded = _interopRequireDefault(__webpack_require__(2886));
	
	var _Filter9PlusSharp = _interopRequireDefault(__webpack_require__(2887));
	
	var _Filter9PlusTwoTone = _interopRequireDefault(__webpack_require__(2888));
	
	var _Filter9Rounded = _interopRequireDefault(__webpack_require__(2889));
	
	var _Filter9Sharp = _interopRequireDefault(__webpack_require__(2890));
	
	var _Filter9TwoTone = _interopRequireDefault(__webpack_require__(2891));
	
	var _FilterBAndW = _interopRequireDefault(__webpack_require__(2892));
	
	var _FilterBAndWOutlined = _interopRequireDefault(__webpack_require__(2893));
	
	var _FilterBAndWRounded = _interopRequireDefault(__webpack_require__(2894));
	
	var _FilterBAndWSharp = _interopRequireDefault(__webpack_require__(2895));
	
	var _FilterBAndWTwoTone = _interopRequireDefault(__webpack_require__(2896));
	
	var _FilterCenterFocus = _interopRequireDefault(__webpack_require__(2897));
	
	var _FilterCenterFocusOutlined = _interopRequireDefault(__webpack_require__(2898));
	
	var _FilterCenterFocusRounded = _interopRequireDefault(__webpack_require__(2899));
	
	var _FilterCenterFocusSharp = _interopRequireDefault(__webpack_require__(2900));
	
	var _FilterCenterFocusTwoTone = _interopRequireDefault(__webpack_require__(2901));
	
	var _FilterDrama = _interopRequireDefault(__webpack_require__(2902));
	
	var _FilterDramaOutlined = _interopRequireDefault(__webpack_require__(2903));
	
	var _FilterDramaRounded = _interopRequireDefault(__webpack_require__(2904));
	
	var _FilterDramaSharp = _interopRequireDefault(__webpack_require__(2905));
	
	var _FilterDramaTwoTone = _interopRequireDefault(__webpack_require__(2906));
	
	var _FilterFrames = _interopRequireDefault(__webpack_require__(2907));
	
	var _FilterFramesOutlined = _interopRequireDefault(__webpack_require__(2908));
	
	var _FilterFramesRounded = _interopRequireDefault(__webpack_require__(2909));
	
	var _FilterFramesSharp = _interopRequireDefault(__webpack_require__(2910));
	
	var _FilterFramesTwoTone = _interopRequireDefault(__webpack_require__(2911));
	
	var _FilterHdr = _interopRequireDefault(__webpack_require__(2912));
	
	var _FilterHdrOutlined = _interopRequireDefault(__webpack_require__(2913));
	
	var _FilterHdrRounded = _interopRequireDefault(__webpack_require__(2914));
	
	var _FilterHdrSharp = _interopRequireDefault(__webpack_require__(2915));
	
	var _FilterHdrTwoTone = _interopRequireDefault(__webpack_require__(2916));
	
	var _FilterList = _interopRequireDefault(__webpack_require__(2917));
	
	var _FilterListOutlined = _interopRequireDefault(__webpack_require__(2918));
	
	var _FilterListRounded = _interopRequireDefault(__webpack_require__(2919));
	
	var _FilterListSharp = _interopRequireDefault(__webpack_require__(2920));
	
	var _FilterListTwoTone = _interopRequireDefault(__webpack_require__(2921));
	
	var _FilterNone = _interopRequireDefault(__webpack_require__(2922));
	
	var _FilterNoneOutlined = _interopRequireDefault(__webpack_require__(2923));
	
	var _FilterNoneRounded = _interopRequireDefault(__webpack_require__(2924));
	
	var _FilterNoneSharp = _interopRequireDefault(__webpack_require__(2925));
	
	var _FilterNoneTwoTone = _interopRequireDefault(__webpack_require__(2926));
	
	var _FilterOutlined = _interopRequireDefault(__webpack_require__(2927));
	
	var _FilterRounded = _interopRequireDefault(__webpack_require__(2928));
	
	var _FilterSharp = _interopRequireDefault(__webpack_require__(2929));
	
	var _FilterTiltShift = _interopRequireDefault(__webpack_require__(2930));
	
	var _FilterTiltShiftOutlined = _interopRequireDefault(__webpack_require__(2931));
	
	var _FilterTiltShiftRounded = _interopRequireDefault(__webpack_require__(2932));
	
	var _FilterTiltShiftSharp = _interopRequireDefault(__webpack_require__(2933));
	
	var _FilterTiltShiftTwoTone = _interopRequireDefault(__webpack_require__(2934));
	
	var _FilterTwoTone = _interopRequireDefault(__webpack_require__(2935));
	
	var _FilterVintage = _interopRequireDefault(__webpack_require__(2936));
	
	var _FilterVintageOutlined = _interopRequireDefault(__webpack_require__(2937));
	
	var _FilterVintageRounded = _interopRequireDefault(__webpack_require__(2938));
	
	var _FilterVintageSharp = _interopRequireDefault(__webpack_require__(2939));
	
	var _FilterVintageTwoTone = _interopRequireDefault(__webpack_require__(2940));
	
	var _FindInPage = _interopRequireDefault(__webpack_require__(2941));
	
	var _FindInPageOutlined = _interopRequireDefault(__webpack_require__(2942));
	
	var _FindInPageRounded = _interopRequireDefault(__webpack_require__(2943));
	
	var _FindInPageSharp = _interopRequireDefault(__webpack_require__(2944));
	
	var _FindInPageTwoTone = _interopRequireDefault(__webpack_require__(2945));
	
	var _FindReplace = _interopRequireDefault(__webpack_require__(2946));
	
	var _FindReplaceOutlined = _interopRequireDefault(__webpack_require__(2947));
	
	var _FindReplaceRounded = _interopRequireDefault(__webpack_require__(2948));
	
	var _FindReplaceSharp = _interopRequireDefault(__webpack_require__(2949));
	
	var _FindReplaceTwoTone = _interopRequireDefault(__webpack_require__(2950));
	
	var _Fingerprint = _interopRequireDefault(__webpack_require__(2951));
	
	var _FingerprintOutlined = _interopRequireDefault(__webpack_require__(2952));
	
	var _FingerprintRounded = _interopRequireDefault(__webpack_require__(2953));
	
	var _FingerprintSharp = _interopRequireDefault(__webpack_require__(2954));
	
	var _FingerprintTwoTone = _interopRequireDefault(__webpack_require__(2955));
	
	var _Fireplace = _interopRequireDefault(__webpack_require__(2956));
	
	var _FireplaceOutlined = _interopRequireDefault(__webpack_require__(2957));
	
	var _FireplaceRounded = _interopRequireDefault(__webpack_require__(2958));
	
	var _FireplaceSharp = _interopRequireDefault(__webpack_require__(2959));
	
	var _FireplaceTwoTone = _interopRequireDefault(__webpack_require__(2960));
	
	var _FirstPage = _interopRequireDefault(__webpack_require__(2961));
	
	var _FirstPageOutlined = _interopRequireDefault(__webpack_require__(2962));
	
	var _FirstPageRounded = _interopRequireDefault(__webpack_require__(2963));
	
	var _FirstPageSharp = _interopRequireDefault(__webpack_require__(2964));
	
	var _FirstPageTwoTone = _interopRequireDefault(__webpack_require__(2965));
	
	var _FitnessCenter = _interopRequireDefault(__webpack_require__(2966));
	
	var _FitnessCenterOutlined = _interopRequireDefault(__webpack_require__(2967));
	
	var _FitnessCenterRounded = _interopRequireDefault(__webpack_require__(2968));
	
	var _FitnessCenterSharp = _interopRequireDefault(__webpack_require__(2969));
	
	var _FitnessCenterTwoTone = _interopRequireDefault(__webpack_require__(2970));
	
	var _Flag = _interopRequireDefault(__webpack_require__(2971));
	
	var _FlagOutlined = _interopRequireDefault(__webpack_require__(2972));
	
	var _FlagRounded = _interopRequireDefault(__webpack_require__(2973));
	
	var _FlagSharp = _interopRequireDefault(__webpack_require__(2974));
	
	var _FlagTwoTone = _interopRequireDefault(__webpack_require__(2975));
	
	var _Flare = _interopRequireDefault(__webpack_require__(2976));
	
	var _FlareOutlined = _interopRequireDefault(__webpack_require__(2977));
	
	var _FlareRounded = _interopRequireDefault(__webpack_require__(2978));
	
	var _FlareSharp = _interopRequireDefault(__webpack_require__(2979));
	
	var _FlareTwoTone = _interopRequireDefault(__webpack_require__(2980));
	
	var _FlashAuto = _interopRequireDefault(__webpack_require__(2981));
	
	var _FlashAutoOutlined = _interopRequireDefault(__webpack_require__(2982));
	
	var _FlashAutoRounded = _interopRequireDefault(__webpack_require__(2983));
	
	var _FlashAutoSharp = _interopRequireDefault(__webpack_require__(2984));
	
	var _FlashAutoTwoTone = _interopRequireDefault(__webpack_require__(2985));
	
	var _FlashOff = _interopRequireDefault(__webpack_require__(2986));
	
	var _FlashOffOutlined = _interopRequireDefault(__webpack_require__(2987));
	
	var _FlashOffRounded = _interopRequireDefault(__webpack_require__(2988));
	
	var _FlashOffSharp = _interopRequireDefault(__webpack_require__(2989));
	
	var _FlashOffTwoTone = _interopRequireDefault(__webpack_require__(2990));
	
	var _FlashOn = _interopRequireDefault(__webpack_require__(2991));
	
	var _FlashOnOutlined = _interopRequireDefault(__webpack_require__(2992));
	
	var _FlashOnRounded = _interopRequireDefault(__webpack_require__(2993));
	
	var _FlashOnSharp = _interopRequireDefault(__webpack_require__(2994));
	
	var _FlashOnTwoTone = _interopRequireDefault(__webpack_require__(2995));
	
	var _Flight = _interopRequireDefault(__webpack_require__(2996));
	
	var _FlightLand = _interopRequireDefault(__webpack_require__(2997));
	
	var _FlightLandOutlined = _interopRequireDefault(__webpack_require__(2998));
	
	var _FlightLandRounded = _interopRequireDefault(__webpack_require__(2999));
	
	var _FlightLandSharp = _interopRequireDefault(__webpack_require__(3000));
	
	var _FlightLandTwoTone = _interopRequireDefault(__webpack_require__(3001));
	
	var _FlightOutlined = _interopRequireDefault(__webpack_require__(3002));
	
	var _FlightRounded = _interopRequireDefault(__webpack_require__(3003));
	
	var _FlightSharp = _interopRequireDefault(__webpack_require__(3004));
	
	var _FlightTakeoff = _interopRequireDefault(__webpack_require__(3005));
	
	var _FlightTakeoffOutlined = _interopRequireDefault(__webpack_require__(3006));
	
	var _FlightTakeoffRounded = _interopRequireDefault(__webpack_require__(3007));
	
	var _FlightTakeoffSharp = _interopRequireDefault(__webpack_require__(3008));
	
	var _FlightTakeoffTwoTone = _interopRequireDefault(__webpack_require__(3009));
	
	var _FlightTwoTone = _interopRequireDefault(__webpack_require__(3010));
	
	var _Flip = _interopRequireDefault(__webpack_require__(3011));
	
	var _FlipCameraAndroid = _interopRequireDefault(__webpack_require__(3012));
	
	var _FlipCameraAndroidOutlined = _interopRequireDefault(__webpack_require__(3013));
	
	var _FlipCameraAndroidRounded = _interopRequireDefault(__webpack_require__(3014));
	
	var _FlipCameraAndroidSharp = _interopRequireDefault(__webpack_require__(3015));
	
	var _FlipCameraAndroidTwoTone = _interopRequireDefault(__webpack_require__(3016));
	
	var _FlipCameraIos = _interopRequireDefault(__webpack_require__(3017));
	
	var _FlipCameraIosOutlined = _interopRequireDefault(__webpack_require__(3018));
	
	var _FlipCameraIosRounded = _interopRequireDefault(__webpack_require__(3019));
	
	var _FlipCameraIosSharp = _interopRequireDefault(__webpack_require__(3020));
	
	var _FlipCameraIosTwoTone = _interopRequireDefault(__webpack_require__(3021));
	
	var _FlipOutlined = _interopRequireDefault(__webpack_require__(3022));
	
	var _FlipRounded = _interopRequireDefault(__webpack_require__(3023));
	
	var _FlipSharp = _interopRequireDefault(__webpack_require__(3024));
	
	var _FlipToBack = _interopRequireDefault(__webpack_require__(3025));
	
	var _FlipToBackOutlined = _interopRequireDefault(__webpack_require__(3026));
	
	var _FlipToBackRounded = _interopRequireDefault(__webpack_require__(3027));
	
	var _FlipToBackSharp = _interopRequireDefault(__webpack_require__(3028));
	
	var _FlipToBackTwoTone = _interopRequireDefault(__webpack_require__(3029));
	
	var _FlipToFront = _interopRequireDefault(__webpack_require__(3030));
	
	var _FlipToFrontOutlined = _interopRequireDefault(__webpack_require__(3031));
	
	var _FlipToFrontRounded = _interopRequireDefault(__webpack_require__(3032));
	
	var _FlipToFrontSharp = _interopRequireDefault(__webpack_require__(3033));
	
	var _FlipToFrontTwoTone = _interopRequireDefault(__webpack_require__(3034));
	
	var _FlipTwoTone = _interopRequireDefault(__webpack_require__(3035));
	
	var _Folder = _interopRequireDefault(__webpack_require__(3036));
	
	var _FolderOpen = _interopRequireDefault(__webpack_require__(3037));
	
	var _FolderOpenOutlined = _interopRequireDefault(__webpack_require__(3038));
	
	var _FolderOpenRounded = _interopRequireDefault(__webpack_require__(3039));
	
	var _FolderOpenSharp = _interopRequireDefault(__webpack_require__(3040));
	
	var _FolderOpenTwoTone = _interopRequireDefault(__webpack_require__(3041));
	
	var _FolderOutlined = _interopRequireDefault(__webpack_require__(3042));
	
	var _FolderRounded = _interopRequireDefault(__webpack_require__(3043));
	
	var _FolderShared = _interopRequireDefault(__webpack_require__(3044));
	
	var _FolderSharedOutlined = _interopRequireDefault(__webpack_require__(3045));
	
	var _FolderSharedRounded = _interopRequireDefault(__webpack_require__(3046));
	
	var _FolderSharedSharp = _interopRequireDefault(__webpack_require__(3047));
	
	var _FolderSharedTwoTone = _interopRequireDefault(__webpack_require__(3048));
	
	var _FolderSharp = _interopRequireDefault(__webpack_require__(3049));
	
	var _FolderSpecial = _interopRequireDefault(__webpack_require__(3050));
	
	var _FolderSpecialOutlined = _interopRequireDefault(__webpack_require__(3051));
	
	var _FolderSpecialRounded = _interopRequireDefault(__webpack_require__(3052));
	
	var _FolderSpecialSharp = _interopRequireDefault(__webpack_require__(3053));
	
	var _FolderSpecialTwoTone = _interopRequireDefault(__webpack_require__(3054));
	
	var _FolderTwoTone = _interopRequireDefault(__webpack_require__(3055));
	
	var _FontDownload = _interopRequireDefault(__webpack_require__(3056));
	
	var _FontDownloadOutlined = _interopRequireDefault(__webpack_require__(3057));
	
	var _FontDownloadRounded = _interopRequireDefault(__webpack_require__(3058));
	
	var _FontDownloadSharp = _interopRequireDefault(__webpack_require__(3059));
	
	var _FontDownloadTwoTone = _interopRequireDefault(__webpack_require__(3060));
	
	var _FormatAlignCenter = _interopRequireDefault(__webpack_require__(3061));
	
	var _FormatAlignCenterOutlined = _interopRequireDefault(__webpack_require__(3062));
	
	var _FormatAlignCenterRounded = _interopRequireDefault(__webpack_require__(3063));
	
	var _FormatAlignCenterSharp = _interopRequireDefault(__webpack_require__(3064));
	
	var _FormatAlignCenterTwoTone = _interopRequireDefault(__webpack_require__(3065));
	
	var _FormatAlignJustify = _interopRequireDefault(__webpack_require__(3066));
	
	var _FormatAlignJustifyOutlined = _interopRequireDefault(__webpack_require__(3067));
	
	var _FormatAlignJustifyRounded = _interopRequireDefault(__webpack_require__(3068));
	
	var _FormatAlignJustifySharp = _interopRequireDefault(__webpack_require__(3069));
	
	var _FormatAlignJustifyTwoTone = _interopRequireDefault(__webpack_require__(3070));
	
	var _FormatAlignLeft = _interopRequireDefault(__webpack_require__(3071));
	
	var _FormatAlignLeftOutlined = _interopRequireDefault(__webpack_require__(3072));
	
	var _FormatAlignLeftRounded = _interopRequireDefault(__webpack_require__(3073));
	
	var _FormatAlignLeftSharp = _interopRequireDefault(__webpack_require__(3074));
	
	var _FormatAlignLeftTwoTone = _interopRequireDefault(__webpack_require__(3075));
	
	var _FormatAlignRight = _interopRequireDefault(__webpack_require__(3076));
	
	var _FormatAlignRightOutlined = _interopRequireDefault(__webpack_require__(3077));
	
	var _FormatAlignRightRounded = _interopRequireDefault(__webpack_require__(3078));
	
	var _FormatAlignRightSharp = _interopRequireDefault(__webpack_require__(3079));
	
	var _FormatAlignRightTwoTone = _interopRequireDefault(__webpack_require__(3080));
	
	var _FormatBold = _interopRequireDefault(__webpack_require__(3081));
	
	var _FormatBoldOutlined = _interopRequireDefault(__webpack_require__(3082));
	
	var _FormatBoldRounded = _interopRequireDefault(__webpack_require__(3083));
	
	var _FormatBoldSharp = _interopRequireDefault(__webpack_require__(3084));
	
	var _FormatBoldTwoTone = _interopRequireDefault(__webpack_require__(3085));
	
	var _FormatClear = _interopRequireDefault(__webpack_require__(3086));
	
	var _FormatClearOutlined = _interopRequireDefault(__webpack_require__(3087));
	
	var _FormatClearRounded = _interopRequireDefault(__webpack_require__(3088));
	
	var _FormatClearSharp = _interopRequireDefault(__webpack_require__(3089));
	
	var _FormatClearTwoTone = _interopRequireDefault(__webpack_require__(3090));
	
	var _FormatColorFill = _interopRequireDefault(__webpack_require__(3091));
	
	var _FormatColorFillOutlined = _interopRequireDefault(__webpack_require__(3092));
	
	var _FormatColorFillRounded = _interopRequireDefault(__webpack_require__(3093));
	
	var _FormatColorFillSharp = _interopRequireDefault(__webpack_require__(3094));
	
	var _FormatColorFillTwoTone = _interopRequireDefault(__webpack_require__(3095));
	
	var _FormatColorReset = _interopRequireDefault(__webpack_require__(3096));
	
	var _FormatColorResetOutlined = _interopRequireDefault(__webpack_require__(3097));
	
	var _FormatColorResetRounded = _interopRequireDefault(__webpack_require__(3098));
	
	var _FormatColorResetSharp = _interopRequireDefault(__webpack_require__(3099));
	
	var _FormatColorResetTwoTone = _interopRequireDefault(__webpack_require__(3100));
	
	var _FormatColorText = _interopRequireDefault(__webpack_require__(3101));
	
	var _FormatColorTextOutlined = _interopRequireDefault(__webpack_require__(3102));
	
	var _FormatColorTextRounded = _interopRequireDefault(__webpack_require__(3103));
	
	var _FormatColorTextSharp = _interopRequireDefault(__webpack_require__(3104));
	
	var _FormatColorTextTwoTone = _interopRequireDefault(__webpack_require__(3105));
	
	var _FormatIndentDecrease = _interopRequireDefault(__webpack_require__(3106));
	
	var _FormatIndentDecreaseOutlined = _interopRequireDefault(__webpack_require__(3107));
	
	var _FormatIndentDecreaseRounded = _interopRequireDefault(__webpack_require__(3108));
	
	var _FormatIndentDecreaseSharp = _interopRequireDefault(__webpack_require__(3109));
	
	var _FormatIndentDecreaseTwoTone = _interopRequireDefault(__webpack_require__(3110));
	
	var _FormatIndentIncrease = _interopRequireDefault(__webpack_require__(3111));
	
	var _FormatIndentIncreaseOutlined = _interopRequireDefault(__webpack_require__(3112));
	
	var _FormatIndentIncreaseRounded = _interopRequireDefault(__webpack_require__(3113));
	
	var _FormatIndentIncreaseSharp = _interopRequireDefault(__webpack_require__(3114));
	
	var _FormatIndentIncreaseTwoTone = _interopRequireDefault(__webpack_require__(3115));
	
	var _FormatItalic = _interopRequireDefault(__webpack_require__(3116));
	
	var _FormatItalicOutlined = _interopRequireDefault(__webpack_require__(3117));
	
	var _FormatItalicRounded = _interopRequireDefault(__webpack_require__(3118));
	
	var _FormatItalicSharp = _interopRequireDefault(__webpack_require__(3119));
	
	var _FormatItalicTwoTone = _interopRequireDefault(__webpack_require__(3120));
	
	var _FormatLineSpacing = _interopRequireDefault(__webpack_require__(3121));
	
	var _FormatLineSpacingOutlined = _interopRequireDefault(__webpack_require__(3122));
	
	var _FormatLineSpacingRounded = _interopRequireDefault(__webpack_require__(3123));
	
	var _FormatLineSpacingSharp = _interopRequireDefault(__webpack_require__(3124));
	
	var _FormatLineSpacingTwoTone = _interopRequireDefault(__webpack_require__(3125));
	
	var _FormatListBulleted = _interopRequireDefault(__webpack_require__(3126));
	
	var _FormatListBulletedOutlined = _interopRequireDefault(__webpack_require__(3127));
	
	var _FormatListBulletedRounded = _interopRequireDefault(__webpack_require__(3128));
	
	var _FormatListBulletedSharp = _interopRequireDefault(__webpack_require__(3129));
	
	var _FormatListBulletedTwoTone = _interopRequireDefault(__webpack_require__(3130));
	
	var _FormatListNumbered = _interopRequireDefault(__webpack_require__(3131));
	
	var _FormatListNumberedOutlined = _interopRequireDefault(__webpack_require__(3132));
	
	var _FormatListNumberedRounded = _interopRequireDefault(__webpack_require__(3133));
	
	var _FormatListNumberedRtl = _interopRequireDefault(__webpack_require__(3134));
	
	var _FormatListNumberedRtlOutlined = _interopRequireDefault(__webpack_require__(3135));
	
	var _FormatListNumberedRtlRounded = _interopRequireDefault(__webpack_require__(3136));
	
	var _FormatListNumberedRtlSharp = _interopRequireDefault(__webpack_require__(3137));
	
	var _FormatListNumberedRtlTwoTone = _interopRequireDefault(__webpack_require__(3138));
	
	var _FormatListNumberedSharp = _interopRequireDefault(__webpack_require__(3139));
	
	var _FormatListNumberedTwoTone = _interopRequireDefault(__webpack_require__(3140));
	
	var _FormatPaint = _interopRequireDefault(__webpack_require__(3141));
	
	var _FormatPaintOutlined = _interopRequireDefault(__webpack_require__(3142));
	
	var _FormatPaintRounded = _interopRequireDefault(__webpack_require__(3143));
	
	var _FormatPaintSharp = _interopRequireDefault(__webpack_require__(3144));
	
	var _FormatPaintTwoTone = _interopRequireDefault(__webpack_require__(3145));
	
	var _FormatQuote = _interopRequireDefault(__webpack_require__(3146));
	
	var _FormatQuoteOutlined = _interopRequireDefault(__webpack_require__(3147));
	
	var _FormatQuoteRounded = _interopRequireDefault(__webpack_require__(3148));
	
	var _FormatQuoteSharp = _interopRequireDefault(__webpack_require__(3149));
	
	var _FormatQuoteTwoTone = _interopRequireDefault(__webpack_require__(3150));
	
	var _FormatShapes = _interopRequireDefault(__webpack_require__(3151));
	
	var _FormatShapesOutlined = _interopRequireDefault(__webpack_require__(3152));
	
	var _FormatShapesRounded = _interopRequireDefault(__webpack_require__(3153));
	
	var _FormatShapesSharp = _interopRequireDefault(__webpack_require__(3154));
	
	var _FormatShapesTwoTone = _interopRequireDefault(__webpack_require__(3155));
	
	var _FormatSize = _interopRequireDefault(__webpack_require__(3156));
	
	var _FormatSizeOutlined = _interopRequireDefault(__webpack_require__(3157));
	
	var _FormatSizeRounded = _interopRequireDefault(__webpack_require__(3158));
	
	var _FormatSizeSharp = _interopRequireDefault(__webpack_require__(3159));
	
	var _FormatSizeTwoTone = _interopRequireDefault(__webpack_require__(3160));
	
	var _FormatStrikethrough = _interopRequireDefault(__webpack_require__(3161));
	
	var _FormatStrikethroughOutlined = _interopRequireDefault(__webpack_require__(3162));
	
	var _FormatStrikethroughRounded = _interopRequireDefault(__webpack_require__(3163));
	
	var _FormatStrikethroughSharp = _interopRequireDefault(__webpack_require__(3164));
	
	var _FormatStrikethroughTwoTone = _interopRequireDefault(__webpack_require__(3165));
	
	var _FormatTextdirectionLToR = _interopRequireDefault(__webpack_require__(3166));
	
	var _FormatTextdirectionLToROutlined = _interopRequireDefault(__webpack_require__(3167));
	
	var _FormatTextdirectionLToRRounded = _interopRequireDefault(__webpack_require__(3168));
	
	var _FormatTextdirectionLToRSharp = _interopRequireDefault(__webpack_require__(3169));
	
	var _FormatTextdirectionLToRTwoTone = _interopRequireDefault(__webpack_require__(3170));
	
	var _FormatTextdirectionRToL = _interopRequireDefault(__webpack_require__(3171));
	
	var _FormatTextdirectionRToLOutlined = _interopRequireDefault(__webpack_require__(3172));
	
	var _FormatTextdirectionRToLRounded = _interopRequireDefault(__webpack_require__(3173));
	
	var _FormatTextdirectionRToLSharp = _interopRequireDefault(__webpack_require__(3174));
	
	var _FormatTextdirectionRToLTwoTone = _interopRequireDefault(__webpack_require__(3175));
	
	var _FormatUnderlined = _interopRequireDefault(__webpack_require__(3176));
	
	var _FormatUnderlinedOutlined = _interopRequireDefault(__webpack_require__(3177));
	
	var _FormatUnderlinedRounded = _interopRequireDefault(__webpack_require__(3178));
	
	var _FormatUnderlinedSharp = _interopRequireDefault(__webpack_require__(3179));
	
	var _FormatUnderlinedTwoTone = _interopRequireDefault(__webpack_require__(3180));
	
	var _Forum = _interopRequireDefault(__webpack_require__(3181));
	
	var _ForumOutlined = _interopRequireDefault(__webpack_require__(3182));
	
	var _ForumRounded = _interopRequireDefault(__webpack_require__(3183));
	
	var _ForumSharp = _interopRequireDefault(__webpack_require__(3184));
	
	var _ForumTwoTone = _interopRequireDefault(__webpack_require__(3185));
	
	var _Forward = _interopRequireDefault(__webpack_require__(3186));
	
	var _Forward2 = _interopRequireDefault(__webpack_require__(3187));
	
	var _Forward10Outlined = _interopRequireDefault(__webpack_require__(3188));
	
	var _Forward10Rounded = _interopRequireDefault(__webpack_require__(3189));
	
	var _Forward10Sharp = _interopRequireDefault(__webpack_require__(3190));
	
	var _Forward10TwoTone = _interopRequireDefault(__webpack_require__(3191));
	
	var _Forward3 = _interopRequireDefault(__webpack_require__(3192));
	
	var _Forward30Outlined = _interopRequireDefault(__webpack_require__(3193));
	
	var _Forward30Rounded = _interopRequireDefault(__webpack_require__(3194));
	
	var _Forward30Sharp = _interopRequireDefault(__webpack_require__(3195));
	
	var _Forward30TwoTone = _interopRequireDefault(__webpack_require__(3196));
	
	var _Forward4 = _interopRequireDefault(__webpack_require__(3197));
	
	var _Forward5Outlined = _interopRequireDefault(__webpack_require__(3198));
	
	var _Forward5Rounded = _interopRequireDefault(__webpack_require__(3199));
	
	var _Forward5Sharp = _interopRequireDefault(__webpack_require__(3200));
	
	var _Forward5TwoTone = _interopRequireDefault(__webpack_require__(3201));
	
	var _ForwardOutlined = _interopRequireDefault(__webpack_require__(3202));
	
	var _ForwardRounded = _interopRequireDefault(__webpack_require__(3203));
	
	var _ForwardSharp = _interopRequireDefault(__webpack_require__(3204));
	
	var _ForwardTwoTone = _interopRequireDefault(__webpack_require__(3205));
	
	var _FourK = _interopRequireDefault(__webpack_require__(3206));
	
	var _FourKOutlined = _interopRequireDefault(__webpack_require__(3207));
	
	var _FourKRounded = _interopRequireDefault(__webpack_require__(3208));
	
	var _FourKSharp = _interopRequireDefault(__webpack_require__(3209));
	
	var _FourKTwoTone = _interopRequireDefault(__webpack_require__(3210));
	
	var _FreeBreakfast = _interopRequireDefault(__webpack_require__(3211));
	
	var _FreeBreakfastOutlined = _interopRequireDefault(__webpack_require__(3212));
	
	var _FreeBreakfastRounded = _interopRequireDefault(__webpack_require__(3213));
	
	var _FreeBreakfastSharp = _interopRequireDefault(__webpack_require__(3214));
	
	var _FreeBreakfastTwoTone = _interopRequireDefault(__webpack_require__(3215));
	
	var _Fullscreen = _interopRequireDefault(__webpack_require__(3216));
	
	var _FullscreenExit = _interopRequireDefault(__webpack_require__(3217));
	
	var _FullscreenExitOutlined = _interopRequireDefault(__webpack_require__(3218));
	
	var _FullscreenExitRounded = _interopRequireDefault(__webpack_require__(3219));
	
	var _FullscreenExitSharp = _interopRequireDefault(__webpack_require__(3220));
	
	var _FullscreenExitTwoTone = _interopRequireDefault(__webpack_require__(3221));
	
	var _FullscreenOutlined = _interopRequireDefault(__webpack_require__(3222));
	
	var _FullscreenRounded = _interopRequireDefault(__webpack_require__(3223));
	
	var _FullscreenSharp = _interopRequireDefault(__webpack_require__(3224));
	
	var _FullscreenTwoTone = _interopRequireDefault(__webpack_require__(3225));
	
	var _Functions = _interopRequireDefault(__webpack_require__(3226));
	
	var _FunctionsOutlined = _interopRequireDefault(__webpack_require__(3227));
	
	var _FunctionsRounded = _interopRequireDefault(__webpack_require__(3228));
	
	var _FunctionsSharp = _interopRequireDefault(__webpack_require__(3229));
	
	var _FunctionsTwoTone = _interopRequireDefault(__webpack_require__(3230));
	
	var _Gamepad = _interopRequireDefault(__webpack_require__(3236));
	
	var _GamepadOutlined = _interopRequireDefault(__webpack_require__(3237));
	
	var _GamepadRounded = _interopRequireDefault(__webpack_require__(3238));
	
	var _GamepadSharp = _interopRequireDefault(__webpack_require__(3239));
	
	var _GamepadTwoTone = _interopRequireDefault(__webpack_require__(3240));
	
	var _Games = _interopRequireDefault(__webpack_require__(3241));
	
	var _GamesOutlined = _interopRequireDefault(__webpack_require__(3242));
	
	var _GamesRounded = _interopRequireDefault(__webpack_require__(3243));
	
	var _GamesSharp = _interopRequireDefault(__webpack_require__(3244));
	
	var _GamesTwoTone = _interopRequireDefault(__webpack_require__(3245));
	
	var _Gavel = _interopRequireDefault(__webpack_require__(3246));
	
	var _GavelOutlined = _interopRequireDefault(__webpack_require__(3247));
	
	var _GavelRounded = _interopRequireDefault(__webpack_require__(3248));
	
	var _GavelSharp = _interopRequireDefault(__webpack_require__(3249));
	
	var _GavelTwoTone = _interopRequireDefault(__webpack_require__(3250));
	
	var _Gesture = _interopRequireDefault(__webpack_require__(3251));
	
	var _GestureOutlined = _interopRequireDefault(__webpack_require__(3252));
	
	var _GestureRounded = _interopRequireDefault(__webpack_require__(3253));
	
	var _GestureSharp = _interopRequireDefault(__webpack_require__(3254));
	
	var _GestureTwoTone = _interopRequireDefault(__webpack_require__(3255));
	
	var _GetApp = _interopRequireDefault(__webpack_require__(3256));
	
	var _GetAppOutlined = _interopRequireDefault(__webpack_require__(3257));
	
	var _GetAppRounded = _interopRequireDefault(__webpack_require__(3258));
	
	var _GetAppSharp = _interopRequireDefault(__webpack_require__(3259));
	
	var _GetAppTwoTone = _interopRequireDefault(__webpack_require__(3260));
	
	var _Gif = _interopRequireDefault(__webpack_require__(3261));
	
	var _GifOutlined = _interopRequireDefault(__webpack_require__(3262));
	
	var _GifRounded = _interopRequireDefault(__webpack_require__(3263));
	
	var _GifSharp = _interopRequireDefault(__webpack_require__(3264));
	
	var _GifTwoTone = _interopRequireDefault(__webpack_require__(3265));
	
	var _GitHub = _interopRequireDefault(__webpack_require__(3266));
	
	var _GolfCourse = _interopRequireDefault(__webpack_require__(3267));
	
	var _GolfCourseOutlined = _interopRequireDefault(__webpack_require__(3268));
	
	var _GolfCourseRounded = _interopRequireDefault(__webpack_require__(3269));
	
	var _GolfCourseSharp = _interopRequireDefault(__webpack_require__(3270));
	
	var _GolfCourseTwoTone = _interopRequireDefault(__webpack_require__(3271));
	
	var _GpsFixed = _interopRequireDefault(__webpack_require__(3272));
	
	var _GpsFixedOutlined = _interopRequireDefault(__webpack_require__(3273));
	
	var _GpsFixedRounded = _interopRequireDefault(__webpack_require__(3274));
	
	var _GpsFixedSharp = _interopRequireDefault(__webpack_require__(3275));
	
	var _GpsFixedTwoTone = _interopRequireDefault(__webpack_require__(3276));
	
	var _GpsNotFixed = _interopRequireDefault(__webpack_require__(3277));
	
	var _GpsNotFixedOutlined = _interopRequireDefault(__webpack_require__(3278));
	
	var _GpsNotFixedRounded = _interopRequireDefault(__webpack_require__(3279));
	
	var _GpsNotFixedSharp = _interopRequireDefault(__webpack_require__(3280));
	
	var _GpsNotFixedTwoTone = _interopRequireDefault(__webpack_require__(3281));
	
	var _GpsOff = _interopRequireDefault(__webpack_require__(3282));
	
	var _GpsOffOutlined = _interopRequireDefault(__webpack_require__(3283));
	
	var _GpsOffRounded = _interopRequireDefault(__webpack_require__(3284));
	
	var _GpsOffSharp = _interopRequireDefault(__webpack_require__(3285));
	
	var _GpsOffTwoTone = _interopRequireDefault(__webpack_require__(3286));
	
	var _Grade = _interopRequireDefault(__webpack_require__(3287));
	
	var _GradeOutlined = _interopRequireDefault(__webpack_require__(3288));
	
	var _GradeRounded = _interopRequireDefault(__webpack_require__(3289));
	
	var _GradeSharp = _interopRequireDefault(__webpack_require__(3290));
	
	var _GradeTwoTone = _interopRequireDefault(__webpack_require__(3291));
	
	var _Gradient = _interopRequireDefault(__webpack_require__(3292));
	
	var _GradientOutlined = _interopRequireDefault(__webpack_require__(3293));
	
	var _GradientRounded = _interopRequireDefault(__webpack_require__(3294));
	
	var _GradientSharp = _interopRequireDefault(__webpack_require__(3295));
	
	var _GradientTwoTone = _interopRequireDefault(__webpack_require__(3296));
	
	var _Grain = _interopRequireDefault(__webpack_require__(3297));
	
	var _GrainOutlined = _interopRequireDefault(__webpack_require__(3298));
	
	var _GrainRounded = _interopRequireDefault(__webpack_require__(3299));
	
	var _GrainSharp = _interopRequireDefault(__webpack_require__(3300));
	
	var _GrainTwoTone = _interopRequireDefault(__webpack_require__(3301));
	
	var _GraphicEq = _interopRequireDefault(__webpack_require__(3302));
	
	var _GraphicEqOutlined = _interopRequireDefault(__webpack_require__(3303));
	
	var _GraphicEqRounded = _interopRequireDefault(__webpack_require__(3304));
	
	var _GraphicEqSharp = _interopRequireDefault(__webpack_require__(3305));
	
	var _GraphicEqTwoTone = _interopRequireDefault(__webpack_require__(3306));
	
	var _GridOff = _interopRequireDefault(__webpack_require__(3307));
	
	var _GridOffOutlined = _interopRequireDefault(__webpack_require__(3308));
	
	var _GridOffRounded = _interopRequireDefault(__webpack_require__(3309));
	
	var _GridOffSharp = _interopRequireDefault(__webpack_require__(3310));
	
	var _GridOffTwoTone = _interopRequireDefault(__webpack_require__(3311));
	
	var _GridOn = _interopRequireDefault(__webpack_require__(3312));
	
	var _GridOnOutlined = _interopRequireDefault(__webpack_require__(3313));
	
	var _GridOnRounded = _interopRequireDefault(__webpack_require__(3314));
	
	var _GridOnSharp = _interopRequireDefault(__webpack_require__(3315));
	
	var _GridOnTwoTone = _interopRequireDefault(__webpack_require__(3316));
	
	var _Group = _interopRequireDefault(__webpack_require__(3317));
	
	var _GroupAdd = _interopRequireDefault(__webpack_require__(3318));
	
	var _GroupAddOutlined = _interopRequireDefault(__webpack_require__(3319));
	
	var _GroupAddRounded = _interopRequireDefault(__webpack_require__(3320));
	
	var _GroupAddSharp = _interopRequireDefault(__webpack_require__(3321));
	
	var _GroupAddTwoTone = _interopRequireDefault(__webpack_require__(3322));
	
	var _GroupOutlined = _interopRequireDefault(__webpack_require__(3323));
	
	var _GroupRounded = _interopRequireDefault(__webpack_require__(3324));
	
	var _GroupSharp = _interopRequireDefault(__webpack_require__(3325));
	
	var _GroupTwoTone = _interopRequireDefault(__webpack_require__(3326));
	
	var _GroupWork = _interopRequireDefault(__webpack_require__(3327));
	
	var _GroupWorkOutlined = _interopRequireDefault(__webpack_require__(3328));
	
	var _GroupWorkRounded = _interopRequireDefault(__webpack_require__(3329));
	
	var _GroupWorkSharp = _interopRequireDefault(__webpack_require__(3330));
	
	var _GroupWorkTwoTone = _interopRequireDefault(__webpack_require__(3331));
	
	var _GTranslate = _interopRequireDefault(__webpack_require__(3231));
	
	var _GTranslateOutlined = _interopRequireDefault(__webpack_require__(3232));
	
	var _GTranslateRounded = _interopRequireDefault(__webpack_require__(3233));
	
	var _GTranslateSharp = _interopRequireDefault(__webpack_require__(3234));
	
	var _GTranslateTwoTone = _interopRequireDefault(__webpack_require__(3235));
	
	var _Hd = _interopRequireDefault(__webpack_require__(3332));
	
	var _HdOutlined = _interopRequireDefault(__webpack_require__(3333));
	
	var _HdrOff = _interopRequireDefault(__webpack_require__(3337));
	
	var _HdrOffOutlined = _interopRequireDefault(__webpack_require__(3338));
	
	var _HdrOffRounded = _interopRequireDefault(__webpack_require__(3339));
	
	var _HdrOffSharp = _interopRequireDefault(__webpack_require__(3340));
	
	var _HdrOffTwoTone = _interopRequireDefault(__webpack_require__(3341));
	
	var _HdrOn = _interopRequireDefault(__webpack_require__(3342));
	
	var _HdrOnOutlined = _interopRequireDefault(__webpack_require__(3343));
	
	var _HdrOnRounded = _interopRequireDefault(__webpack_require__(3344));
	
	var _HdrOnSharp = _interopRequireDefault(__webpack_require__(3345));
	
	var _HdrOnTwoTone = _interopRequireDefault(__webpack_require__(3346));
	
	var _HdRounded = _interopRequireDefault(__webpack_require__(3334));
	
	var _HdrStrong = _interopRequireDefault(__webpack_require__(3347));
	
	var _HdrStrongOutlined = _interopRequireDefault(__webpack_require__(3348));
	
	var _HdrStrongRounded = _interopRequireDefault(__webpack_require__(3349));
	
	var _HdrStrongSharp = _interopRequireDefault(__webpack_require__(3350));
	
	var _HdrStrongTwoTone = _interopRequireDefault(__webpack_require__(3351));
	
	var _HdrWeak = _interopRequireDefault(__webpack_require__(3352));
	
	var _HdrWeakOutlined = _interopRequireDefault(__webpack_require__(3353));
	
	var _HdrWeakRounded = _interopRequireDefault(__webpack_require__(3354));
	
	var _HdrWeakSharp = _interopRequireDefault(__webpack_require__(3355));
	
	var _HdrWeakTwoTone = _interopRequireDefault(__webpack_require__(3356));
	
	var _HdSharp = _interopRequireDefault(__webpack_require__(3335));
	
	var _HdTwoTone = _interopRequireDefault(__webpack_require__(3336));
	
	var _Headset = _interopRequireDefault(__webpack_require__(3357));
	
	var _HeadsetMic = _interopRequireDefault(__webpack_require__(3358));
	
	var _HeadsetMicOutlined = _interopRequireDefault(__webpack_require__(3359));
	
	var _HeadsetMicRounded = _interopRequireDefault(__webpack_require__(3360));
	
	var _HeadsetMicSharp = _interopRequireDefault(__webpack_require__(3361));
	
	var _HeadsetMicTwoTone = _interopRequireDefault(__webpack_require__(3362));
	
	var _HeadsetOutlined = _interopRequireDefault(__webpack_require__(3363));
	
	var _HeadsetRounded = _interopRequireDefault(__webpack_require__(3364));
	
	var _HeadsetSharp = _interopRequireDefault(__webpack_require__(3365));
	
	var _HeadsetTwoTone = _interopRequireDefault(__webpack_require__(3366));
	
	var _Healing = _interopRequireDefault(__webpack_require__(3367));
	
	var _HealingOutlined = _interopRequireDefault(__webpack_require__(3368));
	
	var _HealingRounded = _interopRequireDefault(__webpack_require__(3369));
	
	var _HealingSharp = _interopRequireDefault(__webpack_require__(3370));
	
	var _HealingTwoTone = _interopRequireDefault(__webpack_require__(3371));
	
	var _Hearing = _interopRequireDefault(__webpack_require__(3372));
	
	var _HearingOutlined = _interopRequireDefault(__webpack_require__(3373));
	
	var _HearingRounded = _interopRequireDefault(__webpack_require__(3374));
	
	var _HearingSharp = _interopRequireDefault(__webpack_require__(3375));
	
	var _HearingTwoTone = _interopRequireDefault(__webpack_require__(3376));
	
	var _Height = _interopRequireDefault(__webpack_require__(3377));
	
	var _HeightOutlined = _interopRequireDefault(__webpack_require__(3378));
	
	var _HeightRounded = _interopRequireDefault(__webpack_require__(3379));
	
	var _HeightSharp = _interopRequireDefault(__webpack_require__(3380));
	
	var _HeightTwoTone = _interopRequireDefault(__webpack_require__(3381));
	
	var _Help = _interopRequireDefault(__webpack_require__(3382));
	
	var _HelpOutline = _interopRequireDefault(__webpack_require__(3383));
	
	var _HelpOutlined = _interopRequireDefault(__webpack_require__(3388));
	
	var _HelpOutlineOutlined = _interopRequireDefault(__webpack_require__(3384));
	
	var _HelpOutlineRounded = _interopRequireDefault(__webpack_require__(3385));
	
	var _HelpOutlineSharp = _interopRequireDefault(__webpack_require__(3386));
	
	var _HelpOutlineTwoTone = _interopRequireDefault(__webpack_require__(3387));
	
	var _HelpRounded = _interopRequireDefault(__webpack_require__(3389));
	
	var _HelpSharp = _interopRequireDefault(__webpack_require__(3390));
	
	var _HelpTwoTone = _interopRequireDefault(__webpack_require__(3391));
	
	var _Highlight = _interopRequireDefault(__webpack_require__(3397));
	
	var _HighlightOff = _interopRequireDefault(__webpack_require__(3398));
	
	var _HighlightOffOutlined = _interopRequireDefault(__webpack_require__(3399));
	
	var _HighlightOffRounded = _interopRequireDefault(__webpack_require__(3400));
	
	var _HighlightOffSharp = _interopRequireDefault(__webpack_require__(3401));
	
	var _HighlightOffTwoTone = _interopRequireDefault(__webpack_require__(3402));
	
	var _HighlightOutlined = _interopRequireDefault(__webpack_require__(3403));
	
	var _HighlightRounded = _interopRequireDefault(__webpack_require__(3404));
	
	var _HighlightSharp = _interopRequireDefault(__webpack_require__(3405));
	
	var _HighlightTwoTone = _interopRequireDefault(__webpack_require__(3406));
	
	var _HighQuality = _interopRequireDefault(__webpack_require__(3392));
	
	var _HighQualityOutlined = _interopRequireDefault(__webpack_require__(3393));
	
	var _HighQualityRounded = _interopRequireDefault(__webpack_require__(3394));
	
	var _HighQualitySharp = _interopRequireDefault(__webpack_require__(3395));
	
	var _HighQualityTwoTone = _interopRequireDefault(__webpack_require__(3396));
	
	var _History = _interopRequireDefault(__webpack_require__(3407));
	
	var _HistoryOutlined = _interopRequireDefault(__webpack_require__(3408));
	
	var _HistoryRounded = _interopRequireDefault(__webpack_require__(3409));
	
	var _HistorySharp = _interopRequireDefault(__webpack_require__(3410));
	
	var _HistoryTwoTone = _interopRequireDefault(__webpack_require__(3411));
	
	var _Home = _interopRequireDefault(__webpack_require__(3412));
	
	var _HomeOutlined = _interopRequireDefault(__webpack_require__(3413));
	
	var _HomeRounded = _interopRequireDefault(__webpack_require__(3414));
	
	var _HomeSharp = _interopRequireDefault(__webpack_require__(3415));
	
	var _HomeTwoTone = _interopRequireDefault(__webpack_require__(3416));
	
	var _HomeWork = _interopRequireDefault(__webpack_require__(3417));
	
	var _HomeWorkOutlined = _interopRequireDefault(__webpack_require__(3418));
	
	var _HomeWorkRounded = _interopRequireDefault(__webpack_require__(3419));
	
	var _HomeWorkSharp = _interopRequireDefault(__webpack_require__(3420));
	
	var _HomeWorkTwoTone = _interopRequireDefault(__webpack_require__(3421));
	
	var _HorizontalSplit = _interopRequireDefault(__webpack_require__(3422));
	
	var _HorizontalSplitOutlined = _interopRequireDefault(__webpack_require__(3423));
	
	var _HorizontalSplitRounded = _interopRequireDefault(__webpack_require__(3424));
	
	var _HorizontalSplitSharp = _interopRequireDefault(__webpack_require__(3425));
	
	var _HorizontalSplitTwoTone = _interopRequireDefault(__webpack_require__(3426));
	
	var _Hotel = _interopRequireDefault(__webpack_require__(3432));
	
	var _HotelOutlined = _interopRequireDefault(__webpack_require__(3433));
	
	var _HotelRounded = _interopRequireDefault(__webpack_require__(3434));
	
	var _HotelSharp = _interopRequireDefault(__webpack_require__(3435));
	
	var _HotelTwoTone = _interopRequireDefault(__webpack_require__(3436));
	
	var _HotTub = _interopRequireDefault(__webpack_require__(3427));
	
	var _HotTubOutlined = _interopRequireDefault(__webpack_require__(3428));
	
	var _HotTubRounded = _interopRequireDefault(__webpack_require__(3429));
	
	var _HotTubSharp = _interopRequireDefault(__webpack_require__(3430));
	
	var _HotTubTwoTone = _interopRequireDefault(__webpack_require__(3431));
	
	var _HourglassEmpty = _interopRequireDefault(__webpack_require__(3437));
	
	var _HourglassEmptyOutlined = _interopRequireDefault(__webpack_require__(3438));
	
	var _HourglassEmptyRounded = _interopRequireDefault(__webpack_require__(3439));
	
	var _HourglassEmptySharp = _interopRequireDefault(__webpack_require__(3440));
	
	var _HourglassEmptyTwoTone = _interopRequireDefault(__webpack_require__(3441));
	
	var _HourglassFull = _interopRequireDefault(__webpack_require__(3442));
	
	var _HourglassFullOutlined = _interopRequireDefault(__webpack_require__(3443));
	
	var _HourglassFullRounded = _interopRequireDefault(__webpack_require__(3444));
	
	var _HourglassFullSharp = _interopRequireDefault(__webpack_require__(3445));
	
	var _HourglassFullTwoTone = _interopRequireDefault(__webpack_require__(3446));
	
	var _House = _interopRequireDefault(__webpack_require__(3447));
	
	var _HouseOutlined = _interopRequireDefault(__webpack_require__(3448));
	
	var _HouseRounded = _interopRequireDefault(__webpack_require__(3449));
	
	var _HouseSharp = _interopRequireDefault(__webpack_require__(3450));
	
	var _HouseTwoTone = _interopRequireDefault(__webpack_require__(3451));
	
	var _HowToReg = _interopRequireDefault(__webpack_require__(3452));
	
	var _HowToRegOutlined = _interopRequireDefault(__webpack_require__(3453));
	
	var _HowToRegRounded = _interopRequireDefault(__webpack_require__(3454));
	
	var _HowToRegSharp = _interopRequireDefault(__webpack_require__(3455));
	
	var _HowToRegTwoTone = _interopRequireDefault(__webpack_require__(3456));
	
	var _HowToVote = _interopRequireDefault(__webpack_require__(3457));
	
	var _HowToVoteOutlined = _interopRequireDefault(__webpack_require__(3458));
	
	var _HowToVoteRounded = _interopRequireDefault(__webpack_require__(3459));
	
	var _HowToVoteSharp = _interopRequireDefault(__webpack_require__(3460));
	
	var _HowToVoteTwoTone = _interopRequireDefault(__webpack_require__(3461));
	
	var _Http = _interopRequireDefault(__webpack_require__(3462));
	
	var _HttpOutlined = _interopRequireDefault(__webpack_require__(3463));
	
	var _HttpRounded = _interopRequireDefault(__webpack_require__(3464));
	
	var _Https = _interopRequireDefault(__webpack_require__(3467));
	
	var _HttpSharp = _interopRequireDefault(__webpack_require__(3465));
	
	var _HttpsOutlined = _interopRequireDefault(__webpack_require__(3468));
	
	var _HttpsRounded = _interopRequireDefault(__webpack_require__(3469));
	
	var _HttpsSharp = _interopRequireDefault(__webpack_require__(3470));
	
	var _HttpsTwoTone = _interopRequireDefault(__webpack_require__(3471));
	
	var _HttpTwoTone = _interopRequireDefault(__webpack_require__(3466));
	
	var _Image = _interopRequireDefault(__webpack_require__(3472));
	
	var _ImageAspectRatio = _interopRequireDefault(__webpack_require__(3473));
	
	var _ImageAspectRatioOutlined = _interopRequireDefault(__webpack_require__(3474));
	
	var _ImageAspectRatioRounded = _interopRequireDefault(__webpack_require__(3475));
	
	var _ImageAspectRatioSharp = _interopRequireDefault(__webpack_require__(3476));
	
	var _ImageAspectRatioTwoTone = _interopRequireDefault(__webpack_require__(3477));
	
	var _ImageOutlined = _interopRequireDefault(__webpack_require__(3478));
	
	var _ImageRounded = _interopRequireDefault(__webpack_require__(3479));
	
	var _ImageSearch = _interopRequireDefault(__webpack_require__(3480));
	
	var _ImageSearchOutlined = _interopRequireDefault(__webpack_require__(3481));
	
	var _ImageSearchRounded = _interopRequireDefault(__webpack_require__(3482));
	
	var _ImageSearchSharp = _interopRequireDefault(__webpack_require__(3483));
	
	var _ImageSearchTwoTone = _interopRequireDefault(__webpack_require__(3484));
	
	var _ImageSharp = _interopRequireDefault(__webpack_require__(3485));
	
	var _ImageTwoTone = _interopRequireDefault(__webpack_require__(3486));
	
	var _ImportantDevices = _interopRequireDefault(__webpack_require__(3497));
	
	var _ImportantDevicesOutlined = _interopRequireDefault(__webpack_require__(3498));
	
	var _ImportantDevicesRounded = _interopRequireDefault(__webpack_require__(3499));
	
	var _ImportantDevicesSharp = _interopRequireDefault(__webpack_require__(3500));
	
	var _ImportantDevicesTwoTone = _interopRequireDefault(__webpack_require__(3501));
	
	var _ImportContacts = _interopRequireDefault(__webpack_require__(3487));
	
	var _ImportContactsOutlined = _interopRequireDefault(__webpack_require__(3488));
	
	var _ImportContactsRounded = _interopRequireDefault(__webpack_require__(3489));
	
	var _ImportContactsSharp = _interopRequireDefault(__webpack_require__(3490));
	
	var _ImportContactsTwoTone = _interopRequireDefault(__webpack_require__(3491));
	
	var _ImportExport = _interopRequireDefault(__webpack_require__(3492));
	
	var _ImportExportOutlined = _interopRequireDefault(__webpack_require__(3493));
	
	var _ImportExportRounded = _interopRequireDefault(__webpack_require__(3494));
	
	var _ImportExportSharp = _interopRequireDefault(__webpack_require__(3495));
	
	var _ImportExportTwoTone = _interopRequireDefault(__webpack_require__(3496));
	
	var _Inbox = _interopRequireDefault(__webpack_require__(3502));
	
	var _InboxOutlined = _interopRequireDefault(__webpack_require__(3503));
	
	var _InboxRounded = _interopRequireDefault(__webpack_require__(3504));
	
	var _InboxSharp = _interopRequireDefault(__webpack_require__(3505));
	
	var _InboxTwoTone = _interopRequireDefault(__webpack_require__(3506));
	
	var _IndeterminateCheckBox = _interopRequireDefault(__webpack_require__(3507));
	
	var _IndeterminateCheckBoxOutlined = _interopRequireDefault(__webpack_require__(3508));
	
	var _IndeterminateCheckBoxRounded = _interopRequireDefault(__webpack_require__(3509));
	
	var _IndeterminateCheckBoxSharp = _interopRequireDefault(__webpack_require__(3510));
	
	var _IndeterminateCheckBoxTwoTone = _interopRequireDefault(__webpack_require__(3511));
	
	var _Info = _interopRequireDefault(__webpack_require__(3512));
	
	var _InfoOutlined = _interopRequireDefault(__webpack_require__(3513));
	
	var _InfoRounded = _interopRequireDefault(__webpack_require__(3514));
	
	var _InfoSharp = _interopRequireDefault(__webpack_require__(3515));
	
	var _InfoTwoTone = _interopRequireDefault(__webpack_require__(3516));
	
	var _Input = _interopRequireDefault(__webpack_require__(3517));
	
	var _InputOutlined = _interopRequireDefault(__webpack_require__(3518));
	
	var _InputRounded = _interopRequireDefault(__webpack_require__(3519));
	
	var _InputSharp = _interopRequireDefault(__webpack_require__(3520));
	
	var _InputTwoTone = _interopRequireDefault(__webpack_require__(3521));
	
	var _InsertChart = _interopRequireDefault(__webpack_require__(3522));
	
	var _InsertChartOutlined = _interopRequireDefault(__webpack_require__(3523));
	
	var _InsertChartOutlinedOutlined = _interopRequireDefault(__webpack_require__(3524));
	
	var _InsertChartOutlinedRounded = _interopRequireDefault(__webpack_require__(3525));
	
	var _InsertChartOutlinedSharp = _interopRequireDefault(__webpack_require__(3526));
	
	var _InsertChartOutlinedTwoTone = _interopRequireDefault(__webpack_require__(3527));
	
	var _InsertChartRounded = _interopRequireDefault(__webpack_require__(3528));
	
	var _InsertChartSharp = _interopRequireDefault(__webpack_require__(3529));
	
	var _InsertChartTwoTone = _interopRequireDefault(__webpack_require__(3530));
	
	var _InsertComment = _interopRequireDefault(__webpack_require__(3531));
	
	var _InsertCommentOutlined = _interopRequireDefault(__webpack_require__(3532));
	
	var _InsertCommentRounded = _interopRequireDefault(__webpack_require__(3533));
	
	var _InsertCommentSharp = _interopRequireDefault(__webpack_require__(3534));
	
	var _InsertCommentTwoTone = _interopRequireDefault(__webpack_require__(3535));
	
	var _InsertDriveFile = _interopRequireDefault(__webpack_require__(3536));
	
	var _InsertDriveFileOutlined = _interopRequireDefault(__webpack_require__(3537));
	
	var _InsertDriveFileRounded = _interopRequireDefault(__webpack_require__(3538));
	
	var _InsertDriveFileSharp = _interopRequireDefault(__webpack_require__(3539));
	
	var _InsertDriveFileTwoTone = _interopRequireDefault(__webpack_require__(3540));
	
	var _InsertEmoticon = _interopRequireDefault(__webpack_require__(3541));
	
	var _InsertEmoticonOutlined = _interopRequireDefault(__webpack_require__(3542));
	
	var _InsertEmoticonRounded = _interopRequireDefault(__webpack_require__(3543));
	
	var _InsertEmoticonSharp = _interopRequireDefault(__webpack_require__(3544));
	
	var _InsertEmoticonTwoTone = _interopRequireDefault(__webpack_require__(3545));
	
	var _InsertInvitation = _interopRequireDefault(__webpack_require__(3546));
	
	var _InsertInvitationOutlined = _interopRequireDefault(__webpack_require__(3547));
	
	var _InsertInvitationRounded = _interopRequireDefault(__webpack_require__(3548));
	
	var _InsertInvitationSharp = _interopRequireDefault(__webpack_require__(3549));
	
	var _InsertInvitationTwoTone = _interopRequireDefault(__webpack_require__(3550));
	
	var _InsertLink = _interopRequireDefault(__webpack_require__(3551));
	
	var _InsertLinkOutlined = _interopRequireDefault(__webpack_require__(3552));
	
	var _InsertLinkRounded = _interopRequireDefault(__webpack_require__(3553));
	
	var _InsertLinkSharp = _interopRequireDefault(__webpack_require__(3554));
	
	var _InsertLinkTwoTone = _interopRequireDefault(__webpack_require__(3555));
	
	var _InsertPhoto = _interopRequireDefault(__webpack_require__(3556));
	
	var _InsertPhotoOutlined = _interopRequireDefault(__webpack_require__(3557));
	
	var _InsertPhotoRounded = _interopRequireDefault(__webpack_require__(3558));
	
	var _InsertPhotoSharp = _interopRequireDefault(__webpack_require__(3559));
	
	var _InsertPhotoTwoTone = _interopRequireDefault(__webpack_require__(3560));
	
	var _Instagram = _interopRequireDefault(__webpack_require__(3561));
	
	var _InvertColors = _interopRequireDefault(__webpack_require__(3562));
	
	var _InvertColorsOff = _interopRequireDefault(__webpack_require__(3563));
	
	var _InvertColorsOffOutlined = _interopRequireDefault(__webpack_require__(3564));
	
	var _InvertColorsOffRounded = _interopRequireDefault(__webpack_require__(3565));
	
	var _InvertColorsOffSharp = _interopRequireDefault(__webpack_require__(3566));
	
	var _InvertColorsOffTwoTone = _interopRequireDefault(__webpack_require__(3567));
	
	var _InvertColorsOutlined = _interopRequireDefault(__webpack_require__(3568));
	
	var _InvertColorsRounded = _interopRequireDefault(__webpack_require__(3569));
	
	var _InvertColorsSharp = _interopRequireDefault(__webpack_require__(3570));
	
	var _InvertColorsTwoTone = _interopRequireDefault(__webpack_require__(3571));
	
	var _Iso = _interopRequireDefault(__webpack_require__(3572));
	
	var _IsoOutlined = _interopRequireDefault(__webpack_require__(3573));
	
	var _IsoRounded = _interopRequireDefault(__webpack_require__(3574));
	
	var _IsoSharp = _interopRequireDefault(__webpack_require__(3575));
	
	var _IsoTwoTone = _interopRequireDefault(__webpack_require__(3576));
	
	var _Keyboard = _interopRequireDefault(__webpack_require__(3577));
	
	var _KeyboardArrowDown = _interopRequireDefault(__webpack_require__(3578));
	
	var _KeyboardArrowDownOutlined = _interopRequireDefault(__webpack_require__(3579));
	
	var _KeyboardArrowDownRounded = _interopRequireDefault(__webpack_require__(3580));
	
	var _KeyboardArrowDownSharp = _interopRequireDefault(__webpack_require__(3581));
	
	var _KeyboardArrowDownTwoTone = _interopRequireDefault(__webpack_require__(3582));
	
	var _KeyboardArrowLeft = _interopRequireDefault(__webpack_require__(3583));
	
	var _KeyboardArrowLeftOutlined = _interopRequireDefault(__webpack_require__(3584));
	
	var _KeyboardArrowLeftRounded = _interopRequireDefault(__webpack_require__(3585));
	
	var _KeyboardArrowLeftSharp = _interopRequireDefault(__webpack_require__(3586));
	
	var _KeyboardArrowLeftTwoTone = _interopRequireDefault(__webpack_require__(3587));
	
	var _KeyboardArrowRight = _interopRequireDefault(__webpack_require__(3588));
	
	var _KeyboardArrowRightOutlined = _interopRequireDefault(__webpack_require__(3589));
	
	var _KeyboardArrowRightRounded = _interopRequireDefault(__webpack_require__(3590));
	
	var _KeyboardArrowRightSharp = _interopRequireDefault(__webpack_require__(3591));
	
	var _KeyboardArrowRightTwoTone = _interopRequireDefault(__webpack_require__(3592));
	
	var _KeyboardArrowUp = _interopRequireDefault(__webpack_require__(3593));
	
	var _KeyboardArrowUpOutlined = _interopRequireDefault(__webpack_require__(3594));
	
	var _KeyboardArrowUpRounded = _interopRequireDefault(__webpack_require__(3595));
	
	var _KeyboardArrowUpSharp = _interopRequireDefault(__webpack_require__(3596));
	
	var _KeyboardArrowUpTwoTone = _interopRequireDefault(__webpack_require__(3597));
	
	var _KeyboardBackspace = _interopRequireDefault(__webpack_require__(3598));
	
	var _KeyboardBackspaceOutlined = _interopRequireDefault(__webpack_require__(3599));
	
	var _KeyboardBackspaceRounded = _interopRequireDefault(__webpack_require__(3600));
	
	var _KeyboardBackspaceSharp = _interopRequireDefault(__webpack_require__(3601));
	
	var _KeyboardBackspaceTwoTone = _interopRequireDefault(__webpack_require__(3602));
	
	var _KeyboardCapslock = _interopRequireDefault(__webpack_require__(3603));
	
	var _KeyboardCapslockOutlined = _interopRequireDefault(__webpack_require__(3604));
	
	var _KeyboardCapslockRounded = _interopRequireDefault(__webpack_require__(3605));
	
	var _KeyboardCapslockSharp = _interopRequireDefault(__webpack_require__(3606));
	
	var _KeyboardCapslockTwoTone = _interopRequireDefault(__webpack_require__(3607));
	
	var _KeyboardHide = _interopRequireDefault(__webpack_require__(3608));
	
	var _KeyboardHideOutlined = _interopRequireDefault(__webpack_require__(3609));
	
	var _KeyboardHideRounded = _interopRequireDefault(__webpack_require__(3610));
	
	var _KeyboardHideSharp = _interopRequireDefault(__webpack_require__(3611));
	
	var _KeyboardHideTwoTone = _interopRequireDefault(__webpack_require__(3612));
	
	var _KeyboardOutlined = _interopRequireDefault(__webpack_require__(3613));
	
	var _KeyboardReturn = _interopRequireDefault(__webpack_require__(3614));
	
	var _KeyboardReturnOutlined = _interopRequireDefault(__webpack_require__(3615));
	
	var _KeyboardReturnRounded = _interopRequireDefault(__webpack_require__(3616));
	
	var _KeyboardReturnSharp = _interopRequireDefault(__webpack_require__(3617));
	
	var _KeyboardReturnTwoTone = _interopRequireDefault(__webpack_require__(3618));
	
	var _KeyboardRounded = _interopRequireDefault(__webpack_require__(3619));
	
	var _KeyboardSharp = _interopRequireDefault(__webpack_require__(3620));
	
	var _KeyboardTab = _interopRequireDefault(__webpack_require__(3621));
	
	var _KeyboardTabOutlined = _interopRequireDefault(__webpack_require__(3622));
	
	var _KeyboardTabRounded = _interopRequireDefault(__webpack_require__(3623));
	
	var _KeyboardTabSharp = _interopRequireDefault(__webpack_require__(3624));
	
	var _KeyboardTabTwoTone = _interopRequireDefault(__webpack_require__(3625));
	
	var _KeyboardTwoTone = _interopRequireDefault(__webpack_require__(3626));
	
	var _KeyboardVoice = _interopRequireDefault(__webpack_require__(3627));
	
	var _KeyboardVoiceOutlined = _interopRequireDefault(__webpack_require__(3628));
	
	var _KeyboardVoiceRounded = _interopRequireDefault(__webpack_require__(3629));
	
	var _KeyboardVoiceSharp = _interopRequireDefault(__webpack_require__(3630));
	
	var _KeyboardVoiceTwoTone = _interopRequireDefault(__webpack_require__(3631));
	
	var _KingBed = _interopRequireDefault(__webpack_require__(3632));
	
	var _KingBedOutlined = _interopRequireDefault(__webpack_require__(3633));
	
	var _KingBedRounded = _interopRequireDefault(__webpack_require__(3634));
	
	var _KingBedSharp = _interopRequireDefault(__webpack_require__(3635));
	
	var _KingBedTwoTone = _interopRequireDefault(__webpack_require__(3636));
	
	var _Kitchen = _interopRequireDefault(__webpack_require__(3637));
	
	var _KitchenOutlined = _interopRequireDefault(__webpack_require__(3638));
	
	var _KitchenRounded = _interopRequireDefault(__webpack_require__(3639));
	
	var _KitchenSharp = _interopRequireDefault(__webpack_require__(3640));
	
	var _KitchenTwoTone = _interopRequireDefault(__webpack_require__(3641));
	
	var _Label = _interopRequireDefault(__webpack_require__(3642));
	
	var _LabelImportant = _interopRequireDefault(__webpack_require__(3643));
	
	var _LabelImportantOutlined = _interopRequireDefault(__webpack_require__(3644));
	
	var _LabelImportantRounded = _interopRequireDefault(__webpack_require__(3645));
	
	var _LabelImportantSharp = _interopRequireDefault(__webpack_require__(3646));
	
	var _LabelImportantTwoTone = _interopRequireDefault(__webpack_require__(3647));
	
	var _LabelOff = _interopRequireDefault(__webpack_require__(3648));
	
	var _LabelOffOutlined = _interopRequireDefault(__webpack_require__(3649));
	
	var _LabelOffRounded = _interopRequireDefault(__webpack_require__(3650));
	
	var _LabelOffSharp = _interopRequireDefault(__webpack_require__(3651));
	
	var _LabelOffTwoTone = _interopRequireDefault(__webpack_require__(3652));
	
	var _LabelOutlined = _interopRequireDefault(__webpack_require__(3653));
	
	var _LabelRounded = _interopRequireDefault(__webpack_require__(3654));
	
	var _LabelSharp = _interopRequireDefault(__webpack_require__(3655));
	
	var _LabelTwoTone = _interopRequireDefault(__webpack_require__(3656));
	
	var _Landscape = _interopRequireDefault(__webpack_require__(3657));
	
	var _LandscapeOutlined = _interopRequireDefault(__webpack_require__(3658));
	
	var _LandscapeRounded = _interopRequireDefault(__webpack_require__(3659));
	
	var _LandscapeSharp = _interopRequireDefault(__webpack_require__(3660));
	
	var _LandscapeTwoTone = _interopRequireDefault(__webpack_require__(3661));
	
	var _Language = _interopRequireDefault(__webpack_require__(3662));
	
	var _LanguageOutlined = _interopRequireDefault(__webpack_require__(3663));
	
	var _LanguageRounded = _interopRequireDefault(__webpack_require__(3664));
	
	var _LanguageSharp = _interopRequireDefault(__webpack_require__(3665));
	
	var _LanguageTwoTone = _interopRequireDefault(__webpack_require__(3666));
	
	var _Laptop = _interopRequireDefault(__webpack_require__(3667));
	
	var _LaptopChromebook = _interopRequireDefault(__webpack_require__(3668));
	
	var _LaptopChromebookOutlined = _interopRequireDefault(__webpack_require__(3669));
	
	var _LaptopChromebookRounded = _interopRequireDefault(__webpack_require__(3670));
	
	var _LaptopChromebookSharp = _interopRequireDefault(__webpack_require__(3671));
	
	var _LaptopChromebookTwoTone = _interopRequireDefault(__webpack_require__(3672));
	
	var _LaptopMac = _interopRequireDefault(__webpack_require__(3673));
	
	var _LaptopMacOutlined = _interopRequireDefault(__webpack_require__(3674));
	
	var _LaptopMacRounded = _interopRequireDefault(__webpack_require__(3675));
	
	var _LaptopMacSharp = _interopRequireDefault(__webpack_require__(3676));
	
	var _LaptopMacTwoTone = _interopRequireDefault(__webpack_require__(3677));
	
	var _LaptopOutlined = _interopRequireDefault(__webpack_require__(3678));
	
	var _LaptopRounded = _interopRequireDefault(__webpack_require__(3679));
	
	var _LaptopSharp = _interopRequireDefault(__webpack_require__(3680));
	
	var _LaptopTwoTone = _interopRequireDefault(__webpack_require__(3681));
	
	var _LaptopWindows = _interopRequireDefault(__webpack_require__(3682));
	
	var _LaptopWindowsOutlined = _interopRequireDefault(__webpack_require__(3683));
	
	var _LaptopWindowsRounded = _interopRequireDefault(__webpack_require__(3684));
	
	var _LaptopWindowsSharp = _interopRequireDefault(__webpack_require__(3685));
	
	var _LaptopWindowsTwoTone = _interopRequireDefault(__webpack_require__(3686));
	
	var _LastPage = _interopRequireDefault(__webpack_require__(3687));
	
	var _LastPageOutlined = _interopRequireDefault(__webpack_require__(3688));
	
	var _LastPageRounded = _interopRequireDefault(__webpack_require__(3689));
	
	var _LastPageSharp = _interopRequireDefault(__webpack_require__(3690));
	
	var _LastPageTwoTone = _interopRequireDefault(__webpack_require__(3691));
	
	var _Launch = _interopRequireDefault(__webpack_require__(3692));
	
	var _LaunchOutlined = _interopRequireDefault(__webpack_require__(3693));
	
	var _LaunchRounded = _interopRequireDefault(__webpack_require__(3694));
	
	var _LaunchSharp = _interopRequireDefault(__webpack_require__(3695));
	
	var _LaunchTwoTone = _interopRequireDefault(__webpack_require__(3696));
	
	var _Layers = _interopRequireDefault(__webpack_require__(3697));
	
	var _LayersClear = _interopRequireDefault(__webpack_require__(3698));
	
	var _LayersClearOutlined = _interopRequireDefault(__webpack_require__(3699));
	
	var _LayersClearRounded = _interopRequireDefault(__webpack_require__(3700));
	
	var _LayersClearSharp = _interopRequireDefault(__webpack_require__(3701));
	
	var _LayersClearTwoTone = _interopRequireDefault(__webpack_require__(3702));
	
	var _LayersOutlined = _interopRequireDefault(__webpack_require__(3703));
	
	var _LayersRounded = _interopRequireDefault(__webpack_require__(3704));
	
	var _LayersSharp = _interopRequireDefault(__webpack_require__(3705));
	
	var _LayersTwoTone = _interopRequireDefault(__webpack_require__(3706));
	
	var _LeakAdd = _interopRequireDefault(__webpack_require__(3707));
	
	var _LeakAddOutlined = _interopRequireDefault(__webpack_require__(3708));
	
	var _LeakAddRounded = _interopRequireDefault(__webpack_require__(3709));
	
	var _LeakAddSharp = _interopRequireDefault(__webpack_require__(3710));
	
	var _LeakAddTwoTone = _interopRequireDefault(__webpack_require__(3711));
	
	var _LeakRemove = _interopRequireDefault(__webpack_require__(3712));
	
	var _LeakRemoveOutlined = _interopRequireDefault(__webpack_require__(3713));
	
	var _LeakRemoveRounded = _interopRequireDefault(__webpack_require__(3714));
	
	var _LeakRemoveSharp = _interopRequireDefault(__webpack_require__(3715));
	
	var _LeakRemoveTwoTone = _interopRequireDefault(__webpack_require__(3716));
	
	var _Lens = _interopRequireDefault(__webpack_require__(3717));
	
	var _LensOutlined = _interopRequireDefault(__webpack_require__(3718));
	
	var _LensRounded = _interopRequireDefault(__webpack_require__(3719));
	
	var _LensSharp = _interopRequireDefault(__webpack_require__(3720));
	
	var _LensTwoTone = _interopRequireDefault(__webpack_require__(3721));
	
	var _LibraryAdd = _interopRequireDefault(__webpack_require__(3722));
	
	var _LibraryAddCheck = _interopRequireDefault(__webpack_require__(3723));
	
	var _LibraryAddCheckOutlined = _interopRequireDefault(__webpack_require__(3724));
	
	var _LibraryAddCheckRounded = _interopRequireDefault(__webpack_require__(3725));
	
	var _LibraryAddCheckSharp = _interopRequireDefault(__webpack_require__(3726));
	
	var _LibraryAddCheckTwoTone = _interopRequireDefault(__webpack_require__(3727));
	
	var _LibraryAddOutlined = _interopRequireDefault(__webpack_require__(3728));
	
	var _LibraryAddRounded = _interopRequireDefault(__webpack_require__(3729));
	
	var _LibraryAddSharp = _interopRequireDefault(__webpack_require__(3730));
	
	var _LibraryAddTwoTone = _interopRequireDefault(__webpack_require__(3731));
	
	var _LibraryBooks = _interopRequireDefault(__webpack_require__(3732));
	
	var _LibraryBooksOutlined = _interopRequireDefault(__webpack_require__(3733));
	
	var _LibraryBooksRounded = _interopRequireDefault(__webpack_require__(3734));
	
	var _LibraryBooksSharp = _interopRequireDefault(__webpack_require__(3735));
	
	var _LibraryBooksTwoTone = _interopRequireDefault(__webpack_require__(3736));
	
	var _LibraryMusic = _interopRequireDefault(__webpack_require__(3737));
	
	var _LibraryMusicOutlined = _interopRequireDefault(__webpack_require__(3738));
	
	var _LibraryMusicRounded = _interopRequireDefault(__webpack_require__(3739));
	
	var _LibraryMusicSharp = _interopRequireDefault(__webpack_require__(3740));
	
	var _LibraryMusicTwoTone = _interopRequireDefault(__webpack_require__(3741));
	
	var _LinearScale = _interopRequireDefault(__webpack_require__(3752));
	
	var _LinearScaleOutlined = _interopRequireDefault(__webpack_require__(3753));
	
	var _LinearScaleRounded = _interopRequireDefault(__webpack_require__(3754));
	
	var _LinearScaleSharp = _interopRequireDefault(__webpack_require__(3755));
	
	var _LinearScaleTwoTone = _interopRequireDefault(__webpack_require__(3756));
	
	var _LineStyle = _interopRequireDefault(__webpack_require__(3742));
	
	var _LineStyleOutlined = _interopRequireDefault(__webpack_require__(3743));
	
	var _LineStyleRounded = _interopRequireDefault(__webpack_require__(3744));
	
	var _LineStyleSharp = _interopRequireDefault(__webpack_require__(3745));
	
	var _LineStyleTwoTone = _interopRequireDefault(__webpack_require__(3746));
	
	var _LineWeight = _interopRequireDefault(__webpack_require__(3747));
	
	var _LineWeightOutlined = _interopRequireDefault(__webpack_require__(3748));
	
	var _LineWeightRounded = _interopRequireDefault(__webpack_require__(3749));
	
	var _LineWeightSharp = _interopRequireDefault(__webpack_require__(3750));
	
	var _LineWeightTwoTone = _interopRequireDefault(__webpack_require__(3751));
	
	var _Link = _interopRequireDefault(__webpack_require__(3757));
	
	var _LinkedCamera = _interopRequireDefault(__webpack_require__(3767));
	
	var _LinkedCameraOutlined = _interopRequireDefault(__webpack_require__(3768));
	
	var _LinkedCameraRounded = _interopRequireDefault(__webpack_require__(3769));
	
	var _LinkedCameraSharp = _interopRequireDefault(__webpack_require__(3770));
	
	var _LinkedCameraTwoTone = _interopRequireDefault(__webpack_require__(3771));
	
	var _LinkedIn = _interopRequireDefault(__webpack_require__(3772));
	
	var _LinkOff = _interopRequireDefault(__webpack_require__(3758));
	
	var _LinkOffOutlined = _interopRequireDefault(__webpack_require__(3759));
	
	var _LinkOffRounded = _interopRequireDefault(__webpack_require__(3760));
	
	var _LinkOffSharp = _interopRequireDefault(__webpack_require__(3761));
	
	var _LinkOffTwoTone = _interopRequireDefault(__webpack_require__(3762));
	
	var _LinkOutlined = _interopRequireDefault(__webpack_require__(3763));
	
	var _LinkRounded = _interopRequireDefault(__webpack_require__(3764));
	
	var _LinkSharp = _interopRequireDefault(__webpack_require__(3765));
	
	var _LinkTwoTone = _interopRequireDefault(__webpack_require__(3766));
	
	var _List = _interopRequireDefault(__webpack_require__(3773));
	
	var _ListAlt = _interopRequireDefault(__webpack_require__(3774));
	
	var _ListAltOutlined = _interopRequireDefault(__webpack_require__(3775));
	
	var _ListAltRounded = _interopRequireDefault(__webpack_require__(3776));
	
	var _ListAltSharp = _interopRequireDefault(__webpack_require__(3777));
	
	var _ListAltTwoTone = _interopRequireDefault(__webpack_require__(3778));
	
	var _ListOutlined = _interopRequireDefault(__webpack_require__(3779));
	
	var _ListRounded = _interopRequireDefault(__webpack_require__(3780));
	
	var _ListSharp = _interopRequireDefault(__webpack_require__(3781));
	
	var _ListTwoTone = _interopRequireDefault(__webpack_require__(3782));
	
	var _LiveHelp = _interopRequireDefault(__webpack_require__(3783));
	
	var _LiveHelpOutlined = _interopRequireDefault(__webpack_require__(3784));
	
	var _LiveHelpRounded = _interopRequireDefault(__webpack_require__(3785));
	
	var _LiveHelpSharp = _interopRequireDefault(__webpack_require__(3786));
	
	var _LiveHelpTwoTone = _interopRequireDefault(__webpack_require__(3787));
	
	var _LiveTv = _interopRequireDefault(__webpack_require__(3788));
	
	var _LiveTvOutlined = _interopRequireDefault(__webpack_require__(3789));
	
	var _LiveTvRounded = _interopRequireDefault(__webpack_require__(3790));
	
	var _LiveTvSharp = _interopRequireDefault(__webpack_require__(3791));
	
	var _LiveTvTwoTone = _interopRequireDefault(__webpack_require__(3792));
	
	var _LocalActivity = _interopRequireDefault(__webpack_require__(3793));
	
	var _LocalActivityOutlined = _interopRequireDefault(__webpack_require__(3794));
	
	var _LocalActivityRounded = _interopRequireDefault(__webpack_require__(3795));
	
	var _LocalActivitySharp = _interopRequireDefault(__webpack_require__(3796));
	
	var _LocalActivityTwoTone = _interopRequireDefault(__webpack_require__(3797));
	
	var _LocalAirport = _interopRequireDefault(__webpack_require__(3798));
	
	var _LocalAirportOutlined = _interopRequireDefault(__webpack_require__(3799));
	
	var _LocalAirportRounded = _interopRequireDefault(__webpack_require__(3800));
	
	var _LocalAirportSharp = _interopRequireDefault(__webpack_require__(3801));
	
	var _LocalAirportTwoTone = _interopRequireDefault(__webpack_require__(3802));
	
	var _LocalAtm = _interopRequireDefault(__webpack_require__(3803));
	
	var _LocalAtmOutlined = _interopRequireDefault(__webpack_require__(3804));
	
	var _LocalAtmRounded = _interopRequireDefault(__webpack_require__(3805));
	
	var _LocalAtmSharp = _interopRequireDefault(__webpack_require__(3806));
	
	var _LocalAtmTwoTone = _interopRequireDefault(__webpack_require__(3807));
	
	var _LocalBar = _interopRequireDefault(__webpack_require__(3808));
	
	var _LocalBarOutlined = _interopRequireDefault(__webpack_require__(3809));
	
	var _LocalBarRounded = _interopRequireDefault(__webpack_require__(3810));
	
	var _LocalBarSharp = _interopRequireDefault(__webpack_require__(3811));
	
	var _LocalBarTwoTone = _interopRequireDefault(__webpack_require__(3812));
	
	var _LocalCafe = _interopRequireDefault(__webpack_require__(3813));
	
	var _LocalCafeOutlined = _interopRequireDefault(__webpack_require__(3814));
	
	var _LocalCafeRounded = _interopRequireDefault(__webpack_require__(3815));
	
	var _LocalCafeSharp = _interopRequireDefault(__webpack_require__(3816));
	
	var _LocalCafeTwoTone = _interopRequireDefault(__webpack_require__(3817));
	
	var _LocalCarWash = _interopRequireDefault(__webpack_require__(3818));
	
	var _LocalCarWashOutlined = _interopRequireDefault(__webpack_require__(3819));
	
	var _LocalCarWashRounded = _interopRequireDefault(__webpack_require__(3820));
	
	var _LocalCarWashSharp = _interopRequireDefault(__webpack_require__(3821));
	
	var _LocalCarWashTwoTone = _interopRequireDefault(__webpack_require__(3822));
	
	var _LocalConvenienceStore = _interopRequireDefault(__webpack_require__(3823));
	
	var _LocalConvenienceStoreOutlined = _interopRequireDefault(__webpack_require__(3824));
	
	var _LocalConvenienceStoreRounded = _interopRequireDefault(__webpack_require__(3825));
	
	var _LocalConvenienceStoreSharp = _interopRequireDefault(__webpack_require__(3826));
	
	var _LocalConvenienceStoreTwoTone = _interopRequireDefault(__webpack_require__(3827));
	
	var _LocalDining = _interopRequireDefault(__webpack_require__(3828));
	
	var _LocalDiningOutlined = _interopRequireDefault(__webpack_require__(3829));
	
	var _LocalDiningRounded = _interopRequireDefault(__webpack_require__(3830));
	
	var _LocalDiningSharp = _interopRequireDefault(__webpack_require__(3831));
	
	var _LocalDiningTwoTone = _interopRequireDefault(__webpack_require__(3832));
	
	var _LocalDrink = _interopRequireDefault(__webpack_require__(3833));
	
	var _LocalDrinkOutlined = _interopRequireDefault(__webpack_require__(3834));
	
	var _LocalDrinkRounded = _interopRequireDefault(__webpack_require__(3835));
	
	var _LocalDrinkSharp = _interopRequireDefault(__webpack_require__(3836));
	
	var _LocalDrinkTwoTone = _interopRequireDefault(__webpack_require__(3837));
	
	var _LocalFlorist = _interopRequireDefault(__webpack_require__(3838));
	
	var _LocalFloristOutlined = _interopRequireDefault(__webpack_require__(3839));
	
	var _LocalFloristRounded = _interopRequireDefault(__webpack_require__(3840));
	
	var _LocalFloristSharp = _interopRequireDefault(__webpack_require__(3841));
	
	var _LocalFloristTwoTone = _interopRequireDefault(__webpack_require__(3842));
	
	var _LocalGasStation = _interopRequireDefault(__webpack_require__(3843));
	
	var _LocalGasStationOutlined = _interopRequireDefault(__webpack_require__(3844));
	
	var _LocalGasStationRounded = _interopRequireDefault(__webpack_require__(3845));
	
	var _LocalGasStationSharp = _interopRequireDefault(__webpack_require__(3846));
	
	var _LocalGasStationTwoTone = _interopRequireDefault(__webpack_require__(3847));
	
	var _LocalGroceryStore = _interopRequireDefault(__webpack_require__(3848));
	
	var _LocalGroceryStoreOutlined = _interopRequireDefault(__webpack_require__(3849));
	
	var _LocalGroceryStoreRounded = _interopRequireDefault(__webpack_require__(3850));
	
	var _LocalGroceryStoreSharp = _interopRequireDefault(__webpack_require__(3851));
	
	var _LocalGroceryStoreTwoTone = _interopRequireDefault(__webpack_require__(3852));
	
	var _LocalHospital = _interopRequireDefault(__webpack_require__(3853));
	
	var _LocalHospitalOutlined = _interopRequireDefault(__webpack_require__(3854));
	
	var _LocalHospitalRounded = _interopRequireDefault(__webpack_require__(3855));
	
	var _LocalHospitalSharp = _interopRequireDefault(__webpack_require__(3856));
	
	var _LocalHospitalTwoTone = _interopRequireDefault(__webpack_require__(3857));
	
	var _LocalHotel = _interopRequireDefault(__webpack_require__(3858));
	
	var _LocalHotelOutlined = _interopRequireDefault(__webpack_require__(3859));
	
	var _LocalHotelRounded = _interopRequireDefault(__webpack_require__(3860));
	
	var _LocalHotelSharp = _interopRequireDefault(__webpack_require__(3861));
	
	var _LocalHotelTwoTone = _interopRequireDefault(__webpack_require__(3862));
	
	var _LocalLaundryService = _interopRequireDefault(__webpack_require__(3863));
	
	var _LocalLaundryServiceOutlined = _interopRequireDefault(__webpack_require__(3864));
	
	var _LocalLaundryServiceRounded = _interopRequireDefault(__webpack_require__(3865));
	
	var _LocalLaundryServiceSharp = _interopRequireDefault(__webpack_require__(3866));
	
	var _LocalLaundryServiceTwoTone = _interopRequireDefault(__webpack_require__(3867));
	
	var _LocalLibrary = _interopRequireDefault(__webpack_require__(3868));
	
	var _LocalLibraryOutlined = _interopRequireDefault(__webpack_require__(3869));
	
	var _LocalLibraryRounded = _interopRequireDefault(__webpack_require__(3870));
	
	var _LocalLibrarySharp = _interopRequireDefault(__webpack_require__(3871));
	
	var _LocalLibraryTwoTone = _interopRequireDefault(__webpack_require__(3872));
	
	var _LocalMall = _interopRequireDefault(__webpack_require__(3873));
	
	var _LocalMallOutlined = _interopRequireDefault(__webpack_require__(3874));
	
	var _LocalMallRounded = _interopRequireDefault(__webpack_require__(3875));
	
	var _LocalMallSharp = _interopRequireDefault(__webpack_require__(3876));
	
	var _LocalMallTwoTone = _interopRequireDefault(__webpack_require__(3877));
	
	var _LocalMovies = _interopRequireDefault(__webpack_require__(3878));
	
	var _LocalMoviesOutlined = _interopRequireDefault(__webpack_require__(3879));
	
	var _LocalMoviesRounded = _interopRequireDefault(__webpack_require__(3880));
	
	var _LocalMoviesSharp = _interopRequireDefault(__webpack_require__(3881));
	
	var _LocalMoviesTwoTone = _interopRequireDefault(__webpack_require__(3882));
	
	var _LocalOffer = _interopRequireDefault(__webpack_require__(3883));
	
	var _LocalOfferOutlined = _interopRequireDefault(__webpack_require__(3884));
	
	var _LocalOfferRounded = _interopRequireDefault(__webpack_require__(3885));
	
	var _LocalOfferSharp = _interopRequireDefault(__webpack_require__(3886));
	
	var _LocalOfferTwoTone = _interopRequireDefault(__webpack_require__(3887));
	
	var _LocalParking = _interopRequireDefault(__webpack_require__(3888));
	
	var _LocalParkingOutlined = _interopRequireDefault(__webpack_require__(3889));
	
	var _LocalParkingRounded = _interopRequireDefault(__webpack_require__(3890));
	
	var _LocalParkingSharp = _interopRequireDefault(__webpack_require__(3891));
	
	var _LocalParkingTwoTone = _interopRequireDefault(__webpack_require__(3892));
	
	var _LocalPharmacy = _interopRequireDefault(__webpack_require__(3893));
	
	var _LocalPharmacyOutlined = _interopRequireDefault(__webpack_require__(3894));
	
	var _LocalPharmacyRounded = _interopRequireDefault(__webpack_require__(3895));
	
	var _LocalPharmacySharp = _interopRequireDefault(__webpack_require__(3896));
	
	var _LocalPharmacyTwoTone = _interopRequireDefault(__webpack_require__(3897));
	
	var _LocalPhone = _interopRequireDefault(__webpack_require__(3898));
	
	var _LocalPhoneOutlined = _interopRequireDefault(__webpack_require__(3899));
	
	var _LocalPhoneRounded = _interopRequireDefault(__webpack_require__(3900));
	
	var _LocalPhoneSharp = _interopRequireDefault(__webpack_require__(3901));
	
	var _LocalPhoneTwoTone = _interopRequireDefault(__webpack_require__(3902));
	
	var _LocalPizza = _interopRequireDefault(__webpack_require__(3903));
	
	var _LocalPizzaOutlined = _interopRequireDefault(__webpack_require__(3904));
	
	var _LocalPizzaRounded = _interopRequireDefault(__webpack_require__(3905));
	
	var _LocalPizzaSharp = _interopRequireDefault(__webpack_require__(3906));
	
	var _LocalPizzaTwoTone = _interopRequireDefault(__webpack_require__(3907));
	
	var _LocalPlay = _interopRequireDefault(__webpack_require__(3908));
	
	var _LocalPlayOutlined = _interopRequireDefault(__webpack_require__(3909));
	
	var _LocalPlayRounded = _interopRequireDefault(__webpack_require__(3910));
	
	var _LocalPlaySharp = _interopRequireDefault(__webpack_require__(3911));
	
	var _LocalPlayTwoTone = _interopRequireDefault(__webpack_require__(3912));
	
	var _LocalPostOffice = _interopRequireDefault(__webpack_require__(3913));
	
	var _LocalPostOfficeOutlined = _interopRequireDefault(__webpack_require__(3914));
	
	var _LocalPostOfficeRounded = _interopRequireDefault(__webpack_require__(3915));
	
	var _LocalPostOfficeSharp = _interopRequireDefault(__webpack_require__(3916));
	
	var _LocalPostOfficeTwoTone = _interopRequireDefault(__webpack_require__(3917));
	
	var _LocalPrintshop = _interopRequireDefault(__webpack_require__(3918));
	
	var _LocalPrintshopOutlined = _interopRequireDefault(__webpack_require__(3919));
	
	var _LocalPrintshopRounded = _interopRequireDefault(__webpack_require__(3920));
	
	var _LocalPrintshopSharp = _interopRequireDefault(__webpack_require__(3921));
	
	var _LocalPrintshopTwoTone = _interopRequireDefault(__webpack_require__(3922));
	
	var _LocalSee = _interopRequireDefault(__webpack_require__(3923));
	
	var _LocalSeeOutlined = _interopRequireDefault(__webpack_require__(3924));
	
	var _LocalSeeRounded = _interopRequireDefault(__webpack_require__(3925));
	
	var _LocalSeeSharp = _interopRequireDefault(__webpack_require__(3926));
	
	var _LocalSeeTwoTone = _interopRequireDefault(__webpack_require__(3927));
	
	var _LocalShipping = _interopRequireDefault(__webpack_require__(3928));
	
	var _LocalShippingOutlined = _interopRequireDefault(__webpack_require__(3929));
	
	var _LocalShippingRounded = _interopRequireDefault(__webpack_require__(3930));
	
	var _LocalShippingSharp = _interopRequireDefault(__webpack_require__(3931));
	
	var _LocalShippingTwoTone = _interopRequireDefault(__webpack_require__(3932));
	
	var _LocalTaxi = _interopRequireDefault(__webpack_require__(3933));
	
	var _LocalTaxiOutlined = _interopRequireDefault(__webpack_require__(3934));
	
	var _LocalTaxiRounded = _interopRequireDefault(__webpack_require__(3935));
	
	var _LocalTaxiSharp = _interopRequireDefault(__webpack_require__(3936));
	
	var _LocalTaxiTwoTone = _interopRequireDefault(__webpack_require__(3937));
	
	var _LocationCity = _interopRequireDefault(__webpack_require__(3938));
	
	var _LocationCityOutlined = _interopRequireDefault(__webpack_require__(3939));
	
	var _LocationCityRounded = _interopRequireDefault(__webpack_require__(3940));
	
	var _LocationCitySharp = _interopRequireDefault(__webpack_require__(3941));
	
	var _LocationCityTwoTone = _interopRequireDefault(__webpack_require__(3942));
	
	var _LocationDisabled = _interopRequireDefault(__webpack_require__(3943));
	
	var _LocationDisabledOutlined = _interopRequireDefault(__webpack_require__(3944));
	
	var _LocationDisabledRounded = _interopRequireDefault(__webpack_require__(3945));
	
	var _LocationDisabledSharp = _interopRequireDefault(__webpack_require__(3946));
	
	var _LocationDisabledTwoTone = _interopRequireDefault(__webpack_require__(3947));
	
	var _LocationOff = _interopRequireDefault(__webpack_require__(3948));
	
	var _LocationOffOutlined = _interopRequireDefault(__webpack_require__(3949));
	
	var _LocationOffRounded = _interopRequireDefault(__webpack_require__(3950));
	
	var _LocationOffSharp = _interopRequireDefault(__webpack_require__(3951));
	
	var _LocationOffTwoTone = _interopRequireDefault(__webpack_require__(3952));
	
	var _LocationOn = _interopRequireDefault(__webpack_require__(3953));
	
	var _LocationOnOutlined = _interopRequireDefault(__webpack_require__(3954));
	
	var _LocationOnRounded = _interopRequireDefault(__webpack_require__(3955));
	
	var _LocationOnSharp = _interopRequireDefault(__webpack_require__(3956));
	
	var _LocationOnTwoTone = _interopRequireDefault(__webpack_require__(3957));
	
	var _LocationSearching = _interopRequireDefault(__webpack_require__(3958));
	
	var _LocationSearchingOutlined = _interopRequireDefault(__webpack_require__(3959));
	
	var _LocationSearchingRounded = _interopRequireDefault(__webpack_require__(3960));
	
	var _LocationSearchingSharp = _interopRequireDefault(__webpack_require__(3961));
	
	var _LocationSearchingTwoTone = _interopRequireDefault(__webpack_require__(3962));
	
	var _Lock = _interopRequireDefault(__webpack_require__(3963));
	
	var _LockOpen = _interopRequireDefault(__webpack_require__(3964));
	
	var _LockOpenOutlined = _interopRequireDefault(__webpack_require__(3965));
	
	var _LockOpenRounded = _interopRequireDefault(__webpack_require__(3966));
	
	var _LockOpenSharp = _interopRequireDefault(__webpack_require__(3967));
	
	var _LockOpenTwoTone = _interopRequireDefault(__webpack_require__(3968));
	
	var _LockOutlined = _interopRequireDefault(__webpack_require__(3969));
	
	var _LockRounded = _interopRequireDefault(__webpack_require__(3970));
	
	var _LockSharp = _interopRequireDefault(__webpack_require__(3971));
	
	var _LockTwoTone = _interopRequireDefault(__webpack_require__(3972));
	
	var _Looks = _interopRequireDefault(__webpack_require__(3973));
	
	var _Looks2 = _interopRequireDefault(__webpack_require__(3974));
	
	var _Looks3Outlined = _interopRequireDefault(__webpack_require__(3975));
	
	var _Looks3Rounded = _interopRequireDefault(__webpack_require__(3976));
	
	var _Looks3Sharp = _interopRequireDefault(__webpack_require__(3977));
	
	var _Looks3TwoTone = _interopRequireDefault(__webpack_require__(3978));
	
	var _Looks3 = _interopRequireDefault(__webpack_require__(3979));
	
	var _Looks4Outlined = _interopRequireDefault(__webpack_require__(3980));
	
	var _Looks4Rounded = _interopRequireDefault(__webpack_require__(3981));
	
	var _Looks4Sharp = _interopRequireDefault(__webpack_require__(3982));
	
	var _Looks4TwoTone = _interopRequireDefault(__webpack_require__(3983));
	
	var _Looks4 = _interopRequireDefault(__webpack_require__(3984));
	
	var _Looks5Outlined = _interopRequireDefault(__webpack_require__(3985));
	
	var _Looks5Rounded = _interopRequireDefault(__webpack_require__(3986));
	
	var _Looks5Sharp = _interopRequireDefault(__webpack_require__(3987));
	
	var _Looks5TwoTone = _interopRequireDefault(__webpack_require__(3988));
	
	var _Looks5 = _interopRequireDefault(__webpack_require__(3989));
	
	var _Looks6Outlined = _interopRequireDefault(__webpack_require__(3990));
	
	var _Looks6Rounded = _interopRequireDefault(__webpack_require__(3991));
	
	var _Looks6Sharp = _interopRequireDefault(__webpack_require__(3992));
	
	var _Looks6TwoTone = _interopRequireDefault(__webpack_require__(3993));
	
	var _LooksOne = _interopRequireDefault(__webpack_require__(3994));
	
	var _LooksOneOutlined = _interopRequireDefault(__webpack_require__(3995));
	
	var _LooksOneRounded = _interopRequireDefault(__webpack_require__(3996));
	
	var _LooksOneSharp = _interopRequireDefault(__webpack_require__(3997));
	
	var _LooksOneTwoTone = _interopRequireDefault(__webpack_require__(3998));
	
	var _LooksOutlined = _interopRequireDefault(__webpack_require__(3999));
	
	var _LooksRounded = _interopRequireDefault(__webpack_require__(4000));
	
	var _LooksSharp = _interopRequireDefault(__webpack_require__(4001));
	
	var _LooksTwo = _interopRequireDefault(__webpack_require__(4002));
	
	var _LooksTwoOutlined = _interopRequireDefault(__webpack_require__(4003));
	
	var _LooksTwoRounded = _interopRequireDefault(__webpack_require__(4004));
	
	var _LooksTwoSharp = _interopRequireDefault(__webpack_require__(4005));
	
	var _LooksTwoTone = _interopRequireDefault(__webpack_require__(4006));
	
	var _LooksTwoTwoTone = _interopRequireDefault(__webpack_require__(4007));
	
	var _Loop = _interopRequireDefault(__webpack_require__(4008));
	
	var _LoopOutlined = _interopRequireDefault(__webpack_require__(4009));
	
	var _LoopRounded = _interopRequireDefault(__webpack_require__(4010));
	
	var _LoopSharp = _interopRequireDefault(__webpack_require__(4011));
	
	var _LoopTwoTone = _interopRequireDefault(__webpack_require__(4012));
	
	var _Loupe = _interopRequireDefault(__webpack_require__(4013));
	
	var _LoupeOutlined = _interopRequireDefault(__webpack_require__(4014));
	
	var _LoupeRounded = _interopRequireDefault(__webpack_require__(4015));
	
	var _LoupeSharp = _interopRequireDefault(__webpack_require__(4016));
	
	var _LoupeTwoTone = _interopRequireDefault(__webpack_require__(4017));
	
	var _LowPriority = _interopRequireDefault(__webpack_require__(4018));
	
	var _LowPriorityOutlined = _interopRequireDefault(__webpack_require__(4019));
	
	var _LowPriorityRounded = _interopRequireDefault(__webpack_require__(4020));
	
	var _LowPrioritySharp = _interopRequireDefault(__webpack_require__(4021));
	
	var _LowPriorityTwoTone = _interopRequireDefault(__webpack_require__(4022));
	
	var _Loyalty = _interopRequireDefault(__webpack_require__(4023));
	
	var _LoyaltyOutlined = _interopRequireDefault(__webpack_require__(4024));
	
	var _LoyaltyRounded = _interopRequireDefault(__webpack_require__(4025));
	
	var _LoyaltySharp = _interopRequireDefault(__webpack_require__(4026));
	
	var _LoyaltyTwoTone = _interopRequireDefault(__webpack_require__(4027));
	
	var _Mail = _interopRequireDefault(__webpack_require__(4028));
	
	var _MailOutline = _interopRequireDefault(__webpack_require__(4029));
	
	var _MailOutlined = _interopRequireDefault(__webpack_require__(4034));
	
	var _MailOutlineOutlined = _interopRequireDefault(__webpack_require__(4030));
	
	var _MailOutlineRounded = _interopRequireDefault(__webpack_require__(4031));
	
	var _MailOutlineSharp = _interopRequireDefault(__webpack_require__(4032));
	
	var _MailOutlineTwoTone = _interopRequireDefault(__webpack_require__(4033));
	
	var _MailRounded = _interopRequireDefault(__webpack_require__(4035));
	
	var _MailSharp = _interopRequireDefault(__webpack_require__(4036));
	
	var _MailTwoTone = _interopRequireDefault(__webpack_require__(4037));
	
	var _Map = _interopRequireDefault(__webpack_require__(4038));
	
	var _MapOutlined = _interopRequireDefault(__webpack_require__(4039));
	
	var _MapRounded = _interopRequireDefault(__webpack_require__(4040));
	
	var _MapSharp = _interopRequireDefault(__webpack_require__(4041));
	
	var _MapTwoTone = _interopRequireDefault(__webpack_require__(4042));
	
	var _Markunread = _interopRequireDefault(__webpack_require__(4043));
	
	var _MarkunreadMailbox = _interopRequireDefault(__webpack_require__(4044));
	
	var _MarkunreadMailboxOutlined = _interopRequireDefault(__webpack_require__(4045));
	
	var _MarkunreadMailboxRounded = _interopRequireDefault(__webpack_require__(4046));
	
	var _MarkunreadMailboxSharp = _interopRequireDefault(__webpack_require__(4047));
	
	var _MarkunreadMailboxTwoTone = _interopRequireDefault(__webpack_require__(4048));
	
	var _MarkunreadOutlined = _interopRequireDefault(__webpack_require__(4049));
	
	var _MarkunreadRounded = _interopRequireDefault(__webpack_require__(4050));
	
	var _MarkunreadSharp = _interopRequireDefault(__webpack_require__(4051));
	
	var _MarkunreadTwoTone = _interopRequireDefault(__webpack_require__(4052));
	
	var _Maximize = _interopRequireDefault(__webpack_require__(4053));
	
	var _MaximizeOutlined = _interopRequireDefault(__webpack_require__(4054));
	
	var _MaximizeRounded = _interopRequireDefault(__webpack_require__(4055));
	
	var _MaximizeSharp = _interopRequireDefault(__webpack_require__(4056));
	
	var _MaximizeTwoTone = _interopRequireDefault(__webpack_require__(4057));
	
	var _MeetingRoom = _interopRequireDefault(__webpack_require__(4058));
	
	var _MeetingRoomOutlined = _interopRequireDefault(__webpack_require__(4059));
	
	var _MeetingRoomRounded = _interopRequireDefault(__webpack_require__(4060));
	
	var _MeetingRoomSharp = _interopRequireDefault(__webpack_require__(4061));
	
	var _MeetingRoomTwoTone = _interopRequireDefault(__webpack_require__(4062));
	
	var _Memory = _interopRequireDefault(__webpack_require__(4063));
	
	var _MemoryOutlined = _interopRequireDefault(__webpack_require__(4064));
	
	var _MemoryRounded = _interopRequireDefault(__webpack_require__(4065));
	
	var _MemorySharp = _interopRequireDefault(__webpack_require__(4066));
	
	var _MemoryTwoTone = _interopRequireDefault(__webpack_require__(4067));
	
	var _Menu = _interopRequireDefault(__webpack_require__(4068));
	
	var _MenuBook = _interopRequireDefault(__webpack_require__(4069));
	
	var _MenuBookOutlined = _interopRequireDefault(__webpack_require__(4070));
	
	var _MenuBookRounded = _interopRequireDefault(__webpack_require__(4071));
	
	var _MenuBookSharp = _interopRequireDefault(__webpack_require__(4072));
	
	var _MenuBookTwoTone = _interopRequireDefault(__webpack_require__(4073));
	
	var _MenuOpen = _interopRequireDefault(__webpack_require__(4074));
	
	var _MenuOpenOutlined = _interopRequireDefault(__webpack_require__(4075));
	
	var _MenuOpenRounded = _interopRequireDefault(__webpack_require__(4076));
	
	var _MenuOpenSharp = _interopRequireDefault(__webpack_require__(4077));
	
	var _MenuOpenTwoTone = _interopRequireDefault(__webpack_require__(4078));
	
	var _MenuOutlined = _interopRequireDefault(__webpack_require__(4079));
	
	var _MenuRounded = _interopRequireDefault(__webpack_require__(4080));
	
	var _MenuSharp = _interopRequireDefault(__webpack_require__(4081));
	
	var _MenuTwoTone = _interopRequireDefault(__webpack_require__(4082));
	
	var _MergeType = _interopRequireDefault(__webpack_require__(4083));
	
	var _MergeTypeOutlined = _interopRequireDefault(__webpack_require__(4084));
	
	var _MergeTypeRounded = _interopRequireDefault(__webpack_require__(4085));
	
	var _MergeTypeSharp = _interopRequireDefault(__webpack_require__(4086));
	
	var _MergeTypeTwoTone = _interopRequireDefault(__webpack_require__(4087));
	
	var _Message = _interopRequireDefault(__webpack_require__(4088));
	
	var _MessageOutlined = _interopRequireDefault(__webpack_require__(4089));
	
	var _MessageRounded = _interopRequireDefault(__webpack_require__(4090));
	
	var _MessageSharp = _interopRequireDefault(__webpack_require__(4091));
	
	var _MessageTwoTone = _interopRequireDefault(__webpack_require__(4092));
	
	var _Mic = _interopRequireDefault(__webpack_require__(4093));
	
	var _MicNone = _interopRequireDefault(__webpack_require__(4094));
	
	var _MicNoneOutlined = _interopRequireDefault(__webpack_require__(4095));
	
	var _MicNoneRounded = _interopRequireDefault(__webpack_require__(4096));
	
	var _MicNoneSharp = _interopRequireDefault(__webpack_require__(4097));
	
	var _MicNoneTwoTone = _interopRequireDefault(__webpack_require__(4098));
	
	var _MicOff = _interopRequireDefault(__webpack_require__(4099));
	
	var _MicOffOutlined = _interopRequireDefault(__webpack_require__(4100));
	
	var _MicOffRounded = _interopRequireDefault(__webpack_require__(4101));
	
	var _MicOffSharp = _interopRequireDefault(__webpack_require__(4102));
	
	var _MicOffTwoTone = _interopRequireDefault(__webpack_require__(4103));
	
	var _MicOutlined = _interopRequireDefault(__webpack_require__(4104));
	
	var _MicRounded = _interopRequireDefault(__webpack_require__(4105));
	
	var _MicSharp = _interopRequireDefault(__webpack_require__(4106));
	
	var _MicTwoTone = _interopRequireDefault(__webpack_require__(4107));
	
	var _Minimize = _interopRequireDefault(__webpack_require__(4108));
	
	var _MinimizeOutlined = _interopRequireDefault(__webpack_require__(4109));
	
	var _MinimizeRounded = _interopRequireDefault(__webpack_require__(4110));
	
	var _MinimizeSharp = _interopRequireDefault(__webpack_require__(4111));
	
	var _MinimizeTwoTone = _interopRequireDefault(__webpack_require__(4112));
	
	var _MissedVideoCall = _interopRequireDefault(__webpack_require__(4113));
	
	var _MissedVideoCallOutlined = _interopRequireDefault(__webpack_require__(4114));
	
	var _MissedVideoCallRounded = _interopRequireDefault(__webpack_require__(4115));
	
	var _MissedVideoCallSharp = _interopRequireDefault(__webpack_require__(4116));
	
	var _MissedVideoCallTwoTone = _interopRequireDefault(__webpack_require__(4117));
	
	var _Mms = _interopRequireDefault(__webpack_require__(4118));
	
	var _MmsOutlined = _interopRequireDefault(__webpack_require__(4119));
	
	var _MmsRounded = _interopRequireDefault(__webpack_require__(4120));
	
	var _MmsSharp = _interopRequireDefault(__webpack_require__(4121));
	
	var _MmsTwoTone = _interopRequireDefault(__webpack_require__(4122));
	
	var _MobileFriendly = _interopRequireDefault(__webpack_require__(4123));
	
	var _MobileFriendlyOutlined = _interopRequireDefault(__webpack_require__(4124));
	
	var _MobileFriendlyRounded = _interopRequireDefault(__webpack_require__(4125));
	
	var _MobileFriendlySharp = _interopRequireDefault(__webpack_require__(4126));
	
	var _MobileFriendlyTwoTone = _interopRequireDefault(__webpack_require__(4127));
	
	var _MobileOff = _interopRequireDefault(__webpack_require__(4128));
	
	var _MobileOffOutlined = _interopRequireDefault(__webpack_require__(4129));
	
	var _MobileOffRounded = _interopRequireDefault(__webpack_require__(4130));
	
	var _MobileOffSharp = _interopRequireDefault(__webpack_require__(4131));
	
	var _MobileOffTwoTone = _interopRequireDefault(__webpack_require__(4132));
	
	var _MobileScreenShare = _interopRequireDefault(__webpack_require__(4133));
	
	var _MobileScreenShareOutlined = _interopRequireDefault(__webpack_require__(4134));
	
	var _MobileScreenShareRounded = _interopRequireDefault(__webpack_require__(4135));
	
	var _MobileScreenShareSharp = _interopRequireDefault(__webpack_require__(4136));
	
	var _MobileScreenShareTwoTone = _interopRequireDefault(__webpack_require__(4137));
	
	var _ModeComment = _interopRequireDefault(__webpack_require__(4138));
	
	var _ModeCommentOutlined = _interopRequireDefault(__webpack_require__(4139));
	
	var _ModeCommentRounded = _interopRequireDefault(__webpack_require__(4140));
	
	var _ModeCommentSharp = _interopRequireDefault(__webpack_require__(4141));
	
	var _ModeCommentTwoTone = _interopRequireDefault(__webpack_require__(4142));
	
	var _MonetizationOn = _interopRequireDefault(__webpack_require__(4143));
	
	var _MonetizationOnOutlined = _interopRequireDefault(__webpack_require__(4144));
	
	var _MonetizationOnRounded = _interopRequireDefault(__webpack_require__(4145));
	
	var _MonetizationOnSharp = _interopRequireDefault(__webpack_require__(4146));
	
	var _MonetizationOnTwoTone = _interopRequireDefault(__webpack_require__(4147));
	
	var _Money = _interopRequireDefault(__webpack_require__(4148));
	
	var _MoneyOff = _interopRequireDefault(__webpack_require__(4149));
	
	var _MoneyOffOutlined = _interopRequireDefault(__webpack_require__(4150));
	
	var _MoneyOffRounded = _interopRequireDefault(__webpack_require__(4151));
	
	var _MoneyOffSharp = _interopRequireDefault(__webpack_require__(4152));
	
	var _MoneyOffTwoTone = _interopRequireDefault(__webpack_require__(4153));
	
	var _MoneyOutlined = _interopRequireDefault(__webpack_require__(4154));
	
	var _MoneyRounded = _interopRequireDefault(__webpack_require__(4155));
	
	var _MoneySharp = _interopRequireDefault(__webpack_require__(4156));
	
	var _MoneyTwoTone = _interopRequireDefault(__webpack_require__(4157));
	
	var _MonochromePhotos = _interopRequireDefault(__webpack_require__(4158));
	
	var _MonochromePhotosOutlined = _interopRequireDefault(__webpack_require__(4159));
	
	var _MonochromePhotosRounded = _interopRequireDefault(__webpack_require__(4160));
	
	var _MonochromePhotosSharp = _interopRequireDefault(__webpack_require__(4161));
	
	var _MonochromePhotosTwoTone = _interopRequireDefault(__webpack_require__(4162));
	
	var _Mood = _interopRequireDefault(__webpack_require__(4163));
	
	var _MoodBad = _interopRequireDefault(__webpack_require__(4164));
	
	var _MoodBadOutlined = _interopRequireDefault(__webpack_require__(4165));
	
	var _MoodBadRounded = _interopRequireDefault(__webpack_require__(4166));
	
	var _MoodBadSharp = _interopRequireDefault(__webpack_require__(4167));
	
	var _MoodBadTwoTone = _interopRequireDefault(__webpack_require__(4168));
	
	var _MoodOutlined = _interopRequireDefault(__webpack_require__(4169));
	
	var _MoodRounded = _interopRequireDefault(__webpack_require__(4170));
	
	var _MoodSharp = _interopRequireDefault(__webpack_require__(4171));
	
	var _MoodTwoTone = _interopRequireDefault(__webpack_require__(4172));
	
	var _More = _interopRequireDefault(__webpack_require__(4173));
	
	var _MoreHoriz = _interopRequireDefault(__webpack_require__(4174));
	
	var _MoreHorizOutlined = _interopRequireDefault(__webpack_require__(4175));
	
	var _MoreHorizRounded = _interopRequireDefault(__webpack_require__(4176));
	
	var _MoreHorizSharp = _interopRequireDefault(__webpack_require__(4177));
	
	var _MoreHorizTwoTone = _interopRequireDefault(__webpack_require__(4178));
	
	var _MoreOutlined = _interopRequireDefault(__webpack_require__(4179));
	
	var _MoreRounded = _interopRequireDefault(__webpack_require__(4180));
	
	var _MoreSharp = _interopRequireDefault(__webpack_require__(4181));
	
	var _MoreTwoTone = _interopRequireDefault(__webpack_require__(4182));
	
	var _MoreVert = _interopRequireDefault(__webpack_require__(4183));
	
	var _MoreVertOutlined = _interopRequireDefault(__webpack_require__(4184));
	
	var _MoreVertRounded = _interopRequireDefault(__webpack_require__(4185));
	
	var _MoreVertSharp = _interopRequireDefault(__webpack_require__(4186));
	
	var _MoreVertTwoTone = _interopRequireDefault(__webpack_require__(4187));
	
	var _Motorcycle = _interopRequireDefault(__webpack_require__(4188));
	
	var _MotorcycleOutlined = _interopRequireDefault(__webpack_require__(4189));
	
	var _MotorcycleRounded = _interopRequireDefault(__webpack_require__(4190));
	
	var _MotorcycleSharp = _interopRequireDefault(__webpack_require__(4191));
	
	var _MotorcycleTwoTone = _interopRequireDefault(__webpack_require__(4192));
	
	var _Mouse = _interopRequireDefault(__webpack_require__(4193));
	
	var _MouseOutlined = _interopRequireDefault(__webpack_require__(4194));
	
	var _MouseRounded = _interopRequireDefault(__webpack_require__(4195));
	
	var _MouseSharp = _interopRequireDefault(__webpack_require__(4196));
	
	var _MouseTwoTone = _interopRequireDefault(__webpack_require__(4197));
	
	var _MoveToInbox = _interopRequireDefault(__webpack_require__(4198));
	
	var _MoveToInboxOutlined = _interopRequireDefault(__webpack_require__(4199));
	
	var _MoveToInboxRounded = _interopRequireDefault(__webpack_require__(4200));
	
	var _MoveToInboxSharp = _interopRequireDefault(__webpack_require__(4201));
	
	var _MoveToInboxTwoTone = _interopRequireDefault(__webpack_require__(4202));
	
	var _Movie = _interopRequireDefault(__webpack_require__(4203));
	
	var _MovieCreation = _interopRequireDefault(__webpack_require__(4204));
	
	var _MovieCreationOutlined = _interopRequireDefault(__webpack_require__(4205));
	
	var _MovieCreationRounded = _interopRequireDefault(__webpack_require__(4206));
	
	var _MovieCreationSharp = _interopRequireDefault(__webpack_require__(4207));
	
	var _MovieCreationTwoTone = _interopRequireDefault(__webpack_require__(4208));
	
	var _MovieFilter = _interopRequireDefault(__webpack_require__(4209));
	
	var _MovieFilterOutlined = _interopRequireDefault(__webpack_require__(4210));
	
	var _MovieFilterRounded = _interopRequireDefault(__webpack_require__(4211));
	
	var _MovieFilterSharp = _interopRequireDefault(__webpack_require__(4212));
	
	var _MovieFilterTwoTone = _interopRequireDefault(__webpack_require__(4213));
	
	var _MovieOutlined = _interopRequireDefault(__webpack_require__(4214));
	
	var _MovieRounded = _interopRequireDefault(__webpack_require__(4215));
	
	var _MovieSharp = _interopRequireDefault(__webpack_require__(4216));
	
	var _MovieTwoTone = _interopRequireDefault(__webpack_require__(4217));
	
	var _MultilineChart = _interopRequireDefault(__webpack_require__(4218));
	
	var _MultilineChartOutlined = _interopRequireDefault(__webpack_require__(4219));
	
	var _MultilineChartRounded = _interopRequireDefault(__webpack_require__(4220));
	
	var _MultilineChartSharp = _interopRequireDefault(__webpack_require__(4221));
	
	var _MultilineChartTwoTone = _interopRequireDefault(__webpack_require__(4222));
	
	var _Museum = _interopRequireDefault(__webpack_require__(4223));
	
	var _MuseumOutlined = _interopRequireDefault(__webpack_require__(4224));
	
	var _MuseumRounded = _interopRequireDefault(__webpack_require__(4225));
	
	var _MuseumSharp = _interopRequireDefault(__webpack_require__(4226));
	
	var _MuseumTwoTone = _interopRequireDefault(__webpack_require__(4227));
	
	var _MusicNote = _interopRequireDefault(__webpack_require__(4228));
	
	var _MusicNoteOutlined = _interopRequireDefault(__webpack_require__(4229));
	
	var _MusicNoteRounded = _interopRequireDefault(__webpack_require__(4230));
	
	var _MusicNoteSharp = _interopRequireDefault(__webpack_require__(4231));
	
	var _MusicNoteTwoTone = _interopRequireDefault(__webpack_require__(4232));
	
	var _MusicOff = _interopRequireDefault(__webpack_require__(4233));
	
	var _MusicOffOutlined = _interopRequireDefault(__webpack_require__(4234));
	
	var _MusicOffRounded = _interopRequireDefault(__webpack_require__(4235));
	
	var _MusicOffSharp = _interopRequireDefault(__webpack_require__(4236));
	
	var _MusicOffTwoTone = _interopRequireDefault(__webpack_require__(4237));
	
	var _MusicVideo = _interopRequireDefault(__webpack_require__(4238));
	
	var _MusicVideoOutlined = _interopRequireDefault(__webpack_require__(4239));
	
	var _MusicVideoRounded = _interopRequireDefault(__webpack_require__(4240));
	
	var _MusicVideoSharp = _interopRequireDefault(__webpack_require__(4241));
	
	var _MusicVideoTwoTone = _interopRequireDefault(__webpack_require__(4242));
	
	var _MyLocation = _interopRequireDefault(__webpack_require__(4243));
	
	var _MyLocationOutlined = _interopRequireDefault(__webpack_require__(4244));
	
	var _MyLocationRounded = _interopRequireDefault(__webpack_require__(4245));
	
	var _MyLocationSharp = _interopRequireDefault(__webpack_require__(4246));
	
	var _MyLocationTwoTone = _interopRequireDefault(__webpack_require__(4247));
	
	var _Nature = _interopRequireDefault(__webpack_require__(4248));
	
	var _NatureOutlined = _interopRequireDefault(__webpack_require__(4249));
	
	var _NaturePeople = _interopRequireDefault(__webpack_require__(4250));
	
	var _NaturePeopleOutlined = _interopRequireDefault(__webpack_require__(4251));
	
	var _NaturePeopleRounded = _interopRequireDefault(__webpack_require__(4252));
	
	var _NaturePeopleSharp = _interopRequireDefault(__webpack_require__(4253));
	
	var _NaturePeopleTwoTone = _interopRequireDefault(__webpack_require__(4254));
	
	var _NatureRounded = _interopRequireDefault(__webpack_require__(4255));
	
	var _NatureSharp = _interopRequireDefault(__webpack_require__(4256));
	
	var _NatureTwoTone = _interopRequireDefault(__webpack_require__(4257));
	
	var _NavigateBefore = _interopRequireDefault(__webpack_require__(4258));
	
	var _NavigateBeforeOutlined = _interopRequireDefault(__webpack_require__(4259));
	
	var _NavigateBeforeRounded = _interopRequireDefault(__webpack_require__(4260));
	
	var _NavigateBeforeSharp = _interopRequireDefault(__webpack_require__(4261));
	
	var _NavigateBeforeTwoTone = _interopRequireDefault(__webpack_require__(4262));
	
	var _NavigateNext = _interopRequireDefault(__webpack_require__(4263));
	
	var _NavigateNextOutlined = _interopRequireDefault(__webpack_require__(4264));
	
	var _NavigateNextRounded = _interopRequireDefault(__webpack_require__(4265));
	
	var _NavigateNextSharp = _interopRequireDefault(__webpack_require__(4266));
	
	var _NavigateNextTwoTone = _interopRequireDefault(__webpack_require__(4267));
	
	var _Navigation = _interopRequireDefault(__webpack_require__(4268));
	
	var _NavigationOutlined = _interopRequireDefault(__webpack_require__(4269));
	
	var _NavigationRounded = _interopRequireDefault(__webpack_require__(4270));
	
	var _NavigationSharp = _interopRequireDefault(__webpack_require__(4271));
	
	var _NavigationTwoTone = _interopRequireDefault(__webpack_require__(4272));
	
	var _NearMe = _interopRequireDefault(__webpack_require__(4273));
	
	var _NearMeOutlined = _interopRequireDefault(__webpack_require__(4274));
	
	var _NearMeRounded = _interopRequireDefault(__webpack_require__(4275));
	
	var _NearMeSharp = _interopRequireDefault(__webpack_require__(4276));
	
	var _NearMeTwoTone = _interopRequireDefault(__webpack_require__(4277));
	
	var _NetworkCell = _interopRequireDefault(__webpack_require__(4278));
	
	var _NetworkCellOutlined = _interopRequireDefault(__webpack_require__(4279));
	
	var _NetworkCellRounded = _interopRequireDefault(__webpack_require__(4280));
	
	var _NetworkCellSharp = _interopRequireDefault(__webpack_require__(4281));
	
	var _NetworkCellTwoTone = _interopRequireDefault(__webpack_require__(4282));
	
	var _NetworkCheck = _interopRequireDefault(__webpack_require__(4283));
	
	var _NetworkCheckOutlined = _interopRequireDefault(__webpack_require__(4284));
	
	var _NetworkCheckRounded = _interopRequireDefault(__webpack_require__(4285));
	
	var _NetworkCheckSharp = _interopRequireDefault(__webpack_require__(4286));
	
	var _NetworkCheckTwoTone = _interopRequireDefault(__webpack_require__(4287));
	
	var _NetworkLocked = _interopRequireDefault(__webpack_require__(4288));
	
	var _NetworkLockedOutlined = _interopRequireDefault(__webpack_require__(4289));
	
	var _NetworkLockedRounded = _interopRequireDefault(__webpack_require__(4290));
	
	var _NetworkLockedSharp = _interopRequireDefault(__webpack_require__(4291));
	
	var _NetworkLockedTwoTone = _interopRequireDefault(__webpack_require__(4292));
	
	var _NetworkWifi = _interopRequireDefault(__webpack_require__(4293));
	
	var _NetworkWifiOutlined = _interopRequireDefault(__webpack_require__(4294));
	
	var _NetworkWifiRounded = _interopRequireDefault(__webpack_require__(4295));
	
	var _NetworkWifiSharp = _interopRequireDefault(__webpack_require__(4296));
	
	var _NetworkWifiTwoTone = _interopRequireDefault(__webpack_require__(4297));
	
	var _NewReleases = _interopRequireDefault(__webpack_require__(4298));
	
	var _NewReleasesOutlined = _interopRequireDefault(__webpack_require__(4299));
	
	var _NewReleasesRounded = _interopRequireDefault(__webpack_require__(4300));
	
	var _NewReleasesSharp = _interopRequireDefault(__webpack_require__(4301));
	
	var _NewReleasesTwoTone = _interopRequireDefault(__webpack_require__(4302));
	
	var _NextWeek = _interopRequireDefault(__webpack_require__(4303));
	
	var _NextWeekOutlined = _interopRequireDefault(__webpack_require__(4304));
	
	var _NextWeekRounded = _interopRequireDefault(__webpack_require__(4305));
	
	var _NextWeekSharp = _interopRequireDefault(__webpack_require__(4306));
	
	var _NextWeekTwoTone = _interopRequireDefault(__webpack_require__(4307));
	
	var _Nfc = _interopRequireDefault(__webpack_require__(4308));
	
	var _NfcOutlined = _interopRequireDefault(__webpack_require__(4309));
	
	var _NfcRounded = _interopRequireDefault(__webpack_require__(4310));
	
	var _NfcSharp = _interopRequireDefault(__webpack_require__(4311));
	
	var _NfcTwoTone = _interopRequireDefault(__webpack_require__(4312));
	
	var _NightsStay = _interopRequireDefault(__webpack_require__(4313));
	
	var _NightsStayOutlined = _interopRequireDefault(__webpack_require__(4314));
	
	var _NightsStayRounded = _interopRequireDefault(__webpack_require__(4315));
	
	var _NightsStaySharp = _interopRequireDefault(__webpack_require__(4316));
	
	var _NightsStayTwoTone = _interopRequireDefault(__webpack_require__(4317));
	
	var _NoEncryption = _interopRequireDefault(__webpack_require__(4318));
	
	var _NoEncryptionOutlined = _interopRequireDefault(__webpack_require__(4319));
	
	var _NoEncryptionRounded = _interopRequireDefault(__webpack_require__(4320));
	
	var _NoEncryptionSharp = _interopRequireDefault(__webpack_require__(4321));
	
	var _NoEncryptionTwoTone = _interopRequireDefault(__webpack_require__(4322));
	
	var _NoMeetingRoom = _interopRequireDefault(__webpack_require__(4323));
	
	var _NoMeetingRoomOutlined = _interopRequireDefault(__webpack_require__(4324));
	
	var _NoMeetingRoomRounded = _interopRequireDefault(__webpack_require__(4325));
	
	var _NoMeetingRoomSharp = _interopRequireDefault(__webpack_require__(4326));
	
	var _NoMeetingRoomTwoTone = _interopRequireDefault(__webpack_require__(4327));
	
	var _NoSim = _interopRequireDefault(__webpack_require__(4328));
	
	var _NoSimOutlined = _interopRequireDefault(__webpack_require__(4329));
	
	var _NoSimRounded = _interopRequireDefault(__webpack_require__(4330));
	
	var _NoSimSharp = _interopRequireDefault(__webpack_require__(4331));
	
	var _NoSimTwoTone = _interopRequireDefault(__webpack_require__(4332));
	
	var _Note = _interopRequireDefault(__webpack_require__(4343));
	
	var _NoteAdd = _interopRequireDefault(__webpack_require__(4344));
	
	var _NoteAddOutlined = _interopRequireDefault(__webpack_require__(4345));
	
	var _NoteAddRounded = _interopRequireDefault(__webpack_require__(4346));
	
	var _NoteAddSharp = _interopRequireDefault(__webpack_require__(4347));
	
	var _NoteAddTwoTone = _interopRequireDefault(__webpack_require__(4348));
	
	var _NoteOutlined = _interopRequireDefault(__webpack_require__(4349));
	
	var _NoteRounded = _interopRequireDefault(__webpack_require__(4350));
	
	var _Notes = _interopRequireDefault(__webpack_require__(4353));
	
	var _NoteSharp = _interopRequireDefault(__webpack_require__(4351));
	
	var _NotesOutlined = _interopRequireDefault(__webpack_require__(4354));
	
	var _NotesRounded = _interopRequireDefault(__webpack_require__(4355));
	
	var _NotesSharp = _interopRequireDefault(__webpack_require__(4356));
	
	var _NotesTwoTone = _interopRequireDefault(__webpack_require__(4357));
	
	var _NoteTwoTone = _interopRequireDefault(__webpack_require__(4352));
	
	var _NotificationImportant = _interopRequireDefault(__webpack_require__(4358));
	
	var _NotificationImportantOutlined = _interopRequireDefault(__webpack_require__(4359));
	
	var _NotificationImportantRounded = _interopRequireDefault(__webpack_require__(4360));
	
	var _NotificationImportantSharp = _interopRequireDefault(__webpack_require__(4361));
	
	var _NotificationImportantTwoTone = _interopRequireDefault(__webpack_require__(4362));
	
	var _Notifications = _interopRequireDefault(__webpack_require__(4363));
	
	var _NotificationsActive = _interopRequireDefault(__webpack_require__(4364));
	
	var _NotificationsActiveOutlined = _interopRequireDefault(__webpack_require__(4365));
	
	var _NotificationsActiveRounded = _interopRequireDefault(__webpack_require__(4366));
	
	var _NotificationsActiveSharp = _interopRequireDefault(__webpack_require__(4367));
	
	var _NotificationsActiveTwoTone = _interopRequireDefault(__webpack_require__(4368));
	
	var _NotificationsNone = _interopRequireDefault(__webpack_require__(4369));
	
	var _NotificationsNoneOutlined = _interopRequireDefault(__webpack_require__(4370));
	
	var _NotificationsNoneRounded = _interopRequireDefault(__webpack_require__(4371));
	
	var _NotificationsNoneSharp = _interopRequireDefault(__webpack_require__(4372));
	
	var _NotificationsNoneTwoTone = _interopRequireDefault(__webpack_require__(4373));
	
	var _NotificationsOff = _interopRequireDefault(__webpack_require__(4374));
	
	var _NotificationsOffOutlined = _interopRequireDefault(__webpack_require__(4375));
	
	var _NotificationsOffRounded = _interopRequireDefault(__webpack_require__(4376));
	
	var _NotificationsOffSharp = _interopRequireDefault(__webpack_require__(4377));
	
	var _NotificationsOffTwoTone = _interopRequireDefault(__webpack_require__(4378));
	
	var _NotificationsOutlined = _interopRequireDefault(__webpack_require__(4379));
	
	var _NotificationsPaused = _interopRequireDefault(__webpack_require__(4380));
	
	var _NotificationsPausedOutlined = _interopRequireDefault(__webpack_require__(4381));
	
	var _NotificationsPausedRounded = _interopRequireDefault(__webpack_require__(4382));
	
	var _NotificationsPausedSharp = _interopRequireDefault(__webpack_require__(4383));
	
	var _NotificationsPausedTwoTone = _interopRequireDefault(__webpack_require__(4384));
	
	var _NotificationsRounded = _interopRequireDefault(__webpack_require__(4385));
	
	var _NotificationsSharp = _interopRequireDefault(__webpack_require__(4386));
	
	var _NotificationsTwoTone = _interopRequireDefault(__webpack_require__(4387));
	
	var _NotInterested = _interopRequireDefault(__webpack_require__(4333));
	
	var _NotInterestedOutlined = _interopRequireDefault(__webpack_require__(4334));
	
	var _NotInterestedRounded = _interopRequireDefault(__webpack_require__(4335));
	
	var _NotInterestedSharp = _interopRequireDefault(__webpack_require__(4336));
	
	var _NotInterestedTwoTone = _interopRequireDefault(__webpack_require__(4337));
	
	var _NotListedLocation = _interopRequireDefault(__webpack_require__(4338));
	
	var _NotListedLocationOutlined = _interopRequireDefault(__webpack_require__(4339));
	
	var _NotListedLocationRounded = _interopRequireDefault(__webpack_require__(4340));
	
	var _NotListedLocationSharp = _interopRequireDefault(__webpack_require__(4341));
	
	var _NotListedLocationTwoTone = _interopRequireDefault(__webpack_require__(4342));
	
	var _OfflineBolt = _interopRequireDefault(__webpack_require__(4388));
	
	var _OfflineBoltOutlined = _interopRequireDefault(__webpack_require__(4389));
	
	var _OfflineBoltRounded = _interopRequireDefault(__webpack_require__(4390));
	
	var _OfflineBoltSharp = _interopRequireDefault(__webpack_require__(4391));
	
	var _OfflineBoltTwoTone = _interopRequireDefault(__webpack_require__(4392));
	
	var _OfflinePin = _interopRequireDefault(__webpack_require__(4393));
	
	var _OfflinePinOutlined = _interopRequireDefault(__webpack_require__(4394));
	
	var _OfflinePinRounded = _interopRequireDefault(__webpack_require__(4395));
	
	var _OfflinePinSharp = _interopRequireDefault(__webpack_require__(4396));
	
	var _OfflinePinTwoTone = _interopRequireDefault(__webpack_require__(4397));
	
	var _OndemandVideo = _interopRequireDefault(__webpack_require__(4398));
	
	var _OndemandVideoOutlined = _interopRequireDefault(__webpack_require__(4399));
	
	var _OndemandVideoRounded = _interopRequireDefault(__webpack_require__(4400));
	
	var _OndemandVideoSharp = _interopRequireDefault(__webpack_require__(4401));
	
	var _OndemandVideoTwoTone = _interopRequireDefault(__webpack_require__(4402));
	
	var _Opacity = _interopRequireDefault(__webpack_require__(4403));
	
	var _OpacityOutlined = _interopRequireDefault(__webpack_require__(4404));
	
	var _OpacityRounded = _interopRequireDefault(__webpack_require__(4405));
	
	var _OpacitySharp = _interopRequireDefault(__webpack_require__(4406));
	
	var _OpacityTwoTone = _interopRequireDefault(__webpack_require__(4407));
	
	var _OpenInBrowser = _interopRequireDefault(__webpack_require__(4408));
	
	var _OpenInBrowserOutlined = _interopRequireDefault(__webpack_require__(4409));
	
	var _OpenInBrowserRounded = _interopRequireDefault(__webpack_require__(4410));
	
	var _OpenInBrowserSharp = _interopRequireDefault(__webpack_require__(4411));
	
	var _OpenInBrowserTwoTone = _interopRequireDefault(__webpack_require__(4412));
	
	var _OpenInNew = _interopRequireDefault(__webpack_require__(4413));
	
	var _OpenInNewOutlined = _interopRequireDefault(__webpack_require__(4414));
	
	var _OpenInNewRounded = _interopRequireDefault(__webpack_require__(4415));
	
	var _OpenInNewSharp = _interopRequireDefault(__webpack_require__(4416));
	
	var _OpenInNewTwoTone = _interopRequireDefault(__webpack_require__(4417));
	
	var _OpenWith = _interopRequireDefault(__webpack_require__(4418));
	
	var _OpenWithOutlined = _interopRequireDefault(__webpack_require__(4419));
	
	var _OpenWithRounded = _interopRequireDefault(__webpack_require__(4420));
	
	var _OpenWithSharp = _interopRequireDefault(__webpack_require__(4421));
	
	var _OpenWithTwoTone = _interopRequireDefault(__webpack_require__(4422));
	
	var _OutdoorGrill = _interopRequireDefault(__webpack_require__(4423));
	
	var _OutdoorGrillOutlined = _interopRequireDefault(__webpack_require__(4424));
	
	var _OutdoorGrillRounded = _interopRequireDefault(__webpack_require__(4425));
	
	var _OutdoorGrillSharp = _interopRequireDefault(__webpack_require__(4426));
	
	var _OutdoorGrillTwoTone = _interopRequireDefault(__webpack_require__(4427));
	
	var _OutlinedFlag = _interopRequireDefault(__webpack_require__(4428));
	
	var _OutlinedFlagOutlined = _interopRequireDefault(__webpack_require__(4429));
	
	var _OutlinedFlagRounded = _interopRequireDefault(__webpack_require__(4430));
	
	var _OutlinedFlagSharp = _interopRequireDefault(__webpack_require__(4431));
	
	var _OutlinedFlagTwoTone = _interopRequireDefault(__webpack_require__(4432));
	
	var _Pages = _interopRequireDefault(__webpack_require__(4433));
	
	var _PagesOutlined = _interopRequireDefault(__webpack_require__(4434));
	
	var _PagesRounded = _interopRequireDefault(__webpack_require__(4435));
	
	var _PagesSharp = _interopRequireDefault(__webpack_require__(4436));
	
	var _PagesTwoTone = _interopRequireDefault(__webpack_require__(4437));
	
	var _Pageview = _interopRequireDefault(__webpack_require__(4438));
	
	var _PageviewOutlined = _interopRequireDefault(__webpack_require__(4439));
	
	var _PageviewRounded = _interopRequireDefault(__webpack_require__(4440));
	
	var _PageviewSharp = _interopRequireDefault(__webpack_require__(4441));
	
	var _PageviewTwoTone = _interopRequireDefault(__webpack_require__(4442));
	
	var _Palette = _interopRequireDefault(__webpack_require__(4443));
	
	var _PaletteOutlined = _interopRequireDefault(__webpack_require__(4444));
	
	var _PaletteRounded = _interopRequireDefault(__webpack_require__(4445));
	
	var _PaletteSharp = _interopRequireDefault(__webpack_require__(4446));
	
	var _PaletteTwoTone = _interopRequireDefault(__webpack_require__(4447));
	
	var _Panorama = _interopRequireDefault(__webpack_require__(4453));
	
	var _PanoramaFishEye = _interopRequireDefault(__webpack_require__(4454));
	
	var _PanoramaFishEyeOutlined = _interopRequireDefault(__webpack_require__(4455));
	
	var _PanoramaFishEyeRounded = _interopRequireDefault(__webpack_require__(4456));
	
	var _PanoramaFishEyeSharp = _interopRequireDefault(__webpack_require__(4457));
	
	var _PanoramaFishEyeTwoTone = _interopRequireDefault(__webpack_require__(4458));
	
	var _PanoramaHorizontal = _interopRequireDefault(__webpack_require__(4459));
	
	var _PanoramaHorizontalOutlined = _interopRequireDefault(__webpack_require__(4460));
	
	var _PanoramaHorizontalRounded = _interopRequireDefault(__webpack_require__(4461));
	
	var _PanoramaHorizontalSharp = _interopRequireDefault(__webpack_require__(4462));
	
	var _PanoramaHorizontalTwoTone = _interopRequireDefault(__webpack_require__(4463));
	
	var _PanoramaOutlined = _interopRequireDefault(__webpack_require__(4464));
	
	var _PanoramaRounded = _interopRequireDefault(__webpack_require__(4465));
	
	var _PanoramaSharp = _interopRequireDefault(__webpack_require__(4466));
	
	var _PanoramaTwoTone = _interopRequireDefault(__webpack_require__(4467));
	
	var _PanoramaVertical = _interopRequireDefault(__webpack_require__(4468));
	
	var _PanoramaVerticalOutlined = _interopRequireDefault(__webpack_require__(4469));
	
	var _PanoramaVerticalRounded = _interopRequireDefault(__webpack_require__(4470));
	
	var _PanoramaVerticalSharp = _interopRequireDefault(__webpack_require__(4471));
	
	var _PanoramaVerticalTwoTone = _interopRequireDefault(__webpack_require__(4472));
	
	var _PanoramaWideAngle = _interopRequireDefault(__webpack_require__(4473));
	
	var _PanoramaWideAngleOutlined = _interopRequireDefault(__webpack_require__(4474));
	
	var _PanoramaWideAngleRounded = _interopRequireDefault(__webpack_require__(4475));
	
	var _PanoramaWideAngleSharp = _interopRequireDefault(__webpack_require__(4476));
	
	var _PanoramaWideAngleTwoTone = _interopRequireDefault(__webpack_require__(4477));
	
	var _PanTool = _interopRequireDefault(__webpack_require__(4448));
	
	var _PanToolOutlined = _interopRequireDefault(__webpack_require__(4449));
	
	var _PanToolRounded = _interopRequireDefault(__webpack_require__(4450));
	
	var _PanToolSharp = _interopRequireDefault(__webpack_require__(4451));
	
	var _PanToolTwoTone = _interopRequireDefault(__webpack_require__(4452));
	
	var _PartyMode = _interopRequireDefault(__webpack_require__(4478));
	
	var _PartyModeOutlined = _interopRequireDefault(__webpack_require__(4479));
	
	var _PartyModeRounded = _interopRequireDefault(__webpack_require__(4480));
	
	var _PartyModeSharp = _interopRequireDefault(__webpack_require__(4481));
	
	var _PartyModeTwoTone = _interopRequireDefault(__webpack_require__(4482));
	
	var _Pause = _interopRequireDefault(__webpack_require__(4483));
	
	var _PauseCircleFilled = _interopRequireDefault(__webpack_require__(4484));
	
	var _PauseCircleFilledOutlined = _interopRequireDefault(__webpack_require__(4485));
	
	var _PauseCircleFilledRounded = _interopRequireDefault(__webpack_require__(4486));
	
	var _PauseCircleFilledSharp = _interopRequireDefault(__webpack_require__(4487));
	
	var _PauseCircleFilledTwoTone = _interopRequireDefault(__webpack_require__(4488));
	
	var _PauseCircleOutline = _interopRequireDefault(__webpack_require__(4489));
	
	var _PauseCircleOutlineOutlined = _interopRequireDefault(__webpack_require__(4490));
	
	var _PauseCircleOutlineRounded = _interopRequireDefault(__webpack_require__(4491));
	
	var _PauseCircleOutlineSharp = _interopRequireDefault(__webpack_require__(4492));
	
	var _PauseCircleOutlineTwoTone = _interopRequireDefault(__webpack_require__(4493));
	
	var _PauseOutlined = _interopRequireDefault(__webpack_require__(4494));
	
	var _PausePresentation = _interopRequireDefault(__webpack_require__(4495));
	
	var _PausePresentationOutlined = _interopRequireDefault(__webpack_require__(4496));
	
	var _PausePresentationRounded = _interopRequireDefault(__webpack_require__(4497));
	
	var _PausePresentationSharp = _interopRequireDefault(__webpack_require__(4498));
	
	var _PausePresentationTwoTone = _interopRequireDefault(__webpack_require__(4499));
	
	var _PauseRounded = _interopRequireDefault(__webpack_require__(4500));
	
	var _PauseSharp = _interopRequireDefault(__webpack_require__(4501));
	
	var _PauseTwoTone = _interopRequireDefault(__webpack_require__(4502));
	
	var _Payment = _interopRequireDefault(__webpack_require__(4503));
	
	var _PaymentOutlined = _interopRequireDefault(__webpack_require__(4504));
	
	var _PaymentRounded = _interopRequireDefault(__webpack_require__(4505));
	
	var _PaymentSharp = _interopRequireDefault(__webpack_require__(4506));
	
	var _PaymentTwoTone = _interopRequireDefault(__webpack_require__(4507));
	
	var _People = _interopRequireDefault(__webpack_require__(4508));
	
	var _PeopleAlt = _interopRequireDefault(__webpack_require__(4509));
	
	var _PeopleAltOutlined = _interopRequireDefault(__webpack_require__(4510));
	
	var _PeopleAltRounded = _interopRequireDefault(__webpack_require__(4511));
	
	var _PeopleAltSharp = _interopRequireDefault(__webpack_require__(4512));
	
	var _PeopleAltTwoTone = _interopRequireDefault(__webpack_require__(4513));
	
	var _PeopleOutline = _interopRequireDefault(__webpack_require__(4514));
	
	var _PeopleOutlined = _interopRequireDefault(__webpack_require__(4519));
	
	var _PeopleOutlineOutlined = _interopRequireDefault(__webpack_require__(4515));
	
	var _PeopleOutlineRounded = _interopRequireDefault(__webpack_require__(4516));
	
	var _PeopleOutlineSharp = _interopRequireDefault(__webpack_require__(4517));
	
	var _PeopleOutlineTwoTone = _interopRequireDefault(__webpack_require__(4518));
	
	var _PeopleRounded = _interopRequireDefault(__webpack_require__(4520));
	
	var _PeopleSharp = _interopRequireDefault(__webpack_require__(4521));
	
	var _PeopleTwoTone = _interopRequireDefault(__webpack_require__(4522));
	
	var _PermCameraMic = _interopRequireDefault(__webpack_require__(4523));
	
	var _PermCameraMicOutlined = _interopRequireDefault(__webpack_require__(4524));
	
	var _PermCameraMicRounded = _interopRequireDefault(__webpack_require__(4525));
	
	var _PermCameraMicSharp = _interopRequireDefault(__webpack_require__(4526));
	
	var _PermCameraMicTwoTone = _interopRequireDefault(__webpack_require__(4527));
	
	var _PermContactCalendar = _interopRequireDefault(__webpack_require__(4528));
	
	var _PermContactCalendarOutlined = _interopRequireDefault(__webpack_require__(4529));
	
	var _PermContactCalendarRounded = _interopRequireDefault(__webpack_require__(4530));
	
	var _PermContactCalendarSharp = _interopRequireDefault(__webpack_require__(4531));
	
	var _PermContactCalendarTwoTone = _interopRequireDefault(__webpack_require__(4532));
	
	var _PermDataSetting = _interopRequireDefault(__webpack_require__(4533));
	
	var _PermDataSettingOutlined = _interopRequireDefault(__webpack_require__(4534));
	
	var _PermDataSettingRounded = _interopRequireDefault(__webpack_require__(4535));
	
	var _PermDataSettingSharp = _interopRequireDefault(__webpack_require__(4536));
	
	var _PermDataSettingTwoTone = _interopRequireDefault(__webpack_require__(4537));
	
	var _PermDeviceInformation = _interopRequireDefault(__webpack_require__(4538));
	
	var _PermDeviceInformationOutlined = _interopRequireDefault(__webpack_require__(4539));
	
	var _PermDeviceInformationRounded = _interopRequireDefault(__webpack_require__(4540));
	
	var _PermDeviceInformationSharp = _interopRequireDefault(__webpack_require__(4541));
	
	var _PermDeviceInformationTwoTone = _interopRequireDefault(__webpack_require__(4542));
	
	var _PermIdentity = _interopRequireDefault(__webpack_require__(4543));
	
	var _PermIdentityOutlined = _interopRequireDefault(__webpack_require__(4544));
	
	var _PermIdentityRounded = _interopRequireDefault(__webpack_require__(4545));
	
	var _PermIdentitySharp = _interopRequireDefault(__webpack_require__(4546));
	
	var _PermIdentityTwoTone = _interopRequireDefault(__webpack_require__(4547));
	
	var _PermMedia = _interopRequireDefault(__webpack_require__(4548));
	
	var _PermMediaOutlined = _interopRequireDefault(__webpack_require__(4549));
	
	var _PermMediaRounded = _interopRequireDefault(__webpack_require__(4550));
	
	var _PermMediaSharp = _interopRequireDefault(__webpack_require__(4551));
	
	var _PermMediaTwoTone = _interopRequireDefault(__webpack_require__(4552));
	
	var _PermPhoneMsg = _interopRequireDefault(__webpack_require__(4553));
	
	var _PermPhoneMsgOutlined = _interopRequireDefault(__webpack_require__(4554));
	
	var _PermPhoneMsgRounded = _interopRequireDefault(__webpack_require__(4555));
	
	var _PermPhoneMsgSharp = _interopRequireDefault(__webpack_require__(4556));
	
	var _PermPhoneMsgTwoTone = _interopRequireDefault(__webpack_require__(4557));
	
	var _PermScanWifi = _interopRequireDefault(__webpack_require__(4558));
	
	var _PermScanWifiOutlined = _interopRequireDefault(__webpack_require__(4559));
	
	var _PermScanWifiRounded = _interopRequireDefault(__webpack_require__(4560));
	
	var _PermScanWifiSharp = _interopRequireDefault(__webpack_require__(4561));
	
	var _PermScanWifiTwoTone = _interopRequireDefault(__webpack_require__(4562));
	
	var _Person = _interopRequireDefault(__webpack_require__(4563));
	
	var _PersonAdd = _interopRequireDefault(__webpack_require__(4564));
	
	var _PersonAddDisabled = _interopRequireDefault(__webpack_require__(4565));
	
	var _PersonAddDisabledOutlined = _interopRequireDefault(__webpack_require__(4566));
	
	var _PersonAddDisabledRounded = _interopRequireDefault(__webpack_require__(4567));
	
	var _PersonAddDisabledSharp = _interopRequireDefault(__webpack_require__(4568));
	
	var _PersonAddDisabledTwoTone = _interopRequireDefault(__webpack_require__(4569));
	
	var _PersonAddOutlined = _interopRequireDefault(__webpack_require__(4570));
	
	var _PersonAddRounded = _interopRequireDefault(__webpack_require__(4571));
	
	var _PersonAddSharp = _interopRequireDefault(__webpack_require__(4572));
	
	var _PersonAddTwoTone = _interopRequireDefault(__webpack_require__(4573));
	
	var _PersonalVideo = _interopRequireDefault(__webpack_require__(4593));
	
	var _PersonalVideoOutlined = _interopRequireDefault(__webpack_require__(4594));
	
	var _PersonalVideoRounded = _interopRequireDefault(__webpack_require__(4595));
	
	var _PersonalVideoSharp = _interopRequireDefault(__webpack_require__(4596));
	
	var _PersonalVideoTwoTone = _interopRequireDefault(__webpack_require__(4597));
	
	var _PersonOutline = _interopRequireDefault(__webpack_require__(4574));
	
	var _PersonOutlined = _interopRequireDefault(__webpack_require__(4579));
	
	var _PersonOutlineOutlined = _interopRequireDefault(__webpack_require__(4575));
	
	var _PersonOutlineRounded = _interopRequireDefault(__webpack_require__(4576));
	
	var _PersonOutlineSharp = _interopRequireDefault(__webpack_require__(4577));
	
	var _PersonOutlineTwoTone = _interopRequireDefault(__webpack_require__(4578));
	
	var _PersonPin = _interopRequireDefault(__webpack_require__(4580));
	
	var _PersonPinCircle = _interopRequireDefault(__webpack_require__(4581));
	
	var _PersonPinCircleOutlined = _interopRequireDefault(__webpack_require__(4582));
	
	var _PersonPinCircleRounded = _interopRequireDefault(__webpack_require__(4583));
	
	var _PersonPinCircleSharp = _interopRequireDefault(__webpack_require__(4584));
	
	var _PersonPinCircleTwoTone = _interopRequireDefault(__webpack_require__(4585));
	
	var _PersonPinOutlined = _interopRequireDefault(__webpack_require__(4586));
	
	var _PersonPinRounded = _interopRequireDefault(__webpack_require__(4587));
	
	var _PersonPinSharp = _interopRequireDefault(__webpack_require__(4588));
	
	var _PersonPinTwoTone = _interopRequireDefault(__webpack_require__(4589));
	
	var _PersonRounded = _interopRequireDefault(__webpack_require__(4590));
	
	var _PersonSharp = _interopRequireDefault(__webpack_require__(4591));
	
	var _PersonTwoTone = _interopRequireDefault(__webpack_require__(4592));
	
	var _Pets = _interopRequireDefault(__webpack_require__(4598));
	
	var _PetsOutlined = _interopRequireDefault(__webpack_require__(4599));
	
	var _PetsRounded = _interopRequireDefault(__webpack_require__(4600));
	
	var _PetsSharp = _interopRequireDefault(__webpack_require__(4601));
	
	var _PetsTwoTone = _interopRequireDefault(__webpack_require__(4602));
	
	var _Phone = _interopRequireDefault(__webpack_require__(4603));
	
	var _PhoneAndroid = _interopRequireDefault(__webpack_require__(4604));
	
	var _PhoneAndroidOutlined = _interopRequireDefault(__webpack_require__(4605));
	
	var _PhoneAndroidRounded = _interopRequireDefault(__webpack_require__(4606));
	
	var _PhoneAndroidSharp = _interopRequireDefault(__webpack_require__(4607));
	
	var _PhoneAndroidTwoTone = _interopRequireDefault(__webpack_require__(4608));
	
	var _PhoneBluetoothSpeaker = _interopRequireDefault(__webpack_require__(4609));
	
	var _PhoneBluetoothSpeakerOutlined = _interopRequireDefault(__webpack_require__(4610));
	
	var _PhoneBluetoothSpeakerRounded = _interopRequireDefault(__webpack_require__(4611));
	
	var _PhoneBluetoothSpeakerSharp = _interopRequireDefault(__webpack_require__(4612));
	
	var _PhoneBluetoothSpeakerTwoTone = _interopRequireDefault(__webpack_require__(4613));
	
	var _PhoneCallback = _interopRequireDefault(__webpack_require__(4614));
	
	var _PhoneCallbackOutlined = _interopRequireDefault(__webpack_require__(4615));
	
	var _PhoneCallbackRounded = _interopRequireDefault(__webpack_require__(4616));
	
	var _PhoneCallbackSharp = _interopRequireDefault(__webpack_require__(4617));
	
	var _PhoneCallbackTwoTone = _interopRequireDefault(__webpack_require__(4618));
	
	var _PhoneDisabled = _interopRequireDefault(__webpack_require__(4619));
	
	var _PhoneDisabledOutlined = _interopRequireDefault(__webpack_require__(4620));
	
	var _PhoneDisabledRounded = _interopRequireDefault(__webpack_require__(4621));
	
	var _PhoneDisabledSharp = _interopRequireDefault(__webpack_require__(4622));
	
	var _PhoneDisabledTwoTone = _interopRequireDefault(__webpack_require__(4623));
	
	var _PhoneEnabled = _interopRequireDefault(__webpack_require__(4624));
	
	var _PhoneEnabledOutlined = _interopRequireDefault(__webpack_require__(4625));
	
	var _PhoneEnabledRounded = _interopRequireDefault(__webpack_require__(4626));
	
	var _PhoneEnabledSharp = _interopRequireDefault(__webpack_require__(4627));
	
	var _PhoneEnabledTwoTone = _interopRequireDefault(__webpack_require__(4628));
	
	var _PhoneForwarded = _interopRequireDefault(__webpack_require__(4629));
	
	var _PhoneForwardedOutlined = _interopRequireDefault(__webpack_require__(4630));
	
	var _PhoneForwardedRounded = _interopRequireDefault(__webpack_require__(4631));
	
	var _PhoneForwardedSharp = _interopRequireDefault(__webpack_require__(4632));
	
	var _PhoneForwardedTwoTone = _interopRequireDefault(__webpack_require__(4633));
	
	var _PhoneInTalk = _interopRequireDefault(__webpack_require__(4634));
	
	var _PhoneInTalkOutlined = _interopRequireDefault(__webpack_require__(4635));
	
	var _PhoneInTalkRounded = _interopRequireDefault(__webpack_require__(4636));
	
	var _PhoneInTalkSharp = _interopRequireDefault(__webpack_require__(4637));
	
	var _PhoneInTalkTwoTone = _interopRequireDefault(__webpack_require__(4638));
	
	var _PhoneIphone = _interopRequireDefault(__webpack_require__(4639));
	
	var _PhoneIphoneOutlined = _interopRequireDefault(__webpack_require__(4640));
	
	var _PhoneIphoneRounded = _interopRequireDefault(__webpack_require__(4641));
	
	var _PhoneIphoneSharp = _interopRequireDefault(__webpack_require__(4642));
	
	var _PhoneIphoneTwoTone = _interopRequireDefault(__webpack_require__(4643));
	
	var _Phonelink = _interopRequireDefault(__webpack_require__(4663));
	
	var _PhonelinkErase = _interopRequireDefault(__webpack_require__(4664));
	
	var _PhonelinkEraseOutlined = _interopRequireDefault(__webpack_require__(4665));
	
	var _PhonelinkEraseRounded = _interopRequireDefault(__webpack_require__(4666));
	
	var _PhonelinkEraseSharp = _interopRequireDefault(__webpack_require__(4667));
	
	var _PhonelinkEraseTwoTone = _interopRequireDefault(__webpack_require__(4668));
	
	var _PhonelinkLock = _interopRequireDefault(__webpack_require__(4669));
	
	var _PhonelinkLockOutlined = _interopRequireDefault(__webpack_require__(4670));
	
	var _PhonelinkLockRounded = _interopRequireDefault(__webpack_require__(4671));
	
	var _PhonelinkLockSharp = _interopRequireDefault(__webpack_require__(4672));
	
	var _PhonelinkLockTwoTone = _interopRequireDefault(__webpack_require__(4673));
	
	var _PhonelinkOff = _interopRequireDefault(__webpack_require__(4674));
	
	var _PhonelinkOffOutlined = _interopRequireDefault(__webpack_require__(4675));
	
	var _PhonelinkOffRounded = _interopRequireDefault(__webpack_require__(4676));
	
	var _PhonelinkOffSharp = _interopRequireDefault(__webpack_require__(4677));
	
	var _PhonelinkOffTwoTone = _interopRequireDefault(__webpack_require__(4678));
	
	var _PhonelinkOutlined = _interopRequireDefault(__webpack_require__(4679));
	
	var _PhonelinkRing = _interopRequireDefault(__webpack_require__(4680));
	
	var _PhonelinkRingOutlined = _interopRequireDefault(__webpack_require__(4681));
	
	var _PhonelinkRingRounded = _interopRequireDefault(__webpack_require__(4682));
	
	var _PhonelinkRingSharp = _interopRequireDefault(__webpack_require__(4683));
	
	var _PhonelinkRingTwoTone = _interopRequireDefault(__webpack_require__(4684));
	
	var _PhonelinkRounded = _interopRequireDefault(__webpack_require__(4685));
	
	var _PhonelinkSetup = _interopRequireDefault(__webpack_require__(4686));
	
	var _PhonelinkSetupOutlined = _interopRequireDefault(__webpack_require__(4687));
	
	var _PhonelinkSetupRounded = _interopRequireDefault(__webpack_require__(4688));
	
	var _PhonelinkSetupSharp = _interopRequireDefault(__webpack_require__(4689));
	
	var _PhonelinkSetupTwoTone = _interopRequireDefault(__webpack_require__(4690));
	
	var _PhonelinkSharp = _interopRequireDefault(__webpack_require__(4691));
	
	var _PhonelinkTwoTone = _interopRequireDefault(__webpack_require__(4692));
	
	var _PhoneLocked = _interopRequireDefault(__webpack_require__(4644));
	
	var _PhoneLockedOutlined = _interopRequireDefault(__webpack_require__(4645));
	
	var _PhoneLockedRounded = _interopRequireDefault(__webpack_require__(4646));
	
	var _PhoneLockedSharp = _interopRequireDefault(__webpack_require__(4647));
	
	var _PhoneLockedTwoTone = _interopRequireDefault(__webpack_require__(4648));
	
	var _PhoneMissed = _interopRequireDefault(__webpack_require__(4649));
	
	var _PhoneMissedOutlined = _interopRequireDefault(__webpack_require__(4650));
	
	var _PhoneMissedRounded = _interopRequireDefault(__webpack_require__(4651));
	
	var _PhoneMissedSharp = _interopRequireDefault(__webpack_require__(4652));
	
	var _PhoneMissedTwoTone = _interopRequireDefault(__webpack_require__(4653));
	
	var _PhoneOutlined = _interopRequireDefault(__webpack_require__(4654));
	
	var _PhonePaused = _interopRequireDefault(__webpack_require__(4655));
	
	var _PhonePausedOutlined = _interopRequireDefault(__webpack_require__(4656));
	
	var _PhonePausedRounded = _interopRequireDefault(__webpack_require__(4657));
	
	var _PhonePausedSharp = _interopRequireDefault(__webpack_require__(4658));
	
	var _PhonePausedTwoTone = _interopRequireDefault(__webpack_require__(4659));
	
	var _PhoneRounded = _interopRequireDefault(__webpack_require__(4660));
	
	var _PhoneSharp = _interopRequireDefault(__webpack_require__(4661));
	
	var _PhoneTwoTone = _interopRequireDefault(__webpack_require__(4662));
	
	var _Photo = _interopRequireDefault(__webpack_require__(4693));
	
	var _PhotoAlbum = _interopRequireDefault(__webpack_require__(4694));
	
	var _PhotoAlbumOutlined = _interopRequireDefault(__webpack_require__(4695));
	
	var _PhotoAlbumRounded = _interopRequireDefault(__webpack_require__(4696));
	
	var _PhotoAlbumSharp = _interopRequireDefault(__webpack_require__(4697));
	
	var _PhotoAlbumTwoTone = _interopRequireDefault(__webpack_require__(4698));
	
	var _PhotoCamera = _interopRequireDefault(__webpack_require__(4699));
	
	var _PhotoCameraOutlined = _interopRequireDefault(__webpack_require__(4700));
	
	var _PhotoCameraRounded = _interopRequireDefault(__webpack_require__(4701));
	
	var _PhotoCameraSharp = _interopRequireDefault(__webpack_require__(4702));
	
	var _PhotoCameraTwoTone = _interopRequireDefault(__webpack_require__(4703));
	
	var _PhotoFilter = _interopRequireDefault(__webpack_require__(4704));
	
	var _PhotoFilterOutlined = _interopRequireDefault(__webpack_require__(4705));
	
	var _PhotoFilterRounded = _interopRequireDefault(__webpack_require__(4706));
	
	var _PhotoFilterSharp = _interopRequireDefault(__webpack_require__(4707));
	
	var _PhotoFilterTwoTone = _interopRequireDefault(__webpack_require__(4708));
	
	var _PhotoLibrary = _interopRequireDefault(__webpack_require__(4709));
	
	var _PhotoLibraryOutlined = _interopRequireDefault(__webpack_require__(4710));
	
	var _PhotoLibraryRounded = _interopRequireDefault(__webpack_require__(4711));
	
	var _PhotoLibrarySharp = _interopRequireDefault(__webpack_require__(4712));
	
	var _PhotoLibraryTwoTone = _interopRequireDefault(__webpack_require__(4713));
	
	var _PhotoOutlined = _interopRequireDefault(__webpack_require__(4714));
	
	var _PhotoRounded = _interopRequireDefault(__webpack_require__(4715));
	
	var _PhotoSharp = _interopRequireDefault(__webpack_require__(4716));
	
	var _PhotoSizeSelectActual = _interopRequireDefault(__webpack_require__(4717));
	
	var _PhotoSizeSelectActualOutlined = _interopRequireDefault(__webpack_require__(4718));
	
	var _PhotoSizeSelectActualRounded = _interopRequireDefault(__webpack_require__(4719));
	
	var _PhotoSizeSelectActualSharp = _interopRequireDefault(__webpack_require__(4720));
	
	var _PhotoSizeSelectActualTwoTone = _interopRequireDefault(__webpack_require__(4721));
	
	var _PhotoSizeSelectLarge = _interopRequireDefault(__webpack_require__(4722));
	
	var _PhotoSizeSelectLargeOutlined = _interopRequireDefault(__webpack_require__(4723));
	
	var _PhotoSizeSelectLargeRounded = _interopRequireDefault(__webpack_require__(4724));
	
	var _PhotoSizeSelectLargeSharp = _interopRequireDefault(__webpack_require__(4725));
	
	var _PhotoSizeSelectLargeTwoTone = _interopRequireDefault(__webpack_require__(4726));
	
	var _PhotoSizeSelectSmall = _interopRequireDefault(__webpack_require__(4727));
	
	var _PhotoSizeSelectSmallOutlined = _interopRequireDefault(__webpack_require__(4728));
	
	var _PhotoSizeSelectSmallRounded = _interopRequireDefault(__webpack_require__(4729));
	
	var _PhotoSizeSelectSmallSharp = _interopRequireDefault(__webpack_require__(4730));
	
	var _PhotoSizeSelectSmallTwoTone = _interopRequireDefault(__webpack_require__(4731));
	
	var _PhotoTwoTone = _interopRequireDefault(__webpack_require__(4732));
	
	var _PictureAsPdf = _interopRequireDefault(__webpack_require__(4733));
	
	var _PictureAsPdfOutlined = _interopRequireDefault(__webpack_require__(4734));
	
	var _PictureAsPdfRounded = _interopRequireDefault(__webpack_require__(4735));
	
	var _PictureAsPdfSharp = _interopRequireDefault(__webpack_require__(4736));
	
	var _PictureAsPdfTwoTone = _interopRequireDefault(__webpack_require__(4737));
	
	var _PictureInPicture = _interopRequireDefault(__webpack_require__(4738));
	
	var _PictureInPictureAlt = _interopRequireDefault(__webpack_require__(4739));
	
	var _PictureInPictureAltOutlined = _interopRequireDefault(__webpack_require__(4740));
	
	var _PictureInPictureAltRounded = _interopRequireDefault(__webpack_require__(4741));
	
	var _PictureInPictureAltSharp = _interopRequireDefault(__webpack_require__(4742));
	
	var _PictureInPictureAltTwoTone = _interopRequireDefault(__webpack_require__(4743));
	
	var _PictureInPictureOutlined = _interopRequireDefault(__webpack_require__(4744));
	
	var _PictureInPictureRounded = _interopRequireDefault(__webpack_require__(4745));
	
	var _PictureInPictureSharp = _interopRequireDefault(__webpack_require__(4746));
	
	var _PictureInPictureTwoTone = _interopRequireDefault(__webpack_require__(4747));
	
	var _PieChart = _interopRequireDefault(__webpack_require__(4748));
	
	var _PieChartOutlined = _interopRequireDefault(__webpack_require__(4749));
	
	var _PieChartRounded = _interopRequireDefault(__webpack_require__(4750));
	
	var _PieChartSharp = _interopRequireDefault(__webpack_require__(4751));
	
	var _PieChartTwoTone = _interopRequireDefault(__webpack_require__(4752));
	
	var _PinDrop = _interopRequireDefault(__webpack_require__(4753));
	
	var _PinDropOutlined = _interopRequireDefault(__webpack_require__(4754));
	
	var _PinDropRounded = _interopRequireDefault(__webpack_require__(4755));
	
	var _PinDropSharp = _interopRequireDefault(__webpack_require__(4756));
	
	var _PinDropTwoTone = _interopRequireDefault(__webpack_require__(4757));
	
	var _Pinterest = _interopRequireDefault(__webpack_require__(4758));
	
	var _Place = _interopRequireDefault(__webpack_require__(4759));
	
	var _PlaceOutlined = _interopRequireDefault(__webpack_require__(4760));
	
	var _PlaceRounded = _interopRequireDefault(__webpack_require__(4761));
	
	var _PlaceSharp = _interopRequireDefault(__webpack_require__(4762));
	
	var _PlaceTwoTone = _interopRequireDefault(__webpack_require__(4763));
	
	var _PlayArrow = _interopRequireDefault(__webpack_require__(4764));
	
	var _PlayArrowOutlined = _interopRequireDefault(__webpack_require__(4765));
	
	var _PlayArrowRounded = _interopRequireDefault(__webpack_require__(4766));
	
	var _PlayArrowSharp = _interopRequireDefault(__webpack_require__(4767));
	
	var _PlayArrowTwoTone = _interopRequireDefault(__webpack_require__(4768));
	
	var _PlayCircleFilled = _interopRequireDefault(__webpack_require__(4769));
	
	var _PlayCircleFilledOutlined = _interopRequireDefault(__webpack_require__(4770));
	
	var _PlayCircleFilledRounded = _interopRequireDefault(__webpack_require__(4771));
	
	var _PlayCircleFilledSharp = _interopRequireDefault(__webpack_require__(4772));
	
	var _PlayCircleFilledTwoTone = _interopRequireDefault(__webpack_require__(4773));
	
	var _PlayCircleFilledWhite = _interopRequireDefault(__webpack_require__(4774));
	
	var _PlayCircleFilledWhiteOutlined = _interopRequireDefault(__webpack_require__(4775));
	
	var _PlayCircleFilledWhiteRounded = _interopRequireDefault(__webpack_require__(4776));
	
	var _PlayCircleFilledWhiteSharp = _interopRequireDefault(__webpack_require__(4777));
	
	var _PlayCircleFilledWhiteTwoTone = _interopRequireDefault(__webpack_require__(4778));
	
	var _PlayCircleOutline = _interopRequireDefault(__webpack_require__(4779));
	
	var _PlayCircleOutlineOutlined = _interopRequireDefault(__webpack_require__(4780));
	
	var _PlayCircleOutlineRounded = _interopRequireDefault(__webpack_require__(4781));
	
	var _PlayCircleOutlineSharp = _interopRequireDefault(__webpack_require__(4782));
	
	var _PlayCircleOutlineTwoTone = _interopRequireDefault(__webpack_require__(4783));
	
	var _PlayForWork = _interopRequireDefault(__webpack_require__(4784));
	
	var _PlayForWorkOutlined = _interopRequireDefault(__webpack_require__(4785));
	
	var _PlayForWorkRounded = _interopRequireDefault(__webpack_require__(4786));
	
	var _PlayForWorkSharp = _interopRequireDefault(__webpack_require__(4787));
	
	var _PlayForWorkTwoTone = _interopRequireDefault(__webpack_require__(4788));
	
	var _PlaylistAdd = _interopRequireDefault(__webpack_require__(4789));
	
	var _PlaylistAddCheck = _interopRequireDefault(__webpack_require__(4790));
	
	var _PlaylistAddCheckOutlined = _interopRequireDefault(__webpack_require__(4791));
	
	var _PlaylistAddCheckRounded = _interopRequireDefault(__webpack_require__(4792));
	
	var _PlaylistAddCheckSharp = _interopRequireDefault(__webpack_require__(4793));
	
	var _PlaylistAddCheckTwoTone = _interopRequireDefault(__webpack_require__(4794));
	
	var _PlaylistAddOutlined = _interopRequireDefault(__webpack_require__(4795));
	
	var _PlaylistAddRounded = _interopRequireDefault(__webpack_require__(4796));
	
	var _PlaylistAddSharp = _interopRequireDefault(__webpack_require__(4797));
	
	var _PlaylistAddTwoTone = _interopRequireDefault(__webpack_require__(4798));
	
	var _PlaylistPlay = _interopRequireDefault(__webpack_require__(4799));
	
	var _PlaylistPlayOutlined = _interopRequireDefault(__webpack_require__(4800));
	
	var _PlaylistPlayRounded = _interopRequireDefault(__webpack_require__(4801));
	
	var _PlaylistPlaySharp = _interopRequireDefault(__webpack_require__(4802));
	
	var _PlaylistPlayTwoTone = _interopRequireDefault(__webpack_require__(4803));
	
	var _PlusOne = _interopRequireDefault(__webpack_require__(4804));
	
	var _PlusOneOutlined = _interopRequireDefault(__webpack_require__(4805));
	
	var _PlusOneRounded = _interopRequireDefault(__webpack_require__(4806));
	
	var _PlusOneSharp = _interopRequireDefault(__webpack_require__(4807));
	
	var _PlusOneTwoTone = _interopRequireDefault(__webpack_require__(4808));
	
	var _Policy = _interopRequireDefault(__webpack_require__(4809));
	
	var _PolicyOutlined = _interopRequireDefault(__webpack_require__(4810));
	
	var _PolicyRounded = _interopRequireDefault(__webpack_require__(4811));
	
	var _PolicySharp = _interopRequireDefault(__webpack_require__(4812));
	
	var _PolicyTwoTone = _interopRequireDefault(__webpack_require__(4813));
	
	var _Poll = _interopRequireDefault(__webpack_require__(4814));
	
	var _PollOutlined = _interopRequireDefault(__webpack_require__(4815));
	
	var _PollRounded = _interopRequireDefault(__webpack_require__(4816));
	
	var _PollSharp = _interopRequireDefault(__webpack_require__(4817));
	
	var _PollTwoTone = _interopRequireDefault(__webpack_require__(4818));
	
	var _Polymer = _interopRequireDefault(__webpack_require__(4819));
	
	var _PolymerOutlined = _interopRequireDefault(__webpack_require__(4820));
	
	var _PolymerRounded = _interopRequireDefault(__webpack_require__(4821));
	
	var _PolymerSharp = _interopRequireDefault(__webpack_require__(4822));
	
	var _PolymerTwoTone = _interopRequireDefault(__webpack_require__(4823));
	
	var _Pool = _interopRequireDefault(__webpack_require__(4824));
	
	var _PoolOutlined = _interopRequireDefault(__webpack_require__(4825));
	
	var _PoolRounded = _interopRequireDefault(__webpack_require__(4826));
	
	var _PoolSharp = _interopRequireDefault(__webpack_require__(4827));
	
	var _PoolTwoTone = _interopRequireDefault(__webpack_require__(4828));
	
	var _PortableWifiOff = _interopRequireDefault(__webpack_require__(4829));
	
	var _PortableWifiOffOutlined = _interopRequireDefault(__webpack_require__(4830));
	
	var _PortableWifiOffRounded = _interopRequireDefault(__webpack_require__(4831));
	
	var _PortableWifiOffSharp = _interopRequireDefault(__webpack_require__(4832));
	
	var _PortableWifiOffTwoTone = _interopRequireDefault(__webpack_require__(4833));
	
	var _Portrait = _interopRequireDefault(__webpack_require__(4834));
	
	var _PortraitOutlined = _interopRequireDefault(__webpack_require__(4835));
	
	var _PortraitRounded = _interopRequireDefault(__webpack_require__(4836));
	
	var _PortraitSharp = _interopRequireDefault(__webpack_require__(4837));
	
	var _PortraitTwoTone = _interopRequireDefault(__webpack_require__(4838));
	
	var _PostAdd = _interopRequireDefault(__webpack_require__(4839));
	
	var _PostAddOutlined = _interopRequireDefault(__webpack_require__(4840));
	
	var _PostAddRounded = _interopRequireDefault(__webpack_require__(4841));
	
	var _PostAddSharp = _interopRequireDefault(__webpack_require__(4842));
	
	var _PostAddTwoTone = _interopRequireDefault(__webpack_require__(4843));
	
	var _Power = _interopRequireDefault(__webpack_require__(4844));
	
	var _PowerInput = _interopRequireDefault(__webpack_require__(4845));
	
	var _PowerInputOutlined = _interopRequireDefault(__webpack_require__(4846));
	
	var _PowerInputRounded = _interopRequireDefault(__webpack_require__(4847));
	
	var _PowerInputSharp = _interopRequireDefault(__webpack_require__(4848));
	
	var _PowerInputTwoTone = _interopRequireDefault(__webpack_require__(4849));
	
	var _PowerOff = _interopRequireDefault(__webpack_require__(4850));
	
	var _PowerOffOutlined = _interopRequireDefault(__webpack_require__(4851));
	
	var _PowerOffRounded = _interopRequireDefault(__webpack_require__(4852));
	
	var _PowerOffSharp = _interopRequireDefault(__webpack_require__(4853));
	
	var _PowerOffTwoTone = _interopRequireDefault(__webpack_require__(4854));
	
	var _PowerOutlined = _interopRequireDefault(__webpack_require__(4855));
	
	var _PowerRounded = _interopRequireDefault(__webpack_require__(4856));
	
	var _PowerSettingsNew = _interopRequireDefault(__webpack_require__(4857));
	
	var _PowerSettingsNewOutlined = _interopRequireDefault(__webpack_require__(4858));
	
	var _PowerSettingsNewRounded = _interopRequireDefault(__webpack_require__(4859));
	
	var _PowerSettingsNewSharp = _interopRequireDefault(__webpack_require__(4860));
	
	var _PowerSettingsNewTwoTone = _interopRequireDefault(__webpack_require__(4861));
	
	var _PowerSharp = _interopRequireDefault(__webpack_require__(4862));
	
	var _PowerTwoTone = _interopRequireDefault(__webpack_require__(4863));
	
	var _PregnantWoman = _interopRequireDefault(__webpack_require__(4864));
	
	var _PregnantWomanOutlined = _interopRequireDefault(__webpack_require__(4865));
	
	var _PregnantWomanRounded = _interopRequireDefault(__webpack_require__(4866));
	
	var _PregnantWomanSharp = _interopRequireDefault(__webpack_require__(4867));
	
	var _PregnantWomanTwoTone = _interopRequireDefault(__webpack_require__(4868));
	
	var _PresentToAll = _interopRequireDefault(__webpack_require__(4869));
	
	var _PresentToAllOutlined = _interopRequireDefault(__webpack_require__(4870));
	
	var _PresentToAllRounded = _interopRequireDefault(__webpack_require__(4871));
	
	var _PresentToAllSharp = _interopRequireDefault(__webpack_require__(4872));
	
	var _PresentToAllTwoTone = _interopRequireDefault(__webpack_require__(4873));
	
	var _Print = _interopRequireDefault(__webpack_require__(4874));
	
	var _PrintDisabled = _interopRequireDefault(__webpack_require__(4875));
	
	var _PrintDisabledOutlined = _interopRequireDefault(__webpack_require__(4876));
	
	var _PrintDisabledRounded = _interopRequireDefault(__webpack_require__(4877));
	
	var _PrintDisabledSharp = _interopRequireDefault(__webpack_require__(4878));
	
	var _PrintDisabledTwoTone = _interopRequireDefault(__webpack_require__(4879));
	
	var _PrintOutlined = _interopRequireDefault(__webpack_require__(4880));
	
	var _PrintRounded = _interopRequireDefault(__webpack_require__(4881));
	
	var _PrintSharp = _interopRequireDefault(__webpack_require__(4882));
	
	var _PrintTwoTone = _interopRequireDefault(__webpack_require__(4883));
	
	var _PriorityHigh = _interopRequireDefault(__webpack_require__(4884));
	
	var _PriorityHighOutlined = _interopRequireDefault(__webpack_require__(4885));
	
	var _PriorityHighRounded = _interopRequireDefault(__webpack_require__(4886));
	
	var _PriorityHighSharp = _interopRequireDefault(__webpack_require__(4887));
	
	var _PriorityHighTwoTone = _interopRequireDefault(__webpack_require__(4888));
	
	var _Public = _interopRequireDefault(__webpack_require__(4889));
	
	var _PublicOutlined = _interopRequireDefault(__webpack_require__(4890));
	
	var _PublicRounded = _interopRequireDefault(__webpack_require__(4891));
	
	var _PublicSharp = _interopRequireDefault(__webpack_require__(4892));
	
	var _PublicTwoTone = _interopRequireDefault(__webpack_require__(4893));
	
	var _Publish = _interopRequireDefault(__webpack_require__(4894));
	
	var _PublishOutlined = _interopRequireDefault(__webpack_require__(4895));
	
	var _PublishRounded = _interopRequireDefault(__webpack_require__(4896));
	
	var _PublishSharp = _interopRequireDefault(__webpack_require__(4897));
	
	var _PublishTwoTone = _interopRequireDefault(__webpack_require__(4898));
	
	var _QueryBuilder = _interopRequireDefault(__webpack_require__(4899));
	
	var _QueryBuilderOutlined = _interopRequireDefault(__webpack_require__(4900));
	
	var _QueryBuilderRounded = _interopRequireDefault(__webpack_require__(4901));
	
	var _QueryBuilderSharp = _interopRequireDefault(__webpack_require__(4902));
	
	var _QueryBuilderTwoTone = _interopRequireDefault(__webpack_require__(4903));
	
	var _QuestionAnswer = _interopRequireDefault(__webpack_require__(4904));
	
	var _QuestionAnswerOutlined = _interopRequireDefault(__webpack_require__(4905));
	
	var _QuestionAnswerRounded = _interopRequireDefault(__webpack_require__(4906));
	
	var _QuestionAnswerSharp = _interopRequireDefault(__webpack_require__(4907));
	
	var _QuestionAnswerTwoTone = _interopRequireDefault(__webpack_require__(4908));
	
	var _Queue = _interopRequireDefault(__webpack_require__(4909));
	
	var _QueueMusic = _interopRequireDefault(__webpack_require__(4910));
	
	var _QueueMusicOutlined = _interopRequireDefault(__webpack_require__(4911));
	
	var _QueueMusicRounded = _interopRequireDefault(__webpack_require__(4912));
	
	var _QueueMusicSharp = _interopRequireDefault(__webpack_require__(4913));
	
	var _QueueMusicTwoTone = _interopRequireDefault(__webpack_require__(4914));
	
	var _QueueOutlined = _interopRequireDefault(__webpack_require__(4915));
	
	var _QueuePlayNext = _interopRequireDefault(__webpack_require__(4916));
	
	var _QueuePlayNextOutlined = _interopRequireDefault(__webpack_require__(4917));
	
	var _QueuePlayNextRounded = _interopRequireDefault(__webpack_require__(4918));
	
	var _QueuePlayNextSharp = _interopRequireDefault(__webpack_require__(4919));
	
	var _QueuePlayNextTwoTone = _interopRequireDefault(__webpack_require__(4920));
	
	var _QueueRounded = _interopRequireDefault(__webpack_require__(4921));
	
	var _QueueSharp = _interopRequireDefault(__webpack_require__(4922));
	
	var _QueueTwoTone = _interopRequireDefault(__webpack_require__(4923));
	
	var _Radio = _interopRequireDefault(__webpack_require__(4924));
	
	var _RadioButtonChecked = _interopRequireDefault(__webpack_require__(4925));
	
	var _RadioButtonCheckedOutlined = _interopRequireDefault(__webpack_require__(4926));
	
	var _RadioButtonCheckedRounded = _interopRequireDefault(__webpack_require__(4927));
	
	var _RadioButtonCheckedSharp = _interopRequireDefault(__webpack_require__(4928));
	
	var _RadioButtonCheckedTwoTone = _interopRequireDefault(__webpack_require__(4929));
	
	var _RadioButtonUnchecked = _interopRequireDefault(__webpack_require__(4930));
	
	var _RadioButtonUncheckedOutlined = _interopRequireDefault(__webpack_require__(4931));
	
	var _RadioButtonUncheckedRounded = _interopRequireDefault(__webpack_require__(4932));
	
	var _RadioButtonUncheckedSharp = _interopRequireDefault(__webpack_require__(4933));
	
	var _RadioButtonUncheckedTwoTone = _interopRequireDefault(__webpack_require__(4934));
	
	var _RadioOutlined = _interopRequireDefault(__webpack_require__(4935));
	
	var _RadioRounded = _interopRequireDefault(__webpack_require__(4936));
	
	var _RadioSharp = _interopRequireDefault(__webpack_require__(4937));
	
	var _RadioTwoTone = _interopRequireDefault(__webpack_require__(4938));
	
	var _RateReview = _interopRequireDefault(__webpack_require__(4939));
	
	var _RateReviewOutlined = _interopRequireDefault(__webpack_require__(4940));
	
	var _RateReviewRounded = _interopRequireDefault(__webpack_require__(4941));
	
	var _RateReviewSharp = _interopRequireDefault(__webpack_require__(4942));
	
	var _RateReviewTwoTone = _interopRequireDefault(__webpack_require__(4943));
	
	var _Receipt = _interopRequireDefault(__webpack_require__(4944));
	
	var _ReceiptOutlined = _interopRequireDefault(__webpack_require__(4945));
	
	var _ReceiptRounded = _interopRequireDefault(__webpack_require__(4946));
	
	var _ReceiptSharp = _interopRequireDefault(__webpack_require__(4947));
	
	var _ReceiptTwoTone = _interopRequireDefault(__webpack_require__(4948));
	
	var _RecentActors = _interopRequireDefault(__webpack_require__(4949));
	
	var _RecentActorsOutlined = _interopRequireDefault(__webpack_require__(4950));
	
	var _RecentActorsRounded = _interopRequireDefault(__webpack_require__(4951));
	
	var _RecentActorsSharp = _interopRequireDefault(__webpack_require__(4952));
	
	var _RecentActorsTwoTone = _interopRequireDefault(__webpack_require__(4953));
	
	var _RecordVoiceOver = _interopRequireDefault(__webpack_require__(4954));
	
	var _RecordVoiceOverOutlined = _interopRequireDefault(__webpack_require__(4955));
	
	var _RecordVoiceOverRounded = _interopRequireDefault(__webpack_require__(4956));
	
	var _RecordVoiceOverSharp = _interopRequireDefault(__webpack_require__(4957));
	
	var _RecordVoiceOverTwoTone = _interopRequireDefault(__webpack_require__(4958));
	
	var _Reddit = _interopRequireDefault(__webpack_require__(4959));
	
	var _Redeem = _interopRequireDefault(__webpack_require__(4960));
	
	var _RedeemOutlined = _interopRequireDefault(__webpack_require__(4961));
	
	var _RedeemRounded = _interopRequireDefault(__webpack_require__(4962));
	
	var _RedeemSharp = _interopRequireDefault(__webpack_require__(4963));
	
	var _RedeemTwoTone = _interopRequireDefault(__webpack_require__(4964));
	
	var _Redo = _interopRequireDefault(__webpack_require__(4965));
	
	var _RedoOutlined = _interopRequireDefault(__webpack_require__(4966));
	
	var _RedoRounded = _interopRequireDefault(__webpack_require__(4967));
	
	var _RedoSharp = _interopRequireDefault(__webpack_require__(4968));
	
	var _RedoTwoTone = _interopRequireDefault(__webpack_require__(4969));
	
	var _Refresh = _interopRequireDefault(__webpack_require__(4970));
	
	var _RefreshOutlined = _interopRequireDefault(__webpack_require__(4971));
	
	var _RefreshRounded = _interopRequireDefault(__webpack_require__(4972));
	
	var _RefreshSharp = _interopRequireDefault(__webpack_require__(4973));
	
	var _RefreshTwoTone = _interopRequireDefault(__webpack_require__(4974));
	
	var _Remove = _interopRequireDefault(__webpack_require__(4975));
	
	var _RemoveCircle = _interopRequireDefault(__webpack_require__(4976));
	
	var _RemoveCircleOutline = _interopRequireDefault(__webpack_require__(4977));
	
	var _RemoveCircleOutlined = _interopRequireDefault(__webpack_require__(4982));
	
	var _RemoveCircleOutlineOutlined = _interopRequireDefault(__webpack_require__(4978));
	
	var _RemoveCircleOutlineRounded = _interopRequireDefault(__webpack_require__(4979));
	
	var _RemoveCircleOutlineSharp = _interopRequireDefault(__webpack_require__(4980));
	
	var _RemoveCircleOutlineTwoTone = _interopRequireDefault(__webpack_require__(4981));
	
	var _RemoveCircleRounded = _interopRequireDefault(__webpack_require__(4983));
	
	var _RemoveCircleSharp = _interopRequireDefault(__webpack_require__(4984));
	
	var _RemoveCircleTwoTone = _interopRequireDefault(__webpack_require__(4985));
	
	var _RemoveFromQueue = _interopRequireDefault(__webpack_require__(4986));
	
	var _RemoveFromQueueOutlined = _interopRequireDefault(__webpack_require__(4987));
	
	var _RemoveFromQueueRounded = _interopRequireDefault(__webpack_require__(4988));
	
	var _RemoveFromQueueSharp = _interopRequireDefault(__webpack_require__(4989));
	
	var _RemoveFromQueueTwoTone = _interopRequireDefault(__webpack_require__(4990));
	
	var _RemoveOutlined = _interopRequireDefault(__webpack_require__(4991));
	
	var _RemoveRedEye = _interopRequireDefault(__webpack_require__(4992));
	
	var _RemoveRedEyeOutlined = _interopRequireDefault(__webpack_require__(4993));
	
	var _RemoveRedEyeRounded = _interopRequireDefault(__webpack_require__(4994));
	
	var _RemoveRedEyeSharp = _interopRequireDefault(__webpack_require__(4995));
	
	var _RemoveRedEyeTwoTone = _interopRequireDefault(__webpack_require__(4996));
	
	var _RemoveRounded = _interopRequireDefault(__webpack_require__(4997));
	
	var _RemoveSharp = _interopRequireDefault(__webpack_require__(4998));
	
	var _RemoveShoppingCart = _interopRequireDefault(__webpack_require__(4999));
	
	var _RemoveShoppingCartOutlined = _interopRequireDefault(__webpack_require__(5000));
	
	var _RemoveShoppingCartRounded = _interopRequireDefault(__webpack_require__(5001));
	
	var _RemoveShoppingCartSharp = _interopRequireDefault(__webpack_require__(5002));
	
	var _RemoveShoppingCartTwoTone = _interopRequireDefault(__webpack_require__(5003));
	
	var _RemoveTwoTone = _interopRequireDefault(__webpack_require__(5004));
	
	var _Reorder = _interopRequireDefault(__webpack_require__(5005));
	
	var _ReorderOutlined = _interopRequireDefault(__webpack_require__(5006));
	
	var _ReorderRounded = _interopRequireDefault(__webpack_require__(5007));
	
	var _ReorderSharp = _interopRequireDefault(__webpack_require__(5008));
	
	var _ReorderTwoTone = _interopRequireDefault(__webpack_require__(5009));
	
	var _Repeat = _interopRequireDefault(__webpack_require__(5010));
	
	var _RepeatOne = _interopRequireDefault(__webpack_require__(5011));
	
	var _RepeatOneOutlined = _interopRequireDefault(__webpack_require__(5012));
	
	var _RepeatOneRounded = _interopRequireDefault(__webpack_require__(5013));
	
	var _RepeatOneSharp = _interopRequireDefault(__webpack_require__(5014));
	
	var _RepeatOneTwoTone = _interopRequireDefault(__webpack_require__(5015));
	
	var _RepeatOutlined = _interopRequireDefault(__webpack_require__(5016));
	
	var _RepeatRounded = _interopRequireDefault(__webpack_require__(5017));
	
	var _RepeatSharp = _interopRequireDefault(__webpack_require__(5018));
	
	var _RepeatTwoTone = _interopRequireDefault(__webpack_require__(5019));
	
	var _Replay = _interopRequireDefault(__webpack_require__(5020));
	
	var _Replay2 = _interopRequireDefault(__webpack_require__(5021));
	
	var _Replay10Outlined = _interopRequireDefault(__webpack_require__(5022));
	
	var _Replay10Rounded = _interopRequireDefault(__webpack_require__(5023));
	
	var _Replay10Sharp = _interopRequireDefault(__webpack_require__(5024));
	
	var _Replay10TwoTone = _interopRequireDefault(__webpack_require__(5025));
	
	var _Replay3 = _interopRequireDefault(__webpack_require__(5026));
	
	var _Replay30Outlined = _interopRequireDefault(__webpack_require__(5027));
	
	var _Replay30Rounded = _interopRequireDefault(__webpack_require__(5028));
	
	var _Replay30Sharp = _interopRequireDefault(__webpack_require__(5029));
	
	var _Replay30TwoTone = _interopRequireDefault(__webpack_require__(5030));
	
	var _Replay4 = _interopRequireDefault(__webpack_require__(5031));
	
	var _Replay5Outlined = _interopRequireDefault(__webpack_require__(5032));
	
	var _Replay5Rounded = _interopRequireDefault(__webpack_require__(5033));
	
	var _Replay5Sharp = _interopRequireDefault(__webpack_require__(5034));
	
	var _Replay5TwoTone = _interopRequireDefault(__webpack_require__(5035));
	
	var _ReplayOutlined = _interopRequireDefault(__webpack_require__(5036));
	
	var _ReplayRounded = _interopRequireDefault(__webpack_require__(5037));
	
	var _ReplaySharp = _interopRequireDefault(__webpack_require__(5038));
	
	var _ReplayTwoTone = _interopRequireDefault(__webpack_require__(5039));
	
	var _Reply = _interopRequireDefault(__webpack_require__(5040));
	
	var _ReplyAll = _interopRequireDefault(__webpack_require__(5041));
	
	var _ReplyAllOutlined = _interopRequireDefault(__webpack_require__(5042));
	
	var _ReplyAllRounded = _interopRequireDefault(__webpack_require__(5043));
	
	var _ReplyAllSharp = _interopRequireDefault(__webpack_require__(5044));
	
	var _ReplyAllTwoTone = _interopRequireDefault(__webpack_require__(5045));
	
	var _ReplyOutlined = _interopRequireDefault(__webpack_require__(5046));
	
	var _ReplyRounded = _interopRequireDefault(__webpack_require__(5047));
	
	var _ReplySharp = _interopRequireDefault(__webpack_require__(5048));
	
	var _ReplyTwoTone = _interopRequireDefault(__webpack_require__(5049));
	
	var _Report = _interopRequireDefault(__webpack_require__(5050));
	
	var _ReportOff = _interopRequireDefault(__webpack_require__(5051));
	
	var _ReportOffOutlined = _interopRequireDefault(__webpack_require__(5052));
	
	var _ReportOffRounded = _interopRequireDefault(__webpack_require__(5053));
	
	var _ReportOffSharp = _interopRequireDefault(__webpack_require__(5054));
	
	var _ReportOffTwoTone = _interopRequireDefault(__webpack_require__(5055));
	
	var _ReportOutlined = _interopRequireDefault(__webpack_require__(5056));
	
	var _ReportProblem = _interopRequireDefault(__webpack_require__(5057));
	
	var _ReportProblemOutlined = _interopRequireDefault(__webpack_require__(5058));
	
	var _ReportProblemRounded = _interopRequireDefault(__webpack_require__(5059));
	
	var _ReportProblemSharp = _interopRequireDefault(__webpack_require__(5060));
	
	var _ReportProblemTwoTone = _interopRequireDefault(__webpack_require__(5061));
	
	var _ReportRounded = _interopRequireDefault(__webpack_require__(5062));
	
	var _ReportSharp = _interopRequireDefault(__webpack_require__(5063));
	
	var _ReportTwoTone = _interopRequireDefault(__webpack_require__(5064));
	
	var _Restaurant = _interopRequireDefault(__webpack_require__(5065));
	
	var _RestaurantMenu = _interopRequireDefault(__webpack_require__(5066));
	
	var _RestaurantMenuOutlined = _interopRequireDefault(__webpack_require__(5067));
	
	var _RestaurantMenuRounded = _interopRequireDefault(__webpack_require__(5068));
	
	var _RestaurantMenuSharp = _interopRequireDefault(__webpack_require__(5069));
	
	var _RestaurantMenuTwoTone = _interopRequireDefault(__webpack_require__(5070));
	
	var _RestaurantOutlined = _interopRequireDefault(__webpack_require__(5071));
	
	var _RestaurantRounded = _interopRequireDefault(__webpack_require__(5072));
	
	var _RestaurantSharp = _interopRequireDefault(__webpack_require__(5073));
	
	var _RestaurantTwoTone = _interopRequireDefault(__webpack_require__(5074));
	
	var _Restore = _interopRequireDefault(__webpack_require__(5075));
	
	var _RestoreFromTrash = _interopRequireDefault(__webpack_require__(5076));
	
	var _RestoreFromTrashOutlined = _interopRequireDefault(__webpack_require__(5077));
	
	var _RestoreFromTrashRounded = _interopRequireDefault(__webpack_require__(5078));
	
	var _RestoreFromTrashSharp = _interopRequireDefault(__webpack_require__(5079));
	
	var _RestoreFromTrashTwoTone = _interopRequireDefault(__webpack_require__(5080));
	
	var _RestoreOutlined = _interopRequireDefault(__webpack_require__(5081));
	
	var _RestorePage = _interopRequireDefault(__webpack_require__(5082));
	
	var _RestorePageOutlined = _interopRequireDefault(__webpack_require__(5083));
	
	var _RestorePageRounded = _interopRequireDefault(__webpack_require__(5084));
	
	var _RestorePageSharp = _interopRequireDefault(__webpack_require__(5085));
	
	var _RestorePageTwoTone = _interopRequireDefault(__webpack_require__(5086));
	
	var _RestoreRounded = _interopRequireDefault(__webpack_require__(5087));
	
	var _RestoreSharp = _interopRequireDefault(__webpack_require__(5088));
	
	var _RestoreTwoTone = _interopRequireDefault(__webpack_require__(5089));
	
	var _RingVolume = _interopRequireDefault(__webpack_require__(5090));
	
	var _RingVolumeOutlined = _interopRequireDefault(__webpack_require__(5091));
	
	var _RingVolumeRounded = _interopRequireDefault(__webpack_require__(5092));
	
	var _RingVolumeSharp = _interopRequireDefault(__webpack_require__(5093));
	
	var _RingVolumeTwoTone = _interopRequireDefault(__webpack_require__(5094));
	
	var _Room = _interopRequireDefault(__webpack_require__(5095));
	
	var _RoomOutlined = _interopRequireDefault(__webpack_require__(5096));
	
	var _RoomRounded = _interopRequireDefault(__webpack_require__(5097));
	
	var _RoomService = _interopRequireDefault(__webpack_require__(5098));
	
	var _RoomServiceOutlined = _interopRequireDefault(__webpack_require__(5099));
	
	var _RoomServiceRounded = _interopRequireDefault(__webpack_require__(5100));
	
	var _RoomServiceSharp = _interopRequireDefault(__webpack_require__(5101));
	
	var _RoomServiceTwoTone = _interopRequireDefault(__webpack_require__(5102));
	
	var _RoomSharp = _interopRequireDefault(__webpack_require__(5103));
	
	var _RoomTwoTone = _interopRequireDefault(__webpack_require__(5104));
	
	var _Rotate90DegreesCcw = _interopRequireDefault(__webpack_require__(5105));
	
	var _Rotate90DegreesCcwOutlined = _interopRequireDefault(__webpack_require__(5106));
	
	var _Rotate90DegreesCcwRounded = _interopRequireDefault(__webpack_require__(5107));
	
	var _Rotate90DegreesCcwSharp = _interopRequireDefault(__webpack_require__(5108));
	
	var _Rotate90DegreesCcwTwoTone = _interopRequireDefault(__webpack_require__(5109));
	
	var _RotateLeft = _interopRequireDefault(__webpack_require__(5110));
	
	var _RotateLeftOutlined = _interopRequireDefault(__webpack_require__(5111));
	
	var _RotateLeftRounded = _interopRequireDefault(__webpack_require__(5112));
	
	var _RotateLeftSharp = _interopRequireDefault(__webpack_require__(5113));
	
	var _RotateLeftTwoTone = _interopRequireDefault(__webpack_require__(5114));
	
	var _RotateRight = _interopRequireDefault(__webpack_require__(5115));
	
	var _RotateRightOutlined = _interopRequireDefault(__webpack_require__(5116));
	
	var _RotateRightRounded = _interopRequireDefault(__webpack_require__(5117));
	
	var _RotateRightSharp = _interopRequireDefault(__webpack_require__(5118));
	
	var _RotateRightTwoTone = _interopRequireDefault(__webpack_require__(5119));
	
	var _RoundedCorner = _interopRequireDefault(__webpack_require__(5120));
	
	var _RoundedCornerOutlined = _interopRequireDefault(__webpack_require__(5121));
	
	var _RoundedCornerRounded = _interopRequireDefault(__webpack_require__(5122));
	
	var _RoundedCornerSharp = _interopRequireDefault(__webpack_require__(5123));
	
	var _RoundedCornerTwoTone = _interopRequireDefault(__webpack_require__(5124));
	
	var _Router = _interopRequireDefault(__webpack_require__(5125));
	
	var _RouterOutlined = _interopRequireDefault(__webpack_require__(5126));
	
	var _RouterRounded = _interopRequireDefault(__webpack_require__(5127));
	
	var _RouterSharp = _interopRequireDefault(__webpack_require__(5128));
	
	var _RouterTwoTone = _interopRequireDefault(__webpack_require__(5129));
	
	var _Rowing = _interopRequireDefault(__webpack_require__(5130));
	
	var _RowingOutlined = _interopRequireDefault(__webpack_require__(5131));
	
	var _RowingRounded = _interopRequireDefault(__webpack_require__(5132));
	
	var _RowingSharp = _interopRequireDefault(__webpack_require__(5133));
	
	var _RowingTwoTone = _interopRequireDefault(__webpack_require__(5134));
	
	var _RssFeed = _interopRequireDefault(__webpack_require__(5135));
	
	var _RssFeedOutlined = _interopRequireDefault(__webpack_require__(5136));
	
	var _RssFeedRounded = _interopRequireDefault(__webpack_require__(5137));
	
	var _RssFeedSharp = _interopRequireDefault(__webpack_require__(5138));
	
	var _RssFeedTwoTone = _interopRequireDefault(__webpack_require__(5139));
	
	var _RvHookup = _interopRequireDefault(__webpack_require__(5140));
	
	var _RvHookupOutlined = _interopRequireDefault(__webpack_require__(5141));
	
	var _RvHookupRounded = _interopRequireDefault(__webpack_require__(5142));
	
	var _RvHookupSharp = _interopRequireDefault(__webpack_require__(5143));
	
	var _RvHookupTwoTone = _interopRequireDefault(__webpack_require__(5144));
	
	var _Satellite = _interopRequireDefault(__webpack_require__(5145));
	
	var _SatelliteOutlined = _interopRequireDefault(__webpack_require__(5146));
	
	var _SatelliteRounded = _interopRequireDefault(__webpack_require__(5147));
	
	var _SatelliteSharp = _interopRequireDefault(__webpack_require__(5148));
	
	var _SatelliteTwoTone = _interopRequireDefault(__webpack_require__(5149));
	
	var _Save = _interopRequireDefault(__webpack_require__(5150));
	
	var _SaveAlt = _interopRequireDefault(__webpack_require__(5151));
	
	var _SaveAltOutlined = _interopRequireDefault(__webpack_require__(5152));
	
	var _SaveAltRounded = _interopRequireDefault(__webpack_require__(5153));
	
	var _SaveAltSharp = _interopRequireDefault(__webpack_require__(5154));
	
	var _SaveAltTwoTone = _interopRequireDefault(__webpack_require__(5155));
	
	var _SaveOutlined = _interopRequireDefault(__webpack_require__(5156));
	
	var _SaveRounded = _interopRequireDefault(__webpack_require__(5157));
	
	var _SaveSharp = _interopRequireDefault(__webpack_require__(5158));
	
	var _SaveTwoTone = _interopRequireDefault(__webpack_require__(5159));
	
	var _Scanner = _interopRequireDefault(__webpack_require__(5160));
	
	var _ScannerOutlined = _interopRequireDefault(__webpack_require__(5161));
	
	var _ScannerRounded = _interopRequireDefault(__webpack_require__(5162));
	
	var _ScannerSharp = _interopRequireDefault(__webpack_require__(5163));
	
	var _ScannerTwoTone = _interopRequireDefault(__webpack_require__(5164));
	
	var _ScatterPlot = _interopRequireDefault(__webpack_require__(5165));
	
	var _ScatterPlotOutlined = _interopRequireDefault(__webpack_require__(5166));
	
	var _ScatterPlotRounded = _interopRequireDefault(__webpack_require__(5167));
	
	var _ScatterPlotSharp = _interopRequireDefault(__webpack_require__(5168));
	
	var _ScatterPlotTwoTone = _interopRequireDefault(__webpack_require__(5169));
	
	var _Schedule = _interopRequireDefault(__webpack_require__(5170));
	
	var _ScheduleOutlined = _interopRequireDefault(__webpack_require__(5171));
	
	var _ScheduleRounded = _interopRequireDefault(__webpack_require__(5172));
	
	var _ScheduleSharp = _interopRequireDefault(__webpack_require__(5173));
	
	var _ScheduleTwoTone = _interopRequireDefault(__webpack_require__(5174));
	
	var _School = _interopRequireDefault(__webpack_require__(5175));
	
	var _SchoolOutlined = _interopRequireDefault(__webpack_require__(5176));
	
	var _SchoolRounded = _interopRequireDefault(__webpack_require__(5177));
	
	var _SchoolSharp = _interopRequireDefault(__webpack_require__(5178));
	
	var _SchoolTwoTone = _interopRequireDefault(__webpack_require__(5179));
	
	var _Score = _interopRequireDefault(__webpack_require__(5180));
	
	var _ScoreOutlined = _interopRequireDefault(__webpack_require__(5181));
	
	var _ScoreRounded = _interopRequireDefault(__webpack_require__(5182));
	
	var _ScoreSharp = _interopRequireDefault(__webpack_require__(5183));
	
	var _ScoreTwoTone = _interopRequireDefault(__webpack_require__(5184));
	
	var _ScreenLockLandscape = _interopRequireDefault(__webpack_require__(5185));
	
	var _ScreenLockLandscapeOutlined = _interopRequireDefault(__webpack_require__(5186));
	
	var _ScreenLockLandscapeRounded = _interopRequireDefault(__webpack_require__(5187));
	
	var _ScreenLockLandscapeSharp = _interopRequireDefault(__webpack_require__(5188));
	
	var _ScreenLockLandscapeTwoTone = _interopRequireDefault(__webpack_require__(5189));
	
	var _ScreenLockPortrait = _interopRequireDefault(__webpack_require__(5190));
	
	var _ScreenLockPortraitOutlined = _interopRequireDefault(__webpack_require__(5191));
	
	var _ScreenLockPortraitRounded = _interopRequireDefault(__webpack_require__(5192));
	
	var _ScreenLockPortraitSharp = _interopRequireDefault(__webpack_require__(5193));
	
	var _ScreenLockPortraitTwoTone = _interopRequireDefault(__webpack_require__(5194));
	
	var _ScreenLockRotation = _interopRequireDefault(__webpack_require__(5195));
	
	var _ScreenLockRotationOutlined = _interopRequireDefault(__webpack_require__(5196));
	
	var _ScreenLockRotationRounded = _interopRequireDefault(__webpack_require__(5197));
	
	var _ScreenLockRotationSharp = _interopRequireDefault(__webpack_require__(5198));
	
	var _ScreenLockRotationTwoTone = _interopRequireDefault(__webpack_require__(5199));
	
	var _ScreenRotation = _interopRequireDefault(__webpack_require__(5200));
	
	var _ScreenRotationOutlined = _interopRequireDefault(__webpack_require__(5201));
	
	var _ScreenRotationRounded = _interopRequireDefault(__webpack_require__(5202));
	
	var _ScreenRotationSharp = _interopRequireDefault(__webpack_require__(5203));
	
	var _ScreenRotationTwoTone = _interopRequireDefault(__webpack_require__(5204));
	
	var _ScreenShare = _interopRequireDefault(__webpack_require__(5205));
	
	var _ScreenShareOutlined = _interopRequireDefault(__webpack_require__(5206));
	
	var _ScreenShareRounded = _interopRequireDefault(__webpack_require__(5207));
	
	var _ScreenShareSharp = _interopRequireDefault(__webpack_require__(5208));
	
	var _ScreenShareTwoTone = _interopRequireDefault(__webpack_require__(5209));
	
	var _SdCard = _interopRequireDefault(__webpack_require__(5210));
	
	var _SdCardOutlined = _interopRequireDefault(__webpack_require__(5211));
	
	var _SdCardRounded = _interopRequireDefault(__webpack_require__(5212));
	
	var _SdCardSharp = _interopRequireDefault(__webpack_require__(5213));
	
	var _SdCardTwoTone = _interopRequireDefault(__webpack_require__(5214));
	
	var _SdStorage = _interopRequireDefault(__webpack_require__(5215));
	
	var _SdStorageOutlined = _interopRequireDefault(__webpack_require__(5216));
	
	var _SdStorageRounded = _interopRequireDefault(__webpack_require__(5217));
	
	var _SdStorageSharp = _interopRequireDefault(__webpack_require__(5218));
	
	var _SdStorageTwoTone = _interopRequireDefault(__webpack_require__(5219));
	
	var _Search = _interopRequireDefault(__webpack_require__(5220));
	
	var _SearchOutlined = _interopRequireDefault(__webpack_require__(5221));
	
	var _SearchRounded = _interopRequireDefault(__webpack_require__(5222));
	
	var _SearchSharp = _interopRequireDefault(__webpack_require__(5223));
	
	var _SearchTwoTone = _interopRequireDefault(__webpack_require__(5224));
	
	var _Security = _interopRequireDefault(__webpack_require__(5225));
	
	var _SecurityOutlined = _interopRequireDefault(__webpack_require__(5226));
	
	var _SecurityRounded = _interopRequireDefault(__webpack_require__(5227));
	
	var _SecuritySharp = _interopRequireDefault(__webpack_require__(5228));
	
	var _SecurityTwoTone = _interopRequireDefault(__webpack_require__(5229));
	
	var _SelectAll = _interopRequireDefault(__webpack_require__(5230));
	
	var _SelectAllOutlined = _interopRequireDefault(__webpack_require__(5231));
	
	var _SelectAllRounded = _interopRequireDefault(__webpack_require__(5232));
	
	var _SelectAllSharp = _interopRequireDefault(__webpack_require__(5233));
	
	var _SelectAllTwoTone = _interopRequireDefault(__webpack_require__(5234));
	
	var _Send = _interopRequireDefault(__webpack_require__(5235));
	
	var _SendOutlined = _interopRequireDefault(__webpack_require__(5236));
	
	var _SendRounded = _interopRequireDefault(__webpack_require__(5237));
	
	var _SendSharp = _interopRequireDefault(__webpack_require__(5238));
	
	var _SendTwoTone = _interopRequireDefault(__webpack_require__(5239));
	
	var _SentimentDissatisfied = _interopRequireDefault(__webpack_require__(5240));
	
	var _SentimentDissatisfiedOutlined = _interopRequireDefault(__webpack_require__(5241));
	
	var _SentimentDissatisfiedRounded = _interopRequireDefault(__webpack_require__(5242));
	
	var _SentimentDissatisfiedSharp = _interopRequireDefault(__webpack_require__(5243));
	
	var _SentimentDissatisfiedTwoTone = _interopRequireDefault(__webpack_require__(5244));
	
	var _SentimentSatisfied = _interopRequireDefault(__webpack_require__(5245));
	
	var _SentimentSatisfiedAlt = _interopRequireDefault(__webpack_require__(5246));
	
	var _SentimentSatisfiedAltOutlined = _interopRequireDefault(__webpack_require__(5247));
	
	var _SentimentSatisfiedAltRounded = _interopRequireDefault(__webpack_require__(5248));
	
	var _SentimentSatisfiedAltSharp = _interopRequireDefault(__webpack_require__(5249));
	
	var _SentimentSatisfiedAltTwoTone = _interopRequireDefault(__webpack_require__(5250));
	
	var _SentimentSatisfiedOutlined = _interopRequireDefault(__webpack_require__(5251));
	
	var _SentimentSatisfiedRounded = _interopRequireDefault(__webpack_require__(5252));
	
	var _SentimentSatisfiedSharp = _interopRequireDefault(__webpack_require__(5253));
	
	var _SentimentSatisfiedTwoTone = _interopRequireDefault(__webpack_require__(5254));
	
	var _SentimentVeryDissatisfied = _interopRequireDefault(__webpack_require__(5255));
	
	var _SentimentVeryDissatisfiedOutlined = _interopRequireDefault(__webpack_require__(5256));
	
	var _SentimentVeryDissatisfiedRounded = _interopRequireDefault(__webpack_require__(5257));
	
	var _SentimentVeryDissatisfiedSharp = _interopRequireDefault(__webpack_require__(5258));
	
	var _SentimentVeryDissatisfiedTwoTone = _interopRequireDefault(__webpack_require__(5259));
	
	var _SentimentVerySatisfied = _interopRequireDefault(__webpack_require__(5260));
	
	var _SentimentVerySatisfiedOutlined = _interopRequireDefault(__webpack_require__(5261));
	
	var _SentimentVerySatisfiedRounded = _interopRequireDefault(__webpack_require__(5262));
	
	var _SentimentVerySatisfiedSharp = _interopRequireDefault(__webpack_require__(5263));
	
	var _SentimentVerySatisfiedTwoTone = _interopRequireDefault(__webpack_require__(5264));
	
	var _Settings = _interopRequireDefault(__webpack_require__(5265));
	
	var _SettingsApplications = _interopRequireDefault(__webpack_require__(5266));
	
	var _SettingsApplicationsOutlined = _interopRequireDefault(__webpack_require__(5267));
	
	var _SettingsApplicationsRounded = _interopRequireDefault(__webpack_require__(5268));
	
	var _SettingsApplicationsSharp = _interopRequireDefault(__webpack_require__(5269));
	
	var _SettingsApplicationsTwoTone = _interopRequireDefault(__webpack_require__(5270));
	
	var _SettingsBackupRestore = _interopRequireDefault(__webpack_require__(5271));
	
	var _SettingsBackupRestoreOutlined = _interopRequireDefault(__webpack_require__(5272));
	
	var _SettingsBackupRestoreRounded = _interopRequireDefault(__webpack_require__(5273));
	
	var _SettingsBackupRestoreSharp = _interopRequireDefault(__webpack_require__(5274));
	
	var _SettingsBackupRestoreTwoTone = _interopRequireDefault(__webpack_require__(5275));
	
	var _SettingsBluetooth = _interopRequireDefault(__webpack_require__(5276));
	
	var _SettingsBluetoothOutlined = _interopRequireDefault(__webpack_require__(5277));
	
	var _SettingsBluetoothRounded = _interopRequireDefault(__webpack_require__(5278));
	
	var _SettingsBluetoothSharp = _interopRequireDefault(__webpack_require__(5279));
	
	var _SettingsBluetoothTwoTone = _interopRequireDefault(__webpack_require__(5280));
	
	var _SettingsBrightness = _interopRequireDefault(__webpack_require__(5281));
	
	var _SettingsBrightnessOutlined = _interopRequireDefault(__webpack_require__(5282));
	
	var _SettingsBrightnessRounded = _interopRequireDefault(__webpack_require__(5283));
	
	var _SettingsBrightnessSharp = _interopRequireDefault(__webpack_require__(5284));
	
	var _SettingsBrightnessTwoTone = _interopRequireDefault(__webpack_require__(5285));
	
	var _SettingsCell = _interopRequireDefault(__webpack_require__(5286));
	
	var _SettingsCellOutlined = _interopRequireDefault(__webpack_require__(5287));
	
	var _SettingsCellRounded = _interopRequireDefault(__webpack_require__(5288));
	
	var _SettingsCellSharp = _interopRequireDefault(__webpack_require__(5289));
	
	var _SettingsCellTwoTone = _interopRequireDefault(__webpack_require__(5290));
	
	var _SettingsEthernet = _interopRequireDefault(__webpack_require__(5291));
	
	var _SettingsEthernetOutlined = _interopRequireDefault(__webpack_require__(5292));
	
	var _SettingsEthernetRounded = _interopRequireDefault(__webpack_require__(5293));
	
	var _SettingsEthernetSharp = _interopRequireDefault(__webpack_require__(5294));
	
	var _SettingsEthernetTwoTone = _interopRequireDefault(__webpack_require__(5295));
	
	var _SettingsInputAntenna = _interopRequireDefault(__webpack_require__(5296));
	
	var _SettingsInputAntennaOutlined = _interopRequireDefault(__webpack_require__(5297));
	
	var _SettingsInputAntennaRounded = _interopRequireDefault(__webpack_require__(5298));
	
	var _SettingsInputAntennaSharp = _interopRequireDefault(__webpack_require__(5299));
	
	var _SettingsInputAntennaTwoTone = _interopRequireDefault(__webpack_require__(5300));
	
	var _SettingsInputComponent = _interopRequireDefault(__webpack_require__(5301));
	
	var _SettingsInputComponentOutlined = _interopRequireDefault(__webpack_require__(5302));
	
	var _SettingsInputComponentRounded = _interopRequireDefault(__webpack_require__(5303));
	
	var _SettingsInputComponentSharp = _interopRequireDefault(__webpack_require__(5304));
	
	var _SettingsInputComponentTwoTone = _interopRequireDefault(__webpack_require__(5305));
	
	var _SettingsInputComposite = _interopRequireDefault(__webpack_require__(5306));
	
	var _SettingsInputCompositeOutlined = _interopRequireDefault(__webpack_require__(5307));
	
	var _SettingsInputCompositeRounded = _interopRequireDefault(__webpack_require__(5308));
	
	var _SettingsInputCompositeSharp = _interopRequireDefault(__webpack_require__(5309));
	
	var _SettingsInputCompositeTwoTone = _interopRequireDefault(__webpack_require__(5310));
	
	var _SettingsInputHdmi = _interopRequireDefault(__webpack_require__(5311));
	
	var _SettingsInputHdmiOutlined = _interopRequireDefault(__webpack_require__(5312));
	
	var _SettingsInputHdmiRounded = _interopRequireDefault(__webpack_require__(5313));
	
	var _SettingsInputHdmiSharp = _interopRequireDefault(__webpack_require__(5314));
	
	var _SettingsInputHdmiTwoTone = _interopRequireDefault(__webpack_require__(5315));
	
	var _SettingsInputSvideo = _interopRequireDefault(__webpack_require__(5316));
	
	var _SettingsInputSvideoOutlined = _interopRequireDefault(__webpack_require__(5317));
	
	var _SettingsInputSvideoRounded = _interopRequireDefault(__webpack_require__(5318));
	
	var _SettingsInputSvideoSharp = _interopRequireDefault(__webpack_require__(5319));
	
	var _SettingsInputSvideoTwoTone = _interopRequireDefault(__webpack_require__(5320));
	
	var _SettingsOutlined = _interopRequireDefault(__webpack_require__(5321));
	
	var _SettingsOverscan = _interopRequireDefault(__webpack_require__(5322));
	
	var _SettingsOverscanOutlined = _interopRequireDefault(__webpack_require__(5323));
	
	var _SettingsOverscanRounded = _interopRequireDefault(__webpack_require__(5324));
	
	var _SettingsOverscanSharp = _interopRequireDefault(__webpack_require__(5325));
	
	var _SettingsOverscanTwoTone = _interopRequireDefault(__webpack_require__(5326));
	
	var _SettingsPhone = _interopRequireDefault(__webpack_require__(5327));
	
	var _SettingsPhoneOutlined = _interopRequireDefault(__webpack_require__(5328));
	
	var _SettingsPhoneRounded = _interopRequireDefault(__webpack_require__(5329));
	
	var _SettingsPhoneSharp = _interopRequireDefault(__webpack_require__(5330));
	
	var _SettingsPhoneTwoTone = _interopRequireDefault(__webpack_require__(5331));
	
	var _SettingsPower = _interopRequireDefault(__webpack_require__(5332));
	
	var _SettingsPowerOutlined = _interopRequireDefault(__webpack_require__(5333));
	
	var _SettingsPowerRounded = _interopRequireDefault(__webpack_require__(5334));
	
	var _SettingsPowerSharp = _interopRequireDefault(__webpack_require__(5335));
	
	var _SettingsPowerTwoTone = _interopRequireDefault(__webpack_require__(5336));
	
	var _SettingsRemote = _interopRequireDefault(__webpack_require__(5337));
	
	var _SettingsRemoteOutlined = _interopRequireDefault(__webpack_require__(5338));
	
	var _SettingsRemoteRounded = _interopRequireDefault(__webpack_require__(5339));
	
	var _SettingsRemoteSharp = _interopRequireDefault(__webpack_require__(5340));
	
	var _SettingsRemoteTwoTone = _interopRequireDefault(__webpack_require__(5341));
	
	var _SettingsRounded = _interopRequireDefault(__webpack_require__(5342));
	
	var _SettingsSharp = _interopRequireDefault(__webpack_require__(5343));
	
	var _SettingsSystemDaydream = _interopRequireDefault(__webpack_require__(5344));
	
	var _SettingsSystemDaydreamOutlined = _interopRequireDefault(__webpack_require__(5345));
	
	var _SettingsSystemDaydreamRounded = _interopRequireDefault(__webpack_require__(5346));
	
	var _SettingsSystemDaydreamSharp = _interopRequireDefault(__webpack_require__(5347));
	
	var _SettingsSystemDaydreamTwoTone = _interopRequireDefault(__webpack_require__(5348));
	
	var _SettingsTwoTone = _interopRequireDefault(__webpack_require__(5349));
	
	var _SettingsVoice = _interopRequireDefault(__webpack_require__(5350));
	
	var _SettingsVoiceOutlined = _interopRequireDefault(__webpack_require__(5351));
	
	var _SettingsVoiceRounded = _interopRequireDefault(__webpack_require__(5352));
	
	var _SettingsVoiceSharp = _interopRequireDefault(__webpack_require__(5353));
	
	var _SettingsVoiceTwoTone = _interopRequireDefault(__webpack_require__(5354));
	
	var _Share = _interopRequireDefault(__webpack_require__(5355));
	
	var _ShareOutlined = _interopRequireDefault(__webpack_require__(5356));
	
	var _ShareRounded = _interopRequireDefault(__webpack_require__(5357));
	
	var _ShareSharp = _interopRequireDefault(__webpack_require__(5358));
	
	var _ShareTwoTone = _interopRequireDefault(__webpack_require__(5359));
	
	var _Shop = _interopRequireDefault(__webpack_require__(5360));
	
	var _ShopOutlined = _interopRequireDefault(__webpack_require__(5361));
	
	var _ShoppingBasket = _interopRequireDefault(__webpack_require__(5370));
	
	var _ShoppingBasketOutlined = _interopRequireDefault(__webpack_require__(5371));
	
	var _ShoppingBasketRounded = _interopRequireDefault(__webpack_require__(5372));
	
	var _ShoppingBasketSharp = _interopRequireDefault(__webpack_require__(5373));
	
	var _ShoppingBasketTwoTone = _interopRequireDefault(__webpack_require__(5374));
	
	var _ShoppingCart = _interopRequireDefault(__webpack_require__(5375));
	
	var _ShoppingCartOutlined = _interopRequireDefault(__webpack_require__(5376));
	
	var _ShoppingCartRounded = _interopRequireDefault(__webpack_require__(5377));
	
	var _ShoppingCartSharp = _interopRequireDefault(__webpack_require__(5378));
	
	var _ShoppingCartTwoTone = _interopRequireDefault(__webpack_require__(5379));
	
	var _ShopRounded = _interopRequireDefault(__webpack_require__(5362));
	
	var _ShopSharp = _interopRequireDefault(__webpack_require__(5363));
	
	var _ShopTwo = _interopRequireDefault(__webpack_require__(5364));
	
	var _ShopTwoOutlined = _interopRequireDefault(__webpack_require__(5365));
	
	var _ShopTwoRounded = _interopRequireDefault(__webpack_require__(5366));
	
	var _ShopTwoSharp = _interopRequireDefault(__webpack_require__(5367));
	
	var _ShopTwoTone = _interopRequireDefault(__webpack_require__(5368));
	
	var _ShopTwoTwoTone = _interopRequireDefault(__webpack_require__(5369));
	
	var _ShortText = _interopRequireDefault(__webpack_require__(5380));
	
	var _ShortTextOutlined = _interopRequireDefault(__webpack_require__(5381));
	
	var _ShortTextRounded = _interopRequireDefault(__webpack_require__(5382));
	
	var _ShortTextSharp = _interopRequireDefault(__webpack_require__(5383));
	
	var _ShortTextTwoTone = _interopRequireDefault(__webpack_require__(5384));
	
	var _ShowChart = _interopRequireDefault(__webpack_require__(5385));
	
	var _ShowChartOutlined = _interopRequireDefault(__webpack_require__(5386));
	
	var _ShowChartRounded = _interopRequireDefault(__webpack_require__(5387));
	
	var _ShowChartSharp = _interopRequireDefault(__webpack_require__(5388));
	
	var _ShowChartTwoTone = _interopRequireDefault(__webpack_require__(5389));
	
	var _Shuffle = _interopRequireDefault(__webpack_require__(5390));
	
	var _ShuffleOutlined = _interopRequireDefault(__webpack_require__(5391));
	
	var _ShuffleRounded = _interopRequireDefault(__webpack_require__(5392));
	
	var _ShuffleSharp = _interopRequireDefault(__webpack_require__(5393));
	
	var _ShuffleTwoTone = _interopRequireDefault(__webpack_require__(5394));
	
	var _ShutterSpeed = _interopRequireDefault(__webpack_require__(5395));
	
	var _ShutterSpeedOutlined = _interopRequireDefault(__webpack_require__(5396));
	
	var _ShutterSpeedRounded = _interopRequireDefault(__webpack_require__(5397));
	
	var _ShutterSpeedSharp = _interopRequireDefault(__webpack_require__(5398));
	
	var _ShutterSpeedTwoTone = _interopRequireDefault(__webpack_require__(5399));
	
	var _SignalCellular0Bar = _interopRequireDefault(__webpack_require__(5400));
	
	var _SignalCellular0BarOutlined = _interopRequireDefault(__webpack_require__(5401));
	
	var _SignalCellular0BarRounded = _interopRequireDefault(__webpack_require__(5402));
	
	var _SignalCellular0BarSharp = _interopRequireDefault(__webpack_require__(5403));
	
	var _SignalCellular0BarTwoTone = _interopRequireDefault(__webpack_require__(5404));
	
	var _SignalCellular1Bar = _interopRequireDefault(__webpack_require__(5405));
	
	var _SignalCellular1BarOutlined = _interopRequireDefault(__webpack_require__(5406));
	
	var _SignalCellular1BarRounded = _interopRequireDefault(__webpack_require__(5407));
	
	var _SignalCellular1BarSharp = _interopRequireDefault(__webpack_require__(5408));
	
	var _SignalCellular1BarTwoTone = _interopRequireDefault(__webpack_require__(5409));
	
	var _SignalCellular2Bar = _interopRequireDefault(__webpack_require__(5410));
	
	var _SignalCellular2BarOutlined = _interopRequireDefault(__webpack_require__(5411));
	
	var _SignalCellular2BarRounded = _interopRequireDefault(__webpack_require__(5412));
	
	var _SignalCellular2BarSharp = _interopRequireDefault(__webpack_require__(5413));
	
	var _SignalCellular2BarTwoTone = _interopRequireDefault(__webpack_require__(5414));
	
	var _SignalCellular3Bar = _interopRequireDefault(__webpack_require__(5415));
	
	var _SignalCellular3BarOutlined = _interopRequireDefault(__webpack_require__(5416));
	
	var _SignalCellular3BarRounded = _interopRequireDefault(__webpack_require__(5417));
	
	var _SignalCellular3BarSharp = _interopRequireDefault(__webpack_require__(5418));
	
	var _SignalCellular3BarTwoTone = _interopRequireDefault(__webpack_require__(5419));
	
	var _SignalCellular4Bar = _interopRequireDefault(__webpack_require__(5420));
	
	var _SignalCellular4BarOutlined = _interopRequireDefault(__webpack_require__(5421));
	
	var _SignalCellular4BarRounded = _interopRequireDefault(__webpack_require__(5422));
	
	var _SignalCellular4BarSharp = _interopRequireDefault(__webpack_require__(5423));
	
	var _SignalCellular4BarTwoTone = _interopRequireDefault(__webpack_require__(5424));
	
	var _SignalCellularAlt = _interopRequireDefault(__webpack_require__(5425));
	
	var _SignalCellularAltOutlined = _interopRequireDefault(__webpack_require__(5426));
	
	var _SignalCellularAltRounded = _interopRequireDefault(__webpack_require__(5427));
	
	var _SignalCellularAltSharp = _interopRequireDefault(__webpack_require__(5428));
	
	var _SignalCellularAltTwoTone = _interopRequireDefault(__webpack_require__(5429));
	
	var _SignalCellularConnectedNoInternet0Bar = _interopRequireDefault(__webpack_require__(5430));
	
	var _SignalCellularConnectedNoInternet0BarOutlined = _interopRequireDefault(__webpack_require__(5431));
	
	var _SignalCellularConnectedNoInternet0BarRounded = _interopRequireDefault(__webpack_require__(5432));
	
	var _SignalCellularConnectedNoInternet0BarSharp = _interopRequireDefault(__webpack_require__(5433));
	
	var _SignalCellularConnectedNoInternet0BarTwoTone = _interopRequireDefault(__webpack_require__(5434));
	
	var _SignalCellularConnectedNoInternet1Bar = _interopRequireDefault(__webpack_require__(5435));
	
	var _SignalCellularConnectedNoInternet1BarOutlined = _interopRequireDefault(__webpack_require__(5436));
	
	var _SignalCellularConnectedNoInternet1BarRounded = _interopRequireDefault(__webpack_require__(5437));
	
	var _SignalCellularConnectedNoInternet1BarSharp = _interopRequireDefault(__webpack_require__(5438));
	
	var _SignalCellularConnectedNoInternet1BarTwoTone = _interopRequireDefault(__webpack_require__(5439));
	
	var _SignalCellularConnectedNoInternet2Bar = _interopRequireDefault(__webpack_require__(5440));
	
	var _SignalCellularConnectedNoInternet2BarOutlined = _interopRequireDefault(__webpack_require__(5441));
	
	var _SignalCellularConnectedNoInternet2BarRounded = _interopRequireDefault(__webpack_require__(5442));
	
	var _SignalCellularConnectedNoInternet2BarSharp = _interopRequireDefault(__webpack_require__(5443));
	
	var _SignalCellularConnectedNoInternet2BarTwoTone = _interopRequireDefault(__webpack_require__(5444));
	
	var _SignalCellularConnectedNoInternet3Bar = _interopRequireDefault(__webpack_require__(5445));
	
	var _SignalCellularConnectedNoInternet3BarOutlined = _interopRequireDefault(__webpack_require__(5446));
	
	var _SignalCellularConnectedNoInternet3BarRounded = _interopRequireDefault(__webpack_require__(5447));
	
	var _SignalCellularConnectedNoInternet3BarSharp = _interopRequireDefault(__webpack_require__(5448));
	
	var _SignalCellularConnectedNoInternet3BarTwoTone = _interopRequireDefault(__webpack_require__(5449));
	
	var _SignalCellularConnectedNoInternet4Bar = _interopRequireDefault(__webpack_require__(5450));
	
	var _SignalCellularConnectedNoInternet4BarOutlined = _interopRequireDefault(__webpack_require__(5451));
	
	var _SignalCellularConnectedNoInternet4BarRounded = _interopRequireDefault(__webpack_require__(5452));
	
	var _SignalCellularConnectedNoInternet4BarSharp = _interopRequireDefault(__webpack_require__(5453));
	
	var _SignalCellularConnectedNoInternet4BarTwoTone = _interopRequireDefault(__webpack_require__(5454));
	
	var _SignalCellularNoSim = _interopRequireDefault(__webpack_require__(5455));
	
	var _SignalCellularNoSimOutlined = _interopRequireDefault(__webpack_require__(5456));
	
	var _SignalCellularNoSimRounded = _interopRequireDefault(__webpack_require__(5457));
	
	var _SignalCellularNoSimSharp = _interopRequireDefault(__webpack_require__(5458));
	
	var _SignalCellularNoSimTwoTone = _interopRequireDefault(__webpack_require__(5459));
	
	var _SignalCellularNull = _interopRequireDefault(__webpack_require__(5460));
	
	var _SignalCellularNullOutlined = _interopRequireDefault(__webpack_require__(5461));
	
	var _SignalCellularNullRounded = _interopRequireDefault(__webpack_require__(5462));
	
	var _SignalCellularNullSharp = _interopRequireDefault(__webpack_require__(5463));
	
	var _SignalCellularNullTwoTone = _interopRequireDefault(__webpack_require__(5464));
	
	var _SignalCellularOff = _interopRequireDefault(__webpack_require__(5465));
	
	var _SignalCellularOffOutlined = _interopRequireDefault(__webpack_require__(5466));
	
	var _SignalCellularOffRounded = _interopRequireDefault(__webpack_require__(5467));
	
	var _SignalCellularOffSharp = _interopRequireDefault(__webpack_require__(5468));
	
	var _SignalCellularOffTwoTone = _interopRequireDefault(__webpack_require__(5469));
	
	var _SignalWifi0Bar = _interopRequireDefault(__webpack_require__(5470));
	
	var _SignalWifi0BarOutlined = _interopRequireDefault(__webpack_require__(5471));
	
	var _SignalWifi0BarRounded = _interopRequireDefault(__webpack_require__(5472));
	
	var _SignalWifi0BarSharp = _interopRequireDefault(__webpack_require__(5473));
	
	var _SignalWifi0BarTwoTone = _interopRequireDefault(__webpack_require__(5474));
	
	var _SignalWifi1Bar = _interopRequireDefault(__webpack_require__(5475));
	
	var _SignalWifi1BarLock = _interopRequireDefault(__webpack_require__(5476));
	
	var _SignalWifi1BarLockOutlined = _interopRequireDefault(__webpack_require__(5477));
	
	var _SignalWifi1BarLockRounded = _interopRequireDefault(__webpack_require__(5478));
	
	var _SignalWifi1BarLockSharp = _interopRequireDefault(__webpack_require__(5479));
	
	var _SignalWifi1BarLockTwoTone = _interopRequireDefault(__webpack_require__(5480));
	
	var _SignalWifi1BarOutlined = _interopRequireDefault(__webpack_require__(5481));
	
	var _SignalWifi1BarRounded = _interopRequireDefault(__webpack_require__(5482));
	
	var _SignalWifi1BarSharp = _interopRequireDefault(__webpack_require__(5483));
	
	var _SignalWifi1BarTwoTone = _interopRequireDefault(__webpack_require__(5484));
	
	var _SignalWifi2Bar = _interopRequireDefault(__webpack_require__(5485));
	
	var _SignalWifi2BarLock = _interopRequireDefault(__webpack_require__(5486));
	
	var _SignalWifi2BarLockOutlined = _interopRequireDefault(__webpack_require__(5487));
	
	var _SignalWifi2BarLockRounded = _interopRequireDefault(__webpack_require__(5488));
	
	var _SignalWifi2BarLockSharp = _interopRequireDefault(__webpack_require__(5489));
	
	var _SignalWifi2BarLockTwoTone = _interopRequireDefault(__webpack_require__(5490));
	
	var _SignalWifi2BarOutlined = _interopRequireDefault(__webpack_require__(5491));
	
	var _SignalWifi2BarRounded = _interopRequireDefault(__webpack_require__(5492));
	
	var _SignalWifi2BarSharp = _interopRequireDefault(__webpack_require__(5493));
	
	var _SignalWifi2BarTwoTone = _interopRequireDefault(__webpack_require__(5494));
	
	var _SignalWifi3Bar = _interopRequireDefault(__webpack_require__(5495));
	
	var _SignalWifi3BarLock = _interopRequireDefault(__webpack_require__(5496));
	
	var _SignalWifi3BarLockOutlined = _interopRequireDefault(__webpack_require__(5497));
	
	var _SignalWifi3BarLockRounded = _interopRequireDefault(__webpack_require__(5498));
	
	var _SignalWifi3BarLockSharp = _interopRequireDefault(__webpack_require__(5499));
	
	var _SignalWifi3BarLockTwoTone = _interopRequireDefault(__webpack_require__(5500));
	
	var _SignalWifi3BarOutlined = _interopRequireDefault(__webpack_require__(5501));
	
	var _SignalWifi3BarRounded = _interopRequireDefault(__webpack_require__(5502));
	
	var _SignalWifi3BarSharp = _interopRequireDefault(__webpack_require__(5503));
	
	var _SignalWifi3BarTwoTone = _interopRequireDefault(__webpack_require__(5504));
	
	var _SignalWifi4Bar = _interopRequireDefault(__webpack_require__(5505));
	
	var _SignalWifi4BarLock = _interopRequireDefault(__webpack_require__(5506));
	
	var _SignalWifi4BarLockOutlined = _interopRequireDefault(__webpack_require__(5507));
	
	var _SignalWifi4BarLockRounded = _interopRequireDefault(__webpack_require__(5508));
	
	var _SignalWifi4BarLockSharp = _interopRequireDefault(__webpack_require__(5509));
	
	var _SignalWifi4BarLockTwoTone = _interopRequireDefault(__webpack_require__(5510));
	
	var _SignalWifi4BarOutlined = _interopRequireDefault(__webpack_require__(5511));
	
	var _SignalWifi4BarRounded = _interopRequireDefault(__webpack_require__(5512));
	
	var _SignalWifi4BarSharp = _interopRequireDefault(__webpack_require__(5513));
	
	var _SignalWifi4BarTwoTone = _interopRequireDefault(__webpack_require__(5514));
	
	var _SignalWifiOff = _interopRequireDefault(__webpack_require__(5515));
	
	var _SignalWifiOffOutlined = _interopRequireDefault(__webpack_require__(5516));
	
	var _SignalWifiOffRounded = _interopRequireDefault(__webpack_require__(5517));
	
	var _SignalWifiOffSharp = _interopRequireDefault(__webpack_require__(5518));
	
	var _SignalWifiOffTwoTone = _interopRequireDefault(__webpack_require__(5519));
	
	var _SimCard = _interopRequireDefault(__webpack_require__(5520));
	
	var _SimCardOutlined = _interopRequireDefault(__webpack_require__(5521));
	
	var _SimCardRounded = _interopRequireDefault(__webpack_require__(5522));
	
	var _SimCardSharp = _interopRequireDefault(__webpack_require__(5523));
	
	var _SimCardTwoTone = _interopRequireDefault(__webpack_require__(5524));
	
	var _SingleBed = _interopRequireDefault(__webpack_require__(5525));
	
	var _SingleBedOutlined = _interopRequireDefault(__webpack_require__(5526));
	
	var _SingleBedRounded = _interopRequireDefault(__webpack_require__(5527));
	
	var _SingleBedSharp = _interopRequireDefault(__webpack_require__(5528));
	
	var _SingleBedTwoTone = _interopRequireDefault(__webpack_require__(5529));
	
	var _SkipNext = _interopRequireDefault(__webpack_require__(5530));
	
	var _SkipNextOutlined = _interopRequireDefault(__webpack_require__(5531));
	
	var _SkipNextRounded = _interopRequireDefault(__webpack_require__(5532));
	
	var _SkipNextSharp = _interopRequireDefault(__webpack_require__(5533));
	
	var _SkipNextTwoTone = _interopRequireDefault(__webpack_require__(5534));
	
	var _SkipPrevious = _interopRequireDefault(__webpack_require__(5535));
	
	var _SkipPreviousOutlined = _interopRequireDefault(__webpack_require__(5536));
	
	var _SkipPreviousRounded = _interopRequireDefault(__webpack_require__(5537));
	
	var _SkipPreviousSharp = _interopRequireDefault(__webpack_require__(5538));
	
	var _SkipPreviousTwoTone = _interopRequireDefault(__webpack_require__(5539));
	
	var _Slideshow = _interopRequireDefault(__webpack_require__(5540));
	
	var _SlideshowOutlined = _interopRequireDefault(__webpack_require__(5541));
	
	var _SlideshowRounded = _interopRequireDefault(__webpack_require__(5542));
	
	var _SlideshowSharp = _interopRequireDefault(__webpack_require__(5543));
	
	var _SlideshowTwoTone = _interopRequireDefault(__webpack_require__(5544));
	
	var _SlowMotionVideo = _interopRequireDefault(__webpack_require__(5545));
	
	var _SlowMotionVideoOutlined = _interopRequireDefault(__webpack_require__(5546));
	
	var _SlowMotionVideoRounded = _interopRequireDefault(__webpack_require__(5547));
	
	var _SlowMotionVideoSharp = _interopRequireDefault(__webpack_require__(5548));
	
	var _SlowMotionVideoTwoTone = _interopRequireDefault(__webpack_require__(5549));
	
	var _Smartphone = _interopRequireDefault(__webpack_require__(5550));
	
	var _SmartphoneOutlined = _interopRequireDefault(__webpack_require__(5551));
	
	var _SmartphoneRounded = _interopRequireDefault(__webpack_require__(5552));
	
	var _SmartphoneSharp = _interopRequireDefault(__webpack_require__(5553));
	
	var _SmartphoneTwoTone = _interopRequireDefault(__webpack_require__(5554));
	
	var _SmokeFree = _interopRequireDefault(__webpack_require__(5555));
	
	var _SmokeFreeOutlined = _interopRequireDefault(__webpack_require__(5556));
	
	var _SmokeFreeRounded = _interopRequireDefault(__webpack_require__(5557));
	
	var _SmokeFreeSharp = _interopRequireDefault(__webpack_require__(5558));
	
	var _SmokeFreeTwoTone = _interopRequireDefault(__webpack_require__(5559));
	
	var _SmokingRooms = _interopRequireDefault(__webpack_require__(5560));
	
	var _SmokingRoomsOutlined = _interopRequireDefault(__webpack_require__(5561));
	
	var _SmokingRoomsRounded = _interopRequireDefault(__webpack_require__(5562));
	
	var _SmokingRoomsSharp = _interopRequireDefault(__webpack_require__(5563));
	
	var _SmokingRoomsTwoTone = _interopRequireDefault(__webpack_require__(5564));
	
	var _Sms = _interopRequireDefault(__webpack_require__(5565));
	
	var _SmsFailed = _interopRequireDefault(__webpack_require__(5566));
	
	var _SmsFailedOutlined = _interopRequireDefault(__webpack_require__(5567));
	
	var _SmsFailedRounded = _interopRequireDefault(__webpack_require__(5568));
	
	var _SmsFailedSharp = _interopRequireDefault(__webpack_require__(5569));
	
	var _SmsFailedTwoTone = _interopRequireDefault(__webpack_require__(5570));
	
	var _SmsOutlined = _interopRequireDefault(__webpack_require__(5571));
	
	var _SmsRounded = _interopRequireDefault(__webpack_require__(5572));
	
	var _SmsSharp = _interopRequireDefault(__webpack_require__(5573));
	
	var _SmsTwoTone = _interopRequireDefault(__webpack_require__(5574));
	
	var _Snooze = _interopRequireDefault(__webpack_require__(5575));
	
	var _SnoozeOutlined = _interopRequireDefault(__webpack_require__(5576));
	
	var _SnoozeRounded = _interopRequireDefault(__webpack_require__(5577));
	
	var _SnoozeSharp = _interopRequireDefault(__webpack_require__(5578));
	
	var _SnoozeTwoTone = _interopRequireDefault(__webpack_require__(5579));
	
	var _Sort = _interopRequireDefault(__webpack_require__(5580));
	
	var _SortByAlpha = _interopRequireDefault(__webpack_require__(5581));
	
	var _SortByAlphaOutlined = _interopRequireDefault(__webpack_require__(5582));
	
	var _SortByAlphaRounded = _interopRequireDefault(__webpack_require__(5583));
	
	var _SortByAlphaSharp = _interopRequireDefault(__webpack_require__(5584));
	
	var _SortByAlphaTwoTone = _interopRequireDefault(__webpack_require__(5585));
	
	var _SortOutlined = _interopRequireDefault(__webpack_require__(5586));
	
	var _SortRounded = _interopRequireDefault(__webpack_require__(5587));
	
	var _SortSharp = _interopRequireDefault(__webpack_require__(5588));
	
	var _SortTwoTone = _interopRequireDefault(__webpack_require__(5589));
	
	var _Spa = _interopRequireDefault(__webpack_require__(5590));
	
	var _SpaceBar = _interopRequireDefault(__webpack_require__(5595));
	
	var _SpaceBarOutlined = _interopRequireDefault(__webpack_require__(5596));
	
	var _SpaceBarRounded = _interopRequireDefault(__webpack_require__(5597));
	
	var _SpaceBarSharp = _interopRequireDefault(__webpack_require__(5598));
	
	var _SpaceBarTwoTone = _interopRequireDefault(__webpack_require__(5599));
	
	var _SpaOutlined = _interopRequireDefault(__webpack_require__(5591));
	
	var _SpaRounded = _interopRequireDefault(__webpack_require__(5592));
	
	var _SpaSharp = _interopRequireDefault(__webpack_require__(5593));
	
	var _SpaTwoTone = _interopRequireDefault(__webpack_require__(5594));
	
	var _Speaker = _interopRequireDefault(__webpack_require__(5600));
	
	var _SpeakerGroup = _interopRequireDefault(__webpack_require__(5601));
	
	var _SpeakerGroupOutlined = _interopRequireDefault(__webpack_require__(5602));
	
	var _SpeakerGroupRounded = _interopRequireDefault(__webpack_require__(5603));
	
	var _SpeakerGroupSharp = _interopRequireDefault(__webpack_require__(5604));
	
	var _SpeakerGroupTwoTone = _interopRequireDefault(__webpack_require__(5605));
	
	var _SpeakerNotes = _interopRequireDefault(__webpack_require__(5606));
	
	var _SpeakerNotesOff = _interopRequireDefault(__webpack_require__(5607));
	
	var _SpeakerNotesOffOutlined = _interopRequireDefault(__webpack_require__(5608));
	
	var _SpeakerNotesOffRounded = _interopRequireDefault(__webpack_require__(5609));
	
	var _SpeakerNotesOffSharp = _interopRequireDefault(__webpack_require__(5610));
	
	var _SpeakerNotesOffTwoTone = _interopRequireDefault(__webpack_require__(5611));
	
	var _SpeakerNotesOutlined = _interopRequireDefault(__webpack_require__(5612));
	
	var _SpeakerNotesRounded = _interopRequireDefault(__webpack_require__(5613));
	
	var _SpeakerNotesSharp = _interopRequireDefault(__webpack_require__(5614));
	
	var _SpeakerNotesTwoTone = _interopRequireDefault(__webpack_require__(5615));
	
	var _SpeakerOutlined = _interopRequireDefault(__webpack_require__(5616));
	
	var _SpeakerPhone = _interopRequireDefault(__webpack_require__(5617));
	
	var _SpeakerPhoneOutlined = _interopRequireDefault(__webpack_require__(5618));
	
	var _SpeakerPhoneRounded = _interopRequireDefault(__webpack_require__(5619));
	
	var _SpeakerPhoneSharp = _interopRequireDefault(__webpack_require__(5620));
	
	var _SpeakerPhoneTwoTone = _interopRequireDefault(__webpack_require__(5621));
	
	var _SpeakerRounded = _interopRequireDefault(__webpack_require__(5622));
	
	var _SpeakerSharp = _interopRequireDefault(__webpack_require__(5623));
	
	var _SpeakerTwoTone = _interopRequireDefault(__webpack_require__(5624));
	
	var _Speed = _interopRequireDefault(__webpack_require__(5625));
	
	var _SpeedOutlined = _interopRequireDefault(__webpack_require__(5626));
	
	var _SpeedRounded = _interopRequireDefault(__webpack_require__(5627));
	
	var _SpeedSharp = _interopRequireDefault(__webpack_require__(5628));
	
	var _SpeedTwoTone = _interopRequireDefault(__webpack_require__(5629));
	
	var _Spellcheck = _interopRequireDefault(__webpack_require__(5630));
	
	var _SpellcheckOutlined = _interopRequireDefault(__webpack_require__(5631));
	
	var _SpellcheckRounded = _interopRequireDefault(__webpack_require__(5632));
	
	var _SpellcheckSharp = _interopRequireDefault(__webpack_require__(5633));
	
	var _SpellcheckTwoTone = _interopRequireDefault(__webpack_require__(5634));
	
	var _Sports = _interopRequireDefault(__webpack_require__(5635));
	
	var _SportsBaseball = _interopRequireDefault(__webpack_require__(5636));
	
	var _SportsBaseballOutlined = _interopRequireDefault(__webpack_require__(5637));
	
	var _SportsBaseballRounded = _interopRequireDefault(__webpack_require__(5638));
	
	var _SportsBaseballSharp = _interopRequireDefault(__webpack_require__(5639));
	
	var _SportsBaseballTwoTone = _interopRequireDefault(__webpack_require__(5640));
	
	var _SportsBasketball = _interopRequireDefault(__webpack_require__(5641));
	
	var _SportsBasketballOutlined = _interopRequireDefault(__webpack_require__(5642));
	
	var _SportsBasketballRounded = _interopRequireDefault(__webpack_require__(5643));
	
	var _SportsBasketballSharp = _interopRequireDefault(__webpack_require__(5644));
	
	var _SportsBasketballTwoTone = _interopRequireDefault(__webpack_require__(5645));
	
	var _SportsCricket = _interopRequireDefault(__webpack_require__(5646));
	
	var _SportsCricketOutlined = _interopRequireDefault(__webpack_require__(5647));
	
	var _SportsCricketRounded = _interopRequireDefault(__webpack_require__(5648));
	
	var _SportsCricketSharp = _interopRequireDefault(__webpack_require__(5649));
	
	var _SportsCricketTwoTone = _interopRequireDefault(__webpack_require__(5650));
	
	var _SportsEsports = _interopRequireDefault(__webpack_require__(5651));
	
	var _SportsEsportsOutlined = _interopRequireDefault(__webpack_require__(5652));
	
	var _SportsEsportsRounded = _interopRequireDefault(__webpack_require__(5653));
	
	var _SportsEsportsSharp = _interopRequireDefault(__webpack_require__(5654));
	
	var _SportsEsportsTwoTone = _interopRequireDefault(__webpack_require__(5655));
	
	var _SportsFootball = _interopRequireDefault(__webpack_require__(5656));
	
	var _SportsFootballOutlined = _interopRequireDefault(__webpack_require__(5657));
	
	var _SportsFootballRounded = _interopRequireDefault(__webpack_require__(5658));
	
	var _SportsFootballSharp = _interopRequireDefault(__webpack_require__(5659));
	
	var _SportsFootballTwoTone = _interopRequireDefault(__webpack_require__(5660));
	
	var _SportsGolf = _interopRequireDefault(__webpack_require__(5661));
	
	var _SportsGolfOutlined = _interopRequireDefault(__webpack_require__(5662));
	
	var _SportsGolfRounded = _interopRequireDefault(__webpack_require__(5663));
	
	var _SportsGolfSharp = _interopRequireDefault(__webpack_require__(5664));
	
	var _SportsGolfTwoTone = _interopRequireDefault(__webpack_require__(5665));
	
	var _SportsHandball = _interopRequireDefault(__webpack_require__(5666));
	
	var _SportsHandballOutlined = _interopRequireDefault(__webpack_require__(5667));
	
	var _SportsHandballRounded = _interopRequireDefault(__webpack_require__(5668));
	
	var _SportsHandballSharp = _interopRequireDefault(__webpack_require__(5669));
	
	var _SportsHandballTwoTone = _interopRequireDefault(__webpack_require__(5670));
	
	var _SportsHockey = _interopRequireDefault(__webpack_require__(5671));
	
	var _SportsHockeyOutlined = _interopRequireDefault(__webpack_require__(5672));
	
	var _SportsHockeyRounded = _interopRequireDefault(__webpack_require__(5673));
	
	var _SportsHockeySharp = _interopRequireDefault(__webpack_require__(5674));
	
	var _SportsHockeyTwoTone = _interopRequireDefault(__webpack_require__(5675));
	
	var _SportsKabaddi = _interopRequireDefault(__webpack_require__(5676));
	
	var _SportsKabaddiOutlined = _interopRequireDefault(__webpack_require__(5677));
	
	var _SportsKabaddiRounded = _interopRequireDefault(__webpack_require__(5678));
	
	var _SportsKabaddiSharp = _interopRequireDefault(__webpack_require__(5679));
	
	var _SportsKabaddiTwoTone = _interopRequireDefault(__webpack_require__(5680));
	
	var _SportsMma = _interopRequireDefault(__webpack_require__(5681));
	
	var _SportsMmaOutlined = _interopRequireDefault(__webpack_require__(5682));
	
	var _SportsMmaRounded = _interopRequireDefault(__webpack_require__(5683));
	
	var _SportsMmaSharp = _interopRequireDefault(__webpack_require__(5684));
	
	var _SportsMmaTwoTone = _interopRequireDefault(__webpack_require__(5685));
	
	var _SportsMotorsports = _interopRequireDefault(__webpack_require__(5686));
	
	var _SportsMotorsportsOutlined = _interopRequireDefault(__webpack_require__(5687));
	
	var _SportsMotorsportsRounded = _interopRequireDefault(__webpack_require__(5688));
	
	var _SportsMotorsportsSharp = _interopRequireDefault(__webpack_require__(5689));
	
	var _SportsMotorsportsTwoTone = _interopRequireDefault(__webpack_require__(5690));
	
	var _SportsOutlined = _interopRequireDefault(__webpack_require__(5691));
	
	var _SportsRounded = _interopRequireDefault(__webpack_require__(5692));
	
	var _SportsRugby = _interopRequireDefault(__webpack_require__(5693));
	
	var _SportsRugbyOutlined = _interopRequireDefault(__webpack_require__(5694));
	
	var _SportsRugbyRounded = _interopRequireDefault(__webpack_require__(5695));
	
	var _SportsRugbySharp = _interopRequireDefault(__webpack_require__(5696));
	
	var _SportsRugbyTwoTone = _interopRequireDefault(__webpack_require__(5697));
	
	var _SportsSharp = _interopRequireDefault(__webpack_require__(5698));
	
	var _SportsSoccer = _interopRequireDefault(__webpack_require__(5699));
	
	var _SportsSoccerOutlined = _interopRequireDefault(__webpack_require__(5700));
	
	var _SportsSoccerRounded = _interopRequireDefault(__webpack_require__(5701));
	
	var _SportsSoccerSharp = _interopRequireDefault(__webpack_require__(5702));
	
	var _SportsSoccerTwoTone = _interopRequireDefault(__webpack_require__(5703));
	
	var _SportsTennis = _interopRequireDefault(__webpack_require__(5704));
	
	var _SportsTennisOutlined = _interopRequireDefault(__webpack_require__(5705));
	
	var _SportsTennisRounded = _interopRequireDefault(__webpack_require__(5706));
	
	var _SportsTennisSharp = _interopRequireDefault(__webpack_require__(5707));
	
	var _SportsTennisTwoTone = _interopRequireDefault(__webpack_require__(5708));
	
	var _SportsTwoTone = _interopRequireDefault(__webpack_require__(5709));
	
	var _SportsVolleyball = _interopRequireDefault(__webpack_require__(5710));
	
	var _SportsVolleyballOutlined = _interopRequireDefault(__webpack_require__(5711));
	
	var _SportsVolleyballRounded = _interopRequireDefault(__webpack_require__(5712));
	
	var _SportsVolleyballSharp = _interopRequireDefault(__webpack_require__(5713));
	
	var _SportsVolleyballTwoTone = _interopRequireDefault(__webpack_require__(5714));
	
	var _SquareFoot = _interopRequireDefault(__webpack_require__(5715));
	
	var _SquareFootOutlined = _interopRequireDefault(__webpack_require__(5716));
	
	var _SquareFootRounded = _interopRequireDefault(__webpack_require__(5717));
	
	var _SquareFootSharp = _interopRequireDefault(__webpack_require__(5718));
	
	var _SquareFootTwoTone = _interopRequireDefault(__webpack_require__(5719));
	
	var _Star = _interopRequireDefault(__webpack_require__(5720));
	
	var _StarBorder = _interopRequireDefault(__webpack_require__(5721));
	
	var _StarBorderOutlined = _interopRequireDefault(__webpack_require__(5722));
	
	var _StarBorderRounded = _interopRequireDefault(__webpack_require__(5723));
	
	var _StarBorderSharp = _interopRequireDefault(__webpack_require__(5724));
	
	var _StarBorderTwoTone = _interopRequireDefault(__webpack_require__(5725));
	
	var _StarHalf = _interopRequireDefault(__webpack_require__(5726));
	
	var _StarHalfOutlined = _interopRequireDefault(__webpack_require__(5727));
	
	var _StarHalfRounded = _interopRequireDefault(__webpack_require__(5728));
	
	var _StarHalfSharp = _interopRequireDefault(__webpack_require__(5729));
	
	var _StarHalfTwoTone = _interopRequireDefault(__webpack_require__(5730));
	
	var _StarOutlined = _interopRequireDefault(__webpack_require__(5731));
	
	var _StarRate = _interopRequireDefault(__webpack_require__(5732));
	
	var _StarRateOutlined = _interopRequireDefault(__webpack_require__(5733));
	
	var _StarRateRounded = _interopRequireDefault(__webpack_require__(5734));
	
	var _StarRateSharp = _interopRequireDefault(__webpack_require__(5735));
	
	var _StarRateTwoTone = _interopRequireDefault(__webpack_require__(5736));
	
	var _StarRounded = _interopRequireDefault(__webpack_require__(5737));
	
	var _Stars = _interopRequireDefault(__webpack_require__(5740));
	
	var _StarSharp = _interopRequireDefault(__webpack_require__(5738));
	
	var _StarsOutlined = _interopRequireDefault(__webpack_require__(5741));
	
	var _StarsRounded = _interopRequireDefault(__webpack_require__(5742));
	
	var _StarsSharp = _interopRequireDefault(__webpack_require__(5743));
	
	var _StarsTwoTone = _interopRequireDefault(__webpack_require__(5744));
	
	var _StarTwoTone = _interopRequireDefault(__webpack_require__(5739));
	
	var _StayCurrentLandscape = _interopRequireDefault(__webpack_require__(5745));
	
	var _StayCurrentLandscapeOutlined = _interopRequireDefault(__webpack_require__(5746));
	
	var _StayCurrentLandscapeRounded = _interopRequireDefault(__webpack_require__(5747));
	
	var _StayCurrentLandscapeSharp = _interopRequireDefault(__webpack_require__(5748));
	
	var _StayCurrentLandscapeTwoTone = _interopRequireDefault(__webpack_require__(5749));
	
	var _StayCurrentPortrait = _interopRequireDefault(__webpack_require__(5750));
	
	var _StayCurrentPortraitOutlined = _interopRequireDefault(__webpack_require__(5751));
	
	var _StayCurrentPortraitRounded = _interopRequireDefault(__webpack_require__(5752));
	
	var _StayCurrentPortraitSharp = _interopRequireDefault(__webpack_require__(5753));
	
	var _StayCurrentPortraitTwoTone = _interopRequireDefault(__webpack_require__(5754));
	
	var _StayPrimaryLandscape = _interopRequireDefault(__webpack_require__(5755));
	
	var _StayPrimaryLandscapeOutlined = _interopRequireDefault(__webpack_require__(5756));
	
	var _StayPrimaryLandscapeRounded = _interopRequireDefault(__webpack_require__(5757));
	
	var _StayPrimaryLandscapeSharp = _interopRequireDefault(__webpack_require__(5758));
	
	var _StayPrimaryLandscapeTwoTone = _interopRequireDefault(__webpack_require__(5759));
	
	var _StayPrimaryPortrait = _interopRequireDefault(__webpack_require__(5760));
	
	var _StayPrimaryPortraitOutlined = _interopRequireDefault(__webpack_require__(5761));
	
	var _StayPrimaryPortraitRounded = _interopRequireDefault(__webpack_require__(5762));
	
	var _StayPrimaryPortraitSharp = _interopRequireDefault(__webpack_require__(5763));
	
	var _StayPrimaryPortraitTwoTone = _interopRequireDefault(__webpack_require__(5764));
	
	var _Stop = _interopRequireDefault(__webpack_require__(5765));
	
	var _StopOutlined = _interopRequireDefault(__webpack_require__(5766));
	
	var _StopRounded = _interopRequireDefault(__webpack_require__(5767));
	
	var _StopScreenShare = _interopRequireDefault(__webpack_require__(5768));
	
	var _StopScreenShareOutlined = _interopRequireDefault(__webpack_require__(5769));
	
	var _StopScreenShareRounded = _interopRequireDefault(__webpack_require__(5770));
	
	var _StopScreenShareSharp = _interopRequireDefault(__webpack_require__(5771));
	
	var _StopScreenShareTwoTone = _interopRequireDefault(__webpack_require__(5772));
	
	var _StopSharp = _interopRequireDefault(__webpack_require__(5773));
	
	var _StopTwoTone = _interopRequireDefault(__webpack_require__(5774));
	
	var _Storage = _interopRequireDefault(__webpack_require__(5775));
	
	var _StorageOutlined = _interopRequireDefault(__webpack_require__(5776));
	
	var _StorageRounded = _interopRequireDefault(__webpack_require__(5777));
	
	var _StorageSharp = _interopRequireDefault(__webpack_require__(5778));
	
	var _StorageTwoTone = _interopRequireDefault(__webpack_require__(5779));
	
	var _Store = _interopRequireDefault(__webpack_require__(5780));
	
	var _Storefront = _interopRequireDefault(__webpack_require__(5790));
	
	var _StorefrontOutlined = _interopRequireDefault(__webpack_require__(5791));
	
	var _StorefrontRounded = _interopRequireDefault(__webpack_require__(5792));
	
	var _StorefrontSharp = _interopRequireDefault(__webpack_require__(5793));
	
	var _StorefrontTwoTone = _interopRequireDefault(__webpack_require__(5794));
	
	var _StoreMallDirectory = _interopRequireDefault(__webpack_require__(5781));
	
	var _StoreMallDirectoryOutlined = _interopRequireDefault(__webpack_require__(5782));
	
	var _StoreMallDirectoryRounded = _interopRequireDefault(__webpack_require__(5783));
	
	var _StoreMallDirectorySharp = _interopRequireDefault(__webpack_require__(5784));
	
	var _StoreMallDirectoryTwoTone = _interopRequireDefault(__webpack_require__(5785));
	
	var _StoreOutlined = _interopRequireDefault(__webpack_require__(5786));
	
	var _StoreRounded = _interopRequireDefault(__webpack_require__(5787));
	
	var _StoreSharp = _interopRequireDefault(__webpack_require__(5788));
	
	var _StoreTwoTone = _interopRequireDefault(__webpack_require__(5789));
	
	var _Straighten = _interopRequireDefault(__webpack_require__(5795));
	
	var _StraightenOutlined = _interopRequireDefault(__webpack_require__(5796));
	
	var _StraightenRounded = _interopRequireDefault(__webpack_require__(5797));
	
	var _StraightenSharp = _interopRequireDefault(__webpack_require__(5798));
	
	var _StraightenTwoTone = _interopRequireDefault(__webpack_require__(5799));
	
	var _Streetview = _interopRequireDefault(__webpack_require__(5800));
	
	var _StreetviewOutlined = _interopRequireDefault(__webpack_require__(5801));
	
	var _StreetviewRounded = _interopRequireDefault(__webpack_require__(5802));
	
	var _StreetviewSharp = _interopRequireDefault(__webpack_require__(5803));
	
	var _StreetviewTwoTone = _interopRequireDefault(__webpack_require__(5804));
	
	var _StrikethroughS = _interopRequireDefault(__webpack_require__(5805));
	
	var _StrikethroughSOutlined = _interopRequireDefault(__webpack_require__(5806));
	
	var _StrikethroughSRounded = _interopRequireDefault(__webpack_require__(5807));
	
	var _StrikethroughSSharp = _interopRequireDefault(__webpack_require__(5808));
	
	var _StrikethroughSTwoTone = _interopRequireDefault(__webpack_require__(5809));
	
	var _Style = _interopRequireDefault(__webpack_require__(5810));
	
	var _StyleOutlined = _interopRequireDefault(__webpack_require__(5811));
	
	var _StyleRounded = _interopRequireDefault(__webpack_require__(5812));
	
	var _StyleSharp = _interopRequireDefault(__webpack_require__(5813));
	
	var _StyleTwoTone = _interopRequireDefault(__webpack_require__(5814));
	
	var _SubdirectoryArrowLeft = _interopRequireDefault(__webpack_require__(5815));
	
	var _SubdirectoryArrowLeftOutlined = _interopRequireDefault(__webpack_require__(5816));
	
	var _SubdirectoryArrowLeftRounded = _interopRequireDefault(__webpack_require__(5817));
	
	var _SubdirectoryArrowLeftSharp = _interopRequireDefault(__webpack_require__(5818));
	
	var _SubdirectoryArrowLeftTwoTone = _interopRequireDefault(__webpack_require__(5819));
	
	var _SubdirectoryArrowRight = _interopRequireDefault(__webpack_require__(5820));
	
	var _SubdirectoryArrowRightOutlined = _interopRequireDefault(__webpack_require__(5821));
	
	var _SubdirectoryArrowRightRounded = _interopRequireDefault(__webpack_require__(5822));
	
	var _SubdirectoryArrowRightSharp = _interopRequireDefault(__webpack_require__(5823));
	
	var _SubdirectoryArrowRightTwoTone = _interopRequireDefault(__webpack_require__(5824));
	
	var _Subject = _interopRequireDefault(__webpack_require__(5825));
	
	var _SubjectOutlined = _interopRequireDefault(__webpack_require__(5826));
	
	var _SubjectRounded = _interopRequireDefault(__webpack_require__(5827));
	
	var _SubjectSharp = _interopRequireDefault(__webpack_require__(5828));
	
	var _SubjectTwoTone = _interopRequireDefault(__webpack_require__(5829));
	
	var _Subscriptions = _interopRequireDefault(__webpack_require__(5830));
	
	var _SubscriptionsOutlined = _interopRequireDefault(__webpack_require__(5831));
	
	var _SubscriptionsRounded = _interopRequireDefault(__webpack_require__(5832));
	
	var _SubscriptionsSharp = _interopRequireDefault(__webpack_require__(5833));
	
	var _SubscriptionsTwoTone = _interopRequireDefault(__webpack_require__(5834));
	
	var _Subtitles = _interopRequireDefault(__webpack_require__(5835));
	
	var _SubtitlesOutlined = _interopRequireDefault(__webpack_require__(5836));
	
	var _SubtitlesRounded = _interopRequireDefault(__webpack_require__(5837));
	
	var _SubtitlesSharp = _interopRequireDefault(__webpack_require__(5838));
	
	var _SubtitlesTwoTone = _interopRequireDefault(__webpack_require__(5839));
	
	var _Subway = _interopRequireDefault(__webpack_require__(5840));
	
	var _SubwayOutlined = _interopRequireDefault(__webpack_require__(5841));
	
	var _SubwayRounded = _interopRequireDefault(__webpack_require__(5842));
	
	var _SubwaySharp = _interopRequireDefault(__webpack_require__(5843));
	
	var _SubwayTwoTone = _interopRequireDefault(__webpack_require__(5844));
	
	var _SupervisedUserCircle = _interopRequireDefault(__webpack_require__(5845));
	
	var _SupervisedUserCircleOutlined = _interopRequireDefault(__webpack_require__(5846));
	
	var _SupervisedUserCircleRounded = _interopRequireDefault(__webpack_require__(5847));
	
	var _SupervisedUserCircleSharp = _interopRequireDefault(__webpack_require__(5848));
	
	var _SupervisedUserCircleTwoTone = _interopRequireDefault(__webpack_require__(5849));
	
	var _SupervisorAccount = _interopRequireDefault(__webpack_require__(5850));
	
	var _SupervisorAccountOutlined = _interopRequireDefault(__webpack_require__(5851));
	
	var _SupervisorAccountRounded = _interopRequireDefault(__webpack_require__(5852));
	
	var _SupervisorAccountSharp = _interopRequireDefault(__webpack_require__(5853));
	
	var _SupervisorAccountTwoTone = _interopRequireDefault(__webpack_require__(5854));
	
	var _SurroundSound = _interopRequireDefault(__webpack_require__(5855));
	
	var _SurroundSoundOutlined = _interopRequireDefault(__webpack_require__(5856));
	
	var _SurroundSoundRounded = _interopRequireDefault(__webpack_require__(5857));
	
	var _SurroundSoundSharp = _interopRequireDefault(__webpack_require__(5858));
	
	var _SurroundSoundTwoTone = _interopRequireDefault(__webpack_require__(5859));
	
	var _SwapCalls = _interopRequireDefault(__webpack_require__(5860));
	
	var _SwapCallsOutlined = _interopRequireDefault(__webpack_require__(5861));
	
	var _SwapCallsRounded = _interopRequireDefault(__webpack_require__(5862));
	
	var _SwapCallsSharp = _interopRequireDefault(__webpack_require__(5863));
	
	var _SwapCallsTwoTone = _interopRequireDefault(__webpack_require__(5864));
	
	var _SwapHoriz = _interopRequireDefault(__webpack_require__(5865));
	
	var _SwapHorizontalCircle = _interopRequireDefault(__webpack_require__(5870));
	
	var _SwapHorizontalCircleOutlined = _interopRequireDefault(__webpack_require__(5871));
	
	var _SwapHorizontalCircleRounded = _interopRequireDefault(__webpack_require__(5872));
	
	var _SwapHorizontalCircleSharp = _interopRequireDefault(__webpack_require__(5873));
	
	var _SwapHorizontalCircleTwoTone = _interopRequireDefault(__webpack_require__(5874));
	
	var _SwapHorizOutlined = _interopRequireDefault(__webpack_require__(5866));
	
	var _SwapHorizRounded = _interopRequireDefault(__webpack_require__(5867));
	
	var _SwapHorizSharp = _interopRequireDefault(__webpack_require__(5868));
	
	var _SwapHorizTwoTone = _interopRequireDefault(__webpack_require__(5869));
	
	var _SwapVert = _interopRequireDefault(__webpack_require__(5875));
	
	var _SwapVerticalCircle = _interopRequireDefault(__webpack_require__(5880));
	
	var _SwapVerticalCircleOutlined = _interopRequireDefault(__webpack_require__(5881));
	
	var _SwapVerticalCircleRounded = _interopRequireDefault(__webpack_require__(5882));
	
	var _SwapVerticalCircleSharp = _interopRequireDefault(__webpack_require__(5883));
	
	var _SwapVerticalCircleTwoTone = _interopRequireDefault(__webpack_require__(5884));
	
	var _SwapVertOutlined = _interopRequireDefault(__webpack_require__(5876));
	
	var _SwapVertRounded = _interopRequireDefault(__webpack_require__(5877));
	
	var _SwapVertSharp = _interopRequireDefault(__webpack_require__(5878));
	
	var _SwapVertTwoTone = _interopRequireDefault(__webpack_require__(5879));
	
	var _SwitchCamera = _interopRequireDefault(__webpack_require__(5885));
	
	var _SwitchCameraOutlined = _interopRequireDefault(__webpack_require__(5886));
	
	var _SwitchCameraRounded = _interopRequireDefault(__webpack_require__(5887));
	
	var _SwitchCameraSharp = _interopRequireDefault(__webpack_require__(5888));
	
	var _SwitchCameraTwoTone = _interopRequireDefault(__webpack_require__(5889));
	
	var _SwitchVideo = _interopRequireDefault(__webpack_require__(5890));
	
	var _SwitchVideoOutlined = _interopRequireDefault(__webpack_require__(5891));
	
	var _SwitchVideoRounded = _interopRequireDefault(__webpack_require__(5892));
	
	var _SwitchVideoSharp = _interopRequireDefault(__webpack_require__(5893));
	
	var _SwitchVideoTwoTone = _interopRequireDefault(__webpack_require__(5894));
	
	var _Sync = _interopRequireDefault(__webpack_require__(5895));
	
	var _SyncAlt = _interopRequireDefault(__webpack_require__(5896));
	
	var _SyncAltOutlined = _interopRequireDefault(__webpack_require__(5897));
	
	var _SyncAltRounded = _interopRequireDefault(__webpack_require__(5898));
	
	var _SyncAltSharp = _interopRequireDefault(__webpack_require__(5899));
	
	var _SyncAltTwoTone = _interopRequireDefault(__webpack_require__(5900));
	
	var _SyncDisabled = _interopRequireDefault(__webpack_require__(5901));
	
	var _SyncDisabledOutlined = _interopRequireDefault(__webpack_require__(5902));
	
	var _SyncDisabledRounded = _interopRequireDefault(__webpack_require__(5903));
	
	var _SyncDisabledSharp = _interopRequireDefault(__webpack_require__(5904));
	
	var _SyncDisabledTwoTone = _interopRequireDefault(__webpack_require__(5905));
	
	var _SyncOutlined = _interopRequireDefault(__webpack_require__(5906));
	
	var _SyncProblem = _interopRequireDefault(__webpack_require__(5907));
	
	var _SyncProblemOutlined = _interopRequireDefault(__webpack_require__(5908));
	
	var _SyncProblemRounded = _interopRequireDefault(__webpack_require__(5909));
	
	var _SyncProblemSharp = _interopRequireDefault(__webpack_require__(5910));
	
	var _SyncProblemTwoTone = _interopRequireDefault(__webpack_require__(5911));
	
	var _SyncRounded = _interopRequireDefault(__webpack_require__(5912));
	
	var _SyncSharp = _interopRequireDefault(__webpack_require__(5913));
	
	var _SyncTwoTone = _interopRequireDefault(__webpack_require__(5914));
	
	var _SystemUpdate = _interopRequireDefault(__webpack_require__(5915));
	
	var _SystemUpdateAlt = _interopRequireDefault(__webpack_require__(5916));
	
	var _SystemUpdateAltOutlined = _interopRequireDefault(__webpack_require__(5917));
	
	var _SystemUpdateAltRounded = _interopRequireDefault(__webpack_require__(5918));
	
	var _SystemUpdateAltSharp = _interopRequireDefault(__webpack_require__(5919));
	
	var _SystemUpdateAltTwoTone = _interopRequireDefault(__webpack_require__(5920));
	
	var _SystemUpdateOutlined = _interopRequireDefault(__webpack_require__(5921));
	
	var _SystemUpdateRounded = _interopRequireDefault(__webpack_require__(5922));
	
	var _SystemUpdateSharp = _interopRequireDefault(__webpack_require__(5923));
	
	var _SystemUpdateTwoTone = _interopRequireDefault(__webpack_require__(5924));
	
	var _Tab = _interopRequireDefault(__webpack_require__(5925));
	
	var _TableChart = _interopRequireDefault(__webpack_require__(5935));
	
	var _TableChartOutlined = _interopRequireDefault(__webpack_require__(5936));
	
	var _TableChartRounded = _interopRequireDefault(__webpack_require__(5937));
	
	var _TableChartSharp = _interopRequireDefault(__webpack_require__(5938));
	
	var _TableChartTwoTone = _interopRequireDefault(__webpack_require__(5939));
	
	var _Tablet = _interopRequireDefault(__webpack_require__(5940));
	
	var _TabletAndroid = _interopRequireDefault(__webpack_require__(5941));
	
	var _TabletAndroidOutlined = _interopRequireDefault(__webpack_require__(5942));
	
	var _TabletAndroidRounded = _interopRequireDefault(__webpack_require__(5943));
	
	var _TabletAndroidSharp = _interopRequireDefault(__webpack_require__(5944));
	
	var _TabletAndroidTwoTone = _interopRequireDefault(__webpack_require__(5945));
	
	var _TabletMac = _interopRequireDefault(__webpack_require__(5946));
	
	var _TabletMacOutlined = _interopRequireDefault(__webpack_require__(5947));
	
	var _TabletMacRounded = _interopRequireDefault(__webpack_require__(5948));
	
	var _TabletMacSharp = _interopRequireDefault(__webpack_require__(5949));
	
	var _TabletMacTwoTone = _interopRequireDefault(__webpack_require__(5950));
	
	var _TabletOutlined = _interopRequireDefault(__webpack_require__(5951));
	
	var _TabletRounded = _interopRequireDefault(__webpack_require__(5952));
	
	var _TabletSharp = _interopRequireDefault(__webpack_require__(5953));
	
	var _TabletTwoTone = _interopRequireDefault(__webpack_require__(5954));
	
	var _TabOutlined = _interopRequireDefault(__webpack_require__(5926));
	
	var _TabRounded = _interopRequireDefault(__webpack_require__(5927));
	
	var _TabSharp = _interopRequireDefault(__webpack_require__(5928));
	
	var _TabTwoTone = _interopRequireDefault(__webpack_require__(5929));
	
	var _TabUnselected = _interopRequireDefault(__webpack_require__(5930));
	
	var _TabUnselectedOutlined = _interopRequireDefault(__webpack_require__(5931));
	
	var _TabUnselectedRounded = _interopRequireDefault(__webpack_require__(5932));
	
	var _TabUnselectedSharp = _interopRequireDefault(__webpack_require__(5933));
	
	var _TabUnselectedTwoTone = _interopRequireDefault(__webpack_require__(5934));
	
	var _TagFaces = _interopRequireDefault(__webpack_require__(5955));
	
	var _TagFacesOutlined = _interopRequireDefault(__webpack_require__(5956));
	
	var _TagFacesRounded = _interopRequireDefault(__webpack_require__(5957));
	
	var _TagFacesSharp = _interopRequireDefault(__webpack_require__(5958));
	
	var _TagFacesTwoTone = _interopRequireDefault(__webpack_require__(5959));
	
	var _TapAndPlay = _interopRequireDefault(__webpack_require__(5960));
	
	var _TapAndPlayOutlined = _interopRequireDefault(__webpack_require__(5961));
	
	var _TapAndPlayRounded = _interopRequireDefault(__webpack_require__(5962));
	
	var _TapAndPlaySharp = _interopRequireDefault(__webpack_require__(5963));
	
	var _TapAndPlayTwoTone = _interopRequireDefault(__webpack_require__(5964));
	
	var _Telegram = _interopRequireDefault(__webpack_require__(5965));
	
	var _Terrain = _interopRequireDefault(__webpack_require__(5966));
	
	var _TerrainOutlined = _interopRequireDefault(__webpack_require__(5967));
	
	var _TerrainRounded = _interopRequireDefault(__webpack_require__(5968));
	
	var _TerrainSharp = _interopRequireDefault(__webpack_require__(5969));
	
	var _TerrainTwoTone = _interopRequireDefault(__webpack_require__(5970));
	
	var _TextFields = _interopRequireDefault(__webpack_require__(5971));
	
	var _TextFieldsOutlined = _interopRequireDefault(__webpack_require__(5972));
	
	var _TextFieldsRounded = _interopRequireDefault(__webpack_require__(5973));
	
	var _TextFieldsSharp = _interopRequireDefault(__webpack_require__(5974));
	
	var _TextFieldsTwoTone = _interopRequireDefault(__webpack_require__(5975));
	
	var _TextFormat = _interopRequireDefault(__webpack_require__(5976));
	
	var _TextFormatOutlined = _interopRequireDefault(__webpack_require__(5977));
	
	var _TextFormatRounded = _interopRequireDefault(__webpack_require__(5978));
	
	var _TextFormatSharp = _interopRequireDefault(__webpack_require__(5979));
	
	var _TextFormatTwoTone = _interopRequireDefault(__webpack_require__(5980));
	
	var _TextRotateUp = _interopRequireDefault(__webpack_require__(5981));
	
	var _TextRotateUpOutlined = _interopRequireDefault(__webpack_require__(5982));
	
	var _TextRotateUpRounded = _interopRequireDefault(__webpack_require__(5983));
	
	var _TextRotateUpSharp = _interopRequireDefault(__webpack_require__(5984));
	
	var _TextRotateUpTwoTone = _interopRequireDefault(__webpack_require__(5985));
	
	var _TextRotateVertical = _interopRequireDefault(__webpack_require__(5986));
	
	var _TextRotateVerticalOutlined = _interopRequireDefault(__webpack_require__(5987));
	
	var _TextRotateVerticalRounded = _interopRequireDefault(__webpack_require__(5988));
	
	var _TextRotateVerticalSharp = _interopRequireDefault(__webpack_require__(5989));
	
	var _TextRotateVerticalTwoTone = _interopRequireDefault(__webpack_require__(5990));
	
	var _TextRotationAngledown = _interopRequireDefault(__webpack_require__(5991));
	
	var _TextRotationAngledownOutlined = _interopRequireDefault(__webpack_require__(5992));
	
	var _TextRotationAngledownRounded = _interopRequireDefault(__webpack_require__(5993));
	
	var _TextRotationAngledownSharp = _interopRequireDefault(__webpack_require__(5994));
	
	var _TextRotationAngledownTwoTone = _interopRequireDefault(__webpack_require__(5995));
	
	var _TextRotationAngleup = _interopRequireDefault(__webpack_require__(5996));
	
	var _TextRotationAngleupOutlined = _interopRequireDefault(__webpack_require__(5997));
	
	var _TextRotationAngleupRounded = _interopRequireDefault(__webpack_require__(5998));
	
	var _TextRotationAngleupSharp = _interopRequireDefault(__webpack_require__(5999));
	
	var _TextRotationAngleupTwoTone = _interopRequireDefault(__webpack_require__(6000));
	
	var _TextRotationDown = _interopRequireDefault(__webpack_require__(6001));
	
	var _TextRotationDownOutlined = _interopRequireDefault(__webpack_require__(6002));
	
	var _TextRotationDownRounded = _interopRequireDefault(__webpack_require__(6003));
	
	var _TextRotationDownSharp = _interopRequireDefault(__webpack_require__(6004));
	
	var _TextRotationDownTwoTone = _interopRequireDefault(__webpack_require__(6005));
	
	var _TextRotationNone = _interopRequireDefault(__webpack_require__(6006));
	
	var _TextRotationNoneOutlined = _interopRequireDefault(__webpack_require__(6007));
	
	var _TextRotationNoneRounded = _interopRequireDefault(__webpack_require__(6008));
	
	var _TextRotationNoneSharp = _interopRequireDefault(__webpack_require__(6009));
	
	var _TextRotationNoneTwoTone = _interopRequireDefault(__webpack_require__(6010));
	
	var _Textsms = _interopRequireDefault(__webpack_require__(6011));
	
	var _TextsmsOutlined = _interopRequireDefault(__webpack_require__(6012));
	
	var _TextsmsRounded = _interopRequireDefault(__webpack_require__(6013));
	
	var _TextsmsSharp = _interopRequireDefault(__webpack_require__(6014));
	
	var _TextsmsTwoTone = _interopRequireDefault(__webpack_require__(6015));
	
	var _Texture = _interopRequireDefault(__webpack_require__(6016));
	
	var _TextureOutlined = _interopRequireDefault(__webpack_require__(6017));
	
	var _TextureRounded = _interopRequireDefault(__webpack_require__(6018));
	
	var _TextureSharp = _interopRequireDefault(__webpack_require__(6019));
	
	var _TextureTwoTone = _interopRequireDefault(__webpack_require__(6020));
	
	var _Theaters = _interopRequireDefault(__webpack_require__(6021));
	
	var _TheatersOutlined = _interopRequireDefault(__webpack_require__(6022));
	
	var _TheatersRounded = _interopRequireDefault(__webpack_require__(6023));
	
	var _TheatersSharp = _interopRequireDefault(__webpack_require__(6024));
	
	var _TheatersTwoTone = _interopRequireDefault(__webpack_require__(6025));
	
	var _ThreeDRotation = _interopRequireDefault(__webpack_require__(6026));
	
	var _ThreeDRotationOutlined = _interopRequireDefault(__webpack_require__(6027));
	
	var _ThreeDRotationRounded = _interopRequireDefault(__webpack_require__(6028));
	
	var _ThreeDRotationSharp = _interopRequireDefault(__webpack_require__(6029));
	
	var _ThreeDRotationTwoTone = _interopRequireDefault(__webpack_require__(6030));
	
	var _ThreeSixty = _interopRequireDefault(__webpack_require__(6031));
	
	var _ThreeSixtyOutlined = _interopRequireDefault(__webpack_require__(6032));
	
	var _ThreeSixtyRounded = _interopRequireDefault(__webpack_require__(6033));
	
	var _ThreeSixtySharp = _interopRequireDefault(__webpack_require__(6034));
	
	var _ThreeSixtyTwoTone = _interopRequireDefault(__webpack_require__(6035));
	
	var _ThumbDown = _interopRequireDefault(__webpack_require__(6036));
	
	var _ThumbDownAlt = _interopRequireDefault(__webpack_require__(6037));
	
	var _ThumbDownAltOutlined = _interopRequireDefault(__webpack_require__(6038));
	
	var _ThumbDownAltRounded = _interopRequireDefault(__webpack_require__(6039));
	
	var _ThumbDownAltSharp = _interopRequireDefault(__webpack_require__(6040));
	
	var _ThumbDownAltTwoTone = _interopRequireDefault(__webpack_require__(6041));
	
	var _ThumbDownOutlined = _interopRequireDefault(__webpack_require__(6042));
	
	var _ThumbDownRounded = _interopRequireDefault(__webpack_require__(6043));
	
	var _ThumbDownSharp = _interopRequireDefault(__webpack_require__(6044));
	
	var _ThumbDownTwoTone = _interopRequireDefault(__webpack_require__(6045));
	
	var _ThumbsUpDown = _interopRequireDefault(__webpack_require__(6056));
	
	var _ThumbsUpDownOutlined = _interopRequireDefault(__webpack_require__(6057));
	
	var _ThumbsUpDownRounded = _interopRequireDefault(__webpack_require__(6058));
	
	var _ThumbsUpDownSharp = _interopRequireDefault(__webpack_require__(6059));
	
	var _ThumbsUpDownTwoTone = _interopRequireDefault(__webpack_require__(6060));
	
	var _ThumbUp = _interopRequireDefault(__webpack_require__(6046));
	
	var _ThumbUpAlt = _interopRequireDefault(__webpack_require__(6047));
	
	var _ThumbUpAltOutlined = _interopRequireDefault(__webpack_require__(6048));
	
	var _ThumbUpAltRounded = _interopRequireDefault(__webpack_require__(6049));
	
	var _ThumbUpAltSharp = _interopRequireDefault(__webpack_require__(6050));
	
	var _ThumbUpAltTwoTone = _interopRequireDefault(__webpack_require__(6051));
	
	var _ThumbUpOutlined = _interopRequireDefault(__webpack_require__(6052));
	
	var _ThumbUpRounded = _interopRequireDefault(__webpack_require__(6053));
	
	var _ThumbUpSharp = _interopRequireDefault(__webpack_require__(6054));
	
	var _ThumbUpTwoTone = _interopRequireDefault(__webpack_require__(6055));
	
	var _Timelapse = _interopRequireDefault(__webpack_require__(6066));
	
	var _TimelapseOutlined = _interopRequireDefault(__webpack_require__(6067));
	
	var _TimelapseRounded = _interopRequireDefault(__webpack_require__(6068));
	
	var _TimelapseSharp = _interopRequireDefault(__webpack_require__(6069));
	
	var _TimelapseTwoTone = _interopRequireDefault(__webpack_require__(6070));
	
	var _Timeline = _interopRequireDefault(__webpack_require__(6071));
	
	var _TimelineOutlined = _interopRequireDefault(__webpack_require__(6072));
	
	var _TimelineRounded = _interopRequireDefault(__webpack_require__(6073));
	
	var _TimelineSharp = _interopRequireDefault(__webpack_require__(6074));
	
	var _TimelineTwoTone = _interopRequireDefault(__webpack_require__(6075));
	
	var _Timer = _interopRequireDefault(__webpack_require__(6076));
	
	var _Timer2 = _interopRequireDefault(__webpack_require__(6077));
	
	var _Timer10Outlined = _interopRequireDefault(__webpack_require__(6078));
	
	var _Timer10Rounded = _interopRequireDefault(__webpack_require__(6079));
	
	var _Timer10Sharp = _interopRequireDefault(__webpack_require__(6080));
	
	var _Timer10TwoTone = _interopRequireDefault(__webpack_require__(6081));
	
	var _Timer3 = _interopRequireDefault(__webpack_require__(6082));
	
	var _Timer3Outlined = _interopRequireDefault(__webpack_require__(6083));
	
	var _Timer3Rounded = _interopRequireDefault(__webpack_require__(6084));
	
	var _Timer3Sharp = _interopRequireDefault(__webpack_require__(6085));
	
	var _Timer3TwoTone = _interopRequireDefault(__webpack_require__(6086));
	
	var _TimerOff = _interopRequireDefault(__webpack_require__(6087));
	
	var _TimerOffOutlined = _interopRequireDefault(__webpack_require__(6088));
	
	var _TimerOffRounded = _interopRequireDefault(__webpack_require__(6089));
	
	var _TimerOffSharp = _interopRequireDefault(__webpack_require__(6090));
	
	var _TimerOffTwoTone = _interopRequireDefault(__webpack_require__(6091));
	
	var _TimerOutlined = _interopRequireDefault(__webpack_require__(6092));
	
	var _TimerRounded = _interopRequireDefault(__webpack_require__(6093));
	
	var _TimerSharp = _interopRequireDefault(__webpack_require__(6094));
	
	var _TimerTwoTone = _interopRequireDefault(__webpack_require__(6095));
	
	var _TimeToLeave = _interopRequireDefault(__webpack_require__(6061));
	
	var _TimeToLeaveOutlined = _interopRequireDefault(__webpack_require__(6062));
	
	var _TimeToLeaveRounded = _interopRequireDefault(__webpack_require__(6063));
	
	var _TimeToLeaveSharp = _interopRequireDefault(__webpack_require__(6064));
	
	var _TimeToLeaveTwoTone = _interopRequireDefault(__webpack_require__(6065));
	
	var _Title = _interopRequireDefault(__webpack_require__(6096));
	
	var _TitleOutlined = _interopRequireDefault(__webpack_require__(6097));
	
	var _TitleRounded = _interopRequireDefault(__webpack_require__(6098));
	
	var _TitleSharp = _interopRequireDefault(__webpack_require__(6099));
	
	var _TitleTwoTone = _interopRequireDefault(__webpack_require__(6100));
	
	var _Toc = _interopRequireDefault(__webpack_require__(6101));
	
	var _TocOutlined = _interopRequireDefault(__webpack_require__(6102));
	
	var _TocRounded = _interopRequireDefault(__webpack_require__(6103));
	
	var _TocSharp = _interopRequireDefault(__webpack_require__(6104));
	
	var _TocTwoTone = _interopRequireDefault(__webpack_require__(6105));
	
	var _Today = _interopRequireDefault(__webpack_require__(6106));
	
	var _TodayOutlined = _interopRequireDefault(__webpack_require__(6107));
	
	var _TodayRounded = _interopRequireDefault(__webpack_require__(6108));
	
	var _TodaySharp = _interopRequireDefault(__webpack_require__(6109));
	
	var _TodayTwoTone = _interopRequireDefault(__webpack_require__(6110));
	
	var _ToggleOff = _interopRequireDefault(__webpack_require__(6111));
	
	var _ToggleOffOutlined = _interopRequireDefault(__webpack_require__(6112));
	
	var _ToggleOffRounded = _interopRequireDefault(__webpack_require__(6113));
	
	var _ToggleOffSharp = _interopRequireDefault(__webpack_require__(6114));
	
	var _ToggleOffTwoTone = _interopRequireDefault(__webpack_require__(6115));
	
	var _ToggleOn = _interopRequireDefault(__webpack_require__(6116));
	
	var _ToggleOnOutlined = _interopRequireDefault(__webpack_require__(6117));
	
	var _ToggleOnRounded = _interopRequireDefault(__webpack_require__(6118));
	
	var _ToggleOnSharp = _interopRequireDefault(__webpack_require__(6119));
	
	var _ToggleOnTwoTone = _interopRequireDefault(__webpack_require__(6120));
	
	var _Toll = _interopRequireDefault(__webpack_require__(6121));
	
	var _TollOutlined = _interopRequireDefault(__webpack_require__(6122));
	
	var _TollRounded = _interopRequireDefault(__webpack_require__(6123));
	
	var _TollSharp = _interopRequireDefault(__webpack_require__(6124));
	
	var _TollTwoTone = _interopRequireDefault(__webpack_require__(6125));
	
	var _Tonality = _interopRequireDefault(__webpack_require__(6126));
	
	var _TonalityOutlined = _interopRequireDefault(__webpack_require__(6127));
	
	var _TonalityRounded = _interopRequireDefault(__webpack_require__(6128));
	
	var _TonalitySharp = _interopRequireDefault(__webpack_require__(6129));
	
	var _TonalityTwoTone = _interopRequireDefault(__webpack_require__(6130));
	
	var _TouchApp = _interopRequireDefault(__webpack_require__(6131));
	
	var _TouchAppOutlined = _interopRequireDefault(__webpack_require__(6132));
	
	var _TouchAppRounded = _interopRequireDefault(__webpack_require__(6133));
	
	var _TouchAppSharp = _interopRequireDefault(__webpack_require__(6134));
	
	var _TouchAppTwoTone = _interopRequireDefault(__webpack_require__(6135));
	
	var _Toys = _interopRequireDefault(__webpack_require__(6136));
	
	var _ToysOutlined = _interopRequireDefault(__webpack_require__(6137));
	
	var _ToysRounded = _interopRequireDefault(__webpack_require__(6138));
	
	var _ToysSharp = _interopRequireDefault(__webpack_require__(6139));
	
	var _ToysTwoTone = _interopRequireDefault(__webpack_require__(6140));
	
	var _TrackChanges = _interopRequireDefault(__webpack_require__(6141));
	
	var _TrackChangesOutlined = _interopRequireDefault(__webpack_require__(6142));
	
	var _TrackChangesRounded = _interopRequireDefault(__webpack_require__(6143));
	
	var _TrackChangesSharp = _interopRequireDefault(__webpack_require__(6144));
	
	var _TrackChangesTwoTone = _interopRequireDefault(__webpack_require__(6145));
	
	var _Traffic = _interopRequireDefault(__webpack_require__(6146));
	
	var _TrafficOutlined = _interopRequireDefault(__webpack_require__(6147));
	
	var _TrafficRounded = _interopRequireDefault(__webpack_require__(6148));
	
	var _TrafficSharp = _interopRequireDefault(__webpack_require__(6149));
	
	var _TrafficTwoTone = _interopRequireDefault(__webpack_require__(6150));
	
	var _Train = _interopRequireDefault(__webpack_require__(6151));
	
	var _TrainOutlined = _interopRequireDefault(__webpack_require__(6152));
	
	var _TrainRounded = _interopRequireDefault(__webpack_require__(6153));
	
	var _TrainSharp = _interopRequireDefault(__webpack_require__(6154));
	
	var _TrainTwoTone = _interopRequireDefault(__webpack_require__(6155));
	
	var _Tram = _interopRequireDefault(__webpack_require__(6156));
	
	var _TramOutlined = _interopRequireDefault(__webpack_require__(6157));
	
	var _TramRounded = _interopRequireDefault(__webpack_require__(6158));
	
	var _TramSharp = _interopRequireDefault(__webpack_require__(6159));
	
	var _TramTwoTone = _interopRequireDefault(__webpack_require__(6160));
	
	var _TransferWithinAStation = _interopRequireDefault(__webpack_require__(6161));
	
	var _TransferWithinAStationOutlined = _interopRequireDefault(__webpack_require__(6162));
	
	var _TransferWithinAStationRounded = _interopRequireDefault(__webpack_require__(6163));
	
	var _TransferWithinAStationSharp = _interopRequireDefault(__webpack_require__(6164));
	
	var _TransferWithinAStationTwoTone = _interopRequireDefault(__webpack_require__(6165));
	
	var _Transform = _interopRequireDefault(__webpack_require__(6166));
	
	var _TransformOutlined = _interopRequireDefault(__webpack_require__(6167));
	
	var _TransformRounded = _interopRequireDefault(__webpack_require__(6168));
	
	var _TransformSharp = _interopRequireDefault(__webpack_require__(6169));
	
	var _TransformTwoTone = _interopRequireDefault(__webpack_require__(6170));
	
	var _TransitEnterexit = _interopRequireDefault(__webpack_require__(6171));
	
	var _TransitEnterexitOutlined = _interopRequireDefault(__webpack_require__(6172));
	
	var _TransitEnterexitRounded = _interopRequireDefault(__webpack_require__(6173));
	
	var _TransitEnterexitSharp = _interopRequireDefault(__webpack_require__(6174));
	
	var _TransitEnterexitTwoTone = _interopRequireDefault(__webpack_require__(6175));
	
	var _Translate = _interopRequireDefault(__webpack_require__(6176));
	
	var _TranslateOutlined = _interopRequireDefault(__webpack_require__(6177));
	
	var _TranslateRounded = _interopRequireDefault(__webpack_require__(6178));
	
	var _TranslateSharp = _interopRequireDefault(__webpack_require__(6179));
	
	var _TranslateTwoTone = _interopRequireDefault(__webpack_require__(6180));
	
	var _TrendingDown = _interopRequireDefault(__webpack_require__(6181));
	
	var _TrendingDownOutlined = _interopRequireDefault(__webpack_require__(6182));
	
	var _TrendingDownRounded = _interopRequireDefault(__webpack_require__(6183));
	
	var _TrendingDownSharp = _interopRequireDefault(__webpack_require__(6184));
	
	var _TrendingDownTwoTone = _interopRequireDefault(__webpack_require__(6185));
	
	var _TrendingFlat = _interopRequireDefault(__webpack_require__(6186));
	
	var _TrendingFlatOutlined = _interopRequireDefault(__webpack_require__(6187));
	
	var _TrendingFlatRounded = _interopRequireDefault(__webpack_require__(6188));
	
	var _TrendingFlatSharp = _interopRequireDefault(__webpack_require__(6189));
	
	var _TrendingFlatTwoTone = _interopRequireDefault(__webpack_require__(6190));
	
	var _TrendingUp = _interopRequireDefault(__webpack_require__(6191));
	
	var _TrendingUpOutlined = _interopRequireDefault(__webpack_require__(6192));
	
	var _TrendingUpRounded = _interopRequireDefault(__webpack_require__(6193));
	
	var _TrendingUpSharp = _interopRequireDefault(__webpack_require__(6194));
	
	var _TrendingUpTwoTone = _interopRequireDefault(__webpack_require__(6195));
	
	var _TripOrigin = _interopRequireDefault(__webpack_require__(6196));
	
	var _TripOriginOutlined = _interopRequireDefault(__webpack_require__(6197));
	
	var _TripOriginRounded = _interopRequireDefault(__webpack_require__(6198));
	
	var _TripOriginSharp = _interopRequireDefault(__webpack_require__(6199));
	
	var _TripOriginTwoTone = _interopRequireDefault(__webpack_require__(6200));
	
	var _Tune = _interopRequireDefault(__webpack_require__(6201));
	
	var _TuneOutlined = _interopRequireDefault(__webpack_require__(6202));
	
	var _TuneRounded = _interopRequireDefault(__webpack_require__(6203));
	
	var _TuneSharp = _interopRequireDefault(__webpack_require__(6204));
	
	var _TuneTwoTone = _interopRequireDefault(__webpack_require__(6205));
	
	var _TurnedIn = _interopRequireDefault(__webpack_require__(6206));
	
	var _TurnedInNot = _interopRequireDefault(__webpack_require__(6207));
	
	var _TurnedInNotOutlined = _interopRequireDefault(__webpack_require__(6208));
	
	var _TurnedInNotRounded = _interopRequireDefault(__webpack_require__(6209));
	
	var _TurnedInNotSharp = _interopRequireDefault(__webpack_require__(6210));
	
	var _TurnedInNotTwoTone = _interopRequireDefault(__webpack_require__(6211));
	
	var _TurnedInOutlined = _interopRequireDefault(__webpack_require__(6212));
	
	var _TurnedInRounded = _interopRequireDefault(__webpack_require__(6213));
	
	var _TurnedInSharp = _interopRequireDefault(__webpack_require__(6214));
	
	var _TurnedInTwoTone = _interopRequireDefault(__webpack_require__(6215));
	
	var _Tv = _interopRequireDefault(__webpack_require__(6216));
	
	var _TvOff = _interopRequireDefault(__webpack_require__(6217));
	
	var _TvOffOutlined = _interopRequireDefault(__webpack_require__(6218));
	
	var _TvOffRounded = _interopRequireDefault(__webpack_require__(6219));
	
	var _TvOffSharp = _interopRequireDefault(__webpack_require__(6220));
	
	var _TvOffTwoTone = _interopRequireDefault(__webpack_require__(6221));
	
	var _TvOutlined = _interopRequireDefault(__webpack_require__(6222));
	
	var _TvRounded = _interopRequireDefault(__webpack_require__(6223));
	
	var _TvSharp = _interopRequireDefault(__webpack_require__(6224));
	
	var _TvTwoTone = _interopRequireDefault(__webpack_require__(6225));
	
	var _Twitter = _interopRequireDefault(__webpack_require__(6226));
	
	var _Unarchive = _interopRequireDefault(__webpack_require__(6227));
	
	var _UnarchiveOutlined = _interopRequireDefault(__webpack_require__(6228));
	
	var _UnarchiveRounded = _interopRequireDefault(__webpack_require__(6229));
	
	var _UnarchiveSharp = _interopRequireDefault(__webpack_require__(6230));
	
	var _UnarchiveTwoTone = _interopRequireDefault(__webpack_require__(6231));
	
	var _Undo = _interopRequireDefault(__webpack_require__(6232));
	
	var _UndoOutlined = _interopRequireDefault(__webpack_require__(6233));
	
	var _UndoRounded = _interopRequireDefault(__webpack_require__(6234));
	
	var _UndoSharp = _interopRequireDefault(__webpack_require__(6235));
	
	var _UndoTwoTone = _interopRequireDefault(__webpack_require__(6236));
	
	var _UnfoldLess = _interopRequireDefault(__webpack_require__(6237));
	
	var _UnfoldLessOutlined = _interopRequireDefault(__webpack_require__(6238));
	
	var _UnfoldLessRounded = _interopRequireDefault(__webpack_require__(6239));
	
	var _UnfoldLessSharp = _interopRequireDefault(__webpack_require__(6240));
	
	var _UnfoldLessTwoTone = _interopRequireDefault(__webpack_require__(6241));
	
	var _UnfoldMore = _interopRequireDefault(__webpack_require__(6242));
	
	var _UnfoldMoreOutlined = _interopRequireDefault(__webpack_require__(6243));
	
	var _UnfoldMoreRounded = _interopRequireDefault(__webpack_require__(6244));
	
	var _UnfoldMoreSharp = _interopRequireDefault(__webpack_require__(6245));
	
	var _UnfoldMoreTwoTone = _interopRequireDefault(__webpack_require__(6246));
	
	var _Unsubscribe = _interopRequireDefault(__webpack_require__(6247));
	
	var _UnsubscribeOutlined = _interopRequireDefault(__webpack_require__(6248));
	
	var _UnsubscribeRounded = _interopRequireDefault(__webpack_require__(6249));
	
	var _UnsubscribeSharp = _interopRequireDefault(__webpack_require__(6250));
	
	var _UnsubscribeTwoTone = _interopRequireDefault(__webpack_require__(6251));
	
	var _Update = _interopRequireDefault(__webpack_require__(6252));
	
	var _UpdateOutlined = _interopRequireDefault(__webpack_require__(6253));
	
	var _UpdateRounded = _interopRequireDefault(__webpack_require__(6254));
	
	var _UpdateSharp = _interopRequireDefault(__webpack_require__(6255));
	
	var _UpdateTwoTone = _interopRequireDefault(__webpack_require__(6256));
	
	var _Usb = _interopRequireDefault(__webpack_require__(6257));
	
	var _UsbOutlined = _interopRequireDefault(__webpack_require__(6258));
	
	var _UsbRounded = _interopRequireDefault(__webpack_require__(6259));
	
	var _UsbSharp = _interopRequireDefault(__webpack_require__(6260));
	
	var _UsbTwoTone = _interopRequireDefault(__webpack_require__(6261));
	
	var _VerifiedUser = _interopRequireDefault(__webpack_require__(6262));
	
	var _VerifiedUserOutlined = _interopRequireDefault(__webpack_require__(6263));
	
	var _VerifiedUserRounded = _interopRequireDefault(__webpack_require__(6264));
	
	var _VerifiedUserSharp = _interopRequireDefault(__webpack_require__(6265));
	
	var _VerifiedUserTwoTone = _interopRequireDefault(__webpack_require__(6266));
	
	var _VerticalAlignBottom = _interopRequireDefault(__webpack_require__(6267));
	
	var _VerticalAlignBottomOutlined = _interopRequireDefault(__webpack_require__(6268));
	
	var _VerticalAlignBottomRounded = _interopRequireDefault(__webpack_require__(6269));
	
	var _VerticalAlignBottomSharp = _interopRequireDefault(__webpack_require__(6270));
	
	var _VerticalAlignBottomTwoTone = _interopRequireDefault(__webpack_require__(6271));
	
	var _VerticalAlignCenter = _interopRequireDefault(__webpack_require__(6272));
	
	var _VerticalAlignCenterOutlined = _interopRequireDefault(__webpack_require__(6273));
	
	var _VerticalAlignCenterRounded = _interopRequireDefault(__webpack_require__(6274));
	
	var _VerticalAlignCenterSharp = _interopRequireDefault(__webpack_require__(6275));
	
	var _VerticalAlignCenterTwoTone = _interopRequireDefault(__webpack_require__(6276));
	
	var _VerticalAlignTop = _interopRequireDefault(__webpack_require__(6277));
	
	var _VerticalAlignTopOutlined = _interopRequireDefault(__webpack_require__(6278));
	
	var _VerticalAlignTopRounded = _interopRequireDefault(__webpack_require__(6279));
	
	var _VerticalAlignTopSharp = _interopRequireDefault(__webpack_require__(6280));
	
	var _VerticalAlignTopTwoTone = _interopRequireDefault(__webpack_require__(6281));
	
	var _VerticalSplit = _interopRequireDefault(__webpack_require__(6282));
	
	var _VerticalSplitOutlined = _interopRequireDefault(__webpack_require__(6283));
	
	var _VerticalSplitRounded = _interopRequireDefault(__webpack_require__(6284));
	
	var _VerticalSplitSharp = _interopRequireDefault(__webpack_require__(6285));
	
	var _VerticalSplitTwoTone = _interopRequireDefault(__webpack_require__(6286));
	
	var _Vibration = _interopRequireDefault(__webpack_require__(6287));
	
	var _VibrationOutlined = _interopRequireDefault(__webpack_require__(6288));
	
	var _VibrationRounded = _interopRequireDefault(__webpack_require__(6289));
	
	var _VibrationSharp = _interopRequireDefault(__webpack_require__(6290));
	
	var _VibrationTwoTone = _interopRequireDefault(__webpack_require__(6291));
	
	var _VideoCall = _interopRequireDefault(__webpack_require__(6292));
	
	var _VideoCallOutlined = _interopRequireDefault(__webpack_require__(6293));
	
	var _VideoCallRounded = _interopRequireDefault(__webpack_require__(6294));
	
	var _VideoCallSharp = _interopRequireDefault(__webpack_require__(6295));
	
	var _VideoCallTwoTone = _interopRequireDefault(__webpack_require__(6296));
	
	var _Videocam = _interopRequireDefault(__webpack_require__(6307));
	
	var _VideocamOff = _interopRequireDefault(__webpack_require__(6308));
	
	var _VideocamOffOutlined = _interopRequireDefault(__webpack_require__(6309));
	
	var _VideocamOffRounded = _interopRequireDefault(__webpack_require__(6310));
	
	var _VideocamOffSharp = _interopRequireDefault(__webpack_require__(6311));
	
	var _VideocamOffTwoTone = _interopRequireDefault(__webpack_require__(6312));
	
	var _VideocamOutlined = _interopRequireDefault(__webpack_require__(6313));
	
	var _VideocamRounded = _interopRequireDefault(__webpack_require__(6314));
	
	var _VideocamSharp = _interopRequireDefault(__webpack_require__(6315));
	
	var _VideocamTwoTone = _interopRequireDefault(__webpack_require__(6316));
	
	var _VideogameAsset = _interopRequireDefault(__webpack_require__(6317));
	
	var _VideogameAssetOutlined = _interopRequireDefault(__webpack_require__(6318));
	
	var _VideogameAssetRounded = _interopRequireDefault(__webpack_require__(6319));
	
	var _VideogameAssetSharp = _interopRequireDefault(__webpack_require__(6320));
	
	var _VideogameAssetTwoTone = _interopRequireDefault(__webpack_require__(6321));
	
	var _VideoLabel = _interopRequireDefault(__webpack_require__(6297));
	
	var _VideoLabelOutlined = _interopRequireDefault(__webpack_require__(6298));
	
	var _VideoLabelRounded = _interopRequireDefault(__webpack_require__(6299));
	
	var _VideoLabelSharp = _interopRequireDefault(__webpack_require__(6300));
	
	var _VideoLabelTwoTone = _interopRequireDefault(__webpack_require__(6301));
	
	var _VideoLibrary = _interopRequireDefault(__webpack_require__(6302));
	
	var _VideoLibraryOutlined = _interopRequireDefault(__webpack_require__(6303));
	
	var _VideoLibraryRounded = _interopRequireDefault(__webpack_require__(6304));
	
	var _VideoLibrarySharp = _interopRequireDefault(__webpack_require__(6305));
	
	var _VideoLibraryTwoTone = _interopRequireDefault(__webpack_require__(6306));
	
	var _ViewAgenda = _interopRequireDefault(__webpack_require__(6322));
	
	var _ViewAgendaOutlined = _interopRequireDefault(__webpack_require__(6323));
	
	var _ViewAgendaRounded = _interopRequireDefault(__webpack_require__(6324));
	
	var _ViewAgendaSharp = _interopRequireDefault(__webpack_require__(6325));
	
	var _ViewAgendaTwoTone = _interopRequireDefault(__webpack_require__(6326));
	
	var _ViewArray = _interopRequireDefault(__webpack_require__(6327));
	
	var _ViewArrayOutlined = _interopRequireDefault(__webpack_require__(6328));
	
	var _ViewArrayRounded = _interopRequireDefault(__webpack_require__(6329));
	
	var _ViewArraySharp = _interopRequireDefault(__webpack_require__(6330));
	
	var _ViewArrayTwoTone = _interopRequireDefault(__webpack_require__(6331));
	
	var _ViewCarousel = _interopRequireDefault(__webpack_require__(6332));
	
	var _ViewCarouselOutlined = _interopRequireDefault(__webpack_require__(6333));
	
	var _ViewCarouselRounded = _interopRequireDefault(__webpack_require__(6334));
	
	var _ViewCarouselSharp = _interopRequireDefault(__webpack_require__(6335));
	
	var _ViewCarouselTwoTone = _interopRequireDefault(__webpack_require__(6336));
	
	var _ViewColumn = _interopRequireDefault(__webpack_require__(6337));
	
	var _ViewColumnOutlined = _interopRequireDefault(__webpack_require__(6338));
	
	var _ViewColumnRounded = _interopRequireDefault(__webpack_require__(6339));
	
	var _ViewColumnSharp = _interopRequireDefault(__webpack_require__(6340));
	
	var _ViewColumnTwoTone = _interopRequireDefault(__webpack_require__(6341));
	
	var _ViewComfy = _interopRequireDefault(__webpack_require__(6342));
	
	var _ViewComfyOutlined = _interopRequireDefault(__webpack_require__(6343));
	
	var _ViewComfyRounded = _interopRequireDefault(__webpack_require__(6344));
	
	var _ViewComfySharp = _interopRequireDefault(__webpack_require__(6345));
	
	var _ViewComfyTwoTone = _interopRequireDefault(__webpack_require__(6346));
	
	var _ViewCompact = _interopRequireDefault(__webpack_require__(6347));
	
	var _ViewCompactOutlined = _interopRequireDefault(__webpack_require__(6348));
	
	var _ViewCompactRounded = _interopRequireDefault(__webpack_require__(6349));
	
	var _ViewCompactSharp = _interopRequireDefault(__webpack_require__(6350));
	
	var _ViewCompactTwoTone = _interopRequireDefault(__webpack_require__(6351));
	
	var _ViewDay = _interopRequireDefault(__webpack_require__(6352));
	
	var _ViewDayOutlined = _interopRequireDefault(__webpack_require__(6353));
	
	var _ViewDayRounded = _interopRequireDefault(__webpack_require__(6354));
	
	var _ViewDaySharp = _interopRequireDefault(__webpack_require__(6355));
	
	var _ViewDayTwoTone = _interopRequireDefault(__webpack_require__(6356));
	
	var _ViewHeadline = _interopRequireDefault(__webpack_require__(6357));
	
	var _ViewHeadlineOutlined = _interopRequireDefault(__webpack_require__(6358));
	
	var _ViewHeadlineRounded = _interopRequireDefault(__webpack_require__(6359));
	
	var _ViewHeadlineSharp = _interopRequireDefault(__webpack_require__(6360));
	
	var _ViewHeadlineTwoTone = _interopRequireDefault(__webpack_require__(6361));
	
	var _ViewList = _interopRequireDefault(__webpack_require__(6362));
	
	var _ViewListOutlined = _interopRequireDefault(__webpack_require__(6363));
	
	var _ViewListRounded = _interopRequireDefault(__webpack_require__(6364));
	
	var _ViewListSharp = _interopRequireDefault(__webpack_require__(6365));
	
	var _ViewListTwoTone = _interopRequireDefault(__webpack_require__(6366));
	
	var _ViewModule = _interopRequireDefault(__webpack_require__(6367));
	
	var _ViewModuleOutlined = _interopRequireDefault(__webpack_require__(6368));
	
	var _ViewModuleRounded = _interopRequireDefault(__webpack_require__(6369));
	
	var _ViewModuleSharp = _interopRequireDefault(__webpack_require__(6370));
	
	var _ViewModuleTwoTone = _interopRequireDefault(__webpack_require__(6371));
	
	var _ViewQuilt = _interopRequireDefault(__webpack_require__(6372));
	
	var _ViewQuiltOutlined = _interopRequireDefault(__webpack_require__(6373));
	
	var _ViewQuiltRounded = _interopRequireDefault(__webpack_require__(6374));
	
	var _ViewQuiltSharp = _interopRequireDefault(__webpack_require__(6375));
	
	var _ViewQuiltTwoTone = _interopRequireDefault(__webpack_require__(6376));
	
	var _ViewStream = _interopRequireDefault(__webpack_require__(6377));
	
	var _ViewStreamOutlined = _interopRequireDefault(__webpack_require__(6378));
	
	var _ViewStreamRounded = _interopRequireDefault(__webpack_require__(6379));
	
	var _ViewStreamSharp = _interopRequireDefault(__webpack_require__(6380));
	
	var _ViewStreamTwoTone = _interopRequireDefault(__webpack_require__(6381));
	
	var _ViewWeek = _interopRequireDefault(__webpack_require__(6382));
	
	var _ViewWeekOutlined = _interopRequireDefault(__webpack_require__(6383));
	
	var _ViewWeekRounded = _interopRequireDefault(__webpack_require__(6384));
	
	var _ViewWeekSharp = _interopRequireDefault(__webpack_require__(6385));
	
	var _ViewWeekTwoTone = _interopRequireDefault(__webpack_require__(6386));
	
	var _Vignette = _interopRequireDefault(__webpack_require__(6387));
	
	var _VignetteOutlined = _interopRequireDefault(__webpack_require__(6388));
	
	var _VignetteRounded = _interopRequireDefault(__webpack_require__(6389));
	
	var _VignetteSharp = _interopRequireDefault(__webpack_require__(6390));
	
	var _VignetteTwoTone = _interopRequireDefault(__webpack_require__(6391));
	
	var _Visibility = _interopRequireDefault(__webpack_require__(6392));
	
	var _VisibilityOff = _interopRequireDefault(__webpack_require__(6393));
	
	var _VisibilityOffOutlined = _interopRequireDefault(__webpack_require__(6394));
	
	var _VisibilityOffRounded = _interopRequireDefault(__webpack_require__(6395));
	
	var _VisibilityOffSharp = _interopRequireDefault(__webpack_require__(6396));
	
	var _VisibilityOffTwoTone = _interopRequireDefault(__webpack_require__(6397));
	
	var _VisibilityOutlined = _interopRequireDefault(__webpack_require__(6398));
	
	var _VisibilityRounded = _interopRequireDefault(__webpack_require__(6399));
	
	var _VisibilitySharp = _interopRequireDefault(__webpack_require__(6400));
	
	var _VisibilityTwoTone = _interopRequireDefault(__webpack_require__(6401));
	
	var _VoiceChat = _interopRequireDefault(__webpack_require__(6402));
	
	var _VoiceChatOutlined = _interopRequireDefault(__webpack_require__(6403));
	
	var _VoiceChatRounded = _interopRequireDefault(__webpack_require__(6404));
	
	var _VoiceChatSharp = _interopRequireDefault(__webpack_require__(6405));
	
	var _VoiceChatTwoTone = _interopRequireDefault(__webpack_require__(6406));
	
	var _Voicemail = _interopRequireDefault(__webpack_require__(6412));
	
	var _VoicemailOutlined = _interopRequireDefault(__webpack_require__(6413));
	
	var _VoicemailRounded = _interopRequireDefault(__webpack_require__(6414));
	
	var _VoicemailSharp = _interopRequireDefault(__webpack_require__(6415));
	
	var _VoicemailTwoTone = _interopRequireDefault(__webpack_require__(6416));
	
	var _VoiceOverOff = _interopRequireDefault(__webpack_require__(6407));
	
	var _VoiceOverOffOutlined = _interopRequireDefault(__webpack_require__(6408));
	
	var _VoiceOverOffRounded = _interopRequireDefault(__webpack_require__(6409));
	
	var _VoiceOverOffSharp = _interopRequireDefault(__webpack_require__(6410));
	
	var _VoiceOverOffTwoTone = _interopRequireDefault(__webpack_require__(6411));
	
	var _VolumeDown = _interopRequireDefault(__webpack_require__(6417));
	
	var _VolumeDownOutlined = _interopRequireDefault(__webpack_require__(6418));
	
	var _VolumeDownRounded = _interopRequireDefault(__webpack_require__(6419));
	
	var _VolumeDownSharp = _interopRequireDefault(__webpack_require__(6420));
	
	var _VolumeDownTwoTone = _interopRequireDefault(__webpack_require__(6421));
	
	var _VolumeMute = _interopRequireDefault(__webpack_require__(6422));
	
	var _VolumeMuteOutlined = _interopRequireDefault(__webpack_require__(6423));
	
	var _VolumeMuteRounded = _interopRequireDefault(__webpack_require__(6424));
	
	var _VolumeMuteSharp = _interopRequireDefault(__webpack_require__(6425));
	
	var _VolumeMuteTwoTone = _interopRequireDefault(__webpack_require__(6426));
	
	var _VolumeOff = _interopRequireDefault(__webpack_require__(6427));
	
	var _VolumeOffOutlined = _interopRequireDefault(__webpack_require__(6428));
	
	var _VolumeOffRounded = _interopRequireDefault(__webpack_require__(6429));
	
	var _VolumeOffSharp = _interopRequireDefault(__webpack_require__(6430));
	
	var _VolumeOffTwoTone = _interopRequireDefault(__webpack_require__(6431));
	
	var _VolumeUp = _interopRequireDefault(__webpack_require__(6432));
	
	var _VolumeUpOutlined = _interopRequireDefault(__webpack_require__(6433));
	
	var _VolumeUpRounded = _interopRequireDefault(__webpack_require__(6434));
	
	var _VolumeUpSharp = _interopRequireDefault(__webpack_require__(6435));
	
	var _VolumeUpTwoTone = _interopRequireDefault(__webpack_require__(6436));
	
	var _VpnKey = _interopRequireDefault(__webpack_require__(6437));
	
	var _VpnKeyOutlined = _interopRequireDefault(__webpack_require__(6438));
	
	var _VpnKeyRounded = _interopRequireDefault(__webpack_require__(6439));
	
	var _VpnKeySharp = _interopRequireDefault(__webpack_require__(6440));
	
	var _VpnKeyTwoTone = _interopRequireDefault(__webpack_require__(6441));
	
	var _VpnLock = _interopRequireDefault(__webpack_require__(6442));
	
	var _VpnLockOutlined = _interopRequireDefault(__webpack_require__(6443));
	
	var _VpnLockRounded = _interopRequireDefault(__webpack_require__(6444));
	
	var _VpnLockSharp = _interopRequireDefault(__webpack_require__(6445));
	
	var _VpnLockTwoTone = _interopRequireDefault(__webpack_require__(6446));
	
	var _Wallpaper = _interopRequireDefault(__webpack_require__(6447));
	
	var _WallpaperOutlined = _interopRequireDefault(__webpack_require__(6448));
	
	var _WallpaperRounded = _interopRequireDefault(__webpack_require__(6449));
	
	var _WallpaperSharp = _interopRequireDefault(__webpack_require__(6450));
	
	var _WallpaperTwoTone = _interopRequireDefault(__webpack_require__(6451));
	
	var _Warning = _interopRequireDefault(__webpack_require__(6452));
	
	var _WarningOutlined = _interopRequireDefault(__webpack_require__(6453));
	
	var _WarningRounded = _interopRequireDefault(__webpack_require__(6454));
	
	var _WarningSharp = _interopRequireDefault(__webpack_require__(6455));
	
	var _WarningTwoTone = _interopRequireDefault(__webpack_require__(6456));
	
	var _Watch = _interopRequireDefault(__webpack_require__(6457));
	
	var _WatchLater = _interopRequireDefault(__webpack_require__(6458));
	
	var _WatchLaterOutlined = _interopRequireDefault(__webpack_require__(6459));
	
	var _WatchLaterRounded = _interopRequireDefault(__webpack_require__(6460));
	
	var _WatchLaterSharp = _interopRequireDefault(__webpack_require__(6461));
	
	var _WatchLaterTwoTone = _interopRequireDefault(__webpack_require__(6462));
	
	var _WatchOutlined = _interopRequireDefault(__webpack_require__(6463));
	
	var _WatchRounded = _interopRequireDefault(__webpack_require__(6464));
	
	var _WatchSharp = _interopRequireDefault(__webpack_require__(6465));
	
	var _WatchTwoTone = _interopRequireDefault(__webpack_require__(6466));
	
	var _Waves = _interopRequireDefault(__webpack_require__(6467));
	
	var _WavesOutlined = _interopRequireDefault(__webpack_require__(6468));
	
	var _WavesRounded = _interopRequireDefault(__webpack_require__(6469));
	
	var _WavesSharp = _interopRequireDefault(__webpack_require__(6470));
	
	var _WavesTwoTone = _interopRequireDefault(__webpack_require__(6471));
	
	var _WbAuto = _interopRequireDefault(__webpack_require__(6472));
	
	var _WbAutoOutlined = _interopRequireDefault(__webpack_require__(6473));
	
	var _WbAutoRounded = _interopRequireDefault(__webpack_require__(6474));
	
	var _WbAutoSharp = _interopRequireDefault(__webpack_require__(6475));
	
	var _WbAutoTwoTone = _interopRequireDefault(__webpack_require__(6476));
	
	var _WbCloudy = _interopRequireDefault(__webpack_require__(6477));
	
	var _WbCloudyOutlined = _interopRequireDefault(__webpack_require__(6478));
	
	var _WbCloudyRounded = _interopRequireDefault(__webpack_require__(6479));
	
	var _WbCloudySharp = _interopRequireDefault(__webpack_require__(6480));
	
	var _WbCloudyTwoTone = _interopRequireDefault(__webpack_require__(6481));
	
	var _WbIncandescent = _interopRequireDefault(__webpack_require__(6482));
	
	var _WbIncandescentOutlined = _interopRequireDefault(__webpack_require__(6483));
	
	var _WbIncandescentRounded = _interopRequireDefault(__webpack_require__(6484));
	
	var _WbIncandescentSharp = _interopRequireDefault(__webpack_require__(6485));
	
	var _WbIncandescentTwoTone = _interopRequireDefault(__webpack_require__(6486));
	
	var _WbIridescent = _interopRequireDefault(__webpack_require__(6487));
	
	var _WbIridescentOutlined = _interopRequireDefault(__webpack_require__(6488));
	
	var _WbIridescentRounded = _interopRequireDefault(__webpack_require__(6489));
	
	var _WbIridescentSharp = _interopRequireDefault(__webpack_require__(6490));
	
	var _WbIridescentTwoTone = _interopRequireDefault(__webpack_require__(6491));
	
	var _WbSunny = _interopRequireDefault(__webpack_require__(6492));
	
	var _WbSunnyOutlined = _interopRequireDefault(__webpack_require__(6493));
	
	var _WbSunnyRounded = _interopRequireDefault(__webpack_require__(6494));
	
	var _WbSunnySharp = _interopRequireDefault(__webpack_require__(6495));
	
	var _WbSunnyTwoTone = _interopRequireDefault(__webpack_require__(6496));
	
	var _Wc = _interopRequireDefault(__webpack_require__(6497));
	
	var _WcOutlined = _interopRequireDefault(__webpack_require__(6498));
	
	var _WcRounded = _interopRequireDefault(__webpack_require__(6499));
	
	var _WcSharp = _interopRequireDefault(__webpack_require__(6500));
	
	var _WcTwoTone = _interopRequireDefault(__webpack_require__(6501));
	
	var _Web = _interopRequireDefault(__webpack_require__(6502));
	
	var _WebAsset = _interopRequireDefault(__webpack_require__(6503));
	
	var _WebAssetOutlined = _interopRequireDefault(__webpack_require__(6504));
	
	var _WebAssetRounded = _interopRequireDefault(__webpack_require__(6505));
	
	var _WebAssetSharp = _interopRequireDefault(__webpack_require__(6506));
	
	var _WebAssetTwoTone = _interopRequireDefault(__webpack_require__(6507));
	
	var _WebOutlined = _interopRequireDefault(__webpack_require__(6508));
	
	var _WebRounded = _interopRequireDefault(__webpack_require__(6509));
	
	var _WebSharp = _interopRequireDefault(__webpack_require__(6510));
	
	var _WebTwoTone = _interopRequireDefault(__webpack_require__(6511));
	
	var _Weekend = _interopRequireDefault(__webpack_require__(6512));
	
	var _WeekendOutlined = _interopRequireDefault(__webpack_require__(6513));
	
	var _WeekendRounded = _interopRequireDefault(__webpack_require__(6514));
	
	var _WeekendSharp = _interopRequireDefault(__webpack_require__(6515));
	
	var _WeekendTwoTone = _interopRequireDefault(__webpack_require__(6516));
	
	var _WhatsApp = _interopRequireDefault(__webpack_require__(6517));
	
	var _Whatshot = _interopRequireDefault(__webpack_require__(6518));
	
	var _WhatshotOutlined = _interopRequireDefault(__webpack_require__(6519));
	
	var _WhatshotRounded = _interopRequireDefault(__webpack_require__(6520));
	
	var _WhatshotSharp = _interopRequireDefault(__webpack_require__(6521));
	
	var _WhatshotTwoTone = _interopRequireDefault(__webpack_require__(6522));
	
	var _WhereToVote = _interopRequireDefault(__webpack_require__(6523));
	
	var _WhereToVoteOutlined = _interopRequireDefault(__webpack_require__(6524));
	
	var _WhereToVoteRounded = _interopRequireDefault(__webpack_require__(6525));
	
	var _WhereToVoteSharp = _interopRequireDefault(__webpack_require__(6526));
	
	var _WhereToVoteTwoTone = _interopRequireDefault(__webpack_require__(6527));
	
	var _Widgets = _interopRequireDefault(__webpack_require__(6528));
	
	var _WidgetsOutlined = _interopRequireDefault(__webpack_require__(6529));
	
	var _WidgetsRounded = _interopRequireDefault(__webpack_require__(6530));
	
	var _WidgetsSharp = _interopRequireDefault(__webpack_require__(6531));
	
	var _WidgetsTwoTone = _interopRequireDefault(__webpack_require__(6532));
	
	var _Wifi = _interopRequireDefault(__webpack_require__(6533));
	
	var _WifiLock = _interopRequireDefault(__webpack_require__(6534));
	
	var _WifiLockOutlined = _interopRequireDefault(__webpack_require__(6535));
	
	var _WifiLockRounded = _interopRequireDefault(__webpack_require__(6536));
	
	var _WifiLockSharp = _interopRequireDefault(__webpack_require__(6537));
	
	var _WifiLockTwoTone = _interopRequireDefault(__webpack_require__(6538));
	
	var _WifiOff = _interopRequireDefault(__webpack_require__(6539));
	
	var _WifiOffOutlined = _interopRequireDefault(__webpack_require__(6540));
	
	var _WifiOffRounded = _interopRequireDefault(__webpack_require__(6541));
	
	var _WifiOffSharp = _interopRequireDefault(__webpack_require__(6542));
	
	var _WifiOffTwoTone = _interopRequireDefault(__webpack_require__(6543));
	
	var _WifiOutlined = _interopRequireDefault(__webpack_require__(6544));
	
	var _WifiRounded = _interopRequireDefault(__webpack_require__(6545));
	
	var _WifiSharp = _interopRequireDefault(__webpack_require__(6546));
	
	var _WifiTethering = _interopRequireDefault(__webpack_require__(6547));
	
	var _WifiTetheringOutlined = _interopRequireDefault(__webpack_require__(6548));
	
	var _WifiTetheringRounded = _interopRequireDefault(__webpack_require__(6549));
	
	var _WifiTetheringSharp = _interopRequireDefault(__webpack_require__(6550));
	
	var _WifiTetheringTwoTone = _interopRequireDefault(__webpack_require__(6551));
	
	var _WifiTwoTone = _interopRequireDefault(__webpack_require__(6552));
	
	var _Work = _interopRequireDefault(__webpack_require__(6553));
	
	var _WorkOff = _interopRequireDefault(__webpack_require__(6554));
	
	var _WorkOffOutlined = _interopRequireDefault(__webpack_require__(6555));
	
	var _WorkOffRounded = _interopRequireDefault(__webpack_require__(6556));
	
	var _WorkOffSharp = _interopRequireDefault(__webpack_require__(6557));
	
	var _WorkOffTwoTone = _interopRequireDefault(__webpack_require__(6558));
	
	var _WorkOutline = _interopRequireDefault(__webpack_require__(6559));
	
	var _WorkOutlined = _interopRequireDefault(__webpack_require__(6564));
	
	var _WorkOutlineOutlined = _interopRequireDefault(__webpack_require__(6560));
	
	var _WorkOutlineRounded = _interopRequireDefault(__webpack_require__(6561));
	
	var _WorkOutlineSharp = _interopRequireDefault(__webpack_require__(6562));
	
	var _WorkOutlineTwoTone = _interopRequireDefault(__webpack_require__(6563));
	
	var _WorkRounded = _interopRequireDefault(__webpack_require__(6565));
	
	var _WorkSharp = _interopRequireDefault(__webpack_require__(6566));
	
	var _WorkTwoTone = _interopRequireDefault(__webpack_require__(6567));
	
	var _WrapText = _interopRequireDefault(__webpack_require__(6568));
	
	var _WrapTextOutlined = _interopRequireDefault(__webpack_require__(6569));
	
	var _WrapTextRounded = _interopRequireDefault(__webpack_require__(6570));
	
	var _WrapTextSharp = _interopRequireDefault(__webpack_require__(6571));
	
	var _WrapTextTwoTone = _interopRequireDefault(__webpack_require__(6572));
	
	var _YouTube = _interopRequireDefault(__webpack_require__(6573));
	
	var _YoutubeSearchedFor = _interopRequireDefault(__webpack_require__(6574));
	
	var _YoutubeSearchedForOutlined = _interopRequireDefault(__webpack_require__(6575));
	
	var _YoutubeSearchedForRounded = _interopRequireDefault(__webpack_require__(6576));
	
	var _YoutubeSearchedForSharp = _interopRequireDefault(__webpack_require__(6577));
	
	var _YoutubeSearchedForTwoTone = _interopRequireDefault(__webpack_require__(6578));
	
	var _ZoomIn = _interopRequireDefault(__webpack_require__(6579));
	
	var _ZoomInOutlined = _interopRequireDefault(__webpack_require__(6580));
	
	var _ZoomInRounded = _interopRequireDefault(__webpack_require__(6581));
	
	var _ZoomInSharp = _interopRequireDefault(__webpack_require__(6582));
	
	var _ZoomInTwoTone = _interopRequireDefault(__webpack_require__(6583));
	
	var _ZoomOut = _interopRequireDefault(__webpack_require__(6584));
	
	var _ZoomOutMap = _interopRequireDefault(__webpack_require__(6585));
	
	var _ZoomOutMapOutlined = _interopRequireDefault(__webpack_require__(6586));
	
	var _ZoomOutMapRounded = _interopRequireDefault(__webpack_require__(6587));
	
	var _ZoomOutMapSharp = _interopRequireDefault(__webpack_require__(6588));
	
	var _ZoomOutMapTwoTone = _interopRequireDefault(__webpack_require__(6589));
	
	var _ZoomOutOutlined = _interopRequireDefault(__webpack_require__(6590));
	
	var _ZoomOutRounded = _interopRequireDefault(__webpack_require__(6591));
	
	var _ZoomOutSharp = _interopRequireDefault(__webpack_require__(6592));
	
	var _ZoomOutTwoTone = _interopRequireDefault(__webpack_require__(6593));

/***/ },
/* 400 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	
	var _default = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';
	
	exports.default = _default;

/***/ },
/* 401 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// We use the same empty object to ref count the styles that don't need a theme object.
	var noopTheme = {};
	var _default = noopTheme;
	exports.default = _default;

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _getThemeProps.default;
	  }
	});
	
	var _getThemeProps = _interopRequireDefault(__webpack_require__(6604));

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _jssPreset.default;
	  }
	});
	
	var _jssPreset = _interopRequireDefault(__webpack_require__(6605));

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _mergeClasses.default;
	  }
	});
	
	var _mergeClasses = _interopRequireDefault(__webpack_require__(6609));

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var ThemeContext = _react.default.createContext(null);
	
	if (false) {
	  ThemeContext.displayName = 'ThemeContext';
	}
	
	var _default = ThemeContext;
	exports.default = _default;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.12.2
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  borders: true,
	  breakpoints: true,
	  compose: true,
	  styleFunctionSx: true,
	  display: true,
	  flexbox: true,
	  grid: true,
	  palette: true,
	  positions: true,
	  shadows: true,
	  sizing: true,
	  spacing: true,
	  style: true,
	  typography: true
	};
	Object.defineProperty(exports, "borders", {
	  enumerable: true,
	  get: function get() {
	    return _borders.default;
	  }
	});
	Object.defineProperty(exports, "breakpoints", {
	  enumerable: true,
	  get: function get() {
	    return _breakpoints.default;
	  }
	});
	Object.defineProperty(exports, "compose", {
	  enumerable: true,
	  get: function get() {
	    return _compose.default;
	  }
	});
	Object.defineProperty(exports, "styleFunctionSx", {
	  enumerable: true,
	  get: function get() {
	    return _styleFunctionSx.default;
	  }
	});
	Object.defineProperty(exports, "display", {
	  enumerable: true,
	  get: function get() {
	    return _display.default;
	  }
	});
	Object.defineProperty(exports, "flexbox", {
	  enumerable: true,
	  get: function get() {
	    return _flexbox.default;
	  }
	});
	Object.defineProperty(exports, "grid", {
	  enumerable: true,
	  get: function get() {
	    return _grid.default;
	  }
	});
	Object.defineProperty(exports, "palette", {
	  enumerable: true,
	  get: function get() {
	    return _palette.default;
	  }
	});
	Object.defineProperty(exports, "positions", {
	  enumerable: true,
	  get: function get() {
	    return _positions.default;
	  }
	});
	Object.defineProperty(exports, "shadows", {
	  enumerable: true,
	  get: function get() {
	    return _shadows.default;
	  }
	});
	Object.defineProperty(exports, "sizing", {
	  enumerable: true,
	  get: function get() {
	    return _sizing.default;
	  }
	});
	Object.defineProperty(exports, "spacing", {
	  enumerable: true,
	  get: function get() {
	    return _spacing.default;
	  }
	});
	Object.defineProperty(exports, "style", {
	  enumerable: true,
	  get: function get() {
	    return _style.default;
	  }
	});
	Object.defineProperty(exports, "typography", {
	  enumerable: true,
	  get: function get() {
	    return _typography.default;
	  }
	});
	
	var _borders = _interopRequireWildcard(__webpack_require__(6617));
	
	Object.keys(_borders).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _borders[key];
	    }
	  });
	});
	
	var _breakpoints = _interopRequireDefault(__webpack_require__(244));
	
	var _compose = _interopRequireDefault(__webpack_require__(80));
	
	var _styleFunctionSx = _interopRequireWildcard(__webpack_require__(6627));
	
	Object.keys(_styleFunctionSx).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _styleFunctionSx[key];
	    }
	  });
	});
	
	var _display = _interopRequireDefault(__webpack_require__(6618));
	
	var _flexbox = _interopRequireWildcard(__webpack_require__(6619));
	
	Object.keys(_flexbox).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _flexbox[key];
	    }
	  });
	});
	
	var _grid = _interopRequireWildcard(__webpack_require__(6620));
	
	Object.keys(_grid).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _grid[key];
	    }
	  });
	});
	
	var _palette = _interopRequireWildcard(__webpack_require__(6622));
	
	Object.keys(_palette).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _palette[key];
	    }
	  });
	});
	
	var _positions = _interopRequireWildcard(__webpack_require__(6623));
	
	Object.keys(_positions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _positions[key];
	    }
	  });
	});
	
	var _shadows = _interopRequireDefault(__webpack_require__(6624));
	
	var _sizing = _interopRequireWildcard(__webpack_require__(6625));
	
	Object.keys(_sizing).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _sizing[key];
	    }
	  });
	});
	
	var _spacing = _interopRequireWildcard(__webpack_require__(6626));
	
	Object.keys(_spacing).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _spacing[key];
	    }
	  });
	});
	
	var _style = _interopRequireDefault(__webpack_require__(75));
	
	var _typography = _interopRequireWildcard(__webpack_require__(6628));
	
	Object.keys(_typography).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _typography[key];
	    }
	  });
	});

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var responsivePropType =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.object, _propTypes.default.array]) : {};
	var _default = responsivePropType;
	exports.default = _default;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = useEventCallback;
	
	var _react = __webpack_require__(2);
	
	var _useCommittedRef = _interopRequireDefault(__webpack_require__(6641));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useEventCallback(fn) {
	  var ref = (0, _useCommittedRef.default)(fn);
	  return (0, _react.useCallback)(function () {
	    return ref.current && ref.current.apply(ref, arguments);
	  }, [ref]);
	}

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var isActionSupported = function isActionSupported(targetRef, method) {
	  return targetRef && !!targetRef.current && !!targetRef.current[method];
	};
	
	var useEventListener = function useEventListener(options) {
	  var capture = options.capture,
	      listener = options.listener,
	      type = options.type,
	      targetRef = options.targetRef;
	  var latestListener = React.useRef(listener);
	  latestListener.current = listener;
	  var eventHandler = React.useCallback(function (event) {
	    return latestListener.current(event);
	  }, []);
	  React.useEffect(function () {
	    if (isActionSupported(targetRef, 'addEventListener')) {
	      ;
	      targetRef.current.addEventListener(type, eventHandler, capture);
	    } else if (false) {
	      throw new Error('@stardust-ui/react-component-event-listener: Passed `targetRef` is not valid or does not support `addEventListener()` method.');
	    }
	
	    return function () {
	      if (isActionSupported(targetRef, 'removeEventListener')) {
	        ;
	        targetRef.current.removeEventListener(type, eventHandler, capture);
	      } else if (false) {
	        throw new Error('@stardust-ui/react-component-event-listener: Passed `targetRef` is not valid or does not support `removeEventListener()` method.');
	      }
	    };
	  }, [capture, targetRef, type]);
	};
	
	var _default = useEventListener;
	exports.default = _default;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(45));
	
	var _handleRef = _interopRequireDefault(__webpack_require__(246));
	
	var _types = __webpack_require__(173);
	
	var RefFindNode =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(RefFindNode, _React$Component);
	
	  function RefFindNode() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, RefFindNode);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(RefFindNode)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "prevNode", null);
	    return _this;
	  }
	
	  (0, _createClass2.default)(RefFindNode, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.prevNode = ReactDOM.findDOMNode(this);
	      (0, _handleRef.default)(this.props.innerRef, this.prevNode);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var currentNode = ReactDOM.findDOMNode(this);
	
	      if (this.prevNode !== currentNode) {
	        this.prevNode = currentNode;
	        (0, _handleRef.default)(this.props.innerRef, currentNode);
	      }
	
	      if (prevProps.innerRef !== this.props.innerRef) {
	        (0, _handleRef.default)(this.props.innerRef, currentNode);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      (0, _handleRef.default)(this.props.innerRef, null);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var children = this.props.children;
	      return children;
	    }
	  }]);
	  return RefFindNode;
	}(React.Component);
	
	exports.default = RefFindNode;
	(0, _defineProperty2.default)(RefFindNode, "displayName", 'RefFindNode');
	(0, _defineProperty2.default)(RefFindNode, "propTypes",  false ? {
	  children: PropTypes.element.isRequired,
	  innerRef: _types.refPropType.isRequired
	} : {});

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _handleRef = _interopRequireDefault(__webpack_require__(246));
	
	var _types = __webpack_require__(173);
	
	var RefForward =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(RefForward, _React$Component);
	
	  function RefForward() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, RefForward);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(RefForward)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleRefOverride", function (node) {
	      var _this$props = _this.props,
	          children = _this$props.children,
	          innerRef = _this$props.innerRef;
	      (0, _handleRef.default)(children.ref, node);
	      (0, _handleRef.default)(innerRef, node);
	    });
	    return _this;
	  }
	
	  (0, _createClass2.default)(RefForward, [{
	    key: "render",
	    value: function render() {
	      var children = this.props.children;
	      return React.cloneElement(children, {
	        ref: this.handleRefOverride
	      });
	    }
	  }]);
	  return RefForward;
	}(React.Component);
	
	exports.default = RefForward;
	(0, _defineProperty2.default)(RefForward, "displayName", 'RefForward');
	(0, _defineProperty2.default)(RefForward, "propTypes",  false ? {
	  children: PropTypes.element.isRequired,
	  innerRef: _types.refPropType.isRequired
	} : {});

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(61);
	var settle = __webpack_require__(6663);
	var cookies = __webpack_require__(6666);
	var buildURL = __webpack_require__(419);
	var buildFullPath = __webpack_require__(6660);
	var parseHeaders = __webpack_require__(6670);
	var isURLSameOrigin = __webpack_require__(6668);
	var createError = __webpack_require__(415);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    if (
	      (utils.isBlob(requestData) || utils.isFile(requestData)) &&
	      requestData.type
	    ) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = unescape(encodeURIComponent(config.auth.password)) || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    var fullPath = buildFullPath(config.baseURL, config.url);
	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request.onreadystatechange = function handleLoad() {
	      if (!request || request.readyState !== 4) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }
	
	      reject(createError('Request aborted', config, 'ECONNABORTED', request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }
	      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (!utils.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (!requestData) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 413 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 414 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(6662);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(61);
	
	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */
	module.exports = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};
	
	  var valueFromConfig2Keys = ['url', 'method', 'data'];
	  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
	  var defaultToConfig2Keys = [
	    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
	    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
	    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
	    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
	    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
	  ];
	  var directMergeKeys = ['validateStatus'];
	
	  function getMergedValue(target, source) {
	    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
	      return utils.merge(target, source);
	    } else if (utils.isPlainObject(source)) {
	      return utils.merge({}, source);
	    } else if (utils.isArray(source)) {
	      return source.slice();
	    }
	    return source;
	  }
	
	  function mergeDeepProperties(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(config1[prop], config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(undefined, config2[prop]);
	    }
	  });
	
	  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
	
	  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(undefined, config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  });
	
	  utils.forEach(directMergeKeys, function merge(prop) {
	    if (prop in config2) {
	      config[prop] = getMergedValue(config1[prop], config2[prop]);
	    } else if (prop in config1) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  });
	
	  var axiosKeys = valueFromConfig2Keys
	    .concat(mergeDeepPropertiesKeys)
	    .concat(defaultToConfig2Keys)
	    .concat(directMergeKeys);
	
	  var otherKeys = Object
	    .keys(config1)
	    .concat(Object.keys(config2))
	    .filter(function filterAxiosKeys(key) {
	      return axiosKeys.indexOf(key) === -1;
	    });
	
	  utils.forEach(otherKeys, mergeDeepProperties);
	
	  return config;
	};


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(61);
	var normalizeHeaderName = __webpack_require__(6669);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(412);
	  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(412);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Accept');
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	  maxBodyLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ },
/* 418 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(61);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');
	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }
	
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = function (crypto, password, keyLen, ivLen) {
	  keyLen = keyLen/8;
	  ivLen = ivLen || 0;
	  var ki = 0;
	  var ii = 0;
	  var key = new Buffer(keyLen);
	  var iv = new Buffer(ivLen);
	  var addmd = 0;
	  var md, md_buf;
	  var i;
	  while (true) {
	    md = crypto.createHash('md5');
	    if(addmd++ > 0) {
	       md.update(md_buf);
	    }
	    md.update(password);
	    md_buf = md.digest();
	    i = 0;
	    if(keyLen > 0) {
	      while(true) {
	        if(keyLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	        key[ki++] = md_buf[i];
	        keyLen--;
	        i++;
	       }
	    }
	    if(ivLen > 0 && i !== md_buf.length) {
	      while(true) {
	        if(ivLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	       iv[ii++] = md_buf[i];
	       ivLen--;
	       i++;
	     }
	   }
	   if(keyLen === 0 && ivLen === 0) {
	      break;
	    }
	  }
	  for(i=0;i<md_buf.length;i++) {
	    md_buf[i] = 0;
	  }
	  return {
	    key: key,
	    iv: iv
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39).Buffer))

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	var xor = __webpack_require__(174);
	exports.encrypt = function (self, block) {
	  var data = xor(block, self._prev);
	  self._prev = self._cipher.encryptBlock(data);
	  return self._prev;
	};
	exports.decrypt = function (self, block) {
	  var pad = self._prev;
	  self._prev = block;
	  var out = self._cipher.decryptBlock(block);
	  return xor(out, pad);
	};

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(174);
	exports.encrypt = function (self, data, decrypt) {
	  var out = new Buffer('');
	  var len;
	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev);
	      self._prev = new Buffer('');
	    }
	    if (self._cache.length <= data.length) {
	      len = self._cache.length;
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
	      data = data.slice(len);
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
	      break;
	    }
	  }
	  return out;
	};
	function encryptStart(self, data, decrypt) {
	  var len = data.length;
	  var out = xor(data, self._cache);
	  self._cache = self._cache.slice(len);
	  self._prev = Buffer.concat([self._prev, decrypt?data:out]);
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39).Buffer))

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(174);
	function getBlock(self) {
	  var out = self._cipher.encryptBlock(self._prev);
	  incr32(self._prev);
	  return out;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	function incr32(iv) {
	  var len = iv.length;
	  var item;
	  while (len--) {
	    item = iv.readUInt8(len);
	    if (item === 255) {
	      iv.writeUInt8(0, len);
	    } else {
	      item++;
	      iv.writeUInt8(item, len);
	      break;
	    }
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39).Buffer))

/***/ },
/* 424 */
/***/ function(module, exports) {

	exports.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block);
	};
	exports.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block);
	};

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(174);
	function getBlock(self) {
	  self._prev = self._cipher.encryptBlock(self._prev);
	  return self._prev;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39).Buffer))

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(247);
	var Transform = __webpack_require__(248);
	var inherits = __webpack_require__(76);
	
	inherits(StreamCipher, Transform);
	module.exports = StreamCipher;
	function StreamCipher(mode, key, iv, decrypt) {
	  if (!(this instanceof StreamCipher)) {
	    return new StreamCipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  this._cache = new Buffer('');
	  this._secCache = new Buffer('');
	  this._decrypt = decrypt;
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	StreamCipher.prototype._transform = function (chunk, _, next) {
	  next(null, this._mode.encrypt(this, chunk, this._decrypt));
	};
	StreamCipher.prototype._flush = function (next) {
	  this._cipher.scrub();
	  next();
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39).Buffer))

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(136);
	
	var $apply = __webpack_require__(250);
	var $call = __webpack_require__(251);
	var $reflectApply = __webpack_require__(6679);
	
	/** @type {import('./actualApply')} */
	module.exports = $reflectApply || bind.call($call, $apply);


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var setFunctionLength = __webpack_require__(7324);
	
	var $defineProperty = __webpack_require__(177);
	
	var callBindBasic = __webpack_require__(252);
	var applyBind = __webpack_require__(6678);
	
	module.exports = function callBind(originalFunction) {
		var func = callBindBasic(arguments);
		var adjustedLength = originalFunction.length - (arguments.length - 1);
		return setFunctionLength(
			func,
			1 + (adjustedLength > 0 ? adjustedLength : 0),
			true
		);
	};
	
	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The MIT License (MIT)
	 * 
	 * Copyright (c) 2016 Mykhailo Stadnyk <mikhus@gmail.com>
	 * 
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 * 
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 *
	 * @version 2.1.7
	 */
	!function(e){"use strict";function t(e){if(Array.isArray(e)){for(var t=0,i=Array(e.length);t<e.length;t++)i[t]=e[t];return i}return Array.from(e)}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function r(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function n(e,t){if(t||(t="undefined"==typeof window?global:window),void 0!==t[e])return t[e];for(var i=["webkit","moz","ms","o"],r=0,o=i.length,n=e.charAt(0).toUpperCase()+e.substr(1);r<o;r++){var a=t[i[r]+n];if(void 0!==a)return a}return null}function a(e,t,i,r,o,n,l){if("function"!=typeof r)throw new TypeError("Invalid animation rule:",r);var s=e-i,d=s/o,c=0;d>1&&(d=1),1!==d&&(c=r(d),isFinite(c)&&!isNaN(c)&&(d=c)),t&&t(d),s<o?l.frame=me(function(e){return a(e,t,i,r,o,n,l)}):(n&&n(),l.inProgress=!1)}function l(){Array.prototype.constructor.apply(this,arguments)}function s(e){if(!(e instanceof DOMException&&2152923147===e.result))throw e}function d(e,t){return t.replace(Ve,function(t,i){var r=e[i];return void 0!==r?r:t})}function c(e){return e.majorTicks instanceof Array||(e.majorTicks=e.majorTicks?[e.majorTicks]:[]),e.majorTicks.length||(e.majorTicks.push(We.formatMajorTickNumber(e.minValue,e)),e.majorTicks.push(We.formatMajorTickNumber(e.maxValue,e))),["right"!==e.tickSide,"left"!==e.tickSide]}function h(e,t,i,r,o,n){e.beginPath(),e.moveTo(t+n,i),e.lineTo(t+r-n,i),e.quadraticCurveTo(t+r,i,t+r,i+n),e.lineTo(t+r,i+o-n),e.quadraticCurveTo(t+r,i+o,t+r-n,i+o),e.lineTo(t+n,i+o),e.quadraticCurveTo(t,i+o,t,i+o-n),e.lineTo(t,i+n),e.quadraticCurveTo(t,i,t+n,i),e.closePath()}function u(e,t){var i=t.valueDec,r=t.valueInt,o=0,n=void 0,a=void 0,l=void 0;if(e=parseFloat(e),l=e<0,e=Math.abs(e),i>0){for(a=e.toFixed(i).toString().split("."),n=r-a[0].length;o<n;++o)a[0]="0"+a[0];a=(l?"-":"")+a[0]+"."+a[1]}else{for(a=Math.round(e).toString(),n=r-a.length;o<n;++o)a="0"+a;a=(l?"-":"")+a}return a}function f(e,t){var i=void 0,r=!1;return i=0===t.majorTicksDec?Math.round(e).toString():e.toFixed(t.majorTicksDec),t.majorTicksInt>1?(r=~i.indexOf("."),~i.indexOf("-")?"-"+[t.majorTicksInt+t.majorTicksDec+2+(r?1:0)-i.length].join("0")+i.replace("-",""):[t.majorTicksInt+t.majorTicksDec+1+(r?1:0)-i.length].join("0")+i):i}function m(e){return e*Math.PI/180}function v(e,t){return{x:-e*Math.sin(t),y:e*Math.cos(t)}}function g(e,t,i,r){var o=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],n=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0,a=e.createLinearGradient(o?0:n,o?n:0,o?0:r,o?r:0);return a.addColorStop(0,t),a.addColorStop(1,i),a}function b(e,t){if(arguments.length>2&&void 0!==arguments[2]&&arguments[2])return e.restore(),!0;e.save();var i=t.borderShadowWidth;return i&&(e.shadowBlur=i,e.shadowColor=t.colorBorderShadow),!0}function p(e,t){t.needleShadow&&(e.shadowOffsetX=2,e.shadowOffsetY=2,e.shadowBlur=10,e.shadowColor=t.colorNeedleShadowDown)}function w(e,t,i){return e["font"+t+"Style"]+" "+e["font"+t+"Weight"]+" "+e["font"+t+"Size"]*i+"px "+e["font"+t]}function k(e){e.shadowOffsetX=null,e.shadowOffsetY=null,e.shadowBlur=null,e.shadowColor="",e.strokeStyle=null,e.lineWidth=0,e.save()}function y(e,t,i,r){t.valueTextShadow&&(e.shadowOffsetX=i,e.shadowOffsetY=i,e.shadowBlur=r,e.shadowColor=t.colorValueTextShadow)}function x(e,t,i,r,o,n){if(t.valueBox){k(e);var a=t.valueDec?1+t.valueDec:0,l="9".repeat(Math.max.apply(null,[String(parseInt(i)).length+a].concat(t.majorTicks.map(function(e){return String(parseInt(e,10)).length+a})))),s=t.valueText||u(i,t),d=n/200,c=n/100,f=.4*c,m=1.2*c;e.font=w(t,"Value",d),y(e,t,f,m);var v=e.measureText(t.valueText?s:"-"+u(Number(l),t)).width;k(e);var g=parseFloat(t.fontValueSize)*d+f+m,b=c*parseFloat(t.valueBoxStroke),p=2*n-2*b,x=v+10*c,T=1.1*g+f+m,S=c*t.valueBoxBorderRadius,V=(parseFloat(t.valueBoxWidth)||0)/100*p;V>x&&(x=V),x>p&&(x=p);var W=r-x/2,O=o-T/2,A=o-5.75*c;if(e.beginPath(),S?h(e,W,O,x,T,S):e.rect(W,O,x,T),b){var P=e.createRadialGradient(r,A,10*c,r,A,20*c);P.addColorStop(0,t.colorValueBoxRect),P.addColorStop(1,t.colorValueBoxRectEnd),e.strokeStyle=P,e.lineWidth=b,e.stroke()}t.colorValueBoxShadow&&(e.shadowBlur=1.2*c,e.shadowColor=t.colorValueBoxShadow),t.colorValueBoxBackground&&(e.fillStyle=t.colorValueBoxBackground,e.fill()),e.closePath(),e.restore(),y(e,t,f,m),e.fillStyle=t.colorValueText,e.textAlign="center",e.textBaseline="alphabetic",e.fillText(s,W+x/2,o+T/2-g/3),e.restore()}}function T(e){var t=e.value,i=e.minValue,r=e.maxValue,o=.01*(r-i);return{normal:t<i?i:t>r?r:t,indented:t<i?i-o:t>r?r+o:t}}function S(e,t,i,r,o){i.beginPath(),i.arc(0,0,xe(e),0,2*Oe,!0),i.lineWidth=t,i.strokeStyle=o?We.linearGradient(i,r,o,e):r,i.stroke(),i.closePath()}function V(e,t){var i=pe.pixelRatio;return e.maxRadius||(e.maxRadius=e.max-t.borderShadowWidth-t.borderOuterWidth*i-t.borderMiddleWidth*i-t.borderInnerWidth*i+(t.borderOuterWidth?.5:0)+(t.borderMiddleWidth?.5:0)+(t.borderInnerWidth?.5:0)),e.maxRadius}function W(e,t){var i=pe.pixelRatio,r=t.borderShadowWidth*i,o=e.max-r-t.borderOuterWidth*i/2,n=o-t.borderOuterWidth*i/2-t.borderMiddleWidth*i/2+.5,a=n-t.borderMiddleWidth*i/2-t.borderInnerWidth*i/2+.5,l=V(e,t),s=void 0,d=!1;e.save(),t.borderOuterWidth&&(d=We.drawShadow(e,t,d),S(o,t.borderOuterWidth*i,e,t.colorBorderOuter,t.colorBorderOuterEnd)),t.borderMiddleWidth&&(d=We.drawShadow(e,t,d),S(n,t.borderMiddleWidth*i,e,t.colorBorderMiddle,t.colorBorderMiddleEnd)),t.borderInnerWidth&&(d=We.drawShadow(e,t,d),S(a,t.borderInnerWidth*i,e,t.colorBorderInner,t.colorBorderInnerEnd)),We.drawShadow(e,t,d),e.beginPath(),e.arc(0,0,xe(l),0,2*Oe,!0),t.colorPlateEnd?(s=e.createRadialGradient(0,0,l/2,0,0,l),s.addColorStop(0,t.colorPlate),s.addColorStop(1,t.colorPlateEnd)):s=t.colorPlate,e.fillStyle=s,e.fill(),e.closePath(),e.restore()}function O(e,t){var i=e.max*(parseFloat(t.highlightsWidth)||0)/100;if(i){var r=xe(P(e,t)-i/2),o=0,n=t.highlights.length,a=(t.maxValue-t.minValue)/t.ticksAngle;for(e.save();o<n;o++){var l=t.highlights[o];e.beginPath(),e.rotate(Ae),e.arc(0,0,r,We.radians(t.startAngle+(l.from-t.minValue)/a),We.radians(t.startAngle+(l.to-t.minValue)/a),!1),e.strokeStyle=l.color,e.lineWidth=i,e.lineCap=t.highlightsLineCap,e.stroke(),e.closePath(),e.restore(),e.save()}}}function A(e,t){var i=P(e,t),r=void 0,o=void 0,n=void 0,a=0,l=0,s=Math.abs(t.minorTicks)||0,d=t.ticksAngle/(t.maxValue-t.minValue);for(e.lineWidth=pe.pixelRatio,e.strokeStyle=t.colorMinorTicks||t.colorStrokeTicks,e.save(),t.exactTicks?(o=t.maxValue-t.minValue,r=s?o/s:0,l=(Se.mod(t.majorTicks[0],s)||0)*d):r=s*(t.majorTicks.length-1);a<r;++a)(n=t.startAngle+l+a*(t.ticksAngle/r))<=t.ticksAngle+t.startAngle&&(e.rotate(We.radians(n)),e.beginPath(),e.moveTo(0,i),e.lineTo(0,i-.075*e.max),C(e))}function P(e,t){var i=e.max/100;return V(e,t)-5*i-(t.barWidth?2*(parseFloat(t.barStrokeWidth)||0)+((parseFloat(t.barWidth)||0)+5)*i:0)}function M(e,t){We.prepareTicks(t);var i=xe(P(e,t)),r=void 0,o=void 0,n=t.majorTicks.length,a=pe.pixelRatio;for(e.lineWidth=2*a,e.save(),o=t.colorMajorTicks instanceof Array?t.colorMajorTicks:new Array(n).fill(t.colorStrokeTicks||t.colorMajorTicks),r=0;r<n;++r)e.strokeStyle=o[r],e.rotate(We.radians(B(t,t.exactTicks?t.majorTicks[r]:r,n))),e.beginPath(),e.moveTo(0,i),e.lineTo(0,i-.15*e.max),C(e);t.strokeTicks&&(e.strokeStyle=t.colorStrokeTicks||o[0],e.rotate(Ae),e.beginPath(),e.arc(0,0,i,We.radians(t.startAngle),We.radians(t.startAngle+t.ticksAngle),!1),C(e))}function B(e,t,i){if(e.exactTicks){var r=e.ticksAngle/(e.maxValue-e.minValue);return e.startAngle+r*(t-e.minValue)}return e.startAngle+t*(e.ticksAngle/(i-1))}function C(e){e.stroke(),e.restore(),e.closePath(),e.save()}function j(e,t){var i=P(e,t)-.15*e.max,r={},o=0,n=t.majorTicks.length,a="needle"!==t.animationTarget,l=t.colorNumbers instanceof Array?t.colorNumbers:new Array(n).fill(t.colorNumbers),s=a?-(t.value-t.minValue)/(t.maxValue-t.minValue)*t.ticksAngle:0;for(a&&(e.save(),e.rotate(-We.radians(s))),e.font=We.font(t,"Numbers",e.max/200),e.lineWidth=0,e.textAlign="center",e.textBaseline="middle";o<n;++o){var d=s+B(t,t.exactTicks?t.majorTicks[o]:o,n),c=e.measureText(t.majorTicks[o]).width,h=t.fontNumbersSize,u=Math.sqrt(c*c+h*h)/2,f=We.radialPoint(i-u-t.numbersMargin/100*e.max,We.radians(d));360===d&&(d=0),r[d]||(r[d]=!0,e.fillStyle=l[o],e.fillText(t.majorTicks[o],f.x,f.y))}a&&e.restore()}function N(e,t){t.title&&(e.save(),e.font=We.font(t,"Title",e.max/200),e.fillStyle=t.colorTitle,e.textAlign="center",e.fillText(t.title,0,-e.max/4.25,.8*e.max),e.restore())}function E(e,t){t.units&&(e.save(),e.font=We.font(t,"Units",e.max/200),e.fillStyle=t.colorUnits,e.textAlign="center",e.fillText(We.formatContext(t,t.units),0,e.max/3.25,.8*e.max),e.restore())}function _(e,t){if(t.needle){var i=t.ticksAngle<360?We.normalizedValue(t).indented:t.value,r=u?t.startAngle:t.startAngle+(i-t.minValue)/(t.maxValue-t.minValue)*t.ticksAngle;"right"===t.barStartPosition&&(r=t.startAngle+t.ticksAngle-(i-t.minValue)/(t.maxValue-t.minValue)*t.ticksAngle);var o=V(e,t),n=xe(o/100*t.needleCircleSize),a=xe(o/100*t.needleCircleSize*.75),l=xe(o/100*t.needleEnd),s=xe(t.needleStart?o/100*t.needleStart:0),d=o/100*t.needleWidth,c=o/100*t.needleWidth/2,h=pe.pixelRatio,u="needle"!==t.animationTarget;e.save(),We.drawNeedleShadow(e,t),e.rotate(We.radians(r)),e.fillStyle=We.linearGradient(e,t.colorNeedle,t.colorNeedleEnd,l-s),"arrow"===t.needleType?(e.beginPath(),e.moveTo(-c,-s),e.lineTo(-d,0),e.lineTo(-1*h,l),e.lineTo(h,l),e.lineTo(d,0),e.lineTo(c,-s),e.closePath(),e.fill(),e.beginPath(),e.lineTo(-.5*h,l),e.lineTo(-1*h,l),e.lineTo(-d,0),e.lineTo(-c,-s),e.lineTo(c/2*h-2*h,-s),e.closePath(),e.fillStyle=t.colorNeedleShadowUp,e.fill()):(e.beginPath(),e.moveTo(-c,l),e.lineTo(-c,s),e.lineTo(c,s),e.lineTo(c,l),e.closePath(),e.fill()),t.needleCircleSize&&(e.restore(),We.drawNeedleShadow(e,t),t.needleCircleOuter&&(e.beginPath(),e.arc(0,0,n,0,2*Oe,!0),e.fillStyle=We.linearGradient(e,t.colorNeedleCircleOuter,t.colorNeedleCircleOuterEnd,n),e.fill(),e.closePath()),t.needleCircleInner&&(e.beginPath(),e.arc(0,0,a,0,2*Oe,!0),e.fillStyle=We.linearGradient(e,t.colorNeedleCircleInner,t.colorNeedleCircleInnerEnd,a),e.fill(),e.closePath()),e.restore())}}function R(e,t,i){We.drawValueBox(e,t,i,0,e.max-.33*e.max,e.max)}function I(e){var t=e.startAngle,i=e.startAngle+e.ticksAngle,r=t,o=t+(We.normalizedValue(e).normal-e.minValue)/(e.maxValue-e.minValue)*e.ticksAngle;if("middle"===e.barStartPosition){var n=.5*(e.minValue+e.maxValue);e.value<n?(r=180-(n-We.normalizedValue(e).normal)/(e.maxValue-e.minValue)*e.ticksAngle,o=180):(r=180,o=180+(We.normalizedValue(e).normal-n)/(e.maxValue-e.minValue)*e.ticksAngle)}else"right"===e.barStartPosition&&(r=i-o+t,o=i);return{startAngle:r,endAngle:o}}function D(e,t){var i=e.max/100,r=V(e,t)-5*i,o=parseFloat(t.barStrokeWidth+"")||0,n=(parseFloat(t.barWidth+"")||0)*i,a=r-2*o-n,l=(r-a)/2,s=a+l,d=o/s,c=t.startAngle,h=t.startAngle+t.ticksAngle;if(e.save(),e.rotate(Ae),o&&(e.beginPath(),e.arc(0,0,s,We.radians(c)-d,We.radians(h)+d,!1),e.strokeStyle=t.colorBarStroke,e.lineWidth=2*l,e.stroke(),e.closePath()),n&&(e.beginPath(),e.arc(0,0,s,We.radians(c),We.radians(h),!1),e.strokeStyle=t.colorBar,e.lineWidth=n,e.stroke(),e.closePath(),t.barShadow&&(e.beginPath(),e.arc(0,0,r,We.radians(c),We.radians(h),!1),e.clip(),e.beginPath(),e.strokeStyle=t.colorBar,e.lineWidth=1,e.shadowBlur=t.barShadow,e.shadowColor=t.colorBarShadow,e.shadowOffsetX=0,e.shadowOffsetY=0,e.arc(0,0,r,We.radians(t.startAngle),We.radians(t.startAngle+t.ticksAngle),!1),e.stroke(),e.closePath(),e.restore(),e.rotate(Ae)),t.barProgress)){var u=I(t),f=u.startAngle,m=u.endAngle;e.beginPath(),e.arc(0,0,s,We.radians(f),We.radians(m),!1),e.strokeStyle=t.colorBarProgress,e.lineWidth=n,e.stroke(),e.closePath()}e.restore()}function z(e){return e.options.animatedValue?e.options.value:e.value}function L(e,t,i,r,o,n,a,l){e.beginPath(),e.fillStyle=l?We.linearGradient(e,a,l,o>n?o:n,n>o,o>n?i:r):a,t>0?We.roundRect(e,i,r,o,n,t):e.rect(i,r,o,n),e.fill(),e.closePath()}function G(e,t,i,r,o,n,a,l,s){e.beginPath(),e.lineWidth=t,e.strokeStyle=s?We.linearGradient(e,l,s,a,!0,o):l,i>0?We.roundRect(e,r,o,n,a,i):e.rect(r,o,n,a),e.stroke(),e.closePath()}function F(e,t,i,r,o,n){var a=pe.pixelRatio;e.save();var l=t.borderRadius*a,s=o-t.borderShadowWidth-t.borderOuterWidth*a,d=s-t.borderOuterWidth*a-t.borderMiddleWidth*a,c=d-t.borderMiddleWidth*a-t.borderInnerWidth*a,h=c-t.borderInnerWidth*a,u=n-t.borderShadowWidth-t.borderOuterWidth*a,f=u-t.borderOuterWidth*a-t.borderMiddleWidth*a,m=f-t.borderMiddleWidth*a-t.borderInnerWidth*a,v=m-t.borderInnerWidth*a,g=i-(d-s)/2,b=g-(c-d)/2,p=b-(h-c)/2,w=r-(f-u)/2,k=w-(m-f)/2,y=k-(v-m)/2,x=0,T=!1;return t.borderOuterWidth&&(T=We.drawShadow(e,t,T),G(e,t.borderOuterWidth*a,l,i+t.borderOuterWidth*a/2-x,r+t.borderOuterWidth*a/2-x,s,u,t.colorBorderOuter,t.colorBorderOuterEnd),x+=.5*a),t.borderMiddleWidth&&(T=We.drawShadow(e,t,T),G(e,t.borderMiddleWidth*a,l-=1+2*x,g+t.borderMiddleWidth*a/2-x,w+t.borderMiddleWidth*a/2-x,d+2*x,f+2*x,t.colorBorderMiddle,t.colorBorderMiddleEnd),x+=.5*a),t.borderInnerWidth&&(T=We.drawShadow(e,t,T),G(e,t.borderInnerWidth*a,l-=1+2*x,b+t.borderInnerWidth*a/2-x,k+t.borderInnerWidth*a/2-x,c+2*x,m+2*x,t.colorBorderInner,t.colorBorderInnerEnd),x+=.5*a),We.drawShadow(e,t,T),L(e,l,p,y,h+2*x,v+2*x,t.colorPlate,t.colorPlateEnd),e.restore(),[p,y,h,v]}function X(e,t,i,r,o,n){var a=pe.pixelRatio,l=n>=o,s=l?.85*o:n,d=l?n:o;i=l?ye(i+(o-s)/2):i;var c=!!t.title,h=!!t.units,u=!!t.valueBox,f=void 0,m=void 0,v=void 0;l?(m=ye(.05*d),f=ye(.075*d),v=ye(.11*d),c&&(d-=f,r+=f),h&&(d-=m),u&&(d-=v)):(m=f=ye(.15*s),c&&(s-=f,r+=f),h&&(s-=m));var g=2*t.barStrokeWidth,b=t.barBeginCircle?ye(s*t.barBeginCircle/200-g/2):0,p=ye(s*t.barWidth/100-g),w=ye(d*t.barLength/100-g),k=ye((d-w)/2),y=ye(i+(l?s/2:k+b)),x=ye(r+(l?d-k-b+g/2:s/2)),T=!l||t.hasLeft&&t.hasRight?0:(t.hasRight?-1:1)*t.ticksWidth/100*s,S=l||t.hasLeft&&t.hasRight?0:(t.hasRight?-1:1)*t.ticksWidth/100*s;return e.barDimensions={isVertical:l,width:s,length:d,barWidth:p,barLength:w,strokeWidth:g,barMargin:k,radius:b,pixelRatio:a,barOffset:null,titleMargin:c?f:0,unitsMargin:h?m:0,get ticksLength(){return this.barLength-this.barOffset-this.strokeWidth},X:i+T,Y:r+S,x0:y+T,y0:x+S,baseX:i,baseY:r,ticksPadding:t.ticksPadding/100},e.barDimensions}function Y(e,t,i,r,o,n,a){var l=X(e,t,r,o,n,a),s=l.isVertical,d=l.width,c=l.barWidth,h=l.barLength,u=l.strokeWidth,f=l.barMargin,m=l.radius,v=l.x0,g=l.y0,b=l.X,p=l.Y,w=h;if(e.save(),e.beginPath(),t.barBeginCircle){var k=We.radians(s?270:0),y=Math.asin(c/2/m),x=Math.cos(y),T=Math.sin(y),S=v+(s?m*T:m*x-u/2),V=s?g-m*x:g+m*T,W=xe(s?V-g:S-v);e.barDimensions.barOffset=ye(W+m);var O=s?ye(v-m*T):S,A=s?V:ye(g-m*T);"progress"===i&&(h=e.barDimensions.barOffset+(h-e.barDimensions.barOffset)*(We.normalizedValue(t).normal-t.minValue)/(t.maxValue-t.minValue));var P=ye(S+h-e.barDimensions.barOffset+u/2),M=ye(V-h+e.barDimensions.barOffset-u/2);e.arc(v,g,m,k+y,k-y),s?(e.moveTo(S,A),e.lineTo(S,M),e.lineTo(O,M),e.lineTo(O,A)):(e.moveTo(S,A),e.lineTo(P,A),e.lineTo(P,V),e.lineTo(S,V))}else{var B=ye(s?b+(d-c)/2:b+f),C=ye(s?p+h+f:p+(d-c)/2);"progress"===i&&(h*=(t.value-t.minValue)/(t.maxValue-t.minValue)),s?e.rect(B,C,c,-h):e.rect(B,C,h,c)}"progress"!==i&&t.barStrokeWidth&&(e.lineWidth=u,e.strokeStyle=t.colorBarStroke,e.stroke()),"progress"!==i&&t.colorBar?(e.fillStyle=t.colorBarEnd?We.linearGradient(e,t.colorBar,t.colorBarEnd,h,s,s?p:b):t.colorBar,e.fill()):"progress"===i&&t.colorBarProgress&&(e.fillStyle=t.colorBarProgressEnd?We.linearGradient(e,t.colorBarProgress,t.colorBarProgressEnd,w,s,s?p:b):t.colorBarProgress,e.fill()),e.closePath(),t.barBeginCircle&&(e.barDimensions.radius+=u),e.barDimensions.barWidth+=u,e.barDimensions.barLength+=u}function U(e,t,i,r,o,n){Y(e,t,"",i,r,o,n)}function q(e,t){return t.needleSide!==e||t.tickSide!==e||t.numberSide!==e}function H(e,t,i,r,o,n){t.barProgress&&Y(e,t,"progress",i,r,o,n)}function J(e,t){var i=e.barDimensions,r=i.isVertical,o=i.width,n=i.length,a=i.barWidth,l=i.barOffset,s=i.barMargin,d=i.X,c=i.Y,h=i.ticksLength,u=i.ticksPadding,f=o*(parseFloat(t.highlightsWidth)||0)/100;if(t.highlights&&f){var m="right"!==t.tickSide,v="left"!==t.tickSide,g=0,b=t.highlights.length,p=(o-a)/2,w=t.maxValue-t.minValue,k=ye(r?d+p:d+s+l),y=f,x=r?c+n-s-l:c+p,T=ye((t.ticksWidth/100+u)*o)+(f-t.ticksWidth/100*o),S=ye(a+u*o);for(e.save();g<b;g++){var V=t.highlights[g],W=h*xe(t.minValue-V.from)/w,O=h*xe((V.to-V.from)/w);e.beginPath(),e.fillStyle=V.color,r?(m&&e.rect(k-T,x-W,y,-O),v&&e.rect(k+S,x-W,y,-O)):(m&&e.rect(k+W,x-T,O,y),v&&e.rect(k+W,x+S,O,y)),e.fill(),e.closePath()}}}function Z(e,t,i,r,o){e.beginPath(),e.moveTo(t,i),e.lineTo(r,o),e.stroke(),e.closePath(),e.save()}function $(e,t,i,r,o,n,a,l,s){var d=e.barDimensions,c=d.isVertical,h=d.length,u=d.barWidth,f=d.barOffset,m=d.barMargin,v=d.pixelRatio,g=d.width,b=d.X,p=d.Y,w=d.ticksLength,k=d.ticksPadding,y=(g-u)/2,x=void 0,T=void 0,S=0,V=i.length,W=void 0,O=s*g,A=y-k*g,P=y+u+O+k*g,M=t instanceof Array?t:new Array(i.length).fill(t);e.lineWidth=l*v,e.save();for(var B=w/(o-r);S<V;S++)W=i[S],e.strokeStyle=M[S],c?(T=p+h-m-f+(r-W)*B,n&&(x=b+A,Z(e,x,T,ye(x-O),T)),a&&(x=b+P,Z(e,x,T,ye(x-O),T))):(x=b+m+f-(r-W)*B,n&&(T=p+A,Z(e,x,T,x,ye(T-O))),a&&(T=p+P,Z(e,x,ye(T),x,T-O)))}function K(e,t){var i=We.prepareTicks(t),r=de(i,2),o=r[0],n=r[1],a=2,l=(t.maxValue-t.minValue)/(t.majorTicks.length-1),s=t.colorMajorTicks instanceof Array?t.colorMajorTicks:new Array(t.majorTicks.length).fill(t.colorStrokeTicks||t.colorMajorTicks);if($(e,s,t.exactTicks?t.majorTicks:t.majorTicks.map(function(e,i){return t.minValue+l*i}),t.minValue,t.maxValue,o,n,a,t.ticksWidth/100),t.strokeTicks){var d=e.barDimensions,c=d.isVertical,h=d.length,u=d.width,f=d.barWidth,m=d.barMargin,v=d.barOffset,g=d.X,b=d.Y,p=d.ticksLength,w=d.pixelRatio,k=d.ticksPadding,y=(u-f)/2+f+k*u,x=(u-f)/2-k*u,T=void 0,S=void 0,V=void 0,W=void 0;e.strokeStyle=t.colorStrokeTicks||s[0],a*=w,c?(S=b+h-m-v+a/2,W=S-p-a,o&&(V=T=ye(g+x),Q(e,T,S,V,W)),n&&(V=T=ye(g+y),Q(e,T,S,V,W))):(T=g+m+v-a/2,V=T+p+a,o&&(W=S=ye(b+x),Q(e,T,S,V,W)),n&&(W=S=ye(b+y),Q(e,T,S,V,W)))}}function Q(e,t,i,r,o){e.beginPath(),e.moveTo(t,i),e.lineTo(r,o),e.stroke(),e.closePath()}function ee(e,t){var i=We.prepareTicks(t),r=de(i,2),o=r[0],n=r[1],a=[],l=t.minValue,s=Math.abs(t.minorTicks)||0,d=s?(t.maxValue-t.minValue)/(s*(t.majorTicks.length-1)):0;if(s)if(t.exactTicks)for(var c=Se.mod(t.majorTicks[0],s)||0;l<t.maxValue;l+=s)c+l<t.maxValue&&a.push(c+l);else for(;l<t.maxValue;l+=d)a.push(l);$(e,t.colorMinorTicks||t.colorStrokeTicks,a,t.minValue,t.maxValue,o,n,1,t.ticksWidthMinor/100)}function te(e,t){var i=e.barDimensions,r=i.isVertical,o=i.length,n=i.width,a=i.barWidth,l=i.barMargin,s=i.barOffset,d=i.X,c=i.Y,h=i.ticksLength,u=i.ticksPadding,f=t.maxValue-t.minValue,m=f/(t.majorTicks.length-1),v=t.exactTicks?t.majorTicks:t.majorTicks.map(function(e,i){return t.minValue+m*i}),g=v.length,b="right"!==t.numberSide,p="left"!==t.numberSide,w=t.fontNumbersSize*n/200,k=0,y=(t.ticksWidth/100+2*u)*n,x=(n-a)/2-y,T=(n-a)/2+a+y,S=void 0,V=void 0,W=void 0,O=void 0,A=t.colorNumbers instanceof Array?t.colorNumbers:new Array(g).fill(t.colorNumbers),P=t.numbersMargin/100*n;for(e.font=We.font(t,"Numbers",n/200),e.lineWidth=0,e.textAlign="center";k<g;k++)e.fillStyle=A[k],O=t.majorTicks[k],W=t.exactTicks?h*((v[k]-t.minValue)/f):k*h/(g-1),r?(V=c+o-l-s-W+w/3,b&&(e.textAlign="right",e.fillText(O,d+x-P,V)),p&&(e.textAlign="left",e.fillText(O,d+T+P,V))):(e.measureText(O).width,S=d+l+s+W,b&&e.fillText(O,S,c+x-P),p&&e.fillText(O,S,c+T+w+P))}function ie(e,t){if(t.title){var i=e.barDimensions,r=i.isVertical,o=i.width,n=i.length,a=i.baseX,l=i.baseY,s=i.titleMargin,d=t.fontTitleSize*o/200,c=ye(a+(r?o:n)/2),h=ye(l+s/2-(r?d:d/2)-.025*(r?n:o));e.save(),e.textAlign="center",e.fillStyle=t.colorTitle,e.font=We.font(t,"Title",o/200),e.lineWidth=0,e.fillText(t.title,c,h,r?o:n)}}function re(e,t){if(t.units){var i=e.barDimensions,r=i.isVertical,o=i.width,n=i.length,a=i.baseX,l=i.baseY,s=i.unitsMargin,d=t.fontUnitsSize*o/200,c=ye(a+(r?o:n)/2),h=ye(l+(r?n:o)+s/2-d/2);e.save(),e.textAlign="center",e.fillStyle=t.colorUnits,e.font=We.font(t,"Units",o/200),e.lineWidth=0,e.fillText(We.formatContext(t,t.units),c,h,r?o:n)}}function oe(e,t){if(t.needle){var i=e.barDimensions,r=i.isVertical,o=i.width,n=i.length,a=i.barWidth,l=i.barOffset,s=i.barMargin,d=i.ticksLength,c=i.X,h=i.Y,u=i.ticksPadding,f="right"!==t.needleSide,m="left"!==t.needleSide,v=d*(We.normalizedValue(t).indented-t.minValue)/(t.maxValue-t.minValue),g=(t.ticksWidth/100+u)*o,b=a/2+g,p=b*(t.needleEnd/100),w=void 0,k=void 0,y=void 0,x=void 0,T="arrow"===t.needleType.toLowerCase()?le:ae,S=(o-a)/2,V=b*(t.needleStart/100),W=S-g-V,O=S+a+g+V;e.save(),We.drawNeedleShadow(e,t),r?(y=ye(h+n-s-l-v),f&&(w=ye(c+W),k=w+p,T(e,t,w,y,k,y,p)),m&&(w=ye(c+O),k=w-p,T(e,t,w,y,k,y,p,!0))):(w=ye(c+s+l+v),f&&(y=ye(h+W),x=y+p,T(e,t,w,y,w,x,p)),m&&(y=ye(h+O),x=y-p,T(e,t,w,y,w,x,p,!0))),e.restore()}}function ne(e,t,i,r){return t.colorNeedleEnd?We.linearGradient(e,r?t.colorNeedleEnd:t.colorNeedle,r?t.colorNeedle:t.colorNeedleEnd,i,!e.barDimensions.isVertical):t.colorNeedle}function ae(e,t,i,r,o,n,a,l){e.lineWidth=t.needleWidth,e.strokeStyle=ne(e,t,a,l),e.beginPath(),e.moveTo(i,r),e.lineTo(o,n),e.stroke(),e.closePath()}function le(e,t,i,r,o,n,a,l){var s=ye(.4*a),d=a-s,c=i===o,h=t.needleWidth/2;e.fillStyle=ne(e,t,a,l),e.beginPath(),c?(r>n&&(d*=-1),e.moveTo(i-h,r),e.lineTo(i+h,r),e.lineTo(i+h,r+d),e.lineTo(i,n),e.lineTo(i-h,r+d),e.lineTo(i-h,r)):(i>o&&(d*=-1),e.moveTo(i,r-h),e.lineTo(i,r+h),e.lineTo(i+d,r+h),e.lineTo(o,r),e.lineTo(i+d,r-h),e.lineTo(i,r-h)),e.fill(),e.closePath()}function se(e,t,i,r,o,n,a){var l=(parseFloat(t.fontValueSize)||0)*n/200,s=(.11*a-l)/2;e.barDimensions.isVertical&&We.drawValueBox(e,t,i,r+n/2,o+a-l-s,n)}var de=function(){function e(e,t){var i=[],r=!0,o=!1,n=void 0;try{for(var a,l=e[Symbol.iterator]();!(r=(a=l.next()).done)&&(i.push(a.value),!t||i.length!==t);r=!0);}catch(e){o=!0,n=e}finally{try{!r&&l.return&&l.return()}finally{if(o)throw n}}return i}return function(t,i){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,i);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),ce=function e(t,i,r){null===t&&(t=Function.prototype);var o=Object.getOwnPropertyDescriptor(t,i);if(void 0===o){var n=Object.getPrototypeOf(t);return null===n?void 0:e(n,i,r)}if("value"in o)return o.value;var a=o.get;if(void 0!==a)return a.call(r)},he=function e(t,i,r,o){var n=Object.getOwnPropertyDescriptor(t,i);if(void 0===n){var a=Object.getPrototypeOf(t);null!==a&&e(a,i,r,o)}else if("value"in n&&n.writable)n.value=r;else{var l=n.set;void 0!==l&&l.call(o,r)}return r},ue=function(){function e(e,t){for(var i=0;i<t.length;i++){var r=t[i];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,i,r){return i&&e(t.prototype,i),r&&e(t,r),t}}();Object.assign||Object.defineProperty(Object,"assign",{enumerable:!1,configurable:!0,writable:!0,value:function(e,t){if(void 0===e||null===e)throw new TypeError("Cannot convert first argument to object");for(var i=Object(e),r=1;r<arguments.length;r++){var o=arguments[r];if(void 0!==o&&null!==o)for(var n=Object.keys(Object(o)),a=0,l=n.length;a<l;a++){var s=n[a],d=Object.getOwnPropertyDescriptor(o,s);void 0!==d&&d.enumerable&&(i[s]=o[s])}}return i}}),Array.prototype.indexOf||Object.defineProperty(Array.prototype,"indexOf",{value:function(e,t){var i;if(null===this)throw new TypeError('"this" is null or not defined');var r=Object(this),o=r.length>>>0;if(0===o)return-1;var n=+t||0;if(Math.abs(n)===1/0&&(n=0),n>=o)return-1;for(i=Math.max(n>=0?n:o-Math.abs(n),0);i<o;){if(i in r&&r[i]===e)return i;i++}return-1}}),Array.prototype.fill||Object.defineProperty(Array.prototype,"fill",{value:function(e){if(null===this)throw new TypeError("this is null or not defined");for(var t=Object(this),i=t.length>>>0,r=arguments[1],o=r>>0,n=o<0?Math.max(i+o,0):Math.min(o,i),a=arguments[2],l=void 0===a?i:a>>0,s=l<0?Math.max(i+l,0):Math.min(l,i);n<s;)t[n]=e,n++;return t}}),"undefined"==typeof window&&(window="undefined"==typeof global?{}:global);var fe=function(){function e(){o(this,e),this._events={},this.addListener=this.on,this.removeListener=this.off}return ue(e,[{key:"emit",value:function(e){if(this._events[e]){for(var t=0,i=this._events[e].length,r=arguments.length,o=Array(r>1?r-1:0),n=1;n<r;n++)o[n-1]=arguments[n];for(;t<i;t++)this._events[e][t]&&this._events[e][t].apply(this,o)}}},{key:"once",value:function(e){for(var t=arguments.length,i=Array(t>1?t-1:0),r=1;r<t;r++)i[r-1]=arguments[r];for(var o=0,n=i.length,a=this;o<n;o++)!function(){var t=i[o],r=function i(){a.off(e,i),t.apply(a,arguments)};i[o]=r}();this.on.apply(this,[e].concat(i))}},{key:"on",value:function(e){this._events[e]||(this._events[e]=[]);for(var t=0,i=arguments.length<=1?0:arguments.length-1;t<i;t++)this._events[e].push(arguments.length<=t+1?void 0:arguments[t+1])}},{key:"off",value:function(e){if(this._events[e])for(var t=0,i=arguments.length<=1?0:arguments.length-1;t<i;t++)for(var r=arguments.length<=t+1?void 0:arguments[t+1],o=void 0;~(o=this._events[e].indexOf(r));)this._events[e].splice(o,1)}},{key:"removeAllListeners",value:function(e){delete this._events[e]}},{key:"listeners",get:function(){return this._events}}]),e}(),me=n("requestAnimationFrame")||function(e){return setTimeout(function(){return e((new Date).getTime())},1e3/60)},ve={linear:function(e){return e},quad:function(e){return Math.pow(e,2)},dequad:function(e){return 1-ve.quad(1-e)},quint:function(e){return Math.pow(e,5)},dequint:function(e){return 1-Math.pow(1-e,5)},cycle:function(e){return 1-Math.sin(Math.acos(e))},decycle:function(e){return Math.sin(Math.acos(1-e))},bounce:function(e){return 1-ve.debounce(1-e)},debounce:function(e){for(var t=0,i=1;1;t+=i,i/=2)if(e>=(7-4*t)/11)return-Math.pow((11-6*t-11*e)/4,2)+Math.pow(i,2)},elastic:function(e){return 1-ve.delastic(1-e)},delastic:function(e){return Math.pow(2,10*(e-1))*Math.cos(20*Math.PI*1.5/3*e)}},ge=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"linear",i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:250,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:function(){},n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:function(){};if(o(this,e),this.duration=i,this.rule=t,this.draw=r,this.end=n,"function"!=typeof this.draw)throw new TypeError("Invalid animation draw callback:",r);if("function"!=typeof this.end)throw new TypeError("Invalid animation end callback:",n)}return ue(e,[{key:"animate",value:function(e,t){var i=this;this.frame&&this.cancel();var r=window.performance&&window.performance.now?window.performance.now():n("animationStartTime")||Date.now();e=e||this.draw,t=t||this.end,this.draw=e,this.end=t,this.frame=me(function(o){return a(o,e,r,ve[i.rule]||i.rule,i.duration,t,i)})}},{key:"cancel",value:function(){if(this.frame){(n("cancelAnimationFrame")||function(e){})(this.frame),this.frame=null}}},{key:"destroy",value:function(){this.cancel(),this.draw=null,this.end=null}}]),e}();ge.rules=ve;var be=function(){function t(i,r,n){o(this,t),this.options=i,this.element=r.toLowerCase(),this.type=t.toDashed(n),this.Type=e[n],this.mutationsObserved=!1,this.isObservable=!!window.MutationObserver,window.GAUGES_NO_AUTO_INIT||t.domReady(this.traverse.bind(this))}return ue(t,[{key:"isValidNode",value:function(e){return!(!e.tagName||e.tagName.toLowerCase()!==this.element||e.getAttribute("data-type")!==this.type)}},{key:"traverse",value:function(){for(var e=document.getElementsByTagName(this.element),t=0,i=e.length;t<i;t++)this.process(e[t]);this.isObservable&&!this.mutationsObserved&&(new MutationObserver(this.observe.bind(this)).observe(document.body,{childList:!0,subtree:!0,attributes:!0,characterData:!0,attributeOldValue:!0,characterDataOldValue:!0}),this.mutationsObserved=!0)}},{key:"observe",value:function(e){for(var t=0,i=e.length;t<i;t++){var r=e[t];if("attributes"===r.type&&"data-type"===r.attributeName&&this.isValidNode(r.target)&&r.oldValue!==this.type)setTimeout(this.process.bind(this,r.target));else if(r.addedNodes&&r.addedNodes.length)for(var o=0,n=r.addedNodes.length;o<n;o++)setTimeout(this.process.bind(this,r.addedNodes[o]))}}},{key:"process",value:function(e){var i=this;if(!this.isValidNode(e))return null;var r=void 0,o=JSON.parse(JSON.stringify(this.options)),n=null;for(r in o)if(o.hasOwnProperty(r)){var a=t.toAttributeName(r),l=t.parse(e.getAttribute(a));null!==l&&void 0!==l&&(o[r]=l)}return o.renderTo=e,n=new this.Type(o),n.draw&&n.draw(),this.isObservable?(n.observer=new MutationObserver(function(r){r.forEach(function(r){if("attributes"===r.type){var o=r.attributeName.toLowerCase(),a=e.getAttribute(o).toLowerCase();if("data-type"===o&&a&&a!==i.type)n.observer.disconnect(),delete n.observer,n.destroy&&n.destroy();else if("data-"===o.substr(0,5)){var l=o.substr(5).split("-").map(function(e,t){return t?e.charAt(0).toUpperCase()+e.substr(1):e}).join(""),s={};s[l]=t.parse(e.getAttribute(r.attributeName)),"value"===l?n&&(n.value=s[l]):n.update&&n.update(s)}}})}),n.observer.observe(e,{attributes:!0}),n):n}}],[{key:"parse",value:function(e){if("true"===e)return!0;if("false"===e)return!1;if("undefined"!==e){if("null"===e)return null;if(/^[-+#.\w\d\s]+(?:,[-+#.\w\d\s]*)+$/.test(e))return e.split(",");try{return JSON.parse(e)}catch(e){}return e}}},{key:"toDashed",value:function(e){for(var t=e.split(/(?=[A-Z])/),i=1,r=t.length,o=t[0].toLowerCase();i<r;i++)o+="-"+t[i].toLowerCase();return o}},{key:"toCamelCase",value:function(e){for(var t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=e.split(/-/),r=0,o=i.length,n="";r<o;r++)n+=r||t?i[r][0].toUpperCase()+i[r].substr(1).toLowerCase():i[r].toLowerCase();return n}},{key:"toAttributeName",value:function(e){return"data-"+t.toDashed(e)}},{key:"domReady",value:function(e){if(/comp|inter|loaded/.test((window.document||{}).readyState+""))return e();window.addEventListener?window.addEventListener("DOMContentLoaded",e,!1):window.attachEvent&&window.attachEvent("onload",e)}}]),t}(),pe=function(){function e(t,i,r){o(this,e),e.collection.push(this),this.width=i||0,this.height=r||0,this.element=t,this.init()}return ue(e,[{key:"init",value:function(){var t=e.pixelRatio;this.element.width=this.width*t,this.element.height=this.height*t,this.element.style.width=this.width+"px",this.element.style.height=this.height+"px",this.elementClone=this.element.cloneNode(!0),this.context=this.element.getContext("2d"),this.contextClone=this.elementClone.getContext("2d"),this.drawWidth=this.element.width,this.drawHeight=this.element.height,this.drawX=this.drawWidth/2,this.drawY=this.drawHeight/2,this.minSide=this.drawX<this.drawY?this.drawX:this.drawY,this.elementClone.initialized=!1,this.contextClone.translate(this.drawX,this.drawY),this.contextClone.save(),this.context.translate(this.drawX,this.drawY),this.context.save(),this.context.max=this.contextClone.max=this.minSide,this.context.maxRadius=this.contextClone.maxRadius=null}},{key:"destroy",value:function(){var t=e.collection.indexOf(this);~t&&e.collection.splice(t,1),this.context.clearRect(-this.drawX,-this.drawY,this.drawWidth,this.drawHeight),this.context.max=null,delete this.context.max,this.context.maxRadius=null,delete this.context.maxRadius,this.context=null,this.contextClone=null,this.elementClone=null,this.element=null,this.onRedraw=null}},{key:"commit",value:function(){var t=e.pixelRatio;return 1!==t&&(this.contextClone.scale(t,t),this.contextClone.save()),this}},{key:"redraw",value:function(){return this.init(),this.onRedraw&&this.onRedraw(),this
	}}],[{key:"redraw",value:function(){for(var t=0,i=e.collection.length;t<i;t++)e.collection[t].redraw()}},{key:"pixelRatio",get:function(){return window.devicePixelRatio||1}}]),e}();pe.collection=[],window.matchMedia&&window.matchMedia("screen and (min-resolution: 2dppx)").addListener(pe.redraw);var we={renderTo:null,width:0,height:0,minValue:0,maxValue:100,value:0,units:!1,exactTicks:!1,majorTicks:[0,20,40,60,80,100],minorTicks:10,strokeTicks:!0,animatedValue:!1,animateOnInit:!1,title:!1,borders:!0,numbersMargin:1,listeners:null,valueInt:3,valueDec:2,majorTicksInt:1,majorTicksDec:0,animation:!0,animationDuration:500,animationRule:"cycle",colorPlate:"#fff",colorPlateEnd:"",colorMajorTicks:"#444",colorMinorTicks:"#666",colorStrokeTicks:"",colorTitle:"#888",colorUnits:"#888",colorNumbers:"#444",colorNeedle:"rgba(240,128,128,1)",colorNeedleEnd:"rgba(255,160,122,.9)",colorValueText:"#444",colorValueTextShadow:"rgba(0,0,0,0.3)",colorBorderShadow:"rgba(0,0,0,0.5)",colorBorderOuter:"#ddd",colorBorderOuterEnd:"#aaa",colorBorderMiddle:"#eee",colorBorderMiddleEnd:"#f0f0f0",colorBorderInner:"#fafafa",colorBorderInnerEnd:"#ccc",colorValueBoxRect:"#888",colorValueBoxRectEnd:"#666",colorValueBoxBackground:"#babab2",colorValueBoxShadow:"rgba(0,0,0,1)",colorNeedleShadowUp:"rgba(2,255,255,0.2)",colorNeedleShadowDown:"rgba(188,143,143,0.45)",colorBarStroke:"#222",colorBar:"#ccc",colorBarProgress:"#888",colorBarShadow:"#000",fontNumbers:"Arial",fontTitle:"Arial",fontUnits:"Arial",fontValue:"Arial",fontNumbersSize:20,fontTitleSize:24,fontUnitsSize:22,fontValueSize:26,fontNumbersStyle:"normal",fontTitleStyle:"normal",fontUnitsStyle:"normal",fontValueStyle:"normal",fontNumbersWeight:"normal",fontTitleWeight:"normal",fontUnitsWeight:"normal",fontValueWeight:"normal",needle:!0,needleShadow:!0,needleType:"arrow",needleStart:5,needleEnd:85,needleWidth:4,borderOuterWidth:3,borderMiddleWidth:3,borderInnerWidth:3,borderShadowWidth:3,valueBox:!0,valueBoxStroke:5,valueBoxWidth:0,valueText:"",valueTextShadow:!0,valueBoxBorderRadius:2.5,highlights:[{from:20,to:60,color:"#eee"},{from:60,to:80,color:"#ccc"},{from:80,to:100,color:"#999"}],highlightsWidth:15,highlightsLineCap:"butt",barWidth:20,barStrokeWidth:0,barProgress:!0,barShadow:0};l.prototype=Object.create(Array.prototype),l.prototype.constructor=l,l.prototype.get=function(e){if("string"==typeof e)for(var t=0,i=this.length;t<i;t++){var r=this[t].options.renderTo.tagName?this[t].options.renderTo:document.getElementById(this[t].options.renderTo||"");if(r.getAttribute("id")===e)return this[t]}else if("number"==typeof e)return this[e];return null};var ke="2.1.7",ye=Math.round,xe=Math.abs,Te=new l;Te.version=ke;var Se=function(t){function n(t){o(this,n);var r=i(this,(n.__proto__||Object.getPrototypeOf(n)).call(this)),a=r.constructor.name;if("BaseGauge"===a)throw new TypeError("Attempt to instantiate abstract class!");if(Te.push(r),t.listeners&&Object.keys(t.listeners).forEach(function(e){(t.listeners[e]instanceof Array?t.listeners[e]:[t.listeners[e]]).forEach(function(t){r.on(e,t)})}),r.version=ke,r.type=e[a]||n,r.initialized=!1,t.minValue=parseFloat(t.minValue),t.maxValue=parseFloat(t.maxValue),t.value=parseFloat(t.value)||0,t.borders||(t.borderInnerWidth=t.borderMiddleWidth=t.borderOuterWidth=0),!t.renderTo)throw TypeError("Canvas element was not specified when creating the Gauge object!");var l=t.renderTo.tagName?t.renderTo:document.getElementById(t.renderTo);if(!(l instanceof HTMLCanvasElement))throw TypeError("Given gauge canvas element is invalid!");return t.width=parseFloat(t.width)||0,t.height=parseFloat(t.height)||0,t.width&&t.height||(t.width||(t.width=l.parentNode?l.parentNode.offsetWidth:l.offsetWidth),t.height||(t.height=l.parentNode?l.parentNode.offsetHeight:l.offsetHeight)),r.options=t||{},r.options.animateOnInit&&(r._value=r.options.value,r.options.value=r.options.minValue),r.canvas=new pe(l,t.width,t.height),r.canvas.onRedraw=r.draw.bind(r),r.animation=new ge(t.animationRule,t.animationDuration),r}return r(n,t),ue(n,[{key:"update",value:function(e){return Object.assign(this.options,this.type.configure(e||{})),this.canvas.width=this.options.width,this.canvas.height=this.options.height,this.animation.rule=this.options.animationRule,this.animation.duration=this.options.animationDuration,this.canvas.redraw(),this}},{key:"destroy",value:function(){var e=Te.indexOf(this);~e&&Te.splice(e,1),this.canvas.destroy(),this.canvas=null,this.animation.destroy(),this.animation=null,this.emit("destroy")}},{key:"draw",value:function(){return this.options.animateOnInit&&!this.initialized&&(this.value=this._value,this.initialized=!0,this.emit("init")),this.emit("render"),this}},{key:"value",set:function(e){var t=this;e=n.ensureValue(e,this.options.minValue);var i=this.options.value;if(e!==i)if(this.options.animation){if(this.animation.frame&&(this.options.value=this._value,this._value===e))return this.animation.cancel(),void delete this._value;void 0===this._value&&(this._value=e),this.emit("animationStart"),this.animation.animate(function(r){var o=i+(e-i)*r;t.options.animatedValue&&t.emit("value",o,t.value),t.options.value=o,t.draw(),t.emit("animate",r,t.options.value)},function(){void 0!==t._value&&(t.emit("value",t._value,t.value),t.options.value=t._value,delete t._value),t.draw(),t.emit("animationEnd")})}else this.emit("value",e,this.value),this.options.value=e,this.draw()},get:function(){return void 0===this._value?this.options.value:this._value}}],[{key:"configure",value:function(e){return e}},{key:"initialize",value:function(e,t){return new be(t,"canvas",e)}},{key:"fromElement",value:function(e){var t=be.toCamelCase(e.getAttribute("data-type")),i=e.attributes,r=0,o=i.length,n={};if(t){for(/Gauge$/.test(t)||(t+="Gauge");r<o;r++)n[be.toCamelCase(i[r].name.replace(/^data-/,""),!1)]=be.parse(i[r].value);new be(n,e.tagName,t).process(e)}}},{key:"ensureValue",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return e=parseFloat(e),!isNaN(e)&&isFinite(e)||(e=parseFloat(t)||0),e}},{key:"mod",value:function(e,t){return(e%t+t)%t}},{key:"version",get:function(){return ke}}]),n}(fe);void 0!==e&&(e.BaseGauge=Se,e.gauges=(window.document||{}).gauges=Te);var Ve=/{([_a-zA-Z]+[_a-zA-Z0-9]*)}/g,We={roundRect:h,padValue:u,formatMajorTickNumber:f,radians:m,radialPoint:v,linearGradient:g,drawNeedleShadow:p,drawValueBox:x,verifyError:s,prepareTicks:c,drawShadow:b,font:w,normalizedValue:T,formatContext:d},Oe=Math.PI,Ae=Oe/2,Pe=Object.assign({},we,{ticksAngle:270,startAngle:45,colorNeedleCircleOuter:"#f0f0f0",colorNeedleCircleOuterEnd:"#ccc",colorNeedleCircleInner:"#e8e8e8",colorNeedleCircleInnerEnd:"#f5f5f5",needleCircleSize:10,needleCircleInner:!0,needleCircleOuter:!0,needleStart:20,animationTarget:"needle",useMinPath:!1,barWidth:0,barStartPosition:"left"}),Me=function(e){function t(e){return o(this,t),e=Object.assign({},Pe,e||{}),i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,t.configure(e)))}return r(t,e),ue(t,[{key:"draw",value:function(){try{var e=this.canvas,i=[-e.drawX,-e.drawY,e.drawWidth,e.drawHeight],r=i[0],o=i[1],n=i[2],a=i[3],l=this.options;if("needle"===l.animationTarget){if(!e.elementClone.initialized){var s=e.contextClone;s.clearRect(r,o,n,a),s.save(),this.emit("beforePlate"),W(s,l),this.emit("beforeHighlights"),O(s,l),this.emit("beforeMinorTicks"),A(s,l),this.emit("beforeMajorTicks"),M(s,l),this.emit("beforeNumbers"),j(s,l),this.emit("beforeTitle"),N(s,l),this.emit("beforeUnits"),E(s,l),e.elementClone.initialized=!0}this.canvas.commit(),e.context.clearRect(r,o,n,a),e.context.save(),e.context.drawImage(e.elementClone,r,o,n,a),e.context.save(),this.emit("beforeProgressBar"),D(e.context,l),this.emit("beforeValueBox"),R(e.context,l,z(this)),this.emit("beforeNeedle"),_(e.context,l)}else{var d=-We.radians((l.value-l.minValue)/(l.maxValue-l.minValue)*l.ticksAngle);if(e.context.clearRect(r,o,n,a),e.context.save(),this.emit("beforePlate"),W(e.context,l),e.context.rotate(d),this.emit("beforeHighlights"),O(e.context,l),this.emit("beforeMinorTicks"),A(e.context,l),this.emit("beforeMajorTicks"),M(e.context,l),this.emit("beforeNumbers"),j(e.context,l),this.emit("beforeProgressBar"),D(e.context,l),e.context.rotate(-d),e.context.save(),!e.elementClone.initialized){var c=e.contextClone;c.clearRect(r,o,n,a),c.save(),this.emit("beforeTitle"),N(c,l),this.emit("beforeUnits"),E(c,l),this.emit("beforeNeedle"),_(c,l),e.elementClone.initialized=!0}e.context.drawImage(e.elementClone,r,o,n,a)}this.emit("beforeValueBox"),R(e.context,l,z(this)),ce(t.prototype.__proto__||Object.getPrototypeOf(t.prototype),"draw",this).call(this)}catch(e){We.verifyError(e)}return this}},{key:"value",set:function(e){e=Se.ensureValue(e,this.options.minValue),this.options.animation&&360===this.options.ticksAngle&&this.options.useMinPath&&(this._value=e,e=this.options.value+((e-this.options.value)%360+540)%360-180),he(t.prototype.__proto__||Object.getPrototypeOf(t.prototype),"value",e,this)},get:function(){return ce(t.prototype.__proto__||Object.getPrototypeOf(t.prototype),"value",this)}}],[{key:"configure",value:function(e){return e.barWidth>50&&(e.barWidth=50),isNaN(e.startAngle)&&(e.startAngle=45),isNaN(e.ticksAngle)&&(e.ticksAngle=270),e.ticksAngle>360&&(e.ticksAngle=360),e.ticksAngle<0&&(e.ticksAngle=0),e.startAngle<0&&(e.startAngle=0),e.startAngle>360&&(e.startAngle=360),e}}]),t}(Se);void 0!==e&&(e.RadialGauge=Me),Se.initialize("RadialGauge",Pe);var Be=Object.assign({},we,{borderRadius:0,barBeginCircle:30,colorBarEnd:"",colorBarProgressEnd:"",needleWidth:6,tickSide:"both",needleSide:"both",numberSide:"both",ticksWidth:10,ticksWidthMinor:5,ticksPadding:5,barLength:85,fontTitleSize:26,highlightsWidth:10}),Ce=function(e){function n(e){return o(this,n),e=Object.assign({},Be,e||{}),i(this,(n.__proto__||Object.getPrototypeOf(n)).call(this,n.configure(e)))}return r(n,e),ue(n,[{key:"draw",value:function(){try{var e=this.canvas,i=[-e.drawX,-e.drawY,e.drawWidth,e.drawHeight],r=i[0],o=i[1],a=i[2],l=i[3],s=this.options;if(!e.elementClone.initialized){var d=e.contextClone;d.clearRect(r,o,a,l),d.save(),this.emit("beforePlate"),this.drawBox=F(d,s,r,o,a,l),this.emit("beforeBar"),U.apply(void 0,[d,s].concat(t(this.drawBox))),e.context.barDimensions=d.barDimensions,this.emit("beforeHighlights"),J(d,s),this.emit("beforeMinorTicks"),ee(d,s),this.emit("beforeMajorTicks"),K(d,s),this.emit("beforeNumbers"),te(d,s),this.emit("beforeTitle"),ie(d,s),this.emit("beforeUnits"),re(d,s),e.elementClone.initialized=!0}this.canvas.commit(),e.context.clearRect(r,o,a,l),e.context.save(),e.context.drawImage(e.elementClone,r,o,a,l),e.context.save(),this.emit("beforeProgressBar"),H.apply(void 0,[e.context,s].concat(t(this.drawBox))),this.emit("beforeNeedle"),oe(e.context,s),this.emit("beforeValueBox"),se.apply(void 0,[e.context,s,s.animatedValue?this.options.value:this.value].concat(t(this.drawBox))),ce(n.prototype.__proto__||Object.getPrototypeOf(n.prototype),"draw",this).call(this)}catch(e){We.verifyError(e)}return this}}],[{key:"configure",value:function(e){return e.barStrokeWidth>=e.barWidth&&(e.barStrokeWidth=ye(e.barWidth/2)),e.hasLeft=q("right",e),e.hasRight=q("left",e),e.value>e.maxValue&&(e.value=e.maxValue),e.value<e.minValue&&(e.value=e.minValue),Se.configure(e)}}]),n}(Se);void 0!==e&&(e.LinearGauge=Ce),Se.initialize("LinearGauge",Be),"undefined"!=typeof module&&Object.assign(e,{Collection:l,GenericOptions:we,Animation:ge,BaseGauge:Se,drawings:We,SmartCanvas:pe,DomObserver:be,vendorize:n})}( true?module.exports:window);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Chart.js v2.9.4
	 * https://www.chartjs.org
	 * (c) 2020 Chart.js Contributors
	 * Released under the MIT License
	 */
	(function (global, factory) {
	 true ? module.exports = factory(function() { try { return __webpack_require__(6); } catch(e) { } }()) :
	typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
	(global = global || self, global.Chart = factory(global.moment));
	}(this, (function (moment) { 'use strict';
	
	moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	function getCjsExportFromNamespace (n) {
		return n && n['default'] || n;
	}
	
	var colorName = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};
	
	var conversions = createCommonjsModule(function (module) {
	/* MIT license */
	
	
	// NOTE: conversions should only return primitive values (i.e. arrays, or
	//       values that give correct `typeof` results).
	//       do not use box values types (i.e. Number(), String(), etc.)
	
	var reverseKeywords = {};
	for (var key in colorName) {
		if (colorName.hasOwnProperty(key)) {
			reverseKeywords[colorName[key]] = key;
		}
	}
	
	var convert = module.exports = {
		rgb: {channels: 3, labels: 'rgb'},
		hsl: {channels: 3, labels: 'hsl'},
		hsv: {channels: 3, labels: 'hsv'},
		hwb: {channels: 3, labels: 'hwb'},
		cmyk: {channels: 4, labels: 'cmyk'},
		xyz: {channels: 3, labels: 'xyz'},
		lab: {channels: 3, labels: 'lab'},
		lch: {channels: 3, labels: 'lch'},
		hex: {channels: 1, labels: ['hex']},
		keyword: {channels: 1, labels: ['keyword']},
		ansi16: {channels: 1, labels: ['ansi16']},
		ansi256: {channels: 1, labels: ['ansi256']},
		hcg: {channels: 3, labels: ['h', 'c', 'g']},
		apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
		gray: {channels: 1, labels: ['gray']}
	};
	
	// hide .channels and .labels properties
	for (var model in convert) {
		if (convert.hasOwnProperty(model)) {
			if (!('channels' in convert[model])) {
				throw new Error('missing channels property: ' + model);
			}
	
			if (!('labels' in convert[model])) {
				throw new Error('missing channel labels property: ' + model);
			}
	
			if (convert[model].labels.length !== convert[model].channels) {
				throw new Error('channel and label counts mismatch: ' + model);
			}
	
			var channels = convert[model].channels;
			var labels = convert[model].labels;
			delete convert[model].channels;
			delete convert[model].labels;
			Object.defineProperty(convert[model], 'channels', {value: channels});
			Object.defineProperty(convert[model], 'labels', {value: labels});
		}
	}
	
	convert.rgb.hsl = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var l;
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		l = (min + max) / 2;
	
		if (max === min) {
			s = 0;
		} else if (l <= 0.5) {
			s = delta / (max + min);
		} else {
			s = delta / (2 - max - min);
		}
	
		return [h, s * 100, l * 100];
	};
	
	convert.rgb.hsv = function (rgb) {
		var rdif;
		var gdif;
		var bdif;
		var h;
		var s;
	
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var v = Math.max(r, g, b);
		var diff = v - Math.min(r, g, b);
		var diffc = function (c) {
			return (v - c) / 6 / diff + 1 / 2;
		};
	
		if (diff === 0) {
			h = s = 0;
		} else {
			s = diff / v;
			rdif = diffc(r);
			gdif = diffc(g);
			bdif = diffc(b);
	
			if (r === v) {
				h = bdif - gdif;
			} else if (g === v) {
				h = (1 / 3) + rdif - bdif;
			} else if (b === v) {
				h = (2 / 3) + gdif - rdif;
			}
			if (h < 0) {
				h += 1;
			} else if (h > 1) {
				h -= 1;
			}
		}
	
		return [
			h * 360,
			s * 100,
			v * 100
		];
	};
	
	convert.rgb.hwb = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var h = convert.rgb.hsl(rgb)[0];
		var w = 1 / 255 * Math.min(r, Math.min(g, b));
	
		b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
	
		return [h, w * 100, b * 100];
	};
	
	convert.rgb.cmyk = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var c;
		var m;
		var y;
		var k;
	
		k = Math.min(1 - r, 1 - g, 1 - b);
		c = (1 - r - k) / (1 - k) || 0;
		m = (1 - g - k) / (1 - k) || 0;
		y = (1 - b - k) / (1 - k) || 0;
	
		return [c * 100, m * 100, y * 100, k * 100];
	};
	
	/**
	 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	 * */
	function comparativeDistance(x, y) {
		return (
			Math.pow(x[0] - y[0], 2) +
			Math.pow(x[1] - y[1], 2) +
			Math.pow(x[2] - y[2], 2)
		);
	}
	
	convert.rgb.keyword = function (rgb) {
		var reversed = reverseKeywords[rgb];
		if (reversed) {
			return reversed;
		}
	
		var currentClosestDistance = Infinity;
		var currentClosestKeyword;
	
		for (var keyword in colorName) {
			if (colorName.hasOwnProperty(keyword)) {
				var value = colorName[keyword];
	
				// Compute comparative distance
				var distance = comparativeDistance(rgb, value);
	
				// Check if its less, if so set as closest
				if (distance < currentClosestDistance) {
					currentClosestDistance = distance;
					currentClosestKeyword = keyword;
				}
			}
		}
	
		return currentClosestKeyword;
	};
	
	convert.keyword.rgb = function (keyword) {
		return colorName[keyword];
	};
	
	convert.rgb.xyz = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
	
		// assume sRGB
		r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
		g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
		b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
		var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
		var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
		var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
		return [x * 100, y * 100, z * 100];
	};
	
	convert.rgb.lab = function (rgb) {
		var xyz = convert.rgb.xyz(rgb);
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.hsl.rgb = function (hsl) {
		var h = hsl[0] / 360;
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var t1;
		var t2;
		var t3;
		var rgb;
		var val;
	
		if (s === 0) {
			val = l * 255;
			return [val, val, val];
		}
	
		if (l < 0.5) {
			t2 = l * (1 + s);
		} else {
			t2 = l + s - l * s;
		}
	
		t1 = 2 * l - t2;
	
		rgb = [0, 0, 0];
		for (var i = 0; i < 3; i++) {
			t3 = h + 1 / 3 * -(i - 1);
			if (t3 < 0) {
				t3++;
			}
			if (t3 > 1) {
				t3--;
			}
	
			if (6 * t3 < 1) {
				val = t1 + (t2 - t1) * 6 * t3;
			} else if (2 * t3 < 1) {
				val = t2;
			} else if (3 * t3 < 2) {
				val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
			} else {
				val = t1;
			}
	
			rgb[i] = val * 255;
		}
	
		return rgb;
	};
	
	convert.hsl.hsv = function (hsl) {
		var h = hsl[0];
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var smin = s;
		var lmin = Math.max(l, 0.01);
		var sv;
		var v;
	
		l *= 2;
		s *= (l <= 1) ? l : 2 - l;
		smin *= lmin <= 1 ? lmin : 2 - lmin;
		v = (l + s) / 2;
		sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);
	
		return [h, sv * 100, v * 100];
	};
	
	convert.hsv.rgb = function (hsv) {
		var h = hsv[0] / 60;
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var hi = Math.floor(h) % 6;
	
		var f = h - Math.floor(h);
		var p = 255 * v * (1 - s);
		var q = 255 * v * (1 - (s * f));
		var t = 255 * v * (1 - (s * (1 - f)));
		v *= 255;
	
		switch (hi) {
			case 0:
				return [v, t, p];
			case 1:
				return [q, v, p];
			case 2:
				return [p, v, t];
			case 3:
				return [p, q, v];
			case 4:
				return [t, p, v];
			case 5:
				return [v, p, q];
		}
	};
	
	convert.hsv.hsl = function (hsv) {
		var h = hsv[0];
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var vmin = Math.max(v, 0.01);
		var lmin;
		var sl;
		var l;
	
		l = (2 - s) * v;
		lmin = (2 - s) * vmin;
		sl = s * vmin;
		sl /= (lmin <= 1) ? lmin : 2 - lmin;
		sl = sl || 0;
		l /= 2;
	
		return [h, sl * 100, l * 100];
	};
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	convert.hwb.rgb = function (hwb) {
		var h = hwb[0] / 360;
		var wh = hwb[1] / 100;
		var bl = hwb[2] / 100;
		var ratio = wh + bl;
		var i;
		var v;
		var f;
		var n;
	
		// wh + bl cant be > 1
		if (ratio > 1) {
			wh /= ratio;
			bl /= ratio;
		}
	
		i = Math.floor(6 * h);
		v = 1 - bl;
		f = 6 * h - i;
	
		if ((i & 0x01) !== 0) {
			f = 1 - f;
		}
	
		n = wh + f * (v - wh); // linear interpolation
	
		var r;
		var g;
		var b;
		switch (i) {
			default:
			case 6:
			case 0: r = v; g = n; b = wh; break;
			case 1: r = n; g = v; b = wh; break;
			case 2: r = wh; g = v; b = n; break;
			case 3: r = wh; g = n; b = v; break;
			case 4: r = n; g = wh; b = v; break;
			case 5: r = v; g = wh; b = n; break;
		}
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.cmyk.rgb = function (cmyk) {
		var c = cmyk[0] / 100;
		var m = cmyk[1] / 100;
		var y = cmyk[2] / 100;
		var k = cmyk[3] / 100;
		var r;
		var g;
		var b;
	
		r = 1 - Math.min(1, c * (1 - k) + k);
		g = 1 - Math.min(1, m * (1 - k) + k);
		b = 1 - Math.min(1, y * (1 - k) + k);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.rgb = function (xyz) {
		var x = xyz[0] / 100;
		var y = xyz[1] / 100;
		var z = xyz[2] / 100;
		var r;
		var g;
		var b;
	
		r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
		g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
		b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
		// assume sRGB
		r = r > 0.0031308
			? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
			: r * 12.92;
	
		g = g > 0.0031308
			? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
			: g * 12.92;
	
		b = b > 0.0031308
			? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
			: b * 12.92;
	
		r = Math.min(Math.max(0, r), 1);
		g = Math.min(Math.max(0, g), 1);
		b = Math.min(Math.max(0, b), 1);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.lab = function (xyz) {
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.lab.xyz = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var x;
		var y;
		var z;
	
		y = (l + 16) / 116;
		x = a / 500 + y;
		z = y - b / 200;
	
		var y2 = Math.pow(y, 3);
		var x2 = Math.pow(x, 3);
		var z2 = Math.pow(z, 3);
		y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
		x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
		z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
	
		x *= 95.047;
		y *= 100;
		z *= 108.883;
	
		return [x, y, z];
	};
	
	convert.lab.lch = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var hr;
		var h;
		var c;
	
		hr = Math.atan2(b, a);
		h = hr * 360 / 2 / Math.PI;
	
		if (h < 0) {
			h += 360;
		}
	
		c = Math.sqrt(a * a + b * b);
	
		return [l, c, h];
	};
	
	convert.lch.lab = function (lch) {
		var l = lch[0];
		var c = lch[1];
		var h = lch[2];
		var a;
		var b;
		var hr;
	
		hr = h / 360 * 2 * Math.PI;
		a = c * Math.cos(hr);
		b = c * Math.sin(hr);
	
		return [l, a, b];
	};
	
	convert.rgb.ansi16 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
		var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
	
		value = Math.round(value / 50);
	
		if (value === 0) {
			return 30;
		}
	
		var ansi = 30
			+ ((Math.round(b / 255) << 2)
			| (Math.round(g / 255) << 1)
			| Math.round(r / 255));
	
		if (value === 2) {
			ansi += 60;
		}
	
		return ansi;
	};
	
	convert.hsv.ansi16 = function (args) {
		// optimization here; we already know the value and don't need to get
		// it converted for us.
		return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
	};
	
	convert.rgb.ansi256 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
	
		// we use the extended greyscale palette here, with the exception of
		// black and white. normal palette only has 4 greyscale shades.
		if (r === g && g === b) {
			if (r < 8) {
				return 16;
			}
	
			if (r > 248) {
				return 231;
			}
	
			return Math.round(((r - 8) / 247) * 24) + 232;
		}
	
		var ansi = 16
			+ (36 * Math.round(r / 255 * 5))
			+ (6 * Math.round(g / 255 * 5))
			+ Math.round(b / 255 * 5);
	
		return ansi;
	};
	
	convert.ansi16.rgb = function (args) {
		var color = args % 10;
	
		// handle greyscale
		if (color === 0 || color === 7) {
			if (args > 50) {
				color += 3.5;
			}
	
			color = color / 10.5 * 255;
	
			return [color, color, color];
		}
	
		var mult = (~~(args > 50) + 1) * 0.5;
		var r = ((color & 1) * mult) * 255;
		var g = (((color >> 1) & 1) * mult) * 255;
		var b = (((color >> 2) & 1) * mult) * 255;
	
		return [r, g, b];
	};
	
	convert.ansi256.rgb = function (args) {
		// handle greyscale
		if (args >= 232) {
			var c = (args - 232) * 10 + 8;
			return [c, c, c];
		}
	
		args -= 16;
	
		var rem;
		var r = Math.floor(args / 36) / 5 * 255;
		var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
		var b = (rem % 6) / 5 * 255;
	
		return [r, g, b];
	};
	
	convert.rgb.hex = function (args) {
		var integer = ((Math.round(args[0]) & 0xFF) << 16)
			+ ((Math.round(args[1]) & 0xFF) << 8)
			+ (Math.round(args[2]) & 0xFF);
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.hex.rgb = function (args) {
		var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
		if (!match) {
			return [0, 0, 0];
		}
	
		var colorString = match[0];
	
		if (match[0].length === 3) {
			colorString = colorString.split('').map(function (char) {
				return char + char;
			}).join('');
		}
	
		var integer = parseInt(colorString, 16);
		var r = (integer >> 16) & 0xFF;
		var g = (integer >> 8) & 0xFF;
		var b = integer & 0xFF;
	
		return [r, g, b];
	};
	
	convert.rgb.hcg = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var max = Math.max(Math.max(r, g), b);
		var min = Math.min(Math.min(r, g), b);
		var chroma = (max - min);
		var grayscale;
		var hue;
	
		if (chroma < 1) {
			grayscale = min / (1 - chroma);
		} else {
			grayscale = 0;
		}
	
		if (chroma <= 0) {
			hue = 0;
		} else
		if (max === r) {
			hue = ((g - b) / chroma) % 6;
		} else
		if (max === g) {
			hue = 2 + (b - r) / chroma;
		} else {
			hue = 4 + (r - g) / chroma + 4;
		}
	
		hue /= 6;
		hue %= 1;
	
		return [hue * 360, chroma * 100, grayscale * 100];
	};
	
	convert.hsl.hcg = function (hsl) {
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var c = 1;
		var f = 0;
	
		if (l < 0.5) {
			c = 2.0 * s * l;
		} else {
			c = 2.0 * s * (1.0 - l);
		}
	
		if (c < 1.0) {
			f = (l - 0.5 * c) / (1.0 - c);
		}
	
		return [hsl[0], c * 100, f * 100];
	};
	
	convert.hsv.hcg = function (hsv) {
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
	
		var c = s * v;
		var f = 0;
	
		if (c < 1.0) {
			f = (v - c) / (1 - c);
		}
	
		return [hsv[0], c * 100, f * 100];
	};
	
	convert.hcg.rgb = function (hcg) {
		var h = hcg[0] / 360;
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		if (c === 0.0) {
			return [g * 255, g * 255, g * 255];
		}
	
		var pure = [0, 0, 0];
		var hi = (h % 1) * 6;
		var v = hi % 1;
		var w = 1 - v;
		var mg = 0;
	
		switch (Math.floor(hi)) {
			case 0:
				pure[0] = 1; pure[1] = v; pure[2] = 0; break;
			case 1:
				pure[0] = w; pure[1] = 1; pure[2] = 0; break;
			case 2:
				pure[0] = 0; pure[1] = 1; pure[2] = v; break;
			case 3:
				pure[0] = 0; pure[1] = w; pure[2] = 1; break;
			case 4:
				pure[0] = v; pure[1] = 0; pure[2] = 1; break;
			default:
				pure[0] = 1; pure[1] = 0; pure[2] = w;
		}
	
		mg = (1.0 - c) * g;
	
		return [
			(c * pure[0] + mg) * 255,
			(c * pure[1] + mg) * 255,
			(c * pure[2] + mg) * 255
		];
	};
	
	convert.hcg.hsv = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var v = c + g * (1.0 - c);
		var f = 0;
	
		if (v > 0.0) {
			f = c / v;
		}
	
		return [hcg[0], f * 100, v * 100];
	};
	
	convert.hcg.hsl = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var l = g * (1.0 - c) + 0.5 * c;
		var s = 0;
	
		if (l > 0.0 && l < 0.5) {
			s = c / (2 * l);
		} else
		if (l >= 0.5 && l < 1.0) {
			s = c / (2 * (1 - l));
		}
	
		return [hcg[0], s * 100, l * 100];
	};
	
	convert.hcg.hwb = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
		var v = c + g * (1.0 - c);
		return [hcg[0], (v - c) * 100, (1 - v) * 100];
	};
	
	convert.hwb.hcg = function (hwb) {
		var w = hwb[1] / 100;
		var b = hwb[2] / 100;
		var v = 1 - b;
		var c = v - w;
		var g = 0;
	
		if (c < 1) {
			g = (v - c) / (1 - c);
		}
	
		return [hwb[0], c * 100, g * 100];
	};
	
	convert.apple.rgb = function (apple) {
		return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
	};
	
	convert.rgb.apple = function (rgb) {
		return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
	};
	
	convert.gray.rgb = function (args) {
		return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
	};
	
	convert.gray.hsl = convert.gray.hsv = function (args) {
		return [0, 0, args[0]];
	};
	
	convert.gray.hwb = function (gray) {
		return [0, 100, gray[0]];
	};
	
	convert.gray.cmyk = function (gray) {
		return [0, 0, 0, gray[0]];
	};
	
	convert.gray.lab = function (gray) {
		return [gray[0], 0, 0];
	};
	
	convert.gray.hex = function (gray) {
		var val = Math.round(gray[0] / 100 * 255) & 0xFF;
		var integer = (val << 16) + (val << 8) + val;
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.rgb.gray = function (rgb) {
		var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
		return [val / 255 * 100];
	};
	});
	var conversions_1 = conversions.rgb;
	var conversions_2 = conversions.hsl;
	var conversions_3 = conversions.hsv;
	var conversions_4 = conversions.hwb;
	var conversions_5 = conversions.cmyk;
	var conversions_6 = conversions.xyz;
	var conversions_7 = conversions.lab;
	var conversions_8 = conversions.lch;
	var conversions_9 = conversions.hex;
	var conversions_10 = conversions.keyword;
	var conversions_11 = conversions.ansi16;
	var conversions_12 = conversions.ansi256;
	var conversions_13 = conversions.hcg;
	var conversions_14 = conversions.apple;
	var conversions_15 = conversions.gray;
	
	/*
		this function routes a model to all other models.
	
		all functions that are routed have a property `.conversion` attached
		to the returned synthetic function. This property is an array
		of strings, each with the steps in between the 'from' and 'to'
		color models (inclusive).
	
		conversions that are not possible simply are not included.
	*/
	
	function buildGraph() {
		var graph = {};
		// https://jsperf.com/object-keys-vs-for-in-with-closure/3
		var models = Object.keys(conversions);
	
		for (var len = models.length, i = 0; i < len; i++) {
			graph[models[i]] = {
				// http://jsperf.com/1-vs-infinity
				// micro-opt, but this is simple.
				distance: -1,
				parent: null
			};
		}
	
		return graph;
	}
	
	// https://en.wikipedia.org/wiki/Breadth-first_search
	function deriveBFS(fromModel) {
		var graph = buildGraph();
		var queue = [fromModel]; // unshift -> queue -> pop
	
		graph[fromModel].distance = 0;
	
		while (queue.length) {
			var current = queue.pop();
			var adjacents = Object.keys(conversions[current]);
	
			for (var len = adjacents.length, i = 0; i < len; i++) {
				var adjacent = adjacents[i];
				var node = graph[adjacent];
	
				if (node.distance === -1) {
					node.distance = graph[current].distance + 1;
					node.parent = current;
					queue.unshift(adjacent);
				}
			}
		}
	
		return graph;
	}
	
	function link(from, to) {
		return function (args) {
			return to(from(args));
		};
	}
	
	function wrapConversion(toModel, graph) {
		var path = [graph[toModel].parent, toModel];
		var fn = conversions[graph[toModel].parent][toModel];
	
		var cur = graph[toModel].parent;
		while (graph[cur].parent) {
			path.unshift(graph[cur].parent);
			fn = link(conversions[graph[cur].parent][cur], fn);
			cur = graph[cur].parent;
		}
	
		fn.conversion = path;
		return fn;
	}
	
	var route = function (fromModel) {
		var graph = deriveBFS(fromModel);
		var conversion = {};
	
		var models = Object.keys(graph);
		for (var len = models.length, i = 0; i < len; i++) {
			var toModel = models[i];
			var node = graph[toModel];
	
			if (node.parent === null) {
				// no possible conversion, or this node is the source model.
				continue;
			}
	
			conversion[toModel] = wrapConversion(toModel, graph);
		}
	
		return conversion;
	};
	
	var convert = {};
	
	var models = Object.keys(conversions);
	
	function wrapRaw(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			return fn(args);
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	function wrapRounded(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			var result = fn(args);
	
			// we're assuming the result is an array here.
			// see notice in conversions.js; don't use box types
			// in conversion functions.
			if (typeof result === 'object') {
				for (var len = result.length, i = 0; i < len; i++) {
					result[i] = Math.round(result[i]);
				}
			}
	
			return result;
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	models.forEach(function (fromModel) {
		convert[fromModel] = {};
	
		Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
		Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});
	
		var routes = route(fromModel);
		var routeModels = Object.keys(routes);
	
		routeModels.forEach(function (toModel) {
			var fn = routes[toModel];
	
			convert[fromModel][toModel] = wrapRounded(fn);
			convert[fromModel][toModel].raw = wrapRaw(fn);
		});
	});
	
	var colorConvert = convert;
	
	var colorName$1 = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};
	
	/* MIT license */
	
	
	var colorString = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	};
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
	       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       keyword = /(\w+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr),
	       hexAlpha = "";
	   if (match) {
	      match = match[1];
	      hexAlpha = match[3];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(hex)) {
	      hexAlpha = match[2];
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorName$1[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgba, a) {
	   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
	   return "#" + hexDouble(rgba[0]) 
	              + hexDouble(rgba[1])
	              + hexDouble(rgba[2])
	              + (
	                 (a >= 0 && a < 1)
	                 ? hexDouble(Math.round(a * 255))
	                 : ""
	              );
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorName$1) {
	   reverseNames[colorName$1[name]] = name;
	}
	
	/* MIT license */
	
	
	
	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}
	
		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};
	
		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = colorString.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = colorString.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = colorString.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};
	
	Color.prototype = {
		isValid: function () {
			return this.valid;
		},
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},
	
		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function () {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},
	
		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},
	
		hexString: function () {
			return colorString.hexString(this.values.rgb);
		},
		rgbString: function () {
			return colorString.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return colorString.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return colorString.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return colorString.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return colorString.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return colorString.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return colorString.keyword(this.values.rgb, this.values.alpha);
		},
	
		rgbNumber: function () {
			var rgb = this.values.rgb;
			return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},
	
		lighten: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		darken: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		saturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		desaturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		whiten: function (ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		blacken: function (ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},
	
		clearer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - (alpha * ratio));
			return this;
		},
	
		opaquer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + (alpha * ratio));
			return this;
		},
	
		rotate: function (degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},
	
		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},
	
		toJSON: function () {
			return this.rgb();
		},
	
		clone: function () {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;
	
			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = ({}).toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}
	
			return result;
		}
	};
	
	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};
	
	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};
	
	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};
	
		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}
	
		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}
	
		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};
	
	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;
	
		this.valid = true;
	
		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}
	
			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];
	
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}
	
			alpha = vals.alpha;
		}
	
		values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));
	
		if (space === 'alpha') {
			return false;
		}
	
		var capped;
	
		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}
	
		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = colorConvert[space][sname](values[space]);
			}
		}
	
		return true;
	};
	
	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];
	
		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}
	
		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}
	
		this.setValues(space, vals);
		return this;
	};
	
	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}
	
		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);
	
		return this;
	};
	
	if (typeof window !== 'undefined') {
		window.Color = Color;
	}
	
	var chartjsColor = Color;
	
	function isValidKey(key) {
		return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
	}
	
	/**
	 * @namespace Chart.helpers
	 */
	var helpers = {
		/**
		 * An empty function that can be used, for example, for optional callback.
		 */
		noop: function() {},
	
		/**
		 * Returns a unique id, sequentially generated from a global variable.
		 * @returns {number}
		 * @function
		 */
		uid: (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}()),
	
		/**
		 * Returns true if `value` is neither null nor undefined, else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @since 2.7.0
		 */
		isNullOrUndef: function(value) {
			return value === null || typeof value === 'undefined';
		},
	
		/**
		 * Returns true if `value` is an array (including typed arrays), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @function
		 */
		isArray: function(value) {
			if (Array.isArray && Array.isArray(value)) {
				return true;
			}
			var type = Object.prototype.toString.call(value);
			if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
				return true;
			}
			return false;
		},
	
		/**
		 * Returns true if `value` is an object (excluding null), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @since 2.7.0
		 */
		isObject: function(value) {
			return value !== null && Object.prototype.toString.call(value) === '[object Object]';
		},
	
		/**
		 * Returns true if `value` is a finite number, else returns false
		 * @param {*} value  - The value to test.
		 * @returns {boolean}
		 */
		isFinite: function(value) {
			return (typeof value === 'number' || value instanceof Number) && isFinite(value);
		},
	
		/**
		 * Returns `value` if defined, else returns `defaultValue`.
		 * @param {*} value - The value to return if defined.
		 * @param {*} defaultValue - The value to return if `value` is undefined.
		 * @returns {*}
		 */
		valueOrDefault: function(value, defaultValue) {
			return typeof value === 'undefined' ? defaultValue : value;
		},
	
		/**
		 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
		 * @param {Array} value - The array to lookup for value at `index`.
		 * @param {number} index - The index in `value` to lookup for value.
		 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
		 * @returns {*}
		 */
		valueAtIndexOrDefault: function(value, index, defaultValue) {
			return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
		},
	
		/**
		 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
		 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
		 * @param {function} fn - The function to call.
		 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
		 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @returns {*}
		 */
		callback: function(fn, args, thisArg) {
			if (fn && typeof fn.call === 'function') {
				return fn.apply(thisArg, args);
			}
		},
	
		/**
		 * Note(SB) for performance sake, this method should only be used when loopable type
		 * is unknown or in none intensive code (not called often and small loopable). Else
		 * it's preferable to use a regular for() loop and save extra function calls.
		 * @param {object|Array} loopable - The object or array to be iterated.
		 * @param {function} fn - The function to call for each item.
		 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
		 */
		each: function(loopable, fn, thisArg, reverse) {
			var i, len, keys;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						fn.call(thisArg, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						fn.call(thisArg, loopable[i], i);
					}
				}
			} else if (helpers.isObject(loopable)) {
				keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[keys[i]], keys[i]);
				}
			}
		},
	
		/**
		 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
		 * @see https://stackoverflow.com/a/14853974
		 * @param {Array} a0 - The array to compare
		 * @param {Array} a1 - The array to compare
		 * @returns {boolean}
		 */
		arrayEquals: function(a0, a1) {
			var i, ilen, v0, v1;
	
			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}
	
			for (i = 0, ilen = a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];
	
				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}
	
			return true;
		},
	
		/**
		 * Returns a deep copy of `source` without keeping references on objects and arrays.
		 * @param {*} source - The value to clone.
		 * @returns {*}
		 */
		clone: function(source) {
			if (helpers.isArray(source)) {
				return source.map(helpers.clone);
			}
	
			if (helpers.isObject(source)) {
				var target = Object.create(source);
				var keys = Object.keys(source);
				var klen = keys.length;
				var k = 0;
	
				for (; k < klen; ++k) {
					target[keys[k]] = helpers.clone(source[keys[k]]);
				}
	
				return target;
			}
	
			return source;
		},
	
		/**
		 * The default merger when Chart.helpers.merge is called without merger option.
		 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
		 * @private
		 */
		_merger: function(key, target, source, options) {
			if (!isValidKey(key)) {
				// We want to ensure we do not copy prototypes over
				// as this can pollute global namespaces
				return;
			}
	
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.merge(tval, sval, options);
			} else {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Merges source[key] in target[key] only if target[key] is undefined.
		 * @private
		 */
		_mergerIf: function(key, target, source) {
			if (!isValidKey(key)) {
				// We want to ensure we do not copy prototypes over
				// as this can pollute global namespaces
				return;
			}
	
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.mergeIf(tval, sval);
			} else if (!target.hasOwnProperty(key)) {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` with the given `options`.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {object} target - The target object in which all sources are merged into.
		 * @param {object|object[]} source - Object(s) to merge into `target`.
		 * @param {object} [options] - Merging options:
		 * @param {function} [options.merger] - The merge method (key, target, source, options)
		 * @returns {object} The `target` object.
		 */
		merge: function(target, source, options) {
			var sources = helpers.isArray(source) ? source : [source];
			var ilen = sources.length;
			var merge, i, keys, klen, k;
	
			if (!helpers.isObject(target)) {
				return target;
			}
	
			options = options || {};
			merge = options.merger || helpers._merger;
	
			for (i = 0; i < ilen; ++i) {
				source = sources[i];
				if (!helpers.isObject(source)) {
					continue;
				}
	
				keys = Object.keys(source);
				for (k = 0, klen = keys.length; k < klen; ++k) {
					merge(keys[k], target, source, options);
				}
			}
	
			return target;
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {object} target - The target object in which all sources are merged into.
		 * @param {object|object[]} source - Object(s) to merge into `target`.
		 * @returns {object} The `target` object.
		 */
		mergeIf: function(target, source) {
			return helpers.merge(target, source, {merger: helpers._mergerIf});
		},
	
		/**
		 * Applies the contents of two or more objects together into the first object.
		 * @param {object} target - The target object in which all objects are merged into.
		 * @param {object} arg1 - Object containing additional properties to merge in target.
		 * @param {object} argN - Additional objects containing properties to merge in target.
		 * @returns {object} The `target` object.
		 */
		extend: Object.assign || function(target) {
			return helpers.merge(target, [].slice.call(arguments, 1), {
				merger: function(key, dst, src) {
					dst[key] = src[key];
				}
			});
		},
	
		/**
		 * Basic javascript inheritance based on the model created in Backbone.js
		 */
		inherits: function(extensions) {
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};
	
			var Surrogate = function() {
				this.constructor = ChartElement;
			};
	
			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
			ChartElement.extend = helpers.inherits;
	
			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}
	
			ChartElement.__super__ = me.prototype;
			return ChartElement;
		},
	
		_deprecated: function(scope, value, previous, current) {
			if (value !== undefined) {
				console.warn(scope + ': "' + previous +
					'" is deprecated. Please use "' + current + '" instead');
			}
		}
	};
	
	var helpers_core = helpers;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.callback instead.
	 * @function Chart.helpers.callCallback
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.callCallback = helpers.callback;
	
	/**
	 * Provided for backward compatibility, use Array.prototype.indexOf instead.
	 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
	 * @function Chart.helpers.indexOf
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.indexOf = function(array, item, fromIndex) {
		return Array.prototype.indexOf.call(array, item, fromIndex);
	};
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
	 * @function Chart.helpers.getValueOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueOrDefault = helpers.valueOrDefault;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
	 * @function Chart.helpers.getValueAtIndexOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
	
	/**
	 * Easing functions adapted from Robert Penner's easing equations.
	 * @namespace Chart.helpers.easingEffects
	 * @see http://www.robertpenner.com/easing/
	 */
	var effects = {
		linear: function(t) {
			return t;
		},
	
		easeInQuad: function(t) {
			return t * t;
		},
	
		easeOutQuad: function(t) {
			return -t * (t - 2);
		},
	
		easeInOutQuad: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t;
			}
			return -0.5 * ((--t) * (t - 2) - 1);
		},
	
		easeInCubic: function(t) {
			return t * t * t;
		},
	
		easeOutCubic: function(t) {
			return (t = t - 1) * t * t + 1;
		},
	
		easeInOutCubic: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t + 2);
		},
	
		easeInQuart: function(t) {
			return t * t * t * t;
		},
	
		easeOutQuart: function(t) {
			return -((t = t - 1) * t * t * t - 1);
		},
	
		easeInOutQuart: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t;
			}
			return -0.5 * ((t -= 2) * t * t * t - 2);
		},
	
		easeInQuint: function(t) {
			return t * t * t * t * t;
		},
	
		easeOutQuint: function(t) {
			return (t = t - 1) * t * t * t * t + 1;
		},
	
		easeInOutQuint: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t * t * t + 2);
		},
	
		easeInSine: function(t) {
			return -Math.cos(t * (Math.PI / 2)) + 1;
		},
	
		easeOutSine: function(t) {
			return Math.sin(t * (Math.PI / 2));
		},
	
		easeInOutSine: function(t) {
			return -0.5 * (Math.cos(Math.PI * t) - 1);
		},
	
		easeInExpo: function(t) {
			return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
		},
	
		easeOutExpo: function(t) {
			return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
		},
	
		easeInOutExpo: function(t) {
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if ((t /= 0.5) < 1) {
				return 0.5 * Math.pow(2, 10 * (t - 1));
			}
			return 0.5 * (-Math.pow(2, -10 * --t) + 2);
		},
	
		easeInCirc: function(t) {
			if (t >= 1) {
				return t;
			}
			return -(Math.sqrt(1 - t * t) - 1);
		},
	
		easeOutCirc: function(t) {
			return Math.sqrt(1 - (t = t - 1) * t);
		},
	
		easeInOutCirc: function(t) {
			if ((t /= 0.5) < 1) {
				return -0.5 * (Math.sqrt(1 - t * t) - 1);
			}
			return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
		},
	
		easeInElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		},
	
		easeOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
		},
	
		easeInOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if ((t /= 0.5) === 2) {
				return 1;
			}
			if (!p) {
				p = 0.45;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			if (t < 1) {
				return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
			}
			return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
		},
		easeInBack: function(t) {
			var s = 1.70158;
			return t * t * ((s + 1) * t - s);
		},
	
		easeOutBack: function(t) {
			var s = 1.70158;
			return (t = t - 1) * t * ((s + 1) * t + s) + 1;
		},
	
		easeInOutBack: function(t) {
			var s = 1.70158;
			if ((t /= 0.5) < 1) {
				return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
			}
			return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
		},
	
		easeInBounce: function(t) {
			return 1 - effects.easeOutBounce(1 - t);
		},
	
		easeOutBounce: function(t) {
			if (t < (1 / 2.75)) {
				return 7.5625 * t * t;
			}
			if (t < (2 / 2.75)) {
				return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
			}
			if (t < (2.5 / 2.75)) {
				return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
			}
			return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
		},
	
		easeInOutBounce: function(t) {
			if (t < 0.5) {
				return effects.easeInBounce(t * 2) * 0.5;
			}
			return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
		}
	};
	
	var helpers_easing = {
		effects: effects
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
	 * @function Chart.helpers.easingEffects
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.easingEffects = effects;
	
	var PI = Math.PI;
	var RAD_PER_DEG = PI / 180;
	var DOUBLE_PI = PI * 2;
	var HALF_PI = PI / 2;
	var QUARTER_PI = PI / 4;
	var TWO_THIRDS_PI = PI * 2 / 3;
	
	/**
	 * @namespace Chart.helpers.canvas
	 */
	var exports$1 = {
		/**
		 * Clears the entire canvas associated to the given `chart`.
		 * @param {Chart} chart - The chart for which to clear the canvas.
		 */
		clear: function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		},
	
		/**
		 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
		 * given size (width, height) and the same `radius` for all corners.
		 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
		 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
		 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
		 * @param {number} width - The rectangle's width.
		 * @param {number} height - The rectangle's height.
		 * @param {number} radius - The rounded amount (in pixels) for the four corners.
		 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
		 */
		roundedRect: function(ctx, x, y, width, height, radius) {
			if (radius) {
				var r = Math.min(radius, height / 2, width / 2);
				var left = x + r;
				var top = y + r;
				var right = x + width - r;
				var bottom = y + height - r;
	
				ctx.moveTo(x, top);
				if (left < right && top < bottom) {
					ctx.arc(left, top, r, -PI, -HALF_PI);
					ctx.arc(right, top, r, -HALF_PI, 0);
					ctx.arc(right, bottom, r, 0, HALF_PI);
					ctx.arc(left, bottom, r, HALF_PI, PI);
				} else if (left < right) {
					ctx.moveTo(left, y);
					ctx.arc(right, top, r, -HALF_PI, HALF_PI);
					ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
				} else if (top < bottom) {
					ctx.arc(left, top, r, -PI, 0);
					ctx.arc(left, bottom, r, 0, PI);
				} else {
					ctx.arc(left, top, r, -PI, PI);
				}
				ctx.closePath();
				ctx.moveTo(x, y);
			} else {
				ctx.rect(x, y, width, height);
			}
		},
	
		drawPoint: function(ctx, style, radius, x, y, rotation) {
			var type, xOffset, yOffset, size, cornerRadius;
			var rad = (rotation || 0) * RAD_PER_DEG;
	
			if (style && typeof style === 'object') {
				type = style.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.save();
					ctx.translate(x, y);
					ctx.rotate(rad);
					ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
					ctx.restore();
					return;
				}
			}
	
			if (isNaN(radius) || radius <= 0) {
				return;
			}
	
			ctx.beginPath();
	
			switch (style) {
			// Default includes circle
			default:
				ctx.arc(x, y, radius, 0, DOUBLE_PI);
				ctx.closePath();
				break;
			case 'triangle':
				ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				rad += TWO_THIRDS_PI;
				ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				rad += TWO_THIRDS_PI;
				ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				ctx.closePath();
				break;
			case 'rectRounded':
				// NOTE: the rounded rect implementation changed to use `arc` instead of
				// `quadraticCurveTo` since it generates better results when rect is
				// almost a circle. 0.516 (instead of 0.5) produces results with visually
				// closer proportion to the previous impl and it is inscribed in the
				// circle with `radius`. For more details, see the following PRs:
				// https://github.com/chartjs/Chart.js/issues/5597
				// https://github.com/chartjs/Chart.js/issues/5858
				cornerRadius = radius * 0.516;
				size = radius - cornerRadius;
				xOffset = Math.cos(rad + QUARTER_PI) * size;
				yOffset = Math.sin(rad + QUARTER_PI) * size;
				ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
				ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
				ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
				ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
				ctx.closePath();
				break;
			case 'rect':
				if (!rotation) {
					size = Math.SQRT1_2 * radius;
					ctx.rect(x - size, y - size, 2 * size, 2 * size);
					break;
				}
				rad += QUARTER_PI;
				/* falls through */
			case 'rectRot':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + yOffset, y - xOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				ctx.closePath();
				break;
			case 'crossRot':
				rad += QUARTER_PI;
				/* falls through */
			case 'cross':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				break;
			case 'star':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				rad += QUARTER_PI;
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				break;
			case 'line':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				break;
			case 'dash':
				ctx.moveTo(x, y);
				ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
				break;
			}
	
			ctx.fill();
			ctx.stroke();
		},
	
		/**
		 * Returns true if the point is inside the rectangle
		 * @param {object} point - The point to test
		 * @param {object} area - The rectangle
		 * @returns {boolean}
		 * @private
		 */
		_isPointInArea: function(point, area) {
			var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
	
			return point.x > area.left - epsilon && point.x < area.right + epsilon &&
				point.y > area.top - epsilon && point.y < area.bottom + epsilon;
		},
	
		clipArea: function(ctx, area) {
			ctx.save();
			ctx.beginPath();
			ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
			ctx.clip();
		},
	
		unclipArea: function(ctx) {
			ctx.restore();
		},
	
		lineTo: function(ctx, previous, target, flip) {
			var stepped = target.steppedLine;
			if (stepped) {
				if (stepped === 'middle') {
					var midpoint = (previous.x + target.x) / 2.0;
					ctx.lineTo(midpoint, flip ? target.y : previous.y);
					ctx.lineTo(midpoint, flip ? previous.y : target.y);
				} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
					ctx.lineTo(previous.x, target.y);
				} else {
					ctx.lineTo(target.x, previous.y);
				}
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			if (!target.tension) {
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			ctx.bezierCurveTo(
				flip ? previous.controlPointPreviousX : previous.controlPointNextX,
				flip ? previous.controlPointPreviousY : previous.controlPointNextY,
				flip ? target.controlPointNextX : target.controlPointPreviousX,
				flip ? target.controlPointNextY : target.controlPointPreviousY,
				target.x,
				target.y);
		}
	};
	
	var helpers_canvas = exports$1;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
	 * @namespace Chart.helpers.clear
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.clear = exports$1.clear;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
	 * @namespace Chart.helpers.drawRoundedRectangle
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.drawRoundedRectangle = function(ctx) {
		ctx.beginPath();
		exports$1.roundedRect.apply(exports$1, arguments);
	};
	
	var defaults = {
		/**
		 * @private
		 */
		_set: function(scope, values) {
			return helpers_core.merge(this[scope] || (this[scope] = {}), values);
		}
	};
	
	// TODO(v3): remove 'global' from namespace.  all default are global and
	// there's inconsistency around which options are under 'global'
	defaults._set('global', {
		defaultColor: 'rgba(0,0,0,0.1)',
		defaultFontColor: '#666',
		defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
		defaultFontSize: 12,
		defaultFontStyle: 'normal',
		defaultLineHeight: 1.2,
		showLines: true
	});
	
	var core_defaults = defaults;
	
	var valueOrDefault = helpers_core.valueOrDefault;
	
	/**
	 * Converts the given font object into a CSS font string.
	 * @param {object} font - A font object.
	 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
	 * @private
	 */
	function toFontString(font) {
		if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
			return null;
		}
	
		return (font.style ? font.style + ' ' : '')
			+ (font.weight ? font.weight + ' ' : '')
			+ font.size + 'px '
			+ font.family;
	}
	
	/**
	 * @alias Chart.helpers.options
	 * @namespace
	 */
	var helpers_options = {
		/**
		 * Converts the given line height `value` in pixels for a specific font `size`.
		 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
		 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
		 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
		 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
		 * @since 2.7.0
		 */
		toLineHeight: function(value, size) {
			var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
			if (!matches || matches[1] === 'normal') {
				return size * 1.2;
			}
	
			value = +matches[2];
	
			switch (matches[3]) {
			case 'px':
				return value;
			case '%':
				value /= 100;
				break;
			}
	
			return size * value;
		},
	
		/**
		 * Converts the given value into a padding object with pre-computed width/height.
		 * @param {number|object} value - If a number, set the value to all TRBL component,
		 *  else, if and object, use defined properties and sets undefined ones to 0.
		 * @returns {object} The padding values (top, right, bottom, left, width, height)
		 * @since 2.7.0
		 */
		toPadding: function(value) {
			var t, r, b, l;
	
			if (helpers_core.isObject(value)) {
				t = +value.top || 0;
				r = +value.right || 0;
				b = +value.bottom || 0;
				l = +value.left || 0;
			} else {
				t = r = b = l = +value || 0;
			}
	
			return {
				top: t,
				right: r,
				bottom: b,
				left: l,
				height: t + b,
				width: l + r
			};
		},
	
		/**
		 * Parses font options and returns the font object.
		 * @param {object} options - A object that contains font options to be parsed.
		 * @return {object} The font object.
		 * @todo Support font.* options and renamed to toFont().
		 * @private
		 */
		_parseFont: function(options) {
			var globalDefaults = core_defaults.global;
			var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
			var font = {
				family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
				lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
				size: size,
				style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
				weight: null,
				string: ''
			};
	
			font.string = toFontString(font);
			return font;
		},
	
		/**
		 * Evaluates the given `inputs` sequentially and returns the first defined value.
		 * @param {Array} inputs - An array of values, falling back to the last value.
		 * @param {object} [context] - If defined and the current value is a function, the value
		 * is called with `context` as first argument and the result becomes the new input.
		 * @param {number} [index] - If defined and the current value is an array, the value
		 * at `index` become the new input.
		 * @param {object} [info] - object to return information about resolution in
		 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
		 * @since 2.7.0
		 */
		resolve: function(inputs, context, index, info) {
			var cacheable = true;
			var i, ilen, value;
	
			for (i = 0, ilen = inputs.length; i < ilen; ++i) {
				value = inputs[i];
				if (value === undefined) {
					continue;
				}
				if (context !== undefined && typeof value === 'function') {
					value = value(context);
					cacheable = false;
				}
				if (index !== undefined && helpers_core.isArray(value)) {
					value = value[index];
					cacheable = false;
				}
				if (value !== undefined) {
					if (info && !cacheable) {
						info.cacheable = false;
					}
					return value;
				}
			}
		}
	};
	
	/**
	 * @alias Chart.helpers.math
	 * @namespace
	 */
	var exports$2 = {
		/**
		 * Returns an array of factors sorted from 1 to sqrt(value)
		 * @private
		 */
		_factorize: function(value) {
			var result = [];
			var sqrt = Math.sqrt(value);
			var i;
	
			for (i = 1; i < sqrt; i++) {
				if (value % i === 0) {
					result.push(i);
					result.push(value / i);
				}
			}
			if (sqrt === (sqrt | 0)) { // if value is a square number
				result.push(sqrt);
			}
	
			result.sort(function(a, b) {
				return a - b;
			}).pop();
			return result;
		},
	
		log10: Math.log10 || function(x) {
			var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
			// Check for whole powers of 10,
			// which due to floating point rounding error should be corrected.
			var powerOf10 = Math.round(exponent);
			var isPowerOf10 = x === Math.pow(10, powerOf10);
	
			return isPowerOf10 ? powerOf10 : exponent;
		}
	};
	
	var helpers_math = exports$2;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
	 * @namespace Chart.helpers.log10
	 * @deprecated since version 2.9.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.log10 = exports$2.log10;
	
	var getRtlAdapter = function(rectX, width) {
		return {
			x: function(x) {
				return rectX + rectX + width - x;
			},
			setWidth: function(w) {
				width = w;
			},
			textAlign: function(align) {
				if (align === 'center') {
					return align;
				}
				return align === 'right' ? 'left' : 'right';
			},
			xPlus: function(x, value) {
				return x - value;
			},
			leftForLtr: function(x, itemWidth) {
				return x - itemWidth;
			},
		};
	};
	
	var getLtrAdapter = function() {
		return {
			x: function(x) {
				return x;
			},
			setWidth: function(w) { // eslint-disable-line no-unused-vars
			},
			textAlign: function(align) {
				return align;
			},
			xPlus: function(x, value) {
				return x + value;
			},
			leftForLtr: function(x, _itemWidth) { // eslint-disable-line no-unused-vars
				return x;
			},
		};
	};
	
	var getAdapter = function(rtl, rectX, width) {
		return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
	};
	
	var overrideTextDirection = function(ctx, direction) {
		var style, original;
		if (direction === 'ltr' || direction === 'rtl') {
			style = ctx.canvas.style;
			original = [
				style.getPropertyValue('direction'),
				style.getPropertyPriority('direction'),
			];
	
			style.setProperty('direction', direction, 'important');
			ctx.prevTextDirection = original;
		}
	};
	
	var restoreTextDirection = function(ctx) {
		var original = ctx.prevTextDirection;
		if (original !== undefined) {
			delete ctx.prevTextDirection;
			ctx.canvas.style.setProperty('direction', original[0], original[1]);
		}
	};
	
	var helpers_rtl = {
		getRtlAdapter: getAdapter,
		overrideTextDirection: overrideTextDirection,
		restoreTextDirection: restoreTextDirection,
	};
	
	var helpers$1 = helpers_core;
	var easing = helpers_easing;
	var canvas = helpers_canvas;
	var options = helpers_options;
	var math = helpers_math;
	var rtl = helpers_rtl;
	helpers$1.easing = easing;
	helpers$1.canvas = canvas;
	helpers$1.options = options;
	helpers$1.math = math;
	helpers$1.rtl = rtl;
	
	function interpolate(start, view, model, ease) {
		var keys = Object.keys(model);
		var i, ilen, key, actual, origin, target, type, c0, c1;
	
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
	
			target = model[key];
	
			// if a value is added to the model after pivot() has been called, the view
			// doesn't contain it, so let's initialize the view to the target value.
			if (!view.hasOwnProperty(key)) {
				view[key] = target;
			}
	
			actual = view[key];
	
			if (actual === target || key[0] === '_') {
				continue;
			}
	
			if (!start.hasOwnProperty(key)) {
				start[key] = actual;
			}
	
			origin = start[key];
	
			type = typeof target;
	
			if (type === typeof origin) {
				if (type === 'string') {
					c0 = chartjsColor(origin);
					if (c0.valid) {
						c1 = chartjsColor(target);
						if (c1.valid) {
							view[key] = c1.mix(c0, ease).rgbString();
							continue;
						}
					}
				} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
					view[key] = origin + (target - origin) * ease;
					continue;
				}
			}
	
			view[key] = target;
		}
	}
	
	var Element = function(configuration) {
		helpers$1.extend(this, configuration);
		this.initialize.apply(this, arguments);
	};
	
	helpers$1.extend(Element.prototype, {
		_type: undefined,
	
		initialize: function() {
			this.hidden = false;
		},
	
		pivot: function() {
			var me = this;
			if (!me._view) {
				me._view = helpers$1.extend({}, me._model);
			}
			me._start = {};
			return me;
		},
	
		transition: function(ease) {
			var me = this;
			var model = me._model;
			var start = me._start;
			var view = me._view;
	
			// No animation -> No Transition
			if (!model || ease === 1) {
				me._view = helpers$1.extend({}, model);
				me._start = null;
				return me;
			}
	
			if (!view) {
				view = me._view = {};
			}
	
			if (!start) {
				start = me._start = {};
			}
	
			interpolate(start, view, model, ease);
	
			return me;
		},
	
		tooltipPosition: function() {
			return {
				x: this._model.x,
				y: this._model.y
			};
		},
	
		hasValue: function() {
			return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
		}
	});
	
	Element.extend = helpers$1.inherits;
	
	var core_element = Element;
	
	var exports$3 = core_element.extend({
		chart: null, // the animation associated chart instance
		currentStep: 0, // the current animation step
		numSteps: 60, // default number of steps
		easing: '', // the easing to use for this animation
		render: null, // render function used by the animation service
	
		onAnimationProgress: null, // user specified callback to fire on each step of the animation
		onAnimationComplete: null, // user specified callback to fire when the animation finishes
	});
	
	var core_animation = exports$3;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.Animation instead
	 * @prop Chart.Animation#animationObject
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(exports$3.prototype, 'animationObject', {
		get: function() {
			return this;
		}
	});
	
	/**
	 * Provided for backward compatibility, use Chart.Animation#chart instead
	 * @prop Chart.Animation#chartInstance
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(exports$3.prototype, 'chartInstance', {
		get: function() {
			return this.chart;
		},
		set: function(value) {
			this.chart = value;
		}
	});
	
	core_defaults._set('global', {
		animation: {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers$1.noop,
			onComplete: helpers$1.noop
		}
	});
	
	var core_animations = {
		animations: [],
		request: null,
	
		/**
		 * @param {Chart} chart - The chart to animate.
		 * @param {Chart.Animation} animation - The animation that we will animate.
		 * @param {number} duration - The animation duration in ms.
		 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
		 */
		addAnimation: function(chart, animation, duration, lazy) {
			var animations = this.animations;
			var i, ilen;
	
			animation.chart = chart;
			animation.startTime = Date.now();
			animation.duration = duration;
	
			if (!lazy) {
				chart.animating = true;
			}
	
			for (i = 0, ilen = animations.length; i < ilen; ++i) {
				if (animations[i].chart === chart) {
					animations[i] = animation;
					return;
				}
			}
	
			animations.push(animation);
	
			// If there are no animations queued, manually kickstart a digest, for lack of a better word
			if (animations.length === 1) {
				this.requestAnimationFrame();
			}
		},
	
		cancelAnimation: function(chart) {
			var index = helpers$1.findIndex(this.animations, function(animation) {
				return animation.chart === chart;
			});
	
			if (index !== -1) {
				this.animations.splice(index, 1);
				chart.animating = false;
			}
		},
	
		requestAnimationFrame: function() {
			var me = this;
			if (me.request === null) {
				// Skip animation frame requests until the active one is executed.
				// This can happen when processing mouse events, e.g. 'mousemove'
				// and 'mouseout' events will trigger multiple renders.
				me.request = helpers$1.requestAnimFrame.call(window, function() {
					me.request = null;
					me.startDigest();
				});
			}
		},
	
		/**
		 * @private
		 */
		startDigest: function() {
			var me = this;
	
			me.advance();
	
			// Do we have more stuff to animate?
			if (me.animations.length > 0) {
				me.requestAnimationFrame();
			}
		},
	
		/**
		 * @private
		 */
		advance: function() {
			var animations = this.animations;
			var animation, chart, numSteps, nextStep;
			var i = 0;
	
			// 1 animation per chart, so we are looping charts here
			while (i < animations.length) {
				animation = animations[i];
				chart = animation.chart;
				numSteps = animation.numSteps;
	
				// Make sure that currentStep starts at 1
				// https://github.com/chartjs/Chart.js/issues/6104
				nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
				animation.currentStep = Math.min(nextStep, numSteps);
	
				helpers$1.callback(animation.render, [chart, animation], chart);
				helpers$1.callback(animation.onAnimationProgress, [animation], chart);
	
				if (animation.currentStep >= numSteps) {
					helpers$1.callback(animation.onAnimationComplete, [animation], chart);
					chart.animating = false;
					animations.splice(i, 1);
				} else {
					++i;
				}
			}
		}
	};
	
	var resolve = helpers$1.options.resolve;
	
	var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
	
	/**
	 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
	 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
	 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
	 */
	function listenArrayEvents(array, listener) {
		if (array._chartjs) {
			array._chartjs.listeners.push(listener);
			return;
		}
	
		Object.defineProperty(array, '_chartjs', {
			configurable: true,
			enumerable: false,
			value: {
				listeners: [listener]
			}
		});
	
		arrayEvents.forEach(function(key) {
			var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
			var base = array[key];
	
			Object.defineProperty(array, key, {
				configurable: true,
				enumerable: false,
				value: function() {
					var args = Array.prototype.slice.call(arguments);
					var res = base.apply(this, args);
	
					helpers$1.each(array._chartjs.listeners, function(object) {
						if (typeof object[method] === 'function') {
							object[method].apply(object, args);
						}
					});
	
					return res;
				}
			});
		});
	}
	
	/**
	 * Removes the given array event listener and cleanup extra attached properties (such as
	 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
	 */
	function unlistenArrayEvents(array, listener) {
		var stub = array._chartjs;
		if (!stub) {
			return;
		}
	
		var listeners = stub.listeners;
		var index = listeners.indexOf(listener);
		if (index !== -1) {
			listeners.splice(index, 1);
		}
	
		if (listeners.length > 0) {
			return;
		}
	
		arrayEvents.forEach(function(key) {
			delete array[key];
		});
	
		delete array._chartjs;
	}
	
	// Base class for all dataset controllers (line, bar, etc)
	var DatasetController = function(chart, datasetIndex) {
		this.initialize(chart, datasetIndex);
	};
	
	helpers$1.extend(DatasetController.prototype, {
	
		/**
		 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
		 * @type {Chart.core.element}
		 */
		datasetElementType: null,
	
		/**
		 * Element type used to generate a meta data (e.g. Chart.element.Point).
		 * @type {Chart.core.element}
		 */
		dataElementType: null,
	
		/**
		 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
		 * A derived controller may override this to resolve controller-specific options.
		 * The keys defined here are for backward compatibility for legend styles.
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderCapStyle',
			'borderColor',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'borderWidth'
		],
	
		/**
		 * Data element option keys to be resolved in _resolveDataElementOptions.
		 * A derived controller may override this to resolve controller-specific options.
		 * The keys defined here are for backward compatibility for legend styles.
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'pointStyle'
		],
	
		initialize: function(chart, datasetIndex) {
			var me = this;
			me.chart = chart;
			me.index = datasetIndex;
			me.linkScales();
			me.addElements();
			me._type = me.getMeta().type;
		},
	
		updateIndex: function(datasetIndex) {
			this.index = datasetIndex;
		},
	
		linkScales: function() {
			var me = this;
			var meta = me.getMeta();
			var chart = me.chart;
			var scales = chart.scales;
			var dataset = me.getDataset();
			var scalesOpts = chart.options.scales;
	
			if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
				meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
			}
			if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
				meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
			}
		},
	
		getDataset: function() {
			return this.chart.data.datasets[this.index];
		},
	
		getMeta: function() {
			return this.chart.getDatasetMeta(this.index);
		},
	
		getScaleForId: function(scaleID) {
			return this.chart.scales[scaleID];
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.getMeta().yAxisID;
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.getMeta().xAxisID;
		},
	
		/**
		 * @private
		 */
		_getValueScale: function() {
			return this.getScaleForId(this._getValueScaleId());
		},
	
		/**
		 * @private
		 */
		_getIndexScale: function() {
			return this.getScaleForId(this._getIndexScaleId());
		},
	
		reset: function() {
			this._update(true);
		},
	
		/**
		 * @private
		 */
		destroy: function() {
			if (this._data) {
				unlistenArrayEvents(this._data, this);
			}
		},
	
		createMetaDataset: function() {
			var me = this;
			var type = me.datasetElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index
			});
		},
	
		createMetaData: function(index) {
			var me = this;
			var type = me.dataElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index,
				_index: index
			});
		},
	
		addElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data || [];
			var metaData = meta.data;
			var i, ilen;
	
			for (i = 0, ilen = data.length; i < ilen; ++i) {
				metaData[i] = metaData[i] || me.createMetaData(i);
			}
	
			meta.dataset = meta.dataset || me.createMetaDataset();
		},
	
		addElementAndReset: function(index) {
			var element = this.createMetaData(index);
			this.getMeta().data.splice(index, 0, element);
			this.updateElement(element, index, true);
		},
	
		buildOrUpdateElements: function() {
			var me = this;
			var dataset = me.getDataset();
			var data = dataset.data || (dataset.data = []);
	
			// In order to correctly handle data addition/deletion animation (an thus simulate
			// real-time charts), we need to monitor these data modifications and synchronize
			// the internal meta data accordingly.
			if (me._data !== data) {
				if (me._data) {
					// This case happens when the user replaced the data array instance.
					unlistenArrayEvents(me._data, me);
				}
	
				if (data && Object.isExtensible(data)) {
					listenArrayEvents(data, me);
				}
				me._data = data;
			}
	
			// Re-sync meta data in case the user replaced the data array or if we missed
			// any updates and so make sure that we handle number of datapoints changing.
			me.resyncElements();
		},
	
		/**
		 * Returns the merged user-supplied and default dataset-level options
		 * @private
		 */
		_configure: function() {
			var me = this;
			me._config = helpers$1.merge(Object.create(null), [
				me.chart.options.datasets[me._type],
				me.getDataset(),
			], {
				merger: function(key, target, source) {
					if (key !== '_meta' && key !== 'data') {
						helpers$1._merger(key, target, source);
					}
				}
			});
		},
	
		_update: function(reset) {
			var me = this;
			me._configure();
			me._cachedDataOpts = null;
			me.update(reset);
		},
	
		update: helpers$1.noop,
	
		transition: function(easingValue) {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;
	
			for (; i < ilen; ++i) {
				elements[i].transition(easingValue);
			}
	
			if (meta.dataset) {
				meta.dataset.transition(easingValue);
			}
		},
	
		draw: function() {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;
	
			if (meta.dataset) {
				meta.dataset.draw();
			}
	
			for (; i < ilen; ++i) {
				elements[i].draw();
			}
		},
	
		/**
		 * Returns a set of predefined style properties that should be used to represent the dataset
		 * or the data if the index is specified
		 * @param {number} index - data index
		 * @return {IStyleInterface} style object
		 */
		getStyle: function(index) {
			var me = this;
			var meta = me.getMeta();
			var dataset = meta.dataset;
			var style;
	
			me._configure();
			if (dataset && index === undefined) {
				style = me._resolveDatasetElementOptions(dataset || {});
			} else {
				index = index || 0;
				style = me._resolveDataElementOptions(meta.data[index] || {}, index);
			}
	
			if (style.fill === false || style.fill === null) {
				style.backgroundColor = style.borderColor;
			}
	
			return style;
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function(element, hover) {
			var me = this;
			var chart = me.chart;
			var datasetOpts = me._config;
			var custom = element.custom || {};
			var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
			var elementOptions = me._datasetElementOptions;
			var values = {};
			var i, ilen, key, readKey;
	
			// Scriptable options
			var context = {
				chart: chart,
				dataset: me.getDataset(),
				datasetIndex: me.index,
				hover: hover
			};
	
			for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
				key = elementOptions[i];
				readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
				values[key] = resolve([
					custom[readKey],
					datasetOpts[readKey],
					options[readKey]
				], context);
			}
	
			return values;
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function(element, index) {
			var me = this;
			var custom = element && element.custom;
			var cached = me._cachedDataOpts;
			if (cached && !custom) {
				return cached;
			}
			var chart = me.chart;
			var datasetOpts = me._config;
			var options = chart.options.elements[me.dataElementType.prototype._type] || {};
			var elementOptions = me._dataElementOptions;
			var values = {};
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: me.getDataset(),
				datasetIndex: me.index
			};
	
			// `resolve` sets cacheable to `false` if any option is indexed or scripted
			var info = {cacheable: !custom};
	
			var keys, i, ilen, key;
	
			custom = custom || {};
	
			if (helpers$1.isArray(elementOptions)) {
				for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
					key = elementOptions[i];
					values[key] = resolve([
						custom[key],
						datasetOpts[key],
						options[key]
					], context, index, info);
				}
			} else {
				keys = Object.keys(elementOptions);
				for (i = 0, ilen = keys.length; i < ilen; ++i) {
					key = keys[i];
					values[key] = resolve([
						custom[key],
						datasetOpts[elementOptions[key]],
						datasetOpts[key],
						options[key]
					], context, index, info);
				}
			}
	
			if (info.cacheable) {
				me._cachedDataOpts = Object.freeze(values);
			}
	
			return values;
		},
	
		removeHoverStyle: function(element) {
			helpers$1.merge(element._model, element.$previousStyle || {});
			delete element.$previousStyle;
		},
	
		setHoverStyle: function(element) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var model = element._model;
			var getHoverColor = helpers$1.getHoverColor;
	
			element.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth
			};
	
			model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
			model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
			model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
		},
	
		/**
		 * @private
		 */
		_removeDatasetHoverStyle: function() {
			var element = this.getMeta().dataset;
	
			if (element) {
				this.removeHoverStyle(element);
			}
		},
	
		/**
		 * @private
		 */
		_setDatasetHoverStyle: function() {
			var element = this.getMeta().dataset;
			var prev = {};
			var i, ilen, key, keys, hoverOptions, model;
	
			if (!element) {
				return;
			}
	
			model = element._model;
			hoverOptions = this._resolveDatasetElementOptions(element, true);
	
			keys = Object.keys(hoverOptions);
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				prev[key] = model[key];
				model[key] = hoverOptions[key];
			}
	
			element.$previousStyle = prev;
		},
	
		/**
		 * @private
		 */
		resyncElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data;
			var numMeta = meta.data.length;
			var numData = data.length;
	
			if (numData < numMeta) {
				meta.data.splice(numData, numMeta - numData);
			} else if (numData > numMeta) {
				me.insertElements(numMeta, numData - numMeta);
			}
		},
	
		/**
		 * @private
		 */
		insertElements: function(start, count) {
			for (var i = 0; i < count; ++i) {
				this.addElementAndReset(start + i);
			}
		},
	
		/**
		 * @private
		 */
		onDataPush: function() {
			var count = arguments.length;
			this.insertElements(this.getDataset().data.length - count, count);
		},
	
		/**
		 * @private
		 */
		onDataPop: function() {
			this.getMeta().data.pop();
		},
	
		/**
		 * @private
		 */
		onDataShift: function() {
			this.getMeta().data.shift();
		},
	
		/**
		 * @private
		 */
		onDataSplice: function(start, count) {
			this.getMeta().data.splice(start, count);
			this.insertElements(start, arguments.length - 2);
		},
	
		/**
		 * @private
		 */
		onDataUnshift: function() {
			this.insertElements(0, arguments.length);
		}
	});
	
	DatasetController.extend = helpers$1.inherits;
	
	var core_datasetController = DatasetController;
	
	var TAU = Math.PI * 2;
	
	core_defaults._set('global', {
		elements: {
			arc: {
				backgroundColor: core_defaults.global.defaultColor,
				borderColor: '#fff',
				borderWidth: 2,
				borderAlign: 'center'
			}
		}
	});
	
	function clipArc(ctx, arc) {
		var startAngle = arc.startAngle;
		var endAngle = arc.endAngle;
		var pixelMargin = arc.pixelMargin;
		var angleMargin = pixelMargin / arc.outerRadius;
		var x = arc.x;
		var y = arc.y;
	
		// Draw an inner border by cliping the arc and drawing a double-width border
		// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
		ctx.beginPath();
		ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
		if (arc.innerRadius > pixelMargin) {
			angleMargin = pixelMargin / arc.innerRadius;
			ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
		} else {
			ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
		}
		ctx.closePath();
		ctx.clip();
	}
	
	function drawFullCircleBorders(ctx, vm, arc, inner) {
		var endAngle = arc.endAngle;
		var i;
	
		if (inner) {
			arc.endAngle = arc.startAngle + TAU;
			clipArc(ctx, arc);
			arc.endAngle = endAngle;
			if (arc.endAngle === arc.startAngle && arc.fullCircles) {
				arc.endAngle += TAU;
				arc.fullCircles--;
			}
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
		for (i = 0; i < arc.fullCircles; ++i) {
			ctx.stroke();
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
		for (i = 0; i < arc.fullCircles; ++i) {
			ctx.stroke();
		}
	}
	
	function drawBorder(ctx, vm, arc) {
		var inner = vm.borderAlign === 'inner';
	
		if (inner) {
			ctx.lineWidth = vm.borderWidth * 2;
			ctx.lineJoin = 'round';
		} else {
			ctx.lineWidth = vm.borderWidth;
			ctx.lineJoin = 'bevel';
		}
	
		if (arc.fullCircles) {
			drawFullCircleBorders(ctx, vm, arc, inner);
		}
	
		if (inner) {
			clipArc(ctx, arc);
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
		ctx.closePath();
		ctx.stroke();
	}
	
	var element_arc = core_element.extend({
		_type: 'arc',
	
		inLabelRange: function(mouseX) {
			var vm = this._view;
	
			if (vm) {
				return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
			}
			return false;
		},
	
		inRange: function(chartX, chartY) {
			var vm = this._view;
	
			if (vm) {
				var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
				var angle = pointRelativePosition.angle;
				var distance = pointRelativePosition.distance;
	
				// Sanitise angle range
				var startAngle = vm.startAngle;
				var endAngle = vm.endAngle;
				while (endAngle < startAngle) {
					endAngle += TAU;
				}
				while (angle > endAngle) {
					angle -= TAU;
				}
				while (angle < startAngle) {
					angle += TAU;
				}
	
				// Check if within the range of the open/close angle
				var betweenAngles = (angle >= startAngle && angle <= endAngle);
				var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);
	
				return (betweenAngles && withinRadius);
			}
			return false;
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var halfAngle = (vm.startAngle + vm.endAngle) / 2;
			var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
			return {
				x: vm.x + Math.cos(halfAngle) * halfRadius,
				y: vm.y + Math.sin(halfAngle) * halfRadius
			};
		},
	
		getArea: function() {
			var vm = this._view;
			return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
			var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
	
			return {
				x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
				y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
			};
		},
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
			var arc = {
				x: vm.x,
				y: vm.y,
				innerRadius: vm.innerRadius,
				outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
				pixelMargin: pixelMargin,
				startAngle: vm.startAngle,
				endAngle: vm.endAngle,
				fullCircles: Math.floor(vm.circumference / TAU)
			};
			var i;
	
			ctx.save();
	
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
	
			if (arc.fullCircles) {
				arc.endAngle = arc.startAngle + TAU;
				ctx.beginPath();
				ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
				ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
				ctx.closePath();
				for (i = 0; i < arc.fullCircles; ++i) {
					ctx.fill();
				}
				arc.endAngle = arc.startAngle + vm.circumference % TAU;
			}
	
			ctx.beginPath();
			ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
			ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
			ctx.closePath();
			ctx.fill();
	
			if (vm.borderWidth) {
				drawBorder(ctx, vm, arc);
			}
	
			ctx.restore();
		}
	});
	
	var valueOrDefault$1 = helpers$1.valueOrDefault;
	
	var defaultColor = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			line: {
				tension: 0.4,
				backgroundColor: defaultColor,
				borderWidth: 3,
				borderColor: defaultColor,
				borderCapStyle: 'butt',
				borderDash: [],
				borderDashOffset: 0.0,
				borderJoinStyle: 'miter',
				capBezierPoints: true,
				fill: true, // do we fill in the area between the line and its base axis
			}
		}
	});
	
	var element_line = core_element.extend({
		_type: 'line',
	
		draw: function() {
			var me = this;
			var vm = me._view;
			var ctx = me._chart.ctx;
			var spanGaps = vm.spanGaps;
			var points = me._children.slice(); // clone array
			var globalDefaults = core_defaults.global;
			var globalOptionLineElements = globalDefaults.elements.line;
			var lastDrawnIndex = -1;
			var closePath = me._loop;
			var index, previous, currentVM;
	
			if (!points.length) {
				return;
			}
	
			if (me._loop) {
				for (index = 0; index < points.length; ++index) {
					previous = helpers$1.previousItem(points, index);
					// If the line has an open path, shift the point array
					if (!points[index]._view.skip && previous._view.skip) {
						points = points.slice(index).concat(points.slice(0, index));
						closePath = spanGaps;
						break;
					}
				}
				// If the line has a close path, add the first point again
				if (closePath) {
					points.push(points[0]);
				}
			}
	
			ctx.save();
	
			// Stroke Line Options
			ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
	
			// IE 9 and 10 do not support line dash
			if (ctx.setLineDash) {
				ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
			}
	
			ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
			ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
			ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
			ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
	
			// Stroke Line
			ctx.beginPath();
	
			// First point moves to it's starting position no matter what
			currentVM = points[0]._view;
			if (!currentVM.skip) {
				ctx.moveTo(currentVM.x, currentVM.y);
				lastDrawnIndex = 0;
			}
	
			for (index = 1; index < points.length; ++index) {
				currentVM = points[index]._view;
				previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
	
				if (!currentVM.skip) {
					if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
						// There was a gap and this is the first point after the gap
						ctx.moveTo(currentVM.x, currentVM.y);
					} else {
						// Line to next point
						helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
					}
					lastDrawnIndex = index;
				}
			}
	
			if (closePath) {
				ctx.closePath();
			}
	
			ctx.stroke();
			ctx.restore();
		}
	});
	
	var valueOrDefault$2 = helpers$1.valueOrDefault;
	
	var defaultColor$1 = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			point: {
				radius: 3,
				pointStyle: 'circle',
				backgroundColor: defaultColor$1,
				borderColor: defaultColor$1,
				borderWidth: 1,
				// Hover
				hitRadius: 1,
				hoverRadius: 4,
				hoverBorderWidth: 1
			}
		}
	});
	
	function xRange(mouseX) {
		var vm = this._view;
		return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
	}
	
	function yRange(mouseY) {
		var vm = this._view;
		return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
	}
	
	var element_point = core_element.extend({
		_type: 'point',
	
		inRange: function(mouseX, mouseY) {
			var vm = this._view;
			return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
		},
	
		inLabelRange: xRange,
		inXRange: xRange,
		inYRange: yRange,
	
		getCenterPoint: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		},
	
		getArea: function() {
			return Math.PI * Math.pow(this._view.radius, 2);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y,
				padding: vm.radius + vm.borderWidth
			};
		},
	
		draw: function(chartArea) {
			var vm = this._view;
			var ctx = this._chart.ctx;
			var pointStyle = vm.pointStyle;
			var rotation = vm.rotation;
			var radius = vm.radius;
			var x = vm.x;
			var y = vm.y;
			var globalDefaults = core_defaults.global;
			var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow
	
			if (vm.skip) {
				return;
			}
	
			// Clipping for Points.
			if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
				ctx.strokeStyle = vm.borderColor || defaultColor;
				ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
				ctx.fillStyle = vm.backgroundColor || defaultColor;
				helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
			}
		}
	});
	
	var defaultColor$2 = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			rectangle: {
				backgroundColor: defaultColor$2,
				borderColor: defaultColor$2,
				borderSkipped: 'bottom',
				borderWidth: 0
			}
		}
	});
	
	function isVertical(vm) {
		return vm && vm.width !== undefined;
	}
	
	/**
	 * Helper function to get the bounds of the bar regardless of the orientation
	 * @param bar {Chart.Element.Rectangle} the bar
	 * @return {Bounds} bounds of the bar
	 * @private
	 */
	function getBarBounds(vm) {
		var x1, x2, y1, y2, half;
	
		if (isVertical(vm)) {
			half = vm.width / 2;
			x1 = vm.x - half;
			x2 = vm.x + half;
			y1 = Math.min(vm.y, vm.base);
			y2 = Math.max(vm.y, vm.base);
		} else {
			half = vm.height / 2;
			x1 = Math.min(vm.x, vm.base);
			x2 = Math.max(vm.x, vm.base);
			y1 = vm.y - half;
			y2 = vm.y + half;
		}
	
		return {
			left: x1,
			top: y1,
			right: x2,
			bottom: y2
		};
	}
	
	function swap(orig, v1, v2) {
		return orig === v1 ? v2 : orig === v2 ? v1 : orig;
	}
	
	function parseBorderSkipped(vm) {
		var edge = vm.borderSkipped;
		var res = {};
	
		if (!edge) {
			return res;
		}
	
		if (vm.horizontal) {
			if (vm.base > vm.x) {
				edge = swap(edge, 'left', 'right');
			}
		} else if (vm.base < vm.y) {
			edge = swap(edge, 'bottom', 'top');
		}
	
		res[edge] = true;
		return res;
	}
	
	function parseBorderWidth(vm, maxW, maxH) {
		var value = vm.borderWidth;
		var skip = parseBorderSkipped(vm);
		var t, r, b, l;
	
		if (helpers$1.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}
	
		return {
			t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
			r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
			b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
			l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
		};
	}
	
	function boundingRects(vm) {
		var bounds = getBarBounds(vm);
		var width = bounds.right - bounds.left;
		var height = bounds.bottom - bounds.top;
		var border = parseBorderWidth(vm, width / 2, height / 2);
	
		return {
			outer: {
				x: bounds.left,
				y: bounds.top,
				w: width,
				h: height
			},
			inner: {
				x: bounds.left + border.l,
				y: bounds.top + border.t,
				w: width - border.l - border.r,
				h: height - border.t - border.b
			}
		};
	}
	
	function inRange(vm, x, y) {
		var skipX = x === null;
		var skipY = y === null;
		var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);
	
		return bounds
			&& (skipX || x >= bounds.left && x <= bounds.right)
			&& (skipY || y >= bounds.top && y <= bounds.bottom);
	}
	
	var element_rectangle = core_element.extend({
		_type: 'rectangle',
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var rects = boundingRects(vm);
			var outer = rects.outer;
			var inner = rects.inner;
	
			ctx.fillStyle = vm.backgroundColor;
			ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
	
			if (outer.w === inner.w && outer.h === inner.h) {
				return;
			}
	
			ctx.save();
			ctx.beginPath();
			ctx.rect(outer.x, outer.y, outer.w, outer.h);
			ctx.clip();
			ctx.fillStyle = vm.borderColor;
			ctx.rect(inner.x, inner.y, inner.w, inner.h);
			ctx.fill('evenodd');
			ctx.restore();
		},
	
		height: function() {
			var vm = this._view;
			return vm.base - vm.y;
		},
	
		inRange: function(mouseX, mouseY) {
			return inRange(this._view, mouseX, mouseY);
		},
	
		inLabelRange: function(mouseX, mouseY) {
			var vm = this._view;
			return isVertical(vm)
				? inRange(vm, mouseX, null)
				: inRange(vm, null, mouseY);
		},
	
		inXRange: function(mouseX) {
			return inRange(this._view, mouseX, null);
		},
	
		inYRange: function(mouseY) {
			return inRange(this._view, null, mouseY);
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var x, y;
			if (isVertical(vm)) {
				x = vm.x;
				y = (vm.y + vm.base) / 2;
			} else {
				x = (vm.x + vm.base) / 2;
				y = vm.y;
			}
	
			return {x: x, y: y};
		},
	
		getArea: function() {
			var vm = this._view;
	
			return isVertical(vm)
				? vm.width * Math.abs(vm.y - vm.base)
				: vm.height * Math.abs(vm.x - vm.base);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		}
	});
	
	var elements = {};
	var Arc = element_arc;
	var Line = element_line;
	var Point = element_point;
	var Rectangle = element_rectangle;
	elements.Arc = Arc;
	elements.Line = Line;
	elements.Point = Point;
	elements.Rectangle = Rectangle;
	
	var deprecated = helpers$1._deprecated;
	var valueOrDefault$3 = helpers$1.valueOrDefault;
	
	core_defaults._set('bar', {
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
				offset: true,
				gridLines: {
					offsetGridLines: true
				}
			}],
	
			yAxes: [{
				type: 'linear'
			}]
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			bar: {
				categoryPercentage: 0.8,
				barPercentage: 0.9
			}
		}
	});
	
	/**
	 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
	 * @private
	 */
	function computeMinSampleSize(scale, pixels) {
		var min = scale._length;
		var prev, curr, i, ilen;
	
		for (i = 1, ilen = pixels.length; i < ilen; ++i) {
			min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
		}
	
		for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
			curr = scale.getPixelForTick(i);
			min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
			prev = curr;
		}
	
		return min;
	}
	
	/**
	 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
	 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
	 * mode currently always generates bars equally sized (until we introduce scriptable options?).
	 * @private
	 */
	function computeFitCategoryTraits(index, ruler, options) {
		var thickness = options.barThickness;
		var count = ruler.stackCount;
		var curr = ruler.pixels[index];
		var min = helpers$1.isNullOrUndef(thickness)
			? computeMinSampleSize(ruler.scale, ruler.pixels)
			: -1;
		var size, ratio;
	
		if (helpers$1.isNullOrUndef(thickness)) {
			size = min * options.categoryPercentage;
			ratio = options.barPercentage;
		} else {
			// When bar thickness is enforced, category and bar percentages are ignored.
			// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
			// and deprecate barPercentage since this value is ignored when thickness is absolute.
			size = thickness * count;
			ratio = 1;
		}
	
		return {
			chunk: size / count,
			ratio: ratio,
			start: curr - (size / 2)
		};
	}
	
	/**
	 * Computes an "optimal" category that globally arranges bars side by side (no gap when
	 * percentage options are 1), based on the previous and following categories. This mode
	 * generates bars with different widths when data are not evenly spaced.
	 * @private
	 */
	function computeFlexCategoryTraits(index, ruler, options) {
		var pixels = ruler.pixels;
		var curr = pixels[index];
		var prev = index > 0 ? pixels[index - 1] : null;
		var next = index < pixels.length - 1 ? pixels[index + 1] : null;
		var percent = options.categoryPercentage;
		var start, size;
	
		if (prev === null) {
			// first data: its size is double based on the next point or,
			// if it's also the last data, we use the scale size.
			prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
		}
	
		if (next === null) {
			// last data: its size is also double based on the previous point.
			next = curr + curr - prev;
		}
	
		start = curr - (curr - Math.min(prev, next)) / 2 * percent;
		size = Math.abs(next - prev) / 2 * percent;
	
		return {
			chunk: size / ruler.stackCount,
			ratio: options.barPercentage,
			start: start
		};
	}
	
	var controller_bar = core_datasetController.extend({
	
		dataElementType: elements.Rectangle,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderSkipped',
			'borderWidth',
			'barPercentage',
			'barThickness',
			'categoryPercentage',
			'maxBarThickness',
			'minBarLength'
		],
	
		initialize: function() {
			var me = this;
			var meta, scaleOpts;
	
			core_datasetController.prototype.initialize.apply(me, arguments);
	
			meta = me.getMeta();
			meta.stack = me.getDataset().stack;
			meta.bar = true;
	
			scaleOpts = me._getIndexScale().options;
			deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
			deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
			deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
			deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
			deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
		},
	
		update: function(reset) {
			var me = this;
			var rects = me.getMeta().data;
			var i, ilen;
	
			me._ruler = me.getRuler();
	
			for (i = 0, ilen = rects.length; i < ilen; ++i) {
				me.updateElement(rects[i], i, reset);
			}
		},
	
		updateElement: function(rectangle, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var dataset = me.getDataset();
			var options = me._resolveDataElementOptions(rectangle, index);
	
			rectangle._xScale = me.getScaleForId(meta.xAxisID);
			rectangle._yScale = me.getScaleForId(meta.yAxisID);
			rectangle._datasetIndex = me.index;
			rectangle._index = index;
			rectangle._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderSkipped: options.borderSkipped,
				borderWidth: options.borderWidth,
				datasetLabel: dataset.label,
				label: me.chart.data.labels[index]
			};
	
			if (helpers$1.isArray(dataset.data[index])) {
				rectangle._model.borderSkipped = null;
			}
	
			me._updateElementGeometry(rectangle, index, reset, options);
	
			rectangle.pivot();
		},
	
		/**
		 * @private
		 */
		_updateElementGeometry: function(rectangle, index, reset, options) {
			var me = this;
			var model = rectangle._model;
			var vscale = me._getValueScale();
			var base = vscale.getBasePixel();
			var horizontal = vscale.isHorizontal();
			var ruler = me._ruler || me.getRuler();
			var vpixels = me.calculateBarValuePixels(me.index, index, options);
			var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
	
			model.horizontal = horizontal;
			model.base = reset ? base : vpixels.base;
			model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
			model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
			model.height = horizontal ? ipixels.size : undefined;
			model.width = horizontal ? undefined : ipixels.size;
		},
	
		/**
		 * Returns the stacks based on groups and bar visibility.
		 * @param {number} [last] - The dataset index
		 * @returns {string[]} The list of stack IDs
		 * @private
		 */
		_getStacks: function(last) {
			var me = this;
			var scale = me._getIndexScale();
			var metasets = scale._getMatchingVisibleMetas(me._type);
			var stacked = scale.options.stacked;
			var ilen = metasets.length;
			var stacks = [];
			var i, meta;
	
			for (i = 0; i < ilen; ++i) {
				meta = metasets[i];
				// stacked   | meta.stack
				//           | found | not found | undefined
				// false     |   x   |     x     |     x
				// true      |       |     x     |
				// undefined |       |     x     |     x
				if (stacked === false || stacks.indexOf(meta.stack) === -1 ||
					(stacked === undefined && meta.stack === undefined)) {
					stacks.push(meta.stack);
				}
				if (meta.index === last) {
					break;
				}
			}
	
			return stacks;
		},
	
		/**
		 * Returns the effective number of stacks based on groups and bar visibility.
		 * @private
		 */
		getStackCount: function() {
			return this._getStacks().length;
		},
	
		/**
		 * Returns the stack index for the given dataset based on groups and bar visibility.
		 * @param {number} [datasetIndex] - The dataset index
		 * @param {string} [name] - The stack name to find
		 * @returns {number} The stack index
		 * @private
		 */
		getStackIndex: function(datasetIndex, name) {
			var stacks = this._getStacks(datasetIndex);
			var index = (name !== undefined)
				? stacks.indexOf(name)
				: -1; // indexOf returns -1 if element is not present
	
			return (index === -1)
				? stacks.length - 1
				: index;
		},
	
		/**
		 * @private
		 */
		getRuler: function() {
			var me = this;
			var scale = me._getIndexScale();
			var pixels = [];
			var i, ilen;
	
			for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
				pixels.push(scale.getPixelForValue(null, i, me.index));
			}
	
			return {
				pixels: pixels,
				start: scale._startPixel,
				end: scale._endPixel,
				stackCount: me.getStackCount(),
				scale: scale
			};
		},
	
		/**
		 * Note: pixel values are not clamped to the scale area.
		 * @private
		 */
		calculateBarValuePixels: function(datasetIndex, index, options) {
			var me = this;
			var chart = me.chart;
			var scale = me._getValueScale();
			var isHorizontal = scale.isHorizontal();
			var datasets = chart.data.datasets;
			var metasets = scale._getMatchingVisibleMetas(me._type);
			var value = scale._parseValue(datasets[datasetIndex].data[index]);
			var minBarLength = options.minBarLength;
			var stacked = scale.options.stacked;
			var stack = me.getMeta().stack;
			var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
			var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
			var ilen = metasets.length;
			var i, imeta, ivalue, base, head, size, stackLength;
	
			if (stacked || (stacked === undefined && stack !== undefined)) {
				for (i = 0; i < ilen; ++i) {
					imeta = metasets[i];
	
					if (imeta.index === datasetIndex) {
						break;
					}
	
					if (imeta.stack === stack) {
						stackLength = scale._parseValue(datasets[imeta.index].data[index]);
						ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
	
						if ((value.min < 0 && ivalue < 0) || (value.max >= 0 && ivalue > 0)) {
							start += ivalue;
						}
					}
				}
			}
	
			base = scale.getPixelForValue(start);
			head = scale.getPixelForValue(start + length);
			size = head - base;
	
			if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
				size = minBarLength;
				if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
					head = base - minBarLength;
				} else {
					head = base + minBarLength;
				}
			}
	
			return {
				size: size,
				base: base,
				head: head,
				center: head + size / 2
			};
		},
	
		/**
		 * @private
		 */
		calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
			var me = this;
			var range = options.barThickness === 'flex'
				? computeFlexCategoryTraits(index, ruler, options)
				: computeFitCategoryTraits(index, ruler, options);
	
			var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
			var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
			var size = Math.min(
				valueOrDefault$3(options.maxBarThickness, Infinity),
				range.chunk * range.ratio);
	
			return {
				base: center - size / 2,
				head: center + size / 2,
				center: center,
				size: size
			};
		},
	
		draw: function() {
			var me = this;
			var chart = me.chart;
			var scale = me._getValueScale();
			var rects = me.getMeta().data;
			var dataset = me.getDataset();
			var ilen = rects.length;
			var i = 0;
	
			helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
	
			for (; i < ilen; ++i) {
				var val = scale._parseValue(dataset.data[i]);
				if (!isNaN(val.min) && !isNaN(val.max)) {
					rects[i].draw();
				}
			}
	
			helpers$1.canvas.unclipArea(chart.ctx);
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function() {
			var me = this;
			var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
			var indexOpts = me._getIndexScale().options;
			var valueOpts = me._getValueScale().options;
	
			values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
			values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
			values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
			values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
			values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
	
			return values;
		}
	
	});
	
	var valueOrDefault$4 = helpers$1.valueOrDefault;
	var resolve$1 = helpers$1.options.resolve;
	
	core_defaults._set('bubble', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				type: 'linear', // bubble should probably use a linear scale by default
				position: 'bottom',
				id: 'x-axis-0' // need an ID so datasets can reference the scale
			}],
			yAxes: [{
				type: 'linear',
				position: 'left',
				id: 'y-axis-0'
			}]
		},
	
		tooltips: {
			callbacks: {
				title: function() {
					// Title doesn't make sense for scatter since we format the data as a point
					return '';
				},
				label: function(item, data) {
					var datasetLabel = data.datasets[item.datasetIndex].label || '';
					var dataPoint = data.datasets[item.datasetIndex].data[item.index];
					return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
				}
			}
		}
	});
	
	var controller_bubble = core_datasetController.extend({
		/**
		 * @protected
		 */
		dataElementType: elements.Point,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
			'hoverRadius',
			'hitRadius',
			'pointStyle',
			'rotation'
		],
	
		/**
		 * @protected
		 */
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var points = meta.data;
	
			// Update Points
			helpers$1.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			});
		},
	
		/**
		 * @protected
		 */
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var xScale = me.getScaleForId(meta.xAxisID);
			var yScale = me.getScaleForId(meta.yAxisID);
			var options = me._resolveDataElementOptions(point, index);
			var data = me.getDataset().data[index];
			var dsIndex = me.index;
	
			var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
			var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
	
			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = dsIndex;
			point._index = index;
			point._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				hitRadius: options.hitRadius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				radius: reset ? 0 : options.radius,
				skip: custom.skip || isNaN(x) || isNaN(y),
				x: x,
				y: y,
			};
	
			point.pivot();
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
			model.radius = options.radius + options.hoverRadius;
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function(point, index) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var custom = point.custom || {};
			var data = dataset.data[index] || {};
			var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			// In case values were cached (and thus frozen), we need to clone the values
			if (me._cachedDataOpts === values) {
				values = helpers$1.extend({}, values);
			}
	
			// Custom radius resolution
			values.radius = resolve$1([
				custom.radius,
				data.r,
				me._config.radius,
				chart.options.elements.point.radius
			], context, index);
	
			return values;
		}
	});
	
	var valueOrDefault$5 = helpers$1.valueOrDefault;
	
	var PI$1 = Math.PI;
	var DOUBLE_PI$1 = PI$1 * 2;
	var HALF_PI$1 = PI$1 / 2;
	
	core_defaults._set('doughnut', {
		animation: {
			// Boolean - Whether we animate the rotation of the Doughnut
			animateRotate: true,
			// Boolean - Whether we animate scaling the Doughnut from the centre
			animateScale: false
		},
		hover: {
			mode: 'single'
		},
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
			if (datasets.length) {
				for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
					listItem = list.appendChild(document.createElement('li'));
					listItemSpan = listItem.appendChild(document.createElement('span'));
					listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
					if (labels[i]) {
						listItem.appendChild(document.createTextNode(labels[i]));
					}
				}
			}
	
			return list.outerHTML;
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var style = meta.controller.getStyle(i);
	
							return {
								text: label,
								fillStyle: style.backgroundColor,
								strokeStyle: style.borderColor,
								lineWidth: style.borderWidth,
								hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					// toggle visibility of index if exists
					if (meta.data[index]) {
						meta.data[index].hidden = !meta.data[index].hidden;
					}
				}
	
				chart.update();
			}
		},
	
		// The percentage of the chart that we cut out of the middle.
		cutoutPercentage: 50,
	
		// The rotation of the chart, where the first data arc begins.
		rotation: -HALF_PI$1,
	
		// The total circumference of the chart.
		circumference: DOUBLE_PI$1,
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(tooltipItem, data) {
					var dataLabel = data.labels[tooltipItem.index];
					var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	
					if (helpers$1.isArray(dataLabel)) {
						// show value on first line of multiline label
						// need to clone because we are changing the value
						dataLabel = dataLabel.slice();
						dataLabel[0] += value;
					} else {
						dataLabel += value;
					}
	
					return dataLabel;
				}
			}
		}
	});
	
	var controller_doughnut = core_datasetController.extend({
	
		dataElementType: elements.Arc,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'borderAlign',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
		],
	
		// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
		getRingIndex: function(datasetIndex) {
			var ringIndex = 0;
	
			for (var j = 0; j < datasetIndex; ++j) {
				if (this.chart.isDatasetVisible(j)) {
					++ringIndex;
				}
			}
	
			return ringIndex;
		},
	
		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var ratioX = 1;
			var ratioY = 1;
			var offsetX = 0;
			var offsetY = 0;
			var meta = me.getMeta();
			var arcs = meta.data;
			var cutout = opts.cutoutPercentage / 100 || 0;
			var circumference = opts.circumference;
			var chartWeight = me._getRingWeight(me.index);
			var maxWidth, maxHeight, i, ilen;
	
			// If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
			if (circumference < DOUBLE_PI$1) {
				var startAngle = opts.rotation % DOUBLE_PI$1;
				startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
				var endAngle = startAngle + circumference;
				var startX = Math.cos(startAngle);
				var startY = Math.sin(startAngle);
				var endX = Math.cos(endAngle);
				var endY = Math.sin(endAngle);
				var contains0 = (startAngle <= 0 && endAngle >= 0) || endAngle >= DOUBLE_PI$1;
				var contains90 = (startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1) || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
				var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
				var contains270 = (startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1) || endAngle >= PI$1 + HALF_PI$1;
				var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
				var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
				var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
				var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
				ratioX = (maxX - minX) / 2;
				ratioY = (maxY - minY) / 2;
				offsetX = -(maxX + minX) / 2;
				offsetY = -(maxY + minY) / 2;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
			}
	
			chart.borderWidth = me.getMaxBorderWidth();
			maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
			maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
			chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
			chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
			chart.offsetX = offsetX * chart.outerRadius;
			chart.offsetY = offsetY * chart.outerRadius;
	
			meta.total = me.calculateTotal();
	
			me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
			me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				me.updateElement(arcs[i], i, reset);
			}
		},
	
		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var animationOpts = opts.animation;
			var centerX = (chartArea.left + chartArea.right) / 2;
			var centerY = (chartArea.top + chartArea.bottom) / 2;
			var startAngle = opts.rotation; // non reset case handled later
			var endAngle = opts.rotation; // non reset case handled later
			var dataset = me.getDataset();
			var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
			var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
			var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
			var options = arc._options || {};
	
			helpers$1.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
	
				// Desired view properties
				_model: {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					borderAlign: options.borderAlign,
					x: centerX + chart.offsetX,
					y: centerY + chart.offsetY,
					startAngle: startAngle,
					endAngle: endAngle,
					circumference: circumference,
					outerRadius: outerRadius,
					innerRadius: innerRadius,
					label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
				}
			});
	
			var model = arc._model;
	
			// Set correct angles if not resetting
			if (!reset || !animationOpts.animateRotate) {
				if (index === 0) {
					model.startAngle = opts.rotation;
				} else {
					model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
				}
	
				model.endAngle = model.startAngle + model.circumference;
			}
	
			arc.pivot();
		},
	
		calculateTotal: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var total = 0;
			var value;
	
			helpers$1.each(meta.data, function(element, index) {
				value = dataset.data[index];
				if (!isNaN(value) && !element.hidden) {
					total += Math.abs(value);
				}
			});
	
			/* if (total === 0) {
				total = NaN;
			}*/
	
			return total;
		},
	
		calculateCircumference: function(value) {
			var total = this.getMeta().total;
			if (total > 0 && !isNaN(value)) {
				return DOUBLE_PI$1 * (Math.abs(value) / total);
			}
			return 0;
		},
	
		// gets the max border or hover width to properly scale pie charts
		getMaxBorderWidth: function(arcs) {
			var me = this;
			var max = 0;
			var chart = me.chart;
			var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
	
			if (!arcs) {
				// Find the outmost visible dataset
				for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
					if (chart.isDatasetVisible(i)) {
						meta = chart.getDatasetMeta(i);
						arcs = meta.data;
						if (i !== me.index) {
							controller = meta.controller;
						}
						break;
					}
				}
			}
	
			if (!arcs) {
				return 0;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arc = arcs[i];
				if (controller) {
					controller._configure();
					options = controller._resolveDataElementOptions(arc, i);
				} else {
					options = arc._options;
				}
				if (options.borderAlign !== 'inner') {
					borderWidth = options.borderWidth;
					hoverWidth = options.hoverBorderWidth;
	
					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
			}
			return max;
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(arc) {
			var model = arc._model;
			var options = arc._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			arc.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
			};
	
			model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
		},
	
		/**
		 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
		 * @private
		 */
		_getRingWeightOffset: function(datasetIndex) {
			var ringWeightOffset = 0;
	
			for (var i = 0; i < datasetIndex; ++i) {
				if (this.chart.isDatasetVisible(i)) {
					ringWeightOffset += this._getRingWeight(i);
				}
			}
	
			return ringWeightOffset;
		},
	
		/**
		 * @private
		 */
		_getRingWeight: function(dataSetIndex) {
			return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
		},
	
		/**
		 * Returns the sum of all visibile data set weights.  This value can be 0.
		 * @private
		 */
		_getVisibleDatasetWeightTotal: function() {
			return this._getRingWeightOffset(this.chart.data.datasets.length);
		}
	});
	
	core_defaults._set('horizontalBar', {
		hover: {
			mode: 'index',
			axis: 'y'
		},
	
		scales: {
			xAxes: [{
				type: 'linear',
				position: 'bottom'
			}],
	
			yAxes: [{
				type: 'category',
				position: 'left',
				offset: true,
				gridLines: {
					offsetGridLines: true
				}
			}]
		},
	
		elements: {
			rectangle: {
				borderSkipped: 'left'
			}
		},
	
		tooltips: {
			mode: 'index',
			axis: 'y'
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			horizontalBar: {
				categoryPercentage: 0.8,
				barPercentage: 0.9
			}
		}
	});
	
	var controller_horizontalBar = controller_bar.extend({
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.getMeta().xAxisID;
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.getMeta().yAxisID;
		}
	});
	
	var valueOrDefault$6 = helpers$1.valueOrDefault;
	var resolve$2 = helpers$1.options.resolve;
	var isPointInArea = helpers$1.canvas._isPointInArea;
	
	core_defaults._set('line', {
		showLines: true,
		spanGaps: false,
	
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
				id: 'x-axis-0'
			}],
			yAxes: [{
				type: 'linear',
				id: 'y-axis-0'
			}]
		}
	});
	
	function scaleClip(scale, halfBorderWidth) {
		var tickOpts = scale && scale.options.ticks || {};
		var reverse = tickOpts.reverse;
		var min = tickOpts.min === undefined ? halfBorderWidth : 0;
		var max = tickOpts.max === undefined ? halfBorderWidth : 0;
		return {
			start: reverse ? max : min,
			end: reverse ? min : max
		};
	}
	
	function defaultClip(xScale, yScale, borderWidth) {
		var halfBorderWidth = borderWidth / 2;
		var x = scaleClip(xScale, halfBorderWidth);
		var y = scaleClip(yScale, halfBorderWidth);
	
		return {
			top: y.end,
			right: x.end,
			bottom: y.start,
			left: x.start
		};
	}
	
	function toClip(value) {
		var t, r, b, l;
	
		if (helpers$1.isObject(value)) {
			t = value.top;
			r = value.right;
			b = value.bottom;
			l = value.left;
		} else {
			t = r = b = l = value;
		}
	
		return {
			top: t,
			right: r,
			bottom: b,
			left: l
		};
	}
	
	
	var controller_line = core_datasetController.extend({
	
		datasetElementType: elements.Line,
	
		dataElementType: elements.Point,
	
		/**
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderCapStyle',
			'borderColor',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'borderWidth',
			'cubicInterpolationMode',
			'fill'
		],
	
		/**
		 * @private
		 */
		_dataElementOptions: {
			backgroundColor: 'pointBackgroundColor',
			borderColor: 'pointBorderColor',
			borderWidth: 'pointBorderWidth',
			hitRadius: 'pointHitRadius',
			hoverBackgroundColor: 'pointHoverBackgroundColor',
			hoverBorderColor: 'pointHoverBorderColor',
			hoverBorderWidth: 'pointHoverBorderWidth',
			hoverRadius: 'pointHoverRadius',
			pointStyle: 'pointStyle',
			radius: 'pointRadius',
			rotation: 'pointRotation'
		},
	
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var options = me.chart.options;
			var config = me._config;
			var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
			var i, ilen;
	
			me._xScale = me.getScaleForId(meta.xAxisID);
			me._yScale = me.getScaleForId(meta.yAxisID);
	
			// Update Line
			if (showLine) {
				// Compatibility: If the properties are defined with only the old name, use those values
				if (config.tension !== undefined && config.lineTension === undefined) {
					config.lineTension = config.tension;
				}
	
				// Utility
				line._scale = me._yScale;
				line._datasetIndex = me.index;
				// Data
				line._children = points;
				// Model
				line._model = me._resolveDatasetElementOptions(line);
	
				line.pivot();
			}
	
			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}
	
			if (showLine && line._model.tension !== 0) {
				me.updateBezierControlPoints();
			}
	
			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},
	
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var datasetIndex = me.index;
			var value = dataset.data[index];
			var xScale = me._xScale;
			var yScale = me._yScale;
			var lineModel = meta.dataset._model;
			var x, y;
	
			var options = me._resolveDataElementOptions(point, index);
	
			x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
			y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
	
			// Utility
			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = datasetIndex;
			point._index = index;
	
			// Desired view properties
			point._model = {
				x: x,
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: options.radius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
				steppedLine: lineModel ? lineModel.steppedLine : false,
				// Tooltip
				hitRadius: options.hitRadius
			};
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function(element) {
			var me = this;
			var config = me._config;
			var custom = element.custom || {};
			var options = me.chart.options;
			var lineOptions = options.elements.line;
			var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
	
			// The default behavior of lines is to break at null values, according
			// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
			// This option gives lines the ability to span gaps
			values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
			values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
			values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
			values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
	
			return values;
		},
	
		calculatePointY: function(value, index, datasetIndex) {
			var me = this;
			var chart = me.chart;
			var yScale = me._yScale;
			var sumPos = 0;
			var sumNeg = 0;
			var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
	
			if (yScale.options.stacked) {
				rightValue = +yScale.getRightValue(value);
				metasets = chart._getSortedVisibleDatasetMetas();
				ilen = metasets.length;
	
				for (i = 0; i < ilen; ++i) {
					dsMeta = metasets[i];
					if (dsMeta.index === datasetIndex) {
						break;
					}
	
					ds = chart.data.datasets[dsMeta.index];
					if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
						stackedRightValue = +yScale.getRightValue(ds.data[index]);
						if (stackedRightValue < 0) {
							sumNeg += stackedRightValue || 0;
						} else {
							sumPos += stackedRightValue || 0;
						}
					}
				}
	
				if (rightValue < 0) {
					return yScale.getPixelForValue(sumNeg + rightValue);
				}
				return yScale.getPixelForValue(sumPos + rightValue);
			}
			return yScale.getPixelForValue(value);
		},
	
		updateBezierControlPoints: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var lineModel = meta.dataset._model;
			var area = chart.chartArea;
			var points = meta.data || [];
			var i, ilen, model, controlPoints;
	
			// Only consider points that are drawn in case the spanGaps option is used
			if (lineModel.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}
	
			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}
	
			if (lineModel.cubicInterpolationMode === 'monotone') {
				helpers$1.splineCurveMonotone(points);
			} else {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					controlPoints = helpers$1.splineCurve(
						helpers$1.previousItem(points, i)._model,
						model,
						helpers$1.nextItem(points, i)._model,
						lineModel.tension
					);
					model.controlPointPreviousX = controlPoints.previous.x;
					model.controlPointPreviousY = controlPoints.previous.y;
					model.controlPointNextX = controlPoints.next.x;
					model.controlPointNextY = controlPoints.next.y;
				}
			}
	
			if (chart.options.elements.line.capBezierPoints) {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					if (isPointInArea(model, area)) {
						if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
							model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
							model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						}
						if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
							model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
							model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
						}
					}
				}
			}
		},
	
		draw: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var points = meta.data || [];
			var area = chart.chartArea;
			var canvas = chart.canvas;
			var i = 0;
			var ilen = points.length;
			var clip;
	
			if (me._showLine) {
				clip = meta.dataset._model.clip;
	
				helpers$1.canvas.clipArea(chart.ctx, {
					left: clip.left === false ? 0 : area.left - clip.left,
					right: clip.right === false ? canvas.width : area.right + clip.right,
					top: clip.top === false ? 0 : area.top - clip.top,
					bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
				});
	
				meta.dataset.draw();
	
				helpers$1.canvas.unclipArea(chart.ctx);
			}
	
			// Draw the points
			for (; i < ilen; ++i) {
				points[i].draw(area);
			}
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
			model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
		},
	});
	
	var resolve$3 = helpers$1.options.resolve;
	
	core_defaults._set('polarArea', {
		scale: {
			type: 'radialLinear',
			angleLines: {
				display: false
			},
			gridLines: {
				circular: true
			},
			pointLabels: {
				display: false
			},
			ticks: {
				beginAtZero: true
			}
		},
	
		// Boolean - Whether to animate the rotation of the chart
		animation: {
			animateRotate: true,
			animateScale: true
		},
	
		startAngle: -0.5 * Math.PI,
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
			if (datasets.length) {
				for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
					listItem = list.appendChild(document.createElement('li'));
					listItemSpan = listItem.appendChild(document.createElement('span'));
					listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
					if (labels[i]) {
						listItem.appendChild(document.createTextNode(labels[i]));
					}
				}
			}
	
			return list.outerHTML;
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var style = meta.controller.getStyle(i);
	
							return {
								text: label,
								fillStyle: style.backgroundColor,
								strokeStyle: style.borderColor,
								lineWidth: style.borderWidth,
								hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					meta.data[index].hidden = !meta.data[index].hidden;
				}
	
				chart.update();
			}
		},
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(item, data) {
					return data.labels[item.index] + ': ' + item.yLabel;
				}
			}
		}
	});
	
	var controller_polarArea = core_datasetController.extend({
	
		dataElementType: elements.Arc,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'borderAlign',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
		],
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.chart.scale.id;
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.chart.scale.id;
		},
	
		update: function(reset) {
			var me = this;
			var dataset = me.getDataset();
			var meta = me.getMeta();
			var start = me.chart.options.startAngle || 0;
			var starts = me._starts = [];
			var angles = me._angles = [];
			var arcs = meta.data;
			var i, ilen, angle;
	
			me._updateRadius();
	
			meta.count = me.countVisibleElements();
	
			for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
				starts[i] = start;
				angle = me._computeAngle(i);
				angles[i] = angle;
				start += angle;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
				me.updateElement(arcs[i], i, reset);
			}
		},
	
		/**
		 * @private
		 */
		_updateRadius: function() {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
	
			chart.outerRadius = Math.max(minSize / 2, 0);
			chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
	
			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
			me.innerRadius = me.outerRadius - chart.radiusLength;
		},
	
		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var opts = chart.options;
			var animationOpts = opts.animation;
			var scale = chart.scale;
			var labels = chart.data.labels;
	
			var centerX = scale.xCenter;
			var centerY = scale.yCenter;
	
			// var negHalfPI = -0.5 * Math.PI;
			var datasetStartAngle = opts.startAngle;
			var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var startAngle = me._starts[index];
			var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
	
			var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var options = arc._options || {};
	
			helpers$1.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,
	
				// Desired view properties
				_model: {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					borderAlign: options.borderAlign,
					x: centerX,
					y: centerY,
					innerRadius: 0,
					outerRadius: reset ? resetRadius : distance,
					startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
					endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
					label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
				}
			});
	
			arc.pivot();
		},
	
		countVisibleElements: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var count = 0;
	
			helpers$1.each(meta.data, function(element, index) {
				if (!isNaN(dataset.data[index]) && !element.hidden) {
					count++;
				}
			});
	
			return count;
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(arc) {
			var model = arc._model;
			var options = arc._options;
			var getHoverColor = helpers$1.getHoverColor;
			var valueOrDefault = helpers$1.valueOrDefault;
	
			arc.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
			};
	
			model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
		},
	
		/**
		 * @private
		 */
		_computeAngle: function(index) {
			var me = this;
			var count = this.getMeta().count;
			var dataset = me.getDataset();
			var meta = me.getMeta();
	
			if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
				return 0;
			}
	
			// Scriptable options
			var context = {
				chart: me.chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			return resolve$3([
				me.chart.options.elements.arc.angle,
				(2 * Math.PI) / count
			], context, index);
		}
	});
	
	core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
	core_defaults._set('pie', {
		cutoutPercentage: 0
	});
	
	// Pie charts are Doughnut chart with different defaults
	var controller_pie = controller_doughnut;
	
	var valueOrDefault$7 = helpers$1.valueOrDefault;
	
	core_defaults._set('radar', {
		spanGaps: false,
		scale: {
			type: 'radialLinear'
		},
		elements: {
			line: {
				fill: 'start',
				tension: 0 // no bezier in radar
			}
		}
	});
	
	var controller_radar = core_datasetController.extend({
		datasetElementType: elements.Line,
	
		dataElementType: elements.Point,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderWidth',
			'borderColor',
			'borderCapStyle',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'fill'
		],
	
		/**
		 * @private
		 */
		_dataElementOptions: {
			backgroundColor: 'pointBackgroundColor',
			borderColor: 'pointBorderColor',
			borderWidth: 'pointBorderWidth',
			hitRadius: 'pointHitRadius',
			hoverBackgroundColor: 'pointHoverBackgroundColor',
			hoverBorderColor: 'pointHoverBorderColor',
			hoverBorderWidth: 'pointHoverBorderWidth',
			hoverRadius: 'pointHoverRadius',
			pointStyle: 'pointStyle',
			radius: 'pointRadius',
			rotation: 'pointRotation'
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.chart.scale.id;
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.chart.scale.id;
		},
	
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var scale = me.chart.scale;
			var config = me._config;
			var i, ilen;
	
			// Compatibility: If the properties are defined with only the old name, use those values
			if (config.tension !== undefined && config.lineTension === undefined) {
				config.lineTension = config.tension;
			}
	
			// Utility
			line._scale = scale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			line._loop = true;
			// Model
			line._model = me._resolveDatasetElementOptions(line);
	
			line.pivot();
	
			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}
	
			// Update bezier control points
			me.updateBezierControlPoints();
	
			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},
	
		updateElement: function(point, index, reset) {
			var me = this;
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var scale = me.chart.scale;
			var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
			var options = me._resolveDataElementOptions(point, index);
			var lineModel = me.getMeta().dataset._model;
			var x = reset ? scale.xCenter : pointPosition.x;
			var y = reset ? scale.yCenter : pointPosition.y;
	
			// Utility
			point._scale = scale;
			point._options = options;
			point._datasetIndex = me.index;
			point._index = index;
	
			// Desired view properties
			point._model = {
				x: x, // value not used in dataset scale, but we want a consistent API between scales
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: options.radius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
	
				// Tooltip
				hitRadius: options.hitRadius
			};
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function() {
			var me = this;
			var config = me._config;
			var options = me.chart.options;
			var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
	
			values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
			values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
	
			return values;
		},
	
		updateBezierControlPoints: function() {
			var me = this;
			var meta = me.getMeta();
			var area = me.chart.chartArea;
			var points = meta.data || [];
			var i, ilen, model, controlPoints;
	
			// Only consider points that are drawn in case the spanGaps option is used
			if (meta.dataset._model.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}
	
			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}
	
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i, true)._model,
					model,
					helpers$1.nextItem(points, i, true)._model,
					model.tension
				);
	
				// Prevent the bezier going outside of the bounds of the graph
				model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
				model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
				model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
				model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
			}
		},
	
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
			model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
		}
	});
	
	core_defaults._set('scatter', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				id: 'x-axis-1',    // need an ID so datasets can reference the scale
				type: 'linear',    // scatter should not use a category axis
				position: 'bottom'
			}],
			yAxes: [{
				id: 'y-axis-1',
				type: 'linear',
				position: 'left'
			}]
		},
	
		tooltips: {
			callbacks: {
				title: function() {
					return '';     // doesn't make sense for scatter since data are formatted as a point
				},
				label: function(item) {
					return '(' + item.xLabel + ', ' + item.yLabel + ')';
				}
			}
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			scatter: {
				showLine: false
			}
		}
	});
	
	// Scatter charts use line controllers
	var controller_scatter = controller_line;
	
	// NOTE export a map in which the key represents the controller type, not
	// the class, and so must be CamelCase in order to be correctly retrieved
	// by the controller in core.controller.js (`controllers[meta.type]`).
	
	var controllers = {
		bar: controller_bar,
		bubble: controller_bubble,
		doughnut: controller_doughnut,
		horizontalBar: controller_horizontalBar,
		line: controller_line,
		polarArea: controller_polarArea,
		pie: controller_pie,
		radar: controller_radar,
		scatter: controller_scatter
	};
	
	/**
	 * Helper function to get relative position for an event
	 * @param {Event|IEvent} event - The event to get the position for
	 * @param {Chart} chart - The chart
	 * @returns {object} the event position
	 */
	function getRelativePosition(e, chart) {
		if (e.native) {
			return {
				x: e.x,
				y: e.y
			};
		}
	
		return helpers$1.getRelativePosition(e, chart);
	}
	
	/**
	 * Helper function to traverse all of the visible elements in the chart
	 * @param {Chart} chart - the chart
	 * @param {function} handler - the callback to execute for each visible item
	 */
	function parseVisibleItems(chart, handler) {
		var metasets = chart._getSortedVisibleDatasetMetas();
		var metadata, i, j, ilen, jlen, element;
	
		for (i = 0, ilen = metasets.length; i < ilen; ++i) {
			metadata = metasets[i].data;
			for (j = 0, jlen = metadata.length; j < jlen; ++j) {
				element = metadata[j];
				if (!element._view.skip) {
					handler(element);
				}
			}
		}
	}
	
	/**
	 * Helper function to get the items that intersect the event position
	 * @param {ChartElement[]} items - elements to filter
	 * @param {object} position - the point to be nearest to
	 * @return {ChartElement[]} the nearest items
	 */
	function getIntersectItems(chart, position) {
		var elements = [];
	
		parseVisibleItems(chart, function(element) {
			if (element.inRange(position.x, position.y)) {
				elements.push(element);
			}
		});
	
		return elements;
	}
	
	/**
	 * Helper function to get the items nearest to the event position considering all visible items in teh chart
	 * @param {Chart} chart - the chart to look at elements from
	 * @param {object} position - the point to be nearest to
	 * @param {boolean} intersect - if true, only consider items that intersect the position
	 * @param {function} distanceMetric - function to provide the distance between points
	 * @return {ChartElement[]} the nearest items
	 */
	function getNearestItems(chart, position, intersect, distanceMetric) {
		var minDistance = Number.POSITIVE_INFINITY;
		var nearestItems = [];
	
		parseVisibleItems(chart, function(element) {
			if (intersect && !element.inRange(position.x, position.y)) {
				return;
			}
	
			var center = element.getCenterPoint();
			var distance = distanceMetric(position, center);
			if (distance < minDistance) {
				nearestItems = [element];
				minDistance = distance;
			} else if (distance === minDistance) {
				// Can have multiple items at the same distance in which case we sort by size
				nearestItems.push(element);
			}
		});
	
		return nearestItems;
	}
	
	/**
	 * Get a distance metric function for two points based on the
	 * axis mode setting
	 * @param {string} axis - the axis mode. x|y|xy
	 */
	function getDistanceMetricForAxis(axis) {
		var useX = axis.indexOf('x') !== -1;
		var useY = axis.indexOf('y') !== -1;
	
		return function(pt1, pt2) {
			var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
			var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
			return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
		};
	}
	
	function indexMode(chart, e, options) {
		var position = getRelativePosition(e, chart);
		// Default axis for index mode is 'x' to match old behaviour
		options.axis = options.axis || 'x';
		var distanceMetric = getDistanceMetricForAxis(options.axis);
		var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
		var elements = [];
	
		if (!items.length) {
			return [];
		}
	
		chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
			var element = meta.data[items[0]._index];
	
			// don't count items that are skipped (null data)
			if (element && !element._view.skip) {
				elements.push(element);
			}
		});
	
		return elements;
	}
	
	/**
	 * @interface IInteractionOptions
	 */
	/**
	 * If true, only consider items that intersect the point
	 * @name IInterfaceOptions#boolean
	 * @type Boolean
	 */
	
	/**
	 * Contains interaction related functions
	 * @namespace Chart.Interaction
	 */
	var core_interaction = {
		// Helper function for different modes
		modes: {
			single: function(chart, e) {
				var position = getRelativePosition(e, chart);
				var elements = [];
	
				parseVisibleItems(chart, function(element) {
					if (element.inRange(position.x, position.y)) {
						elements.push(element);
						return elements;
					}
				});
	
				return elements.slice(0, 1);
			},
	
			/**
			 * @function Chart.Interaction.modes.label
			 * @deprecated since version 2.4.0
			 * @todo remove at version 3
			 * @private
			 */
			label: indexMode,
	
			/**
			 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
			 * @function Chart.Interaction.modes.index
			 * @since v2.4.0
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			index: indexMode,
	
			/**
			 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect is false, we find the nearest item and return the items in that dataset
			 * @function Chart.Interaction.modes.dataset
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			dataset: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	
				if (items.length > 0) {
					items = chart.getDatasetMeta(items[0]._datasetIndex).data;
				}
	
				return items;
			},
	
			/**
			 * @function Chart.Interaction.modes.x-axis
			 * @deprecated since version 2.4.0. Use index mode and intersect == true
			 * @todo remove at version 3
			 * @private
			 */
			'x-axis': function(chart, e) {
				return indexMode(chart, e, {intersect: false});
			},
	
			/**
			 * Point mode returns all elements that hit test based on the event position
			 * of the event
			 * @function Chart.Interaction.modes.intersect
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			point: function(chart, e) {
				var position = getRelativePosition(e, chart);
				return getIntersectItems(chart, position);
			},
	
			/**
			 * nearest mode returns the element closest to the point
			 * @function Chart.Interaction.modes.intersect
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			nearest: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				return getNearestItems(chart, position, options.intersect, distanceMetric);
			},
	
			/**
			 * x mode returns the elements that hit-test at the current x coordinate
			 * @function Chart.Interaction.modes.x
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			x: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inXRange(position.x)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			},
	
			/**
			 * y mode returns the elements that hit-test at the current y coordinate
			 * @function Chart.Interaction.modes.y
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			y: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inYRange(position.y)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			}
		}
	};
	
	var extend = helpers$1.extend;
	
	function filterByPosition(array, position) {
		return helpers$1.where(array, function(v) {
			return v.pos === position;
		});
	}
	
	function sortByWeight(array, reverse) {
		return array.sort(function(a, b) {
			var v0 = reverse ? b : a;
			var v1 = reverse ? a : b;
			return v0.weight === v1.weight ?
				v0.index - v1.index :
				v0.weight - v1.weight;
		});
	}
	
	function wrapBoxes(boxes) {
		var layoutBoxes = [];
		var i, ilen, box;
	
		for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
			box = boxes[i];
			layoutBoxes.push({
				index: i,
				box: box,
				pos: box.position,
				horizontal: box.isHorizontal(),
				weight: box.weight
			});
		}
		return layoutBoxes;
	}
	
	function setLayoutDims(layouts, params) {
		var i, ilen, layout;
		for (i = 0, ilen = layouts.length; i < ilen; ++i) {
			layout = layouts[i];
			// store width used instead of chartArea.w in fitBoxes
			layout.width = layout.horizontal
				? layout.box.fullWidth && params.availableWidth
				: params.vBoxMaxWidth;
			// store height used instead of chartArea.h in fitBoxes
			layout.height = layout.horizontal && params.hBoxMaxHeight;
		}
	}
	
	function buildLayoutBoxes(boxes) {
		var layoutBoxes = wrapBoxes(boxes);
		var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
		var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
		var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
		var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
	
		return {
			leftAndTop: left.concat(top),
			rightAndBottom: right.concat(bottom),
			chartArea: filterByPosition(layoutBoxes, 'chartArea'),
			vertical: left.concat(right),
			horizontal: top.concat(bottom)
		};
	}
	
	function getCombinedMax(maxPadding, chartArea, a, b) {
		return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
	}
	
	function updateDims(chartArea, params, layout) {
		var box = layout.box;
		var maxPadding = chartArea.maxPadding;
		var newWidth, newHeight;
	
		if (layout.size) {
			// this layout was already counted for, lets first reduce old size
			chartArea[layout.pos] -= layout.size;
		}
		layout.size = layout.horizontal ? box.height : box.width;
		chartArea[layout.pos] += layout.size;
	
		if (box.getPadding) {
			var boxPadding = box.getPadding();
			maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
			maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
			maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
			maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
		}
	
		newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
		newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');
	
		if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
			chartArea.w = newWidth;
			chartArea.h = newHeight;
	
			// return true if chart area changed in layout's direction
			var sizes = layout.horizontal ? [newWidth, chartArea.w] : [newHeight, chartArea.h];
			return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
		}
	}
	
	function handleMaxPadding(chartArea) {
		var maxPadding = chartArea.maxPadding;
	
		function updatePos(pos) {
			var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
			chartArea[pos] += change;
			return change;
		}
		chartArea.y += updatePos('top');
		chartArea.x += updatePos('left');
		updatePos('right');
		updatePos('bottom');
	}
	
	function getMargins(horizontal, chartArea) {
		var maxPadding = chartArea.maxPadding;
	
		function marginForPositions(positions) {
			var margin = {left: 0, top: 0, right: 0, bottom: 0};
			positions.forEach(function(pos) {
				margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
			});
			return margin;
		}
	
		return horizontal
			? marginForPositions(['left', 'right'])
			: marginForPositions(['top', 'bottom']);
	}
	
	function fitBoxes(boxes, chartArea, params) {
		var refitBoxes = [];
		var i, ilen, layout, box, refit, changed;
	
		for (i = 0, ilen = boxes.length; i < ilen; ++i) {
			layout = boxes[i];
			box = layout.box;
	
			box.update(
				layout.width || chartArea.w,
				layout.height || chartArea.h,
				getMargins(layout.horizontal, chartArea)
			);
			if (updateDims(chartArea, params, layout)) {
				changed = true;
				if (refitBoxes.length) {
					// Dimensions changed and there were non full width boxes before this
					// -> we have to refit those
					refit = true;
				}
			}
			if (!box.fullWidth) { // fullWidth boxes don't need to be re-fitted in any case
				refitBoxes.push(layout);
			}
		}
	
		return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
	}
	
	function placeBoxes(boxes, chartArea, params) {
		var userPadding = params.padding;
		var x = chartArea.x;
		var y = chartArea.y;
		var i, ilen, layout, box;
	
		for (i = 0, ilen = boxes.length; i < ilen; ++i) {
			layout = boxes[i];
			box = layout.box;
			if (layout.horizontal) {
				box.left = box.fullWidth ? userPadding.left : chartArea.left;
				box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
				box.top = y;
				box.bottom = y + box.height;
				box.width = box.right - box.left;
				y = box.bottom;
			} else {
				box.left = x;
				box.right = x + box.width;
				box.top = chartArea.top;
				box.bottom = chartArea.top + chartArea.h;
				box.height = box.bottom - box.top;
				x = box.right;
			}
		}
	
		chartArea.x = x;
		chartArea.y = y;
	}
	
	core_defaults._set('global', {
		layout: {
			padding: {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0
			}
		}
	});
	
	/**
	 * @interface ILayoutItem
	 * @prop {string} position - The position of the item in the chart layout. Possible values are
	 * 'left', 'top', 'right', 'bottom', and 'chartArea'
	 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
	 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
	 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
	 * @prop {function} update - Takes two parameters: width and height. Returns size of item
	 * @prop {function} getPadding -  Returns an object with padding on the edges
	 * @prop {number} width - Width of item. Must be valid after update()
	 * @prop {number} height - Height of item. Must be valid after update()
	 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
	 */
	
	// The layout service is very self explanatory.  It's responsible for the layout within a chart.
	// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
	// It is this service's responsibility of carrying out that layout.
	var core_layouts = {
		defaults: {},
	
		/**
		 * Register a box to a chart.
		 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
		 * @param {Chart} chart - the chart to use
		 * @param {ILayoutItem} item - the item to add to be layed out
		 */
		addBox: function(chart, item) {
			if (!chart.boxes) {
				chart.boxes = [];
			}
	
			// initialize item with default values
			item.fullWidth = item.fullWidth || false;
			item.position = item.position || 'top';
			item.weight = item.weight || 0;
			item._layers = item._layers || function() {
				return [{
					z: 0,
					draw: function() {
						item.draw.apply(item, arguments);
					}
				}];
			};
	
			chart.boxes.push(item);
		},
	
		/**
		 * Remove a layoutItem from a chart
		 * @param {Chart} chart - the chart to remove the box from
		 * @param {ILayoutItem} layoutItem - the item to remove from the layout
		 */
		removeBox: function(chart, layoutItem) {
			var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
			if (index !== -1) {
				chart.boxes.splice(index, 1);
			}
		},
	
		/**
		 * Sets (or updates) options on the given `item`.
		 * @param {Chart} chart - the chart in which the item lives (or will be added to)
		 * @param {ILayoutItem} item - the item to configure with the given options
		 * @param {object} options - the new item options.
		 */
		configure: function(chart, item, options) {
			var props = ['fullWidth', 'position', 'weight'];
			var ilen = props.length;
			var i = 0;
			var prop;
	
			for (; i < ilen; ++i) {
				prop = props[i];
				if (options.hasOwnProperty(prop)) {
					item[prop] = options[prop];
				}
			}
		},
	
		/**
		 * Fits boxes of the given chart into the given size by having each box measure itself
		 * then running a fitting algorithm
		 * @param {Chart} chart - the chart
		 * @param {number} width - the width to fit into
		 * @param {number} height - the height to fit into
		 */
		update: function(chart, width, height) {
			if (!chart) {
				return;
			}
	
			var layoutOptions = chart.options.layout || {};
			var padding = helpers$1.options.toPadding(layoutOptions.padding);
	
			var availableWidth = width - padding.width;
			var availableHeight = height - padding.height;
			var boxes = buildLayoutBoxes(chart.boxes);
			var verticalBoxes = boxes.vertical;
			var horizontalBoxes = boxes.horizontal;
	
			// Essentially we now have any number of boxes on each of the 4 sides.
			// Our canvas looks like the following.
			// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
			// B1 is the bottom axis
			// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
			// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
			// an error will be thrown.
			//
			// |----------------------------------------------------|
			// |                  T1 (Full Width)                   |
			// |----------------------------------------------------|
			// |    |    |                 T2                  |    |
			// |    |----|-------------------------------------|----|
			// |    |    | C1 |                           | C2 |    |
			// |    |    |----|                           |----|    |
			// |    |    |                                     |    |
			// | L1 | L2 |           ChartArea (C0)            | R1 |
			// |    |    |                                     |    |
			// |    |    |----|                           |----|    |
			// |    |    | C3 |                           | C4 |    |
			// |    |----|-------------------------------------|----|
			// |    |    |                 B1                  |    |
			// |----------------------------------------------------|
			// |                  B2 (Full Width)                   |
			// |----------------------------------------------------|
			//
	
			var params = Object.freeze({
				outerWidth: width,
				outerHeight: height,
				padding: padding,
				availableWidth: availableWidth,
				vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
				hBoxMaxHeight: availableHeight / 2
			});
			var chartArea = extend({
				maxPadding: extend({}, padding),
				w: availableWidth,
				h: availableHeight,
				x: padding.left,
				y: padding.top
			}, padding);
	
			setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
	
			// First fit vertical boxes
			fitBoxes(verticalBoxes, chartArea, params);
	
			// Then fit horizontal boxes
			if (fitBoxes(horizontalBoxes, chartArea, params)) {
				// if the area changed, re-fit vertical boxes
				fitBoxes(verticalBoxes, chartArea, params);
			}
	
			handleMaxPadding(chartArea);
	
			// Finally place the boxes to correct coordinates
			placeBoxes(boxes.leftAndTop, chartArea, params);
	
			// Move to opposite side of chart
			chartArea.x += chartArea.w;
			chartArea.y += chartArea.h;
	
			placeBoxes(boxes.rightAndBottom, chartArea, params);
	
			chart.chartArea = {
				left: chartArea.left,
				top: chartArea.top,
				right: chartArea.left + chartArea.w,
				bottom: chartArea.top + chartArea.h
			};
	
			// Finally update boxes in chartArea (radial scale for example)
			helpers$1.each(boxes.chartArea, function(layout) {
				var box = layout.box;
				extend(box, chart.chartArea);
				box.update(chartArea.w, chartArea.h);
			});
		}
	};
	
	/**
	 * Platform fallback implementation (minimal).
	 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
	 */
	
	var platform_basic = {
		acquireContext: function(item) {
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			return item && item.getContext('2d') || null;
		}
	};
	
	var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";
	
	var platform_dom$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': platform_dom
	});
	
	var stylesheet = getCjsExportFromNamespace(platform_dom$1);
	
	var EXPANDO_KEY = '$chartjs';
	var CSS_PREFIX = 'chartjs-';
	var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
	var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
	var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
	var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];
	
	/**
	 * DOM event types -> Chart.js event types.
	 * Note: only events with different types are mapped.
	 * @see https://developer.mozilla.org/en-US/docs/Web/Events
	 */
	var EVENT_TYPES = {
		touchstart: 'mousedown',
		touchmove: 'mousemove',
		touchend: 'mouseup',
		pointerenter: 'mouseenter',
		pointerdown: 'mousedown',
		pointermove: 'mousemove',
		pointerup: 'mouseup',
		pointerleave: 'mouseout',
		pointerout: 'mouseout'
	};
	
	/**
	 * The "used" size is the final value of a dimension property after all calculations have
	 * been performed. This method uses the computed style of `element` but returns undefined
	 * if the computed style is not expressed in pixels. That can happen in some cases where
	 * `element` has a size relative to its parent and this last one is not yet displayed,
	 * for example because of `display: none` on a parent node.
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
	 * @returns {number} Size in pixels or undefined if unknown.
	 */
	function readUsedSize(element, property) {
		var value = helpers$1.getStyle(element, property);
		var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
		return matches ? Number(matches[1]) : undefined;
	}
	
	/**
	 * Initializes the canvas style and render size without modifying the canvas display size,
	 * since responsiveness is handled by the controller.resize() method. The config is used
	 * to determine the aspect ratio to apply in case no explicit height has been specified.
	 */
	function initCanvas(canvas, config) {
		var style = canvas.style;
	
		// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
		// returns null or '' if no explicit value has been set to the canvas attribute.
		var renderHeight = canvas.getAttribute('height');
		var renderWidth = canvas.getAttribute('width');
	
		// Chart.js modifies some canvas values that we want to restore on destroy
		canvas[EXPANDO_KEY] = {
			initial: {
				height: renderHeight,
				width: renderWidth,
				style: {
					display: style.display,
					height: style.height,
					width: style.width
				}
			}
		};
	
		// Force canvas to display as block to avoid extra space caused by inline
		// elements, which would interfere with the responsive resize process.
		// https://github.com/chartjs/Chart.js/issues/2538
		style.display = style.display || 'block';
	
		if (renderWidth === null || renderWidth === '') {
			var displayWidth = readUsedSize(canvas, 'width');
			if (displayWidth !== undefined) {
				canvas.width = displayWidth;
			}
		}
	
		if (renderHeight === null || renderHeight === '') {
			if (canvas.style.height === '') {
				// If no explicit render height and style height, let's apply the aspect ratio,
				// which one can be specified by the user but also by charts as default option
				// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
				canvas.height = canvas.width / (config.options.aspectRatio || 2);
			} else {
				var displayHeight = readUsedSize(canvas, 'height');
				if (displayWidth !== undefined) {
					canvas.height = displayHeight;
				}
			}
		}
	
		return canvas;
	}
	
	/**
	 * Detects support for options object argument in addEventListener.
	 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
	 * @private
	 */
	var supportsEventListenerOptions = (function() {
		var supports = false;
		try {
			var options = Object.defineProperty({}, 'passive', {
				// eslint-disable-next-line getter-return
				get: function() {
					supports = true;
				}
			});
			window.addEventListener('e', null, options);
		} catch (e) {
			// continue regardless of error
		}
		return supports;
	}());
	
	// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
	// https://github.com/chartjs/Chart.js/issues/4287
	var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;
	
	function addListener(node, type, listener) {
		node.addEventListener(type, listener, eventListenerOptions);
	}
	
	function removeListener(node, type, listener) {
		node.removeEventListener(type, listener, eventListenerOptions);
	}
	
	function createEvent(type, chart, x, y, nativeEvent) {
		return {
			type: type,
			chart: chart,
			native: nativeEvent || null,
			x: x !== undefined ? x : null,
			y: y !== undefined ? y : null,
		};
	}
	
	function fromNativeEvent(event, chart) {
		var type = EVENT_TYPES[event.type] || event.type;
		var pos = helpers$1.getRelativePosition(event, chart);
		return createEvent(type, chart, pos.x, pos.y, event);
	}
	
	function throttled(fn, thisArg) {
		var ticking = false;
		var args = [];
	
		return function() {
			args = Array.prototype.slice.call(arguments);
			thisArg = thisArg || this;
	
			if (!ticking) {
				ticking = true;
				helpers$1.requestAnimFrame.call(window, function() {
					ticking = false;
					fn.apply(thisArg, args);
				});
			}
		};
	}
	
	function createDiv(cls) {
		var el = document.createElement('div');
		el.className = cls || '';
		return el;
	}
	
	// Implementation based on https://github.com/marcj/css-element-queries
	function createResizer(handler) {
		var maxSize = 1000000;
	
		// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
		// https://github.com/chartjs/Chart.js/issues/5902
		var resizer = createDiv(CSS_SIZE_MONITOR);
		var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
		var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');
	
		expand.appendChild(createDiv());
		shrink.appendChild(createDiv());
	
		resizer.appendChild(expand);
		resizer.appendChild(shrink);
		resizer._reset = function() {
			expand.scrollLeft = maxSize;
			expand.scrollTop = maxSize;
			shrink.scrollLeft = maxSize;
			shrink.scrollTop = maxSize;
		};
	
		var onScroll = function() {
			resizer._reset();
			handler();
		};
	
		addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
		addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
	
		return resizer;
	}
	
	// https://davidwalsh.name/detect-node-insertion
	function watchForRender(node, handler) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
		var proxy = expando.renderProxy = function(e) {
			if (e.animationName === CSS_RENDER_ANIMATION) {
				handler();
			}
		};
	
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			addListener(node, type, proxy);
		});
	
		// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
		// is removed then added back immediately (same animation frame?). Accessing the
		// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
		// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
		// https://github.com/chartjs/Chart.js/issues/4737
		expando.reflow = !!node.offsetParent;
	
		node.classList.add(CSS_RENDER_MONITOR);
	}
	
	function unwatchForRender(node) {
		var expando = node[EXPANDO_KEY] || {};
		var proxy = expando.renderProxy;
	
		if (proxy) {
			helpers$1.each(ANIMATION_START_EVENTS, function(type) {
				removeListener(node, type, proxy);
			});
	
			delete expando.renderProxy;
		}
	
		node.classList.remove(CSS_RENDER_MONITOR);
	}
	
	function addResizeListener(node, listener, chart) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	
		// Let's keep track of this added resizer and thus avoid DOM query when removing it.
		var resizer = expando.resizer = createResizer(throttled(function() {
			if (expando.resizer) {
				var container = chart.options.maintainAspectRatio && node.parentNode;
				var w = container ? container.clientWidth : 0;
				listener(createEvent('resize', chart));
				if (container && container.clientWidth < w && chart.canvas) {
					// If the container size shrank during chart resize, let's assume
					// scrollbar appeared. So we resize again with the scrollbar visible -
					// effectively making chart smaller and the scrollbar hidden again.
					// Because we are inside `throttled`, and currently `ticking`, scroll
					// events are ignored during this whole 2 resize process.
					// If we assumed wrong and something else happened, we are resizing
					// twice in a frame (potential performance issue)
					listener(createEvent('resize', chart));
				}
			}
		}));
	
		// The resizer needs to be attached to the node parent, so we first need to be
		// sure that `node` is attached to the DOM before injecting the resizer element.
		watchForRender(node, function() {
			if (expando.resizer) {
				var container = node.parentNode;
				if (container && container !== resizer.parentNode) {
					container.insertBefore(resizer, container.firstChild);
				}
	
				// The container size might have changed, let's reset the resizer state.
				resizer._reset();
			}
		});
	}
	
	function removeResizeListener(node) {
		var expando = node[EXPANDO_KEY] || {};
		var resizer = expando.resizer;
	
		delete expando.resizer;
		unwatchForRender(node);
	
		if (resizer && resizer.parentNode) {
			resizer.parentNode.removeChild(resizer);
		}
	}
	
	/**
	 * Injects CSS styles inline if the styles are not already present.
	 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
	 * @param {string} css - the CSS to be injected.
	 */
	function injectCSS(rootNode, css) {
		// https://stackoverflow.com/q/3922139
		var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
		if (!expando.containsStyles) {
			expando.containsStyles = true;
			css = '/* Chart.js */\n' + css;
			var style = document.createElement('style');
			style.setAttribute('type', 'text/css');
			style.appendChild(document.createTextNode(css));
			rootNode.appendChild(style);
		}
	}
	
	var platform_dom$2 = {
		/**
		 * When `true`, prevents the automatic injection of the stylesheet required to
		 * correctly detect when the chart is added to the DOM and then resized. This
		 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
		 * to be manually imported to make this library compatible with any CSP.
		 * See https://github.com/chartjs/Chart.js/issues/5208
		 */
		disableCSSInjection: false,
	
		/**
		 * This property holds whether this platform is enabled for the current environment.
		 * Currently used by platform.js to select the proper implementation.
		 * @private
		 */
		_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
	
		/**
		 * Initializes resources that depend on platform options.
		 * @param {HTMLCanvasElement} canvas - The Canvas element.
		 * @private
		 */
		_ensureLoaded: function(canvas) {
			if (!this.disableCSSInjection) {
				// If the canvas is in a shadow DOM, then the styles must also be inserted
				// into the same shadow DOM.
				// https://github.com/chartjs/Chart.js/issues/5763
				var root = canvas.getRootNode ? canvas.getRootNode() : document;
				var targetNode = root.host ? root : document.head;
				injectCSS(targetNode, stylesheet);
			}
		},
	
		acquireContext: function(item, config) {
			if (typeof item === 'string') {
				item = document.getElementById(item);
			} else if (item.length) {
				// Support for array based queries (such as jQuery)
				item = item[0];
			}
	
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			// To prevent canvas fingerprinting, some add-ons undefine the getContext
			// method, for example: https://github.com/kkapsner/CanvasBlocker
			// https://github.com/chartjs/Chart.js/issues/2807
			var context = item && item.getContext && item.getContext('2d');
	
			// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
			// inside an iframe or when running in a protected environment. We could guess the
			// types from their toString() value but let's keep things flexible and assume it's
			// a sufficient condition if the item has a context2D which has item as `canvas`.
			// https://github.com/chartjs/Chart.js/issues/3887
			// https://github.com/chartjs/Chart.js/issues/4102
			// https://github.com/chartjs/Chart.js/issues/4152
			if (context && context.canvas === item) {
				// Load platform resources on first chart creation, to make it possible to
				// import the library before setting platform options.
				this._ensureLoaded(item);
				initCanvas(item, config);
				return context;
			}
	
			return null;
		},
	
		releaseContext: function(context) {
			var canvas = context.canvas;
			if (!canvas[EXPANDO_KEY]) {
				return;
			}
	
			var initial = canvas[EXPANDO_KEY].initial;
			['height', 'width'].forEach(function(prop) {
				var value = initial[prop];
				if (helpers$1.isNullOrUndef(value)) {
					canvas.removeAttribute(prop);
				} else {
					canvas.setAttribute(prop, value);
				}
			});
	
			helpers$1.each(initial.style || {}, function(value, key) {
				canvas.style[key] = value;
			});
	
			// The canvas render size might have been changed (and thus the state stack discarded),
			// we can't use save() and restore() to restore the initial state. So make sure that at
			// least the canvas context is reset to the default state by setting the canvas width.
			// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
			// eslint-disable-next-line no-self-assign
			canvas.width = canvas.width;
	
			delete canvas[EXPANDO_KEY];
		},
	
		addEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				addResizeListener(canvas, listener, chart);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
			var proxies = expando.proxies || (expando.proxies = {});
			var proxy = proxies[chart.id + '_' + type] = function(event) {
				listener(fromNativeEvent(event, chart));
			};
	
			addListener(canvas, type, proxy);
		},
	
		removeEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				removeResizeListener(canvas);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || {};
			var proxies = expando.proxies || {};
			var proxy = proxies[chart.id + '_' + type];
			if (!proxy) {
				return;
			}
	
			removeListener(canvas, type, proxy);
		}
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use EventTarget.addEventListener instead.
	 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
	 * @function Chart.helpers.addEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.addEvent = addListener;
	
	/**
	 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
	 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
	 * @function Chart.helpers.removeEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.removeEvent = removeListener;
	
	// @TODO Make possible to select another platform at build time.
	var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
	
	/**
	 * @namespace Chart.platform
	 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
	 * @since 2.4.0
	 */
	var platform = helpers$1.extend({
		/**
		 * @since 2.7.0
		 */
		initialize: function() {},
	
		/**
		 * Called at chart construction time, returns a context2d instance implementing
		 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
		 * @param {*} item - The native item from which to acquire context (platform specific)
		 * @param {object} options - The chart options
		 * @returns {CanvasRenderingContext2D} context2d instance
		 */
		acquireContext: function() {},
	
		/**
		 * Called at chart destruction time, releases any resources associated to the context
		 * previously returned by the acquireContext() method.
		 * @param {CanvasRenderingContext2D} context - The context2d instance
		 * @returns {boolean} true if the method succeeded, else false
		 */
		releaseContext: function() {},
	
		/**
		 * Registers the specified listener on the given chart.
		 * @param {Chart} chart - Chart from which to listen for event
		 * @param {string} type - The ({@link IEvent}) type to listen for
		 * @param {function} listener - Receives a notification (an object that implements
		 * the {@link IEvent} interface) when an event of the specified type occurs.
		 */
		addEventListener: function() {},
	
		/**
		 * Removes the specified listener previously registered with addEventListener.
		 * @param {Chart} chart - Chart from which to remove the listener
		 * @param {string} type - The ({@link IEvent}) type to remove
		 * @param {function} listener - The listener function to remove from the event target.
		 */
		removeEventListener: function() {}
	
	}, implementation);
	
	core_defaults._set('global', {
		plugins: {}
	});
	
	/**
	 * The plugin service singleton
	 * @namespace Chart.plugins
	 * @since 2.1.0
	 */
	var core_plugins = {
		/**
		 * Globally registered plugins.
		 * @private
		 */
		_plugins: [],
	
		/**
		 * This identifier is used to invalidate the descriptors cache attached to each chart
		 * when a global plugin is registered or unregistered. In this case, the cache ID is
		 * incremented and descriptors are regenerated during following API calls.
		 * @private
		 */
		_cacheId: 0,
	
		/**
		 * Registers the given plugin(s) if not already registered.
		 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
		 */
		register: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				if (p.indexOf(plugin) === -1) {
					p.push(plugin);
				}
			});
	
			this._cacheId++;
		},
	
		/**
		 * Unregisters the given plugin(s) only if registered.
		 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
		 */
		unregister: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				var idx = p.indexOf(plugin);
				if (idx !== -1) {
					p.splice(idx, 1);
				}
			});
	
			this._cacheId++;
		},
	
		/**
		 * Remove all registered plugins.
		 * @since 2.1.5
		 */
		clear: function() {
			this._plugins = [];
			this._cacheId++;
		},
	
		/**
		 * Returns the number of registered plugins?
		 * @returns {number}
		 * @since 2.1.5
		 */
		count: function() {
			return this._plugins.length;
		},
	
		/**
		 * Returns all registered plugin instances.
		 * @returns {IPlugin[]} array of plugin objects.
		 * @since 2.1.5
		 */
		getAll: function() {
			return this._plugins;
		},
	
		/**
		 * Calls enabled plugins for `chart` on the specified hook and with the given args.
		 * This method immediately returns as soon as a plugin explicitly returns false. The
		 * returned value can be used, for instance, to interrupt the current action.
		 * @param {Chart} chart - The chart instance for which plugins should be called.
		 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
		 * @param {Array} [args] - Extra arguments to apply to the hook call.
		 * @returns {boolean} false if any of the plugins return false, else returns true.
		 */
		notify: function(chart, hook, args) {
			var descriptors = this.descriptors(chart);
			var ilen = descriptors.length;
			var i, descriptor, plugin, params, method;
	
			for (i = 0; i < ilen; ++i) {
				descriptor = descriptors[i];
				plugin = descriptor.plugin;
				method = plugin[hook];
				if (typeof method === 'function') {
					params = [chart].concat(args || []);
					params.push(descriptor.options);
					if (method.apply(plugin, params) === false) {
						return false;
					}
				}
			}
	
			return true;
		},
	
		/**
		 * Returns descriptors of enabled plugins for the given chart.
		 * @returns {object[]} [{ plugin, options }]
		 * @private
		 */
		descriptors: function(chart) {
			var cache = chart.$plugins || (chart.$plugins = {});
			if (cache.id === this._cacheId) {
				return cache.descriptors;
			}
	
			var plugins = [];
			var descriptors = [];
			var config = (chart && chart.config) || {};
			var options = (config.options && config.options.plugins) || {};
	
			this._plugins.concat(config.plugins || []).forEach(function(plugin) {
				var idx = plugins.indexOf(plugin);
				if (idx !== -1) {
					return;
				}
	
				var id = plugin.id;
				var opts = options[id];
				if (opts === false) {
					return;
				}
	
				if (opts === true) {
					opts = helpers$1.clone(core_defaults.global.plugins[id]);
				}
	
				plugins.push(plugin);
				descriptors.push({
					plugin: plugin,
					options: opts || {}
				});
			});
	
			cache.descriptors = descriptors;
			cache.id = this._cacheId;
			return descriptors;
		},
	
		/**
		 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
		 * but in some cases, this reference can be changed by the user when updating options.
		 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		 * @private
		 */
		_invalidate: function(chart) {
			delete chart.$plugins;
		}
	};
	
	var core_scaleService = {
		// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
		// use the new chart options to grab the correct scale
		constructors: {},
		// Use a registration function so that we can move to an ES6 map when we no longer need to support
		// old browsers
	
		// Scale config defaults
		defaults: {},
		registerScaleType: function(type, scaleConstructor, scaleDefaults) {
			this.constructors[type] = scaleConstructor;
			this.defaults[type] = helpers$1.clone(scaleDefaults);
		},
		getScaleConstructor: function(type) {
			return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
		},
		getScaleDefaults: function(type) {
			// Return the scale defaults merged with the global settings so that we always use the latest ones
			return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [core_defaults.scale, this.defaults[type]]) : {};
		},
		updateScaleDefaults: function(type, additions) {
			var me = this;
			if (me.defaults.hasOwnProperty(type)) {
				me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
			}
		},
		addScalesToLayout: function(chart) {
			// Adds each scale to the chart.boxes array to be sized accordingly
			helpers$1.each(chart.scales, function(scale) {
				// Set ILayoutItem parameters for backwards compatibility
				scale.fullWidth = scale.options.fullWidth;
				scale.position = scale.options.position;
				scale.weight = scale.options.weight;
				core_layouts.addBox(chart, scale);
			});
		}
	};
	
	var valueOrDefault$8 = helpers$1.valueOrDefault;
	var getRtlHelper = helpers$1.rtl.getRtlAdapter;
	
	core_defaults._set('global', {
		tooltips: {
			enabled: true,
			custom: null,
			mode: 'nearest',
			position: 'average',
			intersect: true,
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			caretPadding: 2,
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			displayColors: true,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0,
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers$1.noop,
				title: function(tooltipItems, data) {
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;
	
					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
						if (item.label) {
							title = item.label;
						} else if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}
	
					return title;
				},
				afterTitle: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				beforeBody: helpers$1.noop,
	
				// Args are: (tooltipItem, data)
				beforeLabel: helpers$1.noop,
				label: function(tooltipItem, data) {
					var label = data.datasets[tooltipItem.datasetIndex].label || '';
	
					if (label) {
						label += ': ';
					}
					if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
						label += tooltipItem.value;
					} else {
						label += tooltipItem.yLabel;
					}
					return label;
				},
				labelColor: function(tooltipItem, chart) {
					var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				labelTextColor: function() {
					return this._options.bodyFontColor;
				},
				afterLabel: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				afterBody: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				beforeFooter: helpers$1.noop,
				footer: helpers$1.noop,
				afterFooter: helpers$1.noop
			}
		}
	});
	
	var positioners = {
		/**
		 * Average mode places the tooltip at the average position of the elements shown
		 * @function Chart.Tooltip.positioners.average
		 * @param elements {ChartElement[]} the elements being displayed in the tooltip
		 * @returns {object} tooltip position
		 */
		average: function(elements) {
			if (!elements.length) {
				return false;
			}
	
			var i, len;
			var x = 0;
			var y = 0;
			var count = 0;
	
			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					x += pos.x;
					y += pos.y;
					++count;
				}
			}
	
			return {
				x: x / count,
				y: y / count
			};
		},
	
		/**
		 * Gets the tooltip position nearest of the item nearest to the event position
		 * @function Chart.Tooltip.positioners.nearest
		 * @param elements {Chart.Element[]} the tooltip elements
		 * @param eventPosition {object} the position of the event in canvas coordinates
		 * @returns {object} the tooltip position
		 */
		nearest: function(elements, eventPosition) {
			var x = eventPosition.x;
			var y = eventPosition.y;
			var minDistance = Number.POSITIVE_INFINITY;
			var i, len, nearestElement;
	
			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var center = el.getCenterPoint();
					var d = helpers$1.distanceBetweenPoints(eventPosition, center);
	
					if (d < minDistance) {
						minDistance = d;
						nearestElement = el;
					}
				}
			}
	
			if (nearestElement) {
				var tp = nearestElement.tooltipPosition();
				x = tp.x;
				y = tp.y;
			}
	
			return {
				x: x,
				y: y
			};
		}
	};
	
	// Helper to push or concat based on if the 2nd parameter is an array or not
	function pushOrConcat(base, toPush) {
		if (toPush) {
			if (helpers$1.isArray(toPush)) {
				// base = base.concat(toPush);
				Array.prototype.push.apply(base, toPush);
			} else {
				base.push(toPush);
			}
		}
	
		return base;
	}
	
	/**
	 * Returns array of strings split by newline
	 * @param {string} value - The value to split by newline.
	 * @returns {string[]} value if newline present - Returned from String split() method
	 * @function
	 */
	function splitNewlines(str) {
		if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
			return str.split('\n');
		}
		return str;
	}
	
	
	/**
	 * Private helper to create a tooltip item model
	 * @param element - the chart element (point, arc, bar) to create the tooltip item for
	 * @return new tooltip item
	 */
	function createTooltipItem(element) {
		var xScale = element._xScale;
		var yScale = element._yScale || element._scale; // handle radar || polarArea charts
		var index = element._index;
		var datasetIndex = element._datasetIndex;
		var controller = element._chart.getDatasetMeta(datasetIndex).controller;
		var indexScale = controller._getIndexScale();
		var valueScale = controller._getValueScale();
	
		return {
			xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
			yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
			label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
			value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
			index: index,
			datasetIndex: datasetIndex,
			x: element._model.x,
			y: element._model.y
		};
	}
	
	/**
	 * Helper to get the reset model for the tooltip
	 * @param tooltipOpts {object} the tooltip options
	 */
	function getBaseModel(tooltipOpts) {
		var globalDefaults = core_defaults.global;
	
		return {
			// Positioning
			xPadding: tooltipOpts.xPadding,
			yPadding: tooltipOpts.yPadding,
			xAlign: tooltipOpts.xAlign,
			yAlign: tooltipOpts.yAlign,
	
			// Drawing direction and text direction
			rtl: tooltipOpts.rtl,
			textDirection: tooltipOpts.textDirection,
	
			// Body
			bodyFontColor: tooltipOpts.bodyFontColor,
			_bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
			_bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
			_bodyAlign: tooltipOpts.bodyAlign,
			bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
			bodySpacing: tooltipOpts.bodySpacing,
	
			// Title
			titleFontColor: tooltipOpts.titleFontColor,
			_titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
			_titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
			titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
			_titleAlign: tooltipOpts.titleAlign,
			titleSpacing: tooltipOpts.titleSpacing,
			titleMarginBottom: tooltipOpts.titleMarginBottom,
	
			// Footer
			footerFontColor: tooltipOpts.footerFontColor,
			_footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
			_footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
			footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
			_footerAlign: tooltipOpts.footerAlign,
			footerSpacing: tooltipOpts.footerSpacing,
			footerMarginTop: tooltipOpts.footerMarginTop,
	
			// Appearance
			caretSize: tooltipOpts.caretSize,
			cornerRadius: tooltipOpts.cornerRadius,
			backgroundColor: tooltipOpts.backgroundColor,
			opacity: 0,
			legendColorBackground: tooltipOpts.multiKeyBackground,
			displayColors: tooltipOpts.displayColors,
			borderColor: tooltipOpts.borderColor,
			borderWidth: tooltipOpts.borderWidth
		};
	}
	
	/**
	 * Get the size of the tooltip
	 */
	function getTooltipSize(tooltip, model) {
		var ctx = tooltip._chart.ctx;
	
		var height = model.yPadding * 2; // Tooltip Padding
		var width = 0;
	
		// Count of all lines in the body
		var body = model.body;
		var combinedBodyLength = body.reduce(function(count, bodyItem) {
			return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
		}, 0);
		combinedBodyLength += model.beforeBody.length + model.afterBody.length;
	
		var titleLineCount = model.title.length;
		var footerLineCount = model.footer.length;
		var titleFontSize = model.titleFontSize;
		var bodyFontSize = model.bodyFontSize;
		var footerFontSize = model.footerFontSize;
	
		height += titleLineCount * titleFontSize; // Title Lines
		height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
		height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
		height += combinedBodyLength * bodyFontSize; // Body Lines
		height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
		height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
		height += footerLineCount * (footerFontSize); // Footer Lines
		height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
	
		// Title width
		var widthPadding = 0;
		var maxLineWidth = function(line) {
			width = Math.max(width, ctx.measureText(line).width + widthPadding);
		};
	
		ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
		helpers$1.each(model.title, maxLineWidth);
	
		// Body width
		ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
		helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
	
		// Body lines may include some extra width due to the color box
		widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
		helpers$1.each(body, function(bodyItem) {
			helpers$1.each(bodyItem.before, maxLineWidth);
			helpers$1.each(bodyItem.lines, maxLineWidth);
			helpers$1.each(bodyItem.after, maxLineWidth);
		});
	
		// Reset back to 0
		widthPadding = 0;
	
		// Footer width
		ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
		helpers$1.each(model.footer, maxLineWidth);
	
		// Add padding
		width += 2 * model.xPadding;
	
		return {
			width: width,
			height: height
		};
	}
	
	/**
	 * Helper to get the alignment of a tooltip given the size
	 */
	function determineAlignment(tooltip, size) {
		var model = tooltip._model;
		var chart = tooltip._chart;
		var chartArea = tooltip._chart.chartArea;
		var xAlign = 'center';
		var yAlign = 'center';
	
		if (model.y < size.height) {
			yAlign = 'top';
		} else if (model.y > (chart.height - size.height)) {
			yAlign = 'bottom';
		}
	
		var lf, rf; // functions to determine left, right alignment
		var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
		var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
		var midX = (chartArea.left + chartArea.right) / 2;
		var midY = (chartArea.top + chartArea.bottom) / 2;
	
		if (yAlign === 'center') {
			lf = function(x) {
				return x <= midX;
			};
			rf = function(x) {
				return x > midX;
			};
		} else {
			lf = function(x) {
				return x <= (size.width / 2);
			};
			rf = function(x) {
				return x >= (chart.width - (size.width / 2));
			};
		}
	
		olf = function(x) {
			return x + size.width + model.caretSize + model.caretPadding > chart.width;
		};
		orf = function(x) {
			return x - size.width - model.caretSize - model.caretPadding < 0;
		};
		yf = function(y) {
			return y <= midY ? 'top' : 'bottom';
		};
	
		if (lf(model.x)) {
			xAlign = 'left';
	
			// Is tooltip too wide and goes over the right side of the chart.?
			if (olf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		} else if (rf(model.x)) {
			xAlign = 'right';
	
			// Is tooltip too wide and goes outside left edge of canvas?
			if (orf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		}
	
		var opts = tooltip._options;
		return {
			xAlign: opts.xAlign ? opts.xAlign : xAlign,
			yAlign: opts.yAlign ? opts.yAlign : yAlign
		};
	}
	
	/**
	 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
	 */
	function getBackgroundPoint(vm, size, alignment, chart) {
		// Background Position
		var x = vm.x;
		var y = vm.y;
	
		var caretSize = vm.caretSize;
		var caretPadding = vm.caretPadding;
		var cornerRadius = vm.cornerRadius;
		var xAlign = alignment.xAlign;
		var yAlign = alignment.yAlign;
		var paddingAndSize = caretSize + caretPadding;
		var radiusAndPadding = cornerRadius + caretPadding;
	
		if (xAlign === 'right') {
			x -= size.width;
		} else if (xAlign === 'center') {
			x -= (size.width / 2);
			if (x + size.width > chart.width) {
				x = chart.width - size.width;
			}
			if (x < 0) {
				x = 0;
			}
		}
	
		if (yAlign === 'top') {
			y += paddingAndSize;
		} else if (yAlign === 'bottom') {
			y -= size.height + paddingAndSize;
		} else {
			y -= (size.height / 2);
		}
	
		if (yAlign === 'center') {
			if (xAlign === 'left') {
				x += paddingAndSize;
			} else if (xAlign === 'right') {
				x -= paddingAndSize;
			}
		} else if (xAlign === 'left') {
			x -= radiusAndPadding;
		} else if (xAlign === 'right') {
			x += radiusAndPadding;
		}
	
		return {
			x: x,
			y: y
		};
	}
	
	function getAlignedX(vm, align) {
		return align === 'center'
			? vm.x + vm.width / 2
			: align === 'right'
				? vm.x + vm.width - vm.xPadding
				: vm.x + vm.xPadding;
	}
	
	/**
	 * Helper to build before and after body lines
	 */
	function getBeforeAfterBodyLines(callback) {
		return pushOrConcat([], splitNewlines(callback));
	}
	
	var exports$4 = core_element.extend({
		initialize: function() {
			this._model = getBaseModel(this._options);
			this._lastActive = [];
		},
	
		// Get the title
		// Args are: (tooltipItem, data)
		getTitle: function() {
			var me = this;
			var opts = me._options;
			var callbacks = opts.callbacks;
	
			var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
			var title = callbacks.title.apply(me, arguments);
			var afterTitle = callbacks.afterTitle.apply(me, arguments);
	
			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeTitle));
			lines = pushOrConcat(lines, splitNewlines(title));
			lines = pushOrConcat(lines, splitNewlines(afterTitle));
	
			return lines;
		},
	
		// Args are: (tooltipItem, data)
		getBeforeBody: function() {
			return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
		},
	
		// Args are: (tooltipItem, data)
		getBody: function(tooltipItems, data) {
			var me = this;
			var callbacks = me._options.callbacks;
			var bodyItems = [];
	
			helpers$1.each(tooltipItems, function(tooltipItem) {
				var bodyItem = {
					before: [],
					lines: [],
					after: []
				};
				pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
				pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
	
				bodyItems.push(bodyItem);
			});
	
			return bodyItems;
		},
	
		// Args are: (tooltipItem, data)
		getAfterBody: function() {
			return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
		},
	
		// Get the footer and beforeFooter and afterFooter lines
		// Args are: (tooltipItem, data)
		getFooter: function() {
			var me = this;
			var callbacks = me._options.callbacks;
	
			var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
			var footer = callbacks.footer.apply(me, arguments);
			var afterFooter = callbacks.afterFooter.apply(me, arguments);
	
			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeFooter));
			lines = pushOrConcat(lines, splitNewlines(footer));
			lines = pushOrConcat(lines, splitNewlines(afterFooter));
	
			return lines;
		},
	
		update: function(changed) {
			var me = this;
			var opts = me._options;
	
			// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
			// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
			// which breaks any animations.
			var existingModel = me._model;
			var model = me._model = getBaseModel(opts);
			var active = me._active;
	
			var data = me._data;
	
			// In the case where active.length === 0 we need to keep these at existing values for good animations
			var alignment = {
				xAlign: existingModel.xAlign,
				yAlign: existingModel.yAlign
			};
			var backgroundPoint = {
				x: existingModel.x,
				y: existingModel.y
			};
			var tooltipSize = {
				width: existingModel.width,
				height: existingModel.height
			};
			var tooltipPosition = {
				x: existingModel.caretX,
				y: existingModel.caretY
			};
	
			var i, len;
	
			if (active.length) {
				model.opacity = 1;
	
				var labelColors = [];
				var labelTextColors = [];
				tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
	
				var tooltipItems = [];
				for (i = 0, len = active.length; i < len; ++i) {
					tooltipItems.push(createTooltipItem(active[i]));
				}
	
				// If the user provided a filter function, use it to modify the tooltip items
				if (opts.filter) {
					tooltipItems = tooltipItems.filter(function(a) {
						return opts.filter(a, data);
					});
				}
	
				// If the user provided a sorting function, use it to modify the tooltip items
				if (opts.itemSort) {
					tooltipItems = tooltipItems.sort(function(a, b) {
						return opts.itemSort(a, b, data);
					});
				}
	
				// Determine colors for boxes
				helpers$1.each(tooltipItems, function(tooltipItem) {
					labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
					labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
				});
	
	
				// Build the Text Lines
				model.title = me.getTitle(tooltipItems, data);
				model.beforeBody = me.getBeforeBody(tooltipItems, data);
				model.body = me.getBody(tooltipItems, data);
				model.afterBody = me.getAfterBody(tooltipItems, data);
				model.footer = me.getFooter(tooltipItems, data);
	
				// Initial positioning and colors
				model.x = tooltipPosition.x;
				model.y = tooltipPosition.y;
				model.caretPadding = opts.caretPadding;
				model.labelColors = labelColors;
				model.labelTextColors = labelTextColors;
	
				// data points
				model.dataPoints = tooltipItems;
	
				// We need to determine alignment of the tooltip
				tooltipSize = getTooltipSize(this, model);
				alignment = determineAlignment(this, tooltipSize);
				// Final Size and Position
				backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
			} else {
				model.opacity = 0;
			}
	
			model.xAlign = alignment.xAlign;
			model.yAlign = alignment.yAlign;
			model.x = backgroundPoint.x;
			model.y = backgroundPoint.y;
			model.width = tooltipSize.width;
			model.height = tooltipSize.height;
	
			// Point where the caret on the tooltip points to
			model.caretX = tooltipPosition.x;
			model.caretY = tooltipPosition.y;
	
			me._model = model;
	
			if (changed && opts.custom) {
				opts.custom.call(me, model);
			}
	
			return me;
		},
	
		drawCaret: function(tooltipPoint, size) {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
	
			ctx.lineTo(caretPosition.x1, caretPosition.y1);
			ctx.lineTo(caretPosition.x2, caretPosition.y2);
			ctx.lineTo(caretPosition.x3, caretPosition.y3);
		},
		getCaretPosition: function(tooltipPoint, size, vm) {
			var x1, x2, x3, y1, y2, y3;
			var caretSize = vm.caretSize;
			var cornerRadius = vm.cornerRadius;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var ptX = tooltipPoint.x;
			var ptY = tooltipPoint.y;
			var width = size.width;
			var height = size.height;
	
			if (yAlign === 'center') {
				y2 = ptY + (height / 2);
	
				if (xAlign === 'left') {
					x1 = ptX;
					x2 = x1 - caretSize;
					x3 = x1;
	
					y1 = y2 + caretSize;
					y3 = y2 - caretSize;
				} else {
					x1 = ptX + width;
					x2 = x1 + caretSize;
					x3 = x1;
	
					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				}
			} else {
				if (xAlign === 'left') {
					x2 = ptX + cornerRadius + (caretSize);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else if (xAlign === 'right') {
					x2 = ptX + width - cornerRadius - caretSize;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else {
					x2 = vm.caretX;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				}
				if (yAlign === 'top') {
					y1 = ptY;
					y2 = y1 - caretSize;
					y3 = y1;
				} else {
					y1 = ptY + height;
					y2 = y1 + caretSize;
					y3 = y1;
					// invert drawing order
					var tmp = x3;
					x3 = x1;
					x1 = tmp;
				}
			}
			return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
		},
	
		drawTitle: function(pt, vm, ctx) {
			var title = vm.title;
			var length = title.length;
			var titleFontSize, titleSpacing, i;
	
			if (length) {
				var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
				pt.x = getAlignedX(vm, vm._titleAlign);
	
				ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
				ctx.textBaseline = 'middle';
	
				titleFontSize = vm.titleFontSize;
				titleSpacing = vm.titleSpacing;
	
				ctx.fillStyle = vm.titleFontColor;
				ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
	
				for (i = 0; i < length; ++i) {
					ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
					pt.y += titleFontSize + titleSpacing; // Line Height and spacing
	
					if (i + 1 === length) {
						pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
					}
				}
			}
		},
	
		drawBody: function(pt, vm, ctx) {
			var bodyFontSize = vm.bodyFontSize;
			var bodySpacing = vm.bodySpacing;
			var bodyAlign = vm._bodyAlign;
			var body = vm.body;
			var drawColorBoxes = vm.displayColors;
			var xLinePadding = 0;
			var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
	
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
			var fillLineOfText = function(line) {
				ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
				pt.y += bodyFontSize + bodySpacing;
			};
	
			var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
			var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
	
			ctx.textAlign = bodyAlign;
			ctx.textBaseline = 'middle';
			ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
	
			pt.x = getAlignedX(vm, bodyAlignForCalculation);
	
			// Before body lines
			ctx.fillStyle = vm.bodyFontColor;
			helpers$1.each(vm.beforeBody, fillLineOfText);
	
			xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right'
				? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
				: 0;
	
			// Draw body lines now
			for (i = 0, ilen = body.length; i < ilen; ++i) {
				bodyItem = body[i];
				textColor = vm.labelTextColors[i];
				labelColors = vm.labelColors[i];
	
				ctx.fillStyle = textColor;
				helpers$1.each(bodyItem.before, fillLineOfText);
	
				lines = bodyItem.lines;
				for (j = 0, jlen = lines.length; j < jlen; ++j) {
					// Draw Legend-like boxes if needed
					if (drawColorBoxes) {
						var rtlColorX = rtlHelper.x(colorX);
	
						// Fill a white rect so that colours merge nicely if the opacity is < 1
						ctx.fillStyle = vm.legendColorBackground;
						ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
	
						// Border
						ctx.lineWidth = 1;
						ctx.strokeStyle = labelColors.borderColor;
						ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
	
						// Inner square
						ctx.fillStyle = labelColors.backgroundColor;
						ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
						ctx.fillStyle = textColor;
					}
	
					fillLineOfText(lines[j]);
				}
	
				helpers$1.each(bodyItem.after, fillLineOfText);
			}
	
			// Reset back to 0 for after body
			xLinePadding = 0;
	
			// After body lines
			helpers$1.each(vm.afterBody, fillLineOfText);
			pt.y -= bodySpacing; // Remove last body spacing
		},
	
		drawFooter: function(pt, vm, ctx) {
			var footer = vm.footer;
			var length = footer.length;
			var footerFontSize, i;
	
			if (length) {
				var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
				pt.x = getAlignedX(vm, vm._footerAlign);
				pt.y += vm.footerMarginTop;
	
				ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
				ctx.textBaseline = 'middle';
	
				footerFontSize = vm.footerFontSize;
	
				ctx.fillStyle = vm.footerFontColor;
				ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
	
				for (i = 0; i < length; ++i) {
					ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
					pt.y += footerFontSize + vm.footerSpacing;
				}
			}
		},
	
		drawBackground: function(pt, vm, ctx, tooltipSize) {
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = vm.borderWidth;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var x = pt.x;
			var y = pt.y;
			var width = tooltipSize.width;
			var height = tooltipSize.height;
			var radius = vm.cornerRadius;
	
			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			if (yAlign === 'top') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			if (yAlign === 'center' && xAlign === 'right') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			if (yAlign === 'bottom') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			if (yAlign === 'center' && xAlign === 'left') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();
	
			ctx.fill();
	
			if (vm.borderWidth > 0) {
				ctx.stroke();
			}
		},
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
	
			if (vm.opacity === 0) {
				return;
			}
	
			var tooltipSize = {
				width: vm.width,
				height: vm.height
			};
			var pt = {
				x: vm.x,
				y: vm.y
			};
	
			// IE11/Edge does not like very small opacities, so snap to 0
			var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
	
			// Truthy/falsey value for empty tooltip
			var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
	
			if (this._options.enabled && hasTooltipContent) {
				ctx.save();
				ctx.globalAlpha = opacity;
	
				// Draw Background
				this.drawBackground(pt, vm, ctx, tooltipSize);
	
				// Draw Title, Body, and Footer
				pt.y += vm.yPadding;
	
				helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
	
				// Titles
				this.drawTitle(pt, vm, ctx);
	
				// Body
				this.drawBody(pt, vm, ctx);
	
				// Footer
				this.drawFooter(pt, vm, ctx);
	
				helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
	
				ctx.restore();
			}
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @returns {boolean} true if the tooltip changed
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me._options;
			var changed = false;
	
			me._lastActive = me._lastActive || [];
	
			// Find Active Elements for tooltips
			if (e.type === 'mouseout') {
				me._active = [];
			} else {
				me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
				if (options.reverse) {
					me._active.reverse();
				}
			}
	
			// Remember Last Actives
			changed = !helpers$1.arrayEquals(me._active, me._lastActive);
	
			// Only handle target event on tooltip change
			if (changed) {
				me._lastActive = me._active;
	
				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};
	
					me.update(true);
					me.pivot();
				}
			}
	
			return changed;
		}
	});
	
	/**
	 * @namespace Chart.Tooltip.positioners
	 */
	var positioners_1 = positioners;
	
	var core_tooltip = exports$4;
	core_tooltip.positioners = positioners_1;
	
	var valueOrDefault$9 = helpers$1.valueOrDefault;
	
	core_defaults._set('global', {
		elements: {},
		events: [
			'mousemove',
			'mouseout',
			'click',
			'touchstart',
			'touchmove'
		],
		hover: {
			onHover: null,
			mode: 'nearest',
			intersect: true,
			animationDuration: 400
		},
		onClick: null,
		maintainAspectRatio: true,
		responsive: true,
		responsiveAnimationDuration: 0
	});
	
	/**
	 * Recursively merge the given config objects representing the `scales` option
	 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
	 * returns a deep copy of the result, thus doesn't alter inputs.
	 */
	function mergeScaleConfig(/* config objects ... */) {
		return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
			merger: function(key, target, source, options) {
				if (key === 'xAxes' || key === 'yAxes') {
					var slen = source[key].length;
					var i, type, scale;
	
					if (!target[key]) {
						target[key] = [];
					}
	
					for (i = 0; i < slen; ++i) {
						scale = source[key][i];
						type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');
	
						if (i >= target[key].length) {
							target[key].push({});
						}
	
						if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
							// new/untyped scale or type changed: let's apply the new defaults
							// then merge source scale to correctly overwrite the defaults.
							helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
						} else {
							// scales type are the same
							helpers$1.merge(target[key][i], scale);
						}
					}
				} else {
					helpers$1._merger(key, target, source, options);
				}
			}
		});
	}
	
	/**
	 * Recursively merge the given config objects as the root options by handling
	 * default scale options for the `scales` and `scale` properties, then returns
	 * a deep copy of the result, thus doesn't alter inputs.
	 */
	function mergeConfig(/* config objects ... */) {
		return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
			merger: function(key, target, source, options) {
				var tval = target[key] || Object.create(null);
				var sval = source[key];
	
				if (key === 'scales') {
					// scale config merging is complex. Add our own function here for that
					target[key] = mergeScaleConfig(tval, sval);
				} else if (key === 'scale') {
					// used in polar area & radar charts since there is only one scale
					target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
				} else {
					helpers$1._merger(key, target, source, options);
				}
			}
		});
	}
	
	function initConfig(config) {
		config = config || Object.create(null);
	
		// Do NOT use mergeConfig for the data object because this method merges arrays
		// and so would change references to labels and datasets, preventing data updates.
		var data = config.data = config.data || {};
		data.datasets = data.datasets || [];
		data.labels = data.labels || [];
	
		config.options = mergeConfig(
			core_defaults.global,
			core_defaults[config.type],
			config.options || {});
	
		return config;
	}
	
	function updateConfig(chart) {
		var newOptions = chart.options;
	
		helpers$1.each(chart.scales, function(scale) {
			core_layouts.removeBox(chart, scale);
		});
	
		newOptions = mergeConfig(
			core_defaults.global,
			core_defaults[chart.config.type],
			newOptions);
	
		chart.options = chart.config.options = newOptions;
		chart.ensureScalesHaveIDs();
		chart.buildOrUpdateScales();
	
		// Tooltip
		chart.tooltip._options = newOptions.tooltips;
		chart.tooltip.initialize();
	}
	
	function nextAvailableScaleId(axesOpts, prefix, index) {
		var id;
		var hasId = function(obj) {
			return obj.id === id;
		};
	
		do {
			id = prefix + index++;
		} while (helpers$1.findIndex(axesOpts, hasId) >= 0);
	
		return id;
	}
	
	function positionIsHorizontal(position) {
		return position === 'top' || position === 'bottom';
	}
	
	function compare2Level(l1, l2) {
		return function(a, b) {
			return a[l1] === b[l1]
				? a[l2] - b[l2]
				: a[l1] - b[l1];
		};
	}
	
	var Chart = function(item, config) {
		this.construct(item, config);
		return this;
	};
	
	helpers$1.extend(Chart.prototype, /** @lends Chart */ {
		/**
		 * @private
		 */
		construct: function(item, config) {
			var me = this;
	
			config = initConfig(config);
	
			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;
	
			me.id = helpers$1.uid();
			me.ctx = context;
			me.canvas = canvas;
			me.config = config;
			me.width = width;
			me.height = height;
			me.aspectRatio = height ? width / height : null;
			me.options = config.options;
			me._bufferedRender = false;
			me._layers = [];
	
			/**
			 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
			 * the "instance" still need to be defined since it might be called from plugins.
			 * @prop Chart#chart
			 * @deprecated since version 2.6.0
			 * @todo remove at version 3
			 * @private
			 */
			me.chart = me;
			me.controller = me; // chart.chart.controller #inception
	
			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;
	
			// Define alias to the config data: `chart.data === chart.config.data`
			Object.defineProperty(me, 'data', {
				get: function() {
					return me.config.data;
				},
				set: function(value) {
					me.config.data = value;
				}
			});
	
			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return;
			}
	
			me.initialize();
			me.update();
		},
	
		/**
		 * @private
		 */
		initialize: function() {
			var me = this;
	
			// Before init plugin notification
			core_plugins.notify(me, 'beforeInit');
	
			helpers$1.retinaScale(me, me.options.devicePixelRatio);
	
			me.bindEvents();
	
			if (me.options.responsive) {
				// Initial resize before chart draws (must be silent to preserve initial animations).
				me.resize(true);
			}
	
			me.initToolTip();
	
			// After init plugin notification
			core_plugins.notify(me, 'afterInit');
	
			return me;
		},
	
		clear: function() {
			helpers$1.canvas.clear(this);
			return this;
		},
	
		stop: function() {
			// Stops any current animation loop occurring
			core_animations.cancelAnimation(this);
			return this;
		},
	
		resize: function(silent) {
			var me = this;
			var options = me.options;
			var canvas = me.canvas;
			var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;
	
			// the canvas render width and height will be casted to integers so make sure that
			// the canvas display style uses the same integer values to avoid blurring effect.
	
			// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
			var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
			var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
	
			if (me.width === newWidth && me.height === newHeight) {
				return;
			}
	
			canvas.width = me.width = newWidth;
			canvas.height = me.height = newHeight;
			canvas.style.width = newWidth + 'px';
			canvas.style.height = newHeight + 'px';
	
			helpers$1.retinaScale(me, options.devicePixelRatio);
	
			if (!silent) {
				// Notify any plugins about the resize
				var newSize = {width: newWidth, height: newHeight};
				core_plugins.notify(me, 'resize', [newSize]);
	
				// Notify of resize
				if (options.onResize) {
					options.onResize(me, newSize);
				}
	
				me.stop();
				me.update({
					duration: options.responsiveAnimationDuration
				});
			}
		},
	
		ensureScalesHaveIDs: function() {
			var options = this.options;
			var scalesOptions = options.scales || {};
			var scaleOptions = options.scale;
	
			helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
				if (!xAxisOptions.id) {
					xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
				}
			});
	
			helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
				if (!yAxisOptions.id) {
					yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
				}
			});
	
			if (scaleOptions) {
				scaleOptions.id = scaleOptions.id || 'scale';
			}
		},
	
		/**
		 * Builds a map of scale ID to scale object for future lookup.
		 */
		buildOrUpdateScales: function() {
			var me = this;
			var options = me.options;
			var scales = me.scales || {};
			var items = [];
			var updated = Object.keys(scales).reduce(function(obj, id) {
				obj[id] = false;
				return obj;
			}, {});
	
			if (options.scales) {
				items = items.concat(
					(options.scales.xAxes || []).map(function(xAxisOptions) {
						return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
					}),
					(options.scales.yAxes || []).map(function(yAxisOptions) {
						return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
					})
				);
			}
	
			if (options.scale) {
				items.push({
					options: options.scale,
					dtype: 'radialLinear',
					isDefault: true,
					dposition: 'chartArea'
				});
			}
	
			helpers$1.each(items, function(item) {
				var scaleOptions = item.options;
				var id = scaleOptions.id;
				var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
	
				if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
					scaleOptions.position = item.dposition;
				}
	
				updated[id] = true;
				var scale = null;
				if (id in scales && scales[id].type === scaleType) {
					scale = scales[id];
					scale.options = scaleOptions;
					scale.ctx = me.ctx;
					scale.chart = me;
				} else {
					var scaleClass = core_scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
					scale = new scaleClass({
						id: id,
						type: scaleType,
						options: scaleOptions,
						ctx: me.ctx,
						chart: me
					});
					scales[scale.id] = scale;
				}
	
				scale.mergeTicksOptions();
	
				// TODO(SB): I think we should be able to remove this custom case (options.scale)
				// and consider it as a regular scale part of the "scales"" map only! This would
				// make the logic easier and remove some useless? custom code.
				if (item.isDefault) {
					me.scale = scale;
				}
			});
			// clear up discarded scales
			helpers$1.each(updated, function(hasUpdated, id) {
				if (!hasUpdated) {
					delete scales[id];
				}
			});
	
			me.scales = scales;
	
			core_scaleService.addScalesToLayout(this);
		},
	
		buildOrUpdateControllers: function() {
			var me = this;
			var newControllers = [];
			var datasets = me.data.datasets;
			var i, ilen;
	
			for (i = 0, ilen = datasets.length; i < ilen; i++) {
				var dataset = datasets[i];
				var meta = me.getDatasetMeta(i);
				var type = dataset.type || me.config.type;
	
				if (meta.type && meta.type !== type) {
					me.destroyDatasetMeta(i);
					meta = me.getDatasetMeta(i);
				}
				meta.type = type;
				meta.order = dataset.order || 0;
				meta.index = i;
	
				if (meta.controller) {
					meta.controller.updateIndex(i);
					meta.controller.linkScales();
				} else {
					var ControllerClass = controllers[meta.type];
					if (ControllerClass === undefined) {
						throw new Error('"' + meta.type + '" is not a chart type.');
					}
	
					meta.controller = new ControllerClass(me, i);
					newControllers.push(meta.controller);
				}
			}
	
			return newControllers;
		},
	
		/**
		 * Reset the elements of all datasets
		 * @private
		 */
		resetElements: function() {
			var me = this;
			helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.reset();
			}, me);
		},
	
		/**
		* Resets the chart back to it's state before the initial animation
		*/
		reset: function() {
			this.resetElements();
			this.tooltip.initialize();
		},
	
		update: function(config) {
			var me = this;
			var i, ilen;
	
			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}
	
			updateConfig(me);
	
			// plugins options references might have change, let's invalidate the cache
			// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
			core_plugins._invalidate(me);
	
			if (core_plugins.notify(me, 'beforeUpdate') === false) {
				return;
			}
	
			// In case the entire data object changed
			me.tooltip._data = me.data;
	
			// Make sure dataset controllers are updated and new controllers are reset
			var newControllers = me.buildOrUpdateControllers();
	
			// Make sure all dataset controllers have correct meta data counts
			for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
				me.getDatasetMeta(i).controller.buildOrUpdateElements();
			}
	
			me.updateLayout();
	
			// Can only reset the new controllers after the scales have been updated
			if (me.options.animation && me.options.animation.duration) {
				helpers$1.each(newControllers, function(controller) {
					controller.reset();
				});
			}
	
			me.updateDatasets();
	
			// Need to reset tooltip in case it is displayed with elements that are removed
			// after update.
			me.tooltip.initialize();
	
			// Last active contains items that were previously in the tooltip.
			// When we reset the tooltip, we need to clear it
			me.lastActive = [];
	
			// Do this before render so that any plugins that need final scale updates can use it
			core_plugins.notify(me, 'afterUpdate');
	
			me._layers.sort(compare2Level('z', '_idx'));
	
			if (me._bufferedRender) {
				me._bufferedRequest = {
					duration: config.duration,
					easing: config.easing,
					lazy: config.lazy
				};
			} else {
				me.render(config);
			}
		},
	
		/**
		 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
		 * hook, in which case, plugins will not be called on `afterLayout`.
		 * @private
		 */
		updateLayout: function() {
			var me = this;
	
			if (core_plugins.notify(me, 'beforeLayout') === false) {
				return;
			}
	
			core_layouts.update(this, this.width, this.height);
	
			me._layers = [];
			helpers$1.each(me.boxes, function(box) {
				// _configure is called twice, once in core.scale.update and once here.
				// Here the boxes are fully updated and at their final positions.
				if (box._configure) {
					box._configure();
				}
				me._layers.push.apply(me._layers, box._layers());
			}, me);
	
			me._layers.forEach(function(item, index) {
				item._idx = index;
			});
	
			/**
			 * Provided for backward compatibility, use `afterLayout` instead.
			 * @method IPlugin#afterScaleUpdate
			 * @deprecated since version 2.5.0
			 * @todo remove at version 3
			 * @private
			 */
			core_plugins.notify(me, 'afterScaleUpdate');
			core_plugins.notify(me, 'afterLayout');
		},
	
		/**
		 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
		 * @private
		 */
		updateDatasets: function() {
			var me = this;
	
			if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
				return;
			}
	
			for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.updateDataset(i);
			}
	
			core_plugins.notify(me, 'afterDatasetsUpdate');
		},
	
		/**
		 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
		 * @private
		 */
		updateDataset: function(index) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index
			};
	
			if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
				return;
			}
	
			meta.controller._update();
	
			core_plugins.notify(me, 'afterDatasetUpdate', [args]);
		},
	
		render: function(config) {
			var me = this;
	
			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}
	
			var animationOptions = me.options.animation;
			var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
			var lazy = config.lazy;
	
			if (core_plugins.notify(me, 'beforeRender') === false) {
				return;
			}
	
			var onComplete = function(animation) {
				core_plugins.notify(me, 'afterRender');
				helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
			};
	
			if (animationOptions && duration) {
				var animation = new core_animation({
					numSteps: duration / 16.66, // 60 fps
					easing: config.easing || animationOptions.easing,
	
					render: function(chart, animationObject) {
						var easingFunction = helpers$1.easing.effects[animationObject.easing];
						var currentStep = animationObject.currentStep;
						var stepDecimal = currentStep / animationObject.numSteps;
	
						chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
					},
	
					onAnimationProgress: animationOptions.onProgress,
					onAnimationComplete: onComplete
				});
	
				core_animations.addAnimation(me, animation, duration, lazy);
			} else {
				me.draw();
	
				// See https://github.com/chartjs/Chart.js/issues/3781
				onComplete(new core_animation({numSteps: 0, chart: me}));
			}
	
			return me;
		},
	
		draw: function(easingValue) {
			var me = this;
			var i, layers;
	
			me.clear();
	
			if (helpers$1.isNullOrUndef(easingValue)) {
				easingValue = 1;
			}
	
			me.transition(easingValue);
	
			if (me.width <= 0 || me.height <= 0) {
				return;
			}
	
			if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
				return;
			}
	
			// Because of plugin hooks (before/afterDatasetsDraw), datasets can't
			// currently be part of layers. Instead, we draw
			// layers <= 0 before(default, backward compat), and the rest after
			layers = me._layers;
			for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
				layers[i].draw(me.chartArea);
			}
	
			me.drawDatasets(easingValue);
	
			// Rest of layers
			for (; i < layers.length; ++i) {
				layers[i].draw(me.chartArea);
			}
	
			me._drawTooltip(easingValue);
	
			core_plugins.notify(me, 'afterDraw', [easingValue]);
		},
	
		/**
		 * @private
		 */
		transition: function(easingValue) {
			var me = this;
	
			for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
				if (me.isDatasetVisible(i)) {
					me.getDatasetMeta(i).controller.transition(easingValue);
				}
			}
	
			me.tooltip.transition(easingValue);
		},
	
		/**
		 * @private
		 */
		_getSortedDatasetMetas: function(filterVisible) {
			var me = this;
			var datasets = me.data.datasets || [];
			var result = [];
			var i, ilen;
	
			for (i = 0, ilen = datasets.length; i < ilen; ++i) {
				if (!filterVisible || me.isDatasetVisible(i)) {
					result.push(me.getDatasetMeta(i));
				}
			}
	
			result.sort(compare2Level('order', 'index'));
	
			return result;
		},
	
		/**
		 * @private
		 */
		_getSortedVisibleDatasetMetas: function() {
			return this._getSortedDatasetMetas(true);
		},
	
		/**
		 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
		 * @private
		 */
		drawDatasets: function(easingValue) {
			var me = this;
			var metasets, i;
	
			if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
				return;
			}
	
			metasets = me._getSortedVisibleDatasetMetas();
			for (i = metasets.length - 1; i >= 0; --i) {
				me.drawDataset(metasets[i], easingValue);
			}
	
			core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
		},
	
		/**
		 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
		 * @private
		 */
		drawDataset: function(meta, easingValue) {
			var me = this;
			var args = {
				meta: meta,
				index: meta.index,
				easingValue: easingValue
			};
	
			if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
				return;
			}
	
			meta.controller.draw(easingValue);
	
			core_plugins.notify(me, 'afterDatasetDraw', [args]);
		},
	
		/**
		 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
		 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
		 * @private
		 */
		_drawTooltip: function(easingValue) {
			var me = this;
			var tooltip = me.tooltip;
			var args = {
				tooltip: tooltip,
				easingValue: easingValue
			};
	
			if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
				return;
			}
	
			tooltip.draw();
	
			core_plugins.notify(me, 'afterTooltipDraw', [args]);
		},
	
		/**
		 * Get the single element that was clicked on
		 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
		 */
		getElementAtEvent: function(e) {
			return core_interaction.modes.single(this, e);
		},
	
		getElementsAtEvent: function(e) {
			return core_interaction.modes.label(this, e, {intersect: true});
		},
	
		getElementsAtXAxis: function(e) {
			return core_interaction.modes['x-axis'](this, e, {intersect: true});
		},
	
		getElementsAtEventForMode: function(e, mode, options) {
			var method = core_interaction.modes[mode];
			if (typeof method === 'function') {
				return method(this, e, options);
			}
	
			return [];
		},
	
		getDatasetAtEvent: function(e) {
			return core_interaction.modes.dataset(this, e, {intersect: true});
		},
	
		getDatasetMeta: function(datasetIndex) {
			var me = this;
			var dataset = me.data.datasets[datasetIndex];
			if (!dataset._meta) {
				dataset._meta = {};
			}
	
			var meta = dataset._meta[me.id];
			if (!meta) {
				meta = dataset._meta[me.id] = {
					type: null,
					data: [],
					dataset: null,
					controller: null,
					hidden: null,			// See isDatasetVisible() comment
					xAxisID: null,
					yAxisID: null,
					order: dataset.order || 0,
					index: datasetIndex
				};
			}
	
			return meta;
		},
	
		getVisibleDatasetCount: function() {
			var count = 0;
			for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
				if (this.isDatasetVisible(i)) {
					count++;
				}
			}
			return count;
		},
	
		isDatasetVisible: function(datasetIndex) {
			var meta = this.getDatasetMeta(datasetIndex);
	
			// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
			// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
			return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
		},
	
		generateLegend: function() {
			return this.options.legendCallback(this);
		},
	
		/**
		 * @private
		 */
		destroyDatasetMeta: function(datasetIndex) {
			var id = this.id;
			var dataset = this.data.datasets[datasetIndex];
			var meta = dataset._meta && dataset._meta[id];
	
			if (meta) {
				meta.controller.destroy();
				delete dataset._meta[id];
			}
		},
	
		destroy: function() {
			var me = this;
			var canvas = me.canvas;
			var i, ilen;
	
			me.stop();
	
			// dataset controllers need to cleanup associated data
			for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.destroyDatasetMeta(i);
			}
	
			if (canvas) {
				me.unbindEvents();
				helpers$1.canvas.clear(me);
				platform.releaseContext(me.ctx);
				me.canvas = null;
				me.ctx = null;
			}
	
			core_plugins.notify(me, 'destroy');
	
			delete Chart.instances[me.id];
		},
	
		toBase64Image: function() {
			return this.canvas.toDataURL.apply(this.canvas, arguments);
		},
	
		initToolTip: function() {
			var me = this;
			me.tooltip = new core_tooltip({
				_chart: me,
				_chartInstance: me, // deprecated, backward compatibility
				_data: me.data,
				_options: me.options.tooltips
			}, me);
		},
	
		/**
		 * @private
		 */
		bindEvents: function() {
			var me = this;
			var listeners = me._listeners = {};
			var listener = function() {
				me.eventHandler.apply(me, arguments);
			};
	
			helpers$1.each(me.options.events, function(type) {
				platform.addEventListener(me, type, listener);
				listeners[type] = listener;
			});
	
			// Elements used to detect size change should not be injected for non responsive charts.
			// See https://github.com/chartjs/Chart.js/issues/2210
			if (me.options.responsive) {
				listener = function() {
					me.resize();
				};
	
				platform.addEventListener(me, 'resize', listener);
				listeners.resize = listener;
			}
		},
	
		/**
		 * @private
		 */
		unbindEvents: function() {
			var me = this;
			var listeners = me._listeners;
			if (!listeners) {
				return;
			}
	
			delete me._listeners;
			helpers$1.each(listeners, function(listener, type) {
				platform.removeEventListener(me, type, listener);
			});
		},
	
		updateHoverStyle: function(elements, mode, enabled) {
			var prefix = enabled ? 'set' : 'remove';
			var element, i, ilen;
	
			for (i = 0, ilen = elements.length; i < ilen; ++i) {
				element = elements[i];
				if (element) {
					this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
				}
			}
	
			if (mode === 'dataset') {
				this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
			}
		},
	
		/**
		 * @private
		 */
		eventHandler: function(e) {
			var me = this;
			var tooltip = me.tooltip;
	
			if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
				return;
			}
	
			// Buffer any update calls so that renders do not occur
			me._bufferedRender = true;
			me._bufferedRequest = null;
	
			var changed = me.handleEvent(e);
			// for smooth tooltip animations issue #4989
			// the tooltip should be the source of change
			// Animation check workaround:
			// tooltip._start will be null when tooltip isn't animating
			if (tooltip) {
				changed = tooltip._start
					? tooltip.handleEvent(e)
					: changed | tooltip.handleEvent(e);
			}
	
			core_plugins.notify(me, 'afterEvent', [e]);
	
			var bufferedRequest = me._bufferedRequest;
			if (bufferedRequest) {
				// If we have an update that was triggered, we need to do a normal render
				me.render(bufferedRequest);
			} else if (changed && !me.animating) {
				// If entering, leaving, or changing elements, animate the change via pivot
				me.stop();
	
				// We only need to render at this point. Updating will cause scales to be
				// recomputed generating flicker & using more memory than necessary.
				me.render({
					duration: me.options.hover.animationDuration,
					lazy: true
				});
			}
	
			me._bufferedRender = false;
			me._bufferedRequest = null;
	
			return me;
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event the event to handle
		 * @return {boolean} true if the chart needs to re-render
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me.options || {};
			var hoverOptions = options.hover;
			var changed = false;
	
			me.lastActive = me.lastActive || [];
	
			// Find Active Elements for hover and tooltips
			if (e.type === 'mouseout') {
				me.active = [];
			} else {
				me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
			}
	
			// Invoke onHover hook
			// Need to call with native event here to not break backwards compatibility
			helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);
	
			if (e.type === 'mouseup' || e.type === 'click') {
				if (options.onClick) {
					// Use e.native here for backwards compatibility
					options.onClick.call(me, e.native, me.active);
				}
			}
	
			// Remove styling for last active (even if it may still be active)
			if (me.lastActive.length) {
				me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
			}
	
			// Built in hover styling
			if (me.active.length && hoverOptions.mode) {
				me.updateHoverStyle(me.active, hoverOptions.mode, true);
			}
	
			changed = !helpers$1.arrayEquals(me.active, me.lastActive);
	
			// Remember Last Actives
			me.lastActive = me.active;
	
			return changed;
		}
	});
	
	/**
	 * NOTE(SB) We actually don't use this container anymore but we need to keep it
	 * for backward compatibility. Though, it can still be useful for plugins that
	 * would need to work on multiple charts?!
	 */
	Chart.instances = {};
	
	var core_controller = Chart;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart instead.
	 * @class Chart.Controller
	 * @deprecated since version 2.6
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Controller = Chart;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart
	 * @deprecated since version 2.8
	 * @todo remove at version 3
	 * @private
	 */
	Chart.types = {};
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.helpers.configMerge
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.configMerge = mergeConfig;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.helpers.scaleMerge
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.scaleMerge = mergeScaleConfig;
	
	var core_helpers = function() {
	
		// -- Basic js utility methods
	
		helpers$1.where = function(collection, filterCallback) {
			if (helpers$1.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];
	
			helpers$1.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});
	
			return filtered;
		};
		helpers$1.findIndex = Array.prototype.findIndex ?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined ? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (helpers$1.isNullOrUndef(startIndex)) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (helpers$1.isNullOrUndef(startIndex)) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
	
		// -- Math methods
		helpers$1.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers$1.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers$1.almostWhole = function(x, epsilon) {
			var rounded = Math.round(x);
			return ((rounded - epsilon) <= x) && ((rounded + epsilon) >= x);
		};
		helpers$1.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers$1.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers$1.sign = Math.sign ?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers$1.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers$1.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
	
		/**
		 * Returns the number of decimal places
		 * i.e. the number of digits after the decimal point, of the value of this Number.
		 * @param {number} x - A number.
		 * @returns {number} The number of decimal places.
		 * @private
		 */
		helpers$1._decimalPlaces = function(x) {
			if (!helpers$1.isFinite(x)) {
				return;
			}
			var e = 1;
			var p = 0;
			while (Math.round(x * e) / e !== x) {
				e *= 10;
				p++;
			}
			return p;
		};
	
		// Gets the angle from vertical upright to the point about a centre.
		helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x;
			var distanceFromYCenter = anglePoint.y - centrePoint.y;
			var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}
	
			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers$1.distanceBetweenPoints = function(pt1, pt2) {
			return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
		};
	
		/**
		 * Provided for backward compatibility, not available anymore
		 * @function Chart.helpers.aliasPixel
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 */
		helpers$1.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
	
		/**
		 * Returns the aligned pixel value to avoid anti-aliasing blur
		 * @param {Chart} chart - The chart instance.
		 * @param {number} pixel - A pixel value.
		 * @param {number} width - The width of the element.
		 * @returns {number} The aligned pixel value.
		 * @private
		 */
		helpers$1._alignPixel = function(chart, pixel, width) {
			var devicePixelRatio = chart.currentDevicePixelRatio;
			var halfWidth = width / 2;
			return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
		};
	
		helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html
	
			// This function must also respect "skipped" points
	
			var previous = firstPoint.skip ? middlePoint : firstPoint;
			var current = middlePoint;
			var next = afterPoint.skip ? middlePoint : afterPoint;
	
			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
	
			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);
	
			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;
	
			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;
	
			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers$1.EPSILON = Number.EPSILON || 1e-14;
		helpers$1.splineCurveMonotone = function(points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
	
			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});
	
			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);
	
					// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
					pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
				}
	
				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}
	
			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}
	
				if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}
	
				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}
	
				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}
	
			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers$1.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers$1.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers$1.niceNum = function(range, round) {
			var exponent = Math.floor(helpers$1.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;
	
			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
	
			return niceFraction * Math.pow(10, exponent);
		};
		// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers$1.requestAnimFrame = (function() {
			if (typeof window === 'undefined') {
				return function(callback) {
					callback();
				};
			}
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers$1.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt;
			var canvas = evt.target || evt.srcElement;
			var boundingRect = canvas.getBoundingClientRect();
	
			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;
	
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}
	
			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
	
			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);
	
			return {
				x: mouseX,
				y: mouseY
			};
	
		};
	
		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof styleValue === 'string') {
				valueInPixels = parseInt(styleValue, 10);
	
				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}
	
			return valueInPixels;
		}
	
		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}
	
		/**
		 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
		 * @param {HTMLElement} domNode - the node to check the constraint on
		 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
		 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
		 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
		 */
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = helpers$1._getParentNode(domNode);
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;
	
			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}
	
			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers$1.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers$1.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		/**
		 * @private
	 	 */
		helpers$1._calculatePadding = function(container, padding, parentDimension) {
			padding = helpers$1.getStyle(container, padding);
	
			return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
		};
		/**
		 * @private
		 */
		helpers$1._getParentNode = function(domNode) {
			var parent = domNode.parentNode;
			if (parent && parent.toString() === '[object ShadowRoot]') {
				parent = parent.host;
			}
			return parent;
		};
		helpers$1.getMaximumWidth = function(domNode) {
			var container = helpers$1._getParentNode(domNode);
			if (!container) {
				return domNode.clientWidth;
			}
	
			var clientWidth = container.clientWidth;
			var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
			var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);
	
			var w = clientWidth - paddingLeft - paddingRight;
			var cw = helpers$1.getConstraintWidth(domNode);
			return isNaN(cw) ? w : Math.min(w, cw);
		};
		helpers$1.getMaximumHeight = function(domNode) {
			var container = helpers$1._getParentNode(domNode);
			if (!container) {
				return domNode.clientHeight;
			}
	
			var clientHeight = container.clientHeight;
			var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
			var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);
	
			var h = clientHeight - paddingTop - paddingBottom;
			var ch = helpers$1.getConstraintHeight(domNode);
			return isNaN(ch) ? h : Math.min(h, ch);
		};
		helpers$1.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers$1.retinaScale = function(chart, forceRatio) {
			var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
			if (pixelRatio === 1) {
				return;
			}
	
			var canvas = chart.canvas;
			var height = chart.height;
			var width = chart.width;
	
			canvas.height = height * pixelRatio;
			canvas.width = width * pixelRatio;
			chart.ctx.scale(pixelRatio, pixelRatio);
	
			// If no style has been set on the canvas, the render size is used as display size,
			// making the chart visually bigger, so let's enforce it to the "correct" values.
			// See https://github.com/chartjs/Chart.js/issues/3575
			if (!canvas.style.height && !canvas.style.width) {
				canvas.style.height = height + 'px';
				canvas.style.width = width + 'px';
			}
		};
		// -- Canvas methods
		helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];
	
			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}
	
			ctx.font = font;
			var longest = 0;
			var ilen = arrayOfThings.length;
			var i, j, jlen, thing, nestedThing;
			for (i = 0; i < ilen; i++) {
				thing = arrayOfThings[i];
	
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
					longest = helpers$1.measureText(ctx, data, gc, longest, thing);
				} else if (helpers$1.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					for (j = 0, jlen = thing.length; j < jlen; j++) {
						nestedThing = thing[j];
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
							longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
						}
					}
				}
			}
	
			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers$1.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
	
		/**
		 * @deprecated
		 */
		helpers$1.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers$1.each(arrayOfThings, function(thing) {
				if (helpers$1.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};
	
		helpers$1.color = !chartjsColor ?
			function(value) {
				console.error('Color.js not found!');
				return value;
			} :
			function(value) {
				/* global CanvasGradient */
				if (value instanceof CanvasGradient) {
					value = core_defaults.global.defaultColor;
				}
	
				return chartjsColor(value);
			};
	
		helpers$1.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
				colorValue :
				helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};
	
	function abstract() {
		throw new Error(
			'This method is not implemented: either no adapter can ' +
			'be found or an incomplete integration was provided.'
		);
	}
	
	/**
	 * Date adapter (current used by the time scale)
	 * @namespace Chart._adapters._date
	 * @memberof Chart._adapters
	 * @private
	 */
	
	/**
	 * Currently supported unit string values.
	 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
	 * @memberof Chart._adapters._date
	 * @name Unit
	 */
	
	/**
	 * @class
	 */
	function DateAdapter(options) {
		this.options = options || {};
	}
	
	helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
		/**
		 * Returns a map of time formats for the supported formatting units defined
		 * in Unit as well as 'datetime' representing a detailed date/time string.
		 * @returns {{string: string}}
		 */
		formats: abstract,
	
		/**
		 * Parses the given `value` and return the associated timestamp.
		 * @param {any} value - the value to parse (usually comes from the data)
		 * @param {string} [format] - the expected data format
		 * @returns {(number|null)}
		 * @function
		 */
		parse: abstract,
	
		/**
		 * Returns the formatted date in the specified `format` for a given `timestamp`.
		 * @param {number} timestamp - the timestamp to format
		 * @param {string} format - the date/time token
		 * @return {string}
		 * @function
		 */
		format: abstract,
	
		/**
		 * Adds the specified `amount` of `unit` to the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {number} amount - the amount to add
		 * @param {Unit} unit - the unit as string
		 * @return {number}
		 * @function
		 */
		add: abstract,
	
		/**
		 * Returns the number of `unit` between the given timestamps.
		 * @param {number} max - the input timestamp (reference)
		 * @param {number} min - the timestamp to substract
		 * @param {Unit} unit - the unit as string
		 * @return {number}
		 * @function
		 */
		diff: abstract,
	
		/**
		 * Returns start of `unit` for the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {Unit} unit - the unit as string
		 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
		 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
		 * @function
		 */
		startOf: abstract,
	
		/**
		 * Returns end of `unit` for the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {Unit} unit - the unit as string
		 * @function
		 */
		endOf: abstract,
	
		// DEPRECATIONS
	
		/**
		 * Provided for backward compatibility for scale.getValueForPixel(),
		 * this method should be overridden only by the moment adapter.
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 * @private
		 */
		_create: function(value) {
			return value;
		}
	});
	
	DateAdapter.override = function(members) {
		helpers$1.extend(DateAdapter.prototype, members);
	};
	
	var _date = DateAdapter;
	
	var core_adapters = {
		_date: _date
	};
	
	/**
	 * Namespace to hold static tick generation functions
	 * @namespace Chart.Ticks
	 */
	var core_ticks = {
		/**
		 * Namespace to hold formatters for different types of ticks
		 * @namespace Chart.Ticks.formatters
		 */
		formatters: {
			/**
			 * Formatter for value labels
			 * @method Chart.Ticks.formatters.values
			 * @param value the value to display
			 * @return {string|string[]} the label to display
			 */
			values: function(value) {
				return helpers$1.isArray(value) ? value : '' + value;
			},
	
			/**
			 * Formatter for linear numeric ticks
			 * @method Chart.Ticks.formatters.linear
			 * @param tickValue {number} the value to be formatted
			 * @param index {number} the position of the tickValue parameter in the ticks array
			 * @param ticks {number[]} the list of ticks being converted
			 * @return {string} string representation of the tickValue parameter
			 */
			linear: function(tickValue, index, ticks) {
				// If we have lots of ticks, don't use the ones
				var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
	
				// If we have a number like 2.5 as the delta, figure out how many decimal places we need
				if (Math.abs(delta) > 1) {
					if (tickValue !== Math.floor(tickValue)) {
						// not an integer
						delta = tickValue - Math.floor(tickValue);
					}
				}
	
				var logDelta = helpers$1.log10(Math.abs(delta));
				var tickString = '';
	
				if (tickValue !== 0) {
					var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
					if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
						var logTick = helpers$1.log10(Math.abs(tickValue));
						var numExponential = Math.floor(logTick) - Math.floor(logDelta);
						numExponential = Math.max(Math.min(numExponential, 20), 0);
						tickString = tickValue.toExponential(numExponential);
					} else {
						var numDecimal = -1 * Math.floor(logDelta);
						numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
						tickString = tickValue.toFixed(numDecimal);
					}
				} else {
					tickString = '0'; // never show decimal places for 0
				}
	
				return tickString;
			},
	
			logarithmic: function(tickValue, index, ticks) {
				var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));
	
				if (tickValue === 0) {
					return '0';
				} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
					return tickValue.toExponential();
				}
				return '';
			}
		}
	};
	
	var isArray = helpers$1.isArray;
	var isNullOrUndef = helpers$1.isNullOrUndef;
	var valueOrDefault$a = helpers$1.valueOrDefault;
	var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
	
	core_defaults._set('scale', {
		display: true,
		position: 'left',
		offset: false,
	
		// grid line settings
		gridLines: {
			display: true,
			color: 'rgba(0,0,0,0.1)',
			lineWidth: 1,
			drawBorder: true,
			drawOnChartArea: true,
			drawTicks: true,
			tickMarkLength: 10,
			zeroLineWidth: 1,
			zeroLineColor: 'rgba(0,0,0,0.25)',
			zeroLineBorderDash: [],
			zeroLineBorderDashOffset: 0.0,
			offsetGridLines: false,
			borderDash: [],
			borderDashOffset: 0.0
		},
	
		// scale label
		scaleLabel: {
			// display property
			display: false,
	
			// actual label
			labelString: '',
	
			// top/bottom padding
			padding: {
				top: 4,
				bottom: 4
			}
		},
	
		// label settings
		ticks: {
			beginAtZero: false,
			minRotation: 0,
			maxRotation: 50,
			mirror: false,
			padding: 0,
			reverse: false,
			display: true,
			autoSkip: true,
			autoSkipPadding: 0,
			labelOffset: 0,
			// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
			callback: core_ticks.formatters.values,
			minor: {},
			major: {}
		}
	});
	
	/** Returns a new array containing numItems from arr */
	function sample(arr, numItems) {
		var result = [];
		var increment = arr.length / numItems;
		var i = 0;
		var len = arr.length;
	
		for (; i < len; i += increment) {
			result.push(arr[Math.floor(i)]);
		}
		return result;
	}
	
	function getPixelForGridLine(scale, index, offsetGridLines) {
		var length = scale.getTicks().length;
		var validIndex = Math.min(index, length - 1);
		var lineValue = scale.getPixelForTick(validIndex);
		var start = scale._startPixel;
		var end = scale._endPixel;
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
		var offset;
	
		if (offsetGridLines) {
			if (length === 1) {
				offset = Math.max(lineValue - start, end - lineValue);
			} else if (index === 0) {
				offset = (scale.getPixelForTick(1) - lineValue) / 2;
			} else {
				offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
			}
			lineValue += validIndex < index ? offset : -offset;
	
			// Return undefined if the pixel is out of the range
			if (lineValue < start - epsilon || lineValue > end + epsilon) {
				return;
			}
		}
		return lineValue;
	}
	
	function garbageCollect(caches, length) {
		helpers$1.each(caches, function(cache) {
			var gc = cache.gc;
			var gcLen = gc.length / 2;
			var i;
			if (gcLen > length) {
				for (i = 0; i < gcLen; ++i) {
					delete cache.data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
		});
	}
	
	/**
	 * Returns {width, height, offset} objects for the first, last, widest, highest tick
	 * labels where offset indicates the anchor point offset from the top in pixels.
	 */
	function computeLabelSizes(ctx, tickFonts, ticks, caches) {
		var length = ticks.length;
		var widths = [];
		var heights = [];
		var offsets = [];
		var widestLabelSize = 0;
		var highestLabelSize = 0;
		var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
	
		for (i = 0; i < length; ++i) {
			label = ticks[i].label;
			tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
			ctx.font = fontString = tickFont.string;
			cache = caches[fontString] = caches[fontString] || {data: {}, gc: []};
			lineHeight = tickFont.lineHeight;
			width = height = 0;
			// Undefined labels and arrays should not be measured
			if (!isNullOrUndef(label) && !isArray(label)) {
				width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
				height = lineHeight;
			} else if (isArray(label)) {
				// if it is an array let's measure each element
				for (j = 0, jlen = label.length; j < jlen; ++j) {
					nestedLabel = label[j];
					// Undefined labels and arrays should not be measured
					if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
						width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
						height += lineHeight;
					}
				}
			}
			widths.push(width);
			heights.push(height);
			offsets.push(lineHeight / 2);
			widestLabelSize = Math.max(width, widestLabelSize);
			highestLabelSize = Math.max(height, highestLabelSize);
		}
		garbageCollect(caches, length);
	
		widest = widths.indexOf(widestLabelSize);
		highest = heights.indexOf(highestLabelSize);
	
		function valueAt(idx) {
			return {
				width: widths[idx] || 0,
				height: heights[idx] || 0,
				offset: offsets[idx] || 0
			};
		}
	
		return {
			first: valueAt(0),
			last: valueAt(length - 1),
			widest: valueAt(widest),
			highest: valueAt(highest)
		};
	}
	
	function getTickMarkLength(options) {
		return options.drawTicks ? options.tickMarkLength : 0;
	}
	
	function getScaleLabelHeight(options) {
		var font, padding;
	
		if (!options.display) {
			return 0;
		}
	
		font = helpers$1.options._parseFont(options);
		padding = helpers$1.options.toPadding(options.padding);
	
		return font.lineHeight + padding.height;
	}
	
	function parseFontOptions(options, nestedOpts) {
		return helpers$1.extend(helpers$1.options._parseFont({
			fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
			fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
			fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
			lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
		}), {
			color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
		});
	}
	
	function parseTickFontOptions(options) {
		var minor = parseFontOptions(options, options.minor);
		var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
	
		return {minor: minor, major: major};
	}
	
	function nonSkipped(ticksToFilter) {
		var filtered = [];
		var item, index, len;
		for (index = 0, len = ticksToFilter.length; index < len; ++index) {
			item = ticksToFilter[index];
			if (typeof item._index !== 'undefined') {
				filtered.push(item);
			}
		}
		return filtered;
	}
	
	function getEvenSpacing(arr) {
		var len = arr.length;
		var i, diff;
	
		if (len < 2) {
			return false;
		}
	
		for (diff = arr[0], i = 1; i < len; ++i) {
			if (arr[i] - arr[i - 1] !== diff) {
				return false;
			}
		}
		return diff;
	}
	
	function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
		var evenMajorSpacing = getEvenSpacing(majorIndices);
		var spacing = (ticks.length - 1) / ticksLimit;
		var factors, factor, i, ilen;
	
		// If the major ticks are evenly spaced apart, place the minor ticks
		// so that they divide the major ticks into even chunks
		if (!evenMajorSpacing) {
			return Math.max(spacing, 1);
		}
	
		factors = helpers$1.math._factorize(evenMajorSpacing);
		for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
			factor = factors[i];
			if (factor > spacing) {
				return factor;
			}
		}
		return Math.max(spacing, 1);
	}
	
	function getMajorIndices(ticks) {
		var result = [];
		var i, ilen;
		for (i = 0, ilen = ticks.length; i < ilen; i++) {
			if (ticks[i].major) {
				result.push(i);
			}
		}
		return result;
	}
	
	function skipMajors(ticks, majorIndices, spacing) {
		var count = 0;
		var next = majorIndices[0];
		var i, tick;
	
		spacing = Math.ceil(spacing);
		for (i = 0; i < ticks.length; i++) {
			tick = ticks[i];
			if (i === next) {
				tick._index = i;
				count++;
				next = majorIndices[count * spacing];
			} else {
				delete tick.label;
			}
		}
	}
	
	function skip(ticks, spacing, majorStart, majorEnd) {
		var start = valueOrDefault$a(majorStart, 0);
		var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
		var count = 0;
		var length, i, tick, next;
	
		spacing = Math.ceil(spacing);
		if (majorEnd) {
			length = majorEnd - majorStart;
			spacing = length / Math.floor(length / spacing);
		}
	
		next = start;
	
		while (next < 0) {
			count++;
			next = Math.round(start + count * spacing);
		}
	
		for (i = Math.max(start, 0); i < end; i++) {
			tick = ticks[i];
			if (i === next) {
				tick._index = i;
				count++;
				next = Math.round(start + count * spacing);
			} else {
				delete tick.label;
			}
		}
	}
	
	var Scale = core_element.extend({
	
		zeroLineIndex: 0,
	
		/**
		 * Get the padding needed for the scale
		 * @method getPadding
		 * @private
		 * @returns {Padding} the necessary padding
		 */
		getPadding: function() {
			var me = this;
			return {
				left: me.paddingLeft || 0,
				top: me.paddingTop || 0,
				right: me.paddingRight || 0,
				bottom: me.paddingBottom || 0
			};
		},
	
		/**
		 * Returns the scale tick objects ({label, major})
		 * @since 2.7
		 */
		getTicks: function() {
			return this._ticks;
		},
	
		/**
		* @private
		*/
		_getLabels: function() {
			var data = this.chart.data;
			return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
		},
	
		// These methods are ordered by lifecyle. Utilities then follow.
		// Any function defined here is inherited by all scale types.
		// Any function can be extended by the scale type
	
		/**
		 * Provided for backward compatibility, not available anymore
		 * @function Chart.Scale.mergeTicksOptions
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 */
		mergeTicksOptions: function() {
			// noop
		},
	
		beforeUpdate: function() {
			helpers$1.callback(this.options.beforeUpdate, [this]);
		},
	
		/**
		 * @param {number} maxWidth - the max width in pixels
		 * @param {number} maxHeight - the max height in pixels
		 * @param {object} margins - the space between the edge of the other scales and edge of the chart
		 *   This space comes from two sources:
		 *     - padding - space that's required to show the labels at the edges of the scale
		 *     - thickness of scales or legends in another orientation
		 */
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
			var tickOpts = me.options.ticks;
			var sampleSize = tickOpts.sampleSize;
			var i, ilen, labels, ticks, samplingEnabled;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = helpers$1.extend({
				left: 0,
				right: 0,
				top: 0,
				bottom: 0
			}, margins);
	
			me._ticks = null;
			me.ticks = null;
			me._labelSizes = null;
			me._maxLabelLines = 0;
			me.longestLabelWidth = 0;
			me.longestTextCache = me.longestTextCache || {};
			me._gridLineItems = null;
			me._labelItems = null;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
	
			// Data min/max
			me.beforeDataLimits();
			me.determineDataLimits();
			me.afterDataLimits();
	
			// Ticks - `this.ticks` is now DEPRECATED!
			// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
			// and must not be accessed directly from outside this class. `this.ticks` being
			// around for long time and not marked as private, we can't change its structure
			// without unexpected breaking changes. If you need to access the scale ticks,
			// use scale.getTicks() instead.
	
			me.beforeBuildTicks();
	
			// New implementations should return an array of objects but for BACKWARD COMPAT,
			// we still support no return (`this.ticks` internally set by calling this method).
			ticks = me.buildTicks() || [];
	
			// Allow modification of ticks in callback.
			ticks = me.afterBuildTicks(ticks) || ticks;
	
			// Ensure ticks contains ticks in new tick format
			if ((!ticks || !ticks.length) && me.ticks) {
				ticks = [];
				for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
					ticks.push({
						value: me.ticks[i],
						major: false
					});
				}
			}
	
			me._ticks = ticks;
	
			// Compute tick rotation and fit using a sampled subset of labels
			// We generally don't need to compute the size of every single label for determining scale size
			samplingEnabled = sampleSize < ticks.length;
			labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
	
			// _configure is called twice, once here, once from core.controller.updateLayout.
			// Here we haven't been positioned yet, but dimensions are correct.
			// Variables set in _configure are needed for calculateTickRotation, and
			// it's ok that coordinates are not correct there, only dimensions matter.
			me._configure();
	
			// Tick Rotation
			me.beforeCalculateTickRotation();
			me.calculateTickRotation();
			me.afterCalculateTickRotation();
	
			me.beforeFit();
			me.fit();
			me.afterFit();
	
			// Auto-skip
			me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;
	
			if (samplingEnabled) {
				// Generate labels using all non-skipped ticks
				labels = me._convertTicksToLabels(me._ticksToDraw);
			}
	
			me.ticks = labels;   // BACKWARD COMPATIBILITY
	
			// IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!
	
			me.afterUpdate();
	
			// TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
			// make maxWidth and maxHeight private
			return me.minSize;
		},
	
		/**
		 * @private
		 */
		_configure: function() {
			var me = this;
			var reversePixels = me.options.ticks.reverse;
			var startPixel, endPixel;
	
			if (me.isHorizontal()) {
				startPixel = me.left;
				endPixel = me.right;
			} else {
				startPixel = me.top;
				endPixel = me.bottom;
				// by default vertical scales are from bottom to top, so pixels are reversed
				reversePixels = !reversePixels;
			}
			me._startPixel = startPixel;
			me._endPixel = endPixel;
			me._reversePixels = reversePixels;
			me._length = endPixel - startPixel;
		},
	
		afterUpdate: function() {
			helpers$1.callback(this.options.afterUpdate, [this]);
		},
	
		//
	
		beforeSetDimensions: function() {
			helpers$1.callback(this.options.beforeSetDimensions, [this]);
		},
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
		},
		afterSetDimensions: function() {
			helpers$1.callback(this.options.afterSetDimensions, [this]);
		},
	
		// Data limits
		beforeDataLimits: function() {
			helpers$1.callback(this.options.beforeDataLimits, [this]);
		},
		determineDataLimits: helpers$1.noop,
		afterDataLimits: function() {
			helpers$1.callback(this.options.afterDataLimits, [this]);
		},
	
		//
		beforeBuildTicks: function() {
			helpers$1.callback(this.options.beforeBuildTicks, [this]);
		},
		buildTicks: helpers$1.noop,
		afterBuildTicks: function(ticks) {
			var me = this;
			// ticks is empty for old axis implementations here
			if (isArray(ticks) && ticks.length) {
				return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
			}
			// Support old implementations (that modified `this.ticks` directly in buildTicks)
			me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
			return ticks;
		},
	
		beforeTickToLabelConversion: function() {
			helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
		},
		convertTicksToLabels: function() {
			var me = this;
			// Convert ticks to strings
			var tickOpts = me.options.ticks;
			me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
		},
		afterTickToLabelConversion: function() {
			helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
		},
	
		//
	
		beforeCalculateTickRotation: function() {
			helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
		},
		calculateTickRotation: function() {
			var me = this;
			var options = me.options;
			var tickOpts = options.ticks;
			var numTicks = me.getTicks().length;
			var minRotation = tickOpts.minRotation || 0;
			var maxRotation = tickOpts.maxRotation;
			var labelRotation = minRotation;
			var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
	
			if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
				me.labelRotation = minRotation;
				return;
			}
	
			labelSizes = me._getLabelSizes();
			maxLabelWidth = labelSizes.widest.width;
			maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
	
			// Estimate the width of each grid based on the canvas width, the maximum
			// label width and the number of tick intervals
			maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
			tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
	
			// Allow 3 pixels x2 padding either side for label readability
			if (maxLabelWidth + 6 > tickWidth) {
				tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
				maxHeight = me.maxHeight - getTickMarkLength(options.gridLines)
					- tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
				maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
				labelRotation = helpers$1.toDegrees(Math.min(
					Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)),
					Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)
				));
				labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
			}
	
			me.labelRotation = labelRotation;
		},
		afterCalculateTickRotation: function() {
			helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
		},
	
		//
	
		beforeFit: function() {
			helpers$1.callback(this.options.beforeFit, [this]);
		},
		fit: function() {
			var me = this;
			// Reset
			var minSize = me.minSize = {
				width: 0,
				height: 0
			};
	
			var chart = me.chart;
			var opts = me.options;
			var tickOpts = opts.ticks;
			var scaleLabelOpts = opts.scaleLabel;
			var gridLineOpts = opts.gridLines;
			var display = me._isVisible();
			var isBottom = opts.position === 'bottom';
			var isHorizontal = me.isHorizontal();
	
			// Width
			if (isHorizontal) {
				minSize.width = me.maxWidth;
			} else if (display) {
				minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
			}
	
			// height
			if (!isHorizontal) {
				minSize.height = me.maxHeight; // fill all the height
			} else if (display) {
				minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
			}
	
			// Don't bother fitting the ticks if we are not showing the labels
			if (tickOpts.display && display) {
				var tickFonts = parseTickFontOptions(tickOpts);
				var labelSizes = me._getLabelSizes();
				var firstLabelSize = labelSizes.first;
				var lastLabelSize = labelSizes.last;
				var widestLabelSize = labelSizes.widest;
				var highestLabelSize = labelSizes.highest;
				var lineSpace = tickFonts.minor.lineHeight * 0.4;
				var tickPadding = tickOpts.padding;
	
				if (isHorizontal) {
					// A horizontal axis is more constrained by the height.
					var isRotated = me.labelRotation !== 0;
					var angleRadians = helpers$1.toRadians(me.labelRotation);
					var cosRotation = Math.cos(angleRadians);
					var sinRotation = Math.sin(angleRadians);
	
					var labelHeight = sinRotation * widestLabelSize.width
						+ cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0))
						+ (isRotated ? 0 : lineSpace); // padding
	
					minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
	
					var offsetLeft = me.getPixelForTick(0) - me.left;
					var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
					var paddingLeft, paddingRight;
	
					// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
					// which means that the right padding is dominated by the font height
					if (isRotated) {
						paddingLeft = isBottom ?
							cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset :
							sinRotation * (firstLabelSize.height - firstLabelSize.offset);
						paddingRight = isBottom ?
							sinRotation * (lastLabelSize.height - lastLabelSize.offset) :
							cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
					} else {
						paddingLeft = firstLabelSize.width / 2;
						paddingRight = lastLabelSize.width / 2;
					}
	
					// Adjust padding taking into account changes in offsets
					// and add 3 px to move away from canvas edges
					me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
					me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
				} else {
					// A vertical axis is more constrained by the width. Labels are the
					// dominant factor here, so get that length first and account for padding
					var labelWidth = tickOpts.mirror ? 0 :
						// use lineSpace for consistency with horizontal axis
						// tickPadding is not implemented for horizontal
						widestLabelSize.width + tickPadding + lineSpace;
	
					minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
	
					me.paddingTop = firstLabelSize.height / 2;
					me.paddingBottom = lastLabelSize.height / 2;
				}
			}
	
			me.handleMargins();
	
			if (isHorizontal) {
				me.width = me._length = chart.width - me.margins.left - me.margins.right;
				me.height = minSize.height;
			} else {
				me.width = minSize.width;
				me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
			}
		},
	
		/**
		 * Handle margins and padding interactions
		 * @private
		 */
		handleMargins: function() {
			var me = this;
			if (me.margins) {
				me.margins.left = Math.max(me.paddingLeft, me.margins.left);
				me.margins.top = Math.max(me.paddingTop, me.margins.top);
				me.margins.right = Math.max(me.paddingRight, me.margins.right);
				me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
			}
		},
	
		afterFit: function() {
			helpers$1.callback(this.options.afterFit, [this]);
		},
	
		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},
		isFullWidth: function() {
			return this.options.fullWidth;
		},
	
		// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
		getRightValue: function(rawValue) {
			// Null and undefined values first
			if (isNullOrUndef(rawValue)) {
				return NaN;
			}
			// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
			if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
				return NaN;
			}
	
			// If it is in fact an object, dive in one more level
			if (rawValue) {
				if (this.isHorizontal()) {
					if (rawValue.x !== undefined) {
						return this.getRightValue(rawValue.x);
					}
				} else if (rawValue.y !== undefined) {
					return this.getRightValue(rawValue.y);
				}
			}
	
			// Value is good, return it
			return rawValue;
		},
	
		_convertTicksToLabels: function(ticks) {
			var me = this;
			var labels, i, ilen;
	
			me.ticks = ticks.map(function(tick) {
				return tick.value;
			});
	
			me.beforeTickToLabelConversion();
	
			// New implementations should return the formatted tick labels but for BACKWARD
			// COMPAT, we still support no return (`this.ticks` internally changed by calling
			// this method and supposed to contain only string values).
			labels = me.convertTicksToLabels(ticks) || me.ticks;
	
			me.afterTickToLabelConversion();
	
			// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				ticks[i].label = labels[i];
			}
	
			return labels;
		},
	
		/**
		 * @private
		 */
		_getLabelSizes: function() {
			var me = this;
			var labelSizes = me._labelSizes;
	
			if (!labelSizes) {
				me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
				me.longestLabelWidth = labelSizes.widest.width;
			}
	
			return labelSizes;
		},
	
		/**
		 * @private
		 */
		_parseValue: function(value) {
			var start, end, min, max;
	
			if (isArray(value)) {
				start = +this.getRightValue(value[0]);
				end = +this.getRightValue(value[1]);
				min = Math.min(start, end);
				max = Math.max(start, end);
			} else {
				value = +this.getRightValue(value);
				start = undefined;
				end = value;
				min = value;
				max = value;
			}
	
			return {
				min: min,
				max: max,
				start: start,
				end: end
			};
		},
	
		/**
		* @private
		*/
		_getScaleLabel: function(rawValue) {
			var v = this._parseValue(rawValue);
			if (v.start !== undefined) {
				return '[' + v.start + ', ' + v.end + ']';
			}
	
			return +this.getRightValue(rawValue);
		},
	
		/**
		 * Used to get the value to display in the tooltip for the data at the given index
		 * @param index
		 * @param datasetIndex
		 */
		getLabelForIndex: helpers$1.noop,
	
		/**
		 * Returns the location of the given data point. Value can either be an index or a numerical value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param value
		 * @param index
		 * @param datasetIndex
		 */
		getPixelForValue: helpers$1.noop,
	
		/**
		 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param pixel
		 */
		getValueForPixel: helpers$1.noop,
	
		/**
		 * Returns the location of the tick at the given index
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForTick: function(index) {
			var me = this;
			var offset = me.options.offset;
			var numTicks = me._ticks.length;
			var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
	
			return index < 0 || index > numTicks - 1
				? null
				: me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
		},
	
		/**
		 * Utility for getting the pixel location of a percentage of scale
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForDecimal: function(decimal) {
			var me = this;
	
			if (me._reversePixels) {
				decimal = 1 - decimal;
			}
	
			return me._startPixel + decimal * me._length;
		},
	
		getDecimalForPixel: function(pixel) {
			var decimal = (pixel - this._startPixel) / this._length;
			return this._reversePixels ? 1 - decimal : decimal;
		},
	
		/**
		 * Returns the pixel for the minimum chart value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getBasePixel: function() {
			return this.getPixelForValue(this.getBaseValue());
		},
	
		getBaseValue: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
	
			return me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0;
		},
	
		/**
		 * Returns a subset of ticks to be plotted to avoid overlapping labels.
		 * @private
		 */
		_autoSkip: function(ticks) {
			var me = this;
			var tickOpts = me.options.ticks;
			var axisLength = me._length;
			var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
			var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
			var numMajorIndices = majorIndices.length;
			var first = majorIndices[0];
			var last = majorIndices[numMajorIndices - 1];
			var i, ilen, spacing, avgMajorSpacing;
	
			// If there are too many major ticks to display them all
			if (numMajorIndices > ticksLimit) {
				skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
				return nonSkipped(ticks);
			}
	
			spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
	
			if (numMajorIndices > 0) {
				for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
					skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
				}
				avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
				skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
				skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
				return nonSkipped(ticks);
			}
			skip(ticks, spacing);
			return nonSkipped(ticks);
		},
	
		/**
		 * @private
		 */
		_tickSize: function() {
			var me = this;
			var optionTicks = me.options.ticks;
	
			// Calculate space needed by label in axis direction.
			var rot = helpers$1.toRadians(me.labelRotation);
			var cos = Math.abs(Math.cos(rot));
			var sin = Math.abs(Math.sin(rot));
	
			var labelSizes = me._getLabelSizes();
			var padding = optionTicks.autoSkipPadding || 0;
			var w = labelSizes ? labelSizes.widest.width + padding : 0;
			var h = labelSizes ? labelSizes.highest.height + padding : 0;
	
			// Calculate space needed for 1 tick in axis direction.
			return me.isHorizontal()
				? h * cos > w * sin ? w / cos : h / sin
				: h * sin < w * cos ? h / cos : w / sin;
		},
	
		/**
		 * @private
		 */
		_isVisible: function() {
			var me = this;
			var chart = me.chart;
			var display = me.options.display;
			var i, ilen, meta;
	
			if (display !== 'auto') {
				return !!display;
			}
	
			// When 'auto', the scale is visible if at least one associated dataset is visible.
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
						return true;
					}
				}
			}
	
			return false;
		},
	
		/**
		 * @private
		 */
		_computeGridLineItems: function(chartArea) {
			var me = this;
			var chart = me.chart;
			var options = me.options;
			var gridLines = options.gridLines;
			var position = options.position;
			var offsetGridLines = gridLines.offsetGridLines;
			var isHorizontal = me.isHorizontal();
			var ticks = me._ticksToDraw;
			var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
	
			var tl = getTickMarkLength(gridLines);
			var items = [];
			var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
			var axisHalfWidth = axisWidth / 2;
			var alignPixel = helpers$1._alignPixel;
			var alignBorderValue = function(pixel) {
				return alignPixel(chart, pixel, axisWidth);
			};
			var borderValue, i, tick, lineValue, alignedLineValue;
			var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
	
			if (position === 'top') {
				borderValue = alignBorderValue(me.bottom);
				ty1 = me.bottom - tl;
				ty2 = borderValue - axisHalfWidth;
				y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
				y2 = chartArea.bottom;
			} else if (position === 'bottom') {
				borderValue = alignBorderValue(me.top);
				y1 = chartArea.top;
				y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
				ty1 = borderValue + axisHalfWidth;
				ty2 = me.top + tl;
			} else if (position === 'left') {
				borderValue = alignBorderValue(me.right);
				tx1 = me.right - tl;
				tx2 = borderValue - axisHalfWidth;
				x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
				x2 = chartArea.right;
			} else {
				borderValue = alignBorderValue(me.left);
				x1 = chartArea.left;
				x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
				tx1 = borderValue + axisHalfWidth;
				tx2 = me.left + tl;
			}
	
			for (i = 0; i < ticksLength; ++i) {
				tick = ticks[i] || {};
	
				// autoskipper skipped this tick (#4635)
				if (isNullOrUndef(tick.label) && i < ticks.length) {
					continue;
				}
	
				if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
					// Draw the first index specially
					lineWidth = gridLines.zeroLineWidth;
					lineColor = gridLines.zeroLineColor;
					borderDash = gridLines.zeroLineBorderDash || [];
					borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
				} else {
					lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
					lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
					borderDash = gridLines.borderDash || [];
					borderDashOffset = gridLines.borderDashOffset || 0.0;
				}
	
				lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
	
				// Skip if the pixel is out of the range
				if (lineValue === undefined) {
					continue;
				}
	
				alignedLineValue = alignPixel(chart, lineValue, lineWidth);
	
				if (isHorizontal) {
					tx1 = tx2 = x1 = x2 = alignedLineValue;
				} else {
					ty1 = ty2 = y1 = y2 = alignedLineValue;
				}
	
				items.push({
					tx1: tx1,
					ty1: ty1,
					tx2: tx2,
					ty2: ty2,
					x1: x1,
					y1: y1,
					x2: x2,
					y2: y2,
					width: lineWidth,
					color: lineColor,
					borderDash: borderDash,
					borderDashOffset: borderDashOffset,
				});
			}
	
			items.ticksLength = ticksLength;
			items.borderValue = borderValue;
	
			return items;
		},
	
		/**
		 * @private
		 */
		_computeLabelItems: function() {
			var me = this;
			var options = me.options;
			var optionTicks = options.ticks;
			var position = options.position;
			var isMirrored = optionTicks.mirror;
			var isHorizontal = me.isHorizontal();
			var ticks = me._ticksToDraw;
			var fonts = parseTickFontOptions(optionTicks);
			var tickPadding = optionTicks.padding;
			var tl = getTickMarkLength(options.gridLines);
			var rotation = -helpers$1.toRadians(me.labelRotation);
			var items = [];
			var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
	
			if (position === 'top') {
				y = me.bottom - tl - tickPadding;
				textAlign = !rotation ? 'center' : 'left';
			} else if (position === 'bottom') {
				y = me.top + tl + tickPadding;
				textAlign = !rotation ? 'center' : 'right';
			} else if (position === 'left') {
				x = me.right - (isMirrored ? 0 : tl) - tickPadding;
				textAlign = isMirrored ? 'left' : 'right';
			} else {
				x = me.left + (isMirrored ? 0 : tl) + tickPadding;
				textAlign = isMirrored ? 'right' : 'left';
			}
	
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				tick = ticks[i];
				label = tick.label;
	
				// autoskipper skipped this tick (#4635)
				if (isNullOrUndef(label)) {
					continue;
				}
	
				pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
				font = tick.major ? fonts.major : fonts.minor;
				lineHeight = font.lineHeight;
				lineCount = isArray(label) ? label.length : 1;
	
				if (isHorizontal) {
					x = pixel;
					textOffset = position === 'top'
						? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight
						: (!rotation ? 0.5 : 0) * lineHeight;
				} else {
					y = pixel;
					textOffset = (1 - lineCount) * lineHeight / 2;
				}
	
				items.push({
					x: x,
					y: y,
					rotation: rotation,
					label: label,
					font: font,
					textOffset: textOffset,
					textAlign: textAlign
				});
			}
	
			return items;
		},
	
		/**
		 * @private
		 */
		_drawGrid: function(chartArea) {
			var me = this;
			var gridLines = me.options.gridLines;
	
			if (!gridLines.display) {
				return;
			}
	
			var ctx = me.ctx;
			var chart = me.chart;
			var alignPixel = helpers$1._alignPixel;
			var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
			var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
			var width, color, i, ilen, item;
	
			for (i = 0, ilen = items.length; i < ilen; ++i) {
				item = items[i];
				width = item.width;
				color = item.color;
	
				if (width && color) {
					ctx.save();
					ctx.lineWidth = width;
					ctx.strokeStyle = color;
					if (ctx.setLineDash) {
						ctx.setLineDash(item.borderDash);
						ctx.lineDashOffset = item.borderDashOffset;
					}
	
					ctx.beginPath();
	
					if (gridLines.drawTicks) {
						ctx.moveTo(item.tx1, item.ty1);
						ctx.lineTo(item.tx2, item.ty2);
					}
	
					if (gridLines.drawOnChartArea) {
						ctx.moveTo(item.x1, item.y1);
						ctx.lineTo(item.x2, item.y2);
					}
	
					ctx.stroke();
					ctx.restore();
				}
			}
	
			if (axisWidth) {
				// Draw the line at the edge of the axis
				var firstLineWidth = axisWidth;
				var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
				var borderValue = items.borderValue;
				var x1, x2, y1, y2;
	
				if (me.isHorizontal()) {
					x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
					x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
					y1 = y2 = borderValue;
				} else {
					y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
					y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
					x1 = x2 = borderValue;
				}
	
				ctx.lineWidth = axisWidth;
				ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
				ctx.beginPath();
				ctx.moveTo(x1, y1);
				ctx.lineTo(x2, y2);
				ctx.stroke();
			}
		},
	
		/**
		 * @private
		 */
		_drawLabels: function() {
			var me = this;
			var optionTicks = me.options.ticks;
	
			if (!optionTicks.display) {
				return;
			}
	
			var ctx = me.ctx;
			var items = me._labelItems || (me._labelItems = me._computeLabelItems());
			var i, j, ilen, jlen, item, tickFont, label, y;
	
			for (i = 0, ilen = items.length; i < ilen; ++i) {
				item = items[i];
				tickFont = item.font;
	
				// Make sure we draw text in the correct color and font
				ctx.save();
				ctx.translate(item.x, item.y);
				ctx.rotate(item.rotation);
				ctx.font = tickFont.string;
				ctx.fillStyle = tickFont.color;
				ctx.textBaseline = 'middle';
				ctx.textAlign = item.textAlign;
	
				label = item.label;
				y = item.textOffset;
				if (isArray(label)) {
					for (j = 0, jlen = label.length; j < jlen; ++j) {
						// We just make sure the multiline element is a string here..
						ctx.fillText('' + label[j], 0, y);
						y += tickFont.lineHeight;
					}
				} else {
					ctx.fillText(label, 0, y);
				}
				ctx.restore();
			}
		},
	
		/**
		 * @private
		 */
		_drawTitle: function() {
			var me = this;
			var ctx = me.ctx;
			var options = me.options;
			var scaleLabel = options.scaleLabel;
	
			if (!scaleLabel.display) {
				return;
			}
	
			var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
			var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
			var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
			var halfLineHeight = scaleLabelFont.lineHeight / 2;
			var position = options.position;
			var rotation = 0;
			var scaleLabelX, scaleLabelY;
	
			if (me.isHorizontal()) {
				scaleLabelX = me.left + me.width / 2; // midpoint of the width
				scaleLabelY = position === 'bottom'
					? me.bottom - halfLineHeight - scaleLabelPadding.bottom
					: me.top + halfLineHeight + scaleLabelPadding.top;
			} else {
				var isLeft = position === 'left';
				scaleLabelX = isLeft
					? me.left + halfLineHeight + scaleLabelPadding.top
					: me.right - halfLineHeight - scaleLabelPadding.top;
				scaleLabelY = me.top + me.height / 2;
				rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
			}
	
			ctx.save();
			ctx.translate(scaleLabelX, scaleLabelY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
			ctx.fillStyle = scaleLabelFontColor; // render in correct colour
			ctx.font = scaleLabelFont.string;
			ctx.fillText(scaleLabel.labelString, 0, 0);
			ctx.restore();
		},
	
		draw: function(chartArea) {
			var me = this;
	
			if (!me._isVisible()) {
				return;
			}
	
			me._drawGrid(chartArea);
			me._drawTitle();
			me._drawLabels();
		},
	
		/**
		 * @private
		 */
		_layers: function() {
			var me = this;
			var opts = me.options;
			var tz = opts.ticks && opts.ticks.z || 0;
			var gz = opts.gridLines && opts.gridLines.z || 0;
	
			if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
				// backward compatibility: draw has been overridden by custom scale
				return [{
					z: tz,
					draw: function() {
						me.draw.apply(me, arguments);
					}
				}];
			}
	
			return [{
				z: gz,
				draw: function() {
					me._drawGrid.apply(me, arguments);
					me._drawTitle.apply(me, arguments);
				}
			}, {
				z: tz,
				draw: function() {
					me._drawLabels.apply(me, arguments);
				}
			}];
		},
	
		/**
		 * @private
		 */
		_getMatchingVisibleMetas: function(type) {
			var me = this;
			var isHorizontal = me.isHorizontal();
			return me.chart._getSortedVisibleDatasetMetas()
				.filter(function(meta) {
					return (!type || meta.type === type)
						&& (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
				});
		}
	});
	
	Scale.prototype._draw = Scale.prototype.draw;
	
	var core_scale = Scale;
	
	var isNullOrUndef$1 = helpers$1.isNullOrUndef;
	
	var defaultConfig = {
		position: 'bottom'
	};
	
	var scale_category = core_scale.extend({
		determineDataLimits: function() {
			var me = this;
			var labels = me._getLabels();
			var ticksOpts = me.options.ticks;
			var min = ticksOpts.min;
			var max = ticksOpts.max;
			var minIndex = 0;
			var maxIndex = labels.length - 1;
			var findIndex;
	
			if (min !== undefined) {
				// user specified min value
				findIndex = labels.indexOf(min);
				if (findIndex >= 0) {
					minIndex = findIndex;
				}
			}
	
			if (max !== undefined) {
				// user specified max value
				findIndex = labels.indexOf(max);
				if (findIndex >= 0) {
					maxIndex = findIndex;
				}
			}
	
			me.minIndex = minIndex;
			me.maxIndex = maxIndex;
			me.min = labels[minIndex];
			me.max = labels[maxIndex];
		},
	
		buildTicks: function() {
			var me = this;
			var labels = me._getLabels();
			var minIndex = me.minIndex;
			var maxIndex = me.maxIndex;
	
			// If we are viewing some subset of labels, slice the original array
			me.ticks = (minIndex === 0 && maxIndex === labels.length - 1) ? labels : labels.slice(minIndex, maxIndex + 1);
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var chart = me.chart;
	
			if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
				return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
			}
	
			return me._getLabels()[index];
		},
	
		_configure: function() {
			var me = this;
			var offset = me.options.offset;
			var ticks = me.ticks;
	
			core_scale.prototype._configure.call(me);
	
			if (!me.isHorizontal()) {
				// For backward compatibility, vertical category scale reverse is inverted.
				me._reversePixels = !me._reversePixels;
			}
	
			if (!ticks) {
				return;
			}
	
			me._startValue = me.minIndex - (offset ? 0.5 : 0);
			me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
		},
	
		// Used to get data value locations.  Value can either be an index or a numerical value
		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var valueCategory, labels, idx;
	
			if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
				value = me.chart.data.datasets[datasetIndex].data[index];
			}
	
			// If value is a data object, then index is the index in the data array,
			// not the index of the scale. We need to change that.
			if (!isNullOrUndef$1(value)) {
				valueCategory = me.isHorizontal() ? value.x : value.y;
			}
			if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
				labels = me._getLabels();
				value = helpers$1.valueOrDefault(valueCategory, value);
				idx = labels.indexOf(value);
				index = idx !== -1 ? idx : index;
				if (isNaN(index)) {
					index = value;
				}
			}
			return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
		},
	
		getPixelForTick: function(index) {
			var ticks = this.ticks;
			return index < 0 || index > ticks.length - 1
				? null
				: this.getPixelForValue(ticks[index], index + this.minIndex);
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
			return Math.min(Math.max(value, 0), me.ticks.length - 1);
		},
	
		getBasePixel: function() {
			return this.bottom;
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults = defaultConfig;
	scale_category._defaults = _defaults;
	
	var noop = helpers$1.noop;
	var isNullOrUndef$2 = helpers$1.isNullOrUndef;
	
	/**
	 * Generate a set of linear ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {number[]} array of tick values
	 */
	function generateTicks(generationOptions, dataRange) {
		var ticks = [];
		// To get a "nice" value for the tick spacing, we will use the appropriately named
		// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
		// for details.
	
		var MIN_SPACING = 1e-14;
		var stepSize = generationOptions.stepSize;
		var unit = stepSize || 1;
		var maxNumSpaces = generationOptions.maxTicks - 1;
		var min = generationOptions.min;
		var max = generationOptions.max;
		var precision = generationOptions.precision;
		var rmin = dataRange.min;
		var rmax = dataRange.max;
		var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
		var factor, niceMin, niceMax, numSpaces;
	
		// Beyond MIN_SPACING floating point numbers being to lose precision
		// such that we can't do the math necessary to generate ticks
		if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
			return [rmin, rmax];
		}
	
		numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
		if (numSpaces > maxNumSpaces) {
			// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
			spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
		}
	
		if (stepSize || isNullOrUndef$2(precision)) {
			// If a precision is not specified, calculate factor based on spacing
			factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
		} else {
			// If the user specified a precision, round to that number of decimal places
			factor = Math.pow(10, precision);
			spacing = Math.ceil(spacing * factor) / factor;
		}
	
		niceMin = Math.floor(rmin / spacing) * spacing;
		niceMax = Math.ceil(rmax / spacing) * spacing;
	
		// If min, max and stepSize is set and they make an evenly spaced scale use it.
		if (stepSize) {
			// If very close to our whole number, use it.
			if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
				niceMin = min;
			}
			if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
				niceMax = max;
			}
		}
	
		numSpaces = (niceMax - niceMin) / spacing;
		// If very close to our rounded value, use it.
		if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
			numSpaces = Math.round(numSpaces);
		} else {
			numSpaces = Math.ceil(numSpaces);
		}
	
		niceMin = Math.round(niceMin * factor) / factor;
		niceMax = Math.round(niceMax * factor) / factor;
		ticks.push(isNullOrUndef$2(min) ? niceMin : min);
		for (var j = 1; j < numSpaces; ++j) {
			ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
		}
		ticks.push(isNullOrUndef$2(max) ? niceMax : max);
	
		return ticks;
	}
	
	var scale_linearbase = core_scale.extend({
		getRightValue: function(value) {
			if (typeof value === 'string') {
				return +value;
			}
			return core_scale.prototype.getRightValue.call(this, value);
		},
	
		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
			// do nothing since that would make the chart weird. If the user really wants a weird chart
			// axis, they can manually override it
			if (tickOpts.beginAtZero) {
				var minSign = helpers$1.sign(me.min);
				var maxSign = helpers$1.sign(me.max);
	
				if (minSign < 0 && maxSign < 0) {
					// move the top up to 0
					me.max = 0;
				} else if (minSign > 0 && maxSign > 0) {
					// move the bottom down to 0
					me.min = 0;
				}
			}
	
			var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
			var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
	
			if (tickOpts.min !== undefined) {
				me.min = tickOpts.min;
			} else if (tickOpts.suggestedMin !== undefined) {
				if (me.min === null) {
					me.min = tickOpts.suggestedMin;
				} else {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
			}
	
			if (tickOpts.max !== undefined) {
				me.max = tickOpts.max;
			} else if (tickOpts.suggestedMax !== undefined) {
				if (me.max === null) {
					me.max = tickOpts.suggestedMax;
				} else {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
			}
	
			if (setMin !== setMax) {
				// We set the min or the max but not both.
				// So ensure that our range is good
				// Inverted or 0 length range can happen when
				// ticks.min is set, and no datasets are visible
				if (me.min >= me.max) {
					if (setMin) {
						me.max = me.min + 1;
					} else {
						me.min = me.max - 1;
					}
				}
			}
	
			if (me.min === me.max) {
				me.max++;
	
				if (!tickOpts.beginAtZero) {
					me.min--;
				}
			}
		},
	
		getTickLimit: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var stepSize = tickOpts.stepSize;
			var maxTicksLimit = tickOpts.maxTicksLimit;
			var maxTicks;
	
			if (stepSize) {
				maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
			} else {
				maxTicks = me._computeTickLimit();
				maxTicksLimit = maxTicksLimit || 11;
			}
	
			if (maxTicksLimit) {
				maxTicks = Math.min(maxTicksLimit, maxTicks);
			}
	
			return maxTicks;
		},
	
		_computeTickLimit: function() {
			return Number.POSITIVE_INFINITY;
		},
	
		handleDirectionalChanges: noop,
	
		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph. Make sure we always have at least 2 ticks
			var maxTicks = me.getTickLimit();
			maxTicks = Math.max(2, maxTicks);
	
			var numericGeneratorOptions = {
				maxTicks: maxTicks,
				min: tickOpts.min,
				max: tickOpts.max,
				precision: tickOpts.precision,
				stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
			};
			var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
	
			me.handleDirectionalChanges();
	
			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers$1.max(ticks);
			me.min = helpers$1.min(ticks);
	
			if (tickOpts.reverse) {
				ticks.reverse();
	
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},
	
		convertTicksToLabels: function() {
			var me = this;
			me.ticksAsNumbers = me.ticks.slice();
			me.zeroLineIndex = me.ticks.indexOf(0);
	
			core_scale.prototype.convertTicksToLabels.call(me);
		},
	
		_configure: function() {
			var me = this;
			var ticks = me.getTicks();
			var start = me.min;
			var end = me.max;
			var offset;
	
			core_scale.prototype._configure.call(me);
	
			if (me.options.offset && ticks.length) {
				offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
				start -= offset;
				end += offset;
			}
			me._startValue = start;
			me._endValue = end;
			me._valueRange = end - start;
		}
	});
	
	var defaultConfig$1 = {
		position: 'left',
		ticks: {
			callback: core_ticks.formatters.linear
		}
	};
	
	var DEFAULT_MIN = 0;
	var DEFAULT_MAX = 1;
	
	function getOrCreateStack(stacks, stacked, meta) {
		var key = [
			meta.type,
			// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
			stacked === undefined && meta.stack === undefined ? meta.index : '',
			meta.stack
		].join('.');
	
		if (stacks[key] === undefined) {
			stacks[key] = {
				pos: [],
				neg: []
			};
		}
	
		return stacks[key];
	}
	
	function stackData(scale, stacks, meta, data) {
		var opts = scale.options;
		var stacked = opts.stacked;
		var stack = getOrCreateStack(stacks, stacked, meta);
		var pos = stack.pos;
		var neg = stack.neg;
		var ilen = data.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = scale._parseValue(data[i]);
			if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
				continue;
			}
	
			pos[i] = pos[i] || 0;
			neg[i] = neg[i] || 0;
	
			if (opts.relativePoints) {
				pos[i] = 100;
			} else if (value.min < 0 || value.max < 0) {
				neg[i] += value.min;
			} else {
				pos[i] += value.max;
			}
		}
	}
	
	function updateMinMax(scale, meta, data) {
		var ilen = data.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = scale._parseValue(data[i]);
			if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
				continue;
			}
	
			scale.min = Math.min(scale.min, value.min);
			scale.max = Math.max(scale.max, value.max);
		}
	}
	
	var scale_linear = scale_linearbase.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var metasets = me._getMatchingVisibleMetas();
			var hasStacks = opts.stacked;
			var stacks = {};
			var ilen = metasets.length;
			var i, meta, data, values;
	
			me.min = Number.POSITIVE_INFINITY;
			me.max = Number.NEGATIVE_INFINITY;
	
			if (hasStacks === undefined) {
				for (i = 0; !hasStacks && i < ilen; ++i) {
					meta = metasets[i];
					hasStacks = meta.stack !== undefined;
				}
			}
	
			for (i = 0; i < ilen; ++i) {
				meta = metasets[i];
				data = datasets[meta.index].data;
				if (hasStacks) {
					stackData(me, stacks, meta, data);
				} else {
					updateMinMax(me, meta, data);
				}
			}
	
			helpers$1.each(stacks, function(stackValues) {
				values = stackValues.pos.concat(stackValues.neg);
				me.min = Math.min(me.min, helpers$1.min(values));
				me.max = Math.max(me.max, helpers$1.max(values));
			});
	
			me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
			me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
	
			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
	
		// Returns the maximum number of ticks based on the scale dimension
		_computeTickLimit: function() {
			var me = this;
			var tickFont;
	
			if (me.isHorizontal()) {
				return Math.ceil(me.width / 40);
			}
			tickFont = helpers$1.options._parseFont(me.options.ticks);
			return Math.ceil(me.height / tickFont.lineHeight);
		},
	
		// Called after the ticks are built. We need
		handleDirectionalChanges: function() {
			if (!this.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				this.ticks.reverse();
			}
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		// Utils
		getPixelForValue: function(value) {
			var me = this;
			return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
		},
	
		getValueForPixel: function(pixel) {
			return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
		},
	
		getPixelForTick: function(index) {
			var ticks = this.ticksAsNumbers;
			if (index < 0 || index > ticks.length - 1) {
				return null;
			}
			return this.getPixelForValue(ticks[index]);
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$1 = defaultConfig$1;
	scale_linear._defaults = _defaults$1;
	
	var valueOrDefault$b = helpers$1.valueOrDefault;
	var log10 = helpers$1.math.log10;
	
	/**
	 * Generate a set of logarithmic ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {number[]} array of tick values
	 */
	function generateTicks$1(generationOptions, dataRange) {
		var ticks = [];
	
		var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
	
		var endExp = Math.floor(log10(dataRange.max));
		var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
		var exp, significand;
	
		if (tickVal === 0) {
			exp = Math.floor(log10(dataRange.minNotZero));
			significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
	
			ticks.push(tickVal);
			tickVal = significand * Math.pow(10, exp);
		} else {
			exp = Math.floor(log10(tickVal));
			significand = Math.floor(tickVal / Math.pow(10, exp));
		}
		var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
	
		do {
			ticks.push(tickVal);
	
			++significand;
			if (significand === 10) {
				significand = 1;
				++exp;
				precision = exp >= 0 ? 1 : precision;
			}
	
			tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
		} while (exp < endExp || (exp === endExp && significand < endSignificand));
	
		var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
		ticks.push(lastTick);
	
		return ticks;
	}
	
	var defaultConfig$2 = {
		position: 'left',
	
		// label settings
		ticks: {
			callback: core_ticks.formatters.logarithmic
		}
	};
	
	// TODO(v3): change this to positiveOrDefault
	function nonNegativeOrDefault(value, defaultValue) {
		return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
	}
	
	var scale_logarithmic = core_scale.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var isHorizontal = me.isHorizontal();
			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}
			var datasetIndex, meta, value, data, i, ilen;
	
			// Calculate Range
			me.min = Number.POSITIVE_INFINITY;
			me.max = Number.NEGATIVE_INFINITY;
			me.minNotZero = Number.POSITIVE_INFINITY;
	
			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
						break;
					}
				}
			}
	
			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};
	
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');
	
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = [];
						}
	
						data = datasets[datasetIndex].data;
						for (i = 0, ilen = data.length; i < ilen; i++) {
							var values = valuesPerStack[key];
							value = me._parseValue(data[i]);
							// invalid, hidden and negative values are ignored
							if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
								continue;
							}
							values[i] = values[i] || 0;
							values[i] += value.max;
						}
					}
				}
	
				helpers$1.each(valuesPerStack, function(valuesForType) {
					if (valuesForType.length > 0) {
						var minVal = helpers$1.min(valuesForType);
						var maxVal = helpers$1.max(valuesForType);
						me.min = Math.min(me.min, minVal);
						me.max = Math.max(me.max, maxVal);
					}
				});
	
			} else {
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						data = datasets[datasetIndex].data;
						for (i = 0, ilen = data.length; i < ilen; i++) {
							value = me._parseValue(data[i]);
							// invalid, hidden and negative values are ignored
							if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
								continue;
							}
	
							me.min = Math.min(value.min, me.min);
							me.max = Math.max(value.max, me.max);
	
							if (value.min !== 0) {
								me.minNotZero = Math.min(value.min, me.minNotZero);
							}
						}
					}
				}
			}
	
			me.min = helpers$1.isFinite(me.min) ? me.min : null;
			me.max = helpers$1.isFinite(me.max) ? me.max : null;
			me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
	
			// Common base implementation to handle ticks.min, ticks.max
			this.handleTickRangeOptions();
		},
	
		handleTickRangeOptions: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var DEFAULT_MIN = 1;
			var DEFAULT_MAX = 10;
	
			me.min = nonNegativeOrDefault(tickOpts.min, me.min);
			me.max = nonNegativeOrDefault(tickOpts.max, me.max);
	
			if (me.min === me.max) {
				if (me.min !== 0 && me.min !== null) {
					me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
					me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
				} else {
					me.min = DEFAULT_MIN;
					me.max = DEFAULT_MAX;
				}
			}
			if (me.min === null) {
				me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
			}
			if (me.max === null) {
				me.max = me.min !== 0
					? Math.pow(10, Math.floor(log10(me.min)) + 1)
					: DEFAULT_MAX;
			}
			if (me.minNotZero === null) {
				if (me.min > 0) {
					me.minNotZero = me.min;
				} else if (me.max < 1) {
					me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
				} else {
					me.minNotZero = DEFAULT_MIN;
				}
			}
		},
	
		buildTicks: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var reverse = !me.isHorizontal();
	
			var generationOptions = {
				min: nonNegativeOrDefault(tickOpts.min),
				max: nonNegativeOrDefault(tickOpts.max)
			};
			var ticks = me.ticks = generateTicks$1(generationOptions, me);
	
			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers$1.max(ticks);
			me.min = helpers$1.min(ticks);
	
			if (tickOpts.reverse) {
				reverse = !reverse;
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
			if (reverse) {
				ticks.reverse();
			}
		},
	
		convertTicksToLabels: function() {
			this.tickValues = this.ticks.slice();
	
			core_scale.prototype.convertTicksToLabels.call(this);
		},
	
		// Get the correct tooltip label
		getLabelForIndex: function(index, datasetIndex) {
			return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		getPixelForTick: function(index) {
			var ticks = this.tickValues;
			if (index < 0 || index > ticks.length - 1) {
				return null;
			}
			return this.getPixelForValue(ticks[index]);
		},
	
		/**
		 * Returns the value of the first tick.
		 * @param {number} value - The minimum not zero value.
		 * @return {number} The first tick value.
		 * @private
		 */
		_getFirstTickValue: function(value) {
			var exp = Math.floor(log10(value));
			var significand = Math.floor(value / Math.pow(10, exp));
	
			return significand * Math.pow(10, exp);
		},
	
		_configure: function() {
			var me = this;
			var start = me.min;
			var offset = 0;
	
			core_scale.prototype._configure.call(me);
	
			if (start === 0) {
				start = me._getFirstTickValue(me.minNotZero);
				offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
			}
	
			me._startValue = log10(start);
			me._valueOffset = offset;
			me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
		},
	
		getPixelForValue: function(value) {
			var me = this;
			var decimal = 0;
	
			value = +me.getRightValue(value);
	
			if (value > me.min && value > 0) {
				decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
			}
			return me.getPixelForDecimal(decimal);
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var decimal = me.getDecimalForPixel(pixel);
			return decimal === 0 && me.min === 0
				? 0
				: Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$2 = defaultConfig$2;
	scale_logarithmic._defaults = _defaults$2;
	
	var valueOrDefault$c = helpers$1.valueOrDefault;
	var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
	var resolve$4 = helpers$1.options.resolve;
	
	var defaultConfig$3 = {
		display: true,
	
		// Boolean - Whether to animate scaling the chart from the centre
		animate: true,
		position: 'chartArea',
	
		angleLines: {
			display: true,
			color: 'rgba(0,0,0,0.1)',
			lineWidth: 1,
			borderDash: [],
			borderDashOffset: 0.0
		},
	
		gridLines: {
			circular: false
		},
	
		// label settings
		ticks: {
			// Boolean - Show a backdrop to the scale label
			showLabelBackdrop: true,
	
			// String - The colour of the label backdrop
			backdropColor: 'rgba(255,255,255,0.75)',
	
			// Number - The backdrop padding above & below the label in pixels
			backdropPaddingY: 2,
	
			// Number - The backdrop padding to the side of the label in pixels
			backdropPaddingX: 2,
	
			callback: core_ticks.formatters.linear
		},
	
		pointLabels: {
			// Boolean - if true, show point labels
			display: true,
	
			// Number - Point label font size in pixels
			fontSize: 10,
	
			// Function - Used to convert point labels
			callback: function(label) {
				return label;
			}
		}
	};
	
	function getTickBackdropHeight(opts) {
		var tickOpts = opts.ticks;
	
		if (tickOpts.display && opts.display) {
			return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
		}
		return 0;
	}
	
	function measureLabelSize(ctx, lineHeight, label) {
		if (helpers$1.isArray(label)) {
			return {
				w: helpers$1.longestText(ctx, ctx.font, label),
				h: label.length * lineHeight
			};
		}
	
		return {
			w: ctx.measureText(label).width,
			h: lineHeight
		};
	}
	
	function determineLimits(angle, pos, size, min, max) {
		if (angle === min || angle === max) {
			return {
				start: pos - (size / 2),
				end: pos + (size / 2)
			};
		} else if (angle < min || angle > max) {
			return {
				start: pos - size,
				end: pos
			};
		}
	
		return {
			start: pos,
			end: pos + size
		};
	}
	
	/**
	 * Helper function to fit a radial linear scale with point labels
	 */
	function fitWithPointLabels(scale) {
	
		// Right, this is really confusing and there is a lot of maths going on here
		// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
		//
		// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
		//
		// Solution:
		//
		// We assume the radius of the polygon is half the size of the canvas at first
		// at each index we check if the text overlaps.
		//
		// Where it does, we store that angle and that index.
		//
		// After finding the largest index and angle we calculate how much we need to remove
		// from the shape radius to move the point inwards by that x.
		//
		// We average the left and right distances to get the maximum shape radius that can fit in the box
		// along with labels.
		//
		// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
		// on each side, removing that from the size, halving it and adding the left x protrusion width.
		//
		// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
		// and position it in the most space efficient manner
		//
		// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
	
		var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
	
		// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
		// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
		var furthestLimits = {
			l: 0,
			r: scale.width,
			t: 0,
			b: scale.height - scale.paddingTop
		};
		var furthestAngles = {};
		var i, textSize, pointPosition;
	
		scale.ctx.font = plFont.string;
		scale._pointLabelSizes = [];
	
		var valueCount = scale.chart.data.labels.length;
		for (i = 0; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
			textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
			scale._pointLabelSizes[i] = textSize;
	
			// Add quarter circle to make degree 0 mean top of circle
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers$1.toDegrees(angleRadians) % 360;
			var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
			var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
	
			if (hLimits.start < furthestLimits.l) {
				furthestLimits.l = hLimits.start;
				furthestAngles.l = angleRadians;
			}
	
			if (hLimits.end > furthestLimits.r) {
				furthestLimits.r = hLimits.end;
				furthestAngles.r = angleRadians;
			}
	
			if (vLimits.start < furthestLimits.t) {
				furthestLimits.t = vLimits.start;
				furthestAngles.t = angleRadians;
			}
	
			if (vLimits.end > furthestLimits.b) {
				furthestLimits.b = vLimits.end;
				furthestAngles.b = angleRadians;
			}
		}
	
		scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
	}
	
	function getTextAlignForAngle(angle) {
		if (angle === 0 || angle === 180) {
			return 'center';
		} else if (angle < 180) {
			return 'left';
		}
	
		return 'right';
	}
	
	function fillText(ctx, text, position, lineHeight) {
		var y = position.y + lineHeight / 2;
		var i, ilen;
	
		if (helpers$1.isArray(text)) {
			for (i = 0, ilen = text.length; i < ilen; ++i) {
				ctx.fillText(text[i], position.x, y);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, position.x, y);
		}
	}
	
	function adjustPointPositionForLabelHeight(angle, textSize, position) {
		if (angle === 90 || angle === 270) {
			position.y -= (textSize.h / 2);
		} else if (angle > 270 || angle < 90) {
			position.y -= textSize.h;
		}
	}
	
	function drawPointLabels(scale) {
		var ctx = scale.ctx;
		var opts = scale.options;
		var pointLabelOpts = opts.pointLabels;
		var tickBackdropHeight = getTickBackdropHeight(opts);
		var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
		var plFont = helpers$1.options._parseFont(pointLabelOpts);
	
		ctx.save();
	
		ctx.font = plFont.string;
		ctx.textBaseline = 'middle';
	
		for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
			// Extra pixels out for some label spacing
			var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
			var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
	
			// Keep this in loop since we may support array properties here
			var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
			ctx.fillStyle = pointLabelFontColor;
	
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers$1.toDegrees(angleRadians);
			ctx.textAlign = getTextAlignForAngle(angle);
			adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
			fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
		}
		ctx.restore();
	}
	
	function drawRadiusLine(scale, gridLineOpts, radius, index) {
		var ctx = scale.ctx;
		var circular = gridLineOpts.circular;
		var valueCount = scale.chart.data.labels.length;
		var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
		var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
		var pointPosition;
	
		if ((!circular && !valueCount) || !lineColor || !lineWidth) {
			return;
		}
	
		ctx.save();
		ctx.strokeStyle = lineColor;
		ctx.lineWidth = lineWidth;
		if (ctx.setLineDash) {
			ctx.setLineDash(gridLineOpts.borderDash || []);
			ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
		}
	
		ctx.beginPath();
		if (circular) {
			// Draw circular arcs between the points
			ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
		} else {
			// Draw straight lines connecting each index
			pointPosition = scale.getPointPosition(0, radius);
			ctx.moveTo(pointPosition.x, pointPosition.y);
	
			for (var i = 1; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, radius);
				ctx.lineTo(pointPosition.x, pointPosition.y);
			}
		}
		ctx.closePath();
		ctx.stroke();
		ctx.restore();
	}
	
	function numberOrZero(param) {
		return helpers$1.isNumber(param) ? param : 0;
	}
	
	var scale_radialLinear = scale_linearbase.extend({
		setDimensions: function() {
			var me = this;
	
			// Set the unconstrained dimension before label rotation
			me.width = me.maxWidth;
			me.height = me.maxHeight;
			me.paddingTop = getTickBackdropHeight(me.options) / 2;
			me.xCenter = Math.floor(me.width / 2);
			me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
			me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
		},
	
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var min = Number.POSITIVE_INFINITY;
			var max = Number.NEGATIVE_INFINITY;
	
			helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex);
	
					helpers$1.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}
	
						min = Math.min(value, min);
						max = Math.max(value, max);
					});
				}
			});
	
			me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
			me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);
	
			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
	
		// Returns the maximum number of ticks based on the scale dimension
		_computeTickLimit: function() {
			return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
		},
	
		convertTicksToLabels: function() {
			var me = this;
	
			scale_linearbase.prototype.convertTicksToLabels.call(me);
	
			// Point labels
			me.pointLabels = me.chart.data.labels.map(function() {
				var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
				return label || label === 0 ? label : '';
			});
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		fit: function() {
			var me = this;
			var opts = me.options;
	
			if (opts.display && opts.pointLabels.display) {
				fitWithPointLabels(me);
			} else {
				me.setCenterPoint(0, 0, 0, 0);
			}
		},
	
		/**
		 * Set radius reductions and determine new radius and center point
		 * @private
		 */
		setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
			var me = this;
			var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
			var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
			var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
			var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
	
			radiusReductionLeft = numberOrZero(radiusReductionLeft);
			radiusReductionRight = numberOrZero(radiusReductionRight);
			radiusReductionTop = numberOrZero(radiusReductionTop);
			radiusReductionBottom = numberOrZero(radiusReductionBottom);
	
			me.drawingArea = Math.min(
				Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
				Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
			me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
		},
	
		setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
			var me = this;
			var maxRight = me.width - rightMovement - me.drawingArea;
			var maxLeft = leftMovement + me.drawingArea;
			var maxTop = topMovement + me.drawingArea;
			var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;
	
			me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
			me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
		},
	
		getIndexAngle: function(index) {
			var chart = this.chart;
			var angleMultiplier = 360 / chart.data.labels.length;
			var options = chart.options || {};
			var startAngle = options.startAngle || 0;
	
			// Start from the top instead of right, so remove a quarter of the circle
			var angle = (index * angleMultiplier + startAngle) % 360;
	
			return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
		},
	
		getDistanceFromCenterForValue: function(value) {
			var me = this;
	
			if (helpers$1.isNullOrUndef(value)) {
				return NaN;
			}
	
			// Take into account half font size + the yPadding of the top value
			var scalingFactor = me.drawingArea / (me.max - me.min);
			if (me.options.ticks.reverse) {
				return (me.max - value) * scalingFactor;
			}
			return (value - me.min) * scalingFactor;
		},
	
		getPointPosition: function(index, distanceFromCenter) {
			var me = this;
			var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
			return {
				x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
				y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
			};
		},
	
		getPointPositionForValue: function(index, value) {
			return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
		},
	
		getBasePosition: function(index) {
			var me = this;
			var min = me.min;
			var max = me.max;
	
			return me.getPointPositionForValue(index || 0,
				me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0);
		},
	
		/**
		 * @private
		 */
		_drawGrid: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
			var gridLineOpts = opts.gridLines;
			var angleLineOpts = opts.angleLines;
			var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
			var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
			var i, offset, position;
	
			if (opts.pointLabels.display) {
				drawPointLabels(me);
			}
	
			if (gridLineOpts.display) {
				helpers$1.each(me.ticks, function(label, index) {
					if (index !== 0) {
						offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
						drawRadiusLine(me, gridLineOpts, offset, index);
					}
				});
			}
	
			if (angleLineOpts.display && lineWidth && lineColor) {
				ctx.save();
				ctx.lineWidth = lineWidth;
				ctx.strokeStyle = lineColor;
				if (ctx.setLineDash) {
					ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
					ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
				}
	
				for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
					offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
					position = me.getPointPosition(i, offset);
					ctx.beginPath();
					ctx.moveTo(me.xCenter, me.yCenter);
					ctx.lineTo(position.x, position.y);
					ctx.stroke();
				}
	
				ctx.restore();
			}
		},
	
		/**
		 * @private
		 */
		_drawLabels: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			if (!tickOpts.display) {
				return;
			}
	
			var startAngle = me.getIndexAngle(0);
			var tickFont = helpers$1.options._parseFont(tickOpts);
			var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
			var offset, width;
	
			ctx.save();
			ctx.font = tickFont.string;
			ctx.translate(me.xCenter, me.yCenter);
			ctx.rotate(startAngle);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
	
			helpers$1.each(me.ticks, function(label, index) {
				if (index === 0 && !tickOpts.reverse) {
					return;
				}
	
				offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
	
				if (tickOpts.showLabelBackdrop) {
					width = ctx.measureText(label).width;
					ctx.fillStyle = tickOpts.backdropColor;
	
					ctx.fillRect(
						-width / 2 - tickOpts.backdropPaddingX,
						-offset - tickFont.size / 2 - tickOpts.backdropPaddingY,
						width + tickOpts.backdropPaddingX * 2,
						tickFont.size + tickOpts.backdropPaddingY * 2
					);
				}
	
				ctx.fillStyle = tickFontColor;
				ctx.fillText(label, 0, -offset);
			});
	
			ctx.restore();
		},
	
		/**
		 * @private
		 */
		_drawTitle: helpers$1.noop
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$3 = defaultConfig$3;
	scale_radialLinear._defaults = _defaults$3;
	
	var deprecated$1 = helpers$1._deprecated;
	var resolve$5 = helpers$1.options.resolve;
	var valueOrDefault$d = helpers$1.valueOrDefault;
	
	// Integer constants are from the ES6 spec.
	var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
	var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
	
	var INTERVALS = {
		millisecond: {
			common: true,
			size: 1,
			steps: 1000
		},
		second: {
			common: true,
			size: 1000,
			steps: 60
		},
		minute: {
			common: true,
			size: 60000,
			steps: 60
		},
		hour: {
			common: true,
			size: 3600000,
			steps: 24
		},
		day: {
			common: true,
			size: 86400000,
			steps: 30
		},
		week: {
			common: false,
			size: 604800000,
			steps: 4
		},
		month: {
			common: true,
			size: 2.628e9,
			steps: 12
		},
		quarter: {
			common: false,
			size: 7.884e9,
			steps: 4
		},
		year: {
			common: true,
			size: 3.154e10
		}
	};
	
	var UNITS = Object.keys(INTERVALS);
	
	function sorter(a, b) {
		return a - b;
	}
	
	function arrayUnique(items) {
		var hash = {};
		var out = [];
		var i, ilen, item;
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			if (!hash[item]) {
				hash[item] = true;
				out.push(item);
			}
		}
	
		return out;
	}
	
	function getMin(options) {
		return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
	}
	
	function getMax(options) {
		return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
	}
	
	/**
	 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
	 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
	 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
	 * extremity (left + width or top + height). Note that it would be more optimized to directly
	 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
	 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
	 *
	 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
	 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
	 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
	 * If 'series', timestamps will be positioned at the same distance from each other. In this
	 * case, only timestamps that break the time linearity are registered, meaning that in the
	 * best case, all timestamps are linear, the table contains only min and max.
	 */
	function buildLookupTable(timestamps, min, max, distribution) {
		if (distribution === 'linear' || !timestamps.length) {
			return [
				{time: min, pos: 0},
				{time: max, pos: 1}
			];
		}
	
		var table = [];
		var items = [min];
		var i, ilen, prev, curr, next;
	
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			curr = timestamps[i];
			if (curr > min && curr < max) {
				items.push(curr);
			}
		}
	
		items.push(max);
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			next = items[i + 1];
			prev = items[i - 1];
			curr = items[i];
	
			// only add points that breaks the scale linearity
			if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
				table.push({time: curr, pos: i / (ilen - 1)});
			}
		}
	
		return table;
	}
	
	// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
	function lookup(table, key, value) {
		var lo = 0;
		var hi = table.length - 1;
		var mid, i0, i1;
	
		while (lo >= 0 && lo <= hi) {
			mid = (lo + hi) >> 1;
			i0 = table[mid - 1] || null;
			i1 = table[mid];
	
			if (!i0) {
				// given value is outside table (before first item)
				return {lo: null, hi: i1};
			} else if (i1[key] < value) {
				lo = mid + 1;
			} else if (i0[key] > value) {
				hi = mid - 1;
			} else {
				return {lo: i0, hi: i1};
			}
		}
	
		// given value is outside table (after last item)
		return {lo: i1, hi: null};
	}
	
	/**
	 * Linearly interpolates the given source `value` using the table items `skey` values and
	 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
	 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
	 * index [0, 1] or [n - 1, n] are used for the interpolation.
	 */
	function interpolate$1(table, skey, sval, tkey) {
		var range = lookup(table, skey, sval);
	
		// Note: the lookup table ALWAYS contains at least 2 items (min and max)
		var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
		var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
	
		var span = next[skey] - prev[skey];
		var ratio = span ? (sval - prev[skey]) / span : 0;
		var offset = (next[tkey] - prev[tkey]) * ratio;
	
		return prev[tkey] + offset;
	}
	
	function toTimestamp(scale, input) {
		var adapter = scale._adapter;
		var options = scale.options.time;
		var parser = options.parser;
		var format = parser || options.format;
		var value = input;
	
		if (typeof parser === 'function') {
			value = parser(value);
		}
	
		// Only parse if its not a timestamp already
		if (!helpers$1.isFinite(value)) {
			value = typeof format === 'string'
				? adapter.parse(value, format)
				: adapter.parse(value);
		}
	
		if (value !== null) {
			return +value;
		}
	
		// Labels are in an incompatible format and no `parser` has been provided.
		// The user might still use the deprecated `format` option for parsing.
		if (!parser && typeof format === 'function') {
			value = format(input);
	
			// `format` could return something else than a timestamp, if so, parse it
			if (!helpers$1.isFinite(value)) {
				value = adapter.parse(value);
			}
		}
	
		return value;
	}
	
	function parse(scale, input) {
		if (helpers$1.isNullOrUndef(input)) {
			return null;
		}
	
		var options = scale.options.time;
		var value = toTimestamp(scale, scale.getRightValue(input));
		if (value === null) {
			return value;
		}
	
		if (options.round) {
			value = +scale._adapter.startOf(value, options.round);
		}
	
		return value;
	}
	
	/**
	 * Figures out what unit results in an appropriate number of auto-generated ticks
	 */
	function determineUnitForAutoTicks(minUnit, min, max, capacity) {
		var ilen = UNITS.length;
		var i, interval, factor;
	
		for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
			interval = INTERVALS[UNITS[i]];
			factor = interval.steps ? interval.steps : MAX_INTEGER;
	
			if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
				return UNITS[i];
			}
		}
	
		return UNITS[ilen - 1];
	}
	
	/**
	 * Figures out what unit to format a set of ticks with
	 */
	function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
		var i, unit;
	
		for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
			unit = UNITS[i];
			if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
				return unit;
			}
		}
	
		return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
	}
	
	function determineMajorUnit(unit) {
		for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
			if (INTERVALS[UNITS[i]].common) {
				return UNITS[i];
			}
		}
	}
	
	/**
	 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
	 * `minor` unit using the given scale time `options`.
	 * Important: this method can return ticks outside the min and max range, it's the
	 * responsibility of the calling code to clamp values if needed.
	 */
	function generate(scale, min, max, capacity) {
		var adapter = scale._adapter;
		var options = scale.options;
		var timeOpts = options.time;
		var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
		var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
		var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
		var first = min;
		var ticks = [];
		var time;
	
		// For 'week' unit, handle the first day of week option
		if (weekday) {
			first = +adapter.startOf(first, 'isoWeek', weekday);
		}
	
		// Align first ticks on unit
		first = +adapter.startOf(first, weekday ? 'day' : minor);
	
		// Prevent browser from freezing in case user options request millions of milliseconds
		if (adapter.diff(max, min, minor) > 100000 * stepSize) {
			throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
		}
	
		for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
			ticks.push(time);
		}
	
		if (time === max || options.bounds === 'ticks') {
			ticks.push(time);
		}
	
		return ticks;
	}
	
	/**
	 * Returns the start and end offsets from edges in the form of {start, end}
	 * where each value is a relative width to the scale and ranges between 0 and 1.
	 * They add extra margins on the both sides by scaling down the original scale.
	 * Offsets are added when the `offset` option is true.
	 */
	function computeOffsets(table, ticks, min, max, options) {
		var start = 0;
		var end = 0;
		var first, last;
	
		if (options.offset && ticks.length) {
			first = interpolate$1(table, 'time', ticks[0], 'pos');
			if (ticks.length === 1) {
				start = 1 - first;
			} else {
				start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
			}
			last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
			if (ticks.length === 1) {
				end = last;
			} else {
				end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
			}
		}
	
		return {start: start, end: end, factor: 1 / (start + 1 + end)};
	}
	
	function setMajorTicks(scale, ticks, map, majorUnit) {
		var adapter = scale._adapter;
		var first = +adapter.startOf(ticks[0].value, majorUnit);
		var last = ticks[ticks.length - 1].value;
		var major, index;
	
		for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
			index = map[major];
			if (index >= 0) {
				ticks[index].major = true;
			}
		}
		return ticks;
	}
	
	function ticksFromTimestamps(scale, values, majorUnit) {
		var ticks = [];
		var map = {};
		var ilen = values.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = values[i];
			map[value] = i;
	
			ticks.push({
				value: value,
				major: false
			});
		}
	
		// We set the major ticks separately from the above loop because calling startOf for every tick
		// is expensive when there is a large number of ticks
		return (ilen === 0 || !majorUnit) ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
	}
	
	var defaultConfig$4 = {
		position: 'bottom',
	
		/**
		 * Data distribution along the scale:
		 * - 'linear': data are spread according to their time (distances can vary),
		 * - 'series': data are spread at the same distance from each other.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		distribution: 'linear',
	
		/**
		 * Scale boundary strategy (bypassed by min/max time options)
		 * - `data`: make sure data are fully visible, ticks outside are removed
		 * - `ticks`: make sure ticks are fully visible, data outside are truncated
		 * @see https://github.com/chartjs/Chart.js/pull/4556
		 * @since 2.7.0
		 */
		bounds: 'data',
	
		adapters: {},
		time: {
			parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
			unit: false, // false == automatic or override with week, month, year, etc.
			round: false, // none, or override with week, month, year, etc.
			displayFormat: false, // DEPRECATED
			isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
			minUnit: 'millisecond',
			displayFormats: {}
		},
		ticks: {
			autoSkip: false,
	
			/**
			 * Ticks generation input values:
			 * - 'auto': generates "optimal" ticks based on scale size and time options.
			 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
			 * - 'labels': generates ticks from user given `data.labels` values ONLY.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			source: 'auto',
	
			major: {
				enabled: false
			}
		}
	};
	
	var scale_time = core_scale.extend({
		initialize: function() {
			this.mergeTicksOptions();
			core_scale.prototype.initialize.call(this);
		},
	
		update: function() {
			var me = this;
			var options = me.options;
			var time = options.time || (options.time = {});
			var adapter = me._adapter = new core_adapters._date(options.adapters.date);
	
			// DEPRECATIONS: output a message only one time per update
			deprecated$1('time scale', time.format, 'time.format', 'time.parser');
			deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
			deprecated$1('time scale', time.max, 'time.max', 'ticks.max');
	
			// Backward compatibility: before introducing adapter, `displayFormats` was
			// supposed to contain *all* unit/string pairs but this can't be resolved
			// when loading the scale (adapters are loaded afterward), so let's populate
			// missing formats on update
			helpers$1.mergeIf(time.displayFormats, adapter.formats());
	
			return core_scale.prototype.update.apply(me, arguments);
		},
	
		/**
		 * Allows data to be referenced via 't' attribute
		 */
		getRightValue: function(rawValue) {
			if (rawValue && rawValue.t !== undefined) {
				rawValue = rawValue.t;
			}
			return core_scale.prototype.getRightValue.call(this, rawValue);
		},
	
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var adapter = me._adapter;
			var options = me.options;
			var unit = options.time.unit || 'day';
			var min = MAX_INTEGER;
			var max = MIN_INTEGER;
			var timestamps = [];
			var datasets = [];
			var labels = [];
			var i, j, ilen, jlen, data, timestamp, labelsAdded;
			var dataLabels = me._getLabels();
	
			for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
				labels.push(parse(me, dataLabels[i]));
			}
	
			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					data = chart.data.datasets[i].data;
	
					// Let's consider that all data have the same format.
					if (helpers$1.isObject(data[0])) {
						datasets[i] = [];
	
						for (j = 0, jlen = data.length; j < jlen; ++j) {
							timestamp = parse(me, data[j]);
							timestamps.push(timestamp);
							datasets[i][j] = timestamp;
						}
					} else {
						datasets[i] = labels.slice(0);
						if (!labelsAdded) {
							timestamps = timestamps.concat(labels);
							labelsAdded = true;
						}
					}
				} else {
					datasets[i] = [];
				}
			}
	
			if (labels.length) {
				min = Math.min(min, labels[0]);
				max = Math.max(max, labels[labels.length - 1]);
			}
	
			if (timestamps.length) {
				timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
				min = Math.min(min, timestamps[0]);
				max = Math.max(max, timestamps[timestamps.length - 1]);
			}
	
			min = parse(me, getMin(options)) || min;
			max = parse(me, getMax(options)) || max;
	
			// In case there is no valid min/max, set limits based on unit time option
			min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
			max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
	
			// Make sure that max is strictly higher than min (required by the lookup table)
			me.min = Math.min(min, max);
			me.max = Math.max(min + 1, max);
	
			// PRIVATE
			me._table = [];
			me._timestamps = {
				data: timestamps,
				datasets: datasets,
				labels: labels
			};
		},
	
		buildTicks: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
			var options = me.options;
			var tickOpts = options.ticks;
			var timeOpts = options.time;
			var timestamps = me._timestamps;
			var ticks = [];
			var capacity = me.getLabelCapacity(min);
			var source = tickOpts.source;
			var distribution = options.distribution;
			var i, ilen, timestamp;
	
			if (source === 'data' || (source === 'auto' && distribution === 'series')) {
				timestamps = timestamps.data;
			} else if (source === 'labels') {
				timestamps = timestamps.labels;
			} else {
				timestamps = generate(me, min, max, capacity);
			}
	
			if (options.bounds === 'ticks' && timestamps.length) {
				min = timestamps[0];
				max = timestamps[timestamps.length - 1];
			}
	
			// Enforce limits with user min/max options
			min = parse(me, getMin(options)) || min;
			max = parse(me, getMax(options)) || max;
	
			// Remove ticks outside the min/max range
			for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
				timestamp = timestamps[i];
				if (timestamp >= min && timestamp <= max) {
					ticks.push(timestamp);
				}
			}
	
			me.min = min;
			me.max = max;
	
			// PRIVATE
			// determineUnitForFormatting relies on the number of ticks so we don't use it when
			// autoSkip is enabled because we don't yet know what the final number of ticks will be
			me._unit = timeOpts.unit || (tickOpts.autoSkip
				? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity)
				: determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
			me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined
				: determineMajorUnit(me._unit);
			me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
			me._offsets = computeOffsets(me._table, ticks, min, max, options);
	
			if (tickOpts.reverse) {
				ticks.reverse();
			}
	
			return ticksFromTimestamps(me, ticks, me._majorUnit);
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var adapter = me._adapter;
			var data = me.chart.data;
			var timeOpts = me.options.time;
			var label = data.labels && index < data.labels.length ? data.labels[index] : '';
			var value = data.datasets[datasetIndex].data[index];
	
			if (helpers$1.isObject(value)) {
				label = me.getRightValue(value);
			}
			if (timeOpts.tooltipFormat) {
				return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
			}
			if (typeof label === 'string') {
				return label;
			}
			return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
		},
	
		/**
		 * Function to format an individual tick mark
		 * @private
		 */
		tickFormatFunction: function(time, index, ticks, format) {
			var me = this;
			var adapter = me._adapter;
			var options = me.options;
			var formats = options.time.displayFormats;
			var minorFormat = formats[me._unit];
			var majorUnit = me._majorUnit;
			var majorFormat = formats[majorUnit];
			var tick = ticks[index];
			var tickOpts = options.ticks;
			var major = majorUnit && majorFormat && tick && tick.major;
			var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
			var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
			var formatter = resolve$5([
				nestedTickOpts.callback,
				nestedTickOpts.userCallback,
				tickOpts.callback,
				tickOpts.userCallback
			]);
	
			return formatter ? formatter(label, index, ticks) : label;
		},
	
		convertTicksToLabels: function(ticks) {
			var labels = [];
			var i, ilen;
	
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
			}
	
			return labels;
		},
	
		/**
		 * @private
		 */
		getPixelForOffset: function(time) {
			var me = this;
			var offsets = me._offsets;
			var pos = interpolate$1(me._table, 'time', time, 'pos');
			return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
		},
	
		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var time = null;
	
			if (index !== undefined && datasetIndex !== undefined) {
				time = me._timestamps.datasets[datasetIndex][index];
			}
	
			if (time === null) {
				time = parse(me, value);
			}
	
			if (time !== null) {
				return me.getPixelForOffset(time);
			}
		},
	
		getPixelForTick: function(index) {
			var ticks = this.getTicks();
			return index >= 0 && index < ticks.length ?
				this.getPixelForOffset(ticks[index].value) :
				null;
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var offsets = me._offsets;
			var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
			var time = interpolate$1(me._table, 'pos', pos, 'time');
	
			// DEPRECATION, we should return time directly
			return me._adapter._create(time);
		},
	
		/**
		 * @private
		 */
		_getLabelSize: function(label) {
			var me = this;
			var ticksOpts = me.options.ticks;
			var tickLabelWidth = me.ctx.measureText(label).width;
			var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
			var cosRotation = Math.cos(angle);
			var sinRotation = Math.sin(angle);
			var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
	
			return {
				w: (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation),
				h: (tickLabelWidth * sinRotation) + (tickFontSize * cosRotation)
			};
		},
	
		/**
		 * Crude approximation of what the label width might be
		 * @private
		 */
		getLabelWidth: function(label) {
			return this._getLabelSize(label).w;
		},
	
		/**
		 * @private
		 */
		getLabelCapacity: function(exampleTime) {
			var me = this;
			var timeOpts = me.options.time;
			var displayFormats = timeOpts.displayFormats;
	
			// pick the longest format (milliseconds) for guestimation
			var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
			var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
			var size = me._getLabelSize(exampleLabel);
			var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
	
			if (me.options.offset) {
				capacity--;
			}
	
			return capacity > 0 ? capacity : 1;
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$4 = defaultConfig$4;
	scale_time._defaults = _defaults$4;
	
	var scales = {
		category: scale_category,
		linear: scale_linear,
		logarithmic: scale_logarithmic,
		radialLinear: scale_radialLinear,
		time: scale_time
	};
	
	var FORMATS = {
		datetime: 'MMM D, YYYY, h:mm:ss a',
		millisecond: 'h:mm:ss.SSS a',
		second: 'h:mm:ss a',
		minute: 'h:mm a',
		hour: 'hA',
		day: 'MMM D',
		week: 'll',
		month: 'MMM YYYY',
		quarter: '[Q]Q - YYYY',
		year: 'YYYY'
	};
	
	core_adapters._date.override(typeof moment === 'function' ? {
		_id: 'moment', // DEBUG ONLY
	
		formats: function() {
			return FORMATS;
		},
	
		parse: function(value, format) {
			if (typeof value === 'string' && typeof format === 'string') {
				value = moment(value, format);
			} else if (!(value instanceof moment)) {
				value = moment(value);
			}
			return value.isValid() ? value.valueOf() : null;
		},
	
		format: function(time, format) {
			return moment(time).format(format);
		},
	
		add: function(time, amount, unit) {
			return moment(time).add(amount, unit).valueOf();
		},
	
		diff: function(max, min, unit) {
			return moment(max).diff(moment(min), unit);
		},
	
		startOf: function(time, unit, weekday) {
			time = moment(time);
			if (unit === 'isoWeek') {
				return time.isoWeekday(weekday).valueOf();
			}
			return time.startOf(unit).valueOf();
		},
	
		endOf: function(time, unit) {
			return moment(time).endOf(unit).valueOf();
		},
	
		// DEPRECATIONS
	
		/**
		 * Provided for backward compatibility with scale.getValueForPixel().
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 * @private
		 */
		_create: function(time) {
			return moment(time);
		},
	} : {});
	
	core_defaults._set('global', {
		plugins: {
			filler: {
				propagate: true
			}
		}
	});
	
	var mappers = {
		dataset: function(source) {
			var index = source.fill;
			var chart = source.chart;
			var meta = chart.getDatasetMeta(index);
			var visible = meta && chart.isDatasetVisible(index);
			var points = (visible && meta.dataset._children) || [];
			var length = points.length || 0;
	
			return !length ? null : function(point, i) {
				return (i < length && points[i]._view) || null;
			};
		},
	
		boundary: function(source) {
			var boundary = source.boundary;
			var x = boundary ? boundary.x : null;
			var y = boundary ? boundary.y : null;
	
			if (helpers$1.isArray(boundary)) {
				return function(point, i) {
					return boundary[i];
				};
			}
	
			return function(point) {
				return {
					x: x === null ? point.x : x,
					y: y === null ? point.y : y,
				};
			};
		}
	};
	
	// @todo if (fill[0] === '#')
	function decodeFill(el, index, count) {
		var model = el._model || {};
		var fill = model.fill;
		var target;
	
		if (fill === undefined) {
			fill = !!model.backgroundColor;
		}
	
		if (fill === false || fill === null) {
			return false;
		}
	
		if (fill === true) {
			return 'origin';
		}
	
		target = parseFloat(fill, 10);
		if (isFinite(target) && Math.floor(target) === target) {
			if (fill[0] === '-' || fill[0] === '+') {
				target = index + target;
			}
	
			if (target === index || target < 0 || target >= count) {
				return false;
			}
	
			return target;
		}
	
		switch (fill) {
		// compatibility
		case 'bottom':
			return 'start';
		case 'top':
			return 'end';
		case 'zero':
			return 'origin';
		// supported boundaries
		case 'origin':
		case 'start':
		case 'end':
			return fill;
		// invalid fill values
		default:
			return false;
		}
	}
	
	function computeLinearBoundary(source) {
		var model = source.el._model || {};
		var scale = source.el._scale || {};
		var fill = source.fill;
		var target = null;
		var horizontal;
	
		if (isFinite(fill)) {
			return null;
		}
	
		// Backward compatibility: until v3, we still need to support boundary values set on
		// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
		// controllers might still use it (e.g. the Smith chart).
	
		if (fill === 'start') {
			target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
		} else if (fill === 'end') {
			target = model.scaleTop === undefined ? scale.top : model.scaleTop;
		} else if (model.scaleZero !== undefined) {
			target = model.scaleZero;
		} else if (scale.getBasePixel) {
			target = scale.getBasePixel();
		}
	
		if (target !== undefined && target !== null) {
			if (target.x !== undefined && target.y !== undefined) {
				return target;
			}
	
			if (helpers$1.isFinite(target)) {
				horizontal = scale.isHorizontal();
				return {
					x: horizontal ? target : null,
					y: horizontal ? null : target
				};
			}
		}
	
		return null;
	}
	
	function computeCircularBoundary(source) {
		var scale = source.el._scale;
		var options = scale.options;
		var length = scale.chart.data.labels.length;
		var fill = source.fill;
		var target = [];
		var start, end, center, i, point;
	
		if (!length) {
			return null;
		}
	
		start = options.ticks.reverse ? scale.max : scale.min;
		end = options.ticks.reverse ? scale.min : scale.max;
		center = scale.getPointPositionForValue(0, start);
		for (i = 0; i < length; ++i) {
			point = fill === 'start' || fill === 'end'
				? scale.getPointPositionForValue(i, fill === 'start' ? start : end)
				: scale.getBasePosition(i);
			if (options.gridLines.circular) {
				point.cx = center.x;
				point.cy = center.y;
				point.angle = scale.getIndexAngle(i) - Math.PI / 2;
			}
			target.push(point);
		}
		return target;
	}
	
	function computeBoundary(source) {
		var scale = source.el._scale || {};
	
		if (scale.getPointPositionForValue) {
			return computeCircularBoundary(source);
		}
		return computeLinearBoundary(source);
	}
	
	function resolveTarget(sources, index, propagate) {
		var source = sources[index];
		var fill = source.fill;
		var visited = [index];
		var target;
	
		if (!propagate) {
			return fill;
		}
	
		while (fill !== false && visited.indexOf(fill) === -1) {
			if (!isFinite(fill)) {
				return fill;
			}
	
			target = sources[fill];
			if (!target) {
				return false;
			}
	
			if (target.visible) {
				return fill;
			}
	
			visited.push(fill);
			fill = target.fill;
		}
	
		return false;
	}
	
	function createMapper(source) {
		var fill = source.fill;
		var type = 'dataset';
	
		if (fill === false) {
			return null;
		}
	
		if (!isFinite(fill)) {
			type = 'boundary';
		}
	
		return mappers[type](source);
	}
	
	function isDrawable(point) {
		return point && !point.skip;
	}
	
	function drawArea(ctx, curve0, curve1, len0, len1) {
		var i, cx, cy, r;
	
		if (!len0 || !len1) {
			return;
		}
	
		// building first area curve (normal)
		ctx.moveTo(curve0[0].x, curve0[0].y);
		for (i = 1; i < len0; ++i) {
			helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
		}
	
		if (curve1[0].angle !== undefined) {
			cx = curve1[0].cx;
			cy = curve1[0].cy;
			r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
			for (i = len1 - 1; i > 0; --i) {
				ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
			}
			return;
		}
	
		// joining the two area curves
		ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
	
		// building opposite area curve (reverse)
		for (i = len1 - 1; i > 0; --i) {
			helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
		}
	}
	
	function doFill(ctx, points, mapper, view, color, loop) {
		var count = points.length;
		var span = view.spanGaps;
		var curve0 = [];
		var curve1 = [];
		var len0 = 0;
		var len1 = 0;
		var i, ilen, index, p0, p1, d0, d1, loopOffset;
	
		ctx.beginPath();
	
		for (i = 0, ilen = count; i < ilen; ++i) {
			index = i % count;
			p0 = points[index]._view;
			p1 = mapper(p0, index, view);
			d0 = isDrawable(p0);
			d1 = isDrawable(p1);
	
			if (loop && loopOffset === undefined && d0) {
				loopOffset = i + 1;
				ilen = count + loopOffset;
			}
	
			if (d0 && d1) {
				len0 = curve0.push(p0);
				len1 = curve1.push(p1);
			} else if (len0 && len1) {
				if (!span) {
					drawArea(ctx, curve0, curve1, len0, len1);
					len0 = len1 = 0;
					curve0 = [];
					curve1 = [];
				} else {
					if (d0) {
						curve0.push(p0);
					}
					if (d1) {
						curve1.push(p1);
					}
				}
			}
		}
	
		drawArea(ctx, curve0, curve1, len0, len1);
	
		ctx.closePath();
		ctx.fillStyle = color;
		ctx.fill();
	}
	
	var plugin_filler = {
		id: 'filler',
	
		afterDatasetsUpdate: function(chart, options) {
			var count = (chart.data.datasets || []).length;
			var propagate = options.propagate;
			var sources = [];
			var meta, i, el, source;
	
			for (i = 0; i < count; ++i) {
				meta = chart.getDatasetMeta(i);
				el = meta.dataset;
				source = null;
	
				if (el && el._model && el instanceof elements.Line) {
					source = {
						visible: chart.isDatasetVisible(i),
						fill: decodeFill(el, i, count),
						chart: chart,
						el: el
					};
				}
	
				meta.$filler = source;
				sources.push(source);
			}
	
			for (i = 0; i < count; ++i) {
				source = sources[i];
				if (!source) {
					continue;
				}
	
				source.fill = resolveTarget(sources, i, propagate);
				source.boundary = computeBoundary(source);
				source.mapper = createMapper(source);
			}
		},
	
		beforeDatasetsDraw: function(chart) {
			var metasets = chart._getSortedVisibleDatasetMetas();
			var ctx = chart.ctx;
			var meta, i, el, view, points, mapper, color;
	
			for (i = metasets.length - 1; i >= 0; --i) {
				meta = metasets[i].$filler;
	
				if (!meta || !meta.visible) {
					continue;
				}
	
				el = meta.el;
				view = el._view;
				points = el._children || [];
				mapper = meta.mapper;
				color = view.backgroundColor || core_defaults.global.defaultColor;
	
				if (mapper && color && points.length) {
					helpers$1.canvas.clipArea(ctx, chart.chartArea);
					doFill(ctx, points, mapper, view, color, el._loop);
					helpers$1.canvas.unclipArea(ctx);
				}
			}
		}
	};
	
	var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
	var noop$1 = helpers$1.noop;
	var valueOrDefault$e = helpers$1.valueOrDefault;
	
	core_defaults._set('global', {
		legend: {
			display: true,
			position: 'top',
			align: 'center',
			fullWidth: true,
			reverse: false,
			weight: 1000,
	
			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);
	
				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
	
				// We hid a dataset ... rerender the chart
				ci.update();
			},
	
			onHover: null,
			onLeave: null,
	
			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var datasets = chart.data.datasets;
					var options = chart.options.legend || {};
					var usePointStyle = options.labels && options.labels.usePointStyle;
	
					return chart._getSortedDatasetMetas().map(function(meta) {
						var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
	
						return {
							text: datasets[meta.index].label,
							fillStyle: style.backgroundColor,
							hidden: !chart.isDatasetVisible(meta.index),
							lineCap: style.borderCapStyle,
							lineDash: style.borderDash,
							lineDashOffset: style.borderDashOffset,
							lineJoin: style.borderJoinStyle,
							lineWidth: style.borderWidth,
							strokeStyle: style.borderColor,
							pointStyle: style.pointStyle,
							rotation: style.rotation,
	
							// Below is extra data used for toggling the datasets
							datasetIndex: meta.index
						};
					}, this);
				}
			}
		},
	
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var datasets = chart.data.datasets;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
	
			for (i = 0, ilen = datasets.length; i < ilen; i++) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
				if (datasets[i].label) {
					listItem.appendChild(document.createTextNode(datasets[i].label));
				}
			}
	
			return list.outerHTML;
		}
	});
	
	/**
	 * Helper function to get the box width based on the usePointStyle option
	 * @param {object} labelopts - the label options on the legend
	 * @param {number} fontSize - the label font size
	 * @return {number} width of the color box area
	 */
	function getBoxWidth(labelOpts, fontSize) {
		return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
			fontSize :
			labelOpts.boxWidth;
	}
	
	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Legend = core_element.extend({
	
		initialize: function(config) {
			var me = this;
			helpers$1.extend(me, config);
	
			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
	
			/**
	 		 * @private
	 		 */
			me._hoveredItem = null;
	
			// Are we in doughnut mode which has a different data type
			me.doughnutMode = false;
		},
	
		// These methods are ordered by lifecycle. Utilities then follow.
		// Any function defined here is inherited by all legend types.
		// Any function can be extended by the legend type
	
		beforeUpdate: noop$1,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();
	
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();
	
			return me.minSize;
		},
		afterUpdate: noop$1,
	
		//
	
		beforeSetDimensions: noop$1,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
	
			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$1,
	
		//
	
		beforeBuildLabels: noop$1,
		buildLabels: function() {
			var me = this;
			var labelOpts = me.options.labels || {};
			var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];
	
			if (labelOpts.filter) {
				legendItems = legendItems.filter(function(item) {
					return labelOpts.filter(item, me.chart.data);
				});
			}
	
			if (me.options.reverse) {
				legendItems.reverse();
			}
	
			me.legendItems = legendItems;
		},
		afterBuildLabels: noop$1,
	
		//
	
		beforeFit: noop$1,
		fit: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var display = opts.display;
	
			var ctx = me.ctx;
	
			var labelFont = helpers$1.options._parseFont(labelOpts);
			var fontSize = labelFont.size;
	
			// Reset hit boxes
			var hitboxes = me.legendHitBoxes = [];
	
			var minSize = me.minSize;
			var isHorizontal = me.isHorizontal();
	
			if (isHorizontal) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = display ? 10 : 0;
			} else {
				minSize.width = display ? 10 : 0;
				minSize.height = me.maxHeight; // fill all the height
			}
	
			// Increase sizes here
			if (!display) {
				me.width = minSize.width = me.height = minSize.height = 0;
				return;
			}
			ctx.font = labelFont.string;
	
			if (isHorizontal) {
				// Labels
	
				// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
				var lineWidths = me.lineWidths = [0];
				var totalHeight = 0;
	
				ctx.textAlign = 'left';
				ctx.textBaseline = 'middle';
	
				helpers$1.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
					if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
						totalHeight += fontSize + labelOpts.padding;
						lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
					}
	
					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: width,
						height: fontSize
					};
	
					lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
				});
	
				minSize.height += totalHeight;
	
			} else {
				var vPadding = labelOpts.padding;
				var columnWidths = me.columnWidths = [];
				var columnHeights = me.columnHeights = [];
				var totalWidth = labelOpts.padding;
				var currentColWidth = 0;
				var currentColHeight = 0;
	
				helpers$1.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
					// If too tall, go to new column
					if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
						totalWidth += currentColWidth + labelOpts.padding;
						columnWidths.push(currentColWidth); // previous column width
						columnHeights.push(currentColHeight);
						currentColWidth = 0;
						currentColHeight = 0;
					}
	
					// Get max width
					currentColWidth = Math.max(currentColWidth, itemWidth);
					currentColHeight += fontSize + vPadding;
	
					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: itemWidth,
						height: fontSize
					};
				});
	
				totalWidth += currentColWidth;
				columnWidths.push(currentColWidth);
				columnHeights.push(currentColHeight);
				minSize.width += totalWidth;
			}
	
			me.width = minSize.width;
			me.height = minSize.height;
		},
		afterFit: noop$1,
	
		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},
	
		// Actually draw the legend on the canvas
		draw: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var globalDefaults = core_defaults.global;
			var defaultColor = globalDefaults.defaultColor;
			var lineDefault = globalDefaults.elements.line;
			var legendHeight = me.height;
			var columnHeights = me.columnHeights;
			var legendWidth = me.width;
			var lineWidths = me.lineWidths;
	
			if (!opts.display) {
				return;
			}
	
			var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
			var ctx = me.ctx;
			var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
			var labelFont = helpers$1.options._parseFont(labelOpts);
			var fontSize = labelFont.size;
			var cursor;
	
			// Canvas setup
			ctx.textAlign = rtlHelper.textAlign('left');
			ctx.textBaseline = 'middle';
			ctx.lineWidth = 0.5;
			ctx.strokeStyle = fontColor; // for strikethrough effect
			ctx.fillStyle = fontColor; // render in correct colour
			ctx.font = labelFont.string;
	
			var boxWidth = getBoxWidth(labelOpts, fontSize);
			var hitboxes = me.legendHitBoxes;
	
			// current position
			var drawLegendBox = function(x, y, legendItem) {
				if (isNaN(boxWidth) || boxWidth <= 0) {
					return;
				}
	
				// Set the ctx for the box
				ctx.save();
	
				var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
				ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
				ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
				ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
				ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
				ctx.lineWidth = lineWidth;
				ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
	
				if (ctx.setLineDash) {
					// IE 9 and 10 do not support line dash
					ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
				}
	
				if (labelOpts && labelOpts.usePointStyle) {
					// Recalculate x and y for drawPoint() because its expecting
					// x and y to be center of figure (instead of top left)
					var radius = boxWidth * Math.SQRT2 / 2;
					var centerX = rtlHelper.xPlus(x, boxWidth / 2);
					var centerY = y + fontSize / 2;
	
					// Draw pointStyle as legend symbol
					helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
				} else {
					// Draw box as legend symbol
					ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
					if (lineWidth !== 0) {
						ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
					}
				}
	
				ctx.restore();
			};
	
			var fillText = function(x, y, legendItem, textWidth) {
				var halfFontSize = fontSize / 2;
				var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
				var yMiddle = y + halfFontSize;
	
				ctx.fillText(legendItem.text, xLeft, yMiddle);
	
				if (legendItem.hidden) {
					// Strikethrough the text if hidden
					ctx.beginPath();
					ctx.lineWidth = 2;
					ctx.moveTo(xLeft, yMiddle);
					ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
					ctx.stroke();
				}
			};
	
			var alignmentOffset = function(dimension, blockSize) {
				switch (opts.align) {
				case 'start':
					return labelOpts.padding;
				case 'end':
					return dimension - blockSize;
				default: // center
					return (dimension - blockSize + labelOpts.padding) / 2;
				}
			};
	
			// Horizontal
			var isHorizontal = me.isHorizontal();
			if (isHorizontal) {
				cursor = {
					x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
					y: me.top + labelOpts.padding,
					line: 0
				};
			} else {
				cursor = {
					x: me.left + labelOpts.padding,
					y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
					line: 0
				};
			}
	
			helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
	
			var itemHeight = fontSize + labelOpts.padding;
			helpers$1.each(me.legendItems, function(legendItem, i) {
				var textWidth = ctx.measureText(legendItem.text).width;
				var width = boxWidth + (fontSize / 2) + textWidth;
				var x = cursor.x;
				var y = cursor.y;
	
				rtlHelper.setWidth(me.minSize.width);
	
				// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
				// instead of me.right and me.bottom because me.width and me.height
				// may have been changed since me.minSize was calculated
				if (isHorizontal) {
					if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
						y = cursor.y += itemHeight;
						cursor.line++;
						x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
					}
				} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
					x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
					cursor.line++;
					y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
				}
	
				var realX = rtlHelper.x(x);
	
				drawLegendBox(realX, y, legendItem);
	
				hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
				hitboxes[i].top = y;
	
				// Fill the actual label
				fillText(realX, y, legendItem, textWidth);
	
				if (isHorizontal) {
					cursor.x += width + labelOpts.padding;
				} else {
					cursor.y += itemHeight;
				}
			});
	
			helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
		},
	
		/**
		 * @private
		 */
		_getLegendItemAt: function(x, y) {
			var me = this;
			var i, hitBox, lh;
	
			if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
				// See if we are touching one of the dataset boxes
				lh = me.legendHitBoxes;
				for (i = 0; i < lh.length; ++i) {
					hitBox = lh[i];
	
					if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
						// Touching an element
						return me.legendItems[i];
					}
				}
			}
	
			return null;
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 */
		handleEvent: function(e) {
			var me = this;
			var opts = me.options;
			var type = e.type === 'mouseup' ? 'click' : e.type;
			var hoveredItem;
	
			if (type === 'mousemove') {
				if (!opts.onHover && !opts.onLeave) {
					return;
				}
			} else if (type === 'click') {
				if (!opts.onClick) {
					return;
				}
			} else {
				return;
			}
	
			// Chart event already has relative position in it
			hoveredItem = me._getLegendItemAt(e.x, e.y);
	
			if (type === 'click') {
				if (hoveredItem && opts.onClick) {
					// use e.native for backwards compatibility
					opts.onClick.call(me, e.native, hoveredItem);
				}
			} else {
				if (opts.onLeave && hoveredItem !== me._hoveredItem) {
					if (me._hoveredItem) {
						opts.onLeave.call(me, e.native, me._hoveredItem);
					}
					me._hoveredItem = hoveredItem;
				}
	
				if (opts.onHover && hoveredItem) {
					// use e.native for backwards compatibility
					opts.onHover.call(me, e.native, hoveredItem);
				}
			}
		}
	});
	
	function createNewLegendAndAttach(chart, legendOpts) {
		var legend = new Legend({
			ctx: chart.ctx,
			options: legendOpts,
			chart: chart
		});
	
		core_layouts.configure(chart, legend, legendOpts);
		core_layouts.addBox(chart, legend);
		chart.legend = legend;
	}
	
	var plugin_legend = {
		id: 'legend',
	
		/**
		 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
		 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Legend,
	
		beforeInit: function(chart) {
			var legendOpts = chart.options.legend;
	
			if (legendOpts) {
				createNewLegendAndAttach(chart, legendOpts);
			}
		},
	
		beforeUpdate: function(chart) {
			var legendOpts = chart.options.legend;
			var legend = chart.legend;
	
			if (legendOpts) {
				helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
	
				if (legend) {
					core_layouts.configure(chart, legend, legendOpts);
					legend.options = legendOpts;
				} else {
					createNewLegendAndAttach(chart, legendOpts);
				}
			} else if (legend) {
				core_layouts.removeBox(chart, legend);
				delete chart.legend;
			}
		},
	
		afterEvent: function(chart, e) {
			var legend = chart.legend;
			if (legend) {
				legend.handleEvent(e);
			}
		}
	};
	
	var noop$2 = helpers$1.noop;
	
	core_defaults._set('global', {
		title: {
			display: false,
			fontStyle: 'bold',
			fullWidth: true,
			padding: 10,
			position: 'top',
			text: '',
			weight: 2000         // by default greater than legend (1000) to be above
		}
	});
	
	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Title = core_element.extend({
		initialize: function(config) {
			var me = this;
			helpers$1.extend(me, config);
	
			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
		},
	
		// These methods are ordered by lifecycle. Utilities then follow.
	
		beforeUpdate: noop$2,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();
	
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();
	
			return me.minSize;
	
		},
		afterUpdate: noop$2,
	
		//
	
		beforeSetDimensions: noop$2,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
	
			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$2,
	
		//
	
		beforeBuildLabels: noop$2,
		buildLabels: noop$2,
		afterBuildLabels: noop$2,
	
		//
	
		beforeFit: noop$2,
		fit: function() {
			var me = this;
			var opts = me.options;
			var minSize = me.minSize = {};
			var isHorizontal = me.isHorizontal();
			var lineCount, textSize;
	
			if (!opts.display) {
				me.width = minSize.width = me.height = minSize.height = 0;
				return;
			}
	
			lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
			textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
	
			me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
			me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
		},
		afterFit: noop$2,
	
		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},
	
		// Actually draw the title block on the canvas
		draw: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
	
			if (!opts.display) {
				return;
			}
	
			var fontOpts = helpers$1.options._parseFont(opts);
			var lineHeight = fontOpts.lineHeight;
			var offset = lineHeight / 2 + opts.padding;
			var rotation = 0;
			var top = me.top;
			var left = me.left;
			var bottom = me.bottom;
			var right = me.right;
			var maxWidth, titleX, titleY;
	
			ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
			ctx.font = fontOpts.string;
	
			// Horizontal
			if (me.isHorizontal()) {
				titleX = left + ((right - left) / 2); // midpoint of the width
				titleY = top + offset;
				maxWidth = right - left;
			} else {
				titleX = opts.position === 'left' ? left + offset : right - offset;
				titleY = top + ((bottom - top) / 2);
				maxWidth = bottom - top;
				rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
			}
	
			ctx.save();
			ctx.translate(titleX, titleY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
	
			var text = opts.text;
			if (helpers$1.isArray(text)) {
				var y = 0;
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], 0, y, maxWidth);
					y += lineHeight;
				}
			} else {
				ctx.fillText(text, 0, 0, maxWidth);
			}
	
			ctx.restore();
		}
	});
	
	function createNewTitleBlockAndAttach(chart, titleOpts) {
		var title = new Title({
			ctx: chart.ctx,
			options: titleOpts,
			chart: chart
		});
	
		core_layouts.configure(chart, title, titleOpts);
		core_layouts.addBox(chart, title);
		chart.titleBlock = title;
	}
	
	var plugin_title = {
		id: 'title',
	
		/**
		 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
		 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Title,
	
		beforeInit: function(chart) {
			var titleOpts = chart.options.title;
	
			if (titleOpts) {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		},
	
		beforeUpdate: function(chart) {
			var titleOpts = chart.options.title;
			var titleBlock = chart.titleBlock;
	
			if (titleOpts) {
				helpers$1.mergeIf(titleOpts, core_defaults.global.title);
	
				if (titleBlock) {
					core_layouts.configure(chart, titleBlock, titleOpts);
					titleBlock.options = titleOpts;
				} else {
					createNewTitleBlockAndAttach(chart, titleOpts);
				}
			} else if (titleBlock) {
				core_layouts.removeBox(chart, titleBlock);
				delete chart.titleBlock;
			}
		}
	};
	
	var plugins = {};
	var filler = plugin_filler;
	var legend = plugin_legend;
	var title = plugin_title;
	plugins.filler = filler;
	plugins.legend = legend;
	plugins.title = title;
	
	/**
	 * @namespace Chart
	 */
	
	
	core_controller.helpers = helpers$1;
	
	// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
	core_helpers();
	
	core_controller._adapters = core_adapters;
	core_controller.Animation = core_animation;
	core_controller.animationService = core_animations;
	core_controller.controllers = controllers;
	core_controller.DatasetController = core_datasetController;
	core_controller.defaults = core_defaults;
	core_controller.Element = core_element;
	core_controller.elements = elements;
	core_controller.Interaction = core_interaction;
	core_controller.layouts = core_layouts;
	core_controller.platform = platform;
	core_controller.plugins = core_plugins;
	core_controller.Scale = core_scale;
	core_controller.scaleService = core_scaleService;
	core_controller.Ticks = core_ticks;
	core_controller.Tooltip = core_tooltip;
	
	// Register built-in scales
	
	core_controller.helpers.each(scales, function(scale, type) {
		core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
	});
	
	// Load to register built-in adapters (as side effects)
	
	
	// Loading built-in plugins
	
	for (var k in plugins) {
		if (plugins.hasOwnProperty(k)) {
			core_controller.plugins.register(plugins[k]);
		}
	}
	
	core_controller.platform.initialize();
	
	var src = core_controller;
	if (typeof window !== 'undefined') {
		window.Chart = core_controller;
	}
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Chart
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Chart = core_controller;
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Legend
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Legend = plugins.legend._element;
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Title
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Title = plugins.title._element;
	
	/**
	 * Provided for backward compatibility, use Chart.plugins instead
	 * @namespace Chart.pluginService
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.pluginService = core_controller.plugins;
	
	/**
	 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
	 * effect, instead simply create/register plugins via plain JavaScript objects.
	 * @interface Chart.PluginBase
	 * @deprecated since version 2.5.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.PluginBase = core_controller.Element.extend({});
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas instead.
	 * @namespace Chart.canvasHelpers
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.canvasHelpers = core_controller.helpers.canvas;
	
	/**
	 * Provided for backward compatibility, use Chart.layouts instead.
	 * @namespace Chart.layoutService
	 * @deprecated since version 2.7.3
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.layoutService = core_controller.layouts;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.LinearScaleBase
	 * @deprecated since version 2.8
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.LinearScaleBase = scale_linearbase;
	
	/**
	 * Provided for backward compatibility, instead we should create a new Chart
	 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	core_controller.helpers.each(
		[
			'Bar',
			'Bubble',
			'Doughnut',
			'Line',
			'PolarArea',
			'Radar',
			'Scatter'
		],
		function(klass) {
			core_controller[klass] = function(ctx, cfg) {
				return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
					type: klass.charAt(0).toLowerCase() + klass.slice(1)
				}));
			};
		}
	);
	
	return src;
	
	})));


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(7328)
	
	var md5 = toConstructor(__webpack_require__(6683))
	var rmd160 = toConstructor(__webpack_require__(7215))
	
	function toConstructor (fn) {
	  return function () {
	    var buffers = []
	    var m= {
	      update: function (data, enc) {
	        if(!Buffer.isBuffer(data)) data = new Buffer(data, enc)
	        buffers.push(data)
	        return this
	      },
	      digest: function (enc) {
	        var buf = Buffer.concat(buffers)
	        var r = fn(buf)
	        buffers = null
	        return enc ? r.toString(enc) : r
	      }
	    }
	    return m
	  }
	}
	
	module.exports = function (alg) {
	  if('md5' === alg) return new md5()
	  if('rmd160' === alg) return new rmd160()
	  return createHash(alg)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39).Buffer))

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Initialization and round constants tables
		    var H = [];
		    var K = [];
	
		    // Compute constants
		    (function () {
		        function isPrime(n) {
		            var sqrtN = Math.sqrt(n);
		            for (var factor = 2; factor <= sqrtN; factor++) {
		                if (!(n % factor)) {
		                    return false;
		                }
		            }
	
		            return true;
		        }
	
		        function getFractionalBits(n) {
		            return ((n - (n | 0)) * 0x100000000) | 0;
		        }
	
		        var n = 2;
		        var nPrime = 0;
		        while (nPrime < 64) {
		            if (isPrime(n)) {
		                if (nPrime < 8) {
		                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
		                }
		                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
	
		                nPrime++;
		            }
	
		            n++;
		        }
		    }());
	
		    // Reusable object
		    var W = [];
	
		    /**
		     * SHA-256 hash algorithm.
		     */
		    var SHA256 = C_algo.SHA256 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init(H.slice(0));
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var H = this._hash.words;
	
		            // Working variables
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
		            var e = H[4];
		            var f = H[5];
		            var g = H[6];
		            var h = H[7];
	
		            // Computation
		            for (var i = 0; i < 64; i++) {
		                if (i < 16) {
		                    W[i] = M[offset + i] | 0;
		                } else {
		                    var gamma0x = W[i - 15];
		                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
		                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
		                                   (gamma0x >>> 3);
	
		                    var gamma1x = W[i - 2];
		                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
		                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
		                                   (gamma1x >>> 10);
	
		                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
		                }
	
		                var ch  = (e & f) ^ (~e & g);
		                var maj = (a & b) ^ (a & c) ^ (b & c);
	
		                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
		                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));
	
		                var t1 = h + sigma1 + ch + K[i] + W[i];
		                var t2 = sigma0 + maj;
	
		                h = g;
		                g = f;
		                f = e;
		                e = (d + t1) | 0;
		                d = c;
		                c = b;
		                b = a;
		                a = (t1 + t2) | 0;
		            }
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		            H[4] = (H[4] + e) | 0;
		            H[5] = (H[5] + f) | 0;
		            H[6] = (H[6] + g) | 0;
		            H[7] = (H[7] + h) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Return final computed hash
		            return this._hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA256('message');
		     *     var hash = CryptoJS.SHA256(wordArray);
		     */
		    C.SHA256 = Hasher._createHelper(SHA256);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA256(message, key);
		     */
		    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
		}(Math));
	
	
		return CryptoJS.SHA256;
	
	}));

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(175));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Hasher = C_lib.Hasher;
		    var C_x64 = C.x64;
		    var X64Word = C_x64.Word;
		    var X64WordArray = C_x64.WordArray;
		    var C_algo = C.algo;
	
		    function X64Word_create() {
		        return X64Word.create.apply(X64Word, arguments);
		    }
	
		    // Constants
		    var K = [
		        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
		        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
		        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
		        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
		        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
		        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
		        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
		        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
		        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
		        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
		        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
		        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
		        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
		        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
		        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
		        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
		        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
		        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
		        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
		        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
		        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
		        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
		        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
		        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
		        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
		        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
		        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
		        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
		        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
		        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
		        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
		        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
		        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
		        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
		        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
		        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
		        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
		        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
		        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
		        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
		    ];
	
		    // Reusable objects
		    var W = [];
		    (function () {
		        for (var i = 0; i < 80; i++) {
		            W[i] = X64Word_create();
		        }
		    }());
	
		    /**
		     * SHA-512 hash algorithm.
		     */
		    var SHA512 = C_algo.SHA512 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new X64WordArray.init([
		                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
		                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
		                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
		                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
		            ]);
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcuts
		            var H = this._hash.words;
	
		            var H0 = H[0];
		            var H1 = H[1];
		            var H2 = H[2];
		            var H3 = H[3];
		            var H4 = H[4];
		            var H5 = H[5];
		            var H6 = H[6];
		            var H7 = H[7];
	
		            var H0h = H0.high;
		            var H0l = H0.low;
		            var H1h = H1.high;
		            var H1l = H1.low;
		            var H2h = H2.high;
		            var H2l = H2.low;
		            var H3h = H3.high;
		            var H3l = H3.low;
		            var H4h = H4.high;
		            var H4l = H4.low;
		            var H5h = H5.high;
		            var H5l = H5.low;
		            var H6h = H6.high;
		            var H6l = H6.low;
		            var H7h = H7.high;
		            var H7l = H7.low;
	
		            // Working variables
		            var ah = H0h;
		            var al = H0l;
		            var bh = H1h;
		            var bl = H1l;
		            var ch = H2h;
		            var cl = H2l;
		            var dh = H3h;
		            var dl = H3l;
		            var eh = H4h;
		            var el = H4l;
		            var fh = H5h;
		            var fl = H5l;
		            var gh = H6h;
		            var gl = H6l;
		            var hh = H7h;
		            var hl = H7l;
	
		            // Rounds
		            for (var i = 0; i < 80; i++) {
		                var Wil;
		                var Wih;
	
		                // Shortcut
		                var Wi = W[i];
	
		                // Extend message
		                if (i < 16) {
		                    Wih = Wi.high = M[offset + i * 2]     | 0;
		                    Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
		                } else {
		                    // Gamma0
		                    var gamma0x  = W[i - 15];
		                    var gamma0xh = gamma0x.high;
		                    var gamma0xl = gamma0x.low;
		                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
		                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));
	
		                    // Gamma1
		                    var gamma1x  = W[i - 2];
		                    var gamma1xh = gamma1x.high;
		                    var gamma1xl = gamma1x.low;
		                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
		                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));
	
		                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
		                    var Wi7  = W[i - 7];
		                    var Wi7h = Wi7.high;
		                    var Wi7l = Wi7.low;
	
		                    var Wi16  = W[i - 16];
		                    var Wi16h = Wi16.high;
		                    var Wi16l = Wi16.low;
	
		                    Wil = gamma0l + Wi7l;
		                    Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
		                    Wil = Wil + gamma1l;
		                    Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
		                    Wil = Wil + Wi16l;
		                    Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);
	
		                    Wi.high = Wih;
		                    Wi.low  = Wil;
		                }
	
		                var chh  = (eh & fh) ^ (~eh & gh);
		                var chl  = (el & fl) ^ (~el & gl);
		                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
		                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);
	
		                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
		                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
		                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
		                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));
	
		                // t1 = h + sigma1 + ch + K[i] + W[i]
		                var Ki  = K[i];
		                var Kih = Ki.high;
		                var Kil = Ki.low;
	
		                var t1l = hl + sigma1l;
		                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
		                var t1l = t1l + chl;
		                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
		                var t1l = t1l + Kil;
		                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
		                var t1l = t1l + Wil;
		                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);
	
		                // t2 = sigma0 + maj
		                var t2l = sigma0l + majl;
		                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);
	
		                // Update working variables
		                hh = gh;
		                hl = gl;
		                gh = fh;
		                gl = fl;
		                fh = eh;
		                fl = el;
		                el = (dl + t1l) | 0;
		                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
		                dh = ch;
		                dl = cl;
		                ch = bh;
		                cl = bl;
		                bh = ah;
		                bl = al;
		                al = (t1l + t2l) | 0;
		                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
		            }
	
		            // Intermediate hash value
		            H0l = H0.low  = (H0l + al);
		            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
		            H1l = H1.low  = (H1l + bl);
		            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
		            H2l = H2.low  = (H2l + cl);
		            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
		            H3l = H3.low  = (H3l + dl);
		            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
		            H4l = H4.low  = (H4l + el);
		            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
		            H5l = H5.low  = (H5l + fl);
		            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
		            H6l = H6.low  = (H6l + gl);
		            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
		            H7l = H7.low  = (H7l + hl);
		            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Convert hash to 32-bit word array before returning
		            var hash = this._hash.toX32();
	
		            // Return final computed hash
		            return hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        },
	
		        blockSize: 1024/32
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA512('message');
		     *     var hash = CryptoJS.SHA512(wordArray);
		     */
		    C.SHA512 = Hasher._createHelper(SHA512);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA512(message, key);
		     */
		    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
		}());
	
	
		return CryptoJS.SHA512;
	
	}));

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(6716));
	
	/**
	 * Adds a CSS class to a given element.
	 * 
	 * @param element the element
	 * @param className the CSS class name
	 */
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = exports.onceSupported = exports.optionsSupported = void 0;
	
	var _canUseDOM = _interopRequireDefault(__webpack_require__(176));
	
	/* eslint-disable no-return-assign */
	var optionsSupported = false;
	exports.optionsSupported = optionsSupported;
	var onceSupported = false;
	exports.onceSupported = onceSupported;
	
	try {
	  var options = {
	    get passive() {
	      return exports.optionsSupported = optionsSupported = true;
	    },
	
	    get once() {
	      // eslint-disable-next-line no-multi-assign
	      return exports.onceSupported = onceSupported = exports.optionsSupported = optionsSupported = true;
	    }
	
	  };
	
	  if (_canUseDOM.default) {
	    window.addEventListener('test', options, options);
	    window.removeEventListener('test', options, true);
	  }
	} catch (e) {
	  /* */
	}
	
	/**
	 * An `addEventListener` ponyfill, supports the `once` option
	 * 
	 * @param node the element
	 * @param eventName the event name
	 * @param handle the handler
	 * @param options event options
	 */
	function addEventListener(node, eventName, handler, options) {
	  if (options && typeof options !== 'boolean' && !onceSupported) {
	    var once = options.once,
	        capture = options.capture;
	    var wrappedHandler = handler;
	
	    if (!onceSupported && once) {
	      wrappedHandler = handler.__once || function onceHandler(event) {
	        this.removeEventListener(eventName, onceHandler, capture);
	        handler.call(this, event);
	      };
	
	      handler.__once = wrappedHandler;
	    }
	
	    node.addEventListener(eventName, wrappedHandler, optionsSupported ? options : capture);
	  }
	
	  node.addEventListener(eventName, handler, options);
	}
	
	var _default = addEventListener;
	exports.default = _default;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(435));
	
	var _removeEventListener = _interopRequireDefault(__webpack_require__(438));
	
	function listen(node, eventName, handler, options) {
	  (0, _addEventListener.default)(node, eventName, handler, options);
	  return function () {
	    (0, _removeEventListener.default)(node, eventName, handler, options);
	  };
	}
	
	var _default = listen;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 437 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeClass;
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	/**
	 * Removes a CSS class from a given element.
	 * 
	 * @param element the element
	 * @param className the CSS class name
	 */
	
	
	function removeClass(element, className) {
	  if (element.classList) {
	    element.classList.remove(className);
	  } else if (typeof element.className === 'string') {
	    element.className = replaceClassName(element.className, className);
	  } else {
	    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 438 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	/**
	 * A `removeEventListener` ponyfill
	 * 
	 * @param node the element
	 * @param eventName the event name
	 * @param handle the handler
	 * @param options event options
	 */
	function removeEventListener(node, eventName, handler, options) {
	  var capture = options && typeof options !== 'boolean' ? options.capture : options;
	  node.removeEventListener(eventName, handler, capture);
	
	  if (handler.__once) {
	    node.removeEventListener(eventName, handler.__once, capture);
	  }
	}
	
	var _default = removeEventListener;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 439 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = Error;


/***/ },
/* 440 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./syntax')} */
	module.exports = SyntaxError;


/***/ },
/* 441 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = Object;


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var undefined;
	
	var $Object = __webpack_require__(441);
	
	var $Error = __webpack_require__(439);
	var $EvalError = __webpack_require__(6727);
	var $RangeError = __webpack_require__(6728);
	var $ReferenceError = __webpack_require__(6729);
	var $SyntaxError = __webpack_require__(440);
	var $TypeError = __webpack_require__(114);
	var $URIError = __webpack_require__(6730);
	
	var abs = __webpack_require__(6955);
	var floor = __webpack_require__(6956);
	var max = __webpack_require__(6958);
	var min = __webpack_require__(6959);
	var pow = __webpack_require__(6960);
	var round = __webpack_require__(6961);
	var sign = __webpack_require__(6962);
	
	var $Function = Function;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = __webpack_require__(115);
	var $defineProperty = __webpack_require__(177);
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(6736)();
	
	var getProto = __webpack_require__(445);
	var $ObjectGPO = __webpack_require__(443);
	var $ReflectGPO = __webpack_require__(444);
	
	var $apply = __webpack_require__(250);
	var $call = __webpack_require__(251);
	
	var needsEval = {};
	
	var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		__proto__: null,
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': needsEval,
		'%AsyncGenerator%': needsEval,
		'%AsyncGeneratorFunction%': needsEval,
		'%AsyncIteratorPrototype%': needsEval,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
		'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': $Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': $EvalError,
		'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': needsEval,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': $Object,
		'%Object.getOwnPropertyDescriptor%': $gOPD,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': $RangeError,
		'%ReferenceError%': $ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': $URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	
		'%Function.prototype.call%': $call,
		'%Function.prototype.apply%': $apply,
		'%Object.defineProperty%': $defineProperty,
		'%Object.getPrototypeOf%': $ObjectGPO,
		'%Math.abs%': abs,
		'%Math.floor%': floor,
		'%Math.max%': max,
		'%Math.min%': min,
		'%Math.pow%': pow,
		'%Math.round%': round,
		'%Math.sign%': sign,
		'%Reflect.getPrototypeOf%': $ReflectGPO
	};
	
	if (getProto) {
		try {
			null.error; // eslint-disable-line no-unused-expressions
		} catch (e) {
			// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
			var errorProto = getProto(getProto(e));
			INTRINSICS['%Error.prototype%'] = errorProto;
		}
	}
	
	var doEval = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen && getProto) {
				value = getProto(gen.prototype);
			}
		}
	
		INTRINSICS[name] = value;
	
		return value;
	};
	
	var LEGACY_ALIASES = {
		__proto__: null,
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(136);
	var hasOwn = __webpack_require__(447);
	var $concat = bind.call($call, Array.prototype.concat);
	var $spliceApply = bind.call($apply, Array.prototype.splice);
	var $replace = bind.call($call, String.prototype.replace);
	var $strSlice = bind.call($call, String.prototype.slice);
	var $exec = bind.call($call, RegExp.prototype.exec);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) {
				value = doEval(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		if ($exec(/^%?[^%]*%?$/, name) === null) {
			throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
		}
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $Object = __webpack_require__(441);
	
	/** @type {import('./Object.getPrototypeOf')} */
	module.exports = $Object.getPrototypeOf || null;


/***/ },
/* 444 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./Reflect.getPrototypeOf')} */
	module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reflectGetProto = __webpack_require__(444);
	var originalGetProto = __webpack_require__(443);
	
	var getDunderProto = __webpack_require__(6726);
	
	/** @type {import('.')} */
	module.exports = reflectGetProto
		? function getProto(O) {
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return reflectGetProto(O);
		}
		: originalGetProto
			? function getProto(O) {
				if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
					throw new TypeError('getProto: not an object');
				}
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return originalGetProto(O);
			}
			: getDunderProto
				? function getProto(O) {
					// @ts-expect-error TS can't narrow inside a closure, for some reason
					return getDunderProto(O);
				}
				: null;


/***/ },
/* 446 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./shams')} */
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		/** @type {{ [k in symbol]?: unknown }} */
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			// eslint-disable-next-line no-extra-parens
			var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var call = Function.prototype.call;
	var $hasOwn = Object.prototype.hasOwnProperty;
	var bind = __webpack_require__(136);
	
	/** @type {import('.')} */
	module.exports = bind.call(call, $hasOwn);


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(6737);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ },
/* 449 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var isBrowser = exports.isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;
	
	exports.default = isBrowser;

/***/ },
/* 450 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(101),
	    root = __webpack_require__(58);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(58);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(101),
	    root = __webpack_require__(58);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 454 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(471),
	    isArguments = __webpack_require__(148),
	    isArray = __webpack_require__(35),
	    isBuffer = __webpack_require__(120),
	    isIndex = __webpack_require__(146),
	    isTypedArray = __webpack_require__(151);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 456 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 457 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(140),
	    eq = __webpack_require__(147);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(145),
	    keys = __webpack_require__(63);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 460 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.clamp` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 */
	function baseClamp(number, lower, upper) {
	  if (number === number) {
	    if (upper !== undefined) {
	      number = number <= upper ? number : upper;
	    }
	    if (lower !== undefined) {
	      number = number >= lower ? number : lower;
	    }
	  }
	  return number;
	}
	
	module.exports = baseClamp;


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(180),
	    arrayEach = __webpack_require__(139),
	    assignValue = __webpack_require__(268),
	    baseAssign = __webpack_require__(459),
	    baseAssignIn = __webpack_require__(6765),
	    cloneBuffer = __webpack_require__(475),
	    copyArray = __webpack_require__(116),
	    copySymbols = __webpack_require__(6809),
	    copySymbolsIn = __webpack_require__(6810),
	    getAllKeys = __webpack_require__(484),
	    getAllKeysIn = __webpack_require__(485),
	    getTag = __webpack_require__(87),
	    initCloneArray = __webpack_require__(6841),
	    initCloneByTag = __webpack_require__(6842),
	    initCloneObject = __webpack_require__(489),
	    isArray = __webpack_require__(35),
	    isBuffer = __webpack_require__(120),
	    isMap = __webpack_require__(6920),
	    isObject = __webpack_require__(59),
	    isSet = __webpack_require__(6923),
	    keys = __webpack_require__(63),
	    keysIn = __webpack_require__(152);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	  } else if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(179),
	    arrayIncludes = __webpack_require__(182),
	    arrayIncludesWith = __webpack_require__(266),
	    arrayMap = __webpack_require__(81),
	    baseUnary = __webpack_require__(100),
	    cacheHas = __webpack_require__(189);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 463 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(6816);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(267),
	    isArray = __webpack_require__(35);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(99),
	    isArrayLike = __webpack_require__(73);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(143),
	    baseSet = __webpack_require__(469),
	    castPath = __webpack_require__(144);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ },
/* 468 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(268),
	    castPath = __webpack_require__(144),
	    isIndex = __webpack_require__(146),
	    isObject = __webpack_require__(59),
	    toKey = __webpack_require__(102);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	      return object;
	    }
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(77),
	    metaMap = __webpack_require__(494);
	
	/**
	 * The base implementation of `setData` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ },
/* 471 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(6875);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(179),
	    arrayIncludes = __webpack_require__(182),
	    arrayIncludesWith = __webpack_require__(266),
	    cacheHas = __webpack_require__(189),
	    createSet = __webpack_require__(6827),
	    setToArray = __webpack_require__(199);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(77);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(58);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(215)(module)))

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(272);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 477 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ },
/* 478 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(477),
	    composeArgsRight = __webpack_require__(478),
	    countHolders = __webpack_require__(6812),
	    createCtor = __webpack_require__(190),
	    createRecurry = __webpack_require__(480),
	    getHolder = __webpack_require__(275),
	    reorder = __webpack_require__(6865),
	    replaceHolders = __webpack_require__(198),
	    root = __webpack_require__(58);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_ARY_FLAG = 128,
	    WRAP_FLIP_FLAG = 512;
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & WRAP_ARY_FLAG,
	      isBind = bitmask & WRAP_BIND_FLAG,
	      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	      isFlip = bitmask & WRAP_FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybrid;


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	var isLaziable = __webpack_require__(490),
	    setData = __webpack_require__(498),
	    setWrapToString = __webpack_require__(499);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & WRAP_CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, argPos, ary, arity
	  ];
	
	  var result = wrapFunc.apply(undefined, newData);
	  if (isLaziable(func)) {
	    setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}
	
	module.exports = createRecurry;


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(101);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(179),
	    arraySome = __webpack_require__(457),
	    cacheHas = __webpack_require__(189);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 483 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(465),
	    getSymbols = __webpack_require__(276),
	    keys = __webpack_require__(63);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(465),
	    getSymbolsIn = __webpack_require__(487),
	    keysIn = __webpack_require__(152);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(6864);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(267),
	    getPrototype = __webpack_require__(193),
	    getSymbols = __webpack_require__(276),
	    stubArray = __webpack_require__(514);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(144),
	    isArguments = __webpack_require__(148),
	    isArray = __webpack_require__(35),
	    isIndex = __webpack_require__(146),
	    isLength = __webpack_require__(281),
	    toKey = __webpack_require__(102);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(141),
	    getPrototype = __webpack_require__(193),
	    isPrototype = __webpack_require__(195);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(262),
	    getData = __webpack_require__(274),
	    getFuncName = __webpack_require__(486),
	    lodash = __webpack_require__(6954);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(59);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 492 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 493 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(453);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ },
/* 495 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(181);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 497 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	module.exports = safeGet;


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(470),
	    shortOut = __webpack_require__(500);
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity
	 * function to avoid garbage collection pauses in V8. See
	 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = shortOut(baseSetData);
	
	module.exports = setData;


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	var getWrapDetails = __webpack_require__(6834),
	    insertWrapDetails = __webpack_require__(6843),
	    setToString = __webpack_require__(278),
	    updateWrapDetails = __webpack_require__(6879);
	
	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	function setWrapToString(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	}
	
	module.exports = setWrapToString;


/***/ },
/* 500 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(6858);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 502 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 503 */
/***/ function(module, exports) {

	/**
	 * Creates an array with all falsey values removed. The values `false`, `null`,
	 * `0`, `""`, `undefined`, and `NaN` are falsey.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to compact.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.compact([0, 1, false, 2, '', 3]);
	 * // => [1, 2, 3]
	 */
	function compact(array) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = compact;


/***/ },
/* 504 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	var deburrLetter = __webpack_require__(6828),
	    toString = __webpack_require__(78);
	
	/** Used to match Latin Unicode letters (excluding mathematical operators). */
	var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	/** Used to compose unicode character classes. */
	var rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
	
	/** Used to compose unicode capture groups. */
	var rsCombo = '[' + rsComboRange + ']';
	
	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo, 'g');
	
	/**
	 * Deburrs `string` by converting
	 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	 * letters to basic Latin letters and removing
	 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = toString(string);
	  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	}
	
	module.exports = deburr;


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(118);


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(6821),
	    findIndex = __webpack_require__(508);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(463),
	    baseIteratee = __webpack_require__(62),
	    toInteger = __webpack_require__(82);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('flow', __webpack_require__(6891));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('map', __webpack_require__(41));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(6770),
	    hasPath = __webpack_require__(488);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	var baseInRange = __webpack_require__(6771),
	    toFinite = __webpack_require__(285),
	    toNumber = __webpack_require__(207);
	
	/**
	 * Checks if `n` is between `start` and up to, but not including, `end`. If
	 * `end` is not specified, it's set to `start` with `start` then set to `0`.
	 * If `start` is greater than `end` the params are swapped to support
	 * negative ranges.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.3.0
	 * @category Number
	 * @param {number} number The number to check.
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	 * @see _.range, _.rangeRight
	 * @example
	 *
	 * _.inRange(3, 2, 4);
	 * // => true
	 *
	 * _.inRange(4, 8);
	 * // => true
	 *
	 * _.inRange(4, 2);
	 * // => false
	 *
	 * _.inRange(2, 2);
	 * // => false
	 *
	 * _.inRange(1.2, 2);
	 * // => true
	 *
	 * _.inRange(5.2, 4);
	 * // => false
	 *
	 * _.inRange(-3, -2, -6);
	 * // => true
	 */
	function inRange(number, start, end) {
	  start = toFinite(start);
	  if (end === undefined) {
	    end = start;
	    start = 0;
	  } else {
	    end = toFinite(end);
	  }
	  number = toNumber(number);
	  return baseInRange(number, start, end);
	}
	
	module.exports = inRange;


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(140),
	    createAggregator = __webpack_require__(6813);
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The corresponding value of
	 * each key is the last element responsible for generating the key. The
	 * iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * var array = [
	 *   { 'dir': 'left', 'code': 97 },
	 *   { 'dir': 'right', 'code': 100 }
	 * ];
	 *
	 * _.keyBy(array, function(o) {
	 *   return String.fromCharCode(o.code);
	 * });
	 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	 *
	 * _.keyBy(array, 'dir');
	 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	 */
	var keyBy = createAggregator(function(result, value, key) {
	  baseAssignValue(result, key, value);
	});
	
	module.exports = keyBy;


/***/ },
/* 514 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	})));


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ar;
	
	})));


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return az;
	
	})));


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return be;
	
	})));


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bg;
	
	})));


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return bm;
	
	})));


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bn;
	
	})));


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bo;
	
	})));


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	})));


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bs;
	
	})));


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	})));


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	
	    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
	    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return cv;
	
	})));


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	})));


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	})));


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return dv;
	
	})));


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	})));


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enSG = moment.defineLocale('en-SG', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enSG;
	
	})));


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eo;
	
	})));


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	})));


/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eu;
	
	})));


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return fa;
	
	})));


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	})));


/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minuttur',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaður',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	})));


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	})));


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	    var months = [
	        'Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'
	    ];
	
	    var monthsShort = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];
	
	    var weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];
	
	    var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];
	
	    var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné aig] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d mí',
	            y: 'bliain',
	            yy: '%d bliain'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ga;
	
	})));


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	})));


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	})));


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka voran', 'ek vor'],
	            'hh': [number + ' voranim', number + ' voram'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return gu;
	
	})));


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	})));


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return hi;
	
	})));


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hr;
	
	})));


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return id;
	
	})));


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	})));


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var itCh = moment.defineLocale('it-ch', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return itCh;
	
	})));


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return jv;
	
	})));


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	})));


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return kk;
	
	})));


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	})));


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return kn;
	
	})));


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    },
	    months = [
	        'کانونی دووەم',
	        'شوبات',
	        'ئازار',
	        'نیسان',
	        'ئایار',
	        'حوزەیران',
	        'تەمموز',
	        'ئاب',
	        'ئەیلوول',
	        'تشرینی یەكەم',
	        'تشرینی دووەم',
	        'كانونی یەکەم'
	    ];
	
	
	    var ku = moment.defineLocale('ku', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar : {
	            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay : '[به‌یانی كاتژمێر] LT',
	            nextWeek : 'dddd [كاتژمێر] LT',
	            lastDay : '[دوێنێ كاتژمێر] LT',
	            lastWeek : 'dddd [كاتژمێر] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'له‌ %s',
	            past : '%s',
	            s : 'چه‌ند چركه‌یه‌ك',
	            ss : 'چركه‌ %d',
	            m : 'یه‌ك خوله‌ك',
	            mm : '%d خوله‌ك',
	            h : 'یه‌ك كاتژمێر',
	            hh : '%d كاتژمێر',
	            d : 'یه‌ك ڕۆژ',
	            dd : '%d ڕۆژ',
	            M : 'یه‌ك مانگ',
	            MM : '%d مانگ',
	            y : 'یه‌ك ساڵ',
	            yy : '%d ساڵ'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ku;
	
	})));


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кечээ саат] LT',
	            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ky;
	
	})));


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	})));


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	})));


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	})));


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	})));


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return me;
	
	})));


/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	})));


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return mk;
	
	})));


/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	})));


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    return mn;
	
	})));


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return mr;
	
	})));


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ms;
	
	})));


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mt;
	
	})));


/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return my;
	
	})));


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	})));


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ne;
	
	})));


/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	})));


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	})));


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	
	})));


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	})));


/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	})));


/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sl;
	
	})));


/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	})));


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sr;
	
	})));


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	})));


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	})));


/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sw;
	
	})));


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ta;
	
	})));


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return te;
	
	})));


/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	
	})));


/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    return tg;
	
	})));


/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	})));


/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (m === true) {
	            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	
	})));


/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	})));


/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	})));


/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	
	})));


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(6)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 642 */
/***/ function(module, exports) {

	'use strict';
	
	var numberIsNaN = function (value) {
		return value !== value;
	};
	
	module.exports = function is(a, b) {
		if (a === 0 && b === 0) {
			return 1 / a === 1 / b;
		}
		if (a === b) {
			return true;
		}
		if (numberIsNaN(a) && numberIsNaN(b)) {
			return true;
		}
		return false;
	};
	


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(642);
	
	module.exports = function getPolyfill() {
		return typeof Object.is === 'function' ? Object.is : implementation;
	};


/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(645);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(6967);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ },
/* 645 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _all = _interopRequireDefault(__webpack_require__(288));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _Feedback = _interopRequireDefault(__webpack_require__(289));
	
	var _FormCheckInput = _interopRequireDefault(__webpack_require__(6979));
	
	var _FormCheckLabel = _interopRequireDefault(__webpack_require__(6980));
	
	var _FormContext = _interopRequireDefault(__webpack_require__(83));
	
	var _ThemeProvider = __webpack_require__(48);
	
	var defaultProps = {
	  type: 'checkbox',
	  inline: false,
	  disabled: false,
	  isValid: false,
	  isInvalid: false,
	  title: ''
	};
	
	var FormCheck = _react.default.forwardRef(function (_ref, ref) {
	  var id = _ref.id,
	      bsPrefix = _ref.bsPrefix,
	      bsCustomPrefix = _ref.bsCustomPrefix,
	      inline = _ref.inline,
	      disabled = _ref.disabled,
	      isValid = _ref.isValid,
	      isInvalid = _ref.isInvalid,
	      feedback = _ref.feedback,
	      className = _ref.className,
	      style = _ref.style,
	      title = _ref.title,
	      type = _ref.type,
	      label = _ref.label,
	      children = _ref.children,
	      propCustom = _ref.custom,
	      _ref$as = _ref.as,
	      as = _ref$as === void 0 ? 'input' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["id", "bsPrefix", "bsCustomPrefix", "inline", "disabled", "isValid", "isInvalid", "feedback", "className", "style", "title", "type", "label", "children", "custom", "as"]);
	  var custom = type === 'switch' ? true : propCustom;
	
	  var _ref2 = custom ? [bsCustomPrefix, 'custom-control'] : [bsPrefix, 'form-check'],
	      prefix = _ref2[0],
	      defaultPrefix = _ref2[1];
	
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(prefix, defaultPrefix);
	
	  var _useContext = (0, _react.useContext)(_FormContext.default),
	      controlId = _useContext.controlId;
	
	  var innerFormContext = (0, _react.useMemo)(function () {
	    return {
	      controlId: id || controlId,
	      custom: custom
	    };
	  }, [controlId, custom, id]);
	  var hasLabel = label != null && label !== false && !children;
	
	  var input = /*#__PURE__*/_react.default.createElement(_FormCheckInput.default, (0, _extends2.default)({}, props, {
	    type: type === 'switch' ? 'checkbox' : type,
	    ref: ref,
	    isValid: isValid,
	    isInvalid: isInvalid,
	    isStatic: !hasLabel,
	    disabled: disabled,
	    as: as
	  }));
	
	  return /*#__PURE__*/_react.default.createElement(_FormContext.default.Provider, {
	    value: innerFormContext
	  }, /*#__PURE__*/_react.default.createElement("div", {
	    style: style,
	    className: (0, _classnames.default)(className, bsPrefix, custom && "custom-" + type, inline && bsPrefix + "-inline")
	  }, children || /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, input, hasLabel && /*#__PURE__*/_react.default.createElement(_FormCheckLabel.default, {
	    title: title
	  }, label), (isValid || isInvalid) && /*#__PURE__*/_react.default.createElement(_Feedback.default, {
	    type: isValid ? 'valid' : 'invalid'
	  }, feedback))));
	});
	
	FormCheck.displayName = 'FormCheck';
	FormCheck.defaultProps = defaultProps;
	FormCheck.Input = _FormCheckInput.default;
	FormCheck.Label = _FormCheckLabel.default;
	var _default = FormCheck;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var ModalContext = _react.default.createContext({
	  onHide: function onHide() {}
	});
	
	var _default = ModalContext;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _addClass = _interopRequireDefault(__webpack_require__(434));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(437));
	
	var _css = _interopRequireDefault(__webpack_require__(257));
	
	var _scrollbarSize = _interopRequireDefault(__webpack_require__(258));
	
	var _isOverflowing = _interopRequireDefault(__webpack_require__(7004));
	
	var _manageAriaHidden = __webpack_require__(7005);
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	
	    return false;
	  });
	  return idx;
	}
	
	/**
	 * Proper state management for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	var ModalManager = /*#__PURE__*/function () {
	  function ModalManager(_temp) {
	    var _ref = _temp === void 0 ? {} : _temp,
	        _ref$hideSiblingNodes = _ref.hideSiblingNodes,
	        hideSiblingNodes = _ref$hideSiblingNodes === void 0 ? true : _ref$hideSiblingNodes,
	        _ref$handleContainerO = _ref.handleContainerOverflow,
	        handleContainerOverflow = _ref$handleContainerO === void 0 ? true : _ref$handleContainerO;
	
	    this.hideSiblingNodes = void 0;
	    this.handleContainerOverflow = void 0;
	    this.modals = void 0;
	    this.containers = void 0;
	    this.data = void 0;
	    this.scrollbarSize = void 0;
	    this.hideSiblingNodes = hideSiblingNodes;
	    this.handleContainerOverflow = handleContainerOverflow;
	    this.modals = [];
	    this.containers = [];
	    this.data = [];
	    this.scrollbarSize = (0, _scrollbarSize["default"])();
	  }
	
	  var _proto = ModalManager.prototype;
	
	  _proto.isContainerOverflowing = function isContainerOverflowing(modal) {
	    var data = this.data[this.containerIndexFromModal(modal)];
	    return data && data.overflowing;
	  };
	
	  _proto.containerIndexFromModal = function containerIndexFromModal(modal) {
	    return findIndexOf(this.data, function (d) {
	      return d.modals.indexOf(modal) !== -1;
	    });
	  };
	
	  _proto.setContainerStyle = function setContainerStyle(containerState, container) {
	    var style = {
	      overflow: 'hidden'
	    }; // we are only interested in the actual `style` here
	    // because we will override it
	
	    containerState.style = {
	      overflow: container.style.overflow,
	      paddingRight: container.style.paddingRight
	    };
	
	    if (containerState.overflowing) {
	      // use computed style, here to get the real padding
	      // to add our scrollbar width
	      style.paddingRight = parseInt((0, _css["default"])(container, 'paddingRight') || '0', 10) + this.scrollbarSize + "px";
	    }
	
	    (0, _css["default"])(container, style);
	  };
	
	  _proto.removeContainerStyle = function removeContainerStyle(containerState, container) {
	    var style = containerState.style;
	    Object.keys(style).forEach(function (key) {
	      container.style[key] = style[key];
	    });
	  };
	
	  _proto.add = function add(modal, container, className) {
	    var modalIdx = this.modals.indexOf(modal);
	    var containerIdx = this.containers.indexOf(container);
	
	    if (modalIdx !== -1) {
	      return modalIdx;
	    }
	
	    modalIdx = this.modals.length;
	    this.modals.push(modal);
	
	    if (this.hideSiblingNodes) {
	      (0, _manageAriaHidden.hideSiblings)(container, modal);
	    }
	
	    if (containerIdx !== -1) {
	      this.data[containerIdx].modals.push(modal);
	      return modalIdx;
	    }
	
	    var data = {
	      modals: [modal],
	      // right now only the first modal of a container will have its classes applied
	      classes: className ? className.split(/\s+/) : [],
	      overflowing: (0, _isOverflowing["default"])(container)
	    };
	
	    if (this.handleContainerOverflow) {
	      this.setContainerStyle(data, container);
	    }
	
	    data.classes.forEach(_addClass["default"].bind(null, container));
	    this.containers.push(container);
	    this.data.push(data);
	    return modalIdx;
	  };
	
	  _proto.remove = function remove(modal) {
	    var modalIdx = this.modals.indexOf(modal);
	
	    if (modalIdx === -1) {
	      return;
	    }
	
	    var containerIdx = this.containerIndexFromModal(modal);
	    var data = this.data[containerIdx];
	    var container = this.containers[containerIdx];
	    data.modals.splice(data.modals.indexOf(modal), 1);
	    this.modals.splice(modalIdx, 1); // if that was the last modal in a container,
	    // clean up the container
	
	    if (data.modals.length === 0) {
	      data.classes.forEach(_removeClass["default"].bind(null, container));
	
	      if (this.handleContainerOverflow) {
	        this.removeContainerStyle(data, container);
	      }
	
	      if (this.hideSiblingNodes) {
	        (0, _manageAriaHidden.showSiblings)(container, modal);
	      }
	
	      this.containers.splice(containerIdx, 1);
	      this.data.splice(containerIdx, 1);
	    } else if (this.hideSiblingNodes) {
	      // otherwise make sure the next top modal is visible to a SR
	      var _data$modals = data.modals[data.modals.length - 1],
	          backdrop = _data$modals.backdrop,
	          dialog = _data$modals.dialog;
	      (0, _manageAriaHidden.ariaHidden)(false, dialog);
	      (0, _manageAriaHidden.ariaHidden)(false, backdrop);
	    }
	  };
	
	  _proto.isTopModal = function isTopModal(modal) {
	    return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
	  };
	
	  return ModalManager;
	}();
	
	var _default = ModalManager;
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function wrap(e,t,a,r){return"in"in e&&(e.when=e.in),_react2.default.Children.count(r)<2?_react2.default.createElement(_RevealBase2.default,_extends({},e,{inEffect:t,outEffect:a,children:r})):(r=_react2.default.Children.map(r,function(r){return _react2.default.createElement(_RevealBase2.default,_extends({},e,{inEffect:t,outEffect:a,children:r}))}),"Fragment"in _react2.default?_react2.default.createElement(_react2.default.Fragment,null,r):_react2.default.createElement("span",null,r))}Object.defineProperty(exports,"__esModule",{value:!0});var _extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var a=arguments[t];for(var r in a)Object.prototype.hasOwnProperty.call(a,r)&&(e[r]=a[r])}return e};exports.default=wrap;var _react=__webpack_require__(2),_react2=_interopRequireDefault(_react),_RevealBase=__webpack_require__(7008),_RevealBase2=_interopRequireDefault(_RevealBase);module.exports=exports.default;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoDepartamento = function CatalogoDepartamento(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	    var txtBuscar = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        records = _useState6[0],
	        setRecords = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({
	        iddepartamento: '',
	        descripcion: '' }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        values = _useState8[0],
	        setValues = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(-1),
	        _useState10 = _slicedToArray(_useState9, 2),
	        itemSelect = _useState10[0],
	        setItemSelect = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filterFn = _useState12[0],
	        setFilterFn = _useState12[1];
	
	    var headCells = [{ label: 'CODIGO', textAlign: 'center' }, { label: 'DESCRIPCION', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.iddepartamento.includes(target.value) || x.descripcion.toLowerCase().includes(target.value.toLowerCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = 'iddepartamento, trim(descripcion) as descripcion';
	        var nomtab = 'departamento';
	        var orden = 'iddepartamento';
	
	        var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setRecords([]);
	        setValues({
	            iddepartamento: '',
	            descripcion: ''
	        });
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var seleccionarDepartamento = function seleccionarDepartamento() {
	
	        props.onHideAceptaCatalogo(values);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	
	            setValues({
	                iddepartamento: item.iddepartamento,
	                descripcion: item.descripcion
	            });
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	                txtBuscar.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Departamento'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group col-md-6 input-group-sm mb-3' },
	                        _react2.default.createElement('input', { type: 'text',
	                            onChange: handleSearch, className: 'form-control text-uppercase', ref: txtBuscar }),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-info', style: { pointerEvents: 'none' } },
	                            _react2.default.createElement('i', { className: 'fa fa-search' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.iddepartamento === item.iddepartamento ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.iddepartamento
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-start' },
	                                    item.descripcion
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: seleccionarDepartamento },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoDepartamento;

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoFactura = function CatalogoFactura(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtBuscar = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      records = _useState6[0],
	      setRecords = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    idfactura: "",
	    numfactura: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      values = _useState8[0],
	      setValues = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(-1),
	      _useState10 = _slicedToArray(_useState9, 2),
	      itemSelect = _useState10[0],
	      setItemSelect = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      filterFn = _useState12[0],
	      setFilterFn = _useState12[1];
	
	  var headCells = [{ label: "FECHA", textAlign: "center" }, { label: "NÙMERO", textAlign: "center" }, { label: "CEDULA/RIF", textAlign: "center" }, { label: "NOMBRE", textAlign: "center" }, { label: "MONTO TOTAL", textAlign: "center" }, { label: "ESTATUS", textAlign: "center" }];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.numfactura.toLowerCase().includes(target.value.toLowerCase()) || (0, _moment2.default)(x.fecha).format("DD/MM/YYYY").toLowerCase().includes(target.value.toLowerCase()) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.cedularif.toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	
	    var condi = props.tipofactu !== "factuservi" ? "f.tipofactu = " + "'" + 'NO' + "'" : "f.tipofactu != " + "'" + 'NO' + "'";
	    var endpoint = op.conexion + "/api/servicios/seleccionarfactucata?condi=" + condi;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        console.log(response.data);
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setItemSelect("");
	    setActivate(false);
	    setRecords([]);
	    setValues({
	      idfactura: "",
	      numfactura: ""
	    });
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var seleccionarProducto = function seleccionarProducto() {
	    props.onHideAceptaCatalogo(values);
	  };
	
	  var seleccionarFila = function seleccionarFila(item) {
	    return function (e) {
	      e.preventDefault();
	
	      setValues({
	        idfactura: item.idfactura,
	        numfactura: item.numfactura
	      });
	      btnAcepta.current.focus();
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "xl",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        seleccionarRegistros();
	        txtBuscar.current.focus();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Seleccionar Factura"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-6 input-group-sm mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control text-uppercase",
	              ref: txtBuscar
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  style: {
	                    padding: "0",
	                    cursor: "pointer",
	                    background: values.idfactura === item.idfactura ? "lightskyblue" : "white"
	                  },
	                  onClick: seleccionarFila(item)
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  (0, _moment2.default)(item.fecha).format("DD/MM/YYYY")
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.numfactura
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.cedularif
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.nombre
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-end" },
	                  (0, _varios.formatMoneda)(item.totalmonto.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      style: {
	                        fontWeight: "bold",
	                        color: item.status === 0 ? "#007bff" : item.status === 1 ? "#28a745" : item.status === 4 ? "#dc3545" : "#000000"
	                      },
	                      disabled: true,
	                      defaultValue: item.status,
	                      className: "form-select form-select-sm text-uppercase px-1",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "0" },
	                      "PENDIENTE"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "PROCESADO"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "4" },
	                      "ANULADO"
	                    )
	                  )
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          onClick: seleccionarProducto
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoFactura;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoModelo = function CatalogoModelo(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	    var txtBuscar = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        records = _useState6[0],
	        setRecords = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({
	        idmodelo: '',
	        descripcion: '' }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        values = _useState8[0],
	        setValues = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(-1),
	        _useState10 = _slicedToArray(_useState9, 2),
	        itemSelect = _useState10[0],
	        setItemSelect = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filterFn = _useState12[0],
	        setFilterFn = _useState12[1];
	
	    var headCells = [{ label: 'CODIGO', textAlign: 'center' }, { label: 'DESCRIPCION', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.idmodelo.includes(target.value) || x.descripcion.toLowerCase().includes(target.value.toLowerCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = 'idmodelo, trim(descripcion) as descripcion';
	        var nomtab = 'modelo';
	        var orden = 'idmodelo';
	
	        var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setRecords([]);
	        setValues({
	            idmodelo: '',
	            descripcion: ''
	        });
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var seleccionarModelo = function seleccionarModelo() {
	
	        props.onHideAceptaCatalogo(values);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	
	            setValues({
	                idmodelo: item.idmodelo,
	                descripcion: item.descripcion
	            });
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	                txtBuscar.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Modelo'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group col-md-6 input-group-sm mb-3' },
	                        _react2.default.createElement('input', { type: 'text',
	                            onChange: handleSearch, className: 'form-control text-uppercase', ref: txtBuscar }),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-info', style: { pointerEvents: 'none' } },
	                            _react2.default.createElement('i', { className: 'fa fa-search' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.idmodelo === item.idmodelo ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.idmodelo
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-start' },
	                                    item.descripcion
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: seleccionarModelo },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoModelo;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var CatalogoNotaEntregaFacturas = function CatalogoNotaEntregaFacturas(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtBuscar = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      mensajesino = _useState4[0],
	      setMensajesino = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      activate = _useState6[0],
	      setActivate = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      records = _useState8[0],
	      setRecords = _useState8[1];
	
	  var _useState9 = (0, _react.useState)([]),
	      _useState10 = _slicedToArray(_useState9, 2),
	      values = _useState10[0],
	      setValues = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      filterFn = _useState12[0],
	      setFilterFn = _useState12[1];
	
	  var headCells = [{ label: "SELECCIONAR", textAlign: "center" }, { label: "CODIGO", textAlign: "center" }, { label: "N° NOTA ENTREGA", textAlign: "center" }, { label: "FECHA", textAlign: "center" }, { label: "NOMBRE DEL CLIENTE", textAlign: "center" }, { label: "STATUS", textAlign: "center" }];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.idnotaentrega.includes(target.value) || x.numnotaentrega.toLowerCase().includes(target.value.toLowerCase()) || (0, _moment2.default)(x.fecha).format("DD-MM-YYYY").toLowerCase().includes(target.value.toLowerCase()) || x.clientec.toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var endpoint = op.conexion + "/api/registropago/selectnotaentregafactucat";
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setRecords([]);
	    setValues([]);
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	    setSeleccionados([]);
	    setSeleccionadosc([]);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var seleccionarProducto = function seleccionarProducto() {
	    props.onHideAceptaCatalogo(values);
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var handleCloseNo = function handleCloseNo() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var _useState13 = (0, _react.useState)([]),
	      _useState14 = _slicedToArray(_useState13, 2),
	      seleccionados = _useState14[0],
	      setSeleccionados = _useState14[1];
	
	  var _useState15 = (0, _react.useState)([]),
	      _useState16 = _slicedToArray(_useState15, 2),
	      seleccionadosc = _useState16[0],
	      setSeleccionadosc = _useState16[1];
	
	  var handleCheckboxChange = function handleCheckboxChange(item) {
	    return function (e) {
	      var isChecked = e.target.checked;
	      var notaId = item.idnotaentrega;
	      var clienteId = item.idcliente;
	
	      if (isChecked) {
	        if (seleccionados.length > 0 && !seleccionadosc.includes(clienteId)) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "¡Solo puede seleccionar múltiples notas de un mismo Cliente!",
	            icono: "informacion"
	          });
	          return;
	        }
	        setSeleccionados([].concat(_toConsumableArray(seleccionados), [notaId]));
	        if (seleccionados.length === 0) {
	          setSeleccionadosc([clienteId]);
	        }
	        setValues([].concat(_toConsumableArray(values), [{
	          idnota: notaId,
	          idcliente: clienteId,
	          cliente: item.clientec,
	          direccion: item.direccionclientec,
	          rif: item.rifcliente
	        }]));
	      } else {
	        var newSeleccionados = seleccionados.filter(function (id) {
	          return id !== notaId;
	        });
	        setSeleccionados(newSeleccionados);
	
	        setValues(values.filter(function (v) {
	          return v.idnota !== notaId;
	        }));
	
	        var quedanNotasDeEsteCliente = newSeleccionados.some(function (id) {
	          var nota = records.find(function (n) {
	            return n.idnotaentrega === id;
	          });
	          return nota.idcliente === clienteId;
	        });
	
	        if (!quedanNotasDeEsteCliente) {
	          setSeleccionadosc([]);
	        }
	      }
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "xl",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        txtBuscar.current.focus();
	        seleccionarRegistros();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Seleccionar ",
	          props.tipo === "ND" ? "Nota de Debito" : "Precuenta"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, {
	        mensaje: mensajesino,
	        onHideNo: handleCloseNo,
	        onHideSi: handleCloseSi
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-8 input-group-sm mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              ref: txtBuscar,
	              onChange: handleSearch,
	              className: "form-control"
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  style: {
	                    padding: "0"
	                  }
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-check" },
	                    _react2.default.createElement("input", {
	                      className: "form-check-input",
	                      checked: seleccionados.includes(item.idnotaentrega),
	                      onChange: handleCheckboxChange(item),
	                      type: "checkbox",
	                      id: "flexCheckDefault",
	                      disabled: seleccionados.length > 0 && !seleccionados.includes(item.idnotaentrega) && !seleccionadosc.includes(item.idcliente)
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.idnotaentrega
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.numnotaentrega
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  (0, _moment2.default)(item.fecha).format("DD-MM-YYYY")
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.clientec
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.status === 1 ? "PAGADA" : "POR PAGAR"
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          style: { margin: "5px" },
	          onClick: seleccionarProducto
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoNotaEntregaFacturas;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoOrdenCompras = function CatalogoOrdenCompras(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	    var txtBuscar = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(true),
	        _useState6 = _slicedToArray(_useState5, 2),
	        activo = _useState6[0],
	        setActivo = _useState6[1];
	
	    var _useState7 = (0, _react.useState)([]),
	        _useState8 = _slicedToArray(_useState7, 2),
	        records = _useState8[0],
	        setRecords = _useState8[1];
	
	    var _useState9 = (0, _react.useState)({
	        idpedido: '',
	        numpedido: '' }),
	        _useState10 = _slicedToArray(_useState9, 2),
	        values = _useState10[0],
	        setValues = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(-1),
	        _useState12 = _slicedToArray(_useState11, 2),
	        itemSelect = _useState12[0],
	        setItemSelect = _useState12[1];
	
	    var _useState13 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState14 = _slicedToArray(_useState13, 2),
	        filterFn = _useState14[0],
	        setFilterFn = _useState14[1];
	
	    var headCells = [{ label: 'N° ORDEN', textAlign: 'center' }, { label: 'CEDULA/RIF', textAlign: 'center' }, { label: 'NOMBRE', textAlign: 'center' }, { label: 'FECHA', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.codigo.toLowerCase().includes(target.value.toLowerCase()) || (0, _moment2.default)(x.fecha).format('DD/MM/YYYY').toLowerCase().includes(target.value.toLowerCase()) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.cedularif.toLowerCase().includes(target.value.toLowerCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = 'idordendecompra, codigo, fecha, nombre, cedularif';
	        var condicion = props.condicion;
	        var nomtab = 'ordendecompra';
	        var endpoint = void 0;
	        if (props.op === '7') {
	            endpoint = op.conexion + '/api/retenciones/catalogoordencompra?campos=' + campos + '&condicion=' + condicion + '&nomtab=' + nomtab;
	        } else {
	            endpoint = op.conexion + '/api/ordencompra/catalogoordenescompra?campos=' + campos + '&condicion=' + condicion + '&nomtab=' + nomtab;
	        }
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setActivo(true);
	        setRecords([]);
	        setValues({
	            idordendecompra: '',
	            codigo: ''
	        });
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var seleccionarProducto = function seleccionarProducto() {
	
	        props.onHideAceptaCatalogo(values);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	            setActivo(false);
	            setValues({
	                idordendecompra: item.idordendecompra,
	                codigo: item.codigo
	            });
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	                txtBuscar.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Orden de Compra'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group col-md-6 input-group-sm mb-3' },
	                        _react2.default.createElement('input', { type: 'text', ref: txtBuscar,
	                            onChange: handleSearch, className: 'form-control text-uppercase' }),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-info', style: { pointerEvents: 'none' } },
	                            _react2.default.createElement('i', { className: 'fa fa-search' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.idordendecompra === item.idordendecompra ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.codigo
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.cedularif
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-start' },
	                                    item.nombre
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    (0, _moment2.default)(item.fecha).format('DD/MM/YYYY')
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, disabled: activo, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: seleccionarProducto },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoOrdenCompras;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _varios = __webpack_require__(14);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoPlanCuenta = function CatalogoPlanCuenta(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        records = _useState6[0],
	        setRecords = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({
	        idplancuenta: '' }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        values = _useState8[0],
	        setValues = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(-1),
	        _useState10 = _slicedToArray(_useState9, 2),
	        itemSelect = _useState10[0],
	        setItemSelect = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filterFn = _useState12[0],
	        setFilterFn = _useState12[1];
	
	    var headCells = [{ label: 'CODIGO', textAlign: 'center' }, { label: 'DESCRIPCION', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.idmoneda.includes(target.value) || x.descripcion.toLowerCase().includes(target.value.toLowerCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = '*';
	        var nomtab = 'plancuenta';
	        var orden = 'idplancuenta';
	
	        var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setRecords([]);
	        setValues({
	            idmoneda: '',
	            descripcion: '',
	            simbolo: '',
	            predeterminada: false,
	            valormoneda: ''
	        });
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var seleccionarMoneda = function seleccionarMoneda() {
	
	        props.onHideAceptaCatalogo(values);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	            setValues({
	                idplancuenta: item.idplancuenta
	
	            });
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Plan Cuenta'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group col-md-2 input-group-sm mb-3' },
	                        _react2.default.createElement('input', { type: 'text',
	                            onChange: handleSearch, className: 'form-control' }),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-info', style: { pointerEvents: 'none' } },
	                            _react2.default.createElement('i', { className: 'fa fa-search' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.idplancuenta === item.idplancuenta ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.codigocuenta.substring(0, 2) + '-' + item.codigocuenta.substring(2, 5) + '-' + item.codigocuenta.substring(5, 7) + '-' + item.codigocuenta.substring(7, 9) + '-' + item.codigocuenta.substring(9, 12)
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-start' },
	                                    item.descripcion
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: seleccionarMoneda },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoPlanCuenta;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoListRecibosdPagos = function CatalogoListRecibosdPagos(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      records = _useState6[0],
	      setRecords = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    idpago: "",
	    numpago: "",
	    monto: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      values = _useState8[0],
	      setValues = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(-1),
	      _useState10 = _slicedToArray(_useState9, 2),
	      itemSelect = _useState10[0],
	      setItemSelect = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      filterFn = _useState12[0],
	      setFilterFn = _useState12[1];
	
	  var headCells = [{ label: "NÙMERO - RECIBO", textAlign: "center" }, { label: "CEDULA/RIF", textAlign: "center" }, { label: "NOMBRE", textAlign: "center" }, { label: "FECHA", textAlign: "center" }];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.idpago.includes(target.value) || x.numpago.toLowerCase().includes(target.value.toLowerCase()) || (0, _moment2.default)(x.fecha).format("DD/MM/YYYY").toLowerCase().includes(target.value.toLowerCase()) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.rif.toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	
	    var endpoint = "";
	    var tipo = props.tipo;
	
	    endpoint = op.conexion + "/api/consulta/seleccionarrecibodepago?tipo=" + tipo;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setItemSelect("");
	    setActivate(false);
	    setRecords([]);
	    setValues({
	      idpago: "",
	      numpago: "",
	      monto: "",
	      nombre: "",
	      rif: "",
	      tipo: ""
	    });
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var seleccionarAnticipo = function seleccionarAnticipo() {
	    props.onHideAceptaCatalogo(values);
	  };
	
	  var seleccionarFila = function seleccionarFila(item) {
	    return function (e) {
	      e.preventDefault();
	      setValues({
	        idpago: item.idpago,
	        numpago: item.numpago,
	        monto: item.total,
	        nombre: item.nombre,
	        rif: item.rif,
	        tipo: item.tipofac
	      });
	      btnAcepta.current.focus();
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        seleccionarRegistros();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Seleccionar Recibo de Pago"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-8 input-group-sm mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control border-azul border-2"
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  style: {
	                    padding: "0",
	                    cursor: "pointer",
	                    background: values.idpago === item.idpago ? "lightskyblue" : "white"
	                  },
	                  onClick: seleccionarFila(item)
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.numpago
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.rif
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.nombre
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  (0, _moment2.default)(item.fecharegistro).format("DD/MM/YYYY")
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          style: { margin: "5px" },
	          onClick: seleccionarAnticipo
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoListRecibosdPagos;

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoUbicacion = function CatalogoUbicacion(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	    var txtBuscar = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        records = _useState6[0],
	        setRecords = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({
	        idubicacion: '',
	        descripcionubicacion: '',
	        idalmacen: '',
	        ventas: '' }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        values = _useState8[0],
	        setValues = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(-1),
	        _useState10 = _slicedToArray(_useState9, 2),
	        itemSelect = _useState10[0],
	        setItemSelect = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filterFn = _useState12[0],
	        setFilterFn = _useState12[1];
	
	    var headCells = [{ label: 'CODIGO', textAlign: 'center' }, { label: 'DESCRIPCION', textAlign: 'center' }, { label: 'ALMACEN', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.idubicacion.includes(target.value) || x.descripcionubicacion.toLowerCase().includes(target.value.toLowerCase()) || x.idalmacen.includes(target.value)) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = 'idubicacion, trim(descripcionubicacion) as descripcionubicacion, idalmacen, ventas';
	        var nomtab = 'ubicacion';
	        var orden = 'idubicacion';
	
	        var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setRecords([]);
	        setValues({
	            idubicacion: '',
	            descripcionubicacion: '',
	            idalmacen: '',
	            ventas: ''
	        });
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var seleccionarUbicacion = function seleccionarUbicacion() {
	
	        props.onHideAceptaCatalogo(values);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	
	            setValues({
	                idubicacion: item.idubicacion,
	                descripcionubicacion: item.descripcionubicacion,
	                idalmacen: item.idalmacen,
	                ventas: item.ventas
	            });
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	                txtBuscar.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Ubicacion'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group col-md-6 input-group-sm mb-3' },
	                        _react2.default.createElement('input', { type: 'text',
	                            onChange: handleSearch, className: 'form-control text-uppercase', ref: txtBuscar }),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-info', style: { pointerEvents: 'none' } },
	                            _react2.default.createElement('i', { className: 'fa fa-search' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.idubicacion === item.idubicacion ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.idubicacion
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-start' },
	                                    item.descripcionubicacion
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.idalmacen
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: seleccionarUbicacion },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoUbicacion;

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoOrganizacion = function CatalogoOrganizacion(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      records = _useState6[0],
	      setRecords = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    idproducto: "",
	    codigo: "",
	    nombre: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      values = _useState8[0],
	      setValues = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(-1),
	      _useState10 = _slicedToArray(_useState9, 2),
	      itemSelect = _useState10[0],
	      setItemSelect = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      filterFn = _useState12[0],
	      setFilterFn = _useState12[1];
	
	  var headCells = [{ label: "CODIGO", textAlign: "center" }, { label: "NOMBRE", textAlign: "center" }, { label: "RIF", textAlign: "center" }];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.idorganizacion.includes(target.value) || x.rif.toLowerCase().includes(target.value.toLowerCase()) || x.nombre.toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "*";
	    var nomtab = "organizacion";
	    var orden = "idorganizacion";
	
	    var endpoint = op.conexion + "/api/athos/consulta/seleccionarregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setItemSelect("");
	    setActivate(false);
	    setRecords([]);
	    setValues({
	      idproducto: "",
	      codigo: "",
	      nombre: "",
	      preciomax: "",
	      unidadalterna: "",
	      unidadmedida: ""
	    });
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var seleccionarProducto = function seleccionarProducto() {
	    if (values.idorganizacion === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "Debe Seleccionar un Producto.",
	        icono: "informacion"
	      });
	    } else {
	      props.onHideAceptaCatalogo(values);
	    }
	  };
	
	  var seleccionarFila = function seleccionarFila(item) {
	    return function (e) {
	      e.preventDefault();
	
	      setValues({
	        idorganizacion: item.idorganizacion,
	        nombre: item.nombre
	      });
	      btnAcepta.current.focus();
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        seleccionarRegistros();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Seleccionar Organizaci\xF3n"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-2 input-group-sm mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control"
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  style: {
	                    padding: "0",
	                    cursor: "pointer",
	                    background: values.idorganizacion === item.idorganizacion ? "lightskyblue" : "white"
	                  },
	                  onClick: seleccionarFila(item)
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.idorganizacion
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.nombre
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.rif
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          style: { margin: "5px" },
	          onClick: seleccionarProducto
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoOrganizacion;

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _varios = __webpack_require__(14);
	
	var _core = __webpack_require__(19);
	
	var _xlsx = __webpack_require__(160);
	
	var XLSX = _interopRequireWildcard(_xlsx);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileExcelClientes = function FileExcelClientes() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var accbtnactxlsx = JSON.parse(sessionStorage.getItem("accbtnactxlsxc"));
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	
	  var txtFile = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      insertProduct = _useState2[0],
	      setInsertProduct = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      updateProduct = _useState4[0],
	      setUpdateProduct = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mensaje = _useState6[0],
	      setMensaje = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mensajesino = _useState8[0],
	      setMensajesino = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      activate = _useState10[0],
	      setActivate = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      headCells = _useState12[0],
	      setHeadCells = _useState12[1];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var procesarRegistro = function procesarRegistro(operacion, body) {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/agente/actualizarxlsx/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setInsertProduct([]);
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: response.data.contar + " registro creado correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 2) {
	          setUpdateProduct([]);
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: response.data.contar + " registro modificado correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: response.data.contar + " registro eliminado correctamente",
	            icono: "exito"
	          });
	        }
	
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros(productFile) {
	    var campos = "codigo";
	    var nomtab = "producto";
	    var orden = "idproducto";
	    var datos = [];
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          for (var index = 0; index < response.data.length; index++) {
	            datos.push(response.data[index].codigo);
	          }
	          procesarPrecioProd(datos, productFile);
	        } else {
	          setInsertProduct(productFile);
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var updateProcess = function updateProcess() {
	    if (accbtnactxlsx && accbtnactxlsx.toString().substring(1, 2) === "1") {
	      var productos = [];
	      for (var i = 0; i < updateProduct.length; i++) {
	        if (parseInt(updateProduct[i][3]) > 1) {
	          productos.push({
	            idfabricante: _varios.fabricantes[updateProduct[i][0]],
	            codigo: updateProduct[i][1],
	            nombre: updateProduct[i][2],
	            nombrecorto: updateProduct[i][2],
	            ivacompra: updateProduct[i][5],
	            ivaventa: updateProduct[i][5],
	            exento: parseFloat(updateProduct[i][5]) > 0.0 ? false : true,
	            valorfactor: parseInt(updateProduct[i][3]) > 1 ? updateProduct[i][3] : 0.0,
	            tipofactor: parseInt(updateProduct[i][3]) > 1 ? 1 : 0,
	            idunidadmedida: _varios.unidadmedidas[updateProduct[i][11]],
	            idunidadalterna: _varios.unidadmedidas["UNIDAD"],
	            idunidadcompra: _varios.unidadmedidas[updateProduct[i][11]],
	            idunidadventa: _varios.unidadmedidas[updateProduct[i][11]],
	            marca: _varios.marcas[updateProduct[i][12]],
	            idtipoproducto: _varios.tipoproducto[updateProduct[i][13]],
	            modelo: _varios.modelos[updateProduct[i][14]],
	            stockminimo: 1.0,
	            metodocosto: "COSTO PROMEDIO",
	            tipoprecio: "PRECIO POR DEFECTO",
	            almacen: true,
	            servicio: false,
	            idmoneda: "4",
	            costoproveedor: updateProduct[i][4],
	            costocalculado: updateProduct[i][4],
	            ultimocosto: updateProduct[i][4],
	            costopromedio: updateProduct[i][4],
	            utipreciomaxi: (0, _varios.round)(updateProduct[i][8]),
	            utiprecioofe: (0, _varios.round)(updateProduct[i][8]),
	            utipreciomayor: (0, _varios.round)(updateProduct[i][8]),
	            utipreciomini: (0, _varios.round)(updateProduct[i][8]),
	            costoproveedoralter: (0, _varios.round)(updateProduct[i][4] / updateProduct[i][3]),
	            costocalculadoalter: (0, _varios.round)(updateProduct[i][4] / updateProduct[i][3]),
	            ultimocostoalter: (0, _varios.round)(updateProduct[i][4] / updateProduct[i][3]),
	            costopromedioalter: (0, _varios.round)(updateProduct[i][4] / updateProduct[i][3]),
	            utipreciomaxialter: (0, _varios.round)(updateProduct[i][8]),
	            utiprecioofealter: (0, _varios.round)(updateProduct[i][8]),
	            utipreciomayoralter: (0, _varios.round)(updateProduct[i][8]),
	            utipreciominialter: (0, _varios.round)(updateProduct[i][8])
	          });
	        } else {
	          productos.push({
	            idfabricante: _varios.fabricantes[updateProduct[i][0]],
	            codigo: updateProduct[i][1],
	            nombre: updateProduct[i][2],
	            nombrecorto: updateProduct[i][2],
	            ivacompra: updateProduct[i][5],
	            ivaventa: updateProduct[i][5],
	            exento: parseFloat(updateProduct[i][5]) > 0.0 ? false : true,
	            valorfactor: 0.0,
	            tipofactor: 0,
	            idunidadmedida: _varios.unidadmedidas[updateProduct[i][11]],
	            idunidadcompra: _varios.unidadmedidas[updateProduct[i][11]],
	            idunidadventa: _varios.unidadmedidas[updateProduct[i][11]],
	            marca: _varios.marcas[updateProduct[i][12]],
	            idtipoproducto: _varios.tipoproducto[updateProduct[i][13]],
	            modelo: _varios.modelos[updateProduct[i][14]],
	            stockminimo: 1.0,
	            metodocosto: "COSTO PROMEDIO",
	            tipoprecio: "PRECIO POR DEFECTO",
	            almacen: true,
	            servicio: false,
	            idmoneda: "4",
	            costoproveedor: updateProduct[i][4],
	            costocalculado: updateProduct[i][4],
	            ultimocosto: updateProduct[i][4],
	            costopromedio: updateProduct[i][4],
	            utipreciomaxi: (0, _varios.round)(updateProduct[i][8]),
	            utiprecioofe: (0, _varios.round)(updateProduct[i][8]),
	            utipreciomayor: (0, _varios.round)(updateProduct[i][8]),
	            utipreciomini: (0, _varios.round)(updateProduct[i][8])
	          });
	        }
	      }
	      procesarRegistro(2, { productos: JSON.stringify(productos) });
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var insertProcess = function insertProcess() {
	    if (accbtnactxlsx && accbtnactxlsx.toString().substring(1, 2) === "1") {
	      var cliente = [];
	      var datoPer = [];
	
	      for (var i = 0; i < insertProduct.length; i++) {
	        cliente.push({
	          idagente: "0",
	          nombre: insertProduct[i][1],
	          direccion: insertProduct[i][2],
	          tipoper: "1",
	          rif: insertProduct[i][0],
	          reprelegal: insertProduct[i][10] + insertProduct[i][3],
	          telefono: insertProduct[i][5],
	          celular: insertProduct[i][6],
	          email: insertProduct[i][0] + insertProduct[i][4],
	          cliente: true,
	          statuscliente: "51",
	          fechainscripcioncliente: fechasistema,
	          estado: "22",
	          municipio: "22370",
	          ciudad: "2214",
	          islr: "",
	          grupcli: "",
	          agenteretencion: false
	        });
	
	        /*         datoPer.push({
	          apellidos: insertProduct[i][6],
	          cedula: insertProduct[i][3],
	          correoe: insertProduct[i][4],
	          direccion: insertProduct[i][2],
	          fnacimiento: "1990-01-01",
	          nacionalidad: insertProduct[i][9],
	          nombres: insertProduct[i][6],
	          sexo: insertProduct[i][10],
	          tlf1: insertProduct[i][5],
	          tlf2: insertProduct[i][5],
	        }); */
	      }
	
	      var body = {
	        operacionper: 0,
	        agente: cliente,
	        repre: [],
	        client: []
	      };
	
	      procesarRegistro(1, body);
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var handleInputChange = function handleInputChange(e) {
	    if (accbtnactxlsx && accbtnactxlsx.toString().substring(0, 1) === "1") {
	      if (e.target.name === "file" && e.target.files.length > 0) {
	        setActivate(true);
	        setHeadCells([]);
	        setInsertProduct([]);
	        setUpdateProduct([]);
	        var hojas = [];
	        var reader = new FileReader();
	        reader.readAsArrayBuffer(e.target.files[0]);
	        reader.onload = function (e) {
	          var data = new Uint8Array(e.target.result);
	          var workbook = XLSX.read(data, { type: "array" });
	
	          workbook.SheetNames.forEach(function (SheetName) {
	            var objData = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[SheetName]);
	            hojas.push({
	              data: objData,
	              SheetName: SheetName
	            });
	          });
	
	          var titulos = [];
	          var produc = [];
	          var titulo_sigue = false;
	          var produc_sigue = false;
	          var rueda = Object.keys(hojas[0].data[0]);
	          try {
	            for (var i = 0; i < rueda.length; i++) {
	              titulos.push({
	                label: rueda[i].toUpperCase(),
	                textAlign: "center"
	              });
	            }
	            titulo_sigue = true;
	          } catch (error) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Error",
	              texto: "el archivo xlsx esta mal formado",
	              icono: "error"
	            });
	            setActivate(false);
	          }
	
	          try {
	            for (var l = 0; l < hojas[0].data.length; l++) {
	              var obj = {};
	              var array = Object.values(hojas[0].data[l]);
	              for (var k = 0; k < array.length; k++) {
	                obj[k] = array[k];
	              }
	              produc.push(obj);
	            }
	            produc_sigue = true;
	            setActivate(false);
	          } catch (error) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Error",
	              texto: "el archivo xlsx esta mal formado",
	              icono: "error"
	            });
	            setActivate(false);
	          }
	
	          if (titulo_sigue === true && produc_sigue === true) {
	            seleccionarRegistros(produc);
	            setHeadCells(titulos);
	          } else {
	            setHeadCells([]);
	            setInsertProduct([]);
	            setUpdateProduct([]);
	          }
	        };
	      }
	    } else {
	      txtFile.current.value = "";
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var procesarPrecioProd = function procesarPrecioProd(cursorProduct, fileProduct) {
	    var element = fileProduct;
	    var element0 = [];
	    var viejos = [];
	    var nuevos = [];
	
	    for (var i = 0; i < fileProduct.length; i++) {
	      for (var x = 0; x < cursorProduct.length; x++) {
	        if (cursorProduct[x].toString().trim().toUpperCase() === fileProduct[i][1].toString().trim().toUpperCase()) {
	          viejos.push(fileProduct[i][1]);
	          element0.push(fileProduct[i]);
	        }
	      }
	    }
	
	    var _loop = function _loop(_i) {
	      for (var _x = 0; _x < viejos.length; _x++) {
	        if (viejos[_x].toString().trim().toUpperCase() === element[_i][1].toString().trim().toUpperCase()) {
	          element = element.filter(function (value) {
	            return value[1].toString().trim().toUpperCase() !== element[_i][1].toString().trim().toUpperCase();
	          });
	        }
	      }
	    };
	
	    for (var _i = 0; _i < element.length; _i++) {
	      _loop(_i);
	    }
	    nuevos = element;
	
	    setInsertProduct(nuevos);
	    setUpdateProduct(element0);
	    setActivate(false);
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12 py-3 mx-auto card shadow " },
	          _react2.default.createElement(
	            _semanticUiReact.Dimmer,
	            { active: activate, inverted: true },
	            _react2.default.createElement(
	              _semanticUiReact.Loader,
	              { inverted: true },
	              "cargando..."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row col-md-12 mx-auto " },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group input-group-sm mb-2 col-md-12 justify-content-between" },
	              _react2.default.createElement("input", {
	                required: true,
	                type: "file",
	                name: "file",
	                id: "file",
	                ref: txtFile,
	                className: "form-control col-md-3",
	                onChange: handleInputChange,
	                placeholder: "Ingrese Archivo Excel."
	              })
	            ),
	            updateProduct.length > 0 && _react2.default.createElement(
	              "div",
	              { className: "col-md-6 mx-auto mb-3" },
	              _react2.default.createElement(
	                "div",
	                { className: "row col-md-12" },
	                _react2.default.createElement(
	                  "h1",
	                  null,
	                  "PRODUCTOS POR ACTUALIZAR"
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-warning btn-sm rounded-pill col-md-2 mb-3",
	                    onClick: updateProcess
	                  },
	                  " ",
	                  "Actualizar"
	                )
	              ),
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 350,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden" },
	                  updateProduct && updateProduct.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      {
	                        key: index,
	                        style: {
	                          padding: "0",
	                          backgroundColor: "transparent"
	                        }
	                      },
	                      Object.values(item) && Object.values(item).map(function (item2, x) {
	                        return _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            key: x,
	                            className: "align-baseline p-0",
	                            style: {
	                              textAlign: "center",
	                              border: "solid 1px #000000"
	                            }
	                          },
	                          item2
	                        );
	                      })
	                    );
	                  })
	                )
	              )
	            ),
	            insertProduct.length > 0 && _react2.default.createElement(
	              "div",
	              { className: "col-md-6 mx-auto mb-3" },
	              _react2.default.createElement(
	                "div",
	                { className: "row col-md-12" },
	                _react2.default.createElement(
	                  "h1",
	                  null,
	                  "PRODUCTOS POR REGISTRAR"
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-primary btn-sm rounded-pill col-md-2 mb-3",
	                    onClick: insertProcess
	                  },
	                  " ",
	                  "Registrar"
	                )
	              ),
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 350,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden" },
	                  insertProduct && insertProduct.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      {
	                        key: index,
	                        style: {
	                          padding: "0",
	                          backgroundColor: "transparent"
	                        }
	                      },
	                      Object.values(item) && Object.values(item).map(function (item2, x) {
	                        return _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            key: x,
	                            className: "align-baseline p-0",
	                            style: {
	                              textAlign: "center",
	                              border: "solid 1px #000000"
	                            }
	                          },
	                          item2
	                        );
	                      })
	                    );
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = FileExcelClientes;

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CartasAlmacen(props) {
	
	  return _react2.default.createElement(
	    "div",
	    { className: "row d-flex justify-content-between" },
	    _react2.default.createElement(
	      "div",
	      { className: "col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mb-3" },
	      _react2.default.createElement(
	        "div",
	        { className: "card bg-card-info mx-auto", style: { height: '90%', width: '80%' } },
	        _react2.default.createElement(
	          "div",
	          { className: "card-header", style: { height: '80%' } },
	          props.titulo1 !== '' ? props.titulo1 : 'Almacen'
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "card-body bg-light mx-1 mb-1" },
	          _react2.default.createElement(
	            "div",
	            { className: "d-flex justify-content-center px-md-1 pb-2" },
	            _react2.default.createElement(
	              "h1",
	              { className: "text-right" },
	              props.total1 !== '' ? props.total1 : 'Total',
	              " "
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mb-3" },
	      _react2.default.createElement(
	        "div",
	        { className: "card bg-card-info mx-auto", style: { height: '90%', width: '80%' } },
	        _react2.default.createElement(
	          "div",
	          { className: "card-header", style: { height: '80%' } },
	          "Almacen"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "card-body bg-light mx-1 mb-1" },
	          _react2.default.createElement("div", { className: "d-flex justify-content-center px-md-1 pb-2" })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mb-3" },
	      _react2.default.createElement(
	        "div",
	        { className: "card bg-card-info mx-auto", style: { height: '90%', width: '80%' } },
	        _react2.default.createElement(
	          "div",
	          { className: "card-header", style: { height: '80%' } },
	          "Almacen"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "card-body bg-light mx-1 mb-1" },
	          _react2.default.createElement("div", { className: "d-flex justify-content-center px-md-1 pb-2" })
	        )
	      )
	    )
	  );
	}
	
	exports.default = CartasAlmacen;

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GestionarDepartamento = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoDepartamento = __webpack_require__(650);
	
	var _catalogoDepartamento2 = _interopRequireDefault(_catalogoDepartamento);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GestionarDepartamento = exports.GestionarDepartamento = function GestionarDepartamento(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtIdDepartamento = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)('Gestion Departamento.'),
	      _useState2 = _slicedToArray(_useState, 2),
	      tituloHeader = _useState2[0],
	      setTituloHeader = _useState2[1];
	
	  var _useState3 = (0, _react.useState)('visible'),
	      _useState4 = _slicedToArray(_useState3, 2),
	      visibleBtn = _useState4[0],
	      setVisibleBtn = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      body = _useState6[0],
	      setBody = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      activate = _useState8[0],
	      setActivate = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(true),
	      _useState10 = _slicedToArray(_useState9, 2),
	      habilitado = _useState10[0],
	      setHabilitado = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mensaje = _useState12[0],
	      setMensaje = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensajesino = _useState14[0],
	      setMensajesino = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      catalogoDepartamento = _useState16[0],
	      setCatalogoDepartamento = _useState16[1];
	
	  var _useState17 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState18 = _slicedToArray(_useState17, 2),
	      botones = _useState18[0],
	      setBotones = _useState18[1];
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'descripcion') {
	      e.target.value = e.target.value;
	    } else {
	      e.target.value = e.target.value;
	    }
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = 'iddepartamento, trim(descripcion) as descripcion';
	    var nomtab = 'departamento';
	    var nomid = 'iddepartamento';
	    var id = txtIdDepartamento.current.value;
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        txtDescripcion.current.value = '';
	
	        if (response.data !== '') {
	
	          txtDescripcion.current.value = response.data.descripcion.trim();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe un departamento con este codigo', icono: 'informacion' });
	          txtDescripcion.current.value = '';
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var validarDepartamento = function validarDepartamento(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value !== '') {
	
	        seleccionarRegistro();
	      }
	    }
	  };
	
	  var onCatalogoDepartamento = function onCatalogoDepartamento(values) {
	    setCatalogoDepartamento(false);
	    txtIdDepartamento.current.value = values.iddepartamento;
	    txtDescripcion.current.value = values.descripcion;
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	
	    var sigue = true;
	    if (!botones.incluir || !botones.modificar) {
	
	      if (txtDescripcion.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar una descripción', icono: 'informacion' });
	        txtDescripcion.current.focus();
	        sigue = false;
	      }
	    }
	
	    if (sigue) {
	
	      var departamento = [];
	      departamento.push({
	        iddepartamento: txtIdDepartamento.current.value === '' ? 0 : txtIdDepartamento.current.value,
	        descripcion: txtDescripcion.current.value.toUpperCase().trim()
	      });
	
	      setBody({
	        departamento: departamento
	      });
	
	      var msg = '';
	      if (!botones.incluir) {
	        msg = 'Esta Seguro de Registrar estos Datos.';
	      } else if (!botones.modificar) {
	        msg = 'Esta Seguro de Modificar estos Datos.';
	      } else if (!botones.eliminar) {
	        msg = 'Esta Seguro de Eliminar estos Datos.';
	      }
	
	      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + '/api/departamento/actualizar/' + ope;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (ope === 1) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
	        } else if (ope === 2) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
	        } else if (ope === 3) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = '';
	      if (error.response === undefined) {
	        mensaje = 'Error de Conexion';
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
	          mensaje = 'Ya existe un Registro con este rif';
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setTituloHeader('Gestionar Departamento.');
	    setActivate(false);
	    setBody(null);
	    setHabilitado(true);
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      salir: false
	    });
	    txtIdDepartamento.current.setAttribute("disabled", true);
	    txtIdDepartamento.current.value = '';
	    txtDescripcion.current.value = '';
	    setVisibleBtn('visible');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    procesarRegistro();
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      if (op === 1 || op === 2 || op === 3 || op === 4) {
	        setVisibleBtn('collapse');
	      } else if (op === 6) {
	        setVisibleBtn('visible');
	      }
	
	      e.preventDefault();
	
	      if (op === 1) {
	        setTituloHeader('Incluir Departamento.');
	        setHabilitado(false);
	        setBotones({
	          incluir: false,
	          consultar: true,
	          modificar: true,
	          eliminar: true,
	          aceptar: false,
	          cancelar: false,
	          catalogo: true,
	          salir: true
	        });
	        txtIdDepartamento.current.setAttribute("disabled", true);
	        setTimeout(function () {
	          return txtDescripcion.current.focus();
	        }, 200);
	      } else if (op === 2) {
	        setTituloHeader('Editar Departamento.');
	        txtIdDepartamento.current.removeAttribute("disabled");
	        setHabilitado(false);
	        setBotones({
	          incluir: true,
	          consultar: true,
	          modificar: false,
	          eliminar: true,
	          aceptar: false,
	          cancelar: false,
	          catalogo: false,
	          salir: true
	        });
	        txtIdDepartamento.current.focus();
	      } else if (op === 3) {
	        setTituloHeader('Eliminar Departamento.');
	        setHabilitado(true);
	        setBotones({
	          incluir: true,
	          consultar: true,
	          modificar: true,
	          eliminar: false,
	          aceptar: false,
	          cancelar: false,
	          catalogo: false,
	          salir: true
	        });
	        txtIdDepartamento.current.removeAttribute("disabled");
	        txtIdDepartamento.current.focus();
	      } else if (op === 4) {
	        setTituloHeader('Consultar Departamento.');
	        setHabilitado(true);
	        setBotones({
	          incluir: true,
	          consultar: false,
	          modificar: true,
	          eliminar: true,
	          aceptar: true,
	          cancelar: false,
	          catalogo: false,
	          salir: true
	        });
	        txtIdDepartamento.current.removeAttribute("disabled");
	        txtIdDepartamento.current.focus();
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        blanquear();
	      } else if (op === 7) {
	        cancelar();
	      }
	    };
	  };
	
	  var cerrarModal = function cerrarModal() {
	
	    if (props.llamado === 2) {
	      props.onHideRenderizar();
	      props.onHideCancela();
	    }
	
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var imprimirDepartamentos = function imprimirDepartamentos() {
	
	    window.open(op.reportes + "reporte=listDepartamento", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'md',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {}
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        _Modal2.default.Title,
	        { style: { color: "#fff" } },
	        tituloHeader,
	        ' '
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: onBotones(7), className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 mx-auto d-flex justify-content-end' },
	          _react2.default.createElement(
	            'div',
	            { className: 'mb-3 col-md-4' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Fecha: ',
	              _react2.default.createElement(
	                'span',
	                { className: 'fw-bold' },
	                (0, _moment2.default)(fechasistema).format('DD-MM-YYYY'),
	                ' '
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'border-azul col-md-12 py-3 rounded mx-1' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row col-md-12 rounded mx-auto' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-3 col-md-4' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'C\xF3digo:'
	              ),
	              _react2.default.createElement('input', { type: 'text', ref: txtIdDepartamento, disabled: true, onKeyUp: validarDepartamento, onBlur: validarDepartamento, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	              _react2.default.createElement(
	                'button',
	                { disabled: botones.catalogo, type: 'button', onClick: function onClick() {
	                    return setCatalogoDepartamento(true);
	                  }, className: 'btn btn-success' },
	                _react2.default.createElement('i', { className: 'fas fa-search' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-3 col-md-12' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'Descripci\xF3n:'
	              ),
	              _react2.default.createElement('input', { type: 'text', ref: txtDescripcion, name: 'descripcion', autoComplete: 'off', disabled: habilitado, className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onChange: onChange })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm  col-md-12 d-flex justify-content-end' },
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary btn-sm rounded ', onClick: imprimirDepartamentos },
	                _react2.default.createElement('i', { className: 'fas fa-print' })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 mx-auto' },
	        visibleBtn === 'visible' ? _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 mx-auto row justify-content-between', style: { visibility: props.llamado === 2 ? 'collapse' : props.llamado !== 2 ? visibleBtn : 'visible' } },
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.incluir, onClick: onBotones(1), className: 'btn btn-sm mx-1 my-1 col btn-primary rounded-pill', style: { height: '27px' }, title: 'Incluir Departamento' },
	            _react2.default.createElement(
	              'i',
	              { style: { fontSize: '9px' }, className: 'fas fa-plus' },
	              ' Incluir '
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.consultar, onClick: onBotones(4), className: 'btn btn-sm mx-1 my-1 col btn-info rounded-pill', style: { height: '27px' }, title: 'Consultar Departamento' },
	            _react2.default.createElement(
	              'i',
	              { style: { fontSize: '9px' }, className: 'fas fa-eye' },
	              'Consultar'
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.modificar, onClick: onBotones(2), className: 'btn btn-sm mx-1 my-1 col btn-warning rounded-pill', style: { height: '27px' }, title: 'Modificar Departamento' },
	            _react2.default.createElement(
	              'i',
	              { style: { fontSize: '9px' }, className: 'fa fa-edit' },
	              'Modificar'
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.eliminar, onClick: onBotones(3), className: 'btn btn-sm mx-1 my-1 col btn-danger rounded-pill', style: { height: '27px' }, title: 'Eliminar Departamento' },
	            _react2.default.createElement(
	              'i',
	              { style: { fontSize: '9px' }, className: 'fa fa-trash' },
	              'Eliminar'
	            ),
	            ' '
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 row mx-auto justify-content-end', style: { visibility: visibleBtn === 'visible' ? 'collapse' : 'visible' } },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: botones.aceptar, onClick: onBotones(5), style: { height: '27px' }, className: 'btn col-md-3 mx-1 my-1 btn-sm rounded-pill btn-success ' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check-circle', style: { fontSize: '9px' } },
	              '  Aceptar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, disabled: botones.cancelar, onClick: onBotones(6), style: { height: '27px' }, className: 'btn col-md-3 mx-1 my-1 btn-danger btn-sm rounded-pill ' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close', style: { fontSize: '9px' } },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoDepartamento2.default, {
	      show: catalogoDepartamento,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoDepartamento(false);
	      },
	      onHideAceptaCatalogo: onCatalogoDepartamento
	    })
	  );
	};

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GestionarProducto = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _catalogoPersona = __webpack_require__(64);
	
	var _catalogoPersona2 = _interopRequireDefault(_catalogoPersona);
	
	var _mensajes = __webpack_require__(9);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var GestionarProducto = exports.GestionarProducto = function GestionarProducto(props) {
	
	    var headCells = [{ id: '', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'COD.', textAlign: 'center' }, { id: '', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' }, { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }];
	
	    var token = sessionStorage.getItem('jwtToken');
	    var op = __webpack_require__(8);
	    var anio = JSON.parse(sessionStorage.getItem('anioactu'));
	    // const fechaTope = moment(JSON.parse(sessionStorage.getItem('fechasistema'))).format('YYYY-MM-DD').replace(anio.toString(), (anio - 18).toString());
	    var deshabilitado = false;
	
	    /*  variables de referencias */
	    var btnCancela = (0, _react.useRef)();
	    var btnAcepta = (0, _react.useRef)();
	    var txtCodAlmacen = (0, _react.useRef)();
	    var txtDescripcion = (0, _react.useRef)();
	    var cmbAlmacen = (0, _react.useRef)();
	    var txtBuscador = (0, _react.useRef)();
	
	    /*  variables de estados */
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState4 = _slicedToArray(_useState3, 2),
	        mensajesino = _useState4[0],
	        setMensajesino = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(false),
	        _useState6 = _slicedToArray(_useState5, 2),
	        catalogo = _useState6[0],
	        setCatalogo = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(false),
	        _useState8 = _slicedToArray(_useState7, 2),
	        activate = _useState8[0],
	        setActivate = _useState8[1];
	
	    var _useState9 = (0, _react.useState)('0'),
	        _useState10 = _slicedToArray(_useState9, 2),
	        operacion = _useState10[0],
	        setOperacion = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(true),
	        _useState12 = _slicedToArray(_useState11, 2),
	        habilitadoNU = _useState12[0],
	        setHabilitadoNU = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(0),
	        _useState14 = _slicedToArray(_useState13, 2),
	        operacionPer = _useState14[0],
	        setOperacionPer = _useState14[1];
	
	    var _useState15 = (0, _react.useState)('hidden'),
	        _useState16 = _slicedToArray(_useState15, 2),
	        observacion = _useState16[0],
	        setObservacion = _useState16[1];
	
	    var _useState17 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState18 = _slicedToArray(_useState17, 2),
	        filterFn = _useState18[0],
	        setFilterFn = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(),
	        _useState20 = _slicedToArray(_useState19, 2),
	        municipios = _useState20[0],
	        setMunicipios = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(),
	        _useState22 = _slicedToArray(_useState21, 2),
	        ciudades = _useState22[0],
	        setCiudades = _useState22[1];
	
	    var _useState23 = (0, _react.useState)(false),
	        _useState24 = _slicedToArray(_useState23, 2),
	        mostrar = _useState24[0],
	        setMostrar = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(null),
	        _useState26 = _slicedToArray(_useState25, 2),
	        body = _useState26[0],
	        setBody = _useState26[1];
	
	    var _useState27 = (0, _react.useState)([{
	        codigo: 1,
	        nombre: 'JESUS',
	        descripcion: 'ALMACEN 1'
	    }]),
	        _useState28 = _slicedToArray(_useState27, 2),
	        records = _useState28[0],
	        setRecords = _useState28[1];
	
	    var _useState29 = (0, _react.useState)(_defineProperty({
	        cedula: '',
	        correoe: '',
	        tlf1: '',
	        tlf2: '',
	        apellidos: '',
	        direccion: '',
	        fnacimiento: '',
	        nacionalidad: '',
	        nombres: ''
	    }, 'nombres', '')),
	        _useState30 = _slicedToArray(_useState29, 2),
	        values = _useState30[0],
	        setValues = _useState30[1];
	
	    var onChange2 = function onChange2(e) {
	
	        if (e.target.name === 'descripcion') {
	            e.target.value = e.target.value.toUpperCase();
	        }
	    };
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting,
	        TblPagination = _useTable.TblPagination;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	        var st = '';
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") return items;else return items.filter(function (x) {
	                    st = x.status === '51' ? 'activo' : 'inactivo';
	                    if (x.idagente.includes(target.value) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.rif.toLowerCase().includes(target.value.toLowerCase()) || x.nrolicencia.toLowerCase().includes(target.value.toLowerCase()) || st.toLowerCase().includes(target.value.toLowerCase())) {
	                        return x;
	                    }
	                });
	            }
	        });
	    };
	
	    var handleInputNumChange = function handleInputNumChange(event) {
	        event.preventDefault();
	        (0, _varios.validaSoloNumero)(event);
	        var valido;
	        if (event.which === 46) {
	            return false;
	        } else if (event.which >= 48 && event.which <= 57) {
	            return true;
	        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	            return true;
	        } else return false; //alert(e.which);
	    };
	
	    var handleInputMontoChange = function handleInputMontoChange(event) {
	        (0, _varios.validaMonto)(event);
	        if (event.which === 13 || typeof event.which === 'undefined') {
	            if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
	                event.target.value = '0,00';
	            }
	            event.target.value = (0, _varios.formatoMonto)(event.target.value);
	            var char1 = event.target.value.substring(0, 1);
	            var char2 = event.target.value.substring(1, 2);
	            if (char1 === '0' && char2 !== ',') {
	                event.target.value = event.target.value.substring(1, event.target.value.legth);
	            }
	        } else if (event.which === 46) {
	            return false;
	        } else if (event.which >= 48 && event.which <= 57) {
	            return true;
	        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	            return true;
	        } else return false;
	    };
	
	    var onChangeValidar = function onChangeValidar(e) {
	        e.preventDefault();
	
	        var sigue = true;
	        if (operacion === 1 || operacion === 2) {
	
	            if (txtDescripcion.current.value === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar una descripción al Almacen', icono: 'informacion' });
	                txtDescripcion.current.focus();
	                sigue = false;
	            }
	        }
	        if (sigue) {
	
	            var msg = '';
	            if (props.operacion === 1) {
	                msg = 'Esta Seguro de Registrar estos Datos.';
	            } else if (props.operacion === 2) {
	                msg = 'Esta Seguro de Modificar estos Datos.';
	            } else if (props.operacion === 3) {
	                msg = 'Esta Seguro de Eliminar estos Datos.';
	            }
	
	            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	        }
	    };
	
	    var procesarRegistro = function procesarRegistro() {};
	
	    var blanquear = function blanquear() {
	        setActivate(false);
	        setValues({});
	        setOperacion(0);
	    };
	
	    var handleCloseSi = function handleCloseSi() {
	        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        procesarRegistro();
	    };
	
	    var cancelar = function cancelar(e) {
	        setOperacion('0');
	        e.preventDefault();
	        blanquear();
	        props.onHideCancela();
	    };
	
	    var onChange = function onChange(e) {
	
	        if (e.target.name === 'almacen' || e.target.name === 'descripcion') {
	            e.target.value = e.target.value.toUpperCase();
	        }
	        setValues(Object.assign({}, values, _defineProperty({}, e.target.name, e.target.value)));
	    };
	
	    var gestionarExpendedor = function gestionarExpendedor(op, id) {
	        return function (e) {
	
	            setOperacion(op);
	        };
	    };
	
	    var cerrarModal = function cerrarModal() {
	        if (props.llamado === 2) {
	            props.onHideRenderizar();
	            props.onHideCancela();
	        }
	        blanquear();
	        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'md',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {}
	
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                { style: { color: "#fff" } },
	                'Gestionar Tipo Producto.'
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'btn', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            { style: { backgroundColor: "#FFF" } },
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	                onHideNo: function onHideNo() {
	                    return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	                }, onHideSi: handleCloseSi }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'border-azul py-3 rounded' },
	                _react2.default.createElement(
	                    'div',
	                    { style: { fontFamily: 'Times New Roman, Times, serif' } },
	                    operacion.toString() === '0' ? _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 mx-auto' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-12 p-2' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row col-12 d-flex justify-content-between' },
	                                _react2.default.createElement('input', { type: 'text', className: ' col-3 form-control form-control-sm rounded-pill', ref: txtBuscador, onChange: handleSearch, placeholder: 'Buscar' }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-3 d-flex justify-content-end' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { onClick: gestionarExpendedor(1, ''), style: { marginBottom: "5px" }, className: 'btn btn-sm btn-primary rounded-circle' },
	                                        _react2.default.createElement('i', { className: 'fas fa-plus' }),
	                                        ' '
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12', style: { margin: "auto" } },
	                            _react2.default.createElement(
	                                TblContainer,
	                                null,
	                                _react2.default.createElement(TblHead, null),
	                                _react2.default.createElement(
	                                    _core.TableBody,
	                                    null,
	                                    records && recordsAfterPagingAndSorting().map(function (item, index) {
	                                        return _react2.default.createElement(
	                                            _core.TableRow,
	                                            { key: index, style: { padding: "0" } },
	                                            _react2.default.createElement(
	                                                _core.TableCell,
	                                                { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                                                item.codigo
	                                            ),
	                                            _react2.default.createElement(
	                                                _core.TableCell,
	                                                { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center', width: '270px' } },
	                                                item.descripcion
	                                            ),
	                                            _react2.default.createElement(
	                                                _core.TableCell,
	                                                { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    { onClick: gestionarExpendedor(4, item.codigo), className: 'btn btn-sm mx-1 btn-info rounded-circle' },
	                                                    _react2.default.createElement('i', { className: 'fas fa-eye' }),
	                                                    ' '
	                                                ),
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    { onClick: gestionarExpendedor(2, item.codigo), className: 'btn btn-sm mx-1 btn-warning rounded-circle' },
	                                                    _react2.default.createElement('i', { className: 'fa fa-edit' }),
	                                                    ' '
	                                                ),
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    { onClick: gestionarExpendedor(3, item.codigo), className: 'btn btn-sm mx-1 btn-danger rounded-circle' },
	                                                    _react2.default.createElement('i', { className: 'fa fa-trash' }),
	                                                    ' '
	                                                )
	                                            )
	                                        );
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(TblPagination, null)
	                        )
	                    ) : _react2.default.createElement(
	                        'div',
	                        { className: 'row rounded mx-auto justify-content-between' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-3' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'C\xF3digo:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', ref: txtCodAlmacen, disabled: true, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-3 d-flex justify-content-end' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-sm mx-1 btn-primary rounded-pill', onClick: gestionarExpendedor(0, ''), style: { height: '27px' }, title: 'Volver a la Tabla' },
	                                _react2.default.createElement(
	                                    'i',
	                                    { style: { fontSize: '9px' }, className: 'fas fa-long-arrow-alt-left' },
	                                    ' Volver '
	                                ),
	                                ' '
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-12' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Nombre:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', ref: txtDescripcion, name: 'descripcion', className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onChange: onChange2 })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-11 mx-auto row d-flex justify-content-end px-2' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-8 py-1 row border-azul rounded' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'col', style: { fontSize: '15px' } },
	                                    'Producto Informatico'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-check col-md-12' },
	                                        _react2.default.createElement('input', { className: 'form-check-input', type: 'radio', name: 'flexRadioDefault', id: 'flexRadioDefault1' }),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'form-check-label py-1', 'for': 'flexRadioDefault1' },
	                                            'Si'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-check col-md-12' },
	                                        _react2.default.createElement('input', { className: 'form-check-input', type: 'radio', name: 'flexRadioDefault', id: 'flexRadioDefault1' }),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'form-check-label py-1', 'for': 'flexRadioDefault1' },
	                                            'No'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, disabled: operacion === 4 ? true : false, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-success ' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    '  Aceptar'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill ' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _varios = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GenerarBackup = function GenerarBackup(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var organizacion = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var cmbBaseDatos = (0, _react.useRef)();
	  var cmbFormato = (0, _react.useRef)();
	  var cmbTipo = (0, _react.useRef)();
	
	  var headCells = [{ label: "NOMBRE", textAlign: "center", with: 300 }, { label: "TAMAÑO", textAlign: "center", with: 100 }, { label: "FECHA", textAlign: "center", with: 100 }, { label: "DESCARGAR", textAlign: "center", with: 50 }, { label: "ELIMINAR", textAlign: "center", with: 50 }];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      lista = _useState2[0],
	      setLista = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      directorios = _useState4[0],
	      setDirectorios = _useState4[1];
	
	  var _useState5 = (0, _react.useState)("visible"),
	      _useState6 = _slicedToArray(_useState5, 2),
	      visibleBtn = _useState6[0],
	      setVisibleBtn = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      body = _useState8[0],
	      setBody = _useState8[1];
	
	  var _useState9 = (0, _react.useState)([]),
	      _useState10 = _slicedToArray(_useState9, 2),
	      baseDatos = _useState10[0],
	      setBaseDatos = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(true),
	      _useState12 = _slicedToArray(_useState11, 2),
	      habilitado = _useState12[0],
	      setHabilitado = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensaje = _useState14[0],
	      setMensaje = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mensajesino = _useState16[0],
	      setMensajesino = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      activate = _useState18[0],
	      setActivate = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({
	    incluir: false,
	    aceptar: true,
	    cancelar: true
	  }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      botones = _useState20[0],
	      setBotones = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(),
	      _useState22 = _slicedToArray(_useState21, 2),
	      database = _useState22[0],
	      setDataBase = _useState22[1];
	
	  var onChangeSelect = function onChangeSelect(e) {
	    if (e.target.value === "") {
	      setDataBase();
	    } else {
	      setDataBase(baseDatos[parseInt(e.target.value)]);
	      getFTP(baseDatos[parseInt(e.target.value)].nombre);
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	    if (!botones.incluir) {
	      if (cmbBaseDatos.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "debe seleccionar una base de datos",
	          icono: "informacion"
	        });
	        sigue = false;
	        cmbBaseDatos.current.focus();
	      }
	    }
	
	    if (lista.length >= 5) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "ya alcanzo el limite de respaldos, debe eliminar uno de los archivos para poder generar uno nuevo.",
	        icono: "informacion"
	      });
	      sigue = false;
	    }
	
	    if (sigue) {
	      setBody({
	        database: database,
	        formato: cmbFormato.current.value,
	        tipo: cmbTipo.current.value,
	        fechasistema: (0, _moment2.default)(fechaSistema).format("DD-MM-YYYY")
	      });
	
	      var msg = "";
	      if (!botones.incluir) {
	        msg = "Esta Seguro de Generar el Respaldo.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/athos/base/backup";
	
	    _axios2.default.post(endpoint, body, {
	      responseType: "arraybuffer",
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      getFTP(database.nombre);
	      /*         const url = window.URL.createObjectURL(new Blob([response.data]));
	      const link = document.createElement("a");
	      link.href = url;
	      link.setAttribute(
	        "download",
	        `${database.nombre}-${body.fechasistema}.${body.tipo}`
	      );
	      document.body.appendChild(link);
	      link.click();
	      document.body.removeChild(link); */
	      setMensaje({
	        mostrar: true,
	        titulo: "Exito.",
	        texto: "Proceso ejecutado correctamente",
	        icono: "exito"
	      });
	    }).catch(function (error) {
	      console.error(error);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: "Error Al Crear El Respaldo",
	        icono: "error"
	      });
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var seleccionarBasedeDatos = function seleccionarBasedeDatos() {
	    var campos = "*";
	    var nomtab = "basedatos";
	    var nomid = "nombre";
	    var orden = "idbasedatos";
	    var endpoint = "";
	    if (props.menu === "sistema") {
	      endpoint = op.conexion + "/api/athos/consulta/seleccionarregistros?campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	    }
	    if (props.menu === "organizacion") {
	      endpoint = op.conexion + "/api/athos/consulta/modelirows?&campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + organizacion.toLowerCase();
	    }
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setBaseDatos(response.data);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    }).finally(function () {
	      return setActivate(false);
	    });
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op !== 6) {
	        setVisibleBtn("hidden");
	      } else {
	        setVisibleBtn("visible");
	      }
	
	      if (op === 1) {
	        setHabilitado(false);
	        setBotones({
	          incluir: false,
	          aceptar: false,
	          cancelar: false
	        });
	        cmbBaseDatos.current.focus();
	      } else if (op === 5) {
	        onChangeValidar();
	      } /* else if (op === 6) {
	        blanquear();
	        } */
	    };
	  };
	
	  /*   const blanquear = () => {
	    if (props.menu === "sistema") {
	      cmbBaseDatos.current.value = "";
	    }
	     setActivate(false);
	    setBody(null);
	    setHabilitado(true);
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    setVisibleBtn("visible");
	    setBotones({
	      incluir: false,
	      aceptar: true,
	      cancelar: true,
	    });
	  };
	  */
	  var getFTP = function getFTP(folder) {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/athos/base/listar?dir=backup/" + folder.toUpperCase();
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setLista(response.data);
	      }
	    }).catch(function (error) {
	      console.log(error);
	    }).finally(function () {
	      return setActivate(false);
	    });
	  };
	
	  var getDescargar = function getDescargar(ruta, file) {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/athos/base/descargar?ruta=" + ruta + "&archivo=" + file;
	    _axios2.default.get(endpoint, {
	      responseType: "arraybuffer",
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      var url = window.URL.createObjectURL(new Blob([response.data]));
	      var link = document.createElement("a");
	      link.href = url;
	      link.setAttribute("download", "" + file);
	      document.body.appendChild(link);
	      link.click();
	      document.body.removeChild(link);
	    }).catch(function (error) {
	      console.error(error);
	    }).finally(function () {
	      return setActivate(false);
	    });
	  };
	
	  var eliminar = function eliminar(ruta) {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/athos/base/eliminar?ruta=" + ruta;
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        getFTP(database.nombre);
	        setMensaje({
	          mostrar: true,
	          titulo: "Exito.",
	          texto: response.data,
	          icono: "exito"
	        });
	      }
	    }).catch(function (error) {
	      console.error(error);
	    }).finally(function () {
	      return setActivate(false);
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarBasedeDatos();
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    for (var i = 0; i < baseDatos.length; i++) {
	      if (organizacion === baseDatos[i].nombre.toUpperCase()) {
	        cmbBaseDatos.current.value = i;
	        setDataBase(baseDatos[i]);
	        getFTP(organizacion);
	      }
	    }
	  }, [baseDatos]);
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "col-md-12 mx-auto row" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12 py-2 row card" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12 mx-auto rounded py-2  border-azul " },
	          _react2.default.createElement(
	            "div",
	            { className: " row rounded px-0 d-flex justify-content-between" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-3 input-group-sm col-sm-3" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "Base de Datos:"
	              ),
	              _react2.default.createElement(
	                "select",
	                {
	                  className: "form-select",
	                  "aria-label": "Default select example col-md-3",
	                  name: "conexion"
	                  /*      disabled={habilitado} */
	                  , ref: cmbBaseDatos,
	                  defaultValue: organizacion,
	                  onChange: onChangeSelect
	                },
	                baseDatos && baseDatos.map(function (item, index) {
	                  return _react2.default.createElement(
	                    "option",
	                    { key: index, value: index },
	                    item.nombre.toUpperCase()
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-3 input-group-sm col-sm-3" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "FORMATO:"
	              ),
	              _react2.default.createElement(
	                "select",
	                {
	                  className: "form-select",
	                  "aria-label": "Default select example col-md-4",
	                  name: "formato"
	                  /*   disabled={habilitado} */
	                  , ref: cmbFormato
	                },
	                _react2.default.createElement(
	                  "option",
	                  { value: "c" },
	                  "CUSTOM"
	                ),
	                _react2.default.createElement(
	                  "option",
	                  { value: "p" },
	                  "PLAIN"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-3 input-group-sm col-sm-3" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "TIPO:"
	              ),
	              _react2.default.createElement(
	                "select",
	                {
	                  className: "form-select",
	                  "aria-label": "Default select example col-md-4",
	                  name: "tipo"
	                  /*       disabled={habilitado} */
	                  , ref: cmbTipo
	                },
	                _react2.default.createElement(
	                  "option",
	                  { value: "backup" },
	                  "BACKUP"
	                ),
	                _react2.default.createElement(
	                  "option",
	                  { value: "sql" },
	                  "SQL"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-sm-3" },
	              _react2.default.createElement(
	                "button",
	                {
	                  disabled: botones.incluir,
	                  onClick: onBotones(5),
	                  className: "btn btn-sm mx-1 btn-primary rounded-pill",
	                  style: { height: "27px" },
	                  title: "Generar Respaldo"
	                },
	                _react2.default.createElement(
	                  "i",
	                  { style: { fontSize: "9px" }, className: "fas fa-plus" },
	                  " ",
	                  "Generar Respaldo"
	                ),
	                " "
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 mt-2 d-flex justify-content-end" },
	
	            /* visibleBtn === "visible" ?  */_react2.default.createElement("div", {
	              className: "col-md-12 d-flex justify-content-start"
	              /* style={{ visibility: visibleBtn }} */
	            }) /* : (
	               <div
	               className="col-md-5 d-flex justify-content-end"
	               style={{
	               visibility: visibleBtn === "visible" ? "hidden" : "visible",
	               }}
	               >
	               <button
	               disabled={botones.aceptar}
	               onClick={onBotones(5)}
	               ref={btnAcepta}
	               style={{ height: "27px" }}
	               className="mx-2 btn btn-sm rounded-pill btn-success"
	               >
	               <i
	               className="fas fa-check-circle"
	               style={{ fontSize: "9px" }}
	               >
	               {" "}
	               Aceptar
	               </i>
	               </button>
	               <button
	               disabled={botones.cancelar}
	               onClick={onBotones(6)}
	               ref={btnCancela}
	               style={{ height: "27px" }}
	               className="mx-2 btn btn-danger btn-sm rounded-pill"
	               >
	               <i
	               className="fas fa-window-close"
	               style={{ fontSize: "9px" }}
	               >
	               {" "}
	               Cancelar
	               </i>
	               </button>
	               </div>
	               ) */
	
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12" },
	        _react2.default.createElement(
	          TblContainer,
	          {
	            container: {
	              maxHeight: 300,
	              minHeight: 300,
	              width: "100%",
	              overflow: "auto"
	            }
	          },
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            lista && lista.map(function (item, index) {
	              return _react2.default.createElement(
	                "tr",
	                {
	                  style: {
	                    cursor: "pointer"
	                  },
	                  key: index,
	                  onClick: function onClick() {
	                    if (item.type === "dir") {
	                      var dire = directorios;
	                      dire.push(item.route);
	                      setDirectorios(dire);
	                      getFTP(item.route);
	                    } /* else {
	                              getDescargar(item.route, item.name);
	                            } */
	                  }
	                },
	                _react2.default.createElement(
	                  "td",
	                  {
	                    className: "align-baseline letra-tabla-td text-start",
	                    style: { width: 100 }
	                  },
	                  item.type === "dir" ? _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-folder" },
	                    " " + item.name
	                  ) : item.name
	                ),
	                _react2.default.createElement(
	                  "td",
	                  {
	                    className: "align-baseline letra-tabla-td text-right",
	                    style: { width: 40 }
	                  },
	                  (0, _varios.formatBytes)(item.size)
	                ),
	                _react2.default.createElement(
	                  "td",
	                  {
	                    className: "align-baseline letra-tabla-td text-center",
	                    style: { width: 100 }
	                  },
	                  (0, _moment2.default)(item.date).format("DD-MM-YYYY")
	                ),
	                _react2.default.createElement(
	                  "td",
	                  {
	                    className: "align-baseline letra-tabla-td text-center",
	                    style: { width: 10 }
	                  },
	                  item.type !== "dir" && _react2.default.createElement(
	                    "button",
	                    {
	                      className: "btn btn-sm  btn-info rounded-circle ml-2",
	                      onClick: function onClick() {
	                        return getDescargar(item.route, item.name);
	                      }
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-download" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  {
	                    className: "align-baseline letra-tabla-td text-center",
	                    style: { width: 10 }
	                  },
	                  item.type !== "dir" && _react2.default.createElement(
	                    "button",
	                    {
	                      className: "btn btn-sm  btn-danger rounded-circle ml-2",
	                      onClick: function onClick() {
	                        return eliminar(item.route);
	                      }
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-trash" })
	                  )
	                )
	              );
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = GenerarBackup;

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActualizarPersona = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mensajes = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActualizarPersona = exports.ActualizarPersona = function ActualizarPersona(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      activate = _useState2[0],
	      setActivate = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = _slicedToArray(_useState3, 2),
	      msg = _useState4[0],
	      setMsg = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      deshabilitado = _useState6[0],
	      setDeshabilitado = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      operacion = _useState8[0],
	      setOperacion = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({
	    cedula: "",
	    nombres: "",
	    apellidos: "",
	    direccion: "",
	    correoe: "",
	    tlf1: "",
	    tlf2: "",
	    fnacimiento: "",
	    nacionalidad: "",
	    sexo: ""
	  }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      persona = _useState10[0],
	      setPersona = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(),
	      _useState12 = _slicedToArray(_useState11, 2),
	      tecla = _useState12[0],
	      setTecla = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(sessionStorage.getItem("fechasistema")),
	      _useState14 = _slicedToArray(_useState13, 2),
	      fechaSistema = _useState14[0],
	      setFechaSistema = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mensaje = _useState16[0],
	      setMensaje = _useState16[1];
	
	  var _useState17 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState18 = _slicedToArray(_useState17, 2),
	      mensajesino = _useState18[0],
	      setMensajesino = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({}),
	      _useState20 = _slicedToArray(_useState19, 2),
	      body = _useState20[0],
	      setBody = _useState20[1];
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var txtCedula = (0, _react.useRef)();
	  var txtNombre = (0, _react.useRef)();
	  var txtApellido = (0, _react.useRef)();
	  var txtDireccion = (0, _react.useRef)();
	  var txtEmail = (0, _react.useRef)();
	  var txtTlf = (0, _react.useRef)();
	  var txtCel = (0, _react.useRef)();
	  var txtFechaNac = (0, _react.useRef)();
	  var cmbNacionalidad = (0, _react.useRef)();
	  var cmbSexo = (0, _react.useRef)();
	
	  (0, _react.useEffect)(function () {
	    var obj = JSON.parse(sessionStorage.getItem("post"));
	    setFechaSistema(obj.fechasistema);
	
	    if (props.operacion) {
	      setOperacion(props.operacion);
	    }
	  }, [props.operacion]);
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	    var sigue = true;
	    var mensaje = "";
	    if (txtCedula.current.value.trim() === "") {
	      mensaje = "La cedula no debe estar vacia";
	      sigue = false;
	      txtCedula.current.focus();
	    } else if (txtCedula.current.value.trim().length > 8) {
	      mensaje = "La cedula no debe exceder los 8 caracteres";
	      sigue = false;
	      txtCedula.current.focus();
	    } else if (txtNombre.current.value.trim() === "") {
	      mensaje = "Los nombres no deben estar vacios";
	      sigue = false;
	      txtNombre.current.focus();
	    } else if (txtApellido.current.value.trim() === "") {
	      mensaje = "Los Apellidos no deben estar vacio";
	      sigue = false;
	      txtApellido.current.focus();
	    } else if (txtDireccion.current.value.trim() === "") {
	      mensaje = "La direccion del  no debe estar vacia";
	      sigue = false;
	      txtDireccion.current.focus();
	    } else if (txtFechaNac.current.value.trim() === "") {
	      mensaje = "La fecha de nacimiento no debe estar vacia";
	      sigue = false;
	      txtFechaNac.current.focus();
	    }
	
	    if (sigue) {
	      var datoPer = [];
	      datoPer.push({
	        apellidos: txtApellido.current.value.trim().toUpperCase(),
	        cedula: txtCedula.current.value,
	        correoe: txtEmail.current.value,
	        direccion: txtDireccion.current.value.trim().toUpperCase(),
	        fnacimiento: txtFechaNac.current.value.toUpperCase(),
	        nacionalidad: cmbNacionalidad.current.value,
	        nombres: txtNombre.current.value.trim().toUpperCase(),
	        sexo: cmbSexo.current.value,
	        tlf1: txtTlf.current.value,
	        tlf2: txtCel.current.value
	      });
	      setPersona(datoPer);
	      var _body = {
	        cedula: txtCedula.current.value,
	        correoe: txtEmail.current.value,
	        tlf1: txtTlf.current.value,
	        tlf2: txtCel.current.value,
	        apellidos: txtApellido.current.value.trim(),
	        direccion: txtDireccion.current.value.trim(),
	        fnacimiento: txtFechaNac.current.value,
	        nacionalidad: cmbNacionalidad.current.value,
	        nombres: txtNombre.current.value.trim(),
	        sexo: cmbSexo.current.value
	      };
	      setBody(_body);
	      var _msg = "";
	      if (props.operacion === 1) {
	        _msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (props.operacion === 2) {
	        _msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (props.operacion === 3) {
	        _msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: _msg,
	        icono: "confirmacion"
	      });
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: mensaje,
	        icono: "informacion"
	      });
	    }
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	
	    props.onHideCancela();
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    var endpoint = op.conexion + "/api/personas/actualizarpersona/" + operacion;
	
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setActivate(false);
	        var mensaje = "";
	        if (operacion === 1) {
	          mensaje = "La Persona " + txtCedula.current.value + " ha sido registrada de manera satisfactoria.";
	        } else if (operacion === 2) {
	          mensaje = "La Persona " + txtCedula.current.value + " ha sido modificada de manera satisfactoria.";
	        } else if (operacion === 3) {
	          mensaje = "La Persona " + txtCedula.current.value + " ha sido eliminada de manera satisfactoria.";
	        }
	
	        setMensaje({
	          mostrar: true,
	          titulo: "Exito.",
	          texto: mensaje,
	          icono: "exito"
	        });
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var validarPersona = function validarPersona(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        setTecla(event.which);
	      } else {
	        txtNombre.current.value = "";
	      }
	    }
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    if (event.which === 13) {
	      var valido;
	      if (event.target.id === "inputNombres") {
	        txtApellido.current.focus();
	      } else if (event.target.id === "inputApellidos") {
	        txtDireccion.current.focus();
	      } else if (event.target.id === "inputDireccion") {
	        txtEmail.current.focus();
	      } else if (event.target.id === "inputEmail") {
	        valido = (0, _varios.validaEmail)(event.target.value);
	        if (valido) {
	          txtTlf.current.focus();
	        } else {
	          if (event.target.value !== "") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "Formato de Email invalido.",
	              icono: "informacion"
	            });
	            event.target.value = "";
	          } else {
	            txtTlf.current.focus();
	          }
	        }
	      } else if (event.target.id === "inputTlf") {
	        txtCel.current.focus();
	      } else if (event.target.id === "inputCel") {
	        txtFechaNac.current.focus();
	      } else if (event.target.id === "inputFechaNac") {
	        cmbNacionalidad.current.focus();
	      }
	    } else if (typeof event.which === "undefined") {
	      if (event.target.id === "inputEmail") {
	        valido = (0, _varios.validaEmail)(event.target.value);
	        if (valido) {
	          txtTlf.current.focus();
	        } else {
	          if (event.target.value !== "") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "Formato de número telefonico invalido.",
	              icono: "informacion"
	            });
	            event.target.value = "";
	          } else {
	            txtTlf.current.focus();
	          }
	        }
	      } else if (event.target.id === "inputTlf") {
	        txtCel.current.focus();
	      } else if (event.target.id === "inputCel") {
	        txtFechaNac.current.focus();
	      } else {
	        return false;
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    props.onHideAcepta();
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        setOperacion(props.operacion);
	        setDeshabilitado(props.deshabilitado);
	        btnAcepta.current.focus();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          operacion === 1 ? "Agregar Persona." : operacion === 2 ? "Editar Persona." : operacion === 3 ? "Eliminar Persona." : "Consultar Persona."
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "container-fluid bg-light rounded" },
	        _react2.default.createElement(
	          "div",
	          { className: "container row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group py-1 input-group-sm col-sm-3" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "Nacionalidad:"
	            ),
	            _react2.default.createElement(
	              "select",
	              {
	                className: "form-select",
	                disabled: deshabilitado,
	                ref: cmbNacionalidad,
	                style: { maxWidth: 70 },
	                "aria-label": "Default select example ",
	                defaultValue: props.persona && props.persona.nacionalidad !== null ? props.persona.nacionalidad.trim() : "",
	                id: "inputNac"
	              },
	              _react2.default.createElement(
	                "option",
	                { value: "V" },
	                "V"
	              ),
	              _react2.default.createElement(
	                "option",
	                { value: "E" },
	                "E"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group py-1 input-group-sm col-sm-4" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "Cedula:"
	            ),
	            _react2.default.createElement("input", {
	              type: "text",
	              className: "form-control",
	              maxLength: 8,
	              style: { maxWidth: 80 },
	              autoComplete: "off",
	              disabled: operacion === 2 ? true : deshabilitado,
	              ref: txtCedula,
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm",
	              defaultValue: props.persona ? props.persona.cedula : "",
	              id: "inputCedula",
	              onKeyUp: validarPersona,
	              onBlur: validarPersona
	            })
	          ),
	          _react2.default.createElement("div", { className: "col-sm-8" })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group py-1 input-group-sm col-sm-6" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "Nombres:"
	            ),
	            _react2.default.createElement("input", {
	              type: "text",
	              className: "form-control uppercase",
	              disabled: deshabilitado,
	              ref: txtNombre,
	              autoComplete: "off",
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm",
	              defaultValue: props.persona ? props.persona.nombres.trim() : "",
	              id: "inputNombres"
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group py-1 input-group-sm col-sm-6" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "Apellidos:"
	            ),
	            _react2.default.createElement("input", {
	              type: "text",
	              className: "form-control uppercase",
	              disabled: deshabilitado,
	              ref: txtApellido,
	              autoComplete: "off",
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm",
	              defaultValue: props.persona ? props.persona.apellidos.trim() : "",
	              id: "inputApellidos"
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group py-1 input-group-sm col-sm-12" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "Direccion:"
	            ),
	            _react2.default.createElement("input", {
	              type: "text",
	              className: "form-control uppercase",
	              disabled: deshabilitado,
	              ref: txtDireccion,
	              autoComplete: "off",
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm",
	              defaultValue: props.persona ? props.persona.direccion.trim() : "",
	              id: "inputDireccion"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group py-1 input-group-sm col-sm-6" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "E-mail:"
	            ),
	            _react2.default.createElement("input", {
	              type: "text",
	              className: "form-control uppercase",
	              disabled: deshabilitado,
	              ref: txtEmail,
	              autoComplete: "off",
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm",
	              defaultValue: props.persona ? props.persona.correoe : "",
	              id: "inputEmail"
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group py-1 input-group-sm col-sm-3" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "Telefono:"
	            ),
	            _react2.default.createElement("input", {
	              type: "text",
	              className: "form-control",
	              disabled: deshabilitado,
	              maxLength: 11,
	              onChange: _varios.validaSoloNumero,
	              ref: txtTlf,
	              autoComplete: "off",
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm",
	              defaultValue: props.persona ? props.persona.tlf1 : "",
	              id: "inputTlf"
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group py-1 input-group-sm col-sm-3" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "Celular:"
	            ),
	            _react2.default.createElement("input", {
	              type: "text",
	              className: "form-control",
	              disabled: deshabilitado,
	              ref: txtCel,
	              maxLength: 11,
	              autoComplete: "off",
	              onChange: _varios.validaSoloNumero,
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm",
	              defaultValue: props.persona ? props.persona.tlf2 : "",
	              id: "inputCel"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group py-1 input-group-sm col-sm-4" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "Fecha Nacimiento:"
	            ),
	            _react2.default.createElement("input", {
	              type: "date",
	              className: "form-control",
	              disabled: deshabilitado,
	              ref: txtFechaNac,
	              autoComplete: "off",
	              max: (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD"),
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm",
	              defaultValue: props.persona ? (0, _moment2.default)(props.persona.fnacimiento).format("YYYY-MM-DD") : "",
	              id: "inputFnac"
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group py-1 input-group-sm col-sm-4" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "Sexo:"
	            ),
	            _react2.default.createElement(
	              "select",
	              {
	                className: "form-select",
	                disabled: deshabilitado,
	                ref: cmbSexo,
	                style: { maxWidth: 70 },
	                "aria-label": "Default select example ",
	                defaultValue: props.persona ? props.persona.sexo.trim() : "",
	                id: "inputSexo"
	              },
	              _react2.default.createElement(
	                "option",
	                { key: "0", value: "M" },
	                "M"
	              ),
	              _react2.default.createElement(
	                "option",
	                { key: "1", value: "F" },
	                "F"
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          type: "button",
	          ref: btnAcepta,
	          onClick: onChangeValidar,
	          disabled: operacion === 4 ? true : false,
	          style: { margin: "1px" },
	          className: "col-sm-2 btn btn-success btn-sm rounded-pill"
	        },
	        _react2.default.createElement("i", { className: "far fa-check-circle" }),
	        "Aceptar"
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          type: "button",
	          ref: btnCancela,
	          onClick: cancelar,
	          style: { margin: "1px" },
	          className: "col-sm-2 btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement("i", { className: "fas fa-window-close" }),
	        "Cancelar"
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CambiarClaveApp = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _varios = __webpack_require__(14);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CambiarClaveApp = exports.CambiarClaveApp = function CambiarClaveApp(props) {
	
	    var btnCancela = (0, _react.useRef)();
	    var btnAcepta = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        mostrar = _useState2[0],
	        setMostrar = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(true),
	        _useState4 = _slicedToArray(_useState3, 2),
	        deshabilitado = _useState4[0],
	        setDeshabilitado = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(false),
	        _useState6 = _slicedToArray(_useState5, 2),
	        deshabilitadoL = _useState6[0],
	        setDeshabilitadoL = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(),
	        _useState8 = _slicedToArray(_useState7, 2),
	        titulo = _useState8[0],
	        setTitulo = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(),
	        _useState10 = _slicedToArray(_useState9, 2),
	        idUsuario = _useState10[0],
	        setIdUsuario = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(),
	        _useState12 = _slicedToArray(_useState11, 2),
	        msg = _useState12[0],
	        setMsg = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(false),
	        _useState14 = _slicedToArray(_useState13, 2),
	        mostrar1 = _useState14[0],
	        setMostrar1 = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(false),
	        _useState16 = _slicedToArray(_useState15, 2),
	        mostrar2 = _useState16[0],
	        setMostrar2 = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(false),
	        _useState18 = _slicedToArray(_useState17, 2),
	        mostrar3 = _useState18[0],
	        setMostrar3 = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(false),
	        _useState20 = _slicedToArray(_useState19, 2),
	        mostrar4 = _useState20[0],
	        setMostrar4 = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(),
	        _useState22 = _slicedToArray(_useState21, 2),
	        titulo2 = _useState22[0],
	        setTitulo2 = _useState22[1];
	
	    var _useState23 = (0, _react.useState)(),
	        _useState24 = _slicedToArray(_useState23, 2),
	        msg2 = _useState24[0],
	        setMsg2 = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(false),
	        _useState26 = _slicedToArray(_useState25, 2),
	        activate = _useState26[0],
	        setActivate = _useState26[1];
	
	    var _useState27 = (0, _react.useState)(0),
	        _useState28 = _slicedToArray(_useState27, 2),
	        contar = _useState28[0],
	        setContar = _useState28[1];
	
	    var _useState29 = (0, _react.useState)(false),
	        _useState30 = _slicedToArray(_useState29, 2),
	        mostrarClave = _useState30[0],
	        setMostrarClave = _useState30[1];
	
	    var _useState31 = (0, _react.useState)(false),
	        _useState32 = _slicedToArray(_useState31, 2),
	        mostrarClave1 = _useState32[0],
	        setMostrarClave1 = _useState32[1];
	
	    var _useState33 = (0, _react.useState)(),
	        _useState34 = _slicedToArray(_useState33, 2),
	        tecla = _useState34[0],
	        setTecla = _useState34[1];
	
	    var _useState35 = (0, _react.useState)(0),
	        _useState36 = _slicedToArray(_useState35, 2),
	        desde = _useState36[0],
	        setDesde = _useState36[1];
	
	    var _useState37 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState38 = _slicedToArray(_useState37, 2),
	        mensaje = _useState38[0],
	        setMensaje = _useState38[1];
	
	    var _useState39 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState40 = _slicedToArray(_useState39, 2),
	        mensajesino = _useState40[0],
	        setMensajesino = _useState40[1];
	
	    var txtLogin = (0, _react.useRef)();
	    var txtPassword = (0, _react.useRef)();
	    var txtConfirmPassword = (0, _react.useRef)();
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	
	    var procesarRegistro = function procesarRegistro() {
	
	        var endpoint = op.conexion + '/api/athos/usuarioapp/cambiarclave';
	
	        var body = {
	            usuario: txtLogin.current.value,
	            clave: txtPassword.current.value
	
	        };
	
	        _axios2.default.post(endpoint, body, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status == 200) {
	                setActivate(false);
	                setMensaje({ mostrar: true, titulo: 'Cambiar Contraseña', texto: 'La Contraseña fue cambiada.', icono: 'exito' });
	            }
	        }).catch(function (error) {
	
	            setActivate(false);
	            setMensaje({ mostrar: true, titulo: 'Cambiar Contraseña', texto: error.response.data.message, icono: 'error' });
	        });
	    };
	
	    var SelectUsuario = function SelectUsuario(login) {
	
	        var campos = 'idorganizacion, persona, idusuario, login, passwd, status';
	        var nomtab = 'usuarioapp';
	        var nomid = 'login';
	
	        var endpoint = op.conexion + '/api/athos/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + login;
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status == 200) {
	                setActivate(false);
	                if (response.data.idusuario > 0) {
	                    setDeshabilitado(false);
	                    setDeshabilitadoL(true);
	                    txtLogin.current.value = response.data.login;
	                    setIdUsuario(response.data.idusuario);
	                    if (tecla === 13) {
	                        setTimeout(function () {
	                            txtPassword.current.focus();
	                        }, 100);
	                    }
	                } else {
	                    setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'error al cargar el usuario', icono: 'informacion' });
	                    setActivate(false);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        });
	    };
	
	    (0, _react.useEffect)(function () {
	        var obj = JSON.parse(sessionStorage.getItem('post'));
	    }, []);
	
	    var blanquear = function blanquear() {
	
	        setMostrar(false);
	        setTitulo('');
	        setMsg('');
	        setMostrar1(false);
	        setTitulo2('');
	        setMsg2('');
	        setActivate(false);
	        setContar(0);
	        setIdUsuario(0);
	    };
	
	    var cancelar = function cancelar() {
	        blanquear();
	        props.onHide();
	    };
	
	    var validarCapcha = function validarCapcha() {
	        var valido = (0, _varios.ValidCaptcha)();
	        if (valido) {
	
	            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: "Esta seguro de registrar el ejercicio fiscal con estos datos?", icono: 'confirmacion' });
	            setMostrar4(false);
	        }
	    };
	
	    var handleCancelaCapcha = function handleCancelaCapcha() {
	        setMostrar4(false);
	    };
	
	    var handleCloseSi = function handleCloseSi() {
	        procesarRegistro();
	        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    };
	
	    var seleccionarUsuario = function seleccionarUsuario() {
	        setContar(0);
	        setActivate(true);
	        SelectUsuario(txtLogin.current.value);
	    };
	
	    var onChangeValidar = function onChangeValidar(e) {
	        e.preventDefault();
	        var sigue = true;
	        if (txtLogin.current.value.trim() === '') {
	            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'El Usuario no debe estar vacio', icono: 'informacion' });
	            sigue = false;
	            txtLogin.current.focus();
	        } else if (txtPassword.current.value.trim() === '') {
	            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'La Contraseña no debe estar vacia', icono: 'informacion' });
	            sigue = false;
	            txtPassword.current.focus();
	        } else if (txtConfirmPassword.current.value.trim() === '') {
	            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'La Confirmación de la Contraseña no debe estar vacia', icono: 'informacion' });
	            sigue = false;
	            txtConfirmPassword.current.focus();
	        } else if (txtPassword.current.value.trim() !== txtConfirmPassword.current.value.trim()) {
	            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Las Contraseñas no coinciden', icono: 'informacion' });
	            sigue = false;
	            txtConfirmPassword.current.focus();
	        }
	        if (sigue) {
	            setActivate(true);
	            setContar(0);
	            var _msg = '';
	            if (props.operacion === 1) {
	                _msg = 'Esta Seguro de Registrar estos Datos.';
	            } else if (props.operacion === 2) {
	                _msg = 'Esta Seguro de Modificar estos Datos.';
	            } else if (props.operacion === 3) {
	                _msg = 'Esta Seguro de Eliminar estos Datos.';
	            }
	
	            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Esta Seguro de Cambiar la contrasena.', icono: 'confirmacion' });
	        }
	    };
	
	    var handleInputChange = function handleInputChange(event) {
	        setTecla(event.which);
	        if (event.which === 13) {
	            var valido;
	            if (event.target.id === 'inputLogin') {
	                seleccionarUsuario();
	            } else if (event.target.id === 'inputPassword') {
	                if (txtConfirmPassword.current.value !== '' && txtPassword.current.value !== txtConfirmPassword.current.value) {
	                    setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Las Contraseñas no coinciden', icono: 'informacion' });
	                    txtPassword.current.focus();
	                } else {
	                    txtConfirmPassword.current.focus();
	                }
	            } else if (event.target.id === 'inputConfirmPassword') {
	                if (txtConfirmPassword.current.value !== '' && txtPassword.current.value !== txtConfirmPassword.current.value) {
	                    setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Las Contraseñas no coinciden', icono: 'informacion' });
	                    txtConfirmPassword.current.focus();
	                } else {
	                    btnAcepta.current.focus();
	                }
	            }
	        } else if (typeof event.which === 'undefined') {
	            if (event.target.id === 'inputPassword') {
	                if (txtConfirmPassword.current.value !== '' && txtPassword.current.value !== txtConfirmPassword.current.value) {
	                    setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Las Contraseñas no coinciden', icono: 'informacion' });
	                }
	            } else if (event.target.id === 'inputConfirmPassword') {
	                if (txtConfirmPassword.current.value !== '' && txtPassword.current.value !== txtConfirmPassword.current.value) {
	                    setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Las Contraseñas no coinciden', icono: 'informacion' });
	                }
	            }
	        } else if (event.which === 46) {
	            return false;
	        } else if (event.which >= 48 && event.which <= 57) {
	            return true;
	        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	            return true;
	        } else return false;
	    };
	
	    var cerrarModal = function cerrarModal() {
	        props.onHide();
	        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	    };
	
	    var mostrarPassword = function mostrarPassword() {
	        return setMostrarClave(!mostrarClave);
	    };
	    var mostrarPassword1 = function mostrarPassword1() {
	        return setMostrarClave1(!mostrarClave1);
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'sm',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                /*   txtLogin.current.value = props.usuario; */
	                setDeshabilitado(false);
	                setDeshabilitadoL(false);
	                setDesde(0);
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Cambio de Contrase\xF1a.'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.MensajeCapcha, {
	                show: mostrar4,
	                onHideAcepta: validarCapcha, onHideCancela: handleCancelaCapcha }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: { height: "auto", overflow: "auto" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'border-azul rounded' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 py-1' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { htmlFor: 'validationTooltipUsername' },
	                                    'Usuario: '
	                                ),
	                                _react2.default.createElement('input', { type: 'text', autocomplete: 'off', disabled: true, ref: txtLogin, className: 'form-control form-control-sm', defaultValue: props.usuario ? props.usuario !== '' ? props.usuario : '' : '', id: 'inputLogin', onKeyUp: handleInputChange })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 py-1' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { htmlFor: 'validationTooltip02' },
	                                    'Contrase\xF1a: '
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'input-group input-group-sm' },
	                                    _react2.default.createElement('input', { type: mostrarClave ? 'text' : 'password', disabled: deshabilitado, ref: txtPassword, className: 'form-control form-control-sm', id: 'inputPassword', onKeyUp: handleInputChange }),
	                                    _react2.default.createElement(
	                                        'button',
	                                        { style: { textAlign: "center", color: "white" }, disabled: deshabilitado, onClick: mostrarPassword, className: 'btn btn-sm btn-info' },
	                                        _react2.default.createElement('i', { className: 'fa fa-eye-slash' }),
	                                        ' '
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 py-1' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { htmlFor: 'validationTooltip03' },
	                                    'Confirmar Contrase\xF1a: '
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'input-group input-group-sm' },
	                                    _react2.default.createElement('input', { type: mostrarClave1 ? 'text' : 'password', disabled: deshabilitado, ref: txtConfirmPassword, className: 'form-control form-control-sm', id: 'inputConfirmPassword', onKeyUp: handleInputChange }),
	                                    _react2.default.createElement(
	                                        'button',
	                                        { style: { textAlign: "center", color: "white" }, disabled: deshabilitado, onClick: mostrarPassword1, className: 'btn btn-sm btn-info' },
	                                        _react2.default.createElement('i', { className: 'fa fa-eye-slash' }),
	                                        ' '
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement('div', { className: 'col-md-12 py-1' })
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                    'button',
	                    { ref: btnAcepta, onClick: onChangeValidar, className: 'btn btn-success col-md-6 btn-sm rounded-pill' },
	                    _react2.default.createElement(
	                        'i',
	                        { className: 'fas fa-check-circle' },
	                        '  Aceptar'
	                    )
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger col-md-6 btn-sm rounded-pill' },
	                    _react2.default.createElement(
	                        'i',
	                        { className: 'fas fa-window-close' },
	                        ' Cancelar'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	            onHide: function onHide() {
	                mensaje.titulo === 'Cambiar Contraseña' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	            } }),
	        _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	            onHideNo: function onHideNo() {
	                return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	            }, onHideSi: handleCloseSi })
	    );
	};
	
	//export default CambiarClave;

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _modalActualizarAfiliados = __webpack_require__(7086);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _mensajes = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TablaAfiliados(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
	
	  var headCells = [{
	    id: "1",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "CODIGO",
	    textAlign: "center"
	  }, {
	    id: "2",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "NOMBRES/RAZON SOCIAL",
	    textAlign: "center"
	  }, {
	    id: "3",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "RIF",
	    textAlign: "center"
	  }, {
	    id: "opciones",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: " OPCIONES",
	    textAlign: "center"
	  }];
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      mostrarAfiliado = _useState2[0],
	      setMostrarAfiliado = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      operacion = _useState6[0],
	      setOperacion = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(),
	      _useState8 = _slicedToArray(_useState7, 2),
	      organizacion = _useState8[0],
	      setOrganizacion = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mensaje = _useState10[0],
	      setMensaje = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      records = _useState12[0],
	      setRecords = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      filterFn = _useState14[0],
	      setFilterFn = _useState14[1];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting,
	      TblPagination = _useTable.TblPagination;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.idorganizacion.includes(target.value) || x.nombre.toUpperCase().includes(target.value.toUpperCase()) || x.rif.toUpperCase().includes(target.value.toUpperCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    setActivate(true);
	    var campos = "*";
	    var nomtab = "organizacion";
	    var nomid = "idorganizacion";
	    var orden = "idorganizacion";
	    var endpoint = "";
	
	    if (props.menu === "sistema") {
	      endpoint = op.conexion + "/api/athos/consulta/seleccionarregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	    }
	    if (props.menu === "organizacion") {
	      endpoint = op.conexion + "/api/athos/consulta/modelirows?&campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + idorganizacion;
	    }
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        } else {
	          setRecords([]);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response === undefined ? "Error de Conexion" : error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro(id) {
	    setActivate(true);
	    var campos = "*";
	    var nomtab = "organizacion";
	    var nomid = "idorganizacion";
	    var endpoint = op.conexion + "/api/athos/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setOrganizacion(response.data);
	        setMostrarAfiliado(true);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response === undefined ? "Error de Conexion" : error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var gestionarOrganizacion = function gestionarOrganizacion(id, ope) {
	    return function (event) {
	      event.preventDefault();
	      setOperacion(ope);
	      if (ope === 1) {
	        setMostrarAfiliado(true);
	      } else if (ope === 2) {
	        seleccionarRegistro(id);
	      } else if (ope === 3) {
	        seleccionarRegistro(id);
	      } else if (ope === 4) {
	        seleccionarRegistro(id);
	      }
	    };
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarRegistros();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { className: "container-fluid rounded" },
	    _react2.default.createElement(
	      "div",
	      { className: "container-fluid" },
	      _react2.default.createElement(
	        "div",
	        { className: "card" },
	        _react2.default.createElement(
	          _semanticUiReact.Dimmer,
	          { active: activate, inverted: true },
	          _react2.default.createElement(
	            _semanticUiReact.Loader,
	            { inverted: true },
	            "cargando..."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "content" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 row m-0 py-2" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-2" },
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    className: "form-control form-control-sm rounded-pill",
	                    onChange: handleSearch,
	                    placeholder: "Buscar"
	                  })
	                ),
	                props.menu === "sistema" && _react2.default.createElement(
	                  "div",
	                  { className: "col-md-1 ml-auto" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      onClick: gestionarOrganizacion("", 1),
	                      className: "btn btn-sm btn-primary rounded-circle"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-plus" }),
	                    " "
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12" },
	                _react2.default.createElement(
	                  TblContainer,
	                  null,
	                  _react2.default.createElement(TblHead, null),
	                  _react2.default.createElement(
	                    _core.TableBody,
	                    null,
	                    records && recordsAfterPagingAndSorting().map(function (item, index) {
	                      return _react2.default.createElement(
	                        _core.TableRow,
	                        { key: index, style: { padding: "0" } },
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseline",
	                            style: { textAlign: "center", width: "50px" }
	                          },
	                          item.idorganizacion
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseline",
	                            style: { textAlign: "start", width: "250px" }
	                          },
	                          item.nombre
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseline",
	                            style: { textAlign: "center", width: "250px" }
	                          },
	                          item.rif
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseline",
	                            style: { textAlign: "center", width: "100px" }
	                          },
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              onClick: gestionarOrganizacion(item.idorganizacion, 4),
	                              className: "btn btn-sm  btn-info rounded-circle ml-2"
	                            },
	                            _react2.default.createElement("i", { className: "fas fa-eye" }),
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              onClick: gestionarOrganizacion(item.idorganizacion, 2),
	                              className: "btn btn-sm  btn-warning rounded-circle ml-2"
	                            },
	                            _react2.default.createElement("i", { className: "fa fa-edit" }),
	                            " "
	                          ),
	                          props.menu === "sistema" && _react2.default.createElement(
	                            "button",
	                            {
	                              onClick: gestionarOrganizacion(item.idorganizacion, 3),
	                              className: "btn btn-sm  btn-danger rounded-circle ml-2"
	                            },
	                            _react2.default.createElement("i", { className: "fa fa-trash" }),
	                            " "
	                          )
	                        )
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(TblPagination, null)
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_mensajes.Mensaje, {
	          mensaje: mensaje,
	          onHide: function onHide() {
	            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	          }
	        }),
	        _react2.default.createElement(_modalActualizarAfiliados.ActualizarAfiliados, {
	          show: mostrarAfiliado,
	          operacion: operacion,
	          menu: props.menu,
	          organizacion: organizacion,
	          onHideCancela: function onHideCancela() {
	            return setMostrarAfiliado(false);
	          },
	          onHideAcepta: seleccionarRegistros
	        })
	      )
	    )
	  );
	}
	
	exports.default = TablaAfiliados;

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(19);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _modalActualizarUsuario = __webpack_require__(7089);
	
	var _modalActualizarUsuario2 = _interopRequireDefault(_modalActualizarUsuario);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _modalCambiarClave = __webpack_require__(299);
	
	var _mensajes = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headCells = [{
	  id: "1",
	  backgroundColor: "rgba(5, 81, 130, 1)",
	  color: "#ffffff",
	  label: "ID USUARIO",
	  textAlign: "center"
	}, {
	  id: "2",
	  backgroundColor: "rgba(5, 81, 130, 1)",
	  color: "#ffffff",
	  label: "USUARIO",
	  textAlign: "center"
	}, {
	  id: "opciones",
	  backgroundColor: "rgba(5, 81, 130, 1)",
	  color: "#ffffff",
	  label: " OPCIONES",
	  textAlign: "center"
	}];
	
	function TablaUsuarios(props) {
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      mostrar = _useState2[0],
	      setMostrar = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      mostrar2 = _useState4[0],
	      setMostrar2 = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mostrar5 = _useState6[0],
	      setMostrar5 = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      idUsuarioH = _useState8[0],
	      setIdUsuarioH = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      contarRet = _useState10[0],
	      setContarRet = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      activate = _useState12[0],
	      setActivate = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      operacion = _useState14[0],
	      setOperacion = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(),
	      _useState16 = _slicedToArray(_useState15, 2),
	      usuarioH = _useState16[0],
	      setUsuarioH = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(),
	      _useState18 = _slicedToArray(_useState17, 2),
	      persona = _useState18[0],
	      setPersona = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(),
	      _useState20 = _slicedToArray(_useState19, 2),
	      configCome = _useState20[0],
	      setConfigCome = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(),
	      _useState22 = _slicedToArray(_useState21, 2),
	      usuariow = _useState22[0],
	      setUsuariow = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(),
	      _useState24 = _slicedToArray(_useState23, 2),
	      idUsuario = _useState24[0],
	      setIdUsuario = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(),
	      _useState26 = _slicedToArray(_useState25, 2),
	      deuda = _useState26[0],
	      setDeuda = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(),
	      _useState28 = _slicedToArray(_useState27, 2),
	      historico = _useState28[0],
	      setHistorico = _useState28[1];
	
	  var _useState29 = (0, _react.useState)("0000"),
	      _useState30 = _slicedToArray(_useState29, 2),
	      usupermi = _useState30[0],
	      setUsupermi = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(),
	      _useState32 = _slicedToArray(_useState31, 2),
	      retencion = _useState32[0],
	      setRetencion = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(sessionStorage.getItem("espiritu")),
	      _useState34 = _slicedToArray(_useState33, 2),
	      espiritu = _useState34[0],
	      setEspiritu = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(sessionStorage.getItem("fechasistema")),
	      _useState36 = _slicedToArray(_useState35, 2),
	      fechaSistema = _useState36[0],
	      setFechaSistema = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(sessionStorage.getItem("anioactu")),
	      _useState38 = _slicedToArray(_useState37, 2),
	      anioActu = _useState38[0],
	      setAnioActu = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(false),
	      _useState40 = _slicedToArray(_useState39, 2),
	      deshabilitado = _useState40[0],
	      setDeshabilitado = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(),
	      _useState42 = _slicedToArray(_useState41, 2),
	      permiso = _useState42[0],
	      setPermiso = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      mensaje = _useState44[0],
	      setMensaje = _useState44[1];
	
	  var _useState45 = (0, _react.useState)([]),
	      _useState46 = _slicedToArray(_useState45, 2),
	      records = _useState46[0],
	      setRecords = _useState46[1];
	
	  var _useState47 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState48 = _slicedToArray(_useState47, 2),
	      filterFn = _useState48[0],
	      setFilterFn = _useState48[1];
	
	  var contac = 0;
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
	  var idusuario = JSON.parse(sessionStorage.getItem("idusuario"));
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting,
	      TblPagination = _useTable.TblPagination;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.idusuario.includes(target.value) || x.login.toLowerCase().includes(target.value.toLowerCase()) || (x.nombres + " " + x.apellidos).toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    var obj = JSON.parse(sessionStorage.getItem("post"));
	    setFechaSistema(obj.fechasistema);
	    setIdUsuario(obj.idusuario);
	    setEspiritu(obj.espiritu);
	    seleccionarRegistros();
	  }, []);
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "*";
	    var nomtab = "usuarioweb";
	    var nomid = "idorganizacion";
	    var orden = "idusuario";
	    var endpoint = "";
	
	    if (props.menu === "sistema") {
	      endpoint = op.conexion + "/api/athos/consulta/seleccionarregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	    }
	    if (props.menu === "organizacion") {
	      endpoint = op.conexion + "/api/athos/consulta/modelirows?&campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + idorganizacion;
	    }
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	          SelectUsuarioDos(idusuario);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var SelectUsuarioDos = function SelectUsuarioDos(idusuario) {
	    var endpoint = op.conexion + "/api/athos/usuario/getuser?id=" + idusuario;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.idusuario > 0) {
	          setUsupermi(response.data.accopuser);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "Error al cargar el usuario",
	            icono: "informacion"
	          });
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var SelectUsuario = function SelectUsuario(idusuario) {
	    var endpoint = op.conexion + "/api/athos/usuario/getuser?id=" + idusuario;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.idusuario > 0) {
	          setPersona({
	            cedula: response.data.cedula,
	            nombres: response.data.nombres,
	            apellidos: response.data.apellidos,
	            correoe: response.data.correoe,
	            tlf1: response.data.tlf1,
	            tlf2: response.data.tlf2,
	            fnacimiento: response.data.fnacimiento,
	            nacionalidad: response.data.nacionalidad,
	            sexo: response.data.sexo,
	            direccion: response.data.direccion,
	            nombreorg: response.data.nombreorg,
	            idorganizacion: response.data.idorganizacion
	          });
	          setUsuarioH(response.data);
	          setMostrar(true);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "Error al cargar el usuario",
	            icono: "informacion"
	          });
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var gestionarUsuarios = function gestionarUsuarios(id, op) {
	    return function (e) {
	      e.preventDefault();
	      setOperacion(op);
	
	      if (op === 1) {
	        setUsuarioH();
	        setUsuariow();
	        setPersona();
	        setDeshabilitado(false);
	        setMostrar(true);
	      } else if (op === 2) {
	        setDeshabilitado(false);
	        setOperacion(2);
	        setIdUsuarioH(id);
	        setActivate(true);
	        SelectUsuario(id);
	      } else if (op === 3) {
	        if (idUsuario === id) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "El Usuario no se puede eliminar porque esta logueado",
	            icono: "informacion"
	          });
	          return;
	        }
	        setDeshabilitado(true);
	        setOperacion(3);
	        setIdUsuarioH(id);
	        setActivate(true);
	        SelectUsuario(id);
	      } else if (op === 4) {
	        setDeshabilitado(true);
	        setOperacion(4);
	        setIdUsuarioH(id);
	        setActivate(true);
	        SelectUsuario(id);
	      }
	    };
	  };
	
	  var cerrarModalActualizar = function cerrarModalActualizar() {
	    setUsuarioH();
	    setUsuariow();
	    setPersona();
	    setMostrar(false);
	    seleccionarRegistros();
	  };
	
	  var validarActuUsuario = function validarActuUsuario() {
	    if (operacion === 4) {
	      setUsuarioH();
	      setMostrar(false);
	      return;
	    }
	    if (operacion === 1) {
	      setIdUsuarioH(0);
	    }
	    setUsuarioH();
	    setUsuariow();
	    setPersona();
	    setMostrar(false);
	    seleccionarRegistros();
	  };
	
	  var cambiarClave = function cambiarClave() {
	    setMostrar2(true);
	  };
	
	  var handleCloseClave = function handleCloseClave() {
	    setMostrar2(false);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "container-fluid rounded" },
	    _react2.default.createElement(
	      "div",
	      { className: "container-fluid w-100 h-100" },
	      _react2.default.createElement(
	        "div",
	        { className: "card" },
	        _react2.default.createElement(_modalActualizarUsuario2.default, {
	          show: mostrar,
	          onHideCancela: cerrarModalActualizar,
	          onHideAcepta: validarActuUsuario,
	          usuario: usuarioH,
	          datospersonales: persona,
	          deshabilitado: deshabilitado ? deshabilitado : undefined,
	          ingresa: 0,
	          declaweb: configCome ? configCome[0].declaweb.toString() : "false",
	          idusuario: idUsuario,
	          operacion: operacion,
	          menu: props.menu
	        }),
	        _react2.default.createElement(_modalCambiarClave.CambiarClave, { show: mostrar2, onHide: handleCloseClave }),
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "content" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 row m-0 py-2" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-2" },
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    className: "form-control form-control-sm rounded-pill",
	                    onChange: handleSearch,
	                    placeholder: "Buscar"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-3 ml-auto" },
	                  " "
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-1 ml-auto" },
	                  usupermi && usupermi.toString().substring(1, 2) === "1" ? _react2.default.createElement(
	                    "button",
	                    {
	                      onClick: gestionarUsuarios("", 1),
	                      className: "btn btn-sm btn-primary rounded-circle"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-plus" }),
	                    " "
	                  ) : ''
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12", style: { margin: "auto" } },
	                _react2.default.createElement(
	                  TblContainer,
	                  null,
	                  _react2.default.createElement(TblHead, null),
	                  _react2.default.createElement(
	                    _core.TableBody,
	                    null,
	                    records && recordsAfterPagingAndSorting().map(function (item, index) {
	                      return _react2.default.createElement(
	                        _core.TableRow,
	                        { key: index, style: { padding: "0" } },
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseline",
	                            style: { textAlign: "center", width: "50px" }
	                          },
	                          item.idusuario
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseline",
	                            style: { textAlign: "left", width: "250px" }
	                          },
	                          item.login
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseline",
	                            style: { textAlign: "center", width: "100px" }
	                          },
	                          usupermi && usupermi.toString().substring(0, 1) === "1" ? _react2.default.createElement(
	                            "button",
	                            {
	                              onClick: gestionarUsuarios(item.idusuario, 4),
	                              className: "btn btn-sm  btn-info rounded-circle ml-2"
	                            },
	                            _react2.default.createElement("i", { className: "fas fa-eye" }),
	                            " "
	                          ) : '',
	                          usupermi && usupermi.toString().substring(2, 3) === "1" ? _react2.default.createElement(
	                            "button",
	                            {
	                              onClick: gestionarUsuarios(item.idusuario, 2),
	                              className: "btn btn-sm  btn-warning rounded-circle ml-2"
	                            },
	                            _react2.default.createElement("i", { className: "fa fa-edit" }),
	                            " "
	                          ) : '',
	                          " ",
	                          usupermi && usupermi.toString().substring(3, 4) === "1" ? _react2.default.createElement(
	                            "button",
	                            {
	                              onClick: gestionarUsuarios(item.idusuario, 3),
	                              className: "btn btn-sm  btn-danger rounded-circle ml-2"
	                            },
	                            _react2.default.createElement("i", { className: "fa fa-trash" }),
	                            " "
	                          ) : ''
	                        )
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(TblPagination, null)
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Dimmer,
	          { active: activate, inverted: true },
	          _react2.default.createElement(
	            _semanticUiReact.Loader,
	            { inverted: true },
	            "cargando..."
	          )
	        ),
	        _react2.default.createElement(_mensajes.Mensaje, {
	          mensaje: mensaje,
	          onHide: function onHide() {
	            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	          }
	        })
	      )
	    )
	  );
	}
	
	exports.default = TablaUsuarios;

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(19);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _mensajes = __webpack_require__(9);
	
	var _modalActualizarUsuarioApp = __webpack_require__(7090);
	
	var _modalActualizarUsuarioApp2 = _interopRequireDefault(_modalActualizarUsuarioApp);
	
	var _modalCambiarClaveApp = __webpack_require__(665);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headCells = [{
	  id: "1",
	  backgroundColor: "rgba(5, 81, 130, 1)",
	  color: "#ffffff",
	  label: "ID USUARIO",
	  textAlign: "center"
	}, {
	  id: "2",
	  backgroundColor: "rgba(5, 81, 130, 1)",
	  color: "#ffffff",
	  label: "USUARIO",
	  textAlign: "center"
	}, {
	  id: "opciones",
	  backgroundColor: "rgba(5, 81, 130, 1)",
	  color: "#ffffff",
	  label: " OPCIONES",
	  textAlign: "center"
	}];
	
	function TablaUsuariosApp(props) {
	  var _useState = (0, _react.useState)(),
	      _useState2 = _slicedToArray(_useState, 2),
	      titulo = _useState2[0],
	      setTitulo = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = _slicedToArray(_useState3, 2),
	      msg = _useState4[0],
	      setMsg = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(),
	      _useState6 = _slicedToArray(_useState5, 2),
	      titulo1 = _useState6[0],
	      setTitulo1 = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(),
	      _useState8 = _slicedToArray(_useState7, 2),
	      msg1 = _useState8[0],
	      setMsg1 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mostrar = _useState10[0],
	      setMostrar = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mostrar2 = _useState12[0],
	      setMostrar2 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mostrar5 = _useState14[0],
	      setMostrar5 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      idUsuarioH = _useState16[0],
	      setIdUsuarioH = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      contarRet = _useState18[0],
	      setContarRet = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(false),
	      _useState20 = _slicedToArray(_useState19, 2),
	      activate = _useState20[0],
	      setActivate = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      operacion = _useState22[0],
	      setOperacion = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(),
	      _useState24 = _slicedToArray(_useState23, 2),
	      usuarioH = _useState24[0],
	      setUsuarioH = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(),
	      _useState26 = _slicedToArray(_useState25, 2),
	      persona = _useState26[0],
	      setPersona = _useState26[1];
	
	  var _useState27 = (0, _react.useState)("0000"),
	      _useState28 = _slicedToArray(_useState27, 2),
	      usupermi = _useState28[0],
	      setUsupermi = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(),
	      _useState30 = _slicedToArray(_useState29, 2),
	      configCome = _useState30[0],
	      setConfigCome = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(),
	      _useState32 = _slicedToArray(_useState31, 2),
	      usuariow = _useState32[0],
	      setUsuariow = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(),
	      _useState34 = _slicedToArray(_useState33, 2),
	      idUsuario = _useState34[0],
	      setIdUsuario = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(),
	      _useState36 = _slicedToArray(_useState35, 2),
	      deuda = _useState36[0],
	      setDeuda = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(),
	      _useState38 = _slicedToArray(_useState37, 2),
	      historico = _useState38[0],
	      setHistorico = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(),
	      _useState40 = _slicedToArray(_useState39, 2),
	      pagow = _useState40[0],
	      setPagow = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(),
	      _useState42 = _slicedToArray(_useState41, 2),
	      retencion = _useState42[0],
	      setRetencion = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(sessionStorage.getItem("espiritu")),
	      _useState44 = _slicedToArray(_useState43, 2),
	      espiritu = _useState44[0],
	      setEspiritu = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(sessionStorage.getItem("fechasistema")),
	      _useState46 = _slicedToArray(_useState45, 2),
	      fechaSistema = _useState46[0],
	      setFechaSistema = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(sessionStorage.getItem("anioactu")),
	      _useState48 = _slicedToArray(_useState47, 2),
	      anioActu = _useState48[0],
	      setAnioActu = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(false),
	      _useState50 = _slicedToArray(_useState49, 2),
	      deshabilitado = _useState50[0],
	      setDeshabilitado = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(),
	      _useState52 = _slicedToArray(_useState51, 2),
	      permiso = _useState52[0],
	      setPermiso = _useState52[1];
	
	  var _useState53 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState54 = _slicedToArray(_useState53, 2),
	      mensaje = _useState54[0],
	      setMensaje = _useState54[1];
	
	  var _useState55 = (0, _react.useState)([]),
	      _useState56 = _slicedToArray(_useState55, 2),
	      records = _useState56[0],
	      setRecords = _useState56[1];
	
	  var _useState57 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState58 = _slicedToArray(_useState57, 2),
	      filterFn = _useState58[0],
	      setFilterFn = _useState58[1];
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
	  var idusuarioc = JSON.parse(sessionStorage.getItem("idusuario"));
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting,
	      TblPagination = _useTable.TblPagination;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.idusuario.includes(target.value) || x.login.toLowerCase().includes(target.value.toLowerCase()) || (x.nombres + " " + x.apellidos).toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    var obj = JSON.parse(sessionStorage.getItem("post"));
	    setFechaSistema(obj.fechasistema);
	    setIdUsuario(obj.idusuario);
	    setEspiritu(obj.espiritu);
	    seleccionarRegistros();
	  }, []);
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "*";
	    var nomtab = "usuarioapp";
	    var nomid = "idorganizacion";
	    var orden = "idusuario";
	    var endpoint = "";
	
	    if (props.menu === "sistema") {
	      endpoint = op.conexion + "/api/athos/consulta/seleccionarregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	    }
	    if (props.menu === "organizacion") {
	      endpoint = op.conexion + "/api/athos/consulta/modelirows?&campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + idorganizacion;
	    }
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          SelectUsuarioDos(idusuarioc);
	          setRecords(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var SelectUsuarioDos = function SelectUsuarioDos(idusuario) {
	    var endpoint = op.conexion + "/api/athos/usuario/getuser?id=" + idusuario;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.idusuario > 0) {
	          setUsupermi(response.data.accopuserapp);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "Error al cargar el usuario",
	            icono: "informacion"
	          });
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var SelectUsuario = function SelectUsuario(idusuario) {
	    var endpoint = op.conexion + "/api/athos/usuarioapp/getuser?id=" + idusuario;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.idusuario > 0) {
	          setPersona({
	            cedula: response.data.cedula,
	            nombres: response.data.nombres,
	            apellidos: response.data.apellidos,
	            correoe: response.data.correoe,
	            tlf1: response.data.tlf1,
	            tlf2: response.data.tlf2,
	            fnacimiento: response.data.fnacimiento,
	            nacionalidad: response.data.nacionalidad,
	            sexo: response.data.sexo,
	            direccion: response.data.direccion,
	            nombreorg: response.data.nombreorg,
	            idorganizacion: response.data.idorganizacion
	          });
	          setUsuarioH(response.data);
	          setMostrar(true);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "Error al cargar el usuario",
	            icono: "informacion"
	          });
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var gestionarUsuarios = function gestionarUsuarios(id, op) {
	    return function (e) {
	      e.preventDefault();
	      setOperacion(op);
	
	      if (op === 1) {
	        setUsuarioH();
	        setUsuariow();
	        setPersona();
	        setDeshabilitado(false);
	        setMostrar(true);
	      } else if (op === 2) {
	        setDeshabilitado(false);
	        setOperacion(2);
	        setIdUsuarioH(id);
	        setActivate(true);
	        SelectUsuario(id);
	      } else if (op === 3) {
	        if (idUsuario === id) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "El Usuario no se puede eliminar porque esta logueado",
	            icono: "informacion"
	          });
	          return;
	        }
	        setDeshabilitado(true);
	        setOperacion(3);
	        setIdUsuarioH(id);
	        setActivate(true);
	        SelectUsuario(id);
	      } else if (op === 4) {
	        setDeshabilitado(true);
	        setOperacion(4);
	        setIdUsuarioH(id);
	        setActivate(true);
	        SelectUsuario(id);
	      }
	    };
	  };
	
	  var cerrarModalActualizar = function cerrarModalActualizar() {
	    seleccionarRegistros();
	    setUsuarioH();
	    setUsuariow();
	    setPersona();
	    setMostrar(false);
	  };
	
	  var validarActuUsuario = function validarActuUsuario() {
	    seleccionarRegistros();
	    if (operacion === 4) {
	      setUsuarioH();
	      setMostrar(false);
	      return;
	    }
	    if (operacion === 1) {
	      setIdUsuarioH(0);
	    }
	    setUsuarioH();
	    setUsuariow();
	    setPersona();
	    setMostrar(false);
	  };
	
	  var cambiarClave = function cambiarClave() {
	    setMostrar2(true);
	  };
	
	  var handleCloseClave = function handleCloseClave() {
	    setMostrar2(false);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "container-fluid rounded" },
	    _react2.default.createElement(
	      "div",
	      { className: "container-fluid w-100 h-100" },
	      _react2.default.createElement(
	        "div",
	        { className: "card" },
	        _react2.default.createElement(_modalActualizarUsuarioApp2.default, {
	          show: mostrar,
	          onHideCancela: cerrarModalActualizar,
	          onHideAcepta: validarActuUsuario,
	          usuario: usuarioH,
	          datospersonales: persona,
	          deshabilitado: deshabilitado ? deshabilitado : undefined,
	          ingresa: 0,
	          declaweb: configCome ? configCome[0].declaweb.toString() : "false",
	          idusuario: idUsuario,
	          operacion: operacion,
	          render: seleccionarRegistros,
	          menu: props.menu
	        }),
	        _react2.default.createElement(_modalCambiarClaveApp.CambiarClaveApp, { show: mostrar2, onHide: handleCloseClave }),
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "content" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 row m-0 py-2" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-2" },
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    className: "form-control form-control-sm rounded-pill",
	                    onChange: handleSearch,
	                    placeholder: "Buscar"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-3 ml-auto" },
	                  " "
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-1 ml-auto" },
	                  usupermi && usupermi.toString().substring(1, 2) === "1" ? _react2.default.createElement(
	                    "button",
	                    {
	                      onClick: gestionarUsuarios("", 1),
	                      className: "btn btn-sm btn-primary rounded-circle"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-plus" }),
	                    " "
	                  ) : ''
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12", style: { margin: "auto" } },
	                _react2.default.createElement(
	                  TblContainer,
	                  null,
	                  _react2.default.createElement(TblHead, null),
	                  _react2.default.createElement(
	                    _core.TableBody,
	                    null,
	                    records && recordsAfterPagingAndSorting().map(function (item, index) {
	                      return _react2.default.createElement(
	                        _core.TableRow,
	                        { key: index, style: { padding: "0" } },
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseline",
	                            style: { textAlign: "center", width: "50px" }
	                          },
	                          item.idusuario
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseline",
	                            style: { textAlign: "left", width: "250px" }
	                          },
	                          item.login
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseline",
	                            style: { textAlign: "center", width: "100px" }
	                          },
	                          usupermi && usupermi.toString().substring(0, 1) === "1" ? _react2.default.createElement(
	                            "button",
	                            {
	                              onClick: gestionarUsuarios(item.idusuario, 4),
	                              className: "btn btn-sm  btn-info rounded-circle ml-2"
	                            },
	                            _react2.default.createElement("i", { className: "fas fa-eye" }),
	                            " "
	                          ) : '',
	                          usupermi && usupermi.toString().substring(2, 3) === "1" ? _react2.default.createElement(
	                            "button",
	                            {
	                              onClick: gestionarUsuarios(item.idusuario, 2),
	                              className: "btn btn-sm  btn-warning rounded-circle ml-2"
	                            },
	                            _react2.default.createElement("i", { className: "fa fa-edit" }),
	                            " "
	                          ) : '',
	                          usupermi && usupermi.toString().substring(3, 4) === "1" ? _react2.default.createElement(
	                            "button",
	                            {
	                              onClick: gestionarUsuarios(item.idusuario, 3),
	                              className: "btn btn-sm  btn-danger rounded-circle ml-2"
	                            },
	                            _react2.default.createElement("i", { className: "fa fa-trash" }),
	                            " "
	                          ) : ''
	                        )
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(TblPagination, null)
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Dimmer,
	          { active: activate, inverted: true },
	          _react2.default.createElement(
	            _semanticUiReact.Loader,
	            { inverted: true },
	            "cargando..."
	          )
	        ),
	        _react2.default.createElement(_mensajes.Mensaje, {
	          mensaje: mensaje,
	          onHide: function onHide() {
	            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	          }
	        })
	      )
	    )
	  );
	}
	
	exports.default = TablaUsuariosApp;

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IncluirMovimiento = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IncluirMovimiento = exports.IncluirMovimiento = function IncluirMovimiento(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtIdMovimiento = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	  var txtFechaDocu = (0, _react.useRef)();
	  var txtFechaIngre = (0, _react.useRef)();
	  var txtReferencia = (0, _react.useRef)();
	  var cmbTipoMovimiento = (0, _react.useRef)();
	  var txtConcepto = (0, _react.useRef)();
	  var txtMonto = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      body = _useState2[0],
	      setBody = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      operacion = _useState4[0],
	      setOperacion = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      activate = _useState6[0],
	      setActivate = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      habilitado = _useState8[0],
	      setHabilitado = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mensaje = _useState10[0],
	      setMensaje = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mensajesino = _useState12[0],
	      setMensajesino = _useState12[1];
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'concepto') {
	      e.target.value = e.target.value;
	    } else {
	      e.target.value = e.target.value;
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	
	    var sigue = true;
	
	    if (cmbTipoMovimiento.current.value === '') {
	      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar el Tipo de Movimiento', icono: 'informacion' });
	      cmbTipoMovimiento.current.focus();
	      sigue = false;
	    } else if (txtFechaDocu.current.value === '') {
	      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar la Fecha del Documento', icono: 'informacion' });
	      txtFechaDocu.current.focus();
	      sigue = false;
	    } else if (txtFechaIngre.current.value === '') {
	      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar la fecha de Ingreso', icono: 'informacion' });
	      txtFechaIngre.current.focus();
	      sigue = false;
	    } else if (txtReferencia.current.value === '') {
	      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar la Referencia', icono: 'informacion' });
	      txtReferencia.current.focus();
	      sigue = false;
	    } else if (txtConcepto.current.value === '') {
	      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar el Concepto de Movimiento', icono: 'informacion' });
	      txtConcepto.current.focus();
	      sigue = false;
	    } else if (txtMonto.current.value === '' || txtMonto.current.value === '0,00') {
	      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar el Monto de Movimiento', icono: 'informacion' });
	      txtMonto.current.focus();
	      sigue = false;
	    }
	
	    if (sigue) {
	      var movi = [];
	      movi.push({
	        idmovimientobancario: txtIdMovimiento.current.value === '' ? 0 : txtIdMovimiento.current.value,
	        idcuentabancaria: props.idcuentabancaria,
	        fecha: txtFechaDocu.current.value,
	        fechaingreso: txtFechaIngre.current.value,
	        fechareal: fechasistema,
	        referencia: txtReferencia.current.value.toUpperCase(),
	        concepto: txtConcepto.current.value.toUpperCase(),
	        monto: txtMonto.current.value !== '' ? parseFloat(txtMonto.current.value.replace(/\./g, '').replace(',', '.')) : '0.00',
	        tipo: cmbTipoMovimiento.current.value,
	        conciliado: '0',
	        manual: 'true'
	      });
	
	      setBody({
	        movimiento: movi
	      });
	
	      var msg = '';
	      if (operacion === 1) {
	        msg = 'Esta Seguro de Registrar estos Datos.';
	      } else if (operacion === 2) {
	        msg = 'Esta Seguro de Modificar estos Datos.';
	      } else if (operacion === 3) {
	        msg = 'Esta Seguro de Eliminar estos Datos.';
	      }
	
	      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + '/api/banco/actualizarmovimientosbancarios/' + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
	        } else if (operacion === 2) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
	        } else if (operacion === 3) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = '';
	      if (error.response === undefined) {
	        mensaje = 'Error de Conexion';
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
	          mensaje = 'Ya existe un Registro con este rif';
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    procesarRegistro();
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setBody(null);
	    setHabilitado(false);
	
	    //txtIdMovimiento.current.setAttribute("disabled", true);
	    txtIdMovimiento.current.value = '';
	    cmbTipoMovimiento.current.value = '';
	    txtFechaDocu.current.value = '';
	    txtFechaIngre.current.value = '';
	    txtReferencia.current.value = '';
	    txtConcepto.current.value = '';
	    txtMonto.current.value = '';
	  };
	
	  var cancelar = function cancelar() {
	    /*  blanquear(); */
	    props.onHideCancela();
	  };
	
	  var handleInputMontoChange = function handleInputMontoChange(event) {
	    (0, _varios.validaMonto)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
	        event.target.value = '0,00';
	      }
	      event.target.value = (0, _varios.formatoMonto)(event.target.value);
	      var char1 = event.target.value.substring(0, 1);
	      var char2 = event.target.value.substring(1, 2);
	      if (char1 === '0' && char2 !== ',') {
	        event.target.value = event.target.value.substring(1, event.target.value.legth);
	      }
	      if (event.which === 13) {
	        btnAcepta.current.focus();
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	
	      e.preventDefault();
	
	      if (op === 1) {
	        setHabilitado(false);
	        txtIdMovimiento.current.setAttribute("disabled", true);
	        setTimeout(function () {
	          return txtDescripcion.current.focus();
	        }, 200);
	      } else if (op === 2) {
	        txtIdMovimiento.current.removeAttribute("disabled");
	        setHabilitado(false);
	        txtIdMovimiento.current.focus();
	      } else if (op === 3) {
	        setHabilitado(true);
	        txtIdMovimiento.current.removeAttribute("disabled");
	        txtIdMovimiento.current.focus();
	      } else if (op === 4) {
	        setHabilitado(true);
	        txtIdMovimiento.current.removeAttribute("disabled");
	        txtIdMovimiento.current.focus();
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        blanquear();
	      } else if (op === 7) {
	        cancelar();
	      }
	    };
	  };
	
	  var cerrarModal = function cerrarModal() {
	    props.onHideRenderizar();
	    props.onHideCancela();
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    event.preventDefault();
	    if (event.which === 13) {
	      if (event.target.name === 'fechadoc') {
	        event.target.value = (0, _moment2.default)(event.target.value).format('YYYY-MM-DD');
	        txtFechaIngre.current.focus();
	      } else if (event.target.name === 'fechaingre') {
	        event.target.value = (0, _moment2.default)(event.target.value).format('YYYY-MM-DD');
	        txtReferencia.current.focus();
	      } else if (event.target.name === 'refe') {
	        txtConcepto.current.focus();
	      }
	    } else if (typeof event.which === 'undefined') {
	      if (event.target.name === 'fechadoc') {
	        event.target.value = (0, _moment2.default)(event.target.value).format('YYYY-MM-DD');
	      } else if (event.target.name === 'fechaingre') {
	        event.target.value = (0, _moment2.default)(event.target.value).format('YYYY-MM-DD');
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false; //alert(e.which);
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	        setOperacion(props.operacion);
	        setHabilitado(props.habilitado);
	        if (props.operacion === 1) {
	          txtIdMovimiento.current.value = props.idmovimiento;
	          txtIdMovimiento.current.focus();
	        } else {
	          txtIdMovimiento.current.value = props.registro.idmovimientobancario;
	          cmbTipoMovimiento.current.value = props.registro.tipo;
	
	          txtFechaDocu.current.value = (0, _moment2.default)(props.registro.fecha).format('YYYY-MM-DD');
	          txtFechaIngre.current.value = (0, _moment2.default)(props.registro.fechaingreso).format('YYYY-MM-DD');
	          txtReferencia.current.value = props.registro.referencia.trim();
	          txtConcepto.current.value = props.registro.concepto.trim();
	          txtMonto.current.value = (0, _varios.formatMoneda)(props.registro.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	          /*for (let i = 0; i < props.tipoingreso.length; i++) {
	            if (props.tipoingreso[i].descripcion === props.registro.tipomovimiento) {
	              cmbTipoMovimiento.current.selectedIndex = i;//props.tipoingreso[i].idtipo;
	              break;
	            }
	           }*/
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        _Modal2.default.Title,
	        { style: { color: "#fff" } },
	        'Incluir Movimiento.'
	      ),
	      _react2.default.createElement(
	        'button',
	        { ref: btnCancela, className: 'btn', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	        _react2.default.createElement('i', { className: 'far fa-window-close' })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'border-azul col-md-12 py-3 rounded mx-auto', style: { fontSizeAdjust: '0.6' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'row col-md-12 rounded mx-auto' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-2 col-md-3' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'Id Movimiento:'
	              ),
	              _react2.default.createElement('input', { type: 'text', disabled: true, className: 'form-control bg-light', ref: txtIdMovimiento, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-2 col-md-4' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'Tipo Movimiento:'
	              ),
	              _react2.default.createElement(
	                'select',
	                { className: 'form-select form-select-sm ', disabled: !habilitado, ref: cmbTipoMovimiento, 'aria-label': '.form-select-sm example' },
	                _react2.default.createElement(
	                  'option',
	                  { value: '' },
	                  '--'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '0' },
	                  'Deposito'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '1' },
	                  'Transferencia'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '2' },
	                  'Nota Credito'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '3' },
	                  'Nota Debito'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '4' },
	                  'Cheque'
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'col-md-3' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-2 col-md-4' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'Fecha Documento:'
	              ),
	              _react2.default.createElement('input', { type: 'date', className: 'form-control bg-light', disabled: !habilitado, ref: txtFechaDocu, defaultValue: (0, _moment2.default)(fechasistema).format('YYYY-MM-DD'), 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', name: 'fechadoc', onKeyUp: handleInputChange, onBlur: handleInputChange })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-2 col-md-4' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'Fecha Ingreso:'
	              ),
	              _react2.default.createElement('input', { type: 'date', className: 'form-control bg-light', disabled: !habilitado, ref: txtFechaIngre, defaultValue: (0, _moment2.default)(fechasistema).format('YYYY-MM-DD'), 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', name: 'fechaingre', onKeyUp: handleInputChange, onBlur: handleInputChange })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-2 col-md-4' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'Referencia:'
	              ),
	              _react2.default.createElement('input', { type: 'text', className: 'form-control bg-light text-uppercase', disabled: !habilitado, ref: txtReferencia, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', name: 'refe', onKeyUp: handleInputChange, onBlur: handleInputChange })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-2 col-md-12' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'Concepto:'
	              ),
	              _react2.default.createElement('textarea', { type: 'area', className: 'form-control bg-light text-uppercase', disabled: !habilitado, ref: txtConcepto, name: 'concepto', onChange: onChange, style: { height: 40 }, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 mx-auto row justify-content-end px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm mb-2 col-md-3' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text bg-transparent border-0', id: 'inputGroup-sizing-sm' },
	                  'Monto:'
	                ),
	                _react2.default.createElement('input', { type: 'text', className: 'form-control bg-light rounded text-right', defaultValue: '0,00', disabled: !habilitado, ref: txtMonto, onFocus: _varios.seleccionarCampo, onKeyUp: handleInputMontoChange, onBlur: handleInputMontoChange, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      { className: 'd-flex justify-content-end' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-5 row d-flex justify-content-end' },
	        _react2.default.createElement(
	          'button',
	          { ref: btnAcepta, disabled: operacion === 4 ? true : false, onClick: onBotones(5), style: { height: '27px' }, className: 'btn col mx-1 my-1 btn-sm rounded-pill btn-success ' },
	          _react2.default.createElement(
	            'i',
	            { className: 'fas fa-check-circle', style: { fontSize: '9px' } },
	            '  Aceptar'
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { ref: btnSalir, onClick: onBotones(7), style: { height: '27px' }, className: 'btn col mx-1 my-1 btn-danger btn-sm rounded-pill ' },
	          _react2.default.createElement(
	            'i',
	            { className: 'fas fa-sign-out-alt', style: { fontSize: '9px' } },
	            ' Cancelar'
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RegistrarPago = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _modalAgreProcesosMontos = __webpack_require__(7115);
	
	var _datos = __webpack_require__(8);
	
	var _catalogoValorMoneda = __webpack_require__(295);
	
	var _catalogoValorMoneda2 = _interopRequireDefault(_catalogoValorMoneda);
	
	var _tablaRetencionesxCobrar = __webpack_require__(7137);
	
	var _tablaRetencionesxCobrar2 = _interopRequireDefault(_tablaRetencionesxCobrar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var RegistrarPago = exports.RegistrarPago = function RegistrarPago(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var ncaja = JSON.parse(sessionStorage.getItem("numcaja"));
	
	  var headCells = [{ label: "FORMA DE PAGO", textAlign: "center" }, { label: "REFERENCIA", textAlign: "center" }, { label: "MONTO", textAlign: "center" }, { label: "MONTO AL CAMBIO", textAlign: "center" }, { label: "", textAlign: "center" }];
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtFechaPago = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0.0),
	      _useState2 = _slicedToArray(_useState, 2),
	      restabs = _useState2[0],
	      setRestabs = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0.0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      anticipos = _useState4[0],
	      setAnticipos = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0.0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      sobrabs = _useState6[0],
	      setSobrabs = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0.0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      totalresta = _useState8[0],
	      setTotalresta = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0.0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      totalsobra = _useState10[0],
	      setTotalsobra = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0.0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      totaldolares = _useState12[0],
	      setTotaldolares = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0.0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      totalcredito = _useState14[0],
	      setTotalcredito = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0.0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      totales = _useState16[0],
	      setTotales = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0.0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      totalesr = _useState18[0],
	      setTotalesr = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0.0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      totalesrb = _useState20[0],
	      setTotalesrb = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0.0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      totaldeuda = _useState22[0],
	      setTotaldeuda = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0.0),
	      _useState24 = _slicedToArray(_useState23, 2),
	      totaldeudabs = _useState24[0],
	      setTotaldeudabs = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(0.0),
	      _useState26 = _slicedToArray(_useState25, 2),
	      tasa = _useState26[0],
	      setTasa = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(false),
	      _useState28 = _slicedToArray(_useState27, 2),
	      mostrar1 = _useState28[0],
	      setMostrar1 = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(0),
	      _useState30 = _slicedToArray(_useState29, 2),
	      operacion = _useState30[0],
	      setOperacion = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(""),
	      _useState32 = _slicedToArray(_useState31, 2),
	      numfactu = _useState32[0],
	      setNumfactu = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(0),
	      _useState34 = _slicedToArray(_useState33, 2),
	      idvendedor = _useState34[0],
	      setIdvendedor = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(0),
	      _useState36 = _slicedToArray(_useState35, 2),
	      idfactu = _useState36[0],
	      setIdfactu = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(null),
	      _useState38 = _slicedToArray(_useState37, 2),
	      body = _useState38[0],
	      setBody = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(null),
	      _useState40 = _slicedToArray(_useState39, 2),
	      idmon = _useState40[0],
	      setIdmon = _useState40[1];
	
	  var _useState41 = (0, _react.useState)([]),
	      _useState42 = _slicedToArray(_useState41, 2),
	      retencionesid = _useState42[0],
	      setRetencionesid = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(false),
	      _useState44 = _slicedToArray(_useState43, 2),
	      activate = _useState44[0],
	      setActivate = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(0),
	      _useState46 = _slicedToArray(_useState45, 2),
	      idmone = _useState46[0],
	      setIdmone = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(0.0),
	      _useState48 = _slicedToArray(_useState47, 2),
	      valormone = _useState48[0],
	      setValormone = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(""),
	      _useState50 = _slicedToArray(_useState49, 2),
	      tiponot = _useState50[0],
	      setTiponot = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(false),
	      _useState52 = _slicedToArray(_useState51, 2),
	      mostrar2 = _useState52[0],
	      setMostrar2 = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(false),
	      _useState54 = _slicedToArray(_useState53, 2),
	      mostrar3 = _useState54[0],
	      setMostrar3 = _useState54[1];
	
	  var _useState55 = (0, _react.useState)([]),
	      _useState56 = _slicedToArray(_useState55, 2),
	      records = _useState56[0],
	      setRecords = _useState56[1];
	
	  var _useState57 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState58 = _slicedToArray(_useState57, 2),
	      filterFn = _useState58[0],
	      setFilterFn = _useState58[1];
	
	  var _useState59 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState60 = _slicedToArray(_useState59, 2),
	      mensaje = _useState60[0],
	      setMensaje = _useState60[1];
	
	  var _useState61 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState62 = _slicedToArray(_useState61, 2),
	      mensajesino = _useState62[0],
	      setMensajesino = _useState62[1];
	
	  var _useState63 = (0, _react.useState)([]),
	      _useState64 = _slicedToArray(_useState63, 2),
	      combomoneda = _useState64[0],
	      setComboMoneda = _useState64[1];
	
	  var _useState65 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState66 = _slicedToArray(_useState65, 2),
	      botones = _useState66[0],
	      setBotones = _useState66[1];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells, filterFn),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setRestabs(0.0);
	    setSobrabs(0.0);
	    setAnticipos(0.0);
	    setIdfactu(0);
	    setIdvendedor(0);
	    setNumfactu("");
	    setIdmon(null);
	    setRetencionesid([]);
	    setTotalresta(0.0);
	    setTotales(0.0);
	    setTotalesr(0.0);
	    setTotalesrb(0.0);
	    setMostrar2(false);
	    setTotaldolares(0.0);
	    setTotalsobra(0.0);
	    setTotaldeuda(0.0);
	    setRecords([]);
	    setValormone(0.0);
	    setIdmone(0);
	    setTiponot("");
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope === 1) {
	      if (records.length > 0) {
	        sigue = true;
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Introduzca el Pago !",
	          icono: "informacion"
	        });
	        sigue = false;
	      }
	
	      if (sigue) {
	        var pago = [];
	        var pagodetalle = [];
	
	        pago.push({
	          idpago: 0,
	          numpago: "",
	          concepto: props.tipo === "notaentrega" ? "PAGO DE NOTA DE ENTREGA N°" + " " + props.numfactu : props.tipo === "debito" ? "PAGO DE NOTA DE DEBITO N°" + " " + props.numfactu : "PAGO DE FACTURA N°" + " " + props.numfactu,
	          idcliente: props.idclient,
	          idvendedor: idvendedor,
	          idfactura: idfactu,
	          monto: totaldolares + totalesr,
	          descuento: "",
	          iva: props.iva,
	          montoiva: props.montoiva,
	          abono: props.abonos,
	          total: totaldolares + totalesr,
	          sobrante: parseFloat(totalsobra),
	          fecharegistro: txtFechaPago.current.value,
	          tipofac: props.tipo === "notaentrega" ? "NE" : props.tipo === "debito" ? "ND" : "FA",
	          numfactura: numfactu,
	          status: (0, _varios.formatMoneda)(totaldolares.toString().replace(",", "").replace(".", ","), ",", ".", 2) === (0, _varios.formatMoneda)(totaldeuda.toString().replace(",", "").replace(".", ","), ",", ".", 2) ? 1 : 0,
	          idmoneda: idmone,
	          valormoneda: valormone,
	          montodeuda: totaldeuda
	        });
	
	        for (var i = 0; i < records.length; i++) {
	
	          pagodetalle.push(Object.assign({
	            idpago: 0,
	            monto: records[i].tipo === 7 || records[i].tipo === 8 || records[i].tipo === 9 || records[i].tipo === 10 ? records[i].montodefinic : records[i].montos,
	            nroreferencia: records[i].referencia,
	            idmoneda: records[i].tipodivisa,
	            numcredito: records[i].notacredito,
	            factorcambio: records[i].valormoneda,
	            moneda: records[i].simbolo === "$" ? "DOLAR" : records[i].simbolo === "€" ? "EURO" : "BOLIVARES",
	            tipo: records[i].tipo,
	            fechaemision: records[i].fechapago,
	            idcuenta: records[i].idbanco
	          }, records[i].tipo === 10 && {
	            idretiene: 0,
	            porc_unidad: records[i].porc,
	            idretencion: records[i].tiporeten,
	            idusuario: idvendedor,
	            numorden: numfactu
	          }, {
	            idreten: records[i].tiporeten
	          }));
	        }
	
	        setBody({
	          pago: pago,
	          pagodeta: pagodetalle,
	          app: false,
	          ncaja: ncaja
	        });
	
	        var msg = "";
	        if (props.ope === 1) {
	          msg = "Esta Seguro de Registrar este Pago.";
	        }
	
	        setMensajesino({
	          mostrar: true,
	          titulo: "Confirmación.",
	          texto: msg,
	          icono: "confirmacion"
	        });
	      }
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/registropago/" + props.ope;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (props.ope === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Pago Registrado Correctamente",
	            icono: "exito"
	          });
	
	          var reporte = "ReporteRecibodePago";
	          var opera = 2;
	          var condi = "'" + response.data.numeropago + "'";
	          var tipo = tiponot;
	
	          window.open(op.reportes + "/finanzas?afiliado=" + afiliado + "&reporte=" + reporte + "&NUMPAGO=" + condi + "&OP=" + opera + "&TIPOPAGO=" + tipo, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	        } else if (props.ope === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Pago Registrado Correctamente",
	            icono: "exito"
	          });
	        }
	        blanquear();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = error.response.data.message;
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    props.onHideCancelar();
	    props.onRenderizar();
	  };
	
	  var seleccionarReten = function seleccionarReten(numorden) {
	    var campos = "idretencion";
	    var nomtab = "retiene";
	    var nomid = "numorden";
	    var endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + numorden;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRetencionesid(response.data);
	        } else {
	          setRetencionesid([]);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarMonedas = function seleccionarMonedas(idmoneda, fecha) {
	
	    var endpoint = op.conexion + "/api/moneda/selectmonedasfecha?idmoneda=" + idmoneda + "&fecha=" + fecha;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idmoneda > 0) {
	          setComboMoneda(response.data);
	          setIdmon(response.data.idmoneda);
	          console.log(response.data.valor);
	          var valormoney = (0, _varios.round)(response.data.valor, 2);
	          var total = 0.0;
	          var _idmone = response.data.idmoneda;
	
	          setTasa(valormoney);
	          setValormone(valormoney);
	          setIdmone(_idmone);
	
	          var datos = [].concat(_toConsumableArray(records));
	          var montototal = 0.0;
	          var restbs = 0.0;
	          var data = [];
	          var predeterminada = void 0;
	          var montod = totaldeuda;
	          var calcular = 0.0;
	          var sobrante = 0.0;
	          var totalm = 0.0;
	          var tosobrabs = 0.0;
	          var calcularbs = 0.0;
	          var montbs = 0.0;
	          var montrestabs = 0.0;
	          var restabss = 0.0;
	          var reten = 0.0;
	          var tore = 0.0;
	
	          restbs = totaldeuda > 0 ? (0, _varios.round)(totaldeuda, 2) * valormoney : props.monto * valormoney;
	          predeterminada = valormoney;
	
	          if (datos.length > 0) {
	            for (var e = 0; e < datos.length; e++) {
	              data.push({
	                forma: datos[e].tipo === 1 ? "Efectivo Bs" : datos[e].tipo === 2 ? "Tarjeta(Debito) Bs" : datos[e].tipo === 3 ? "Tarjeta(Crédito) Bs" : datos[e].tipo === 4 ? "Pago Movil Bs" : datos[e].tipo === 5 ? "Deposito Bancario Bs" : datos[e].tipo === 6 ? "Transferencia Bancaria Bs" : datos[e].tipo === 7 ? "Divisa" + " " + datos[e].simbolo : datos[e].tipo === 8 ? "Saldo a Credito $" : datos[e].tipo === 9 ? "Saldo Anticipo $" : datos[e].forma,
	                montos: datos[e].montos,
	                index: datos[e].index,
	                fechapago: datos[e].fechapago,
	                tipo: datos[e].tipo,
	                tipodivisa: datos[e].tipodivisa,
	                montoalcambio: datos[e].tipo === 8 || datos[e].tipo === 9 || datos[e].tipo === 10 || datos[e].tipo === 7 && datos[e].tipodivisa === idmon ? datos[e].montos * valormoney : datos[e].tipo === 7 && datos[e].tipodivisa !== idmon ? datos[e].montoalcambio : parseFloat(datos[e].montos) / valormoney,
	                montodefinic: datos[e].tipo === 7 && datos[e].tipodivisa !== idmon ? datos[e].montoalcambio / valormoney : datos[e].tipo === 8 || datos[e].tipo === 9 || datos[e].tipo === 10 || datos[e].tipo === 7 && datos[e].tipodivisa === idmon ? datos[e].montodefinic * valormoney / valormoney : parseFloat(datos[e].montos) / valormoney,
	                notacredito: datos[e].tipo === 8 || datos[e].tipo === 9 ? datos[e].notacredito : "",
	                valormoneda: datos[e].tipo === 7 && datos[e].tipodivisa !== idmon ? datos[e].valormoneda : datos[e].tipo === 8 || datos[e].tipo === 9 || datos[e].tipo === 10 || datos[e].tipo === 7 && datos[e].tipodivisa === idmon ? valormoney : datos[e].valormoneda,
	                idbanco: datos[e].idbanco,
	                referencia: datos[e].referencia,
	                simbolo: datos[e].simbolo
	              });
	            }
	
	            for (var i = 0; i < data.length; i++) {
	
	              if (data[i].tipo === 10) {
	                reten = parseFloat(reten) + parseFloat(data[i].montodefinic);
	              } else {
	                montototal = parseFloat(montototal) + parseFloat(data[i].montodefinic);
	              }
	            }
	
	            total = (0, _varios.round)(montod, 2) - (0, _varios.round)(montototal, 2) - (0, _varios.round)(reten, 2);
	            calcular = (0, _varios.round)(montototal, 2) > (0, _varios.round)(montod, 2) ? "0,00" : total;
	            sobrante = (0, _varios.round)(montototal + reten, 2) > (0, _varios.round)(montod, 2) ? Math.abs(total) : "0,00";
	            totalm = montototal * predeterminada;
	            tore = reten * predeterminada;
	            tosobrabs = sobrante * predeterminada;
	
	            montbs = (0, _varios.round)(montod, 2) * predeterminada;
	            montrestabs = (0, _varios.round)(montod, 2) * predeterminada - totalm - tore;
	            restabss = (0, _varios.round)(montototal, 2) * predeterminada;
	            calcularbs = restabss > montbs ? "0,00" : montrestabs;
	
	            setSobrabs(Math.abs(tosobrabs));
	            setRestabs(Math.abs(calcularbs));
	            setTotalresta(Math.abs(calcular));
	            setTotalsobra(sobrante);
	            setTotaldolares(montototal);
	            setTotalesr(reten);
	            setTotalesrb(tore);
	            setTotales(totalm);
	          } else {
	            setRestabs(Math.abs(restbs));
	          }
	          setRecords(data);
	          setTotaldeudabs(restbs);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var handleAceptaDatos = function handleAceptaDatos(values) {
	    setMostrar1(false);
	
	    var predeterminada = void 0;
	    var totalm = 0.0;
	    var tanti = 0.0;
	    var valormoney = 0.0;
	    var indx = 0;
	    var credito = 0.0;
	    var credit = 0.0;
	    var idmoney = void 0;
	
	    var datos = [].concat(_toConsumableArray(records));
	    var montod = totaldeuda;
	    var montototal = 0.0;
	    var total = 0.0;
	    var calcular = 0.0;
	    var sobrante = 0.0;
	    var reten = 0.0;
	    var tore = 0.0;
	
	    for (var b = 0; b < datos.length; b++) {
	      if (datos[b].index > 0) {
	        indx = datos[b].index + 1;
	      } else {
	        indx = indx + 1;
	      }
	    }
	
	    for (var i = 0; i < values.length; i++) {
	      idmoney = values[i].tipodivisa;
	
	      predeterminada = tasa;
	      console.log(predeterminada);
	
	      datos.push({
	        forma: values[i].formapago === 1 ? "Efectivo Bs" : values[i].formapago === 2 ? "Tarjeta(Debito) Bs" : values[i].formapago === 3 ? "Tarjeta(Crédito) Bs" : values[i].formapago === 4 ? "Pago Movil Bs" : values[i].formapago === 5 ? "Deposito Bancario Bs" : values[i].formapago === 6 ? "Transferencia Bancaria Bs" : values[i].formapago === 7 ? "Divisa" + " " + values[i].simbolo : values[i].formapago === 8 ? "Saldo a Credito $" : "Saldo Anticipo $",
	        montos: values[i].monto,
	        fechapago: values[i].fecha,
	        tipo: values[i].formapago,
	        tipodivisa: values[i].tipodivisa,
	        montoalcambio: values[i].formapago === 7 && values[i].tipodivisa === idmon ? parseFloat(values[i].monto) * predeterminada : values[i].formapago === 7 && values[i].tipodivisa !== idmon ? parseFloat(values[i].monto) * valormoney : values[i].formapago === 8 || values[i].formapago === 9 ? parseFloat(values[i].monto) * predeterminada : parseFloat(values[i].monto) / predeterminada,
	        montodefinic: values[i].formapago === 7 && values[i].tipodivisa === idmon ? parseFloat(values[i].monto) * predeterminada / predeterminada : values[i].formapago === 7 && values[i].tipodivisa !== idmon ? parseFloat(values[i].monto) * valormoney / predeterminada : values[i].formapago === 8 || values[i].formapago === 9 ? parseFloat(values[i].monto) : parseFloat(values[i].monto) / predeterminada,
	        index: indx,
	        notacredito: values[i].formapago === 8 || values[i].formapago === 9 ? values[i].notacredito : "",
	        valormoneda: values[i].formapago === 7 && values[i].tipodivisa !== idmon ? values[i].valormoneda : values[i].formapago === 8 || values[i].formapago === 9 || values[i].formapago === 7 && values[i].tipodivisa === idmon ? predeterminada : values[i].valormoneda,
	        idbanco: values[i].idbanco,
	        referencia: values[i].referencia,
	        simbolo: values[i].simbolo,
	        tiporeten: values[i].codigo,
	        porc: values[i].porc > 0 ? values[i].porc : ""
	      });
	    }
	
	    for (var e = 0; e < datos.length; e++) {
	
	      if (datos[e].tipo === 10) {
	        reten = parseFloat(reten) + parseFloat(datos[e].montodefinic);
	      } else {
	        montototal = parseFloat(montototal) + parseFloat(datos[e].montodefinic);
	      }
	
	      if (datos[e].tipo === 8) {
	        credito = parseFloat(datos[e].montodefinic);
	      } else {
	        credito = totalcredito;
	      }
	
	      if (datos[e].tipo === 9) {
	        tanti = parseFloat(datos[e].montodefinic);
	      } else {
	        tanti = anticipos;
	      }
	    }
	
	    var totalcredit = 0.0;
	
	    if (values[0].formapago === 8) {
	      credit = parseFloat(totalcredito) - credito;
	    } else {
	      credit = totalcredito;
	    }
	
	    if (values[0].formapago === 9) {
	      tanti = parseFloat(anticipos) - tanti;
	    } else {
	      tanti = anticipos;
	    }
	
	    var tosobrabs = 0.0;
	    var totalanticipo = 0.0;
	    var calcularbs = 0.0;
	    var montbs = 0.0;
	    var montrestabs = 0.0;
	    var restabss = 0.0;
	
	    totalcredit = values[0].formapago === 8 ? credit >= parseFloat(totalcredito) ? "0,00" : credit : totalcredito;
	    totalanticipo = values[0].formapago === 9 ? tanti >= parseFloat(anticipos) ? "0,00" : tanti : anticipos;
	    total = (0, _varios.round)(montod, 2) - (0, _varios.round)(montototal, 2) - (0, _varios.round)(reten, 2);
	    calcular = (0, _varios.round)(montototal, 2) > (0, _varios.round)(montod, 2) ? "0,00" : total;
	    sobrante = (0, _varios.round)(montototal + reten, 2) > (0, _varios.round)(montod, 2) ? Math.abs(total) : "0,00";
	    totalm = montototal * predeterminada;
	    tore = reten * predeterminada;
	    tosobrabs = sobrante * predeterminada;
	
	    montbs = (0, _varios.round)(montod, 2) * predeterminada;
	    montrestabs = (0, _varios.round)(montod, 2) * predeterminada - totalm - tore;
	    restabss = (0, _varios.round)(montototal, 2) * predeterminada;
	    calcularbs = restabss > montbs ? "0,00" : montrestabs;
	
	    setAnticipos(totalanticipo);
	    setSobrabs(Math.abs(tosobrabs));
	    setRestabs(Math.abs(calcularbs));
	    setTotalcredito(totalcredit);
	    setTotalresta(Math.abs(calcular));
	    setTotalsobra(sobrante);
	    setTotaldolares(montototal);
	    setTotales(totalm);
	    setRecords(datos);
	  };
	
	  var handleAceptaDatosReten = function handleAceptaDatosReten(values) {
	    setMostrar3(false);
	
	    var predeterminada = void 0;
	    var totalm = 0.0;
	    var idmoney = void 0;
	    var indx2 = 0;
	    var indx = 0;
	    var tore = 0.0;
	    var reten = 0.0;
	
	    var datos = [].concat(_toConsumableArray(records));
	    var montod = totaldeuda;
	    var montototal = 0.0;
	    var total = 0.0;
	    var calcular = 0.0;
	    var sobrante = 0.0;
	
	    if (retencionesid.length > 0) {
	      for (var c = 0; c < retencionesid.length; c++) {
	        if (parseInt(retencionesid[c].idretencion) === parseInt(values[0].codigo)) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "¡ Este Tipo de Retención ya fue Procesada !",
	            icono: "informacion"
	          });
	          return;
	        }
	      }
	    } else {
	      for (var b = 0; b < datos.length; b++) {
	
	        if (parseInt(datos[b].tiporeten) === parseInt(values[0].codigo)) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "¡ Este Tipo de Retención ya fue Procesada !",
	            icono: "informacion"
	          });
	          return;
	        }
	
	        indx = indx;
	      }
	    }
	
	    for (var i = 0; i < values.length; i++) {
	
	      idmoney = idmon;
	
	      predeterminada = tasa;
	
	      indx === 0 ? indx2 = indx2 + 1 : indx + 1;
	
	      datos.push({
	        forma: values[i].descripcion,
	        montos: values[i].monto,
	        fechapago: values[i].fecha,
	        tipo: values[i].formapago,
	        tipodivisa: idmoney,
	        montoalcambio: values[i].monto * predeterminada,
	        montodefinic: values[i].monto,
	        index: indx2,
	        notacredito: "",
	        valormoneda: predeterminada,
	        idbanco: values[i].idbanco,
	        referencia: values[i].referencia,
	        simbolo: values[i].simbolo,
	        tiporeten: values[i].codigo,
	        porc: values[i].porc
	      });
	    }
	
	    for (var e = 0; e < datos.length; e++) {
	
	      if (datos[e].tipo === 10) {
	        reten = parseFloat(reten) + parseFloat(datos[e].montodefinic);
	      } else {
	        montototal = parseFloat(montototal) + parseFloat(datos[e].montodefinic);
	      }
	    }
	
	    var tosobrabs = 0.0;
	    var totalanticipo = 0.0;
	    var calcularbs = 0.0;
	    var montbs = 0.0;
	    var montrestabs = 0.0;
	    var restabss = 0.0;
	
	    total = (0, _varios.round)(montod, 2) - (0, _varios.round)(montototal, 2) - (0, _varios.round)(reten, 2);
	    calcular = (0, _varios.round)(montototal, 2) > (0, _varios.round)(montod, 2) ? "0,00" : total;
	    sobrante = (0, _varios.round)(montototal + reten, 2) > (0, _varios.round)(montod, 2) ? Math.abs(total) : "0,00";
	    totalm = montototal * predeterminada;
	    tore = reten * predeterminada;
	    tosobrabs = sobrante * predeterminada;
	
	    montbs = (0, _varios.round)(montod, 2) * predeterminada;
	    montrestabs = (0, _varios.round)(montod, 2) * predeterminada - totalm - tore;
	    restabss = (0, _varios.round)(montototal, 2) * predeterminada;
	    calcularbs = restabss > montbs ? "0,00" : montrestabs;
	
	    setAnticipos(totalanticipo);
	    setSobrabs(Math.abs(tosobrabs));
	    setRestabs(Math.abs(calcularbs));
	    setTotalresta(Math.abs(calcular));
	    setTotalsobra(sobrante);
	    setTotaldolares(montototal);
	    setTotales(totalm);
	    setTotalesr(reten);
	    setTotalesrb(tore);
	    setRecords(datos);
	  };
	
	  var calcularTotales = function calcularTotales(data, datos) {
	    var predeterminada = void 0;
	    var montod = totaldeuda;
	    var montototal = 0.0;
	    var total = 0.0;
	    var calcular = 0.0;
	    var sobrante = 0.0;
	    var totalm = 0.0;
	    var credito = 0.0;
	    var credit = 0.0;
	    var ant = 0.0;
	    var mant = 0.0;
	    var tore = 0.0;
	    var reten = 0.0;
	    var tocredict = totalcredito;
	    var totalanticipo = anticipos;
	
	    predeterminada = tasa;
	
	    console.log(data);
	    console.log(datos);
	
	    for (var e = 0; e < data.length; e++) {
	
	      for (var c = 0; c < datos.length; c++) {
	
	        if (datos[c].tipo === 10) {
	          reten = parseFloat(reten) + parseFloat(datos[c].montodefinic);
	        } else {
	          montototal = parseFloat(montototal) + parseFloat(datos[c].montodefinic);
	        }
	      }
	
	      if (data[e].tipo === 8) {
	        credito = parseFloat(data[e].montodefinic);
	        credit = parseFloat(tocredict) + credito;
	      } else {
	        credito = tocredict;
	        credit = tocredict;
	      }
	
	      if (data[e].tipo === 9) {
	        ant = parseFloat(data[e].montodefinic);
	        mant = parseFloat(totalanticipo) + ant;
	      } else {
	        ant = totalanticipo;
	        mant = totalanticipo;
	      }
	    }
	
	    var totalcredit = 0.0;
	    var restabs = 0.0;
	    var tosobrabs = 0.0;
	    var toanticipo = 0.0;
	
	    totalcredit = credit;
	    toanticipo = mant;
	
	    total = (0, _varios.round)(montod, 2) - (0, _varios.round)(Math.abs(montototal), 2) - (0, _varios.round)(reten, 2);
	    calcular = Math.abs(montototal) > (0, _varios.round)(montod, 2) ? "0,00" : total;
	    sobrante = Math.abs(montototal) > (0, _varios.round)(montod, 2) ? total : "0,00";
	    totalm = (0, _varios.round)(Math.abs(montototal), 2) * predeterminada;
	    tore = (0, _varios.round)(reten, 2) * predeterminada;
	
	    restabs = calcular * predeterminada;
	    tosobrabs = sobrante * predeterminada;
	    console.log(montototal, sobrante);
	    setAnticipos(toanticipo);
	    setSobrabs(Math.abs(tosobrabs));
	    setRestabs(Math.abs(restabs));
	    setTotalcredito(totalcredit);
	    setTotalresta(Math.abs(calcular));
	    setTotalsobra(Math.abs(sobrante));
	    setTotalesr(reten);
	    setTotalesrb(tore);
	    setTotaldolares(Math.abs(montototal));
	    setTotales(totalm);
	  };
	
	  var handleAceptaValorMoneda = function handleAceptaValorMoneda(valuesm) {
	    setMostrar2(false);
	    var valormoney = (0, _varios.round)(valuesm.valor, 2);
	    setTasa(valormoney);
	    setValormone(valormoney);
	    setIdmone(valuesm.idmoneda);
	
	    var datos = [].concat(_toConsumableArray(records));
	    var montototal = 0.0;
	    var restbs = 0.0;
	    var data = [];
	    var predeterminada = void 0;
	    var montod = totaldeuda;
	    var total = 0.0;
	    var calcular = 0.0;
	    var sobrante = 0.0;
	    var totalm = 0.0;
	    var tosobrabs = 0.0;
	    var calcularbs = 0.0;
	    var montbs = 0.0;
	    var montrestabs = 0.0;
	    var restabss = 0.0;
	    var reten = 0.0;
	    var tore = 0.0;
	
	    restbs = (0, _varios.round)(totaldeuda, 2) * valormoney;
	    predeterminada = valormoney;
	
	    if (datos.length > 0) {
	      for (var e = 0; e < datos.length; e++) {
	        data.push({
	          forma: datos[e].tipo === 1 ? "Efectivo Bs" : datos[e].tipo === 2 ? "Tarjeta(Debito) Bs" : datos[e].tipo === 3 ? "Tarjeta(Crédito) Bs" : datos[e].tipo === 4 ? "Pago Movil Bs" : datos[e].tipo === 5 ? "Deposito Bancario Bs" : datos[e].tipo === 6 ? "Transferencia Bancaria Bs" : datos[e].tipo === 7 ? "Divisa" + " " + datos[e].simbolo : datos[e].tipo === 8 ? "Saldo a Credito $" : datos[e].tipo === 9 ? "Saldo Anticipo $" : datos[e].forma,
	          montos: datos[e].montos,
	          index: datos[e].index,
	          fechapago: datos[e].fechapago,
	          tipo: datos[e].tipo,
	          tipodivisa: datos[e].tipodivisa,
	          montoalcambio: datos[e].tipo === 8 || datos[e].tipo === 9 || datos[e].tipo === 10 || datos[e].tipo === 7 && datos[e].tipodivisa === idmon ? datos[e].montos * valormoney : datos[e].tipo === 7 && datos[e].tipodivisa !== idmon ? datos[e].montoalcambio : parseFloat(datos[e].montos) / valormoney,
	          montodefinic: datos[e].tipo === 7 && datos[e].tipodivisa !== idmon ? datos[e].montoalcambio / valormoney : datos[e].tipo === 8 || datos[e].tipo === 9 || datos[e].tipo === 10 || datos[e].tipo === 7 && datos[e].tipodivisa === idmon ? datos[e].montodefinic * valormoney / valormoney : parseFloat(datos[e].montos) / valormoney,
	          notacredito: datos[e].tipo === 8 || datos[e].tipo === 9 ? datos[e].notacredito : "",
	          valormoneda: datos[e].tipo === 7 && datos[e].tipodivisa !== idmon ? datos[e].valormoneda : datos[e].tipo === 8 || datos[e].tipo === 9 || datos[e].tipo === 10 || datos[e].tipo === 7 && datos[e].tipodivisa === idmon ? valuesm.valor : datos[e].valormoneda,
	          idbanco: datos[e].idbanco,
	          referencia: datos[e].referencia,
	          simbolo: datos[e].simbolo
	        });
	      }
	
	      for (var i = 0; i < data.length; i++) {
	
	        if (data[i].tipo === 10) {
	          reten = parseFloat(reten) + parseFloat(data[i].montodefinic);
	        } else {
	          montototal = parseFloat(montototal) + parseFloat(data[i].montodefinic);
	        }
	      }
	
	      total = (0, _varios.round)(montod, 2) - (0, _varios.round)(montototal, 2) - (0, _varios.round)(reten, 2);
	      calcular = (0, _varios.round)(montototal, 2) > (0, _varios.round)(montod, 2) ? "0,00" : total;
	      sobrante = (0, _varios.round)(montototal + reten, 2) > (0, _varios.round)(montod, 2) ? Math.abs(total) : "0,00";
	      totalm = montototal * predeterminada;
	      tore = reten * predeterminada;
	      tosobrabs = sobrante * predeterminada;
	
	      montbs = (0, _varios.round)(montod, 2) * predeterminada;
	      montrestabs = (0, _varios.round)(montod, 2) * predeterminada - totalm - tore;
	      restabss = (0, _varios.round)(montototal, 2) * predeterminada;
	      calcularbs = restabss > montbs ? "0,00" : montrestabs;
	
	      setSobrabs(Math.abs(tosobrabs));
	      setRestabs(Math.abs(calcularbs));
	      setTotalresta(Math.abs(calcular));
	      setTotalsobra(sobrante);
	      setTotaldolares(montototal);
	      setTotalesr(reten);
	      setTotalesrb(tore);
	      setTotales(totalm);
	    } else {
	      setRestabs(Math.abs(restbs));
	    }
	
	    setRecords(data);
	    setTotaldeudabs(restbs);
	  };
	
	  var eliminarFila = function eliminarFila(values) {
	    return function (e) {
	      e.preventDefault();
	      var data = [].concat(_toConsumableArray(records));
	      var elementos = [];
	      var eliminado = [];
	
	      for (var i = 0; i < data.length; i++) {
	        if (values !== data[i].index) {
	          elementos.push(data[i]);
	        }
	
	        if (values === data[i].index) {
	          eliminado.push(data[i]);
	        }
	      }
	
	      setRecords(elementos);
	      calcularTotales(eliminado, elementos);
	    };
	  };
	
	  var onGestionar = function onGestionar(op) {
	    return function (e) {
	      if (op === 1) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 2) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 3) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 4) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 5) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 6) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 7) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 8) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 9) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 10) {
	        setOperacion(op);
	        setMostrar3(true);
	      }
	    };
	  };
	
	  var seleccionarCredito = function seleccionarCredito(id) {
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/seleccionarcredito?idcliente=" + id;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var montototal = 0.0;
	
	          for (var i = 0; i < response.data.length; i++) {
	            montototal = parseFloat(montototal) + parseFloat(response.data[i].totalmonto);
	          }
	
	          setTotalcredito(montototal);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === 'fecha') {
	      var fehcs = (0, _moment2.default)(e.target.value).format('DD-MM-YYYY');
	      var idmoney = props.idmoned;
	      seleccionarMonedas(idmoney, fehcs);
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "xl",
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        var fech = (0, _moment2.default)(fechasistema).format('DD-MM-YYYY');
	        seleccionarMonedas(props.idmoned, fech);
	        if (props.ope === 1) {
	          if (props.tipo === "factura") {
	            setIdvendedor(props.idvendedor);
	            setIdfactu(props.idfactu);
	            setNumfactu(props.numfactu);
	            setTotalresta(props.monto);
	            seleccionarCredito(props.idclient);
	            setAnticipos(props.anticipo);
	            txtFechaPago.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	            if (props.tipo === "notaentrega") {
	              setTiponot("NE");
	            } else {
	              setTiponot("ND");
	            }
	          } else {
	            setIdvendedor(props.idvendedor);
	            setIdfactu(props.idfactu);
	            setNumfactu(props.numfactu);
	            setTotaldeuda(props.monto);
	            setTotalresta(props.monto);
	            seleccionarCredito(props.idclient);
	            setAnticipos(props.anticipo);
	            seleccionarReten(props.numfactu);
	            txtFechaPago.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	            if (props.tipo === "notaentrega") {
	              setTiponot("NE");
	            } else {
	              setTiponot("ND");
	            }
	          }
	        } else {}
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold", style: { color: "#fff" } },
	        _react2.default.createElement(
	          "h3",
	          null,
	          props.tipo === "debito" ? "Registrar Pago - (Nota de Debito)" : props.tipo === "notaentrega" ? "Registrar Pago - (Nota de Entrega)" : "Registrar Pago - (Factura)"
	        )
	      ),
	      _react2.default.createElement(
	        "a",
	        {
	          href: "#",
	          ref: btnSalir,
	          disabled: botones.salir,
	          onClick: cancelar,
	          className: "text-light"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-times fa-1x shadow" },
	          " "
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({
	            mostrar: false,
	            titulo: "",
	            texto: "",
	            icono: ""
	          });
	        }
	      }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, {
	        mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	        },
	        onHideSi: handleCloseSi
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12 row mx-auto px-0" },
	        _react2.default.createElement(
	          "div",
	          { className: "row col-md-12 rounded mx-auto" },
	          _react2.default.createElement(
	            "fieldset",
	            {
	              className: "row col-sm-12 mx-auto border-azul rounded mb-1",
	              style: { fontSizeAdjust: "0.6" }
	            },
	            _react2.default.createElement(
	              "legend",
	              { className: "float-none m-0 w-auto fs-4 fw-bold" },
	              "Datos"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-4 row m-0 px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-280 px-1 py-2 mb-2" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA DE PAGO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "date",
	                    ref: txtFechaPago,
	                    disabled: props.ope === 0 ? true : false,
	                    name: "fecha",
	                    onChange: onChange,
	                    className: "form-control fs-6 text-uppercase",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-8 row m-0 px-0 border-azul d-flex align-items-center",
	                style: { background: "#cfe2ff", borderRadius: "3px" }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-5 px-1 row m-0",
	                  style: { fontSizeAdjust: "0.5" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  { className: "col-pd-130 px-1 text-left fs-5" },
	                  "Total a Pagar:",
	                  " "
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "col px-0 fw-bold text-right fs-5" },
	                  "\xA0",
	                  (0, _varios.formatMoneda)(totaldeuda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                  "\xA0$"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-6 px-1 row m-0 ml-auto",
	                  style: { fontSizeAdjust: "0.5" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  { className: "col-pd-180 px-1 text-left fs-5" },
	                  "Total a Pagar Bs:",
	                  " "
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "col px-0 fw-bold text-right fs-5" },
	                  "\xA0",
	                  (0, _varios.formatMoneda)(totaldeudabs.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-4 row m-0 px-0 d-flex justify-content-center border-azul py-2",
	                style: { background: "#cfe2ff", borderRadius: "3px" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 mb-2 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(1),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-money-bill-alt fs-5 mr-2" }),
	                  " Efectivo Bs"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(7),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-dollar-sign fs-5 mr-2" }),
	                  " Divisas"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 mb-2 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(2),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-credit-card fs-5 mr-2" }),
	                  " Tarjeta de Debito"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 mb-2 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(3),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fab fa-cc-visa fw-bold fs-5 mr-2" }),
	                  " Tarjeta de Credito"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 mb-2 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(6),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-money-check fs-5 mr-2" }),
	                  " Deposito Bancario"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 mb-2 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(5),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-laptop fs-5 mr-2" }),
	                  " Transferencia Bancaria"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 mb-2 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(4),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-mobile-alt fs-5 mr-2" }),
	                  " Pago Movil"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta,
	                    disabled: props.siescredit !== 1 ? true : false,
	                    style: { height: "80px", fontSize: "14px" },
	                    onClick: onGestionar(8),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-money-check-alt fs-5 mr-2" }),
	                  " Saldo a Credito",
	                  " ",
	                  (0, _varios.formatMoneda)(totalcredito.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta,
	                    disabled: props.siesanticipo !== 1 ? true : false,
	                    style: { height: "80px", fontSize: "14px" },
	                    onClick: onGestionar(9),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-pager fs-5 mr-2" }),
	                  " Saldo en Anticipo",
	                  " ",
	                  (0, _varios.formatMoneda)(anticipos.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta,
	                    disabled: props.esretenedor === 1 ? false : true,
	                    style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(10),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-hand-holding-usd fs-5 mr-2" }),
	                  " Retenciones"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-8 px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-12 px-0" },
	                _react2.default.createElement(
	                  TblContainer,
	                  {
	                    container: {
	                      height: "290px",
	                      width: "100%",
	                      overflow: "auto",
	                      padding: "2px"
	                    }
	                  },
	                  _react2.default.createElement(TblHead, null),
	                  _react2.default.createElement(
	                    _semanticUiReact.TableBody,
	                    { className: "overflow-hidden table-bordered" },
	                    records && records.map(function (item, index) {
	                      return _react2.default.createElement(
	                        _semanticUiReact.TableRow,
	                        {
	                          key: index,
	                          style: { padding: "0", cursor: "pointer" }
	                        },
	                        _react2.default.createElement(
	                          _semanticUiReact.TableCell,
	                          { className: "align-baseline text-center" },
	                          item.forma
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.TableCell,
	                          { className: "align-baseline text-center" },
	                          item.referencia
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.TableCell,
	                          { className: "align-middle text-right" },
	                          (0, _varios.formatMoneda)(item.montos.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.TableCell,
	                          { className: "align-baseline text-right" },
	                          (0, _varios.formatMoneda)(item.montoalcambio.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.TableCell,
	                          { className: "align-baseline text-center" },
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              className: "btn btn-sm mx-1 btn-danger",
	                              onClick: eliminarFila(item.index)
	                            },
	                            _react2.default.createElement("i", { className: "fa fa-trash" }),
	                            " "
	                          )
	                        )
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-12 row m-0 border-azul px-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-5 px-0" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-pd-280 mx-auto mt-2" },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "col-pd-210 row m-0 py-1 mx-auto d-flex align-items-center",
	                        style: { fontSizeAdjust: "0.5" }
	                      },
	                      _react2.default.createElement(
	                        "span",
	                        { className: "col-pd-90 px-1 text-left fs-5 fw-bold" },
	                        "Tasa 1$ =",
	                        " "
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        { className: "col-pd-70 px-0 fw-bold fs-5" },
	                        "\xA0",
	                        tasa && (0, _varios.formatMoneda)(tasa.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        { className: "col-pd-50 px-0" },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            type: "button",
	                            disabled: props.ope === 0 ? true : false,
	                            onClick: function onClick() {
	                              /* setCualCat(2); */
	                              setMostrar2(true);
	                            },
	                            className: "btn btn-primary"
	                          },
	                          _react2.default.createElement("i", { className: "fas fa-search" })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("img", { src: "imagenes/logo.ico", className: "img-fluid" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "col-7 ml-auto px-0 row m-0 d-flex align-items-center border-azul py-2",
	                    style: {
	                      background: "#cfe2ff",
	                      borderRadius: "3px",
	                      fontSizeAdjust: "0.5"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 row m-0 py-1",
	                      style: { fontSizeAdjust: "0.5" }
	                    },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "col-4 px-1 text-left fs-5" },
	                      "Total $:",
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "col px-0 fw-bold text-right fs-5" },
	                      "\xA0",
	                      (0, _varios.formatMoneda)(totaldolares.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 row m-0 py-1",
	                      style: { fontSizeAdjust: "0.5" }
	                    },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "col-4 px-1 text-left fs-5" },
	                      "Total Bs:",
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "col px-0 fw-bold text-right fs-5" },
	                      "\xA0",
	                      (0, _varios.formatMoneda)(totales.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 row m-0 py-1",
	                      style: { fontSizeAdjust: "0.5" }
	                    },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "col-pd-200 px-1 text-left fs-5" },
	                      "Total Retenciones $:",
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "col px-0 fw-bold text-right fs-5" },
	                      "\xA0",
	                      (0, _varios.formatMoneda)(totalesr.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 row m-0 py-1",
	                      style: { fontSizeAdjust: "0.5" }
	                    },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "col-pd-200 px-1 text-left fs-5" },
	                      "Total Retenciones Bs:",
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "col px-0 fw-bold text-right fs-5" },
	                      "\xA0",
	                      (0, _varios.formatMoneda)(totalesrb.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 row m-0 py-1",
	                      style: { fontSizeAdjust: "0.5" }
	                    },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "col-pd-180 px-1 text-left fs-5" },
	                      totalsobra > 0 ? "Sobrante $:" : "Restante a Pagar $:",
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "col px-0 fw-bold text-right fs-5" },
	                      "\xA0",
	                      totalsobra > 0 ? (0, _varios.formatMoneda)(totalsobra.toString().replace(",", "").replace(".", ","), ",", ".", 2) : (0, _varios.formatMoneda)(totalresta.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 px-1 row m-0 py-1",
	                      style: { fontSizeAdjust: "0.5" }
	                    },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "col-pd-200 px-2 text-left fs-5" },
	                      sobrabs > 0 ? "Sobrante Bs:" : "Restante a Pagar Bs:"
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "col px-1 fw-bold text-right fs-5" },
	                      "\xA0",
	                      sobrabs > 0 ? (0, _varios.formatMoneda)(sobrabs.toString().replace(",", "").replace(".", ","), ",", ".", 2) : (0, _varios.formatMoneda)(restabs.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "row m-0 col-md-12 mx-auto" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-4 ml-auto px-0 m-0 d-flex justify-content-end" },
	          _react2.default.createElement(
	            "button",
	            {
	              ref: btnAcepta,
	              disabled: props.ope === 0 ? true : false,
	              onClick: onChangeValidar,
	              className: "btn btn-sm rounded-pill btn-success mx-1"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-sync-alt" },
	              " ",
	              "Procesar Pago"
	            )
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              ref: btnCancela,
	              onClick: cancelar,
	              className: "btn btn-danger btn-sm rounded-pill mx-1"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-window-close" },
	              " ",
	              "Cancelar"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_modalAgreProcesosMontos.ProcesosMontos, {
	      show: mostrar1,
	      ope: operacion,
	      data: records,
	      idclients: props.idclient,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar1(false);
	      },
	      onHideAceptaData: handleAceptaDatos
	    }),
	    _react2.default.createElement(_tablaRetencionesxCobrar2.default, {
	      show: mostrar3,
	      ope: operacion,
	      montonota: props.monto,
	      montoiva: props.montoiva,
	      numfact: props.numfactu,
	      idclient: props.idclient,
	      ivas: props.iva,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar3(false);
	      },
	      onHideAceptaData: handleAceptaDatosReten
	    }),
	    _react2.default.createElement(_catalogoValorMoneda2.default, {
	      show: mostrar2,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar2(false);
	      },
	      onHideAceptaCatalogo: handleAceptaValorMoneda
	    })
	  );
	};

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _core = __webpack_require__(19);
	
	var _tablaRetencionesDos = __webpack_require__(7136);
	
	var _tablaRetencionesDos2 = _interopRequireDefault(_tablaRetencionesDos);
	
	var _modalRegistrarPagoCompras = __webpack_require__(7126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var RegistrarPagodeFactura = function RegistrarPagodeFactura(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var anio = JSON.parse(sessionStorage.getItem("anioactu"));
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var accbtncntxcobrar = JSON.parse(sessionStorage.getItem("accbtncntxcobrarc"));
	
	  var headCells = [{ label: "COD-P", textAlign: "center", width: "60px" }, { label: "PRODUCTO", textAlign: "center", width: "270px" }, { label: "CANTIDAD", textAlign: "center", width: "60px" }, { label: "PRECIO UNI.", textAlign: "center", width: "50px" }, { label: "UND. ALT.", textAlign: "center", width: "50px" }, { label: "%IVA", textAlign: "center", width: "50px" }, { label: "MONTO IVA", textAlign: "center", width: "50px" }, { label: "SIN IVA", textAlign: "center", width: "50px" }];
	
	  var fechaTope = (0, _moment2.default)(JSON.parse(sessionStorage.getItem("fechasistema"))).format("YYYY-MM-DD").replace(anio.toString(), (anio - 18).toString());
	
	  var txtIdFactura = (0, _react.useRef)();
	  var txtNumFactura = (0, _react.useRef)();
	  var cmbTipo = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtId = (0, _react.useRef)([]);
	  var txtTotalreten = (0, _react.useRef)();
	  var txtCantidad = (0, _react.useRef)([]);
	  var txtFechafactura = (0, _react.useRef)();
	  var txtNcontrol = (0, _react.useRef)();
	  var txtAbono = (0, _react.useRef)();
	  var txtSaldo = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtTotalRetenido = (0, _react.useRef)();
	  var btnProducto = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtSubTotal = (0, _react.useRef)();
	  var txtDescuento = (0, _react.useRef)();
	  var txtTotIva = (0, _react.useRef)();
	  var txtTotal = (0, _react.useRef)();
	  var txtIdNotaEntrega = (0, _react.useRef)();
	  var cmbMoneda = (0, _react.useRef)();
	  var txtMontoTotal = (0, _react.useRef)();
	  var txtIdmoneda = (0, _react.useRef)();
	  var txtDias = (0, _react.useRef)();
	  var txtFechaVencimiento = (0, _react.useRef)();
	  var txtCedRifVendedor = (0, _react.useRef)();
	  var txtNomVendedor = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      body = _useState2[0],
	      setBody = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0.00),
	      _useState4 = _slicedToArray(_useState3, 2),
	      ivas = _useState4[0],
	      setIvas = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0.00),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mivas = _useState6[0],
	      setMivas = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(""),
	      _useState8 = _slicedToArray(_useState7, 2),
	      tipoAgente = _useState8[0],
	      setTipoAgente = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0.00),
	      _useState10 = _slicedToArray(_useState9, 2),
	      tasa = _useState10[0],
	      setTasa = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      selectd = _useState12[0],
	      setSelectd = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      actcredit = _useState14[0],
	      setActcredit = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      operacion = _useState16[0],
	      setOperacion = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      habilitado = _useState18[0],
	      setHabilitado = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      valida = _useState20[0],
	      setValida = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(true),
	      _useState22 = _slicedToArray(_useState21, 2),
	      habilitadoBot = _useState22[0],
	      setHabilitadoBot = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(false),
	      _useState24 = _slicedToArray(_useState23, 2),
	      habilitadoCli = _useState24[0],
	      setHabilitadoCli = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(true),
	      _useState26 = _slicedToArray(_useState25, 2),
	      habilitadoProductos = _useState26[0],
	      setHabilitadoProductos = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(false),
	      _useState28 = _slicedToArray(_useState27, 2),
	      habilitadoMod = _useState28[0],
	      setHabilitadoMod = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      habilitadoTip = _useState30[0],
	      setHabilitadoTip = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(false),
	      _useState32 = _slicedToArray(_useState31, 2),
	      habilitarMoneda = _useState32[0],
	      setHabilitarMoneda = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(null),
	      _useState34 = _slicedToArray(_useState33, 2),
	      indice = _useState34[0],
	      setIndice = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(null),
	      _useState36 = _slicedToArray(_useState35, 2),
	      idvendedor = _useState36[0],
	      setIdvendedor = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(""),
	      _useState38 = _slicedToArray(_useState37, 2),
	      numNota = _useState38[0],
	      setNumNota = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(""),
	      _useState40 = _slicedToArray(_useState39, 2),
	      cedRif = _useState40[0],
	      setCedRif = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(""),
	      _useState42 = _slicedToArray(_useState41, 2),
	      nomVendedor = _useState42[0],
	      setNomVendedor = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(0),
	      _useState44 = _slicedToArray(_useState43, 2),
	      idfact = _useState44[0],
	      setIdfact = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(""),
	      _useState46 = _slicedToArray(_useState45, 2),
	      numfact = _useState46[0],
	      setNumfact = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(""),
	      _useState48 = _slicedToArray(_useState47, 2),
	      idCliente = _useState48[0],
	      setIdCliente = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(0.0),
	      _useState50 = _slicedToArray(_useState49, 2),
	      monto = _useState50[0],
	      setMonto = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(""),
	      _useState52 = _slicedToArray(_useState51, 2),
	      nomCliente = _useState52[0],
	      setNomCliente = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(""),
	      _useState54 = _slicedToArray(_useState53, 2),
	      dirCliente = _useState54[0],
	      setDirCliente = _useState54[1];
	
	  var _useState55 = (0, _react.useState)(0),
	      _useState56 = _slicedToArray(_useState55, 2),
	      visible = _useState56[0],
	      setVisible = _useState56[1];
	
	  var _useState57 = (0, _react.useState)(false),
	      _useState58 = _slicedToArray(_useState57, 2),
	      mostrar = _useState58[0],
	      setMostrar = _useState58[1];
	
	  var _useState59 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState60 = _slicedToArray(_useState59, 2),
	      mensaje = _useState60[0],
	      setMensaje = _useState60[1];
	
	  var _useState61 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState62 = _slicedToArray(_useState61, 2),
	      mensajesino = _useState62[0],
	      setMensajesino = _useState62[1];
	
	  var _useState63 = (0, _react.useState)(0),
	      _useState64 = _slicedToArray(_useState63, 2),
	      desde = _useState64[0],
	      setDesde = _useState64[1];
	
	  var _useState65 = (0, _react.useState)(0.00),
	      _useState66 = _slicedToArray(_useState65, 2),
	      retorno = _useState66[0],
	      setRetorno = _useState66[1];
	
	  var _useState67 = (0, _react.useState)(0),
	      _useState68 = _slicedToArray(_useState67, 2),
	      idAlmacen = _useState68[0],
	      setIdAlmacen = _useState68[1];
	
	  var _useState69 = (0, _react.useState)(""),
	      _useState70 = _slicedToArray(_useState69, 2),
	      idOpeInve = _useState70[0],
	      setIdOpeInve = _useState70[1];
	
	  var _useState71 = (0, _react.useState)([]),
	      _useState72 = _slicedToArray(_useState71, 2),
	      records = _useState72[0],
	      setRecords = _useState72[1];
	
	  var _useState73 = (0, _react.useState)([]),
	      _useState74 = _slicedToArray(_useState73, 2),
	      combomoneda = _useState74[0],
	      setComboMoneda = _useState74[1];
	
	  var _useState75 = (0, _react.useState)([]),
	      _useState76 = _slicedToArray(_useState75, 2),
	      moneda = _useState76[0],
	      setMoneda = _useState76[1];
	
	  var _useState77 = (0, _react.useState)({
	    idmoneda: "2",
	    descripcion: "DOLARES",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 0.0
	  }),
	      _useState78 = _slicedToArray(_useState77, 2),
	      monedaSub = _useState78[0],
	      setMonedaSub = _useState78[1];
	
	  var _useState79 = (0, _react.useState)(false),
	      _useState80 = _slicedToArray(_useState79, 2),
	      catalogoCliente = _useState80[0],
	      setCatalogoCliente = _useState80[1];
	
	  var _useState81 = (0, _react.useState)(false),
	      _useState82 = _slicedToArray(_useState81, 2),
	      catalogoVendedor = _useState82[0],
	      setCatalogoVendedor = _useState82[1];
	
	  var _useState83 = (0, _react.useState)(false),
	      _useState84 = _slicedToArray(_useState83, 2),
	      catalogoNota = _useState84[0],
	      setCatalogoNota = _useState84[1];
	
	  var _useState85 = (0, _react.useState)(false),
	      _useState86 = _slicedToArray(_useState85, 2),
	      catalogoFactura = _useState86[0],
	      setCatalogoFactura = _useState86[1];
	
	  var _useState87 = (0, _react.useState)("Gestionar Facturas."),
	      _useState88 = _slicedToArray(_useState87, 2),
	      tituloHeader = _useState88[0],
	      setTituloHeader = _useState88[1];
	
	  var _useState89 = (0, _react.useState)(0),
	      _useState90 = _slicedToArray(_useState89, 2),
	      selectp = _useState90[0],
	      setSelectp = _useState90[1];
	
	  var _useState91 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState92 = _slicedToArray(_useState91, 2),
	      filterFn = _useState92[0],
	      setFilterFn = _useState92[1];
	
	  var _useState93 = (0, _react.useState)(false),
	      _useState94 = _slicedToArray(_useState93, 2),
	      activate = _useState94[0],
	      setActivate = _useState94[1];
	
	  var _useState95 = (0, _react.useState)("visible"),
	      _useState96 = _slicedToArray(_useState95, 2),
	      visibleBtn = _useState96[0],
	      setVisibleBtn = _useState96[1];
	
	  var _useState97 = (0, _react.useState)([{ value: "J" }, { value: "V" }, { value: "G" }, { value: "P" }]),
	      _useState98 = _slicedToArray(_useState97, 2),
	      cmbCedula = _useState98[0],
	      setCmbCedula = _useState98[1];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var handleInputNumeroChange = function handleInputNumeroChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.target.name === "codpedido") {
	      /*txtDescripAlmaOrigen.current.value = '';
	            setRecords([]);*/
	    }
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "idfactu") {
	          seleccionarRegistro(event.target.value);
	        } else if (event.target.name === "idnotaentre") {} /*else if (event.target.name === 'codalmadestino') {
	                                                             seleccionarAlmacen(event.target.value, 2);
	                                                           }*/
	      }
	    }
	  };
	
	  var _useState99 = (0, _react.useState)(true),
	      _useState100 = _slicedToArray(_useState99, 2),
	      habilitadoNU = _useState100[0],
	      setHabilitadoNU = _useState100[1];
	
	  var validarCliente = function validarCliente(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (cmbRif.current.value !== "" && event.target.value !== "") {
	        var rif = cmbRif.current.value + event.target.value;
	        seleccionarClienteinput(rif, event.which);
	      }
	    }
	  };
	
	  var blanquear = function blanquear() {
	    setTituloHeader("Gestionar Facturas.");
	    setBody();
	    setActivate(false);
	    setOperacion(0);
	    setHabilitado(false);
	    setHabilitadoMod(false);
	    setHabilitadoTip(false);
	    setHabilitarMoneda(false);
	    setHabilitadoCli(false);
	    setHabilitadoBot(true);
	    setValida(0);
	    setHabilitadoProductos(true);
	    setTasa(0.00);
	    setSelectd(0);
	    setSelectp(0);
	    setIdvendedor(0);
	    setVisible(0);
	    setVisibleBtn("visible");
	    setMoneda([]);
	    setRecords([]);
	    setNumNota("");
	    setNomCliente("");
	    setDirCliente("");
	    setNomVendedor("");
	    setCedRif("");
	    setIdOpeInve("");
	  };
	
	  var onCambioUnidad = function onCambioUnidad(index) {
	    return function (event) {
	      var data = [].concat(_toConsumableArray(records));
	      var precio = 0.0;
	      var tasa = moneda.valormoneda;
	      var montoiva = 0.0;
	      var uni = [];
	      var tipounidad = 0;
	      var cantie = data[index].cantidadEA;
	      //  let valorfactor = 0.00;
	
	      if (parseInt(event.target.value) === parseInt(data[index].idunidadmedida)) {
	        precio = parseFloat(data[index].costocalculado) * (1 + parseFloat(data[index].utipreciomaxi) / 100);
	        precio = Math.round(precio * 100) / 100;
	        precio = precio * data[index].valormoneda;
	        precio = precio / tasa;
	        precio = Math.round(precio * 100) / 100;
	        //   valorfactor = data[index].cantidadE/data[index].valorfactor;
	        montoiva = precio * data[index].ivaventa / 100;
	        montoiva = Math.round(montoiva * 100) / 100;
	
	        uni = data[index].unidad.reverse();
	        tipounidad = 0;
	        if (data[index].tipofactor === "1") {
	          cantie = parseFloat(data[index].cantidadE / data[index].valorfactor);
	          //cantie = Math.round(cantie * 100) / 100;
	          cantie = Math.trunc(cantie);
	        }
	      } else {
	        precio = data[index].costocalculadoalter * (1 + data[index].utipreciomaxialter / 100);
	        precio = Math.round(precio * 100) / 100;
	        precio = precio * data[index].valormoneda;
	        precio = precio / tasa;
	        precio = Math.round(precio * 100) / 100;
	        //   valorfactor = data[index].valorfactor*data[index].cantidadE;
	        montoiva = precio * data[index].ivaventa / 100;
	        montoiva = Math.round(montoiva * 100) / 100;
	
	        uni = data[index].unidad.reverse();
	        tipounidad = 1;
	        if (data[index].tipofactor === "0") {
	          cantie = parseFloat(data[index].cantidadE / data[index].valorfactor);
	          //cantie = Math.round(cantie * 100) / 100;
	          cantie = Math.trunc(cantie);
	        }
	      }
	
	      // data[index].cantidadE = valorfactor;
	      data[index].tipounidad = tipounidad;
	      data[index].precio = precio;
	      data[index].montoiva = montoiva;
	      data[index].unidad = uni;
	      data[index].total = precio * data[index].cantidad;
	      data[index].montoiva = precio * data[index].cantidad * data[index].iva / 100;
	      data[index].cantidadE = cantie;
	
	      setRecords(data);
	      //  setTimeout(() => txtCantidad.current[index].focus(), 300);
	    };
	  };
	
	  var onCambioMoneda = function onCambioMoneda(values) {
	    var tasa = 0.0;
	    var data = [].concat(_toConsumableArray(records));
	    var precio = 0.0;
	    var ivato = 0.00;
	    var totalreten = 0.00;
	    var retenido = txtTotalreten.current.value;
	
	    for (var i = 0; i < data.length; i++) {
	
	      tasa = data[i].valormoneda;
	
	      if (values.subpredeterminada === true) {
	        precio = (0, _varios.round)(data[i].precio / tasa, 2);
	        ivato = (0, _varios.round)(data[i].montoiva / tasa, 2);
	        totalreten = (0, _varios.round)(retenido, 2);
	        setValida(0);
	      } else {
	        precio = (0, _varios.round)(data[i].precio * data[i].valormoneda, 2);
	        ivato = (0, _varios.round)(data[i].montoiva * data[i].valormoneda, 2);
	        totalreten = (0, _varios.round)(retenido * tasa, 2);
	        setValida(1);
	      }
	
	      data[i].precio = precio;
	      data[i].montoiva = ivato;
	      data[i].total = (0, _varios.round)(precio * data[i].cantidad, 2);
	    }
	
	    setRecords(data);
	    calcularTotales(data, totalreten);
	  };
	
	  var validarCantidad = function validarCantidad(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	          event.target.value = "1,00";
	        }
	        event.target.value = (0, _varios.formatoMonto)(event.target.value);
	        var char1 = event.target.value.substring(0, 1);
	        var char2 = event.target.value.substring(1, 2);
	        if (char1 === "0" && char2 !== ",") {
	          event.target.value = event.target.value.substring(1, event.target.value.length);
	        }
	        if (event.target.id === "cantidad") {
	          //var canti = parseFloat(event.target.value.replace(/\./g, '').replace(',', '.'));
	          var canti = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	          var data = [].concat(_toConsumableArray(records));
	          if (canti > data[index].cantidadE) {
	            data[index].cantidad = 1.0;
	            canti = 1.0;
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La  cantidad no debe ser mayor a la cantidad existente",
	              icono: "informacion"
	            });
	          }
	          //data[index].montodeclarado = event.target.value;
	          //data[index].montodeclarado = formatoMonto(event.target.value).replace(/\./g, '').replace(',', '.');
	          data[index].cantidad = canti;
	          data[index].total = data[index].precio * canti;
	          data[index].montoiva = data[index].precio * canti * data[index].iva / 100;
	          setRecords(data);
	
	          if (event.which === 13) {
	            if (index < data.length - 1) {
	              setTimeout(function () {
	                return txtCantidad.current[index + 1].focus();
	              }, 300);
	            } else {
	              //btnProducto.current.focus();
	            }
	          }
	        }
	      } else if (event.which === 46) {
	        return false;
	      } else if (event.which >= 48 && event.which <= 57) {
	        return true;
	      } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	        return true;
	      } else return false;
	    };
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    setActcredit(1);
	    setMostrar(true);
	  };
	
	  var handleCloseNo = function handleCloseNo() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    setActcredit(0);
	    setMostrar(true);
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "tipo") {
	      e.target.value = e.target.value.toUpperCase();
	      setRecords([]);
	      if (selectp !== 0) {
	        txtIdNotaEntrega.current.value = "";
	      }
	      txtRif.current.value = "";
	      cmbRif.current.selectedIndex = -1;
	      cmbMoneda.current.selectedIndex = 0;
	      setIdCliente();
	      setNomCliente("");
	      setDirCliente("");
	      setNumNota("");
	      txtSubTotal.current.value = "";
	      txtTotIva.current.value = "";
	      txtTotal.current.value = "";
	
	      if (e.target.value === "1") {
	        setHabilitadoCli(true);
	        setHabilitadoMod(true);
	        setHabilitadoProductos(false);
	        setHabilitarMoneda(true);
	      } else {
	        setHabilitadoCli(false);
	        setHabilitadoMod(false);
	        setHabilitadoProductos(true);
	        setHabilitarMoneda(false);
	      }
	    } else if (e.target.name === "cedula") {
	      setIdCliente();
	      setNomCliente("");
	      setDirCliente("");
	    } else if (e.target.name === "idnotaentre") {
	      setRecords([]);
	      setNomCliente("");
	      setDirCliente("");
	      /*setNomVendedor('');
	            setCedRif('');*/
	      setNumNota("");
	      txtFecha.current.value = "";
	      cmbMoneda.current.selectedIndex = 0;
	    }
	  };
	
	  var seleccionarClienteinput = function seleccionarClienteinput(rif, tecla) {
	    var campos = "ag.*";
	    var endpoint = op.conexion + "/api/consulta/clienteporvendedorinput?campos=" + campos + "&id=" + idvendedor + "&rifcliente=" + rif;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          cmbRif.current.value = response.data.rif.trim().substring(0, 1);
	          txtRif.current.value = response.data.rif.trim().substring(1, 10);
	          setNomCliente(response.data.nombre);
	          setDirCliente(response.data.direccion.trim());
	          if (tecla === 13) {
	            txtFecha.current.focus();
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un cliente con este codigo",
	            icono: "informacion"
	          });
	          txtRif.current.value = "";
	          cmbRif.current.selectedIndex = -1;
	          if (tecla === 13) {
	            txtRif.current.focus();
	          }
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarVendedor = function seleccionarVendedor(idv) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "idagente";
	    var nomid2 = "proveedor";
	
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + idv + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtNomVendedor.current.value = response.data.nombre;
	          txtCedRifVendedor.current.value = response.data.rif;
	          setCedRif(response.data.rif);
	          setNomVendedor(response.data.nombre);
	          setIdvendedor(response.data.idagente);
	          setIdAlmacen(response.data.idalmacen);
	          setHabilitadoCli(true);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El usuario no tiene un vendedor asociado",
	            icono: "informacion"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarMoneda = function seleccionarMoneda() {
	    var endpoint = op.conexion + "/api/moneda/seleccionarmonedasdos";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	
	          var datamoneda = [];
	
	          for (var i = 0; i < response.data.length; i++) {
	            datamoneda.push({
	              descripcion: response.data[i].descripcion,
	              idmoneda: response.data[i].idmoneda,
	              predeterminada: response.data[i].predeterminada,
	              simbolo: response.data[i].simbolo,
	              subpredeterminada: response.data[i].subpredeterminada,
	              valormoneda: response.data[i].valormoneda
	            });
	          }
	          setMoneda(datamoneda);
	          setComboMoneda(datamoneda);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro(id) {
	    var campos = "*";
	    var nomtab = "facturacompra";
	    var nomid = "idfacturacompra";
	    //let id = id;
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtNumFactura.current.value = response.data.codigo;
	          setNumfact(response.data.codigo);
	          setIdfact(response.data.idfacturacompra);
	          txtNcontrol.current.value = response.data.numcontrol;
	          txtFechafactura.current.value = (0, _moment2.default)(response.data.fechafactura).format('YYYY-MM-DD');
	          seleccionarVendedor(response.data.idproveedor);
	          seleccionarMoneda();
	          seleccionarDetalle(id, response.data.tasa);
	          setTasa(response.data.tasa);
	          setHabilitadoTip(false);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "ID no existe.",
	            icono: "informacion"
	          });
	          txtIdFactura.current.value = "";
	          txtIdFactura.current.focus();
	        }
	      }
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarDetalle = function seleccionarDetalle(id, tasac) {
	    var nomtab1 = "facturacompra_detalle";
	    var nomtab2 = "facturacompra";
	    var nomid = "idfacturacompra";
	    var endpoint = op.conexion + "/api/inventario/seleccionarfactucompradet?id=" + id + "&nomtab1=" + nomtab1 + "&nomtab2=" + nomtab2 + "&nomid=" + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var prod = [];
	          var uni = [];
	
	          for (var i = 0; i < response.data.length; i++) {
	            if (parseInt(response.data[i].idunidadalterna) === 0 || response.data[i].idunidadalterna === null) {
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	            } else {
	              if (response.data[i].tipounidad === 0) {
	                uni = [{
	                  idunidad: response.data[i].idunidadmedida,
	                  descripcion: response.data[i].descripcionuni,
	                  tipo: "medida"
	                }, {
	                  idunidad: response.data[i].idunidadalterna,
	                  descripcion: response.data[i].descripcionunialt,
	                  tipo: "alterna"
	                }];
	              } else {
	                uni = [{
	                  idunidad: response.data[i].idunidadalterna,
	                  descripcion: response.data[i].descripcionunialt,
	                  tipo: "alterna"
	                }, {
	                  idunidad: response.data[i].idunidadmedida,
	                  descripcion: response.data[i].descripcionuni,
	                  tipo: "medida"
	                }];
	              }
	            }
	
	            var montoiva = response.data[i].punitario * response.data[i].iva / 100;
	            montoiva = Math.round(montoiva * 100) / 100;
	
	            if (montoiva > 0) {
	              setIvas(response.data[i].iva);
	            } else {
	              setIvas(0.00);
	            }
	
	            prod.push({
	              idproducto: response.data[i].idproducto,
	              codigo: response.data[i].codigo,
	              cantidad: response.data[i].cantidad,
	              nombrecorto: response.data[i].nombrecorto,
	              precio: response.data[i].punitario,
	              precious: response.data[i].punitario,
	              iva: response.data[i].iva,
	              ivaventa: response.data[i].ivaventa,
	              montoiva: response.data[i].cantidad * montoiva,
	              total: response.data[i].cantidad * response.data[i].punitario,
	              unidad: uni,
	              idunidadmedida: response.data[i].idunidadmedida,
	              idunidadalterna: response.data[i].idunidadalterna,
	              costocalculado: response.data[i].costocalculado,
	              costocalculadoalter: response.data[i].costocalculadoalter,
	              utipreciomaxi: response.data[i].utipreciomaxi,
	              utipreciomaxialter: response.data[i].utipreciomaxialter,
	              tipounidad: response.data[i].tipounidad,
	              valormoneda: response.data[i].valormoneda,
	              idmoneda: response.data[i].idmoneda,
	              tipofactor: response.data[i].tipofactor,
	              valorfactor: response.data[i].valorfactor
	            });
	          }
	          setRecords(prod);
	          seleccionarRetenciones(id, prod, tasac);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var validarIdProductoM = function validarIdProductoM(index) {
	    return function (event) {
	      (0, _varios.validaSoloNumero)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        if (event.target.value !== "") {} else {
	          var data = [].concat(_toConsumableArray(records));
	          setRecords(data);
	        }
	      }
	    };
	  };
	
	  var onChangeMoneda = function onChangeMoneda(e) {
	    var i = e.target.value;
	    onCambioMoneda(combomoneda[i]);
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    if (accbtncntxcobrar && accbtncntxcobrar.toString().substring(1, 2) === "1") {
	      setMostrar(true);
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var seleccionarRetenciones = function seleccionarRetenciones(id, data, tasac) {
	    var endpoint = op.conexion + "/api/retenciones/seleccionarretenciones?idfacturacompra=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var total = 0.00;
	          var _monto = 0.00;
	          var montod = void 0;
	          for (var i = 0; i < response.data.length; i++) {
	            total = parseFloat(total) + parseFloat(response.data[i].total);
	          }
	          _monto = (0, _varios.round)(total, 2);
	          montod = (0, _varios.round)(total, 2);
	          txtTotalreten.current.value = montod;
	          calcularTotales(data, _monto);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var calcularTotales = function calcularTotales(datos, reten) {
	    var subtot = 0.0,
	        descu = 0.0,
	        totiva = 0.0,
	        totalm = 0.0;
	    for (var i = 0; i < datos.length; i++) {
	      subtot = subtot + datos[i].total;
	      totiva = totiva + datos[i].montoiva;
	    }
	    totalm = subtot + totiva;
	    txtSubTotal.current.value = (0, _varios.formatMoneda)(subtot.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    txtTotIva.current.value = (0, _varios.formatMoneda)(totiva.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    txtTotal.current.value = (0, _varios.formatMoneda)(totalm.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    txtTotalRetenido.current.value = (0, _varios.formatMoneda)(reten.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	    var mtotalm = totalm - reten;
	
	    txtMontoTotal.current.value = (0, _varios.formatMoneda)(mtotalm.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	    var tosaldo = 0.0;
	    tosaldo = totalm - reten - props.abono;
	
	    txtAbono.current.value = (0, _varios.formatMoneda)(props.abono.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    txtSaldo.current.value = (0, _varios.formatMoneda)(tosaldo.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    setMonto(tosaldo);
	    setMivas(totiva);
	  };
	
	  var imprimirFactura = function imprimirFactura() {
	    if (accbtncntxcobrar && accbtncntxcobrar.toString().substring(4, 5) === "1") {
	      var fact = 0;
	      if (txtIdFactura.current.value !== "") {
	        var idnot = txtIdFactura.current.value;
	
	        var reporte = "ReportFacturaEntrega";
	
	        window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&idnota=" + idnot, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Seleccione la Factura !",
	          icono: "informacion"
	        });
	        fact = 1;
	      }
	
	      if (fact === 1) {
	        txtIdFactura.current.focus();
	      }
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    props.onHideCancelar();
	    props.onRenderizar();
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      size: "xl",
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        if (props.ope === 1) {
	          seleccionarRegistro(props.idnot);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Factura de Compra"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 ", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12 row border-azul mx-auto rounded py-1" },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "colfull1070 col-pd-470 mx-auto mb-1 py-1 px-1",
	              style: { fontSizeAdjust: "0.6" }
	            },
	            _react2.default.createElement(
	              "fieldset",
	              { className: "col-md-12 mx-auto row border-azul rounded py-2 px-1" },
	              _react2.default.createElement(
	                "legend",
	                { className: "float-none m-0 w-auto fw-bold fs-5" },
	                "Datos de la Factura"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-pd-250 px-1" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "N\xB0 FACTURA:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  ref: txtNumFactura,
	                  autoComplete: "off",
	                  disabled: true,
	                  type: "text",
	                  className: "form-control fs-6",
	                  name: "cedula",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  onKeyUp: validarCliente,
	                  onBlur: validarCliente,
	                  onChange: onChange
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-pd-200 px-1" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "N\xB0 CONTROL:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  ref: txtNcontrol,
	                  className: "form-control fs-6",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-pd-260 px-1" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "FECHA FACTURA:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "date",
	                  className: "form-control fs-6",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  ref: txtFechafactura
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "colfull1070 col-pd-600 mx-auto row mb-1 py-1",
	              style: { fontSizeAdjust: "0.6" }
	            },
	            _react2.default.createElement(
	              "fieldset",
	              { className: "col-md-12 mx-auto row mb-1 py-2 border-azul rounded " },
	              _react2.default.createElement(
	                "legend",
	                { className: "float-none m-0 w-auto fw-bold fs-5" },
	                "Datos del Proveedor"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-pd-230 px-1" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "CEDULA/RIF:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  ref: txtCedRifVendedor,
	                  className: "form-control fs-6",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                }),
	                operacion === 1 && selectp === 0 ? _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: operacion === 1 && selectp === 0 ? false : true,
	                    type: "button",
	                    onClick: function onClick() {
	                      setTipoAgente("vendedor");
	                      setCatalogoVendedor(true);
	                    },
	                    className: "btn btn-success"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-search" })
	                ) : ""
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-1 col-pd-570 px-1" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "NOMBRE:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  ref: txtNomVendedor,
	                  className: "form-control fs-6",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "colfull col-pd-170 mb-1 ml-auto" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group input-group-sm" },
	              _react2.default.createElement(
	                "select",
	                {
	                  className: "form-control form-control-sm form-select fw-bold",
	                  ref: txtIdmoneda,
	                  onChange: onChangeMoneda
	                },
	                combomoneda && combomoneda.map(function (item, index) {
	                  return _react2.default.createElement(
	                    "option",
	                    { key: index, value: index },
	                    " ",
	                    item.descripcion + " " + item.simbolo,
	                    " "
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "col-md-12 border-azul rounded px-0",
	              style: { backgroundColor: "#d5e9ff" }
	            },
	            _react2.default.createElement(
	              TblContainer,
	              {
	                container: {
	                  height: 190,
	                  width: "100%",
	                  overflow: "auto",
	                  padding: "2px",
	                  fontSizeAdjust: "0.6"
	                }
	              },
	              _react2.default.createElement(TblHead, null),
	              _react2.default.createElement(
	                _core.TableBody,
	                { className: "overflow-hidden" },
	                records && records.map(function (item, index) {
	                  return _react2.default.createElement(
	                    _core.TableRow,
	                    { key: index, style: { padding: "0" } },
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: "align-middle bg-light text-center p-0 d-flex" },
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        style: {
	                          borderBottomRightRadius: 0,
	                          borderTopRightRadius: 0,
	                          height: "37px"
	                        },
	                        disabled: habilitadoProductos,
	                        ref: function ref(el) {
	                          return txtId.current[index] = el;
	                        },
	                        className: "form-control form-control-sm bg-light text-center fs-6",
	                        defaultValue: item.idproducto,
	                        onKeyUp: validarIdProductoM(index),
	                        onBlur: validarIdProductoM(index)
	                      })
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      {
	                        className: "align-middle bg-light text-start p-0 pl-2",
	                        style: { width: "270px" }
	                      },
	                      item.nombrecorto
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      {
	                        className: "align-middle bg-light d-fex justify-content-center p-0",
	                        style: { width: "60px" }
	                      },
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        className: "form-control form-control-sm bg-light text-right fs-6",
	                        id: "cantidad",
	                        disabled: !habilitadoMod,
	                        defaultValue: (0, _varios.formatMoneda)(item.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                        ref: function ref(el) {
	                          return txtCantidad.current[index] = el;
	                        },
	                        onFocus: _varios.seleccionarCampo,
	                        onKeyUp: validarCantidad(index),
	                        onBlur: validarCantidad(index),
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm"
	                      })
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      {
	                        className: "align-middle bg-light text-end p-0 pr-2",
	                        style: { width: "50px" }
	                      },
	                      (0, _varios.formatMoneda)(item.precio.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      {
	                        className: "align-middle bg-light p-0",
	                        style: { width: 50 }
	                      },
	                      _react2.default.createElement(
	                        "select",
	                        {
	                          className: "form-control form-control-sm fs-6",
	                          style: { width: "100%" },
	                          disabled: habilitadoProductos,
	                          onChange: onCambioUnidad(index)
	                        },
	                        item.unidad && item.unidad.map(function (item2, x) {
	                          return _react2.default.createElement(
	                            "option",
	                            { key: x, value: item2.idunidad },
	                            " ",
	                            item2.descripcion,
	                            " "
	                          );
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      {
	                        className: "align-middle bg-light text-end p-0 pr-2",
	                        style: { width: "50px" }
	                      },
	                      (0, _varios.formatMoneda)(item.iva.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      {
	                        className: "align-middle bg-light text-end p-0 pr-2",
	                        style: { width: "50px" }
	                      },
	                      (0, _varios.formatMoneda)(item.montoiva.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      {
	                        className: "align-middle bg-light text-end p-0 pr-2",
	                        style: { width: "50px" }
	                      },
	                      (0, _varios.formatMoneda)(item.total.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    )
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row m-0 px-0" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-8 mt-auto px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 px-0 border-azul p-1 rounded border-3" },
	                _react2.default.createElement(
	                  "h4",
	                  { className: "fw-bold" },
	                  "RETENCIONES ",
	                  _react2.default.createElement("i", { className: "fas fa-arrow-down" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 px-0 mx-0 rounded" },
	                _react2.default.createElement(_tablaRetencionesDos2.default, {
	                  idfact: props.idnot,
	                  tasa: tasa,
	                  val: valida
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-4 border-azul rounded p-2 shadow px-1",
	                style: { backgroundColor: "#dbeeff" }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "input-group input-group-sm  col-md-12",
	                  style: { fontSizeAdjust: "0.7" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text bg-transparent border-0",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "SUBTOTAL: ",
	                  moneda.simbolo
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  disabled: true,
	                  ref: txtSubTotal,
	                  className: "form-control bg-transparent text-right rounded border-0 fs-5 fw-bold",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "input-group input-group-sm  col-md-12",
	                  style: { fontSizeAdjust: "0.7" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text bg-transparent border-0",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "TOTAL IVA: ",
	                  moneda.simbolo
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  disabled: true,
	                  ref: txtTotIva,
	                  className: "form-control bg-transparent text-right rounded border-0 fs-5 fw-bold",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "input-group input-group-sm  col-md-12",
	                  style: { fontSizeAdjust: "0.7" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text bg-transparent border-0",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "TOTAL: ",
	                  moneda.simbolo
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  disabled: true,
	                  ref: txtTotal,
	                  className: "form-control bg-transparent text-right rounded border-0 fs-5 fw-bold",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "input-group input-group-sm  col-md-12",
	                  style: { fontSizeAdjust: "0.7" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text bg-transparent border-0",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "TOTAL RETENIDO: ",
	                  moneda.simbolo
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  disabled: true,
	                  ref: txtTotalRetenido,
	                  className: "form-control bg-transparent text-right rounded border-0 fs-5 fw-bold",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                }),
	                _react2.default.createElement("input", { type: "hidden", ref: txtTotalreten })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "input-group input-group-sm  col-md-12",
	                  style: { fontSizeAdjust: "0.7" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text bg-transparent border-0",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "MONTO TOTAL: ",
	                  moneda.simbolo
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  disabled: true,
	                  ref: txtMontoTotal,
	                  className: "form-control bg-transparent text-right rounded border-0 fs-5 fw-bold",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "input-group input-group-sm  col-md-12",
	                  style: { fontSizeAdjust: "0.7" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text bg-transparent border-0",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "ABONO: ",
	                  moneda.simbolo
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  disabled: true,
	                  ref: txtAbono,
	                  className: "form-control bg-transparent text-right rounded border-0 fs-5 fw-bold",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "input-group input-group-sm  col-md-12",
	                  style: { fontSizeAdjust: "0.7" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text bg-transparent border-0",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "SALDO: ",
	                  moneda.simbolo
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  disabled: true,
	                  ref: txtSaldo,
	                  className: "form-control bg-transparent text-right rounded border-0 fs-5 fw-bold",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          className: "btn btn-sm btn-success rounded-pill",
	          onClick: onChangeValidar,
	          style: { margin: "5px" }
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Registrar Pago"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          onClick: imprimirFactura,
	          style: { margin: "5px" },
	          className: "btn btn-sm btn-primary rounded-pill",
	          title: "Imprimir Nota de Entrega"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fa fa-print" },
	          " Imprimir"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    ),
	    _react2.default.createElement(_modalRegistrarPagoCompras.RegistrarPagoFCompras, {
	      show: mostrar,
	      ope: 1,
	      idfactu: idfact,
	      numfactu: numfact,
	      siescredit: actcredit,
	      idclient: idvendedor,
	      idvendedor: idVendedor,
	      onRenderizar: cerrarModal,
	      monto: monto,
	      iva: ivas,
	      montoiva: mivas,
	      abono: props.abono,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar(false);
	      }
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "Cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: handleCloseNo,
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = RegistrarPagodeFactura;

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActualizarMoviles = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActualizarMoviles = exports.ActualizarMoviles = function ActualizarMoviles(props) {
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var cmbCedula = ["J", "V", "G", "P"];
	
	  var _useState = (0, _react.useState)(),
	      _useState2 = _slicedToArray(_useState, 2),
	      msg = _useState2[0],
	      setMsg = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      mostrar1 = _useState4[0],
	      setMostrar1 = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      visible = _useState6[0],
	      setVisible = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      activate = _useState8[0],
	      setActivate = _useState8[1];
	
	  var txtIdcliente = (0, _react.useRef)();
	  var txtCedula = (0, _react.useRef)();
	  var txtNombreRespon = (0, _react.useRef)();
	  var txtObserStatus = (0, _react.useRef)();
	  var txtDireccionRespon = (0, _react.useRef)();
	  var txtNumContac = (0, _react.useRef)();
	  var txtSerialCa = (0, _react.useRef)();
	  var txtSerialMt = (0, _react.useRef)();
	  var txtPeso = (0, _react.useRef)();
	  var cmbCedularespon = ["J", "V", "G", "P"];
	  var cmbRifrespon = (0, _react.useRef)();
	  var txtCedulaPro = (0, _react.useRef)();
	  var txtNombrePro = (0, _react.useRef)();
	  var txtNumPro = (0, _react.useRef)();
	  var txtDireccionPro = (0, _react.useRef)();
	  var txtNumPuesto = (0, _react.useRef)();
	  var txtTipoVh = (0, _react.useRef)();
	  var txtMarcaVh = (0, _react.useRef)();
	  var txtAnioVh = (0, _react.useRef)();
	  var txtValorVh = (0, _react.useRef)();
	  var txtModeloVh = (0, _react.useRef)();
	  var txtId = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtPlacaVh = (0, _react.useRef)();
	  var txtClaseVh = (0, _react.useRef)();
	  var txtCheck = (0, _react.useRef)();
	  var txtUsoVh = (0, _react.useRef)();
	  var txtColorVh = (0, _react.useRef)();
	  var txtCapCarga = (0, _react.useRef)();
	  var txtFechaIns = (0, _react.useRef)();
	
	  var _useState9 = (0, _react.useState)([]),
	      _useState10 = _slicedToArray(_useState9, 2),
	      anio = _useState10[0],
	      setAnio = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(null),
	      _useState12 = _slicedToArray(_useState11, 2),
	      body = _useState12[0],
	      setBody = _useState12[1];
	
	  var _useState13 = (0, _react.useState)('colorbloqueado'),
	      _useState14 = _slicedToArray(_useState13, 2),
	      bloquear = _useState14[0],
	      setBloquear = _useState14[1];
	
	  var _useState15 = (0, _react.useState)([]),
	      _useState16 = _slicedToArray(_useState15, 2),
	      fechas = _useState16[0],
	      setFechas = _useState16[1];
	
	  var _useState17 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState18 = _slicedToArray(_useState17, 2),
	      mensaje = _useState18[0],
	      setMensaje = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      mensajesino = _useState20[0],
	      setMensajesino = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(false),
	      _useState22 = _slicedToArray(_useState21, 2),
	      catalogoModelo = _useState22[0],
	      setCatalogoModelo = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(false),
	      _useState24 = _slicedToArray(_useState23, 2),
	      deshabilitado = _useState24[0],
	      setDeshabilitado = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(0),
	      _useState26 = _slicedToArray(_useState25, 2),
	      operacion = _useState26[0],
	      setOperacion = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      tabIndex = _useState28[0],
	      setTabIndex = _useState28[1];
	
	  var token = sessionStorage.getItem('jwtToken');
	  var op = __webpack_require__(8);
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	
	  var onChange = function onChange(event) {};
	
	  var onCheck = function onCheck() {
	
	    if (txtCheck.current.checked) {
	      txtCedula.current.value = txtCedulaPro.current.value;
	      txtNombreRespon.current.value = txtNombrePro.current.value;
	      txtDireccionRespon.current.value = txtDireccionPro.current.value;
	      txtNumContac.current.value = txtNumPro.current.value;
	      cmbRifrespon.current.value = cmbRif.current.value;
	    } else {
	      txtCedula.current.value = "";
	      txtNombreRespon.current.value = "";
	      txtDireccionRespon.current.value = "";
	      txtNumContac.current.value = "";
	    }
	  };
	
	  var handleInputMontoChange = function handleInputMontoChange(event) {
	    (0, _varios.validaMonto)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	
	      if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
	        event.target.value = '0,00';
	      }
	      event.target.value = (0, _varios.formatoMonto)(event.target.value);
	      var char1 = event.target.value.substring(0, 1);
	      var char2 = event.target.value.substring(1, 2);
	      if (char1 === '0' && char2 !== ',') {
	        event.target.value = event.target.value.substring(1, event.target.value.legth);
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/servicios/actualizaromoviles/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Registro Creado Correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Registro Modificado Correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Registro Eliminado Correctamente",
	            icono: "exito"
	          });
	        }
	        blanquear();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = error.response.data.message;
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleInputNumChange = function handleInputNumChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    var valido;
	    if (event.which === 13 || typeof event.which === 'undefined') {} else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope !== 4) {
	      if (txtObserStatus.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Seleccione el Estatus !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtObserStatus.current.focus();
	      } else if (txtFechaIns.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Seleccione la Fecha !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtFechaIns.current.focus();
	      } else if (txtCedulaPro.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Seleccione el Cliente !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtCedulaPro.current.focus();
	      } else if (cmbRifrespon.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Seleccione el Tipo de Documento !",
	          icono: "informacion"
	        });
	        sigue = false;
	        cmbRifrespon.current.focus();
	      } else if (txtCedula.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Introduzca el N° de Cédula/RIF del Responsable!",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtCedula.current.focus();
	      } else if (txtNombreRespon.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Introduzca el Nombre del Responsable !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtNombreRespon.current.focus();
	      } else if (txtDireccionRespon.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Introduzca la Dirección del Responsable !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtDireccionRespon.current.focus();
	      } else if (txtSerialCa.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Introduzca el Serial de la Carroceria !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtSerialCa.current.focus();
	      } else if (txtPeso.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ El Campo Peso no debe ir Vacio !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtPeso.current.focus();
	      } else if (txtCapCarga.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ El Campo CAP(CARGA Tons) no debe ir Vacio !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtCapCarga.current.focus();
	      } else if (txtSerialMt.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Introduzca el Serial del Motor !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtSerialMt.current.focus();
	      } else if (txtAnioVh.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ El Campo Año no debe ir Vacio !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtAnioVh.current.focus();
	      } else if (txtMarcaVh.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ El Campo Marca no debe ir Vacio !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtMarcaVh.current.focus();
	      } else if (txtModeloVh.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ El Campo Modelo no debe ir Vacio !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtModeloVh.current.focus();
	      } else if (txtColorVh.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ El Campo Color no debe ir Vacio !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtColorVh.current.focus();
	      } else if (txtTipoVh.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ El Campo Tipo(Movil) no debe ir Vacio !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtTipoVh.current.focus();
	      } else if (txtPlacaVh.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Introduzca la Placa del Movil !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtPlacaVh.current.focus();
	      } else if (txtNumPuesto.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Introduzca la Cantidad de Puestos del Movil !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtNumPuesto.current.focus();
	      } else if (txtUsoVh.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Describa el USO del Movil !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtUsoVh.current.focus();
	      } else {
	        sigue = true;
	      }
	
	      if (sigue) {
	
	        var moviles = [];
	
	        moviles.push({
	          idmovil: txtId.current.value !== "" ? txtId.current.value : 0,
	          idpropietario: txtIdcliente.current.value,
	          nombrerespo: txtNombreRespon.current.value.trim(),
	          cedularespo: cmbRif.current.value + txtCedula.current.value,
	          direccionrespo: txtDireccionRespon.current.value.trim(),
	          telefonorespo: txtNumContac.current.value,
	          celularrespo: txtNumContac.current.value,
	          serialcarroceria: txtSerialCa.current.value,
	          serialmotor: txtSerialMt.current.value,
	          placa: txtPlacaVh.current.value,
	          marca: txtMarcaVh.current.value.trim(),
	          modelo: txtModeloVh.current.value.trim(),
	          anio: txtAnioVh.current.value,
	          color: txtColorVh.current.value,
	          uso: txtUsoVh.current.value,
	          numpuesto: txtNumPuesto.current.value,
	          peso: txtPeso.current.value.trim().replace(".", "").replace(",", "."),
	          capacidadcarga: txtCapCarga.current.value.trim().replace(".", "").replace(",", "."),
	          tipovehiculo: txtTipoVh.current.value.trim(),
	          fecharegistro: txtFechaIns.current.value,
	          status: txtObserStatus.current.value
	        });
	
	        setBody({
	          moviles: moviles
	        });
	
	        var _msg = "";
	        if (operacion === 1) {
	          _msg = "Esta Seguro de Procesar este Registro.";
	        } else if (operacion === 2) {
	          _msg = "Esta Seguro de Modificar este Registro.";
	        } else if (operacion === 3) {
	          _msg = "Esta Seguro de Eliminar este Registro.";
	        }
	
	        setMensajesino({
	          mostrar: true,
	          titulo: "Confirmación.",
	          texto: _msg,
	          icono: "confirmacion"
	        });
	      }
	    }
	  };
	
	  var blanquear = function blanquear() {
	    setVisible(false);
	    setMostrar1(false);
	    setActivate(false);
	    setDeshabilitado(false);
	    setTabIndex(0);
	    setFechas([]);
	    setOperacion(0);
	    setMsg('');
	    setOperacion(0);
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var cancelar = function cancelar(e) {
	    e.preventDefault();
	    blanquear();
	    props.onHideCancelar();
	    //props.onRenderizar();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    props.onHideCancelar();
	    if (props.ope === 3 || props.ope === 2) {
	      props.onHideCancelaDos();
	    } else {
	      props.onRenderizar();
	    }
	  };
	
	  var onCatalogoCliente = function onCatalogoCliente(values) {
	    setCatalogoModelo(false);
	    txtCedulaPro.current.value = values.rif.substring(1, 12);
	    txtNombrePro.current.value = values.nombre;
	    txtDireccionPro.current.value = values.direccion;
	    txtNumPro.current.value = values.celular;
	    txtIdcliente.current.value = values.idagente;
	    cmbRif.current.value = values.rif.substring(0, 1);
	  };
	
	  var seleccionarCliente = function seleccionarCliente(id, oper) {
	    var campos = "idagente, trim(nombre) as nombre, trim(direccion) as direccion, rif, celular";
	    var nomtab = "agente";
	    var nomid = "";
	
	    if (oper === 2) {
	      nomid = 'rif';
	    } else {
	      nomid = 'idagente';
	    }
	
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&id=" + id + "&nomtab=" + nomtab + "&nomid=" + nomid;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idagente > 0) {
	          txtCedulaPro.current.value = response.data.rif.substring(1, 12);
	          txtNombrePro.current.value = response.data.nombre;
	          txtDireccionPro.current.value = response.data.direccion;
	          txtNumPro.current.value = response.data.celular;
	          cmbRif.current.value = response.data.rif.substring(0, 1);
	          if (oper === 2 || props.ope === 5) {
	            txtIdcliente.current.value = response.data.idagente;
	          }
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var validarCliente = function validarCliente(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (cmbRif.current.value !== "" && event.target.value !== "") {
	        var rif = cmbRif.current.value + event.target.value;
	        seleccionarCliente(rif, 2);
	      }
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	
	    if (props.data.length > 0) {
	      var i = void 0;
	      var years = [];
	
	      for (i = (0, _moment2.default)(fechasistema).format('YYYY'); i >= (0, _moment2.default)(fechasistema).format('YYYY') - 40; i--) {
	        years.push(i);
	      }
	      setFechas(years);
	    } else {
	      var _i = void 0;
	      var _years = [];
	
	      for (_i = (0, _moment2.default)(fechasistema).format('YYYY'); _i >= (0, _moment2.default)(fechasistema).format('YYYY') - 40; _i--) {
	        _years.push(_i);
	      }
	      setFechas(_years);
	    }
	  }, [props.data]);
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "xl",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.ope !== 1) {
	          if (props.ope === 5) {
	            setOperacion(1);
	            seleccionarCliente(props.data[0].idpropietario, 1);
	            setTabIndex(props.data[0].idpropietario);
	          } else {
	            setOperacion(props.ope);
	            seleccionarCliente(props.data.idpropietario, 1);
	            txtPeso.current.value = (0, _varios.formatMoneda)(props.data.peso.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtCapCarga.current.value = (0, _varios.formatMoneda)(props.data.capacidadcarga.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtFechaIns.current.value = (0, _moment2.default)(props.data.fecharegistro).format('YYYY-MM-DD');
	            txtCedula.current.value = props.data.cedularespo.substring(1, 12).trim();
	            txtNombreRespon.current.value = props.data.nombrerespo.trim();
	            txtDireccionRespon.current.value = props.data.direccionrespo.trim();
	            txtNumContac.current.value = props.data.celularrespo !== null ? props.data.celularrespo.trim() : 0;
	            txtSerialCa.current.value = props.data.serialcarroceria.trim();
	            txtSerialMt.current.value = props.data.serialmotor.trim();
	            txtAnioVh.current.value = props.data.anio;
	            txtMarcaVh.current.value = props.data.marca.trim();
	            txtModeloVh.current.value = props.data.modelo.trim();
	            txtColorVh.current.value = props.data.color.trim();
	            txtTipoVh.current.value = props.data.tipovehiculo.trim();
	            txtPlacaVh.current.value = props.data.placa.trim();
	            txtNumPuesto.current.value = props.data.numpuesto;
	            txtUsoVh.current.value = props.data.uso.trim();
	            txtIdcliente.current.value = props.data.idpropietario;
	            cmbRifrespon.current.value = props.data.cedularespo.substring(0, 1).trim();
	            setTabIndex(props.data.idmovil);
	          }
	        } else {
	          setOperacion(props.ope);
	          var i = void 0;
	          var years = [];
	
	          for (i = (0, _moment2.default)(fechasistema).format('YYYY'); i >= (0, _moment2.default)(fechasistema).format('YYYY') - 40; i--) {
	            years.push(i);
	          }
	          setFechas(years);
	        }
	      }
	
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant", style: { height: '40px' } },
	      _react2.default.createElement(
	        "div",
	        { style: { color: "#fff" } },
	        props.ope === 1 ? 'Agregar Móvil.' : props.ope === 2 ? 'Editar Móvil.' : props.ope === 3 ? 'Eliminar Móvil.' : 'Consultar Móvil.'
	      ),
	      _react2.default.createElement(
	        "button",
	        { ref: btnCancela, className: "btn", style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF", color: "" } },
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({
	            mostrar: false,
	            titulo: "",
	            texto: "",
	            icono: ""
	          });
	        }
	      }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, {
	        mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	        },
	        onHideSi: handleCloseSi
	      }),
	      _react2.default.createElement(_catalogoCliente2.default, {
	        show: catalogoModelo,
	        nomid: "cliente",
	        onHideCancelar: function onHideCancelar() {
	          return setCatalogoModelo(false);
	        },
	        onHideAceptaCatalogo: onCatalogoCliente
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "border-azul rounded mx-auto py-3 px-0" },
	        _react2.default.createElement(
	          "div",
	          { className: "container col-md-12 py-1" },
	          _react2.default.createElement(
	            "div",
	            { className: "container row m-0 px-0" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group input-group-sm mb-1 col-md-2" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group-prepend" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "CODIGO: "
	                )
	              ),
	              _react2.default.createElement("input", { type: "text", disabled: true, ref: txtId, className: "form-control", name: "idvehiculo", defaultValue: props.data && props.data.idmovil, id: "inputCodigo" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group input-group-sm mb-1 col-md-2" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group-prepend" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "input-group-text" },
	                  "ESTATUS: "
	                )
	              ),
	              _react2.default.createElement(
	                "select",
	                { disabled: operacion === 4 || operacion === 3 ? true : deshabilitado, defaultValue: props.data && props.data.status, ref: txtObserStatus, className: "form-control", id: "inputStatus", name: "status", onChange: onChange },
	                _react2.default.createElement(
	                  "option",
	                  { value: "" },
	                  "Seleccione"
	                ),
	                _react2.default.createElement(
	                  "option",
	                  { value: "0" },
	                  "ACTIVO"
	                ),
	                _react2.default.createElement(
	                  "option",
	                  { value: "1" },
	                  "INACTIVO"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group input-group-sm mb-1 col-md-4" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group-prepend" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "input-group-text" },
	                  "FECHA REGISTRO: "
	                )
	              ),
	              _react2.default.createElement("input", { type: "date", disabled: operacion === 4 || operacion === 3 ? true : deshabilitado, ref: txtFechaIns, name: "fechainscripcion", onChange: onChange, className: "form-control col-md-5", id: "inputFechaInscripcion" })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12 m-0 row mx-auto px-0 mb-1" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-6 px-1" },
	            _react2.default.createElement(
	              "fieldset",
	              { className: "row col-md-12 col-12 border-azul rounded mx-auto" },
	              _react2.default.createElement(
	                "legend",
	                { className: "float-none w-auto mx-auto" },
	                "Datos del Propietario"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "container row m-0 px-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm col-md-7 px-1 m-0 mb-1" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: cmbRif,
	                      name: "cmbrif",
	                      disabled: operacion === 4 || operacion === 3 || props.ope === 5 ? true : deshabilitado,
	                      className: "form-select form-select-sm col-md-3 text-center",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "--"
	                    ),
	                    cmbCedula && cmbCedula.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item },
	                        item
	                      );
	                    })
	                  ),
	                  _react2.default.createElement("input", {
	                    ref: txtCedulaPro,
	                    autoComplete: "off",
	                    disabled: operacion === 4 || operacion === 3 || props.ope === 5 ? true : deshabilitado,
	                    maxLength: 12,
	                    type: "text",
	                    onKeyUp: validarCliente,
	                    onBlur: validarCliente,
	                    className: "form-control fs-6 px-1",
	                    name: "cedula",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    { disabled: operacion === 4 || operacion === 3 || props.ope === 5 ? true : deshabilitado, type: "button", onClick: function onClick() {
	                        return setCatalogoModelo(true);
	                      }, className: "btn btn-success" },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  ),
	                  _react2.default.createElement("input", { type: "hidden", ref: txtIdcliente })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm col-md-12 px-1 m-0 mb-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group-prepend" },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "input-group-text" },
	                      "APELLIDOS y NOMBRES:"
	                    )
	                  ),
	                  _react2.default.createElement("input", { type: "text", disabled: true, ref: txtNombrePro, className: "form-control text-uppercase", name: "nombrepropie", onChange: onChange, id: "inputPropiet" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "container row m-0 px-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm col-md-12 px-1 m-0 mb-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group-prepend" },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "input-group-text" },
	                      "DIRECCION:"
	                    )
	                  ),
	                  _react2.default.createElement("textarea", { type: "textarea", style: { height: 70 }, disabled: true, ref: txtDireccionPro, className: "form-control text-uppercase", name: "direccionpropie", onChange: onChange, id: "inputDirecpropiet" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "container row m-0 px-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm col-md-6 px-1 m-0 mb-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group-prepend" },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "input-group-text" },
	                      "N\xB0 TELEFONO:"
	                    )
	                  ),
	                  _react2.default.createElement("input", { type: "text", disabled: true, maxLength: "12", ref: txtNumPro, className: "form-control col-md-5", name: "telefonopropie", onChange: handleInputNumChange, id: "inputTelefonopropie" })
	                ),
	                _react2.default.createElement("div", { className: "col-md-2" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-4" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-check" },
	                    _react2.default.createElement("input", { className: "my-auto form-check-input", disabled: operacion === 4 || operacion === 3 || operacion === 2 ? true : deshabilitado, ref: txtCheck, onChange: onCheck, type: "checkbox", value: "", id: "flexCheckIndeterminate" }),
	                    _react2.default.createElement(
	                      "label",
	                      { className: "my-auto form-check-label", "for": "flexCheckIndeterminate" },
	                      "Responsable"
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-6 px-1" },
	            _react2.default.createElement(
	              "fieldset",
	              { className: "row col-md-12 col-12 border-azul rounded mx-auto" },
	              _react2.default.createElement(
	                "legend",
	                { className: "float-none w-auto mx-auto " },
	                "Datos del Responsable"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "container row m-0 px-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm col-md-7 px-1 m-0 mb-1" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: cmbRifrespon,
	                      name: "cmbrif",
	                      disabled: operacion === 4 || operacion === 3 ? true : deshabilitado,
	                      className: "form-select form-select-sm col-md-3 text-center",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "--"
	                    ),
	                    cmbCedularespon && cmbCedularespon.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item },
	                        item
	                      );
	                    })
	                  ),
	                  _react2.default.createElement("input", {
	                    ref: txtCedula,
	                    autoComplete: "off",
	                    disabled: operacion === 4 || operacion === 3 ? true : deshabilitado,
	                    maxLength: 12,
	                    type: "text",
	                    onKeyUp: validarCliente,
	                    onBlur: validarCliente,
	                    className: "form-control fs-6 px-1",
	                    name: "cedula",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm col-md-12 px-1 m-0 mb-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group-prepend" },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "input-group-text" },
	                      "APELLIDOS y NOMBRES:"
	                    )
	                  ),
	                  _react2.default.createElement("input", { type: "text", disabled: operacion === 4 || operacion === 3 ? true : deshabilitado, ref: txtNombreRespon, className: "form-control text-uppercase", name: "nombrerespo", onChange: onChange, id: "inputNombrerespon" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "container row m-0 px-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm col-md-12 px-1 m-0 mb-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group-prepend" },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "input-group-text" },
	                      "DIRECCION:"
	                    )
	                  ),
	                  _react2.default.createElement("textarea", { type: "textarea", style: { height: 70 }, disabled: operacion === 4 || operacion === 3 ? true : deshabilitado, ref: txtDireccionRespon, className: "form-control text-uppercase", name: "direccionrespo", onChange: onChange, id: "inputDireccionrespon" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "container row m-0 px-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm col-md-6 px-1 m-0 mb-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group-prepend" },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "input-group-text" },
	                      "N\xB0 TELEFONO:"
	                    )
	                  ),
	                  _react2.default.createElement("input", { type: "text", disabled: operacion === 4 || operacion === 3 ? true : deshabilitado, maxLength: "11", ref: txtNumContac, className: "form-control col-md-5", name: "telefonorespo", onChange: handleInputNumChange, id: "inputTelefrespon" })
	                ),
	                _react2.default.createElement("div", { className: "col-md-6" })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "fieldset",
	        { className: "row col-md-12 col-12 border-azul rounded mx-auto" },
	        _react2.default.createElement(
	          "legend",
	          { className: "float-none w-auto" },
	          "Datos del Veh\xEDculo"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container row m-0 px-0" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group input-group-sm col-md-4 px-1 m-0 mb-2" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group-prepend" },
	              _react2.default.createElement(
	                "span",
	                { className: "input-group-text" },
	                "SERIAL(CARROCERIA): "
	              )
	            ),
	            _react2.default.createElement("input", { type: "text", disabled: operacion === 4 || operacion === 3 ? true : deshabilitado, ref: txtSerialCa, className: "form-control text-uppercase", name: "serialcarroceria", onChange: onChange, id: "inputSerialcarro" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group input-group-sm col-pd-150 px-1 m-0 mb-2" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group-prepend" },
	              _react2.default.createElement(
	                "span",
	                { className: "input-group-text" },
	                "PESO: "
	              )
	            ),
	            _react2.default.createElement("input", { type: "text", disabled: operacion === 4 || operacion === 3 ? true : deshabilitado, ref: txtPeso, className: (operacion === 4 || operacion === 3 ? bloquear : deshabilitado) + " form-control", name: "peso", onKeyUp: handleInputMontoChange, onBlur: handleInputMontoChange, id: "inputPeso" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group input-group-sm col-pd-230 px-1 m-0 mb-2" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group-prepend" },
	              _react2.default.createElement(
	                "span",
	                { className: "input-group-text" },
	                "CAP(CARGA Tons): "
	              )
	            ),
	            _react2.default.createElement("input", { type: "text", disabled: operacion === 4 || operacion === 3 ? true : deshabilitado, ref: txtCapCarga, className: (operacion === 4 || operacion === 3 ? bloquear : deshabilitado) + " form-control", name: "capacidadcarga", onKeyUp: handleInputMontoChange, onBlur: handleInputMontoChange, id: "inputcapacidadcarga" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group input-group-sm col-pd-340 px-1 m-0 mb-2" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group-prepend" },
	              _react2.default.createElement(
	                "span",
	                { className: "input-group-text" },
	                "SERIAL(MOTOR): "
	              )
	            ),
	            _react2.default.createElement("input", { type: "text", disabled: operacion === 4 || operacion === 3 ? true : deshabilitado, ref: txtSerialMt, className: "form-control text-uppercase", name: "serialmotor", onChange: onChange, id: "inputSerialmotor" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container row m-0 px-0" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group input-group-sm col-pd-110 px-1 m-0 mb-2" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group-prepend" },
	              _react2.default.createElement(
	                "span",
	                { className: "input-group-text" },
	                "A\xD1O: "
	              )
	            ),
	            _react2.default.createElement(
	              "select",
	              { disabled: operacion === 4 || operacion === 3 ? true : deshabilitado, ref: txtAnioVh, className: "form-control", id: "inputStatus", name: "anio" },
	              fechas && fechas.map(function (item, index) {
	                return _react2.default.createElement(
	                  "option",
	                  { key: index, value: item },
	                  item
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group input-group-sm col-pd-220 px-1 m-0 mb-2" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group-prepend" },
	              _react2.default.createElement(
	                "span",
	                { className: "input-group-text" },
	                "MARCA: "
	              )
	            ),
	            _react2.default.createElement("input", { type: "text", disabled: operacion === 4 || operacion === 3 ? true : deshabilitado, ref: txtMarcaVh, className: "form-control text-uppercase", name: "marca", onChange: onChange, id: "inputMarca" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group input-group-sm col-md-3 px-1 m-0 mb-2" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group-prepend" },
	              _react2.default.createElement(
	                "span",
	                { className: "input-group-text" },
	                "MODELO: "
	              )
	            ),
	            _react2.default.createElement("input", { type: "text", disabled: operacion === 4 || operacion === 3 ? true : deshabilitado, ref: txtModeloVh, className: "form-control text-uppercase", name: "modelo", onChange: onChange, id: "inputmodelo" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group input-group-sm col-md-2 px-1 m-0 mb-2" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group-prepend" },
	              _react2.default.createElement(
	                "span",
	                { className: "input-group-text" },
	                "COLOR: "
	              )
	            ),
	            _react2.default.createElement("input", { type: "text", disabled: operacion === 4 || operacion === 3 ? true : deshabilitado, ref: txtColorVh, className: "form-control text-uppercase", name: "color", onChange: onChange, id: "inputColor" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group input-group-sm col-pd-300 px-1 m-0 mb-2" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group-prepend" },
	              _react2.default.createElement(
	                "span",
	                { className: "input-group-text" },
	                "TIPO(Movil): "
	              )
	            ),
	            _react2.default.createElement("input", { type: "text", disabled: operacion === 4 || operacion === 3 ? true : deshabilitado, ref: txtTipoVh, className: "form-control text-uppercase", name: "tipovehiculo", onChange: onChange, id: "inputtipovehiculo" })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container row m-0 px-0" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group input-group-sm col-md-2 px-1 m-0 mb-2" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group-prepend" },
	              _react2.default.createElement(
	                "span",
	                { className: "input-group-text" },
	                "N\xB0 PLACA: "
	              )
	            ),
	            _react2.default.createElement("input", { type: "text", disabled: operacion === 4 || operacion === 3 ? true : deshabilitado, ref: txtPlacaVh, className: "form-control text-uppercase", name: "placa", onChange: onChange, id: "inputplaca", "aria-label": "Amount (to the nearest dollar)" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group input-group-sm col-pd-130 px-1 m-0 mb-2" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group-prepend" },
	              _react2.default.createElement(
	                "span",
	                { className: "input-group-text" },
	                "PUESTOS: "
	              )
	            ),
	            _react2.default.createElement("input", { type: "text", maxLength: 2, disabled: operacion === 4 || operacion === 3 ? true : deshabilitado, ref: txtNumPuesto, className: (operacion === 4 || operacion === 3 ? bloquear : deshabilitado) + " form-control", name: "numpuesto", onChange: handleInputNumChange, id: "inputnumpuesto", "aria-label": "Amount (to the nearest dollar)" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group input-group-sm col-pd-769  px-0 m-0 mb-2" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group-prepend" },
	              _react2.default.createElement(
	                "span",
	                { className: "input-group-text" },
	                "USO: "
	              )
	            ),
	            _react2.default.createElement("input", { type: "text", disabled: operacion === 4 || operacion === 3 ? true : deshabilitado, ref: txtUsoVh, className: "form-control text-uppercase", name: "uso", onChange: onChange, id: "inputuso" })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        { ref: btnAcepta, disabled: operacion === 4 ? true : false, onClick: onChangeValidar, className: "btn btn-success rounded-pill btn-sm" },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          "  Aceptar"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        { ref: btnCancela, onClick: cancelar, className: "btn btn-danger rounded-pill btn-sm" },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	exports.default = ActualizarMoviles;

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalPermisosUsuarisServicios = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTable = __webpack_require__(20);
	
	var _useTable2 = _interopRequireDefault(_useTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalPermisosUsuarisServicios = exports.ModalPermisosUsuarisServicios = function ModalPermisosUsuarisServicios(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
	  var idusuario = JSON.parse(sessionStorage.getItem("idusuario"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtLogin = (0, _react.useRef)();
	  var txtCedula = (0, _react.useRef)();
	  var txtStatus = (0, _react.useRef)();
	  var txtIduser = (0, _react.useRef)();
	
	  var txtuTodos = (0, _react.useRef)();
	  var txtuIncluir = (0, _react.useRef)();
	  var txtuModificar = (0, _react.useRef)();
	  var txtuCosultar = (0, _react.useRef)();
	  var txtuEliminar = (0, _react.useRef)();
	  var txtuImprimir = (0, _react.useRef)();
	
	  var txtdTodos = (0, _react.useRef)();
	  var txtdIncluir = (0, _react.useRef)();
	  var txtdModificar = (0, _react.useRef)();
	  var txtdCosultar = (0, _react.useRef)();
	  var txtdEliminar = (0, _react.useRef)();
	  var txtdImprimir = (0, _react.useRef)();
	
	  var txttTodos = (0, _react.useRef)();
	  var txttIncluir = (0, _react.useRef)();
	  var txttModificar = (0, _react.useRef)();
	  var txttCosultar = (0, _react.useRef)();
	  var txttEliminar = (0, _react.useRef)();
	  var txttImprimir = (0, _react.useRef)();
	
	  var txtcTodos = (0, _react.useRef)();
	  var txtcIncluir = (0, _react.useRef)();
	  var txtcModificar = (0, _react.useRef)();
	  var txtcCosultar = (0, _react.useRef)();
	  var txtcEliminar = (0, _react.useRef)();
	  var txtcImprimir = (0, _react.useRef)();
	
	  var txtcoTodos = (0, _react.useRef)();
	  var txtcoIncluir = (0, _react.useRef)();
	  var txtcoModificar = (0, _react.useRef)();
	  var txtcoCosultar = (0, _react.useRef)();
	  var txtcoEliminar = (0, _react.useRef)();
	  var txtcoImprimir = (0, _react.useRef)();
	
	  var txtsTodos = (0, _react.useRef)();
	  var txtsIncluir = (0, _react.useRef)();
	  var txtsModificar = (0, _react.useRef)();
	  var txtsCosultar = (0, _react.useRef)();
	  var txtsEliminar = (0, _react.useRef)();
	  var txtsImprimir = (0, _react.useRef)();
	
	  var txtsiTodos = (0, _react.useRef)();
	  var txtsiIncluir = (0, _react.useRef)();
	  var txtsiModificar = (0, _react.useRef)();
	  var txtsiCosultar = (0, _react.useRef)();
	  var txtsiEliminar = (0, _react.useRef)();
	  var txtsiImprimir = (0, _react.useRef)();
	
	  var txtoTodos = (0, _react.useRef)();
	  var txtoIncluir = (0, _react.useRef)();
	  var txtoModificar = (0, _react.useRef)();
	  var txtoCosultar = (0, _react.useRef)();
	  var txtoEliminar = (0, _react.useRef)();
	  var txtoImprimir = (0, _react.useRef)();
	
	  var txtnTodos = (0, _react.useRef)();
	  var txtnIncluir = (0, _react.useRef)();
	  var txtnModificar = (0, _react.useRef)();
	  var txtnCosultar = (0, _react.useRef)();
	  var txtnEliminar = (0, _react.useRef)();
	  var txtnImprimir = (0, _react.useRef)();
	
	  var txtdzTodos = (0, _react.useRef)();
	  var txtdzIncluir = (0, _react.useRef)();
	  var txtdzModificar = (0, _react.useRef)();
	  var txtdzCosultar = (0, _react.useRef)();
	  var txtdzEliminar = (0, _react.useRef)();
	  var txtdzImprimir = (0, _react.useRef)();
	
	  var txtocTodos = (0, _react.useRef)();
	  var txtocIncluir = (0, _react.useRef)();
	  var txtocModificar = (0, _react.useRef)();
	  var txtocCosultar = (0, _react.useRef)();
	  var txtocEliminar = (0, _react.useRef)();
	  var txtocImprimir = (0, _react.useRef)();
	
	  var txtReportTodos = (0, _react.useRef)();
	  var txtReport1 = (0, _react.useRef)();
	  var txtReport2 = (0, _react.useRef)();
	  var txtReport3 = (0, _react.useRef)();
	  var txtReport4 = (0, _react.useRef)();
	  var txtReport5 = (0, _react.useRef)();
	  var txtReport6 = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      modu1 = _useState2[0],
	      setModu1 = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      modu2 = _useState4[0],
	      setModu2 = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      modu3 = _useState6[0],
	      setModu3 = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      modu4 = _useState8[0],
	      setModu4 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      modu5 = _useState10[0],
	      setModu5 = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      modu6 = _useState12[0],
	      setModu6 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      modu7 = _useState14[0],
	      setModu7 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      modu8 = _useState16[0],
	      setModu8 = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      modu9 = _useState18[0],
	      setModu9 = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      modu10 = _useState20[0],
	      setModu10 = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      modu11 = _useState22[0],
	      setModu11 = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0),
	      _useState24 = _slicedToArray(_useState23, 2),
	      modu12 = _useState24[0],
	      setModu12 = _useState24[1];
	
	  var _useState25 = (0, _react.useState)({}),
	      _useState26 = _slicedToArray(_useState25, 2),
	      body = _useState26[0],
	      setBody = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      operacion = _useState28[0],
	      setOperacion = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      activate = _useState30[0],
	      setActivate = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(true),
	      _useState32 = _slicedToArray(_useState31, 2),
	      habilitado = _useState32[0],
	      setHabilitado = _useState32[1];
	
	  var _useState33 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState34 = _slicedToArray(_useState33, 2),
	      mensaje = _useState34[0],
	      setMensaje = _useState34[1];
	
	  var _useState35 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState36 = _slicedToArray(_useState35, 2),
	      mensajesino = _useState36[0],
	      setMensajesino = _useState36[1];
	
	  var _useState37 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState38 = _slicedToArray(_useState37, 2),
	      botones = _useState38[0],
	      setBotones = _useState38[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var SelectUsuario = function SelectUsuario(idusuario) {
	    var endpoint = op.conexion + '/api/athos/usuario/getuser?id=' + idusuario;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.idusuario > 0) {
	
	          var para1 = response.data.ordservicios;
	          var para2 = response.data.accmoviles;
	          var para3 = response.data.accgservicios;
	          var para4 = response.data.btnreportserv;
	          var para5 = response.data.accservnota;
	
	          sessionStorage.setItem("ordserviciosc", JSON.stringify(para1));
	          sessionStorage.setItem("accmovilesc", JSON.stringify(para2));
	          sessionStorage.setItem("accgserviciosc", JSON.stringify(para3));
	          sessionStorage.setItem("btnreportservc", JSON.stringify(para4));
	          sessionStorage.setItem("accservnotac", JSON.stringify(para5));
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "Error al cargar el usuario",
	            icono: "informacion"
	          });
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var parameter1 = "";
	    var parameter2 = "";
	    var parameter3 = "";
	    var parameter4 = "";
	    var parameter5 = "";
	    var parameter6 = "";
	    var parameter7 = "";
	    var parameter8 = "";
	    var parameter9 = "";
	    var parameter10 = "";
	    var reportes = "";
	
	    if (props.usuario.accservicios.toString().substring(0, 1) === '1') {
	
	      var val1 = txtuIncluir.current.checked === true ? "1" : "0";
	      var val2 = txtuModificar.current.checked === true ? "1" : "0";
	      var val3 = txtuCosultar.current.checked === true ? "1" : "0";
	      var val4 = txtuEliminar.current.checked === true ? "1" : "0";
	      var val5 = txtuImprimir.current.checked === true ? "1" : "0";
	
	      parameter1 = val1 + val2 + val3 + val4 + val5;
	    } else {
	
	      parameter1 = '000000';
	    }
	
	    if (props.usuario.accservicios.toString().substring(1, 2) === '1') {
	
	      var _val = txtdIncluir.current.checked === true ? "1" : "0";
	      var _val2 = txtdModificar.current.checked === true ? "1" : "0";
	      var _val3 = txtdCosultar.current.checked === true ? "1" : "0";
	      var _val4 = txtdEliminar.current.checked === true ? "1" : "0";
	      var _val5 = txtdImprimir.current.checked === true ? "1" : "0";
	
	      parameter2 = _val2 + _val3 + _val + _val4 + _val5;
	    } else {
	
	      parameter2 = '000000';
	    }
	
	    if (props.usuario.accservicios.toString().substring(2, 3) === '1') {
	
	      var _val6 = txttIncluir.current.checked === true ? "1" : "0";
	      var _val7 = txttModificar.current.checked === true ? "1" : "0";
	      var _val8 = txttCosultar.current.checked === true ? "1" : "0";
	      var _val9 = txttEliminar.current.checked === true ? "1" : "0";
	      var _val10 = txttImprimir.current.checked === true ? "1" : "0";
	
	      parameter3 = _val6 + _val7 + _val8 + _val9 + _val10;
	    } else {
	
	      parameter3 = '000000';
	    }
	
	    if (props.usuario.accservicios.toString().substring(3, 4) === '1') {
	
	      var _val11 = txtcIncluir.current.checked === true ? "1" : "0";
	      var _val12 = txtcModificar.current.checked === true ? "1" : "0";
	      var _val13 = txtcCosultar.current.checked === true ? "1" : "0";
	      var _val14 = txtcEliminar.current.checked === true ? "1" : "0";
	      var _val15 = txtcImprimir.current.checked === true ? "1" : "0";
	
	      parameter4 = _val11 + _val12 + _val13 + _val14 + _val15;
	    } else {
	
	      parameter4 = '000000';
	    }
	
	    if (props.usuario.accservicios.toString().substring(5, 6) === '1') {
	
	      var _val16 = txtReport1.current.checked === true ? "1" : "0";
	      var _val17 = txtReport2.current.checked === true ? "1" : "0";
	      var _val18 = txtReport3.current.checked === true ? "1" : "0";
	      var _val19 = txtReport4.current.checked === true ? "1" : "0";
	      var _val20 = txtReport5.current.checked === true ? "1" : "0";
	      var val6 = txtReport6.current.checked === true ? "1" : "0";
	
	      reportes = _val16 + _val17 + _val18 + _val19 + _val20 + val6;
	    } else {
	
	      reportes = '000000';
	    }
	
	    var sigue = true;
	    var mensaje = "";
	
	    if (sigue) {
	      var user = [];
	      user.push({
	        idusuario: txtIduser.current.value,
	        login: txtLogin.current.value,
	        persona: txtCedula.current.value,
	        status: txtStatus.current.value === 'ACTIVO' ? 1 : 0,
	        idorganizacion: idorganizacion,
	        ordservicios: parameter1,
	        btnreportserv: reportes,
	        accmoviles: parameter2,
	        accgservicios: parameter3,
	        accservnota: parameter4
	      });
	
	      var _body = {
	        usu: JSON.stringify(user)
	      };
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	      setBody(_body);
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: mensaje,
	        icono: "informacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    var endpoint = op.conexion + '/api/athos/usuario/actualizar/' + operacion;
	
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setActivate(false);
	
	        if (parseInt(response.data.iduser) > 0) {
	          if (parseInt(response.data.iduser) === parseInt(idusuario)) {
	            SelectUsuario(parseInt(response.data.iduser));
	          }
	        }
	
	        var mensaje = "";
	        if (operacion === 1) {
	          mensaje = "El Usuario " + response.data.iduser + " ha sido registrada de manera satisfactoria.";
	        } else if (operacion === 2) {
	          mensaje = "El Usuario " + response.data.iduser + " ha sido Modificada de manera Satisfactoria.";
	        } else if (operacion === 3) {
	          mensaje = "El usuario " + response.data.iduser + " ha sido eliminada de manera satisfactoria.";
	        }
	
	        setMensaje({
	          mostrar: true,
	          titulo: "Exito.",
	          texto: mensaje,
	          icono: "exito"
	        });
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    procesarRegistro();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    props.onHideCancela();
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var checkBlank = function checkBlank(e) {
	
	    if (modu1 === 1) {
	      if (txtuIncluir.current.checked && txtuModificar.current.checked && txtuCosultar.current.checked && txtuEliminar.current.checked && txtuImprimir.current.checked) {
	        txtuTodos.current.checked = true;
	      } else {
	        txtuTodos.current.checked = false;
	      }
	    }
	
	    if (modu2 === 1) {
	      if (txtdIncluir.current.checked && txtdModificar.current.checked && txtdCosultar.current.checked && txtdEliminar.current.checked && txtdImprimir.current.checked) {
	        txtdTodos.current.checked = true;
	      } else {
	        txtdTodos.current.checked = false;
	      }
	    }
	
	    if (modu3 === 1) {
	      if (txttIncluir.current.checked && txttModificar.current.checked && txttCosultar.current.checked && txttEliminar.current.checked && txttImprimir.current.checked) {
	        txttTodos.current.checked = true;
	      } else {
	        txttTodos.current.checked = false;
	      }
	    }
	
	    if (modu4 === 1) {
	      if (txtcIncluir.current.checked && txtcModificar.current.checked && txtcCosultar.current.checked && txtcEliminar.current.checked && txtcImprimir.current.checked) {
	        txtcTodos.current.checked = true;
	      } else {
	        txtcTodos.current.checked = false;
	      }
	    }
	
	    if (modu5 === 1) {
	      if (txtReport1.current.checked && txtReport2.current.checked && txtReport3.current.checked && txtReport4.current.checked && txtReport5.current.checked && txtReport6.current.checked) {
	        txtReportTodos.current.checked = true;
	      } else {
	        txtReportTodos.current.checked = false;
	      }
	    }
	  };
	
	  var checkTodo = function checkTodo(e) {
	    if (e.target.name === "todos1") {
	      if (txtuTodos.current.checked) {
	        txtuIncluir.current.checked = true;
	        txtuModificar.current.checked = true;
	        txtuCosultar.current.checked = true;
	        txtuEliminar.current.checked = true;
	        txtuImprimir.current.checked = true;
	      } else {
	        txtuIncluir.current.checked = false;
	        txtuModificar.current.checked = false;
	        txtuCosultar.current.checked = false;
	        txtuEliminar.current.checked = false;
	        txtuImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos2") {
	      if (txtdTodos.current.checked) {
	        txtdIncluir.current.checked = true;
	        txtdModificar.current.checked = true;
	        txtdCosultar.current.checked = true;
	        txtdEliminar.current.checked = true;
	        txtdImprimir.current.checked = true;
	      } else {
	        txtdIncluir.current.checked = false;
	        txtdModificar.current.checked = false;
	        txtdCosultar.current.checked = false;
	        txtdEliminar.current.checked = false;
	        txtdImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos3") {
	      if (txttTodos.current.checked) {
	        txttIncluir.current.checked = true;
	        txttModificar.current.checked = true;
	        txttCosultar.current.checked = true;
	        txttEliminar.current.checked = true;
	        txttImprimir.current.checked = true;
	      } else {
	        txttIncluir.current.checked = false;
	        txttModificar.current.checked = false;
	        txttCosultar.current.checked = false;
	        txttEliminar.current.checked = false;
	        txttImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos4") {
	      if (txtcTodos.current.checked) {
	        txtcIncluir.current.checked = true;
	        txtcModificar.current.checked = true;
	        txtcCosultar.current.checked = true;
	        txtcEliminar.current.checked = true;
	        txtcImprimir.current.checked = true;
	      } else {
	        txtcIncluir.current.checked = false;
	        txtcModificar.current.checked = false;
	        txtcCosultar.current.checked = false;
	        txtcEliminar.current.checked = false;
	        txtcImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todosreportes") {
	      if (txtReportTodos.current.checked) {
	        txtReport1.current.checked = true;
	        txtReport2.current.checked = true;
	        txtReport3.current.checked = true;
	        txtReport4.current.checked = true;
	        txtReport5.current.checked = true;
	        txtReport6.current.checked = true;
	      } else {
	        txtReport1.current.checked = false;
	        txtReport2.current.checked = false;
	        txtReport3.current.checked = false;
	        txtReport4.current.checked = false;
	        txtReport5.current.checked = false;
	        txtReport6.current.checked = false;
	      }
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'xl',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.op === 1) {
	          setOperacion(2);
	          if (props.usuario.accservicios.toString().substring(0, 1) === '1') {
	            setModu1(1);
	          } else {
	            setModu1(0);
	          }
	
	          if (props.usuario.accservicios.toString().substring(1, 2) === '1') {
	            setModu2(1);
	          } else {
	            setModu2(0);
	          }
	
	          if (props.usuario.accservicios.toString().substring(2, 3) === '1') {
	            setModu3(1);
	          } else {
	            setModu3(0);
	          }
	
	          if (props.usuario.accservicios.toString().substring(3, 4) === '1') {
	            setModu4(1);
	          } else {
	            setModu4(0);
	          }
	
	          if (props.usuario.accservicios.toString().substring(5, 6) === '1') {
	            setModu5(1);
	          } else {
	            setModu5(0);
	          }
	          setHabilitado(false);
	        } else {
	
	          setHabilitado(true);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Permisos de Usuario (Gesti\xF3n de Servicios)'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto m-0' },
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1 d-flex justify-content-around', style: { fontSizeAdjust: '0.6' } },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-6 fw-bold' },
	              'Datos del Usuarios'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-200 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'USUARIO:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtLogin, defaultValue: props.usuario && props.usuario.login, className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement('input', { type: 'hidden', ref: txtIduser, defaultValue: props.usuario && props.usuario.idusuario }),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-180 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'CEDULA:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtCedula, defaultValue: props.persona && props.persona.cedula, className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-500 px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'NOMBRES Y APELLIDOS:'
	                ),
	                _react2.default.createElement('input', { type: 'text', defaultValue: props.persona && props.persona.nombres.trim() + " " + props.persona.apellidos.trim(), className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-170 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'ESTATUS:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtStatus, defaultValue: props.usuario && props.usuario.status === '1' ? 'ACTIVO' : 'INACTIVO', className: 'form-control text-uppercase fs-6 text-center', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-5 fw-bold' },
	              'Modulos Autorizados'
	            ),
	            modu1 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Ordenes de Servicio'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuTodos,
	                          defaultChecked: props.usuario.ordservicios.substring(0, 1) === '1' && props.usuario.ordservicios.substring(1, 2) === '1' && props.usuario.ordservicios.substring(2, 3) === '1' && props.usuario.ordservicios.substring(3, 4) === '1' && props.usuario.ordservicios.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos1', id: 'inlineCheckboxu' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuIncluir, defaultChecked: props.usuario.ordservicios.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuModificar, defaultChecked: props.usuario.ordservicios.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuCosultar, defaultChecked: props.usuario.ordservicios.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuEliminar, defaultChecked: props.usuario.ordservicios.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuImprimir, defaultChecked: props.usuario.ordservicios.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu2 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Gesti\xF3n de Moviles'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdTodos,
	                          defaultChecked: props.usuario.accmoviles.substring(0, 1) === '1' && props.usuario.accmoviles.substring(1, 2) === '1' && props.usuario.accmoviles.substring(2, 3) === '1' && props.usuario.accmoviles.substring(3, 4) === '1' && props.usuario.accmoviles.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos2', id: 'inlineCheckboxd' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdModificar, defaultChecked: props.usuario.accmoviles.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd1' },
	                          'ACTUALIZAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdCosultar, defaultChecked: props.usuario.accmoviles.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd2' },
	                          'MOSTRAR NOTA DE ENTREGA'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdIncluir, defaultChecked: props.usuario.accmoviles.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd3' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdEliminar, defaultChecked: props.usuario.accmoviles.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdImprimir, defaultChecked: props.usuario.accmoviles.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu3 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Gesti\xF3n de Servicios'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttTodos,
	                          defaultChecked: props.usuario.accgservicios.substring(0, 1) === '1' && props.usuario.accgservicios.substring(1, 2) === '1' && props.usuario.accgservicios.substring(2, 3) === '1' && props.usuario.accgservicios.substring(3, 4) === '1' && props.usuario.accgservicios.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos3', id: 'inlineCheckboxt' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttIncluir, defaultChecked: props.usuario.accgservicios.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttModificar, defaultChecked: props.usuario.accgservicios.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttCosultar, defaultChecked: props.usuario.accgservicios.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttEliminar, defaultChecked: props.usuario.accgservicios.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttImprimir, defaultChecked: props.usuario.accgservicios.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu4 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Nota de Entrega'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcTodos,
	                          defaultChecked: props.usuario.accservnota.substring(0, 1) === '1' && props.usuario.accservnota.substring(1, 2) === '1' && props.usuario.accservnota.substring(2, 3) === '1' && props.usuario.accservnota.substring(3, 4) === '1' && props.usuario.accservnota.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos4', id: 'inlineCheckboxc' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcIncluir, defaultChecked: props.usuario.accservnota.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcModificar, defaultChecked: props.usuario.accservnota.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcCosultar, defaultChecked: props.usuario.accservnota.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcEliminar, defaultChecked: props.usuario.accservnota.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcImprimir, defaultChecked: props.usuario.accservnota.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu5 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Reportes'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReportTodos,
	                          defaultChecked: props.usuario.btnreportserv.substring(0, 1) === '1' /* && props.usuario.btnreportserv.substring(1, 2) === '1' &&
	                                                                                              props.usuario.btnreportserv.substring(2, 3) === '1' && props.usuario.btnreportserv.substring(3, 4) === '1' &&
	                                                                                              props.usuario.btnreportserv.substring(4, 5) === '1' && props.usuario.btnreportserv.substring(5, 6) === '1' */ ? true : false,
	                          onChange: checkTodo, name: 'todosreportes', id: 'inlineCheckboxr' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport1, defaultChecked: props.usuario.btnreportserv.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr1' },
	                          '"---"'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement('input', { type: 'hidden', ref: txtReport2, value: 'false' }),
	                    _react2.default.createElement('input', { type: 'hidden', ref: txtReport3, value: 'false' }),
	                    _react2.default.createElement('input', { type: 'hidden', ref: txtReport4, value: 'false' }),
	                    _react2.default.createElement('input', { type: 'hidden', ref: txtReport5, value: 'false' }),
	                    _react2.default.createElement('input', { type: 'hidden', ref: txtReport6, value: 'false' })
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : ''
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-4 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: props.usuario && props.usuario.status === '0' ? true : false, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-success' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check-circle' },
	              '  Aceptar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = useTableScroll;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(19);
	
	var _TableContainer = __webpack_require__(167);
	
	var _TableContainer2 = _interopRequireDefault(_TableContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function useTableScroll(headCells) {
	
	    var TblContainer = function TblContainer(props) {
	        return _react2.default.createElement(
	            _TableContainer2.default,
	            { className: 'table-sm border-table', style: props.container },
	            _react2.default.createElement(
	                _core.Table,
	                { className: 'table table-striped table-hover table-sm' },
	                props.children
	            )
	        );
	    };
	
	    var TblHead = function TblHead() {
	
	        return _react2.default.createElement(
	            _core.TableHead,
	            { style: { border: 'none' } },
	            _react2.default.createElement(
	                _core.TableRow,
	                { style: { border: 'none' } },
	                headCells.map(function (item, index) {
	                    var _ref;
	
	                    return _react2.default.createElement(
	                        _core.TableCell,
	                        { key: index, style: (_ref = { width: item.width, textAlign: item.textAlign, backgroundColor: 'rgba(5, 81, 130, 1)',
	                                position: '-webkit-sticky' }, _defineProperty(_ref, 'position', 'sticky'), _defineProperty(_ref, 'top', 0), _defineProperty(_ref, 'left', 0), _defineProperty(_ref, 'fontWeight', 'bold'), _defineProperty(_ref, 'color', '#FFFFFF'), _defineProperty(_ref, 'fontSize', 14), _defineProperty(_ref, 'padding', 5), _defineProperty(_ref, 'margin', 0), _defineProperty(_ref, 'fontFamily', 'times new roman, times, serif'), _defineProperty(_ref, 'border', 'none'), _ref) },
	                        item.label
	                    );
	                })
	            )
	        );
	    };
	
	    return {
	        TblContainer: TblContainer,
	        TblHead: TblHead
	    };
	}

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.imprimirReportePicking = exports.crearDocumentoPicking = exports.normalizarPicking = exports.cantidadSugerida = exports.textoCantidad = exports.parsearCantidadBU = exports.existenciaTexto = exports.letraUnidad = exports.cargarReactPDF = undefined;
	
	var _regenerator = __webpack_require__(69);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/**
	 * Reporte Picking List en PDF con react-pdf.
	 *
	 * Los datos vienen de /api/pedido/pedidoPicking
	 * (SELECT * FROM fn_reporte_picking($1::jsonb, $2::integer)):
	 *
	 *   codproducto               codigo del producto
	 *   nomproducto               nombre del producto
	 *   cantidad_total_principal  cantidad pedida en la unidad principal, ej "5.00B"
	 *                             (tipounidad = 0; si no aplica viene "0.00")
	 *   cantidad_total_unidades   cantidad pedida en unidades, ej "6.00U"
	 *                             (tipounidad = 1; si no aplica viene "0.00")
	 *   cantidad_existencia       existencia total en unidades (ej. 584.00)
	 *   cantidad_principal        existencia en la unidad principal (bultos, cajas...)
	 *   cantidad_unidades         existencia sobrante en unidades
	 *   unidad                    nombre de la unidad pedida (BULTO, CAJAS, UNIDAD...)
	 *   orden_picking             orden sugerido de picking
	 *   observacion               observacion del renglon del pedido
	 *
	 * react-pdf se carga en forma diferida desde public/lib/reactpdf.bundle.js
	 * (ver tools/reactpdf) porque el webpack 1 de react-scripts 0.9.5 no puede
	 * parsear la sintaxis moderna con la que se publica la libreria.
	 */
	
	var RUTA_BUNDLE = (("") || '') + '/lib/reactpdf.bundle.js';
	
	// ---- continuacion ----
	
	var cargaBundle = null;
	
	var cargarReactPDF = exports.cargarReactPDF = function cargarReactPDF() {
	  if (typeof window !== 'undefined' && window.ReactPDF) {
	    return Promise.resolve(window.ReactPDF);
	  }
	
	  if (cargaBundle) return cargaBundle;
	
	  cargaBundle = new Promise(function (resolve, reject) {
	    var script = document.createElement('script');
	    script.src = RUTA_BUNDLE;
	    script.async = true;
	    script.onload = function () {
	      if (window.ReactPDF) {
	        resolve(window.ReactPDF);
	      } else {
	        cargaBundle = null;
	        reject(new Error('No se pudo inicializar react-pdf'));
	      }
	    };
	    script.onerror = function () {
	      cargaBundle = null;
	      reject(new Error('No se pudo cargar la libreria de PDF (react-pdf)'));
	    };
	    document.body.appendChild(script);
	  });
	
	  return cargaBundle;
	};
	
	// Campos del API usados por el reporte (con alias por si cambian de nombre)
	var CAMPOS = {
	  orden: ['orden_picking', 'ordenpicking', 'orden'],
	  codigo: ['codproducto', 'codigoproducto', 'codigo'],
	  nombre: ['nomproducto', 'nombreproducto', 'nombre', 'descripcion'],
	  pedida: ['cantidad_total', 'cantidad_total_principal', 'cantidad_pedida_principal', 'cantidad_pedida'],
	  existenciaTotal: ['cantidad_existencia', 'existencia_total'],
	  principal: ['cantidad_principal', 'cantidadprincipal', 'existencia_principal'],
	  unidades: ['cantidad_unidades', 'cantidadunidades', 'unidades'],
	  unidadPrincipal: ['unidadprincipal', 'unidad_principal', 'letraunidad'],
	  tipoUnidad: ['tipounidad', 'tipo_unidad'],
	  unidad: ['unidad', 'unidadmedida', 'nomunidad'],
	  observacion: ['observacion', 'observaciones', 'nota']
	};
	
	var texto = function texto(valor) {
	  if (valor === undefined || valor === null) return '';
	  if (valor instanceof Date) return (0, _moment2.default)(valor).format('DD-MM-YYYY');
	  if ((typeof valor === 'undefined' ? 'undefined' : _typeof(valor)) === 'object') {
	    try {
	      return JSON.stringify(valor);
	    } catch (e) {
	      return '';
	    }
	  }
	  return String(valor);
	};
	
	var numero = function numero(valor) {
	  if (valor === undefined || valor === null) return null;
	  // acepta numeros y textos con la unidad al final, ej. "5.00B" o "6.00U"
	  var n = parseFloat(String(valor).trim());
	  return isNaN(n) ? null : n;
	};
	
	var conValor = function conValor(valor) {
	  return valor !== undefined && valor !== null && String(valor).trim() !== '';
	};
	
	// el backend usa el prefijo txt en algunas funciones de reporte (txtproducto, ...)
	var sinPrefijo = function sinPrefijo(clave) {
	  return String(clave).toLowerCase().replace(/^txt/, '');
	};
	
	var indexarFila = function indexarFila(fila) {
	  var indice = {};
	  Object.keys(fila).forEach(function (clave) {
	    var normal = sinPrefijo(clave);
	    if (indice[normal] === undefined) indice[normal] = clave;
	  });
	  return indice;
	};
	
	var valorCampo = function valorCampo(fila, indice, claves) {
	  for (var i = 0; i < claves.length; i++) {
	    var clave = indice[claves[i]];
	    if (clave !== undefined && conValor(fila[clave])) return fila[clave];
	  }
	  return null;
	};
	
	var formatearCantidad = function formatearCantidad(valor) {
	  var n = numero(valor);
	  if (n === null) return '';
	  return n.toFixed(2).replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
	};
	
	var LETRAS_UNIDAD = [{ prueba: /bult/i, letra: 'B' }, { prueba: /caj/i, letra: 'C' }, { prueba: /paq/i, letra: 'P' }, { prueba: /docen/i, letra: 'D' }, { prueba: /unid/i, letra: 'U' }];
	
	var letraUnidad = exports.letraUnidad = function letraUnidad(unidad) {
	  var nombre = texto(unidad).trim();
	  for (var i = 0; i < LETRAS_UNIDAD.length; i++) {
	    if (LETRAS_UNIDAD[i].prueba.test(nombre)) return LETRAS_UNIDAD[i].letra;
	  }
	  return nombre === '' ? 'U' : nombre.substring(0, 1).toUpperCase();
	};
	
	/**
	 * Existencia en formato "104B-21U": cantidad principal + letra + unidades.
	 * unidad puede ser el nombre ("BULTO") o directamente la letra ("B").
	 */
	var existenciaTexto = exports.existenciaTexto = function existenciaTexto(principal, unidades, unidad) {
	  var p = numero(principal);
	  var u = numero(unidades);
	  if (p === null && u === null) return '';
	  if (p === null) return formatearCantidad(u) + 'U';
	
	  var letra = letraUnidad(unidad);
	  var sueltas = u === null ? 0 : u;
	  return formatearCantidad(p) + letra + '-' + formatearCantidad(sueltas) + 'U';
	};
	
	/**
	 * Lee cantidades del API del tipo "15B-10U", "5.00B", "6.00U" o 5.
	 * Devuelve { principal, unidades, letra, modo } o null.
	 */
	var parsearCantidadBU = exports.parsearCantidadBU = function parsearCantidadBU(valor) {
	  if (valor === undefined || valor === null) return null;
	  if (typeof valor === 'number') {
	    return { principal: valor, unidades: 0, letra: '', modo: 'numero' };
	  }
	
	  var limpio = String(valor).trim();
	  if (limpio === '') return null;
	
	  var numeros = limpio.match(/\d+(?:[.,]\d+)?/g) || [];
	  if (numeros.length === 0) return null;
	
	  var letras = limpio.match(/[A-Za-z]/g) || [];
	  var letra = letras.length > 0 ? letras[0].toUpperCase() : '';
	  var aNumero = function aNumero(t) {
	    return parseFloat(t.replace(',', '.'));
	  };
	
	  if (numeros.length === 1) {
	    if (letra === 'U') {
	      return { principal: 0, unidades: aNumero(numeros[0]), letra: letra, modo: 'unidades' };
	    }
	    return {
	      principal: aNumero(numeros[0]),
	      unidades: 0,
	      letra: letra,
	      modo: letra === '' ? 'numero' : 'principal'
	    };
	  }
	
	  return {
	    principal: aNumero(numeros[0]),
	    unidades: aNumero(numeros[1]),
	    letra: letra,
	    modo: 'bu'
	  };
	};
	
	var textoCantidad = exports.textoCantidad = function textoCantidad(partes, letra, tipoUnidad) {
	  if (!partes) return '';
	
	  var letraUsar = partes.letra || letra;
	  if (partes.modo === 'bu') {
	    return formatearCantidad(partes.principal) + letraUsar + '-' + formatearCantidad(partes.unidades) + 'U';
	  }
	  if (partes.modo === 'unidades') return formatearCantidad(partes.unidades) + 'U';
	  if (partes.modo === 'principal') return formatearCantidad(partes.principal) + letraUsar;
	  // numero sin letra (la funcion devuelve '0' cuando no hay cantidad)
	  if (partes.principal === 0) return '0';
	  return tipoUnidad === 1 ? formatearCantidad(partes.principal) + 'U' : formatearCantidad(partes.principal) + letraUsar;
	};
	
	/**
	 * Unidades por empaque deducidas de la existencia total
	 * (ej. 2517 total, 104 bultos, 21 unidades => 24 unidades por bulto).
	 */
	var factorExistencia = function factorExistencia(principal, unidades, total) {
	  if (total === null || principal === null || principal <= 0) return null;
	  var factor = (total - (unidades === null ? 0 : unidades)) / principal;
	  return factor > 0 ? factor : null;
	};
	
	/**
	 * Cantidad sugerida de picking = faltante para cubrir lo pedido
	 * (cantidad pedida - existencia). null = no falta producto.
	 */
	var cantidadSugerida = exports.cantidadSugerida = function cantidadSugerida(pedida, principal, unidades, letra, existenciaTotal) {
	  var partes = pedida && (typeof pedida === 'undefined' ? 'undefined' : _typeof(pedida)) === 'object' ? pedida : parsearCantidadBU(pedida);
	  if (!partes) return null;
	
	  var exB = principal === null ? 0 : principal;
	  var exU = unidades === null ? 0 : unidades;
	  var total = existenciaTotal === undefined ? null : existenciaTotal;
	  var factor = factorExistencia(principal, unidades, total);
	
	  // pidieron en unidades: se compara contra la existencia total
	  if (partes.modo === 'unidades') {
	    if (total === null) return null;
	    var faltaTotal = partes.unidades - total;
	    if (faltaTotal <= 0) return null;
	
	    if (factor !== null) {
	      var _faltaB = Math.floor(faltaTotal / factor);
	      var _faltaU = faltaTotal - _faltaB * factor;
	      if (_faltaB > 0) {
	        return formatearCantidad(_faltaB) + letra + (_faltaU > 0 ? '-' + formatearCantidad(_faltaU) + 'U' : '');
	      }
	      return formatearCantidad(_faltaU) + 'U';
	    }
	    return formatearCantidad(faltaTotal) + 'U';
	  }
	
	  // pidieron en la unidad principal
	  var faltaB = partes.principal - exB;
	  var faltaU = partes.unidades - exU;
	
	  // si faltan unidades se toma prestado un empaque completo
	  if (faltaU < 0 && factor !== null) {
	    var prestamos = Math.ceil(-faltaU / factor);
	    faltaB -= prestamos;
	    faltaU += prestamos * factor;
	  }
	  if (faltaU < 0) faltaU = 0;
	  if (faltaB < 0 || faltaB === 0 && faltaU === 0) return null;
	
	  var letraUsar = partes.letra || letra;
	  if (faltaB <= 0) return formatearCantidad(faltaU) + 'U';
	
	  return formatearCantidad(faltaB) + letraUsar + (faltaU > 0 ? '-' + formatearCantidad(faltaU) + 'U' : '');
	};
	
	/**
	 * Normaliza las filas del API a los renglones del reporte.
	 */
	var normalizarPicking = exports.normalizarPicking = function normalizarPicking(datos) {
	  var entrada = Array.isArray(datos) ? datos : [];
	
	  var filas = entrada.map(function (registro) {
	    var fila = registro || {};
	    var indice = indexarFila(fila);
	    var unidad = texto(valorCampo(fila, indice, CAMPOS.unidad));
	    var letraDato = texto(valorCampo(fila, indice, CAMPOS.unidadPrincipal)).trim();
	    var letra = letraDato !== '' ? letraDato.toUpperCase() : letraUnidad(unidad);
	    var tipoUnidad = numero(valorCampo(fila, indice, CAMPOS.tipoUnidad));
	    var existenciaPrincipal = numero(valorCampo(fila, indice, CAMPOS.principal));
	    var existenciaUnidades = numero(valorCampo(fila, indice, CAMPOS.unidades));
	    var existenciaTotal = numero(valorCampo(fila, indice, CAMPOS.existenciaTotal));
	    var partesPedida = parsearCantidadBU(valorCampo(fila, indice, CAMPOS.pedida));
	    var orden = numero(valorCampo(fila, indice, CAMPOS.orden));
	
	    // cuando el producto no tiene valorfactor la funcion devuelve el desglose
	    // de existencia en NULL: en ese caso se muestra la existencia total
	    var tieneDesglose = existenciaPrincipal !== null || existenciaUnidades !== null;
	
	    var existencia = existenciaTexto(existenciaPrincipal, existenciaUnidades, letra);
	    if (existencia === '' && existenciaTotal !== null) {
	      existencia = formatearCantidad(existenciaTotal) + 'U';
	    }
	
	    return {
	      orden: orden,
	      codigo: texto(valorCampo(fila, indice, CAMPOS.codigo)),
	      nombre: texto(valorCampo(fila, indice, CAMPOS.nombre)),
	      unidad: unidad,
	      pedida: textoCantidad(partesPedida, letra, tipoUnidad),
	      existencia: existencia,
	      sugerida: tieneDesglose ? cantidadSugerida(partesPedida, existenciaPrincipal, existenciaUnidades, letra, existenciaTotal) : null,
	      observacion: texto(valorCampo(fila, indice, CAMPOS.observacion))
	    };
	  });
	
	  filas.sort(function (a, b) {
	    var oa = a.orden === null ? 0 : a.orden;
	    var ob = b.orden === null ? 0 : b.orden;
	    if (oa !== ob) return oa - ob;
	    return a.codigo < b.codigo ? -1 : a.codigo > b.codigo ? 1 : 0;
	  });
	
	  var hayObservacion = false;
	  var conFaltante = 0;
	  filas.forEach(function (fila) {
	    if (fila.observacion !== '') hayObservacion = true;
	    if (fila.sugerida !== null) conFaltante++;
	  });
	
	  return { filas: filas, hayObservacion: hayObservacion, conFaltante: conFaltante };
	};
	
	var crearEstilos = function crearEstilos(StyleSheet) {
	  return StyleSheet.create({
	    pagina: {
	      paddingTop: 30,
	      paddingBottom: 34,
	      paddingHorizontal: 24,
	      fontSize: 8,
	      fontFamily: 'Helvetica',
	      color: '#232323'
	    },
	    encabezado: {
	      flexDirection: 'row',
	      justifyContent: 'space-between',
	      alignItems: 'flex-end',
	      borderBottomWidth: 1.5,
	      borderBottomColor: '#0b3d63',
	      paddingBottom: 5
	    },
	    titulo: {
	      fontSize: 15,
	      fontFamily: 'Helvetica-Bold',
	      color: '#0b3d63'
	    },
	    subtitulo: {
	      fontSize: 8,
	      color: '#4d4d4d'
	    },
	    resumen: {
	      borderWidth: 1,
	      borderColor: '#d5dee6',
	      backgroundColor: '#f2f6fa',
	      paddingVertical: 4,
	      paddingHorizontal: 6,
	      marginBottom: 8
	    },
	    resumenFila: {
	      flexDirection: 'row',
	      justifyContent: 'space-between'
	    },
	    resumenTexto: {
	      fontSize: 8,
	      fontFamily: 'Helvetica-Bold',
	      color: '#0b3d63'
	    },
	    resumenPedidos: {
	      fontSize: 7.5,
	      color: '#4d4d4d',
	      marginTop: 2
	    },
	    filaTitulos: {
	      flexDirection: 'row',
	      backgroundColor: '#0b3d63'
	    },
	    tituloColumna: {
	      fontSize: 7.5,
	      fontFamily: 'Helvetica-Bold',
	      color: '#ffffff',
	      paddingVertical: 4,
	      paddingHorizontal: 3
	    },
	    fila: {
	      flexDirection: 'row',
	      borderBottomWidth: 0.5,
	      borderBottomColor: '#dfe6ec'
	    },
	    filaPar: {
	      backgroundColor: '#f7f9fb'
	    },
	    celda: {
	      fontSize: 7.5,
	      paddingVertical: 3,
	      paddingHorizontal: 3
	    },
	    centrado: {
	      textAlign: 'center'
	    },
	    derecha: {
	      textAlign: 'right'
	    },
	    faltante: {
	      fontFamily: 'Helvetica-Bold',
	      color: '#b00020'
	    },
	    firmas: {
	      flexDirection: 'row',
	      justifyContent: 'space-between',
	      marginTop: 28
	    },
	    firma: {
	      width: '30%',
	      borderTopWidth: 0.8,
	      borderTopColor: '#8a99a8',
	      paddingTop: 3
	    },
	    firmaTexto: {
	      fontSize: 7,
	      color: '#5c6b7a',
	      textAlign: 'center'
	    },
	    pieFijo: {
	      position: 'absolute',
	      bottom: 14,
	      left: 24,
	      right: 24,
	      flexDirection: 'row',
	      justifyContent: 'space-between',
	      borderTopWidth: 0.5,
	      borderTopColor: '#d5dee6',
	      paddingTop: 3
	    },
	    pieTexto: {
	      fontSize: 7,
	      color: '#6c757d'
	    },
	    sinDatos: {
	      marginTop: 40,
	      textAlign: 'center',
	      fontSize: 10,
	      color: '#6c757d'
	    }
	  });
	};
	
	/**
	 * Documento react-pdf del picking. R = window.ReactPDF
	 *
	 * datos     : filas devueltas por /api/pedido/pedidoPicking
	 * metadatos : { empresa, usuario, titulo, pedidos, esNota }
	 *
	 * Para notas de entrega el reporte solo muestra las columnas
	 * ORDEN PICKING, CODIGO, PRODUCTO y CANT. A DESPACHAR.
	 */
	var crearDocumentoPicking = exports.crearDocumentoPicking = function crearDocumentoPicking(R, datos, metadatos) {
	  var Document = R.Document,
	      Page = R.Page,
	      View = R.View,
	      Text = R.Text;
	
	  var estilos = crearEstilos(R.StyleSheet);
	  var info = metadatos || {};
	  var etiquetaDocumentos = texto(info.etiquetaDocumentos || 'PEDIDOS').toUpperCase();
	  var esNota = info.esNota === true;
	
	  var _normalizarPicking = normalizarPicking(datos),
	      filas = _normalizarPicking.filas,
	      hayObservacion = _normalizarPicking.hayObservacion,
	      conFaltante = _normalizarPicking.conFaltante;
	
	  var pedidos = (Array.isArray(info.pedidos) ? info.pedidos : []).filter(conValor);
	  var maxPedidosResumen = 20;
	  var resumenPedidos = '0';
	  if (pedidos.length > 0 && pedidos.length <= maxPedidosResumen) {
	    resumenPedidos = pedidos.join(', ');
	  } else if (pedidos.length > maxPedidosResumen) {
	    resumenPedidos = pedidos.slice(0, maxPedidosResumen).join(', ') + ' (+' + (pedidos.length - maxPedidosResumen) + ')';
	  }
	
	  return _react2.default.createElement(
	    Document,
	    {
	      title: 'Picking List',
	      author: texto(info.empresa),
	      subject: 'Reporte Picking List',
	      creator: 'ATHOS ERP',
	      producer: 'ATHOS ERP'
	    },
	    _react2.default.createElement(
	      Page,
	      { size: 'A4', orientation: 'portrait', style: estilos.pagina },
	      _react2.default.createElement(
	        View,
	        { style: estilos.encabezado, fixed: true },
	        _react2.default.createElement(
	          View,
	          null,
	          _react2.default.createElement(
	            Text,
	            { style: estilos.titulo },
	            'PICKING LIST'
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: estilos.subtitulo },
	            texto(info.empresa)
	          )
	        ),
	        _react2.default.createElement(
	          View,
	          null,
	          _react2.default.createElement(
	            Text,
	            { style: estilos.subtitulo },
	            'Emitido: ' + (0, _moment2.default)().format('DD-MM-YYYY hh:mm a')
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: estilos.subtitulo },
	            'Usuario: ' + texto(info.usuario)
	          )
	        )
	      ),
	      _react2.default.createElement(
	        View,
	        { style: estilos.resumen },
	        _react2.default.createElement(
	          View,
	          { style: estilos.resumenFila },
	          _react2.default.createElement(
	            Text,
	            { style: estilos.resumenTexto },
	            'PRODUCTOS: ' + filas.length
	          ),
	          !esNota && _react2.default.createElement(
	            Text,
	            { style: estilos.resumenTexto },
	            'CON FALTANTE: ' + conFaltante
	          )
	        ),
	        _react2.default.createElement(
	          Text,
	          { style: estilos.resumenPedidos },
	          etiquetaDocumentos + ': ' + resumenPedidos
	        )
	      ),
	      _react2.default.createElement(
	        View,
	        { style: estilos.filaTitulos },
	        _react2.default.createElement(
	          Text,
	          { style: [estilos.tituloColumna, { flex: 0.8 }, estilos.centrado] },
	          'ORDEN PICKING'
	        ),
	        _react2.default.createElement(
	          Text,
	          { style: [estilos.tituloColumna, { flex: 1.1 }] },
	          'CODIGO'
	        ),
	        _react2.default.createElement(
	          Text,
	          { style: [estilos.tituloColumna, { flex: 3.7 }] },
	          'PRODUCTO'
	        ),
	        _react2.default.createElement(
	          Text,
	          {
	            style: [estilos.tituloColumna, { flex: esNota ? 1.35 : 1.05 }, estilos.derecha]
	          },
	          esNota ? 'CANT. A DESPACHAR' : 'CANT. PEDIDA'
	        ),
	        !esNota && _react2.default.createElement(
	          Text,
	          { style: [estilos.tituloColumna, { flex: 1.25 }, estilos.centrado] },
	          'EXISTENCIA'
	        ),
	        !esNota && _react2.default.createElement(
	          Text,
	          { style: [estilos.tituloColumna, { flex: 1.35 }, estilos.derecha] },
	          'CANT. SUGERIDA'
	        ),
	        !esNota && hayObservacion && _react2.default.createElement(
	          Text,
	          { style: [estilos.tituloColumna, { flex: 2 }] },
	          'OBSERVACION'
	        )
	      ),
	      filas.length === 0 && _react2.default.createElement(
	        Text,
	        { style: estilos.sinDatos },
	        'No hay informacion por mostrar'
	      ),
	      filas.map(function (fila, indice) {
	        return _react2.default.createElement(
	          View,
	          {
	            key: indice,
	            style: [estilos.fila, indice % 2 === 1 ? estilos.filaPar : null],
	            wrap: false
	          },
	          _react2.default.createElement(
	            Text,
	            { style: [estilos.celda, { flex: 0.8 }, estilos.centrado] },
	            fila.orden === null ? '' : fila.orden
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: [estilos.celda, { flex: 1.1 }] },
	            fila.codigo
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: [estilos.celda, { flex: 3.7 }] },
	            fila.nombre
	          ),
	          _react2.default.createElement(
	            Text,
	            {
	              style: [estilos.celda, { flex: esNota ? 1.35 : 1.05 }, estilos.derecha]
	            },
	            fila.pedida
	          ),
	          !esNota && _react2.default.createElement(
	            Text,
	            { style: [estilos.celda, { flex: 1.25 }, estilos.centrado] },
	            fila.existencia
	          ),
	          !esNota && _react2.default.createElement(
	            Text,
	            {
	              style: [estilos.celda, { flex: 1.35 }, estilos.derecha, fila.sugerida !== null ? estilos.faltante : null]
	            },
	            fila.sugerida === null ? '-' : fila.sugerida
	          ),
	          !esNota && hayObservacion && _react2.default.createElement(
	            Text,
	            { style: [estilos.celda, { flex: 2 }] },
	            fila.observacion
	          )
	        );
	      }),
	      _react2.default.createElement(
	        View,
	        { style: estilos.firmas, wrap: false },
	        _react2.default.createElement(
	          View,
	          { style: estilos.firma },
	          _react2.default.createElement(
	            Text,
	            { style: estilos.firmaTexto },
	            'PREPARADO POR'
	          )
	        ),
	        _react2.default.createElement(
	          View,
	          { style: estilos.firma },
	          _react2.default.createElement(
	            Text,
	            { style: estilos.firmaTexto },
	            'VERIFICADO POR'
	          )
	        ),
	        _react2.default.createElement(
	          View,
	          { style: estilos.firma },
	          _react2.default.createElement(
	            Text,
	            { style: estilos.firmaTexto },
	            'RECIBIDO POR'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        View,
	        { style: estilos.pieFijo, fixed: true },
	        _react2.default.createElement(
	          Text,
	          { style: estilos.pieTexto },
	          texto(info.titulo) + ' | B: bultos, C: cajas, P: paquetes, U: unidades'
	        ),
	        _react2.default.createElement(Text, {
	          style: estilos.pieTexto,
	          render: function render(_ref) {
	            var pageNumber = _ref.pageNumber,
	                totalPages = _ref.totalPages;
	            return 'Pagina ' + pageNumber + ' de ' + totalPages;
	          }
	        })
	      )
	    )
	  );
	};
	
	/**
	 * Genera el PDF y lo muestra en la ventana indicada (si no se pudo abrir,
	 * lo descarga).
	 */
	var imprimirReportePicking = exports.imprimirReportePicking = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(datos, metadatos, ventana) {
	    var R, documento, blob, url, enlace;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return cargarReactPDF();
	
	          case 2:
	            R = _context.sent;
	            documento = crearDocumentoPicking(R, datos, metadatos);
	            _context.next = 6;
	            return R.pdf(documento).toBlob();
	
	          case 6:
	            blob = _context.sent;
	            url = URL.createObjectURL(blob);
	
	
	            if (ventana && !ventana.closed) {
	              ventana.location.href = url;
	            } else {
	              enlace = document.createElement('a');
	
	              enlace.href = url;
	              enlace.download = 'Picking-' + (0, _moment2.default)().format('DD-MM-YYYY-hhmm') + '.pdf';
	              document.body.appendChild(enlace);
	              enlace.click();
	              document.body.removeChild(enlace);
	            }
	
	            setTimeout(function () {
	              return URL.revokeObjectURL(url);
	            }, 120000);
	
	          case 10:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function imprimirReportePicking(_x, _x2, _x3) {
	    return _ref2.apply(this, arguments);
	  };
	}();

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useBcv = undefined;
	
	var _regenerator = __webpack_require__(69);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var useBcv = exports.useBcv = function useBcv() {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	
	  var _useState = (0, _react.useState)({
	    idmoneda: "",
	    descripcion: "",
	    simbolo: "",
	    predeterminada: false,
	    valormoneda: "0,00",
	    subpredeterminada: true
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      moneda = _useState2[0],
	      setMoneda = _useState2[1];
	
	  var seleccionarRegistros = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var campos, nomtab, orden, endpoint;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	              nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	              orden = "m.idmoneda";
	              endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	
	              _axios2.default.get(endpoint, {
	                headers: {
	                  "x-access-token": "" + token
	                }
	              }).then(function (response) {
	                if (response.status === 200) {
	                  if (response.data.length > 0) {
	                    for (var i = 0; i < response.data.length; i++) {
	                      if (response.data[i].subpredeterminada) {
	                        setMoneda(response.data[i]);
	                      }
	                    }
	                  }
	                }
	              });
	
	            case 5:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function seleccionarRegistros() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var actualizarTasa = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var endpoint;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              endpoint = op.conexion + "/api/bcv";
	
	              _axios2.default.get(endpoint, {
	                headers: {
	                  "x-access-token": "" + token
	                }
	              }).then(function (response) {
	                if (response.status === 200) {
	                  console.log("tasa");
	                  console.log(response.data);
	                }
	              }).finally(_asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                  while (1) {
	                    switch (_context2.prev = _context2.next) {
	                      case 0:
	                        _context2.next = 2;
	                        return seleccionarRegistros();
	
	                      case 2:
	                      case "end":
	                        return _context2.stop();
	                    }
	                  }
	                }, _callee2, undefined);
	              })));
	
	            case 2:
	            case "end":
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined);
	    }));
	
	    return function actualizarTasa() {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  (0, _react.useEffect)(function () {
	    actualizarTasa();
	    console.log("hola prueba");
	  }, []);
	
	  return {
	    moneda: moneda
	  };
	};

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(6655);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(304));
	
	var _ChildMapping = __webpack_require__(7203);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	/**
	 * The `<TransitionGroup>` component manages a set of transition components
	 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	 * components, `<TransitionGroup>` is a state machine for managing the mounting
	 * and unmounting of components over time.
	 *
	 * Consider the example below. As items are removed or added to the TodoList the
	 * `in` prop is toggled automatically by the `<TransitionGroup>`.
	 *
	 * Note that `<TransitionGroup>`  does not define any animation behavior!
	 * Exactly _how_ a list item animates is up to the individual transition
	 * component. This means you can mix and match animations across different list
	 * items.
	 */
	
	var TransitionGroup = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      contextValue: {
	        isMounting: true
	      },
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.mounted = true;
	    this.setState({
	      contextValue: {
	        isMounting: false
	      }
	    });
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  } // node is `undefined` when user provided `nodeRef` prop
	  ;
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var contextValue = this.state.contextValue;
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: contextValue
	      }, children);
	    }
	
	    return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: contextValue
	    }, /*#__PURE__*/_react.default.createElement(Component, props, children));
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	var _default = TransitionGroup;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 679 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	var _default = {
	  disabled: false
	};
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ },
/* 681 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.forceReflow = void 0;
	
	var forceReflow = function forceReflow(node) {
	  return node.scrollTop;
	};
	
	exports.forceReflow = forceReflow;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(208);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(450);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(259).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(685);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(217).Buffer;
	var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(133));
	util.inherits = __webpack_require__(76);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(7341);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(7207);
	var destroyImpl = __webpack_require__(684);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(107);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(789).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(107);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(789).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', state.awaitDrain);
	        state.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, { hasUnpiped: false });
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(90)))

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(107);
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(133));
	util.inherits = __webpack_require__(76);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(208);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err) {
	      if (!this._writableState) {
	        pna.nextTick(emitErrorNT, this, err);
	      } else if (!this._writableState.errorEmitted) {
	        this._writableState.errorEmitted = true;
	        pna.nextTick(emitErrorNT, this, err);
	      }
	    }
	
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      if (!_this._writableState) {
	        pna.nextTick(emitErrorNT, _this, err);
	      } else if (!_this._writableState.errorEmitted) {
	        _this._writableState.errorEmitted = true;
	        pna.nextTick(emitErrorNT, _this, err);
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finalCalled = false;
	    this._writableState.prefinished = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(259).EventEmitter;


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var setFunctionName = __webpack_require__(7325);
	var $TypeError = __webpack_require__(114);
	
	var $Object = Object;
	
	module.exports = setFunctionName(function flags() {
		if (this == null || this !== $Object(this)) {
			throw new $TypeError('RegExp.prototype.flags getter called on non-object');
		}
		var result = '';
		if (this.hasIndices) {
			result += 'd';
		}
		if (this.global) {
			result += 'g';
		}
		if (this.ignoreCase) {
			result += 'i';
		}
		if (this.multiline) {
			result += 'm';
		}
		if (this.dotAll) {
			result += 's';
		}
		if (this.unicode) {
			result += 'u';
		}
		if (this.unicodeSets) {
			result += 'v';
		}
		if (this.sticky) {
			result += 'y';
		}
		return result;
	}, 'get flags', true);
	


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(686);
	
	var supportsDescriptors = __webpack_require__(134).supportsDescriptors;
	var $gOPD = Object.getOwnPropertyDescriptor;
	
	module.exports = function getPolyfill() {
		if (supportsDescriptors && (/a/mig).flags === 'gim') {
			var descriptor = $gOPD(RegExp.prototype, 'flags');
			if (
				descriptor
				&& typeof descriptor.get === 'function'
				&& 'dotAll' in RegExp.prototype
				&& 'hasIndices' in RegExp.prototype
			) {
				/* eslint getter-return: 0 */
				var calls = '';
				var o = {};
				Object.defineProperty(o, 'hasIndices', {
					get: function () {
						calls += 'd';
					}
				});
				Object.defineProperty(o, 'sticky', {
					get: function () {
						calls += 'y';
					}
				});
	
				descriptor.get.call(o);
	
				if (calls === 'dy') {
					return descriptor.get;
				}
			}
		}
		return implementation;
	};


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MountNode["default"];
	  }
	});
	
	var _MountNode = _interopRequireDefault(__webpack_require__(7220));

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _keyboardKey = _interopRequireDefault(__webpack_require__(138));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = __webpack_require__(2);
	
	var _lib = __webpack_require__(12);
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(309));
	
	/**
	 * An item of a pagination.
	 */
	var PaginationItem =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(PaginationItem, _Component);
	
	  function PaginationItem() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, PaginationItem);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(PaginationItem)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (e) {
	      (0, _invoke2["default"])(_this.props, 'onClick', e, _this.props);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleKeyDown", function (e) {
	      (0, _invoke2["default"])(_this.props, 'onKeyDown', e, _this.props);
	      if (_keyboardKey["default"].getCode(e) === _keyboardKey["default"].Enter) (0, _invoke2["default"])(_this.props, 'onClick', e, _this.props);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleOverrides", function () {
	      return {
	        onClick: _this.handleClick,
	        onKeyDown: _this.handleKeyDown
	      };
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(PaginationItem, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          active = _this$props.active,
	          type = _this$props.type;
	      var disabled = this.props.disabled || type === 'ellipsisItem';
	      return _MenuItem["default"].create(this.props, {
	        defaultProps: {
	          active: active,
	          'aria-current': active,
	          'aria-disabled': disabled,
	          disabled: disabled,
	          onClick: this.handleClick,
	          onKeyDown: this.handleKeyDown,
	          tabIndex: disabled ? -1 : 0
	        },
	        overrideProps: this.handleOverrides
	      });
	    }
	  }]);
	  return PaginationItem;
	}(_react.Component);
	
	(0, _defineProperty2["default"])(PaginationItem, "handledProps", ["active", "disabled", "onClick", "onKeyDown", "type"]);
	PaginationItem.propTypes =  false ? {
	  /** A pagination item can be active. */
	  active: _propTypes["default"].bool,
	
	  /** A pagination item can be disabled. */
	  disabled: _propTypes["default"].bool,
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes["default"].func,
	
	  /**
	   * Called on key down.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onKeyDown: _propTypes["default"].func,
	
	  /** A pagination should have a type. */
	  type: _propTypes["default"].oneOf(['ellipsisItem', 'firstItem', 'prevItem', 'pageItem', 'nextItem', 'lastItem'])
	} : {};
	PaginationItem.create = (0, _lib.createShorthandFactory)(PaginationItem, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = PaginationItem;
	exports["default"] = _default;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _reactComponentRef = __webpack_require__(52);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactDom = __webpack_require__(45);
	
	var _lib = __webpack_require__(12);
	
	/**
	 * An inner component that allows you to render children outside their parent.
	 */
	var PortalInner =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(PortalInner, _Component);
	
	  function PortalInner() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, PortalInner);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(PortalInner)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleRef", function (c) {
	      (0, _reactComponentRef.handleRef)(_this.props.innerRef, c);
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(PortalInner, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      (0, _invoke2["default"])(this.props, 'onMount', null, this.props);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      (0, _invoke2["default"])(this.props, 'onUnmount', null, this.props);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!(0, _lib.isBrowser)()) return null;
	      var _this$props = this.props,
	          children = _this$props.children,
	          _this$props$mountNode = _this$props.mountNode,
	          mountNode = _this$props$mountNode === void 0 ? document.body : _this$props$mountNode;
	      return (0, _reactDom.createPortal)(_react["default"].createElement(_reactComponentRef.Ref, {
	        innerRef: this.handleRef
	      }, children), mountNode);
	    }
	  }]);
	  return PortalInner;
	}(_react.Component);
	
	(0, _defineProperty2["default"])(PortalInner, "handledProps", ["children", "innerRef", "mountNode", "onMount", "onUnmount"]);
	PortalInner.propTypes =  false ? {
	  /** Primary content. */
	  children: _propTypes["default"].node.isRequired,
	
	  /** Called with a ref to the inner node. */
	  innerRef: _lib.customPropTypes.ref,
	
	  /** The node where the portal should mount. */
	  mountNode: _propTypes["default"].any,
	
	  /**
	   * Called when the portal is mounted on the DOM
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onMount: _propTypes["default"].func,
	
	  /**
	   * Called when the portal is unmounted from the DOM
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onUnmount: _propTypes["default"].func
	} : {};
	var _default = PortalInner;
	exports["default"] = _default;

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Select["default"];
	  }
	});
	
	var _Select = _interopRequireDefault(__webpack_require__(7233));

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TextArea["default"];
	  }
	});
	
	var _TextArea = _interopRequireDefault(__webpack_require__(7234));

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(43));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Icon = _interopRequireDefault(__webpack_require__(54));
	
	/**
	 * A divider sub-component for Breadcrumb component.
	 */
	function BreadcrumbDivider(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      icon = props.icon;
	  var classes = (0, _classnames["default"])('divider', className);
	  var rest = (0, _lib.getUnhandledProps)(BreadcrumbDivider, props);
	  var ElementType = (0, _lib.getElementType)(BreadcrumbDivider, props);
	
	  if (!(0, _isNil2["default"])(icon)) {
	    return _Icon["default"].create(icon, {
	      defaultProps: (0, _objectSpread2["default"])({}, rest, {
	        className: classes
	      }),
	      autoGenerateKey: false
	    });
	  }
	
	  if (!(0, _isNil2["default"])(content)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), content);
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? '/' : children);
	}
	
	BreadcrumbDivider.handledProps = ["as", "children", "className", "content", "icon"];
	BreadcrumbDivider.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Render as an `Icon` component with `divider` class instead of a `div`. */
	  icon: _lib.customPropTypes.itemShorthand
	} : {};
	BreadcrumbDivider.create = (0, _lib.createShorthandFactory)(BreadcrumbDivider, function (icon) {
	  return {
	    icon: icon
	  };
	});
	var _default = BreadcrumbDivider;
	exports["default"] = _default;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A section sub-component for Breadcrumb component.
	 */
	var BreadcrumbSection =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(BreadcrumbSection, _Component);
	
	  function BreadcrumbSection() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, BreadcrumbSection);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(BreadcrumbSection)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "computeElementType", function () {
	      var _this$props = _this.props,
	          link = _this$props.link,
	          onClick = _this$props.onClick;
	      if (link || onClick) return 'a';
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (e) {
	      return (0, _invoke2["default"])(_this.props, 'onClick', e, _this.props);
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(BreadcrumbSection, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          active = _this$props2.active,
	          children = _this$props2.children,
	          className = _this$props2.className,
	          content = _this$props2.content,
	          href = _this$props2.href;
	      var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(active, 'active'), 'section', className);
	      var rest = (0, _lib.getUnhandledProps)(BreadcrumbSection, this.props);
	      var ElementType = (0, _lib.getElementType)(BreadcrumbSection, this.props, this.computeElementType);
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes,
	        href: href,
	        onClick: this.handleClick
	      }), _lib.childrenUtils.isNil(children) ? content : children);
	    }
	  }]);
	  return BreadcrumbSection;
	}(_react.Component);
	
	exports["default"] = BreadcrumbSection;
	(0, _defineProperty2["default"])(BreadcrumbSection, "handledProps", ["active", "as", "children", "className", "content", "href", "link", "onClick"]);
	BreadcrumbSection.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Style as the currently active section. */
	  active: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
	  href: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['link']), _propTypes["default"].string]),
	
	  /** Render as an `a` tag instead of a `div`. */
	  link: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['href']), _propTypes["default"].bool]),
	
	  /**
	   * Called on click. When passed, the component will render as an `a`
	   * tag by default instead of a `div`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes["default"].func
	} : {};
	BreadcrumbSection.create = (0, _lib.createShorthandFactory)(BreadcrumbSection, function (content) {
	  return {
	    content: content,
	    link: true
	  };
	});

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Button = _interopRequireDefault(__webpack_require__(219));
	
	var _FormField = _interopRequireDefault(__webpack_require__(84));
	
	/**
	 * Sugar for <Form.Field control={Button} />.
	 * @see Button
	 * @see Form
	 */
	function FormButton(props) {
	  var control = props.control;
	  var rest = (0, _lib.getUnhandledProps)(FormButton, props);
	  var ElementType = (0, _lib.getElementType)(FormButton, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    control: control
	  }));
	}
	
	FormButton.handledProps = ["as", "control"];
	FormButton.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A FormField control prop. */
	  control: _FormField["default"].propTypes.control
	} : {};
	FormButton.defaultProps = {
	  as: _FormField["default"],
	  control: _Button["default"]
	};
	var _default = FormButton;
	exports["default"] = _default;

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(223));
	
	var _FormField = _interopRequireDefault(__webpack_require__(84));
	
	/**
	 * Sugar for <Form.Field control={Checkbox} />.
	 * @see Checkbox
	 * @see Form
	 */
	function FormCheckbox(props) {
	  var control = props.control;
	  var rest = (0, _lib.getUnhandledProps)(FormCheckbox, props);
	  var ElementType = (0, _lib.getElementType)(FormCheckbox, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    control: control
	  }));
	}
	
	FormCheckbox.handledProps = ["as", "control"];
	FormCheckbox.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A FormField control prop. */
	  control: _FormField["default"].propTypes.control
	} : {};
	FormCheckbox.defaultProps = {
	  as: _FormField["default"],
	  control: _Checkbox["default"]
	};
	var _default = FormCheckbox;
	exports["default"] = _default;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(224));
	
	var _FormField = _interopRequireDefault(__webpack_require__(84));
	
	/**
	 * Sugar for <Form.Field control={Dropdown} />.
	 * @see Dropdown
	 * @see Form
	 */
	function FormDropdown(props) {
	  var control = props.control;
	  var rest = (0, _lib.getUnhandledProps)(FormDropdown, props);
	  var ElementType = (0, _lib.getElementType)(FormDropdown, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    control: control
	  }));
	}
	
	FormDropdown.handledProps = ["as", "control"];
	FormDropdown.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A FormField control prop. */
	  control: _FormField["default"].propTypes.control
	} : {};
	FormDropdown.defaultProps = {
	  as: _FormField["default"],
	  control: _Dropdown["default"]
	};
	var _default = FormDropdown;
	exports["default"] = _default;

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(46));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A set of fields can appear grouped together.
	 * @see Form
	 */
	function FormGroup(props) {
	  var children = props.children,
	      className = props.className,
	      grouped = props.grouped,
	      inline = props.inline,
	      unstackable = props.unstackable,
	      widths = props.widths;
	  var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(grouped, 'grouped'), (0, _lib.useKeyOnly)(inline, 'inline'), (0, _lib.useKeyOnly)(unstackable, 'unstackable'), (0, _lib.useWidthProp)(widths, null, true), 'fields', className);
	  var rest = (0, _lib.getUnhandledProps)(FormGroup, props);
	  var ElementType = (0, _lib.getElementType)(FormGroup, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), children);
	}
	
	FormGroup.handledProps = ["as", "children", "className", "grouped", "inline", "unstackable", "widths"];
	FormGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Fields can show related choices. */
	  grouped: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['inline']), _propTypes["default"].bool]),
	
	  /** Multiple fields may be inline in a row. */
	  inline: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['grouped']), _propTypes["default"].bool]),
	
	  /** A form group can prevent itself from stacking on mobile. */
	  unstackable: _propTypes["default"].bool,
	
	  /** Fields Groups can specify their width in grid columns or automatically divide fields to be equal width. */
	  widths: _propTypes["default"].oneOf([].concat((0, _toConsumableArray2["default"])(_lib.SUI.WIDTHS), ['equal']))
	} : {};
	var _default = FormGroup;
	exports["default"] = _default;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Input = _interopRequireDefault(__webpack_require__(313));
	
	var _FormField = _interopRequireDefault(__webpack_require__(84));
	
	/**
	 * Sugar for <Form.Field control={Input} />.
	 * @see Form
	 * @see Input
	 */
	function FormInput(props) {
	  var control = props.control;
	  var rest = (0, _lib.getUnhandledProps)(FormInput, props);
	  var ElementType = (0, _lib.getElementType)(FormInput, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    control: control
	  }));
	}
	
	FormInput.handledProps = ["as", "control"];
	FormInput.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A FormField control prop. */
	  control: _FormField["default"].propTypes.control
	} : {};
	FormInput.defaultProps = {
	  as: _FormField["default"],
	  control: _Input["default"]
	};
	var _default = FormInput;
	exports["default"] = _default;

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Radio = _interopRequireDefault(__webpack_require__(307));
	
	var _FormField = _interopRequireDefault(__webpack_require__(84));
	
	/**
	 * Sugar for <Form.Field control={Radio} />.
	 * @see Form
	 * @see Radio
	 */
	function FormRadio(props) {
	  var control = props.control;
	  var rest = (0, _lib.getUnhandledProps)(FormRadio, props);
	  var ElementType = (0, _lib.getElementType)(FormRadio, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    control: control
	  }));
	}
	
	FormRadio.handledProps = ["as", "control"];
	FormRadio.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A FormField control prop. */
	  control: _FormField["default"].propTypes.control
	} : {};
	FormRadio.defaultProps = {
	  as: _FormField["default"],
	  control: _Radio["default"]
	};
	var _default = FormRadio;
	exports["default"] = _default;

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Select = _interopRequireDefault(__webpack_require__(691));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(224));
	
	var _FormField = _interopRequireDefault(__webpack_require__(84));
	
	/**
	 * Sugar for <Form.Field control={Select} />.
	 * @see Form
	 * @see Select
	 */
	function FormSelect(props) {
	  var control = props.control,
	      options = props.options;
	  var rest = (0, _lib.getUnhandledProps)(FormSelect, props);
	  var ElementType = (0, _lib.getElementType)(FormSelect, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    control: control,
	    options: options
	  }));
	}
	
	FormSelect.handledProps = ["as", "control", "options"];
	FormSelect.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A FormField control prop. */
	  control: _FormField["default"].propTypes.control,
	
	  /** Array of Dropdown.Item props e.g. `{ text: '', value: '' }` */
	  options: _propTypes["default"].arrayOf(_propTypes["default"].shape(_Dropdown["default"].Item.propTypes)).isRequired
	} : {};
	FormSelect.defaultProps = {
	  as: _FormField["default"],
	  control: _Select["default"]
	};
	var _default = FormSelect;
	exports["default"] = _default;

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _TextArea = _interopRequireDefault(__webpack_require__(692));
	
	var _FormField = _interopRequireDefault(__webpack_require__(84));
	
	/**
	 * Sugar for <Form.Field control={TextArea} />.
	 * @see Form
	 * @see TextArea
	 */
	function FormTextArea(props) {
	  var control = props.control;
	  var rest = (0, _lib.getUnhandledProps)(FormTextArea, props);
	  var ElementType = (0, _lib.getElementType)(FormTextArea, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    control: control
	  }));
	}
	
	FormTextArea.handledProps = ["as", "control"];
	FormTextArea.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A FormField control prop. */
	  control: _FormField["default"].propTypes.control
	} : {};
	FormTextArea.defaultProps = {
	  as: _FormField["default"],
	  control: _TextArea["default"]
	};
	var _default = FormTextArea;
	exports["default"] = _default;

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(46));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _GridColumn = _interopRequireDefault(__webpack_require__(308));
	
	var _GridRow = _interopRequireDefault(__webpack_require__(704));
	
	/**
	 * A grid is used to harmonize negative space in a layout.
	 */
	function Grid(props) {
	  var celled = props.celled,
	      centered = props.centered,
	      children = props.children,
	      className = props.className,
	      columns = props.columns,
	      container = props.container,
	      divided = props.divided,
	      doubling = props.doubling,
	      inverted = props.inverted,
	      padded = props.padded,
	      relaxed = props.relaxed,
	      reversed = props.reversed,
	      stackable = props.stackable,
	      stretched = props.stretched,
	      textAlign = props.textAlign,
	      verticalAlign = props.verticalAlign;
	  var classes = (0, _classnames["default"])('ui', (0, _lib.useKeyOnly)(centered, 'centered'), (0, _lib.useKeyOnly)(container, 'container'), (0, _lib.useKeyOnly)(doubling, 'doubling'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(stackable, 'stackable'), (0, _lib.useKeyOnly)(stretched, 'stretched'), (0, _lib.useKeyOrValueAndKey)(celled, 'celled'), (0, _lib.useKeyOrValueAndKey)(divided, 'divided'), (0, _lib.useKeyOrValueAndKey)(padded, 'padded'), (0, _lib.useKeyOrValueAndKey)(relaxed, 'relaxed'), (0, _lib.useMultipleProp)(reversed, 'reversed'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(columns, 'column', true), 'grid', className);
	  var rest = (0, _lib.getUnhandledProps)(Grid, props);
	  var ElementType = (0, _lib.getElementType)(Grid, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), children);
	}
	
	Grid.handledProps = ["as", "celled", "centered", "children", "className", "columns", "container", "divided", "doubling", "inverted", "padded", "relaxed", "reversed", "stackable", "stretched", "textAlign", "verticalAlign"];
	Grid.Column = _GridColumn["default"];
	Grid.Row = _GridRow["default"];
	Grid.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A grid can have rows divided into cells. */
	  celled: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['internally'])]),
	
	  /** A grid can have its columns centered. */
	  centered: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Represents column count per row in Grid. */
	  columns: _propTypes["default"].oneOf([].concat((0, _toConsumableArray2["default"])(_lib.SUI.WIDTHS), ['equal'])),
	
	  /** A grid can be combined with a container to use the available layout and alignment. */
	  container: _propTypes["default"].bool,
	
	  /** A grid can have dividers between its columns. */
	  divided: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['vertically'])]),
	
	  /** A grid can double its column width on tablet and mobile sizes. */
	  doubling: _propTypes["default"].bool,
	
	  /** A grid's colors can be inverted. */
	  inverted: _propTypes["default"].bool,
	
	  /** A grid can preserve its vertical and horizontal gutters on first and last columns. */
	  padded: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['horizontally', 'vertically'])]),
	
	  /** A grid can increase its gutters to allow for more negative space. */
	  relaxed: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['very'])]),
	
	  /** A grid can specify that its columns should reverse order at different device sizes. */
	  reversed: _lib.customPropTypes.multipleProp(['computer', 'computer vertically', 'mobile', 'mobile vertically', 'tablet', 'tablet vertically']),
	
	  /** A grid can have its columns stack on-top of each other after reaching mobile breakpoints. */
	  stackable: _propTypes["default"].bool,
	
	  /** A grid can stretch its contents to take up the entire grid height. */
	  stretched: _propTypes["default"].bool,
	
	  /** A grid can specify its text alignment. */
	  textAlign: _propTypes["default"].oneOf(_lib.SUI.TEXT_ALIGNMENTS),
	
	  /** A grid can specify its vertical alignment to have all its columns vertically centered. */
	  verticalAlign: _propTypes["default"].oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : {};
	var _default = Grid;
	exports["default"] = _default;

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(46));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A row sub-component for Grid.
	 */
	function GridRow(props) {
	  var centered = props.centered,
	      children = props.children,
	      className = props.className,
	      color = props.color,
	      columns = props.columns,
	      divided = props.divided,
	      only = props.only,
	      reversed = props.reversed,
	      stretched = props.stretched,
	      textAlign = props.textAlign,
	      verticalAlign = props.verticalAlign;
	  var classes = (0, _classnames["default"])(color, (0, _lib.useKeyOnly)(centered, 'centered'), (0, _lib.useKeyOnly)(divided, 'divided'), (0, _lib.useKeyOnly)(stretched, 'stretched'), (0, _lib.useMultipleProp)(only, 'only'), (0, _lib.useMultipleProp)(reversed, 'reversed'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(columns, 'column', true), 'row', className);
	  var rest = (0, _lib.getUnhandledProps)(GridRow, props);
	  var ElementType = (0, _lib.getElementType)(GridRow, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), children);
	}
	
	GridRow.handledProps = ["as", "centered", "children", "className", "color", "columns", "divided", "only", "reversed", "stretched", "textAlign", "verticalAlign"];
	GridRow.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A row can have its columns centered. */
	  centered: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** A grid row can be colored. */
	  color: _propTypes["default"].oneOf(_lib.SUI.COLORS),
	
	  /** Represents column count per line in Row. */
	  columns: _propTypes["default"].oneOf([].concat((0, _toConsumableArray2["default"])(_lib.SUI.WIDTHS), ['equal'])),
	
	  /** A row can have dividers between its columns. */
	  divided: _propTypes["default"].bool,
	
	  /** A row can appear only for a specific device, or screen sizes. */
	  only: _lib.customPropTypes.multipleProp(_lib.SUI.VISIBILITY),
	
	  /** A row can specify that its columns should reverse order at different device sizes. */
	  reversed: _lib.customPropTypes.multipleProp(['computer', 'computer vertically', 'mobile', 'mobile vertically', 'tablet', 'tablet vertically']),
	
	  /** A row can stretch its contents to take up the entire column height. */
	  stretched: _propTypes["default"].bool,
	
	  /** A row can specify its text alignment. */
	  textAlign: _propTypes["default"].oneOf(_lib.SUI.TEXT_ALIGNMENTS),
	
	  /** A row can specify its vertical alignment to have all its columns vertically centered. */
	  verticalAlign: _propTypes["default"].oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : {};
	var _default = GridRow;
	exports["default"] = _default;

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _map2 = _interopRequireDefault(__webpack_require__(41));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _MenuHeader = _interopRequireDefault(__webpack_require__(706));
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(309));
	
	var _MenuMenu = _interopRequireDefault(__webpack_require__(707));
	
	/**
	 * A menu displays grouped navigation actions.
	 * @see Dropdown
	 */
	var Menu =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Menu, _Component);
	
	  function Menu() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Menu);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Menu)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleItemOverrides", function (predefinedProps) {
	      return {
	        onClick: function onClick(e, itemProps) {
	          var index = itemProps.index;
	
	          _this.trySetState({
	            activeIndex: index
	          });
	
	          (0, _invoke2["default"])(predefinedProps, 'onClick', e, itemProps);
	          (0, _invoke2["default"])(_this.props, 'onItemClick', e, itemProps);
	        }
	      };
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Menu, [{
	    key: "renderItems",
	    value: function renderItems() {
	      var _this2 = this;
	
	      var items = this.props.items;
	      var activeIndex = this.state.activeIndex;
	      return (0, _map2["default"])(items, function (item, index) {
	        return _MenuItem["default"].create(item, {
	          defaultProps: {
	            active: parseInt(activeIndex, 10) === index,
	            index: index
	          },
	          overrideProps: _this2.handleItemOverrides
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          attached = _this$props.attached,
	          borderless = _this$props.borderless,
	          children = _this$props.children,
	          className = _this$props.className,
	          color = _this$props.color,
	          compact = _this$props.compact,
	          fixed = _this$props.fixed,
	          floated = _this$props.floated,
	          fluid = _this$props.fluid,
	          icon = _this$props.icon,
	          inverted = _this$props.inverted,
	          pagination = _this$props.pagination,
	          pointing = _this$props.pointing,
	          secondary = _this$props.secondary,
	          size = _this$props.size,
	          stackable = _this$props.stackable,
	          tabular = _this$props.tabular,
	          text = _this$props.text,
	          vertical = _this$props.vertical,
	          widths = _this$props.widths;
	      var classes = (0, _classnames["default"])('ui', color, size, (0, _lib.useKeyOnly)(borderless, 'borderless'), (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(pagination, 'pagination'), (0, _lib.useKeyOnly)(pointing, 'pointing'), (0, _lib.useKeyOnly)(secondary, 'secondary'), (0, _lib.useKeyOnly)(stackable, 'stackable'), (0, _lib.useKeyOnly)(text, 'text'), (0, _lib.useKeyOnly)(vertical, 'vertical'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), (0, _lib.useKeyOrValueAndKey)(floated, 'floated'), (0, _lib.useKeyOrValueAndKey)(icon, 'icon'), (0, _lib.useKeyOrValueAndKey)(tabular, 'tabular'), (0, _lib.useValueAndKey)(fixed, 'fixed'), (0, _lib.useWidthProp)(widths, 'item'), className, 'menu');
	      var rest = (0, _lib.getUnhandledProps)(Menu, this.props);
	      var ElementType = (0, _lib.getElementType)(Menu, this.props);
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes
	      }), _lib.childrenUtils.isNil(children) ? this.renderItems() : children);
	    }
	  }]);
	  return Menu;
	}(_lib.AutoControlledComponent);
	
	(0, _defineProperty2["default"])(Menu, "autoControlledProps", ['activeIndex']);
	(0, _defineProperty2["default"])(Menu, "Header", _MenuHeader["default"]);
	(0, _defineProperty2["default"])(Menu, "Item", _MenuItem["default"]);
	(0, _defineProperty2["default"])(Menu, "Menu", _MenuMenu["default"]);
	(0, _defineProperty2["default"])(Menu, "handledProps", ["activeIndex", "as", "attached", "borderless", "children", "className", "color", "compact", "defaultActiveIndex", "fixed", "floated", "fluid", "icon", "inverted", "items", "onItemClick", "pagination", "pointing", "secondary", "size", "stackable", "tabular", "text", "vertical", "widths"]);
	Menu.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Index of the currently active item. */
	  activeIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /** A menu may be attached to other content segments. */
	  attached: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['top', 'bottom'])]),
	
	  /** A menu item or menu can have no borders. */
	  borderless: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Additional colors can be specified. */
	  color: _propTypes["default"].oneOf(_lib.SUI.COLORS),
	
	  /** A menu can take up only the space necessary to fit its content. */
	  compact: _propTypes["default"].bool,
	
	  /** Initial activeIndex value. */
	  defaultActiveIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /** A menu can be fixed to a side of its context. */
	  fixed: _propTypes["default"].oneOf(['left', 'right', 'bottom', 'top']),
	
	  /** A menu can be floated. */
	  floated: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['right'])]),
	
	  /** A vertical menu may take the size of its container. */
	  fluid: _propTypes["default"].bool,
	
	  /** A menu may have just icons (bool) or labeled icons. */
	  icon: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['labeled'])]),
	
	  /** A menu may have its colors inverted to show greater contrast. */
	  inverted: _propTypes["default"].bool,
	
	  /** Shorthand array of props for Menu. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /**
	   * onClick handler for MenuItem. Mutually exclusive with children.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All item props.
	   */
	  onItemClick: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _propTypes["default"].func]),
	
	  /** A pagination menu is specially formatted to present links to pages of content. */
	  pagination: _propTypes["default"].bool,
	
	  /** A menu can point to show its relationship to nearby content. */
	  pointing: _propTypes["default"].bool,
	
	  /** A menu can adjust its appearance to de-emphasize its contents. */
	  secondary: _propTypes["default"].bool,
	
	  /** A menu can vary in size. */
	  size: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.SIZES, 'medium', 'big')),
	
	  /** A menu can stack at mobile resolutions. */
	  stackable: _propTypes["default"].bool,
	
	  /** A menu can be formatted to show tabs of information. */
	  tabular: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['right'])]),
	
	  /** A menu can be formatted for text content. */
	  text: _propTypes["default"].bool,
	
	  /** A vertical menu displays elements vertically. */
	  vertical: _propTypes["default"].bool,
	
	  /** A menu can have its items divided evenly. */
	  widths: _propTypes["default"].oneOf(_lib.SUI.WIDTHS)
	} : {};
	Menu.create = (0, _lib.createShorthandFactory)(Menu, function (items) {
	  return {
	    items: items
	  };
	});
	var _default = Menu;
	exports["default"] = _default;

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A menu item may include a header or may itself be a header.
	 */
	function MenuHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('header', className);
	  var rest = (0, _lib.getUnhandledProps)(MenuHeader, props);
	  var ElementType = (0, _lib.getElementType)(MenuHeader, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	MenuHeader.handledProps = ["as", "children", "className", "content"];
	MenuHeader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	var _default = MenuHeader;
	exports["default"] = _default;

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A menu can contain a sub menu.
	 */
	function MenuMenu(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      position = props.position;
	  var classes = (0, _classnames["default"])(position, 'menu', className);
	  var rest = (0, _lib.getUnhandledProps)(MenuMenu, props);
	  var ElementType = (0, _lib.getElementType)(MenuMenu, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	MenuMenu.handledProps = ["as", "children", "className", "content", "position"];
	MenuMenu.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A sub menu can take left or right position. */
	  position: _propTypes["default"].oneOf(['left', 'right'])
	} : {};
	var _default = MenuMenu;
	exports["default"] = _default;

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Menu["default"];
	  }
	});
	
	var _Menu = _interopRequireDefault(__webpack_require__(705));

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A message can contain a content.
	 */
	function MessageContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('content', className);
	  var rest = (0, _lib.getUnhandledProps)(MessageContent, props);
	  var ElementType = (0, _lib.getElementType)(MessageContent, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	MessageContent.handledProps = ["as", "children", "className", "content"];
	MessageContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	var _default = MessageContent;
	exports["default"] = _default;

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A message can contain a header.
	 */
	function MessageHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('header', className);
	  var rest = (0, _lib.getUnhandledProps)(MessageHeader, props);
	  var ElementType = (0, _lib.getElementType)(MessageHeader, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	MessageHeader.handledProps = ["as", "children", "className", "content"];
	MessageHeader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	MessageHeader.create = (0, _lib.createShorthandFactory)(MessageHeader, function (val) {
	  return {
	    content: val
	  };
	});
	var _default = MessageHeader;
	exports["default"] = _default;

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _map2 = _interopRequireDefault(__webpack_require__(41));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _MessageItem = _interopRequireDefault(__webpack_require__(310));
	
	/**
	 * A message can contain a list of items.
	 */
	function MessageList(props) {
	  var children = props.children,
	      className = props.className,
	      items = props.items;
	  var classes = (0, _classnames["default"])('list', className);
	  var rest = (0, _lib.getUnhandledProps)(MessageList, props);
	  var ElementType = (0, _lib.getElementType)(MessageList, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? (0, _map2["default"])(items, _MessageItem["default"].create) : children);
	}
	
	MessageList.handledProps = ["as", "children", "className", "items"];
	MessageList.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand Message.Items. */
	  items: _lib.customPropTypes.collectionShorthand
	} : {};
	MessageList.defaultProps = {
	  as: 'ul'
	};
	MessageList.create = (0, _lib.createShorthandFactory)(MessageList, function (val) {
	  return {
	    items: val
	  };
	});
	var _default = MessageList;
	exports["default"] = _default;

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	function TableBody(props) {
	  var children = props.children,
	      className = props.className;
	  var classes = (0, _classnames["default"])(className);
	  var rest = (0, _lib.getUnhandledProps)(TableBody, props);
	  var ElementType = (0, _lib.getElementType)(TableBody, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), children);
	}
	
	TableBody.handledProps = ["as", "children", "className"];
	TableBody.defaultProps = {
	  as: 'tbody'
	};
	TableBody.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string
	} : {};
	var _default = TableBody;
	exports["default"] = _default;

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _TableHeader = _interopRequireDefault(__webpack_require__(311));
	
	/**
	 * A table can have a footer.
	 */
	function TableFooter(props) {
	  var as = props.as;
	  var rest = (0, _lib.getUnhandledProps)(TableFooter, props);
	  return _react["default"].createElement(_TableHeader["default"], (0, _extends2["default"])({}, rest, {
	    as: as
	  }));
	}
	
	TableFooter.handledProps = ["as"];
	TableFooter.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType
	} : {};
	TableFooter.defaultProps = {
	  as: 'tfoot'
	};
	var _default = TableFooter;
	exports["default"] = _default;

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _TableCell = _interopRequireDefault(__webpack_require__(218));
	
	/**
	 * A table can have a header cell.
	 */
	function TableHeaderCell(props) {
	  var as = props.as,
	      className = props.className,
	      sorted = props.sorted;
	  var classes = (0, _classnames["default"])((0, _lib.useValueAndKey)(sorted, 'sorted'), className);
	  var rest = (0, _lib.getUnhandledProps)(TableHeaderCell, props);
	  return _react["default"].createElement(_TableCell["default"], (0, _extends2["default"])({}, rest, {
	    as: as,
	    className: classes
	  }));
	}
	
	TableHeaderCell.handledProps = ["as", "className", "sorted"];
	TableHeaderCell.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** A header cell can be sorted in ascending or descending order. */
	  sorted: _propTypes["default"].oneOf(['ascending', 'descending'])
	} : {};
	TableHeaderCell.defaultProps = {
	  as: 'th'
	};
	var _default = TableHeaderCell;
	exports["default"] = _default;

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _map2 = _interopRequireDefault(__webpack_require__(41));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _TableCell = _interopRequireDefault(__webpack_require__(218));
	
	/**
	 * A table can have rows.
	 */
	function TableRow(props) {
	  var active = props.active,
	      cellAs = props.cellAs,
	      cells = props.cells,
	      children = props.children,
	      className = props.className,
	      disabled = props.disabled,
	      error = props.error,
	      negative = props.negative,
	      positive = props.positive,
	      textAlign = props.textAlign,
	      verticalAlign = props.verticalAlign,
	      warning = props.warning;
	  var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(negative, 'negative'), (0, _lib.useKeyOnly)(positive, 'positive'), (0, _lib.useKeyOnly)(warning, 'warning'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useVerticalAlignProp)(verticalAlign), className);
	  var rest = (0, _lib.getUnhandledProps)(TableRow, props);
	  var ElementType = (0, _lib.getElementType)(TableRow, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), (0, _map2["default"])(cells, function (cell) {
	    return _TableCell["default"].create(cell, {
	      defaultProps: {
	        as: cellAs
	      }
	    });
	  }));
	}
	
	TableRow.handledProps = ["active", "as", "cellAs", "cells", "children", "className", "disabled", "error", "negative", "positive", "textAlign", "verticalAlign", "warning"];
	TableRow.defaultProps = {
	  as: 'tr',
	  cellAs: 'td'
	};
	TableRow.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A row can be active or selected by a user. */
	  active: _propTypes["default"].bool,
	
	  /** An element type to render as (string or function). */
	  cellAs: _propTypes["default"].elementType,
	
	  /** Shorthand array of props for TableCell. */
	  cells: _lib.customPropTypes.collectionShorthand,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** A row can be disabled. */
	  disabled: _propTypes["default"].bool,
	
	  /** A row may call attention to an error or a negative value. */
	  error: _propTypes["default"].bool,
	
	  /** A row may let a user know whether a value is bad. */
	  negative: _propTypes["default"].bool,
	
	  /** A row may let a user know whether a value is good. */
	  positive: _propTypes["default"].bool,
	
	  /** A table row can adjust its text alignment. */
	  textAlign: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.TEXT_ALIGNMENTS, 'justified')),
	
	  /** A table row can adjust its vertical alignment. */
	  verticalAlign: _propTypes["default"].oneOf(_lib.SUI.VERTICAL_ALIGNMENTS),
	
	  /** A row may warn a user. */
	  warning: _propTypes["default"].bool
	} : {};
	TableRow.create = (0, _lib.createShorthandFactory)(TableRow, function (cells) {
	  return {
	    cells: cells
	  };
	});
	var _default = TableRow;
	exports["default"] = _default;

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * Used in some Button types, such as `animated`.
	 */
	function ButtonContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      hidden = props.hidden,
	      visible = props.visible;
	  var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(visible, 'visible'), (0, _lib.useKeyOnly)(hidden, 'hidden'), 'content', className);
	  var rest = (0, _lib.getUnhandledProps)(ButtonContent, props);
	  var ElementType = (0, _lib.getElementType)(ButtonContent, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	ButtonContent.handledProps = ["as", "children", "className", "content", "hidden", "visible"];
	ButtonContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Initially hidden, visible on hover. */
	  hidden: _propTypes["default"].bool,
	
	  /** Initially visible, hidden on hover. */
	  visible: _propTypes["default"].bool
	} : {};
	var _default = ButtonContent;
	exports["default"] = _default;

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _map2 = _interopRequireDefault(__webpack_require__(41));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(43));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Button = _interopRequireDefault(__webpack_require__(312));
	
	/**
	 * Buttons can be grouped.
	 */
	function ButtonGroup(props) {
	  var attached = props.attached,
	      basic = props.basic,
	      buttons = props.buttons,
	      children = props.children,
	      className = props.className,
	      color = props.color,
	      compact = props.compact,
	      content = props.content,
	      floated = props.floated,
	      fluid = props.fluid,
	      icon = props.icon,
	      inverted = props.inverted,
	      labeled = props.labeled,
	      negative = props.negative,
	      positive = props.positive,
	      primary = props.primary,
	      secondary = props.secondary,
	      size = props.size,
	      toggle = props.toggle,
	      vertical = props.vertical,
	      widths = props.widths;
	  var classes = (0, _classnames["default"])('ui', color, size, (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(icon, 'icon'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(labeled, 'labeled'), (0, _lib.useKeyOnly)(negative, 'negative'), (0, _lib.useKeyOnly)(positive, 'positive'), (0, _lib.useKeyOnly)(primary, 'primary'), (0, _lib.useKeyOnly)(secondary, 'secondary'), (0, _lib.useKeyOnly)(toggle, 'toggle'), (0, _lib.useKeyOnly)(vertical, 'vertical'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useWidthProp)(widths), 'buttons', className);
	  var rest = (0, _lib.getUnhandledProps)(ButtonGroup, props);
	  var ElementType = (0, _lib.getElementType)(ButtonGroup, props);
	
	  if ((0, _isNil2["default"])(buttons)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), _lib.childrenUtils.isNil(children) ? content : children);
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), (0, _map2["default"])(buttons, function (button) {
	    return _Button["default"].create(button);
	  }));
	}
	
	ButtonGroup.handledProps = ["as", "attached", "basic", "buttons", "children", "className", "color", "compact", "content", "floated", "fluid", "icon", "inverted", "labeled", "negative", "positive", "primary", "secondary", "size", "toggle", "vertical", "widths"];
	ButtonGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Groups can be attached to other content. */
	  attached: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['left', 'right', 'top', 'bottom'])]),
	
	  /** Groups can be less pronounced. */
	  basic: _propTypes["default"].bool,
	
	  /** Array of shorthand Button values. */
	  buttons: _lib.customPropTypes.collectionShorthand,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Groups can have a shared color. */
	  color: _propTypes["default"].oneOf(_lib.SUI.COLORS),
	
	  /** Groups can reduce their padding to fit into tighter spaces. */
	  compact: _propTypes["default"].bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Groups can be aligned to the left or right of its container. */
	  floated: _propTypes["default"].oneOf(_lib.SUI.FLOATS),
	
	  /** Groups can take the width of their container. */
	  fluid: _propTypes["default"].bool,
	
	  /** Groups can be formatted as icons. */
	  icon: _propTypes["default"].bool,
	
	  /** Groups can be formatted to appear on dark backgrounds. */
	  inverted: _propTypes["default"].bool,
	
	  /** Groups can be formatted as labeled icon buttons. */
	  labeled: _propTypes["default"].bool,
	
	  /** Groups can hint towards a negative consequence. */
	  negative: _propTypes["default"].bool,
	
	  /** Groups can hint towards a positive consequence. */
	  positive: _propTypes["default"].bool,
	
	  /** Groups can be formatted to show different levels of emphasis. */
	  primary: _propTypes["default"].bool,
	
	  /** Groups can be formatted to show different levels of emphasis. */
	  secondary: _propTypes["default"].bool,
	
	  /** Groups can have different sizes. */
	  size: _propTypes["default"].oneOf(_lib.SUI.SIZES),
	
	  /** Groups can be formatted to toggle on and off. */
	  toggle: _propTypes["default"].bool,
	
	  /** Groups can be formatted to appear vertically. */
	  vertical: _propTypes["default"].bool,
	
	  /** Groups can have their widths divided evenly. */
	  widths: _propTypes["default"].oneOf(_lib.SUI.WIDTHS)
	} : {};
	var _default = ButtonGroup;
	exports["default"] = _default;

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * Button groups can contain conditionals.
	 */
	function ButtonOr(props) {
	  var className = props.className,
	      text = props.text;
	  var classes = (0, _classnames["default"])('or', className);
	  var rest = (0, _lib.getUnhandledProps)(ButtonOr, props);
	  var ElementType = (0, _lib.getElementType)(ButtonOr, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes,
	    "data-text": text
	  }));
	}
	
	ButtonOr.handledProps = ["as", "className", "text"];
	ButtonOr.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Or buttons can have their text localized, or adjusted by using the text prop. */
	  text: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	} : {};
	var _default = ButtonOr;
	exports["default"] = _default;

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Flag["default"];
	  }
	});
	
	var _Flag = _interopRequireDefault(__webpack_require__(7252));

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * Header content wraps the main content when there is an adjacent Icon or Image.
	 */
	function HeaderContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('content', className);
	  var rest = (0, _lib.getUnhandledProps)(HeaderContent, props);
	  var ElementType = (0, _lib.getElementType)(HeaderContent, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	HeaderContent.handledProps = ["as", "children", "className", "content"];
	HeaderContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	var _default = HeaderContent;
	exports["default"] = _default;

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * Headers may contain subheaders.
	 */
	function HeaderSubheader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('sub header', className);
	  var rest = (0, _lib.getUnhandledProps)(HeaderSubheader, props);
	  var ElementType = (0, _lib.getElementType)(HeaderSubheader, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	HeaderSubheader.handledProps = ["as", "children", "className", "content"];
	HeaderSubheader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	HeaderSubheader.create = (0, _lib.createShorthandFactory)(HeaderSubheader, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = HeaderSubheader;
	exports["default"] = _default;

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * Several icons can be used together as a group.
	 */
	function IconGroup(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      size = props.size;
	  var classes = (0, _classnames["default"])(size, 'icons', className);
	  var rest = (0, _lib.getUnhandledProps)(IconGroup, props);
	  var ElementType = (0, _lib.getElementType)(IconGroup, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	IconGroup.handledProps = ["as", "children", "className", "content", "size"];
	IconGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Size of the icon group. */
	  size: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.SIZES, 'medium'))
	} : {};
	IconGroup.defaultProps = {
	  as: 'i'
	};
	var _default = IconGroup;
	exports["default"] = _default;

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(43));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Dimmer = _interopRequireDefault(__webpack_require__(745));
	
	var _Label = _interopRequireDefault(__webpack_require__(314));
	
	var _ImageGroup = _interopRequireDefault(__webpack_require__(724));
	
	/**
	 * An image is a graphic representation of something.
	 * @see Icon
	 */
	function Image(props) {
	  var avatar = props.avatar,
	      bordered = props.bordered,
	      centered = props.centered,
	      children = props.children,
	      circular = props.circular,
	      className = props.className,
	      content = props.content,
	      dimmer = props.dimmer,
	      disabled = props.disabled,
	      floated = props.floated,
	      fluid = props.fluid,
	      hidden = props.hidden,
	      href = props.href,
	      inline = props.inline,
	      label = props.label,
	      rounded = props.rounded,
	      size = props.size,
	      spaced = props.spaced,
	      verticalAlign = props.verticalAlign,
	      wrapped = props.wrapped,
	      ui = props.ui;
	  var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(ui, 'ui'), size, (0, _lib.useKeyOnly)(avatar, 'avatar'), (0, _lib.useKeyOnly)(bordered, 'bordered'), (0, _lib.useKeyOnly)(circular, 'circular'), (0, _lib.useKeyOnly)(centered, 'centered'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(hidden, 'hidden'), (0, _lib.useKeyOnly)(inline, 'inline'), (0, _lib.useKeyOnly)(rounded, 'rounded'), (0, _lib.useKeyOrValueAndKey)(spaced, 'spaced'), (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useVerticalAlignProp)(verticalAlign, 'aligned'), 'image', className);
	  var rest = (0, _lib.getUnhandledProps)(Image, props);
	
	  var _partitionHTMLProps = (0, _lib.partitionHTMLProps)(rest, {
	    htmlProps: _lib.htmlImageProps
	  }),
	      _partitionHTMLProps2 = (0, _slicedToArray2["default"])(_partitionHTMLProps, 2),
	      imgTagProps = _partitionHTMLProps2[0],
	      rootProps = _partitionHTMLProps2[1];
	
	  var ElementType = (0, _lib.getElementType)(Image, props, function () {
	    if (!(0, _isNil2["default"])(dimmer) || !(0, _isNil2["default"])(label) || !(0, _isNil2["default"])(wrapped) || !_lib.childrenUtils.isNil(children)) {
	      return 'div';
	    }
	  });
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  if (!_lib.childrenUtils.isNil(content)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), content);
	  }
	
	  if (ElementType === 'img') {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rootProps, imgTagProps, {
	      className: classes
	    }));
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rootProps, {
	    className: classes,
	    href: href
	  }), _Dimmer["default"].create(dimmer, {
	    autoGenerateKey: false
	  }), _Label["default"].create(label, {
	    autoGenerateKey: false
	  }), _react["default"].createElement("img", imgTagProps));
	}
	
	Image.handledProps = ["as", "avatar", "bordered", "centered", "children", "circular", "className", "content", "dimmer", "disabled", "floated", "fluid", "hidden", "href", "inline", "label", "rounded", "size", "spaced", "ui", "verticalAlign", "wrapped"];
	Image.Group = _ImageGroup["default"];
	Image.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** An image may be formatted to appear inline with text as an avatar. */
	  avatar: _propTypes["default"].bool,
	
	  /** An image may include a border to emphasize the edges of white or transparent content. */
	  bordered: _propTypes["default"].bool,
	
	  /** An image can appear centered in a content block. */
	  centered: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** An image may appear circular. */
	  circular: _propTypes["default"].bool,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** An image can show that it is disabled and cannot be selected. */
	  disabled: _propTypes["default"].bool,
	
	  /** Shorthand for Dimmer. */
	  dimmer: _lib.customPropTypes.itemShorthand,
	
	  /** An image can sit to the left or right of other content. */
	  floated: _propTypes["default"].oneOf(_lib.SUI.FLOATS),
	
	  /** An image can take up the width of its container. */
	  fluid: _lib.customPropTypes.every([_propTypes["default"].bool, _lib.customPropTypes.disallow(['size'])]),
	
	  /** An image can be hidden. */
	  hidden: _propTypes["default"].bool,
	
	  /** Renders the Image as an <a> tag with this href. */
	  href: _propTypes["default"].string,
	
	  /** An image may appear inline. */
	  inline: _propTypes["default"].bool,
	
	  /** Shorthand for Label. */
	  label: _lib.customPropTypes.itemShorthand,
	
	  /** An image may appear rounded. */
	  rounded: _propTypes["default"].bool,
	
	  /** An image may appear at different sizes. */
	  size: _propTypes["default"].oneOf(_lib.SUI.SIZES),
	
	  /** An image can specify that it needs an additional spacing to separate it from nearby content. */
	  spaced: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['left', 'right'])]),
	
	  /** Whether or not to add the ui className. */
	  ui: _propTypes["default"].bool,
	
	  /** An image can specify its vertical alignment. */
	  verticalAlign: _propTypes["default"].oneOf(_lib.SUI.VERTICAL_ALIGNMENTS),
	
	  /** An image can render wrapped in a `div.ui.image` as alternative HTML markup. */
	  wrapped: _propTypes["default"].bool
	} : {};
	Image.defaultProps = {
	  as: 'img',
	  ui: true
	};
	Image.create = (0, _lib.createShorthandFactory)(Image, function (value) {
	  return {
	    src: value
	  };
	});
	var _default = Image;
	exports["default"] = _default;

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A group of images.
	 */
	function ImageGroup(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      size = props.size;
	  var classes = (0, _classnames["default"])('ui', size, className, 'images');
	  var rest = (0, _lib.getUnhandledProps)(ImageGroup, props);
	  var ElementType = (0, _lib.getElementType)(ImageGroup, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	ImageGroup.handledProps = ["as", "children", "className", "content", "size"];
	ImageGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A group of images can be formatted to have the same size. */
	  size: _propTypes["default"].oneOf(_lib.SUI.SIZES)
	} : {};
	var _default = ImageGroup;
	exports["default"] = _default;

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	function LabelDetail(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('detail', className);
	  var rest = (0, _lib.getUnhandledProps)(LabelDetail, props);
	  var ElementType = (0, _lib.getElementType)(LabelDetail, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	LabelDetail.handledProps = ["as", "children", "className", "content"];
	LabelDetail.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	LabelDetail.create = (0, _lib.createShorthandFactory)(LabelDetail, function (val) {
	  return {
	    content: val
	  };
	});
	var _default = LabelDetail;
	exports["default"] = _default;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A label can be grouped.
	 */
	function LabelGroup(props) {
	  var children = props.children,
	      circular = props.circular,
	      className = props.className,
	      color = props.color,
	      content = props.content,
	      size = props.size,
	      tag = props.tag;
	  var classes = (0, _classnames["default"])('ui', color, size, (0, _lib.useKeyOnly)(circular, 'circular'), (0, _lib.useKeyOnly)(tag, 'tag'), 'labels', className);
	  var rest = (0, _lib.getUnhandledProps)(LabelGroup, props);
	  var ElementType = (0, _lib.getElementType)(LabelGroup, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	LabelGroup.handledProps = ["as", "children", "circular", "className", "color", "content", "size", "tag"];
	LabelGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Labels can share shapes. */
	  circular: _propTypes["default"].bool,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Label group can share colors together. */
	  color: _propTypes["default"].oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Label group can share sizes together. */
	  size: _propTypes["default"].oneOf(_lib.SUI.SIZES),
	
	  /** Label group can share tag formatting. */
	  tag: _propTypes["default"].bool
	} : {};
	var _default = LabelGroup;
	exports["default"] = _default;

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(150));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Image = _interopRequireDefault(__webpack_require__(124));
	
	var _ListContent = _interopRequireDefault(__webpack_require__(315));
	
	var _ListDescription = _interopRequireDefault(__webpack_require__(221));
	
	var _ListHeader = _interopRequireDefault(__webpack_require__(222));
	
	var _ListIcon = _interopRequireDefault(__webpack_require__(316));
	
	/**
	 * A list item can contain a set of items.
	 */
	var ListItem =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(ListItem, _Component);
	
	  function ListItem() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, ListItem);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(ListItem)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (e) {
	      var disabled = _this.props.disabled;
	      if (!disabled) (0, _invoke2["default"])(_this.props, 'onClick', e, _this.props);
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(ListItem, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          active = _this$props.active,
	          children = _this$props.children,
	          className = _this$props.className,
	          content = _this$props.content,
	          description = _this$props.description,
	          disabled = _this$props.disabled,
	          header = _this$props.header,
	          icon = _this$props.icon,
	          image = _this$props.image,
	          value = _this$props.value;
	      var ElementType = (0, _lib.getElementType)(ListItem, this.props);
	      var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(ElementType !== 'li', 'item'), className);
	      var rest = (0, _lib.getUnhandledProps)(ListItem, this.props);
	      var valueProp = ElementType === 'li' ? {
	        value: value
	      } : {
	        'data-value': value
	      };
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, valueProp, {
	          role: "listitem",
	          className: classes,
	          onClick: this.handleClick
	        }, rest), children);
	      }
	
	      var iconElement = _ListIcon["default"].create(icon, {
	        autoGenerateKey: false
	      });
	
	      var imageElement = _Image["default"].create(image, {
	        autoGenerateKey: false
	      }); // See description of `content` prop for explanation about why this is necessary.
	
	
	      if (!(0, _react.isValidElement)(content) && (0, _isPlainObject2["default"])(content)) {
	        return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, valueProp, {
	          role: "listitem",
	          className: classes,
	          onClick: this.handleClick
	        }, rest), iconElement || imageElement, _ListContent["default"].create(content, {
	          autoGenerateKey: false,
	          defaultProps: {
	            header: header,
	            description: description
	          }
	        }));
	      }
	
	      var headerElement = _ListHeader["default"].create(header, {
	        autoGenerateKey: false
	      });
	
	      var descriptionElement = _ListDescription["default"].create(description, {
	        autoGenerateKey: false
	      });
	
	      if (iconElement || imageElement) {
	        return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, valueProp, {
	          role: "listitem",
	          className: classes,
	          onClick: this.handleClick
	        }, rest), iconElement || imageElement, (content || headerElement || descriptionElement) && _react["default"].createElement(_ListContent["default"], null, headerElement, descriptionElement, content));
	      }
	
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, valueProp, {
	        role: "listitem",
	        className: classes,
	        onClick: this.handleClick
	      }, rest), headerElement, descriptionElement, content);
	    }
	  }]);
	  return ListItem;
	}(_react.Component);
	
	(0, _defineProperty2["default"])(ListItem, "handledProps", ["active", "as", "children", "className", "content", "description", "disabled", "header", "icon", "image", "onClick", "value"]);
	ListItem.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A list item can active. */
	  active: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /**
	   * Shorthand for primary content.
	   *
	   * Heads up!
	   *
	   * This is handled slightly differently than the typical `content` prop since
	   * the wrapping ListContent is not used when there's no icon or image.
	   *
	   * If you pass content as:
	   * - an element/literal, it's treated as the sibling node to
	   * header/description (whether wrapped in Item.Content or not).
	   * - a props object, it forces the presence of Item.Content and passes those
	   * props to it. If you pass a content prop within that props object, it
	   * will be treated as the sibling node to header/description.
	   */
	  content: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ListDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** A list item can disabled. */
	  disabled: _propTypes["default"].bool,
	
	  /** Shorthand for ListHeader. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ListIcon. */
	  icon: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['image']), _lib.customPropTypes.itemShorthand]),
	
	  /** Shorthand for Image. */
	  image: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['icon']), _lib.customPropTypes.itemShorthand]),
	
	  /** A ListItem can be clicked */
	  onClick: _propTypes["default"].func,
	
	  /** A value for an ordered list. */
	  value: _propTypes["default"].string
	} : {};
	ListItem.create = (0, _lib.createShorthandFactory)(ListItem, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = ListItem;
	exports["default"] = _default;

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A list can contain a sub list.
	 */
	function ListList(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var rest = (0, _lib.getUnhandledProps)(ListList, props);
	  var ElementType = (0, _lib.getElementType)(ListList, props);
	  var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(ElementType !== 'ul' && ElementType !== 'ol', 'list'), className);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	ListList.handledProps = ["as", "children", "className", "content"];
	ListList.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	var _default = ListList;
	exports["default"] = _default;

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A placeholder can contain a header.
	 */
	function PlaceholderHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      image = props.image;
	  var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(image, 'image'), 'header', className);
	  var rest = (0, _lib.getUnhandledProps)(PlaceholderHeader, props);
	  var ElementType = (0, _lib.getElementType)(PlaceholderHeader, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	PlaceholderHeader.handledProps = ["as", "children", "className", "content", "image"];
	PlaceholderHeader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A placeholder can contain an image. */
	  image: _propTypes["default"].bool
	} : {};
	var _default = PlaceholderHeader;
	exports["default"] = _default;

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A placeholder can contain an image.
	 */
	function PlaceholderImage(props) {
	  var className = props.className,
	      square = props.square,
	      rectangular = props.rectangular;
	  var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(square, 'square'), (0, _lib.useKeyOnly)(rectangular, 'rectangular'), 'image', className);
	  var rest = (0, _lib.getUnhandledProps)(PlaceholderImage, props);
	  var ElementType = (0, _lib.getElementType)(PlaceholderImage, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }));
	}
	
	PlaceholderImage.handledProps = ["as", "className", "rectangular", "square"];
	PlaceholderImage.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** An image can modify size correctly with responsive styles. */
	  square: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['rectangular']), _propTypes["default"].bool]),
	
	  /** An image can modify size correctly with responsive styles. */
	  rectangular: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['square']), _propTypes["default"].bool])
	} : {};
	var _default = PlaceholderImage;
	exports["default"] = _default;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A placeholder can contain have lines of text.
	 */
	function PlaceholderLine(props) {
	  var className = props.className,
	      length = props.length;
	  var classes = (0, _classnames["default"])('line', length, className);
	  var rest = (0, _lib.getUnhandledProps)(PlaceholderLine, props);
	  var ElementType = (0, _lib.getElementType)(PlaceholderLine, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }));
	}
	
	PlaceholderLine.handledProps = ["as", "className", "length"];
	PlaceholderLine.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** A line can specify how long its contents should appear. */
	  length: _propTypes["default"].oneOf(['full', 'very long', 'long', 'medium', 'short', 'very short'])
	} : {};
	var _default = PlaceholderLine;
	exports["default"] = _default;

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A placeholder can contain a paragraph.
	 */
	function PlaceholderParagraph(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('paragraph', className);
	  var rest = (0, _lib.getUnhandledProps)(PlaceholderParagraph, props);
	  var ElementType = (0, _lib.getElementType)(PlaceholderParagraph, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	PlaceholderParagraph.handledProps = ["as", "children", "className", "content"];
	PlaceholderParagraph.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	var _default = PlaceholderParagraph;
	exports["default"] = _default;

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A content sub-component for the Reveal.
	 */
	function RevealContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      hidden = props.hidden,
	      visible = props.visible;
	  var classes = (0, _classnames["default"])('ui', (0, _lib.useKeyOnly)(hidden, 'hidden'), (0, _lib.useKeyOnly)(visible, 'visible'), 'content', className);
	  var rest = (0, _lib.getUnhandledProps)(RevealContent, props);
	  var ElementType = (0, _lib.getElementType)(RevealContent, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	RevealContent.handledProps = ["as", "children", "className", "content", "hidden", "visible"];
	RevealContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A reveal may contain content that is visible before interaction. */
	  hidden: _propTypes["default"].bool,
	
	  /** A reveal may contain content that is hidden before user interaction. */
	  visible: _propTypes["default"].bool
	} : {};
	var _default = RevealContent;
	exports["default"] = _default;

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _SegmentGroup = _interopRequireDefault(__webpack_require__(735));
	
	var _SegmentInline = _interopRequireDefault(__webpack_require__(736));
	
	/**
	 * A segment is used to create a grouping of related content.
	 */
	function Segment(props) {
	  var attached = props.attached,
	      basic = props.basic,
	      children = props.children,
	      circular = props.circular,
	      className = props.className,
	      clearing = props.clearing,
	      color = props.color,
	      compact = props.compact,
	      content = props.content,
	      disabled = props.disabled,
	      floated = props.floated,
	      inverted = props.inverted,
	      loading = props.loading,
	      placeholder = props.placeholder,
	      padded = props.padded,
	      piled = props.piled,
	      raised = props.raised,
	      secondary = props.secondary,
	      size = props.size,
	      stacked = props.stacked,
	      tertiary = props.tertiary,
	      textAlign = props.textAlign,
	      vertical = props.vertical;
	  var classes = (0, _classnames["default"])('ui', color, size, (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(circular, 'circular'), (0, _lib.useKeyOnly)(clearing, 'clearing'), (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useKeyOnly)(placeholder, 'placeholder'), (0, _lib.useKeyOnly)(piled, 'piled'), (0, _lib.useKeyOnly)(raised, 'raised'), (0, _lib.useKeyOnly)(secondary, 'secondary'), (0, _lib.useKeyOnly)(stacked, 'stacked'), (0, _lib.useKeyOnly)(tertiary, 'tertiary'), (0, _lib.useKeyOnly)(vertical, 'vertical'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), (0, _lib.useKeyOrValueAndKey)(padded, 'padded'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useValueAndKey)(floated, 'floated'), 'segment', className);
	  var rest = (0, _lib.getUnhandledProps)(Segment, props);
	  var ElementType = (0, _lib.getElementType)(Segment, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	Segment.handledProps = ["as", "attached", "basic", "children", "circular", "className", "clearing", "color", "compact", "content", "disabled", "floated", "inverted", "loading", "padded", "piled", "placeholder", "raised", "secondary", "size", "stacked", "tertiary", "textAlign", "vertical"];
	Segment.Group = _SegmentGroup["default"];
	Segment.Inline = _SegmentInline["default"];
	Segment.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Attach segment to other content, like a header. */
	  attached: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['top', 'bottom'])]),
	
	  /** A basic segment has no special formatting. */
	  basic: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** A segment can be circular. */
	  circular: _propTypes["default"].bool,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** A segment can clear floated content. */
	  clearing: _propTypes["default"].bool,
	
	  /** Segment can be colored. */
	  color: _propTypes["default"].oneOf(_lib.SUI.COLORS),
	
	  /** A segment may take up only as much space as is necessary. */
	  compact: _propTypes["default"].bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A segment may show its content is disabled. */
	  disabled: _propTypes["default"].bool,
	
	  /** Segment content can be floated to the left or right. */
	  floated: _propTypes["default"].oneOf(_lib.SUI.FLOATS),
	
	  /** A segment can have its colors inverted for contrast. */
	  inverted: _propTypes["default"].bool,
	
	  /** A segment may show its content is being loaded. */
	  loading: _propTypes["default"].bool,
	
	  /** A segment can increase its padding. */
	  padded: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['very'])]),
	
	  /** A segment can be used to reserve space for conditionally displayed content. */
	  placeholder: _propTypes["default"].bool,
	
	  /** Formatted to look like a pile of pages. */
	  piled: _propTypes["default"].bool,
	
	  /** A segment may be formatted to raise above the page. */
	  raised: _propTypes["default"].bool,
	
	  /** A segment can be formatted to appear less noticeable. */
	  secondary: _propTypes["default"].bool,
	
	  /** A segment can have different sizes. */
	  size: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.SIZES, 'medium')),
	
	  /** Formatted to show it contains multiple pages. */
	  stacked: _propTypes["default"].bool,
	
	  /** A segment can be formatted to appear even less noticeable. */
	  tertiary: _propTypes["default"].bool,
	
	  /** Formats content to be aligned as part of a vertical group. */
	  textAlign: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.TEXT_ALIGNMENTS, 'justified')),
	
	  /** Formats content to be aligned vertically. */
	  vertical: _propTypes["default"].bool
	} : {};
	var _default = Segment;
	exports["default"] = _default;

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A group of segments can be formatted to appear together.
	 */
	function SegmentGroup(props) {
	  var children = props.children,
	      className = props.className,
	      compact = props.compact,
	      content = props.content,
	      horizontal = props.horizontal,
	      piled = props.piled,
	      raised = props.raised,
	      size = props.size,
	      stacked = props.stacked;
	  var classes = (0, _classnames["default"])('ui', size, (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(piled, 'piled'), (0, _lib.useKeyOnly)(raised, 'raised'), (0, _lib.useKeyOnly)(stacked, 'stacked'), 'segments', className);
	  var rest = (0, _lib.getUnhandledProps)(SegmentGroup, props);
	  var ElementType = (0, _lib.getElementType)(SegmentGroup, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	SegmentGroup.handledProps = ["as", "children", "className", "compact", "content", "horizontal", "piled", "raised", "size", "stacked"];
	SegmentGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** A segment may take up only as much space as is necessary. */
	  compact: _propTypes["default"].bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Formats content to be aligned horizontally. */
	  horizontal: _propTypes["default"].bool,
	
	  /** Formatted to look like a pile of pages. */
	  piled: _propTypes["default"].bool,
	
	  /** A segment group may be formatted to raise above the page. */
	  raised: _propTypes["default"].bool,
	
	  /** A segment group can have different sizes. */
	  size: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.SIZES, 'medium')),
	
	  /** Formatted to show it contains multiple pages. */
	  stacked: _propTypes["default"].bool
	} : {};
	var _default = SegmentGroup;
	exports["default"] = _default;

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A placeholder segment can be inline.
	 */
	function SegmentInline(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('inline', className);
	  var rest = (0, _lib.getUnhandledProps)(SegmentInline, props);
	  var ElementType = (0, _lib.getElementType)(SegmentInline, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	SegmentInline.handledProps = ["as", "children", "className", "content"];
	SegmentInline.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	var _default = SegmentInline;
	exports["default"] = _default;

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Icon = _interopRequireDefault(__webpack_require__(54));
	
	var _StepContent = _interopRequireDefault(__webpack_require__(738));
	
	var _StepDescription = _interopRequireDefault(__webpack_require__(317));
	
	var _StepGroup = _interopRequireDefault(__webpack_require__(739));
	
	var _StepTitle = _interopRequireDefault(__webpack_require__(318));
	
	/**
	 * A step shows the completion status of an activity in a series of activities.
	 */
	var Step =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Step, _Component);
	
	  function Step() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Step);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Step)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "computeElementType", function () {
	      var onClick = _this.props.onClick;
	      if (onClick) return 'a';
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (e) {
	      var disabled = _this.props.disabled;
	      if (!disabled) (0, _invoke2["default"])(_this.props, 'onClick', e, _this.props);
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Step, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          active = _this$props.active,
	          children = _this$props.children,
	          className = _this$props.className,
	          completed = _this$props.completed,
	          content = _this$props.content,
	          description = _this$props.description,
	          disabled = _this$props.disabled,
	          href = _this$props.href,
	          icon = _this$props.icon,
	          link = _this$props.link,
	          title = _this$props.title;
	      var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(completed, 'completed'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(link, 'link'), 'step', className);
	      var rest = (0, _lib.getUnhandledProps)(Step, this.props);
	      var ElementType = (0, _lib.getElementType)(Step, this.props, this.computeElementType);
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	          className: classes,
	          href: href,
	          onClick: this.handleClick
	        }), children);
	      }
	
	      if (!_lib.childrenUtils.isNil(content)) {
	        return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	          className: classes,
	          href: href,
	          onClick: this.handleClick
	        }), content);
	      }
	
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes,
	        href: href,
	        onClick: this.handleClick
	      }), _Icon["default"].create(icon, {
	        autoGenerateKey: false
	      }), _StepContent["default"].create({
	        description: description,
	        title: title
	      }, {
	        autoGenerateKey: false
	      }));
	    }
	  }]);
	  return Step;
	}(_react.Component);
	
	(0, _defineProperty2["default"])(Step, "Content", _StepContent["default"]);
	(0, _defineProperty2["default"])(Step, "Description", _StepDescription["default"]);
	(0, _defineProperty2["default"])(Step, "Group", _StepGroup["default"]);
	(0, _defineProperty2["default"])(Step, "Title", _StepTitle["default"]);
	(0, _defineProperty2["default"])(Step, "handledProps", ["active", "as", "children", "className", "completed", "content", "description", "disabled", "href", "icon", "link", "onClick", "ordered", "title"]);
	Step.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A step can be highlighted as active. */
	  active: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** A step can show that a user has completed it. */
	  completed: _propTypes["default"].bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for StepDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** Show that the Loader is inactive. */
	  disabled: _propTypes["default"].bool,
	
	  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
	  href: _propTypes["default"].string,
	
	  /** Shorthand for Icon. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** A step can be link. */
	  link: _propTypes["default"].bool,
	
	  /**
	   * Called on click. When passed, the component will render as an `a`
	   * tag by default instead of a `div`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes["default"].func,
	
	  /** A step can show a ordered sequence of steps. Passed from StepGroup. */
	  ordered: _propTypes["default"].bool,
	
	  /** Shorthand for StepTitle. */
	  title: _lib.customPropTypes.itemShorthand
	} : {};
	Step.create = (0, _lib.createShorthandFactory)(Step, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = Step;
	exports["default"] = _default;

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _StepDescription = _interopRequireDefault(__webpack_require__(317));
	
	var _StepTitle = _interopRequireDefault(__webpack_require__(318));
	
	/**
	 * A step can contain a content.
	 */
	function StepContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      description = props.description,
	      title = props.title;
	  var classes = (0, _classnames["default"])('content', className);
	  var rest = (0, _lib.getUnhandledProps)(StepContent, props);
	  var ElementType = (0, _lib.getElementType)(StepContent, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  if (!_lib.childrenUtils.isNil(content)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), content);
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _StepTitle["default"].create(title, {
	    autoGenerateKey: false
	  }), _StepDescription["default"].create(description, {
	    autoGenerateKey: false
	  }));
	}
	
	StepContent.handledProps = ["as", "children", "className", "content", "description", "title"];
	StepContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for StepDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for StepTitle. */
	  title: _lib.customPropTypes.itemShorthand
	} : {};
	StepContent.create = (0, _lib.createShorthandFactory)(StepContent, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = StepContent;
	exports["default"] = _default;

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(46));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _values2 = _interopRequireDefault(__webpack_require__(153));
	
	var _keys2 = _interopRequireDefault(__webpack_require__(63));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _map2 = _interopRequireDefault(__webpack_require__(41));
	
	var _pickBy2 = _interopRequireDefault(__webpack_require__(6931));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Step = _interopRequireDefault(__webpack_require__(737));
	
	var numberMap =  false ? (0, _pickBy2["default"])(_lib.numberToWordMap, function (val, key) {
	  return key <= 8;
	}) : {};
	/**
	 * A set of steps.
	 */
	
	function StepGroup(props) {
	  var attached = props.attached,
	      children = props.children,
	      className = props.className,
	      content = props.content,
	      fluid = props.fluid,
	      items = props.items,
	      ordered = props.ordered,
	      size = props.size,
	      stackable = props.stackable,
	      unstackable = props.unstackable,
	      vertical = props.vertical,
	      widths = props.widths;
	  var classes = (0, _classnames["default"])('ui', size, (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(ordered, 'ordered'), (0, _lib.useKeyOnly)(unstackable, 'unstackable'), (0, _lib.useKeyOnly)(vertical, 'vertical'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), (0, _lib.useValueAndKey)(stackable, 'stackable'), (0, _lib.useWidthProp)(widths), 'steps', className);
	  var rest = (0, _lib.getUnhandledProps)(StepGroup, props);
	  var ElementType = (0, _lib.getElementType)(StepGroup, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  if (!_lib.childrenUtils.isNil(content)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), content);
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), (0, _map2["default"])(items, function (item) {
	    return _Step["default"].create(item);
	  }));
	}
	
	StepGroup.handledProps = ["as", "attached", "children", "className", "content", "fluid", "items", "ordered", "size", "stackable", "unstackable", "vertical", "widths"];
	StepGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Steps can be attached to other elements. */
	  attached: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['top', 'bottom'])]),
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A fluid step takes up the width of its container. */
	  fluid: _propTypes["default"].bool,
	
	  /** Shorthand array of props for Step. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /** A step can show a ordered sequence of steps. */
	  ordered: _propTypes["default"].bool,
	
	  /** Steps can have different sizes. */
	  size: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.SIZES, 'medium')),
	
	  /** A step can stack vertically only on smaller screens. */
	  stackable: _propTypes["default"].oneOf(['tablet']),
	
	  /** A step can prevent itself from stacking on mobile. */
	  unstackable: _propTypes["default"].bool,
	
	  /** A step can be displayed stacked vertically. */
	  vertical: _propTypes["default"].bool,
	
	  /** Steps can be divided evenly inside their parent. */
	  widths: _propTypes["default"].oneOf([].concat((0, _toConsumableArray2["default"])((0, _keys2["default"])(numberMap)), (0, _toConsumableArray2["default"])((0, _keys2["default"])(numberMap).map(Number)), (0, _toConsumableArray2["default"])((0, _values2["default"])(numberMap))))
	} : {};
	var _default = StepGroup;
	exports["default"] = _default;

/***/ },
/* 740 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createLastItem = exports.createNextItem = exports.createPageFactory = exports.createPrevItem = exports.createFirstPage = exports.createEllipsisItem = void 0;
	
	/**
	 * @param {number} pageNumber
	 * @return {Object}
	 */
	var createEllipsisItem = function createEllipsisItem(pageNumber) {
	  return {
	    active: false,
	    type: 'ellipsisItem',
	    value: pageNumber
	  };
	};
	/**
	 * @return {Object}
	 */
	
	
	exports.createEllipsisItem = createEllipsisItem;
	
	var createFirstPage = function createFirstPage() {
	  return {
	    active: false,
	    type: 'firstItem',
	    value: 1
	  };
	};
	/**
	 * @param {number} activePage
	 * @return {Object}
	 */
	
	
	exports.createFirstPage = createFirstPage;
	
	var createPrevItem = function createPrevItem(activePage) {
	  return {
	    active: false,
	    type: 'prevItem',
	    value: Math.max(1, activePage - 1)
	  };
	};
	/**
	 * @param {number} activePage
	 * @return {function}
	 */
	
	
	exports.createPrevItem = createPrevItem;
	
	var createPageFactory = function createPageFactory(activePage) {
	  return function (pageNumber) {
	    return {
	      active: activePage === pageNumber,
	      type: 'pageItem',
	      value: pageNumber
	    };
	  };
	};
	/**
	 * @param {number} activePage
	 * @param {number} totalPages
	 * @return {Object}
	 */
	
	
	exports.createPageFactory = createPageFactory;
	
	var createNextItem = function createNextItem(activePage, totalPages) {
	  return {
	    active: false,
	    type: 'nextItem',
	    value: Math.min(activePage + 1, totalPages)
	  };
	};
	/**
	 * @param {number} totalPages
	 * @return {Object}
	 */
	
	
	exports.createNextItem = createNextItem;
	
	var createLastItem = function createLastItem(totalPages) {
	  return {
	    active: false,
	    type: 'lastItem',
	    value: totalPages
	  };
	};
	
	exports.createLastItem = createLastItem;

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	// Copy of sindre's leven, wrapped in dead code elimination for production
	// https://github.com/sindresorhus/leven/blob/master/index.js
	
	/* eslint-disable complexity, import/no-mutable-exports, no-multi-assign, no-nested-ternary, no-plusplus */
	var leven = function leven() {
	  return 0;
	};
	
	if (false) {
	  var arr = [];
	  var charCodeCache = [];
	
	  leven = function leven(a, b) {
	    if (a === b) return 0;
	    var aLen = a.length;
	    var bLen = b.length;
	    if (aLen === 0) return bLen;
	    if (bLen === 0) return aLen;
	    var bCharCode;
	    var ret;
	    var tmp;
	    var tmp2;
	    var i = 0;
	    var j = 0;
	
	    while (i < aLen) {
	      charCodeCache[i] = a.charCodeAt(i);
	      arr[i] = ++i;
	    }
	
	    while (j < bLen) {
	      bCharCode = b.charCodeAt(j);
	      tmp = j++;
	      ret = j;
	
	      for (i = 0; i < aLen; i++) {
	        tmp2 = bCharCode === charCodeCache[i] ? tmp : tmp + 1;
	        tmp = arr[i];
	        ret = arr[i] = tmp > ret ? tmp2 > ret ? ret + 1 : tmp2 : tmp2 > tmp ? tmp + 1 : tmp2;
	      }
	    }
	
	    return ret;
	  };
	}
	
	var _default = leven;
	exports["default"] = _default;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(46));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _map2 = _interopRequireDefault(__webpack_require__(41));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _includes2 = _interopRequireDefault(__webpack_require__(88));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(35));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _AccordionPanel = _interopRequireDefault(__webpack_require__(321));
	
	var warnIfPropsAreInvalid = function warnIfPropsAreInvalid(props, state) {
	  var exclusive = props.exclusive;
	  var activeIndex = state.activeIndex;
	  /* eslint-disable no-console */
	
	  if (exclusive && typeof activeIndex !== 'number') {
	    console.error('`activeIndex` must be a number if `exclusive` is true');
	  } else if (!exclusive && !(0, _isArray2["default"])(activeIndex)) {
	    console.error('`activeIndex` must be an array if `exclusive` is false');
	  }
	  /* eslint-enable no-console */
	
	};
	/**
	 * An Accordion can contain sub-accordions.
	 */
	
	
	var AccordionAccordion =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(AccordionAccordion, _Component);
	
	  function AccordionAccordion() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, AccordionAccordion);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(AccordionAccordion)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "computeNewIndex", function (index) {
	      var exclusive = _this.props.exclusive;
	      var activeIndex = _this.state.activeIndex;
	      if (exclusive) return index === activeIndex ? -1 : index; // check to see if index is in array, and remove it, if not then add it
	
	      return (0, _includes2["default"])(activeIndex, index) ? (0, _without2["default"])(activeIndex, index) : [].concat((0, _toConsumableArray2["default"])(activeIndex), [index]);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTitleClick", function (e, titleProps) {
	      var index = titleProps.index;
	
	      _this.trySetState({
	        activeIndex: _this.computeNewIndex(index)
	      });
	
	      (0, _invoke2["default"])(_this.props, 'onTitleClick', e, titleProps);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isIndexActive", function (index) {
	      var exclusive = _this.props.exclusive;
	      var activeIndex = _this.state.activeIndex;
	      return exclusive ? activeIndex === index : (0, _includes2["default"])(activeIndex, index);
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(AccordionAccordion, [{
	    key: "getInitialAutoControlledState",
	    value: function getInitialAutoControlledState(_ref) {
	      var exclusive = _ref.exclusive;
	      return {
	        activeIndex: exclusive ? -1 : []
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (false) {
	        warnIfPropsAreInvalid(this.props, this.state);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (false) {
	        warnIfPropsAreInvalid(this.props, this.state);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          className = _this$props.className,
	          children = _this$props.children,
	          panels = _this$props.panels;
	      var classes = (0, _classnames["default"])('accordion', className);
	      var rest = (0, _lib.getUnhandledProps)(AccordionAccordion, this.props);
	      var ElementType = (0, _lib.getElementType)(AccordionAccordion, this.props);
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes
	      }), _lib.childrenUtils.isNil(children) ? (0, _map2["default"])(panels, function (panel, index) {
	        return _AccordionPanel["default"].create(panel, {
	          defaultProps: {
	            active: _this2.isIndexActive(index),
	            index: index,
	            onTitleClick: _this2.handleTitleClick
	          }
	        });
	      }) : children);
	    }
	  }]);
	  return AccordionAccordion;
	}(_lib.AutoControlledComponent);
	
	exports["default"] = AccordionAccordion;
	(0, _defineProperty2["default"])(AccordionAccordion, "defaultProps", {
	  exclusive: true
	});
	(0, _defineProperty2["default"])(AccordionAccordion, "autoControlledProps", ['activeIndex']);
	(0, _defineProperty2["default"])(AccordionAccordion, "handledProps", ["activeIndex", "as", "children", "className", "defaultActiveIndex", "exclusive", "onTitleClick", "panels"]);
	AccordionAccordion.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Index of the currently active panel. */
	  activeIndex: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].number), _propTypes["default"].number])]),
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Initial activeIndex value. */
	  defaultActiveIndex: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].number), _propTypes["default"].number])]),
	
	  /** Only allow one panel open at a time. */
	  exclusive: _propTypes["default"].bool,
	
	  /**
	   * Called when a panel title is clicked.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All item props.
	   */
	  onTitleClick: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _propTypes["default"].func]),
	
	  /** Shorthand array of props for Accordion. */
	  panels: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    content: _lib.customPropTypes.itemShorthand,
	    title: _lib.customPropTypes.itemShorthand
	  }))])
	} : {};
	AccordionAccordion.create = (0, _lib.createShorthandFactory)(AccordionAccordion, function (content) {
	  return {
	    content: content
	  };
	});

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A dimmable sub-component for Dimmer.
	 */
	function DimmerDimmable(props) {
	  var blurring = props.blurring,
	      className = props.className,
	      children = props.children,
	      content = props.content,
	      dimmed = props.dimmed;
	  var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(blurring, 'blurring'), (0, _lib.useKeyOnly)(dimmed, 'dimmed'), 'dimmable', className);
	  var rest = (0, _lib.getUnhandledProps)(DimmerDimmable, props);
	  var ElementType = (0, _lib.getElementType)(DimmerDimmable, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	DimmerDimmable.handledProps = ["as", "blurring", "children", "className", "content", "dimmed"];
	DimmerDimmable.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A dimmable element can blur its contents. */
	  blurring: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Controls whether or not the dim is displayed. */
	  dimmed: _propTypes["default"].bool
	} : {};
	var _default = DimmerDimmable;
	exports["default"] = _default;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _reactComponentRef = __webpack_require__(52);
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * An inner element for a Dimmer.
	 */
	var DimmerInner =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(DimmerInner, _Component);
	
	  function DimmerInner() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, DimmerInner);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(DimmerInner)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "containerRef", (0, _react.createRef)());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "contentRef", (0, _react.createRef)());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (e) {
	      var contentRef = _this.contentRef.current;
	      (0, _invoke2["default"])(_this.props, 'onClick', e, _this.props);
	
	      if (contentRef && contentRef !== e.target && (0, _lib.doesNodeContainClick)(contentRef, e)) {
	        return;
	      }
	
	      (0, _invoke2["default"])(_this.props, 'onClickOutside', e, _this.props);
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(DimmerInner, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var active = this.props.active;
	      this.toggleStyles(active);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var currentActive = this.props.active;
	      var prevActive = prevProps.active;
	      if (prevActive !== currentActive) this.toggleStyles(currentActive);
	    }
	  }, {
	    key: "toggleStyles",
	    value: function toggleStyles(active) {
	      var containerRef = this.containerRef.current;
	      if (!containerRef || !containerRef.style) return;
	
	      if (active) {
	        containerRef.style.setProperty('display', 'flex', 'important');
	      } else {
	        containerRef.style.removeProperty('display');
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          active = _this$props.active,
	          children = _this$props.children,
	          className = _this$props.className,
	          content = _this$props.content,
	          disabled = _this$props.disabled,
	          inverted = _this$props.inverted,
	          page = _this$props.page,
	          simple = _this$props.simple,
	          verticalAlign = _this$props.verticalAlign;
	      var classes = (0, _classnames["default"])('ui', (0, _lib.useKeyOnly)(active, 'active transition visible'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(page, 'page'), (0, _lib.useKeyOnly)(simple, 'simple'), (0, _lib.useVerticalAlignProp)(verticalAlign), 'dimmer', className);
	      var rest = (0, _lib.getUnhandledProps)(DimmerInner, this.props);
	      var ElementType = (0, _lib.getElementType)(DimmerInner, this.props);
	      var childrenContent = _lib.childrenUtils.isNil(children) ? content : children;
	      return _react["default"].createElement(_reactComponentRef.Ref, {
	        innerRef: this.containerRef
	      }, _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes,
	        onClick: this.handleClick
	      }), childrenContent && _react["default"].createElement("div", {
	        className: "content",
	        ref: this.contentRef
	      }, childrenContent)));
	    }
	  }]);
	  return DimmerInner;
	}(_react.Component);
	
	exports["default"] = DimmerInner;
	(0, _defineProperty2["default"])(DimmerInner, "handledProps", ["active", "as", "children", "className", "content", "disabled", "inverted", "onClick", "onClickOutside", "page", "simple", "verticalAlign"]);
	DimmerInner.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** An active dimmer will dim its parent container. */
	  active: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A disabled dimmer cannot be activated */
	  disabled: _propTypes["default"].bool,
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes["default"].func,
	
	  /**
	   * Handles click outside Dimmer's content, but inside Dimmer area.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClickOutside: _propTypes["default"].func,
	
	  /** A dimmer can be formatted to have its colors inverted. */
	  inverted: _propTypes["default"].bool,
	
	  /** A dimmer can be formatted to be fixed to the page. */
	  page: _propTypes["default"].bool,
	
	  /** A dimmer can be controlled with simple prop. */
	  simple: _propTypes["default"].bool,
	
	  /** A dimmer can have its content top or bottom aligned. */
	  verticalAlign: _propTypes["default"].oneOf(['bottom', 'top'])
	} : {};

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Dimmer["default"];
	  }
	});
	
	var _Dimmer = _interopRequireDefault(__webpack_require__(7291));

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A dropdown menu can contain dividers to separate related content.
	 */
	function DropdownDivider(props) {
	  var className = props.className;
	  var classes = (0, _classnames["default"])('divider', className);
	  var rest = (0, _lib.getUnhandledProps)(DropdownDivider, props);
	  var ElementType = (0, _lib.getElementType)(DropdownDivider, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }));
	}
	
	DropdownDivider.handledProps = ["as", "className"];
	DropdownDivider.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string
	} : {};
	var _default = DropdownDivider;
	exports["default"] = _default;

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Icon = _interopRequireDefault(__webpack_require__(54));
	
	/**
	 * A dropdown menu can contain a header.
	 */
	function DropdownHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      icon = props.icon;
	  var classes = (0, _classnames["default"])('header', className);
	  var rest = (0, _lib.getUnhandledProps)(DropdownHeader, props);
	  var ElementType = (0, _lib.getElementType)(DropdownHeader, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _Icon["default"].create(icon, {
	    autoGenerateKey: false
	  }), content);
	}
	
	DropdownHeader.handledProps = ["as", "children", "className", "content", "icon"];
	DropdownHeader.propTypes =  false ? {
	  /** An element type to render as (string or function) */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for Icon. */
	  icon: _lib.customPropTypes.itemShorthand
	} : {};
	DropdownHeader.create = (0, _lib.createShorthandFactory)(DropdownHeader, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = DropdownHeader;
	exports["default"] = _default;

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(43));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Flag = _interopRequireDefault(__webpack_require__(719));
	
	var _Icon = _interopRequireDefault(__webpack_require__(54));
	
	var _Image = _interopRequireDefault(__webpack_require__(124));
	
	var _Label = _interopRequireDefault(__webpack_require__(159));
	
	/**
	 * An item sub-component for Dropdown component.
	 */
	var DropdownItem =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(DropdownItem, _Component);
	
	  function DropdownItem() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, DropdownItem);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(DropdownItem)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (e) {
	      (0, _invoke2["default"])(_this.props, 'onClick', e, _this.props);
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(DropdownItem, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          active = _this$props.active,
	          children = _this$props.children,
	          className = _this$props.className,
	          content = _this$props.content,
	          disabled = _this$props.disabled,
	          description = _this$props.description,
	          flag = _this$props.flag,
	          icon = _this$props.icon,
	          image = _this$props.image,
	          label = _this$props.label,
	          selected = _this$props.selected,
	          text = _this$props.text;
	      var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(selected, 'selected'), 'item', className); // add default dropdown icon if item contains another menu
	
	      var iconName = (0, _isNil2["default"])(icon) ? _lib.childrenUtils.someByType(children, 'DropdownMenu') && 'dropdown' : icon;
	      var rest = (0, _lib.getUnhandledProps)(DropdownItem, this.props);
	      var ElementType = (0, _lib.getElementType)(DropdownItem, this.props);
	      var ariaOptions = {
	        role: 'option',
	        'aria-disabled': disabled,
	        'aria-checked': active,
	        'aria-selected': selected
	      };
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, ariaOptions, {
	          className: classes,
	          onClick: this.handleClick
	        }), children);
	      }
	
	      var flagElement = _Flag["default"].create(flag, {
	        autoGenerateKey: false
	      });
	
	      var iconElement = _Icon["default"].create(iconName, {
	        autoGenerateKey: false
	      });
	
	      var imageElement = _Image["default"].create(image, {
	        autoGenerateKey: false
	      });
	
	      var labelElement = _Label["default"].create(label, {
	        autoGenerateKey: false
	      });
	
	      var descriptionElement = (0, _lib.createShorthand)('span', function (val) {
	        return {
	          children: val
	        };
	      }, description, {
	        defaultProps: {
	          className: 'description'
	        },
	        autoGenerateKey: false
	      });
	      var textElement = (0, _lib.createShorthand)('span', function (val) {
	        return {
	          children: val
	        };
	      }, _lib.childrenUtils.isNil(content) ? text : content, {
	        defaultProps: {
	          className: 'text'
	        },
	        autoGenerateKey: false
	      });
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, ariaOptions, {
	        className: classes,
	        onClick: this.handleClick
	      }), imageElement, iconElement, flagElement, labelElement, descriptionElement, textElement);
	    }
	  }]);
	  return DropdownItem;
	}(_react.Component);
	
	(0, _defineProperty2["default"])(DropdownItem, "handledProps", ["active", "as", "children", "className", "content", "description", "disabled", "flag", "icon", "image", "label", "onClick", "selected", "text", "value"]);
	DropdownItem.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Style as the currently chosen item. */
	  active: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Additional text with less emphasis. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** A dropdown item can be disabled. */
	  disabled: _propTypes["default"].bool,
	
	  /** Shorthand for Flag. */
	  flag: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for Icon. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for Image. */
	  image: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for Label. */
	  label: _lib.customPropTypes.itemShorthand,
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes["default"].func,
	
	  /**
	   * The item currently selected by keyboard shortcut.
	   * This is not the active item.
	   */
	  selected: _propTypes["default"].bool,
	
	  /** Display text. */
	  text: _lib.customPropTypes.contentShorthand,
	
	  /** Stored value. */
	  value: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].number, _propTypes["default"].string])
	} : {};
	DropdownItem.create = (0, _lib.createShorthandFactory)(DropdownItem, function (opts) {
	  return opts;
	});
	var _default = DropdownItem;
	exports["default"] = _default;

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A dropdown menu can contain a menu.
	 */
	function DropdownMenu(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      direction = props.direction,
	      open = props.open,
	      scrolling = props.scrolling;
	  var classes = (0, _classnames["default"])(direction, (0, _lib.useKeyOnly)(open, 'visible'), (0, _lib.useKeyOnly)(scrolling, 'scrolling'), 'menu transition', className);
	  var rest = (0, _lib.getUnhandledProps)(DropdownMenu, props);
	  var ElementType = (0, _lib.getElementType)(DropdownMenu, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	DropdownMenu.handledProps = ["as", "children", "className", "content", "direction", "open", "scrolling"];
	DropdownMenu.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A dropdown menu can open to the left or to the right. */
	  direction: _propTypes["default"].oneOf(['left', 'right']),
	
	  /** Whether or not the dropdown menu is displayed. */
	  open: _propTypes["default"].bool,
	
	  /** A dropdown menu can scroll. */
	  scrolling: _propTypes["default"].bool
	} : {};
	var _default = DropdownMenu;
	exports["default"] = _default;

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _get2 = _interopRequireDefault(__webpack_require__(72));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A search item sub-component for Dropdown component.
	 */
	var DropdownSearchInput =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(DropdownSearchInput, _Component);
	
	  function DropdownSearchInput() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, DropdownSearchInput);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(DropdownSearchInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleChange", function (e) {
	      var value = (0, _get2["default"])(e, 'target.value');
	      (0, _invoke2["default"])(_this.props, 'onChange', e, (0, _objectSpread2["default"])({}, _this.props, {
	        value: value
	      }));
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(DropdownSearchInput, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          autoComplete = _this$props.autoComplete,
	          className = _this$props.className,
	          tabIndex = _this$props.tabIndex,
	          type = _this$props.type,
	          value = _this$props.value;
	      var classes = (0, _classnames["default"])('search', className);
	      var rest = (0, _lib.getUnhandledProps)(DropdownSearchInput, this.props);
	      return _react["default"].createElement("input", (0, _extends2["default"])({}, rest, {
	        "aria-autocomplete": "list",
	        autoComplete: autoComplete,
	        className: classes,
	        onChange: this.handleChange,
	        tabIndex: tabIndex,
	        type: type,
	        value: value
	      }));
	    }
	  }]);
	  return DropdownSearchInput;
	}(_react.Component);
	
	(0, _defineProperty2["default"])(DropdownSearchInput, "defaultProps", {
	  autoComplete: 'off',
	  type: 'text'
	});
	(0, _defineProperty2["default"])(DropdownSearchInput, "handledProps", ["as", "autoComplete", "className", "tabIndex", "type", "value"]);
	DropdownSearchInput.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** An input can have the auto complete. */
	  autoComplete: _propTypes["default"].string,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** An input can receive focus. */
	  tabIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /** The HTML input type. */
	  type: _propTypes["default"].string,
	
	  /** Stored value. */
	  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	} : {};
	DropdownSearchInput.create = (0, _lib.createShorthandFactory)(DropdownSearchInput, function (type) {
	  return {
	    type: type
	  };
	});
	var _default = DropdownSearchInput;
	exports["default"] = _default;

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _map2 = _interopRequireDefault(__webpack_require__(41));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Button = _interopRequireDefault(__webpack_require__(219));
	
	/**
	 * A modal can contain a row of actions.
	 */
	var ModalActions =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(ModalActions, _Component);
	
	  function ModalActions() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, ModalActions);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(ModalActions)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleButtonOverrides", function (predefinedProps) {
	      return {
	        onClick: function onClick(e, buttonProps) {
	          (0, _invoke2["default"])(predefinedProps, 'onClick', e, buttonProps);
	          (0, _invoke2["default"])(_this.props, 'onActionClick', e, buttonProps);
	        }
	      };
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(ModalActions, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          actions = _this$props.actions,
	          children = _this$props.children,
	          className = _this$props.className,
	          content = _this$props.content;
	      var classes = (0, _classnames["default"])('actions', className);
	      var rest = (0, _lib.getUnhandledProps)(ModalActions, this.props);
	      var ElementType = (0, _lib.getElementType)(ModalActions, this.props);
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	          className: classes
	        }), children);
	      }
	
	      if (!_lib.childrenUtils.isNil(content)) {
	        return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	          className: classes
	        }), content);
	      }
	
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes
	      }), (0, _map2["default"])(actions, function (action) {
	        return _Button["default"].create(action, {
	          overrideProps: _this2.handleButtonOverrides
	        });
	      }));
	    }
	  }]);
	  return ModalActions;
	}(_react.Component);
	
	exports["default"] = ModalActions;
	(0, _defineProperty2["default"])(ModalActions, "handledProps", ["actions", "as", "children", "className", "content", "onActionClick"]);
	ModalActions.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Array of shorthand buttons. */
	  actions: _lib.customPropTypes.collectionShorthand,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /**
	   * Action onClick handler when using shorthand `actions`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props from the clicked action.
	   */
	  onActionClick: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _propTypes["default"].func])
	} : {};
	ModalActions.create = (0, _lib.createShorthandFactory)(ModalActions, function (actions) {
	  return {
	    actions: actions
	  };
	});

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A modal can contain content.
	 */
	function ModalContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      image = props.image,
	      scrolling = props.scrolling;
	  var classes = (0, _classnames["default"])(className, (0, _lib.useKeyOnly)(image, 'image'), (0, _lib.useKeyOnly)(scrolling, 'scrolling'), 'content');
	  var rest = (0, _lib.getUnhandledProps)(ModalContent, props);
	  var ElementType = (0, _lib.getElementType)(ModalContent, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	ModalContent.handledProps = ["as", "children", "className", "content", "image", "scrolling"];
	ModalContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A modal can contain image content. */
	  image: _propTypes["default"].bool,
	
	  /** A modal can use the entire size of the screen. */
	  scrolling: _propTypes["default"].bool
	} : {};
	ModalContent.create = (0, _lib.createShorthandFactory)(ModalContent, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = ModalContent;
	exports["default"] = _default;

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A modal can contain a description with one or more paragraphs.
	 */
	function ModalDescription(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('description', className);
	  var rest = (0, _lib.getUnhandledProps)(ModalDescription, props);
	  var ElementType = (0, _lib.getElementType)(ModalDescription, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	ModalDescription.handledProps = ["as", "children", "className", "content"];
	ModalDescription.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	var _default = ModalDescription;
	exports["default"] = _default;

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A modal can have a header.
	 */
	function ModalHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])(className, 'header');
	  var rest = (0, _lib.getUnhandledProps)(ModalHeader, props);
	  var ElementType = (0, _lib.getElementType)(ModalHeader, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	ModalHeader.handledProps = ["as", "children", "className", "content"];
	ModalHeader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	ModalHeader.create = (0, _lib.createShorthandFactory)(ModalHeader, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = ModalHeader;
	exports["default"] = _default;

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Modal["default"];
	  }
	});
	
	var _Modal = _interopRequireDefault(__webpack_require__(7295));

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = PopupContent;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A PopupContent displays the content body of a Popover.
	 */
	function PopupContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('content', className);
	  var rest = (0, _lib.getUnhandledProps)(PopupContent, props);
	  var ElementType = (0, _lib.getElementType)(PopupContent, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	PopupContent.handledProps = ["as", "children", "className", "content"];
	PopupContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** The content of the Popup */
	  children: _propTypes["default"].node,
	
	  /** Classes to add to the Popup content className. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	PopupContent.create = (0, _lib.createShorthandFactory)(PopupContent, function (children) {
	  return {
	    children: children
	  };
	});

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = PopupHeader;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A PopupHeader displays a header in a Popover.
	 */
	function PopupHeader(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('header', className);
	  var rest = (0, _lib.getUnhandledProps)(PopupHeader, props);
	  var ElementType = (0, _lib.getElementType)(PopupHeader, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	PopupHeader.handledProps = ["as", "children", "className", "content"];
	PopupHeader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	PopupHeader.create = (0, _lib.createShorthandFactory)(PopupHeader, function (children) {
	  return {
	    children: children
	  };
	});

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _keyboardKey = _interopRequireDefault(__webpack_require__(138));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * An internal icon sub-component for Rating component
	 */
	var RatingIcon =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(RatingIcon, _Component);
	
	  function RatingIcon() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, RatingIcon);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(RatingIcon)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (e) {
	      (0, _invoke2["default"])(_this.props, 'onClick', e, _this.props);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleKeyUp", function (e) {
	      (0, _invoke2["default"])(_this.props, 'onKeyUp', e, _this.props);
	
	      switch (_keyboardKey["default"].getCode(e)) {
	        case _keyboardKey["default"].Enter:
	        case _keyboardKey["default"].Spacebar:
	          e.preventDefault();
	          (0, _invoke2["default"])(_this.props, 'onClick', e, _this.props);
	          break;
	
	        default:
	      }
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleMouseEnter", function (e) {
	      (0, _invoke2["default"])(_this.props, 'onMouseEnter', e, _this.props);
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(RatingIcon, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          active = _this$props.active,
	          className = _this$props.className,
	          selected = _this$props.selected;
	      var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(selected, 'selected'), 'icon', className);
	      var rest = (0, _lib.getUnhandledProps)(RatingIcon, this.props);
	      var ElementType = (0, _lib.getElementType)(RatingIcon, this.props);
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes,
	        onClick: this.handleClick,
	        onKeyUp: this.handleKeyUp,
	        onMouseEnter: this.handleMouseEnter,
	        role: "radio"
	      }));
	    }
	  }]);
	  return RatingIcon;
	}(_react.Component);
	
	exports["default"] = RatingIcon;
	(0, _defineProperty2["default"])(RatingIcon, "defaultProps", {
	  as: 'i'
	});
	(0, _defineProperty2["default"])(RatingIcon, "handledProps", ["active", "as", "className", "index", "onClick", "onKeyUp", "onMouseEnter", "selected"]);
	RatingIcon.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Indicates activity of an icon. */
	  active: _propTypes["default"].bool,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** An index of icon inside Rating. */
	  index: _propTypes["default"].number,
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes["default"].func,
	
	  /**
	   * Called on keyup.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onKeyUp: _propTypes["default"].func,
	
	  /**
	   * Called on mouseenter.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onMouseEnter: _propTypes["default"].func,
	
	  /** Indicates selection of an icon. */
	  selected: _propTypes["default"].bool
	} : {};

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	function SearchCategory(props) {
	  var active = props.active,
	      children = props.children,
	      className = props.className,
	      content = props.content,
	      renderer = props.renderer;
	  var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(active, 'active'), 'category', className);
	  var rest = (0, _lib.getUnhandledProps)(SearchCategory, props);
	  var ElementType = (0, _lib.getElementType)(SearchCategory, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _react["default"].createElement("div", {
	    className: "name"
	  }, renderer(props)), _react["default"].createElement("div", {
	    className: "results"
	  }, _lib.childrenUtils.isNil(children) ? content : children));
	}
	
	SearchCategory.handledProps = ["active", "as", "children", "className", "content", "name", "renderer", "results"];
	SearchCategory.defaultProps = {
	  renderer: function renderer(_ref) {
	    var name = _ref.name;
	    return name;
	  }
	};
	SearchCategory.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** The item currently selected by keyboard shortcut. */
	  active: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Display name. */
	  name: _propTypes["default"].string,
	
	  /**
	   * Renders the category contents.
	   *
	   * @param {object} props - The SearchCategory props object.
	   * @returns {*} - Renderable category contents.
	   */
	  renderer: _propTypes["default"].func,
	
	  /** Array of Search.Result props. */
	  results: _propTypes["default"].array
	} : {};
	var _default = SearchCategory;
	exports["default"] = _default;

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	// Note: You technically only need the 'content' wrapper when there's an
	// image. However, optionally wrapping it makes this function a lot more
	// complicated and harder to read. Since always wrapping it doesn't affect
	// the style in any way let's just do that.
	//
	// Note: To avoid requiring a wrapping div, we return an array here so to
	// prevent rendering issues each node needs a unique key.
	var defaultRenderer = function defaultRenderer(_ref) {
	  var image = _ref.image,
	      price = _ref.price,
	      title = _ref.title,
	      description = _ref.description;
	  return [image && _react["default"].createElement("div", {
	    key: "image",
	    className: "image"
	  }, (0, _lib.createHTMLImage)(image, {
	    autoGenerateKey: false
	  })), _react["default"].createElement("div", {
	    key: "content",
	    className: "content"
	  }, price && _react["default"].createElement("div", {
	    className: "price"
	  }, price), title && _react["default"].createElement("div", {
	    className: "title"
	  }, title), description && _react["default"].createElement("div", {
	    className: "description"
	  }, description))];
	};
	
	defaultRenderer.handledProps = [];
	
	var SearchResult =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(SearchResult, _Component);
	
	  function SearchResult() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, SearchResult);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(SearchResult)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (e) {
	      var onClick = _this.props.onClick;
	      if (onClick) onClick(e, _this.props);
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(SearchResult, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          active = _this$props.active,
	          className = _this$props.className,
	          renderer = _this$props.renderer;
	      var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(active, 'active'), 'result', className);
	      var rest = (0, _lib.getUnhandledProps)(SearchResult, this.props);
	      var ElementType = (0, _lib.getElementType)(SearchResult, this.props); // Note: You technically only need the 'content' wrapper when there's an
	      // image. However, optionally wrapping it makes this function a lot more
	      // complicated and harder to read. Since always wrapping it doesn't affect
	      // the style in any way let's just do that.
	
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes,
	        onClick: this.handleClick
	      }), renderer(this.props));
	    }
	  }]);
	  return SearchResult;
	}(_react.Component);
	
	exports["default"] = SearchResult;
	(0, _defineProperty2["default"])(SearchResult, "defaultProps", {
	  renderer: defaultRenderer
	});
	(0, _defineProperty2["default"])(SearchResult, "handledProps", ["active", "as", "className", "content", "description", "id", "image", "onClick", "price", "renderer", "title"]);
	SearchResult.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** The item currently selected by keyboard shortcut. */
	  active: _propTypes["default"].bool,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Additional text with less emphasis. */
	  description: _propTypes["default"].string,
	
	  /** A unique identifier. */
	  id: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /** Add an image to the item. */
	  image: _propTypes["default"].string,
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes["default"].func,
	
	  /** Customized text for price. */
	  price: _propTypes["default"].string,
	
	  /**
	   * Renders the result contents.
	   *
	   * @param {object} props - The SearchResult props object.
	   * @returns {*} - Renderable result contents.
	   */
	  renderer: _propTypes["default"].func,
	
	  /** Display title. */
	  title: _propTypes["default"].string.isRequired
	} : {};

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	function SearchResults(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('results transition', className);
	  var rest = (0, _lib.getUnhandledProps)(SearchResults, props);
	  var ElementType = (0, _lib.getElementType)(SearchResults, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	SearchResults.handledProps = ["as", "children", "className", "content"];
	SearchResults.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	var _default = SearchResults;
	exports["default"] = _default;

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A pushable sub-component for Sidebar.
	 */
	function SidebarPushable(props) {
	  var className = props.className,
	      children = props.children,
	      content = props.content;
	  var classes = (0, _classnames["default"])('pushable', className);
	  var rest = (0, _lib.getUnhandledProps)(SidebarPushable, props);
	  var ElementType = (0, _lib.getElementType)(SidebarPushable, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	SidebarPushable.handledProps = ["as", "children", "className", "content"];
	SidebarPushable.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	var _default = SidebarPushable;
	exports["default"] = _default;

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A pushable sub-component for Sidebar.
	 */
	function SidebarPusher(props) {
	  var className = props.className,
	      dimmed = props.dimmed,
	      children = props.children,
	      content = props.content;
	  var classes = (0, _classnames["default"])('pusher', (0, _lib.useKeyOnly)(dimmed, 'dimmed'), className);
	  var rest = (0, _lib.getUnhandledProps)(SidebarPusher, props);
	  var ElementType = (0, _lib.getElementType)(SidebarPusher, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	SidebarPusher.handledProps = ["as", "children", "className", "content", "dimmed"];
	SidebarPusher.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Controls whether or not the dim is displayed. */
	  dimmed: _propTypes["default"].bool
	} : {};
	var _default = SidebarPusher;
	exports["default"] = _default;

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Segment = _interopRequireDefault(__webpack_require__(734));
	
	/**
	 * A tab pane holds the content of a tab.
	 */
	function TabPane(props) {
	  var active = props.active,
	      children = props.children,
	      className = props.className,
	      content = props.content,
	      loading = props.loading;
	  var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(loading, 'loading'), 'tab', className);
	  var rest = (0, _lib.getUnhandledProps)(TabPane, props);
	  var ElementType = (0, _lib.getElementType)(TabPane, props);
	  var calculatedDefaultProps = {};
	
	  if (ElementType === _Segment["default"]) {
	    calculatedDefaultProps.attached = 'bottom';
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, calculatedDefaultProps, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	TabPane.handledProps = ["active", "as", "children", "className", "content", "loading"];
	TabPane.defaultProps = {
	  as: _Segment["default"],
	  active: true
	};
	TabPane.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A tab pane can be active. */
	  active: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A Tab.Pane can display a loading indicator. */
	  loading: _propTypes["default"].bool
	} : {};
	TabPane.create = (0, _lib.createShorthandFactory)(TabPane, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = TabPane;
	exports["default"] = _default;

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _includes2 = _interopRequireDefault(__webpack_require__(88));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(43));
	
	var _get2 = _interopRequireDefault(__webpack_require__(72));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = __webpack_require__(2);
	
	var _lib = __webpack_require__(12);
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(766));
	
	var TRANSITION_TYPE = {
	  ENTERING: 'show',
	  EXITING: 'hide'
	  /**
	   * A transition is an animation usually used to move content in or out of view.
	   */
	
	};
	
	var Transition =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Transition, _Component);
	
	  function Transition() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Transition);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Transition)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleStart", function () {
	      var duration = _this.props.duration;
	      var status = _this.nextStatus;
	      _this.nextStatus = null;
	
	      _this.setState({
	        status: status,
	        animating: true
	      }, function () {
	        var durationType = TRANSITION_TYPE[status];
	        var durationValue = (0, _lib.normalizeTransitionDuration)(duration, durationType);
	        (0, _invoke2["default"])(_this.props, 'onStart', null, (0, _objectSpread2["default"])({}, _this.props, {
	          status: status
	        }));
	        _this.timeoutId = setTimeout(_this.handleComplete, durationValue);
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleComplete", function () {
	      var current = _this.state.status;
	      (0, _invoke2["default"])(_this.props, 'onComplete', null, (0, _objectSpread2["default"])({}, _this.props, {
	        status: current
	      }));
	
	      if (_this.nextStatus) {
	        _this.handleStart();
	
	        return;
	      }
	
	      var status = _this.computeCompletedStatus();
	
	      var callback = current === Transition.ENTERING ? 'onShow' : 'onHide';
	
	      _this.setState({
	        status: status,
	        animating: false
	      }, function () {
	        (0, _invoke2["default"])(_this.props, callback, null, (0, _objectSpread2["default"])({}, _this.props, {
	          status: status
	        }));
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateStatus", function () {
	      var animating = _this.state.animating;
	
	      if (_this.nextStatus) {
	        _this.nextStatus = _this.computeNextStatus();
	        if (!animating) _this.handleStart();
	      }
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "computeClasses", function () {
	      var _this$props = _this.props,
	          animation = _this$props.animation,
	          directional = _this$props.directional,
	          children = _this$props.children;
	      var _this$state = _this.state,
	          animating = _this$state.animating,
	          status = _this$state.status;
	      var childClasses = (0, _get2["default"])(children, 'props.className');
	      var isDirectional = (0, _isNil2["default"])(directional) ? (0, _includes2["default"])(_lib.SUI.DIRECTIONAL_TRANSITIONS, animation) : directional;
	
	      if (isDirectional) {
	        return (0, _classnames["default"])(animation, childClasses, (0, _lib.useKeyOnly)(animating, 'animating'), (0, _lib.useKeyOnly)(status === Transition.ENTERING, 'in'), (0, _lib.useKeyOnly)(status === Transition.EXITING, 'out'), (0, _lib.useKeyOnly)(status === Transition.EXITED, 'hidden'), (0, _lib.useKeyOnly)(status !== Transition.EXITED, 'visible'), 'transition');
	      }
	
	      return (0, _classnames["default"])(animation, childClasses, (0, _lib.useKeyOnly)(animating, 'animating transition'));
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "computeCompletedStatus", function () {
	      var unmountOnHide = _this.props.unmountOnHide;
	      var status = _this.state.status;
	      if (status === Transition.ENTERING) return Transition.ENTERED;
	      return unmountOnHide ? Transition.UNMOUNTED : Transition.EXITED;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "computeInitialStatuses", function () {
	      var _this$props2 = _this.props,
	          visible = _this$props2.visible,
	          mountOnShow = _this$props2.mountOnShow,
	          transitionOnMount = _this$props2.transitionOnMount,
	          unmountOnHide = _this$props2.unmountOnHide;
	
	      if (visible) {
	        if (transitionOnMount) {
	          return {
	            initial: Transition.EXITED,
	            next: Transition.ENTERING
	          };
	        }
	
	        return {
	          initial: Transition.ENTERED
	        };
	      }
	
	      if (mountOnShow || unmountOnHide) return {
	        initial: Transition.UNMOUNTED
	      };
	      return {
	        initial: Transition.EXITED
	      };
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "computeNextStatus", function () {
	      var _this$state2 = _this.state,
	          animating = _this$state2.animating,
	          status = _this$state2.status;
	      if (animating) return status === Transition.ENTERING ? Transition.EXITING : Transition.ENTERING;
	      return status === Transition.ENTERED ? Transition.EXITING : Transition.ENTERING;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "computeStatuses", function (props) {
	      var status = _this.state.status;
	      var visible = props.visible;
	
	      if (visible) {
	        return {
	          current: status === Transition.UNMOUNTED && Transition.EXITED,
	          next: status !== Transition.ENTERING && status !== Transition.ENTERED && Transition.ENTERING
	        };
	      }
	
	      return {
	        next: (status === Transition.ENTERING || status === Transition.ENTERED) && Transition.EXITING
	      };
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "computeStyle", function () {
	      var _this$props3 = _this.props,
	          children = _this$props3.children,
	          duration = _this$props3.duration;
	      var status = _this.state.status;
	      var childStyle = (0, _get2["default"])(children, 'props.style');
	      var type = TRANSITION_TYPE[status];
	      var animationDuration = type && "".concat((0, _lib.normalizeTransitionDuration)(duration, type), "ms");
	      return (0, _objectSpread2["default"])({}, childStyle, {
	        animationDuration: animationDuration
	      });
	    });
	
	    var _this$computeInitialS = _this.computeInitialStatuses(),
	        _status = _this$computeInitialS.initial,
	        next = _this$computeInitialS.next;
	
	    _this.nextStatus = next;
	    _this.state = {
	      status: _status
	    };
	    return _this;
	  } // ----------------------------------------
	  // Lifecycle
	  // ----------------------------------------
	
	
	  (0, _createClass2["default"])(Transition, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateStatus();
	    } // eslint-disable-next-line camelcase
	
	  }, {
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      var _this$computeStatuses = this.computeStatuses(nextProps),
	          status = _this$computeStatuses.current,
	          next = _this$computeStatuses.next;
	
	      this.nextStatus = next;
	      if (status) this.setState({
	        status: status
	      });
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.updateStatus();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeoutId);
	    } // ----------------------------------------
	    // Callback handling
	    // ----------------------------------------
	
	  }, {
	    key: "render",
	    // ----------------------------------------
	    // Render
	    // ----------------------------------------
	    value: function render() {
	      var children = this.props.children;
	      var status = this.state.status;
	      if (status === Transition.UNMOUNTED) return null;
	      return (0, _react.cloneElement)(children, {
	        className: this.computeClasses(),
	        style: this.computeStyle()
	      });
	    }
	  }]);
	  return Transition;
	}(_react.Component);
	
	exports["default"] = Transition;
	(0, _defineProperty2["default"])(Transition, "defaultProps", {
	  animation: 'fade',
	  duration: 500,
	  visible: true,
	  mountOnShow: true,
	  transitionOnMount: false,
	  unmountOnHide: false
	});
	(0, _defineProperty2["default"])(Transition, "ENTERED", 'ENTERED');
	(0, _defineProperty2["default"])(Transition, "ENTERING", 'ENTERING');
	(0, _defineProperty2["default"])(Transition, "EXITED", 'EXITED');
	(0, _defineProperty2["default"])(Transition, "EXITING", 'EXITING');
	(0, _defineProperty2["default"])(Transition, "UNMOUNTED", 'UNMOUNTED');
	(0, _defineProperty2["default"])(Transition, "Group", _TransitionGroup["default"]);
	(0, _defineProperty2["default"])(Transition, "handledProps", ["animation", "children", "directional", "duration", "mountOnShow", "onComplete", "onHide", "onShow", "onStart", "reactKey", "transitionOnMount", "unmountOnHide", "visible"]);
	Transition.propTypes =  false ? {
	  /** Named animation event to used. Must be defined in CSS. */
	  animation: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(_lib.SUI.TRANSITIONS), _propTypes["default"].string]),
	
	  /** Primary content. */
	  children: _propTypes["default"].element.isRequired,
	
	  /** Whether it is directional animation event or not. Use it only for custom transitions. */
	  directional: _propTypes["default"].bool,
	
	  /** Duration of the CSS transition animation in milliseconds. */
	  duration: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].shape({
	    hide: _propTypes["default"].number,
	    show: _propTypes["default"].number
	  }), _propTypes["default"].string]),
	
	  /** Show the component; triggers the enter or exit animation. */
	  visible: _propTypes["default"].bool,
	
	  /** Wait until the first "enter" transition to mount the component (add it to the DOM). */
	  mountOnShow: _propTypes["default"].bool,
	
	  /**
	   * Callback on each transition that changes visibility to shown.
	   *
	   * @param {null}
	   * @param {object} data - All props with status.
	   */
	  onComplete: _propTypes["default"].func,
	
	  /**
	   * Callback on each transition that changes visibility to hidden.
	   *
	   * @param {null}
	   * @param {object} data - All props with status.
	   */
	  onHide: _propTypes["default"].func,
	
	  /**
	   * Callback on each transition that changes visibility to shown.
	   *
	   * @param {null}
	   * @param {object} data - All props with status.
	   */
	  onShow: _propTypes["default"].func,
	
	  /**
	   * Callback on animation start.
	   *
	   * @param {null}
	   * @param {object} data - All props with status.
	   */
	  onStart: _propTypes["default"].func,
	
	  /** React's key of the element. */
	  reactKey: _propTypes["default"].string,
	
	  /** Run the enter animation when the component mounts, if it is initially shown. */
	  transitionOnMount: _propTypes["default"].bool,
	
	  /** Unmount the component (remove it from the DOM) when it is not shown. */
	  unmountOnHide: _propTypes["default"].bool
	} : {};

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _values2 = _interopRequireDefault(__webpack_require__(153));
	
	var _get2 = _interopRequireDefault(__webpack_require__(72));
	
	var _has2 = _interopRequireDefault(__webpack_require__(119));
	
	var _forEach2 = _interopRequireDefault(__webpack_require__(118));
	
	var _mapValues2 = _interopRequireDefault(__webpack_require__(6927));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Transition = _interopRequireDefault(__webpack_require__(765));
	
	/**
	 * A Transition.Group animates children as they mount and unmount.
	 */
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2["default"])(TransitionGroup, _React$Component);
	
	  function TransitionGroup() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, TransitionGroup);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(TransitionGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleOnHide", function (nothing, childProps) {
	      var reactKey = childProps.reactKey;
	
	      _this.setState(function (state) {
	        var children = (0, _objectSpread2["default"])({}, state.children);
	        delete children[reactKey];
	        return {
	          children: children
	        };
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "wrapChild", function (child) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var _this$props = _this.props,
	          animation = _this$props.animation,
	          directional = _this$props.directional,
	          duration = _this$props.duration;
	      var key = child.key;
	      var _options$visible = options.visible,
	          visible = _options$visible === void 0 ? true : _options$visible,
	          _options$transitionOn = options.transitionOnMount,
	          transitionOnMount = _options$transitionOn === void 0 ? false : _options$transitionOn;
	      return _react["default"].createElement(_Transition["default"], {
	        animation: animation,
	        directional: directional,
	        duration: duration,
	        key: key,
	        onHide: _this.handleOnHide,
	        reactKey: key,
	        transitionOnMount: transitionOnMount,
	        visible: visible
	      }, child);
	    });
	    var _children = _this.props.children;
	    _this.state = {
	      children: (0, _mapValues2["default"])((0, _lib.getChildMapping)(_children), function (child) {
	        return _this.wrapChild(child);
	      })
	    };
	    return _this;
	  } // eslint-disable-next-line camelcase
	
	
	  (0, _createClass2["default"])(TransitionGroup, [{
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var prevMapping = this.state.children;
	      var nextMapping = (0, _lib.getChildMapping)(nextProps.children);
	      var children = (0, _lib.mergeChildMappings)(prevMapping, nextMapping);
	      (0, _forEach2["default"])(children, function (child, key) {
	        var hasPrev = (0, _has2["default"])(prevMapping, key);
	        var hasNext = (0, _has2["default"])(nextMapping, key);
	        var prevChild = prevMapping[key];
	        var isLeaving = !(0, _get2["default"])(prevChild, 'props.visible'); // Heads up!
	        // An item is new (entering), it will be picked from `nextChildren`, so it should be wrapped
	
	        if (hasNext && (!hasPrev || isLeaving)) {
	          children[key] = _this2.wrapChild(child, {
	            transitionOnMount: true
	          });
	          return;
	        } // Heads up!
	        // An item is old (exiting), it will be picked from `prevChildren`, so it has been already
	        // wrapped, so should be only updated
	
	
	        if (!hasNext && hasPrev && !isLeaving) {
	          children[key] = (0, _react.cloneElement)(prevChild, {
	            visible: false
	          });
	          return;
	        } // Heads up!
	        // An item item hasn't changed transition states, but it will be picked from `nextChildren`,
	        // so we should wrap it again
	
	
	        var _prevChild$props = prevChild.props,
	            visible = _prevChild$props.visible,
	            transitionOnMount = _prevChild$props.transitionOnMount;
	        children[key] = _this2.wrapChild(child, {
	          transitionOnMount: transitionOnMount,
	          visible: visible
	        });
	      });
	      this.setState({
	        children: children
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var children = this.state.children;
	      var ElementType = (0, _lib.getElementType)(TransitionGroup, this.props);
	      var rest = (0, _lib.getUnhandledProps)(TransitionGroup, this.props);
	      return _react["default"].createElement(ElementType, rest, (0, _values2["default"])(children));
	    }
	  }]);
	  return TransitionGroup;
	}(_react["default"].Component);
	
	exports["default"] = TransitionGroup;
	(0, _defineProperty2["default"])(TransitionGroup, "defaultProps", {
	  as: _react.Fragment,
	  animation: 'fade',
	  duration: 500
	});
	(0, _defineProperty2["default"])(TransitionGroup, "handledProps", ["animation", "as", "children", "directional", "duration"]);
	TransitionGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Named animation event to used. Must be defined in CSS. */
	  animation: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(_lib.SUI.TRANSITIONS), _propTypes["default"].string]),
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Whether it is directional animation event or not. Use it only for custom transitions. */
	  directional: _propTypes["default"].bool,
	
	  /** Duration of the CSS transition animation in milliseconds. */
	  duration: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].shape({
	    hide: _propTypes["default"].number.isRequired,
	    show: _propTypes["default"].number.isRequired
	  }), _propTypes["default"].string])
	} : {};

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Transition["default"];
	  }
	});
	
	var _Transition = _interopRequireDefault(__webpack_require__(765));

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Image = _interopRequireDefault(__webpack_require__(124));
	
	var _CardContent = _interopRequireDefault(__webpack_require__(769));
	
	var _CardDescription = _interopRequireDefault(__webpack_require__(323));
	
	var _CardGroup = _interopRequireDefault(__webpack_require__(770));
	
	var _CardHeader = _interopRequireDefault(__webpack_require__(324));
	
	var _CardMeta = _interopRequireDefault(__webpack_require__(325));
	
	/**
	 * A card displays site content in a manner similar to a playing card.
	 */
	var Card =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Card, _Component);
	
	  function Card() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Card);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Card)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (e) {
	      var onClick = _this.props.onClick;
	      if (onClick) onClick(e, _this.props);
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Card, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          centered = _this$props.centered,
	          children = _this$props.children,
	          className = _this$props.className,
	          color = _this$props.color,
	          content = _this$props.content,
	          description = _this$props.description,
	          extra = _this$props.extra,
	          fluid = _this$props.fluid,
	          header = _this$props.header,
	          href = _this$props.href,
	          image = _this$props.image,
	          link = _this$props.link,
	          meta = _this$props.meta,
	          onClick = _this$props.onClick,
	          raised = _this$props.raised;
	      var classes = (0, _classnames["default"])('ui', color, (0, _lib.useKeyOnly)(centered, 'centered'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(link, 'link'), (0, _lib.useKeyOnly)(raised, 'raised'), 'card', className);
	      var rest = (0, _lib.getUnhandledProps)(Card, this.props);
	      var ElementType = (0, _lib.getElementType)(Card, this.props, function () {
	        if (onClick) return 'a';
	      });
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	          className: classes,
	          href: href,
	          onClick: this.handleClick
	        }), children);
	      }
	
	      if (!_lib.childrenUtils.isNil(content)) {
	        return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	          className: classes,
	          href: href,
	          onClick: this.handleClick
	        }), content);
	      }
	
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes,
	        href: href,
	        onClick: this.handleClick
	      }), _Image["default"].create(image, {
	        autoGenerateKey: false,
	        defaultProps: {
	          ui: false,
	          wrapped: true
	        }
	      }), (description || header || meta) && _react["default"].createElement(_CardContent["default"], {
	        description: description,
	        header: header,
	        meta: meta
	      }), extra && _react["default"].createElement(_CardContent["default"], {
	        extra: true
	      }, extra));
	    }
	  }]);
	  return Card;
	}(_react.Component);
	
	exports["default"] = Card;
	(0, _defineProperty2["default"])(Card, "Content", _CardContent["default"]);
	(0, _defineProperty2["default"])(Card, "Description", _CardDescription["default"]);
	(0, _defineProperty2["default"])(Card, "Group", _CardGroup["default"]);
	(0, _defineProperty2["default"])(Card, "Header", _CardHeader["default"]);
	(0, _defineProperty2["default"])(Card, "Meta", _CardMeta["default"]);
	(0, _defineProperty2["default"])(Card, "handledProps", ["as", "centered", "children", "className", "color", "content", "description", "extra", "fluid", "header", "href", "image", "link", "meta", "onClick", "raised"]);
	Card.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A Card can center itself inside its container. */
	  centered: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** A Card can be formatted to display different colors. */
	  color: _propTypes["default"].oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for CardDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for primary content of CardContent. */
	  extra: _lib.customPropTypes.contentShorthand,
	
	  /** A Card can be formatted to take up the width of its container. */
	  fluid: _propTypes["default"].bool,
	
	  /** Shorthand for CardHeader. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
	  href: _propTypes["default"].string,
	
	  /** A card can contain an Image component. */
	  image: _lib.customPropTypes.itemShorthand,
	
	  /** A card can be formatted to link to other content. */
	  link: _propTypes["default"].bool,
	
	  /** Shorthand for CardMeta. */
	  meta: _lib.customPropTypes.itemShorthand,
	
	  /**
	   * Called on click. When passed, the component renders as an `a`
	   * tag by default instead of a `div`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes["default"].func,
	
	  /** A Card can be formatted to raise above the page. */
	  raised: _propTypes["default"].bool
	} : {};

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _CardDescription = _interopRequireDefault(__webpack_require__(323));
	
	var _CardHeader = _interopRequireDefault(__webpack_require__(324));
	
	var _CardMeta = _interopRequireDefault(__webpack_require__(325));
	
	/**
	 * A card can contain blocks of content or extra content meant to be formatted separately from the main content.
	 */
	function CardContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      description = props.description,
	      extra = props.extra,
	      header = props.header,
	      meta = props.meta,
	      textAlign = props.textAlign;
	  var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(extra, 'extra'), (0, _lib.useTextAlignProp)(textAlign), 'content', className);
	  var rest = (0, _lib.getUnhandledProps)(CardContent, props);
	  var ElementType = (0, _lib.getElementType)(CardContent, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  if (!_lib.childrenUtils.isNil(content)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), content);
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), (0, _lib.createShorthand)(_CardHeader["default"], function (val) {
	    return {
	      content: val
	    };
	  }, header, {
	    autoGenerateKey: false
	  }), (0, _lib.createShorthand)(_CardMeta["default"], function (val) {
	    return {
	      content: val
	    };
	  }, meta, {
	    autoGenerateKey: false
	  }), (0, _lib.createShorthand)(_CardDescription["default"], function (val) {
	    return {
	      content: val
	    };
	  }, description, {
	    autoGenerateKey: false
	  }));
	}
	
	CardContent.handledProps = ["as", "children", "className", "content", "description", "extra", "header", "meta", "textAlign"];
	CardContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for CardDescription. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** A card can contain extra content meant to be formatted separately from the main content. */
	  extra: _propTypes["default"].bool,
	
	  /** Shorthand for CardHeader. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for CardMeta. */
	  meta: _lib.customPropTypes.itemShorthand,
	
	  /** A card content can adjust its text alignment. */
	  textAlign: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.TEXT_ALIGNMENTS, 'justified'))
	} : {};
	var _default = CardContent;
	exports["default"] = _default;

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _map2 = _interopRequireDefault(__webpack_require__(41));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Card = _interopRequireDefault(__webpack_require__(768));
	
	/**
	 * A group of cards.
	 */
	function CardGroup(props) {
	  var centered = props.centered,
	      children = props.children,
	      className = props.className,
	      content = props.content,
	      doubling = props.doubling,
	      items = props.items,
	      itemsPerRow = props.itemsPerRow,
	      stackable = props.stackable,
	      textAlign = props.textAlign;
	  var classes = (0, _classnames["default"])('ui', (0, _lib.useKeyOnly)(centered, 'centered'), (0, _lib.useKeyOnly)(doubling, 'doubling'), (0, _lib.useKeyOnly)(stackable, 'stackable'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useWidthProp)(itemsPerRow), 'cards', className);
	  var rest = (0, _lib.getUnhandledProps)(CardGroup, props);
	  var ElementType = (0, _lib.getElementType)(CardGroup, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  if (!_lib.childrenUtils.isNil(content)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), content);
	  }
	
	  var itemsJSX = (0, _map2["default"])(items, function (item) {
	    var key = item.key || [item.header, item.description].join('-');
	    return _react["default"].createElement(_Card["default"], (0, _extends2["default"])({
	      key: key
	    }, item));
	  });
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), itemsJSX);
	}
	
	CardGroup.handledProps = ["as", "centered", "children", "className", "content", "doubling", "items", "itemsPerRow", "stackable", "textAlign"];
	CardGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A group of cards can center itself inside its container. */
	  centered: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A group of cards can double its column width for mobile. */
	  doubling: _propTypes["default"].bool,
	
	  /** Shorthand array of props for Card. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /** A group of cards can set how many cards should exist in a row. */
	  itemsPerRow: _propTypes["default"].oneOf(_lib.SUI.WIDTHS),
	
	  /** A group of cards can automatically stack rows to a single columns on mobile devices. */
	  stackable: _propTypes["default"].bool,
	
	  /** A card group can adjust its text alignment. */
	  textAlign: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.TEXT_ALIGNMENTS, 'justified'))
	} : {};
	var _default = CardGroup;
	exports["default"] = _default;

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A comment can contain an action.
	 */
	function CommentAction(props) {
	  var active = props.active,
	      className = props.className,
	      children = props.children,
	      content = props.content;
	  var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(active, 'active'), className);
	  var rest = (0, _lib.getUnhandledProps)(CommentAction, props);
	  var ElementType = (0, _lib.getElementType)(CommentAction, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	CommentAction.handledProps = ["active", "as", "children", "className", "content"];
	CommentAction.defaultProps = {
	  as: 'a'
	};
	CommentAction.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Style as the currently active action. */
	  active: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	var _default = CommentAction;
	exports["default"] = _default;

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A comment can contain an list of actions a user may perform related to this comment.
	 */
	function CommentActions(props) {
	  var className = props.className,
	      children = props.children,
	      content = props.content;
	  var classes = (0, _classnames["default"])('actions', className);
	  var rest = (0, _lib.getUnhandledProps)(CommentActions, props);
	  var ElementType = (0, _lib.getElementType)(CommentActions, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	CommentActions.handledProps = ["as", "children", "className", "content"];
	CommentActions.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	var _default = CommentActions;
	exports["default"] = _default;

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A comment can contain an author.
	 */
	function CommentAuthor(props) {
	  var className = props.className,
	      children = props.children,
	      content = props.content;
	  var classes = (0, _classnames["default"])('author', className);
	  var rest = (0, _lib.getUnhandledProps)(CommentAuthor, props);
	  var ElementType = (0, _lib.getElementType)(CommentAuthor, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	CommentAuthor.handledProps = ["as", "children", "className", "content"];
	CommentAuthor.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	var _default = CommentAuthor;
	exports["default"] = _default;

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A comment can contain an image or avatar.
	 */
	function CommentAvatar(props) {
	  var className = props.className,
	      src = props.src;
	  var classes = (0, _classnames["default"])('avatar', className);
	  var rest = (0, _lib.getUnhandledProps)(CommentAvatar, props);
	
	  var _partitionHTMLProps = (0, _lib.partitionHTMLProps)(rest, {
	    htmlProps: _lib.htmlImageProps
	  }),
	      _partitionHTMLProps2 = (0, _slicedToArray2["default"])(_partitionHTMLProps, 2),
	      imageProps = _partitionHTMLProps2[0],
	      rootProps = _partitionHTMLProps2[1];
	
	  var ElementType = (0, _lib.getElementType)(CommentAvatar, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rootProps, {
	    className: classes
	  }), (0, _lib.createHTMLImage)(src, {
	    autoGenerateKey: false,
	    defaultProps: imageProps
	  }));
	}
	
	CommentAvatar.handledProps = ["as", "className", "src"];
	CommentAvatar.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Specifies the URL of the image. */
	  src: _propTypes["default"].string
	} : {};
	var _default = CommentAvatar;
	exports["default"] = _default;

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A comment can contain content.
	 */
	function CommentContent(props) {
	  var className = props.className,
	      children = props.children,
	      content = props.content;
	  var classes = (0, _classnames["default"])(className, 'content');
	  var rest = (0, _lib.getUnhandledProps)(CommentContent, props);
	  var ElementType = (0, _lib.getElementType)(CommentContent, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	CommentContent.handledProps = ["as", "children", "className", "content"];
	CommentContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	var _default = CommentContent;
	exports["default"] = _default;

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * Comments can be grouped.
	 */
	function CommentGroup(props) {
	  var className = props.className,
	      children = props.children,
	      collapsed = props.collapsed,
	      content = props.content,
	      minimal = props.minimal,
	      size = props.size,
	      threaded = props.threaded;
	  var classes = (0, _classnames["default"])('ui', size, (0, _lib.useKeyOnly)(collapsed, 'collapsed'), (0, _lib.useKeyOnly)(minimal, 'minimal'), (0, _lib.useKeyOnly)(threaded, 'threaded'), 'comments', className);
	  var rest = (0, _lib.getUnhandledProps)(CommentGroup, props);
	  var ElementType = (0, _lib.getElementType)(CommentGroup, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	CommentGroup.handledProps = ["as", "children", "className", "collapsed", "content", "minimal", "size", "threaded"];
	CommentGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Comments can be collapsed, or hidden from view. */
	  collapsed: _propTypes["default"].bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Comments can hide extra information unless a user shows intent to interact with a comment. */
	  minimal: _propTypes["default"].bool,
	
	  /** Comments can have different sizes. */
	  size: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.SIZES, 'medium')),
	
	  /** A comment list can be threaded to showing the relationship between conversations. */
	  threaded: _propTypes["default"].bool
	} : {};
	var _default = CommentGroup;
	exports["default"] = _default;

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A comment can contain metadata about the comment, an arbitrary amount of metadata may be defined.
	 */
	function CommentMetadata(props) {
	  var className = props.className,
	      children = props.children,
	      content = props.content;
	  var classes = (0, _classnames["default"])('metadata', className);
	  var rest = (0, _lib.getUnhandledProps)(CommentMetadata, props);
	  var ElementType = (0, _lib.getElementType)(CommentMetadata, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	CommentMetadata.handledProps = ["as", "children", "className", "content"];
	CommentMetadata.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	var _default = CommentMetadata;
	exports["default"] = _default;

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A comment can contain text.
	 */
	function CommentText(props) {
	  var className = props.className,
	      children = props.children,
	      content = props.content;
	  var classes = (0, _classnames["default"])(className, 'text');
	  var rest = (0, _lib.getUnhandledProps)(CommentText, props);
	  var ElementType = (0, _lib.getElementType)(CommentText, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	CommentText.handledProps = ["as", "children", "className", "content"];
	CommentText.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	var _default = CommentText;
	exports["default"] = _default;

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _FeedContent = _interopRequireDefault(__webpack_require__(326));
	
	var _FeedLabel = _interopRequireDefault(__webpack_require__(328));
	
	/**
	 * A feed contains an event.
	 */
	function FeedEvent(props) {
	  var content = props.content,
	      children = props.children,
	      className = props.className,
	      date = props.date,
	      extraImages = props.extraImages,
	      extraText = props.extraText,
	      image = props.image,
	      icon = props.icon,
	      meta = props.meta,
	      summary = props.summary;
	  var classes = (0, _classnames["default"])('event', className);
	  var rest = (0, _lib.getUnhandledProps)(FeedEvent, props);
	  var ElementType = (0, _lib.getElementType)(FeedEvent, props);
	  var hasContentProp = content || date || extraImages || extraText || meta || summary;
	  var contentProps = {
	    content: content,
	    date: date,
	    extraImages: extraImages,
	    extraText: extraText,
	    meta: meta,
	    summary: summary
	  };
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), (0, _lib.createShorthand)(_FeedLabel["default"], function (val) {
	    return {
	      icon: val
	    };
	  }, icon, {
	    autoGenerateKey: false
	  }), (0, _lib.createShorthand)(_FeedLabel["default"], function (val) {
	    return {
	      image: val
	    };
	  }, image, {
	    autoGenerateKey: false
	  }), hasContentProp && _react["default"].createElement(_FeedContent["default"], contentProps), children);
	}
	
	FeedEvent.handledProps = ["as", "children", "className", "content", "date", "extraImages", "extraText", "icon", "image", "meta", "summary"];
	FeedEvent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for FeedContent. */
	  content: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedDate. */
	  date: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedExtra with images. */
	  extraImages: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedExtra with content. */
	  extraText: _lib.customPropTypes.itemShorthand,
	
	  /** An event can contain icon label. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** An event can contain image label. */
	  image: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedMeta. */
	  meta: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for FeedSummary. */
	  summary: _lib.customPropTypes.itemShorthand
	} : {};
	var _default = FeedEvent;
	exports["default"] = _default;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _ItemContent = _interopRequireDefault(__webpack_require__(781));
	
	var _ItemDescription = _interopRequireDefault(__webpack_require__(333));
	
	var _ItemExtra = _interopRequireDefault(__webpack_require__(334));
	
	var _ItemGroup = _interopRequireDefault(__webpack_require__(782));
	
	var _ItemHeader = _interopRequireDefault(__webpack_require__(335));
	
	var _ItemImage = _interopRequireDefault(__webpack_require__(783));
	
	var _ItemMeta = _interopRequireDefault(__webpack_require__(336));
	
	/**
	 * An item view presents large collections of site content for display.
	 */
	function Item(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      description = props.description,
	      extra = props.extra,
	      header = props.header,
	      image = props.image,
	      meta = props.meta;
	  var classes = (0, _classnames["default"])('item', className);
	  var rest = (0, _lib.getUnhandledProps)(Item, props);
	  var ElementType = (0, _lib.getElementType)(Item, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _ItemImage["default"].create(image, {
	    autoGenerateKey: false
	  }), _react["default"].createElement(_ItemContent["default"], {
	    content: content,
	    description: description,
	    extra: extra,
	    header: header,
	    meta: meta
	  }));
	}
	
	Item.handledProps = ["as", "children", "className", "content", "description", "extra", "header", "image", "meta"];
	Item.Content = _ItemContent["default"];
	Item.Description = _ItemDescription["default"];
	Item.Extra = _ItemExtra["default"];
	Item.Group = _ItemGroup["default"];
	Item.Header = _ItemHeader["default"];
	Item.Image = _ItemImage["default"];
	Item.Meta = _ItemMeta["default"];
	Item.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for ItemContent component. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for ItemDescription component. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemExtra component. */
	  extra: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemHeader component. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemImage component. */
	  image: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemMeta component. */
	  meta: _lib.customPropTypes.itemShorthand
	} : {};
	var _default = Item;
	exports["default"] = _default;

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _ItemHeader = _interopRequireDefault(__webpack_require__(335));
	
	var _ItemDescription = _interopRequireDefault(__webpack_require__(333));
	
	var _ItemExtra = _interopRequireDefault(__webpack_require__(334));
	
	var _ItemMeta = _interopRequireDefault(__webpack_require__(336));
	
	/**
	 * An item can contain content.
	 */
	function ItemContent(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      description = props.description,
	      extra = props.extra,
	      header = props.header,
	      meta = props.meta,
	      verticalAlign = props.verticalAlign;
	  var classes = (0, _classnames["default"])((0, _lib.useVerticalAlignProp)(verticalAlign), 'content', className);
	  var rest = (0, _lib.getUnhandledProps)(ItemContent, props);
	  var ElementType = (0, _lib.getElementType)(ItemContent, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _ItemHeader["default"].create(header, {
	    autoGenerateKey: false
	  }), _ItemMeta["default"].create(meta, {
	    autoGenerateKey: false
	  }), _ItemDescription["default"].create(description, {
	    autoGenerateKey: false
	  }), _ItemExtra["default"].create(extra, {
	    autoGenerateKey: false
	  }), content);
	}
	
	ItemContent.handledProps = ["as", "children", "className", "content", "description", "extra", "header", "meta", "verticalAlign"];
	ItemContent.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Shorthand for ItemDescription component. */
	  description: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemExtra component. */
	  extra: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemHeader component. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for ItemMeta component. */
	  meta: _lib.customPropTypes.itemShorthand,
	
	  /** Content can specify its vertical alignment. */
	  verticalAlign: _propTypes["default"].oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : {};
	var _default = ItemContent;
	exports["default"] = _default;

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _map2 = _interopRequireDefault(__webpack_require__(41));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Item = _interopRequireDefault(__webpack_require__(780));
	
	/**
	 * A group of items.
	 */
	function ItemGroup(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      divided = props.divided,
	      items = props.items,
	      link = props.link,
	      relaxed = props.relaxed,
	      unstackable = props.unstackable;
	  var classes = (0, _classnames["default"])('ui', (0, _lib.useKeyOnly)(divided, 'divided'), (0, _lib.useKeyOnly)(link, 'link'), (0, _lib.useKeyOnly)(unstackable, 'unstackable'), (0, _lib.useKeyOrValueAndKey)(relaxed, 'relaxed'), 'items', className);
	  var rest = (0, _lib.getUnhandledProps)(ItemGroup, props);
	  var ElementType = (0, _lib.getElementType)(ItemGroup, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  if (!_lib.childrenUtils.isNil(content)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), content);
	  }
	
	  var itemsJSX = (0, _map2["default"])(items, function (item) {
	    var childKey = item.childKey,
	        itemProps = (0, _objectWithoutProperties2["default"])(item, ["childKey"]);
	    var finalKey = childKey || [itemProps.content, itemProps.description, itemProps.header, itemProps.meta].join('-');
	    return _react["default"].createElement(_Item["default"], (0, _extends2["default"])({}, itemProps, {
	      key: finalKey
	    }));
	  });
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), itemsJSX);
	}
	
	ItemGroup.handledProps = ["as", "children", "className", "content", "divided", "items", "link", "relaxed", "unstackable"];
	ItemGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Items can be divided to better distinguish between grouped content. */
	  divided: _propTypes["default"].bool,
	
	  /** Shorthand array of props for Item. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /** An item can be formatted so that the entire contents link to another page. */
	  link: _propTypes["default"].bool,
	
	  /** A group of items can relax its padding to provide more negative space. */
	  relaxed: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['very'])]),
	
	  /** Prevent items from stacking on mobile. */
	  unstackable: _propTypes["default"].bool
	} : {};
	var _default = ItemGroup;
	exports["default"] = _default;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Image = _interopRequireDefault(__webpack_require__(124));
	
	/**
	 * An item can contain an image.
	 */
	function ItemImage(props) {
	  var size = props.size;
	  var rest = (0, _lib.getUnhandledProps)(ItemImage, props);
	  return _react["default"].createElement(_Image["default"], (0, _extends2["default"])({}, rest, {
	    size: size,
	    ui: !!size,
	    wrapped: true
	  }));
	}
	
	ItemImage.handledProps = ["size"];
	ItemImage.propTypes =  false ? {
	  /** An image may appear at different sizes. */
	  size: _Image["default"].propTypes.size
	} : {};
	ItemImage.create = (0, _lib.createShorthandFactory)(ItemImage, function (src) {
	  return {
	    src: src
	  };
	});
	var _default = ItemImage;
	exports["default"] = _default;

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _StatisticGroup = _interopRequireDefault(__webpack_require__(785));
	
	var _StatisticLabel = _interopRequireDefault(__webpack_require__(786));
	
	var _StatisticValue = _interopRequireDefault(__webpack_require__(787));
	
	/**
	 * A statistic emphasizes the current value of an attribute.
	 */
	function Statistic(props) {
	  var children = props.children,
	      className = props.className,
	      color = props.color,
	      content = props.content,
	      floated = props.floated,
	      horizontal = props.horizontal,
	      inverted = props.inverted,
	      label = props.label,
	      size = props.size,
	      text = props.text,
	      value = props.value;
	  var classes = (0, _classnames["default"])('ui', color, size, (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(inverted, 'inverted'), 'statistic', className);
	  var rest = (0, _lib.getUnhandledProps)(Statistic, props);
	  var ElementType = (0, _lib.getElementType)(Statistic, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  if (!_lib.childrenUtils.isNil(content)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), content);
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _StatisticValue["default"].create(value, {
	    defaultProps: {
	      text: text
	    },
	    autoGenerateKey: false
	  }), _StatisticLabel["default"].create(label, {
	    autoGenerateKey: false
	  }));
	}
	
	Statistic.handledProps = ["as", "children", "className", "color", "content", "floated", "horizontal", "inverted", "label", "size", "text", "value"];
	Statistic.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** A statistic can be formatted to be different colors. */
	  color: _propTypes["default"].oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A statistic can sit to the left or right of other content. */
	  floated: _propTypes["default"].oneOf(_lib.SUI.FLOATS),
	
	  /** A statistic can present its measurement horizontally. */
	  horizontal: _propTypes["default"].bool,
	
	  /** A statistic can be formatted to fit on a dark background. */
	  inverted: _propTypes["default"].bool,
	
	  /** Label content of the Statistic. */
	  label: _lib.customPropTypes.contentShorthand,
	
	  /** A statistic can vary in size. */
	  size: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.SIZES, 'big', 'massive', 'medium')),
	
	  /** Format the StatisticValue with smaller font size to fit nicely beside number values. */
	  text: _propTypes["default"].bool,
	
	  /** Value content of the Statistic. */
	  value: _lib.customPropTypes.contentShorthand
	} : {};
	Statistic.Group = _StatisticGroup["default"];
	Statistic.Label = _StatisticLabel["default"];
	Statistic.Value = _StatisticValue["default"];
	Statistic.create = (0, _lib.createShorthandFactory)(Statistic, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = Statistic;
	exports["default"] = _default;

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _map2 = _interopRequireDefault(__webpack_require__(41));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Statistic = _interopRequireDefault(__webpack_require__(784));
	
	/**
	 * A group of statistics.
	 */
	function StatisticGroup(props) {
	  var children = props.children,
	      className = props.className,
	      color = props.color,
	      content = props.content,
	      horizontal = props.horizontal,
	      inverted = props.inverted,
	      items = props.items,
	      size = props.size,
	      widths = props.widths;
	  var classes = (0, _classnames["default"])('ui', color, size, (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useWidthProp)(widths), 'statistics', className);
	  var rest = (0, _lib.getUnhandledProps)(StatisticGroup, props);
	  var ElementType = (0, _lib.getElementType)(StatisticGroup, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  if (!_lib.childrenUtils.isNil(content)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), content);
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), (0, _map2["default"])(items, function (item) {
	    return _Statistic["default"].create(item);
	  }));
	}
	
	StatisticGroup.handledProps = ["as", "children", "className", "color", "content", "horizontal", "inverted", "items", "size", "widths"];
	StatisticGroup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** A statistic group can be formatted to be different colors. */
	  color: _propTypes["default"].oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A statistic group can present its measurement horizontally. */
	  horizontal: _propTypes["default"].bool,
	
	  /** A statistic group can be formatted to fit on a dark background. */
	  inverted: _propTypes["default"].bool,
	
	  /** Array of props for Statistic. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /** A statistic group can vary in size. */
	  size: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.SIZES, 'big', 'massive', 'medium')),
	
	  /** A statistic group can have its items divided evenly. */
	  widths: _propTypes["default"].oneOf(_lib.SUI.WIDTHS)
	} : {};
	var _default = StatisticGroup;
	exports["default"] = _default;

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A statistic can contain a label to help provide context for the presented value.
	 */
	function StatisticLabel(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content;
	  var classes = (0, _classnames["default"])('label', className);
	  var rest = (0, _lib.getUnhandledProps)(StatisticLabel, props);
	  var ElementType = (0, _lib.getElementType)(StatisticLabel, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	StatisticLabel.handledProps = ["as", "children", "className", "content"];
	StatisticLabel.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	StatisticLabel.create = (0, _lib.createShorthandFactory)(StatisticLabel, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = StatisticLabel;
	exports["default"] = _default;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A statistic can contain a numeric, icon, image, or text value.
	 */
	function StatisticValue(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      text = props.text;
	  var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(text, 'text'), 'value', className);
	  var rest = (0, _lib.getUnhandledProps)(StatisticValue, props);
	  var ElementType = (0, _lib.getElementType)(StatisticValue, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	StatisticValue.handledProps = ["as", "children", "className", "content", "text"];
	StatisticValue.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Format the value with smaller font size to fit nicely beside number values. */
	  text: _propTypes["default"].bool
	} : {};
	StatisticValue.create = (0, _lib.createShorthandFactory)(StatisticValue, function (content) {
	  return {
	    content: content
	  };
	});
	var _default = StatisticValue;
	exports["default"] = _default;

/***/ },
/* 788 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setRef = exports.shallowEqual = exports.safeInvoke = exports.unwrapArray = void 0;
	
	/**
	 * Takes an argument and if it's an array, returns the first item in the array,
	 * otherwise returns the argument. Used for Preact compatibility.
	 */
	var unwrapArray = function unwrapArray(arg) {
	  return Array.isArray(arg) ? arg[0] : arg;
	};
	/**
	 * Takes a maybe-undefined function and arbitrary args and invokes the function
	 * only if it is defined.
	 */
	
	
	exports.unwrapArray = unwrapArray;
	
	var safeInvoke = function safeInvoke(fn) {
	  if (typeof fn === "function") {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return fn.apply(void 0, args);
	  }
	};
	/**
	 * Does a shallow equality check of two objects by comparing the reference
	 * equality of each value.
	 */
	
	
	exports.safeInvoke = safeInvoke;
	
	var shallowEqual = function shallowEqual(objA, objB) {
	  var aKeys = Object.keys(objA);
	  var bKeys = Object.keys(objB);
	
	  if (bKeys.length !== aKeys.length) {
	    return false;
	  }
	
	  for (var i = 0; i < bKeys.length; i++) {
	    var key = aKeys[i];
	
	    if (objA[key] !== objB[key]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	/**
	 * Sets a ref using either a ref callback or a ref object
	 */
	
	
	exports.shallowEqual = shallowEqual;
	
	var setRef = function setRef(ref, node) {
	  // if its a function call it
	  if (typeof ref === "function") {
	    return safeInvoke(ref, node);
	  } // otherwise we should treat it as a ref object
	  else if (ref != null) {
	      ref.current = node;
	    }
	};
	
	exports.setRef = setRef;

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(217).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ },
/* 790 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeToArray = __webpack_require__(340);
	function _arrayWithoutHoles(r) {
	  if (Array.isArray(r)) return arrayLikeToArray(r);
	}
	module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 792 */
/***/ function(module, exports) {

	function _iterableToArrayLimit(r, l) {
	  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
	  if (null != t) {
	    var e,
	      n,
	      i,
	      u,
	      a = [],
	      f = !0,
	      o = !1;
	    try {
	      if (i = (t = t.call(r)).next, 0 === l) {
	        if (Object(t) !== t) return;
	        f = !1;
	      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
	    } catch (r) {
	      o = !0, n = r;
	    } finally {
	      try {
	        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
	      } finally {
	        if (o) throw n;
	      }
	    }
	    return a;
	  }
	}
	module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 793 */
/***/ function(module, exports) {

	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototypeOf = __webpack_require__(26);
	function _superPropBase(t, o) {
	  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = getPrototypeOf(t)););
	  return t;
	}
	module.exports = _superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(55)["default"];
	function toPrimitive(t, r) {
	  if ("object" != _typeof(t) || !t) return t;
	  var e = t[Symbol.toPrimitive];
	  if (void 0 !== e) {
	    var i = e.call(t, r || "default");
	    if ("object" != _typeof(i)) return i;
	    throw new TypeError("@@toPrimitive must return a primitive value.");
	  }
	  return ("string" === r ? String : Number)(t);
	}
	module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gud = __webpack_require__(6735);
	
	var _gud2 = _interopRequireDefault(_gud);
	
	var _warning = __webpack_require__(227);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	// Inlined Object.is polyfill.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Provider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits = void 0;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0; // No change
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	          if (false) {
	            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    Provider.prototype.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
	
	  var Consumer = function (_Component2) {
	    _inherits(Consumer, _Component2);
	
	    function Consumer() {
	      var _temp2, _this2, _ret2;
	
	      _classCallCheck(this, Consumer);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
	        value: _this2.getValue()
	      }, _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({ value: _this2.getValue() });
	        }
	      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	    }
	
	    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	      var observedBits = this.props.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    Consumer.prototype.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    Consumer.prototype.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(_react.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
	
	
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}
	
	exports.default = createReactContext;
	module.exports = exports['default'];

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _implementation = __webpack_require__(796);
	
	var _implementation2 = _interopRequireDefault(_implementation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createContext || _implementation2.default;
	module.exports = exports['default'];

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _toArray2 = _interopRequireDefault(__webpack_require__(346));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(67);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _Collapse = _interopRequireDefault(__webpack_require__(161));
	
	var _Paper = _interopRequireDefault(__webpack_require__(65));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _AccordionContext = _interopRequireDefault(__webpack_require__(348));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(85));
	
	var styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      transition: theme.transitions.create(['margin'], transition),
	      '&:before': {
	        position: 'absolute',
	        left: 0,
	        top: -1,
	        right: 0,
	        height: 1,
	        content: '""',
	        opacity: 1,
	        backgroundColor: theme.palette.divider,
	        transition: theme.transitions.create(['opacity', 'background-color'], transition)
	      },
	      '&:first-child': {
	        '&:before': {
	          display: 'none'
	        }
	      },
	      '&$expanded': {
	        margin: '16px 0',
	        '&:first-child': {
	          marginTop: 0
	        },
	        '&:last-child': {
	          marginBottom: 0
	        },
	        '&:before': {
	          opacity: 0
	        }
	      },
	      '&$expanded + &': {
	        '&:before': {
	          display: 'none'
	        }
	      },
	      '&$disabled': {
	        backgroundColor: theme.palette.action.disabledBackground
	      }
	    },
	
	    /* Styles applied to the root element if `square={false}`. */
	    rounded: {
	      borderRadius: 0,
	      '&:first-child': {
	        borderTopLeftRadius: theme.shape.borderRadius,
	        borderTopRightRadius: theme.shape.borderRadius
	      },
	      '&:last-child': {
	        borderBottomLeftRadius: theme.shape.borderRadius,
	        borderBottomRightRadius: theme.shape.borderRadius,
	        // Fix a rendering issue on Edge
	        '@supports (-ms-ime-align: auto)': {
	          borderBottomLeftRadius: 0,
	          borderBottomRightRadius: 0
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `expanded={true}`. */
	    expanded: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {}
	  };
	};
	
	exports.styles = styles;
	var Accordion = /*#__PURE__*/React.forwardRef(function Accordion(props, ref) {
	  var childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$defaultExpande = props.defaultExpanded,
	      defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      expandedProp = props.expanded,
	      onChange = props.onChange,
	      _props$square = props.square,
	      square = _props$square === void 0 ? false : _props$square,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Collapse.default : _props$TransitionComp,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "defaultExpanded", "disabled", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"]);
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: expandedProp,
	    default: defaultExpanded,
	    name: 'Accordion',
	    state: 'expanded'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      expanded = _useControlled2[0],
	      setExpandedState = _useControlled2[1];
	
	  var handleChange = React.useCallback(function (event) {
	    setExpandedState(!expanded);
	
	    if (onChange) {
	      onChange(event, !expanded);
	    }
	  }, [expanded, onChange, setExpandedState]);
	
	  var _React$Children$toArr = React.Children.toArray(childrenProp),
	      _React$Children$toArr2 = (0, _toArray2.default)(_React$Children$toArr),
	      summary = _React$Children$toArr2[0],
	      children = _React$Children$toArr2.slice(1);
	
	  var contextValue = React.useMemo(function () {
	    return {
	      expanded: expanded,
	      disabled: disabled,
	      toggle: handleChange
	    };
	  }, [expanded, disabled, handleChange]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
	    ref: ref,
	    square: square
	  }, other), /*#__PURE__*/React.createElement(_AccordionContext.default.Provider, {
	    value: contextValue
	  }, summary), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    in: expanded,
	    timeout: "auto"
	  }, TransitionProps), /*#__PURE__*/React.createElement("div", {
	    "aria-labelledby": summary.props.id,
	    id: summary.props['aria-controls'],
	    role: "region"
	  }, children)));
	});
	 false ? Accordion.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the accordion.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node.isRequired, function (props) {
	    var summary = React.Children.toArray(props.children)[0];
	
	    if ((0, _reactIs.isFragment)(summary)) {
	      return new Error("Material-UI: The Accordion doesn't accept a Fragment as a child. " + 'Consider providing an array instead.');
	    }
	
	    if (! /*#__PURE__*/React.isValidElement(summary)) {
	      return new Error('Material-UI: Expected the first child of Accordion to be a valid element.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, expands the accordion by default.
	   */
	  defaultExpanded: _propTypes.default.bool,
	
	  /**
	   * If `true`, the accordion will be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, expands the accordion, otherwise collapse it.
	   * Setting this prop enables control over the accordion.
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * Callback fired when the expand/collapse state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {boolean} expanded The `expanded` state of the accordion.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, rounded corners are disabled.
	   */
	  square: _propTypes.default.bool,
	
	  /**
	   * The component used for the collapse effect.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAccordion'
	})(Accordion);
	
	exports.default = _default;

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Accordion.default;
	  }
	});
	
	var _Accordion = _interopRequireDefault(__webpack_require__(798));

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 8,
	    justifyContent: 'flex-end'
	  },
	
	  /* Styles applied to the root element if `disableSpacing={false}`. */
	  spacing: {
	    '& > :not(:first-child)': {
	      marginLeft: 8
	    }
	  }
	};
	exports.styles = styles;
	var AccordionActions = /*#__PURE__*/React.forwardRef(function AccordionActions(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$disableSpacing = props.disableSpacing,
	      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disableSpacing"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, !disableSpacing && classes.spacing),
	    ref: ref
	  }, other));
	});
	 false ? AccordionActions.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the actions do not have additional margin.
	   */
	  disableSpacing: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAccordionActions'
	})(AccordionActions);
	
	exports.default = _default;

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _AccordionActions.default;
	  }
	});
	
	var _AccordionActions = _interopRequireDefault(__webpack_require__(800));

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      padding: theme.spacing(1, 2, 2)
	    }
	  };
	};
	
	exports.styles = styles;
	var AccordionDetails = /*#__PURE__*/React.forwardRef(function AccordionDetails(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other));
	});
	 false ? AccordionDetails.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the accordion details.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAccordionDetails'
	})(AccordionDetails);
	
	exports.default = _default;

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _AccordionDetails.default;
	  }
	});
	
	var _AccordionDetails = _interopRequireDefault(__webpack_require__(802));

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(56));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(125));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _AccordionContext = _interopRequireDefault(__webpack_require__(348));
	
	/* eslint-disable jsx-a11y/aria-role */
	var styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      minHeight: 8 * 6,
	      transition: theme.transitions.create(['min-height', 'background-color'], transition),
	      padding: theme.spacing(0, 2),
	      '&:hover:not($disabled)': {
	        cursor: 'pointer'
	      },
	      '&$expanded': {
	        minHeight: 64
	      },
	      '&$focused': {
	        backgroundColor: theme.palette.action.focus
	      },
	      '&$disabled': {
	        opacity: theme.palette.action.disabledOpacity
	      }
	    },
	
	    /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
	    expanded: {},
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the children wrapper element. */
	    content: {
	      display: 'flex',
	      flexGrow: 1,
	      transition: theme.transitions.create(['margin'], transition),
	      margin: '12px 0',
	      '&$expanded': {
	        margin: '20px 0'
	      }
	    },
	
	    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
	    expandIcon: {
	      transform: 'rotate(0deg)',
	      transition: theme.transitions.create('transform', transition),
	      '&:hover': {
	        // Disable the hover effect for the IconButton,
	        // because a hover effect should apply to the entire Expand button and
	        // not only to the IconButton.
	        backgroundColor: 'transparent'
	      },
	      '&$expanded': {
	        transform: 'rotate(180deg)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var AccordionSummary = /*#__PURE__*/React.forwardRef(function AccordionSummary(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      expandIcon = props.expandIcon,
	      IconButtonProps = props.IconButtonProps,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocusVisible = props.onFocusVisible,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "expandIcon", "IconButtonProps", "onBlur", "onClick", "onFocusVisible"]);
	
	  var _React$useState = React.useState(false),
	      focusedState = _React$useState[0],
	      setFocusedState = _React$useState[1];
	
	  var handleFocusVisible = function handleFocusVisible(event) {
	    setFocusedState(true);
	
	    if (onFocusVisible) {
	      onFocusVisible(event);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    setFocusedState(false);
	
	    if (onBlur) {
	      onBlur(event);
	    }
	  };
	
	  var _React$useContext = React.useContext(_AccordionContext.default),
	      _React$useContext$dis = _React$useContext.disabled,
	      disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis,
	      expanded = _React$useContext.expanded,
	      toggle = _React$useContext.toggle;
	
	  var handleChange = function handleChange(event) {
	    if (toggle) {
	      toggle(event);
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    focusRipple: false,
	    disableRipple: true,
	    disabled: disabled,
	    component: "div",
	    "aria-expanded": expanded,
	    className: (0, _clsx.default)(classes.root, className, disabled && classes.disabled, expanded && classes.expanded, focusedState && classes.focused),
	    onFocusVisible: handleFocusVisible,
	    onBlur: handleBlur,
	    onClick: handleChange,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.content, expanded && classes.expanded)
	  }, children), expandIcon && /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.expandIcon, expanded && classes.expanded),
	    edge: "end",
	    component: "div",
	    tabIndex: null,
	    role: null,
	    "aria-hidden": true
	  }, IconButtonProps), expandIcon));
	});
	 false ? AccordionSummary.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the accordion summary.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The icon to display as the expand indicator.
	   */
	  expandIcon: _propTypes.default.node,
	
	  /**
	   * Props applied to the `IconButton` element wrapping the expand icon.
	   */
	  IconButtonProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocusVisible: _propTypes.default.func
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAccordionSummary'
	})(AccordionSummary);
	
	exports.default = _default;

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _AccordionSummary.default;
	  }
	});
	
	var _AccordionSummary = _interopRequireDefault(__webpack_require__(804));

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _Paper = _interopRequireDefault(__webpack_require__(65));
	
	var styles = function styles(theme) {
	  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      flexDirection: 'column',
	      width: '100%',
	      boxSizing: 'border-box',
	      // Prevent padding issue with the Modal and fixed positioned AppBar.
	      zIndex: theme.zIndex.appBar,
	      flexShrink: 0
	    },
	
	    /* Styles applied to the root element if `position="fixed"`. */
	    positionFixed: {
	      position: 'fixed',
	      top: 0,
	      left: 'auto',
	      right: 0,
	      '@media print': {
	        // Prevent the app bar to be visible on each printed page.
	        position: 'absolute'
	      }
	    },
	
	    /* Styles applied to the root element if `position="absolute"`. */
	    positionAbsolute: {
	      position: 'absolute',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	
	    /* Styles applied to the root element if `position="sticky"`. */
	    positionSticky: {
	      // ⚠️ sticky is not supported by IE 11.
	      position: 'sticky',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	
	    /* Styles applied to the root element if `position="static"`. */
	    positionStatic: {
	      position: 'static'
	    },
	
	    /* Styles applied to the root element if `position="relative"`. */
	    positionRelative: {
	      position: 'relative'
	    },
	
	    /* Styles applied to the root element if `color="default"`. */
	    colorDefault: {
	      backgroundColor: backgroundColorDefault,
	      color: theme.palette.getContrastText(backgroundColorDefault)
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="transparent"`. */
	    colorTransparent: {
	      backgroundColor: 'transparent',
	      color: 'inherit'
	    }
	  };
	};
	
	exports.styles = styles;
	var AppBar = /*#__PURE__*/React.forwardRef(function AppBar(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$position = props.position,
	      position = _props$position === void 0 ? 'fixed' : _props$position,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "position"]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    component: "header",
	    elevation: 4,
	    className: (0, _clsx.default)(classes.root, classes["position".concat((0, _capitalize.default)(position))], classes["color".concat((0, _capitalize.default)(color))], className, position === 'fixed' && 'mui-fixed'),
	    ref: ref
	  }, other));
	});
	 false ? AppBar.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary', 'transparent']),
	
	  /**
	   * The positioning type. The behavior of the different options is described
	   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
	   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
	   */
	  position: _propTypes.default.oneOf(['absolute', 'fixed', 'relative', 'static', 'sticky'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAppBar'
	})(AppBar);
	
	exports.default = _default;

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _AppBar.default;
	  }
	});
	
	var _AppBar = _interopRequireDefault(__webpack_require__(806));

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Person = _interopRequireDefault(__webpack_require__(1022));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      flexShrink: 0,
	      width: 40,
	      height: 40,
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(20),
	      lineHeight: 1,
	      borderRadius: '50%',
	      overflow: 'hidden',
	      userSelect: 'none'
	    },
	
	    /* Styles applied to the root element if not `src` or `srcSet`. */
	    colorDefault: {
	      color: theme.palette.background.default,
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
	    },
	
	    /* Styles applied to the root element if `variant="circle"`. */
	    circle: {},
	
	    /* Styles applied to the root element if `variant="rounded"`. */
	    rounded: {
	      borderRadius: theme.shape.borderRadius
	    },
	
	    /* Styles applied to the root element if `variant="square"`. */
	    square: {
	      borderRadius: 0
	    },
	
	    /* Styles applied to the img element if either `src` or `srcSet` is defined. */
	    img: {
	      width: '100%',
	      height: '100%',
	      textAlign: 'center',
	      // Handle non-square image. The property isn't supported by IE 11.
	      objectFit: 'cover',
	      // Hide alt text.
	      color: 'transparent',
	      // Hide the image broken icon, only works on Chrome.
	      textIndent: 10000
	    },
	
	    /* Styles applied to the fallback icon */
	    fallback: {
	      width: '75%',
	      height: '75%'
	    }
	  };
	};
	
	exports.styles = styles;
	
	function useLoaded(_ref) {
	  var src = _ref.src,
	      srcSet = _ref.srcSet;
	
	  var _React$useState = React.useState(false),
	      loaded = _React$useState[0],
	      setLoaded = _React$useState[1];
	
	  React.useEffect(function () {
	    if (!src && !srcSet) {
	      return undefined;
	    }
	
	    setLoaded(false);
	    var active = true;
	    var image = new Image();
	    image.src = src;
	    image.srcSet = srcSet;
	
	    image.onload = function () {
	      if (!active) {
	        return;
	      }
	
	      setLoaded('loaded');
	    };
	
	    image.onerror = function () {
	      if (!active) {
	        return;
	      }
	
	      setLoaded('error');
	    };
	
	    return function () {
	      active = false;
	    };
	  }, [src, srcSet]);
	  return loaded;
	}
	
	var Avatar = /*#__PURE__*/React.forwardRef(function Avatar(props, ref) {
	  var alt = props.alt,
	      childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      imgProps = props.imgProps,
	      sizes = props.sizes,
	      src = props.src,
	      srcSet = props.srcSet,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'circle' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["alt", "children", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet", "variant"]);
	  var children = null; // Use a hook instead of onError on the img element to support server-side rendering.
	
	  var loaded = useLoaded({
	    src: src,
	    srcSet: srcSet
	  });
	  var hasImg = src || srcSet;
	  var hasImgNotFailing = hasImg && loaded !== 'error';
	
	  if (hasImgNotFailing) {
	    children = /*#__PURE__*/React.createElement("img", (0, _extends2.default)({
	      alt: alt,
	      src: src,
	      srcSet: srcSet,
	      sizes: sizes,
	      className: classes.img
	    }, imgProps));
	  } else if (childrenProp != null) {
	    children = childrenProp;
	  } else if (hasImg && alt) {
	    children = alt[0];
	  } else {
	    children = /*#__PURE__*/React.createElement(_Person.default, {
	      className: classes.fallback
	    });
	  }
	
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes.system, classes[variant], className, !hasImgNotFailing && classes.colorDefault),
	    ref: ref
	  }, other), children);
	});
	 false ? Avatar.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Used in combination with `src` or `srcSet` to
	   * provide an alt attribute for the rendered `img` element.
	   */
	  alt: _propTypes.default.string,
	
	  /**
	   * Used to render icon or text elements inside the Avatar if `src` is not set.
	   * This can be an element, or just a string.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Attributes applied to the `img` element if the component is used to display an image.
	   * It can be used to listen for the loading error event.
	   */
	  imgProps: _propTypes.default.object,
	
	  /**
	   * The `sizes` attribute for the `img` element.
	   */
	  sizes: _propTypes.default.string,
	
	  /**
	   * The `src` attribute for the `img` element.
	   */
	  src: _propTypes.default.string,
	
	  /**
	   * The `srcSet` attribute for the `img` element.
	   * Use this attribute for responsive image display.
	   */
	  srcSet: _propTypes.default.string,
	
	  /**
	   * The shape of the avatar.
	   */
	  variant: _propTypes.default.oneOf(['circle', 'rounded', 'square'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAvatar'
	})(Avatar);
	
	exports.default = _default;

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Avatar.default;
	  }
	});
	
	var _Avatar = _interopRequireDefault(__webpack_require__(808));

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Fade = _interopRequireDefault(__webpack_require__(231));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    // Improve scrollable dialog support.
	    zIndex: -1,
	    position: 'fixed',
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    right: 0,
	    bottom: 0,
	    top: 0,
	    left: 0,
	    backgroundColor: 'rgba(0, 0, 0, 0.5)',
	    WebkitTapHighlightColor: 'transparent'
	  },
	
	  /* Styles applied to the root element if `invisible={true}`. */
	  invisible: {
	    backgroundColor: 'transparent'
	  }
	};
	exports.styles = styles;
	var Backdrop = /*#__PURE__*/React.forwardRef(function Backdrop(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$invisible = props.invisible,
	      invisible = _props$invisible === void 0 ? false : _props$invisible,
	      open = props.open,
	      transitionDuration = props.transitionDuration,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Fade.default : _props$TransitionComp,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "invisible", "open", "transitionDuration", "TransitionComponent"]);
	  return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    in: open,
	    timeout: transitionDuration
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.root, className, invisible && classes.invisible),
	    "aria-hidden": true,
	    ref: ref
	  }, children));
	});
	 false ? Backdrop.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the backdrop is invisible.
	   * It can be used when rendering a popover or a custom select component.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBackdrop'
	})(Backdrop);
	
	exports.default = _default;

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var RADIUS_STANDARD = 10;
	var RADIUS_DOT = 4;
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      display: 'inline-flex',
	      // For correct alignment with the text.
	      verticalAlign: 'middle',
	      flexShrink: 0
	    },
	
	    /* Styles applied to the badge `span` element. */
	    badge: {
	      display: 'flex',
	      flexDirection: 'row',
	      flexWrap: 'wrap',
	      justifyContent: 'center',
	      alignContent: 'center',
	      alignItems: 'center',
	      position: 'absolute',
	      boxSizing: 'border-box',
	      fontFamily: theme.typography.fontFamily,
	      fontWeight: theme.typography.fontWeightMedium,
	      fontSize: theme.typography.pxToRem(12),
	      minWidth: RADIUS_STANDARD * 2,
	      lineHeight: 1,
	      padding: '0 6px',
	      height: RADIUS_STANDARD * 2,
	      borderRadius: RADIUS_STANDARD,
	      zIndex: 1,
	      // Render the badge on top of potential ripples.
	      transition: theme.transitions.create('transform', {
	        easing: theme.transitions.easing.easeInOut,
	        duration: theme.transitions.duration.enteringScreen
	      })
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      backgroundColor: theme.palette.error.main,
	      color: theme.palette.error.contrastText
	    },
	
	    /* Styles applied to the root element if `variant="dot"`. */
	    dot: {
	      borderRadius: RADIUS_DOT,
	      height: RADIUS_DOT * 2,
	      minWidth: RADIUS_DOT * 2,
	      padding: 0
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangle"`. */
	    anchorOriginTopRightRectangle: {
	      top: 0,
	      right: 0,
	      transform: 'scale(1) translate(50%, -50%)',
	      transformOrigin: '100% 0%',
	      '&$invisible': {
	        transform: 'scale(0) translate(50%, -50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangle"`. */
	    anchorOriginBottomRightRectangle: {
	      bottom: 0,
	      right: 0,
	      transform: 'scale(1) translate(50%, 50%)',
	      transformOrigin: '100% 100%',
	      '&$invisible': {
	        transform: 'scale(0) translate(50%, 50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangle"`. */
	    anchorOriginTopLeftRectangle: {
	      top: 0,
	      left: 0,
	      transform: 'scale(1) translate(-50%, -50%)',
	      transformOrigin: '0% 0%',
	      '&$invisible': {
	        transform: 'scale(0) translate(-50%, -50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangle"`. */
	    anchorOriginBottomLeftRectangle: {
	      bottom: 0,
	      left: 0,
	      transform: 'scale(1) translate(-50%, 50%)',
	      transformOrigin: '0% 100%',
	      '&$invisible': {
	        transform: 'scale(0) translate(-50%, 50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circle"`. */
	    anchorOriginTopRightCircle: {
	      top: '14%',
	      right: '14%',
	      transform: 'scale(1) translate(50%, -50%)',
	      transformOrigin: '100% 0%',
	      '&$invisible': {
	        transform: 'scale(0) translate(50%, -50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circle"`. */
	    anchorOriginBottomRightCircle: {
	      bottom: '14%',
	      right: '14%',
	      transform: 'scale(1) translate(50%, 50%)',
	      transformOrigin: '100% 100%',
	      '&$invisible': {
	        transform: 'scale(0) translate(50%, 50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circle"`. */
	    anchorOriginTopLeftCircle: {
	      top: '14%',
	      left: '14%',
	      transform: 'scale(1) translate(-50%, -50%)',
	      transformOrigin: '0% 0%',
	      '&$invisible': {
	        transform: 'scale(0) translate(-50%, -50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circle"`. */
	    anchorOriginBottomLeftCircle: {
	      bottom: '14%',
	      left: '14%',
	      transform: 'scale(1) translate(-50%, 50%)',
	      transformOrigin: '0% 100%',
	      '&$invisible': {
	        transform: 'scale(0) translate(-50%, 50%)'
	      }
	    },
	
	    /* Pseudo-class to the badge `span` element if `invisible={true}`. */
	    invisible: {
	      transition: theme.transitions.create('transform', {
	        easing: theme.transitions.easing.easeInOut,
	        duration: theme.transitions.duration.leavingScreen
	      })
	    }
	  };
	};
	
	exports.styles = styles;
	var Badge = /*#__PURE__*/React.forwardRef(function Badge(props, ref) {
	  var _props$anchorOrigin = props.anchorOrigin,
	      anchorOrigin = _props$anchorOrigin === void 0 ? {
	    vertical: 'top',
	    horizontal: 'right'
	  } : _props$anchorOrigin,
	      badgeContent = props.badgeContent,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      ComponentProp = _props$component === void 0 ? 'span' : _props$component,
	      invisibleProp = props.invisible,
	      _props$max = props.max,
	      max = _props$max === void 0 ? 99 : _props$max,
	      _props$overlap = props.overlap,
	      overlap = _props$overlap === void 0 ? 'rectangle' : _props$overlap,
	      _props$showZero = props.showZero,
	      showZero = _props$showZero === void 0 ? false : _props$showZero,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchorOrigin", "badgeContent", "children", "classes", "className", "color", "component", "invisible", "max", "overlap", "showZero", "variant"]);
	  var invisible = invisibleProp;
	
	  if (invisibleProp == null && (badgeContent === 0 && !showZero || badgeContent == null && variant !== 'dot')) {
	    invisible = true;
	  }
	
	  var displayValue = '';
	
	  if (variant !== 'dot') {
	    displayValue = badgeContent > max ? "".concat(max, "+") : badgeContent;
	  }
	
	  return /*#__PURE__*/React.createElement(ComponentProp, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), children, /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.badge, classes["".concat(anchorOrigin.horizontal).concat((0, _capitalize.default)(anchorOrigin.vertical), "}")], classes["anchorOrigin".concat((0, _capitalize.default)(anchorOrigin.vertical)).concat((0, _capitalize.default)(anchorOrigin.horizontal)).concat((0, _capitalize.default)(overlap))], color !== 'default' && classes["color".concat((0, _capitalize.default)(color))], invisible && classes.invisible, variant === 'dot' && classes.dot)
	  }, displayValue));
	});
	 false ? Badge.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The anchor of the badge.
	   */
	  anchorOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOf(['left', 'right']).isRequired,
	    vertical: _propTypes.default.oneOf(['bottom', 'top']).isRequired
	  }),
	
	  /**
	   * The content rendered within the badge.
	   */
	  badgeContent: _propTypes.default.node,
	
	  /**
	   * The badge will be added relative to this node.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'error', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the badge will be invisible.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * Max count to show.
	   */
	  max: _propTypes.default.number,
	
	  /**
	   * Wrapped shape the badge should overlap.
	   */
	  overlap: _propTypes.default.oneOf(['circle', 'rectangle']),
	
	  /**
	   * Controls whether the badge is hidden when `badgeContent` is zero.
	   */
	  showZero: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['dot', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBadge'
	})(Badge);
	
	exports.default = _default;

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Badge.default;
	  }
	});
	
	var _Badge = _interopRequireDefault(__webpack_require__(811));

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(67);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      justifyContent: 'center',
	      height: 56,
	      backgroundColor: theme.palette.background.paper
	    }
	  };
	};
	
	exports.styles = styles;
	var BottomNavigation = /*#__PURE__*/React.forwardRef(function BottomNavigation(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      onChange = props.onChange,
	      _props$showLabels = props.showLabels,
	      showLabels = _props$showLabels === void 0 ? false : _props$showLabels,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "onChange", "showLabels", "value"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), React.Children.map(children, function (child, childIndex) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The BottomNavigation component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var childValue = child.props.value === undefined ? childIndex : child.props.value;
	    return /*#__PURE__*/React.cloneElement(child, {
	      selected: childValue === value,
	      showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
	      value: childValue,
	      onChange: onChange
	    });
	  }));
	});
	 false ? BottomNavigation.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Callback fired when the value changes.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {any} value We default to the index of the child.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, all `BottomNavigationAction`s will show their labels.
	   * By default, only the selected `BottomNavigationAction` will show its label.
	   */
	  showLabels: _propTypes.default.bool,
	
	  /**
	   * The value of the currently selected `BottomNavigationAction`.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBottomNavigation'
	})(BottomNavigation);
	
	exports.default = _default;

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigation.default;
	  }
	});
	
	var _BottomNavigation = _interopRequireDefault(__webpack_require__(813));

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(56));
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(170));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      transition: theme.transitions.create(['color', 'padding-top'], {
	        duration: theme.transitions.duration.short
	      }),
	      padding: '6px 12px 8px',
	      minWidth: 80,
	      maxWidth: 168,
	      color: theme.palette.text.secondary,
	      flex: '1',
	      '&$iconOnly': {
	        paddingTop: 16
	      },
	      '&$selected': {
	        paddingTop: 6,
	        color: theme.palette.primary.main
	      }
	    },
	
	    /* Pseudo-class applied to the root element if selected. */
	    selected: {},
	
	    /* Pseudo-class applied to the root element if `showLabel={false}` and not selected. */
	    iconOnly: {},
	
	    /* Styles applied to the span element that wraps the icon and label. */
	    wrapper: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      width: '100%',
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the label's span element. */
	    label: {
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(12),
	      opacity: 1,
	      transition: 'font-size 0.2s, opacity 0.2s',
	      transitionDelay: '0.1s',
	      '&$iconOnly': {
	        opacity: 0,
	        transitionDelay: '0s'
	      },
	      '&$selected': {
	        fontSize: theme.typography.pxToRem(14)
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var BottomNavigationAction = /*#__PURE__*/React.forwardRef(function BottomNavigationAction(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      icon = props.icon,
	      label = props.label,
	      onChange = props.onChange,
	      onClick = props.onClick,
	      selected = props.selected,
	      showLabel = props.showLabel,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "icon", "label", "onChange", "onClick", "selected", "showLabel", "value"]);
	
	  var handleChange = function handleChange(event) {
	    if (onChange) {
	      onChange(event, value);
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className, selected ? classes.selected : !showLabel && classes.iconOnly),
	    focusRipple: true,
	    onClick: handleChange
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.wrapper
	  }, icon, /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.label, selected ? classes.selected : !showLabel && classes.iconOnly)
	  }, label)));
	});
	 false ? BottomNavigationAction.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop isn't supported.
	   * Use the `component` prop if you need to change the children structure.
	   */
	  children: _unsupportedProp.default,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The icon element.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The label element.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  selected: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `BottomNavigationAction` will show its label.
	   * By default, only the selected `BottomNavigationAction`
	   * inside `BottomNavigation` will show its label.
	   */
	  showLabel: _propTypes.default.bool,
	
	  /**
	   * You can provide your own value. Otherwise, we fallback to the child position index.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBottomNavigationAction'
	})(BottomNavigationAction);
	
	exports.default = _default;

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigationAction.default;
	  }
	});
	
	var _BottomNavigationAction = _interopRequireDefault(__webpack_require__(815));

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styleFunction = void 0;
	
	var _system = __webpack_require__(406);
	
	var _styled = _interopRequireDefault(__webpack_require__(393));
	
	var styleFunction = (0, _system.css)((0, _system.compose)(_system.borders, _system.display, _system.flexbox, _system.grid, _system.positions, _system.palette, _system.shadows, _system.sizing, _system.spacing, _system.typography));
	/**
	 * @ignore - do not document.
	 */
	
	exports.styleFunction = styleFunction;
	var Box = (0, _styled.default)('div')(styleFunction, {
	  name: 'MuiBox'
	});
	var _default = Box;
	exports.default = _default;

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Box.default;
	  }
	});
	Object.defineProperty(exports, "styleFunction", {
	  enumerable: true,
	  get: function get() {
	    return _Box.styleFunction;
	  }
	});
	
	var _Box = _interopRequireWildcard(__webpack_require__(817));

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _colorManipulator = __webpack_require__(49);
	
	var _MoreHoriz = _interopRequireDefault(__webpack_require__(1021));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(56));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      marginLeft: theme.spacing(0.5),
	      marginRight: theme.spacing(0.5),
	      backgroundColor: theme.palette.grey[100],
	      color: theme.palette.grey[700],
	      borderRadius: 2,
	      cursor: 'pointer',
	      '&:hover, &:focus': {
	        backgroundColor: theme.palette.grey[200]
	      },
	      '&:active': {
	        boxShadow: theme.shadows[0],
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.grey[200], 0.12)
	      }
	    },
	    icon: {
	      width: 24,
	      height: 16
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	function BreadcrumbCollapsed(props) {
	  var classes = props.classes,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    component: "li",
	    className: classes.root,
	    focusRipple: true
	  }, other), /*#__PURE__*/React.createElement(_MoreHoriz.default, {
	    className: classes.icon
	  }));
	}
	
	 false ? BreadcrumbCollapsed.propTypes = {
	  /**
	   * @ignore
	   */
	  classes: _propTypes.default.object.isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateBreadcrumbCollapsed'
	})(BreadcrumbCollapsed);
	
	exports.default = _default;

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(46));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(67);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Typography = _interopRequireDefault(__webpack_require__(66));
	
	var _BreadcrumbCollapsed = _interopRequireDefault(__webpack_require__(819));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {},
	
	  /* Styles applied to the ol element. */
	  ol: {
	    display: 'flex',
	    flexWrap: 'wrap',
	    alignItems: 'center',
	    padding: 0,
	    margin: 0,
	    listStyle: 'none'
	  },
	
	  /* Styles applied to the li element. */
	  li: {},
	
	  /* Styles applied to the separator element. */
	  separator: {
	    display: 'flex',
	    userSelect: 'none',
	    marginLeft: 8,
	    marginRight: 8
	  }
	};
	exports.styles = styles;
	
	function insertSeparators(items, className, separator) {
	  return items.reduce(function (acc, current, index) {
	    if (index < items.length - 1) {
	      acc = acc.concat(current, /*#__PURE__*/React.createElement("li", {
	        "aria-hidden": true,
	        key: "separator-".concat(index),
	        className: className
	      }, separator));
	    } else {
	      acc.push(current);
	    }
	
	    return acc;
	  }, []);
	}
	
	var Breadcrumbs = /*#__PURE__*/React.forwardRef(function Breadcrumbs(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'nav' : _props$component,
	      _props$expandText = props.expandText,
	      expandText = _props$expandText === void 0 ? 'Show path' : _props$expandText,
	      _props$itemsAfterColl = props.itemsAfterCollapse,
	      itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl,
	      _props$itemsBeforeCol = props.itemsBeforeCollapse,
	      itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol,
	      _props$maxItems = props.maxItems,
	      maxItems = _props$maxItems === void 0 ? 8 : _props$maxItems,
	      _props$separator = props.separator,
	      separator = _props$separator === void 0 ? '/' : _props$separator,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"]);
	
	  var _React$useState = React.useState(false),
	      expanded = _React$useState[0],
	      setExpanded = _React$useState[1];
	
	  var renderItemsBeforeAndAfter = function renderItemsBeforeAndAfter(allItems) {
	    var handleClickExpand = function handleClickExpand(event) {
	      setExpanded(true); // The clicked element received the focus but gets removed from the DOM.
	      // Let's keep the focus in the component after expanding.
	
	      var focusable = event.currentTarget.parentNode.querySelector('a[href],button,[tabindex]');
	
	      if (focusable) {
	        focusable.focus();
	      }
	    }; // This defends against someone passing weird input, to ensure that if all
	    // items would be shown anyway, we just show all items without the EllipsisItem
	
	
	    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
	      if (false) {
	        console.error(['Material-UI: You have provided an invalid combination of props to the Breadcrumbs.', "itemsAfterCollapse={".concat(itemsAfterCollapse, "} + itemsBeforeCollapse={").concat(itemsBeforeCollapse, "} >= maxItems={").concat(maxItems, "}")].join('\n'));
	      }
	
	      return allItems;
	    }
	
	    return [].concat((0, _toConsumableArray2.default)(allItems.slice(0, itemsBeforeCollapse)), [/*#__PURE__*/React.createElement(_BreadcrumbCollapsed.default, {
	      "aria-label": expandText,
	      key: "ellipsis",
	      onClick: handleClickExpand
	    })], (0, _toConsumableArray2.default)(allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)));
	  };
	
	  var allItems = React.Children.toArray(children).filter(function (child) {
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The Breadcrumbs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    return /*#__PURE__*/React.isValidElement(child);
	  }).map(function (child, index) {
	    return /*#__PURE__*/React.createElement("li", {
	      className: classes.li,
	      key: "child-".concat(index)
	    }, child);
	  });
	  return /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	    ref: ref,
	    component: Component,
	    color: "textSecondary",
	    className: (0, _clsx.default)(classes.root, className)
	  }, other), /*#__PURE__*/React.createElement("ol", {
	    className: classes.ol
	  }, insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator)));
	});
	 false ? Breadcrumbs.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The breadcrumb children.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Override the default label for the expand button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  expandText: _propTypes.default.string,
	
	  /**
	   * If max items is exceeded, the number of items to show after the ellipsis.
	   */
	  itemsAfterCollapse: _propTypes.default.number,
	
	  /**
	   * If max items is exceeded, the number of items to show before the ellipsis.
	   */
	  itemsBeforeCollapse: _propTypes.default.number,
	
	  /**
	   * Specifies the maximum number of breadcrumbs to display. When there are more
	   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
	   * will be shown, with an ellipsis in between.
	   */
	  maxItems: _propTypes.default.number,
	
	  /**
	   * Custom separator node.
	   */
	  separator: _propTypes.default.node
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBreadcrumbs'
	})(Breadcrumbs);
	
	exports.default = _default;

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Breadcrumbs.default;
	  }
	});
	
	var _Breadcrumbs = _interopRequireDefault(__webpack_require__(820));

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _colorManipulator = __webpack_require__(49);
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(56));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.button, {
	      boxSizing: 'border-box',
	      minWidth: 64,
	      padding: '6px 16px',
	      borderRadius: theme.shape.borderRadius,
	      color: theme.palette.text.primary,
	      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
	        duration: theme.transitions.duration.short
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        },
	        '&$disabled': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    }),
	
	    /* Styles applied to the span element that wraps the children. */
	    label: {
	      width: '100%',
	      // Ensure the correct width for iOS Safari
	      display: 'inherit',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    },
	
	    /* Styles applied to the root element if `variant="text"`. */
	    text: {
	      padding: '6px 8px'
	    },
	
	    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
	    textPrimary: {
	      color: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
	    textSecondary: {
	      color: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      padding: '5px 15px',
	      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
	      '&$disabled': {
	        border: "1px solid ".concat(theme.palette.action.disabledBackground)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
	    outlinedPrimary: {
	      color: theme.palette.primary.main,
	      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.primary.main, 0.5)),
	      '&:hover': {
	        border: "1px solid ".concat(theme.palette.primary.main),
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
	    outlinedSecondary: {
	      color: theme.palette.secondary.main,
	      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.secondary.main, 0.5)),
	      '&:hover': {
	        border: "1px solid ".concat(theme.palette.secondary.main),
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        border: "1px solid ".concat(theme.palette.action.disabled)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="contained"`. */
	    contained: {
	      color: theme.palette.getContrastText(theme.palette.grey[300]),
	      backgroundColor: theme.palette.grey[300],
	      boxShadow: theme.shadows[2],
	      '&:hover': {
	        backgroundColor: theme.palette.grey.A100,
	        boxShadow: theme.shadows[4],
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          boxShadow: theme.shadows[2],
	          backgroundColor: theme.palette.grey[300]
	        },
	        '&$disabled': {
	          backgroundColor: theme.palette.action.disabledBackground
	        }
	      },
	      '&$focusVisible': {
	        boxShadow: theme.shadows[6]
	      },
	      '&:active': {
	        boxShadow: theme.shadows[8]
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled,
	        boxShadow: theme.shadows[0],
	        backgroundColor: theme.palette.action.disabledBackground
	      }
	    },
	
	    /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */
	    containedPrimary: {
	      color: theme.palette.primary.contrastText,
	      backgroundColor: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.primary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.primary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
	    containedSecondary: {
	      color: theme.palette.secondary.contrastText,
	      backgroundColor: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.secondary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.secondary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `disableElevation={true}`. */
	    disableElevation: {
	      boxShadow: 'none',
	      '&:hover': {
	        boxShadow: 'none'
	      },
	      '&$focusVisible': {
	        boxShadow: 'none'
	      },
	      '&:active': {
	        boxShadow: 'none'
	      },
	      '&$disabled': {
	        boxShadow: 'none'
	      }
	    },
	
	    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
	    focusVisible: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit',
	      borderColor: 'currentColor'
	    },
	
	    /* Styles applied to the root element if `size="small"` and `variant="text"`. */
	    textSizeSmall: {
	      padding: '4px 5px',
	      fontSize: theme.typography.pxToRem(13)
	    },
	
	    /* Styles applied to the root element if `size="large"` and `variant="text"`. */
	    textSizeLarge: {
	      padding: '8px 11px',
	      fontSize: theme.typography.pxToRem(15)
	    },
	
	    /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */
	    outlinedSizeSmall: {
	      padding: '3px 9px',
	      fontSize: theme.typography.pxToRem(13)
	    },
	
	    /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */
	    outlinedSizeLarge: {
	      padding: '7px 21px',
	      fontSize: theme.typography.pxToRem(15)
	    },
	
	    /* Styles applied to the root element if `size="small"` and `variant="contained"`. */
	    containedSizeSmall: {
	      padding: '4px 10px',
	      fontSize: theme.typography.pxToRem(13)
	    },
	
	    /* Styles applied to the root element if `size="large"` and `variant="contained"`. */
	    containedSizeLarge: {
	      padding: '8px 22px',
	      fontSize: theme.typography.pxToRem(15)
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {},
	
	    /* Styles applied to the root element if `size="large"`. */
	    sizeLarge: {},
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {
	      width: '100%'
	    },
	
	    /* Styles applied to the startIcon element if supplied. */
	    startIcon: {
	      display: 'inherit',
	      marginRight: 8,
	      marginLeft: -4,
	      '&$iconSizeSmall': {
	        marginLeft: -2
	      }
	    },
	
	    /* Styles applied to the endIcon element if supplied. */
	    endIcon: {
	      display: 'inherit',
	      marginRight: -4,
	      marginLeft: 8,
	      '&$iconSizeSmall': {
	        marginRight: -2
	      }
	    },
	
	    /* Styles applied to the icon element if supplied and `size="small"`. */
	    iconSizeSmall: {
	      '& > *:first-child': {
	        fontSize: 18
	      }
	    },
	
	    /* Styles applied to the icon element if supplied and `size="medium"`. */
	    iconSizeMedium: {
	      '& > *:first-child': {
	        fontSize: 20
	      }
	    },
	
	    /* Styles applied to the icon element if supplied and `size="large"`. */
	    iconSizeLarge: {
	      '& > *:first-child': {
	        fontSize: 22
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var Button = /*#__PURE__*/React.forwardRef(function Button(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'button' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableElevati = props.disableElevation,
	      disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      endIconProp = props.endIcon,
	      focusVisibleClassName = props.focusVisibleClassName,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      startIconProp = props.startIcon,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'button' : _props$type,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'text' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]);
	  var startIcon = startIconProp && /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.startIcon, classes["iconSize".concat((0, _capitalize.default)(size))])
	  }, startIconProp);
	  var endIcon = endIconProp && /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.endIcon, classes["iconSize".concat((0, _capitalize.default)(size))])
	  }, endIconProp);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat((0, _capitalize.default)(color))], size !== 'medium' && [classes["".concat(variant, "Size").concat((0, _capitalize.default)(size))], classes["size".concat((0, _capitalize.default)(size))]], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
	    component: component,
	    disabled: disabled,
	    focusRipple: !disableFocusRipple,
	    focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName),
	    ref: ref,
	    type: type
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.label
	  }, startIcon, children, endIcon));
	});
	 false ? Button.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the button.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, no elevation is used.
	   */
	  disableElevation: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   *
	   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
	   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * Element placed after the children.
	   */
	  endIcon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * If `true`, the button will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The URL to link to when the button is clicked.
	   * If defined, an `a` element will be used as the root node.
	   */
	  href: _propTypes.default.string,
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['large', 'medium', 'small']),
	
	  /**
	   * Element placed before the children.
	   */
	  startIcon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  type: _propTypes.default.oneOfType([_propTypes.default.oneOf(['button', 'reset', 'submit']), _propTypes.default.string]),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['contained', 'outlined', 'text'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButton'
	})(Button);
	
	exports.default = _default;

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(45));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(79));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _useIsFocusVisible2 = _interopRequireDefault(__webpack_require__(131));
	
	var _TouchRipple = _interopRequireDefault(__webpack_require__(825));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'inline-flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    position: 'relative',
	    WebkitTapHighlightColor: 'transparent',
	    backgroundColor: 'transparent',
	    // Reset default value
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0,
	    border: 0,
	    margin: 0,
	    // Remove the margin in Safari
	    borderRadius: 0,
	    padding: 0,
	    // Remove the padding in Firefox
	    cursor: 'pointer',
	    userSelect: 'none',
	    verticalAlign: 'middle',
	    '-moz-appearance': 'none',
	    // Reset
	    '-webkit-appearance': 'none',
	    // Reset
	    textDecoration: 'none',
	    // So we take precedent over the style of a native <a /> element.
	    color: 'inherit',
	    '&::-moz-focus-inner': {
	      borderStyle: 'none' // Remove Firefox dotted outline.
	
	    },
	    '&$disabled': {
	      pointerEvents: 'none',
	      // Disable link interactions
	      cursor: 'default'
	    },
	    '@media print': {
	      colorAdjust: 'exact'
	    }
	  },
	
	  /* Pseudo-class applied to the root element if `disabled={true}`. */
	  disabled: {},
	
	  /* Pseudo-class applied to the root element if keyboard focused. */
	  focusVisible: {}
	};
	/**
	 * `ButtonBase` contains as few styles as possible.
	 * It aims to be a simple building block for creating a button.
	 * It contains a load of style reset and some focus/ripple logic.
	 */
	
	exports.styles = styles;
	var ButtonBase = /*#__PURE__*/React.forwardRef(function ButtonBase(props, ref) {
	  var action = props.action,
	      buttonRefProp = props.buttonRef,
	      _props$centerRipple = props.centerRipple,
	      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'button' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableRipple = props.disableRipple,
	      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
	      _props$disableTouchRi = props.disableTouchRipple,
	      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
	      _props$focusRipple = props.focusRipple,
	      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
	      focusVisibleClassName = props.focusVisibleClassName,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onFocusVisible = props.onFocusVisible,
	      onKeyDown = props.onKeyDown,
	      onKeyUp = props.onKeyUp,
	      onMouseDown = props.onMouseDown,
	      onMouseLeave = props.onMouseLeave,
	      onMouseUp = props.onMouseUp,
	      onTouchEnd = props.onTouchEnd,
	      onTouchMove = props.onTouchMove,
	      onTouchStart = props.onTouchStart,
	      onDragLeave = props.onDragLeave,
	      _props$tabIndex = props.tabIndex,
	      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
	      TouchRippleProps = props.TouchRippleProps,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'button' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);
	  var buttonRef = React.useRef(null);
	
	  function getButtonNode() {
	    // #StrictMode ready
	    return ReactDOM.findDOMNode(buttonRef.current);
	  }
	
	  var rippleRef = React.useRef(null);
	
	  var _React$useState = React.useState(false),
	      focusVisible = _React$useState[0],
	      setFocusVisible = _React$useState[1];
	
	  if (disabled && focusVisible) {
	    setFocusVisible(false);
	  }
	
	  var _useIsFocusVisible = (0, _useIsFocusVisible2.default)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  React.useImperativeHandle(action, function () {
	    return {
	      focusVisible: function focusVisible() {
	        setFocusVisible(true);
	        buttonRef.current.focus();
	      }
	    };
	  }, []);
	  React.useEffect(function () {
	    if (focusVisible && focusRipple && !disableRipple) {
	      rippleRef.current.pulsate();
	    }
	  }, [disableRipple, focusRipple, focusVisible]);
	
	  function useRippleHandler(rippleAction, eventCallback) {
	    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
	    return (0, _useEventCallback.default)(function (event) {
	      if (eventCallback) {
	        eventCallback(event);
	      }
	
	      var ignore = skipRippleAction;
	
	      if (!ignore && rippleRef.current) {
	        rippleRef.current[rippleAction](event);
	      }
	
	      return true;
	    });
	  }
	
	  var handleMouseDown = useRippleHandler('start', onMouseDown);
	  var handleDragLeave = useRippleHandler('stop', onDragLeave);
	  var handleMouseUp = useRippleHandler('stop', onMouseUp);
	  var handleMouseLeave = useRippleHandler('stop', function (event) {
	    if (focusVisible) {
	      event.preventDefault();
	    }
	
	    if (onMouseLeave) {
	      onMouseLeave(event);
	    }
	  });
	  var handleTouchStart = useRippleHandler('start', onTouchStart);
	  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
	  var handleTouchMove = useRippleHandler('stop', onTouchMove);
	  var handleBlur = useRippleHandler('stop', function (event) {
	    if (focusVisible) {
	      onBlurVisible(event);
	      setFocusVisible(false);
	    }
	
	    if (onBlur) {
	      onBlur(event);
	    }
	  }, false);
	  var handleFocus = (0, _useEventCallback.default)(function (event) {
	    // Fix for https://github.com/facebook/react/issues/7769
	    if (!buttonRef.current) {
	      buttonRef.current = event.currentTarget;
	    }
	
	    if (isFocusVisible(event)) {
	      setFocusVisible(true);
	
	      if (onFocusVisible) {
	        onFocusVisible(event);
	      }
	    }
	
	    if (onFocus) {
	      onFocus(event);
	    }
	  });
	
	  var isNonNativeButton = function isNonNativeButton() {
	    var button = getButtonNode();
	    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
	  };
	  /**
	   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
	   */
	
	
	  var keydownRef = React.useRef(false);
	  var handleKeyDown = (0, _useEventCallback.default)(function (event) {
	    // Check if key is already down to avoid repeats being counted as multiple activations
	    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
	      keydownRef.current = true;
	      event.persist();
	      rippleRef.current.stop(event, function () {
	        rippleRef.current.start(event);
	      });
	    }
	
	    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
	      event.preventDefault();
	    }
	
	    if (onKeyDown) {
	      onKeyDown(event);
	    } // Keyboard accessibility for non interactive elements
	
	
	    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
	      event.preventDefault();
	
	      if (onClick) {
	        onClick(event);
	      }
	    }
	  });
	  var handleKeyUp = (0, _useEventCallback.default)(function (event) {
	    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
	    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
	    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
	      keydownRef.current = false;
	      event.persist();
	      rippleRef.current.stop(event, function () {
	        rippleRef.current.pulsate(event);
	      });
	    }
	
	    if (onKeyUp) {
	      onKeyUp(event);
	    } // Keyboard accessibility for non interactive elements
	
	
	    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
	      onClick(event);
	    }
	  });
	  var ComponentProp = component;
	
	  if (ComponentProp === 'button' && other.href) {
	    ComponentProp = 'a';
	  }
	
	  var buttonProps = {};
	
	  if (ComponentProp === 'button') {
	    buttonProps.type = type;
	    buttonProps.disabled = disabled;
	  } else {
	    if (ComponentProp !== 'a' || !other.href) {
	      buttonProps.role = 'button';
	    }
	
	    buttonProps['aria-disabled'] = disabled;
	  }
	
	  var handleUserRef = (0, _useForkRef.default)(buttonRefProp, ref);
	  var handleOwnRef = (0, _useForkRef.default)(focusVisibleRef, buttonRef);
	  var handleRef = (0, _useForkRef.default)(handleUserRef, handleOwnRef);
	
	  var _React$useState2 = React.useState(false),
	      mountedState = _React$useState2[0],
	      setMountedState = _React$useState2[1];
	
	  React.useEffect(function () {
	    setMountedState(true);
	  }, []);
	  var enableTouchRipple = mountedState && !disableRipple && !disabled;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useEffect(function () {
	      if (enableTouchRipple && !rippleRef.current) {
	        console.error(['Material-UI: The `component` prop provided to ButtonBase is invalid.', 'Please make sure the children prop is rendered in this custom component.'].join('\n'));
	      }
	    }, [enableTouchRipple]);
	  }
	
	  return /*#__PURE__*/React.createElement(ComponentProp, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
	    onBlur: handleBlur,
	    onClick: onClick,
	    onFocus: handleFocus,
	    onKeyDown: handleKeyDown,
	    onKeyUp: handleKeyUp,
	    onMouseDown: handleMouseDown,
	    onMouseLeave: handleMouseLeave,
	    onMouseUp: handleMouseUp,
	    onDragLeave: handleDragLeave,
	    onTouchEnd: handleTouchEnd,
	    onTouchMove: handleTouchMove,
	    onTouchStart: handleTouchStart,
	    ref: handleRef,
	    tabIndex: disabled ? -1 : tabIndex
	  }, buttonProps, other), children, enableTouchRipple ?
	  /*#__PURE__*/
	
	  /* TouchRipple is only needed client-side, x2 boost on the server. */
	  React.createElement(_TouchRipple.default, (0, _extends2.default)({
	    ref: rippleRef,
	    center: centerRipple
	  }, TouchRippleProps)) : null);
	});
	 false ? ButtonBase.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A ref for imperative actions.
	   * It currently only supports `focusVisible()` action.
	   */
	  action: _utils.refType,
	
	  /**
	   * @ignore
	   *
	   * Use that prop to pass a ref to the native button component.
	   * @deprecated Use `ref` instead.
	   */
	  buttonRef: _utils.refType,
	
	  /**
	   * If `true`, the ripples will be centered.
	   * They won't start at the cursor interaction position.
	   */
	  centerRipple: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _utils.elementTypeAcceptingRef,
	
	  /**
	   * If `true`, the base button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   *
	   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
	   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the touch ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the base button will have a keyboard focus ripple.
	   */
	  focusRipple: _propTypes.default.bool,
	
	  /**
	   * This prop can help a person know which element has the keyboard focus.
	   * The class name will be applied when the element gain the focus through a keyboard interaction.
	   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
	   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
	   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
	   * if needed.
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  href: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onDragLeave: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is focused with a keyboard.
	   * We trigger a `onFocus` callback too.
	   */
	  onFocusVisible: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchEnd: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchMove: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchStart: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Props applied to the `TouchRipple` element.
	   */
	  TouchRippleProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  type: _propTypes.default.oneOfType([_propTypes.default.oneOf(['button', 'reset', 'submit']), _propTypes.default.string])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButtonBase'
	})(ButtonBase);
	
	exports.default = _default;

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(79));
	
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	/**
	 * @ignore - internal component.
	 */
	
	function Ripple(props) {
	  var classes = props.classes,
	      _props$pulsate = props.pulsate,
	      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
	      rippleX = props.rippleX,
	      rippleY = props.rippleY,
	      rippleSize = props.rippleSize,
	      inProp = props.in,
	      _props$onExited = props.onExited,
	      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
	      timeout = props.timeout;
	
	  var _React$useState = React.useState(false),
	      leaving = _React$useState[0],
	      setLeaving = _React$useState[1];
	
	  var rippleClassName = (0, _clsx.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
	  var rippleStyles = {
	    width: rippleSize,
	    height: rippleSize,
	    top: -(rippleSize / 2) + rippleY,
	    left: -(rippleSize / 2) + rippleX
	  };
	  var childClassName = (0, _clsx.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
	  var handleExited = (0, _useEventCallback.default)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
	
	  useEnhancedEffect(function () {
	    if (!inProp) {
	      // react-transition-group#onExit
	      setLeaving(true); // react-transition-group#onExited
	
	      var timeoutId = setTimeout(handleExited, timeout);
	      return function () {
	        clearTimeout(timeoutId);
	      };
	    }
	
	    return undefined;
	  }, [handleExited, inProp, timeout]);
	  return /*#__PURE__*/React.createElement("span", {
	    className: rippleClassName,
	    style: rippleStyles
	  }, /*#__PURE__*/React.createElement("span", {
	    className: childClassName
	  }));
	}
	
	 false ? Ripple.propTypes = {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore - injected from TransitionGroup
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore - injected from TransitionGroup
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
	   */
	  pulsate: _propTypes.default.bool,
	
	  /**
	   * Diameter of the ripple.
	   */
	  rippleSize: _propTypes.default.number,
	
	  /**
	   * Horizontal position of the ripple center.
	   */
	  rippleX: _propTypes.default.number,
	
	  /**
	   * Vertical position of the ripple center.
	   */
	  rippleY: _propTypes.default.number,
	
	  /**
	   * exit delay
	   */
	  timeout: _propTypes.default.number.isRequired
	} : void 0;
	var _default = Ripple;
	exports.default = _default;

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = exports.DELAY_RIPPLE = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(46));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _reactTransitionGroup = __webpack_require__(123);
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Ripple = _interopRequireDefault(__webpack_require__(824));
	
	var DURATION = 550;
	var DELAY_RIPPLE = 80;
	exports.DELAY_RIPPLE = DELAY_RIPPLE;
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      overflow: 'hidden',
	      pointerEvents: 'none',
	      position: 'absolute',
	      zIndex: 0,
	      top: 0,
	      right: 0,
	      bottom: 0,
	      left: 0,
	      borderRadius: 'inherit'
	    },
	
	    /* Styles applied to the internal `Ripple` components `ripple` class. */
	    ripple: {
	      opacity: 0,
	      position: 'absolute'
	    },
	
	    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
	    rippleVisible: {
	      opacity: 0.3,
	      transform: 'scale(1)',
	      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
	    },
	
	    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
	    ripplePulsate: {
	      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
	    },
	
	    /* Styles applied to the internal `Ripple` components `child` class. */
	    child: {
	      opacity: 1,
	      display: 'block',
	      width: '100%',
	      height: '100%',
	      borderRadius: '50%',
	      backgroundColor: 'currentColor'
	    },
	
	    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
	    childLeaving: {
	      opacity: 0,
	      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
	    },
	
	    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
	    childPulsate: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
	    },
	    '@keyframes enter': {
	      '0%': {
	        transform: 'scale(0)',
	        opacity: 0.1
	      },
	      '100%': {
	        transform: 'scale(1)',
	        opacity: 0.3
	      }
	    },
	    '@keyframes exit': {
	      '0%': {
	        opacity: 1
	      },
	      '100%': {
	        opacity: 0
	      }
	    },
	    '@keyframes pulsate': {
	      '0%': {
	        transform: 'scale(1)'
	      },
	      '50%': {
	        transform: 'scale(0.92)'
	      },
	      '100%': {
	        transform: 'scale(1)'
	      }
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 *
	 * TODO v5: Make private
	 */
	
	
	exports.styles = styles;
	var TouchRipple = /*#__PURE__*/React.forwardRef(function TouchRipple(props, ref) {
	  var _props$center = props.center,
	      centerProp = _props$center === void 0 ? false : _props$center,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["center", "classes", "className"]);
	
	  var _React$useState = React.useState([]),
	      ripples = _React$useState[0],
	      setRipples = _React$useState[1];
	
	  var nextKey = React.useRef(0);
	  var rippleCallback = React.useRef(null);
	  React.useEffect(function () {
	    if (rippleCallback.current) {
	      rippleCallback.current();
	      rippleCallback.current = null;
	    }
	  }, [ripples]); // Used to filter out mouse emulated events on mobile.
	
	  var ignoringMouseDown = React.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
	  // We don't want to display the ripple for touch scroll events.
	
	  var startTimer = React.useRef(null); // This is the hook called once the previous timeout is ready.
	
	  var startTimerCommit = React.useRef(null);
	  var container = React.useRef(null);
	  React.useEffect(function () {
	    return function () {
	      clearTimeout(startTimer.current);
	    };
	  }, []);
	  var startCommit = React.useCallback(function (params) {
	    var pulsate = params.pulsate,
	        rippleX = params.rippleX,
	        rippleY = params.rippleY,
	        rippleSize = params.rippleSize,
	        cb = params.cb;
	    setRipples(function (oldRipples) {
	      return [].concat((0, _toConsumableArray2.default)(oldRipples), [/*#__PURE__*/React.createElement(_Ripple.default, {
	        key: nextKey.current,
	        classes: classes,
	        timeout: DURATION,
	        pulsate: pulsate,
	        rippleX: rippleX,
	        rippleY: rippleY,
	        rippleSize: rippleSize
	      })]);
	    });
	    nextKey.current += 1;
	    rippleCallback.current = cb;
	  }, [classes]);
	  var start = React.useCallback(function () {
	    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var cb = arguments.length > 2 ? arguments[2] : undefined;
	    var _options$pulsate = options.pulsate,
	        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
	        _options$center = options.center,
	        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
	        _options$fakeElement = options.fakeElement,
	        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
	
	    if (event.type === 'mousedown' && ignoringMouseDown.current) {
	      ignoringMouseDown.current = false;
	      return;
	    }
	
	    if (event.type === 'touchstart') {
	      ignoringMouseDown.current = true;
	    }
	
	    var element = fakeElement ? null : container.current;
	    var rect = element ? element.getBoundingClientRect() : {
	      width: 0,
	      height: 0,
	      left: 0,
	      top: 0
	    }; // Get the size of the ripple
	
	    var rippleX;
	    var rippleY;
	    var rippleSize;
	
	    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
	      rippleX = Math.round(rect.width / 2);
	      rippleY = Math.round(rect.height / 2);
	    } else {
	      var _ref = event.touches ? event.touches[0] : event,
	          clientX = _ref.clientX,
	          clientY = _ref.clientY;
	
	      rippleX = Math.round(clientX - rect.left);
	      rippleY = Math.round(clientY - rect.top);
	    }
	
	    if (center) {
	      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
	
	      if (rippleSize % 2 === 0) {
	        rippleSize += 1;
	      }
	    } else {
	      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
	      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
	      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
	    } // Touche devices
	
	
	    if (event.touches) {
	      // check that this isn't another touchstart due to multitouch
	      // otherwise we will only clear a single timer when unmounting while two
	      // are running
	      if (startTimerCommit.current === null) {
	        // Prepare the ripple effect.
	        startTimerCommit.current = function () {
	          startCommit({
	            pulsate: pulsate,
	            rippleX: rippleX,
	            rippleY: rippleY,
	            rippleSize: rippleSize,
	            cb: cb
	          });
	        }; // Delay the execution of the ripple effect.
	
	
	        startTimer.current = setTimeout(function () {
	          if (startTimerCommit.current) {
	            startTimerCommit.current();
	            startTimerCommit.current = null;
	          }
	        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
	      }
	    } else {
	      startCommit({
	        pulsate: pulsate,
	        rippleX: rippleX,
	        rippleY: rippleY,
	        rippleSize: rippleSize,
	        cb: cb
	      });
	    }
	  }, [centerProp, startCommit]);
	  var pulsate = React.useCallback(function () {
	    start({}, {
	      pulsate: true
	    });
	  }, [start]);
	  var stop = React.useCallback(function (event, cb) {
	    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
	    // We still want to show ripple effect.
	
	    if (event.type === 'touchend' && startTimerCommit.current) {
	      event.persist();
	      startTimerCommit.current();
	      startTimerCommit.current = null;
	      startTimer.current = setTimeout(function () {
	        stop(event, cb);
	      });
	      return;
	    }
	
	    startTimerCommit.current = null;
	    setRipples(function (oldRipples) {
	      if (oldRipples.length > 0) {
	        return oldRipples.slice(1);
	      }
	
	      return oldRipples;
	    });
	    rippleCallback.current = cb;
	  }, []);
	  React.useImperativeHandle(ref, function () {
	    return {
	      pulsate: pulsate,
	      start: start,
	      stop: stop
	    };
	  }, [pulsate, start, stop]);
	  return /*#__PURE__*/React.createElement("span", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: container
	  }, other), /*#__PURE__*/React.createElement(_reactTransitionGroup.TransitionGroup, {
	    component: null,
	    exit: true
	  }, ripples));
	});
	 false ? TouchRipple.propTypes = {
	  /**
	   * If `true`, the ripple starts at the center of the component
	   * rather than at the point of interaction.
	   */
	  center: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  flip: false,
	  name: 'MuiTouchRipple'
	})( /*#__PURE__*/React.memo(TouchRipple));
	
	exports.default = _default;

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(67);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _colorManipulator = __webpack_require__(49);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Button = _interopRequireDefault(__webpack_require__(349));
	
	// Force a side effect so we don't have any override priority issue.
	// eslint-disable-next-line no-unused-expressions
	_Button.default.styles;
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-flex',
	      borderRadius: theme.shape.borderRadius
	    },
	
	    /* Styles applied to the root element if `variant="contained"`. */
	    contained: {
	      boxShadow: theme.shadows[2]
	    },
	
	    /* Styles applied to the root element if `disableElevation={true}`. */
	    disableElevation: {
	      boxShadow: 'none'
	    },
	
	    /* Pseudo-class applied to child elements if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {
	      width: '100%'
	    },
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the children. */
	    grouped: {
	      minWidth: 40
	    },
	
	    /* Styles applied to the children if `orientation="horizontal"`. */
	    groupedHorizontal: {
	      '&:not(:first-child)': {
	        borderTopLeftRadius: 0,
	        borderBottomLeftRadius: 0
	      },
	      '&:not(:last-child)': {
	        borderTopRightRadius: 0,
	        borderBottomRightRadius: 0
	      }
	    },
	
	    /* Styles applied to the children if `orientation="vertical"`. */
	    groupedVertical: {
	      '&:not(:first-child)': {
	        borderTopRightRadius: 0,
	        borderTopLeftRadius: 0
	      },
	      '&:not(:last-child)': {
	        borderBottomRightRadius: 0,
	        borderBottomLeftRadius: 0
	      }
	    },
	
	    /* Styles applied to the children if `variant="text"`. */
	    groupedText: {},
	
	    /* Styles applied to the children if `variant="text"` and `orientation="horizontal"`. */
	    groupedTextHorizontal: {
	      '&:not(:last-child)': {
	        borderRight: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
	      }
	    },
	
	    /* Styles applied to the children if `variant="text"` and `orientation="vertical"`. */
	    groupedTextVertical: {
	      '&:not(:last-child)': {
	        borderBottom: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
	      }
	    },
	
	    /* Styles applied to the children if `variant="text"` and `color="primary"`. */
	    groupedTextPrimary: {
	      '&:not(:last-child)': {
	        borderColor: (0, _colorManipulator.fade)(theme.palette.primary.main, 0.5)
	      }
	    },
	
	    /* Styles applied to the children if `variant="text"` and `color="secondary"`. */
	    groupedTextSecondary: {
	      '&:not(:last-child)': {
	        borderColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, 0.5)
	      }
	    },
	
	    /* Styles applied to the children if `variant="outlined"`. */
	    groupedOutlined: {},
	
	    /* Styles applied to the children if `variant="outlined"` and `orientation="horizontal"`. */
	    groupedOutlinedHorizontal: {
	      '&:not(:first-child)': {
	        marginLeft: -1
	      },
	      '&:not(:last-child)': {
	        borderRightColor: 'transparent'
	      }
	    },
	
	    /* Styles applied to the children if `variant="outlined"` and `orientation="vertical"`. */
	    groupedOutlinedVertical: {
	      '&:not(:first-child)': {
	        marginTop: -1
	      },
	      '&:not(:last-child)': {
	        borderBottomColor: 'transparent'
	      }
	    },
	
	    /* Styles applied to the children if `variant="outlined"` and `color="primary"`. */
	    groupedOutlinedPrimary: {
	      '&:hover': {
	        borderColor: theme.palette.primary.main
	      }
	    },
	
	    /* Styles applied to the children if `variant="outlined"` and `color="secondary"`. */
	    groupedOutlinedSecondary: {
	      '&:hover': {
	        borderColor: theme.palette.secondary.main
	      }
	    },
	
	    /* Styles applied to the children if `variant="contained"`. */
	    groupedContained: {
	      boxShadow: 'none'
	    },
	
	    /* Styles applied to the children if `variant="contained"` and `orientation="horizontal"`. */
	    groupedContainedHorizontal: {
	      '&:not(:last-child)': {
	        borderRight: "1px solid ".concat(theme.palette.grey[400]),
	        '&$disabled': {
	          borderRight: "1px solid ".concat(theme.palette.action.disabled)
	        }
	      }
	    },
	
	    /* Styles applied to the children if `variant="contained"` and `orientation="vertical"`. */
	    groupedContainedVertical: {
	      '&:not(:last-child)': {
	        borderBottom: "1px solid ".concat(theme.palette.grey[400]),
	        '&$disabled': {
	          borderBottom: "1px solid ".concat(theme.palette.action.disabled)
	        }
	      }
	    },
	
	    /* Styles applied to the children if `variant="contained"` and `color="primary"`. */
	    groupedContainedPrimary: {
	      '&:not(:last-child)': {
	        borderColor: theme.palette.primary.dark
	      }
	    },
	
	    /* Styles applied to the children if `variant="contained"` and `color="secondary"`. */
	    groupedContainedSecondary: {
	      '&:not(:last-child)': {
	        borderColor: theme.palette.secondary.dark
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var ButtonGroup = /*#__PURE__*/React.forwardRef(function ButtonGroup(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableElevati = props.disableElevation,
	      disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      _props$disableRipple = props.disableRipple,
	      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'outlined' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "disableRipple", "fullWidth", "orientation", "size", "variant"]);
	  var buttonClassName = (0, _clsx.default)(classes.grouped, classes["grouped".concat((0, _capitalize.default)(orientation))], classes["grouped".concat((0, _capitalize.default)(variant))], classes["grouped".concat((0, _capitalize.default)(variant)).concat((0, _capitalize.default)(orientation))], classes["grouped".concat((0, _capitalize.default)(variant)).concat(color !== 'default' ? (0, _capitalize.default)(color) : '')], disabled && classes.disabled);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    role: "group",
	    className: (0, _clsx.default)(classes.root, className, fullWidth && classes.fullWidth, disableElevation && classes.disableElevation, variant === 'contained' && classes.contained, orientation === 'vertical' && classes.vertical),
	    ref: ref
	  }, other), React.Children.map(children, function (child) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The ButtonGroup component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    return /*#__PURE__*/React.cloneElement(child, {
	      className: (0, _clsx.default)(buttonClassName, child.props.className),
	      color: child.props.color || color,
	      disabled: child.props.disabled || disabled,
	      disableElevation: child.props.disableElevation || disableElevation,
	      disableFocusRipple: disableFocusRipple,
	      disableRipple: disableRipple,
	      fullWidth: fullWidth,
	      size: child.props.size || size,
	      variant: child.props.variant || variant
	    });
	  }));
	});
	 false ? ButtonGroup.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the button group.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the buttons will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, no elevation is used.
	   */
	  disableElevation: _propTypes.default.bool,
	
	  /**
	   * If `true`, the button keyboard focus ripple will be disabled.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the button ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the buttons will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The group orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['large', 'medium', 'small']),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['contained', 'outlined', 'text'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButtonGroup'
	})(ButtonGroup);
	
	exports.default = _default;

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonGroup.default;
	  }
	});
	
	var _ButtonGroup = _interopRequireDefault(__webpack_require__(826));

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _Paper = _interopRequireDefault(__webpack_require__(65));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    overflow: 'hidden'
	  }
	};
	exports.styles = styles;
	var Card = /*#__PURE__*/React.forwardRef(function Card(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$raised = props.raised,
	      raised = _props$raised === void 0 ? false : _props$raised,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "raised"]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    elevation: raised ? 8 : 1,
	    ref: ref
	  }, other));
	});
	 false ? Card.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the card will use raised styling.
	   */
	  raised: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCard'
	})(Card);
	
	exports.default = _default;

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Card.default;
	  }
	});
	
	var _Card = _interopRequireDefault(__webpack_require__(828));

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(56));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      textAlign: 'inherit',
	      width: '100%',
	      '&:hover $focusHighlight': {
	        opacity: theme.palette.action.hoverOpacity
	      },
	      '&$focusVisible $focusHighlight': {
	        opacity: 0.12
	      }
	    },
	
	    /* Pseudo-class applied to the ButtonBase root element if the action area is keyboard focused. */
	    focusVisible: {},
	
	    /* Styles applied to the overlay that covers the action area when it is keyboard focused. */
	    focusHighlight: {
	      overflow: 'hidden',
	      pointerEvents: 'none',
	      position: 'absolute',
	      top: 0,
	      right: 0,
	      bottom: 0,
	      left: 0,
	      borderRadius: 'inherit',
	      opacity: 0,
	      backgroundColor: 'currentcolor',
	      transition: theme.transitions.create('opacity', {
	        duration: theme.transitions.duration.short
	      })
	    }
	  };
	};
	
	exports.styles = styles;
	var CardActionArea = /*#__PURE__*/React.forwardRef(function CardActionArea(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      focusVisibleClassName = props.focusVisibleClassName,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "focusVisibleClassName"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    focusVisibleClassName: (0, _clsx.default)(focusVisibleClassName, classes.focusVisible),
	    ref: ref
	  }, other), children, /*#__PURE__*/React.createElement("span", {
	    className: classes.focusHighlight
	  }));
	});
	 false ? CardActionArea.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardActionArea'
	})(CardActionArea);
	
	exports.default = _default;

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardActionArea.default;
	  }
	});
	
	var _CardActionArea = _interopRequireDefault(__webpack_require__(830));

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 8
	  },
	
	  /* Styles applied to the root element if `disableSpacing={false}`. */
	  spacing: {
	    '& > :not(:first-child)': {
	      marginLeft: 8
	    }
	  }
	};
	exports.styles = styles;
	var CardActions = /*#__PURE__*/React.forwardRef(function CardActions(props, ref) {
	  var _props$disableSpacing = props.disableSpacing,
	      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableSpacing", "classes", "className"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, !disableSpacing && classes.spacing),
	    ref: ref
	  }, other));
	});
	 false ? CardActions.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the actions do not have additional margin.
	   */
	  disableSpacing: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardActions'
	})(CardActions);
	
	exports.default = _default;

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardActions.default;
	  }
	});
	
	var _CardActions = _interopRequireDefault(__webpack_require__(832));

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    padding: 16,
	    '&:last-child': {
	      paddingBottom: 24
	    }
	  }
	};
	exports.styles = styles;
	var CardContent = /*#__PURE__*/React.forwardRef(function CardContent(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other));
	});
	 false ? CardContent.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardContent'
	})(CardContent);
	
	exports.default = _default;

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardContent.default;
	  }
	});
	
	var _CardContent = _interopRequireDefault(__webpack_require__(834));

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Typography = _interopRequireDefault(__webpack_require__(66));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 16
	  },
	
	  /* Styles applied to the avatar element. */
	  avatar: {
	    flex: '0 0 auto',
	    marginRight: 16
	  },
	
	  /* Styles applied to the action element. */
	  action: {
	    flex: '0 0 auto',
	    alignSelf: 'flex-start',
	    marginTop: -8,
	    marginRight: -8
	  },
	
	  /* Styles applied to the content wrapper element. */
	  content: {
	    flex: '1 1 auto'
	  },
	
	  /* Styles applied to the title Typography element. */
	  title: {},
	
	  /* Styles applied to the subheader Typography element. */
	  subheader: {}
	};
	exports.styles = styles;
	var CardHeader = /*#__PURE__*/React.forwardRef(function CardHeader(props, ref) {
	  var action = props.action,
	      avatar = props.avatar,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      subheaderProp = props.subheader,
	      subheaderTypographyProps = props.subheaderTypographyProps,
	      titleProp = props.title,
	      titleTypographyProps = props.titleTypographyProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "avatar", "classes", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"]);
	  var title = titleProp;
	
	  if (title != null && title.type !== _Typography.default && !disableTypography) {
	    title = /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	      variant: avatar ? 'body2' : 'h5',
	      className: classes.title,
	      component: "span",
	      display: "block"
	    }, titleTypographyProps), title);
	  }
	
	  var subheader = subheaderProp;
	
	  if (subheader != null && subheader.type !== _Typography.default && !disableTypography) {
	    subheader = /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	      variant: avatar ? 'body2' : 'body1',
	      className: classes.subheader,
	      color: "textSecondary",
	      component: "span",
	      display: "block"
	    }, subheaderTypographyProps), subheader);
	  }
	
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), avatar && /*#__PURE__*/React.createElement("div", {
	    className: classes.avatar
	  }, avatar), /*#__PURE__*/React.createElement("div", {
	    className: classes.content
	  }, title, subheader), action && /*#__PURE__*/React.createElement("div", {
	    className: classes.action
	  }, action));
	});
	 false ? CardHeader.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The action to display in the card header.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * The Avatar for the Card Header.
	   */
	  avatar: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
	   * This can be useful to render an alternative Typography variant by wrapping
	   * the `title` text, and optional `subheader` text
	   * with the Typography component.
	   */
	  disableTypography: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  subheader: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the subheader
	   * (as long as disableTypography is not `true`).
	   */
	  subheaderTypographyProps: _propTypes.default.object,
	
	  /**
	   * The content of the Card Title.
	   */
	  title: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the title
	   * (as long as disableTypography is not `true`).
	   */
	  titleTypographyProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardHeader'
	})(CardHeader);
	
	exports.default = _default;

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardHeader.default;
	  }
	});
	
	var _CardHeader = _interopRequireDefault(__webpack_require__(836));

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _utils = __webpack_require__(22);
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'block',
	    backgroundSize: 'cover',
	    backgroundRepeat: 'no-repeat',
	    backgroundPosition: 'center'
	  },
	
	  /* Styles applied to the root element if `component="video, audio, picture, iframe, or img"`. */
	  media: {
	    width: '100%'
	  },
	
	  /* Styles applied to the root element if `component="picture or img"`. */
	  img: {
	    // ⚠️ object-fit is not supported by IE 11.
	    objectFit: 'cover'
	  }
	};
	exports.styles = styles;
	var MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];
	var CardMedia = /*#__PURE__*/React.forwardRef(function CardMedia(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      image = props.image,
	      src = props.src,
	      style = props.style,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "image", "src", "style"]);
	  var isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;
	  var composedStyle = !isMediaComponent && image ? (0, _extends2.default)({
	    backgroundImage: "url(\"".concat(image, "\")")
	  }, style) : style;
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, isMediaComponent && classes.media, "picture img".indexOf(Component) !== -1 && classes.img),
	    ref: ref,
	    style: composedStyle,
	    src: isMediaComponent ? image || src : undefined
	  }, other), children);
	});
	 false ? CardMedia.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node, function (props) {
	    if (!props.children && !props.image && !props.src && !props.component) {
	      return new Error('Material-UI: Either `children`, `image`, `src` or `component` prop must be specified.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Image to be displayed as a background image.
	   * Either `image` or `src` prop must be specified.
	   * Note that caller must specify height otherwise the image will not be visible.
	   */
	  image: _propTypes.default.string,
	
	  /**
	   * An alias for `image` property.
	   * Available only with media components.
	   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
	   */
	  src: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardMedia'
	})(CardMedia);
	
	exports.default = _default;

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardMedia.default;
	  }
	});
	
	var _CardMedia = _interopRequireDefault(__webpack_require__(838));

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _SwitchBase = _interopRequireDefault(__webpack_require__(238));
	
	var _CheckBoxOutlineBlank = _interopRequireDefault(__webpack_require__(1018));
	
	var _CheckBox = _interopRequireDefault(__webpack_require__(1017));
	
	var _colorManipulator = __webpack_require__(49);
	
	var _IndeterminateCheckBox = _interopRequireDefault(__webpack_require__(1020));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: theme.palette.text.secondary
	    },
	
	    /* Pseudo-class applied to the root element if `checked={true}`. */
	    checked: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Pseudo-class applied to the root element if `indeterminate={true}`. */
	    indeterminate: {},
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      '&$checked': {
	        color: theme.palette.primary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      '&$checked': {
	        color: theme.palette.secondary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultCheckedIcon = /*#__PURE__*/React.createElement(_CheckBox.default, null);
	var defaultIcon = /*#__PURE__*/React.createElement(_CheckBoxOutlineBlank.default, null);
	var defaultIndeterminateIcon = /*#__PURE__*/React.createElement(_IndeterminateCheckBox.default, null);
	var Checkbox = /*#__PURE__*/React.forwardRef(function Checkbox(props, ref) {
	  var _props$checkedIcon = props.checkedIcon,
	      checkedIcon = _props$checkedIcon === void 0 ? defaultCheckedIcon : _props$checkedIcon,
	      classes = props.classes,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'secondary' : _props$color,
	      _props$icon = props.icon,
	      iconProp = _props$icon === void 0 ? defaultIcon : _props$icon,
	      _props$indeterminate = props.indeterminate,
	      indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate,
	      _props$indeterminateI = props.indeterminateIcon,
	      indeterminateIconProp = _props$indeterminateI === void 0 ? defaultIndeterminateIcon : _props$indeterminateI,
	      inputProps = props.inputProps,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      other = (0, _objectWithoutProperties2.default)(props, ["checkedIcon", "classes", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size"]);
	  var icon = indeterminate ? indeterminateIconProp : iconProp;
	  var indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
	  return /*#__PURE__*/React.createElement(_SwitchBase.default, (0, _extends2.default)({
	    type: "checkbox",
	    classes: {
	      root: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(color))], indeterminate && classes.indeterminate),
	      checked: classes.checked,
	      disabled: classes.disabled
	    },
	    color: color,
	    inputProps: (0, _extends2.default)({
	      'data-indeterminate': indeterminate
	    }, inputProps),
	    icon: /*#__PURE__*/React.cloneElement(icon, {
	      fontSize: icon.props.fontSize === undefined && size === "small" ? size : icon.props.fontSize
	    }),
	    checkedIcon: /*#__PURE__*/React.cloneElement(indeterminateIcon, {
	      fontSize: indeterminateIcon.props.fontSize === undefined && size === "small" ? size : indeterminateIcon.props.fontSize
	    }),
	    ref: ref
	  }, other));
	});
	 false ? Checkbox.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the checkbox will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * If `true`, the component appears indeterminate.
	   * This does not set the native input element to indeterminate due
	   * to inconsistent behavior across browsers.
	   * However, we set a `data-indeterminate` attribute on the input.
	   */
	  indeterminate: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is indeterminate.
	   */
	  indeterminateIcon: _propTypes.default.node,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The size of the checkbox.
	   * `small` is equivalent to the dense checkbox styling.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The value of the component. The DOM API casts this to a string.
	   * The browser uses "on" as the default value.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCheckbox'
	})(Checkbox);
	
	exports.default = _default;

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Checkbox.default;
	  }
	});
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(840));

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _Cancel = _interopRequireDefault(__webpack_require__(1016));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _colorManipulator = __webpack_require__(49);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(170));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(56));
	
	var styles = function styles(theme) {
	  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
	  var deleteIconColor = (0, _colorManipulator.fade)(theme.palette.text.primary, 0.26);
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(13),
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      height: 32,
	      color: theme.palette.getContrastText(backgroundColor),
	      backgroundColor: backgroundColor,
	      borderRadius: 32 / 2,
	      whiteSpace: 'nowrap',
	      transition: theme.transitions.create(['background-color', 'box-shadow']),
	      // label will inherit this from root, then `clickable` class overrides this for both
	      cursor: 'default',
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 0,
	      textDecoration: 'none',
	      border: 'none',
	      // Remove `button` border
	      padding: 0,
	      // Remove `button` padding
	      verticalAlign: 'middle',
	      boxSizing: 'border-box',
	      '&$disabled': {
	        opacity: 0.5,
	        pointerEvents: 'none'
	      },
	      '& $avatar': {
	        marginLeft: 5,
	        marginRight: -6,
	        width: 24,
	        height: 24,
	        color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
	        fontSize: theme.typography.pxToRem(12)
	      },
	      '& $avatarColorPrimary': {
	        color: theme.palette.primary.contrastText,
	        backgroundColor: theme.palette.primary.dark
	      },
	      '& $avatarColorSecondary': {
	        color: theme.palette.secondary.contrastText,
	        backgroundColor: theme.palette.secondary.dark
	      },
	      '& $avatarSmall': {
	        marginLeft: 4,
	        marginRight: -4,
	        width: 18,
	        height: 18,
	        fontSize: theme.typography.pxToRem(10)
	      }
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      height: 24
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    },
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */
	    clickable: {
	      userSelect: 'none',
	      WebkitTapHighlightColor: 'transparent',
	      cursor: 'pointer',
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
	      },
	      '&:active': {
	        boxShadow: theme.shadows[1]
	      }
	    },
	
	    /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */
	    clickableColorPrimary: {
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.primary.main, 0.08)
	      }
	    },
	
	    /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */
	    clickableColorSecondary: {
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.secondary.main, 0.08)
	      }
	    },
	
	    /* Styles applied to the root element if `onDelete` is defined. */
	    deletable: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
	      }
	    },
	
	    /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */
	    deletableColorPrimary: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.primary.main, 0.2)
	      }
	    },
	
	    /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */
	    deletableColorSecondary: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.secondary.main, 0.2)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      backgroundColor: 'transparent',
	      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
	      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
	      },
	      '& $avatar': {
	        marginLeft: 4
	      },
	      '& $avatarSmall': {
	        marginLeft: 2
	      },
	      '& $icon': {
	        marginLeft: 4
	      },
	      '& $iconSmall': {
	        marginLeft: 2
	      },
	      '& $deleteIcon': {
	        marginRight: 5
	      },
	      '& $deleteIconSmall': {
	        marginRight: 3
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
	    outlinedPrimary: {
	      color: theme.palette.primary.main,
	      border: "1px solid ".concat(theme.palette.primary.main),
	      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
	    outlinedSecondary: {
	      color: theme.palette.secondary.main,
	      border: "1px solid ".concat(theme.palette.secondary.main),
	      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
	      }
	    },
	    // TODO v5: remove
	
	    /* Styles applied to the `avatar` element. */
	    avatar: {},
	
	    /* Styles applied to the `avatar` element if `size="small"`. */
	    avatarSmall: {},
	
	    /* Styles applied to the `avatar` element if `color="primary"`. */
	    avatarColorPrimary: {},
	
	    /* Styles applied to the `avatar` element if `color="secondary"`. */
	    avatarColorSecondary: {},
	
	    /* Styles applied to the `icon` element. */
	    icon: {
	      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
	      marginLeft: 5,
	      marginRight: -6
	    },
	
	    /* Styles applied to the `icon` element if `size="small"`. */
	    iconSmall: {
	      width: 18,
	      height: 18,
	      marginLeft: 4,
	      marginRight: -4
	    },
	
	    /* Styles applied to the `icon` element if `color="primary"`. */
	    iconColorPrimary: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the `icon` element if `color="secondary"`. */
	    iconColorSecondary: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the label `span` element. */
	    label: {
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      paddingLeft: 12,
	      paddingRight: 12,
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the label `span` element if `size="small"`. */
	    labelSmall: {
	      paddingLeft: 8,
	      paddingRight: 8
	    },
	
	    /* Styles applied to the `deleteIcon` element. */
	    deleteIcon: {
	      WebkitTapHighlightColor: 'transparent',
	      color: deleteIconColor,
	      height: 22,
	      width: 22,
	      cursor: 'pointer',
	      margin: '0 5px 0 -6px',
	      '&:hover': {
	        color: (0, _colorManipulator.fade)(deleteIconColor, 0.4)
	      }
	    },
	
	    /* Styles applied to the `deleteIcon` element if `size="small"`. */
	    deleteIconSmall: {
	      height: 16,
	      width: 16,
	      marginRight: 4,
	      marginLeft: -4
	    },
	
	    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */
	    deleteIconColorPrimary: {
	      color: (0, _colorManipulator.fade)(theme.palette.primary.contrastText, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.primary.contrastText
	      }
	    },
	
	    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */
	    deleteIconColorSecondary: {
	      color: (0, _colorManipulator.fade)(theme.palette.secondary.contrastText, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.secondary.contrastText
	      }
	    },
	
	    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */
	    deleteIconOutlinedColorPrimary: {
	      color: (0, _colorManipulator.fade)(theme.palette.primary.main, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.primary.main
	      }
	    },
	
	    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */
	    deleteIconOutlinedColorSecondary: {
	      color: (0, _colorManipulator.fade)(theme.palette.secondary.main, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.secondary.main
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	function isDeleteKeyboardEvent(keyboardEvent) {
	  return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
	}
	/**
	 * Chips represent complex entities in small blocks, such as a contact.
	 */
	
	
	var Chip = /*#__PURE__*/React.forwardRef(function Chip(props, ref) {
	  var avatarProp = props.avatar,
	      classes = props.classes,
	      className = props.className,
	      clickableProp = props.clickable,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      ComponentProp = props.component,
	      deleteIconProp = props.deleteIcon,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      iconProp = props.icon,
	      label = props.label,
	      onClick = props.onClick,
	      onDelete = props.onDelete,
	      onKeyDown = props.onKeyDown,
	      onKeyUp = props.onKeyUp,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'default' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["avatar", "classes", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant"]);
	  var chipRef = React.useRef(null);
	  var handleRef = (0, _useForkRef.default)(chipRef, ref);
	
	  var handleDeleteIconClick = function handleDeleteIconClick(event) {
	    // Stop the event from bubbling up to the `Chip`
	    event.stopPropagation();
	
	    if (onDelete) {
	      onDelete(event);
	    }
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    // Ignore events from children of `Chip`.
	    if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
	      // will be handled in keyUp, otherwise some browsers
	      // might init navigation
	      event.preventDefault();
	    }
	
	    if (onKeyDown) {
	      onKeyDown(event);
	    }
	  };
	
	  var handleKeyUp = function handleKeyUp(event) {
	    // Ignore events from children of `Chip`.
	    if (event.currentTarget === event.target) {
	      if (onDelete && isDeleteKeyboardEvent(event)) {
	        onDelete(event);
	      } else if (event.key === 'Escape' && chipRef.current) {
	        chipRef.current.blur();
	      }
	    }
	
	    if (onKeyUp) {
	      onKeyUp(event);
	    }
	  };
	
	  var clickable = clickableProp !== false && onClick ? true : clickableProp;
	  var small = size === 'small';
	  var Component = ComponentProp || (clickable ? _ButtonBase.default : 'div');
	  var moreProps = Component === _ButtonBase.default ? {
	    component: 'div'
	  } : {};
	  var deleteIcon = null;
	
	  if (onDelete) {
	    var customClasses = (0, _clsx.default)(color !== 'default' && (variant === "default" ? classes["deleteIconColor".concat((0, _capitalize.default)(color))] : classes["deleteIconOutlinedColor".concat((0, _capitalize.default)(color))]), small && classes.deleteIconSmall);
	    deleteIcon = deleteIconProp && /*#__PURE__*/React.isValidElement(deleteIconProp) ? /*#__PURE__*/React.cloneElement(deleteIconProp, {
	      className: (0, _clsx.default)(deleteIconProp.props.className, classes.deleteIcon, customClasses),
	      onClick: handleDeleteIconClick
	    }) : /*#__PURE__*/React.createElement(_Cancel.default, {
	      className: (0, _clsx.default)(classes.deleteIcon, customClasses),
	      onClick: handleDeleteIconClick
	    });
	  }
	
	  var avatar = null;
	
	  if (avatarProp && /*#__PURE__*/React.isValidElement(avatarProp)) {
	    avatar = /*#__PURE__*/React.cloneElement(avatarProp, {
	      className: (0, _clsx.default)(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== 'default' && classes["avatarColor".concat((0, _capitalize.default)(color))])
	    });
	  }
	
	  var icon = null;
	
	  if (iconProp && /*#__PURE__*/React.isValidElement(iconProp)) {
	    icon = /*#__PURE__*/React.cloneElement(iconProp, {
	      className: (0, _clsx.default)(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== 'default' && classes["iconColor".concat((0, _capitalize.default)(color))])
	    });
	  }
	
	  if (false) {
	    if (avatar && icon) {
	      console.error('Material-UI: The Chip component can not handle the avatar ' + 'and the icon prop at the same time. Pick one.');
	    }
	  }
	
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    role: clickable || onDelete ? 'button' : undefined,
	    className: (0, _clsx.default)(classes.root, className, color !== 'default' && [classes["color".concat((0, _capitalize.default)(color))], clickable && classes["clickableColor".concat((0, _capitalize.default)(color))], onDelete && classes["deletableColor".concat((0, _capitalize.default)(color))]], variant !== "default" && [classes.outlined, {
	      'primary': classes.outlinedPrimary,
	      'secondary': classes.outlinedSecondary
	    }[color]], disabled && classes.disabled, small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable),
	    "aria-disabled": disabled ? true : undefined,
	    tabIndex: clickable || onDelete ? 0 : undefined,
	    onClick: onClick,
	    onKeyDown: handleKeyDown,
	    onKeyUp: handleKeyUp,
	    ref: handleRef
	  }, moreProps, other), avatar || icon, /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.label, small && classes.labelSmall)
	  }, label), deleteIcon);
	});
	 false ? Chip.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Avatar element.
	   */
	  avatar: _propTypes.default.element,
	
	  /**
	   * This prop isn't supported.
	   * Use the `component` prop if you need to change the children structure.
	   */
	  children: _unsupportedProp.default,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the chip will appear clickable, and will raise when pressed,
	   * even if the onClick prop is not defined.
	   * If false, the chip will not be clickable, even if onClick prop is defined.
	   * This can be used, for example,
	   * along with the component prop to indicate an anchor Chip is clickable.
	   */
	  clickable: _propTypes.default.bool,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Override the default delete icon element. Shown only if `onDelete` is set.
	   */
	  deleteIcon: _propTypes.default.element,
	
	  /**
	   * If `true`, the chip should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Icon element.
	   */
	  icon: _propTypes.default.element,
	
	  /**
	   * The content of the label.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * Callback function fired when the delete icon is clicked.
	   * If set, the delete icon will be shown.
	   */
	  onDelete: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * The size of the chip.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['default', 'outlined'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiChip'
	})(Chip);
	
	exports.default = _default;

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Chip.default;
	  }
	});
	
	var _Chip = _interopRequireDefault(__webpack_require__(842));

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var SIZE = 44;
	
	function getRelativeValue(value, min, max) {
	  return (Math.min(Math.max(min, value), max) - min) / (max - min);
	}
	
	function easeOut(t) {
	  t = getRelativeValue(t, 0, 1); // https://gist.github.com/gre/1650294
	
	  t = (t -= 1) * t * t + 1;
	  return t;
	}
	
	function easeIn(t) {
	  return t * t;
	}
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-block'
	    },
	
	    /* Styles applied to the root element if `variant="static"`. */
	    static: {
	      transition: theme.transitions.create('transform')
	    },
	
	    /* Styles applied to the root element if `variant="indeterminate"`. */
	    indeterminate: {
	      animation: '$circular-rotate 1.4s linear infinite'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the `svg` element. */
	    svg: {
	      display: 'block' // Keeps the progress centered
	
	    },
	
	    /* Styles applied to the `circle` svg path. */
	    circle: {
	      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
	      // strokeLinecap: 'butt',
	
	    },
	
	    /* Styles applied to the `circle` svg path if `variant="static"`. */
	    circleStatic: {
	      transition: theme.transitions.create('stroke-dashoffset')
	    },
	
	    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
	    circleIndeterminate: {
	      animation: '$circular-dash 1.4s ease-in-out infinite',
	      // Some default value that looks fine waiting for the animation to kicks in.
	      strokeDasharray: '80px, 200px',
	      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
	
	    },
	    '@keyframes circular-rotate': {
	      '0%': {
	        // Fix IE 11 wobbly
	        transformOrigin: '50% 50%'
	      },
	      '100%': {
	        transform: 'rotate(360deg)'
	      }
	    },
	    '@keyframes circular-dash': {
	      '0%': {
	        strokeDasharray: '1px, 200px',
	        strokeDashoffset: '0px'
	      },
	      '50%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-15px'
	      },
	      '100%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-125px'
	      }
	    },
	
	    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
	    circleDisableShrink: {
	      animation: 'none'
	    }
	  };
	};
	/**
	 * ## ARIA
	 *
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	
	
	exports.styles = styles;
	var CircularProgress = /*#__PURE__*/React.forwardRef(function CircularProgress(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$disableShrink = props.disableShrink,
	      disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 40 : _props$size,
	      style = props.style,
	      _props$thickness = props.thickness,
	      thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
	      _props$value = props.value,
	      value = _props$value === void 0 ? 0 : _props$value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);
	  var circleStyle = {};
	  var rootStyle = {};
	  var rootProps = {};
	
	  if (variant === 'determinate' || variant === 'static') {
	    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
	    circleStyle.strokeDasharray = circumference.toFixed(3);
	    rootProps['aria-valuenow'] = Math.round(value);
	
	    if (variant === 'static') {
	      circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
	      rootStyle.transform = 'rotate(-90deg)';
	    } else {
	      circleStyle.strokeDashoffset = "".concat((easeIn((100 - value) / 100) * circumference).toFixed(3), "px");
	      rootStyle.transform = "rotate(".concat((easeOut(value / 70) * 270).toFixed(3), "deg)");
	    }
	  }
	
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, _capitalize.default)(color))], {
	      'indeterminate': classes.indeterminate,
	      'static': classes.static
	    }[variant]),
	    style: (0, _extends2.default)({
	      width: size,
	      height: size
	    }, rootStyle, style),
	    ref: ref,
	    role: "progressbar"
	  }, rootProps, other), /*#__PURE__*/React.createElement("svg", {
	    className: classes.svg,
	    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
	  }, /*#__PURE__*/React.createElement("circle", {
	    className: (0, _clsx.default)(classes.circle, disableShrink && classes.circleDisableShrink, {
	      'indeterminate': classes.circleIndeterminate,
	      'static': classes.circleStatic
	    }[variant]),
	    style: circleStyle,
	    cx: SIZE,
	    cy: SIZE,
	    r: (SIZE - thickness) / 2,
	    fill: "none",
	    strokeWidth: thickness
	  })));
	});
	 false ? CircularProgress.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the shrink animation is disabled.
	   * This only works if variant is `indeterminate`.
	   */
	  disableShrink: (0, _utils.chainPropTypes)(_propTypes.default.bool, function (props) {
	    if (props.disableShrink && props.variant && props.variant !== 'indeterminate') {
	      return new Error('Material-UI: You have provided the `disableShrink` prop ' + 'with a variant other than `indeterminate`. This will have no effect.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * The size of the circle.
	   * If using a number, the pixel unit is assumed.
	   * If using a string, you need to provide the CSS unit, e.g '3rem'.
	   */
	  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The thickness of the circle.
	   */
	  thickness: _propTypes.default.number,
	
	  /**
	   * The value of the progress indicator for the determinate and static variants.
	   * Value between 0 and 100.
	   */
	  value: _propTypes.default.number,
	
	  /**
	   * The variant to use.
	   * Use indeterminate when there is no progress value.
	   */
	  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'static'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCircularProgress',
	  flip: false
	})(CircularProgress);
	
	exports.default = _default;

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CircularProgress.default;
	  }
	});
	
	var _CircularProgress = _interopRequireDefault(__webpack_require__(844));

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(45));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(68));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(79));
	
	var _utils = __webpack_require__(22);
	
	function mapEventPropToEvent(eventProp) {
	  return eventProp.substring(2).toLowerCase();
	}
	
	function clickedRootScrollbar(event) {
	  return document.documentElement.clientWidth < event.clientX || document.documentElement.clientHeight < event.clientY;
	}
	/**
	 * Listen for click events that occur somewhere in the document, outside of the element itself.
	 * For instance, if you need to hide a menu when people click anywhere else on your page.
	 */
	
	
	function ClickAwayListener(props) {
	  var children = props.children,
	      _props$disableReactTr = props.disableReactTree,
	      disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr,
	      _props$mouseEvent = props.mouseEvent,
	      mouseEvent = _props$mouseEvent === void 0 ? 'onClick' : _props$mouseEvent,
	      onClickAway = props.onClickAway,
	      _props$touchEvent = props.touchEvent,
	      touchEvent = _props$touchEvent === void 0 ? 'onTouchEnd' : _props$touchEvent;
	  var movedRef = React.useRef(false);
	  var nodeRef = React.useRef(null);
	  var mountedRef = React.useRef(false);
	  var syntheticEventRef = React.useRef(false);
	  React.useEffect(function () {
	    mountedRef.current = true;
	    return function () {
	      mountedRef.current = false;
	    };
	  }, []); // can be removed once we drop support for non ref forwarding class components
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    nodeRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRef = (0, _useForkRef.default)(children.ref, handleOwnRef); // The handler doesn't take event.defaultPrevented into account:
	  //
	  // event.preventDefault() is meant to stop default behaviours like
	  // clicking a checkbox to check it, hitting a button to submit a form,
	  // and hitting left arrow to move the cursor in a text input etc.
	  // Only special HTML elements have these default behaviors.
	
	  var handleClickAway = (0, _useEventCallback.default)(function (event) {
	    // Given developers can stop the propagation of the synthetic event,
	    // we can only be confident with a positive value.
	    var insideReactTree = syntheticEventRef.current;
	    syntheticEventRef.current = false; // 1. IE 11 support, which trigger the handleClickAway even after the unbind
	    // 2. The child might render null.
	    // 3. Behave like a blur listener.
	
	    if (!mountedRef.current || !nodeRef.current || clickedRootScrollbar(event)) {
	      return;
	    } // Do not act if user performed touchmove
	
	
	    if (movedRef.current) {
	      movedRef.current = false;
	      return;
	    }
	
	    var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
	
	    if (event.composedPath) {
	      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
	    } else {
	      // TODO v6 remove dead logic https://caniuse.com/#search=composedPath.
	      var doc = (0, _ownerDocument.default)(nodeRef.current);
	      insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
	    }
	
	    if (!insideDOM && (disableReactTree || !insideReactTree)) {
	      onClickAway(event);
	    }
	  }); // Keep track of mouse/touch events that bubbled up through the portal.
	
	  var createHandleSynthetic = function createHandleSynthetic(handlerName) {
	    return function (event) {
	      syntheticEventRef.current = true;
	      var childrenPropsHandler = children.props[handlerName];
	
	      if (childrenPropsHandler) {
	        childrenPropsHandler(event);
	      }
	    };
	  };
	
	  var childrenProps = {
	    ref: handleRef
	  };
	
	  if (touchEvent !== false) {
	    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
	  }
	
	  React.useEffect(function () {
	    if (touchEvent !== false) {
	      var mappedTouchEvent = mapEventPropToEvent(touchEvent);
	      var doc = (0, _ownerDocument.default)(nodeRef.current);
	
	      var handleTouchMove = function handleTouchMove() {
	        movedRef.current = true;
	      };
	
	      doc.addEventListener(mappedTouchEvent, handleClickAway);
	      doc.addEventListener('touchmove', handleTouchMove);
	      return function () {
	        doc.removeEventListener(mappedTouchEvent, handleClickAway);
	        doc.removeEventListener('touchmove', handleTouchMove);
	      };
	    }
	
	    return undefined;
	  }, [handleClickAway, touchEvent]);
	
	  if (mouseEvent !== false) {
	    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
	  }
	
	  React.useEffect(function () {
	    if (mouseEvent !== false) {
	      var mappedMouseEvent = mapEventPropToEvent(mouseEvent);
	      var doc = (0, _ownerDocument.default)(nodeRef.current);
	      doc.addEventListener(mappedMouseEvent, handleClickAway);
	      return function () {
	        doc.removeEventListener(mappedMouseEvent, handleClickAway);
	      };
	    }
	
	    return undefined;
	  }, [handleClickAway, mouseEvent]);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.cloneElement(children, childrenProps));
	}
	
	 false ? ClickAwayListener.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The wrapped element.
	   */
	  children: _utils.elementAcceptingRef.isRequired,
	
	  /**
	   * If `true`, the React tree is ignored and only the DOM tree is considered.
	   * This prop changes how portaled elements are handled.
	   */
	  disableReactTree: _propTypes.default.bool,
	
	  /**
	   * The mouse event to listen to. You can disable the listener by providing `false`.
	   */
	  mouseEvent: _propTypes.default.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),
	
	  /**
	   * Callback fired when a "click away" event is detected.
	   */
	  onClickAway: _propTypes.default.func.isRequired,
	
	  /**
	   * The touch event to listen to. You can disable the listener by providing `false`.
	   */
	  touchEvent: _propTypes.default.oneOf(['onTouchEnd', 'onTouchStart', false])
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  ClickAwayListener['propTypes' + ''] = (0, _utils.exactProp)(ClickAwayListener.propTypes);
	}
	
	var _default = ClickAwayListener;
	exports.default = _default;

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _reactTransitionGroup = __webpack_require__(123);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _transitions = __webpack_require__(74);
	
	var _utils = __webpack_require__(110);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(47));
	
	var _utils2 = __webpack_require__(397);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the container element. */
	    container: {
	      height: 0,
	      overflow: 'hidden',
	      transition: theme.transitions.create('height')
	    },
	
	    /* Styles applied to the container element when the transition has entered. */
	    entered: {
	      height: 'auto',
	      overflow: 'visible'
	    },
	
	    /* Styles applied to the container element when the transition has exited and `collapsedHeight` != 0px. */
	    hidden: {
	      visibility: 'hidden'
	    },
	
	    /* Styles applied to the outer wrapper element. */
	    wrapper: {
	      // Hack to get children with a negative margin to not falsify the height computation.
	      display: 'flex'
	    },
	
	    /* Styles applied to the inner wrapper element. */
	    wrapperInner: {
	      width: '100%'
	    }
	  };
	};
	/**
	 * The Collapse transition is used by the
	 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	
	exports.styles = styles;
	var Collapse = /*#__PURE__*/React.forwardRef(function Collapse(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$collapsedHeigh = props.collapsedHeight,
	      collapsedHeightProp = _props$collapsedHeigh === void 0 ? '0px' : _props$collapsedHeigh,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disableStrictM = props.disableStrictModeCompat,
	      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? _transitions.duration.standard : _props$timeout,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _reactTransitionGroup.Transition : _props$TransitionComp,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "collapsedHeight", "component", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);
	  var theme = (0, _useTheme.default)();
	  var timer = React.useRef();
	  var wrapperRef = React.useRef(null);
	  var autoTransitionDuration = React.useRef();
	  var collapsedHeight = typeof collapsedHeightProp === 'number' ? "".concat(collapsedHeightProp, "px") : collapsedHeightProp;
	  React.useEffect(function () {
	    return function () {
	      clearTimeout(timer.current);
	    };
	  }, []);
	  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
	  var nodeRef = React.useRef(null);
	  var handleRef = (0, _utils2.useForkRef)(ref, enableStrictModeCompat ? nodeRef : undefined);
	
	  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
	    return function (nodeOrAppearing, maybeAppearing) {
	      if (callback) {
	        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
	            _ref2 = (0, _slicedToArray2.default)(_ref, 2),
	            node = _ref2[0],
	            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
	
	
	        if (isAppearing === undefined) {
	          callback(node);
	        } else {
	          callback(node, isAppearing);
	        }
	      }
	    };
	  };
	
	  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
	    node.style.height = collapsedHeight;
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  });
	  var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
	    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
	
	    var _getTransitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    }),
	        transitionDuration = _getTransitionProps.duration;
	
	    if (timeout === 'auto') {
	      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
	      node.style.transitionDuration = "".concat(duration2, "ms");
	      autoTransitionDuration.current = duration2;
	    } else {
	      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
	    }
	
	    node.style.height = "".concat(wrapperHeight, "px");
	
	    if (onEntering) {
	      onEntering(node, isAppearing);
	    }
	  });
	  var handleEntered = normalizedTransitionCallback(function (node, isAppearing) {
	    node.style.height = 'auto';
	
	    if (onEntered) {
	      onEntered(node, isAppearing);
	    }
	  });
	  var handleExit = normalizedTransitionCallback(function (node) {
	    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
	    node.style.height = "".concat(wrapperHeight, "px");
	
	    if (onExit) {
	      onExit(node);
	    }
	  });
	  var handleExited = normalizedTransitionCallback(onExited);
	  var handleExiting = normalizedTransitionCallback(function (node) {
	    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
	
	    var _getTransitionProps2 = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    }),
	        transitionDuration = _getTransitionProps2.duration;
	
	    if (timeout === 'auto') {
	      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
	      node.style.transitionDuration = "".concat(duration2, "ms");
	      autoTransitionDuration.current = duration2;
	    } else {
	      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
	    }
	
	    node.style.height = collapsedHeight;
	
	    if (onExiting) {
	      onExiting(node);
	    }
	  });
	
	  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
	    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
	
	    if (timeout === 'auto') {
	      timer.current = setTimeout(next, autoTransitionDuration.current || 0);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    in: inProp,
	    onEnter: handleEnter,
	    onEntered: handleEntered,
	    onEntering: handleEntering,
	    onExit: handleExit,
	    onExited: handleExited,
	    onExiting: handleExiting,
	    addEndListener: addEndListener,
	    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
	    timeout: timeout === 'auto' ? null : timeout
	  }, other), function (state, childProps) {
	    return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.container, className, {
	        'entered': classes.entered,
	        'exited': !inProp && collapsedHeight === '0px' && classes.hidden
	      }[state]),
	      style: (0, _extends2.default)({
	        minHeight: collapsedHeight
	      }, style),
	      ref: handleRef
	    }, childProps), /*#__PURE__*/React.createElement("div", {
	      className: classes.wrapper,
	      ref: wrapperRef
	    }, /*#__PURE__*/React.createElement("div", {
	      className: classes.wrapperInner
	    }, children)));
	  });
	});
	 false ? Collapse.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content node to be collapsed.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The height of the container when collapsed.
	   */
	  collapsedHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Enable this prop if you encounter 'Function components cannot be given refs',
	   * use `unstable_createStrictModeTheme`,
	   * and can't forward the ref in the passed `Component`.
	   */
	  disableStrictModeCompat: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	Collapse.muiSupportAuto = true;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCollapse'
	})(Collapse);
	
	exports.default = _default;

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _defineProperty2.default)({
	      width: '100%',
	      marginLeft: 'auto',
	      boxSizing: 'border-box',
	      marginRight: 'auto',
	      paddingLeft: theme.spacing(2),
	      paddingRight: theme.spacing(2),
	      display: 'block'
	    }, theme.breakpoints.up('sm'), {
	      paddingLeft: theme.spacing(3),
	      paddingRight: theme.spacing(3)
	    }),
	
	    /* Styles applied to the root element if `disableGutters={true}`. */
	    disableGutters: {
	      paddingLeft: 0,
	      paddingRight: 0
	    },
	
	    /* Styles applied to the root element if `fixed={true}`. */
	    fixed: Object.keys(theme.breakpoints.values).reduce(function (acc, breakpoint) {
	      var value = theme.breakpoints.values[breakpoint];
	
	      if (value !== 0) {
	        acc[theme.breakpoints.up(breakpoint)] = {
	          maxWidth: value
	        };
	      }
	
	      return acc;
	    }, {}),
	
	    /* Styles applied to the root element if `maxWidth="xs"`. */
	    maxWidthXs: (0, _defineProperty2.default)({}, theme.breakpoints.up('xs'), {
	      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
	    }),
	
	    /* Styles applied to the root element if `maxWidth="sm"`. */
	    maxWidthSm: (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), {
	      maxWidth: theme.breakpoints.values.sm
	    }),
	
	    /* Styles applied to the root element if `maxWidth="md"`. */
	    maxWidthMd: (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), {
	      maxWidth: theme.breakpoints.values.md
	    }),
	
	    /* Styles applied to the root element if `maxWidth="lg"`. */
	    maxWidthLg: (0, _defineProperty2.default)({}, theme.breakpoints.up('lg'), {
	      maxWidth: theme.breakpoints.values.lg
	    }),
	
	    /* Styles applied to the root element if `maxWidth="xl"`. */
	    maxWidthXl: (0, _defineProperty2.default)({}, theme.breakpoints.up('xl'), {
	      maxWidth: theme.breakpoints.values.xl
	    })
	  };
	};
	
	exports.styles = styles;
	var Container = /*#__PURE__*/React.forwardRef(function Container(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$fixed = props.fixed,
	      fixed = _props$fixed === void 0 ? false : _props$fixed,
	      _props$maxWidth = props.maxWidth,
	      maxWidth = _props$maxWidth === void 0 ? 'lg' : _props$maxWidth,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disableGutters", "fixed", "maxWidth"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, fixed && classes.fixed, disableGutters && classes.disableGutters, maxWidth !== false && classes["maxWidth".concat((0, _capitalize.default)(String(maxWidth)))]),
	    ref: ref
	  }, other));
	});
	 false ? Container.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * @ignore
	   */
	  children: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * Set the max-width to match the min-width of the current breakpoint.
	   * This is useful if you'd prefer to design for a fixed set of sizes
	   * instead of trying to accommodate a fully fluid viewport.
	   * It's fluid by default.
	   */
	  fixed: _propTypes.default.bool,
	
	  /**
	   * Determine the max-width of the container.
	   * The container width grows with the size of the screen.
	   * Set to `false` to disable `maxWidth`.
	   */
	  maxWidth: _propTypes.default.oneOf(['lg', 'md', 'sm', 'xl', 'xs', false])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiContainer'
	})(Container);
	
	exports.default = _default;

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Container.default;
	  }
	});
	
	var _Container = _interopRequireDefault(__webpack_require__(848));

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = exports.body = exports.html = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _utils = __webpack_require__(22);
	
	var html = {
	  WebkitFontSmoothing: 'antialiased',
	  // Antialiasing.
	  MozOsxFontSmoothing: 'grayscale',
	  // Antialiasing.
	  // Change from `box-sizing: content-box` so that `width`
	  // is not affected by `padding` or `border`.
	  boxSizing: 'border-box'
	};
	exports.html = html;
	
	var body = function body(theme) {
	  return (0, _extends2.default)({
	    color: theme.palette.text.primary
	  }, theme.typography.body2, {
	    backgroundColor: theme.palette.background.default,
	    '@media print': {
	      // Save printer ink.
	      backgroundColor: theme.palette.common.white
	    }
	  });
	};
	
	exports.body = body;
	
	var styles = function styles(theme) {
	  return {
	    '@global': {
	      html: html,
	      '*, *::before, *::after': {
	        boxSizing: 'inherit'
	      },
	      'strong, b': {
	        fontWeight: theme.typography.fontWeightBold
	      },
	      body: (0, _extends2.default)({
	        margin: 0
	      }, body(theme), {
	        // Add support for document.body.requestFullScreen().
	        // Other elements, if background transparent, are not supported.
	        '&::backdrop': {
	          backgroundColor: theme.palette.background.default
	        }
	      })
	    }
	  };
	};
	/**
	 * Kickstart an elegant, consistent, and simple baseline to build upon.
	 */
	
	
	exports.styles = styles;
	
	function CssBaseline(props) {
	  /* eslint-disable no-unused-vars */
	  var _props$children = props.children,
	      children = _props$children === void 0 ? null : _props$children,
	      classes = props.classes;
	  /* eslint-enable no-unused-vars */
	
	  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
	}
	
	 false ? CssBaseline.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * You can wrap a node.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  CssBaseline['propTypes' + ''] = (0, _utils.exactProp)(CssBaseline.propTypes);
	}
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCssBaseline'
	})(CssBaseline);
	
	exports.default = _default;

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CssBaseline.default;
	  }
	});
	
	var _CssBaseline = _interopRequireDefault(__webpack_require__(850));

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _Modal = _interopRequireDefault(__webpack_require__(165));
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(229));
	
	var _Fade = _interopRequireDefault(__webpack_require__(231));
	
	var _transitions = __webpack_require__(74);
	
	var _Paper = _interopRequireDefault(__webpack_require__(65));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      '@media print': {
	        // Use !important to override the Modal inline-style.
	        position: 'absolute !important'
	      }
	    },
	
	    /* Styles applied to the container element if `scroll="paper"`. */
	    scrollPaper: {
	      display: 'flex',
	      justifyContent: 'center',
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the container element if `scroll="body"`. */
	    scrollBody: {
	      overflowY: 'auto',
	      overflowX: 'hidden',
	      textAlign: 'center',
	      '&:after': {
	        content: '""',
	        display: 'inline-block',
	        verticalAlign: 'middle',
	        height: '100%',
	        width: '0'
	      }
	    },
	
	    /* Styles applied to the container element. */
	    container: {
	      height: '100%',
	      '@media print': {
	        height: 'auto'
	      },
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 0
	    },
	
	    /* Styles applied to the `Paper` component. */
	    paper: {
	      margin: 32,
	      position: 'relative',
	      overflowY: 'auto',
	      // Fix IE 11 issue, to remove at some point.
	      '@media print': {
	        overflowY: 'visible',
	        boxShadow: 'none'
	      }
	    },
	
	    /* Styles applied to the `Paper` component if `scroll="paper"`. */
	    paperScrollPaper: {
	      display: 'flex',
	      flexDirection: 'column',
	      maxHeight: 'calc(100% - 64px)'
	    },
	
	    /* Styles applied to the `Paper` component if `scroll="body"`. */
	    paperScrollBody: {
	      display: 'inline-block',
	      verticalAlign: 'middle',
	      textAlign: 'left' // 'initial' doesn't work on IE 11
	
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth=false`. */
	    paperWidthFalse: {
	      maxWidth: 'calc(100% - 64px)'
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
	    paperWidthXs: {
	      maxWidth: Math.max(theme.breakpoints.values.xs, 444),
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2), {
	        maxWidth: 'calc(100% - 64px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
	    paperWidthSm: {
	      maxWidth: theme.breakpoints.values.sm,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.sm + 32 * 2), {
	        maxWidth: 'calc(100% - 64px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
	    paperWidthMd: {
	      maxWidth: theme.breakpoints.values.md,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.md + 32 * 2), {
	        maxWidth: 'calc(100% - 64px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
	    paperWidthLg: {
	      maxWidth: theme.breakpoints.values.lg,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.lg + 32 * 2), {
	        maxWidth: 'calc(100% - 64px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="xl"`. */
	    paperWidthXl: {
	      maxWidth: theme.breakpoints.values.xl,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.xl + 32 * 2), {
	        maxWidth: 'calc(100% - 64px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
	    paperFullWidth: {
	      width: 'calc(100% - 64px)'
	    },
	
	    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
	    paperFullScreen: {
	      margin: 0,
	      width: '100%',
	      maxWidth: '100%',
	      height: '100%',
	      maxHeight: 'none',
	      borderRadius: 0,
	      '&$paperScrollBody': {
	        margin: 0,
	        maxWidth: '100%'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultTransitionDuration = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * Dialogs are overlaid modal paper based components with a backdrop.
	 */
	
	var Dialog = /*#__PURE__*/React.forwardRef(function Dialog(props, ref) {
	  var BackdropProps = props.BackdropProps,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$disableBackdro = props.disableBackdropClick,
	      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
	      _props$disableEscapeK = props.disableEscapeKeyDown,
	      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
	      _props$fullScreen = props.fullScreen,
	      fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$maxWidth = props.maxWidth,
	      maxWidth = _props$maxWidth === void 0 ? 'sm' : _props$maxWidth,
	      onBackdropClick = props.onBackdropClick,
	      onClose = props.onClose,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onEscapeKeyDown = props.onEscapeKeyDown,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      open = props.open,
	      _props$PaperComponent = props.PaperComponent,
	      PaperComponent = _props$PaperComponent === void 0 ? _Paper.default : _props$PaperComponent,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      _props$scroll = props.scroll,
	      scroll = _props$scroll === void 0 ? 'paper' : _props$scroll,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Fade.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
	      TransitionProps = props.TransitionProps,
	      ariaDescribedby = props['aria-describedby'],
	      ariaLabelledby = props['aria-labelledby'],
	      other = (0, _objectWithoutProperties2.default)(props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps", "aria-describedby", "aria-labelledby"]);
	  var mouseDownTarget = React.useRef();
	
	  var handleMouseDown = function handleMouseDown(event) {
	    mouseDownTarget.current = event.target;
	  };
	
	  var handleBackdropClick = function handleBackdropClick(event) {
	    // Ignore the events not coming from the "backdrop"
	    // We don't want to close the dialog when clicking the dialog content.
	    if (event.target !== event.currentTarget) {
	      return;
	    } // Make sure the event starts and ends on the same DOM element.
	
	
	    if (event.target !== mouseDownTarget.current) {
	      return;
	    }
	
	    mouseDownTarget.current = null;
	
	    if (onBackdropClick) {
	      onBackdropClick(event);
	    }
	
	    if (!disableBackdropClick && onClose) {
	      onClose(event, 'backdropClick');
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_Modal.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    BackdropComponent: _Backdrop.default,
	    BackdropProps: (0, _extends2.default)({
	      transitionDuration: transitionDuration
	    }, BackdropProps),
	    closeAfterTransition: true,
	    disableBackdropClick: disableBackdropClick,
	    disableEscapeKeyDown: disableEscapeKeyDown,
	    onEscapeKeyDown: onEscapeKeyDown,
	    onClose: onClose,
	    open: open,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: open,
	    timeout: transitionDuration,
	    onEnter: onEnter,
	    onEntering: onEntering,
	    onEntered: onEntered,
	    onExit: onExit,
	    onExiting: onExiting,
	    onExited: onExited,
	    role: "none presentation"
	  }, TransitionProps), /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.container, classes["scroll".concat((0, _capitalize.default)(scroll))]),
	    onMouseUp: handleBackdropClick,
	    onMouseDown: handleMouseDown
	  }, /*#__PURE__*/React.createElement(PaperComponent, (0, _extends2.default)({
	    elevation: 24,
	    role: "dialog",
	    "aria-describedby": ariaDescribedby,
	    "aria-labelledby": ariaLabelledby
	  }, PaperProps, {
	    className: (0, _clsx.default)(classes.paper, classes["paperScroll".concat((0, _capitalize.default)(scroll))], classes["paperWidth".concat((0, _capitalize.default)(String(maxWidth)))], PaperProps.className, fullScreen && classes.paperFullScreen, fullWidth && classes.paperFullWidth)
	  }), children))));
	});
	 false ? Dialog.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The id(s) of the element(s) that describe the dialog.
	   */
	  'aria-describedby': _propTypes.default.string,
	
	  /**
	   * The id(s) of the element(s) that label the dialog.
	   */
	  'aria-labelledby': _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * Dialog children, usually the included sub-components.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, clicking the backdrop will not fire the `onClose` callback.
	   */
	  disableBackdropClick: _propTypes.default.bool,
	
	  /**
	   * If `true`, hitting escape will not fire the `onClose` callback.
	   */
	  disableEscapeKeyDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, the dialog will be full-screen
	   */
	  fullScreen: _propTypes.default.bool,
	
	  /**
	   * If `true`, the dialog stretches to `maxWidth`.
	   *
	   * Notice that the dialog width grow is limited by the default margin.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * Determine the max-width of the dialog.
	   * The dialog width grows with the size of the screen.
	   * Set to `false` to disable `maxWidth`.
	   */
	  maxWidth: _propTypes.default.oneOf(['lg', 'md', 'sm', 'xl', 'xs', false]),
	
	  /**
	   * Callback fired when the backdrop is clicked.
	   */
	  onBackdropClick: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the dialog enters.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired when the escape key is pressed,
	   * `disableKeyboard` is false and the modal is in focus.
	   */
	  onEscapeKeyDown: _propTypes.default.func,
	
	  /**
	   * Callback fired before the dialog exits.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * If `true`, the Dialog is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * The component used to render the body of the dialog.
	   */
	  PaperComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Paper`](/api/paper/) element.
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * Determine the container for scrolling the dialog.
	   */
	  scroll: _propTypes.default.oneOf(['body', 'paper']),
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialog'
	})(Dialog);
	
	exports.default = _default;

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.default;
	  }
	});
	
	var _Dialog = _interopRequireDefault(__webpack_require__(852));

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 8,
	    justifyContent: 'flex-end',
	    flex: '0 0 auto'
	  },
	
	  /* Styles applied to the root element if `disableSpacing={false}`. */
	  spacing: {
	    '& > :not(:first-child)': {
	      marginLeft: 8
	    }
	  }
	};
	exports.styles = styles;
	var DialogActions = /*#__PURE__*/React.forwardRef(function DialogActions(props, ref) {
	  var _props$disableSpacing = props.disableSpacing,
	      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableSpacing", "classes", "className"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, !disableSpacing && classes.spacing),
	    ref: ref
	  }, other));
	});
	 false ? DialogActions.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the actions do not have additional margin.
	   */
	  disableSpacing: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogActions'
	})(DialogActions);
	
	exports.default = _default;

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogActions.default;
	  }
	});
	
	var _DialogActions = _interopRequireDefault(__webpack_require__(854));

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      flex: '1 1 auto',
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      overflowY: 'auto',
	      padding: '8px 24px',
	      '&:first-child': {
	        // dialog without title
	        paddingTop: 20
	      }
	    },
	
	    /* Styles applied to the root element if `dividers={true}`. */
	    dividers: {
	      padding: '16px 24px',
	      borderTop: "1px solid ".concat(theme.palette.divider),
	      borderBottom: "1px solid ".concat(theme.palette.divider)
	    }
	  };
	};
	
	exports.styles = styles;
	var DialogContent = /*#__PURE__*/React.forwardRef(function DialogContent(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$dividers = props.dividers,
	      dividers = _props$dividers === void 0 ? false : _props$dividers,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "dividers"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, dividers && classes.dividers),
	    ref: ref
	  }, other));
	});
	 false ? DialogContent.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Display the top and bottom dividers.
	   */
	  dividers: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogContent'
	})(DialogContent);
	
	exports.default = _default;

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContent.default;
	  }
	});
	
	var _DialogContent = _interopRequireDefault(__webpack_require__(856));

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Typography = _interopRequireDefault(__webpack_require__(66));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    marginBottom: 12
	  }
	};
	exports.styles = styles;
	var DialogContentText = /*#__PURE__*/React.forwardRef(function DialogContentText(props, ref) {
	  return /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	    component: "p",
	    variant: "body1",
	    color: "textSecondary",
	    ref: ref
	  }, props));
	});
	 false ? DialogContentText.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogContentText'
	})(DialogContentText);
	
	exports.default = _default;

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContentText.default;
	  }
	});
	
	var _DialogContentText = _interopRequireDefault(__webpack_require__(858));

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Typography = _interopRequireDefault(__webpack_require__(66));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    margin: 0,
	    padding: '16px 24px',
	    flex: '0 0 auto'
	  }
	};
	exports.styles = styles;
	var DialogTitle = /*#__PURE__*/React.forwardRef(function DialogTitle(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), disableTypography ? children : /*#__PURE__*/React.createElement(_Typography.default, {
	    component: "h2",
	    variant: "h6"
	  }, children));
	});
	 false ? DialogTitle.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the children won't be wrapped by a typography component.
	   * For instance, this can be useful to render an h4 instead of the default h2.
	   */
	  disableTypography: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogTitle'
	})(DialogTitle);
	
	exports.default = _default;

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogTitle.default;
	  }
	});
	
	var _DialogTitle = _interopRequireDefault(__webpack_require__(860));

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _colorManipulator = __webpack_require__(49);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      height: 1,
	      margin: 0,
	      // Reset browser default style.
	      border: 'none',
	      flexShrink: 0,
	      backgroundColor: theme.palette.divider
	    },
	
	    /* Styles applied to the root element if `absolute={true}`. */
	    absolute: {
	      position: 'absolute',
	      bottom: 0,
	      left: 0,
	      width: '100%'
	    },
	
	    /* Styles applied to the root element if `variant="inset"`. */
	    inset: {
	      marginLeft: 72
	    },
	
	    /* Styles applied to the root element if `light={true}`. */
	    light: {
	      backgroundColor: (0, _colorManipulator.fade)(theme.palette.divider, 0.08)
	    },
	
	    /* Styles applied to the root element if `variant="middle"`. */
	    middle: {
	      marginLeft: theme.spacing(2),
	      marginRight: theme.spacing(2)
	    },
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {
	      height: '100%',
	      width: 1
	    },
	
	    /* Styles applied to the root element if `flexItem={true}`. */
	    flexItem: {
	      alignSelf: 'stretch',
	      height: 'auto'
	    }
	  };
	};
	
	exports.styles = styles;
	var Divider = /*#__PURE__*/React.forwardRef(function Divider(props, ref) {
	  var _props$absolute = props.absolute,
	      absolute = _props$absolute === void 0 ? false : _props$absolute,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'hr' : _props$component,
	      _props$flexItem = props.flexItem,
	      flexItem = _props$flexItem === void 0 ? false : _props$flexItem,
	      _props$light = props.light,
	      light = _props$light === void 0 ? false : _props$light,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      _props$role = props.role,
	      role = _props$role === void 0 ? Component !== 'hr' ? 'separator' : undefined : _props$role,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'fullWidth' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["absolute", "classes", "className", "component", "flexItem", "light", "orientation", "role", "variant"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant !== 'fullWidth' && classes[variant], absolute && classes.absolute, flexItem && classes.flexItem, light && classes.light, orientation === 'vertical' && classes.vertical),
	    role: role,
	    ref: ref
	  }, other));
	});
	 false ? Divider.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Absolutely position the element.
	   */
	  absolute: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, a vertical divider will have the correct height when used in flex container.
	   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
	   */
	  flexItem: _propTypes.default.bool,
	
	  /**
	   * If `true`, the divider will have a lighter color.
	   */
	  light: _propTypes.default.bool,
	
	  /**
	   * The divider orientation.
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['fullWidth', 'inset', 'middle'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDivider'
	})(Divider);
	
	exports.default = _default;

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Divider.default;
	  }
	});
	
	var _Divider = _interopRequireDefault(__webpack_require__(862));

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Drawer.default;
	  }
	});
	
	var _Drawer = _interopRequireDefault(__webpack_require__(230));

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _toArray2 = _interopRequireDefault(__webpack_require__(346));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(67);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _Collapse = _interopRequireDefault(__webpack_require__(161));
	
	var _Paper = _interopRequireDefault(__webpack_require__(65));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _ExpansionPanelContext = _interopRequireDefault(__webpack_require__(351));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(85));
	
	var styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      transition: theme.transitions.create(['margin'], transition),
	      '&:before': {
	        position: 'absolute',
	        left: 0,
	        top: -1,
	        right: 0,
	        height: 1,
	        content: '""',
	        opacity: 1,
	        backgroundColor: theme.palette.divider,
	        transition: theme.transitions.create(['opacity', 'background-color'], transition)
	      },
	      '&:first-child': {
	        '&:before': {
	          display: 'none'
	        }
	      },
	      '&$expanded': {
	        margin: '16px 0',
	        '&:first-child': {
	          marginTop: 0
	        },
	        '&:last-child': {
	          marginBottom: 0
	        },
	        '&:before': {
	          opacity: 0
	        }
	      },
	      '&$expanded + &': {
	        '&:before': {
	          display: 'none'
	        }
	      },
	      '&$disabled': {
	        backgroundColor: theme.palette.action.disabledBackground
	      }
	    },
	
	    /* Styles applied to the root element if `square={false}`. */
	    rounded: {
	      borderRadius: 0,
	      '&:first-child': {
	        borderTopLeftRadius: theme.shape.borderRadius,
	        borderTopRightRadius: theme.shape.borderRadius
	      },
	      '&:last-child': {
	        borderBottomLeftRadius: theme.shape.borderRadius,
	        borderBottomRightRadius: theme.shape.borderRadius,
	        // Fix a rendering issue on Edge
	        '@supports (-ms-ime-align: auto)': {
	          borderBottomLeftRadius: 0,
	          borderBottomRightRadius: 0
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `expanded={true}`. */
	    expanded: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {}
	  };
	};
	
	exports.styles = styles;
	var warnedOnce = false;
	/**
	 * ⚠️ The ExpansionPanel component was renamed to Accordion to use a more common naming convention.
	 *
	 * You should use `import { Accordion } from '@material-ui/core'`
	 * or `import Accordion from '@material-ui/core/Accordion'`.
	 */
	
	var ExpansionPanel = /*#__PURE__*/React.forwardRef(function ExpansionPanel(props, ref) {
	  if (false) {
	    if (!warnedOnce) {
	      warnedOnce = true;
	      console.error(['Material-UI: the ExpansionPanel component was renamed to Accordion to use a more common naming convention.', '', "You should use `import { Accordion } from '@material-ui/core'`", "or `import Accordion from '@material-ui/core/Accordion'`"].join('\n'));
	    }
	  }
	
	  var childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$defaultExpande = props.defaultExpanded,
	      defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      expandedProp = props.expanded,
	      onChange = props.onChange,
	      _props$square = props.square,
	      square = _props$square === void 0 ? false : _props$square,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Collapse.default : _props$TransitionComp,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "defaultExpanded", "disabled", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"]);
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: expandedProp,
	    default: defaultExpanded,
	    name: 'ExpansionPanel',
	    state: 'expanded'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      expanded = _useControlled2[0],
	      setExpandedState = _useControlled2[1];
	
	  var handleChange = React.useCallback(function (event) {
	    setExpandedState(!expanded);
	
	    if (onChange) {
	      onChange(event, !expanded);
	    }
	  }, [expanded, onChange, setExpandedState]);
	
	  var _React$Children$toArr = React.Children.toArray(childrenProp),
	      _React$Children$toArr2 = (0, _toArray2.default)(_React$Children$toArr),
	      summary = _React$Children$toArr2[0],
	      children = _React$Children$toArr2.slice(1);
	
	  var contextValue = React.useMemo(function () {
	    return {
	      expanded: expanded,
	      disabled: disabled,
	      toggle: handleChange
	    };
	  }, [expanded, disabled, handleChange]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
	    ref: ref,
	    square: square
	  }, other), /*#__PURE__*/React.createElement(_ExpansionPanelContext.default.Provider, {
	    value: contextValue
	  }, summary), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    in: expanded,
	    timeout: "auto"
	  }, TransitionProps), /*#__PURE__*/React.createElement("div", {
	    "aria-labelledby": summary.props.id,
	    id: summary.props['aria-controls'],
	    role: "region"
	  }, children)));
	});
	 false ? ExpansionPanel.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the expansion panel.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node.isRequired, function (props) {
	    var summary = React.Children.toArray(props.children)[0];
	
	    if ((0, _reactIs.isFragment)(summary)) {
	      return new Error("Material-UI: The ExpansionPanel doesn't accept a Fragment as a child. " + 'Consider providing an array instead.');
	    }
	
	    if (! /*#__PURE__*/React.isValidElement(summary)) {
	      return new Error('Material-UI: Expected the first child of ExpansionPanel to be a valid element.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, expands the panel by default.
	   */
	  defaultExpanded: _propTypes.default.bool,
	
	  /**
	   * If `true`, the panel will be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, expands the panel, otherwise collapse it.
	   * Setting this prop enables control over the panel.
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * Callback fired when the expand/collapse state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {boolean} expanded The `expanded` state of the panel.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, rounded corners are disabled.
	   */
	  square: _propTypes.default.bool,
	
	  /**
	   * The component used for the collapse effect.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanel'
	})(ExpansionPanel);
	
	exports.default = _default;

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanel.default;
	  }
	});
	
	var _ExpansionPanel = _interopRequireDefault(__webpack_require__(865));

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 8,
	    justifyContent: 'flex-end'
	  },
	
	  /* Styles applied to the root element if `disableSpacing={false}`. */
	  spacing: {
	    '& > :not(:first-child)': {
	      marginLeft: 8
	    }
	  }
	};
	exports.styles = styles;
	var warnedOnce = false;
	/**
	 * ⚠️ The ExpansionPanelActions component was renamed to AccordionActions to use a more common naming convention.
	 *
	 * You should use `import { AccordionActions } from '@material-ui/core'`
	 * or `import AccordionActions from '@material-ui/core/AccordionActions'`.
	 */
	
	var ExpansionPanelActions = /*#__PURE__*/React.forwardRef(function ExpansionPanelActions(props, ref) {
	  if (false) {
	    if (!warnedOnce) {
	      warnedOnce = true;
	      console.error(['Material-UI: the ExpansionPanelActions component was renamed to AccordionActions to use a more common naming convention.', '', "You should use `import { AccordionActions } from '@material-ui/core'`", "or `import AccordionActions from '@material-ui/core/AccordionActions'`"].join('\n'));
	    }
	  }
	
	  var classes = props.classes,
	      className = props.className,
	      _props$disableSpacing = props.disableSpacing,
	      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disableSpacing"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, !disableSpacing && classes.spacing),
	    ref: ref
	  }, other));
	});
	 false ? ExpansionPanelActions.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the actions do not have additional margin.
	   */
	  disableSpacing: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelActions'
	})(ExpansionPanelActions);
	
	exports.default = _default;

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelActions.default;
	  }
	});
	
	var _ExpansionPanelActions = _interopRequireDefault(__webpack_require__(867));

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      padding: theme.spacing(1, 2, 2)
	    }
	  };
	};
	
	exports.styles = styles;
	var warnedOnce = false;
	/**
	 * ⚠️ The ExpansionPanelDetails component was renamed to AccordionDetails to use a more common naming convention.
	 *
	 * You should use `import { AccordionDetails } from '@material-ui/core'`
	 * or `import AccordionDetails from '@material-ui/core/AccordionDetails'`.
	 */
	
	var ExpansionPanelDetails = /*#__PURE__*/React.forwardRef(function ExpansionPanelDetails(props, ref) {
	  if (false) {
	    if (!warnedOnce) {
	      warnedOnce = true;
	      console.error(['Material-UI: the ExpansionPanelDetails component was renamed to AccordionDetails to use a more common naming convention.', '', "You should use `import { AccordionDetails } from '@material-ui/core'`", "or `import AccordionDetails from '@material-ui/core/AccordionActions'`"].join('\n'));
	    }
	  }
	
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other));
	});
	 false ? ExpansionPanelDetails.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the expansion panel details.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelDetails'
	})(ExpansionPanelDetails);
	
	exports.default = _default;

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelDetails.default;
	  }
	});
	
	var _ExpansionPanelDetails = _interopRequireDefault(__webpack_require__(869));

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(56));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(125));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _ExpansionPanelContext = _interopRequireDefault(__webpack_require__(351));
	
	/* eslint-disable jsx-a11y/aria-role */
	var styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      minHeight: 8 * 6,
	      transition: theme.transitions.create(['min-height', 'background-color'], transition),
	      padding: theme.spacing(0, 2),
	      '&:hover:not($disabled)': {
	        cursor: 'pointer'
	      },
	      '&$expanded': {
	        minHeight: 64
	      },
	      '&$focused': {
	        backgroundColor: theme.palette.action.focus
	      },
	      '&$disabled': {
	        opacity: theme.palette.action.disabledOpacity
	      }
	    },
	
	    /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
	    expanded: {},
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the children wrapper element. */
	    content: {
	      display: 'flex',
	      flexGrow: 1,
	      transition: theme.transitions.create(['margin'], transition),
	      margin: '12px 0',
	      '&$expanded': {
	        margin: '20px 0'
	      }
	    },
	
	    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
	    expandIcon: {
	      transform: 'rotate(0deg)',
	      transition: theme.transitions.create('transform', transition),
	      '&:hover': {
	        // Disable the hover effect for the IconButton,
	        // because a hover effect should apply to the entire Expand button and
	        // not only to the IconButton.
	        backgroundColor: 'transparent'
	      },
	      '&$expanded': {
	        transform: 'rotate(180deg)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var warnedOnce = false;
	/**
	 * ⚠️ The ExpansionPanelSummary component was renamed to AccordionSummary to use a more common naming convention.
	 *
	 * You should use `import { AccordionSummary } from '@material-ui/core'`
	 * or `import AccordionSummary from '@material-ui/core/AccordionSummary'`.
	 */
	
	var ExpansionPanelSummary = /*#__PURE__*/React.forwardRef(function ExpansionPanelSummary(props, ref) {
	  if (false) {
	    if (!warnedOnce) {
	      warnedOnce = true;
	      console.error(['Material-UI: the ExpansionPanelSummary component was renamed to AccordionSummary to use a more common naming convention.', '', "You should use `import { AccordionSummary } from '@material-ui/core'`", "or `import AccordionSummary from '@material-ui/core/AccordionSummary'`"].join('\n'));
	    }
	  }
	
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      expandIcon = props.expandIcon,
	      IconButtonProps = props.IconButtonProps,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocusVisible = props.onFocusVisible,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "expandIcon", "IconButtonProps", "onBlur", "onClick", "onFocusVisible"]);
	
	  var _React$useState = React.useState(false),
	      focusedState = _React$useState[0],
	      setFocusedState = _React$useState[1];
	
	  var handleFocusVisible = function handleFocusVisible(event) {
	    setFocusedState(true);
	
	    if (onFocusVisible) {
	      onFocusVisible(event);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    setFocusedState(false);
	
	    if (onBlur) {
	      onBlur(event);
	    }
	  };
	
	  var _React$useContext = React.useContext(_ExpansionPanelContext.default),
	      _React$useContext$dis = _React$useContext.disabled,
	      disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis,
	      expanded = _React$useContext.expanded,
	      toggle = _React$useContext.toggle;
	
	  var handleChange = function handleChange(event) {
	    if (toggle) {
	      toggle(event);
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    focusRipple: false,
	    disableRipple: true,
	    disabled: disabled,
	    component: "div",
	    "aria-expanded": expanded,
	    className: (0, _clsx.default)(classes.root, className, disabled && classes.disabled, expanded && classes.expanded, focusedState && classes.focused),
	    onFocusVisible: handleFocusVisible,
	    onBlur: handleBlur,
	    onClick: handleChange,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.content, expanded && classes.expanded)
	  }, children), expandIcon && /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.expandIcon, expanded && classes.expanded),
	    edge: "end",
	    component: "div",
	    tabIndex: null,
	    role: null,
	    "aria-hidden": true
	  }, IconButtonProps), expandIcon));
	});
	 false ? ExpansionPanelSummary.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the expansion panel summary.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The icon to display as the expand indicator.
	   */
	  expandIcon: _propTypes.default.node,
	
	  /**
	   * Props applied to the `IconButton` element wrapping the expand icon.
	   */
	  IconButtonProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is focused with a keyboard.
	   * We trigger a `onFocus` callback too.
	   */
	  onFocusVisible: _propTypes.default.func
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelSummary'
	})(ExpansionPanelSummary);
	
	exports.default = _default;

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelSummary.default;
	  }
	});
	
	var _ExpansionPanelSummary = _interopRequireDefault(__webpack_require__(871));

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(56));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.button, {
	      boxSizing: 'border-box',
	      minHeight: 36,
	      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
	        duration: theme.transitions.duration.short
	      }),
	      borderRadius: '50%',
	      padding: 0,
	      minWidth: 0,
	      width: 56,
	      height: 56,
	      boxShadow: theme.shadows[6],
	      '&:active': {
	        boxShadow: theme.shadows[12]
	      },
	      color: theme.palette.getContrastText(theme.palette.grey[300]),
	      backgroundColor: theme.palette.grey[300],
	      '&:hover': {
	        backgroundColor: theme.palette.grey.A100,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.grey[300]
	        },
	        '&$disabled': {
	          backgroundColor: theme.palette.action.disabledBackground
	        },
	        textDecoration: 'none'
	      },
	      '&$focusVisible': {
	        boxShadow: theme.shadows[6]
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled,
	        boxShadow: theme.shadows[0],
	        backgroundColor: theme.palette.action.disabledBackground
	      }
	    }),
	
	    /* Styles applied to the span element that wraps the children. */
	    label: {
	      width: '100%',
	      // assure the correct width for iOS Safari
	      display: 'inherit',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    primary: {
	      color: theme.palette.primary.contrastText,
	      backgroundColor: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.primary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.primary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    secondary: {
	      color: theme.palette.secondary.contrastText,
	      backgroundColor: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.secondary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.secondary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="extended"`. */
	    extended: {
	      borderRadius: 48 / 2,
	      padding: '0 16px',
	      width: 'auto',
	      minHeight: 'auto',
	      minWidth: 48,
	      height: 48,
	      '&$sizeSmall': {
	        width: 'auto',
	        padding: '0 8px',
	        borderRadius: 34 / 2,
	        minWidth: 34,
	        height: 34
	      },
	      '&$sizeMedium': {
	        width: 'auto',
	        padding: '0 16px',
	        borderRadius: 40 / 2,
	        minWidth: 40,
	        height: 40
	      }
	    },
	
	    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
	    focusVisible: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `size="small"``. */
	    sizeSmall: {
	      width: 40,
	      height: 40
	    },
	
	    /* Styles applied to the root element if `size="medium"``. */
	    sizeMedium: {
	      width: 48,
	      height: 48
	    }
	  };
	};
	
	exports.styles = styles;
	var Fab = /*#__PURE__*/React.forwardRef(function Fab(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'button' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      focusVisibleClassName = props.focusVisibleClassName,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'large' : _props$size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'round' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "disableFocusRipple", "focusVisibleClassName", "size", "variant"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant !== "round" && classes.extended, size !== 'large' && classes["size".concat((0, _capitalize.default)(size))], disabled && classes.disabled, {
	      'primary': classes.primary,
	      'secondary': classes.secondary,
	      'inherit': classes.colorInherit
	    }[color]),
	    component: component,
	    disabled: disabled,
	    focusRipple: !disableFocusRipple,
	    focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.label
	  }, children));
	});
	 false ? Fab.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the button.
	   */
	  children: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * The URL to link to when the button is clicked.
	   * If defined, an `a` element will be used as the root node.
	   */
	  href: _propTypes.default.string,
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['large', 'medium', 'small']),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['extended', 'round'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFab'
	})(Fab);
	
	exports.default = _default;

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Fab.default;
	  }
	});
	
	var _Fab = _interopRequireDefault(__webpack_require__(873));

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _reactTransitionGroup = __webpack_require__(123);
	
	var _transitions = __webpack_require__(74);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(47));
	
	var _utils = __webpack_require__(110);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	var styles = {
	  entering: {
	    opacity: 1
	  },
	  entered: {
	    opacity: 1
	  }
	};
	var defaultTimeout = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The Fade transition is used by the [Modal](/components/modal/) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Fade = /*#__PURE__*/React.forwardRef(function Fade(props, ref) {
	  var children = props.children,
	      _props$disableStrictM = props.disableStrictModeCompat,
	      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      style = props.style,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _reactTransitionGroup.Transition : _props$TransitionComp,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "TransitionComponent", "timeout"]);
	  var theme = (0, _useTheme.default)();
	  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
	  var nodeRef = React.useRef(null);
	  var foreignRef = (0, _useForkRef.default)(children.ref, ref);
	  var handleRef = (0, _useForkRef.default)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
	
	  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
	    return function (nodeOrAppearing, maybeAppearing) {
	      if (callback) {
	        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
	            _ref2 = (0, _slicedToArray2.default)(_ref, 2),
	            node = _ref2[0],
	            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
	
	
	        if (isAppearing === undefined) {
	          callback(node);
	        } else {
	          callback(node, isAppearing);
	        }
	      }
	    };
	  };
	
	  var handleEntering = normalizedTransitionCallback(onEntering);
	  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
	    (0, _utils.reflow)(node); // So the animation always start from the start.
	
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    });
	    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
	    node.style.transition = theme.transitions.create('opacity', transitionProps);
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  });
	  var handleEntered = normalizedTransitionCallback(onEntered);
	  var handleExiting = normalizedTransitionCallback(onExiting);
	  var handleExit = normalizedTransitionCallback(function (node) {
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    });
	    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
	    node.style.transition = theme.transitions.create('opacity', transitionProps);
	
	    if (onExit) {
	      onExit(node);
	    }
	  });
	  var handleExited = normalizedTransitionCallback(onExited);
	  return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: inProp,
	    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
	    onEnter: handleEnter,
	    onEntered: handleEntered,
	    onEntering: handleEntering,
	    onExit: handleExit,
	    onExited: handleExited,
	    onExiting: handleExiting,
	    timeout: timeout
	  }, other), function (state, childProps) {
	    return /*#__PURE__*/React.cloneElement(children, (0, _extends2.default)({
	      style: (0, _extends2.default)({
	        opacity: 0,
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, styles[state], style, children.props.style),
	      ref: handleRef
	    }, childProps));
	  });
	});
	 false ? Fade.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * Enable this prop if you encounter 'Function components cannot be given refs',
	   * use `unstable_createStrictModeTheme`,
	   * and can't forward the ref in the child component.
	   */
	  disableStrictModeCompat: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	var _default = Fade;
	exports.default = _default;

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _InputBase = _interopRequireDefault(__webpack_require__(126));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
	  var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      backgroundColor: backgroundColor,
	      borderTopLeftRadius: theme.shape.borderRadius,
	      borderTopRightRadius: theme.shape.borderRadius,
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shorter,
	        easing: theme.transitions.easing.easeOut
	      }),
	      '&:hover': {
	        backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: backgroundColor
	        }
	      },
	      '&$focused': {
	        backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
	      },
	      '&$disabled': {
	        backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
	      }
	    },
	
	    /* Styles applied to the root element if color secondary. */
	    colorSecondary: {
	      '&$underline:after': {
	        borderBottomColor: theme.palette.secondary.main
	      }
	    },
	
	    /* Styles applied to the root element if `disableUnderline={false}`. */
	    underline: {
	      '&:after': {
	        borderBottom: "2px solid ".concat(theme.palette.primary.main),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '""',
	        position: 'absolute',
	        right: 0,
	        transform: 'scaleX(0)',
	        transition: theme.transitions.create('transform', {
	          duration: theme.transitions.duration.shorter,
	          easing: theme.transitions.easing.easeOut
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&$focused:after': {
	        transform: 'scaleX(1)'
	      },
	      '&$error:after': {
	        borderBottomColor: theme.palette.error.main,
	        transform: 'scaleX(1)' // error is always underlined in red
	
	      },
	      '&:before': {
	        borderBottom: "1px solid ".concat(bottomLineColor),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '"\\00a0"',
	        position: 'absolute',
	        right: 0,
	        transition: theme.transitions.create('border-bottom-color', {
	          duration: theme.transitions.duration.shorter
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&:hover:before': {
	        borderBottom: "1px solid ".concat(theme.palette.text.primary)
	      },
	      '&$disabled:before': {
	        borderBottomStyle: 'dotted'
	      }
	    },
	
	    /* Pseudo-class applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `startAdornment` is provided. */
	    adornedStart: {
	      paddingLeft: 12
	    },
	
	    /* Styles applied to the root element if `endAdornment` is provided. */
	    adornedEnd: {
	      paddingRight: 12
	    },
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {
	      padding: '27px 12px 10px',
	      '&$marginDense': {
	        paddingTop: 23,
	        paddingBottom: 6
	      }
	    },
	
	    /* Styles applied to the `input` element. */
	    input: {
	      padding: '27px 12px 10px',
	      '&:-webkit-autofill': {
	        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
	        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
	        caretColor: theme.palette.type === 'light' ? null : '#fff',
	        borderTopLeftRadius: 'inherit',
	        borderTopRightRadius: 'inherit'
	      }
	    },
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {
	      paddingTop: 23,
	      paddingBottom: 6
	    },
	
	    /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */
	    inputHiddenLabel: {
	      paddingTop: 18,
	      paddingBottom: 19,
	      '&$inputMarginDense': {
	        paddingTop: 10,
	        paddingBottom: 11
	      }
	    },
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {
	      padding: 0
	    },
	
	    /* Styles applied to the `input` element if `startAdornment` is provided. */
	    inputAdornedStart: {
	      paddingLeft: 0
	    },
	
	    /* Styles applied to the `input` element if `endAdornment` is provided. */
	    inputAdornedEnd: {
	      paddingRight: 0
	    }
	  };
	};
	
	exports.styles = styles;
	var FilledInput = /*#__PURE__*/React.forwardRef(function FilledInput(props, ref) {
	  var disableUnderline = props.disableUnderline,
	      classes = props.classes,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
	  return /*#__PURE__*/React.createElement(_InputBase.default, (0, _extends2.default)({
	    classes: (0, _extends2.default)({}, classes, {
	      root: (0, _clsx.default)(classes.root, !disableUnderline && classes.underline),
	      underline: null
	    }),
	    fullWidth: fullWidth,
	    inputComponent: inputComponent,
	    multiline: multiline,
	    ref: ref,
	    type: type
	  }, other));
	});
	 false ? FilledInput.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will not have an underline.
	   */
	  disableUnderline: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a HTML element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	FilledInput.muiName = 'Input';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFilledInput'
	})(FilledInput);
	
	exports.default = _default;

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(234);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(130));
	
	var _FormControlContext = _interopRequireDefault(__webpack_require__(162));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'inline-flex',
	    flexDirection: 'column',
	    position: 'relative',
	    // Reset fieldset default style.
	    minWidth: 0,
	    padding: 0,
	    margin: 0,
	    border: 0,
	    verticalAlign: 'top' // Fix alignment issue on Safari.
	
	  },
	
	  /* Styles applied to the root element if `margin="normal"`. */
	  marginNormal: {
	    marginTop: 16,
	    marginBottom: 8
	  },
	
	  /* Styles applied to the root element if `margin="dense"`. */
	  marginDense: {
	    marginTop: 8,
	    marginBottom: 4
	  },
	
	  /* Styles applied to the root element if `fullWidth={true}`. */
	  fullWidth: {
	    width: '100%'
	  }
	};
	/**
	 * Provides context such as filled/focused/error/required for form inputs.
	 * Relying on the context provides high flexibility and ensures that the state always stays
	 * consistent across the children of the `FormControl`.
	 * This context is used by the following components:
	 *
	 *  - FormLabel
	 *  - FormHelperText
	 *  - Input
	 *  - InputLabel
	 *
	 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
	 *
	 * ```jsx
	 * <FormControl>
	 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
	 *   <Input id="my-input" aria-describedby="my-helper-text" />
	 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
	 * </FormControl>
	 * ```
	 *
	 * ⚠️Only one input can be used within a FormControl.
	 */
	
	exports.styles = styles;
	var FormControl = /*#__PURE__*/React.forwardRef(function FormControl(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      visuallyFocused = props.focused,
	      _props$hiddenLabel = props.hiddenLabel,
	      hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel,
	      _props$margin = props.margin,
	      margin = _props$margin === void 0 ? 'none' : _props$margin,
	      _props$required = props.required,
	      required = _props$required === void 0 ? false : _props$required,
	      size = props.size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "error", "fullWidth", "focused", "hiddenLabel", "margin", "required", "size", "variant"]);
	
	  var _React$useState = React.useState(function () {
	    // We need to iterate through the children and find the Input in order
	    // to fully support server-side rendering.
	    var initialAdornedStart = false;
	
	    if (children) {
	      React.Children.forEach(children, function (child) {
	        if (!(0, _isMuiElement.default)(child, ['Input', 'Select'])) {
	          return;
	        }
	
	        var input = (0, _isMuiElement.default)(child, ['Select']) ? child.props.input : child;
	
	        if (input && (0, _utils.isAdornedStart)(input.props)) {
	          initialAdornedStart = true;
	        }
	      });
	    }
	
	    return initialAdornedStart;
	  }),
	      adornedStart = _React$useState[0],
	      setAdornedStart = _React$useState[1];
	
	  var _React$useState2 = React.useState(function () {
	    // We need to iterate through the children and find the Input in order
	    // to fully support server-side rendering.
	    var initialFilled = false;
	
	    if (children) {
	      React.Children.forEach(children, function (child) {
	        if (!(0, _isMuiElement.default)(child, ['Input', 'Select'])) {
	          return;
	        }
	
	        if ((0, _utils.isFilled)(child.props, true)) {
	          initialFilled = true;
	        }
	      });
	    }
	
	    return initialFilled;
	  }),
	      filled = _React$useState2[0],
	      setFilled = _React$useState2[1];
	
	  var _React$useState3 = React.useState(false),
	      _focused = _React$useState3[0],
	      setFocused = _React$useState3[1];
	
	  var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;
	
	  if (disabled && focused) {
	    setFocused(false);
	  }
	
	  var registerEffect;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    var registeredInput = React.useRef(false);
	
	    registerEffect = function registerEffect() {
	      if (registeredInput.current) {
	        console.error(['Material-UI: There are multiple InputBase components inside a FormControl.', 'This is not supported. It might cause infinite rendering loops.', 'Only use one InputBase.'].join('\n'));
	      }
	
	      registeredInput.current = true;
	      return function () {
	        registeredInput.current = false;
	      };
	    };
	  }
	
	  var onFilled = React.useCallback(function () {
	    setFilled(true);
	  }, []);
	  var onEmpty = React.useCallback(function () {
	    setFilled(false);
	  }, []);
	  var childContext = {
	    adornedStart: adornedStart,
	    setAdornedStart: setAdornedStart,
	    color: color,
	    disabled: disabled,
	    error: error,
	    filled: filled,
	    focused: focused,
	    fullWidth: fullWidth,
	    hiddenLabel: hiddenLabel,
	    margin: (size === 'small' ? 'dense' : undefined) || margin,
	    onBlur: function onBlur() {
	      setFocused(false);
	    },
	    onEmpty: onEmpty,
	    onFilled: onFilled,
	    onFocus: function onFocus() {
	      setFocused(true);
	    },
	    registerEffect: registerEffect,
	    required: required,
	    variant: variant
	  };
	  return /*#__PURE__*/React.createElement(_FormControlContext.default.Provider, {
	    value: childContext
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, margin !== 'none' && classes["margin".concat((0, _capitalize.default)(margin))], fullWidth && classes.fullWidth),
	    ref: ref
	  }, other), children));
	});
	 false ? FormControl.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The contents of the form control.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the label, input and helper text should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will be displayed in focused state.
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be hidden.
	   * This is used to increase density for a `FilledInput`.
	   * Be sure to add `aria-label` to the `input` element.
	   */
	  hiddenLabel: _propTypes.default.bool,
	
	  /**
	   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none', 'normal']),
	
	  /**
	   * If `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The size of the text field.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormControl'
	})(FormControl);
	
	exports.default = _default;

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _FormControl = __webpack_require__(233);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Typography = _interopRequireDefault(__webpack_require__(66));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      cursor: 'pointer',
	      // For correct alignment with the text.
	      verticalAlign: 'middle',
	      WebkitTapHighlightColor: 'transparent',
	      marginLeft: -11,
	      marginRight: 16,
	      // used for row presentation of radio/checkbox
	      '&$disabled': {
	        cursor: 'default'
	      }
	    },
	
	    /* Styles applied to the root element if `labelPlacement="start"`. */
	    labelPlacementStart: {
	      flexDirection: 'row-reverse',
	      marginLeft: 16,
	      // used for row presentation of radio/checkbox
	      marginRight: -11
	    },
	
	    /* Styles applied to the root element if `labelPlacement="top"`. */
	    labelPlacementTop: {
	      flexDirection: 'column-reverse',
	      marginLeft: 16
	    },
	
	    /* Styles applied to the root element if `labelPlacement="bottom"`. */
	    labelPlacementBottom: {
	      flexDirection: 'column',
	      marginLeft: 16
	    },
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the label's Typography component. */
	    label: {
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      }
	    }
	  };
	};
	/**
	 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
	 * Use this component if you want to display an extra label.
	 */
	
	
	exports.styles = styles;
	var FormControlLabel = /*#__PURE__*/React.forwardRef(function FormControlLabel(props, ref) {
	  var checked = props.checked,
	      classes = props.classes,
	      className = props.className,
	      control = props.control,
	      disabledProp = props.disabled,
	      inputRef = props.inputRef,
	      label = props.label,
	      _props$labelPlacement = props.labelPlacement,
	      labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement,
	      name = props.name,
	      onChange = props.onChange,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]);
	  var muiFormControl = (0, _FormControl.useFormControl)();
	  var disabled = disabledProp;
	
	  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
	    disabled = control.props.disabled;
	  }
	
	  if (typeof disabled === 'undefined' && muiFormControl) {
	    disabled = muiFormControl.disabled;
	  }
	
	  var controlProps = {
	    disabled: disabled
	  };
	  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
	    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
	      controlProps[key] = props[key];
	    }
	  });
	  return /*#__PURE__*/React.createElement("label", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, labelPlacement !== 'end' && classes["labelPlacement".concat((0, _capitalize.default)(labelPlacement))], disabled && classes.disabled),
	    ref: ref
	  }, other), /*#__PURE__*/React.cloneElement(control, controlProps), /*#__PURE__*/React.createElement(_Typography.default, {
	    component: "span",
	    className: (0, _clsx.default)(classes.label, disabled && classes.disabled)
	  }, label));
	});
	 false ? FormControlLabel.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the component appears selected.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
	   */
	  control: _propTypes.default.element.isRequired,
	
	  /**
	   * If `true`, the control will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The text to be used in an enclosing label element.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The position of the label.
	   */
	  labelPlacement: _propTypes.default.oneOf(['bottom', 'end', 'start', 'top']),
	
	  /**
	   * @ignore
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The value of the component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormControlLabel'
	})(FormControlLabel);
	
	exports.default = _default;

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormControlLabel.default;
	  }
	});
	
	var _FormControlLabel = _interopRequireDefault(__webpack_require__(878));

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    flexDirection: 'column',
	    flexWrap: 'wrap'
	  },
	
	  /* Styles applied to the root element if `row={true}`. */
	  row: {
	    flexDirection: 'row'
	  }
	};
	/**
	 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
	 * It provides compact row layout.
	 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
	 */
	
	exports.styles = styles;
	var FormGroup = /*#__PURE__*/React.forwardRef(function FormGroup(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$row = props.row,
	      row = _props$row === void 0 ? false : _props$row,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "row"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, row && classes.row),
	    ref: ref
	  }, other));
	});
	 false ? FormGroup.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Display group of elements in a compact row.
	   */
	  row: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormGroup'
	})(FormGroup);
	
	exports.default = _default;

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(109));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(93));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({
	      color: theme.palette.text.secondary
	    }, theme.typography.caption, {
	      textAlign: 'left',
	      marginTop: 3,
	      margin: 0,
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    }),
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `margin="dense"`. */
	    marginDense: {
	      marginTop: 4
	    },
	
	    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
	    contained: {
	      marginLeft: 14,
	      marginRight: 14
	    },
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `filled={true}`. */
	    filled: {},
	
	    /* Pseudo-class applied to the root element if `required={true}`. */
	    required: {}
	  };
	};
	
	exports.styles = styles;
	var FormHelperText = /*#__PURE__*/React.forwardRef(function FormHelperText(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'p' : _props$component,
	      disabled = props.disabled,
	      error = props.error,
	      filled = props.filled,
	      focused = props.focused,
	      margin = props.margin,
	      required = props.required,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['variant', 'margin', 'disabled', 'error', 'filled', 'focused', 'required']
	  });
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, (fcs.variant === 'filled' || fcs.variant === 'outlined') && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === 'dense' && classes.marginDense),
	    ref: ref
	  }, other), children === ' ' ?
	  /*#__PURE__*/
	  // eslint-disable-next-line react/no-danger
	  React.createElement("span", {
	    dangerouslySetInnerHTML: {
	      __html: '&#8203;'
	    }
	  }) : children);
	});
	 false ? FormHelperText.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   *
	   * If `' '` is provided, the component reserves one line height for displaying a future message.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the helper text should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, helper text should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the helper text should use filled classes key.
	   */
	  filled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the helper text should use focused classes key.
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense']),
	
	  /**
	   * If `true`, the helper text should use required classes key.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormHelperText'
	})(FormHelperText);
	
	exports.default = _default;

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(109));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(93));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({
	      color: theme.palette.text.secondary
	    }, theme.typography.body1, {
	      lineHeight: 1,
	      padding: 0,
	      '&$focused': {
	        color: theme.palette.primary.main
	      },
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    }),
	
	    /* Styles applied to the root element if the color is secondary. */
	    colorSecondary: {
	      '&$focused': {
	        color: theme.palette.secondary.main
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element if `filled={true}`. */
	    filled: {},
	
	    /* Pseudo-class applied to the root element if `required={true}`. */
	    required: {},
	
	    /* Styles applied to the asterisk element. */
	    asterisk: {
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var FormLabel = /*#__PURE__*/React.forwardRef(function FormLabel(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      color = props.color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'label' : _props$component,
	      disabled = props.disabled,
	      error = props.error,
	      filled = props.filled,
	      focused = props.focused,
	      required = props.required,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "error", "filled", "focused", "required"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['color', 'required', 'focused', 'disabled', 'error', 'filled']
	  });
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
	    ref: ref
	  }, other), children, fcs.required && /*#__PURE__*/React.createElement("span", {
	    "aria-hidden": true,
	    className: (0, _clsx.default)(classes.asterisk, fcs.error && classes.error)
	  }, "\u2009", '*'));
	});
	 false ? FormLabel.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the label should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should use filled classes key.
	   */
	  filled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input of this label is focused (used by `FormGroup` components).
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormLabel'
	})(FormLabel);
	
	exports.default = _default;

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _requirePropFactory = _interopRequireDefault(__webpack_require__(398));
	
	// A grid component using the following libs as inspiration.
	//
	// For the implementation:
	// - https://getbootstrap.com/docs/4.3/layout/grid/
	// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
	// - https://github.com/roylee0704/react-flexbox-grid
	// - https://material.angularjs.org/latest/layout/introduction
	//
	// Follow this flexbox Guide to better understand the underlying model:
	// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/
	var SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
	var GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
	
	function generateGrid(globalStyles, theme, breakpoint) {
	  var styles = {};
	  GRID_SIZES.forEach(function (size) {
	    var key = "grid-".concat(breakpoint, "-").concat(size);
	
	    if (size === true) {
	      // For the auto layouting
	      styles[key] = {
	        flexBasis: 0,
	        flexGrow: 1,
	        maxWidth: '100%'
	      };
	      return;
	    }
	
	    if (size === 'auto') {
	      styles[key] = {
	        flexBasis: 'auto',
	        flexGrow: 0,
	        maxWidth: 'none'
	      };
	      return;
	    } // Keep 7 significant numbers.
	
	
	    var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
	    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
	
	    styles[key] = {
	      flexBasis: width,
	      flexGrow: 0,
	      maxWidth: width
	    };
	  }); // No need for a media query for the first size.
	
	  if (breakpoint === 'xs') {
	    (0, _extends2.default)(globalStyles, styles);
	  } else {
	    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
	  }
	}
	
	function getOffset(val) {
	  var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var parse = parseFloat(val);
	  return "".concat(parse / div).concat(String(val).replace(String(parse), '') || 'px');
	}
	
	function generateGutter(theme, breakpoint) {
	  var styles = {};
	  SPACINGS.forEach(function (spacing) {
	    var themeSpacing = theme.spacing(spacing);
	
	    if (themeSpacing === 0) {
	      return;
	    }
	
	    styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
	      margin: "-".concat(getOffset(themeSpacing, 2)),
	      width: "calc(100% + ".concat(getOffset(themeSpacing), ")"),
	      '& > $item': {
	        padding: getOffset(themeSpacing, 2)
	      }
	    };
	  });
	  return styles;
	} // Default CSS values
	// flex: '0 1 auto',
	// flexDirection: 'row',
	// alignItems: 'flex-start',
	// flexWrap: 'nowrap',
	// justifyContent: 'flex-start',
	
	
	var styles = function styles(theme) {
	  return (0, _extends2.default)({
	    /* Styles applied to the root element. */
	    root: {},
	
	    /* Styles applied to the root element if `container={true}`. */
	    container: {
	      boxSizing: 'border-box',
	      display: 'flex',
	      flexWrap: 'wrap',
	      width: '100%'
	    },
	
	    /* Styles applied to the root element if `item={true}`. */
	    item: {
	      boxSizing: 'border-box',
	      margin: '0' // For instance, it's useful when used with a `figure` element.
	
	    },
	
	    /* Styles applied to the root element if `zeroMinWidth={true}`. */
	    zeroMinWidth: {
	      minWidth: 0
	    },
	
	    /* Styles applied to the root element if `direction="column"`. */
	    'direction-xs-column': {
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the root element if `direction="column-reverse"`. */
	    'direction-xs-column-reverse': {
	      flexDirection: 'column-reverse'
	    },
	
	    /* Styles applied to the root element if `direction="row-reverse"`. */
	    'direction-xs-row-reverse': {
	      flexDirection: 'row-reverse'
	    },
	
	    /* Styles applied to the root element if `wrap="nowrap"`. */
	    'wrap-xs-nowrap': {
	      flexWrap: 'nowrap'
	    },
	
	    /* Styles applied to the root element if `wrap="reverse"`. */
	    'wrap-xs-wrap-reverse': {
	      flexWrap: 'wrap-reverse'
	    },
	
	    /* Styles applied to the root element if `alignItems="center"`. */
	    'align-items-xs-center': {
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the root element if `alignItems="flex-start"`. */
	    'align-items-xs-flex-start': {
	      alignItems: 'flex-start'
	    },
	
	    /* Styles applied to the root element if `alignItems="flex-end"`. */
	    'align-items-xs-flex-end': {
	      alignItems: 'flex-end'
	    },
	
	    /* Styles applied to the root element if `alignItems="baseline"`. */
	    'align-items-xs-baseline': {
	      alignItems: 'baseline'
	    },
	
	    /* Styles applied to the root element if `alignContent="center"`. */
	    'align-content-xs-center': {
	      alignContent: 'center'
	    },
	
	    /* Styles applied to the root element if `alignContent="flex-start"`. */
	    'align-content-xs-flex-start': {
	      alignContent: 'flex-start'
	    },
	
	    /* Styles applied to the root element if `alignContent="flex-end"`. */
	    'align-content-xs-flex-end': {
	      alignContent: 'flex-end'
	    },
	
	    /* Styles applied to the root element if `alignContent="space-between"`. */
	    'align-content-xs-space-between': {
	      alignContent: 'space-between'
	    },
	
	    /* Styles applied to the root element if `alignContent="space-around"`. */
	    'align-content-xs-space-around': {
	      alignContent: 'space-around'
	    },
	
	    /* Styles applied to the root element if `justify="center"`. */
	    'justify-xs-center': {
	      justifyContent: 'center'
	    },
	
	    /* Styles applied to the root element if `justify="flex-end"`. */
	    'justify-xs-flex-end': {
	      justifyContent: 'flex-end'
	    },
	
	    /* Styles applied to the root element if `justify="space-between"`. */
	    'justify-xs-space-between': {
	      justifyContent: 'space-between'
	    },
	
	    /* Styles applied to the root element if `justify="space-around"`. */
	    'justify-xs-space-around': {
	      justifyContent: 'space-around'
	    },
	
	    /* Styles applied to the root element if `justify="space-evenly"`. */
	    'justify-xs-space-evenly': {
	      justifyContent: 'space-evenly'
	    }
	  }, generateGutter(theme, 'xs'), theme.breakpoints.keys.reduce(function (accumulator, key) {
	    // Use side effect over immutability for better performance.
	    generateGrid(accumulator, theme, key);
	    return accumulator;
	  }, {}));
	};
	
	exports.styles = styles;
	var Grid = /*#__PURE__*/React.forwardRef(function Grid(props, ref) {
	  var _props$alignContent = props.alignContent,
	      alignContent = _props$alignContent === void 0 ? 'stretch' : _props$alignContent,
	      _props$alignItems = props.alignItems,
	      alignItems = _props$alignItems === void 0 ? 'stretch' : _props$alignItems,
	      classes = props.classes,
	      classNameProp = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$container = props.container,
	      container = _props$container === void 0 ? false : _props$container,
	      _props$direction = props.direction,
	      direction = _props$direction === void 0 ? 'row' : _props$direction,
	      _props$item = props.item,
	      item = _props$item === void 0 ? false : _props$item,
	      _props$justify = props.justify,
	      justify = _props$justify === void 0 ? 'flex-start' : _props$justify,
	      _props$lg = props.lg,
	      lg = _props$lg === void 0 ? false : _props$lg,
	      _props$md = props.md,
	      md = _props$md === void 0 ? false : _props$md,
	      _props$sm = props.sm,
	      sm = _props$sm === void 0 ? false : _props$sm,
	      _props$spacing = props.spacing,
	      spacing = _props$spacing === void 0 ? 0 : _props$spacing,
	      _props$wrap = props.wrap,
	      wrap = _props$wrap === void 0 ? 'wrap' : _props$wrap,
	      _props$xl = props.xl,
	      xl = _props$xl === void 0 ? false : _props$xl,
	      _props$xs = props.xs,
	      xs = _props$xs === void 0 ? false : _props$xs,
	      _props$zeroMinWidth = props.zeroMinWidth,
	      zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth,
	      other = (0, _objectWithoutProperties2.default)(props, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]);
	  var className = (0, _clsx.default)(classes.root, classNameProp, container && [classes.container, spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== 'row' && classes["direction-xs-".concat(String(direction))], wrap !== 'wrap' && classes["wrap-xs-".concat(String(wrap))], alignItems !== 'stretch' && classes["align-items-xs-".concat(String(alignItems))], alignContent !== 'stretch' && classes["align-content-xs-".concat(String(alignContent))], justify !== 'flex-start' && classes["justify-xs-".concat(String(justify))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: className,
	    ref: ref
	  }, other));
	});
	 false ? Grid.propTypes = {
	  /**
	   * Defines the `align-content` style property.
	   * It's applied for all screen sizes.
	   */
	  alignContent: _propTypes.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),
	
	  /**
	   * Defines the `align-items` style property.
	   * It's applied for all screen sizes.
	   */
	  alignItems: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the component will have the flex *container* behavior.
	   * You should be wrapping *items* with a *container*.
	   */
	  container: _propTypes.default.bool,
	
	  /**
	   * Defines the `flex-direction` style property.
	   * It is applied for all screen sizes.
	   */
	  direction: _propTypes.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
	
	  /**
	   * If `true`, the component will have the flex *item* behavior.
	   * You should be wrapping *items* with a *container*.
	   */
	  item: _propTypes.default.bool,
	
	  /**
	   * Defines the `justify-content` style property.
	   * It is applied for all screen sizes.
	   */
	  justify: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `lg` breakpoint and wider screens if not overridden.
	   */
	  lg: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `md` breakpoint and wider screens if not overridden.
	   */
	  md: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `sm` breakpoint and wider screens if not overridden.
	   */
	  sm: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the space between the type `item` component.
	   * It can only be used on a type `container` component.
	   */
	  spacing: _propTypes.default.oneOf(SPACINGS),
	
	  /**
	   * Defines the `flex-wrap` style property.
	   * It's applied for all screen sizes.
	   */
	  wrap: _propTypes.default.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `xl` breakpoint and wider screens.
	   */
	  xl: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for all the screen sizes with the lowest priority.
	   */
	  xs: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * If `true`, it sets `min-width: 0` on the item.
	   * Refer to the limitations section of the documentation to better understand the use case.
	   */
	  zeroMinWidth: _propTypes.default.bool
	} : void 0;
	var StyledGrid = (0, _withStyles.default)(styles, {
	  name: 'MuiGrid'
	})(Grid);
	
	if (false) {
	  var requireProp = (0, _requirePropFactory.default)('Grid');
	  StyledGrid.propTypes = (0, _extends2.default)({}, StyledGrid.propTypes, {
	    alignContent: requireProp('container'),
	    alignItems: requireProp('container'),
	    direction: requireProp('container'),
	    justify: requireProp('container'),
	    lg: requireProp('item'),
	    md: requireProp('item'),
	    sm: requireProp('item'),
	    spacing: requireProp('container'),
	    wrap: requireProp('container'),
	    xs: requireProp('item'),
	    zeroMinWidth: requireProp('item')
	  });
	}
	
	var _default = StyledGrid;
	exports.default = _default;

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Grid.default;
	  }
	});
	
	var _Grid = _interopRequireDefault(__webpack_require__(883));

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(67);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    flexWrap: 'wrap',
	    overflowY: 'auto',
	    listStyle: 'none',
	    padding: 0,
	    WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.
	
	  }
	};
	exports.styles = styles;
	var GridList = /*#__PURE__*/React.forwardRef(function GridList(props, ref) {
	  var _props$cellHeight = props.cellHeight,
	      cellHeight = _props$cellHeight === void 0 ? 180 : _props$cellHeight,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$cols = props.cols,
	      cols = _props$cols === void 0 ? 2 : _props$cols,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'ul' : _props$component,
	      _props$spacing = props.spacing,
	      spacing = _props$spacing === void 0 ? 4 : _props$spacing,
	      style = props.style,
	      other = (0, _objectWithoutProperties2.default)(props, ["cellHeight", "children", "classes", "className", "cols", "component", "spacing", "style"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref,
	    style: (0, _extends2.default)({
	      margin: -spacing / 2
	    }, style)
	  }, other), React.Children.map(children, function (child) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The GridList component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var childCols = child.props.cols || 1;
	    var childRows = child.props.rows || 1;
	    return /*#__PURE__*/React.cloneElement(child, {
	      style: (0, _extends2.default)({
	        width: "".concat(100 / cols * childCols, "%"),
	        height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + spacing,
	        padding: spacing / 2
	      }, child.props.style)
	    });
	  }));
	});
	 false ? GridList.propTypes = {
	  /**
	   * Number of px for one cell height.
	   * You can set `'auto'` if you want to let the children determine the height.
	   */
	  cellHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]),
	
	  /**
	   * Grid Tiles that will be in Grid List.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Number of columns.
	   */
	  cols: _propTypes.default.number,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Number of px for the spacing between tiles.
	   */
	  spacing: _propTypes.default.number,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridList'
	})(GridList);
	
	exports.default = _default;

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _GridList.default;
	  }
	});
	
	var _GridList = _interopRequireDefault(__webpack_require__(885));

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(46));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _debounce = _interopRequireDefault(__webpack_require__(94));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(130));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    boxSizing: 'border-box',
	    flexShrink: 0
	  },
	
	  /* Styles applied to the `div` element that wraps the children. */
	  tile: {
	    position: 'relative',
	    display: 'block',
	    // In case it's not rendered with a div.
	    height: '100%',
	    overflow: 'hidden'
	  },
	
	  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
	  imgFullHeight: {
	    height: '100%',
	    transform: 'translateX(-50%)',
	    position: 'relative',
	    left: '50%'
	  },
	
	  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
	  imgFullWidth: {
	    width: '100%',
	    position: 'relative',
	    transform: 'translateY(-50%)',
	    top: '50%'
	  }
	};
	exports.styles = styles;
	
	var fit = function fit(imgEl, classes) {
	  if (!imgEl || !imgEl.complete) {
	    return;
	  }
	
	  if (imgEl.width / imgEl.height > imgEl.parentElement.offsetWidth / imgEl.parentElement.offsetHeight) {
	    var _imgEl$classList, _imgEl$classList2;
	
	    (_imgEl$classList = imgEl.classList).remove.apply(_imgEl$classList, (0, _toConsumableArray2.default)(classes.imgFullWidth.split(' ')));
	
	    (_imgEl$classList2 = imgEl.classList).add.apply(_imgEl$classList2, (0, _toConsumableArray2.default)(classes.imgFullHeight.split(' ')));
	  } else {
	    var _imgEl$classList3, _imgEl$classList4;
	
	    (_imgEl$classList3 = imgEl.classList).remove.apply(_imgEl$classList3, (0, _toConsumableArray2.default)(classes.imgFullHeight.split(' ')));
	
	    (_imgEl$classList4 = imgEl.classList).add.apply(_imgEl$classList4, (0, _toConsumableArray2.default)(classes.imgFullWidth.split(' ')));
	  }
	};
	
	function ensureImageCover(imgEl, classes) {
	  if (!imgEl) {
	    return;
	  }
	
	  if (imgEl.complete) {
	    fit(imgEl, classes);
	  } else {
	    imgEl.addEventListener('load', function () {
	      fit(imgEl, classes);
	    });
	  }
	}
	
	var GridListTile = /*#__PURE__*/React.forwardRef(function GridListTile(props, ref) {
	  // cols rows default values are for docs only
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$cols = props.cols,
	      cols = _props$cols === void 0 ? 1 : _props$cols,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'li' : _props$component,
	      _props$rows = props.rows,
	      rows = _props$rows === void 0 ? 1 : _props$rows,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "cols", "component", "rows"]);
	  var imgRef = React.useRef(null);
	  React.useEffect(function () {
	    ensureImageCover(imgRef.current, classes);
	  });
	  React.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      fit(imgRef.current, classes);
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [classes]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: classes.tile
	  }, React.Children.map(children, function (child) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return null;
	    }
	
	    if (child.type === 'img' || (0, _isMuiElement.default)(child, ['Image'])) {
	      return /*#__PURE__*/React.cloneElement(child, {
	        ref: imgRef
	      });
	    }
	
	    return child;
	  })));
	});
	 false ? GridListTile.propTypes = {
	  /**
	   * Theoretically you can pass any node as children, but the main use case is to pass an img,
	   * in which case GridListTile takes care of making the image "cover" available space
	   * (similar to `background-size: cover` or to `object-fit: cover`).
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Width of the tile in number of grid cells.
	   */
	  cols: _propTypes.default.number,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Height of the tile in number of grid cells.
	   */
	  rows: _propTypes.default.number
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridListTile'
	})(GridListTile);
	
	exports.default = _default;

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTile.default;
	  }
	});
	
	var _GridListTile = _interopRequireDefault(__webpack_require__(887));

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'absolute',
	      left: 0,
	      right: 0,
	      height: 48,
	      background: 'rgba(0, 0, 0, 0.5)',
	      display: 'flex',
	      alignItems: 'center',
	      fontFamily: theme.typography.fontFamily
	    },
	
	    /* Styles applied to the root element if `titlePosition="bottom"`. */
	    titlePositionBottom: {
	      bottom: 0
	    },
	
	    /* Styles applied to the root element if `titlePosition="top"`. */
	    titlePositionTop: {
	      top: 0
	    },
	
	    /* Styles applied to the root element if a `subtitle` is provided. */
	    rootSubtitle: {
	      height: 68
	    },
	
	    /* Styles applied to the title and subtitle container element. */
	    titleWrap: {
	      flexGrow: 1,
	      marginLeft: 16,
	      marginRight: 16,
	      color: theme.palette.common.white,
	      overflow: 'hidden'
	    },
	
	    /* Styles applied to the container element if `actionPosition="left"`. */
	    titleWrapActionPosLeft: {
	      marginLeft: 0
	    },
	
	    /* Styles applied to the container element if `actionPosition="right"`. */
	    titleWrapActionPosRight: {
	      marginRight: 0
	    },
	
	    /* Styles applied to the title container element. */
	    title: {
	      fontSize: theme.typography.pxToRem(16),
	      lineHeight: '24px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the subtitle container element. */
	    subtitle: {
	      fontSize: theme.typography.pxToRem(12),
	      lineHeight: 1,
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the actionIcon if supplied. */
	    actionIcon: {},
	
	    /* Styles applied to the actionIcon if `actionPosition="left"`. */
	    actionIconActionPosLeft: {
	      order: -1
	    }
	  };
	};
	
	exports.styles = styles;
	var GridListTileBar = /*#__PURE__*/React.forwardRef(function GridListTileBar(props, ref) {
	  var actionIcon = props.actionIcon,
	      _props$actionPosition = props.actionPosition,
	      actionPosition = _props$actionPosition === void 0 ? 'right' : _props$actionPosition,
	      classes = props.classes,
	      className = props.className,
	      subtitle = props.subtitle,
	      title = props.title,
	      _props$titlePosition = props.titlePosition,
	      titlePosition = _props$titlePosition === void 0 ? 'bottom' : _props$titlePosition,
	      other = (0, _objectWithoutProperties2.default)(props, ["actionIcon", "actionPosition", "classes", "className", "subtitle", "title", "titlePosition"]);
	  var actionPos = actionIcon && actionPosition;
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, titlePosition === 'top' ? classes.titlePositionTop : classes.titlePositionBottom, subtitle && classes.rootSubtitle),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.titleWrap, {
	      'left': classes.titleWrapActionPosLeft,
	      'right': classes.titleWrapActionPosRight
	    }[actionPos])
	  }, /*#__PURE__*/React.createElement("div", {
	    className: classes.title
	  }, title), subtitle ? /*#__PURE__*/React.createElement("div", {
	    className: classes.subtitle
	  }, subtitle) : null), actionIcon ? /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.actionIcon, actionPos === 'left' && classes.actionIconActionPosLeft)
	  }, actionIcon) : null);
	});
	 false ? GridListTileBar.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * An IconButton element to be used as secondary action target
	   * (primary action target is the tile itself).
	   */
	  actionIcon: _propTypes.default.node,
	
	  /**
	   * Position of secondary action IconButton.
	   */
	  actionPosition: _propTypes.default.oneOf(['left', 'right']),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * String or element serving as subtitle (support text).
	   */
	  subtitle: _propTypes.default.node,
	
	  /**
	   * Title to be displayed on tile.
	   */
	  title: _propTypes.default.node,
	
	  /**
	   * Position of the title bar.
	   */
	  titlePosition: _propTypes.default.oneOf(['bottom', 'top'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridListTileBar'
	})(GridListTileBar);
	
	exports.default = _default;

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTileBar.default;
	  }
	});
	
	var _GridListTileBar = _interopRequireDefault(__webpack_require__(889));

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _reactTransitionGroup = __webpack_require__(123);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(47));
	
	var _utils = __webpack_require__(110);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	function getScale(value) {
	  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
	}
	
	var styles = {
	  entering: {
	    opacity: 1,
	    transform: getScale(1)
	  },
	  entered: {
	    opacity: 1,
	    transform: 'none'
	  }
	};
	/**
	 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
	 * [Popover](/components/popover/) components.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Grow = /*#__PURE__*/React.forwardRef(function Grow(props, ref) {
	  var children = props.children,
	      _props$disableStrictM = props.disableStrictModeCompat,
	      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? 'auto' : _props$timeout,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _reactTransitionGroup.Transition : _props$TransitionComp,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);
	  var timer = React.useRef();
	  var autoTimeout = React.useRef();
	  var theme = (0, _useTheme.default)();
	  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
	  var nodeRef = React.useRef(null);
	  var foreignRef = (0, _useForkRef.default)(children.ref, ref);
	  var handleRef = (0, _useForkRef.default)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
	
	  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
	    return function (nodeOrAppearing, maybeAppearing) {
	      if (callback) {
	        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
	            _ref2 = (0, _slicedToArray2.default)(_ref, 2),
	            node = _ref2[0],
	            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
	
	
	        if (isAppearing === undefined) {
	          callback(node);
	        } else {
	          callback(node, isAppearing);
	        }
	      }
	    };
	  };
	
	  var handleEntering = normalizedTransitionCallback(onEntering);
	  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
	    (0, _utils.reflow)(node); // So the animation always start from the start.
	
	    var _getTransitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    }),
	        transitionDuration = _getTransitionProps.duration,
	        delay = _getTransitionProps.delay;
	
	    var duration;
	
	    if (timeout === 'auto') {
	      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
	      autoTimeout.current = duration;
	    } else {
	      duration = transitionDuration;
	    }
	
	    node.style.transition = [theme.transitions.create('opacity', {
	      duration: duration,
	      delay: delay
	    }), theme.transitions.create('transform', {
	      duration: duration * 0.666,
	      delay: delay
	    })].join(',');
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  });
	  var handleEntered = normalizedTransitionCallback(onEntered);
	  var handleExiting = normalizedTransitionCallback(onExiting);
	  var handleExit = normalizedTransitionCallback(function (node) {
	    var _getTransitionProps2 = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    }),
	        transitionDuration = _getTransitionProps2.duration,
	        delay = _getTransitionProps2.delay;
	
	    var duration;
	
	    if (timeout === 'auto') {
	      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
	      autoTimeout.current = duration;
	    } else {
	      duration = transitionDuration;
	    }
	
	    node.style.transition = [theme.transitions.create('opacity', {
	      duration: duration,
	      delay: delay
	    }), theme.transitions.create('transform', {
	      duration: duration * 0.666,
	      delay: delay || duration * 0.333
	    })].join(',');
	    node.style.opacity = '0';
	    node.style.transform = getScale(0.75);
	
	    if (onExit) {
	      onExit(node);
	    }
	  });
	  var handleExited = normalizedTransitionCallback(onExited);
	
	  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
	    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
	
	    if (timeout === 'auto') {
	      timer.current = setTimeout(next, autoTimeout.current || 0);
	    }
	  };
	
	  React.useEffect(function () {
	    return function () {
	      clearTimeout(timer.current);
	    };
	  }, []);
	  return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: inProp,
	    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
	    onEnter: handleEnter,
	    onEntered: handleEntered,
	    onEntering: handleEntering,
	    onExit: handleExit,
	    onExited: handleExited,
	    onExiting: handleExiting,
	    addEndListener: addEndListener,
	    timeout: timeout === 'auto' ? null : timeout
	  }, other), function (state, childProps) {
	    return /*#__PURE__*/React.cloneElement(children, (0, _extends2.default)({
	      style: (0, _extends2.default)({
	        opacity: 0,
	        transform: getScale(0.75),
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, styles[state], style, children.props.style),
	      ref: handleRef
	    }, childProps));
	  });
	});
	 false ? Grow.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * Enable this prop if you encounter 'Function components cannot be given refs',
	   * use `unstable_createStrictModeTheme`,
	   * and can't forward the ref in the child component.
	   */
	  disableStrictModeCompat: _propTypes.default.bool,
	
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	Grow.muiSupportAuto = true;
	var _default = Grow;
	exports.default = _default;

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _HiddenJs = _interopRequireDefault(__webpack_require__(894));
	
	var _HiddenCss = _interopRequireDefault(__webpack_require__(893));
	
	/**
	 * Responsively hides children based on the selected implementation.
	 */
	function Hidden(props) {
	  var _props$implementation = props.implementation,
	      implementation = _props$implementation === void 0 ? 'js' : _props$implementation,
	      _props$lgDown = props.lgDown,
	      lgDown = _props$lgDown === void 0 ? false : _props$lgDown,
	      _props$lgUp = props.lgUp,
	      lgUp = _props$lgUp === void 0 ? false : _props$lgUp,
	      _props$mdDown = props.mdDown,
	      mdDown = _props$mdDown === void 0 ? false : _props$mdDown,
	      _props$mdUp = props.mdUp,
	      mdUp = _props$mdUp === void 0 ? false : _props$mdUp,
	      _props$smDown = props.smDown,
	      smDown = _props$smDown === void 0 ? false : _props$smDown,
	      _props$smUp = props.smUp,
	      smUp = _props$smUp === void 0 ? false : _props$smUp,
	      _props$xlDown = props.xlDown,
	      xlDown = _props$xlDown === void 0 ? false : _props$xlDown,
	      _props$xlUp = props.xlUp,
	      xlUp = _props$xlUp === void 0 ? false : _props$xlUp,
	      _props$xsDown = props.xsDown,
	      xsDown = _props$xsDown === void 0 ? false : _props$xsDown,
	      _props$xsUp = props.xsUp,
	      xsUp = _props$xsUp === void 0 ? false : _props$xsUp,
	      other = (0, _objectWithoutProperties2.default)(props, ["implementation", "lgDown", "lgUp", "mdDown", "mdUp", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"]);
	
	  if (implementation === 'js') {
	    return /*#__PURE__*/React.createElement(_HiddenJs.default, (0, _extends2.default)({
	      lgDown: lgDown,
	      lgUp: lgUp,
	      mdDown: mdDown,
	      mdUp: mdUp,
	      smDown: smDown,
	      smUp: smUp,
	      xlDown: xlDown,
	      xlUp: xlUp,
	      xsDown: xsDown,
	      xsUp: xsUp
	    }, other));
	  }
	
	  return /*#__PURE__*/React.createElement(_HiddenCss.default, (0, _extends2.default)({
	    lgDown: lgDown,
	    lgUp: lgUp,
	    mdDown: mdDown,
	    mdUp: mdUp,
	    smDown: smDown,
	    smUp: smUp,
	    xlDown: xlDown,
	    xlUp: xlUp,
	    xsDown: xsDown,
	    xsUp: xsUp
	  }, other));
	}
	
	 false ? Hidden.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for
	   * server-side rendering.
	   */
	  implementation: _propTypes.default.oneOf(['js', 'css']),
	
	  /**
	   * You can use this prop when choosing the `js` implementation with server-side rendering.
	   *
	   * As `window.innerWidth` is unavailable on the server,
	   * we default to rendering an empty component during the first mount.
	   * You might want to use an heuristic to approximate
	   * the screen width of the client browser screen width.
	   *
	   * For instance, you could be using the user-agent or the client-hints.
	   * https://caniuse.com/#search=client%20hint
	   */
	  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes.default.bool,
	
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  smDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  smUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes.default.bool
	} : void 0;
	var _default = Hidden;
	exports.default = _default;

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(47));
	
	var styles = function styles(theme) {
	  var hidden = {
	    display: 'none'
	  };
	  return theme.breakpoints.keys.reduce(function (acc, key) {
	    acc["only".concat((0, _capitalize.default)(key))] = (0, _defineProperty2.default)({}, theme.breakpoints.only(key), hidden);
	    acc["".concat(key, "Up")] = (0, _defineProperty2.default)({}, theme.breakpoints.up(key), hidden);
	    acc["".concat(key, "Down")] = (0, _defineProperty2.default)({}, theme.breakpoints.down(key), hidden);
	    return acc;
	  }, {});
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	function HiddenCss(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      only = props.only,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "only"]);
	  var theme = (0, _useTheme.default)();
	
	  if (false) {
	    var unknownProps = Object.keys(other).filter(function (propName) {
	      var isUndeclaredBreakpoint = !theme.breakpoints.keys.some(function (breakpoint) {
	        return "".concat(breakpoint, "Up") === propName || "".concat(breakpoint, "Down") === propName;
	      });
	      return isUndeclaredBreakpoint;
	    });
	
	    if (unknownProps.length > 0) {
	      console.error("Material-UI: Unsupported props received by `<Hidden implementation=\"css\" />`: ".concat(unknownProps.join(', '), ". Did you forget to wrap this component in a ThemeProvider declaring these breakpoints?"));
	    }
	  }
	
	  var clsx = [];
	
	  if (className) {
	    clsx.push(className);
	  }
	
	  for (var i = 0; i < theme.breakpoints.keys.length; i += 1) {
	    var breakpoint = theme.breakpoints.keys[i];
	    var breakpointUp = props["".concat(breakpoint, "Up")];
	    var breakpointDown = props["".concat(breakpoint, "Down")];
	
	    if (breakpointUp) {
	      clsx.push(classes["".concat(breakpoint, "Up")]);
	    }
	
	    if (breakpointDown) {
	      clsx.push(classes["".concat(breakpoint, "Down")]);
	    }
	  }
	
	  if (only) {
	    var onlyBreakpoints = Array.isArray(only) ? only : [only];
	    onlyBreakpoints.forEach(function (breakpoint) {
	      clsx.push(classes["only".concat((0, _capitalize.default)(breakpoint))]);
	    });
	  }
	
	  return /*#__PURE__*/React.createElement("div", {
	    className: clsx.join(' ')
	  }, children);
	}
	
	 false ? HiddenCss.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for
	   * server-side rendering.
	   */
	  implementation: _propTypes.default.oneOf(['js', 'css']),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes.default.bool,
	
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  smDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  smUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateHiddenCss'
	})(HiddenCss);
	
	exports.default = _default;

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _utils = __webpack_require__(22);
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(240));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(47));
	
	/**
	 * @ignore - internal component.
	 */
	function HiddenJs(props) {
	  var children = props.children,
	      only = props.only,
	      width = props.width;
	  var theme = (0, _useTheme.default)();
	  var visible = true; // `only` check is faster to get out sooner if used.
	
	  if (only) {
	    if (Array.isArray(only)) {
	      for (var i = 0; i < only.length; i += 1) {
	        var breakpoint = only[i];
	
	        if (width === breakpoint) {
	          visible = false;
	          break;
	        }
	      }
	    } else if (only && width === only) {
	      visible = false;
	    }
	  } // Allow `only` to be combined with other props. If already hidden, no need to check others.
	
	
	  if (visible) {
	    // determine visibility based on the smallest size up
	    for (var _i = 0; _i < theme.breakpoints.keys.length; _i += 1) {
	      var _breakpoint = theme.breakpoints.keys[_i];
	      var breakpointUp = props["".concat(_breakpoint, "Up")];
	      var breakpointDown = props["".concat(_breakpoint, "Down")];
	
	      if (breakpointUp && (0, _withWidth.isWidthUp)(_breakpoint, width) || breakpointDown && (0, _withWidth.isWidthDown)(_breakpoint, width)) {
	        visible = false;
	        break;
	      }
	    }
	  }
	
	  if (!visible) {
	    return null;
	  }
	
	  return children;
	}
	
	HiddenJs.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for
	   * server-side rendering.
	   */
	  implementation: _propTypes.default.oneOf(['js', 'css']),
	
	  /**
	   * You can use this prop when choosing the `js` implementation with server-side rendering.
	   *
	   * As `window.innerWidth` is unavailable on the server,
	   * we default to rendering an empty component during the first mount.
	   * You might want to use an heuristic to approximate
	   * the screen width of the client browser screen width.
	   *
	   * For instance, you could be using the user-agent or the client-hints.
	   * https://caniuse.com/#search=client%20hint
	   */
	  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes.default.bool,
	
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  smDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  smUp: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * width prop provided by withWidth decorator.
	   */
	  width: _propTypes.default.string.isRequired,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes.default.bool
	};
	
	if (false) {
	  HiddenJs.propTypes = (0, _utils.exactProp)(HiddenJs.propTypes);
	}
	
	var _default = (0, _withWidth.default)()(HiddenJs);
	
	exports.default = _default;

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Hidden.default;
	  }
	});
	
	var _Hidden = _interopRequireDefault(__webpack_require__(892));

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      userSelect: 'none',
	      fontSize: theme.typography.pxToRem(24),
	      width: '1em',
	      height: '1em',
	      // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
	      // To remove at some point.
	      overflow: 'hidden',
	      flexShrink: 0
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="action"`. */
	    colorAction: {
	      color: theme.palette.action.active
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `color="disabled"`. */
	    colorDisabled: {
	      color: theme.palette.action.disabled
	    },
	
	    /* Styles applied to the root element if `fontSize="inherit"`. */
	    fontSizeInherit: {
	      fontSize: 'inherit'
	    },
	
	    /* Styles applied to the root element if `fontSize="small"`. */
	    fontSizeSmall: {
	      fontSize: theme.typography.pxToRem(20)
	    },
	
	    /* Styles applied to the root element if `fontSize="large"`. */
	    fontSizeLarge: {
	      fontSize: theme.typography.pxToRem(36)
	    }
	  };
	};
	
	exports.styles = styles;
	var Icon = /*#__PURE__*/React.forwardRef(function Icon(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'inherit' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'span' : _props$component,
	      _props$fontSize = props.fontSize,
	      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "component", "fontSize"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)('material-icons', classes.root, className, color !== 'inherit' && classes["color".concat((0, _capitalize.default)(color))], fontSize !== 'default' && classes["fontSize".concat((0, _capitalize.default)(fontSize))]),
	    "aria-hidden": true,
	    ref: ref
	  }, other));
	});
	 false ? Icon.propTypes = {
	  /**
	   * The name of the icon font ligature.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
	   */
	  fontSize: _propTypes.default.oneOf(['inherit', 'default', 'small', 'large'])
	} : void 0;
	Icon.muiName = 'Icon';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiIcon'
	})(Icon);
	
	exports.default = _default;

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Icon.default;
	  }
	});
	
	var _Icon = _interopRequireDefault(__webpack_require__(896));

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _colorManipulator = __webpack_require__(49);
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(56));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      textAlign: 'center',
	      flex: '0 0 auto',
	      fontSize: theme.typography.pxToRem(24),
	      padding: 12,
	      borderRadius: '50%',
	      overflow: 'visible',
	      // Explicitly set the default value to solve a bug on IE 11.
	      color: theme.palette.action.active,
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        backgroundColor: 'transparent',
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `edge="start"`. */
	    edgeStart: {
	      marginLeft: -12,
	      '$sizeSmall&': {
	        marginLeft: -3
	      }
	    },
	
	    /* Styles applied to the root element if `edge="end"`. */
	    edgeEnd: {
	      marginRight: -12,
	      '$sizeSmall&': {
	        marginRight: -3
	      }
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      padding: 3,
	      fontSize: theme.typography.pxToRem(18)
	    },
	
	    /* Styles applied to the children container element. */
	    label: {
	      width: '100%',
	      display: 'flex',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    }
	  };
	};
	/**
	 * Refer to the [Icons](/components/icons/) section of the documentation
	 * regarding the available icon options.
	 */
	
	
	exports.styles = styles;
	var IconButton = /*#__PURE__*/React.forwardRef(function IconButton(props, ref) {
	  var _props$edge = props.edge,
	      edge = _props$edge === void 0 ? false : _props$edge,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      other = (0, _objectWithoutProperties2.default)(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'default' && classes["color".concat((0, _capitalize.default)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, _capitalize.default)(size))], {
	      'start': classes.edgeStart,
	      'end': classes.edgeEnd
	    }[edge]),
	    centerRipple: true,
	    focusRipple: !disableFocusRipple,
	    disabled: disabled,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.label
	  }, children));
	});
	 false ? IconButton.propTypes = {
	  /**
	   * The icon element.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node, function (props) {
	    var found = React.Children.toArray(props.children).some(function (child) {
	      return /*#__PURE__*/React.isValidElement(child) && child.props.onClick;
	    });
	
	    if (found) {
	      return new Error(['Material-UI: You are providing an onClick event listener ' + 'to a child of a button element.', 'Firefox will never trigger the event.', 'You should move the onClick listener to the parent button element.', 'https://github.com/mui-org/material-ui/issues/13957'].join('\n'));
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If given, uses a negative margin to counteract the padding on one
	   * side (this is often helpful for aligning the left or right
	   * side of the icon with content above or below, without ruining the border
	   * size and shape).
	   */
	  edge: _propTypes.default.oneOf(['start', 'end', false]),
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiIconButton'
	})(IconButton);
	
	exports.default = _default;

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _InputBase = _interopRequireDefault(__webpack_require__(126));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative'
	    },
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {
	      'label + &': {
	        marginTop: 16
	      }
	    },
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if color secondary. */
	    colorSecondary: {
	      '&$underline:after': {
	        borderBottomColor: theme.palette.secondary.main
	      }
	    },
	
	    /* Styles applied to the root element if `disableUnderline={false}`. */
	    underline: {
	      '&:after': {
	        borderBottom: "2px solid ".concat(theme.palette.primary.main),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '""',
	        position: 'absolute',
	        right: 0,
	        transform: 'scaleX(0)',
	        transition: theme.transitions.create('transform', {
	          duration: theme.transitions.duration.shorter,
	          easing: theme.transitions.easing.easeOut
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&$focused:after': {
	        transform: 'scaleX(1)'
	      },
	      '&$error:after': {
	        borderBottomColor: theme.palette.error.main,
	        transform: 'scaleX(1)' // error is always underlined in red
	
	      },
	      '&:before': {
	        borderBottom: "1px solid ".concat(bottomLineColor),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '"\\00a0"',
	        position: 'absolute',
	        right: 0,
	        transition: theme.transitions.create('border-bottom-color', {
	          duration: theme.transitions.duration.shorter
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&:hover:not($disabled):before': {
	        borderBottom: "2px solid ".concat(theme.palette.text.primary),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          borderBottom: "1px solid ".concat(bottomLineColor)
	        }
	      },
	      '&$disabled:before': {
	        borderBottomStyle: 'dotted'
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {},
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {},
	
	    /* Styles applied to the `input` element. */
	    input: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {},
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {},
	
	    /* Styles applied to the `input` element if `type="search"`. */
	    inputTypeSearch: {}
	  };
	};
	
	exports.styles = styles;
	var Input = /*#__PURE__*/React.forwardRef(function Input(props, ref) {
	  var disableUnderline = props.disableUnderline,
	      classes = props.classes,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
	  return /*#__PURE__*/React.createElement(_InputBase.default, (0, _extends2.default)({
	    classes: (0, _extends2.default)({}, classes, {
	      root: (0, _clsx.default)(classes.root, !disableUnderline && classes.underline),
	      underline: null
	    }),
	    fullWidth: fullWidth,
	    inputComponent: inputComponent,
	    multiline: multiline,
	    ref: ref,
	    type: type
	  }, other));
	});
	 false ? Input.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will not have an underline.
	   */
	  disableUnderline: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a HTML element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	Input.muiName = 'Input';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInput'
	})(Input);
	
	exports.default = _default;

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _Typography = _interopRequireDefault(__webpack_require__(66));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _FormControlContext = _interopRequireWildcard(__webpack_require__(162));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    height: '0.01em',
	    // Fix IE 11 flexbox alignment. To remove at some point.
	    maxHeight: '2em',
	    alignItems: 'center',
	    whiteSpace: 'nowrap'
	  },
	
	  /* Styles applied to the root element if `variant="filled"`. */
	  filled: {
	    '&$positionStart:not($hiddenLabel)': {
	      marginTop: 16
	    }
	  },
	
	  /* Styles applied to the root element if `position="start"`. */
	  positionStart: {
	    marginRight: 8
	  },
	
	  /* Styles applied to the root element if `position="end"`. */
	  positionEnd: {
	    marginLeft: 8
	  },
	
	  /* Styles applied to the root element if `disablePointerEvents=true`. */
	  disablePointerEvents: {
	    pointerEvents: 'none'
	  },
	
	  /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */
	  hiddenLabel: {},
	
	  /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */
	  marginDense: {}
	};
	exports.styles = styles;
	var InputAdornment = /*#__PURE__*/React.forwardRef(function InputAdornment(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disablePointer = props.disablePointerEvents,
	      disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      position = props.position,
	      variantProp = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"]);
	  var muiFormControl = (0, _FormControlContext.useFormControl)() || {};
	  var variant = variantProp;
	
	  if (variantProp && muiFormControl.variant) {
	    if (false) {
	      if (variantProp === muiFormControl.variant) {
	        console.error('Material-UI: The `InputAdornment` variant infers the variant prop ' + 'you do not have to provide one.');
	      }
	    }
	  }
	
	  if (muiFormControl && !variant) {
	    variant = muiFormControl.variant;
	  }
	
	  return /*#__PURE__*/React.createElement(_FormControlContext.default.Provider, {
	    value: null
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, disablePointerEvents && classes.disablePointerEvents, muiFormControl.hiddenLabel && classes.hiddenLabel, variant === 'filled' && classes.filled, {
	      'start': classes.positionStart,
	      'end': classes.positionEnd
	    }[position], muiFormControl.margin === 'dense' && classes.marginDense),
	    ref: ref
	  }, other), typeof children === 'string' && !disableTypography ? /*#__PURE__*/React.createElement(_Typography.default, {
	    color: "textSecondary"
	  }, children) : children));
	});
	 false ? InputAdornment.propTypes = {
	  /**
	   * The content of the component, normally an `IconButton` or string.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Disable pointer events on the root.
	   * This allows for the content of the adornment to focus the input on click.
	   */
	  disablePointerEvents: _propTypes.default.bool,
	
	  /**
	   * If children is a string then disable wrapping in a Typography component.
	   */
	  disableTypography: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  muiFormControl: _propTypes.default.object,
	
	  /**
	   * The position this adornment should appear relative to the `Input`.
	   */
	  position: _propTypes.default.oneOf(['start', 'end']),
	
	  /**
	   * The variant to use.
	   * Note: If you are using the `TextField` component or the `FormControl` component
	   * you do not have to set this manually.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInputAdornment'
	})(InputAdornment);
	
	exports.default = _default;

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _InputAdornment.default;
	  }
	});
	
	var _InputAdornment = _interopRequireDefault(__webpack_require__(900));

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(22);
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(109));
	
	var _FormControlContext = _interopRequireWildcard(__webpack_require__(162));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	var _TextareaAutosize = _interopRequireDefault(__webpack_require__(378));
	
	var _utils2 = __webpack_require__(234);
	
	/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
	var styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var placeholder = {
	    color: 'currentColor',
	    opacity: light ? 0.42 : 0.5,
	    transition: theme.transitions.create('opacity', {
	      duration: theme.transitions.duration.shorter
	    })
	  };
	  var placeholderHidden = {
	    opacity: '0 !important'
	  };
	  var placeholderVisible = {
	    opacity: light ? 0.42 : 0.5
	  };
	  return {
	    '@global': {
	      '@keyframes mui-auto-fill': {},
	      '@keyframes mui-auto-fill-cancel': {}
	    },
	
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.body1, {
	      color: theme.palette.text.primary,
	      lineHeight: '1.1876em',
	      // Reset (19px), match the native input line-height
	      boxSizing: 'border-box',
	      // Prevent padding issue with fullWidth.
	      position: 'relative',
	      cursor: 'text',
	      display: 'inline-flex',
	      alignItems: 'center',
	      '&$disabled': {
	        color: theme.palette.text.disabled,
	        cursor: 'default'
	      }
	    }),
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {},
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `startAdornment` is provided. */
	    adornedStart: {},
	
	    /* Styles applied to the root element if `endAdornment` is provided. */
	    adornedEnd: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {
	      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
	      '&$marginDense': {
	        paddingTop: 4 - 1
	      }
	    },
	
	    /* Styles applied to the root element if the color is secondary. */
	    colorSecondary: {},
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {
	      width: '100%'
	    },
	
	    /* Styles applied to the `input` element. */
	    input: {
	      font: 'inherit',
	      letterSpacing: 'inherit',
	      color: 'currentColor',
	      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
	      border: 0,
	      boxSizing: 'content-box',
	      background: 'none',
	      height: '1.1876em',
	      // Reset (19px), match the native input line-height
	      margin: 0,
	      // Reset for Safari
	      WebkitTapHighlightColor: 'transparent',
	      display: 'block',
	      // Make the flex item shrink with Firefox
	      minWidth: 0,
	      width: '100%',
	      // Fix IE 11 width issue
	      animationName: 'mui-auto-fill-cancel',
	      animationDuration: '10ms',
	      '&::-webkit-input-placeholder': placeholder,
	      '&::-moz-placeholder': placeholder,
	      // Firefox 19+
	      '&:-ms-input-placeholder': placeholder,
	      // IE 11
	      '&::-ms-input-placeholder': placeholder,
	      // Edge
	      '&:focus': {
	        outline: 0
	      },
	      // Reset Firefox invalid required input style
	      '&:invalid': {
	        boxShadow: 'none'
	      },
	      '&::-webkit-search-decoration': {
	        // Remove the padding when type=search.
	        '-webkit-appearance': 'none'
	      },
	      // Show and hide the placeholder logic
	      'label[data-shrink=false] + $formControl &': {
	        '&::-webkit-input-placeholder': placeholderHidden,
	        '&::-moz-placeholder': placeholderHidden,
	        // Firefox 19+
	        '&:-ms-input-placeholder': placeholderHidden,
	        // IE 11
	        '&::-ms-input-placeholder': placeholderHidden,
	        // Edge
	        '&:focus::-webkit-input-placeholder': placeholderVisible,
	        '&:focus::-moz-placeholder': placeholderVisible,
	        // Firefox 19+
	        '&:focus:-ms-input-placeholder': placeholderVisible,
	        // IE 11
	        '&:focus::-ms-input-placeholder': placeholderVisible // Edge
	
	      },
	      '&$disabled': {
	        opacity: 1 // Reset iOS opacity
	
	      },
	      '&:-webkit-autofill': {
	        animationDuration: '5000s',
	        animationName: 'mui-auto-fill'
	      }
	    },
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {
	      paddingTop: 4 - 1
	    },
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {
	      height: 'auto',
	      resize: 'none',
	      padding: 0
	    },
	
	    /* Styles applied to the `input` element if `type="search"`. */
	    inputTypeSearch: {
	      // Improve type search style.
	      '-moz-appearance': 'textfield',
	      '-webkit-appearance': 'textfield'
	    },
	
	    /* Styles applied to the `input` element if `startAdornment` is provided. */
	    inputAdornedStart: {},
	
	    /* Styles applied to the `input` element if `endAdornment` is provided. */
	    inputAdornedEnd: {},
	
	    /* Styles applied to the `input` element if `hiddenLabel={true}`. */
	    inputHiddenLabel: {}
	  };
	};
	
	exports.styles = styles;
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	/**
	 * `InputBase` contains as few styles as possible.
	 * It aims to be a simple building block for creating an input.
	 * It contains a load of style reset and some state logic.
	 */
	
	var InputBase = /*#__PURE__*/React.forwardRef(function InputBase(props, ref) {
	  var ariaDescribedby = props['aria-describedby'],
	      autoComplete = props.autoComplete,
	      autoFocus = props.autoFocus,
	      classes = props.classes,
	      className = props.className,
	      color = props.color,
	      defaultValue = props.defaultValue,
	      disabled = props.disabled,
	      endAdornment = props.endAdornment,
	      error = props.error,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      id = props.id,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      _props$inputProps = props.inputProps,
	      inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps,
	      inputRefProp = props.inputRef,
	      margin = props.margin,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onKeyDown = props.onKeyDown,
	      onKeyUp = props.onKeyUp,
	      placeholder = props.placeholder,
	      readOnly = props.readOnly,
	      renderSuffix = props.renderSuffix,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      rowsMin = props.rowsMin,
	      startAdornment = props.startAdornment,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      valueProp = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "rowsMin", "startAdornment", "type", "value"]);
	  var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
	
	  var _React$useRef = React.useRef(value != null),
	      isControlled = _React$useRef.current;
	
	  var inputRef = React.useRef();
	  var handleInputRefWarning = React.useCallback(function (instance) {
	    if (false) {
	      if (instance && instance.nodeName !== 'INPUT' && !instance.focus) {
	        console.error(['Material-UI: You have provided a `inputComponent` to the input component', 'that does not correctly handle the `inputRef` prop.', 'Make sure the `inputRef` prop is called with a HTMLInputElement.'].join('\n'));
	      }
	    }
	  }, []);
	  var handleInputPropsRefProp = (0, _useForkRef.default)(inputPropsProp.ref, handleInputRefWarning);
	  var handleInputRefProp = (0, _useForkRef.default)(inputRefProp, handleInputPropsRefProp);
	  var handleInputRef = (0, _useForkRef.default)(inputRef, handleInputRefProp);
	
	  var _React$useState = React.useState(false),
	      focused = _React$useState[0],
	      setFocused = _React$useState[1];
	
	  var muiFormControl = (0, _FormControlContext.useFormControl)();
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useEffect(function () {
	      if (muiFormControl) {
	        return muiFormControl.registerEffect();
	      }
	
	      return undefined;
	    }, [muiFormControl]);
	  }
	
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['color', 'disabled', 'error', 'hiddenLabel', 'margin', 'required', 'filled']
	  });
	  fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
	  // We need to book keep the focused state manually.
	
	  React.useEffect(function () {
	    if (!muiFormControl && disabled && focused) {
	      setFocused(false);
	
	      if (onBlur) {
	        onBlur();
	      }
	    }
	  }, [muiFormControl, disabled, focused, onBlur]);
	  var onFilled = muiFormControl && muiFormControl.onFilled;
	  var onEmpty = muiFormControl && muiFormControl.onEmpty;
	  var checkDirty = React.useCallback(function (obj) {
	    if ((0, _utils2.isFilled)(obj)) {
	      if (onFilled) {
	        onFilled();
	      }
	    } else if (onEmpty) {
	      onEmpty();
	    }
	  }, [onFilled, onEmpty]);
	  useEnhancedEffect(function () {
	    if (isControlled) {
	      checkDirty({
	        value: value
	      });
	    }
	  }, [value, checkDirty, isControlled]);
	
	  var handleFocus = function handleFocus(event) {
	    // Fix a bug with IE 11 where the focus/blur events are triggered
	    // while the input is disabled.
	    if (fcs.disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onFocus) {
	      onFocus(event);
	    }
	
	    if (inputPropsProp.onFocus) {
	      inputPropsProp.onFocus(event);
	    }
	
	    if (muiFormControl && muiFormControl.onFocus) {
	      muiFormControl.onFocus(event);
	    } else {
	      setFocused(true);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    if (onBlur) {
	      onBlur(event);
	    }
	
	    if (inputPropsProp.onBlur) {
	      inputPropsProp.onBlur(event);
	    }
	
	    if (muiFormControl && muiFormControl.onBlur) {
	      muiFormControl.onBlur(event);
	    } else {
	      setFocused(false);
	    }
	  };
	
	  var handleChange = function handleChange(event) {
	    if (!isControlled) {
	      var element = event.target || inputRef.current;
	
	      if (element == null) {
	        throw new Error( false ? "Material-UI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://material-ui.com/r/input-component-ref-interface for more info." : (0, _utils.formatMuiErrorMessage)(1));
	      }
	
	      checkDirty({
	        value: element.value
	      });
	    }
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (inputPropsProp.onChange) {
	      inputPropsProp.onChange.apply(inputPropsProp, [event].concat(args));
	    } // Perform in the willUpdate
	
	
	    if (onChange) {
	      onChange.apply(void 0, [event].concat(args));
	    }
	  }; // Check the input state on mount, in case it was filled by the user
	  // or auto filled by the browser before the hydration (for SSR).
	
	
	  React.useEffect(function () {
	    checkDirty(inputRef.current);
	  }, []); // eslint-disable-line react-hooks/exhaustive-deps
	
	  var handleClick = function handleClick(event) {
	    if (inputRef.current && event.currentTarget === event.target) {
	      inputRef.current.focus();
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  var InputComponent = inputComponent;
	  var inputProps = (0, _extends2.default)({}, inputPropsProp, {
	    ref: handleInputRef
	  });
	
	  if (typeof InputComponent !== 'string') {
	    inputProps = (0, _extends2.default)({
	      // Rename ref to inputRef as we don't know the
	      // provided `inputComponent` structure.
	      inputRef: handleInputRef,
	      type: type
	    }, inputProps, {
	      ref: null
	    });
	  } else if (multiline) {
	    if (rows && !rowsMax && !rowsMin) {
	      InputComponent = 'textarea';
	    } else {
	      inputProps = (0, _extends2.default)({
	        rows: rows,
	        rowsMax: rowsMax
	      }, inputProps);
	      InputComponent = _TextareaAutosize.default;
	    }
	  } else {
	    inputProps = (0, _extends2.default)({
	      type: type
	    }, inputProps);
	  }
	
	  var handleAutoFill = function handleAutoFill(event) {
	    // Provide a fake value as Chrome might not let you access it for security reasons.
	    checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
	      value: 'x'
	    });
	  };
	
	  React.useEffect(function () {
	    if (muiFormControl) {
	      muiFormControl.setAdornedStart(Boolean(startAdornment));
	    }
	  }, [muiFormControl, startAdornment]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === 'dense' && classes.marginDense),
	    onClick: handleClick,
	    ref: ref
	  }, other), startAdornment, /*#__PURE__*/React.createElement(_FormControlContext.default.Provider, {
	    value: null
	  }, /*#__PURE__*/React.createElement(InputComponent, (0, _extends2.default)({
	    "aria-invalid": fcs.error,
	    "aria-describedby": ariaDescribedby,
	    autoComplete: autoComplete,
	    autoFocus: autoFocus,
	    defaultValue: defaultValue,
	    disabled: fcs.disabled,
	    id: id,
	    onAnimationStart: handleAutoFill,
	    name: name,
	    placeholder: placeholder,
	    readOnly: readOnly,
	    required: fcs.required,
	    rows: rows,
	    value: value,
	    onKeyDown: onKeyDown,
	    onKeyUp: onKeyUp
	  }, inputProps, {
	    className: (0, _clsx.default)(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === 'search' && classes.inputTypeSearch, fcs.margin === 'dense' && classes.inputMarginDense),
	    onBlur: handleBlur,
	    onChange: handleChange,
	    onFocus: handleFocus
	  }))), endAdornment, renderSuffix ? renderSuffix((0, _extends2.default)({}, fcs, {
	    startAdornment: startAdornment
	  })) : null);
	});
	 false ? InputBase.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * @ignore
	   */
	  'aria-describedby': _propTypes.default.string,
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a HTML element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the input is blurred.
	   *
	   * Notice that the first argument (event) might be undefined.
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  renderSuffix: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Minimum number of rows to display when multiline option is set to true.
	   */
	  rowsMin: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInputBase'
	})(InputBase);
	
	exports.default = _default;

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(109));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(93));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _FormLabel = _interopRequireDefault(__webpack_require__(354));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      transformOrigin: 'top left'
	    },
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element if `required={true}`. */
	    required: {},
	
	    /* Pseudo-class applied to the asterisk element. */
	    asterisk: {},
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      // slight alteration to spec spacing to match visual spec result
	      transform: 'translate(0, 24px) scale(1)'
	    },
	
	    /* Styles applied to the root element if `margin="dense"`. */
	    marginDense: {
	      // Compensation for the `Input.inputDense` style.
	      transform: 'translate(0, 21px) scale(1)'
	    },
	
	    /* Styles applied to the `input` element if `shrink={true}`. */
	    shrink: {
	      transform: 'translate(0, 1.5px) scale(0.75)',
	      transformOrigin: 'top left'
	    },
	
	    /* Styles applied to the `input` element if `disableAnimation={false}`. */
	    animated: {
	      transition: theme.transitions.create(['color', 'transform'], {
	        duration: theme.transitions.duration.shorter,
	        easing: theme.transitions.easing.easeOut
	      })
	    },
	
	    /* Styles applied to the root element if `variant="filled"`. */
	    filled: {
	      // Chrome's autofill feature gives the input field a yellow background.
	      // Since the input field is behind the label in the HTML tree,
	      // the input field is drawn last and hides the label with an opaque background color.
	      // zIndex: 1 will raise the label above opaque background-colors of input.
	      zIndex: 1,
	      pointerEvents: 'none',
	      transform: 'translate(12px, 20px) scale(1)',
	      '&$marginDense': {
	        transform: 'translate(12px, 17px) scale(1)'
	      },
	      '&$shrink': {
	        transform: 'translate(12px, 10px) scale(0.75)',
	        '&$marginDense': {
	          transform: 'translate(12px, 7px) scale(0.75)'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      // see comment above on filled.zIndex
	      zIndex: 1,
	      pointerEvents: 'none',
	      transform: 'translate(14px, 20px) scale(1)',
	      '&$marginDense': {
	        transform: 'translate(14px, 12px) scale(1)'
	      },
	      '&$shrink': {
	        transform: 'translate(14px, -6px) scale(0.75)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var InputLabel = /*#__PURE__*/React.forwardRef(function InputLabel(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$disableAnimati = props.disableAnimation,
	      disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati,
	      margin = props.margin,
	      shrinkProp = props.shrink,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disableAnimation", "margin", "shrink", "variant"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var shrink = shrinkProp;
	
	  if (typeof shrink === 'undefined' && muiFormControl) {
	    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
	  }
	
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['margin', 'variant']
	  });
	  return /*#__PURE__*/React.createElement(_FormLabel.default, (0, _extends2.default)({
	    "data-shrink": shrink,
	    className: (0, _clsx.default)(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === 'dense' && classes.marginDense, {
	      'filled': classes.filled,
	      'outlined': classes.outlined
	    }[fcs.variant]),
	    classes: {
	      focused: classes.focused,
	      disabled: classes.disabled,
	      error: classes.error,
	      required: classes.required,
	      asterisk: classes.asterisk
	    },
	    ref: ref
	  }, other));
	});
	 false ? InputLabel.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The contents of the `InputLabel`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * If `true`, the transition animation is disabled.
	   */
	  disableAnimation: _propTypes.default.bool,
	
	  /**
	   * If `true`, apply disabled class.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input of this label is focused.
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense']),
	
	  /**
	   * if `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label is shrunk.
	   */
	  shrink: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInputLabel'
	})(InputLabel);
	
	exports.default = _default;

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _colorManipulator = __webpack_require__(49);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(47));
	
	var TRANSITION_DURATION = 4; // seconds
	
	var styles = function styles(theme) {
	  var getColor = function getColor(color) {
	    return theme.palette.type === 'light' ? (0, _colorManipulator.lighten)(color, 0.62) : (0, _colorManipulator.darken)(color, 0.5);
	  };
	
	  var backgroundPrimary = getColor(theme.palette.primary.main);
	  var backgroundSecondary = getColor(theme.palette.secondary.main);
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      overflow: 'hidden',
	      height: 4,
	      '@media print': {
	        colorAdjust: 'exact'
	      }
	    },
	
	    /* Styles applied to the root and bar2 element if `color="primary"`; bar2 if `variant="buffer"`. */
	    colorPrimary: {
	      backgroundColor: backgroundPrimary
	    },
	
	    /* Styles applied to the root and bar2 elements if `color="secondary"`; bar2 if `variant="buffer"`. */
	    colorSecondary: {
	      backgroundColor: backgroundSecondary
	    },
	
	    /* Styles applied to the root element if `variant="determinate"`. */
	    determinate: {},
	
	    /* Styles applied to the root element if `variant="indeterminate"`. */
	    indeterminate: {},
	
	    /* Styles applied to the root element if `variant="buffer"`. */
	    buffer: {
	      backgroundColor: 'transparent'
	    },
	
	    /* Styles applied to the root element if `variant="query"`. */
	    query: {
	      transform: 'rotate(180deg)'
	    },
	
	    /* Styles applied to the additional bar element if `variant="buffer"`. */
	    dashed: {
	      position: 'absolute',
	      marginTop: 0,
	      height: '100%',
	      width: '100%',
	      animation: '$buffer 3s infinite linear'
	    },
	
	    /* Styles applied to the additional bar element if `variant="buffer"` and `color="primary"`. */
	    dashedColorPrimary: {
	      backgroundImage: "radial-gradient(".concat(backgroundPrimary, " 0%, ").concat(backgroundPrimary, " 16%, transparent 42%)"),
	      backgroundSize: '10px 10px',
	      backgroundPosition: '0 -23px'
	    },
	
	    /* Styles applied to the additional bar element if `variant="buffer"` and `color="secondary"`. */
	    dashedColorSecondary: {
	      backgroundImage: "radial-gradient(".concat(backgroundSecondary, " 0%, ").concat(backgroundSecondary, " 16%, transparent 42%)"),
	      backgroundSize: '10px 10px',
	      backgroundPosition: '0 -23px'
	    },
	
	    /* Styles applied to the layered bar1 and bar2 elements. */
	    bar: {
	      width: '100%',
	      position: 'absolute',
	      left: 0,
	      bottom: 0,
	      top: 0,
	      transition: 'transform 0.2s linear',
	      transformOrigin: 'left'
	    },
	
	    /* Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */
	    barColorPrimary: {
	      backgroundColor: theme.palette.primary.main
	    },
	
	    /* Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */
	    barColorSecondary: {
	      backgroundColor: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the bar1 element if `variant="indeterminate or query"`. */
	    bar1Indeterminate: {
	      width: 'auto',
	      animation: '$indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
	    },
	
	    /* Styles applied to the bar1 element if `variant="determinate"`. */
	    bar1Determinate: {
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	
	    /* Styles applied to the bar1 element if `variant="buffer"`. */
	    bar1Buffer: {
	      zIndex: 1,
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	
	    /* Styles applied to the bar2 element if `variant="indeterminate or query"`. */
	    bar2Indeterminate: {
	      width: 'auto',
	      animation: '$indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite'
	    },
	
	    /* Styles applied to the bar2 element if `variant="buffer"`. */
	    bar2Buffer: {
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	    // Legends:
	    // || represents the viewport
	    // -  represents a light background
	    // x  represents a dark background
	    '@keyframes indeterminate1': {
	      //  |-----|---x-||-----||-----|
	      '0%': {
	        left: '-35%',
	        right: '100%'
	      },
	      //  |-----|-----||-----||xxxx-|
	      '60%': {
	        left: '100%',
	        right: '-90%'
	      },
	      '100%': {
	        left: '100%',
	        right: '-90%'
	      }
	    },
	    '@keyframes indeterminate2': {
	      //  |xxxxx|xxxxx||-----||-----|
	      '0%': {
	        left: '-200%',
	        right: '100%'
	      },
	      //  |-----|-----||-----||-x----|
	      '60%': {
	        left: '107%',
	        right: '-8%'
	      },
	      '100%': {
	        left: '107%',
	        right: '-8%'
	      }
	    },
	    '@keyframes buffer': {
	      '0%': {
	        opacity: 1,
	        backgroundPosition: '0 -23px'
	      },
	      '50%': {
	        opacity: 0,
	        backgroundPosition: '0 -23px'
	      },
	      '100%': {
	        opacity: 1,
	        backgroundPosition: '-200px -23px'
	      }
	    }
	  };
	};
	/**
	 * ## ARIA
	 *
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	
	
	exports.styles = styles;
	var LinearProgress = /*#__PURE__*/React.forwardRef(function LinearProgress(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      value = props.value,
	      valueBuffer = props.valueBuffer,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);
	  var theme = (0, _useTheme.default)();
	  var rootProps = {};
	  var inlineStyles = {
	    bar1: {},
	    bar2: {}
	  };
	
	  if (variant === 'determinate' || variant === 'buffer') {
	    if (value !== undefined) {
	      rootProps['aria-valuenow'] = Math.round(value);
	      rootProps['aria-valuemin'] = 0;
	      rootProps['aria-valuemax'] = 100;
	      var transform = value - 100;
	
	      if (theme.direction === 'rtl') {
	        transform = -transform;
	      }
	
	      inlineStyles.bar1.transform = "translateX(".concat(transform, "%)");
	    } else if (false) {
	      console.error('Material-UI: You need to provide a value prop ' + 'when using the determinate or buffer variant of LinearProgress .');
	    }
	  }
	
	  if (variant === 'buffer') {
	    if (valueBuffer !== undefined) {
	      var _transform = (valueBuffer || 0) - 100;
	
	      if (theme.direction === 'rtl') {
	        _transform = -_transform;
	      }
	
	      inlineStyles.bar2.transform = "translateX(".concat(_transform, "%)");
	    } else if (false) {
	      console.error('Material-UI: You need to provide a valueBuffer prop ' + 'when using the buffer variant of LinearProgress.');
	    }
	  }
	
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(color))], className, {
	      'determinate': classes.determinate,
	      'indeterminate': classes.indeterminate,
	      'buffer': classes.buffer,
	      'query': classes.query
	    }[variant]),
	    role: "progressbar"
	  }, rootProps, {
	    ref: ref
	  }, other), variant === 'buffer' ? /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.dashed, classes["dashedColor".concat((0, _capitalize.default)(color))])
	  }) : null, /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.bar, classes["barColor".concat((0, _capitalize.default)(color))], (variant === 'indeterminate' || variant === 'query') && classes.bar1Indeterminate, {
	      'determinate': classes.bar1Determinate,
	      'buffer': classes.bar1Buffer
	    }[variant]),
	    style: inlineStyles.bar1
	  }), variant === 'determinate' ? null : /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.bar, (variant === 'indeterminate' || variant === 'query') && classes.bar2Indeterminate, variant === 'buffer' ? [classes["color".concat((0, _capitalize.default)(color))], classes.bar2Buffer] : classes["barColor".concat((0, _capitalize.default)(color))]),
	    style: inlineStyles.bar2
	  }));
	});
	 false ? LinearProgress.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The value of the progress indicator for the determinate and buffer variants.
	   * Value between 0 and 100.
	   */
	  value: _propTypes.default.number,
	
	  /**
	   * The value for the buffer variant.
	   * Value between 0 and 100.
	   */
	  valueBuffer: _propTypes.default.number,
	
	  /**
	   * The variant to use.
	   * Use indeterminate or query when there is no progress value.
	   */
	  variant: _propTypes.default.oneOf(['buffer', 'determinate', 'indeterminate', 'query'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiLinearProgress'
	})(LinearProgress);
	
	exports.default = _default;

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _utils = __webpack_require__(22);
	
	var _useIsFocusVisible2 = _interopRequireDefault(__webpack_require__(131));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	var _Typography = _interopRequireDefault(__webpack_require__(66));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {},
	
	  /* Styles applied to the root element if `underline="none"`. */
	  underlineNone: {
	    textDecoration: 'none'
	  },
	
	  /* Styles applied to the root element if `underline="hover"`. */
	  underlineHover: {
	    textDecoration: 'none',
	    '&:hover': {
	      textDecoration: 'underline'
	    }
	  },
	
	  /* Styles applied to the root element if `underline="always"`. */
	  underlineAlways: {
	    textDecoration: 'underline'
	  },
	  // Same reset as ButtonBase.root
	
	  /* Styles applied to the root element if `component="button"`. */
	  button: {
	    position: 'relative',
	    WebkitTapHighlightColor: 'transparent',
	    backgroundColor: 'transparent',
	    // Reset default value
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0,
	    border: 0,
	    margin: 0,
	    // Remove the margin in Safari
	    borderRadius: 0,
	    padding: 0,
	    // Remove the padding in Firefox
	    cursor: 'pointer',
	    userSelect: 'none',
	    verticalAlign: 'middle',
	    '-moz-appearance': 'none',
	    // Reset
	    '-webkit-appearance': 'none',
	    // Reset
	    '&::-moz-focus-inner': {
	      borderStyle: 'none' // Remove Firefox dotted outline.
	
	    },
	    '&$focusVisible': {
	      outline: 'auto'
	    }
	  },
	
	  /* Pseudo-class applied to the root element if the link is keyboard focused. */
	  focusVisible: {}
	};
	exports.styles = styles;
	var Link = /*#__PURE__*/React.forwardRef(function Link(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'a' : _props$component,
	      onBlur = props.onBlur,
	      onFocus = props.onFocus,
	      TypographyClasses = props.TypographyClasses,
	      _props$underline = props.underline,
	      underline = _props$underline === void 0 ? 'hover' : _props$underline,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'inherit' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant"]);
	
	  var _useIsFocusVisible = (0, _useIsFocusVisible2.default)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  var _React$useState = React.useState(false),
	      focusVisible = _React$useState[0],
	      setFocusVisible = _React$useState[1];
	
	  var handlerRef = (0, _useForkRef.default)(ref, focusVisibleRef);
	
	  var handleBlur = function handleBlur(event) {
	    if (focusVisible) {
	      onBlurVisible();
	      setFocusVisible(false);
	    }
	
	    if (onBlur) {
	      onBlur(event);
	    }
	  };
	
	  var handleFocus = function handleFocus(event) {
	    if (isFocusVisible(event)) {
	      setFocusVisible(true);
	    }
	
	    if (onFocus) {
	      onFocus(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["underline".concat((0, _capitalize.default)(underline))], className, focusVisible && classes.focusVisible, component === 'button' && classes.button),
	    classes: TypographyClasses,
	    color: color,
	    component: component,
	    onBlur: handleBlur,
	    onFocus: handleFocus,
	    ref: handlerRef,
	    variant: variant
	  }, other));
	});
	 false ? Link.propTypes = {
	  /**
	   * The content of the link.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the link.
	   */
	  color: _propTypes.default.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _utils.elementTypeAcceptingRef,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * `classes` prop applied to the [`Typography`](/api/typography/) element.
	   */
	  TypographyClasses: _propTypes.default.object,
	
	  /**
	   * Controls when the link should have an underline.
	   */
	  underline: _propTypes.default.oneOf(['none', 'hover', 'always']),
	
	  /**
	   * Applies the theme typography styles.
	   */
	  variant: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiLink'
	})(Link);
	
	exports.default = _default;

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Link.default;
	  }
	});
	
	var _Link = _interopRequireDefault(__webpack_require__(905));

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(127));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    listStyle: 'none',
	    margin: 0,
	    padding: 0,
	    position: 'relative'
	  },
	
	  /* Styles applied to the root element if `disablePadding={false}`. */
	  padding: {
	    paddingTop: 8,
	    paddingBottom: 8
	  },
	
	  /* Styles applied to the root element if dense. */
	  dense: {},
	
	  /* Styles applied to the root element if a `subheader` is provided. */
	  subheader: {
	    paddingTop: 0
	  }
	};
	exports.styles = styles;
	var List = /*#__PURE__*/React.forwardRef(function List(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'ul' : _props$component,
	      _props$dense = props.dense,
	      dense = _props$dense === void 0 ? false : _props$dense,
	      _props$disablePadding = props.disablePadding,
	      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
	      subheader = props.subheader,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);
	  var context = React.useMemo(function () {
	    return {
	      dense: dense
	    };
	  }, [dense]);
	  return /*#__PURE__*/React.createElement(_ListContext.default.Provider, {
	    value: context
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
	    ref: ref
	  }, other), subheader, children));
	});
	 false ? List.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
	   * the list and list items.
	   * The prop is available to descendant components as the `dense` context.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * If `true`, vertical padding will be removed from the list.
	   */
	  disablePadding: _propTypes.default.bool,
	
	  /**
	   * The content of the subheader, normally `ListSubheader`.
	   */
	  subheader: _propTypes.default.node
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiList'
	})(List);
	
	exports.default = _default;

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(56));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(130));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(127));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(45));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
	    root: {
	      display: 'flex',
	      justifyContent: 'flex-start',
	      alignItems: 'center',
	      position: 'relative',
	      textDecoration: 'none',
	      width: '100%',
	      boxSizing: 'border-box',
	      textAlign: 'left',
	      paddingTop: 8,
	      paddingBottom: 8,
	      '&$focusVisible': {
	        backgroundColor: theme.palette.action.selected
	      },
	      '&$selected, &$selected:hover': {
	        backgroundColor: theme.palette.action.selected
	      },
	      '&$disabled': {
	        opacity: 0.5
	      }
	    },
	
	    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
	    container: {
	      position: 'relative'
	    },
	
	    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
	    focusVisible: {},
	
	    /* Styles applied to the `component` element if dense. */
	    dense: {
	      paddingTop: 4,
	      paddingBottom: 4
	    },
	
	    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
	    alignItemsFlexStart: {
	      alignItems: 'flex-start'
	    },
	
	    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the inner `component` element if `divider={true}`. */
	    divider: {
	      borderBottom: "1px solid ".concat(theme.palette.divider),
	      backgroundClip: 'padding-box'
	    },
	
	    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
	    gutters: {
	      paddingLeft: 16,
	      paddingRight: 16
	    },
	
	    /* Styles applied to the inner `component` element if `button={true}`. */
	    button: {
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        backgroundColor: theme.palette.action.hover,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
	    secondaryAction: {
	      // Add some space to avoid collision as `ListItemSecondaryAction`
	      // is absolutely positioned.
	      paddingRight: 48
	    },
	
	    /* Pseudo-class applied to the root element if `selected={true}`. */
	    selected: {}
	  };
	};
	
	exports.styles = styles;
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	/**
	 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
	 */
	
	var ListItem = /*#__PURE__*/React.forwardRef(function ListItem(props, ref) {
	  var _props$alignItems = props.alignItems,
	      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
	      _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
	      _props$button = props.button,
	      button = _props$button === void 0 ? false : _props$button,
	      childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      componentProp = props.component,
	      _props$ContainerCompo = props.ContainerComponent,
	      ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
	      _props$ContainerProps = props.ContainerProps;
	  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
	  var ContainerClassName = _props$ContainerProps.className,
	      ContainerProps = (0, _objectWithoutProperties2.default)(_props$ContainerProps, ["className"]),
	      _props$dense = props.dense,
	      dense = _props$dense === void 0 ? false : _props$dense,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$divider = props.divider,
	      divider = _props$divider === void 0 ? false : _props$divider,
	      focusVisibleClassName = props.focusVisibleClassName,
	      _props$selected = props.selected,
	      selected = _props$selected === void 0 ? false : _props$selected,
	      other = (0, _objectWithoutProperties2.default)(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);
	  var context = React.useContext(_ListContext.default);
	  var childContext = {
	    dense: dense || context.dense || false,
	    alignItems: alignItems
	  };
	  var listItemRef = React.useRef(null);
	  useEnhancedEffect(function () {
	    if (autoFocus) {
	      if (listItemRef.current) {
	        listItemRef.current.focus();
	      } else if (false) {
	        console.error('Material-UI: Unable to set focus to a ListItem whose component has not been rendered.');
	      }
	    }
	  }, [autoFocus]);
	  var children = React.Children.toArray(childrenProp);
	  var hasSecondaryAction = children.length && (0, _isMuiElement.default)(children[children.length - 1], ['ListItemSecondaryAction']);
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    listItemRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRef = (0, _useForkRef.default)(handleOwnRef, ref);
	  var componentProps = (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
	    disabled: disabled
	  }, other);
	  var Component = componentProp || 'li';
	
	  if (button) {
	    componentProps.component = componentProp || 'div';
	    componentProps.focusVisibleClassName = (0, _clsx.default)(classes.focusVisible, focusVisibleClassName);
	    Component = _ButtonBase.default;
	  }
	
	  if (hasSecondaryAction) {
	    // Use div by default.
	    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.
	
	    if (ContainerComponent === 'li') {
	      if (Component === 'li') {
	        Component = 'div';
	      } else if (componentProps.component === 'li') {
	        componentProps.component = 'div';
	      }
	    }
	
	    return /*#__PURE__*/React.createElement(_ListContext.default.Provider, {
	      value: childContext
	    }, /*#__PURE__*/React.createElement(ContainerComponent, (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.container, ContainerClassName),
	      ref: handleRef
	    }, ContainerProps), /*#__PURE__*/React.createElement(Component, componentProps, children), children.pop()));
	  }
	
	  return /*#__PURE__*/React.createElement(_ListContext.default.Provider, {
	    value: childContext
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: handleRef
	  }, componentProps), children));
	});
	 false ? ListItem.propTypes = {
	  /**
	   * Defines the `align-items` style property.
	   */
	  alignItems: _propTypes.default.oneOf(['flex-start', 'center']),
	
	  /**
	   * If `true`, the list item will be focused during the first mount.
	   * Focus will also be triggered if the value changes from false to true.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the list item will be a button (using `ButtonBase`). Props intended
	   * for `ButtonBase` can then be applied to `ListItem`.
	   */
	  button: _propTypes.default.bool,
	
	  /**
	   * The content of the component. If a `ListItemSecondaryAction` is used it must
	   * be the last child.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node, function (props) {
	    var children = React.Children.toArray(props.children); // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)
	
	    var secondaryActionIndex = -1;
	
	    for (var i = children.length - 1; i >= 0; i -= 1) {
	      var child = children[i];
	
	      if ((0, _isMuiElement.default)(child, ['ListItemSecondaryAction'])) {
	        secondaryActionIndex = i;
	        break;
	      }
	    } //  is ListItemSecondaryAction the last child of ListItem
	
	
	    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
	      return new Error('Material-UI: You used an element after ListItemSecondaryAction. ' + 'For ListItem to detect that it has a secondary action ' + 'you must pass it as the last child to ListItem.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * The container component used when a `ListItemSecondaryAction` is the last child.
	   */
	  ContainerComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the container component if used.
	   */
	  ContainerProps: _propTypes.default.object,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * If `true`, the list item will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * If `true`, a 1px light border is added to the bottom of the list item.
	   */
	  divider: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * Use to apply selected styling.
	   */
	  selected: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItem'
	})(ListItem);
	
	exports.default = _default;

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(127));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    minWidth: 56,
	    flexShrink: 0
	  },
	
	  /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
	  alignItemsFlexStart: {
	    marginTop: 8
	  }
	};
	/**
	 * A simple wrapper to apply `List` styles to an `Avatar`.
	 */
	
	exports.styles = styles;
	var ListItemAvatar = /*#__PURE__*/React.forwardRef(function ListItemAvatar(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  var context = React.useContext(_ListContext.default);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
	    ref: ref
	  }, other));
	});
	 false ? ListItemAvatar.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component – normally `Avatar`.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemAvatar'
	})(ListItemAvatar);
	
	exports.default = _default;

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemAvatar.default;
	  }
	});
	
	var _ListItemAvatar = _interopRequireDefault(__webpack_require__(909));

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(127));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      minWidth: 56,
	      color: theme.palette.action.active,
	      flexShrink: 0,
	      display: 'inline-flex'
	    },
	
	    /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
	    alignItemsFlexStart: {
	      marginTop: 8
	    }
	  };
	};
	/**
	 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
	 */
	
	
	exports.styles = styles;
	var ListItemIcon = /*#__PURE__*/React.forwardRef(function ListItemIcon(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  var context = React.useContext(_ListContext.default);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
	    ref: ref
	  }, other));
	});
	 false ? ListItemIcon.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component, normally `Icon`, `SvgIcon`,
	   * or a `@material-ui/icons` SVG icon element.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemIcon'
	})(ListItemIcon);
	
	exports.default = _default;

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemIcon.default;
	  }
	});
	
	var _ListItemIcon = _interopRequireDefault(__webpack_require__(911));

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    position: 'absolute',
	    right: 16,
	    top: '50%',
	    transform: 'translateY(-50%)'
	  }
	};
	/**
	 * Must be used as the last child of ListItem to function properly.
	 */
	
	exports.styles = styles;
	var ListItemSecondaryAction = /*#__PURE__*/React.forwardRef(function ListItemSecondaryAction(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other));
	});
	 false ? ListItemSecondaryAction.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component, normally an `IconButton` or selection control.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemSecondaryAction'
	})(ListItemSecondaryAction);
	
	exports.default = _default;

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemSecondaryAction.default;
	  }
	});
	
	var _ListItemSecondaryAction = _interopRequireDefault(__webpack_require__(913));

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Typography = _interopRequireDefault(__webpack_require__(66));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(127));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    flex: '1 1 auto',
	    minWidth: 0,
	    marginTop: 4,
	    marginBottom: 4
	  },
	
	  /* Styles applied to the `Typography` components if primary and secondary are set. */
	  multiline: {
	    marginTop: 6,
	    marginBottom: 6
	  },
	
	  /* Styles applied to the `Typography` components if dense. */
	  dense: {},
	
	  /* Styles applied to the root element if `inset={true}`. */
	  inset: {
	    paddingLeft: 56
	  },
	
	  /* Styles applied to the primary `Typography` component. */
	  primary: {},
	
	  /* Styles applied to the secondary `Typography` component. */
	  secondary: {}
	};
	exports.styles = styles;
	var ListItemText = /*#__PURE__*/React.forwardRef(function ListItemText(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      _props$inset = props.inset,
	      inset = _props$inset === void 0 ? false : _props$inset,
	      primaryProp = props.primary,
	      primaryTypographyProps = props.primaryTypographyProps,
	      secondaryProp = props.secondary,
	      secondaryTypographyProps = props.secondaryTypographyProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"]);
	
	  var _React$useContext = React.useContext(_ListContext.default),
	      dense = _React$useContext.dense;
	
	  var primary = primaryProp != null ? primaryProp : children;
	
	  if (primary != null && primary.type !== _Typography.default && !disableTypography) {
	    primary = /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	      variant: dense ? 'body2' : 'body1',
	      className: classes.primary,
	      component: "span",
	      display: "block"
	    }, primaryTypographyProps), primary);
	  }
	
	  var secondary = secondaryProp;
	
	  if (secondary != null && secondary.type !== _Typography.default && !disableTypography) {
	    secondary = /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	      variant: "body2",
	      className: classes.secondary,
	      color: "textSecondary",
	      display: "block"
	    }, secondaryTypographyProps), secondary);
	  }
	
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
	    ref: ref
	  }, other), primary, secondary);
	});
	 false ? ListItemText.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Alias for the `primary` prop.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the children won't be wrapped by a Typography component.
	   * This can be useful to render an alternative Typography variant by wrapping
	   * the `children` (or `primary`) text, and optional `secondary` text
	   * with the Typography component.
	   */
	  disableTypography: _propTypes.default.bool,
	
	  /**
	   * If `true`, the children will be indented.
	   * This should be used if there is no left avatar or left icon.
	   */
	  inset: _propTypes.default.bool,
	
	  /**
	   * The main content element.
	   */
	  primary: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the primary typography component
	   * (as long as disableTypography is not `true`).
	   */
	  primaryTypographyProps: _propTypes.default.object,
	
	  /**
	   * The secondary content element.
	   */
	  secondary: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the secondary typography component
	   * (as long as disableTypography is not `true`).
	   */
	  secondaryTypographyProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemText'
	})(ListItemText);
	
	exports.default = _default;

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemText.default;
	  }
	});
	
	var _ListItemText = _interopRequireDefault(__webpack_require__(915));

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      boxSizing: 'border-box',
	      lineHeight: '48px',
	      listStyle: 'none',
	      color: theme.palette.text.secondary,
	      fontFamily: theme.typography.fontFamily,
	      fontWeight: theme.typography.fontWeightMedium,
	      fontSize: theme.typography.pxToRem(14)
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
	    gutters: {
	      paddingLeft: 16,
	      paddingRight: 16
	    },
	
	    /* Styles applied to the root element if `inset={true}`. */
	    inset: {
	      paddingLeft: 72
	    },
	
	    /* Styles applied to the root element if `disableSticky={false}`. */
	    sticky: {
	      position: 'sticky',
	      top: 0,
	      zIndex: 1,
	      backgroundColor: 'inherit'
	    }
	  };
	};
	
	exports.styles = styles;
	var ListSubheader = /*#__PURE__*/React.forwardRef(function ListSubheader(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'li' : _props$component,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$disableSticky = props.disableSticky,
	      disableSticky = _props$disableSticky === void 0 ? false : _props$disableSticky,
	      _props$inset = props.inset,
	      inset = _props$inset === void 0 ? false : _props$inset,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "component", "disableGutters", "disableSticky", "inset"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'default' && classes["color".concat((0, _capitalize.default)(color))], inset && classes.inset, !disableSticky && classes.sticky, !disableGutters && classes.gutters),
	    ref: ref
	  }, other));
	});
	 false ? ListSubheader.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'inherit']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the List Subheader will not have gutters.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * If `true`, the List Subheader will not stick to the top during scroll.
	   */
	  disableSticky: _propTypes.default.bool,
	
	  /**
	   * If `true`, the List Subheader will be indented.
	   */
	  inset: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListSubheader'
	})(ListSubheader);
	
	exports.default = _default;

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListSubheader.default;
	  }
	});
	
	var _ListSubheader = _interopRequireDefault(__webpack_require__(917));

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Menu.default;
	  }
	});
	
	var _Menu = _interopRequireDefault(__webpack_require__(359));

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _ListItem = _interopRequireDefault(__webpack_require__(358));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends3.default)({}, theme.typography.body1, (0, _defineProperty2.default)({
	      minHeight: 48,
	      paddingTop: 6,
	      paddingBottom: 6,
	      boxSizing: 'border-box',
	      width: 'auto',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    }, theme.breakpoints.up('sm'), {
	      minHeight: 'auto'
	    })),
	    // TODO v5: remove
	
	    /* Styles applied to the root element if `disableGutters={false}`. */
	    gutters: {},
	
	    /* Styles applied to the root element if `selected={true}`. */
	    selected: {},
	
	    /* Styles applied to the root element if dense. */
	    dense: (0, _extends3.default)({}, theme.typography.body2, {
	      minHeight: 'auto'
	    })
	  };
	};
	
	exports.styles = styles;
	var MenuItem = /*#__PURE__*/React.forwardRef(function MenuItem(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'li' : _props$component,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      ListItemClasses = props.ListItemClasses,
	      _props$role = props.role,
	      role = _props$role === void 0 ? 'menuitem' : _props$role,
	      selected = props.selected,
	      tabIndexProp = props.tabIndex,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disableGutters", "ListItemClasses", "role", "selected", "tabIndex"]);
	  var tabIndex;
	
	  if (!props.disabled) {
	    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
	  }
	
	  return /*#__PURE__*/React.createElement(_ListItem.default, (0, _extends3.default)({
	    button: true,
	    role: role,
	    tabIndex: tabIndex,
	    component: component,
	    selected: selected,
	    disableGutters: disableGutters,
	    classes: (0, _extends3.default)({
	      dense: classes.dense
	    }, ListItemClasses),
	    className: (0, _clsx.default)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
	    ref: ref
	  }, other));
	});
	 false ? MenuItem.propTypes = {
	  /**
	   * Menu item contents.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * `classes` prop applied to the [`ListItem`](/api/list-item/) element.
	   */
	  ListItemClasses: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  selected: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.number
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMenuItem'
	})(MenuItem);
	
	exports.default = _default;

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(67);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(45));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(68));
	
	var _List = _interopRequireDefault(__webpack_require__(357));
	
	var _getScrollbarSize = _interopRequireDefault(__webpack_require__(396));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	function nextItem(list, item, disableListWrap) {
	  if (list === item) {
	    return list.firstChild;
	  }
	
	  if (item && item.nextElementSibling) {
	    return item.nextElementSibling;
	  }
	
	  return disableListWrap ? null : list.firstChild;
	}
	
	function previousItem(list, item, disableListWrap) {
	  if (list === item) {
	    return disableListWrap ? list.firstChild : list.lastChild;
	  }
	
	  if (item && item.previousElementSibling) {
	    return item.previousElementSibling;
	  }
	
	  return disableListWrap ? null : list.lastChild;
	}
	
	function textCriteriaMatches(nextFocus, textCriteria) {
	  if (textCriteria === undefined) {
	    return true;
	  }
	
	  var text = nextFocus.innerText;
	
	  if (text === undefined) {
	    // jsdom doesn't support innerText
	    text = nextFocus.textContent;
	  }
	
	  text = text.trim().toLowerCase();
	
	  if (text.length === 0) {
	    return false;
	  }
	
	  if (textCriteria.repeating) {
	    return text[0] === textCriteria.keys[0];
	  }
	
	  return text.indexOf(textCriteria.keys.join('')) === 0;
	}
	
	function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
	  var wrappedOnce = false;
	  var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
	
	  while (nextFocus) {
	    // Prevent infinite loop.
	    if (nextFocus === list.firstChild) {
	      if (wrappedOnce) {
	        return;
	      }
	
	      wrappedOnce = true;
	    } // Same logic as useAutocomplete.js
	
	
	    var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
	
	    if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
	      // Move to the next element.
	      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
	    } else {
	      nextFocus.focus();
	      return;
	    }
	  }
	}
	
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	/**
	 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
	 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
	 * use it separately you need to move focus into the component manually. Once
	 * the focus is placed inside the component it is fully keyboard accessible.
	 */
	
	var MenuList = /*#__PURE__*/React.forwardRef(function MenuList(props, ref) {
	  var actions = props.actions,
	      _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
	      _props$autoFocusItem = props.autoFocusItem,
	      autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem,
	      children = props.children,
	      className = props.className,
	      _props$disabledItemsF = props.disabledItemsFocusable,
	      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
	      _props$disableListWra = props.disableListWrap,
	      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
	      onKeyDown = props.onKeyDown,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"]);
	  var listRef = React.useRef(null);
	  var textCriteriaRef = React.useRef({
	    keys: [],
	    repeating: true,
	    previousKeyMatched: true,
	    lastTime: null
	  });
	  useEnhancedEffect(function () {
	    if (autoFocus) {
	      listRef.current.focus();
	    }
	  }, [autoFocus]);
	  React.useImperativeHandle(actions, function () {
	    return {
	      adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
	        // Let's ignore that piece of logic if users are already overriding the width
	        // of the menu.
	        var noExplicitWidth = !listRef.current.style.width;
	
	        if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
	          var scrollbarSize = "".concat((0, _getScrollbarSize.default)(true), "px");
	          listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
	          listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
	        }
	
	        return listRef.current;
	      }
	    };
	  }, []);
	
	  var handleKeyDown = function handleKeyDown(event) {
	    var list = listRef.current;
	    var key = event.key;
	    /**
	     * @type {Element} - will always be defined since we are in a keydown handler
	     * attached to an element. A keydown event is either dispatched to the activeElement
	     * or document.body or document.documentElement. Only the first case will
	     * trigger this specific handler.
	     */
	
	    var currentFocus = (0, _ownerDocument.default)(list).activeElement;
	
	    if (key === 'ArrowDown') {
	      // Prevent scroll of the page
	      event.preventDefault();
	      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
	    } else if (key === 'ArrowUp') {
	      event.preventDefault();
	      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
	    } else if (key === 'Home') {
	      event.preventDefault();
	      moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
	    } else if (key === 'End') {
	      event.preventDefault();
	      moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
	    } else if (key.length === 1) {
	      var criteria = textCriteriaRef.current;
	      var lowerKey = key.toLowerCase();
	      var currTime = performance.now();
	
	      if (criteria.keys.length > 0) {
	        // Reset
	        if (currTime - criteria.lastTime > 500) {
	          criteria.keys = [];
	          criteria.repeating = true;
	          criteria.previousKeyMatched = true;
	        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
	          criteria.repeating = false;
	        }
	      }
	
	      criteria.lastTime = currTime;
	      criteria.keys.push(lowerKey);
	      var keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);
	
	      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
	        event.preventDefault();
	      } else {
	        criteria.previousKeyMatched = false;
	      }
	    }
	
	    if (onKeyDown) {
	      onKeyDown(event);
	    }
	  };
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    listRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRef = (0, _useForkRef.default)(handleOwnRef, ref);
	  /**
	   * the index of the item should receive focus
	   * in a `variant="selectedMenu"` it's the first `selected` item
	   * otherwise it's the very first item.
	   */
	
	  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
	  // to check if there is a `selected` item. We're looking for the last `selected`
	  // item and use the first valid item as a fallback
	
	  React.Children.forEach(children, function (child, index) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    if (!child.props.disabled) {
	      if (variant === 'selectedMenu' && child.props.selected) {
	        activeItemIndex = index;
	      } else if (activeItemIndex === -1) {
	        activeItemIndex = index;
	      }
	    }
	  });
	  var items = React.Children.map(children, function (child, index) {
	    if (index === activeItemIndex) {
	      var newChildProps = {};
	
	      if (autoFocusItem) {
	        newChildProps.autoFocus = true;
	      }
	
	      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
	        newChildProps.tabIndex = 0;
	      }
	
	      return /*#__PURE__*/React.cloneElement(child, newChildProps);
	    }
	
	    return child;
	  });
	  return /*#__PURE__*/React.createElement(_List.default, (0, _extends2.default)({
	    role: "menu",
	    ref: handleRef,
	    className: className,
	    onKeyDown: handleKeyDown,
	    tabIndex: autoFocus ? 0 : -1
	  }, other), items);
	});
	 false ? MenuList.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, will focus the `[role="menu"]` container and move into tab order.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
	   * if `variant="selectedMenu"`.
	   */
	  autoFocusItem: _propTypes.default.bool,
	
	  /**
	   * MenuList contents, normally `MenuItem`s.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, will allow focus on disabled items.
	   */
	  disabledItemsFocusable: _propTypes.default.bool,
	
	  /**
	   * If `true`, the menu items will not wrap focus.
	   */
	  disableListWrap: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
	   * and the vertical alignment relative to the anchor element.
	   */
	  variant: _propTypes.default.oneOf(['menu', 'selectedMenu'])
	} : void 0;
	var _default = MenuList;
	exports.default = _default;

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(46));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Paper = _interopRequireDefault(__webpack_require__(65));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _LinearProgress = _interopRequireDefault(__webpack_require__(356));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      flexDirection: 'row',
	      justifyContent: 'space-between',
	      alignItems: 'center',
	      background: theme.palette.background.default,
	      padding: 8
	    },
	
	    /* Styles applied to the root element if `position="bottom"`. */
	    positionBottom: {
	      position: 'fixed',
	      bottom: 0,
	      left: 0,
	      right: 0,
	      zIndex: theme.zIndex.mobileStepper
	    },
	
	    /* Styles applied to the root element if `position="top"`. */
	    positionTop: {
	      position: 'fixed',
	      top: 0,
	      left: 0,
	      right: 0,
	      zIndex: theme.zIndex.mobileStepper
	    },
	
	    /* Styles applied to the root element if `position="static"`. */
	    positionStatic: {},
	
	    /* Styles applied to the dots container if `variant="dots"`. */
	    dots: {
	      display: 'flex',
	      flexDirection: 'row'
	    },
	
	    /* Styles applied to each dot if `variant="dots"`. */
	    dot: {
	      backgroundColor: theme.palette.action.disabled,
	      borderRadius: '50%',
	      width: 8,
	      height: 8,
	      margin: '0 2px'
	    },
	
	    /* Styles applied to a dot if `variant="dots"` and this is the active step. */
	    dotActive: {
	      backgroundColor: theme.palette.primary.main
	    },
	
	    /* Styles applied to the Linear Progress component if `variant="progress"`. */
	    progress: {
	      width: '50%'
	    }
	  };
	};
	
	exports.styles = styles;
	var MobileStepper = /*#__PURE__*/React.forwardRef(function MobileStepper(props, ref) {
	  var _props$activeStep = props.activeStep,
	      activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
	      backButton = props.backButton,
	      classes = props.classes,
	      className = props.className,
	      LinearProgressProps = props.LinearProgressProps,
	      nextButton = props.nextButton,
	      _props$position = props.position,
	      position = _props$position === void 0 ? 'bottom' : _props$position,
	      steps = props.steps,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'dots' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["activeStep", "backButton", "classes", "className", "LinearProgressProps", "nextButton", "position", "steps", "variant"]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    elevation: 0,
	    className: (0, _clsx.default)(classes.root, classes["position".concat((0, _capitalize.default)(position))], className),
	    ref: ref
	  }, other), backButton, variant === 'text' && /*#__PURE__*/React.createElement(React.Fragment, null, activeStep + 1, " / ", steps), variant === 'dots' && /*#__PURE__*/React.createElement("div", {
	    className: classes.dots
	  }, (0, _toConsumableArray2.default)(new Array(steps)).map(function (_, index) {
	    return /*#__PURE__*/React.createElement("div", {
	      key: index,
	      className: (0, _clsx.default)(classes.dot, index === activeStep && classes.dotActive)
	    });
	  })), variant === 'progress' && /*#__PURE__*/React.createElement(_LinearProgress.default, (0, _extends2.default)({
	    className: classes.progress,
	    variant: "determinate",
	    value: Math.ceil(activeStep / (steps - 1) * 100)
	  }, LinearProgressProps)), nextButton);
	});
	 false ? MobileStepper.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Set the active step (zero based index).
	   * Defines which dot is highlighted when the variant is 'dots'.
	   */
	  activeStep: _propTypes.default.number,
	
	  /**
	   * A back button element. For instance, it can be a `Button` or an `IconButton`.
	   */
	  backButton: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Props applied to the `LinearProgress` element.
	   */
	  LinearProgressProps: _propTypes.default.object,
	
	  /**
	   * A next button element. For instance, it can be a `Button` or an `IconButton`.
	   */
	  nextButton: _propTypes.default.node,
	
	  /**
	   * Set the positioning type.
	   */
	  position: _propTypes.default.oneOf(['bottom', 'static', 'top']),
	
	  /**
	   * The total steps.
	   */
	  steps: _propTypes.default.number.isRequired,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['dots', 'progress', 'text'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMobileStepper'
	})(MobileStepper);
	
	exports.default = _default;

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MobileStepper.default;
	  }
	});
	
	var _MobileStepper = _interopRequireDefault(__webpack_require__(922));

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(45));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _styles = __webpack_require__(60);
	
	var _utils = __webpack_require__(22);
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(68));
	
	var _Portal = _interopRequireDefault(__webpack_require__(236));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(111));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(79));
	
	var _zIndex = _interopRequireDefault(__webpack_require__(394));
	
	var _ModalManager = _interopRequireWildcard(__webpack_require__(362));
	
	var _Unstable_TrapFocus = _interopRequireDefault(__webpack_require__(380));
	
	var _SimpleBackdrop = _interopRequireDefault(__webpack_require__(925));
	
	function getContainer(container) {
	  container = typeof container === 'function' ? container() : container;
	  return ReactDOM.findDOMNode(container);
	}
	
	function getHasTransition(props) {
	  return props.children ? props.children.props.hasOwnProperty('in') : false;
	} // A modal manager used to track and manage the state of open Modals.
	// Modals don't open on the server so this won't conflict with concurrent requests.
	
	
	var defaultManager = new _ModalManager.default();
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'fixed',
	      zIndex: theme.zIndex.modal,
	      right: 0,
	      bottom: 0,
	      top: 0,
	      left: 0
	    },
	
	    /* Styles applied to the root element if the `Modal` has exited. */
	    hidden: {
	      visibility: 'hidden'
	    }
	  };
	};
	/**
	 * Modal is a lower-level construct that is leveraged by the following components:
	 *
	 * - [Dialog](/api/dialog/)
	 * - [Drawer](/api/drawer/)
	 * - [Menu](/api/menu/)
	 * - [Popover](/api/popover/)
	 *
	 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
	 * rather than directly using Modal.
	 *
	 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
	 */
	
	
	exports.styles = styles;
	var Modal = /*#__PURE__*/React.forwardRef(function Modal(inProps, ref) {
	  var theme = (0, _styles.useTheme)();
	  var props = (0, _styles.getThemeProps)({
	    name: 'MuiModal',
	    props: (0, _extends2.default)({}, inProps),
	    theme: theme
	  });
	  var _props$BackdropCompon = props.BackdropComponent,
	      BackdropComponent = _props$BackdropCompon === void 0 ? _SimpleBackdrop.default : _props$BackdropCompon,
	      BackdropProps = props.BackdropProps,
	      children = props.children,
	      _props$closeAfterTran = props.closeAfterTransition,
	      closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran,
	      container = props.container,
	      _props$disableAutoFoc = props.disableAutoFocus,
	      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
	      _props$disableBackdro = props.disableBackdropClick,
	      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
	      _props$disableEnforce = props.disableEnforceFocus,
	      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
	      _props$disableEscapeK = props.disableEscapeKeyDown,
	      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      _props$disableRestore = props.disableRestoreFocus,
	      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
	      _props$disableScrollL = props.disableScrollLock,
	      disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL,
	      _props$hideBackdrop = props.hideBackdrop,
	      hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop,
	      _props$keepMounted = props.keepMounted,
	      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
	      _props$manager = props.manager,
	      manager = _props$manager === void 0 ? defaultManager : _props$manager,
	      onBackdropClick = props.onBackdropClick,
	      onClose = props.onClose,
	      onEscapeKeyDown = props.onEscapeKeyDown,
	      onRendered = props.onRendered,
	      open = props.open,
	      other = (0, _objectWithoutProperties2.default)(props, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);
	
	  var _React$useState = React.useState(true),
	      exited = _React$useState[0],
	      setExited = _React$useState[1];
	
	  var modal = React.useRef({});
	  var mountNodeRef = React.useRef(null);
	  var modalRef = React.useRef(null);
	  var handleRef = (0, _useForkRef.default)(modalRef, ref);
	  var hasTransition = getHasTransition(props);
	
	  var getDoc = function getDoc() {
	    return (0, _ownerDocument.default)(mountNodeRef.current);
	  };
	
	  var getModal = function getModal() {
	    modal.current.modalRef = modalRef.current;
	    modal.current.mountNode = mountNodeRef.current;
	    return modal.current;
	  };
	
	  var handleMounted = function handleMounted() {
	    manager.mount(getModal(), {
	      disableScrollLock: disableScrollLock
	    }); // Fix a bug on Chrome where the scroll isn't initially 0.
	
	    modalRef.current.scrollTop = 0;
	  };
	
	  var handleOpen = (0, _useEventCallback.default)(function () {
	    var resolvedContainer = getContainer(container) || getDoc().body;
	    manager.add(getModal(), resolvedContainer); // The element was already mounted.
	
	    if (modalRef.current) {
	      handleMounted();
	    }
	  });
	  var isTopModal = React.useCallback(function () {
	    return manager.isTopModal(getModal());
	  }, [manager]);
	  var handlePortalRef = (0, _useEventCallback.default)(function (node) {
	    mountNodeRef.current = node;
	
	    if (!node) {
	      return;
	    }
	
	    if (onRendered) {
	      onRendered();
	    }
	
	    if (open && isTopModal()) {
	      handleMounted();
	    } else {
	      (0, _ModalManager.ariaHidden)(modalRef.current, true);
	    }
	  });
	  var handleClose = React.useCallback(function () {
	    manager.remove(getModal());
	  }, [manager]);
	  React.useEffect(function () {
	    return function () {
	      handleClose();
	    };
	  }, [handleClose]);
	  React.useEffect(function () {
	    if (open) {
	      handleOpen();
	    } else if (!hasTransition || !closeAfterTransition) {
	      handleClose();
	    }
	  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);
	
	  if (!keepMounted && !open && (!hasTransition || exited)) {
	    return null;
	  }
	
	  var handleEnter = function handleEnter() {
	    setExited(false);
	  };
	
	  var handleExited = function handleExited() {
	    setExited(true);
	
	    if (closeAfterTransition) {
	      handleClose();
	    }
	  };
	
	  var handleBackdropClick = function handleBackdropClick(event) {
	    if (event.target !== event.currentTarget) {
	      return;
	    }
	
	    if (onBackdropClick) {
	      onBackdropClick(event);
	    }
	
	    if (!disableBackdropClick && onClose) {
	      onClose(event, 'backdropClick');
	    }
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    // The handler doesn't take event.defaultPrevented into account:
	    //
	    // event.preventDefault() is meant to stop default behaviours like
	    // clicking a checkbox to check it, hitting a button to submit a form,
	    // and hitting left arrow to move the cursor in a text input etc.
	    // Only special HTML elements have these default behaviors.
	    if (event.key !== 'Escape' || !isTopModal()) {
	      return;
	    }
	
	    if (onEscapeKeyDown) {
	      onEscapeKeyDown(event);
	    }
	
	    if (!disableEscapeKeyDown) {
	      // Swallow the event, in case someone is listening for the escape key on the body.
	      event.stopPropagation();
	
	      if (onClose) {
	        onClose(event, 'escapeKeyDown');
	      }
	    }
	  };
	
	  var inlineStyle = styles(theme || {
	    zIndex: _zIndex.default
	  });
	  var childProps = {};
	
	  if (children.props.tabIndex === undefined) {
	    childProps.tabIndex = children.props.tabIndex || '-1';
	  } // It's a Transition like component
	
	
	  if (hasTransition) {
	    childProps.onEnter = (0, _createChainedFunction.default)(handleEnter, children.props.onEnter);
	    childProps.onExited = (0, _createChainedFunction.default)(handleExited, children.props.onExited);
	  }
	
	  return /*#__PURE__*/React.createElement(_Portal.default, {
	    ref: handlePortalRef,
	    container: container,
	    disablePortal: disablePortal
	  }, /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    ref: handleRef,
	    onKeyDown: handleKeyDown,
	    role: "presentation"
	  }, other, {
	    style: (0, _extends2.default)({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
	  }), hideBackdrop ? null : /*#__PURE__*/React.createElement(BackdropComponent, (0, _extends2.default)({
	    open: open,
	    onClick: handleBackdropClick
	  }, BackdropProps)), /*#__PURE__*/React.createElement(_Unstable_TrapFocus.default, {
	    disableEnforceFocus: disableEnforceFocus,
	    disableAutoFocus: disableAutoFocus,
	    disableRestoreFocus: disableRestoreFocus,
	    getDoc: getDoc,
	    isEnabled: isTopModal,
	    open: open
	  }, /*#__PURE__*/React.cloneElement(children, childProps))));
	});
	 false ? Modal.propTypes = {
	  /**
	   * A backdrop component. This prop enables custom backdrop rendering.
	   */
	  BackdropComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Backdrop`](/api/backdrop/) element.
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * A single child content element.
	   */
	  children: _utils.elementAcceptingRef.isRequired,
	
	  /**
	   * When set to true the Modal waits until a nested Transition is completed before closing.
	   */
	  closeAfterTransition: _propTypes.default.bool,
	
	  /**
	   * A HTML element, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   *
	   * By default, it uses the body of the top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_utils.HTMLElementType, _propTypes.default.instanceOf(React.Component), _propTypes.default.func]),
	
	  /**
	   * If `true`, the modal will not automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes.
	   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableAutoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, clicking the backdrop will not fire `onClose`.
	   */
	  disableBackdropClick: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not prevent focus from leaving the modal while open.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableEnforceFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, hitting escape will not fire `onClose`.
	   */
	  disableEscapeKeyDown: _propTypes.default.bool,
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not restore focus to previously focused element once
	   * modal is hidden.
	   */
	  disableRestoreFocus: _propTypes.default.bool,
	
	  /**
	   * Disable the scroll lock behavior.
	   */
	  disableScrollLock: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is not rendered.
	   */
	  hideBackdrop: _propTypes.default.bool,
	
	  /**
	   * Always keep the children in the DOM.
	   * This prop can be useful in SEO situation or
	   * when you want to maximize the responsiveness of the Modal.
	   */
	  keepMounted: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  manager: _propTypes.default.object,
	
	  /**
	   * Callback fired when the backdrop is clicked.
	   */
	  onBackdropClick: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * The `reason` parameter can optionally be used to control the response to `onClose`.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the escape key is pressed,
	   * `disableEscapeKeyDown` is false and the modal is in focus.
	   */
	  onEscapeKeyDown: _propTypes.default.func,
	
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   * It signals that the `open={true}` prop took effect.
	   *
	   * This prop will be deprecated and removed in v5, the ref can be used instead.
	   */
	  onRendered: _propTypes.default.func,
	
	  /**
	   * If `true`, the modal is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	var _default = Modal;
	exports.default = _default;

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    zIndex: -1,
	    position: 'fixed',
	    right: 0,
	    bottom: 0,
	    top: 0,
	    left: 0,
	    backgroundColor: 'rgba(0, 0, 0, 0.5)',
	    WebkitTapHighlightColor: 'transparent'
	  },
	
	  /* Styles applied to the root element if `invisible={true}`. */
	  invisible: {
	    backgroundColor: 'transparent'
	  }
	};
	/**
	 * @ignore - internal component.
	 */
	
	exports.styles = styles;
	var SimpleBackdrop = /*#__PURE__*/React.forwardRef(function SimpleBackdrop(props, ref) {
	  var _props$invisible = props.invisible,
	      invisible = _props$invisible === void 0 ? false : _props$invisible,
	      open = props.open,
	      other = (0, _objectWithoutProperties2.default)(props, ["invisible", "open"]);
	  return open ? /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    "aria-hidden": true,
	    ref: ref
	  }, other, {
	    style: (0, _extends2.default)({}, styles.root, invisible ? styles.invisible : {}, other.style)
	  })) : null;
	});
	 false ? SimpleBackdrop.propTypes = {
	  /**
	   * If `true`, the backdrop is invisible.
	   * It can be used when rendering a popover or a custom select component.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	var _default = SimpleBackdrop;
	exports.default = _default;

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _NativeSelect.default;
	  }
	});
	
	var _NativeSelect = _interopRequireDefault(__webpack_require__(363));

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _utils = __webpack_require__(22);
	
	var useEnhancedEffect = typeof window !== 'undefined' && ("production") !== 'test' ? React.useLayoutEffect : React.useEffect;
	/**
	 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
	 *
	 * This component can be useful in a variety of situations:
	 * - Escape hatch for broken dependencies not supporting SSR.
	 * - Improve the time-to-first paint on the client by only rendering above the fold.
	 * - Reduce the rendering time on the server.
	 * - Under too heavy server load, you can turn on service degradation.
	 */
	
	function NoSsr(props) {
	  var children = props.children,
	      _props$defer = props.defer,
	      defer = _props$defer === void 0 ? false : _props$defer,
	      _props$fallback = props.fallback,
	      fallback = _props$fallback === void 0 ? null : _props$fallback;
	
	  var _React$useState = React.useState(false),
	      mountedState = _React$useState[0],
	      setMountedState = _React$useState[1];
	
	  useEnhancedEffect(function () {
	    if (!defer) {
	      setMountedState(true);
	    }
	  }, [defer]);
	  React.useEffect(function () {
	    if (defer) {
	      setMountedState(true);
	    }
	  }, [defer]); // We need the Fragment here to force react-docgen to recognise NoSsr as a component.
	
	  return /*#__PURE__*/React.createElement(React.Fragment, null, mountedState ? children : fallback);
	}
	
	 false ? NoSsr.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * You can wrap a node.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * If `true`, the component will not only prevent server-side rendering.
	   * It will also defer the rendering of the children into a different screen frame.
	   */
	  defer: _propTypes.default.bool,
	
	  /**
	   * The fallback content to display.
	   */
	  fallback: _propTypes.default.node
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  NoSsr['propTypes' + ''] = (0, _utils.exactProp)(NoSsr.propTypes);
	}
	
	var _default = NoSsr;
	exports.default = _default;

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(47));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'absolute',
	      bottom: 0,
	      right: 0,
	      top: -5,
	      left: 0,
	      margin: 0,
	      padding: '0 8px',
	      pointerEvents: 'none',
	      borderRadius: 'inherit',
	      borderStyle: 'solid',
	      borderWidth: 1,
	      overflow: 'hidden'
	    },
	
	    /* Styles applied to the legend element when `labelWidth` is provided. */
	    legend: {
	      textAlign: 'left',
	      padding: 0,
	      lineHeight: '11px',
	      // sync with `height` in `legend` styles
	      transition: theme.transitions.create('width', {
	        duration: 150,
	        easing: theme.transitions.easing.easeOut
	      })
	    },
	
	    /* Styles applied to the legend element. */
	    legendLabelled: {
	      display: 'block',
	      width: 'auto',
	      textAlign: 'left',
	      padding: 0,
	      height: 11,
	      // sync with `lineHeight` in `legend` styles
	      fontSize: '0.75em',
	      visibility: 'hidden',
	      maxWidth: 0.01,
	      transition: theme.transitions.create('max-width', {
	        duration: 50,
	        easing: theme.transitions.easing.easeOut
	      }),
	      '& > span': {
	        paddingLeft: 5,
	        paddingRight: 5,
	        display: 'inline-block'
	      }
	    },
	
	    /* Styles applied to the legend element is notched. */
	    legendNotched: {
	      maxWidth: 1000,
	      transition: theme.transitions.create('max-width', {
	        duration: 100,
	        easing: theme.transitions.easing.easeOut,
	        delay: 50
	      })
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	var NotchedOutline = /*#__PURE__*/React.forwardRef(function NotchedOutline(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      label = props.label,
	      labelWidthProp = props.labelWidth,
	      notched = props.notched,
	      style = props.style,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "label", "labelWidth", "notched", "style"]);
	  var theme = (0, _useTheme.default)();
	  var align = theme.direction === 'rtl' ? 'right' : 'left';
	
	  if (label !== undefined) {
	    return /*#__PURE__*/React.createElement("fieldset", (0, _extends3.default)({
	      "aria-hidden": true,
	      className: (0, _clsx.default)(classes.root, className),
	      ref: ref,
	      style: style
	    }, other), /*#__PURE__*/React.createElement("legend", {
	      className: (0, _clsx.default)(classes.legendLabelled, notched && classes.legendNotched)
	    }, label ? /*#__PURE__*/React.createElement("span", null, label) : /*#__PURE__*/React.createElement("span", {
	      dangerouslySetInnerHTML: {
	        __html: '&#8203;'
	      }
	    })));
	  }
	
	  var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
	  return /*#__PURE__*/React.createElement("fieldset", (0, _extends3.default)({
	    "aria-hidden": true,
	    style: (0, _extends3.default)((0, _defineProperty2.default)({}, "padding".concat((0, _capitalize.default)(align)), 8), style),
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("legend", {
	    className: classes.legend,
	    style: {
	      // IE 11: fieldset with legend does not render
	      // a border radius. This maintains consistency
	      // by always having a legend rendered
	      width: notched ? labelWidth : 0.01
	    }
	  }, /*#__PURE__*/React.createElement("span", {
	    dangerouslySetInnerHTML: {
	      __html: '&#8203;'
	    }
	  })));
	});
	 false ? NotchedOutline.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The label.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The width of the label.
	   */
	  labelWidth: _propTypes.default.number.isRequired,
	
	  /**
	   * If `true`, the outline is notched to accommodate the label.
	   */
	  notched: _propTypes.default.bool.isRequired,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateNotchedOutline'
	})(NotchedOutline);
	
	exports.default = _default;

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _InputBase = _interopRequireDefault(__webpack_require__(126));
	
	var _NotchedOutline = _interopRequireDefault(__webpack_require__(928));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = function styles(theme) {
	  var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      borderRadius: theme.shape.borderRadius,
	      '&:hover $notchedOutline': {
	        borderColor: theme.palette.text.primary
	      },
	      // Reset on touch devices, it doesn't add specificity
	      '@media (hover: none)': {
	        '&:hover $notchedOutline': {
	          borderColor: borderColor
	        }
	      },
	      '&$focused $notchedOutline': {
	        borderColor: theme.palette.primary.main,
	        borderWidth: 2
	      },
	      '&$error $notchedOutline': {
	        borderColor: theme.palette.error.main
	      },
	      '&$disabled $notchedOutline': {
	        borderColor: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if the color is secondary. */
	    colorSecondary: {
	      '&$focused $notchedOutline': {
	        borderColor: theme.palette.secondary.main
	      }
	    },
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `startAdornment` is provided. */
	    adornedStart: {
	      paddingLeft: 14
	    },
	
	    /* Styles applied to the root element if `endAdornment` is provided. */
	    adornedEnd: {
	      paddingRight: 14
	    },
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {
	      padding: '18.5px 14px',
	      '&$marginDense': {
	        paddingTop: 10.5,
	        paddingBottom: 10.5
	      }
	    },
	
	    /* Styles applied to the `NotchedOutline` element. */
	    notchedOutline: {
	      borderColor: borderColor
	    },
	
	    /* Styles applied to the `input` element. */
	    input: {
	      padding: '18.5px 14px',
	      '&:-webkit-autofill': {
	        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
	        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
	        caretColor: theme.palette.type === 'light' ? null : '#fff',
	        borderRadius: 'inherit'
	      }
	    },
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {
	      paddingTop: 10.5,
	      paddingBottom: 10.5
	    },
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {
	      padding: 0
	    },
	
	    /* Styles applied to the `input` element if `startAdornment` is provided. */
	    inputAdornedStart: {
	      paddingLeft: 0
	    },
	
	    /* Styles applied to the `input` element if `endAdornment` is provided. */
	    inputAdornedEnd: {
	      paddingRight: 0
	    }
	  };
	};
	
	exports.styles = styles;
	var OutlinedInput = /*#__PURE__*/React.forwardRef(function OutlinedInput(props, ref) {
	  var classes = props.classes,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      label = props.label,
	      _props$labelWidth = props.labelWidth,
	      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      notched = props.notched,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);
	  return /*#__PURE__*/React.createElement(_InputBase.default, (0, _extends2.default)({
	    renderSuffix: function renderSuffix(state) {
	      return /*#__PURE__*/React.createElement(_NotchedOutline.default, {
	        className: classes.notchedOutline,
	        label: label,
	        labelWidth: labelWidth,
	        notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
	      });
	    },
	    classes: (0, _extends2.default)({}, classes, {
	      root: (0, _clsx.default)(classes.root, classes.underline),
	      notchedOutline: null
	    }),
	    fullWidth: fullWidth,
	    inputComponent: inputComponent,
	    multiline: multiline,
	    ref: ref,
	    type: type
	  }, other));
	});
	 false ? OutlinedInput.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a HTML element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The label of the input. It is only used for layout. The actual labelling
	   * is handled by `InputLabel`. If specified `labelWidth` is ignored.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The width of the label. Is ignored if `label` is provided. Prefer `label`
	   * if the input label appears with a strike through.
	   */
	  labelWidth: _propTypes.default.number,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * If `true`, the outline is notched to accommodate the label.
	   */
	  notched: _propTypes.default.bool,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	OutlinedInput.muiName = 'Input';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiOutlinedInput'
	})(OutlinedInput);
	
	exports.default = _default;

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = function styles(theme) {
	  var elevations = {};
	  theme.shadows.forEach(function (shadow, index) {
	    elevations["elevation".concat(index)] = {
	      boxShadow: shadow
	    };
	  });
	  return (0, _extends2.default)({
	    /* Styles applied to the root element. */
	    root: {
	      backgroundColor: theme.palette.background.paper,
	      color: theme.palette.text.primary,
	      transition: theme.transitions.create('box-shadow')
	    },
	
	    /* Styles applied to the root element if `square={false}`. */
	    rounded: {
	      borderRadius: theme.shape.borderRadius
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      border: "1px solid ".concat(theme.palette.divider)
	    }
	  }, elevations);
	};
	
	exports.styles = styles;
	var Paper = /*#__PURE__*/React.forwardRef(function Paper(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$square = props.square,
	      square = _props$square === void 0 ? false : _props$square,
	      _props$elevation = props.elevation,
	      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'elevation' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation", "variant"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
	    ref: ref
	  }, other));
	});
	 false ? Paper.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Shadow depth, corresponds to `dp` in the spec.
	   * It accepts values between 0 and 24 inclusive.
	   */
	  elevation: (0, _utils.chainPropTypes)(_propTypes.default.number, function (props) {
	    var classes = props.classes,
	        elevation = props.elevation; // in case `withStyles` fails to inject we don't need this warning
	
	    if (classes === undefined) {
	      return null;
	    }
	
	    if (elevation != null && classes["elevation".concat(elevation)] === undefined) {
	      return new Error("Material-UI: This elevation `".concat(elevation, "` is not implemented."));
	    }
	
	    return null;
	  }),
	
	  /**
	   * If `true`, rounded corners are disabled.
	   */
	  square: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['elevation', 'outlined'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiPaper'
	})(Paper);
	
	exports.default = _default;

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOffsetTop = getOffsetTop;
	exports.getOffsetLeft = getOffsetLeft;
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(45));
	
	var _utils = __webpack_require__(22);
	
	var _debounce = _interopRequireDefault(__webpack_require__(94));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(68));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(168));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(111));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Modal = _interopRequireDefault(__webpack_require__(165));
	
	var _Grow = _interopRequireDefault(__webpack_require__(163));
	
	var _Paper = _interopRequireDefault(__webpack_require__(65));
	
	function getOffsetTop(rect, vertical) {
	  var offset = 0;
	
	  if (typeof vertical === 'number') {
	    offset = vertical;
	  } else if (vertical === 'center') {
	    offset = rect.height / 2;
	  } else if (vertical === 'bottom') {
	    offset = rect.height;
	  }
	
	  return offset;
	}
	
	function getOffsetLeft(rect, horizontal) {
	  var offset = 0;
	
	  if (typeof horizontal === 'number') {
	    offset = horizontal;
	  } else if (horizontal === 'center') {
	    offset = rect.width / 2;
	  } else if (horizontal === 'right') {
	    offset = rect.width;
	  }
	
	  return offset;
	}
	
	function getTransformOriginValue(transformOrigin) {
	  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
	    return typeof n === 'number' ? "".concat(n, "px") : n;
	  }).join(' ');
	} // Sum the scrollTop between two elements.
	
	
	function getScrollParent(parent, child) {
	  var element = child;
	  var scrollTop = 0;
	
	  while (element && element !== parent) {
	    element = element.parentElement;
	    scrollTop += element.scrollTop;
	  }
	
	  return scrollTop;
	}
	
	function getAnchorEl(anchorEl) {
	  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
	}
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {},
	
	  /* Styles applied to the `Paper` component. */
	  paper: {
	    position: 'absolute',
	    overflowY: 'auto',
	    overflowX: 'hidden',
	    // So we see the popover when it's empty.
	    // It's most likely on issue on userland.
	    minWidth: 16,
	    minHeight: 16,
	    maxWidth: 'calc(100% - 32px)',
	    maxHeight: 'calc(100% - 32px)',
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0
	  }
	};
	exports.styles = styles;
	var Popover = /*#__PURE__*/React.forwardRef(function Popover(props, ref) {
	  var action = props.action,
	      anchorEl = props.anchorEl,
	      _props$anchorOrigin = props.anchorOrigin,
	      anchorOrigin = _props$anchorOrigin === void 0 ? {
	    vertical: 'top',
	    horizontal: 'left'
	  } : _props$anchorOrigin,
	      anchorPosition = props.anchorPosition,
	      _props$anchorReferenc = props.anchorReference,
	      anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      containerProp = props.container,
	      _props$elevation = props.elevation,
	      elevation = _props$elevation === void 0 ? 8 : _props$elevation,
	      getContentAnchorEl = props.getContentAnchorEl,
	      _props$marginThreshol = props.marginThreshold,
	      marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      open = props.open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      _props$transformOrigi = props.transformOrigin,
	      transformOrigin = _props$transformOrigi === void 0 ? {
	    vertical: 'top',
	    horizontal: 'left'
	  } : _props$transformOrigi,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Grow.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
	      _props$TransitionProp = props.TransitionProps,
	      TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);
	  var paperRef = React.useRef(); // Returns the top/left offset of the position
	  // to attach to on the anchor element (or body if none is provided)
	
	  var getAnchorOffset = React.useCallback(function (contentAnchorOffset) {
	    if (anchorReference === 'anchorPosition') {
	      if (false) {
	        if (!anchorPosition) {
	          console.error('Material-UI: You need to provide a `anchorPosition` prop when using ' + '<Popover anchorReference="anchorPosition" />.');
	        }
	      }
	
	      return anchorPosition;
	    }
	
	    var resolvedAnchorEl = getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover
	
	    var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, _ownerDocument.default)(paperRef.current).body;
	    var anchorRect = anchorElement.getBoundingClientRect();
	
	    if (false) {
	      var box = anchorElement.getBoundingClientRect();
	
	      if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	        console.warn(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	      }
	    }
	
	    var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
	    return {
	      top: anchorRect.top + getOffsetTop(anchorRect, anchorVertical),
	      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
	    };
	  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]); // Returns the vertical offset of inner content to anchor the transform on if provided
	
	  var getContentAnchorOffset = React.useCallback(function (element) {
	    var contentAnchorOffset = 0;
	
	    if (getContentAnchorEl && anchorReference === 'anchorEl') {
	      var contentAnchorEl = getContentAnchorEl(element);
	
	      if (contentAnchorEl && element.contains(contentAnchorEl)) {
	        var scrollTop = getScrollParent(element, contentAnchorEl);
	        contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
	      } // != the default value
	
	
	      if (false) {
	        if (anchorOrigin.vertical !== 'top') {
	          console.error(['Material-UI: You can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` prop to the popover component.', 'Only use one of the two props.', 'Set `getContentAnchorEl` to `null | undefined`' + ' or leave `anchorOrigin.vertical` unchanged.'].join('\n'));
	        }
	      }
	    }
	
	    return contentAnchorOffset;
	  }, [anchorOrigin.vertical, anchorReference, getContentAnchorEl]); // Return the base transform origin using the element
	  // and taking the content anchor offset into account if in use
	
	  var getTransformOrigin = React.useCallback(function (elemRect) {
	    var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    return {
	      vertical: getOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
	      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
	    };
	  }, [transformOrigin.horizontal, transformOrigin.vertical]);
	  var getPositioningStyle = React.useCallback(function (element) {
	    // Check if the parent has requested anchoring on an inner content node
	    var contentAnchorOffset = getContentAnchorOffset(element);
	    var elemRect = {
	      width: element.offsetWidth,
	      height: element.offsetHeight
	    }; // Get the transform origin point on the element itself
	
	    var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);
	
	    if (anchorReference === 'none') {
	      return {
	        top: null,
	        left: null,
	        transformOrigin: getTransformOriginValue(elemTransformOrigin)
	      };
	    } // Get the offset of of the anchoring element
	
	
	    var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning
	
	    var top = anchorOffset.top - elemTransformOrigin.vertical;
	    var left = anchorOffset.left - elemTransformOrigin.horizontal;
	    var bottom = top + elemRect.height;
	    var right = left + elemRect.width; // Use the parent window of the anchorEl if provided
	
	    var containerWindow = (0, _ownerWindow.default)(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account
	
	    var heightThreshold = containerWindow.innerHeight - marginThreshold;
	    var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
	
	    if (top < marginThreshold) {
	      var diff = top - marginThreshold;
	      top -= diff;
	      elemTransformOrigin.vertical += diff;
	    } else if (bottom > heightThreshold) {
	      var _diff = bottom - heightThreshold;
	
	      top -= _diff;
	      elemTransformOrigin.vertical += _diff;
	    }
	
	    if (false) {
	      if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
	        console.error(['Material-UI: The popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n'));
	      }
	    } // Check if the horizontal axis needs shifting
	
	
	    if (left < marginThreshold) {
	      var _diff2 = left - marginThreshold;
	
	      left -= _diff2;
	      elemTransformOrigin.horizontal += _diff2;
	    } else if (right > widthThreshold) {
	      var _diff3 = right - widthThreshold;
	
	      left -= _diff3;
	      elemTransformOrigin.horizontal += _diff3;
	    }
	
	    return {
	      top: "".concat(Math.round(top), "px"),
	      left: "".concat(Math.round(left), "px"),
	      transformOrigin: getTransformOriginValue(elemTransformOrigin)
	    };
	  }, [anchorEl, anchorReference, getAnchorOffset, getContentAnchorOffset, getTransformOrigin, marginThreshold]);
	  var setPositioningStyles = React.useCallback(function () {
	    var element = paperRef.current;
	
	    if (!element) {
	      return;
	    }
	
	    var positioning = getPositioningStyle(element);
	
	    if (positioning.top !== null) {
	      element.style.top = positioning.top;
	    }
	
	    if (positioning.left !== null) {
	      element.style.left = positioning.left;
	    }
	
	    element.style.transformOrigin = positioning.transformOrigin;
	  }, [getPositioningStyle]);
	
	  var handleEntering = function handleEntering(element, isAppearing) {
	    if (onEntering) {
	      onEntering(element, isAppearing);
	    }
	
	    setPositioningStyles();
	  };
	
	  var handlePaperRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    paperRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  React.useEffect(function () {
	    if (open) {
	      setPositioningStyles();
	    }
	  });
	  React.useImperativeHandle(action, function () {
	    return open ? {
	      updatePosition: function updatePosition() {
	        setPositioningStyles();
	      }
	    } : null;
	  }, [open, setPositioningStyles]);
	  React.useEffect(function () {
	    if (!open) {
	      return undefined;
	    }
	
	    var handleResize = (0, _debounce.default)(function () {
	      setPositioningStyles();
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [open, setPositioningStyles]);
	  var transitionDuration = transitionDurationProp;
	
	  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
	    transitionDuration = undefined;
	  } // If the container prop is provided, use that
	  // If the anchorEl prop is provided, use its parent body element as the container
	  // If neither are provided let the Modal take care of choosing the container
	
	
	  var container = containerProp || (anchorEl ? (0, _ownerDocument.default)(getAnchorEl(anchorEl)).body : undefined);
	  return /*#__PURE__*/React.createElement(_Modal.default, (0, _extends2.default)({
	    container: container,
	    open: open,
	    ref: ref,
	    BackdropProps: {
	      invisible: true
	    },
	    className: (0, _clsx.default)(classes.root, className)
	  }, other), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: open,
	    onEnter: onEnter,
	    onEntered: onEntered,
	    onExit: onExit,
	    onExited: onExited,
	    onExiting: onExiting,
	    timeout: transitionDuration
	  }, TransitionProps, {
	    onEntering: (0, _createChainedFunction.default)(handleEntering, TransitionProps.onEntering)
	  }), /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    elevation: elevation,
	    ref: handlePaperRef
	  }, PaperProps, {
	    className: (0, _clsx.default)(classes.paper, PaperProps.className)
	  }), children)));
	});
	 false ? Popover.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A ref for imperative actions.
	   * It currently only supports updatePosition() action.
	   */
	  action: _utils.refType,
	
	  /**
	   * A HTML element, or a function that returns it.
	   * It's used to set the position of the popover.
	   */
	  anchorEl: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_utils.HTMLElementType, _propTypes.default.func]), function (props) {
	    if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
	      var resolvedAnchorEl = getAnchorEl(props.anchorEl);
	
	      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
	        var box = resolvedAnchorEl.getBoundingClientRect();
	
	        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	          return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	        }
	      } else {
	        return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', "It should be an Element instance but it's `".concat(resolvedAnchorEl, "` instead.")].join('\n'));
	      }
	    }
	
	    return null;
	  }),
	
	  /**
	   * This is the point on the anchor where the popover's
	   * `anchorEl` will attach to. This is not used when the
	   * anchorReference is 'anchorPosition'.
	   *
	   * Options:
	   * vertical: [top, center, bottom];
	   * horizontal: [left, center, right].
	   */
	  anchorOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOfType([_propTypes.default.oneOf(['center', 'left', 'right']), _propTypes.default.number]).isRequired,
	    vertical: _propTypes.default.oneOfType([_propTypes.default.oneOf(['bottom', 'center', 'top']), _propTypes.default.number]).isRequired
	  }),
	
	  /**
	   * This is the position that may be used
	   * to set the position of the popover.
	   * The coordinates are relative to
	   * the application's client area.
	   */
	  anchorPosition: _propTypes.default.shape({
	    left: _propTypes.default.number.isRequired,
	    top: _propTypes.default.number.isRequired
	  }),
	
	  /**
	   * This determines which anchor prop to refer to to set
	   * the position of the popover.
	   */
	  anchorReference: _propTypes.default.oneOf(['anchorEl', 'anchorPosition', 'none']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * A HTML element, component instance, or function that returns either.
	   * The `container` will passed to the Modal component.
	   *
	   * By default, it uses the body of the anchorEl's top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_utils.HTMLElementType, _propTypes.default.instanceOf(React.Component), _propTypes.default.func]),
	
	  /**
	   * The elevation of the popover.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * This function is called in order to retrieve the content anchor element.
	   * It's the opposite of the `anchorEl` prop.
	   * The content anchor element should be an element inside the popover.
	   * It's used to correctly scroll and set the position of the popover.
	   * The positioning strategy tries to make the content anchor element just above the
	   * anchor element.
	   */
	  getContentAnchorEl: _propTypes.default.func,
	
	  /**
	   * Specifies how close to the edge of the window the popover can appear.
	   */
	  marginThreshold: _propTypes.default.number,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the component is entering.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired before the component is exiting.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * If `true`, the popover is visible.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * Props applied to the [`Paper`](/api/paper/) element.
	   */
	  PaperProps: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .shape({
	    component: _utils.elementTypeAcceptingRef
	  }),
	
	  /**
	   * This is the point on the popover which
	   * will attach to the anchor's origin.
	   *
	   * Options:
	   * vertical: [top, center, bottom, x(px)];
	   * horizontal: [left, center, right, x(px)].
	   */
	  transformOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOfType([_propTypes.default.oneOf(['center', 'left', 'right']), _propTypes.default.number]).isRequired,
	    vertical: _propTypes.default.oneOfType([_propTypes.default.oneOf(['bottom', 'center', 'top']), _propTypes.default.number]).isRequired
	  }),
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiPopover'
	})(Popover);
	
	exports.default = _default;

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _popper = _interopRequireDefault(__webpack_require__(1026));
	
	var _utils = __webpack_require__(22);
	
	var _styles = __webpack_require__(60);
	
	var _Portal = _interopRequireDefault(__webpack_require__(236));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(111));
	
	var _setRef = _interopRequireDefault(__webpack_require__(95));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	function flipPlacement(placement, theme) {
	  var direction = theme && theme.direction || 'ltr';
	
	  if (direction === 'ltr') {
	    return placement;
	  }
	
	  switch (placement) {
	    case 'bottom-end':
	      return 'bottom-start';
	
	    case 'bottom-start':
	      return 'bottom-end';
	
	    case 'top-end':
	      return 'top-start';
	
	    case 'top-start':
	      return 'top-end';
	
	    default:
	      return placement;
	  }
	}
	
	function getAnchorEl(anchorEl) {
	  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
	}
	
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	var defaultPopperOptions = {};
	/**
	 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v1/) for positioning.
	 */
	
	var Popper = /*#__PURE__*/React.forwardRef(function Popper(props, ref) {
	  var anchorEl = props.anchorEl,
	      children = props.children,
	      container = props.container,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      _props$keepMounted = props.keepMounted,
	      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
	      modifiers = props.modifiers,
	      open = props.open,
	      _props$placement = props.placement,
	      initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement,
	      _props$popperOptions = props.popperOptions,
	      popperOptions = _props$popperOptions === void 0 ? defaultPopperOptions : _props$popperOptions,
	      popperRefProp = props.popperRef,
	      style = props.style,
	      _props$transition = props.transition,
	      transition = _props$transition === void 0 ? false : _props$transition,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"]);
	  var tooltipRef = React.useRef(null);
	  var ownRef = (0, _useForkRef.default)(tooltipRef, ref);
	  var popperRef = React.useRef(null);
	  var handlePopperRef = (0, _useForkRef.default)(popperRef, popperRefProp);
	  var handlePopperRefRef = React.useRef(handlePopperRef);
	  useEnhancedEffect(function () {
	    handlePopperRefRef.current = handlePopperRef;
	  }, [handlePopperRef]);
	  React.useImperativeHandle(popperRefProp, function () {
	    return popperRef.current;
	  }, []);
	
	  var _React$useState = React.useState(true),
	      exited = _React$useState[0],
	      setExited = _React$useState[1];
	
	  var theme = (0, _styles.useTheme)();
	  var rtlPlacement = flipPlacement(initialPlacement, theme);
	  /**
	   * placement initialized from prop but can change during lifetime if modifiers.flip.
	   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
	   */
	
	  var _React$useState2 = React.useState(rtlPlacement),
	      placement = _React$useState2[0],
	      setPlacement = _React$useState2[1];
	
	  React.useEffect(function () {
	    if (popperRef.current) {
	      popperRef.current.update();
	    }
	  });
	  var handleOpen = React.useCallback(function () {
	    if (!tooltipRef.current || !anchorEl || !open) {
	      return;
	    }
	
	    if (popperRef.current) {
	      popperRef.current.destroy();
	      handlePopperRefRef.current(null);
	    }
	
	    var handlePopperUpdate = function handlePopperUpdate(data) {
	      setPlacement(data.placement);
	    };
	
	    var resolvedAnchorEl = getAnchorEl(anchorEl);
	
	    if (false) {
	      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
	        var box = resolvedAnchorEl.getBoundingClientRect();
	
	        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	          console.warn(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	        }
	      }
	    }
	
	    var popper = new _popper.default(getAnchorEl(anchorEl), tooltipRef.current, (0, _extends2.default)({
	      placement: rtlPlacement
	    }, popperOptions, {
	      modifiers: (0, _extends2.default)({}, disablePortal ? {} : {
	        // It's using scrollParent by default, we can use the viewport when using a portal.
	        preventOverflow: {
	          boundariesElement: 'window'
	        }
	      }, modifiers, popperOptions.modifiers),
	      // We could have been using a custom modifier like react-popper is doing.
	      // But it seems this is the best public API for this use case.
	      onCreate: (0, _createChainedFunction.default)(handlePopperUpdate, popperOptions.onCreate),
	      onUpdate: (0, _createChainedFunction.default)(handlePopperUpdate, popperOptions.onUpdate)
	    }));
	    handlePopperRefRef.current(popper);
	  }, [anchorEl, disablePortal, modifiers, open, rtlPlacement, popperOptions]);
	  var handleRef = React.useCallback(function (node) {
	    (0, _setRef.default)(ownRef, node);
	    handleOpen();
	  }, [ownRef, handleOpen]);
	
	  var handleEnter = function handleEnter() {
	    setExited(false);
	  };
	
	  var handleClose = function handleClose() {
	    if (!popperRef.current) {
	      return;
	    }
	
	    popperRef.current.destroy();
	    handlePopperRefRef.current(null);
	  };
	
	  var handleExited = function handleExited() {
	    setExited(true);
	    handleClose();
	  };
	
	  React.useEffect(function () {
	    return function () {
	      handleClose();
	    };
	  }, []);
	  React.useEffect(function () {
	    if (!open && !transition) {
	      // Otherwise handleExited will call this.
	      handleClose();
	    }
	  }, [open, transition]);
	
	  if (!keepMounted && !open && (!transition || exited)) {
	    return null;
	  }
	
	  var childProps = {
	    placement: placement
	  };
	
	  if (transition) {
	    childProps.TransitionProps = {
	      in: open,
	      onEnter: handleEnter,
	      onExited: handleExited
	    };
	  }
	
	  return /*#__PURE__*/React.createElement(_Portal.default, {
	    disablePortal: disablePortal,
	    container: container
	  }, /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    ref: handleRef,
	    role: "tooltip"
	  }, other, {
	    style: (0, _extends2.default)({
	      // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
	      position: 'fixed',
	      // Fix Popper.js display issue
	      top: 0,
	      left: 0,
	      display: !open && keepMounted && !transition ? 'none' : null
	    }, style)
	  }), typeof children === 'function' ? children(childProps) : children));
	});
	 false ? Popper.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A HTML element, [referenceObject](https://popper.js.org/docs/v1/#referenceObject),
	   * or a function that returns either.
	   * It's used to set the position of the popper.
	   * The return value will passed as the reference object of the Popper instance.
	   */
	  anchorEl: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_utils.HTMLElementType, _propTypes.default.object, _propTypes.default.func]), function (props) {
	    if (props.open) {
	      var resolvedAnchorEl = getAnchorEl(props.anchorEl);
	
	      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
	        var box = resolvedAnchorEl.getBoundingClientRect();
	
	        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	          return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	        }
	      } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.clientWidth !== 'number' || typeof resolvedAnchorEl.clientHeight !== 'number' || typeof resolvedAnchorEl.getBoundingClientRect !== 'function') {
	        return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'It should be an HTML element instance or a referenceObject ', '(https://popper.js.org/docs/v1/#referenceObject).'].join('\n'));
	      }
	    }
	
	    return null;
	  }),
	
	  /**
	   * Popper render function or node.
	   */
	  children: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_propTypes.default.node, _propTypes.default.func]).isRequired,
	
	  /**
	   * A HTML element, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   *
	   * By default, it uses the body of the top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_utils.HTMLElementType, _propTypes.default.instanceOf(React.Component), _propTypes.default.func]),
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * Always keep the children in the DOM.
	   * This prop can be useful in SEO situation or
	   * when you want to maximize the responsiveness of the Popper.
	   */
	  keepMounted: _propTypes.default.bool,
	
	  /**
	   * Popper.js is based on a "plugin-like" architecture,
	   * most of its features are fully encapsulated "modifiers".
	   *
	   * A modifier is a function that is called each time Popper.js needs to
	   * compute the position of the popper.
	   * For this reason, modifiers should be very performant to avoid bottlenecks.
	   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v1/#modifiers).
	   */
	  modifiers: _propTypes.default.object,
	
	  /**
	   * If `true`, the popper is visible.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * Popper placement.
	   */
	  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
	
	  /**
	   * Options provided to the [`popper.js`](https://popper.js.org/docs/v1/) instance.
	   */
	  popperOptions: _propTypes.default.object,
	
	  /**
	   * A ref that points to the used popper instance.
	   */
	  popperRef: _utils.refType,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * Help supporting a react-transition-group/Transition component.
	   */
	  transition: _propTypes.default.bool
	} : void 0;
	var _default = Popper;
	exports.default = _default;

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(45));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _utils = __webpack_require__(22);
	
	var _setRef = _interopRequireDefault(__webpack_require__(95));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	function getContainer(container) {
	  container = typeof container === 'function' ? container() : container; // #StrictMode ready
	
	  return ReactDOM.findDOMNode(container);
	}
	
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	/**
	 * Portals provide a first-class way to render children into a DOM node
	 * that exists outside the DOM hierarchy of the parent component.
	 */
	
	var Portal = /*#__PURE__*/React.forwardRef(function Portal(props, ref) {
	  var children = props.children,
	      container = props.container,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      onRendered = props.onRendered;
	
	  var _React$useState = React.useState(null),
	      mountNode = _React$useState[0],
	      setMountNode = _React$useState[1];
	
	  var handleRef = (0, _useForkRef.default)( /*#__PURE__*/React.isValidElement(children) ? children.ref : null, ref);
	  useEnhancedEffect(function () {
	    if (!disablePortal) {
	      setMountNode(getContainer(container) || document.body);
	    }
	  }, [container, disablePortal]);
	  useEnhancedEffect(function () {
	    if (mountNode && !disablePortal) {
	      (0, _setRef.default)(ref, mountNode);
	      return function () {
	        (0, _setRef.default)(ref, null);
	      };
	    }
	
	    return undefined;
	  }, [ref, mountNode, disablePortal]);
	  useEnhancedEffect(function () {
	    if (onRendered && (mountNode || disablePortal)) {
	      onRendered();
	    }
	  }, [onRendered, mountNode, disablePortal]);
	
	  if (disablePortal) {
	    if ( /*#__PURE__*/React.isValidElement(children)) {
	      return /*#__PURE__*/React.cloneElement(children, {
	        ref: handleRef
	      });
	    }
	
	    return children;
	  }
	
	  return mountNode ? /*#__PURE__*/ReactDOM.createPortal(children, mountNode) : mountNode;
	});
	 false ? Portal.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The children to render into the `container`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A HTML element, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   *
	   * By default, it uses the body of the top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_utils.HTMLElementType, _propTypes.default.instanceOf(React.Component), _propTypes.default.func]),
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   *
	   * This prop will be deprecated and removed in v5, the ref can be used instead.
	   */
	  onRendered: _propTypes.default.func
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  Portal['propTypes' + ''] = (0, _utils.exactProp)(Portal.propTypes);
	}
	
	var _default = Portal;
	exports.default = _default;

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _SwitchBase = _interopRequireDefault(__webpack_require__(238));
	
	var _RadioButtonIcon = _interopRequireDefault(__webpack_require__(935));
	
	var _colorManipulator = __webpack_require__(49);
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(111));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _useRadioGroup = _interopRequireDefault(__webpack_require__(369));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: theme.palette.text.secondary
	    },
	
	    /* Pseudo-class applied to the root element if `checked={true}`. */
	    checked: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      '&$checked': {
	        color: theme.palette.primary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      '&$checked': {
	        color: theme.palette.secondary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultCheckedIcon = /*#__PURE__*/React.createElement(_RadioButtonIcon.default, {
	  checked: true
	});
	var defaultIcon = /*#__PURE__*/React.createElement(_RadioButtonIcon.default, null);
	var Radio = /*#__PURE__*/React.forwardRef(function Radio(props, ref) {
	  var checkedProp = props.checked,
	      classes = props.classes,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'secondary' : _props$color,
	      nameProp = props.name,
	      onChangeProp = props.onChange,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      other = (0, _objectWithoutProperties2.default)(props, ["checked", "classes", "color", "name", "onChange", "size"]);
	  var radioGroup = (0, _useRadioGroup.default)();
	  var checked = checkedProp;
	  var onChange = (0, _createChainedFunction.default)(onChangeProp, radioGroup && radioGroup.onChange);
	  var name = nameProp;
	
	  if (radioGroup) {
	    if (typeof checked === 'undefined') {
	      checked = radioGroup.value === props.value;
	    }
	
	    if (typeof name === 'undefined') {
	      name = radioGroup.name;
	    }
	  }
	
	  return /*#__PURE__*/React.createElement(_SwitchBase.default, (0, _extends2.default)({
	    color: color,
	    type: "radio",
	    icon: /*#__PURE__*/React.cloneElement(defaultIcon, {
	      fontSize: size === 'small' ? 'small' : 'default'
	    }),
	    checkedIcon: /*#__PURE__*/React.cloneElement(defaultCheckedIcon, {
	      fontSize: size === 'small' ? 'small' : 'default'
	    }),
	    classes: {
	      root: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(color))]),
	      checked: classes.checked,
	      disabled: classes.disabled
	    },
	    name: name,
	    checked: checked,
	    onChange: onChange,
	    ref: ref
	  }, other));
	});
	 false ? Radio.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the radio will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The size of the radio.
	   * `small` is equivalent to the dense radio styling.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The value of the component. The DOM API casts this to a string.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiRadio'
	})(Radio);
	
	exports.default = _default;

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _RadioButtonUnchecked = _interopRequireDefault(__webpack_require__(1024));
	
	var _RadioButtonChecked = _interopRequireDefault(__webpack_require__(1023));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'relative',
	      display: 'flex',
	      '&$checked $layer': {
	        transform: 'scale(1)',
	        transition: theme.transitions.create('transform', {
	          easing: theme.transitions.easing.easeOut,
	          duration: theme.transitions.duration.shortest
	        })
	      }
	    },
	    layer: {
	      left: 0,
	      position: 'absolute',
	      transform: 'scale(0)',
	      transition: theme.transitions.create('transform', {
	        easing: theme.transitions.easing.easeIn,
	        duration: theme.transitions.duration.shortest
	      })
	    },
	    checked: {}
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	
	function RadioButtonIcon(props) {
	  var checked = props.checked,
	      classes = props.classes,
	      fontSize = props.fontSize;
	  return /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.root, checked && classes.checked)
	  }, /*#__PURE__*/React.createElement(_RadioButtonUnchecked.default, {
	    fontSize: fontSize
	  }), /*#__PURE__*/React.createElement(_RadioButtonChecked.default, {
	    fontSize: fontSize,
	    className: classes.layer
	  }));
	}
	
	 false ? RadioButtonIcon.propTypes = {
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The size of the radio.
	   * `small` is equivalent to the dense radio styling.
	   */
	  fontSize: _propTypes.default.oneOf(['small', 'default'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateRadioButtonIcon'
	})(RadioButtonIcon);
	
	exports.default = _default;

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Radio.default;
	  }
	});
	
	var _Radio = _interopRequireDefault(__webpack_require__(934));

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _FormGroup = _interopRequireDefault(__webpack_require__(352));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(85));
	
	var _RadioGroupContext = _interopRequireDefault(__webpack_require__(368));
	
	var _unstable_useId = _interopRequireDefault(__webpack_require__(169));
	
	var RadioGroup = /*#__PURE__*/React.forwardRef(function RadioGroup(props, ref) {
	  var actions = props.actions,
	      children = props.children,
	      nameProp = props.name,
	      valueProp = props.value,
	      onChange = props.onChange,
	      other = (0, _objectWithoutProperties2.default)(props, ["actions", "children", "name", "value", "onChange"]);
	  var rootRef = React.useRef(null);
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: valueProp,
	    default: props.defaultValue,
	    name: 'RadioGroup'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      value = _useControlled2[0],
	      setValue = _useControlled2[1];
	
	  React.useImperativeHandle(actions, function () {
	    return {
	      focus: function focus() {
	        var input = rootRef.current.querySelector('input:not(:disabled):checked');
	
	        if (!input) {
	          input = rootRef.current.querySelector('input:not(:disabled)');
	        }
	
	        if (input) {
	          input.focus();
	        }
	      }
	    };
	  }, []);
	  var handleRef = (0, _useForkRef.default)(ref, rootRef);
	
	  var handleChange = function handleChange(event) {
	    setValue(event.target.value);
	
	    if (onChange) {
	      onChange(event, event.target.value);
	    }
	  };
	
	  var name = (0, _unstable_useId.default)(nameProp);
	  return /*#__PURE__*/React.createElement(_RadioGroupContext.default.Provider, {
	    value: {
	      name: name,
	      onChange: handleChange,
	      value: value
	    }
	  }, /*#__PURE__*/React.createElement(_FormGroup.default, (0, _extends2.default)({
	    role: "radiogroup",
	    ref: handleRef
	  }, other), children));
	});
	 false ? RadioGroup.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The name used to reference the value of the control.
	   * If you don't provide this prop, it falls back to a randomly generated name.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when a radio button is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Value of the selected radio button. The DOM API casts this to a string.
	   */
	  value: _propTypes.default.any
	} : void 0;
	var _default = RadioGroup;
	exports.default = _default;

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _RadioGroup.default;
	  }
	});
	Object.defineProperty(exports, "useRadioGroup", {
	  enumerable: true,
	  get: function get() {
	    return _useRadioGroup.default;
	  }
	});
	
	var _RadioGroup = _interopRequireDefault(__webpack_require__(937));
	
	var _useRadioGroup = _interopRequireDefault(__webpack_require__(369));

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(26));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(45));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _utils = __webpack_require__(22);
	
	var _setRef = _interopRequireDefault(__webpack_require__(95));
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	/**
	 * ⚠️⚠️⚠️
	 * If you want the DOM element of a Material-UI component check out
	 * [FAQ: How can I access the DOM element?](/getting-started/faq/#how-can-i-access-the-dom-element)
	 * first.
	 *
	 * This component uses `findDOMNode` which is deprecated in React.StrictMode.
	 *
	 * Helper component to allow attaching a ref to a
	 * wrapped element to access the underlying DOM element.
	 *
	 * It's highly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801.
	 * For example:
	 * ```jsx
	 * import React from 'react';
	 * import RootRef from '@material-ui/core/RootRef';
	 *
	 * function MyComponent() {
	 *   const domRef = React.useRef();
	 *
	 *   React.useEffect(() => {
	 *     console.log(domRef.current); // DOM node
	 *   }, []);
	 *
	 *   return (
	 *     <RootRef rootRef={domRef}>
	 *       <SomeChildComponent />
	 *     </RootRef>
	 *   );
	 * }
	 * ```
	 */
	var RootRef = /*#__PURE__*/function (_React$Component) {
	  (0, _inherits2.default)(RootRef, _React$Component);
	
	  var _super = _createSuper(RootRef);
	
	  function RootRef() {
	    (0, _classCallCheck2.default)(this, RootRef);
	    return _super.apply(this, arguments);
	  }
	
	  (0, _createClass2.default)(RootRef, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.ref = ReactDOM.findDOMNode(this);
	      (0, _setRef.default)(this.props.rootRef, this.ref);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var ref = ReactDOM.findDOMNode(this);
	
	      if (prevProps.rootRef !== this.props.rootRef || this.ref !== ref) {
	        if (prevProps.rootRef !== this.props.rootRef) {
	          (0, _setRef.default)(prevProps.rootRef, null);
	        }
	
	        this.ref = ref;
	        (0, _setRef.default)(this.props.rootRef, this.ref);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.ref = null;
	      (0, _setRef.default)(this.props.rootRef, null);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return RootRef;
	}(React.Component);
	
	 false ? RootRef.propTypes = {
	  /**
	   * The wrapped element.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * A ref that points to the first DOM node of the wrapped element.
	   */
	  rootRef: _utils.refType.isRequired
	} : void 0;
	
	if (false) {
	  process.env.NODE_ENV !== "production" ? RootRef.propTypes = (0, _utils.exactProp)(RootRef.propTypes) : void 0;
	}
	
	var _default = RootRef;
	exports.default = _default;

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _RootRef.default;
	  }
	});
	
	var _RootRef = _interopRequireDefault(__webpack_require__(939));

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _styles = __webpack_require__(60);
	
	var _SelectInput = _interopRequireDefault(__webpack_require__(942));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(109));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(93));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _ArrowDropDown = _interopRequireDefault(__webpack_require__(389));
	
	var _Input = _interopRequireDefault(__webpack_require__(164));
	
	var _NativeSelect = __webpack_require__(363);
	
	var _NativeSelectInput = _interopRequireDefault(__webpack_require__(364));
	
	var _FilledInput = _interopRequireDefault(__webpack_require__(232));
	
	var _OutlinedInput = _interopRequireDefault(__webpack_require__(235));
	
	var styles = _NativeSelect.styles;
	exports.styles = styles;
	
	var _ref = /*#__PURE__*/React.createElement(_Input.default, null);
	
	var _ref2 = /*#__PURE__*/React.createElement(_FilledInput.default, null);
	
	var Select = /*#__PURE__*/React.forwardRef(function Select(props, ref) {
	  var _props$autoWidth = props.autoWidth,
	      autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth,
	      children = props.children,
	      classes = props.classes,
	      _props$displayEmpty = props.displayEmpty,
	      displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty,
	      _props$IconComponent = props.IconComponent,
	      IconComponent = _props$IconComponent === void 0 ? _ArrowDropDown.default : _props$IconComponent,
	      id = props.id,
	      input = props.input,
	      inputProps = props.inputProps,
	      label = props.label,
	      labelId = props.labelId,
	      _props$labelWidth = props.labelWidth,
	      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
	      MenuProps = props.MenuProps,
	      _props$multiple = props.multiple,
	      multiple = _props$multiple === void 0 ? false : _props$multiple,
	      _props$native = props.native,
	      native = _props$native === void 0 ? false : _props$native,
	      onClose = props.onClose,
	      onOpen = props.onOpen,
	      open = props.open,
	      renderValue = props.renderValue,
	      SelectDisplayProps = props.SelectDisplayProps,
	      _props$variant = props.variant,
	      variantProps = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "labelWidth", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]);
	  var inputComponent = native ? _NativeSelectInput.default : _SelectInput.default;
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['variant']
	  });
	  var variant = fcs.variant || variantProps;
	  var InputComponent = input || {
	    standard: _ref,
	    outlined: /*#__PURE__*/React.createElement(_OutlinedInput.default, {
	      label: label,
	      labelWidth: labelWidth
	    }),
	    filled: _ref2
	  }[variant];
	  return /*#__PURE__*/React.cloneElement(InputComponent, (0, _extends2.default)({
	    // Most of the logic is implemented in `SelectInput`.
	    // The `Select` component is a simple API wrapper to expose something better to play with.
	    inputComponent: inputComponent,
	    inputProps: (0, _extends2.default)({
	      children: children,
	      IconComponent: IconComponent,
	      variant: variant,
	      type: undefined,
	      // We render a select. We can ignore the type provided by the `Input`.
	      multiple: multiple
	    }, native ? {
	      id: id
	    } : {
	      autoWidth: autoWidth,
	      displayEmpty: displayEmpty,
	      labelId: labelId,
	      MenuProps: MenuProps,
	      onClose: onClose,
	      onOpen: onOpen,
	      open: open,
	      renderValue: renderValue,
	      SelectDisplayProps: (0, _extends2.default)({
	        id: id
	      }, SelectDisplayProps)
	    }, inputProps, {
	      classes: inputProps ? (0, _styles.mergeClasses)({
	        baseClasses: classes,
	        newClasses: inputProps.classes,
	        Component: Select
	      }) : classes
	    }, input ? input.props.inputProps : {}),
	    ref: ref
	  }, other));
	});
	 false ? Select.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the width of the popover will automatically be set according to the items inside the
	   * menu, otherwise it will be at least the width of the select input.
	   */
	  autoWidth: _propTypes.default.bool,
	
	  /**
	   * The option elements to populate the select with.
	   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
	   *
	   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The default element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, a value is displayed even if no items are selected.
	   *
	   * In order to display a meaningful value, a function should be passed to the `renderValue` prop which returns the value to be displayed when no items are selected.
	   * You can only use it when the `native` prop is `false` (default).
	   */
	  displayEmpty: _propTypes.default.bool,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType,
	
	  /**
	   * The `id` of the wrapper element or the `select` element when `native`.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * An `Input` element; does not have to be a material-ui specific `Input`.
	   */
	  input: _propTypes.default.element,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   * When `native` is `true`, the attributes are applied on the `select` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * See [OutlinedInput#label](/api/outlined-input/#props)
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The ID of an element that acts as an additional label. The Select will
	   * be labelled by the additional label and the selected value.
	   */
	  labelId: _propTypes.default.string,
	
	  /**
	   * See [OutlinedInput#label](/api/outlined-input/#props)
	   */
	  labelWidth: _propTypes.default.number,
	
	  /**
	   * Props applied to the [`Menu`](/api/menu/) element.
	   */
	  MenuProps: _propTypes.default.object,
	
	  /**
	   * If `true`, `value` must be an array and the menu will support multiple selections.
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will be using a native `select` element.
	   */
	  native: _propTypes.default.bool,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (any).
	   * @param {object} [child] The react element that was selected when `native` is `false` (default).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be opened.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * Control `select` open state.
	   * You can only use it when the `native` prop is `false` (default).
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Render the selected value.
	   * You can only use it when the `native` prop is `false` (default).
	   *
	   * @param {any} value The `value` provided to the component.
	   * @returns {ReactNode}
	   */
	  renderValue: _propTypes.default.func,
	
	  /**
	   * Props applied to the clickable div element.
	   */
	  SelectDisplayProps: _propTypes.default.object,
	
	  /**
	   * The input value. Providing an empty string will select no options.
	   * This prop is required when the `native` prop is `false` (default).
	   * Set to an empty string `''` if you don't want any of the available options to be selected.
	   *
	   * If the value is an object it must have reference equality with the option in order to be selected.
	   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	Select.muiName = 'Select';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSelect'
	})(Select);
	
	exports.default = _default;

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(55));
	
	var _utils = __webpack_require__(22);
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(67);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(68));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _Menu = _interopRequireDefault(__webpack_require__(359));
	
	var _utils2 = __webpack_require__(234);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(85));
	
	function areEqualValues(a, b) {
	  if ((0, _typeof2.default)(b) === 'object' && b !== null) {
	    return a === b;
	  }
	
	  return String(a) === String(b);
	}
	
	function isEmpty(display) {
	  return display == null || typeof display === 'string' && !display.trim();
	}
	/**
	 * @ignore - internal component.
	 */
	
	
	var SelectInput = /*#__PURE__*/React.forwardRef(function SelectInput(props, ref) {
	  var ariaLabel = props['aria-label'],
	      autoFocus = props.autoFocus,
	      autoWidth = props.autoWidth,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      defaultValue = props.defaultValue,
	      disabled = props.disabled,
	      displayEmpty = props.displayEmpty,
	      IconComponent = props.IconComponent,
	      inputRefProp = props.inputRef,
	      labelId = props.labelId,
	      _props$MenuProps = props.MenuProps,
	      MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps,
	      multiple = props.multiple,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onClose = props.onClose,
	      onFocus = props.onFocus,
	      onOpen = props.onOpen,
	      openProp = props.open,
	      readOnly = props.readOnly,
	      renderValue = props.renderValue,
	      _props$SelectDisplayP = props.SelectDisplayProps,
	      SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP,
	      tabIndexProp = props.tabIndex,
	      type = props.type,
	      valueProp = props.value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["aria-label", "autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: valueProp,
	    default: defaultValue,
	    name: 'Select'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      value = _useControlled2[0],
	      setValue = _useControlled2[1];
	
	  var inputRef = React.useRef(null);
	
	  var _React$useState = React.useState(null),
	      displayNode = _React$useState[0],
	      setDisplayNode = _React$useState[1];
	
	  var _React$useRef = React.useRef(openProp != null),
	      isOpenControlled = _React$useRef.current;
	
	  var _React$useState2 = React.useState(),
	      menuMinWidthState = _React$useState2[0],
	      setMenuMinWidthState = _React$useState2[1];
	
	  var _React$useState3 = React.useState(false),
	      openState = _React$useState3[0],
	      setOpenState = _React$useState3[1];
	
	  var handleRef = (0, _useForkRef.default)(ref, inputRefProp);
	  React.useImperativeHandle(handleRef, function () {
	    return {
	      focus: function focus() {
	        displayNode.focus();
	      },
	      node: inputRef.current,
	      value: value
	    };
	  }, [displayNode, value]);
	  React.useEffect(function () {
	    if (autoFocus && displayNode) {
	      displayNode.focus();
	    }
	  }, [autoFocus, displayNode]);
	  React.useEffect(function () {
	    if (displayNode) {
	      var label = (0, _ownerDocument.default)(displayNode).getElementById(labelId);
	
	      if (label) {
	        var handler = function handler() {
	          if (getSelection().isCollapsed) {
	            displayNode.focus();
	          }
	        };
	
	        label.addEventListener('click', handler);
	        return function () {
	          label.removeEventListener('click', handler);
	        };
	      }
	    }
	
	    return undefined;
	  }, [labelId, displayNode]);
	
	  var update = function update(open, event) {
	    if (open) {
	      if (onOpen) {
	        onOpen(event);
	      }
	    } else if (onClose) {
	      onClose(event);
	    }
	
	    if (!isOpenControlled) {
	      setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
	      setOpenState(open);
	    }
	  };
	
	  var handleMouseDown = function handleMouseDown(event) {
	    // Ignore everything but left-click
	    if (event.button !== 0) {
	      return;
	    } // Hijack the default focus behavior.
	
	
	    event.preventDefault();
	    displayNode.focus();
	    update(true, event);
	  };
	
	  var handleClose = function handleClose(event) {
	    update(false, event);
	  };
	
	  var childrenArray = React.Children.toArray(children); // Support autofill.
	
	  var handleChange = function handleChange(event) {
	    var index = childrenArray.map(function (child) {
	      return child.props.value;
	    }).indexOf(event.target.value);
	
	    if (index === -1) {
	      return;
	    }
	
	    var child = childrenArray[index];
	    setValue(child.props.value);
	
	    if (onChange) {
	      onChange(event, child);
	    }
	  };
	
	  var handleItemClick = function handleItemClick(child) {
	    return function (event) {
	      if (!multiple) {
	        update(false, event);
	      }
	
	      var newValue;
	
	      if (multiple) {
	        newValue = Array.isArray(value) ? value.slice() : [];
	        var itemIndex = value.indexOf(child.props.value);
	
	        if (itemIndex === -1) {
	          newValue.push(child.props.value);
	        } else {
	          newValue.splice(itemIndex, 1);
	        }
	      } else {
	        newValue = child.props.value;
	      }
	
	      if (child.props.onClick) {
	        child.props.onClick(event);
	      }
	
	      if (value === newValue) {
	        return;
	      }
	
	      setValue(newValue);
	
	      if (onChange) {
	        event.persist(); // Preact support, target is read only property on a native event.
	
	        Object.defineProperty(event, 'target', {
	          writable: true,
	          value: {
	            value: newValue,
	            name: name
	          }
	        });
	        onChange(event, child);
	      }
	    };
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    if (!readOnly) {
	      var validKeys = [' ', 'ArrowUp', 'ArrowDown', // The native select doesn't respond to enter on MacOS, but it's recommended by
	      // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
	      'Enter'];
	
	      if (validKeys.indexOf(event.key) !== -1) {
	        event.preventDefault();
	        update(true, event);
	      }
	    }
	  };
	
	  var open = displayNode !== null && (isOpenControlled ? openProp : openState);
	
	  var handleBlur = function handleBlur(event) {
	    // if open event.stopImmediatePropagation
	    if (!open && onBlur) {
	      event.persist(); // Preact support, target is read only property on a native event.
	
	      Object.defineProperty(event, 'target', {
	        writable: true,
	        value: {
	          value: value,
	          name: name
	        }
	      });
	      onBlur(event);
	    }
	  };
	
	  delete other['aria-invalid'];
	  var display;
	  var displaySingle;
	  var displayMultiple = [];
	  var computeDisplay = false;
	  var foundMatch = false; // No need to display any value if the field is empty.
	
	  if ((0, _utils2.isFilled)({
	    value: value
	  }) || displayEmpty) {
	    if (renderValue) {
	      display = renderValue(value);
	    } else {
	      computeDisplay = true;
	    }
	  }
	
	  var items = childrenArray.map(function (child) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var selected;
	
	    if (multiple) {
	      if (!Array.isArray(value)) {
	        throw new Error( false ? "Material-UI: The `value` prop must be an array when using the `Select` component with `multiple`." : (0, _utils.formatMuiErrorMessage)(2));
	      }
	
	      selected = value.some(function (v) {
	        return areEqualValues(v, child.props.value);
	      });
	
	      if (selected && computeDisplay) {
	        displayMultiple.push(child.props.children);
	      }
	    } else {
	      selected = areEqualValues(value, child.props.value);
	
	      if (selected && computeDisplay) {
	        displaySingle = child.props.children;
	      }
	    }
	
	    if (selected) {
	      foundMatch = true;
	    }
	
	    return /*#__PURE__*/React.cloneElement(child, {
	      'aria-selected': selected ? 'true' : undefined,
	      onClick: handleItemClick(child),
	      onKeyUp: function onKeyUp(event) {
	        if (event.key === ' ') {
	          // otherwise our MenuItems dispatches a click event
	          // it's not behavior of the native <option> and causes
	          // the select to close immediately since we open on space keydown
	          event.preventDefault();
	        }
	
	        if (child.props.onKeyUp) {
	          child.props.onKeyUp(event);
	        }
	      },
	      role: 'option',
	      selected: selected,
	      value: undefined,
	      // The value is most likely not a valid HTML attribute.
	      'data-value': child.props.value // Instead, we provide it as a data attribute.
	
	    });
	  });
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useEffect(function () {
	      if (!foundMatch && !multiple && value !== '') {
	        var values = childrenArray.map(function (child) {
	          return child.props.value;
	        });
	        console.warn(["Material-UI: You have provided an out-of-range value `".concat(value, "` for the select ").concat(name ? "(name=\"".concat(name, "\") ") : '', "component."), "Consider providing a value that matches one of the available options or ''.", "The available values are ".concat(values.filter(function (x) {
	          return x != null;
	        }).map(function (x) {
	          return "`".concat(x, "`");
	        }).join(', ') || '""', ".")].join('\n'));
	      }
	    }, [foundMatch, childrenArray, multiple, name, value]);
	  }
	
	  if (computeDisplay) {
	    display = multiple ? displayMultiple.join(', ') : displaySingle;
	  } // Avoid performing a layout computation in the render method.
	
	
	  var menuMinWidth = menuMinWidthState;
	
	  if (!autoWidth && isOpenControlled && displayNode) {
	    menuMinWidth = displayNode.clientWidth;
	  }
	
	  var tabIndex;
	
	  if (typeof tabIndexProp !== 'undefined') {
	    tabIndex = tabIndexProp;
	  } else {
	    tabIndex = disabled ? null : 0;
	  }
	
	  var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, // TODO v5: merge root and select
	    classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
	    ref: setDisplayNode,
	    tabIndex: tabIndex,
	    role: "button",
	    "aria-disabled": disabled ? 'true' : undefined,
	    "aria-expanded": open ? 'true' : undefined,
	    "aria-haspopup": "listbox",
	    "aria-label": ariaLabel,
	    "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
	    onKeyDown: handleKeyDown,
	    onMouseDown: disabled || readOnly ? null : handleMouseDown,
	    onBlur: handleBlur,
	    onFocus: onFocus
	  }, SelectDisplayProps, {
	    // The id is required for proper a11y
	    id: buttonId
	  }), isEmpty(display) ?
	  /*#__PURE__*/
	  // eslint-disable-next-line react/no-danger
	  React.createElement("span", {
	    dangerouslySetInnerHTML: {
	      __html: '&#8203;'
	    }
	  }) : display), /*#__PURE__*/React.createElement("input", (0, _extends2.default)({
	    value: Array.isArray(value) ? value.join(',') : value,
	    name: name,
	    ref: inputRef,
	    "aria-hidden": true,
	    onChange: handleChange,
	    tabIndex: -1,
	    className: classes.nativeInput,
	    autoFocus: autoFocus
	  }, other)), /*#__PURE__*/React.createElement(IconComponent, {
	    className: (0, _clsx.default)(classes.icon, classes["icon".concat((0, _capitalize.default)(variant))], open && classes.iconOpen, disabled && classes.disabled)
	  }), /*#__PURE__*/React.createElement(_Menu.default, (0, _extends2.default)({
	    id: "menu-".concat(name || ''),
	    anchorEl: displayNode,
	    open: open,
	    onClose: handleClose
	  }, MenuProps, {
	    MenuListProps: (0, _extends2.default)({
	      'aria-labelledby': labelId,
	      role: 'listbox',
	      disableListWrap: true
	    }, MenuProps.MenuListProps),
	    PaperProps: (0, _extends2.default)({}, MenuProps.PaperProps, {
	      style: (0, _extends2.default)({
	        minWidth: menuMinWidth
	      }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
	    })
	  }), items));
	});
	 false ? SelectInput.propTypes = {
	  /**
	   * @ignore
	   */
	  'aria-label': _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the width of the popover will automatically be set according to the items inside the
	   * menu, otherwise it will be at least the width of the select input.
	   */
	  autoWidth: _propTypes.default.bool,
	
	  /**
	   * The option elements to populate the select with.
	   * Can be some `<MenuItem>` elements.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The CSS class name of the select element.
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The default element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the select will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the selected item is displayed even if its value is empty.
	   */
	  displayEmpty: _propTypes.default.bool,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType.isRequired,
	
	  /**
	   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
	   * Equivalent to `ref`
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The ID of an element that acts as an additional label. The Select will
	   * be labelled by the additional label and the selected value.
	   */
	  labelId: _propTypes.default.string,
	
	  /**
	   * Props applied to the [`Menu`](/api/menu/) element.
	   */
	  MenuProps: _propTypes.default.object,
	
	  /**
	   * If `true`, `value` must be an array and the menu will support multiple selections.
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `select` or hidden `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (any).
	   * @param {object} [child] The react element that was selected.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be opened.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * Control `select` open state.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * Render the selected value.
	   *
	   * @param {any} value The `value` provided to the component.
	   * @returns {ReactNode}
	   */
	  renderValue: _propTypes.default.func,
	
	  /**
	   * Props applied to the clickable div element.
	   */
	  SelectDisplayProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  type: _propTypes.default.any,
	
	  /**
	   * The input value.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	var _default = SelectInput;
	exports.default = _default;

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setTranslateValue = setTranslateValue;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(45));
	
	var _debounce = _interopRequireDefault(__webpack_require__(94));
	
	var _reactTransitionGroup = __webpack_require__(123);
	
	var _utils = __webpack_require__(22);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(47));
	
	var _transitions = __webpack_require__(74);
	
	var _utils2 = __webpack_require__(110);
	
	// Translate the node so he can't be seen on the screen.
	// Later, we gonna translate back the node to his original location
	// with `none`.`
	function getTranslateValue(direction, node) {
	  var rect = node.getBoundingClientRect();
	  var transform;
	
	  if (node.fakeTransform) {
	    transform = node.fakeTransform;
	  } else {
	    var computedStyle = window.getComputedStyle(node);
	    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
	  }
	
	  var offsetX = 0;
	  var offsetY = 0;
	
	  if (transform && transform !== 'none' && typeof transform === 'string') {
	    var transformValues = transform.split('(')[1].split(')')[0].split(',');
	    offsetX = parseInt(transformValues[4], 10);
	    offsetY = parseInt(transformValues[5], 10);
	  }
	
	  if (direction === 'left') {
	    return "translateX(".concat(window.innerWidth, "px) translateX(").concat(offsetX - rect.left, "px)");
	  }
	
	  if (direction === 'right') {
	    return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
	  }
	
	  if (direction === 'up') {
	    return "translateY(".concat(window.innerHeight, "px) translateY(").concat(offsetY - rect.top, "px)");
	  } // direction === 'down'
	
	
	  return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
	}
	
	function setTranslateValue(direction, node) {
	  var transform = getTranslateValue(direction, node);
	
	  if (transform) {
	    node.style.webkitTransform = transform;
	    node.style.transform = transform;
	  }
	}
	
	var defaultTimeout = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The Slide transition is used by the [Drawer](/components/drawers/) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Slide = /*#__PURE__*/React.forwardRef(function Slide(props, ref) {
	  var children = props.children,
	      _props$direction = props.direction,
	      direction = _props$direction === void 0 ? 'down' : _props$direction,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _reactTransitionGroup.Transition : _props$TransitionComp,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "direction", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);
	  var theme = (0, _useTheme.default)();
	  var childrenRef = React.useRef(null);
	  /**
	   * used in cloneElement(children, { ref: handleRef })
	   */
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    childrenRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRefIntermediary = (0, _useForkRef.default)(children.ref, handleOwnRef);
	  var handleRef = (0, _useForkRef.default)(handleRefIntermediary, ref);
	
	  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
	    return function (isAppearing) {
	      if (callback) {
	        // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
	        if (isAppearing === undefined) {
	          callback(childrenRef.current);
	        } else {
	          callback(childrenRef.current, isAppearing);
	        }
	      }
	    };
	  };
	
	  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
	    setTranslateValue(direction, node);
	    (0, _utils2.reflow)(node);
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  });
	  var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
	    var transitionProps = (0, _utils2.getTransitionProps)({
	      timeout: timeout,
	      style: style
	    }, {
	      mode: 'enter'
	    });
	    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.easeOut
	    }));
	    node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.easeOut
	    }));
	    node.style.webkitTransform = 'none';
	    node.style.transform = 'none';
	
	    if (onEntering) {
	      onEntering(node, isAppearing);
	    }
	  });
	  var handleEntered = normalizedTransitionCallback(onEntered);
	  var handleExiting = normalizedTransitionCallback(onExiting);
	  var handleExit = normalizedTransitionCallback(function (node) {
	    var transitionProps = (0, _utils2.getTransitionProps)({
	      timeout: timeout,
	      style: style
	    }, {
	      mode: 'exit'
	    });
	    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.sharp
	    }));
	    node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.sharp
	    }));
	    setTranslateValue(direction, node);
	
	    if (onExit) {
	      onExit(node);
	    }
	  });
	  var handleExited = normalizedTransitionCallback(function (node) {
	    // No need for transitions when the component is hidden
	    node.style.webkitTransition = '';
	    node.style.transition = '';
	
	    if (onExited) {
	      onExited(node);
	    }
	  });
	  var updatePosition = React.useCallback(function () {
	    if (childrenRef.current) {
	      setTranslateValue(direction, childrenRef.current);
	    }
	  }, [direction]);
	  React.useEffect(function () {
	    // Skip configuration where the position is screen size invariant.
	    if (inProp || direction === 'down' || direction === 'right') {
	      return undefined;
	    }
	
	    var handleResize = (0, _debounce.default)(function () {
	      if (childrenRef.current) {
	        setTranslateValue(direction, childrenRef.current);
	      }
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [direction, inProp]);
	  React.useEffect(function () {
	    if (!inProp) {
	      // We need to update the position of the drawer when the direction change and
	      // when it's hidden.
	      updatePosition();
	    }
	  }, [inProp, updatePosition]);
	  return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    nodeRef: childrenRef,
	    onEnter: handleEnter,
	    onEntered: handleEntered,
	    onEntering: handleEntering,
	    onExit: handleExit,
	    onExited: handleExited,
	    onExiting: handleExiting,
	    appear: true,
	    in: inProp,
	    timeout: timeout
	  }, other), function (state, childProps) {
	    return /*#__PURE__*/React.cloneElement(children, (0, _extends2.default)({
	      ref: handleRef,
	      style: (0, _extends2.default)({
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, style, children.props.style)
	    }, childProps));
	  });
	});
	 false ? Slide.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A single child content element.
	   */
	  children: _utils.elementAcceptingRef,
	
	  /**
	   * Direction the child node will enter from.
	   */
	  direction: _propTypes.default.oneOf(['down', 'left', 'right', 'up']),
	
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	var _default = Slide;
	exports.default = _default;

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(46));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(47));
	
	var _colorManipulator = __webpack_require__(49);
	
	var _useIsFocusVisible2 = _interopRequireDefault(__webpack_require__(131));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(68));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(79));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(85));
	
	var _ValueLabel = _interopRequireDefault(__webpack_require__(945));
	
	function asc(a, b) {
	  return a - b;
	}
	
	function clamp(value, min, max) {
	  return Math.min(Math.max(min, value), max);
	}
	
	function findClosest(values, currentValue) {
	  var _values$reduce = values.reduce(function (acc, value, index) {
	    var distance = Math.abs(currentValue - value);
	
	    if (acc === null || distance < acc.distance || distance === acc.distance) {
	      return {
	        distance: distance,
	        index: index
	      };
	    }
	
	    return acc;
	  }, null),
	      closestIndex = _values$reduce.index;
	
	  return closestIndex;
	}
	
	function trackFinger(event, touchId) {
	  if (touchId.current !== undefined && event.changedTouches) {
	    for (var i = 0; i < event.changedTouches.length; i += 1) {
	      var touch = event.changedTouches[i];
	
	      if (touch.identifier === touchId.current) {
	        return {
	          x: touch.clientX,
	          y: touch.clientY
	        };
	      }
	    }
	
	    return false;
	  }
	
	  return {
	    x: event.clientX,
	    y: event.clientY
	  };
	}
	
	function valueToPercent(value, min, max) {
	  return (value - min) * 100 / (max - min);
	}
	
	function percentToValue(percent, min, max) {
	  return (max - min) * percent + min;
	}
	
	function getDecimalPrecision(num) {
	  // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
	  // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
	  if (Math.abs(num) < 1) {
	    var parts = num.toExponential().split('e-');
	    var matissaDecimalPart = parts[0].split('.')[1];
	    return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
	  }
	
	  var decimalPart = num.toString().split('.')[1];
	  return decimalPart ? decimalPart.length : 0;
	}
	
	function roundValueToStep(value, step, min) {
	  var nearest = Math.round((value - min) / step) * step + min;
	  return Number(nearest.toFixed(getDecimalPrecision(step)));
	}
	
	function setValueIndex(_ref) {
	  var values = _ref.values,
	      source = _ref.source,
	      newValue = _ref.newValue,
	      index = _ref.index;
	
	  // Performance shortcut
	  if (values[index] === newValue) {
	    return source;
	  }
	
	  var output = values.slice();
	  output[index] = newValue;
	  return output;
	}
	
	function focusThumb(_ref2) {
	  var sliderRef = _ref2.sliderRef,
	      activeIndex = _ref2.activeIndex,
	      setActive = _ref2.setActive;
	
	  if (!sliderRef.current.contains(document.activeElement) || Number(document.activeElement.getAttribute('data-index')) !== activeIndex) {
	    sliderRef.current.querySelector("[role=\"slider\"][data-index=\"".concat(activeIndex, "\"]")).focus();
	  }
	
	  if (setActive) {
	    setActive(activeIndex);
	  }
	}
	
	var axisProps = {
	  horizontal: {
	    offset: function offset(percent) {
	      return {
	        left: "".concat(percent, "%")
	      };
	    },
	    leap: function leap(percent) {
	      return {
	        width: "".concat(percent, "%")
	      };
	    }
	  },
	  'horizontal-reverse': {
	    offset: function offset(percent) {
	      return {
	        right: "".concat(percent, "%")
	      };
	    },
	    leap: function leap(percent) {
	      return {
	        width: "".concat(percent, "%")
	      };
	    }
	  },
	  vertical: {
	    offset: function offset(percent) {
	      return {
	        bottom: "".concat(percent, "%")
	      };
	    },
	    leap: function leap(percent) {
	      return {
	        height: "".concat(percent, "%")
	      };
	    }
	  }
	};
	
	var Identity = function Identity(x) {
	  return x;
	};
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      height: 2,
	      width: '100%',
	      boxSizing: 'content-box',
	      padding: '13px 0',
	      display: 'inline-block',
	      position: 'relative',
	      cursor: 'pointer',
	      touchAction: 'none',
	      color: theme.palette.primary.main,
	      WebkitTapHighlightColor: 'transparent',
	      '&$disabled': {
	        pointerEvents: 'none',
	        cursor: 'default',
	        color: theme.palette.grey[400]
	      },
	      '&$vertical': {
	        width: 2,
	        height: '100%',
	        padding: '0 13px'
	      },
	      // The primary input mechanism of the device includes a pointing device of limited accuracy.
	      '@media (pointer: coarse)': {
	        // Reach 42px touch target, about ~8mm on screen.
	        padding: '20px 0',
	        '&$vertical': {
	          padding: '0 20px'
	        }
	      },
	      '@media print': {
	        colorAdjust: 'exact'
	      }
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {// TODO v5: move the style here
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `marks` is provided with at least one label. */
	    marked: {
	      marginBottom: 20,
	      '&$vertical': {
	        marginBottom: 'auto',
	        marginRight: 20
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `orientation="vertical"`. */
	    vertical: {},
	
	    /* Pseudo-class applied to the root and thumb element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the rail element. */
	    rail: {
	      display: 'block',
	      position: 'absolute',
	      width: '100%',
	      height: 2,
	      borderRadius: 1,
	      backgroundColor: 'currentColor',
	      opacity: 0.38,
	      '$vertical &': {
	        height: '100%',
	        width: 2
	      }
	    },
	
	    /* Styles applied to the track element. */
	    track: {
	      display: 'block',
	      position: 'absolute',
	      height: 2,
	      borderRadius: 1,
	      backgroundColor: 'currentColor',
	      '$vertical &': {
	        width: 2
	      }
	    },
	
	    /* Styles applied to the track element if `track={false}`. */
	    trackFalse: {
	      '& $track': {
	        display: 'none'
	      }
	    },
	
	    /* Styles applied to the track element if `track="inverted"`. */
	    trackInverted: {
	      '& $track': {
	        backgroundColor: // Same logic as the LinearProgress track color
	        theme.palette.type === 'light' ? (0, _colorManipulator.lighten)(theme.palette.primary.main, 0.62) : (0, _colorManipulator.darken)(theme.palette.primary.main, 0.5)
	      },
	      '& $rail': {
	        opacity: 1
	      }
	    },
	
	    /* Styles applied to the thumb element. */
	    thumb: {
	      position: 'absolute',
	      width: 12,
	      height: 12,
	      marginLeft: -6,
	      marginTop: -5,
	      boxSizing: 'border-box',
	      borderRadius: '50%',
	      outline: 0,
	      backgroundColor: 'currentColor',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      transition: theme.transitions.create(['box-shadow'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&::after': {
	        position: 'absolute',
	        content: '""',
	        borderRadius: '50%',
	        // reach 42px hit target (2 * 15 + thumb diameter)
	        left: -15,
	        top: -15,
	        right: -15,
	        bottom: -15
	      },
	      '&$focusVisible,&:hover': {
	        boxShadow: "0px 0px 0px 8px ".concat((0, _colorManipulator.fade)(theme.palette.primary.main, 0.16)),
	        '@media (hover: none)': {
	          boxShadow: 'none'
	        }
	      },
	      '&$active': {
	        boxShadow: "0px 0px 0px 14px ".concat((0, _colorManipulator.fade)(theme.palette.primary.main, 0.16))
	      },
	      '&$disabled': {
	        width: 8,
	        height: 8,
	        marginLeft: -4,
	        marginTop: -3,
	        '&:hover': {
	          boxShadow: 'none'
	        }
	      },
	      '$vertical &': {
	        marginLeft: -5,
	        marginBottom: -6
	      },
	      '$vertical &$disabled': {
	        marginLeft: -3,
	        marginBottom: -4
	      }
	    },
	
	    /* Styles applied to the thumb element if `color="primary"`. */
	    thumbColorPrimary: {// TODO v5: move the style here
	    },
	
	    /* Styles applied to the thumb element if `color="secondary"`. */
	    thumbColorSecondary: {
	      '&$focusVisible,&:hover': {
	        boxShadow: "0px 0px 0px 8px ".concat((0, _colorManipulator.fade)(theme.palette.secondary.main, 0.16))
	      },
	      '&$active': {
	        boxShadow: "0px 0px 0px 14px ".concat((0, _colorManipulator.fade)(theme.palette.secondary.main, 0.16))
	      }
	    },
	
	    /* Pseudo-class applied to the thumb element if it's active. */
	    active: {},
	
	    /* Pseudo-class applied to the thumb element if keyboard focused. */
	    focusVisible: {},
	
	    /* Styles applied to the thumb label element. */
	    valueLabel: {
	      // IE 11 centering bug, to remove from the customization demos once no longer supported
	      left: 'calc(-50% - 4px)'
	    },
	
	    /* Styles applied to the mark element. */
	    mark: {
	      position: 'absolute',
	      width: 2,
	      height: 2,
	      borderRadius: 1,
	      backgroundColor: 'currentColor'
	    },
	
	    /* Styles applied to the mark element if active (depending on the value). */
	    markActive: {
	      backgroundColor: theme.palette.background.paper,
	      opacity: 0.8
	    },
	
	    /* Styles applied to the mark label element. */
	    markLabel: (0, _extends2.default)({}, theme.typography.body2, {
	      color: theme.palette.text.secondary,
	      position: 'absolute',
	      top: 26,
	      transform: 'translateX(-50%)',
	      whiteSpace: 'nowrap',
	      '$vertical &': {
	        top: 'auto',
	        left: 26,
	        transform: 'translateY(50%)'
	      },
	      '@media (pointer: coarse)': {
	        top: 40,
	        '$vertical &': {
	          left: 31
	        }
	      }
	    }),
	
	    /* Styles applied to the mark label element if active (depending on the value). */
	    markLabelActive: {
	      color: theme.palette.text.primary
	    }
	  };
	};
	
	exports.styles = styles;
	var Slider = /*#__PURE__*/React.forwardRef(function Slider(props, ref) {
	  var ariaLabel = props['aria-label'],
	      ariaLabelledby = props['aria-labelledby'],
	      ariaValuetext = props['aria-valuetext'],
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'span' : _props$component,
	      defaultValue = props.defaultValue,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      getAriaLabel = props.getAriaLabel,
	      getAriaValueText = props.getAriaValueText,
	      _props$marks = props.marks,
	      marksProp = _props$marks === void 0 ? false : _props$marks,
	      _props$max = props.max,
	      max = _props$max === void 0 ? 100 : _props$max,
	      _props$min = props.min,
	      min = _props$min === void 0 ? 0 : _props$min,
	      name = props.name,
	      onChange = props.onChange,
	      onChangeCommitted = props.onChangeCommitted,
	      onMouseDown = props.onMouseDown,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      _props$scale = props.scale,
	      scale = _props$scale === void 0 ? Identity : _props$scale,
	      _props$step = props.step,
	      step = _props$step === void 0 ? 1 : _props$step,
	      _props$ThumbComponent = props.ThumbComponent,
	      ThumbComponent = _props$ThumbComponent === void 0 ? 'span' : _props$ThumbComponent,
	      _props$track = props.track,
	      track = _props$track === void 0 ? 'normal' : _props$track,
	      valueProp = props.value,
	      _props$ValueLabelComp = props.ValueLabelComponent,
	      ValueLabelComponent = _props$ValueLabelComp === void 0 ? _ValueLabel.default : _props$ValueLabelComp,
	      _props$valueLabelDisp = props.valueLabelDisplay,
	      valueLabelDisplay = _props$valueLabelDisp === void 0 ? 'off' : _props$valueLabelDisp,
	      _props$valueLabelForm = props.valueLabelFormat,
	      valueLabelFormat = _props$valueLabelForm === void 0 ? Identity : _props$valueLabelForm,
	      other = (0, _objectWithoutProperties2.default)(props, ["aria-label", "aria-labelledby", "aria-valuetext", "classes", "className", "color", "component", "defaultValue", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "onMouseDown", "orientation", "scale", "step", "ThumbComponent", "track", "value", "ValueLabelComponent", "valueLabelDisplay", "valueLabelFormat"]);
	  var theme = (0, _useTheme.default)();
	  var touchId = React.useRef(); // We can't use the :active browser pseudo-classes.
	  // - The active state isn't triggered when clicking on the rail.
	  // - The active state isn't transfered when inversing a range slider.
	
	  var _React$useState = React.useState(-1),
	      active = _React$useState[0],
	      setActive = _React$useState[1];
	
	  var _React$useState2 = React.useState(-1),
	      open = _React$useState2[0],
	      setOpen = _React$useState2[1];
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: valueProp,
	    default: defaultValue,
	    name: 'Slider'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      valueDerived = _useControlled2[0],
	      setValueState = _useControlled2[1];
	
	  var range = Array.isArray(valueDerived);
	  var values = range ? valueDerived.slice().sort(asc) : [valueDerived];
	  values = values.map(function (value) {
	    return clamp(value, min, max);
	  });
	  var marks = marksProp === true && step !== null ? (0, _toConsumableArray2.default)(Array(Math.floor((max - min) / step) + 1)).map(function (_, index) {
	    return {
	      value: min + step * index
	    };
	  }) : marksProp || [];
	
	  var _useIsFocusVisible = (0, _useIsFocusVisible2.default)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  var _React$useState3 = React.useState(-1),
	      focusVisible = _React$useState3[0],
	      setFocusVisible = _React$useState3[1];
	
	  var sliderRef = React.useRef();
	  var handleFocusRef = (0, _useForkRef.default)(focusVisibleRef, sliderRef);
	  var handleRef = (0, _useForkRef.default)(ref, handleFocusRef);
	  var handleFocus = (0, _useEventCallback.default)(function (event) {
	    var index = Number(event.currentTarget.getAttribute('data-index'));
	
	    if (isFocusVisible(event)) {
	      setFocusVisible(index);
	    }
	
	    setOpen(index);
	  });
	  var handleBlur = (0, _useEventCallback.default)(function () {
	    if (focusVisible !== -1) {
	      setFocusVisible(-1);
	      onBlurVisible();
	    }
	
	    setOpen(-1);
	  });
	  var handleMouseOver = (0, _useEventCallback.default)(function (event) {
	    var index = Number(event.currentTarget.getAttribute('data-index'));
	    setOpen(index);
	  });
	  var handleMouseLeave = (0, _useEventCallback.default)(function () {
	    setOpen(-1);
	  });
	  var isRtl = theme.direction === 'rtl';
	  var handleKeyDown = (0, _useEventCallback.default)(function (event) {
	    var index = Number(event.currentTarget.getAttribute('data-index'));
	    var value = values[index];
	    var tenPercents = (max - min) / 10;
	    var marksValues = marks.map(function (mark) {
	      return mark.value;
	    });
	    var marksIndex = marksValues.indexOf(value);
	    var newValue;
	    var increaseKey = isRtl ? 'ArrowLeft' : 'ArrowRight';
	    var decreaseKey = isRtl ? 'ArrowRight' : 'ArrowLeft';
	
	    switch (event.key) {
	      case 'Home':
	        newValue = min;
	        break;
	
	      case 'End':
	        newValue = max;
	        break;
	
	      case 'PageUp':
	        if (step) {
	          newValue = value + tenPercents;
	        }
	
	        break;
	
	      case 'PageDown':
	        if (step) {
	          newValue = value - tenPercents;
	        }
	
	        break;
	
	      case increaseKey:
	      case 'ArrowUp':
	        if (step) {
	          newValue = value + step;
	        } else {
	          newValue = marksValues[marksIndex + 1] || marksValues[marksValues.length - 1];
	        }
	
	        break;
	
	      case decreaseKey:
	      case 'ArrowDown':
	        if (step) {
	          newValue = value - step;
	        } else {
	          newValue = marksValues[marksIndex - 1] || marksValues[0];
	        }
	
	        break;
	
	      default:
	        return;
	    } // Prevent scroll of the page
	
	
	    event.preventDefault();
	
	    if (step) {
	      newValue = roundValueToStep(newValue, step, min);
	    }
	
	    newValue = clamp(newValue, min, max);
	
	    if (range) {
	      var previousValue = newValue;
	      newValue = setValueIndex({
	        values: values,
	        source: valueDerived,
	        newValue: newValue,
	        index: index
	      }).sort(asc);
	      focusThumb({
	        sliderRef: sliderRef,
	        activeIndex: newValue.indexOf(previousValue)
	      });
	    }
	
	    setValueState(newValue);
	    setFocusVisible(index);
	
	    if (onChange) {
	      onChange(event, newValue);
	    }
	
	    if (onChangeCommitted) {
	      onChangeCommitted(event, newValue);
	    }
	  });
	  var previousIndex = React.useRef();
	  var axis = orientation;
	
	  if (isRtl && orientation !== "vertical") {
	    axis += '-reverse';
	  }
	
	  var getFingerNewValue = function getFingerNewValue(_ref3) {
	    var finger = _ref3.finger,
	        _ref3$move = _ref3.move,
	        move = _ref3$move === void 0 ? false : _ref3$move,
	        values2 = _ref3.values,
	        source = _ref3.source;
	    var slider = sliderRef.current;
	
	    var _slider$getBoundingCl = slider.getBoundingClientRect(),
	        width = _slider$getBoundingCl.width,
	        height = _slider$getBoundingCl.height,
	        bottom = _slider$getBoundingCl.bottom,
	        left = _slider$getBoundingCl.left;
	
	    var percent;
	
	    if (axis.indexOf('vertical') === 0) {
	      percent = (bottom - finger.y) / height;
	    } else {
	      percent = (finger.x - left) / width;
	    }
	
	    if (axis.indexOf('-reverse') !== -1) {
	      percent = 1 - percent;
	    }
	
	    var newValue;
	    newValue = percentToValue(percent, min, max);
	
	    if (step) {
	      newValue = roundValueToStep(newValue, step, min);
	    } else {
	      var marksValues = marks.map(function (mark) {
	        return mark.value;
	      });
	      var closestIndex = findClosest(marksValues, newValue);
	      newValue = marksValues[closestIndex];
	    }
	
	    newValue = clamp(newValue, min, max);
	    var activeIndex = 0;
	
	    if (range) {
	      if (!move) {
	        activeIndex = findClosest(values2, newValue);
	      } else {
	        activeIndex = previousIndex.current;
	      }
	
	      var previousValue = newValue;
	      newValue = setValueIndex({
	        values: values2,
	        source: source,
	        newValue: newValue,
	        index: activeIndex
	      }).sort(asc);
	      activeIndex = newValue.indexOf(previousValue);
	      previousIndex.current = activeIndex;
	    }
	
	    return {
	      newValue: newValue,
	      activeIndex: activeIndex
	    };
	  };
	
	  var handleTouchMove = (0, _useEventCallback.default)(function (event) {
	    var finger = trackFinger(event, touchId);
	
	    if (!finger) {
	      return;
	    }
	
	    var _getFingerNewValue = getFingerNewValue({
	      finger: finger,
	      move: true,
	      values: values,
	      source: valueDerived
	    }),
	        newValue = _getFingerNewValue.newValue,
	        activeIndex = _getFingerNewValue.activeIndex;
	
	    focusThumb({
	      sliderRef: sliderRef,
	      activeIndex: activeIndex,
	      setActive: setActive
	    });
	    setValueState(newValue);
	
	    if (onChange) {
	      onChange(event, newValue);
	    }
	  });
	  var handleTouchEnd = (0, _useEventCallback.default)(function (event) {
	    var finger = trackFinger(event, touchId);
	
	    if (!finger) {
	      return;
	    }
	
	    var _getFingerNewValue2 = getFingerNewValue({
	      finger: finger,
	      values: values,
	      source: valueDerived
	    }),
	        newValue = _getFingerNewValue2.newValue;
	
	    setActive(-1);
	
	    if (event.type === 'touchend') {
	      setOpen(-1);
	    }
	
	    if (onChangeCommitted) {
	      onChangeCommitted(event, newValue);
	    }
	
	    touchId.current = undefined;
	    var doc = (0, _ownerDocument.default)(sliderRef.current);
	    doc.removeEventListener('mousemove', handleTouchMove);
	    doc.removeEventListener('mouseup', handleTouchEnd);
	    doc.removeEventListener('touchmove', handleTouchMove);
	    doc.removeEventListener('touchend', handleTouchEnd);
	  });
	  var handleTouchStart = (0, _useEventCallback.default)(function (event) {
	    // Workaround as Safari has partial support for touchAction: 'none'.
	    event.preventDefault();
	    var touch = event.changedTouches[0];
	
	    if (touch != null) {
	      // A number that uniquely identifies the current finger in the touch session.
	      touchId.current = touch.identifier;
	    }
	
	    var finger = trackFinger(event, touchId);
	
	    var _getFingerNewValue3 = getFingerNewValue({
	      finger: finger,
	      values: values,
	      source: valueDerived
	    }),
	        newValue = _getFingerNewValue3.newValue,
	        activeIndex = _getFingerNewValue3.activeIndex;
	
	    focusThumb({
	      sliderRef: sliderRef,
	      activeIndex: activeIndex,
	      setActive: setActive
	    });
	    setValueState(newValue);
	
	    if (onChange) {
	      onChange(event, newValue);
	    }
	
	    var doc = (0, _ownerDocument.default)(sliderRef.current);
	    doc.addEventListener('touchmove', handleTouchMove);
	    doc.addEventListener('touchend', handleTouchEnd);
	  });
	  React.useEffect(function () {
	    var slider = sliderRef.current;
	    slider.addEventListener('touchstart', handleTouchStart);
	    var doc = (0, _ownerDocument.default)(slider);
	    return function () {
	      slider.removeEventListener('touchstart', handleTouchStart);
	      doc.removeEventListener('mousemove', handleTouchMove);
	      doc.removeEventListener('mouseup', handleTouchEnd);
	      doc.removeEventListener('touchmove', handleTouchMove);
	      doc.removeEventListener('touchend', handleTouchEnd);
	    };
	  }, [handleTouchEnd, handleTouchMove, handleTouchStart]);
	  var handleMouseDown = (0, _useEventCallback.default)(function (event) {
	    if (onMouseDown) {
	      onMouseDown(event);
	    }
	
	    event.preventDefault();
	    var finger = trackFinger(event, touchId);
	
	    var _getFingerNewValue4 = getFingerNewValue({
	      finger: finger,
	      values: values,
	      source: valueDerived
	    }),
	        newValue = _getFingerNewValue4.newValue,
	        activeIndex = _getFingerNewValue4.activeIndex;
	
	    focusThumb({
	      sliderRef: sliderRef,
	      activeIndex: activeIndex,
	      setActive: setActive
	    });
	    setValueState(newValue);
	
	    if (onChange) {
	      onChange(event, newValue);
	    }
	
	    var doc = (0, _ownerDocument.default)(sliderRef.current);
	    doc.addEventListener('mousemove', handleTouchMove);
	    doc.addEventListener('mouseup', handleTouchEnd);
	  });
	  var trackOffset = valueToPercent(range ? values[0] : min, min, max);
	  var trackLeap = valueToPercent(values[values.length - 1], min, max) - trackOffset;
	  var trackStyle = (0, _extends2.default)({}, axisProps[axis].offset(trackOffset), axisProps[axis].leap(trackLeap));
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: handleRef,
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(color))], className, disabled && classes.disabled, marks.length > 0 && marks.some(function (mark) {
	      return mark.label;
	    }) && classes.marked, track === false && classes.trackFalse, orientation === 'vertical' && classes.vertical, track === 'inverted' && classes.trackInverted),
	    onMouseDown: handleMouseDown
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.rail
	  }), /*#__PURE__*/React.createElement("span", {
	    className: classes.track,
	    style: trackStyle
	  }), /*#__PURE__*/React.createElement("input", {
	    value: values.join(','),
	    name: name,
	    type: "hidden"
	  }), marks.map(function (mark, index) {
	    var percent = valueToPercent(mark.value, min, max);
	    var style = axisProps[axis].offset(percent);
	    var markActive;
	
	    if (track === false) {
	      markActive = values.indexOf(mark.value) !== -1;
	    } else {
	      markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
	    }
	
	    return /*#__PURE__*/React.createElement(React.Fragment, {
	      key: mark.value
	    }, /*#__PURE__*/React.createElement("span", {
	      style: style,
	      "data-index": index,
	      className: (0, _clsx.default)(classes.mark, markActive && classes.markActive)
	    }), mark.label != null ? /*#__PURE__*/React.createElement("span", {
	      "aria-hidden": true,
	      "data-index": index,
	      style: style,
	      className: (0, _clsx.default)(classes.markLabel, markActive && classes.markLabelActive)
	    }, mark.label) : null);
	  }), values.map(function (value, index) {
	    var percent = valueToPercent(value, min, max);
	    var style = axisProps[axis].offset(percent);
	    return /*#__PURE__*/React.createElement(ValueLabelComponent, {
	      key: index,
	      valueLabelFormat: valueLabelFormat,
	      valueLabelDisplay: valueLabelDisplay,
	      className: classes.valueLabel,
	      value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
	      index: index,
	      open: open === index || active === index || valueLabelDisplay === 'on',
	      disabled: disabled
	    }, /*#__PURE__*/React.createElement(ThumbComponent, {
	      className: (0, _clsx.default)(classes.thumb, classes["thumbColor".concat((0, _capitalize.default)(color))], active === index && classes.active, disabled && classes.disabled, focusVisible === index && classes.focusVisible),
	      tabIndex: disabled ? null : 0,
	      role: "slider",
	      style: style,
	      "data-index": index,
	      "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
	      "aria-labelledby": ariaLabelledby,
	      "aria-orientation": orientation,
	      "aria-valuemax": scale(max),
	      "aria-valuemin": scale(min),
	      "aria-valuenow": scale(value),
	      "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
	      onKeyDown: handleKeyDown,
	      onFocus: handleFocus,
	      onBlur: handleBlur,
	      onMouseOver: handleMouseOver,
	      onMouseLeave: handleMouseLeave
	    }));
	  }));
	});
	 false ? Slider.propTypes = {
	  /**
	   * The label of the slider.
	   */
	  'aria-label': (0, _utils.chainPropTypes)(_propTypes.default.string, function (props) {
	    var range = Array.isArray(props.value || props.defaultValue);
	
	    if (range && props['aria-label'] != null) {
	      return new Error('Material-UI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * The id of the element containing a label for the slider.
	   */
	  'aria-labelledby': _propTypes.default.string,
	
	  /**
	   * A string value that provides a user-friendly name for the current value of the slider.
	   */
	  'aria-valuetext': (0, _utils.chainPropTypes)(_propTypes.default.string, function (props) {
	    var range = Array.isArray(props.value || props.defaultValue);
	
	    if (range && props['aria-valuetext'] != null) {
	      return new Error('Material-UI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * The default element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
	
	  /**
	   * If `true`, the slider will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
	   *
	   * @param {number} index The thumb label's index to format.
	   * @returns {string}
	   */
	  getAriaLabel: _propTypes.default.func,
	
	  /**
	   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
	   *
	   * @param {number} value The thumb label's value to format.
	   * @param {number} index The thumb label's index to format.
	   * @returns {string}
	   */
	  getAriaValueText: _propTypes.default.func,
	
	  /**
	   * Marks indicate predetermined values to which the user can move the slider.
	   * If `true` the marks will be spaced according the value of the `step` prop.
	   * If an array, it should contain objects with `value` and an optional `label` keys.
	   */
	  marks: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.array]),
	
	  /**
	   * The maximum allowed value of the slider.
	   * Should not be equal to min.
	   */
	  max: _propTypes.default.number,
	
	  /**
	   * The minimum allowed value of the slider.
	   * Should not be equal to max.
	   */
	  min: _propTypes.default.number,
	
	  /**
	   * Name attribute of the hidden `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback function that is fired when the slider's value changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {number | number[]} value The new value.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback function that is fired when the `mouseup` is triggered.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {number | number[]} value The new value.
	   */
	  onChangeCommitted: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * The slider orientation.
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * A transformation function, to change the scale of the slider.
	   */
	  scale: _propTypes.default.func,
	
	  /**
	   * The granularity with which the slider can step through values. (A "discrete" slider.)
	   * The `min` prop serves as the origin for the valid values.
	   * We recommend (max - min) to be evenly divisible by the step.
	   *
	   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
	   */
	  step: _propTypes.default.number,
	
	  /**
	   * The component used to display the value label.
	   */
	  ThumbComponent: _propTypes.default.elementType,
	
	  /**
	   * The track presentation:
	   *
	   * - `normal` the track will render a bar representing the slider value.
	   * - `inverted` the track will render a bar representing the remaining slider value.
	   * - `false` the track will render without a bar.
	   */
	  track: _propTypes.default.oneOf(['normal', false, 'inverted']),
	
	  /**
	   * The value of the slider.
	   * For ranged sliders, provide an array with two values.
	   */
	  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
	
	  /**
	   * The value label component.
	   */
	  ValueLabelComponent: _propTypes.default.elementType,
	
	  /**
	   * Controls when the value label is displayed:
	   *
	   * - `auto` the value label will display when the thumb is hovered or focused.
	   * - `on` will display persistently.
	   * - `off` will never display.
	   */
	  valueLabelDisplay: _propTypes.default.oneOf(['on', 'auto', 'off']),
	
	  /**
	   * The format function the value label's value.
	   *
	   * When a function is provided, it should have the following signature:
	   *
	   * - {number} value The value label's value to format
	   * - {number} index The value label's index to format
	   */
	  valueLabelFormat: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSlider'
	})(Slider);
	
	exports.default = _default;

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = function styles(theme) {
	  return {
	    thumb: {
	      '&$open': {
	        '& $offset': {
	          transform: 'scale(1) translateY(-10px)'
	        }
	      }
	    },
	    open: {},
	    offset: (0, _extends2.default)({
	      zIndex: 1
	    }, theme.typography.body2, {
	      fontSize: theme.typography.pxToRem(12),
	      lineHeight: 1.2,
	      transition: theme.transitions.create(['transform'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      top: -34,
	      transformOrigin: 'bottom center',
	      transform: 'scale(0)',
	      position: 'absolute'
	    }),
	    circle: {
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      width: 32,
	      height: 32,
	      borderRadius: '50% 50% 50% 0',
	      backgroundColor: 'currentColor',
	      transform: 'rotate(-45deg)'
	    },
	    label: {
	      color: theme.palette.primary.contrastText,
	      transform: 'rotate(45deg)'
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	function ValueLabel(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      open = props.open,
	      value = props.value,
	      valueLabelDisplay = props.valueLabelDisplay;
	
	  if (valueLabelDisplay === 'off') {
	    return children;
	  }
	
	  return /*#__PURE__*/React.cloneElement(children, {
	    className: (0, _clsx.default)(children.props.className, (open || valueLabelDisplay === 'on') && classes.open, classes.thumb)
	  }, /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.offset, className)
	  }, /*#__PURE__*/React.createElement("span", {
	    className: classes.circle
	  }, /*#__PURE__*/React.createElement("span", {
	    className: classes.label
	  }, value))));
	}
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateValueLabel'
	})(ValueLabel);
	
	exports.default = _default;

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Slider.default;
	  }
	});
	
	var _Slider = _interopRequireDefault(__webpack_require__(944));

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _extends8 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _transitions = __webpack_require__(74);
	
	var _ClickAwayListener = _interopRequireDefault(__webpack_require__(350));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(79));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(111));
	
	var _Grow = _interopRequireDefault(__webpack_require__(163));
	
	var _SnackbarContent = _interopRequireDefault(__webpack_require__(371));
	
	var styles = function styles(theme) {
	  var top1 = {
	    top: 8
	  };
	  var bottom1 = {
	    bottom: 8
	  };
	  var right = {
	    justifyContent: 'flex-end'
	  };
	  var left = {
	    justifyContent: 'flex-start'
	  };
	  var top3 = {
	    top: 24
	  };
	  var bottom3 = {
	    bottom: 24
	  };
	  var right3 = {
	    right: 24
	  };
	  var left3 = {
	    left: 24
	  };
	  var center = {
	    left: '50%',
	    right: 'auto',
	    transform: 'translateX(-50%)'
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      zIndex: theme.zIndex.snackbar,
	      position: 'fixed',
	      display: 'flex',
	      left: 8,
	      right: 8,
	      justifyContent: 'center',
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */
	    anchorOriginTopCenter: (0, _extends8.default)({}, top1, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({}, top3, center))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */
	    anchorOriginBottomCenter: (0, _extends8.default)({}, bottom1, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({}, bottom3, center))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */
	    anchorOriginTopRight: (0, _extends8.default)({}, top1, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({
	      left: 'auto'
	    }, top3, right3))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */
	    anchorOriginBottomRight: (0, _extends8.default)({}, bottom1, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({
	      left: 'auto'
	    }, bottom3, right3))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */
	    anchorOriginTopLeft: (0, _extends8.default)({}, top1, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({
	      right: 'auto'
	    }, top3, left3))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */
	    anchorOriginBottomLeft: (0, _extends8.default)({}, bottom1, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({
	      right: 'auto'
	    }, bottom3, left3)))
	  };
	};
	
	exports.styles = styles;
	var Snackbar = /*#__PURE__*/React.forwardRef(function Snackbar(props, ref) {
	  var action = props.action,
	      _props$anchorOrigin = props.anchorOrigin;
	  _props$anchorOrigin = _props$anchorOrigin === void 0 ? {
	    vertical: 'bottom',
	    horizontal: 'center'
	  } : _props$anchorOrigin;
	  var vertical = _props$anchorOrigin.vertical,
	      horizontal = _props$anchorOrigin.horizontal,
	      _props$autoHideDurati = props.autoHideDuration,
	      autoHideDuration = _props$autoHideDurati === void 0 ? null : _props$autoHideDurati,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      ClickAwayListenerProps = props.ClickAwayListenerProps,
	      ContentProps = props.ContentProps,
	      _props$disableWindowB = props.disableWindowBlurListener,
	      disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB,
	      message = props.message,
	      onClose = props.onClose,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      onMouseEnter = props.onMouseEnter,
	      onMouseLeave = props.onMouseLeave,
	      open = props.open,
	      resumeHideDuration = props.resumeHideDuration,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Grow.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  } : _props$transitionDura,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "anchorOrigin", "autoHideDuration", "children", "classes", "className", "ClickAwayListenerProps", "ContentProps", "disableWindowBlurListener", "message", "onClose", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"]);
	  var timerAutoHide = React.useRef();
	
	  var _React$useState = React.useState(true),
	      exited = _React$useState[0],
	      setExited = _React$useState[1];
	
	  var handleClose = (0, _useEventCallback.default)(function () {
	    if (onClose) {
	      onClose.apply(void 0, arguments);
	    }
	  });
	  var setAutoHideTimer = (0, _useEventCallback.default)(function (autoHideDurationParam) {
	    if (!onClose || autoHideDurationParam == null) {
	      return;
	    }
	
	    clearTimeout(timerAutoHide.current);
	    timerAutoHide.current = setTimeout(function () {
	      handleClose(null, 'timeout');
	    }, autoHideDurationParam);
	  });
	  React.useEffect(function () {
	    if (open) {
	      setAutoHideTimer(autoHideDuration);
	    }
	
	    return function () {
	      clearTimeout(timerAutoHide.current);
	    };
	  }, [open, autoHideDuration, setAutoHideTimer]); // Pause the timer when the user is interacting with the Snackbar
	  // or when the user hide the window.
	
	  var handlePause = function handlePause() {
	    clearTimeout(timerAutoHide.current);
	  }; // Restart the timer when the user is no longer interacting with the Snackbar
	  // or when the window is shown back.
	
	
	  var handleResume = React.useCallback(function () {
	    if (autoHideDuration != null) {
	      setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
	    }
	  }, [autoHideDuration, resumeHideDuration, setAutoHideTimer]);
	
	  var handleMouseEnter = function handleMouseEnter(event) {
	    if (onMouseEnter) {
	      onMouseEnter(event);
	    }
	
	    handlePause();
	  };
	
	  var handleMouseLeave = function handleMouseLeave(event) {
	    if (onMouseLeave) {
	      onMouseLeave(event);
	    }
	
	    handleResume();
	  };
	
	  var handleClickAway = function handleClickAway(event) {
	    if (onClose) {
	      onClose(event, 'clickaway');
	    }
	  };
	
	  var handleExited = function handleExited() {
	    setExited(true);
	  };
	
	  var handleEnter = function handleEnter() {
	    setExited(false);
	  };
	
	  React.useEffect(function () {
	    if (!disableWindowBlurListener && open) {
	      window.addEventListener('focus', handleResume);
	      window.addEventListener('blur', handlePause);
	      return function () {
	        window.removeEventListener('focus', handleResume);
	        window.removeEventListener('blur', handlePause);
	      };
	    }
	
	    return undefined;
	  }, [disableWindowBlurListener, handleResume, open]); // So we only render active snackbars.
	
	  if (!open && exited) {
	    return null;
	  }
	
	  return /*#__PURE__*/React.createElement(_ClickAwayListener.default, (0, _extends8.default)({
	    onClickAway: handleClickAway
	  }, ClickAwayListenerProps), /*#__PURE__*/React.createElement("div", (0, _extends8.default)({
	    className: (0, _clsx.default)(classes.root, classes["anchorOrigin".concat((0, _capitalize.default)(vertical)).concat((0, _capitalize.default)(horizontal))], className),
	    onMouseEnter: handleMouseEnter,
	    onMouseLeave: handleMouseLeave,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends8.default)({
	    appear: true,
	    in: open,
	    onEnter: (0, _createChainedFunction.default)(handleEnter, onEnter),
	    onEntered: onEntered,
	    onEntering: onEntering,
	    onExit: onExit,
	    onExited: (0, _createChainedFunction.default)(handleExited, onExited),
	    onExiting: onExiting,
	    timeout: transitionDuration,
	    direction: vertical === 'top' ? 'down' : 'up'
	  }, TransitionProps), children || /*#__PURE__*/React.createElement(_SnackbarContent.default, (0, _extends8.default)({
	    message: message,
	    action: action
	  }, ContentProps)))));
	});
	 false ? Snackbar.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The action to display. It renders after the message, at the end of the snackbar.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * The anchor of the `Snackbar`.
	   */
	  anchorOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOf(['center', 'left', 'right']).isRequired,
	    vertical: _propTypes.default.oneOf(['bottom', 'top']).isRequired
	  }),
	
	  /**
	   * The number of milliseconds to wait before automatically calling the
	   * `onClose` function. `onClose` should then set the state of the `open`
	   * prop to hide the Snackbar. This behavior is disabled by default with
	   * the `null` value.
	   */
	  autoHideDuration: _propTypes.default.number,
	
	  /**
	   * Replace the `SnackbarContent` component.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Props applied to the `ClickAwayListener` element.
	   */
	  ClickAwayListenerProps: _propTypes.default.object,
	
	  /**
	   * Props applied to the [`SnackbarContent`](/api/snackbar-content/) element.
	   */
	  ContentProps: _propTypes.default.object,
	
	  /**
	   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
	   */
	  disableWindowBlurListener: _propTypes.default.bool,
	
	  /**
	   * When displaying multiple consecutive Snackbars from a parent rendering a single
	   * <Snackbar/>, add the key prop to ensure independent treatment of each message.
	   * e.g. <Snackbar key={message} />, otherwise, the message may update-in-place and
	   * features such as autoHideDuration may be canceled.
	   */
	  key: _propTypes.default.any,
	
	  /**
	   * The message to display.
	   */
	  message: _propTypes.default.node,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Typically `onClose` is used to set state in the parent component,
	   * which is used to control the `Snackbar` `open` prop.
	   * The `reason` parameter can optionally be used to control the response to `onClose`,
	   * for example ignoring `clickaway`.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the transition is entering.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired before the transition is exiting.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes.default.func,
	
	  /**
	   * If `true`, `Snackbar` is open.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * The number of milliseconds to wait before dismissing after user interaction.
	   * If `autoHideDuration` prop isn't specified, it does nothing.
	   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
	   * we default to `autoHideDuration / 2` ms.
	   */
	  resumeHideDuration: _propTypes.default.number,
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  flip: false,
	  name: 'MuiSnackbar'
	})(Snackbar);
	
	exports.default = _default;

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Snackbar.default;
	  }
	});
	
	var _Snackbar = _interopRequireDefault(__webpack_require__(947));

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Paper = _interopRequireDefault(__webpack_require__(65));
	
	var _colorManipulator = __webpack_require__(49);
	
	var styles = function styles(theme) {
	  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
	  var backgroundColor = (0, _colorManipulator.emphasize)(theme.palette.background.default, emphasis);
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends3.default)({}, theme.typography.body2, (0, _defineProperty2.default)({
	      color: theme.palette.getContrastText(backgroundColor),
	      backgroundColor: backgroundColor,
	      display: 'flex',
	      alignItems: 'center',
	      flexWrap: 'wrap',
	      padding: '6px 16px',
	      borderRadius: theme.shape.borderRadius,
	      flexGrow: 1
	    }, theme.breakpoints.up('sm'), {
	      flexGrow: 'initial',
	      minWidth: 288
	    })),
	
	    /* Styles applied to the message wrapper element. */
	    message: {
	      padding: '8px 0'
	    },
	
	    /* Styles applied to the action wrapper element if `action` is provided. */
	    action: {
	      display: 'flex',
	      alignItems: 'center',
	      marginLeft: 'auto',
	      paddingLeft: 16,
	      marginRight: -8
	    }
	  };
	};
	
	exports.styles = styles;
	var SnackbarContent = /*#__PURE__*/React.forwardRef(function SnackbarContent(props, ref) {
	  var action = props.action,
	      classes = props.classes,
	      className = props.className,
	      message = props.message,
	      _props$role = props.role,
	      role = _props$role === void 0 ? 'alert' : _props$role,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "classes", "className", "message", "role"]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends3.default)({
	    role: role,
	    square: true,
	    elevation: 6,
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: classes.message
	  }, message), action ? /*#__PURE__*/React.createElement("div", {
	    className: classes.action
	  }, action) : null);
	});
	 false ? SnackbarContent.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The action to display. It renders after the message, at the end of the snackbar.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The message to display.
	   */
	  message: _propTypes.default.node,
	
	  /**
	   * The ARIA role attribute of the element.
	   */
	  role: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSnackbarContent'
	})(SnackbarContent);
	
	exports.default = _default;

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(67);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {},
	
	  /* Styles applied to the root element if `orientation="horizontal"`. */
	  horizontal: {
	    paddingLeft: 8,
	    paddingRight: 8
	  },
	
	  /* Styles applied to the root element if `orientation="vertical"`. */
	  vertical: {},
	
	  /* Styles applied to the root element if `alternativeLabel={true}`. */
	  alternativeLabel: {
	    flex: 1,
	    position: 'relative'
	  },
	
	  /* Pseudo-class applied to the root element if `completed={true}`. */
	  completed: {}
	};
	exports.styles = styles;
	var Step = /*#__PURE__*/React.forwardRef(function Step(props, ref) {
	  var _props$active = props.active,
	      active = _props$active === void 0 ? false : _props$active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$completed = props.completed,
	      completed = _props$completed === void 0 ? false : _props$completed,
	      connectorProp = props.connector,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$expanded = props.expanded,
	      expanded = _props$expanded === void 0 ? false : _props$expanded,
	      index = props.index,
	      last = props.last,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "connector", "disabled", "expanded", "index", "last", "orientation"]);
	  var connector = connectorProp ? /*#__PURE__*/React.cloneElement(connectorProp, {
	    orientation: orientation,
	    alternativeLabel: alternativeLabel,
	    index: index,
	    active: active,
	    completed: completed,
	    disabled: disabled
	  }) : null;
	  var newChildren = /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel, completed && classes.completed),
	    ref: ref
	  }, other), connector && alternativeLabel && index !== 0 ? connector : null, React.Children.map(children, function (child) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The Step component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    return /*#__PURE__*/React.cloneElement(child, (0, _extends2.default)({
	      active: active,
	      alternativeLabel: alternativeLabel,
	      completed: completed,
	      disabled: disabled,
	      expanded: expanded,
	      last: last,
	      icon: index + 1,
	      orientation: orientation
	    }, child.props));
	  }));
	
	  if (connector && !alternativeLabel && index !== 0) {
	    return /*#__PURE__*/React.createElement(React.Fragment, null, connector, newChildren);
	  }
	
	  return newChildren;
	});
	 false ? Step.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepButton` is a child of `Step`. Is passed to child components.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Expand the step.
	   */
	  expanded: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStep'
	})(Step);
	
	exports.default = _default;

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Step.default;
	  }
	});
	
	var _Step = _interopRequireDefault(__webpack_require__(950));

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(56));
	
	var _StepLabel = _interopRequireDefault(__webpack_require__(374));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(130));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    width: '100%',
	    padding: '24px 16px',
	    margin: '-24px -16px',
	    boxSizing: 'content-box'
	  },
	
	  /* Styles applied to the root element if `orientation="horizontal"`. */
	  horizontal: {},
	
	  /* Styles applied to the root element if `orientation="vertical"`. */
	  vertical: {
	    justifyContent: 'flex-start',
	    padding: '8px',
	    margin: '-8px'
	  },
	
	  /* Styles applied to the `ButtonBase` touch-ripple. */
	  touchRipple: {
	    color: 'rgba(0, 0, 0, 0.3)'
	  }
	};
	exports.styles = styles;
	var StepButton = /*#__PURE__*/React.forwardRef(function StepButton(props, ref) {
	  var active = props.active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      completed = props.completed,
	      disabled = props.disabled,
	      expanded = props.expanded,
	      icon = props.icon,
	      last = props.last,
	      optional = props.optional,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "expanded", "icon", "last", "optional", "orientation"]);
	  var childProps = {
	    active: active,
	    alternativeLabel: alternativeLabel,
	    completed: completed,
	    disabled: disabled,
	    icon: icon,
	    optional: optional,
	    orientation: orientation
	  };
	  var child = (0, _isMuiElement.default)(children, ['StepLabel']) ? /*#__PURE__*/React.cloneElement(children, childProps) : /*#__PURE__*/React.createElement(_StepLabel.default, childProps, children);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    focusRipple: true,
	    disabled: disabled,
	    TouchRippleProps: {
	      className: classes.touchRipple
	    },
	    className: (0, _clsx.default)(classes.root, classes[orientation], className),
	    ref: ref
	  }, other), child);
	});
	 false ? StepButton.propTypes = {
	  /**
	   * @ignore
	   * Passed in via `Step` - passed through to `StepLabel`.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Set internally by Stepper when it's supplied with the alternativeLabel property.
	   */
	  alternativeLabel: _propTypes.default.bool,
	
	  /**
	   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   * Sets completed styling. Is passed to StepLabel.
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Disables the button and sets disabled styling. Is passed to StepLabel.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * potentially passed from parent `Step`
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  last: _propTypes.default.bool,
	
	  /**
	   * The optional node to display.
	   */
	  optional: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepButton'
	})(StepButton);
	
	exports.default = _default;

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepButton.default;
	  }
	});
	
	var _StepButton = _interopRequireDefault(__webpack_require__(952));

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      flex: '1 1 auto'
	    },
	
	    /* Styles applied to the root element if `orientation="horizontal"`. */
	    horizontal: {},
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {
	      marginLeft: 12,
	      // half icon
	      padding: '0 0 8px'
	    },
	
	    /* Styles applied to the root element if `alternativeLabel={true}`. */
	    alternativeLabel: {
	      position: 'absolute',
	      top: 8 + 4,
	      left: 'calc(-50% + 20px)',
	      right: 'calc(50% + 20px)'
	    },
	
	    /* Pseudo-class applied to the root element if `active={true}`. */
	    active: {},
	
	    /* Pseudo-class applied to the root element if `completed={true}`. */
	    completed: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the line element. */
	    line: {
	      display: 'block',
	      borderColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
	    },
	
	    /* Styles applied to the root element if `orientation="horizontal"`. */
	    lineHorizontal: {
	      borderTopStyle: 'solid',
	      borderTopWidth: 1
	    },
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    lineVertical: {
	      borderLeftStyle: 'solid',
	      borderLeftWidth: 1,
	      minHeight: 24
	    }
	  };
	};
	
	exports.styles = styles;
	var StepConnector = /*#__PURE__*/React.forwardRef(function StepConnector(props, ref) {
	  var active = props.active,
	      _props$alternativeLab = props.alternativeLabel,
	      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
	      classes = props.classes,
	      className = props.className,
	      completed = props.completed,
	      disabled = props.disabled,
	      index = props.index,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "classes", "className", "completed", "disabled", "index", "orientation"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel, active && classes.active, completed && classes.completed, disabled && classes.disabled),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.line, {
	      'horizontal': classes.lineHorizontal,
	      'vertical': classes.lineVertical
	    }[orientation])
	  }));
	});
	 false ? StepConnector.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepConnector'
	})(StepConnector);
	
	exports.default = _default;

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _Collapse = _interopRequireDefault(__webpack_require__(161));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      marginTop: 8,
	      marginLeft: 12,
	      // half icon
	      paddingLeft: 8 + 12,
	      // margin + half icon
	      paddingRight: 8,
	      borderLeft: "1px solid ".concat(theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600])
	    },
	
	    /* Styles applied to the root element if `last={true}` (controlled by `Step`). */
	    last: {
	      borderLeft: 'none'
	    },
	
	    /* Styles applied to the Transition component. */
	    transition: {}
	  };
	};
	
	exports.styles = styles;
	var StepContent = /*#__PURE__*/React.forwardRef(function StepContent(props, ref) {
	  var active = props.active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      completed = props.completed,
	      expanded = props.expanded,
	      last = props.last,
	      optional = props.optional,
	      orientation = props.orientation,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Collapse.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "expanded", "last", "optional", "orientation", "TransitionComponent", "transitionDuration", "TransitionProps"]);
	
	  if (false) {
	    if (orientation !== 'vertical') {
	      console.error('Material-UI: <StepContent /> is only designed for use with the vertical stepper.');
	    }
	  }
	
	  var transitionDuration = transitionDurationProp;
	
	  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
	    transitionDuration = undefined;
	  }
	
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, last && classes.last),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    in: active || expanded,
	    className: classes.transition,
	    timeout: transitionDuration,
	    unmountOnExit: true
	  }, TransitionProps), children));
	});
	 false ? StepContent.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Step content.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Adjust the duration of the content expand transition.
	   * Passed as a prop to the transition component.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepContent'
	})(StepContent);
	
	exports.default = _default;

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepContent.default;
	  }
	});
	
	var _StepContent = _interopRequireDefault(__webpack_require__(955));

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _CheckCircle = _interopRequireDefault(__webpack_require__(1019));
	
	var _Warning = _interopRequireDefault(__webpack_require__(1025));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(166));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      color: theme.palette.text.disabled,
	      '&$completed': {
	        color: theme.palette.primary.main
	      },
	      '&$active': {
	        color: theme.palette.primary.main
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    },
	
	    /* Styles applied to the SVG text element. */
	    text: {
	      fill: theme.palette.primary.contrastText,
	      fontSize: theme.typography.caption.fontSize,
	      fontFamily: theme.typography.fontFamily
	    },
	
	    /* Pseudo-class applied to the root element if `active={true}`. */
	    active: {},
	
	    /* Pseudo-class applied to the root element if `completed={true}`. */
	    completed: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {}
	  };
	};
	
	exports.styles = styles;
	
	var _ref = /*#__PURE__*/React.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "12"
	});
	
	var StepIcon = /*#__PURE__*/React.forwardRef(function StepIcon(props, ref) {
	  var _props$completed = props.completed,
	      completed = _props$completed === void 0 ? false : _props$completed,
	      icon = props.icon,
	      _props$active = props.active,
	      active = _props$active === void 0 ? false : _props$active,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      classes = props.classes;
	
	  if (typeof icon === 'number' || typeof icon === 'string') {
	    var className = (0, _clsx.default)(classes.root, active && classes.active, error && classes.error, completed && classes.completed);
	
	    if (error) {
	      return /*#__PURE__*/React.createElement(_Warning.default, {
	        className: className,
	        ref: ref
	      });
	    }
	
	    if (completed) {
	      return /*#__PURE__*/React.createElement(_CheckCircle.default, {
	        className: className,
	        ref: ref
	      });
	    }
	
	    return /*#__PURE__*/React.createElement(_SvgIcon.default, {
	      className: className,
	      ref: ref
	    }, _ref, /*#__PURE__*/React.createElement("text", {
	      className: classes.text,
	      x: "12",
	      y: "16",
	      textAnchor: "middle"
	    }, icon));
	  }
	
	  return icon;
	});
	 false ? StepIcon.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Whether this step is active.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * Mark the step as failed.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * The label displayed in the step icon.
	   */
	  icon: _propTypes.default.node
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepIcon'
	})(StepIcon);
	
	exports.default = _default;

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Typography = _interopRequireDefault(__webpack_require__(66));
	
	var _StepIcon = _interopRequireDefault(__webpack_require__(373));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      alignItems: 'center',
	      '&$alternativeLabel': {
	        flexDirection: 'column'
	      },
	      '&$disabled': {
	        cursor: 'default'
	      }
	    },
	
	    /* Styles applied to the root element if `orientation="horizontal"`. */
	    horizontal: {},
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {},
	
	    /* Styles applied to the `Typography` component which wraps `children`. */
	    label: {
	      color: theme.palette.text.secondary,
	      '&$active': {
	        color: theme.palette.text.primary,
	        fontWeight: 500
	      },
	      '&$completed': {
	        color: theme.palette.text.primary,
	        fontWeight: 500
	      },
	      '&$alternativeLabel': {
	        textAlign: 'center',
	        marginTop: 16
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    },
	
	    /* Pseudo-class applied to the `Typography` component if `active={true}`. */
	    active: {},
	
	    /* Pseudo-class applied to the `Typography` component if `completed={true}`. */
	    completed: {},
	
	    /* Pseudo-class applied to the root element and `Typography` component if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element and `Typography` component if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the `icon` container element. */
	    iconContainer: {
	      flexShrink: 0,
	      // Fix IE 11 issue
	      display: 'flex',
	      paddingRight: 8,
	      '&$alternativeLabel': {
	        paddingRight: 0
	      }
	    },
	
	    /* Pseudo-class applied to the root and icon container and `Typography` if `alternativeLabel={true}`. */
	    alternativeLabel: {},
	
	    /* Styles applied to the container element which wraps `Typography` and `optional`. */
	    labelContainer: {
	      width: '100%'
	    }
	  };
	};
	
	exports.styles = styles;
	var StepLabel = /*#__PURE__*/React.forwardRef(function StepLabel(props, ref) {
	  var _props$active = props.active,
	      active = _props$active === void 0 ? false : _props$active,
	      _props$alternativeLab = props.alternativeLabel,
	      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$completed = props.completed,
	      completed = _props$completed === void 0 ? false : _props$completed,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      expanded = props.expanded,
	      icon = props.icon,
	      last = props.last,
	      optional = props.optional,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      StepIconComponentProp = props.StepIconComponent,
	      StepIconProps = props.StepIconProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "error", "expanded", "icon", "last", "optional", "orientation", "StepIconComponent", "StepIconProps"]);
	  var StepIconComponent = StepIconComponentProp;
	
	  if (icon && !StepIconComponent) {
	    StepIconComponent = _StepIcon.default;
	  }
	
	  return /*#__PURE__*/React.createElement("span", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[orientation], className, disabled && classes.disabled, alternativeLabel && classes.alternativeLabel, error && classes.error),
	    ref: ref
	  }, other), icon || StepIconComponent ? /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.iconContainer, alternativeLabel && classes.alternativeLabel)
	  }, /*#__PURE__*/React.createElement(StepIconComponent, (0, _extends2.default)({
	    completed: completed,
	    active: active,
	    error: error,
	    icon: icon
	  }, StepIconProps))) : null, /*#__PURE__*/React.createElement("span", {
	    className: classes.labelContainer
	  }, children ? /*#__PURE__*/React.createElement(_Typography.default, {
	    variant: "body2",
	    component: "span",
	    display: "block",
	    className: (0, _clsx.default)(classes.label, alternativeLabel && classes.alternativeLabel, completed && classes.completed, active && classes.active, error && classes.error)
	  }, children) : null, optional));
	});
	 false ? StepLabel.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * In most cases will simply be a string containing a title for the label.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepLabelButton` is a child of `StepLabel`. Is passed to child components.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Mark the step as failed.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * Override the default label of the step icon.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The optional node to display.
	   */
	  optional: _propTypes.default.node,
	
	  /**
	   * The component to render in place of the [`StepIcon`](/api/step-icon/).
	   */
	  StepIconComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`StepIcon`](/api/step-icon/) element.
	   */
	  StepIconProps: _propTypes.default.object
	} : void 0;
	StepLabel.muiName = 'StepLabel';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepLabel'
	})(StepLabel);
	
	exports.default = _default;

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Paper = _interopRequireDefault(__webpack_require__(65));
	
	var _StepConnector = _interopRequireDefault(__webpack_require__(372));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    padding: 24
	  },
	
	  /* Styles applied to the root element if `orientation="horizontal"`. */
	  horizontal: {
	    flexDirection: 'row',
	    alignItems: 'center'
	  },
	
	  /* Styles applied to the root element if `orientation="vertical"`. */
	  vertical: {
	    flexDirection: 'column'
	  },
	
	  /* Styles applied to the root element if `alternativeLabel={true}`. */
	  alternativeLabel: {
	    alignItems: 'flex-start'
	  }
	};
	exports.styles = styles;
	var defaultConnector = /*#__PURE__*/React.createElement(_StepConnector.default, null);
	var Stepper = /*#__PURE__*/React.forwardRef(function Stepper(props, ref) {
	  var _props$activeStep = props.activeStep,
	      activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
	      _props$alternativeLab = props.alternativeLabel,
	      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$connector = props.connector,
	      connectorProp = _props$connector === void 0 ? defaultConnector : _props$connector,
	      _props$nonLinear = props.nonLinear,
	      nonLinear = _props$nonLinear === void 0 ? false : _props$nonLinear,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["activeStep", "alternativeLabel", "children", "classes", "className", "connector", "nonLinear", "orientation"]);
	  var connector = /*#__PURE__*/React.isValidElement(connectorProp) ? /*#__PURE__*/React.cloneElement(connectorProp, {
	    orientation: orientation
	  }) : null;
	  var childrenArray = React.Children.toArray(children);
	  var steps = childrenArray.map(function (step, index) {
	    var state = {
	      index: index,
	      active: false,
	      completed: false,
	      disabled: false
	    };
	
	    if (activeStep === index) {
	      state.active = true;
	    } else if (!nonLinear && activeStep > index) {
	      state.completed = true;
	    } else if (!nonLinear && activeStep < index) {
	      state.disabled = true;
	    }
	
	    return /*#__PURE__*/React.cloneElement(step, (0, _extends2.default)({
	      alternativeLabel: alternativeLabel,
	      connector: connector,
	      last: index + 1 === childrenArray.length,
	      orientation: orientation
	    }, state, step.props));
	  });
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    elevation: 0,
	    className: (0, _clsx.default)(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel),
	    ref: ref
	  }, other), steps);
	});
	 false ? Stepper.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Set the active step (zero based index).
	   * Set to -1 to disable all the steps.
	   */
	  activeStep: _propTypes.default.number,
	
	  /**
	   * If set to 'true' and orientation is horizontal,
	   * then the step label will be positioned under the icon.
	   */
	  alternativeLabel: _propTypes.default.bool,
	
	  /**
	   * Two or more `<Step />` components.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * An element to be placed between each step.
	   */
	  connector: _propTypes.default.element,
	
	  /**
	   * If set the `Stepper` will not assist in controlling steps for linear flow.
	   */
	  nonLinear: _propTypes.default.bool,
	
	  /**
	   * The stepper orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepper'
	})(Stepper);
	
	exports.default = _default;

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.default;
	  }
	});
	
	var _Stepper = _interopRequireDefault(__webpack_require__(959));

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      userSelect: 'none',
	      width: '1em',
	      height: '1em',
	      display: 'inline-block',
	      fill: 'currentColor',
	      flexShrink: 0,
	      fontSize: theme.typography.pxToRem(24),
	      transition: theme.transitions.create('fill', {
	        duration: theme.transitions.duration.shorter
	      })
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="action"`. */
	    colorAction: {
	      color: theme.palette.action.active
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `color="disabled"`. */
	    colorDisabled: {
	      color: theme.palette.action.disabled
	    },
	
	    /* Styles applied to the root element if `fontSize="inherit"`. */
	    fontSizeInherit: {
	      fontSize: 'inherit'
	    },
	
	    /* Styles applied to the root element if `fontSize="small"`. */
	    fontSizeSmall: {
	      fontSize: theme.typography.pxToRem(20)
	    },
	
	    /* Styles applied to the root element if `fontSize="large"`. */
	    fontSizeLarge: {
	      fontSize: theme.typography.pxToRem(35)
	    }
	  };
	};
	
	exports.styles = styles;
	var SvgIcon = /*#__PURE__*/React.forwardRef(function SvgIcon(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'inherit' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'svg' : _props$component,
	      _props$fontSize = props.fontSize,
	      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
	      htmlColor = props.htmlColor,
	      titleAccess = props.titleAccess,
	      _props$viewBox = props.viewBox,
	      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, _capitalize.default)(color))], fontSize !== 'default' && classes["fontSize".concat((0, _capitalize.default)(fontSize))]),
	    focusable: "false",
	    viewBox: viewBox,
	    color: htmlColor,
	    "aria-hidden": titleAccess ? undefined : true,
	    role: titleAccess ? 'img' : undefined,
	    ref: ref
	  }, other), children, titleAccess ? /*#__PURE__*/React.createElement("title", null, titleAccess) : null);
	});
	 false ? SvgIcon.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Node passed into the SVG element.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
	   */
	  color: _propTypes.default.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
	   */
	  fontSize: _propTypes.default.oneOf(['default', 'inherit', 'large', 'small']),
	
	  /**
	   * Applies a color attribute to the SVG element.
	   */
	  htmlColor: _propTypes.default.string,
	
	  /**
	   * The shape-rendering attribute. The behavior of the different options is described on the
	   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
	   * If you are having issues with blurry icons you should investigate this property.
	   */
	  shapeRendering: _propTypes.default.string,
	
	  /**
	   * Provides a human-readable title for the element that contains it.
	   * https://www.w3.org/TR/SVG-access/#Equivalent
	   */
	  titleAccess: _propTypes.default.string,
	
	  /**
	   * Allows you to redefine what the coordinates without units mean inside an SVG element.
	   * For example, if the SVG element is 500 (width) by 200 (height),
	   * and you pass viewBox="0 0 50 20",
	   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
	   * to bottom right (50,20) and each unit will be worth 10px.
	   */
	  viewBox: _propTypes.default.string
	} : void 0;
	SvgIcon.muiName = 'SvgIcon';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSvgIcon'
	})(SvgIcon);
	
	exports.default = _default;

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _Drawer = __webpack_require__(230);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'fixed',
	      top: 0,
	      left: 0,
	      bottom: 0,
	      zIndex: theme.zIndex.drawer - 1
	    },
	    anchorLeft: {
	      right: 'auto'
	    },
	    anchorRight: {
	      left: 'auto',
	      right: 0
	    },
	    anchorTop: {
	      bottom: 'auto',
	      right: 0
	    },
	    anchorBottom: {
	      top: 'auto',
	      bottom: 0,
	      right: 0
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	var SwipeArea = /*#__PURE__*/React.forwardRef(function SwipeArea(props, ref) {
	  var anchor = props.anchor,
	      classes = props.classes,
	      className = props.className,
	      width = props.width,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchor", "classes", "className", "width"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["anchor".concat((0, _capitalize.default)(anchor))], className),
	    ref: ref,
	    style: (0, _defineProperty2.default)({}, (0, _Drawer.isHorizontal)(anchor) ? 'width' : 'height', width)
	  }, other));
	});
	 false ? SwipeArea.propTypes = {
	  /**
	   * Side on which to attach the discovery area.
	   */
	  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']).isRequired,
	
	  /**
	   * @ignore
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The width of the left most (or right most) area in pixels where the
	   * drawer can be swiped open from.
	   */
	  width: _propTypes.default.number.isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateSwipeArea'
	})(SwipeArea);
	
	exports.default = _default;

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reset = reset;
	exports.default = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(45));
	
	var _utils = __webpack_require__(22);
	
	var _styles = __webpack_require__(60);
	
	var _Drawer = _interopRequireWildcard(__webpack_require__(230));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(68));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(79));
	
	var _transitions = __webpack_require__(74);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(47));
	
	var _utils2 = __webpack_require__(110);
	
	var _NoSsr = _interopRequireDefault(__webpack_require__(365));
	
	var _SwipeArea = _interopRequireDefault(__webpack_require__(962));
	
	// This value is closed to what browsers are using internally to
	// trigger a native scroll.
	var UNCERTAINTY_THRESHOLD = 3; // px
	// We can only have one node at the time claiming ownership for handling the swipe.
	// Otherwise, the UX would be confusing.
	// That's why we use a singleton here.
	
	var nodeThatClaimedTheSwipe = null; // Exported for test purposes.
	
	function reset() {
	  nodeThatClaimedTheSwipe = null;
	}
	
	function calculateCurrentX(anchor, touches) {
	  return anchor === 'right' ? document.body.offsetWidth - touches[0].pageX : touches[0].pageX;
	}
	
	function calculateCurrentY(anchor, touches) {
	  return anchor === 'bottom' ? window.innerHeight - touches[0].clientY : touches[0].clientY;
	}
	
	function getMaxTranslate(horizontalSwipe, paperInstance) {
	  return horizontalSwipe ? paperInstance.clientWidth : paperInstance.clientHeight;
	}
	
	function getTranslate(currentTranslate, startLocation, open, maxTranslate) {
	  return Math.min(Math.max(open ? startLocation - currentTranslate : maxTranslate + startLocation - currentTranslate, 0), maxTranslate);
	}
	
	function getDomTreeShapes(element, rootNode) {
	  // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L129
	  var domTreeShapes = [];
	
	  while (element && element !== rootNode) {
	    var style = window.getComputedStyle(element);
	
	    if ( // Ignore the scroll children if the element is absolute positioned.
	    style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
	    style.getPropertyValue('overflow-x') === 'hidden') {
	      domTreeShapes = [];
	    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
	      // Ignore the nodes that have no width.
	      // Keep elements with a scroll
	      domTreeShapes.push(element);
	    }
	
	    element = element.parentElement;
	  }
	
	  return domTreeShapes;
	}
	
	function findNativeHandler(_ref) {
	  var domTreeShapes = _ref.domTreeShapes,
	      start = _ref.start,
	      current = _ref.current,
	      anchor = _ref.anchor;
	  // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L175
	  var axisProperties = {
	    scrollPosition: {
	      x: 'scrollLeft',
	      y: 'scrollTop'
	    },
	    scrollLength: {
	      x: 'scrollWidth',
	      y: 'scrollHeight'
	    },
	    clientLength: {
	      x: 'clientWidth',
	      y: 'clientHeight'
	    }
	  };
	  return domTreeShapes.some(function (shape) {
	    // Determine if we are going backward or forward.
	    var goingForward = current >= start;
	
	    if (anchor === 'top' || anchor === 'left') {
	      goingForward = !goingForward;
	    }
	
	    var axis = anchor === 'left' || anchor === 'right' ? 'x' : 'y';
	    var scrollPosition = shape[axisProperties.scrollPosition[axis]];
	    var areNotAtStart = scrollPosition > 0;
	    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];
	
	    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
	      return shape;
	    }
	
	    return null;
	  });
	}
	
	var iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
	var transitionDurationDefault = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	var SwipeableDrawer = /*#__PURE__*/React.forwardRef(function SwipeableDrawer(inProps, ref) {
	  var theme = (0, _useTheme.default)();
	  var props = (0, _styles.getThemeProps)({
	    name: 'MuiSwipeableDrawer',
	    props: (0, _extends2.default)({}, inProps),
	    theme: theme
	  });
	  var _props$anchor = props.anchor,
	      anchor = _props$anchor === void 0 ? 'left' : _props$anchor,
	      _props$disableBackdro = props.disableBackdropTransition,
	      disableBackdropTransition = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
	      _props$disableDiscove = props.disableDiscovery,
	      disableDiscovery = _props$disableDiscove === void 0 ? false : _props$disableDiscove,
	      _props$disableSwipeTo = props.disableSwipeToOpen,
	      disableSwipeToOpen = _props$disableSwipeTo === void 0 ? iOS : _props$disableSwipeTo,
	      hideBackdrop = props.hideBackdrop,
	      _props$hysteresis = props.hysteresis,
	      hysteresis = _props$hysteresis === void 0 ? 0.52 : _props$hysteresis,
	      _props$minFlingVeloci = props.minFlingVelocity,
	      minFlingVelocity = _props$minFlingVeloci === void 0 ? 450 : _props$minFlingVeloci,
	      _props$ModalProps = props.ModalProps;
	  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
	  var BackdropProps = _props$ModalProps.BackdropProps,
	      ModalPropsProp = (0, _objectWithoutProperties2.default)(_props$ModalProps, ["BackdropProps"]),
	      onClose = props.onClose,
	      onOpen = props.onOpen,
	      open = props.open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      SwipeAreaProps = props.SwipeAreaProps,
	      _props$swipeAreaWidth = props.swipeAreaWidth,
	      swipeAreaWidth = _props$swipeAreaWidth === void 0 ? 20 : _props$swipeAreaWidth,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? transitionDurationDefault : _props$transitionDura,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'temporary' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchor", "disableBackdropTransition", "disableDiscovery", "disableSwipeToOpen", "hideBackdrop", "hysteresis", "minFlingVelocity", "ModalProps", "onClose", "onOpen", "open", "PaperProps", "SwipeAreaProps", "swipeAreaWidth", "transitionDuration", "variant"]);
	
	  var _React$useState = React.useState(false),
	      maybeSwiping = _React$useState[0],
	      setMaybeSwiping = _React$useState[1];
	
	  var swipeInstance = React.useRef({
	    isSwiping: null
	  });
	  var swipeAreaRef = React.useRef();
	  var backdropRef = React.useRef();
	  var paperRef = React.useRef();
	  var touchDetected = React.useRef(false); // Ref for transition duration based on / to match swipe speed
	
	  var calculatedDurationRef = React.useRef(); // Use a ref so the open value used is always up to date inside useCallback.
	
	  useEnhancedEffect(function () {
	    calculatedDurationRef.current = null;
	  }, [open]);
	  var setPosition = React.useCallback(function (translate) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$mode = options.mode,
	        mode = _options$mode === void 0 ? null : _options$mode,
	        _options$changeTransi = options.changeTransition,
	        changeTransition = _options$changeTransi === void 0 ? true : _options$changeTransi;
	    var anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
	    var rtlTranslateMultiplier = ['right', 'bottom'].indexOf(anchorRtl) !== -1 ? 1 : -1;
	    var horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
	    var transform = horizontalSwipe ? "translate(".concat(rtlTranslateMultiplier * translate, "px, 0)") : "translate(0, ".concat(rtlTranslateMultiplier * translate, "px)");
	    var drawerStyle = paperRef.current.style;
	    drawerStyle.webkitTransform = transform;
	    drawerStyle.transform = transform;
	    var transition = '';
	
	    if (mode) {
	      transition = theme.transitions.create('all', (0, _utils2.getTransitionProps)({
	        timeout: transitionDuration
	      }, {
	        mode: mode
	      }));
	    }
	
	    if (changeTransition) {
	      drawerStyle.webkitTransition = transition;
	      drawerStyle.transition = transition;
	    }
	
	    if (!disableBackdropTransition && !hideBackdrop) {
	      var backdropStyle = backdropRef.current.style;
	      backdropStyle.opacity = 1 - translate / getMaxTranslate(horizontalSwipe, paperRef.current);
	
	      if (changeTransition) {
	        backdropStyle.webkitTransition = transition;
	        backdropStyle.transition = transition;
	      }
	    }
	  }, [anchor, disableBackdropTransition, hideBackdrop, theme, transitionDuration]);
	  var handleBodyTouchEnd = (0, _useEventCallback.default)(function (event) {
	    if (!touchDetected.current) {
	      return;
	    }
	
	    nodeThatClaimedTheSwipe = null;
	    touchDetected.current = false;
	    setMaybeSwiping(false); // The swipe wasn't started.
	
	    if (!swipeInstance.current.isSwiping) {
	      swipeInstance.current.isSwiping = null;
	      return;
	    }
	
	    swipeInstance.current.isSwiping = null;
	    var anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
	    var horizontal = (0, _Drawer.isHorizontal)(anchor);
	    var current;
	
	    if (horizontal) {
	      current = calculateCurrentX(anchorRtl, event.changedTouches);
	    } else {
	      current = calculateCurrentY(anchorRtl, event.changedTouches);
	    }
	
	    var startLocation = horizontal ? swipeInstance.current.startX : swipeInstance.current.startY;
	    var maxTranslate = getMaxTranslate(horizontal, paperRef.current);
	    var currentTranslate = getTranslate(current, startLocation, open, maxTranslate);
	    var translateRatio = currentTranslate / maxTranslate;
	
	    if (Math.abs(swipeInstance.current.velocity) > minFlingVelocity) {
	      // Calculate transition duration to match swipe speed
	      calculatedDurationRef.current = Math.abs((maxTranslate - currentTranslate) / swipeInstance.current.velocity) * 1000;
	    }
	
	    if (open) {
	      if (swipeInstance.current.velocity > minFlingVelocity || translateRatio > hysteresis) {
	        onClose();
	      } else {
	        // Reset the position, the swipe was aborted.
	        setPosition(0, {
	          mode: 'exit'
	        });
	      }
	
	      return;
	    }
	
	    if (swipeInstance.current.velocity < -minFlingVelocity || 1 - translateRatio > hysteresis) {
	      onOpen();
	    } else {
	      // Reset the position, the swipe was aborted.
	      setPosition(getMaxTranslate(horizontal, paperRef.current), {
	        mode: 'enter'
	      });
	    }
	  });
	  var handleBodyTouchMove = (0, _useEventCallback.default)(function (event) {
	    // the ref may be null when a parent component updates while swiping
	    if (!paperRef.current || !touchDetected.current) {
	      return;
	    } // We are not supposed to handle this touch move because the swipe was started in a scrollable container in the drawer
	
	
	    if (nodeThatClaimedTheSwipe != null && nodeThatClaimedTheSwipe !== swipeInstance.current) {
	      return;
	    }
	
	    var anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
	    var horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
	    var currentX = calculateCurrentX(anchorRtl, event.touches);
	    var currentY = calculateCurrentY(anchorRtl, event.touches);
	
	    if (open && paperRef.current.contains(event.target) && nodeThatClaimedTheSwipe == null) {
	      var domTreeShapes = getDomTreeShapes(event.target, paperRef.current);
	      var nativeHandler = findNativeHandler({
	        domTreeShapes: domTreeShapes,
	        start: horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY,
	        current: horizontalSwipe ? currentX : currentY,
	        anchor: anchor
	      });
	
	      if (nativeHandler) {
	        nodeThatClaimedTheSwipe = nativeHandler;
	        return;
	      }
	
	      nodeThatClaimedTheSwipe = swipeInstance.current;
	    } // We don't know yet.
	
	
	    if (swipeInstance.current.isSwiping == null) {
	      var dx = Math.abs(currentX - swipeInstance.current.startX);
	      var dy = Math.abs(currentY - swipeInstance.current.startY); // We are likely to be swiping, let's prevent the scroll event on iOS.
	
	      if (dx > dy) {
	        if (event.cancelable) {
	          event.preventDefault();
	        }
	      }
	
	      var definitelySwiping = horizontalSwipe ? dx > dy && dx > UNCERTAINTY_THRESHOLD : dy > dx && dy > UNCERTAINTY_THRESHOLD;
	
	      if (definitelySwiping === true || (horizontalSwipe ? dy > UNCERTAINTY_THRESHOLD : dx > UNCERTAINTY_THRESHOLD)) {
	        swipeInstance.current.isSwiping = definitelySwiping;
	
	        if (!definitelySwiping) {
	          handleBodyTouchEnd(event);
	          return;
	        } // Shift the starting point.
	
	
	        swipeInstance.current.startX = currentX;
	        swipeInstance.current.startY = currentY; // Compensate for the part of the drawer displayed on touch start.
	
	        if (!disableDiscovery && !open) {
	          if (horizontalSwipe) {
	            swipeInstance.current.startX -= swipeAreaWidth;
	          } else {
	            swipeInstance.current.startY -= swipeAreaWidth;
	          }
	        }
	      }
	    }
	
	    if (!swipeInstance.current.isSwiping) {
	      return;
	    }
	
	    var maxTranslate = getMaxTranslate(horizontalSwipe, paperRef.current);
	    var startLocation = horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY;
	
	    if (open && !swipeInstance.current.paperHit) {
	      startLocation = Math.min(startLocation, maxTranslate);
	    }
	
	    var translate = getTranslate(horizontalSwipe ? currentX : currentY, startLocation, open, maxTranslate);
	
	    if (open) {
	      if (!swipeInstance.current.paperHit) {
	        var paperHit = horizontalSwipe ? currentX < maxTranslate : currentY < maxTranslate;
	
	        if (paperHit) {
	          swipeInstance.current.paperHit = true;
	          swipeInstance.current.startX = currentX;
	          swipeInstance.current.startY = currentY;
	        } else {
	          return;
	        }
	      } else if (translate === 0) {
	        swipeInstance.current.startX = currentX;
	        swipeInstance.current.startY = currentY;
	      }
	    }
	
	    if (swipeInstance.current.lastTranslate === null) {
	      swipeInstance.current.lastTranslate = translate;
	      swipeInstance.current.lastTime = performance.now() + 1;
	    }
	
	    var velocity = (translate - swipeInstance.current.lastTranslate) / (performance.now() - swipeInstance.current.lastTime) * 1e3; // Low Pass filter.
	
	    swipeInstance.current.velocity = swipeInstance.current.velocity * 0.4 + velocity * 0.6;
	    swipeInstance.current.lastTranslate = translate;
	    swipeInstance.current.lastTime = performance.now(); // We are swiping, let's prevent the scroll event on iOS.
	
	    if (event.cancelable) {
	      event.preventDefault();
	    }
	
	    setPosition(translate);
	  });
	  var handleBodyTouchStart = (0, _useEventCallback.default)(function (event) {
	    // We are not supposed to handle this touch move.
	    // Example of use case: ignore the event if there is a Slider.
	    if (event.defaultPrevented) {
	      return;
	    } // We can only have one node at the time claiming ownership for handling the swipe.
	
	
	    if (event.muiHandled) {
	      return;
	    } // At least one element clogs the drawer interaction zone.
	
	
	    if (open && !backdropRef.current.contains(event.target) && !paperRef.current.contains(event.target)) {
	      return;
	    }
	
	    var anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
	    var horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
	    var currentX = calculateCurrentX(anchorRtl, event.touches);
	    var currentY = calculateCurrentY(anchorRtl, event.touches);
	
	    if (!open) {
	      if (disableSwipeToOpen || event.target !== swipeAreaRef.current) {
	        return;
	      }
	
	      if (horizontalSwipe) {
	        if (currentX > swipeAreaWidth) {
	          return;
	        }
	      } else if (currentY > swipeAreaWidth) {
	        return;
	      }
	    }
	
	    event.muiHandled = true;
	    nodeThatClaimedTheSwipe = null;
	    swipeInstance.current.startX = currentX;
	    swipeInstance.current.startY = currentY;
	    setMaybeSwiping(true);
	
	    if (!open && paperRef.current) {
	      // The ref may be null when a parent component updates while swiping.
	      setPosition(getMaxTranslate(horizontalSwipe, paperRef.current) + (disableDiscovery ? 20 : -swipeAreaWidth), {
	        changeTransition: false
	      });
	    }
	
	    swipeInstance.current.velocity = 0;
	    swipeInstance.current.lastTime = null;
	    swipeInstance.current.lastTranslate = null;
	    swipeInstance.current.paperHit = false;
	    touchDetected.current = true;
	  });
	  React.useEffect(function () {
	    if (variant === 'temporary') {
	      var doc = (0, _ownerDocument.default)(paperRef.current);
	      doc.addEventListener('touchstart', handleBodyTouchStart);
	      doc.addEventListener('touchmove', handleBodyTouchMove, {
	        passive: false
	      });
	      doc.addEventListener('touchend', handleBodyTouchEnd);
	      return function () {
	        doc.removeEventListener('touchstart', handleBodyTouchStart);
	        doc.removeEventListener('touchmove', handleBodyTouchMove, {
	          passive: false
	        });
	        doc.removeEventListener('touchend', handleBodyTouchEnd);
	      };
	    }
	
	    return undefined;
	  }, [variant, handleBodyTouchStart, handleBodyTouchMove, handleBodyTouchEnd]);
	  React.useEffect(function () {
	    return function () {
	      // We need to release the lock.
	      if (nodeThatClaimedTheSwipe === swipeInstance.current) {
	        nodeThatClaimedTheSwipe = null;
	      }
	    };
	  }, []);
	  React.useEffect(function () {
	    if (!open) {
	      setMaybeSwiping(false);
	    }
	  }, [open]);
	  var handleBackdropRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    backdropRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Drawer.default, (0, _extends2.default)({
	    open: variant === 'temporary' && maybeSwiping ? true : open,
	    variant: variant,
	    ModalProps: (0, _extends2.default)({
	      BackdropProps: (0, _extends2.default)({}, BackdropProps, {
	        ref: handleBackdropRef
	      })
	    }, ModalPropsProp),
	    PaperProps: (0, _extends2.default)({}, PaperProps, {
	      style: (0, _extends2.default)({
	        pointerEvents: variant === 'temporary' && !open ? 'none' : ''
	      }, PaperProps.style),
	      ref: paperRef
	    }),
	    anchor: anchor,
	    transitionDuration: calculatedDurationRef.current || transitionDuration,
	    onClose: onClose,
	    ref: ref
	  }, other)), !disableSwipeToOpen && variant === 'temporary' && /*#__PURE__*/React.createElement(_NoSsr.default, null, /*#__PURE__*/React.createElement(_SwipeArea.default, (0, _extends2.default)({
	    anchor: anchor,
	    ref: swipeAreaRef,
	    width: swipeAreaWidth
	  }, SwipeAreaProps))));
	});
	 false ? SwipeableDrawer.propTypes = {
	  /**
	   * @ignore
	   */
	  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Disable the backdrop transition.
	   * This can improve the FPS on low-end devices.
	   */
	  disableBackdropTransition: _propTypes.default.bool,
	
	  /**
	   * If `true`, touching the screen near the edge of the drawer will not slide in the drawer a bit
	   * to promote accidental discovery of the swipe gesture.
	   */
	  disableDiscovery: _propTypes.default.bool,
	
	  /**
	   * If `true`, swipe to open is disabled. This is useful in browsers where swiping triggers
	   * navigation actions. Swipe to open is disabled on iOS browsers by default.
	   */
	  disableSwipeToOpen: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  hideBackdrop: _propTypes.default.bool,
	
	  /**
	   * Affects how far the drawer must be opened/closed to change his state.
	   * Specified as percent (0-1) of the width of the drawer
	   */
	  hysteresis: _propTypes.default.number,
	
	  /**
	   * Defines, from which (average) velocity on, the swipe is
	   * defined as complete although hysteresis isn't reached.
	   * Good threshold is between 250 - 1000 px/s
	   */
	  minFlingVelocity: _propTypes.default.number,
	
	  /**
	   * @ignore
	   */
	  ModalProps: _propTypes.default.shape({
	    BackdropProps: _propTypes.default.shape({
	      component: _utils.elementTypeAcceptingRef
	    })
	  }),
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func.isRequired,
	
	  /**
	   * Callback fired when the component requests to be opened.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func.isRequired,
	
	  /**
	   * If `true`, the drawer is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * @ignore
	   */
	  PaperProps: _propTypes.default.shape({
	    component: _utils.elementTypeAcceptingRef,
	    style: _propTypes.default.object
	  }),
	
	  /**
	   * The element is used to intercept the touch events on the edge.
	   */
	  SwipeAreaProps: _propTypes.default.object,
	
	  /**
	   * The width of the left most (or right most) area in pixels where the
	   * drawer can be swiped open from.
	   */
	  swipeAreaWidth: _propTypes.default.number,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * @ignore
	   */
	  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
	} : void 0;
	var _default = SwipeableDrawer;
	exports.default = _default;

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SwipeableDrawer.default;
	  }
	});
	
	var _SwipeableDrawer = _interopRequireDefault(__webpack_require__(963));

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _colorManipulator = __webpack_require__(49);
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _SwitchBase = _interopRequireDefault(__webpack_require__(238));
	
	// @inheritedComponent IconButton
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-flex',
	      width: 34 + 12 * 2,
	      height: 14 + 12 * 2,
	      overflow: 'hidden',
	      padding: 12,
	      boxSizing: 'border-box',
	      position: 'relative',
	      flexShrink: 0,
	      zIndex: 0,
	      // Reset the stacking context.
	      verticalAlign: 'middle',
	      // For correct alignment with the text.
	      '@media print': {
	        colorAdjust: 'exact'
	      }
	    },
	
	    /* Styles applied to the root element if `edge="start"`. */
	    edgeStart: {
	      marginLeft: -8
	    },
	
	    /* Styles applied to the root element if `edge="end"`. */
	    edgeEnd: {
	      marginRight: -8
	    },
	
	    /* Styles applied to the internal `SwitchBase` component's `root` class. */
	    switchBase: {
	      position: 'absolute',
	      top: 0,
	      left: 0,
	      zIndex: 1,
	      // Render above the focus ripple.
	      color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
	      transition: theme.transitions.create(['left', 'transform'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&$checked': {
	        transform: 'translateX(20px)'
	      },
	      '&$disabled': {
	        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
	      },
	      '&$checked + $track': {
	        opacity: 0.5
	      },
	      '&$disabled + $track': {
	        opacity: theme.palette.type === 'light' ? 0.12 : 0.1
	      }
	    },
	
	    /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */
	    colorPrimary: {
	      '&$checked': {
	        color: theme.palette.primary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
	      },
	      '&$checked + $track': {
	        backgroundColor: theme.palette.primary.main
	      },
	      '&$disabled + $track': {
	        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
	      }
	    },
	
	    /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */
	    colorSecondary: {
	      '&$checked': {
	        color: theme.palette.secondary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
	      },
	      '&$checked + $track': {
	        backgroundColor: theme.palette.secondary.main
	      },
	      '&$disabled + $track': {
	        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
	      }
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      width: 40,
	      height: 24,
	      padding: 7,
	      '& $thumb': {
	        width: 16,
	        height: 16
	      },
	      '& $switchBase': {
	        padding: 4,
	        '&$checked': {
	          transform: 'translateX(16px)'
	        }
	      }
	    },
	
	    /* Pseudo-class applied to the internal `SwitchBase` component's `checked` class. */
	    checked: {},
	
	    /* Pseudo-class applied to the internal SwitchBase component's disabled class. */
	    disabled: {},
	
	    /* Styles applied to the internal SwitchBase component's input element. */
	    input: {
	      left: '-100%',
	      width: '300%'
	    },
	
	    /* Styles used to create the thumb passed to the internal `SwitchBase` component `icon` prop. */
	    thumb: {
	      boxShadow: theme.shadows[1],
	      backgroundColor: 'currentColor',
	      width: 20,
	      height: 20,
	      borderRadius: '50%'
	    },
	
	    /* Styles applied to the track element. */
	    track: {
	      height: '100%',
	      width: '100%',
	      borderRadius: 14 / 2,
	      zIndex: -1,
	      transition: theme.transitions.create(['opacity', 'background-color'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
	      opacity: theme.palette.type === 'light' ? 0.38 : 0.3
	    }
	  };
	};
	
	exports.styles = styles;
	var Switch = /*#__PURE__*/React.forwardRef(function Switch(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'secondary' : _props$color,
	      _props$edge = props.edge,
	      edge = _props$edge === void 0 ? false : _props$edge,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "edge", "size"]);
	  var icon = /*#__PURE__*/React.createElement("span", {
	    className: classes.thumb
	  });
	  return /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.root, className, {
	      'start': classes.edgeStart,
	      'end': classes.edgeEnd
	    }[edge], size === "small" && classes["size".concat((0, _capitalize.default)(size))])
	  }, /*#__PURE__*/React.createElement(_SwitchBase.default, (0, _extends2.default)({
	    type: "checkbox",
	    icon: icon,
	    checkedIcon: icon,
	    classes: {
	      root: (0, _clsx.default)(classes.switchBase, classes["color".concat((0, _capitalize.default)(color))]),
	      input: classes.input,
	      checked: classes.checked,
	      disabled: classes.disabled
	    },
	    ref: ref
	  }, other)), /*#__PURE__*/React.createElement("span", {
	    className: classes.track
	  }));
	});
	 false ? Switch.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'secondary']),
	
	  /**
	   * @ignore
	   */
	  defaultChecked: _propTypes.default.bool,
	
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If given, uses a negative margin to counteract the padding on one
	   * side (this is often helpful for aligning the left or right
	   * side of the icon with content above or below, without ruining the border
	   * size and shape).
	   */
	  edge: _propTypes.default.oneOf(['end', 'start', false]),
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The size of the switch.
	   * `small` is equivalent to the dense switch styling.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The value of the component. The DOM API casts this to a string.
	   * The browser uses "on" as the default value.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSwitch'
	})(Switch);
	
	exports.default = _default;

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Switch.default;
	  }
	});
	
	var _Switch = _interopRequireDefault(__webpack_require__(965));

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(56));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(170));
	
	var styles = function styles(theme) {
	  var _extends2;
	
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends3.default)({}, theme.typography.button, (_extends2 = {
	      maxWidth: 264,
	      minWidth: 72,
	      position: 'relative',
	      boxSizing: 'border-box',
	      minHeight: 48,
	      flexShrink: 0,
	      padding: '6px 12px'
	    }, (0, _defineProperty2.default)(_extends2, theme.breakpoints.up('sm'), {
	      padding: '6px 24px'
	    }), (0, _defineProperty2.default)(_extends2, "overflow", 'hidden'), (0, _defineProperty2.default)(_extends2, "whiteSpace", 'normal'), (0, _defineProperty2.default)(_extends2, "textAlign", 'center'), (0, _defineProperty2.default)(_extends2, theme.breakpoints.up('sm'), {
	      minWidth: 160
	    }), _extends2)),
	
	    /* Styles applied to the root element if both `icon` and `label` are provided. */
	    labelIcon: {
	      minHeight: 72,
	      paddingTop: 9,
	      '& $wrapper > *:first-child': {
	        marginBottom: 6
	      }
	    },
	
	    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="inherit"`. */
	    textColorInherit: {
	      color: 'inherit',
	      opacity: 0.7,
	      '&$selected': {
	        opacity: 1
	      },
	      '&$disabled': {
	        opacity: 0.5
	      }
	    },
	
	    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="primary"`. */
	    textColorPrimary: {
	      color: theme.palette.text.secondary,
	      '&$selected': {
	        color: theme.palette.primary.main
	      },
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      }
	    },
	
	    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="secondary"`. */
	    textColorSecondary: {
	      color: theme.palette.text.secondary,
	      '&$selected': {
	        color: theme.palette.secondary.main
	      },
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `selected={true}` (controlled by the Tabs component). */
	    selected: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}` (controlled by the Tabs component). */
	    disabled: {},
	
	    /* Styles applied to the root element if `fullWidth={true}` (controlled by the Tabs component). */
	    fullWidth: {
	      flexShrink: 1,
	      flexGrow: 1,
	      flexBasis: 0,
	      maxWidth: 'none'
	    },
	
	    /* Styles applied to the root element if `wrapped={true}`. */
	    wrapped: {
	      fontSize: theme.typography.pxToRem(12),
	      lineHeight: 1.5
	    },
	
	    /* Styles applied to the `icon` and `label`'s wrapper element. */
	    wrapper: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      width: '100%',
	      flexDirection: 'column'
	    }
	  };
	};
	
	exports.styles = styles;
	var Tab = /*#__PURE__*/React.forwardRef(function Tab(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      fullWidth = props.fullWidth,
	      icon = props.icon,
	      indicator = props.indicator,
	      label = props.label,
	      onChange = props.onChange,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      selected = props.selected,
	      selectionFollowsFocus = props.selectionFollowsFocus,
	      _props$textColor = props.textColor,
	      textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor,
	      value = props.value,
	      _props$wrapped = props.wrapped,
	      wrapped = _props$wrapped === void 0 ? false : _props$wrapped,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disabled", "disableFocusRipple", "fullWidth", "icon", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"]);
	
	  var handleClick = function handleClick(event) {
	    if (onChange) {
	      onChange(event, value);
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  var handleFocus = function handleFocus(event) {
	    if (selectionFollowsFocus && !selected && onChange) {
	      onChange(event, value);
	    }
	
	    if (onFocus) {
	      onFocus(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends3.default)({
	    focusRipple: !disableFocusRipple,
	    className: (0, _clsx.default)(classes.root, classes["textColor".concat((0, _capitalize.default)(textColor))], className, disabled && classes.disabled, selected && classes.selected, label && icon && classes.labelIcon, fullWidth && classes.fullWidth, wrapped && classes.wrapped),
	    ref: ref,
	    role: "tab",
	    "aria-selected": selected,
	    disabled: disabled,
	    onClick: handleClick,
	    onFocus: handleFocus,
	    tabIndex: selected ? 0 : -1
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.wrapper
	  }, icon, label), indicator);
	});
	 false ? Tab.propTypes = {
	  /**
	   * This prop isn't supported.
	   * Use the `component` prop if you need to change the children structure.
	   */
	  children: _unsupportedProp.default,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the tab will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The icon element.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   * For server-side rendering consideration, we let the selected tab
	   * render the indicator.
	   */
	  indicator: _propTypes.default.node,
	
	  /**
	   * The label element.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  selected: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  selectionFollowsFocus: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  textColor: _propTypes.default.oneOf(['secondary', 'primary', 'inherit']),
	
	  /**
	   * You can provide your own value. Otherwise, we fallback to the child position index.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * Tab labels appear in a single row.
	   * They can use a second line if needed.
	   */
	  wrapped: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTab'
	})(Tab);
	
	exports.default = _default;

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Tab.default;
	  }
	});
	
	var _Tab = _interopRequireDefault(__webpack_require__(967));

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _KeyboardArrowLeft = _interopRequireDefault(__webpack_require__(390));
	
	var _KeyboardArrowRight = _interopRequireDefault(__webpack_require__(391));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(56));
	
	/* eslint-disable jsx-a11y/aria-role */
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    width: 40,
	    flexShrink: 0,
	    opacity: 0.8,
	    '&$disabled': {
	      opacity: 0
	    }
	  },
	
	  /* Styles applied to the root element if `orientation="vertical"`. */
	  vertical: {
	    width: '100%',
	    height: 40,
	    '& svg': {
	      transform: 'rotate(90deg)'
	    }
	  },
	
	  /* Pseudo-class applied to the root element if `disabled={true}`. */
	  disabled: {}
	};
	exports.styles = styles;
	
	var _ref = /*#__PURE__*/React.createElement(_KeyboardArrowLeft.default, {
	  fontSize: "small"
	});
	
	var _ref2 = /*#__PURE__*/React.createElement(_KeyboardArrowRight.default, {
	  fontSize: "small"
	});
	
	var TabScrollButton = /*#__PURE__*/React.forwardRef(function TabScrollButton(props, ref) {
	  var classes = props.classes,
	      classNameProp = props.className,
	      direction = props.direction,
	      orientation = props.orientation,
	      disabled = props.disabled,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "direction", "orientation", "disabled"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    component: "div",
	    className: (0, _clsx.default)(classes.root, classNameProp, disabled && classes.disabled, orientation === 'vertical' && classes.vertical),
	    ref: ref,
	    role: null,
	    tabIndex: null
	  }, other), direction === 'left' ? _ref : _ref2);
	});
	 false ? TabScrollButton.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Which direction should the button indicate?
	   */
	  direction: _propTypes.default.oneOf(['left', 'right']).isRequired,
	
	  /**
	   * If `true`, the element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * The tabs orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']).isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTabScrollButton'
	})(TabScrollButton);
	
	exports.default = _default;

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _TableContext = _interopRequireDefault(__webpack_require__(376));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'table',
	      width: '100%',
	      borderCollapse: 'collapse',
	      borderSpacing: 0,
	      '& caption': (0, _extends2.default)({}, theme.typography.body2, {
	        padding: theme.spacing(2),
	        color: theme.palette.text.secondary,
	        textAlign: 'left',
	        captionSide: 'bottom'
	      })
	    },
	
	    /* Styles applied to the root element if `stickyHeader={true}`. */
	    stickyHeader: {
	      borderCollapse: 'separate'
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultComponent = 'table';
	var Table = /*#__PURE__*/React.forwardRef(function Table(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? defaultComponent : _props$component,
	      _props$padding = props.padding,
	      padding = _props$padding === void 0 ? 'default' : _props$padding,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      _props$stickyHeader = props.stickyHeader,
	      stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "padding", "size", "stickyHeader"]);
	  var table = React.useMemo(function () {
	    return {
	      padding: padding,
	      size: size,
	      stickyHeader: stickyHeader
	    };
	  }, [padding, size, stickyHeader]);
	  return /*#__PURE__*/React.createElement(_TableContext.default.Provider, {
	    value: table
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    role: Component === defaultComponent ? null : 'table',
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className, stickyHeader && classes.stickyHeader)
	  }, other)));
	});
	 false ? Table.propTypes = {
	  /**
	   * The content of the table, normally `TableHead` and `TableBody`.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Allows TableCells to inherit padding of the Table.
	   */
	  padding: _propTypes.default.oneOf(['default', 'checkbox', 'none']),
	
	  /**
	   * Allows TableCells to inherit size of the Table.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium']),
	
	  /**
	   * Set the header sticky.
	   *
	   * ⚠️ It doesn't work with IE 11.
	   */
	  stickyHeader: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTable'
	})(Table);
	
	exports.default = _default;

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Table.default;
	  }
	});
	
	var _Table = _interopRequireDefault(__webpack_require__(970));

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(128));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'table-row-group'
	  }
	};
	exports.styles = styles;
	var tablelvl2 = {
	  variant: 'body'
	};
	var defaultComponent = 'tbody';
	var TableBody = /*#__PURE__*/React.forwardRef(function TableBody(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? defaultComponent : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return /*#__PURE__*/React.createElement(_Tablelvl2Context.default.Provider, {
	    value: tablelvl2
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref,
	    role: Component === defaultComponent ? null : 'rowgroup'
	  }, other)));
	});
	 false ? TableBody.propTypes = {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableBody'
	})(TableBody);
	
	exports.default = _default;

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableBody.default;
	  }
	});
	
	var _TableBody = _interopRequireDefault(__webpack_require__(972));

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _colorManipulator = __webpack_require__(49);
	
	var _TableContext = _interopRequireDefault(__webpack_require__(376));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(128));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.body2, {
	      display: 'table-cell',
	      verticalAlign: 'inherit',
	      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
	      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
	      borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? (0, _colorManipulator.lighten)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.88) : (0, _colorManipulator.darken)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.68)),
	      textAlign: 'left',
	      padding: 16
	    }),
	
	    /* Styles applied to the root element if `variant="head"` or `context.table.head`. */
	    head: {
	      color: theme.palette.text.primary,
	      lineHeight: theme.typography.pxToRem(24),
	      fontWeight: theme.typography.fontWeightMedium
	    },
	
	    /* Styles applied to the root element if `variant="body"` or `context.table.body`. */
	    body: {
	      color: theme.palette.text.primary
	    },
	
	    /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
	    footer: {
	      color: theme.palette.text.secondary,
	      lineHeight: theme.typography.pxToRem(21),
	      fontSize: theme.typography.pxToRem(12)
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      padding: '6px 24px 6px 16px',
	      '&:last-child': {
	        paddingRight: 16
	      },
	      '&$paddingCheckbox': {
	        width: 24,
	        // prevent the checkbox column from growing
	        padding: '0 12px 0 16px',
	        '&:last-child': {
	          paddingLeft: 12,
	          paddingRight: 16
	        },
	        '& > *': {
	          padding: 0
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `padding="checkbox"`. */
	    paddingCheckbox: {
	      width: 48,
	      // prevent the checkbox column from growing
	      padding: '0 0 0 4px',
	      '&:last-child': {
	        paddingLeft: 0,
	        paddingRight: 4
	      }
	    },
	
	    /* Styles applied to the root element if `padding="none"`. */
	    paddingNone: {
	      padding: 0,
	      '&:last-child': {
	        padding: 0
	      }
	    },
	
	    /* Styles applied to the root element if `align="left"`. */
	    alignLeft: {
	      textAlign: 'left'
	    },
	
	    /* Styles applied to the root element if `align="center"`. */
	    alignCenter: {
	      textAlign: 'center'
	    },
	
	    /* Styles applied to the root element if `align="right"`. */
	    alignRight: {
	      textAlign: 'right',
	      flexDirection: 'row-reverse'
	    },
	
	    /* Styles applied to the root element if `align="justify"`. */
	    alignJustify: {
	      textAlign: 'justify'
	    },
	
	    /* Styles applied to the root element if `context.table.stickyHeader={true}`. */
	    stickyHeader: {
	      position: 'sticky',
	      top: 0,
	      left: 0,
	      zIndex: 2,
	      backgroundColor: theme.palette.background.default
	    }
	  };
	};
	/**
	 * The component renders a `<th>` element when the parent context is a header
	 * or otherwise a `<td>` element.
	 */
	
	
	exports.styles = styles;
	var TableCell = /*#__PURE__*/React.forwardRef(function TableCell(props, ref) {
	  var _props$align = props.align,
	      align = _props$align === void 0 ? 'inherit' : _props$align,
	      classes = props.classes,
	      className = props.className,
	      component = props.component,
	      paddingProp = props.padding,
	      scopeProp = props.scope,
	      sizeProp = props.size,
	      sortDirection = props.sortDirection,
	      variantProp = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["align", "classes", "className", "component", "padding", "scope", "size", "sortDirection", "variant"]);
	  var table = React.useContext(_TableContext.default);
	  var tablelvl2 = React.useContext(_Tablelvl2Context.default);
	  var isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
	  var role;
	  var Component;
	
	  if (component) {
	    Component = component;
	    role = isHeadCell ? 'columnheader' : 'cell';
	  } else {
	    Component = isHeadCell ? 'th' : 'td';
	  }
	
	  var scope = scopeProp;
	
	  if (!scope && isHeadCell) {
	    scope = 'col';
	  }
	
	  var padding = paddingProp || (table && table.padding ? table.padding : 'default');
	  var size = sizeProp || (table && table.size ? table.size : 'medium');
	  var variant = variantProp || tablelvl2 && tablelvl2.variant;
	  var ariaSort = null;
	
	  if (sortDirection) {
	    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
	  }
	
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, classes[variant], className, align !== 'inherit' && classes["align".concat((0, _capitalize.default)(align))], padding !== 'default' && classes["padding".concat((0, _capitalize.default)(padding))], size !== 'medium' && classes["size".concat((0, _capitalize.default)(size))], variant === 'head' && table && table.stickyHeader && classes.stickyHeader),
	    "aria-sort": ariaSort,
	    role: role,
	    scope: scope
	  }, other));
	});
	 false ? TableCell.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Set the text-align on the table cell content.
	   *
	   * Monetary or generally number fields **should be right aligned** as that allows
	   * you to add them up quickly in your head without having to worry about decimals.
	   */
	  align: _propTypes.default.oneOf(['center', 'inherit', 'justify', 'left', 'right']),
	
	  /**
	   * The table cell contents.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Sets the padding applied to the cell.
	   * By default, the Table parent component set the value (`default`).
	   */
	  padding: _propTypes.default.oneOf(['checkbox', 'default', 'none']),
	
	  /**
	   * Set scope attribute.
	   */
	  scope: _propTypes.default.string,
	
	  /**
	   * Specify the size of the cell.
	   * By default, the Table parent component set the value (`medium`).
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * Set aria-sort direction.
	   */
	  sortDirection: _propTypes.default.oneOf(['asc', 'desc', false]),
	
	  /**
	   * Specify the cell type.
	   * By default, the TableHead, TableBody or TableFooter parent component set the value.
	   */
	  variant: _propTypes.default.oneOf(['body', 'footer', 'head'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableCell'
	})(TableCell);
	
	exports.default = _default;

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    width: '100%',
	    overflowX: 'auto'
	  }
	};
	exports.styles = styles;
	var TableContainer = /*#__PURE__*/React.forwardRef(function TableContainer(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className)
	  }, other));
	});
	 false ? TableContainer.propTypes = {
	  /**
	   * The table itself, normally `<Table />`
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableContainer'
	})(TableContainer);
	
	exports.default = _default;

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(128));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'table-footer-group'
	  }
	};
	exports.styles = styles;
	var tablelvl2 = {
	  variant: 'footer'
	};
	var defaultComponent = 'tfoot';
	var TableFooter = /*#__PURE__*/React.forwardRef(function TableFooter(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? defaultComponent : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return /*#__PURE__*/React.createElement(_Tablelvl2Context.default.Provider, {
	    value: tablelvl2
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref,
	    role: Component === defaultComponent ? null : 'rowgroup'
	  }, other)));
	});
	 false ? TableFooter.propTypes = {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableFooter'
	})(TableFooter);
	
	exports.default = _default;

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableFooter.default;
	  }
	});
	
	var _TableFooter = _interopRequireDefault(__webpack_require__(976));

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(128));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'table-header-group'
	  }
	};
	exports.styles = styles;
	var tablelvl2 = {
	  variant: 'head'
	};
	var defaultComponent = 'thead';
	var TableHead = /*#__PURE__*/React.forwardRef(function TableHead(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? defaultComponent : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return /*#__PURE__*/React.createElement(_Tablelvl2Context.default.Provider, {
	    value: tablelvl2
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref,
	    role: Component === defaultComponent ? null : 'rowgroup'
	  }, other)));
	});
	 false ? TableHead.propTypes = {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableHead'
	})(TableHead);
	
	exports.default = _default;

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableHead.default;
	  }
	});
	
	var _TableHead = _interopRequireDefault(__webpack_require__(978));

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _utils = __webpack_require__(22);
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _InputBase = _interopRequireDefault(__webpack_require__(126));
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(360));
	
	var _Select = _interopRequireDefault(__webpack_require__(237));
	
	var _TableCell = _interopRequireDefault(__webpack_require__(377));
	
	var _Toolbar = _interopRequireDefault(__webpack_require__(379));
	
	var _Typography = _interopRequireDefault(__webpack_require__(66));
	
	var _TablePaginationActions = _interopRequireDefault(__webpack_require__(981));
	
	var _unstable_useId = _interopRequireDefault(__webpack_require__(169));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: theme.palette.text.primary,
	      fontSize: theme.typography.pxToRem(14),
	      overflow: 'auto',
	      // Increase the specificity to override TableCell.
	      '&:last-child': {
	        padding: 0
	      }
	    },
	
	    /* Styles applied to the Toolbar component. */
	    toolbar: {
	      minHeight: 52,
	      paddingRight: 2
	    },
	
	    /* Styles applied to the spacer element. */
	    spacer: {
	      flex: '1 1 100%'
	    },
	
	    /* Styles applied to the caption Typography components if `variant="caption"`. */
	    caption: {
	      flexShrink: 0
	    },
	    // TODO v5: `.selectRoot` should be merged with `.input`
	
	    /* Styles applied to the Select component root element. */
	    selectRoot: {
	      marginRight: 32,
	      marginLeft: 8
	    },
	
	    /* Styles applied to the Select component `select` class. */
	    select: {
	      paddingLeft: 8,
	      paddingRight: 24,
	      textAlign: 'right',
	      textAlignLast: 'right' // Align <select> on Chrome.
	
	    },
	    // TODO v5: remove
	
	    /* Styles applied to the Select component `icon` class. */
	    selectIcon: {},
	
	    /* Styles applied to the `InputBase` component. */
	    input: {
	      color: 'inherit',
	      fontSize: 'inherit',
	      flexShrink: 0
	    },
	
	    /* Styles applied to the MenuItem component. */
	    menuItem: {},
	
	    /* Styles applied to the internal `TablePaginationActions` component. */
	    actions: {
	      flexShrink: 0,
	      marginLeft: 20
	    }
	  };
	};
	
	exports.styles = styles;
	
	var defaultLabelDisplayedRows = function defaultLabelDisplayedRows(_ref) {
	  var from = _ref.from,
	      to = _ref.to,
	      count = _ref.count;
	  return "".concat(from, "-").concat(to, " of ").concat(count !== -1 ? count : "more than ".concat(to));
	};
	
	var defaultRowsPerPageOptions = [10, 25, 50, 100];
	/**
	 * A `TableCell` based component for placing inside `TableFooter` for pagination.
	 */
	
	var TablePagination = /*#__PURE__*/React.forwardRef(function TablePagination(props, ref) {
	  var _props$ActionsCompone = props.ActionsComponent,
	      ActionsComponent = _props$ActionsCompone === void 0 ? _TablePaginationActions.default : _props$ActionsCompone,
	      backIconButtonProps = props.backIconButtonProps,
	      _props$backIconButton = props.backIconButtonText,
	      backIconButtonText = _props$backIconButton === void 0 ? 'Previous page' : _props$backIconButton,
	      classes = props.classes,
	      className = props.className,
	      colSpanProp = props.colSpan,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? _TableCell.default : _props$component,
	      count = props.count,
	      _props$labelDisplayed = props.labelDisplayedRows,
	      labelDisplayedRows = _props$labelDisplayed === void 0 ? defaultLabelDisplayedRows : _props$labelDisplayed,
	      _props$labelRowsPerPa = props.labelRowsPerPage,
	      labelRowsPerPage = _props$labelRowsPerPa === void 0 ? 'Rows per page:' : _props$labelRowsPerPa,
	      nextIconButtonProps = props.nextIconButtonProps,
	      _props$nextIconButton = props.nextIconButtonText,
	      nextIconButtonText = _props$nextIconButton === void 0 ? 'Next page' : _props$nextIconButton,
	      onChangePage = props.onChangePage,
	      onChangeRowsPerPage = props.onChangeRowsPerPage,
	      page = props.page,
	      rowsPerPage = props.rowsPerPage,
	      _props$rowsPerPageOpt = props.rowsPerPageOptions,
	      rowsPerPageOptions = _props$rowsPerPageOpt === void 0 ? defaultRowsPerPageOptions : _props$rowsPerPageOpt,
	      _props$SelectProps = props.SelectProps,
	      SelectProps = _props$SelectProps === void 0 ? {} : _props$SelectProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["ActionsComponent", "backIconButtonProps", "backIconButtonText", "classes", "className", "colSpan", "component", "count", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "nextIconButtonText", "onChangePage", "onChangeRowsPerPage", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps"]);
	  var colSpan;
	
	  if (Component === _TableCell.default || Component === 'td') {
	    colSpan = colSpanProp || 1000; // col-span over everything
	  }
	
	  var selectId = (0, _unstable_useId.default)();
	  var labelId = (0, _unstable_useId.default)();
	  var MenuItemComponent = SelectProps.native ? 'option' : _MenuItem.default;
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    colSpan: colSpan,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement(_Toolbar.default, {
	    className: classes.toolbar
	  }, /*#__PURE__*/React.createElement("div", {
	    className: classes.spacer
	  }), rowsPerPageOptions.length > 1 && /*#__PURE__*/React.createElement(_Typography.default, {
	    color: "inherit",
	    variant: "body2",
	    className: classes.caption,
	    id: labelId
	  }, labelRowsPerPage), rowsPerPageOptions.length > 1 && /*#__PURE__*/React.createElement(_Select.default, (0, _extends2.default)({
	    classes: {
	      select: classes.select,
	      icon: classes.selectIcon
	    },
	    input: /*#__PURE__*/React.createElement(_InputBase.default, {
	      className: (0, _clsx.default)(classes.input, classes.selectRoot)
	    }),
	    value: rowsPerPage,
	    onChange: onChangeRowsPerPage,
	    id: selectId,
	    labelId: labelId
	  }, SelectProps), rowsPerPageOptions.map(function (rowsPerPageOption) {
	    return /*#__PURE__*/React.createElement(MenuItemComponent, {
	      className: classes.menuItem,
	      key: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption,
	      value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
	    }, rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption);
	  })), /*#__PURE__*/React.createElement(_Typography.default, {
	    color: "inherit",
	    variant: "body2",
	    className: classes.caption
	  }, labelDisplayedRows({
	    from: count === 0 ? 0 : page * rowsPerPage + 1,
	    to: count !== -1 ? Math.min(count, (page + 1) * rowsPerPage) : (page + 1) * rowsPerPage,
	    count: count === -1 ? -1 : count,
	    page: page
	  })), /*#__PURE__*/React.createElement(ActionsComponent, {
	    className: classes.actions,
	    backIconButtonProps: (0, _extends2.default)({
	      title: backIconButtonText,
	      'aria-label': backIconButtonText
	    }, backIconButtonProps),
	    count: count,
	    nextIconButtonProps: (0, _extends2.default)({
	      title: nextIconButtonText,
	      'aria-label': nextIconButtonText
	    }, nextIconButtonProps),
	    onChangePage: onChangePage,
	    page: page,
	    rowsPerPage: rowsPerPage
	  })));
	});
	 false ? TablePagination.propTypes = {
	  /**
	   * The component used for displaying the actions.
	   * Either a string to use a HTML element or a component.
	   */
	  ActionsComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the back arrow [`IconButton`](/api/icon-button/) component.
	   */
	  backIconButtonProps: _propTypes.default.object,
	
	  /**
	   * Text label for the back arrow icon button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  backIconButtonText: _propTypes.default.string,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  colSpan: _propTypes.default.number,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * The total number of rows.
	   *
	   * To enable server side pagination for an unknown number of items, provide -1.
	   */
	  count: _propTypes.default.number.isRequired,
	
	  /**
	   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
	   * object.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  labelDisplayedRows: _propTypes.default.func,
	
	  /**
	   * Customize the rows per page label.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  labelRowsPerPage: _propTypes.default.node,
	
	  /**
	   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
	   */
	  nextIconButtonProps: _propTypes.default.object,
	
	  /**
	   * Text label for the next arrow icon button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  nextIconButtonText: _propTypes.default.string,
	
	  /**
	   * Callback fired when the page is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {number} page The page selected.
	   */
	  onChangePage: _propTypes.default.func.isRequired,
	
	  /**
	   * Callback fired when the number of rows per page is changed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onChangeRowsPerPage: _propTypes.default.func,
	
	  /**
	   * The zero-based index of the current page.
	   */
	  page: (0, _utils.chainPropTypes)(_propTypes.default.number.isRequired, function (props) {
	    var count = props.count,
	        page = props.page,
	        rowsPerPage = props.rowsPerPage;
	
	    if (count === -1) {
	      return null;
	    }
	
	    var newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
	
	    if (page < 0 || page > newLastPage) {
	      return new Error('Material-UI: The page prop of a TablePagination is out of range ' + "(0 to ".concat(newLastPage, ", but page is ").concat(page, ")."));
	    }
	
	    return null;
	  }),
	
	  /**
	   * The number of rows per page.
	   */
	  rowsPerPage: _propTypes.default.number.isRequired,
	
	  /**
	   * Customizes the options of the rows per page select field. If less than two options are
	   * available, no select field will be displayed.
	   */
	  rowsPerPageOptions: _propTypes.default.array,
	
	  /**
	   * Props applied to the rows per page [`Select`](/api/select/) element.
	   */
	  SelectProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTablePagination'
	})(TablePagination);
	
	exports.default = _default;

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _KeyboardArrowLeft = _interopRequireDefault(__webpack_require__(390));
	
	var _KeyboardArrowRight = _interopRequireDefault(__webpack_require__(391));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(47));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(125));
	
	var _ref = /*#__PURE__*/React.createElement(_KeyboardArrowRight.default, null);
	
	var _ref2 = /*#__PURE__*/React.createElement(_KeyboardArrowLeft.default, null);
	
	var _ref3 = /*#__PURE__*/React.createElement(_KeyboardArrowLeft.default, null);
	
	var _ref4 = /*#__PURE__*/React.createElement(_KeyboardArrowRight.default, null);
	
	/**
	 * @ignore - internal component.
	 */
	var TablePaginationActions = /*#__PURE__*/React.forwardRef(function TablePaginationActions(props, ref) {
	  var backIconButtonProps = props.backIconButtonProps,
	      count = props.count,
	      nextIconButtonProps = props.nextIconButtonProps,
	      onChangePage = props.onChangePage,
	      page = props.page,
	      rowsPerPage = props.rowsPerPage,
	      other = (0, _objectWithoutProperties2.default)(props, ["backIconButtonProps", "count", "nextIconButtonProps", "onChangePage", "page", "rowsPerPage"]);
	  var theme = (0, _useTheme.default)();
	
	  var handleBackButtonClick = function handleBackButtonClick(event) {
	    onChangePage(event, page - 1);
	  };
	
	  var handleNextButtonClick = function handleNextButtonClick(event) {
	    onChangePage(event, page + 1);
	  };
	
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({
	    onClick: handleBackButtonClick,
	    disabled: page === 0,
	    color: "inherit"
	  }, backIconButtonProps), theme.direction === 'rtl' ? _ref : _ref2), /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({
	    onClick: handleNextButtonClick,
	    disabled: count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false,
	    color: "inherit"
	  }, nextIconButtonProps), theme.direction === 'rtl' ? _ref3 : _ref4));
	});
	 false ? TablePaginationActions.propTypes = {
	  /**
	   * Props applied to the back arrow [`IconButton`](/api/icon-button/) element.
	   */
	  backIconButtonProps: _propTypes.default.object,
	
	  /**
	   * The total number of rows.
	   */
	  count: _propTypes.default.number.isRequired,
	
	  /**
	   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
	   */
	  nextIconButtonProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the page is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {number} page The page selected.
	   */
	  onChangePage: _propTypes.default.func.isRequired,
	
	  /**
	   * The zero-based index of the current page.
	   */
	  page: _propTypes.default.number.isRequired,
	
	  /**
	   * The number of rows per page.
	   */
	  rowsPerPage: _propTypes.default.number.isRequired
	} : void 0;
	var _default = TablePaginationActions;
	exports.default = _default;

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TablePagination.default;
	  }
	});
	
	var _TablePagination = _interopRequireDefault(__webpack_require__(980));

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(128));
	
	var _colorManipulator = __webpack_require__(49);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: 'inherit',
	      display: 'table-row',
	      verticalAlign: 'middle',
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 0,
	      '&$hover:hover': {
	        backgroundColor: theme.palette.action.hover
	      },
	      '&$selected, &$selected:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.selectedOpacity)
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `selected={true}`. */
	    selected: {},
	
	    /* Pseudo-class applied to the root element if `hover={true}`. */
	    hover: {},
	
	    /* Styles applied to the root element if table variant="head". */
	    head: {},
	
	    /* Styles applied to the root element if table variant="footer". */
	    footer: {}
	  };
	};
	
	exports.styles = styles;
	var defaultComponent = 'tr';
	/**
	 * Will automatically set dynamic row height
	 * based on the material table element parent (head, body, etc).
	 */
	
	var TableRow = /*#__PURE__*/React.forwardRef(function TableRow(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? defaultComponent : _props$component,
	      _props$hover = props.hover,
	      hover = _props$hover === void 0 ? false : _props$hover,
	      _props$selected = props.selected,
	      selected = _props$selected === void 0 ? false : _props$selected,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "hover", "selected"]);
	  var tablelvl2 = React.useContext(_Tablelvl2Context.default);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className, tablelvl2 && {
	      'head': classes.head,
	      'footer': classes.footer
	    }[tablelvl2.variant], hover && classes.hover, selected && classes.selected),
	    role: Component === defaultComponent ? null : 'row'
	  }, other));
	});
	 false ? TableRow.propTypes = {
	  /**
	   * Should be valid <tr> children such as `TableCell`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, the table row will shade on hover.
	   */
	  hover: _propTypes.default.bool,
	
	  /**
	   * If `true`, the table row will have the selected shading.
	   */
	  selected: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableRow'
	})(TableRow);
	
	exports.default = _default;

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableRow.default;
	  }
	});
	
	var _TableRow = _interopRequireDefault(__webpack_require__(983));

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _ArrowDownward = _interopRequireDefault(__webpack_require__(1015));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(56));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      cursor: 'pointer',
	      display: 'inline-flex',
	      justifyContent: 'flex-start',
	      flexDirection: 'inherit',
	      alignItems: 'center',
	      '&:focus': {
	        color: theme.palette.text.secondary
	      },
	      '&:hover': {
	        color: theme.palette.text.secondary,
	        '& $icon': {
	          opacity: 0.5
	        }
	      },
	      '&$active': {
	        color: theme.palette.text.primary,
	        // && instead of & is a workaround for https://github.com/cssinjs/jss/issues/1045
	        '&& $icon': {
	          opacity: 1,
	          color: theme.palette.text.secondary
	        }
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `active={true}`. */
	    active: {},
	
	    /* Styles applied to the icon component. */
	    icon: {
	      fontSize: 18,
	      marginRight: 4,
	      marginLeft: 4,
	      opacity: 0,
	      transition: theme.transitions.create(['opacity', 'transform'], {
	        duration: theme.transitions.duration.shorter
	      }),
	      userSelect: 'none'
	    },
	
	    /* Styles applied to the icon component if `direction="desc"`. */
	    iconDirectionDesc: {
	      transform: 'rotate(0deg)'
	    },
	
	    /* Styles applied to the icon component if `direction="asc"`. */
	    iconDirectionAsc: {
	      transform: 'rotate(180deg)'
	    }
	  };
	};
	/**
	 * A button based label for placing inside `TableCell` for column sorting.
	 */
	
	
	exports.styles = styles;
	var TableSortLabel = /*#__PURE__*/React.forwardRef(function TableSortLabel(props, ref) {
	  var _props$active = props.active,
	      active = _props$active === void 0 ? false : _props$active,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$direction = props.direction,
	      direction = _props$direction === void 0 ? 'asc' : _props$direction,
	      _props$hideSortIcon = props.hideSortIcon,
	      hideSortIcon = _props$hideSortIcon === void 0 ? false : _props$hideSortIcon,
	      _props$IconComponent = props.IconComponent,
	      IconComponent = _props$IconComponent === void 0 ? _ArrowDownward.default : _props$IconComponent,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "children", "classes", "className", "direction", "hideSortIcon", "IconComponent"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, active && classes.active),
	    component: "span",
	    disableRipple: true,
	    ref: ref
	  }, other), children, hideSortIcon && !active ? null : /*#__PURE__*/React.createElement(IconComponent, {
	    className: (0, _clsx.default)(classes.icon, classes["iconDirection".concat((0, _capitalize.default)(direction))])
	  }));
	});
	 false ? TableSortLabel.propTypes = {
	  /**
	   * If `true`, the label will have the active styling (should be true for the sorted column).
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * Label contents, the arrow will be appended automatically.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The current sort direction.
	   */
	  direction: _propTypes.default.oneOf(['asc', 'desc']),
	
	  /**
	   * Hide sort icon when active is false.
	   */
	  hideSortIcon: _propTypes.default.bool,
	
	  /**
	   * Sort icon to use.
	   */
	  IconComponent: _propTypes.default.elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableSortLabel'
	})(TableSortLabel);
	
	exports.default = _default;

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableSortLabel.default;
	  }
	});
	
	var _TableSortLabel = _interopRequireDefault(__webpack_require__(985));

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ScrollbarSize;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _debounce = _interopRequireDefault(__webpack_require__(94));
	
	var styles = {
	  width: 99,
	  height: 99,
	  position: 'absolute',
	  top: -9999,
	  overflow: 'scroll'
	};
	/**
	 * @ignore - internal component.
	 * The component originates from https://github.com/STORIS/react-scrollbar-size.
	 * It has been moved into the core in order to minimize the bundle size.
	 */
	
	function ScrollbarSize(props) {
	  var onChange = props.onChange,
	      other = (0, _objectWithoutProperties2.default)(props, ["onChange"]);
	  var scrollbarHeight = React.useRef();
	  var nodeRef = React.useRef(null);
	
	  var setMeasurements = function setMeasurements() {
	    scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
	  };
	
	  React.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      var prevHeight = scrollbarHeight.current;
	      setMeasurements();
	
	      if (prevHeight !== scrollbarHeight.current) {
	        onChange(scrollbarHeight.current);
	      }
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [onChange]);
	  React.useEffect(function () {
	    setMeasurements();
	    onChange(scrollbarHeight.current);
	  }, [onChange]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    style: styles,
	    ref: nodeRef
	  }, other));
	}
	
	 false ? ScrollbarSize.propTypes = {
	  onChange: _propTypes.default.func.isRequired
	} : void 0;

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'absolute',
	      height: 2,
	      bottom: 0,
	      width: '100%',
	      transition: theme.transitions.create()
	    },
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main
	    },
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main
	    },
	    vertical: {
	      height: '100%',
	      width: 2,
	      right: 0
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	var TabIndicator = /*#__PURE__*/React.forwardRef(function TabIndicator(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      color = props.color,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "orientation"]);
	  return /*#__PURE__*/React.createElement("span", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(color))], className, orientation === 'vertical' && classes.vertical),
	    ref: ref
	  }, other));
	});
	 false ? TabIndicator.propTypes = {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   * The color of the tab indicator.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']).isRequired,
	
	  /**
	   * The tabs orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']).isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateTabIndicator'
	})(TabIndicator);
	
	exports.default = _default;

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(67);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _debounce = _interopRequireDefault(__webpack_require__(94));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(168));
	
	var _scrollLeft = __webpack_require__(1045);
	
	var _animate = _interopRequireDefault(__webpack_require__(1014));
	
	var _ScrollbarSize = _interopRequireDefault(__webpack_require__(987));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _TabIndicator = _interopRequireDefault(__webpack_require__(988));
	
	var _TabScrollButton = _interopRequireDefault(__webpack_require__(375));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(79));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(47));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      overflow: 'hidden',
	      minHeight: 48,
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      display: 'flex'
	    },
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the flex container element. */
	    flexContainer: {
	      display: 'flex'
	    },
	
	    /* Styles applied to the flex container element if `orientation="vertical"`. */
	    flexContainerVertical: {
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the flex container element if `centered={true}` & `!variant="scrollable"`. */
	    centered: {
	      justifyContent: 'center'
	    },
	
	    /* Styles applied to the tablist element. */
	    scroller: {
	      position: 'relative',
	      display: 'inline-block',
	      flex: '1 1 auto',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the tablist element if `!variant="scrollable"`. */
	    fixed: {
	      overflowX: 'hidden',
	      width: '100%'
	    },
	
	    /* Styles applied to the tablist element if `variant="scrollable"`. */
	    scrollable: {
	      overflowX: 'scroll',
	      // Hide dimensionless scrollbar on MacOS
	      scrollbarWidth: 'none',
	      // Firefox
	      '&::-webkit-scrollbar': {
	        display: 'none' // Safari + Chrome
	
	      }
	    },
	
	    /* Styles applied to the `ScrollButtonComponent` component. */
	    scrollButtons: {},
	
	    /* Styles applied to the `ScrollButtonComponent` component if `scrollButtons="auto"` or scrollButtons="desktop"`. */
	    scrollButtonsDesktop: (0, _defineProperty2.default)({}, theme.breakpoints.down('xs'), {
	      display: 'none'
	    }),
	
	    /* Styles applied to the `TabIndicator` component. */
	    indicator: {}
	  };
	};
	
	exports.styles = styles;
	var Tabs = /*#__PURE__*/React.forwardRef(function Tabs(props, ref) {
	  var ariaLabel = props['aria-label'],
	      ariaLabelledBy = props['aria-labelledby'],
	      action = props.action,
	      _props$centered = props.centered,
	      centered = _props$centered === void 0 ? false : _props$centered,
	      childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$indicatorColor = props.indicatorColor,
	      indicatorColor = _props$indicatorColor === void 0 ? 'secondary' : _props$indicatorColor,
	      onChange = props.onChange,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      _props$ScrollButtonCo = props.ScrollButtonComponent,
	      ScrollButtonComponent = _props$ScrollButtonCo === void 0 ? _TabScrollButton.default : _props$ScrollButtonCo,
	      _props$scrollButtons = props.scrollButtons,
	      scrollButtons = _props$scrollButtons === void 0 ? 'auto' : _props$scrollButtons,
	      selectionFollowsFocus = props.selectionFollowsFocus,
	      _props$TabIndicatorPr = props.TabIndicatorProps,
	      TabIndicatorProps = _props$TabIndicatorPr === void 0 ? {} : _props$TabIndicatorPr,
	      TabScrollButtonProps = props.TabScrollButtonProps,
	      _props$textColor = props.textColor,
	      textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor,
	      value = props.value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["aria-label", "aria-labelledby", "action", "centered", "children", "classes", "className", "component", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "selectionFollowsFocus", "TabIndicatorProps", "TabScrollButtonProps", "textColor", "value", "variant"]);
	  var theme = (0, _useTheme.default)();
	  var scrollable = variant === 'scrollable';
	  var isRtl = theme.direction === 'rtl';
	  var vertical = orientation === 'vertical';
	  var scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
	  var start = vertical ? 'top' : 'left';
	  var end = vertical ? 'bottom' : 'right';
	  var clientSize = vertical ? 'clientHeight' : 'clientWidth';
	  var size = vertical ? 'height' : 'width';
	
	  if (false) {
	    if (centered && scrollable) {
	      console.error('Material-UI: You can not use the `centered={true}` and `variant="scrollable"` properties ' + 'at the same time on a `Tabs` component.');
	    }
	  }
	
	  var _React$useState = React.useState(false),
	      mounted = _React$useState[0],
	      setMounted = _React$useState[1];
	
	  var _React$useState2 = React.useState({}),
	      indicatorStyle = _React$useState2[0],
	      setIndicatorStyle = _React$useState2[1];
	
	  var _React$useState3 = React.useState({
	    start: false,
	    end: false
	  }),
	      displayScroll = _React$useState3[0],
	      setDisplayScroll = _React$useState3[1];
	
	  var _React$useState4 = React.useState({
	    overflow: 'hidden',
	    marginBottom: null
	  }),
	      scrollerStyle = _React$useState4[0],
	      setScrollerStyle = _React$useState4[1];
	
	  var valueToIndex = new Map();
	  var tabsRef = React.useRef(null);
	  var tabListRef = React.useRef(null);
	
	  var getTabsMeta = function getTabsMeta() {
	    var tabsNode = tabsRef.current;
	    var tabsMeta;
	
	    if (tabsNode) {
	      var rect = tabsNode.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft
	
	      tabsMeta = {
	        clientWidth: tabsNode.clientWidth,
	        scrollLeft: tabsNode.scrollLeft,
	        scrollTop: tabsNode.scrollTop,
	        scrollLeftNormalized: (0, _scrollLeft.getNormalizedScrollLeft)(tabsNode, theme.direction),
	        scrollWidth: tabsNode.scrollWidth,
	        top: rect.top,
	        bottom: rect.bottom,
	        left: rect.left,
	        right: rect.right
	      };
	    }
	
	    var tabMeta;
	
	    if (tabsNode && value !== false) {
	      var _children = tabListRef.current.children;
	
	      if (_children.length > 0) {
	        var tab = _children[valueToIndex.get(value)];
	
	        if (false) {
	          if (!tab) {
	            console.error(["Material-UI: The value provided to the Tabs component is invalid.", "None of the Tabs' children match with `".concat(value, "`."), valueToIndex.keys ? "You can provide one of the following values: ".concat(Array.from(valueToIndex.keys()).join(', '), ".") : null].join('\n'));
	          }
	        }
	
	        tabMeta = tab ? tab.getBoundingClientRect() : null;
	      }
	    }
	
	    return {
	      tabsMeta: tabsMeta,
	      tabMeta: tabMeta
	    };
	  };
	
	  var updateIndicatorState = (0, _useEventCallback.default)(function () {
	    var _newIndicatorStyle;
	
	    var _getTabsMeta = getTabsMeta(),
	        tabsMeta = _getTabsMeta.tabsMeta,
	        tabMeta = _getTabsMeta.tabMeta;
	
	    var startValue = 0;
	
	    if (tabMeta && tabsMeta) {
	      if (vertical) {
	        startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
	      } else {
	        var correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
	        startValue = tabMeta.left - tabsMeta.left + correction;
	      }
	    }
	
	    var newIndicatorStyle = (_newIndicatorStyle = {}, (0, _defineProperty2.default)(_newIndicatorStyle, start, startValue), (0, _defineProperty2.default)(_newIndicatorStyle, size, tabMeta ? tabMeta[size] : 0), _newIndicatorStyle);
	
	    if (isNaN(indicatorStyle[start]) || isNaN(indicatorStyle[size])) {
	      setIndicatorStyle(newIndicatorStyle);
	    } else {
	      var dStart = Math.abs(indicatorStyle[start] - newIndicatorStyle[start]);
	      var dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
	
	      if (dStart >= 1 || dSize >= 1) {
	        setIndicatorStyle(newIndicatorStyle);
	      }
	    }
	  });
	
	  var scroll = function scroll(scrollValue) {
	    (0, _animate.default)(scrollStart, tabsRef.current, scrollValue);
	  };
	
	  var moveTabsScroll = function moveTabsScroll(delta) {
	    var scrollValue = tabsRef.current[scrollStart];
	
	    if (vertical) {
	      scrollValue += delta;
	    } else {
	      scrollValue += delta * (isRtl ? -1 : 1); // Fix for Edge
	
	      scrollValue *= isRtl && (0, _scrollLeft.detectScrollType)() === 'reverse' ? -1 : 1;
	    }
	
	    scroll(scrollValue);
	  };
	
	  var handleStartScrollClick = function handleStartScrollClick() {
	    moveTabsScroll(-tabsRef.current[clientSize]);
	  };
	
	  var handleEndScrollClick = function handleEndScrollClick() {
	    moveTabsScroll(tabsRef.current[clientSize]);
	  };
	
	  var handleScrollbarSizeChange = React.useCallback(function (scrollbarHeight) {
	    setScrollerStyle({
	      overflow: null,
	      marginBottom: -scrollbarHeight
	    });
	  }, []);
	
	  var getConditionalElements = function getConditionalElements() {
	    var conditionalElements = {};
	    conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/React.createElement(_ScrollbarSize.default, {
	      className: classes.scrollable,
	      onChange: handleScrollbarSizeChange
	    }) : null;
	    var scrollButtonsActive = displayScroll.start || displayScroll.end;
	    var showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === 'desktop' || scrollButtons === 'on');
	    conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/React.createElement(ScrollButtonComponent, (0, _extends2.default)({
	      orientation: orientation,
	      direction: isRtl ? 'right' : 'left',
	      onClick: handleStartScrollClick,
	      disabled: !displayScroll.start,
	      className: (0, _clsx.default)(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
	    }, TabScrollButtonProps)) : null;
	    conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/React.createElement(ScrollButtonComponent, (0, _extends2.default)({
	      orientation: orientation,
	      direction: isRtl ? 'left' : 'right',
	      onClick: handleEndScrollClick,
	      disabled: !displayScroll.end,
	      className: (0, _clsx.default)(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
	    }, TabScrollButtonProps)) : null;
	    return conditionalElements;
	  };
	
	  var scrollSelectedIntoView = (0, _useEventCallback.default)(function () {
	    var _getTabsMeta2 = getTabsMeta(),
	        tabsMeta = _getTabsMeta2.tabsMeta,
	        tabMeta = _getTabsMeta2.tabMeta;
	
	    if (!tabMeta || !tabsMeta) {
	      return;
	    }
	
	    if (tabMeta[start] < tabsMeta[start]) {
	      // left side of button is out of view
	      var nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
	      scroll(nextScrollStart);
	    } else if (tabMeta[end] > tabsMeta[end]) {
	      // right side of button is out of view
	      var _nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
	
	      scroll(_nextScrollStart);
	    }
	  });
	  var updateScrollButtonState = (0, _useEventCallback.default)(function () {
	    if (scrollable && scrollButtons !== 'off') {
	      var _tabsRef$current = tabsRef.current,
	          scrollTop = _tabsRef$current.scrollTop,
	          scrollHeight = _tabsRef$current.scrollHeight,
	          clientHeight = _tabsRef$current.clientHeight,
	          scrollWidth = _tabsRef$current.scrollWidth,
	          clientWidth = _tabsRef$current.clientWidth;
	      var showStartScroll;
	      var showEndScroll;
	
	      if (vertical) {
	        showStartScroll = scrollTop > 1;
	        showEndScroll = scrollTop < scrollHeight - clientHeight - 1;
	      } else {
	        var scrollLeft = (0, _scrollLeft.getNormalizedScrollLeft)(tabsRef.current, theme.direction); // use 1 for the potential rounding error with browser zooms.
	
	        showStartScroll = isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
	        showEndScroll = !isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
	      }
	
	      if (showStartScroll !== displayScroll.start || showEndScroll !== displayScroll.end) {
	        setDisplayScroll({
	          start: showStartScroll,
	          end: showEndScroll
	        });
	      }
	    }
	  });
	  React.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      updateIndicatorState();
	      updateScrollButtonState();
	    });
	    var win = (0, _ownerWindow.default)(tabsRef.current);
	    win.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      win.removeEventListener('resize', handleResize);
	    };
	  }, [updateIndicatorState, updateScrollButtonState]);
	  var handleTabsScroll = React.useCallback((0, _debounce.default)(function () {
	    updateScrollButtonState();
	  }));
	  React.useEffect(function () {
	    return function () {
	      handleTabsScroll.clear();
	    };
	  }, [handleTabsScroll]);
	  React.useEffect(function () {
	    setMounted(true);
	  }, []);
	  React.useEffect(function () {
	    updateIndicatorState();
	    updateScrollButtonState();
	  });
	  React.useEffect(function () {
	    scrollSelectedIntoView();
	  }, [scrollSelectedIntoView, indicatorStyle]);
	  React.useImperativeHandle(action, function () {
	    return {
	      updateIndicator: updateIndicatorState,
	      updateScrollButtons: updateScrollButtonState
	    };
	  }, [updateIndicatorState, updateScrollButtonState]);
	  var indicator = /*#__PURE__*/React.createElement(_TabIndicator.default, (0, _extends2.default)({
	    className: classes.indicator,
	    orientation: orientation,
	    color: indicatorColor
	  }, TabIndicatorProps, {
	    style: (0, _extends2.default)({}, indicatorStyle, TabIndicatorProps.style)
	  }));
	  var childIndex = 0;
	  var children = React.Children.map(childrenProp, function (child) {
	    if (! /*#__PURE__*/React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: The Tabs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var childValue = child.props.value === undefined ? childIndex : child.props.value;
	    valueToIndex.set(childValue, childIndex);
	    var selected = childValue === value;
	    childIndex += 1;
	    return /*#__PURE__*/React.cloneElement(child, {
	      fullWidth: variant === 'fullWidth',
	      indicator: selected && !mounted && indicator,
	      selected: selected,
	      selectionFollowsFocus: selectionFollowsFocus,
	      onChange: onChange,
	      textColor: textColor,
	      value: childValue
	    });
	  });
	
	  var handleKeyDown = function handleKeyDown(event) {
	    var target = event.target; // Keyboard navigation assumes that [role="tab"] are siblings
	    // though we might warn in the future about nested, interactive elements
	    // as a a11y violation
	
	    var role = target.getAttribute('role');
	
	    if (role !== 'tab') {
	      return;
	    }
	
	    var newFocusTarget = null;
	    var previousItemKey = orientation !== "vertical" ? 'ArrowLeft' : 'ArrowUp';
	    var nextItemKey = orientation !== "vertical" ? 'ArrowRight' : 'ArrowDown';
	
	    if (orientation !== "vertical" && theme.direction === 'rtl') {
	      // swap previousItemKey with nextItemKey
	      previousItemKey = 'ArrowRight';
	      nextItemKey = 'ArrowLeft';
	    }
	
	    switch (event.key) {
	      case previousItemKey:
	        newFocusTarget = target.previousElementSibling || tabListRef.current.lastChild;
	        break;
	
	      case nextItemKey:
	        newFocusTarget = target.nextElementSibling || tabListRef.current.firstChild;
	        break;
	
	      case 'Home':
	        newFocusTarget = tabListRef.current.firstChild;
	        break;
	
	      case 'End':
	        newFocusTarget = tabListRef.current.lastChild;
	        break;
	
	      default:
	        break;
	    }
	
	    if (newFocusTarget !== null) {
	      newFocusTarget.focus();
	      event.preventDefault();
	    }
	  };
	
	  var conditionalElements = getConditionalElements();
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, vertical && classes.vertical),
	    ref: ref
	  }, other), conditionalElements.scrollButtonStart, conditionalElements.scrollbarSizeListener, /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.scroller, scrollable ? classes.scrollable : classes.fixed),
	    style: scrollerStyle,
	    ref: tabsRef,
	    onScroll: handleTabsScroll
	  }, /*#__PURE__*/React.createElement("div", {
	    "aria-label": ariaLabel,
	    "aria-labelledby": ariaLabelledBy,
	    className: (0, _clsx.default)(classes.flexContainer, vertical && classes.flexContainerVertical, centered && !scrollable && classes.centered),
	    onKeyDown: handleKeyDown,
	    ref: tabListRef,
	    role: "tablist"
	  }, children), mounted && indicator), conditionalElements.scrollButtonEnd);
	});
	 false ? Tabs.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Callback fired when the component mounts.
	   * This is useful when you want to trigger an action programmatically.
	   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
	   *
	   * @param {object} actions This object contains all possible actions
	   * that can be triggered programmatically.
	   */
	  action: _utils.refType,
	
	  /**
	   * The label for the Tabs as a string.
	   */
	  'aria-label': _propTypes.default.string,
	
	  /**
	   * An id or list of ids separated by a space that label the Tabs.
	   */
	  'aria-labelledby': _propTypes.default.string,
	
	  /**
	   * If `true`, the tabs will be centered.
	   * This property is intended for large views.
	   */
	  centered: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Determines the color of the indicator.
	   */
	  indicatorColor: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * Callback fired when the value changes.
	   *
	   * @param {object} event The event source of the callback
	   * @param {any} value We default to the index of the child (number)
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The tabs orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * The component used to render the scroll buttons.
	   */
	  ScrollButtonComponent: _propTypes.default.elementType,
	
	  /**
	   * Determine behavior of scroll buttons when tabs are set to scroll:
	   *
	   * - `auto` will only present them when not all the items are visible.
	   * - `desktop` will only present them on medium and larger viewports.
	   * - `on` will always present them.
	   * - `off` will never present them.
	   */
	  scrollButtons: _propTypes.default.oneOf(['auto', 'desktop', 'off', 'on']),
	
	  /**
	   * If `true` the selected tab changes on focus. Otherwise it only
	   * changes on activation.
	   */
	  selectionFollowsFocus: _propTypes.default.bool,
	
	  /**
	   * Props applied to the tab indicator element.
	   */
	  TabIndicatorProps: _propTypes.default.object,
	
	  /**
	   * Props applied to the [`TabScrollButton`](/api/tab-scroll-button/) element.
	   */
	  TabScrollButtonProps: _propTypes.default.object,
	
	  /**
	   * Determines the color of the `Tab`.
	   */
	  textColor: _propTypes.default.oneOf(['inherit', 'primary', 'secondary']),
	
	  /**
	   * The value of the currently selected `Tab`.
	   * If you don't want any selected `Tab`, you can set this property to `false`.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * Determines additional display behavior of the tabs:
	   *
	   *  - `scrollable` will invoke scrolling properties and allow for horizontally
	   *  scrolling (or swiping) of the tab bar.
	   *  -`fullWidth` will make the tabs grow to use all the available space,
	   *  which should be used for small views, like on mobile.
	   *  - `standard` will render the default state.
	   */
	  variant: _propTypes.default.oneOf(['fullWidth', 'scrollable', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTabs'
	})(Tabs);
	
	exports.default = _default;

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Tabs.default;
	  }
	});
	
	var _Tabs = _interopRequireDefault(__webpack_require__(989));

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _Input = _interopRequireDefault(__webpack_require__(164));
	
	var _FilledInput = _interopRequireDefault(__webpack_require__(232));
	
	var _OutlinedInput = _interopRequireDefault(__webpack_require__(235));
	
	var _InputLabel = _interopRequireDefault(__webpack_require__(355));
	
	var _FormControl = _interopRequireDefault(__webpack_require__(233));
	
	var _FormHelperText = _interopRequireDefault(__webpack_require__(353));
	
	var _Select = _interopRequireDefault(__webpack_require__(237));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var variantComponent = {
	  standard: _Input.default,
	  filled: _FilledInput.default,
	  outlined: _OutlinedInput.default
	};
	var styles = {
	  /* Styles applied to the root element. */
	  root: {}
	};
	/**
	 * The `TextField` is a convenience wrapper for the most common cases (80%).
	 * It cannot be all things to all people, otherwise the API would grow out of control.
	 *
	 * ## Advanced Configuration
	 *
	 * It's important to understand that the text field is a simple abstraction
	 * on top of the following components:
	 *
	 * - [FormControl](/api/form-control/)
	 * - [InputLabel](/api/input-label/)
	 * - [FilledInput](/api/filled-input/)
	 * - [OutlinedInput](/api/outlined-input/)
	 * - [Input](/api/input/)
	 * - [FormHelperText](/api/form-helper-text/)
	 *
	 * If you wish to alter the props applied to the `input` element, you can do so as follows:
	 *
	 * ```jsx
	 * const inputProps = {
	 *   step: 300,
	 * };
	 *
	 * return <TextField id="time" type="time" inputProps={inputProps} />;
	 * ```
	 *
	 * For advanced cases, please look at the source of TextField by clicking on the
	 * "Edit this page" button above. Consider either:
	 *
	 * - using the upper case props for passing values directly to the components
	 * - using the underlying components directly as shown in the demos
	 */
	
	exports.styles = styles;
	var TextField = /*#__PURE__*/React.forwardRef(function TextField(props, ref) {
	  var autoComplete = props.autoComplete,
	      _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      defaultValue = props.defaultValue,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      FormHelperTextProps = props.FormHelperTextProps,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      helperText = props.helperText,
	      hiddenLabel = props.hiddenLabel,
	      id = props.id,
	      InputLabelProps = props.InputLabelProps,
	      inputProps = props.inputProps,
	      InputProps = props.InputProps,
	      inputRef = props.inputRef,
	      label = props.label,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onFocus = props.onFocus,
	      placeholder = props.placeholder,
	      _props$required = props.required,
	      required = _props$required === void 0 ? false : _props$required,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      _props$select = props.select,
	      select = _props$select === void 0 ? false : _props$select,
	      SelectProps = props.SelectProps,
	      type = props.type,
	      value = props.value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoComplete", "autoFocus", "children", "classes", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "select", "SelectProps", "type", "value", "variant"]);
	
	  if (false) {
	    if (select && !children) {
	      console.error('Material-UI: `children` must be passed when using the `TextField` component with `select`.');
	    }
	  }
	
	  var InputMore = {};
	
	  if (variant === 'outlined') {
	    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
	      InputMore.notched = InputLabelProps.shrink;
	    }
	
	    if (label) {
	      var _InputLabelProps$requ;
	
	      var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
	      InputMore.label = /*#__PURE__*/React.createElement(React.Fragment, null, label, displayRequired && "\xA0*");
	    }
	  }
	
	  if (select) {
	    // unset defaults from textbox inputs
	    if (!SelectProps || !SelectProps.native) {
	      InputMore.id = undefined;
	    }
	
	    InputMore['aria-describedby'] = undefined;
	  }
	
	  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
	  var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
	  var InputComponent = variantComponent[variant];
	  var InputElement = /*#__PURE__*/React.createElement(InputComponent, (0, _extends2.default)({
	    "aria-describedby": helperTextId,
	    autoComplete: autoComplete,
	    autoFocus: autoFocus,
	    defaultValue: defaultValue,
	    fullWidth: fullWidth,
	    multiline: multiline,
	    name: name,
	    rows: rows,
	    rowsMax: rowsMax,
	    type: type,
	    value: value,
	    id: id,
	    inputRef: inputRef,
	    onBlur: onBlur,
	    onChange: onChange,
	    onFocus: onFocus,
	    placeholder: placeholder,
	    inputProps: inputProps
	  }, InputMore, InputProps));
	  return /*#__PURE__*/React.createElement(_FormControl.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    disabled: disabled,
	    error: error,
	    fullWidth: fullWidth,
	    hiddenLabel: hiddenLabel,
	    ref: ref,
	    required: required,
	    color: color,
	    variant: variant
	  }, other), label && /*#__PURE__*/React.createElement(_InputLabel.default, (0, _extends2.default)({
	    htmlFor: id,
	    id: inputLabelId
	  }, InputLabelProps), label), select ? /*#__PURE__*/React.createElement(_Select.default, (0, _extends2.default)({
	    "aria-describedby": helperTextId,
	    id: id,
	    labelId: inputLabelId,
	    value: value,
	    input: InputElement
	  }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/React.createElement(_FormHelperText.default, (0, _extends2.default)({
	    id: helperTextId
	  }, FormHelperTextProps), helperText));
	});
	 false ? TextField.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default value of the `input` element.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`FormHelperText`](/api/form-helper-text/) element.
	   */
	  FormHelperTextProps: _propTypes.default.object,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The helper text content.
	   */
	  helperText: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  hiddenLabel: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   * Use this prop to make `label` and `helperText` accessible for screen readers.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * Props applied to the [`InputLabel`](/api/input-label/) element.
	   */
	  InputLabelProps: _propTypes.default.object,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Props applied to the Input element.
	   * It will be a [`FilledInput`](/api/filled-input/),
	   * [`OutlinedInput`](/api/outlined-input/) or [`Input`](/api/input/)
	   * component depending on the `variant` prop value.
	   */
	  InputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The label content.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none', 'normal']),
	
	  /**
	   * If `true`, a textarea element will be rendered instead of an input.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * If `true`, the label is displayed as required and the `input` element` will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Render a [`Select`](/api/select/) element while passing the Input element to `Select` as `input` parameter.
	   * If this option is set you must pass the options of the select as children.
	   */
	  select: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`Select`](/api/select/) element.
	   */
	  SelectProps: _propTypes.default.object,
	
	  /**
	   * The size of the text field.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTextField'
	})(TextField);
	
	exports.default = _default;

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TextField.default;
	  }
	});
	
	var _TextField = _interopRequireDefault(__webpack_require__(991));

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _debounce = _interopRequireDefault(__webpack_require__(94));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	function getStyleValue(computedStyle, property) {
	  return parseInt(computedStyle[property], 10) || 0;
	}
	
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	var styles = {
	  /* Styles applied to the shadow textarea element. */
	  shadow: {
	    // Visibility needed to hide the extra text area on iPads
	    visibility: 'hidden',
	    // Remove from the content flow
	    position: 'absolute',
	    // Ignore the scrollbar width
	    overflow: 'hidden',
	    height: 0,
	    top: 0,
	    left: 0,
	    // Create a new layer, increase the isolation of the computed values
	    transform: 'translateZ(0)'
	  }
	};
	var TextareaAutosize = /*#__PURE__*/React.forwardRef(function TextareaAutosize(props, ref) {
	  var onChange = props.onChange,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      _props$rowsMin = props.rowsMin,
	      rowsMinProp = _props$rowsMin === void 0 ? 1 : _props$rowsMin,
	      style = props.style,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["onChange", "rows", "rowsMax", "rowsMin", "style", "value"]);
	  var rowsMin = rows || rowsMinProp;
	
	  var _React$useRef = React.useRef(value != null),
	      isControlled = _React$useRef.current;
	
	  var inputRef = React.useRef(null);
	  var handleRef = (0, _useForkRef.default)(ref, inputRef);
	  var shadowRef = React.useRef(null);
	  var renders = React.useRef(0);
	
	  var _React$useState = React.useState({}),
	      state = _React$useState[0],
	      setState = _React$useState[1];
	
	  var syncHeight = React.useCallback(function () {
	    var input = inputRef.current;
	    var computedStyle = window.getComputedStyle(input);
	    var inputShallow = shadowRef.current;
	    inputShallow.style.width = computedStyle.width;
	    inputShallow.value = input.value || props.placeholder || 'x';
	
	    if (inputShallow.value.slice(-1) === '\n') {
	      // Certain fonts which overflow the line height will cause the textarea
	      // to report a different scrollHeight depending on whether the last line
	      // is empty. Make it non-empty to avoid this issue.
	      inputShallow.value += ' ';
	    }
	
	    var boxSizing = computedStyle['box-sizing'];
	    var padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
	    var border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content
	
	    var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row
	
	    inputShallow.value = 'x';
	    var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content
	
	    var outerHeight = innerHeight;
	
	    if (rowsMin) {
	      outerHeight = Math.max(Number(rowsMin) * singleRowHeight, outerHeight);
	    }
	
	    if (rowsMax) {
	      outerHeight = Math.min(Number(rowsMax) * singleRowHeight, outerHeight);
	    }
	
	    outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.
	
	    var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
	    var overflow = Math.abs(outerHeight - innerHeight) <= 1;
	    setState(function (prevState) {
	      // Need a large enough difference to update the height.
	      // This prevents infinite rendering loop.
	      if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
	        renders.current += 1;
	        return {
	          overflow: overflow,
	          outerHeightStyle: outerHeightStyle
	        };
	      }
	
	      if (false) {
	        if (renders.current === 20) {
	          console.error(['Material-UI: Too many re-renders. The layout is unstable.', 'TextareaAutosize limits the number of renders to prevent an infinite loop.'].join('\n'));
	        }
	      }
	
	      return prevState;
	    });
	  }, [rowsMax, rowsMin, props.placeholder]);
	  React.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      renders.current = 0;
	      syncHeight();
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [syncHeight]);
	  useEnhancedEffect(function () {
	    syncHeight();
	  });
	  React.useEffect(function () {
	    renders.current = 0;
	  }, [value]);
	
	  var handleChange = function handleChange(event) {
	    renders.current = 0;
	
	    if (!isControlled) {
	      syncHeight();
	    }
	
	    if (onChange) {
	      onChange(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("textarea", (0, _extends2.default)({
	    value: value,
	    onChange: handleChange,
	    ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
	    ,
	    rows: rowsMin,
	    style: (0, _extends2.default)({
	      height: state.outerHeightStyle,
	      // Need a large enough difference to allow scrolling.
	      // This prevents infinite rendering loop.
	      overflow: state.overflow ? 'hidden' : null
	    }, style)
	  }, other)), /*#__PURE__*/React.createElement("textarea", {
	    "aria-hidden": true,
	    className: props.className,
	    readOnly: true,
	    ref: shadowRef,
	    tabIndex: -1,
	    style: (0, _extends2.default)({}, styles.shadow, style)
	  }));
	});
	 false ? TextareaAutosize.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * Use `rowsMin` instead. The prop will be removed in v5.
	   *
	   * @deprecated
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Minimum number of rows to display.
	   */
	  rowsMin: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  value: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.number, _propTypes.default.string])
	} : void 0;
	var _default = TextareaAutosize;
	exports.default = _default;

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the root element if `disableGutters={false}`. */
	    gutters: (0, _defineProperty2.default)({
	      paddingLeft: theme.spacing(2),
	      paddingRight: theme.spacing(2)
	    }, theme.breakpoints.up('sm'), {
	      paddingLeft: theme.spacing(3),
	      paddingRight: theme.spacing(3)
	    }),
	
	    /* Styles applied to the root element if `variant="regular"`. */
	    regular: theme.mixins.toolbar,
	
	    /* Styles applied to the root element if `variant="dense"`. */
	    dense: {
	      minHeight: 48
	    }
	  };
	};
	
	exports.styles = styles;
	var Toolbar = /*#__PURE__*/React.forwardRef(function Toolbar(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'regular' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disableGutters", "variant"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[variant], className, !disableGutters && classes.gutters),
	    ref: ref
	  }, other));
	});
	 false ? Toolbar.propTypes = {
	  /**
	   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * If `true`, disables gutter padding.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['regular', 'dense'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiToolbar'
	})(Toolbar);
	
	exports.default = _default;

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.testReset = testReset;
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(45));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _utils = __webpack_require__(22);
	
	var _colorManipulator = __webpack_require__(49);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var _Grow = _interopRequireDefault(__webpack_require__(163));
	
	var _Popper = _interopRequireDefault(__webpack_require__(367));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	var _unstable_useId = _interopRequireDefault(__webpack_require__(169));
	
	var _setRef = _interopRequireDefault(__webpack_require__(95));
	
	var _useIsFocusVisible2 = _interopRequireDefault(__webpack_require__(131));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(85));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(47));
	
	function round(value) {
	  return Math.round(value * 1e5) / 1e5;
	}
	
	function arrowGenerator() {
	  return {
	    '&[x-placement*="bottom"] $arrow': {
	      top: 0,
	      left: 0,
	      marginTop: '-0.71em',
	      marginLeft: 4,
	      marginRight: 4,
	      '&::before': {
	        transformOrigin: '0 100%'
	      }
	    },
	    '&[x-placement*="top"] $arrow': {
	      bottom: 0,
	      left: 0,
	      marginBottom: '-0.71em',
	      marginLeft: 4,
	      marginRight: 4,
	      '&::before': {
	        transformOrigin: '100% 0'
	      }
	    },
	    '&[x-placement*="right"] $arrow': {
	      left: 0,
	      marginLeft: '-0.71em',
	      height: '1em',
	      width: '0.71em',
	      marginTop: 4,
	      marginBottom: 4,
	      '&::before': {
	        transformOrigin: '100% 100%'
	      }
	    },
	    '&[x-placement*="left"] $arrow': {
	      right: 0,
	      marginRight: '-0.71em',
	      height: '1em',
	      width: '0.71em',
	      marginTop: 4,
	      marginBottom: 4,
	      '&::before': {
	        transformOrigin: '0 0'
	      }
	    }
	  };
	}
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the Popper component. */
	    popper: {
	      zIndex: theme.zIndex.tooltip,
	      pointerEvents: 'none' // disable jss-rtl plugin
	
	    },
	
	    /* Styles applied to the Popper component if `interactive={true}`. */
	    popperInteractive: {
	      pointerEvents: 'auto'
	    },
	
	    /* Styles applied to the Popper component if `arrow={true}`. */
	    popperArrow: arrowGenerator(),
	
	    /* Styles applied to the tooltip (label wrapper) element. */
	    tooltip: {
	      backgroundColor: (0, _colorManipulator.fade)(theme.palette.grey[700], 0.9),
	      borderRadius: theme.shape.borderRadius,
	      color: theme.palette.common.white,
	      fontFamily: theme.typography.fontFamily,
	      padding: '4px 8px',
	      fontSize: theme.typography.pxToRem(10),
	      lineHeight: "".concat(round(14 / 10), "em"),
	      maxWidth: 300,
	      wordWrap: 'break-word',
	      fontWeight: theme.typography.fontWeightMedium
	    },
	
	    /* Styles applied to the tooltip (label wrapper) element if `arrow={true}`. */
	    tooltipArrow: {
	      position: 'relative',
	      margin: '0'
	    },
	
	    /* Styles applied to the arrow element. */
	    arrow: {
	      overflow: 'hidden',
	      position: 'absolute',
	      width: '1em',
	      height: '0.71em'
	      /* = width / sqrt(2) = (length of the hypotenuse) */
	      ,
	      boxSizing: 'border-box',
	      color: (0, _colorManipulator.fade)(theme.palette.grey[700], 0.9),
	      '&::before': {
	        content: '""',
	        margin: 'auto',
	        display: 'block',
	        width: '100%',
	        height: '100%',
	        backgroundColor: 'currentColor',
	        transform: 'rotate(45deg)'
	      }
	    },
	
	    /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */
	    touch: {
	      padding: '8px 16px',
	      fontSize: theme.typography.pxToRem(14),
	      lineHeight: "".concat(round(16 / 14), "em"),
	      fontWeight: theme.typography.fontWeightRegular
	    },
	
	    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
	    tooltipPlacementLeft: (0, _defineProperty2.default)({
	      transformOrigin: 'right center',
	      margin: '0 24px '
	    }, theme.breakpoints.up('sm'), {
	      margin: '0 14px'
	    }),
	
	    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
	    tooltipPlacementRight: (0, _defineProperty2.default)({
	      transformOrigin: 'left center',
	      margin: '0 24px'
	    }, theme.breakpoints.up('sm'), {
	      margin: '0 14px'
	    }),
	
	    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
	    tooltipPlacementTop: (0, _defineProperty2.default)({
	      transformOrigin: 'center bottom',
	      margin: '24px 0'
	    }, theme.breakpoints.up('sm'), {
	      margin: '14px 0'
	    }),
	
	    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
	    tooltipPlacementBottom: (0, _defineProperty2.default)({
	      transformOrigin: 'center top',
	      margin: '24px 0'
	    }, theme.breakpoints.up('sm'), {
	      margin: '14px 0'
	    })
	  };
	};
	
	exports.styles = styles;
	var hystersisOpen = false;
	var hystersisTimer = null;
	
	function testReset() {
	  hystersisOpen = false;
	  clearTimeout(hystersisTimer);
	}
	
	var Tooltip = /*#__PURE__*/React.forwardRef(function Tooltip(props, ref) {
	  var _props$arrow = props.arrow,
	      arrow = _props$arrow === void 0 ? false : _props$arrow,
	      children = props.children,
	      classes = props.classes,
	      _props$disableFocusLi = props.disableFocusListener,
	      disableFocusListener = _props$disableFocusLi === void 0 ? false : _props$disableFocusLi,
	      _props$disableHoverLi = props.disableHoverListener,
	      disableHoverListener = _props$disableHoverLi === void 0 ? false : _props$disableHoverLi,
	      _props$disableTouchLi = props.disableTouchListener,
	      disableTouchListener = _props$disableTouchLi === void 0 ? false : _props$disableTouchLi,
	      _props$enterDelay = props.enterDelay,
	      enterDelay = _props$enterDelay === void 0 ? 100 : _props$enterDelay,
	      _props$enterNextDelay = props.enterNextDelay,
	      enterNextDelay = _props$enterNextDelay === void 0 ? 0 : _props$enterNextDelay,
	      _props$enterTouchDela = props.enterTouchDelay,
	      enterTouchDelay = _props$enterTouchDela === void 0 ? 700 : _props$enterTouchDela,
	      idProp = props.id,
	      _props$interactive = props.interactive,
	      interactive = _props$interactive === void 0 ? false : _props$interactive,
	      _props$leaveDelay = props.leaveDelay,
	      leaveDelay = _props$leaveDelay === void 0 ? 0 : _props$leaveDelay,
	      _props$leaveTouchDela = props.leaveTouchDelay,
	      leaveTouchDelay = _props$leaveTouchDela === void 0 ? 1500 : _props$leaveTouchDela,
	      onClose = props.onClose,
	      onOpen = props.onOpen,
	      openProp = props.open,
	      _props$placement = props.placement,
	      placement = _props$placement === void 0 ? 'bottom' : _props$placement,
	      _props$PopperComponen = props.PopperComponent,
	      PopperComponent = _props$PopperComponen === void 0 ? _Popper.default : _props$PopperComponen,
	      PopperProps = props.PopperProps,
	      title = props.title,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Grow.default : _props$TransitionComp,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["arrow", "children", "classes", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "id", "interactive", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "title", "TransitionComponent", "TransitionProps"]);
	  var theme = (0, _useTheme.default)();
	
	  var _React$useState = React.useState(),
	      childNode = _React$useState[0],
	      setChildNode = _React$useState[1];
	
	  var _React$useState2 = React.useState(null),
	      arrowRef = _React$useState2[0],
	      setArrowRef = _React$useState2[1];
	
	  var ignoreNonTouchEvents = React.useRef(false);
	  var closeTimer = React.useRef();
	  var enterTimer = React.useRef();
	  var leaveTimer = React.useRef();
	  var touchTimer = React.useRef();
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: openProp,
	    default: false,
	    name: 'Tooltip',
	    state: 'open'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      openState = _useControlled2[0],
	      setOpenState = _useControlled2[1];
	
	  var open = openState;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    var _React$useRef = React.useRef(openProp !== undefined),
	        isControlled = _React$useRef.current; // eslint-disable-next-line react-hooks/rules-of-hooks
	
	
	    React.useEffect(function () {
	      if (childNode && childNode.disabled && !isControlled && title !== '' && childNode.tagName.toLowerCase() === 'button') {
	        console.error(['Material-UI: You are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Add a simple wrapper element, such as a `span`.'].join('\n'));
	      }
	    }, [title, childNode, isControlled]);
	  }
	
	  var id = (0, _unstable_useId.default)(idProp);
	  React.useEffect(function () {
	    return function () {
	      clearTimeout(closeTimer.current);
	      clearTimeout(enterTimer.current);
	      clearTimeout(leaveTimer.current);
	      clearTimeout(touchTimer.current);
	    };
	  }, []);
	
	  var handleOpen = function handleOpen(event) {
	    clearTimeout(hystersisTimer);
	    hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
	    // We can skip rerendering when the tooltip is already open.
	    // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
	
	    setOpenState(true);
	
	    if (onOpen) {
	      onOpen(event);
	    }
	  };
	
	  var handleEnter = function handleEnter() {
	    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	    return function (event) {
	      var childrenProps = children.props;
	
	      if (event.type === 'mouseover' && childrenProps.onMouseOver && forward) {
	        childrenProps.onMouseOver(event);
	      }
	
	      if (ignoreNonTouchEvents.current && event.type !== 'touchstart') {
	        return;
	      } // Remove the title ahead of time.
	      // We don't want to wait for the next render commit.
	      // We would risk displaying two tooltips at the same time (native + this one).
	
	
	      if (childNode) {
	        childNode.removeAttribute('title');
	      }
	
	      clearTimeout(enterTimer.current);
	      clearTimeout(leaveTimer.current);
	
	      if (enterDelay || hystersisOpen && enterNextDelay) {
	        event.persist();
	        enterTimer.current = setTimeout(function () {
	          handleOpen(event);
	        }, hystersisOpen ? enterNextDelay : enterDelay);
	      } else {
	        handleOpen(event);
	      }
	    };
	  };
	
	  var _useIsFocusVisible = (0, _useIsFocusVisible2.default)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  var _React$useState3 = React.useState(false),
	      childIsFocusVisible = _React$useState3[0],
	      setChildIsFocusVisible = _React$useState3[1];
	
	  var handleBlur = function handleBlur() {
	    if (childIsFocusVisible) {
	      setChildIsFocusVisible(false);
	      onBlurVisible();
	    }
	  };
	
	  var handleFocus = function handleFocus() {
	    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	    return function (event) {
	      // Workaround for https://github.com/facebook/react/issues/7769
	      // The autoFocus of React might trigger the event before the componentDidMount.
	      // We need to account for this eventuality.
	      if (!childNode) {
	        setChildNode(event.currentTarget);
	      }
	
	      if (isFocusVisible(event)) {
	        setChildIsFocusVisible(true);
	        handleEnter()(event);
	      }
	
	      var childrenProps = children.props;
	
	      if (childrenProps.onFocus && forward) {
	        childrenProps.onFocus(event);
	      }
	    };
	  };
	
	  var handleClose = function handleClose(event) {
	    clearTimeout(hystersisTimer);
	    hystersisTimer = setTimeout(function () {
	      hystersisOpen = false;
	    }, 800 + leaveDelay);
	    setOpenState(false);
	
	    if (onClose) {
	      onClose(event);
	    }
	
	    clearTimeout(closeTimer.current);
	    closeTimer.current = setTimeout(function () {
	      ignoreNonTouchEvents.current = false;
	    }, theme.transitions.duration.shortest);
	  };
	
	  var handleLeave = function handleLeave() {
	    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	    return function (event) {
	      var childrenProps = children.props;
	
	      if (event.type === 'blur') {
	        if (childrenProps.onBlur && forward) {
	          childrenProps.onBlur(event);
	        }
	
	        handleBlur();
	      }
	
	      if (event.type === 'mouseleave' && childrenProps.onMouseLeave && event.currentTarget === childNode) {
	        childrenProps.onMouseLeave(event);
	      }
	
	      clearTimeout(enterTimer.current);
	      clearTimeout(leaveTimer.current);
	      event.persist();
	      leaveTimer.current = setTimeout(function () {
	        handleClose(event);
	      }, leaveDelay);
	    };
	  };
	
	  var detectTouchStart = function detectTouchStart(event) {
	    ignoreNonTouchEvents.current = true;
	    var childrenProps = children.props;
	
	    if (childrenProps.onTouchStart) {
	      childrenProps.onTouchStart(event);
	    }
	  };
	
	  var handleTouchStart = function handleTouchStart(event) {
	    detectTouchStart(event);
	    clearTimeout(leaveTimer.current);
	    clearTimeout(closeTimer.current);
	    clearTimeout(touchTimer.current);
	    event.persist();
	    touchTimer.current = setTimeout(function () {
	      handleEnter()(event);
	    }, enterTouchDelay);
	  };
	
	  var handleTouchEnd = function handleTouchEnd(event) {
	    if (children.props.onTouchEnd) {
	      children.props.onTouchEnd(event);
	    }
	
	    clearTimeout(touchTimer.current);
	    clearTimeout(leaveTimer.current);
	    event.persist();
	    leaveTimer.current = setTimeout(function () {
	      handleClose(event);
	    }, leaveTouchDelay);
	  };
	
	  var handleUseRef = (0, _useForkRef.default)(setChildNode, ref);
	  var handleFocusRef = (0, _useForkRef.default)(focusVisibleRef, handleUseRef); // can be removed once we drop support for non ref forwarding class components
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    (0, _setRef.default)(handleFocusRef, ReactDOM.findDOMNode(instance));
	  }, [handleFocusRef]);
	  var handleRef = (0, _useForkRef.default)(children.ref, handleOwnRef); // There is no point in displaying an empty tooltip.
	
	  if (title === '') {
	    open = false;
	  } // For accessibility and SEO concerns, we render the title to the DOM node when
	  // the tooltip is hidden. However, we have made a tradeoff when
	  // `disableHoverListener` is set. This title logic is disabled.
	  // It's allowing us to keep the implementation size minimal.
	  // We are open to change the tradeoff.
	
	
	  var shouldShowNativeTitle = !open && !disableHoverListener;
	  var childrenProps = (0, _extends2.default)({
	    'aria-describedby': open ? id : null,
	    title: shouldShowNativeTitle && typeof title === 'string' ? title : null
	  }, other, children.props, {
	    className: (0, _clsx.default)(other.className, children.props.className),
	    onTouchStart: detectTouchStart,
	    ref: handleRef
	  });
	  var interactiveWrapperListeners = {};
	
	  if (!disableTouchListener) {
	    childrenProps.onTouchStart = handleTouchStart;
	    childrenProps.onTouchEnd = handleTouchEnd;
	  }
	
	  if (!disableHoverListener) {
	    childrenProps.onMouseOver = handleEnter();
	    childrenProps.onMouseLeave = handleLeave();
	
	    if (interactive) {
	      interactiveWrapperListeners.onMouseOver = handleEnter(false);
	      interactiveWrapperListeners.onMouseLeave = handleLeave(false);
	    }
	  }
	
	  if (!disableFocusListener) {
	    childrenProps.onFocus = handleFocus();
	    childrenProps.onBlur = handleLeave();
	
	    if (interactive) {
	      interactiveWrapperListeners.onFocus = handleFocus(false);
	      interactiveWrapperListeners.onBlur = handleLeave(false);
	    }
	  }
	
	  if (false) {
	    if (children.props.title) {
	      console.error(['Material-UI: You have provided a `title` prop to the child of <Tooltip />.', "Remove this title prop `".concat(children.props.title, "` or the Tooltip component.")].join('\n'));
	    }
	  }
	
	  var mergedPopperProps = React.useMemo(function () {
	    return (0, _utils.deepmerge)({
	      popperOptions: {
	        modifiers: {
	          arrow: {
	            enabled: Boolean(arrowRef),
	            element: arrowRef
	          }
	        }
	      }
	    }, PopperProps);
	  }, [arrowRef, PopperProps]);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.cloneElement(children, childrenProps), /*#__PURE__*/React.createElement(PopperComponent, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.popper, interactive && classes.popperInteractive, arrow && classes.popperArrow),
	    placement: placement,
	    anchorEl: childNode,
	    open: childNode ? open : false,
	    id: childrenProps['aria-describedby'],
	    transition: true
	  }, interactiveWrapperListeners, mergedPopperProps), function (_ref) {
	    var placementInner = _ref.placement,
	        TransitionPropsInner = _ref.TransitionProps;
	    return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	      timeout: theme.transitions.duration.shorter
	    }, TransitionPropsInner, TransitionProps), /*#__PURE__*/React.createElement("div", {
	      className: (0, _clsx.default)(classes.tooltip, classes["tooltipPlacement".concat((0, _capitalize.default)(placementInner.split('-')[0]))], ignoreNonTouchEvents.current && classes.touch, arrow && classes.tooltipArrow)
	    }, title, arrow ? /*#__PURE__*/React.createElement("span", {
	      className: classes.arrow,
	      ref: setArrowRef
	    }) : null));
	  }));
	});
	 false ? Tooltip.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, adds an arrow to the tooltip.
	   */
	  arrow: _propTypes.default.bool,
	
	  /**
	   * Tooltip reference element.
	   */
	  children: _utils.elementAcceptingRef.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Do not respond to focus events.
	   */
	  disableFocusListener: _propTypes.default.bool,
	
	  /**
	   * Do not respond to hover events.
	   */
	  disableHoverListener: _propTypes.default.bool,
	
	  /**
	   * Do not respond to long press touch events.
	   */
	  disableTouchListener: _propTypes.default.bool,
	
	  /**
	   * The number of milliseconds to wait before showing the tooltip.
	   * This prop won't impact the enter touch delay (`enterTouchDelay`).
	   */
	  enterDelay: _propTypes.default.number,
	
	  /**
	   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
	   */
	  enterNextDelay: _propTypes.default.number,
	
	  /**
	   * The number of milliseconds a user must touch the element before showing the tooltip.
	   */
	  enterTouchDelay: _propTypes.default.number,
	
	  /**
	   * This prop is used to help implement the accessibility logic.
	   * If you don't provide this prop. It falls back to a randomly generated id.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * Makes a tooltip interactive, i.e. will not close when the user
	   * hovers over the tooltip before the `leaveDelay` is expired.
	   */
	  interactive: _propTypes.default.bool,
	
	  /**
	   * The number of milliseconds to wait before hiding the tooltip.
	   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
	   */
	  leaveDelay: _propTypes.default.number,
	
	  /**
	   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
	   */
	  leaveTouchDelay: _propTypes.default.number,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be open.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * If `true`, the tooltip is shown.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Tooltip placement.
	   */
	  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
	
	  /**
	   * The component used for the popper.
	   */
	  PopperComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Popper`](/api/popper/) element.
	   */
	  PopperProps: _propTypes.default.object,
	
	  /**
	   * Tooltip title. Zero-length titles string are never displayed.
	   */
	  title: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .node.isRequired,
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTooltip',
	  flip: false
	})(Tooltip);
	
	exports.default = _default;

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Tooltip.default;
	  }
	});
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(995));

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(31));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      margin: 0
	    },
	
	    /* Styles applied to the root element if `variant="body2"`. */
	    body2: theme.typography.body2,
	
	    /* Styles applied to the root element if `variant="body1"`. */
	    body1: theme.typography.body1,
	
	    /* Styles applied to the root element if `variant="caption"`. */
	    caption: theme.typography.caption,
	
	    /* Styles applied to the root element if `variant="button"`. */
	    button: theme.typography.button,
	
	    /* Styles applied to the root element if `variant="h1"`. */
	    h1: theme.typography.h1,
	
	    /* Styles applied to the root element if `variant="h2"`. */
	    h2: theme.typography.h2,
	
	    /* Styles applied to the root element if `variant="h3"`. */
	    h3: theme.typography.h3,
	
	    /* Styles applied to the root element if `variant="h4"`. */
	    h4: theme.typography.h4,
	
	    /* Styles applied to the root element if `variant="h5"`. */
	    h5: theme.typography.h5,
	
	    /* Styles applied to the root element if `variant="h6"`. */
	    h6: theme.typography.h6,
	
	    /* Styles applied to the root element if `variant="subtitle1"`. */
	    subtitle1: theme.typography.subtitle1,
	
	    /* Styles applied to the root element if `variant="subtitle2"`. */
	    subtitle2: theme.typography.subtitle2,
	
	    /* Styles applied to the root element if `variant="overline"`. */
	    overline: theme.typography.overline,
	
	    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
	    srOnly: {
	      position: 'absolute',
	      height: 1,
	      width: 1,
	      overflow: 'hidden'
	    },
	
	    /* Styles applied to the root element if `align="left"`. */
	    alignLeft: {
	      textAlign: 'left'
	    },
	
	    /* Styles applied to the root element if `align="center"`. */
	    alignCenter: {
	      textAlign: 'center'
	    },
	
	    /* Styles applied to the root element if `align="right"`. */
	    alignRight: {
	      textAlign: 'right'
	    },
	
	    /* Styles applied to the root element if `align="justify"`. */
	    alignJustify: {
	      textAlign: 'justify'
	    },
	
	    /* Styles applied to the root element if `nowrap={true}`. */
	    noWrap: {
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the root element if `gutterBottom={true}`. */
	    gutterBottom: {
	      marginBottom: '0.35em'
	    },
	
	    /* Styles applied to the root element if `paragraph={true}`. */
	    paragraph: {
	      marginBottom: 16
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="textPrimary"`. */
	    colorTextPrimary: {
	      color: theme.palette.text.primary
	    },
	
	    /* Styles applied to the root element if `color="textSecondary"`. */
	    colorTextSecondary: {
	      color: theme.palette.text.secondary
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `display="inline"`. */
	    displayInline: {
	      display: 'inline'
	    },
	
	    /* Styles applied to the root element if `display="block"`. */
	    displayBlock: {
	      display: 'block'
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultVariantMapping = {
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  subtitle1: 'h6',
	  subtitle2: 'h6',
	  body1: 'p',
	  body2: 'p'
	};
	var Typography = /*#__PURE__*/React.forwardRef(function Typography(props, ref) {
	  var _props$align = props.align,
	      align = _props$align === void 0 ? 'inherit' : _props$align,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'initial' : _props$color,
	      component = props.component,
	      _props$display = props.display,
	      display = _props$display === void 0 ? 'initial' : _props$display,
	      _props$gutterBottom = props.gutterBottom,
	      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
	      _props$noWrap = props.noWrap,
	      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
	      _props$paragraph = props.paragraph,
	      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'body1' : _props$variant,
	      _props$variantMapping = props.variantMapping,
	      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
	      other = (0, _objectWithoutProperties2.default)(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);
	  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat((0, _capitalize.default)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat((0, _capitalize.default)(align))], display !== 'initial' && classes["display".concat((0, _capitalize.default)(display))]),
	    ref: ref
	  }, other));
	});
	 false ? Typography.propTypes = {
	  /**
	   * Set the text-align on the component.
	   */
	  align: _propTypes.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a HTML element or a component.
	   * Overrides the behavior of the `variantMapping` prop.
	   */
	  component: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .elementType,
	
	  /**
	   * Controls the display type
	   */
	  display: _propTypes.default.oneOf(['initial', 'block', 'inline']),
	
	  /**
	   * If `true`, the text will have a bottom margin.
	   */
	  gutterBottom: _propTypes.default.bool,
	
	  /**
	   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
	   *
	   * Note that text overflow can only happen with block or inline-block level elements
	   * (the element needs to have a width in order to overflow).
	   */
	  noWrap: _propTypes.default.bool,
	
	  /**
	   * If `true`, the text will have a bottom margin.
	   */
	  paragraph: _propTypes.default.bool,
	
	  /**
	   * Applies the theme typography styles.
	   */
	  variant: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit']),
	
	  /**
	   * The component maps the variant prop to a range of different HTML element types.
	   * For instance, subtitle1 to `<h6>`.
	   * If you wish to change that mapping, you can provide your own.
	   * Alternatively, you can use the `component` prop.
	   */
	  variantMapping: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTypography'
	})(Typography);
	
	exports.default = _default;

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(45));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(68));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	var _utils = __webpack_require__(22);
	
	/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */
	
	/**
	 * Utility component that locks focus inside the component.
	 */
	function Unstable_TrapFocus(props) {
	  var children = props.children,
	      _props$disableAutoFoc = props.disableAutoFocus,
	      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
	      _props$disableEnforce = props.disableEnforceFocus,
	      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
	      _props$disableRestore = props.disableRestoreFocus,
	      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
	      getDoc = props.getDoc,
	      isEnabled = props.isEnabled,
	      open = props.open;
	  var ignoreNextEnforceFocus = React.useRef();
	  var sentinelStart = React.useRef(null);
	  var sentinelEnd = React.useRef(null);
	  var nodeToRestore = React.useRef();
	  var rootRef = React.useRef(null); // can be removed once we drop support for non ref forwarding class components
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    rootRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRef = (0, _useForkRef.default)(children.ref, handleOwnRef);
	  var prevOpenRef = React.useRef();
	  React.useEffect(function () {
	    prevOpenRef.current = open;
	  }, [open]);
	
	  if (!prevOpenRef.current && open && typeof window !== 'undefined') {
	    // WARNING: Potentially unsafe in concurrent mode.
	    // The way the read on `nodeToRestore` is setup could make this actually safe.
	    // Say we render `open={false}` -> `open={true}` but never commit.
	    // We have now written a state that wasn't committed. But no committed effect
	    // will read this wrong value. We only read from `nodeToRestore` in effects
	    // that were committed on `open={true}`
	    // WARNING: Prevents the instance from being garbage collected. Should only
	    // hold a weak ref.
	    nodeToRestore.current = getDoc().activeElement;
	  }
	
	  React.useEffect(function () {
	    if (!open) {
	      return;
	    }
	
	    var doc = (0, _ownerDocument.default)(rootRef.current); // We might render an empty child.
	
	    if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
	      if (!rootRef.current.hasAttribute('tabIndex')) {
	        if (false) {
	          console.error(['Material-UI: The modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n'));
	        }
	
	        rootRef.current.setAttribute('tabIndex', -1);
	      }
	
	      rootRef.current.focus();
	    }
	
	    var contain = function contain() {
	      if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
	        ignoreNextEnforceFocus.current = false;
	        return;
	      }
	
	      if (rootRef.current && !rootRef.current.contains(doc.activeElement)) {
	        rootRef.current.focus();
	      }
	    };
	
	    var loopFocus = function loopFocus(event) {
	      // 9 = Tab
	      if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) {
	        return;
	      } // Make sure the next tab starts from the right place.
	
	
	      if (doc.activeElement === rootRef.current) {
	        // We need to ignore the next contain as
	        // it will try to move the focus back to the rootRef element.
	        ignoreNextEnforceFocus.current = true;
	
	        if (event.shiftKey) {
	          sentinelEnd.current.focus();
	        } else {
	          sentinelStart.current.focus();
	        }
	      }
	    };
	
	    doc.addEventListener('focus', contain, true);
	    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
	    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
	    //
	    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
	    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
	
	    var interval = setInterval(function () {
	      contain();
	    }, 50);
	    return function () {
	      clearInterval(interval);
	      doc.removeEventListener('focus', contain, true);
	      doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()
	
	      if (!disableRestoreFocus) {
	        // In IE 11 it is possible for document.activeElement to be null resulting
	        // in nodeToRestore.current being null.
	        // Not all elements in IE 11 have a focus method.
	        // Once IE 11 support is dropped the focus() call can be unconditional.
	        if (nodeToRestore.current && nodeToRestore.current.focus) {
	          nodeToRestore.current.focus();
	        }
	
	        nodeToRestore.current = null;
	      }
	    };
	  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open]);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
	    tabIndex: 0,
	    ref: sentinelStart,
	    "data-test": "sentinelStart"
	  }), /*#__PURE__*/React.cloneElement(children, {
	    ref: handleRef
	  }), /*#__PURE__*/React.createElement("div", {
	    tabIndex: 0,
	    ref: sentinelEnd,
	    "data-test": "sentinelEnd"
	  }));
	}
	
	 false ? Unstable_TrapFocus.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * If `true`, the trap focus will not automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes.
	   * This also works correctly with any trap focus children that have the `disableAutoFocus` prop.
	   *
	   * Generally this should never be set to `true` as it makes the trap focus less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableAutoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the trap focus will not prevent focus from leaving the trap focus while open.
	   *
	   * Generally this should never be set to `true` as it makes the trap focus less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableEnforceFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the trap focus will not restore focus to previously focused element once
	   * trap focus is hidden.
	   */
	  disableRestoreFocus: _propTypes.default.bool,
	
	  /**
	   * Return the document to consider.
	   * We use it to implement the restore focus between different browser documents.
	   */
	  getDoc: _propTypes.default.func.isRequired,
	
	  /**
	   * Do we still want to enforce the focus?
	   * This prop helps nesting TrapFocus elements.
	   */
	  isEnabled: _propTypes.default.func.isRequired,
	
	  /**
	   * If `true`, focus will be locked.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  Unstable_TrapFocus['propTypes' + ''] = (0, _utils.exactProp)(Unstable_TrapFocus.propTypes);
	}
	
	var _default = Unstable_TrapFocus;
	exports.default = _default;

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _reactTransitionGroup = __webpack_require__(123);
	
	var _transitions = __webpack_require__(74);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(47));
	
	var _utils = __webpack_require__(110);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(42));
	
	var styles = {
	  entering: {
	    transform: 'none'
	  },
	  entered: {
	    transform: 'none'
	  }
	};
	var defaultTimeout = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The Zoom transition can be used for the floating variant of the
	 * [Button](/components/buttons/#floating-action-buttons) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Zoom = /*#__PURE__*/React.forwardRef(function Zoom(props, ref) {
	  var children = props.children,
	      _props$disableStrictM = props.disableStrictModeCompat,
	      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _reactTransitionGroup.Transition : _props$TransitionComp,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);
	  var theme = (0, _useTheme.default)();
	  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
	  var nodeRef = React.useRef(null);
	  var foreignRef = (0, _useForkRef.default)(children.ref, ref);
	  var handleRef = (0, _useForkRef.default)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
	
	  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
	    return function (nodeOrAppearing, maybeAppearing) {
	      if (callback) {
	        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
	            _ref2 = (0, _slicedToArray2.default)(_ref, 2),
	            node = _ref2[0],
	            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
	
	
	        if (isAppearing === undefined) {
	          callback(node);
	        } else {
	          callback(node, isAppearing);
	        }
	      }
	    };
	  };
	
	  var handleEntering = normalizedTransitionCallback(onEntering);
	  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
	    (0, _utils.reflow)(node); // So the animation always start from the start.
	
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    });
	    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
	    node.style.transition = theme.transitions.create('transform', transitionProps);
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  });
	  var handleEntered = normalizedTransitionCallback(onEntered);
	  var handleExiting = normalizedTransitionCallback(onExiting);
	  var handleExit = normalizedTransitionCallback(function (node) {
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    });
	    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
	    node.style.transition = theme.transitions.create('transform', transitionProps);
	
	    if (onExit) {
	      onExit(node);
	    }
	  });
	  var handleExited = normalizedTransitionCallback(onExited);
	  return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: inProp,
	    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
	    onEnter: handleEnter,
	    onEntered: handleEntered,
	    onEntering: handleEntering,
	    onExit: handleExit,
	    onExited: handleExited,
	    onExiting: handleExiting,
	    timeout: timeout
	  }, other), function (state, childProps) {
	    return /*#__PURE__*/React.cloneElement(children, (0, _extends2.default)({
	      style: (0, _extends2.default)({
	        transform: 'scale(0)',
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, styles[state], style, children.props.style),
	      ref: handleRef
	    }, childProps));
	  });
	});
	 false ? Zoom.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * Enable this prop if you encounter 'Function components cannot be given refs',
	   * use `unstable_createStrictModeTheme`,
	   * and can't forward the ref in the child component.
	   */
	  disableStrictModeCompat: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	var _default = Zoom;
	exports.default = _default;

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Zoom.default;
	  }
	});
	
	var _Zoom = _interopRequireDefault(__webpack_require__(999));

/***/ },
/* 1001 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var amber = {
	  50: '#fff8e1',
	  100: '#ffecb3',
	  200: '#ffe082',
	  300: '#ffd54f',
	  400: '#ffca28',
	  500: '#ffc107',
	  600: '#ffb300',
	  700: '#ffa000',
	  800: '#ff8f00',
	  900: '#ff6f00',
	  A100: '#ffe57f',
	  A200: '#ffd740',
	  A400: '#ffc400',
	  A700: '#ffab00'
	};
	var _default = amber;
	exports.default = _default;

/***/ },
/* 1002 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var blueGrey = {
	  50: '#eceff1',
	  100: '#cfd8dc',
	  200: '#b0bec5',
	  300: '#90a4ae',
	  400: '#78909c',
	  500: '#607d8b',
	  600: '#546e7a',
	  700: '#455a64',
	  800: '#37474f',
	  900: '#263238',
	  A100: '#cfd8dc',
	  A200: '#b0bec5',
	  A400: '#78909c',
	  A700: '#455a64'
	};
	var _default = blueGrey;
	exports.default = _default;

/***/ },
/* 1003 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var brown = {
	  50: '#efebe9',
	  100: '#d7ccc8',
	  200: '#bcaaa4',
	  300: '#a1887f',
	  400: '#8d6e63',
	  500: '#795548',
	  600: '#6d4c41',
	  700: '#5d4037',
	  800: '#4e342e',
	  900: '#3e2723',
	  A100: '#d7ccc8',
	  A200: '#bcaaa4',
	  A400: '#8d6e63',
	  A700: '#5d4037'
	};
	var _default = brown;
	exports.default = _default;

/***/ },
/* 1004 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var cyan = {
	  50: '#e0f7fa',
	  100: '#b2ebf2',
	  200: '#80deea',
	  300: '#4dd0e1',
	  400: '#26c6da',
	  500: '#00bcd4',
	  600: '#00acc1',
	  700: '#0097a7',
	  800: '#00838f',
	  900: '#006064',
	  A100: '#84ffff',
	  A200: '#18ffff',
	  A400: '#00e5ff',
	  A700: '#00b8d4'
	};
	var _default = cyan;
	exports.default = _default;

/***/ },
/* 1005 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var deepOrange = {
	  50: '#fbe9e7',
	  100: '#ffccbc',
	  200: '#ffab91',
	  300: '#ff8a65',
	  400: '#ff7043',
	  500: '#ff5722',
	  600: '#f4511e',
	  700: '#e64a19',
	  800: '#d84315',
	  900: '#bf360c',
	  A100: '#ff9e80',
	  A200: '#ff6e40',
	  A400: '#ff3d00',
	  A700: '#dd2c00'
	};
	var _default = deepOrange;
	exports.default = _default;

/***/ },
/* 1006 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var deepPurple = {
	  50: '#ede7f6',
	  100: '#d1c4e9',
	  200: '#b39ddb',
	  300: '#9575cd',
	  400: '#7e57c2',
	  500: '#673ab7',
	  600: '#5e35b1',
	  700: '#512da8',
	  800: '#4527a0',
	  900: '#311b92',
	  A100: '#b388ff',
	  A200: '#7c4dff',
	  A400: '#651fff',
	  A700: '#6200ea'
	};
	var _default = deepPurple;
	exports.default = _default;

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "common", {
	  enumerable: true,
	  get: function get() {
	    return _common.default;
	  }
	});
	Object.defineProperty(exports, "red", {
	  enumerable: true,
	  get: function get() {
	    return _red.default;
	  }
	});
	Object.defineProperty(exports, "pink", {
	  enumerable: true,
	  get: function get() {
	    return _pink.default;
	  }
	});
	Object.defineProperty(exports, "purple", {
	  enumerable: true,
	  get: function get() {
	    return _purple.default;
	  }
	});
	Object.defineProperty(exports, "deepPurple", {
	  enumerable: true,
	  get: function get() {
	    return _deepPurple.default;
	  }
	});
	Object.defineProperty(exports, "indigo", {
	  enumerable: true,
	  get: function get() {
	    return _indigo.default;
	  }
	});
	Object.defineProperty(exports, "blue", {
	  enumerable: true,
	  get: function get() {
	    return _blue.default;
	  }
	});
	Object.defineProperty(exports, "lightBlue", {
	  enumerable: true,
	  get: function get() {
	    return _lightBlue.default;
	  }
	});
	Object.defineProperty(exports, "cyan", {
	  enumerable: true,
	  get: function get() {
	    return _cyan.default;
	  }
	});
	Object.defineProperty(exports, "teal", {
	  enumerable: true,
	  get: function get() {
	    return _teal.default;
	  }
	});
	Object.defineProperty(exports, "green", {
	  enumerable: true,
	  get: function get() {
	    return _green.default;
	  }
	});
	Object.defineProperty(exports, "lightGreen", {
	  enumerable: true,
	  get: function get() {
	    return _lightGreen.default;
	  }
	});
	Object.defineProperty(exports, "lime", {
	  enumerable: true,
	  get: function get() {
	    return _lime.default;
	  }
	});
	Object.defineProperty(exports, "yellow", {
	  enumerable: true,
	  get: function get() {
	    return _yellow.default;
	  }
	});
	Object.defineProperty(exports, "amber", {
	  enumerable: true,
	  get: function get() {
	    return _amber.default;
	  }
	});
	Object.defineProperty(exports, "orange", {
	  enumerable: true,
	  get: function get() {
	    return _orange.default;
	  }
	});
	Object.defineProperty(exports, "deepOrange", {
	  enumerable: true,
	  get: function get() {
	    return _deepOrange.default;
	  }
	});
	Object.defineProperty(exports, "brown", {
	  enumerable: true,
	  get: function get() {
	    return _brown.default;
	  }
	});
	Object.defineProperty(exports, "grey", {
	  enumerable: true,
	  get: function get() {
	    return _grey.default;
	  }
	});
	Object.defineProperty(exports, "blueGrey", {
	  enumerable: true,
	  get: function get() {
	    return _blueGrey.default;
	  }
	});
	
	var _common = _interopRequireDefault(__webpack_require__(382));
	
	var _red = _interopRequireDefault(__webpack_require__(388));
	
	var _pink = _interopRequireDefault(__webpack_require__(387));
	
	var _purple = _interopRequireDefault(__webpack_require__(1011));
	
	var _deepPurple = _interopRequireDefault(__webpack_require__(1006));
	
	var _indigo = _interopRequireDefault(__webpack_require__(385));
	
	var _blue = _interopRequireDefault(__webpack_require__(381));
	
	var _lightBlue = _interopRequireDefault(__webpack_require__(1008));
	
	var _cyan = _interopRequireDefault(__webpack_require__(1004));
	
	var _teal = _interopRequireDefault(__webpack_require__(1012));
	
	var _green = _interopRequireDefault(__webpack_require__(383));
	
	var _lightGreen = _interopRequireDefault(__webpack_require__(1009));
	
	var _lime = _interopRequireDefault(__webpack_require__(1010));
	
	var _yellow = _interopRequireDefault(__webpack_require__(1013));
	
	var _amber = _interopRequireDefault(__webpack_require__(1001));
	
	var _orange = _interopRequireDefault(__webpack_require__(386));
	
	var _deepOrange = _interopRequireDefault(__webpack_require__(1005));
	
	var _brown = _interopRequireDefault(__webpack_require__(1003));
	
	var _grey = _interopRequireDefault(__webpack_require__(384));
	
	var _blueGrey = _interopRequireDefault(__webpack_require__(1002));

/***/ },
/* 1008 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var lightBlue = {
	  50: '#e1f5fe',
	  100: '#b3e5fc',
	  200: '#81d4fa',
	  300: '#4fc3f7',
	  400: '#29b6f6',
	  500: '#03a9f4',
	  600: '#039be5',
	  700: '#0288d1',
	  800: '#0277bd',
	  900: '#01579b',
	  A100: '#80d8ff',
	  A200: '#40c4ff',
	  A400: '#00b0ff',
	  A700: '#0091ea'
	};
	var _default = lightBlue;
	exports.default = _default;

/***/ },
/* 1009 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var lightGreen = {
	  50: '#f1f8e9',
	  100: '#dcedc8',
	  200: '#c5e1a5',
	  300: '#aed581',
	  400: '#9ccc65',
	  500: '#8bc34a',
	  600: '#7cb342',
	  700: '#689f38',
	  800: '#558b2f',
	  900: '#33691e',
	  A100: '#ccff90',
	  A200: '#b2ff59',
	  A400: '#76ff03',
	  A700: '#64dd17'
	};
	var _default = lightGreen;
	exports.default = _default;

/***/ },
/* 1010 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var lime = {
	  50: '#f9fbe7',
	  100: '#f0f4c3',
	  200: '#e6ee9c',
	  300: '#dce775',
	  400: '#d4e157',
	  500: '#cddc39',
	  600: '#c0ca33',
	  700: '#afb42b',
	  800: '#9e9d24',
	  900: '#827717',
	  A100: '#f4ff81',
	  A200: '#eeff41',
	  A400: '#c6ff00',
	  A700: '#aeea00'
	};
	var _default = lime;
	exports.default = _default;

/***/ },
/* 1011 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var purple = {
	  50: '#f3e5f5',
	  100: '#e1bee7',
	  200: '#ce93d8',
	  300: '#ba68c8',
	  400: '#ab47bc',
	  500: '#9c27b0',
	  600: '#8e24aa',
	  700: '#7b1fa2',
	  800: '#6a1b9a',
	  900: '#4a148c',
	  A100: '#ea80fc',
	  A200: '#e040fb',
	  A400: '#d500f9',
	  A700: '#aa00ff'
	};
	var _default = purple;
	exports.default = _default;

/***/ },
/* 1012 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var teal = {
	  50: '#e0f2f1',
	  100: '#b2dfdb',
	  200: '#80cbc4',
	  300: '#4db6ac',
	  400: '#26a69a',
	  500: '#009688',
	  600: '#00897b',
	  700: '#00796b',
	  800: '#00695c',
	  900: '#004d40',
	  A100: '#a7ffeb',
	  A200: '#64ffda',
	  A400: '#1de9b6',
	  A700: '#00bfa5'
	};
	var _default = teal;
	exports.default = _default;

/***/ },
/* 1013 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var yellow = {
	  50: '#fffde7',
	  100: '#fff9c4',
	  200: '#fff59d',
	  300: '#fff176',
	  400: '#ffee58',
	  500: '#ffeb3b',
	  600: '#fdd835',
	  700: '#fbc02d',
	  800: '#f9a825',
	  900: '#f57f17',
	  A100: '#ffff8d',
	  A200: '#ffff00',
	  A400: '#ffea00',
	  A700: '#ffd600'
	};
	var _default = yellow;
	exports.default = _default;

/***/ },
/* 1014 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = animate;
	
	function easeInOutSin(time) {
	  return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
	}
	
	function animate(property, element, to) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
	  var _options$ease = options.ease,
	      ease = _options$ease === void 0 ? easeInOutSin : _options$ease,
	      _options$duration = options.duration,
	      duration = _options$duration === void 0 ? 300 : _options$duration;
	  var start = null;
	  var from = element[property];
	  var cancelled = false;
	
	  var cancel = function cancel() {
	    cancelled = true;
	  };
	
	  var step = function step(timestamp) {
	    if (cancelled) {
	      cb(new Error('Animation cancelled'));
	      return;
	    }
	
	    if (start === null) {
	      start = timestamp;
	    }
	
	    var time = Math.min(1, (timestamp - start) / duration);
	    element[property] = ease(time) * (to - from) + from;
	
	    if (time >= 1) {
	      requestAnimationFrame(function () {
	        cb(null);
	      });
	      return;
	    }
	
	    requestAnimationFrame(step);
	  };
	
	  if (from === to) {
	    cb(new Error('Element already at target position'));
	    return cancel;
	  }
	
	  requestAnimationFrame(step);
	  return cancel;
	}

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(57));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
	}), 'ArrowDownward');
	
	exports.default = _default;

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(57));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
	}), 'Cancel');
	
	exports.default = _default;

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(57));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
	}), 'CheckBox');
	
	exports.default = _default;

/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(57));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'CheckBoxOutlineBlank');
	
	exports.default = _default;

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(57));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
	}), 'CheckCircle');
	
	exports.default = _default;

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(57));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
	}), 'IndeterminateCheckBox');
	
	exports.default = _default;

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(57));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'MoreHoriz');
	
	exports.default = _default;

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(57));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
	}), 'Person');
	
	exports.default = _default;

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(57));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
	}), 'RadioButtonChecked');
	
	exports.default = _default;

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(57));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'RadioButtonUnchecked');
	
	exports.default = _default;

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(57));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
	}), 'Warning');
	
	exports.default = _default;

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.1-lts
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
	
	var timeoutDuration = function () {
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      return 1;
	    }
	  }
	  return 0;
	}();
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the reference node of the reference object, or the reference object itself.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	 * @returns {Element} parent
	 */
	function getReferenceNode(reference) {
	  return reference && reference.referenceNode ? reference.referenceNode : reference;
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.width;
	  var height = sizes.height || element.clientHeight || result.height;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop);
	    var marginLeft = parseFloat(styles.marginLeft);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicitly asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1027 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createMixins;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(4));
	
	function createMixins(breakpoints, spacing, mixins) {
	  var _toolbar;
	
	  return (0, _extends3.default)({
	    gutters: function gutters() {
	      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      // To deprecate in v4.1
	      //       warning(
	      //         false,
	      //         [
	      //           'Material-UI: Theme.mixins.gutters() is deprecated.',
	      //           'You can use the source of the mixin directly:',
	      //           `
	      // paddingLeft: theme.spacing(2),
	      // paddingRight: theme.spacing(2),
	      // [theme.breakpoints.up('sm')]: {
	      //   paddingLeft: theme.spacing(3),
	      //   paddingRight: theme.spacing(3),
	      // },
	      // `,
	      //         ].join('\n'),
	      //       );
	      return (0, _extends3.default)({
	        paddingLeft: spacing(2),
	        paddingRight: spacing(2)
	      }, styles, (0, _defineProperty2.default)({}, breakpoints.up('sm'), (0, _extends3.default)({
	        paddingLeft: spacing(3),
	        paddingRight: spacing(3)
	      }, styles[breakpoints.up('sm')])));
	    },
	    toolbar: (_toolbar = {
	      minHeight: 56
	    }, (0, _defineProperty2.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
	      minHeight: 48
	    }), (0, _defineProperty2.default)(_toolbar, breakpoints.up('sm'), {
	      minHeight: 64
	    }), _toolbar)
	  }, mixins);
	}

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createMuiStrictModeTheme;
	
	var _utils = __webpack_require__(22);
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(239));
	
	function createMuiStrictModeTheme(options) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return _createMuiTheme.default.apply(void 0, [(0, _utils.deepmerge)({
	    unstable_strictMode: true
	  }, options)].concat(args));
	}

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPalette;
	exports.dark = exports.light = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _utils = __webpack_require__(22);
	
	var _common = _interopRequireDefault(__webpack_require__(382));
	
	var _grey = _interopRequireDefault(__webpack_require__(384));
	
	var _indigo = _interopRequireDefault(__webpack_require__(385));
	
	var _pink = _interopRequireDefault(__webpack_require__(387));
	
	var _red = _interopRequireDefault(__webpack_require__(388));
	
	var _orange = _interopRequireDefault(__webpack_require__(386));
	
	var _blue = _interopRequireDefault(__webpack_require__(381));
	
	var _green = _interopRequireDefault(__webpack_require__(383));
	
	var _colorManipulator = __webpack_require__(49);
	
	var light = {
	  // The colors used to style the text.
	  text: {
	    // The most important text.
	    primary: 'rgba(0, 0, 0, 0.87)',
	    // Secondary text.
	    secondary: 'rgba(0, 0, 0, 0.54)',
	    // Disabled text have even lower visual prominence.
	    disabled: 'rgba(0, 0, 0, 0.38)',
	    // Text hints.
	    hint: 'rgba(0, 0, 0, 0.38)'
	  },
	  // The color used to divide different elements.
	  divider: 'rgba(0, 0, 0, 0.12)',
	  // The background colors used to style the surfaces.
	  // Consistency between these values is important.
	  background: {
	    paper: _common.default.white,
	    default: _grey.default[50]
	  },
	  // The colors used to style the action elements.
	  action: {
	    // The color of an active action like an icon button.
	    active: 'rgba(0, 0, 0, 0.54)',
	    // The color of an hovered action.
	    hover: 'rgba(0, 0, 0, 0.04)',
	    hoverOpacity: 0.04,
	    // The color of a selected action.
	    selected: 'rgba(0, 0, 0, 0.08)',
	    selectedOpacity: 0.08,
	    // The color of a disabled action.
	    disabled: 'rgba(0, 0, 0, 0.26)',
	    // The background color of a disabled action.
	    disabledBackground: 'rgba(0, 0, 0, 0.12)',
	    disabledOpacity: 0.38,
	    focus: 'rgba(0, 0, 0, 0.12)',
	    focusOpacity: 0.12,
	    activatedOpacity: 0.12
	  }
	};
	exports.light = light;
	var dark = {
	  text: {
	    primary: _common.default.white,
	    secondary: 'rgba(255, 255, 255, 0.7)',
	    disabled: 'rgba(255, 255, 255, 0.5)',
	    hint: 'rgba(255, 255, 255, 0.5)',
	    icon: 'rgba(255, 255, 255, 0.5)'
	  },
	  divider: 'rgba(255, 255, 255, 0.12)',
	  background: {
	    paper: _grey.default[800],
	    default: '#303030'
	  },
	  action: {
	    active: _common.default.white,
	    hover: 'rgba(255, 255, 255, 0.08)',
	    hoverOpacity: 0.08,
	    selected: 'rgba(255, 255, 255, 0.16)',
	    selectedOpacity: 0.16,
	    disabled: 'rgba(255, 255, 255, 0.3)',
	    disabledBackground: 'rgba(255, 255, 255, 0.12)',
	    disabledOpacity: 0.38,
	    focus: 'rgba(255, 255, 255, 0.12)',
	    focusOpacity: 0.12,
	    activatedOpacity: 0.24
	  }
	};
	exports.dark = dark;
	
	function addLightOrDark(intent, direction, shade, tonalOffset) {
	  var tonalOffsetLight = tonalOffset.light || tonalOffset;
	  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
	
	  if (!intent[direction]) {
	    if (intent.hasOwnProperty(shade)) {
	      intent[direction] = intent[shade];
	    } else if (direction === 'light') {
	      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffsetLight);
	    } else if (direction === 'dark') {
	      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffsetDark);
	    }
	  }
	}
	
	function createPalette(palette) {
	  var _palette$primary = palette.primary,
	      primary = _palette$primary === void 0 ? {
	    light: _indigo.default[300],
	    main: _indigo.default[500],
	    dark: _indigo.default[700]
	  } : _palette$primary,
	      _palette$secondary = palette.secondary,
	      secondary = _palette$secondary === void 0 ? {
	    light: _pink.default.A200,
	    main: _pink.default.A400,
	    dark: _pink.default.A700
	  } : _palette$secondary,
	      _palette$error = palette.error,
	      error = _palette$error === void 0 ? {
	    light: _red.default[300],
	    main: _red.default[500],
	    dark: _red.default[700]
	  } : _palette$error,
	      _palette$warning = palette.warning,
	      warning = _palette$warning === void 0 ? {
	    light: _orange.default[300],
	    main: _orange.default[500],
	    dark: _orange.default[700]
	  } : _palette$warning,
	      _palette$info = palette.info,
	      info = _palette$info === void 0 ? {
	    light: _blue.default[300],
	    main: _blue.default[500],
	    dark: _blue.default[700]
	  } : _palette$info,
	      _palette$success = palette.success,
	      success = _palette$success === void 0 ? {
	    light: _green.default[300],
	    main: _green.default[500],
	    dark: _green.default[700]
	  } : _palette$success,
	      _palette$type = palette.type,
	      type = _palette$type === void 0 ? 'light' : _palette$type,
	      _palette$contrastThre = palette.contrastThreshold,
	      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
	      _palette$tonalOffset = palette.tonalOffset,
	      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
	      other = (0, _objectWithoutProperties2.default)(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
	  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
	  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
	
	  function getContrastText(background) {
	    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
	
	    if (false) {
	      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
	
	      if (contrast < 3) {
	        console.error(["Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
	      }
	    }
	
	    return contrastText;
	  }
	
	  var augmentColor = function augmentColor(color) {
	    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
	    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
	    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
	    color = (0, _extends2.default)({}, color);
	
	    if (!color.main && color[mainShade]) {
	      color.main = color[mainShade];
	    }
	
	    if (!color.main) {
	      throw new Error( false ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(mainShade, "` property.") : (0, _utils.formatMuiErrorMessage)(4, mainShade));
	    }
	
	    if (typeof color.main !== 'string') {
	      throw new Error( false ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport {\xA0green } from \"@material-ui/core/colors\";\n\nconst theme1 = createMuiTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createMuiTheme({ palette: {\n  primary: { main: green[500] },\n} });") : _formatMuiErrorMessage(5, JSON.stringify(color.main)));
	    }
	
	    addLightOrDark(color, 'light', lightShade, tonalOffset);
	    addLightOrDark(color, 'dark', darkShade, tonalOffset);
	
	    if (!color.contrastText) {
	      color.contrastText = getContrastText(color.main);
	    }
	
	    return color;
	  };
	
	  var types = {
	    dark: dark,
	    light: light
	  };
	
	  if (false) {
	    if (!types[type]) {
	      console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
	    }
	  }
	
	  var paletteOutput = (0, _utils.deepmerge)((0, _extends2.default)({
	    // A collection of common colors.
	    common: _common.default,
	    // The palette type, can be light or dark.
	    type: type,
	    // The colors used to represent primary interface elements for a user.
	    primary: augmentColor(primary),
	    // The colors used to represent secondary interface elements for a user.
	    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
	    // The colors used to represent interface elements that the user should be made aware of.
	    error: augmentColor(error),
	    // The colors used to represent potentially dangerous actions or important messages.
	    warning: augmentColor(warning),
	    // The colors used to present information to the user that is neutral and not necessarily important.
	    info: augmentColor(info),
	    // The colors used to indicate the successful completion of an action that user triggered.
	    success: augmentColor(success),
	    // The grey colors.
	    grey: _grey.default,
	    // Used by `getContrastText()` to maximize the contrast between
	    // the background and the text.
	    contrastThreshold: contrastThreshold,
	    // Takes a background color and returns the text color that maximizes the contrast.
	    getContrastText: getContrastText,
	    // Generate a rich color object.
	    augmentColor: augmentColor,
	    // Used by the functions below to shift a color's luminance by approximately
	    // two indexes within its tonal palette.
	    // E.g., shift from Red 500 to Red 300 or Red 700.
	    tonalOffset: tonalOffset
	  }, types[type]), other);
	  return paletteOutput;
	}

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSpacing;
	
	var _system = __webpack_require__(406);
	
	var warnOnce;
	
	function createSpacing() {
	  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
	
	  // Already transformed.
	  if (spacingInput.mui) {
	    return spacingInput;
	  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
	  // Smaller components, such as icons and type, can align to a 4dp grid.
	  // https://material.io/design/layout/understanding-layout.html#usage
	
	
	  var transform = (0, _system.createUnarySpacing)({
	    spacing: spacingInput
	  });
	
	  var spacing = function spacing() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (false) {
	      if (!(args.length <= 4)) {
	        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
	      }
	    }
	
	    if (args.length === 0) {
	      return transform(1);
	    }
	
	    if (args.length === 1) {
	      return transform(args[0]);
	    }
	
	    return args.map(function (argument) {
	      if (typeof argument === 'string') {
	        return argument;
	      }
	
	      var output = transform(argument);
	      return typeof output === 'number' ? "".concat(output, "px") : output;
	    }).join(' ');
	  }; // Backward compatibility, to remove in v5.
	
	
	  Object.defineProperty(spacing, 'unit', {
	    get: function get() {
	      if (false) {
	        if (!warnOnce || process.env.NODE_ENV === 'test') {
	          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
	        }
	
	        warnOnce = true;
	      }
	
	      return spacingInput;
	    }
	  });
	  spacing.mui = true;
	  return spacing;
	}

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createStyles;
	
	var _styles = __webpack_require__(60);
	
	// let warnOnce = false;
	// To remove in v5
	function createStyles(styles) {
	  // warning(
	  //   warnOnce,
	  //   [
	  //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
	  //     'Please use @material-ui/styles/createStyles',
	  //   ].join('\n'),
	  // );
	  // warnOnce = true;
	  return (0, _styles.createStyles)(styles);
	}

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createTypography;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _utils = __webpack_require__(22);
	
	function round(value) {
	  return Math.round(value * 1e5) / 1e5;
	}
	
	var caseAllCaps = {
	  textTransform: 'uppercase'
	};
	var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
	/**
	 * @see @link{https://material.io/design/typography/the-type-system.html}
	 * @see @link{https://material.io/design/typography/understanding-typography.html}
	 */
	
	function createTypography(palette, typography) {
	  var _ref = typeof typography === 'function' ? typography(palette) : typography,
	      _ref$fontFamily = _ref.fontFamily,
	      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
	      _ref$fontSize = _ref.fontSize,
	      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
	      _ref$fontWeightLight = _ref.fontWeightLight,
	      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
	      _ref$fontWeightRegula = _ref.fontWeightRegular,
	      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
	      _ref$fontWeightMedium = _ref.fontWeightMedium,
	      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
	      _ref$fontWeightBold = _ref.fontWeightBold,
	      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
	      _ref$htmlFontSize = _ref.htmlFontSize,
	      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
	      allVariants = _ref.allVariants,
	      pxToRem2 = _ref.pxToRem,
	      other = (0, _objectWithoutProperties2.default)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
	
	  if (false) {
	    if (typeof fontSize !== 'number') {
	      console.error('Material-UI: `fontSize` is required to be a number.');
	    }
	
	    if (typeof htmlFontSize !== 'number') {
	      console.error('Material-UI: `htmlFontSize` is required to be a number.');
	    }
	  }
	
	  var coef = fontSize / 14;
	
	  var pxToRem = pxToRem2 || function (size) {
	    return "".concat(size / htmlFontSize * coef, "rem");
	  };
	
	  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
	    return (0, _extends2.default)({
	      fontFamily: fontFamily,
	      fontWeight: fontWeight,
	      fontSize: pxToRem(size),
	      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
	      lineHeight: lineHeight
	    }, fontFamily === defaultFontFamily ? {
	      letterSpacing: "".concat(round(letterSpacing / size), "em")
	    } : {}, casing, allVariants);
	  };
	
	  var variants = {
	    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
	    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
	    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
	    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
	    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
	    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
	    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
	    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
	    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
	    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
	    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
	    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
	    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
	  };
	  return (0, _utils.deepmerge)((0, _extends2.default)({
	    htmlFontSize: htmlFontSize,
	    pxToRem: pxToRem,
	    round: round,
	    // TODO v5: remove
	    fontFamily: fontFamily,
	    fontSize: fontSize,
	    fontWeightLight: fontWeightLight,
	    fontWeightRegular: fontWeightRegular,
	    fontWeightMedium: fontWeightMedium,
	    fontWeightBold: fontWeightBold
	  }, variants), other, {
	    clone: false // No need to clone deep
	
	  });
	}

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isUnitless = isUnitless;
	exports.getUnit = getUnit;
	exports.toUnitless = toUnitless;
	exports.convertLength = convertLength;
	exports.alignProperty = alignProperty;
	exports.fontGrid = fontGrid;
	exports.responsiveProperty = responsiveProperty;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	function isUnitless(value) {
	  return String(parseFloat(value)).length === String(value).length;
	} // Ported from Compass
	// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
	// Emulate the sass function "unit"
	
	
	function getUnit(input) {
	  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
	} // Emulate the sass function "unitless"
	
	
	function toUnitless(length) {
	  return parseFloat(length);
	} // Convert any CSS <length> or <percentage> value to any another.
	// From https://github.com/KyleAMathews/convert-css-length
	
	
	function convertLength(baseFontSize) {
	  return function (length, toUnit) {
	    var fromUnit = getUnit(length); // Optimize for cases where `from` and `to` units are accidentally the same.
	
	    if (fromUnit === toUnit) {
	      return length;
	    } // Convert input length to pixels.
	
	
	    var pxLength = toUnitless(length);
	
	    if (fromUnit !== 'px') {
	      if (fromUnit === 'em') {
	        pxLength = toUnitless(length) * toUnitless(baseFontSize);
	      } else if (fromUnit === 'rem') {
	        pxLength = toUnitless(length) * toUnitless(baseFontSize);
	        return length;
	      }
	    } // Convert length in pixels to the output unit
	
	
	    var outputLength = pxLength;
	
	    if (toUnit !== 'px') {
	      if (toUnit === 'em') {
	        outputLength = pxLength / toUnitless(baseFontSize);
	      } else if (toUnit === 'rem') {
	        outputLength = pxLength / toUnitless(baseFontSize);
	      } else {
	        return length;
	      }
	    }
	
	    return parseFloat(outputLength.toFixed(5)) + toUnit;
	  };
	}
	
	function alignProperty(_ref) {
	  var size = _ref.size,
	      grid = _ref.grid;
	  var sizeBelow = size - size % grid;
	  var sizeAbove = sizeBelow + grid;
	  return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
	} // fontGrid finds a minimal grid (in rem) for the fontSize values so that the
	// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
	// without changing the relative line height
	
	
	function fontGrid(_ref2) {
	  var lineHeight = _ref2.lineHeight,
	      pixels = _ref2.pixels,
	      htmlFontSize = _ref2.htmlFontSize;
	  return pixels / (lineHeight * htmlFontSize);
	}
	/**
	 * generate a responsive version of a given CSS property
	 * @example
	 * responsiveProperty({
	 *   cssProperty: 'fontSize',
	 *   min: 15,
	 *   max: 20,
	 *   unit: 'px',
	 *   breakpoints: [300, 600],
	 * })
	 *
	 * // this returns
	 *
	 * {
	 *   fontSize: '15px',
	 *   '@media (min-width:300px)': {
	 *     fontSize: '17.5px',
	 *   },
	 *   '@media (min-width:600px)': {
	 *     fontSize: '20px',
	 *   },
	 * }
	 *
	 * @param {Object} params
	 * @param {string} params.cssProperty - The CSS property to be made responsive
	 * @param {number} params.min - The smallest value of the CSS property
	 * @param {number} params.max - The largest value of the CSS property
	 * @param {string} [params.unit] - The unit to be used for the CSS property
	 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
	 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
	 * @returns {Object} responsive styles for {params.cssProperty}
	 */
	
	
	function responsiveProperty(_ref3) {
	  var cssProperty = _ref3.cssProperty,
	      min = _ref3.min,
	      max = _ref3.max,
	      _ref3$unit = _ref3.unit,
	      unit = _ref3$unit === void 0 ? 'rem' : _ref3$unit,
	      _ref3$breakpoints = _ref3.breakpoints,
	      breakpoints = _ref3$breakpoints === void 0 ? [600, 960, 1280] : _ref3$breakpoints,
	      _ref3$transform = _ref3.transform,
	      transform = _ref3$transform === void 0 ? null : _ref3$transform;
	  var output = (0, _defineProperty2.default)({}, cssProperty, "".concat(min).concat(unit));
	  var factor = (max - min) / breakpoints[breakpoints.length - 1];
	  breakpoints.forEach(function (breakpoint) {
	    var value = min + factor * breakpoint;
	
	    if (transform !== null) {
	      value = transform(value);
	    }
	
	    output["@media (min-width:".concat(breakpoint, "px)")] = (0, _defineProperty2.default)({}, cssProperty, "".concat(Math.round(value * 10000) / 10000).concat(unit));
	  });
	  return output;
	}

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  createMuiTheme: true,
	  unstable_createMuiStrictModeTheme: true,
	  createStyles: true,
	  makeStyles: true,
	  responsiveFontSizes: true,
	  styled: true,
	  useTheme: true,
	  withStyles: true,
	  withTheme: true,
	  createGenerateClassName: true,
	  jssPreset: true,
	  ServerStyleSheets: true,
	  StylesProvider: true,
	  MuiThemeProvider: true,
	  ThemeProvider: true
	};
	Object.defineProperty(exports, "createMuiTheme", {
	  enumerable: true,
	  get: function get() {
	    return _createMuiTheme.default;
	  }
	});
	Object.defineProperty(exports, "unstable_createMuiStrictModeTheme", {
	  enumerable: true,
	  get: function get() {
	    return _createMuiStrictModeTheme.default;
	  }
	});
	Object.defineProperty(exports, "createStyles", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	Object.defineProperty(exports, "makeStyles", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	Object.defineProperty(exports, "responsiveFontSizes", {
	  enumerable: true,
	  get: function get() {
	    return _responsiveFontSizes.default;
	  }
	});
	Object.defineProperty(exports, "styled", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	Object.defineProperty(exports, "useTheme", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	Object.defineProperty(exports, "withStyles", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	Object.defineProperty(exports, "withTheme", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	Object.defineProperty(exports, "createGenerateClassName", {
	  enumerable: true,
	  get: function get() {
	    return _styles.createGenerateClassName;
	  }
	});
	Object.defineProperty(exports, "jssPreset", {
	  enumerable: true,
	  get: function get() {
	    return _styles.jssPreset;
	  }
	});
	Object.defineProperty(exports, "ServerStyleSheets", {
	  enumerable: true,
	  get: function get() {
	    return _styles.ServerStyleSheets;
	  }
	});
	Object.defineProperty(exports, "StylesProvider", {
	  enumerable: true,
	  get: function get() {
	    return _styles.StylesProvider;
	  }
	});
	Object.defineProperty(exports, "MuiThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _styles.ThemeProvider;
	  }
	});
	Object.defineProperty(exports, "ThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _styles.ThemeProvider;
	  }
	});
	
	var _colorManipulator = __webpack_require__(49);
	
	Object.keys(_colorManipulator).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _colorManipulator[key];
	    }
	  });
	});
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(239));
	
	var _createMuiStrictModeTheme = _interopRequireDefault(__webpack_require__(1029));
	
	var _createStyles = _interopRequireDefault(__webpack_require__(1032));
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(1036));
	
	var _responsiveFontSizes = _interopRequireDefault(__webpack_require__(1037));
	
	var _styled = _interopRequireDefault(__webpack_require__(393));
	
	var _transitions = __webpack_require__(74);
	
	Object.keys(_transitions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _transitions[key];
	    }
	  });
	});
	
	var _useTheme = _interopRequireDefault(__webpack_require__(47));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(17));
	
	var _withTheme = _interopRequireDefault(__webpack_require__(1040));
	
	var _styles = __webpack_require__(60);

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _styles = __webpack_require__(60);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(129));
	
	function makeStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return (0, _styles.makeStyles)(stylesOrCreator, (0, _extends2.default)({
	    defaultTheme: _defaultTheme.default
	  }, options));
	}
	
	var _default = makeStyles;
	exports.default = _default;

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = responsiveFontSizes;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(22);
	
	var _cssUtils = __webpack_require__(1034);
	
	function responsiveFontSizes(themeInput) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$breakpoints = options.breakpoints,
	      breakpoints = _options$breakpoints === void 0 ? ['sm', 'md', 'lg'] : _options$breakpoints,
	      _options$disableAlign = options.disableAlign,
	      disableAlign = _options$disableAlign === void 0 ? false : _options$disableAlign,
	      _options$factor = options.factor,
	      factor = _options$factor === void 0 ? 2 : _options$factor,
	      _options$variants = options.variants,
	      variants = _options$variants === void 0 ? ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline'] : _options$variants;
	  var theme = (0, _extends2.default)({}, themeInput);
	  theme.typography = (0, _extends2.default)({}, theme.typography);
	  var typography = theme.typography; // Convert between css lengths e.g. em->px or px->rem
	  // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
	
	  var convert = (0, _cssUtils.convertLength)(typography.htmlFontSize);
	  var breakpointValues = breakpoints.map(function (x) {
	    return theme.breakpoints.values[x];
	  });
	  variants.forEach(function (variant) {
	    var style = typography[variant];
	    var remFontSize = parseFloat(convert(style.fontSize, 'rem'));
	
	    if (remFontSize <= 1) {
	      return;
	    }
	
	    var maxFontSize = remFontSize;
	    var minFontSize = 1 + (maxFontSize - 1) / factor;
	    var lineHeight = style.lineHeight;
	
	    if (!(0, _cssUtils.isUnitless)(lineHeight) && !disableAlign) {
	      throw new Error( false ? "Material-UI: Unsupported non-unitless line height with grid alignment.\nUse unitless line heights instead." : (0, _utils.formatMuiErrorMessage)(6));
	    }
	
	    if (!(0, _cssUtils.isUnitless)(lineHeight)) {
	      // make it unitless
	      lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
	    }
	
	    var transform = null;
	
	    if (!disableAlign) {
	      transform = function transform(value) {
	        return (0, _cssUtils.alignProperty)({
	          size: value,
	          grid: (0, _cssUtils.fontGrid)({
	            pixels: 4,
	            lineHeight: lineHeight,
	            htmlFontSize: typography.htmlFontSize
	          })
	        });
	      };
	    }
	
	    typography[variant] = (0, _extends2.default)({}, style, (0, _cssUtils.responsiveProperty)({
	      cssProperty: 'fontSize',
	      min: minFontSize,
	      max: maxFontSize,
	      unit: 'rem',
	      breakpoints: breakpointValues,
	      transform: transform
	    }));
	  });
	  return theme;
	}

/***/ },
/* 1038 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var shadowKeyUmbraOpacity = 0.2;
	var shadowKeyPenumbraOpacity = 0.14;
	var shadowAmbientShadowOpacity = 0.12;
	
	function createShadow() {
	  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
	} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
	
	
	var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
	var _default = shadows;
	exports.default = _default;

/***/ },
/* 1039 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var shape = {
	  borderRadius: 4
	};
	var _default = shape;
	exports.default = _default;

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _styles = __webpack_require__(60);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(129));
	
	var withTheme = (0, _styles.withThemeCreator)({
	  defaultTheme: _defaultTheme.default
	});
	var _default = withTheme;
	exports.default = _default;

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useMediaQuery;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _styles = __webpack_require__(60);
	
	function useMediaQuery(queryInput) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var theme = (0, _styles.useTheme)();
	  var props = (0, _styles.getThemeProps)({
	    theme: theme,
	    name: 'MuiUseMediaQuery',
	    props: {}
	  });
	
	  if (false) {
	    if (typeof queryInput === 'function' && theme === null) {
	      console.error(['Material-UI: The `query` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
	    }
	  }
	
	  var query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
	  query = query.replace(/^@media( ?)/m, ''); // Wait for jsdom to support the match media feature.
	  // All the browsers Material-UI support have this built-in.
	  // This defensive check is here for simplicity.
	  // Most of the time, the match media logic isn't central to people tests.
	
	  var supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
	
	  var _props$options = (0, _extends2.default)({}, props, options),
	      _props$options$defaul = _props$options.defaultMatches,
	      defaultMatches = _props$options$defaul === void 0 ? false : _props$options$defaul,
	      _props$options$matchM = _props$options.matchMedia,
	      matchMedia = _props$options$matchM === void 0 ? supportMatchMedia ? window.matchMedia : null : _props$options$matchM,
	      _props$options$noSsr = _props$options.noSsr,
	      noSsr = _props$options$noSsr === void 0 ? false : _props$options$noSsr,
	      _props$options$ssrMat = _props$options.ssrMatchMedia,
	      ssrMatchMedia = _props$options$ssrMat === void 0 ? null : _props$options$ssrMat;
	
	  var _React$useState = React.useState(function () {
	    if (noSsr && supportMatchMedia) {
	      return matchMedia(query).matches;
	    }
	
	    if (ssrMatchMedia) {
	      return ssrMatchMedia(query).matches;
	    } // Once the component is mounted, we rely on the
	    // event listeners to return the correct matches value.
	
	
	    return defaultMatches;
	  }),
	      match = _React$useState[0],
	      setMatch = _React$useState[1];
	
	  React.useEffect(function () {
	    var active = true;
	
	    if (!supportMatchMedia) {
	      return undefined;
	    }
	
	    var queryList = matchMedia(query);
	
	    var updateMatch = function updateMatch() {
	      // Workaround Safari wrong implementation of matchMedia
	      // TODO can we remove it?
	      // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
	      if (active) {
	        setMatch(queryList.matches);
	      }
	    };
	
	    updateMatch();
	    queryList.addListener(updateMatch);
	    return function () {
	      active = false;
	      queryList.removeListener(updateMatch);
	    };
	  }, [query, matchMedia, supportMatchMedia]);
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useDebugValue({
	      query: query,
	      match: match
	    });
	  }
	
	  return match;
	}

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _useScrollTrigger.default;
	  }
	});
	
	var _useScrollTrigger = _interopRequireDefault(__webpack_require__(1043));

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useScrollTrigger;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	function defaultTrigger(store, options) {
	  var _options$disableHyste = options.disableHysteresis,
	      disableHysteresis = _options$disableHyste === void 0 ? false : _options$disableHyste,
	      _options$threshold = options.threshold,
	      threshold = _options$threshold === void 0 ? 100 : _options$threshold,
	      target = options.target;
	  var previous = store.current;
	
	  if (target) {
	    // Get vertical scroll
	    store.current = target.pageYOffset !== undefined ? target.pageYOffset : target.scrollTop;
	  }
	
	  if (!disableHysteresis && previous !== undefined) {
	    if (store.current < previous) {
	      return false;
	    }
	  }
	
	  return store.current > threshold;
	}
	
	var defaultTarget = typeof window !== 'undefined' ? window : null;
	
	function useScrollTrigger() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$getTrigger = options.getTrigger,
	      getTrigger = _options$getTrigger === void 0 ? defaultTrigger : _options$getTrigger,
	      _options$target = options.target,
	      target = _options$target === void 0 ? defaultTarget : _options$target,
	      other = (0, _objectWithoutProperties2.default)(options, ["getTrigger", "target"]);
	  var store = React.useRef();
	
	  var _React$useState = React.useState(function () {
	    return getTrigger(store, other);
	  }),
	      trigger = _React$useState[0],
	      setTrigger = _React$useState[1];
	
	  React.useEffect(function () {
	    var handleScroll = function handleScroll() {
	      setTrigger(getTrigger(store, (0, _extends2.default)({
	        target: target
	      }, other)));
	    };
	
	    handleScroll(); // Re-evaluate trigger when dependencies change
	
	    target.addEventListener('scroll', handleScroll);
	    return function () {
	      target.removeEventListener('scroll', handleScroll);
	    }; // See Option 3. https://github.com/facebook/react/issues/14476#issuecomment-471199055
	    // eslint-disable-next-line react-hooks/exhaustive-deps
	  }, [target, getTrigger, JSON.stringify(other)]);
	  return trigger;
	}

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecatedPropType;
	
	function deprecatedPropType(validator, reason) {
	  if (true) {
	    return function () {
	      return null;
	    };
	  }
	
	  return function (props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (typeof props[propName] !== 'undefined') {
	      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
	    }
	
	    return null;
	  };
	}

/***/ },
/* 1045 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.detectScrollType = detectScrollType;
	exports.getNormalizedScrollLeft = getNormalizedScrollLeft;
	// Source from https://github.com/alitaheri/normalize-scroll-left
	var cachedType;
	/**
	 * Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
	 *
	 * Types of scrollLeft, assiming scrollWidth=100 and direction is rtl.
	 *
	 * Browser        | Type          | <- Most Left | Most Right -> | Initial
	 * -------------- | ------------- | ------------ | ------------- | -------
	 * WebKit         | default       | 0            | 100           | 100
	 * Firefox/Opera  | negative      | -100         | 0             | 0
	 * IE/Edge        | reverse       | 100          | 0             | 0
	 */
	
	function detectScrollType() {
	  if (cachedType) {
	    return cachedType;
	  }
	
	  var dummy = document.createElement('div');
	  dummy.appendChild(document.createTextNode('ABCD'));
	  dummy.dir = 'rtl';
	  dummy.style.fontSize = '14px';
	  dummy.style.width = '4px';
	  dummy.style.height = '1px';
	  dummy.style.position = 'absolute';
	  dummy.style.top = '-1000px';
	  dummy.style.overflow = 'scroll';
	  document.body.appendChild(dummy);
	  cachedType = 'reverse';
	
	  if (dummy.scrollLeft > 0) {
	    cachedType = 'default';
	  } else {
	    dummy.scrollLeft = 1;
	
	    if (dummy.scrollLeft === 0) {
	      cachedType = 'negative';
	    }
	  }
	
	  document.body.removeChild(dummy);
	  return cachedType;
	} // Based on https://stackoverflow.com/a/24394376
	
	
	function getNormalizedScrollLeft(element, direction) {
	  var scrollLeft = element.scrollLeft; // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
	
	  if (direction !== 'rtl') {
	    return scrollLeft;
	  }
	
	  var type = detectScrollType();
	
	  switch (type) {
	    case 'negative':
	      return element.scrollWidth - element.clientWidth + scrollLeft;
	
	    case 'reverse':
	      return element.scrollWidth - element.clientWidth - scrollLeft;
	
	    default:
	      return scrollLeft;
	  }
	}

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withMobileDialog.default;
	  }
	});
	
	var _withMobileDialog = _interopRequireDefault(__webpack_require__(1047));

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(240));
	
	/**
	 * Dialog will responsively be full screen *at or below* the given breakpoint
	 * (defaults to 'sm' for mobile devices).
	 * Notice that this Higher-order Component is incompatible with server-side rendering.
	 */
	var withMobileDialog = function withMobileDialog() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (Component) {
	    var _options$breakpoint = options.breakpoint,
	        breakpoint = _options$breakpoint === void 0 ? 'sm' : _options$breakpoint;
	
	    function WithMobileDialog(props) {
	      return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	        fullScreen: (0, _withWidth.isWidthDown)(breakpoint, props.width)
	      }, props));
	    }
	
	     false ? WithMobileDialog.propTypes = {
	      width: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired
	    } : void 0;
	    return (0, _withWidth.default)()(WithMobileDialog);
	  };
	};
	
	var _default = withMobileDialog;
	exports.default = _default;

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.isWidthDown = exports.isWidthUp = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _utils = __webpack_require__(22);
	
	var _styles = __webpack_require__(60);
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(137));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(47));
	
	var _createBreakpoints = __webpack_require__(392);
	
	var _useMediaQuery = _interopRequireDefault(__webpack_require__(395));
	
	// By default, returns true if screen width is the same or greater than the given breakpoint.
	var isWidthUp = function isWidthUp(breakpoint, width) {
	  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (inclusive) {
	    return _createBreakpoints.keys.indexOf(breakpoint) <= _createBreakpoints.keys.indexOf(width);
	  }
	
	  return _createBreakpoints.keys.indexOf(breakpoint) < _createBreakpoints.keys.indexOf(width);
	}; // By default, returns true if screen width is the same or less than the given breakpoint.
	
	
	exports.isWidthUp = isWidthUp;
	
	var isWidthDown = function isWidthDown(breakpoint, width) {
	  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (inclusive) {
	    return _createBreakpoints.keys.indexOf(width) <= _createBreakpoints.keys.indexOf(breakpoint);
	  }
	
	  return _createBreakpoints.keys.indexOf(width) < _createBreakpoints.keys.indexOf(breakpoint);
	};
	
	exports.isWidthDown = isWidthDown;
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	
	var withWidth = function withWidth() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (Component) {
	    var _options$withTheme = options.withTheme,
	        withThemeOption = _options$withTheme === void 0 ? false : _options$withTheme,
	        _options$noSSR = options.noSSR,
	        noSSR = _options$noSSR === void 0 ? false : _options$noSSR,
	        initialWidthOption = options.initialWidth;
	
	    function WithWidth(props) {
	      var contextTheme = (0, _useTheme.default)();
	      var theme = props.theme || contextTheme;
	
	      var _getThemeProps = (0, _styles.getThemeProps)({
	        theme: theme,
	        name: 'MuiWithWidth',
	        props: (0, _extends2.default)({}, props)
	      }),
	          initialWidth = _getThemeProps.initialWidth,
	          width = _getThemeProps.width,
	          other = (0, _objectWithoutProperties2.default)(_getThemeProps, ["initialWidth", "width"]);
	
	      var _React$useState = React.useState(false),
	          mountedState = _React$useState[0],
	          setMountedState = _React$useState[1];
	
	      useEnhancedEffect(function () {
	        setMountedState(true);
	      }, []);
	      /**
	       * innerWidth |xs      sm      md      lg      xl
	       *            |-------|-------|-------|-------|------>
	       * width      |  xs   |  sm   |  md   |  lg   |  xl
	       */
	
	      var keys = theme.breakpoints.keys.slice().reverse();
	      var widthComputed = keys.reduce(function (output, key) {
	        // eslint-disable-next-line react-hooks/rules-of-hooks
	        var matches = (0, _useMediaQuery.default)(theme.breakpoints.up(key));
	        return !output && matches ? key : output;
	      }, null);
	      var more = (0, _extends2.default)({
	        width: width || (mountedState || noSSR ? widthComputed : undefined) || initialWidth || initialWidthOption
	      }, withThemeOption ? {
	        theme: theme
	      } : {}, other); // When rendering the component on the server,
	      // we have no idea about the client browser screen width.
	      // In order to prevent blinks and help the reconciliation of the React tree
	      // we are not rendering the child component.
	      //
	      // An alternative is to use the `initialWidth` property.
	
	      if (more.width === undefined) {
	        return null;
	      }
	
	      return /*#__PURE__*/React.createElement(Component, more);
	    }
	
	     false ? WithWidth.propTypes = {
	      /**
	       * As `window.innerWidth` is unavailable on the server,
	       * we default to rendering an empty component during the first mount.
	       * You might want to use an heuristic to approximate
	       * the screen width of the client browser screen width.
	       *
	       * For instance, you could be using the user-agent or the client-hints.
	       * https://caniuse.com/#search=client%20hint
	       */
	      initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	
	      /**
	       * @ignore
	       */
	      theme: _propTypes.default.object,
	
	      /**
	       * Bypass the width calculation logic.
	       */
	      width: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
	    } : void 0;
	
	    if (false) {
	      WithWidth.displayName = "WithWidth(".concat((0, _utils.getDisplayName)(Component), ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(WithWidth, Component);
	    return WithWidth;
	  };
	};
	
	var _default = withWidth;
	exports.default = _default;

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z"
	}), 'AcUnit');
	
	exports.default = _default;

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22v-2z"
	}), 'AcUnitOutlined');
	
	exports.default = _default;

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 11h-3.17l2.54-2.54c.39-.39.39-1.02 0-1.41-.39-.39-1.03-.39-1.42 0L15 11h-2V9l3.95-3.95c.39-.39.39-1.03 0-1.42a.9959.9959 0 00-1.41 0L13 6.17V3c0-.55-.45-1-1-1s-1 .45-1 1v3.17L8.46 3.63a.9959.9959 0 00-1.41 0c-.39.39-.39 1.03 0 1.42L11 9v2H9L5.05 7.05c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41L6.17 11H3c-.55 0-1 .45-1 1s.45 1 1 1h3.17l-2.54 2.54c-.39.39-.39 1.02 0 1.41.39.39 1.03.39 1.42 0L9 13h2v2l-3.95 3.95c-.39.39-.39 1.03 0 1.42.39.39 1.02.39 1.41 0L11 17.83V21c0 .55.45 1 1 1s1-.45 1-1v-3.17l2.54 2.54c.39.39 1.02.39 1.41 0 .39-.39.39-1.03 0-1.42L13 15v-2h2l3.95 3.95c.39.39 1.03.39 1.42 0 .39-.39.39-1.02 0-1.41L17.83 13H21c.55 0 1-.45 1-1s-.45-1-1-1z"
	}), 'AcUnitRounded');
	
	exports.default = _default;

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22v-2z"
	}), 'AcUnitSharp');
	
	exports.default = _default;

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22v-2z"
	}), 'AcUnitTwoTone');
	
	exports.default = _default;

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'AccessAlarm');
	
	exports.default = _default;

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'AccessAlarmOutlined');
	
	exports.default = _default;

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.87 15.25l-3.37-2V8.72c0-.4-.32-.72-.72-.72h-.06c-.4 0-.72.32-.72.72v4.72c0 .35.18.68.49.86l3.65 2.19c.34.2.78.1.98-.24.21-.35.1-.8-.25-1zm5.31-10.24L18.1 2.45c-.42-.35-1.05-.3-1.41.13-.35.42-.29 1.05.13 1.41l3.07 2.56c.42.35 1.05.3 1.41-.13.36-.42.3-1.05-.12-1.41zM4.1 6.55l3.07-2.56c.43-.36.49-.99.13-1.41-.35-.43-.98-.48-1.4-.13L2.82 5.01c-.42.36-.48.99-.12 1.41.35.43.98.48 1.4.13zM12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
	}), 'AccessAlarmRounded');
	
	exports.default = _default;

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'AccessAlarmSharp');
	
	exports.default = _default;

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 6c-3.87 0-7 3.13-7 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm3.75 10.85L11 14V8h1.5v5.25l4 2.37-.75 1.23z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm.5-12H11v6l4.75 2.85.75-1.23-4-2.37zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53z"
	})), 'AccessAlarmTwoTone');
	
	exports.default = _default;

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 5.7l-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7zM7.9 3.4L6.6 1.9 2 5.7l1.3 1.5 4.6-3.8zM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4V8zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
	}), 'AccessAlarms');
	
	exports.default = _default;

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 5.7l-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7zM7.9 3.4L6.6 1.9 2 5.7l1.3 1.5 4.6-3.8zM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4V8zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
	}), 'AccessAlarmsOutlined');
	
	exports.default = _default;

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.87 15.25l-3.37-2V8.72c0-.4-.32-.72-.72-.72h-.06c-.4 0-.72.32-.72.72v4.72c0 .35.18.68.49.86l3.65 2.19c.34.2.78.1.98-.24.21-.35.1-.8-.25-1zm5.31-10.24L18.1 2.45c-.42-.35-1.05-.3-1.41.13-.35.42-.29 1.05.13 1.41l3.07 2.56c.42.35 1.05.3 1.41-.13.36-.42.3-1.05-.12-1.41zM4.1 6.55l3.07-2.56c.43-.36.49-.99.13-1.41-.35-.43-.98-.48-1.4-.13L2.82 5.01c-.42.36-.48.99-.12 1.41.35.43.98.48 1.4.13zM12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
	}), 'AccessAlarmsRounded');
	
	exports.default = _default;

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 5.7l-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7zM7.9 3.4L6.6 1.9 2 5.7l1.3 1.5 4.6-3.8zM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4V8zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
	}), 'AccessAlarmsSharp');
	
	exports.default = _default;

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 6c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm3.7 10.9L11 14V8h1.5v5.3l4 2.4-.8 1.2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M22 5.7l-4.6-3.9-1.3 1.5 4.6 3.9zM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zM7.9 3.4L6.6 1.9 2 5.7l1.3 1.5z"
	})), 'AccessAlarmsTwoTone');
	
	exports.default = _default;

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), _react.default.createElement("path", {
	  d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
	})), 'AccessTime');
	
	exports.default = _default;

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
	}), 'AccessTimeOutlined');
	
	exports.default = _default;

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-.22-13h-.06c-.4 0-.72.32-.72.72v4.72c0 .35.18.68.49.86l4.15 2.49c.34.2.78.1.98-.24.21-.34.1-.79-.25-.99l-3.87-2.3V7.72c0-.4-.32-.72-.72-.72z"
	}), 'AccessTimeRounded');
	
	exports.default = _default;

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
	}), 'AccessTimeSharp');
	
	exports.default = _default;

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm4.25 12.15L11 13V7h1.5v5.25l4.5 2.67-.75 1.23z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
	})), 'AccessTimeTwoTone');
	
	exports.default = _default;

/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"
	}), 'Accessibility');
	
	exports.default = _default;

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.5 6c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 8c1.86.5 4 .83 6 1v13h2v-6h2v6h2V9c2-.17 4.14-.5 6-1l-.5-2zM12 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
	}), 'AccessibilityNew');
	
	exports.default = _default;

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.5 6c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 8c1.86.5 4 .83 6 1v13h2v-6h2v6h2V9c2-.17 4.14-.5 6-1l-.5-2zM12 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
	}), 'AccessibilityNewOutlined');
	
	exports.default = _default;

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.75 6.99c-.14-.55-.69-.87-1.24-.75-2.38.53-5.03.76-7.51.76s-5.13-.23-7.51-.76c-.55-.12-1.1.2-1.24.75-.14.56.2 1.13.75 1.26 1.61.36 3.35.61 5 .75v12c0 .55.45 1 1 1s1-.45 1-1v-5h2v5c0 .55.45 1 1 1s1-.45 1-1V9c1.65-.14 3.39-.39 4.99-.75.56-.13.9-.7.76-1.26zM12 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
	}), 'AccessibilityNewRounded');
	
	exports.default = _default;

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.5 6c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 8c1.86.5 4 .83 6 1v13h2v-6h2v6h2V9c2-.17 4.14-.5 6-1l-.5-2zM12 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
	}), 'AccessibilityNewSharp');
	
	exports.default = _default;

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.5 6c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 8c1.86.5 4 .83 6 1v13h2v-6h2v6h2V9c2-.17 4.14-.5 6-1l-.5-2zM12 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
	}), 'AccessibilityNewTwoTone');
	
	exports.default = _default;

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"
	}), 'AccessibilityOutlined');
	
	exports.default = _default;

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm8 7h-5v12c0 .55-.45 1-1 1s-1-.45-1-1v-5h-2v5c0 .55-.45 1-1 1s-1-.45-1-1V9H4c-.55 0-1-.45-1-1s.45-1 1-1h16c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'AccessibilityRounded');
	
	exports.default = _default;

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"
	}), 'AccessibilitySharp');
	
	exports.default = _default;

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"
	}), 'AccessibilityTwoTone');
	
	exports.default = _default;

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "4",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-6.17 5c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1c-2.28.46-4 2.48-4 4.9 0 2.76 2.24 5 5 5 2.42 0 4.44-1.72 4.9-4h-2.07z"
	})), 'Accessible');
	
	exports.default = _default;

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "17",
	  cy: "4.54",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M14 17h-2c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3v-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5zm3-3.5h-1.86l1.67-3.67C17.42 8.5 16.44 7 14.96 7h-5.2c-.81 0-1.54.47-1.87 1.2L7.22 10l1.92.53L9.79 9H12l-1.83 4.1c-.6 1.33.39 2.9 1.85 2.9H17v5h2v-5.5c0-1.1-.9-2-2-2z"
	})), 'AccessibleForward');
	
	exports.default = _default;

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "18",
	  cy: "4.54",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M15 17h-2c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3v-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5zm3-3.5h-1.86l1.67-3.67C18.42 8.5 17.44 7 15.96 7h-5.2c-.81 0-1.54.47-1.87 1.2L8.22 10l1.92.53.65-1.53H13l-1.83 4.1c-.6 1.33.39 2.9 1.85 2.9H18v5h2v-5.5c0-1.1-.9-2-2-2z"
	})), 'AccessibleForwardOutlined');
	
	exports.default = _default;

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "18",
	  cy: "4.54",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M15 17h-2c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3v-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5zm3-3.5h-1.86l1.67-3.67C18.42 8.5 17.44 7 15.96 7h-5.2c-.81 0-1.54.47-1.87 1.2l-.28.76c-.21.56.11 1.17.68 1.33.49.14 1-.11 1.2-.58l.3-.71H13l-1.83 4.1c-.6 1.33.39 2.9 1.85 2.9H18v4c0 .55.45 1 1 1s1-.45 1-1v-4.5c0-1.1-.9-2-2-2z"
	})), 'AccessibleForwardRounded');
	
	exports.default = _default;

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "18",
	  cy: "4.54",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M15 17h-2c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3v-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5zm5-3.5h-3.86l1.67-3.67C18.42 8.5 17.44 7 15.96 7h-5.2c-.81 0-1.54.47-1.87 1.2L8.22 10l1.92.53.65-1.53H13l-3.12 7H18v5h2v-7.5z"
	})), 'AccessibleForwardSharp');
	
	exports.default = _default;

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "18",
	  cy: "4.54",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M15 17h-2c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3v-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5zm3-3.5h-1.86l1.67-3.67C18.42 8.5 17.44 7 15.96 7h-5.2c-.81 0-1.54.47-1.87 1.2L8.22 10l1.92.53.65-1.53H13l-1.83 4.1c-.6 1.33.39 2.9 1.85 2.9H18v5h2v-5.5c0-1.1-.9-2-2-2z"
	})), 'AccessibleForwardTwoTone');
	
	exports.default = _default;

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "4",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-9 7c-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1c-2.28.46-4 2.48-4 4.9 0 2.76 2.24 5 5 5 2.42 0 4.44-1.72 4.9-4h-2.07c-.41 1.16-1.52 2-2.83 2z"
	})), 'AccessibleOutlined');
	
	exports.default = _default;

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "4",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M19 11.9c0-.49-.36-.89-.84-.97-1.25-.21-2.43-.88-3.23-1.76l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.37-.21-.78-.31-1.25-.25C10.73 7.15 10 8.07 10 9.1V15c0 1.1.9 2 2 2h5v4c0 .55.45 1 1 1s1-.45 1-1v-4.5c0-1.1-.9-2-2-2h-3v-3.45c1 .83 2.4 1.54 3.8 1.82.62.13 1.2-.34 1.2-.97zM12.83 18c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1c-2.28.46-4 2.48-4 4.9 0 2.76 2.24 5 5 5 2.42 0 4.44-1.72 4.9-4h-2.07z"
	})), 'AccessibleRounded');
	
	exports.default = _default;

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "4",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.37-.21-.78-.31-1.25-.25C10.73 7.15 10 8.07 10 9.1V17h7v5h2v-7.5h-5v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-6.17 5c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1c-2.28.46-4 2.48-4 4.9 0 2.76 2.24 5 5 5 2.42 0 4.44-1.72 4.9-4h-2.07z"
	})), 'AccessibleSharp');
	
	exports.default = _default;

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "4",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-6.17 5c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1c-2.28.46-4 2.48-4 4.9 0 2.76 2.24 5 5 5 2.42 0 4.44-1.72 4.9-4h-2.07z"
	})), 'AccessibleTwoTone');
	
	exports.default = _default;

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 10h3v7H4zM10.5 10h3v7h-3zM2 19h20v3H2zM17 10h3v7h-3zM12 1L2 6v2h20V6z"
	}), 'AccountBalance');
	
	exports.default = _default;

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.5 10h-2v7h2v-7zm6 0h-2v7h2v-7zm8.5 9H2v2h19v-2zm-2.5-9h-2v7h2v-7zm-7-6.74L16.71 6H6.29l5.21-2.74m0-2.26L2 6v2h19V6l-9.5-5z"
	}), 'AccountBalanceOutlined');
	
	exports.default = _default;

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 11.5v4c0 .83.67 1.5 1.5 1.5S7 16.33 7 15.5v-4c0-.83-.67-1.5-1.5-1.5S4 10.67 4 11.5zm6 0v4c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5zM3.5 22h16c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-16c-.83 0-1.5.67-1.5 1.5S2.67 22 3.5 22zM16 11.5v4c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5zM10.57 1.49l-7.9 4.16c-.41.21-.67.64-.67 1.1C2 7.44 2.56 8 3.25 8h16.51C20.44 8 21 7.44 21 6.75c0-.46-.26-.89-.67-1.1l-7.9-4.16c-.58-.31-1.28-.31-1.86 0z"
	}), 'AccountBalanceRounded');
	
	exports.default = _default;

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z"
	}), 'AccountBalanceSharp');
	
	exports.default = _default;

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6.29 6l5.21-2.74L16.71 6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M6.5 10h-2v7h2v-7zm6 0h-2v7h2v-7zm8.5 9H2v2h19v-2zm-2.5-9h-2v7h2v-7zm-7-9L2 6v2h19V6l-9.5-5zM6.29 6l5.21-2.74L16.71 6H6.29z"
	})), 'AccountBalanceTwoTone');
	
	exports.default = _default;

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'AccountBalanceWallet');
	
	exports.default = _default;

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21 7.28V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-2.28c.59-.35 1-.98 1-1.72V9c0-.74-.41-1.37-1-1.72zM20 9v6h-7V9h7zM5 19V5h14v2h-6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6v2H5z"
	}), _react.default.createElement("circle", {
	  cx: "16",
	  cy: "12",
	  r: "1.5"
	})), 'AccountBalanceWalletOutlined');
	
	exports.default = _default;

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 16V8c0-1.1.89-2 2-2h9V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-1h-9c-1.11 0-2-.9-2-2zm3-8c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h9V8h-9zm3 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'AccountBalanceWalletRounded');
	
	exports.default = _default;

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 18v3H3V3h18v3H10v12h11zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'AccountBalanceWalletSharp');
	
	exports.default = _default;

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M13 17c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6V5H5v14h14v-2h-6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 7.28V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-2.28c.59-.35 1-.98 1-1.72V9c0-.74-.41-1.38-1-1.72zM20 9v6h-7V9h7zM5 19V5h14v2h-6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6v2H5z"
	}), _react.default.createElement("circle", {
	  cx: "16",
	  cy: "12",
	  r: "1.5"
	})), 'AccountBalanceWalletTwoTone');
	
	exports.default = _default;

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z"
	}), 'AccountBox');
	
	exports.default = _default;

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5v14H5V5h14m0-2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 9c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 10H6v-1.53c0-2.5 3.97-3.58 6-3.58s6 1.08 6 3.58V18zm-9.69-2h7.38c-.69-.56-2.38-1.12-3.69-1.12s-3.01.56-3.69 1.12z"
	}), 'AccountBoxOutlined');
	
	exports.default = _default;

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z"
	}), 'AccountBoxRounded');
	
	exports.default = _default;

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 21h18V3H3v18zM15 9c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z"
	}), 'AccountBoxSharp');
	
	exports.default = _default;

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14V5H5v14zm7-13c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zM6 16.47c0-2.5 3.97-3.58 6-3.58s6 1.08 6 3.58V18H6v-1.53z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7-5H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-1-2.53c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V18h12v-1.53zM8.31 16c.69-.56 2.38-1.12 3.69-1.12s3.01.56 3.69 1.12H8.31z"
	})), 'AccountBoxTwoTone');
	
	exports.default = _default;

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
	}), 'AccountCircle');
	
	exports.default = _default;

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.07 18.28c.43-.9 3.05-1.78 4.93-1.78s4.51.88 4.93 1.78C15.57 19.36 13.86 20 12 20s-3.57-.64-4.93-1.72zm11.29-1.45c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33C4.62 15.49 4 13.82 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.49-1.64 4.83zM12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z"
	}), 'AccountCircleOutlined');
	
	exports.default = _default;

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
	}), 'AccountCircleRounded');
	
	exports.default = _default;

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
	}), 'AccountCircleSharp');
	
	exports.default = _default;

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8 0 1.82.62 3.49 1.64 4.83 1.43-1.74 4.9-2.33 6.36-2.33s4.93.59 6.36 2.33C19.38 15.49 20 13.82 20 12c0-4.41-3.59-8-8-8zm0 9c-1.94 0-3.5-1.56-3.5-3.5S10.06 6 12 6s3.5 1.56 3.5 3.5S13.94 13 12 13z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.07 18.28c.43-.9 3.05-1.78 4.93-1.78s4.51.88 4.93 1.78C15.57 19.36 13.86 20 12 20s-3.57-.64-4.93-1.72zm11.29-1.45c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33C4.62 15.49 4 13.82 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.49-1.64 4.83zM12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z"
	})), 'AccountCircleTwoTone');
	
	exports.default = _default;

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3z"
	}), 'AccountTree');
	
	exports.default = _default;

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3h7zM7 9H4V5h3v4zm10 6h3v4h-3v-4zm0-10h3v4h-3V5z"
	}), 'AccountTreeOutlined');
	
	exports.default = _default;

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 11h3c1.11 0 2-.9 2-2V5c0-1.11-.9-2-2-2h-3c-1.11 0-2 .9-2 2v1H9.01V5c0-1.11-.9-2-2-2H4c-1.1 0-2 .9-2 2v4c0 1.11.9 2 2 2h3c1.11 0 2-.9 2-2V8h2v7.01c0 1.65 1.34 2.99 2.99 2.99H15v1c0 1.11.9 2 2 2h3c1.11 0 2-.9 2-2v-4c0-1.11-.9-2-2-2h-3c-1.11 0-2 .9-2 2v1h-1.01c-.54 0-.99-.45-.99-.99V8h2v1c0 1.1.9 2 2 2z"
	}), 'AccountTreeRounded');
	
	exports.default = _default;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3z"
	}), 'AccountTreeSharp');
	
	exports.default = _default;

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3h7zM7 9H4V5h3v4zm10 6h3v4h-3v-4zm0-10h3v4h-3V5z"
	}), _react.default.createElement("path", {
	  d: "M7 5v4H4V5h3M20 5v4h-3V5h3M20 15v4h-3v-4h3",
	  opacity: ".3"
	})), 'AccountTreeTwoTone');
	
	exports.default = _default;

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4zM16.12 4.37l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'Adb');
	
	exports.default = _default;

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4zM16.12 4.37l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'AdbOutlined');
	
	exports.default = _default;

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4zM16.12 4.37l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'AdbRounded');
	
	exports.default = _default;

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4zM16.12 4.37l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'AdbSharp');
	
	exports.default = _default;

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4zM16.12 4.37l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'AdbTwoTone');
	
	exports.default = _default;

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
	}), 'Add');
	
	exports.default = _default;

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z"
	}), 'AddAPhoto');
	
	exports.default = _default;

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 6h-3.17L16 4h-6v2h5.12l1.83 2H21v12H5v-9H3v9c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM8 14c0 2.76 2.24 5 5 5s5-2.24 5-5-2.24-5-5-5-5 2.24-5 5zm5-3c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zM5 6h3V4H5V1H3v3H0v2h3v3h2z"
	}), 'AddAPhotoOutlined');
	
	exports.default = _default;

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 8c0 .55.45 1 1 1s1-.45 1-1V6h2c.55 0 1-.45 1-1s-.45-1-1-1H5V2c0-.55-.45-1-1-1s-1 .45-1 1v2H1c-.55 0-1 .45-1 1s.45 1 1 1h2v2z"
	}), _react.default.createElement("circle", {
	  cx: "13",
	  cy: "14",
	  r: "3"
	}), _react.default.createElement("path", {
	  d: "M21 6h-3.17l-1.24-1.35c-.37-.41-.91-.65-1.47-.65h-6.4c.17.3.28.63.28 1 0 1.1-.9 2-2 2H6v1c0 1.1-.9 2-2 2-.37 0-.7-.11-1-.28V20c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-8 13c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	})), 'AddAPhotoRounded');
	
	exports.default = _default;

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H23v16H3V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3-5c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
	}), 'AddAPhotoSharp');
	
	exports.default = _default;

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 7v3H5v10h16V8h-4.05l-1.83-2H9v1H6zm7 2c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 6h-3.17L16 4H9v2h6.12l1.83 2H21v12H5V10H3v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM8 14c0 2.76 2.24 5 5 5s5-2.24 5-5-2.24-5-5-5-5 2.24-5 5zm5-3c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zM5 9V6h3V4H5V1H3v3H0v2h3v3z"
	})), 'AddAPhotoTwoTone');
	
	exports.default = _default;

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"
	}), 'AddAlarm');
	
	exports.default = _default;

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"
	}), 'AddAlarmOutlined');
	
	exports.default = _default;

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 12h-2v-2c0-.55-.45-1-1-1s-1 .45-1 1v2H9c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1zm6.18-6.99L18.1 2.45c-.42-.35-1.05-.3-1.41.13-.35.42-.29 1.05.13 1.41l3.07 2.56c.42.35 1.05.3 1.41-.13.36-.42.3-1.05-.12-1.41zM4.1 6.55l3.07-2.56c.43-.36.49-.99.13-1.41-.35-.43-.98-.48-1.4-.13L2.82 5.01c-.42.36-.48.99-.12 1.41.35.43.98.48 1.4.13zM12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
	}), 'AddAlarmRounded');
	
	exports.default = _default;

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"
	}), 'AddAlarmSharp');
	
	exports.default = _default;

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 6c-3.87 0-7 3.13-7 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm4 8h-3v3h-2v-3H8v-2h3V9h2v3h3v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3zm9-3.28l-4.6-3.86-1.29 1.53 4.6 3.86zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53z"
	})), 'AddAlarmTwoTone');
	
	exports.default = _default;

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zm8.87-4.19V11c0-3.25-2.25-5.97-5.29-6.69v-.72C13.59 2.71 12.88 2 12 2s-1.59.71-1.59 1.59v.72C7.37 5.03 5.12 7.75 5.12 11v5.82L3 18.94V20h18v-1.06l-2.12-2.12zM16 13.01h-3v3h-2v-3H8V11h3V8h2v3h3v2.01z"
	}), 'AddAlert');
	
	exports.default = _default;

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zM12 6c2.76 0 5 2.24 5 5v7H7v-7c0-2.76 2.24-5 5-5zm0-4.5c-.83 0-1.5.67-1.5 1.5v1.17C7.36 4.85 5 7.65 5 11v6l-2 2v1h18v-1l-2-2v-6c0-3.35-2.36-6.15-5.5-6.83V3c0-.83-.67-1.5-1.5-1.5zM13 8h-2v3H8v2h3v3h2v-3h3v-2h-3z"
	}), 'AddAlertOutlined');
	
	exports.default = _default;

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 23c1.1 0 1.99-.89 1.99-1.99h-3.98c0 1.1.89 1.99 1.99 1.99zm7-6v-6c0-3.35-2.36-6.15-5.5-6.83V3c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v1.17C7.36 4.85 5 7.65 5 11v6l-1.29 1.29c-.63.63-.19 1.71.7 1.71h15.17c.89 0 1.34-1.08.71-1.71L19 17zm-4-3.99h-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2H9c-.55 0-1-.45-1-1V12c0-.55.45-1 1-1h2V9c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1v.01c0 .55-.45 1-1 1z"
	}), 'AddAlertRounded');
	
	exports.default = _default;

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 23c1.1 0 1.99-.89 1.99-1.99h-3.98c0 1.1.89 1.99 1.99 1.99zm7-6v-6c0-3.35-2.36-6.15-5.5-6.83V1.5h-3v2.67C7.36 4.85 5 7.65 5 11v6l-2 2v1h18v-1l-2-2zm-3-3.99h-3v3h-2v-3H8V11h3V8h2v3h3v2.01z"
	}), 'AddAlertSharp');
	
	exports.default = _default;

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 6c-2.76 0-5 2.24-5 5v7h10v-7c0-2.76-2.24-5-5-5zm4 7h-3v3h-2v-3H8v-2h3V8h2v3h3v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 23c1.1 0 1.99-.89 1.99-1.99h-3.98c0 1.1.89 1.99 1.99 1.99zm7-6v-6c0-3.35-2.36-6.15-5.5-6.83V3c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v1.17C7.36 4.85 5 7.65 5 11v6l-2 2v1h18v-1l-2-2zm-2 1H7v-7c0-2.76 2.24-5 5-5s5 2.24 5 5v7zm-4-7V8h-2v3H8v2h3v3h2v-3h3v-2z"
	})), 'AddAlertTwoTone');
	
	exports.default = _default;

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
	}), 'AddBox');
	
	exports.default = _default;

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-8-2h2v-4h4v-2h-4V7h-2v4H7v2h4z"
	}), 'AddBoxOutlined');
	
	exports.default = _default;

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 10h-3v3c0 .55-.45 1-1 1s-1-.45-1-1v-3H8c-.55 0-1-.45-1-1s.45-1 1-1h3V8c0-.55.45-1 1-1s1 .45 1 1v3h3c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'AddBoxRounded');
	
	exports.default = _default;

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zm-4 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
	}), 'AddBoxSharp');
	
	exports.default = _default;

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14V5H5v14zm2-8h4V7h2v4h4v2h-4v4h-2v-4H7v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-8-2h2v-4h4v-2h-4V7h-2v4H7v2h4z"
	})), 'AddBoxTwoTone');
	
	exports.default = _default;

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
	}), 'AddCircle');
	
	exports.default = _default;

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'AddCircleOutline');
	
	exports.default = _default;

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'AddCircleOutlineOutlined');
	
	exports.default = _default;

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7c-.55 0-1 .45-1 1v3H8c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V8c0-.55-.45-1-1-1zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'AddCircleOutlineRounded');
	
	exports.default = _default;

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'AddCircleOutlineSharp');
	
	exports.default = _default;

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'AddCircleOutlineTwoTone');
	
	exports.default = _default;

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
	}), 'AddCircleOutlined');
	
	exports.default = _default;

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4 11h-3v3c0 .55-.45 1-1 1s-1-.45-1-1v-3H8c-.55 0-1-.45-1-1s.45-1 1-1h3V8c0-.55.45-1 1-1s1 .45 1 1v3h3c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'AddCircleRounded');
	
	exports.default = _default;

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
	}), 'AddCircleSharp');
	
	exports.default = _default;

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm5 9h-4v4h-2v-4H7v-2h4V7h2v4h4v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	})), 'AddCircleTwoTone');
	
	exports.default = _default;

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM17 11h-4v4h-2v-4H7V9h4V5h2v4h4v2z"
	}), 'AddComment');
	
	exports.default = _default;

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4zm-2 13.17L18.83 16H4V4h16v13.17zM13 5h-2v4H7v2h4v4h2v-4h4V9h-4z"
	}), 'AddCommentOutlined');
	
	exports.default = _default;

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4zm-6 7h-3v3c0 .55-.45 1-1 1s-1-.45-1-1v-3H8c-.55 0-1-.45-1-1s.45-1 1-1h3V6c0-.55.45-1 1-1s1 .45 1 1v3h3c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'AddCommentRounded');
	
	exports.default = _default;

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H2v16h16l4 4V2zm-5 9h-4v4h-2v-4H7V9h4V5h2v4h4v2z"
	}), 'AddCommentSharp');
	
	exports.default = _default;

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm0 15.17L18.83 16H4V4h16v13.17zM13 5h-2v4H7v2h4v4h2v-4h4V9h-4z"
	}), _react.default.createElement("path", {
	  d: "M4 4v12h14.83L20 17.17V4H4zm13 7h-4v4h-2v-4H7V9h4V5h2v4h4v2z",
	  opacity: ".3"
	})), 'AddCommentTwoTone');
	
	exports.default = _default;

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM21 6h-3V3h-2v3h-3v2h3v3h2V8h3z"
	}), 'AddIcCall');
	
	exports.default = _default;

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.45c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.4 8.5 5.2 8.5 3.95c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 4.95h1.5c.07.88.22 1.75.45 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79zM19 18.92c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM18 5.95v-3h-2v3h-3v2h3v3h2v-3h3v-2z"
	}), 'AddIcCallOutlined');
	
	exports.default = _default;

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 8h2v2c0 .55.45 1 1 1s1-.45 1-1V8h2c.55 0 1-.45 1-1s-.45-1-1-1h-2V4c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1zm5.21 7.27l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.04.57-1.64l-.29-2.52c-.11-1.01-.97-1.78-1.98-1.78H5.02c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1-.76-1.86-1.77-1.97z"
	}), 'AddIcCallRounded');
	
	exports.default = _default;

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 6h-3V3h-2v3h-3v2h3v3h2V8h3zm0 9.46l-5.27-.61-2.52 2.52c-2.83-1.44-5.15-3.75-6.59-6.59l2.53-2.53L8.54 3H3.03C2.45 13.18 10.82 21.55 21 20.97v-5.51z"
	}), 'AddIcCallSharp');
	
	exports.default = _default;

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 17.41c-.88-.07-1.75-.22-2.6-.45l-1.2 1.2c1.21.41 2.48.67 3.8.76v-1.51zM6.54 4.95h-1.5c.09 1.32.34 2.58.75 3.79l1.2-1.21c-.24-.83-.39-1.7-.45-2.58z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 20.95c.55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.4 8.5 5.2 8.5 3.95c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17zm-3.6-3.99c.85.24 1.72.39 2.6.45v1.5c-1.32-.09-2.6-.35-3.8-.76l1.2-1.19zM5.03 4.95h1.5c.07.88.22 1.75.45 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79zm10.97 6h2v-3h3v-2h-3v-3h-2v3h-3v2h3z"
	})), 'AddIcCallTwoTone');
	
	exports.default = _default;

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm4 8h-3v3h-2v-3H8V8h3V5h2v3h3v2z"
	}), 'AddLocation');
	
	exports.default = _default;

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9zm6-3h-2v2H9v2h2v2h2v-2h2V8h-2z"
	}), 'AddLocationOutlined');
	
	exports.default = _default;

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C8.14 2 5 5.14 5 9c0 4.17 4.42 9.92 6.24 12.11.4.48 1.13.48 1.53 0C14.58 18.92 19 13.17 19 9c0-3.86-3.14-7-7-7zm3 8h-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2H9c-.55 0-1-.45-1-1s.45-1 1-1h2V6c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'AddLocationRounded');
	
	exports.default = _default;

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm4 8h-3v3h-2v-3H8V8h3V5h2v3h3v2z"
	})), 'AddLocationSharp');
	
	exports.default = _default;

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17 9c0-2.76-2.24-5-5-5S7 6.24 7 9c0 2.85 2.92 7.21 5 9.88 2.12-2.69 5-7 5-9.88zm-8 1V8h2V6h2v2h2v2h-2v2h-2v-2H9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 9c0-3.86-3.14-7-7-7S5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13zm-7-5c2.76 0 5 2.24 5 5 0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9c0-2.76 2.24-5 5-5zm1 8v-2h2V8h-2V6h-2v2H9v2h2v2z"
	})), 'AddLocationTwoTone');
	
	exports.default = _default;

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
	}), 'AddOutlined');
	
	exports.default = _default;

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z"
	}), 'AddPhotoAlternate');
	
	exports.default = _default;

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 20H4V6h9V4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9zm-7.79-3.17l-1.96-2.36L5.5 18h11l-3.54-4.71zM20 4V1h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V6h3V4h-3z"
	}), 'AddPhotoAlternateOutlined');
	
	exports.default = _default;

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.02 5H19V2.98c0-.54-.44-.98-.98-.98h-.03c-.55 0-.99.44-.99.98V5h-2.01c-.54 0-.98.44-.99.98v.03c0 .55.44.99.99.99H17v2.01c0 .54.44.99.99.98h.03c.54 0 .98-.44.98-.98V7h2.02c.54 0 .98-.44.98-.98v-.04c0-.54-.44-.98-.98-.98zM16 9.01V8h-1.01c-.53 0-1.03-.21-1.41-.58-.37-.38-.58-.88-.58-1.44 0-.36.1-.69.27-.98H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8.28c-.3.17-.64.28-1.02.28-1.09-.01-1.98-.9-1.98-1.99zM15.96 19H6c-.41 0-.65-.47-.4-.8l1.98-2.63c.21-.28.62-.26.82.02L10 18l2.61-3.48c.2-.26.59-.27.79-.01l2.95 3.68c.26.33.03.81-.39.81z"
	}), 'AddPhotoAlternateRounded');
	
	exports.default = _default;

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H3v16h16V11h-3zM5 19l3-4 2 3 3-4 4 5H5z"
	}), 'AddPhotoAlternateSharp');
	
	exports.default = _default;

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M10.21 16.83l-1.96-2.36L5.5 18h11l-3.54-4.71z"
	}), _react.default.createElement("path", {
	  d: "M16.5 18h-11l2.75-3.53 1.96 2.36 2.75-3.54L16.5 18zM17 7h-3V6H4v14h14V10h-1V7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 4V1h-2v3h-3v2h3v2.99h2V6h3V4zm-2 16H4V6h10V4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V10h-2v10z"
	})), 'AddPhotoAlternateTwoTone');
	
	exports.default = _default;

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'AddRounded');
	
	exports.default = _default;

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
	}), 'AddSharp');
	
	exports.default = _default;

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-9.83-3.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4h-.01l-1.1 2-2.76 5H8.53l-.13-.27L6.16 6l-.95-2-.94-2H1v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.13 0-.25-.11-.25-.25z"
	}), 'AddShoppingCart');
	
	exports.default = _default;

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-8.9-5h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4l-3.87 7H8.53L4.27 2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2z"
	}), 'AddShoppingCartOutlined');
	
	exports.default = _default;

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 9c.55 0 1-.45 1-1V6h2c.55 0 1-.45 1-1s-.45-1-1-1h-2V2c0-.55-.45-1-1-1s-1 .45-1 1v2H9c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1zm-5 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-8.9-5h7.45c.75 0 1.41-.41 1.75-1.03l3.38-6.13c.27-.48.09-1.09-.39-1.36-.48-.26-1.09-.09-1.35.39L15.55 11H8.53L4.54 2.57c-.16-.35-.52-.57-.9-.57H2c-.55 0-1 .45-1 1s.45 1 1 1h1l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h11c.55 0 1-.45 1-1s-.45-1-1-1H7l1.1-2z"
	}), 'AddShoppingCartRounded');
	
	exports.default = _default;

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-8.9-5h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4l-3.87 7H8.53L4.27 2H1v2h2l3.6 7.59L3.62 17H19v-2H7l1.1-2z"
	}), 'AddShoppingCartSharp');
	
	exports.default = _default;

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-8.9-5h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.41 4l-3.86 7H8.53L4.27 2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2z"
	}), 'AddShoppingCartTwoTone');
	
	exports.default = _default;

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 1.01L8 1c-1.1 0-2 .9-2 2v3h2V5h10v14H8v-1H6v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM10 15h2V8H5v2h3.59L3 15.59 4.41 17 10 11.41z"
	}), 'AddToHomeScreen');
	
	exports.default = _default;

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 1.01L8 1c-1.1 0-2 .9-2 2v3h2V5h10v14H8v-1H6v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM10 15h2V8H5v2h3.59L3 15.59 4.41 17 10 11.41V15z"
	}), 'AddToHomeScreenOutlined');
	
	exports.default = _default;

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 1.01L8 1c-1.1 0-2 .9-2 2v3c0 .55.45 1 1 1s1-.45 1-1V5h10v14H8v-1c0-.55-.45-1-1-1s-1 .45-1 1v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM11 15c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1h2.59L3.7 14.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L10 11.41V14c0 .55.45 1 1 1z"
	}), 'AddToHomeScreenRounded');
	
	exports.default = _default;

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 1.01L6 1v5h2V5h10v14H8v-1H6v5h14V1.01zM10 15h2V8H5v2h3.59L3 15.59 4.41 17 10 11.41V15z"
	}), 'AddToHomeScreenSharp');
	
	exports.default = _default;

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 1.01L8 1c-1.1 0-2 .9-2 2v3h2V5h10v14H8v-1H6v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM10 15h2V8H5v2h3.59L3 15.59 4.41 17 10 11.41V15z"
	}), 'AddToHomeScreenTwoTone');
	
	exports.default = _default;

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
	}), 'AddToPhotos');
	
	exports.default = _default;

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-7-1h2v-4h4V9h-4V5h-2v4H9v2h4z"
	}), 'AddToPhotosOutlined');
	
	exports.default = _default;

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 6c-.55 0-1 .45-1 1v13c0 1.1.9 2 2 2h13c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1zm17-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 9h-3v3c0 .55-.45 1-1 1s-1-.45-1-1v-3h-3c-.55 0-1-.45-1-1s.45-1 1-1h3V6c0-.55.45-1 1-1s1 .45 1 1v3h3c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'AddToPhotosRounded');
	
	exports.default = _default;

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6H2v16h16v-2H4V6zm18-4H6v16h16V2zm-3 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
	}), 'AddToPhotosSharp');
	
	exports.default = _default;

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 4H8v12h12V4zm-1 7h-4v4h-2v-4H9V9h4V5h2v4h4v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 22h14v-2H4V6H2v14c0 1.1.9 2 2 2zm4-4h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2zM8 4h12v12H8V4zm7 1h-2v4H9v2h4v4h2v-4h4V9h-4z"
	})), 'AddToPhotosTwoTone');
	
	exports.default = _default;

/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-7v2h-3v3h-2v-3H8v-2h3V7h2v3h3z"
	}), 'AddToQueue');
	
	exports.default = _default;

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 15h2v-3h3v-2h-3V7h-2v3H8v2h3zM21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 14H3V5h18v12z"
	}), 'AddToQueueOutlined');
	
	exports.default = _default;

/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v1c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-1h5c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm-1 14H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1zm-4-6c0 .55-.45 1-1 1h-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2H9c-.55 0-1-.45-1-1s.45-1 1-1h2V8c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1z"
	}), 'AddToQueueRounded');
	
	exports.default = _default;

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 3H1v16h7v2h8v-2h7V3zm-2 14H3V5h18v12zm-5-7v2h-3v3h-2v-3H8v-2h3V7h2v3h3z"
	}), 'AddToQueueSharp');
	
	exports.default = _default;

/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 17h18V5H3v12zm5-7h3V7h2v3h3v2h-3v3h-2v-3H8v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11 15h2v-3h3v-2h-3V7h-2v3H8v2h3zM21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 14H3V5h18v12z"
	})), 'AddToQueueTwoTone');
	
	exports.default = _default;

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
	}), 'AddTwoTone');
	
	exports.default = _default;

/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"
	}), 'Adjust');
	
	exports.default = _default;

/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"
	}), 'AdjustOutlined');
	
	exports.default = _default;

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"
	}), 'AdjustRounded');
	
	exports.default = _default;

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"
	}), 'AdjustSharp');
	
	exports.default = _default;

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0-7C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'AdjustTwoTone');
	
	exports.default = _default;

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 11v2H9V7h9c2.21 0 4 1.79 4 4zM2 14v2h6v2h8v-2h6v-2H2zm5.14-1.9c1.16-1.19 1.14-3.08-.04-4.24-1.19-1.16-3.08-1.14-4.24.04-1.16 1.19-1.14 3.08.04 4.24 1.19 1.16 3.08 1.14 4.24-.04z"
	}), 'AirlineSeatFlat');
	
	exports.default = _default;

/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22.25 14.29l-.69 1.89L9.2 11.71l2.08-5.66 8.56 3.09c2.1.76 3.18 3.06 2.41 5.15zM1.5 12.14L8 14.48V19h8v-1.63L20.52 19l.69-1.89-19.02-6.86-.69 1.89zm5.8-1.94c1.49-.72 2.12-2.51 1.41-4C7.99 4.71 6.2 4.08 4.7 4.8c-1.49.71-2.12 2.5-1.4 4 .71 1.49 2.5 2.12 4 1.4z"
	}), 'AirlineSeatFlatAngled');
	
	exports.default = _default;

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 6.5c.31 0 .7.15.9.56.24.5.02 1.1-.47 1.34-.14.06-.28.1-.43.1-.3 0-.7-.15-.89-.56-.17-.34-.1-.63-.05-.78.05-.14.18-.4.51-.56.14-.06.28-.1.43-.1m6.47 2.11l6.69 2.41c.52.19.93.56 1.15 1.05.22.48.25 1.03.06 1.53l-.01.02-8.59-3.11.7-1.9M10 15.19l4 1.44V17h-4v-1.81M6 4.5c-.44 0-.88.1-1.3.3-1.49.71-2.12 2.5-1.4 4 .51 1.07 1.58 1.7 2.7 1.7.44 0 .88-.1 1.3-.3 1.49-.72 2.12-2.51 1.41-4C8.19 5.13 7.12 4.5 6 4.5zm5.28 1.55L9.2 11.71l12.36 4.47.69-1.89c.77-2.09-.31-4.39-2.41-5.15l-8.56-3.09zm-9.09 4.2l-.69 1.89L8 14.48V19h8v-1.63L20.52 19l.69-1.89-19.02-6.86z"
	}), 'AirlineSeatFlatAngledOutlined');
	
	exports.default = _default;

/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22.25 14.29l-.69 1.89L9.2 11.71l1.39-3.79c.38-1.03 1.52-1.56 2.56-1.19l6.69 2.41c2.1.76 3.18 3.06 2.41 5.15zm-19.8-1.81l5.55 2V18c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-.63l3.58 1.29c.52.19 1.1-.08 1.29-.6.19-.52-.08-1.1-.6-1.29L3.13 10.59c-.52-.19-1.1.08-1.29.6-.18.52.09 1.1.61 1.29zM7.3 10.2c1.49-.72 2.12-2.51 1.41-4C7.99 4.71 6.2 4.08 4.7 4.8c-1.49.71-2.12 2.5-1.4 4 .71 1.49 2.5 2.12 4 1.4z"
	}), 'AirlineSeatFlatAngledRounded');
	
	exports.default = _default;

/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.56 16.18L9.2 11.71l2.08-5.66 12.35 4.47-2.07 5.66zM1.5 12.14L8 14.48V19h8v-1.63L20.52 19l.69-1.89-19.02-6.86-.69 1.89zm5.8-1.94c1.49-.72 2.12-2.51 1.41-4C7.99 4.71 6.2 4.08 4.7 4.8c-1.49.71-2.12 2.5-1.4 4 .71 1.49 2.5 2.12 4 1.4z"
	}), 'AirlineSeatFlatAngledSharp');
	
	exports.default = _default;

/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14 16.64l-4-1.45V17h4zM6 8.5c.15 0 .3-.03.44-.1.49-.24.7-.84.46-1.34-.19-.41-.59-.56-.9-.56-.15 0-.3.03-.44.1-.32.16-.45.42-.5.56-.05.15-.12.44.04.77.2.42.59.57.9.57zm13.16 2.52l-6.69-2.41-.7 1.91 8.59 3.11.01-.02c.19-.51.17-1.05-.06-1.53-.23-.5-.63-.87-1.15-1.06z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M1.5 12.14L8 14.48V19h8v-1.63L20.52 19l.69-1.89-19.02-6.86-.69 1.89zm8.5 3.05l4 1.44V17h-4v-1.81zm9.84-6.05l-8.56-3.09-2.08 5.66 12.36 4.47.69-1.89c.77-2.09-.31-4.39-2.41-5.15zm.53 4.46l-.01.02-8.59-3.11.7-1.91 6.69 2.41c.52.19.93.56 1.15 1.05.23.49.25 1.04.06 1.54zM6 10.5c.44 0 .88-.1 1.3-.3 1.49-.72 2.12-2.51 1.41-4C8.19 5.13 7.12 4.5 6 4.5c-.44 0-.88.1-1.3.3-1.49.71-2.12 2.5-1.4 4 .51 1.07 1.58 1.7 2.7 1.7zm-.94-3.34c.05-.14.18-.4.51-.56.14-.06.28-.1.43-.1.31 0 .7.15.9.56.24.5.02 1.1-.47 1.34-.14.06-.28.1-.43.1-.3 0-.7-.15-.89-.56-.17-.34-.1-.63-.05-.78z"
	})), 'AirlineSeatFlatAngledTwoTone');
	
	exports.default = _default;

/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 13c.78 0 1.55-.3 2.14-.9 1.16-1.19 1.14-3.08-.04-4.24C6.51 7.29 5.75 7 5 7c-.78 0-1.55.3-2.14.9-1.16 1.19-1.14 3.08.04 4.24.59.57 1.35.86 2.1.86zm-.71-3.7c.19-.19.44-.3.71-.3.26 0 .51.1.7.28.4.39.4 1.01.02 1.41-.2.2-.45.31-.72.31-.26 0-.51-.1-.7-.28-.4-.4-.4-1.02-.01-1.42zM18 7H9v6h13v-2c0-2.21-1.79-4-4-4zm-7 4V9h7c1.1 0 2 .9 2 2h-9zm-9 5h6v2h8v-2h6v-2H2z"
	}), 'AirlineSeatFlatOutlined');
	
	exports.default = _default;

/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 11v2H9V9c0-1.1.9-2 2-2h7c2.21 0 4 1.79 4 4zM2 15c0 .55.45 1 1 1h5v1c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-1h5c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1zm5.14-2.9c1.16-1.19 1.14-3.08-.04-4.24-1.19-1.16-3.08-1.14-4.24.04-1.16 1.19-1.14 3.08.04 4.24 1.19 1.16 3.08 1.14 4.24-.04z"
	}), 'AirlineSeatFlatRounded');
	
	exports.default = _default;

/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 7v6H9V7h13zM2 14v2h6v2h8v-2h6v-2H2zm5.14-1.9c1.16-1.19 1.14-3.08-.04-4.24-1.19-1.16-3.08-1.14-4.24.04-1.16 1.19-1.14 3.08.04 4.24 1.19 1.16 3.08 1.14 4.24-.04z"
	}), 'AirlineSeatFlatSharp');
	
	exports.default = _default;

/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 11c.27 0 .52-.11.71-.3.39-.4.39-1.02-.01-1.41C5.51 9.11 5.26 9 5 9c-.27 0-.52.11-.71.3-.39.4-.39 1.02.01 1.41.19.18.44.29.7.29zm13-2h-7v2h9c0-1.1-.9-2-2-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 13c.78 0 1.55-.3 2.14-.9 1.16-1.19 1.14-3.08-.04-4.24C6.51 7.29 5.75 7 5 7c-.78 0-1.55.3-2.14.9-1.16 1.19-1.14 3.08.04 4.24.59.57 1.35.86 2.1.86zm-.71-3.7c.19-.19.44-.3.71-.3.26 0 .51.1.7.28.4.39.4 1.01.02 1.41-.2.2-.45.31-.72.31-.26 0-.51-.1-.7-.28-.4-.4-.4-1.02-.01-1.42zM18 7H9v6h13v-2c0-2.21-1.79-4-4-4zm-7 4V9h7c1.1 0 2 .9 2 2h-9zm-9 5h6v2h8v-2h6v-2H2z"
	})), 'AirlineSeatFlatTwoTone');
	
	exports.default = _default;

/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 13c1.65 0 3-1.35 3-3S8.65 7 7 7s-3 1.35-3 3 1.35 3 3 3zm12-6h-8v7H3V7H1v10h22v-6c0-2.21-1.79-4-4-4z"
	}), 'AirlineSeatIndividualSuite');
	
	exports.default = _default;

/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 14c1.66 0 3-1.34 3-3S8.66 8 7 8s-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm12-3h-8v8H3V7H1v10h22v-6c0-2.21-1.79-4-4-4zm2 8h-8V9h6c1.1 0 2 .9 2 2v4z"
	}), 'AirlineSeatIndividualSuiteOutlined');
	
	exports.default = _default;

/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 13c1.65 0 3-1.35 3-3S8.65 7 7 7s-3 1.35-3 3 1.35 3 3 3zm12-6h-6c-1.1 0-2 .9-2 2v5H3V8c0-.55-.45-1-1-1s-1 .45-1 1v7c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-4c0-2.21-1.79-4-4-4z"
	}), 'AirlineSeatIndividualSuiteRounded');
	
	exports.default = _default;

/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 13c1.65 0 3-1.35 3-3S8.65 7 7 7s-3 1.35-3 3 1.35 3 3 3zm16-6H11v7H3V7H1v10h22V7z"
	}), 'AirlineSeatIndividualSuiteSharp');
	
	exports.default = _default;

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "7",
	  cy: "11",
	  r: "1",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 9h-6v6h8v-4c0-1.1-.9-2-2-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M7 14c1.66 0 3-1.34 3-3S8.66 8 7 8s-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm12-3h-8v8H3V7H1v10h22v-6c0-2.21-1.79-4-4-4zm2 8h-8V9h6c1.1 0 2 .9 2 2v4z"
	})), 'AirlineSeatIndividualSuiteTwoTone');
	
	exports.default = _default;

/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 12V3H2v9c0 2.76 2.24 5 5 5h6v-2H7c-1.66 0-3-1.34-3-3zm18.83 5.24c-.38-.72-1.29-.97-2.03-.63l-1.09.5-3.41-6.98c-.34-.68-1.03-1.12-1.79-1.12L11 9V3H5v8c0 1.66 1.34 3 3 3h7l3.41 7 3.72-1.7c.77-.36 1.1-1.3.7-2.06z"
	}), 'AirlineSeatLegroomExtra');
	
	exports.default = _default;

/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 12V3H2v9c0 2.76 2.24 5 5 5h6v-2H7c-1.66 0-3-1.34-3-3zm18.83 5.24c-.38-.72-1.29-.97-2.03-.63l-1.09.5-3.41-6.98C15.96 9.45 15.27 9 14.51 9H11V3H5v8c0 1.66 1.34 3 3 3h7l3.41 7 3.72-1.7c.77-.36 1.1-1.3.7-2.06z"
	}), 'AirlineSeatLegroomExtraOutlined');
	
	exports.default = _default;

/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 12V4c0-.55-.45-1-1-1s-1 .45-1 1v8c0 2.76 2.24 5 5 5h5c.55 0 1-.45 1-1s-.45-1-1-1H7c-1.66 0-3-1.34-3-3zm18.83 5.24c-.38-.72-1.29-.97-2.03-.63l-1.09.5-3.41-6.98C15.96 9.45 15.27 9 14.51 9H11V3H5v8c0 1.66 1.34 3 3 3h7l2.56 5.25c.48.98 1.64 1.39 2.63.94l1.95-.89c.76-.36 1.09-1.3.69-2.06z"
	}), 'AirlineSeatLegroomExtraRounded');
	
	exports.default = _default;

/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 3H2v14h11v-2H4zm18.24 12.96l-2.53 1.15-3.41-6.98C15.96 9.45 15.27 9 14.51 9H11V3H5v11h10l3.41 7 5.07-2.32-1.24-2.72z"
	}), 'AirlineSeatLegroomExtraSharp');
	
	exports.default = _default;

/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 12V3H2v9c0 2.76 2.24 5 5 5h6v-2H7c-1.66 0-3-1.34-3-3zm18.83 5.24c-.38-.72-1.29-.97-2.03-.63l-1.09.5-3.41-6.98C15.96 9.45 15.27 9 14.51 9H11V3H5v8c0 1.66 1.34 3 3 3h7l3.41 7 3.72-1.7c.77-.36 1.1-1.3.7-2.06z"
	}), 'AirlineSeatLegroomExtraTwoTone');
	
	exports.default = _default;

/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 12V3H3v9c0 2.76 2.24 5 5 5h6v-2H8c-1.66 0-3-1.34-3-3zm15.5 6H19v-7c0-1.1-.9-2-2-2h-5V3H6v8c0 1.65 1.35 3 3 3h7v7h4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5z"
	}), 'AirlineSeatLegroomNormal');
	
	exports.default = _default;

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 12V3H3v9c0 2.76 2.24 5 5 5h6v-2H8c-1.66 0-3-1.34-3-3zm15.5 6H19v-7c0-1.1-.9-2-2-2h-5V3H6v8c0 1.65 1.35 3 3 3h7v7h4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5z"
	}), 'AirlineSeatLegroomNormalOutlined');
	
	exports.default = _default;

/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 12V4c0-.55-.45-1-1-1s-1 .45-1 1v8c0 2.76 2.24 5 5 5h5c.55 0 1-.45 1-1s-.45-1-1-1H8c-1.66 0-3-1.34-3-3zm15.5 6H19v-7c0-1.1-.9-2-2-2h-5V3H6v8c0 1.65 1.35 3 3 3h7v5c0 1.1.9 2 2 2h2.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5z"
	}), 'AirlineSeatLegroomNormalRounded');
	
	exports.default = _default;

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 15V3H3v14h11v-2H5zm17 3h-3v-7c0-1.1-.9-2-2-2h-5V3H6v11h10v7h6v-3z"
	}), 'AirlineSeatLegroomNormalSharp');
	
	exports.default = _default;

/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 12V3H3v9c0 2.76 2.24 5 5 5h6v-2H8c-1.66 0-3-1.34-3-3zm15.5 6H19v-7c0-1.1-.9-2-2-2h-5V3H6v8c0 1.65 1.35 3 3 3h7v7h4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5z"
	}), 'AirlineSeatLegroomNormalTwoTone');
	
	exports.default = _default;

/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.97 19.2c.18.96-.55 1.8-1.47 1.8H14v-3l1-4H9c-1.65 0-3-1.35-3-3V3h6v6h5c1.1 0 2 .9 2 2l-2 7h1.44c.73 0 1.39.49 1.53 1.2zM5 12V3H3v9c0 2.76 2.24 5 5 5h4v-2H8c-1.66 0-3-1.34-3-3z"
	}), 'AirlineSeatLegroomReduced');
	
	exports.default = _default;

/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.97 19.2c.18.96-.55 1.8-1.47 1.8H14v-3l1-4H9c-1.65 0-3-1.35-3-3V3h6v6h5c1.1 0 2 .9 2 2l-2 7h1.44c.73 0 1.39.49 1.53 1.2zM5 12V3H3v9c0 2.76 2.24 5 5 5h4v-2H8c-1.66 0-3-1.34-3-3z"
	}), 'AirlineSeatLegroomReducedOutlined');
	
	exports.default = _default;

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.97 19.2c.18.96-.55 1.8-1.47 1.8h-2.69c-1.3 0-2.26-1.22-1.94-2.49L15 14H9c-1.65 0-3-1.35-3-3V3h6v6h5c1.1 0 2 .9 2 2l-2 7h1.44c.73 0 1.39.49 1.53 1.2zM5 12V4c0-.55-.45-1-1-1s-1 .45-1 1v8c0 2.76 2.24 5 5 5h3c.55 0 1-.45 1-1s-.45-1-1-1H8c-1.66 0-3-1.34-3-3z"
	}), 'AirlineSeatLegroomReducedRounded');
	
	exports.default = _default;

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.97 21H14v-3l1-4H6V3h6v6h5c1.1 0 2 .9 2 2l-2 7h2.97v3zM5 15V3H3v14h9v-2H5z"
	}), 'AirlineSeatLegroomReducedSharp');
	
	exports.default = _default;

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.97 19.2c.18.96-.55 1.8-1.47 1.8H14v-3l1-4H9c-1.65 0-3-1.35-3-3V3h6v6h5c1.1 0 2 .9 2 2l-2 7h1.44c.73 0 1.39.49 1.53 1.2zM5 12V3H3v9c0 2.76 2.24 5 5 5h4v-2H8c-1.66 0-3-1.34-3-3z"
	}), 'AirlineSeatLegroomReducedTwoTone');
	
	exports.default = _default;

/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49zM16 19H8.93c-1.48 0-2.74-1.08-2.96-2.54L4 7H2l1.99 9.76C4.37 19.2 6.47 21 8.94 21H16v-2zm.23-4h-4.88l-1.03-4.1c1.58.89 3.28 1.54 5.15 1.22V9.99c-1.63.31-3.44-.27-4.69-1.25L9.14 7.47c-.23-.18-.49-.3-.76-.38-.32-.09-.66-.12-.99-.06h-.02c-1.23.22-2.05 1.39-1.84 2.61l1.35 5.92C7.16 16.98 8.39 18 9.83 18h6.85l3.82 3 1.5-1.5-5.77-4.5z"
	}), 'AirlineSeatReclineExtra');
	
	exports.default = _default;

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49zM16 19H8.93c-1.48 0-2.74-1.08-2.96-2.54L4 7H2l1.99 9.76C4.37 19.2 6.47 21 8.94 21H16v-2zm.23-4h-4.88l-1.03-4.1c1.58.89 3.28 1.54 5.15 1.22V9.99c-1.63.31-3.44-.27-4.69-1.25L9.14 7.47c-.23-.18-.49-.3-.76-.38-.32-.09-.66-.12-.99-.06h-.02c-1.23.22-2.05 1.39-1.84 2.61l1.35 5.92C7.16 16.98 8.39 18 9.83 18h6.85l3.82 3 1.5-1.5-5.77-4.5z"
	}), 'AirlineSeatReclineExtraOutlined');
	
	exports.default = _default;

/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49zM16 20c0-.55-.45-1-1-1H8.93c-1.48 0-2.74-1.08-2.96-2.54L4.16 7.78C4.07 7.33 3.67 7 3.2 7c-.62 0-1.08.57-.96 1.18l1.75 8.58C4.37 19.2 6.47 21 8.94 21H15c.55 0 1-.45 1-1zm-.46-5h-4.19l-1.03-4.1c1.28.72 2.63 1.28 4.1 1.3.58.01 1.05-.49 1.05-1.07 0-.59-.49-1.04-1.08-1.06-1.31-.04-2.63-.56-3.61-1.33L9.14 7.47c-.23-.18-.49-.3-.76-.38-.32-.09-.66-.12-.99-.06h-.02c-1.23.22-2.05 1.39-1.84 2.61l1.35 5.92C7.16 16.98 8.39 18 9.83 18h6.85l3.09 2.42c.42.33 1.02.29 1.39-.08.45-.45.4-1.18-.1-1.57l-4.29-3.35c-.35-.27-.78-.42-1.23-.42z"
	}), 'AirlineSeatReclineExtraRounded');
	
	exports.default = _default;

/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49zM16 19H6.5L4 7H2l2.85 14H16v-2zm.23-4h-4.88l-1.03-4.1c1.58.89 3.28 1.54 5.15 1.22V9.99c-1.63.31-3.44-.27-4.69-1.25L9.14 7.47c-.23-.18-.49-.3-.76-.38-.32-.09-.66-.12-.99-.06h-.02c-1.23.22-2.05 1.39-1.84 2.61L7.44 18h9.24l3.82 3 1.5-1.5-5.77-4.5z"
	}), 'AirlineSeatReclineExtraSharp');
	
	exports.default = _default;

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49zM16 19H8.93c-1.48 0-2.74-1.08-2.96-2.54L4 7H2l1.99 9.76C4.37 19.2 6.47 21 8.94 21H16v-2zm.23-4h-4.88l-1.03-4.1c1.58.89 3.28 1.54 5.15 1.22V9.99c-1.63.31-3.44-.27-4.69-1.25L9.14 7.47c-.23-.18-.49-.3-.76-.38-.32-.09-.66-.12-.99-.06h-.02c-1.23.22-2.05 1.39-1.84 2.61l1.35 5.92C7.16 16.98 8.39 18 9.83 18h6.85l3.82 3 1.5-1.5-5.77-4.5z"
	}), 'AirlineSeatReclineExtraTwoTone');
	
	exports.default = _default;

/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.59 5.41c-.78-.78-.78-2.05 0-2.83.78-.78 2.05-.78 2.83 0 .78.78.78 2.05 0 2.83-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z"
	}), 'AirlineSeatReclineNormal');
	
	exports.default = _default;

/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.59 5.41c-.78-.78-.78-2.05 0-2.83s2.05-.78 2.83 0 .78 2.05 0 2.83c-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z"
	}), 'AirlineSeatReclineNormalOutlined');
	
	exports.default = _default;

/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.59 5.41c-.78-.78-.78-2.05 0-2.83s2.05-.78 2.83 0 .78 2.05 0 2.83c-.79.79-2.05.79-2.83 0zM6 16V8c0-.55-.45-1-1-1s-1 .45-1 1v8c0 2.76 2.24 5 5 5h5c.55 0 1-.45 1-1s-.45-1-1-1H9c-1.66 0-3-1.34-3-3zm13.28 3.35l-3.77-3.77c-.37-.37-.88-.58-1.41-.58h-2.6v-3.68c1.09.89 2.66 1.7 4.2 2.02.67.14 1.3-.36 1.3-1.04 0-.53-.39-.96-.92-1.05-1.42-.24-2.88-1.01-3.75-1.97l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l2.78 2.78c.39.39 1.04.39 1.43 0 .4-.39.4-1.03 0-1.43z"
	}), 'AirlineSeatReclineNormalRounded');
	
	exports.default = _default;

/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.59 5.41c-.78-.78-.78-2.05 0-2.83s2.05-.78 2.83 0 .78 2.05 0 2.83c-.79.79-2.05.79-2.83 0zM6 19V7H4v14h11v-2H6zm14 1.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V18h8.07l3.5 3.5L20 20.07z"
	}), 'AirlineSeatReclineNormalSharp');
	
	exports.default = _default;

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.59 5.41c-.78-.78-.78-2.05 0-2.83s2.05-.78 2.83 0 .78 2.05 0 2.83c-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z"
	}), 'AirlineSeatReclineNormalTwoTone');
	
	exports.default = _default;

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 16v-2l-8.5-5V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V9L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-5.5L22 16z"
	}), 'AirplanemodeActive');
	
	exports.default = _default;

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 16v-2l-8.5-5V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V9L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-5.5L22 16z"
	}), 'AirplanemodeActiveOutlined');
	
	exports.default = _default;

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.48 13.7L13.5 9V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V9l-7.98 4.7c-.32.18-.52.53-.52.9 0 .7.67 1.2 1.34 1.01l7.16-2.1V19l-2.26 1.35c-.15.09-.24.26-.24.43v.58c0 .33.31.57.62.49l2.92-.73L12 21l.38.09.42.11 1.9.48.67.17c.32.08.62-.16.62-.49v-.58c0-.18-.09-.34-.24-.43L13.5 19v-5.5l7.16 2.1c.67.2 1.34-.3 1.34-1 0-.37-.2-.72-.52-.9z"
	}), 'AirplanemodeActiveRounded');
	
	exports.default = _default;

/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 16v-2l-8.5-5V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V9L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-5.5L22 16z"
	}), 'AirplanemodeActiveSharp');
	
	exports.default = _default;

/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 16v-2l-8.5-5V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V9L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-5.5L22 16z"
	}), 'AirplanemodeActiveTwoTone');
	
	exports.default = _default;

/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.5 7.67V3.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V9l8.5 5v2l-4.49-1.32-7.01-7.01zm9.28 14.94l1.41-1.41-7.69-7.7-3.94-3.94-6.75-6.75-1.42 1.41 6.38 6.38L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-2.67l6.28 6.28z"
	}), 'AirplanemodeInactive');
	
	exports.default = _default;

/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.5 7.67V3.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V9l8.5 5v2l-4.49-1.32-7.01-7.01zm9.28 14.94l1.41-1.41-7.69-7.7-3.94-3.94-6.75-6.75-1.42 1.41 6.38 6.38L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-2.67l6.28 6.28z"
	}), 'AirplanemodeInactiveOutlined');
	
	exports.default = _default;

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 14.6c0 .7-.67 1.2-1.34 1.01l-3.15-.93-7.01-7.01V3.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V9l7.98 4.7c.32.18.52.53.52.9zm-8.5-1.1L9.56 9.56 3.51 3.51a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l5.67 5.67-5.25 3.11c-.32.18-.52.53-.52.9 0 .7.67 1.2 1.34 1.01l7.16-2.1V19l-2.26 1.35c-.15.09-.24.26-.24.43v.58c0 .33.31.57.62.49l2.92-.73L12 21l.38.09.42.11 1.9.48.67.17c.32.08.62-.16.62-.49v-.58c0-.18-.09-.34-.24-.43L13.5 19v-2.67l5.57 5.57c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L13.5 13.5z"
	}), 'AirplanemodeInactiveRounded');
	
	exports.default = _default;

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.5 7.67V3.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V9l8.5 5v2l-4.49-1.32-7.01-7.01zm9.28 14.94l1.41-1.41-7.69-7.7-3.94-3.94-6.75-6.75-1.42 1.41 6.38 6.38L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-2.67l6.28 6.28z"
	}), 'AirplanemodeInactiveSharp');
	
	exports.default = _default;

/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.5 7.67V3.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V9l8.5 5v2l-4.49-1.32-7.01-7.01zm9.28 14.94l1.41-1.41-7.69-7.7-3.94-3.94-6.75-6.75-1.42 1.41 6.38 6.38L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-2.67l6.28 6.28z"
	}), 'AirplanemodeInactiveTwoTone');
	
	exports.default = _default;

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 22h12l-6-6z"
	}), _react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	})), 'Airplay');
	
	exports.default = _default;

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 22h12l-6-6z"
	}), _react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	})), 'AirplayOutlined');
	
	exports.default = _default;

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.41 22h7.17c.89 0 1.34-1.08.71-1.71L12.7 16.7a.9959.9959 0 00-1.41 0L7.7 20.29c-.62.63-.18 1.71.71 1.71zM21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h3c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'AirplayRounded');
	
	exports.default = _default;

/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 22h12l-6-6-6 6zM23 3H1v16h6v-2H3V5h18v12h-4v2h6V3z"
	}), 'AirplaySharp');
	
	exports.default = _default;

/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 22h12l-6-6z"
	}), _react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	})), 'AirplayTwoTone');
	
	exports.default = _default;

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 5H3c-1.1 0-2 .89-2 2v9h2c0 1.65 1.34 3 3 3s3-1.35 3-3h5.5c0 1.65 1.34 3 3 3s3-1.35 3-3H23v-5l-6-6zM3 11V7h4v4H3zm3 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7-6.5H9V7h4v4zm4.5 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM15 11V7h1l4 4h-5z"
	}), 'AirportShuttle');
	
	exports.default = _default;

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 5H3c-1.1 0-2 .89-2 2v9h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-6-6zm-2 2h1l3 3h-4V7zM9 7h4v3H9V7zM3 7h4v3H3V7zm3 10.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zm12 0c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zM21 14h-.78c-.55-.61-1.34-1-2.22-1s-1.67.39-2.22 1H8.22c-.55-.61-1.33-1-2.22-1s-1.67.39-2.22 1H3v-2h18v2z"
	}), 'AirportShuttleOutlined');
	
	exports.default = _default;

/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22.41 10.41l-4.83-4.83c-.37-.37-.88-.58-1.41-.58H3c-1.1 0-2 .89-2 2v7c0 1.1.9 2 2 2 0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3c1.1 0 2-.9 2-2v-2.17c0-.53-.21-1.04-.59-1.42zM3 10V8c0-.55.45-1 1-1h3v4H4c-.55 0-1-.45-1-1zm3 7.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zM13 11H9V7h4v4zm5 6.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zM15 11V7h1l4 4h-5z"
	}), 'AirportShuttleRounded');
	
	exports.default = _default;

/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 5H1v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-6-6zM3 11V7h4v4H3zm3 6.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zM13 11H9V7h4v4zm5 6.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zM15 11V7h1l4 4h-5z"
	}), 'AirportShuttleSharp');
	
	exports.default = _default;

/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 14h.78c.55-.61 1.34-1 2.22-1s1.67.39 2.22 1h7.56c.55-.61 1.34-1 2.22-1s1.67.39 2.22 1H21v-2H3v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 5H3c-1.1 0-2 .89-2 2v9h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-6-6zm-2 2h1l3 3h-4V7zM9 7h4v3H9V7zM3 7h4v3H3V7zm3 10.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zm12 0c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zM21 14h-.78c-.55-.61-1.34-1-2.22-1s-1.67.39-2.22 1H8.22c-.55-.61-1.33-1-2.22-1s-1.67.39-2.22 1H3v-2h18v2z"
	})), 'AirportShuttleTwoTone');
	
	exports.default = _default;

/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'Alarm');
	
	exports.default = _default;

/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"
	}), 'AlarmAdd');
	
	exports.default = _default;

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.337 1.81l4.607 3.845-1.28 1.535-4.61-3.843zm-10.674 0l1.282 1.536L3.337 7.19l-1.28-1.536zM12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3z"
	}), 'AlarmAddOutlined');
	
	exports.default = _default;

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.18 5.01L18.1 2.45c-.42-.35-1.05-.3-1.41.13-.35.42-.29 1.05.13 1.41l3.07 2.56c.42.35 1.05.3 1.41-.13.36-.42.3-1.05-.12-1.41zM4.1 6.55l3.07-2.56c.43-.36.49-.99.13-1.41-.35-.43-.98-.48-1.4-.13L2.82 5.01c-.42.36-.48.99-.12 1.41.35.43.98.48 1.4.13zM12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zm3-8h-2v-2c0-.55-.45-1-1-1s-1 .45-1 1v2H9c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1z"
	}), 'AlarmAddRounded');
	
	exports.default = _default;

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.337 1.81l4.607 3.845-1.28 1.535-4.61-3.843zm-10.674 0l1.282 1.536L3.337 7.19l-1.28-1.536zM12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3z"
	}), 'AlarmAddSharp');
	
	exports.default = _default;

/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 6c-3.86 0-7 3.14-7 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm4 8h-3v3h-2v-3H8v-2h3V9h2v3h3v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17.337 1.81l4.607 3.845-1.28 1.535-4.61-3.843zm-10.674 0l1.282 1.536L3.337 7.19l-1.28-1.536zM12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3z"
	})), 'AlarmAddTwoTone');
	
	exports.default = _default;

/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6c3.87 0 7 3.13 7 7 0 .84-.16 1.65-.43 2.4l1.52 1.52c.58-1.19.91-2.51.91-3.92 0-4.97-4.03-9-9-9-1.41 0-2.73.33-3.92.91L9.6 6.43C10.35 6.16 11.16 6 12 6zm10-.28l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM2.92 2.29L1.65 3.57 2.98 4.9l-1.11.93 1.42 1.42 1.11-.94.8.8C3.83 8.69 3 10.75 3 13c0 4.97 4.02 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.2 2.2 1.27-1.27L3.89 3.27l-.97-.98zm13.55 16.1C15.26 19.39 13.7 20 12 20c-3.87 0-7-3.13-7-7 0-1.7.61-3.26 1.61-4.47l9.86 9.86zM8.02 3.28L6.6 1.86l-.86.71 1.42 1.42.86-.71z"
	}), 'AlarmOff');
	
	exports.default = _default;

/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.04 6.29C10.66 6.11 11.32 6 12 6c3.86 0 7 3.14 7 7 0 .68-.11 1.34-.29 1.96l1.56 1.56c.47-1.08.73-2.27.73-3.52 0-4.97-4.03-9-9-9-1.25 0-2.44.26-3.53.72l1.57 1.57zm7.297-4.48l4.607 3.845-1.28 1.535-4.61-3.843zM3.02 2.1L1.61 3.51l1.37 1.37-.92.77 1.28 1.54 1.06-.88.8.8C3.83 8.69 3 10.75 3 13c0 4.97 4.03 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.1 2.1 1.41-1.41L3.02 2.1zM12 20c-3.86 0-7-3.14-7-7 0-1.7.61-3.26 1.62-4.47l9.85 9.85C15.26 19.39 13.7 20 12 20zM7.48 3.73l.46-.38-1.28-1.54-.6.5z"
	}), 'AlarmOffOutlined');
	
	exports.default = _default;

/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.04 6.29C10.66 6.11 11.32 6 12 6c3.86 0 7 3.14 7 7 0 .68-.11 1.34-.29 1.96l1.56 1.56c.47-1.08.73-2.27.73-3.52 0-4.97-4.03-9-9-9-1.25 0-2.44.26-3.53.72l1.57 1.57zm-6.33-3.5c-.38-.38-1-.38-1.39 0l-.02.03c-.39.39-.39 1.01 0 1.39l.68.68-.17.14c-.42.34-.47.96-.13 1.38l.03.03c.35.42.96.47 1.38.12l.31-.25.8.8C3.83 8.69 3 10.75 3 13c0 4.97 4.03 9 9 9 2.25 0 4.31-.83 5.89-2.2l1.41 1.41c.38.38 1 .38 1.39 0l.03-.03c.38-.38.38-1 0-1.39l-17.01-17zM12 20c-3.86 0-7-3.14-7-7 0-1.7.61-3.26 1.62-4.47l9.85 9.85C15.26 19.39 13.7 20 12 20zm7.91-13.44c.42.35 1.03.29 1.38-.12l.03-.03c.35-.42.29-1.03-.12-1.38l-3.1-2.59c-.42-.35-1.03-.29-1.38.12l-.03.03c-.35.42-.29 1.03.12 1.38l3.1 2.59zM7.43 3.68c.18-.34.15-.77-.11-1.09l-.03-.03c-.3-.36-.8-.43-1.2-.22l1.34 1.34z"
	}), 'AlarmOffRounded');
	
	exports.default = _default;

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.04 6.29C10.66 6.11 11.32 6 12 6c3.86 0 7 3.14 7 7 0 .68-.11 1.34-.29 1.96l1.56 1.56c.47-1.08.73-2.27.73-3.52 0-4.97-4.03-9-9-9-1.25 0-2.44.26-3.53.72l1.57 1.57zm7.297-4.48l4.607 3.845-1.28 1.535-4.61-3.843zM3.02 2.1L1.61 3.51l1.37 1.37-.92.77 1.28 1.54 1.06-.88.8.8C3.83 8.69 3 10.75 3 13c0 4.97 4.03 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.1 2.1 1.41-1.41L3.02 2.1zM12 20c-3.86 0-7-3.14-7-7 0-1.7.61-3.26 1.62-4.47l9.85 9.85C15.26 19.39 13.7 20 12 20zM7.48 3.73l.46-.38-1.28-1.54-.6.5z"
	}), 'AlarmOffSharp');
	
	exports.default = _default;

/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.04 6.29C10.66 6.11 11.32 6 12 6c3.86 0 7 3.14 7 7 0 .68-.11 1.34-.29 1.96l1.56 1.56c.47-1.08.73-2.27.73-3.52 0-4.97-4.03-9-9-9-1.25 0-2.44.26-3.53.72l1.57 1.57zm7.297-4.48l4.607 3.845-1.28 1.535-4.61-3.843zm1.903 16.51l-1.43-1.43-9.7-9.7-1.43-1.43-.74-.74L4.52 3.6l-1.5-1.5-1.41 1.41 1.37 1.37-.92.77 1.28 1.54 1.06-.88.8.8C3.83 8.69 3 10.75 3 13c0 4.97 4.03 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.1 2.1 1.41-1.41-2.16-2.17zM12 20c-3.86 0-7-3.14-7-7 0-1.7.61-3.26 1.62-4.47l9.85 9.85C15.26 19.39 13.7 20 12 20zM7.48 3.73l.46-.38-1.28-1.54-.6.5z"
	}), 'AlarmOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-1.46-5.47L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06-4.93 4.95z"
	}), 'AlarmOn');
	
	exports.default = _default;

/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.54 14.53L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06zm6.797-12.72l4.607 3.845-1.28 1.535-4.61-3.843zm-10.674 0l1.282 1.536L3.337 7.19l-1.28-1.536zM12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
	}), 'AlarmOnOutlined');
	
	exports.default = _default;

/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.94 10.11l-4.4 4.42-1.6-1.6c-.29-.29-.77-.29-1.06 0-.29.29-.29.77 0 1.06L10 16.11c.29.29.77.29 1.06 0L16 11.17c.29-.29.29-.77 0-1.06-.29-.29-.77-.29-1.06 0zm6.24-5.1L18.1 2.45c-.42-.35-1.05-.3-1.41.13-.35.42-.29 1.05.13 1.41l3.07 2.56c.42.35 1.05.3 1.41-.13.36-.42.3-1.05-.12-1.41zM4.1 6.55l3.07-2.56c.43-.36.49-.99.13-1.41-.35-.43-.98-.48-1.4-.13L2.82 5.01c-.42.36-.48.99-.12 1.41.35.43.98.48 1.4.13zM12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
	}), 'AlarmOnRounded');
	
	exports.default = _default;

/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.54 14.53L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06zm6.797-12.72l4.607 3.845-1.28 1.535-4.61-3.843zm-10.674 0l1.282 1.536L3.337 7.19l-1.28-1.536zM12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
	}), 'AlarmOnSharp');
	
	exports.default = _default;

/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 6c-3.86 0-7 3.14-7 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm-1.47 10.64l-3.18-3.18 1.06-1.06 2.13 2.13 4.93-4.95 1.06 1.06-6 6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M10.54 14.53L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06zm6.797-12.72l4.607 3.845-1.28 1.535-4.61-3.843zm-10.674 0l1.282 1.536L3.337 7.19l-1.28-1.536zM12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
	})), 'AlarmOnTwoTone');
	
	exports.default = _default;

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.5 8H11v6l4.75 2.85.75-1.23-4-2.37zm4.837-6.19l4.607 3.845-1.28 1.535-4.61-3.843zm-10.674 0l1.282 1.536L3.337 7.19l-1.28-1.536zM12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
	}), 'AlarmOutlined');
	
	exports.default = _default;

/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.87 15.25l-3.37-2V8.72c0-.4-.32-.72-.72-.72h-.06c-.4 0-.72.32-.72.72v4.72c0 .35.18.68.49.86l3.65 2.19c.34.2.78.1.98-.24.21-.35.1-.8-.25-1zm5.31-10.24L18.1 2.45c-.42-.35-1.05-.3-1.41.13-.35.42-.29 1.05.13 1.41l3.07 2.56c.42.35 1.05.3 1.41-.13.36-.42.3-1.05-.12-1.41zM4.1 6.55l3.07-2.56c.43-.36.49-.99.13-1.41-.35-.43-.98-.48-1.4-.13L2.82 5.01c-.42.36-.48.99-.12 1.41.35.43.98.48 1.4.13zM12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
	}), 'AlarmRounded');
	
	exports.default = _default;

/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.5 8H11v6l4.75 2.85.75-1.23-4-2.37zm4.837-6.19l4.607 3.845-1.28 1.535-4.61-3.843zm-10.674 0l1.282 1.536L3.337 7.19l-1.28-1.536zM12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
	}), 'AlarmSharp');
	
	exports.default = _default;

/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 6c-3.86 0-7 3.14-7 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm3.75 10.85L11 14V8h1.5v5.25l4 2.37-.75 1.23z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12.5 8H11v6l4.75 2.85.75-1.23-4-2.37zm4.837-6.19l4.607 3.845-1.28 1.535-4.61-3.843zm-10.674 0l1.282 1.536L3.337 7.19l-1.28-1.536zM12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
	})), 'AlarmTwoTone');
	
	exports.default = _default;

/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 14.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5zm0-5.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
	}), 'Album');
	
	exports.default = _default;

/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-12.5c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 5.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'AlbumOutlined');
	
	exports.default = _default;

/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 14.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5zm0-5.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
	}), 'AlbumRounded');
	
	exports.default = _default;

/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 14.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5zm0-5.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
	}), 'AlbumSharp');
	
	exports.default = _default;

/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm0 12.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-12.5c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 5.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	})), 'AlbumTwoTone');
	
	exports.default = _default;

/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 6h-4c0 1.62-1.38 3-3 3s-3-1.38-3-3H5V5h14v4zm-4 7h6v3c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3z"
	}), 'AllInbox');
	
	exports.default = _default;

/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 10h3.13c.21.78.67 1.47 1.27 2H5v-2zm14 2h-4.4c.6-.53 1.06-1.22 1.27-2H19v2zm0-4h-5v1c0 1.07-.93 2-2 2s-2-.93-2-2V8H5V5h14v3zm-2 7h-3v1c0 .47-.19.9-.48 1.25-.37.45-.92.75-1.52.75s-1.15-.3-1.52-.75c-.29-.35-.48-.78-.48-1.25v-1H3v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4h-4zM5 17h3.13c.02.09.06.17.09.25.24.68.65 1.28 1.18 1.75H5v-2zm14 2h-4.4c.54-.47.95-1.07 1.18-1.75.03-.08.07-.16.09-.25H19v2z"
	}), 'AllInboxOutlined');
	
	exports.default = _default;

/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 6h-3.14c-.47 0-.84.33-.97.78C14.53 11.04 13.35 12 12 12s-2.53-.96-2.89-2.22c-.13-.45-.5-.78-.97-.78H5V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v3zm-3.13 7H20c.55 0 1 .45 1 1v2c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-2c0-.55.45-1 1-1h4.13c.47 0 .85.34.98.8.35 1.27 1.51 2.2 2.89 2.2s2.54-.93 2.89-2.2c.13-.46.51-.8.98-.8z"
	}), 'AllInboxRounded');
	
	exports.default = _default;

/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v11h18V3zm-2 6h-4c0 1.62-1.38 3-3 3s-3-1.38-3-3H5V5h14v4zm-4 7h6v5H3v-5h6c0 1.66 1.34 3 3 3s3-1.34 3-3z"
	}), 'AllInboxSharp');
	
	exports.default = _default;

/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 10h3.13c.21.78.67 1.47 1.27 2H5v-2zm14 2h-4.4c.6-.53 1.06-1.22 1.27-2H19v2zm0-4h-5v1c0 1.07-.93 2-2 2s-2-.93-2-2V8H5V5h14v3zm-5 7v1c0 .47-.19.9-.48 1.25-.37.45-.92.75-1.52.75s-1.15-.3-1.52-.75c-.29-.35-.48-.78-.48-1.25v-1H3v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4h-7zm-9 2h3.13c.02.09.06.17.09.25.24.68.65 1.28 1.18 1.75H5v-2zm14 2h-4.4c.54-.47.95-1.07 1.18-1.75.03-.08.07-.16.09-.25H19v2z"
	}), _react.default.createElement("path", {
	  d: "M8.13 10H5v2h4.4c-.6-.53-1.06-1.22-1.27-2zm6.47 2H19v-2h-3.13c-.21.78-.67 1.47-1.27 2zm-6.38 5.25c-.03-.08-.06-.16-.09-.25H5v2h4.4c-.53-.47-.94-1.07-1.18-1.75zm7.65-.25c-.02.09-.06.17-.09.25-.23.68-.64 1.28-1.18 1.75H19v-2h-3.13z",
	  opacity: ".3"
	})), 'AllInboxTwoTone');
	
	exports.default = _default;

/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L12 10.66 10.48 12h.01L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2C8.2 7.18 6.84 6.62 5.4 6.62 2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l2.83-2.5.01.01L13.52 12h-.01l2.69-2.39c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12c1.02 1.01 2.37 1.57 3.82 1.57 2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z"
	}), 'AllInclusive');
	
	exports.default = _default;

/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2C8.2 7.18 6.84 6.62 5.4 6.62 2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l7.03-6.24c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12c1.02 1.01 2.37 1.57 3.82 1.57 2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z"
	}), 'AllInclusiveOutlined');
	
	exports.default = _default;

/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.22 6.86c-2-.6-4.06-.04-5.39 1.29L12 10.66 10.48 12h.01L7.8 14.39c-.81.81-1.95 1.15-3.12.92-1.25-.25-2.28-1.25-2.57-2.49-.52-2.23 1.16-4.2 3.29-4.2.91 0 1.76.35 2.44 1.03l.47.41c.38.34.95.34 1.33 0 .45-.4.45-1.1 0-1.5l-.42-.36C8.2 7.18 6.84 6.62 5.4 6.62 2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l2.83-2.5.01.01L13.52 12h-.01l2.69-2.39c.81-.81 1.95-1.15 3.12-.92 1.25.25 2.28 1.25 2.57 2.49.52 2.23-1.16 4.2-3.29 4.2-.9 0-1.76-.35-2.44-1.03l-.48-.42c-.38-.34-.95-.34-1.33 0-.45.4-.45 1.1 0 1.5l.42.37c1.02 1.01 2.37 1.57 3.82 1.57 3.27 0 5.86-2.9 5.33-6.25-.3-1.99-1.77-3.69-3.7-4.26z"
	}), 'AllInclusiveRounded');
	
	exports.default = _default;

/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2C8.2 7.18 6.84 6.62 5.4 6.62 2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53L13.51 12l2.69-2.39c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12c1.02 1.01 2.37 1.57 3.82 1.57 2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z"
	}), 'AllInclusiveSharp');
	
	exports.default = _default;

/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2C8.2 7.18 6.84 6.62 5.4 6.62 2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l7.03-6.24c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12c1.02 1.01 2.37 1.57 3.82 1.57 2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z"
	}), 'AllInclusiveTwoTone');
	
	exports.default = _default;

/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.21 4.16l4 4v-4zm4 12l-4 4h4zm-12 4l-4-4v4zm-4-12l4-4h-4zm12.95-.95c-2.73-2.73-7.17-2.73-9.9 0s-2.73 7.17 0 9.9 7.17 2.73 9.9 0 2.73-7.16 0-9.9zm-1.1 8.8c-2.13 2.13-5.57 2.13-7.7 0s-2.13-5.57 0-7.7 5.57-2.13 7.7 0 2.13 5.57 0 7.7z"
	}), 'AllOut');
	
	exports.default = _default;

/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 4v4l4-4zm12 0l4 4V4zm4 16v-4l-4 4zM4 20h4l-4-4zm15-8c0-3.87-3.13-7-7-7s-7 3.13-7 7 3.13 7 7 7 7-3.13 7-7zm-7 5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	}), 'AllOutOutlined');
	
	exports.default = _default;

/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 4.5V8l4-4H4.5c-.28 0-.5.22-.5.5zM16 4l4 4V4.5c0-.28-.22-.5-.5-.5H16zm4 15.5V16l-4 4h3.5c.28 0 .5-.22.5-.5zM4.5 20H8l-4-4v3.5c0 .28.22.5.5.5zM19 12c0-3.87-3.13-7-7-7s-7 3.13-7 7 3.13 7 7 7 7-3.13 7-7zm-7 5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	}), 'AllOutRounded');
	
	exports.default = _default;

/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 4v4l4-4zm12 0l4 4V4zm4 16v-4l-4 4zM4 20h4l-4-4zm15-8c0-3.87-3.13-7-7-7s-7 3.13-7 7 3.13 7 7 7 7-3.13 7-7zm-7 5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	}), 'AllOutSharp');
	
	exports.default = _default;

/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "5",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 4v4l4-4zm12 0l4 4V4zm4 16v-4l-4 4zM4 20h4l-4-4zm15-8c0-3.87-3.13-7-7-7s-7 3.13-7 7 3.13 7 7 7 7-3.13 7-7zm-7 5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	})), 'AllOutTwoTone');
	
	exports.default = _default;

/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  fillOpacity: ".9",
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57V12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57V12c0-5.52-4.48-10-10-10zm0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
	}), 'AlternateEmail');
	
	exports.default = _default;

/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".9",
	  d: "M12 1.95c-5.52 0-10 4.48-10 10s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57v-1.43c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57v-1.43c0-5.52-4.48-10-10-10zm0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
	})), 'AlternateEmailOutlined');
	
	exports.default = _default;

/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".9",
	  d: "M12.72 2.03C6.63 1.6 1.6 6.63 2.03 12.72 2.39 18.01 7.01 22 12.31 22H16c.55 0 1-.45 1-1s-.45-1-1-1h-3.67c-3.73 0-7.15-2.42-8.08-6.03-1.49-5.8 3.91-11.21 9.71-9.71C17.58 5.18 20 8.6 20 12.33v1.1c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57v-1.25c0-2.51-1.78-4.77-4.26-5.12-3.4-.49-6.27 2.45-5.66 5.87.34 1.91 1.83 3.49 3.72 3.94 1.84.43 3.59-.16 4.74-1.33.89 1.22 2.67 1.86 4.3 1.21 1.34-.53 2.16-1.9 2.16-3.34v-1.09c0-5.31-3.99-9.93-9.28-10.29zM12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
	})), 'AlternateEmailRounded');
	
	exports.default = _default;

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".9",
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57V12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57V12c0-5.52-4.48-10-10-10zm0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
	})), 'AlternateEmailSharp');
	
	exports.default = _default;

/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".9",
	  d: "M12 21.95h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57v-1.43c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57v-1.43c0-5.52-4.48-10-10-10s-10 4.48-10 10 4.48 10 10 10zm0-7c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
	})), 'AlternateEmailTwoTone');
	
	exports.default = _default;

/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 4h10v15H7zM3 6h2v11H3zM19 6h2v11h-2z"
	}), 'AmpStories');
	
	exports.default = _default;

/***/ },
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 19h10V4H7v15zM9 6h6v11H9V6zM3 6h2v11H3zM19 6h2v11h-2z"
	}), 'AmpStoriesOutlined');
	
	exports.default = _default;

/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 4H8c-.55 0-1 .45-1 1v13c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zM4 6c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1s1-.45 1-1V7c0-.55-.45-1-1-1zM20 6c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1s1-.45 1-1V7c0-.55-.45-1-1-1z"
	}), 'AmpStoriesRounded');
	
	exports.default = _default;

/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 4h10v15H7zM3 6h2v11H3zM19 6h2v11h-2z"
	}), 'AmpStoriesSharp');
	
	exports.default = _default;

/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9 6h6v11H9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M7 19h10V4H7v15zM9 6h6v11H9V6zM3 6h2v11H3zM19 6h2v11h-2z"
	})), 'AmpStoriesTwoTone');
	
	exports.default = _default;

/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z"
	}), 'Android');
	
	exports.default = _default;

/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71s-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z"
	}), 'AndroidOutlined');
	
	exports.default = _default;

/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71s-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z"
	}), 'AndroidRounded');
	
	exports.default = _default;

/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71s-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z"
	}), 'AndroidSharp');
	
	exports.default = _default;

/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71s-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z"
	}), 'AndroidTwoTone');
	
	exports.default = _default;

/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z"
	}), 'Announcement');
	
	exports.default = _default;

/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zM11 5h2v6h-2zm0 8h2v2h-2z"
	}), 'AnnouncementOutlined');
	
	exports.default = _default;

/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 9c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z"
	}), 'AnnouncementRounded');
	
	exports.default = _default;

/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H2v20l4-4h16V2zm-9 9h-2V5h2v6zm0 4h-2v-2h2v2z"
	}), 'AnnouncementSharp');
	
	exports.default = _default;

/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 4v13.17l.59-.59.58-.58H20V4H4zm9 11h-2v-2h2v2zm0-4h-2V5h2v6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zM11 5h2v6h-2zm0 8h2v2h-2z"
	})), 'AnnouncementTwoTone');
	
	exports.default = _default;

/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 11V3H7v4H3v14h8v-4h2v4h8V11h-4zM7 19H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm4 4H9v-2h2v2zm0-4H9V9h2v2zm0-4H9V5h2v2zm4 8h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm4 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
	}), 'Apartment');
	
	exports.default = _default;

/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 11V3H7v4H3v14h8v-4h2v4h8V11h-4zM7 19H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm4 4H9v-2h2v2zm0-4H9V9h2v2zm0-4H9V5h2v2zm4 8h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm4 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
	}), 'ApartmentOutlined');
	
	exports.default = _default;

/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 11V5c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h5c.55 0 1-.45 1-1v-3h2v3c0 .55.45 1 1 1h5c1.1 0 2-.9 2-2v-6c0-1.1-.9-2-2-2h-2zM7 19H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm4 4H9v-2h2v2zm0-4H9V9h2v2zm0-4H9V5h2v2zm4 8h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm4 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
	}), 'ApartmentRounded');
	
	exports.default = _default;

/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 11V3H7v4H3v14h8v-4h2v4h8V11h-4zM7 19H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm4 4H9v-2h2v2zm0-4H9V9h2v2zm0-4H9V5h2v2zm4 8h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm4 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
	}), 'ApartmentSharp');
	
	exports.default = _default;

/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 11V3H7v4H3v14h8v-4h2v4h8V11h-4zM7 19H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm4 4H9v-2h2v2zm0-4H9V9h2v2zm0-4H9V5h2v2zm4 8h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm4 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
	}), 'ApartmentTwoTone');
	
	exports.default = _default;

/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"
	}), 'Apple');
	
	exports.default = _default;

/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
	}), 'Apps');
	
	exports.default = _default;

/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
	}), 'AppsOutlined');
	
	exports.default = _default;

/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
	}), 'AppsRounded');
	
	exports.default = _default;

/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
	}), 'AppsSharp');
	
	exports.default = _default;

/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
	}), 'AppsTwoTone');
	
	exports.default = _default;

/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z"
	}), 'Archive');
	
	exports.default = _default;

/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM6.24 5h11.52l.81.97H5.44l.8-.97zM5 19V8h14v11H5zm8.45-9h-2.9v3H8l4 4 4-4h-2.55z"
	}), 'ArchiveOutlined');
	
	exports.default = _default;

/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zm-8.89 11.92L6.5 12H10v-2h4v2h3.5l-5.15 5.15c-.19.19-.51.19-.7 0zM5.12 5l.81-1h12l.94 1H5.12z"
	}), 'ArchiveRounded');
	
	exports.default = _default;

/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.71 3H5.29L3 5.79V21h18V5.79L18.71 3zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z"
	}), 'ArchiveSharp');
	
	exports.default = _default;

/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14V8H5v11zm5.55-6v-3h2.91v3H16l-4 4-4-4h2.55z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16 13h-2.55v-3h-2.9v3H8l4 4zm4.54-7.77l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM6.24 5h11.52l.81.97H5.44l.8-.97zM19 19H5V8h14v11z"
	})), 'ArchiveTwoTone');
	
	exports.default = _default;

/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
	}), 'ArrowBack');
	
	exports.default = _default;

/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"
	}), 'ArrowBackIos');
	
	exports.default = _default;

/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.51 3.87L15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z"
	}), 'ArrowBackIosOutlined');
	
	exports.default = _default;

/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.62 2.99c-.49-.49-1.28-.49-1.77 0L6.54 11.3c-.39.39-.39 1.02 0 1.41l8.31 8.31c.49.49 1.28.49 1.77 0s.49-1.28 0-1.77L9.38 12l7.25-7.25c.48-.48.48-1.28-.01-1.76z"
	}), 'ArrowBackIosRounded');
	
	exports.default = _default;

/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.51 3.87L15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z"
	}), 'ArrowBackIosSharp');
	
	exports.default = _default;

/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.51 3.87L15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z"
	}), 'ArrowBackIosTwoTone');
	
	exports.default = _default;

/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
	}), 'ArrowBackOutlined');
	
	exports.default = _default;

/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 11H7.83l4.88-4.88c.39-.39.39-1.03 0-1.42a.9959.9959 0 00-1.41 0l-6.59 6.59c-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L7.83 13H19c.55 0 1-.45 1-1s-.45-1-1-1z"
	}), 'ArrowBackRounded');
	
	exports.default = _default;

/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
	}), 'ArrowBackSharp');
	
	exports.default = _default;

/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
	}), 'ArrowBackTwoTone');
	
	exports.default = _default;

/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
	}), 'ArrowDownward');
	
	exports.default = _default;

/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
	}), 'ArrowDownwardOutlined');
	
	exports.default = _default;

/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 5v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41a.9959.9959 0 00-1.41 0L13 16.17V5c0-.55-.45-1-1-1s-1 .45-1 1z"
	}), 'ArrowDownwardRounded');
	
	exports.default = _default;

/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
	}), 'ArrowDownwardSharp');
	
	exports.default = _default;

/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
	}), 'ArrowDownwardTwoTone');
	
	exports.default = _default;

/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 10l5 5 5-5z"
	}), 'ArrowDropDown');
	
	exports.default = _default;

/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 12l-4-4h8l-4 4z"
	}), 'ArrowDropDownCircle');
	
	exports.default = _default;

/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 13l-4-4h8z"
	}), 'ArrowDropDownCircleOutlined');
	
	exports.default = _default;

/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-.35 12.65l-2.79-2.79c-.32-.32-.1-.86.35-.86h5.59c.45 0 .67.54.35.85l-2.79 2.79c-.2.2-.52.2-.71.01z"
	}), 'ArrowDropDownCircleRounded');
	
	exports.default = _default;

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 13l-4-4h8l-4 4z"
	}), 'ArrowDropDownCircleSharp');
	
	exports.default = _default;

/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm0 11l-4-4h8l-4 4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-5l4-4H8z"
	})), 'ArrowDropDownCircleTwoTone');
	
	exports.default = _default;

/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 10l5 5 5-5H7z"
	}), 'ArrowDropDownOutlined');
	
	exports.default = _default;

/***/ },
/* 1357 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.71 11.71l2.59 2.59c.39.39 1.02.39 1.41 0l2.59-2.59c.63-.63.18-1.71-.71-1.71H9.41c-.89 0-1.33 1.08-.7 1.71z"
	}), 'ArrowDropDownRounded');
	
	exports.default = _default;

/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 10l5 5 5-5H7z"
	}), 'ArrowDropDownSharp');
	
	exports.default = _default;

/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 10l5 5 5-5H7z"
	}), 'ArrowDropDownTwoTone');
	
	exports.default = _default;

/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 14l5-5 5 5z"
	}), 'ArrowDropUp');
	
	exports.default = _default;

/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 14l5-5 5 5H7z"
	}), 'ArrowDropUpOutlined');
	
	exports.default = _default;

/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.71 12.29L11.3 9.7c.39-.39 1.02-.39 1.41 0l2.59 2.59c.63.63.18 1.71-.71 1.71H9.41c-.89 0-1.33-1.08-.7-1.71z"
	}), 'ArrowDropUpRounded');
	
	exports.default = _default;

/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 14l5-5 5 5H7z"
	}), 'ArrowDropUpSharp');
	
	exports.default = _default;

/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 14l5-5 5 5H7z"
	}), 'ArrowDropUpTwoTone');
	
	exports.default = _default;

/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
	}), 'ArrowForward');
	
	exports.default = _default;

/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"
	}), 'ArrowForwardIos');
	
	exports.default = _default;

/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.49 20.13l1.77 1.77 9.9-9.9-9.9-9.9-1.77 1.77L14.62 12l-8.13 8.13z"
	}), 'ArrowForwardIosOutlined');
	
	exports.default = _default;

/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.38 21.01c.49.49 1.28.49 1.77 0l8.31-8.31c.39-.39.39-1.02 0-1.41L9.15 2.98c-.49-.49-1.28-.49-1.77 0s-.49 1.28 0 1.77L14.62 12l-7.25 7.25c-.48.48-.48 1.28.01 1.76z"
	}), 'ArrowForwardIosRounded');
	
	exports.default = _default;

/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.49 20.13l1.77 1.77 9.9-9.9-9.9-9.9-1.77 1.77L14.62 12l-8.13 8.13z"
	}), 'ArrowForwardIosSharp');
	
	exports.default = _default;

/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.49 20.13l1.77 1.77 9.9-9.9-9.9-9.9-1.77 1.77L14.62 12l-8.13 8.13z"
	}), 'ArrowForwardIosTwoTone');
	
	exports.default = _default;

/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"
	}), 'ArrowForwardOutlined');
	
	exports.default = _default;

/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 13h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41l-6.58-6.6a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L16.17 11H5c-.55 0-1 .45-1 1s.45 1 1 1z"
	}), 'ArrowForwardRounded');
	
	exports.default = _default;

/***/ },
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"
	}), 'ArrowForwardSharp');
	
	exports.default = _default;

/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"
	}), 'ArrowForwardTwoTone');
	
	exports.default = _default;

/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 7l-5 5 5 5V7z"
	}), 'ArrowLeft');
	
	exports.default = _default;

/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 7l-5 5 5 5V7z"
	}), 'ArrowLeftOutlined');
	
	exports.default = _default;

/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.29 8.71L9.7 11.3c-.39.39-.39 1.02 0 1.41l2.59 2.59c.63.63 1.71.18 1.71-.71V9.41c0-.89-1.08-1.33-1.71-.7z"
	}), 'ArrowLeftRounded');
	
	exports.default = _default;

/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 7l-5 5 5 5V7z"
	}), 'ArrowLeftSharp');
	
	exports.default = _default;

/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 7l-5 5 5 5V7z"
	}), 'ArrowLeftTwoTone');
	
	exports.default = _default;

/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 17l5-5-5-5v10z"
	}), 'ArrowRight');
	
	exports.default = _default;

/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.01 11H4v2h12.01v3L20 12l-3.99-4z"
	}), 'ArrowRightAlt');
	
	exports.default = _default;

/***/ },
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z"
	}), 'ArrowRightAltOutlined');
	
	exports.default = _default;

/***/ },
/* 1383 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.01 11H5c-.55 0-1 .45-1 1s.45 1 1 1h11.01v1.79c0 .45.54.67.85.35l2.78-2.79c.19-.2.19-.51 0-.71l-2.78-2.79c-.31-.32-.85-.09-.85.35V11z"
	}), 'ArrowRightAltRounded');
	
	exports.default = _default;

/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z"
	}), 'ArrowRightAltSharp');
	
	exports.default = _default;

/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z"
	}), 'ArrowRightAltTwoTone');
	
	exports.default = _default;

/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 17l5-5-5-5v10z"
	}), 'ArrowRightOutlined');
	
	exports.default = _default;

/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.71 15.29l2.59-2.59c.39-.39.39-1.02 0-1.41L11.71 8.7c-.63-.62-1.71-.18-1.71.71v5.17c0 .9 1.08 1.34 1.71.71z"
	}), 'ArrowRightRounded');
	
	exports.default = _default;

/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 17l5-5-5-5v10z"
	}), 'ArrowRightSharp');
	
	exports.default = _default;

/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 17l5-5-5-5v10z"
	}), 'ArrowRightTwoTone');
	
	exports.default = _default;

/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
	}), 'ArrowUpward');
	
	exports.default = _default;

/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
	}), 'ArrowUpwardOutlined');
	
	exports.default = _default;

/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 19V7.83l4.88 4.88c.39.39 1.03.39 1.42 0 .39-.39.39-1.02 0-1.41l-6.59-6.59a.9959.9959 0 00-1.41 0l-6.6 6.58c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 7.83V19c0 .55.45 1 1 1s1-.45 1-1z"
	}), 'ArrowUpwardRounded');
	
	exports.default = _default;

/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
	}), 'ArrowUpwardSharp');
	
	exports.default = _default;

/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
	}), 'ArrowUpwardTwoTone');
	
	exports.default = _default;

/***/ },
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 13h-8v-2h8v2zm0-6h-8v2h8V7zm-8 10h8v-2h-8v2zm-2-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zm-1.5 6l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7z"
	}), 'ArtTrack');
	
	exports.default = _default;

/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 13h-8v-2h8v2zm0-6h-8v2h8V7zm-8 10h8v-2h-8v2zm-2-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zm-1.5 6l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7z"
	}), 'ArtTrackOutlined');
	
	exports.default = _default;

/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 13h-6c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1zm0-6h-6c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zm-6 10h6c.55 0 1-.45 1-1s-.45-1-1-1h-6c-.55 0-1 .45-1 1s.45 1 1 1zm-3-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zm-2.1 5.2l-1.26-1.68c-.2-.26-.59-.27-.8-.01L6.5 14.26l-.85-1.03c-.2-.25-.58-.24-.78.01l-.74.95c-.26.33-.02.81.39.81H9.5c.41 0 .65-.47.4-.8z"
	}), 'ArtTrackRounded');
	
	exports.default = _default;

/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 13h-8v-2h8v2zm0-6h-8v2h8V7zm-8 10h8v-2h-8v2zM12 7v10H2V7h10zm-1.5 8l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7z"
	}), 'ArtTrackSharp');
	
	exports.default = _default;

/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 7h8v2h-8zm0 4h8v2h-8zm0 4h8v2h-8zM4 17h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2zm1.25-4.25l1.25 1.51L8.25 12l2.25 3h-7l1.75-2.25z"
	}), 'ArtTrackTwoTone');
	
	exports.default = _default;

/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
	}), 'AspectRatio');
	
	exports.default = _default;

/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
	}), 'AspectRatioOutlined');
	
	exports.default = _default;

/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 12c-.55 0-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zM7 9h2c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1s1-.45 1-1V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16.01H4c-.55 0-1-.45-1-1V5.99c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v12.02c0 .55-.45 1-1 1z"
	}), 'AspectRatioRounded');
	
	exports.default = _default;

/***/ },
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm16-6H1v18h22V3zm-2 16.01H3V4.99h18v14.02z"
	}), 'AspectRatioSharp');
	
	exports.default = _default;

/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 19.01h18V4.99H3v14.02zM14 15h3v-3h2v5h-5v-2zM5 7h5v2H7v3H5V7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02zM7 9h3V7H5v5h2zm12 3h-2v3h-3v2h5z"
	})), 'AspectRatioTwoTone');
	
	exports.default = _default;

/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
	}), 'Assessment');
	
	exports.default = _default;

/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"
	}), 'AssessmentOutlined');
	
	exports.default = _default;

/***/ },
/* 1407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM8 17c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v5c0 .55-.45 1-1 1zm4 0c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1zm4 0c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1z"
	}), 'AssessmentRounded');
	
	exports.default = _default;

/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
	}), 'AssessmentSharp');
	
	exports.default = _default;

/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 5v14h14V5H5zm4 12H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"
	})), 'AssessmentTwoTone');
	
	exports.default = _default;

/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
	}), 'Assignment');
	
	exports.default = _default;

/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"
	}), 'AssignmentInd');
	
	exports.default = _default;

/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.22 0 .41.1.55.25.12.13.2.31.2.5 0 .41-.34.75-.75.75s-.75-.34-.75-.75c0-.19.08-.37.2-.5.14-.15.33-.25.55-.25zM19 19H5V5h14v14zM12 6c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-6 6.47V18h12v-1.53c0-2.5-3.97-3.58-6-3.58s-6 1.07-6 3.58zM8.31 16c.69-.56 2.38-1.12 3.69-1.12s3.01.56 3.69 1.12H8.31z"
	}), 'AssignmentIndOutlined');
	
	exports.default = _default;

/***/ },
/* 1413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"
	}), 'AssignmentIndRounded');
	
	exports.default = _default;

/***/ },
/* 1414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3h-6.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H3v18h18V3zm-9 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"
	}), 'AssignmentIndSharp');
	
	exports.default = _default;

/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 5H5v14h14V5zm-7 1c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zm6 12H6v-1.53c0-2.5 3.97-3.58 6-3.58s6 1.08 6 3.58V18z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20.66 3.88c-.14-.21-.33-.4-.54-.54-.11-.07-.22-.13-.34-.18-.24-.1-.5-.16-.78-.16h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c.28 0 .54-.06.78-.16.12-.05.23-.11.34-.18.21-.14.4-.33.54-.54.21-.32.34-.71.34-1.12V5c0-.41-.13-.8-.34-1.12zM12 2.75c.22 0 .41.1.55.25.12.13.2.31.2.5 0 .41-.34.75-.75.75s-.75-.34-.75-.75c0-.19.08-.37.2-.5.14-.15.33-.25.55-.25zM19 19H5V5h14v14zm-7-7c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0 2.88c-2.03 0-6 1.08-6 3.58V18h12v-1.53c0-2.51-3.97-3.59-6-3.59zM8.31 16c.69-.56 2.38-1.12 3.69-1.12s3.01.56 3.69 1.12H8.31z"
	})), 'AssignmentIndTwoTone');
	
	exports.default = _default;

/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 15h-2v-2h2v2zm0-4h-2V8h2v6zm-1-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'AssignmentLate');
	
	exports.default = _default;

/***/ },
/* 1417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 15h2v2h-2zm0-8h2v6h-2zm8-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
	}), 'AssignmentLateOutlined');
	
	exports.default = _default;

/***/ },
/* 1418 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 15h-2v-2h2v2zm0-5c0 .55-.45 1-1 1s-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v4zm-1-8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'AssignmentLateRounded');
	
	exports.default = _default;

/***/ },
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3h-6.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H3v18h18V3zm-8 15h-2v-2h2v2zm0-4h-2V8h2v6zm-1-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'AssignmentLateSharp');
	
	exports.default = _default;

/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 5v14h14V5H5zm8 12h-2v-2h2v2zm0-4h-2V7h2v6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11 15h2v2h-2zm0-8h2v6h-2zm8-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64S3 4.72 3 5v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
	})), 'AssignmentLateTwoTone');
	
	exports.default = _default;

/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
	}), 'AssignmentOutlined');
	
	exports.default = _default;

/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z"
	}), 'AssignmentReturn');
	
	exports.default = _default;

/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 14h4v-4h-4V7l-5 5 5 5zm7-11h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
	}), 'AssignmentReturnOutlined');
	
	exports.default = _default;

/***/ },
/* 1424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-4.65-4.65c-.2-.2-.2-.51 0-.71L12 8v3h4v4z"
	}), 'AssignmentReturnRounded');
	
	exports.default = _default;

/***/ },
/* 1425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3h-6.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H3v18h18V3zm-9 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z"
	}), 'AssignmentReturnSharp');
	
	exports.default = _default;

/***/ },
/* 1426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 5v14h14V5H5zm11 9h-4v3l-5-5 5-5v3h4v4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 7l-5 5 5 5v-3h4v-4h-4zm7-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64S3 4.72 3 5v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
	})), 'AssignmentReturnTwoTone');
	
	exports.default = _default;

/***/ },
/* 1427 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 15l-5-5h3V9h4v4h3l-5 5z"
	}), 'AssignmentReturned');
	
	exports.default = _default;

/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 12h-3V8h-4v4H7l5 5zm2-9h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
	}), 'AssignmentReturnedOutlined');
	
	exports.default = _default;

/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-.35 14.65L7 13h3V9h4v4h3l-4.65 4.65c-.19.19-.51.19-.7 0z"
	}), 'AssignmentReturnedRounded');
	
	exports.default = _default;

/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3h-6.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H3v18h18V3zm-9 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 15l-5-5h3V9h4v4h3l-5 5z"
	}), 'AssignmentReturnedSharp');
	
	exports.default = _default;

/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14V5H5v14zm5-7V8h4v4h3l-5 5-5-5h3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 12h-3V8h-4v4H7l5 5zm2-9h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64S3 4.72 3 5v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
	})), 'AssignmentReturnedTwoTone');
	
	exports.default = _default;

/***/ },
/* 1432 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm1 14H8c-.55 0-1-.45-1-1s.45-1 1-1h5c.55 0 1 .45 1 1s-.45 1-1 1zm3-4H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zm0-4H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'AssignmentRounded');
	
	exports.default = _default;

/***/ },
/* 1433 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3h-6.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H3v18h18V3zm-9 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
	}), 'AssignmentSharp');
	
	exports.default = _default;

/***/ },
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
	}), 'AssignmentTurnedIn');
	
	exports.default = _default;

/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 9l-1.41-1.42L10 14.17l-2.59-2.58L6 13l4 4zm1-6h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
	}), 'AssignmentTurnedInOutlined');
	
	exports.default = _default;

/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9.29 16.29L6.7 13.7a.9959.9959 0 010-1.41c.39-.39 1.02-.39 1.41 0L10 14.17l5.88-5.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-6.59 6.59c-.38.39-1.02.39-1.41 0z"
	}), 'AssignmentTurnedInRounded');
	
	exports.default = _default;

/***/ },
/* 1437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3h-6.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H3v18h18V3zm-9 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
	}), 'AssignmentTurnedInSharp');
	
	exports.default = _default;

/***/ },
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14V5H5v14zm2.41-7.41L10 14.17l6.59-6.59L18 9l-8 8-4-4 1.41-1.41z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 9l-1.41-1.42L10 14.17l-2.59-2.58L6 13l4 4zm1-6h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64S3 4.72 3 5v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
	})), 'AssignmentTurnedInTwoTone');
	
	exports.default = _default;

/***/ },
/* 1439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 5v14h14V5H5zm9 12H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64S3 4.72 3 5v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
	})), 'AssignmentTwoTone');
	
	exports.default = _default;

/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5.12 10.88L12 17l-1.88-4.12L6 11l4.12-1.88L12 5l1.88 4.12L18 11l-4.12 1.88z"
	}), 'Assistant');
	
	exports.default = _default;

/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 16h-4.83l-.59.59L12 20.17l-1.59-1.59-.58-.58H5V4h14v14zm-7-1l1.88-4.12L18 11l-4.12-1.88L12 5l-1.88 4.12L6 11l4.12 1.88z"
	}), 'AssistantOutlined');
	
	exports.default = _default;

/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"
	}), 'AssistantPhoto');
	
	exports.default = _default;

/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.36 6l.08.39.32 1.61H18v6h-3.36l-.08-.39-.32-1.61H7V6h5.36M14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6L14 4z"
	}), 'AssistantPhotoOutlined');
	
	exports.default = _default;

/***/ },
/* 1444 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.4 6l-.24-1.2c-.09-.46-.5-.8-.98-.8H6c-.55 0-1 .45-1 1v15c0 .55.45 1 1 1s1-.45 1-1v-6h5.6l.24 1.2c.09.47.5.8.98.8H19c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1h-4.6z"
	}), 'AssistantPhotoRounded');
	
	exports.default = _default;

/***/ },
/* 1445 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6z"
	}), 'AssistantPhotoSharp');
	
	exports.default = _default;

/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14.24 12l.4 2H18V8h-5.24l-.4-2H7v6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M7 14h5.6l.4 2h7V6h-5.6L14 4H5v17h2v-7zm0-8h5.36l.4 2H18v6h-3.36l-.4-2H7V6z"
	})), 'AssistantPhotoTwoTone');
	
	exports.default = _default;

/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l2.29 2.29c.39.39 1.02.39 1.41 0L15 20h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5.12 10.88L12 17l-1.88-4.12L6 11l4.12-1.88L12 5l1.88 4.12L18 11l-4.12 1.88z"
	}), 'AssistantRounded');
	
	exports.default = _default;

/***/ },
/* 1448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 2H3v18h6l3 3 3-3h6V2zm-7.12 10.88L12 17l-1.88-4.12L6 11l4.12-1.88L12 5l1.88 4.12L18 11l-4.12 1.88z"
	}), 'AssistantSharp');
	
	exports.default = _default;

/***/ },
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9.83 18l.59.59L12 20.17l1.59-1.59.58-.58H19V4H5v14h4.83zm.29-8.88L12 5l1.88 4.12L18 11l-4.12 1.88L12 17l-1.88-4.12L6 11l4.12-1.88z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 20h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2zM5 4h14v14h-4.83l-.59.59L12 20.17l-1.59-1.59-.58-.58H5V4zm7 13l1.88-4.12L18 11l-4.12-1.88L12 5l-1.88 4.12L6 11l4.12 1.88z"
	})), 'AssistantTwoTone');
	
	exports.default = _default;

/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 9v1.5h2.25V15h1.5v-4.5H14V9zM6 9H3c-.55 0-1 .45-1 1v5h1.5v-1.5h2V15H7v-5c0-.55-.45-1-1-1zm-.5 3h-2v-1.5h2V12zM21 9h-4.5c-.55 0-1 .45-1 1v5H17v-4.5h1V14h1.5v-3.51h1V15H22v-5c0-.55-.45-1-1-1z"
	}), 'Atm');
	
	exports.default = _default;

/***/ },
/* 1451 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 9v1.5h2.25V15h1.5v-4.5H14V9H8zM6 9H3c-.55 0-1 .45-1 1v5h1.5v-1.5h2V15H7v-5c0-.55-.45-1-1-1zm-.5 3h-2v-1.5h2V12zM21 9h-4.5c-.55 0-1 .45-1 1v5H17v-4.5h1V14h1.5v-3.51h1V15H22v-5c0-.55-.45-1-1-1z"
	}), 'AtmOutlined');
	
	exports.default = _default;

/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 9.75c0 .41.34.75.75.75h1.5v3.75c0 .41.34.75.75.75s.75-.34.75-.75V10.5h1.5c.41 0 .75-.34.75-.75S13.66 9 13.25 9h-4.5c-.41 0-.75.34-.75.75zM6 9H3c-.55 0-1 .45-1 1v4.25c0 .41.34.75.75.75s.75-.34.75-.75v-.75h2v.75c0 .41.34.75.75.75s.75-.34.75-.75V10c0-.55-.45-1-1-1zm-.5 3h-2v-1.5h2V12zM21 9h-4.5c-.55 0-1 .45-1 1v4.25c0 .41.34.75.75.75s.75-.34.75-.75V10.5h1v2.75c0 .41.34.75.75.75s.75-.34.75-.75v-2.76h1v3.76c0 .41.34.75.75.75s.75-.34.75-.75V10c0-.55-.45-1-1-1z"
	}), 'AtmRounded');
	
	exports.default = _default;

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 9v1.5h2.25V15h1.5v-4.5H14V9H8zM7 9H2v6h1.5v-1.5h2V15H7V9zm-1.5 3h-2v-1.5h2V12zM22 9h-6.5v6H17v-4.5h1V14h1.5v-3.51h1V15H22V9z"
	}), 'AtmSharp');
	
	exports.default = _default;

/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.5 13.5h2V15H7v-5c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v5h1.5v-1.5zm0-3h2V12h-2v-1.5zm13.5 0h1V14h1.5v-3.51h1V15H22v-5c0-.55-.45-1-1-1h-4.5c-.55 0-1 .45-1 1v5H17v-4.5zM10.25 15h1.5v-4.5H14V9H8v1.5h2.25z"
	}), 'AtmTwoTone');
	
	exports.default = _default;

/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
	}), 'AttachFile');
	
	exports.default = _default;

/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
	}), 'AttachFileOutlined');
	
	exports.default = _default;

/***/ },
/* 1457 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.5 6.75v10.58c0 2.09-1.53 3.95-3.61 4.15-2.39.23-4.39-1.64-4.39-3.98V5.14c0-1.31.94-2.5 2.24-2.63 1.5-.15 2.76 1.02 2.76 2.49v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75v8.61c0 1.31.94 2.5 2.24 2.63 1.5.15 2.76-1.02 2.76-2.49V5.17c0-2.09-1.53-3.95-3.61-4.15C9.01.79 7 2.66 7 5v12.27c0 2.87 2.1 5.44 4.96 5.71 3.29.3 6.04-2.26 6.04-5.48V6.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75z"
	}), 'AttachFileRounded');
	
	exports.default = _default;

/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
	}), 'AttachFileSharp');
	
	exports.default = _default;

/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.5 23c3.04 0 5.5-2.46 5.5-5.5V6h-1.5v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5z"
	}), 'AttachFileTwoTone');
	
	exports.default = _default;

/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
	}), 'AttachMoney');
	
	exports.default = _default;

/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
	}), 'AttachMoneyOutlined');
	
	exports.default = _default;

/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.42 0 2.13.54 2.39 1.4.12.4.45.7.87.7h.3c.66 0 1.13-.65.9-1.27-.42-1.18-1.4-2.16-2.96-2.54V4.5c0-.83-.67-1.5-1.5-1.5S10 3.67 10 4.5v.66c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-1.65 0-2.5-.59-2.83-1.43-.15-.39-.49-.67-.9-.67h-.28c-.67 0-1.14.68-.89 1.3.57 1.39 1.9 2.21 3.4 2.53v.67c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-.65c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
	}), 'AttachMoneyRounded');
	
	exports.default = _default;

/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
	}), 'AttachMoneySharp');
	
	exports.default = _default;

/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.5 17.1c-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79z"
	}), 'AttachMoneyTwoTone');
	
	exports.default = _default;

/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z"
	}), 'Attachment');
	
	exports.default = _default;

/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.5 16H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h12.5c1.38 0 2.5 1.12 2.5 2.5S20.88 13 19.5 13H9c-.55 0-1-.45-1-1s.45-1 1-1h9.5V9.5H9c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5h10.5c2.21 0 4-1.79 4-4s-1.79-4-4-4H7c-3.04 0-5.5 2.46-5.5 5.5s2.46 5.5 5.5 5.5h11.5V16z"
	}), 'AttachmentOutlined');
	
	exports.default = _default;

/***/ },
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.75 16H7.17c-2.09 0-3.95-1.53-4.15-3.61C2.79 10.01 4.66 8 7 8h12.36c1.31 0 2.5.94 2.63 2.24.15 1.5-1.02 2.76-2.49 2.76H9c-.55 0-1-.45-1-1s.45-1 1-1h8.75c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H9.14c-1.31 0-2.5.94-2.63 2.24-.15 1.5 1.02 2.76 2.49 2.76h10.33c2.09 0 3.95-1.53 4.15-3.61.23-2.39-1.64-4.39-3.98-4.39H7.23c-2.87 0-5.44 2.1-5.71 4.96-.3 3.29 2.26 6.04 5.48 6.04h10.75c.41 0 .75-.34.75-.75s-.34-.75-.75-.75z"
	}), 'AttachmentRounded');
	
	exports.default = _default;

/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.5 16H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h12.5c1.38 0 2.5 1.12 2.5 2.5S20.88 13 19.5 13H9c-.55 0-1-.45-1-1s.45-1 1-1h9.5V9.5H9c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5h10.5c2.21 0 4-1.79 4-4s-1.79-4-4-4H7c-3.04 0-5.5 2.46-5.5 5.5s2.46 5.5 5.5 5.5h11.5V16z"
	}), 'AttachmentSharp');
	
	exports.default = _default;

/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.5 16H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h12.5c1.38 0 2.5 1.12 2.5 2.5S20.88 13 19.5 13H9c-.55 0-1-.45-1-1s.45-1 1-1h9.5V9.5H9c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5h10.5c2.21 0 4-1.79 4-4s-1.79-4-4-4H7c-3.04 0-5.5 2.46-5.5 5.5s2.46 5.5 5.5 5.5h11.5V16z"
	}), 'AttachmentTwoTone');
	
	exports.default = _default;

/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3v9.28c-.47-.17-.97-.28-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7z"
	}), 'Audiotrack');
	
	exports.default = _default;

/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6zm-2 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'AudiotrackOutlined');
	
	exports.default = _default;

/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5v8.55c-.94-.54-2.1-.75-3.33-.32-1.34.48-2.37 1.67-2.61 3.07-.46 2.74 1.86 5.08 4.59 4.65 1.96-.31 3.35-2.11 3.35-4.1V7h2c1.1 0 2-.9 2-2s-.9-2-2-2h-2c-1.1 0-2 .9-2 2z"
	}), 'AudiotrackRounded');
	
	exports.default = _default;

/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"
	}), 'AudiotrackSharp');
	
	exports.default = _default;

/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "10",
	  cy: "17",
	  r: "2",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M10 21c2.21 0 4-1.79 4-4V7h4V3h-6v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"
	})), 'AudiotrackTwoTone');
	
	exports.default = _default;

/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
	}), 'Autorenew');
	
	exports.default = _default;

/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
	}), 'AutorenewOutlined');
	
	exports.default = _default;

/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6v1.79c0 .45.54.67.85.35l2.79-2.79c.2-.2.2-.51 0-.71l-2.79-2.79c-.31-.31-.85-.09-.85.36V4c-4.42 0-8 3.58-8 8 0 1.04.2 2.04.57 2.95.27.67 1.13.85 1.64.34.27-.27.38-.68.23-1.04C6.15 13.56 6 12.79 6 12c0-3.31 2.69-6 6-6zm5.79 2.71c-.27.27-.38.69-.23 1.04.28.7.44 1.46.44 2.25 0 3.31-2.69 6-6 6v-1.79c0-.45-.54-.67-.85-.35l-2.79 2.79c-.2.2-.2.51 0 .71l2.79 2.79c.31.31.85.09.85-.35V20c4.42 0 8-3.58 8-8 0-1.04-.2-2.04-.57-2.95-.27-.67-1.13-.85-1.64-.34z"
	}), 'AutorenewRounded');
	
	exports.default = _default;

/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
	}), 'AutorenewSharp');
	
	exports.default = _default;

/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
	}), 'AutorenewTwoTone');
	
	exports.default = _default;

/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm0-14v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9 4.97 0 9-4.03 9-9s-4.03-9-9-9h-1zm7 9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zM6 12c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z"
	}), 'AvTimer');
	
	exports.default = _default;

/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm0-14v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9 4.97 0 9-4.03 9-9s-4.03-9-9-9h-1zm7 9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zM6 12c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z"
	}), 'AvTimerOutlined');
	
	exports.default = _default;

/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "17",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "7",
	  cy: "12",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "17",
	  cy: "12",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M12 3c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1v-.92c3.31.48 5.87 3.25 6 6.66.14 3.85-3.03 7.2-6.88 7.26C8.19 19.06 5 15.91 5 12c0-1.68.59-3.22 1.58-4.42l4.71 4.72c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L7.26 5.46c-.38-.38-1-.39-1.4-.02C4.1 7.07 3 9.4 3 12c0 5.04 4.14 9.12 9.21 9 4.7-.11 8.63-4.01 8.78-8.71C21.16 7.19 17.07 3 12 3z"
	})), 'AvTimerRounded');
	
	exports.default = _default;

/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm0-14v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9 4.97 0 9-4.03 9-9s-4.03-9-9-9h-1zm7 9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zM6 12c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z"
	}), 'AvTimerSharp');
	
	exports.default = _default;

/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9h-1v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "17",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "17",
	  cy: "12",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "7",
	  cy: "12",
	  r: "1"
	})), 'AvTimerTwoTone');
	
	exports.default = _default;

/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z"
	}), 'Backspace');
	
	exports.default = _default;

/***/ },
/* 1486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7.07L2.4 12l4.66-7H22v14zm-11.59-2L14 13.41 17.59 17 19 15.59 15.41 12 19 8.41 17.59 7 14 10.59 10.41 7 9 8.41 12.59 12 9 15.59z"
	}), 'BackspaceOutlined');
	
	exports.default = _default;

/***/ },
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 3H7c-.69 0-1.23.35-1.59.88L.37 11.45c-.22.34-.22.77 0 1.11l5.04 7.56c.36.52.9.88 1.59.88h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3.7 13.3c-.39.39-1.02.39-1.41 0L14 13.41l-2.89 2.89c-.39.39-1.02.39-1.41 0a.9959.9959 0 010-1.41L12.59 12 9.7 9.11a.9959.9959 0 010-1.41c.39-.39 1.02-.39 1.41 0L14 10.59l2.89-2.89c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41L15.41 12l2.89 2.89c.38.38.38 1.02 0 1.41z"
	}), 'BackspaceRounded');
	
	exports.default = _default;

/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M24 3H6l-6 9 6 9h18V3zm-5 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z"
	}), 'BackspaceSharp');
	
	exports.default = _default;

/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7.06 5L2.4 12l4.67 7H22V5H7.06c.01 0 .01 0 0 0zM9 8.41L10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59 17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7.07L2.4 12l4.66-7H22v14zm-11.59-2L14 13.41 17.59 17 19 15.59 15.41 12 19 8.41 17.59 7 14 10.59 10.41 7 9 8.41 12.59 12 9 15.59z"
	})), 'BackspaceTwoTone');
	
	exports.default = _default;

/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
	}), 'Backup');
	
	exports.default = _default;

/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z"
	}), 'BackupOutlined');
	
	exports.default = _default;

/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l4.65-4.65c.2-.2.51-.2.71 0L17 13h-3z"
	}), 'BackupRounded');
	
	exports.default = _default;

/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
	}), 'BackupSharp');
	
	exports.default = _default;

/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19.21 12.04l-1.53-.11-.3-1.5C16.88 7.86 14.62 6 12 6 9.94 6 8.08 7.14 7.12 8.96l-.5.95-1.07.11C3.53 10.24 2 11.95 2 14c0 2.21 1.79 4 4 4h13c1.65 0 3-1.35 3-3 0-1.55-1.22-2.86-2.79-2.96zm-5.76.96v3h-2.91v-3H8l4-4 4 4h-2.55z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z"
	})), 'BackupTwoTone');
	
	exports.default = _default;

/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  fillRule: "evenodd",
	  d: "M13 9.5h5v-2h-5v2zm0 7h5v-2h-5v2zm6 4.5H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2zM6 11h5V6H6v5zm1-4h3v3H7V7zM6 18h5v-5H6v5zm1-4h3v3H7v-3z"
	}), 'Ballot');
	
	exports.default = _default;

/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 7.5h5v2h-5zm0 7h5v2h-5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM11 6H6v5h5V6zm-1 4H7V7h3v3zm1 3H6v5h5v-5zm-1 4H7v-3h3v3z"
	}), 'BallotOutlined');
	
	exports.default = _default;

/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 9.5h3c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1zm0 7h3c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1zm5 4.5H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2zM7 11h3c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm0-4h3v3H7V7zm0 11h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm0-4h3v3H7v-3z"
	}), 'BallotRounded');
	
	exports.default = _default;

/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 9.5h5v-2h-5v2zm0 7h5v-2h-5v2zm8 4.5H3V3h18v18zM6 11h5V6H6v5zm1-4h3v3H7V7zM6 18h5v-5H6v5zm1-4h3v3H7v-3z"
	}), 'BallotSharp');
	
	exports.default = _default;

/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 14h3v3H7zm0-7h3v3H7zM5 19h14V5H5v14zm8-11.5h5v2h-5v-2zm0 7h5v2h-5v-2zM6 6h5v5H6V6zm0 7h5v5H6v-5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M13 7.5h5v2h-5zm0 7h5v2h-5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM11 6H6v5h5V6zm-1 4H7V7h3v3zm1 3H6v5h5v-5zm-1 4H7v-3h3v3z"
	})), 'BallotTwoTone');
	
	exports.default = _default;

/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z"
	}), 'BarChart');
	
	exports.default = _default;

/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 9.2h3V19H5V9.2zM10.6 5h2.8v14h-2.8V5zm5.6 8H19v6h-2.8v-6z"
	}), 'BarChartOutlined');
	
	exports.default = _default;

/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.4 9.2h.2c.77 0 1.4.63 1.4 1.4v7c0 .77-.63 1.4-1.4 1.4h-.2c-.77 0-1.4-.63-1.4-1.4v-7c0-.77.63-1.4 1.4-1.4zM12 5c.77 0 1.4.63 1.4 1.4v11.2c0 .77-.63 1.4-1.4 1.4-.77 0-1.4-.63-1.4-1.4V6.4c0-.77.63-1.4 1.4-1.4zm5.6 8c.77 0 1.4.63 1.4 1.4v3.2c0 .77-.63 1.4-1.4 1.4-.77 0-1.4-.63-1.4-1.4v-3.2c0-.77.63-1.4 1.4-1.4z"
	}), 'BarChartRounded');
	
	exports.default = _default;

/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 9.2h3V19H5V9.2zM10.6 5h2.8v14h-2.8V5zm5.6 8H19v6h-2.8v-6z"
	}), 'BarChartSharp');
	
	exports.default = _default;

/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 9.2h3V19H5zM16.2 13H19v6h-2.8zm-5.6-8h2.8v14h-2.8z"
	}), 'BarChartTwoTone');
	
	exports.default = _default;

/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "7",
	  cy: "7",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M20 13V4.83C20 3.27 18.73 2 17.17 2c-.75 0-1.47.3-2 .83l-1.25 1.25c-.16-.05-.33-.08-.51-.08-.4 0-.77.12-1.08.32l2.76 2.76c.2-.31.32-.68.32-1.08 0-.18-.03-.34-.07-.51l1.25-1.25c.15-.15.36-.24.58-.24.46 0 .83.37.83.83V13h-6.85c-.3-.21-.57-.45-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.31-.15-.65-.23-1-.23C6 10.01 5 11.01 5 12.25V13H2v6c0 1.1.9 2 2 2 0 .55.45 1 1 1h14c.55 0 1-.45 1-1 1.1 0 2-.9 2-2v-6h-2z"
	})), 'Bathtub');
	
	exports.default = _default;

/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "7",
	  cy: "7",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M20 13V4.83C20 3.27 18.73 2 17.17 2c-.75 0-1.47.3-2 .83l-1.25 1.25c-.16-.05-.33-.08-.51-.08-.4 0-.77.12-1.08.32l2.76 2.76c.2-.31.32-.68.32-1.08 0-.18-.03-.34-.07-.51l1.25-1.25c.15-.15.36-.24.58-.24.46 0 .83.37.83.83V13h-6.85c-.3-.21-.57-.45-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.31-.15-.65-.23-1-.23C6 10.01 5 11.01 5 12.25V13H2v6c0 1.1.9 2 2 2 0 .55.45 1 1 1h14c.55 0 1-.45 1-1 1.1 0 2-.9 2-2v-6h-2zm0 6H4v-4h16v4z"
	})), 'BathtubOutlined');
	
	exports.default = _default;

/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "7",
	  cy: "7",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M21 13h-1V4.83C20 3.27 18.73 2 17.17 2c-.75 0-1.47.3-2 .83l-1.25 1.25c-.16-.05-.33-.08-.51-.08-.4 0-.77.12-1.08.32l2.76 2.76c.2-.31.32-.68.32-1.08 0-.18-.03-.34-.07-.51l1.25-1.25c.15-.15.36-.24.58-.24.46 0 .83.37.83.83V13h-6.85c-.3-.21-.57-.45-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.31-.15-.65-.23-1-.23C6 10.01 5 11.01 5 12.25V13H3c-.55 0-1 .45-1 1v5c0 1.1.9 2 2 2 0 .55.45 1 1 1h14c.55 0 1-.45 1-1 1.1 0 2-.9 2-2v-5c0-.55-.45-1-1-1z"
	})), 'BathtubRounded');
	
	exports.default = _default;

/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "7",
	  cy: "7",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M20 13V4.83C20 3.27 18.73 2 17.17 2c-.75 0-1.47.3-2 .83l-1.25 1.25c-.16-.05-.33-.08-.51-.08-.4 0-.77.12-1.08.32l2.76 2.76c.2-.31.32-.68.32-1.08 0-.18-.03-.34-.07-.51l1.25-1.25c.15-.15.36-.24.58-.24.46 0 .83.37.83.83V13h-6.85c-.3-.21-.57-.45-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.31-.15-.65-.23-1-.23C6 10.01 5 11.01 5 12.25V13H2v8h2v1h16v-1h2v-8h-2z"
	})), 'BathtubSharp');
	
	exports.default = _default;

/***/ },
/* 1509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 15h16v4H4z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "7",
	  cy: "7",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M20 13V4.83C20 3.27 18.73 2 17.17 2c-.75 0-1.47.3-2 .83l-1.25 1.25c-.16-.05-.33-.08-.51-.08-.4 0-.77.12-1.08.32l2.76 2.76c.2-.31.32-.68.32-1.08 0-.18-.03-.34-.07-.51l1.25-1.25c.15-.15.36-.24.58-.24.46 0 .83.37.83.83V13h-6.85c-.3-.21-.57-.45-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.31-.15-.65-.23-1-.23C6 10.01 5 11.01 5 12.25V13H2v6c0 1.1.9 2 2 2 0 .55.45 1 1 1h14c.55 0 1-.45 1-1 1.1 0 2-.9 2-2v-6h-2zm0 6H4v-4h16v4z"
	})), 'BathtubTwoTone');
	
	exports.default = _default;

/***/ },
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 17v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17H7z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h10V5.33z"
	})), 'Battery20');
	
	exports.default = _default;

/***/ },
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 17v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17H7z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h10V5.33z"
	})), 'Battery20Outlined');
	
	exports.default = _default;

/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 17v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17H7z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H8.33C7.6 4 7 4.6 7 5.33V17h10V5.33z"
	})), 'Battery20Rounded');
	
	exports.default = _default;

/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 17v5h10v-5H7z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 4h-3V2h-4v2H7v13h10V4z"
	})), 'Battery20Sharp');
	
	exports.default = _default;

/***/ },
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 17v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17H7z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h10V5.33z"
	})), 'Battery20TwoTone');
	
	exports.default = _default;

/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V15h10V5.33z"
	}), _react.default.createElement("path", {
	  d: "M7 15v5.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V15H7z"
	})), 'Battery30');
	
	exports.default = _default;

/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V15h10V5.33z"
	}), _react.default.createElement("path", {
	  d: "M7 15v5.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V15H7z"
	})), 'Battery30Outlined');
	
	exports.default = _default;

/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H8.33C7.6 4 7 4.6 7 5.33V15h10V5.33z"
	}), _react.default.createElement("path", {
	  d: "M7 15v5.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V15H7z"
	})), 'Battery30Rounded');
	
	exports.default = _default;

/***/ },
/* 1518 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 4h-3V2h-4v2H7v11h10V4z"
	}), _react.default.createElement("path", {
	  d: "M7 15v7h10v-7H7z"
	})), 'Battery30Sharp');
	
	exports.default = _default;

/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V15h10V5.33z"
	}), _react.default.createElement("path", {
	  d: "M7 15v5.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V15H7z"
	})), 'Battery30TwoTone');
	
	exports.default = _default;

/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V13h10V5.33z"
	}), _react.default.createElement("path", {
	  d: "M7 13v7.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13H7z"
	})), 'Battery50');
	
	exports.default = _default;

/***/ },
/* 1521 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V13h10V5.33z"
	}), _react.default.createElement("path", {
	  d: "M7 13v7.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13H7z"
	})), 'Battery50Outlined');
	
	exports.default = _default;

/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H8.33C7.6 4 7 4.6 7 5.33V13h10V5.33z"
	}), _react.default.createElement("path", {
	  d: "M7 13v7.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13H7z"
	})), 'Battery50Rounded');
	
	exports.default = _default;

/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 4h-3V2h-4v2H7v9h10V4z"
	}), _react.default.createElement("path", {
	  d: "M7 13v9h10v-9H7z"
	})), 'Battery50Sharp');
	
	exports.default = _default;

/***/ },
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V13h10V5.33z"
	}), _react.default.createElement("path", {
	  d: "M7 13v7.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13H7z"
	})), 'Battery50TwoTone');
	
	exports.default = _default;

/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h10V5.33z"
	}), _react.default.createElement("path", {
	  d: "M7 11v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11H7z"
	})), 'Battery60');
	
	exports.default = _default;

/***/ },
/* 1526 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h10V5.33z"
	}), _react.default.createElement("path", {
	  d: "M7 11v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11H7z"
	})), 'Battery60Outlined');
	
	exports.default = _default;

/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H8.33C7.6 4 7 4.6 7 5.33V11h10V5.33z"
	}), _react.default.createElement("path", {
	  d: "M7 11v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11H7z"
	})), 'Battery60Rounded');
	
	exports.default = _default;

/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 4h-3V2h-4v2H7v7h10V4z"
	}), _react.default.createElement("path", {
	  d: "M7 11v11h10V11H7z"
	})), 'Battery60Sharp');
	
	exports.default = _default;

/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h10V5.33z"
	}), _react.default.createElement("path", {
	  d: "M7 11v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11H7z"
	})), 'Battery60TwoTone');
	
	exports.default = _default;

/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h10V5.33z"
	}), _react.default.createElement("path", {
	  d: "M7 9v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9H7z"
	})), 'Battery80');
	
	exports.default = _default;

/***/ },
/* 1531 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h10V5.33z"
	}), _react.default.createElement("path", {
	  d: "M7 9v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9H7z"
	})), 'Battery80Outlined');
	
	exports.default = _default;

/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H8.33C7.6 4 7 4.6 7 5.33V9h10V5.33z"
	}), _react.default.createElement("path", {
	  d: "M7 9v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9H7z"
	})), 'Battery80Rounded');
	
	exports.default = _default;

/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 4h-3V2h-4v2H7v5h10V4z"
	}), _react.default.createElement("path", {
	  d: "M7 9v13h10V9H7z"
	})), 'Battery80Sharp');
	
	exports.default = _default;

/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h10V5.33z"
	}), _react.default.createElement("path", {
	  d: "M7 9v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9H7z"
	})), 'Battery80TwoTone');
	
	exports.default = _default;

/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h10V5.33z"
	}), _react.default.createElement("path", {
	  d: "M7 8v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8H7z"
	})), 'Battery90');
	
	exports.default = _default;

/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h10V5.33z"
	}), _react.default.createElement("path", {
	  d: "M7 8v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8H7z"
	})), 'Battery90Outlined');
	
	exports.default = _default;

/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H8.33C7.6 4 7 4.6 7 5.33V8h10V5.33z"
	}), _react.default.createElement("path", {
	  d: "M7 8v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8H7z"
	})), 'Battery90Rounded');
	
	exports.default = _default;

/***/ },
/* 1538 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 4h-3V2h-4v2H7v4h10V4z"
	}), _react.default.createElement("path", {
	  d: "M7 8v14h10V8H7z"
	})), 'Battery90Sharp');
	
	exports.default = _default;

/***/ },
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h10V5.33z"
	}), _react.default.createElement("path", {
	  d: "M7 8v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8H7z"
	})), 'Battery90TwoTone');
	
	exports.default = _default;

/***/ },
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z"
	}), 'BatteryAlert');
	
	exports.default = _default;

/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z"
	}), 'BatteryAlertOutlined');
	
	exports.default = _default;

/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.34 22h7.32c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-5c0 .55-.45 1-1 1s-1-.45-1-1v-3c0-.55.45-1 1-1s1 .45 1 1v3z"
	}), 'BatteryAlertRounded');
	
	exports.default = _default;

/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 4h-3V2h-4v2H7v18h10V4zm-4 14h-2v-2h2v2zm0-4h-2V9h2v5z"
	}), 'BatteryAlertSharp');
	
	exports.default = _default;

/***/ },
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z"
	}), 'BatteryAlertTwoTone');
	
	exports.default = _default;

/***/ },
/* 1545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11 20v-3H7v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17h-4.4L11 20z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h4v-2.5H9L13 7v5.5h2L12.6 17H17V5.33C17 4.6 16.4 4 15.67 4z"
	})), 'BatteryCharging20');
	
	exports.default = _default;

/***/ },
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11 20v-3H7v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17h-4.4L11 20z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h4v-2.5H9L13 7v5.5h2L12.6 17H17V5.33C17 4.6 16.4 4 15.67 4z"
	})), 'BatteryCharging20Outlined');
	
	exports.default = _default;

/***/ },
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.94 18.24c-.24.45-.94.28-.94-.24v-1H7v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17h-4.4l-.66 1.24z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H8.33C7.6 4 7 4.6 7 5.33V17h4v-2.5H9.83c-.38 0-.62-.4-.44-.74l2.67-5c.24-.45.94-.28.94.24v3.5h1.17c.38 0 .62.4.44.74L12.6 17H17V5.33C17 4.6 16.4 4 15.67 4z"
	})), 'BatteryCharging20Rounded');
	
	exports.default = _default;

/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11 20v-3H7v5h10v-5h-4.4L11 20z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 4h-3V2h-4v2H7v13h4v-2.5H9L13 7v5.5h2L12.6 17H17V4z"
	})), 'BatteryCharging20Sharp');
	
	exports.default = _default;

/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11 20v-3H7v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17h-4.4L11 20z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h4v-2.5H9L13 7v5.5h2L12.6 17H17V5.33C17 4.6 16.4 4 15.67 4z"
	})), 'BatteryCharging20TwoTone');
	
	exports.default = _default;

/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v9.17h2L13 7v5.5h2l-1.07 2H17V5.33C17 4.6 16.4 4 15.67 4z"
	}), _react.default.createElement("path", {
	  d: "M11 20v-5.5H7v6.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V14.5h-3.07L11 20z"
	})), 'BatteryCharging30');
	
	exports.default = _default;

/***/ },
/* 1551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v9.17h2L13 7v5.5h2l-1.07 2H17V5.33C17 4.6 16.4 4 15.67 4z"
	}), _react.default.createElement("path", {
	  d: "M11 20v-5.5H7v6.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V14.5h-3.07L11 20z"
	})), 'BatteryCharging30Outlined');
	
	exports.default = _default;

/***/ },
/* 1552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H8.33C7.6 4 7 4.6 7 5.33v9.17h2.83c-.38 0-.62-.4-.44-.74l2.67-5c.24-.45.94-.28.94.24v3.5h1.17c.38 0 .62.4.44.74l-.67 1.26H17V5.33C17 4.6 16.4 4 15.67 4z"
	}), _react.default.createElement("path", {
	  d: "M11.94 18.24c-.24.45-.94.28-.94-.24v-3.5H7v6.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V14.5h-3.07l-1.99 3.74z"
	})), 'BatteryCharging30Rounded');
	
	exports.default = _default;

/***/ },
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 4h-3V2h-4v2H7v10.5h2L13 7v5.5h2l-1.07 2H17V4z"
	}), _react.default.createElement("path", {
	  d: "M11 20v-5.5H7V22h10v-7.5h-3.07L11 20z"
	})), 'BatteryCharging30Sharp');
	
	exports.default = _default;

/***/ },
/* 1554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v9.17h2L13 7v5.5h2l-1.07 2H17V5.33C17 4.6 16.4 4 15.67 4z"
	}), _react.default.createElement("path", {
	  d: "M11 20v-5.5H7v6.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V14.5h-3.07L11 20z"
	})), 'BatteryCharging30TwoTone');
	
	exports.default = _default;

/***/ },
/* 1555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14.47 13.5L11 20v-5.5H9l.53-1H7v7.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13.5h-2.53z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v8.17h2.53L13 7v5.5h2l-.53 1H17V5.33C17 4.6 16.4 4 15.67 4z"
	})), 'BatteryCharging50');
	
	exports.default = _default;

/***/ },
/* 1556 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14.47 13.5L11 20v-5.5H9l.53-1H7v7.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13.5h-2.53z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v8.17h2.53L13 7v5.5h2l-.53 1H17V5.33C17 4.6 16.4 4 15.67 4z"
	})), 'BatteryCharging50Outlined');
	
	exports.default = _default;

/***/ },
/* 1557 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.94 18.24c-.24.45-.94.28-.94-.24v-3.5H9.83c-.38 0-.62-.4-.44-.74l.14-.26H7v7.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13.5h-2.53l-2.53 4.74z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H8.33C7.6 4 7 4.6 7 5.33v8.17h2.53l2.53-4.74c.24-.45.94-.28.94.24v3.5h1.17c.38 0 .62.4.44.74l-.14.26H17V5.33C17 4.6 16.4 4 15.67 4z"
	})), 'BatteryCharging50Rounded');
	
	exports.default = _default;

/***/ },
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14.47 13.5L11 20v-5.5H9l.53-1H7V22h10v-8.5h-2.53z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 4h-3V2h-4v2H7v9.5h2.53L13 7v5.5h2l-.53 1H17V4z"
	})), 'BatteryCharging50Sharp');
	
	exports.default = _default;

/***/ },
/* 1559 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14.47 13.5L11 20v-5.5H9l.53-1H7v7.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13.5h-2.53z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v8.17h2.53L13 7v5.5h2l-.53 1H17V5.33C17 4.6 16.4 4 15.67 4z"
	})), 'BatteryCharging50TwoTone');
	
	exports.default = _default;

/***/ },
/* 1560 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h3.87L13 7v4h4V5.33C17 4.6 16.4 4 15.67 4z"
	}), _react.default.createElement("path", {
	  d: "M13 12.5h2L11 20v-5.5H9l1.87-3.5H7v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11h-4v1.5z"
	})), 'BatteryCharging60');
	
	exports.default = _default;

/***/ },
/* 1561 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h3.87L13 7v4h4V5.33C17 4.6 16.4 4 15.67 4z"
	}), _react.default.createElement("path", {
	  d: "M13 12.5h2L11 20v-5.5H9l1.87-3.5H7v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11h-4v1.5z"
	})), 'BatteryCharging60Outlined');
	
	exports.default = _default;

/***/ },
/* 1562 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H8.33C7.6 4 7 4.6 7 5.33V11h3.87l1.19-2.24c.24-.45.94-.28.94.24v2h4V5.33C17 4.6 16.4 4 15.67 4z"
	}), _react.default.createElement("path", {
	  d: "M13 12.5h1.17c.38 0 .62.4.44.74l-2.67 5c-.24.45-.94.28-.94-.24v-3.5H9.83c-.38 0-.62-.4-.44-.74L10.87 11H7v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11h-4v1.5z"
	})), 'BatteryCharging60Rounded');
	
	exports.default = _default;

/***/ },
/* 1563 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 4h-3V2h-4v2H7v7h3.87L13 7v4h4V4z"
	}), _react.default.createElement("path", {
	  d: "M13 12.5h2L11 20v-5.5H9l1.87-3.5H7v11h10V11h-4v1.5z"
	})), 'BatteryCharging60Sharp');
	
	exports.default = _default;

/***/ },
/* 1564 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h3.87L13 7v4h4V5.33C17 4.6 16.4 4 15.67 4z"
	}), _react.default.createElement("path", {
	  d: "M13 12.5h2L11 20v-5.5H9l1.87-3.5H7v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11h-4v1.5z"
	})), 'BatteryCharging60TwoTone');
	
	exports.default = _default;

/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h4.93L13 7v2h4V5.33C17 4.6 16.4 4 15.67 4z"
	}), _react.default.createElement("path", {
	  d: "M13 12.5h2L11 20v-5.5H9L11.93 9H7v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9h-4v3.5z"
	})), 'BatteryCharging80');
	
	exports.default = _default;

/***/ },
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h4.93L13 7v2h4V5.33C17 4.6 16.4 4 15.67 4z"
	}), _react.default.createElement("path", {
	  d: "M13 12.5h2L11 20v-5.5H9L11.93 9H7v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9h-4v3.5z"
	})), 'BatteryCharging80Outlined');
	
	exports.default = _default;

/***/ },
/* 1567 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H8.33C7.6 4 7 4.6 7 5.33V9h4.93l.13-.24c.24-.45.94-.28.94.24h4V5.33C17 4.6 16.4 4 15.67 4z"
	}), _react.default.createElement("path", {
	  d: "M13 12.5h1.17c.38 0 .62.4.44.74l-2.67 5c-.24.45-.94.28-.94-.24v-3.5H9.83c-.38 0-.62-.4-.44-.74L11.93 9H7v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9h-4v3.5z"
	})), 'BatteryCharging80Rounded');
	
	exports.default = _default;

/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 4h-3V2h-4v2H7v5h4.93L13 7v2h4V4z"
	}), _react.default.createElement("path", {
	  d: "M13 12.5h2L11 20v-5.5H9L11.93 9H7v13h10V9h-4v3.5z"
	})), 'BatteryCharging80Sharp');
	
	exports.default = _default;

/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h4.93L13 7v2h4V5.33C17 4.6 16.4 4 15.67 4z"
	}), _react.default.createElement("path", {
	  d: "M13 12.5h2L11 20v-5.5H9L11.93 9H7v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9h-4v3.5z"
	})), 'BatteryCharging80TwoTone');
	
	exports.default = _default;

/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h5.47L13 7v1h4V5.33C17 4.6 16.4 4 15.67 4z"
	}), _react.default.createElement("path", {
	  d: "M13 12.5h2L11 20v-5.5H9L12.47 8H7v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8h-4v4.5z"
	})), 'BatteryCharging90');
	
	exports.default = _default;

/***/ },
/* 1571 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h5.47L13 7v1h4V5.33C17 4.6 16.4 4 15.67 4z"
	}), _react.default.createElement("path", {
	  d: "M13 12.5h2L11 20v-5.5H9L12.47 8H7v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8h-4v4.5z"
	})), 'BatteryCharging90Outlined');
	
	exports.default = _default;

/***/ },
/* 1572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H8.33C7.6 4 7 4.6 7 5.33V8h10V5.33C17 4.6 16.4 4 15.67 4z"
	}), _react.default.createElement("path", {
	  d: "M7 20.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8H7v12.67zm2.39-6.91l2.67-5c.24-.45.94-.28.94.24v3.5h1.17c.38 0 .62.4.44.74l-2.67 5c-.24.45-.94.28-.94-.24v-3.5H9.83c-.37 0-.62-.4-.44-.74z"
	})), 'BatteryCharging90Rounded');
	
	exports.default = _default;

/***/ },
/* 1573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M17 4h-3V2h-4v2H7v4h5.47L13 7v1h4V4z"
	}), _react.default.createElement("path", {
	  d: "M13 12.5h2L11 20v-5.5H9L12.47 8H7v14h10V8h-4v4.5z"
	})), 'BatteryCharging90Sharp');
	
	exports.default = _default;

/***/ },
/* 1574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h5.47L13 7v1h4V5.33C17 4.6 16.4 4 15.67 4z"
	}), _react.default.createElement("path", {
	  d: "M13 12.5h2L11 20v-5.5H9L12.47 8H7v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8h-4v4.5z"
	})), 'BatteryCharging90TwoTone');
	
	exports.default = _default;

/***/ },
/* 1575 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z"
	}), 'BatteryChargingFull');
	
	exports.default = _default;

/***/ },
/* 1576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z"
	}), 'BatteryChargingFullOutlined');
	
	exports.default = _default;

/***/ },
/* 1577 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.34 22h7.32c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zm-1.06 9.24l-2.67 5c-.24.45-.94.28-.94-.24v-3.5H9.83c-.38 0-.62-.4-.44-.74l2.67-5c.24-.45.94-.28.94.24v3.5h1.17c.37 0 .62.4.44.74z"
	}), 'BatteryChargingFullRounded');
	
	exports.default = _default;

/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 4h-3V2h-4v2H7v18h10V4zm-6 16v-5.5H9L13 7v5.5h2L11 20z"
	}), 'BatteryChargingFullSharp');
	
	exports.default = _default;

/***/ },
/* 1579 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z"
	}), 'BatteryChargingFullTwoTone');
	
	exports.default = _default;

/***/ },
/* 1580 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
	}), 'BatteryFull');
	
	exports.default = _default;

/***/ },
/* 1581 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
	}), 'BatteryFullOutlined');
	
	exports.default = _default;

/***/ },
/* 1582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.34 22h7.32c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
	}), 'BatteryFullRounded');
	
	exports.default = _default;

/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 4h-3V2h-4v2H7v18h10V4z"
	}), 'BatteryFullSharp');
	
	exports.default = _default;

/***/ },
/* 1584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
	}), 'BatteryFullTwoTone');
	
	exports.default = _default;

/***/ },
/* 1585 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
	}), 'BatteryStd');
	
	exports.default = _default;

/***/ },
/* 1586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
	}), 'BatteryStdOutlined');
	
	exports.default = _default;

/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.34 22h7.32c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
	}), 'BatteryStdRounded');
	
	exports.default = _default;

/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 4h-3V2h-4v2H7v18h10V4z"
	}), 'BatteryStdSharp');
	
	exports.default = _default;

/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
	}), 'BatteryStdTwoTone');
	
	exports.default = _default;

/***/ },
/* 1590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zm-2.72 13.95h-1.9v-1.9h1.9v1.9zm1.35-5.26s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94c.27-.27.44-.65.44-1.06 0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69z"
	}), 'BatteryUnknown');
	
	exports.default = _default;

/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm1.3-5.31s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94c.27-.27.44-.65.44-1.06 0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69z"
	}), 'BatteryUnknownOutlined');
	
	exports.default = _default;

/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.34 22h7.32c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm1.3-5.31s-.38.42-.67.71c-.14.14-.27.31-.39.47l-.09.15c-.08.12-.14.25-.19.37-.09.22-.16.43-.16.61h-1.6c0-.42.12-.8.29-1.13.06-.11.13-.21.2-.31.03-.05.06-.11.1-.16.11-.14.23-.28.34-.4l.93-.94c.27-.27.44-.65.44-1.06 0-.83-.67-1.5-1.5-1.5-.65 0-1.21.41-1.41.99-.11.31-.39.51-.71.51-.52 0-.88-.52-.71-1.01C9.59 8.83 10.69 8 12 8c1.66 0 3 1.34 3 3 0 .66-.27 1.26-.7 1.69z"
	}), 'BatteryUnknownRounded');
	
	exports.default = _default;

/***/ },
/* 1593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm1.3-5.31s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94c.27-.27.44-.65.44-1.06 0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69z"
	}), 'BatteryUnknownSharp');
	
	exports.default = _default;

/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm1.3-5.31s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94c.27-.27.44-.65.44-1.06 0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69z"
	}), 'BatteryUnknownTwoTone');
	
	exports.default = _default;

/***/ },
/* 1595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.127 14.56l1.43-1.43 6.44 6.443L19.57 21zm4.293-5.73l2.86-2.86c-3.95-3.95-10.35-3.96-14.3-.02 3.93-1.3 8.31-.25 11.44 2.88zM5.95 5.98c-3.94 3.95-3.93 10.35.02 14.3l2.86-2.86C5.7 14.29 4.65 9.91 5.95 5.98zm.02-.02l-.01.01c-.38 3.01 1.17 6.88 4.3 10.02l5.73-5.73c-3.13-3.13-7.01-4.68-10.02-4.3z"
	}), 'BeachAccess');
	
	exports.default = _default;

/***/ },
/* 1596 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 19.57l-1.427 1.428-6.442-6.442 1.43-1.428zM13.12 3c-2.58 0-5.16.98-7.14 2.95l-.01.01c-3.95 3.95-3.95 10.36 0 14.31l14.3-14.31C18.3 3.99 15.71 3 13.12 3zM6.14 17.27C5.4 16.03 5 14.61 5 13.12c0-.93.16-1.82.46-2.67.19 1.91.89 3.79 2.07 5.44l-1.39 1.38zm2.84-2.84C7.63 12.38 7.12 9.93 7.6 7.6c.58-.12 1.16-.18 1.75-.18 1.8 0 3.55.55 5.08 1.56l-5.45 5.45zm1.47-8.97c.85-.3 1.74-.46 2.67-.46 1.49 0 2.91.4 4.15 1.14l-1.39 1.39c-1.65-1.18-3.52-1.88-5.43-2.07z"
	}), 'BeachAccessOutlined');
	
	exports.default = _default;

/***/ },
/* 1597 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.13 14.56l1.43-1.43 5.73 5.73c.39.39.39 1.03 0 1.43-.39.39-1.03.39-1.43 0l-5.73-5.73zm4.29-5.73l1.27-1.27c.89-.89.77-2.43-.31-3.08-3.89-2.38-9.03-1.89-12.4 1.47 3.93-1.3 8.31-.25 11.44 2.88zM5.95 5.98c-3.36 3.37-3.85 8.51-1.48 12.4.66 1.08 2.19 1.21 3.08.31l1.27-1.27C5.7 14.29 4.65 9.91 5.95 5.98zm.02-.02l-.01.01c-.38 3.01 1.17 6.88 4.3 10.02l5.73-5.73c-3.13-3.13-7.01-4.68-10.02-4.3z"
	}), 'BeachAccessRounded');
	
	exports.default = _default;

/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.95 5.98c-3.94 3.95-3.93 10.35.02 14.3l2.86-2.86C5.7 14.29 4.65 9.91 5.95 5.98zm11.47 2.85l2.86-2.86c-3.95-3.95-10.35-3.96-14.3-.02 3.93-1.3 8.31-.25 11.44 2.88zM5.97 5.96l-.01.01c-.38 3.01 1.17 6.88 4.3 10.02l5.73-5.73c-3.13-3.13-7.01-4.68-10.02-4.3zm7.156 8.6l1.428-1.428 6.442 6.442-1.43 1.428z"
	}), 'BeachAccessSharp');
	
	exports.default = _default;

/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7.6 7.6c-.47 2.34.03 4.78 1.39 6.83l5.45-5.45c-1.53-1.02-3.28-1.56-5.08-1.56-.6 0-1.19.06-1.76.18zM13.12 5c-.93 0-1.82.16-2.67.46 1.91.19 3.79.89 5.44 2.07l1.39-1.39C16.03 5.4 14.61 5 13.12 5zM5 13.12c0 1.49.4 2.91 1.14 4.15l1.39-1.39c-1.18-1.65-1.88-3.52-2.07-5.44-.3.86-.46 1.76-.46 2.68z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M13.126 14.56l1.428-1.428 6.442 6.442-1.43 1.428zM13.12 3c-2.58 0-5.16.98-7.14 2.95l-.01.01c-3.95 3.95-3.95 10.36 0 14.31l14.3-14.31C18.3 3.99 15.71 3 13.12 3zM6.14 17.27C5.4 16.03 5 14.61 5 13.12c0-.93.16-1.82.46-2.67.19 1.91.89 3.79 2.07 5.44l-1.39 1.38zm2.84-2.84C7.63 12.38 7.12 9.93 7.6 7.6c.58-.12 1.16-.18 1.75-.18 1.8 0 3.55.55 5.08 1.56l-5.45 5.45zm1.47-8.97c.85-.3 1.74-.46 2.67-.46 1.49 0 2.91.4 4.15 1.14l-1.39 1.39c-1.65-1.18-3.52-1.88-5.43-2.07z"
	})), 'BeachAccessTwoTone');
	
	exports.default = _default;

/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2zm-9 15l-5-5 1.41-1.41L10 13.17l7.59-7.59L19 7l-9 9z"
	}), 'Beenhere');
	
	exports.default = _default;

/***/ },
/* 1601 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2zm-7 19.6l-7-4.66V3h14v12.93l-7 4.67zm-2.01-7.42l-2.58-2.59L6 12l4 4 8-8-1.42-1.42z"
	}), 'BeenhereOutlined');
	
	exports.default = _default;

/***/ },
/* 1602 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66l7.57 5.04c.34.22.77.22 1.11 0l7.56-5.04c.53-.36.88-.97.88-1.66V3c0-1.1-.9-2-2-2zm-.7 6.7l-7.59 7.59c-.39.39-1.02.39-1.41 0L5.71 11.7c-.39-.39-.39-1.02 0-1.41s1.02-.39 1.41 0L10 13.17l6.88-6.88c.39-.39 1.02-.39 1.41 0s.4 1.02.01 1.41z"
	}), 'BeenhereRounded');
	
	exports.default = _default;

/***/ },
/* 1603 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.01 1L3 17l9 6 8.99-6L21 1H3.01zM10 16l-5-5 1.41-1.42L10 13.17l7.59-7.59L19 7l-9 9z"
	}), 'BeenhereSharp');
	
	exports.default = _default;

/***/ },
/* 1604 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 3H5v12.93l7 4.66 7-4.67V3zm-9 13l-4-4 1.41-1.41 2.58 2.58 6.59-6.59L18 8l-8 8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2zm-7 19.6l-7-4.66V3h14v12.93l-7 4.67zm-2.01-7.42l-2.58-2.59L6 12l4 4 8-8-1.42-1.42z"
	})), 'BeenhereTwoTone');
	
	exports.default = _default;

/***/ },
/* 1605 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z"
	}), 'Block');
	
	exports.default = _default;

/***/ },
/* 1606 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z"
	}), 'BlockOutlined');
	
	exports.default = _default;

/***/ },
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z"
	}), 'BlockRounded');
	
	exports.default = _default;

/***/ },
/* 1608 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z"
	}), 'BlockSharp');
	
	exports.default = _default;

/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z"
	}), 'BlockTwoTone');
	
	exports.default = _default;

/***/ },
/* 1610 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.71 7.71L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z"
	}), 'Bluetooth');
	
	exports.default = _default;

/***/ },
/* 1611 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
	}), 'BluetoothAudio');
	
	exports.default = _default;

/***/ },
/* 1612 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33s-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
	}), 'BluetoothAudioOutlined');
	
	exports.default = _default;

/***/ },
/* 1613 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.98 10.28l-1.38 1.38c-.2.2-.2.51 0 .71l1.38 1.38c.28.28.75.15.85-.23.11-.5.17-1 .17-1.52 0-.51-.06-1.01-.18-1.48-.09-.38-.56-.52-.84-.24zm4.12-2.5c-.25-.55-.98-.67-1.4-.24-.26.26-.31.64-.17.98.46 1.07.72 2.24.72 3.47 0 1.24-.26 2.42-.73 3.49-.14.32-.09.69.16.94.41.41 1.1.29 1.35-.23.63-1.3.98-2.76.98-4.3-.01-1.45-.33-2.85-.91-4.11zM11.39 12l3.59-3.58c.39-.39.39-1.02 0-1.42l-4.29-4.29c-.63-.63-1.71-.18-1.71.71V9.6L5.09 5.7a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L8.57 12l-4.89 4.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l3.89-3.89v6.18c0 .89 1.08 1.34 1.71.71l4.3-4.3c.39-.39.39-1.02 0-1.42L11.39 12zm-.41-6.17l1.88 1.88-1.88 1.88V5.83zm0 12.34v-3.76l1.88 1.88-1.88 1.88z"
	}), 'BluetoothAudioRounded');
	
	exports.default = _default;

/***/ },
/* 1614 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33s-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
	}), 'BluetoothAudioSharp');
	
	exports.default = _default;

/***/ },
/* 1615 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33s-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
	}), 'BluetoothAudioTwoTone');
	
	exports.default = _default;

/***/ },
/* 1616 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 12l-2-2-2 2 2 2 2-2zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88zM19 10l-2 2 2 2 2-2-2-2z"
	}), 'BluetoothConnected');
	
	exports.default = _default;

/***/ },
/* 1617 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 12l-2-2-2 2 2 2 2-2zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88zM19 10l-2 2 2 2 2-2-2-2z"
	}), 'BluetoothConnectedOutlined');
	
	exports.default = _default;

/***/ },
/* 1618 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 13c.55-.55.55-1.44 0-1.99V11c-.55-.55-1.45-.55-2 0s-.55 1.45 0 2 1.45.55 2 0zm14-2c-.56-.56-1.45-.56-2-.01V11c-.55.55-.55 1.44 0 1.99V13c.55.55 1.44.55 1.99 0H20c.55-.55.55-1.45 0-2zm-3-4l-4.29-4.29c-.63-.63-1.71-.19-1.71.7v6.18L7.11 5.7a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 14.41v6.18c0 .89 1.08 1.34 1.71.71L17 17c.39-.39.39-1.02 0-1.42L13.41 12 17 8.42c.39-.39.39-1.03 0-1.42zm-2.12 9.29L13 18.17v-3.76l1.88 1.88zM13 9.59V5.83l1.88 1.88L13 9.59z"
	}), 'BluetoothConnectedRounded');
	
	exports.default = _default;

/***/ },
/* 1619 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 12l-2-2-2 2 2 2 2-2zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88zM19 10l-2 2 2 2 2-2-2-2z"
	}), 'BluetoothConnectedSharp');
	
	exports.default = _default;

/***/ },
/* 1620 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 12l-2-2-2 2 2 2 2-2zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88zM19 10l-2 2 2 2 2-2-2-2z"
	}), 'BluetoothConnectedTwoTone');
	
	exports.default = _default;

/***/ },
/* 1621 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4zM13 18.17v-3.76l1.88 1.88L13 18.17z"
	}), 'BluetoothDisabled');
	
	exports.default = _default;

/***/ },
/* 1622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4zM13 18.17v-3.76l1.88 1.88L13 18.17z"
	}), 'BluetoothDisabledOutlined');
	
	exports.default = _default;

/***/ },
/* 1623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.29 17.89L6.11 4.7a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 14.41v6.18c0 .89 1.08 1.34 1.71.71l3.59-3.59 1.59 1.59c.39.39 1.02.39 1.41 0 .38-.39.38-1.03-.01-1.41zm-6.29.28v-3.76l1.88 1.88L13 18.17zm0-12.34l1.88 1.88-1.47 1.47 1.41 1.41L17 8.42c.39-.39.39-1.02 0-1.42l-4.29-4.29c-.63-.63-1.71-.19-1.71.7v3.36l2 2V5.83z"
	}), 'BluetoothDisabledRounded');
	
	exports.default = _default;

/***/ },
/* 1624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4zM13 18.17v-3.76l1.88 1.88L13 18.17z"
	}), 'BluetoothDisabledSharp');
	
	exports.default = _default;

/***/ },
/* 1625 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4zM13 18.17v-3.76l1.88 1.88L13 18.17z"
	}), 'BluetoothDisabledTwoTone');
	
	exports.default = _default;

/***/ },
/* 1626 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.71 7.71L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z"
	}), 'BluetoothOutlined');
	
	exports.default = _default;

/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 7l-4.29-4.29c-.63-.63-1.71-.19-1.71.7v6.18L7.11 5.7a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L11 14.41v6.18c0 .89 1.08 1.34 1.71.71L17 17c.39-.39.39-1.02 0-1.41L13.41 12 17 8.42c.39-.39.39-1.03 0-1.42zm-4-1.17l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z"
	}), 'BluetoothRounded');
	
	exports.default = _default;

/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
	}), 'BluetoothSearching');
	
	exports.default = _default;

/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33s-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
	}), 'BluetoothSearchingOutlined');
	
	exports.default = _default;

/***/ },
/* 1630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.98 10.28l-1.38 1.38c-.2.2-.2.51 0 .71l1.38 1.38c.28.28.75.15.85-.23.11-.5.17-1 .17-1.52 0-.51-.06-1.01-.18-1.48-.09-.38-.56-.52-.84-.24zm4.12-2.5c-.25-.55-.98-.67-1.4-.24-.26.26-.31.64-.17.98.46 1.07.72 2.24.72 3.47 0 1.24-.26 2.42-.73 3.49-.14.32-.09.69.16.94.41.41 1.1.29 1.35-.23.63-1.3.98-2.76.98-4.3-.01-1.45-.33-2.85-.91-4.11zM11.41 12L15 8.42c.39-.39.39-1.02 0-1.42l-4.29-4.29c-.63-.63-1.71-.19-1.71.7v6.18L5.11 5.7a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L8.59 12 3.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L9 14.41v6.18c0 .89 1.08 1.34 1.71.71L15 17c.39-.39.39-1.02 0-1.42L11.41 12zM11 5.83l1.88 1.88L11 9.59V5.83zm0 12.34v-3.76l1.88 1.88L11 18.17z"
	}), 'BluetoothSearchingRounded');
	
	exports.default = _default;

/***/ },
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33s-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
	}), 'BluetoothSearchingSharp');
	
	exports.default = _default;

/***/ },
/* 1632 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33s-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
	}), 'BluetoothSearchingTwoTone');
	
	exports.default = _default;

/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.71 7.71L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z"
	}), 'BluetoothSharp');
	
	exports.default = _default;

/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.71 7.71L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z"
	}), 'BluetoothTwoTone');
	
	exports.default = _default;

/***/ },
/* 1635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-3-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm3 6c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm2-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
	}), 'BlurCircular');
	
	exports.default = _default;

/***/ },
/* 1636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-3-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm3 6c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm2-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
	}), 'BlurCircularOutlined');
	
	exports.default = _default;

/***/ },
/* 1637 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-3-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm3 6c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm2-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
	}), 'BlurCircularRounded');
	
	exports.default = _default;

/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-3-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm3 6c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm2-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
	}), 'BlurCircularSharp');
	
	exports.default = _default;

/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14 7.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
	}), _react.default.createElement("circle", {
	  cx: "14",
	  cy: "10",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "14",
	  cy: "14",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M10 16.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
	}), _react.default.createElement("circle", {
	  cx: "10",
	  cy: "10",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M7 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
	}), _react.default.createElement("circle", {
	  cx: "10",
	  cy: "14",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M10 7.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm4 9c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0 4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
	})), 'BlurCircularTwoTone');
	
	exports.default = _default;

/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM3 21h18v-2H3v2zM5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5 3.5 7.17 3.5 8 4.17 9.5 5 9.5zm0 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8-.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM3 3v2h18V3H3zm14 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm0 4c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM13 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"
	}), 'BlurLinear');
	
	exports.default = _default;

/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM3 21h18v-2H3v2zM5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5 3.5 7.17 3.5 8 4.17 9.5 5 9.5zm0 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8-.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM3 3v2h18V3H3zm14 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm0 4c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM13 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"
	}), 'BlurLinearOutlined');
	
	exports.default = _default;

/***/ },
/* 1642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM4 21h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5 3.5 7.17 3.5 8 4.17 9.5 5 9.5zm0 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8-.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM3 4c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1zm14 4.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm0 4c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM13 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"
	}), 'BlurLinearRounded');
	
	exports.default = _default;

/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM3 21h18v-2H3v2zM5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5 3.5 7.17 3.5 8 4.17 9.5 5 9.5zm0 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8-.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM3 3v2h18V3H3zm14 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm0 4c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM13 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"
	}), 'BlurLinearSharp');
	
	exports.default = _default;

/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17 16.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
	}), _react.default.createElement("circle", {
	  cx: "9",
	  cy: "12",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "13",
	  cy: "8",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "13",
	  cy: "16",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M17 12.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
	}), _react.default.createElement("circle", {
	  cx: "13",
	  cy: "12",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M3 3h18v2H3z"
	}), _react.default.createElement("circle", {
	  cx: "5",
	  cy: "8",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "5",
	  cy: "12",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "5",
	  cy: "16",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M17 8.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
	}), _react.default.createElement("circle", {
	  cx: "9",
	  cy: "16",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "9",
	  cy: "8",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M3 19h18v2H3z"
	})), 'BlurLinearTwoTone');
	
	exports.default = _default;

/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-.2 4.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm11 7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8 8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-4 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM2.5 5.27l3.78 3.78L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81c-.09-.03-.18-.06-.28-.06-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78L20 20.23 3.77 4 2.5 5.27zM10 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm11-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
	}), 'BlurOff');
	
	exports.default = _default;

/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "14",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M13.8 11.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "10",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M21 10.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
	}), _react.default.createElement("circle", {
	  cx: "10",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "14",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "6",
	  cy: "18",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M14 20.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7-7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-18 0c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
	}), _react.default.createElement("circle", {
	  cx: "10",
	  cy: "18",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
	}), _react.default.createElement("circle", {
	  cx: "6",
	  cy: "14",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M2.5 5.27L6 8.77l.28.28L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81c-.09-.03-.18-.06-.28-.06-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78h.01l1.41-1.41L3.91 3.86 2.5 5.27z"
	})), 'BlurOffOutlined');
	
	exports.default = _default;

/***/ },
/* 1647 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "14",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M13.8 11.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "10",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M21 10.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
	}), _react.default.createElement("circle", {
	  cx: "10",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "14",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "6",
	  cy: "18",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M14 20.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7-7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-18 0c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
	}), _react.default.createElement("circle", {
	  cx: "10",
	  cy: "18",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
	}), _react.default.createElement("circle", {
	  cx: "6",
	  cy: "14",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M3.21 4.56c-.39.39-.39 1.02 0 1.41l3.07 3.07L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81c-.09-.03-.18-.06-.28-.06-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.08 3.07c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.42L4.62 4.56a.9959.9959 0 00-1.41 0z"
	})), 'BlurOffRounded');
	
	exports.default = _default;

/***/ },
/* 1648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "14",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M13.8 11.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "10",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M21 10.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
	}), _react.default.createElement("circle", {
	  cx: "10",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "14",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "6",
	  cy: "18",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M14 20.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7-7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-18 0c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
	}), _react.default.createElement("circle", {
	  cx: "10",
	  cy: "18",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
	}), _react.default.createElement("circle", {
	  cx: "6",
	  cy: "14",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M2.5 5.27L6 8.77l.28.28L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81c-.09-.03-.18-.06-.28-.06-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78h.01l1.41-1.41L3.91 3.86 2.5 5.27z"
	})), 'BlurOffSharp');
	
	exports.default = _default;

/***/ },
/* 1649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "14",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M13.8 11.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "10",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M21 10.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
	}), _react.default.createElement("circle", {
	  cx: "10",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "14",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "6",
	  cy: "18",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M14 20.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7-7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-18 0c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
	}), _react.default.createElement("circle", {
	  cx: "10",
	  cy: "18",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
	}), _react.default.createElement("circle", {
	  cx: "6",
	  cy: "14",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M2.5 5.27L6 8.77l.28.28L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81c-.09-.03-.18-.06-.28-.06-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78h.01l1.41-1.41L3.91 3.86 2.5 5.27z"
	})), 'BlurOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 1650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
	}), 'BlurOn');
	
	exports.default = _default;

/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
	}), 'BlurOnOutlined');
	
	exports.default = _default;

/***/ },
/* 1652 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
	}), 'BlurOnRounded');
	
	exports.default = _default;

/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
	}), 'BlurOnSharp');
	
	exports.default = _default;

/***/ },
/* 1654 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "14",
	  cy: "10",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "14",
	  cy: "18",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "14",
	  cy: "14",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "14",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14.5 3c0-.28-.22-.5-.5-.5s-.5.22-.5.5.22.5.5.5.5-.22.5-.5zM21 14.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "18",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M13.5 21c0 .28.22.5.5.5s.5-.22.5-.5-.22-.5-.5-.5-.5.22-.5.5zM21 10.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "14",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "6",
	  cy: "18",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "6",
	  cy: "14",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M3.5 14c0-.28-.22-.5-.5-.5s-.5.22-.5.5.22.5.5.5.5-.22.5-.5z"
	}), _react.default.createElement("circle", {
	  cx: "10",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "6",
	  cy: "10",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "6",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M9.5 21c0 .28.22.5.5.5s.5-.22.5-.5-.22-.5-.5-.5-.5.22-.5.5z"
	}), _react.default.createElement("circle", {
	  cx: "10",
	  cy: "18",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M10.5 3c0-.28-.22-.5-.5-.5s-.5.22-.5.5.22.5.5.5.5-.22.5-.5z"
	}), _react.default.createElement("circle", {
	  cx: "10",
	  cy: "14",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "10",
	  cy: "10",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "10",
	  r: "1"
	})), 'BlurOnTwoTone');
	
	exports.default = _default;

/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"
	}), 'Book');
	
	exports.default = _default;

/***/ },
/* 1656 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 4h2v5l-1-.75L9 9V4zm9 16H6V4h1v9l3-2.25L13 13V4h5v16z"
	}), 'BookOutlined');
	
	exports.default = _default;

/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"
	}), 'BookRounded');
	
	exports.default = _default;

/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4v20h16V2zM6 4h5v8l-2.5-1.5L6 12V4z"
	}), 'BookSharp');
	
	exports.default = _default;

/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M13 13l-3-2.25L7 13V4H6v16h12V4h-5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 4h2v5l-1-.75L9 9V4zm9 16H6V4h1v9l3-2.25L13 13V4h5v16z"
	})), 'BookTwoTone');
	
	exports.default = _default;

/***/ },
/* 1660 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"
	}), 'Bookmark');
	
	exports.default = _default;

/***/ },
/* 1661 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
	}), 'BookmarkBorder');
	
	exports.default = _default;

/***/ },
/* 1662 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
	}), 'BookmarkBorderOutlined');
	
	exports.default = _default;

/***/ },
/* 1663 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V6c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v12z"
	}), 'BookmarkBorderRounded');
	
	exports.default = _default;

/***/ },
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5v18l7-3 7 3V3zm-2 15l-5-2.18L7 18V5h10v13z"
	}), 'BookmarkBorderSharp');
	
	exports.default = _default;

/***/ },
/* 1665 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
	}), 'BookmarkBorderTwoTone');
	
	exports.default = _default;

/***/ },
/* 1666 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2z"
	}), 'BookmarkOutlined');
	
	exports.default = _default;

/***/ },
/* 1667 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2z"
	}), 'BookmarkRounded');
	
	exports.default = _default;

/***/ },
/* 1668 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5v18l7-3 7 3V3z"
	}), 'BookmarkSharp');
	
	exports.default = _default;

/***/ },
/* 1669 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 17.97l5-2.15 5 2.15V5H7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2zm0 14.97l-5-2.14-5 2.14V5h10v12.97z"
	})), 'BookmarkTwoTone');
	
	exports.default = _default;

/***/ },
/* 1670 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 18l2 1V3c0-1.1-.9-2-2-2H8.99C7.89 1 7 1.9 7 3h10c1.1 0 2 .9 2 2v13zM15 5H5c-1.1 0-2 .9-2 2v16l7-3 7 3V7c0-1.1-.9-2-2-2z"
	}), 'Bookmarks');
	
	exports.default = _default;

/***/ },
/* 1671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 7v12.97l-4.21-1.81-.79-.34-.79.34L5 19.97V7h10m4-6H8.99C7.89 1 7 1.9 7 3h10c1.1 0 2 .9 2 2v13l2 1V3c0-1.1-.9-2-2-2zm-4 4H5c-1.1 0-2 .9-2 2v16l7-3 7 3V7c0-1.1-.9-2-2-2z"
	}), 'BookmarksOutlined');
	
	exports.default = _default;

/***/ },
/* 1672 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 18l2 1V3c0-1.1-.9-2-2-2H8.99C7.89 1 7 1.9 7 3h10c1.1 0 2 .9 2 2v13zM15 5H5c-1.1 0-2 .9-2 2v16l7-3 7 3V7c0-1.1-.9-2-2-2z"
	}), 'BookmarksRounded');
	
	exports.default = _default;

/***/ },
/* 1673 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 18l2 1V1H7v2h12v15zM17 5H3v18l7-3 7 3V5z"
	}), 'BookmarksSharp');
	
	exports.default = _default;

/***/ },
/* 1674 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 1H8.99C7.89 1 7 1.9 7 3h10c1.1 0 2 .9 2 2v13l2 1V3c0-1.1-.9-2-2-2zm-4 4H5c-1.1 0-2 .9-2 2v16l7-3 7 3V7c0-1.1-.9-2-2-2zm0 14.97l-4.21-1.81-.79-.34-.79.34L5 19.97V7h10v12.97z"
	}), _react.default.createElement("path", {
	  d: "M5 19.97l5-2.15 5 2.15V7H5z",
	  opacity: ".3"
	})), 'BookmarksTwoTone');
	
	exports.default = _default;

/***/ },
/* 1675 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z"
	}), 'BorderAll');
	
	exports.default = _default;

/***/ },
/* 1676 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z"
	}), 'BorderAllOutlined');
	
	exports.default = _default;

/***/ },
/* 1677 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2zm8 14H6c-.55 0-1-.45-1-1v-5h5c.55 0 1 .45 1 1v5zm-1-8H5V6c0-.55.45-1 1-1h5v5c0 .55-.45 1-1 1zm8 8h-5v-5c0-.55.45-1 1-1h5v5c0 .55-.45 1-1 1zm1-8h-5c-.55 0-1-.45-1-1V5h5c.55 0 1 .45 1 1v5z"
	}), 'BorderAllRounded');
	
	exports.default = _default;

/***/ },
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z"
	}), 'BorderAllSharp');
	
	exports.default = _default;

/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zM11 19H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z"
	}), 'BorderAllTwoTone');
	
	exports.default = _default;

/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z"
	}), 'BorderBottom');
	
	exports.default = _default;

/***/ },
/* 1681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z"
	}), 'BorderBottomOutlined');
	
	exports.default = _default;

/***/ },
/* 1682 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM4 21h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm1-6H3v2h2v-2z"
	}), 'BorderBottomRounded');
	
	exports.default = _default;

/***/ },
/* 1683 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z"
	}), 'BorderBottomSharp');
	
	exports.default = _default;

/***/ },
/* 1684 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 11h2v2H3zm0 4h2v2H3zm0 4h18v2H3zm16-4h2v2h-2zM3 7h2v2H3zm16 4h2v2h-2zm0-8h2v2h-2zm-4 8h2v2h-2zm4-4h2v2h-2zm-4-4h2v2h-2zm-8 8h2v2H7zM3 3h2v2H3zm8 4h2v2h-2zM7 3h2v2H7zm4 8h2v2h-2zm0 4h2v2h-2zm0-12h2v2h-2z"
	}), 'BorderBottomTwoTone');
	
	exports.default = _default;

/***/ },
/* 1685 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 5h2V3H7v2zm0 8h2v-2H7v2zm0 8h2v-2H7v2zm4-4h2v-2h-2v2zm0 4h2v-2h-2v2zm-8 0h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2V7H3v2zm0-4h2V3H3v2zm8 8h2v-2h-2v2zm8 4h2v-2h-2v2zm0-4h2v-2h-2v2zm0 8h2v-2h-2v2zm0-12h2V7h-2v2zm-8 0h2V7h-2v2zm8-6v2h2V3h-2zm-8 2h2V3h-2v2zm4 16h2v-2h-2v2zm0-8h2v-2h-2v2zm0-8h2V3h-2v2z"
	}), 'BorderClear');
	
	exports.default = _default;

/***/ },
/* 1686 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 5h2V3H7v2zm0 8h2v-2H7v2zm0 8h2v-2H7v2zm4-4h2v-2h-2v2zm0 4h2v-2h-2v2zm-8 0h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2V7H3v2zm0-4h2V3H3v2zm8 8h2v-2h-2v2zm8 4h2v-2h-2v2zm0-4h2v-2h-2v2zm0 8h2v-2h-2v2zm0-12h2V7h-2v2zm-8 0h2V7h-2v2zm8-6v2h2V3h-2zm-8 2h2V3h-2v2zm4 16h2v-2h-2v2zm0-8h2v-2h-2v2zm0-8h2V3h-2v2z"
	}), 'BorderClearOutlined');
	
	exports.default = _default;

/***/ },
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 5h2V3H7v2zm0 8h2v-2H7v2zm0 8h2v-2H7v2zm4-4h2v-2h-2v2zm0 4h2v-2h-2v2zm-8 0h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2V7H3v2zm0-4h2V3H3v2zm8 8h2v-2h-2v2zm8 4h2v-2h-2v2zm0-4h2v-2h-2v2zm0 8h2v-2h-2v2zm0-12h2V7h-2v2zm-8 0h2V7h-2v2zm8-6v2h2V3h-2zm-8 2h2V3h-2v2zm4 16h2v-2h-2v2zm0-8h2v-2h-2v2zm0-8h2V3h-2v2z"
	}), 'BorderClearRounded');
	
	exports.default = _default;

/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 5h2V3H7v2zm0 8h2v-2H7v2zm0 8h2v-2H7v2zm4-4h2v-2h-2v2zm0 4h2v-2h-2v2zm-8 0h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2V7H3v2zm0-4h2V3H3v2zm8 8h2v-2h-2v2zm8 4h2v-2h-2v2zm0-4h2v-2h-2v2zm0 8h2v-2h-2v2zm0-12h2V7h-2v2zm-8 0h2V7h-2v2zm8-6v2h2V3h-2zm-8 2h2V3h-2v2zm4 16h2v-2h-2v2zm0-8h2v-2h-2v2zm0-8h2V3h-2v2z"
	}), 'BorderClearSharp');
	
	exports.default = _default;

/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 3h2v2H7zm0 16h2v2H7zM3 3h2v2H3zm16 0h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2zM3 7h2v2H3zm0 12h2v2H3zm16 0h2v2h-2zm0-4h2v2h-2zM3 15h2v2H3zm0-4h2v2H3zm4 0h2v2H7zm8 0h2v2h-2zm-4 8h2v2h-2zm4 0h2v2h-2zm0-16h2v2h-2zm-4 0h2v2h-2zm0 4h2v2h-2zm0 8h2v2h-2zm0-4h2v2h-2z"
	}), 'BorderClearTwoTone');
	
	exports.default = _default;

/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96c.39-.39.39-1.02 0-1.41L18.37.29a.9959.9959 0 0 0-1.41 0L15 2.25 18.75 6l1.96-1.96z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".36",
	  d: "M0 20h24v4H0z"
	})), 'BorderColor');
	
	exports.default = _default;

/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14 3.25l-10 10V17h3.75l10-10L14 3.25zM6.92 15H6v-.92l8-8 .92.92-8 8zM20.71 4.04c.39-.39.39-1.02 0-1.41L18.37.29a.9959.9959 0 0 0-1.41 0L15 2.25 18.75 6l1.96-1.96z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".36",
	  d: "M0 20h24v4H0v-4z"
	})), 'BorderColorOutlined');
	
	exports.default = _default;

/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17.75 7L14 3.25 4.15 13.1c-.1.1-.15.22-.15.36v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15L17.75 7zm2.96-2.96c.39-.39.39-1.02 0-1.41L18.37.29a.9959.9959 0 0 0-1.41 0L15 2.25 18.75 6l1.96-1.96z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".36",
	  d: "M2 20h20c1.1 0 2 .9 2 2s-.9 2-2 2H2c-1.1 0-2-.9-2-2s.9-2 2-2z"
	})), 'BorderColorRounded');
	
	exports.default = _default;

/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17.75 8L14 4.25l-10 10V18h3.75l10-10zm3.66-3.66L17.66.59 15 3.25 18.75 7l2.66-2.66z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".36",
	  d: "M0 20h24v4H0v-4z"
	})), 'BorderColorSharp');
	
	exports.default = _default;

/***/ },
/* 1694 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".36",
	  d: "M14 6.08l-8 8V15h.92l8-8z"
	}), _react.default.createElement("path", {
	  d: "M14 3.25l-10 10V17h3.75l10-10L14 3.25zM6.92 15H6v-.92l8-8 .92.92-8 8zM20.71 4.04c.39-.39.39-1.02 0-1.41L18.37.29a.9959.9959 0 0 0-1.41 0L15 2.25 18.75 6l1.96-1.96z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".36",
	  d: "M0 20h24v4H0v-4z"
	})), 'BorderColorTwoTone');
	
	exports.default = _default;

/***/ },
/* 1695 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 21h2v-2H3v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zm4 4h2v-2H7v2zM5 3H3v2h2V3zm4 0H7v2h2V3zm8 0h-2v2h2V3zm-4 4h-2v2h2V7zm0-4h-2v2h2V3zm6 14h2v-2h-2v2zm-8 4h2v-2h-2v2zm-8-8h18v-2H3v2zM19 3v2h2V3h-2zm0 6h2V7h-2v2zm-8 8h2v-2h-2v2zm4 4h2v-2h-2v2zm4 0h2v-2h-2v2z"
	}), 'BorderHorizontal');
	
	exports.default = _default;

/***/ },
/* 1696 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 21h2v-2H3v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zm4 4h2v-2H7v2zM5 3H3v2h2V3zm4 0H7v2h2V3zm8 0h-2v2h2V3zm-4 4h-2v2h2V7zm0-4h-2v2h2V3zm6 14h2v-2h-2v2zm-8 4h2v-2h-2v2zm-8-8h18v-2H3v2zM19 3v2h2V3h-2zm0 6h2V7h-2v2zm-8 8h2v-2h-2v2zm4 4h2v-2h-2v2zm4 0h2v-2h-2v2z"
	}), 'BorderHorizontalOutlined');
	
	exports.default = _default;

/***/ },
/* 1697 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 21h2v-2H3v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zm4 4h2v-2H7v2zM5 3H3v2h2V3zm4 0H7v2h2V3zm8 0h-2v2h2V3zm-4 4h-2v2h2V7zm0-4h-2v2h2V3zm6 14h2v-2h-2v2zm-8 4h2v-2h-2v2zm-7-8h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM19 3v2h2V3h-2zm0 6h2V7h-2v2zm-8 8h2v-2h-2v2zm4 4h2v-2h-2v2zm4 0h2v-2h-2v2z"
	}), 'BorderHorizontalRounded');
	
	exports.default = _default;

/***/ },
/* 1698 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 21h2v-2H3v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zm4 4h2v-2H7v2zM5 3H3v2h2V3zm4 0H7v2h2V3zm8 0h-2v2h2V3zm-4 4h-2v2h2V7zm0-4h-2v2h2V3zm6 14h2v-2h-2v2zm-8 4h2v-2h-2v2zm-8-8h18v-2H3v2zM19 3v2h2V3h-2zm0 6h2V7h-2v2zm-8 8h2v-2h-2v2zm4 4h2v-2h-2v2zm4 0h2v-2h-2v2z"
	}), 'BorderHorizontalSharp');
	
	exports.default = _default;

/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 3h2v2h-2zm8 0h2v2h-2zm0 4h2v2h-2zm-4-4h2v2h-2zM3 19h2v2H3zm0-4h2v2H3zm0-8h2v2H3zm4 12h2v2H7zm4-12h2v2h-2zM7 3h2v2H7zM3 3h2v2H3zm12 16h2v2h-2zm-4 0h2v2h-2zm8-4h2v2h-2zm0 4h2v2h-2zm-8-4h2v2h-2zm-8-4h18v2H3z"
	}), 'BorderHorizontalTwoTone');
	
	exports.default = _default;

/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 21h2v-2H3v2zm4 0h2v-2H7v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zM9 3H7v2h2V3zM5 3H3v2h2V3zm12 0h-2v2h2V3zm2 6h2V7h-2v2zm0-6v2h2V3h-2zm-4 18h2v-2h-2v2zM13 3h-2v8H3v2h8v8h2v-8h8v-2h-8V3zm6 18h2v-2h-2v2zm0-4h2v-2h-2v2z"
	}), 'BorderInner');
	
	exports.default = _default;

/***/ },
/* 1701 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 21h2v-2H3v2zm4 0h2v-2H7v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zM9 3H7v2h2V3zM5 3H3v2h2V3zm12 0h-2v2h2V3zm2 6h2V7h-2v2zm0-6v2h2V3h-2zm-4 18h2v-2h-2v2zM13 3h-2v8H3v2h8v8h2v-8h8v-2h-8V3zm6 18h2v-2h-2v2zm0-4h2v-2h-2v2z"
	}), 'BorderInnerOutlined');
	
	exports.default = _default;

/***/ },
/* 1702 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 21h2v-2H3v2zm4 0h2v-2H7v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zM9 3H7v2h2V3zM5 3H3v2h2V3zm12 0h-2v2h2V3zm2 6h2V7h-2v2zm0-6v2h2V3h-2zm-4 18h2v-2h-2v2zM12 3c-.55 0-1 .45-1 1v7H4c-.55 0-1 .45-1 1s.45 1 1 1h7v7c0 .55.45 1 1 1s1-.45 1-1v-7h7c.55 0 1-.45 1-1s-.45-1-1-1h-7V4c0-.55-.45-1-1-1zm7 18h2v-2h-2v2zm0-4h2v-2h-2v2z"
	}), 'BorderInnerRounded');
	
	exports.default = _default;

/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 21h2v-2H3v2zm4 0h2v-2H7v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zM9 3H7v2h2V3zM5 3H3v2h2V3zm12 0h-2v2h2V3zm2 6h2V7h-2v2zm0-6v2h2V3h-2zm-4 18h2v-2h-2v2zM13 3h-2v8H3v2h8v8h2v-8h8v-2h-8V3zm6 18h2v-2h-2v2zm0-4h2v-2h-2v2z"
	}), 'BorderInnerSharp');
	
	exports.default = _default;

/***/ },
/* 1704 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 15h2v2H3zM3 3h2v2H3zm0 16h2v2H3zm8 2h2v-8h8v-2h-8V3h-2v8H3v2h8zm-4-2h2v2H7zm12-4h2v2h-2zm-4 4h2v2h-2zm4 0h2v2h-2zM3 7h2v2H3zm16 0h2v2h-2zM7 3h2v2H7zm8 0h2v2h-2zm4 0h2v2h-2z"
	}), 'BorderInnerTwoTone');
	
	exports.default = _default;

/***/ },
/* 1705 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z"
	}), 'BorderLeft');
	
	exports.default = _default;

/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z"
	}), 'BorderLeftOutlined');
	
	exports.default = _default;

/***/ },
/* 1707 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-3 8c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1s-1 .45-1 1v16c0 .55.45 1 1 1zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z"
	}), 'BorderLeftRounded');
	
	exports.default = _default;

/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z"
	}), 'BorderLeftSharp');
	
	exports.default = _default;

/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 3h2v2h-2zM3 3h2v18H3zm12 0h2v2h-2zm-4 16h2v2h-2zm0-4h2v2h-2zm4 4h2v2h-2zM11 7h2v2h-2zm0 4h2v2h-2zm8 4h2v2h-2zm0 4h2v2h-2zm0-12h2v2h-2zm0 4h2v2h-2zm0-8h2v2h-2zm-4 8h2v2h-2zm-8 8h2v2H7zm0-8h2v2H7zm0-8h2v2H7z"
	}), 'BorderLeftTwoTone');
	
	exports.default = _default;

/***/ },
/* 1710 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z"
	}), 'BorderOuter');
	
	exports.default = _default;

/***/ },
/* 1711 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z"
	}), 'BorderOuterOutlined');
	
	exports.default = _default;

/***/ },
/* 1712 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2zm15 14H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zm-5-4h-2v2h2v-2zm-4-4H7v2h2v-2z"
	}), 'BorderOuterRounded');
	
	exports.default = _default;

/***/ },
/* 1713 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z"
	}), 'BorderOuterSharp');
	
	exports.default = _default;

/***/ },
/* 1714 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 11h2v2h-2zm0-4h2v2h-2zm10-4H3v18h18V3zm-2 16H5V5h14v14zm-4-8h2v2h-2zm-8 0h2v2H7zm4 4h2v2h-2z"
	}), 'BorderOuterTwoTone');
	
	exports.default = _default;

/***/ },
/* 1715 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z"
	}), 'BorderRight');
	
	exports.default = _default;

/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z"
	}), 'BorderRightOutlined');
	
	exports.default = _default;

/***/ },
/* 1717 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-9v16c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1s-1 .45-1 1zm-4 17h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z"
	}), 'BorderRightRounded');
	
	exports.default = _default;

/***/ },
/* 1718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z"
	}), 'BorderRightSharp');
	
	exports.default = _default;

/***/ },
/* 1719 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 3h2v2H3zm0 16h2v2H3zM15 3h2v2h-2zm0 16h2v2h-2zm0-8h2v2h-2zM3 15h2v2H3zm0-4h2v2H3zm0-4h2v2H3zm8 8h2v2h-2zm-4-4h2v2H7zm0-8h2v2H7zm12 0h2v18h-2zM7 19h2v2H7zm4-16h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2zm0 8h2v2h-2z"
	}), 'BorderRightTwoTone');
	
	exports.default = _default;

/***/ },
/* 1720 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 21h2v-2h-2v2zm4 0h2v-2h-2v2zM7 21h2v-2H7v2zm4 0h2v-2h-2v2zm8-4h2v-2h-2v2zm0-4h2v-2h-2v2zM3 3v18h2V5h16V3H3zm16 6h2V7h-2v2z"
	}), 'BorderStyle');
	
	exports.default = _default;

/***/ },
/* 1721 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 21h2v-2h-2v2zm4 0h2v-2h-2v2zM7 21h2v-2H7v2zm4 0h2v-2h-2v2zm8-4h2v-2h-2v2zm0-4h2v-2h-2v2zM3 3v18h2V5h16V3H3zm16 6h2V7h-2v2z"
	}), 'BorderStyleOutlined');
	
	exports.default = _default;

/***/ },
/* 1722 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 21h2v-2h-2v2zm4 0h2v-2h-2v2zM7 21h2v-2H7v2zm4 0h2v-2h-2v2zm8-4h2v-2h-2v2zm0-4h2v-2h-2v2zM3 5v15c0 .55.45 1 1 1s1-.45 1-1V6c0-.55.45-1 1-1h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.1 0-2 .9-2 2zm16 4h2V7h-2v2z"
	}), 'BorderStyleRounded');
	
	exports.default = _default;

/***/ },
/* 1723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 21h2v-2h-2v2zm4 0h2v-2h-2v2zM7 21h2v-2H7v2zm4 0h2v-2h-2v2zm8-4h2v-2h-2v2zm0-4h2v-2h-2v2zM3 3v18h2V5h16V3H3zm16 6h2V7h-2v2z"
	}), 'BorderStyleSharp');
	
	exports.default = _default;

/***/ },
/* 1724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 19h2v2h-2zm0-8h2v2h-2zm0 4h2v2h-2zm-4 4h2v2h-2zM3 21h2V5h16V3H3zM19 7h2v2h-2zm-8 12h2v2h-2zm-4 0h2v2H7z"
	}), 'BorderStyleTwoTone');
	
	exports.default = _default;

/***/ },
/* 1725 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z"
	}), 'BorderTop');
	
	exports.default = _default;

/***/ },
/* 1726 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z"
	}), 'BorderTopOutlined');
	
	exports.default = _default;

/***/ },
/* 1727 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 4c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1zm16 13h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z"
	}), 'BorderTopRounded');
	
	exports.default = _default;

/***/ },
/* 1728 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z"
	}), 'BorderTopSharp');
	
	exports.default = _default;

/***/ },
/* 1729 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 19h2v2h-2zM3 19h2v2H3zm8 0h2v2h-2zm-8-8h2v2H3zm0 4h2v2H3zm4 4h2v2H7zm4-12h2v2h-2zm0 4h2v2h-2zM3 7h2v2H3zm0-4h18v2H3zm8 12h2v2h-2zm4 4h2v2h-2zm-8-8h2v2H7zm8 0h2v2h-2zm4 4h2v2h-2zm0-4h2v2h-2zm0-4h2v2h-2z"
	}), 'BorderTopTwoTone');
	
	exports.default = _default;

/***/ },
/* 1730 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 9h2V7H3v2zm0-4h2V3H3v2zm4 16h2v-2H7v2zm0-8h2v-2H7v2zm-4 0h2v-2H3v2zm0 8h2v-2H3v2zm0-4h2v-2H3v2zM7 5h2V3H7v2zm12 12h2v-2h-2v2zm-8 4h2V3h-2v18zm8 0h2v-2h-2v2zm0-8h2v-2h-2v2zm0-10v2h2V3h-2zm0 6h2V7h-2v2zm-4-4h2V3h-2v2zm0 16h2v-2h-2v2zm0-8h2v-2h-2v2z"
	}), 'BorderVertical');
	
	exports.default = _default;

/***/ },
/* 1731 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 9h2V7H3v2zm0-4h2V3H3v2zm4 16h2v-2H7v2zm0-8h2v-2H7v2zm-4 0h2v-2H3v2zm0 8h2v-2H3v2zm0-4h2v-2H3v2zM7 5h2V3H7v2zm12 12h2v-2h-2v2zm-8 4h2V3h-2v18zm8 0h2v-2h-2v2zm0-8h2v-2h-2v2zm0-10v2h2V3h-2zm0 6h2V7h-2v2zm-4-4h2V3h-2v2zm0 16h2v-2h-2v2zm0-8h2v-2h-2v2z"
	}), 'BorderVerticalOutlined');
	
	exports.default = _default;

/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 9h2V7H3v2zm0-4h2V3H3v2zm4 16h2v-2H7v2zm0-8h2v-2H7v2zm-4 0h2v-2H3v2zm0 8h2v-2H3v2zm0-4h2v-2H3v2zM7 5h2V3H7v2zm12 12h2v-2h-2v2zm-7 4c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1s-1 .45-1 1v16c0 .55.45 1 1 1zm7 0h2v-2h-2v2zm0-8h2v-2h-2v2zm0-10v2h2V3h-2zm0 6h2V7h-2v2zm-4-4h2V3h-2v2zm0 16h2v-2h-2v2zm0-8h2v-2h-2v2z"
	}), 'BorderVerticalRounded');
	
	exports.default = _default;

/***/ },
/* 1733 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 9h2V7H3v2zm0-4h2V3H3v2zm4 16h2v-2H7v2zm0-8h2v-2H7v2zm-4 0h2v-2H3v2zm0 8h2v-2H3v2zm0-4h2v-2H3v2zM7 5h2V3H7v2zm12 12h2v-2h-2v2zm-8 4h2V3h-2v18zm8 0h2v-2h-2v2zm0-8h2v-2h-2v2zm0-10v2h2V3h-2zm0 6h2V7h-2v2zm-4-4h2V3h-2v2zm0 16h2v-2h-2v2zm0-8h2v-2h-2v2z"
	}), 'BorderVerticalSharp');
	
	exports.default = _default;

/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 3h2v2H7zm0 8h2v2H7zm0 8h2v2H7zm-4 0h2v2H3zM3 3h2v2H3zm0 8h2v2H3zm16-8h2v2h-2zM3 7h2v2H3zm8-4h2v18h-2zM3 15h2v2H3zm12-4h2v2h-2zm4 4h2v2h-2zm0-4h2v2h-2zm0-4h2v2h-2zm0 12h2v2h-2zm-4 0h2v2h-2zm0-16h2v2h-2z"
	}), 'BorderVerticalTwoTone');
	
	exports.default = _default;

/***/ },
/* 1735 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-9v-6h9v6z"
	}), 'BrandingWatermark');
	
	exports.default = _default;

/***/ },
/* 1736 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zm-10-7h9v6h-9z"
	}), 'BrandingWatermarkOutlined');
	
	exports.default = _default;

/***/ },
/* 1737 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16h-7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h7c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1z"
	}), 'BrandingWatermarkRounded');
	
	exports.default = _default;

/***/ },
/* 1738 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 3H1v18h22V3zm-2 16h-9v-6h9v6z"
	}), 'BrandingWatermarkSharp');
	
	exports.default = _default;

/***/ },
/* 1739 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 19h18V5H3v14zm8-7h9v6h-9v-6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zm-10-7h9v6h-9z"
	})), 'BrandingWatermarkTwoTone');
	
	exports.default = _default;

/***/ },
/* 1740 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "10"
	}), 'Brightness1');
	
	exports.default = _default;

/***/ },
/* 1741 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
	}), 'Brightness1Outlined');
	
	exports.default = _default;

/***/ },
/* 1742 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "10"
	}), 'Brightness1Rounded');
	
	exports.default = _default;

/***/ },
/* 1743 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "10"
	}), 'Brightness1Sharp');
	
	exports.default = _default;

/***/ },
/* 1744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 20c4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8 3.59 8 8 8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zm0-18c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8z"
	})), 'Brightness1TwoTone');
	
	exports.default = _default;

/***/ },
/* 1745 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z"
	}), 'Brightness2');
	
	exports.default = _default;

/***/ },
/* 1746 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 4c4.41 0 8 3.59 8 8s-3.59 8-8 8c-.34 0-.68-.02-1.01-.07C10.9 17.77 12 14.95 12 12s-1.1-5.77-3.01-7.93C9.32 4.02 9.66 4 10 4m0-2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z"
	}), 'Brightness2Outlined');
	
	exports.default = _default;

/***/ },
/* 1747 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.43 2.3c-2.38-.59-4.68-.27-6.63.64-.35.16-.41.64-.1.86C8.3 5.6 10 8.6 10 12c0 3.4-1.7 6.4-4.3 8.2-.32.22-.26.7.09.86 1.28.6 2.71.94 4.21.94 6.05 0 10.85-5.38 9.87-11.6-.61-3.92-3.59-7.16-7.44-8.1z"
	}), 'Brightness2Rounded');
	
	exports.default = _default;

/***/ },
/* 1748 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z"
	}), 'Brightness2Sharp');
	
	exports.default = _default;

/***/ },
/* 1749 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18 12c0-4.41-3.59-8-8-8-.34 0-.68.02-1.01.07C10.9 6.23 12 9.05 12 12c0 2.95-1.1 5.77-3.01 7.93.33.05.67.07 1.01.07 4.41 0 8-3.59 8-8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 20.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65zM12 12c0-2.95-1.1-5.77-3.01-7.93C9.32 4.02 9.66 4 10 4c4.41 0 8 3.59 8 8s-3.59 8-8 8c-.34 0-.68-.02-1.01-.07C10.9 17.77 12 14.95 12 12z"
	})), 'Brightness2TwoTone');
	
	exports.default = _default;

/***/ },
/* 1750 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z"
	}), 'Brightness3');
	
	exports.default = _default;

/***/ },
/* 1751 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.7 4.91C15.25 6.24 17 8.92 17 12s-1.75 5.76-4.3 7.09c1.46-2 2.3-4.46 2.3-7.09s-.84-5.09-2.3-7.09M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54s-2.94 8.27-7 9.54c.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z"
	}), 'Brightness3Outlined');
	
	exports.default = _default;

/***/ },
/* 1752 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.87 10.37c-.75-4.76-5-8.35-9.82-8.37-.49 0-.97.03-1.44.1-.5.07-.6.73-.14.96C10.75 4.69 13 8.08 13 12s-2.25 7.31-5.53 8.95c-.45.23-.36.89.14.96.47.06.95.09 1.44.09 4.82-.02 9.07-3.61 9.82-8.37.09-.55.11-1.09.11-1.63 0-.54-.02-1.08-.11-1.63z"
	}), 'Brightness3Rounded');
	
	exports.default = _default;

/***/ },
/* 1753 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54s-2.94 8.27-7 9.54c.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z"
	}), 'Brightness3Sharp');
	
	exports.default = _default;

/***/ },
/* 1754 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12.7 4.91c1.46 2 2.3 4.46 2.3 7.09s-.84 5.09-2.3 7.09C15.25 17.76 17 15.08 17 12s-1.75-5.76-4.3-7.09z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2zm3.7 17.09c1.46-2 2.3-4.46 2.3-7.09s-.84-5.09-2.3-7.09C15.25 6.24 17 8.92 17 12s-1.75 5.76-4.3 7.09z"
	})), 'Brightness3TwoTone');
	
	exports.default = _default;

/***/ },
/* 1755 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
	}), 'Brightness4');
	
	exports.default = _default;

/***/ },
/* 1756 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12.29 7c-.74 0-1.45.17-2.08.46 1.72.79 2.92 2.53 2.92 4.54s-1.2 3.75-2.92 4.54c.63.29 1.34.46 2.08.46 2.76 0 5-2.24 5-5s-2.24-5-5-5z"
	}), 'Brightness4Outlined');
	
	exports.default = _default;

/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22.6 11.29L20 8.69V5c0-.55-.45-1-1-1h-3.69l-2.6-2.6a.9959.9959 0 00-1.41 0L8.69 4H5c-.55 0-1 .45-1 1v3.69l-2.6 2.6c-.39.39-.39 1.02 0 1.41L4 15.3V19c0 .55.45 1 1 1h3.69l2.6 2.6c.39.39 1.02.39 1.41 0l2.6-2.6H19c.55 0 1-.45 1-1v-3.69l2.6-2.6c.39-.39.39-1.03 0-1.42zm-4.68 1.69c-.34 2.12-1.85 3.94-3.88 4.66-1.21.43-2.41.45-3.5.18-.41-.1-.48-.65-.13-.9C11.98 15.84 13 14.04 13 12s-1.02-3.84-2.58-4.92c-.35-.24-.29-.79.13-.9 1.09-.27 2.29-.25 3.5.18 2.02.72 3.54 2.54 3.88 4.66.05.33.07.66.07.98-.01.32-.03.65-.08.98z"
	}), 'Brightness4Rounded');
	
	exports.default = _default;

/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
	}), 'Brightness4Sharp');
	
	exports.default = _default;

/***/ },
/* 1759 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18 9.52V6h-3.52L12 3.52 9.52 6H6v3.52L3.52 12 6 14.48V18h3.52L12 20.48 14.48 18H18v-3.52L20.48 12 18 9.52zM12.29 17c-.74 0-1.45-.17-2.08-.46 1.72-.79 2.92-2.52 2.92-4.54s-1.2-3.75-2.92-4.54c.63-.29 1.34-.46 2.08-.46 2.76 0 5 2.24 5 5s-2.24 5-5 5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12.29 7c-.74 0-1.45.17-2.08.46 1.72.79 2.92 2.53 2.92 4.54s-1.2 3.75-2.92 4.54c.63.29 1.34.46 2.08.46 2.76 0 5-2.24 5-5s-2.24-5-5-5z"
	})), 'Brightness4TwoTone');
	
	exports.default = _default;

/***/ },
/* 1760 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
	}), 'Brightness5');
	
	exports.default = _default;

/***/ },
/* 1761 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6.5c-3.03 0-5.5 2.47-5.5 5.5s2.47 5.5 5.5 5.5 5.5-2.47 5.5-5.5-2.47-5.5-5.5-5.5zm0 9c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
	}), 'Brightness5Outlined');
	
	exports.default = _default;

/***/ },
/* 1762 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.31l2.6-2.6c.39-.39.39-1.02 0-1.41L20 8.69V5c0-.55-.45-1-1-1h-3.69l-2.6-2.6a.9959.9959 0 00-1.41 0L8.69 4H5c-.55 0-1 .45-1 1v3.69l-2.6 2.6c-.39.39-.39 1.02 0 1.41L4 15.3V19c0 .55.45 1 1 1h3.69l2.6 2.6c.39.39 1.02.39 1.41 0l2.6-2.6H19c.55 0 1-.45 1-1v-3.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
	}), 'Brightness5Rounded');
	
	exports.default = _default;

/***/ },
/* 1763 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
	}), 'Brightness5Sharp');
	
	exports.default = _default;

/***/ },
/* 1764 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18 9.52V6h-3.52L12 3.52 9.52 6H6v3.52L3.52 12 6 14.48V18h3.52L12 20.48 14.48 18H18v-3.52L20.48 12 18 9.52zm-6 7.98c-3.03 0-5.5-2.47-5.5-5.5S8.97 6.5 12 6.5s5.5 2.47 5.5 5.5-2.47 5.5-5.5 5.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6.5c-3.03 0-5.5 2.47-5.5 5.5s2.47 5.5 5.5 5.5 5.5-2.47 5.5-5.5-2.47-5.5-5.5-5.5zm0 9c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
	})), 'Brightness5TwoTone');
	
	exports.default = _default;

/***/ },
/* 1765 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
	}), 'Brightness6');
	
	exports.default = _default;

/***/ },
/* 1766 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6.5v11c3.03 0 5.5-2.47 5.5-5.5S15.03 6.5 12 6.5z"
	}), 'Brightness6Outlined');
	
	exports.default = _default;

/***/ },
/* 1767 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.31l2.6-2.6c.39-.39.39-1.02 0-1.41L20 8.69V5c0-.55-.45-1-1-1h-3.69l-2.6-2.6a.9959.9959 0 00-1.41 0L8.69 4H5c-.55 0-1 .45-1 1v3.69l-2.6 2.6c-.39.39-.39 1.02 0 1.41L4 15.3V19c0 .55.45 1 1 1h3.69l2.6 2.6c.39.39 1.02.39 1.41 0l2.6-2.6H19c.55 0 1-.45 1-1v-3.69zm-8 1.59V7.1c0-.61.55-1.11 1.15-.99C15.91 6.65 18 9.08 18 12s-2.09 5.35-4.85 5.89c-.6.12-1.15-.38-1.15-.99z"
	}), 'Brightness6Rounded');
	
	exports.default = _default;

/***/ },
/* 1768 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
	}), 'Brightness6Sharp');
	
	exports.default = _default;

/***/ },
/* 1769 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18 9.52V6h-3.52L12 3.52 9.52 6H6v3.52L3.52 12 6 14.48V18h3.52L12 20.48 14.48 18H18v-3.52L20.48 12 18 9.52zm-6 7.98v-11c3.03 0 5.5 2.47 5.5 5.5s-2.47 5.5-5.5 5.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6.5v11c3.03 0 5.5-2.47 5.5-5.5S15.03 6.5 12 6.5z"
	})), 'Brightness6TwoTone');
	
	exports.default = _default;

/***/ },
/* 1770 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
	}), 'Brightness7');
	
	exports.default = _default;

/***/ },
/* 1771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6.5c-3.03 0-5.5 2.47-5.5 5.5s2.47 5.5 5.5 5.5 5.5-2.47 5.5-5.5-2.47-5.5-5.5-5.5zm0 9c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "2"
	})), 'Brightness7Outlined');
	
	exports.default = _default;

/***/ },
/* 1772 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8.69V5c0-.55-.45-1-1-1h-3.69l-2.6-2.6a.9959.9959 0 00-1.41 0L8.69 4H5c-.55 0-1 .45-1 1v3.69l-2.6 2.6c-.39.39-.39 1.02 0 1.41L4 15.3V19c0 .55.45 1 1 1h3.69l2.6 2.6c.39.39 1.02.39 1.41 0l2.6-2.6H19c.55 0 1-.45 1-1v-3.69l2.6-2.6c.39-.39.39-1.02 0-1.41L20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
	}), 'Brightness7Rounded');
	
	exports.default = _default;

/***/ },
/* 1773 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
	}), 'Brightness7Sharp');
	
	exports.default = _default;

/***/ },
/* 1774 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18 9.52V6h-3.52L12 3.52 9.52 6H6v3.52L3.52 12 6 14.48V18h3.52L12 20.48 14.48 18H18v-3.52L20.48 12 18 9.52zm-6 7.98c-3.03 0-5.5-2.47-5.5-5.5S8.97 6.5 12 6.5s5.5 2.47 5.5 5.5-2.47 5.5-5.5 5.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6.5c-3.03 0-5.5 2.47-5.5 5.5s2.47 5.5 5.5 5.5 5.5-2.47 5.5-5.5-2.47-5.5-5.5-5.5zm0 9c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "2"
	})), 'Brightness7TwoTone');
	
	exports.default = _default;

/***/ },
/* 1775 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.85 12.65h2.3L12 9l-1.15 3.65zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9h-1.9z"
	}), 'BrightnessAuto');
	
	exports.default = _default;

/***/ },
/* 1776 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 7l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L13 7h-2zm-.15 5.65L12 9l1.15 3.65h-2.3zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48z"
	}), 'BrightnessAutoOutlined');
	
	exports.default = _default;

/***/ },
/* 1777 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.85 12.65h2.3L12 9l-1.15 3.65zM20 8.69V6c0-1.1-.9-2-2-2h-2.69l-1.9-1.9c-.78-.78-2.05-.78-2.83 0L8.69 4H6c-1.1 0-2 .9-2 2v2.69l-1.9 1.9c-.78.78-.78 2.05 0 2.83l1.9 1.9V18c0 1.1.9 2 2 2h2.69l1.9 1.9c.78.78 2.05.78 2.83 0l1.9-1.9H18c1.1 0 2-.9 2-2v-2.69l1.9-1.9c.78-.78.78-2.05 0-2.83L20 8.69zm-5.91 6.71L13.6 14h-3.2l-.49 1.4c-.13.36-.46.6-.84.6-.62 0-1.05-.61-.84-1.19l2.44-6.86c.2-.57.73-.95 1.33-.95.6 0 1.13.38 1.34.94l2.44 6.86c.21.58-.22 1.19-.84 1.19-.39.01-.72-.23-.85-.59z"
	}), 'BrightnessAutoRounded');
	
	exports.default = _default;

/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.85 12.65h2.3L12 9l-1.15 3.65zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9h-1.9z"
	}), 'BrightnessAutoSharp');
	
	exports.default = _default;

/***/ },
/* 1779 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M18 9.52V6h-3.52L12 3.52 9.52 6H6v3.52L3.52 12 6 14.48V18h3.52L12 20.48 14.48 18H18v-3.52L20.48 12 18 9.52zM14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9h-1.9zm-3.45-3.35h2.3L12 9z"
	}), _react.default.createElement("path", {
	  d: "M11 7l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L13 7h-2zm-.15 5.65L12 9l1.15 3.65h-2.3zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48z"
	})), 'BrightnessAutoTwoTone');
	
	exports.default = _default;

/***/ },
/* 1780 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
	}), 'BrightnessHigh');
	
	exports.default = _default;

/***/ },
/* 1781 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "2.5"
	})), 'BrightnessHighOutlined');
	
	exports.default = _default;

/***/ },
/* 1782 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8.69V6c0-1.1-.9-2-2-2h-2.69l-1.9-1.9c-.78-.78-2.05-.78-2.83 0L8.69 4H6c-1.1 0-2 .9-2 2v2.69l-1.9 1.9c-.78.78-.78 2.05 0 2.83l1.9 1.9V18c0 1.1.9 2 2 2h2.69l1.9 1.9c.78.78 2.05.78 2.83 0l1.9-1.9H18c1.1 0 2-.9 2-2v-2.69l1.9-1.9c.78-.78.78-2.05 0-2.83L20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
	}), 'BrightnessHighRounded');
	
	exports.default = _default;

/***/ },
/* 1783 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
	}), 'BrightnessHighSharp');
	
	exports.default = _default;

/***/ },
/* 1784 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M18 9.52V6h-3.52L12 3.52 9.52 6H6v3.52L3.52 12 6 14.48V18h3.52L12 20.48 14.48 18H18v-3.52L20.48 12 18 9.52zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
	}), _react.default.createElement("path", {
	  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "2.5"
	})), 'BrightnessHighTwoTone');
	
	exports.default = _default;

/***/ },
/* 1785 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
	}), 'BrightnessLow');
	
	exports.default = _default;

/***/ },
/* 1786 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
	}), 'BrightnessLowOutlined');
	
	exports.default = _default;

/***/ },
/* 1787 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.31l1.9-1.9c.78-.78.78-2.05 0-2.83L20 8.69V6c0-1.1-.9-2-2-2h-2.69l-1.9-1.9c-.78-.78-2.05-.78-2.83 0L8.69 4H6c-1.1 0-2 .9-2 2v2.69l-1.9 1.9c-.78.78-.78 2.05 0 2.83l1.9 1.9V18c0 1.1.9 2 2 2h2.69l1.9 1.9c.78.78 2.05.78 2.83 0l1.9-1.9H18c1.1 0 2-.9 2-2v-2.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
	}), 'BrightnessLowRounded');
	
	exports.default = _default;

/***/ },
/* 1788 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
	}), 'BrightnessLowSharp');
	
	exports.default = _default;

/***/ },
/* 1789 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M18 9.52V6h-3.52L12 3.52 9.52 6H6v3.52L3.52 12 6 14.48V18h3.52L12 20.48 14.48 18H18v-3.52L20.48 12 18 9.52zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
	}), _react.default.createElement("path", {
	  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
	})), 'BrightnessLowTwoTone');
	
	exports.default = _default;

/***/ },
/* 1790 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
	}), 'BrightnessMedium');
	
	exports.default = _default;

/***/ },
/* 1791 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6v12c3.31 0 6-2.69 6-6s-2.69-6-6-6z"
	}), 'BrightnessMediumOutlined');
	
	exports.default = _default;

/***/ },
/* 1792 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.31l1.9-1.9c.78-.78.78-2.05 0-2.83L20 8.69V6c0-1.1-.9-2-2-2h-2.69l-1.9-1.9c-.78-.78-2.05-.78-2.83 0L8.69 4H6c-1.1 0-2 .9-2 2v2.69l-1.9 1.9c-.78.78-.78 2.05 0 2.83l1.9 1.9V18c0 1.1.9 2 2 2h2.69l1.9 1.9c.78.78 2.05.78 2.83 0l1.9-1.9H18c1.1 0 2-.9 2-2v-2.69zm-8 1.59V7.1c0-.61.55-1.11 1.15-.99C15.91 6.65 18 9.08 18 12s-2.09 5.35-4.85 5.89c-.6.12-1.15-.38-1.15-.99z"
	}), 'BrightnessMediumRounded');
	
	exports.default = _default;

/***/ },
/* 1793 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
	}), 'BrightnessMediumSharp');
	
	exports.default = _default;

/***/ },
/* 1794 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M18 9.52V6h-3.52L12 3.52 9.52 6H6v3.52L3.52 12 6 14.48V18h3.52L12 20.48 14.48 18H18v-3.52L20.48 12 18 9.52zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
	}), _react.default.createElement("path", {
	  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6v12c3.31 0 6-2.69 6-6s-2.69-6-6-6z"
	})), 'BrightnessMediumTwoTone');
	
	exports.default = _default;

/***/ },
/* 1795 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z"
	}), 'BrokenImage');
	
	exports.default = _default;

/***/ },
/* 1796 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5v-4.58l.99.99 4-4 4 4 4-3.99L19 12.43V19zm0-9.41l-1.01-1.01-4 4.01-4-4-4 4-.99-1V5h14v4.59z"
	}), 'BrokenImageOutlined');
	
	exports.default = _default;

/***/ },
/* 1797 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 5v6.59l-2.29-2.3c-.39-.39-1.03-.39-1.42 0L14 12.59 10.71 9.3a.9959.9959 0 00-1.41 0L6 12.59 3 9.58V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l2.29 2.29c.39.39 1.02.39 1.41 0l3.3-3.3 3.29 3.29c.39.39 1.02.39 1.41 0l3.3-3.28z"
	}), 'BrokenImageRounded');
	
	exports.default = _default;

/***/ },
/* 1798 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3v8.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V3h18zm-3 8.42l3 3.01V21H3v-8.58l3 2.99 4-4 4 4 4-3.99z"
	}), 'BrokenImageSharp');
	
	exports.default = _default;

/***/ },
/* 1799 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M13.99 15.41l-4-4-4 4-.99-.99V19h14v-6.57l-1.01-1.01zM5 11.59l.99 1 4-4 4 4 4-4.01L19 9.59V5H5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5v-4.58l.99.99 4-4 4 4 4-3.99L19 12.43V19zm0-9.41l-1.01-1.01-4 4.01-4-4-4 4-.99-1V5h14v4.59z"
	})), 'BrokenImageTwoTone');
	
	exports.default = _default;

/***/ },
/* 1800 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34a.9959.9959 0 00-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41z"
	}), 'Brush');
	
	exports.default = _default;

/***/ },
/* 1801 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 16c.55 0 1 .45 1 1 0 1.1-.9 2-2 2-.17 0-.33-.02-.5-.05.31-.55.5-1.21.5-1.95 0-.55.45-1 1-1M18.67 3c-.26 0-.51.1-.71.29L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41l-1.34-1.34c-.2-.2-.45-.29-.7-.29zM7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3z"
	}), 'BrushOutlined');
	
	exports.default = _default;

/***/ },
/* 1802 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34a.9959.9959 0 00-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41z"
	}), 'BrushRounded');
	
	exports.default = _default;

/***/ },
/* 1803 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm14.41-8.66l-2.75-2.75L9 12.25 11.75 15l9.66-9.66z"
	}), 'BrushSharp');
	
	exports.default = _default;

/***/ },
/* 1804 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 17c0-.55-.45-1-1-1s-1 .45-1 1c0 .74-.19 1.4-.5 1.95.17.03.33.05.5.05 1.1 0 2-.9 2-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41l-1.34-1.34c-.2-.2-.45-.29-.7-.29s-.51.1-.71.29L9 12.25 11.75 15zM6 21c2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3s-3 1.34-3 3c0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2zm0-4c0-.55.45-1 1-1s1 .45 1 1c0 1.1-.9 2-2 2-.17 0-.33-.02-.5-.05.31-.55.5-1.21.5-1.95z"
	})), 'BrushTwoTone');
	
	exports.default = _default;

/***/ },
/* 1805 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "7.2",
	  cy: "14.4",
	  r: "3.2"
	}), _react.default.createElement("circle", {
	  cx: "14.8",
	  cy: "18",
	  r: "2"
	}), _react.default.createElement("circle", {
	  cx: "15.2",
	  cy: "8.8",
	  r: "4.8"
	})), 'BubbleChart');
	
	exports.default = _default;

/***/ },
/* 1806 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm8.01-1c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM16.5 3C13.47 3 11 5.47 11 8.5s2.47 5.5 5.5 5.5S22 11.53 22 8.5 19.53 3 16.5 3zm0 9c-1.93 0-3.5-1.57-3.5-3.5S14.57 5 16.5 5 20 6.57 20 8.5 18.43 12 16.5 12z"
	}), 'BubbleChartOutlined');
	
	exports.default = _default;

/***/ },
/* 1807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "7.2",
	  cy: "14.4",
	  r: "3.2"
	}), _react.default.createElement("circle", {
	  cx: "14.8",
	  cy: "18",
	  r: "2"
	}), _react.default.createElement("circle", {
	  cx: "15.2",
	  cy: "8.8",
	  r: "4.8"
	})), 'BubbleChartRounded');
	
	exports.default = _default;

/***/ },
/* 1808 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "7.2",
	  cy: "14.4",
	  r: "3.2"
	}), _react.default.createElement("circle", {
	  cx: "14.8",
	  cy: "18",
	  r: "2"
	}), _react.default.createElement("circle", {
	  cx: "15.2",
	  cy: "8.8",
	  r: "4.8"
	})), 'BubbleChartSharp');
	
	exports.default = _default;

/***/ },
/* 1809 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16.5 12c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "15.01",
	  cy: "18",
	  r: "1",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "7",
	  cy: "14",
	  r: "2",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M7 18c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm11.01 6c0-1.65-1.35-3-3-3s-3 1.35-3 3 1.35 3 3 3 3-1.35 3-3zm-4 0c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm2.49-4c3.03 0 5.5-2.47 5.5-5.5S19.53 3 16.5 3 11 5.47 11 8.5s2.47 5.5 5.5 5.5zm0-9C18.43 5 20 6.57 20 8.5S18.43 12 16.5 12 13 10.43 13 8.5 14.57 5 16.5 5z"
	})), 'BubbleChartTwoTone');
	
	exports.default = _default;

/***/ },
/* 1810 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z"
	}), 'BugReport');
	
	exports.default = _default;

/***/ },
/* 1811 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5s-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-4 4v3c0 .22-.03.47-.07.7l-.1.65-.37.65c-.72 1.24-2.04 2-3.46 2s-2.74-.77-3.46-2l-.37-.64-.1-.65C8.03 15.48 8 15.23 8 15v-4c0-.23.03-.48.07-.7l.1-.65.37-.65c.3-.52.72-.97 1.21-1.31l.57-.39.74-.18c.31-.08.63-.12.94-.12.32 0 .63.04.95.12l.68.16.61.42c.5.34.91.78 1.21 1.31l.38.65.1.65c.04.22.07.47.07.69v1zm-6 2h4v2h-4zm0-4h4v2h-4z"
	}), 'BugReportOutlined');
	
	exports.default = _default;

/***/ },
/* 1812 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 8h-1.81c-.45-.78-1.07-1.45-1.82-1.96l.93-.93c.39-.39.39-1.02 0-1.41a.9959.9959 0 00-1.41 0l-1.47 1.47C12.96 5.06 12.49 5 12 5s-.96.06-1.41.17L9.11 3.7a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l.92.93C7.88 6.55 7.26 7.22 6.81 8H5c-.55 0-1 .45-1 1s.45 1 1 1h1.09c-.05.33-.09.66-.09 1v1H5c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .34.04.67.09 1H5c-.55 0-1 .45-1 1s.45 1 1 1h1.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H19c.55 0 1-.45 1-1s-.45-1-1-1h-1.09c.05-.33.09-.66.09-1v-1h1c.55 0 1-.45 1-1s-.45-1-1-1h-1v-1c0-.34-.04-.67-.09-1H19c.55 0 1-.45 1-1s-.45-1-1-1zm-6 8h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1zm0-4h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'BugReportRounded');
	
	exports.default = _default;

/***/ },
/* 1813 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5s-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z"
	}), 'BugReportSharp');
	
	exports.default = _default;

/***/ },
/* 1814 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.83 9.65L15.46 9c-.3-.53-.71-.96-1.21-1.31l-.61-.42-.68-.16C12.63 7.04 12.32 7 12 7c-.31 0-.63.04-.94.11l-.74.18-.57.4c-.49.34-.91.79-1.21 1.31l-.37.65-.1.65c-.04.23-.07.48-.07.7v4c0 .22.03.47.07.7l.1.65.37.65c.72 1.24 2.04 2 3.46 2s2.74-.77 3.46-2l.37-.64.1-.65c.04-.24.07-.49.07-.71v-4c0-.22-.03-.47-.07-.7l-.1-.65zM14 16h-4v-2h4v2zm0-4h-4v-2h4v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5s-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-4 4v3c0 .22-.03.47-.07.7l-.1.65-.37.65c-.72 1.24-2.04 2-3.46 2s-2.74-.77-3.46-2l-.37-.64-.1-.65C8.03 15.47 8 15.22 8 15v-4c0-.22.03-.47.07-.7l.1-.65.37-.65c.3-.52.72-.97 1.21-1.31l.57-.39.74-.18c.31-.08.63-.12.94-.12.32 0 .63.04.95.12l.68.16.61.42c.5.34.91.78 1.21 1.31l.38.65.1.65c.04.22.07.47.07.69v1zm-6 2h4v2h-4zm0-4h4v2h-4z"
	})), 'BugReportTwoTone');
	
	exports.default = _default;

/***/ },
/* 1815 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"
	}), 'Build');
	
	exports.default = _default;

/***/ },
/* 1816 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22.61 18.99l-9.08-9.08c.93-2.34.45-5.1-1.44-7C9.79.61 6.21.4 3.66 2.26L7.5 6.11 6.08 7.52 2.25 3.69C.39 6.23.6 9.82 2.9 12.11c1.86 1.86 4.57 2.35 6.89 1.48l9.11 9.11c.39.39 1.02.39 1.41 0l2.3-2.3c.4-.38.4-1.01 0-1.41zm-3 1.6l-9.46-9.46c-.61.45-1.29.72-2 .82-1.36.2-2.79-.21-3.83-1.25C3.37 9.76 2.93 8.5 3 7.26l3.09 3.09 4.24-4.24-3.09-3.09c1.24-.07 2.49.37 3.44 1.31 1.08 1.08 1.49 2.57 1.24 3.96-.12.71-.42 1.37-.88 1.96l9.45 9.45-.88.89z"
	}), 'BuildOutlined');
	
	exports.default = _default;

/***/ },
/* 1817 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.09 2.91C10.08.9 7.07.49 4.65 1.67L8.28 5.3c.39.39.39 1.02 0 1.41L6.69 8.3c-.39.4-1.02.4-1.41 0L1.65 4.67C.48 7.1.89 10.09 2.9 12.1c1.86 1.86 4.58 2.35 6.89 1.48l7.96 7.96c1.03 1.03 2.69 1.03 3.71 0 1.03-1.03 1.03-2.69 0-3.71L13.54 9.9c.92-2.34.44-5.1-1.45-6.99z"
	}), 'BuildRounded');
	
	exports.default = _default;

/***/ },
/* 1818 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.09 2.91C10.08.9 7.07.49 4.65 1.67l4.34 4.34-3 3-4.34-4.34C.48 7.1.89 10.09 2.9 12.1c1.86 1.86 4.58 2.35 6.89 1.48l9.82 9.82 3.71-3.71-9.78-9.79c.92-2.34.44-5.1-1.45-6.99z"
	}), 'BuildSharp');
	
	exports.default = _default;

/***/ },
/* 1819 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.92 8.28c.24-1.4-.16-2.89-1.24-3.96-.94-.95-2.2-1.39-3.44-1.32l3.09 3.09-4.24 4.24L3 7.24c-.07 1.24.37 2.49 1.31 3.44 1.04 1.04 2.47 1.45 3.83 1.25.71-.1 1.4-.38 2-.82l9.46 9.46.88-.88-9.45-9.45c.47-.6.77-1.26.89-1.96z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M22.61 18.97L13.54 9.9c.93-2.34.45-5.1-1.44-7C9.8.6 6.22.39 3.67 2.25L7.5 6.08 6.08 7.5 2.25 3.67C.39 6.21.6 9.79 2.9 12.09c1.86 1.86 4.57 2.35 6.89 1.48l9.11 9.11c.39.39 1.02.39 1.41 0l2.3-2.3c.4-.38.4-1.02 0-1.41zm-3 1.6l-9.46-9.46c-.61.45-1.29.72-2 .82-1.36.2-2.79-.21-3.83-1.25-.95-.94-1.39-2.2-1.32-3.44l3.09 3.09 4.24-4.24L7.24 3c1.24-.07 2.49.37 3.44 1.31 1.08 1.08 1.49 2.57 1.24 3.96-.12.7-.42 1.36-.88 1.95l9.45 9.45-.88.9z"
	})), 'BuildTwoTone');
	
	exports.default = _default;

/***/ },
/* 1820 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 5h2v14H1zm4 0h2v14H5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM11 17l2.5-3.15L15.29 16l2.5-3.22L21 17H11z"
	}), 'BurstMode');
	
	exports.default = _default;

/***/ },
/* 1821 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 5h2v14H1zm4 0h2v14H5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-1 12H11V7h10v10zm-3.57-4.38l-2 2.57L14 13.47l-2 2.52h8z"
	}), 'BurstModeOutlined');
	
	exports.default = _default;

/***/ },
/* 1822 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 5c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1s-1-.45-1-1V6c0-.55.45-1 1-1zm4 0c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1s-1-.45-1-1V6c0-.55.45-1 1-1zm16 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM11.64 16.19l1.47-1.86c.2-.25.57-.25.78-.01l1.4 1.68 2.1-2.71c.2-.26.59-.26.79 0l2.21 2.9c.25.33.02.8-.4.8h-7.96c-.41.01-.65-.47-.39-.8z"
	}), 'BurstModeRounded');
	
	exports.default = _default;

/***/ },
/* 1823 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 5h2v14H1V5zm4 0h2v14H5V5zm18 0H9v14h14V5zM11 17l2.5-3.15L15.29 16l2.5-3.22L21 17H11z"
	}), 'BurstModeSharp');
	
	exports.default = _default;

/***/ },
/* 1824 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11 17h10V7H11v10zm3-3.53l1.43 1.72 2-2.58L20 15.99h-8l2-2.52z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M1 5h2v14H1zm4 0h2v14H5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-1 12H11V7h10v10zm-3.57-4.38l-2 2.57L14 13.47l-2 2.52h8z"
	})), 'BurstModeTwoTone');
	
	exports.default = _default;

/***/ },
/* 1825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
	}), 'Business');
	
	exports.default = _default;

/***/ },
/* 1826 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 16v-1H3.01L3 19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-4h-7v1h-4zm10-9h-4.01V5l-2-2h-4l-2 2v2H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h4v2h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-6 0h-4V5h4v2z"
	}), 'BusinessCenter');
	
	exports.default = _default;

/***/ },
/* 1827 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 7h-4V5l-2-2h-4L8 5v2H4c-1.1 0-2 .9-2 2v5c0 .75.4 1.38 1 1.73V19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-3.28c.59-.35 1-.99 1-1.72V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zM4 9h16v5h-5v-3H9v3H4V9zm9 6h-2v-2h2v2zm6 4H5v-3h4v1h6v-1h4v3z"
	}), 'BusinessCenterOutlined');
	
	exports.default = _default;

/***/ },
/* 1828 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 16h-2c-.55 0-1-.45-1-1H3.01v4c0 1.1.9 2 2 2H19c1.1 0 2-.9 2-2v-4h-7c0 .55-.45 1-1 1zm7-9h-4c0-2.21-1.79-4-4-4S8 4.79 8 7H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-1c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v1h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 7c0-1.1.9-2 2-2s2 .9 2 2H9.99 10z"
	}), 'BusinessCenterRounded');
	
	exports.default = _default;

/***/ },
/* 1829 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 16v-1H3.01v6H21v-6h-7v1h-4zm12-9h-6V5l-2-2h-4L8 5v2H2v7h8v-2h4v2h8V7zm-8 0h-4V5h4v2z"
	}), 'BusinessCenterSharp');
	
	exports.default = _default;

/***/ },
/* 1830 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15 17H9v-1H5v3h14v-3h-4zM4 14h5v-3h6v3h5V9H4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 7h-4V5l-2-2h-4L8 5v2H4c-1.1 0-2 .9-2 2v5c0 .75.4 1.38 1 1.73V19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-3.28c.59-.35 1-.99 1-1.72V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm9 14H5v-3h4v1h6v-1h4v3zm-8-4v-2h2v2h-2zm9-1h-5v-3H9v3H4V9h16v5z"
	})), 'BusinessCenterTwoTone');
	
	exports.default = _default;

/***/ },
/* 1831 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
	}), 'BusinessOutlined');
	
	exports.default = _default;

/***/ },
/* 1832 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2h-8zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm9 12h-7v-2h2v-2h-2v-2h2v-2h-2V9h7c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1zm-1-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
	}), 'BusinessRounded');
	
	exports.default = _default;

/***/ },
/* 1833 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
	}), 'BusinessSharp');
	
	exports.default = _default;

/***/ },
/* 1834 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 11h2v2h-2v2h2v2h-2v2h8V9h-8v2zm4 0h2v2h-2v-2zm0 4h2v2h-2v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16 15h2v2h-2zm0-4h2v2h-2zm6-4H12V3H2v18h20V7zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10z"
	})), 'BusinessTwoTone');
	
	exports.default = _default;

/***/ },
/* 1835 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z"
	}), 'Cached');
	
	exports.default = _default;

/***/ },
/* 1836 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z"
	}), 'CachedOutlined');
	
	exports.default = _default;

/***/ },
/* 1837 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.65 8.35l-2.79 2.79c-.32.32-.1.86.35.86H18c0 3.31-2.69 6-6 6-.79 0-1.56-.15-2.25-.44-.36-.15-.77-.04-1.04.23-.51.51-.33 1.37.34 1.64.91.37 1.91.57 2.95.57 4.42 0 8-3.58 8-8h1.79c.45 0 .67-.54.35-.85l-2.79-2.79c-.19-.2-.51-.2-.7-.01zM6 12c0-3.31 2.69-6 6-6 .79 0 1.56.15 2.25.44.36.15.77.04 1.04-.23.51-.51.33-1.37-.34-1.64C14.04 4.2 13.04 4 12 4c-4.42 0-8 3.58-8 8H2.21c-.45 0-.67.54-.35.85l2.79 2.79c.2.2.51.2.71 0l2.79-2.79c.31-.31.09-.85-.36-.85H6z"
	}), 'CachedRounded');
	
	exports.default = _default;

/***/ },
/* 1838 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z"
	}), 'CachedSharp');
	
	exports.default = _default;

/***/ },
/* 1839 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z"
	}), 'CachedTwoTone');
	
	exports.default = _default;

/***/ },
/* 1840 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm4.6 9.99l-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-4.61c-.56.38-1.23.61-1.96.61-.92 0-1.79-.36-2.44-1.01zM18 9h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v1.54c0 1.08.88 1.96 1.96 1.96.52 0 1.02-.2 1.38-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.37.37.86.57 1.38.57 1.08 0 1.96-.88 1.96-1.96V12C21 10.34 19.66 9 18 9z"
	}), 'Cake');
	
	exports.default = _default;

/***/ },
/* 1841 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm6 3h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v9c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-9c0-1.66-1.34-3-3-3zm1 11H5v-3c.9-.01 1.76-.37 2.4-1.01l1.09-1.07 1.07 1.07c1.31 1.31 3.59 1.3 4.89 0l1.08-1.07 1.07 1.07c.64.64 1.5 1 2.4 1.01v3zm0-4.5c-.51-.01-.99-.2-1.35-.57l-2.13-2.13-2.14 2.13c-.74.74-2.03.74-2.77 0L8.48 12.8l-2.14 2.13c-.35.36-.83.56-1.34.57V12c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v3.5z"
	}), 'CakeOutlined');
	
	exports.default = _default;

/***/ },
/* 1842 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.68 5.88c.7-.24 1.22-.9 1.3-1.64.05-.47-.05-.91-.28-1.27L12.42.75c-.19-.33-.67-.33-.87 0l-1.28 2.22c-.17.3-.27.65-.27 1.03 0 1.32 1.3 2.35 2.68 1.88zm3.85 10.04l-1-1-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V20c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-3.61c-.75.51-1.71.75-2.74.52-.66-.14-1.25-.51-1.73-.99zM18 9h-5V8c0-.55-.45-1-1-1s-1 .45-1 1v1H6c-1.66 0-3 1.34-3 3v1.46c0 .85.5 1.67 1.31 1.94.73.24 1.52.06 2.03-.46l2.14-2.13 2.13 2.13c.76.76 2.01.76 2.77 0l2.14-2.13 2.13 2.13c.43.43 1.03.63 1.65.55.99-.13 1.69-1.06 1.69-2.06v-1.42C21 10.34 19.66 9 18 9z"
	}), 'CakeRounded');
	
	exports.default = _default;

/***/ },
/* 1843 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm4.53 9.92l-1-1-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V22h18v-5.61c-.75.51-1.71.75-2.74.52-.66-.14-1.25-.51-1.73-.99zM18 9h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v1.54c0 1.08.88 1.96 1.96 1.96.52 0 1.02-.2 1.38-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.37.37.86.57 1.38.57 1.08 0 1.96-.88 1.96-1.96V12C21 10.34 19.66 9 18 9z"
	}), 'CakeSharp');
	
	exports.default = _default;

/***/ },
/* 1844 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.53 14.92l-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07c-.64.64-1.5 1-2.4 1.01v3h14v-3c-.9-.01-1.76-.37-2.4-1.01l-1.07-1.07zM18 11H6c-.55 0-1 .45-1 1v3.5c.51-.01.99-.21 1.34-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.36.36.84.56 1.35.57V12c0-.55-.45-1-1-1z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm6 3h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v9c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-9c0-1.66-1.34-3-3-3zm1 11H5v-3c.9-.01 1.76-.37 2.4-1.01l1.09-1.07 1.07 1.07c1.31 1.31 3.59 1.3 4.89 0l1.08-1.07 1.07 1.07c.64.64 1.5 1 2.4 1.01v3zm0-4.5c-.51-.01-.99-.2-1.35-.57l-2.13-2.13-2.14 2.13c-.74.74-2.03.74-2.77 0L8.48 12.8l-2.14 2.13c-.35.36-.83.56-1.34.57V12c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v3.5z"
	})), 'CakeTwoTone');
	
	exports.default = _default;

/***/ },
/* 1845 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"
	}), 'CalendarToday');
	
	exports.default = _default;

/***/ },
/* 1846 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V10h16v11zm0-13H4V5h16v3z"
	}), 'CalendarTodayOutlined');
	
	exports.default = _default;

/***/ },
/* 1847 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 3h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1H7V2c0-.55-.45-1-1-1s-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 18H5c-.55 0-1-.45-1-1V8h16v12c0 .55-.45 1-1 1z"
	}), 'CalendarTodayRounded');
	
	exports.default = _default;

/***/ },
/* 1848 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 3h-3V1h-2v2H7V1H5v2H2v20h20V3zm-2 18H4V8h16v13z"
	}), 'CalendarTodaySharp');
	
	exports.default = _default;

/***/ },
/* 1849 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 2v3H4V5h16zM4 21V10h16v11H4z"
	}), _react.default.createElement("path", {
	  d: "M4 5.01h16V8H4z",
	  opacity: ".3"
	})), 'CalendarTodayTwoTone');
	
	exports.default = _default;

/***/ },
/* 1850 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 17h18v2H3zm0-7h18v5H3zm0-4h18v2H3z"
	}), 'CalendarViewDay');
	
	exports.default = _default;

/***/ },
/* 1851 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 17h18v2H3zm16-5v1H5v-1h14m2-2H3v5h18v-5zM3 6h18v2H3z"
	}), 'CalendarViewDayOutlined');
	
	exports.default = _default;

/***/ },
/* 1852 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 17h16c.55 0 1 .45 1 1s-.45 1-1 1H4c-.55 0-1-.45-1-1s.45-1 1-1zm0-7h16c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1zm0-4h16c.55 0 1 .45 1 1s-.45 1-1 1H4c-.55 0-1-.45-1-1s.45-1 1-1z"
	}), 'CalendarViewDayRounded');
	
	exports.default = _default;

/***/ },
/* 1853 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 17h18v2H3v-2zm0-7h18v5H3v-5zm0-4h18v2H3V6z"
	}), 'CalendarViewDaySharp');
	
	exports.default = _default;

/***/ },
/* 1854 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 17h18v2H3zm16-5v1H5v-1h14m2-2H3v5h18v-5zM3 6h18v2H3z"
	}), _react.default.createElement("path", {
	  d: "M5 12h14v1H5z",
	  opacity: ".3"
	})), 'CalendarViewDayTwoTone');
	
	exports.default = _default;

/***/ },
/* 1855 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"
	}), 'Call');
	
	exports.default = _default;

/***/ },
/* 1856 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08c-.18-.17-.29-.42-.29-.7 0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.69-1.36-2.67-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z"
	}), 'CallEnd');
	
	exports.default = _default;

/***/ },
/* 1857 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.59 10.52c1.05.51 2.04 1.15 2.96 1.91l-1.07 1.07c-.58-.47-1.21-.89-1.88-1.27v-1.71m-13.2 0v1.7c-.65.37-1.28.79-1.87 1.27l-1.07-1.07c.91-.75 1.9-1.38 2.94-1.9M12 7C7.46 7 3.34 8.78.29 11.67c-.18.18-.29.43-.29.71s.11.53.29.7l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.1.7-.28.79-.73 1.68-1.36 2.66-1.85.33-.16.56-.51.56-.9v-3.1C8.85 9.25 10.4 9 12 9s3.15.25 4.59.73v3.1c0 .4.23.74.56.9.98.49 1.88 1.11 2.67 1.85.18.17.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71s-.11-.53-.29-.71C20.66 8.78 16.54 7 12 7z"
	}), 'CallEndOutlined');
	
	exports.default = _default;

/***/ },
/* 1858 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.51 15.48l2-1.59c.48-.38.76-.96.76-1.57v-2.6c3.02-.98 6.29-.99 9.32 0v2.61c0 .61.28 1.19.76 1.57l1.99 1.58c.8.63 1.94.57 2.66-.15l1.22-1.22c.8-.8.8-2.13-.05-2.88-6.41-5.66-16.07-5.66-22.48 0-.85.75-.85 2.08-.05 2.88l1.22 1.22c.71.72 1.85.78 2.65.15z"
	}), 'CallEndRounded');
	
	exports.default = _default;

/***/ },
/* 1859 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.68 16.07l3.92-3.11V9.59c2.85-.93 5.94-.93 8.8 0v3.38l3.91 3.1L24 12.39c-6.41-7.19-17.59-7.19-24 0l3.68 3.68z"
	}), 'CallEndSharp');
	
	exports.default = _default;

/***/ },
/* 1860 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18.59 12.23c.67.38 1.3.8 1.88 1.27l1.07-1.07c-.92-.75-1.91-1.39-2.96-1.91v1.71zM3.53 13.49c.59-.48 1.22-.9 1.87-1.27v-1.7c-1.04.51-2.03 1.15-2.94 1.9l1.07 1.07z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 7C7.46 7 3.34 8.78.29 11.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.7l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.1.7-.28.79-.73 1.68-1.36 2.66-1.85.33-.16.56-.51.56-.9v-3.1C8.85 9.25 10.4 9 12 9c1.6 0 3.15.25 4.59.73v3.1c0 .4.23.74.56.9.98.49 1.88 1.11 2.67 1.85.18.17.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71C20.66 8.78 16.54 7 12 7zm-6.6 5.22c-.65.37-1.28.79-1.87 1.27l-1.07-1.07c.91-.75 1.9-1.38 2.94-1.9v1.7zm15.07 1.28c-.58-.47-1.21-.89-1.88-1.27v-1.71c1.05.51 2.04 1.15 2.96 1.91l-1.08 1.07z"
	})), 'CallEndTwoTone');
	
	exports.default = _default;

/***/ },
/* 1861 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z"
	}), 'CallMade');
	
	exports.default = _default;

/***/ },
/* 1862 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5H9z"
	}), 'CallMadeOutlined');
	
	exports.default = _default;

/***/ },
/* 1863 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 6c0 .56.45 1 1 1h5.59L4.7 17.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L17 8.41V14c0 .55.45 1 1 1s1-.45 1-1V6c0-.55-.45-1-1-1h-8c-.55 0-1 .45-1 1z"
	}), 'CallMadeRounded');
	
	exports.default = _default;

/***/ },
/* 1864 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5H9z"
	}), 'CallMadeSharp');
	
	exports.default = _default;

/***/ },
/* 1865 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.41 20L17 8.41V15h2V5H9v2h6.59L4 18.59z"
	}), 'CallMadeTwoTone');
	
	exports.default = _default;

/***/ },
/* 1866 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
	}), 'CallMerge');
	
	exports.default = _default;

/***/ },
/* 1867 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
	}), 'CallMergeOutlined');
	
	exports.default = _default;

/***/ },
/* 1868 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.7 19.7c.39-.39.39-1.02 0-1.41l-2.7-2.7L13.59 17l2.7 2.7c.39.39 1.03.39 1.41 0zM8.71 8H11v5.59l-4.71 4.7c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l5.3-5.3V8h2.29c.45 0 .67-.54.35-.85l-3.29-3.29c-.2-.2-.51-.2-.71 0L8.35 7.15c-.31.31-.09.85.36.85z"
	}), 'CallMergeRounded');
	
	exports.default = _default;

/***/ },
/* 1869 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
	}), 'CallMergeSharp');
	
	exports.default = _default;

/***/ },
/* 1870 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.997 20.41l-3.408-3.407 1.4-1.407 3.41 3.408zM5.59 19L7 20.41l6-6V8h3.5L12 3.5 7.5 8H11v5.59z"
	}), 'CallMergeTwoTone');
	
	exports.default = _default;

/***/ },
/* 1871 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9z"
	}), 'CallMissed');
	
	exports.default = _default;

/***/ },
/* 1872 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 8.41l9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z"
	}), 'CallMissedOutgoing');
	
	exports.default = _default;

/***/ },
/* 1873 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 8.41l9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z"
	}), 'CallMissedOutgoingOutlined');
	
	exports.default = _default;

/***/ },
/* 1874 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.7 9.11l7.59 7.59c.39.39 1.02.39 1.41 0l6.3-6.3V14c0 .55.45 1 1 1s1-.45 1-1V8c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1s.45 1 1 1h3.59L12 14.59 5.11 7.7a.9959.9959 0 00-1.41 0c-.38.39-.38 1.03 0 1.41z"
	}), 'CallMissedOutgoingRounded');
	
	exports.default = _default;

/***/ },
/* 1875 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 8.41l9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z"
	}), 'CallMissedOutgoingSharp');
	
	exports.default = _default;

/***/ },
/* 1876 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 10.41V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41l9 9z"
	}), 'CallMissedOutgoingTwoTone');
	
	exports.default = _default;

/***/ },
/* 1877 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9L19.59 7z"
	}), 'CallMissedOutlined');
	
	exports.default = _default;

/***/ },
/* 1878 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.89 7.7L12 14.59 6.41 9H10c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1s1-.45 1-1v-3.59l6.29 6.29c.39.39 1.02.39 1.41 0l7.59-7.59c.39-.39.39-1.02 0-1.41-.38-.38-1.02-.38-1.4 0z"
	}), 'CallMissedRounded');
	
	exports.default = _default;

/***/ },
/* 1879 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9L19.59 7z"
	}), 'CallMissedSharp');
	
	exports.default = _default;

/***/ },
/* 1880 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 10.41l7 7 9-9L19.59 7 12 14.59 6.41 9H11V7H3v8h2z"
	}), 'CallMissedTwoTone');
	
	exports.default = _default;

/***/ },
/* 1881 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1z"
	}), 'CallOutlined');
	
	exports.default = _default;

/***/ },
/* 1882 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41z"
	}), 'CallReceived');
	
	exports.default = _default;

/***/ },
/* 1883 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41L20 5.41z"
	}), 'CallReceivedOutlined');
	
	exports.default = _default;

/***/ },
/* 1884 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.3 4.71a.9959.9959 0 00-1.41 0L7 15.59V10c0-.55-.45-1-1-1s-1 .45-1 1v8c0 .55.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1H8.41L19.3 6.11c.38-.38.38-1.02 0-1.4z"
	}), 'CallReceivedRounded');
	
	exports.default = _default;

/***/ },
/* 1885 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41L20 5.41z"
	}), 'CallReceivedSharp');
	
	exports.default = _default;

/***/ },
/* 1886 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 17H8.41L20 5.41 18.59 4 7 15.59V9H5v10h10z"
	}), 'CallReceivedTwoTone');
	
	exports.default = _default;

/***/ },
/* 1887 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.23 15.26l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z"
	}), 'CallRounded');
	
	exports.default = _default;

/***/ },
/* 1888 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 15.46l-5.27-.61-2.52 2.52c-2.83-1.44-5.15-3.75-6.59-6.59l2.53-2.53L8.54 3H3.03C2.45 13.18 10.82 21.55 21 20.97v-5.51z"
	}), 'CallSharp');
	
	exports.default = _default;

/***/ },
/* 1889 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z"
	}), 'CallSplit');
	
	exports.default = _default;

/***/ },
/* 1890 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4h-6zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3L10 4z"
	}), 'CallSplitOutlined');
	
	exports.default = _default;

/***/ },
/* 1891 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.85 4.85l1.44 1.44-2.88 2.88 1.42 1.42 2.88-2.88 1.44 1.44c.31.31.85.09.85-.36V4.5c0-.28-.22-.5-.5-.5h-4.29c-.45 0-.67.54-.36.85zM8.79 4H4.5c-.28 0-.5.22-.5.5v4.29c0 .45.54.67.85.35L6.29 7.7 11 12.4V19c0 .55.45 1 1 1s1-.45 1-1v-7c0-.26-.11-.52-.29-.71l-5-5.01 1.44-1.44c.31-.3.09-.84-.36-.84z"
	}), 'CallSplitRounded');
	
	exports.default = _default;

/***/ },
/* 1892 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4h-6zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3L10 4z"
	}), 'CallSplitSharp');
	
	exports.default = _default;

/***/ },
/* 1893 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4h-6l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10zM4 4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3L10 4z"
	}), 'CallSplitTwoTone');
	
	exports.default = _default;

/***/ },
/* 1894 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3v-3h18v3z"
	}), 'CallToAction');
	
	exports.default = _default;

/***/ },
/* 1895 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 15h14v3H5z"
	}), 'CallToActionOutlined');
	
	exports.default = _default;

/***/ },
/* 1896 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16H4c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1z"
	}), 'CallToActionRounded');
	
	exports.default = _default;

/***/ },
/* 1897 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 3H1v18h22V3zm-2 16H3v-3h18v3z"
	}), 'CallToActionSharp');
	
	exports.default = _default;

/***/ },
/* 1898 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 19h18V5H3v14zm2-4h14v3H5v-3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 15h14v3H5z"
	})), 'CallToActionTwoTone');
	
	exports.default = _default;

/***/ },
/* 1899 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 17.47c-.88-.07-1.75-.22-2.6-.45l-1.19 1.19c1.2.41 2.48.67 3.8.75v-1.49zM6.54 5h-1.5c.09 1.32.35 2.59.75 3.8l1.2-1.2c-.24-.84-.39-1.71-.45-2.6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 21c.55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17zm-3.6-3.98c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19zM5.03 5h1.5c.07.89.22 1.76.46 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79z"
	})), 'CallTwoTone');
	
	exports.default = _default;

/***/ },
/* 1900 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.4 10.5l4.77-8.26C13.47 2.09 12.75 2 12 2c-2.4 0-4.6.85-6.32 2.25l3.66 6.35.06-.1zM21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9h9.66zm.26 1h-7.49l.29.5 4.76 8.25C21 16.97 22 14.61 22 12c0-.69-.07-1.35-.2-2zM8.54 12l-3.9-6.75C3.01 7.03 2 9.39 2 12c0 .69.07 1.35.2 2h7.49l-1.15-2zm-6.08 3c.92 2.92 3.15 5.26 6 6.34L12.12 15H2.46zm11.27 0l-3.9 6.76c.7.15 1.42.24 2.17.24 2.4 0 4.6-.85 6.32-2.25l-3.66-6.35-.93 1.6z"
	}), 'Camera');
	
	exports.default = _default;

/***/ },
/* 1901 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "3.2"
	}), _react.default.createElement("path", {
	  d: "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	})), 'CameraAlt');
	
	exports.default = _default;

/***/ },
/* 1902 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h4.05l1.83-2h4.24l1.83 2H20v12zM12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
	}), 'CameraAltOutlined');
	
	exports.default = _default;

/***/ },
/* 1903 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "3"
	}), _react.default.createElement("path", {
	  d: "M20 4h-3.17l-1.24-1.35c-.37-.41-.91-.65-1.47-.65H9.88c-.56 0-1.1.24-1.48.65L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 13c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	})), 'CameraAltRounded');
	
	exports.default = _default;

/***/ },
/* 1904 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "3"
	}), _react.default.createElement("path", {
	  d: "M16.83 4L15 2H9L7.17 4H2v16h20V4h-5.17zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	})), 'CameraAltSharp');
	
	exports.default = _default;

/***/ },
/* 1905 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14.12 4H9.88L8.05 6H4v12h16V6h-4.05l-1.83-2zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h4.05l1.83-2h4.24l1.83 2H20v12zM12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
	})), 'CameraAltTwoTone');
	
	exports.default = _default;

/***/ },
/* 1906 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9 3L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-3.17L15 3H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	}), _react.default.createElement("path", {
	  d: "M12 17l1.25-2.75L16 13l-2.75-1.25L12 9l-1.25 2.75L8 13l2.75 1.25z"
	})), 'CameraEnhance');
	
	exports.default = _default;

/***/ },
/* 1907 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 10l-.94 2.06L9 13l2.06.94L12 16l.94-2.06L15 13l-2.06-.94zm8-5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14H4V7h4.05l.59-.65L9.88 5h4.24l1.24 1.35.59.65H20v12zM12 8c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
	}), 'CameraEnhanceOutlined');
	
	exports.default = _default;

/***/ },
/* 1908 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 5h-3.17l-1.24-1.35c-.37-.41-.91-.65-1.47-.65H9.88c-.56 0-1.1.24-1.48.65L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-8 13c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-9l-1.25 2.75L8 13l2.75 1.25L12 17l1.25-2.75L16 13l-2.75-1.25z"
	}), 'CameraEnhanceRounded');
	
	exports.default = _default;

/***/ },
/* 1909 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.83 5L15 3H9L7.17 5H2v16h20V5h-5.17zM12 18c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-9l-1.25 2.75L8 13l2.75 1.25L12 17l1.25-2.75L16 13l-2.75-1.25z"
	}), 'CameraEnhanceSharp');
	
	exports.default = _default;

/***/ },
/* 1910 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.95 7l-.59-.65L14.12 5H9.88L8.65 6.35l-.6.65H4v12h16V7h-4.05zM12 18c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 10l-.94 2.06L9 13l2.06.94L12 16l.94-2.06L15 13l-2.06-.94zm8-5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14H4V7h4.05l.59-.65L9.88 5h4.24l1.24 1.35.59.65H20v12zM12 8c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
	})), 'CameraEnhanceTwoTone');
	
	exports.default = _default;

/***/ },
/* 1911 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zM12 8c1.1 0 2-.9 2-2s-.9-2-2-2-1.99.9-1.99 2S10.9 8 12 8zm5-8H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM7 2h10v10.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2z"
	}), 'CameraFront');
	
	exports.default = _default;

/***/ },
/* 1912 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 20v2h5v2l3-3-3-3v2zm9 0h5v2h-5zM11.99 8C13.1 8 14 7.1 14 6s-.9-2-2.01-2S10 4.9 10 6s.89 2 1.99 2zM17 0H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 16H7v-2h10v2zm0-3.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2h10v10.5z"
	}), 'CameraFrontOutlined');
	
	exports.default = _default;

/***/ },
/* 1913 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 0H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 12.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V3c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v9.5zm-6.15 6.35c-.31-.31-.85-.09-.85.36V20H6c-.55 0-1 .45-1 1s.45 1 1 1h4v.79c0 .45.54.67.85.35l1.79-1.79c.2-.2.2-.51 0-.71l-1.79-1.79zM18 20h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1zM12 8c1.1 0 2-.9 2-2s-.9-2-2-2-1.99.9-1.99 2S10.9 8 12 8z"
	}), 'CameraFrontRounded');
	
	exports.default = _default;

/***/ },
/* 1914 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zM12 8c1.1 0 2-.9 2-2s-.9-2-2-2-1.99.9-1.99 2S10.9 8 12 8zm7-8H5v18h14V0zM7 2h10v10.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2z"
	}), 'CameraFrontSharp');
	
	exports.default = _default;

/***/ },
/* 1915 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 14h10v2H7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 20v2h5v2l3-3-3-3v2zm9 0h5v2h-5zM11.99 8C13.1 8 14 7.1 14 6s-.9-2-2.01-2S10 4.9 10 6s.89 2 1.99 2zM17 0H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 16H7v-2h10v2zm0-3.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2h10v10.5z"
	})), 'CameraFrontTwoTone');
	
	exports.default = _default;

/***/ },
/* 1916 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.25 2.26l-.08-.04-.01.02C13.46 2.09 12.74 2 12 2 6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-4.75-3.31-8.72-7.75-9.74zM19.41 9h-7.99l2.71-4.7c2.4.66 4.35 2.42 5.28 4.7zM13.1 4.08L10.27 9l-1.15 2L6.4 6.3C7.84 4.88 9.82 4 12 4c.37 0 .74.03 1.1.08zM5.7 7.09L8.54 12l1.15 2H4.26C4.1 13.36 4 12.69 4 12c0-1.85.64-3.55 1.7-4.91zM4.59 15h7.98l-2.71 4.7c-2.4-.67-4.34-2.42-5.27-4.7zm6.31 4.91L14.89 13l2.72 4.7C16.16 19.12 14.18 20 12 20c-.38 0-.74-.04-1.1-.09zm7.4-3l-4-6.91h5.43c.17.64.27 1.31.27 2 0 1.85-.64 3.55-1.7 4.91z"
	}), 'CameraOutlined');
	
	exports.default = _default;

/***/ },
/* 1917 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zm3-20H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-5 6c-1.11 0-2-.9-2-2s.89-2 1.99-2 2 .9 2 2C14 5.1 13.1 6 12 6z"
	}), 'CameraRear');
	
	exports.default = _default;

/***/ },
/* 1918 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 20v2h5v2l3-3-3-3v2zm9 0h5v2h-5zm3-20H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 16H7V2h10v14zm-5-9c1.1 0 2-.9 1.99-2 0-1.1-.9-2-2-2S10 3.9 10 5s.89 2 2 2z"
	}), 'CameraRearOutlined');
	
	exports.default = _default;

/***/ },
/* 1919 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.85 18.85c-.31-.31-.85-.09-.85.36V20H6c-.55 0-1 .45-1 1s.45 1 1 1h4v.79c0 .45.54.67.85.35l1.79-1.79c.2-.2.2-.51 0-.71l-1.79-1.79zM18 20h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1zM17 0H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-5 6c-1.11 0-2-.9-2-2s.89-2 1.99-2 2 .9 2 2C14 5.1 13.1 6 12 6z"
	}), 'CameraRearRounded');
	
	exports.default = _default;

/***/ },
/* 1920 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zm5-20H5v18h14V0zm-7 6c-1.11 0-2-.9-2-2s.89-2 1.99-2 2 .9 2 2C14 5.1 13.1 6 12 6z"
	}), 'CameraRearSharp');
	
	exports.default = _default;

/***/ },
/* 1921 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 16h10V2H7v14zm4.99-13c1.1 0 2 .9 2 2C14 6.1 13.1 7 12 7c-1.11 0-2-.9-2-2s.89-2 1.99-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 20v2h5v2l3-3-3-3v2zm9 0h5v2h-5zm5-18c0-1.1-.9-2-2-2H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2zm-2 14H7V2h10v14zm-5-9c1.1 0 2-.9 1.99-2 0-1.1-.9-2-2-2S10 3.9 10 5s.89 2 2 2z"
	})), 'CameraRearTwoTone');
	
	exports.default = _default;

/***/ },
/* 1922 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h8V5h-8zm-2 13h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2z"
	}), 'CameraRoll');
	
	exports.default = _default;

/***/ },
/* 1923 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h8V5h-8zm6 13h-8v2H4V5h3V3h2v2h3v2h8v11zM9 15h2v2H9zm0-7h2v2H9zm4 7h2v2h-2zm0-7h2v2h-2zm4 7h2v2h-2zm0-7h2v2h-2z"
	}), 'CameraRollOutlined');
	
	exports.default = _default;

/***/ },
/* 1924 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h6c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-6zm-2 13h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2z"
	}), 'CameraRollRounded');
	
	exports.default = _default;

/***/ },
/* 1925 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 5V3h-3V1H5v2H2v19h12v-2h8V5h-8zm-2 13h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2z"
	}), 'CameraRollSharp');
	
	exports.default = _default;

/***/ },
/* 1926 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 5H9V3H7v2H4v15h8v-2h8V7h-8V5zm-1 12H9v-2h2v2zm0-7H9V8h2v2zm6-2h2v2h-2V8zm0 7h2v2h-2v-2zm-4-7h2v2h-2V8zm0 7h2v2h-2v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h8V5h-8zm6 13h-8v2H4V5h3V3h2v2h3v2h8v11zM9 15h2v2H9zm0-7h2v2H9zm4 7h2v2h-2zm0-7h2v2h-2zm4 7h2v2h-2zm0-7h2v2h-2z"
	})), 'CameraRollTwoTone');
	
	exports.default = _default;

/***/ },
/* 1927 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.81 2.86c.17-.3 0-.7-.35-.74-2.62-.37-5.3.28-7.44 1.86-.19.15-.25.43-.12.65l3.01 5.22c.19.33.67.33.87 0l4.03-6.99zm7.49 5.47c-.98-2.47-2.92-4.46-5.35-5.5-.23-.1-.5 0-.63.22l-3.01 5.21c-.19.32.05.74.44.74h8.08c.35 0 .6-.35.47-.67zm.07 1.67h-6.2c-.38 0-.63.42-.43.75L19 18.14c.17.3.6.35.82.08 1.74-2.18 2.48-5.03 2.05-7.79-.03-.25-.25-.43-.5-.43zM4.18 5.79c-1.73 2.19-2.48 5.02-2.05 7.79.03.24.25.42.5.42h6.2c.38 0 .63-.42.43-.75L5 5.87c-.18-.3-.61-.35-.82-.08zM2.7 15.67c.98 2.47 2.92 4.46 5.35 5.5.23.1.5 0 .63-.22l3.01-5.21c.19-.33-.05-.75-.43-.75H3.17c-.35.01-.6.36-.47.68zm7.83 6.22c2.62.37 5.3-.28 7.44-1.86.2-.15.26-.44.13-.66l-3.01-5.22c-.19-.33-.67-.33-.87 0l-4.04 6.99c-.17.3.01.7.35.75z"
	}), 'CameraRounded');
	
	exports.default = _default;

/***/ },
/* 1928 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.4 10.5l4.77-8.26C13.47 2.09 12.75 2 12 2c-2.4 0-4.6.85-6.32 2.25l3.66 6.35.06-.1zM21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9h9.66zm.26 1h-7.49l.29.5 4.76 8.25C21 16.97 22 14.61 22 12c0-.69-.07-1.35-.2-2zM8.54 12l-3.9-6.75C3.01 7.03 2 9.39 2 12c0 .69.07 1.35.2 2h7.49l-1.15-2zm-6.08 3c.92 2.92 3.15 5.26 6 6.34L12.12 15H2.46zm11.27 0l-3.9 6.76c.7.15 1.42.24 2.17.24 2.4 0 4.6-.85 6.32-2.25l-3.66-6.35-.93 1.6z"
	}), 'CameraSharp');
	
	exports.default = _default;

/***/ },
/* 1929 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M10.9 19.91c.36.05.72.09 1.1.09 2.18 0 4.16-.88 5.61-2.3L14.89 13l-3.99 6.91zm-1.04-.21l2.71-4.7H4.59c.93 2.28 2.87 4.03 5.27 4.7zM8.54 12L5.7 7.09C4.64 8.45 4 10.15 4 12c0 .69.1 1.36.26 2h5.43l-1.15-2zm9.76 4.91C19.36 15.55 20 13.85 20 12c0-.69-.1-1.36-.26-2h-5.43l3.99 6.91zM13.73 9h5.68c-.93-2.28-2.88-4.04-5.28-4.7L11.42 9h2.31zm-3.46 0l2.83-4.92C12.74 4.03 12.37 4 12 4c-2.18 0-4.16.88-5.6 2.3L9.12 11l1.15-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 22c5.52 0 10-4.48 10-10 0-4.75-3.31-8.72-7.75-9.74l-.08-.04-.01.02C13.46 2.09 12.74 2 12 2 6.48 2 2 6.48 2 12s4.48 10 10 10zm0-2c-.38 0-.74-.04-1.1-.09L14.89 13l2.72 4.7C16.16 19.12 14.18 20 12 20zm8-8c0 1.85-.64 3.55-1.7 4.91l-4-6.91h5.43c.17.64.27 1.31.27 2zm-.59-3h-7.99l2.71-4.7c2.4.66 4.35 2.42 5.28 4.7zM12 4c.37 0 .74.03 1.1.08L10.27 9l-1.15 2L6.4 6.3C7.84 4.88 9.82 4 12 4zm-8 8c0-1.85.64-3.55 1.7-4.91L8.54 12l1.15 2H4.26C4.1 13.36 4 12.69 4 12zm6.27 3h2.3l-2.71 4.7c-2.4-.67-4.35-2.42-5.28-4.7h5.69z"
	})), 'CameraTwoTone');
	
	exports.default = _default;

/***/ },
/* 1930 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
	}), 'Cancel');
	
	exports.default = _default;

/***/ },
/* 1931 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z"
	}), 'CancelOutlined');
	
	exports.default = _default;

/***/ },
/* 1932 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21 19.1H3V5h18v14.1zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), _react.default.createElement("path", {
	  d: "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41z"
	})), 'CancelPresentation');
	
	exports.default = _default;

/***/ },
/* 1933 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM9.41 15.95L12 13.36l2.59 2.59L16 14.54l-2.59-2.59L16 9.36l-1.41-1.41L12 10.54 9.41 7.95 8 9.36l2.59 2.59L8 14.54z"
	}), 'CancelPresentationOutlined');
	
	exports.default = _default;

/***/ },
/* 1934 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 15c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v12zm-5.71-9.3a.9959.9959 0 00-1.41 0L12 10.59 10.11 8.7a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 8.7 13.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l1.89 1.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l1.89-1.89c.38-.38.38-1.02-.01-1.41z"
	}), 'CancelPresentationRounded');
	
	exports.default = _default;

/***/ },
/* 1935 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 3v18h22V3H1zm20 16H3V5h18v14zM9.41 16L12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8 12 10.59 9.41 8 8 9.41 10.59 12 8 14.59z"
	}), 'CancelPresentationSharp');
	
	exports.default = _default;

/***/ },
/* 1936 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 19.1h18V4.95H3V19.1zm5-9.74l1.41-1.41L12 10.54l2.59-2.59L16 9.36l-2.59 2.59L16 14.54l-1.41 1.41L12 13.36l-2.59 2.59L8 14.54l2.59-2.59L8 9.36z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM9.41 15.95L12 13.36l2.59 2.59L16 14.54l-2.59-2.59L16 9.36l-1.41-1.41L12 10.54 9.41 7.95 8 9.36l2.59 2.59L8 14.54z"
	})), 'CancelPresentationTwoTone');
	
	exports.default = _default;

/***/ },
/* 1937 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm4.3 14.3c-.39.39-1.02.39-1.41 0L12 13.41 9.11 16.3c-.39.39-1.02.39-1.41 0a.9959.9959 0 010-1.41L10.59 12 7.7 9.11a.9959.9959 0 010-1.41c.39-.39 1.02-.39 1.41 0L12 10.59l2.89-2.89c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41L13.41 12l2.89 2.89c.38.38.38 1.02 0 1.41z"
	}), 'CancelRounded');
	
	exports.default = _default;

/***/ },
/* 1938 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16.5 9c-.42 0-.83.04-1.24.11L1.01 3 1 10l9 2-9 2 .01 7 8.07-3.46C9.59 21.19 12.71 24 16.5 24c4.14 0 7.5-3.36 7.5-7.5S20.64 9 16.5 9zm0 13c-3.03 0-5.5-2.47-5.5-5.5s2.47-5.5 5.5-5.5 5.5 2.47 5.5 5.5-2.47 5.5-5.5 5.5z"
	}), _react.default.createElement("path", {
	  d: "M18.27 14.03l-1.77 1.76-1.77-1.76-.7.7 1.76 1.77-1.76 1.77.7.7 1.77-1.76 1.77 1.76.7-.7-1.76-1.77 1.76-1.77z"
	})), 'CancelScheduleSend');
	
	exports.default = _default;

/***/ },
/* 1939 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16.5 9c-.42 0-.83.04-1.24.11L1.01 3 1 10l10.06 1.34c-.42.44-.78.93-1.09 1.46L1 14l.01 7 8.07-3.46C9.59 21.19 12.71 24 16.5 24c4.14 0 7.5-3.36 7.5-7.5S20.64 9 16.5 9zM3 8.25l.01-2.22 7.51 3.22-7.52-1zm6.1 7.11L3 17.97v-2.22l6.17-.82c-.03.14-.05.28-.07.43zM16.5 22c-3.03 0-5.5-2.47-5.5-5.5s2.47-5.5 5.5-5.5 5.5 2.47 5.5 5.5-2.47 5.5-5.5 5.5z"
	}), _react.default.createElement("path", {
	  d: "M18.27 14.03l-1.77 1.76-1.77-1.76-.7.7 1.76 1.77-1.76 1.77.7.7 1.77-1.76 1.77 1.76.7-.7-1.76-1.77 1.76-1.77z"
	})), 'CancelScheduleSendOutlined');
	
	exports.default = _default;

/***/ },
/* 1940 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16.5 9c-.42 0-.83.04-1.24.11L2.4 3.6c-.66-.29-1.39.2-1.39.91L1 9.2c0 .47.33.88.78.98L10 12l-8.22 1.83c-.45.1-.78.5-.78.97l.01 4.68c0 .72.73 1.2 1.39.92l6.68-2.86C9.59 21.19 12.71 24 16.5 24c4.14 0 7.5-3.36 7.5-7.5S20.64 9 16.5 9zm0 13c-3.03 0-5.5-2.47-5.5-5.5s2.47-5.5 5.5-5.5 5.5 2.47 5.5 5.5-2.47 5.5-5.5 5.5z"
	}), _react.default.createElement("path", {
	  d: "M18.62 14.38c-.2-.2-.51-.2-.71 0l-1.41 1.41-1.41-1.41c-.2-.2-.51-.2-.71 0s-.2.51 0 .71l1.41 1.41-1.41 1.41c-.2.2-.2.51 0 .71.2.2.51.2.71 0l1.41-1.41 1.41 1.41c.2.2.51.2.71 0 .2-.2.2-.51 0-.71l-1.41-1.41 1.41-1.41c.2-.2.2-.52 0-.71z"
	})), 'CancelScheduleSendRounded');
	
	exports.default = _default;

/***/ },
/* 1941 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16.5 9c-.42 0-.83.04-1.24.11L1.01 3 1 10l9 2-9 2 .01 7 8.07-3.46C9.59 21.19 12.71 24 16.5 24c4.14 0 7.5-3.36 7.5-7.5S20.64 9 16.5 9zm0 13c-3.03 0-5.5-2.47-5.5-5.5s2.47-5.5 5.5-5.5 5.5 2.47 5.5 5.5-2.47 5.5-5.5 5.5z"
	}), _react.default.createElement("path", {
	  d: "M18.27 14.03l-1.77 1.76-1.77-1.76-.7.7 1.76 1.77-1.76 1.77.7.7 1.77-1.76 1.77 1.76.7-.7-1.76-1.77 1.76-1.77z"
	})), 'CancelScheduleSendSharp');
	
	exports.default = _default;

/***/ },
/* 1942 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 17.97l6.1-2.61c.02-.14.04-.29.07-.43L3 15.75v2.22zM16.5 11c-3.03 0-5.5 2.47-5.5 5.5s2.47 5.5 5.5 5.5 5.5-2.47 5.5-5.5-2.47-5.5-5.5-5.5zm2.47 7.27l-.71.71-1.77-1.77-1.77 1.77-.71-.71 1.77-1.77-1.77-1.77.71-.71 1.77 1.77 1.77-1.77.71.71-1.77 1.77 1.77 1.77zM3 8.25l7.52 1-7.51-3.22z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16.5 9c-.42 0-.83.04-1.24.11L1.01 3 1 10l10.06 1.34c-.42.44-.78.93-1.09 1.46L1 14l.01 7 8.07-3.46C9.59 21.19 12.71 24 16.5 24c4.14 0 7.5-3.36 7.5-7.5S20.64 9 16.5 9zM3 8.25l.01-2.22 7.51 3.22-7.52-1zm6.1 7.11L3 17.97v-2.22l6.17-.82c-.03.14-.05.28-.07.43zM16.5 22c-3.03 0-5.5-2.47-5.5-5.5s2.47-5.5 5.5-5.5 5.5 2.47 5.5 5.5-2.47 5.5-5.5 5.5z"
	}), _react.default.createElement("path", {
	  d: "M18.27 14.03l-1.77 1.76-1.77-1.76-.7.7 1.76 1.77-1.76 1.77.7.7 1.77-1.76 1.77 1.76.7-.7-1.76-1.77 1.76-1.77z"
	})), 'CancelScheduleSendTwoTone');
	
	exports.default = _default;

/***/ },
/* 1943 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
	}), 'CancelSharp');
	
	exports.default = _default;

/***/ },
/* 1944 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm5 11.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z"
	})), 'CancelTwoTone');
	
	exports.default = _default;

/***/ },
/* 1945 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
	}), 'CardGiftcard');
	
	exports.default = _default;

/***/ },
/* 1946 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 12 7.4l3.38 4.6L17 10.83 14.92 8H20v6z"
	}), 'CardGiftcardOutlined');
	
	exports.default = _default;

/***/ },
/* 1947 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V9c0-.55.45-1 1-1h4.08L7.6 10.02c-.33.45-.23 1.08.22 1.4.44.32 1.07.22 1.39-.22L12 7.4l2.79 3.8c.32.44.95.54 1.39.22.45-.32.55-.95.22-1.4L14.92 8H19c.55 0 1 .45 1 1v5z"
	}), 'CardGiftcardRounded');
	
	exports.default = _default;

/***/ },
/* 1948 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6h-4.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H2.01v15H22V6zm-7-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 12 7.4l3.38 4.6L17 10.83 14.92 8H20v6z"
	}), 'CardGiftcardSharp');
	
	exports.default = _default;

/***/ },
/* 1949 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 17h16v2H4zm13-6.17L15.38 12 12 7.4 8.62 12 7 10.83 9.08 8H4v6h16V8h-5.08z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 12 7.4l3.38 4.6L17 10.83 14.92 8H20v6z"
	})), 'CardGiftcardTwoTone');
	
	exports.default = _default;

/***/ },
/* 1950 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z"
	}), 'CardMembership');
	
	exports.default = _default;

/***/ },
/* 1951 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z"
	}), 'CardMembershipOutlined');
	
	exports.default = _default;

/***/ },
/* 1952 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V5c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v5z"
	}), 'CardMembershipRounded');
	
	exports.default = _default;

/***/ },
/* 1953 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H2v15h6v5l4-2 4 2v-5h6V2zm-2 13H4v-2h16v2zm0-5H4V4h16v6z"
	}), 'CardMembershipSharp');
	
	exports.default = _default;

/***/ },
/* 1954 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 4h16v6H4zm0 9h16v2H4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z"
	})), 'CardMembershipTwoTone');
	
	exports.default = _default;

/***/ },
/* 1955 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z"
	}), 'CardTravel');
	
	exports.default = _default;

/***/ },
/* 1956 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z"
	}), 'CardTravelOutlined');
	
	exports.default = _default;

/***/ },
/* 1957 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V9c0-.55.45-1 1-1h2v1c0 .55.45 1 1 1s1-.45 1-1V8h6v1c0 .55.45 1 1 1s1-.45 1-1V8h2c.55 0 1 .45 1 1v5z"
	}), 'CardTravelRounded');
	
	exports.default = _default;

/***/ },
/* 1958 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6h-5V4c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2H2v15h20V6zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z"
	}), 'CardTravelSharp');
	
	exports.default = _default;

/***/ },
/* 1959 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 17h16v2H4zm13-7h-2V8H9v2H7V8H4v6h16V8h-3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z"
	})), 'CardTravelTwoTone');
	
	exports.default = _default;

/***/ },
/* 1960 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.5 18c-.83 0-1.5-.67-1.5-1.5S6.67 15 7.5 15s1.5.67 1.5 1.5S8.33 18 7.5 18zm0-9C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-9c-.83 0-1.5-.67-1.5-1.5S15.67 6 16.5 6s1.5.67 1.5 1.5S17.33 9 16.5 9z"
	}), 'Casino');
	
	exports.default = _default;

/***/ },
/* 1961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
	}), _react.default.createElement("circle", {
	  cx: "7.5",
	  cy: "16.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "7.5",
	  cy: "7.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "16.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "7.5",
	  r: "1.5"
	})), 'CasinoOutlined');
	
	exports.default = _default;

/***/ },
/* 1962 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.5 18c-.83 0-1.5-.67-1.5-1.5S6.67 15 7.5 15s1.5.67 1.5 1.5S8.33 18 7.5 18zm0-9C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-9c-.83 0-1.5-.67-1.5-1.5S15.67 6 16.5 6s1.5.67 1.5 1.5S17.33 9 16.5 9z"
	}), 'CasinoRounded');
	
	exports.default = _default;

/***/ },
/* 1963 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zM7.5 18c-.83 0-1.5-.67-1.5-1.5S6.67 15 7.5 15s1.5.67 1.5 1.5S8.33 18 7.5 18zm0-9C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-9c-.83 0-1.5-.67-1.5-1.5S15.67 6 16.5 6s1.5.67 1.5 1.5S17.33 9 16.5 9z"
	}), 'CasinoSharp');
	
	exports.default = _default;

/***/ },
/* 1964 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14V5H5v14zM16.5 6c.83 0 1.5.67 1.5 1.5S17.33 9 16.5 9 15 8.33 15 7.5 15.67 6 16.5 6zm0 9c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zM12 10.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zM7.5 6C8.33 6 9 6.67 9 7.5S8.33 9 7.5 9 6 8.33 6 7.5 6.67 6 7.5 6zm0 9c.83 0 1.5.67 1.5 1.5S8.33 18 7.5 18 6 17.33 6 16.5 6.67 15 7.5 15z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
	}), _react.default.createElement("circle", {
	  cx: "7.5",
	  cy: "16.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "7.5",
	  cy: "7.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "16.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "7.5",
	  r: "1.5"
	})), 'CasinoTwoTone');
	
	exports.default = _default;

/***/ },
/* 1965 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z"
	}), 'Cast');
	
	exports.default = _default;

/***/ },
/* 1966 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm18-7H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19V7zM1 10v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'CastConnected');
	
	exports.default = _default;

/***/ },
/* 1967 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 7v2h12v6h-3v2h5V7z"
	}), 'CastConnectedOutlined');
	
	exports.default = _default;

/***/ },
/* 1968 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 16V8c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v.63c3.96 1.28 7.09 4.41 8.37 8.37H18c.55 0 1-.45 1-1zm2-13H3c-1.1 0-2 .9-2 2v2c0 .55.45 1 1 1s1-.45 1-1V6c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1h-5c-.55 0-1 .45-1 1s.45 1 1 1h6c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-.62-.19-1.2-.51-1.68C2.95 18.52 2.04 18 1 18zm1.14-3.91c-.6-.1-1.14.39-1.14 1 0 .49.36.9.85.98 2.08.36 3.72 2 4.08 4.08.08.49.49.85.98.85.61 0 1.09-.54 1-1.14-.48-2.96-2.82-5.29-5.77-5.77zm-.04-4.04c-.59-.05-1.1.41-1.1 1 0 .51.38.94.88.99 4.27.41 7.67 3.81 8.08 8.08.05.5.48.87.99.87.6 0 1.06-.52 1-1.11-.53-5.19-4.66-9.31-9.85-9.83z"
	}), 'CastConnectedRounded');
	
	exports.default = _default;

/***/ },
/* 1969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm18-7H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19V7zM1 10v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm22-7H1v5h2V5h18v14h-7v2h9V3z"
	}), 'CastConnectedSharp');
	
	exports.default = _default;

/***/ },
/* 1970 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17 9H5.95c2.83 1.17 5.15 3.3 6.56 6H17V9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 7v1.63c.32.1.63.24.95.37H17v6h-4.49c.15.29.29.58.42.88.16.36.31.74.44 1.12H19V7H5z"
	})), 'CastConnectedTwoTone');
	
	exports.default = _default;

/***/ },
/* 1971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  transform: "scale(0.5, 0.5)",
	  d: "M42 6H6c-2.2 0-4 1.8-4 4v6h4v-6h36v28H28v4h14c2.2 0 4-1.8 4-4V10c0-2.2-1.8-4-4-4zM2 36v6h6c0-3.32-2.68-6-6-6zm0-8v4c5.52 0 10 4.48 10 10h4c0-7.74-6.26-14-14-14zm0-8v4c9.94 0 18 8.06 18 18h4c0-12.16-9.86-22-22-22zm20 2.18v4L29 30l7-3.82v-4L29 26l-7-3.82zM29 12l-11 6 11 6 11-6-11-6z"
	}), 'CastForEducation');
	
	exports.default = _default;

/***/ },
/* 1972 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm10 1.09v2L14.5 15l3.5-1.91v-2L14.5 13 11 11.09zM14.5 6L9 9l5.5 3L20 9l-5.5-3z"
	})), 'CastForEducationOutlined');
	
	exports.default = _default;

/***/ },
/* 1973 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.2 8.56l-4.22-2.3c-.3-.16-.66-.16-.96 0L9.8 8.56c-.35.19-.35.69 0 .88l4.22 2.3c.3.16.66.16.96 0l4.22-2.3c.34-.19.34-.69 0-.88zM21 3H3c-1.1 0-2 .9-2 2v2c0 .55.45 1 1 1s1-.45 1-1V6c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1h-5c-.55 0-1 .45-1 1s.45 1 1 1h6c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6.98 9.74L11 11.09v1.41c0 .37.2.7.52.88l2.5 1.36c.3.16.66.16.96 0l2.5-1.36c.32-.18.52-.52.52-.88v-1.41l-3.02 1.65c-.3.16-.66.16-.96 0zM1 18v3h3c0-1.66-1.34-3-3-3zm1.14-3.91c-.6-.1-1.14.39-1.14 1 0 .49.36.9.85.98 2.08.36 3.72 2 4.08 4.08.08.49.49.85.98.85.61 0 1.09-.54 1-1.14-.48-2.96-2.82-5.29-5.77-5.77zm-.04-4.04c-.59-.05-1.1.41-1.1 1 0 .51.38.94.88.99 4.27.41 7.67 3.81 8.08 8.08.05.5.48.87.99.87.6 0 1.06-.52 1-1.11-.53-5.19-4.66-9.31-9.85-9.83z"
	}), 'CastForEducationRounded');
	
	exports.default = _default;

/***/ },
/* 1974 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M23 3H1v5h2V5h18v14h-7v2h9V3zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm10 1.09v2L14.5 15l3.5-1.91v-2L14.5 13 11 11.09zM14.5 6L9 9l5.5 3L20 9l-5.5-3z"
	})), 'CastForEducationSharp');
	
	exports.default = _default;

/***/ },
/* 1975 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm10 1.09v2L14.5 15l3.5-1.91v-2L14.5 13 11 11.09zM14.5 6L9 9l5.5 3L20 9l-5.5-3z"
	})), 'CastForEducationTwoTone');
	
	exports.default = _default;

/***/ },
/* 1976 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z"
	}), 'CastOutlined');
	
	exports.default = _default;

/***/ },
/* 1977 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v2c0 .55.45 1 1 1s1-.45 1-1V6c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1h-5c-.55 0-1 .45-1 1s.45 1 1 1h6c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM2.14 14.09c-.6-.1-1.14.39-1.14 1 0 .49.36.9.85.98 2.08.36 3.72 2 4.08 4.08.08.49.49.85.98.85.61 0 1.09-.54 1-1.14-.48-2.96-2.82-5.29-5.77-5.77zM1 18v3h3c0-1.66-1.34-3-3-3zm1.1-7.95c-.59-.05-1.1.41-1.1 1 0 .51.38.94.88.99 4.27.41 7.67 3.81 8.08 8.08.05.5.48.87.99.87.6 0 1.06-.52 1-1.11-.53-5.19-4.66-9.31-9.85-9.83z"
	}), 'CastRounded');
	
	exports.default = _default;

/***/ },
/* 1978 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 3H1v5h2V5h18v14h-7v2h9V3zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z"
	}), 'CastSharp');
	
	exports.default = _default;

/***/ },
/* 1979 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z"
	}), 'CastTwoTone');
	
	exports.default = _default;

/***/ },
/* 1980 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2l-5.5 9h11z"
	}), _react.default.createElement("circle", {
	  cx: "17.5",
	  cy: "17.5",
	  r: "4.5"
	}), _react.default.createElement("path", {
	  d: "M3 13.5h8v8H3z"
	})), 'Category');
	
	exports.default = _default;

/***/ },
/* 1981 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2l-5.5 9h11L12 2zm0 3.84L13.93 9h-3.87L12 5.84zM17.5 13c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 7c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM3 21.5h8v-8H3v8zm2-6h4v4H5v-4z"
	}), 'CategoryOutlined');
	
	exports.default = _default;

/***/ },
/* 1982 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.15 3.4L7.43 9.48c-.41.66.07 1.52.85 1.52h7.43c.78 0 1.26-.86.85-1.52L12.85 3.4c-.39-.64-1.31-.64-1.7 0z"
	}), _react.default.createElement("circle", {
	  cx: "17.5",
	  cy: "17.5",
	  r: "4.5"
	}), _react.default.createElement("path", {
	  d: "M4 21.5h6c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1z"
	})), 'CategoryRounded');
	
	exports.default = _default;

/***/ },
/* 1983 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2l-5.5 9h11z"
	}), _react.default.createElement("circle", {
	  cx: "17.5",
	  cy: "17.5",
	  r: "4.5"
	}), _react.default.createElement("path", {
	  d: "M3 13.5h8v8H3z"
	})), 'CategorySharp');
	
	exports.default = _default;

/***/ },
/* 1984 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "17.5",
	  cy: "17.5",
	  r: "2.5",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 15.5h4v4H5zm7-9.66L10.07 9h3.86z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2l-5.5 9h11L12 2zm0 3.84L13.93 9h-3.87L12 5.84zM17.5 13c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 7c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM11 13.5H3v8h8v-8zm-2 6H5v-4h4v4z"
	})), 'CategoryTwoTone');
	
	exports.default = _default;

/***/ },
/* 1985 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M6 22h16V6L6 22z"
	}), _react.default.createElement("path", {
	  d: "M18 10L6 22h12V10zM3.93 5.93l1.29 1.29c3.19-3.19 8.38-3.19 11.57 0l1.29-1.29c-3.91-3.91-10.25-3.91-14.15 0zm5.14 5.14L11 13l1.93-1.93c-1.07-1.06-2.79-1.06-3.86 0zM6.5 8.5l1.29 1.29c1.77-1.77 4.65-1.77 6.43 0L15.5 8.5c-2.48-2.48-6.52-2.48-9 0z"
	})), 'CellWifi');
	
	exports.default = _default;

/***/ },
/* 1986 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 10.78V20h-9.22L20 10.78m2-4.81L6 22h16V5.97z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 9.98L6 22h12V9.98zM3.93 5.93l1.29 1.29c3.19-3.19 8.38-3.19 11.57 0l1.29-1.29c-3.91-3.91-10.25-3.91-14.15 0zm5.14 5.14L11 13l1.93-1.93c-1.07-1.06-2.79-1.06-3.86 0zM6.5 8.5l1.29 1.29c1.77-1.77 4.65-1.77 6.43 0L15.5 8.5c-2.48-2.48-6.52-2.48-9 0z"
	})), 'CellWifiOutlined');
	
	exports.default = _default;

/***/ },
/* 1987 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M8.41 22H20c1.1 0 2-.9 2-2V8.39c0-.89-1.08-1.34-1.71-.71L7.7 20.29c-.63.63-.18 1.71.71 1.71z"
	}), _react.default.createElement("path", {
	  d: "M7.71 20.29c-.63.63-.19 1.71.7 1.71H18V9.98L7.71 20.29zm1.36-9.22L11 13l1.93-1.93c-1.07-1.06-2.79-1.06-3.86 0zm-.7-1.77c1.57-1.12 3.7-1.12 5.27 0 .36.26.85.22 1.16-.1.39-.39.35-1.06-.1-1.38-2.2-1.57-5.19-1.57-7.4 0-.45.32-.5.99-.1 1.38.32.32.81.36 1.17.1zm7.84-2.61c.34.28.83.28 1.14-.03l.12-.12c.35-.35.31-.92-.08-1.24-3.67-3.05-9.02-3.07-12.7-.06-.43.35-.47.99-.08 1.37.32.33.84.37 1.19.08 3.01-2.48 7.4-2.48 10.41 0z"
	})), 'CellWifiRounded');
	
	exports.default = _default;

/***/ },
/* 1988 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M6 22h16V5.97L6 22z"
	}), _react.default.createElement("path", {
	  d: "M18 9.98L6 22h12V9.98zM3.93 5.93l1.29 1.29c3.19-3.19 8.38-3.19 11.57 0l1.29-1.29c-3.91-3.91-10.25-3.91-14.15 0zm5.14 5.14L11 13l1.93-1.93c-1.07-1.06-2.79-1.06-3.86 0zM6.5 8.5l1.29 1.29c1.77-1.77 4.65-1.77 6.43 0L15.5 8.5c-2.48-2.48-6.52-2.48-9 0z"
	})), 'CellWifiSharp');
	
	exports.default = _default;

/***/ },
/* 1989 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M22 5.97l-4 4.01v2.8l2-2V20h-2v2h4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9.07 11.07L11 13l1.93-1.93c-1.07-1.06-2.79-1.06-3.86 0zm9.01-5.14c-3.91-3.91-10.25-3.91-14.15 0l1.29 1.29c3.19-3.19 8.38-3.19 11.57 0l1.29-1.29zM15.5 8.5c-2.48-2.48-6.52-2.48-9 0l1.29 1.29c1.77-1.77 4.65-1.77 6.43 0L15.5 8.5zm2.5 4.28v-2.8L6 22h12v-2.05z"
	})), 'CellWifiTwoTone');
	
	exports.default = _default;

/***/ },
/* 1990 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-7 7H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"
	}), 'CenterFocusStrong');
	
	exports.default = _default;

/***/ },
/* 1991 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5 5-2.24 5-5zm-5 3c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm-7 0H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"
	}), 'CenterFocusStrongOutlined');
	
	exports.default = _default;

/***/ },
/* 1992 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-8 7c-.55 0-1 .45-1 1v3c0 1.1.9 2 2 2h3c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1-.45-1-1v-2c0-.55-.45-1-1-1zm1-9c0-.55.45-1 1-1h2c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.1 0-2 .9-2 2v3c0 .55.45 1 1 1s1-.45 1-1V6zm14-3h-3c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1 .45 1 1v2c0 .55.45 1 1 1s1-.45 1-1V5c0-1.1-.9-2-2-2zm0 15c0 .55-.45 1-1 1h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c1.1 0 2-.9 2-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v2z"
	}), 'CenterFocusStrongRounded');
	
	exports.default = _default;

/***/ },
/* 1993 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-7 7H3v6h6v-2H5v-4zM5 5h4V3H3v6h2V5zm16-2h-6v2h4v4h2V3zm-2 16h-4v2h6v-6h-2v4z"
	}), 'CenterFocusStrongSharp');
	
	exports.default = _default;

/***/ },
/* 1994 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "3",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M7 12c0 2.76 2.24 5 5 5s5-2.24 5-5-2.24-5-5-5-5 2.24-5 5zm8 0c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3 3 1.35 3 3zM3 19c0 1.1.9 2 2 2h4v-2H5v-4H3v4zM3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm18 0c0-1.1-.9-2-2-2h-4v2h4v4h2V5zm-2 14h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"
	})), 'CenterFocusStrongTwoTone');
	
	exports.default = _default;

/***/ },
/* 1995 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'CenterFocusWeak');
	
	exports.default = _default;

/***/ },
/* 1996 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm7 3c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm7-11h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"
	}), 'CenterFocusWeakOutlined');
	
	exports.default = _default;

/***/ },
/* 1997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 15c-.55 0-1 .45-1 1v3c0 1.1.9 2 2 2h3c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1-.45-1-1v-2c0-.55-.45-1-1-1zm1-9c0-.55.45-1 1-1h2c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.1 0-2 .9-2 2v3c0 .55.45 1 1 1s1-.45 1-1V6zm14-3h-3c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1 .45 1 1v2c0 .55.45 1 1 1s1-.45 1-1V5c0-1.1-.9-2-2-2zm0 15c0 .55-.45 1-1 1h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c1.1 0 2-.9 2-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v2zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'CenterFocusWeakRounded');
	
	exports.default = _default;

/***/ },
/* 1998 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 15H3v6h6v-2H5v-4zM5 5h4V3H3v6h2V5zm16-2h-6v2h4v4h2V3zm-2 16h-4v2h6v-6h-2v4zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'CenterFocusWeakSharp');
	
	exports.default = _default;

/***/ },
/* 1999 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 19c0 1.1.9 2 2 2h4v-2H5v-4H3v4zM3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm9 3c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm9-9c0-1.1-.9-2-2-2h-4v2h4v4h2V5zm-2 14h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"
	})), 'CenterFocusWeakTwoTone');
	
	exports.default = _default;

/***/ },
/* 2000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z"
	}), 'ChangeHistory');
	
	exports.default = _default;

/***/ },
/* 2001 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z"
	}), 'ChangeHistoryOutlined');
	
	exports.default = _default;

/***/ },
/* 2002 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7.77L18.39 18H5.61L12 7.77m-.85-2.41l-8.2 13.11c-.41.67.07 1.53.85 1.53h16.4c.79 0 1.26-.86.85-1.53l-8.2-13.11c-.39-.63-1.31-.63-1.7 0z"
	}), 'ChangeHistoryRounded');
	
	exports.default = _default;

/***/ },
/* 2003 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z"
	}), 'ChangeHistorySharp');
	
	exports.default = _default;

/***/ },
/* 2004 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 7.77L5.61 18h12.78z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 4L2 20h20L12 4zm0 3.77L18.39 18H5.61L12 7.77z"
	})), 'ChangeHistoryTwoTone');
	
	exports.default = _default;

/***/ },
/* 2005 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
	}), 'Chat');
	
	exports.default = _default;

/***/ },
/* 2006 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
	}), 'ChatBubble');
	
	exports.default = _default;

/***/ },
/* 2007 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
	}), 'ChatBubbleOutline');
	
	exports.default = _default;

/***/ },
/* 2008 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
	}), 'ChatBubbleOutlineOutlined');
	
	exports.default = _default;

/***/ },
/* 2009 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 14H6l-2 2V5c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1z"
	}), 'ChatBubbleOutlineRounded');
	
	exports.default = _default;

/***/ },
/* 2010 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H2v20l4-4h16V2zm-2 14H6l-2 2V4h16v12z"
	}), 'ChatBubbleOutlineSharp');
	
	exports.default = _default;

/***/ },
/* 2011 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
	}), 'ChatBubbleOutlineTwoTone');
	
	exports.default = _default;

/***/ },
/* 2012 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
	}), 'ChatBubbleOutlined');
	
	exports.default = _default;

/***/ },
/* 2013 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
	}), 'ChatBubbleRounded');
	
	exports.default = _default;

/***/ },
/* 2014 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H2v20l4-4h16V2z"
	}), 'ChatBubbleSharp');
	
	exports.default = _default;

/***/ },
/* 2015 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 18l2-2h14V4H4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
	})), 'ChatBubbleTwoTone');
	
	exports.default = _default;

/***/ },
/* 2016 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 4h16v12H5.17L4 17.17V4m0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4zm2 10h8v2H6v-2zm0-3h12v2H6V9zm0-3h12v2H6V6z"
	}), 'ChatOutlined');
	
	exports.default = _default;

/***/ },
/* 2017 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM7 9h10c.55 0 1 .45 1 1s-.45 1-1 1H7c-.55 0-1-.45-1-1s.45-1 1-1zm6 5H7c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1zm4-6H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'ChatRounded');
	
	exports.default = _default;

/***/ },
/* 2018 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H2.01L2 22l4-4h16V2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
	}), 'ChatSharp');
	
	exports.default = _default;

/***/ },
/* 2019 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 4H4v13.17L5.17 16H20V4zm-6 10H6v-2h8v2zm4-3H6V9h12v2zm0-3H6V6h12v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 18c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14zm-16-.83V4h16v12H5.17L4 17.17zM6 12h8v2H6zm0-3h12v2H6zm0-3h12v2H6z"
	})), 'ChatTwoTone');
	
	exports.default = _default;

/***/ },
/* 2020 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
	}), 'Check');
	
	exports.default = _default;

/***/ },
/* 2021 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
	}), 'CheckBox');
	
	exports.default = _default;

/***/ },
/* 2022 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'CheckBoxOutlineBlank');
	
	exports.default = _default;

/***/ },
/* 2023 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'CheckBoxOutlineBlankOutlined');
	
	exports.default = _default;

/***/ },
/* 2024 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 19H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zm1-16H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'CheckBoxOutlineBlankRounded');
	
	exports.default = _default;

/***/ },
/* 2025 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5v14H5V5h14m2-2H3v18h18V3z"
	}), 'CheckBoxOutlineBlankSharp');
	
	exports.default = _default;

/***/ },
/* 2026 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'CheckBoxOutlineBlankTwoTone');
	
	exports.default = _default;

/***/ },
/* 2027 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM17.99 9l-1.41-1.42-6.59 6.59-2.58-2.57-1.42 1.41 4 3.99z"
	}), 'CheckBoxOutlined');
	
	exports.default = _default;

/***/ },
/* 2028 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8.29 13.29c-.39.39-1.02.39-1.41 0L5.71 12.7a.9959.9959 0 010-1.41c.39-.39 1.02-.39 1.41 0L10 14.17l6.88-6.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-7.58 7.59z"
	}), 'CheckBoxRounded');
	
	exports.default = _default;

/***/ },
/* 2029 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zM10 17l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
	}), 'CheckBoxSharp');
	
	exports.default = _default;

/***/ },
/* 2030 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14V5H5v14zm2.41-7.4l2.58 2.58 6.59-6.59L17.99 9l-8 8L6 13.01l1.41-1.41z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM17.99 9l-1.41-1.42-6.59 6.59-2.58-2.57-1.42 1.41 4 3.99z"
	})), 'CheckBoxTwoTone');
	
	exports.default = _default;

/***/ },
/* 2031 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
	}), 'CheckCircle');
	
	exports.default = _default;

/***/ },
/* 2032 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'CheckCircleOutline');
	
	exports.default = _default;

/***/ },
/* 2033 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"
	}), 'CheckCircleOutlineOutlined');
	
	exports.default = _default;

/***/ },
/* 2034 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.88-11.71L10 14.17l-1.88-1.88a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l2.59 2.59c.39.39 1.02.39 1.41 0L17.3 9.7c.39-.39.39-1.02 0-1.41-.39-.39-1.03-.39-1.42 0z"
	}), 'CheckCircleOutlineRounded');
	
	exports.default = _default;

/***/ },
/* 2035 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"
	}), 'CheckCircleOutlineSharp');
	
	exports.default = _default;

/***/ },
/* 2036 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"
	}), 'CheckCircleOutlineTwoTone');
	
	exports.default = _default;

/***/ },
/* 2037 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"
	}), 'CheckCircleOutlined');
	
	exports.default = _default;

/***/ },
/* 2038 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM9.29 16.29L5.7 12.7a.9959.9959 0 010-1.41c.39-.39 1.02-.39 1.41 0L10 14.17l6.88-6.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-7.59 7.59c-.38.39-1.02.39-1.41 0z"
	}), 'CheckCircleRounded');
	
	exports.default = _default;

/***/ },
/* 2039 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
	}), 'CheckCircleSharp');
	
	exports.default = _default;

/***/ },
/* 2040 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm-2 13l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"
	})), 'CheckCircleTwoTone');
	
	exports.default = _default;

/***/ },
/* 2041 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
	}), 'CheckOutlined');
	
	exports.default = _default;

/***/ },
/* 2042 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 16.17L5.53 12.7a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l4.18 4.18c.39.39 1.02.39 1.41 0L20.29 7.71c.39-.39.39-1.02 0-1.41a.9959.9959 0 00-1.41 0L9 16.17z"
	}), 'CheckRounded');
	
	exports.default = _default;

/***/ },
/* 2043 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
	}), 'CheckSharp');
	
	exports.default = _default;

/***/ },
/* 2044 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
	}), 'CheckTwoTone');
	
	exports.default = _default;

/***/ },
/* 2045 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
	}), 'ChevronLeft');
	
	exports.default = _default;

/***/ },
/* 2046 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z"
	}), 'ChevronLeftOutlined');
	
	exports.default = _default;

/***/ },
/* 2047 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.71 6.71a.9959.9959 0 00-1.41 0L8.71 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L10.83 12l3.88-3.88c.39-.39.38-1.03 0-1.41z"
	}), 'ChevronLeftRounded');
	
	exports.default = _default;

/***/ },
/* 2048 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z"
	}), 'ChevronLeftSharp');
	
	exports.default = _default;

/***/ },
/* 2049 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z"
	}), 'ChevronLeftTwoTone');
	
	exports.default = _default;

/***/ },
/* 2050 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
	}), 'ChevronRight');
	
	exports.default = _default;

/***/ },
/* 2051 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"
	}), 'ChevronRightOutlined');
	
	exports.default = _default;

/***/ },
/* 2052 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.29 6.71c-.39.39-.39 1.02 0 1.41L13.17 12l-3.88 3.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L10.7 6.7c-.38-.38-1.02-.38-1.41.01z"
	}), 'ChevronRightRounded');
	
	exports.default = _default;

/***/ },
/* 2053 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"
	}), 'ChevronRightSharp');
	
	exports.default = _default;

/***/ },
/* 2054 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"
	}), 'ChevronRightTwoTone');
	
	exports.default = _default;

/***/ },
/* 2055 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "14.5",
	  cy: "10.5",
	  r: "1.25"
	}), _react.default.createElement("circle", {
	  cx: "9.5",
	  cy: "10.5",
	  r: "1.25"
	}), _react.default.createElement("path", {
	  d: "M22.94 12.66c.04-.21.06-.43.06-.66s-.02-.45-.06-.66c-.25-1.51-1.36-2.74-2.81-3.17-.53-1.12-1.28-2.1-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91-1.45.43-2.56 1.65-2.81 3.17-.04.21-.06.43-.06.66s.02.45.06.66c.25 1.51 1.36 2.74 2.81 3.17.52 1.11 1.27 2.09 2.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89 1.44-.43 2.55-1.65 2.8-3.17zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2zM7.5 14c.76 1.77 2.49 3 4.5 3s3.74-1.23 4.5-3h-9z"
	})), 'ChildCare');
	
	exports.default = _default;

/***/ },
/* 2056 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "14.5",
	  cy: "10.5",
	  r: "1.25"
	}), _react.default.createElement("circle", {
	  cx: "9.5",
	  cy: "10.5",
	  r: "1.25"
	}), _react.default.createElement("path", {
	  d: "M22.94 11.34c-.25-1.51-1.36-2.74-2.81-3.17-.53-1.12-1.28-2.1-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91-1.45.43-2.56 1.65-2.81 3.17-.04.21-.06.43-.06.66 0 .23.02.45.06.66.25 1.51 1.36 2.74 2.81 3.17.52 1.11 1.27 2.09 2.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89 1.44-.43 2.55-1.65 2.8-3.17.04-.21.06-.43.06-.66 0-.23-.02-.45-.06-.66zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2zm-7 3c2.01 0 3.74-1.23 4.5-3h-9c.76 1.77 2.49 3 4.5 3z"
	})), 'ChildCareOutlined');
	
	exports.default = _default;

/***/ },
/* 2057 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "14.5",
	  cy: "10.5",
	  r: "1.25"
	}), _react.default.createElement("circle", {
	  cx: "9.5",
	  cy: "10.5",
	  r: "1.25"
	}), _react.default.createElement("path", {
	  d: "M16.1 14H7.9c-.19 0-.32.2-.23.37C8.5 15.94 10.13 17 12 17s3.5-1.06 4.33-2.63c.08-.17-.05-.37-.23-.37zm6.84-2.66c-.25-1.51-1.36-2.74-2.81-3.17-.53-1.12-1.28-2.1-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91-1.45.43-2.56 1.65-2.81 3.17-.04.21-.06.43-.06.66 0 .23.02.45.06.66.25 1.51 1.36 2.74 2.81 3.17.52 1.11 1.27 2.09 2.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89 1.44-.43 2.55-1.65 2.8-3.17.04-.21.06-.43.06-.66 0-.23-.02-.45-.06-.66zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2z"
	})), 'ChildCareRounded');
	
	exports.default = _default;

/***/ },
/* 2058 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "14.5",
	  cy: "10.5",
	  r: "1.25"
	}), _react.default.createElement("circle", {
	  cx: "9.5",
	  cy: "10.5",
	  r: "1.25"
	}), _react.default.createElement("path", {
	  d: "M12 17c2.01 0 3.74-1.23 4.5-3h-9c.76 1.77 2.49 3 4.5 3zm10.94-5.66c-.25-1.51-1.36-2.74-2.81-3.17-.53-1.12-1.28-2.1-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91-1.45.43-2.56 1.65-2.81 3.17-.04.21-.06.43-.06.66 0 .23.02.45.06.66.25 1.51 1.36 2.74 2.81 3.17.52 1.11 1.27 2.09 2.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89 1.44-.43 2.55-1.65 2.8-3.17.04-.21.06-.43.06-.66 0-.23-.02-.45-.06-.66zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2z"
	})), 'ChildCareSharp');
	
	exports.default = _default;

/***/ },
/* 2059 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 10c-.1 0-.19.02-.29.03-.2-.67-.49-1.29-.86-1.86C16.6 6.26 14.45 5 12 5S7.4 6.26 6.15 8.17c-.37.57-.66 1.19-.86 1.86-.1-.01-.19-.03-.29-.03-1.1 0-2 .9-2 2s.9 2 2 2c.1 0 .19-.02.29-.03.2.67.49 1.29.86 1.86C7.4 17.74 9.55 19 12 19s4.6-1.26 5.85-3.17c.37-.57.66-1.19.86-1.86.1.01.19.03.29.03 1.1 0 2-.9 2-2s-.9-2-2-2zm-4.5-.75c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25zm-5 0c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25zM12 17c-2.01 0-3.74-1.23-4.5-3h9c-.76 1.77-2.49 3-4.5 3z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "14.5",
	  cy: "10.5",
	  r: "1.25"
	}), _react.default.createElement("circle", {
	  cx: "9.5",
	  cy: "10.5",
	  r: "1.25"
	}), _react.default.createElement("path", {
	  d: "M12 17c2.01 0 3.74-1.23 4.5-3h-9c.76 1.77 2.49 3 4.5 3zm10.94-5.66c-.25-1.51-1.36-2.74-2.81-3.17-.53-1.12-1.28-2.1-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91-1.45.43-2.56 1.65-2.81 3.17-.04.21-.06.43-.06.66 0 .23.02.45.06.66.25 1.51 1.36 2.74 2.81 3.17.52 1.11 1.27 2.09 2.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89 1.44-.43 2.55-1.65 2.8-3.17.04-.21.06-.43.06-.66 0-.23-.02-.45-.06-.66zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2z"
	})), 'ChildCareTwoTone');
	
	exports.default = _default;

/***/ },
/* 2060 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 2v8h8c0-4.42-3.58-8-8-8zm6.32 13.89C20.37 14.54 21 12.84 21 11H6.44l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20z"
	}), 'ChildFriendly');
	
	exports.default = _default;

/***/ },
/* 2061 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 2v8h8c0-4.42-3.58-8-8-8zm2 6V4.34c1.7.6 3.05 1.95 3.66 3.66H15zm-8.56 3l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61C20.37 14.54 21 12.84 21 11H6.44zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20zm.74-5.34l-.29.37c-.14-.02-.3-.03-.45-.03-1.39 0-2.6.82-3.16 2h-2.68c-.5-1.04-1.5-1.8-2.68-1.97l-.44-.67c-.1-.17-.34-.69-.67-1.36h11.29c-.21.59-.52 1.15-.92 1.66z"
	}), 'ChildFriendlyOutlined');
	
	exports.default = _default;

/***/ },
/* 2062 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 3.08V10h8c0-4.03-2.98-7.37-6.86-7.92-.6-.09-1.14.39-1.14 1zm6.32 12.81C20.37 14.54 21 12.84 21 11H6.44l-.68-1.43C5.6 9.22 5.24 9 4.86 9H3c-.55 0-1 .45-1 1s.45 1 1 1h1.22s1.89 4.07 2.12 4.42c-1.33.71-2.14 2.27-1.74 3.94.3 1.26 1.34 2.27 2.6 2.55 2.1.46 3.98-.96 4.25-2.91h2.08c.27 1.94 2.14 3.36 4.22 2.92 1.27-.27 2.31-1.27 2.63-2.53.35-1.39-.14-2.68-1.06-3.5zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20z"
	}), 'ChildFriendlyRounded');
	
	exports.default = _default;

/***/ },
/* 2063 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 2v8h8c0-4.42-3.58-8-8-8zm6.32 13.89C20.37 14.54 21 12.84 21 11H6.44l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20z"
	}), 'ChildFriendlySharp');
	
	exports.default = _default;

/***/ },
/* 2064 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15 4.34V8h3.66C18.05 6.3 16.7 4.95 15 4.34zM8.04 14.36l.44.67c1.19.16 2.19.92 2.68 1.97h2.68c.56-1.18 1.77-2 3.16-2 .15 0 .31.01.46.03l.29-.37c.4-.51.7-1.07.92-1.66H7.37c.32.67.57 1.19.67 1.36z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M13 2v8h8c0-4.42-3.58-8-8-8zm2 6V4.34c1.7.6 3.05 1.95 3.66 3.66H15zm-8.56 3l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61C20.37 14.54 21 12.84 21 11H6.44zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20zm.74-5.34l-.29.37c-.14-.02-.3-.03-.45-.03-1.39 0-2.6.82-3.16 2h-2.68c-.5-1.04-1.5-1.8-2.68-1.97l-.44-.67c-.1-.17-.34-.69-.67-1.36h11.29c-.21.59-.52 1.15-.92 1.66z"
	})), 'ChildFriendlyTwoTone');
	
	exports.default = _default;

/***/ },
/* 2065 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 12h7v1.5h-7zm0-2.5h7V11h-7zm0 5h7V16h-7zM21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15h-9V6h9v13z"
	}), 'ChromeReaderMode');
	
	exports.default = _default;

/***/ },
/* 2066 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM3 19V6h8v13H3zm18 0h-8V6h8v13zm-7-9.5h6V11h-6zm0 2.5h6v1.5h-6zm0 2.5h6V16h-6z"
	}), 'ChromeReaderModeOutlined');
	
	exports.default = _default;

/***/ },
/* 2067 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14c0 .55-.45 1-1 1h-8V6h8c.55 0 1 .45 1 1v11zm-1.75-8.5h-5.5c-.41 0-.75.34-.75.75s.34.75.75.75h5.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75zm0 2.5h-5.5c-.41 0-.75.34-.75.75s.34.75.75.75h5.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75zm0 2.5h-5.5c-.41 0-.75.34-.75.75s.34.75.75.75h5.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75z"
	}), 'ChromeReaderModeRounded');
	
	exports.default = _default;

/***/ },
/* 2068 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 12h7v1.5h-7V12zm0-2.5h7V11h-7V9.5zm0 5h7V16h-7v-1.5zM23 4H1v17h22V4zm-2 15h-9V6h9v13z"
	}), 'ChromeReaderModeSharp');
	
	exports.default = _default;

/***/ },
/* 2069 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 6h8v13H3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM11 19H3V6h8v13zm10 0h-8V6h8v13zm-7-9.5h6V11h-6zm0 2.5h6v1.5h-6zm0 2.5h6V16h-6z"
	})), 'ChromeReaderModeTwoTone');
	
	exports.default = _default;

/***/ },
/* 2070 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"
	}), 'Class');
	
	exports.default = _default;

/***/ },
/* 2071 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 4h2v5l-1-.75L9 9V4zm9 16H6V4h1v9l3-2.25L13 13V4h5v16z"
	}), 'ClassOutlined');
	
	exports.default = _default;

/***/ },
/* 2072 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"
	}), 'ClassRounded');
	
	exports.default = _default;

/***/ },
/* 2073 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4v20h16V2zM6 4h5v8l-2.5-1.5L6 12V4z"
	}), 'ClassSharp');
	
	exports.default = _default;

/***/ },
/* 2074 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M13 13l-3-2.25L7 13V4H6v16h12V4h-5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 4h2v5l-1-.75L9 9V4zm9 16H6V4h1v9l3-2.25L13 13V4h5v16z"
	})), 'ClassTwoTone');
	
	exports.default = _default;

/***/ },
/* 2075 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
	}), 'Clear');
	
	exports.default = _default;

/***/ },
/* 2076 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z"
	}), 'ClearAll');
	
	exports.default = _default;

/***/ },
/* 2077 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z"
	}), 'ClearAllOutlined');
	
	exports.default = _default;

/***/ },
/* 2078 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 13h12c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1zm-2 4h12c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm3-9c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1z"
	}), 'ClearAllRounded');
	
	exports.default = _default;

/***/ },
/* 2079 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z"
	}), 'ClearAllSharp');
	
	exports.default = _default;

/***/ },
/* 2080 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 11h14v2H5zm-2 4h14v2H3zm4-8h14v2H7z"
	}), 'ClearAllTwoTone');
	
	exports.default = _default;

/***/ },
/* 2081 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
	}), 'ClearOutlined');
	
	exports.default = _default;

/***/ },
/* 2082 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.3 5.71a.9959.9959 0 00-1.41 0L12 10.59 7.11 5.7a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
	}), 'ClearRounded');
	
	exports.default = _default;

/***/ },
/* 2083 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
	}), 'ClearSharp');
	
	exports.default = _default;

/***/ },
/* 2084 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
	}), 'ClearTwoTone');
	
	exports.default = _default;

/***/ },
/* 2085 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
	}), 'Close');
	
	exports.default = _default;

/***/ },
/* 2086 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
	}), 'CloseOutlined');
	
	exports.default = _default;

/***/ },
/* 2087 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.3 5.71a.9959.9959 0 00-1.41 0L12 10.59 7.11 5.7a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
	}), 'CloseRounded');
	
	exports.default = _default;

/***/ },
/* 2088 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
	}), 'CloseSharp');
	
	exports.default = _default;

/***/ },
/* 2089 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
	}), 'CloseTwoTone');
	
	exports.default = _default;

/***/ },
/* 2090 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z"
	}), 'ClosedCaption');
	
	exports.default = _default;

/***/ },
/* 2091 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12zM7 15h3c.55 0 1-.45 1-1v-1H9.5v.5h-2v-3h2v.5H11v-1c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm7 0h3c.55 0 1-.45 1-1v-1h-1.5v.5h-2v-3h2v.5H18v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1z"
	}), 'ClosedCaptionOutlined');
	
	exports.default = _default;

/***/ },
/* 2092 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 6.5c0 .28-.22.5-.5.5H10c-.28 0-.5-.22-.5-.5h-2v3h2c0-.28.22-.5.5-.5h.5c.28 0 .5.22.5.5v.5c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v.5zm7 0c0 .28-.22.5-.5.5H17c-.28 0-.5-.22-.5-.5h-2v3h2c0-.28.22-.5.5-.5h.5c.28 0 .5.22.5.5v.5c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v.5z"
	}), 'ClosedCaptionRounded');
	
	exports.default = _default;

/***/ },
/* 2093 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 4H3v16h18V4zm-10 7H9.5v-.5h-2v3h2V13H11v2H6V9h5v2zm7 0h-1.5v-.5h-2v3h2V13H18v2h-5V9h5v2z"
	}), 'ClosedCaptionSharp');
	
	exports.default = _default;

/***/ },
/* 2094 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 6H5v12h14V6zm-8 5H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 20h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2zM5 6h14v12H5V6zm5 3H7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-1H9.5v.5h-2v-3h2v.5H11v-1c0-.55-.45-1-1-1zm7 0h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-1h-1.5v.5h-2v-3h2v.5H18v-1c0-.55-.45-1-1-1z"
	})), 'ClosedCaptionTwoTone');
	
	exports.default = _default;

/***/ },
/* 2095 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"
	}), 'Cloud');
	
	exports.default = _default;

/***/ },
/* 2096 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.5 14H8c-1.66 0-3-1.34-3-3s1.34-3 3-3l.14.01C8.58 8.28 10.13 7 12 7c2.21 0 4 1.79 4 4h.5c1.38 0 2.5 1.12 2.5 2.5S17.88 16 16.5 16z"
	}), 'CloudCircle');
	
	exports.default = _default;

/***/ },
/* 2097 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.29-9.81c-.4-2.01-2.16-3.52-4.29-3.52-1.69 0-3.15.96-3.88 2.36C6.36 9.21 5 10.7 5 12.5 5 14.43 6.57 16 8.5 16h7.58c1.61 0 2.92-1.31 2.92-2.92 0-1.54-1.2-2.79-2.71-2.89zM16 14H8.5c-.83 0-1.5-.67-1.5-1.5S7.67 11 8.5 11h.9l.49-1.05c.41-.79 1.22-1.28 2.11-1.28 1.13 0 2.11.8 2.33 1.91l.28 1.42H16c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'CloudCircleOutlined');
	
	exports.default = _default;

/***/ },
/* 2098 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.5 14H8c-1.66 0-3-1.34-3-3s1.34-3 3-3h.14c.44-1.73 1.99-3 3.86-3 2.21 0 4 1.79 4 4h.5c1.38 0 2.5 1.12 2.5 2.5S17.88 16 16.5 16z"
	}), 'CloudCircleRounded');
	
	exports.default = _default;

/***/ },
/* 2099 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.5 14H8c-1.66 0-3-1.34-3-3s1.34-3 3-3h.14c.44-1.73 1.99-3 3.86-3 2.21 0 4 1.79 4 4h.5c1.38 0 2.5 1.12 2.5 2.5S17.88 16 16.5 16z"
	}), 'CloudCircleSharp');
	
	exports.default = _default;

/***/ },
/* 2100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm4.08 12H8.5C6.57 16 5 14.43 5 12.5c0-1.8 1.36-3.29 3.12-3.48.73-1.4 2.19-2.36 3.88-2.36 2.12 0 3.89 1.51 4.29 3.52 1.52.1 2.71 1.35 2.71 2.89 0 1.62-1.31 2.93-2.92 2.93z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.29-9.81c-.4-2.01-2.16-3.52-4.29-3.52-1.69 0-3.15.96-3.88 2.36C6.36 9.21 5 10.7 5 12.5 5 14.43 6.57 16 8.5 16h7.58c1.61 0 2.92-1.31 2.92-2.92 0-1.54-1.2-2.79-2.71-2.89zM16 14H8.5c-.83 0-1.5-.67-1.5-1.5S7.67 11 8.5 11h.9l.49-1.05c.41-.79 1.22-1.28 2.11-1.28 1.13 0 2.11.8 2.33 1.91l.28 1.42H16c.55 0 1 .45 1 1s-.45 1-1 1z"
	})), 'CloudCircleTwoTone');
	
	exports.default = _default;

/***/ },
/* 2101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM10 17l-3.5-3.5 1.41-1.41L10 14.17 15.18 9l1.41 1.41L10 17z"
	}), 'CloudDone');
	
	exports.default = _default;

/***/ },
/* 2102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zm-9-3.82l-2.09-2.09L6.5 13.5 10 17l6.01-6.01-1.41-1.41z"
	}), 'CloudDoneOutlined');
	
	exports.default = _default;

/***/ },
/* 2103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zm-8.64 6.25c-.39.39-1.02.39-1.41 0L7.2 14.2a.9959.9959 0 010-1.41c.39-.39 1.02-.39 1.41 0L10 14.18l4.48-4.48c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-5.18 5.18z"
	}), 'CloudDoneRounded');
	
	exports.default = _default;

/***/ },
/* 2104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM10 17l-3.5-3.5 1.41-1.41L10 14.18 15.18 9l1.41 1.41L10 17z"
	}), 'CloudDoneSharp');
	
	exports.default = _default;

/***/ },
/* 2105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19.21 12.04l-1.53-.11-.3-1.5C16.88 7.86 14.62 6 12 6 9.94 6 8.08 7.14 7.12 8.96l-.5.95-1.07.11C3.53 10.24 2 11.95 2 14c0 2.21 1.79 4 4 4h13c1.65 0 3-1.35 3-3 0-1.55-1.22-2.86-2.79-2.96zM10 17l-3.5-3.5 1.41-1.41L10 14.18l4.6-4.6 1.41 1.41L10 17z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zm-9-3.82l-2.09-2.09L6.5 13.5 10 17l6.01-6.01-1.41-1.41z"
	})), 'CloudDoneTwoTone');
	
	exports.default = _default;

/***/ },
/* 2106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"
	}), 'CloudDownload');
	
	exports.default = _default;

/***/ },
/* 2107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zm-5.55-8h-2.9v3H8l4 4 4-4h-2.55z"
	}), 'CloudDownloadOutlined');
	
	exports.default = _default;

/***/ },
/* 2108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-4.65 4.65c-.2.2-.51.2-.71 0L7 13h3V9h4v4h3z"
	}), 'CloudDownloadRounded');
	
	exports.default = _default;

/***/ },
/* 2109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"
	}), 'CloudDownloadSharp');
	
	exports.default = _default;

/***/ },
/* 2110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19.21 12.04l-1.53-.11-.3-1.5C16.88 7.86 14.62 6 12 6 9.94 6 8.08 7.14 7.12 8.96l-.5.95-1.07.11C3.53 10.24 2 11.95 2 14c0 2.21 1.79 4 4 4h13c1.65 0 3-1.35 3-3 0-1.55-1.22-2.86-2.79-2.96zM12 17l-4-4h2.55v-3h2.91v3H16l-4 4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zm-5.55-8h-2.9v3H8l4 4 4-4h-2.55z"
	})), 'CloudDownloadTwoTone');
	
	exports.default = _default;

/***/ },
/* 2111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z"
	}), 'CloudOff');
	
	exports.default = _default;

/***/ },
/* 2112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M24 15c0-2.64-2.05-4.78-4.65-4.96C18.67 6.59 15.64 4 12 4c-1.33 0-2.57.36-3.65.97l1.49 1.49C10.51 6.17 11.23 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 .99-.48 1.85-1.21 2.4l1.41 1.41c1.09-.92 1.8-2.27 1.8-3.81zM4.41 3.86L3 5.27l2.77 2.77h-.42C2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h11.73l2 2 1.41-1.41L4.41 3.86zM6 18c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73l8 8H6z"
	}), 'CloudOffOutlined');
	
	exports.default = _default;

/***/ },
/* 2113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M24 15c0-2.64-2.05-4.78-4.65-4.96C18.67 6.59 15.64 4 12 4c-1.33 0-2.57.36-3.65.97l1.49 1.49C10.51 6.17 11.23 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 .99-.48 1.85-1.21 2.4l1.41 1.41c1.09-.92 1.8-2.27 1.8-3.81zM3.71 4.56c-.39.39-.39 1.02 0 1.41l2.06 2.06h-.42c-3.28.35-5.76 3.34-5.29 6.79C.46 17.84 3.19 20 6.22 20h11.51l1.29 1.29c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L5.12 4.56a.9959.9959 0 00-1.41 0zM6 18c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73l8 8H6z"
	}), 'CloudOffRounded');
	
	exports.default = _default;

/***/ },
/* 2114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M24 15c0-2.64-2.05-4.78-4.65-4.96C18.67 6.59 15.64 4 12 4c-1.33 0-2.57.36-3.65.97l1.49 1.49C10.51 6.17 11.23 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 .99-.48 1.85-1.21 2.4l1.41 1.41c1.09-.92 1.8-2.27 1.8-3.81zM4.41 3.86L3 5.27l2.77 2.77h-.42C2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h11.73l2 2 1.41-1.41L4.41 3.86zM6 18c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73l8 8H6z"
	}), 'CloudOffSharp');
	
	exports.default = _default;

/***/ },
/* 2115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M22 15c0-1.66-1.34-3-3-3h-1.5v-.5C17.5 8.46 15.04 6 12 6c-.77 0-1.49.17-2.16.46L20.79 17.4c.73-.55 1.21-1.41 1.21-2.4zM2 14c0 2.21 1.79 4 4 4h9.73l-8-8H6c-2.21 0-4 1.79-4 4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.33 0-2.57.36-3.65.97l1.49 1.49C10.51 6.17 11.23 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 .99-.48 1.85-1.21 2.4l1.41 1.41c1.09-.92 1.8-2.27 1.8-3.81 0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.77 2.77h-.42C2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h11.73l2 2 1.41-1.41L4.41 3.86 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z"
	})), 'CloudOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 2116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6m0-2C9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96C18.67 6.59 15.64 4 12 4z"
	}), 'CloudOutlined');
	
	exports.default = _default;

/***/ },
/* 2117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z"
	}), 'CloudQueue');
	
	exports.default = _default;

/***/ },
/* 2118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z"
	}), 'CloudQueueOutlined');
	
	exports.default = _default;

/***/ },
/* 2119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z"
	}), 'CloudQueueRounded');
	
	exports.default = _default;

/***/ },
/* 2120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z"
	}), 'CloudQueueSharp');
	
	exports.default = _default;

/***/ },
/* 2121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 12h-1.5v-.5C17.5 8.46 15.04 6 12 6c-2.52 0-4.63 1.69-5.29 4H6c-2.21 0-4 1.79-4 4s1.79 4 4 4h13c1.66 0 3-1.34 3-3s-1.34-3-3-3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z"
	})), 'CloudQueueTwoTone');
	
	exports.default = _default;

/***/ },
/* 2122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"
	}), 'CloudRounded');
	
	exports.default = _default;

/***/ },
/* 2123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"
	}), 'CloudSharp');
	
	exports.default = _default;

/***/ },
/* 2124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19.21 12.04l-1.53-.11-.3-1.5C16.88 7.86 14.62 6 12 6 9.94 6 8.08 7.14 7.12 8.96l-.5.95-1.07.11C3.53 10.24 2 11.95 2 14c0 2.21 1.79 4 4 4h13c1.65 0 3-1.35 3-3 0-1.55-1.22-2.86-2.79-2.96z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3z"
	})), 'CloudTwoTone');
	
	exports.default = _default;

/***/ },
/* 2125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
	}), 'CloudUpload');
	
	exports.default = _default;

/***/ },
/* 2126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z"
	}), 'CloudUploadOutlined');
	
	exports.default = _default;

/***/ },
/* 2127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l4.65-4.65c.2-.2.51-.2.71 0L17 13h-3z"
	}), 'CloudUploadRounded');
	
	exports.default = _default;

/***/ },
/* 2128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
	}), 'CloudUploadSharp');
	
	exports.default = _default;

/***/ },
/* 2129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19.21 12.04l-1.53-.11-.3-1.5C16.88 7.86 14.62 6 12 6 9.94 6 8.08 7.14 7.12 8.96l-.5.95-1.07.11C3.53 10.24 2 11.95 2 14c0 2.21 1.79 4 4 4h13c1.65 0 3-1.35 3-3 0-1.55-1.22-2.86-2.79-2.96zm-5.76.96v3h-2.91v-3H8l4-4 4 4h-2.55z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z"
	})), 'CloudUploadTwoTone');
	
	exports.default = _default;

/***/ },
/* 2130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
	}), 'Code');
	
	exports.default = _default;

/***/ },
/* 2131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
	}), 'CodeOutlined');
	
	exports.default = _default;

/***/ },
/* 2132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.7 15.9L4.8 12l3.9-3.9c.39-.39.39-1.01 0-1.4a.9839.9839 0 00-1.4 0l-4.59 4.59c-.39.39-.39 1.02 0 1.41l4.59 4.6c.39.39 1.01.39 1.4 0 .39-.39.39-1.01 0-1.4zm6.6 0l3.9-3.9-3.9-3.9a.9839.9839 0 010-1.4c.39-.39 1.01-.39 1.4 0l4.59 4.59c.39.39.39 1.02 0 1.41l-4.59 4.6c-.39.39-1.01.39-1.4 0a.9839.9839 0 010-1.4z"
	}), 'CodeRounded');
	
	exports.default = _default;

/***/ },
/* 2133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
	}), 'CodeSharp');
	
	exports.default = _default;

/***/ },
/* 2134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
	}), 'CodeTwoTone');
	
	exports.default = _default;

/***/ },
/* 2135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
	}), 'Collections');
	
	exports.default = _default;

/***/ },
/* 2136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
	}), _react.default.createElement("path", {
	  d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10l-2.5-1.5L15 12V4h5v8z"
	})), 'CollectionsBookmark');
	
	exports.default = _default;

/***/ },
/* 2137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-3 2v5l-1-.75L15 9V4h2zm3 12H8V4h5v9l3-2.25L19 13V4h1v12z"
	}), 'CollectionsBookmarkOutlined');
	
	exports.default = _default;

/***/ },
/* 2138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 20H5c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1s-1 .45-1 1v13c0 1.1.9 2 2 2h13c.55 0 1-.45 1-1s-.45-1-1-1zm3-18H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10l-2.5-1.5L15 12V4h5v8z"
	}), 'CollectionsBookmarkRounded');
	
	exports.default = _default;

/***/ },
/* 2139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6H2v16h16v-2H4V6zm18-4H6v16h16V2zm-2 10l-2.5-1.5L15 12V4h5v8z"
	}), 'CollectionsBookmarkSharp');
	
	exports.default = _default;

/***/ },
/* 2140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 4h-1v9l-3-2.25L13 13V4H8v12h12z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 22h14v-2H4V6H2v14c0 1.1.9 2 2 2zm18-6V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zM15 4h2v5l-1-.75L15 9V4zM8 4h5v9l3-2.25L19 13V4h1v12H8V4z"
	})), 'CollectionsBookmarkTwoTone');
	
	exports.default = _default;

/***/ },
/* 2141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4v12H8V4h12m0-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 9.67l1.69 2.26 2.48-3.1L19 15H9zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
	}), 'CollectionsOutlined');
	
	exports.default = _default;

/***/ },
/* 2142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-10.6-3.47l1.63 2.18 2.58-3.22c.2-.25.58-.25.78 0l2.96 3.7c.26.33.03.81-.39.81H9c-.41 0-.65-.47-.4-.8l2-2.67c.2-.26.6-.26.8 0zM2 7v13c0 1.1.9 2 2 2h13c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1s-1 .45-1 1z"
	}), 'CollectionsRounded');
	
	exports.default = _default;

/***/ },
/* 2143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 18V2H6v16h16zm-11-6l2.03 2.71L16 11l4 5H8l3-4zM2 6v16h16v-2H4V6H2z"
	}), 'CollectionsSharp');
	
	exports.default = _default;

/***/ },
/* 2144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 16h12V4H8v12zm3.5-4.33l1.69 2.26 2.48-3.09L19 15H9l2.5-3.33z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M8 2c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H8zm12 14H8V4h12v12zm-4.33-5.17l-2.48 3.09-1.69-2.25L9 15h10zM4 22h14v-2H4V6H2v14c0 1.1.9 2 2 2z"
	})), 'CollectionsTwoTone');
	
	exports.default = _default;

/***/ },
/* 2145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'ColorLens');
	
	exports.default = _default;

/***/ },
/* 2146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.04 10 9c0 3.31-2.69 6-6 6h-1.77c-.28 0-.5.22-.5.5 0 .12.05.23.13.33.41.47.64 1.06.64 1.67 0 1.38-1.12 2.5-2.5 2.5zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8c.28 0 .5-.22.5-.5 0-.16-.08-.28-.14-.35-.41-.46-.63-1.05-.63-1.65 0-1.38 1.12-2.5 2.5-2.5H16c2.21 0 4-1.79 4-4 0-3.86-3.59-7-8-7z"
	}), _react.default.createElement("circle", {
	  cx: "6.5",
	  cy: "11.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "9.5",
	  cy: "7.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "14.5",
	  cy: "7.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "17.5",
	  cy: "11.5",
	  r: "1.5"
	})), 'ColorLensOutlined');
	
	exports.default = _default;

/***/ },
/* 2147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'ColorLensRounded');
	
	exports.default = _default;

/***/ },
/* 2148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'ColorLensSharp');
	
	exports.default = _default;

/***/ },
/* 2149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8c.28 0 .5-.22.5-.5 0-.16-.08-.28-.14-.35-.41-.46-.63-1.05-.63-1.65 0-1.38 1.12-2.5 2.5-2.5H16c2.21 0 4-1.79 4-4 0-3.86-3.59-7-8-7zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 10 6.5 10s1.5.67 1.5 1.5S7.33 13 6.5 13zm3-4C8.67 9 8 8.33 8 7.5S8.67 6 9.5 6s1.5.67 1.5 1.5S10.33 9 9.5 9zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 6 14.5 6s1.5.67 1.5 1.5S15.33 9 14.5 9zm4.5 2.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10c1.38 0 2.5-1.12 2.5-2.5 0-.61-.23-1.21-.64-1.67-.08-.09-.13-.21-.13-.33 0-.28.22-.5.5-.5H16c3.31 0 6-2.69 6-6 0-4.96-4.49-9-10-9zm4 13h-1.77c-1.38 0-2.5 1.12-2.5 2.5 0 .61.22 1.19.63 1.65.06.07.14.19.14.35 0 .28-.22.5-.5.5-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.14 8 7c0 2.21-1.79 4-4 4z"
	}), _react.default.createElement("circle", {
	  cx: "6.5",
	  cy: "11.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "9.5",
	  cy: "7.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "14.5",
	  cy: "7.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "17.5",
	  cy: "11.5",
	  r: "1.5"
	})), 'ColorLensTwoTone');
	
	exports.default = _default;

/***/ },
/* 2150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.71 5.63l-2.34-2.34a.9959.9959 0 00-1.41 0l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z"
	}), 'Colorize');
	
	exports.default = _default;

/***/ },
/* 2151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.66 5.41l.92.92-2.69 2.69-.92-.92 2.69-2.69M17.67 3c-.26 0-.51.1-.71.29l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42l-2.34-2.34c-.2-.19-.45-.29-.7-.29zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z"
	}), 'ColorizeOutlined');
	
	exports.default = _default;

/***/ },
/* 2152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.71 5.63l-2.34-2.34a.9959.9959 0 00-1.41 0l-3.12 3.12-1.23-1.21c-.39-.39-1.02-.38-1.41 0-.39.39-.39 1.02 0 1.41l.72.72-8.77 8.77c-.1.1-.15.22-.15.36v4.04c0 .28.22.5.5.5h4.04c.13 0 .26-.05.35-.15l8.77-8.77.72.72c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41l-1.22-1.22 3.12-3.12c.41-.4.41-1.03.02-1.42zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z"
	}), 'ColorizeRounded');
	
	exports.default = _default;

/***/ },
/* 2153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.42 6.34l-3.75-3.75-3.82 3.82-1.94-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.84-3.83zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z"
	}), 'ColorizeSharp');
	
	exports.default = _default;

/***/ },
/* 2154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.896 9.023l-.92-.92L17.67 5.41l.92.92z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19zm8.98-9.97l-.93-.93 2.69-2.69.92.92-2.68 2.7z"
	})), 'ColorizeTwoTone');
	
	exports.default = _default;

/***/ },
/* 2155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
	}), 'Comment');
	
	exports.default = _default;

/***/ },
/* 2156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM20 4v13.17L18.83 16H4V4h16zM6 12h12v2H6zm0-3h12v2H6zm0-3h12v2H6z"
	}), 'CommentOutlined');
	
	exports.default = _default;

/***/ },
/* 2157 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM17 14H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1zm0-3H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1zm0-3H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'CommentRounded');
	
	exports.default = _default;

/***/ },
/* 2158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.99 2H2v16h16l4 4-.01-20zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
	}), 'CommentSharp');
	
	exports.default = _default;

/***/ },
/* 2159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 17.17V4H4v12h14.83L20 17.17zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 18h14l4 4-.01-18c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2zM4 4h16v13.17L18.83 16H4V4zm2 8h12v2H6zm0-3h12v2H6zm0-3h12v2H6z"
	})), 'CommentTwoTone');
	
	exports.default = _default;

/***/ },
/* 2160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4H5C3.34 4 2 5.34 2 7v8c0 1.66 1.34 3 3 3l-1 1v1h1l2-2.03L9 18v-5H4V5.98L13 6v2h2V7c0-1.66-1.34-3-3-3zM5 14c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm15.57-4.34c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66L10 13.77l.01 5.51c0 .38.31.72.69.72h.62c.38 0 .68-.38.68-.76V18h8v1.24c0 .38.31.76.69.76h.61c.38 0 .69-.34.69-.72l.01-1.37v-4.14l-1.43-4.11zm-8.16.34h7.19l1.03 3h-9.25l1.03-3zM12 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'Commute');
	
	exports.default = _default;

/***/ },
/* 2161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4H5C3.34 4 2 5.34 2 7v8c0 1.66 1.34 3 3 3l-1 1v1h1l2-2h2v-5H4V6h9v2h2V7c0-1.66-1.34-3-3-3zM5 14c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm15.57-4.34c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66l-1.42 4.11v5.51c0 .38.31.72.69.72h.62c.38 0 .68-.38.68-.76V18h8v1.24c0 .38.31.76.69.76h.61c.38 0 .69-.34.69-.72l.01-1.37v-4.14l-1.43-4.11zm-8.16.34h7.19l1.03 3h-9.25l1.03-3zM12 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'CommuteOutlined');
	
	exports.default = _default;

/***/ },
/* 2162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4H5C3.34 4 2 5.34 2 7v8c0 1.66 1.34 3 3 3l-.77.77c-.28.28-.28.72 0 1s.72.28 1 0L7 18h2v-5H4.5c-.28 0-.5-.22-.5-.5v-6c0-.28.22-.5.5-.5h8c.28 0 .5.22.5.5V8h2V7c0-1.66-1.34-3-3-3zM5 14c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm15.57-4.34c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66l-1.42 4.11v5.24c0 .55.45.99 1 .99s1-.45 1-1v-1h8v1c0 .55.45 1 1 1s.99-.44 1-.99L22 13.77l-1.43-4.11zm-7.8.34h6.48c.21 0 .4.14.47.34l.69 2c.11.32-.13.66-.47.66h-7.85c-.34 0-.58-.34-.47-.66l.69-2c.05-.2.24-.34.46-.34zM12 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'CommuteRounded');
	
	exports.default = _default;

/***/ },
/* 2163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4H5C3.34 4 2 5.34 2 7v8c0 1.66 1.34 3 3 3l-1 1v1h1l2-2h2v-5H4V6h9v2h2V7c0-1.66-1.34-3-3-3zM5 14c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm15.57-4.34c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66l-1.42 4.11v5.51c0 .38.31.72.69.72h.62c.38 0 .68-.38.68-.76V18h8v1.24c0 .38.31.76.69.76h.61c.38 0 .69-.34.69-.72l.01-1.37v-4.14l-1.43-4.11zm-8.16.34h7.19l1.03 3h-9.25l1.03-3zM12 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'CommuteSharp');
	
	exports.default = _default;

/***/ },
/* 2164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4H5C3.34 4 2 5.34 2 7v8c0 1.66 1.34 3 3 3l-1 1v1h1l2-2h2v-5H4V6h9v2h2V7c0-1.66-1.34-3-3-3zM5 14c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm15.57-4.34c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66l-1.42 4.11v5.51c0 .38.31.72.69.72h.62c.38 0 .68-.38.68-.76V18h8v1.24c0 .38.31.76.69.76h.61c.38 0 .69-.34.69-.72l.01-1.37v-4.14l-1.43-4.11zm-8.16.34h7.19l1.03 3h-9.25l1.03-3zM12 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'CommuteTwoTone');
	
	exports.default = _default;

/***/ },
/* 2165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2zm0 15H5l5-6v6zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'Compare');
	
	exports.default = _default;

/***/ },
/* 2166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z"
	}), 'CompareArrows');
	
	exports.default = _default;

/***/ },
/* 2167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z"
	}), 'CompareArrowsOutlined');
	
	exports.default = _default;

/***/ },
/* 2168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.01 14H3c-.55 0-1 .45-1 1s.45 1 1 1h6.01v1.79c0 .45.54.67.85.35l2.78-2.79c.19-.2.19-.51 0-.71l-2.78-2.79c-.31-.32-.85-.09-.85.35V14zm5.98-2.21V10H21c.55 0 1-.45 1-1s-.45-1-1-1h-6.01V6.21c0-.45-.54-.67-.85-.35l-2.78 2.79c-.19.2-.19.51 0 .71l2.78 2.79c.31.31.85.09.85-.36z"
	}), 'CompareArrowsRounded');
	
	exports.default = _default;

/***/ },
/* 2169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z"
	}), 'CompareArrowsSharp');
	
	exports.default = _default;

/***/ },
/* 2170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z"
	}), 'CompareArrowsTwoTone');
	
	exports.default = _default;

/***/ },
/* 2171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2zm0 15H5l5-6v6zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'CompareOutlined');
	
	exports.default = _default;

/***/ },
/* 2172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v1c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1zm0 15H5l5-6v6zm9-15h-5v2h4c.55 0 1 .45 1 1v12l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'CompareRounded');
	
	exports.default = _default;

/***/ },
/* 2173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 3H3v18h7v2h2V1h-2v2zm0 15H5l5-6v6zM21 3h-7v2h5v13l-5-6v9h7V3z"
	}), 'CompareSharp');
	
	exports.default = _default;

/***/ },
/* 2174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 5h-5v7l5 6zm-9 13v-6l-5 6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 3h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-2h-2v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1zm-2 17H5l5-6v6z"
	})), 'CompareTwoTone');
	
	exports.default = _default;

/***/ },
/* 2175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "17",
	  r: "4"
	}), _react.default.createElement("path", {
	  d: "M12 10.07c1.95 0 3.72.79 5 2.07l5-5C19.44 4.59 15.9 3 12 3S4.56 4.59 2 7.15l5 5c1.28-1.28 3.05-2.08 5-2.08z"
	})), 'CompassCalibration');
	
	exports.default = _default;

/***/ },
/* 2176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 12c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-17C8.1 3 4.56 4.59 2 7.15l5 5c1.28-1.28 3.05-2.08 5-2.08s3.72.79 5 2.07l5-5C19.44 4.59 15.9 3 12 3zm4.84 6.47c-1.44-.91-3.1-1.4-4.84-1.4-1.74 0-3.41.49-4.85 1.41L4.94 7.26C6.99 5.79 9.44 5 12 5c2.56 0 5 .79 7.05 2.26l-2.21 2.21z"
	}), 'CompassCalibrationOutlined');
	
	exports.default = _default;

/***/ },
/* 2177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "17",
	  r: "4"
	}), _react.default.createElement("path", {
	  d: "M12 3C8.49 3 5.28 4.29 2.8 6.41c-.44.38-.48 1.06-.06 1.48l3.6 3.6c.36.36.92.39 1.32.08 1.2-.94 2.71-1.5 4.34-1.5 1.64 0 3.14.56 4.34 1.49.4.31.96.28 1.31-.08l3.6-3.6c.42-.42.38-1.1-.07-1.48C18.72 4.28 15.51 3 12 3z"
	})), 'CompassCalibrationRounded');
	
	exports.default = _default;

/***/ },
/* 2178 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "17",
	  r: "4"
	}), _react.default.createElement("path", {
	  d: "M12 3C8.1 3 4.56 4.59 2 7.15l5 5c1.28-1.28 3.05-2.08 5-2.08s3.72.79 5 2.07l5-5C19.44 4.59 15.9 3 12 3z"
	})), 'CompassCalibrationSharp');
	
	exports.default = _default;

/***/ },
/* 2179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4.94 7.26l2.21 2.21c1.44-.91 3.11-1.4 4.85-1.4 1.74 0 3.41.49 4.84 1.4l2.21-2.21C17 5.79 14.56 5 12 5c-2.56 0-5.01.79-7.06 2.26z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "17",
	  r: "3",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 17c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5 5-2.24 5-5zm-8 0c0-1.65 1.35-3 3-3s3 1.35 3 3-1.35 3-3 3-3-1.35-3-3zM2 7.15l5 5c1.28-1.28 3.05-2.08 5-2.08s3.72.79 5 2.07l5-5C19.44 4.59 15.9 3 12 3 8.1 3 4.56 4.59 2 7.15zm14.84 2.32c-1.44-.91-3.1-1.4-4.84-1.4-1.74 0-3.41.49-4.85 1.41L4.94 7.26C6.99 5.79 9.44 5 12 5c2.56 0 5 .79 7.05 2.26l-2.21 2.21z"
	})), 'CompassCalibrationTwoTone');
	
	exports.default = _default;

/***/ },
/* 2180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
	}), 'Computer');
	
	exports.default = _default;

/***/ },
/* 2181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
	}), 'ComputerOutlined');
	
	exports.default = _default;

/***/ },
/* 2182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H1c-.55 0-1 .45-1 1s.45 1 1 1h22c.55 0 1-.45 1-1s-.45-1-1-1h-3zM5 6h14c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1z"
	}), 'ComputerRounded');
	
	exports.default = _default;

/***/ },
/* 2183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18l2-2V4H2v12l2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
	}), 'ComputerSharp');
	
	exports.default = _default;

/***/ },
/* 2184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 6h16v10H4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
	})), 'ComputerTwoTone');
	
	exports.default = _default;

/***/ },
/* 2185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z"
	}), 'ConfirmationNumber');
	
	exports.default = _default;

/***/ },
/* 2186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-2-1.46c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46V18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16v2.54zM11 15h2v2h-2zm0-4h2v2h-2zm0-4h2v2h-2z"
	}), 'ConfirmationNumberOutlined');
	
	exports.default = _default;

/***/ },
/* 2187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 8.54V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v2.54c0 .69.33 1.37.94 1.69C3.58 10.58 4 11.24 4 12s-.43 1.43-1.06 1.76c-.6.33-.94 1.01-.94 1.7V18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-2.54c0-.69-.34-1.37-.94-1.7-.63-.34-1.06-1-1.06-1.76s.43-1.42 1.06-1.76c.6-.33.94-1.01.94-1.7zm-9 8.96h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z"
	}), 'ConfirmationNumberRounded');
	
	exports.default = _default;

/***/ },
/* 2188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 10V4H2.01v6c1.1 0 1.99.9 1.99 2s-.89 2-2 2v6h20v-6c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z"
	}), 'ConfirmationNumberSharp');
	
	exports.default = _default;

/***/ },
/* 2189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4.01 8.54C5.2 9.23 6 10.52 6 12s-.81 2.77-2 3.46V18h16v-2.54c-1.19-.69-2-1.99-2-3.46s.81-2.77 2-3.46V6H4l.01 2.54zM11 7h2v2h-2V7zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-2-1.46c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46V18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16v2.54zM11 15h2v2h-2zm0-4h2v2h-2zm0-4h2v2h-2z"
	})), 'ConfirmationNumberTwoTone');
	
	exports.default = _default;

/***/ },
/* 2190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 8V7l-3 2-3-2v1l3 2 3-2zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm8-6h-8V6h8v6z"
	}), 'ContactMail');
	
	exports.default = _default;

/***/ },
/* 2191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zm0 16H2V5h20v14zM21 6h-7v5h7V6zm-1 2l-2.5 1.75L15 8V7l2.5 1.75L20 7v1zM9 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 8.59c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V18h12v-1.41zM5.48 16c.74-.5 2.22-1 3.52-1s2.77.49 3.52 1H5.48z"
	}), 'ContactMailOutlined');
	
	exports.default = _default;

/***/ },
/* 2192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 8V7l-3 2-3-2v1l2.72 1.82c.17.11.39.11.55 0L21 8zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm7.5-6h-7c-.28 0-.5-.22-.5-.5v-5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v5c0 .28-.22.5-.5.5z"
	}), 'ContactMailRounded');
	
	exports.default = _default;

/***/ },
/* 2193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 8V7l-3 2-3-2v1l3 2 3-2zm3-5H0v18h23.99L24 3zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm8-6h-8V6h8v6z"
	}), 'ContactMailSharp');
	
	exports.default = _default;

/***/ },
/* 2194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M2 19h20V5H2v14zM14 6h7v5h-7V6zM9 6c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zM3 16.59C3 14.08 6.97 13 9 13s6 1.08 6 3.58V18H3v-1.41z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zm0 16H2V5h20v14zM21 6h-7v5h7V6zm-1 2l-2.5 1.75L15 8V7l2.5 1.75L20 7v1zM9 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 8.59c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V18h12v-1.41zM5.48 16c.74-.5 2.22-1 3.52-1s2.77.49 3.52 1H5.48z"
	})), 'ContactMailTwoTone');
	
	exports.default = _default;

/***/ },
/* 2195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm3.85-4h1.64L21 16l-1.99 1.99c-1.31-.98-2.28-2.38-2.73-3.99-.18-.64-.28-1.31-.28-2s.1-1.36.28-2c.45-1.62 1.42-3.01 2.73-3.99L21 8l-1.51 2h-1.64c-.22.63-.35 1.3-.35 2s.13 1.37.35 2z"
	}), 'ContactPhone');
	
	exports.default = _default;

/***/ },
/* 2196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zm0 16H2V5h20v14zm-2.99-1.01L21 16l-1.51-2h-1.64c-.22-.63-.35-1.3-.35-2s.13-1.37.35-2h1.64L21 8l-1.99-1.99c-1.31.98-2.28 2.37-2.73 3.99-.18.64-.28 1.31-.28 2s.1 1.36.28 2c.45 1.61 1.42 3.01 2.73 3.99zM9 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 8.59c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V18h12v-1.41zM5.48 16c.74-.5 2.22-1 3.52-1s2.77.49 3.52 1H5.48z"
	}), 'ContactPhoneOutlined');
	
	exports.default = _default;

/***/ },
/* 2197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm3.85-4h1.39c.16 0 .3.07.4.2l1.1 1.45c.15.2.13.48-.05.65l-1.36 1.36c-.18.18-.48.2-.67.04a7.557 7.557 0 01-2.38-3.71c-.18-.63-.28-1.3-.28-1.99s.1-1.36.28-2c.41-1.47 1.25-2.75 2.38-3.71.2-.17.49-.14.67.04l1.36 1.36c.18.18.2.46.05.65l-1.1 1.45c-.09.13-.24.2-.4.2h-1.39c-.22.63-.35 1.3-.35 2s.13 1.38.35 2.01z"
	}), 'ContactPhoneRounded');
	
	exports.default = _default;

/***/ },
/* 2198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23.99 3H0v18h24l-.01-18zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm3.85-4h1.64L21 16l-1.99 1.99c-1.31-.98-2.28-2.38-2.73-3.99-.18-.64-.28-1.31-.28-2s.1-1.36.28-2c.45-1.62 1.42-3.01 2.73-3.99L21 8l-1.51 2h-1.64c-.22.63-.35 1.3-.35 2s.13 1.37.35 2z"
	}), 'ContactPhoneSharp');
	
	exports.default = _default;

/***/ },
/* 2199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M22 5H2v14h20V5zM9 6c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zm6 12H3v-1.41C3 14.08 6.97 13 9 13s6 1.08 6 3.58V18zm2.85-4h1.64L21 16l-1.99 1.99c-1.31-.98-2.28-2.38-2.73-3.99-.18-.64-.28-1.31-.28-2s.1-1.36.28-2c.45-1.62 1.42-3.01 2.73-3.99L21 8l-1.51 2h-1.64c-.22.63-.35 1.3-.35 2s.13 1.37.35 2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M2 21h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2zM2 5h20v14H2V5zm17.49 5L21 8l-1.99-1.99c-1.31.98-2.28 2.37-2.73 3.99-.18.64-.28 1.31-.28 2s.1 1.36.28 2c.45 1.61 1.42 3.01 2.73 3.99L21 16l-1.51-2h-1.64c-.22-.63-.35-1.3-.35-2s.13-1.37.35-2h1.64zM9 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 5c-2.03 0-6 1.08-6 3.58V18h12v-1.41C15 14.08 11.03 13 9 13zm-3.52 3c.74-.5 2.22-1 3.52-1s2.77.49 3.52 1H5.48z"
	})), 'ContactPhoneTwoTone');
	
	exports.default = _default;

/***/ },
/* 2200 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.5 2C6.81 2 3 5.81 3 10.5S6.81 19 11.5 19h.5v3c4.86-2.34 8-7 8-11.5C20 5.81 16.19 2 11.5 2zm1 14.5h-2v-2h2v2zm0-3.5h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5z"
	}), 'ContactSupport');
	
	exports.default = _default;

/***/ },
/* 2201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 23.59v-3.6c-5.01-.26-9-4.42-9-9.49C2 5.26 6.26 1 11.5 1S21 5.26 21 10.5c0 4.95-3.44 9.93-8.57 12.4l-1.43.69zM11.5 3C7.36 3 4 6.36 4 10.5S7.36 18 11.5 18H13v2.3c3.64-2.3 6-6.08 6-9.8C19 6.36 15.64 3 11.5 3zm-1 11.5h2v2h-2zm2-1.5h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5z"
	}), 'ContactSupportOutlined');
	
	exports.default = _default;

/***/ },
/* 2202 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.5 2C6.81 2 3 5.81 3 10.5S6.81 19 11.5 19h.5v3c4.86-2.34 8-7 8-11.5C20 5.81 16.19 2 11.5 2zm1 14.5h-2v-2h2v2zm.4-4.78c-.01.01-.02.03-.03.05-.05.08-.1.16-.14.24-.02.03-.03.07-.04.11-.03.07-.06.14-.08.21-.07.21-.1.43-.1.68H10.5c0-.51.08-.94.2-1.3 0-.01 0-.02.01-.03.01-.04.04-.06.05-.1.06-.16.13-.3.22-.44.03-.05.07-.1.1-.15.03-.04.05-.09.08-.12l.01.01c.84-1.1 2.21-1.44 2.32-2.68.09-.98-.61-1.93-1.57-2.13-1.04-.22-1.98.39-2.3 1.28-.14.36-.47.65-.88.65h-.2c-.6 0-1.04-.59-.87-1.17.55-1.82 2.37-3.09 4.43-2.79 1.69.25 3.04 1.64 3.33 3.33.44 2.44-1.63 3.03-2.53 4.35z"
	}), 'ContactSupportRounded');
	
	exports.default = _default;

/***/ },
/* 2203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.5 2C6.81 2 3 5.81 3 10.5S6.81 19 11.5 19h.5v3c4.86-2.34 8-7 8-11.5C20 5.81 16.19 2 11.5 2zm1 14.5h-2v-2h2v2zm0-3.5h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5z"
	}), 'ContactSupportSharp');
	
	exports.default = _default;

/***/ },
/* 2204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.5 3C7.36 3 4 6.36 4 10.5S7.36 18 11.5 18H13v2.3c3.64-2.3 6-6.08 6-9.8C19 6.36 15.64 3 11.5 3zm1 13.5h-2v-2h2v2zm0-3.5h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11.5 1C6.26 1 2 5.26 2 10.5c0 5.07 3.99 9.23 9 9.49v3.6l1.43-.69C17.56 20.43 21 15.45 21 10.5 21 5.26 16.74 1 11.5 1zM13 20.3V18h-1.5C7.36 18 4 14.64 4 10.5S7.36 3 11.5 3 19 6.36 19 10.5c0 3.73-2.36 7.51-6 9.8zm-2.5-5.8h2v2h-2zm1-10.5c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
	})), 'ContactSupportTwoTone');
	
	exports.default = _default;

/***/ },
/* 2205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8.46 14.45l-1.36-.62c.28-.61.41-1.24.4-1.86-.01-.63-.14-1.24-.4-1.8l1.36-.63c.35.75.53 1.56.54 2.4.01.86-.17 1.7-.54 2.51zm3.07 1.56l-1.3-.74c.52-.92.78-1.98.78-3.15 0-1.19-.27-2.33-.8-3.4l1.34-.67c.64 1.28.96 2.65.96 4.07 0 1.43-.33 2.74-.98 3.89zm3.14 1.32l-1.35-.66c.78-1.6 1.18-3.18 1.18-4.69 0-1.51-.4-3.07-1.18-4.64l1.34-.67c.9 1.78 1.34 3.56 1.34 5.31 0 1.74-.44 3.54-1.33 5.35z"
	}), 'Contactless');
	
	exports.default = _default;

/***/ },
/* 2206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), _react.default.createElement("path", {
	  d: "M7.1 10.18c.26.56.39 1.16.4 1.8.01.63-.13 1.25-.4 1.86l1.37.62c.37-.81.55-1.65.54-2.5-.01-.84-.19-1.65-.54-2.4l-1.37.62zM13.33 7.33c.78 1.57 1.18 3.14 1.18 4.64 0 1.51-.4 3.09-1.18 4.69l1.35.66c.88-1.81 1.33-3.61 1.33-5.35 0-1.74-.45-3.53-1.33-5.31l-1.35.67zM10.2 8.72c.53 1.07.8 2.21.8 3.4 0 1.17-.26 2.23-.78 3.15l1.3.74c.65-1.15.98-2.45.98-3.89 0-1.42-.32-2.79-.96-4.07l-1.34.67z"
	})), 'ContactlessOutlined');
	
	exports.default = _default;

/***/ },
/* 2207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8.75 13.68c-.13.43-.62.63-1.02.45a.749.749 0 01-.4-.9c.12-.41.18-.83.17-1.24-.01-.41-.06-.8-.17-1.18-.1-.36.06-.75.4-.9.42-.19.91.04 1.04.49.15.51.22 1.03.23 1.57 0 .56-.08 1.14-.25 1.71zm3.14 1.59c-.17.41-.67.57-1.06.35-.33-.19-.46-.59-.32-.94.33-.77.49-1.63.49-2.56 0-.96-.18-1.89-.53-2.78-.14-.36.02-.76.36-.94.39-.2.87-.02 1.03.39.42 1.06.63 2.18.63 3.33.02 1.13-.19 2.19-.6 3.15zM15 16.6c-.17.4-.64.58-1.02.39-.35-.17-.52-.59-.37-.95.59-1.39.89-2.75.89-4.06 0-1.31-.3-2.65-.88-4.01-.16-.36.01-.78.36-.95.39-.2.85-.02 1.02.38.66 1.54 1 3.08 1 4.58s-.34 3.06-1 4.62z"
	}), 'ContactlessRounded');
	
	exports.default = _default;

/***/ },
/* 2208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8.46 14.45l-1.36-.62c.28-.61.41-1.24.4-1.86-.01-.63-.14-1.24-.4-1.8l1.36-.63c.35.75.53 1.56.54 2.4.01.86-.17 1.7-.54 2.51zm3.07 1.56l-1.3-.74c.52-.92.78-1.98.78-3.15 0-1.19-.27-2.33-.8-3.4l1.34-.67c.64 1.28.96 2.65.96 4.07 0 1.43-.33 2.74-.98 3.89zm3.14 1.32l-1.35-.66c.78-1.6 1.18-3.18 1.18-4.69 0-1.51-.4-3.07-1.18-4.64l1.34-.67c.9 1.78 1.34 3.56 1.34 5.31 0 1.74-.44 3.54-1.33 5.35z"
	}), 'ContactlessSharp');
	
	exports.default = _default;

/***/ },
/* 2209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zM8.46 14.45l-1.36-.62c.28-.61.41-1.24.4-1.86-.01-.63-.14-1.24-.4-1.8l1.36-.63c.35.75.53 1.56.54 2.4.01.86-.17 1.7-.54 2.51zm3.07 1.56l-1.3-.74c.52-.92.78-1.98.78-3.15 0-1.19-.27-2.33-.8-3.4l1.34-.67c.64 1.28.96 2.65.96 4.07 0 1.43-.33 2.74-.98 3.89zm3.14 1.32l-1.35-.66c.78-1.6 1.18-3.18 1.18-4.69 0-1.51-.4-3.07-1.18-4.64l1.34-.67c.9 1.78 1.34 3.56 1.34 5.31 0 1.74-.44 3.54-1.33 5.35z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), _react.default.createElement("path", {
	  d: "M7.1 10.18c.26.56.39 1.16.4 1.8.01.63-.13 1.25-.4 1.86l1.37.62c.37-.81.55-1.65.54-2.5-.01-.84-.19-1.65-.54-2.4l-1.37.62zM13.33 7.33c.78 1.57 1.18 3.14 1.18 4.64 0 1.51-.4 3.09-1.18 4.69l1.35.66c.88-1.81 1.33-3.61 1.33-5.35 0-1.74-.45-3.53-1.33-5.31l-1.35.67zM10.2 8.72c.53 1.07.8 2.21.8 3.4 0 1.17-.26 2.23-.78 3.15l1.3.74c.65-1.15.98-2.45.98-3.89 0-1.42-.32-2.79-.96-4.07l-1.34.67z"
	})), 'ContactlessTwoTone');
	
	exports.default = _default;

/***/ },
/* 2210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 0H4v2h16V0zM4 24h16v-2H4v2zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25S9.75 10.24 9.75 9 10.76 6.75 12 6.75zM17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17z"
	}), 'Contacts');
	
	exports.default = _default;

/***/ },
/* 2211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12zM4 0h16v2H4zm0 22h16v2H4zm8-10c1.38 0 2.5-1.12 2.5-2.5S13.38 7 12 7 9.5 8.12 9.5 9.5 10.62 12 12 12zm0-3.5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 7.49C17 13.9 13.69 13 12 13s-5 .9-5 2.99V17h10v-1.01zm-8.19-.49c.61-.52 2.03-1 3.19-1 1.17 0 2.59.48 3.2 1H8.81z"
	}), 'ContactsOutlined');
	
	exports.default = _default;

/***/ },
/* 2212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 0H5c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM5 24h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25S9.75 10.24 9.75 9 10.76 6.75 12 6.75zM17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17z"
	}), 'ContactsRounded');
	
	exports.default = _default;

/***/ },
/* 2213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 0H4v2h16V0zM4 24h16v-2H4v2zM22 4H2v16h20V4zM12 6.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25S9.75 10.24 9.75 9 10.76 6.75 12 6.75zM17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17z"
	}), 'ContactsSharp');
	
	exports.default = _default;

/***/ },
/* 2214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 6H4v12h16V6zm-8 1c1.38 0 2.5 1.12 2.5 2.5S13.38 12 12 12s-2.5-1.12-2.5-2.5S10.62 7 12 7zm5 10H7v-1.01C7 13.9 10.31 13 12 13s5 .9 5 2.99V17z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 20h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2zM4 6h16v12H4V6zm0-6h16v2H4zm0 22h16v2H4zm8-10c1.38 0 2.5-1.12 2.5-2.5S13.38 7 12 7 9.5 8.12 9.5 9.5 10.62 12 12 12zm0-3.5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4.5c-1.69 0-5 .9-5 2.99V17h10v-1.01C17 13.9 13.69 13 12 13zm-3.19 2.5c.61-.52 2.03-1 3.19-1 1.17 0 2.59.48 3.2 1H8.81z"
	})), 'ContactsTwoTone');
	
	exports.default = _default;

/***/ },
/* 2215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.54 5.54L13.77 7.3 12 5.54 10.23 7.3 8.46 5.54 12 2zm2.92 10l-1.76-1.77L18.46 12l-1.76-1.77 1.76-1.77L22 12zm-10 2.92l1.77-1.76L12 18.46l1.77-1.76 1.77 1.76L12 22zm-2.92-10l1.76 1.77L5.54 12l1.76 1.77-1.76 1.77L2 12z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "3"
	})), 'ControlCamera');
	
	exports.default = _default;

/***/ },
/* 2216 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5.54 8.46L2 12l3.54 3.54 1.76-1.77L5.54 12l1.76-1.77zm6.46 10l-1.77-1.76-1.77 1.76L12 22l3.54-3.54-1.77-1.76zm6.46-10l-1.76 1.77L18.46 12l-1.76 1.77 1.76 1.77L22 12zm-10-2.92l1.77 1.76L12 5.54l1.77 1.76 1.77-1.76L12 2z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "3"
	})), 'ControlCameraOutlined');
	
	exports.default = _default;

/***/ },
/* 2217 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4.65 9.35L2.7 11.3c-.39.39-.39 1.02 0 1.41l1.95 1.95c.49.49 1.28.49 1.77 0 .48-.49.48-1.27 0-1.76l-.88-.9.88-.89c.48-.49.48-1.27 0-1.76s-1.28-.49-1.77 0zm12.93 0c-.48.49-.48 1.27 0 1.76l.88.89-.88.89c-.48.49-.48 1.27 0 1.76.49.49 1.28.49 1.77 0l1.95-1.95c.39-.39.39-1.02 0-1.41l-1.95-1.95c-.49-.48-1.29-.48-1.77.01zM12 18.46l-.89-.88c-.49-.48-1.27-.48-1.76 0-.49.49-.49 1.28 0 1.77l1.95 1.95c.39.39 1.02.39 1.41 0l1.95-1.95c.49-.49.49-1.28 0-1.77-.49-.48-1.27-.48-1.76 0l-.9.88zM9.35 6.42c.49.48 1.27.48 1.76 0l.89-.88.89.88c.49.48 1.27.48 1.76 0 .49-.49.49-1.28 0-1.77L12.7 2.7a.9959.9959 0 00-1.41 0L9.35 4.65c-.49.49-.49 1.29 0 1.77z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "3"
	})), 'ControlCameraRounded');
	
	exports.default = _default;

/***/ },
/* 2218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5.54 8.46L2 12l3.54 3.54 1.76-1.77L5.54 12l1.76-1.77zm12.92 0l-1.76 1.77L18.46 12l-1.76 1.77 1.76 1.77L22 12zm-6.46 10l-1.77-1.76-1.77 1.76L12 22l3.54-3.54-1.77-1.76zM8.46 5.54l1.77 1.76L12 5.54l1.77 1.76 1.77-1.76L12 2z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "3"
	})), 'ControlCameraSharp');
	
	exports.default = _default;

/***/ },
/* 2219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7.3 13.77L5.54 12l1.76-1.77-1.76-1.77L2 12l3.54 3.54zm8.24 4.69l-1.77-1.76L12 18.46l-1.77-1.76-1.77 1.76L12 22zm2.92-2.92L22 12l-3.54-3.54-1.76 1.77L18.46 12l-1.76 1.77zM12 5.54l1.77 1.76 1.77-1.76L12 2 8.46 5.54l1.77 1.76z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "3"
	})), 'ControlCameraTwoTone');
	
	exports.default = _default;

/***/ },
/* 2220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'ControlPoint');
	
	exports.default = _default;

/***/ },
/* 2221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16C3.64 17.2 2 14.79 2 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
	}), 'ControlPointDuplicate');
	
	exports.default = _default;

/***/ },
/* 2222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3V8zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16C3.64 17.2 2 14.79 2 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
	}), 'ControlPointDuplicateOutlined');
	
	exports.default = _default;

/***/ },
/* 2223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 8c-.55 0-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1h-2V9c0-.55-.45-1-1-1zM2 12c0-2.58 1.4-4.83 3.48-6.04.32-.19.53-.51.53-.88 0-.77-.84-1.25-1.51-.86C1.82 5.78 0 8.68 0 12s1.82 6.22 4.5 7.78c.67.39 1.51-.09 1.51-.86 0-.37-.21-.69-.53-.88C3.4 16.83 2 14.58 2 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
	}), 'ControlPointDuplicateRounded');
	
	exports.default = _default;

/***/ },
/* 2224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3V8zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16C3.64 17.2 2 14.79 2 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
	}), 'ControlPointDuplicateSharp');
	
	exports.default = _default;

/***/ },
/* 2225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15 5c-3.86 0-7 3.14-7 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm4 8h-3v3h-2v-3h-3v-2h3V8h2v3h3v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zm-1-5c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16C3.64 17.2 2 14.79 2 12z"
	})), 'ControlPointDuplicateTwoTone');
	
	exports.default = _default;

/***/ },
/* 2226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'ControlPointOutlined');
	
	exports.default = _default;

/***/ },
/* 2227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7c-.55 0-1 .45-1 1v3H8c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V8c0-.55-.45-1-1-1zm0-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'ControlPointRounded');
	
	exports.default = _default;

/***/ },
/* 2228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'ControlPointSharp');
	
	exports.default = _default;

/***/ },
/* 2229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm5 9h-4v4h-2v-4H7v-2h4V7h2v4h4v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-13h-2v4H7v2h4v4h2v-4h4v-2h-4z"
	})), 'ControlPointTwoTone');
	
	exports.default = _default;

/***/ },
/* 2230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.88 9.14c1.28.06 1.61 1.15 1.63 1.66h1.79c-.08-1.98-1.49-3.19-3.45-3.19C9.64 7.61 8 9 8 12.14c0 1.94.93 4.24 3.84 4.24 2.22 0 3.41-1.65 3.44-2.95h-1.79c-.03.59-.45 1.38-1.63 1.44-1.31-.04-1.86-1.06-1.86-2.73 0-2.89 1.28-2.98 1.88-3zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'Copyright');
	
	exports.default = _default;

/***/ },
/* 2231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.08 10.86c.05-.33.16-.62.3-.87s.34-.46.59-.62c.24-.15.54-.22.91-.23.23.01.44.05.63.13.2.09.38.21.52.36s.25.33.34.53.13.42.14.64h1.79c-.02-.47-.11-.9-.28-1.29s-.4-.73-.7-1.01-.66-.5-1.08-.66-.88-.23-1.39-.23c-.65 0-1.22.11-1.7.34s-.88.53-1.2.92-.56.84-.71 1.36S8 11.29 8 11.87v.27c0 .58.08 1.12.23 1.64s.39.97.71 1.35.72.69 1.2.91c.48.22 1.05.34 1.7.34.47 0 .91-.08 1.32-.23s.77-.36 1.08-.63.56-.58.74-.94.29-.74.3-1.15h-1.79c-.01.21-.06.4-.15.58s-.21.33-.36.46-.32.23-.52.3c-.19.07-.39.09-.6.1-.36-.01-.66-.08-.89-.23-.25-.16-.45-.37-.59-.62s-.25-.55-.3-.88-.08-.67-.08-1v-.27c0-.35.03-.68.08-1.01zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'CopyrightOutlined');
	
	exports.default = _default;

/***/ },
/* 2232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.08 10.86c.05-.33.16-.62.3-.87s.34-.46.59-.62c.24-.15.54-.22.91-.23.23.01.44.05.63.13.2.09.38.21.52.36s.25.33.34.53.13.42.14.64h1.79c-.02-.47-.11-.9-.28-1.29s-.4-.73-.7-1.01-.66-.5-1.08-.66-.88-.23-1.39-.23c-.65 0-1.22.11-1.7.34s-.88.53-1.2.92-.56.84-.71 1.36S8 11.29 8 11.87v.27c0 .58.08 1.12.23 1.64s.39.97.71 1.35.72.69 1.2.91c.48.22 1.05.34 1.7.34.47 0 .91-.08 1.32-.23s.77-.36 1.08-.63.56-.58.74-.94.29-.74.3-1.15h-1.79c-.01.21-.06.4-.15.58s-.21.33-.36.46-.32.23-.52.3c-.19.07-.39.09-.6.1-.36-.01-.66-.08-.89-.23-.25-.16-.45-.37-.59-.62s-.25-.55-.3-.88-.08-.67-.08-1v-.27c0-.35.03-.68.08-1.01zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'CopyrightRounded');
	
	exports.default = _default;

/***/ },
/* 2233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.08 10.86c.05-.33.16-.62.3-.87s.34-.46.59-.62c.24-.15.54-.22.91-.23.23.01.44.05.63.13.2.09.38.21.52.36s.25.33.34.53.13.42.14.64h1.79c-.02-.47-.11-.9-.28-1.29s-.4-.73-.7-1.01-.66-.5-1.08-.66-.88-.23-1.39-.23c-.65 0-1.22.11-1.7.34s-.88.53-1.2.92-.56.84-.71 1.36S8 11.29 8 11.87v.27c0 .58.08 1.12.23 1.64s.39.97.71 1.35.72.69 1.2.91c.48.22 1.05.34 1.7.34.47 0 .91-.08 1.32-.23s.77-.36 1.08-.63.56-.58.74-.94.29-.74.3-1.15h-1.79c-.01.21-.06.4-.15.58s-.21.33-.36.46-.32.23-.52.3c-.19.07-.39.09-.6.1-.36-.01-.66-.08-.89-.23-.25-.16-.45-.37-.59-.62s-.25-.55-.3-.88-.08-.67-.08-1v-.27c0-.35.03-.68.08-1.01zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'CopyrightSharp');
	
	exports.default = _default;

/***/ },
/* 2234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm-1.92 9.14c.05.33.16.63.3.88s.34.46.59.62c.23.15.53.22.89.23.21-.01.41-.03.6-.1.2-.07.37-.17.52-.3.15-.13.27-.28.36-.46.09-.18.14-.37.15-.58h1.79c-.01.41-.12.79-.3 1.15-.18.36-.43.67-.74.94-.31.27-.67.48-1.08.63-.41.15-.85.23-1.32.23-.65 0-1.22-.12-1.7-.34-.48-.22-.88-.53-1.2-.91s-.56-.83-.71-1.35c-.15-.52-.23-1.06-.23-1.64v-.27c0-.58.09-1.12.24-1.64.15-.52.39-.97.71-1.36s.72-.69 1.2-.92c.48-.23 1.05-.34 1.7-.34.51 0 .97.07 1.39.23.42.16.78.38 1.08.66.3.28.53.62.7 1.01.17.39.26.82.28 1.29h-1.79c-.01-.22-.05-.44-.14-.64-.09-.2-.2-.38-.34-.53-.14-.15-.32-.27-.52-.36-.19-.08-.4-.12-.63-.13-.37.01-.67.08-.91.23-.25.16-.45.37-.59.62s-.25.54-.3.87c-.05.33-.08.66-.08 1.01v.27c0 .33.03.67.08 1z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M10.08 10.86c.05-.33.16-.62.3-.87s.34-.46.59-.62c.24-.15.54-.22.91-.23.23.01.44.05.63.13.2.09.38.21.52.36s.25.33.34.53c.09.2.13.42.14.64h1.79c-.02-.47-.11-.9-.28-1.29-.17-.39-.4-.73-.7-1.01-.3-.28-.66-.5-1.08-.66-.42-.16-.88-.23-1.39-.23-.65 0-1.22.11-1.7.34-.48.23-.88.53-1.2.92s-.56.84-.71 1.36c-.15.52-.24 1.06-.24 1.64v.27c0 .58.08 1.12.23 1.64.15.52.39.97.71 1.35s.72.69 1.2.91c.48.22 1.05.34 1.7.34.47 0 .91-.08 1.32-.23.41-.15.77-.36 1.08-.63.31-.27.56-.58.74-.94.18-.36.29-.74.3-1.15h-1.79c-.01.21-.06.4-.15.58-.09.18-.21.33-.36.46s-.32.23-.52.3c-.19.07-.39.09-.6.1-.36-.01-.66-.08-.89-.23-.25-.16-.45-.37-.59-.62s-.25-.55-.3-.88c-.05-.33-.08-.67-.08-1v-.27c0-.35.03-.68.08-1.01zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	})), 'CopyrightTwoTone');
	
	exports.default = _default;

/***/ },
/* 2235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
	}), 'Create');
	
	exports.default = _default;

/***/ },
/* 2236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z"
	}), 'CreateNewFolder');
	
	exports.default = _default;

/***/ },
/* 2237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-8-4h2v2h2v-2h2v-2h-2v-2h-2v2h-2z"
	}), 'CreateNewFolderOutlined');
	
	exports.default = _default;

/***/ },
/* 2238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-8l-1.41-1.41C10.21 4.21 9.7 4 9.17 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-2 8h-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2h-2c-.55 0-1-.45-1-1s.45-1 1-1h2v-2c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'CreateNewFolderRounded');
	
	exports.default = _default;

/***/ },
/* 2239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6H12l-2-2H2v16h20V6zm-3 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z"
	}), 'CreateNewFolderSharp');
	
	exports.default = _default;

/***/ },
/* 2240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.17 8l-.59-.59L9.17 6H4v12h16V8h-8.83zM14 10h2v2h2v2h-2v2h-2v-2h-2v-2h2v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm0 12H4V6h5.17l1.41 1.41.59.59H20v10zm-8-4h2v2h2v-2h2v-2h-2v-2h-2v2h-2z"
	})), 'CreateNewFolderTwoTone');
	
	exports.default = _default;

/***/ },
/* 2241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z"
	}), 'CreateOutlined');
	
	exports.default = _default;

/***/ },
/* 2242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 17.46v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15L17.81 9.94l-3.75-3.75L3.15 17.1c-.1.1-.15.22-.15.36zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
	}), 'CreateRounded');
	
	exports.default = _default;

/***/ },
/* 2243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM21.41 6.34l-3.75-3.75-2.53 2.54 3.75 3.75 2.53-2.54z"
	}), 'CreateSharp');
	
	exports.default = _default;

/***/ },
/* 2244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 18.08V19h.92l9.06-9.06-.92-.92z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z"
	})), 'CreateTwoTone');
	
	exports.default = _default;

/***/ },
/* 2245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
	}), 'CreditCard');
	
	exports.default = _default;

/***/ },
/* 2246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
	}), 'CreditCardOutlined');
	
	exports.default = _default;

/***/ },
/* 2247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm-1 14H5c-.55 0-1-.45-1-1v-5h16v5c0 .55-.45 1-1 1zm1-10H4V6h16v2z"
	}), 'CreditCardRounded');
	
	exports.default = _default;

/***/ },
/* 2248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 4H2.01L2 20h20V4zm-2 14H4v-6h16v6zm0-10H4V6h16v2z"
	}), 'CreditCardSharp');
	
	exports.default = _default;

/***/ },
/* 2249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 12h16v6H4zm0-6h16v2H4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
	})), 'CreditCardTwoTone');
	
	exports.default = _default;

/***/ },
/* 2250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z"
	}), 'Crop');
	
	exports.default = _default;

/***/ },
/* 2251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z"
	}), 'Crop169');
	
	exports.default = _default;

/***/ },
/* 2252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z"
	}), 'Crop169Outlined');
	
	exports.default = _default;

/***/ },
/* 2253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-1 10H6c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1z"
	}), 'Crop169Rounded');
	
	exports.default = _default;

/***/ },
/* 2254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 6H3v12h18V6zm-2 10H5V8h14v8z"
	}), 'Crop169Sharp');
	
	exports.default = _default;

/***/ },
/* 2255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z"
	}), 'Crop169TwoTone');
	
	exports.default = _default;

/***/ },
/* 2256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z"
	}), 'Crop32');
	
	exports.default = _default;

/***/ },
/* 2257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z"
	}), 'Crop32Outlined');
	
	exports.default = _default;

/***/ },
/* 2258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-1 14H6c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1z"
	}), 'Crop32Rounded');
	
	exports.default = _default;

/***/ },
/* 2259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 4H3v16h18V4zm-2 14H5V6h14v12z"
	}), 'Crop32Sharp');
	
	exports.default = _default;

/***/ },
/* 2260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z"
	}), 'Crop32TwoTone');
	
	exports.default = _default;

/***/ },
/* 2261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
	}), 'Crop54');
	
	exports.default = _default;

/***/ },
/* 2262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
	}), 'Crop54Outlined');
	
	exports.default = _default;

/***/ },
/* 2263 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-1 12H6c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1z"
	}), 'Crop54Rounded');
	
	exports.default = _default;

/***/ },
/* 2264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 5H3v14h18V5zm-2 12H5V7h14v10z"
	}), 'Crop54Sharp');
	
	exports.default = _default;

/***/ },
/* 2265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
	}), 'Crop54TwoTone');
	
	exports.default = _default;

/***/ },
/* 2266 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z"
	}), 'Crop75');
	
	exports.default = _default;

/***/ },
/* 2267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z"
	}), 'Crop75Outlined');
	
	exports.default = _default;

/***/ },
/* 2268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-1 8H6c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1z"
	}), 'Crop75Rounded');
	
	exports.default = _default;

/***/ },
/* 2269 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 7H3v10h18V7zm-2 8H5V9h14v6z"
	}), 'Crop75Sharp');
	
	exports.default = _default;

/***/ },
/* 2270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z"
	}), 'Crop75TwoTone');
	
	exports.default = _default;

/***/ },
/* 2271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
	}), 'CropDin');
	
	exports.default = _default;

/***/ },
/* 2272 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
	}), 'CropDinOutlined');
	
	exports.default = _default;

/***/ },
/* 2273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1z"
	}), 'CropDinRounded');
	
	exports.default = _default;

/***/ },
/* 2274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zm-2 16H5V5h14v14z"
	}), 'CropDinSharp');
	
	exports.default = _default;

/***/ },
/* 2275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
	}), 'CropDinTwoTone');
	
	exports.default = _default;

/***/ },
/* 2276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z"
	}), 'CropFree');
	
	exports.default = _default;

/***/ },
/* 2277 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z"
	}), 'CropFreeOutlined');
	
	exports.default = _default;

/***/ },
/* 2278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5v3c0 .55.45 1 1 1s1-.45 1-1V6c0-.55.45-1 1-1h2c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.1 0-2 .9-2 2zm1 10c-.55 0-1 .45-1 1v3c0 1.1.9 2 2 2h3c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1-.45-1-1v-2c0-.55-.45-1-1-1zm15 3c0 .55-.45 1-1 1h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c1.1 0 2-.9 2-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v2zm0-15h-3c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1 .45 1 1v2c0 .55.45 1 1 1s1-.45 1-1V5c0-1.1-.9-2-2-2z"
	}), 'CropFreeRounded');
	
	exports.default = _default;

/***/ },
/* 2279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 3v6h2V5h4V3H3zm2 12H3v6h6v-2H5v-4zm14 4h-4v2h6v-6h-2v4zm2-16h-6v2h4v4h2V3z"
	}), 'CropFreeSharp');
	
	exports.default = _default;

/***/ },
/* 2280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 19c0 1.1.9 2 2 2h4v-2H5v-4H3v4zM21 5c0-1.1-.9-2-2-2h-4v2h4v4h2V5zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm16 14v-4h-2v4h-4v2h4c1.1 0 2-.9 2-2z"
	}), 'CropFreeTwoTone');
	
	exports.default = _default;

/***/ },
/* 2281 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
	}), 'CropLandscape');
	
	exports.default = _default;

/***/ },
/* 2282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
	}), 'CropLandscapeOutlined');
	
	exports.default = _default;

/***/ },
/* 2283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-1 12H6c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1z"
	}), 'CropLandscapeRounded');
	
	exports.default = _default;

/***/ },
/* 2284 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 5H3v14h18V5zm-2 12H5V7h14v10z"
	}), 'CropLandscapeSharp');
	
	exports.default = _default;

/***/ },
/* 2285 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
	}), 'CropLandscapeTwoTone');
	
	exports.default = _default;

/***/ },
/* 2286 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z"
	}), 'CropOriginal');
	
	exports.default = _default;

/***/ },
/* 2287 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z"
	}), 'CropOriginalOutlined');
	
	exports.default = _default;

/***/ },
/* 2288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zm-4.44-6.19l-2.35 3.02-1.56-1.88c-.2-.25-.58-.24-.78.01l-1.74 2.23c-.26.33-.02.81.39.81h8.98c.41 0 .65-.47.4-.8l-2.55-3.39c-.19-.26-.59-.26-.79 0z"
	}), 'CropOriginalRounded');
	
	exports.default = _default;

/***/ },
/* 2289 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zm-2 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z"
	}), 'CropOriginalSharp');
	
	exports.default = _default;

/***/ },
/* 2290 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11z"
	}), 'CropOriginalTwoTone');
	
	exports.default = _default;

/***/ },
/* 2291 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z"
	}), 'CropOutlined');
	
	exports.default = _default;

/***/ },
/* 2292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z"
	}), 'CropPortrait');
	
	exports.default = _default;

/***/ },
/* 2293 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z"
	}), 'CropPortraitOutlined');
	
	exports.default = _default;

/***/ },
/* 2294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16H8c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1z"
	}), 'CropPortraitRounded');
	
	exports.default = _default;

/***/ },
/* 2295 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5v18h14V3zm-2 16H7V5h10v14z"
	}), 'CropPortraitSharp');
	
	exports.default = _default;

/***/ },
/* 2296 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z"
	}), 'CropPortraitTwoTone');
	
	exports.default = _default;

/***/ },
/* 2297 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zM16 14h2V8c0-1.11-.9-2-2-2h-6v2h6v6zm-8 2V4H6v2H4v2h2v8c0 1.1.89 2 2 2h8v2h2v-2h2v-2H8z"
	}), 'CropRotate');
	
	exports.default = _default;

/***/ },
/* 2298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zM16 14h2V8c0-1.11-.9-2-2-2h-6v2h6v6zm-8 2V4H6v2H4v2h2v8c0 1.1.89 2 2 2h8v2h2v-2h2v-2H8z"
	}), 'CropRotateOutlined');
	
	exports.default = _default;

/***/ },
/* 2299 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 9v5h2V8c0-1.1-.9-2-2-2h-6v2h5c.55 0 1 .45 1 1zm3 7H9c-.55 0-1-.45-1-1V5c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-.55 0-1 .45-1 1s.45 1 1 1h1v8c0 1.1.9 2 2 2h8v1c0 .55.45 1 1 1s1-.45 1-1v-1h1c.55 0 1-.45 1-1s-.45-1-1-1zM17.66 1.4C15.99.51 13.83-.11 11.39.04l3.81 3.81 1.33-1.33c3.09 1.46 5.34 4.37 5.89 7.86.06.41.44.69.86.62.41-.06.69-.45.62-.86-.6-3.8-2.96-7-6.24-8.74zM7.47 21.49c-3.09-1.46-5.34-4.37-5.89-7.86-.06-.41-.44-.69-.86-.62-.41.06-.69.45-.62.86.6 3.81 2.96 7.01 6.24 8.75 1.67.89 3.83 1.51 6.27 1.36L8.8 20.16l-1.33 1.33z"
	}), 'CropRotateRounded');
	
	exports.default = _default;

/***/ },
/* 2300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zM16 14h2V6h-8v2h6v6zm-8 2V4H6v2H4v2h2v10h10v2h2v-2h2v-2H8z"
	}), 'CropRotateSharp');
	
	exports.default = _default;

/***/ },
/* 2301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.95 24c.23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11zm.1-24c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zM16 6h-6v2h6v6h2V8c0-1.11-.9-2-2-2zm2 12h2v-2H8V4H6v2H4v2h2v8c0 1.1.89 2 2 2h8v2h2v-2z"
	}), 'CropRotateTwoTone');
	
	exports.default = _default;

/***/ },
/* 2302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 15h2V7c0-1.1-.9-2-2-2H9v2h7c.55 0 1 .45 1 1v7zm-9 2c-.55 0-1-.45-1-1V2c0-.55-.45-1-1-1s-1 .45-1 1v3H2c-.55 0-1 .45-1 1s.45 1 1 1h3v10c0 1.1.9 2 2 2h10v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1H8z"
	}), 'CropRounded');
	
	exports.default = _default;

/***/ },
/* 2303 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 15h2V5H9v2h8v8zM7 17V1H5v4H1v2h4v12h12v4h2v-4h4v-2H7z"
	}), 'CropSharp');
	
	exports.default = _default;

/***/ },
/* 2304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z"
	}), 'CropSquare');
	
	exports.default = _default;

/***/ },
/* 2305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z"
	}), 'CropSquareOutlined');
	
	exports.default = _default;

/***/ },
/* 2306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-1 14H7c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1z"
	}), 'CropSquareRounded');
	
	exports.default = _default;

/***/ },
/* 2307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4v16h16V4zm-2 14H6V6h12v12z"
	}), 'CropSquareSharp');
	
	exports.default = _default;

/***/ },
/* 2308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z"
	}), 'CropSquareTwoTone');
	
	exports.default = _default;

/***/ },
/* 2309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 17c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7V1H5v4H1v2h4v10zm14-2V7c0-1.1-.9-2-2-2H9v2h8v8h2z"
	}), 'CropTwoTone');
	
	exports.default = _default;

/***/ },
/* 2310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
	}), 'Dashboard');
	
	exports.default = _default;

/***/ },
/* 2311 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z"
	}), 'DashboardOutlined');
	
	exports.default = _default;

/***/ },
/* 2312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 13h6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1zm0 8h6c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm10 0h6c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1zM13 4v4c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1z"
	}), 'DashboardRounded');
	
	exports.default = _default;

/***/ },
/* 2313 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
	}), 'DashboardSharp');
	
	exports.default = _default;

/***/ },
/* 2314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 5h4v6H5zm10 8h4v6h-4zM5 17h4v2H5zM15 5h4v2h-4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 13h8V3H3v10zm2-8h4v6H5V5zm8 16h8V11h-8v10zm2-8h4v6h-4v-6zM13 3v6h8V3h-8zm6 4h-4V5h4v2zM3 21h8v-6H3v6zm2-4h4v2H5v-2z"
	})), 'DashboardTwoTone');
	
	exports.default = _default;

/***/ },
/* 2315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z"
	}), 'DataUsage');
	
	exports.default = _default;

/***/ },
/* 2316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z"
	}), 'DataUsageOutlined');
	
	exports.default = _default;

/***/ },
/* 2317 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 3.87v.02c0 .67.45 1.23 1.08 1.43C16.93 6.21 19 8.86 19 12c0 .52-.06 1.01-.17 1.49-.14.64.12 1.3.69 1.64l.01.01c.86.5 1.98.05 2.21-.91.17-.72.26-1.47.26-2.23 0-4.5-2.98-8.32-7.08-9.57-.95-.29-1.92.44-1.92 1.44zm-2.06 15.05c-2.99-.43-5.42-2.86-5.86-5.84-.54-3.6 1.66-6.77 4.83-7.76.64-.19 1.09-.76 1.09-1.43v-.02c0-1-.97-1.73-1.93-1.44-4.51 1.38-7.66 5.86-6.98 10.96.59 4.38 4.13 7.92 8.51 8.51 3.14.42 6.04-.61 8.13-2.53.74-.68.61-1.89-.26-2.39-.58-.34-1.3-.23-1.8.22-1.47 1.34-3.51 2.05-5.73 1.72z"
	}), 'DataUsageRounded');
	
	exports.default = _default;

/***/ },
/* 2318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z"
	}), 'DataUsageSharp');
	
	exports.default = _default;

/***/ },
/* 2319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z"
	}), 'DataUsageTwoTone');
	
	exports.default = _default;

/***/ },
/* 2320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
	}), 'DateRange');
	
	exports.default = _default;

/***/ },
/* 2321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 11h2v2H7v-2zm14-5v14c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2l.01-14c0-1.1.88-2 1.99-2h1V2h2v2h8V2h2v2h1c1.1 0 2 .9 2 2zM5 8h14V6H5v2zm14 12V10H5v10h14zm-4-7h2v-2h-2v2zm-4 0h2v-2h-2v2z"
	}), 'DateRangeOutlined');
	
	exports.default = _default;

/***/ },
/* 2322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4h-1V3c0-.55-.45-1-1-1s-1 .45-1 1v1H8V3c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V9h14v10zM7 11h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"
	}), 'DateRangeRounded');
	
	exports.default = _default;

/***/ },
/* 2323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm4-7h-3V2h-2v2H8V2H6v2H3v18h18V4zm-2 16H5V9h14v11z"
	}), 'DateRangeSharp');
	
	exports.default = _default;

/***/ },
/* 2324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 8h14V6H5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M7 11h2v2H7zm12-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zm-4 3h2v2h-2zm-4 0h2v2h-2z"
	})), 'DateRangeTwoTone');
	
	exports.default = _default;

/***/ },
/* 2325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M22 9L12 2 2 9h9v13h2V9z"
	}), _react.default.createElement("path", {
	  d: "M4.14 12l-1.96.37.82 4.37V22h2l.02-4H7v4h2v-6H4.9zM19.1 16H15v6h2v-4h1.98l.02 4h2v-5.26l.82-4.37-1.96-.37z"
	})), 'Deck');
	
	exports.default = _default;

/***/ },
/* 2326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M22 9L12 2 2 9h9v13h2V9h9zM12 4.44L15.66 7H8.34L12 4.44z"
	}), _react.default.createElement("path", {
	  d: "M4.14 12l-1.96.37.82 4.37V22h2l.02-4H7v4h2v-6H4.9zM19.1 16H15v6h2v-4h1.98l.02 4h2v-5.26l.82-4.37-1.96-.37z"
	})), 'DeckOutlined');
	
	exports.default = _default;

/***/ },
/* 2327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20.41 9c.49 0 .69-.63.29-.91L13.15 2.8c-.69-.48-1.61-.48-2.29 0L3.3 8.09c-.4.28-.2.91.29.91H11v12c0 .55.45 1 1 1s1-.45 1-1V9h7.41z"
	}), _react.default.createElement("path", {
	  d: "M8 16H4.9l-.57-3.02c-.1-.54-.62-.9-1.17-.8-.54.1-.9.62-.8 1.17L3 16.74V21c0 .55.45 1 1 1h.01c.55 0 1-.44 1-.99L5.02 18H7v3c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1zM20.84 12.18c-.54-.1-1.06.26-1.17.8L19.1 16H16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1v-3h1.98l.02 3.01c0 .55.45.99 1 .99s1-.45 1-1v-4.26l.64-3.39c.1-.54-.26-1.07-.8-1.17z"
	})), 'DeckRounded');
	
	exports.default = _default;

/***/ },
/* 2328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M22 9L12 2 2 9h9v13h2V9z"
	}), _react.default.createElement("path", {
	  d: "M4.14 12l-1.96.37.82 4.37V22h2l.02-4H7v4h2v-6H4.9zM19.1 16H15v6h2v-4h1.98l.02 4h2v-5.26l.82-4.37-1.96-.37z"
	})), 'DeckSharp');
	
	exports.default = _default;

/***/ },
/* 2329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4.44L8.34 7h7.32z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M22 9L12 2 2 9h9v13h2V9h9zM12 4.44L15.66 7H8.34L12 4.44z"
	}), _react.default.createElement("path", {
	  d: "M4.14 12l-1.96.37.82 4.37V22h2l.02-4H7v4h2v-6H4.9zM19.1 16H15v6h2v-4h1.98l.02 4h2v-5.26l.82-4.37-1.96-.37z"
	})), 'DeckTwoTone');
	
	exports.default = _default;

/***/ },
/* 2330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 15.5v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20v-2H2z"
	}), 'Dehaze');
	
	exports.default = _default;

/***/ },
/* 2331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 16v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20V6H2z"
	}), 'DehazeOutlined');
	
	exports.default = _default;

/***/ },
/* 2332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 17c0 .55.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1zm0-5c0 .55.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1zm0-5c0 .55.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1z"
	}), 'DehazeRounded');
	
	exports.default = _default;

/***/ },
/* 2333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 16v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20V6H2z"
	}), 'DehazeSharp');
	
	exports.default = _default;

/***/ },
/* 2334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 16v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20V6H2z"
	}), 'DehazeTwoTone');
	
	exports.default = _default;

/***/ },
/* 2335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
	}), 'Delete');
	
	exports.default = _default;

/***/ },
/* 2336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
	}), 'DeleteForever');
	
	exports.default = _default;

/***/ },
/* 2337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.12 10.47L12 12.59l-2.13-2.12-1.41 1.41L10.59 14l-2.12 2.12 1.41 1.41L12 15.41l2.12 2.12 1.41-1.41L13.41 14l2.12-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4zM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9z"
	}), 'DeleteForeverOutlined');
	
	exports.default = _default;

/***/ },
/* 2338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10zm3.17-7.83c.39-.39 1.02-.39 1.41 0L12 12.59l1.42-1.42c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41L13.41 14l1.42 1.42c.39.39.39 1.02 0 1.41-.39.39-1.02.39-1.41 0L12 15.41l-1.42 1.42c-.39.39-1.02.39-1.41 0a.9959.9959 0 010-1.41L10.59 14l-1.42-1.42c-.39-.38-.39-1.02 0-1.41zM15.5 4l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5z"
	}), 'DeleteForeverRounded');
	
	exports.default = _default;

/***/ },
/* 2339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 21h12V7H6v14zm2.46-9.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4h-3.5z"
	}), 'DeleteForeverSharp');
	
	exports.default = _default;

/***/ },
/* 2340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16 9H8v10h8V9zm-.47 7.12l-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12 1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M14.12 10.47L12 12.59l-2.13-2.12-1.41 1.41L10.59 14l-2.12 2.12 1.41 1.41L12 15.41l2.12 2.12 1.41-1.41L13.41 14l2.12-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4zM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9z"
	})), 'DeleteForeverTwoTone');
	
	exports.default = _default;

/***/ },
/* 2341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"
	}), 'DeleteOutline');
	
	exports.default = _default;

/***/ },
/* 2342 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z"
	}), 'DeleteOutlineOutlined');
	
	exports.default = _default;

/***/ },
/* 2343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10zM9 9h6c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1zm6.5-5l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5z"
	}), 'DeleteOutlineRounded');
	
	exports.default = _default;

/***/ },
/* 2344 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 21h12V7H6v14zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z"
	}), 'DeleteOutlineSharp');
	
	exports.default = _default;

/***/ },
/* 2345 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z"
	}), 'DeleteOutlineTwoTone');
	
	exports.default = _default;

/***/ },
/* 2346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z"
	}), 'DeleteOutlined');
	
	exports.default = _default;

/***/ },
/* 2347 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10zM18 4h-2.5l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z"
	}), 'DeleteRounded');
	
	exports.default = _default;

/***/ },
/* 2348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 21h12V7H6v14zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
	}), 'DeleteSharp');
	
	exports.default = _default;

/***/ },
/* 2349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 16h4v2h-4zm0-8h7v2h-7zm0 4h6v2h-6zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zM14 5h-3l-1-1H6L5 5H2v2h12z"
	}), 'DeleteSweep');
	
	exports.default = _default;

/***/ },
/* 2350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 16h4v2h-4zm0-8h7v2h-7zm0 4h6v2h-6zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zm2-8h6v8H5v-8zm5-6H6L5 5H2v2h12V5h-3z"
	}), 'DeleteSweepOutlined');
	
	exports.default = _default;

/***/ },
/* 2351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 16h2c.55 0 1 .45 1 1s-.45 1-1 1h-2c-.55 0-1-.45-1-1s.45-1 1-1zm0-8h5c.55 0 1 .45 1 1s-.45 1-1 1h-5c-.55 0-1-.45-1-1s.45-1 1-1zm0 4h4c.55 0 1 .45 1 1s-.45 1-1 1h-4c-.55 0-1-.45-1-1s.45-1 1-1zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zM13 5h-2l-.71-.71c-.18-.18-.44-.29-.7-.29H6.41c-.26 0-.52.11-.7.29L5 5H3c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1z"
	}), 'DeleteSweepRounded');
	
	exports.default = _default;

/***/ },
/* 2352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 16h4v2h-4v-2zm0-8h7v2h-7V8zm0 4h6v2h-6v-2zM3 20h10V8H3v12zM14 5h-3l-1-1H6L5 5H2v2h12V5z"
	}), 'DeleteSweepSharp');
	
	exports.default = _default;

/***/ },
/* 2353 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 10h6v8H5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M15 16h4v2h-4zm0-8h7v2h-7zm0 4h6v2h-6zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zm2-8h6v8H5v-8zm5-6H6L5 5H2v2h12V5h-3z"
	})), 'DeleteSweepTwoTone');
	
	exports.default = _default;

/***/ },
/* 2354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 9h8v10H8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M15.5 4l-1-1h-5l-1 1H5v2h14V4zM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9z"
	})), 'DeleteTwoTone');
	
	exports.default = _default;

/***/ },
/* 2355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 1c-2.4 0-4.52 1.21-5.78 3.05.01-.01.01-.02.02-.03C9.84 4 9.42 4 9 4c-4.42 0-8 .5-8 4v10c0 .88.39 1.67 1 2.22V22c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22v-3.08c3.39-.49 6-3.39 6-6.92 0-3.87-3.13-7-7-7zM4.5 19c-.83 0-1.5-.67-1.5-1.5S3.67 16 4.5 16s1.5.67 1.5 1.5S5.33 19 4.5 19zM3 13V8h6c0 1.96.81 3.73 2.11 5H3zm10.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm2.5-6c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm.5-9H15v5l3.62 2.16.75-1.23-2.87-1.68z"
	}), 'DepartureBoard');
	
	exports.default = _default;

/***/ },
/* 2356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "5.5",
	  cy: "16.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "12.5",
	  cy: "16.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M16 1c-2.39 0-4.49 1.2-5.75 3.02C9.84 4.01 9.43 4 9 4c-4.42 0-8 .5-8 4v10c0 .88.39 1.67 1 2.22V22c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22v-3.08c3.39-.49 6-3.39 6-6.92 0-3.87-3.13-7-7-7zM9 6h.29c-.09.32-.16.66-.21.99H3.34C3.89 6.46 5.31 6 9 6zM3 8.99h6.08c.16 1.11.57 2.13 1.18 3.01H3V8.99zM15 18c0 .37-.21.62-.34.73l-.29.27H3.63l-.29-.27C3.21 18.62 3 18.37 3 18v-4h9.41c.78.47 1.65.79 2.59.92V18zm1-5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm.5-9H15v5l3.62 2.16.75-1.23-2.87-1.68z"
	})), 'DepartureBoardOutlined');
	
	exports.default = _default;

/***/ },
/* 2357 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.34 1.13c-2.94-.55-5.63.75-7.12 2.92.01-.01.01-.02.02-.03C9.84 4 9.42 4 9 4c-4.42 0-8 .5-8 4v10c0 .88.39 1.67 1 2.22v1.28c0 .83.67 1.5 1.5 1.5S5 22.33 5 21.5V21h8v.5c0 .82.67 1.5 1.5 1.5.82 0 1.5-.67 1.5-1.5v-1.28c.61-.55 1-1.34 1-2.22v-3.08c3.72-.54 6.5-3.98 5.92-7.97-.42-2.9-2.7-5.29-5.58-5.82zM4.5 19c-.83 0-1.5-.67-1.5-1.5S3.67 16 4.5 16s1.5.67 1.5 1.5S5.33 19 4.5 19zM3 13V8h6c0 1.96.81 3.73 2.11 5H3zm10.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm2.5-6c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm-.25-9c-.41 0-.75.34-.75.75v3.68c0 .35.19.68.49.86l2.52 1.51c.34.2.78.09.98-.24.21-.34.1-.79-.25-.99L16.5 8.25v-3.5c0-.41-.34-.75-.75-.75z"
	}), 'DepartureBoardRounded');
	
	exports.default = _default;

/***/ },
/* 2358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.34 1.13c-2.94-.55-5.63.75-7.12 2.92.01-.01.01-.02.02-.03C9.84 4 9.42 4 9 4c-4.42 0-8 .5-8 4v10c0 .88.39 1.67 1 2.22V23h3v-2h8v2h3v-2.78c.61-.55 1-1.34 1-2.22v-3.08c3.72-.54 6.5-3.98 5.92-7.97-.42-2.9-2.7-5.29-5.58-5.82zM4.5 19c-.83 0-1.5-.67-1.5-1.5S3.67 16 4.5 16s1.5.67 1.5 1.5S5.33 19 4.5 19zM3 13V8h6c0 1.96.81 3.73 2.11 5H3zm10.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm2.5-6c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm.5-9H15v5l3.62 2.16.75-1.23-2.87-1.68V4z"
	}), 'DepartureBoardSharp');
	
	exports.default = _default;

/***/ },
/* 2359 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9.29 6H9c-3.69 0-5.11.46-5.66.99h5.74c.05-.33.12-.67.21-.99zM3 14v4c0 .37.21.62.34.73l.29.27h10.74l.29-.27c.13-.11.34-.36.34-.73v-3.08c-.94-.13-1.81-.45-2.59-.92H3zm2.5 4c-.83 0-1.5-.67-1.5-1.5S4.67 15 5.5 15s1.5.67 1.5 1.5S6.33 18 5.5 18zm8.5-1.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "5.5",
	  cy: "16.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "12.5",
	  cy: "16.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M16 1c-2.39 0-4.49 1.2-5.75 3.02C9.84 4.01 9.43 4 9 4c-4.42 0-8 .5-8 4v10c0 .88.39 1.67 1 2.22V22c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22v-3.08c3.39-.49 6-3.39 6-6.92 0-3.87-3.13-7-7-7zM9 6h.29c-.09.32-.16.66-.21.99H3.34C3.89 6.46 5.31 6 9 6zM3 8.99h6.08c.16 1.11.57 2.13 1.18 3.01H3V8.99zM15 18c0 .37-.21.62-.34.73l-.29.27H3.63l-.29-.27C3.21 18.62 3 18.37 3 18v-4h9.41c.78.47 1.65.79 2.59.92V18zm1-5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm.5-9H15v5l3.62 2.16.75-1.23-2.87-1.68z"
	})), 'DepartureBoardTwoTone');
	
	exports.default = _default;

/***/ },
/* 2360 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"
	}), 'Description');
	
	exports.default = _default;

/***/ },
/* 2361 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"
	}), 'DescriptionOutlined');
	
	exports.default = _default;

/***/ },
/* 2362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.59 2.59c-.38-.38-.89-.59-1.42-.59H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8.83c0-.53-.21-1.04-.59-1.41l-4.82-4.83zM15 18H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1zm0-4H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1zm-2-6V3.5L18.5 9H14c-.55 0-1-.45-1-1z"
	}), 'DescriptionRounded');
	
	exports.default = _default;

/***/ },
/* 2363 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 2H4v20h16V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"
	}), 'DescriptionSharp');
	
	exports.default = _default;

/***/ },
/* 2364 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M13 4H6v16h12V9h-5V4zm3 14H8v-2h8v2zm0-6v2H8v-2h8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"
	})), 'DescriptionTwoTone');
	
	exports.default = _default;

/***/ },
/* 2365 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 16c0 1.1-.9 2-2 2h-1l-2-2h3V4H6L4 2h17c1.1 0 2 .9 2 2v12zm-5.5 2l-2-2zm-2.6 0l6 6 1.3-1.3-4.7-4.7-2-2L1.2 1.8 0 3.1l1 1V16c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h.9zM3 16V6.1l9.9 9.9H3z"
	}), 'DesktopAccessDisabled');
	
	exports.default = _default;

/***/ },
/* 2366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1.41 1.69L0 3.1l1 .99V16c0 1.1.89 2 1.99 2H10v2H8v2h8v-2h-2v-2h.9l6 6 1.41-1.41-20.9-20.9zM2.99 16V6.09L12.9 16H2.99zM4.55 2l2 2H21v12h-2.45l2 2h.44c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4.55z"
	}), 'DesktopAccessDisabledOutlined');
	
	exports.default = _default;

/***/ },
/* 2367 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M.31 2c-.39.39-.39 1.02 0 1.41l.69.68V16c0 1.1.9 2 2 2h7v2H9c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1h-1v-2h.9l5.29 5.29c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L1.72 2A.9959.9959 0 00.31 2zm2.68 13V6.09L12.9 16H3.99c-.55 0-1-.45-1-1zM4.55 2l2 2H20c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1h-1.45l2 2h.44c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4.55z"
	}), 'DesktopAccessDisabledRounded');
	
	exports.default = _default;

/***/ },
/* 2368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1.41 1.69L0 3.1l1 .99V18h9v2H8v2h8v-2h-2v-2h.9l6 6 1.41-1.41-20.9-20.9zM2.99 16V6.09L12.9 16H2.99zM4.55 2l2 2H21v12h-2.45l2 2h2.44V2z"
	}), 'DesktopAccessDisabledSharp');
	
	exports.default = _default;

/***/ },
/* 2369 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M1.41 1.69L0 3.1l1 .99V16c0 1.1.89 2 1.99 2H10v2H8v2h8v-2h-2v-2h.9l6 6 1.41-1.41-20.9-20.9zM2.99 16V6.09L12.9 16H2.99zM4.55 2l2 2H21v12h-2.45l2 2h.44c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4.55z"
	}), _react.default.createElement("path", {
	  d: "M2.99 6.09V16h9.91zM6.55 4l12 12H21V4z",
	  opacity: ".3"
	})), 'DesktopAccessDisabledTwoTone');
	
	exports.default = _default;

/***/ },
/* 2370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z"
	}), 'DesktopMac');
	
	exports.default = _default;

/***/ },
/* 2371 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z"
	}), 'DesktopMacOutlined');
	
	exports.default = _default;

/***/ },
/* 2372 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-1.63 2.45c-.44.66.03 1.55.83 1.55h5.6c.8 0 1.28-.89.83-1.55L14 18h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V5c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v9z"
	}), 'DesktopMacRounded');
	
	exports.default = _default;

/***/ },
/* 2373 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 2H1v16h9l-2 3v1h8v-1l-2-3h9V2zm-2 12H3V4h18v10z"
	}), 'DesktopMacSharp');
	
	exports.default = _default;

/***/ },
/* 2374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 4h18v10H3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z"
	})), 'DesktopMacTwoTone');
	
	exports.default = _default;

/***/ },
/* 2375 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z"
	}), 'DesktopWindows');
	
	exports.default = _default;

/***/ },
/* 2376 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z"
	}), 'DesktopWindowsOutlined');
	
	exports.default = _default;

/***/ },
/* 2377 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H9c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1h-1v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 14H4c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1z"
	}), 'DesktopWindowsRounded');
	
	exports.default = _default;

/***/ },
/* 2378 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 2H1v16h9v2H8v2h8v-2h-2v-2h9V2zm-2 14H3V4h18v12z"
	}), 'DesktopWindowsSharp');
	
	exports.default = _default;

/***/ },
/* 2379 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 4h18v12H3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z"
	})), 'DesktopWindowsTwoTone');
	
	exports.default = _default;

/***/ },
/* 2380 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 4l9 16 9-16H3zm3.38 2h11.25L12 16 6.38 6z"
	}), 'Details');
	
	exports.default = _default;

/***/ },
/* 2381 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 4l9 16 9-16H3zm3.38 2h11.25L12 16 6.38 6z"
	}), 'DetailsOutlined');
	
	exports.default = _default;

/***/ },
/* 2382 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.84 5.49l7.29 12.96c.38.68 1.36.68 1.74 0l7.29-12.96c.38-.67-.11-1.49-.87-1.49H4.71c-.76 0-1.25.82-.87 1.49zM6.38 6h11.25L12 16 6.38 6z"
	}), 'DetailsRounded');
	
	exports.default = _default;

/***/ },
/* 2383 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 4l9 16 9-16H3zm3.38 2h11.25L12 16 6.38 6z"
	}), 'DetailsSharp');
	
	exports.default = _default;

/***/ },
/* 2384 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6.38 6L12 16l5.63-10z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 4l9 16 9-16H3zm3.38 2h11.25L12 16 6.38 6z"
	})), 'DetailsTwoTone');
	
	exports.default = _default;

/***/ },
/* 2385 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14zM6 13h5v4H6zm6-6h4v3h-4zM6 7h5v5H6zm6 4h4v6h-4z"
	}), 'DeveloperBoard');
	
	exports.default = _default;

/***/ },
/* 2386 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14zM6 13h5v4H6v-4zm6-6h4v3h-4V7zM6 7h5v5H6V7zm6 4h4v6h-4v-6z"
	}), 'DeveloperBoardOutlined');
	
	exports.default = _default;

/***/ },
/* 2387 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 8c0-.55-.45-1-1-1h-1V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h1c.55 0 1-.45 1-1s-.45-1-1-1h-1v-2h1c.55 0 1-.45 1-1s-.45-1-1-1h-1V9h1c.55 0 1-.45 1-1zm-5 11H5c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zM6.5 13h4c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-4c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5zm6-6h3c.28 0 .5.22.5.5v2c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-2c0-.28.22-.5.5-.5zm-6 0h4c.28 0 .5.22.5.5v4c0 .28-.22.5-.5.5h-4c-.28 0-.5-.22-.5-.5v-4c0-.28.22-.5.5-.5zm6 4h3c.28 0 .5.22.5.5v5c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-5c0-.28.22-.5.5-.5z"
	}), 'DeveloperBoardRounded');
	
	exports.default = _default;

/***/ },
/* 2388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 9V7h-2V3H2v18h18v-4h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14zM6 13h5v4H6v-4zm6-6h4v3h-4V7zM6 7h5v5H6V7zm6 4h4v6h-4v-6z"
	}), 'DeveloperBoardSharp');
	
	exports.default = _default;

/***/ },
/* 2389 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 19h14V5H4v14zm8-12h4v3h-4V7zm0 4h4v6h-4v-6zM6 7h5v5H6V7zm0 6h5v4H6v-4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M6 13h5v4H6zm0-6h5v5H6zm6 0h4v3h-4zm0 4h4v6h-4zm10-2V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14z"
	})), 'DeveloperBoardTwoTone');
	
	exports.default = _default;

/***/ },
/* 2390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z"
	}), 'DeveloperMode');
	
	exports.default = _default;

/***/ },
/* 2391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z"
	}), 'DeveloperModeOutlined');
	
	exports.default = _default;

/***/ },
/* 2392 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 5h10v1c0 .55.45 1 1 1s1-.45 1-1V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v3c0 .55.45 1 1 1s1-.45 1-1V5zm9.12 10.88l3.17-3.17c.39-.39.39-1.02 0-1.41l-3.17-3.17c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41L17.17 12l-2.47 2.47c-.39.39-.39 1.02 0 1.41.39.39 1.03.39 1.42 0zm-6.83-1.42L6.83 12l2.46-2.46c.39-.39.39-1.02 0-1.41-.39-.39-1.03-.39-1.42 0L4.7 11.3c-.39.39-.39 1.02 0 1.41l3.17 3.17c.39.39 1.03.39 1.42 0 .4-.39.39-1.03 0-1.42zM17 19H7v-1c0-.55-.45-1-1-1s-1 .45-1 1v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v1z"
	}), 'DeveloperModeRounded');
	
	exports.default = _default;

/***/ },
/* 2393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 5h10v2h2V1.01L5 1v6h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v6h14v-6h-2v2z"
	}), 'DeveloperModeSharp');
	
	exports.default = _default;

/***/ },
/* 2394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z"
	}), 'DeveloperModeTwoTone');
	
	exports.default = _default;

/***/ },
/* 2395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z"
	}), 'DeviceHub');
	
	exports.default = _default;

/***/ },
/* 2396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z"
	}), 'DeviceHubOutlined');
	
	exports.default = _default;

/***/ },
/* 2397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 16l-4-4V8.82c1.35-.49 2.26-1.89 1.93-3.46-.25-1.18-1.23-2.12-2.42-2.32C10.63 2.73 9 4.17 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H4c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-2.05l4-4.2 4 4.2V20c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3z"
	}), 'DeviceHubRounded');
	
	exports.default = _default;

/***/ },
/* 2398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z"
	}), 'DeviceHubSharp');
	
	exports.default = _default;

/***/ },
/* 2399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z"
	}), 'DeviceHubTwoTone');
	
	exports.default = _default;

/***/ },
/* 2400 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14zM12 6.72c-1.96 0-3.5 1.52-3.5 3.47h1.75c0-.93.82-1.75 1.75-1.75s1.75.82 1.75 1.75c0 1.75-2.63 1.57-2.63 4.45h1.76c0-1.96 2.62-2.19 2.62-4.45 0-1.96-1.54-3.47-3.5-3.47zm-.88 8.8h1.76v1.76h-1.76z"
	}), 'DeviceUnknown');
	
	exports.default = _default;

/***/ },
/* 2401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14zM12 6.72c-1.96 0-3.5 1.52-3.5 3.47h1.75c0-.93.82-1.75 1.75-1.75s1.75.82 1.75 1.75c0 1.75-2.63 1.57-2.63 4.45h1.76c0-1.96 2.62-2.19 2.62-4.45 0-1.96-1.54-3.47-3.5-3.47zM11 16h2v2h-2v-2z"
	}), 'DeviceUnknownOutlined');
	
	exports.default = _default;

/***/ },
/* 2402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14zm-6-3h2v2h-2zm-1.48-5.81h.13c.33 0 .59-.23.7-.54.24-.69.91-1.21 1.66-1.21.93 0 1.75.82 1.75 1.75 0 1.32-1.49 1.55-2.23 2.82h-.01c-.08.14-.14.29-.2.45-.01.02-.02.03-.02.05-.01.02-.01.04-.01.05-.1.31-.16.66-.16 1.08h1.76c0-.25.04-.47.12-.67.54-1.47 2.77-1.86 2.48-4.18-.19-1.55-1.43-2.84-2.98-3.04-1.77-.23-3.29.78-3.81 2.3-.2.56.23 1.14.82 1.14z"
	}), 'DeviceUnknownRounded');
	
	exports.default = _default;

/***/ },
/* 2403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 1H5v22h14V1zm-2 18H7V5h10v14zM12 6.72c-1.96 0-3.5 1.52-3.5 3.47h1.75c0-.93.82-1.75 1.75-1.75s1.75.82 1.75 1.75c0 1.75-2.63 1.57-2.63 4.45h1.76c0-1.96 2.62-2.19 2.62-4.45 0-1.96-1.54-3.47-3.5-3.47zM11 16h2v2h-2v-2z"
	}), 'DeviceUnknownSharp');
	
	exports.default = _default;

/***/ },
/* 2404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 19h10V5H7v14zm6-1h-2v-2h2v2zM12 6.72c1.96 0 3.5 1.51 3.5 3.47 0 2.26-2.62 2.49-2.62 4.45h-1.76c0-2.88 2.63-2.7 2.63-4.45 0-.93-.82-1.75-1.75-1.75s-1.75.82-1.75 1.75H8.5c0-1.95 1.54-3.47 3.5-3.47z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11 16h2v2h-2zm6-15H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14zM12 8.44c.93 0 1.75.82 1.75 1.75 0 1.75-2.63 1.57-2.63 4.45h1.76c0-1.96 2.62-2.19 2.62-4.45 0-1.96-1.54-3.47-3.5-3.47s-3.5 1.52-3.5 3.47h1.75c0-.93.82-1.75 1.75-1.75z"
	})), 'DeviceUnknownTwoTone');
	
	exports.default = _default;

/***/ },
/* 2405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
	}), 'Devices');
	
	exports.default = _default;

/***/ },
/* 2406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6zm10 6H9v1.78c-.61.55-1 1.33-1 2.22s.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8z"
	}), 'DevicesOther');
	
	exports.default = _default;

/***/ },
/* 2407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6zm10 6H9v1.78c-.61.55-1 1.33-1 2.22 0 .89.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8z"
	}), 'DevicesOtherOutlined');
	
	exports.default = _default;

/***/ },
/* 2408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 7c0-.55.45-1 1-1h16c.55 0 1-.45 1-1s-.45-1-1-1H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h3c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1-.45-1-1V7zm9 5h-2c-.55 0-1 .45-1 1v.78c-.61.55-1 1.33-1 2.22 0 .89.39 1.67 1 2.22V19c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V13c0-.55-.45-1-1-1zm-1 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8z"
	}), 'DevicesOtherRounded');
	
	exports.default = _default;

/***/ },
/* 2409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 6h18V4H1v16h6v-2H3V6zm10 6H9v1.78c-.61.55-1 1.33-1 2.22 0 .89.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM23 8h-8v12h8V8zm-2 10h-4v-8h4v8z"
	}), 'DevicesOtherSharp');
	
	exports.default = _default;

/***/ },
/* 2410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17 10h4v8h-4z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "11",
	  cy: "16",
	  r: "1.5",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6zm19 2h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8zm-8-6H9v1.78c-.61.55-1 1.33-1 2.22s.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	})), 'DevicesOtherTwoTone');
	
	exports.default = _default;

/***/ },
/* 2411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
	}), 'DevicesOutlined');
	
	exports.default = _default;

/***/ },
/* 2412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 7c0-.55.45-1 1-1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-1.1 0-2 .9-2 2v11h-.5c-.83 0-1.5.67-1.5 1.5S.67 20 1.5 20H14v-3H4V7zm19 1h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
	}), 'DevicesRounded');
	
	exports.default = _default;

/***/ },
/* 2413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6h18V4H2v13H0v3h14v-3H4V6zm20 2h-8v12h8V8zm-2 9h-4v-7h4v7z"
	}), 'DevicesSharp');
	
	exports.default = _default;

/***/ },
/* 2414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18 10h4v7h-4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M23 8h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7zM4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6z"
	})), 'DevicesTwoTone');
	
	exports.default = _default;

/***/ },
/* 2415 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3h-1v5h1V3zm-2 2h-2V4h2V3h-3v3h2v1h-2v1h3V5zm3-2v5h1V6h2V3h-3zm2 2h-1V4h1v1zm0 10.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.01.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.27-.26.35-.65.24-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"
	}), 'DialerSip');
	
	exports.default = _default;

/***/ },
/* 2416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 3h1v5h-1zm-1 2h-2V4h2V3h-3v3h2v1h-2v1h3zm3-2v5h1V6h2V3h-3zm2 2h-1V4h1v1zm0 10.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.7.29l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.27-.26.35-.65.24-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.46 2.59L5.79 8.8c-.41-1.21-.67-2.48-.76-3.8zM19 18.97c-1.32-.09-2.59-.35-3.8-.75l1.2-1.2c.85.24 1.71.39 2.59.45v1.5z"
	}), 'DialerSipOutlined');
	
	exports.default = _default;

/***/ },
/* 2417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.5 8c.28 0 .5-.22.5-.5v-4c0-.28-.22-.5-.5-.5s-.5.22-.5.5v4c0 .28.22.5.5.5zm-4-1c-.28 0-.5.22-.5.5s.22.5.5.5h1.95c.3 0 .55-.25.55-.55v-1.9c0-.3-.25-.55-.55-.55H13V4h1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-1.95c-.3 0-.55.25-.55.55v1.89c0 .31.25.56.55.56H14v1h-1.5zm7.95-4h-1.89c-.31 0-.56.25-.56.55V7.5c0 .28.22.5.5.5s.5-.22.5-.5V6h1.45c.3 0 .55-.25.55-.55v-1.9c0-.3-.25-.55-.55-.55zM20 5h-1V4h1v1zm-.79 10.27l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.04.57-1.64l-.29-2.52c-.11-1.01-.97-1.78-1.98-1.78H5.02c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1-.76-1.86-1.77-1.97z"
	}), 'DialerSipRounded');
	
	exports.default = _default;

/***/ },
/* 2418 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 3h1v5h-1zm-1 2h-2V4h2V3h-3v3h2v1h-2v1h3zm3-2v5h1V6h2V3h-3zm2 2h-1V4h1v1zm1 10.46l-5.27-.61-2.52 2.52c-2.83-1.44-5.15-3.75-6.59-6.59l2.53-2.53L8.54 3H3.03C2.45 13.18 10.82 21.55 21 20.97v-5.51z"
	}), 'DialerSipSharp');
	
	exports.default = _default;

/***/ },
/* 2419 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.2 18.21c1.2.41 2.48.67 3.8.75v-1.5c-.88-.06-1.75-.22-2.59-.45l-1.21 1.2zM6.54 5h-1.5c.09 1.32.35 2.59.75 3.79l1.2-1.21c-.24-.83-.39-1.7-.45-2.58z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16 3h1v5h-1zm-4 4v1h3V5h-2V4h2V3h-3v3h2v1zm9-4h-3v5h1V6h2V3zm-1 2h-1V4h1v1zm1 11.5c0-.55-.45-1-1-1-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.7.29l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.27-.26.35-.65.24-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5zM5.03 5h1.5c.07.88.22 1.75.46 2.59L5.79 8.8c-.41-1.21-.67-2.48-.76-3.8zM19 18.97c-1.32-.09-2.59-.35-3.8-.75l1.2-1.2c.85.24 1.71.39 2.59.45v1.5z"
	})), 'DialerSipTwoTone');
	
	exports.default = _default;

/***/ },
/* 2420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'Dialpad');
	
	exports.default = _default;

/***/ },
/* 2421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'DialpadOutlined');
	
	exports.default = _default;

/***/ },
/* 2422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'DialpadRounded');
	
	exports.default = _default;

/***/ },
/* 2423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'DialpadSharp');
	
	exports.default = _default;

/***/ },
/* 2424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm2 8c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-8 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM6 5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm12-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0-6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0-6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0-6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
	}), 'DialpadTwoTone');
	
	exports.default = _default;

/***/ },
/* 2425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.71 11.29l-9-9a.9959.9959 0 00-1.41 0l-9 9c-.39.39-.39 1.02 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9c.39-.38.39-1.01 0-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z"
	}), 'Directions');
	
	exports.default = _default;

/***/ },
/* 2426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"
	}), 'DirectionsBike');
	
	exports.default = _default;

/***/ },
/* 2427 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"
	}), 'DirectionsBikeOutlined');
	
	exports.default = _default;

/***/ },
/* 2428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.06 1.06 2.38 1.78 3.96 2.02.6.09 1.14-.39 1.14-1 0-.49-.37-.91-.85-.99-1.11-.18-2.02-.71-2.75-1.43l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v4c0 .55.45 1 1 1s1-.45 1-1v-4.4c0-.52-.2-1.01-.55-1.38L10.8 10.5zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"
	}), 'DirectionsBikeRounded');
	
	exports.default = _default;

/***/ },
/* 2429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L6.31 9.9 11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"
	}), 'DirectionsBikeSharp');
	
	exports.default = _default;

/***/ },
/* 2430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 22c2.8 0 5-2.2 5-5s-2.2-5-5-5-5 2.2-5 5 2.2 5 5 5zm0-8.5c1.9 0 3.5 1.6 3.5 3.5S6.9 20.5 5 20.5 1.5 18.9 1.5 17s1.6-3.5 3.5-3.5zm2.8-2.3L11 14v5h2v-6.2l-2.2-2.3 2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"
	}), 'DirectionsBikeTwoTone');
	
	exports.default = _default;

/***/ },
/* 2431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 2.52 1.29 5.48 1.29 8 0 1.26.65 2.62.99 4 .99h2v-2h-2zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.26.08-.48.26-.6.5s-.15.52-.06.78L3.95 19zM6 6h12v3.97L12 8 6 9.97V6z"
	}), 'DirectionsBoat');
	
	exports.default = _default;

/***/ },
/* 2432 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 3v1h-2V3h2m-1 7.11l5.38 1.77 2.39.78-1.12 3.97c-.54-.3-.94-.71-1.14-.94L16 13.96l-1.51 1.72c-.34.4-1.28 1.32-2.49 1.32s-2.15-.92-2.49-1.32L8 13.96l-1.51 1.72c-.2.23-.6.63-1.14.93l-1.13-3.96 2.4-.79L12 10.11M15 1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.26.08-.48.26-.6.5s-.15.52-.06.78L3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1zM6 9.97V6h12v3.97L12 8 6 9.97zm10 9.71c-1.22.85-2.61 1.28-4 1.28s-2.78-.43-4-1.28C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 1.26.64 2.63.97 4 .97s2.74-.32 4-.97c1.26.65 2.62.99 4 .99h2v-2h-2c-1.39 0-2.78-.47-4-1.32z"
	}), 'DirectionsBoatOutlined');
	
	exports.default = _default;

/***/ },
/* 2433 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 21c-1.29 0-2.58-.41-3.74-1.14-.16-.1-.37-.1-.53 0-2.31 1.47-5.16 1.47-7.47 0-.16-.1-.37-.1-.53 0C6.58 20.59 5.29 21 4 21H3c-.55 0-1 .45-1 1s.45 1 1 1h1c1.38 0 2.74-.35 4-.99 2.52 1.29 5.48 1.29 8 0 1.26.65 2.62.99 4 .99h1c.55 0 1-.45 1-1s-.45-1-1-1h-1zM3.95 19H4c1.42 0 2.7-.7 3.66-1.64.19-.18.5-.18.69 0C9.3 18.3 10.58 19 12 19s2.7-.7 3.66-1.64c.19-.19.49-.19.69 0C17.3 18.3 18.58 19 20 19h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V2c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v2H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.26.08-.48.26-.6.5s-.15.52-.06.78L3.95 19zM7 6h10c.55 0 1 .45 1 1v2.97L12.62 8.2c-.41-.13-.84-.13-1.25 0L6 9.97V7c0-.55.45-1 1-1z"
	}), 'DirectionsBoatRounded');
	
	exports.default = _default;

/***/ },
/* 2434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 2.52 1.29 5.48 1.29 8 0 1.26.65 2.62.99 4 .99h2v-2h-2zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l2.18-7.65-2.23-.73V4h-5V1H9v3H4v6.62l-2.23.73L3.95 19zM6 6h12v3.97L12 8 6 9.97V6z"
	}), 'DirectionsBoatSharp');
	
	exports.default = _default;

/***/ },
/* 2435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6.49 15.68L8 13.96l1.51 1.72c.34.4 1.28 1.32 2.49 1.32 1.21 0 2.15-.92 2.49-1.32L16 13.96l1.51 1.72c.2.23.6.64 1.14.94l1.12-3.97-2.39-.78L12 10.11l-5.38 1.77-2.4.79 1.13 3.96c.55-.31.94-.72 1.14-.95zM11 3h2v1h-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.26.08-.48.26-.6.5s-.15.52-.06.78L3.95 19zM11 3h2v1h-2V3zM6 6h12v3.97L12 8 6 9.97V6zm.62 5.87L12 10.11l5.38 1.77 2.39.78-1.12 3.97c-.54-.3-.94-.71-1.14-.94L16 13.96l-1.51 1.72c-.34.4-1.28 1.32-2.49 1.32-1.21 0-2.15-.92-2.49-1.32L8 13.96l-1.51 1.72c-.2.23-.6.63-1.14.93l-1.13-3.96 2.4-.78zM8 22.01c1.26.64 2.63.97 4 .97s2.74-.32 4-.97c1.26.65 2.62.99 4 .99h2v-2h-2c-1.39 0-2.78-.47-4-1.32-1.22.85-2.61 1.28-4 1.28s-2.78-.43-4-1.28C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99z"
	})), 'DirectionsBoatTwoTone');
	
	exports.default = _default;

/***/ },
/* 2436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z"
	}), 'DirectionsBus');
	
	exports.default = _default;

/***/ },
/* 2437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2c-4.42 0-8 .5-8 4v10c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4zm5.66 2.99H6.34C6.89 4.46 8.31 4 12 4s5.11.46 5.66.99zm.34 2V10H6V6.99h12zm-.34 9.74l-.29.27H6.63l-.29-.27C6.21 16.62 6 16.37 6 16v-4h12v4c0 .37-.21.62-.34.73z"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "14.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "14.5",
	  r: "1.5"
	})), 'DirectionsBusOutlined');
	
	exports.default = _default;

/***/ },
/* 2438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 16c0 .88.39 1.67 1 2.22v1.28c0 .83.67 1.5 1.5 1.5S8 20.33 8 19.5V19h8v.5c0 .82.67 1.5 1.5 1.5.82 0 1.5-.67 1.5-1.5v-1.28c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z"
	}), 'DirectionsBusRounded');
	
	exports.default = _default;

/***/ },
/* 2439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 16c0 .88.39 1.67 1 2.22V21h3v-2h8v2h3v-2.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z"
	}), 'DirectionsBusSharp');
	
	exports.default = _default;

/***/ },
/* 2440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17.37 17l.29-.27c.13-.11.34-.36.34-.73v-4H6v4c0 .37.21.62.34.73l.29.27h10.74zM8.5 16c-.83 0-1.5-.67-1.5-1.5S7.67 13 8.5 13s1.5.67 1.5 1.5S9.33 16 8.5 16zm5.5-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5zM12 4c-3.69 0-5.11.46-5.66.99h11.31C17.11 4.46 15.69 4 12 4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 21h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1zM12 4c3.69 0 5.11.46 5.66.99H6.34C6.89 4.46 8.31 4 12 4zM6 6.99h12V10H6V6.99zM8 17H6.63l-.29-.27C6.21 16.62 6 16.37 6 16v-4h12v4c0 .37-.21.62-.34.73l-.29.27H8z"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "14.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "14.5",
	  r: "1.5"
	})), 'DirectionsBusTwoTone');
	
	exports.default = _default;

/***/ },
/* 2441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
	}), 'DirectionsCar');
	
	exports.default = _default;

/***/ },
/* 2442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 7h10.29l1.08 3.11H5.77L6.85 7zM19 17H5v-5h14v5z"
	}), _react.default.createElement("circle", {
	  cx: "7.5",
	  cy: "14.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "14.5",
	  r: "1.5"
	})), 'DirectionsCarOutlined');
	
	exports.default = _default;

/***/ },
/* 2443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01l-1.97 5.67c-.07.21-.11.43-.11.66v7.16c0 .83.67 1.5 1.5 1.5S6 20.33 6 19.5V19h12v.5c0 .82.67 1.5 1.5 1.5.82 0 1.5-.67 1.5-1.5v-7.16c0-.22-.04-.45-.11-.66l-1.97-5.67zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.27-3.82c.14-.4.52-.68.95-.68h9.56c.43 0 .81.28.95.68L19 11H5z"
	}), 'DirectionsCarRounded');
	
	exports.default = _default;

/***/ },
/* 2444 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.58 5H5.43L3 12v9h3v-2h12v2h3v-9l-2.42-7zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
	}), 'DirectionsCarSharp');
	
	exports.default = _default;

/***/ },
/* 2445 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 17h14v-5H5v5zm11.5-4c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-9 0c.83 0 1.5.67 1.5 1.5S8.33 16 7.5 16 6 15.33 6 14.5 6.67 13 7.5 13z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 7h10.29l1.08 3.11H5.77L6.85 7zM19 17H5v-5h14v5z"
	}), _react.default.createElement("circle", {
	  cx: "7.5",
	  cy: "14.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "14.5",
	  r: "1.5"
	})), 'DirectionsCarTwoTone');
	
	exports.default = _default;

/***/ },
/* 2446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22.43 10.59l-9.01-9.01c-.75-.75-2.07-.76-2.83 0l-9 9c-.78.78-.78 2.04 0 2.82l9 9c.39.39.9.58 1.41.58.51 0 1.02-.19 1.41-.58l8.99-8.99c.79-.76.8-2.02.03-2.82zm-10.42 10.4l-9-9 9-9 9 9-9 9zM8 11v4h2v-3h4v2.5l3.5-3.5L14 7.5V10H9c-.55 0-1 .45-1 1z"
	}), 'DirectionsOutlined');
	
	exports.default = _default;

/***/ },
/* 2447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 15.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-7H6V5h12v5z"
	}), 'DirectionsRailway');
	
	exports.default = _default;

/***/ },
/* 2448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 1c-4.42 0-8 .5-8 4v10.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4zm0 2c6 0 6 1.2 6 2H6c0-.8 0-2 6-2zm6 4v3H6V7h12zm-1.5 10h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5c0 .83-.67 1.5-1.5 1.5zM12 12.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'DirectionsRailwayOutlined');
	
	exports.default = _default;

/***/ },
/* 2449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 15.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-7H6V5h12v5zM4 15.5C4 17.43 5.57 19 7.5 19l-1.14 1.15c-.32.31-.1.85.35.85h10.58c.45 0 .67-.54.35-.85L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-7H6V5h12v5z"
	}), 'DirectionsRailwayRounded');
	
	exports.default = _default;

/***/ },
/* 2450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 15.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-7H6V5h12v5z"
	}), 'DirectionsRailwaySharp');
	
	exports.default = _default;

/***/ },
/* 2451 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 15.5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V12H6v3.5zm6-3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM12 3C6 3 6 4.2 6 5h12c0-.8 0-2-6-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 15.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5zm-2 0c0 .83-.67 1.5-1.5 1.5h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5zm0-5.5H6V7h12v3zM6 5c0-.8 0-2 6-2s6 1.2 6 2H6zm6 11.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
	})), 'DirectionsRailwayTwoTone');
	
	exports.default = _default;

/***/ },
/* 2452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.71 11.29l-9-9a.9959.9959 0 00-1.41 0l-9 9c-.39.39-.39 1.02 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9c.39-.38.39-1.01 0-1.41zM14 14.5V12h-4v2c0 .55-.45 1-1 1s-1-.45-1-1v-3c0-.55.45-1 1-1h5V7.5l3.15 3.15c.2.2.2.51 0 .71L14 14.5z"
	}), 'DirectionsRounded');
	
	exports.default = _default;

/***/ },
/* 2453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z"
	}), 'DirectionsRun');
	
	exports.default = _default;

/***/ },
/* 2454 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z"
	}), 'DirectionsRunOutlined');
	
	exports.default = _default;

/***/ },
/* 2455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.17 12l.57-2.5 2.1 2v5c0 .55.45 1 1 1s1-.45 1-1v-5.64c0-.55-.22-1.07-.62-1.45l-1.48-1.41.6-3c1.07 1.24 2.62 2.13 4.36 2.41.6.09 1.14-.39 1.14-1 0-.49-.36-.9-.85-.98-1.52-.25-2.78-1.15-3.45-2.33l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L7.21 7.76c-.74.32-1.22 1.04-1.22 1.85v2.37c0 .55.45 1 1 1s1-.45 1-1v-2.4l1.8-.7-1.6 8.1-3.92-.8c-.54-.11-1.07.24-1.18.78V17c-.11.54.24 1.07.78 1.18l4.11.82c1.06.21 2.1-.46 2.34-1.52z"
	}), 'DirectionsRunRounded');
	
	exports.default = _default;

/***/ },
/* 2456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z"
	}), 'DirectionsRunSharp');
	
	exports.default = _default;

/***/ },
/* 2457 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.49 3.48c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2zm-.6 11.5l2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4 1-4.4z"
	}), 'DirectionsRunTwoTone');
	
	exports.default = _default;

/***/ },
/* 2458 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22.41 12L12 1.59 1.59 11.99 12 22.41 22.41 12zM14 14.5V12h-4v3H8v-5h6V7.5l3.5 3.5-3.5 3.5z"
	}), 'DirectionsSharp');
	
	exports.default = _default;

/***/ },
/* 2459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z"
	}), 'DirectionsSubway');
	
	exports.default = _default;

/***/ },
/* 2460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zm5.66 3H6.43c.61-.52 2.06-1 5.57-1 3.71 0 5.12.46 5.66 1zM11 7v3H6V7h5zm2 0h5v3h-5V7zm3.5 10h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5c0 .83-.67 1.5-1.5 1.5z"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "14.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "14.5",
	  r: "1.5"
	})), 'DirectionsSubwayOutlined');
	
	exports.default = _default;

/***/ },
/* 2461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19l-1.15 1.15c-.31.31-.09.85.36.85H17.3c.45 0 .67-.54.35-.85L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z"
	}), 'DirectionsSubwayRounded');
	
	exports.default = _default;

/***/ },
/* 2462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z"
	}), 'DirectionsSubwaySharp');
	
	exports.default = _default;

/***/ },
/* 2463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-3.51 0-4.96.48-5.57 1h11.23c-.54-.54-1.95-1-5.66-1zM6 15.5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V12H6v3.5zm9.5-2.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-7 0c.83 0 1.5.67 1.5 1.5S9.33 16 8.5 16 7 15.33 7 14.5 7.67 13 8.5 13z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zm0 2c3.71 0 5.12.46 5.66 1H6.43c.61-.52 2.06-1 5.57-1zM6 7h5v3H6V7zm12 8.5c0 .83-.67 1.5-1.5 1.5h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5zm0-5.5h-5V7h5v3z"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "14.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "14.5",
	  r: "1.5"
	})), 'DirectionsSubwayTwoTone');
	
	exports.default = _default;

/***/ },
/* 2464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z"
	}), 'DirectionsTransit');
	
	exports.default = _default;

/***/ },
/* 2465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zm5.66 3H6.43c.61-.52 2.06-1 5.57-1 3.71 0 5.12.46 5.66 1zM11 7v3H6V7h5zm2 0h5v3h-5V7zm3.5 10h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5c0 .83-.67 1.5-1.5 1.5z"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "14.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "14.5",
	  r: "1.5"
	})), 'DirectionsTransitOutlined');
	
	exports.default = _default;

/***/ },
/* 2466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19l-1.15 1.15c-.31.31-.09.85.36.85H17.3c.45 0 .67-.54.35-.85L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z"
	}), 'DirectionsTransitRounded');
	
	exports.default = _default;

/***/ },
/* 2467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z"
	}), 'DirectionsTransitSharp');
	
	exports.default = _default;

/***/ },
/* 2468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-3.51 0-4.96.48-5.57 1h11.23c-.54-.54-1.95-1-5.66-1zM7.5 17h9c.83 0 1.5-.67 1.5-1.5V12H6v3.5c0 .83.67 1.5 1.5 1.5zm8-4c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-7 0c.83 0 1.5.67 1.5 1.5S9.33 16 8.5 16 7 15.33 7 14.5 7.67 13 8.5 13z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 6v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4-4 0-8 .5-8 4zm14 4h-5V7h5v3zm-6-6c3.71 0 5.12.46 5.66 1H6.43c.61-.52 2.06-1 5.57-1zM6 7h5v3H6V7zm0 5h12v3.5c0 .83-.67 1.5-1.5 1.5h-9c-.83 0-1.5-.67-1.5-1.5V12z"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "14.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "14.5",
	  r: "1.5"
	})), 'DirectionsTransitTwoTone');
	
	exports.default = _default;

/***/ },
/* 2469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3.01 12l9 9L21 12l-9-9-8.99 9zM14 7.5l3.5 3.5-3.5 3.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M13.42 1.58c-.75-.75-2.07-.76-2.83 0l-9 9c-.78.78-.78 2.04 0 2.82l9 9c.39.39.9.58 1.41.58.51 0 1.02-.19 1.41-.58l8.99-8.99c.78-.76.79-2.03.02-2.82l-9-9.01zm-1.41 19.41l-9-9 9-9 9 9-9 9zM8 11v4h2v-3h4v2.5l3.5-3.5L14 7.5V10H9c-.55 0-1 .45-1 1z"
	})), 'DirectionsTwoTone');
	
	exports.default = _default;

/***/ },
/* 2470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7"
	}), 'DirectionsWalk');
	
	exports.default = _default;

/***/ },
/* 2471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.56-.89-1.68-1.25-2.65-.84L6 8.3V13h2V9.6l1.8-.7"
	}), 'DirectionsWalkOutlined');
	
	exports.default = _default;

/***/ },
/* 2472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7.24 21.81c-.13.61.35 1.19.98 1.19h.08c.47 0 .87-.32.98-.78L10.9 15l2.1 2v5c0 .55.45 1 1 1s1-.45 1-1v-5.64c0-.55-.22-1.07-.62-1.45L12.9 13.5l.6-3c1.07 1.24 2.62 2.13 4.36 2.41.6.09 1.14-.39 1.14-1 0-.49-.36-.9-.85-.98-1.52-.25-2.78-1.15-3.45-2.33l-1-1.6c-.56-.89-1.68-1.25-2.65-.84L7.22 7.78C6.48 8.1 6 8.82 6 9.63V12c0 .55.45 1 1 1s1-.45 1-1V9.6l1.8-.7"
	}), 'DirectionsWalkRounded');
	
	exports.default = _default;

/***/ },
/* 2473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.56-.89-1.68-1.25-2.65-.84L6 8.3V13h2V9.6l1.8-.7"
	}), 'DirectionsWalkSharp');
	
	exports.default = _default;

/***/ },
/* 2474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.56-.89-1.68-1.25-2.65-.84L6 8.3V13h2V9.6l1.8-.7"
	}), 'DirectionsWalkTwoTone');
	
	exports.default = _default;

/***/ },
/* 2475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 16h2v-2h-2v2zm0-9v5h2V7h-2zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'DiscFull');
	
	exports.default = _default;

/***/ },
/* 2476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 7h2v5h-2zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm10-4h2v2h-2zm-10-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'DiscFullOutlined');
	
	exports.default = _default;

/***/ },
/* 2477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 16h2v-2h-2v2zm0-8v3c0 .55.45 1 1 1s1-.45 1-1V8c0-.55-.45-1-1-1s-1 .45-1 1zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'DiscFullRounded');
	
	exports.default = _default;

/***/ },
/* 2478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 16h2v-2h-2v2zm0-9v5h2V7h-2zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'DiscFullSharp');
	
	exports.default = _default;

/***/ },
/* 2479 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M10 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 14h2v2h-2zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM20 7h2v5h-2zm-10 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	})), 'DiscFullTwoTone');
	
	exports.default = _default;

/***/ },
/* 2480 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'Dns');
	
	exports.default = _default;

/***/ },
/* 2481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 15v4H5v-4h14m1-2H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 18.5c-.82 0-1.5-.67-1.5-1.5s.68-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM19 5v4H5V5h14m1-2H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 8.5c-.82 0-1.5-.67-1.5-1.5S6.18 5.5 7 5.5s1.5.68 1.5 1.5S7.83 8.5 7 8.5z"
	}), 'DnsOutlined');
	
	exports.default = _default;

/***/ },
/* 2482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 13H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM19 3H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'DnsRounded');
	
	exports.default = _default;

/***/ },
/* 2483 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 13H3v8h18v-8zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM21 3H3v8h18V3zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'DnsSharp');
	
	exports.default = _default;

/***/ },
/* 2484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 9h14V5H5v4zm2-3.5c.83 0 1.5.67 1.5 1.5S7.83 8.5 7 8.5 5.5 7.83 5.5 7 6.17 5.5 7 5.5zM5 19h14v-4H5v4zm2-3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm-1 6H5v-4h14v4zm-12-.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm-1 6H5V5h14v4zM7 8.5c.83 0 1.5-.67 1.5-1.5S7.83 5.5 7 5.5 5.5 6.17 5.5 7 6.17 8.5 7 8.5z"
	})), 'DnsTwoTone');
	
	exports.default = _default;

/***/ },
/* 2485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 23h8v-2H8v2zm8-21.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z"
	}), 'Dock');
	
	exports.default = _default;

/***/ },
/* 2486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 23h8v-2H8v2zm8-21.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z"
	}), 'DockOutlined');
	
	exports.default = _default;

/***/ },
/* 2487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 23h6c.55 0 1-.45 1-1s-.45-1-1-1H9c-.55 0-1 .45-1 1s.45 1 1 1zm7-21.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z"
	}), 'DockRounded');
	
	exports.default = _default;

/***/ },
/* 2488 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 23h8v-2H8v2zM18 1.01L6 1v18h12V1.01zM16 15H8V5h8v10z"
	}), 'DockSharp');
	
	exports.default = _default;

/***/ },
/* 2489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 5h8v10H8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M8 21h8v2H8zm8-19.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z"
	})), 'DockTwoTone');
	
	exports.default = _default;

/***/ },
/* 2490 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  transform: "scale(0.5, 0.5)",
	  d: "M24 14V6H4v36h40V14H24zM12 38H8v-4h4v4zm0-8H8v-4h4v4zm0-8H8v-4h4v4zm0-8H8v-4h4v4zm8 24h-4v-4h4v4zm0-8h-4v-4h4v4zm0-8h-4v-4h4v4zm0-8h-4v-4h4v4zm20 24H24v-4h4v-4h-4v-4h4v-4h-4v-4h16v20zm-4-16h-4v4h4v-4zm0 8h-4v4h4v-4z"
	}), 'Domain');
	
	exports.default = _default;

/***/ },
/* 2491 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 5h2v2h-.9L12 9.9V9h8v8.9l2 2V7H12V3H5.1L8 5.9zm8 6h2v2h-2zM1.3 1.8L.1 3.1 2 5v16h16l3 3 1.3-1.3-21-20.9zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm4 8H8v-2h2v2zm0-4H8v-2h2v2zm2 4v-2h2l2 2h-4z"
	}), 'DomainDisabled');
	
	exports.default = _default;

/***/ },
/* 2492 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1.41 1.69L0 3.1l2 2V21h15.9l3 3 1.41-1.41-20.9-20.9zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm-2-4V9h2v2H4zm6 8H8v-2h2v2zm-2-4v-2h2v2H8zm4 4v-2h1.9l2 2H12zM8 5h2v2h-.45L12 9.45V9h8v8.45l2 2V7H12V3H5.55L8 5.45zm8 6h2v2h-2z"
	}), 'DomainDisabledOutlined');
	
	exports.default = _default;

/***/ },
/* 2493 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M.71 2.39c-.39.39-.39 1.02 0 1.41L2 5.1V19c0 1.1.9 2 2 2h13.9l2.29 2.29c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L2.12 2.39a.9959.9959 0 00-1.41 0zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm-2-4V9h2v2H4zm6 8H8v-2h2v2zm-2-4v-2h2v2H8zm4 4v-2h1.9l2 2H12zM8 5h2v2h-.45L12 9.45V9h7c.55 0 1 .45 1 1v7.45l2 2V9c0-1.1-.9-2-2-2h-8V5c0-1.1-.9-2-2-2H5.55L8 5.45V5zm8 6h2v2h-2z"
	}), 'DomainDisabledRounded');
	
	exports.default = _default;

/***/ },
/* 2494 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1.41 1.69L0 3.1l2 2V21h15.9l3 3 1.41-1.41-20.9-20.9zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm-2-4V9h2v2H4zm6 8H8v-2h2v2zm-2-4v-2h2v2H8zm4 4v-2h1.9l2 2H12zM8 5h2v2h-.45L12 9.45V9h8v8.45l2 2V7H12V3H5.55L8 5.45zm8 6h2v2h-2z"
	}), 'DomainDisabledSharp');
	
	exports.default = _default;

/***/ },
/* 2495 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M1.41 1.69L0 3.1l2 2V21h15.9l3 3 1.41-1.41-20.9-20.9zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm-2-4V9h2v2H4zm6 8H8v-2h2v2zm-2-4v-2h2v2H8zm4 4v-2h1.9l2 2H12zM8 5h2v2h-.45L12 9.45V9h8v8.45l2 2V7H12V3H5.55L8 5.45zm8 6h2v2h-2z"
	}), _react.default.createElement("path", {
	  d: "M12 9v.45l8 8V9h-8zm6 4h-2v-2h2v2z",
	  opacity: ".3"
	})), 'DomainDisabledTwoTone');
	
	exports.default = _default;

/***/ },
/* 2496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
	})), 'DomainOutlined');
	
	exports.default = _default;

/***/ },
/* 2497 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 7V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2h-8zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm9 12h-7v-2h2v-2h-2v-2h2v-2h-2V9h7c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1zm-1-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
	})), 'DomainRounded');
	
	exports.default = _default;

/***/ },
/* 2498 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
	})), 'DomainSharp');
	
	exports.default = _default;

/***/ },
/* 2499 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 11h2v2h-2v2h2v2h-2v2h8V9h-8v2zm4 0h2v2h-2v-2zm0 4h2v2h-2v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-4-8h2v2h-2zm0 4h2v2h-2z"
	})), 'DomainTwoTone');
	
	exports.default = _default;

/***/ },
/* 2500 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
	}), 'Done');
	
	exports.default = _default;

/***/ },
/* 2501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"
	}), 'DoneAll');
	
	exports.default = _default;

/***/ },
/* 2502 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"
	}), 'DoneAllOutlined');
	
	exports.default = _default;

/***/ },
/* 2503 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.3 6.3a.9959.9959 0 00-1.41 0l-5.64 5.64 1.41 1.41L17.3 7.7c.38-.38.38-1.02 0-1.4zm4.24-.01l-9.88 9.88-3.48-3.47a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l4.18 4.18c.39.39 1.02.39 1.41 0L22.95 7.71c.39-.39.39-1.02 0-1.41h-.01c-.38-.4-1.01-.4-1.4-.01zM1.12 14.12L5.3 18.3c.39.39 1.02.39 1.41 0l.7-.7-4.88-4.9a.9959.9959 0 00-1.41 0c-.39.39-.39 1.03 0 1.42z"
	}), 'DoneAllRounded');
	
	exports.default = _default;

/***/ },
/* 2504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"
	}), 'DoneAllSharp');
	
	exports.default = _default;

/***/ },
/* 2505 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"
	}), 'DoneAllTwoTone');
	
	exports.default = _default;

/***/ },
/* 2506 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.77 5.03l1.4 1.4L8.43 19.17l-5.6-5.6 1.4-1.4 4.2 4.2L19.77 5.03m0-2.83L8.43 13.54l-4.2-4.2L0 13.57 8.43 22 24 6.43 19.77 2.2z"
	}), 'DoneOutline');
	
	exports.default = _default;

/***/ },
/* 2507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.77 4.93l1.4 1.4L8.43 19.07l-5.6-5.6 1.4-1.4 4.2 4.2L19.77 4.93m0-2.83L8.43 13.44l-4.2-4.2L0 13.47l8.43 8.43L24 6.33 19.77 2.1z"
	}), 'DoneOutlineOutlined');
	
	exports.default = _default;

/***/ },
/* 2508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.47 5.63c.39.39.39 1.01 0 1.4L9.13 18.37c-.39.39-1.01.39-1.4 0l-4.2-4.2a.9839.9839 0 010-1.4c.39-.39 1.01-.39 1.4 0l3.5 3.5L19.07 5.63c.39-.39 1.01-.39 1.4 0zm-2.11-2.12l-9.93 9.93-2.79-2.79c-.78-.78-2.05-.78-2.83 0l-1.4 1.4c-.78.78-.78 2.05 0 2.83l5.6 5.6c.78.78 2.05.78 2.83 0L22.59 7.74c.78-.78.78-2.05 0-2.83l-1.4-1.4c-.79-.78-2.05-.78-2.83 0z"
	}), 'DoneOutlineRounded');
	
	exports.default = _default;

/***/ },
/* 2509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.77 4.93l1.4 1.4L8.43 19.07l-5.6-5.6 1.4-1.4 4.2 4.2L19.77 4.93m0-2.83L8.43 13.44l-4.2-4.2L0 13.47l8.43 8.43L24 6.33 19.77 2.1z"
	}), 'DoneOutlineSharp');
	
	exports.default = _default;

/***/ },
/* 2510 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.77 4.93l1.4 1.4L8.43 19.07l-5.6-5.6 1.4-1.4 4.2 4.2L19.77 4.93m0-2.83L8.43 13.44l-4.2-4.2L0 13.47l8.43 8.43L24 6.33 19.77 2.1z"
	}), 'DoneOutlineTwoTone');
	
	exports.default = _default;

/***/ },
/* 2511 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
	}), 'DoneOutlined');
	
	exports.default = _default;

/***/ },
/* 2512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 16.2l-3.5-3.5a.9839.9839 0 00-1.4 0c-.39.39-.39 1.01 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7c.39-.39.39-1.01 0-1.4a.9839.9839 0 00-1.4 0L9 16.2z"
	}), 'DoneRounded');
	
	exports.default = _default;

/***/ },
/* 2513 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
	}), 'DoneSharp');
	
	exports.default = _default;

/***/ },
/* 2514 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
	}), 'DoneTwoTone');
	
	exports.default = _default;

/***/ },
/* 2515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 5.08V2c-5 .5-9 4.81-9 10s4 9.5 9 10v-3.08c-3-.48-6-3.4-6-6.92s3-6.44 6-6.92zM18.97 11H22c-.47-5-4-8.53-9-9v3.08C16 5.51 18.54 8 18.97 11zM13 18.92V22c5-.47 8.53-4 9-9h-3.03c-.43 3-2.97 5.49-5.97 5.92z"
	}), 'DonutLarge');
	
	exports.default = _default;

/***/ },
/* 2516 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 5.08c3.06.44 5.48 2.86 5.92 5.92h3.03c-.47-4.72-4.23-8.48-8.95-8.95v3.03zM18.92 13c-.44 3.06-2.86 5.48-5.92 5.92v3.03c4.72-.47 8.48-4.23 8.95-8.95h-3.03zM11 18.92c-3.39-.49-6-3.4-6-6.92s2.61-6.43 6-6.92V2.05c-5.05.5-9 4.76-9 9.95 0 5.19 3.95 9.45 9 9.95v-3.03z"
	}), 'DonutLargeOutlined');
	
	exports.default = _default;

/***/ },
/* 2517 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.07 5.32C16.26 6 18 7.74 18.68 9.93c.19.63.76 1.07 1.41 1.07h.04c1 0 1.72-.96 1.43-1.91-.97-3.18-3.48-5.69-6.66-6.66-.94-.29-1.9.43-1.9 1.43v.04c0 .66.44 1.23 1.07 1.42zm4.61 8.75c-.68 2.2-2.42 3.93-4.61 4.61-.63.19-1.07.76-1.07 1.41v.04c0 1 .96 1.72 1.91 1.43 3.18-.97 5.69-3.48 6.66-6.66.29-.95-.43-1.91-1.42-1.91h-.05c-.66.01-1.23.45-1.42 1.08zM11 20.11c0-.67-.45-1.24-1.09-1.44C7.07 17.78 5 15.13 5 12s2.07-5.78 4.91-6.67c.64-.2 1.09-.77 1.09-1.44v-.01c0-1-.97-1.74-1.93-1.44C4.98 3.69 2 7.5 2 12c0 4.5 2.98 8.31 7.07 9.56.96.3 1.93-.44 1.93-1.45z"
	}), 'DonutLargeRounded');
	
	exports.default = _default;

/***/ },
/* 2518 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 5.08c3.06.44 5.48 2.86 5.92 5.92h3.03c-.47-4.72-4.23-8.48-8.95-8.95v3.03zM18.92 13c-.44 3.06-2.86 5.48-5.92 5.92v3.03c4.72-.47 8.48-4.23 8.95-8.95h-3.03zM11 18.92c-3.39-.49-6-3.4-6-6.92s2.61-6.43 6-6.92V2.05c-5.05.5-9 4.76-9 9.95 0 5.19 3.95 9.45 9 9.95v-3.03z"
	}), 'DonutLargeSharp');
	
	exports.default = _default;

/***/ },
/* 2519 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 5.08c3.06.44 5.48 2.86 5.92 5.92h3.03c-.47-4.72-4.23-8.48-8.95-8.95v3.03zM18.92 13c-.44 3.06-2.86 5.48-5.92 5.92v3.03c4.72-.47 8.48-4.23 8.95-8.95h-3.03zM11 18.92c-3.39-.49-6-3.4-6-6.92s2.61-6.43 6-6.92V2.05c-5.05.5-9 4.76-9 9.95 0 5.19 3.95 9.45 9 9.95v-3.03z"
	}), 'DonutLargeTwoTone');
	
	exports.default = _default;

/***/ },
/* 2520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 9.16V2c-5 .5-9 4.79-9 10s4 9.5 9 10v-7.16c-1-.41-2-1.52-2-2.84s1-2.43 2-2.84zM14.86 11H22c-.48-4.75-4-8.53-9-9v7.16c1 .3 1.52.98 1.86 1.84zM13 14.84V22c5-.47 8.52-4.25 9-9h-7.14c-.34.86-.86 1.54-1.86 1.84z"
	}), 'DonutSmall');
	
	exports.default = _default;

/***/ },
/* 2521 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.82 11h7.13c-.47-4.72-4.23-8.48-8.95-8.95v7.13c.85.31 1.51.97 1.82 1.82zM15 4.58C17 5.4 18.6 7 19.42 9h-3.43c-.28-.37-.62-.71-.99-.99V4.58zM2 12c0 5.19 3.95 9.45 9 9.95v-7.13C9.84 14.4 9 13.3 9 12c0-1.3.84-2.4 2-2.82V2.05c-5.05.5-9 4.76-9 9.95zm7-7.42v3.44c-1.23.92-2 2.39-2 3.98 0 1.59.77 3.06 2 3.99v3.44C6.04 18.24 4 15.35 4 12c0-3.35 2.04-6.24 5-7.42zm4 10.24v7.13c4.72-.47 8.48-4.23 8.95-8.95h-7.13c-.31.85-.97 1.51-1.82 1.82zm2 1.17c.37-.28.71-.61.99-.99h3.43C18.6 17 17 18.6 15 19.42v-3.43z"
	}), 'DonutSmallOutlined');
	
	exports.default = _default;

/***/ },
/* 2522 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 3.18v17.64c0 .64-.59 1.12-1.21.98C5.32 20.8 2 16.79 2 12s3.32-8.8 7.79-9.8c.62-.14 1.21.34 1.21.98zm2.03 0v6.81c0 .55.45 1 1 1h6.79c.64 0 1.12-.59.98-1.22-.85-3.76-3.8-6.72-7.55-7.57-.63-.14-1.22.34-1.22.98zm0 10.83v6.81c0 .64.59 1.12 1.22.98 3.76-.85 6.71-3.82 7.56-7.58.14-.62-.35-1.22-.98-1.22h-6.79c-.56.01-1.01.46-1.01 1.01z"
	}), 'DonutSmallRounded');
	
	exports.default = _default;

/***/ },
/* 2523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 9.18c.85.3 1.51.97 1.82 1.82h7.13c-.47-4.72-4.23-8.48-8.95-8.95v7.13zm-2 5.64C9.84 14.4 9 13.3 9 12c0-1.3.84-2.4 2-2.82V2.05c-5.05.5-9 4.76-9 9.95 0 5.19 3.95 9.45 9 9.95v-7.13zM14.82 13c-.3.85-.97 1.51-1.82 1.82v7.13c4.72-.47 8.48-4.23 8.95-8.95h-7.13z"
	}), 'DonutSmallSharp');
	
	exports.default = _default;

/***/ },
/* 2524 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.99 9h3.43C18.6 7 17 5.4 15 4.58v3.43c.37.28.71.62.99.99zM4 12c0 3.35 2.04 6.24 5 7.42v-3.44c-1.23-.93-2-2.4-2-3.99C7 10.4 7.77 8.93 9 8V4.58C6.04 5.76 4 8.65 4 12zm11 3.99v3.43c2-.82 3.6-2.42 4.42-4.42h-3.43c-.28.37-.62.71-.99.99z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M14.82 11h7.13c-.47-4.72-4.23-8.48-8.95-8.95v7.13c.85.31 1.51.97 1.82 1.82zM15 4.58C17 5.4 18.6 7 19.42 9h-3.43c-.28-.37-.62-.71-.99-.99V4.58zM2 12c0 5.19 3.95 9.45 9 9.95v-7.13C9.84 14.4 9 13.3 9 12c0-1.3.84-2.4 2-2.82V2.05c-5.05.5-9 4.76-9 9.95zm7-7.42v3.44c-1.23.92-2 2.39-2 3.98 0 1.59.77 3.06 2 3.99v3.44C6.04 18.24 4 15.35 4 12c0-3.35 2.04-6.24 5-7.42zm4 10.24v7.13c4.72-.47 8.48-4.23 8.95-8.95h-7.13c-.31.85-.97 1.51-1.82 1.82zm2 1.17c.37-.28.71-.61.99-.99h3.43C18.6 17 17 18.6 15 19.42v-3.43z"
	})), 'DonutSmallTwoTone');
	
	exports.default = _default;

/***/ },
/* 2525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.5 5H11l5 7-5 7h4.5l5-7z"
	}), _react.default.createElement("path", {
	  d: "M8.5 5H4l5 7-5 7h4.5l5-7z"
	})), 'DoubleArrow');
	
	exports.default = _default;

/***/ },
/* 2526 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.5 5H11l5 7-5 7h4.5l5-7z"
	}), _react.default.createElement("path", {
	  d: "M8.5 5H4l5 7-5 7h4.5l5-7z"
	})), 'DoubleArrowOutlined');
	
	exports.default = _default;

/***/ },
/* 2527 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20.08 11.42l-4.04-5.65c-.34-.48-.89-.77-1.48-.77-1.49 0-2.35 1.68-1.49 2.89L16 12l-2.93 4.11c-.87 1.21 0 2.89 1.49 2.89.59 0 1.15-.29 1.49-.77l4.04-5.65c.24-.35.24-.81-.01-1.16z"
	}), _react.default.createElement("path", {
	  d: "M13.08 11.42L9.05 5.77C8.7 5.29 8.15 5 7.56 5 6.07 5 5.2 6.68 6.07 7.89L9 12l-2.93 4.11C5.2 17.32 6.07 19 7.56 19c.59 0 1.15-.29 1.49-.77l4.04-5.65c.24-.35.24-.81-.01-1.16z"
	})), 'DoubleArrowRounded');
	
	exports.default = _default;

/***/ },
/* 2528 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.5 5H11l5 7-5 7h4.5l5-7z"
	}), _react.default.createElement("path", {
	  d: "M8.5 5H4l5 7-5 7h4.5l5-7z"
	})), 'DoubleArrowSharp');
	
	exports.default = _default;

/***/ },
/* 2529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.5 5H11l5 7-5 7h4.5l5-7z"
	}), _react.default.createElement("path", {
	  d: "M8.5 5H4l5 7-5 7h4.5l5-7z"
	})), 'DoubleArrowTwoTone');
	
	exports.default = _default;

/***/ },
/* 2530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z"
	}), 'Drafts');
	
	exports.default = _default;

/***/ },
/* 2531 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zm-2 0v.01L12 13 4 8l8-4.68L19.99 8zM4 18v-7.66l8 5.02 7.99-4.99L20 18H4z"
	}), 'DraftsOutlined');
	
	exports.default = _default;

/***/ },
/* 2532 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.99 8c0-.72-.37-1.35-.94-1.7l-8.04-4.71c-.62-.37-1.4-.37-2.02 0L2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zm-11.05 4.34l-7.2-4.5 7.25-4.25c.62-.37 1.4-.37 2.02 0l7.25 4.25-7.2 4.5c-.65.4-1.47.4-2.12 0z"
	}), 'DraftsRounded');
	
	exports.default = _default;

/***/ },
/* 2533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.99 6.86L12 1 2 6.86V20h20l-.01-13.14zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z"
	}), 'DraftsSharp');
	
	exports.default = _default;

/***/ },
/* 2534 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 15.36l-8-5.02V18h16l-.01-7.63z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 3.32L19.99 8v.01L12 13 4 8l8-4.68zM4 18v-7.66l8 5.02 7.99-4.99L20 18H4z"
	})), 'DraftsTwoTone');
	
	exports.default = _default;

/***/ },
/* 2535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 9H4v2h16V9zM4 15h16v-2H4v2z"
	}), 'DragHandle');
	
	exports.default = _default;

/***/ },
/* 2536 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 9H4v2h16V9zM4 15h16v-2H4v2z"
	}), 'DragHandleOutlined');
	
	exports.default = _default;

/***/ },
/* 2537 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 9H5c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM5 15h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1z"
	}), 'DragHandleRounded');
	
	exports.default = _default;

/***/ },
/* 2538 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 9H4v2h16V9zM4 15h16v-2H4v2z"
	}), 'DragHandleSharp');
	
	exports.default = _default;

/***/ },
/* 2539 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 9h16v2H4zm0 4h16v2H4z"
	}), 'DragHandleTwoTone');
	
	exports.default = _default;

/***/ },
/* 2540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'DragIndicator');
	
	exports.default = _default;

/***/ },
/* 2541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'DragIndicatorOutlined');
	
	exports.default = _default;

/***/ },
/* 2542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'DragIndicatorRounded');
	
	exports.default = _default;

/***/ },
/* 2543 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'DragIndicatorSharp');
	
	exports.default = _default;

/***/ },
/* 2544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'DragIndicatorTwoTone');
	
	exports.default = _default;

/***/ },
/* 2545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z"
	}), 'DriveEta');
	
	exports.default = _default;

/***/ },
/* 2546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 6h10.29l1.04 3H5.81l1.04-3zM19 16H5v-4.66l.12-.34h13.77l.11.34V16z"
	}), _react.default.createElement("circle", {
	  cx: "7.5",
	  cy: "13.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "13.5",
	  r: "1.5"
	})), 'DriveEtaOutlined');
	
	exports.default = _default;

/***/ },
/* 2547 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01l-1.97 5.67c-.07.21-.11.43-.11.66v7.16c0 .83.67 1.5 1.5 1.5S6 19.33 6 18.5V18h12v.5c0 .82.67 1.5 1.5 1.5.82 0 1.5-.67 1.5-1.5v-7.16c0-.22-.04-.45-.11-.66l-1.97-5.67zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.27-3.82c.14-.4.52-.68.95-.68h9.56c.43 0 .81.28.95.68L19 10H5z"
	}), 'DriveEtaRounded');
	
	exports.default = _default;

/***/ },
/* 2548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.92 5.01L18.57 4H5.43L3 11v9h3v-2h12v2h3v-9l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z"
	}), 'DriveEtaSharp');
	
	exports.default = _default;

/***/ },
/* 2549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5.12 11l-.12.34V16h14v-4.66l-.12-.34H5.12zm2.38 4c-.83 0-1.5-.67-1.5-1.5S6.67 12 7.5 12s1.5.67 1.5 1.5S8.33 15 7.5 15zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 6h10.29l1.04 3H5.81l1.04-3zM19 16H5v-4.66l.12-.34h13.77l.11.34V16z"
	}), _react.default.createElement("circle", {
	  cx: "7.5",
	  cy: "13.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "13.5",
	  r: "1.5"
	})), 'DriveEtaTwoTone');
	
	exports.default = _default;

/***/ },
/* 2550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2h-8C6.38 2 2 6.66 2 12.28 2 17.5 6.49 22 11.72 22 17.39 22 22 17.62 22 12V4c0-1.1-.9-2-2-2zm-3 13l-3-2v2H7V9h7v2l3-2v6z"
	}), 'Duo');
	
	exports.default = _default;

/***/ },
/* 2551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2h-8C6.38 2 2 6.66 2 12.28 2 17.5 6.49 22 11.72 22 17.39 22 22 17.62 22 12V4c0-1.1-.9-2-2-2zm-3 13l-3-2v2H7V9h7v2l3-2v6z"
	}), 'DuoOutlined');
	
	exports.default = _default;

/***/ },
/* 2552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2h-8C6.38 2 2 6.66 2 12.28 2 17.5 6.49 22 11.72 22 17.39 22 22 17.62 22 12V4c0-1.1-.9-2-2-2zm-3 13l-3-2v2H7V9h7v2l3-2v6z"
	}), 'DuoRounded');
	
	exports.default = _default;

/***/ },
/* 2553 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2h-8C6.38 2 2 6.66 2 12.28 2 17.5 6.49 22 11.72 22 17.39 22 22 17.62 22 12V4c0-1.1-.9-2-2-2zm-3 13l-3-2v2H7V9h7v2l3-2v6z"
	}), 'DuoSharp');
	
	exports.default = _default;

/***/ },
/* 2554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2h-8C6.38 2 2 6.66 2 12.28 2 17.5 6.49 22 11.72 22 17.39 22 22 17.62 22 12V4c0-1.1-.9-2-2-2zm-3 13l-3-2v2H7V9h7v2l3-2v6z"
	}), 'DuoTwoTone');
	
	exports.default = _default;

/***/ },
/* 2555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z"
	}), 'Dvr');
	
	exports.default = _default;

/***/ },
/* 2556 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z"
	}), 'DvrOutlined');
	
	exports.default = _default;

/***/ },
/* 2557 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v1c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-1h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 14H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1zm-2-9H9c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1s-.45-1-1-1zm0 4H9c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1s-.45-1-1-1zM7 8H5v2h2V8zm0 4H5v2h2v-2z"
	}), 'DvrRounded');
	
	exports.default = _default;

/***/ },
/* 2558 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 3H1v16h7v2h8v-2h7V3zm-2 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z"
	}), 'DvrSharp');
	
	exports.default = _default;

/***/ },
/* 2559 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 17h18V5H3v12zm5-9h11v2H8V8zm0 4h11v2H8v-2zM5 8h2v2H5V8zm0 4h2v2H5v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M8 12h11v2H8zm0-4h11v2H8zm13-5H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zM5 12h2v2H5zm0-4h2v2H5z"
	})), 'DvrTwoTone');
	
	exports.default = _default;

/***/ },
/* 2560 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 8H6v7c0 1.1.9 2 2 2h9v-2H8V8z"
	}), _react.default.createElement("path", {
	  d: "M20 3h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8h-8V7h8v4zM4 12H2v7c0 1.1.9 2 2 2h9v-2H4v-7z"
	})), 'DynamicFeed');
	
	exports.default = _default;

/***/ },
/* 2561 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 8H6v7c0 1.1.9 2 2 2h9v-2H8V8z"
	}), _react.default.createElement("path", {
	  d: "M20 3h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8h-8V7h8v4zM4 12H2v7c0 1.1.9 2 2 2h9v-2H4v-7z"
	})), 'DynamicFeedOutlined');
	
	exports.default = _default;

/***/ },
/* 2562 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 8c-.55 0-1 .45-1 1v6c0 1.1.9 2 2 2h8c.55 0 1-.45 1-1s-.45-1-1-1H8V9c0-.55-.45-1-1-1z"
	}), _react.default.createElement("path", {
	  d: "M20 3h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-.5 8h-7c-.28 0-.5-.22-.5-.5V7h8v3.5c0 .28-.22.5-.5.5zM3 12c-.55 0-1 .45-1 1v6c0 1.1.9 2 2 2h8c.55 0 1-.45 1-1s-.45-1-1-1H4v-6c0-.55-.45-1-1-1z"
	})), 'DynamicFeedRounded');
	
	exports.default = _default;

/***/ },
/* 2563 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 8H6v9h11v-2H8z"
	}), _react.default.createElement("path", {
	  d: "M22 3H10v10h12V3zm-2 8h-8V7h8v4zM4 12H2v9h11v-2H4z"
	})), 'DynamicFeedSharp');
	
	exports.default = _default;

/***/ },
/* 2564 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 7h8v4h-8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M8 8H6v7c0 1.1.9 2 2 2h9v-2H8V8z"
	}), _react.default.createElement("path", {
	  d: "M20 3h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8h-8V7h8v4zM4 12H2v7c0 1.1.9 2 2 2h9v-2H4v-7z"
	})), 'DynamicFeedTwoTone');
	
	exports.default = _default;

/***/ },
/* 2565 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.05 8.05c-2.73 2.73-2.73 7.15-.02 9.88 1.47-3.4 4.09-6.24 7.36-7.93-2.77 2.34-4.71 5.61-5.39 9.32 2.6 1.23 5.8.78 7.95-1.37C19.43 14.47 20 4 20 4S9.53 4.57 6.05 8.05z"
	}), 'Eco');
	
	exports.default = _default;

/***/ },
/* 2566 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.05 8.05c-2.73 2.73-2.73 7.17 0 9.9C7.42 19.32 9.21 20 11 20s3.58-.68 4.95-2.05C19.43 14.47 20 4 20 4S9.53 4.57 6.05 8.05zm8.49 8.49c-.95.94-2.2 1.46-3.54 1.46-.89 0-1.73-.25-2.48-.68.92-2.88 2.62-5.41 4.88-7.32-2.63 1.36-4.84 3.46-6.37 6-1.48-1.96-1.35-4.75.44-6.54C9.21 7.72 14.04 6.65 17.8 6.2c-.45 3.76-1.52 8.59-3.26 10.34z"
	}), 'EcoOutlined');
	
	exports.default = _default;

/***/ },
/* 2567 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.05 8.05c-2.73 2.73-2.73 7.15-.02 9.88 1.47-3.4 4.09-6.24 7.36-7.93-2.77 2.34-4.71 5.61-5.39 9.32 2.6 1.23 5.8.78 7.95-1.37 2.99-2.99 3.83-11.14 4.01-13.38.02-.31-.23-.56-.53-.53-2.24.18-10.39 1.02-13.38 4.01z"
	}), 'EcoRounded');
	
	exports.default = _default;

/***/ },
/* 2568 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.05 8.05c-2.73 2.73-2.73 7.15-.02 9.88 1.47-3.4 4.09-6.24 7.36-7.93-2.77 2.34-4.71 5.61-5.39 9.32 2.6 1.23 5.8.78 7.95-1.37C19.43 14.47 20 4 20 4S9.53 4.57 6.05 8.05z"
	}), 'EcoSharp');
	
	exports.default = _default;

/***/ },
/* 2569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7.46 9.46c-1.78 1.79-1.91 4.58-.43 6.54 1.53-2.54 3.73-4.64 6.37-6-2.26 1.91-3.95 4.44-4.88 7.32.75.43 1.59.68 2.48.68 1.34 0 2.59-.52 3.54-1.46 1.74-1.74 2.81-6.57 3.26-10.33-3.76.44-8.59 1.51-10.34 3.25z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M6.05 8.05c-2.73 2.73-2.73 7.17 0 9.9C7.42 19.32 9.21 20 11 20s3.58-.68 4.95-2.05C19.43 14.47 20 4 20 4S9.53 4.57 6.05 8.05zm8.49 8.49c-.95.94-2.2 1.46-3.54 1.46-.89 0-1.73-.25-2.48-.68.92-2.88 2.62-5.41 4.88-7.32-2.63 1.36-4.84 3.46-6.37 6-1.48-1.96-1.35-4.75.44-6.54C9.21 7.72 14.04 6.65 17.8 6.2c-.45 3.76-1.52 8.59-3.26 10.34z"
	})), 'EcoTwoTone');
	
	exports.default = _default;

/***/ },
/* 2570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
	}), 'Edit');
	
	exports.default = _default;

/***/ },
/* 2571 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.63 7H6.37C3.96 7 2 9.24 2 12s1.96 5 4.37 5h11.26c2.41 0 4.37-2.24 4.37-5s-1.96-5-4.37-5zM7.24 14.46l-2.57-2.57.7-.7 1.87 1.87 3.52-3.52.7.7-4.22 4.22z"
	}), 'EditAttributes');
	
	exports.default = _default;

/***/ },
/* 2572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.63 7H6.37C3.96 7 2 9.24 2 12s1.96 5 4.37 5h11.26c2.41 0 4.37-2.24 4.37-5s-1.96-5-4.37-5zm0 8H6.37C5.09 15 4 13.63 4 12s1.09-3 2.37-3h11.26C18.91 9 20 10.37 20 12s-1.09 3-2.37 3zM7.24 13.06l-1.87-1.87-.7.7 2.57 2.57 4.22-4.22-.7-.7z"
	}), 'EditAttributesOutlined');
	
	exports.default = _default;

/***/ },
/* 2573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.63 7H6.37C3.96 7 2 9.24 2 12s1.96 5 4.37 5h11.26c2.41 0 4.37-2.24 4.37-5s-1.96-5-4.37-5zm-6.52 3.6L7.6 14.11c-.1.1-.23.15-.35.15s-.26-.05-.35-.15l-1.86-1.86c-.2-.2-.2-.51 0-.71s.51-.2.71 0l1.51 1.51 3.16-3.16c.2-.2.51-.2.71 0s.17.51-.02.71z"
	}), 'EditAttributesRounded');
	
	exports.default = _default;

/***/ },
/* 2574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.63 7H6.37C3.96 7 2 9.24 2 12s1.96 5 4.37 5h11.26c2.41 0 4.37-2.24 4.37-5s-1.96-5-4.37-5zM7.24 14.46l-2.57-2.57.7-.7 1.87 1.87 3.52-3.52.7.7-4.22 4.22z"
	}), 'EditAttributesSharp');
	
	exports.default = _default;

/***/ },
/* 2575 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17.63 9H6.37C5.09 9 4 10.37 4 12s1.09 3 2.37 3h11.26c1.28 0 2.37-1.37 2.37-3s-1.09-3-2.37-3zM7.24 14.46l-2.57-2.57.7-.7 1.87 1.87 3.52-3.52.7.7-4.22 4.22z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17.63 7H6.37C3.96 7 2 9.24 2 12s1.96 5 4.37 5h11.26c2.41 0 4.37-2.24 4.37-5s-1.96-5-4.37-5zm0 8H6.37C5.09 15 4 13.63 4 12s1.09-3 2.37-3h11.26C18.91 9 20 10.37 20 12s-1.09 3-2.37 3zM7.24 13.06l-1.87-1.87-.7.7 2.57 2.57 4.22-4.22-.7-.7z"
	})), 'EditAttributesTwoTone');
	
	exports.default = _default;

/***/ },
/* 2576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm-1.56 10H9v-1.44l3.35-3.34 1.43 1.43L10.44 12zm4.45-4.45l-.7.7-1.44-1.44.7-.7c.15-.15.39-.15.54 0l.9.9c.15.15.15.39 0 .54z"
	}), 'EditLocation');
	
	exports.default = _default;

/***/ },
/* 2577 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 1C7.59 1 4 4.59 4 9c0 5.57 6.96 13.34 7.26 13.67l.74.82.74-.82C13.04 22.34 20 14.57 20 9c0-4.41-3.59-8-8-8zm0 19.47C9.82 17.86 6 12.54 6 9c0-3.31 2.69-6 6-6s6 2.69 6 6c0 3.83-4.25 9.36-6 11.47zm-3.49-9.42v1.44h1.44l3.92-3.93-1.43-1.43zm5.88-5.34c-.15-.15-.39-.15-.54 0l-.7.7 1.44 1.44.7-.7c.15-.15.15-.39 0-.54l-.9-.9z"
	})), 'EditLocationOutlined');
	
	exports.default = _default;

/***/ },
/* 2578 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2C8.14 2 5 5.14 5 9c0 4.17 4.42 9.92 6.24 12.11.4.48 1.13.48 1.53 0C14.58 18.92 19 13.17 19 9c0-3.86-3.14-7-7-7zM9.95 12.49H8.51v-1.44l3.93-3.92 1.43 1.43-3.92 3.93zm5.34-5.34l-.7.7-1.44-1.44.7-.7c.15-.15.39-.15.54 0l.9.9c.15.15.15.39 0 .54z"
	})), 'EditLocationRounded');
	
	exports.default = _default;

/***/ },
/* 2579 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zM9.95 12.49H8.51v-1.44l3.93-3.92 1.43 1.43-3.92 3.93zm5.34-5.34l-.7.7-1.44-1.44.7-.7c.15-.15.39-.15.54 0l.9.9c.15.15.15.39 0 .54z"
	})), 'EditLocationSharp');
	
	exports.default = _default;

/***/ },
/* 2580 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 3C8.69 3 6 5.69 6 9c0 3.54 3.82 8.86 6 11.47 1.75-2.11 6-7.63 6-11.47 0-3.31-2.69-6-6-6zm-2.05 9.49H8.51v-1.44l3.93-3.92 1.43 1.43-3.92 3.93zm5.34-5.34l-.7.7-1.44-1.44.7-.7c.15-.15.39-.15.54 0l.9.9c.15.15.15.39 0 .54z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 1C7.59 1 4 4.59 4 9c0 5.57 6.96 13.34 7.26 13.67l.74.82.74-.82C13.04 22.34 20 14.57 20 9c0-4.41-3.59-8-8-8zm0 19.47C9.82 17.86 6 12.54 6 9c0-3.31 2.69-6 6-6s6 2.69 6 6c0 3.83-4.25 9.36-6 11.47zm-3.49-9.42v1.44h1.44l3.92-3.93-1.43-1.43zm5.88-5.34c-.15-.15-.39-.15-.54 0l-.7.7 1.44 1.44.7-.7c.15-.15.15-.39 0-.54l-.9-.9z"
	})), 'EditLocationTwoTone');
	
	exports.default = _default;

/***/ },
/* 2581 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"
	}), 'EditOutlined');
	
	exports.default = _default;

/***/ },
/* 2582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 17.46v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15L17.81 9.94l-3.75-3.75L3.15 17.1c-.1.1-.15.22-.15.36zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
	}), 'EditRounded');
	
	exports.default = _default;

/***/ },
/* 2583 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM21.41 6.34l-3.75-3.75-2.53 2.54 3.75 3.75 2.53-2.54z"
	}), 'EditSharp');
	
	exports.default = _default;

/***/ },
/* 2584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 18.08V19h.92l9.06-9.06-.92-.92z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83zM3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19z"
	})), 'EditTwoTone');
	
	exports.default = _default;

/***/ },
/* 2585 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 17h14v2H5zm7-12L5.33 15h13.34z"
	}), 'Eject');
	
	exports.default = _default;

/***/ },
/* 2586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 17h14v2H5zm7-12L5.33 15h13.34L12 5zm0 3.6l2.93 4.4H9.07L12 8.6z"
	}), 'EjectOutlined');
	
	exports.default = _default;

/***/ },
/* 2587 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 17h12c.55 0 1 .45 1 1s-.45 1-1 1H6c-.55 0-1-.45-1-1s.45-1 1-1zm5.17-10.75l-4.8 7.2c-.45.66.03 1.55.83 1.55h9.6c.8 0 1.28-.89.83-1.55l-4.8-7.2c-.39-.6-1.27-.6-1.66 0z"
	}), 'EjectRounded');
	
	exports.default = _default;

/***/ },
/* 2588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 17h14v2H5v-2zm7-12L5.33 15h13.34L12 5z"
	}), 'EjectSharp');
	
	exports.default = _default;

/***/ },
/* 2589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 8.6L9.07 13h5.86z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 17h14v2H5zm7-12L5.33 15h13.34L12 5zm0 3.6l2.93 4.4H9.07L12 8.6z"
	})), 'EjectTwoTone');
	
	exports.default = _default;

/***/ },
/* 2590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
	}), 'Email');
	
	exports.default = _default;

/***/ },
/* 2591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z"
	}), 'EmailOutlined');
	
	exports.default = _default;

/***/ },
/* 2592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-.4 4.25l-7.07 4.42c-.32.2-.74.2-1.06 0L4.4 8.25c-.25-.16-.4-.43-.4-.72 0-.67.73-1.07 1.3-.72L12 11l6.7-4.19c.57-.35 1.3.05 1.3.72 0 .29-.15.56-.4.72z"
	}), 'EmailRounded');
	
	exports.default = _default;

/***/ },
/* 2593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 4H2v16h20V4zm-2 4l-8 5-8-5V6l8 5 8-5v2z"
	}), 'EmailSharp');
	
	exports.default = _default;

/***/ },
/* 2594 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 8l-8 5-8-5v10h16zm0-2H4l8 4.99z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 20h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2zM20 6l-8 4.99L4 6h16zM4 8l8 5 8-5v10H4V8z"
	})), 'EmailTwoTone');
	
	exports.default = _default;

/***/ },
/* 2595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM8.5 8c.83 0 1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5 7.67 8 8.5 8zM12 18c-2.28 0-4.22-1.66-5-4h10c-.78 2.34-2.72 4-5 4zm3.5-7c-.83 0-1.5-.67-1.5-1.5S14.67 8 15.5 8s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'EmojiEmotions');
	
	exports.default = _default;

/***/ },
/* 2596 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M12 18c2.28 0 4.22-1.66 5-4H7c.78 2.34 2.72 4 5 4z"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	})), 'EmojiEmotionsOutlined');
	
	exports.default = _default;

/***/ },
/* 2597 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM8.5 8c.83 0 1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5 7.67 8 8.5 8zm8.21 6.72C15.8 16.67 14.04 18 12 18s-3.8-1.33-4.71-3.28c-.16-.33.08-.72.45-.72h8.52c.37 0 .61.39.45.72zM15.5 11c-.83 0-1.5-.67-1.5-1.5S14.67 8 15.5 8s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'EmojiEmotionsRounded');
	
	exports.default = _default;

/***/ },
/* 2598 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM8.5 8c.83 0 1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5 7.67 8 8.5 8zM12 18c-2.28 0-4.22-1.66-5-4h10c-.78 2.34-2.72 4-5 4zm3.5-7c-.83 0-1.5-.67-1.5-1.5S14.67 8 15.5 8s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'EmojiEmotionsSharp');
	
	exports.default = _default;

/***/ },
/* 2599 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 12c0-4.42-3.58-8-8-8s-8 3.58-8 8 3.58 8 8 8 8-3.58 8-8zM8.5 8c.83 0 1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5 7.67 8 8.5 8zM12 18c-2.28 0-4.22-1.66-5-4h10c-.78 2.34-2.72 4-5 4zm3.5-7c-.83 0-1.5-.67-1.5-1.5S14.67 8 15.5 8s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), _react.default.createElement("path", {
	  d: "M12 18c2.28 0 4.22-1.66 5-4H7c.78 2.34 2.72 4 5 4z"
	})), 'EmojiEmotionsTwoTone');
	
	exports.default = _default;

/***/ },
/* 2600 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM7 10.82C5.84 10.4 5 9.3 5 8V7h2v3.82zM19 8c0 1.3-.84 2.4-2 2.82V7h2v1z"
	}), 'EmojiEvents');
	
	exports.default = _default;

/***/ },
/* 2601 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm7 6c-1.65 0-3-1.35-3-3V5h6v6c0 1.65-1.35 3-3 3zm7-6c0 1.3-.84 2.4-2 2.82V7h2v1z"
	}), 'EmojiEventsOutlined');
	
	exports.default = _default;

/***/ },
/* 2602 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5h-2V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H8c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1h-3v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM7 10.82C5.84 10.4 5 9.3 5 8V7h2v3.82zM19 8c0 1.3-.84 2.4-2 2.82V7h2v1z"
	}), 'EmojiEventsRounded');
	
	exports.default = _default;

/***/ },
/* 2603 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 5V3H7v2H3v3c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V5h-4zM7 10.82C5.84 10.4 5 9.3 5 8V7h2v3.82zM19 8c0 1.3-.84 2.4-2 2.82V7h2v1z"
	}), 'EmojiEventsSharp');
	
	exports.default = _default;

/***/ },
/* 2604 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM7 10.82C5.84 10.4 5 9.3 5 8V7h2v3.82zm8 .18c0 1.65-1.35 3-3 3s-3-1.35-3-3V5h6v6zm4-3c0 1.3-.84 2.4-2 2.82V7h2v1z"
	}), _react.default.createElement("path", {
	  d: "M9 11c0 1.65 1.35 3 3 3s3-1.35 3-3V5H9v6z",
	  opacity: ".3"
	})), 'EmojiEventsTwoTone');
	
	exports.default = _default;

/***/ },
/* 2605 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 9l-1-2H7V5.72c.6-.34 1-.98 1-1.72 0-1.1-.9-2-2-2s-2 .9-2 2c0 .74.4 1.38 1 1.72V21h2v-4h5l1 2h7V9h-6zm4 8h-4l-1-2H7V9h5l1 2h5v6z"
	}), 'EmojiFlags');
	
	exports.default = _default;

/***/ },
/* 2606 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 9l-1-2H7V5.72c.6-.34 1-.98 1-1.72 0-1.1-.9-2-2-2s-2 .9-2 2c0 .74.4 1.38 1 1.72V21h2v-4h5l1 2h7V9h-6zm4 8h-4l-1-2H7V9h5l1 2h5v6z"
	}), 'EmojiFlagsOutlined');
	
	exports.default = _default;

/***/ },
/* 2607 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 9h-5l-.72-1.45c-.17-.34-.52-.55-.9-.55H7V5.72c.6-.34 1-.98 1-1.72 0-1.1-.9-2-2-2s-2 .9-2 2c0 .74.4 1.38 1 1.72V20c0 .55.45 1 1 1s1-.45 1-1v-3h5l.72 1.45c.17.34.52.55.89.55H19c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1zm-1 8h-4l-1-2H7V9h5l1 2h5v6z"
	}), 'EmojiFlagsRounded');
	
	exports.default = _default;

/***/ },
/* 2608 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 9l-1-2H7V5.72c.6-.34 1-.98 1-1.72 0-1.1-.9-2-2-2s-2 .9-2 2c0 .74.4 1.38 1 1.72V21h2v-4h5l1 2h7V9h-6zm4 8h-4l-1-2H7V9h5l1 2h5v6z"
	}), 'EmojiFlagsSharp');
	
	exports.default = _default;

/***/ },
/* 2609 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 9H7v6h6l1 2h4v-6h-5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M14 9l-1-2H7V5.72c.6-.34 1-.98 1-1.72 0-1.1-.9-2-2-2s-2 .9-2 2c0 .74.4 1.38 1 1.72V21h2v-4h5l1 2h7V9h-6zm4 8h-4l-1-2H7V9h5l1 2h5v6z"
	})), 'EmojiFlagsTwoTone');
	
	exports.default = _default;

/***/ },
/* 2610 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 3H9v2.4l1.81 1.45c.12.09.19.24.19.39v4.26c0 .28-.22.5-.5.5h-4c-.28 0-.5-.22-.5-.5V7.24c0-.15.07-.3.19-.39L8 5.4V3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z"
	}), 'EmojiFoodBeverage');
	
	exports.default = _default;

/***/ },
/* 2611 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 19h18v2H2zM20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm-4 10c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V5h3v1.4L7.19 7.85c-.12.09-.19.24-.19.39v4.26c0 .28.22.5.5.5h4c.28 0 .5-.22.5-.5V8.24c0-.15-.07-.3-.19-.39L10 6.4V5h6v8zM9.5 7.28l1.5 1.2V12H8V8.48l1.5-1.2zM20 8h-2V5h2v3z"
	}), 'EmojiFoodBeverageOutlined');
	
	exports.default = _default;

/***/ },
/* 2612 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 19H3c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1zM20 3H9v2.4l1.81 1.45c.12.09.19.24.19.39v4.26c0 .28-.22.5-.5.5h-4c-.28 0-.5-.22-.5-.5V7.24c0-.15.07-.3.19-.39L8 5.4V3H6c-1.1 0-2 .9-2 2v8c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 5h-2V5h2v3z"
	}), 'EmojiFoodBeverageRounded');
	
	exports.default = _default;

/***/ },
/* 2613 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 19h18v2H2zM20 3H9v2.4L11 7v5H6V7l2-1.6V3H4v14h14v-7h2c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 5h-2V5h2v3z"
	}), 'EmojiFoodBeverageSharp');
	
	exports.default = _default;

/***/ },
/* 2614 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M10 6.4l1.81 1.45c.12.09.19.24.19.39v4.26c0 .28-.22.5-.5.5h-4c-.28 0-.5-.22-.5-.5V8.24c0-.15.07-.3.19-.39L9 6.4V5H6v8c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V5h-6v1.4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M2 19h18v2H2zM20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zM9.5 7.28l1.5 1.2V12H8V8.48l1.5-1.2zM16 13c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V5h3v1.4L7.19 7.85c-.12.09-.19.24-.19.39v4.26c0 .28.22.5.5.5h4c.28 0 .5-.22.5-.5V8.24c0-.15-.07-.3-.19-.39L10 6.4V5h6v8zm4-5h-2V5h2v3z"
	})), 'EmojiFoodBeverageTwoTone');
	
	exports.default = _default;

/***/ },
/* 2615 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.94 4.88c-.18-.53-.69-.88-1.26-.88H19.6l-.31-.97C19.15 2.43 18.61 2 18 2s-1.15.43-1.29 1.04L16.4 4h-1.07c-.57 0-1.08.35-1.26.88-.19.56.04 1.17.56 1.48l.87.52-.4 1.24c-.23.58-.04 1.25.45 1.62.23.17.51.26.78.26.31 0 .61-.11.86-.32l.81-.7.81.7c.25.21.55.32.86.32.27 0 .55-.09.78-.26.5-.37.68-1.04.45-1.62l-.39-1.24.87-.52c.51-.31.74-.92.56-1.48zM18 7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM13.49 10.51c-.43-.43-.94-.73-1.49-.93V8h-1v1.38c-.11-.01-.23-.03-.34-.03-1.02 0-2.05.39-2.83 1.17-.16.16-.3.34-.43.53L6 10.52c-1.56-.55-3.28.27-3.83 1.82-.27.75-.23 1.57.12 2.29.23.48.58.87 1 1.16-.38 1.35-.06 2.85 1 3.91s2.57 1.38 3.91 1c.29.42.68.77 1.16 1 .42.2.85.3 1.29.3.34 0 .68-.06 1.01-.17 1.56-.55 2.38-2.27 1.82-3.85l-.52-1.37c.18-.13.36-.27.53-.43.87-.87 1.24-2.04 1.14-3.17H16v-1h-1.59c-.19-.55-.49-1.06-.92-1.5zm-8.82 3.78c-.25-.09-.45-.27-.57-.51s-.13-.51-.04-.76c.19-.52.76-.79 1.26-.61l3.16 1.19c-1.15.6-2.63 1.11-3.81.69zm6.32 5.65c-.25.09-.52.08-.76-.04-.24-.11-.42-.32-.51-.57-.42-1.18.09-2.65.7-3.8l1.18 3.13c.18.52-.09 1.1-.61 1.28zm1.21-5.34l-.61-1.61c0-.01-.01-.02-.02-.03l-.06-.12c-.02-.04-.04-.07-.07-.11l-.09-.09-.09-.09c-.03-.03-.07-.05-.11-.07-.04-.02-.07-.05-.12-.06-.01 0-.02-.01-.03-.02l-1.6-.6c.36-.29.79-.46 1.26-.46.53 0 1.04.21 1.41.59.73.73.77 1.88.13 2.67z"
	}), 'EmojiNature');
	
	exports.default = _default;

/***/ },
/* 2616 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.94 4.88c-.18-.53-.69-.88-1.26-.88H19.6l-.31-.97C19.15 2.43 18.61 2 18 2s-1.15.43-1.29 1.04L16.4 4h-1.07c-.57 0-1.08.35-1.26.88-.19.56.04 1.17.56 1.48l.87.52-.4 1.24c-.23.58-.04 1.25.45 1.62.23.17.51.26.78.26.31 0 .61-.11.86-.32l.81-.7.81.7c.25.21.55.32.86.32.27 0 .55-.09.78-.26.5-.37.68-1.04.45-1.62l-.39-1.24.87-.52c.51-.31.74-.92.56-1.48zM18 7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM13.49 10.51c-.43-.43-.94-.73-1.49-.93V8h-1v1.38c-.11-.01-.23-.03-.34-.03-1.02 0-2.05.39-2.83 1.17l-.5.5-1.33-.5c-1.56-.55-3.28.27-3.83 1.82-.27.75-.23 1.57.12 2.29.23.48.58.87 1 1.16-.38 1.35-.06 2.85 1 3.91.78.78 1.8 1.17 2.83 1.17.37 0 .73-.07 1.09-.17.29.42.68.77 1.16 1 .41.2.84.3 1.28.3.34 0 .68-.06 1.01-.17 1.56-.55 2.38-2.27 1.82-3.85l-.49-1.3.5-.5c.87-.87 1.24-2.04 1.14-3.17H16v-1h-1.59c-.19-.55-.49-1.06-.92-1.5zm-5.91 8.31c-.15.04-.3.06-.46.06-.53 0-1.04-.21-1.41-.59-.38-.38-.59-.88-.59-1.41 0-.16.03-.32.06-.47.14.01.28.03.42.03.85 0 1.68-.2 2.44-.48-.32.89-.54 1.87-.46 2.86zm-2.91-4.53c-.25-.09-.45-.27-.57-.51s-.13-.51-.04-.76c.19-.52.76-.79 1.26-.61l3.16 1.19c-1.15.6-2.63 1.11-3.81.69zm6.32 5.65c-.25.09-.52.08-.76-.04-.24-.11-.42-.32-.51-.57-.42-1.18.09-2.65.7-3.8l1.18 3.13c.18.52-.09 1.1-.61 1.28zm1.21-5.34l-.61-1.61c0-.01-.01-.02-.02-.03l-.06-.12c-.02-.04-.04-.07-.07-.11l-.09-.09-.09-.09c-.03-.03-.07-.05-.11-.07-.04-.02-.07-.05-.12-.06-.01 0-.02-.01-.03-.02l-1.6-.6c.36-.29.79-.46 1.26-.46.53 0 1.04.21 1.41.59.73.73.77 1.88.13 2.67z"
	}), 'EmojiNatureOutlined');
	
	exports.default = _default;

/***/ },
/* 2617 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.94 4.88c-.18-.53-.69-.88-1.26-.88H19.6l-.31-.97C19.15 2.43 18.61 2 18 2s-1.15.43-1.29 1.04L16.4 4h-1.07c-.57 0-1.08.35-1.26.88-.19.56.04 1.17.56 1.48l.87.52-.4 1.24c-.23.58-.04 1.25.45 1.62.23.17.51.26.78.26.31 0 .61-.11.86-.32l.81-.7.81.7c.25.21.55.32.86.32.27 0 .55-.09.78-.26.5-.37.68-1.04.45-1.62l-.39-1.24.87-.52c.51-.31.74-.92.56-1.48zM18 7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM15.5 12h-1.09c-.19-.54-.49-1.05-.93-1.49s-.94-.73-1.48-.92V8.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5v.88c-.11-.01-.23-.03-.34-.03-1.02 0-2.05.39-2.83 1.17-.16.16-.3.34-.43.53L6 10.52c-1.56-.55-3.28.27-3.83 1.82-.27.75-.23 1.57.12 2.29.23.48.58.87 1 1.16-.38 1.35-.06 2.85 1 3.91s2.57 1.38 3.91 1c.29.42.68.77 1.16 1 .42.2.85.3 1.29.3.34 0 .68-.06 1.01-.17 1.56-.55 2.38-2.27 1.82-3.85l-.52-1.37c.18-.13.36-.27.53-.43.87-.87 1.24-2.04 1.14-3.17h.88c.28 0 .5-.22.5-.5-.01-.29-.23-.51-.51-.51zM4.67 14.29c-.25-.09-.45-.27-.57-.51s-.13-.51-.04-.76c.19-.52.76-.79 1.26-.61l3.16 1.19c-1.15.6-2.63 1.11-3.81.69zm6.32 5.65c-.25.09-.52.08-.76-.04-.24-.11-.42-.32-.51-.57-.42-1.18.09-2.65.7-3.8l1.18 3.13c.18.52-.09 1.1-.61 1.28zm1.21-5.34l-.61-1.61c0-.01-.01-.02-.02-.03l-.06-.12c-.02-.04-.04-.07-.07-.11l-.09-.09-.09-.09c-.03-.03-.07-.05-.11-.07-.04-.02-.07-.05-.12-.06-.01 0-.02-.01-.03-.02l-1.6-.6c.36-.29.79-.46 1.26-.46.53 0 1.04.21 1.41.59.73.73.77 1.88.13 2.67z"
	}), 'EmojiNatureRounded');
	
	exports.default = _default;

/***/ },
/* 2618 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.94 4.88c-.18-.53-.69-.88-1.26-.88H19.6l-.31-.97C19.15 2.43 18.61 2 18 2s-1.15.43-1.29 1.04L16.4 4h-1.07c-.57 0-1.08.35-1.26.88-.19.56.04 1.17.56 1.48l.87.52-.4 1.24c-.23.58-.04 1.25.45 1.62.23.17.51.26.78.26.31 0 .61-.11.86-.32l.81-.7.81.7c.25.21.55.32.86.32.27 0 .55-.09.78-.26.5-.37.68-1.04.45-1.62l-.39-1.24.87-.52c.51-.31.74-.92.56-1.48zM18 7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM13.49 10.51c-.43-.43-.94-.73-1.49-.93V8h-1v1.38c-.11-.01-.23-.03-.34-.03-1.02 0-2.05.39-2.83 1.17-.16.16-.3.34-.43.53L6 10.52c-1.56-.55-3.28.27-3.83 1.82-.27.75-.23 1.57.12 2.29.23.48.58.87 1 1.16-.38 1.35-.06 2.85 1 3.91s2.57 1.38 3.91 1c.29.42.68.77 1.16 1 .42.2.85.3 1.29.3.34 0 .68-.06 1.01-.17 1.56-.55 2.38-2.27 1.82-3.85l-.52-1.37c.18-.13.36-.27.53-.43.87-.87 1.24-2.04 1.14-3.17H16v-1h-1.59c-.19-.55-.49-1.06-.92-1.5zm-8.82 3.78c-.25-.09-.45-.27-.57-.51s-.13-.51-.04-.76c.19-.52.76-.79 1.26-.61l3.16 1.19c-1.15.6-2.63 1.11-3.81.69zm6.32 5.65c-.25.09-.52.08-.76-.04-.24-.11-.42-.32-.51-.57-.42-1.18.09-2.65.7-3.8l1.18 3.13c.18.52-.09 1.1-.61 1.28zm1.21-5.34l-.61-1.61c0-.01-.01-.02-.02-.03l-.06-.12c-.02-.04-.04-.07-.07-.11l-.09-.09-.09-.09c-.03-.03-.07-.05-.11-.07-.04-.02-.07-.05-.12-.06-.01 0-.02-.01-.03-.02l-1.6-.6c.36-.29.79-.46 1.26-.46.53 0 1.04.21 1.41.59.73.73.77 1.88.13 2.67z"
	}), 'EmojiNatureSharp');
	
	exports.default = _default;

/***/ },
/* 2619 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "18",
	  cy: "6",
	  r: "1",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21.94 4.88c-.19-.55-.75-.92-1.36-.88h-.98l-.31-.97C19.15 2.43 18.61 2 18 2s-1.15.43-1.29 1.04L16.4 4h-.98c-.61-.04-1.16.32-1.35.88-.19.56.04 1.17.56 1.48l.87.52-.4 1.24c-.23.58-.04 1.25.45 1.62.5.37 1.17.35 1.64-.06l.81-.7.81.7c.47.4 1.15.43 1.64.06.5-.37.68-1.04.45-1.62l-.39-1.24.87-.52c.51-.31.74-.92.56-1.48zM18 7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), _react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M6.1 17.9c.53.53 1.27.69 1.94.5-.03-1.19.35-2.37.92-3.36-1 .57-2.17.95-3.36.92-.19.67-.02 1.41.5 1.94zM9.65 11.55l1.61.66c.25.1.44.3.54.54l.66 1.61c.75-.78.74-2.01-.03-2.78-.77-.78-2-.78-2.78-.03z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M14.86 12c-.17-.67-.5-1.31-1.03-1.84-.52-.52-1.16-.85-1.83-1.02V7h-1v2c-1.01.01-2.02.39-2.79 1.16l-.56.56-1.53-.63c-1.52-.63-3.27.1-3.89 1.62-.6 1.46.05 3.11 1.44 3.8-.33 1.31 0 2.76 1.03 3.79 1.03 1.03 2.48 1.36 3.79 1.03.69 1.39 2.34 2.04 3.8 1.44 1.52-.63 2.25-2.37 1.62-3.89l-.63-1.53.56-.56C14.61 15.02 15 14.01 15 13h2v-1h-2.14zM4.58 13.8c-.51-.21-.75-.79-.54-1.3.21-.51.79-.75 1.3-.54l2.92 1.2c-1.04.68-2.43 1.15-3.68.64zm3.46 4.6c-.67.19-1.41.02-1.94-.5-.53-.53-.69-1.27-.5-1.94 1.19.03 2.37-.35 3.36-.92-.57.99-.95 2.17-.92 3.36zm3.46 1.56c-.51.21-1.09-.03-1.3-.54-.51-1.25-.04-2.64.64-3.67l1.2 2.92c.21.5-.03 1.09-.54 1.29zm.95-5.61l-.66-1.61c-.1-.25-.3-.44-.54-.54l-1.61-.66c.78-.75 2.01-.74 2.78.03.78.77.78 2 .03 2.78z"
	}))), 'EmojiNatureTwoTone');
	
	exports.default = _default;

/***/ },
/* 2620 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3c-.46 0-.93.04-1.4.14-2.76.53-4.96 2.76-5.48 5.52-.48 2.61.48 5.01 2.22 6.56.43.38.66.91.66 1.47V19c0 1.1.9 2 2 2h.28c.35.6.98 1 1.72 1s1.38-.4 1.72-1H14c1.1 0 2-.9 2-2v-2.31c0-.55.22-1.09.64-1.46C18.09 13.95 19 12.08 19 10c0-3.87-3.13-7-7-7zm2 16h-4v-1h4v1zm0-2h-4v-1h4v1zm-1.5-5.59V14h-1v-2.59L9.67 9.59l.71-.71L12 10.5l1.62-1.62.71.71-1.83 1.82z"
	}), 'EmojiObjects');
	
	exports.default = _default;

/***/ },
/* 2621 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 3c-.46 0-.93.04-1.4.14-2.76.53-4.96 2.76-5.48 5.52-.48 2.61.48 5.01 2.22 6.56.43.38.66.91.66 1.47V19c0 1.1.9 2 2 2h.28c.35.6.98 1 1.72 1s1.38-.4 1.72-1H14c1.1 0 2-.9 2-2v-2.31c0-.55.22-1.09.64-1.46C18.09 13.95 19 12.08 19 10c0-3.87-3.13-7-7-7zm2 14h-4v-1h4v1zm-4 2v-1h4v1h-4zm5.31-5.26c-.09.08-.16.18-.24.26H8.92c-.08-.09-.15-.19-.24-.27-1.32-1.18-1.91-2.94-1.59-4.7.36-1.94 1.96-3.55 3.89-3.93.34-.07.68-.1 1.02-.1 2.76 0 5 2.24 5 5 0 1.43-.61 2.79-1.69 3.74z"
	}), _react.default.createElement("path", {
	  d: "M11.5 11h1v3h-1z"
	}), _react.default.createElement("path", {
	  d: "M9.6724 9.5808l.7071-.707 2.1213 2.1212-.7071.7071z"
	}), _react.default.createElement("path", {
	  d: "M12.2081 11.7123l-.7071-.7071 2.1213-2.1213.7071.707z"
	})), 'EmojiObjectsOutlined');
	
	exports.default = _default;

/***/ },
/* 2622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3c-.46 0-.93.04-1.4.14-2.76.53-4.96 2.76-5.48 5.52-.48 2.61.48 5.01 2.22 6.56.43.38.66.91.66 1.47V19c0 1.1.9 2 2 2h.28c.35.6.98 1 1.72 1s1.38-.4 1.72-1H14c1.1 0 2-.9 2-2v-2.31c0-.55.22-1.09.64-1.46C18.09 13.95 19 12.08 19 10c0-3.87-3.13-7-7-7zm.5 11h-1v-2.59L9.67 9.59l.71-.71L12 10.5l1.62-1.62.71.71-1.83 1.83V14zm1 5c-.01 0-.02-.01-.03-.01V19h-2.94v-.01c-.01 0-.02.01-.03.01-.28 0-.5-.22-.5-.5s.22-.5.5-.5c.01 0 .02.01.03.01V18h2.94v.01c.01 0 .02-.01.03-.01.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-3c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h3c.28 0 .5.22.5.5s-.22.5-.5.5z"
	}), 'EmojiObjectsRounded');
	
	exports.default = _default;

/***/ },
/* 2623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3c-.42 0-.85.04-1.28.11-2.81.5-5.08 2.75-5.6 5.55-.48 2.61.48 5.01 2.22 6.56.43.38.66.91.66 1.47V21h2.28c.35.6.98 1 1.72 1s1.38-.4 1.72-1H16v-4.31c0-.55.22-1.09.64-1.46C18.09 13.95 19 12.08 19 10c0-3.87-3.13-7-7-7zm2 16h-4v-1h4v1zm0-2h-4v-1h4v1zm-1.5-5.59V14h-1v-2.59L9.67 9.59l.71-.71L12 10.5l1.62-1.62.71.71-1.83 1.82z"
	}), 'EmojiObjectsSharp');
	
	exports.default = _default;

/***/ },
/* 2624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M10 18h4v1h-4zM10 16h4v1h-4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 3c-.46 0-.93.04-1.4.14-2.76.53-4.96 2.76-5.48 5.52-.48 2.61.48 5.01 2.22 6.56.43.38.66.91.66 1.47V19c0 1.1.9 2 2 2h.28c.35.6.98 1 1.72 1s1.38-.4 1.72-1H14c1.1 0 2-.9 2-2v-2.31c0-.55.22-1.09.64-1.46C18.09 13.95 19 12.08 19 10c0-3.87-3.13-7-7-7zm2 16h-4v-1h4v1zm0-2h-4v-1h4v1zm1.31-3.26c-.09.08-.16.18-.24.26H8.92c-.08-.09-.15-.19-.24-.27-1.32-1.18-1.91-2.94-1.59-4.7.36-1.94 1.96-3.55 3.89-3.93.34-.07.68-.1 1.02-.1 2.76 0 5 2.24 5 5 0 1.43-.61 2.79-1.69 3.74z"
	}), _react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M11.5 11h1v3h-1z"
	}), _react.default.createElement("path", {
	  d: "M9.6724 9.5808l.7071-.707 2.1213 2.1212-.7071.7071z"
	}), _react.default.createElement("path", {
	  d: "M12.2081 11.7123l-.7071-.7071 2.1213-2.1213.7071.707z"
	}))), 'EmojiObjectsTwoTone');
	
	exports.default = _default;

/***/ },
/* 2625 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "4",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M15.89 8.11C15.5 7.72 14.83 7 13.53 7h-2.54C8.24 6.99 6 4.75 6 2H4c0 3.16 2.11 5.84 5 6.71V22h2v-6h2v6h2V10.05L18.95 14l1.41-1.41-4.47-4.48z"
	})), 'EmojiPeople');
	
	exports.default = _default;

/***/ },
/* 2626 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "4",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M15.89 8.11C15.5 7.72 14.83 7 13.53 7h-2.54C8.24 6.99 6 4.75 6 2H4c0 3.16 2.11 5.84 5 6.71V22h2v-6h2v6h2V10.05L18.95 14l1.41-1.41-4.47-4.48z"
	})), 'EmojiPeopleOutlined');
	
	exports.default = _default;

/***/ },
/* 2627 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "4",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M15.89 8.11C15.5 7.72 14.83 7 13.53 7h-2.54c-2.46-.01-4.51-1.8-4.92-4.15-.08-.49-.49-.85-.98-.85-.61 0-1.09.54-1 1.14C4.53 5.8 6.47 7.95 9 8.71V21c0 .55.45 1 1 1s1-.45 1-1v-5h2v5c0 .55.45 1 1 1s1-.45 1-1V10.05l3.24 3.24c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41l-3.76-3.77z"
	})), 'EmojiPeopleRounded');
	
	exports.default = _default;

/***/ },
/* 2628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "4",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M15.89 8.11C15.5 7.72 14.83 7 13.53 7h-2.54C8.24 6.99 6 4.75 6 2H4c0 3.16 2.11 5.84 5 6.71V22h2v-6h2v6h2V10.05L18.95 14l1.41-1.41-4.47-4.48z"
	})), 'EmojiPeopleSharp');
	
	exports.default = _default;

/***/ },
/* 2629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "4",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M15.89 8.11C15.5 7.72 14.83 7 13.53 7h-2.54C8.24 6.99 6 4.75 6 2H4c0 3.16 2.11 5.84 5 6.71V22h2v-6h2v6h2V10.05L18.95 14l1.41-1.41-4.47-4.48z"
	})), 'EmojiPeopleTwoTone');
	
	exports.default = _default;

/***/ },
/* 2630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 2h8v2H3zM6 11h2V7h3V5H3v2h3zM12.4036 20.1819l7.7781-7.7781 1.4142 1.4142-7.778 7.778z"
	}), _react.default.createElement("circle", {
	  cx: "14.5",
	  cy: "14.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "19.5",
	  cy: "19.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M15.5 11c1.38 0 2.5-1.12 2.5-2.5V4h3V2h-4v4.51c-.42-.32-.93-.51-1.5-.51C14.12 6 13 7.12 13 8.5s1.12 2.5 2.5 2.5zM9.74 15.96l-1.41 1.41-.71-.71.35-.35c.98-.98.98-2.56 0-3.54-.49-.49-1.13-.73-1.77-.73-.64 0-1.28.24-1.77.73-.98.98-.98 2.56 0 3.54l.35.35-1.06 1.06c-.98.98-.98 2.56 0 3.54.5.5 1.14.74 1.78.74s1.28-.24 1.77-.73l1.06-1.06 1.41 1.41 1.41-1.41-1.41-1.41 1.41-1.41-1.41-1.43zM5.85 14.2c.12-.12.26-.15.35-.15s.23.03.35.15c.19.2.19.51 0 .71l-.35.35-.35-.36c-.19-.19-.19-.51 0-.7zm0 5.65c-.12.12-.26.15-.35.15s-.23-.03-.35-.15c-.19-.19-.19-.51 0-.71l1.06-1.06.71.71-1.07 1.06z"
	})), 'EmojiSymbols');
	
	exports.default = _default;

/***/ },
/* 2631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 2h8v2H3zM6 11h2V7h3V5H3v2h3zM12.4036 20.1819l7.7781-7.7781 1.4142 1.4142-7.778 7.778z"
	}), _react.default.createElement("circle", {
	  cx: "14.5",
	  cy: "14.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "19.5",
	  cy: "19.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M15.5 11c1.38 0 2.5-1.12 2.5-2.5V4h3V2h-4v4.51c-.42-.32-.93-.51-1.5-.51C14.12 6 13 7.12 13 8.5s1.12 2.5 2.5 2.5zM9.74 15.96l-1.41 1.41-.71-.71.35-.35c.98-.98.98-2.56 0-3.54-.49-.49-1.13-.73-1.77-.73-.64 0-1.28.24-1.77.73-.98.98-.98 2.56 0 3.54l.35.35-1.06 1.06c-.98.98-.98 2.56 0 3.54.5.5 1.14.74 1.78.74s1.28-.24 1.77-.73l1.06-1.06 1.41 1.41 1.41-1.41-1.41-1.41 1.41-1.41-1.41-1.43zM5.85 14.2c.12-.12.26-.15.35-.15s.23.03.35.15c.19.2.19.51 0 .71l-.35.35-.35-.36c-.19-.19-.19-.51 0-.7zm0 5.65c-.12.12-.26.15-.35.15s-.23-.03-.35-.15c-.19-.19-.19-.51 0-.71l1.06-1.06.71.71-1.07 1.06z"
	})), 'EmojiSymbolsOutlined');
	
	exports.default = _default;

/***/ },
/* 2632 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M10 5H4c-.55 0-1 .45-1 1s.45 1 1 1h2v3c0 .55.45 1 1 1s1-.45 1-1V7h2c.55 0 1-.45 1-1s-.45-1-1-1zM10 2H4c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zM20.89 13.11a.9959.9959 0 00-1.41 0l-6.36 6.36c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l6.36-6.36c.39-.39.39-1.02 0-1.41z"
	}), _react.default.createElement("circle", {
	  cx: "14.5",
	  cy: "14.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "19.5",
	  cy: "19.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M15.5 11c1.38 0 2.5-1.12 2.5-2.5V4h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1v3.51c-.42-.32-.93-.51-1.5-.51C14.12 6 13 7.12 13 8.5s1.12 2.5 2.5 2.5zM10.45 18.09c.39-.39.39-1.02 0-1.41a.9959.9959 0 00-1.41 0l-.71.71-.71-.71.35-.35c.98-.98.98-2.56 0-3.54-.49-.49-1.13-.73-1.77-.73-.64 0-1.28.24-1.77.73-.98.98-.98 2.56 0 3.54l.35.35-1.06 1.06c-.98.98-.98 2.56 0 3.54.5.48 1.14.72 1.78.72.64 0 1.28-.24 1.77-.73l1.06-1.06.71.71c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41l-.71-.71.71-.71zm-4.6-3.89c.12-.12.26-.15.35-.15s.23.03.35.15c.19.2.19.51 0 .71l-.35.35-.35-.36c-.12-.12-.15-.26-.15-.35s.03-.23.15-.35zm0 5.65c-.12.12-.26.15-.35.15s-.23-.03-.35-.15c-.12-.12-.15-.26-.15-.35s.03-.23.15-.35l1.06-1.06.71.71-1.07 1.05z"
	})), 'EmojiSymbolsRounded');
	
	exports.default = _default;

/***/ },
/* 2633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 2h8v2H3zM6 11h2V7h3V5H3v2h3zM12.4036 20.1819l7.7781-7.7781 1.4142 1.4142-7.778 7.778z"
	}), _react.default.createElement("circle", {
	  cx: "14.5",
	  cy: "14.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "19.5",
	  cy: "19.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M15.5 11c1.38 0 2.5-1.12 2.5-2.5V4h3V2h-4v4.51c-.42-.32-.93-.51-1.5-.51C14.12 6 13 7.12 13 8.5s1.12 2.5 2.5 2.5zM9.74 15.96l-1.41 1.41-.71-.71.35-.35c.98-.98.98-2.56 0-3.54-.49-.49-1.13-.73-1.77-.73-.64 0-1.28.24-1.77.73-.98.98-.98 2.56 0 3.54l.35.35-1.06 1.06c-.98.98-.98 2.56 0 3.54.5.5 1.14.74 1.78.74s1.28-.24 1.77-.73l1.06-1.06 1.41 1.41 1.41-1.41-1.41-1.41 1.41-1.41-1.41-1.43zM5.85 14.2c.12-.12.26-.15.35-.15s.23.03.35.15c.19.2.19.51 0 .71l-.35.35-.35-.36c-.19-.19-.19-.51 0-.7zm0 5.65c-.12.12-.26.15-.35.15s-.23-.03-.35-.15c-.19-.19-.19-.51 0-.71l1.06-1.06.71.71-1.07 1.06z"
	})), 'EmojiSymbolsSharp');
	
	exports.default = _default;

/***/ },
/* 2634 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 2h8v2H3zM6 11h2V7h3V5H3v2h3zM12.4036 20.1819l7.7781-7.7781 1.4142 1.4142-7.778 7.778z"
	}), _react.default.createElement("circle", {
	  cx: "14.5",
	  cy: "14.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "19.5",
	  cy: "19.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M15.5 11c1.38 0 2.5-1.12 2.5-2.5V4h3V2h-4v4.51c-.42-.32-.93-.51-1.5-.51C14.12 6 13 7.12 13 8.5s1.12 2.5 2.5 2.5zM9.74 15.96l-1.41 1.41-.71-.71.35-.35c.98-.98.98-2.56 0-3.54-.49-.49-1.13-.73-1.77-.73-.64 0-1.28.24-1.77.73-.98.98-.98 2.56 0 3.54l.35.35-1.06 1.06c-.98.98-.98 2.56 0 3.54.5.5 1.14.74 1.78.74s1.28-.24 1.77-.73l1.06-1.06 1.41 1.41 1.41-1.41-1.41-1.41 1.41-1.41-1.41-1.43zM5.85 14.2c.12-.12.26-.15.35-.15s.23.03.35.15c.19.2.19.51 0 .71l-.35.35-.35-.36c-.19-.19-.19-.51 0-.7zm0 5.65c-.12.12-.26.15-.35.15s-.23-.03-.35-.15c-.19-.19-.19-.51 0-.71l1.06-1.06.71.71-1.07 1.06z"
	})), 'EmojiSymbolsTwoTone');
	
	exports.default = _default;

/***/ },
/* 2635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20.57 10.66c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66L10 14.77l.01 5.51c0 .38.31.72.69.72h.62c.38 0 .68-.38.68-.76V19h8v1.24c0 .38.31.76.69.76h.61c.38 0 .69-.34.69-.72l.01-1.37v-4.14l-1.43-4.11zm-8.16.34h7.19l1.03 3h-9.25l1.03-3zM12 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), _react.default.createElement("path", {
	  d: "M14 9h1V3H7v5H2v13h1V9h5V4h6z"
	}), _react.default.createElement("path", {
	  d: "M5 11h2v2H5zM10 5h2v2h-2zM5 15h2v2H5zM5 19h2v2H5z"
	})), 'EmojiTransportation');
	
	exports.default = _default;

/***/ },
/* 2636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20.57 10.66c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66L10 14.77l.01 5.51c0 .38.31.72.69.72h.62c.38 0 .68-.38.68-.76V19h8v1.24c0 .38.31.76.69.76h.61c.38 0 .69-.34.69-.72l.01-1.37v-4.14l-1.43-4.11zm-8.16.34h7.19l1.03 3h-9.25l1.03-3zM12 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), _react.default.createElement("path", {
	  d: "M14 9h1V3H7v5H2v13h1V9h5V4h6z"
	}), _react.default.createElement("path", {
	  d: "M5 11h2v2H5zM10 5h2v2h-2zM5 15h2v2H5zM5 19h2v2H5z"
	})), 'EmojiTransportationOutlined');
	
	exports.default = _default;

/***/ },
/* 2637 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21.99 14.77l-1.43-4.11c-.14-.4-.52-.66-.97-.66H12.4c-.46 0-.83.26-.98.66L10 14.77v5.24c0 .55.45.99 1 .99s1-.45 1-1v-1h8v1c0 .55.45 1 1 1s.99-.44 1-.99l-.01-5.24zm-10.38-1.43l.69-2c.05-.2.24-.34.46-.34h6.48c.21 0 .4.14.47.34l.69 2c.11.32-.13.66-.47.66h-7.85c-.34 0-.58-.34-.47-.66zm.38 3.66c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), _react.default.createElement("path", {
	  d: "M14 4.5V9h1V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v4H3c-.55 0-1 .45-1 1v12h1V9.5c0-.28.22-.5.5-.5h4c.28 0 .5-.22.5-.5v-4c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5z"
	}), _react.default.createElement("path", {
	  d: "M5 11h2v2H5zM10 5h2v2h-2zM5 15h2v2H5zM5 19h2v2H5z"
	})), 'EmojiTransportationRounded');
	
	exports.default = _default;

/***/ },
/* 2638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20.57 10.66c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66L10 14.77l.01 5.51c0 .38.31.72.69.72h.62c.38 0 .68-.38.68-.76V19h8v1.24c0 .38.31.76.69.76h.61c.38 0 .69-.34.69-.72l.01-1.37v-4.14l-1.43-4.11zm-8.16.34h7.19l1.03 3h-9.25l1.03-3zM12 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), _react.default.createElement("path", {
	  d: "M14 9h1V3H7v5H2v13h1V9h5V4h6z"
	}), _react.default.createElement("path", {
	  d: "M5 11h2v2H5zM10 5h2v2h-2zM5 15h2v2H5zM5 19h2v2H5z"
	})), 'EmojiTransportationSharp');
	
	exports.default = _default;

/***/ },
/* 2639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20.57 10.66c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66L10 14.77l.01 5.51c0 .38.31.72.69.72h.62c.38 0 .68-.38.68-.76V19h8v1.24c0 .38.31.76.69.76h.61c.38 0 .69-.34.69-.72l.01-1.37v-4.14l-1.43-4.11zm-8.16.34h7.19l1.03 3h-9.25l1.03-3zM12 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), _react.default.createElement("path", {
	  d: "M14 9h1V3H7v5H2v13h1V9h5V4h6z"
	}), _react.default.createElement("path", {
	  d: "M5 11h2v2H5zM10 5h2v2h-2zM5 15h2v2H5zM5 19h2v2H5z"
	})), 'EmojiTransportationTwoTone');
	
	exports.default = _default;

/***/ },
/* 2640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM16 16h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z"
	}), 'EnhancedEncryption');
	
	exports.default = _default;

/***/ },
/* 2641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10zm-5-9h-2v3H8v2h3v3h2v-3h3v-2h-3z"
	}), 'EnhancedEncryptionOutlined');
	
	exports.default = _default;

/***/ },
/* 2642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM15 16h-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2H9c-.55 0-1-.45-1-1s.45-1 1-1h2v-2c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'EnhancedEncryptionRounded');
	
	exports.default = _default;

/***/ },
/* 2643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8h-3V6.22c0-2.61-1.91-4.94-4.51-5.19C9.51.74 7 3.08 7 6v2H4v14h16V8zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM16 16h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z"
	}), 'EnhancedEncryptionSharp');
	
	exports.default = _default;

/***/ },
/* 2644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 20h12V10H6v10zm2-6h3v-3h2v3h3v2h-3v3h-2v-3H8v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10zm-7-1h2v-3h3v-2h-3v-3h-2v3H8v2h3z"
	})), 'EnhancedEncryptionTwoTone');
	
	exports.default = _default;

/***/ },
/* 2645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z"
	}), 'Equalizer');
	
	exports.default = _default;

/***/ },
/* 2646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z"
	}), 'EqualizerOutlined');
	
	exports.default = _default;

/***/ },
/* 2647 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 20c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2s-2 .9-2 2v12c0 1.1.9 2 2 2zm-6 0c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2s-2 .9-2 2v4c0 1.1.9 2 2 2zm10-9v7c0 1.1.9 2 2 2s2-.9 2-2v-7c0-1.1-.9-2-2-2s-2 .9-2 2z"
	}), 'EqualizerRounded');
	
	exports.default = _default;

/***/ },
/* 2648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z"
	}), 'EqualizerSharp');
	
	exports.default = _default;

/***/ },
/* 2649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 9h4v11h-4zm-6-5h4v16h-4zm-6 8h4v8H4z"
	}), 'EqualizerTwoTone');
	
	exports.default = _default;

/***/ },
/* 2650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
	}), 'Error');
	
	exports.default = _default;

/***/ },
/* 2651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'ErrorOutline');
	
	exports.default = _default;

/***/ },
/* 2652 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'ErrorOutlineOutlined');
	
	exports.default = _default;

/***/ },
/* 2653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1zm-.01-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-3h-2v-2h2v2z"
	}), 'ErrorOutlineRounded');
	
	exports.default = _default;

/***/ },
/* 2654 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'ErrorOutlineSharp');
	
	exports.default = _default;

/***/ },
/* 2655 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-1-5h2v2h-2zm0-8h2v6h-2z"
	}), 'ErrorOutlineTwoTone');
	
	exports.default = _default;

/***/ },
/* 2656 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
	}), 'ErrorOutlined');
	
	exports.default = _default;

/***/ },
/* 2657 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 11c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z"
	}), 'ErrorRounded');
	
	exports.default = _default;

/***/ },
/* 2658 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
	}), 'ErrorSharp');
	
	exports.default = _default;

/***/ },
/* 2659 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm1 13h-2v-2h2v2zm0-4h-2V7h2v6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-1-5h2v2h-2zm0-8h2v6h-2z"
	})), 'ErrorTwoTone');
	
	exports.default = _default;

/***/ },
/* 2660 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15l1-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15l1-2H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3l-1 2h4.06c-.04.33-.06.66-.06 1s.02.67.06 1H3l-1 2h4.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
	}), 'Euro');
	
	exports.default = _default;

/***/ },
/* 2661 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15l1-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15l1-2H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3l-1 2h4.06c-.04.33-.06.66-.06 1s.02.67.06 1H3l-1 2h4.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
	}), 'EuroOutlined');
	
	exports.default = _default;

/***/ },
/* 2662 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 18.5c-2.51 0-4.68-1.42-5.76-3.5h5.14c.38 0 .73-.21.89-.55.33-.66-.15-1.45-.89-1.45h-5.8c-.05-.33-.08-.66-.08-1s.03-.67.08-1h5.8c.38 0 .73-.21.89-.55.34-.67-.14-1.45-.89-1.45H9.24C10.32 6.92 12.5 5.5 15 5.5c1.25 0 2.42.36 3.42.97.5.31 1.15.26 1.57-.16.58-.58.45-1.53-.25-1.96C18.36 3.5 16.73 3 15 3c-3.92 0-7.24 2.51-8.48 6h-2.9c-.38 0-.73.21-.9.55-.33.67.15 1.45.9 1.45h2.44c-.04.33-.06.66-.06 1s.02.67.06 1H3.62c-.38 0-.73.21-.89.55-.34.67.14 1.45.89 1.45h2.9c1.24 3.49 4.56 6 8.48 6 1.74 0 3.36-.49 4.74-1.35.69-.43.82-1.39.24-1.97-.42-.42-1.07-.47-1.57-.15-.99.62-2.15.97-3.41.97z"
	}), 'EuroRounded');
	
	exports.default = _default;

/***/ },
/* 2663 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15l1-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15l1-2H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3l-1 2h4.06c-.04.33-.06.66-.06 1s.02.67.06 1H3l-1 2h4.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
	}), 'EuroSharp');
	
	exports.default = _default;

/***/ },
/* 2664 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06c-.04.33-.06.66-.06 1 0 .34.02.67.06 1H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
	}), 'EuroSymbol');
	
	exports.default = _default;

/***/ },
/* 2665 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06c-.04.33-.06.66-.06 1s.02.67.06 1H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
	}), 'EuroSymbolOutlined');
	
	exports.default = _default;

/***/ },
/* 2666 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H14c.55 0 1-.45 1-1s-.45-1-1-1H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H14c.55 0 1-.45 1-1s-.45-1-1-1H9.24C10.32 6.92 12.5 5.5 15 5.5c1.25 0 2.42.36 3.42.97.5.31 1.15.26 1.57-.16.58-.58.45-1.53-.25-1.96C18.36 3.5 16.73 3 15 3c-3.92 0-7.24 2.51-8.48 6H4c-.55 0-1 .45-1 1s.45 1 1 1h2.06c-.04.33-.06.66-.06 1s.02.67.06 1H4c-.55 0-1 .45-1 1s.45 1 1 1h2.52c1.24 3.49 4.56 6 8.48 6 1.74 0 3.36-.49 4.74-1.35.69-.43.82-1.39.24-1.97-.42-.42-1.07-.47-1.57-.15-.99.62-2.15.97-3.41.97z"
	}), 'EuroSymbolRounded');
	
	exports.default = _default;

/***/ },
/* 2667 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06c-.04.33-.06.66-.06 1s.02.67.06 1H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
	}), 'EuroSymbolSharp');
	
	exports.default = _default;

/***/ },
/* 2668 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06c-.04.33-.06.66-.06 1s.02.67.06 1H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
	}), 'EuroSymbolTwoTone');
	
	exports.default = _default;

/***/ },
/* 2669 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15l1-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15l1-2H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3l-1 2h4.06c-.04.33-.06.66-.06 1s.02.67.06 1H3l-1 2h4.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
	}), 'EuroTwoTone');
	
	exports.default = _default;

/***/ },
/* 2670 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM18 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM8 18v-4.5H6L10 6v5h2l-4 7z"
	}), 'EvStation');
	
	exports.default = _default;

/***/ },
/* 2671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 11v8H6V5h6v6zm6-1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-8-4l-4 7.5h2V18l4-7h-2z"
	}), 'EvStationOutlined');
	
	exports.default = _default;

/***/ },
/* 2672 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.77 7.23l.01-.01-3.19-3.19c-.29-.29-.77-.29-1.06 0-.29.29-.29.77 0 1.06l1.58 1.58c-1.05.4-1.76 1.47-1.58 2.71.16 1.1 1.1 1.99 2.2 2.11.47.05.88-.03 1.27-.2v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v15c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-6.5h1.5v4.86c0 1.31.94 2.5 2.24 2.63 1.5.15 2.76-1.02 2.76-2.49V9c0-.69-.28-1.32-.73-1.77zM18 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM8 16.12V13.5H6.83c-.38 0-.62-.4-.44-.74l2.67-5c.24-.45.94-.28.94.24v3h1.14c.38 0 .62.41.43.75l-2.64 4.62c-.25.44-.93.26-.93-.25z"
	}), 'EvStationRounded');
	
	exports.default = _default;

/***/ },
/* 2673 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-1.05.4-1.76 1.47-1.58 2.71.16 1.1 1.1 1.99 2.2 2.11.47.05.88-.03 1.27-.2v8.21h-2V12h-3V3H4v18h10v-7.5h1.5V21h5V9c0-.69-.28-1.32-.73-1.77zM18 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM8 18v-4.5H6L10 6v5h2l-4 7z"
	}), 'EvStationSharp');
	
	exports.default = _default;

/***/ },
/* 2674 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 13.5H6V19h6v-8l-4 7zm-2 0L10 6v5h2V5H6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 3H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2zm0 8v8H6V5h6v6zm6-1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-8-4l-4 7.5h2V18l4-7h-2z"
	})), 'EvStationTwoTone');
	
	exports.default = _default;

/***/ },
/* 2675 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
	}), 'Event');
	
	exports.default = _default;

/***/ },
/* 2676 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z"
	}), 'EventAvailable');
	
	exports.default = _default;

/***/ },
/* 2677 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zM5 7V5h14v2H5zm5.56 10.46l5.93-5.93-1.06-1.06-4.87 4.87-2.11-2.11-1.06 1.06z"
	}), 'EventAvailableOutlined');
	
	exports.default = _default;

/***/ },
/* 2678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 10.53c-.29-.29-.77-.29-1.06 0l-4.35 4.35L9 13.29c-.29-.29-.77-.29-1.06 0-.29.29-.29.77 0 1.06l1.94 1.94c.39.39 1.02.39 1.41 0l4.7-4.7c.3-.29.3-.77.01-1.06zM19 3h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1H8V2c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16H6c-.55 0-1-.45-1-1V8h14v10c0 .55-.45 1-1 1z"
	}), 'EventAvailableRounded');
	
	exports.default = _default;

/***/ },
/* 2679 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM21 3h-3V1h-2v2H8V1H6v2H3v18h18V3zm-2 16H5V8h14v11z"
	}), 'EventAvailableSharp');
	
	exports.default = _default;

/***/ },
/* 2680 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 5h14v2H5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2zm-2.51 4.53l-1.06-1.06-4.87 4.87-2.11-2.11-1.06 1.06 3.17 3.17z"
	})), 'EventAvailableTwoTone');
	
	exports.default = _default;

/***/ },
/* 2681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.31 17l2.44-2.44L14.19 17l1.06-1.06-2.44-2.44 2.44-2.44L14.19 10l-2.44 2.44L9.31 10l-1.06 1.06 2.44 2.44-2.44 2.44L9.31 17zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z"
	}), 'EventBusy');
	
	exports.default = _default;

/***/ },
/* 2682 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zM5 7V5h14v2H5zm3.23 9.41l1.06 1.06 2.44-2.44 2.44 2.44 1.06-1.06-2.44-2.44 2.44-2.44-1.06-1.06-2.44 2.44-2.44-2.44-1.06 1.06 2.44 2.44z"
	}), 'EventBusyOutlined');
	
	exports.default = _default;

/***/ },
/* 2683 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.84 16.47l1.91-1.91 1.91 1.91c.29.29.77.29 1.06 0 .29-.29.29-.77 0-1.06l-1.91-1.91 1.91-1.91c.29-.29.29-.77 0-1.06-.29-.29-.77-.29-1.06 0l-1.91 1.91-1.91-1.91c-.29-.29-.77-.29-1.06 0-.29.29-.29.77 0 1.06l1.91 1.91-1.91 1.91c-.29.29-.29.77 0 1.06.29.29.77.29 1.06 0zM19 3h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1H8V2c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16H6c-.55 0-1-.45-1-1V8h14v10c0 .55-.45 1-1 1z"
	}), 'EventBusyRounded');
	
	exports.default = _default;

/***/ },
/* 2684 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.31 17l2.44-2.44L14.19 17l1.06-1.06-2.44-2.44 2.44-2.44L14.19 10l-2.44 2.44L9.31 10l-1.06 1.06 2.44 2.44-2.44 2.44L9.31 17zM21 3h-3V1h-2v2H8V1H6v2H3.01L3 21h18V3zm-2 16H5V8h14v11z"
	}), 'EventBusySharp');
	
	exports.default = _default;

/***/ },
/* 2685 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 5h14v2H5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2zM9.29 17.47l2.44-2.44 2.44 2.44 1.06-1.06-2.44-2.44 2.44-2.44-1.06-1.06-2.44 2.44-2.44-2.44-1.06 1.06 2.44 2.44-2.44 2.44z"
	})), 'EventBusyTwoTone');
	
	exports.default = _default;

/***/ },
/* 2686 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z"
	}), 'EventNote');
	
	exports.default = _default;

/***/ },
/* 2687 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zM5 7V5h14v2H5zm2 4h10v2H7zm0 4h7v2H7z"
	}), 'EventNoteOutlined');
	
	exports.default = _default;

/***/ },
/* 2688 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 10H8c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1zm3-7h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1H8V2c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16H6c-.55 0-1-.45-1-1V8h14v10c0 .55-.45 1-1 1zm-5-5H8c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1z"
	}), 'EventNoteRounded');
	
	exports.default = _default;

/***/ },
/* 2689 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 10H7v2h10v-2zm4-7h-3V1h-2v2H8V1H6v2H3v18h18V3zm-2 16H5V8h14v11zm-5-5H7v2h7v-2z"
	}), 'EventNoteSharp');
	
	exports.default = _default;

/***/ },
/* 2690 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 5h14v2H5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2zM7 11h10v2H7zm0 4h7v2H7z"
	})), 'EventNoteTwoTone');
	
	exports.default = _default;

/***/ },
/* 2691 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zm-7 5h5v5h-5z"
	}), 'EventOutlined');
	
	exports.default = _default;

/***/ },
/* 2692 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 13h-3c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm0-10v1H8V3c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-1V3c0-.55-.45-1-1-1s-1 .45-1 1zm2 17H6c-.55 0-1-.45-1-1V9h14v10c0 .55-.45 1-1 1z"
	}), 'EventRounded');
	
	exports.default = _default;

/***/ },
/* 2693 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 18v3h3v-3h10v3h3v-6H4v3zm15-8h3v3h-3v-3zM2 10h3v3H2v-3zm15 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z"
	}), 'EventSeat');
	
	exports.default = _default;

/***/ },
/* 2694 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 5v7H9V5h6m0-2H9c-1.1 0-2 .9-2 2v9h10V5c0-1.1-.9-2-2-2zm7 7h-3v3h3v-3zM5 10H2v3h3v-3zm15 5H4v6h2v-4h12v4h2v-6z"
	}), 'EventSeatOutlined');
	
	exports.default = _default;

/***/ },
/* 2695 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.5 21c.83 0 1.5-.67 1.5-1.5V18h10v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V17c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v2.5c0 .83.67 1.5 1.5 1.5zM20 10h1c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1zM3 10h1c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1zm14 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z"
	}), 'EventSeatRounded');
	
	exports.default = _default;

/***/ },
/* 2696 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 21h3v-3h10v3h3v-6H4v6zm15-11h3v3h-3v-3zM2 10h3v3H2v-3zm15 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z"
	}), 'EventSeatSharp');
	
	exports.default = _default;

/***/ },
/* 2697 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9 5h6v7H9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 21h2v-4h12v4h2v-6H4zM17 5c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v9h10V5zm-2 7H9V5h6v7zm4-2h3v3h-3zM2 10h3v3H2z"
	})), 'EventSeatTwoTone');
	
	exports.default = _default;

/***/ },
/* 2698 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 13h-5v5h5v-5zM16 2v2H8V2H6v2H3.01L3 22h18V4h-3V2h-2zm3 18H5V9h14v11z"
	}), 'EventSharp');
	
	exports.default = _default;

/***/ },
/* 2699 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 8h14V6H5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zm-7 5h5v5h-5z"
	})), 'EventTwoTone');
	
	exports.default = _default;

/***/ },
/* 2700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'ExitToApp');
	
	exports.default = _default;

/***/ },
/* 2701 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'ExitToAppOutlined');
	
	exports.default = _default;

/***/ },
/* 2702 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.79 16.29c.39.39 1.02.39 1.41 0l3.59-3.59c.39-.39.39-1.02 0-1.41L12.2 7.7a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L12.67 11H4c-.55 0-1 .45-1 1s.45 1 1 1h8.67l-1.88 1.88c-.39.39-.38 1.03 0 1.41zM19 3H5c-1.11 0-2 .9-2 2v3c0 .55.45 1 1 1s1-.45 1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1v3c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'ExitToAppRounded');
	
	exports.default = _default;

/***/ },
/* 2703 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM21 3H3v6h2V5h14v14H5v-4H3v6h18V3z"
	}), 'ExitToAppSharp');
	
	exports.default = _default;

/***/ },
/* 2704 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'ExitToAppTwoTone');
	
	exports.default = _default;

/***/ },
/* 2705 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
	}), 'ExpandLess');
	
	exports.default = _default;

/***/ },
/* 2706 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z"
	}), 'ExpandLessOutlined');
	
	exports.default = _default;

/***/ },
/* 2707 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.29 8.71L6.7 13.3c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 10.83l3.88 3.88c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L12.7 8.71c-.38-.39-1.02-.39-1.41 0z"
	}), 'ExpandLessRounded');
	
	exports.default = _default;

/***/ },
/* 2708 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z"
	}), 'ExpandLessSharp');
	
	exports.default = _default;

/***/ },
/* 2709 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z"
	}), 'ExpandLessTwoTone');
	
	exports.default = _default;

/***/ },
/* 2710 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
	}), 'ExpandMore');
	
	exports.default = _default;

/***/ },
/* 2711 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"
	}), 'ExpandMoreOutlined');
	
	exports.default = _default;

/***/ },
/* 2712 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.88 9.29L12 13.17 8.12 9.29a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41-.39-.38-1.03-.39-1.42 0z"
	}), 'ExpandMoreRounded');
	
	exports.default = _default;

/***/ },
/* 2713 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"
	}), 'ExpandMoreSharp');
	
	exports.default = _default;

/***/ },
/* 2714 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"
	}), 'ExpandMoreTwoTone');
	
	exports.default = _default;

/***/ },
/* 2715 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h4v2h-4v2h4v2H9V7h6v2z"
	}), 'Explicit');
	
	exports.default = _default;

/***/ },
/* 2716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-4-4h-4v-2h4v-2h-4V9h4V7H9v10h6z"
	}), 'ExplicitOutlined');
	
	exports.default = _default;

/***/ },
/* 2717 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 6h-3v2h3c.55 0 1 .45 1 1s-.45 1-1 1h-3v2h3c.55 0 1 .45 1 1s-.45 1-1 1h-4c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'ExplicitRounded');
	
	exports.default = _default;

/***/ },
/* 2718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zm-6 6h-4v2h4v2h-4v2h4v2H9V7h6v2z"
	}), 'ExplicitSharp');
	
	exports.default = _default;

/***/ },
/* 2719 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14V5H5v14zM9 7h6v2h-4v2h4v2h-4v2h4v2H9V7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zm-2 0H5V5h14v14zm-4-4h-4v-2h4v-2h-4V9h4V7H9v10h6z"
	})), 'ExplicitTwoTone');
	
	exports.default = _default;

/***/ },
/* 2720 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z"
	}), 'Explore');
	
	exports.default = _default;

/***/ },
/* 2721 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.19 14.19l-1.41-1.41-1.56-1.56L11 11 9.81 9.81 4.93 4.93 2.27 2.27 1 3.54l2.78 2.78c-.11.16-.21.32-.31.48-.04.07-.09.14-.13.21-.09.15-.17.31-.25.47-.05.1-.1.21-.16.32-.06.14-.13.28-.19.43-.1.24-.19.48-.27.73l-.09.3c-.05.2-.1.39-.14.59-.02.11-.04.22-.07.33-.04.2-.07.4-.09.61-.01.1-.03.2-.03.3-.03.29-.05.6-.05.91 0 5.52 4.48 10 10 10 .31 0 .62-.02.92-.05l.3-.03c.2-.02.41-.06.61-.09.11-.02.22-.04.33-.07.2-.04.39-.09.58-.15.1-.03.2-.05.3-.09.25-.08.49-.17.73-.27.15-.06.29-.13.43-.19.11-.05.22-.1.33-.16.16-.08.31-.16.46-.25.07-.04.14-.09.21-.13.16-.1.32-.2.48-.31L20.46 23l1.27-1.27-2.66-2.66-4.88-4.88zM6 18l3-6.46L12.46 15 6 18zm16-6c0 .31-.02.62-.05.92l-.03.3c-.02.2-.06.41-.09.61-.02.11-.04.22-.07.33-.04.2-.09.39-.15.58-.03.1-.05.21-.09.31-.08.25-.17.49-.27.73-.06.15-.13.29-.19.43-.05.11-.1.22-.16.33-.08.16-.16.31-.25.46-.04.07-.09.14-.13.21-.1.16-.2.32-.31.48L15 12.46 18 6l-6.46 3-5.22-5.22c.16-.11.32-.21.48-.31.07-.04.14-.09.21-.13.15-.09.31-.17.46-.25.11-.05.22-.1.33-.16.14-.06.28-.13.43-.19.24-.1.48-.19.73-.27l.31-.09c.19-.05.38-.11.58-.15.11-.02.22-.04.33-.07.2-.04.4-.07.61-.09.1-.01.2-.03.3-.03.29-.02.6-.04.91-.04 5.52 0 10 4.48 10 10z"
	}), 'ExploreOff');
	
	exports.default = _default;

/***/ },
/* 2722 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4c4.41 0 8 3.59 8 8 0 1.48-.41 2.86-1.12 4.06l1.46 1.46C21.39 15.93 22 14.04 22 12c0-5.52-4.48-10-10-10-2.04 0-3.93.61-5.51 1.66l1.46 1.46C9.14 4.41 10.52 4 12 4zm2.91 8.08L17.5 6.5l-5.58 2.59 2.99 2.99zM2.1 4.93l1.56 1.56C2.61 8.07 2 9.96 2 12c0 5.52 4.48 10 10 10 2.04 0 3.93-.61 5.51-1.66l1.56 1.56 1.41-1.41L3.51 3.51 2.1 4.93zm3.02 3.01l3.98 3.98-2.6 5.58 5.58-2.59 3.98 3.98c-1.2.7-2.58 1.11-4.06 1.11-4.41 0-8-3.59-8-8 0-1.48.41-2.86 1.12-4.06z"
	}), 'ExploreOffOutlined');
	
	exports.default = _default;

/***/ },
/* 2723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 6l-2.91 6.26 5.25 5.25C21.39 15.93 22 14.04 22 12c0-5.52-4.48-10-10-10-2.04 0-3.93.61-5.51 1.66l5.25 5.25L18 6zM2.81 5.64l.85.85c-1.37 2.07-2 4.68-1.48 7.45.75 3.95 3.92 7.13 7.88 7.88 2.77.52 5.38-.1 7.45-1.48l.85.85c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L4.22 4.22a.9959.9959 0 00-1.41 0c-.39.39-.39 1.03 0 1.42zm6.1 6.1l3.35 3.35L6 18l2.91-6.26z"
	}), 'ExploreOffRounded');
	
	exports.default = _default;

/***/ },
/* 2724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 6l-2.91 6.26 5.25 5.25C21.39 15.93 22 14.04 22 12c0-5.52-4.48-10-10-10-2.04 0-3.93.61-5.51 1.66l5.25 5.25L18 6zM2.1 4.93l1.56 1.56C2.61 8.07 2 9.96 2 12c0 5.52 4.48 10 10 10 2.04 0 3.93-.61 5.51-1.66l1.56 1.56 1.41-1.41L3.51 3.51 2.1 4.93zm6.81 6.81l3.35 3.35L6 18l2.91-6.26z"
	}), 'ExploreOffSharp');
	
	exports.default = _default;

/***/ },
/* 2725 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 20c1.48 0 2.86-.41 4.06-1.12l-3.98-3.98-5.58 2.6 2.59-5.58-3.97-3.98C4.41 9.14 4 10.52 4 12c0 4.41 3.59 8 8 8zm0-16c-1.48 0-2.86.41-4.06 1.12l3.98 3.98 5.58-2.6-2.59 5.58 3.98 3.98c.7-1.2 1.11-2.58 1.11-4.06 0-4.41-3.59-8-8-8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17.5 6.5l-5.58 2.59 2.99 2.99zM2.1 4.93l1.56 1.56C2.61 8.07 2 9.96 2 12c0 5.52 4.48 10 10 10 2.04 0 3.93-.61 5.51-1.66l1.56 1.56 1.41-1.41L3.51 3.51 2.1 4.93zm3.02 3.01l3.98 3.98-2.6 5.58 5.58-2.59 3.98 3.98c-1.2.7-2.58 1.11-4.06 1.11-4.41 0-8-3.59-8-8 0-1.48.41-2.86 1.12-4.06zM12 4c4.41 0 8 3.59 8 8 0 1.48-.41 2.86-1.12 4.06l1.46 1.46C21.39 15.93 22 14.04 22 12c0-5.52-4.48-10-10-10-2.04 0-3.93.61-5.51 1.66l1.46 1.46C9.14 4.41 10.52 4 12 4z"
	})), 'ExploreOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 2726 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5.5-2.5l7.51-3.49L17.5 6.5 9.99 9.99 6.5 17.5zm5.5-6.6c.61 0 1.1.49 1.1 1.1s-.49 1.1-1.1 1.1-1.1-.49-1.1-1.1.49-1.1 1.1-1.1z"
	}), 'ExploreOutlined');
	
	exports.default = _default;

/***/ },
/* 2727 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z"
	}), 'ExploreRounded');
	
	exports.default = _default;

/***/ },
/* 2728 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z"
	}), 'ExploreSharp');
	
	exports.default = _default;

/***/ },
/* 2729 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm2.01 10.01L6.5 17.5l3.49-7.51L17.5 6.5l-3.49 7.51z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5.5-2.5l7.51-3.49L17.5 6.5 9.99 9.99 6.5 17.5zm5.5-6.6c.61 0 1.1.49 1.1 1.1s-.49 1.1-1.1 1.1-1.1-.49-1.1-1.1.49-1.1 1.1-1.1z"
	})), 'ExploreTwoTone');
	
	exports.default = _default;

/***/ },
/* 2730 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM6 7h5v1.5H6V7zm13 12H5L19 5v14zm-4.5-3v2H16v-2h2v-1.5h-2v-2h-1.5v2h-2V16z"
	}), 'Exposure');
	
	exports.default = _default;

/***/ },
/* 2731 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z"
	}), 'ExposureNeg1');
	
	exports.default = _default;

/***/ },
/* 2732 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z"
	}), 'ExposureNeg1Outlined');
	
	exports.default = _default;

/***/ },
/* 2733 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1zm15 6h-2V7.38L14 8.4V6.7L18.7 5h.3v13z"
	}), 'ExposureNeg1Rounded');
	
	exports.default = _default;

/***/ },
/* 2734 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z"
	}), 'ExposureNeg1Sharp');
	
	exports.default = _default;

/***/ },
/* 2735 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 18V5h-.3L14 6.7v1.7l3-1.02V18zM4 11h8v2H4z"
	}), 'ExposureNeg1TwoTone');
	
	exports.default = _default;

/***/ },
/* 2736 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17s.19-.79.19-1.18c0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95zM2 11v2h8v-2H2z"
	}), 'ExposureNeg2');
	
	exports.default = _default;

/***/ },
/* 2737 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17s.41-.78.54-1.17.19-.79.19-1.18c0-.53-.09-1.02-.27-1.46s-.44-.81-.78-1.11c-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49s.6-.18.96-.18c.31 0 .58.05.81.15s.43.25.59.43.28.4.37.65c.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95zM2 11v2h8v-2H2z"
	}), 'ExposureNeg2Outlined');
	
	exports.default = _default;

/***/ },
/* 2738 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17s.41-.78.54-1.17.19-.79.19-1.18c0-.53-.09-1.02-.27-1.46s-.44-.81-.78-1.11c-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49s.6-.18.96-.18c.31 0 .58.05.81.15s.43.25.59.43.28.4.37.65c.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95zM2 12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1z"
	}), 'ExposureNeg2Rounded');
	
	exports.default = _default;

/***/ },
/* 2739 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17s.41-.78.54-1.17.19-.79.19-1.18c0-.53-.09-1.02-.27-1.46s-.44-.81-.78-1.11c-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49s.6-.18.96-.18c.31 0 .58.05.81.15s.43.25.59.43.28.4.37.65c.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95zM2 11v2h8v-2H2z"
	}), 'ExposureNeg2Sharp');
	
	exports.default = _default;

/***/ },
/* 2740 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.98 10.1c-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95l2.86-3.07c.38-.39.72-.79 1.04-1.18s.59-.78.82-1.17c.23-.39.41-.78.54-1.17.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46s-.44-.81-.78-1.11c-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15s.43.25.59.43c.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7zM2 11h8v2H2z"
	}), 'ExposureNeg2TwoTone');
	
	exports.default = _default;

/***/ },
/* 2741 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1.41 2L5 17.59V5h12.59zM6.41 19L19 6.41V19H6.41zM6 7h5v1.5H6zm10 5.5h-1.5v2h-2V16h2v2H16v-2h2v-1.5h-2z"
	}), 'ExposureOutlined');
	
	exports.default = _default;

/***/ },
/* 2742 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z"
	}), 'ExposurePlus1');
	
	exports.default = _default;

/***/ },
/* 2743 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z"
	}), 'ExposurePlus1Outlined');
	
	exports.default = _default;

/***/ },
/* 2744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 7c-.55 0-1 .45-1 1v3H5c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V8c0-.55-.45-1-1-1zm11 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z"
	}), 'ExposurePlus1Rounded');
	
	exports.default = _default;

/***/ },
/* 2745 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z"
	}), 'ExposurePlus1Sharp');
	
	exports.default = _default;

/***/ },
/* 2746 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18V5h-.3L15 6.7v1.7l3-1.02V18zm-10-1v-4h4v-2h-4V7H8v4H4v2h4v4z"
	}), 'ExposurePlus1TwoTone');
	
	exports.default = _default;

/***/ },
/* 2747 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95zM8 7H6v4H2v2h4v4h2v-4h4v-2H8V7z"
	}), 'ExposurePlus2');
	
	exports.default = _default;

/***/ },
/* 2748 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17s.41-.78.54-1.17c.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46s-.44-.81-.78-1.11c-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49s.6-.18.96-.18c.31 0 .58.05.81.15s.43.25.59.43.28.4.37.65c.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95zM8 7H6v4H2v2h4v4h2v-4h4v-2H8V7z"
	}), 'ExposurePlus2Outlined');
	
	exports.default = _default;

/***/ },
/* 2749 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17s.41-.78.54-1.17c.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46s-.44-.81-.78-1.11c-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49s.6-.18.96-.18c.31 0 .58.05.81.15s.43.25.59.43.28.4.37.65c.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95zM7 7c-.55 0-1 .45-1 1v3H3c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1H8V8c0-.55-.45-1-1-1z"
	}), 'ExposurePlus2Rounded');
	
	exports.default = _default;

/***/ },
/* 2750 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17s.41-.78.54-1.17c.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46s-.44-.81-.78-1.11c-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49s.6-.18.96-.18c.31 0 .58.05.81.15s.43.25.59.43.28.4.37.65c.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95zM8 7H6v4H2v2h4v4h2v-4h4v-2H8V7z"
	}), 'ExposurePlus2Sharp');
	
	exports.default = _default;

/***/ },
/* 2751 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 17v-4h4v-2H8V7H6v4H2v2h4v4zm11.95-4.96c.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46s-.44-.81-.78-1.11c-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15s.43.25.59.43c.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95l2.86-3.07c.38-.39.72-.79 1.04-1.18z"
	}), 'ExposurePlus2TwoTone');
	
	exports.default = _default;

/***/ },
/* 2752 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM6.75 7h3.5c.41 0 .75.34.75.75s-.34.75-.75.75h-3.5c-.41 0-.75-.34-.75-.75S6.34 7 6.75 7zM18 19H5L19 5v13c0 .55-.45 1-1 1zm-3.5-3v1.25c0 .41.34.75.75.75s.75-.34.75-.75V16h1.25c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H16v-1.25c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.25h-1.25c-.41 0-.75.34-.75.75s.34.75.75.75h1.25z"
	}), 'ExposureRounded');
	
	exports.default = _default;

/***/ },
/* 2753 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zM6 7h5v1.5H6V7zm13 12H5L19 5v14zm-4.5-3v2H16v-2h2v-1.5h-2v-2h-1.5v2h-2V16h2z"
	}), 'ExposureSharp');
	
	exports.default = _default;

/***/ },
/* 2754 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 19V5L5 19h14zm-4.5-4.5v-2H16v2h2V16h-2v2h-1.5v-2h-2v-1.5h2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM6 7h5v1.5H6V7zm13 12H5L19 5v14zm-4.5-3v2H16v-2h2v-1.5h-2v-2h-1.5v2h-2V16z"
	})), 'ExposureTwoTone');
	
	exports.default = _default;

/***/ },
/* 2755 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.14 12.5c0 1-.1 1.85-.3 2.55-.2.7-.48 1.27-.83 1.7-.36.44-.79.75-1.3.95-.51.2-1.07.3-1.7.3-.62 0-1.18-.1-1.69-.3-.51-.2-.95-.51-1.31-.95-.36-.44-.65-1.01-.85-1.7-.2-.7-.3-1.55-.3-2.55v-2.04c0-1 .1-1.85.3-2.55.2-.7.48-1.26.84-1.69.36-.43.8-.74 1.31-.93C10.81 5.1 11.38 5 12 5c.63 0 1.19.1 1.7.29.51.19.95.5 1.31.93.36.43.64.99.84 1.69.2.7.3 1.54.3 2.55v2.04zm-2.11-2.36c0-.64-.05-1.18-.13-1.62-.09-.44-.22-.79-.4-1.06-.17-.27-.39-.46-.64-.58-.25-.13-.54-.19-.86-.19-.32 0-.61.06-.86.18s-.47.31-.64.58c-.17.27-.31.62-.4 1.06s-.13.98-.13 1.62v2.67c0 .64.05 1.18.14 1.62.09.45.23.81.4 1.09s.39.48.64.61.54.19.87.19c.33 0 .62-.06.87-.19s.46-.33.63-.61c.17-.28.3-.64.39-1.09.09-.45.13-.99.13-1.62v-2.66z"
	}), 'ExposureZero');
	
	exports.default = _default;

/***/ },
/* 2756 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.14 12.5c0 1-.1 1.85-.3 2.55s-.48 1.27-.83 1.7c-.36.44-.79.75-1.3.95s-1.07.3-1.7.3c-.62 0-1.18-.1-1.69-.3-.51-.2-.95-.51-1.31-.95s-.65-1.01-.85-1.7c-.2-.7-.3-1.55-.3-2.55v-2.04c0-1 .1-1.85.3-2.55.2-.7.48-1.26.84-1.69.36-.43.8-.74 1.31-.93C10.81 5.1 11.38 5 12 5c.63 0 1.19.1 1.7.29.51.19.95.5 1.31.93.36.43.64.99.84 1.69.2.7.3 1.54.3 2.55v2.04h-.01zm-2.11-2.36c0-.64-.05-1.18-.13-1.62-.09-.44-.22-.79-.4-1.06-.17-.27-.39-.46-.64-.58-.25-.13-.54-.19-.86-.19s-.61.06-.86.18-.47.31-.64.58-.31.62-.4 1.06-.13.98-.13 1.62v2.67c0 .64.05 1.18.14 1.62.09.45.23.81.4 1.09s.39.48.64.61.54.19.87.19.62-.06.87-.19.46-.33.63-.61.3-.64.39-1.09.13-.99.13-1.62v-2.66h-.01z"
	}), 'ExposureZeroOutlined');
	
	exports.default = _default;

/***/ },
/* 2757 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.14 12.5c0 1-.1 1.85-.3 2.55s-.48 1.27-.83 1.7c-.36.44-.79.75-1.3.95s-1.07.3-1.7.3c-.62 0-1.18-.1-1.69-.3-.51-.2-.95-.51-1.31-.95s-.65-1.01-.85-1.7c-.2-.7-.3-1.55-.3-2.55v-2.04c0-1 .1-1.85.3-2.55.2-.7.48-1.26.84-1.69.36-.43.8-.74 1.31-.93C10.81 5.1 11.38 5 12 5c.63 0 1.19.1 1.7.29.51.19.95.5 1.31.93.36.43.64.99.84 1.69.2.7.3 1.54.3 2.55v2.04h-.01zm-2.11-2.36c0-.64-.05-1.18-.13-1.62-.09-.44-.22-.79-.4-1.06-.17-.27-.39-.46-.64-.58-.25-.13-.54-.19-.86-.19s-.61.06-.86.18-.47.31-.64.58-.31.62-.4 1.06-.13.98-.13 1.62v2.67c0 .64.05 1.18.14 1.62.09.45.23.81.4 1.09s.39.48.64.61.54.19.87.19.62-.06.87-.19.46-.33.63-.61.3-.64.39-1.09.13-.99.13-1.62v-2.66h-.01z"
	}), 'ExposureZeroRounded');
	
	exports.default = _default;

/***/ },
/* 2758 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.14 12.5c0 1-.1 1.85-.3 2.55s-.48 1.27-.83 1.7c-.36.44-.79.75-1.3.95s-1.07.3-1.7.3c-.62 0-1.18-.1-1.69-.3-.51-.2-.95-.51-1.31-.95s-.65-1.01-.85-1.7c-.2-.7-.3-1.55-.3-2.55v-2.04c0-1 .1-1.85.3-2.55.2-.7.48-1.26.84-1.69.36-.43.8-.74 1.31-.93C10.81 5.1 11.38 5 12 5c.63 0 1.19.1 1.7.29.51.19.95.5 1.31.93.36.43.64.99.84 1.69.2.7.3 1.54.3 2.55v2.04h-.01zm-2.11-2.36c0-.64-.05-1.18-.13-1.62-.09-.44-.22-.79-.4-1.06-.17-.27-.39-.46-.64-.58-.25-.13-.54-.19-.86-.19s-.61.06-.86.18-.47.31-.64.58-.31.62-.4 1.06-.13.98-.13 1.62v2.67c0 .64.05 1.18.14 1.62.09.45.23.81.4 1.09s.39.48.64.61.54.19.87.19.62-.06.87-.19.46-.33.63-.61.3-.64.39-1.09.13-.99.13-1.62v-2.66h-.01z"
	}), 'ExposureZeroSharp');
	
	exports.default = _default;

/***/ },
/* 2759 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.01 6.22c-.36-.43-.8-.74-1.31-.93S12.63 5 12 5c-.62 0-1.19.1-1.69.29-.51.19-.95.5-1.31.93s-.64.99-.84 1.69c-.2.7-.3 1.55-.3 2.55v2.04c0 1 .1 1.85.3 2.55.2.69.49 1.26.85 1.7s.8.75 1.31.95c.51.2 1.07.3 1.69.3.63 0 1.19-.1 1.7-.3.51-.2.94-.51 1.3-.95.35-.43.63-1 .83-1.7.2-.7.3-1.55.3-2.55h.01v-2.04c0-1.01-.1-1.85-.3-2.55-.2-.7-.48-1.26-.84-1.69zm-.97 6.58c0 .63-.04 1.17-.13 1.62-.09.45-.22.81-.39 1.09s-.38.48-.63.61-.54.19-.87.19c-.33 0-.62-.06-.87-.19s-.47-.33-.64-.61c-.17-.28-.31-.64-.4-1.09-.09-.44-.14-.98-.14-1.62v-2.67c0-.64.04-1.18.13-1.62.09-.44.23-.79.4-1.06s.39-.46.64-.58.54-.18.86-.18.61.06.86.19c.25.12.47.31.64.58.18.27.31.62.4 1.06.08.44.13.98.13 1.62h.01v2.66z"
	}), 'ExposureZeroTwoTone');
	
	exports.default = _default;

/***/ },
/* 2760 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z"
	}), 'Extension');
	
	exports.default = _default;

/***/ },
/* 2761 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.5 4.5c.28 0 .5.22.5.5v2h6v6h2c.28 0 .5.22.5.5s-.22.5-.5.5h-2v6h-2.12c-.68-1.75-2.39-3-4.38-3s-3.7 1.25-4.38 3H4v-2.12c1.75-.68 3-2.39 3-4.38 0-1.99-1.24-3.7-2.99-4.38L4 7h6V5c0-.28.22-.5.5-.5m0-2C9.12 2.5 8 3.62 8 5H4c-1.1 0-1.99.9-1.99 2v3.8h.29c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-.3c0-1.49 1.21-2.7 2.7-2.7s2.7 1.21 2.7 2.7v.3H17c1.1 0 2-.9 2-2v-4c1.38 0 2.5-1.12 2.5-2.5S20.38 11 19 11V7c0-1.1-.9-2-2-2h-4c0-1.38-1.12-2.5-2.5-2.5z"
	}), 'ExtensionOutlined');
	
	exports.default = _default;

/***/ },
/* 2762 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7s2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z"
	}), 'ExtensionRounded');
	
	exports.default = _default;

/***/ },
/* 2763 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.36 11H19V5h-6V3.64c0-1.31-.94-2.5-2.24-2.63C9.26.86 8 2.03 8 3.5V5H2.01v5.8H3.4c1.31 0 2.5.88 2.75 2.16.33 1.72-.98 3.24-2.65 3.24H2V22h5.8v-1.4c0-1.31.88-2.5 2.16-2.75 1.72-.33 3.24.98 3.24 2.65V22H19v-6h1.5c1.47 0 2.64-1.26 2.49-2.76-.13-1.3-1.33-2.24-2.63-2.24z"
	}), 'ExtensionSharp');
	
	exports.default = _default;

/***/ },
/* 2764 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 13h-2V7h-6V5c0-.28-.22-.5-.5-.5s-.5.22-.5.5v2H4l.01 2.12C5.76 9.8 7 11.51 7 13.5c0 1.99-1.25 3.7-3 4.38V20h2.12c.68-1.75 2.39-3 4.38-3 1.99 0 3.7 1.25 4.38 3H17v-6h2c.28 0 .5-.22.5-.5s-.22-.5-.5-.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 11V7c0-1.1-.9-2-2-2h-4c0-1.38-1.12-2.5-2.5-2.5S8 3.62 8 5H4c-1.1 0-1.99.9-1.99 2v3.8h.29c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-.3c0-1.49 1.21-2.7 2.7-2.7s2.7 1.21 2.7 2.7v.3H17c1.1 0 2-.9 2-2v-4c1.38 0 2.5-1.12 2.5-2.5S20.38 11 19 11zm0 3h-2v6h-2.12c-.68-1.75-2.39-3-4.38-3-1.99 0-3.7 1.25-4.38 3H4v-2.12c1.75-.68 3-2.39 3-4.38 0-1.99-1.24-3.7-2.99-4.38L4 7h6V5c0-.28.22-.5.5-.5s.5.22.5.5v2h6v6h2c.28 0 .5.22.5.5s-.22.5-.5.5z"
	})), 'ExtensionTwoTone');
	
	exports.default = _default;

/***/ },
/* 2765 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z"
	}), 'Face');
	
	exports.default = _default;

/***/ },
/* 2766 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.25 13c0 .69-.56 1.25-1.25 1.25S7.75 13.69 7.75 13s.56-1.25 1.25-1.25 1.25.56 1.25 1.25zM15 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm7 .25c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2s10 4.48 10 10zM10.66 4.12C12.06 6.44 14.6 8 17.5 8c.46 0 .91-.05 1.34-.12C17.44 5.56 14.9 4 12 4c-.46 0-.91.05-1.34.12zM4.42 9.47c1.71-.97 3.03-2.55 3.66-4.44C6.37 6 5.05 7.58 4.42 9.47zM20 12c0-.78-.12-1.53-.33-2.24-.7.15-1.42.24-2.17.24-3.13 0-5.92-1.44-7.76-3.69C8.69 8.87 6.6 10.88 4 11.86c.01.04 0 .09 0 .14 0 4.41 3.59 8 8 8s8-3.59 8-8z"
	}), 'FaceOutlined');
	
	exports.default = _default;

/***/ },
/* 2767 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z"
	}), 'FaceRounded');
	
	exports.default = _default;

/***/ },
/* 2768 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z"
	}), 'FaceSharp');
	
	exports.default = _default;

/***/ },
/* 2769 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17.5 8c.46 0 .91-.05 1.34-.12C17.44 5.56 14.9 4 12 4c-.46 0-.91.05-1.34.12C12.06 6.44 14.6 8 17.5 8zM8.08 5.03C6.37 6 5.05 7.58 4.42 9.47c1.71-.97 3.03-2.55 3.66-4.44z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 2c2.9 0 5.44 1.56 6.84 3.88-.43.07-.88.12-1.34.12-2.9 0-5.44-1.56-6.84-3.88.43-.07.88-.12 1.34-.12zM8.08 5.03C7.45 6.92 6.13 8.5 4.42 9.47 5.05 7.58 6.37 6 8.08 5.03zM12 20c-4.41 0-8-3.59-8-8 0-.05.01-.1.01-.15 2.6-.98 4.68-2.99 5.74-5.55 1.83 2.26 4.62 3.7 7.75 3.7.75 0 1.47-.09 2.17-.24.21.71.33 1.46.33 2.24 0 4.41-3.59 8-8 8z"
	}), _react.default.createElement("circle", {
	  cx: "9",
	  cy: "13",
	  r: "1.25"
	}), _react.default.createElement("circle", {
	  cx: "15",
	  cy: "13",
	  r: "1.25"
	})), 'FaceTwoTone');
	
	exports.default = _default;

/***/ },
/* 2770 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z"
	}), 'Facebook');
	
	exports.default = _default;

/***/ },
/* 2771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"
	}), 'FastForward');
	
	exports.default = _default;

/***/ },
/* 2772 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 9.86L18.03 12 15 14.14V9.86m-9 0L9.03 12 6 14.14V9.86M13 6v12l8.5-6L13 6zM4 6v12l8.5-6L4 6z"
	}), 'FastForwardOutlined');
	
	exports.default = _default;

/***/ },
/* 2773 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.58 16.89l5.77-4.07c.56-.4.56-1.24 0-1.63L5.58 7.11C4.91 6.65 4 7.12 4 7.93v8.14c0 .81.91 1.28 1.58.82zM13 7.93v8.14c0 .81.91 1.28 1.58.82l5.77-4.07c.56-.4.56-1.24 0-1.63l-5.77-4.07c-.67-.47-1.58 0-1.58.81z"
	}), 'FastForwardRounded');
	
	exports.default = _default;

/***/ },
/* 2774 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"
	}), 'FastForwardSharp');
	
	exports.default = _default;

/***/ },
/* 2775 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15 9.86v4.28L18.03 12zM6 9.86v4.28L9.03 12z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 18l8.5-6L4 6v12zm2-8.14L9.03 12 6 14.14V9.86zM21.5 12L13 6v12l8.5-6zM15 9.86L18.03 12 15 14.14V9.86z"
	})), 'FastForwardTwoTone');
	
	exports.default = _default;

/***/ },
/* 2776 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z"
	}), 'FastRewind');
	
	exports.default = _default;

/***/ },
/* 2777 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 9.86v4.28L14.97 12 18 9.86m-9 0v4.28L5.97 12 9 9.86M20 6l-8.5 6 8.5 6V6zm-9 0l-8.5 6 8.5 6V6z"
	}), 'FastRewindOutlined');
	
	exports.default = _default;

/***/ },
/* 2778 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 16.07V7.93c0-.81-.91-1.28-1.58-.82l-5.77 4.07c-.56.4-.56 1.24 0 1.63l5.77 4.07c.67.47 1.58 0 1.58-.81zm1.66-3.25l5.77 4.07c.66.47 1.58-.01 1.58-.82V7.93c0-.81-.91-1.28-1.58-.82l-5.77 4.07c-.57.4-.57 1.24 0 1.64z"
	}), 'FastRewindRounded');
	
	exports.default = _default;

/***/ },
/* 2779 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z"
	}), 'FastRewindSharp');
	
	exports.default = _default;

/***/ },
/* 2780 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9 14.14V9.86L5.97 12zm9 0V9.86L14.97 12z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11 6l-8.5 6 8.5 6V6zm-2 8.14L5.97 12 9 9.86v4.28zM20 6l-8.5 6 8.5 6V6zm-2 8.14L14.97 12 18 9.86v4.28z"
	})), 'FastRewindTwoTone');
	
	exports.default = _default;

/***/ },
/* 2781 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.06 22.99h1.66c.84 0 1.53-.64 1.63-1.46L23 5.05h-5V1h-1.97v4.05h-4.97l.3 2.34c1.71.47 3.31 1.32 4.27 2.26 1.44 1.42 2.43 2.89 2.43 5.29v8.05zM1 21.99V21h15.03v.99c0 .55-.45 1-1.01 1H2.01c-.56 0-1.01-.45-1.01-1zm15.03-7c0-8-15.03-8-15.03 0h15.03zM1.02 17h15v2h-15z"
	}), 'Fastfood');
	
	exports.default = _default;

/***/ },
/* 2782 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 21.98c0 .56.45 1.01 1.01 1.01H15c.56 0 1.01-.45 1.01-1.01V21H1v.98zM8.5 8.99C4.75 8.99 1 11 1 15h15c0-4-3.75-6.01-7.5-6.01zM3.62 13c1.11-1.55 3.47-2.01 4.88-2.01s3.77.46 4.88 2.01H3.62zM1 17h15v2H1zM18 5V1h-2v4h-5l.23 2h9.56l-1.4 14H18v2h1.72c.84 0 1.53-.65 1.63-1.47L23 5h-5z"
	}), 'FastfoodOutlined');
	
	exports.default = _default;

/***/ },
/* 2783 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.9 5H18V2c0-.55-.45-1-1-1s-1 .45-1 1v3h-3.9c-.59 0-1.05.51-1 1.1l.12 1.21C14.9 8.16 18 10.77 18 15l.02 8h1.7c.84 0 1.53-.65 1.63-1.47L22.89 6.1c.06-.59-.4-1.1-.99-1.1zM15 21H2c-.55 0-1 .45-1 1s.45 1 1 1h13c.55 0 1-.45 1-1s-.45-1-1-1zM2.1 15h12.8c.62 0 1.11-.56.99-1.16-.65-3.23-4.02-4.85-7.39-4.85s-6.73 1.62-7.39 4.85c-.12.6.38 1.16.99 1.16zM15 17H2c-.55 0-1 .45-1 1s.45 1 1 1h13c.55 0 1-.45 1-1s-.45-1-1-1z"
	}), 'FastfoodRounded');
	
	exports.default = _default;

/***/ },
/* 2784 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 5V1h-2v4h-5l.23 2.31C14.9 8.16 18 10.77 18 15l.02 8h3.18L23 5h-5zM1 21h15v2H1zM8.5 8.99C4.75 8.99 1 11 1 15h15c0-4-3.75-6.01-7.5-6.01zM1 17h15v2H1z"
	}), 'FastfoodSharp');
	
	exports.default = _default;

/***/ },
/* 2785 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M1 21.98c0 .56.45 1.01 1.01 1.01H15c.56 0 1.01-.45 1.01-1.01V21H1v.98z"
	}), _react.default.createElement("path", {
	  d: "M8.5 10.99c-1.42 0-3.77.46-4.88 2.01h9.77c-1.12-1.55-3.47-2.01-4.89-2.01z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M8.5 8.99C4.75 8.99 1 11 1 15h15c0-4-3.75-6.01-7.5-6.01zM3.62 13c1.11-1.55 3.47-2.01 4.88-2.01s3.77.46 4.88 2.01H3.62zM1 17h15v2H1zM18 5V1h-2v4h-5l.23 2h9.56l-1.4 14H18v2h1.72c.84 0 1.53-.65 1.63-1.47L23 5h-5z"
	})), 'FastfoodTwoTone');
	
	exports.default = _default;

/***/ },
/* 2786 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
	}), 'Favorite');
	
	exports.default = _default;

/***/ },
/* 2787 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
	}), 'FavoriteBorder');
	
	exports.default = _default;

/***/ },
/* 2788 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
	}), 'FavoriteBorderOutlined');
	
	exports.default = _default;

/***/ },
/* 2789 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.66 3.99c-2.64-1.8-5.9-.96-7.66 1.1-1.76-2.06-5.02-2.91-7.66-1.1-1.4.96-2.28 2.58-2.34 4.29-.14 3.88 3.3 6.99 8.55 11.76l.1.09c.76.69 1.93.69 2.69-.01l.11-.1c5.25-4.76 8.68-7.87 8.55-11.75-.06-1.7-.94-3.32-2.34-4.28zM12.1 18.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
	}), 'FavoriteBorderRounded');
	
	exports.default = _default;

/***/ },
/* 2790 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
	}), 'FavoriteBorderSharp');
	
	exports.default = _default;

/***/ },
/* 2791 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
	}), 'FavoriteBorderTwoTone');
	
	exports.default = _default;

/***/ },
/* 2792 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
	}), 'FavoriteOutlined');
	
	exports.default = _default;

/***/ },
/* 2793 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.35 20.13c-.76.69-1.93.69-2.69-.01l-.11-.1C5.3 15.27 1.87 12.16 2 8.28c.06-1.7.93-3.33 2.34-4.29 2.64-1.8 5.9-.96 7.66 1.1 1.76-2.06 5.02-2.91 7.66-1.1 1.41.96 2.28 2.59 2.34 4.29.14 3.88-3.3 6.99-8.55 11.76l-.1.09z"
	}), 'FavoriteRounded');
	
	exports.default = _default;

/***/ },
/* 2794 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
	}), 'FavoriteSharp');
	
	exports.default = _default;

/***/ },
/* 2795 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16.5 5c-1.54 0-3.04.99-3.56 2.36h-1.87C10.54 5.99 9.04 5 7.5 5 5.5 5 4 6.5 4 8.5c0 2.89 3.14 5.74 7.9 10.05l.1.1.1-.1C16.86 14.24 20 11.39 20 8.5c0-2-1.5-3.5-3.5-3.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
	})), 'FavoriteTwoTone');
	
	exports.default = _default;

/***/ },
/* 2796 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 8H3V9h9v2zm0-4H3V5h9v2z"
	}), 'FeaturedPlayList');
	
	exports.default = _default;

/***/ },
/* 2797 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 10h9v2H5zm0-3h9v2H5z"
	}), 'FeaturedPlayListOutlined');
	
	exports.default = _default;

/***/ },
/* 2798 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-10 8H4c-.55 0-1-.45-1-1s.45-1 1-1h7c.55 0 1 .45 1 1s-.45 1-1 1zm0-4H4c-.55 0-1-.45-1-1s.45-1 1-1h7c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'FeaturedPlayListRounded');
	
	exports.default = _default;

/***/ },
/* 2799 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 3H1v18h22V3zm-11 8H3V9h9v2zm0-4H3V5h9v2z"
	}), 'FeaturedPlayListSharp');
	
	exports.default = _default;

/***/ },
/* 2800 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 19h18V5H3v14zM5 7h9v2H5V7zm0 3h9v2H5v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 10h9v2H5zm0-3h9v2H5z"
	})), 'FeaturedPlayListTwoTone');
	
	exports.default = _default;

/***/ },
/* 2801 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 9H3V5h9v7z"
	}), 'FeaturedVideo');
	
	exports.default = _default;

/***/ },
/* 2802 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM4 6h9v7H4z"
	}), 'FeaturedVideoOutlined');
	
	exports.default = _default;

/***/ },
/* 2803 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-10 9H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h7c.55 0 1 .45 1 1v5c0 .55-.45 1-1 1z"
	}), 'FeaturedVideoRounded');
	
	exports.default = _default;

/***/ },
/* 2804 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 3H1v18h22V3zm-11 9H3V5h9v7z"
	}), 'FeaturedVideoSharp');
	
	exports.default = _default;

/***/ },
/* 2805 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 19h18V5H3v14zM4 6h9v7H4V6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM4 6h9v7H4z"
	})), 'FeaturedVideoTwoTone');
	
	exports.default = _default;

/***/ },
/* 2806 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z"
	}), 'Feedback');
	
	exports.default = _default;

/***/ },
/* 2807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zm-9-4h2v2h-2zm0-6h2v4h-2z"
	}), 'FeedbackOutlined');
	
	exports.default = _default;

/***/ },
/* 2808 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4.01c-1.1 0-2 .9-2 2v18L6 18h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-5c0 .55-.45 1-1 1s-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v2z"
	}), 'FeedbackRounded');
	
	exports.default = _default;

/***/ },
/* 2809 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H2.01L2 22l4-4h16V2zm-9 12h-2v-2h2v2zm0-4h-2V6h2v4z"
	}), 'FeedbackSharp');
	
	exports.default = _default;

/***/ },
/* 2810 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 17.17L5.17 16H20V4H4v13.17zM11 6h2v4h-2V6zm0 6h2v2h-2v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-9-4h2v2h-2zm0-6h2v4h-2z"
	})), 'FeedbackTwoTone');
	
	exports.default = _default;

/***/ },
/* 2811 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.5 10.5h2v1h-2v-1zm-13 0h2v3h-2v-3zM21 3H3c-1.11 0-2 .89-2 2v14c0 1.1.89 2 2 2h18c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zM8 13.5c0 .85-.65 1.5-1.5 1.5H3V9h3.5c.85 0 1.5.65 1.5 1.5v3zm4.62 1.5h-1.5L9.37 9h1.5l1 3.43 1-3.43h1.5l-1.75 6zM21 11.5c0 .6-.4 1.15-.9 1.4L21 15h-1.5l-.85-2H17.5v2H16V9h3.5c.85 0 1.5.65 1.5 1.5v1z"
	}), 'FiberDvr');
	
	exports.default = _default;

/***/ },
/* 2812 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.87 12.43l-1-3.43h-1.5l1.75 6h1.5l1.75-6h-1.5zM21 11.5v-1c0-.85-.65-1.5-1.5-1.5H16v6h1.5v-2h1.15l.85 2H21l-.9-2.1c.5-.25.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zM6.5 9H3v6h3.5c.85 0 1.5-.65 1.5-1.5v-3C8 9.65 7.35 9 6.5 9zm0 4.5h-2v-3h2v3z"
	}), 'FiberDvrOutlined');
	
	exports.default = _default;

/***/ },
/* 2813 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.5 10.5h2v3h-2zm13 0h2v1h-2zM21 3H3c-1.11 0-2 .89-2 2v14c0 1.1.89 2 2 2h18c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zM8 13.5c0 .83-.67 1.5-1.5 1.5h-3c-.28 0-.5-.22-.5-.5v-5c0-.28.22-.5.5-.5h3c.83 0 1.5.67 1.5 1.5v3zm6.1-3.58l-1.27 4.36c-.12.43-.52.72-.96.72s-.84-.29-.96-.72L9.64 9.92c-.14-.46.21-.92.69-.92.32 0 .6.21.69.52l.85 2.91.85-2.91c.09-.31.37-.52.69-.52.48 0 .83.46.69.92zM21 11.5c0 .6-.4 1.15-.9 1.4l.63 1.48c.19.45-.14.96-.63.96-.28 0-.53-.16-.63-.42L18.65 13H17.5v1.31c0 .38-.31.69-.69.69h-.12c-.38 0-.69-.31-.69-.69V9.64c0-.35.29-.64.64-.64h2.86c.83 0 1.5.67 1.5 1.5v1z"
	}), 'FiberDvrRounded');
	
	exports.default = _default;

/***/ },
/* 2814 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.5 10.5h2v1h-2v-1zm-13 0h2v3h-2v-3zM23 3H1v18h22V3zM8 13.5c0 .85-.65 1.5-1.5 1.5H3V9h3.5c.85 0 1.5.65 1.5 1.5v3zm4.62 1.5h-1.5L9.37 9h1.5l1 3.43 1-3.43h1.5l-1.75 6zM21 12.9h-.9L21 15h-1.5l-.85-2H17.5v2H16V9h5v3.9z"
	}), 'FiberDvrSharp');
	
	exports.default = _default;

/***/ },
/* 2815 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 11.56v-.89c0-.76-.58-1.33-1.33-1.33h-3.11v5.33h1.33v-1.78h1.02l.76 1.78H20l-.8-1.87c.44-.22.8-.71.8-1.24zm-1.33 0h-1.78v-.89h1.78v.89zM7.11 9.33H4v5.33h3.11c.76 0 1.33-.58 1.33-1.33v-2.67c0-.75-.57-1.33-1.33-1.33zm0 4H5.33v-2.67h1.78v2.67zm7-4h-1.34l-.89 3.05L11 9.33H9.66l1.56 5.34h1.33z"
	}), _react.default.createElement("path", {
	  d: "M3 5h18v14H3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 3H3c-1.11 0-2 .89-2 2v14c0 1.1.89 2 2 2h18c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zm0 16H3V5h18v14z"
	})), 'FiberDvrTwoTone');
	
	exports.default = _default;

/***/ },
/* 2816 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "8"
	}), 'FiberManualRecord');
	
	exports.default = _default;

/***/ },
/* 2817 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6m0-2c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8z"
	}), 'FiberManualRecordOutlined');
	
	exports.default = _default;

/***/ },
/* 2818 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "8"
	}), 'FiberManualRecordRounded');
	
	exports.default = _default;

/***/ },
/* 2819 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "8"
	}), 'FiberManualRecordSharp');
	
	exports.default = _default;

/***/ },
/* 2820 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 18c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 20c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8zm0-14c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6z"
	})), 'FiberManualRecordTwoTone');
	
	exports.default = _default;

/***/ },
/* 2821 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM8.5 15H7.3l-2.55-3.5V15H3.5V9h1.25l2.5 3.5V9H8.5v6zm5-4.74H11v1.12h2.5v1.26H11v1.11h2.5V15h-4V9h4v1.26zm7 3.74c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1V9h1.25v4.51h1.13V9.99h1.25v3.51h1.12V9h1.25v5z"
	}), 'FiberNew');
	
	exports.default = _default;

/***/ },
/* 2822 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.25 12.5L4.75 9H3.5v6h1.25v-3.5L7.3 15h1.2V9H7.25zM9.5 15h4v-1.25H11v-1.11h2.5v-1.26H11v-1.12h2.5V9h-4zm9.75-6v4.5h-1.12V9.99h-1.25v3.52h-1.13V9H14.5v5c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V9h-1.25z"
	}), 'FiberNewOutlined');
	
	exports.default = _default;

/***/ },
/* 2823 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM8.5 14.21c0 .43-.36.79-.79.79-.25 0-.49-.12-.64-.33L4.75 11.5v2.88c0 .35-.28.62-.62.62s-.63-.28-.63-.62V9.79c0-.43.36-.79.79-.79h.05c.26 0 .5.12.65.33l2.26 3.17V9.62c0-.34.28-.62.63-.62s.62.28.62.62v4.59zm5-4.57c0 .35-.28.62-.62.62H11v1.12h1.88c.35 0 .62.28.62.62v.01c0 .35-.28.62-.62.62H11v1.11h1.88c.35 0 .62.28.62.62 0 .35-.28.62-.62.62h-2.53c-.47 0-.85-.38-.85-.85v-4.3c0-.45.38-.83.85-.83h2.53c.35 0 .62.28.62.62v.02zm7 4.36c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1V9.62c0-.34.28-.62.62-.62s.62.28.62.62v3.89h1.13v-2.9c0-.35.28-.62.62-.62s.62.28.62.62v2.89h1.12V9.62c0-.35.28-.62.62-.62s.62.28.62.62V14z"
	}), 'FiberNewRounded');
	
	exports.default = _default;

/***/ },
/* 2824 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 4H2v16h20V4zM8.5 15H7.3l-2.55-3.5V15H3.5V9h1.25l2.5 3.5V9H8.5v6zm5-4.74H11v1.12h2.5v1.26H11v1.11h2.5V15h-4V9h4v1.26zm7 4.74h-6V9h1.25v4.51h1.13V9.99h1.25v3.51h1.12V9h1.25v6z"
	}), 'FiberNewSharp');
	
	exports.default = _default;

/***/ },
/* 2825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9.12 14.47V9.53H8.09v2.88L6.03 9.53H5v4.94h1.03v-2.88l2.1 2.88zm4.12-3.9V9.53h-3.3v4.94h3.3v-1.03h-2.06v-.91h2.06v-1.04h-2.06v-.92zm.82-1.04v4.12c0 .45.37.82.82.82h3.29c.45 0 .82-.37.82-.82V9.53h-1.03v3.71h-.92v-2.89h-1.03v2.9h-.93V9.53h-1.02z"
	}), _react.default.createElement("path", {
	  d: "M4 6h16v12H4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z"
	})), 'FiberNewTwoTone');
	
	exports.default = _default;

/***/ },
/* 2826 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.5 10.5h2v1h-2zM20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM9 11.5c0 .85-.65 1.5-1.5 1.5h-2v2H4V9h3.5c.85 0 1.5.65 1.5 1.5v1zm3.5 3.5H11V9h1.5v6zm7.5 0h-1.2l-2.55-3.5V15H15V9h1.25l2.5 3.5V9H20v6z"
	}), 'FiberPin');
	
	exports.default = _default;

/***/ },
/* 2827 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 15h1.5V9H11v6zm7.75-6v3.5L16.25 9H15v6h1.25v-3.5L18.8 15H20V9h-1.25zM7.5 9H4v6h1.5v-2h2c.85 0 1.5-.65 1.5-1.5v-1C9 9.65 8.35 9 7.5 9zm0 2.5h-2v-1h2v1z"
	}), 'FiberPinOutlined');
	
	exports.default = _default;

/***/ },
/* 2828 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM9 11.5c0 .83-.67 1.5-1.5 1.5h-2v1.25c0 .41-.34.75-.75.75S4 14.66 4 14.25V10c0-.55.45-1 1-1h2.5c.83 0 1.5.67 1.5 1.5v1zm3.5 2.75c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-4.5c0-.41.34-.75.75-.75s.75.34.75.75v4.5zm7.5-.04c0 .44-.35.79-.79.79-.25 0-.49-.12-.64-.33l-2.31-3.17v2.88c0 .34-.28.62-.62.62h-.01c-.35 0-.63-.28-.63-.62V9.83c0-.46.37-.83.83-.83.27 0 .52.13.67.35l2.25 3.15V9.62c0-.34.28-.62.62-.62h.01c.34 0 .62.28.62.62v4.59zM5.5 10.5h2v1h-2z"
	}), 'FiberPinRounded');
	
	exports.default = _default;

/***/ },
/* 2829 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.5 10.5h2v1h-2v-1zM22 4H2v16h20V4zM9 13H5.5v2H4V9h5v4zm3.5 2H11V9h1.5v6zm7.5 0h-1.2l-2.55-3.5V15H15V9h1.25l2.5 3.5V9H20v6z"
	}), 'FiberPinSharp');
	
	exports.default = _default;

/***/ },
/* 2830 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 14.62h1.31v-1.75h1.75c.74 0 1.31-.57 1.31-1.31v-.88c0-.74-.57-1.31-1.31-1.31H5v5.25zm1.31-3.93h1.75v.88H6.31v-.88zm5.03-1.31h1.31v5.25h-1.31zm3.28 5.24h1.1v-3.06l2.23 3.06H19V9.38h-1.09v3.06l-2.19-3.06h-1.1z"
	}), _react.default.createElement("path", {
	  d: "M4 6h16v12H4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z"
	})), 'FiberPinTwoTone');
	
	exports.default = _default;

/***/ },
/* 2831 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "9",
	  cy: "12",
	  r: "8"
	}), _react.default.createElement("path", {
	  d: "M17 4.26v2.09c2.33.82 4 3.04 4 5.65s-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74s-2.55-6.85-6-7.74z"
	})), 'FiberSmartRecord');
	
	exports.default = _default;

/***/ },
/* 2832 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm8-13.74v2.09c2.33.82 4 3.04 4 5.65s-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-3.73-2.55-6.85-6-7.74z"
	}), 'FiberSmartRecordOutlined');
	
	exports.default = _default;

/***/ },
/* 2833 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "9",
	  cy: "12",
	  r: "8"
	}), _react.default.createElement("path", {
	  d: "M17 5.55v.18c0 .37.23.69.57.85C19.6 7.54 21 9.61 21 12s-1.4 4.46-3.43 5.42c-.34.16-.57.47-.57.84v.18c0 .68.71 1.11 1.32.82C21.08 18.01 23 15.23 23 12s-1.92-6.01-4.68-7.27c-.61-.28-1.32.14-1.32.82z"
	})), 'FiberSmartRecordRounded');
	
	exports.default = _default;

/***/ },
/* 2834 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "9",
	  cy: "12",
	  r: "8"
	}), _react.default.createElement("path", {
	  d: "M17 4.26v2.09c2.33.82 4 3.04 4 5.65s-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74s-2.55-6.85-6-7.74z"
	})), 'FiberSmartRecordSharp');
	
	exports.default = _default;

/***/ },
/* 2835 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9 18c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9 20c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8zM9 6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6zm8-1.74v2.09c2.33.82 4 3.04 4 5.65s-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-3.73-2.55-6.85-6-7.74z"
	})), 'FiberSmartRecordTwoTone');
	
	exports.default = _default;

/***/ },
/* 2836 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4l6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2h7zm-1 7h5.5L14 6.5V12z"
	}), 'FileCopy');
	
	exports.default = _default;

/***/ },
/* 2837 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4H8c-1.1 0-1.99.9-1.99 2L6 21c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V11l-6-6zM8 21V7h6v5h5v9H8z"
	}), 'FileCopyOutlined');
	
	exports.default = _default;

/***/ },
/* 2838 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 1H4c-1.1 0-2 .9-2 2v13c0 .55.45 1 1 1s1-.45 1-1V4c0-.55.45-1 1-1h10c.55 0 1-.45 1-1s-.45-1-1-1zm.59 4.59l4.83 4.83c.37.37.58.88.58 1.41V21c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2h6.17c.53 0 1.04.21 1.42.59zM15 12h4.5L14 6.5V11c0 .55.45 1 1 1z"
	}), 'FileCopyRounded');
	
	exports.default = _default;

/***/ },
/* 2839 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 1H2v16h2V3h12V1zm-1 4l6 6v12H6V5h9zm-1 7h5.5L14 6.5V12z"
	}), 'FileCopySharp');
	
	exports.default = _default;

/***/ },
/* 2840 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14 7H8v14h11v-9h-5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4H8c-1.1 0-1.99.9-1.99 2L6 21c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V11l-6-6zm4 16H8V7h6v5h5v9z"
	})), 'FileCopyTwoTone');
	
	exports.default = _default;

/***/ },
/* 2841 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.96 10.29l-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
	}), 'Filter');
	
	exports.default = _default;

/***/ },
/* 2842 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 10h2V5h-4v2h2v8zm7-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
	}), 'Filter1');
	
	exports.default = _default;

/***/ },
/* 2843 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 10h2V5h-4v2h2v8zm7-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
	}), 'Filter1Outlined');
	
	exports.default = _default;

/***/ },
/* 2844 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 5c-.55 0-1 .45-1 1v15c0 1.1.9 2 2 2h15c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1-.45-1-1V6c0-.55-.45-1-1-1zm13 10c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1h1v7c0 .55.45 1 1 1zm6-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-1 16H8c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1z"
	}), 'Filter1Rounded');
	
	exports.default = _default;

/***/ },
/* 2845 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v18h18v-2H3V5zm11 10h2V5h-4v2h2v8zm9-14H5v18h18V1zm-2 16H7V3h14v14z"
	}), 'Filter1Sharp');
	
	exports.default = _default;

/***/ },
/* 2846 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 17h14V3H7v14zm5-12h4v10h-2V7h-2V5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M14 15h2V5h-4v2h2zm7-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM1 5v16c0 1.1.9 2 2 2h16v-2H3V5H1z"
	})), 'Filter1TwoTone');
	
	exports.default = _default;

/***/ },
/* 2847 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-4-4h-4v-2h2c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2h-4v2h4v2h-2c-1.1 0-2 .89-2 2v4h6v-2z"
	}), 'Filter2');
	
	exports.default = _default;

/***/ },
/* 2848 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-4-4h-4v-2h2c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2h-4v2h4v2h-2c-1.1 0-2 .89-2 2v4h6v-2z"
	}), 'Filter2Outlined');
	
	exports.default = _default;

/***/ },
/* 2849 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 5c-.55 0-1 .45-1 1v15c0 1.1.9 2 2 2h15c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1-.45-1-1V6c0-.55-.45-1-1-1zm19-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-1 16H8c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zm-4-4h-3v-2h2c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-3c-.55 0-1 .45-1 1s.45 1 1 1h3v2h-2c-1.1 0-2 .9-2 2v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1z"
	}), 'Filter2Rounded');
	
	exports.default = _default;

/***/ },
/* 2850 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v18h18v-2H3V5zm20-4H5v18h18V1zm-2 16H7V3h14v14zm-4-4h-4v-2h4V5h-6v2h4v2h-4v6h6v-2z"
	}), 'Filter2Sharp');
	
	exports.default = _default;

/***/ },
/* 2851 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 17h14V3H7v14zm4-6c0-1.11.9-2 2-2h2V7h-4V5h4c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2h-2v2h4v2h-6v-4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 13h-4v-2h2c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2h-4v2h4v2h-2c-1.1 0-2 .89-2 2v4h6v-2zm4-12H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM1 21c0 1.1.9 2 2 2h16v-2H3V5H1v16z"
	})), 'Filter2TwoTone');
	
	exports.default = _default;

/***/ },
/* 2852 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-4v2h4v2h-2v2h2v2h-4v2h4c1.1 0 2-.89 2-2z"
	}), 'Filter3');
	
	exports.default = _default;

/***/ },
/* 2853 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-4v2h4v2h-2v2h2v2h-4v2h4c1.1 0 2-.89 2-2z"
	}), 'Filter3Outlined');
	
	exports.default = _default;

/***/ },
/* 2854 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-1 16H8c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zM2 5c-.55 0-1 .45-1 1v15c0 1.1.9 2 2 2h15c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1-.45-1-1V6c0-.55-.45-1-1-1zm15 8v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.1-.9-2-2-2h-3c-.55 0-1 .45-1 1s.45 1 1 1h3v2h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v2h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c1.1 0 2-.9 2-2z"
	}), 'Filter3Rounded');
	
	exports.default = _default;

/***/ },
/* 2855 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 1H5v18h18V1zm-2 16H7V3h14v14zM3 5H1v18h18v-2H3V5zm14 10V5h-6v2h4v2h-2v2h2v2h-4v2h6z"
	}), 'Filter3Sharp');
	
	exports.default = _default;

/***/ },
/* 2856 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 17h14V3H7v14zm4-4h4v-2h-2V9h2V7h-4V5h4c1.1 0 2 .89 2 2v1.5c0 .83-.67 1.5-1.5 1.5.83 0 1.5.67 1.5 1.5V13c0 1.11-.9 2-2 2h-4v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-4-4v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-4v2h4v2h-2v2h2v2h-4v2h4c1.1 0 2-.89 2-2zm2 10v-2H3V5H1v16c0 1.1.9 2 2 2h16z"
	})), 'Filter3TwoTone');
	
	exports.default = _default;

/***/ },
/* 2857 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm12 10h2V5h-2v4h-2V5h-2v6h4v4zm6-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
	}), 'Filter4');
	
	exports.default = _default;

/***/ },
/* 2858 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm12 10h2V5h-2v4h-2V5h-2v6h4v4zm6-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
	}), 'Filter4Outlined');
	
	exports.default = _default;

/***/ },
/* 2859 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 5c-.55 0-1 .45-1 1v15c0 1.1.9 2 2 2h15c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1-.45-1-1V6c0-.55-.45-1-1-1zm14 10c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1s-1 .45-1 1v3h-2V6c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h3v3c0 .55.45 1 1 1zm5-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-1 16H8c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1z"
	}), 'Filter4Rounded');
	
	exports.default = _default;

/***/ },
/* 2860 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v18h18v-2H3V5zm12 10h2V5h-2v4h-2V5h-2v6h4v4zm8-14H5v18h18V1zm-2 16H7V3h14v14z"
	}), 'Filter4Sharp');
	
	exports.default = _default;

/***/ },
/* 2861 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21 3H7v14h14V3zm-4 12h-2v-4h-4V5h2v4h2V5h2v10z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 23h16v-2H3V5H1v16c0 1.1.9 2 2 2zm4-4h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2zM7 3h14v14H7V3zm8 6h-2V5h-2v6h4v4h2V5h-2z"
	})), 'Filter4TwoTone');
	
	exports.default = _default;

/***/ },
/* 2862 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-2c0-1.11-.9-2-2-2h-2V7h4V5h-6v6h4v2h-4v2h4c1.1 0 2-.89 2-2z"
	}), 'Filter5');
	
	exports.default = _default;

/***/ },
/* 2863 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-2c0-1.11-.9-2-2-2h-2V7h4V5h-6v6h4v2h-4v2h4c1.1 0 2-.89 2-2z"
	}), 'Filter5Outlined');
	
	exports.default = _default;

/***/ },
/* 2864 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-1 16H8c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zM2 5c-.55 0-1 .45-1 1v15c0 1.1.9 2 2 2h15c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1-.45-1-1V6c0-.55-.45-1-1-1zm15 8v-2c0-1.1-.9-2-2-2h-2V7h3c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3v2h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c1.1 0 2-.9 2-2z"
	}), 'Filter5Rounded');
	
	exports.default = _default;

/***/ },
/* 2865 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 1H5v18h18V1zm-2 16H7V3h14v14zM3 5H1v18h18v-2H3V5zm14 10V9h-4V7h4V5h-6v6h4v2h-4v2h6z"
	}), 'Filter5Sharp');
	
	exports.default = _default;

/***/ },
/* 2866 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 17h14V3H7v14zm4-4h4v-2h-4V5h6v2h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2h-4v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 23v-2H3V5H1v16c0 1.1.9 2 2 2h16zm-2-10v-2c0-1.11-.9-2-2-2h-2V7h4V5h-6v6h4v2h-4v2h4c1.1 0 2-.89 2-2zm4-12H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
	})), 'Filter5TwoTone');
	
	exports.default = _default;

/***/ },
/* 2867 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-2c0-1.11-.9-2-2-2h-2V7h4V5h-4c-1.1 0-2 .89-2 2v6c0 1.11.9 2 2 2zm0-4h2v2h-2v-2z"
	}), 'Filter6');
	
	exports.default = _default;

/***/ },
/* 2868 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-2c0-1.11-.9-2-2-2h-2V7h4V5h-4c-1.1 0-2 .89-2 2v6c0 1.11.9 2 2 2zm0-4h2v2h-2v-2z"
	}), 'Filter6Outlined');
	
	exports.default = _default;

/***/ },
/* 2869 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 5c-.55 0-1 .45-1 1v15c0 1.1.9 2 2 2h15c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1-.45-1-1V6c0-.55-.45-1-1-1zm19-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-1 16H8c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zm-7-2h2c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2h-2V7h3c.55 0 1-.45 1-1s-.45-1-1-1h-3c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2zm0-4h2v2h-2v-2z"
	}), 'Filter6Rounded');
	
	exports.default = _default;

/***/ },
/* 2870 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v18h18v-2H3V5zm20-4H5v18h18V1zm-2 16H7V3h14v14zm-10-2h6V9h-4V7h4V5h-6v10zm2-4h2v2h-2v-2z"
	}), 'Filter6Sharp');
	
	exports.default = _default;

/***/ },
/* 2871 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 17h14V3H7v14zm4-10c0-1.11.9-2 2-2h4v2h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2h-2c-1.1 0-2-.89-2-2V7zm2 4h2v2h-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-2c0-1.11-.9-2-2-2h-2V7h4V5h-4c-1.1 0-2 .89-2 2v6c0 1.11.9 2 2 2zm0-4h2v2h-2v-2zM3 23h16v-2H3V5H1v16c0 1.1.9 2 2 2z"
	})), 'Filter6TwoTone');
	
	exports.default = _default;

/***/ },
/* 2872 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2l4-8V5h-6v2h4l-4 8h2z"
	}), 'Filter7');
	
	exports.default = _default;

/***/ },
/* 2873 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2l4-8V5h-6v2h4l-4 8h2z"
	}), 'Filter7Outlined');
	
	exports.default = _default;

/***/ },
/* 2874 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 5c-.55 0-1 .45-1 1v15c0 1.1.9 2 2 2h15c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1-.45-1-1V6c0-.55-.45-1-1-1zm19-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-1 16H8c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zm-6.75-2.49l3.58-7.17c.11-.22.17-.47.17-.72 0-.9-.72-1.62-1.62-1.62H12c-.55 0-1 .45-1 1s.45 1 1 1h3l-3.36 6.71c-.3.59.13 1.29.8 1.29h.01c.34 0 .65-.19.8-.49z"
	}), 'Filter7Rounded');
	
	exports.default = _default;

/***/ },
/* 2875 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v18h18v-2H3V5zm20-4H5v18h18V1zm-2 16H7V3h14v14zm-8-2l4-8V5h-6v2h4l-4 8h2z"
	}), 'Filter7Sharp');
	
	exports.default = _default;

/***/ },
/* 2876 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 17h14V3H7v14zm4-10V5h6v2l-4 8h-2l4-8h-4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 23h16v-2H3V5H1v16c0 1.1.9 2 2 2zm10-8l4-8V5h-6v2h4l-4 8zm8-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
	})), 'Filter7TwoTone');
	
	exports.default = _default;

/***/ },
/* 2877 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-2c-1.1 0-2 .89-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13c0 1.11.9 2 2 2zm0-8h2v2h-2V7zm0 4h2v2h-2v-2z"
	}), 'Filter8');
	
	exports.default = _default;

/***/ },
/* 2878 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-2c-1.1 0-2 .89-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13c0 1.11.9 2 2 2zm0-8h2v2h-2V7zm0 4h2v2h-2v-2z"
	}), 'Filter8Outlined');
	
	exports.default = _default;

/***/ },
/* 2879 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 5c-.55 0-1 .45-1 1v15c0 1.1.9 2 2 2h15c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1-.45-1-1V6c0-.55-.45-1-1-1zm19-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-1 16H8c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zm-7-2h2c1.1 0 2-.89 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-2c-1.1 0-2 .89-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13c0 1.11.9 2 2 2zm0-8h2v2h-2V7zm0 4h2v2h-2v-2z"
	}), 'Filter8Rounded');
	
	exports.default = _default;

/***/ },
/* 2880 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v18h18v-2H3V5zm20-4H5v18h18V1zm-2 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-2c-1.1 0-2 .89-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13c0 1.11.9 2 2 2zm0-8h2v2h-2V7zm0 4h2v2h-2v-2z"
	}), 'Filter8Sharp');
	
	exports.default = _default;

/***/ },
/* 2881 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 17h14V3H7v14zm4-5.5c0-.83.67-1.5 1.5-1.5-.83 0-1.5-.67-1.5-1.5V7c0-1.11.9-2 2-2h2c1.1 0 2 .89 2 2v1.5c0 .83-.67 1.5-1.5 1.5.83 0 1.5.67 1.5 1.5V13c0 1.11-.9 2-2 2h-2c-1.1 0-2-.89-2-2v-1.5zM13 7h2v2h-2zm0 4h2v2h-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 23h16v-2H3V5H1v16c0 1.1.9 2 2 2zm10-8h2c1.1 0 2-.89 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-2c-1.1 0-2 .89-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13c0 1.11.9 2 2 2zm0-8h2v2h-2V7zm0 4h2v2h-2v-2z"
	})), 'Filter8TwoTone');
	
	exports.default = _default;

/***/ },
/* 2882 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM15 5h-2c-1.1 0-2 .89-2 2v2c0 1.11.9 2 2 2h2v2h-4v2h4c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2zm0 4h-2V7h2v2z"
	}), 'Filter9');
	
	exports.default = _default;

/***/ },
/* 2883 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM15 5h-2c-1.1 0-2 .89-2 2v2c0 1.11.9 2 2 2h2v2h-4v2h4c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2zm0 4h-2V7h2v2z"
	}), 'Filter9Outlined');
	
	exports.default = _default;

/***/ },
/* 2884 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 7V8c0-1.11-.9-2-2-2h-1c-1.1 0-2 .89-2 2v1c0 1.11.9 2 2 2h1v1H9v2h3c1.1 0 2-.89 2-2zm-3-3V8h1v1h-1zm10-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z"
	}), 'Filter9Plus');
	
	exports.default = _default;

/***/ },
/* 2885 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 7V8c0-1.11-.9-2-2-2h-1c-1.1 0-2 .89-2 2v1c0 1.11.9 2 2 2h1v1H9v2h3c1.1 0 2-.89 2-2zm-3-3V8h1v1h-1zm10-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z"
	}), 'Filter9PlusOutlined');
	
	exports.default = _default;

/***/ },
/* 2886 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 5c-.55 0-1 .45-1 1v15c0 1.1.9 2 2 2h15c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1-.45-1-1V6c0-.55-.45-1-1-1zm12 7V8c0-1.1-.9-2-2-2h-1c-1.1 0-2 .9-2 2v1c0 1.1.9 2 2 2h1v1h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c1.1 0 2-.9 2-2zm-3-3V8h1v1h-1zm10-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-1 16H8c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zm1-7c0-.55-.45-1-1-1h-1V8c0-.55-.45-1-1-1s-1 .45-1 1v1h-1c-.55 0-1 .45-1 1s.45 1 1 1h1v1c0 .55.45 1 1 1s1-.45 1-1v-1h1c.55 0 1-.45 1-1z"
	}), 'Filter9PlusRounded');
	
	exports.default = _default;

/***/ },
/* 2887 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v18h18v-2H3V5zm11 9V6H9v5h3v1H9v2h5zm-3-5V8h1v1h-1zm12-8H5v18h18V1zm-2 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z"
	}), 'Filter9PlusSharp');
	
	exports.default = _default;

/***/ },
/* 2888 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 17h14v-6h-2v2h-2v-2h-2V9h2V7h2v2h2V3H7v14zm2-5h3v-1h-1c-1.1 0-2-.89-2-2V8c0-1.11.9-2 2-2h1c1.1 0 2 .89 2 2v4c0 1.11-.9 2-2 2H9v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 21H3V5H1v16c0 1.1.9 2 2 2h16v-2z"
	}), _react.default.createElement("path", {
	  d: "M11 8h1v1h-1z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 6h-1c-1.1 0-2 .89-2 2v1c0 1.11.9 2 2 2h1v1H9v2h3c1.1 0 2-.89 2-2V8c0-1.11-.9-2-2-2zm0 3h-1V8h1v1zm9-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z"
	})), 'Filter9PlusTwoTone');
	
	exports.default = _default;

/***/ },
/* 2889 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 5c-.55 0-1 .45-1 1v15c0 1.1.9 2 2 2h15c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1-.45-1-1V6c0-.55-.45-1-1-1zm19-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-1 16H8c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zM15 5h-2c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h2v2h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 4h-2V7h2v2z"
	}), 'Filter9Rounded');
	
	exports.default = _default;

/***/ },
/* 2890 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v18h18v-2H3V5zm20-4H5v18h18V1zm-2 16H7V3h14v14zM17 5h-6v6h4v2h-4v2h6V5zm-2 4h-2V7h2v2z"
	}), 'Filter9Sharp');
	
	exports.default = _default;

/***/ },
/* 2891 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M13 7h2v2h-2zM7 17h14V3H7v14zm4-4h4v-2h-2c-1.1 0-2-.89-2-2V7c0-1.11.9-2 2-2h2c1.1 0 2 .89 2 2v6c0 1.11-.9 2-2 2h-4v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 23h16v-2H3V5H1v16c0 1.1.9 2 2 2zm14-10V7c0-1.11-.9-2-2-2h-2c-1.1 0-2 .89-2 2v2c0 1.11.9 2 2 2h2v2h-4v2h4c1.1 0 2-.89 2-2zm-4-4V7h2v2h-2z"
	})), 'Filter9TwoTone');
	
	exports.default = _default;

/***/ },
/* 2892 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h7v14z"
	}), 'FilterBAndW');
	
	exports.default = _default;

/***/ },
/* 2893 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h7v14z"
	}), 'FilterBAndWOutlined');
	
	exports.default = _default;

/***/ },
/* 2894 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h6c.55 0 1 .45 1 1v13z"
	}), 'FilterBAndWRounded');
	
	exports.default = _default;

/***/ },
/* 2895 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zm-2 16l-7-8v8H5l7-8V5h7v14z"
	}), 'FilterBAndWSharp');
	
	exports.default = _default;

/***/ },
/* 2896 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 5h-7v6l7 8zm-7 14v-8l-7 8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zm-9 0H5l7-8V5h7v14l-7-8v8z"
	})), 'FilterBAndWTwoTone');
	
	exports.default = _default;

/***/ },
/* 2897 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
	}), 'FilterCenterFocus');
	
	exports.default = _default;

/***/ },
/* 2898 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
	}), 'FilterCenterFocusOutlined');
	
	exports.default = _default;

/***/ },
/* 2899 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 15c-.55 0-1 .45-1 1v3c0 1.1.9 2 2 2h3c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1-.45-1-1v-2c0-.55-.45-1-1-1zm1-9c0-.55.45-1 1-1h2c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.1 0-2 .9-2 2v3c0 .55.45 1 1 1s1-.45 1-1V6zm14-3h-3c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1 .45 1 1v2c0 .55.45 1 1 1s1-.45 1-1V5c0-1.1-.9-2-2-2zm0 15c0 .55-.45 1-1 1h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c1.1 0 2-.9 2-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v2zm-7-9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
	}), 'FilterCenterFocusRounded');
	
	exports.default = _default;

/***/ },
/* 2900 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 15H3v6h6v-2H5v-4zM5 5h4V3H3v6h2V5zm16-2h-6v2h4v4h2V3zm-2 16h-4v2h6v-6h-2v4zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
	}), 'FilterCenterFocusSharp');
	
	exports.default = _default;

/***/ },
/* 2901 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm7 4c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm7-6h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4z"
	}), 'FilterCenterFocusTwoTone');
	
	exports.default = _default;

/***/ },
/* 2902 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.61 5.64 5.36 8.04 2.35 8.36 0 10.9 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19c1.65 0 3 1.35 3 3s-1.35 3-3 3z"
	}), 'FilterDrama');
	
	exports.default = _default;

/***/ },
/* 2903 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.61 5.64 5.36 8.04 2.35 8.36 0 10.9 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19c1.65 0 3 1.35 3 3s-1.35 3-3 3z"
	}), 'FilterDramaOutlined');
	
	exports.default = _default;

/***/ },
/* 2904 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.61 5.64 5.36 8.04 2.35 8.36 0 10.9 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6.17c-2.09 0-3.95-1.53-4.15-3.61C1.79 12.01 3.66 10 6 10c1.92 0 3.53 1.36 3.91 3.17.1.48.5.83.98.83.61 0 1.11-.55.99-1.15-.43-2.24-2.11-4.03-4.29-4.63 1.1-1.46 2.89-2.37 4.89-2.2 2.88.25 5.01 2.82 5.01 5.71V12h1.37c1.45 0 2.79.97 3.07 2.4.39 1.91-1.08 3.6-2.93 3.6z"
	}), 'FilterDramaRounded');
	
	exports.default = _default;

/***/ },
/* 2905 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.61 5.64 5.36 8.04 2.35 8.36 0 10.9 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19c1.65 0 3 1.35 3 3s-1.35 3-3 3z"
	}), 'FilterDramaSharp');
	
	exports.default = _default;

/***/ },
/* 2906 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 12h-1.5v-.5C17.5 8.47 15.03 6 12 6c-1.8 0-3.39.88-4.4 2.22 2.54.7 4.4 3.02 4.4 5.78h-2c0-2.21-1.79-4-4-4s-4 1.79-4 4 1.79 4 4 4h13c1.65 0 3-1.35 3-3s-1.35-3-3-3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.61 5.64 5.36 8.04 2.35 8.36 0 10.9 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19c1.65 0 3 1.35 3 3s-1.35 3-3 3z"
	})), 'FilterDramaTwoTone');
	
	exports.default = _default;

/***/ },
/* 2907 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4h-4l-4-4-4 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H4V6h4.52l3.52-3.5L15.52 6H20v14zM18 8H6v10h12"
	}), 'FilterFrames');
	
	exports.default = _default;

/***/ },
/* 2908 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4h-4l-4-4-4 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H4V6h4.52l3.52-3.5L15.52 6H20v14zM6 18h12V8H6v10zm2-8h8v6H8v-6z"
	}), 'FilterFramesOutlined');
	
	exports.default = _default;

/***/ },
/* 2909 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4h-4L12.71.71a.9959.9959 0 00-1.41 0L8 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-1 16H5c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h3.52l3.52-3.5L15.52 6H19c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zM17 8H7c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z"
	}), 'FilterFramesRounded');
	
	exports.default = _default;

/***/ },
/* 2910 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 4h-6l-4-4-4 4H2v18h20V4zm-2 16H4V6h4.52l3.52-3.5L15.52 6H20v14zM18 8H6v10h12"
	}), 'FilterFramesSharp');
	
	exports.default = _default;

/***/ },
/* 2911 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 10h8v6H8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 4h-4l-4-4-4 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H4V6h4.52l3.52-3.5L15.52 6H20v14zM6 18h12V8H6v10zm2-8h8v6H8v-6z"
	})), 'FilterFramesTwoTone');
	
	exports.default = _default;

/***/ },
/* 2912 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
	}), 'FilterHdr');
	
	exports.default = _default;

/***/ },
/* 2913 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6l-4.22 5.63 1.25 1.67L14 9.33 19 16h-8.46l-4.01-5.37L1 18h22L14 6zM5 16l1.52-2.03L8.04 16H5z"
	}), 'FilterHdrOutlined');
	
	exports.default = _default;

/***/ },
/* 2914 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.2 7.07L10.25 11l2.25 3c.33.44.24 1.07-.2 1.4-.44.33-1.07.25-1.4-.2-1.05-1.4-2.31-3.07-3.1-4.14-.4-.53-1.2-.53-1.6 0l-4 5.33c-.49.67-.02 1.61.8 1.61h18c.82 0 1.29-.94.8-1.6l-7-9.33c-.4-.54-1.2-.54-1.6 0z"
	}), 'FilterHdrRounded');
	
	exports.default = _default;

/***/ },
/* 2915 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
	}), 'FilterHdrSharp');
	
	exports.default = _default;

/***/ },
/* 2916 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 16h3.04l-1.52-2.03z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9.78 11.63l1.25 1.67L14 9.33 19 16h-8.46l-4.01-5.37L1 18h22L14 6l-4.22 5.63zM5 16l1.52-2.03L8.04 16H5z"
	})), 'FilterHdrTwoTone');
	
	exports.default = _default;

/***/ },
/* 2917 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
	}), 'FilterList');
	
	exports.default = _default;

/***/ },
/* 2918 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
	}), 'FilterListOutlined');
	
	exports.default = _default;

/***/ },
/* 2919 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 18h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1zm4 6h10c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1z"
	}), 'FilterListRounded');
	
	exports.default = _default;

/***/ },
/* 2920 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
	}), 'FilterListSharp');
	
	exports.default = _default;

/***/ },
/* 2921 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
	}), 'FilterListTwoTone');
	
	exports.default = _default;

/***/ },
/* 2922 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
	}), 'FilterNone');
	
	exports.default = _default;

/***/ },
/* 2923 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
	}), 'FilterNoneOutlined');
	
	exports.default = _default;

/***/ },
/* 2924 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 5c-.55 0-1 .45-1 1v15c0 1.1.9 2 2 2h15c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1-.45-1-1V6c0-.55-.45-1-1-1zm19-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-1 16H8c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1z"
	}), 'FilterNoneRounded');
	
	exports.default = _default;

/***/ },
/* 2925 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5H1v18h18v-2H3V5zm20-4H5v18h18V1zm-2 16H7V3h14v14z"
	}), 'FilterNoneSharp');
	
	exports.default = _default;

/***/ },
/* 2926 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 3h14v14H7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 23h16v-2H3V5H1v16c0 1.1.9 2 2 2zM21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
	})), 'FilterNoneTwoTone');
	
	exports.default = _default;

/***/ },
/* 2927 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.96 10.29l-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
	}), 'FilterOutlined');
	
	exports.default = _default;

/***/ },
/* 2928 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.56 10.81l-2.35 3.02-1.56-1.88c-.2-.25-.58-.24-.78.01l-1.74 2.23c-.26.33-.02.81.39.81h8.98c.41 0 .65-.47.4-.8l-2.55-3.39c-.19-.26-.59-.26-.79 0zM2 5c-.55 0-1 .45-1 1v15c0 1.1.9 2 2 2h15c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1-.45-1-1V6c0-.55-.45-1-1-1zm19-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-1 16H8c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1z"
	}), 'FilterRounded');
	
	exports.default = _default;

/***/ },
/* 2929 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.96 10.29l-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71zM3 5H1v18h18v-2H3V5zm20-4H5v18h18V1zm-2 16H7V3h14v14z"
	}), 'FilterSharp');
	
	exports.default = _default;

/***/ },
/* 2930 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zm7.32.19C16.84 3.05 15.01 2.25 13 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1c.86 1.11 1.44 2.44 1.62 3.9zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zM15 12c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm3.31 4.9l1.43 1.43c1.21-1.48 2.01-3.32 2.21-5.32h-2.02c-.18 1.45-.76 2.78-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm-7.32-.19C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43z"
	}), 'FilterTiltShift');
	
	exports.default = _default;

/***/ },
/* 2931 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zm7.32.19C16.84 3.05 15.01 2.25 13 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1c.86 1.11 1.44 2.44 1.62 3.9zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zM15 12c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm3.31 4.9l1.43 1.43c1.21-1.48 2.01-3.32 2.21-5.32h-2.02c-.18 1.45-.76 2.78-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm-7.32-.19C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43z"
	}), 'FilterTiltShiftOutlined');
	
	exports.default = _default;

/***/ },
/* 2932 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 3.23c0-.64-.59-1.13-1.21-.99-1.12.26-2.18.7-3.12 1.3-.53.34-.61 1.1-.16 1.55.32.32.83.4 1.21.16.77-.49 1.62-.85 2.54-1.05.44-.1.74-.51.74-.97zm6.33.32c-.94-.6-2-1.04-3.12-1.3-.62-.14-1.21.34-1.21.98 0 .45.3.87.74.96.91.2 1.77.57 2.53 1.05.39.24.89.17 1.21-.16.46-.44.39-1.19-.15-1.53zM20.77 11c.64 0 1.13-.59.99-1.21-.26-1.12-.7-2.18-1.3-3.12-.34-.53-1.1-.61-1.55-.16-.32.32-.4.83-.16 1.21.49.77.85 1.62 1.05 2.53.1.45.51.75.97.75zM5.1 6.51c-.46-.45-1.21-.38-1.55.16-.6.94-1.04 2-1.3 3.12-.14.62.34 1.21.98 1.21.45 0 .87-.3.96-.74.2-.91.57-1.77 1.05-2.53.26-.39.18-.9-.14-1.22zM3.23 13c-.64 0-1.13.59-.99 1.21.26 1.12.7 2.17 1.3 3.12.34.54 1.1.61 1.55.16.32-.32.4-.83.15-1.21-.49-.76-.85-1.61-1.05-2.53-.09-.45-.5-.75-.96-.75zM15 12c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm3.9 5.49c.45.45 1.21.38 1.55-.15.6-.94 1.04-2 1.3-3.11.14-.62-.35-1.21-.98-1.21-.45 0-.87.3-.96.74-.2.91-.57 1.76-1.05 2.53-.26.37-.18.88.14 1.2zM13 20.77c0 .64.59 1.13 1.21.99 1.12-.26 2.17-.7 3.12-1.3.54-.34.61-1.1.16-1.55-.32-.32-.83-.4-1.21-.15-.76.49-1.61.85-2.53 1.05-.45.09-.75.5-.75.96zm-6.33-.32c.95.6 2 1.04 3.12 1.3.62.14 1.21-.35 1.21-.98 0-.45-.3-.87-.74-.96-.91-.2-1.77-.57-2.53-1.05-.39-.24-.89-.17-1.21.16-.46.44-.39 1.19.15 1.53z"
	}), 'FilterTiltShiftRounded');
	
	exports.default = _default;

/***/ },
/* 2933 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zm7.32.19C16.84 3.05 15.01 2.25 13 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1c.86 1.11 1.44 2.44 1.62 3.9zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zM15 12c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm3.31 4.9l1.43 1.43c1.21-1.48 2.01-3.32 2.21-5.32h-2.02c-.18 1.45-.76 2.78-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm-7.32-.19C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43z"
	}), 'FilterTiltShiftSharp');
	
	exports.default = _default;

/***/ },
/* 2934 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43C16.84 3.05 15.01 2.25 13 2.05zm0 17.88v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm-8.74-1.61l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89H2.05c.2 2.01 1 3.84 2.21 5.32zM2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11zm16.26-3.9c.86 1.11 1.44 2.44 1.62 3.9h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1zM7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69zM5.68 19.74C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43zm16.27-6.73h-2.02c-.18 1.45-.76 2.78-1.62 3.89l1.43 1.43c1.21-1.48 2.01-3.32 2.21-5.32zM9 12c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
	}), 'FilterTiltShiftTwoTone');
	
	exports.default = _default;

/***/ },
/* 2935 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 17h14V3H7v14zm4.25-5.53l1.96 2.36 2.75-3.54L19.5 15h-11l2.75-3.53z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M1 21c0 1.1.9 2 2 2h16v-2H3V5H1v16zM21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L8.5 15h11z"
	})), 'FilterTwoTone');
	
	exports.default = _default;

/***/ },
/* 2936 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.7 12.4c-.28-.16-.57-.29-.86-.4.29-.11.58-.24.86-.4 1.92-1.11 2.99-3.12 3-5.19-1.79-1.03-4.07-1.11-6 0-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55-1.92-1.11-4.2-1.03-6 0 0 2.07 1.07 4.08 3 5.19.28.16.57.29.86.4-.29.11-.58.24-.86.4-1.92 1.11-2.99 3.12-3 5.19 1.79 1.03 4.07 1.11 6 0 .28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54 1.92 1.11 4.2 1.03 6 0-.01-2.07-1.08-4.08-3-5.19zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
	}), 'FilterVintage');
	
	exports.default = _default;

/***/ },
/* 2937 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.7 12.4c-.28-.16-.57-.29-.86-.4.29-.11.58-.24.86-.4 1.92-1.11 2.99-3.12 3-5.19-.91-.52-1.95-.8-3.01-.8-1.02 0-2.05.26-2.99.8-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55-.94-.54-1.97-.8-2.99-.8-1.05 0-2.1.28-3.01.8 0 2.07 1.07 4.08 3 5.19.28.16.57.29.86.4-.29.11-.58.24-.86.4-1.92 1.11-2.99 3.12-3 5.19.91.52 1.95.8 3.01.8 1.02 0 2.05-.26 2.99-.8.28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54.94.54 1.97.8 2.99.8 1.05 0 2.1-.28 3.01-.8-.01-2.07-1.08-4.08-3-5.19zm-2.54-3.88c.21-.17.38-.29.54-.37.61-.35 1.3-.54 2-.54.27 0 .53.03.79.08-.31.91-.94 1.69-1.78 2.18-.17.1-.36.18-.58.27l-1.38.52c-.17-.46-.41-.87-.72-1.24l1.13-.9zM12 3.37c.63.72 1 1.66 1 2.63 0 .19-.02.41-.05.63l-.23 1.44C12.48 8.03 12.24 8 12 8s-.48.03-.71.07l-.23-1.44C11.02 6.41 11 6.19 11 6c0-.98.37-1.91 1-2.63zM4.51 7.68c.26-.06.53-.08.8-.08.69 0 1.38.18 1.99.54.15.09.32.2.49.35l1.15.96c-.3.36-.53.76-.7 1.2l-1.38-.52c-.21-.09-.4-.18-.56-.27-.87-.5-1.49-1.27-1.79-2.18zm3.33 7.79c-.21.17-.38.29-.54.37-.61.35-1.3.54-2 .54-.27 0-.53-.03-.79-.08.31-.91.94-1.69 1.78-2.18.17-.1.36-.18.58-.27l1.38-.52c.16.46.41.88.72 1.24l-1.13.9zM12 20.63c-.63-.72-1-1.66-1-2.63 0-.2.02-.41.06-.65l.22-1.42c.23.04.47.07.72.07.24 0 .48-.03.71-.07l.23 1.44c.04.22.06.44.06.63 0 .98-.37 1.91-1 2.63zm6.69-4.24c-.69 0-1.38-.18-1.99-.54-.18-.1-.34-.22-.49-.34l-1.15-.96c.3-.36.54-.76.7-1.21l1.38.52c.22.08.41.17.57.26.85.49 1.47 1.27 1.78 2.18-.27.07-.54.09-.8.09z"
	}), 'FilterVintageOutlined');
	
	exports.default = _default;

/***/ },
/* 2938 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.7 12.4c-.28-.16-.57-.29-.86-.4.29-.11.58-.24.86-.4 1.92-1.11 2.99-3.12 3-5.19-1.79-1.03-4.07-1.11-6 0-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55-1.92-1.11-4.2-1.03-6 0 0 2.07 1.07 4.08 3 5.19.28.16.57.29.86.4-.29.11-.58.24-.86.4-1.92 1.11-2.99 3.12-3 5.19 1.79 1.03 4.07 1.11 6 0 .28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54 1.92 1.11 4.2 1.03 6 0-.01-2.07-1.08-4.08-3-5.19zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
	}), 'FilterVintageRounded');
	
	exports.default = _default;

/***/ },
/* 2939 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.7 12.4c-.28-.16-.57-.29-.86-.4.29-.11.58-.24.86-.4 1.92-1.11 2.99-3.12 3-5.19-1.79-1.03-4.07-1.11-6 0-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55-1.92-1.11-4.2-1.03-6 0 0 2.07 1.07 4.08 3 5.19.28.16.57.29.86.4-.29.11-.58.24-.86.4-1.92 1.11-2.99 3.12-3 5.19 1.79 1.03 4.07 1.11 6 0 .28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54 1.92 1.11 4.2 1.03 6 0-.01-2.07-1.08-4.08-3-5.19zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
	}), 'FilterVintageSharp');
	
	exports.default = _default;

/***/ },
/* 2940 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18.69 7.61c-.7 0-1.39.19-2 .54-.16.09-.32.21-.54.37l-1.13.9c.31.36.56.78.72 1.24l1.38-.52c.22-.08.41-.17.58-.27.84-.49 1.47-1.27 1.78-2.18-.26-.06-.52-.08-.79-.08zm-1.56 6.26l-1.38-.52c-.16.45-.4.85-.7 1.21l1.15.96c.15.12.31.24.49.34.61.35 1.3.54 1.99.54.27 0 .53-.03.8-.08-.31-.91-.94-1.69-1.78-2.18-.16-.1-.35-.19-.57-.27zM11 6c0 .19.02.41.05.63l.23 1.44c.24-.04.48-.07.72-.07s.48.03.71.07l.23-1.44c.04-.22.06-.44.06-.63 0-.98-.37-1.91-1-2.63-.63.72-1 1.65-1 2.63zm1.71 9.93c-.23.04-.47.07-.71.07-.25 0-.49-.03-.72-.07l-.22 1.42c-.04.24-.06.45-.06.65 0 .98.37 1.91 1 2.63.63-.72 1-1.66 1-2.63 0-.19-.02-.41-.05-.63l-.24-1.44zm-5.84-5.81l1.38.52c.16-.44.4-.85.7-1.2L7.8 8.49c-.17-.15-.34-.27-.49-.35-.62-.36-1.3-.54-2-.54-.27 0-.54.03-.81.08.3.91.93 1.68 1.79 2.18.17.09.36.18.58.26zm0 3.74c-.22.08-.41.17-.58.27-.84.49-1.47 1.27-1.78 2.18.26.05.52.08.79.08.7 0 1.39-.19 2-.54.16-.09.32-.21.54-.37l1.13-.89c-.31-.36-.56-.78-.72-1.24l-1.38.51z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18.7 12.4c-.28-.16-.57-.29-.86-.4.29-.11.58-.24.86-.4 1.92-1.11 2.99-3.12 3-5.19-.91-.52-1.95-.8-3.01-.8-1.02 0-2.05.26-2.99.8-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55-.94-.54-1.97-.8-2.99-.8-1.05 0-2.1.28-3.01.8 0 2.07 1.07 4.08 3 5.19.28.16.57.29.86.4-.29.11-.58.24-.86.4-1.92 1.11-2.99 3.12-3 5.19.91.52 1.95.8 3.01.8 1.02 0 2.05-.26 2.99-.8.28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54.94.54 1.97.8 2.99.8 1.05 0 2.1-.28 3.01-.8-.01-2.07-1.08-4.08-3-5.19zM4.51 7.68c.26-.06.53-.08.8-.08.69 0 1.38.18 1.99.54.15.09.32.2.49.35l1.15.96c-.3.36-.53.76-.7 1.2l-1.38-.52c-.21-.09-.4-.18-.56-.27-.87-.5-1.49-1.27-1.79-2.18zm3.33 7.79c-.21.17-.38.29-.54.37-.61.35-1.3.54-2 .54-.27 0-.53-.03-.79-.08.31-.91.94-1.69 1.78-2.18.17-.1.36-.18.58-.27l1.38-.52c.16.46.41.88.72 1.24l-1.13.9zM12 3.37c.63.72 1 1.66 1 2.63 0 .19-.02.41-.05.63l-.23 1.44C12.48 8.03 12.24 8 12 8s-.48.03-.71.07l-.23-1.44C11.02 6.41 11 6.19 11 6c0-.98.37-1.91 1-2.63zm0 17.26c-.63-.72-1-1.66-1-2.63 0-.2.02-.41.06-.65l.22-1.42c.23.04.47.07.72.07.24 0 .48-.03.71-.07l.23 1.44c.04.22.06.44.06.63 0 .98-.37 1.91-1 2.63zM12 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm4.16-5.48c.21-.17.38-.29.54-.37.61-.35 1.3-.54 2-.54.27 0 .53.03.79.08-.31.91-.94 1.69-1.78 2.18-.17.1-.36.18-.58.27l-1.38.52c-.17-.46-.41-.87-.72-1.24l1.13-.9zm2.53 7.87c-.69 0-1.38-.18-1.99-.54-.18-.1-.34-.22-.49-.34l-1.15-.96c.3-.36.54-.76.7-1.21l1.38.52c.22.08.41.17.57.26.85.49 1.47 1.27 1.78 2.18-.27.07-.54.09-.8.09z"
	})), 'FilterVintageTwoTone');
	
	exports.default = _default;

/***/ },
/* 2941 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 19.59V8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L20 19.59zM9 13c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
	}), 'FindInPage');
	
	exports.default = _default;

/***/ },
/* 2942 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 4h7l5 5v8.58l-1.84-1.84c1.28-1.94 1.07-4.57-.64-6.28C14.55 8.49 13.28 8 12 8c-1.28 0-2.55.49-3.53 1.46-1.95 1.95-1.95 5.11 0 7.05.97.97 2.25 1.46 3.53 1.46.96 0 1.92-.28 2.75-.83L17.6 20H6V4zm8.11 11.1c-.56.56-1.31.88-2.11.88s-1.55-.31-2.11-.88c-.56-.56-.88-1.31-.88-2.11s.31-1.55.88-2.11c.56-.57 1.31-.88 2.11-.88s1.55.31 2.11.88c.56.56.88 1.31.88 2.11s-.31 1.55-.88 2.11z"
	}), 'FindInPageOutlined');
	
	exports.default = _default;

/***/ },
/* 2943 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 19.59V8.83c0-.53-.21-1.04-.59-1.41l-4.83-4.83c-.37-.38-.88-.59-1.41-.59H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.86.56-1.89.88-3 .82-2.37-.11-4.4-1.96-4.72-4.31-.44-3.35 2.45-6.18 5.83-5.61 1.95.33 3.57 1.85 4 3.78.33 1.46.01 2.82-.7 3.9L20 19.59zM9 13c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
	}), 'FindInPageRounded');
	
	exports.default = _default;

/***/ },
/* 2944 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 19.59V8l-6-6H4v20l15.57-.02-4.81-4.81c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L20 19.59zM9 13c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
	}), 'FindInPageSharp');
	
	exports.default = _default;

/***/ },
/* 2945 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 4v16h11.6l-2.85-2.85c-.83.55-1.79.83-2.75.83-1.28 0-2.55-.49-3.53-1.46-1.95-1.95-1.95-5.11 0-7.05C9.45 8.49 10.72 8 12 8c1.28 0 2.55.49 3.53 1.46 1.71 1.71 1.92 4.34.64 6.28L18 17.58V9l-5-5H6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 15.58l-1.84-1.84c1.28-1.94 1.07-4.57-.64-6.28C14.55 8.49 13.28 8 12 8c-1.28 0-2.55.49-3.53 1.46-1.95 1.95-1.95 5.11 0 7.05.97.97 2.25 1.46 3.53 1.46.96 0 1.92-.28 2.75-.83L17.6 20H6V4h7l5 5v8.58zm-3.01-4.59c0 .8-.31 1.55-.88 2.11-.56.56-1.31.88-2.11.88s-1.55-.31-2.11-.88c-.56-.56-.88-1.31-.88-2.11s.31-1.55.88-2.11S11.2 10 12 10s1.55.31 2.11.88c.57.56.88 1.31.88 2.11z"
	})), 'FindInPageTwoTone');
	
	exports.default = _default;

/***/ },
/* 2946 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05C14.68 4.78 12.93 4 11 4c-3.53 0-6.43 2.61-6.92 6H6.1c.46-2.28 2.48-4 4.9-4zm5.64 9.14c.66-.9 1.12-1.97 1.28-3.14H15.9c-.46 2.28-2.48 4-4.9 4-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05C7.32 17.22 9.07 18 11 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z"
	}), 'FindReplace');
	
	exports.default = _default;

/***/ },
/* 2947 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05C14.68 4.78 12.93 4 11 4c-3.53 0-6.43 2.61-6.92 6H6.1c.46-2.28 2.48-4 4.9-4zm5.64 9.14c.66-.9 1.12-1.97 1.28-3.14H15.9c-.46 2.28-2.48 4-4.9 4-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05C7.32 17.22 9.07 18 11 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z"
	}), 'FindReplaceOutlined');
	
	exports.default = _default;

/***/ },
/* 2948 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 6c1.38 0 2.63.56 3.54 1.46l-1.69 1.69c-.31.31-.09.85.36.85h4.29c.28 0 .5-.22.5-.5V5.21c0-.45-.54-.67-.85-.35l-1.2 1.2C14.68 4.78 12.93 4 11 4 7.96 4 5.38 5.94 4.42 8.64c-.24.66.23 1.36.93 1.36.42 0 .79-.26.93-.66C6.96 7.4 8.82 6 11 6zm5.64 9.14c.4-.54.72-1.15.95-1.8.23-.65-.25-1.34-.94-1.34-.42 0-.79.26-.93.66C15.04 14.6 13.18 16 11 16c-1.38 0-2.63-.56-3.54-1.46l1.69-1.69c.31-.31.09-.85-.36-.85H4.5c-.28 0-.5.22-.5.5v4.29c0 .45.54.67.85.35l1.2-1.2C7.32 17.22 9.07 18 11 18c1.55 0 2.98-.51 4.14-1.36l4.11 4.11c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49l-4.1-4.12z"
	}), 'FindReplaceRounded');
	
	exports.default = _default;

/***/ },
/* 2949 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05C14.68 4.78 12.93 4 11 4c-3.53 0-6.43 2.61-6.92 6H6.1c.46-2.28 2.48-4 4.9-4zm5.64 9.14c.66-.9 1.12-1.97 1.28-3.14H15.9c-.46 2.28-2.48 4-4.9 4-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05C7.32 17.22 9.07 18 11 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z"
	}), 'FindReplaceSharp');
	
	exports.default = _default;

/***/ },
/* 2950 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05C14.68 4.78 12.93 4 11 4c-3.53 0-6.43 2.61-6.92 6H6.1c.46-2.28 2.48-4 4.9-4zm5.64 9.14c.66-.9 1.12-1.97 1.28-3.14H15.9c-.46 2.28-2.48 4-4.9 4-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05C7.32 17.22 9.07 18 11 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z"
	}), 'FindReplaceTwoTone');
	
	exports.default = _default;

/***/ },
/* 2951 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z"
	}), 'Fingerprint');
	
	exports.default = _default;

/***/ },
/* 2952 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39s-4.66 1.97-4.66 4.39c0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94s3.08 1.32 3.08 2.94c0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z"
	}), 'FingerprintOutlined');
	
	exports.default = _default;

/***/ },
/* 2953 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39s-4.66 1.97-4.66 4.39c0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94s3.08 1.32 3.08 2.94c0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z"
	}), 'FingerprintRounded');
	
	exports.default = _default;

/***/ },
/* 2954 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39s-4.66 1.97-4.66 4.39c0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94s3.08 1.32 3.08 2.94c0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z"
	}), 'FingerprintSharp');
	
	exports.default = _default;

/***/ },
/* 2955 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39s-4.66 1.97-4.66 4.39c0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94s3.08 1.32 3.08 2.94c0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z"
	}), 'FingerprintTwoTone');
	
	exports.default = _default;

/***/ },
/* 2956 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 2v20h20V2H2zm9.86 14.96c.76-.24 1.4-1.04 1.53-1.63.13-.56-.1-1.05-.2-1.6-.08-.46-.07-.85.08-1.28.54 1.21 2.15 1.64 1.98 3.18-.19 1.7-2.11 2.38-3.39 1.33zM20 20h-2v-2h-2.02c.63-.84 1.02-1.87 1.02-3 0-1.89-1.09-2.85-1.85-3.37C12.2 9.61 13 7 13 7c-6.73 3.57-6.02 7.47-6 8 .03.96.49 2.07 1.23 3H6v2H4V4h16v16z"
	}), 'Fireplace');
	
	exports.default = _default;

/***/ },
/* 2957 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12.01 12.46c-.15.42-.15.82-.08 1.28.1.55.33 1.04.2 1.6-.13.59-.77 1.38-1.53 1.63 1.28 1.05 3.2.37 3.39-1.32.17-1.54-1.44-1.98-1.98-3.19z"
	}), _react.default.createElement("path", {
	  d: "M2 2v20h20V2H2zm10 16c-1.58 0-2.97-1.88-3-3.06 0-.05-.01-.13-.01-.22-.13-1.73 1-3.2 2.47-4.37.47 1.01 1.27 2.03 2.57 2.92.58.42.97.86.97 1.73 0 1.65-1.35 3-3 3zm8 2h-2v-2h-2.02c.63-.84 1.02-1.87 1.02-3 0-1.89-1.09-2.85-1.85-3.37C12.2 9.61 13 7 13 7c-6.73 3.57-6.02 7.47-6 8 .03.96.49 2.07 1.23 3H6v2H4V4h16v16z"
	})), 'FireplaceOutlined');
	
	exports.default = _default;

/***/ },
/* 2958 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 17c0 .55-.45 1-1 1h-1v-1c0-.55-.45-1-1-1h-1.15c.71-.85 1.15-1.89 1.15-3 0-1.89-1.09-2.84-1.85-3.36-1.86-1.27-2.23-2.78-2.25-3.72-.01-.4-.43-.63-.77-.43-5.8 3.43-5.15 7-5.13 7.51.03.96.49 2.07 1.24 3H7c-.55 0-1 .45-1 1v1H5c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v14zm-6.8-5.26c-.08-.46-.07-.85.08-1.28.54 1.21 2.15 1.64 1.98 3.18-.19 1.69-2.11 2.37-3.39 1.32.76-.24 1.4-1.04 1.53-1.63.12-.55-.11-1.04-.2-1.59z"
	}), 'FireplaceRounded');
	
	exports.default = _default;

/***/ },
/* 2959 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 2v20h20V2H2zm11.2 11.74c-.08-.46-.07-.85.08-1.28.54 1.21 2.15 1.64 1.98 3.18-.19 1.69-2.11 2.37-3.39 1.32.76-.24 1.4-1.04 1.53-1.63.12-.55-.11-1.04-.2-1.59zM20 20h-2v-2h-2.02c.63-.84 1.02-1.87 1.02-3 0-1.89-1.09-2.85-1.85-3.37C12.2 9.61 13 7 13 7c-6.73 3.57-6.02 7.47-6 8 .03.96.49 2.07 1.23 3H6v2H4V4h16v16z"
	}), 'FireplaceSharp');
	
	exports.default = _default;

/***/ },
/* 2960 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 20h2v-2h2.23c-.75-.93-1.2-2.04-1.23-3-.02-.53-.73-4.43 6-8 0 0-.8 2.61 2.15 4.63.76.52 1.85 1.48 1.85 3.37 0 1.13-.39 2.16-1.02 3H18v2h2V4H4v16z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12.01 12.46c-.15.42-.15.82-.08 1.28.1.55.33 1.04.2 1.6-.13.59-.77 1.38-1.53 1.63 1.28 1.05 3.2.37 3.39-1.32.17-1.54-1.44-1.98-1.98-3.19z"
	}), _react.default.createElement("path", {
	  d: "M2 2v20h20V2H2zm10 16c-1.58 0-2.97-1.88-3-3.06 0-.05-.01-.13-.01-.22-.13-1.73 1-3.2 2.47-4.37.47 1.01 1.27 2.03 2.57 2.92.58.42.97.86.97 1.73 0 1.65-1.35 3-3 3zm8 2h-2v-2h-2.02c.63-.84 1.02-1.87 1.02-3 0-1.89-1.09-2.85-1.85-3.37C12.2 9.61 13 7 13 7c-6.73 3.57-6.02 7.47-6 8 .03.96.49 2.07 1.23 3H6v2H4V4h16v16z"
	})), 'FireplaceTwoTone');
	
	exports.default = _default;

/***/ },
/* 2961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
	}), 'FirstPage');
	
	exports.default = _default;

/***/ },
/* 2962 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6 1.41-1.41zM6 6h2v12H6V6z"
	}), 'FirstPageOutlined');
	
	exports.default = _default;

/***/ },
/* 2963 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.7 15.89L13.82 12l3.89-3.89c.39-.39.39-1.02 0-1.41a.9959.9959 0 00-1.41 0l-4.59 4.59c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .38-.38.38-1.02-.01-1.4zM7 6c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1s-1-.45-1-1V7c0-.55.45-1 1-1z"
	}), 'FirstPageRounded');
	
	exports.default = _default;

/***/ },
/* 2964 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6 1.41-1.41zM6 6h2v12H6V6z"
	}), 'FirstPageSharp');
	
	exports.default = _default;

/***/ },
/* 2965 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6 1.41-1.41zM6 6h2v12H6V6z"
	}), 'FirstPageTwoTone');
	
	exports.default = _default;

/***/ },
/* 2966 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z"
	}), 'FitnessCenter');
	
	exports.default = _default;

/***/ },
/* 2967 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29l-1.43-1.43z"
	}), 'FitnessCenterOutlined');
	
	exports.default = _default;

/***/ },
/* 2968 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.57 14.86l.72-.72c.39-.39.39-1.02 0-1.41l-.02-.02a.9959.9959 0 00-1.41 0L17 15.57 8.43 7l2.86-2.86c.39-.39.39-1.02 0-1.41l-.02-.02a.9959.9959 0 00-1.41 0l-.72.72-.72-.72c-.39-.39-1.03-.39-1.42 0L5.57 4.14l-.72-.72c-.39-.39-1.04-.39-1.43 0-.39.39-.39 1.04 0 1.43l.72.72L2.71 7c-.39.39-.39 1.02 0 1.41l.72.72-.72.73c-.39.39-.39 1.02 0 1.41l.02.02c.39.39 1.02.39 1.41 0L7 8.43 15.57 17l-2.86 2.86c-.39.39-.39 1.02 0 1.41l.02.02c.39.39 1.02.39 1.41 0l.72-.72.72.72c.39.39 1.02.39 1.41 0l1.43-1.43.72.72c.39.39 1.04.39 1.43 0 .39-.39.39-1.04 0-1.43l-.72-.72L21.29 17c.39-.39.39-1.02 0-1.41l-.72-.73z"
	}), 'FitnessCenterRounded');
	
	exports.default = _default;

/***/ },
/* 2969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29l-1.43-1.43z"
	}), 'FitnessCenterSharp');
	
	exports.default = _default;

/***/ },
/* 2970 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29l-1.43-1.43z"
	}), 'FitnessCenterTwoTone');
	
	exports.default = _default;

/***/ },
/* 2971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"
	}), 'Flag');
	
	exports.default = _default;

/***/ },
/* 2972 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.36 6l.4 2H18v6h-3.36l-.4-2H7V6h5.36M14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6L14 4z"
	}), 'FlagOutlined');
	
	exports.default = _default;

/***/ },
/* 2973 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.4 6l-.24-1.2c-.09-.46-.5-.8-.98-.8H6c-.55 0-1 .45-1 1v15c0 .55.45 1 1 1s1-.45 1-1v-6h5.6l.24 1.2c.09.47.5.8.98.8H19c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1h-4.6z"
	}), 'FlagRounded');
	
	exports.default = _default;

/***/ },
/* 2974 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6z"
	}), 'FlagSharp');
	
	exports.default = _default;

/***/ },
/* 2975 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12.36 6H7v6h7.24l.4 2H18V8h-5.24z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6zm3.6 8h-3.36l-.4-2H7V6h5.36l.4 2H18v6z"
	})), 'FlagTwoTone');
	
	exports.default = _default;

/***/ },
/* 2976 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 11H1v2h6v-2zm2.17-3.24L7.05 5.64 5.64 7.05l2.12 2.12 1.41-1.41zM13 1h-2v6h2V1zm5.36 6.05l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM17 11v2h6v-2h-6zm-5-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm2.83 7.24l2.12 2.12 1.41-1.41-2.12-2.12-1.41 1.41zm-9.19.71l1.41 1.41 2.12-2.12-1.41-1.41-2.12 2.12zM11 23h2v-6h-2v6z"
	}), 'Flare');
	
	exports.default = _default;

/***/ },
/* 2977 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 11H1v2h6v-2zm2.17-3.24L7.05 5.64 5.64 7.05l2.12 2.12 1.41-1.41zM13 1h-2v6h2V1zm5.36 6.05l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM17 11v2h6v-2h-6zm-5-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm2.83 7.24l2.12 2.12 1.41-1.41-2.12-2.12-1.41 1.41zm-9.19.71l1.41 1.41 2.12-2.12-1.41-1.41-2.12 2.12zM11 23h2v-6h-2v6z"
	}), 'FlareOutlined');
	
	exports.default = _default;

/***/ },
/* 2978 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 11H2c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1zm2.47-3.94l-.72-.72a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l.71.71c.39.39 1.02.39 1.41 0 .39-.38.39-1.02.01-1.4zM12 1c-.56 0-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1zm5.66 5.35a.9959.9959 0 00-1.41 0l-.71.71c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l.71-.71c.38-.39.38-1.03 0-1.41zM17 12c0 .56.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1zm-5-3c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm3.53 7.94l.71.71c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41l-.71-.71a.9959.9959 0 00-1.41 0c-.38.39-.38 1.03 0 1.41zm-9.19.71c.39.39 1.02.39 1.41 0l.71-.71c.39-.39.39-1.02 0-1.41a.9959.9959 0 00-1.41 0l-.71.71c-.38.39-.38 1.03 0 1.41zM12 23c.56 0 1-.45 1-1v-4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1z"
	}), 'FlareRounded');
	
	exports.default = _default;

/***/ },
/* 2979 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 11H1v2h6v-2zm2.17-3.24L7.05 5.64 5.64 7.05l2.12 2.12 1.41-1.41zM13 1h-2v6h2V1zm5.36 6.05l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM17 11v2h6v-2h-6zm-5-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm2.83 7.24l2.12 2.12 1.41-1.41-2.12-2.12-1.41 1.41zm-9.19.71l1.41 1.41 2.12-2.12-1.41-1.41-2.12 2.12zM11 23h2v-6h-2v6z"
	}), 'FlareSharp');
	
	exports.default = _default;

/***/ },
/* 2980 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.644 7.05L7.05 5.645l2.123 2.122-1.408 1.407zM11 1h2v6h-2zm5.242 13.834l2.12 2.12-1.406 1.408-2.12-2.12zM14.834 7.76l2.12-2.123 1.41 1.407-2.123 2.122zm-5.668 8.482l-2.122 2.12-1.407-1.406 2.122-2.122zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm-1 8h2v6h-2zM1 11h6v2H1zm16 0h6v2h-6z"
	}), 'FlareTwoTone');
	
	exports.default = _default;

/***/ },
/* 2981 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 2v12h3v9l7-12H9l4-9H3zm16 0h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2zm-2.15 5.65L18 4l1.15 3.65h-2.3z"
	}), 'FlashAuto');
	
	exports.default = _default;

/***/ },
/* 2982 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 2v12h3v9l7-12H9l4-9H3zm16 0h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2zm-2.15 5.65L18 4l1.15 3.65h-2.3z"
	}), 'FlashAutoOutlined');
	
	exports.default = _default;

/***/ },
/* 2983 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 3v10c0 .55.45 1 1 1h2v7.15c0 .51.67.69.93.25l5.19-8.9c.39-.67-.09-1.5-.86-1.5H9l3.38-7.59c.29-.67-.2-1.41-.92-1.41H4c-.55 0-1 .45-1 1zm15-1c-.6 0-1.13.38-1.34.94L14.22 9.8c-.2.59.23 1.2.85 1.2.38 0 .72-.24.84-.6L16.4 9h3.2l.49 1.4c.13.36.46.6.84.6.62 0 1.05-.61.84-1.19l-2.44-6.86C19.13 2.38 18.6 2 18 2zm-1.15 5.65L18 4l1.15 3.65h-2.3z"
	}), 'FlashAutoRounded');
	
	exports.default = _default;

/***/ },
/* 2984 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 2v12h3v9l7-12H9l4-9H3zm16 0h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2zm-2.15 5.65L18 4l1.15 3.65h-2.3z"
	}), 'FlashAutoSharp');
	
	exports.default = _default;

/***/ },
/* 2985 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 2v12h3v9l7-12H9l4-9zm14 0l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2h-2zm-.15 5.65L18 4l1.15 3.65h-2.3z"
	}), 'FlashAutoTwoTone');
	
	exports.default = _default;

/***/ },
/* 2986 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.27 3L2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73 3.27 3zM17 10h-4l4-8H7v2.18l8.46 8.46L17 10z"
	}), 'FlashOff');
	
	exports.default = _default;

/***/ },
/* 2987 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 10h-3.61l2.28 2.28zm0-8H7v1.61l6.13 6.13zm-13.59.86L2 4.27l5 5V13h3v9l3.58-6.15L17.73 20l1.41-1.41z"
	}), 'FlashOffOutlined');
	
	exports.default = _default;

/***/ },
/* 2988 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.12 11.5c.39-.67-.09-1.5-.86-1.5h-1.87l2.28 2.28.45-.78zm.16-8.05c.33-.67-.15-1.45-.9-1.45H8c-.55 0-1 .45-1 1v.61l6.13 6.13 3.15-6.29zm2.16 14.43L4.12 3.56a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L7 9.27V12c0 .55.45 1 1 1h2v7.15c0 .51.67.69.93.25l2.65-4.55 3.44 3.44c.39.39 1.02.39 1.41 0 .4-.39.4-1.02.01-1.41z"
	}), 'FlashOffRounded');
	
	exports.default = _default;

/***/ },
/* 2989 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 10h-3.61l2.28 2.28zm0-8H7v1.61l6.13 6.13zm-13.59.86L2 4.27l5 5V13h3v9l3.58-6.15L17.73 20l1.41-1.41z"
	}), 'FlashOffSharp');
	
	exports.default = _default;

/***/ },
/* 2990 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 10h-3.61l2.28 2.28zm0-8H7v1.61l6.13 6.13zm-13.59.86L2 4.27l5 5V13h3v9l3.58-6.15L17.73 20l1.41-1.41z"
	}), 'FlashOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 2991 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 2v11h3v9l7-12h-4l4-8z"
	}), 'FlashOn');
	
	exports.default = _default;

/***/ },
/* 2992 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 2v11h3v9l7-12h-4l3-8z"
	}), 'FlashOnOutlined');
	
	exports.default = _default;

/***/ },
/* 2993 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 3v9c0 .55.45 1 1 1h2v7.15c0 .51.67.69.93.25l5.19-8.9c.39-.67-.09-1.5-.86-1.5H13l2.49-6.65c.25-.65-.23-1.35-.93-1.35H8c-.55 0-1 .45-1 1z"
	}), 'FlashOnRounded');
	
	exports.default = _default;

/***/ },
/* 2994 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 2v11h3v9l7-12h-4l3-8z"
	}), 'FlashOnSharp');
	
	exports.default = _default;

/***/ },
/* 2995 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 10h-4l3-8H7v11h3v9z"
	}), 'FlashOnTwoTone');
	
	exports.default = _default;

/***/ },
/* 2996 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
	}), 'Flight');
	
	exports.default = _default;

/***/ },
/* 2997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.5 19h19v2h-19v-2zm16.84-3.15c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l16.57 4.44z"
	}), 'FlightLand');
	
	exports.default = _default;

/***/ },
/* 2998 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.5 19h19v2h-19v-2zm16.84-3.15c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l16.57 4.44z"
	}), 'FlightLandOutlined');
	
	exports.default = _default;

/***/ },
/* 2999 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.5 19h-17c-.55 0-1 .45-1 1s.45 1 1 1h17c.55 0 1-.45 1-1s-.45-1-1-1zM3.51 11.61l15.83 4.24c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.58-8.45c-.11-.36-.39-.63-.75-.73-.68-.18-1.35.33-1.35 1.04v6.88L5.15 8.95 4.4 7.09c-.12-.29-.36-.51-.67-.59l-.33-.09c-.32-.09-.63.15-.63.48v3.75c0 .46.3.85.74.97z"
	}), 'FlightLandRounded');
	
	exports.default = _default;

/***/ },
/* 3000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.5 19h19v2h-19v-2zm16.84-3.15c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l16.57 4.44z"
	}), 'FlightLandSharp');
	
	exports.default = _default;

/***/ },
/* 3001 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.5 19h19v2h-19v-2zm16.84-3.15c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l16.57 4.44z"
	}), 'FlightLandTwoTone');
	
	exports.default = _default;

/***/ },
/* 3002 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
	}), 'FlightOutlined');
	
	exports.default = _default;

/***/ },
/* 3003 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 14.58c0-.36-.19-.69-.49-.89L13 9V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-7.51 4.69c-.3.19-.49.53-.49.89 0 .7.68 1.21 1.36 1L10 13.5V19l-1.8 1.35c-.13.09-.2.24-.2.4v.59c0 .33.32.57.64.48L11.5 21l2.86.82c.32.09.64-.15.64-.48v-.59c0-.16-.07-.31-.2-.4L13 19v-5.5l6.64 2.08c.68.21 1.36-.3 1.36-1z"
	}), 'FlightRounded');
	
	exports.default = _default;

/***/ },
/* 3004 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
	}), 'FlightSharp');
	
	exports.default = _default;

/***/ },
/* 3005 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.5 19h19v2h-19v-2zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 2.59 4.49s7.12-1.9 16.57-4.43c.81-.23 1.28-1.05 1.07-1.85z"
	}), 'FlightTakeoff');
	
	exports.default = _default;

/***/ },
/* 3006 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.5 19h19v2h-19v-2zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 2.59 4.49L21 11.49c.81-.23 1.28-1.05 1.07-1.85z"
	}), 'FlightTakeoffOutlined');
	
	exports.default = _default;

/***/ },
/* 3007 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.5 19h-17c-.55 0-1 .45-1 1s.45 1 1 1h17c.55 0 1-.45 1-1s-.45-1-1-1zm1.57-9.36c-.22-.8-1.04-1.27-1.84-1.06L14.92 10 8.46 3.98c-.27-.26-.66-.35-1.02-.25-.68.19-1 .97-.65 1.58l3.44 5.96-4.97 1.33-1.57-1.24c-.25-.19-.57-.26-.88-.18l-.33.09c-.32.08-.47.45-.3.73l1.88 3.25c.23.39.69.58 1.12.47L21 11.48c.8-.22 1.28-1.04 1.07-1.84z"
	}), 'FlightTakeoffRounded');
	
	exports.default = _default;

/***/ },
/* 3008 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.5 19h19v2h-19v-2zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 1.82 3.16.77 1.33L21 11.49c.81-.23 1.28-1.05 1.07-1.85z"
	}), 'FlightTakeoffSharp');
	
	exports.default = _default;

/***/ },
/* 3009 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.5 19h19v2h-19v-2zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 2.59 4.49L21 11.49c.81-.23 1.28-1.05 1.07-1.85z"
	}), 'FlightTakeoffTwoTone');
	
	exports.default = _default;

/***/ },
/* 3010 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19z"
	}), 'FlightTwoTone');
	
	exports.default = _default;

/***/ },
/* 3011 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z"
	}), 'Flip');
	
	exports.default = _default;

/***/ },
/* 3012 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9 12c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
	}), _react.default.createElement("path", {
	  d: "M8 10V8H5.09C6.47 5.61 9.05 4 12 4c3.72 0 6.85 2.56 7.74 6h2.06c-.93-4.56-4.96-8-9.8-8-3.27 0-6.18 1.58-8 4.01V4H2v6h6zM16 14v2h2.91c-1.38 2.39-3.96 4-6.91 4-3.72 0-6.85-2.56-7.74-6H2.2c.93 4.56 4.96 8 9.8 8 3.27 0 6.18-1.58 8-4.01V20h2v-6h-6z"
	})), 'FlipCameraAndroid');
	
	exports.default = _default;

/***/ },
/* 3013 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9 12c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3zm4 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1z"
	}), _react.default.createElement("path", {
	  d: "M8 10V8H5.09C6.47 5.61 9.05 4 12 4c3.72 0 6.85 2.56 7.74 6h2.06c-.93-4.56-4.96-8-9.8-8-3.27 0-6.18 1.58-8 4.01V4H2v6h6zM16 14v2h2.91c-1.38 2.39-3.96 4-6.91 4-3.72 0-6.85-2.56-7.74-6H2.2c.93 4.56 4.96 8 9.8 8 3.27 0 6.18-1.58 8-4.01V20h2v-6h-6z"
	})), 'FlipCameraAndroidOutlined');
	
	exports.default = _default;

/***/ },
/* 3014 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9 12c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
	}), _react.default.createElement("path", {
	  d: "M8 9c0-.55-.45-1-1-1H5.09C6.47 5.61 9.05 4 12 4c3.49 0 6.45 2.24 7.54 5.36.14.39.53.64.94.64.68 0 1.18-.67.96-1.31C20.07 4.79 16.36 2 12 2 8.73 2 5.82 3.58 4 6.01V5c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1zM16 15c0 .55.45 1 1 1h1.91c-1.38 2.39-3.96 4-6.91 4-3.49 0-6.45-2.24-7.54-5.36-.14-.39-.53-.64-.94-.64-.68 0-1.18.67-.96 1.31C3.93 19.21 7.64 22 12 22c3.27 0 6.18-1.58 8-4.01V19c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1z"
	})), 'FlipCameraAndroidRounded');
	
	exports.default = _default;

/***/ },
/* 3015 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9 12c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
	}), _react.default.createElement("path", {
	  d: "M8 10V8H5.09C6.47 5.61 9.05 4 12 4c3.72 0 6.85 2.56 7.74 6h2.06c-.93-4.56-4.96-8-9.8-8-3.27 0-6.18 1.58-8 4.01V4H2v6h6zM16 14v2h2.91c-1.38 2.39-3.96 4-6.91 4-3.72 0-6.85-2.56-7.74-6H2.2c.93 4.56 4.96 8 9.8 8 3.27 0 6.18-1.58 8-4.01V20h2v-6h-6z"
	})), 'FlipCameraAndroidSharp');
	
	exports.default = _default;

/***/ },
/* 3016 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "1",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9 12c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3zm4 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1z"
	}), _react.default.createElement("path", {
	  d: "M8 8H5.09C6.47 5.61 9.05 4 12 4c3.72 0 6.85 2.56 7.74 6h2.06c-.93-4.56-4.96-8-9.8-8-3.27 0-6.18 1.58-8 4.01V4H2v6h6V8zM16 14v2h2.91c-1.38 2.39-3.96 4-6.91 4-3.72 0-6.85-2.56-7.74-6H2.2c.93 4.56 4.96 8 9.8 8 3.27 0 6.18-1.58 8-4.01V20h2v-6h-6z"
	})), 'FlipCameraAndroidTwoTone');
	
	exports.default = _default;

/***/ },
/* 3017 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-8 13c-2.76 0-5-2.24-5-5H5l2.5-2.5L10 13H8c0 2.21 1.79 4 4 4 .58 0 1.13-.13 1.62-.35l.74.74c-.71.37-1.5.61-2.36.61zm4.5-2.5L14 13h2c0-2.21-1.79-4-4-4-.58 0-1.13.13-1.62.35l-.74-.73C10.35 8.24 11.14 8 12 8c2.76 0 5 2.24 5 5h2l-2.5 2.5z"
	}), 'FlipCameraIos');
	
	exports.default = _default;

/***/ },
/* 3018 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14H4V7h4.05l.59-.65L9.88 5h4.24l1.24 1.35.59.65H20v12z"
	}), _react.default.createElement("path", {
	  d: "M12 17c-2.21 0-4-1.79-4-4h2l-2.5-2.5L5 13h2c0 2.76 2.24 5 5 5 .86 0 1.65-.24 2.36-.62l-.74-.74c-.49.23-1.04.36-1.62.36zM12 8c-.86 0-1.65.24-2.36.62l.74.73C10.87 9.13 11.42 9 12 9c2.21 0 4 1.79 4 4h-2l2.5 2.5L19 13h-2c0-2.76-2.24-5-5-5z"
	})), 'FlipCameraIosOutlined');
	
	exports.default = _default;

/***/ },
/* 3019 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 5h-3.17l-1.24-1.35c-.37-.41-.91-.65-1.47-.65H9.88c-.56 0-1.1.24-1.48.65L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-6.33 12.7c-.52.19-1.08.3-1.67.3-2.76 0-5-2.24-5-5H5l2.5-2.5L10 13H8c0 2.21 1.79 4 4 4 .46 0 .91-.08 1.32-.23.19-.07.39-.03.53.11.26.26.16.69-.18.82zm2.83-2.2L14 13h2c0-2.21-1.79-4-4-4-.46 0-.91.08-1.32.23-.19.07-.39.03-.53-.11-.26-.26-.16-.69.18-.82.52-.19 1.08-.3 1.67-.3 2.76 0 5 2.24 5 5h2l-2.5 2.5z"
	}), 'FlipCameraIosRounded');
	
	exports.default = _default;

/***/ },
/* 3020 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.83 5L15 3H9L7.17 5H2v16h20V5h-5.17zM12 18c-2.76 0-5-2.24-5-5H5l2.5-2.5L10 13H8c0 2.21 1.79 4 4 4 .58 0 1.13-.13 1.62-.35l.74.74c-.71.37-1.5.61-2.36.61zm4.5-2.5L14 13h2c0-2.21-1.79-4-4-4-.58 0-1.13.13-1.62.35l-.74-.73C10.35 8.24 11.14 8 12 8c2.76 0 5 2.24 5 5h2l-2.5 2.5z"
	}), 'FlipCameraIosSharp');
	
	exports.default = _default;

/***/ },
/* 3021 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14.12 5H9.88L8.05 7H4v12h16V7h-4.05l-1.83-2zM12 18c-2.76 0-5-2.24-5-5H5l2.49-2.49.01-.01L10 13H8c0 2.21 1.79 4 4 4 .58 0 1.13-.13 1.62-.35l.74.74c-.71.37-1.5.61-2.36.61zm7-5l-2.49 2.49-.01.01L14 13h2c0-2.21-1.79-4-4-4-.58 0-1.13.13-1.62.35l-.74-.73C10.35 8.24 11.14 8 12 8c2.76 0 5 2.24 5 5h2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14H4V7h4.05l1.83-2h4.24l1.83 2H20v12z"
	}), _react.default.createElement("path", {
	  d: "M12 17c-2.21 0-4-1.79-4-4h2l-2.5-2.5-.01.01L5 13h2c0 2.76 2.24 5 5 5 .86 0 1.65-.24 2.36-.62l-.74-.74c-.49.23-1.04.36-1.62.36zM12 8c-.86 0-1.65.24-2.36.62l.74.73C10.87 9.13 11.42 9 12 9c2.21 0 4 1.79 4 4h-2l2.5 2.5.01-.01L19 13h-2c0-2.76-2.24-5-5-5z"
	})), 'FlipCameraIosTwoTone');
	
	exports.default = _default;

/***/ },
/* 3022 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z"
	}), 'FlipOutlined');
	
	exports.default = _default;

/***/ },
/* 3023 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h3c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h2c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-7 20c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1v20c0 .55.45 1 1 1zm7-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z"
	}), 'FlipRounded');
	
	exports.default = _default;

/***/ },
/* 3024 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 3v18h6v-2H5V5h4V3H3zm16 0v2h2V3h-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8h2v-2h-2v2z"
	}), 'FlipSharp');
	
	exports.default = _default;

/***/ },
/* 3025 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 7H7v2h2V7zm0 4H7v2h2v-2zm0-8c-1.11 0-2 .9-2 2h2V3zm4 12h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6 0h-2v2h2V3zM9 17v-2H7c0 1.1.89 2 2 2zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zM5 7H3v12c0 1.1.89 2 2 2h12v-2H5V7zm10-2h2V3h-2v2zm0 12h2v-2h-2v2z"
	}), 'FlipToBack');
	
	exports.default = _default;

/***/ },
/* 3026 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 7H7v2h2V7zm0 4H7v2h2v-2zm0-8c-1.11 0-2 .9-2 2h2V3zm4 12h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6 0h-2v2h2V3zM9 17v-2H7c0 1.1.89 2 2 2zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zM5 7H3v12c0 1.1.89 2 2 2h12v-2H5V7zm10-2h2V3h-2v2zm0 12h2v-2h-2v2z"
	}), 'FlipToBackOutlined');
	
	exports.default = _default;

/***/ },
/* 3027 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 7H7v2h2V7zm0 4H7v2h2v-2zm0-8c-1.11 0-2 .9-2 2h2V3zm4 12h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6 0h-2v2h2V3zM9 17v-2H7c0 1.1.89 2 2 2zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zM4 7c-.55 0-1 .45-1 1v11c0 1.1.9 2 2 2h11c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1-.45-1-1V8c0-.55-.45-1-1-1zm11-2h2V3h-2v2zm0 12h2v-2h-2v2z"
	}), 'FlipToBackRounded');
	
	exports.default = _default;

/***/ },
/* 3028 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 7H7v2h2V7zm0 4H7v2h2v-2zm4 4h-2v2h2v-2zm0-12h-2v2h2V3zM9 3H7v2h2V3zm12 0h-2v2h2V3zm0 12h-2v2h2v-2zM9 15H7v2h2v-2zm10-2h2v-2h-2v2zm0-4h2V7h-2v2zM5 7H3v14h14v-2H5V7zm10-2h2V3h-2v2zm0 12h2v-2h-2v2z"
	}), 'FlipToBackSharp');
	
	exports.default = _default;

/***/ },
/* 3029 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 7H7v2h2V7zm0 4H7v2h2v-2zm0-8c-1.11 0-2 .9-2 2h2V3zm4 12h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6 0h-2v2h2V3zM9 17v-2H7c0 1.1.89 2 2 2zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zM5 7H3v12c0 1.1.89 2 2 2h12v-2H5V7zm10-2h2V3h-2v2zm0 12h2v-2h-2v2z"
	}), 'FlipToBackTwoTone');
	
	exports.default = _default;

/***/ },
/* 3030 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3c0 1.1.89 2 2 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9c-1.11 0-2 .9-2 2v10c0 1.1.89 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z"
	}), 'FlipToFront');
	
	exports.default = _default;

/***/ },
/* 3031 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3c0 1.1.89 2 2 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9c-1.11 0-2 .9-2 2v10c0 1.1.89 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z"
	}), 'FlipToFrontOutlined');
	
	exports.default = _default;

/***/ },
/* 3032 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3c0 1.1.89 2 2 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9c-1.11 0-2 .9-2 2v10c0 1.1.89 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 12h-8c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1zm-7 6h2v-2h-2v2zm-4 0h2v-2H7v2z"
	}), 'FlipToFrontRounded');
	
	exports.default = _default;

/***/ },
/* 3033 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm12 12h2v-2h-2v2zm6-18H7v14h14V3zm-2 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2zm-4 0h2v-2H3v2z"
	}), 'FlipToFrontSharp');
	
	exports.default = _default;

/***/ },
/* 3034 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3c0 1.1.89 2 2 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9c-1.11 0-2 .9-2 2v10c0 1.1.89 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z"
	}), 'FlipToFrontTwoTone');
	
	exports.default = _default;

/***/ },
/* 3035 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 7h2v2h-2zm0 14c1.1 0 2-.9 2-2h-2v2zm0-6h2v2h-2zm0-4h2v2h-2zM9 5V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4v-2H5V5h4zm10-2v2h2c0-1.1-.9-2-2-2zm-8-2h2v22h-2zm4 2h2v2h-2zm0 16h2v2h-2z"
	}), 'FlipTwoTone');
	
	exports.default = _default;

/***/ },
/* 3036 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"
	}), 'Folder');
	
	exports.default = _default;

/***/ },
/* 3037 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"
	}), 'FolderOpen');
	
	exports.default = _default;

/***/ },
/* 3038 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"
	}), 'FolderOpenOutlined');
	
	exports.default = _default;

/***/ },
/* 3039 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-8l-1.41-1.41C10.21 4.21 9.7 4 9.17 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-1 12H5c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1z"
	}), 'FolderOpenRounded');
	
	exports.default = _default;

/***/ },
/* 3040 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6H12l-2-2H2v16h20V6zm-2 12H4V8h16v10z"
	}), 'FolderOpenSharp');
	
	exports.default = _default;

/***/ },
/* 3041 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 8h16v10H4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"
	})), 'FolderOpenTwoTone');
	
	exports.default = _default;

/***/ },
/* 3042 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.17 6l2 2H20v10H4V6h5.17M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"
	}), 'FolderOutlined');
	
	exports.default = _default;

/***/ },
/* 3043 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.59 4.59C10.21 4.21 9.7 4 9.17 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-1.41-1.41z"
	}), 'FolderRounded');
	
	exports.default = _default;

/***/ },
/* 3044 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z"
	}), 'FolderShared');
	
	exports.default = _default;

/***/ },
/* 3045 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-5-5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 4h8v-1c0-1.33-2.67-2-4-2s-4 .67-4 2v1z"
	}), 'FolderSharedOutlined');
	
	exports.default = _default;

/***/ },
/* 3046 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-8l-1.41-1.41C10.21 4.21 9.7 4 9.17 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z"
	}), 'FolderSharedRounded');
	
	exports.default = _default;

/***/ },
/* 3047 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6H12l-2-2H2v16h20V6zm-7 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z"
	}), 'FolderSharedSharp');
	
	exports.default = _default;

/***/ },
/* 3048 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.17 8l-.59-.59L9.17 6H4v12h16V8h-8.83zM19 16v1h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2zm-4-7c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-5-5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 3v1h8v-1c0-1.33-2.67-2-4-2s-4 .67-4 2z"
	})), 'FolderSharedTwoTone');
	
	exports.default = _default;

/***/ },
/* 3049 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 4H2v16h20V6H12l-2-2z"
	}), 'FolderSharp');
	
	exports.default = _default;

/***/ },
/* 3050 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-2.06 11L15 15.28 12.06 17l.78-3.33-2.59-2.24 3.41-.29L15 8l1.34 3.14 3.41.29-2.59 2.24.78 3.33z"
	}), 'FolderSpecial');
	
	exports.default = _default;

/***/ },
/* 3051 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"
	}), 'FolderSpecialOutlined');
	
	exports.default = _default;

/***/ },
/* 3052 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-8l-1.41-1.41C10.21 4.21 9.7 4 9.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-3.06 10.41L15 15.28l-1.94 1.13c-.38.22-.84-.12-.74-.55l.51-2.2-1.69-1.46c-.33-.29-.16-.84.28-.88l2.23-.19.88-2.06c.17-.4.75-.4.92 0l.88 2.06 2.23.19c.44.04.62.59.28.88l-1.69 1.46.51 2.2c.11.43-.35.77-.72.55z"
	}), 'FolderSpecialRounded');
	
	exports.default = _default;

/***/ },
/* 3053 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6H12l-2-2H2v16h20V6zm-4.06 11L15 15.28 12.06 17l.78-3.33-2.59-2.24 3.41-.29L15 8l1.34 3.14 3.41.29-2.59 2.24.78 3.33z"
	}), 'FolderSpecialSharp');
	
	exports.default = _default;

/***/ },
/* 3054 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.17 8l-2-2H4v12h16V8h-8.83zM15 9l1.19 2.79 3.03.26-2.3 1.99.69 2.96L15 15.47 12.39 17l.69-2.96-2.3-1.99 3.03-.26L15 9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"
	})), 'FolderSpecialTwoTone');
	
	exports.default = _default;

/***/ },
/* 3055 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.17 8l-.58-.59L9.17 6H4v12h16V8h-8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l1.41 1.41.59.59H20v10z"
	})), 'FolderTwoTone');
	
	exports.default = _default;

/***/ },
/* 3056 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z"
	}), 'FontDownload');
	
	exports.default = _default;

/***/ },
/* 3057 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.17 15.5h5.64l1.14 3h2.09l-5.11-13h-1.86l-5.11 13h2.09l1.12-3zM12 7.98l2.07 5.52H9.93L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16z"
	}), 'FontDownloadOutlined');
	
	exports.default = _default;

/***/ },
/* 3058 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.93 13.5h4.14L12 7.98 9.93 13.5zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.29 15.88l-.9-2.38H9.17l-.89 2.37c-.14.38-.5.63-.91.63-.68 0-1.15-.69-.9-1.32l4.25-10.81c.22-.53.72-.87 1.28-.87s1.06.34 1.27.87l4.25 10.81c.25.63-.22 1.32-.9 1.32-.4 0-.76-.25-.91-.62z"
	}), 'FontDownloadRounded');
	
	exports.default = _default;

/***/ },
/* 3059 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.93 13.5h4.14L12 7.98 9.93 13.5zM22 2H2v20h20V2zm-6.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z"
	}), 'FontDownloadSharp');
	
	exports.default = _default;

/***/ },
/* 3060 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 20h16V4H4v16zm7.07-14.5h1.86l5.11 13h-2.09l-1.14-3H9.17l-1.12 3H5.96l5.11-13zM12 7.98L9.93 13.5h4.14z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9.17 15.5h5.64l1.14 3h2.09l-5.11-13h-1.86l-5.11 13h2.09l1.12-3zM12 7.98l2.07 5.52H9.93L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16z"
	})), 'FontDownloadTwoTone');
	
	exports.default = _default;

/***/ },
/* 3061 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z"
	}), 'FormatAlignCenter');
	
	exports.default = _default;

/***/ },
/* 3062 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z"
	}), 'FormatAlignCenterOutlined');
	
	exports.default = _default;

/***/ },
/* 3063 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 16c0 .55.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1zm-3 5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-8h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm3-5c0 .55.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1zM3 4c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z"
	}), 'FormatAlignCenterRounded');
	
	exports.default = _default;

/***/ },
/* 3064 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z"
	}), 'FormatAlignCenterSharp');
	
	exports.default = _default;

/***/ },
/* 3065 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 3h18v2H3zm4 12h10v2H7zm0-8h10v2H7zm-4 4h18v2H3zm0 8h18v2H3z"
	}), 'FormatAlignCenterTwoTone');
	
	exports.default = _default;

/***/ },
/* 3066 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z"
	}), 'FormatAlignJustify');
	
	exports.default = _default;

/***/ },
/* 3067 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z"
	}), 'FormatAlignJustifyOutlined');
	
	exports.default = _default;

/***/ },
/* 3068 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 21h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-4h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-4h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-4h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 4c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z"
	}), 'FormatAlignJustifyRounded');
	
	exports.default = _default;

/***/ },
/* 3069 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z"
	}), 'FormatAlignJustifySharp');
	
	exports.default = _default;

/***/ },
/* 3070 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 3h18v2H3zm0 8h18v2H3zm0 8h18v2H3zm0-4h18v2H3zm0-8h18v2H3z"
	}), 'FormatAlignJustifyTwoTone');
	
	exports.default = _default;

/***/ },
/* 3071 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z"
	}), 'FormatAlignLeft');
	
	exports.default = _default;

/***/ },
/* 3072 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z"
	}), 'FormatAlignLeftOutlined');
	
	exports.default = _default;

/***/ },
/* 3073 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 15H4c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zm0-8H4c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zM4 13h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0 8h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 4c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z"
	}), 'FormatAlignLeftRounded');
	
	exports.default = _default;

/***/ },
/* 3074 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z"
	}), 'FormatAlignLeftSharp');
	
	exports.default = _default;

/***/ },
/* 3075 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 19h18v2H3zM3 7h12v2H3zm0-4h18v2H3zm0 12h12v2H3zm0-4h18v2H3z"
	}), 'FormatAlignLeftTwoTone');
	
	exports.default = _default;

/***/ },
/* 3076 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z"
	}), 'FormatAlignRight');
	
	exports.default = _default;

/***/ },
/* 3077 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z"
	}), 'FormatAlignRightOutlined');
	
	exports.default = _default;

/***/ },
/* 3078 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 21h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm6-4h10c.55 0 1-.45 1-1s-.45-1-1-1H10c-.55 0-1 .45-1 1s.45 1 1 1zm-6-4h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm6-4h10c.55 0 1-.45 1-1s-.45-1-1-1H10c-.55 0-1 .45-1 1s.45 1 1 1zM3 4c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z"
	}), 'FormatAlignRightRounded');
	
	exports.default = _default;

/***/ },
/* 3079 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z"
	}), 'FormatAlignRightSharp');
	
	exports.default = _default;

/***/ },
/* 3080 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 3h18v2H3zm0 16h18v2H3zm0-8h18v2H3zm6 4h12v2H9zm0-8h12v2H9z"
	}), 'FormatAlignRightTwoTone');
	
	exports.default = _default;

/***/ },
/* 3081 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
	}), 'FormatBold');
	
	exports.default = _default;

/***/ },
/* 3082 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
	}), 'FormatBoldOutlined');
	
	exports.default = _default;

/***/ },
/* 3083 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H8c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h5.78c2.07 0 3.96-1.69 3.97-3.77.01-1.53-.85-2.84-2.15-3.44zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
	}), 'FormatBoldRounded');
	
	exports.default = _default;

/***/ },
/* 3084 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
	}), 'FormatBoldSharp');
	
	exports.default = _default;

/***/ },
/* 3085 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.25 8c0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42.97-.67 1.65-1.77 1.65-2.79zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
	}), 'FormatBoldTwoTone');
	
	exports.default = _default;

/***/ },
/* 3086 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5zM6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z"
	}), 'FormatClear');
	
	exports.default = _default;

/***/ },
/* 3087 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8V5H6.39l3 3h1.83l-.55 1.28 2.09 2.1L14.21 8zM3.41 4.86L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21l1.41-1.41z"
	}), 'FormatClearOutlined');
	
	exports.default = _default;

/***/ },
/* 3088 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.5 8c.83 0 1.5-.67 1.5-1.5S19.33 5 18.5 5H6.39l3 3h1.83l-.55 1.28 2.09 2.09L14.21 8h4.29zm-1.06 10.88L4.12 5.56a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l6.26 6.26-1.65 3.84c-.39.92.28 1.93 1.27 1.93.55 0 1.05-.33 1.27-.84l1.21-2.83 4.95 4.95c.39.39 1.02.39 1.41 0 .4-.38.4-1.01.01-1.4z"
	}), 'FormatClearRounded');
	
	exports.default = _default;

/***/ },
/* 3089 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8V5H6.39l3 3h1.83l-.55 1.28 2.09 2.1L14.21 8zM3.41 4.86L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21l1.41-1.41z"
	}), 'FormatClearSharp');
	
	exports.default = _default;

/***/ },
/* 3090 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8V5H6.39l3 3h1.83l-.55 1.28 2.09 2.1L14.21 8zM3.41 4.86L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21l1.41-1.41z"
	}), 'FormatClearTwoTone');
	
	exports.default = _default;

/***/ },
/* 3091 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".36",
	  d: "M0 20h24v4H0z"
	})), 'FormatColorFill');
	
	exports.default = _default;

/***/ },
/* 3092 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".36",
	  d: "M0 20h24v4H0v-4z"
	})), 'FormatColorFillOutlined');
	
	exports.default = _default;

/***/ },
/* 3093 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16.56 8.94L8.32.7a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l1.68 1.68-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".36",
	  d: "M2 20h20c1.1 0 2 .9 2 2s-.9 2-2 2H2c-1.1 0-2-.9-2-2s.9-2 2-2z"
	})), 'FormatColorFillRounded');
	
	exports.default = _default;

/***/ },
/* 3094 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17.62 10l-10-10-1.41 1.41 2.38 2.38L2.38 10 10 17.62 17.62 10zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".36",
	  d: "M0 20h24v4H0v-4z"
	})), 'FormatColorFillSharp');
	
	exports.default = _default;

/***/ },
/* 3095 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M10 5.21L5.21 10h9.58z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 17c1.1 0 2-.9 2-2 0-1.33-2-3.5-2-3.5s-2 2.17-2 3.5c0 1.1.9 2 2 2zm-10.06-.44c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5zM10 5.21L14.79 10H5.21L10 5.21z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".36",
	  d: "M0 20h24v4H0z"
	})), 'FormatColorFillTwoTone');
	
	exports.default = _default;

/***/ },
/* 3096 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 14c0-4-6-10.8-6-10.8s-1.33 1.51-2.73 3.52l8.59 8.59c.09-.42.14-.86.14-1.31zm-.88 3.12L12.5 12.5 5.27 5.27 4 6.55l3.32 3.32C6.55 11.32 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.96-1.5l2.63 2.63 1.27-1.27-2.74-2.74z"
	}), 'FormatColorReset');
	
	exports.default = _default;

/***/ },
/* 3097 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6.36c1.53 2 3.08 4.43 3.71 6.24l2.23 2.23c.03-.27.06-.55.06-.83 0-3.98-6-10.8-6-10.8s-1.18 1.35-2.5 3.19l1.44 1.44c.34-.51.7-1 1.06-1.47zM5.41 5.14L4 6.55l3.32 3.32C6.55 11.33 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.95-1.5l2.63 2.63L20 19.72 5.41 5.14zM12 18c-2.21 0-4-1.79-4-4 0-.69.32-1.62.81-2.64l5.72 5.72c-.7.56-1.57.92-2.53.92z"
	}), 'FormatColorResetOutlined');
	
	exports.default = _default;

/***/ },
/* 3098 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 14c0-3.09-3.6-7.88-5.23-9.87-.4-.49-1.15-.49-1.55 0-.46.57-1.08 1.36-1.73 2.27l8.44 8.44c.04-.28.07-.56.07-.84zm1.29 5.01L6.12 5.84a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l2.61 2.61C6.55 11.33 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.95-1.5l1.92 1.92c.39.39 1.02.39 1.41 0 .4-.38.4-1.02.01-1.41z"
	}), 'FormatColorResetRounded');
	
	exports.default = _default;

/***/ },
/* 3099 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 14c0-3.98-6-10.8-6-10.8s-1.18 1.35-2.5 3.19l8.44 8.44c.03-.27.06-.55.06-.83zM5.41 5.14L4 6.55l3.32 3.32C6.55 11.33 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.95-1.5l2.63 2.63L20 19.72 5.41 5.14z"
	}), 'FormatColorResetSharp');
	
	exports.default = _default;

/***/ },
/* 3100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M10.93 7.83l4.77 4.77c-.62-1.81-2.17-4.24-3.71-6.24-.35.47-.71.96-1.06 1.47zM12 18c.96 0 1.83-.36 2.53-.92l-5.72-5.72C8.32 12.38 8 13.31 8 14c0 2.21 1.79 4 4 4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 6.36c1.53 2 3.08 4.43 3.71 6.24l2.23 2.23c.03-.27.06-.55.06-.83 0-3.98-6-10.8-6-10.8s-1.18 1.35-2.5 3.19l1.44 1.44c.34-.51.7-1 1.06-1.47zM5.41 5.14L4 6.55l3.32 3.32C6.55 11.33 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.95-1.5l2.63 2.63L20 19.72 5.41 5.14zM12 18c-2.21 0-4-1.79-4-4 0-.69.32-1.62.81-2.64l5.72 5.72c-.7.56-1.57.92-2.53.92z"
	})), 'FormatColorResetTwoTone');
	
	exports.default = _default;

/***/ },
/* 3101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".36",
	  d: "M0 20h24v4H0z"
	}), _react.default.createElement("path", {
	  d: "M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z"
	})), 'FormatColorText');
	
	exports.default = _default;

/***/ },
/* 3102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".36",
	  d: "M0 20h24v4H0v-4z"
	}), _react.default.createElement("path", {
	  d: "M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z"
	})), 'FormatColorTextOutlined');
	
	exports.default = _default;

/***/ },
/* 3103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".36",
	  d: "M2 20h20c1.1 0 2 .9 2 2s-.9 2-2 2H2c-1.1 0-2-.9-2-2s.9-2 2-2z"
	}), _react.default.createElement("path", {
	  d: "M10.63 3.93L6.06 15.58c-.27.68.23 1.42.97 1.42.43 0 .82-.27.98-.68L8.87 14h6.25l.87 2.32c.15.41.54.68.98.68.73 0 1.24-.74.97-1.42L13.37 3.93C13.14 3.37 12.6 3 12 3c-.6 0-1.15.37-1.37.93zM9.62 12L12 5.67 14.38 12H9.62z"
	})), 'FormatColorTextRounded');
	
	exports.default = _default;

/***/ },
/* 3104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".36",
	  d: "M0 20h24v4H0v-4z"
	}), _react.default.createElement("path", {
	  d: "M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z"
	})), 'FormatColorTextSharp');
	
	exports.default = _default;

/***/ },
/* 3105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".36",
	  d: "M0 20h24v4H0z"
	}), _react.default.createElement("path", {
	  d: "M5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2L5.5 17zm8.88-5H9.62L12 5.67 14.38 12z"
	})), 'FormatColorTextTwoTone');
	
	exports.default = _default;

/***/ },
/* 3106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 17h10v-2H11v2zm-8-5l4 4V8l-4 4zm0 9h18v-2H3v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
	}), 'FormatIndentDecrease');
	
	exports.default = _default;

/***/ },
/* 3107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 17h10v-2H11v2zm-8-5l4 4V8l-4 4zm0 9h18v-2H3v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
	}), 'FormatIndentDecreaseOutlined');
	
	exports.default = _default;

/***/ },
/* 3108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 17h8c.55 0 1-.45 1-1s-.45-1-1-1h-8c-.55 0-1 .45-1 1s.45 1 1 1zm-8.65-4.65l2.79 2.79c.32.32.86.1.86-.35V9.21c0-.45-.54-.67-.85-.35l-2.79 2.79c-.2.19-.2.51-.01.7zM4 21h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 4c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1zm9 5h8c.55 0 1-.45 1-1s-.45-1-1-1h-8c-.55 0-1 .45-1 1s.45 1 1 1zm0 4h8c.55 0 1-.45 1-1s-.45-1-1-1h-8c-.55 0-1 .45-1 1s.45 1 1 1z"
	}), 'FormatIndentDecreaseRounded');
	
	exports.default = _default;

/***/ },
/* 3109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 17h10v-2H11v2zm-8-5l4 4V8l-4 4zm0 9h18v-2H3v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
	}), 'FormatIndentDecreaseSharp');
	
	exports.default = _default;

/***/ },
/* 3110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 16V8l-4 4zm4-9h10v2H11zm0 4h10v2H11zm0 4h10v2H11zm-8 4h18v2H3zM3 3h18v2H3z"
	}), 'FormatIndentDecreaseTwoTone');
	
	exports.default = _default;

/***/ },
/* 3111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
	}), 'FormatIndentIncrease');
	
	exports.default = _default;

/***/ },
/* 3112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
	}), 'FormatIndentIncreaseOutlined');
	
	exports.default = _default;

/***/ },
/* 3113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 21h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 9.21v5.59c0 .45.54.67.85.35l2.79-2.79c.2-.2.2-.51 0-.71l-2.79-2.8c-.31-.31-.85-.09-.85.36zM12 17h8c.55 0 1-.45 1-1s-.45-1-1-1h-8c-.55 0-1 .45-1 1s.45 1 1 1zM3 4c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1zm9 5h8c.55 0 1-.45 1-1s-.45-1-1-1h-8c-.55 0-1 .45-1 1s.45 1 1 1zm0 4h8c.55 0 1-.45 1-1s-.45-1-1-1h-8c-.55 0-1 .45-1 1s.45 1 1 1z"
	}), 'FormatIndentIncreaseRounded');
	
	exports.default = _default;

/***/ },
/* 3114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
	}), 'FormatIndentIncreaseSharp');
	
	exports.default = _default;

/***/ },
/* 3115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 19h18v2H3zM3 3h18v2H3zm8 4h10v2H11zM3 8v8l4-4zm8 3h10v2H11zm0 4h10v2H11z"
	}), 'FormatIndentIncreaseTwoTone');
	
	exports.default = _default;

/***/ },
/* 3116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z"
	}), 'FormatItalic');
	
	exports.default = _default;

/***/ },
/* 3117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4h-8z"
	}), 'FormatItalicOutlined');
	
	exports.default = _default;

/***/ },
/* 3118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 5.5c0 .83.67 1.5 1.5 1.5h.71l-3.42 8H7.5c-.83 0-1.5.67-1.5 1.5S6.67 18 7.5 18h5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-.71l3.42-8h1.29c.83 0 1.5-.67 1.5-1.5S17.33 4 16.5 4h-5c-.83 0-1.5.67-1.5 1.5z"
	}), 'FormatItalicRounded');
	
	exports.default = _default;

/***/ },
/* 3119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4h-8z"
	}), 'FormatItalicSharp');
	
	exports.default = _default;

/***/ },
/* 3120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 15v3h8v-3h-2.21l3.42-8H18V4h-8v3h2.21l-3.42 8z"
	}), 'FormatItalicTwoTone');
	
	exports.default = _default;

/***/ },
/* 3121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z"
	}), 'FormatLineSpacing');
	
	exports.default = _default;

/***/ },
/* 3122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z"
	}), 'FormatLineSpacingOutlined');
	
	exports.default = _default;

/***/ },
/* 3123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.29 7c.45 0 .67-.54.35-.85l-2.29-2.3c-.2-.2-.51-.2-.71 0l-2.29 2.3c-.31.31-.09.85.36.85H4v10H2.71c-.45 0-.67.54-.35.85l2.29 2.29c.2.2.51.2.71 0l2.29-2.29c.31-.31.09-.85-.36-.85H6V7h1.29zM11 7h10c.55 0 1-.45 1-1s-.45-1-1-1H11c-.55 0-1 .45-1 1s.45 1 1 1zm10 10H11c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zm0-6H11c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1z"
	}), 'FormatLineSpacingRounded');
	
	exports.default = _default;

/***/ },
/* 3124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z"
	}), 'FormatLineSpacingSharp');
	
	exports.default = _default;

/***/ },
/* 3125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 5h12v2H10zm0 12h12v2H10zm-8.5 0L5 20.5 8.5 17H6V7h2.5L5 3.5 1.5 7H4v10zm8.5-6h12v2H10z"
	}), 'FormatLineSpacingTwoTone');
	
	exports.default = _default;

/***/ },
/* 3126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"
	}), 'FormatListBulleted');
	
	exports.default = _default;

/***/ },
/* 3127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"
	}), 'FormatListBulletedOutlined');
	
	exports.default = _default;

/***/ },
/* 3128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM8 19h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm0-6h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zM7 6c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1z"
	}), 'FormatListBulletedRounded');
	
	exports.default = _default;

/***/ },
/* 3129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"
	}), 'FormatListBulletedSharp');
	
	exports.default = _default;

/***/ },
/* 3130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 5h14v2H7z"
	}), _react.default.createElement("circle", {
	  cx: "4",
	  cy: "6",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M7 11h14v2H7zm0 6h14v2H7zm-3 2.5c.82 0 1.5-.68 1.5-1.5s-.67-1.5-1.5-1.5-1.5.68-1.5 1.5.68 1.5 1.5 1.5z"
	}), _react.default.createElement("circle", {
	  cx: "4",
	  cy: "12",
	  r: "1.5"
	})), 'FormatListBulletedTwoTone');
	
	exports.default = _default;

/***/ },
/* 3131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z"
	}), 'FormatListNumbered');
	
	exports.default = _default;

/***/ },
/* 3132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z"
	}), 'FormatListNumberedOutlined');
	
	exports.default = _default;

/***/ },
/* 3133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 7h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm12 10H8c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zm0-6H8c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zM4.5 16h-2c-.28 0-.5.22-.5.5s.22.5.5.5H4v.5h-.5c-.28 0-.5.22-.5.5s.22.5.5.5H4v.5H2.5c-.28 0-.5.22-.5.5s.22.5.5.5h2c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5zm-2-11H3v2.5c0 .28.22.5.5.5s.5-.22.5-.5v-3c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5s.22.5.5.5zm2 5h-2c-.28 0-.5.22-.5.5s.22.5.5.5h1.3l-1.68 1.96c-.08.09-.12.21-.12.32v.22c0 .28.22.5.5.5h2c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H3.2l1.68-1.96c.08-.09.12-.21.12-.32v-.22c0-.28-.22-.5-.5-.5z"
	}), 'FormatListNumberedRounded');
	
	exports.default = _default;

/***/ },
/* 3134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 17h2v.5h-1v1h1v.5h-2v1h3v-4h-3zm1-9h1V4h-2v1h1zm-1 3h1.8L18 13.1v.9h3v-1h-1.8l1.8-2.1V10h-3zM2 5h14v2H2zm0 12h14v2H2zm0-6h14v2H2z"
	}), 'FormatListNumberedRtl');
	
	exports.default = _default;

/***/ },
/* 3135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 17h2v.5h-1v1h1v.5h-2v1h3v-4h-3v1zm1-9h1V4h-2v1h1v3zm-1 3h1.8L18 13.1v.9h3v-1h-1.8l1.8-2.1V10h-3v1zM2 5h14v2H2V5zm0 12h14v2H2v-2zm0-6h14v2H2v-2z"
	}), 'FormatListNumberedRtlOutlined');
	
	exports.default = _default;

/***/ },
/* 3136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.5 16h-2c-.28 0-.5.22-.5.5s.22.5.5.5H20v.5h-.5c-.28 0-.5.22-.5.5s.22.5.5.5h.5v.5h-1.5c-.28 0-.5.22-.5.5s.22.5.5.5h2c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5zm-2-11h.5v2.5c0 .28.22.5.5.5s.5-.22.5-.5v-3c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5s.22.5.5.5zm2.5 5.72v-.22c0-.28-.22-.5-.5-.5h-2c-.28 0-.5.22-.5.5s.22.5.5.5h1.3l-1.68 1.96c-.08.09-.12.21-.12.32v.22c0 .28.22.5.5.5h2c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-1.3l1.68-1.96c.08-.09.12-.21.12-.32zM15 5H3c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zm0 12H3c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1zm0-6H3c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z"
	}), 'FormatListNumberedRtlRounded');
	
	exports.default = _default;

/***/ },
/* 3137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 17h2v.5h-1v1h1v.5h-2v1h3v-4h-3v1zm1-9h1V4h-2v1h1v3zm-1 3h1.8L18 13.1v.9h3v-1h-1.8l1.8-2.1V10h-3v1zM2 5h14v2H2V5zm0 12h14v2H2v-2zm0-6h14v2H2v-2z"
	}), 'FormatListNumberedRtlSharp');
	
	exports.default = _default;

/***/ },
/* 3138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 11h14v2H2zm16 6h2v.5h-1v1h1v.5h-2v1h3v-4h-3zm0-6h1.8L18 13.1v.9h3v-1h-1.8l1.8-2.1V10h-3zm2-3V4h-2v1h1v3zM2 17h14v2H2zM2 5h14v2H2z"
	}), 'FormatListNumberedRtlTwoTone');
	
	exports.default = _default;

/***/ },
/* 3139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z"
	}), 'FormatListNumberedSharp');
	
	exports.default = _default;

/***/ },
/* 3140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 13H3.2L5 10.9V10H2v1h1.8L2 13.1v.9h3zm2-8h14v2H7zM5 16H2v1h2v.5H3v1h1v.5H2v1h3zm2 1h14v2H7zM3 8h1V4H2v1h1zm4 3h14v2H7z"
	}), 'FormatListNumberedTwoTone');
	
	exports.default = _default;

/***/ },
/* 3141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3z"
	}), 'FormatPaint');
	
	exports.default = _default;

/***/ },
/* 3142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3zm-2 2H6V4h10v2z"
	}), 'FormatPaintOutlined');
	
	exports.default = _default;

/***/ },
/* 3143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4h-9c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h7c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1h-2z"
	}), 'FormatPaintRounded');
	
	exports.default = _default;

/***/ },
/* 3144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4V2H4v6h14V6h1v4H9v12h4V12h8V4h-3z"
	}), 'FormatPaintSharp');
	
	exports.default = _default;

/***/ },
/* 3145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 4h10v2H6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 2H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3V3c0-.55-.45-1-1-1zm-1 4H6V4h10v2z"
	})), 'FormatPaintTwoTone');
	
	exports.default = _default;

/***/ },
/* 3146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"
	}), 'FormatQuote');
	
	exports.default = _default;

/***/ },
/* 3147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.62 18h-5.24l2-4H13V6h8v7.24L18.62 18zm-2-2h.76L19 12.76V8h-4v4h3.62l-2 4zm-8 2H3.38l2-4H3V6h8v7.24L8.62 18zm-2-2h.76L9 12.76V8H5v4h3.62l-2 4z"
	}), 'FormatQuoteOutlined');
	
	exports.default = _default;

/***/ },
/* 3148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.17 17c.51 0 .98-.29 1.2-.74l1.42-2.84c.14-.28.21-.58.21-.89V8c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h2l-1.03 2.06c-.45.89.2 1.94 1.2 1.94zm10 0c.51 0 .98-.29 1.2-.74l1.42-2.84c.14-.28.21-.58.21-.89V8c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h2l-1.03 2.06c-.45.89.2 1.94 1.2 1.94z"
	}), 'FormatQuoteRounded');
	
	exports.default = _default;

/***/ },
/* 3149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 17h3l2-4V7H4v6h3l-2 4zm10 0h3l2-4V7h-6v6h3l-2 4z"
	}), 'FormatQuoteSharp');
	
	exports.default = _default;

/***/ },
/* 3150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16.62 16h.76L19 12.76V8h-4v4h3.62zm-10 0h.76L9 12.76V8H5v4h3.62z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18.62 18L21 13.24V6h-8v8h2.38l-2 4h5.24zM15 12V8h4v4.76L17.38 16h-.76l2-4H15zM3.38 18h5.24L11 13.24V6H3v8h2.38l-2 4zM5 12V8h4v4.76L7.38 16h-.76l2-4H5z"
	})), 'FormatQuoteTwoTone');
	
	exports.default = _default;

/***/ },
/* 3151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z"
	}), 'FormatShapes');
	
	exports.default = _default;

/***/ },
/* 3152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z"
	}), 'FormatShapesOutlined');
	
	exports.default = _default;

/***/ },
/* 3153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 6V2c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v1H7V2c0-.55-.45-1-1-1H2c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h1v10H2c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1h10v1c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-1V7h1c.55 0 1-.45 1-1zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-1c0-.55-.45-1-1-1H5V7h1c.55 0 1-.45 1-1V5h10v1c0 .55.45 1 1 1h1v10h-1c-.55 0-1 .45-1 1v1zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-6.06 2.65c-.15-.39-.53-.65-.95-.65-.42 0-.8.26-.94.65l-2.77 7.33c-.19.49.17 1.02.7 1.02.32 0 .6-.2.71-.5l.55-1.5h3.49l.56 1.51c.11.29.39.49.71.49h.01c.53 0 .89-.53.71-1.02l-2.78-7.33zm-2.25 5.09L12 8.91l1.3 3.83h-2.61z"
	}), 'FormatShapesRounded');
	
	exports.default = _default;

/***/ },
/* 3154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z"
	}), 'FormatShapesSharp');
	
	exports.default = _default;

/***/ },
/* 3155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 3h2v2H3zm16 16h2v2h-2zm0-16h2v2h-2zM3 19h2v2H3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11.29 7l-3.4 9h1.62l.73-2h3.49l.74 2h1.63l-3.41-9h-1.4zm-.6 5.74L12 8.91l1.3 3.83h-2.61zM17 3H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2V1h-6v2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm16 0h-2v-2h2v2zM19 3h2v2h-2V3zm0 14h-2v2H7v-2H5V7h2V5h10v2h2v10z"
	})), 'FormatShapesTwoTone');
	
	exports.default = _default;

/***/ },
/* 3156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z"
	}), 'FormatSize');
	
	exports.default = _default;

/***/ },
/* 3157 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z"
	}), 'FormatSizeOutlined');
	
	exports.default = _default;

/***/ },
/* 3158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 5.5c0 .83.67 1.5 1.5 1.5H14v10.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V7h3.5c.83 0 1.5-.67 1.5-1.5S21.33 4 20.5 4h-10C9.67 4 9 4.67 9 5.5zM4.5 12H6v5.5c0 .83.67 1.5 1.5 1.5S9 18.33 9 17.5V12h1.5c.83 0 1.5-.67 1.5-1.5S11.33 9 10.5 9h-6C3.67 9 3 9.67 3 10.5S3.67 12 4.5 12z"
	}), 'FormatSizeRounded');
	
	exports.default = _default;

/***/ },
/* 3159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z"
	}), 'FormatSizeSharp');
	
	exports.default = _default;

/***/ },
/* 3160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 12h3v7h3v-7h3V9H3zm6-5h5v12h3V7h5V4H9z"
	}), 'FormatSizeTwoTone');
	
	exports.default = _default;

/***/ },
/* 3161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z"
	}), 'FormatStrikethrough');
	
	exports.default = _default;

/***/ },
/* 3162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z"
	}), 'FormatStrikethroughOutlined');
	
	exports.default = _default;

/***/ },
/* 3163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 19c1.1 0 2-.9 2-2v-1h-4v1c0 1.1.9 2 2 2zM5 5.5C5 6.33 5.67 7 6.5 7H10v3h4V7h3.5c.83 0 1.5-.67 1.5-1.5S18.33 4 17.5 4h-11C5.67 4 5 4.67 5 5.5zM4 14h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1z"
	}), 'FormatStrikethroughRounded');
	
	exports.default = _default;

/***/ },
/* 3164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z"
	}), 'FormatStrikethroughSharp');
	
	exports.default = _default;

/***/ },
/* 3165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 12h18v2H3zm11-2V7h5V4H5v3h5v3zm-4 6h4v3h-4z"
	}), 'FormatStrikethroughTwoTone');
	
	exports.default = _default;

/***/ },
/* 3166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 10v5h2V4h2v11h2V4h2V2H9C6.79 2 5 3.79 5 6s1.79 4 4 4zm12 8l-4-4v3H5v2h12v3l4-4z"
	}), 'FormatTextdirectionLToR');
	
	exports.default = _default;

/***/ },
/* 3167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 4v4c-1.1 0-2-.9-2-2s.9-2 2-2m8-2H9C6.79 2 5 3.79 5 6s1.79 4 4 4v5h2V4h2v11h2V4h2V2zm0 12v3H5v2h12v3l4-4-4-4z"
	}), 'FormatTextdirectionLToROutlined');
	
	exports.default = _default;

/***/ },
/* 3168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 10v4c0 .55.45 1 1 1s1-.45 1-1V4h2v10c0 .55.45 1 1 1s1-.45 1-1V4h1c.55 0 1-.45 1-1s-.45-1-1-1H9.17C7.08 2 5.22 3.53 5.02 5.61 4.79 7.99 6.66 10 9 10zm11.65 7.65l-2.79-2.79c-.32-.32-.86-.1-.86.35V17H6c-.55 0-1 .45-1 1s.45 1 1 1h11v1.79c0 .45.54.67.85.35l2.79-2.79c.2-.19.2-.51.01-.7z"
	}), 'FormatTextdirectionLToRRounded');
	
	exports.default = _default;

/***/ },
/* 3169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 10v5h2V4h2v11h2V4h2V2H9C6.79 2 5 3.79 5 6s1.79 4 4 4zm12 8l-4-4v3H5v2h12v3l4-4z"
	}), 'FormatTextdirectionLToRSharp');
	
	exports.default = _default;

/***/ },
/* 3170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9 8V4c-1.1 0-2 .9-2 2s.9 2 2 2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9 10v5h2V4h2v11h2V4h2V2H9C6.79 2 5 3.79 5 6s1.79 4 4 4zm0-6v4c-1.1 0-2-.9-2-2s.9-2 2-2zm12 14l-4-4v3H5v2h12v3z"
	})), 'FormatTextdirectionLToRTwoTone');
	
	exports.default = _default;

/***/ },
/* 3171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4zm-2 7v-3l-4 4 4 4v-3h12v-2H8z"
	}), 'FormatTextdirectionRToL');
	
	exports.default = _default;

/***/ },
/* 3172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 4v4c-1.1 0-2-.9-2-2s.9-2 2-2m8-2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4v5h2V4h2v11h2V4h2V2zM8 14l-4 4 4 4v-3h12v-2H8v-3z"
	}), 'FormatTextdirectionRToLOutlined');
	
	exports.default = _default;

/***/ },
/* 3173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 10v4c0 .55.45 1 1 1s1-.45 1-1V4h2v10c0 .55.45 1 1 1s1-.45 1-1V4h1c.55 0 1-.45 1-1s-.45-1-1-1h-6.83C8.08 2 6.22 3.53 6.02 5.61 5.79 7.99 7.66 10 10 10zm-2 7v-1.79c0-.45-.54-.67-.85-.35l-2.79 2.79c-.2.2-.2.51 0 .71l2.79 2.79c.31.31.85.09.85-.36V19h11c.55 0 1-.45 1-1s-.45-1-1-1H8z"
	}), 'FormatTextdirectionRToLRounded');
	
	exports.default = _default;

/***/ },
/* 3174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4zm-2 7v-3l-4 4 4 4v-3h12v-2H8z"
	}), 'FormatTextdirectionRToLSharp');
	
	exports.default = _default;

/***/ },
/* 3175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 6c0 1.1.9 2 2 2V4c-1.1 0-2 .9-2 2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M6 6c0 2.21 1.79 4 4 4v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6zm4 2c-1.1 0-2-.9-2-2s.9-2 2-2v4zM4 18l4 4v-3h12v-2H8v-3z"
	})), 'FormatTextdirectionRToLTwoTone');
	
	exports.default = _default;

/***/ },
/* 3176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z"
	}), 'FormatUnderlined');
	
	exports.default = _default;

/***/ },
/* 3177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z"
	}), 'FormatUnderlinedOutlined');
	
	exports.default = _default;

/***/ },
/* 3178 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.79 16.95c3.03-.39 5.21-3.11 5.21-6.16V4.25C18 3.56 17.44 3 16.75 3s-1.25.56-1.25 1.25v6.65c0 1.67-1.13 3.19-2.77 3.52-2.25.47-4.23-1.25-4.23-3.42V4.25C8.5 3.56 7.94 3 7.25 3S6 3.56 6 4.25V11c0 3.57 3.13 6.42 6.79 5.95zM5 20c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1z"
	}), 'FormatUnderlinedRounded');
	
	exports.default = _default;

/***/ },
/* 3179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z"
	}), 'FormatUnderlinedSharp');
	
	exports.default = _default;

/***/ },
/* 3180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 19h14v2H5zM6 3v8c0 3.31 2.69 6 6 6s6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6z"
	}), 'FormatUnderlinedTwoTone');
	
	exports.default = _default;

/***/ },
/* 3181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"
	}), 'Forum');
	
	exports.default = _default;

/***/ },
/* 3182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 4v7H5.17L4 12.17V4h11m1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1z"
	}), 'ForumOutlined');
	
	exports.default = _default;

/***/ },
/* 3183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-1v8c0 .55-.45 1-1 1H6v1c0 1.1.9 2 2 2h10l4 4V8c0-1.1-.9-2-2-2zm-3 5V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v13l4-4h9c1.1 0 2-.9 2-2z"
	}), 'ForumRounded');
	
	exports.default = _default;

/***/ },
/* 3184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6h-3v9H6v3h12l4 4V6zm-5 7V2H2v15l4-4h11z"
	}), 'ForumSharp');
	
	exports.default = _default;

/***/ },
/* 3185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15 11V4H4v8.17L5.17 11H6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16 13c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10zm-12-.83V4h11v7H5.17L4 12.17zM22 7c0-.55-.45-1-1-1h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7z"
	})), 'ForumTwoTone');
	
	exports.default = _default;

/***/ },
/* 3186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8V4l8 8-8 8v-4H4V8z"
	}), 'Forward');
	
	exports.default = _default;

/***/ },
/* 3187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2z"
	}), _react.default.createElement("path", {
	  d: "M10.86 15.94v-4.27h-.09L9 12.3v.69l1.01-.31v3.26zM12.25 13.44v.74c0 1.9 1.31 1.82 1.44 1.82.14 0 1.44.09 1.44-1.82v-.74c0-1.9-1.31-1.82-1.44-1.82-.14 0-1.44-.09-1.44 1.82zm2.04-.12v.97c0 .77-.21 1.03-.59 1.03s-.6-.26-.6-1.03v-.97c0-.75.22-1.01.59-1.01.38-.01.6.26.6 1.01z"
	})), 'Forward10');
	
	exports.default = _default;

/***/ },
/* 3188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2z"
	}), _react.default.createElement("path", {
	  d: "M10.9 16v-4.27h-.09l-1.77.63v.69l1.01-.31V16zM14.32 11.78c-.18-.07-.37-.1-.59-.1s-.41.03-.59.1-.33.18-.45.33-.23.34-.29.57-.1.5-.1.82v.74c0 .32.04.6.11.82s.17.42.3.57.28.26.46.33.37.1.59.1.41-.03.59-.1.33-.18.45-.33.22-.34.29-.57.1-.5.1-.82v-.74c0-.32-.04-.6-.11-.82s-.17-.42-.3-.57-.29-.26-.46-.33zm.01 2.57c0 .19-.01.35-.04.48s-.06.24-.11.32-.11.14-.19.17-.16.05-.25.05-.18-.02-.25-.05-.14-.09-.19-.17-.09-.19-.12-.32-.04-.29-.04-.48v-.97c0-.19.01-.35.04-.48s.06-.23.12-.31.11-.14.19-.17.16-.05.25-.05.18.02.25.05.14.09.19.17.09.18.12.31.04.29.04.48v.97z"
	})), 'Forward10Outlined');
	
	exports.default = _default;

/***/ },
/* 3189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.92 13c-.5 0-.91.37-.98.86-.48 3.37-3.77 5.84-7.42 4.96-2.25-.54-3.91-2.27-4.39-4.53C5.32 10.42 8.27 7 12 7v2.79c0 .45.54.67.85.35l3.79-3.79c.2-.2.2-.51 0-.71l-3.79-3.79c-.31-.31-.85-.09-.85.36V5c-4.94 0-8.84 4.48-7.84 9.6.6 3.11 2.9 5.5 5.99 6.19 4.83 1.08 9.15-2.2 9.77-6.67.09-.59-.4-1.12-1-1.12zm-8.02 3v-4.27h-.09l-1.77.63v.69l1.01-.31V16zm3.42-4.22c-.18-.07-.37-.1-.59-.1s-.41.03-.59.1-.33.18-.45.33-.23.34-.29.57-.1.5-.1.82v.74c0 .32.04.6.11.82s.17.42.3.57.28.26.46.33.37.1.59.1.41-.03.59-.1.33-.18.45-.33.22-.34.29-.57.1-.5.1-.82v-.74c0-.32-.04-.6-.11-.82s-.17-.42-.3-.57-.29-.26-.46-.33zm.01 2.57c0 .19-.01.35-.04.48s-.06.24-.11.32-.11.14-.19.17-.16.05-.25.05-.18-.02-.25-.05-.14-.09-.19-.17-.09-.19-.12-.32-.04-.29-.04-.48v-.97c0-.19.01-.35.04-.48s.06-.23.12-.31.11-.14.19-.17.16-.05.25-.05.18.02.25.05.14.09.19.17.09.18.12.31.04.29.04.48v.97z"
	}), 'Forward10Rounded');
	
	exports.default = _default;

/***/ },
/* 3190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2z"
	}), _react.default.createElement("path", {
	  d: "M10.9 16v-4.27h-.09l-1.77.63v.69l1.01-.31V16zM14.32 11.78c-.18-.07-.37-.1-.59-.1s-.41.03-.59.1-.33.18-.45.33-.23.34-.29.57-.1.5-.1.82v.74c0 .32.04.6.11.82s.17.42.3.57.28.26.46.33.37.1.59.1.41-.03.59-.1.33-.18.45-.33.22-.34.29-.57.1-.5.1-.82v-.74c0-.32-.04-.6-.11-.82s-.17-.42-.3-.57-.29-.26-.46-.33zm.01 2.57c0 .19-.01.35-.04.48s-.06.24-.11.32-.11.14-.19.17-.16.05-.25.05-.18-.02-.25-.05-.14-.09-.19-.17-.09-.19-.12-.32-.04-.29-.04-.48v-.97c0-.19.01-.35.04-.48s.06-.23.12-.31.11-.14.19-.17.16-.05.25-.05.18.02.25.05.14.09.19.17.09.18.12.31.04.29.04.48v.97z"
	})), 'Forward10Sharp');
	
	exports.default = _default;

/***/ },
/* 3191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2z"
	}), _react.default.createElement("path", {
	  d: "M10.9 16v-4.27h-.09l-1.77.63v.69l1.01-.31V16zM14.32 11.78c-.18-.07-.37-.1-.59-.1s-.41.03-.59.1-.33.18-.45.33-.23.34-.29.57-.1.5-.1.82v.74c0 .32.04.6.11.82s.17.42.3.57.28.26.46.33.37.1.59.1.41-.03.59-.1.33-.18.45-.33.22-.34.29-.57.1-.5.1-.82v-.74c0-.32-.04-.6-.11-.82s-.17-.42-.3-.57-.29-.26-.46-.33zm.01 2.57c0 .19-.01.35-.04.48s-.06.24-.11.32-.11.14-.19.17-.16.05-.25.05-.18-.02-.25-.05-.14-.09-.19-.17-.09-.19-.12-.32-.04-.29-.04-.48v-.97c0-.19.01-.35.04-.48s.06-.23.12-.31.11-.14.19-.17.16-.05.25-.05.18.02.25.05.14.09.19.17.09.18.12.31.04.29.04.48v.97z"
	})), 'Forward10TwoTone');
	
	exports.default = _default;

/***/ },
/* 3192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2z"
	}), _react.default.createElement("path", {
	  d: "M10.06 15.38c-.29 0-.62-.17-.62-.54h-.85c0 .97.9 1.23 1.45 1.23.87 0 1.51-.46 1.51-1.25 0-.66-.45-.9-.71-1 .11-.05.65-.32.65-.92 0-.21-.05-1.22-1.44-1.22-.62 0-1.4.35-1.4 1.16h.85c0-.34.31-.48.57-.48.59 0 .58.5.58.54 0 .52-.41.59-.63.59h-.46v.66h.45c.65 0 .7.42.7.64 0 .32-.21.59-.65.59zM13.85 11.68c-.14 0-1.44-.08-1.44 1.82v.74c0 1.9 1.31 1.82 1.44 1.82.14 0 1.44.09 1.44-1.82v-.74c.01-1.91-1.3-1.82-1.44-1.82zm.6 2.67c0 .77-.21 1.03-.59 1.03s-.6-.26-.6-1.03v-.97c0-.75.22-1.01.59-1.01.38 0 .6.26.6 1.01v.97z"
	})), 'Forward30');
	
	exports.default = _default;

/***/ },
/* 3193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2zm-7.46 2.22c-.06.05-.12.09-.2.12s-.17.04-.27.04c-.09 0-.17-.01-.25-.04s-.14-.06-.2-.11-.1-.1-.13-.17-.05-.14-.05-.22h-.85c0 .21.04.39.12.55s.19.28.33.38.29.18.46.23.35.07.53.07c.21 0 .41-.03.6-.08s.34-.14.48-.24.24-.24.32-.39.12-.33.12-.53c0-.23-.06-.44-.18-.61s-.3-.3-.54-.39c.1-.05.2-.1.28-.17s.15-.14.2-.22.1-.16.13-.25.04-.18.04-.27c0-.2-.04-.37-.11-.53s-.17-.28-.3-.38-.28-.18-.46-.23-.37-.08-.59-.08c-.19 0-.38.03-.54.08s-.32.13-.44.23-.23.22-.3.37-.11.3-.11.48h.85c0-.07.02-.14.05-.2s.07-.11.12-.15.11-.07.18-.1.14-.03.22-.03c.1 0 .18.01.25.04s.13.06.18.11.08.11.11.17.04.14.04.22c0 .18-.05.32-.16.43s-.26.16-.48.16h-.43v.66h.45c.11 0 .2.01.29.04s.16.06.22.11.11.12.14.2.05.18.05.29c0 .09-.01.17-.04.24s-.08.11-.13.17zm3.9-3.44c-.18-.07-.37-.1-.59-.1s-.41.03-.59.1-.33.18-.45.33-.23.34-.29.57-.1.5-.1.82v.74c0 .32.04.6.11.82s.17.42.3.57.28.26.46.33.37.1.59.1.41-.03.59-.1.33-.18.45-.33.22-.34.29-.57.1-.5.1-.82v-.74c0-.32-.04-.6-.11-.82s-.17-.42-.3-.57-.28-.26-.46-.33zm.01 2.57c0 .19-.01.35-.04.48s-.06.24-.11.32-.11.14-.19.17-.16.05-.25.05-.18-.02-.25-.05-.14-.09-.19-.17-.09-.19-.12-.32-.04-.29-.04-.48v-.97c0-.19.01-.35.04-.48s.06-.23.12-.31.11-.14.19-.17.16-.05.25-.05.18.02.25.05.14.09.19.17.09.18.12.31.04.29.04.48v.97z"
	}), 'Forward30Outlined');
	
	exports.default = _default;

/***/ },
/* 3194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.92 13c-.5 0-.91.37-.98.86-.48 3.37-3.77 5.84-7.42 4.96-2.25-.54-3.91-2.27-4.39-4.53C5.32 10.42 8.27 7 12 7v2.79c0 .45.54.67.85.35l3.79-3.79c.2-.2.2-.51 0-.71l-3.79-3.79c-.31-.31-.85-.09-.85.36V5c-4.94 0-8.84 4.48-7.84 9.6.6 3.11 2.9 5.5 5.99 6.19 4.83 1.08 9.15-2.2 9.77-6.67.09-.59-.4-1.12-1-1.12zm-8.38 2.22c-.06.05-.12.09-.2.12s-.17.04-.27.04c-.09 0-.17-.01-.25-.04s-.14-.06-.2-.11-.1-.1-.13-.17-.05-.14-.05-.22h-.85c0 .21.04.39.12.55s.19.28.33.38.29.18.46.23.35.07.53.07c.21 0 .41-.03.6-.08s.34-.14.48-.24.24-.24.32-.39.12-.33.12-.53c0-.23-.06-.44-.18-.61s-.3-.3-.54-.39c.1-.05.2-.1.28-.17s.15-.14.2-.22.1-.16.13-.25.04-.18.04-.27c0-.2-.04-.37-.11-.53s-.17-.28-.3-.38-.28-.18-.46-.23-.37-.08-.59-.08c-.19 0-.38.03-.54.08s-.32.13-.44.23-.23.22-.3.37-.11.3-.11.48h.85c0-.07.02-.14.05-.2s.07-.11.12-.15.11-.07.18-.1.14-.03.22-.03c.1 0 .18.01.25.04s.13.06.18.11.08.11.11.17.04.14.04.22c0 .18-.05.32-.16.43s-.26.16-.48.16h-.43v.66h.45c.11 0 .2.01.29.04s.16.06.22.11.11.12.14.2.05.18.05.29c0 .09-.01.17-.04.24s-.08.11-.13.17zm3.9-3.44c-.18-.07-.37-.1-.59-.1s-.41.03-.59.1-.33.18-.45.33-.23.34-.29.57-.1.5-.1.82v.74c0 .32.04.6.11.82s.17.42.3.57.28.26.46.33.37.1.59.1.41-.03.59-.1.33-.18.45-.33.22-.34.29-.57.1-.5.1-.82v-.74c0-.32-.04-.6-.11-.82s-.17-.42-.3-.57-.28-.26-.46-.33zm.01 2.57c0 .19-.01.35-.04.48s-.06.24-.11.32-.11.14-.19.17-.16.05-.25.05-.18-.02-.25-.05-.14-.09-.19-.17-.09-.19-.12-.32-.04-.29-.04-.48v-.97c0-.19.01-.35.04-.48s.06-.23.12-.31.11-.14.19-.17.16-.05.25-.05.18.02.25.05.14.09.19.17.09.18.12.31.04.29.04.48v.97z"
	}), 'Forward30Rounded');
	
	exports.default = _default;

/***/ },
/* 3195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2zm-7.46 2.22c-.06.05-.12.09-.2.12s-.17.04-.27.04c-.09 0-.17-.01-.25-.04s-.14-.06-.2-.11-.1-.1-.13-.17-.05-.14-.05-.22h-.85c0 .21.04.39.12.55s.19.28.33.38.29.18.46.23.35.07.53.07c.21 0 .41-.03.6-.08s.34-.14.48-.24.24-.24.32-.39.12-.33.12-.53c0-.23-.06-.44-.18-.61s-.3-.3-.54-.39c.1-.05.2-.1.28-.17s.15-.14.2-.22.1-.16.13-.25.04-.18.04-.27c0-.2-.04-.37-.11-.53s-.17-.28-.3-.38-.28-.18-.46-.23-.37-.08-.59-.08c-.19 0-.38.03-.54.08s-.32.13-.44.23-.23.22-.3.37-.11.3-.11.48h.85c0-.07.02-.14.05-.2s.07-.11.12-.15.11-.07.18-.1.14-.03.22-.03c.1 0 .18.01.25.04s.13.06.18.11.08.11.11.17.04.14.04.22c0 .18-.05.32-.16.43s-.26.16-.48.16h-.43v.66h.45c.11 0 .2.01.29.04s.16.06.22.11.11.12.14.2.05.18.05.29c0 .09-.01.17-.04.24s-.08.11-.13.17zm3.9-3.44c-.18-.07-.37-.1-.59-.1s-.41.03-.59.1-.33.18-.45.33-.23.34-.29.57-.1.5-.1.82v.74c0 .32.04.6.11.82s.17.42.3.57.28.26.46.33.37.1.59.1.41-.03.59-.1.33-.18.45-.33.22-.34.29-.57.1-.5.1-.82v-.74c0-.32-.04-.6-.11-.82s-.17-.42-.3-.57-.28-.26-.46-.33zm.01 2.57c0 .19-.01.35-.04.48s-.06.24-.11.32-.11.14-.19.17-.16.05-.25.05-.18-.02-.25-.05-.14-.09-.19-.17-.09-.19-.12-.32-.04-.29-.04-.48v-.97c0-.19.01-.35.04-.48s.06-.23.12-.31.11-.14.19-.17.16-.05.25-.05.18.02.25.05.14.09.19.17.09.18.12.31.04.29.04.48v.97z"
	}), 'Forward30Sharp');
	
	exports.default = _default;

/***/ },
/* 3196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2zm-7.46 2.22c-.06.05-.12.09-.2.12s-.17.04-.27.04c-.09 0-.17-.01-.25-.04s-.14-.06-.2-.11-.1-.1-.13-.17-.05-.14-.05-.22h-.85c0 .21.04.39.12.55s.19.28.33.38.29.18.46.23.35.07.53.07c.21 0 .41-.03.6-.08s.34-.14.48-.24.24-.24.32-.39.12-.33.12-.53c0-.23-.06-.44-.18-.61s-.3-.3-.54-.39c.1-.05.2-.1.28-.17s.15-.14.2-.22.1-.16.13-.25.04-.18.04-.27c0-.2-.04-.37-.11-.53s-.17-.28-.3-.38-.28-.18-.46-.23-.37-.08-.59-.08c-.19 0-.38.03-.54.08s-.32.13-.44.23-.23.22-.3.37-.11.3-.11.48h.85c0-.07.02-.14.05-.2s.07-.11.12-.15.11-.07.18-.1.14-.03.22-.03c.1 0 .18.01.25.04s.13.06.18.11.08.11.11.17.04.14.04.22c0 .18-.05.32-.16.43s-.26.16-.48.16h-.43v.66h.45c.11 0 .2.01.29.04s.16.06.22.11.11.12.14.2.05.18.05.29c0 .09-.01.17-.04.24s-.08.11-.13.17zm3.9-3.44c-.18-.07-.37-.1-.59-.1s-.41.03-.59.1-.33.18-.45.33-.23.34-.29.57-.1.5-.1.82v.74c0 .32.04.6.11.82s.17.42.3.57.28.26.46.33.37.1.59.1.41-.03.59-.1.33-.18.45-.33.22-.34.29-.57.1-.5.1-.82v-.74c0-.32-.04-.6-.11-.82s-.17-.42-.3-.57-.28-.26-.46-.33zm.01 2.57c0 .19-.01.35-.04.48s-.06.24-.11.32-.11.14-.19.17-.16.05-.25.05-.18-.02-.25-.05-.14-.09-.19-.17-.09-.19-.12-.32-.04-.29-.04-.48v-.97c0-.19.01-.35.04-.48s.06-.23.12-.31.11-.14.19-.17.16-.05.25-.05.18.02.25.05.14.09.19.17.09.18.12.31.04.29.04.48v.97z"
	}), 'Forward30TwoTone');
	
	exports.default = _default;

/***/ },
/* 3197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2z"
	}), _react.default.createElement("path", {
	  d: "M12.03 15.38c-.44 0-.58-.31-.6-.56h-.84c.03.85.79 1.25 1.44 1.25.93 0 1.44-.63 1.44-1.43 0-1.33-.97-1.44-1.3-1.44-.2 0-.43.05-.64.16l.11-.92h1.7v-.71h-2.39l-.25 2.17.67.17c.13-.13.28-.23.57-.23.4 0 .69.23.69.75-.01.05.02.79-.6.79z"
	})), 'Forward5');
	
	exports.default = _default;

/***/ },
/* 3198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.95 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2zm-5.52 2.15c-.05.07-.11.13-.18.17s-.17.06-.27.06c-.17 0-.31-.05-.42-.15s-.17-.24-.19-.41h-.84c.01.2.05.37.13.53s.19.28.32.39.29.19.46.24.35.08.53.08c.24 0 .46-.04.64-.12s.33-.18.45-.31.21-.28.27-.45.09-.35.09-.54c0-.22-.03-.43-.09-.6s-.14-.33-.25-.45-.25-.22-.41-.28-.34-.1-.55-.1c-.07 0-.14.01-.2.02s-.13.02-.18.04-.1.03-.15.05-.08.04-.11.05l.11-.92h1.7v-.71H10.9l-.25 2.17.67.17c.03-.03.06-.06.1-.09s.07-.05.12-.07.1-.04.15-.05.13-.02.2-.02c.12 0 .22.02.3.05s.16.09.21.15.1.14.13.24.04.19.04.31-.01.22-.03.31-.06.17-.11.24z"
	}), 'Forward5Outlined');
	
	exports.default = _default;

/***/ },
/* 3199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.87 13c-.5 0-.91.37-.98.86-.48 3.37-3.77 5.84-7.42 4.96-2.25-.54-3.91-2.27-4.39-4.53C5.27 10.42 8.22 7 11.95 7v2.79c0 .45.54.67.85.35l3.79-3.79c.2-.2.2-.51 0-.71L12.8 1.85c-.31-.31-.85-.09-.85.35V5c-4.94 0-8.84 4.48-7.84 9.6.6 3.11 2.9 5.5 5.99 6.19 4.83 1.08 9.15-2.2 9.77-6.67.09-.59-.4-1.12-1-1.12zm-6.44 2.15c-.05.07-.11.13-.18.17s-.17.06-.27.06c-.17 0-.31-.05-.42-.15s-.17-.24-.19-.41h-.84c.01.2.05.37.13.53s.19.28.32.39.29.19.46.24.35.08.53.08c.24 0 .46-.04.64-.12s.33-.18.45-.31.21-.28.27-.45.09-.35.09-.54c0-.22-.03-.43-.09-.6s-.14-.33-.25-.45-.25-.22-.41-.28-.34-.1-.55-.1c-.07 0-.14.01-.2.02s-.13.02-.18.04-.1.03-.15.05-.08.04-.11.05l.11-.92h1.7v-.71H10.9l-.25 2.17.67.17c.03-.03.06-.06.1-.09s.07-.05.12-.07.1-.04.15-.05.13-.02.2-.02c.12 0 .22.02.3.05s.16.09.21.15.1.14.13.24.04.19.04.31-.01.22-.03.31-.06.17-.11.24z"
	}), 'Forward5Rounded');
	
	exports.default = _default;

/***/ },
/* 3200 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.95 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2zm-5.52 2.15c-.05.07-.11.13-.18.17s-.17.06-.27.06c-.17 0-.31-.05-.42-.15s-.17-.24-.19-.41h-.84c.01.2.05.37.13.53s.19.28.32.39.29.19.46.24.35.08.53.08c.24 0 .46-.04.64-.12s.33-.18.45-.31.21-.28.27-.45.09-.35.09-.54c0-.22-.03-.43-.09-.6s-.14-.33-.25-.45-.25-.22-.41-.28-.34-.1-.55-.1c-.07 0-.14.01-.2.02s-.13.02-.18.04-.1.03-.15.05-.08.04-.11.05l.11-.92h1.7v-.71H10.9l-.25 2.17.67.17c.03-.03.06-.06.1-.09s.07-.05.12-.07.1-.04.15-.05.13-.02.2-.02c.12 0 .22.02.3.05s.16.09.21.15.1.14.13.24.04.19.04.31-.01.22-.03.31-.06.17-.11.24z"
	}), 'Forward5Sharp');
	
	exports.default = _default;

/***/ },
/* 3201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.95 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2zm-5.52 2.15c-.05.07-.11.13-.18.17s-.17.06-.27.06c-.17 0-.31-.05-.42-.15s-.17-.24-.19-.41h-.84c.01.2.05.37.13.53s.19.28.32.39.29.19.46.24.35.08.53.08c.24 0 .46-.04.64-.12s.33-.18.45-.31.21-.28.27-.45.09-.35.09-.54c0-.22-.03-.43-.09-.6s-.14-.33-.25-.45-.25-.22-.41-.28-.34-.1-.55-.1c-.07 0-.14.01-.2.02s-.13.02-.18.04-.1.03-.15.05-.08.04-.11.05l.11-.92h1.7v-.71H10.9l-.25 2.17.67.17c.03-.03.06-.06.1-.09s.07-.05.12-.07.1-.04.15-.05.13-.02.2-.02c.12 0 .22.02.3.05s.16.09.21.15.1.14.13.24.04.19.04.31-.01.22-.03.31-.06.17-.11.24z"
	}), 'Forward5TwoTone');
	
	exports.default = _default;

/***/ },
/* 3202 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 8.83L17.17 12 14 15.17V14H6v-4h8V8.83M12 4v4H4v8h8v4l8-8-8-8z"
	}), 'ForwardOutlined');
	
	exports.default = _default;

/***/ },
/* 3203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8V6.41c0-.89 1.08-1.34 1.71-.71l5.59 5.59c.39.39.39 1.02 0 1.41l-5.59 5.59c-.63.63-1.71.19-1.71-.7V16H5c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h7z"
	}), 'ForwardRounded');
	
	exports.default = _default;

/***/ },
/* 3204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8V4l8 8-8 8v-4H4V8h8z"
	}), 'ForwardSharp');
	
	exports.default = _default;

/***/ },
/* 3205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14 14v1.17L17.17 12 14 8.83V10H6v4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 12l-8-8v4H4v8h8v4l8-8zM6 14v-4h8V8.83L17.17 12 14 15.17V14H6z"
	})), 'ForwardTwoTone');
	
	exports.default = _default;

/***/ },
/* 3206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 10.5h-1V15H9.5v-1.5h-3V9H8v3h1.5V9H11v3h1v1.5zm6 1.5h-1.75l-1.75-2.25V15H13V9h1.5v2.25L16.25 9H18l-2.25 3L18 15z"
	}), 'FourK');
	
	exports.default = _default;

/***/ },
/* 3207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm0 16H5V5h14v14zm-9.5-4H11v-1.49h1V12h-1V9H9.5v3H8V9H6.5v4.5h3zm8.7 0l-2-3 2-3h-1.7l-2 3 2 3zm-3.7-3V9H13v6h1.5z"
	}), 'FourKOutlined');
	
	exports.default = _default;

/***/ },
/* 3208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-7 9.76c0 .41-.34.75-.75.75H11v.74c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.75h-2c-.55 0-1-.45-1-1V9.75c0-.41.34-.75.75-.75s.75.34.75.75V12h1.5V9.75c0-.41.34-.75.75-.75s.75.34.75.75V12h.25c.41 0 .75.34.75.75v.01zm5.47 1.14c.22.33.13.77-.2.98-.12.08-.26.12-.39.12-.23 0-.45-.11-.59-.32L14.5 12v2.24c0 .41-.34.75-.75.75-.41.01-.75-.33-.75-.74v-4.5c0-.41.34-.75.75-.75s.75.34.75.75v2.24l1.79-2.68c.22-.33.66-.41.98-.2.33.22.41.66.2.98L16.2 12l1.27 1.9z"
	}), 'FourKRounded');
	
	exports.default = _default;

/***/ },
/* 3209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zm-9 10.51h-1V15H9.5v-1.5h-3V9H8v3h1.5V9H11v3h1v1.51zM18.2 15h-1.7l-2-3v3H13V9h1.5v3l2-3h1.7l-2 3 2 3z"
	}), 'FourKSharp');
	
	exports.default = _default;

/***/ },
/* 3210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 5H5v14h14V5zm-7 8.51h-1V15H9.5v-1.5h-3V9H8v3h1.5V9H11v3h1v1.51zM18.2 15h-1.7l-2-3v3H13V9h1.5v3l2-3h1.7l-2 3 2 3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 21h14c1.1 0 2-.9 2-2V5c0-1.1-.89-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.89 2 2 2zM5 5h14v14H5V5zm6 4H9.5v3H8V9H6.5v4.5h3V15H11v-1.49h1V12h-1zm5.5 0l-2 3 2 3h1.7l-2-3 2-3zM13 9v6h1.5V9z"
	})), 'FourKTwoTone');
	
	exports.default = _default;

/***/ },
/* 3211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z"
	}), 'FreeBreakfast');
	
	exports.default = _default;

/***/ },
/* 3212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 19h16v2H4zM20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zm-4 10c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V5h10v8zm4-5h-2V5h2v3z"
	}), 'FreeBreakfastOutlined');
	
	exports.default = _default;

/***/ },
/* 3213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 3H6c-1.1 0-2 .9-2 2v8c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 5h-2V5h2v3zM5 19h14c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1z"
	}), 'FreeBreakfastRounded');
	
	exports.default = _default;

/***/ },
/* 3214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 3H4v14h14v-7h2c1.11 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4v-2z"
	}), 'FreeBreakfastSharp');
	
	exports.default = _default;

/***/ },
/* 3215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 13c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V5H6v8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 19h16v2H4zM20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zm-4 10c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V5h10v8zm4-5h-2V5h2v3z"
	})), 'FreeBreakfastTwoTone');
	
	exports.default = _default;

/***/ },
/* 3216 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
	}), 'Fullscreen');
	
	exports.default = _default;

/***/ },
/* 3217 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
	}), 'FullscreenExit');
	
	exports.default = _default;

/***/ },
/* 3218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
	}), 'FullscreenExitOutlined');
	
	exports.default = _default;

/***/ },
/* 3219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 16h2v2c0 .55.45 1 1 1s1-.45 1-1v-3c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1s.45 1 1 1zm2-8H6c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1s-1 .45-1 1v2zm7 11c.55 0 1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm1-11V6c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1h-2z"
	}), 'FullscreenExitRounded');
	
	exports.default = _default;

/***/ },
/* 3220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
	}), 'FullscreenExitSharp');
	
	exports.default = _default;

/***/ },
/* 3221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
	}), 'FullscreenExitTwoTone');
	
	exports.default = _default;

/***/ },
/* 3222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
	}), 'FullscreenOutlined');
	
	exports.default = _default;

/***/ },
/* 3223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 14c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1H7v-2c0-.55-.45-1-1-1zm0-4c.55 0 1-.45 1-1V7h2c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm11 7h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1s-1 .45-1 1v2zM14 6c0 .55.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V6c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1z"
	}), 'FullscreenRounded');
	
	exports.default = _default;

/***/ },
/* 3224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
	}), 'FullscreenSharp');
	
	exports.default = _default;

/***/ },
/* 3225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
	}), 'FullscreenTwoTone');
	
	exports.default = _default;

/***/ },
/* 3226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7z"
	}), 'Functions');
	
	exports.default = _default;

/***/ },
/* 3227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7V4z"
	}), 'FunctionsOutlined');
	
	exports.default = _default;

/***/ },
/* 3228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.5 4H7.56C6.7 4 6 4.7 6 5.56c0 .28.12.55.32.74L12.5 12l-6.18 5.7c-.2.19-.32.46-.32.74C6 19.3 6.7 20 7.56 20h8.94c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H11l3.59-3.59c.78-.78.78-2.05 0-2.83L11 7h5.5c.83 0 1.5-.67 1.5-1.5S17.33 4 16.5 4z"
	}), 'FunctionsRounded');
	
	exports.default = _default;

/***/ },
/* 3229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7V4z"
	}), 'FunctionsSharp');
	
	exports.default = _default;

/***/ },
/* 3230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 17h-7l5-5-5-5h7V4H6v2l6.5 6L6 18v2h12z"
	}), 'FunctionsTwoTone');
	
	exports.default = _default;

/***/ },
/* 3231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 4H11l-1-3H3c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8l1 3h9c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 16c-2.76 0-5-2.24-5-5s2.24-5 5-5c1.35 0 2.48.5 3.35 1.3L9.03 8.57c-.38-.36-1.04-.78-2.03-.78-1.74 0-3.15 1.44-3.15 3.21S5.26 14.21 7 14.21c2.01 0 2.84-1.44 2.92-2.41H7v-1.71h4.68c.07.31.12.61.12 1.02C11.8 13.97 9.89 16 7 16zm6.17-5.42h3.7c-.43 1.25-1.11 2.43-2.05 3.47-.31-.35-.6-.72-.86-1.1l-.79-2.37zm8.33 9.92c0 .55-.45 1-1 1H14l2-2.5-1.04-3.1 3.1 3.1.92-.92-3.3-3.25.02-.02c1.13-1.25 1.93-2.69 2.4-4.22H20v-1.3h-4.53V8h-1.29v1.29h-1.44L11.46 5.5h9.04c.55 0 1 .45 1 1v14z"
	}), 'GTranslate');
	
	exports.default = _default;

/***/ },
/* 3232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 5h-9.12L10 2H4c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h7l1 3h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM7.17 14.59c-2.25 0-4.09-1.83-4.09-4.09s1.83-4.09 4.09-4.09c1.04 0 1.99.37 2.74 1.07l.07.06-1.23 1.18-.06-.05c-.29-.27-.78-.59-1.52-.59-1.31 0-2.38 1.09-2.38 2.42s1.07 2.42 2.38 2.42c1.37 0 1.96-.87 2.12-1.46H7.08V9.91h3.95l.01.07c.04.21.05.4.05.61 0 2.35-1.61 4-3.92 4zm6.03-1.71c.33.6.74 1.18 1.19 1.7l-.54.53-.65-2.23zm.77-.76h-.99l-.31-1.04h3.99s-.34 1.31-1.56 2.74c-.52-.62-.89-1.23-1.13-1.7zM21 20c0 .55-.45 1-1 1h-7l2-2-.81-2.77.92-.92L17.79 18l.73-.73-2.71-2.68c.9-1.03 1.6-2.25 1.92-3.51H19v-1.04h-3.64V9h-1.04v1.04h-1.96L11.18 6H20c.55 0 1 .45 1 1v13z"
	}), 'GTranslateOutlined');
	
	exports.default = _default;

/***/ },
/* 3233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 5h-9.12L10 2H4c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h7l1 3h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM7.17 14.59c-2.25 0-4.09-1.83-4.09-4.09s1.83-4.09 4.09-4.09c1.04 0 1.99.37 2.74 1.07l.07.06-1.23 1.18-.06-.05c-.29-.27-.78-.59-1.52-.59-1.31 0-2.38 1.09-2.38 2.42s1.07 2.42 2.38 2.42c1.37 0 1.96-.87 2.12-1.46H7.08V9.91h3.95l.01.07c.04.21.05.4.05.61 0 2.35-1.61 4-3.92 4zm6.03-1.71c.33.6.74 1.18 1.19 1.7l-.54.53-.65-2.23zm.77-.76h-.99l-.31-1.04h3.99s-.34 1.31-1.56 2.74c-.52-.62-.89-1.23-1.13-1.7zM21 20c0 .55-.45 1-1 1h-7l2-2-.81-2.77.92-.92L17.79 18l.73-.73-2.71-2.68c.9-1.03 1.6-2.25 1.92-3.51H19v-1.04h-3.64V9h-1.04v1.04h-1.96L11.18 6H20c.55 0 1 .45 1 1v13z"
	}), 'GTranslateRounded');
	
	exports.default = _default;

/***/ },
/* 3234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 5h-9.12L10 2H4c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h7l1 3h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM7.17 14.59c-2.25 0-4.09-1.83-4.09-4.09s1.83-4.09 4.09-4.09c1.04 0 1.99.37 2.74 1.07l.07.06-1.23 1.18-.06-.05c-.29-.27-.78-.59-1.52-.59-1.31 0-2.38 1.09-2.38 2.42s1.07 2.42 2.38 2.42c1.37 0 1.96-.87 2.12-1.46H7.08V9.91h3.95l.01.07c.04.21.05.4.05.61 0 2.35-1.61 4-3.92 4zm6.03-1.71c.33.6.74 1.18 1.19 1.7l-.54.53-.65-2.23zm.77-.76h-.99l-.31-1.04h3.99s-.34 1.31-1.56 2.74c-.52-.62-.89-1.23-1.13-1.7zM21 20c0 .55-.45 1-1 1h-7l2-2-.81-2.77.92-.92L17.79 18l.73-.73-2.71-2.68c.9-1.03 1.6-2.25 1.92-3.51H19v-1.04h-3.64V9h-1.04v1.04h-1.96L11.18 6H20c.55 0 1 .45 1 1v13z"
	}), 'GTranslateSharp');
	
	exports.default = _default;

/***/ },
/* 3235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 5h-9.12L10 2H4c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h7l1 3h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM7.17 14.59c-2.25 0-4.09-1.83-4.09-4.09s1.83-4.09 4.09-4.09c1.04 0 1.99.37 2.74 1.07l.07.06-1.23 1.18-.06-.05c-.29-.27-.78-.59-1.52-.59-1.31 0-2.38 1.09-2.38 2.42 0 1.33 1.07 2.42 2.38 2.42 1.37 0 1.96-.87 2.12-1.46H7.08V9.91h3.95l.01.07c.04.21.05.4.05.61 0 2.35-1.61 4-3.92 4zm5.5-3.51h3.99s-.34 1.31-1.56 2.74c-.52-.62-.89-1.23-1.13-1.7h-.99l-.31-1.04zm1.72 3.5l-.54.53-.65-2.23c.33.6.74 1.18 1.19 1.7zM21 20c0 .55-.45 1-1 1h-7l2-2-.81-2.77.92-.92L17.79 18l.73-.73-2.71-2.68c.9-1.03 1.6-2.25 1.92-3.51H19v-1.04h-3.64V9h-1.04v1.04h-1.96L11.18 6H20c.55 0 1 .45 1 1v13z"
	}), 'GTranslateTwoTone');
	
	exports.default = _default;

/***/ },
/* 3236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z"
	}), 'Gamepad');
	
	exports.default = _default;

/***/ },
/* 3237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 4v2.67l-1 1-1-1V4h2m7 7v2h-2.67l-1-1 1-1H20M6.67 11l1 1-1 1H4v-2h2.67M12 16.33l1 1V20h-2v-2.67l1-1M15 2H9v5.5l3 3 3-3V2zm7 7h-5.5l-3 3 3 3H22V9zM7.5 9H2v6h5.5l3-3-3-3zm4.5 4.5l-3 3V22h6v-5.5l-3-3z"
	}), 'GamepadOutlined');
	
	exports.default = _default;

/***/ },
/* 3238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 7.29V3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v4.29c0 .13.05.26.15.35l2.5 2.5c.2.2.51.2.71 0l2.5-2.5c.09-.09.14-.21.14-.35zM7.29 9H3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h4.29c.13 0 .26-.05.35-.15l2.5-2.5c.2-.2.2-.51 0-.71l-2.5-2.5C7.55 9.05 7.43 9 7.29 9zM9 16.71V21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-4.29c0-.13-.05-.26-.15-.35l-2.5-2.5c-.2-.2-.51-.2-.71 0l-2.5 2.5c-.09.09-.14.21-.14.35zm7.35-7.56l-2.5 2.5c-.2.2-.2.51 0 .71l2.5 2.5c.09.09.22.15.35.15H21c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-4.29c-.14-.01-.26.04-.36.14z"
	}), 'GamepadRounded');
	
	exports.default = _default;

/***/ },
/* 3239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z"
	}), 'GamepadSharp');
	
	exports.default = _default;

/***/ },
/* 3240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6.67 11H4v2h2.67l1-1zM13 6.67V4h-2v2.67l1 1zm-2 10.66V20h2v-2.67l-1-1zM16.33 12l1 1H20v-2h-2.67z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9 16.5V22h6v-5.5l-3-3-3 3zm4 3.5h-2v-2.67l1-1 1 1V20zm2-12.5V2H9v5.5l3 3 3-3zM11 4h2v2.67l-1 1-1-1V4zM7.5 9H2v6h5.5l3-3-3-3zm-.83 4H4v-2h2.67l1 1-1 1zm9.83-4l-3 3 3 3H22V9h-5.5zm3.5 4h-2.67l-1-1 1-1H20v2z"
	})), 'GamepadTwoTone');
	
	exports.default = _default;

/***/ },
/* 3241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z"
	}), 'Games');
	
	exports.default = _default;

/***/ },
/* 3242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 4v2.67l-1 1-1-1V4h2m7 7v2h-2.67l-1-1 1-1H20M6.67 11l1 1-1 1H4v-2h2.67M12 16.33l1 1V20h-2v-2.67l1-1M15 2H9v5.5l3 3 3-3V2zm7 7h-5.5l-3 3 3 3H22V9zM7.5 9H2v6h5.5l3-3-3-3zm4.5 4.5l-3 3V22h6v-5.5l-3-3z"
	}), 'GamesOutlined');
	
	exports.default = _default;

/***/ },
/* 3243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 7.29V3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v4.29c0 .13.05.26.15.35l2.5 2.5c.2.2.51.2.71 0l2.5-2.5c.09-.09.14-.21.14-.35zM7.29 9H3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h4.29c.13 0 .26-.05.35-.15l2.5-2.5c.2-.2.2-.51 0-.71l-2.5-2.5C7.55 9.05 7.43 9 7.29 9zM9 16.71V21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-4.29c0-.13-.05-.26-.15-.35l-2.5-2.5c-.2-.2-.51-.2-.71 0l-2.5 2.5c-.09.09-.14.21-.14.35zm7.35-7.56l-2.5 2.5c-.2.2-.2.51 0 .71l2.5 2.5c.09.09.22.15.35.15H21c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-4.29c-.14-.01-.26.04-.36.14z"
	}), 'GamesRounded');
	
	exports.default = _default;

/***/ },
/* 3244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z"
	}), 'GamesSharp');
	
	exports.default = _default;

/***/ },
/* 3245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11 17.33V20h2v-2.67l-1-1zm2-10.66V4h-2v2.67l1 1zM16.33 12l1 1H20v-2h-2.67zM4 11v2h2.67l1-1-1-1z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M2 9v6h5.5l3-3-3-3H2zm4.67 4H4v-2h2.67l1 1-1 1zM22 9h-5.5l-3 3 3 3H22V9zm-2 4h-2.67l-1-1 1-1H20v2zm-5 3.5l-3-3-3 3V22h6v-5.5zM13 20h-2v-2.67l1-1 1 1V20zM9 7.5l3 3 3-3V2H9v5.5zM11 4h2v2.67l-1 1-1-1V4z"
	})), 'GamesTwoTone');
	
	exports.default = _default;

/***/ },
/* 3246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.2496 8.0688l2.83-2.8268 14.134 14.15-2.83 2.8268zM9.4857 3.8272l2.828-2.8288 5.6576 5.656-2.828 2.8288zM.9989 12.3147l2.8284-2.8284L9.484 15.143l-2.8284 2.8284zM1 21h12v2H1z"
	}), 'Gavel');
	
	exports.default = _default;

/***/ },
/* 3247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 21h12v2H1v-2zM5.24 8.07l2.83-2.83 14.14 14.14-2.83 2.83L5.24 8.07zM12.32 1l5.66 5.66-2.83 2.83-5.66-5.66L12.32 1zM3.83 9.48l5.66 5.66-2.83 2.83L1 12.31l2.83-2.83z"
	}), 'GavelOutlined');
	
	exports.default = _default;

/***/ },
/* 3248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 21h10c.55 0 1 .45 1 1s-.45 1-1 1H2c-.55 0-1-.45-1-1s.45-1 1-1zM5.24 8.07l2.83-2.83L20.8 17.97c.78.78.78 2.05 0 2.83-.78.78-2.05.78-2.83 0L5.24 8.07zm8.49-5.66l2.83 2.83c.78.78.78 2.05 0 2.83l-1.42 1.42-5.65-5.66 1.41-1.41c.78-.79 2.05-.79 2.83-.01zm-9.9 7.07l5.66 5.66-1.41 1.41c-.78.78-2.05.78-2.83 0l-2.83-2.83c-.78-.78-.78-2.05 0-2.83l1.41-1.41z"
	}), 'GavelRounded');
	
	exports.default = _default;

/***/ },
/* 3249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 21h12v2H1v-2zM5.24 8.07l2.83-2.83 14.14 14.14-2.83 2.83L5.24 8.07zM12.32 1l5.66 5.66-2.83 2.83-5.66-5.66L12.32 1zM3.83 9.48l5.66 5.66-2.83 2.83L1 12.31l2.83-2.83z"
	}), 'GavelSharp');
	
	exports.default = _default;

/***/ },
/* 3250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 21h12v2H1v-2zM5.24 8.07l2.83-2.83 14.14 14.14-2.83 2.83L5.24 8.07zM12.32 1l5.66 5.66-2.83 2.83-5.66-5.66L12.32 1zM3.83 9.48l5.66 5.66-2.83 2.83L1 12.31l2.83-2.83z"
	}), 'GavelTwoTone');
	
	exports.default = _default;

/***/ },
/* 3251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z"
	}), 'Gesture');
	
	exports.default = _default;

/***/ },
/* 3252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z"
	}), 'GestureOutlined');
	
	exports.default = _default;

/***/ },
/* 3253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.72 6.04c.47.46 1.21.48 1.71.06.37-.32.69-.51.87-.43.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1h1.21c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25h-1.22c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3c-1.09 0-2.04.63-2.7 1.22-.53.48-.53 1.32-.02 1.82zm10.16 12.51c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z"
	}), 'GestureRounded');
	
	exports.default = _default;

/***/ },
/* 3254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z"
	}), 'GestureSharp');
	
	exports.default = _default;

/***/ },
/* 3255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z"
	}), 'GestureTwoTone');
	
	exports.default = _default;

/***/ },
/* 3256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
	}), 'GetApp');
	
	exports.default = _default;

/***/ },
/* 3257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 5v6h1.17L12 13.17 9.83 11H11V5h2m2-2H9v6H5l7 7 7-7h-4V3zm4 15H5v2h14v-2z"
	}), 'GetAppOutlined');
	
	exports.default = _default;

/***/ },
/* 3258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.59 9H15V4c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v5H7.41c-.89 0-1.34 1.08-.71 1.71l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59c.63-.63.19-1.71-.7-1.71zM5 19c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1z"
	}), 'GetAppRounded');
	
	exports.default = _default;

/***/ },
/* 3259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
	}), 'GetAppSharp');
	
	exports.default = _default;

/***/ },
/* 3260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14.17 11H13V5h-2v6H9.83L12 13.17z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 9h-4V3H9v6H5l7 7 7-7zm-8 2V5h2v6h1.17L12 13.17 9.83 11H11zm-6 7h14v2H5z"
	})), 'GetAppTwoTone');
	
	exports.default = _default;

/***/ },
/* 3261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.5 9H13v6h-1.5zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zM19 10.5V9h-4.5v6H16v-2h2v-1.5h-2v-1z"
	}), 'Gif');
	
	exports.default = _default;

/***/ },
/* 3262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.5 9H13v6h-1.5V9zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zm10 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1h3z"
	}), 'GifOutlined');
	
	exports.default = _default;

/***/ },
/* 3263 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.25 9c.41 0 .75.34.75.75v4.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-4.5c0-.41.34-.75.75-.75zM10 9.75c0-.41-.34-.75-.75-.75H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-1.25c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.75h-2v-3h2.75c.41 0 .75-.34.75-.75zm9 0c0-.41-.34-.75-.75-.75H15.5c-.55 0-1 .45-1 1v4.25c0 .41.34.75.75.75s.75-.34.75-.75V13h1.25c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H16v-1h2.25c.41 0 .75-.34.75-.75z"
	}), 'GifRounded');
	
	exports.default = _default;

/***/ },
/* 3264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.5 9H13v6h-1.5V9zM10 9H5v6h5v-3H8.5v1.5h-2v-3H10V9zm9 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1h3z"
	}), 'GifSharp');
	
	exports.default = _default;

/***/ },
/* 3265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.5 9H13v6h-1.5V9zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zm10 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1h3z",
	  opacity: ".87"
	}), 'GifTwoTone');
	
	exports.default = _default;

/***/ },
/* 3266 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 .3a12 12 0 0 0-3.8 23.4c.6.1.8-.3.8-.6v-2c-3.3.7-4-1.6-4-1.6-.6-1.4-1.4-1.8-1.4-1.8-1-.7.1-.7.1-.7 1.2 0 1.9 1.2 1.9 1.2 1 1.8 2.8 1.3 3.5 1 0-.8.4-1.3.7-1.6-2.7-.3-5.5-1.3-5.5-6 0-1.2.5-2.3 1.3-3.1-.2-.4-.6-1.6 0-3.2 0 0 1-.3 3.4 1.2a11.5 11.5 0 0 1 6 0c2.3-1.5 3.3-1.2 3.3-1.2.6 1.6.2 2.8 0 3.2.9.8 1.3 1.9 1.3 3.2 0 4.6-2.8 5.6-5.5 5.9.5.4.9 1 .9 2.2v3.3c0 .3.1.7.8.6A12 12 0 0 0 12 .3"
	}), 'GitHub');
	
	exports.default = _default;

/***/ },
/* 3267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "19.5",
	  cy: "19.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z"
	})), 'GolfCourse');
	
	exports.default = _default;

/***/ },
/* 3268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "19.5",
	  cy: "19.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z"
	})), 'GolfCourseOutlined');
	
	exports.default = _default;

/***/ },
/* 3269 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "19.5",
	  cy: "19.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M11 18.03V8.98l4.22-2.15c.73-.37.73-1.43-.01-1.79l-4.76-2.33C9.78 2.38 9 2.86 9 3.6V19c0 .55-.45 1-1 1s-1-.45-1-1v-.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97z"
	})), 'GolfCourseRounded');
	
	exports.default = _default;

/***/ },
/* 3270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "19.5",
	  cy: "19.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z"
	})), 'GolfCourseSharp');
	
	exports.default = _default;

/***/ },
/* 3271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "19.5",
	  cy: "19.5",
	  r: "1.5",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "19.5",
	  cy: "19.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z"
	})), 'GolfCourseTwoTone');
	
	exports.default = _default;

/***/ },
/* 3272 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'GpsFixed');
	
	exports.default = _default;

/***/ },
/* 3273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'GpsFixedOutlined');
	
	exports.default = _default;

/***/ },
/* 3274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V2c0-.55-.45-1-1-1s-1 .45-1 1v1.06C6.83 3.52 3.52 6.83 3.06 11H2c-.55 0-1 .45-1 1s.45 1 1 1h1.06c.46 4.17 3.77 7.48 7.94 7.94V22c0 .55.45 1 1 1s1-.45 1-1v-1.06c4.17-.46 7.48-3.77 7.94-7.94H22c.55 0 1-.45 1-1s-.45-1-1-1h-1.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'GpsFixedRounded');
	
	exports.default = _default;

/***/ },
/* 3275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'GpsFixedSharp');
	
	exports.default = _default;

/***/ },
/* 3276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "2",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm8.94-3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	})), 'GpsFixedTwoTone');
	
	exports.default = _default;

/***/ },
/* 3277 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'GpsNotFixed');
	
	exports.default = _default;

/***/ },
/* 3278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'GpsNotFixedOutlined');
	
	exports.default = _default;

/***/ },
/* 3279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V2c0-.55-.45-1-1-1s-1 .45-1 1v1.06C6.83 3.52 3.52 6.83 3.06 11H2c-.55 0-1 .45-1 1s.45 1 1 1h1.06c.46 4.17 3.77 7.48 7.94 7.94V22c0 .55.45 1 1 1s1-.45 1-1v-1.06c4.17-.46 7.48-3.77 7.94-7.94H22c.55 0 1-.45 1-1s-.45-1-1-1h-1.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'GpsNotFixedRounded');
	
	exports.default = _default;

/***/ },
/* 3280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'GpsNotFixedSharp');
	
	exports.default = _default;

/***/ },
/* 3281 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'GpsNotFixedTwoTone');
	
	exports.default = _default;

/***/ },
/* 3282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z"
	}), 'GpsOff');
	
	exports.default = _default;

/***/ },
/* 3283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-.98.11-1.91.38-2.77.78l1.53 1.53C10.46 5.13 11.22 5 12 5c3.87 0 7 3.13 7 7 0 .79-.13 1.54-.37 2.24l1.53 1.53c.4-.86.67-1.79.78-2.77H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.26 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21l1.41-1.41L4.41 2.86 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z"
	}), 'GpsOffOutlined');
	
	exports.default = _default;

/***/ },
/* 3284 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 13c.55 0 1-.45 1-1s-.45-1-1-1h-1.06c-.46-4.17-3.77-7.48-7.94-7.94V2c0-.55-.45-1-1-1s-1 .45-1 1v1.06c-.98.11-1.91.38-2.77.78l1.53 1.53C10.46 5.13 11.22 5 12 5c3.87 0 7 3.13 7 7 0 .79-.13 1.54-.37 2.24l1.53 1.53c.4-.86.67-1.79.78-2.77H22zm-1.56 5.88L5.12 3.56a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L5.04 6.3C3.97 7.62 3.26 9.23 3.06 11H2c-.55 0-1 .45-1 1s.45 1 1 1h1.06c.46 4.17 3.77 7.48 7.94 7.94V22c0 .55.45 1 1 1s1-.45 1-1v-1.06c1.77-.2 3.38-.91 4.69-1.98l1.33 1.33c.39.39 1.02.39 1.41 0 .4-.39.4-1.02.01-1.41zM12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81C15.09 18.45 13.61 19 12 19z"
	}), 'GpsOffRounded');
	
	exports.default = _default;

/***/ },
/* 3285 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-.98.11-1.91.38-2.77.78l1.53 1.53C10.46 5.13 11.22 5 12 5c3.87 0 7 3.13 7 7 0 .79-.13 1.54-.37 2.24l1.53 1.53c.4-.86.67-1.79.78-2.77H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.26 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21l1.41-1.41L4.41 2.86 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z"
	}), 'GpsOffSharp');
	
	exports.default = _default;

/***/ },
/* 3286 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-.98.11-1.91.38-2.77.78l1.53 1.53C10.46 5.13 11.22 5 12 5c3.87 0 7 3.13 7 7 0 .79-.13 1.54-.37 2.24l1.53 1.53c.4-.86.67-1.79.78-2.77H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.26 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21l1.41-1.41L4.41 2.86 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z"
	}), 'GpsOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 3287 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
	}), 'Grade');
	
	exports.default = _default;

/***/ },
/* 3288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7.13l.97 2.29.47 1.11 1.2.1 2.47.21-1.88 1.63-.91.79.27 1.18.56 2.41-2.12-1.28-1.03-.64-1.03.62-2.12 1.28.56-2.41.27-1.18-.91-.79-1.88-1.63 2.47-.21 1.2-.1.47-1.11.97-2.27M12 2L9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2z"
	}), 'GradeOutlined');
	
	exports.default = _default;

/***/ },
/* 3289 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 17.27l5.17 3.12c.38.23.85-.11.75-.54l-1.37-5.88 4.56-3.95c.33-.29.16-.84-.29-.88l-6.01-.51-2.35-5.54c-.17-.41-.75-.41-.92 0L9.19 8.63l-6.01.51c-.44.04-.62.59-.28.88l4.56 3.95-1.37 5.88c-.1.43.37.77.75.54L12 17.27z"
	}), 'GradeRounded');
	
	exports.default = _default;

/***/ },
/* 3290 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27z"
	}), 'GradeSharp');
	
	exports.default = _default;

/***/ },
/* 3291 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17.11 10.83l-2.47-.21-1.2-.1-.47-1.11L12 7.13l-.97 2.28-.47 1.11-1.2.1-2.47.21 1.88 1.63.91.79-.27 1.17-.57 2.42 2.13-1.28 1.03-.63 1.03.63 2.13 1.28-.57-2.42-.27-1.17.91-.79z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.64-7.03L22 9.24zm-7.41 5.18l.56 2.41-2.12-1.28-1.03-.62-1.03.62-2.12 1.28.56-2.41.27-1.18-.91-.79-1.88-1.63 2.47-.21 1.2-.1.47-1.11.97-2.27.97 2.29.47 1.11 1.2.1 2.47.21-1.88 1.63-.91.79.27 1.16z"
	})), 'GradeTwoTone');
	
	exports.default = _default;

/***/ },
/* 3292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z"
	}), 'Gradient');
	
	exports.default = _default;

/***/ },
/* 3293 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 9h2v2h-2V9zm-2 2h2v2H9v-2zm4 0h2v2h-2v-2zm2-2h2v2h-2V9zM7 9h2v2H7V9zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z"
	}), 'GradientOutlined');
	
	exports.default = _default;

/***/ },
/* 3294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 9h2v2h-2V9zm-2 2h2v2H9v-2zm4 0h2v2h-2v-2zm2-2h2v2h-2V9zM7 9h2v2H7V9zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v5z"
	}), 'GradientRounded');
	
	exports.default = _default;

/***/ },
/* 3295 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 9h2v2h-2V9zm-2 2h2v2H9v-2zm4 0h2v2h-2v-2zm2-2h2v2h-2V9zM7 9h2v2H7V9zm14-6H3v18h18V3zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z"
	}), 'GradientSharp');
	
	exports.default = _default;

/***/ },
/* 3296 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 11h2v2h-2zm6 10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zM5 13h2v-2H5V5h14v6h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2zm2-4h2v2H7zm8 0h2v2h-2zm-4 0h2v2h-2zm-2 2h2v2H9z"
	}), 'GradientTwoTone');
	
	exports.default = _default;

/***/ },
/* 3297 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'Grain');
	
	exports.default = _default;

/***/ },
/* 3298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'GrainOutlined');
	
	exports.default = _default;

/***/ },
/* 3299 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'GrainRounded');
	
	exports.default = _default;

/***/ },
/* 3300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'GrainSharp');
	
	exports.default = _default;

/***/ },
/* 3301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm8 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0-12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-8 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
	}), 'GrainTwoTone');
	
	exports.default = _default;

/***/ },
/* 3302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z"
	}), 'GraphicEq');
	
	exports.default = _default;

/***/ },
/* 3303 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z"
	}), 'GraphicEqOutlined');
	
	exports.default = _default;

/***/ },
/* 3304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 18c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1zm4 4c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1s-1 .45-1 1v18c0 .55.45 1 1 1zm-8-8c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1zm12 4c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1zm3-7v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1z"
	}), 'GraphicEqRounded');
	
	exports.default = _default;

/***/ },
/* 3305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z"
	}), 'GraphicEqSharp');
	
	exports.default = _default;

/***/ },
/* 3306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z"
	}), 'GraphicEqTwoTone');
	
	exports.default = _default;

/***/ },
/* 3307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 4v1.45l2 2V4h4v4h-3.45l2 2H14v1.45l2 2V10h4v4h-3.45l2 2H20v1.45l2 2V4c0-1.1-.9-2-2-2H4.55l2 2H8zm8 0h4v4h-4V4zM1.27 1.27L0 2.55l2 2V20c0 1.1.9 2 2 2h15.46l2 2 1.27-1.27L1.27 1.27zM10 12.55L11.45 14H10v-1.45zm-6-6L5.45 8H4V6.55zM8 20H4v-4h4v4zm0-6H4v-4h3.45l.55.55V14zm6 6h-4v-4h3.45l.55.54V20zm2 0v-1.46L17.46 20H16z"
	}), 'GridOff');
	
	exports.default = _default;

/***/ },
/* 3308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 4v.89l2 2V4h4v4h-2.89l2 2H14v.89l2 2V10h4v4h-2.89l2 2H20v.89l2 2V4c0-1.1-.9-2-2-2H5.11l2 2H8zm8 0h4v4h-4V4zM1.41 1.14L0 2.55l2 2V20c0 1.1.9 2 2 2h15.45l2.01 2.01 1.41-1.41L1.41 1.14zM10 12.55L11.45 14H10v-1.45zm-6-6L5.45 8H4V6.55zM8 20H4v-4h4v4zm0-6H4v-4h3.45l.55.55V14zm6 6h-4v-4h3.45l.55.55V20zm2 0v-1.45L17.45 20H16z"
	}), 'GridOffOutlined');
	
	exports.default = _default;

/***/ },
/* 3309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 4v.89l2 2V4h4v4h-2.89l2 2H14v.89l2 2V10h4v4h-2.89l2 2H20v.89l2 2V4c0-1.1-.9-2-2-2H5.11l2 2H8zm8 0h3c.55 0 1 .45 1 1v3h-4V4zm6.16 17.88L2.12 1.84a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L2 4.55V20c0 1.1.9 2 2 2h15.45l1.3 1.3c.39.39 1.02.39 1.41 0 .39-.39.39-1.03 0-1.42zM10 12.55L11.45 14H10v-1.45zm-6-6L5.45 8H4V6.55zM8 20H5c-.55 0-1-.45-1-1v-3h4v4zm0-6H4v-4h3.45l.55.55V14zm6 6h-4v-4h3.45l.55.55V20zm2 0v-1.45L17.45 20H16z"
	}), 'GridOffRounded');
	
	exports.default = _default;

/***/ },
/* 3310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 4v.89l2 2V4h4v4h-2.89l2 2H14v.89l2 2V10h4v4h-2.89l2 2H20v.89l2 2V2H5.11l2 2H8zm8 0h4v4h-4V4zM1.41 1.14L0 2.55l2 2V22h17.45l2.01 2.01 1.41-1.41L1.41 1.14zM10 12.55L11.45 14H10v-1.45zm-6-6L5.45 8H4V6.55zM8 20H4v-4h4v4zm0-6H4v-4h3.45l.55.55V14zm6 6h-4v-4h3.45l.55.55V20zm2 0v-1.45L17.45 20H16z"
	}), 'GridOffSharp');
	
	exports.default = _default;

/***/ },
/* 3311 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 14v-4h-4v2.89L17.11 14zm-10-1.45V14h1.45zM14 10h-.89l.89.89zm5.11 6l.89.89V16zM8 4h-.89l.89.89zm6 4V4h-4v2.89L11.11 8zm2-4h4v4h-4zm-6 12v4h4v-3.45l-.55-.55zm-6-6v4h4v-3.45L7.45 10zm12 10h1.45L16 18.55zM4 16h4v4H4zm0-9.45V8h1.45z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M8 4v.89l2 2V4h4v4h-2.89l2 2H14v.89l2 2V10h4v4h-2.89l2 2H20v.89l2 2V4c0-1.1-.9-2-2-2H5.11l2 2H8zm8 0h4v4h-4V4zM1.41 1.14L0 2.55l2 2V20c0 1.1.9 2 2 2h15.45l2.01 2.01 1.41-1.41L1.41 1.14zM10 12.55L11.45 14H10v-1.45zm-6-6L5.45 8H4V6.55zM8 20H4v-4h4v4zm0-6H4v-4h3.45l.55.55V14zm6 6h-4v-4h3.45l.55.55V20zm2 0v-1.45L17.45 20H16z"
	})), 'GridOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 3312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z"
	}), 'GridOn');
	
	exports.default = _default;

/***/ },
/* 3313 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z"
	}), 'GridOnOutlined');
	
	exports.default = _default;

/***/ },
/* 3314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H5c-.55 0-1-.45-1-1v-3h4v4zm0-6H4v-4h4v4zm0-6H4V5c0-.55.45-1 1-1h3v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm5 12h-3v-4h4v3c0 .55-.45 1-1 1zm1-6h-4v-4h4v4zm0-6h-4V4h3c.55 0 1 .45 1 1v3z"
	}), 'GridOnRounded');
	
	exports.default = _default;

/***/ },
/* 3315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H2v20h20V2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z"
	}), 'GridOnSharp');
	
	exports.default = _default;

/***/ },
/* 3316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M10 10h4v4h-4zm0 6h4v4h-4zM4 4h4v4H4zm0 6h4v4H4zm0 6h4v4H4zM16 4h4v4h-4zm0 6h4v4h-4zm0 6h4v4h-4zM10 4h4v4h-4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z"
	})), 'GridOnTwoTone');
	
	exports.default = _default;

/***/ },
/* 3317 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
	}), 'Group');
	
	exports.default = _default;

/***/ },
/* 3318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z"
	}), 'GroupAdd');
	
	exports.default = _default;

/***/ },
/* 3319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 15v-3h3v-2H5V7H3v3H0v2h3v3zm7-1.25c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM7.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H7.34zM12 12c1.93 0 3.5-1.57 3.5-3.5S13.93 5 12 5 8.5 6.57 8.5 8.5 10.07 12 12 12zm0-5c.83 0 1.5.67 1.5 1.5S12.83 10 12 10s-1.5-.67-1.5-1.5S11.17 7 12 7zm5 5c1.93 0 3.5-1.57 3.5-3.5S18.93 5 17 5c-.24 0-.48.02-.71.07.76.94 1.21 2.13 1.21 3.43 0 1.3-.47 2.48-1.23 3.42.24.05.48.08.73.08zm2.32 2.02c1 .81 1.68 1.87 1.68 3.23V19h3v-1.75c0-1.69-2.44-2.76-4.68-3.23z"
	}), 'GroupAddOutlined');
	
	exports.default = _default;

/***/ },
/* 3320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 10H5V8c0-.55-.45-1-1-1s-1 .45-1 1v2H1c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1zm11 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5s-3 1.34-3 3 1.34 3 3 3zm0 2c-2 0-6 1-6 3v1c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-1c0-2-4-3-6-3zm6.62.16c.83.73 1.38 1.66 1.38 2.84v1.5c0 .17-.02.34-.05.5h2.55c.28 0 .5-.22.5-.5V16c0-1.54-2.37-2.49-4.38-2.84z"
	}), 'GroupAddRounded');
	
	exports.default = _default;

/***/ },
/* 3321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5s-3 1.34-3 3 1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z"
	}), 'GroupAddSharp');
	
	exports.default = _default;

/***/ },
/* 3322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 15v-3h3v-2H5V7H3v3H0v2h3v3z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "8.5",
	  r: "1.5",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M7.34 17h9.32c-.84-.58-2.87-1.25-4.66-1.25s-3.82.67-4.66 1.25z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 12c1.93 0 3.5-1.57 3.5-3.5S13.93 5 12 5 8.5 6.57 8.5 8.5 10.07 12 12 12zm0-5c.83 0 1.5.67 1.5 1.5S12.83 10 12 10s-1.5-.67-1.5-1.5S11.17 7 12 7zm0 6.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM7.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H7.34zM17 12c1.93 0 3.5-1.57 3.5-3.5S18.93 5 17 5c-.24 0-.48.02-.71.07.76.94 1.21 2.13 1.21 3.43 0 1.3-.47 2.48-1.23 3.42.24.05.48.08.73.08zm2.32 2.02c1 .81 1.68 1.87 1.68 3.23V19h3v-1.75c0-1.69-2.44-2.76-4.68-3.23z"
	})), 'GroupAddTwoTone');
	
	exports.default = _default;

/***/ },
/* 3323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 13.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zM9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm7.04 6.81c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z"
	}), 'GroupOutlined');
	
	exports.default = _default;

/***/ },
/* 3324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V18c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05.02.01.03.03.04.04 1.14.83 1.93 1.94 1.93 3.41V18c0 .35-.07.69-.18 1H22c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5z"
	}), 'GroupRounded');
	
	exports.default = _default;

/***/ },
/* 3325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
	}), 'GroupSharp');
	
	exports.default = _default;

/***/ },
/* 3326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "9",
	  cy: "8.5",
	  r: "1.5",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4.34 17h9.32c-.84-.58-2.87-1.25-4.66-1.25s-3.82.67-4.66 1.25z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm0 6.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zm11.7-3.19c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z"
	})), 'GroupTwoTone');
	
	exports.default = _default;

/***/ },
/* 3327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM9.5 8c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8zm6.5 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
	}), 'GroupWork');
	
	exports.default = _default;

/***/ },
/* 3328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), _react.default.createElement("circle", {
	  cx: "8",
	  cy: "14",
	  r: "2"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "8",
	  r: "2"
	}), _react.default.createElement("circle", {
	  cx: "16",
	  cy: "14",
	  r: "2"
	})), 'GroupWorkOutlined');
	
	exports.default = _default;

/***/ },
/* 3329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM9.5 8c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8zm6.5 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
	}), 'GroupWorkRounded');
	
	exports.default = _default;

/***/ },
/* 3330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM9.5 8c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8zm6.5 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
	}), 'GroupWorkSharp');
	
	exports.default = _default;

/***/ },
/* 3331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zM8 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm4-6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm4 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), _react.default.createElement("circle", {
	  cx: "8",
	  cy: "14",
	  r: "2"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "8",
	  r: "2"
	}), _react.default.createElement("circle", {
	  cx: "16",
	  cy: "14",
	  r: "2"
	})), 'GroupWorkTwoTone');
	
	exports.default = _default;

/***/ },
/* 3332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z"
	}), 'Hd');
	
	exports.default = _default;

/***/ },
/* 3333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7.5 13h2v2H11V9H9.5v2.5h-2V9H6v6h1.5zM18 14v-4c0-.55-.45-1-1-1h-4v6h4c.55 0 1-.45 1-1zm-1.5-.5h-2v-3h2v3z"
	}), 'HdOutlined');
	
	exports.default = _default;

/***/ },
/* 3334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8.75 12c-.41 0-.75-.34-.75-.75V13h-2v1.25c0 .41-.34.75-.75.75S6 14.66 6 14.25v-4.5c0-.41.34-.75.75-.75s.75.34.75.75v1.75h2V9.75c0-.41.34-.75.75-.75s.75.34.75.75v4.5c0 .41-.34.75-.75.75zm3.25-6H17c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-3.5c-.28 0-.5-.22-.5-.5v-5c0-.28.22-.5.5-.5zm1 4.5h2v-3h-2v3z"
	}), 'HdRounded');
	
	exports.default = _default;

/***/ },
/* 3335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zM11 15H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z"
	}), 'HdSharp');
	
	exports.default = _default;

/***/ },
/* 3336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14.5 10.5h2v3h-2zM19 5H5v14h14V5zm-8 10H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm7-1c0 .55-.45 1-1 1h-4V9h4c.55 0 1 .45 1 1v4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 21h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2zM5 5h14v14H5V5zm4.5 6.5h-2V9H6v6h1.5v-2h2v2H11V9H9.5zM17 9h-4v6h4c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-.5 4.5h-2v-3h2v3z"
	})), 'HdTwoTone');
	
	exports.default = _default;

/***/ },
/* 3337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.5 15v-2h1.1l.9 2H21l-.9-2.1c.5-.2.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5H16v4.9l1.1 1.1h.4zm0-4.5h2v1h-2v-1zm-4.5 0v.4l1.5 1.5v-1.9c0-.8-.7-1.5-1.5-1.5h-1.9l1.5 1.5h.4zm-3.5-1l-7-7-1.1 1L6.9 9h-.4v2h-2V9H3v6h1.5v-2.5h2V15H8v-4.9l1.5 1.5V15h3.4l7.6 7.6 1.1-1.1-12.1-12z"
	}), 'HdrOff');
	
	exports.default = _default;

/***/ },
/* 3338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.5 15v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5H16v4.86L17.14 15h.36zm0-4.5h2v1h-2v-1zm-4.5 0v.36l1.5 1.5V10.5c0-.8-.7-1.5-1.5-1.5h-1.86l1.5 1.5H13zM2.51 2.49L1.45 3.55 6.9 9h-.4v2h-2V9H3v6h1.5v-2.5h2V15H8v-4.9l1.5 1.5V15h3.4l7.6 7.6 1.06-1.06z"
	}), 'HdrOffOutlined');
	
	exports.default = _default;

/***/ },
/* 3339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.5 14.25V13h1.1l.72 1.59c.11.25.36.41.63.41.5 0 .83-.51.64-.96l-.49-1.14c.5-.3.9-.8.9-1.4v-1c0-.83-.67-1.5-1.5-1.5H17c-.55 0-1 .45-1 1v3.9l1.04 1.04c.27-.11.46-.38.46-.69zm0-3.75h2v1h-2v-1zm-4.5 0v.4l1.5 1.5v-1.9c0-.82-.68-1.5-1.5-1.5h-1.9l1.5 1.5h.4zm8.03 10.53l-18-18c-.29-.29-.76-.29-1.05 0-.29.29-.29.76 0 1.05l4.98 4.98c-.27.11-.46.38-.46.69V11h-2V9.75c0-.41-.34-.75-.75-.75S3 9.34 3 9.75v4.5c0 .41.34.75.75.75s.75-.34.75-.75V12.5h2v1.75c0 .41.34.75.75.75s.75-.34.75-.75V10.1l1.5 1.5v2.9c0 .28.22.5.5.5h2.5c.12 0 .24-.01.36-.04l7.11 7.11c.29.29.76.29 1.05 0 .29-.28.29-.75.01-1.04z"
	}), 'HdrOffRounded');
	
	exports.default = _default;

/***/ },
/* 3340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.5 15v-2h1.1l.9 2H21l-.9-2.1h.9V9h-5v4.86L17.14 15h.36zm0-4.5h2v1h-2v-1zm-4.5 0v.36l1.5 1.5V10.5c0-.8-.7-1.5-1.5-1.5h-1.86l1.5 1.5H13zM2.51 2.49L1.45 3.55 6.9 9h-.4v2h-2V9H3v6h1.5v-2.5h2V15H8v-4.9l1.5 1.5V15h3.4l7.6 7.6 1.06-1.06z"
	}), 'HdrOffSharp');
	
	exports.default = _default;

/***/ },
/* 3341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.5 15v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5H16v4.86L17.14 15h.36zm0-4.5h2v1h-2v-1zm-4.5 0v.36l1.5 1.5V10.5c0-.8-.7-1.5-1.5-1.5h-1.86l1.5 1.5H13zM2.51 2.49L1.45 3.55 6.9 9h-.4v2h-2V9H3v6h1.5v-2.5h2V15H8v-4.9l1.5 1.5V15h3.4l7.6 7.6 1.06-1.06z"
	}), 'HdrOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 3342 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 11.5v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2zM13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5h-2v-3h2v3z"
	}), 'HdrOn');
	
	exports.default = _default;

/***/ },
/* 3343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 11.5v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2zM13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5h-2v-3h2v3z"
	}), 'HdrOnOutlined');
	
	exports.default = _default;

/***/ },
/* 3344 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.25 9c-.41 0-.75.34-.75.75V11h-2V9.75c0-.41-.34-.75-.75-.75S3 9.34 3 9.75v4.5c0 .41.34.75.75.75s.75-.34.75-.75V12.5h2v1.75c0 .41.34.75.75.75s.75-.34.75-.75v-4.5C8 9.34 7.66 9 7.25 9zM21 11.5v-1c0-.83-.67-1.5-1.5-1.5H17c-.55 0-1 .45-1 1v4.25c0 .41.34.75.75.75s.75-.34.75-.75V13h1.1l.72 1.59c.11.25.36.41.63.41.5 0 .83-.51.64-.96l-.49-1.14c.5-.3.9-.8.9-1.4zm-3.5 0v-1h2v1h-2zM13 9h-3c-.28 0-.5.22-.5.5v5c0 .28.22.5.5.5h3c.82 0 1.5-.68 1.5-1.5v-3c0-.82-.68-1.5-1.5-1.5zm0 4.5h-2v-3h2v3z"
	}), 'HdrOnRounded');
	
	exports.default = _default;

/***/ },
/* 3345 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 12.9V9h-5v6h1.5v-2h1.1l.9 2H21l-.9-2.1h.9zm-1.5-1.4h-2v-1h2v1zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2zM13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5h-2v-3h2v3z"
	}), 'HdrOnSharp');
	
	exports.default = _default;

/***/ },
/* 3346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5h-2v-3h2v3zm8-2v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5z"
	}), 'HdrOnTwoTone');
	
	exports.default = _default;

/***/ },
/* 3347 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zM5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'HdrStrong');
	
	exports.default = _default;

/***/ },
/* 3348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zM5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'HdrStrongOutlined');
	
	exports.default = _default;

/***/ },
/* 3349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zM5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'HdrStrongRounded');
	
	exports.default = _default;

/***/ },
/* 3350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zM5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'HdrStrongSharp');
	
	exports.default = _default;

/***/ },
/* 3351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zM5 16c2.21 0 4-1.79 4-4S7.21 8 5 8s-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"
	})), 'HdrStrongTwoTone');
	
	exports.default = _default;

/***/ },
/* 3352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm12-2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
	}), 'HdrWeak');
	
	exports.default = _default;

/***/ },
/* 3353 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm12-2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
	}), 'HdrWeakOutlined');
	
	exports.default = _default;

/***/ },
/* 3354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm12-2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
	}), 'HdrWeakRounded');
	
	exports.default = _default;

/***/ },
/* 3355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm12-2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
	}), 'HdrWeakSharp');
	
	exports.default = _default;

/***/ },
/* 3356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
	}), _react.default.createElement("circle", {
	  cx: "5",
	  cy: "12",
	  r: "2",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	})), 'HdrWeakTwoTone');
	
	exports.default = _default;

/***/ },
/* 3357 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z"
	}), 'Headset');
	
	exports.default = _default;

/***/ },
/* 3358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9z"
	}), 'HeadsetMic');
	
	exports.default = _default;

/***/ },
/* 3359 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 14v4h-2v-4h2M7 14v4H6c-.55 0-1-.45-1-1v-3h2m5-13c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9z"
	}), 'HeadsetMicOutlined');
	
	exports.default = _default;

/***/ },
/* 3360 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.4 1.02C6.62 1.33 3 5.52 3 10.31V17c0 1.66 1.34 3 3 3h1c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2H5v-1.71C5 6.45 7.96 3.11 11.79 3 15.76 2.89 19 6.06 19 10v2h-2c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h2v1h-6c-.55 0-1 .45-1 1s.45 1 1 1h5c1.66 0 3-1.34 3-3V10c0-5.17-4.36-9.32-9.6-8.98z"
	}), 'HeadsetMicRounded');
	
	exports.default = _default;

/***/ },
/* 3361 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.4 1.02C6.62 1.33 3 5.51 3 10.31V20h6v-8H5v-1.71C5 6.45 7.96 3.11 11.79 3 15.76 2.89 19 6.06 19 10v2h-4v8h4v1h-7v2h9V10c0-5.17-4.36-9.32-9.6-8.98z"
	}), 'HeadsetMicSharp');
	
	exports.default = _default;

/***/ },
/* 3362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 17c0 .55.45 1 1 1h1v-4H5v3zm12-3h2v4h-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9zM7 14v4H6c-.55 0-1-.45-1-1v-3h2zm12 4h-2v-4h2v4z"
	})), 'HeadsetMicTwoTone');
	
	exports.default = _default;

/***/ },
/* 3363 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 14v3c0 .55-.45 1-1 1h-1v-4h2M7 14v4H6c-.55 0-1-.45-1-1v-3h2m5-13c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z"
	}), 'HeadsetOutlined');
	
	exports.default = _default;

/***/ },
/* 3364 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.4 1.02C6.62 1.33 3 5.52 3 10.31V17c0 1.66 1.34 3 3 3h1c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2H5v-1.71C5 6.45 7.96 3.11 11.79 3 15.76 2.89 19 6.06 19 10v2h-2c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h1c1.66 0 3-1.34 3-3v-7c0-5.17-4.36-9.32-9.6-8.98z"
	}), 'HeadsetRounded');
	
	exports.default = _default;

/***/ },
/* 3365 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.4 1.02C6.62 1.33 3 5.52 3 10.31V20h6v-8H5v-1.71C5 6.45 7.96 3.11 11.79 3 15.76 2.89 19 6.06 19 10v2h-4v8h6V10c0-5.17-4.36-9.32-9.6-8.98z"
	}), 'HeadsetSharp');
	
	exports.default = _default;

/***/ },
/* 3366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17 18h1c.55 0 1-.45 1-1v-3h-2v4zM5 17c0 .55.45 1 1 1h1v-4H5v3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9zM7 14v4H6c-.55 0-1-.45-1-1v-3h2zm12 3c0 .55-.45 1-1 1h-1v-4h2v3z"
	})), 'HeadsetTwoTone');
	
	exports.default = _default;

/***/ },
/* 3367 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.73 12.02l3.98-3.98c.39-.39.39-1.02 0-1.41l-4.34-4.34a.9959.9959 0 00-1.41 0l-3.98 3.98L8 2.29C7.8 2.1 7.55 2 7.29 2c-.25 0-.51.1-.7.29L2.25 6.63c-.39.39-.39 1.02 0 1.41l3.98 3.98L2.25 16c-.39.39-.39 1.02 0 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4.34-4.34c.39-.39.39-1.02 0-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z"
	}), 'Healing');
	
	exports.default = _default;

/***/ },
/* 3368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.73 12.02l3.98-3.98c.39-.39.39-1.02 0-1.41l-4.34-4.34a.9959.9959 0 00-1.41 0l-3.98 3.98L8 2.29C7.8 2.1 7.55 2 7.29 2c-.25 0-.51.1-.7.29L2.25 6.63c-.39.39-.39 1.02 0 1.41l3.98 3.98L2.25 16c-.39.39-.39 1.02 0 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4.34-4.34c.39-.39.39-1.02 0-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z"
	}), 'HealingOutlined');
	
	exports.default = _default;

/***/ },
/* 3369 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.73 12.02l3.98-3.98c.39-.39.39-1.02 0-1.41l-4.34-4.34a.9959.9959 0 00-1.41 0l-3.98 3.98L8 2.29C7.8 2.1 7.55 2 7.29 2c-.25 0-.51.1-.7.29L2.25 6.63c-.39.39-.39 1.02 0 1.41l3.98 3.98L2.25 16c-.39.39-.39 1.02 0 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4.34-4.34c.39-.39.39-1.02 0-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z"
	}), 'HealingRounded');
	
	exports.default = _default;

/***/ },
/* 3370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.74 12.01l4.68-4.68-5.75-5.75-4.68 4.68L7.3 1.58 1.55 7.34l4.68 4.69-4.68 4.68 5.75 5.75 4.68-4.68 4.69 4.69 5.76-5.76-4.69-4.7zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z"
	}), 'HealingSharp');
	
	exports.default = _default;

/***/ },
/* 3371 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M13.03 16.72l3.63 3.62 3.62-3.63-3.62-3.62zM7.29 3.71L3.66 7.34l3.63 3.62 3.62-3.63z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17.73 12.02l3.98-3.98c.39-.39.39-1.02 0-1.41l-4.34-4.34a.9959.9959 0 00-1.41 0l-3.98 3.98L8 2.29C7.8 2.1 7.55 2 7.29 2c-.25 0-.51.1-.7.29L2.25 6.63c-.39.39-.39 1.02 0 1.41l3.98 3.98L2.25 16c-.39.39-.39 1.02 0 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29s.51-.1.71-.29l4.34-4.34c.39-.39.39-1.02 0-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z"
	})), 'HealingTwoTone');
	
	exports.default = _default;

/***/ },
/* 3372 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55.51.23 1.07.35 1.64.35 2.21 0 4-1.79 4-4h-2c0 1.1-.9 2-2 2zM7.64 2.64L6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36zM11.5 9c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5-2.5 1.12-2.5 2.5z"
	}), 'Hearing');
	
	exports.default = _default;

/***/ },
/* 3373 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55.51.23 1.07.35 1.64.35 2.21 0 4-1.79 4-4h-2c0 1.1-.9 2-2 2zM7.64 2.64L6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36zM11.5 9c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5-2.5 1.12-2.5 2.5z"
	}), 'HearingOutlined');
	
	exports.default = _default;

/***/ },
/* 3374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5 2.56 0 4.63 1.85 4.95 4.31.06.4.41.69.82.69h.34c.5 0 .89-.44.83-.94C20.49 4.59 17.61 2 14 2c-3.93 0-7 3.07-7 7 0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55.51.23 1.07.35 1.64.35 1.84 0 3.39-1.24 3.86-2.93.14-.54-.25-1.07-.81-1.07h-.35c-.38 0-.68.27-.81.63-.26.79-1.01 1.37-1.89 1.37zM6.97 1.97c-.43-.43-1.12-.39-1.5.07C3.93 3.94 3 6.36 3 9s.93 5.06 2.47 6.95c.38.46 1.07.5 1.49.08.36-.36.39-.93.07-1.32C5.77 13.16 5 11.17 5 9s.77-4.16 2.04-5.7c.33-.4.29-.97-.07-1.33zM11.5 9c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5-2.5 1.12-2.5 2.5z"
	}), 'HearingRounded');
	
	exports.default = _default;

/***/ },
/* 3375 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55.51.23 1.07.35 1.64.35 2.21 0 4-1.79 4-4h-2c0 1.1-.9 2-2 2zM7.64 2.64L6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36zM11.5 9c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5-2.5 1.12-2.5 2.5z"
	}), 'HearingSharp');
	
	exports.default = _default;

/***/ },
/* 3376 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7.64 2.64L6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36z"
	}), _react.default.createElement("circle", {
	  cx: "14",
	  cy: "9",
	  r: "2.5"
	}), _react.default.createElement("path", {
	  d: "M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55.51.23 1.07.35 1.64.35 2.21 0 4-1.79 4-4h-2c0 1.1-.9 2-2 2z"
	})), 'HearingTwoTone');
	
	exports.default = _default;

/***/ },
/* 3377 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 6.99h3L12 3 8 6.99h3v10.02H8L12 21l4-3.99h-3z"
	}), 'Height');
	
	exports.default = _default;

/***/ },
/* 3378 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 6.99h3L12 3 8 6.99h3v10.02H8L12 21l4-3.99h-3z"
	}), 'HeightOutlined');
	
	exports.default = _default;

/***/ },
/* 3379 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 6.99h1.79c.45 0 .67-.54.35-.85l-2.79-2.78c-.2-.19-.51-.19-.71 0L8.86 6.14c-.32.31-.1.85.35.85H11v10.02H9.21c-.45 0-.67.54-.35.85l2.79 2.78c.2.19.51.19.71 0l2.79-2.78c.32-.31.09-.85-.35-.85H13V6.99z"
	}), 'HeightRounded');
	
	exports.default = _default;

/***/ },
/* 3380 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 6.99h3L12 3 8 6.99h3v10.02H8L12 21l4-3.99h-3z"
	}), 'HeightSharp');
	
	exports.default = _default;

/***/ },
/* 3381 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 6.99h3L12 3 8 6.99h3v10.02H8L12 21l4-3.99h-3z"
	}), 'HeightTwoTone');
	
	exports.default = _default;

/***/ },
/* 3382 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
	}), 'Help');
	
	exports.default = _default;

/***/ },
/* 3383 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
	}), 'HelpOutline');
	
	exports.default = _default;

/***/ },
/* 3384 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
	}), 'HelpOutlineOutlined');
	
	exports.default = _default;

/***/ },
/* 3385 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-4h2v2h-2zm1.61-9.96c-2.06-.3-3.88.97-4.43 2.79-.18.58.26 1.17.87 1.17h.2c.41 0 .74-.29.88-.67.32-.89 1.27-1.5 2.3-1.28.95.2 1.65 1.13 1.57 2.1-.1 1.34-1.62 1.63-2.45 2.88 0 .01-.01.01-.01.02-.01.02-.02.03-.03.05-.09.15-.18.32-.25.5-.01.03-.03.05-.04.08-.01.02-.01.04-.02.07-.12.34-.2.75-.2 1.25h2c0-.42.11-.77.28-1.07.02-.03.03-.06.05-.09.08-.14.18-.27.28-.39.01-.01.02-.03.03-.04.1-.12.21-.23.33-.34.96-.91 2.26-1.65 1.99-3.56-.24-1.74-1.61-3.21-3.35-3.47z"
	}), 'HelpOutlineRounded');
	
	exports.default = _default;

/***/ },
/* 3386 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
	}), 'HelpOutlineSharp');
	
	exports.default = _default;

/***/ },
/* 3387 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 16h2v2h-2zm1-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
	}), 'HelpOutlineTwoTone');
	
	exports.default = _default;

/***/ },
/* 3388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
	}), 'HelpOutlined');
	
	exports.default = _default;

/***/ },
/* 3389 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92c-.5.51-.86.97-1.04 1.69-.08.32-.13.68-.13 1.14h-2v-.5c0-.46.08-.9.22-1.31.2-.58.53-1.1.95-1.52l1.24-1.26c.46-.44.68-1.1.55-1.8-.13-.72-.69-1.33-1.39-1.53-1.11-.31-2.14.32-2.47 1.27-.12.37-.43.65-.82.65h-.3C8.4 9 8 8.44 8.16 7.88c.43-1.47 1.68-2.59 3.23-2.83 1.52-.24 2.97.55 3.87 1.8 1.18 1.63.83 3.38-.19 4.4z"
	}), 'HelpRounded');
	
	exports.default = _default;

/***/ },
/* 3390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
	}), 'HelpSharp');
	
	exports.default = _default;

/***/ },
/* 3391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm1 14h-2v-2h2v2zm0-3h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11 16h2v2h-2zm1-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
	})), 'HelpTwoTone');
	
	exports.default = _default;

/***/ },
/* 3392 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 11H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm7-1c0 .55-.45 1-1 1h-.75v1.5h-1.5V15H14c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v4zm-3.5-.5h2v-3h-2v3z"
	}), 'HighQuality');
	
	exports.default = _default;

/***/ },
/* 3393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12zM7.5 13h2v2H11V9H9.5v2.5h-2V9H6v6h1.5zm6.5 2h.75v1.5h1.5V15H17c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-4.5h2v3h-2v-3z"
	}), 'HighQualityOutlined');
	
	exports.default = _default;

/***/ },
/* 3394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8.75 11c-.41 0-.75-.34-.75-.75V13h-2v1.25c0 .41-.34.75-.75.75S6 14.66 6 14.25v-4.5c0-.41.34-.75.75-.75s.75.34.75.75v1.75h2V9.75c0-.41.34-.75.75-.75s.75.34.75.75v4.5c0 .41-.34.75-.75.75zM18 14c0 .55-.45 1-1 1h-.75v.75c0 .41-.34.75-.75.75s-.75-.34-.75-.75V15H14c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v4zm-3.5-.5h2v-3h-2v3z"
	}), 'HighQualityRounded');
	
	exports.default = _default;

/***/ },
/* 3395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 4H3v16h18V4zM11 15H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm7 0h-1.75v1.5h-1.5V15H13V9h5v6zm-3.5-1.5h2v-3h-2v3z"
	}), 'HighQualitySharp');
	
	exports.default = _default;

/***/ },
/* 3396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 6H5v12h14V6zm-8 9H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm7-1c0 .55-.45 1-1 1h-.75v1.5h-1.5V15H14c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v4zm-3.5-3.5h2v3h-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 6v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm2 0h14v12H5V6zm4.5 5.5h-2V9H6v6h1.5v-2h2v2H11V9H9.5zM17 9h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h.75v1.5h1.5V15H17c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-.5 4.5h-2v-3h2v3z"
	})), 'HighQualityTwoTone');
	
	exports.default = _default;

/***/ },
/* 3397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 14l3 3v5h6v-5l3-3V9H6v5zm5-12h2v3h-2V2zM3.5 5.88l1.41-1.41 2.12 2.12L5.62 8 3.5 5.88zm13.46.71l2.12-2.12 1.41 1.41L18.38 8l-1.42-1.41z"
	}), 'Highlight');
	
	exports.default = _default;

/***/ },
/* 3398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'HighlightOff');
	
	exports.default = _default;

/***/ },
/* 3399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'HighlightOffOutlined');
	
	exports.default = _default;

/***/ },
/* 3400 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.89 8.7L12 10.59 10.11 8.7a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 8.7 13.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l1.89 1.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l1.89-1.89c.39-.39.39-1.02 0-1.41-.39-.38-1.03-.38-1.41 0zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'HighlightOffRounded');
	
	exports.default = _default;

/***/ },
/* 3401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'HighlightOffSharp');
	
	exports.default = _default;

/***/ },
/* 3402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm4 10.59L14.59 16 12 13.41 9.41 16 8 14.59 10.59 12 8 9.41 9.41 8 12 10.59 14.59 8 16 9.41 13.41 12 16 14.59z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	})), 'HighlightOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 3403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 14l3 3v5h6v-5l3-3V9H6v5zm2-3h8v2.17l-3 3V20h-2v-3.83l-3-3V11zm3-9h2v3h-2zM3.502 5.874L4.916 4.46l2.122 2.12-1.414 1.415zm13.458.708l2.123-2.12 1.413 1.416-2.123 2.12z"
	}), 'HighlightOutlined');
	
	exports.default = _default;

/***/ },
/* 3404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.29 14.29L9 17v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-4l2.71-2.71c.19-.19.29-.44.29-.71V10c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v3.59c0 .26.11.52.29.7zM12 2c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1s-1-.45-1-1V3c0-.55.45-1 1-1zM4.21 5.17c.39-.39 1.02-.39 1.42 0l.71.71c.39.39.39 1.02 0 1.41-.39.39-1.02.39-1.41 0l-.72-.71a.9959.9959 0 010-1.41zm13.46.71l.71-.71c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-.71.71c-.39.39-1.02.39-1.41 0a.9959.9959 0 010-1.41z"
	}), 'HighlightRounded');
	
	exports.default = _default;

/***/ },
/* 3405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 14l3 3v5h6v-5l3-3V9H6v5zm5-12h2v3h-2V2zM3.5 5.88l1.41-1.41 2.12 2.12L5.62 8 3.5 5.88zm13.46.71l2.12-2.12 1.41 1.41L18.38 8l-1.42-1.41z"
	}), 'HighlightSharp');
	
	exports.default = _default;

/***/ },
/* 3406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11 20h2v-3.83l3-3V11H8v2.17l3 3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M6 14l3 3v5h6v-5l3-3V9H6v5zm2-3h8v2.17l-3 3V20h-2v-3.83l-3-3V11zm3-9h2v3h-2zM4.916 4.464l2.12 2.122L5.62 8 3.5 5.877zM18.372 8l-1.414-1.414 2.12-2.12 1.415 1.413z"
	})), 'HighlightTwoTone');
	
	exports.default = _default;

/***/ },
/* 3407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
	}), 'History');
	
	exports.default = _default;

/***/ },
/* 3408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8z"
	}), 'HistoryOutlined');
	
	exports.default = _default;

/***/ },
/* 3409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.26 3C8.17 2.86 4 6.95 4 12H2.21c-.45 0-.67.54-.35.85l2.79 2.8c.2.2.51.2.71 0l2.79-2.8c.31-.31.09-.85-.36-.85H6c0-3.9 3.18-7.05 7.1-7 3.72.05 6.85 3.18 6.9 6.9.05 3.91-3.1 7.1-7 7.1-1.61 0-3.1-.55-4.28-1.48-.4-.31-.96-.28-1.32.08-.42.42-.39 1.13.08 1.49C9 20.29 10.91 21 13 21c5.05 0 9.14-4.17 9-9.26-.13-4.69-4.05-8.61-8.74-8.74zm-.51 5c-.41 0-.75.34-.75.75v3.68c0 .35.19.68.49.86l3.12 1.85c.36.21.82.09 1.03-.26.21-.36.09-.82-.26-1.03l-2.88-1.71v-3.4c0-.4-.34-.74-.75-.74z"
	}), 'HistoryRounded');
	
	exports.default = _default;

/***/ },
/* 3410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.25 2.52.77-1.29-3.52-2.09V8H12z"
	}), 'HistorySharp');
	
	exports.default = _default;

/***/ },
/* 3411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8z"
	}), 'HistoryTwoTone');
	
	exports.default = _default;

/***/ },
/* 3412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
	}), 'Home');
	
	exports.default = _default;

/***/ },
/* 3413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5.69l5 4.5V18h-2v-6H9v6H7v-7.81l5-4.5M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3z"
	}), 'HomeOutlined');
	
	exports.default = _default;

/***/ },
/* 3414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 19v-5h4v5c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-7h1.7c.46 0 .68-.57.33-.87L12.67 3.6c-.38-.34-.96-.34-1.34 0l-8.36 7.53c-.34.3-.13.87.33.87H5v7c0 .55.45 1 1 1h3c.55 0 1-.45 1-1z"
	}), 'HomeRounded');
	
	exports.default = _default;

/***/ },
/* 3415 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8h5z"
	}), 'HomeSharp');
	
	exports.default = _default;

/***/ },
/* 3416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3zm5 15h-2v-6H9v6H7v-7.81l5-4.5 5 4.5V18z"
	}), _react.default.createElement("path", {
	  d: "M7 10.19V18h2v-6h6v6h2v-7.81l-5-4.5z",
	  opacity: ".3"
	})), 'HomeTwoTone');
	
	exports.default = _default;

/***/ },
/* 3417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8.17 5.7L1 10.48V21h5v-8h4v8h5V10.25z"
	}), _react.default.createElement("path", {
	  d: "M10 3v1.51l2 1.33L13.73 7H15v.85l2 1.34V11h2v2h-2v2h2v2h-2v4h6V3H10zm9 6h-2V7h2v2z"
	})), 'HomeWork');
	
	exports.default = _default;

/***/ },
/* 3418 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17 15h2v2h-2zm0-4h2v2h-2zm0-4h2v2h-2zm-3.26 0l1.26.84V7z"
	}), _react.default.createElement("path", {
	  d: "M10 3v1.51l2 1.33V5h9v14h-4v2h6V3z"
	}), _react.default.createElement("path", {
	  d: "M8.17 5.7L15 10.25V21H1V10.48L8.17 5.7zM10 19h3v-7.84L8.17 8.09 3 11.38V19h3v-6h4v6z"
	})), 'HomeWorkOutlined');
	
	exports.default = _default;

/***/ },
/* 3419 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 3h-8c-.55 0-1 .45-1 1v1.61l.01.01 5 4.5c.63.56.99 1.38.99 2.23V13h2v2h-2v2h2v2h-2v2h3c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm-5 4h-2V5h2v2zm4 4h-2V9h2v2zm0-4h-2V5h2v2z"
	}), _react.default.createElement("path", {
	  d: "M15 20v-7.65c0-.28-.12-.55-.33-.74l-5-4.5c-.19-.18-.43-.26-.67-.26-.24 0-.48.09-.67.26l-5 4.5c-.21.18-.33.45-.33.74V20c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-4h4v4c0 .55.45 1 1 1h2c.55 0 1-.45 1-1z"
	})), 'HomeWorkRounded');
	
	exports.default = _default;

/***/ },
/* 3420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8.17 5.7L1 10.48V21h5v-8h4v8h5V10.25z"
	}), _react.default.createElement("path", {
	  d: "M10 3v1.51l2 1.33L13.73 7H15v.85l2 1.34V11h2v2h-2v2h2v2h-2v4h6V3H10zm9 6h-2V7h2v2z"
	})), 'HomeWorkSharp');
	
	exports.default = _default;

/***/ },
/* 3421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17 15h2v2h-2zm0-4h2v2h-2zm0-4h2v2h-2zm-3.26 0l1.26.84V7z"
	}), _react.default.createElement("path", {
	  d: "M10 3v1.51l2 1.33V5h9v14h-4v2h6V3z"
	}), _react.default.createElement("path", {
	  d: "M8.17 5.7L15 10.25V21H1V10.48L8.17 5.7zM10 19h3v-7.84L8.17 8.09 3 11.38V19h3v-6h4v6z"
	}), _react.default.createElement("path", {
	  d: "M10 19h3v-7.84L8.17 8.09 3 11.38V19h3v-6h4z",
	  opacity: ".3"
	})), 'HomeWorkTwoTone');
	
	exports.default = _default;

/***/ },
/* 3422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 19h18v-6H3v6zm0-8h18V9H3v2zm0-6v2h18V5H3z"
	}), 'HorizontalSplit');
	
	exports.default = _default;

/***/ },
/* 3423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 15v2H5v-2h14m2-10H3v2h18V5zm0 4H3v2h18V9zm0 4H3v6h18v-6z"
	}), 'HorizontalSplitOutlined');
	
	exports.default = _default;

/***/ },
/* 3424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 19h16c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm0-8h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z"
	}), 'HorizontalSplitRounded');
	
	exports.default = _default;

/***/ },
/* 3425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 19h18v-6H3v6zm0-8h18V9H3v2zm0-6v2h18V5H3z"
	}), 'HorizontalSplitSharp');
	
	exports.default = _default;

/***/ },
/* 3426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 15v2H5v-2h14m2-10H3v2h18V5zm0 4H3v2h18V9zm0 4H3v6h18v-6z"
	}), _react.default.createElement("path", {
	  d: "M5 15h14v2H5z",
	  opacity: ".3"
	})), 'HorizontalSplitTwoTone');
	
	exports.default = _default;

/***/ },
/* 3427 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "7",
	  cy: "6",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M11.15 12c-.31-.22-.59-.46-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C6.01 9 5 10.01 5 11.25V12H2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8H11.15zM7 20H5v-6h2v6zm4 0H9v-6h2v6zm4 0h-2v-6h2v6zm4 0h-2v-6h2v6zm-.35-14.14l-.07-.07c-.57-.62-.82-1.41-.67-2.2L18 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zm-4 0l-.07-.07c-.57-.62-.82-1.41-.67-2.2L14 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71z"
	})), 'HotTub');
	
	exports.default = _default;

/***/ },
/* 3428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "7",
	  cy: "6",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M11.15 12c-.31-.22-.59-.46-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C6.01 9 5 10.01 5 11.25V12H2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8H11.15zM7 20H5v-6h2v6zm4 0H9v-6h2v6zm4 0h-2v-6h2v6zm4 0h-2v-6h2v6zM17.42 7.21c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71l-.07-.07c-.57-.62-.82-1.41-.67-2.2L18 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06zm-4 0c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71l-.07-.07c-.57-.62-.82-1.41-.67-2.2L14 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06z"
	})), 'HotTubOutlined');
	
	exports.default = _default;

/***/ },
/* 3429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "7",
	  cy: "6",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M21 12h-9.85c-.31-.22-.59-.46-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C6.01 9 5 10.01 5 11.25V12H3c-.55 0-1 .45-1 1v7c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-7c0-.55-.45-1-1-1zM7 19c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4zm4 0c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4zm4 0c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4zm4 0c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4zm-3.94-9c.5 0 .93-.39.94-.89.04-1.4-.58-2.48-1.35-3.25-.65-.72-.8-1.27-.77-1.91.02-.52-.41-.95-.94-.95-.5 0-.93.4-.94.9-.03 1.29.5 2.43 1.35 3.25.61.59.78 1.27.78 1.89-.01.52.4.96.93.96zm4 0c.5 0 .93-.39.94-.89.04-1.4-.58-2.48-1.35-3.25-.65-.72-.8-1.27-.77-1.91.02-.52-.41-.95-.94-.95-.5 0-.93.4-.94.9-.03 1.29.5 2.43 1.35 3.25.61.59.78 1.27.78 1.89-.01.52.4.96.93.96z"
	})), 'HotTubRounded');
	
	exports.default = _default;

/***/ },
/* 3430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "7",
	  cy: "6",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M11.15 12c-.31-.22-.59-.46-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C6.01 9 5 10.01 5 11.25V12H2v10h20V12H11.15zM7 20H5v-6h2v6zm4 0H9v-6h2v6zm4 0h-2v-6h2v6zm4 0h-2v-6h2v6zm-.35-14.14l-.07-.07c-.57-.62-.82-1.41-.67-2.2L18 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zm-4 0l-.07-.07c-.57-.62-.82-1.41-.67-2.2L14 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71z"
	})), 'HotTubSharp');
	
	exports.default = _default;

/***/ },
/* 3431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "7",
	  cy: "6",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M17.42 7.21c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71l-.07-.07c-.57-.62-.82-1.41-.67-2.2L18 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06zM11.15 12c-.31-.22-.59-.46-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C6.01 9 5 10.01 5 11.25V12H2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8H11.15zM7 20H5v-6h2v6zm4 0H9v-6h2v6zm4 0h-2v-6h2v6zm4 0h-2v-6h2v6zM13.42 7.21c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71l-.07-.07c-.57-.62-.82-1.41-.67-2.2L14 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06z"
	})), 'HotTubTwoTone');
	
	exports.default = _default;

/***/ },
/* 3432 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z"
	}), 'Hotel');
	
	exports.default = _default;

/***/ },
/* 3433 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 14c1.66 0 3-1.34 3-3S8.66 8 7 8s-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm12-3h-8v8H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4zm2 8h-8V9h6c1.1 0 2 .9 2 2v4z"
	}), 'HotelOutlined');
	
	exports.default = _default;

/***/ },
/* 3434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-6c-1.1 0-2 .9-2 2v5H3V6c0-.55-.45-1-1-1s-1 .45-1 1v13c0 .55.45 1 1 1s1-.45 1-1v-2h18v2c0 .55.45 1 1 1s1-.45 1-1v-8c0-2.21-1.79-4-4-4z"
	}), 'HotelRounded');
	
	exports.default = _default;

/***/ },
/* 3435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm16-6H11v7H3V5H1v15h2v-3h18v3h2V7z"
	}), 'HotelSharp');
	
	exports.default = _default;

/***/ },
/* 3436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 9h-6v6h8v-4c0-1.1-.9-2-2-2z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "7",
	  cy: "11",
	  r: "1",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 11c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3zm4 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm11-4h-8v8H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4zm2 8h-8V9h6c1.1 0 2 .9 2 2v4z"
	})), 'HotelTwoTone');
	
	exports.default = _default;

/***/ },
/* 3437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z"
	}), 'HourglassEmpty');
	
	exports.default = _default;

/***/ },
/* 3438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z"
	}), 'HourglassEmptyOutlined');
	
	exports.default = _default;

/***/ },
/* 3439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 2c-1.1 0-2 .9-2 2v3.17c0 .53.21 1.04.59 1.42L10 12l-3.42 3.42c-.37.38-.58.89-.58 1.42V20c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-3.16c0-.53-.21-1.04-.58-1.41L14 12l3.41-3.4c.38-.38.59-.89.59-1.42V4c0-1.1-.9-2-2-2H8zm8 14.5V19c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-2.5l4-4 4 4zm-4-5l-4-4V5c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v2.5l-4 4z"
	}), 'HourglassEmptyRounded');
	
	exports.default = _default;

/***/ },
/* 3440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z"
	}), 'HourglassEmptySharp');
	
	exports.default = _default;

/***/ },
/* 3441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 2H6v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2zm-2 14.5V20H8v-3.5l4-4 4 4zm0-9l-4 4-4-4V4h8v3.5z"
	}), 'HourglassEmptyTwoTone');
	
	exports.default = _default;

/***/ },
/* 3442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z"
	}), 'HourglassFull');
	
	exports.default = _default;

/***/ },
/* 3443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z"
	}), 'HourglassFullOutlined');
	
	exports.default = _default;

/***/ },
/* 3444 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 4v3.17c0 .53.21 1.04.59 1.42L10 12l-3.42 3.42c-.37.38-.58.89-.58 1.42V20c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-3.16c0-.53-.21-1.04-.58-1.41L14 12l3.41-3.4c.38-.38.59-.89.59-1.42V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2z"
	}), 'HourglassFullRounded');
	
	exports.default = _default;

/***/ },
/* 3445 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z"
	}), 'HourglassFullSharp');
	
	exports.default = _default;

/***/ },
/* 3446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 7.5l4 4 4-4V4H8zm0 9V20h8v-3.5l-4-4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 2H6v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2zm-2 14.5V20H8v-3.5l4-4 4 4zm0-9l-4 4-4-4V4h8v3.5z"
	})), 'HourglassFullTwoTone');
	
	exports.default = _default;

/***/ },
/* 3447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 9.3V4h-3v2.6L12 3 2 12h3v8h5v-6h4v6h5v-8h3l-3-2.7zm-9 .7c0-1.1.9-2 2-2s2 .9 2 2h-4z"
	}), 'House');
	
	exports.default = _default;

/***/ },
/* 3448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 9.3V4h-3v2.6L12 3 2 12h3v8h6v-6h2v6h6v-8h3l-3-2.7zM17 18h-2v-6H9v6H7v-7.81l5-4.5 5 4.5V18z"
	}), _react.default.createElement("path", {
	  d: "M10 10h4c0-1.1-.9-2-2-2s-2 .9-2 2z"
	})), 'HouseOutlined');
	
	exports.default = _default;

/***/ },
/* 3449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 9.3V5c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v1.6l-3.33-3c-.38-.34-.96-.34-1.34 0l-8.36 7.53c-.34.3-.13.87.33.87H5v7c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-5h4v5c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-7h1.7c.46 0 .68-.57.33-.87L19 9.3zm-9 .7c0-1.1.9-2 2-2s2 .9 2 2h-4z"
	}), 'HouseRounded');
	
	exports.default = _default;

/***/ },
/* 3450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 9.3V4h-3v2.6L12 3 2 12h3v8h5v-6h4v6h5v-8h3l-3-2.7zm-9 .7c0-1.1.9-2 2-2s2 .9 2 2h-4z"
	}), 'HouseSharp');
	
	exports.default = _default;

/***/ },
/* 3451 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 10.19V18h2v-6h6v6h2v-7.81l-5-4.5-5 4.5zm7-.19h-4c0-1.1.9-2 2-2s2 .9 2 2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 9.3V4h-3v2.6L12 3 2 12h3v8h6v-6h2v6h6v-8h3l-3-2.7zM17 18h-2v-6H9v6H7v-7.81l5-4.5 5 4.5V18z"
	}), _react.default.createElement("path", {
	  d: "M10 10h4c0-1.1-.9-2-2-2s-2 .9-2 2z"
	})), 'HouseTwoTone');
	
	exports.default = _default;

/***/ },
/* 3452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", {
	  fillRule: "evenodd"
	}, _react.default.createElement("path", {
	  d: "M9 17l3-2.94c-.39-.04-.68-.06-1-.06-2.67 0-8 1.34-8 4v2h9l-3-3zm2-5c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4M15.47 20.5L12 17l1.4-1.41 2.07 2.08 5.13-5.17 1.4 1.41z"
	})), 'HowToReg');
	
	exports.default = _default;

/***/ },
/* 3453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM5 18c.2-.63 2.57-1.68 4.96-1.94l2.04-2c-.39-.04-.68-.06-1-.06-2.67 0-8 1.34-8 4v2h9l-2-2H5zm15.6-5.5l-5.13 5.17-2.07-2.08L12 17l3.47 3.5L22 13.91z"
	}), 'HowToRegOutlined');
	
	exports.default = _default;

/***/ },
/* 3454 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 20l-.86-.86c-1.18-1.18-1.17-3.1.02-4.26l.84-.82c-.39-.04-.68-.06-1-.06-2.67 0-8 1.34-8 4v2h9zm-1-8c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4M16.18 19.78c-.39.39-1.03.39-1.42 0l-2.07-2.09c-.38-.39-.38-1.01 0-1.39l.01-.01c.39-.39 1.02-.39 1.4 0l1.37 1.37 4.43-4.46c.39-.39 1.02-.39 1.41 0l.01.01c.38.39.38 1.01 0 1.39l-5.14 5.18z"
	}), 'HowToRegRounded');
	
	exports.default = _default;

/***/ },
/* 3455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 17l3-2.94c-.39-.04-.68-.06-1-.06-2.67 0-8 1.34-8 4v2h9l-3-3zm2-5c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4M15.47 20.5L12 17l1.4-1.41 2.07 2.08 5.13-5.17 1.4 1.41-6.53 6.59z"
	}), 'HowToRegSharp');
	
	exports.default = _default;

/***/ },
/* 3456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "11",
	  cy: "8",
	  r: "2",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 18h4.99L9 17l.93-.94C7.55 16.33 5.2 17.37 5 18z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm-1 12H5c.2-.63 2.55-1.67 4.93-1.94h.03l.46-.45L12 14.06c-.39-.04-.68-.06-1-.06-2.67 0-8 1.34-8 4v2h9l-2-2zm10.6-5.5l-5.13 5.17-2.07-2.08L12 17l3.47 3.5L22 13.91z"
	})), 'HowToRegTwoTone');
	
	exports.default = _default;

/***/ },
/* 3457 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 13h-.68l-2 2h1.91L19 17H5l1.78-2h2.05l-2-2H6l-3 3v4c0 1.1.89 2 1.99 2H19c1.1 0 2-.89 2-2v-4l-3-3zm-1-5.05l-4.95 4.95-3.54-3.54 4.95-4.95L17 7.95zm-4.24-5.66L6.39 8.66c-.39.39-.39 1.02 0 1.41l4.95 4.95c.39.39 1.02.39 1.41 0l6.36-6.36c.39-.39.39-1.02 0-1.41L14.16 2.3c-.38-.4-1.01-.4-1.4-.01z"
	}), 'HowToVote');
	
	exports.default = _default;

/***/ },
/* 3458 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 13h-.68l-2 2h1.91L19 17H5l1.78-2h2.05l-2-2H6l-3 3v4c0 1.1.89 2 1.99 2H19c1.1 0 2-.89 2-2v-4l-3-3zm1 7H5v-1h14v1zm-7.66-4.98c.39.39 1.02.39 1.41 0l6.36-6.36c.39-.39.39-1.02 0-1.41L14.16 2.3c-.38-.4-1.01-.4-1.4-.01L6.39 8.66c-.39.39-.39 1.02 0 1.41l4.95 4.95zm2.12-10.61L17 7.95l-4.95 4.95-3.54-3.54 4.95-4.95z"
	}), 'HowToVoteOutlined');
	
	exports.default = _default;

/***/ },
/* 3459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.34 15.02c.39.39 1.02.39 1.41 0l6.36-6.36c.39-.39.39-1.02 0-1.41L14.16 2.3c-.38-.4-1.01-.4-1.4-.01L6.39 8.66c-.39.39-.39 1.02 0 1.41l4.95 4.95zm2.12-10.61L17 7.95l-4.95 4.95-3.54-3.54 4.95-4.95zm6.95 11l-2.12-2.12c-.18-.18-.44-.29-.7-.29h-.27l-2 2h1.91L19 17H5l1.78-2h2.05l-2-2h-.42c-.27 0-.52.11-.71.29l-2.12 2.12c-.37.38-.58.89-.58 1.42V20c0 1.1.9 2 2 2h14c1.1 0 2-.89 2-2v-3.17c0-.53-.21-1.04-.59-1.42z"
	}), 'HowToVoteRounded');
	
	exports.default = _default;

/***/ },
/* 3460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 13h-.68l-2 2h1.91L19 17H5l1.78-2h2.05l-2-2H6l-3 3v6h18v-6zm1.81-5.04L13.45 1.6 5.68 9.36l6.36 6.36 7.77-7.76zm-6.35-3.55L17 7.95l-4.95 4.95-3.54-3.54 4.95-4.95z"
	}), 'HowToVoteSharp');
	
	exports.default = _default;

/***/ },
/* 3461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14v1H5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 13h-.68l-2 2h1.91L19 17H5l1.78-2h2.05l-2-2H6l-3 3v4c0 1.1.89 2 1.99 2H19c1.1 0 2-.89 2-2v-4l-3-3zm1 7H5v-1h14v1z"
	}), _react.default.createElement("path", {
	  d: "M12.048 12.905L8.505 9.362l4.95-4.95 3.543 3.543z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19.11 7.25L14.16 2.3c-.38-.4-1.01-.4-1.4-.01L6.39 8.66c-.39.39-.39 1.02 0 1.41l4.95 4.95c.39.39 1.02.39 1.41 0l6.36-6.36c.39-.39.39-1.02 0-1.41zm-7.06 5.65L8.51 9.36l4.95-4.95L17 7.95l-4.95 4.95z"
	})), 'HowToVoteTwoTone');
	
	exports.default = _default;

/***/ },
/* 3462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zm9-1.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z"
	}), 'Http');
	
	exports.default = _default;

/***/ },
/* 3463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zm9-1.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z"
	}), 'HttpOutlined');
	
	exports.default = _default;

/***/ },
/* 3464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.5 11h-2V9.75c0-.41-.34-.75-.75-.75S1 9.34 1 9.75v4.5c0 .41.34.75.75.75s.75-.34.75-.75V12.5h2v1.75c0 .41.34.75.75.75s.75-.34.75-.75v-4.5C6 9.34 5.66 9 5.25 9s-.75.34-.75.75V11zm3.25-.5h.75v3.75c0 .41.34.75.75.75s.75-.34.75-.75V10.5h.75c.41 0 .75-.34.75-.75S11.16 9 10.75 9h-3c-.41 0-.75.34-.75.75s.34.75.75.75zm5.5 0H14v3.75c0 .41.34.75.75.75s.75-.34.75-.75V10.5h.75c.41 0 .75-.34.75-.75S16.66 9 16.25 9h-3c-.41 0-.75.34-.75.75s.34.75.75.75zM21.5 9H19c-.55 0-1 .45-1 1v4.25c0 .41.34.75.75.75s.75-.34.75-.75V13h2c.83 0 1.5-.68 1.5-1.5v-1c0-.82-.67-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z"
	}), 'HttpRounded');
	
	exports.default = _default;

/***/ },
/* 3465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zM23 9h-5v6h1.5v-2H23V9zm-1.5 2.5h-2v-1h2v1z"
	}), 'HttpSharp');
	
	exports.default = _default;

/***/ },
/* 3466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zm9-1.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z"
	}), 'HttpTwoTone');
	
	exports.default = _default;

/***/ },
/* 3467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
	}), 'Https');
	
	exports.default = _default;

/***/ },
/* 3468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
	}), 'HttpsOutlined');
	
	exports.default = _default;

/***/ },
/* 3469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM9 8V6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9z"
	}), 'HttpsRounded');
	
	exports.default = _default;

/***/ },
/* 3470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8h-3V6.21c0-2.61-1.91-4.94-4.51-5.19C9.51.74 7 3.08 7 6v2H4v14h16V8zm-8 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM9 8V6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9z"
	}), 'HttpsSharp');
	
	exports.default = _default;

/***/ },
/* 3471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 20h12V10H6v10zm6-7c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
	})), 'HttpsTwoTone');
	
	exports.default = _default;

/***/ },
/* 3472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
	}), 'Image');
	
	exports.default = _default;

/***/ },
/* 3473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
	}), 'ImageAspectRatio');
	
	exports.default = _default;

/***/ },
/* 3474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
	}), 'ImageAspectRatioOutlined');
	
	exports.default = _default;

/***/ },
/* 3475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-1 14H5c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1z"
	}), 'ImageAspectRatioRounded');
	
	exports.default = _default;

/***/ },
/* 3476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm10-6H2v16h20V4zm-2 14H4V6h16v12z"
	}), 'ImageAspectRatioSharp');
	
	exports.default = _default;

/***/ },
/* 3477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 18h16V6H4v12zm10-8h2v2h-2v-2zm0 4h2v2h-2v-2zm-4-4h2v2h-2v-2zm-4 0h2v2H6v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M14 10h2v2h-2zm0 4h2v2h-2zm-8-4h2v2H6zm4 0h2v2h-2zm10-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
	})), 'ImageAspectRatioTwoTone');
	
	exports.default = _default;

/***/ },
/* 3478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"
	}), 'ImageOutlined');
	
	exports.default = _default;

/***/ },
/* 3479 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.9 13.98l2.1 2.53 3.1-3.99c.2-.26.6-.26.8.01l3.51 4.68c.25.33.01.8-.4.8H6.02c-.42 0-.65-.48-.39-.81L8.12 14c.19-.26.57-.27.78-.02z"
	}), 'ImageRounded');
	
	exports.default = _default;

/***/ },
/* 3480 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 13v7H4V6h5.02c.05-.71.22-1.38.48-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5l-2-2zm-1.5 5h-11l2.75-3.53 1.96 2.36 2.75-3.54zm2.8-9.11c.44-.7.7-1.51.7-2.39C20 4.01 17.99 2 15.5 2S11 4.01 11 6.5s2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7L21 13.42 22.42 12 19.3 8.89zM15.5 9C14.12 9 13 7.88 13 6.5S14.12 4 15.5 4 18 5.12 18 6.5 16.88 9 15.5 9z"
	}), 'ImageSearch');
	
	exports.default = _default;

/***/ },
/* 3481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 13v7H4V6h5.02c.05-.71.22-1.38.48-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5l-2-2zm-1.5 5h-11l2.75-3.53 1.96 2.36 2.75-3.54L16.5 18zm2.8-9.11c.44-.7.7-1.51.7-2.39C20 4.01 17.99 2 15.5 2S11 4.01 11 6.5s2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7L21 13.42 22.42 12 19.3 8.89zM15.5 9C14.12 9 13 7.88 13 6.5S14.12 4 15.5 4 18 5.12 18 6.5 16.88 9 15.5 9z"
	}), 'ImageSearchOutlined');
	
	exports.default = _default;

/***/ },
/* 3482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 15v4c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h3.02c.55 0 1-.45 1-1s-.45-1-1-1H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5c0-.55-.45-1-1-1s-1 .45-1 1zm-2.5 3H6.52c-.42 0-.65-.48-.39-.81l1.74-2.23c.2-.25.58-.26.78-.01l1.56 1.88 2.35-3.02c.2-.26.6-.26.79.01l2.55 3.39c.25.32.01.79-.4.79zm3.8-9.11c.48-.77.75-1.67.69-2.66-.13-2.15-1.84-3.97-3.97-4.2C13.3 1.73 11 3.84 11 6.5c0 2.49 2.01 4.5 4.49 4.5.88 0 1.7-.26 2.39-.7l2.41 2.41c.39.39 1.03.39 1.42 0 .39-.39.39-1.03 0-1.42l-2.41-2.4zM15.5 9C14.12 9 13 7.88 13 6.5S14.12 4 15.5 4 18 5.12 18 6.5 16.88 9 15.5 9z"
	}), 'ImageSearchRounded');
	
	exports.default = _default;

/***/ },
/* 3483 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 13v7H4V6h5.02c.05-.71.22-1.38.48-2H2v18h18v-7l-2-2zm-1.5 5h-11l2.75-3.53 1.96 2.36 2.75-3.54L16.5 18zm2.8-9.11c.44-.7.7-1.51.7-2.39C20 4.01 17.99 2 15.5 2S11 4.01 11 6.5s2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7L21 13.42 22.42 12 19.3 8.89zM15.5 9C14.12 9 13 7.88 13 6.5S14.12 4 15.5 4 18 5.12 18 6.5 16.88 9 15.5 9z"
	}), 'ImageSearchSharp');
	
	exports.default = _default;

/***/ },
/* 3484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17.7 11.53c-.7.31-1.45.47-2.21.47C12.46 12 10 9.53 10 6.5c0-.17.01-.34.03-.5H4v14h14v-8.17l-.3-.3zM5.5 18l2.75-3.53 1.96 2.36 2.75-3.54L16.5 18h-11z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M10.21 16.83l-1.96-2.36L5.5 18h11l-3.54-4.71zM20 6.5C20 4.01 17.99 2 15.5 2S11 4.01 11 6.5s2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7L21 13.42 22.42 12 19.3 8.89c.44-.7.7-1.51.7-2.39zM15.5 9C14.12 9 13 7.88 13 6.5S14.12 4 15.5 4 18 5.12 18 6.5 16.88 9 15.5 9zM18 20H4V6h6.03c.06-.72.27-1.39.58-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6.17l-2-2V20z"
	})), 'ImageSearchTwoTone');
	
	exports.default = _default;

/***/ },
/* 3485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 21V3H3v18h18zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
	}), 'ImageSharp');
	
	exports.default = _default;

/***/ },
/* 3486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14V5H5v14zm4-5.86l2.14 2.58 3-3.87L18 17H6l3-3.86z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-4.86-7.14l-3 3.86L9 13.14 6 17h12z"
	})), 'ImageTwoTone');
	
	exports.default = _default;

/***/ },
/* 3487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.5 4.5c-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .65.73.45.75.45C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.41.21.75-.19.75-.45V6c-1.49-1.12-3.63-1.5-5.5-1.5zm3.5 14c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"
	}), 'ImportContacts');
	
	exports.default = _default;

/***/ },
/* 3488 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"
	}), 'ImportContactsOutlined');
	
	exports.default = _default;

/***/ },
/* 3489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.5 4.5c-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5-1.45 0-2.99.22-4.28.79C1.49 5.62 1 6.33 1 7.14v11.28c0 1.3 1.22 2.26 2.48 1.94.98-.25 2.02-.36 3.02-.36 1.56 0 3.22.26 4.56.92.6.3 1.28.3 1.87 0 1.34-.67 3-.92 4.56-.92 1 0 2.04.11 3.02.36 1.26.33 2.48-.63 2.48-1.94V7.14c0-.81-.49-1.52-1.22-1.85-1.28-.57-2.82-.79-4.27-.79zM21 17.23c0 .63-.58 1.09-1.2.98-.75-.14-1.53-.2-2.3-.2-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5.92 0 1.83.09 2.7.28.46.1.8.51.8.98v9.47z"
	}), 'ImportContactsRounded');
	
	exports.default = _default;

/***/ },
/* 3490 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v15.5C2.45 20.4 4.55 20 6.5 20s4.05.4 5.5 1.5c1.45-1.1 3.55-1.5 5.5-1.5 1.17 0 2.39.15 3.5.5.75.25 1.4.55 2 1V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"
	}), 'ImportContactsSharp');
	
	exports.default = _default;

/***/ },
/* 3491 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zM3 18.5V7c1.1-.35 2.3-.5 3.5-.5 1.34 0 3.13.41 4.5.99v11.5C9.63 18.41 7.84 18 6.5 18c-1.2 0-2.4.15-3.5.5zm18 0c-1.1-.35-2.3-.5-3.5-.5-1.34 0-3.13.41-4.5.99V7.49c1.37-.59 3.16-.99 4.5-.99 1.2 0 2.4.15 3.5.5v11.5z"
	}), _react.default.createElement("path", {
	  d: "M11 7.49c-1.37-.58-3.16-.99-4.5-.99-1.2 0-2.4.15-3.5.5v11.5c1.1-.35 2.3-.5 3.5-.5 1.34 0 3.13.41 4.5.99V7.49z",
	  opacity: ".3"
	})), 'ImportContactsTwoTone');
	
	exports.default = _default;

/***/ },
/* 3492 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z"
	}), 'ImportExport');
	
	exports.default = _default;

/***/ },
/* 3493 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z"
	}), 'ImportExportOutlined');
	
	exports.default = _default;

/***/ },
/* 3494 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.65 3.35L5.86 6.14c-.32.31-.1.85.35.85H8V13c0 .55.45 1 1 1s1-.45 1-1V6.99h1.79c.45 0 .67-.54.35-.85L9.35 3.35c-.19-.19-.51-.19-.7 0zM16 17.01V11c0-.55-.45-1-1-1s-1 .45-1 1v6.01h-1.79c-.45 0-.67.54-.35.85l2.79 2.78c.2.19.51.19.71 0l2.79-2.78c.32-.31.09-.85-.35-.85H16z"
	}), 'ImportExportRounded');
	
	exports.default = _default;

/***/ },
/* 3495 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z"
	}), 'ImportExportSharp');
	
	exports.default = _default;

/***/ },
/* 3496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 6.99h3V14h2V6.99h3L9 3zM14 10v7.01h-3L15 21l4-3.99h-3V10z"
	}), 'ImportExportTwoTone');
	
	exports.default = _default;

/***/ },
/* 3497 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 11.01L18 11c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99zM23 20h-5v-7h5v7zM20 2H2C.89 2 0 2.89 0 4v12c0 1.1.89 2 2 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4c0-1.11-.9-2-2-2zm-8.03 7L11 6l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z"
	}), 'ImportantDevices');
	
	exports.default = _default;

/***/ },
/* 3498 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 11.01L18 11c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99zM23 20h-5v-7h5v7zM20 2H2C.89 2 0 2.89 0 4v12c0 1.1.89 2 2 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4c0-1.11-.9-2-2-2zm-8.03 7L11 6l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z"
	}), 'ImportantDevicesOutlined');
	
	exports.default = _default;

/***/ },
/* 3499 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 11.01L18 11c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99zM23 20h-5v-7h5v7zM20 2H2C.9 2 0 2.9 0 4v12c0 1.1.9 2 2 2h7v2H8c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1h-1v-2h1c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v3c0 .55.45 1 1 1s1-.45 1-1V4c0-1.1-.9-2-2-2zm-8.03 7L11 6l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z"
	}), 'ImportantDevicesRounded');
	
	exports.default = _default;

/***/ },
/* 3500 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M24 11.01L17 11v11h7V11.01zM23 20h-5v-7h5v7zM22 2H0v16h9v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V2zM11.97 9L11 6l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z"
	}), 'ImportantDevicesSharp');
	
	exports.default = _default;

/***/ },
/* 3501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18 13h5v7h-5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M23 11.01L18 11c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99zM23 20h-5v-7h5v7zM2 4h18v5h2V4c0-1.11-.9-2-2-2H2C.89 2 0 2.89 0 4v12c0 1.1.89 2 2 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4zm9 2l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z"
	})), 'ImportantDevicesTwoTone');
	
	exports.default = _default;

/***/ },
/* 3502 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z"
	}), 'Inbox');
	
	exports.default = _default;

/***/ },
/* 3503 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5v-3h3.56c.69 1.19 1.97 2 3.45 2s2.75-.81 3.45-2H19v3zm0-5h-4.99c0 1.1-.9 2-2 2s-2-.9-2-2H5V5h14v9z"
	}), 'InboxOutlined');
	
	exports.default = _default;

/***/ },
/* 3504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 12h-3.13c-.47 0-.85.34-.98.8-.35 1.27-1.52 2.2-2.89 2.2s-2.54-.93-2.89-2.2c-.13-.46-.51-.8-.98-.8H5V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v9z"
	}), 'InboxRounded');
	
	exports.default = _default;

/***/ },
/* 3505 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3.01v18H21V3zm-2 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H5V5h14v10z"
	}), 'InboxSharp');
	
	exports.default = _default;

/***/ },
/* 3506 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12.01 18c-1.48 0-2.75-.81-3.45-2H5v3h14v-3h-3.55c-.69 1.19-1.97 2-3.44 2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5v-3h3.56c.69 1.19 1.97 2 3.45 2s2.75-.81 3.45-2H19v3zm0-5h-5c0 1.1-.9 2-2 2s-2-.9-2-2H5V5h14v9z"
	})), 'InboxTwoTone');
	
	exports.default = _default;

/***/ },
/* 3507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
	}), 'IndeterminateCheckBox');
	
	exports.default = _default;

/***/ },
/* 3508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 11h10v2H7z"
	}), 'IndeterminateCheckBoxOutlined');
	
	exports.default = _default;

/***/ },
/* 3509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 10H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'IndeterminateCheckBoxRounded');
	
	exports.default = _default;

/***/ },
/* 3510 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zm-4 10H7v-2h10v2z"
	}), 'IndeterminateCheckBoxSharp');
	
	exports.default = _default;

/***/ },
/* 3511 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14V5H5v14zm2-8h10v2H7v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 11h10v2H7z"
	})), 'IndeterminateCheckBoxTwoTone');
	
	exports.default = _default;

/***/ },
/* 3512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
	}), 'Info');
	
	exports.default = _default;

/***/ },
/* 3513 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'InfoOutlined');
	
	exports.default = _default;

/***/ },
/* 3514 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm1-8h-2V7h2v2z"
	}), 'InfoRounded');
	
	exports.default = _default;

/***/ },
/* 3515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
	}), 'InfoSharp');
	
	exports.default = _default;

/***/ },
/* 3516 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm1 13h-2v-6h2v6zm0-8h-2V7h2v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	})), 'InfoTwoTone');
	
	exports.default = _default;

/***/ },
/* 3517 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3z"
	}), 'Input');
	
	exports.default = _default;

/***/ },
/* 3518 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3zM21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3z"
	}), 'InputOutlined');
	
	exports.default = _default;

/***/ },
/* 3519 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3.01H3c-1.1 0-2 .9-2 2V8c0 .55.45 1 1 1s1-.45 1-1V5.99c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v12.03c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V16c0-.55-.45-1-1-1s-1 .45-1 1v3.01c0 1.09.89 1.98 1.98 1.98H21c1.1 0 2-.9 2-2V5.01c0-1.1-.9-2-2-2zm-9.15 12.14l2.79-2.79c.2-.2.2-.51 0-.71l-2.79-2.79c-.31-.32-.85-.1-.85.35V11H2c-.55 0-1 .45-1 1s.45 1 1 1h9v1.79c0 .45.54.67.85.36z"
	}), 'InputRounded');
	
	exports.default = _default;

/***/ },
/* 3520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3zM23 3.01H1V9h2V4.99h18v14.03H3V15H1v5.99h22V3.01zM11 16l4-4-4-4v3H1v2h10v3z"
	}), 'InputSharp');
	
	exports.default = _default;

/***/ },
/* 3521 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3z"
	}), 'InputTwoTone');
	
	exports.default = _default;

/***/ },
/* 3522 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
	}), 'InsertChart');
	
	exports.default = _default;

/***/ },
/* 3523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2.5 2.1h-15V5h15v14.1zm0-16.1h-15c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'InsertChartOutlined');
	
	exports.default = _default;

/***/ },
/* 3524 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2 2H5V5h14v14zm0-16H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'InsertChartOutlinedOutlined');
	
	exports.default = _default;

/***/ },
/* 3525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 17c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v5c0 .55-.45 1-1 1zm4 0c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1zm4 0c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm2 2H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zm1-16H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'InsertChartOutlinedRounded');
	
	exports.default = _default;

/***/ },
/* 3526 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2 2H5V5h14v14zm2-16H3v18h18V3z"
	}), 'InsertChartOutlinedSharp');
	
	exports.default = _default;

/***/ },
/* 3527 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2 2H5V5h14v14zm0-16H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'InsertChartOutlinedTwoTone');
	
	exports.default = _default;

/***/ },
/* 3528 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM8 17c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v5c0 .55-.45 1-1 1zm4 0c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1zm4 0c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1z"
	}), 'InsertChartRounded');
	
	exports.default = _default;

/***/ },
/* 3529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
	}), 'InsertChartSharp');
	
	exports.default = _default;

/***/ },
/* 3530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 5H5v14h14V5zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2zm2 0h14v14H5V5zm2 5h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"
	})), 'InsertChartTwoTone');
	
	exports.default = _default;

/***/ },
/* 3531 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
	}), 'InsertComment');
	
	exports.default = _default;

/***/ },
/* 3532 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4v13.17L18.83 16H4V4h16m0-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 10H6v2h12v-2zm0-3H6v2h12V9zm0-3H6v2h12V6z"
	}), 'InsertCommentOutlined');
	
	exports.default = _default;

/***/ },
/* 3533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-3 12H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1zm0-3H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1zm0-3H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'InsertCommentRounded');
	
	exports.default = _default;

/***/ },
/* 3534 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H2v16h16l4 4V2zm-4 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
	}), 'InsertCommentSharp');
	
	exports.default = _default;

/***/ },
/* 3535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 16h14.83L20 17.17V4H4v12zM6 6h12v2H6V6zm0 3h12v2H6V9zm0 3h12v2H6v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm0 2v13.17L18.83 16H4V4h16zM6 12h12v2H6zm0-3h12v2H6zm0-3h12v2H6z"
	})), 'InsertCommentTwoTone');
	
	exports.default = _default;

/***/ },
/* 3536 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"
	}), 'InsertDriveFile');
	
	exports.default = _default;

/***/ },
/* 3537 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z"
	}), 'InsertDriveFileOutlined');
	
	exports.default = _default;

/***/ },
/* 3538 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8.83c0-.53-.21-1.04-.59-1.41l-4.83-4.83c-.37-.38-.88-.59-1.41-.59H6zm7 6V3.5L18.5 9H14c-.55 0-1-.45-1-1z"
	}), 'InsertDriveFileRounded');
	
	exports.default = _default;

/***/ },
/* 3539 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.01 2L4 22h16V8l-6-6H4.01zM13 9V3.5L18.5 9H13z"
	}), 'InsertDriveFileSharp');
	
	exports.default = _default;

/***/ },
/* 3540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M13 4H6v16h12V9h-5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm-2 12H6V4h7v5h5v11z"
	})), 'InsertDriveFileTwoTone');
	
	exports.default = _default;

/***/ },
/* 3541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
	}), 'InsertEmoticon');
	
	exports.default = _default;

/***/ },
/* 3542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
	}), 'InsertEmoticonOutlined');
	
	exports.default = _default;

/***/ },
/* 3543 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.03 0 3.8-1.11 4.75-2.75.19-.33-.05-.75-.44-.75H7.69c-.38 0-.63.42-.44.75.95 1.64 2.72 2.75 4.75 2.75z"
	}), 'InsertEmoticonRounded');
	
	exports.default = _default;

/***/ },
/* 3544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
	}), 'InsertEmoticonSharp');
	
	exports.default = _default;

/***/ },
/* 3545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3.5 4c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-7 0c.83 0 1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5 7.67 8 8.5 8zm3.5 9.5c-2.33 0-4.31-1.46-5.11-3.5h10.22c-.8 2.04-2.78 3.5-5.11 3.5z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
	})), 'InsertEmoticonTwoTone');
	
	exports.default = _default;

/***/ },
/* 3546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
	}), 'InsertInvitation');
	
	exports.default = _default;

/***/ },
/* 3547 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2zm-2 5h-5v5h5v-5z"
	}), 'InsertInvitationOutlined');
	
	exports.default = _default;

/***/ },
/* 3548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 12h-3c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm0-10v1H8V2c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm2 17H6c-.55 0-1-.45-1-1V8h14v10c0 .55-.45 1-1 1z"
	}), 'InsertInvitationRounded');
	
	exports.default = _default;

/***/ },
/* 3549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H3.01v18H21V3h-3V1h-2zm3 18H5V8h14v11z"
	}), 'InsertInvitationSharp');
	
	exports.default = _default;

/***/ },
/* 3550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 5H5v2h14z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 21h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2zM5 7V5h14v2H5zm0 2h14v10H5V9zm7 3h5v5h-5z"
	})), 'InsertInvitationTwoTone');
	
	exports.default = _default;

/***/ },
/* 3551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
	}), 'InsertLink');
	
	exports.default = _default;

/***/ },
/* 3552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
	}), 'InsertLinkOutlined');
	
	exports.default = _default;

/***/ },
/* 3553 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.96 11.38C4.24 9.91 5.62 8.9 7.12 8.9h2.93c.52 0 .95-.43.95-.95S10.57 7 10.05 7H7.22c-2.61 0-4.94 1.91-5.19 4.51C1.74 14.49 4.08 17 7 17h3.05c.52 0 .95-.43.95-.95s-.43-.95-.95-.95H7c-1.91 0-3.42-1.74-3.04-3.72zM9 13h6c.55 0 1-.45 1-1s-.45-1-1-1H9c-.55 0-1 .45-1 1s.45 1 1 1zm7.78-6h-2.83c-.52 0-.95.43-.95.95s.43.95.95.95h2.93c1.5 0 2.88 1.01 3.16 2.48.38 1.98-1.13 3.72-3.04 3.72h-3.05c-.52 0-.95.43-.95.95s.43.95.95.95H17c2.92 0 5.26-2.51 4.98-5.49-.25-2.6-2.59-4.51-5.2-4.51z"
	}), 'InsertLinkRounded');
	
	exports.default = _default;

/***/ },
/* 3554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
	}), 'InsertLinkSharp');
	
	exports.default = _default;

/***/ },
/* 3555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
	}), 'InsertLinkTwoTone');
	
	exports.default = _default;

/***/ },
/* 3556 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
	}), 'InsertPhoto');
	
	exports.default = _default;

/***/ },
/* 3557 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"
	}), 'InsertPhotoOutlined');
	
	exports.default = _default;

/***/ },
/* 3558 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.9 13.98l2.1 2.53 3.1-3.99c.2-.26.6-.26.8.01l3.51 4.68c.25.33.01.8-.4.8H6.02c-.42 0-.65-.48-.39-.81L8.12 14c.19-.26.57-.27.78-.02z"
	}), 'InsertPhotoRounded');
	
	exports.default = _default;

/***/ },
/* 3559 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 21V3H3v18h18zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
	}), 'InsertPhotoSharp');
	
	exports.default = _default;

/***/ },
/* 3560 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14V5H5v14zm4-5.86l2.14 2.58 3-3.87L18 17H6l3-3.86z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2zm16 14H5V5h14v14zm-4.86-7.14l-3 3.86L9 13.14 6 17h12z"
	})), 'InsertPhotoTwoTone');
	
	exports.default = _default;

/***/ },
/* 3561 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z"
	}), 'Instagram');
	
	exports.default = _default;

/***/ },
/* 3562 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z"
	}), 'InvertColors');
	
	exports.default = _default;

/***/ },
/* 3563 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.65 20.87l-2.35-2.35-6.3-6.29-3.56-3.57-1.42-1.41L4.27 4.5 3 5.77l2.78 2.78c-2.55 3.14-2.36 7.76.56 10.69C7.9 20.8 9.95 21.58 12 21.58c1.79 0 3.57-.59 5.03-1.78l2.7 2.7L21 21.23l-.35-.36zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59c0-1.32.43-2.57 1.21-3.6L12 14.77v4.82zM12 5.1v4.58l7.25 7.26c1.37-2.96.84-6.57-1.6-9.01L12 2.27l-3.7 3.7 1.41 1.41L12 5.1z"
	}), 'InvertColorsOff');
	
	exports.default = _default;

/***/ },
/* 3564 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5.1v4.05l7.4 7.4c1.15-2.88.59-6.28-1.75-8.61L12 2.27 8.56 5.71l1.41 1.41L12 5.1zm-7.6-.73L2.99 5.78l2.78 2.78c-2.54 3.14-2.35 7.75.57 10.68C7.9 20.8 9.95 21.58 12 21.58c1.78 0 3.56-.59 5.02-1.77l2.7 2.7 1.41-1.41L4.4 4.37zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59c0-1.32.43-2.56 1.21-3.59L12 14.79v4.8z"
	}), 'InvertColorsOffOutlined');
	
	exports.default = _default;

/***/ },
/* 3565 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5.1v4.05l7.4 7.4c1.15-2.88.59-6.28-1.75-8.61l-4.94-4.95a.9959.9959 0 00-1.41 0L8.56 5.71l1.41 1.41L12 5.1zm-8.31-.02c-.39.39-.39 1.02 0 1.41l2.08 2.08c-2.54 3.14-2.35 7.75.57 10.68C7.9 20.8 9.95 21.58 12 21.58c1.78 0 3.56-.59 5.02-1.77l2 2c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L5.11 5.08c-.39-.39-1.03-.39-1.42 0zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59c0-1.32.43-2.56 1.21-3.59L12 14.79v4.8z"
	}), 'InvertColorsOffRounded');
	
	exports.default = _default;

/***/ },
/* 3566 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5.1v4.05l7.4 7.4c1.15-2.88.59-6.28-1.75-8.61L12 2.27 8.56 5.71l1.41 1.41L12 5.1zm-7.6-.73L2.99 5.78l2.78 2.78c-2.54 3.14-2.35 7.75.57 10.68C7.9 20.8 9.95 21.58 12 21.58c1.78 0 3.56-.59 5.02-1.77l2.7 2.7 1.41-1.41L4.4 4.37zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59c0-1.32.43-2.56 1.21-3.59L12 14.79v4.8z"
	}), 'InvertColorsOffSharp');
	
	exports.default = _default;

/***/ },
/* 3567 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 13.59c0 1.6.62 3.1 1.76 4.24 1.13 1.14 2.64 1.76 4.24 1.76v-4.8L7.21 10C6.43 11.03 6 12.27 6 13.59z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 5.1v4.05l7.4 7.4c1.15-2.88.59-6.28-1.75-8.61L12 2.27 8.56 5.71l1.41 1.41L12 5.1zm-7.6-.73L2.99 5.78l2.78 2.78c-2.54 3.14-2.35 7.75.57 10.68C7.9 20.8 9.95 21.58 12 21.58c1.78 0 3.56-.59 5.02-1.77l2.7 2.7 1.41-1.41L4.4 4.37zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59c0-1.32.43-2.56 1.21-3.59L12 14.79v4.8z"
	}), _react.default.createElement("path", {
	  d: "M12 9.15V5.1L9.97 7.12z",
	  opacity: ".3"
	})), 'InvertColorsOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 3568 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58s4.1-.78 5.66-2.34c3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z"
	}), 'InvertColorsOutlined');
	
	exports.default = _default;

/***/ },
/* 3569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58s4.1-.78 5.66-2.34c3.12-3.12 3.12-8.19 0-11.31l-4.95-4.95a.9959.9959 0 00-1.41 0L6.34 7.93zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z"
	}), 'InvertColorsRounded');
	
	exports.default = _default;

/***/ },
/* 3570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58s4.1-.78 5.66-2.34c3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z"
	}), 'InvertColorsSharp');
	
	exports.default = _default;

/***/ },
/* 3571 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 13.59c0 1.6.62 3.1 1.76 4.24 1.13 1.14 2.64 1.76 4.24 1.76V5.1L7.76 9.35C6.62 10.48 6 11.99 6 13.59z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58s4.1-.78 5.66-2.34c3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z"
	})), 'InvertColorsTwoTone');
	
	exports.default = _default;

/***/ },
/* 3572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14zm-2-2v-1.5h-5V17h5z"
	}), 'Iso');
	
	exports.default = _default;

/***/ },
/* 3573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14zm-2-2v-1.5h-5V17h5z"
	}), 'IsoOutlined');
	
	exports.default = _default;

/***/ },
/* 3574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM6.25 7.5H7.5V6.25c0-.41.34-.75.75-.75s.75.34.75.75V7.5h1.25c.41 0 .75.34.75.75s-.34.75-.75.75H9v1.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75V9H6.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75zM18 19H5L19 5v13c0 .55-.45 1-1 1zm-1-2.75c0-.41-.34-.75-.75-.75h-3.5c-.41 0-.75.34-.75.75s.34.75.75.75h3.5c.41 0 .75-.34.75-.75z"
	}), 'IsoRounded');
	
	exports.default = _default;

/***/ },
/* 3575 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14zm-2-2v-1.5h-5V17h5z"
	}), 'IsoSharp');
	
	exports.default = _default;

/***/ },
/* 3576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 19V5L5 19h14zm-2-3.5V17h-5v-1.5h5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 15.5h5V17h-5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14z"
	})), 'IsoTwoTone');
	
	exports.default = _default;

/***/ },
/* 3577 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z"
	}), 'Keyboard');
	
	exports.default = _default;

/***/ },
/* 3578 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
	}), 'KeyboardArrowDown');
	
	exports.default = _default;

/***/ },
/* 3579 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
	}), 'KeyboardArrowDownOutlined');
	
	exports.default = _default;

/***/ },
/* 3580 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.12 9.29L12 13.17l3.88-3.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-4.59 4.59c-.39.39-1.02.39-1.41 0L6.7 10.7a.9959.9959 0 010-1.41c.39-.38 1.03-.39 1.42 0z"
	}), 'KeyboardArrowDownRounded');
	
	exports.default = _default;

/***/ },
/* 3581 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
	}), 'KeyboardArrowDownSharp');
	
	exports.default = _default;

/***/ },
/* 3582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
	}), 'KeyboardArrowDownTwoTone');
	
	exports.default = _default;

/***/ },
/* 3583 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
	}), 'KeyboardArrowLeft');
	
	exports.default = _default;

/***/ },
/* 3584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
	}), 'KeyboardArrowLeftOutlined');
	
	exports.default = _default;

/***/ },
/* 3585 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.71 15.88L10.83 12l3.88-3.88c.39-.39.39-1.02 0-1.41a.9959.9959 0 00-1.41 0L8.71 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .38-.39.39-1.03 0-1.42z"
	}), 'KeyboardArrowLeftRounded');
	
	exports.default = _default;

/***/ },
/* 3586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
	}), 'KeyboardArrowLeftSharp');
	
	exports.default = _default;

/***/ },
/* 3587 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
	}), 'KeyboardArrowLeftTwoTone');
	
	exports.default = _default;

/***/ },
/* 3588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
	}), 'KeyboardArrowRight');
	
	exports.default = _default;

/***/ },
/* 3589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
	}), 'KeyboardArrowRightOutlined');
	
	exports.default = _default;

/***/ },
/* 3590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.29 15.88L13.17 12 9.29 8.12a.9959.9959 0 010-1.41c.39-.39 1.02-.39 1.41 0l4.59 4.59c.39.39.39 1.02 0 1.41L10.7 17.3c-.39.39-1.02.39-1.41 0-.38-.39-.39-1.03 0-1.42z"
	}), 'KeyboardArrowRightRounded');
	
	exports.default = _default;

/***/ },
/* 3591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
	}), 'KeyboardArrowRightSharp');
	
	exports.default = _default;

/***/ },
/* 3592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
	}), 'KeyboardArrowRightTwoTone');
	
	exports.default = _default;

/***/ },
/* 3593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
	}), 'KeyboardArrowUp');
	
	exports.default = _default;

/***/ },
/* 3594 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"
	}), 'KeyboardArrowUpOutlined');
	
	exports.default = _default;

/***/ },
/* 3595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.12 14.71L12 10.83l3.88 3.88c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L12.7 8.71a.9959.9959 0 00-1.41 0L6.7 13.3c-.39.39-.39 1.02 0 1.41.39.38 1.03.39 1.42 0z"
	}), 'KeyboardArrowUpRounded');
	
	exports.default = _default;

/***/ },
/* 3596 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"
	}), 'KeyboardArrowUpSharp');
	
	exports.default = _default;

/***/ },
/* 3597 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"
	}), 'KeyboardArrowUpTwoTone');
	
	exports.default = _default;

/***/ },
/* 3598 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"
	}), 'KeyboardBackspace');
	
	exports.default = _default;

/***/ },
/* 3599 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21v-2z"
	}), 'KeyboardBackspaceOutlined');
	
	exports.default = _default;

/***/ },
/* 3600 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 11H6.83l2.88-2.88c.39-.39.39-1.02 0-1.41a.9959.9959 0 00-1.41 0L3.71 11.3c-.39.39-.39 1.02 0 1.41L8.3 17.3c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L6.83 13H20c.55 0 1-.45 1-1s-.45-1-1-1z"
	}), 'KeyboardBackspaceRounded');
	
	exports.default = _default;

/***/ },
/* 3601 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21v-2z"
	}), 'KeyboardBackspaceSharp');
	
	exports.default = _default;

/***/ },
/* 3602 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21v-2z"
	}), 'KeyboardBackspaceTwoTone');
	
	exports.default = _default;

/***/ },
/* 3603 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z"
	}), 'KeyboardCapslock');
	
	exports.default = _default;

/***/ },
/* 3604 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z"
	}), 'KeyboardCapslockOutlined');
	
	exports.default = _default;

/***/ },
/* 3605 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8.41l3.89 3.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L12.71 6.3a.9959.9959 0 00-1.41 0l-4.6 4.59c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 8.41zM7 18h10c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1z"
	}), 'KeyboardCapslockRounded');
	
	exports.default = _default;

/***/ },
/* 3606 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z"
	}), 'KeyboardCapslockSharp');
	
	exports.default = _default;

/***/ },
/* 3607 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z"
	}), 'KeyboardCapslockTwoTone');
	
	exports.default = _default;

/***/ },
/* 3608 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 3h2v2h-2V6zm0 3h2v2h-2V9zM8 6h2v2H8V6zm0 3h2v2H8V9zm-1 2H5V9h2v2zm0-3H5V6h2v2zm9 7H8v-2h8v2zm0-4h-2V9h2v2zm0-3h-2V6h2v2zm3 3h-2V9h2v2zm0-3h-2V6h2v2zm-7 15l4-4H8l4 4z"
	}), 'KeyboardHide');
	
	exports.default = _default;

/***/ },
/* 3609 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H4V5h16v10zm-9-9h2v2h-2zm0 3h2v2h-2zM8 6h2v2H8zm0 3h2v2H8zM5 9h2v2H5zm0-3h2v2H5zm3 6h8v2H8zm6-3h2v2h-2zm0-3h2v2h-2zm3 3h2v2h-2zm0-3h2v2h-2zm-5 17l4-4H8z"
	}), 'KeyboardHideOutlined');
	
	exports.default = _default;

/***/ },
/* 3610 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 3h2v2h-2V6zm0 3h2v2h-2V9zM8 6h2v2H8V6zm0 3h2v2H8V9zm-1 2H5V9h2v2zm0-3H5V6h2v2zm8 7H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1zm1-4h-2V9h2v2zm0-3h-2V6h2v2zm3 3h-2V9h2v2zm0-3h-2V6h2v2zm-6.65 14.65l2.79-2.79c.31-.31.09-.85-.35-.85H9.21c-.45 0-.67.54-.35.85l2.79 2.79c.19.19.51.19.7 0z"
	}), 'KeyboardHideRounded');
	
	exports.default = _default;

/***/ },
/* 3611 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 3H2.01L2 17h20V3zM11 6h2v2h-2V6zm0 3h2v2h-2V9zM8 6h2v2H8V6zm0 3h2v2H8V9zm-1 2H5V9h2v2zm0-3H5V6h2v2zm9 7H8v-2h8v2zm0-4h-2V9h2v2zm0-3h-2V6h2v2zm3 3h-2V9h2v2zm0-3h-2V6h2v2zm-7 15l4-4H8l4 4z"
	}), 'KeyboardHideSharp');
	
	exports.default = _default;

/***/ },
/* 3612 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 15h16V5H4v10zm13-9h2v2h-2V6zm0 3h2v2h-2V9zm-3-3h2v2h-2V6zm0 3h2v2h-2V9zm-3-3h2v2h-2V6zm0 3h2v2h-2V9zM8 6h2v2H8V6zm0 3h2v2H8V9zm0 3h8v2H8v-2zM5 6h2v2H5V6zm0 3h2v2H5V9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H4V5h16v10zm-9-9h2v2h-2zm0 3h2v2h-2zM8 6h2v2H8zm0 3h2v2H8zM5 9h2v2H5zm0-3h2v2H5zm3 6h8v2H8zm6-3h2v2h-2zm0-3h2v2h-2zm3 3h2v2h-2zm0-3h2v2h-2zm-5 17l4-4H8l4 4z"
	})), 'KeyboardHideTwoTone');
	
	exports.default = _default;

/***/ },
/* 3613 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 7v10H4V7h16m0-2H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2zm0 3h2v2h-2zM8 8h2v2H8zm0 3h2v2H8zm-3 0h2v2H5zm0-3h2v2H5zm3 6h8v2H8zm6-3h2v2h-2zm0-3h2v2h-2zm3 3h2v2h-2zm0-3h2v2h-2z"
	}), 'KeyboardOutlined');
	
	exports.default = _default;

/***/ },
/* 3614 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z"
	}), 'KeyboardReturn');
	
	exports.default = _default;

/***/ },
/* 3615 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7h-2z"
	}), 'KeyboardReturnOutlined');
	
	exports.default = _default;

/***/ },
/* 3616 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 8v3H5.83l2.88-2.88c.39-.39.39-1.02 0-1.41a.9959.9959 0 00-1.41 0L2.71 11.3c-.39.39-.39 1.02 0 1.41L7.3 17.3c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L5.83 13H20c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1s-1 .45-1 1z"
	}), 'KeyboardReturnRounded');
	
	exports.default = _default;

/***/ },
/* 3617 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7h-2z"
	}), 'KeyboardReturnSharp');
	
	exports.default = _default;

/***/ },
/* 3618 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7h-2z"
	}), 'KeyboardReturnTwoTone');
	
	exports.default = _default;

/***/ },
/* 3619 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm8 7H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1zm1-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z"
	}), 'KeyboardRounded');
	
	exports.default = _default;

/***/ },
/* 3620 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 5H2.01L2 19h20V5zM11 8h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z"
	}), 'KeyboardSharp');
	
	exports.default = _default;

/***/ },
/* 3621 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z"
	}), 'KeyboardTab');
	
	exports.default = _default;

/***/ },
/* 3622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z"
	}), 'KeyboardTabOutlined');
	
	exports.default = _default;

/***/ },
/* 3623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.29 8.12L15.17 11H2c-.55 0-1 .45-1 1s.45 1 1 1h13.17l-2.88 2.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L13.7 6.7a.9959.9959 0 00-1.41 0c-.38.39-.39 1.03 0 1.42zM20 7v10c0 .55.45 1 1 1s1-.45 1-1V7c0-.55-.45-1-1-1s-1 .45-1 1z"
	}), 'KeyboardTabRounded');
	
	exports.default = _default;

/***/ },
/* 3624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z"
	}), 'KeyboardTabSharp');
	
	exports.default = _default;

/***/ },
/* 3625 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z"
	}), 'KeyboardTabTwoTone');
	
	exports.default = _default;

/***/ },
/* 3626 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 17h16V7H4v10zm13-9h2v2h-2V8zm0 3h2v2h-2v-2zm-3-3h2v2h-2V8zm0 3h2v2h-2v-2zm-3-3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm0 3h8v2H8v-2zM5 8h2v2H5V8zm0 3h2v2H5v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H4V7h16v10zm-9-9h2v2h-2zm0 3h2v2h-2zM8 8h2v2H8zm0 3h2v2H8zm-3 0h2v2H5zm0-3h2v2H5zm3 6h8v2H8zm6-3h2v2h-2zm0-3h2v2h-2zm3 3h2v2h-2zm0-3h2v2h-2z"
	})), 'KeyboardTwoTone');
	
	exports.default = _default;

/***/ },
/* 3627 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.42 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
	}), 'KeyboardVoice');
	
	exports.default = _default;

/***/ },
/* 3628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm-1.2-9.1c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2s-1.2-.54-1.2-1.2V5.9zm6.5 6.1c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.41 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
	}), 'KeyboardVoiceOutlined');
	
	exports.default = _default;

/***/ },
/* 3629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm6.08-3c-.42 0-.77.3-.83.71-.37 2.61-2.72 4.39-5.25 4.39s-4.88-1.77-5.25-4.39c-.06-.41-.42-.71-.83-.71-.52 0-.92.46-.85.97.46 2.97 2.96 5.3 5.93 5.75V21c0 .55.45 1 1 1s1-.45 1-1v-2.28c2.96-.43 5.47-2.78 5.93-5.75.07-.51-.33-.97-.85-.97z"
	}), 'KeyboardVoiceRounded');
	
	exports.default = _default;

/***/ },
/* 3630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.42 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
	}), 'KeyboardVoiceSharp');
	
	exports.default = _default;

/***/ },
/* 3631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 13.3c.66 0 1.19-.54 1.19-1.2l.01-6.2c0-.66-.54-1.2-1.2-1.2s-1.2.54-1.2 1.2v6.2c0 .66.54 1.2 1.2 1.2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm-1.2-9.1c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2s-1.2-.54-1.2-1.2V5.9zm6.5 6.1c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.41 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
	})), 'KeyboardVoiceTwoTone');
	
	exports.default = _default;

/***/ },
/* 3632 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 10V7c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33L4 19h1l.67-2h12.67l.66 2h1l.67-2H22v-5c0-1.1-.9-2-2-2zm-9 0H6V7h5v3zm7 0h-5V7h5v3z"
	}), 'KingBed');
	
	exports.default = _default;

/***/ },
/* 3633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 12c0-1.1-.9-2-2-2V7c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33L4 19h1l.67-2h12.67l.66 2h1l.67-2H22v-5zm-4-2h-5V7h5v3zM6 7h5v3H6V7zm-2 5h16v3H4v-3z"
	}), 'KingBedOutlined');
	
	exports.default = _default;

/***/ },
/* 3634 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 10V7c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33l.51 1.53c.1.28.36.47.66.47.3 0 .56-.19.66-.47L5.67 17h12.67l.51 1.53c.09.28.35.47.65.47.3 0 .56-.19.66-.47l.51-1.53H22v-5c0-1.1-.9-2-2-2zm-9 0H6V8c0-.55.45-1 1-1h4v3zm7 0h-5V7h4c.55 0 1 .45 1 1v2z"
	}), 'KingBedRounded');
	
	exports.default = _default;

/***/ },
/* 3635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 10V5H4v5H2v7h1.33L4 19h1l.67-2h12.67l.66 2h1l.67-2H22v-7h-2zm-9 0H6V7h5v3zm7 0h-5V7h5v3z"
	}), 'KingBedSharp');
	
	exports.default = _default;

/***/ },
/* 3636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 12h16v3H4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 10V7c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33L4 19h1l.67-2h12.67l.66 2h1l.67-2H22v-5c0-1.1-.9-2-2-2zm-7-3h5v3h-5V7zM6 7h5v3H6V7zm14 8H4v-3h16v3z"
	})), 'KingBedTwoTone');
	
	exports.default = _default;

/***/ },
/* 3637 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 2.01L6 2c-1.1 0-2 .89-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.11-.9-1.99-2-1.99zM18 20H6v-9.02h12V20zm0-11H6V4h12v5zM8 5h2v3H8zm0 7h2v5H8z"
	}), 'Kitchen');
	
	exports.default = _default;

/***/ },
/* 3638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 5h2v3H8zm0 7h2v5H8zm10-9.99L6 2c-1.1 0-2 .89-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.11-.9-1.99-2-1.99zM18 20H6v-9.02h12V20zm0-11H6V4h12v5z"
	}), 'KitchenOutlined');
	
	exports.default = _default;

/***/ },
/* 3639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 2.01L6 2c-1.1 0-2 .89-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.11-.9-1.99-2-1.99zM17 20H7c-.55 0-1-.45-1-1v-7.02c0-.55.45-1 1-1h10c.55 0 1 .45 1 1V19c0 .55-.45 1-1 1zm0-11H7c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1zM9 5c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1s-1-.45-1-1V6c0-.55.45-1 1-1zm0 7c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1s-1-.45-1-1v-3c0-.55.45-1 1-1z"
	}), 'KitchenRounded');
	
	exports.default = _default;

/***/ },
/* 3640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2.01L4 2v20h16V2.01zM18 20H6v-9.02h12V20zm0-11H6V4h12v5zM8 5h2v3H8V5zm0 7h2v5H8v-5z"
	}), 'KitchenSharp');
	
	exports.default = _default;

/***/ },
/* 3641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 5h2v3H8zm0 7h2v5H8zm-2 8h12v-9.02H6V20zm2-8h2v5H8v-5zM6 9h12V4H6v5zm2-4h2v3H8V5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 2.01L6 2c-1.1 0-2 .89-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.11-.9-1.99-2-1.99zM18 20H6v-9.02h12V20zm0-11H6V4h12v5zM8 5h2v3H8zm0 7h2v5H8z"
	})), 'KitchenTwoTone');
	
	exports.default = _default;

/***/ },
/* 3642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z"
	}), 'Label');
	
	exports.default = _default;

/***/ },
/* 3643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.5 18.99l11 .01c.67 0 1.27-.33 1.63-.84L20.5 12l-4.37-6.16c-.36-.51-.96-.84-1.63-.84l-11 .01L8.34 12 3.5 18.99z"
	}), 'LabelImportant');
	
	exports.default = _default;

/***/ },
/* 3644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 18.99h11c.67 0 1.27-.32 1.63-.83L21 12l-4.37-6.16C16.27 5.33 15.67 5 15 5H4l5 7-5 6.99z"
	}), 'LabelImportantOutlined');
	
	exports.default = _default;

/***/ },
/* 3645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.94 18.99H15c.65 0 1.26-.31 1.63-.84l3.95-5.57c.25-.35.25-.81 0-1.16l-3.96-5.58C16.26 5.31 15.65 5 15 5H5.94c-.81 0-1.28.93-.81 1.59L9 12l-3.87 5.41c-.47.66 0 1.58.81 1.58z"
	}), 'LabelImportantRounded');
	
	exports.default = _default;

/***/ },
/* 3646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 18.99h12.04L21 12l-4.97-7H4l5 7-5 6.99z"
	}), 'LabelImportantSharp');
	
	exports.default = _default;

/***/ },
/* 3647 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15 7H7.89l3.57 5-3.57 5H15l3.55-5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16.63 5.84C16.27 5.33 15.67 5 15 5H4l5 7-5 6.99h11c.67 0 1.27-.32 1.63-.83L21 12l-4.37-6.16zM15 17H7.89l3.57-5-3.57-5H15l3.55 5L15 17z"
	})), 'LabelImportantTwoTone');
	
	exports.default = _default;

/***/ },
/* 3648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.25 2.75l17 17L19 21l-2-2H5c-1.1 0-2-.9-2-2V7c0-.55.23-1.05.59-1.41L2 4l1.25-1.25zM22 12l-4.37-6.16C17.27 5.33 16.67 5 16 5H8l11 11 3-4z"
	}), 'LabelOff');
	
	exports.default = _default;

/***/ },
/* 3649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 7l3.55 5-1.63 2.29 1.43 1.43L22 12l-4.37-6.16C17.27 5.33 16.67 5 16 5l-7.37.01 2 1.99H16zM2 4.03l1.58 1.58C3.22 5.96 3 6.46 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.28 0 .55-.07.79-.18L18.97 21l1.41-1.41L3.41 2.62 2 4.03zM14.97 17H5V7.03L14.97 17z"
	}), 'LabelOffOutlined');
	
	exports.default = _default;

/***/ },
/* 3650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.59 12.58c.25-.35.25-.81 0-1.16l-3.96-5.58C17.27 5.33 16.67 5 16 5H8.66l10.7 10.73 2.23-3.15zM2.72 4.72l.87.87C3.23 5.95 3 6.45 3 7v10c0 1.1.9 2 2 2h12l1.29 1.29c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L4.14 3.31c-.38-.38-1.01-.39-1.4-.01-.41.38-.41 1.03-.02 1.42z"
	}), 'LabelOffRounded');
	
	exports.default = _default;

/***/ },
/* 3651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 12l-4.97-7H8.66l10.7 10.73zM2 4l1 1v14h14l2 2 1.41-1.41L3.44 2.62z"
	}), 'LabelOffSharp');
	
	exports.default = _default;

/***/ },
/* 3652 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 7.03V17h9.97zM16 7h-5.37l7.29 7.29L19.55 12z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16 7l3.55 5-1.63 2.29 1.43 1.43L22 12l-4.37-6.16C17.27 5.33 16.67 5 16 5l-7.37.01 2 1.99H16zM2 4.03l1.58 1.58C3.22 5.96 3 6.46 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.28 0 .55-.07.79-.18L18.97 21l1.41-1.41L3.41 2.62 2 4.03zm3 3L14.97 17H5V7.03z"
	})), 'LabelOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 3653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z"
	}), 'LabelOutlined');
	
	exports.default = _default;

/***/ },
/* 3654 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84l3.96-5.58c.25-.35.25-.81 0-1.16l-3.96-5.58z"
	}), 'LabelRounded');
	
	exports.default = _default;

/***/ },
/* 3655 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.03 5L3 5.01v13.98l14.03.01L22 12l-4.97-7z"
	}), 'LabelSharp');
	
	exports.default = _default;

/***/ },
/* 3656 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16 7H5v10h11l3.55-5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z"
	})), 'LabelTwoTone');
	
	exports.default = _default;

/***/ },
/* 3657 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
	}), 'Landscape');
	
	exports.default = _default;

/***/ },
/* 3658 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6l-4.22 5.63 1.25 1.67L14 9.33 19 16h-8.46l-4.01-5.37L1 18h22L14 6zM5 16l1.52-2.03L8.04 16H5z"
	}), 'LandscapeOutlined');
	
	exports.default = _default;

/***/ },
/* 3659 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.2 7.07L10.25 11l2.25 3c.33.44.24 1.07-.2 1.4-.44.33-1.07.25-1.4-.2-1.05-1.4-2.31-3.07-3.1-4.14-.4-.53-1.2-.53-1.6 0l-4 5.33c-.49.67-.02 1.61.8 1.61h18c.82 0 1.29-.94.8-1.6l-7-9.33c-.4-.54-1.2-.54-1.6 0z"
	}), 'LandscapeRounded');
	
	exports.default = _default;

/***/ },
/* 3660 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
	}), 'LandscapeSharp');
	
	exports.default = _default;

/***/ },
/* 3661 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 16h3.04l-1.52-2.03z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9.78 11.63l1.25 1.67L14 9.33 19 16h-8.46l-4.01-5.37L1 18h22L14 6l-4.22 5.63zM5 16l1.52-2.03L8.04 16H5z"
	})), 'LandscapeTwoTone');
	
	exports.default = _default;

/***/ },
/* 3662 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
	}), 'Language');
	
	exports.default = _default;

/***/ },
/* 3663 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
	}), 'LanguageOutlined');
	
	exports.default = _default;

/***/ },
/* 3664 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
	}), 'LanguageRounded');
	
	exports.default = _default;

/***/ },
/* 3665 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
	}), 'LanguageSharp');
	
	exports.default = _default;

/***/ },
/* 3666 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5.08 8h2.95c.32-1.25.78-2.45 1.38-3.56-1.84.63-3.37 1.9-4.33 3.56zm2.42 4c0-.68.06-1.34.14-2H4.26c-.16.64-.26 1.31-.26 2s.1 1.36.26 2h3.38c-.08-.66-.14-1.32-.14-2zm-2.42 4c.96 1.66 2.49 2.93 4.33 3.56-.6-1.11-1.06-2.31-1.38-3.56H5.08zM12 4.04c-.83 1.2-1.48 2.53-1.91 3.96h3.82c-.43-1.43-1.08-2.76-1.91-3.96zM18.92 8c-.96-1.65-2.49-2.93-4.33-3.56.6 1.11 1.06 2.31 1.38 3.56h2.95zM12 19.96c.83-1.2 1.48-2.53 1.91-3.96h-3.82c.43 1.43 1.08 2.76 1.91 3.96zm2.59-.4c1.84-.63 3.37-1.91 4.33-3.56h-2.95c-.32 1.25-.78 2.45-1.38 3.56zM19.74 10h-3.38c.08.66.14 1.32.14 2s-.06 1.34-.14 2h3.38c.16-.64.26-1.31.26-2s-.1-1.36-.26-2zM9.66 10c-.09.65-.16 1.32-.16 2s.07 1.34.16 2h4.68c.09-.66.16-1.32.16-2s-.07-1.35-.16-2H9.66z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
	})), 'LanguageTwoTone');
	
	exports.default = _default;

/***/ },
/* 3667 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
	}), 'Laptop');
	
	exports.default = _default;

/***/ },
/* 3668 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z"
	}), 'LaptopChromebook');
	
	exports.default = _default;

/***/ },
/* 3669 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z"
	}), 'LaptopChromebookOutlined');
	
	exports.default = _default;

/***/ },
/* 3670 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 18h-1V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v13H1c-.55 0-1 .45-1 1s.45 1 1 1h22c.55 0 1-.45 1-1s-.45-1-1-1zm-9.5 0h-3c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h3c.28 0 .5.22.5.5s-.22.5-.5.5zm6.5-3H4V6c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v9z"
	}), 'LaptopChromebookRounded');
	
	exports.default = _default;

/***/ },
/* 3671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z"
	}), 'LaptopChromebookSharp');
	
	exports.default = _default;

/***/ },
/* 3672 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 5h16v10H4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z"
	})), 'LaptopChromebookTwoTone');
	
	exports.default = _default;

/***/ },
/* 3673 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'LaptopMac');
	
	exports.default = _default;

/***/ },
/* 3674 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'LaptopMacOutlined');
	
	exports.default = _default;

/***/ },
/* 3675 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM5 5h14c.55 0 1 .45 1 1v9c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1zm7 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'LaptopMacRounded');
	
	exports.default = _default;

/***/ },
/* 3676 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18l1.99-2L22 3H2v13l2 2H0v2h24v-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'LaptopMacSharp');
	
	exports.default = _default;

/***/ },
/* 3677 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 5h16v11H4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	})), 'LaptopMacTwoTone');
	
	exports.default = _default;

/***/ },
/* 3678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
	}), 'LaptopOutlined');
	
	exports.default = _default;

/***/ },
/* 3679 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H1c-.55 0-1 .45-1 1s.45 1 1 1h22c.55 0 1-.45 1-1s-.45-1-1-1h-3zM5 6h14c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1z"
	}), 'LaptopRounded');
	
	exports.default = _default;

/***/ },
/* 3680 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18l2-2V4H2v12l2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
	}), 'LaptopSharp');
	
	exports.default = _default;

/***/ },
/* 3681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 6h16v10H4V6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
	})), 'LaptopTwoTone');
	
	exports.default = _default;

/***/ },
/* 3682 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H0v2h24v-2h-4zM4 5h16v10H4V5z"
	}), 'LaptopWindows');
	
	exports.default = _default;

/***/ },
/* 3683 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H0v2h24v-2h-4zM4 5h16v10H4V5z"
	}), 'LaptopWindowsOutlined');
	
	exports.default = _default;

/***/ },
/* 3684 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H1c-.55 0-1 .45-1 1s.45 1 1 1h22c.55 0 1-.45 1-1s-.45-1-1-1h-3zM5 5h14c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1z"
	}), 'LaptopWindowsRounded');
	
	exports.default = _default;

/***/ },
/* 3685 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18v-1h1.99L22 3H2v14h2v1H0v2h24v-2h-4zM4 5h16v10H4V5z"
	}), 'LaptopWindowsSharp');
	
	exports.default = _default;

/***/ },
/* 3686 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 5h16v10H4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H0v2h24v-2h-4zM4 5h16v10H4V5z"
	})), 'LaptopWindowsTwoTone');
	
	exports.default = _default;

/***/ },
/* 3687 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
	}), 'LastPage');
	
	exports.default = _default;

/***/ },
/* 3688 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6-1.41 1.41zM16 6h2v12h-2V6z"
	}), 'LastPageOutlined');
	
	exports.default = _default;

/***/ },
/* 3689 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.29 8.11L10.18 12l-3.89 3.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L7.7 6.7a.9959.9959 0 00-1.41 0c-.38.39-.38 1.03 0 1.41zM17 6c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1s-1-.45-1-1V7c0-.55.45-1 1-1z"
	}), 'LastPageRounded');
	
	exports.default = _default;

/***/ },
/* 3690 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6-1.41 1.41zM16 6h2v12h-2V6z"
	}), 'LastPageSharp');
	
	exports.default = _default;

/***/ },
/* 3691 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6-1.41 1.41zM16 6h2v12h-2V6z"
	}), 'LastPageTwoTone');
	
	exports.default = _default;

/***/ },
/* 3692 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
	}), 'Launch');
	
	exports.default = _default;

/***/ },
/* 3693 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
	}), 'LaunchOutlined');
	
	exports.default = _default;

/***/ },
/* 3694 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 19H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h5c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.11 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55-.45 1-1 1zM14 4c0 .55.45 1 1 1h2.59l-9.13 9.13c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L19 6.41V9c0 .55.45 1 1 1s1-.45 1-1V3h-6c-.55 0-1 .45-1 1z"
	}), 'LaunchRounded');
	
	exports.default = _default;

/***/ },
/* 3695 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 19H5V5h7V3H3v18h18v-9h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
	}), 'LaunchSharp');
	
	exports.default = _default;

/***/ },
/* 3696 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
	}), 'LaunchTwoTone');
	
	exports.default = _default;

/***/ },
/* 3697 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"
	}), 'Layers');
	
	exports.default = _default;

/***/ },
/* 3698 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.81 14.99l1.19-.92-1.43-1.43-1.19.92 1.43 1.43zm-.45-4.72L21 9l-9-7-2.91 2.27 7.87 7.88 2.4-1.88zM3.27 1L2 2.27l4.22 4.22L3 9l1.63 1.27L12 16l2.1-1.63 1.43 1.43L12 18.54l-7.37-5.73L3 14.07l9 7 4.95-3.85L20.73 21 22 19.73 3.27 1z"
	}), 'LayersClear');
	
	exports.default = _default;

/***/ },
/* 3699 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4.53L17.74 9l-1.89 1.47 1.43 1.42L21 9l-9-7-2.59 2.02 1.42 1.42zm9 9.54l-1.63-1.27-.67.52 1.43 1.43zM3.41.86L2 2.27l4.22 4.22L3 9l9 7 2.1-1.63 1.42 1.42-3.53 2.75-7.37-5.73L3 14.07l9 7 4.95-3.85L20.73 21l1.41-1.41L3.41.86zM12 13.47L6.26 9l1.39-1.08 5.02 5.02-.67.53z"
	}), 'LayersClearOutlined');
	
	exports.default = _default;

/***/ },
/* 3700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.99 9.79c.51-.4.51-1.18 0-1.58l-6.76-5.26c-.72-.56-1.73-.56-2.46 0L9.41 4.02l7.88 7.88 2.7-2.11zm0 3.49l-.01-.01a.991.991 0 00-1.22 0l-.05.04 1.4 1.4c.37-.41.34-1.07-.12-1.43zm1.45 5.6L4.12 1.56a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l3.52 3.52-2.22 1.72c-.51.4-.51 1.18 0 1.58l6.76 5.26c.72.56 1.73.56 2.46 0l.87-.68 1.42 1.42-2.92 2.27c-.36.28-.87.28-1.23 0l-6.15-4.78a.991.991 0 00-1.22 0c-.51.4-.51 1.17 0 1.57l6.76 5.26c.72.56 1.73.56 2.46 0l3.72-2.89 3.07 3.07c.39.39 1.02.39 1.41 0 .41-.39.41-1.02.02-1.41z"
	}), 'LayersClearRounded');
	
	exports.default = _default;

/***/ },
/* 3701 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 9l-9-7-2.59 2.02 7.87 7.87zm0 5.07l-1.63-1.27-.67.52 1.43 1.43zM3.41.86L2 2.27l4.22 4.22L3 9l9 7 2.1-1.63 1.42 1.42-3.53 2.75-7.37-5.73L3 14.07l9 7 4.95-3.85L20.73 21l1.41-1.41z"
	}), 'LayersClearSharp');
	
	exports.default = _default;

/***/ },
/* 3702 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 13.47l.67-.53-5.02-5.02L6.26 9zm0-8.94l-1.17.91 5.02 5.03L17.74 9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 4.53L17.74 9l-1.89 1.47 1.43 1.42L21 9l-9-7-2.59 2.02 1.42 1.42zm9 9.54l-1.63-1.27-.67.52 1.43 1.43zM3.41.86L2 2.27l4.22 4.22L3 9l9 7 2.1-1.63 1.42 1.42-3.53 2.75-7.37-5.73L3 14.07l9 7 4.95-3.85L20.73 21l1.41-1.41L3.41.86zM12 13.47L6.26 9l1.39-1.08 5.02 5.02-.67.53z"
	})), 'LayersClearTwoTone');
	
	exports.default = _default;

/***/ },
/* 3703 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16zm0-11.47L17.74 9 12 13.47 6.26 9 12 4.53z"
	}), 'LayersOutlined');
	
	exports.default = _default;

/***/ },
/* 3704 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.6 18.06c-.36.28-.87.28-1.23 0l-6.15-4.78a.991.991 0 00-1.22 0c-.51.4-.51 1.17 0 1.57l6.76 5.26c.72.56 1.73.56 2.46 0l6.76-5.26c.51-.4.51-1.17 0-1.57l-.01-.01a.991.991 0 00-1.22 0l-6.15 4.79zm.63-3.02l6.76-5.26c.51-.4.51-1.18 0-1.58l-6.76-5.26c-.72-.56-1.73-.56-2.46 0L4.01 8.21c-.51.4-.51 1.18 0 1.58l6.76 5.26c.72.56 1.74.56 2.46-.01z"
	}), 'LayersRounded');
	
	exports.default = _default;

/***/ },
/* 3705 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"
	}), 'LayersSharp');
	
	exports.default = _default;

/***/ },
/* 3706 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6.26 9L12 13.47 17.74 9 12 4.53z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19.37 12.8l-7.38 5.74-7.37-5.73L3 14.07l9 7 9-7zM12 2L3 9l1.63 1.27L12 16l7.36-5.73L21 9l-9-7zm0 11.47L6.26 9 12 4.53 17.74 9 12 13.47z"
	})), 'LayersTwoTone');
	
	exports.default = _default;

/***/ },
/* 3707 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 3H3v3c1.66 0 3-1.34 3-3zm8 0h-2c0 4.97-4.03 9-9 9v2c6.08 0 11-4.93 11-11zm-4 0H8c0 2.76-2.24 5-5 5v2c3.87 0 7-3.13 7-7zm0 18h2c0-4.97 4.03-9 9-9v-2c-6.07 0-11 4.93-11 11zm8 0h3v-3c-1.66 0-3 1.34-3 3zm-4 0h2c0-2.76 2.24-5 5-5v-2c-3.87 0-7 3.13-7 7z"
	}), 'LeakAdd');
	
	exports.default = _default;

/***/ },
/* 3708 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 3H3v3c1.66 0 3-1.34 3-3zm8 0h-2c0 4.97-4.03 9-9 9v2c6.08 0 11-4.93 11-11zm-4 0H8c0 2.76-2.24 5-5 5v2c3.87 0 7-3.13 7-7zm0 18h2c0-4.97 4.03-9 9-9v-2c-6.07 0-11 4.93-11 11zm8 0h3v-3c-1.66 0-3 1.34-3 3zm-4 0h2c0-2.76 2.24-5 5-5v-2c-3.87 0-7 3.13-7 7z"
	}), 'LeakAddOutlined');
	
	exports.default = _default;

/***/ },
/* 3709 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.05 21c.5 0 .94-.37.99-.87.41-4.27 3.81-7.67 8.08-8.08.5-.05.88-.48.88-.99 0-.59-.51-1.06-1.1-1-5.19.52-9.32 4.65-9.84 9.83-.06.59.4 1.11.99 1.11zM18 21h3v-3c-1.66 0-3 1.34-3 3zm-2.91 0c.49 0 .9-.36.98-.85.36-2.08 2-3.72 4.08-4.08.49-.08.85-.49.85-.98 0-.61-.54-1.09-1.14-1-2.96.48-5.29 2.81-5.77 5.77-.1.6.39 1.14 1 1.14zM12.97 3.02c-.5 0-.94.37-.99.87-.41 4.27-3.81 7.67-8.08 8.08-.5.05-.88.48-.88.99 0 .59.51 1.06 1.1 1 5.19-.52 9.32-4.65 9.84-9.83.07-.58-.39-1.11-.99-1.11zm-6.94 0h-3v3c1.66 0 3-1.34 3-3zm2.91 0c-.49 0-.9.36-.98.85-.36 2.08-2 3.72-4.08 4.08-.49.09-.85.49-.85.99 0 .61.54 1.09 1.14 1 2.96-.48 5.29-2.81 5.77-5.77.09-.61-.4-1.15-1-1.15z"
	}), 'LeakAddRounded');
	
	exports.default = _default;

/***/ },
/* 3710 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 3H3v3c1.66 0 3-1.34 3-3zm8 0h-2c0 4.97-4.03 9-9 9v2c6.08 0 11-4.93 11-11zm-4 0H8c0 2.76-2.24 5-5 5v2c3.87 0 7-3.13 7-7zm0 18h2c0-4.97 4.03-9 9-9v-2c-6.07 0-11 4.93-11 11zm8 0h3v-3c-1.66 0-3 1.34-3 3zm-4 0h2c0-2.76 2.24-5 5-5v-2c-3.87 0-7 3.13-7 7z"
	}), 'LeakAddSharp');
	
	exports.default = _default;

/***/ },
/* 3711 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 21h3v-3c-1.66 0-3 1.34-3 3zM3 14c6.08 0 11-4.93 11-11h-2c0 4.97-4.03 9-9 9v2zm11 7h2c0-2.76 2.24-5 5-5v-2c-3.87 0-7 3.13-7 7zM3 10c3.87 0 7-3.13 7-7H8c0 2.76-2.24 5-5 5v2zm7 11h2c0-4.97 4.03-9 9-9v-2c-6.07 0-11 4.93-11 11zM3 3v3c1.66 0 3-1.34 3-3H3z"
	}), 'LeakAddTwoTone');
	
	exports.default = _default;

/***/ },
/* 3712 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 3H8c0 .37-.04.72-.12 1.06l1.59 1.59C9.81 4.84 10 3.94 10 3zM3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97C7.14 11.24 5.16 12 3 12v2c2.71 0 5.19-.99 7.11-2.62l2.5 2.5C10.99 15.81 10 18.29 10 21h2c0-2.16.76-4.14 2.03-5.69l1.43 1.43C14.55 17.91 14 19.39 14 21h2c0-1.06.33-2.03.89-2.84L19.73 21 21 19.73 4.27 3 3 4.27zM14 3h-2c0 1.5-.37 2.91-1.02 4.16l1.46 1.46C13.42 6.98 14 5.06 14 3zm5.94 13.12c.34-.08.69-.12 1.06-.12v-2c-.94 0-1.84.19-2.66.52l1.6 1.6zm-4.56-4.56l1.46 1.46C18.09 12.37 19.5 12 21 12v-2c-2.06 0-3.98.58-5.62 1.56z"
	}), 'LeakRemove');
	
	exports.default = _default;

/***/ },
/* 3713 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 3h-2c0 1.35-.31 2.63-.84 3.77l1.49 1.49C13.51 6.7 14 4.91 14 3zm7 9v-2c-1.91 0-3.7.49-5.27 1.35l1.49 1.49c1.15-.53 2.43-.84 3.78-.84zm0 4v-2c-.79 0-1.54.13-2.24.37l1.68 1.68c.19-.01.37-.05.56-.05zM10 3H8c0 .19-.04.37-.06.56l1.68 1.68c.25-.7.38-1.46.38-2.24zm-5.59-.14L3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97C7.14 11.24 5.16 12 3 12v2c2.72 0 5.2-.99 7.11-2.62l2.51 2.51C10.99 15.81 10 18.29 10 21h2c0-2.16.76-4.14 2.03-5.7l1.43 1.43C14.55 17.91 14 19.39 14 21h2c0-1.06.33-2.03.89-2.84L19.73 21l1.41-1.41L4.41 2.86z"
	}), 'LeakRemoveOutlined');
	
	exports.default = _default;

/***/ },
/* 3714 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.12 12.04c.5-.05.88-.48.88-.99 0-.59-.51-1.06-1.1-1-1.5.15-2.9.61-4.16 1.3l1.48 1.48c.9-.41 1.87-.69 2.9-.79zm.88 3.05c0-.61-.54-1.09-1.14-1-.38.06-.75.16-1.11.28l1.62 1.62c.37-.15.63-.49.63-.9zM13.97 4.14c.06-.59-.4-1.11-1-1.11-.5 0-.94.37-.99.87-.1 1.03-.38 2.01-.79 2.91l1.48 1.48c.69-1.26 1.15-2.66 1.3-4.15zm-4.04.02c.1-.6-.39-1.14-1-1.14-.41 0-.75.26-.9.62l1.62 1.62c.13-.35.22-.72.28-1.1zm10.51 14.72L5.12 3.56a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l2.15 2.15c-.59.41-1.26.7-1.99.82-.48.1-.84.5-.84 1 0 .61.54 1.09 1.14 1 1.17-.19 2.23-.68 3.13-1.37L8.73 10c-1.34 1.1-3 1.82-4.81 1.99-.5.05-.88.48-.88.99 0 .59.51 1.06 1.1 1 2.28-.23 4.36-1.15 6.01-2.56l2.48 2.48c-1.4 1.65-2.33 3.72-2.56 6-.06.59.4 1.11 1 1.11.5 0 .94-.37.99-.87.18-1.82.9-3.48 1.99-4.82l1.43 1.43c-.69.9-1.18 1.96-1.37 3.13-.1.6.39 1.14 1 1.14.49 0 .9-.36.98-.85.12-.73.42-1.4.82-1.99l2.13 2.13c.39.39 1.02.39 1.41 0 .38-.41.38-1.04-.01-1.43z"
	}), 'LeakRemoveRounded');
	
	exports.default = _default;

/***/ },
/* 3715 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 3h-2c0 1.35-.31 2.63-.84 3.77l1.49 1.49C13.51 6.7 14 4.91 14 3zm7 9v-2c-1.91 0-3.7.49-5.27 1.35l1.49 1.49c1.15-.53 2.43-.84 3.78-.84zm0 4v-2c-.79 0-1.54.13-2.24.37l1.68 1.68c.19-.01.37-.05.56-.05zM10 3H8c0 .19-.04.37-.06.56l1.68 1.68c.25-.7.38-1.46.38-2.24zm-5.59-.14L3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97C7.14 11.24 5.16 12 3 12v2c2.72 0 5.2-.99 7.11-2.62l2.51 2.51C10.99 15.81 10 18.29 10 21h2c0-2.16.76-4.14 2.03-5.7l1.43 1.43C14.55 17.91 14 19.39 14 21h2c0-1.06.33-2.03.89-2.84L19.73 21l1.41-1.41L4.41 2.86z"
	}), 'LeakRemoveSharp');
	
	exports.default = _default;

/***/ },
/* 3716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 3h-2c0 1.35-.31 2.63-.84 3.77l1.49 1.49C13.51 6.7 14 4.91 14 3zm7 9v-2c-1.91 0-3.7.49-5.27 1.35l1.49 1.49c1.15-.53 2.43-.84 3.78-.84zm0 4v-2c-.79 0-1.54.13-2.24.37l1.68 1.68c.19-.01.37-.05.56-.05zM10 3H8c0 .19-.04.37-.06.56l1.68 1.68c.25-.7.38-1.46.38-2.24zm-5.59-.14L3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97C7.14 11.24 5.16 12 3 12v2c2.72 0 5.2-.99 7.11-2.62l2.51 2.51C10.99 15.81 10 18.29 10 21h2c0-2.16.76-4.14 2.03-5.7l1.43 1.43C14.55 17.91 14 19.39 14 21h2c0-1.06.33-2.03.89-2.84L19.73 21l1.41-1.41L4.41 2.86z"
	}), 'LeakRemoveTwoTone');
	
	exports.default = _default;

/***/ },
/* 3717 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
	}), 'Lens');
	
	exports.default = _default;

/***/ },
/* 3718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
	}), 'LensOutlined');
	
	exports.default = _default;

/***/ },
/* 3719 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
	}), 'LensRounded');
	
	exports.default = _default;

/***/ },
/* 3720 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
	}), 'LensSharp');
	
	exports.default = _default;

/***/ },
/* 3721 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	})), 'LensTwoTone');
	
	exports.default = _default;

/***/ },
/* 3722 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
	}), 'LibraryAdd');
	
	exports.default = _default;

/***/ },
/* 3723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7.53 12L9 10.5l1.4-1.41 2.07 2.08L17.6 6 19 7.41 12.47 14zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
	}), 'LibraryAddCheck');
	
	exports.default = _default;

/***/ },
/* 3724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4v12H8V4h12m0-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7.53 12L9 10.5l1.4-1.41 2.07 2.08L17.6 6 19 7.41 12.47 14zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
	}), 'LibraryAddCheckOutlined');
	
	exports.default = _default;

/***/ },
/* 3725 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.24 11.28L9.69 11.2c-.38-.39-.38-1.01 0-1.4.39-.39 1.02-.39 1.41 0l1.36 1.37 4.42-4.46c.39-.39 1.02-.39 1.41 0 .38.39.38 1.01 0 1.4l-5.13 5.17c-.37.4-1.01.4-1.4 0zM3 6c-.55 0-1 .45-1 1v13c0 1.1.9 2 2 2h13c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1z"
	}), 'LibraryAddCheckRounded');
	
	exports.default = _default;

/***/ },
/* 3726 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H6v16h16V2zm-9.53 12L9 10.5l1.4-1.41 2.07 2.08L17.6 6 19 7.41 12.47 14zM4 6H2v16h16v-2H4V6z"
	}), 'LibraryAddCheckSharp');
	
	exports.default = _default;

/***/ },
/* 3727 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 16h12V4H8v12zm2.4-6.91l2.07 2.08L17.6 6 19 7.41 12.47 14 9 10.5l1.4-1.41z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-7.53-2L9 10.5l1.4-1.41 2.07 2.08L17.6 6 19 7.41 12.47 14zM4 20h14v2H4c-1.1 0-2-.9-2-2V6h2v14z"
	})), 'LibraryAddCheckTwoTone');
	
	exports.default = _default;

/***/ },
/* 3728 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-7-2h2v-3h3V9h-3V6h-2v3h-3v2h3z"
	}), 'LibraryAddOutlined');
	
	exports.default = _default;

/***/ },
/* 3729 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 6c-.55 0-1 .45-1 1v13c0 1.1.9 2 2 2h13c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1zm17-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 9h-3v3c0 .55-.45 1-1 1s-1-.45-1-1v-3h-3c-.55 0-1-.45-1-1s.45-1 1-1h3V6c0-.55.45-1 1-1s1 .45 1 1v3h3c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'LibraryAddRounded');
	
	exports.default = _default;

/***/ },
/* 3730 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6H2v16h16v-2H4V6zm18-4H6v16h16V2zm-3 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
	}), 'LibraryAddSharp');
	
	exports.default = _default;

/***/ },
/* 3731 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 16h12V4H8v12zm2-7h3V6h2v3h3v2h-3v3h-2v-3h-3V9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 22h14v-2H4V6H2v14c0 1.1.9 2 2 2zM8 2c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H8zm12 14H8V4h12v12zm-7-2h2v-3h3V9h-3V6h-2v3h-3v2h3z"
	})), 'LibraryAddTwoTone');
	
	exports.default = _default;

/***/ },
/* 3732 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z"
	}), 'LibraryBooks');
	
	exports.default = _default;

/***/ },
/* 3733 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zM10 9h8v2h-8zm0 3h4v2h-4zm0-6h8v2h-8z"
	}), 'LibraryBooksOutlined');
	
	exports.default = _default;

/***/ },
/* 3734 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 6c-.55 0-1 .45-1 1v13c0 1.1.9 2 2 2h13c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1zm17-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 9h-8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zm-4 4h-4c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1zm4-8h-8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'LibraryBooksRounded');
	
	exports.default = _default;

/***/ },
/* 3735 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6H2v16h16v-2H4V6zm18-4H6v16h16V2zm-3 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z"
	}), 'LibraryBooksSharp');
	
	exports.default = _default;

/***/ },
/* 3736 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 16h12V4H8v12zm2-10h8v2h-8V6zm0 3h8v2h-8V9zm0 3h4v2h-4v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 22h14v-2H4V6H2v14c0 1.1.9 2 2 2zM6 4v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2zm14 12H8V4h12v12zM10 9h8v2h-8zm0 3h4v2h-4zm0-6h8v2h-8z"
	})), 'LibraryBooksTwoTone');
	
	exports.default = _default;

/***/ },
/* 3737 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 5h-3v5.5c0 1.38-1.12 2.5-2.5 2.5S10 13.88 10 12.5s1.12-2.5 2.5-2.5c.57 0 1.08.19 1.5.51V5h4v2zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
	}), 'LibraryMusic');
	
	exports.default = _default;

/***/ },
/* 3738 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-7.5-1c1.38 0 2.5-1.12 2.5-2.5V7h3V5h-4v5.51c-.42-.32-.93-.51-1.5-.51-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
	}), 'LibraryMusicOutlined');
	
	exports.default = _default;

/***/ },
/* 3739 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-3 5h-2v5.37c0 1.27-.9 2.44-2.16 2.6-1.69.23-3.11-1.25-2.8-2.95.2-1.1 1.18-1.95 2.3-2.02.63-.04 1.2.16 1.66.51V6c0-.55.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1zM3 6c-.55 0-1 .45-1 1v13c0 1.1.9 2 2 2h13c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1z"
	}), 'LibraryMusicRounded');
	
	exports.default = _default;

/***/ },
/* 3740 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H6v16h16V2zm-4 5h-3v5.5c0 1.38-1.12 2.5-2.5 2.5S10 13.88 10 12.5s1.12-2.5 2.5-2.5c.57 0 1.08.19 1.5.51V5h4v2zM4 6H2v16h16v-2H4V6z"
	}), 'LibraryMusicSharp');
	
	exports.default = _default;

/***/ },
/* 3741 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 16h12V4H8v12zm4.5-6c.57 0 1.08.19 1.5.51V5h4v2h-3v5.5c0 1.38-1.12 2.5-2.5 2.5S10 13.88 10 12.5s1.12-2.5 2.5-2.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-7.5-1c1.38 0 2.5-1.12 2.5-2.5V7h3V5h-4v5.51c-.42-.32-.93-.51-1.5-.51-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
	})), 'LibraryMusicTwoTone');
	
	exports.default = _default;

/***/ },
/* 3742 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 16h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 20h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM3 12h8v-2H3v2zm10 0h8v-2h-8v2zM3 4v4h18V4H3z"
	}), 'LineStyle');
	
	exports.default = _default;

/***/ },
/* 3743 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 16h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 20h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM3 12h8v-2H3v2zm10 0h8v-2h-8v2zM3 4v4h18V4H3z"
	}), 'LineStyleOutlined');
	
	exports.default = _default;

/***/ },
/* 3744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 16h3c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm6.5 0h3c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1zm6.5 0h3c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1zM4 20c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm4 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm4 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm4 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm4 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM4 12h6c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm10 0h6c.55 0 1-.45 1-1s-.45-1-1-1h-6c-.55 0-1 .45-1 1s.45 1 1 1zM3 5v2c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1z"
	}), 'LineStyleRounded');
	
	exports.default = _default;

/***/ },
/* 3745 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 16h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 20h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM3 12h8v-2H3v2zm10 0h8v-2h-8v2zM3 4v4h18V4H3z"
	}), 'LineStyleSharp');
	
	exports.default = _default;

/***/ },
/* 3746 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 16h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 20h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM3 12h8v-2H3v2zm10 0h8v-2h-8v2zM3 4v4h18V4H3z"
	}), 'LineStyleTwoTone');
	
	exports.default = _default;

/***/ },
/* 3747 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z"
	}), 'LineWeight');
	
	exports.default = _default;

/***/ },
/* 3748 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z"
	}), 'LineWeightOutlined');
	
	exports.default = _default;

/***/ },
/* 3749 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1zm0-5H4c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1zm0-6H4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm.5 15h-17c-.28 0-.5.22-.5.5s.22.5.5.5h17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5z"
	}), 'LineWeightRounded');
	
	exports.default = _default;

/***/ },
/* 3750 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z"
	}), 'LineWeightSharp');
	
	exports.default = _default;

/***/ },
/* 3751 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z"
	}), 'LineWeightTwoTone');
	
	exports.default = _default;

/***/ },
/* 3752 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5C3.12 9.5 2 10.62 2 12s1.12 2.5 2.5 2.5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5z"
	}), 'LinearScale');
	
	exports.default = _default;

/***/ },
/* 3753 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5C3.12 9.5 2 10.62 2 12s1.12 2.5 2.5 2.5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5z"
	}), 'LinearScaleOutlined');
	
	exports.default = _default;

/***/ },
/* 3754 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5C3.12 9.5 2 10.62 2 12s1.12 2.5 2.5 2.5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5z"
	}), 'LinearScaleRounded');
	
	exports.default = _default;

/***/ },
/* 3755 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5C3.12 9.5 2 10.62 2 12s1.12 2.5 2.5 2.5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5z"
	}), 'LinearScaleSharp');
	
	exports.default = _default;

/***/ },
/* 3756 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5C3.12 9.5 2 10.62 2 12s1.12 2.5 2.5 2.5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5z"
	}), 'LinearScaleTwoTone');
	
	exports.default = _default;

/***/ },
/* 3757 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
	}), 'Link');
	
	exports.default = _default;

/***/ },
/* 3758 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.43-.98 2.63-2.31 2.98l1.46 1.46C20.88 15.61 22 13.95 22 12c0-2.76-2.24-5-5-5zm-1 4h-2.19l2 2H16zM2 4.27l3.11 3.11C3.29 8.12 2 9.91 2 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4L20 19.74 3.27 3 2 4.27z"
	}), 'LinkOff');
	
	exports.default = _default;

/***/ },
/* 3759 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.39 11L16 12.61V11zM17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.27-.77 2.37-1.87 2.84l1.4 1.4C21.05 15.36 22 13.79 22 12c0-2.76-2.24-5-5-5zM2 4.27l3.11 3.11C3.29 8.12 2 9.91 2 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4.01 1.41-1.41L3.41 2.86 2 4.27z"
	}), 'LinkOffOutlined');
	
	exports.default = _default;

/***/ },
/* 3760 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.94 11.23C21.57 8.76 19.32 7 16.82 7h-2.87c-.52 0-.95.43-.95.95s.43.95.95.95h2.9c1.6 0 3.04 1.14 3.22 2.73.17 1.43-.64 2.69-1.85 3.22l1.4 1.4c1.63-1.02 2.64-2.91 2.32-5.02zM4.12 3.56c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41l2.4 2.4c-1.94.8-3.27 2.77-3.09 5.04C2.23 15.05 4.59 17 7.23 17h2.82c.52 0 .95-.43.95-.95s-.43-.95-.95-.95H7.16c-1.63 0-3.1-1.19-3.25-2.82-.15-1.72 1.11-3.17 2.75-3.35l2.1 2.1c-.43.09-.76.46-.76.92v.1c0 .52.43.95.95.95h1.78L13 15.27V17h1.73l3.3 3.3c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L4.12 3.56zM16 11.95c0-.52-.43-.95-.95-.95h-.66l1.49 1.49c.07-.13.12-.28.12-.44v-.1z"
	}), 'LinkOffRounded');
	
	exports.default = _default;

/***/ },
/* 3761 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.39 11L16 12.61V11zM17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.27-.77 2.37-1.87 2.84l1.4 1.4C21.05 15.36 22 13.79 22 12c0-2.76-2.24-5-5-5zM2 4.27l3.11 3.11C3.29 8.12 2 9.91 2 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4.01 1.41-1.41L3.41 2.86 2 4.27z"
	}), 'LinkOffSharp');
	
	exports.default = _default;

/***/ },
/* 3762 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.39 11L16 12.61V11zM17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.27-.77 2.37-1.87 2.84l1.4 1.4C21.05 15.36 22 13.79 22 12c0-2.76-2.24-5-5-5zM2 4.27l3.11 3.11C3.29 8.12 2 9.91 2 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4.01 1.41-1.41L3.41 2.86 2 4.27z"
	}), 'LinkOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 3763 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2zm-3-4h8v2H8z"
	}), 'LinkOutlined');
	
	exports.default = _default;

/***/ },
/* 3764 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 7h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c1.65 0 3 1.35 3 3s-1.35 3-3 3h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-9 5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1H9c-.55 0-1 .45-1 1zm2 3H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h3c.55 0 1-.45 1-1s-.45-1-1-1H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h3c.55 0 1-.45 1-1s-.45-1-1-1z"
	}), 'LinkRounded');
	
	exports.default = _default;

/***/ },
/* 3765 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2zm-3-4h8v2H8zm9-4h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2zm-3-4h8v2H8z"
	}), 'LinkSharp');
	
	exports.default = _default;

/***/ },
/* 3766 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2zm-3-4h8v2H8z",
	  opacity: ".87"
	}), 'LinkTwoTone');
	
	exports.default = _default;

/***/ },
/* 3767 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "14",
	  r: "3.2"
	}), _react.default.createElement("path", {
	  d: "M16 3.33c2.58 0 4.67 2.09 4.67 4.67H22c0-3.31-2.69-6-6-6v1.33M16 6c1.11 0 2 .89 2 2h1.33c0-1.84-1.49-3.33-3.33-3.33V6"
	}), _react.default.createElement("path", {
	  d: "M17 9c0-1.11-.89-2-2-2V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-5zm-5 10c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	})), 'LinkedCamera');
	
	exports.default = _default;

/***/ },
/* 3768 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 9v11H4V8h4.05l1.83-2H15V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-2zm.67-1.01H22C21.99 4.68 19.31 2 16 2v1.33c2.58 0 4.66 2.08 4.67 4.66zm-2.67 0h1.33c-.01-1.84-1.49-3.32-3.33-3.32V6c1.11 0 1.99.89 2 1.99zM7 14c0 2.76 2.24 5 5 5s5-2.24 5-5-2.24-5-5-5-5 2.24-5 5zm8 0c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3 3 1.34 3 3z"
	}), 'LinkedCameraOutlined');
	
	exports.default = _default;

/***/ },
/* 3769 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "14",
	  r: "3"
	}), _react.default.createElement("path", {
	  d: "M16.6 3.37c2.1.27 3.77 1.93 4.03 4.03.04.34.32.6.66.6.39 0 .71-.34.66-.73-.33-2.72-2.5-4.89-5.22-5.22-.39-.05-.73.27-.73.66 0 .34.26.62.6.66zm2.63 3.82a3.338 3.338 0 00-2.42-2.42c-.41-.1-.81.22-.81.65 0 .29.19.57.48.64.72.18 1.29.74 1.46 1.46.07.29.34.48.64.48.43 0 .75-.4.65-.81zM17 9c0-1.1-.9-2-2-2V5c0-.55-.45-1-1-1H9.88c-.56 0-1.1.24-1.48.65L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-9c0-1.1-.9-2-2-2h-3zm-5 10c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	})), 'LinkedCameraRounded');
	
	exports.default = _default;

/***/ },
/* 3770 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "14",
	  r: "3"
	}), _react.default.createElement("path", {
	  d: "M18 8h1.33c0-1.84-1.49-3.33-3.33-3.33V6c1.11 0 2 .89 2 2zm2.67 0H22c0-3.31-2.69-6-6-6v1.33c2.58 0 4.67 2.09 4.67 4.67zM15 7V4H9L7.17 6H2v16h20V9h-5c0-1.1-.9-2-2-2zm-3 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	})), 'LinkedCameraSharp');
	
	exports.default = _default;

/***/ },
/* 3771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 20H4V8h4.05l1.83-2H15V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-2v11zM16 2v1.33c2.58 0 4.66 2.09 4.67 4.66H22C21.99 4.68 19.31 2 16 2zm0 2.67V6c1.11 0 1.99.89 2 1.99h1.33c-.01-1.84-1.49-3.32-3.33-3.32z"
	}), _react.default.createElement("path", {
	  d: "M14.98 10.01c-.13-.09-.26-.18-.39-.26.14.08.27.17.39.26zM17 9c0-.37-.11-.71-.28-1.01-.18-.3-.43-.55-.73-.72C15.7 7.1 15.36 7 15 7V6H9.88L8.05 8H4v12h16V9h-3zm-5 10c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 9c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
	})), 'LinkedCameraTwoTone');
	
	exports.default = _default;

/***/ },
/* 3772 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"
	}), 'LinkedIn');
	
	exports.default = _default;

/***/ },
/* 3773 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
	}), 'List');
	
	exports.default = _default;

/***/ },
/* 3774 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5v14H5V5h14m1.1-2H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9zM11 7h6v2h-6V7zm0 4h6v2h-6v-2zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7z"
	}), 'ListAlt');
	
	exports.default = _default;

/***/ },
/* 3775 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 7h6v2h-6zm0 4h6v2h-6zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7zM20.1 3H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9zM19 19H5V5h14v14z"
	}), 'ListAltOutlined');
	
	exports.default = _default;

/***/ },
/* 3776 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 9h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1zm0 4h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1zm0 4h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7zM20 3H4c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm-1 16H5V5h14v14z"
	}), 'ListAltRounded');
	
	exports.default = _default;

/***/ },
/* 3777 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 7h6v2h-6zm0 4h6v2h-6zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7zM3 3v18h18V3H3zm16 16H5V5h14v14z"
	}), 'ListAltSharp');
	
	exports.default = _default;

/***/ },
/* 3778 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14V5H5v14zm6-12h6v2h-6V7zm0 4h6v2h-6v-2zm0 4h6v2h-6v-2zM7 7h2v2H7V7zm0 4h2v2H7v-2zm0 4h2v2H7v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11 7h6v2h-6zm0 4h6v2h-6zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7zM20.1 3H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9zM19 19H5V5h14v14z"
	})), 'ListAltTwoTone');
	
	exports.default = _default;

/***/ },
/* 3779 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7zm-4 6h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
	}), 'ListOutlined');
	
	exports.default = _default;

/***/ },
/* 3780 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm4 4h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm0 4h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zM7 8c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1zm-3 5c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm4 4h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zm0 4h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zM7 8c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1z"
	}), 'ListRounded');
	
	exports.default = _default;

/***/ },
/* 3781 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7zm-4 6h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
	}), 'ListSharp');
	
	exports.default = _default;

/***/ },
/* 3782 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7zm-4 6h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
	}), 'ListTwoTone');
	
	exports.default = _default;

/***/ },
/* 3783 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
	}), 'LiveHelp');
	
	exports.default = _default;

/***/ },
/* 3784 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 16h-4.83l-.59.59L12 20.17l-1.59-1.59-.58-.58H5V4h14v14zm-8-3h2v2h-2zm1-8c1.1 0 2 .9 2 2 0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4S8 6.79 8 9h2c0-1.1.9-2 2-2z"
	}), 'LiveHelpOutlined');
	
	exports.default = _default;

/***/ },
/* 3785 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l2.29 2.29c.39.39 1.02.39 1.41 0L15 20h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92c-.58.59-.99 1.1-1.12 2.06-.06.43-.41.76-.85.76h-.31c-.52 0-.92-.46-.85-.98.11-.91.53-1.72 1.14-2.34l1.24-1.26c.36-.36.58-.86.58-1.41 0-1.1-.9-2-2-2-.87 0-1.62.57-1.89 1.35-.13.37-.44.64-.83.64h-.3c-.58 0-.98-.56-.82-1.12C8.65 5.21 10.18 4 12 4c2.21 0 4 1.79 4 4 0 .88-.36 1.68-.93 2.25z"
	}), 'LiveHelpRounded');
	
	exports.default = _default;

/***/ },
/* 3786 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 2H3v18h6l3 3 3-3h6V2zm-8 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
	}), 'LiveHelpSharp');
	
	exports.default = _default;

/***/ },
/* 3787 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 18h4.83l.59.59L12 20.17l1.59-1.59.58-.58H19V4H5v14zm8-1h-2v-2h2v2zM12 5c2.21 0 4 1.79 4 4 0 2.5-3 2.75-3 5h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 4c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4zm-2 14h-4.83l-.59.59L12 20.17l-1.59-1.59-.58-.58H5V4h14v14zm-8-3h2v2h-2zm1-8c1.1 0 2 .9 2 2 0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4S8 6.79 8 9h2c0-1.1.9-2 2-2z"
	})), 'LiveHelpTwoTone');
	
	exports.default = _default;

/***/ },
/* 3788 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 6h-7.59l3.29-3.29L16 2l-4 4-4-4-.71.71L10.59 6H3c-1.1 0-2 .89-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.11-.9-2-2-2zm0 14H3V8h18v12zM9 10v8l7-4z"
	}), 'LiveTv');
	
	exports.default = _default;

/***/ },
/* 3789 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 10v8l7-4zm12-4h-7.58l3.29-3.29L16 2l-4 4h-.03l-4-4-.69.71L10.56 6H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 14H3V8h18v12z"
	}), 'LiveTvOutlined');
	
	exports.default = _default;

/***/ },
/* 3790 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.5 17.15l3.98-2.28c.67-.38.67-1.35 0-1.74l-3.98-2.28c-.67-.38-1.5.11-1.5.87v4.55c0 .77.83 1.26 1.5.88zM21 6h-7.59l2.94-2.94c.2-.2.2-.51 0-.71s-.51-.2-.71 0L12 5.99 8.36 2.35c-.2-.2-.51-.2-.71 0s-.2.51 0 .71L10.59 6H3c-1.1 0-2 .89-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.11-.9-2-2-2zm-1 14H4c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1z"
	}), 'LiveTvRounded');
	
	exports.default = _default;

/***/ },
/* 3791 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 6h-9.59l3.29-3.29L16 2l-4 4-4-4-.71.71L10.59 6H1v16h22V6zm-2 14H3V8h18v12zM9 10v8l7-4-7-4z"
	}), 'LiveTvSharp');
	
	exports.default = _default;

/***/ },
/* 3792 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 20h18V8H3v12zm6-10l7 4-7 4v-8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9 10v8l7-4zm12-4h-7.58l3.29-3.29L16 2l-4 4h-.03l-4-4-.69.71L10.56 6H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 14H3V8h18v12z"
	})), 'LiveTvTwoTone');
	
	exports.default = _default;

/***/ },
/* 3793 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z"
	}), 'LocalActivity');
	
	exports.default = _default;

/***/ },
/* 3794 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 10V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-2-1.46c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46V18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16v2.54zM9.07 16L12 14.12 14.93 16l-.89-3.36 2.69-2.2-3.47-.21L12 7l-1.27 3.22-3.47.21 2.69 2.2z"
	}), 'LocalActivityOutlined');
	
	exports.default = _default;

/***/ },
/* 3795 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 12c0-.76.43-1.42 1.06-1.76.6-.33.94-1.01.94-1.7V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.89-1.99 1.99v2.55c0 .69.33 1.37.94 1.69C3.58 10.58 4 11.24 4 12s-.43 1.43-1.06 1.76c-.6.33-.94 1.01-.94 1.7V18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-2.54c0-.69-.34-1.37-.94-1.7-.63-.34-1.06-1-1.06-1.76zm-5.5 4.1L12 14.5l-2.5 1.61c-.38.24-.87-.11-.75-.55l.75-2.88-2.3-1.88c-.35-.29-.17-.86.29-.89l2.96-.17 1.08-2.75c.17-.42.77-.42.93 0l1.08 2.76 2.96.17c.45.03.64.6.29.89l-2.3 1.88.76 2.86c.12.45-.37.8-.75.55z"
	}), 'LocalActivityRounded');
	
	exports.default = _default;

/***/ },
/* 3796 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 12c0-1.1.9-2 2-2V4H2.01v6c1.1 0 1.99.9 1.99 2s-.89 2-2 2v6h20v-6c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z"
	}), 'LocalActivitySharp');
	
	exports.default = _default;

/***/ },
/* 3797 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4.01 8.54C5.2 9.23 6 10.52 6 12s-.81 2.77-2 3.46V18h16v-2.54c-1.19-.69-2-1.99-2-3.46s.81-2.77 2-3.46V6H4l.01 2.54zm6.72 1.68L12 7l1.26 3.23 3.47.2-2.69 2.2.89 3.37L12 14.12 9.07 16l.88-3.37-2.69-2.2 3.47-.21z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2V6c0-1.1-.9-2-2-2zm0 4.54c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46V18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16v2.54zM9.07 16L12 14.12 14.93 16l-.89-3.36 2.69-2.2-3.47-.21L12 7l-1.27 3.22-3.47.21 2.69 2.2z"
	})), 'LocalActivityTwoTone');
	
	exports.default = _default;

/***/ },
/* 3798 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 16v-2l-8.5-5V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V9L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-5.5L22 16z"
	}), 'LocalAirport');
	
	exports.default = _default;

/***/ },
/* 3799 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 16v-2l-8.5-5V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V9L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-5.5L22 16z"
	}), 'LocalAirportOutlined');
	
	exports.default = _default;

/***/ },
/* 3800 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.48 13.7L13.5 9V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V9l-7.98 4.7c-.32.18-.52.53-.52.9 0 .7.67 1.2 1.34 1.01l7.16-2.1V19l-2.26 1.35c-.15.09-.24.26-.24.43v.58c0 .33.31.57.62.49l2.92-.73L12 21l.38.09.42.11 1.9.48.67.17c.32.08.62-.16.62-.49v-.58c0-.18-.09-.34-.24-.43L13.5 19v-5.5l7.16 2.1c.67.2 1.34-.3 1.34-1 0-.37-.2-.72-.52-.9z"
	}), 'LocalAirportRounded');
	
	exports.default = _default;

/***/ },
/* 3801 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 16v-2l-8.5-5V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V9L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-5.5L22 16z"
	}), 'LocalAirportSharp');
	
	exports.default = _default;

/***/ },
/* 3802 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 16v-2l-8.5-5V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V9L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-5.5L22 16z"
	}), 'LocalAirportTwoTone');
	
	exports.default = _default;

/***/ },
/* 3803 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z"
	}), 'LocalAtm');
	
	exports.default = _default;

/***/ },
/* 3804 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z"
	}), 'LocalAtmOutlined');
	
	exports.default = _default;

/***/ },
/* 3805 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 13c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v10zm-6-7c.55 0 1-.45 1-1s-.45-1-1-1h-1v-.01c0-.55-.45-1-1-1s-1 .45-1 1V8h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1h-3c-.55 0-1 .45-1 1s.45 1 1 1h1c0 .55.45 1 1 1s1-.45 1-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h3z"
	}), 'LocalAtmRounded');
	
	exports.default = _default;

/***/ },
/* 3806 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 17h2v-1h2v-5h-4v-1h4V8h-2V7h-2v1H9v5h4v1H9v2h2v1zM22 4H2.01L2 20h20V4zm-2 14H4V6h16v12z"
	}), 'LocalAtmSharp');
	
	exports.default = _default;

/***/ },
/* 3807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 18h16V6H4v12zm5-4h4v-1h-3c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h1V7h2v1h2v2h-4v1h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1h-1v1h-2v-1H9v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12zm-9-1h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1z"
	})), 'LocalAtmTwoTone');
	
	exports.default = _default;

/***/ },
/* 3808 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 5V3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9zM7.43 7L5.66 5h12.69l-1.78 2H7.43z"
	}), 'LocalBar');
	
	exports.default = _default;

/***/ },
/* 3809 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.77 9L12 12.11 9.23 9h5.54M21 3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9V3zM7.43 7L5.66 5h12.69l-1.78 2H7.43z"
	}), 'LocalBarOutlined');
	
	exports.default = _default;

/***/ },
/* 3810 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 4.45c0-.8-.65-1.45-1.45-1.45H4.45C3.65 3 3 3.65 3 4.45c0 .35.13.7.37.96L11 14v5H7c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1h-4v-5l7.63-8.59c.24-.26.37-.61.37-.96zM7.43 7L5.66 5h12.69l-1.78 2H7.43z"
	}), 'LocalBarRounded');
	
	exports.default = _default;

/***/ },
/* 3811 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 5V3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9zM7.43 7L5.66 5h12.69l-1.78 2H7.43z"
	}), 'LocalBarSharp');
	
	exports.default = _default;

/***/ },
/* 3812 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9.23 9L12 12.11 14.77 9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 5V3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9zM5.66 5h12.69l-1.78 2H7.43L5.66 5zM12 12.11L9.23 9h5.54L12 12.11z"
	})), 'LocalBarTwoTone');
	
	exports.default = _default;

/***/ },
/* 3813 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z"
	}), 'LocalCafe');
	
	exports.default = _default;

/***/ },
/* 3814 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 5v8c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V5h10m4-2H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm-2 5V5h2v3h-2zm2 11H2v2h18v-2z"
	}), 'LocalCafeOutlined');
	
	exports.default = _default;

/***/ },
/* 3815 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 3H6c-1.1 0-2 .9-2 2v8c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 5h-2V5h2v3zM3 21h16c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1z"
	}), 'LocalCafeRounded');
	
	exports.default = _default;

/***/ },
/* 3816 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 3H4v14h14v-7h2c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 5h-2V5h2v3zM2 21h18v-2H2v2z"
	}), 'LocalCafeSharp');
	
	exports.default = _default;

/***/ },
/* 3817 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 15h6c1.1 0 2-.9 2-2V5H6v8c0 1.1.9 2 2 2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M2 19h18v2H2zm2-6c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2H4v10zm14-8h2v3h-2V5zM6 5h10v8c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V5z"
	})), 'LocalCafeTwoTone');
	
	exports.default = _default;

/***/ },
/* 3818 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 5c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zm-5 0c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zM7 5c.83 0 1.5-.67 1.5-1.5C8.5 2.5 7 .8 7 .8S5.5 2.5 5.5 3.5C5.5 4.33 6.17 5 7 5zm11.92 3.01C18.72 7.42 18.16 7 17.5 7h-11c-.66 0-1.21.42-1.42 1.01L3 14v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 18c-.83 0-1.5-.67-1.5-1.5S5.67 15 6.5 15s1.5.67 1.5 1.5S7.33 18 6.5 18zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 13l1.5-4.5h11L19 13H5z"
	}), 'LocalCarWash');
	
	exports.default = _default;

/***/ },
/* 3819 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17 5c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zm-5 0c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zM7 5c.83 0 1.5-.67 1.5-1.5C8.5 2.5 7 .8 7 .8S5.5 2.5 5.5 3.5C5.5 4.33 6.17 5 7 5zm11.92 3.01C18.72 7.42 18.16 7 17.5 7h-11c-.66 0-1.21.42-1.42 1.01L3 14v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 9h10.29l1.04 3H5.81l1.04-3zM19 19H5v-4.66l.12-.34h13.77l.11.34V19z"
	}), _react.default.createElement("circle", {
	  cx: "7.5",
	  cy: "16.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "16.5",
	  r: "1.5"
	})), 'LocalCarWashOutlined');
	
	exports.default = _default;

/***/ },
/* 3820 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 5c.83 0 1.5-.67 1.5-1.5 0-.66-.66-1.64-1.11-2.22-.2-.26-.59-.26-.79 0-.44.58-1.1 1.56-1.1 2.22 0 .83.67 1.5 1.5 1.5zm-5 0c.83 0 1.5-.67 1.5-1.5 0-.66-.66-1.64-1.11-2.22-.2-.26-.59-.26-.79 0-.44.58-1.1 1.56-1.1 2.22 0 .83.67 1.5 1.5 1.5zM7 5c.83 0 1.5-.67 1.5-1.5 0-.66-.66-1.64-1.11-2.22-.2-.26-.59-.26-.79 0-.44.58-1.1 1.56-1.1 2.22C5.5 4.33 6.17 5 7 5zm11.92 3.01C18.72 7.42 18.16 7 17.5 7h-11c-.66 0-1.21.42-1.42 1.01l-1.97 5.67c-.07.21-.11.43-.11.66v7.16c0 .83.67 1.5 1.5 1.5S6 22.33 6 21.5V21h12v.5c0 .82.67 1.5 1.5 1.5.82 0 1.5-.67 1.5-1.5v-7.16c0-.22-.04-.45-.11-.66l-1.97-5.67zM6.5 18c-.83 0-1.5-.67-1.5-1.5S5.67 15 6.5 15s1.5.67 1.5 1.5S7.33 18 6.5 18zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 13l1.27-3.82c.14-.4.52-.68.95-.68h9.56c.43 0 .81.28.95.68L19 13H5z"
	}), 'LocalCarWashRounded');
	
	exports.default = _default;

/***/ },
/* 3821 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.58 7H5.43L3 14v9h3v-2h12v2h3v-9l-2.42-7zM6.5 18c-.83 0-1.5-.67-1.5-1.5S5.67 15 6.5 15s1.5.67 1.5 1.5S7.33 18 6.5 18zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 13l1.5-4.5h11L19 13H5zm12-8c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zm-5 0c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zM7 5c.83 0 1.5-.67 1.5-1.5C8.5 2.5 7 .8 7 .8S5.5 2.5 5.5 3.5C5.5 4.33 6.17 5 7 5z"
	}), 'LocalCarWashSharp');
	
	exports.default = _default;

/***/ },
/* 3822 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5.12 14l-.12.34V19h14v-4.66l-.12-.34H5.12zm2.38 4c-.83 0-1.5-.67-1.5-1.5S6.67 15 7.5 15s1.5.67 1.5 1.5S8.33 18 7.5 18zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M15.5 3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5c0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7zm-2 0c0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5zm-5 0C8.5 2.5 7 .8 7 .8S5.5 2.5 5.5 3.5C5.5 4.33 6.17 5 7 5s1.5-.67 1.5-1.5zM21 14l-2.08-5.99C18.72 7.42 18.16 7 17.5 7h-11c-.66 0-1.21.42-1.42 1.01L3 14v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8zM6.85 9h10.29l1.04 3H5.81l1.04-3zM19 19H5v-4.66l.12-.34h13.77l.11.34V19z"
	}), _react.default.createElement("circle", {
	  cx: "7.5",
	  cy: "16.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "16.5",
	  r: "1.5"
	})), 'LocalCarWashTwoTone');
	
	exports.default = _default;

/***/ },
/* 3823 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 7V4H5v3H2v13h8v-4h4v4h8V7h-3zm-8 3H9v1h2v1H8V9h2V8H8V7h3v3zm5 2h-1v-2h-2V7h1v2h1V7h1v5z"
	}), 'LocalConvenienceStore');
	
	exports.default = _default;

/***/ },
/* 3824 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 7V4H5v3H2v13h8v-4h4v4h8V7h-3zm1 11h-4v-4H8v4H4V9h3V6h10v3h3v9zM8 8h2v1H8v3h3v-1H9v-1h2V7H8zm7 1h-1V7h-1v3h2v2h1V7h-1z"
	}), 'LocalConvenienceStoreOutlined');
	
	exports.default = _default;

/***/ },
/* 3825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 7h-2V5c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v2H3c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-3h4v3c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zM11 9c0 .55-.45 1-1 1H9v1h1.5c.28 0 .5.22.5.5s-.22.5-.5.5H9c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1h1V8H8.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5H10c.55 0 1 .45 1 1v1zm5 2.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5V10h-1c-.55 0-1-.45-1-1V7.5c0-.28.22-.5.5-.5s.5.22.5.5V9h1V7.5c0-.28.22-.5.5-.5s.5.22.5.5v4z"
	}), 'LocalConvenienceStoreRounded');
	
	exports.default = _default;

/***/ },
/* 3826 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 7V4H5v3H2v13h8v-4h4v4h8V7h-3zm-8 3H9v1h2v1H8V9h2V8H8V7h3v3zm5 2h-1v-2h-2V7h1v2h1V7h1v5z"
	}), 'LocalConvenienceStoreSharp');
	
	exports.default = _default;

/***/ },
/* 3827 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14 14h2v4h4V9h-3V6H7v3H4v9h4v-4h6zm-1-7h1v2h1V7h1v5h-1v-2h-2V7zM8 9h2V8H8V7h3v3H9v1h2v1H8V9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M10 16h4v4h8V7h-3V4H5v3H2v13h8v-4zm-2 0v2H4V9h3V6h10v3h3v9h-4v-4H8v2zm3-5H9v-1h2V7H8v1h2v1H8v3h3zm4 1h1V7h-1v2h-1V7h-1v3h2z"
	})), 'LocalConvenienceStoreTwoTone');
	
	exports.default = _default;

/***/ },
/* 3828 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
	}), 'LocalDining');
	
	exports.default = _default;

/***/ },
/* 3829 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
	}), 'LocalDiningOutlined');
	
	exports.default = _default;

/***/ },
/* 3830 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.1 13.34l2.83-2.83-6.19-6.18c-.48-.48-1.31-.35-1.61.27-.71 1.49-.45 3.32.78 4.56l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27l-9.05 9.05c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 14.41l6.18 6.18c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 13l1.47-1.47z"
	}), 'LocalDiningRounded');
	
	exports.default = _default;

/***/ },
/* 3831 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
	}), 'LocalDiningSharp');
	
	exports.default = _default;

/***/ },
/* 3832 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.11 21.28L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41zM3.91 9.16l4.19 4.18 2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66z"
	}), 'LocalDiningTwoTone');
	
	exports.default = _default;

/***/ },
/* 3833 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 2l2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm9 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm6.33-11H5.67l-.44-4h13.53l-.43 4z"
	}), 'LocalDrink');
	
	exports.default = _default;

/***/ },
/* 3834 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 2l2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm14 18l-10 .01L5.89 10H18.1L17 20zm1.33-12H5.67l-.44-4h13.53l-.43 4zM12 19c1.66 0 3-1.34 3-3 0-2-3-5.4-3-5.4S9 14 9 16c0 1.66 1.34 3 3 3zm0-5.09c.59.91 1 1.73 1 2.09 0 .55-.45 1-1 1s-1-.45-1-1c0-.37.41-1.19 1-2.09z"
	}), 'LocalDrinkOutlined');
	
	exports.default = _default;

/***/ },
/* 3835 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.23 2C4.04 2 3.11 3.04 3.24 4.22l1.77 16.01C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77l1.77-16.01c.13-1.18-.8-2.22-1.99-2.22H5.23zM12 19c-1.66 0-3-1.34-3-3 0-1.55 1.81-3.95 2.62-4.94.2-.25.57-.25.77 0 .81 1 2.62 3.39 2.62 4.94-.01 1.66-1.35 3-3.01 3zm6.33-11H5.67l-.32-2.89c-.06-.59.4-1.11 1-1.11h11.3c.59 0 1.06.52.99 1.11L18.33 8z"
	}), 'LocalDrinkRounded');
	
	exports.default = _default;

/***/ },
/* 3836 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 2l2.21 20H18.8L21 2H3zm9 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm6.33-11H5.67l-.44-4h13.53l-.43 4z"
	}), 'LocalDrinkSharp');
	
	exports.default = _default;

/***/ },
/* 3837 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 20.01L17 20l1.1-10H5.89L7 20.01zm5-9.41s3 3.4 3 5.4c0 1.66-1.34 3-3 3s-3-1.34-3-3c0-2 3-5.4 3-5.4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5.01 20.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3l2.01 18.23zM17 20l-10 .01L5.89 10H18.1L17 20zm1.76-16l-.43 4H5.67l-.44-4h13.53zM12 19c1.66 0 3-1.34 3-3 0-2-3-5.4-3-5.4S9 14 9 16c0 1.66 1.34 3 3 3zm0-5.09c.59.91 1 1.73 1 2.09 0 .55-.45 1-1 1s-1-.45-1-1c0-.37.41-1.19 1-2.09z"
	})), 'LocalDrinkTwoTone');
	
	exports.default = _default;

/***/ },
/* 3838 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 22c4.97 0 9-4.03 9-9-4.97 0-9 4.03-9 9zM5.6 10.25c0 1.38 1.12 2.5 2.5 2.5.53 0 1.01-.16 1.42-.44l-.02.19c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5l-.02-.19c.4.28.89.44 1.42.44 1.38 0 2.5-1.12 2.5-2.5 0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25 0-1.38-1.12-2.5-2.5-2.5-.53 0-1.01.16-1.42.44l.02-.19C14.5 2.12 13.38 1 12 1S9.5 2.12 9.5 3.5l.02.19c-.4-.28-.89-.44-1.42-.44-1.38 0-2.5 1.12-2.5 2.5 0 1 .59 1.85 1.43 2.25-.84.4-1.43 1.25-1.43 2.25zM12 5.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8s1.12-2.5 2.5-2.5zM3 13c0 4.97 4.03 9 9 9 0-4.97-4.03-9-9-9z"
	}), 'LocalFlorist');
	
	exports.default = _default;

/***/ },
/* 3839 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.66 13.07c.15 0 .29-.01.43-.03C9.56 14.19 10.69 15 12 15s2.44-.81 2.91-1.96c.14.02.29.03.43.03 1.73 0 3.14-1.41 3.14-3.14 0-.71-.25-1.39-.67-1.93.43-.54.67-1.22.67-1.93 0-1.73-1.41-3.14-3.14-3.14-.15 0-.29.01-.43.03C14.44 1.81 13.31 1 12 1s-2.44.81-2.91 1.96c-.14-.02-.29-.03-.43-.03-1.73 0-3.14 1.41-3.14 3.14 0 .71.25 1.39.67 1.93-.43.54-.68 1.22-.68 1.93 0 1.73 1.41 3.14 3.15 3.14zM12 13c-.62 0-1.12-.49-1.14-1.1l.12-1.09c.32.12.66.19 1.02.19s.71-.07 1.03-.19l.11 1.09c-.02.61-.52 1.1-1.14 1.1zm3.34-1.93c-.24 0-.46-.07-.64-.2l-.81-.57c.55-.45.94-1.09 1.06-1.83l.88.42c.4.19.66.59.66 1.03 0 .64-.52 1.15-1.15 1.15zm-.65-5.94c.2-.13.42-.2.65-.2.63 0 1.14.51 1.14 1.14 0 .44-.25.83-.66 1.03l-.88.42c-.12-.74-.51-1.38-1.07-1.83l.82-.56zM12 3c.62 0 1.12.49 1.14 1.1l-.11 1.09C12.71 5.07 12.36 5 12 5s-.7.07-1.02.19l-.12-1.09c.02-.61.52-1.1 1.14-1.1zM8.66 4.93c.24 0 .46.07.64.2l.81.56c-.55.45-.94 1.09-1.06 1.83l-.88-.42c-.4-.2-.66-.59-.66-1.03 0-.63.52-1.14 1.15-1.14zM8.17 8.9l.88-.42c.12.74.51 1.38 1.07 1.83l-.81.55c-.2.13-.42.2-.65.2-.63 0-1.14-.51-1.14-1.14-.01-.43.25-.82.65-1.02zM12 22c4.97 0 9-4.03 9-9-4.97 0-9 4.03-9 9zm2.44-2.44c.71-1.9 2.22-3.42 4.12-4.12-.71 1.9-2.22 3.41-4.12 4.12zM3 13c0 4.97 4.03 9 9 9 0-4.97-4.03-9-9-9zm2.44 2.44c1.9.71 3.42 2.22 4.12 4.12-1.9-.71-3.41-2.22-4.12-4.12z"
	}), 'LocalFloristOutlined');
	
	exports.default = _default;

/***/ },
/* 3840 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 22c4.56 0 8.33-3.4 8.92-7.8.09-.64-.48-1.21-1.12-1.12-4.4.59-7.8 4.36-7.8 8.92zM5.6 10.25c0 1.38 1.12 2.5 2.5 2.5.53 0 1.01-.16 1.42-.44l-.02.19c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5l-.02-.19c.4.28.89.44 1.42.44 1.38 0 2.5-1.12 2.5-2.5 0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25 0-1.38-1.12-2.5-2.5-2.5-.53 0-1.01.16-1.42.44l.02-.19C14.5 2.12 13.38 1 12 1S9.5 2.12 9.5 3.5l.02.19c-.4-.28-.89-.44-1.42-.44-1.38 0-2.5 1.12-2.5 2.5 0 1 .59 1.85 1.43 2.25-.84.4-1.43 1.25-1.43 2.25zM12 5.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8s1.12-2.5 2.5-2.5zm-8.92 8.7C3.67 18.6 7.44 22 12 22c0-4.56-3.4-8.33-7.8-8.92-.64-.09-1.21.48-1.12 1.12z"
	}), 'LocalFloristRounded');
	
	exports.default = _default;

/***/ },
/* 3841 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 22c4.97 0 9-4.03 9-9-4.97 0-9 4.03-9 9zM5.6 10.25c0 1.38 1.12 2.5 2.5 2.5.53 0 1.01-.16 1.42-.44l-.02.19c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5l-.02-.19c.4.28.89.44 1.42.44 1.38 0 2.5-1.12 2.5-2.5 0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25 0-1.38-1.12-2.5-2.5-2.5-.53 0-1.01.16-1.42.44l.02-.19C14.5 2.12 13.38 1 12 1S9.5 2.12 9.5 3.5l.02.19c-.4-.28-.89-.44-1.42-.44-1.38 0-2.5 1.12-2.5 2.5 0 1 .59 1.85 1.43 2.25-.84.4-1.43 1.25-1.43 2.25zM12 5.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8s1.12-2.5 2.5-2.5zM3 13c0 4.97 4.03 9 9 9 0-4.97-4.03-9-9-9z"
	}), 'LocalFloristSharp');
	
	exports.default = _default;

/***/ },
/* 3842 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 13c.62 0 1.12-.49 1.14-1.1l-.11-1.09c-.32.12-.67.19-1.03.19s-.7-.07-1.02-.19l-.12 1.09c.02.61.52 1.1 1.14 1.1zM8.17 7.1l.88.42c.12-.73.51-1.37 1.06-1.83l-.81-.56c-.18-.13-.41-.2-.64-.2-.63 0-1.14.51-1.14 1.14-.01.44.25.83.65 1.03zm7.66 1.8l-.88-.42c-.12.73-.51 1.37-1.06 1.83l.81.57c.18.13.41.2.64.2.63 0 1.14-.51 1.14-1.14.01-.45-.25-.84-.65-1.04zm-.88-1.38l.88-.42c.4-.19.66-.59.66-1.03 0-.63-.51-1.14-1.14-1.14-.24 0-.46.07-.65.2l-.81.55c.55.46.94 1.1 1.06 1.84zM12 5c.36 0 .71.07 1.03.19l.11-1.09C13.12 3.49 12.62 3 12 3s-1.12.49-1.14 1.1l.12 1.09C11.3 5.07 11.64 5 12 5zm-3.34 6.07c.24 0 .46-.07.65-.2l.81-.55c-.56-.46-.95-1.1-1.07-1.84l-.88.42c-.4.2-.66.59-.66 1.03 0 .63.52 1.14 1.15 1.14zm9.9 4.37c-1.9.71-3.42 2.22-4.12 4.12 1.9-.71 3.41-2.22 4.12-4.12zm-13.12 0c.71 1.9 2.22 3.42 4.12 4.12-.71-1.9-2.22-3.41-4.12-4.12z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M8.66 13.07c.15 0 .29-.01.43-.03C9.56 14.19 10.69 15 12 15s2.44-.81 2.91-1.96c.14.02.29.03.43.03 1.73 0 3.14-1.41 3.14-3.14 0-.71-.25-1.39-.67-1.93.43-.54.67-1.22.67-1.93 0-1.73-1.41-3.14-3.14-3.14-.15 0-.29.01-.43.03C14.44 1.81 13.31 1 12 1s-2.44.81-2.91 1.96c-.14-.02-.29-.03-.43-.03-1.73 0-3.14 1.41-3.14 3.14 0 .71.25 1.39.67 1.93-.43.54-.68 1.22-.68 1.93 0 1.73 1.41 3.14 3.15 3.14zm6.68-2c-.24 0-.46-.07-.64-.2l-.81-.57c.55-.45.94-1.09 1.06-1.83l.88.42c.4.19.66.59.66 1.03 0 .64-.52 1.15-1.15 1.15zm-.65-5.94c.2-.13.42-.2.65-.2.63 0 1.14.51 1.14 1.14 0 .44-.25.83-.66 1.03l-.88.42c-.12-.74-.51-1.38-1.07-1.83l.82-.56zM12 3c.62 0 1.12.49 1.14 1.1l-.11 1.09C12.71 5.07 12.36 5 12 5s-.7.07-1.02.19l-.12-1.09c.02-.61.52-1.1 1.14-1.1zm1 5c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm-2.02 2.81c.32.12.66.19 1.02.19s.71-.07 1.03-.19l.11 1.09c-.02.61-.52 1.1-1.14 1.1s-1.12-.49-1.14-1.1l.12-1.09zM8.66 4.93c.24 0 .46.07.64.2l.81.56c-.55.45-.94 1.09-1.06 1.83l-.88-.42c-.4-.2-.66-.59-.66-1.03 0-.63.52-1.14 1.15-1.14zM8.17 8.9l.88-.42c.12.74.51 1.38 1.07 1.83l-.81.55c-.2.13-.42.2-.65.2-.63 0-1.14-.51-1.14-1.14-.01-.43.25-.82.65-1.02zM12 22c4.97 0 9-4.03 9-9-4.97 0-9 4.03-9 9zm6.56-6.56c-.71 1.9-2.22 3.42-4.12 4.12.71-1.9 2.22-3.41 4.12-4.12zM3 13c0 4.97 4.03 9 9 9 0-4.97-4.03-9-9-9zm2.44 2.44c1.9.71 3.42 2.22 4.12 4.12-1.9-.71-3.41-2.22-4.12-4.12z"
	})), 'LocalFloristTwoTone');
	
	exports.default = _default;

/***/ },
/* 3843 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'LocalGasStation');
	
	exports.default = _default;

/***/ },
/* 3844 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 13.5V19H6v-7h6v1.5zm0-3.5H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'LocalGasStationOutlined');
	
	exports.default = _default;

/***/ },
/* 3845 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.77 7.23l.01-.01-3.19-3.19c-.29-.29-.77-.29-1.06 0-.29.29-.29.77 0 1.06l1.58 1.58c-1.05.4-1.76 1.47-1.58 2.71.16 1.1 1.1 1.99 2.2 2.11.47.05.88-.03 1.27-.2v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v15c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-6.5h1.5v4.86c0 1.31.94 2.5 2.24 2.63 1.5.15 2.76-1.02 2.76-2.49V9c0-.69-.28-1.32-.73-1.77zM12 10H6V6c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v4zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'LocalGasStationRounded');
	
	exports.default = _default;

/***/ },
/* 3846 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-1.05.4-1.76 1.47-1.58 2.71.16 1.1 1.1 1.99 2.2 2.11.47.05.88-.03 1.27-.2v8.21h-2V12h-3V3H4v18h10v-7.5h1.5v7.49h5V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'LocalGasStationSharp');
	
	exports.default = _default;

/***/ },
/* 3847 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 19h6v-7H6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 3H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2zm0 10.5V19H6v-7h6v1.5zm0-3.5H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	})), 'LocalGasStationTwoTone');
	
	exports.default = _default;

/***/ },
/* 3848 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
	}), 'LocalGroceryStore');
	
	exports.default = _default;

/***/ },
/* 3849 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-1.45-5c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6z"
	}), 'LocalGroceryStoreOutlined');
	
	exports.default = _default;

/***/ },
/* 3850 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM2 4h1l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h11c.55 0 1-.45 1-1s-.45-1-1-1H7l1.1-2h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.67-1.43c-.16-.35-.52-.57-.9-.57H2c-.55 0-1 .45-1 1s.45 1 1 1zm15 14c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
	}), 'LocalGroceryStoreRounded');
	
	exports.default = _default;

/***/ },
/* 3851 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 4h2l3.6 7.59L3.62 17H19v-2H7l1.1-2h8.64l4.97-9H5.21l-.94-2H1v2zm16 14c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
	}), 'LocalGroceryStoreSharp');
	
	exports.default = _default;

/***/ },
/* 3852 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8.53 11h7.02l2.76-5H6.16z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-1.45-5c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6z"
	})), 'LocalGroceryStoreTwoTone');
	
	exports.default = _default;

/***/ },
/* 3853 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z"
	}), 'LocalHospital');
	
	exports.default = _default;

/***/ },
/* 3854 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-8.5-2h3v-3.5H17v-3h-3.5V7h-3v3.5H7v3h3.5z"
	}), 'LocalHospitalOutlined');
	
	exports.default = _default;

/***/ },
/* 3855 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 11h-3v3c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1v-3H7c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1h3V7c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v3h3c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1z"
	}), 'LocalHospitalRounded');
	
	exports.default = _default;

/***/ },
/* 3856 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3.01L3 21h18V3zm-3 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z"
	}), 'LocalHospitalSharp');
	
	exports.default = _default;

/***/ },
/* 3857 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14V5H5v14zm2-8.5h3.5V7h3v3.5H17v3h-3.5V17h-3v-3.5H7v-3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 5c0-1.1-.9-2-2-2H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5zm-2 14H5V5h14v14zm-8.5-2h3v-3.5H17v-3h-3.5V7h-3v3.5H7v3h3.5z"
	})), 'LocalHospitalTwoTone');
	
	exports.default = _default;

/***/ },
/* 3858 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z"
	}), 'LocalHotel');
	
	exports.default = _default;

/***/ },
/* 3859 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 14c1.66 0 3-1.34 3-3S8.66 8 7 8s-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm12-3h-8v8H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4zm2 8h-8V9h6c1.1 0 2 .9 2 2v4z"
	}), 'LocalHotelOutlined');
	
	exports.default = _default;

/***/ },
/* 3860 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-6c-1.1 0-2 .9-2 2v5H3V6c0-.55-.45-1-1-1s-1 .45-1 1v13c0 .55.45 1 1 1s1-.45 1-1v-2h18v2c0 .55.45 1 1 1s1-.45 1-1v-8c0-2.21-1.79-4-4-4z"
	}), 'LocalHotelRounded');
	
	exports.default = _default;

/***/ },
/* 3861 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm16-6H11v7H3V5H1v15h2v-3h18v3h2V7z"
	}), 'LocalHotelSharp');
	
	exports.default = _default;

/***/ },
/* 3862 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "7",
	  cy: "11",
	  r: "1",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 9h-6v6h8v-4c0-1.1-.9-2-2-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 11c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3zm4 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm11-4h-8v8H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4zm2 8h-8V9h6c1.1 0 2 .9 2 2v4z"
	})), 'LocalHotelTwoTone');
	
	exports.default = _default;

/***/ },
/* 3863 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.17 16.83c1.56 1.56 4.1 1.56 5.66 0 1.56-1.56 1.56-4.1 0-5.66l-5.66 5.66zM18 2.01L6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM10 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
	}), 'LocalLaundryService');
	
	exports.default = _default;

/***/ },
/* 3864 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18 2.01L6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM18 20H6L5.99 4H18v16z"
	}), _react.default.createElement("circle", {
	  cx: "8",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "11",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M12 19c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm2.36-7.36c1.3 1.3 1.3 3.42 0 4.72-1.3 1.3-3.42 1.3-4.72 0l4.72-4.72z"
	})), 'LocalLaundryServiceOutlined');
	
	exports.default = _default;

/***/ },
/* 3865 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.55 16.45c-.2.2-.21.55.02.73 1.57 1.2 3.83 1.08 5.26-.35s1.55-3.69.35-5.26c-.18-.23-.53-.23-.73-.02l-4.9 4.9zM18 2.01L6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM10 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
	}), 'LocalLaundryServiceRounded');
	
	exports.default = _default;

/***/ },
/* 3866 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.17 16.83c1.56 1.56 4.1 1.56 5.66 0s1.56-4.1 0-5.66l-5.66 5.66zM20 2.01L4 2v20h16V2.01zM10 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
	}), 'LocalLaundryServiceSharp');
	
	exports.default = _default;

/***/ },
/* 3867 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5.99 4L6 20h12V4H5.99c.01 0 0 0 0 0zM11 5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM8 5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 4c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 2.01L6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM18 20H6L5.99 4H18v16z"
	}), _react.default.createElement("circle", {
	  cx: "8",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "11",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M12 19c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm2.36-7.36c1.3 1.3 1.3 3.42 0 4.72-1.3 1.3-3.42 1.3-4.72 0l4.72-4.72z"
	})), 'LocalLaundryServiceTwoTone');
	
	exports.default = _default;

/***/ },
/* 3868 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 11.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zM12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z"
	}), 'LocalLibrary');
	
	exports.default = _default;

/***/ },
/* 3869 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 9c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zm7 5.58c-2.53.34-4.93 1.3-7 2.82-2.06-1.52-4.47-2.49-7-2.83v-6.95c2.1.38 4.05 1.35 5.64 2.83L12 14.28l1.36-1.27c1.59-1.48 3.54-2.45 5.64-2.83v6.95z"
	}), 'LocalLibraryOutlined');
	
	exports.default = _default;

/***/ },
/* 3870 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 11.55c-1.82-1.7-4.12-2.89-6.68-3.35C4.11 7.99 3 8.95 3 10.18v6.24c0 1.68.72 2.56 1.71 2.69 2.5.32 4.77 1.35 6.63 2.87.35.29.92.32 1.27.04 1.87-1.53 4.16-2.58 6.68-2.9.94-.13 1.71-1.06 1.71-2.02v-6.92c0-1.23-1.11-2.19-2.32-1.98-2.56.46-4.86 1.65-6.68 3.35zM12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z"
	}), 'LocalLibraryRounded');
	
	exports.default = _default;

/***/ },
/* 3871 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 11.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zM12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z"
	}), 'LocalLibrarySharp');
	
	exports.default = _default;

/***/ },
/* 3872 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 17.13v-6.95c-2.1.38-4.05 1.35-5.64 2.83L12 14.28l-1.36-1.27C9.05 11.53 7.1 10.56 5 10.18v6.95c2.53.34 4.94 1.3 7 2.83 2.07-1.52 4.47-2.49 7-2.83z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "5",
	  r: "2",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16 5c0-2.21-1.79-4-4-4S8 2.79 8 5s1.79 4 4 4 4-1.79 4-4zm-6 0c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM3 19c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55C9.64 9.35 6.48 8 3 8v11zm2-8.82c2.1.38 4.05 1.35 5.64 2.83L12 14.28l1.36-1.27c1.59-1.48 3.54-2.45 5.64-2.83v6.95c-2.53.34-4.93 1.3-7 2.82-2.06-1.52-4.47-2.49-7-2.83v-6.94z"
	})), 'LocalLibraryTwoTone');
	
	exports.default = _default;

/***/ },
/* 3873 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z"
	}), 'LocalMall');
	
	exports.default = _default;

/***/ },
/* 3874 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm7 17H5V8h14v12zm-7-8c-1.66 0-3-1.34-3-3H7c0 2.76 2.24 5 5 5s5-2.24 5-5h-2c0 1.66-1.34 3-3 3z"
	}), 'LocalMallOutlined');
	
	exports.default = _default;

/***/ },
/* 3875 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.33 0-4.29-1.59-4.84-3.75-.17-.63.32-1.25.97-1.25.47 0 .85.34.98.8.35 1.27 1.51 2.2 2.89 2.2s2.54-.93 2.89-2.2c.13-.46.51-.8.98-.8.65 0 1.13.62.97 1.25C16.29 11.41 14.33 13 12 13z"
	}), 'LocalMallRounded');
	
	exports.default = _default;

/***/ },
/* 3876 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 6h-4c0-2.76-2.24-5-5-5S7 3.24 7 6H3v16h18V6zm-9-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z"
	}), 'LocalMallSharp');
	
	exports.default = _default;

/***/ },
/* 3877 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 8v12h14V8H5zm7 6c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 6c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-2zm-5-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm7 17H5V8h14v12zm-7-8c-1.66 0-3-1.34-3-3H7c0 2.76 2.24 5 5 5s5-2.24 5-5h-2c0 1.66-1.34 3-3 3z"
	})), 'LocalMallTwoTone');
	
	exports.default = _default;

/***/ },
/* 3878 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
	}), 'LocalMovies');
	
	exports.default = _default;

/***/ },
/* 3879 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 5v14h-4V5h4m6-2h-2v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3zm-4 6V7h2v2h-2zM6 9V7h2v2H6zm10 4v-2h2v2h-2zM6 13v-2h2v2H6zm10 4v-2h2v2h-2zM6 17v-2h2v2H6z"
	}), 'LocalMoviesOutlined');
	
	exports.default = _default;

/***/ },
/* 3880 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4v1h-2V4c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v1H6V4c0-.55-.45-1-1-1s-1 .45-1 1v16c0 .55.45 1 1 1s1-.45 1-1v-1h2v1c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-1h2v1c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1s-1 .45-1 1zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
	}), 'LocalMoviesRounded');
	
	exports.default = _default;

/***/ },
/* 3881 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
	}), 'LocalMoviesSharp');
	
	exports.default = _default;

/***/ },
/* 3882 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M10 5h4v14h-4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 21V3h-2v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm6 10h-4V5h4v14zm2-12h2v2h-2V7zm0 4h2v2h-2v-2zm0 6v-2h2v2h-2z"
	})), 'LocalMoviesTwoTone');
	
	exports.default = _default;

/***/ },
/* 3883 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"
	}), 'LocalOffer');
	
	exports.default = _default;

/***/ },
/* 3884 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM13 20.01L4 11V4h7v-.01l9 9-7 7.02z"
	}), _react.default.createElement("circle", {
	  cx: "6.5",
	  cy: "6.5",
	  r: "1.5"
	})), 'LocalOfferOutlined');
	
	exports.default = _default;

/***/ },
/* 3885 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"
	}), 'LocalOfferRounded');
	
	exports.default = _default;

/***/ },
/* 3886 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22.83 12.99L11.83 2H2v9.83l10.99 10.99 9.84-9.83zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"
	}), 'LocalOfferSharp');
	
	exports.default = _default;

/***/ },
/* 3887 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11 4H4v7l9 9.01L20 13l-9-9zM6.5 8C5.67 8 5 7.33 5 6.5S5.67 5 6.5 5 8 5.67 8 6.5 7.33 8 6.5 8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12.41 2.58C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42l-9-9zM13 20.01L4 11V4h7v-.01l9 9-7 7.02z"
	}), _react.default.createElement("circle", {
	  cx: "6.5",
	  cy: "6.5",
	  r: "1.5"
	})), 'LocalOfferTwoTone');
	
	exports.default = _default;

/***/ },
/* 3888 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z"
	}), 'LocalParking');
	
	exports.default = _default;

/***/ },
/* 3889 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z"
	}), 'LocalParkingOutlined');
	
	exports.default = _default;

/***/ },
/* 3890 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.79 3H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2s2-.9 2-2v-4h3c3.57 0 6.42-3.13 5.95-6.79C18.56 5.19 15.84 3 12.79 3zm.41 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z"
	}), 'LocalParkingRounded');
	
	exports.default = _default;

/***/ },
/* 3891 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z"
	}), 'LocalParkingSharp');
	
	exports.default = _default;

/***/ },
/* 3892 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z"
	}), 'LocalParkingTwoTone');
	
	exports.default = _default;

/***/ },
/* 3893 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-5 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z"
	}), 'LocalPharmacy');
	
	exports.default = _default;

/***/ },
/* 3894 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-3.9 8.63L18.89 19H5.11l1.79-5.37.21-.63-.21-.63L5.11 7h13.78l-1.79 5.37-.21.63.21.63zM13 9h-2v3H8v2h3v3h2v-3h3v-2h-3z"
	}), 'LocalPharmacyOutlined');
	
	exports.default = _default;

/***/ },
/* 3895 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.89 5h-.53l.71-1.97c.24-.65-.1-1.37-.75-1.6-.65-.24-1.37.1-1.61.75L15.69 5H5.1C3.73 5 2.77 6.34 3.2 7.63L5 13l-1.79 5.37C2.77 19.66 3.74 21 5.1 21h13.78c1.36 0 2.33-1.34 1.9-2.63L19 13l1.78-5.37C21.21 6.34 20.25 5 18.89 5zM15 14h-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2H9c-.55 0-1-.45-1-1s.45-1 1-1h2v-2c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'LocalPharmacyRounded');
	
	exports.default = _default;

/***/ },
/* 3896 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-5 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z"
	}), 'LocalPharmacySharp');
	
	exports.default = _default;

/***/ },
/* 3897 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5.11 19h13.78l-1.79-5.37-.21-.63.21-.63L18.89 7H5.11l1.79 5.37.21.63-.21.63L5.11 19zM8 12h3V9h2v3h3v2h-3v3h-2v-3H8v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 21h18v-2l-2-6 2-6V5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2zm3.9-8.63L5.11 7h13.78l-1.79 5.37-.21.63.21.63L18.89 19H5.11l1.79-5.37.21-.63-.21-.63zM11 17h2v-3h3v-2h-3V9h-2v3H8v2h3z"
	})), 'LocalPharmacyTwoTone');
	
	exports.default = _default;

/***/ },
/* 3898 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
	}), 'LocalPhone');
	
	exports.default = _default;

/***/ },
/* 3899 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1z"
	}), 'LocalPhoneOutlined');
	
	exports.default = _default;

/***/ },
/* 3900 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.23 15.26l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z"
	}), 'LocalPhoneRounded');
	
	exports.default = _default;

/***/ },
/* 3901 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 15.46l-5.27-.61-2.52 2.52c-2.83-1.44-5.15-3.75-6.59-6.59l2.53-2.53L8.54 3H3.03C2.45 13.18 10.82 21.55 21 20.97v-5.51z"
	}), 'LocalPhoneSharp');
	
	exports.default = _default;

/***/ },
/* 3902 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 17.47c-.88-.07-1.75-.22-2.6-.45l-1.19 1.19c1.2.41 2.48.67 3.8.75v-1.49zM6.99 7.59c-.24-.83-.39-1.7-.45-2.59h-1.5c.09 1.32.35 2.59.75 3.8l1.2-1.21z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 4c0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1zm13.4 13.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19zM6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51z"
	})), 'LocalPhoneTwoTone');
	
	exports.default = _default;

/***/ },
/* 3903 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C8.43 2 5.23 3.54 3.01 6L12 22l8.99-16C18.78 3.55 15.57 2 12 2zM7 7c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm5 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'LocalPizza');
	
	exports.default = _default;

/***/ },
/* 3904 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C8.43 2 5.23 3.54 3.01 6L12 22l8.99-16C18.78 3.55 15.57 2 12 2zm0 15.92L5.51 6.36C7.32 4.85 9.62 4 12 4s4.68.85 6.49 2.36L12 17.92zM9 5.5c-.83 0-1.5.67-1.5 1.5S8.17 8.5 9 8.5s1.5-.67 1.5-1.5S9.82 5.5 9 5.5zm1.5 7.5c0 .83.67 1.5 1.5 1.5.82 0 1.5-.67 1.5-1.5s-.68-1.5-1.5-1.5-1.5.67-1.5 1.5z"
	}), 'LocalPizzaOutlined');
	
	exports.default = _default;

/***/ },
/* 3905 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C9.01 2 6.28 3.08 4.17 4.88c-.71.61-.86 1.65-.4 2.46l7.36 13.11c.38.68 1.36.68 1.74 0l7.36-13.11c.46-.81.31-1.86-.4-2.46C17.73 3.09 14.99 2 12 2zM7 7c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm5 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'LocalPizzaRounded');
	
	exports.default = _default;

/***/ },
/* 3906 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C8.43 2 5.23 3.54 3.01 6L12 22l8.99-16C18.78 3.55 15.57 2 12 2zM7 7c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm5 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'LocalPizzaSharp');
	
	exports.default = _default;

/***/ },
/* 3907 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5.51 6.36L12 17.92l6.49-11.55C16.68 4.85 14.38 4 12 4s-4.68.85-6.49 2.36zM9 8.5c-.83 0-1.5-.67-1.5-1.5S8.17 5.5 9 5.5s1.5.67 1.5 1.5S9.82 8.5 9 8.5zm4.5 4.5c0 .83-.68 1.5-1.5 1.5-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C8.43 2 5.23 3.54 3.01 6L12 22l8.99-16C18.78 3.55 15.57 2 12 2zm0 15.92L5.51 6.36C7.32 4.85 9.62 4 12 4s4.68.85 6.49 2.36L12 17.92zM9 5.5c-.83 0-1.5.67-1.5 1.5S8.17 8.5 9 8.5s1.5-.67 1.5-1.5S9.82 5.5 9 5.5zm1.5 7.5c0 .83.67 1.5 1.5 1.5.82 0 1.5-.67 1.5-1.5s-.68-1.5-1.5-1.5-1.5.67-1.5 1.5z"
	})), 'LocalPizzaTwoTone');
	
	exports.default = _default;

/***/ },
/* 3908 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z"
	}), 'LocalPlay');
	
	exports.default = _default;

/***/ },
/* 3909 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 10V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-2-1.46c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46V18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16v2.54zM9.07 16L12 14.12 14.93 16l-.89-3.36 2.69-2.2-3.47-.21L12 7l-1.27 3.22-3.47.21 2.69 2.2z"
	}), 'LocalPlayOutlined');
	
	exports.default = _default;

/***/ },
/* 3910 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 12c0-.76.43-1.42 1.06-1.76.6-.33.94-1.01.94-1.7V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.89-1.99 1.99v2.55c0 .69.33 1.37.94 1.69C3.58 10.58 4 11.24 4 12s-.43 1.43-1.06 1.76c-.6.33-.94 1.01-.94 1.7v2.25C2 19.1 2.9 20 4 20h16c1.1 0 2-.9 2-2v-2.54c0-.69-.34-1.37-.94-1.7-.63-.34-1.06-1-1.06-1.76zm-5.5 4.1L12 14.5l-2.5 1.61c-.38.24-.87-.11-.75-.55l.75-2.88-2.3-1.88c-.35-.29-.17-.86.29-.89l2.96-.17 1.08-2.75c.17-.42.77-.42.93 0l1.08 2.76 2.96.17c.45.03.64.6.29.89l-2.3 1.88.76 2.86c.12.45-.37.8-.75.55z"
	}), 'LocalPlayRounded');
	
	exports.default = _default;

/***/ },
/* 3911 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 12c0-1.1.9-2 2-2V4H2.01v6c1.1 0 1.99.9 1.99 2s-.89 2-2 2v6h20v-6c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z"
	}), 'LocalPlaySharp');
	
	exports.default = _default;

/***/ },
/* 3912 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4.01 8.54C5.2 9.23 6 10.52 6 12s-.81 2.77-2 3.46V18h16v-2.54c-1.19-.69-2-1.99-2-3.46s.81-2.77 2-3.46V6H4l.01 2.54zm6.72 1.68L12 7l1.26 3.23 3.47.2-2.69 2.2.89 3.37L12 14.12 9.07 16l.88-3.37-2.69-2.2 3.47-.21z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2V6c0-1.1-.9-2-2-2zm0 4.54c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46V18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16v2.54zM9.07 16L12 14.12 14.93 16l-.89-3.36 2.69-2.2-3.47-.21L12 7l-1.27 3.22-3.47.21 2.69 2.2z"
	})), 'LocalPlayTwoTone');
	
	exports.default = _default;

/***/ },
/* 3913 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
	}), 'LocalPostOffice');
	
	exports.default = _default;

/***/ },
/* 3914 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z"
	}), 'LocalPostOfficeOutlined');
	
	exports.default = _default;

/***/ },
/* 3915 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-.4 4.25l-6.54 4.09c-.65.41-1.47.41-2.12 0L4.4 8.25c-.25-.16-.4-.43-.4-.72 0-.67.73-1.07 1.3-.72L12 11l6.7-4.19c.57-.35 1.3.05 1.3.72 0 .29-.15.56-.4.72z"
	}), 'LocalPostOfficeRounded');
	
	exports.default = _default;

/***/ },
/* 3916 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 4H2.01v16H22V4zm-2 4l-8 5-8-5V6l8 5 8-5v2z"
	}), 'LocalPostOfficeSharp');
	
	exports.default = _default;

/***/ },
/* 3917 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 11l8-5H4zM4 8v10h16V8l-8 5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
	})), 'LocalPostOfficeTwoTone');
	
	exports.default = _default;

/***/ },
/* 3918 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
	}), 'LocalPrintshop');
	
	exports.default = _default;

/***/ },
/* 3919 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 8h-1V3H6v5H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zM8 5h8v3H8V5zm8 14H8v-4h8v4zm2-4v-2H6v2H4v-4c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v4h-2z"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "11.5",
	  r: "1"
	})), 'LocalPrintshopOutlined');
	
	exports.default = _default;

/***/ },
/* 3920 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 8H5c-1.66 0-3 1.34-3 3v4c0 1.1.9 2 2 2h2v2c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-2h2c1.1 0 2-.9 2-2v-4c0-1.66-1.34-3-3-3zm-4 11H9c-.55 0-1-.45-1-1v-4h8v4c0 .55-.45 1-1 1zm4-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2-9H7c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
	}), 'LocalPrintshopRounded');
	
	exports.default = _default;

/***/ },
/* 3921 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 8v9h4v4h12v-4h4V8H2zm14 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
	}), 'LocalPrintshopSharp');
	
	exports.default = _default;

/***/ },
/* 3922 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 5h8v3H8zm11 5H5c-.55 0-1 .45-1 1v4h2v-2h12v2h2v-4c0-.55-.45-1-1-1zm-1 2.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 8h-1V3H6v5H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zM8 5h8v3H8V5zm8 14H8v-4h8v4zm4-4h-2v-2H6v2H4v-4c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v4z"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "11.5",
	  r: "1"
	})), 'LocalPrintshopTwoTone');
	
	exports.default = _default;

/***/ },
/* 3923 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "3.2"
	}), _react.default.createElement("path", {
	  d: "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	})), 'LocalSee');
	
	exports.default = _default;

/***/ },
/* 3924 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h4.05l.59-.65L9.88 4h4.24l1.24 1.35.59.65H20v12zM12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8.2c-1.77 0-3.2-1.43-3.2-3.2 0-1.77 1.43-3.2 3.2-3.2s3.2 1.43 3.2 3.2c0 1.77-1.43 3.2-3.2 3.2z"
	}), 'LocalSeeOutlined');
	
	exports.default = _default;

/***/ },
/* 3925 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "3.2"
	}), _react.default.createElement("path", {
	  d: "M20 4h-3.17l-1.24-1.35c-.37-.41-.91-.65-1.47-.65H9.88c-.56 0-1.1.24-1.48.65L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 13c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	})), 'LocalSeeRounded');
	
	exports.default = _default;

/***/ },
/* 3926 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "3.2"
	}), _react.default.createElement("path", {
	  d: "M22 4h-5.17L15 2H9L7.17 4H2v16h20V4zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	})), 'LocalSeeSharp');
	
	exports.default = _default;

/***/ },
/* 3927 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 6h-4.05l-.59-.65L14.12 4H9.88L8.65 5.35l-.6.65H4v12h16V6zm-8 11c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 20h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2zM4 6h4.05l.59-.65L9.88 4h4.24l1.24 1.35.59.65H20v12H4V6zm8 1c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8.2c-1.77 0-3.2-1.43-3.2-3.2 0-1.77 1.43-3.2 3.2-3.2s3.2 1.43 3.2 3.2c0 1.77-1.43 3.2-3.2 3.2z"
	})), 'LocalSeeTwoTone');
	
	exports.default = _default;

/***/ },
/* 3928 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'LocalShipping');
	
	exports.default = _default;

/***/ },
/* 3929 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zm-.5 1.5l1.96 2.5H17V9.5h2.5zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2.22-3c-.55-.61-1.33-1-2.22-1s-1.67.39-2.22 1H3V6h12v9H8.22zM18 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'LocalShippingOutlined');
	
	exports.default = _default;

/***/ },
/* 3930 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.5 8H17V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2 0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h1c.55 0 1-.45 1-1v-3.33c0-.43-.14-.85-.4-1.2L20.3 8.4c-.19-.25-.49-.4-.8-.4zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm13.5-8.5l1.96 2.5H17V9.5h2.5zM18 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'LocalShippingRounded');
	
	exports.default = _default;

/***/ },
/* 3931 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8h-3V4H1v13h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm13.5-8.5l1.96 2.5H17V9.5h2.5zM18 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'LocalShippingSharp');
	
	exports.default = _default;

/***/ },
/* 3932 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 15h.78c.55-.61 1.34-1 2.22-1s1.67.39 2.22 1H15V6H3v9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 8V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4h-3zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm9-3H8.22c-.55-.61-1.33-1-2.22-1s-1.67.39-2.22 1H3V6h12v9zm3 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-6V9.5h2.5l1.96 2.5H17z"
	})), 'LocalShippingTwoTone');
	
	exports.default = _default;

/***/ },
/* 3933 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
	}), 'LocalTaxi');
	
	exports.default = _default;

/***/ },
/* 3934 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 7h10.29l1.04 3H5.81l1.04-3zM19 17H5v-4.66l.12-.34h13.77l.11.34V17z"
	}), _react.default.createElement("circle", {
	  cx: "7.5",
	  cy: "14.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "14.5",
	  r: "1.5"
	})), 'LocalTaxiOutlined');
	
	exports.default = _default;

/***/ },
/* 3935 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V4c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v1H6.5c-.66 0-1.21.42-1.42 1.01l-1.97 5.67c-.07.21-.11.43-.11.66v7.16c0 .83.67 1.5 1.5 1.5S6 20.33 6 19.5V19h12v.5c0 .82.67 1.5 1.5 1.5.82 0 1.5-.67 1.5-1.5v-7.16c0-.22-.04-.45-.11-.66l-1.97-5.67zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
	}), 'LocalTaxiRounded');
	
	exports.default = _default;

/***/ },
/* 3936 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.58 5H15V3H9v2H5.43L3 12v9h3v-2h12v2h3v-9l-2.42-7zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
	}), 'LocalTaxiSharp');
	
	exports.default = _default;

/***/ },
/* 3937 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5.12 12l-.12.34V17h14v-4.66l-.12-.34H5.12zm2.38 4c-.83 0-1.5-.67-1.5-1.5S6.67 13 7.5 13s1.5.67 1.5 1.5S8.33 16 7.5 16zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99C18.72 5.42 18.16 5 17.5 5zM6.85 7h10.29l1.04 3H5.81l1.04-3zM19 17H5v-4.66l.12-.34h13.77l.11.34V17z"
	}), _react.default.createElement("circle", {
	  cx: "7.5",
	  cy: "14.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "14.5",
	  r: "1.5"
	})), 'LocalTaxiTwoTone');
	
	exports.default = _default;

/***/ },
/* 3938 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
	}), 'LocationCity');
	
	exports.default = _default;

/***/ },
/* 3939 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
	}), 'LocationCityOutlined');
	
	exports.default = _default;

/***/ },
/* 3940 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 11V5.83c0-.53-.21-1.04-.59-1.41L12.7 2.71a.9959.9959 0 00-1.41 0l-1.7 1.7C9.21 4.79 9 5.3 9 5.83V7H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6c0-1.1-.9-2-2-2h-4zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
	}), 'LocationCityRounded');
	
	exports.default = _default;

/***/ },
/* 3941 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
	}), 'LocationCitySharp');
	
	exports.default = _default;

/***/ },
/* 3942 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
	}), 'LocationCityTwoTone');
	
	exports.default = _default;

/***/ },
/* 3943 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z"
	}), 'LocationDisabled');
	
	exports.default = _default;

/***/ },
/* 3944 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 13v-2h-2.06c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-.98.11-1.91.38-2.77.78l1.53 1.53C10.46 5.13 11.22 5 12 5c3.87 0 7 3.13 7 7 0 .79-.13 1.54-.37 2.24l1.53 1.53c.4-.86.67-1.79.78-2.77H23zM4.41 2.86L3 4.27l2.04 2.04C3.97 7.62 3.26 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21l1.41-1.41L4.41 2.86zM12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81C15.09 18.45 13.61 19 12 19z"
	}), 'LocationDisabledOutlined');
	
	exports.default = _default;

/***/ },
/* 3945 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 13c.55 0 1-.45 1-1s-.45-1-1-1h-1.06c-.46-4.17-3.77-7.48-7.94-7.94V2c0-.55-.45-1-1-1s-1 .45-1 1v1.06c-.98.11-1.91.38-2.77.78l1.53 1.53C10.46 5.13 11.22 5 12 5c3.87 0 7 3.13 7 7 0 .79-.13 1.54-.37 2.24l1.53 1.53c.4-.86.67-1.79.78-2.77H22zm-1.56 5.88L5.12 3.56a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L5.04 6.3C3.97 7.62 3.26 9.23 3.06 11H2c-.55 0-1 .45-1 1s.45 1 1 1h1.06c.46 4.17 3.77 7.48 7.94 7.94V22c0 .55.45 1 1 1s1-.45 1-1v-1.06c1.77-.2 3.38-.91 4.69-1.98l1.33 1.33c.39.39 1.02.39 1.41 0 .4-.39.4-1.02.01-1.41zM12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81C15.09 18.45 13.61 19 12 19z"
	}), 'LocationDisabledRounded');
	
	exports.default = _default;

/***/ },
/* 3946 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 13v-2h-2.06c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-.98.11-1.91.38-2.77.78l1.53 1.53C10.46 5.13 11.22 5 12 5c3.87 0 7 3.13 7 7 0 .79-.13 1.54-.37 2.24l1.53 1.53c.4-.86.67-1.79.78-2.77H23zM4.41 2.86L3 4.27l2.04 2.04C3.97 7.62 3.26 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21l1.41-1.41L4.41 2.86zM12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81C15.09 18.45 13.61 19 12 19z"
	}), 'LocationDisabledSharp');
	
	exports.default = _default;

/***/ },
/* 3947 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 13v-2h-2.06c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-.98.11-1.91.38-2.77.78l1.53 1.53C10.46 5.13 11.22 5 12 5c3.87 0 7 3.13 7 7 0 .79-.13 1.54-.37 2.24l1.53 1.53c.4-.86.67-1.79.78-2.77H23zM4.41 2.86L3 4.27l2.04 2.04C3.97 7.62 3.26 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21l1.41-1.41L4.41 2.86zM12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81C15.09 18.45 13.61 19 12 19z"
	}), 'LocationDisabledTwoTone');
	
	exports.default = _default;

/***/ },
/* 3948 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6.5c1.38 0 2.5 1.12 2.5 2.5 0 .74-.33 1.39-.83 1.85l3.63 3.63c.98-1.86 1.7-3.8 1.7-5.48 0-3.87-3.13-7-7-7-1.98 0-3.76.83-5.04 2.15l3.19 3.19c.46-.52 1.11-.84 1.85-.84zm4.37 9.6l-4.63-4.63-.11-.11L3.27 3 2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21 20 19.73l-3.63-3.63z"
	}), 'LocationOff');
	
	exports.default = _default;

/***/ },
/* 3949 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c2.76 0 5 2.24 5 5 0 1.06-.39 2.32-1 3.62l1.49 1.49C18.37 12.36 19 10.57 19 9c0-3.87-3.13-7-7-7-1.84 0-3.5.71-4.75 1.86l1.43 1.43C9.56 4.5 10.72 4 12 4zm0 2.5c-.59 0-1.13.21-1.56.56l3.5 3.5c.35-.43.56-.97.56-1.56 0-1.38-1.12-2.5-2.5-2.5zM3.41 2.86L2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21l1.41-1.41L3.41 2.86zM12 18.88c-2.01-2.58-4.8-6.74-4.98-9.59l6.92 6.92c-.65.98-1.33 1.89-1.94 2.67z"
	})), 'LocationOffOutlined');
	
	exports.default = _default;

/***/ },
/* 3950 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M2.71 3.56c-.39.39-.39 1.02 0 1.41l2.47 2.47C5.07 7.95 5 8.47 5 9c0 4.17 4.42 9.92 6.23 12.11.4.48 1.13.48 1.53 0 .65-.78 1.62-2.01 2.61-3.46l2.65 2.65c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L4.12 3.56a.9959.9959 0 0 0-1.41 0zM12 2c-1.84 0-3.5.71-4.75 1.86l3.19 3.19c.43-.34.97-.55 1.56-.55 1.38 0 2.5 1.12 2.5 2.5 0 .59-.21 1.13-.56 1.56l3.55 3.55C18.37 12.36 19 10.57 19 9c0-3.87-3.13-7-7-7z"
	})), 'LocationOffRounded');
	
	exports.default = _default;

/***/ },
/* 3951 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3.41 2.86L2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21l1.41-1.41L3.41 2.86zM12 2c-1.84 0-3.5.71-4.75 1.86l3.19 3.19c.43-.34.97-.55 1.56-.55 1.38 0 2.5 1.12 2.5 2.5 0 .59-.21 1.13-.56 1.56l3.55 3.55C18.37 12.36 19 10.57 19 9c0-3.87-3.13-7-7-7z"
	})), 'LocationOffSharp');
	
	exports.default = _default;

/***/ },
/* 3952 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17 9c0 1.06-.39 2.32-1 3.62l1.49 1.49C18.37 12.36 19 10.57 19 9c0-3.87-3.13-7-7-7-1.84 0-3.5.71-4.75 1.86l1.43 1.43C9.56 4.5 10.72 4 12 4c2.76 0 5 2.24 5 5zm-5-2.5c-.59 0-1.13.21-1.56.56l3.5 3.5c.35-.43.56-.97.56-1.56 0-1.38-1.12-2.5-2.5-2.5zM3.41 2.86L2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21l1.41-1.41L3.41 2.86zM12 18.88c-2.01-2.58-4.8-6.74-4.98-9.59l6.92 6.92c-.65.98-1.33 1.89-1.94 2.67z"
	})), 'LocationOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 3953 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
	}), 'LocationOn');
	
	exports.default = _default;

/***/ },
/* 3954 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "9",
	  r: "2.5"
	})), 'LocationOnOutlined');
	
	exports.default = _default;

/***/ },
/* 3955 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2C8.13 2 5 5.13 5 9c0 4.17 4.42 9.92 6.24 12.11.4.48 1.13.48 1.53 0C14.58 18.92 19 13.17 19 9c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
	})), 'LocationOnRounded');
	
	exports.default = _default;

/***/ },
/* 3956 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
	})), 'LocationOnSharp');
	
	exports.default = _default;

/***/ },
/* 3957 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4C9.24 4 7 6.24 7 9c0 2.85 2.92 7.21 5 9.88 2.11-2.69 5-7 5-9.88 0-2.76-2.24-5-5-5zm0 7.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "9",
	  r: "2.5"
	})), 'LocationOnTwoTone');
	
	exports.default = _default;

/***/ },
/* 3958 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'LocationSearching');
	
	exports.default = _default;

/***/ },
/* 3959 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'LocationSearchingOutlined');
	
	exports.default = _default;

/***/ },
/* 3960 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V2c0-.55-.45-1-1-1s-1 .45-1 1v1.06C6.83 3.52 3.52 6.83 3.06 11H2c-.55 0-1 .45-1 1s.45 1 1 1h1.06c.46 4.17 3.77 7.48 7.94 7.94V22c0 .55.45 1 1 1s1-.45 1-1v-1.06c4.17-.46 7.48-3.77 7.94-7.94H22c.55 0 1-.45 1-1s-.45-1-1-1h-1.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'LocationSearchingRounded');
	
	exports.default = _default;

/***/ },
/* 3961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'LocationSearchingSharp');
	
	exports.default = _default;

/***/ },
/* 3962 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'LocationSearchingTwoTone');
	
	exports.default = _default;

/***/ },
/* 3963 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
	}), 'Lock');
	
	exports.default = _default;

/***/ },
/* 3964 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z"
	}), 'LockOpen');
	
	exports.default = _default;

/***/ },
/* 3965 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
	}), 'LockOpenOutlined');
	
	exports.default = _default;

/***/ },
/* 3966 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6-5h-1V6c0-2.76-2.24-5-5-5-2.28 0-4.27 1.54-4.84 3.75-.14.54.18 1.08.72 1.22.53.14 1.08-.18 1.22-.72C9.44 3.93 10.63 3 12 3c1.65 0 3 1.35 3 3v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 11c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v8z"
	}), 'LockOpenRounded');
	
	exports.default = _default;

/***/ },
/* 3967 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8h-3V6.21c0-2.61-1.91-4.94-4.51-5.19C9.51.74 7 3.08 7 6h2c0-1.13.6-2.24 1.64-2.7C12.85 2.31 15 3.9 15 6v2H4v14h16V8zm-2 12H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
	}), 'LockOpenSharp');
	
	exports.default = _default;

/***/ },
/* 3968 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 20h12V10H6v10zm6-7c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
	})), 'LockOpenTwoTone');
	
	exports.default = _default;

/***/ },
/* 3969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
	}), 'LockOutlined');
	
	exports.default = _default;

/***/ },
/* 3970 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM9 8V6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9z"
	}), 'LockRounded');
	
	exports.default = _default;

/***/ },
/* 3971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8h-3V6.21c0-2.61-1.91-4.94-4.51-5.19C9.51.74 7 3.08 7 6v2H4v14h16V8zm-8 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM9 8V6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9z"
	}), 'LockSharp');
	
	exports.default = _default;

/***/ },
/* 3972 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 20h12V10H6v10zm6-7c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
	})), 'LockTwoTone');
	
	exports.default = _default;

/***/ },
/* 3973 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 10c-3.86 0-7 3.14-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.86-3.14-7-7-7zm0-4C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11z"
	}), 'Looks');
	
	exports.default = _default;

/***/ },
/* 3974 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.01 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 7.5c0 .83-.67 1.5-1.5 1.5.83 0 1.5.67 1.5 1.5V15c0 1.11-.9 2-2 2h-4v-2h4v-2h-2v-2h2V9h-4V7h4c1.1 0 2 .89 2 2v1.5z"
	}), 'Looks3');
	
	exports.default = _default;

/***/ },
/* 3975 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-4-4v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V9c0-1.11-.9-2-2-2H9v2h4v2h-2v2h2v2H9v2h4c1.1 0 2-.89 2-2z"
	}), 'Looks3Outlined');
	
	exports.default = _default;

/***/ },
/* 3976 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5.01c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3.99 7.5c0 .83-.67 1.5-1.5 1.5.83 0 1.5.67 1.5 1.5V15c0 1.11-.9 2-2 2H10c-.55 0-1-.45-1-1s.45-1 1-1h3.01L13 13h-1c-.55 0-1-.45-1-1s.45-1 1-1h1l.01-2H10c-.55 0-.99-.45-.99-1s.44-1 .99-1h3.01c1.1 0 2 .9 2 2v1.5z"
	}), 'Looks3Rounded');
	
	exports.default = _default;

/***/ },
/* 3977 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3.01v18H21V3zm-5.99 14H9v-2h4v-2h-2v-2h2V9H9V7h6.01v10z"
	}), 'Looks3Sharp');
	
	exports.default = _default;

/***/ },
/* 3978 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14V5H5v14zm4-4h4v-2h-2v-2h2V9H9V7h4c1.1 0 2 .89 2 2v1.5c0 .83-.67 1.5-1.5 1.5.83 0 1.5.67 1.5 1.5V15c0 1.11-.9 2-2 2H9v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-4-4v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V9c0-1.11-.9-2-2-2H9v2h4v2h-2v2h2v2H9v2h4c1.1 0 2-.89 2-2z"
	})), 'Looks3TwoTone');
	
	exports.default = _default;

/***/ },
/* 3979 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 14h-2v-4H9V7h2v4h2V7h2v10z"
	}), 'Looks4');
	
	exports.default = _default;

/***/ },
/* 3980 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.04 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-14V5h14v14zm-6-2h2V7h-2v4h-2V7h-2v6h4z"
	}), 'Looks4Outlined');
	
	exports.default = _default;

/***/ },
/* 3981 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.04 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14c-.55 0-1-.45-1-1v-3h-3c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v3h2V8c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1z"
	}), 'Looks4Rounded');
	
	exports.default = _default;

/***/ },
/* 3982 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.04 3h-18v18h18V3zm-6 14h-2v-4h-4V7h2v4h2V7h2v10z"
	}), 'Looks4Sharp');
	
	exports.default = _default;

/***/ },
/* 3983 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5.04 19h14V5h-14v14zm4-12h2v4h2V7h2v10h-2v-4h-4V7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19.04 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-14V5h14v14zm-6-2h2V7h-2v4h-2V7h-2v6h4z"
	})), 'Looks4TwoTone');
	
	exports.default = _default;

/***/ },
/* 3984 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2H9v-2h4v-2H9V7h6v2z"
	}), 'Looks5');
	
	exports.default = _default;

/***/ },
/* 3985 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-4-4v-2c0-1.11-.9-2-2-2h-2V9h4V7H9v6h4v2H9v2h4c1.1 0 2-.89 2-2z"
	}), 'Looks5Outlined');
	
	exports.default = _default;

/***/ },
/* 3986 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 6h-3v2h2c1.1 0 2 .9 2 2v2c0 1.11-.9 2-2 2h-3c-.55 0-1-.45-1-1s.45-1 1-1h3v-2h-3c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'Looks5Rounded');
	
	exports.default = _default;

/***/ },
/* 3987 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zm-6 6h-4v2h4v6H9v-2h4v-2H9V7h6v2z"
	}), 'Looks5Sharp');
	
	exports.default = _default;

/***/ },
/* 3988 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 5H5v14h14V5zm-4 4h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2H9v-2h4v-2H9V7h6v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 21h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2zM5 5h14v14H5V5zm4 8h4v2H9v2h4c1.1 0 2-.89 2-2v-2c0-1.11-.9-2-2-2h-2V9h4V7H9v6z"
	})), 'Looks5TwoTone');
	
	exports.default = _default;

/***/ },
/* 3989 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 15h2v-2h-2v2zm8-12H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2h-2c-1.1 0-2-.89-2-2V9c0-1.11.9-2 2-2h4v2z"
	}), 'Looks6');
	
	exports.default = _default;

/***/ },
/* 3990 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 17h2c1.1 0 2-.89 2-2v-2c0-1.11-.9-2-2-2h-2V9h4V7h-4c-1.1 0-2 .89-2 2v6c0 1.11.9 2 2 2zm0-4h2v2h-2v-2zm8-10H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
	}), 'Looks6Outlined');
	
	exports.default = _default;

/***/ },
/* 3991 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 15h2v-2h-2v2zm8-12H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 6h-3v2h2c1.1 0 2 .9 2 2v2c0 1.11-.9 2-2 2h-2c-1.1 0-2-.89-2-2V9c0-1.1.9-2 2-2h3c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'Looks6Rounded');
	
	exports.default = _default;

/***/ },
/* 3992 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 15h2v-2h-2v2zM21 3H3v18h18V3zm-6 6h-4v2h4v6H9V7h6v2z"
	}), 'Looks6Sharp');
	
	exports.default = _default;

/***/ },
/* 3993 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11 13h2v2h-2zm8-8H5v14h14V5zm-4 4h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2h-2c-1.1 0-2-.89-2-2V9c0-1.11.9-2 2-2h4v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9 9v6c0 1.11.9 2 2 2h2c1.1 0 2-.89 2-2v-2c0-1.11-.9-2-2-2h-2V9h4V7h-4c-1.1 0-2 .89-2 2zm4 4v2h-2v-2h2zm-8 8h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2zM5 5h14v14H5V5z"
	})), 'Looks6TwoTone');
	
	exports.default = _default;

/***/ },
/* 3994 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V9h-2V7h4v10z"
	}), 'LooksOne');
	
	exports.default = _default;

/***/ },
/* 3995 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-7-2h2V7h-4v2h2z"
	}), 'LooksOneOutlined');
	
	exports.default = _default;

/***/ },
/* 3996 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 14c-.55 0-1-.45-1-1V9h-1c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1z"
	}), 'LooksOneRounded');
	
	exports.default = _default;

/***/ },
/* 3997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zm-7 14h-2V9h-2V7h4v10z"
	}), 'LooksOneSharp');
	
	exports.default = _default;

/***/ },
/* 3998 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 5H5v14h14V5zm-5 12h-2V9h-2V7h4v10z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 21h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2zM5 5h14v14H5V5zm5 4h2v8h2V7h-4z"
	})), 'LooksOneTwoTone');
	
	exports.default = _default;

/***/ },
/* 3999 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 10c-3.86 0-7 3.14-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.86-3.14-7-7-7zm0-4C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11z"
	}), 'LooksOutlined');
	
	exports.default = _default;

/***/ },
/* 4000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 10c-3.47 0-6.36 2.54-6.91 5.86-.1.6.39 1.14 1 1.14.49 0 .9-.36.98-.85C7.48 13.79 9.53 12 12 12s4.52 1.79 4.93 4.15c.08.49.49.85.98.85.61 0 1.09-.54.99-1.14C18.36 12.54 15.47 10 12 10zm0-4C6.3 6 1.61 10.34 1.05 15.9c-.05.59.41 1.1 1.01 1.1.51 0 .94-.38.99-.88C3.49 11.57 7.34 8 12 8s8.51 3.57 8.96 8.12c.05.5.48.88.99.88.59 0 1.06-.51 1-1.1C22.39 10.34 17.7 6 12 6z"
	}), 'LooksRounded');
	
	exports.default = _default;

/***/ },
/* 4001 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 10c-3.86 0-7 3.14-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.86-3.14-7-7-7zm0-4C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11z"
	}), 'LooksSharp');
	
	exports.default = _default;

/***/ },
/* 4002 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 8c0 1.11-.9 2-2 2h-2v2h4v2H9v-4c0-1.11.9-2 2-2h2V9H9V7h4c1.1 0 2 .89 2 2v2z"
	}), 'LooksTwo');
	
	exports.default = _default;

/***/ },
/* 4003 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-4-4h-4v-2h2c1.1 0 2-.89 2-2V9c0-1.11-.9-2-2-2H9v2h4v2h-2c-1.1 0-2 .89-2 2v4h6v-2z"
	}), 'LooksTwoOutlined');
	
	exports.default = _default;

/***/ },
/* 4004 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 8c0 1.1-.9 2-2 2h-2v2h3c.55 0 1 .45 1 1s-.45 1-1 1h-4c-.55 0-1-.45-1-1v-3c0-1.1.9-2 2-2h2V9h-3c-.55 0-1-.45-1-1s.45-1 1-1h3c1.1 0 2 .9 2 2v2z"
	}), 'LooksTwoRounded');
	
	exports.default = _default;

/***/ },
/* 4005 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zm-6 10h-4v2h4v2H9v-6h4V9H9V7h6v6z"
	}), 'LooksTwoSharp');
	
	exports.default = _default;

/***/ },
/* 4006 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11zm0 6c2.76 0 5 2.24 5 5h2c0-3.86-3.14-7-7-7s-7 3.14-7 7h2c0-2.76 2.24-5 5-5z"
	}), 'LooksTwoTone');
	
	exports.default = _default;

/***/ },
/* 4007 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 5H5v14h14V5zm-4 6c0 1.11-.9 2-2 2h-2v2h4v2H9v-4c0-1.11.9-2 2-2h2V9H9V7h4c1.1 0 2 .89 2 2v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 21h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2zM5 5h14v14H5V5zm8 2H9v2h4v2h-2c-1.1 0-2 .89-2 2v4h6v-2h-4v-2h2c1.1 0 2-.89 2-2V9c0-1.11-.9-2-2-2z"
	})), 'LooksTwoTwoTone');
	
	exports.default = _default;

/***/ },
/* 4008 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
	}), 'Loop');
	
	exports.default = _default;

/***/ },
/* 4009 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
	}), 'LoopOutlined');
	
	exports.default = _default;

/***/ },
/* 4010 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4V2.21c0-.45-.54-.67-.85-.35l-2.8 2.79c-.2.2-.2.51 0 .71l2.79 2.79c.32.31.86.09.86-.36V6c3.31 0 6 2.69 6 6 0 .79-.15 1.56-.44 2.25-.15.36-.04.77.23 1.04.51.51 1.37.33 1.64-.34.37-.91.57-1.91.57-2.95 0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-.79.15-1.56.44-2.25.15-.36.04-.77-.23-1.04-.51-.51-1.37-.33-1.64.34C4.2 9.96 4 10.96 4 12c0 4.42 3.58 8 8 8v1.79c0 .45.54.67.85.35l2.79-2.79c.2-.2.2-.51 0-.71l-2.79-2.79c-.31-.31-.85-.09-.85.36V18z"
	}), 'LoopRounded');
	
	exports.default = _default;

/***/ },
/* 4011 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
	}), 'LoopSharp');
	
	exports.default = _default;

/***/ },
/* 4012 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 18c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3zm0-14V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8z"
	}), 'LoopTwoTone');
	
	exports.default = _default;

/***/ },
/* 4013 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.51-4.49-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'Loupe');
	
	exports.default = _default;

/***/ },
/* 4014 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.51-4.49-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'LoupeOutlined');
	
	exports.default = _default;

/***/ },
/* 4015 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7c-.55 0-1 .45-1 1v3H8c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V8c0-.55-.45-1-1-1zm0-5C6.49 2 2 6.49 2 12s4.49 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.51-4.49-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'LoupeRounded');
	
	exports.default = _default;

/***/ },
/* 4016 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-.27-4.97c-6.08-.44-11.14 4.62-10.7 10.7.38 5.28 5 9.27 10.29 9.27H22v-9.68c0-5.3-3.98-9.91-9.27-10.29zM12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'LoupeSharp');
	
	exports.default = _default;

/***/ },
/* 4017 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 20c4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8 3.59 8 8 8zm-5-9h4V7h2v4h4v2h-4v4h-2v-4H7v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11 17h2v-4h4v-2h-4V7h-2v4H7v2h4zm1 5h8c1.1 0 2-.9 2-2v-8c0-5.51-4.49-10-10-10S2 6.49 2 12s4.49 10 10 10zm0-18c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8z"
	})), 'LoupeTwoTone');
	
	exports.default = _default;

/***/ },
/* 4018 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 5h8v2h-8zm0 5.5h8v2h-8zm0 5.5h8v2h-8zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z"
	}), 'LowPriority');
	
	exports.default = _default;

/***/ },
/* 4019 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 5h8v2h-8V5zm0 5.5h8v2h-8v-2zm0 5.5h8v2h-8v-2zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z"
	}), 'LowPriorityOutlined');
	
	exports.default = _default;

/***/ },
/* 4020 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 5h6c.55 0 1 .45 1 1s-.45 1-1 1h-6c-.55 0-1-.45-1-1s.45-1 1-1zm0 5.5h6c.55 0 1 .45 1 1s-.45 1-1 1h-6c-.55 0-1-.45-1-1s.45-1 1-1zm0 5.5h6c.55 0 1 .45 1 1s-.45 1-1 1h-6c-.55 0-1-.45-1-1s.45-1 1-1zm-5.15 3.15l1.79-1.79c.2-.2.2-.51 0-.71l-1.79-1.79c-.31-.32-.85-.1-.85.35v3.59c0 .44.54.66.85.35zM9 16h-.3c-2.35 0-4.45-1.71-4.68-4.05C3.76 9.27 5.87 7 8.5 7H11c.55 0 1-.45 1-1s-.45-1-1-1H8.5c-3.86 0-6.96 3.4-6.44 7.36C2.48 15.64 5.43 18 8.73 18H9"
	}), 'LowPriorityRounded');
	
	exports.default = _default;

/***/ },
/* 4021 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 5h8v2h-8V5zm0 5.5h8v2h-8v-2zm0 5.5h8v2h-8v-2zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z"
	}), 'LowPrioritySharp');
	
	exports.default = _default;

/***/ },
/* 4022 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 5h8v2h-8V5zm0 5.5h8v2h-8v-2zm0 5.5h8v2h-8v-2zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z"
	}), 'LowPriorityTwoTone');
	
	exports.default = _default;

/***/ },
/* 4023 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z"
	}), 'Loyalty');
	
	exports.default = _default;

/***/ },
/* 4024 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM13 20.01L4 11V4h7v-.01l9 9-7 7.02z"
	}), _react.default.createElement("circle", {
	  cx: "6.5",
	  cy: "6.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M8.9 12.55c0 .57.23 1.07.6 1.45l3.5 3.5 3.5-3.5c.37-.37.6-.89.6-1.45 0-1.13-.92-2.05-2.05-2.05-.57 0-1.08.23-1.45.6l-.6.6-.6-.59c-.37-.38-.89-.61-1.45-.61-1.13 0-2.05.92-2.05 2.05z"
	})), 'LoyaltyOutlined');
	
	exports.default = _default;

/***/ },
/* 4025 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27l-3.92 3.92c-.2.2-.51.2-.71 0l-3.92-3.92c-.57-.58-.87-1.43-.67-2.34.19-.88.89-1.61 1.76-1.84.94-.25 1.85.04 2.44.65l.75.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z"
	}), 'LoyaltyRounded');
	
	exports.default = _default;

/***/ },
/* 4026 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.83 2H2v9.83l10.99 11s1.05-1.05 1.41-1.42L22.82 13 11.83 2zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zM13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77L13 19.54z"
	}), 'LoyaltySharp');
	
	exports.default = _default;

/***/ },
/* 4027 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11 4H4v7l9 9.01L20 13l-9-9zM6.5 8C5.67 8 5 7.33 5 6.5S5.67 5 6.5 5 8 5.67 8 6.5 7.33 8 6.5 8zm6.5 3.7l.6-.6c.37-.37.89-.6 1.45-.6 1.13 0 2.05.92 2.05 2.05 0 .57-.23 1.08-.6 1.45L13 17.5 9.5 14c-.37-.38-.6-.89-.6-1.45 0-1.13.92-2.05 2.05-2.05.57 0 1.08.23 1.45.61l.6.59z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM13 20.01L4 11V4h7v-.01l9 9-7 7.02z"
	}), _react.default.createElement("circle", {
	  cx: "6.5",
	  cy: "6.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M8.9 12.55c0 .57.23 1.07.6 1.45l3.5 3.5 3.5-3.5c.37-.37.6-.89.6-1.45 0-1.13-.92-2.05-2.05-2.05-.57 0-1.08.23-1.45.6l-.6.6-.6-.59c-.37-.38-.89-.61-1.45-.61-1.13 0-2.05.92-2.05 2.05z"
	})), 'LoyaltyTwoTone');
	
	exports.default = _default;

/***/ },
/* 4028 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
	}), 'Mail');
	
	exports.default = _default;

/***/ },
/* 4029 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
	}), 'MailOutline');
	
	exports.default = _default;

/***/ },
/* 4030 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
	}), 'MailOutlineOutlined');
	
	exports.default = _default;

/***/ },
/* 4031 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-1 14H5c-.55 0-1-.45-1-1V8l6.94 4.34c.65.41 1.47.41 2.12 0L20 8v9c0 .55-.45 1-1 1zm-7-7L4 6h16l-8 5z"
	}), 'MailOutlineRounded');
	
	exports.default = _default;

/***/ },
/* 4032 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 4H2.01L2 20h20V4zm-2 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
	}), 'MailOutlineSharp');
	
	exports.default = _default;

/***/ },
/* 4033 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
	}), 'MailOutlineTwoTone');
	
	exports.default = _default;

/***/ },
/* 4034 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 4.99L4 6h16zm0 12H4V8l8 5 8-5v10z"
	}), 'MailOutlined');
	
	exports.default = _default;

/***/ },
/* 4035 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-.4 4.25l-6.54 4.09c-.65.41-1.47.41-2.12 0L4.4 8.25c-.25-.16-.4-.43-.4-.72 0-.67.73-1.07 1.3-.72L12 11l6.7-4.19c.57-.35 1.3.05 1.3.72 0 .29-.15.56-.4.72z"
	}), 'MailRounded');
	
	exports.default = _default;

/***/ },
/* 4036 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 4H2v16h20V4zm-2 4l-8 5-8-5V6l8 5 8-5v2z"
	}), 'MailSharp');
	
	exports.default = _default;

/***/ },
/* 4037 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 6H4l8 4.99zM4 8v10h16V8l-8 5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 2l-8 4.99L4 6h16zm0 12H4V8l8 5 8-5v10z"
	})), 'MailTwoTone');
	
	exports.default = _default;

/***/ },
/* 4038 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z"
	}), 'Map');
	
	exports.default = _default;

/***/ },
/* 4039 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM10 5.47l4 1.4v11.66l-4-1.4V5.47zm-5 .99l3-1.01v11.7l-3 1.16V6.46zm14 11.08l-3 1.01V6.86l3-1.16v11.84z"
	}), 'MapOutlined');
	
	exports.default = _default;

/***/ },
/* 4040 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.65 4.98l-5-1.75c-.42-.15-.88-.15-1.3-.01L4.36 4.56C3.55 4.84 3 5.6 3 6.46v11.85c0 1.41 1.41 2.37 2.72 1.86l2.93-1.14c.22-.09.47-.09.69-.01l5 1.75c.42.15.88.15 1.3.01l3.99-1.34c.81-.27 1.36-1.04 1.36-1.9V5.69c0-1.41-1.41-2.37-2.72-1.86l-2.93 1.14c-.22.08-.46.09-.69.01zM15 18.89l-6-2.11V5.11l6 2.11v11.67z"
	}), 'MapRounded');
	
	exports.default = _default;

/***/ },
/* 4041 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 5.1L9 3 3 5.02v16.2l6-2.33 6 2.1 6-2.02V2.77L15 5.1zm0 13.79l-6-2.11V5.11l6 2.11v11.67z"
	}), 'MapSharp');
	
	exports.default = _default;

/***/ },
/* 4042 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 18.31l3-1.16V5.45L5 6.46zm11 .24l3-1.01V5.69l-3 1.17z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM8 17.15l-3 1.16V6.46l3-1.01v11.7zm6 1.38l-4-1.4V5.47l4 1.4v11.66zm5-.99l-3 1.01V6.86l3-1.16v11.84z"
	})), 'MapTwoTone');
	
	exports.default = _default;

/***/ },
/* 4043 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
	}), 'Markunread');
	
	exports.default = _default;

/***/ },
/* 4044 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6H10v6H8V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z"
	}), 'MarkunreadMailbox');
	
	exports.default = _default;

/***/ },
/* 4045 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6H10v2h10v12H4V8h2v4h2V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z"
	}), 'MarkunreadMailboxOutlined');
	
	exports.default = _default;

/***/ },
/* 4046 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6H10v5c0 .55-.45 1-1 1s-1-.45-1-1V4h5c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z"
	}), 'MarkunreadMailboxRounded');
	
	exports.default = _default;

/***/ },
/* 4047 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6H10v6H8V4h6V0H6v6H2v16h20V6z"
	}), 'MarkunreadMailboxSharp');
	
	exports.default = _default;

/***/ },
/* 4048 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M10 12H6V8H4v12h16V8H10z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 6H10v2h10v12H4V8h2v4h2V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z"
	})), 'MarkunreadMailboxTwoTone');
	
	exports.default = _default;

/***/ },
/* 4049 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z"
	}), 'MarkunreadOutlined');
	
	exports.default = _default;

/***/ },
/* 4050 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-.4 4.25l-6.54 4.09c-.65.41-1.47.41-2.12 0L4.4 8.25c-.25-.16-.4-.43-.4-.72 0-.67.73-1.07 1.3-.72L12 11l6.7-4.19c.57-.35 1.3.05 1.3.72 0 .29-.15.56-.4.72z"
	}), 'MarkunreadRounded');
	
	exports.default = _default;

/***/ },
/* 4051 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 4H2v16h20V4zm-2 4l-8 5-8-5V6l8 5 8-5v2z"
	}), 'MarkunreadSharp');
	
	exports.default = _default;

/***/ },
/* 4052 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 6H4l8 5zM4 8v10h16V8l-8 5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 2l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z"
	})), 'MarkunreadTwoTone');
	
	exports.default = _default;

/***/ },
/* 4053 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 3h18v2H3z"
	}), 'Maximize');
	
	exports.default = _default;

/***/ },
/* 4054 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 3h18v2H3V3z"
	}), 'MaximizeOutlined');
	
	exports.default = _default;

/***/ },
/* 4055 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 3h16c.55 0 1 .45 1 1s-.45 1-1 1H4c-.55 0-1-.45-1-1s.45-1 1-1z"
	}), 'MaximizeRounded');
	
	exports.default = _default;

/***/ },
/* 4056 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 3h18v2H3V3z"
	}), 'MaximizeSharp');
	
	exports.default = _default;

/***/ },
/* 4057 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 3h18v2H3V3z"
	}), 'MaximizeTwoTone');
	
	exports.default = _default;

/***/ },
/* 4058 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6v15H3v-2h2V3h9v1h5v15h2v2h-4V6h-3zm-4 5v2h2v-2h-2z"
	}), 'MeetingRoom');
	
	exports.default = _default;

/***/ },
/* 4059 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 19V4h-4V3H5v16H3v2h12V6h2v15h4v-2h-2zm-6 0H7V5h6v14zm-3-8h2v2h-2z"
	}), 'MeetingRoomOutlined');
	
	exports.default = _default;

/***/ },
/* 4060 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 19h-1V5c0-.55-.45-1-1-1h-4c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v15H4c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1V6h3v14c0 .55.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1zm-8-6h-2v-2h2v2z"
	}), 'MeetingRoomRounded');
	
	exports.default = _default;

/***/ },
/* 4061 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6v15H3v-2h2V3h9v1h5v15h2v2h-4V6h-3zm-4 5v2h2v-2h-2z"
	}), 'MeetingRoomSharp');
	
	exports.default = _default;

/***/ },
/* 4062 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 19h6V5H7v14zm3-8h2v2h-2v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 19V4h-4V3H5v16H3v2h12V6h2v15h4v-2h-2zm-6 0H7V5h6v14zm-3-8h2v2h-2z"
	})), 'MeetingRoomTwoTone');
	
	exports.default = _default;

/***/ },
/* 4063 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z"
	}), 'Memory');
	
	exports.default = _default;

/***/ },
/* 4064 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z"
	}), 'MemoryOutlined');
	
	exports.default = _default;

/***/ },
/* 4065 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 9h-4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 4h-2v-2h2v2zm8-3c0-.55-.45-1-1-1h-1V7c0-1.1-.9-2-2-2h-2V4c0-.55-.45-1-1-1s-1 .45-1 1v1h-2V4c0-.55-.45-1-1-1s-1 .45-1 1v1H7c-1.1 0-2 .9-2 2v2H4c-.55 0-1 .45-1 1s.45 1 1 1h1v2H4c-.55 0-1 .45-1 1s.45 1 1 1h1v2c0 1.1.9 2 2 2h2v1c0 .55.45 1 1 1s1-.45 1-1v-1h2v1c0 .55.45 1 1 1s1-.45 1-1v-1h2c1.1 0 2-.9 2-2v-2h1c.55 0 1-.45 1-1s-.45-1-1-1h-1v-2h1c.55 0 1-.45 1-1zm-5 7H8c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1z"
	}), 'MemoryRounded');
	
	exports.default = _default;

/***/ },
/* 4066 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V5h-4V3h-2v2h-2V3H9v2H5v4H3v2h2v2H3v2h2v4h4v2h2v-2h2v2h2v-2h4v-4h2v-2h-2v-2h2zm-4 6H7V7h10v10z"
	}), 'MemorySharp');
	
	exports.default = _default;

/***/ },
/* 4067 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 17h10V7H7v10zm2-8h6v6H9V9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 11V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10zm-2-8H9v6h6V9zm-2 4h-2v-2h2v2z"
	})), 'MemoryTwoTone');
	
	exports.default = _default;

/***/ },
/* 4068 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
	}), 'Menu');
	
	exports.default = _default;

/***/ },
/* 4069 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"
	}), _react.default.createElement("path", {
	  d: "M17.5 10.5c.88 0 1.73.09 2.5.26V9.24c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99zM13 12.49v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26V11.9c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.3-4.5.83zM17.5 14.33c-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26v-1.52c-.79-.16-1.64-.24-2.5-.24z"
	})), 'MenuBook');
	
	exports.default = _default;

/***/ },
/* 4070 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"
	}), _react.default.createElement("path", {
	  d: "M17.5 10.5c.88 0 1.73.09 2.5.26V9.24c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99zM13 12.49v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26V11.9c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.3-4.5.83zM17.5 14.33c-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26v-1.52c-.79-.16-1.64-.24-2.5-.24z"
	})), 'MenuBookOutlined');
	
	exports.default = _default;

/***/ },
/* 4071 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17.5 4.5c-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5-1.45 0-2.99.22-4.28.79C1.49 5.62 1 6.33 1 7.14v11.28c0 1.3 1.22 2.26 2.48 1.94.98-.25 2.02-.36 3.02-.36 1.56 0 3.22.26 4.56.92.6.3 1.28.3 1.87 0 1.34-.67 3-.92 4.56-.92 1 0 2.04.11 3.02.36 1.26.33 2.48-.63 2.48-1.94V7.14c0-.81-.49-1.52-1.22-1.85-1.28-.57-2.82-.79-4.27-.79zM21 17.23c0 .63-.58 1.09-1.2.98-.75-.14-1.53-.2-2.3-.2-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5.92 0 1.83.09 2.7.28.46.1.8.51.8.98v9.47z"
	}), _react.default.createElement("path", {
	  d: "M13.98 11.01c-.32 0-.61-.2-.71-.52-.13-.39.09-.82.48-.94 1.54-.5 3.53-.66 5.36-.45.41.05.71.42.66.83-.05.41-.42.71-.83.66-1.62-.19-3.39-.04-4.73.39-.08.01-.16.03-.23.03zM13.98 13.67c-.32 0-.61-.2-.71-.52-.13-.39.09-.82.48-.94 1.53-.5 3.53-.66 5.36-.45.41.05.71.42.66.83-.05.41-.42.71-.83.66-1.62-.19-3.39-.04-4.73.39-.08.02-.16.03-.23.03zM13.98 16.33c-.32 0-.61-.2-.71-.52-.13-.39.09-.82.48-.94 1.53-.5 3.53-.66 5.36-.45.41.05.71.42.66.83-.05.41-.42.7-.83.66-1.62-.19-3.39-.04-4.73.39-.08.02-.16.03-.23.03z"
	})), 'MenuBookRounded');
	
	exports.default = _default;

/***/ },
/* 4072 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v15.5C2.45 20.4 4.55 20 6.5 20s4.05.4 5.5 1.5c1.45-1.1 3.55-1.5 5.5-1.5 1.17 0 2.39.15 3.5.5.75.25 1.4.55 2 1V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"
	}), _react.default.createElement("path", {
	  d: "M17.5 10.5c.88 0 1.73.09 2.5.26V9.24c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99zM13 12.49v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26V11.9c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.3-4.5.83zM17.5 14.33c-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26v-1.52c-.79-.16-1.64-.24-2.5-.24z"
	})), 'MenuBookSharp');
	
	exports.default = _default;

/***/ },
/* 4073 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zM3 18.5V7c1.1-.35 2.3-.5 3.5-.5 1.34 0 3.13.41 4.5.99v11.5C9.63 18.41 7.84 18 6.5 18c-1.2 0-2.4.15-3.5.5zm18 0c-1.1-.35-2.3-.5-3.5-.5-1.34 0-3.13.41-4.5.99V7.49c1.37-.59 3.16-.99 4.5-.99 1.2 0 2.4.15 3.5.5v11.5z"
	}), _react.default.createElement("path", {
	  d: "M11 7.49c-1.37-.58-3.16-.99-4.5-.99-1.2 0-2.4.15-3.5.5v11.5c1.1-.35 2.3-.5 3.5-.5 1.34 0 3.13.41 4.5.99V7.49z",
	  opacity: ".3"
	}), _react.default.createElement("g", null, _react.default.createElement("path", {
	  d: "M17.5 10.5c.88 0 1.73.09 2.5.26V9.24c-.79-.15-1.64-.24-2.5-.24-1.28 0-2.46.16-3.5.47v1.57c.99-.35 2.18-.54 3.5-.54zM17.5 13.16c.88 0 1.73.09 2.5.26V11.9c-.79-.15-1.64-.24-2.5-.24-1.28 0-2.46.16-3.5.47v1.57c.99-.34 2.18-.54 3.5-.54zM17.5 15.83c.88 0 1.73.09 2.5.26v-1.52c-.79-.15-1.64-.24-2.5-.24-1.28 0-2.46.16-3.5.47v1.57c.99-.35 2.18-.54 3.5-.54z"
	}))), 'MenuBookTwoTone');
	
	exports.default = _default;

/***/ },
/* 4074 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 18h13v-2H3v2zm0-5h10v-2H3v2zm0-7v2h13V6H3zm18 9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5L21 15.59z"
	}), 'MenuOpen');
	
	exports.default = _default;

/***/ },
/* 4075 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 18h13v-2H3v2zm0-5h10v-2H3v2zm0-7v2h13V6H3zm18 9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5L21 15.59z"
	}), 'MenuOpenOutlined');
	
	exports.default = _default;

/***/ },
/* 4076 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 18h11c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-5h8c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 7c0 .55.45 1 1 1h11c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1zm17.3 7.88L17.42 12l2.88-2.88c.39-.39.39-1.02 0-1.41a.9959.9959 0 00-1.41 0L15.3 11.3c-.39.39-.39 1.02 0 1.41l3.59 3.59c.39.39 1.02.39 1.41 0 .38-.39.39-1.03 0-1.42z"
	}), 'MenuOpenRounded');
	
	exports.default = _default;

/***/ },
/* 4077 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 18h13v-2H3v2zm0-5h10v-2H3v2zm0-7v2h13V6H3zm18 9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5L21 15.59z"
	}), 'MenuOpenSharp');
	
	exports.default = _default;

/***/ },
/* 4078 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 18h13v-2H3v2zm0-5h10v-2H3v2zm0-7v2h13V6H3zm18 9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5L21 15.59z"
	}), 'MenuOpenTwoTone');
	
	exports.default = _default;

/***/ },
/* 4079 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
	}), 'MenuOutlined');
	
	exports.default = _default;

/***/ },
/* 4080 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 18h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z"
	}), 'MenuRounded');
	
	exports.default = _default;

/***/ },
/* 4081 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
	}), 'MenuSharp');
	
	exports.default = _default;

/***/ },
/* 4082 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
	}), 'MenuTwoTone');
	
	exports.default = _default;

/***/ },
/* 4083 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
	}), 'MergeType');
	
	exports.default = _default;

/***/ },
/* 4084 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
	}), 'MergeTypeOutlined');
	
	exports.default = _default;

/***/ },
/* 4085 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.7 19.7c.39-.39.39-1.02 0-1.41l-2.7-2.7L13.59 17l2.7 2.7c.39.39 1.03.39 1.41 0zM8.71 8H11v5.59l-4.71 4.7c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.71-4.7c.38-.38.59-.88.59-1.41V8h2.29c.45 0 .67-.54.35-.85l-3.29-3.29c-.2-.2-.51-.2-.71 0L8.35 7.15c-.31.31-.09.85.36.85z"
	}), 'MergeTypeRounded');
	
	exports.default = _default;

/***/ },
/* 4086 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
	}), 'MergeTypeSharp');
	
	exports.default = _default;

/***/ },
/* 4087 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.59 19L7 20.41l6-6V8h3.5L12 3.5 7.5 8H11v5.59zm11.407 1.41l-3.408-3.407 1.4-1.407 3.41 3.408z"
	}), 'MergeTypeTwoTone');
	
	exports.default = _default;

/***/ },
/* 4088 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
	}), 'Message');
	
	exports.default = _default;

/***/ },
/* 4089 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 4h16v12H5.17L4 17.17V4m0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4zm2 10h12v2H6v-2zm0-3h12v2H6V9zm0-3h12v2H6V6z"
	}), 'MessageOutlined');
	
	exports.default = _default;

/***/ },
/* 4090 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-3 12H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1zm0-3H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1zm0-3H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'MessageRounded');
	
	exports.default = _default;

/***/ },
/* 4091 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H2.01L2 22l4-4h16V2zm-4 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
	}), 'MessageSharp');
	
	exports.default = _default;

/***/ },
/* 4092 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 4H4v13.17L5.17 16H20V4zm-2 10H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 18c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14zm-16-.83V4h16v12H5.17L4 17.17zM6 12h12v2H6zm0-3h12v2H6zm0-3h12v2H6z"
	})), 'MessageTwoTone');
	
	exports.default = _default;

/***/ },
/* 4093 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
	}), 'Mic');
	
	exports.default = _default;

/***/ },
/* 4094 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1.2-9.1c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2-.66 0-1.2-.54-1.2-1.2V4.9zm6.5 6.1c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
	}), 'MicNone');
	
	exports.default = _default;

/***/ },
/* 4095 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V5zm6 6c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"
	}), 'MicNoneOutlined');
	
	exports.default = _default;

/***/ },
/* 4096 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V5zm6.91 6c-.49 0-.9.36-.98.85C16.52 14.2 14.47 16 12 16s-4.52-1.8-4.93-4.15c-.08-.49-.49-.85-.98-.85-.61 0-1.09.54-1 1.14.49 3 2.89 5.35 5.91 5.78V20c0 .55.45 1 1 1s1-.45 1-1v-2.08c3.02-.43 5.42-2.78 5.91-5.78.1-.6-.39-1.14-1-1.14z"
	}), 'MicNoneRounded');
	
	exports.default = _default;

/***/ },
/* 4097 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V5zm6 6c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"
	}), 'MicNoneSharp');
	
	exports.default = _default;

/***/ },
/* 4098 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 12c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V5zm6 6c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"
	})), 'MicNoneTwoTone');
	
	exports.default = _default;

/***/ },
/* 4099 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z"
	}), 'MicOff');
	
	exports.default = _default;

/***/ },
/* 4100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.8 4.9c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2l-.01 3.91L15 10.6V5c0-1.66-1.34-3-3-3-1.54 0-2.79 1.16-2.96 2.65l1.76 1.76V4.9zM19 11h-1.7c0 .58-.1 1.13-.27 1.64l1.27 1.27c.44-.88.7-1.87.7-2.91zM4.41 2.86L3 4.27l6 6V11c0 1.66 1.34 3 3 3 .23 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.55-.9l4.2 4.2 1.41-1.41L4.41 2.86z"
	}), 'MicOffOutlined');
	
	exports.default = _default;

/***/ },
/* 4101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 10.6V5c0-1.66-1.34-3-3-3-1.54 0-2.79 1.16-2.96 2.65L15 10.6zm3.08.4c-.41 0-.77.3-.83.71-.05.32-.12.64-.22.93l1.27 1.27c.3-.6.52-1.25.63-1.94.07-.51-.33-.97-.85-.97zM3.71 3.56c-.39.39-.39 1.02 0 1.41L9 10.27v.43c0 1.19.6 2.32 1.63 2.91.75.43 1.41.44 2.02.31l1.66 1.66c-.71.33-1.5.52-2.31.52-2.54 0-4.88-1.77-5.25-4.39-.06-.41-.42-.71-.83-.71-.52 0-.92.46-.85.97.46 2.96 2.96 5.3 5.93 5.75V20c0 .55.45 1 1 1s1-.45 1-1v-2.28c.91-.13 1.77-.45 2.55-.9l3.49 3.49c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L5.12 3.56a.9959.9959 0 00-1.41 0z"
	}), 'MicOffRounded');
	
	exports.default = _default;

/***/ },
/* 4102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 10.6V5c0-1.66-1.34-3-3-3-1.54 0-2.79 1.16-2.96 2.65L15 10.6zm4 .4h-1.7c0 .58-.1 1.13-.27 1.64l1.27 1.27c.44-.88.7-1.87.7-2.91zM4.41 2.86L3 4.27l6 6V11c0 1.66 1.34 3 3 3 .23 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.55-.9l4.2 4.2 1.41-1.41L4.41 2.86z"
	}), 'MicOffSharp');
	
	exports.default = _default;

/***/ },
/* 4103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 3.7c-.66 0-1.2.54-1.2 1.2v1.51l2.39 2.39.01-3.9c0-.66-.54-1.2-1.2-1.2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 11h-1.7c0 .58-.1 1.13-.27 1.64l1.27 1.27c.44-.88.7-1.87.7-2.91zM4.41 2.86L3 4.27l6 6V11c0 1.66 1.34 3 3 3 .23 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.55-.9l4.2 4.2 1.41-1.41L4.41 2.86zM10.8 4.9c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2l-.01 3.91L15 10.6V5c0-1.66-1.34-3-3-3-1.54 0-2.79 1.16-2.96 2.65l1.76 1.76V4.9z"
	})), 'MicOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 4104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"
	}), _react.default.createElement("path", {
	  d: "M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"
	})), 'MicOutlined');
	
	exports.default = _default;

/***/ },
/* 4105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.91-3c-.49 0-.9.36-.98.85C16.52 14.2 14.47 16 12 16s-4.52-1.8-4.93-4.15c-.08-.49-.49-.85-.98-.85-.61 0-1.09.54-1 1.14.49 3 2.89 5.35 5.91 5.78V20c0 .55.45 1 1 1s1-.45 1-1v-2.08c3.02-.43 5.42-2.78 5.91-5.78.1-.6-.39-1.14-1-1.14z"
	}), 'MicRounded');
	
	exports.default = _default;

/***/ },
/* 4106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"
	}), _react.default.createElement("path", {
	  d: "M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"
	})), 'MicSharp');
	
	exports.default = _default;

/***/ },
/* 4107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 12c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V5z"
	}), _react.default.createElement("path", {
	  d: "M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"
	})), 'MicTwoTone');
	
	exports.default = _default;

/***/ },
/* 4108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 19h12v2H6z"
	}), 'Minimize');
	
	exports.default = _default;

/***/ },
/* 4109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 19h12v2H6v-2z"
	}), 'MinimizeOutlined');
	
	exports.default = _default;

/***/ },
/* 4110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 19h10c.55 0 1 .45 1 1s-.45 1-1 1H7c-.55 0-1-.45-1-1s.45-1 1-1z"
	}), 'MinimizeRounded');
	
	exports.default = _default;

/***/ },
/* 4111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 19h12v2H6v-2z"
	}), 'MinimizeSharp');
	
	exports.default = _default;

/***/ },
/* 4112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 19h12v2H6v-2z"
	}), 'MinimizeTwoTone');
	
	exports.default = _default;

/***/ },
/* 4113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM10 15l-3.89-3.89v2.55H5V9.22h4.44v1.11H6.89l3.11 3.1 4.22-4.22.78.79-5 5z"
	}), 'MissedVideoCall');
	
	exports.default = _default;

/***/ },
/* 4114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zm-2-1.83V16H5V8h10v.67zm-7.89 2.44L11 15l3.77-3.79-.78-.79L11 13.43l-3.11-3.1h2.55V9.22H6v4.44h1.11z"
	}), 'MissedVideoCallOutlined');
	
	exports.default = _default;

/***/ },
/* 4115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l2.29 2.29c.63.63 1.71.18 1.71-.71V8.91c0-.89-1.08-1.34-1.71-.71L17 10.5zm-6.29 3.79c-.39.39-1.02.39-1.41 0l-3.18-3.18v2.55H5V9.72c0-.28.22-.5.5-.5h3.94v1.11H6.89l3.11 3.1 4.22-4.22.78.79-4.29 4.29z"
	}), 'MissedVideoCallRounded');
	
	exports.default = _default;

/***/ },
/* 4116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 10.5V6H3v12h14v-4.5l4 4v-11l-4 4zM10 15l-3.89-3.89v2.55H5V9.22h4.44v1.11H6.89l3.11 3.1 4.22-4.22.78.79-5 5z"
	}), 'MissedVideoCallSharp');
	
	exports.default = _default;

/***/ },
/* 4117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15 13.5V8H5v8h10v-2.5zM11 15l-3.89-3.89v2.55H6V9.22h4.44v1.11H7.89l3.11 3.1 2.99-3.01.78.79L11 15z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 17c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10zm2-9h10v8H5V8zm6 5.43l-3.11-3.1h2.55V9.22H6v4.44h1.11v-2.55L11 15l3.77-3.79-.78-.79z"
	})), 'MissedVideoCallTwoTone');
	
	exports.default = _default;

/***/ },
/* 4118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 14l3.5-4.5 2.5 3.01L14.5 8l4.5 6H5z"
	}), 'Mms');
	
	exports.default = _default;

/***/ },
/* 4119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-5.5-8L11 12.51 8.5 9.5 5 14h14z"
	}), 'MmsOutlined');
	
	exports.default = _default;

/***/ },
/* 4120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5.63 13.19l2.49-3.2c.2-.25.58-.26.78-.01l2.1 2.53 3.1-3.99c.2-.26.6-.26.8.01l3.51 4.68c.25.33.01.8-.4.8H6.02c-.41-.01-.65-.49-.39-.82z"
	}), 'MmsRounded');
	
	exports.default = _default;

/***/ },
/* 4121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H2v20l4-4h16V2zM5 14l3.5-4.5 2.5 3.01L14.5 8l4.5 6H5z"
	}), 'MmsSharp');
	
	exports.default = _default;

/***/ },
/* 4122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 17.17L5.17 16H20V4H4v13.17zM8.5 9.5l2.5 3.01L14.5 8l4.5 6H5l3.5-4.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-5.5-8L11 12.51 8.5 9.5 5 14h14z"
	})), 'MmsTwoTone');
	
	exports.default = _default;

/***/ },
/* 4123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7.01 13.47l-2.55-2.55-1.27 1.27L7 16l7.19-7.19-1.27-1.27z"
	}), 'MobileFriendly');
	
	exports.default = _default;

/***/ },
/* 4124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7.01 13.47l-2.55-2.55-1.27 1.27L7 16l7.19-7.19-1.27-1.27-5.91 5.93z"
	}), 'MobileFriendlyOutlined');
	
	exports.default = _default;

/***/ },
/* 4125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 1H9c-1.1 0-2 .9-2 2v2c0 .55.45 1 1 1s1-.45 1-1V4h10v16H9v-1c0-.55-.45-1-1-1s-1 .45-1 1v2c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7.01 13.47l-1.92-1.92c-.35-.35-.92-.35-1.27 0s-.35.92 0 1.27l2.47 2.47c.39.39 1.02.39 1.41 0l5.85-5.85c.35-.35.35-.92 0-1.27s-.92-.35-1.27 0l-5.27 5.3z"
	}), 'MobileFriendlyRounded');
	
	exports.default = _default;

/***/ },
/* 4126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 1H7v5h2V4h10v16H9v-2H7v5h14V1zM7.01 13.47l-2.55-2.55-1.27 1.27L7 16l7.19-7.19-1.27-1.27-5.91 5.93z"
	}), 'MobileFriendlySharp');
	
	exports.default = _default;

/***/ },
/* 4127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7.01 13.47l-2.55-2.55-1.27 1.27L7 16l7.19-7.19-1.27-1.27-5.91 5.93z"
	}), 'MobileFriendlyTwoTone');
	
	exports.default = _default;

/***/ },
/* 4128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.76 2.49L1.49 3.76 5 7.27V21c0 1.1.9 2 2 2h10c1.02 0 1.85-.77 1.98-1.75l1.72 1.72 1.27-1.27L2.76 2.49zM7 19V9.27L16.73 19H7zM17 5v9.17l2 2V3c0-1.1-.9-2-2-2H7c-.85 0-1.58.54-1.87 1.3L7.83 5H17z"
	}), 'MobileOff');
	
	exports.default = _default;

/***/ },
/* 4129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 5v8.61l2 2V3c0-1.1-.9-2-2-2H7c-.71 0-1.33.37-1.68.93L8.39 5H17zM1.49 3.76L5 7.27V21c0 1.1.9 2 2 2h10c1.02 0 1.85-.77 1.98-1.75l1.72 1.72 1.41-1.41L2.9 2.35 1.49 3.76zM7 9.27L16.73 19H7V9.27z"
	}), 'MobileOffOutlined');
	
	exports.default = _default;

/***/ },
/* 4130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 16.44L3.61 3.05a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L5 7.27V21c0 1.1.9 2 2 2h10c1.02 0 1.85-.77 1.98-1.75L20 22.27c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L19 18.44l-2-2zM7 19V9.27L16.73 19H7zM17 5v8.61l2 2V3c0-1.1-.9-2-2-2H7c-.71 0-1.33.37-1.68.93L8.39 5H17z"
	}), 'MobileOffRounded');
	
	exports.default = _default;

/***/ },
/* 4131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 5v8.61l2 2V1H5v.61L8.39 5zM2.9 2.35L1.49 3.76 5 7.27V23h14v-1.73l1.7 1.7 1.41-1.41L2.9 2.35zM7 19V9.27L16.73 19H7z"
	}), 'MobileOffSharp');
	
	exports.default = _default;

/***/ },
/* 4132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 5v8.61l2 2V3c0-1.1-.9-2-2-2H7c-.71 0-1.33.37-1.68.93L8.39 5H17zM1.49 3.76L5 7.27V21c0 1.1.9 2 2 2h10c1.02 0 1.85-.77 1.98-1.75l1.72 1.72 1.41-1.41L2.9 2.35 1.49 3.76zM7 9.27L16.73 19H7V9.27z"
	}), 'MobileOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 4133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-4.2-5.78v1.75l3.2-2.99L12.8 9v1.7c-3.11.43-4.35 2.56-4.8 4.7 1.11-1.5 2.58-2.18 4.8-2.18z"
	}), 'MobileScreenShare');
	
	exports.default = _default;

/***/ },
/* 4134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 1H7c-1.1 0-1.99.85-1.99 1.95v18C5.01 22.05 5.9 23 7 23h10c1.1 0 2-.95 2-2.05v-18C19 1.85 18.1 1 17 1zm0 18H7V5h10v14zm-4.2-5.76v1.75L16 12l-3.2-2.98v1.7c-3.11.43-4.35 2.56-4.8 4.7 1.11-1.5 2.58-2.18 4.8-2.18z"
	}), 'MobileScreenShareOutlined');
	
	exports.default = _default;

/***/ },
/* 4135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 1H7c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14zm-4.2-5.78v1.75l2.81-2.62c.21-.2.21-.53 0-.73L12.8 9v1.7c-3.11.43-4.35 2.56-4.8 4.7 1.11-1.5 2.58-2.18 4.8-2.18z"
	}), 'MobileScreenShareRounded');
	
	exports.default = _default;

/***/ },
/* 4136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.01 1v22H19V1H5.01zM17 19H7V5h10v14zm-4.2-5.76v1.75L16 12l-3.2-2.98v1.7c-3.11.43-4.35 2.56-4.8 4.7 1.11-1.5 2.58-2.18 4.8-2.18z"
	}), 'MobileScreenShareSharp');
	
	exports.default = _default;

/***/ },
/* 4137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 19h10V5H7v14zm5.8-8.28v-1.7L16 12l-3.2 2.99v-1.75c-2.22 0-3.69.68-4.8 2.18.45-2.14 1.69-4.27 4.8-4.7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 1H7c-1.1 0-1.99.85-1.99 1.95v18C5.01 22.05 5.9 23 7 23h10c1.1 0 2-.95 2-2.05V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14zm-4.2-5.76v1.75L16 12l-3.2-2.98v1.7c-3.11.43-4.35 2.56-4.8 4.7 1.11-1.5 2.58-2.18 4.8-2.18z"
	})), 'MobileScreenShareTwoTone');
	
	exports.default = _default;

/***/ },
/* 4138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z"
	}), 'ModeComment');
	
	exports.default = _default;

/***/ },
/* 4139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 17.17L18.83 16H4V4h16v13.17zM20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2z"
	}), 'ModeCommentOutlined');
	
	exports.default = _default;

/***/ },
/* 4140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4z"
	}), 'ModeCommentRounded');
	
	exports.default = _default;

/***/ },
/* 4141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H2v16h16l4 4z"
	}), 'ModeCommentSharp');
	
	exports.default = _default;

/***/ },
/* 4142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm0 15.17L18.83 16H4V4h16v13.17z"
	}), _react.default.createElement("path", {
	  d: "M4 4v12h14.83L20 17.17V4z",
	  opacity: ".3"
	})), 'ModeCommentTwoTone');
	
	exports.default = _default;

/***/ },
/* 4143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"
	}), 'MonetizationOn');
	
	exports.default = _default;

/***/ },
/* 4144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.73-2.77-.01-2.2-1.9-2.96-3.66-3.42z"
	}), 'MonetizationOnOutlined');
	
	exports.default = _default;

/***/ },
/* 4145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09v.58c0 .73-.6 1.33-1.33 1.33h-.01c-.73 0-1.33-.6-1.33-1.33v-.6c-1.33-.28-2.51-1.01-3.01-2.24-.23-.55.2-1.16.8-1.16h.24c.37 0 .67.25.81.6.29.75 1.05 1.27 2.51 1.27 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21v-.6c0-.73.6-1.33 1.33-1.33h.01c.73 0 1.33.6 1.33 1.33v.62c1.38.34 2.25 1.2 2.63 2.26.2.55-.22 1.13-.81 1.13h-.26c-.37 0-.67-.26-.77-.62-.23-.76-.86-1.25-2.12-1.25-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.02 1.83-1.39 2.83-3.13 3.16z"
	}), 'MonetizationOnRounded');
	
	exports.default = _default;

/***/ },
/* 4146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"
	}), 'MonetizationOnSharp');
	
	exports.default = _default;

/***/ },
/* 4147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm1.23 13.33V19H10.9v-1.69c-1.5-.31-2.77-1.28-2.86-2.97h1.71c.09.92.72 1.64 2.32 1.64 1.71 0 2.1-.86 2.1-1.39 0-.73-.39-1.41-2.34-1.87-2.17-.53-3.66-1.42-3.66-3.21 0-1.51 1.22-2.48 2.72-2.81V5h2.34v1.71c1.63.39 2.44 1.63 2.49 2.97h-1.71c-.04-.97-.56-1.64-1.94-1.64-1.31 0-2.1.59-2.1 1.43 0 .73.57 1.22 2.34 1.67 1.77.46 3.66 1.22 3.66 3.42-.01 1.6-1.21 2.48-2.74 2.77z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.73-2.77-.01-2.2-1.9-2.96-3.66-3.42z"
	})), 'MonetizationOnTwoTone');
	
	exports.default = _default;

/***/ },
/* 4148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 8h2v8H5zm7 0H9c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 6h-1v-4h1v4zm7-6h-3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 6h-1v-4h1v4z"
	}), _react.default.createElement("path", {
	  d: "M2 4v16h20V4H2zm2 14V6h16v12H4z"
	})), 'Money');
	
	exports.default = _default;

/***/ },
/* 4149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.53.12-1.03.3-1.48.54l1.47 1.47c.41-.17.91-.27 1.51-.27zM5.33 4.06L4.06 5.33 7.5 8.77c0 2.08 1.56 3.21 3.91 3.91l3.51 3.51c-.34.48-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.82-.55 2.45-1.12l2.22 2.22 1.27-1.27L5.33 4.06z"
	}), 'MoneyOff');
	
	exports.default = _default;

/***/ },
/* 4150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.39.08-.75.21-1.1.36l1.51 1.51c.32-.08.69-.13 1.09-.13zM5.47 3.92L4.06 5.33 7.5 8.77c0 2.08 1.56 3.22 3.91 3.91l3.51 3.51c-.34.49-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.83-.55 2.46-1.12l2.22 2.22 1.41-1.41L5.47 3.92z"
	}), 'MoneyOffOutlined');
	
	exports.default = _default;

/***/ },
/* 4151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.5 6.9c1.42 0 2.13.54 2.39 1.4.13.43.56.7 1.01.7h.06c.7 0 1.22-.71.97-1.36-.44-1.15-1.41-2.08-2.93-2.45V4.5c0-.83-.67-1.5-1.5-1.5S11 3.67 11 4.5v.66c-.39.08-.75.21-1.1.36l1.51 1.51c.32-.08.69-.13 1.09-.13zM4.77 4.62c-.39.39-.39 1.02 0 1.41L7.5 8.77c0 2.08 1.56 3.22 3.91 3.91l3.51 3.51c-.34.49-1.05.91-2.42.91-1.65 0-2.5-.59-2.83-1.43-.15-.39-.49-.67-.9-.67H8.6c-.72 0-1.24.74-.95 1.39.59 1.33 1.89 2.12 3.36 2.44v.67c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-.65c.96-.18 1.83-.55 2.46-1.12l1.51 1.51c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L6.18 4.62a.9959.9959 0 00-1.41 0z"
	}), 'MoneyOffRounded');
	
	exports.default = _default;

/***/ },
/* 4152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.39.08-.75.21-1.1.36l1.51 1.51c.32-.08.69-.13 1.09-.13zM5.47 3.92L4.06 5.33 7.5 8.77c0 2.08 1.56 3.22 3.91 3.91l3.51 3.51c-.34.49-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.83-.55 2.46-1.12l2.22 2.22 1.41-1.41L5.47 3.92z"
	}), 'MoneyOffSharp');
	
	exports.default = _default;

/***/ },
/* 4153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.39.08-.75.21-1.1.36l1.51 1.51c.32-.08.69-.13 1.09-.13zM5.47 3.92L4.06 5.33 7.5 8.77c0 2.08 1.56 3.22 3.91 3.91l3.51 3.51c-.34.49-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.83-.55 2.46-1.12l2.22 2.22 1.41-1.41L5.47 3.92z"
	}), 'MoneyOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 4154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 16h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1zm1-6h1v4h-1v-4zm-7 6h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1zm1-6h1v4h-1v-4zM5 8h2v8H5zM2 4v16h20V4H2zm18 14H4V6h16v12z"
	}), 'MoneyOutlined');
	
	exports.default = _default;

/***/ },
/* 4155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 16h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1zm1-6h1v4h-1v-4zm-7 6h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1zm1-6h1v4h-1v-4zM6 8c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1s1-.45 1-1V9c0-.55-.45-1-1-1zM2 6v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2zm17 12H5c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1z"
	}), 'MoneyRounded');
	
	exports.default = _default;

/***/ },
/* 4156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 16h5V8h-5v8zm2-6h1v4h-1v-4zm-8 6h5V8H8v8zm2-6h1v4h-1v-4zM5 8h2v8H5zM2 4v16h20V4H2zm18 14H4V6h16v12z"
	}), 'MoneySharp');
	
	exports.default = _default;

/***/ },
/* 4157 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M10 10h1v4h-1zm6 0h1v4h-1zM4 18h16V6H4v12zm10-9c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1V9zM8 9c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1V9zM5 8h2v8H5V8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M15 16h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1zm1-6h1v4h-1v-4zm-7 6h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1zm1-6h1v4h-1v-4zM5 8h2v8H5zM2 4v16h20V4H2zm18 14H4V6h16v12z"
	})), 'MoneyTwoTone');
	
	exports.default = _default;

/***/ },
/* 4158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 5h-3.2L15 3H9L7.2 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h8v12zm-3-6c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5zm-8.2 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z"
	}), 'MonochromePhotos');
	
	exports.default = _default;

/***/ },
/* 4159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 5h-3.2L15 3H9L7.2 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h8v12zm-3-6c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5zm-8.2 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z"
	}), 'MonochromePhotosOutlined');
	
	exports.default = _default;

/***/ },
/* 4160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 5h-3.2l-1.2-1.34c-.38-.42-.92-.66-1.49-.66H9.89c-.57 0-1.11.24-1.49.66L7.2 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 13c0 .55-.45 1-1 1h-7v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h7c.55 0 1 .45 1 1v10zm-3-5c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5zm-8.2 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z"
	}), 'MonochromePhotosRounded');
	
	exports.default = _default;

/***/ },
/* 4161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 5h-5.2L15 3H9L7.2 5H2v16h20V5zm-2 14h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h8v12zm-3-6c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5zm-8.2 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z"
	}), 'MonochromePhotosSharp');
	
	exports.default = _default;

/***/ },
/* 4162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 18v-1.8c-1.8 0-3.2-1.4-3.2-3.2s1.4-3.2 3.2-3.2V8c-2.8 0-5 2.2-5 5s2.2 5 5 5zm5-5c0 2.8-2.2 5-5 5v1h8V7h-8v1c2.8 0 5 2.2 5 5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 21h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-3.2L15 3H9L7.2 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2zm8-13V7h8v12h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5zm3.2 5c0 1.8-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5s-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2zm-6.4 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z"
	})), 'MonochromePhotosTwoTone');
	
	exports.default = _default;

/***/ },
/* 4163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
	}), 'Mood');
	
	exports.default = _default;

/***/ },
/* 4164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 3c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z"
	}), 'MoodBad');
	
	exports.default = _default;

/***/ },
/* 4165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 2.5c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z"
	}), 'MoodBadOutlined');
	
	exports.default = _default;

/***/ },
/* 4166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 2.5c-2.03 0-3.8 1.11-4.75 2.75-.19.33.06.75.44.75h8.62c.38 0 .63-.42.44-.75-.95-1.64-2.72-2.75-4.75-2.75z"
	}), 'MoodBadRounded');
	
	exports.default = _default;

/***/ },
/* 4167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 2.5c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z"
	}), 'MoodBadSharp');
	
	exports.default = _default;

/***/ },
/* 4168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3.5 4c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-7 0c.83 0 1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5 7.67 8 8.5 8zm-1.61 9c.8-2.04 2.78-3.5 5.11-3.5s4.31 1.46 5.11 3.5H6.89z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6.5c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z"
	}), _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	})), 'MoodBadTwoTone');
	
	exports.default = _default;

/***/ },
/* 4169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
	}), 'MoodOutlined');
	
	exports.default = _default;

/***/ },
/* 4170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.03 0 3.8-1.11 4.75-2.75.19-.33-.05-.75-.44-.75H7.69c-.38 0-.63.42-.44.75.95 1.64 2.72 2.75 4.75 2.75z"
	}), 'MoodRounded');
	
	exports.default = _default;

/***/ },
/* 4171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
	}), 'MoodSharp');
	
	exports.default = _default;

/***/ },
/* 4172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3.5 4c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-7 0c.83 0 1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5 7.67 8 8.5 8zm3.5 9.5c-2.33 0-4.31-1.46-5.11-3.5h10.22c-.8 2.04-2.78 3.5-5.11 3.5z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
	})), 'MoodTwoTone');
	
	exports.default = _default;

/***/ },
/* 4173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.97.89 1.66.89H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'More');
	
	exports.default = _default;

/***/ },
/* 4174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'MoreHoriz');
	
	exports.default = _default;

/***/ },
/* 4175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'MoreHorizOutlined');
	
	exports.default = _default;

/***/ },
/* 4176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'MoreHorizRounded');
	
	exports.default = _default;

/***/ },
/* 4177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'MoreHorizSharp');
	
	exports.default = _default;

/***/ },
/* 4178 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'MoreHorizTwoTone');
	
	exports.default = _default;

/***/ },
/* 4179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.97.89 1.66.89H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7.07L2.4 12l4.66-7H22v14z"
	}), _react.default.createElement("circle", {
	  cx: "9",
	  cy: "12",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "14",
	  cy: "12",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "19",
	  cy: "12",
	  r: "1.5"
	})), 'MoreOutlined');
	
	exports.default = _default;

/***/ },
/* 4180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 3H7c-.69 0-1.23.35-1.59.88L.37 11.45c-.22.34-.22.77 0 1.11l5.04 7.56c.36.52.97.88 1.66.88H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'MoreRounded');
	
	exports.default = _default;

/***/ },
/* 4181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M24 3H6l-6 9 6 9h18V3zM9 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'MoreSharp');
	
	exports.default = _default;

/***/ },
/* 4182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7.06 5L2.4 12l4.67 7H22V5H7.06c.01 0 .01 0 0 0zM19 10.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-5 0c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-5 0c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.97.89 1.66.89H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7.07L2.4 12l4.66-7H22v14z"
	}), _react.default.createElement("circle", {
	  cx: "9",
	  cy: "12",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "14",
	  cy: "12",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "19",
	  cy: "12",
	  r: "1.5"
	})), 'MoreTwoTone');
	
	exports.default = _default;

/***/ },
/* 4183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'MoreVert');
	
	exports.default = _default;

/***/ },
/* 4184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'MoreVertOutlined');
	
	exports.default = _default;

/***/ },
/* 4185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'MoreVertRounded');
	
	exports.default = _default;

/***/ },
/* 4186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'MoreVertSharp');
	
	exports.default = _default;

/***/ },
/* 4187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'MoreVertTwoTone');
	
	exports.default = _default;

/***/ },
/* 4188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.5 10c-.03 0-.05.01-.08.01L13.41 6H9v2h3.59l2 2h-8.1C4.01 10 2 12.02 2 14.5 2 16.99 4.01 19 6.5 19c2.22 0 4.06-1.62 4.42-3.73L13.04 14c-.02.17-.04.33-.04.5 0 2.49 2.01 4.5 4.5 4.5s4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm-8.66 5.26C8.52 16.27 7.58 17 6.47 17c-1.38 0-2.5-1.12-2.5-2.5S5.09 12 6.47 12c1.12 0 2.05.74 2.37 1.75H6v1.5l2.84.01zM17.47 17c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
	}), 'Motorcycle');
	
	exports.default = _default;

/***/ },
/* 4189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.72 11l-2 2h-.77l-.25-.69c-.18-.48-.42-.92-.72-1.31h3.74m2.69-6H11v2h3.59l2 2H5c-2.8 0-5 2.2-5 5s2.2 5 5 5c2.46 0 4.45-1.69 4.9-4h1.65l2.77-2.77c-.21.54-.32 1.14-.32 1.77 0 2.8 2.2 5 5 5s5-2.2 5-5c0-2.65-1.97-4.77-4.56-4.97L15.41 5zM19 17c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zM5 17c-1.63 0-3-1.37-3-3s1.37-3 3-3c1.28 0 2.4.85 2.82 2H5v2h2.82C7.4 16.15 6.28 17 5 17z"
	}), 'MotorcycleOutlined');
	
	exports.default = _default;

/***/ },
/* 4190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.44 9.03L17.31 6.9l-1.6-1.6c-.19-.19-.45-.3-.71-.3h-3c-.55 0-1 .45-1 1s.45 1 1 1h2.59l2 2H5c-2.8 0-5 2.2-5 5s2.2 5 5 5c2.46 0 4.45-1.69 4.9-4h.82c.53 0 1.04-.21 1.41-.59l2.18-2.18c-.2.54-.31 1.14-.31 1.77 0 2.8 2.2 5 5 5s5-2.2 5-5c0-2.65-1.97-4.77-4.56-4.97zM5 15h2.82C7.4 16.15 6.28 17 5 17c-1.63 0-3-1.37-3-3s1.37-3 3-3c1.28 0 2.4.85 2.82 2H5c-.55 0-1 .45-1 1s.45 1 1 1zm14 2c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
	}), 'MotorcycleRounded');
	
	exports.default = _default;

/***/ },
/* 4191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.44 9.03L15.41 5H11v2h3.59l2 2H5c-2.8 0-5 2.2-5 5s2.2 5 5 5c2.46 0 4.45-1.69 4.9-4h1.65l2.77-2.77c-.21.54-.32 1.14-.32 1.77 0 2.8 2.2 5 5 5s5-2.2 5-5c0-2.65-1.97-4.77-4.56-4.97zM7.82 15C7.4 16.15 6.28 17 5 17c-1.63 0-3-1.37-3-3s1.37-3 3-3c1.28 0 2.4.85 2.82 2H5v2h2.82zM19 17c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
	}), 'MotorcycleSharp');
	
	exports.default = _default;

/***/ },
/* 4192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9.7 12.31l.25.69h.77l2-2H8.98c.3.39.54.83.72 1.31z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19.44 9.03L15.41 5H11v2h3.59l2 2H5c-2.8 0-5 2.2-5 5s2.2 5 5 5c2.46 0 4.45-1.69 4.9-4h1.65l2.77-2.77c-.21.54-.32 1.14-.32 1.77 0 2.8 2.2 5 5 5s5-2.2 5-5c0-2.65-1.97-4.77-4.56-4.97zM7.82 15C7.4 16.15 6.28 17 5 17c-1.63 0-3-1.37-3-3s1.37-3 3-3c1.28 0 2.4.85 2.82 2H5v2h2.82zm2.9-2h-.77l-.25-.69c-.18-.48-.42-.92-.72-1.31h3.74l-2 2zM19 17c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
	})), 'MotorcycleTwoTone');
	
	exports.default = _default;

/***/ },
/* 4193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 1.07V9h7c0-4.08-3.05-7.44-7-7.93zM4 15c0 4.42 3.58 8 8 8s8-3.58 8-8v-4H4v4zm7-13.93C7.05 1.56 4 4.92 4 9h7V1.07z"
	}), 'Mouse');
	
	exports.default = _default;

/***/ },
/* 4194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 9c-.04-4.39-3.6-7.93-8-7.93S4.04 4.61 4 9v6c0 4.42 3.58 8 8 8s8-3.58 8-8V9zm-2 0h-5V3.16c2.81.47 4.96 2.9 5 5.84zm-7-5.84V9H6c.04-2.94 2.19-5.37 5-5.84zM18 15c0 3.31-2.69 6-6 6s-6-2.69-6-6v-4h12v4z"
	}), 'MouseOutlined');
	
	exports.default = _default;

/***/ },
/* 4195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 1.07V9h7c0-4.08-3.05-7.44-7-7.93zM4 15c0 4.42 3.58 8 8 8s8-3.58 8-8v-4H4v4zm7-13.93C7.05 1.56 4 4.92 4 9h7V1.07z"
	}), 'MouseRounded');
	
	exports.default = _default;

/***/ },
/* 4196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 1.07V9h7c0-4.08-3.05-7.44-7-7.93zM4 15c0 4.42 3.58 8 8 8s8-3.58 8-8v-4H4v4zm7-13.93C7.05 1.56 4 4.92 4 9h7V1.07z"
	}), 'MouseSharp');
	
	exports.default = _default;

/***/ },
/* 4197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M13 3.16V9h5c-.04-2.94-2.19-5.37-5-5.84zm-2 0C8.19 3.63 6.04 6.06 6 9h5V3.16zM11 11H6v4c0 3.31 2.69 6 6 6s6-2.69 6-6v-4h-7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 9c-.04-4.39-3.6-7.93-8-7.93S4.04 4.61 4 9v6c0 4.42 3.58 8 8 8s8-3.58 8-8V9zm-7-5.84c2.81.47 4.96 2.9 5 5.84h-5V3.16zm-2 0V9H6c.04-2.94 2.19-5.37 5-5.84zM18 15c0 3.31-2.69 6-6 6s-6-2.69-6-6v-4h12v4z"
	})), 'MouseTwoTone');
	
	exports.default = _default;

/***/ },
/* 4198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z"
	}), 'MoveToInbox');
	
	exports.default = _default;

/***/ },
/* 4199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 9h-2.55V6h-2.9v3H8l4 4zm3-6H4.99C3.88 3 3 3.9 3 5v14c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5v-3h3.56c.69 1.19 1.97 2 3.45 2s2.75-.81 3.45-2H19v3zm0-5h-4.99c0 1.1-.9 2-2 2s-2-.9-2-2H5l-.01-9H19v9z"
	}), 'MoveToInboxOutlined');
	
	exports.default = _default;

/***/ },
/* 4200 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H4.99C3.88 3 3 3.9 3 5v14c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-3.13c-.47 0-.85.34-.98.8-.35 1.27-1.52 2.2-2.89 2.2s-2.54-.93-2.89-2.2c-.13-.46-.51-.8-.98-.8H4.99V6c0-.55.45-1 1-1H18c.55 0 1 .45 1 1v9zm-3-5h-2V7h-4v3H8l3.65 3.65c.2.2.51.2.71 0L16 10z"
	}), 'MoveToInboxRounded');
	
	exports.default = _default;

/***/ },
/* 4201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zm-2 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z"
	}), 'MoveToInboxSharp');
	
	exports.default = _default;

/***/ },
/* 4202 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12.01 18c-1.48 0-2.75-.81-3.45-2H5v3h14v-3h-3.55c-.69 1.19-1.97 2-3.44 2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16 9h-2.55V6h-2.9v3H8l4 4zm3-6H4.99C3.88 3 3 3.9 3 5v14c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5v-3h3.56c.69 1.19 1.97 2 3.45 2s2.75-.81 3.45-2H19v3zm0-5h-4.99c0 1.1-.9 2-2 2s-2-.9-2-2H5l-.01-9H19v9z"
	})), 'MoveToInboxTwoTone');
	
	exports.default = _default;

/***/ },
/* 4203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"
	}), 'Movie');
	
	exports.default = _default;

/***/ },
/* 4204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"
	}), 'MovieCreation');
	
	exports.default = _default;

/***/ },
/* 4205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.76 10H20v8H4V6.47M22 4h-4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4z"
	}), 'MovieCreationOutlined');
	
	exports.default = _default;

/***/ },
/* 4206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4l1.82 3.64c.08.16-.04.36-.22.36h-1.98c-.38 0-.73-.21-.89-.55L15 4h-2l1.82 3.64c.08.16-.04.36-.22.36h-1.98c-.38 0-.73-.21-.89-.55L10 4H8l1.82 3.64c.08.16-.04.36-.22.36H7.62c-.38 0-.73-.21-.9-.55L5 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-.55-.45-1-1-1h-3z"
	}), 'MovieCreationRounded');
	
	exports.default = _default;

/***/ },
/* 4207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"
	}), 'MovieCreationSharp');
	
	exports.default = _default;

/***/ },
/* 4208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 6.47V18h16v-8H5.76z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4zm2 14H4V6.47L5.76 10H20v8z"
	})), 'MovieCreationTwoTone');
	
	exports.default = _default;

/***/ },
/* 4209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4l2 3h-3l-2-3h-2l2 3h-3l-2-3H8l2 3H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4zm-6.75 11.25L10 18l-1.25-2.75L6 14l2.75-1.25L10 10l1.25 2.75L14 14l-2.75 1.25zm5.69-3.31L16 14l-.94-2.06L13 11l2.06-.94L16 8l.94 2.06L19 11l-2.06.94z"
	}), 'MovieFilter');
	
	exports.default = _default;

/***/ },
/* 4210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 11l-.94 2.06L7 14l2.06.94L10 17l.94-2.06L13 14l-2.06-.94zm8.01-7l2 4h-3l-2-4h-2l2 4h-3l-2-4h-2l2 4h-3l-2-4h-1c-1.1 0-1.99.9-1.99 2l-.01 12c0 1.1.9 2 2 2h16c1.1 0 1.99-.9 1.99-2V4h-3.99zm2 14h-16V6.47L5.77 10H16l-.63 1.37L14 12l1.37.63L16 14l.63-1.37L18 12l-1.37-.63L16 10h4.01v8z"
	}), 'MovieFilterOutlined');
	
	exports.default = _default;

/***/ },
/* 4211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.5 4H18l1.74 2.61c.11.17-.01.39-.21.39h-2c-.33 0-.65-.17-.83-.45L15 4h-2l1.74 2.61c.11.17-.01.39-.21.39h-2c-.33 0-.65-.17-.83-.45L10 4H8l1.74 2.61c.11.17-.01.39-.21.39h-2c-.33 0-.64-.17-.83-.45L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4.5c0-.28-.22-.5-.5-.5zM11.25 15.25L10 18l-1.25-2.75L6 14l2.75-1.25L10 10l1.25 2.75L14 14l-2.75 1.25zm5.69-3.31L16 14l-.94-2.06L13 11l2.06-.94L16 8l.94 2.06L19 11l-2.06.94z"
	}), 'MovieFilterRounded');
	
	exports.default = _default;

/***/ },
/* 4212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4l2 3h-3l-2-3h-2l2 3h-3l-2-3H8l2 3H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4zm-6.75 11.25L10 18l-1.25-2.75L6 14l2.75-1.25L10 10l1.25 2.75L14 14l-2.75 1.25zm5.69-3.31L16 14l-.94-2.06L13 11l2.06-.94L16 8l.94 2.06L19 11l-2.06.94z"
	}), 'MovieFilterSharp');
	
	exports.default = _default;

/***/ },
/* 4213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16.63 11.37L18 12l-1.37.63L16 14l-.63-1.37L14 12l1.37-.63L16 10H5.77L4.01 6.47V18h16v-8H16l.63 1.37zm-5.69 3.57L10 17l-.94-2.06L7 14l2.06-.94L10 11l.94 2.06L13 14l-2.06.94z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M10 11l-.94 2.06L7 14l2.06.94L10 17l.94-2.06L13 14l-2.06-.94zm8.01-7l2 4h-3l-2-4h-2l2 4h-3l-2-4h-2l2 4h-3l-2-4h-1c-1.1 0-1.99.9-1.99 2l-.01 12c0 1.1.9 2 2 2h16c1.1 0 1.99-.9 1.99-2V4h-3.99zm2 14h-16V6.47L5.77 10H16l-.63 1.37L14 12l1.37.63L16 14l.63-1.37L18 12l-1.37-.63L16 10h4.01v8z"
	})), 'MovieFilterTwoTone');
	
	exports.default = _default;

/***/ },
/* 4214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6.47L5.76 10H20v8H4V6.47M22 4h-4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4z"
	}), 'MovieOutlined');
	
	exports.default = _default;

/***/ },
/* 4215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4l1.82 3.64c.08.16-.04.36-.22.36h-1.98c-.38 0-.73-.21-.89-.55L15 4h-2l1.82 3.64c.08.16-.04.36-.22.36h-1.98c-.38 0-.73-.21-.89-.55L10 4H8l1.82 3.64c.08.16-.04.36-.22.36H7.62c-.38 0-.73-.21-.9-.55L5 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-.55-.45-1-1-1h-3z"
	}), 'MovieRounded');
	
	exports.default = _default;

/***/ },
/* 4216 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"
	}), 'MovieSharp');
	
	exports.default = _default;

/***/ },
/* 4217 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 10H5.76L4 6.47V18h16z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M2.01 6L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2zM4 6.47L5.76 10H20v8H4V6.47z"
	})), 'MovieTwoTone');
	
	exports.default = _default;

/***/ },
/* 4218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6.92l-1.41-1.41-2.85 3.21C15.68 6.4 12.83 5 9.61 5 6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-4-4L2 16.99l1.5 1.5 6-6.01 4 4 4.05-4.55c.75 1.35 1.25 2.9 1.44 4.55H21c-.22-2.3-.95-4.39-2.04-6.14L22 6.92z"
	}), 'MultilineChart');
	
	exports.default = _default;

/***/ },
/* 4219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6.92l-1.41-1.41-2.85 3.21C15.68 6.4 12.83 5 9.61 5 6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-4-4L2 16.99l1.5 1.5 6-6.01 4 4 4.05-4.55c.75 1.35 1.25 2.9 1.44 4.55H21c-.22-2.3-.95-4.39-2.04-6.14L22 6.92z"
	}), 'MultilineChartOutlined');
	
	exports.default = _default;

/***/ },
/* 4220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.36 6.28l-.06-.06c-.39-.39-1.03-.37-1.39.04l-2.18 2.45C15.68 6.4 12.83 5 9.61 5c-2.5 0-4.83.87-6.75 2.3-.47.35-.52 1.04-.11 1.45l.06.06c.33.33.86.39 1.23.11C5.63 7.72 7.54 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-3.29-3.29a.9959.9959 0 00-1.41 0l-6.12 6.13c-.37.37-.37.98 0 1.35l.15.15c.37.37.98.37 1.35 0l5.32-5.33 3.25 3.25c.41.41 1.07.39 1.45-.04l3.35-3.76c.62 1.12 1.08 2.39 1.32 3.73.08.47.47.82.95.82h.09c.6 0 1.05-.55.94-1.14-.32-1.85-.98-3.54-1.89-5L21.4 7.6c.34-.38.32-.96-.04-1.32z"
	}), 'MultilineChartRounded');
	
	exports.default = _default;

/***/ },
/* 4221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6.92l-1.41-1.41-2.85 3.21C15.68 6.4 12.83 5 9.61 5 6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-4-4L2 16.99l1.5 1.5 6-6.01 4 4 4.05-4.55c.75 1.35 1.25 2.9 1.44 4.55H21c-.22-2.3-.95-4.39-2.04-6.14L22 6.92z"
	}), 'MultilineChartSharp');
	
	exports.default = _default;

/***/ },
/* 4222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6.92l-1.41-1.41-2.85 3.21C15.68 6.4 12.83 5 9.61 5 6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-4-4L2 16.99l1.5 1.5 6-6.01 4 4 4.05-4.55c.75 1.35 1.25 2.9 1.44 4.55H21c-.22-2.3-.95-4.39-2.04-6.14L22 6.92z"
	}), 'MultilineChartTwoTone');
	
	exports.default = _default;

/***/ },
/* 4223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 11V9L12 2 2 9v2h2v9H2v2h20v-2h-2v-9h2zm-6 7h-2v-4l-2 3-2-3v4H8v-7h2l2 3 2-3h2v7z"
	}), 'Museum');
	
	exports.default = _default;

/***/ },
/* 4224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M22 11V9L12 2 2 9v2h2v9H2v2h20v-2h-2v-9h2zm-4 9H6V9h12v11z"
	}), _react.default.createElement("path", {
	  d: "M10 14l2 3 2-3v4h2v-7h-2l-2 3-2-3H8v7h2z"
	})), 'MuseumOutlined');
	
	exports.default = _default;

/***/ },
/* 4225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.5 11c.28 0 .5-.22.5-.5V9.26c0-.16-.08-.32-.21-.41L12.57 2.4c-.34-.24-.8-.24-1.15 0L2.21 8.85c-.13.09-.21.25-.21.41v1.24c0 .28.22.5.5.5H4v9H3c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1h-1v-9h1.5zM16 17c0 .55-.45 1-1 1s-1-.45-1-1v-3l-1.17 1.75c-.4.59-1.27.59-1.66 0L10 14v3c0 .55-.45 1-1 1s-1-.45-1-1v-4.7c0-.72.58-1.3 1.3-1.3.43 0 .84.22 1.08.58L12 14l1.61-2.42c.25-.36.65-.58 1.09-.58.72 0 1.3.58 1.3 1.3V17z"
	}), 'MuseumRounded');
	
	exports.default = _default;

/***/ },
/* 4226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 11V9L12 2 2 9v2h2v9H2v2h20v-2h-2v-9h2zm-6 7h-2v-4l-2 3-2-3v4H8v-7h2l2 3 2-3h2v7z"
	}), 'MuseumSharp');
	
	exports.default = _default;

/***/ },
/* 4227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 20h12V9H6v11zm2-9h2l2 3 2-3h2v7h-2v-4l-2 3-2-3v4H8v-7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M22 11V9L12 2 2 9v2h2v9H2v2h20v-2h-2v-9h2zm-4 9H6V9h12v11z"
	}), _react.default.createElement("path", {
	  d: "M10 14l2 3 2-3v4h2v-7h-2l-2 3-2-3H8v7h2z"
	})), 'MuseumTwoTone');
	
	exports.default = _default;

/***/ },
/* 4228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"
	}), 'MusicNote');
	
	exports.default = _default;

/***/ },
/* 4229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3l.01 10.55c-.59-.34-1.27-.55-2-.55C7.79 13 6 14.79 6 17s1.79 4 4.01 4S14 19.21 14 17V7h4V3h-6zm-1.99 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'MusicNoteOutlined');
	
	exports.default = _default;

/***/ },
/* 4230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5v8.55c-.94-.54-2.1-.75-3.33-.32-1.34.48-2.37 1.67-2.61 3.07-.46 2.74 1.86 5.08 4.59 4.65 1.96-.31 3.35-2.11 3.35-4.1V7h2c1.1 0 2-.9 2-2s-.9-2-2-2h-2c-1.1 0-2 .9-2 2z"
	}), 'MusicNoteRounded');
	
	exports.default = _default;

/***/ },
/* 4231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"
	}), 'MusicNoteSharp');
	
	exports.default = _default;

/***/ },
/* 4232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "10.01",
	  cy: "17",
	  r: "2",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 3l.01 10.55c-.59-.34-1.27-.55-2-.55C7.79 13 6 14.79 6 17s1.79 4 4.01 4S14 19.21 14 17V7h4V3h-6zm-1.99 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	})), 'MusicNoteTwoTone');
	
	exports.default = _default;

/***/ },
/* 4233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.27 3L3 4.27l9 9v.28c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4v-1.73L19.73 21 21 19.73 4.27 3zM14 7h4V3h-6v5.18l2 2z"
	}), 'MusicOff');
	
	exports.default = _default;

/***/ },
/* 4234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 7h4V3h-6v4.61l2 2zm-2 3.44L4.41 2.86 3 4.27l9 9v.28c-.94-.54-2.1-.75-3.33-.32-1.34.48-2.37 1.67-2.61 3.07-.46 2.74 1.86 5.08 4.59 4.65 1.96-.31 3.35-2.11 3.35-4.1v-1.58L19.73 21l1.41-1.41L12 10.44zM10 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'MusicOffOutlined');
	
	exports.default = _default;

/***/ },
/* 4235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 9.61V7h2c1.1 0 2-.9 2-2s-.9-2-2-2h-3c-.55 0-1 .45-1 1v3.61l2 2zM5.12 3.56a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l8.29 8.3v.28c-.94-.54-2.1-.75-3.33-.32-1.34.48-2.37 1.67-2.61 3.07-.46 2.74 1.86 5.08 4.59 4.65 1.96-.31 3.35-2.11 3.35-4.1v-1.58l5.02 5.02c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L5.12 3.56z"
	}), 'MusicOffRounded');
	
	exports.default = _default;

/***/ },
/* 4236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 9.61V7h4V3h-6v4.61zM4.41 2.86L3 4.27l9 9v.28c-.94-.54-2.1-.75-3.33-.32-1.34.48-2.37 1.67-2.61 3.07-.46 2.74 1.86 5.08 4.59 4.65 1.96-.31 3.35-2.11 3.35-4.1v-1.58L19.73 21l1.41-1.41L12 10.44 4.41 2.86z"
	}), 'MusicOffSharp');
	
	exports.default = _default;

/***/ },
/* 4237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "10",
	  cy: "17",
	  r: "2",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M14 7h4V3h-6v4.61l2 2zm-2 3.44L4.41 2.86 3 4.27l9 9v.28c-.94-.54-2.1-.75-3.33-.32-1.34.48-2.37 1.67-2.61 3.07-.46 2.74 1.86 5.08 4.59 4.65 1.96-.31 3.35-2.11 3.35-4.1v-1.58L19.73 21l1.41-1.41L12 10.44zM10 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	})), 'MusicOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 4238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03c-.02 1.64-1.35 2.97-3 2.97-1.66 0-3-1.34-3-3z"
	}), 'MusicVideo');
	
	exports.default = _default;

/***/ },
/* 4239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03c-.02 1.64-1.35 2.97-3 2.97-1.66 0-3-1.34-3-3z"
	}), 'MusicVideoOutlined');
	
	exports.default = _default;

/***/ },
/* 4240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1zM8.05 15.54C7.72 13.64 9.16 12 11 12c.35 0 .69.07 1 .18V8c0-1.1.9-2 2-2h2c.55 0 1 .45 1 1s-.45 1-1 1h-2v7.03c-.02 1.82-1.66 3.26-3.55 2.92-1.21-.21-2.2-1.2-2.4-2.41z"
	}), 'MusicVideoRounded');
	
	exports.default = _default;

/***/ },
/* 4241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 3H1v18h22V3zm-2 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03c-.02 1.64-1.35 2.97-3 2.97-1.66 0-3-1.34-3-3z"
	}), 'MusicVideoSharp');
	
	exports.default = _default;

/***/ },
/* 4242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 19h18V5H3v14zm8-7c.35 0 .69.07 1 .18V6h5v2h-3v7.03c-.02 1.64-1.35 2.97-3 2.97-1.66 0-3-1.34-3-3s1.34-3 3-3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zm-10-1c1.65 0 2.98-1.33 3-2.97V8h3V6h-5v6.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3z"
	})), 'MusicVideoTwoTone');
	
	exports.default = _default;

/***/ },
/* 4243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'MyLocation');
	
	exports.default = _default;

/***/ },
/* 4244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'MyLocationOutlined');
	
	exports.default = _default;

/***/ },
/* 4245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V2c0-.55-.45-1-1-1s-1 .45-1 1v1.06C6.83 3.52 3.52 6.83 3.06 11H2c-.55 0-1 .45-1 1s.45 1 1 1h1.06c.46 4.17 3.77 7.48 7.94 7.94V22c0 .55.45 1 1 1s1-.45 1-1v-1.06c4.17-.46 7.48-3.77 7.94-7.94H22c.55 0 1-.45 1-1s-.45-1-1-1h-1.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'MyLocationRounded');
	
	exports.default = _default;

/***/ },
/* 4246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'MyLocationSharp');
	
	exports.default = _default;

/***/ },
/* 4247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M13 3.06V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06c-.46-4.17-3.77-7.48-7.94-7.94zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "2",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	})), 'MyLocationTwoTone');
	
	exports.default = _default;

/***/ },
/* 4248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 16.12c3.47-.41 6.17-3.36 6.17-6.95 0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H5v2h14v-2h-6v-3.88z"
	}), 'Nature');
	
	exports.default = _default;

/***/ },
/* 4249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 16.12h-.03c3.49-.4 6.2-3.36 6.2-6.95 0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H5v2h14v-2h-6v-3.88zM7.17 9.17c0-2.76 2.24-5 5-5s5 2.24 5 5-2.24 5-5 5-5-2.24-5-5z"
	}), 'NatureOutlined');
	
	exports.default = _default;

/***/ },
/* 4250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88c3.47-.41 6.17-3.36 6.17-6.95zM4.5 11c.83 0 1.5-.67 1.5-1.5S5.33 8 4.5 8 3 8.67 3 9.5 3.67 11 4.5 11z"
	}), 'NaturePeople');
	
	exports.default = _default;

/***/ },
/* 4251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "4.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M22.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88c3.47-.41 6.17-3.36 6.17-6.95zm-7 5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	})), 'NaturePeopleOutlined');
	
	exports.default = _default;

/***/ },
/* 4252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "4.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M22.17 9.17c0-3.91-3.19-7.06-7.11-7-3.83.06-6.99 3.37-6.88 7.19.09 3.38 2.58 6.16 5.83 6.7V20H6v-3h.5c.28 0 .5-.22.5-.5V13c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v3.5c0 .28.22.5.5.5H3v4c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1h-2v-3.88c3.47-.41 6.17-3.36 6.17-6.95z"
	})), 'NaturePeopleRounded');
	
	exports.default = _default;

/***/ },
/* 4253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22.17 9.17c0-3.91-3.19-7.06-7.11-7-3.83.06-6.99 3.37-6.88 7.19.09 3.38 2.58 6.16 5.83 6.7V20H6v-3h1v-5H2v5h1v5h16v-2h-3v-3.88c3.47-.41 6.17-3.36 6.17-6.95zM4.5 11c.83 0 1.5-.67 1.5-1.5S5.33 8 4.5 8 3 8.67 3 9.5 3.67 11 4.5 11z"
	}), 'NaturePeopleSharp');
	
	exports.default = _default;

/***/ },
/* 4254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "15.17",
	  cy: "9.17",
	  r: "5",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "4.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M15.17 2.17c-3.87 0-7 3.13-7 7 0 3.47 2.52 6.34 5.83 6.89V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88c3.47-.41 6.17-3.36 6.17-6.95 0-3.87-3.13-7-7-7zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	})), 'NaturePeopleTwoTone');
	
	exports.default = _default;

/***/ },
/* 4255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 16.12c3.37-.4 6.01-3.19 6.16-6.64.17-3.87-3.02-7.25-6.89-7.31-3.92-.05-7.1 3.1-7.1 7 0 3.47 2.52 6.34 5.83 6.89V20H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-5v-3.88z"
	}), 'NatureRounded');
	
	exports.default = _default;

/***/ },
/* 4256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 16.12c3.47-.41 6.17-3.36 6.17-6.95 0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H5v2h14v-2h-6v-3.88z"
	}), 'NatureSharp');
	
	exports.default = _default;

/***/ },
/* 4257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12.17 4.17c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.25-5-5-5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H5v2h14v-2h-6v-3.88h-.03c3.49-.4 6.2-3.36 6.2-6.95zm-7 5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.25 5-5 5z"
	})), 'NatureTwoTone');
	
	exports.default = _default;

/***/ },
/* 4258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
	}), 'NavigateBefore');
	
	exports.default = _default;

/***/ },
/* 4259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.61 7.41L14.2 6l-6 6 6 6 1.41-1.41L11.03 12l4.58-4.59z"
	}), 'NavigateBeforeOutlined');
	
	exports.default = _default;

/***/ },
/* 4260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.91 6.71a.9959.9959 0 00-1.41 0L8.91 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L11.03 12l3.88-3.88c.38-.39.38-1.03 0-1.41z"
	}), 'NavigateBeforeRounded');
	
	exports.default = _default;

/***/ },
/* 4261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.61 7.41L14.2 6l-6 6 6 6 1.41-1.41L11.03 12l4.58-4.59z"
	}), 'NavigateBeforeSharp');
	
	exports.default = _default;

/***/ },
/* 4262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.2 6l-6 6 6 6 1.41-1.41L11.03 12l4.58-4.59z"
	}), 'NavigateBeforeTwoTone');
	
	exports.default = _default;

/***/ },
/* 4263 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
	}), 'NavigateNext');
	
	exports.default = _default;

/***/ },
/* 4264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.02 6L8.61 7.41 13.19 12l-4.58 4.59L10.02 18l6-6-6-6z"
	}), 'NavigateNextOutlined');
	
	exports.default = _default;

/***/ },
/* 4265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.31 6.71c-.39.39-.39 1.02 0 1.41L13.19 12l-3.88 3.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L10.72 6.7c-.38-.38-1.02-.38-1.41.01z"
	}), 'NavigateNextRounded');
	
	exports.default = _default;

/***/ },
/* 4266 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.02 6L8.61 7.41 13.19 12l-4.58 4.59L10.02 18l6-6-6-6z"
	}), 'NavigateNextSharp');
	
	exports.default = _default;

/***/ },
/* 4267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.02 18l6-6-6-6-1.41 1.41L13.19 12l-4.58 4.59z"
	}), 'NavigateNextTwoTone');
	
	exports.default = _default;

/***/ },
/* 4268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z"
	}), 'Navigation');
	
	exports.default = _default;

/***/ },
/* 4269 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7.27l4.28 10.43-3.47-1.53-.81-.36-.81.36-3.47 1.53L12 7.27M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71L12 2z"
	}), 'NavigationOutlined');
	
	exports.default = _default;

/***/ },
/* 4270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.93 4.26l6.15 14.99c.34.83-.51 1.66-1.33 1.29l-5.34-2.36c-.26-.11-.55-.11-.81 0l-5.34 2.36c-.82.36-1.67-.46-1.33-1.29l6.15-14.99c.33-.83 1.51-.83 1.85 0z"
	}), 'NavigationRounded');
	
	exports.default = _default;

/***/ },
/* 4271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71L12 2z"
	}), 'NavigationSharp');
	
	exports.default = _default;

/***/ },
/* 4272 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7.72 17.7l3.47-1.53.81-.36.81.36 3.47 1.53L12 7.27z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4.5 20.29l.71.71L12 18l6.79 3 .71-.71L12 2 4.5 20.29zm8.31-4.12l-.81-.36-.81.36-3.47 1.53L12 7.27l4.28 10.43-3.47-1.53z"
	})), 'NavigationTwoTone');
	
	exports.default = _default;

/***/ },
/* 4273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z"
	}), 'NearMe');
	
	exports.default = _default;

/***/ },
/* 4274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.27 6.73l-4.24 10.13-1.32-3.42-.32-.83-.82-.32-3.43-1.33 10.13-4.23M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z"
	}), 'NearMeOutlined');
	
	exports.default = _default;

/***/ },
/* 4275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.75 3.94L4.07 10.08c-.83.35-.81 1.53.02 1.85L9.43 14c.26.1.47.31.57.57l2.06 5.33c.32.84 1.51.86 1.86.03l6.15-14.67c.33-.83-.5-1.66-1.32-1.32z"
	}), 'NearMeRounded');
	
	exports.default = _default;

/***/ },
/* 4276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z"
	}), 'NearMeSharp');
	
	exports.default = _default;

/***/ },
/* 4277 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.39 12.61l.32.83 1.32 3.42 4.24-10.13-10.13 4.24 3.42 1.33z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 11.51l6.84 2.65L12.48 21h.98L21 3 3 10.53v.98zm14.27-4.78l-4.24 10.13-1.32-3.42-.32-.83-.82-.32-3.43-1.33 10.13-4.23z"
	})), 'NearMeTwoTone');
	
	exports.default = _default;

/***/ },
/* 4278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M2 22h20V2z"
	}), _react.default.createElement("path", {
	  d: "M17 7L2 22h15z"
	})), 'NetworkCell');
	
	exports.default = _default;

/***/ },
/* 4279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M2 22h20V2L2 22z"
	}), _react.default.createElement("path", {
	  d: "M17 7L2 22h15V7z"
	})), 'NetworkCellOutlined');
	
	exports.default = _default;

/***/ },
/* 4280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M4.41 22H20c1.1 0 2-.9 2-2V4.41c0-.89-1.08-1.34-1.71-.71L3.71 20.29c-.63.63-.19 1.71.7 1.71z"
	}), _react.default.createElement("path", {
	  d: "M17 7L3.71 20.29c-.63.63-.19 1.71.7 1.71H17V7z"
	})), 'NetworkCellRounded');
	
	exports.default = _default;

/***/ },
/* 4281 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M2 22h20V2L2 22z"
	}), _react.default.createElement("path", {
	  d: "M17 7L2 22h15V7z"
	})), 'NetworkCellSharp');
	
	exports.default = _default;

/***/ },
/* 4282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M2 22h20V2L2 22z"
	}), _react.default.createElement("path", {
	  d: "M17 7L2 22h15V7z"
	})), 'NetworkCellTwoTone');
	
	exports.default = _default;

/***/ },
/* 4283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.9 5c-.17 0-.32.09-.41.23l-.07.15-5.18 11.65c-.16.29-.26.61-.26.96 0 1.11.9 2.01 2.01 2.01.96 0 1.77-.68 1.96-1.59l.01-.03L16.4 5.5c0-.28-.22-.5-.5-.5zM1 9l2 2c2.88-2.88 6.79-4.08 10.53-3.62l1.19-2.68C9.89 3.84 4.74 5.27 1 9zm20 2l2-2c-1.64-1.64-3.55-2.82-5.59-3.57l-.53 2.82c1.5.62 2.9 1.53 4.12 2.75zm-4 4l2-2c-.8-.8-1.7-1.42-2.66-1.89l-.55 2.92c.42.27.83.59 1.21.97zM5 13l2 2c1.13-1.13 2.56-1.79 4.03-2l1.28-2.88c-2.63-.08-5.3.87-7.31 2.88z"
	}), 'NetworkCheck');
	
	exports.default = _default;

/***/ },
/* 4284 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.9 5c-.17 0-.32.09-.41.23l-.07.15-5.18 11.65c-.16.29-.26.61-.26.96 0 1.11.9 2.01 2.01 2.01.96 0 1.77-.68 1.96-1.59l.01-.03L16.4 5.5c0-.28-.22-.5-.5-.5zM1 9l2 2c2.88-2.88 6.79-4.08 10.53-3.62l1.19-2.68C9.89 3.84 4.74 5.27 1 9zm20 2l2-2c-1.64-1.64-3.55-2.82-5.59-3.57l-.53 2.82c1.5.62 2.9 1.53 4.12 2.75zm-4 4l2-2c-.8-.8-1.7-1.42-2.66-1.89l-.55 2.92c.42.27.83.59 1.21.97zM5 13l2 2c1.13-1.13 2.56-1.79 4.03-2l1.28-2.88c-2.63-.08-5.3.87-7.31 2.88z"
	}), 'NetworkCheckOutlined');
	
	exports.default = _default;

/***/ },
/* 4285 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.9 5c-.17 0-.32.09-.41.23l-.07.15-5.18 11.65c-.16.29-.26.61-.26.96 0 1.11.9 2.01 2.01 2.01.96 0 1.77-.68 1.96-1.59l.01-.03L16.4 5.5c0-.28-.22-.5-.5-.5zM2.06 10.06c.51.51 1.33.55 1.89.09 2.76-2.26 6.24-3.18 9.58-2.76l1.19-2.68c-4.35-.78-8.96.3-12.57 3.25-.64.53-.68 1.51-.09 2.1zm19.88 0c.59-.59.55-1.57-.1-2.1-1.36-1.11-2.86-1.95-4.44-2.53l-.53 2.82c1.13.47 2.19 1.09 3.17 1.89.58.46 1.39.43 1.9-.08zm-4.03 4.03c.6-.6.56-1.63-.14-2.12-.46-.33-.94-.61-1.44-.86l-.55 2.92c.11.07.22.14.32.22.57.4 1.33.32 1.81-.16zm-11.83-.01c.5.5 1.27.54 1.85.13.94-.66 2.01-1.06 3.1-1.22l1.28-2.88c-2.13-.06-4.28.54-6.09 1.84-.69.51-.74 1.53-.14 2.13z"
	}), 'NetworkCheckRounded');
	
	exports.default = _default;

/***/ },
/* 4286 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.9 5c-.17 0-.32.09-.41.23l-.07.15-5.18 11.65c-.16.29-.26.61-.26.96 0 1.11.9 2.01 2.01 2.01.96 0 1.77-.68 1.96-1.59l.01-.03L16.4 5.5c0-.28-.22-.5-.5-.5zM1 9l2 2c2.88-2.88 6.79-4.08 10.53-3.62l1.19-2.68C9.89 3.84 4.74 5.27 1 9zm20 2l2-2c-1.64-1.64-3.55-2.82-5.59-3.57l-.53 2.82c1.5.62 2.9 1.53 4.12 2.75zm-4 4l2-2c-.8-.8-1.7-1.42-2.66-1.89l-.55 2.92c.42.27.83.59 1.21.97zM5 13l2 2c1.13-1.13 2.56-1.79 4.03-2l1.28-2.88c-2.63-.08-5.3.87-7.31 2.88z"
	}), 'NetworkCheckSharp');
	
	exports.default = _default;

/***/ },
/* 4287 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.9 5c-.17 0-.32.09-.41.23l-.07.15-5.18 11.65c-.16.29-.26.61-.26.96 0 1.11.9 2.01 2.01 2.01.96 0 1.77-.68 1.96-1.59l.01-.03L16.4 5.5c0-.28-.22-.5-.5-.5zM1 9l2 2c2.88-2.88 6.79-4.08 10.53-3.62l1.19-2.68C9.89 3.84 4.74 5.27 1 9zm20 2l2-2c-1.64-1.64-3.55-2.82-5.59-3.57l-.53 2.82c1.5.62 2.9 1.53 4.12 2.75zm-4 4l2-2c-.8-.8-1.7-1.42-2.66-1.89l-.55 2.92c.42.27.83.59 1.21.97zM5 13l2 2c1.13-1.13 2.56-1.79 4.03-2l1.28-2.88c-2.63-.08-5.3.87-7.31 2.88z"
	}), 'NetworkCheckTwoTone');
	
	exports.default = _default;

/***/ },
/* 4288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.5 10c.17 0 .33.03.5.05V1L1 20h13v-3c0-.89.39-1.68 1-2.23v-.27c0-2.48 2.02-4.5 4.5-4.5zm2.5 6v-1.5c0-1.38-1.12-2.5-2.5-2.5S17 13.12 17 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z"
	}), 'NetworkLocked');
	
	exports.default = _default;

/***/ },
/* 4289 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 16v-.5c0-1.38-1.12-2.5-2.5-2.5S17 14.12 17 15.5v.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.5zM18 5.83v5.43c.47-.16.97-.26 1.5-.26.17 0 .33.03.5.05V1L1 20h13v-2H5.83L18 5.83z"
	}), 'NetworkLockedOutlined');
	
	exports.default = _default;

/***/ },
/* 4290 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 16v-.5c0-1.38-1.12-2.5-2.5-2.5S17 14.12 17 15.5v.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.5zm-1.5-5c.17 0 .33.03.5.05V3.41c0-.89-1.08-1.34-1.71-.71L2.71 18.29c-.63.63-.19 1.71.7 1.71H14v-3c0-.92.42-1.74 1.07-2.3.38-2.1 2.22-3.7 4.43-3.7z"
	}), 'NetworkLockedRounded');
	
	exports.default = _default;

/***/ },
/* 4291 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 16v-.36c0-1.31-.94-2.5-2.24-2.63-1.5-.15-2.76 1.02-2.76 2.49v.5h-1v6h7v-6h-1zm-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.5zm-1.5-5c.15 0 .3.01.46.02.01 0 .03.01.04.01V1L1 20h13v-6h1.26c.22-.63.58-1.2 1.06-1.68.85-.85 1.98-1.32 3.18-1.32z"
	}), 'NetworkLockedSharp');
	
	exports.default = _default;

/***/ },
/* 4292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 16v-.5c0-1.38-1.12-2.5-2.5-2.5S17 14.12 17 15.5v.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.5zM18 5.83v5.43c.47-.16.97-.26 1.5-.26.17 0 .33.03.5.05V1L1 20h13v-2H5.83L18 5.83z"
	}), 'NetworkLockedTwoTone');
	
	exports.default = _default;

/***/ },
/* 4293 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
	}), _react.default.createElement("path", {
	  d: "M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z"
	})), 'NetworkWifi');
	
	exports.default = _default;

/***/ },
/* 4294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5 23.64 7z"
	}), _react.default.createElement("path", {
	  d: "M3.53 10.94L12 21.5l8.47-10.56c-.43-.33-3.66-2.95-8.47-2.95s-8.04 2.62-8.47 2.95z"
	})), 'NetworkWifiOutlined');
	
	exports.default = _default;

/***/ },
/* 4295 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l10.08 12.56c.8 1 2.32 1 3.12 0L23.64 7z"
	}), _react.default.createElement("path", {
	  d: "M3.53 10.94l6.91 8.61c.8 1 2.32 1 3.12 0l6.91-8.61c-.43-.33-3.66-2.95-8.47-2.95s-8.04 2.62-8.47 2.95z"
	})), 'NetworkWifiRounded');
	
	exports.default = _default;

/***/ },
/* 4296 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5 23.64 7z"
	}), _react.default.createElement("path", {
	  d: "M3.53 10.94L12 21.5l8.47-10.56c-.43-.33-3.66-2.95-8.47-2.95s-8.04 2.62-8.47 2.95z"
	})), 'NetworkWifiSharp');
	
	exports.default = _default;

/***/ },
/* 4297 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5 23.64 7z"
	}), _react.default.createElement("path", {
	  d: "M3.53 10.94L12 21.5l8.47-10.56c-.43-.33-3.66-2.95-8.47-2.95s-8.04 2.62-8.47 2.95z"
	})), 'NetworkWifiTwoTone');
	
	exports.default = _default;

/***/ },
/* 4298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z"
	}), 'NewReleases');
	
	exports.default = _default;

/***/ },
/* 4299 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-4.51 2.11l.26 2.79-2.74.62-1.43 2.41L12 18.82l-2.58 1.11-1.43-2.41-2.74-.62.26-2.8L3.66 12l1.85-2.12-.26-2.78 2.74-.61 1.43-2.41L12 5.18l2.58-1.11 1.43 2.41 2.74.62-.26 2.79L20.34 12l-1.85 2.11zM11 15h2v2h-2zm0-8h2v6h-2z"
	}), 'NewReleasesOutlined');
	
	exports.default = _default;

/***/ },
/* 4300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22.42 11.34l-1.86-2.12.26-2.81c.05-.5-.29-.96-.77-1.07l-2.76-.63-1.44-2.43c-.26-.43-.79-.61-1.25-.41L12 3 9.41 1.89c-.46-.2-1-.02-1.25.41L6.71 4.72l-2.75.62c-.49.11-.83.56-.78 1.07l.26 2.8-1.86 2.13c-.33.38-.33.94 0 1.32l1.86 2.12-.26 2.82c-.05.5.29.96.77 1.07l2.76.63 1.44 2.42c.26.43.79.61 1.26.41L12 21l2.59 1.11c.46.2 1 .02 1.25-.41l1.44-2.43 2.76-.63c.49-.11.82-.57.77-1.07l-.26-2.81 1.86-2.12c.34-.36.34-.92.01-1.3zM13 17h-2v-2h2v2zm-1-4c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1z"
	}), 'NewReleasesRounded');
	
	exports.default = _default;

/***/ },
/* 4301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z"
	}), 'NewReleasesSharp');
	
	exports.default = _default;

/***/ },
/* 4302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18.49 9.89l.26-2.79-2.74-.62-1.43-2.41L12 5.18 9.42 4.07 7.99 6.48l-2.74.62.26 2.78L3.66 12l1.85 2.11-.26 2.8 2.74.62 1.43 2.41L12 18.82l2.58 1.11 1.43-2.41 2.74-.62-.26-2.79L20.34 12l-1.85-2.11zM13 17h-2v-2h2v2zm0-4h-2V7h2v6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20.9 5.54l-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12l-2.44-2.78.34-3.68zM18.75 16.9l-2.74.62-1.43 2.41L12 18.82l-2.58 1.11-1.43-2.41-2.74-.62.26-2.8L3.66 12l1.85-2.12-.26-2.78 2.74-.61 1.43-2.41L12 5.18l2.58-1.11 1.43 2.41 2.74.62-.26 2.79L20.34 12l-1.85 2.11.26 2.79zM11 15h2v2h-2zm0-8h2v6h-2z"
	})), 'NewReleasesTwoTone');
	
	exports.default = _default;

/***/ },
/* 4303 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm1 13.5l-1-1 3-3-3-3 1-1 4 4-4 4z"
	}), 'NextWeek');
	
	exports.default = _default;

/***/ },
/* 4304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 18.5l4-4-4-4-1 1 3 3-3 3zM20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm10 15H4V9h16v11z"
	}), 'NextWeekOutlined');
	
	exports.default = _default;

/***/ },
/* 4305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm.5 13c-.28-.28-.28-.72 0-1l2.5-2.5-2.5-2.5c-.28-.28-.28-.72 0-1s.72-.28 1 0l3.15 3.15c.2.2.2.51 0 .71L11.5 18c-.28.28-.72.28-1 0z"
	}), 'NextWeekRounded');
	
	exports.default = _default;

/***/ },
/* 4306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 7h-6V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H2v15h20V7zM10 5h4v2h-4V5zm1 13.5l-1-1 3-3-3-3 1-1 4 4-4 4z"
	}), 'NextWeekSharp');
	
	exports.default = _default;

/***/ },
/* 4307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 20h16V9H4v11zm6-8.5l1-1 4 4-4 4-1-1 3-3-3-3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11 18.5l4-4-4-4-1 1 3 3-3 3zM20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm10 15H4V9h16v11z"
	})), 'NextWeekTwoTone');
	
	exports.default = _default;

/***/ },
/* 4308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM18 6h-5c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12V6z"
	}), 'Nfc');
	
	exports.default = _default;

/***/ },
/* 4309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM18 6h-5c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12V6z"
	}), 'NfcOutlined');
	
	exports.default = _default;

/***/ },
/* 4310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 18H5c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1zM16 6h-3c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v7c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1V8h1c.55 0 1-.45 1-1s-.45-1-1-1H8c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z"
	}), 'NfcRounded');
	
	exports.default = _default;

/***/ },
/* 4311 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H2v20h20V2zm-2 18H4V4h16v16zM18 6h-7v4.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12V6z"
	}), 'NfcSharp');
	
	exports.default = _default;

/***/ },
/* 4312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM18 6h-5c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12V6z"
	}), 'NfcTwoTone');
	
	exports.default = _default;

/***/ },
/* 4313 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.1 12.08c-2.33-4.51-.5-8.48.53-10.07C6.27 2.2 1.98 6.59 1.98 12c0 .14.02.28.02.42.62-.27 1.29-.42 2-.42 1.66 0 3.18.83 4.1 2.15 1.67.48 2.9 2.02 2.9 3.85 0 1.52-.87 2.83-2.12 3.51.98.32 2.03.5 3.11.5 3.5 0 6.58-1.8 8.37-4.52-2.36.23-6.98-.97-9.26-5.41z"
	}), _react.default.createElement("path", {
	  d: "M7 16h-.18C6.4 14.84 5.3 14 4 14c-1.66 0-3 1.34-3 3s1.34 3 3 3h3c1.1 0 2-.9 2-2s-.9-2-2-2z"
	})), 'NightsStay');
	
	exports.default = _default;

/***/ },
/* 4314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19.78 17.51c-2.47 0-6.57-1.33-8.68-5.43-2.33-4.51-.5-8.48.53-10.07C6.27 2.2 1.98 6.59 1.98 12c0 .14.02.28.02.42.61-.26 1.28-.42 1.98-.42 0-3.09 1.73-5.77 4.3-7.1-.5 2.19-.54 5.04 1.04 8.1 1.57 3.04 4.18 4.95 6.8 5.86-1.23.74-2.65 1.15-4.13 1.15-.5 0-1-.05-1.48-.14-.37.7-.94 1.27-1.64 1.64.98.32 2.03.5 3.11.5 3.5 0 6.58-1.8 8.37-4.52-.17.01-.37.02-.57.02z"
	}), _react.default.createElement("path", {
	  d: "M7 16h-.18C6.4 14.84 5.3 14 4 14c-1.66 0-3 1.34-3 3s1.34 3 3 3h3c1.1 0 2-.9 2-2s-.9-2-2-2z"
	})), 'NightsStayOutlined');
	
	exports.default = _default;

/***/ },
/* 4315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.1 12.08c-2-3.88-.92-7.36.07-9.27.19-.36-.12-.77-.53-.72-5.02.68-8.86 5.07-8.65 10.32.01 0 .01 0 .01.01.62-.27 1.29-.42 2-.42 1.66 0 3.18.83 4.1 2.15 1.67.48 2.9 2.02 2.9 3.85 0 1.52-.87 2.83-2.12 3.51.98.32 2.03.5 3.11.5 3.13 0 5.92-1.44 7.76-3.69.26-.32.04-.79-.37-.82-2.49-.13-6.28-1.53-8.28-5.42z"
	}), _react.default.createElement("path", {
	  d: "M7 16h-.18C6.4 14.84 5.3 14 4 14c-1.66 0-3 1.34-3 3s1.34 3 3 3h3c1.1 0 2-.9 2-2s-.9-2-2-2z"
	})), 'NightsStayRounded');
	
	exports.default = _default;

/***/ },
/* 4316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.1 12.08c-2.33-4.51-.5-8.48.53-10.07C6.27 2.2 1.98 6.59 1.98 12c0 .14.02.28.02.42.62-.27 1.29-.42 2-.42 1.66 0 3.18.83 4.1 2.15 1.67.48 2.9 2.02 2.9 3.85 0 1.52-.87 2.83-2.12 3.51.98.32 2.03.5 3.11.5 3.5 0 6.58-1.8 8.37-4.52-2.36.23-6.98-.97-9.26-5.41z"
	}), _react.default.createElement("path", {
	  d: "M7 16h-.18C6.4 14.84 5.3 14 4 14c-1.66 0-3 1.34-3 3s1.34 3 3 3h3c1.1 0 2-.9 2-2s-.9-2-2-2z"
	})), 'NightsStaySharp');
	
	exports.default = _default;

/***/ },
/* 4317 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8.1 14.15c1.67.48 2.9 2.02 2.9 3.85 0 .68-.19 1.31-.48 1.87.48.09.97.14 1.48.14 1.48 0 2.9-.41 4.13-1.15-2.62-.92-5.23-2.82-6.8-5.86-1.59-3.06-1.55-5.91-1.04-8.1-2.57 1.33-4.3 4.01-4.3 7.1h.02c1.65 0 3.17.83 4.09 2.15z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19.78 17.51c-2.47 0-6.57-1.33-8.68-5.43-2.33-4.51-.5-8.48.53-10.07C6.27 2.2 1.98 6.59 1.98 12c0 .14.02.28.02.42.61-.26 1.28-.42 1.98-.42 0-3.09 1.73-5.77 4.3-7.1-.5 2.19-.54 5.04 1.04 8.1 1.57 3.04 4.18 4.95 6.8 5.86-1.23.74-2.65 1.15-4.13 1.15-.5 0-1-.05-1.48-.14-.37.7-.94 1.27-1.64 1.64.98.32 2.03.5 3.11.5 3.5 0 6.58-1.8 8.37-4.52-.17.01-.37.02-.57.02z"
	}), _react.default.createElement("path", {
	  d: "M7 16h-.18C6.4 14.84 5.3 14 4 14c-1.66 0-3 1.34-3 3s1.34 3 3 3h3c1.1 0 2-.9 2-2s-.9-2-2-2z"
	})), 'NightsStayTwoTone');
	
	exports.default = _default;

/***/ },
/* 4318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 21.78L4.22 5 3 6.22l2.04 2.04C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12c.23 0 .45-.05.66-.12L19.78 23 21 21.78zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H9.66L20 18.34V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.56 0-4.64 1.93-4.94 4.4L8.9 7.24V6z"
	}), 'NoEncryption');
	
	exports.default = _default;

/***/ },
/* 4319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2h-4.66l2 2H18v5.56l2 2V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.32 0-4.26 1.59-4.82 3.74L8.9 6.46V6zM4.41 4.81L3 6.22l2.04 2.04C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12.78l1 1 1.41-1.41L4.41 4.81zM6 20V10h.78l10 10H6z"
	}), 'NoEncryptionOutlined');
	
	exports.default = _default;

/***/ },
/* 4320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2h-4.66L20 17.56V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.32 0-4.26 1.59-4.82 3.74L8.9 6.46V6zm-3.78-.49a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l1.33 1.33C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12.78l.29.29c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L5.12 5.51z"
	}), 'NoEncryptionRounded');
	
	exports.default = _default;

/***/ },
/* 4321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2h-4.66L20 17.56V8h-3V6.22c0-2.61-1.91-4.94-4.51-5.19-2.53-.25-4.72 1.41-5.32 3.7L8.9 6.46V6zM4.41 4.81L3 6.22 4.78 8H4v14h14.78l1 1 1.41-1.41z"
	}), 'NoEncryptionSharp');
	
	exports.default = _default;

/***/ },
/* 4322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 20h10.78l-10-10H6zm6.44-10L18 15.56V10z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2h-4.66l2 2H18v5.56l2 2V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.32 0-4.26 1.59-4.82 3.74L8.9 6.46V6zM4.41 4.81L3 6.22l2.04 2.04C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12.78l1 1 1.41-1.41L4.41 4.81zM6 20V10h.78l10 10H6z"
	})), 'NoEncryptionTwoTone');
	
	exports.default = _default;

/***/ },
/* 4323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 11h-1v2h2v-1l9.73 9.73L20.46 23 14 16.54V21H3v-2h2V7.54l-4-4 1.27-1.27L11 11zm3 .49L5.51 3H14v1h5v12.49l-2-2V6h-3v5.49z"
	}), 'NoMeetingRoom');
	
	exports.default = _default;

/***/ },
/* 4324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5v3.88l2 2V6h3v7.88l2 2V4h-5V3H6.12l2 2zM2.41 2.13L1 3.54l4 4V19H3v2h11v-4.46L20.46 23l1.41-1.41L2.41 2.13zM12 19H7V9.54l5 5V19z"
	}), 'NoMeetingRoomOutlined');
	
	exports.default = _default;

/***/ },
/* 4325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6h3v7.88l2 2V5c0-.55-.45-1-1-1h-4c0-.55-.45-1-1-1H6.12L14 10.88V6zm7.17 14.88L12 11.71V13h-2v-2h1.29L3.12 2.83a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L5 7.54V19H4c-.55 0-1 .45-1 1s.45 1 1 1h9c.55 0 1-.45 1-1v-3.46l5.75 5.75c.39.39 1.02.39 1.41 0 .4-.39.4-1.02.01-1.41z"
	}), 'NoMeetingRoomRounded');
	
	exports.default = _default;

/***/ },
/* 4326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6h3v7.88l2 2V4h-5V3H6.12L14 10.88zm-2 5.71V13h-2v-2h1.29L2.41 2.13 1 3.54l4 4V19H3v2h11v-4.46L20.46 23l1.41-1.41z"
	}), 'NoMeetingRoomSharp');
	
	exports.default = _default;

/***/ },
/* 4327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 5H8.12L12 8.88V6zM7 19h5v-4.46l-5-5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 5v3.88l2 2V6h3v7.88l2 2V4h-5V3H6.12l2 2zM2.41 2.13L1 3.54l4 4V19H3v2h11v-4.46L20.46 23l1.41-1.41L2.41 2.13zM12 19H7V9.54l5 5V19z"
	})), 'NoMeetingRoomTwoTone');
	
	exports.default = _default;

/***/ },
/* 4328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z"
	}), 'NoSim');
	
	exports.default = _default;

/***/ },
/* 4329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.26 21.21L3.79 3.74 2.38 5.15l2.74 2.74-.12.12V19c0 1.1.9 2 2 2h10c.35 0 .68-.1.97-.26l1.88 1.88 1.41-1.41zM7 19V9.77L16.23 19H7zm3.84-14H17v9.11l2 2V5c0-1.1-.9-2-2-2h-6.99L7.95 5.06l1.41 1.41L10.84 5z"
	}), 'NoSimOutlined');
	
	exports.default = _default;

/***/ },
/* 4330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.09 4.44c-.39.39-.39 1.02 0 1.41l2.03 2.03-.12.13V19c0 1.1.9 2 2 2h10c.35 0 .68-.1.97-.26l1.17 1.17c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L4.5 4.44a.9959.9959 0 00-1.41 0zM19 16.11V5c0-1.1-.9-2-2-2h-6.99L7.95 5.06 19 16.11z"
	}), 'NoSimRounded');
	
	exports.default = _default;

/***/ },
/* 4331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.79 3.74L2.38 5.15l2.74 2.74-.12.12V21h13.27l1.58 1.62 1.41-1.41zM19 16.11V3h-8.99L7.95 5.06z"
	}), 'NoSimSharp');
	
	exports.default = _default;

/***/ },
/* 4332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 19h9.23L7 9.77z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3.79 3.74L2.38 5.15l2.74 2.74-.12.12V19c0 1.1.9 2 2 2h10c.35 0 .68-.1.97-.26l1.88 1.88 1.41-1.41L3.79 3.74zM7 19V9.77L16.23 19H7z"
	}), _react.default.createElement("path", {
	  d: "M10.84 5L9.36 6.47 17 14.11V5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M10.84 5H17v9.11l2 2V5c0-1.1-.9-2-2-2h-6.99L7.95 5.06l1.41 1.41L10.84 5z"
	})), 'NoSimTwoTone');
	
	exports.default = _default;

/***/ },
/* 4333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
	}), 'NotInterested');
	
	exports.default = _default;

/***/ },
/* 4334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
	}), 'NotInterestedOutlined');
	
	exports.default = _default;

/***/ },
/* 4335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
	}), 'NotInterestedRounded');
	
	exports.default = _default;

/***/ },
/* 4336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
	}), 'NotInterestedSharp');
	
	exports.default = _default;

/***/ },
/* 4337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zm0-18c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9L7.1 5.69C8.45 4.63 10.15 4 12 4zM5.69 7.1L16.9 18.31C15.55 19.37 13.85 20 12 20c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9z"
	}), 'NotInterestedTwoTone');
	
	exports.default = _default;

/***/ },
/* 4338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm.88 13.75h-1.75V14h1.75v1.75zm0-2.87h-1.75c0-2.84 2.62-2.62 2.62-4.38 0-.96-.79-1.75-1.75-1.75s-1.75.79-1.75 1.75H8.5C8.5 6.57 10.07 5 12 5s3.5 1.57 3.5 3.5c0 2.19-2.62 2.41-2.62 4.38z"
	})), 'NotListedLocation');
	
	exports.default = _default;

/***/ },
/* 4339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 1C7.59 1 4 4.59 4 9c0 5.57 6.96 13.34 7.26 13.67l.74.82.74-.82C13.04 22.34 20 14.57 20 9c0-4.41-3.59-8-8-8zm0 19.47C9.82 17.86 6 12.54 6 9c0-3.31 2.69-6 6-6s6 2.69 6 6c0 3.83-4.25 9.36-6 11.47zM11.13 14h1.75v1.75h-1.75zM12 5c-1.93 0-3.5 1.57-3.5 3.5h1.75c0-.96.79-1.75 1.75-1.75s1.75.79 1.75 1.75c0 1.76-2.62 1.54-2.62 4.38h1.75c0-1.97 2.62-2.19 2.62-4.38C15.5 6.57 13.93 5 12 5z"
	})), 'NotListedLocationOutlined');
	
	exports.default = _default;

/***/ },
/* 4340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2C8.14 2 5 5.14 5 9c0 4.17 4.42 9.92 6.23 12.11.4.48 1.13.48 1.53 0C14.58 18.92 19 13.17 19 9c0-3.86-3.14-7-7-7zm.88 13.75h-1.75V14h1.75v1.75zm.38-4.04c-.03.04-.06.09-.09.14-.02.04-.05.08-.07.12-.03.05-.05.1-.07.15-.02.04-.04.08-.05.13-.06.19-.1.4-.1.63h-1.76c0-.36.04-.66.11-.93h.02v-.06c.51-1.76 2.36-1.86 2.48-3.24.07-.85-.53-1.67-1.36-1.85-.91-.2-1.74.33-2.03 1.12-.11.33-.4.58-.76.58h-.16c-.55 0-.93-.53-.76-1.05.5-1.58 2.09-2.68 3.89-2.4 1.52.23 2.72 1.53 2.92 3.05.27 1.99-1.42 2.51-2.21 3.61z"
	})), 'NotListedLocationRounded');
	
	exports.default = _default;

/***/ },
/* 4341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm.88 13.75h-1.75V14h1.75v1.75zm0-2.87h-1.75c0-2.84 2.62-2.62 2.62-4.38 0-.96-.79-1.75-1.75-1.75s-1.75.79-1.75 1.75H8.5C8.5 6.57 10.07 5 12 5s3.5 1.57 3.5 3.5c0 2.19-2.62 2.41-2.62 4.38z"
	})), 'NotListedLocationSharp');
	
	exports.default = _default;

/***/ },
/* 4342 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 9c0 3.54 3.82 8.86 6 11.47 1.75-2.11 6-7.63 6-11.47 0-3.31-2.69-6-6-6S6 5.69 6 9zm6.88 6.75h-1.75V14h1.75v1.75zM15.5 8.5c0 2.19-2.62 2.41-2.62 4.38h-1.75c0-2.84 2.62-2.62 2.62-4.38 0-.96-.79-1.75-1.75-1.75s-1.75.79-1.75 1.75H8.5C8.5 6.57 10.07 5 12 5s3.5 1.57 3.5 3.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 9c0 5.57 6.96 13.34 7.26 13.67l.74.82.74-.82C13.04 22.34 20 14.57 20 9c0-4.41-3.59-8-8-8S4 4.59 4 9zm14 0c0 3.83-4.25 9.36-6 11.47C9.82 17.86 6 12.54 6 9c0-3.31 2.69-6 6-6s6 2.69 6 6zm-6.87 5h1.75v1.75h-1.75zM8.5 8.5h1.75c0-.96.79-1.75 1.75-1.75s1.75.79 1.75 1.75c0 1.76-2.62 1.54-2.62 4.38h1.75c0-1.97 2.62-2.19 2.62-4.38C15.5 6.57 13.93 5 12 5S8.5 6.57 8.5 8.5z"
	})), 'NotListedLocationTwoTone');
	
	exports.default = _default;

/***/ },
/* 4343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 10l-6-6H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99l16-.01c1.1 0 2-.89 2-1.99v-8zm-7-4.5l5.5 5.5H15V5.5z"
	}), 'Note');
	
	exports.default = _default;

/***/ },
/* 4344 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z"
	}), 'NoteAdd');
	
	exports.default = _default;

/***/ },
/* 4345 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 11h-2v3H8v2h3v3h2v-3h3v-2h-3zm1-9H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"
	}), 'NoteAddOutlined');
	
	exports.default = _default;

/***/ },
/* 4346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.59 2.59c-.38-.38-.89-.59-1.42-.59H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8.83c0-.53-.21-1.04-.59-1.41l-4.82-4.83zM15 16h-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2H9c-.55 0-1-.45-1-1s.45-1 1-1h2v-2c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1s-.45 1-1 1zm-2-8V3.5L18.5 9H14c-.55 0-1-.45-1-1z"
	}), 'NoteAddRounded');
	
	exports.default = _default;

/***/ },
/* 4347 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 2H4v20h16V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z"
	}), 'NoteAddSharp');
	
	exports.default = _default;

/***/ },
/* 4348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M13 4H6v16h12V9h-5V4zm3 10v2h-3v3h-2v-3H8v-2h3v-3h2v3h3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M13 11h-2v3H8v2h3v3h2v-3h3v-2h-3zm1-9H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"
	})), 'NoteAddTwoTone');
	
	exports.default = _default;

/***/ },
/* 4349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 4H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99h16c1.1 0 2-.9 2-2v-8l-6-6zM4 18.01V6h11v5h5v7.01H4z"
	}), 'NoteOutlined');
	
	exports.default = _default;

/***/ },
/* 4350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.41 9.41l-4.83-4.83c-.37-.37-.88-.58-1.41-.58H4c-1.1 0-2 .9-2 2v12.01c0 1.1.89 1.99 1.99 1.99H20c1.1 0 2-.9 2-2v-7.17c0-.53-.21-1.04-.59-1.42zM15 5.5l5.5 5.5H16c-.55 0-1-.45-1-1V5.5z"
	}), 'NoteRounded');
	
	exports.default = _default;

/***/ },
/* 4351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 10l-6-6H2v16h20V10zm-7-4.5l5.5 5.5H15V5.5z"
	}), 'NoteSharp');
	
	exports.default = _default;

/***/ },
/* 4352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15 6H4v12.01h16V11h-5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99h16c1.1 0 2-.9 2-2v-8l-6-6H4zm16 14.01H4V6h11v5h5v7.01z"
	})), 'NoteTwoTone');
	
	exports.default = _default;

/***/ },
/* 4353 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 18h12v-2H3v2zM3 6v2h18V6H3zm0 7h18v-2H3v2z"
	}), 'Notes');
	
	exports.default = _default;

/***/ },
/* 4354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 11.01L3 11v2h18zM3 16h12v2H3zM21 6H3v2.01L21 8z"
	}), 'NotesOutlined');
	
	exports.default = _default;

/***/ },
/* 4355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 11H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1zM4 18h10c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM20 6H4c-.55 0-1 .45-1 1v.01c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1z"
	}), 'NotesRounded');
	
	exports.default = _default;

/***/ },
/* 4356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 11.01L3 11v2h18zM3 16h12v2H3zM21 6H3v2.01L21 8z"
	}), 'NotesSharp');
	
	exports.default = _default;

/***/ },
/* 4357 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 11.01L3 11v2h18zM3 16h12v2H3zM21 6H3v2.01L21 8z"
	}), 'NotesTwoTone');
	
	exports.default = _default;

/***/ },
/* 4358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 16v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-5 0h-2v-2h2v2zm0-4h-2V8h2v4zm-1 10c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2z"
	}), 'NotificationImportant');
	
	exports.default = _default;

/***/ },
/* 4359 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zM12 6c2.76 0 5 2.24 5 5v7H7v-7c0-2.76 2.24-5 5-5zm0-4.5c-.83 0-1.5.67-1.5 1.5v1.17C7.36 4.85 5 7.65 5 11v6l-2 2v1h18v-1l-2-2v-6c0-3.35-2.36-6.15-5.5-6.83V3c0-.83-.67-1.5-1.5-1.5zM11 8h2v4h-2zm0 6h2v2h-2z"
	}), 'NotificationImportantOutlined');
	
	exports.default = _default;

/***/ },
/* 4360 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 23c1.1 0 1.99-.89 1.99-1.99h-3.98c0 1.1.89 1.99 1.99 1.99zm8.29-4.71L19 17v-6c0-3.35-2.36-6.15-5.5-6.83V3c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v1.17C7.36 4.85 5 7.65 5 11v6l-1.29 1.29c-.63.63-.19 1.71.7 1.71h15.17c.9 0 1.34-1.08.71-1.71zM13 16h-2v-2h2v2zm0-5c0 .55-.45 1-1 1s-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v2z"
	}), 'NotificationImportantRounded');
	
	exports.default = _default;

/***/ },
/* 4361 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 23c1.1 0 1.99-.89 1.99-1.99h-3.98c0 1.1.89 1.99 1.99 1.99zm7-6v-6c0-3.35-2.36-6.15-5.5-6.83V1.5h-3v2.67C7.36 4.85 5 7.65 5 11v6l-2 2v1h18v-1l-2-2zm-6-1h-2v-2h2v2zm0-4h-2V8h2v4z"
	}), 'NotificationImportantSharp');
	
	exports.default = _default;

/***/ },
/* 4362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 6c-2.76 0-5 2.24-5 5v7h10v-7c0-2.76-2.24-5-5-5zm1 10h-2v-2h2v2zm0-4h-2V8h2v4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 23c1.1 0 1.99-.89 1.99-1.99h-3.98c0 1.1.89 1.99 1.99 1.99zm7-6v-6c0-3.35-2.36-6.15-5.5-6.83V3c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v1.17C7.36 4.85 5 7.65 5 11v6l-2 2v1h18v-1l-2-2zm-2 1H7v-7c0-2.76 2.24-5 5-5s5 2.24 5 5v7zM11 8h2v4h-2zm0 6h2v2h-2z"
	})), 'NotificationImportantTwoTone');
	
	exports.default = _default;

/***/ },
/* 4363 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
	}), 'Notifications');
	
	exports.default = _default;

/***/ },
/* 4364 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z"
	}), 'NotificationsActive');
	
	exports.default = _default;

/***/ },
/* 4365 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6zM7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42z"
	}), 'NotificationsActiveOutlined');
	
	exports.default = _default;

/***/ },
/* 4366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 16v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.68-1.5-1.51-1.5S10.5 3.17 10.5 4v.68C7.63 5.36 6 7.92 6 11v5l-1.3 1.29c-.63.63-.19 1.71.7 1.71h13.17c.89 0 1.34-1.08.71-1.71L18 16zm-6.01 6c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zM6.77 4.73c.42-.38.43-1.03.03-1.43-.38-.38-1-.39-1.39-.02C3.7 4.84 2.52 6.96 2.14 9.34c-.09.61.38 1.16 1 1.16.48 0 .9-.35.98-.83.3-1.94 1.26-3.67 2.65-4.94zM18.6 3.28c-.4-.37-1.02-.36-1.4.02-.4.4-.38 1.04.03 1.42 1.38 1.27 2.35 3 2.65 4.94.07.48.49.83.98.83.61 0 1.09-.55.99-1.16-.38-2.37-1.55-4.48-3.25-6.05z"
	}), 'NotificationsActiveRounded');
	
	exports.default = _default;

/***/ },
/* 4367 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V2.5h-3v2.18C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z"
	}), 'NotificationsActiveSharp');
	
	exports.default = _default;

/***/ },
/* 4368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 6.5c-2.49 0-4 2.02-4 4.5v6h8v-6c0-2.48-1.51-4.5-4-4.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-11c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-2 6H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6zM7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42z"
	})), 'NotificationsActiveTwoTone');
	
	exports.default = _default;

/***/ },
/* 4369 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
	}), 'NotificationsNone');
	
	exports.default = _default;

/***/ },
/* 4370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
	}), 'NotificationsNoneOutlined');
	
	exports.default = _default;

/***/ },
/* 4371 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.29 17.29L18 16v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-1.29 1.29c-.63.63-.19 1.71.7 1.71h13.17c.9 0 1.34-1.08.71-1.71zM16 17H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6zm-4 5c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2z"
	}), 'NotificationsNoneRounded');
	
	exports.default = _default;

/***/ },
/* 4372 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V2.5h-3v2.18C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
	}), 'NotificationsNoneSharp');
	
	exports.default = _default;

/***/ },
/* 4373 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 6.5c-2.49 0-4 2.02-4 4.5v6h8v-6c0-2.48-1.51-4.5-4-4.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 16v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6zm-4 5c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2z"
	})), 'NotificationsNoneTwoTone');
	
	exports.default = _default;

/***/ },
/* 4374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18.69L7.84 6.14 5.27 3.49 4 4.76l2.8 2.8v.01c-.52.99-.8 2.16-.8 3.42v5l-2 2v1h13.73l2 2L21 19.72l-1-1.03zM12 22c1.11 0 2-.89 2-2h-4c0 1.11.89 2 2 2zm6-7.32V11c0-3.08-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.15.03-.29.08-.42.12-.1.03-.2.07-.3.11h-.01c-.01 0-.01 0-.02.01-.23.09-.46.2-.68.31 0 0-.01 0-.01.01L18 14.68z"
	}), 'NotificationsOff');
	
	exports.default = _default;

/***/ },
/* 4375 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm0-15.5c2.49 0 4 2.02 4 4.5v.1l2 2V11c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.24.06-.47.15-.69.23l1.64 1.64c.18-.02.36-.05.55-.05zM5.41 3.35L4 4.76l2.81 2.81C6.29 8.57 6 9.74 6 11v5l-2 2v1h14.24l1.74 1.74 1.41-1.41L5.41 3.35zM16 17H8v-6c0-.68.12-1.32.34-1.9L16 16.76V17z"
	}), 'NotificationsOffOutlined');
	
	exports.default = _default;

/***/ },
/* 4376 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.24.06-.47.15-.69.23L18 13.1V11zM5.41 3.35L4 4.76l2.81 2.81C6.29 8.57 6 9.73 6 11v5l-1.29 1.29c-.63.63-.19 1.71.7 1.71h12.83l1.74 1.74 1.41-1.41L5.41 3.35z"
	}), 'NotificationsOffRounded');
	
	exports.default = _default;

/***/ },
/* 4377 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-11c0-3.07-1.64-5.64-4.5-6.32V2.5h-3v2.18c-.24.06-.47.15-.69.23L18 13.1V11zM5.41 3.35L4 4.76l2.81 2.81C6.29 8.57 6 9.73 6 11v5l-2 2v1h14.24l1.74 1.74 1.41-1.41L5.41 3.35z"
	}), 'NotificationsOffSharp');
	
	exports.default = _default;

/***/ },
/* 4378 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 17h8v-.24L8.34 9.1C8.12 9.68 8 10.32 8 11v6zm4-10.5c-.19 0-.37.03-.55.06L16 11.1V11c0-2.48-1.51-4.5-4-4.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm0-15.5c2.49 0 4 2.02 4 4.5v.1l2 2V11c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.24.06-.47.15-.69.23l1.64 1.64c.18-.02.36-.05.55-.05zM5.41 3.35L4 4.76l2.81 2.81C6.29 8.57 6 9.74 6 11v5l-2 2v1h14.24l1.74 1.74 1.41-1.41L5.41 3.35zM16 17H8v-6c0-.68.12-1.32.34-1.9L16 16.76V17z"
	})), 'NotificationsOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 4379 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
	}), 'NotificationsOutlined');
	
	exports.default = _default;

/***/ },
/* 4380 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.93 6 11v5l-2 2v1h16v-1l-2-2zm-3.5-6.2l-2.8 3.4h2.8V15h-5v-1.8l2.8-3.4H9.5V8h5v1.8z"
	}), 'NotificationsPaused');
	
	exports.default = _default;

/***/ },
/* 4381 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.5 9.8h2.8l-2.8 3.4V15h5v-1.8h-2.8l2.8-3.4V8h-5zM18 16v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6zm-4 5c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2z"
	}), 'NotificationsPausedOutlined');
	
	exports.default = _default;

/***/ },
/* 4382 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm7.29-4.71L18 16v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-1.29 1.29c-.63.63-.19 1.71.7 1.71h13.17c.9 0 1.34-1.08.71-1.71zM14.5 9.33c0 .31-.11.6-.3.84l-2.5 3.03h1.9c.5 0 .9.4.9.9s-.4.9-.9.9h-2.78c-.73 0-1.32-.59-1.32-1.32v-.01c0-.31.11-.6.3-.84l2.5-3.03h-1.9c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h2.78c.73 0 1.32.59 1.32 1.33z"
	}), 'NotificationsPausedRounded');
	
	exports.default = _default;

/***/ },
/* 4383 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V2.5h-3v2.18C7.63 5.36 6 7.93 6 11v5l-2 2v1h16v-1l-2-2zm-3.5-6.2l-2.8 3.4h2.8V15h-5v-1.8l2.8-3.4H9.5V8h5v1.8z"
	}), 'NotificationsPausedSharp');
	
	exports.default = _default;

/***/ },
/* 4384 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 6.5c-2.49 0-4 2.02-4 4.5v6h8v-6c0-2.48-1.51-4.5-4-4.5zm2.5 3.3l-2.8 3.4h2.8V15h-5v-1.8l2.8-3.4H9.5V8h5v1.8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9.5 9.8h2.8l-2.8 3.4V15h5v-1.8h-2.8l2.8-3.4V8h-5zM18 16v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6zm-4 5c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2z"
	})), 'NotificationsPausedTwoTone');
	
	exports.default = _default;

/***/ },
/* 4385 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-1.29 1.29c-.63.63-.19 1.71.7 1.71h13.17c.89 0 1.34-1.08.71-1.71L18 16z"
	}), 'NotificationsRounded');
	
	exports.default = _default;

/***/ },
/* 4386 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V2.5h-3v2.18C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
	}), 'NotificationsSharp');
	
	exports.default = _default;

/***/ },
/* 4387 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 6.5c-2.49 0-4 2.02-4 4.5v6h8v-6c0-2.48-1.51-4.5-4-4.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
	})), 'NotificationsTwoTone');
	
	exports.default = _default;

/***/ },
/* 4388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2.02c-5.51 0-9.98 4.47-9.98 9.98s4.47 9.98 9.98 9.98 9.98-4.47 9.98-9.98S17.51 2.02 12 2.02zM11.48 20v-6.26H8L13 4v6.26h3.35L11.48 20z"
	}), 'OfflineBolt');
	
	exports.default = _default;

/***/ },
/* 4389 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2.02c-5.51 0-9.98 4.47-9.98 9.98s4.47 9.98 9.98 9.98 9.98-4.47 9.98-9.98S17.51 2.02 12 2.02zm0 17.96c-4.4 0-7.98-3.58-7.98-7.98S7.6 4.02 12 4.02 19.98 7.6 19.98 12 16.4 19.98 12 19.98zM12.75 5l-4.5 8.5h3.14V19l4.36-8.5h-3z"
	}), 'OfflineBoltOutlined');
	
	exports.default = _default;

/***/ },
/* 4390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2.02c-5.51 0-9.98 4.47-9.98 9.98s4.47 9.98 9.98 9.98 9.98-4.47 9.98-9.98S17.51 2.02 12 2.02zm-.52 15.86v-4.14H8.82c-.37 0-.62-.4-.44-.73l3.68-7.17c.23-.47.94-.3.94.23v4.19h2.54c.37 0 .61.39.45.72l-3.56 7.12c-.24.48-.95.31-.95-.22z"
	}), 'OfflineBoltRounded');
	
	exports.default = _default;

/***/ },
/* 4391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2.02c-5.51 0-9.98 4.47-9.98 9.98s4.47 9.98 9.98 9.98 9.98-4.47 9.98-9.98S17.51 2.02 12 2.02zM11.48 20v-6.26H8L13 4v6.26h3.35L11.48 20z"
	}), 'OfflineBoltSharp');
	
	exports.default = _default;

/***/ },
/* 4392 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4.02C7.6 4.02 4.02 7.6 4.02 12S7.6 19.98 12 19.98s7.98-3.58 7.98-7.98S16.4 4.02 12 4.02zM11.39 19v-5.5H8.25l4.5-8.5v5.5h3L11.39 19z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2.02c-5.51 0-9.98 4.47-9.98 9.98s4.47 9.98 9.98 9.98 9.98-4.47 9.98-9.98S17.51 2.02 12 2.02zm0 17.96c-4.4 0-7.98-3.58-7.98-7.98S7.6 4.02 12 4.02 19.98 7.6 19.98 12 16.4 19.98 12 19.98zM12.75 5l-4.5 8.5h3.14V19l4.36-8.5h-3V5z"
	})), 'OfflineBoltTwoTone');
	
	exports.default = _default;

/***/ },
/* 4393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm5 16H7v-2h10v2zm-6.7-4L7 10.7l1.4-1.4 1.9 1.9 5.3-5.3L17 7.3 10.3 14z"
	}), 'OfflinePin');
	
	exports.default = _default;

/***/ },
/* 4394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5-5h10v2H7zm3.3-3.8L8.4 9.3 7 10.7l3.3 3.3L17 7.3l-1.4-1.4z"
	}), 'OfflinePinOutlined');
	
	exports.default = _default;

/***/ },
/* 4395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4 16H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zm-6.41-4.71L7.7 11.4a.9839.9839 0 010-1.4c.39-.39 1.01-.39 1.4 0l1.2 1.2 4.6-4.6c.39-.39 1.01-.39 1.4 0 .39.39.39 1.01 0 1.4l-5.29 5.29c-.39.39-1.03.39-1.42 0z"
	}), 'OfflinePinRounded');
	
	exports.default = _default;

/***/ },
/* 4396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm5 16H7v-2h10v2zm-6.7-4L7 10.7l1.4-1.4 1.9 1.9 5.3-5.3L17 7.3 10.3 14z"
	}), 'OfflinePinSharp');
	
	exports.default = _default;

/***/ },
/* 4397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm5 13H7v-2h10v2zm-6.7-3L7 10.7l1.4-1.4 1.9 1.9 5.3-5.3L17 7.3 10.3 14z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5-5h10v2H7zm3.3-3.8L8.4 9.3 7 10.7l3.3 3.3L17 7.3l-1.4-1.4z"
	})), 'OfflinePinTwoTone');
	
	exports.default = _default;

/***/ },
/* 4398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-6l-7 4V7z"
	}), 'OndemandVideo');
	
	exports.default = _default;

/***/ },
/* 4399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 7v8l7-4zm12-4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"
	}), 'OndemandVideoOutlined');
	
	exports.default = _default;

/***/ },
/* 4400 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v1c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-1h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm-1 14H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1zm-5.52-5.13l-3.98 2.28c-.67.38-1.5-.11-1.5-.87V8.72c0-.77.83-1.25 1.5-.87l3.98 2.28c.67.39.67 1.35 0 1.74z"
	}), 'OndemandVideoRounded');
	
	exports.default = _default;

/***/ },
/* 4401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 3H1v16h7v2h8v-2h6.99L23 3zm-2 14H3V5h18v12zm-5-6l-7 4V7l7 4z"
	}), 'OndemandVideoSharp');
	
	exports.default = _default;

/***/ },
/* 4402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 17h18V5H3v12zM9 7l7 4-7 4V7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9 7v8l7-4zm12-4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"
	})), 'OndemandVideoTwoTone');
	
	exports.default = _default;

/***/ },
/* 4403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.66 8L12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"
	}), 'Opacity');
	
	exports.default = _default;

/***/ },
/* 4404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.66 8L12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"
	}), 'OpacityOutlined');
	
	exports.default = _default;

/***/ },
/* 4405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.66 8l-4.95-4.94a.9959.9959 0 00-1.41 0L6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"
	}), 'OpacityRounded');
	
	exports.default = _default;

/***/ },
/* 4406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.66 8L12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"
	}), 'OpacitySharp');
	
	exports.default = _default;

/***/ },
/* 4407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16.24 9.65L12 5.27 7.76 9.6C6.62 10.73 6.01 12 6 14h12c-.01-2-.62-3.23-1.76-4.35z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17.66 8L12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"
	})), 'OpacityTwoTone');
	
	exports.default = _default;

/***/ },
/* 4408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm-7 6l-4 4h3v6h2v-6h3l-4-4z"
	}), 'OpenInBrowser');
	
	exports.default = _default;

/***/ },
/* 4409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm-7 6l-4 4h3v6h2v-6h3l-4-4z"
	}), 'OpenInBrowserOutlined');
	
	exports.default = _default;

/***/ },
/* 4410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.9 2 2 2h3c.55 0 1-.45 1-1s-.45-1-1-1H5V8h14v10h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm-7.35 6.35l-2.79 2.79c-.32.32-.1.86.35.86H11v5c0 .55.45 1 1 1s1-.45 1-1v-5h1.79c.45 0 .67-.54.35-.85l-2.79-2.79c-.19-.2-.51-.2-.7-.01z"
	}), 'OpenInBrowserRounded');
	
	exports.default = _default;

/***/ },
/* 4411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 4v16h6v-2H5V8h14v10h-4v2h6V4H3zm9 6l-4 4h3v6h2v-6h3l-4-4z"
	}), 'OpenInBrowserSharp');
	
	exports.default = _default;

/***/ },
/* 4412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm-7 6l-4 4h3v6h2v-6h3l-4-4z"
	}), 'OpenInBrowserTwoTone');
	
	exports.default = _default;

/***/ },
/* 4413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
	}), 'OpenInNew');
	
	exports.default = _default;

/***/ },
/* 4414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
	}), 'OpenInNewOutlined');
	
	exports.default = _default;

/***/ },
/* 4415 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 19H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h5c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.11 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55-.45 1-1 1zM14 4c0 .55.45 1 1 1h2.59l-9.13 9.13c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L19 6.41V9c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1h-5c-.55 0-1 .45-1 1z"
	}), 'OpenInNewRounded');
	
	exports.default = _default;

/***/ },
/* 4416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 19H5V5h7V3H3v18h18v-9h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
	}), 'OpenInNewSharp');
	
	exports.default = _default;

/***/ },
/* 4417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
	}), 'OpenInNewTwoTone');
	
	exports.default = _default;

/***/ },
/* 4418 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
	}), 'OpenWith');
	
	exports.default = _default;

/***/ },
/* 4419 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
	}), 'OpenWithOutlined');
	
	exports.default = _default;

/***/ },
/* 4420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.5 9h3c.28 0 .5-.22.5-.5V6h1.79c.45 0 .67-.54.35-.85l-3.79-3.79c-.2-.2-.51-.2-.71 0L7.85 5.15c-.31.31-.09.85.36.85H10v2.5c0 .28.22.5.5.5zm-2 1H6V8.21c0-.45-.54-.67-.85-.35l-3.79 3.79c-.2.2-.2.51 0 .71l3.79 3.79c.31.31.85.09.85-.36V14h2.5c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5zm14.15 1.65l-3.79-3.79c-.32-.32-.86-.1-.86.35V10h-2.5c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5H18v1.79c0 .45.54.67.85.35l3.79-3.79c.2-.19.2-.51.01-.7zM13.5 15h-3c-.28 0-.5.22-.5.5V18H8.21c-.45 0-.67.54-.35.85l3.79 3.79c.2.2.51.2.71 0l3.79-3.79c.31-.31.09-.85-.35-.85H14v-2.5c0-.28-.22-.5-.5-.5z"
	}), 'OpenWithRounded');
	
	exports.default = _default;

/***/ },
/* 4421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
	}), 'OpenWithSharp');
	
	exports.default = _default;

/***/ },
/* 4422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
	}), 'OpenWithTwoTone');
	
	exports.default = _default;

/***/ },
/* 4423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 22c1.66 0 3-1.34 3-3s-1.34-3-3-3c-1.3 0-2.4.84-2.82 2H9.14l1.99-3.06c.29.04.58.06.87.06s.58-.02.87-.06l1.02 1.57c.42-.53.96-.95 1.6-1.21l-.6-.93C17.31 13.27 19 10.84 19 8H5c0 2.84 1.69 5.27 4.12 6.37l-3.95 6.08c-.3.46-.17 1.08.29 1.38.46.3 1.08.17 1.38-.29l1-1.55h6.34C14.6 21.16 15.7 22 17 22zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9.41 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.77-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.22.24.79.67.45 2.04zM11.89 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.78-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.23.24.8.67.45 2.04zM14.41 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.77-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.22.24.79.67.45 2.04z"
	}), 'OutdoorGrill');
	
	exports.default = _default;

/***/ },
/* 4424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 22c1.66 0 3-1.34 3-3s-1.34-3-3-3c-1.3 0-2.4.84-2.82 2H9.14l1.99-3.06c.29.04.58.06.87.06s.58-.02.87-.06l1.02 1.57c.42-.53.96-.95 1.6-1.21l-.6-.93C17.31 13.27 19 10.84 19 8H5c0 2.84 1.69 5.27 4.12 6.37l-3.95 6.08c-.3.46-.17 1.08.29 1.38.46.3 1.08.17 1.38-.29l1-1.55h6.34C14.6 21.16 15.7 22 17 22zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-9.58-8h9.16c-.77 1.76-2.54 3-4.58 3s-3.81-1.24-4.58-3zM9.41 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.77-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.22.24.79.67.45 2.04zM11.89 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.78-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.23.24.8.67.45 2.04zM14.41 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.77-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.22.24.79.67.45 2.04z"
	}), 'OutdoorGrillOutlined');
	
	exports.default = _default;

/***/ },
/* 4425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 22c1.66 0 3-1.34 3-3s-1.34-3-3-3c-1.3 0-2.4.84-2.82 2H9.14l1.99-3.06c.29.04.58.06.87.06s.58-.02.87-.06l1.02 1.57c.42-.53.96-.95 1.6-1.21l-.6-.93c2.1-.95 3.64-2.9 4.02-5.24.1-.59-.39-1.13-.99-1.13H6.08c-.6 0-1.09.54-.99 1.14.38 2.34 1.93 4.29 4.02 5.24l-3.95 6.08c-.3.46-.17 1.08.29 1.38.46.3 1.08.17 1.38-.29l1-1.55h6.34c.43 1.16 1.53 2 2.83 2zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9.5 6.47c-.02.28.18.53.46.53H10c.24 0 .44-.18.46-.42.1-.87.04-1.39-.94-2.54-.36-.43-.6-.69-.53-1.55.03-.26-.19-.49-.46-.49h-.05c-.24 0-.45.19-.47.43-.08.93.2 1.74.95 2.53.19.21.64.56.54 1.51zM11.99 6.47c-.03.28.18.53.46.53h.03c.24 0 .44-.18.46-.42.1-.87.04-1.39-.94-2.54-.36-.43-.61-.69-.53-1.55.03-.26-.19-.49-.46-.49h-.05c-.24 0-.45.19-.47.43-.08.93.2 1.74.95 2.53.19.21.64.56.55 1.51zM14.5 6.47c-.02.28.18.53.46.53H15c.24 0 .44-.18.46-.42.1-.87.04-1.39-.94-2.54-.36-.43-.61-.69-.53-1.55.03-.26-.19-.49-.46-.49h-.05c-.24 0-.45.19-.47.43-.08.93.2 1.74.95 2.53.19.21.64.56.54 1.51z"
	}), 'OutdoorGrillRounded');
	
	exports.default = _default;

/***/ },
/* 4426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 22c1.66 0 3-1.34 3-3s-1.34-3-3-3c-1.3 0-2.4.84-2.82 2H9.14l1.99-3.06c.29.04.58.06.87.06.29 0 .58-.02.87-.06l1.02 1.57c.42-.53.96-.95 1.6-1.21l-.6-.93C17.31 13.27 19 10.84 19 8H5c0 2.84 1.69 5.27 4.12 6.37l-4.5 6.92 1.68 1.09L7.84 20h6.34c.42 1.16 1.52 2 2.82 2zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9.41 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.77-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.22.24.79.67.45 2.04zM11.89 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.78-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.23.24.8.67.45 2.04zM14.41 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.77-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.22.24.79.67.45 2.04z"
	}), 'OutdoorGrillSharp');
	
	exports.default = _default;

/***/ },
/* 4427 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16.58 10H7.42c.77 1.76 2.54 3 4.58 3s3.81-1.24 4.58-3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 22c1.66 0 3-1.34 3-3s-1.34-3-3-3c-1.3 0-2.4.84-2.82 2H9.14l1.99-3.06c.29.04.58.06.87.06s.58-.02.87-.06l1.02 1.57c.42-.53.96-.95 1.6-1.21l-.6-.93C17.31 13.27 19 10.84 19 8H5c0 2.84 1.69 5.27 4.12 6.37l-3.95 6.08c-.3.46-.17 1.08.29 1.38.46.3 1.08.17 1.38-.29l1-1.55h6.34C14.6 21.16 15.7 22 17 22zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-9.58-8h9.16c-.77 1.76-2.54 3-4.58 3s-3.81-1.24-4.58-3z"
	}), _react.default.createElement("circle", {
	  cx: "17",
	  cy: "19",
	  r: "1",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9.41 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.77-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.22.24.79.67.45 2.04zM11.89 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.78-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.23.24.8.67.45 2.04zM14.41 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.77-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.22.24.79.67.45 2.04z"
	})), 'OutdoorGrillTwoTone');
	
	exports.default = _default;

/***/ },
/* 4428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6l-1-2H5v17h2v-7h5l1 2h7V6h-6zm4 8h-4l-1-2H7V6h5l1 2h5v6z"
	}), 'OutlinedFlag');
	
	exports.default = _default;

/***/ },
/* 4429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6l-1-2H5v17h2v-7h5l1 2h7V6h-6zm4 8h-4l-1-2H7V6h5l1 2h5v6z"
	}), 'OutlinedFlagOutlined');
	
	exports.default = _default;

/***/ },
/* 4430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6l-.72-1.45c-.17-.34-.52-.55-.9-.55H6c-.55 0-1 .45-1 1v15c0 .55.45 1 1 1s1-.45 1-1v-6h5l.72 1.45c.17.34.52.55.89.55H19c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1h-5zm4 8h-4l-1-2H7V6h5l1 2h5v6z"
	}), 'OutlinedFlagRounded');
	
	exports.default = _default;

/***/ },
/* 4431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6l-1-2H5v17h2v-7h5l1 2h7V6h-6zm4 8h-4l-1-2H7V6h5l1 2h5v6z"
	}), 'OutlinedFlagSharp');
	
	exports.default = _default;

/***/ },
/* 4432 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6l-1-2H5v17h2v-7h5l1 2h7V6h-6zm4 8h-4l-1-2H7V6h5l1 2h5v6z"
	}), 'OutlinedFlagTwoTone');
	
	exports.default = _default;

/***/ },
/* 4433 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5v6h5L7 7l4 1V3H5c-1.1 0-2 .9-2 2zm5 8H3v6c0 1.1.9 2 2 2h6v-5l-4 1 1-4zm9 4l-4-1v5h6c1.1 0 2-.9 2-2v-6h-5l1 4zm2-14h-6v5l4-1-1 4h5V5c0-1.1-.9-2-2-2z"
	}), 'Pages');
	
	exports.default = _default;

/***/ },
/* 4434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 2h6v6h-3l1-4-4 1V5zM5 5h6v3L7 7l1 4H5V5zm6 14H5v-6h3l-1 4 4-1v3zm8 0h-6v-3l4 1-1-4h3v6zm-4.37-4.37L12 13.72l-2.63.91.91-2.63-.91-2.63 2.63.91 2.63-.91-.91 2.63.91 2.63z"
	}), 'PagesOutlined');
	
	exports.default = _default;

/***/ },
/* 4435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5v6h5l-.6-2.38c-.18-.74.48-1.4 1.22-1.22L11 8V3H5c-1.1 0-2 .9-2 2zm5 8H3v6c0 1.1.9 2 2 2h6v-5l-2.38.6c-.73.18-1.4-.48-1.21-1.21L8 13zm7.38 3.6L13 16v5h6c1.1 0 2-.9 2-2v-6h-5l.6 2.38c.18.74-.48 1.4-1.22 1.22zM19 3h-6v5l2.38-.6c.73-.18 1.4.48 1.21 1.21L16 11h5V5c0-1.1-.9-2-2-2z"
	}), 'PagesRounded');
	
	exports.default = _default;

/***/ },
/* 4436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 3v8h5L7 7l4 1V3H3zm5 10H3v8h8v-5l-4 1 1-4zm9 4l-4-1v5h8v-8h-5l1 4zm4-14h-8v5l4-1-1 4h5V3z"
	}), 'PagesSharp');
	
	exports.default = _default;

/***/ },
/* 4437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 7l4 1V5H5v6h3zm1 6H5v6h6v-3l-4 1zm9 4l-4-1v3h6v-6h-3zm-4-9l4-1-1 4h3V5h-6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 5h6v3L7 7l1 4H5V5zm6 14H5v-6h3l-1 4 4-1v3zm-1.63-4.37l.91-2.63-.91-2.63 2.63.91 2.63-.91-.91 2.63.91 2.63-2.63-.91-2.63.91zM19 19h-6v-3l4 1-1-4h3v6zm0-8h-3l1-4-4 1V5h6v6z"
	})), 'PagesTwoTone');
	
	exports.default = _default;

/***/ },
/* 4438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.5 9C10.12 9 9 10.12 9 11.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5S12.88 9 11.5 9zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-3.21 14.21l-2.91-2.91c-.69.44-1.51.7-2.39.7C9.01 16 7 13.99 7 11.5S9.01 7 11.5 7 16 9.01 16 11.5c0 .88-.26 1.69-.7 2.39l2.91 2.9-1.42 1.42z"
	}), 'Pageview');
	
	exports.default = _default;

/***/ },
/* 4439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.49 16c.88 0 1.7-.26 2.39-.7l2.44 2.44 1.42-1.42-2.44-2.43c.44-.7.7-1.51.7-2.39C16 9.01 13.99 7 11.5 7S7 9.01 7 11.5 9.01 16 11.49 16zm.01-7c1.38 0 2.5 1.12 2.5 2.5S12.88 14 11.5 14 9 12.88 9 11.5 10.12 9 11.5 9zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
	}), 'PageviewOutlined');
	
	exports.default = _default;

/***/ },
/* 4440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.5 9C10.12 9 9 10.12 9 11.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5S12.88 9 11.5 9zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-3.92 13.5l-2.2-2.2c-.9.58-2.03.84-3.22.62-1.88-.35-3.38-1.93-3.62-3.83-.38-3.01 2.18-5.52 5.21-5.04 1.88.3 3.39 1.84 3.7 3.71.19 1.16-.08 2.23-.64 3.12l2.2 2.19c.39.39.39 1.03 0 1.42-.4.4-1.04.4-1.43.01z"
	}), 'PageviewRounded');
	
	exports.default = _default;

/***/ },
/* 4441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.5 9C10.12 9 9 10.12 9 11.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5S12.88 9 11.5 9zM22 4H2v16h20V4zm-5.21 14.21l-2.91-2.91c-.69.44-1.51.7-2.39.7C9.01 16 7 13.99 7 11.5S9.01 7 11.5 7 16 9.01 16 11.5c0 .88-.26 1.69-.7 2.39l2.91 2.9-1.42 1.42z"
	}), 'PageviewSharp');
	
	exports.default = _default;

/***/ },
/* 4442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 18h16V6H4v12zm7.5-11c2.49 0 4.5 2.01 4.5 4.5 0 .88-.26 1.69-.7 2.39l2.44 2.43-1.42 1.42-2.44-2.44c-.69.44-1.51.7-2.39.7C9.01 16 7 13.99 7 11.5S9.01 7 11.5 7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11.49 16c.88 0 1.7-.26 2.39-.7l2.44 2.44 1.42-1.42-2.44-2.43c.44-.7.7-1.51.7-2.39C16 9.01 13.99 7 11.5 7S7 9.01 7 11.5 9.01 16 11.49 16zm.01-7c1.38 0 2.5 1.12 2.5 2.5S12.88 14 11.5 14 9 12.88 9 11.5 10.12 9 11.5 9zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
	})), 'PageviewTwoTone');
	
	exports.default = _default;

/***/ },
/* 4443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'Palette');
	
	exports.default = _default;

/***/ },
/* 4444 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.04 10 9c0 3.31-2.69 6-6 6h-1.77c-.28 0-.5.22-.5.5 0 .12.05.23.13.33.41.47.64 1.06.64 1.67 0 1.38-1.12 2.5-2.5 2.5zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8c.28 0 .5-.22.5-.5 0-.16-.08-.28-.14-.35-.41-.46-.63-1.05-.63-1.65 0-1.38 1.12-2.5 2.5-2.5H16c2.21 0 4-1.79 4-4 0-3.86-3.59-7-8-7z"
	}), _react.default.createElement("circle", {
	  cx: "6.5",
	  cy: "11.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "9.5",
	  cy: "7.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "14.5",
	  cy: "7.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "17.5",
	  cy: "11.5",
	  r: "1.5"
	})), 'PaletteOutlined');
	
	exports.default = _default;

/***/ },
/* 4445 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'PaletteRounded');
	
	exports.default = _default;

/***/ },
/* 4446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'PaletteSharp');
	
	exports.default = _default;

/***/ },
/* 4447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8c.28 0 .5-.22.5-.5 0-.16-.08-.28-.14-.35-.41-.46-.63-1.05-.63-1.65 0-1.38 1.12-2.5 2.5-2.5H16c2.21 0 4-1.79 4-4 0-3.86-3.59-7-8-7zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 10 6.5 10s1.5.67 1.5 1.5S7.33 13 6.5 13zm3-4C8.67 9 8 8.33 8 7.5S8.67 6 9.5 6s1.5.67 1.5 1.5S10.33 9 9.5 9zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 6 14.5 6s1.5.67 1.5 1.5S15.33 9 14.5 9zm4.5 2.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10c1.38 0 2.5-1.12 2.5-2.5 0-.61-.23-1.21-.64-1.67-.08-.09-.13-.21-.13-.33 0-.28.22-.5.5-.5H16c3.31 0 6-2.69 6-6 0-4.96-4.49-9-10-9zm4 13h-1.77c-1.38 0-2.5 1.12-2.5 2.5 0 .61.22 1.19.63 1.65.06.07.14.19.14.35 0 .28-.22.5-.5.5-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.14 8 7c0 2.21-1.79 4-4 4z"
	}), _react.default.createElement("circle", {
	  cx: "6.5",
	  cy: "11.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "9.5",
	  cy: "7.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "14.5",
	  cy: "7.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "17.5",
	  cy: "11.5",
	  r: "1.5"
	})), 'PaletteTwoTone');
	
	exports.default = _default;

/***/ },
/* 4448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"
	}), 'PanTool');
	
	exports.default = _default;

/***/ },
/* 4449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 24h-6.55c-1.08 0-2.14-.45-2.89-1.23l-7.3-7.61 2.07-1.83c.62-.55 1.53-.66 2.26-.27L8 14.34V4.79c0-1.38 1.12-2.5 2.5-2.5.17 0 .34.02.51.05.09-1.3 1.17-2.33 2.49-2.33.86 0 1.61.43 2.06 1.09.29-.12.61-.18.94-.18 1.38 0 2.5 1.12 2.5 2.5v.28c.16-.03.33-.05.5-.05 1.38 0 2.5 1.12 2.5 2.5V20c0 2.21-1.79 4-4 4zM4.14 15.28l5.86 6.1c.38.39.9.62 1.44.62H18c1.1 0 2-.9 2-2V6.15c0-.28-.22-.5-.5-.5s-.5.22-.5.5V12h-2V3.42c0-.28-.22-.5-.5-.5s-.5.22-.5.5V12h-2V2.51c0-.28-.22-.5-.5-.5s-.5.22-.5.5V12h-2V4.79c0-.28-.22-.5-.5-.5s-.5.23-.5.5v12.87l-5.35-2.83-.51.45z"
	}), 'PanToolOutlined');
	
	exports.default = _default;

/***/ },
/* 4450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.5 4c-.83 0-1.5.67-1.5 1.5v5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-8c0-.83-.67-1.5-1.5-1.5S16 1.67 16 2.5v8c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-9c0-.83-.67-1.5-1.5-1.5S12 .67 12 1.5v8.99c0 .28-.22.5-.5.5s-.5-.22-.5-.5V4.5c0-.83-.67-1.5-1.5-1.5S8 3.67 8 4.5v11.41l-4.12-2.35c-.58-.33-1.3-.24-1.78.22-.6.58-.62 1.54-.03 2.13l6.78 6.89c.75.77 1.77 1.2 2.85 1.2H19c2.21 0 4-1.79 4-4V5.5c0-.83-.67-1.5-1.5-1.5z"
	}), 'PanToolRounded');
	
	exports.default = _default;

/***/ },
/* 4451 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 4v20H10.02L1 14.83 2.9 13 8 15.91V3h3v8h1V0h3v11h1V1h3v10h1V4h3z"
	}), 'PanToolSharp');
	
	exports.default = _default;

/***/ },
/* 4452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19.5 5.65c-.28 0-.5.22-.5.5V12h-2V3.42c0-.28-.22-.5-.5-.5s-.5.22-.5.5V12h-2V2.51c0-.28-.22-.5-.5-.5s-.5.22-.5.5V12h-2V4.79c0-.28-.22-.5-.5-.5s-.5.23-.5.5v12.87l-5.35-2.83-.51.45 5.86 6.1c.38.39.9.62 1.44.62H18c1.1 0 2-.9 2-2V6.15c0-.28-.22-.5-.5-.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19.5 3.65c-.17 0-.34.02-.5.05v-.28c0-1.38-1.12-2.5-2.5-2.5-.33 0-.65.06-.94.18C15.11.44 14.35.01 13.5.01c-1.32 0-2.41 1.03-2.49 2.33-.16-.03-.33-.05-.51-.05-1.38 0-2.5 1.12-2.5 2.5v9.55l-2.41-1.28c-.73-.39-1.64-.28-2.26.27l-2.07 1.83 7.3 7.61c.75.78 1.8 1.23 2.89 1.23H18c2.21 0 4-1.79 4-4V6.15c0-1.38-1.12-2.5-2.5-2.5zM20 20c0 1.1-.9 2-2 2h-6.55c-.54 0-1.07-.22-1.44-.62l-5.86-6.11.51-.45L10 17.66V4.79c0-.28.22-.5.5-.5s.5.23.5.5V12h2V2.51c0-.28.22-.5.5-.5s.5.22.5.5V12h2V3.42c0-.28.22-.5.5-.5s.5.22.5.5V12h2V6.15c0-.28.22-.5.5-.5s.5.22.5.5V20z"
	})), 'PanToolTwoTone');
	
	exports.default = _default;

/***/ },
/* 4453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z"
	}), 'Panorama');
	
	exports.default = _default;

/***/ },
/* 4454 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'PanoramaFishEye');
	
	exports.default = _default;

/***/ },
/* 4455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'PanoramaFishEyeOutlined');
	
	exports.default = _default;

/***/ },
/* 4456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'PanoramaFishEyeRounded');
	
	exports.default = _default;

/***/ },
/* 4457 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'PanoramaFishEyeSharp');
	
	exports.default = _default;

/***/ },
/* 4458 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	})), 'PanoramaFishEyeTwoTone');
	
	exports.default = _default;

/***/ },
/* 4459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16-2.72 0-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7c-3.09 0-6.18-.55-9.12-1.64-.11-.04-.22-.06-.31-.06-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64 3.09 0 6.18.55 9.12 1.64.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z"
	}), 'PanoramaHorizontal');
	
	exports.default = _default;

/***/ },
/* 4460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16s-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7s-6.18-.55-9.12-1.64C2.77 4.02 2.66 4 2.57 4c-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64s6.18.55 9.12 1.64c.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z"
	}), 'PanoramaHorizontalOutlined');
	
	exports.default = _default;

/***/ },
/* 4461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16s-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7s-6.18-.55-9.12-1.64C2.77 4.02 2.66 4 2.57 4c-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64s6.18.55 9.12 1.64c.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z"
	}), 'PanoramaHorizontalRounded');
	
	exports.default = _default;

/***/ },
/* 4462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6.55c2.6.77 5.28 1.16 8 1.16 2.72 0 5.41-.39 8-1.16v10.91c-2.6-.77-5.28-1.16-8-1.16-2.72 0-5.41.39-8 1.16V6.55M2 3.77v16.47s.77-.26.88-.3C5.82 18.85 8.91 18.3 12 18.3c3.09 0 6.18.55 9.12 1.64.11.04.88.3.88.3V3.77s-.77.26-.88.3C18.18 5.15 15.09 5.71 12 5.71s-6.18-.56-9.12-1.64c-.11-.05-.88-.3-.88-.3z"
	}), 'PanoramaHorizontalSharp');
	
	exports.default = _default;

/***/ },
/* 4463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 6.54v10.91c2.6-.77 5.28-1.16 8-1.16s5.4.39 8 1.16V6.54c-2.6.78-5.28 1.17-8 1.16-2.72 0-5.4-.39-8-1.16z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7s-6.18-.55-9.12-1.64C2.77 4.02 2.66 4 2.57 4c-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64s6.18.55 9.12 1.64c.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63zM20 17.45c-2.6-.77-5.28-1.16-8-1.16s-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16v10.91z"
	})), 'PanoramaHorizontalTwoTone');
	
	exports.default = _default;

/***/ },
/* 4464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H3V6h18v12zm-6.5-7L11 15.51 8.5 12.5 5 17h14z"
	}), 'PanoramaOutlined');
	
	exports.default = _default;

/***/ },
/* 4465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.9 12.98l2.1 2.53 3.1-3.99c.2-.26.6-.26.8.01l3.51 4.68c.25.33.01.8-.4.8H6.02c-.42 0-.65-.48-.39-.81L8.12 13c.19-.26.57-.27.78-.02z"
	}), 'PanoramaRounded');
	
	exports.default = _default;

/***/ },
/* 4466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 20V4H1v16h22zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z"
	}), 'PanoramaSharp');
	
	exports.default = _default;

/***/ },
/* 4467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 18h18V6H3v12zm5.5-5.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H3V6h18v12zm-6.5-7L11 15.51 8.5 12.5 5 17h14z"
	})), 'PanoramaTwoTone');
	
	exports.default = _default;

/***/ },
/* 4468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.94 21.12c-1.1-2.94-1.64-6.03-1.64-9.12 0-3.09.55-6.18 1.64-9.12.04-.11.06-.22.06-.31 0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.71 8.91 5.71 12c0 3.09-.55 6.18-1.64 9.12-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57-.01-.1-.03-.2-.07-.31zM6.54 20c.77-2.6 1.16-5.28 1.16-8 0-2.72-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8 0 2.72.39 5.4 1.16 8H6.54z"
	}), 'PanoramaVertical');
	
	exports.default = _default;

/***/ },
/* 4469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.94 21.12c-1.1-2.94-1.64-6.03-1.64-9.12s.55-6.18 1.64-9.12c.04-.11.06-.22.06-.31 0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.71 8.91 5.71 12s-.55 6.18-1.64 9.12c-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57-.01-.1-.03-.2-.07-.31zM6.54 20c.77-2.6 1.16-5.28 1.16-8s-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8s.39 5.4 1.16 8H6.54z"
	}), 'PanoramaVerticalOutlined');
	
	exports.default = _default;

/***/ },
/* 4470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.94 21.12c-1.1-2.94-1.64-6.03-1.64-9.12s.55-6.18 1.64-9.12c.04-.11.06-.22.06-.31 0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.71 8.91 5.71 12s-.55 6.18-1.64 9.12c-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57-.01-.1-.03-.2-.07-.31zM6.54 20c.77-2.6 1.16-5.28 1.16-8s-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8s.39 5.4 1.16 8H6.54z"
	}), 'PanoramaVerticalRounded');
	
	exports.default = _default;

/***/ },
/* 4471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.46 4c-.77 2.6-1.16 5.28-1.16 8 0 2.72.39 5.41 1.16 8H6.55c.77-2.6 1.16-5.28 1.16-8 0-2.72-.39-5.41-1.16-8h10.91m2.78-2H3.77s.26.77.3.88C5.16 5.82 5.71 8.91 5.71 12s-.55 6.18-1.64 9.12c-.04.11-.3.88-.3.88h16.47s-.26-.77-.3-.88c-1.09-2.94-1.64-6.03-1.64-9.12s.55-6.18 1.64-9.12c.04-.11.3-.88.3-.88z"
	}), 'PanoramaVerticalSharp');
	
	exports.default = _default;

/***/ },
/* 4472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6.54 4c.77 2.6 1.16 5.28 1.16 8 0 2.72-.39 5.4-1.16 8h10.91c-.77-2.6-1.16-5.28-1.16-8 0-2.72.39-5.4 1.16-8H6.54z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19.94 21.12c-1.1-2.94-1.64-6.03-1.64-9.12 0-3.09.55-6.18 1.64-9.12.04-.11.06-.22.06-.31 0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.71 8.91 5.71 12c0 3.09-.55 6.18-1.64 9.12-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57-.01-.1-.03-.2-.07-.31zM17.45 20H6.54c.77-2.6 1.16-5.28 1.16-8 0-2.72-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8 0 2.72.39 5.4 1.16 8z"
	})), 'PanoramaVerticalTwoTone');
	
	exports.default = _default;

/***/ },
/* 4473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6c2.45 0 4.71.2 7.29.64.47 1.78.71 3.58.71 5.36 0 1.78-.24 3.58-.71 5.36-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64C4.24 15.58 4 13.78 4 12c0-1.78.24-3.58.71-5.36C7.29 6.2 9.55 6 12 6m0-2c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z"
	}), 'PanoramaWideAngle');
	
	exports.default = _default;

/***/ },
/* 4474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6c2.45 0 4.71.2 7.29.64.47 1.78.71 3.58.71 5.36s-.24 3.58-.71 5.36c-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64C4.24 15.58 4 13.78 4 12s.24-3.58.71-5.36C7.29 6.2 9.55 6 12 6m0-2c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z"
	}), 'PanoramaWideAngleOutlined');
	
	exports.default = _default;

/***/ },
/* 4475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6c2.45 0 4.71.2 7.29.64.47 1.78.71 3.58.71 5.36s-.24 3.58-.71 5.36c-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64C4.24 15.58 4 13.78 4 12s.24-3.58.71-5.36C7.29 6.2 9.55 6 12 6m0-2c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z"
	}), 'PanoramaWideAngleRounded');
	
	exports.default = _default;

/***/ },
/* 4476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6c2.45 0 4.71.2 7.29.64.47 1.78.71 3.58.71 5.36s-.24 3.58-.71 5.36c-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64C4.24 15.58 4 13.78 4 12s.24-3.58.71-5.36C7.29 6.2 9.55 6 12 6m0-2c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z"
	}), 'PanoramaWideAngleSharp');
	
	exports.default = _default;

/***/ },
/* 4477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 6c-2.45 0-4.71.2-7.29.64C4.24 8.42 4 10.22 4 12c0 1.78.24 3.58.71 5.36 2.58.44 4.84.64 7.29.64s4.71-.2 7.29-.64c.47-1.78.71-3.58.71-5.36 0-1.78-.24-3.58-.71-5.36C16.71 6.2 14.45 6 12 6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21.13 5.78l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4s-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22zm-1.84 11.58c-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64C4.24 15.58 4 13.78 4 12c0-1.78.24-3.58.71-5.36C7.29 6.2 9.55 6 12 6s4.71.2 7.29.64c.47 1.78.71 3.58.71 5.36 0 1.78-.24 3.58-.71 5.36z"
	})), 'PanoramaWideAngleTwoTone');
	
	exports.default = _default;

/***/ },
/* 4478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 3c1.63 0 3.06.79 3.98 2H12c-1.66 0-3 1.34-3 3 0 .35.07.69.18 1H7.1c-.06-.32-.1-.66-.1-1 0-2.76 2.24-5 5-5zm0 10c-1.63 0-3.06-.79-3.98-2H12c1.66 0 3-1.34 3-3 0-.35-.07-.69-.18-1h2.08c.07.32.1.66.1 1 0 2.76-2.24 5-5 5z"
	}), 'PartyMode');
	
	exports.default = _default;

/***/ },
/* 4479 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h4.05l.59-.65L9.88 4h4.24l1.24 1.35.59.65H20v12zM9 12c0-1.66 1.34-3 3-3h3.98c-.92-1.21-2.35-2-3.98-2-2.76 0-5 2.24-5 5 0 .34.04.68.1 1h2.08c-.11-.31-.18-.65-.18-1zm6 0c0 1.66-1.34 3-3 3H8.02c.92 1.21 2.35 2 3.98 2 2.76 0 5-2.24 5-5 0-.34-.03-.68-.1-1h-2.08c.11.31.18.65.18 1z"
	}), 'PartyModeOutlined');
	
	exports.default = _default;

/***/ },
/* 4480 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4h-3.17l-1.24-1.35c-.37-.41-.91-.65-1.47-.65H9.88c-.56 0-1.1.24-1.48.65L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 3c1.63 0 3.06.79 3.98 2H12c-1.66 0-3 1.34-3 3 0 .35.07.69.18 1H7.1c-.06-.32-.1-.66-.1-1 0-2.76 2.24-5 5-5zm0 10c-1.63 0-3.06-.79-3.98-2H12c1.66 0 3-1.34 3-3 0-.35-.07-.69-.18-1h2.08c.07.32.1.66.1 1 0 2.76-2.24 5-5 5z"
	}), 'PartyModeRounded');
	
	exports.default = _default;

/***/ },
/* 4481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 4h-5.17L15 2H9L7.17 4H2v16h20V4zM12 7c1.63 0 3.06.79 3.98 2H12c-1.66 0-3 1.34-3 3 0 .35.07.69.18 1H7.1c-.06-.32-.1-.66-.1-1 0-2.76 2.24-5 5-5zm0 10c-1.63 0-3.06-.79-3.98-2H12c1.66 0 3-1.34 3-3 0-.35-.07-.69-.18-1h2.08c.07.32.1.66.1 1 0 2.76-2.24 5-5 5z"
	}), 'PartyModeSharp');
	
	exports.default = _default;

/***/ },
/* 4482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.95 6l-.59-.65L14.12 4H9.88L8.65 5.35l-.6.65H4v12h16V6h-4.05zM7 12c0-2.76 2.24-5 5-5 1.63 0 3.06.79 3.98 2H12c-1.66 0-3 1.34-3 3 0 .35.07.69.18 1H7.1c-.06-.32-.1-.66-.1-1zm10 0c0 2.76-2.24 5-5 5-1.63 0-3.06-.79-3.98-2H12c1.66 0 3-1.34 3-3 0-.35-.07-.69-.18-1h2.08c.07.32.1.66.1 1z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h4.05l.59-.65L9.88 4h4.24l1.24 1.35.59.65H20v12zM9 12c0-1.66 1.34-3 3-3h3.98c-.92-1.21-2.35-2-3.98-2-2.76 0-5 2.24-5 5 0 .34.04.68.1 1h2.08c-.11-.31-.18-.65-.18-1zm6 0c0 1.66-1.34 3-3 3H8.02c.92 1.21 2.35 2 3.98 2 2.76 0 5-2.24 5-5 0-.34-.03-.68-.1-1h-2.08c.11.31.18.65.18 1z"
	})), 'PartyModeTwoTone');
	
	exports.default = _default;

/***/ },
/* 4483 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
	}), 'Pause');
	
	exports.default = _default;

/***/ },
/* 4484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"
	}), 'PauseCircleFilled');
	
	exports.default = _default;

/***/ },
/* 4485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"
	}), 'PauseCircleFilledOutlined');
	
	exports.default = _default;

/***/ },
/* 4486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1zm4 0c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1z"
	}), 'PauseCircleFilledRounded');
	
	exports.default = _default;

/***/ },
/* 4487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"
	}), 'PauseCircleFilledSharp');
	
	exports.default = _default;

/***/ },
/* 4488 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm-1 12H9V8h2v8zm4 0h-2V8h2v8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M13 8h2v8h-2zM9 8h2v8H9z"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	})), 'PauseCircleFilledTwoTone');
	
	exports.default = _default;

/***/ },
/* 4489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z"
	}), 'PauseCircleOutline');
	
	exports.default = _default;

/***/ },
/* 4490 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z"
	}), 'PauseCircleOutlineOutlined');
	
	exports.default = _default;

/***/ },
/* 4491 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 16c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1zm2-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm2-4c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1z"
	}), 'PauseCircleOutlineRounded');
	
	exports.default = _default;

/***/ },
/* 4492 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z"
	}), 'PauseCircleOutlineSharp');
	
	exports.default = _default;

/***/ },
/* 4493 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 8h2v8h-2zM9 8h2v8H9zm3 14c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zm0-18c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8z"
	}), 'PauseCircleOutlineTwoTone');
	
	exports.default = _default;

/***/ },
/* 4494 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
	}), 'PauseOutlined');
	
	exports.default = _default;

/***/ },
/* 4495 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21 19.1H3V5h18v14.1zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), _react.default.createElement("path", {
	  d: "M9 8h2v8H9zm4 0h2v8h-2z"
	})), 'PausePresentation');
	
	exports.default = _default;

/***/ },
/* 4496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .85-2 1.95v14c0 1.1.9 2.05 2 2.05h18c1.1 0 2-.95 2-2.05v-14C23 3.85 22.1 3 21 3zm0 16H3V5h18v14zM9 8h2v8H9zm4 0h2v8h-2z"
	}), 'PausePresentationOutlined');
	
	exports.default = _default;

/***/ },
/* 4497 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 15c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v12zM10 8c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1s1-.45 1-1V9c0-.55-.45-1-1-1zm4 0c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1s1-.45 1-1V9c0-.55-.45-1-1-1z"
	}), 'PausePresentationRounded');
	
	exports.default = _default;

/***/ },
/* 4498 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 3v18h22V3H1zm20 16H3V5h18v14zM9 8h2v8H9zm4 0h2v8h-2z"
	}), 'PausePresentationSharp');
	
	exports.default = _default;

/***/ },
/* 4499 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 19h18V5H3v14zM13 8h2v8h-2V8zM9 8h2v8H9V8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM9 8h2v8H9zm4 0h2v8h-2z"
	})), 'PausePresentationTwoTone');
	
	exports.default = _default;

/***/ },
/* 4500 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 19c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2s-2 .9-2 2v10c0 1.1.9 2 2 2zm6-12v10c0 1.1.9 2 2 2s2-.9 2-2V7c0-1.1-.9-2-2-2s-2 .9-2 2z"
	}), 'PauseRounded');
	
	exports.default = _default;

/***/ },
/* 4501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
	}), 'PauseSharp');
	
	exports.default = _default;

/***/ },
/* 4502 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 5h4v14H6zm8 0h4v14h-4z"
	}), 'PauseTwoTone');
	
	exports.default = _default;

/***/ },
/* 4503 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
	}), 'Payment');
	
	exports.default = _default;

/***/ },
/* 4504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
	}), 'PaymentOutlined');
	
	exports.default = _default;

/***/ },
/* 4505 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm-1 14H5c-.55 0-1-.45-1-1v-5h16v5c0 .55-.45 1-1 1zm1-10H4V7c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v1z"
	}), 'PaymentRounded');
	
	exports.default = _default;

/***/ },
/* 4506 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 4H2v16h20V4zm-2 14H4v-6h16v6zm0-10H4V6h16v2z"
	}), 'PaymentSharp');
	
	exports.default = _default;

/***/ },
/* 4507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 6h16v2H4zm0 6h16v6H4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
	})), 'PaymentTwoTone');
	
	exports.default = _default;

/***/ },
/* 4508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
	}), 'People');
	
	exports.default = _default;

/***/ },
/* 4509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillRule: "evenodd",
	  d: "M16.67 13.13C18.04 14.06 19 15.32 19 17v3h4v-3c0-2.18-3.57-3.47-6.33-3.87z"
	}), _react.default.createElement("circle", {
	  cx: "9",
	  cy: "8",
	  r: "4",
	  fillRule: "evenodd"
	}), _react.default.createElement("path", {
	  fillRule: "evenodd",
	  d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4c-.47 0-.91.1-1.33.24C14.5 5.27 15 6.58 15 8s-.5 2.73-1.33 3.76c.42.14.86.24 1.33.24zM9 13c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
	})), 'PeopleAlt');
	
	exports.default = _default;

/***/ },
/* 4510 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.67 13.13C18.04 14.06 19 15.32 19 17v3h4v-3c0-2.18-3.57-3.47-6.33-3.87zM15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4c-.47 0-.91.1-1.33.24C14.5 5.27 15 6.58 15 8s-.5 2.73-1.33 3.76c.42.14.86.24 1.33.24zM9 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM9 13c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm6 5H3v-.99C3.2 16.29 6.3 15 9 15s5.8 1.29 6 2v1z"
	}), 'PeopleAltOutlined');
	
	exports.default = _default;

/***/ },
/* 4511 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillRule: "evenodd",
	  d: "M16.67 13.13C18.04 14.06 19 15.32 19 17v3h3c.55 0 1-.45 1-1v-2c0-2.18-3.57-3.47-6.33-3.87z"
	}), _react.default.createElement("circle", {
	  cx: "9",
	  cy: "8",
	  r: "4",
	  fillRule: "evenodd"
	}), _react.default.createElement("path", {
	  fillRule: "evenodd",
	  d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4c-.47 0-.91.1-1.33.24C14.5 5.27 15 6.58 15 8s-.5 2.73-1.33 3.76c.42.14.86.24 1.33.24zM9 13c-2.67 0-8 1.34-8 4v2c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-2c0-2.66-5.33-4-8-4z"
	})), 'PeopleAltRounded');
	
	exports.default = _default;

/***/ },
/* 4512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillRule: "evenodd",
	  d: "M16.67 13.13C18.04 14.06 19 15.32 19 17v3h4v-3c0-2.18-3.57-3.47-6.33-3.87z"
	}), _react.default.createElement("circle", {
	  cx: "9",
	  cy: "8",
	  r: "4",
	  fillRule: "evenodd"
	}), _react.default.createElement("path", {
	  fillRule: "evenodd",
	  d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4c-.47 0-.91.1-1.33.24C14.5 5.27 15 6.58 15 8s-.5 2.73-1.33 3.76c.42.14.86.24 1.33.24zM9 13c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
	})), 'PeopleAltSharp');
	
	exports.default = _default;

/***/ },
/* 4513 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "9",
	  cy: "8",
	  r: "2",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9 15c-2.7 0-5.8 1.29-6 2.01V18h12v-1c-.2-.71-3.3-2-6-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16.67 13.13C18.04 14.06 19 15.32 19 17v3h4v-3c0-2.18-3.57-3.47-6.33-3.87zM15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4c-.47 0-.91.1-1.33.24C14.5 5.27 15 6.58 15 8s-.5 2.73-1.33 3.76c.42.14.86.24 1.33.24zM9 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM9 13c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm6 5H3v-.99C3.2 16.29 6.3 15 9 15s5.8 1.29 6 2v1z"
	})), 'PeopleAltTwoTone');
	
	exports.default = _default;

/***/ },
/* 4514 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"
	}), 'PeopleOutline');
	
	exports.default = _default;

/***/ },
/* 4515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 13.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zM9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm7.04 6.81c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z"
	}), 'PeopleOutlineOutlined');
	
	exports.default = _default;

/***/ },
/* 4516 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm0 6.75c-2.34 0-7 1.17-7 3.5V18c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zm11.7-3.19c1.16.84 1.96 1.96 1.96 3.44V19h3c.55 0 1-.45 1-1v-.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z"
	}), 'PeopleOutlineRounded');
	
	exports.default = _default;

/***/ },
/* 4517 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm0 6.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zm11.7-3.19c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z"
	}), 'PeopleOutlineSharp');
	
	exports.default = _default;

/***/ },
/* 4518 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "9",
	  cy: "8.5",
	  r: "1.5",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4.34 17h9.32c-.84-.58-2.87-1.25-4.66-1.25s-3.82.67-4.66 1.25z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm0 6.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zm11.7-3.19c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z"
	})), 'PeopleOutlineTwoTone');
	
	exports.default = _default;

/***/ },
/* 4519 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 13.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zM9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm7.04 6.81c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z"
	}), 'PeopleOutlined');
	
	exports.default = _default;

/***/ },
/* 4520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V18c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05.02.01.03.03.04.04 1.14.83 1.93 1.94 1.93 3.41V18c0 .35-.07.69-.18 1H22c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5z"
	}), 'PeopleRounded');
	
	exports.default = _default;

/***/ },
/* 4521 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
	}), 'PeopleSharp');
	
	exports.default = _default;

/***/ },
/* 4522 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "9",
	  cy: "8.5",
	  r: "1.5",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4.34 17h9.32c-.84-.58-2.87-1.25-4.66-1.25s-3.82.67-4.66 1.25z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm0 6.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zm11.7-3.19c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z"
	})), 'PeopleTwoTone');
	
	exports.default = _default;

/***/ },
/* 4523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v-2.09c-2.83-.48-5-2.94-5-5.91h2c0 2.21 1.79 4 4 4s4-1.79 4-4h2c0 2.97-2.17 5.43-5 5.91V21h7c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-6 8c0 1.1-.9 2-2 2s-2-.9-2-2V9c0-1.1.9-2 2-2s2 .9 2 2v4z"
	}), 'PermCameraMic');
	
	exports.default = _default;

/***/ },
/* 4524 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2s2-.9 2-2V8c0-1.1-.9-2-2-2zm8-1h-3.17l-1.86-2H8.96L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-7v-1.09c2.83-.48 5-2.94 5-5.91h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6c0 2.97 2.17 5.43 5 5.91V19H4V7h4.21l.59-.65L10.04 5h4.24l1.24 1.35.59.65H20v12z"
	}), 'PermCameraMicOutlined');
	
	exports.default = _default;

/***/ },
/* 4525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 5h-3.17l-1.24-1.35c-.37-.41-.91-.65-1.47-.65H9.88c-.56 0-1.1.24-1.48.65L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v-2.09c-2.45-.42-4.41-2.32-4.89-4.75-.12-.61.38-1.16.99-1.16.49 0 .88.35.98.83C8.47 15.64 10.07 17 12 17s3.53-1.36 3.91-3.17c.1-.48.5-.83.98-.83.61 0 1.11.55.99 1.16-.48 2.43-2.44 4.34-4.89 4.75V21h7c1.1 0 2-.9 2-2V7C22 5.9 21.1 5 20 5zm-6 8c0 1.1-.9 2-2 2s-2-.9-2-2V9c0-1.1.9-2 2-2s2 .9 2 2v4z"
	}), 'PermCameraMicRounded');
	
	exports.default = _default;

/***/ },
/* 4526 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 5h-5.17L15 3H9L7.17 5H2v16h9v-2.09c-2.83-.48-5-2.94-5-5.91h2c0 2.21 1.79 4 4 4s4-1.79 4-4h2c0 2.97-2.17 5.43-5 5.91V21h9V5zm-8 8c0 1.1-.9 2-2 2s-2-.9-2-2V9c0-1.1.9-2 2-2s2 .9 2 2v4z"
	}), 'PermCameraMicSharp');
	
	exports.default = _default;

/***/ },
/* 4527 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16.11 7l-.59-.65L14.28 5h-4.24L8.81 6.35l-.6.65H4v12h7v-1.09c-2.83-.48-5-2.94-5-5.91h2c0 2.21 1.79 4 4 4s4-1.79 4-4h2c0 2.97-2.17 5.43-5 5.91V19h7V7h-3.89zM14 12c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-1.1.9-2 2-2s2 .9 2 2v4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 6c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2s2-.9 2-2V8c0-1.1-.9-2-2-2zm8-1h-3.17l-1.86-2H8.96L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-7v-1.09c2.83-.48 5-2.94 5-5.91h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6c0 2.97 2.17 5.43 5 5.91V19H4V7h4.21l.59-.65L10.04 5h4.24l1.24 1.35.59.65H20v12z"
	})), 'PermCameraMicTwoTone');
	
	exports.default = _default;

/***/ },
/* 4528 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z"
	}), 'PermContactCalendar');
	
	exports.default = _default;

/***/ },
/* 4529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.84 4.22c-.05-.12-.11-.23-.18-.34-.14-.21-.33-.4-.54-.54-.11-.07-.22-.13-.34-.18-.24-.1-.5-.16-.78-.16h-1V1h-2v2H8V1H6v2H5c-.42 0-.8.13-1.12.34-.21.14-.4.33-.54.54-.07.11-.13.22-.18.34-.1.24-.16.5-.16.78v14c0 1.1.89 2 2 2h14c.28 0 .54-.06.78-.16.12-.05.23-.11.34-.18.21-.14.4-.33.54-.54.21-.32.34-.71.34-1.12V5c0-.28-.06-.54-.16-.78zM5 19V5h14v14H5zm7-6.12c-2.03 0-6 1.08-6 3.58V18h12v-1.53c0-2.51-3.97-3.59-6-3.59zM8.31 16c.69-.56 2.38-1.12 3.69-1.12s3.01.56 3.69 1.12H8.31zM12 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
	}), 'PermContactCalendarOutlined');
	
	exports.default = _default;

/***/ },
/* 4530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1H8V2c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-1.11 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z"
	}), 'PermContactCalendarRounded');
	
	exports.default = _default;

/***/ },
/* 4531 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3h-3V1h-2v2H8V1H6v2H3v18h18V3zm-9 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z"
	}), 'PermContactCalendarSharp');
	
	exports.default = _default;

/***/ },
/* 4532 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16 5H5v14h14V5h-3zm-4 1c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zm6 12H6v-1.53c0-2.5 3.97-3.58 6-3.58s6 1.08 6 3.58V18z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20.84 4.22c-.05-.12-.11-.23-.18-.34-.14-.21-.33-.4-.54-.54-.11-.07-.22-.13-.34-.18-.24-.1-.5-.16-.78-.16h-1V1h-2v2H8V1H6v2H5c-.42 0-.8.13-1.12.34-.21.14-.4.33-.54.54-.07.11-.13.22-.18.34-.1.24-.16.5-.16.78v14c0 1.1.89 2 2 2h14c.28 0 .54-.06.78-.16.12-.05.23-.11.34-.18.21-.14.4-.33.54-.54.21-.32.34-.71.34-1.12V5c0-.28-.06-.54-.16-.78zM19 19H5V5h14v14zm-7-6.12c-2.03 0-6 1.08-6 3.58V18h12v-1.53c0-2.51-3.97-3.59-6-3.59zM8.31 16c.69-.56 2.38-1.12 3.69-1.12s3.01.56 3.69 1.12H8.31zM12 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
	})), 'PermContactCalendarTwoTone');
	
	exports.default = _default;

/***/ },
/* 4533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.99 11.5c.34 0 .67.03 1 .07L20 0 0 20h11.56c-.04-.33-.07-.66-.07-1 0-4.14 3.36-7.5 7.5-7.5zm3.71 7.99c.02-.16.04-.32.04-.49 0-.17-.01-.33-.04-.49l1.06-.83c.09-.08.12-.21.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83c-.02.16-.03.32-.03.49 0 .17.01.33.03.49l-1.06.83c-.09.08-.12.21-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73c.06-.11.03-.24-.06-.32l-1.07-.83zm-3.71 1.01c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'PermDataSetting');
	
	exports.default = _default;

/***/ },
/* 4534 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.99 11.57H20V0L0 20h11.56v-2H4.83L17.99 4.83v6.74zm5.78 8.75l-1.07-.83c.02-.16.04-.32.04-.49 0-.17-.01-.33-.04-.49l1.06-.83c.09-.08.12-.21.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83c-.02.16-.03.32-.03.49 0 .17.01.33.03.49l-1.06.83c-.09.08-.12.21-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73c.06-.11.03-.24-.06-.32zm-4.78.18c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'PermDataSettingOutlined');
	
	exports.default = _default;

/***/ },
/* 4535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.99 11.5c.34 0 .68.03 1.01.07V2.42c0-.89-1.08-1.34-1.71-.71L1.71 18.29c-.63.63-.19 1.71.7 1.71h9.15c-.04-.33-.07-.66-.07-1 0-4.14 3.36-7.5 7.5-7.5zm3.71 7.99c.02-.16.04-.32.04-.49s-.01-.33-.04-.49l1.06-.83c.09-.08.12-.21.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83c-.02.16-.03.32-.03.49s.01.33.03.49l-1.06.83c-.09.08-.12.21-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73c.06-.11.03-.24-.06-.32l-1.07-.83zm-3.71 1.01c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'PermDataSettingRounded');
	
	exports.default = _default;

/***/ },
/* 4536 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.99 11.5c.34 0 .67.03 1 .07L20 0 0 20h11.56c-.04-.33-.07-.66-.07-1 0-4.14 3.36-7.5 7.5-7.5zm3.71 7.99c.02-.16.04-.32.04-.49s-.01-.33-.04-.49l1.06-.83c.09-.08.12-.21.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83c-.02.16-.03.32-.03.49s.01.33.03.49l-1.06.83c-.09.08-.12.21-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73c.06-.11.03-.24-.06-.32l-1.07-.83zm-3.71 1.01c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'PermDataSettingSharp');
	
	exports.default = _default;

/***/ },
/* 4537 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.99 11.57H20V0L0 20h11.56v-2H4.83L17.99 4.83v6.74zm5.78 8.75l-1.07-.83c.02-.16.04-.32.04-.49 0-.17-.01-.33-.04-.49l1.06-.83c.09-.08.12-.21.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83c-.02.16-.03.32-.03.49 0 .17.01.33.03.49l-1.06.83c-.09.08-.12.21-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73c.06-.11.03-.24-.06-.32zm-4.78.18c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'PermDataSettingTwoTone');
	
	exports.default = _default;

/***/ },
/* 4538 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 7h-2v2h2V7zm0 4h-2v6h2v-6zm4-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
	}), 'PermDeviceInformation');
	
	exports.default = _default;

/***/ },
/* 4539 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 7h2v2h-2zm0 4h2v6h-2zm6-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zM7 4V3h10v1H7z"
	}), 'PermDeviceInformationOutlined');
	
	exports.default = _default;

/***/ },
/* 4540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 7h-2v2h2V7zm-1 4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1zm5-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
	}), 'PermDeviceInformationRounded');
	
	exports.default = _default;

/***/ },
/* 4541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 7h-2v2h2V7zm0 4h-2v6h2v-6zM5 1v22h14V1H5zm12 18H7V5h10v14z"
	}), 'PermDeviceInformationSharp');
	
	exports.default = _default;

/***/ },
/* 4542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 20h10v1H7zM7 3h10v1H7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11 7h2v2h-2zm0 4h2v6h-2zm6-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zm0-14H7V3h10v1z"
	})), 'PermDeviceInformationTwoTone');
	
	exports.default = _default;

/***/ },
/* 4543 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
	}), 'PermIdentity');
	
	exports.default = _default;

/***/ },
/* 4544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 9c2.7 0 5.8 1.29 6 2v1H6v-.99c.2-.72 3.3-2.01 6-2.01m0-11C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
	}), 'PermIdentityOutlined');
	
	exports.default = _default;

/***/ },
/* 4545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 7c-2.67 0-8 1.34-8 4v2c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-2c0-2.66-5.33-4-8-4zm6 5H6v-.99c.2-.72 3.3-2.01 6-2.01s5.8 1.29 6 2v1z"
	}), 'PermIdentityRounded');
	
	exports.default = _default;

/***/ },
/* 4546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 7c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm6 5H6v-.99c.2-.72 3.3-2.01 6-2.01s5.8 1.29 6 2v1z"
	}), 'PermIdentitySharp');
	
	exports.default = _default;

/***/ },
/* 4547 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "8",
	  r: "2",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 15c-2.7 0-5.8 1.29-6 2.01V18h12v-1c-.2-.71-3.3-2-6-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 7c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm6 5H6v-.99c.2-.72 3.3-2.01 6-2.01s5.8 1.29 6 2v1z"
	})), 'PermIdentityTwoTone');
	
	exports.default = _default;

/***/ },
/* 4548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm20-2h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 15l4.5-6 3.5 4.51 2.5-3.01L21 15H7z"
	}), 'PermMedia');
	
	exports.default = _default;

/***/ },
/* 4549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm5 9h14l-3.5-4.5-2.5 3.01L11.5 9zM22 4h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 12H6V4h5.17l1.41 1.41.59.59H22v10z"
	}), 'PermMediaOutlined');
	
	exports.default = _default;

/***/ },
/* 4550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 6c-.55 0-1 .45-1 1v4h.01L0 20c0 1.1.9 2 2 2h17c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1zm21-2h-8l-1.41-1.41c-.38-.38-.89-.59-1.42-.59H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.6 14.2l3.51-4.68c.2-.26.59-.27.8-.01l3.1 3.99 2.1-2.53c.2-.25.58-.24.78.01l2.49 3.2c.26.33.02.81-.39.81H8c-.41.01-.65-.46-.4-.79z"
	}), 'PermMediaRounded');
	
	exports.default = _default;

/***/ },
/* 4551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 6H0v16h20v-2H2V6zm22-2H14l-2-2H4v16h20V4zM7 15l4.5-6 3.5 4.51 2.5-3.01L21 15H7z"
	}), 'PermMediaSharp');
	
	exports.default = _default;

/***/ },
/* 4552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M13.17 6l-.59-.59L11.17 4H6v12h16V6h-8.83zm4.33 4.5L21 15H7l4.5-6 3.5 4.51 2.5-3.01z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm5 9h14l-3.5-4.5-2.5 3.01L11.5 9zM22 4h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 12H6V4h5.17l1.41 1.41.59.59H22v10z"
	})), 'PermMediaTwoTone');
	
	exports.default = _default;

/***/ },
/* 4553 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12 3v10l3-3h6V3h-9z"
	}), 'PermPhoneMsg');
	
	exports.default = _default;

/***/ },
/* 4554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.46 2.59L5.79 8.8c-.41-1.21-.67-2.48-.76-3.8zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM12 3v10l3-3h6V3h-9zm7 5h-5V5h5v3z"
	}), 'PermPhoneMsgOutlined');
	
	exports.default = _default;

/***/ },
/* 4555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 3h-7c-.55 0-1 .45-1 1v9l3-3h5c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm-.77 12.26l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z"
	}), 'PermPhoneMsgRounded');
	
	exports.default = _default;

/***/ },
/* 4556 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3v10l3-3h6V3zm1.21 14.37c-2.83-1.44-5.15-3.75-6.59-6.59l2.53-2.53L8.54 3H3.03C2.45 13.18 10.82 21.55 21 20.97v-5.51l-5.27-.61-2.52 2.52z"
	}), 'PermPhoneMsgSharp');
	
	exports.default = _default;

/***/ },
/* 4557 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.2 18.21c1.21.41 2.48.67 3.8.76v-1.5c-.88-.07-1.75-.22-2.6-.45l-1.2 1.19zM6.54 5h-1.5c.09 1.32.35 2.59.75 3.79l1.2-1.21c-.24-.83-.39-1.7-.45-2.58zM14 8h5V5h-5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.46 2.59L5.79 8.8c-.41-1.21-.67-2.48-.76-3.8zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM12 3v10l3-3h6V3h-9zm7 5h-5V5h5v3z"
	})), 'PermPhoneMsgTwoTone');
	
	exports.default = _default;

/***/ },
/* 4558 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zm1 13h-2v-6h2v6zm-2-8V6h2v2h-2z"
	}), 'PermScanWifi');
	
	exports.default = _default;

/***/ },
/* 4559 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zM2.92 7.65C5.8 5.85 8.74 5 12 5c3.25 0 6.18.85 9.08 2.67L12 18.83 2.92 7.65zM11 10h2v6h-2zm0-4h2v2h-2z"
	}), 'PermScanWifiOutlined');
	
	exports.default = _default;

/***/ },
/* 4560 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3C7.41 3 3.86 4.53.89 6.59c-.49.33-.59 1-.22 1.46l9.78 12.04c.8.98 2.3.99 3.1 0l9.78-12.02c.37-.46.27-1.13-.22-1.46C20.14 4.54 16.59 3 12 3zm0 13c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm-1-8V6h2v2h-2z"
	}), 'PermScanWifiRounded');
	
	exports.default = _default;

/***/ },
/* 4561 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zm1 13h-2v-6h2v6zm-2-8V6h2v2h-2z"
	}), 'PermScanWifiSharp');
	
	exports.default = _default;

/***/ },
/* 4562 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 5c-3.26 0-6.2.85-9.08 2.65L12 18.83l9.08-11.16C18.18 5.85 15.25 5 12 5zm1 11h-2v-6h2v6zm-2-8V6h2v2h-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zM2.92 7.65C5.8 5.85 8.74 5 12 5c3.25 0 6.18.85 9.08 2.67L12 18.83 2.92 7.65zM11 10h2v6h-2zm0-4h2v2h-2z"
	})), 'PermScanWifiTwoTone');
	
	exports.default = _default;

/***/ },
/* 4563 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
	}), 'Person');
	
	exports.default = _default;

/***/ },
/* 4564 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
	}), 'PersonAdd');
	
	exports.default = _default;

/***/ },
/* 4565 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "15",
	  cy: "8",
	  r: "4"
	}), _react.default.createElement("path", {
	  d: "M23 20v-2c0-2.3-4.1-3.7-6.9-3.9l6 5.9h.9zm-11.6-5.5C9.2 15.1 7 16.3 7 18v2h9.9l4 4 1.3-1.3-21-20.9L0 3.1l4 4V10H1v2h3v3h2v-3h2.9l2.5 2.5zM6 10v-.9l.9.9H6z"
	})), 'PersonAddDisabled');
	
	exports.default = _default;

/***/ },
/* 4566 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 6c1.1 0 2 .9 2 2 0 .99-.73 1.82-1.67 1.97l-2.31-2.31C13.19 6.72 14.01 6 15 6m0-2c-2.21 0-4 1.79-4 4 0 .18.03.35.05.52l3.43 3.43c.17.02.34.05.52.05 2.21 0 4-1.79 4-4s-1.79-4-4-4zm1.69 10.16L22.53 20H23v-2c0-2.14-3.56-3.5-6.31-3.84zm-3.68 1.97L14.88 18H9c.08-.24.88-1.01 2.91-1.57l1.1-.3M1.41 1.71L0 3.12l4 4V10H1v2h3v3h2v-3h2.88l2.51 2.51C9.19 15.11 7 16.3 7 18v2h9.88l4 4 1.41-1.41L1.41 1.71zM6 10v-.88l.88.88H6z"
	}), 'PersonAddDisabledOutlined');
	
	exports.default = _default;

/***/ },
/* 4567 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.48 11.95c.17.02.34.05.52.05 2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4c0 .18.03.35.05.52l3.43 3.43zm2.21 2.21l5.74 5.74c.33-.17.57-.5.57-.9v-1c0-2.14-3.56-3.5-6.31-3.84zM2.12 2.42a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L4 7.12V10H2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2.88l2.51 2.51C9.19 15.11 7 16.3 7 18v1c0 .55.45 1 1 1h8.88l3.29 3.29c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L2.12 2.42zM6 10v-.88l.88.88H6z"
	}), 'PersonAddDisabledRounded');
	
	exports.default = _default;

/***/ },
/* 4568 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.48 11.95c.17.02.34.05.52.05 2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4c0 .18.03.35.05.52l3.43 3.43zm2.21 2.21L22.53 20H23v-2c0-2.14-3.56-3.5-6.31-3.84zM0 3.12l4 4V10H1v2h3v3h2v-3h2.88l2.51 2.51C9.19 15.11 7 16.3 7 18v2h9.88l4 4 1.41-1.41L1.41 1.71 0 3.12zM6.88 10H6v-.88l.88.88z"
	}), 'PersonAddDisabledSharp');
	
	exports.default = _default;

/***/ },
/* 4569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9 18h5.87L13 16.13l-1.1.3C9.89 16.99 9.08 17.76 9 18zm8-10c0-1.1-.9-2-2-2-.99 0-1.81.72-1.97 1.67l2.31 2.31C16.27 9.82 17 8.99 17 8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M14.48 11.95c.17.02.34.05.52.05 2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4c0 .18.03.35.05.52l3.43 3.43zM15 6c1.1 0 2 .9 2 2 0 .99-.73 1.82-1.67 1.97l-2.31-2.31C13.19 6.72 14.01 6 15 6zm1.69 8.16L22.53 20H23v-2c0-2.14-3.56-3.5-6.31-3.84zM0 3.12l4 4V10H1v2h3v3h2v-3h2.88l2.51 2.51C9.19 15.11 7 16.3 7 18v2h9.88l4 4 1.41-1.41L1.41 1.71 0 3.12zm13.01 13.01L14.88 18H9c.08-.24.88-1.01 2.91-1.57l1.1-.3zM6 9.12l.88.88H6v-.88z"
	})), 'PersonAddDisabledTwoTone');
	
	exports.default = _default;

/***/ },
/* 4570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H9zm-3-3v-3h3v-2H6V7H4v3H1v2h3v3z"
	}), 'PersonAddOutlined');
	
	exports.default = _default;

/***/ },
/* 4571 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V8c0-.55-.45-1-1-1s-1 .45-1 1v2H2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1H6zm9 4c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4z"
	}), 'PersonAddRounded');
	
	exports.default = _default;

/***/ },
/* 4572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
	}), 'PersonAddSharp');
	
	exports.default = _default;

/***/ },
/* 4573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15 16c-2.69 0-5.77 1.28-6 2h12c-.2-.71-3.3-2-6-2z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "15",
	  cy: "8",
	  r: "2",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H9zm-3-3v-3h3v-2H6V7H4v3H1v2h3v3z"
	})), 'PersonAddTwoTone');
	
	exports.default = _default;

/***/ },
/* 4574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
	}), 'PersonOutline');
	
	exports.default = _default;

/***/ },
/* 4575 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
	}), 'PersonOutlineOutlined');
	
	exports.default = _default;

/***/ },
/* 4576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v2c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-2c0-2.66-5.33-4-8-4z"
	}), 'PersonOutlineRounded');
	
	exports.default = _default;

/***/ },
/* 4577 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
	}), 'PersonOutlineSharp');
	
	exports.default = _default;

/***/ },
/* 4578 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "8",
	  r: "2.1",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 14.9c-2.97 0-6.1 1.46-6.1 2.1v1.1h12.2V17c0-.64-3.13-2.1-6.1-2.1z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 13c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm6.1 5.1H5.9V17c0-.64 3.13-2.1 6.1-2.1s6.1 1.46 6.1 2.1v1.1zM12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6.1c1.16 0 2.1.94 2.1 2.1 0 1.16-.94 2.1-2.1 2.1S9.9 9.16 9.9 8c0-1.16.94-2.1 2.1-2.1z"
	})), 'PersonOutlineTwoTone');
	
	exports.default = _default;

/***/ },
/* 4579 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
	}), 'PersonOutlined');
	
	exports.default = _default;

/***/ },
/* 4580 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2c-4.97 0-9 4.03-9 9 0 4.17 2.84 7.67 6.69 8.69L12 22l2.31-2.31C18.16 18.67 21 15.17 21 11c0-4.97-4.03-9-9-9zm0 2c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.3c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
	}), 'PersonPin');
	
	exports.default = _default;

/***/ },
/* 4581 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("defs", null, _react.default.createElement("path", {
	  id: "a",
	  d: "M0 0h24v24H0V0z"
	})), _react.default.createElement("path", {
	  d: "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm0 2c1.1 0 2 .9 2 2 0 1.11-.9 2-2 2s-2-.89-2-2c0-1.1.9-2 2-2zm0 10c-1.67 0-3.14-.85-4-2.15.02-1.32 2.67-2.05 4-2.05s3.98.73 4 2.05c-.86 1.3-2.33 2.15-4 2.15z"
	})), 'PersonPinCircle');
	
	exports.default = _default;

/***/ },
/* 4582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 1C7.59 1 4 4.59 4 9c0 5.57 6.96 13.34 7.26 13.67l.74.82.74-.82C13.04 22.34 20 14.57 20 9c0-4.41-3.59-8-8-8zm0 19.47C9.82 17.86 6 12.54 6 9c0-3.31 2.69-6 6-6s6 2.69 6 6c0 3.83-4.25 9.36-6 11.47zM12 9c.83 0 1.5-.67 1.5-1.5S12.83 6 12 6s-1.5.68-1.5 1.5c0 .83.67 1.5 1.5 1.5zm0 1c-1 0-3 .5-3 1.5v.12c.73.84 1.8 1.38 3 1.38s2.27-.54 3-1.38v-.12c0-1-2-1.5-3-1.5z"
	}), 'PersonPinCircleOutlined');
	
	exports.default = _default;

/***/ },
/* 4583 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C8.14 2 5 5.14 5 9c0 4.17 4.42 9.92 6.24 12.11.4.48 1.13.48 1.53 0C14.58 18.92 19 13.17 19 9c0-3.86-3.14-7-7-7zm0 2c1.1 0 2 .9 2 2 0 1.11-.9 2-2 2s-2-.89-2-2c0-1.1.9-2 2-2zm0 10c-1.67 0-3.14-.85-4-2.15.02-1.32 2.67-2.05 4-2.05s3.98.73 4 2.05c-.86 1.3-2.33 2.15-4 2.15z"
	}), 'PersonPinCircleRounded');
	
	exports.default = _default;

/***/ },
/* 4584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm0 2c1.1 0 2 .9 2 2 0 1.11-.9 2-2 2s-2-.89-2-2c0-1.1.9-2 2-2zm0 10c-1.67 0-3.14-.85-4-2.15.02-1.32 2.67-2.05 4-2.05s3.98.73 4 2.05c-.86 1.3-2.33 2.15-4 2.15z"
	}), 'PersonPinCircleSharp');
	
	exports.default = _default;

/***/ },
/* 4585 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 9c0 3.54 3.82 8.86 6 11.47 1.75-2.11 6-7.63 6-11.47 0-3.31-2.69-6-6-6S6 5.69 6 9zm9 2.5v.12c-.73.84-1.8 1.38-3 1.38s-2.27-.54-3-1.38v-.12c0-1 2-1.5 3-1.5s3 .5 3 1.5zm-1.5-4c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5S11.17 6 12 6s1.5.67 1.5 1.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 9c0 5.57 6.96 13.34 7.26 13.67l.74.82.74-.82C13.04 22.34 20 14.57 20 9c0-4.41-3.59-8-8-8S4 4.59 4 9zm14 0c0 3.83-4.25 9.36-6 11.47C9.82 17.86 6 12.54 6 9c0-3.31 2.69-6 6-6s6 2.69 6 6zm-7.5-1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5S12.83 6 12 6s-1.5.67-1.5 1.5zm-1.5 4v.12c.73.84 1.8 1.38 3 1.38s2.27-.54 3-1.38v-.12c0-1-2-1.5-3-1.5s-3 .5-3 1.5z"
	})), 'PersonPinCircleTwoTone');
	
	exports.default = _default;

/***/ },
/* 4586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 16h-4.83l-.59.59L12 20.17l-1.59-1.59-.58-.58H5V4h14v14zm-7-7c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 8.58c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V17h12v-1.42zM8.48 15c.74-.51 2.23-1 3.52-1s2.78.49 3.52 1H8.48z"
	}), 'PersonPinOutlined');
	
	exports.default = _default;

/***/ },
/* 4587 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l2.29 2.29c.39.39 1.02.39 1.41 0L15 20h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 3.3c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7S9.3 9.49 9.3 8s1.21-2.7 2.7-2.7zM18 16H6v-.9c0-2 4-3.1 6-3.1s6 1.1 6 3.1v.9z"
	}), 'PersonPinRounded');
	
	exports.default = _default;

/***/ },
/* 4588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 2H3v18h6l3 3 3-3h6V2zm-9 3.3c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7S9.3 9.49 9.3 8s1.21-2.7 2.7-2.7zM18 16H6v-.9c0-2 4-3.1 6-3.1s6 1.1 6 3.1v.9z"
	}), 'PersonPinSharp');
	
	exports.default = _default;

/***/ },
/* 4589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9.83 18l.59.59L12 20.17l1.59-1.59.58-.58H19V4H5v14h4.83zM12 5c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zM6 15.58C6 13.08 9.97 12 12 12s6 1.08 6 3.58V17H6v-1.42z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9 20l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4zM5 4h14v14h-4.83l-.59.59L12 20.17l-1.59-1.59-.58-.58H5V4zm7 7c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 8.58c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V17h12v-1.42zM8.48 15c.74-.51 2.23-1 3.52-1s2.78.49 3.52 1H8.48z"
	})), 'PersonPinTwoTone');
	
	exports.default = _default;

/***/ },
/* 4590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4z"
	}), 'PersonRounded');
	
	exports.default = _default;

/***/ },
/* 4591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
	}), 'PersonSharp');
	
	exports.default = _default;

/***/ },
/* 4592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 16c-2.69 0-5.77 1.28-6 2h12c-.2-.71-3.3-2-6-2z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "8",
	  r: "2",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 14c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H6zm6-6c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"
	})), 'PersonTwoTone');
	
	exports.default = _default;

/***/ },
/* 4593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12z"
	}), 'PersonalVideo');
	
	exports.default = _default;

/***/ },
/* 4594 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12z"
	}), 'PersonalVideoOutlined');
	
	exports.default = _default;

/***/ },
/* 4595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v1c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-1h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm-1 14H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1z"
	}), 'PersonalVideoRounded');
	
	exports.default = _default;

/***/ },
/* 4596 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 3H1v16h7v2h8v-2h6.99L23 3zm-2 14H3V5h18v12z"
	}), 'PersonalVideoSharp');
	
	exports.default = _default;

/***/ },
/* 4597 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 5h18v12H3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12z"
	})), 'PersonalVideoTwoTone');
	
	exports.default = _default;

/***/ },
/* 4598 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "4.5",
	  cy: "9.5",
	  r: "2.5"
	}), _react.default.createElement("circle", {
	  cx: "9",
	  cy: "5.5",
	  r: "2.5"
	}), _react.default.createElement("circle", {
	  cx: "15",
	  cy: "5.5",
	  r: "2.5"
	}), _react.default.createElement("circle", {
	  cx: "19.5",
	  cy: "9.5",
	  r: "2.5"
	}), _react.default.createElement("path", {
	  d: "M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z"
	})), 'Pets');
	
	exports.default = _default;

/***/ },
/* 4599 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "4.5",
	  cy: "9.5",
	  r: "2.5"
	}), _react.default.createElement("circle", {
	  cx: "9",
	  cy: "5.5",
	  r: "2.5"
	}), _react.default.createElement("circle", {
	  cx: "15",
	  cy: "5.5",
	  r: "2.5"
	}), _react.default.createElement("circle", {
	  cx: "19.5",
	  cy: "9.5",
	  r: "2.5"
	}), _react.default.createElement("path", {
	  d: "M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z"
	})), 'PetsOutlined');
	
	exports.default = _default;

/***/ },
/* 4600 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "4.5",
	  cy: "9.5",
	  r: "2.5"
	}), _react.default.createElement("circle", {
	  cx: "9",
	  cy: "5.5",
	  r: "2.5"
	}), _react.default.createElement("circle", {
	  cx: "15",
	  cy: "5.5",
	  r: "2.5"
	}), _react.default.createElement("circle", {
	  cx: "19.5",
	  cy: "9.5",
	  r: "2.5"
	}), _react.default.createElement("path", {
	  d: "M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z"
	})), 'PetsRounded');
	
	exports.default = _default;

/***/ },
/* 4601 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "4.5",
	  cy: "9.5",
	  r: "2.5"
	}), _react.default.createElement("circle", {
	  cx: "9",
	  cy: "5.5",
	  r: "2.5"
	}), _react.default.createElement("circle", {
	  cx: "15",
	  cy: "5.5",
	  r: "2.5"
	}), _react.default.createElement("circle", {
	  cx: "19.5",
	  cy: "9.5",
	  r: "2.5"
	}), _react.default.createElement("path", {
	  d: "M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z"
	})), 'PetsSharp');
	
	exports.default = _default;

/***/ },
/* 4602 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "4.5",
	  cy: "9.5",
	  r: "2.5"
	}), _react.default.createElement("circle", {
	  cx: "9",
	  cy: "5.5",
	  r: "2.5"
	}), _react.default.createElement("circle", {
	  cx: "15",
	  cy: "5.5",
	  r: "2.5"
	}), _react.default.createElement("circle", {
	  cx: "19.5",
	  cy: "9.5",
	  r: "2.5"
	}), _react.default.createElement("path", {
	  d: "M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z"
	})), 'PetsTwoTone');
	
	exports.default = _default;

/***/ },
/* 4603 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
	}), 'Phone');
	
	exports.default = _default;

/***/ },
/* 4604 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z"
	}), 'PhoneAndroid');
	
	exports.default = _default;

/***/ },
/* 4605 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm1 17H7V4h10v14zm-3 3h-4v-1h4v1z"
	}), 'PhoneAndroidOutlined');
	
	exports.default = _default;

/***/ },
/* 4606 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2.5 20h-3c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h3c.28 0 .5.22.5.5s-.22.5-.5.5zm3.5-3H7V4h10v14z"
	}), 'PhoneAndroidRounded');
	
	exports.default = _default;

/***/ },
/* 4607 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 1H5v22h14V1zm-5 20h-4v-1h4v1zm3-3H7V4h10v14z"
	}), 'PhoneAndroidSharp');
	
	exports.default = _default;

/***/ },
/* 4608 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 4h10v14H7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3-3H7V4h10v14z"
	})), 'PhoneAndroidTwoTone');
	
	exports.default = _default;

/***/ },
/* 4609 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.71 9.5L17 7.21V11h.5l2.85-2.85L18.21 6l2.15-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6 14 8.79l.71.71zM18 2.91l.94.94-.94.94V2.91zm0 4.3l.94.94-.94.94V7.21zm2 8.29c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"
	}), 'PhoneBluetoothSpeaker');
	
	exports.default = _default;

/***/ },
/* 4610 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.45 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM14.71 9.5L17 7.21V11h.5l2.85-2.85L18.21 6l2.15-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6 14 8.79l.71.71zM18 2.91l.94.94-.94.94V2.91zm0 4.3l.94.94-.94.94V7.21z"
	}), 'PhoneBluetoothSpeakerOutlined');
	
	exports.default = _default;

/***/ },
/* 4611 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.23 15.26l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98zm-2.44-9.25l-2.45 2.45c-.2.2-.2.52 0 .71.2.2.52.2.71 0L17 7.23v3.15c0 .2.12.39.31.47.06.03.13.04.19.04.13 0 .26-.05.36-.15l2.18-2.18c.2-.2.2-.52 0-.71l-1.83-1.83 1.83-1.83c.09-.09.15-.22.15-.36s-.05-.26-.15-.36l-2.18-2.18c-.14-.14-.36-.19-.55-.11-.19.08-.31.26-.31.46v3.15l-1.95-1.95c-.2-.2-.52-.2-.71 0-.2.2-.2.52 0 .71l2.45 2.46zm1.22-3.15l.96.96-.96.96V2.86zm0 4.37l.96.96-.96.96V7.23z"
	}), 'PhoneBluetoothSpeakerRounded');
	
	exports.default = _default;

/***/ },
/* 4612 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.71 9.5L17 7.21V11h.5l2.85-2.85L18.21 6l2.15-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6 14 8.79l.71.71zM18 2.91l.94.94-.94.94V2.91zm0 4.3l.94.94-.94.94V7.21zm3 8.25l-5.27-.61-2.52 2.52c-2.83-1.44-5.15-3.75-6.59-6.59l2.53-2.53L8.54 3H3.03C2.45 13.18 10.82 21.55 21 20.97v-5.51z"
	}), 'PhoneBluetoothSpeakerSharp');
	
	exports.default = _default;

/***/ },
/* 4613 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.2 18.21c1.21.41 2.48.67 3.8.76v-1.5c-.88-.07-1.75-.22-2.6-.45l-1.2 1.19zM6.54 5h-1.5c.09 1.32.34 2.58.75 3.79l1.2-1.21c-.24-.83-.39-1.7-.45-2.58z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.45 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM14.71 9.5L17 7.21V11h.5l2.85-2.85L18.21 6l2.15-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6 14 8.79l.71.71zM18 2.91l.94.94-.94.94V2.91zm0 4.3l.94.94-.94.94V7.21z"
	})), 'PhoneBluetoothSpeakerTwoTone');
	
	exports.default = _default;

/***/ },
/* 4614 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2zm13.54-7.1l-.71-.7L13 9.29V5h-1v6h6v-1h-4.15z"
	}), 'PhoneCallback');
	
	exports.default = _default;

/***/ },
/* 4615 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.51c-1.24 0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1zM5.03 5h1.5c.07.89.22 1.76.46 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79zM19 18.97c-1.32-.09-2.59-.35-3.8-.75l1.19-1.19c.85.24 1.72.39 2.6.45v1.49zM18 9h-2.59l5.02-5.02-1.41-1.41L14 7.59V5h-2v6h6z"
	}), 'PhoneCallbackOutlined');
	
	exports.default = _default;

/***/ },
/* 4616 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.23 15.26l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98zM13 11h4c.55 0 1-.45 1-1s-.45-1-1-1h-1.59l4.31-4.31c.39-.39.39-1.02 0-1.41s-1.02-.39-1.41 0L14 7.59V6c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1z"
	}), 'PhoneCallbackRounded');
	
	exports.default = _default;

/***/ },
/* 4617 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.73 14.85l-2.52 2.52c-2.83-1.44-5.15-3.75-6.59-6.59l2.53-2.53L8.54 3H3.03C2.45 13.18 10.82 21.55 21 20.97v-5.51l-5.27-.61zM18 9h-2.59l5.02-5.02-1.41-1.41L14 7.59V5h-2v6h6z"
	}), 'PhoneCallbackSharp');
	
	exports.default = _default;

/***/ },
/* 4618 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6.54 5h-1.5c.09 1.32.35 2.59.75 3.8l1.2-1.2c-.24-.84-.39-1.71-.45-2.6zm8.66 13.21c1.2.41 2.48.67 3.8.75v-1.49c-.88-.07-1.75-.22-2.6-.45l-1.2 1.19z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 15.51c-1.24 0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1zM5.03 5h1.5c.07.89.22 1.76.46 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79zM19 18.97c-1.32-.09-2.59-.35-3.8-.75l1.19-1.19c.85.24 1.72.39 2.6.45v1.49zM18 9h-2.59l5.02-5.02-1.41-1.41L14 7.59V5h-2v6h6z"
	})), 'PhoneCallbackTwoTone');
	
	exports.default = _default;

/***/ },
/* 4619 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.34 14.54l-1.43-1.43c.56-.73 1.05-1.5 1.47-2.32l-2.2-2.2c-.28-.28-.36-.67-.25-1.02.37-1.12.57-2.32.57-3.57 0-.55.45-1 1-1H20c.55 0 1 .45 1 1 0 3.98-1.37 7.64-3.66 10.54zm-2.82 2.81C11.63 19.64 7.97 21 4 21c-.55 0-1-.45-1-1v-3.49c0-.55.45-1 1-1 1.24 0 2.45-.2 3.57-.57.35-.12.75-.03 1.02.24l2.2 2.2c.81-.42 1.58-.9 2.3-1.46L1.39 4.22l1.42-1.41L21.19 21.2l-1.41 1.41-5.26-5.26z"
	}), 'PhoneDisabled');
	
	exports.default = _default;

/***/ },
/* 4620 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.34 14.54l-1.43-1.43c.56-.73 1.05-1.5 1.47-2.32l-2.2-2.2c-.28-.28-.36-.67-.25-1.02.37-1.12.57-2.32.57-3.57 0-.55.45-1 1-1H20c.55 0 1 .45 1 1 0 3.98-1.37 7.64-3.66 10.54zm-2.82 2.81C11.63 19.64 7.97 21 4 21c-.55 0-1-.45-1-1v-3.49c0-.55.45-1 1-1 1.24 0 2.45-.2 3.57-.57.1-.04.21-.05.31-.05.26 0 .51.1.71.29l2.2 2.2c.81-.42 1.58-.9 2.3-1.46L1.39 4.22l1.42-1.41L21.19 21.2l-1.41 1.41-5.26-5.26zm-6.92-.33c-.85.24-1.72.39-2.6.45v1.49c1.32-.09 2.59-.35 3.8-.75l-1.2-1.19zM17.46 5c-.06.89-.21 1.76-.45 2.59l1.2 1.2c.41-1.2.67-2.47.76-3.79h-1.51z"
	}), 'PhoneDisabledOutlined');
	
	exports.default = _default;

/***/ },
/* 4621 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.54 17.37c-2.63 2.08-5.89 3.39-9.45 3.61-1.13.07-2.07-.87-2.07-2v-1.73c-.01-1.01.75-1.86 1.76-1.98l2.54-.29c.61-.07 1.21.14 1.64.57l1.84 1.84c.81-.41 1.59-.9 2.31-1.45L2.1 4.93a.9959.9959 0 010-1.41c.39-.39 1.03-.39 1.42 0L20.49 20.5c.39.39.39 1.02 0 1.41s-1.02.39-1.41 0l-4.54-4.54zm2.85-6.57l-1.85-1.85c-.43-.43-.64-1.03-.57-1.64l.29-2.52c.12-1.01.97-1.77 1.99-1.77h1.73c1.13 0 2.07.94 2 2.07-.22 3.57-1.54 6.83-3.62 9.47l-1.43-1.43c.55-.73 1.04-1.51 1.46-2.33z"
	}), 'PhoneDisabledRounded');
	
	exports.default = _default;

/***/ },
/* 4622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.52 17.35C11.39 19.83 7.36 21.22 3 20.97v-5.51l5.27-.61 2.52 2.52c.81-.41 1.58-.9 2.3-1.45L1.39 4.22l1.42-1.41L21.19 21.2l-1.41 1.41-5.26-5.26zm1.39-4.24c.56-.73 1.05-1.51 1.47-2.33l-2.53-2.53.61-5.25h5.51c.25 4.37-1.15 8.4-3.63 11.54l-1.43-1.43z"
	}), 'PhoneDisabledSharp');
	
	exports.default = _default;

/***/ },
/* 4623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.34 14.54l-1.43-1.43c.56-.73 1.05-1.5 1.47-2.32l-2.2-2.2c-.28-.28-.36-.67-.25-1.02.37-1.12.57-2.32.57-3.57 0-.55.45-1 1-1H20c.55 0 1 .45 1 1 0 3.98-1.37 7.64-3.66 10.54zm-2.82 2.81C11.63 19.64 7.97 21 4 21c-.55 0-1-.45-1-1v-3.49c0-.55.45-1 1-1 1.24 0 2.45-.2 3.57-.57.1-.04.21-.05.31-.05.26 0 .51.1.71.29l2.2 2.2c.81-.42 1.58-.9 2.3-1.46L1.39 4.22l1.42-1.41L21.19 21.2l-1.41 1.41-5.26-5.26zM17.46 5c-.06.89-.21 1.76-.45 2.59l1.2 1.2c.41-1.2.67-2.47.76-3.79h-1.51zM7.6 17.02c-.85.24-1.72.39-2.6.45v1.49c1.32-.09 2.59-.35 3.8-.75l-1.2-1.19z"
	}), 'PhoneDisabledTwoTone');
	
	exports.default = _default;

/***/ },
/* 4624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.38 10.79l-2.2-2.2c-.28-.28-.36-.67-.25-1.02.37-1.12.57-2.32.57-3.57 0-.55.45-1 1-1H20c.55 0 1 .45 1 1 0 9.39-7.61 17-17 17-.55 0-1-.45-1-1v-3.49c0-.55.45-1 1-1 1.24 0 2.45-.2 3.57-.57.35-.12.75-.03 1.02.24l2.2 2.2c2.83-1.45 5.15-3.76 6.59-6.59z"
	}), 'PhoneEnabled');
	
	exports.default = _default;

/***/ },
/* 4625 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.46 5c-.06.89-.21 1.76-.45 2.59l1.2 1.2c.41-1.2.67-2.47.76-3.79h-1.51zM7.6 17.02c-.85.24-1.72.39-2.6.45v1.49c1.32-.09 2.59-.35 3.8-.75l-1.2-1.19zM16.5 3H20c.55 0 1 .45 1 1 0 9.39-7.61 17-17 17-.55 0-1-.45-1-1v-3.49c0-.55.45-1 1-1 1.24 0 2.45-.2 3.57-.57.1-.04.21-.05.31-.05.26 0 .51.1.71.29l2.2 2.2c2.83-1.45 5.15-3.76 6.59-6.59l-2.2-2.2c-.28-.28-.36-.67-.25-1.02.37-1.12.57-2.32.57-3.57 0-.55.45-1 1-1z"
	}), 'PhoneEnabledOutlined');
	
	exports.default = _default;

/***/ },
/* 4626 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.78 15.27l2.54-.29c.61-.07 1.21.14 1.64.57l1.84 1.84c2.83-1.44 5.15-3.75 6.59-6.59l-1.85-1.85c-.43-.43-.64-1.03-.57-1.64l.29-2.52c.12-1.01.97-1.77 1.99-1.77h1.73c1.13 0 2.07.94 2 2.07-.53 8.54-7.36 15.36-15.89 15.89-1.13.07-2.07-.87-2.07-2v-1.73c-.01-1.01.75-1.86 1.76-1.98z"
	}), 'PhoneEnabledRounded');
	
	exports.default = _default;

/***/ },
/* 4627 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 15.46l5.27-.61 2.52 2.52c2.83-1.44 5.15-3.75 6.59-6.59l-2.53-2.53.61-5.25h5.51C21.55 13.18 13.18 21.55 3 20.97v-5.51z"
	}), 'PhoneEnabledSharp');
	
	exports.default = _default;

/***/ },
/* 4628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 4c0 9.39-7.61 17-17 17-.55 0-1-.45-1-1v-3.49c0-.55.45-1 1-1 1.24 0 2.45-.2 3.57-.57.1-.04.21-.05.31-.05.26 0 .51.1.71.29l2.2 2.2c2.83-1.45 5.15-3.76 6.59-6.59l-2.2-2.2c-.28-.28-.36-.67-.25-1.02.37-1.12.57-2.32.57-3.57 0-.55.45-1 1-1H20c.55 0 1 .45 1 1zM7.6 17.02c-.85.24-1.72.39-2.6.45v1.49c1.32-.09 2.59-.35 3.8-.75l-1.2-1.19zM17.46 5c-.06.89-.21 1.76-.45 2.59l1.2 1.2c.41-1.2.67-2.47.76-3.79h-1.51z"
	}), 'PhoneEnabledTwoTone');
	
	exports.default = _default;

/***/ },
/* 4629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 11l5-5-5-5v3h-4v4h4v3zm2 4.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"
	}), 'PhoneForwarded');
	
	exports.default = _default;

/***/ },
/* 4630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.45 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM18 11l5-5-5-5v3h-4v4h4z"
	}), 'PhoneForwardedOutlined');
	
	exports.default = _default;

/***/ },
/* 4631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22.65 5.65l-3.79-3.79c-.32-.32-.86-.1-.86.35V4h-3.5c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5H18v1.79c0 .45.54.67.85.35l3.79-3.79c.2-.19.2-.51.01-.7zm-3.42 9.61l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z"
	}), 'PhoneForwardedRounded');
	
	exports.default = _default;

/***/ },
/* 4632 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 11l5-5-5-5v3h-4v4h4zm-4.79 6.37c-2.83-1.44-5.15-3.75-6.59-6.59l2.53-2.53L8.54 3H3.03C2.45 13.18 10.82 21.55 21 20.97v-5.51l-5.27-.61-2.52 2.52z"
	}), 'PhoneForwardedSharp');
	
	exports.default = _default;

/***/ },
/* 4633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.2 18.21c1.21.41 2.48.67 3.8.76v-1.5c-.88-.07-1.75-.22-2.6-.45l-1.2 1.19zM6.54 5h-1.5c.09 1.32.34 2.58.75 3.79l1.2-1.21c-.24-.83-.39-1.7-.45-2.58z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.45 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM18 11l5-5-5-5v3h-4v4h4z"
	})), 'PhoneForwardedTwoTone');
	
	exports.default = _default;

/***/ },
/* 4634 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 12h2c0-4.97-4.03-9-9-9v2c3.87 0 7 3.13 7 7zm-4 0h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3z"
	}), 'PhoneInTalk');
	
	exports.default = _default;

/***/ },
/* 4635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 12h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3zm4 0h2c0-4.97-4.03-9-9-9v2c3.87 0 7 3.13 7 7zm1 3.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.45 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51z"
	}), 'PhoneInTalkOutlined');
	
	exports.default = _default;

/***/ },
/* 4636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.88 5.05c3.18.4 5.67 2.89 6.07 6.07.06.51.49.88.99.88.04 0 .08 0 .12-.01.55-.07.94-.57.87-1.12-.51-4.09-3.72-7.3-7.81-7.81-.55-.06-1.05.33-1.11.88-.07.55.32 1.05.87 1.11zm.38 2.11c-.53-.14-1.08.18-1.22.72s.18 1.08.72 1.22c1.05.27 1.87 1.09 2.15 2.15.12.45.52.75.97.75.08 0 .17-.01.25-.03.53-.14.85-.69.72-1.22-.47-1.77-1.84-3.14-3.59-3.59zm5.97 8.1l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z"
	}), 'PhoneInTalkRounded');
	
	exports.default = _default;

/***/ },
/* 4637 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 12h2c0-4.97-4.03-9-9-9v2c3.87 0 7 3.13 7 7zm-4 0h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3zm-1.79 5.37c-2.83-1.44-5.15-3.75-6.59-6.59l2.53-2.53L8.54 3H3.03C2.45 13.18 10.82 21.55 21 20.97v-5.51l-5.27-.61-2.52 2.52z"
	}), 'PhoneInTalkSharp');
	
	exports.default = _default;

/***/ },
/* 4638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6.54 5h-1.5c.09 1.32.34 2.58.75 3.79l1.2-1.21c-.24-.83-.39-1.7-.45-2.58zm8.66 13.21c1.21.41 2.48.67 3.8.76v-1.5c-.88-.07-1.75-.22-2.6-.45l-1.2 1.19z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M15 12h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3zm4 0h2c0-4.97-4.03-9-9-9v2c3.87 0 7 3.13 7 7zm1 3.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.45 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51z"
	})), 'PhoneInTalkTwoTone');
	
	exports.default = _default;

/***/ },
/* 4639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z"
	}), 'PhoneIphone');
	
	exports.default = _default;

/***/ },
/* 4640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z"
	}), 'PhoneIphoneOutlined');
	
	exports.default = _default;

/***/ },
/* 4641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z"
	}), 'PhoneIphoneRounded');
	
	exports.default = _default;

/***/ },
/* 4642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 1H5v22h13V1zm-6.5 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z"
	}), 'PhoneIphoneSharp');
	
	exports.default = _default;

/***/ },
/* 4643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 4h9v14H7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z"
	})), 'PhoneIphoneTwoTone');
	
	exports.default = _default;

/***/ },
/* 4644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM20 4v-.5C20 2.12 18.88 1 17.5 1S15 2.12 15 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4z"
	}), 'PhoneLocked');
	
	exports.default = _default;

/***/ },
/* 4645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.45 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM20 4v-.5C20 2.12 18.88 1 17.5 1S15 2.12 15 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V4z"
	}), 'PhoneLockedOutlined');
	
	exports.default = _default;

/***/ },
/* 4646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.23 15.26l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98zM20 4v-.5C20 2.12 18.88 1 17.5 1S15 2.12 15 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V4z"
	}), 'PhoneLockedRounded');
	
	exports.default = _default;

/***/ },
/* 4647 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.21 17.37c-2.83-1.44-5.15-3.75-6.59-6.59l2.53-2.53L8.54 3H3.03C2.45 13.18 10.82 21.55 21 20.97v-5.51l-5.27-.61-2.52 2.52zM20 4v-.36c0-1.31-.94-2.5-2.24-2.63C16.26.86 15 2.03 15 3.5V4h-1v6h7V4h-1zm-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V4z"
	}), 'PhoneLockedSharp');
	
	exports.default = _default;

/***/ },
/* 4648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6.54 5h-1.5c.09 1.32.34 2.58.75 3.79l1.2-1.21c-.24-.83-.39-1.7-.45-2.58zm8.66 13.21c1.21.41 2.48.67 3.8.76v-1.5c-.88-.07-1.75-.22-2.6-.45l-1.2 1.19z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.45 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM20 4v-.5C20 2.12 18.88 1 17.5 1S15 2.12 15 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V4z"
	})), 'PhoneLockedTwoTone');
	
	exports.default = _default;

/***/ },
/* 4649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.5 5.5L12 11l7-7-1-1-6 6-4.5-4.5H11V3H5v6h1.5V5.5zm17.21 11.17C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71s.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.67 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71s-.12-.52-.3-.7z"
	}), 'PhoneMissed');
	
	exports.default = _default;

/***/ },
/* 4650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23.71 16.67C20.66 13.78 16.54 12 12 12S3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.67 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.28-.12-.52-.3-.7zm-18.31.56c-.66.37-1.29.8-1.87 1.27l-1.07-1.07c.91-.75 1.9-1.39 2.95-1.9v1.7zm15.08 1.26c-.6-.48-1.22-.9-1.88-1.27v-1.7c1.05.51 2.03 1.15 2.95 1.9l-1.07 1.07zM7 6.43l4.94 4.94 7.07-7.07-1.41-1.42-5.66 5.66L8.4 5H11V3H5v6h2z"
	}), 'PhoneMissedOutlined');
	
	exports.default = _default;

/***/ },
/* 4651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23.09 16.2c-6.33-5.59-15.86-5.59-22.18 0-.84.74-.84 2.05-.05 2.84l1.2 1.2c.71.71 1.84.77 2.62.15l1.97-1.57c.47-.37.75-.94.75-1.55V14.7c2.98-.97 6.21-.98 9.2 0v2.58c0 .6.28 1.17.75 1.55l1.96 1.56c.79.62 1.91.56 2.62-.15l1.2-1.2c.8-.79.79-2.1-.04-2.84zM6 9c.55 0 1-.45 1-1V6.43l4.24 4.24c.39.39 1.02.39 1.41 0l5.66-5.66c.39-.39.39-1.02 0-1.41a.9959.9959 0 00-1.41 0l-4.95 4.95L8.4 5H10c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1z"
	}), 'PhoneMissedRounded');
	
	exports.default = _default;

/***/ },
/* 4652 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23.32 16.67c-2.95-2.79-6.93-4.51-11.31-4.51-4.39 0-8.37 1.72-11.31 4.51l-.69.69L3.65 21l3.93-2.72-.01-3.49c1.4-.45 2.9-.7 4.44-.7 1.55 0 3.04.24 4.44.7l-.01 3.49L20.37 21l3.64-3.64c0-.01-.52-.52-.69-.69zM7 6.43l4.94 4.94 7.07-7.07-1.41-1.42-5.66 5.66L8.4 5H11V3H5v6h2z"
	}), 'PhoneMissedSharp');
	
	exports.default = _default;

/***/ },
/* 4653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18.6 17.22c.66.37 1.28.79 1.88 1.27l1.07-1.07c-.91-.75-1.9-1.39-2.95-1.9v1.7zM3.53 18.5c.58-.47 1.21-.89 1.87-1.27v-1.71c-1.05.51-2.03 1.15-2.95 1.9l1.08 1.08z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M23.71 16.67C20.66 13.78 16.54 12 12 12S3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.67 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.28-.12-.52-.3-.7zm-18.31.56c-.66.37-1.29.8-1.87 1.27l-1.07-1.07c.91-.75 1.9-1.39 2.95-1.9v1.7zm15.08 1.26c-.6-.48-1.22-.9-1.88-1.27v-1.7c1.05.51 2.03 1.15 2.95 1.9l-1.07 1.07zM7 6.43l4.94 4.94 7.07-7.07-1.41-1.42-5.66 5.66L8.4 5H11V3H5v6h2z"
	})), 'PhoneMissedTwoTone');
	
	exports.default = _default;

/***/ },
/* 4654 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1z"
	}), 'PhoneOutlined');
	
	exports.default = _default;

/***/ },
/* 4655 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3h-2v7h2V3zm3 12.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 3v7h2V3h-2z"
	}), 'PhonePaused');
	
	exports.default = _default;

/***/ },
/* 4656 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.54 5c.06.88.21 1.75.44 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79h1.51m9.86 12.01c.85.24 1.72.39 2.6.45v1.5c-1.32-.09-2.6-.35-3.8-.76l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1zM15 3h2v7h-2zm4 0h2v7h-2z"
	}), 'PhonePausedOutlined');
	
	exports.default = _default;

/***/ },
/* 4657 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 3c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1zm3 1v5c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1s-1 .45-1 1zm.23 11.26l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z"
	}), 'PhonePausedRounded');
	
	exports.default = _default;

/***/ },
/* 4658 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 3h2v7h-2zm4 0h2v7h-2zm-5.79 14.37c-2.83-1.44-5.15-3.75-6.59-6.59l2.53-2.53L8.54 3H3.03C2.45 13.18 10.82 21.55 21 20.97v-5.51l-5.27-.61-2.52 2.52z"
	}), 'PhonePausedSharp');
	
	exports.default = _default;

/***/ },
/* 4659 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6.54 5h-1.5c.09 1.32.34 2.58.75 3.79l1.2-1.21c-.24-.83-.39-1.7-.45-2.58zm8.66 13.21c1.21.41 2.48.67 3.8.76v-1.5c-.88-.07-1.75-.22-2.6-.45l-1.2 1.19z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.45 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM15 3h2v7h-2zm4 0h2v7h-2z"
	})), 'PhonePausedTwoTone');
	
	exports.default = _default;

/***/ },
/* 4660 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.23 15.26l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z"
	}), 'PhoneRounded');
	
	exports.default = _default;

/***/ },
/* 4661 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 15.46l-5.27-.61-2.52 2.52c-2.83-1.44-5.15-3.75-6.59-6.59l2.53-2.53L8.54 3H3.03C2.45 13.18 10.82 21.55 21 20.97v-5.51z"
	}), 'PhoneSharp');
	
	exports.default = _default;

/***/ },
/* 4662 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 17.47c-.88-.07-1.75-.22-2.6-.45l-1.19 1.19c1.2.41 2.48.67 3.8.75v-1.49zM5.03 5c.09 1.32.35 2.59.75 3.8l1.2-1.2c-.23-.84-.38-1.71-.44-2.6H5.03z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9.07 7.57C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02zm7.33 9.45c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19zM5.79 8.8c-.41-1.21-.67-2.48-.76-3.8h1.5c.07.89.22 1.76.46 2.59L5.79 8.8z"
	})), 'PhoneTwoTone');
	
	exports.default = _default;

/***/ },
/* 4663 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
	}), 'Phonelink');
	
	exports.default = _default;

/***/ },
/* 4664 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 8.2l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"
	}), 'PhonelinkErase');
	
	exports.default = _default;

/***/ },
/* 4665 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 8.2l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"
	}), 'PhonelinkEraseOutlined');
	
	exports.default = _default;

/***/ },
/* 4666 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.5 7.7c-.28-.28-.72-.28-1 0L8 11.2 4.5 7.7c-.28-.28-.72-.28-1 0s-.28.72 0 1L7 12.2l-3.5 3.5c-.28.28-.28.72 0 1s.72.28 1 0L8 13.2l3.5 3.5c.28.28.72.28 1 0s.28-.72 0-1L9 12.2l3.5-3.5c.28-.28.28-.72 0-1zM19 1H9c-1.1 0-2 .9-2 2v2c0 .55.45 1 1 1s1-.45 1-1V4h10v16H9v-1c0-.55-.45-1-1-1s-1 .45-1 1v2c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"
	}), 'PhonelinkEraseRounded');
	
	exports.default = _default;

/***/ },
/* 4667 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 8.2l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM21 1H7v5h2V4h10v16H9v-2H7v5h14V1z"
	}), 'PhonelinkEraseSharp');
	
	exports.default = _default;

/***/ },
/* 4668 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 17.2l4-4 4 4 1-1-4-4 4-4-1-1-4 4-4-4-1 1 4 4-4 4zM9 23h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2z"
	}), 'PhonelinkEraseTwoTone');
	
	exports.default = _default;

/***/ },
/* 4669 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-8.2 10V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z"
	}), 'PhonelinkLock');
	
	exports.default = _default;

/***/ },
/* 4670 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-8.2 10V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z"
	}), 'PhonelinkLockOutlined');
	
	exports.default = _default;

/***/ },
/* 4671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 1H9c-1.1 0-2 .9-2 2v2c0 .55.45 1 1 1s1-.45 1-1V4h10v16H9v-1c0-.55-.45-1-1-1s-1 .45-1 1v2c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-8.2 10V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z"
	}), 'PhonelinkLockRounded');
	
	exports.default = _default;

/***/ },
/* 4672 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 1H7v5h2V4h10v16H9v-2H7v5h14V1zM10.8 11V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11H4v6h8v-6h-1.2zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z"
	}), 'PhonelinkLockSharp');
	
	exports.default = _default;

/***/ },
/* 4673 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 7C6.6 7 5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3V9.5C10.8 8.1 9.4 7 8 7zm1.5 4h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11zM21 21V3c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2z"
	}), 'PhonelinkLockTwoTone');
	
	exports.default = _default;

/***/ },
/* 4674 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6V4H6.82l2 2H22zM1.92 1.65L.65 2.92l1.82 1.82C2.18 5.08 2 5.52 2 6v11H0v3h17.73l2.35 2.35 1.27-1.27L3.89 3.62 1.92 1.65zM4 6.27L14.73 17H4V6.27zM23 8h-6c-.55 0-1 .45-1 1v4.18l2 2V10h4v7h-2.18l3 3H23c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z"
	}), 'PhonelinkOff');
	
	exports.default = _default;

/***/ },
/* 4675 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6V4H7.39l2 2zm2 13V9c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1v3.61l2 2V10h4v7h-1.61l2.93 2.93c.39-.13.68-.49.68-.93zM2.06 1.51L.65 2.92l1.82 1.82C2.18 5.08 2 5.52 2 6v11H0v3h17.73l2.35 2.35 1.41-1.41L2.06 1.51zM4 17V6.27L14.73 17H4z"
	}), 'PhonelinkOffOutlined');
	
	exports.default = _default;

/***/ },
/* 4676 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M24 19V9c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1v3.61l2 2V10h4v7h-1.61l2.93 2.93c.39-.13.68-.49.68-.93zM21 6c.55 0 1-.45 1-1s-.45-1-1-1H7.39l2 2H21zM1.36 2.21c-.39.39-.39 1.02 0 1.41l1.11 1.11C2.18 5.08 2 5.52 2 6v11h-.5c-.83 0-1.5.67-1.5 1.5S.67 20 1.5 20h16.23l1.64 1.64c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L2.77 2.21a.9959.9959 0 00-1.41 0zM4 17V6.27L14.73 17H4z"
	}), 'PhonelinkOffRounded');
	
	exports.default = _default;

/***/ },
/* 4677 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.56 4l-2.5-2.49L4.56 4zM24 8h-8v4.61l2 2V10h4v7h-1.61l3 3H24zm-2-2V4H7.39l2 2zM2.06 1.51L.65 2.92 2 4.27V17H0v3h17.73l2.35 2.35 1.41-1.41L2.06 1.51zM4 17V6.27L14.73 17H4z"
	}), 'PhonelinkOffSharp');
	
	exports.default = _default;

/***/ },
/* 4678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M22 17v-7h-4v4.61L20.39 17z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M23 8h-6c-.55 0-1 .45-1 1v3.61l2 2V10h4v7h-1.61l2.93 2.93c.39-.13.68-.49.68-.93V9c0-.55-.45-1-1-1zm-1-2V4H7.39l2 2zM.65 2.92l1.82 1.82C2.18 5.08 2 5.52 2 6v11H0v3h17.73l2.35 2.35 1.41-1.41L2.06 1.51.65 2.92zM4 6.27L14.73 17H4V6.27z"
	})), 'PhonelinkOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 4679 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
	}), 'PhonelinkOutlined');
	
	exports.default = _default;

/***/ },
/* 4680 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16z"
	}), 'PhonelinkRing');
	
	exports.default = _default;

/***/ },
/* 4681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16z"
	}), 'PhonelinkRingOutlined');
	
	exports.default = _default;

/***/ },
/* 4682 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16zm6.63-11.74c-.26-.32-.74-.36-1.04-.06l-.03.03c-.25.25-.26.65-.05.93 1.26 1.64 1.25 3.87-.02 5.57-.21.28-.19.67.05.92l.05.05c.29.29.76.26 1.03-.05 1.8-2.13 1.8-5.19.01-7.39zm-3.21 2.11l-.06.06c-.2.2-.26.5-.15.76.21.49.21 1.03 0 1.52-.11.26-.05.56.15.76l.08.08c.32.32.87.25 1.09-.15.49-.89.49-1.94-.01-2.86a.687.687 0 00-1.1-.17z"
	}), 'PhonelinkRingRounded');
	
	exports.default = _default;

/***/ },
/* 4683 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM16 1H2v22h14V1zm-2 19H4V4h10v16z"
	}), 'PhonelinkRingSharp');
	
	exports.default = _default;

/***/ },
/* 4684 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 4h10v16H4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16zm6.1-12.3l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM17 10.8c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3l-1 1z"
	})), 'PhonelinkRingTwoTone');
	
	exports.default = _default;

/***/ },
/* 4685 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 7c0-.55.45-1 1-1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-1.1 0-2 .9-2 2v11h-.5c-.83 0-1.5.67-1.5 1.5S.67 20 1.5 20h11c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H4V7zm19 1h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
	}), 'PhonelinkRounded');
	
	exports.default = _default;

/***/ },
/* 4686 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.82 12.49c.02-.16.04-.32.04-.49 0-.17-.02-.33-.04-.49l1.08-.82c.1-.07.12-.21.06-.32l-1.03-1.73c-.06-.11-.2-.15-.31-.11l-1.28.5c-.27-.2-.56-.36-.87-.49l-.2-1.33c0-.12-.11-.21-.24-.21H5.98c-.13 0-.24.09-.26.21l-.2 1.32c-.31.12-.6.3-.87.49l-1.28-.5c-.12-.05-.25 0-.31.11l-1.03 1.73c-.06.12-.03.25.07.33l1.08.82c-.02.16-.03.33-.03.49 0 .17.02.33.04.49l-1.09.83c-.1.07-.12.21-.06.32l1.03 1.73c.06.11.2.15.31.11l1.28-.5c.27.2.56.36.87.49l.2 1.32c.01.12.12.21.25.21h2.06c.13 0 .24-.09.25-.21l.2-1.32c.31-.12.6-.3.87-.49l1.28.5c.12.05.25 0 .31-.11l1.03-1.73c.06-.11.04-.24-.06-.32l-1.1-.83zM7 13.75c-.99 0-1.8-.78-1.8-1.75s.81-1.75 1.8-1.75 1.8.78 1.8 1.75S8 13.75 7 13.75zM18 1.01L8 1c-1.1 0-2 .9-2 2v3h2V5h10v14H8v-1H6v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"
	}), 'PhonelinkSetup');
	
	exports.default = _default;

/***/ },
/* 4687 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 3v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2zm2.5 12.5c.29-.12.55-.29.8-.48l-.02.03 1.01.39c.23.09.49 0 .61-.22l.84-1.46c.12-.21.07-.49-.12-.64l-.85-.68-.02.03c.02-.16.05-.32.05-.48s-.03-.32-.05-.48l.02.03.85-.68c.19-.15.24-.43.12-.64l-.84-1.46c-.12-.21-.38-.31-.61-.22l-1.01.39.02.03c-.25-.17-.51-.34-.8-.46l-.17-1.08C9.3 7.18 9.09 7 8.84 7H7.16c-.25 0-.46.18-.49.42L6.5 8.5c-.29.12-.55.29-.8.48l.02-.03-1.02-.39c-.23-.09-.49 0-.61.22l-.84 1.46c-.12.21-.07.49.12.64l.85.68.02-.03c-.02.15-.05.31-.05.47s.03.32.05.48l-.02-.03-.85.68c-.19.15-.24.43-.12.64l.84 1.46c.12.21.38.31.61.22l1.01-.39-.01-.04c.25.19.51.36.8.48l.17 1.07c.03.25.24.43.49.43h1.68c.25 0 .46-.18.49-.42l.17-1.08zM6 12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2z"
	}), 'PhonelinkSetupOutlined');
	
	exports.default = _default;

/***/ },
/* 4688 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 3v2c0 .55.45 1 1 1s1-.45 1-1V4h10v16H9v-1c0-.55-.45-1-1-1s-1 .45-1 1v2c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2zm2.5 12.5c.29-.12.55-.29.8-.48l-.02.03 1.01.39c.23.09.49 0 .61-.22l.84-1.46c.12-.21.07-.49-.12-.64l-.85-.68-.02.03c.02-.16.05-.32.05-.48s-.03-.32-.05-.48l.02.03.85-.68c.19-.15.24-.43.12-.64l-.84-1.46c-.12-.21-.38-.31-.61-.22l-1.01.39.02.03c-.25-.17-.51-.34-.8-.46l-.17-1.08C9.3 7.18 9.09 7 8.84 7H7.16c-.25 0-.46.18-.49.42L6.5 8.5c-.29.12-.55.29-.8.48l.02-.03-1.02-.39c-.23-.09-.49 0-.61.22l-.84 1.46c-.12.21-.07.49.12.64l.85.68.02-.03c-.02.15-.05.31-.05.47s.03.32.05.48l-.02-.03-.85.68c-.19.15-.24.43-.12.64l.84 1.46c.12.21.38.31.61.22l1.01-.39-.01-.04c.25.19.51.36.8.48l.17 1.07c.03.25.24.43.49.43h1.68c.25 0 .46-.18.49-.42l.17-1.08zM6 12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2z"
	}), 'PhonelinkSetupRounded');
	
	exports.default = _default;

/***/ },
/* 4689 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 1v5h2V4h10v16H9v-2H7v5h14V1zm2.5 14.5c.29-.12.55-.29.8-.48l-.02.03 1.41.55 1.27-2.2-1.18-.95-.02.03c.02-.16.05-.32.05-.48s-.03-.32-.05-.48l.02.03 1.18-.95-1.26-2.2-1.41.55.02.03c-.26-.19-.52-.36-.81-.48L9.27 7H6.73L6.5 8.5c-.29.12-.55.29-.8.48l.02-.03L4.3 8.4l-1.27 2.2 1.18.95.02-.03c-.01.16-.04.32-.04.48s.03.32.05.48l-.02-.03-1.18.95 1.27 2.2 1.41-.55-.02-.03c.25.19.51.36.8.48l.23 1.5h2.54l.23-1.5zM6 12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2z"
	}), 'PhonelinkSetupSharp');
	
	exports.default = _default;

/***/ },
/* 4690 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 3v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2zm2.5 12.5c.29-.12.55-.29.8-.48l-.02.03 1.01.39c.23.09.49 0 .61-.22l.84-1.46c.12-.21.07-.49-.12-.64l-.85-.68-.02.03c.02-.16.05-.32.05-.48s-.03-.32-.05-.48l.02.03.85-.68c.19-.15.24-.43.12-.64l-.84-1.46c-.12-.21-.38-.31-.61-.22l-1.01.39.02.03c-.25-.17-.51-.34-.8-.46l-.17-1.08C9.3 7.18 9.09 7 8.84 7H7.16c-.25 0-.46.18-.49.42L6.5 8.5c-.29.12-.55.29-.8.48l.02-.03-1.02-.39c-.23-.09-.49 0-.61.22l-.84 1.46c-.12.21-.07.49.12.64l.85.68.02-.03c-.02.15-.05.31-.05.47s.03.32.05.48l-.02-.03-.85.68c-.19.15-.24.43-.12.64l.84 1.46c.12.21.38.31.61.22l1.01-.39-.01-.04c.25.19.51.36.8.48l.17 1.07c.03.25.24.43.49.43h1.68c.25 0 .46-.18.49-.42l.17-1.08zM6 12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2z"
	}), 'PhonelinkSetupTwoTone');
	
	exports.default = _default;

/***/ },
/* 4691 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6h18V4H2v13H0v3h14v-3H4V6zm20 2h-8v12h8V8zm-2 9h-4v-7h4v7z"
	}), 'PhonelinkSharp');
	
	exports.default = _default;

/***/ },
/* 4692 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18 10h4v7h-4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
	})), 'PhonelinkTwoTone');
	
	exports.default = _default;

/***/ },
/* 4693 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
	}), 'Photo');
	
	exports.default = _default;

/***/ },
/* 4694 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4zm0 15l3-3.86 2.14 2.58 3-3.86L18 19H6z"
	}), 'PhotoAlbum');
	
	exports.default = _default;

/***/ },
/* 4695 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 2v5l-1-.75L9 9V4h2zm7 16H6V4h1v9l3-2.25L13 13V4h5v16zm-6.72-2.04L9.5 15.81 7 19h10l-3.22-4.26z"
	}), 'PhotoAlbumOutlined');
	
	exports.default = _default;

/***/ },
/* 4696 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4zm.63 14.19l1.99-2.56c.2-.25.58-.26.78-.01l1.74 2.1 2.6-3.34c.2-.26.6-.26.79.01l2.87 3.82c.25.33.01.8-.4.8H7.02c-.41-.01-.65-.49-.39-.82z"
	}), 'PhotoAlbumRounded');
	
	exports.default = _default;

/***/ },
/* 4697 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4v20h16V2zM6 4h5v8l-2.5-1.5L6 12V4zm0 15l3-3.86 2.14 2.58 3-3.86L18 19H6z"
	}), 'PhotoAlbumSharp');
	
	exports.default = _default;

/***/ },
/* 4698 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M13 13l-3-2.25L7 13V4H6v16h12V4h-5v9zm4 6H7l2.5-3.19 1.78 2.15 2.5-3.22L17 19z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 4h2v5l-1-.75L9 9V4zm9 16H6V4h1v9l3-2.25L13 13V4h5v16zm-8.5-4.19L7 19h10l-3.22-4.26-2.5 3.22z"
	})), 'PhotoAlbumTwoTone');
	
	exports.default = _default;

/***/ },
/* 4699 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "3.2"
	}), _react.default.createElement("path", {
	  d: "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	})), 'PhotoCamera');
	
	exports.default = _default;

/***/ },
/* 4700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.12 4l1.83 2H20v12H4V6h4.05l1.83-2h4.24M15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2zm-3 7c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3m0-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5z"
	}), 'PhotoCameraOutlined');
	
	exports.default = _default;

/***/ },
/* 4701 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "3"
	}), _react.default.createElement("path", {
	  d: "M20 4h-3.17l-1.24-1.35c-.37-.41-.91-.65-1.47-.65H9.88c-.56 0-1.1.24-1.48.65L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 13c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	})), 'PhotoCameraRounded');
	
	exports.default = _default;

/***/ },
/* 4702 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "3"
	}), _react.default.createElement("path", {
	  d: "M9 2L7.17 4H2v16h20V4h-5.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
	})), 'PhotoCameraSharp');
	
	exports.default = _default;

/***/ },
/* 4703 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 6h-4.05l-1.83-2H9.88L8.05 6H4v12h16V6zm-8 11c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 20h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2zM4 6h4.05l1.83-2h4.24l1.83 2H20v12H4V6zm8 1c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
	})), 'PhotoCameraTwoTone');
	
	exports.default = _default;

/***/ },
/* 4704 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.02 10v9H5V5h9V3H5.02c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2zM17 10l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7l2.06.94zm-3.75.75L12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12z"
	}), 'PhotoFilter');
	
	exports.default = _default;

/***/ },
/* 4705 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 10v9H4.98V5h9V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2zm-2.94-2.06L17 10l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7zM12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12l-2.75-1.25z"
	}), 'PhotoFilterOutlined');
	
	exports.default = _default;

/***/ },
/* 4706 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.02 10.99V18c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h7c.55 0 1-.45 1-1s-.45-1-1-1H5.02c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2H19c1.1 0 2-.89 2-2v-8.01c0-.55-.44-.99-.99-.99s-.99.44-.99.99zm-5.77-.24L12.46 9c-.18-.39-.73-.39-.91 0l-.79 1.75-1.76.79c-.39.18-.39.73 0 .91l1.75.79.79 1.76c.18.39.73.39.91 0l.79-1.75 1.76-.79c.39-.18.39-.73 0-.91l-1.75-.8zm4.69-4.69l-.6-1.32c-.13-.29-.55-.29-.69 0l-.6 1.32-1.32.6c-.29.13-.29.55 0 .69l1.32.6.6 1.32c.13.29.55.29.69 0l.6-1.32 1.32-.6c.29-.13.29-.55 0-.69l-1.32-.6z"
	}), 'PhotoFilterRounded');
	
	exports.default = _default;

/***/ },
/* 4707 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 10v9H4.98V5h9V3H3v18h18V10h-2zm-2 0l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7l2.06.94L17 10zm-3.75.75L12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12l-2.75-1.25z"
	}), 'PhotoFilterSharp');
	
	exports.default = _default;

/***/ },
/* 4708 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 10v9H4.98V5h9V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2zm-2.94-2.06L17 10l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7zM12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12l-2.75-1.25z"
	}), 'PhotoFilterTwoTone');
	
	exports.default = _default;

/***/ },
/* 4709 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
	}), 'PhotoLibrary');
	
	exports.default = _default;

/***/ },
/* 4710 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4v12H8V4h12m0-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 9.67l1.69 2.26 2.48-3.1L19 15H9zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
	}), 'PhotoLibraryOutlined');
	
	exports.default = _default;

/***/ },
/* 4711 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-10.6-3.47l1.63 2.18 2.58-3.22c.2-.25.58-.25.78 0l2.96 3.7c.26.33.03.81-.39.81H9c-.41 0-.65-.47-.4-.8l2-2.67c.2-.26.6-.26.8 0zM2 7v13c0 1.1.9 2 2 2h13c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1s-1 .45-1 1z"
	}), 'PhotoLibraryRounded');
	
	exports.default = _default;

/***/ },
/* 4712 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 18V2H6v16h16zm-11-6l2.03 2.71L16 11l4 5H8l3-4zM2 6v16h16v-2H4V6H2z"
	}), 'PhotoLibrarySharp');
	
	exports.default = _default;

/***/ },
/* 4713 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 16h12V4H8v12zm3.5-4.33l1.69 2.26 2.48-3.09L19 15H9l2.5-3.33z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-2 0H8V4h12v12zm-4.33-5.17l-2.48 3.09-1.69-2.25L9 15h10zM4 22h14v-2H4V6H2v14c0 1.1.9 2 2 2z"
	})), 'PhotoLibraryTwoTone');
	
	exports.default = _default;

/***/ },
/* 4714 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"
	}), 'PhotoOutlined');
	
	exports.default = _default;

/***/ },
/* 4715 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.9 13.98l2.1 2.53 3.1-3.99c.2-.26.6-.26.8.01l3.51 4.68c.25.33.01.8-.4.8H6.02c-.42 0-.65-.48-.39-.81L8.12 14c.19-.26.57-.27.78-.02z"
	}), 'PhotoRounded');
	
	exports.default = _default;

/***/ },
/* 4716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 21V3H3v18h18zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
	}), 'PhotoSharp');
	
	exports.default = _default;

/***/ },
/* 4717 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z"
	}), 'PhotoSizeSelectActual');
	
	exports.default = _default;

/***/ },
/* 4718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zm0 15.92c-.02.03-.06.06-.08.08H3V5.08L3.08 5h17.83c.03.02.06.06.08.08v13.84zm-10-3.41L8.5 12.5 5 17h14l-4.5-6z"
	}), 'PhotoSizeSelectActualOutlined');
	
	exports.default = _default;

/***/ },
/* 4719 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zM5.63 16.19l2.49-3.2c.2-.25.58-.26.78-.01l2.1 2.53 3.1-3.99c.2-.26.6-.26.8.01l3.51 4.68c.25.33.01.8-.4.8H6.02c-.41-.01-.65-.49-.39-.82z"
	}), 'PhotoSizeSelectActualRounded');
	
	exports.default = _default;

/***/ },
/* 4720 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 3H1v18h22V3zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z"
	}), 'PhotoSizeSelectActualSharp');
	
	exports.default = _default;

/***/ },
/* 4721 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3.08 5L3 5.08V19h17.92c.03-.02.06-.06.08-.08V5.08L20.92 5H3.08zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zm0 15.92c-.02.03-.06.06-.08.08H3V5.08L3.08 5h17.83c.03.02.06.06.08.08v13.84zm-10-3.41L8.5 12.5 5 17h14l-4.5-6z"
	})), 'PhotoSizeSelectActualTwoTone');
	
	exports.default = _default;

/***/ },
/* 4722 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12V11H1zm2 8l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z"
	}), 'PhotoSizeSelectLarge');
	
	exports.default = _default;

/***/ },
/* 4723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12V11H1zm2 8l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z"
	}), 'PhotoSizeSelectLargeOutlined');
	
	exports.default = _default;

/***/ },
/* 4724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12v-8c0-1.1-.9-2-2-2H1zm2.63 7.19l1.49-1.91c.2-.25.57-.26.78-.01l1.39 1.67 2.1-2.7c.2-.26.6-.26.79.01l2.22 2.96c.25.33.01.8-.4.8H4.02c-.41-.01-.65-.49-.39-.82z"
	}), 'PhotoSizeSelectLargeRounded');
	
	exports.default = _default;

/***/ },
/* 4725 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 15h2v2h-2v-2zm0 4h2v2h-2v-2zm0-8h2v2h-2v-2zm-8-8h2v2h-2V3zm8 4h2v2h-2V7zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3H1v2h2V3zm20 0h-2v2h2V3zM9 3h2v2H9V3zM5 3h2v2H5V3zm-4 8v10h14V11H1zm2 8l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z"
	}), 'PhotoSizeSelectLargeSharp');
	
	exports.default = _default;

/***/ },
/* 4726 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 19h2v2h-2zM1 19c0 1.1.9 2 2 2h12V11H1v8zm4.5-3.21l1.79 2.15 2.5-3.22L13 19H3l2.5-3.21zM17 3h2v2h-2zm4 8h2v2h-2zm0 4h2v2h-2zM3 3C2 3 1 4 1 5h2V3zm18 4h2v2h-2zm-8-4h2v2h-2zm8 18c1 0 2-1 2-2h-2v2zM1 7h2v2H1zm8-4h2v2H9zM5 3h2v2H5zm16 0v2h2c0-1-1-2-2-2z"
	}), 'PhotoSizeSelectLargeTwoTone');
	
	exports.default = _default;

/***/ },
/* 4727 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-6H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z"
	}), 'PhotoSizeSelectSmall');
	
	exports.default = _default;

/***/ },
/* 4728 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-6H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z"
	}), 'PhotoSizeSelectSmallOutlined');
	
	exports.default = _default;

/***/ },
/* 4729 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-4c0-1.1-.9-2-2-2H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z"
	}), 'PhotoSizeSelectSmallRounded');
	
	exports.default = _default;

/***/ },
/* 4730 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 15h-2v2h2v-2zm0 4h-2v2h2v-2zm0-8h-2v2h2v-2zm-8-8h-2v2h2V3zm8 4h-2v2h2V7zM1 21h10v-6H1v6zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm4 0h-2v2h2V3zm-4 16h-2v2h2v-2zM3 11H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3zM3 3H1v2h2V3z"
	}), 'PhotoSizeSelectSmallSharp');
	
	exports.default = _default;

/***/ },
/* 4731 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 19h2v2h-2zm-4 0h2v2h-2zM1 19c0 1.1.9 2 2 2h8v-6H1v4zM9 3h2v2H9zM5 3h2v2H5zm12 0h2v2h-2zM1 11h2v2H1zm0-4h2v2H1zm2-4C2 3 1 4 1 5h2V3zm10 0h2v2h-2zm8 18c1 0 2-1 2-2h-2v2zm0-10h2v2h-2zm0-8v2h2c0-1-1-2-2-2zm0 12h2v2h-2zm0-8h2v2h-2z"
	}), 'PhotoSizeSelectSmallTwoTone');
	
	exports.default = _default;

/***/ },
/* 4732 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 5H5v14h14V5zM6 17l3-3.86 2.14 2.58 3-3.87L18 17H6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 21h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2zM5 5h14v14H5V5zm6.14 10.72L9 13.14 6 17h12l-3.86-5.14z"
	})), 'PhotoTwoTone');
	
	exports.default = _default;

/***/ },
/* 4733 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"
	}), 'PictureAsPdf');
	
	exports.default = _default;

/***/ },
/* 4734 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm12 6V9c0-.55-.45-1-1-1h-2v5h2c.55 0 1-.45 1-1zm-2-3h1v3h-1V9zm4 2h1v-1h-1V9h1V8h-2v5h1zm-8 0h1c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H9v5h1v-2zm0-2h1v1h-1V9z"
	}), 'PictureAsPdfOutlined');
	
	exports.default = _default;

/***/ },
/* 4735 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v1.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75V8c0-.55.45-1 1-1H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2c-.28 0-.5-.22-.5-.5v-5c0-.28.22-.5.5-.5h2c.83 0 1.5.67 1.5 1.5v3zm4-3.75c0 .41-.34.75-.75.75H19v1h.75c.41 0 .75.34.75.75s-.34.75-.75.75H19v1.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75V8c0-.55.45-1 1-1h1.25c.41 0 .75.34.75.75zM9 9.5h1v-1H9v1zM3 6c-.55 0-1 .45-1 1v13c0 1.1.9 2 2 2h13c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1zm11 5.5h1v-3h-1v3z"
	}), 'PictureAsPdfRounded');
	
	exports.default = _default;

/***/ },
/* 4736 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H6v16h16V2zm-10.5 9H9v2H7.5V7h4v4zm5 .5c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v16h16v-2H4V6zm10 5.5h1v-3h-1v3z"
	}), 'PictureAsPdfSharp');
	
	exports.default = _default;

/***/ },
/* 4737 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
	}), _react.default.createElement("path", {
	  d: "M10 9h1v1h-1zm4 0h1v3h-1zm-6 7h12V4H8v12zm9-8h2v1h-1v1h1v1h-1v2h-1V8zm-4 0h2c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1h-2V8zM9 8h2c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1h-1v2H9V8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-4-4V9c0-.55-.45-1-1-1h-2v5h2c.55 0 1-.45 1-1zm-2-3h1v3h-1V9zm4 2h1v-1h-1V9h1V8h-2v5h1zm-8 0h1c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H9v5h1v-2zm0-2h1v1h-1V9z"
	})), 'PictureAsPdfTwoTone');
	
	exports.default = _default;

/***/ },
/* 4738 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 7h-8v6h8V7zm2-4H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z"
	}), 'PictureInPicture');
	
	exports.default = _default;

/***/ },
/* 4739 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 11h-8v6h8v-6zm4 8V4.98C23 3.88 22.1 3 21 3H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H3V4.97h18v14.05z"
	}), 'PictureInPictureAlt');
	
	exports.default = _default;

/***/ },
/* 4740 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 11h-8v6h8v-6zm-2 4h-4v-2h4v2zm4-12H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V4.98C23 3.88 22.1 3 21 3zm0 16.02H3V4.97h18v14.05z"
	}), 'PictureInPictureAltOutlined');
	
	exports.default = _default;

/***/ },
/* 4741 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 11h-6c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm5 8V4.98C23 3.88 22.1 3 21 3H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-3 .02H4c-.55 0-1-.45-1-1V5.97c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v12.05c0 .55-.45 1-1 1z"
	}), 'PictureInPictureAltRounded');
	
	exports.default = _default;

/***/ },
/* 4742 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 11h-8v6h8v-6zm4 10V3H1v18h22zm-2-1.98H3V4.97h18v14.05z"
	}), 'PictureInPictureAltSharp');
	
	exports.default = _default;

/***/ },
/* 4743 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 11h-8v6h8v-6zm-2 4h-4v-2h4v2zm4-12H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V4.98C23 3.88 22.1 3 21 3zm0 16.02H3V4.97h18v14.05z"
	}), _react.default.createElement("path", {
	  d: "M13 13h4v2h-4z",
	  opacity: ".3"
	})), 'PictureInPictureAltTwoTone');
	
	exports.default = _default;

/***/ },
/* 4744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 7h-8v6h8V7zm-2 4h-4V9h4v2zm4-8H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z"
	}), 'PictureInPictureOutlined');
	
	exports.default = _default;

/***/ },
/* 4745 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 7h-6c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm3-4H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm-1 16.01H4c-.55 0-1-.45-1-1V5.98c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v12.03c0 .55-.45 1-1 1z"
	}), 'PictureInPictureRounded');
	
	exports.default = _default;

/***/ },
/* 4746 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 7h-8v6h8V7zm4-4H1v17.98h22V3zm-2 16.01H3V4.98h18v14.03z"
	}), 'PictureInPictureSharp');
	
	exports.default = _default;

/***/ },
/* 4747 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 7h-8v6h8V7zm-2 4h-4V9h4v2z"
	}), _react.default.createElement("path", {
	  d: "M13 9h4v2h-4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z"
	})), 'PictureInPictureTwoTone');
	
	exports.default = _default;

/***/ },
/* 4748 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z"
	}), 'PieChart');
	
	exports.default = _default;

/***/ },
/* 4749 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm7.93 9H13V4.07c3.61.45 6.48 3.32 6.93 6.93zM4 12c0-4.07 3.06-7.44 7-7.93v15.86c-3.94-.49-7-3.86-7-7.93zm9 7.93V13h6.93c-.45 3.61-3.32 6.48-6.93 6.93z"
	}), 'PieChartOutlined');
	
	exports.default = _default;

/***/ },
/* 4750 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 3.18v17.64c0 .64-.59 1.12-1.21.98C5.32 20.8 2 16.79 2 12s3.32-8.8 7.79-9.8c.62-.14 1.21.34 1.21.98zm2.03 0v6.81c0 .55.45 1 1 1h6.79c.64 0 1.12-.59.98-1.22-.85-3.76-3.8-6.72-7.55-7.57-.63-.14-1.22.34-1.22.98zm0 10.83v6.81c0 .64.59 1.12 1.22.98 3.76-.85 6.71-3.82 7.56-7.58.14-.62-.35-1.22-.98-1.22h-6.79c-.56.01-1.01.46-1.01 1.01z"
	}), 'PieChartRounded');
	
	exports.default = _default;

/***/ },
/* 4751 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z"
	}), 'PieChartSharp');
	
	exports.default = _default;

/***/ },
/* 4752 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 12c0 4.07 3.06 7.44 7 7.93V4.07C7.06 4.56 4 7.93 4 12zm9 7.93c3.61-.45 6.48-3.32 6.93-6.93H13v6.93zm0-15.86V11h6.93c-.45-3.61-3.32-6.48-6.93-6.93z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.86-7-7.93s3.06-7.44 7-7.93v15.86zm2 0V13h6.93c-.45 3.61-3.32 6.48-6.93 6.93zM13 11V4.07c3.61.45 6.48 3.32 6.93 6.93H13z"
	})), 'PieChartTwoTone');
	
	exports.default = _default;

/***/ },
/* 4753 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z"
	}), 'PinDrop');
	
	exports.default = _default;

/***/ },
/* 4754 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 20h14v2H5zM18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zM8 8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.13-2.08 5.46-4 7.91-1.92-2.44-4-5.78-4-7.91zm4-2c-1.1 0-2 .9-2 2s.9 2 2 2c1.11 0 2-.9 2-2s-.9-2-2-2z"
	}), 'PinDropOutlined');
	
	exports.default = _default;

/***/ },
/* 4755 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 3.49 3.62 8.19 5.23 10.12.4.48 1.13.48 1.53 0C14.38 16.19 18 11.49 18 8zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 21c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1z"
	}), 'PinDropRounded');
	
	exports.default = _default;

/***/ },
/* 4756 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z"
	}), 'PinDropSharp');
	
	exports.default = _default;

/***/ },
/* 4757 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4C9.79 4 8 5.79 8 8c0 2.13 2.08 5.47 4 7.91 1.92-2.44 4-5.78 4-7.91 0-2.21-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.89 2-2 2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 20h14v2H5zm7-18C8.69 2 6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11c0-3.31-2.69-6-6-6zm0 13.91C10.08 13.47 8 10.13 8 8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.13-2.08 5.46-4 7.91zM12 6c-1.1 0-2 .9-2 2s.9 2 2 2c1.11 0 2-.9 2-2s-.9-2-2-2z"
	})), 'PinDropTwoTone');
	
	exports.default = _default;

/***/ },
/* 4758 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.04 21.54c.96.29 1.93.46 2.96.46a10 10 0 0 0 10-10A10 10 0 0 0 12 2 10 10 0 0 0 2 12c0 4.25 2.67 7.9 6.44 9.34-.09-.78-.18-2.07 0-2.96l1.15-4.94s-.29-.58-.29-1.5c0-1.38.86-2.41 1.84-2.41.86 0 1.26.63 1.26 1.44 0 .86-.57 2.09-.86 3.27-.17.98.52 1.84 1.52 1.84 1.78 0 3.16-1.9 3.16-4.58 0-2.4-1.72-4.04-4.19-4.04-2.82 0-4.48 2.1-4.48 4.31 0 .86.28 1.73.74 2.3.09.06.09.14.06.29l-.29 1.09c0 .17-.11.23-.28.11-1.28-.56-2.02-2.38-2.02-3.85 0-3.16 2.24-6.03 6.56-6.03 3.44 0 6.12 2.47 6.12 5.75 0 3.44-2.13 6.2-5.18 6.2-.97 0-1.92-.52-2.26-1.13l-.67 2.37c-.23.86-.86 2.01-1.29 2.7v-.03z"
	}), 'Pinterest');
	
	exports.default = _default;

/***/ },
/* 4759 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
	}), 'Place');
	
	exports.default = _default;

/***/ },
/* 4760 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "9",
	  r: "2.5"
	})), 'PlaceOutlined');
	
	exports.default = _default;

/***/ },
/* 4761 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C8.13 2 5 5.13 5 9c0 4.17 4.42 9.92 6.24 12.11.4.48 1.13.48 1.53 0C14.58 18.92 19 13.17 19 9c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
	}), 'PlaceRounded');
	
	exports.default = _default;

/***/ },
/* 4762 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
	}), 'PlaceSharp');
	
	exports.default = _default;

/***/ },
/* 4763 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17 9c0-2.76-2.24-5-5-5S7 6.24 7 9c0 2.85 2.92 7.21 5 9.88 2.12-2.69 5-7 5-9.88zM9.5 9c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5S9.5 10.38 9.5 9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 9c0-3.87-3.13-7-7-7S5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13zm-7-5c2.76 0 5 2.24 5 5 0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9c0-2.76 2.24-5 5-5z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "9",
	  r: "2.5"
	})), 'PlaceTwoTone');
	
	exports.default = _default;

/***/ },
/* 4764 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 5v14l11-7z"
	}), 'PlayArrow');
	
	exports.default = _default;

/***/ },
/* 4765 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 8.64L15.27 12 10 15.36V8.64M8 5v14l11-7L8 5z"
	}), 'PlayArrowOutlined');
	
	exports.default = _default;

/***/ },
/* 4766 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18c.62-.39.62-1.29 0-1.69L9.54 5.98C8.87 5.55 8 6.03 8 6.82z"
	}), 'PlayArrowRounded');
	
	exports.default = _default;

/***/ },
/* 4767 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 5v14l11-7L8 5z"
	}), 'PlayArrowSharp');
	
	exports.default = _default;

/***/ },
/* 4768 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M10 8.64v6.72L15.27 12z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M8 19l11-7L8 5v14zm2-10.36L15.27 12 10 15.36V8.64z"
	})), 'PlayArrowTwoTone');
	
	exports.default = _default;

/***/ },
/* 4769 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"
	}), 'PlayCircleFilled');
	
	exports.default = _default;

/***/ },
/* 4770 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"
	}), 'PlayCircleFilledOutlined');
	
	exports.default = _default;

/***/ },
/* 4771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 13.5v-7c0-.41.47-.65.8-.4l4.67 3.5c.27.2.27.6 0 .8l-4.67 3.5c-.33.25-.8.01-.8-.4z"
	}), 'PlayCircleFilledRounded');
	
	exports.default = _default;

/***/ },
/* 4772 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"
	}), 'PlayCircleFilledSharp');
	
	exports.default = _default;

/***/ },
/* 4773 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 20c4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8 3.59 8 8 8zM10 7.5l6 4.5-6 4.5v-9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zm0-18c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8zm-2 3.5v9l6-4.5z"
	})), 'PlayCircleFilledTwoTone');
	
	exports.default = _default;

/***/ },
/* 4774 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  transform: "scale(0.5, 0.5)",
	  d: "M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm-4 29V15l12 9-12 9z"
	}), 'PlayCircleFilledWhite');
	
	exports.default = _default;

/***/ },
/* 4775 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-2-3.5l6-4.5-6-4.5z"
	}), 'PlayCircleFilledWhiteOutlined');
	
	exports.default = _default;

/***/ },
/* 4776 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 13.5v-7c0-.41.47-.65.8-.4l4.67 3.5c.27.2.27.6 0 .8l-4.67 3.5c-.33.25-.8.01-.8-.4z"
	}), 'PlayCircleFilledWhiteRounded');
	
	exports.default = _default;

/***/ },
/* 4777 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"
	}), 'PlayCircleFilledWhiteSharp');
	
	exports.default = _default;

/***/ },
/* 4778 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 20c4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8 3.59 8 8 8zM10 7.5l6 4.5-6 4.5v-9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zm0-18c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8zm-2 3.5v9l6-4.5z"
	})), 'PlayCircleFilledWhiteTwoTone');
	
	exports.default = _default;

/***/ },
/* 4779 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'PlayCircleOutline');
	
	exports.default = _default;

/***/ },
/* 4780 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 16.5l6-4.5-6-4.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'PlayCircleOutlineOutlined');
	
	exports.default = _default;

/***/ },
/* 4781 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.8 15.9l4.67-3.5c.27-.2.27-.6 0-.8L10.8 8.1c-.33-.25-.8-.01-.8.4v7c0 .41.47.65.8.4zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'PlayCircleOutlineRounded');
	
	exports.default = _default;

/***/ },
/* 4782 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'PlayCircleOutlineSharp');
	
	exports.default = _default;

/***/ },
/* 4783 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 16.5l6-4.5-6-4.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'PlayCircleOutlineTwoTone');
	
	exports.default = _default;

/***/ },
/* 4784 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z"
	}), 'PlayForWork');
	
	exports.default = _default;

/***/ },
/* 4785 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z"
	}), 'PlayForWorkOutlined');
	
	exports.default = _default;

/***/ },
/* 4786 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 6v4.59H8.71c-.45 0-.67.54-.35.85l3.29 3.29c.2.2.51.2.71 0l3.29-3.29c.31-.31.09-.85-.35-.85H13V6c0-.55-.45-1-1-1s-1 .45-1 1zm-3.9 8c-.61 0-1.11.55-.99 1.15C6.65 17.91 9.08 20 12 20s5.35-2.09 5.89-4.85c.12-.6-.38-1.15-.99-1.15-.49 0-.88.35-.98.83C15.53 16.64 13.93 18 12 18s-3.53-1.36-3.91-3.17c-.1-.48-.5-.83-.99-.83z"
	}), 'PlayForWorkRounded');
	
	exports.default = _default;

/***/ },
/* 4787 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z"
	}), 'PlayForWorkSharp');
	
	exports.default = _default;

/***/ },
/* 4788 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z"
	}), 'PlayForWorkTwoTone');
	
	exports.default = _default;

/***/ },
/* 4789 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z"
	}), 'PlaylistAdd');
	
	exports.default = _default;

/***/ },
/* 4790 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z"
	}), 'PlaylistAddCheck');
	
	exports.default = _default;

/***/ },
/* 4791 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z"
	}), 'PlaylistAddCheckOutlined');
	
	exports.default = _default;

/***/ },
/* 4792 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 10H3c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zm0-4H3c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zM3 16h6c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1zm19.21-3.79l.09.09c.39.39.39 1.02 0 1.41l-5.58 5.59c-.39.39-1.02.39-1.41 0l-3.09-3.09a.9959.9959 0 010-1.41l.09-.09c.39-.39 1.02-.39 1.41 0l2.3 2.3 4.78-4.79c.38-.4 1.02-.4 1.41-.01z"
	}), 'PlaylistAddCheckRounded');
	
	exports.default = _default;

/***/ },
/* 4793 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z"
	}), 'PlaylistAddCheckSharp');
	
	exports.default = _default;

/***/ },
/* 4794 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 6h12v2H2zm0 4h12v2H2zm0 4h8v2H2zm14.01 3L13 14l-1.5 1.5 4.51 4.5L23 13l-1.5-1.5z"
	}), 'PlaylistAddCheckTwoTone');
	
	exports.default = _default;

/***/ },
/* 4795 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z"
	}), 'PlaylistAddOutlined');
	
	exports.default = _default;

/***/ },
/* 4796 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 10H3c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zm0-4H3c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zm5 8v-3c0-.55-.45-1-1-1s-1 .45-1 1v3h-3c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1h-3zM3 16h6c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1z"
	}), 'PlaylistAddRounded');
	
	exports.default = _default;

/***/ },
/* 4797 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z"
	}), 'PlaylistAddSharp');
	
	exports.default = _default;

/***/ },
/* 4798 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 14h8v2H2zm0-4h12v2H2zm0-4h12v2H2zm16 4h-2v4h-4v2h4v4h2v-4h4v-2h-4z"
	}), 'PlaylistAddTwoTone');
	
	exports.default = _default;

/***/ },
/* 4799 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 10h12v2H4zm0-4h12v2H4zm0 8h8v2H4zm10 0v6l5-3z"
	}), 'PlaylistPlay');
	
	exports.default = _default;

/***/ },
/* 4800 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 10h12v2H4zm0-4h12v2H4zm0 8h8v2H4zm10 0v6l5-3z"
	}), 'PlaylistPlayOutlined');
	
	exports.default = _default;

/***/ },
/* 4801 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 10h10c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1zm0-4h10c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1zm0 8h6c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1zm9 .88v4.23c0 .39.42.63.76.43l3.53-2.12c.32-.19.32-.66 0-.86l-3.53-2.12c-.34-.19-.76.05-.76.44z"
	}), 'PlaylistPlayRounded');
	
	exports.default = _default;

/***/ },
/* 4802 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 10h12v2H4zm0-4h12v2H4zm0 8h8v2H4zm10 0v6l5-3z"
	}), 'PlaylistPlaySharp');
	
	exports.default = _default;

/***/ },
/* 4803 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 10h12v2H4zm0-4h12v2H4zm0 8h8v2H4zm10 6l5-3-5-3z"
	}), 'PlaylistPlayTwoTone');
	
	exports.default = _default;

/***/ },
/* 4804 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 8H8v4H4v2h4v4h2v-4h4v-2h-4zm4.5-1.92V7.9l2.5-.5V18h2V5z"
	}), 'PlusOne');
	
	exports.default = _default;

/***/ },
/* 4805 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 8H8v4H4v2h4v4h2v-4h4v-2h-4V8zm4.5-1.92V7.9l2.5-.5V18h2V5l-4.5 1.08z"
	}), 'PlusOneOutlined');
	
	exports.default = _default;

/***/ },
/* 4806 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 8c-.55 0-1 .45-1 1v3H5c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V9c0-.55-.45-1-1-1zm5.5-1.21c0 .57.52 1 1.08.89L17 7.4V17c0 .55.45 1 1 1s1-.45 1-1V6.27c0-.65-.6-1.12-1.23-.97l-2.57.62c-.41.09-.7.46-.7.87z"
	}), 'PlusOneRounded');
	
	exports.default = _default;

/***/ },
/* 4807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 8H8v4H4v2h4v4h2v-4h4v-2h-4V8zm4.5-1.92V7.9l2.5-.5V18h2V5l-4.5 1.08z"
	}), 'PlusOneSharp');
	
	exports.default = _default;

/***/ },
/* 4808 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 8H8v4H4v2h4v4h2v-4h4v-2h-4V8zm4.5-1.92V7.9l2.5-.5V18h2V5l-4.5 1.08z"
	}), 'PlusOneTwoTone');
	
	exports.default = _default;

/***/ },
/* 4809 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21 5l-9-4-9 4v6c0 5.55 3.84 10.74 9 12 2.3-.56 4.33-1.9 5.88-3.71l-3.12-3.12c-1.94 1.29-4.58 1.07-6.29-.64-1.95-1.95-1.95-5.12 0-7.07 1.95-1.95 5.12-1.95 7.07 0 1.71 1.71 1.92 4.35.64 6.29l2.9 2.9C20.29 15.69 21 13.38 21 11V5z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "3"
	})), 'Policy');
	
	exports.default = _default;

/***/ },
/* 4810 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm7 10c0 1.85-.51 3.65-1.38 5.21l-1.45-1.45c1.29-1.94 1.07-4.58-.64-6.29-1.95-1.95-5.12-1.95-7.07 0-1.95 1.95-1.95 5.12 0 7.07 1.71 1.71 4.35 1.92 6.29.64l1.72 1.72c-1.19 1.42-2.73 2.51-4.47 3.04-4.02-1.25-7-5.42-7-9.94V6.3l7-3.11 7 3.11V11zm-7 4c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
	}), 'PolicyOutlined');
	
	exports.default = _default;

/***/ },
/* 4811 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21 6.3c0-.79-.47-1.51-1.19-1.83l-7-3.11c-.52-.23-1.11-.23-1.62 0l-7 3.11C3.47 4.79 3 5.51 3 6.3V11c0 5.55 3.84 10.74 9 12 2.3-.56 4.33-1.9 5.88-3.71l-3.12-3.12c-1.94 1.29-4.58 1.07-6.29-.64-1.95-1.95-1.95-5.12 0-7.07 1.95-1.95 5.12-1.95 7.07 0 1.71 1.71 1.92 4.35.64 6.29l2.9 2.9C20.29 15.69 21 13.38 21 11V6.3z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "3"
	})), 'PolicyRounded');
	
	exports.default = _default;

/***/ },
/* 4812 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21 5l-9-4-9 4v6c0 5.55 3.84 10.74 9 12 2.3-.56 4.33-1.9 5.88-3.71l-3.12-3.12c-1.94 1.29-4.58 1.07-6.29-.64-1.95-1.95-1.95-5.12 0-7.07 1.95-1.95 5.12-1.95 7.07 0 1.71 1.71 1.92 4.35.64 6.29l2.9 2.9C20.29 15.69 21 13.38 21 11V5z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "3"
	})), 'PolicySharp');
	
	exports.default = _default;

/***/ },
/* 4813 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 6.3V11c0 4.52 2.98 8.69 7 9.93 1.74-.53 3.28-1.62 4.47-3.04l-1.72-1.72c-1.94 1.29-4.58 1.07-6.29-.64-1.95-1.95-1.95-5.12 0-7.07 1.95-1.95 5.12-1.95 7.07 0 1.71 1.71 1.92 4.35.64 6.29l1.45 1.45C18.49 14.65 19 12.85 19 11V6.3l-7-3.11L5 6.3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 .65-.16 1.27-.38 1.87-.65 1.8-.82 3.36-2.13 4.57-3.74C20.04 16.46 21 13.77 21 11V5l-9-4zm7 10c0 1.85-.51 3.65-1.38 5.21l-1.45-1.45c1.29-1.94 1.07-4.58-.64-6.29-1.95-1.95-5.12-1.95-7.07 0-1.95 1.95-1.95 5.12 0 7.07 1.71 1.71 4.35 1.92 6.29.64l1.72 1.72c-1.19 1.42-2.73 2.51-4.47 3.04-4.02-1.25-7-5.42-7-9.94V6.3l7-3.11 7 3.11V11zm-4 1c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"
	})), 'PolicyTwoTone');
	
	exports.default = _default;

/***/ },
/* 4814 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
	}), 'Poll');
	
	exports.default = _default;

/***/ },
/* 4815 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"
	}), 'PollOutlined');
	
	exports.default = _default;

/***/ },
/* 4816 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM8 17c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v5c0 .55-.45 1-1 1zm4 0c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1zm4 0c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1z"
	}), 'PollRounded');
	
	exports.default = _default;

/***/ },
/* 4817 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 3v18h18V3H3zm6 14H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
	}), 'PollSharp');
	
	exports.default = _default;

/***/ },
/* 4818 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14V5H5v14zm10-6h2v4h-2v-4zm-4-6h2v10h-2V7zm-4 3h2v7H7v-7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"
	})), 'PollTwoTone');
	
	exports.default = _default;

/***/ },
/* 4819 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8z"
	}), 'Polymer');
	
	exports.default = _default;

/***/ },
/* 4820 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8L19 4z"
	}), 'PolymerOutlined');
	
	exports.default = _default;

/***/ },
/* 4821 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8L19 4z"
	}), 'PolymerRounded');
	
	exports.default = _default;

/***/ },
/* 4822 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8L19 4z"
	}), 'PolymerSharp');
	
	exports.default = _default;

/***/ },
/* 4823 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8L19 4z"
	}), 'PolymerTwoTone');
	
	exports.default = _default;

/***/ },
/* 4824 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M22 21c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.08.64-2.19.64-1.11 0-1.73-.37-2.18-.64-.37-.23-.6-.36-1.15-.36s-.78.13-1.15.36c-.46.27-1.08.64-2.19.64v-2c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36v2zm0-4.5c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36s-.78.13-1.15.36c-.47.27-1.09.64-2.2.64v-2c.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36v2zM8.67 12c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36z"
	}), _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "5.5",
	  r: "2.5"
	})), 'Pool');
	
	exports.default = _default;

/***/ },
/* 4825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M10 8l-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36s.78-.13 1.15-.36c.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.55 0 .78-.13 1.15-.36.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1zm12 8.5h-.02.02zm-16.65-1c.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.06.63 2.16.64v-2c-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.6.36-1.15.36s-.78-.14-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.2-.64.37-.23.6-.36 1.15-.36zM18.67 18c-1.11 0-1.73.37-2.18.64-.37.23-.6.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36s-.78-.13-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.19-.64.37-.23.6-.36 1.15-.36.55 0 .78.13 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.19-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.72-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64v-2c-.56 0-.78-.13-1.15-.36-.45-.27-1.07-.64-2.18-.64z"
	}), _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "5.5",
	  r: "2.5"
	})), 'PoolOutlined');
	
	exports.default = _default;

/***/ },
/* 4826 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6.11 5.56C7.3 5.7 8.14 6.14 9 7l1 1-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36s.78-.13 1.15-.36c.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.55 0 .78-.13 1.15-.36.12-.07.26-.15.41-.23L10.48 5C9.22 3.74 8.04 3.2 6.3 3.05 5.6 2.99 5 3.56 5 4.26v.09c0 .63.49 1.13 1.11 1.21zm15.24 13.35c-.17-.06-.32-.15-.5-.27-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.6.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36s-.78-.13-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.18.11-.33.2-.5.27-.38.13-.65.45-.65.85v.12c0 .67.66 1.13 1.3.91.37-.13.65-.3.89-.44.37-.22.6-.35 1.15-.35.55 0 .78.13 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.19-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.72-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.23.14.51.31.88.44.63.22 1.3-.24 1.3-.91v-.12c0-.41-.27-.73-.65-.86zM3.11 16.35c.47-.13.81-.33 1.09-.49.37-.23.6-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.23.14.5.3.85.43.63.23 1.31-.24 1.31-.91v-.12c0-.4-.27-.72-.64-.86-.17-.06-.32-.15-.51-.26-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.6.36-1.15.36s-.78-.14-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.18.11-.33.2-.5.27-.38.13-.65.45-.65.85v.23c0 .58.55 1.02 1.11.86z"
	}), _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "5.5",
	  r: "2.5"
	})), 'PoolRounded');
	
	exports.default = _default;

/***/ },
/* 4827 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M10 8l-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36s.78-.13 1.15-.36c.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.55 0 .78-.13 1.15-.36.12-.07.26-.15.41-.23L10.48 5 5 3v2.5L9 7l1 1zm12 8.5h-.02.02zm-16.65-1c.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.06.63 2.16.64v-2c-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.6.36-1.15.36s-.78-.14-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.2-.64.37-.23.6-.36 1.15-.36zM18.67 18c-1.11 0-1.73.37-2.18.64-.37.23-.6.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36s-.78-.13-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.19-.64.37-.23.6-.36 1.15-.36.55 0 .78.13 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.19-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.72-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64v-2c-.56 0-.78-.13-1.15-.36-.45-.27-1.07-.64-2.18-.64z"
	}), _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "5.5",
	  r: "2.5"
	})), 'PoolSharp');
	
	exports.default = _default;

/***/ },
/* 4828 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M22 21c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.08.64-2.19.64s-1.73-.37-2.18-.64c-.37-.23-.6-.36-1.15-.36s-.78.13-1.15.36c-.46.27-1.08.64-2.19.64v-2c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36v2zm0-4.5c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36s-.78.13-1.15.36c-.47.27-1.09.64-2.2.64v-2c.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36v2H22zM8.67 12c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36s.78-.13 1.15-.36c.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "5.5",
	  r: "2.5",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M22 16.5h-.02.02zM10 8l-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36s.78-.13 1.15-.36c.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.55 0 .78-.13 1.15-.36.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1zm-4.65 7.5c.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.06.63 2.16.64v-2c-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.6.36-1.15.36s-.78-.14-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.2-.64.37-.23.6-.36 1.15-.36zM18.67 18c-1.11 0-1.73.37-2.18.64-.37.23-.6.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36s-.78-.13-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.19-.64.37-.23.6-.36 1.15-.36.55 0 .78.13 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.19-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.72-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64v-2c-.56 0-.78-.13-1.15-.36-.45-.27-1.07-.64-2.18-.64z"
	}), _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "5.5",
	  r: "2.5"
	})), 'PoolTwoTone');
	
	exports.default = _default;

/***/ },
/* 4829 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.56 14.24c.28-.69.44-1.45.44-2.24 0-3.31-2.69-6-6-6-.79 0-1.55.16-2.24.44l1.62 1.62c.2-.03.41-.06.62-.06 2.21 0 4 1.79 4 4 0 .21-.02.42-.05.63l1.61 1.61zM12 4c4.42 0 8 3.58 8 8 0 1.35-.35 2.62-.95 3.74l1.47 1.47C21.46 15.69 22 13.91 22 12c0-5.52-4.48-10-10-10-1.91 0-3.69.55-5.21 1.47l1.46 1.46C9.37 4.34 10.65 4 12 4zM3.27 2.5L2 3.77l2.1 2.1C2.79 7.57 2 9.69 2 12c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 17.53 4 14.96 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02.01.01 7.51 7.51L21 20.23 4.27 3.5l-1-1z"
	}), 'PortableWifiOff');
	
	exports.default = _default;

/***/ },
/* 4830 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.42 2.36L2.01 3.78 4.1 5.87C2.79 7.57 2 9.69 2 12c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 17.53 4 14.96 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02 7.52 7.52 1.41-1.41L3.42 2.36zm14.29 11.46c.18-.57.29-1.19.29-1.82 0-3.31-2.69-6-6-6-.63 0-1.25.11-1.82.29l1.72 1.72c.03 0 .06-.01.1-.01 2.21 0 4 1.79 4 4 0 .04-.01.07-.01.11l1.72 1.71zM12 4c4.42 0 8 3.58 8 8 0 1.2-.29 2.32-.77 3.35l1.49 1.49C21.53 15.4 22 13.76 22 12c0-5.52-4.48-10-10-10-1.76 0-3.4.48-4.84 1.28l1.48 1.48C9.66 4.28 10.8 4 12 4z"
	}), 'PortableWifiOffOutlined');
	
	exports.default = _default;

/***/ },
/* 4831 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.71 3.07c-.39.39-.39 1.02 0 1.41L4.1 5.87C2.79 7.57 2 9.69 2 12c0 3.3 1.6 6.22 4.06 8.04.48.35 1.16.21 1.46-.31.25-.43.14-.99-.26-1.29C5.29 16.98 4 14.65 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 1.8.8 3.41 2.06 4.51.46.4 1.19.25 1.5-.28l.01-.01c.24-.42.13-.94-.23-1.26C8.52 14.23 8 13.18 8 12c0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02 6.81 6.81c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L4.13 3.07c-.39-.39-1.03-.39-1.42 0zm15 10.75c.18-.57.29-1.19.29-1.82 0-3.31-2.69-6-6-6-.63 0-1.25.11-1.82.29l1.72 1.72c.03 0 .06-.01.1-.01 2.21 0 4 1.79 4 4 0 .04-.01.07-.01.11l1.72 1.71zM12 4c4.42 0 8 3.58 8 8 0 1.2-.29 2.32-.77 3.35l1.49 1.49C21.53 15.4 22 13.76 22 12c0-5.52-4.48-10-10-10-1.76 0-3.4.48-4.84 1.28l1.48 1.48C9.66 4.28 10.8 4 12 4z"
	}), 'PortableWifiOffRounded');
	
	exports.default = _default;

/***/ },
/* 4832 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.42 2.36L2.01 3.78 4.1 5.87C2.79 7.57 2 9.69 2 12c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 17.53 4 14.96 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02 7.52 7.52 1.41-1.41L3.42 2.36zm14.29 11.46c.18-.57.29-1.19.29-1.82 0-3.31-2.69-6-6-6-.63 0-1.25.11-1.82.29l1.72 1.72c.03 0 .06-.01.1-.01 2.21 0 4 1.79 4 4 0 .04-.01.07-.01.11l1.72 1.71zM12 4c4.42 0 8 3.58 8 8 0 1.2-.29 2.32-.77 3.35l1.49 1.49C21.53 15.4 22 13.76 22 12c0-5.52-4.48-10-10-10-1.76 0-3.4.48-4.84 1.28l1.48 1.48C9.66 4.28 10.8 4 12 4z"
	}), 'PortableWifiOffSharp');
	
	exports.default = _default;

/***/ },
/* 4833 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.42 2.36L2.01 3.78 4.1 5.87C2.79 7.57 2 9.69 2 12c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 17.53 4 14.96 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02 7.52 7.52 1.41-1.41L3.42 2.36zm14.29 11.46c.18-.57.29-1.19.29-1.82 0-3.31-2.69-6-6-6-.63 0-1.25.11-1.82.29l1.72 1.72c.03 0 .06-.01.1-.01 2.21 0 4 1.79 4 4 0 .04-.01.07-.01.11l1.72 1.71zM12 4c4.42 0 8 3.58 8 8 0 1.2-.29 2.32-.77 3.35l1.49 1.49C21.53 15.4 22 13.76 22 12c0-5.52-4.48-10-10-10-1.76 0-3.4.48-4.84 1.28l1.48 1.48C9.66 4.28 10.8 4 12 4z"
	}), 'PortableWifiOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 4834 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 12.25c1.24 0 2.25-1.01 2.25-2.25S13.24 7.75 12 7.75 9.75 8.76 9.75 10s1.01 2.25 2.25 2.25zm4.5 4c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V17h9v-.75zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
	}), 'Portrait');
	
	exports.default = _default;

/***/ },
/* 4835 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 8.58c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V18h12v-1.42zM8.48 16c.74-.51 2.23-1 3.52-1s2.78.49 3.52 1H8.48zM19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
	}), 'PortraitOutlined');
	
	exports.default = _default;

/***/ },
/* 4836 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 12.25c1.24 0 2.25-1.01 2.25-2.25S13.24 7.75 12 7.75 9.75 8.76 9.75 10s1.01 2.25 2.25 2.25zm4.5 4c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V17h9v-.75zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1z"
	}), 'PortraitRounded');
	
	exports.default = _default;

/***/ },
/* 4837 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 12.25c1.24 0 2.25-1.01 2.25-2.25S13.24 7.75 12 7.75 9.75 8.76 9.75 10s1.01 2.25 2.25 2.25zm4.5 4c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V17h9v-.75zM21 3H3v18h18V3zm-2 16H5V5h14v14z"
	}), 'PortraitSharp');
	
	exports.default = _default;

/***/ },
/* 4838 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14V5H5v14zm7-13c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zM6 16.58C6 14.08 9.97 13 12 13s6 1.08 6 3.58V18H6v-1.42z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 8.58c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V18h12v-1.42zM8.48 16c.74-.51 2.23-1 3.52-1s2.78.49 3.52 1H8.48zM19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
	})), 'PortraitTwoTone');
	
	exports.default = _default;

/***/ },
/* 4839 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17 19.22H5V7h7V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-7h-2v7.22z"
	}), _react.default.createElement("path", {
	  d: "M19 2h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V7h3V5h-3V2zM7 9h8v2H7zM7 12v2h8v-2h-3zM7 15h8v2H7z"
	})), 'PostAdd');
	
	exports.default = _default;

/***/ },
/* 4840 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17 19.22H5V7h7V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-7h-2v7.22z"
	}), _react.default.createElement("path", {
	  d: "M19 2h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V7h3V5h-3V2zM7 9h8v2H7zM7 12v2h8v-2h-3zM7 15h8v2H7z"
	})), 'PostAddOutlined');
	
	exports.default = _default;

/***/ },
/* 4841 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18 12c-.55 0-1 .45-1 1v5.22c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h5c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-6c0-.55-.45-1-1-1zM21.02 5H19V2.98c0-.54-.44-.98-.98-.98h-.03c-.55 0-.99.44-.99.98V5h-2.01c-.54 0-.98.44-.99.98v.03c0 .55.44.99.99.99H17v2.01c0 .54.44.99.99.98h.03c.54 0 .98-.44.98-.98V7h2.02c.54 0 .98-.44.98-.98v-.04c0-.54-.44-.98-.98-.98z"
	}), _react.default.createElement("path", {
	  d: "M14 9H8c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zM14 12H8c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zM14 15H8c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1z"
	})), 'PostAddRounded');
	
	exports.default = _default;

/***/ },
/* 4842 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17 19.22H5V7h7V5H3v16h16v-9h-2z"
	}), _react.default.createElement("path", {
	  d: "M19 2h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V7h3V5h-3V2zM7 9h8v2H7zM7 12v2h8v-2h-3zM7 15h8v2H7z"
	})), 'PostAddSharp');
	
	exports.default = _default;

/***/ },
/* 4843 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17 19.22H5V7h7V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-7h-2v7.22z"
	}), _react.default.createElement("path", {
	  d: "M19 2h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V7h3V5h-3V2zM7 9h8v2H7zM7 12v2h8v-2h-3zM7 15h8v2H7z"
	})), 'PostAddTwoTone');
	
	exports.default = _default;

/***/ },
/* 4844 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.01 7L16 3h-2v4h-4V3H8v4h-.01C7 6.99 6 7.99 6 8.99v5.49L9.5 18v3h5v-3l3.5-3.51v-5.5c0-1-1-2-1.99-1.99z"
	}), 'Power');
	
	exports.default = _default;

/***/ },
/* 4845 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z"
	}), 'PowerInput');
	
	exports.default = _default;

/***/ },
/* 4846 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z"
	}), 'PowerInputOutlined');
	
	exports.default = _default;

/***/ },
/* 4847 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 10c0 .55.45 1 1 1h17c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1zm1 5h3c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1zm7 0h3c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1zm7 0h3c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1z"
	}), 'PowerInputRounded');
	
	exports.default = _default;

/***/ },
/* 4848 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z"
	}), 'PowerInputSharp');
	
	exports.default = _default;

/***/ },
/* 4849 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z"
	}), 'PowerInputTwoTone');
	
	exports.default = _default;

/***/ },
/* 4850 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 14.49V9c0-1-1.01-2.01-2-2V3h-2v4h-4V3H8v2.48l9.51 9.5.49-.49zm-1.76 1.77L7.2 7.2l-.01.01L3.98 4 2.71 5.25l3.36 3.36C6.04 8.74 6 8.87 6 9v5.48L9.5 18v3h5v-3l.48-.48L19.45 22l1.26-1.28-4.47-4.46z"
	}), 'PowerOff');
	
	exports.default = _default;

/***/ },
/* 4851 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 3H8v1.88l2 2zm6 6v3.88l1.8 1.8.2-.2V9c0-1.1-.9-2-2-2V3h-2v4h-3.88l2 2H16zM4.12 3.84L2.71 5.25 6 8.54v5.96L9.5 18v3h5v-3l.48-.48 4.47 4.47 1.41-1.41L4.12 3.84zm8.38 13.33V19h-1v-1.83L8 13.65v-3.11l5.57 5.57-1.07 1.06z"
	}), 'PowerOffOutlined');
	
	exports.default = _default;

/***/ },
/* 4852 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 13.66V8.99c0-1-1.01-2-2-1.99V4c0-.55-.45-1-1-1s-1 .45-1 1v3h-3.88l7.63 7.63c.15-.3.25-.63.25-.97zM10 4c0-.55-.45-1-1-1s-1 .45-1 1v.88l2 2V4zm10.15 15.86l-7.66-7.66-5.1-5.1-2.56-2.56a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l2.63 2.63c-.03.13-.05.27-.05.41v4.66c0 .53.21 1.04.58 1.41L9.5 18v2c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-2l.48-.48 3.76 3.76c.39.39 1.02.39 1.41 0 .39-.39.39-1.03 0-1.42z"
	}), 'PowerOffRounded');
	
	exports.default = _default;

/***/ },
/* 4853 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 14.49V9c0-1.1-.9-2-2-2V3h-2v4h-3.88l7.69 7.69.19-.2zM10 3H8v1.88l2 2zm-5.88.84L2.71 5.25l3.34 3.34c-.03.13-.05.27-.05.4v5.51L9.5 18v3h5v-3l.48-.48 4.47 4.47 1.41-1.41L4.12 3.84z"
	}), 'PowerOffSharp');
	
	exports.default = _default;

/***/ },
/* 4854 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12.12 9L16 12.88V9zm-.62 8.17V19h1v-1.83l1.07-1.06L8 10.54v3.11z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M10 3H8v1.88l2 2zm6 6v3.88l1.8 1.8.2-.2V9c0-1.1-.9-2-2-2V3h-2v4h-3.88l2 2H16zM4.12 3.84L2.71 5.25 6 8.54v5.96L9.5 18v3h5v-3l.48-.48 4.47 4.47 1.41-1.41L4.12 3.84zm8.38 13.33V19h-1v-1.83L8 13.65v-3.11l5.57 5.57-1.07 1.06z"
	})), 'PowerOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 4855 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 9v4.66l-3.5 3.51V19h-1v-1.83L8 13.65V9h8m0-6h-2v4h-4V3H8v4h-.01C6.9 6.99 6 7.89 6 8.98v5.52L9.5 18v3h5v-3l3.5-3.51V9c0-1.1-.9-2-2-2V3z"
	}), 'PowerOutlined');
	
	exports.default = _default;

/***/ },
/* 4856 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.01 7L16 4c0-.55-.45-1-1-1s-1 .45-1 1v3h-4V4c0-.55-.45-1-1-1s-1 .45-1 1v3h-.01C6.9 7 6 7.9 6 8.99v4.66c0 .53.21 1.04.58 1.41L9.5 18v2c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-2l2.92-2.92c.37-.38.58-.89.58-1.42V8.99C18 7.89 17.11 7 16.01 7z"
	}), 'PowerRounded');
	
	exports.default = _default;

/***/ },
/* 4857 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z"
	}), 'PowerSettingsNew');
	
	exports.default = _default;

/***/ },
/* 4858 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z"
	}), 'PowerSettingsNewOutlined');
	
	exports.default = _default;

/***/ },
/* 4859 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1zm5.14 2.86c-.39.39-.38 1-.01 1.39 1.13 1.2 1.83 2.8 1.87 4.57.09 3.83-3.08 7.13-6.91 7.17C8.18 19.05 5 15.9 5 12c0-1.84.71-3.51 1.87-4.76.37-.39.37-1-.01-1.38-.4-.4-1.05-.39-1.43.02C3.98 7.42 3.07 9.47 3 11.74c-.14 4.88 3.83 9.1 8.71 9.25 5.1.16 9.29-3.93 9.29-9 0-2.37-.92-4.51-2.42-6.11-.38-.41-1.04-.42-1.44-.02z"
	}), 'PowerSettingsNewRounded');
	
	exports.default = _default;

/***/ },
/* 4860 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z"
	}), 'PowerSettingsNewSharp');
	
	exports.default = _default;

/***/ },
/* 4861 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z"
	}), 'PowerSettingsNewTwoTone');
	
	exports.default = _default;

/***/ },
/* 4862 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 7V3h-2v4h-4V3H8v4H6v7.5L9.5 18v3h5v-3l3.5-3.51V7h-2z"
	}), 'PowerSharp');
	
	exports.default = _default;

/***/ },
/* 4863 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 13.65l3.5 3.52V19h1v-1.83l3.5-3.51V9H8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16 7V3h-2v4h-4V3H8v4h-.01C6.89 7 6 7.89 6 8.98v5.52L9.5 18v3h5v-3l3.5-3.5V9c0-1.1-.9-2-2-2zm0 6.66l-3.5 3.51V19h-1v-1.83L8 13.65V9h8v4.66z"
	})), 'PowerTwoTone');
	
	exports.default = _default;

/***/ },
/* 4864 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9c-.01-1.34-.83-2.51-2-3 0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z"
	}), 'PregnantWoman');
	
	exports.default = _default;

/***/ },
/* 4865 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9c-.01-1.34-.83-2.51-2-3 0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z"
	}), 'PregnantWomanOutlined');
	
	exports.default = _default;

/***/ },
/* 4866 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9c-.01-1.34-.83-2.51-2-3 0-1.71-1.42-3.08-3.16-3C9.22 7.09 8 8.54 8 10.16V16c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V17h2c.55 0 1-.45 1-1v-3z"
	}), 'PregnantWomanRounded');
	
	exports.default = _default;

/***/ },
/* 4867 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9c-.01-1.34-.83-2.51-2-3 0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z"
	}), 'PregnantWomanSharp');
	
	exports.default = _default;

/***/ },
/* 4868 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9c-.01-1.34-.83-2.51-2-3 0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z"
	}), 'PregnantWomanTwoTone');
	
	exports.default = _default;

/***/ },
/* 4869 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z"
	}), 'PresentToAll');
	
	exports.default = _default;

/***/ },
/* 4870 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z"
	}), 'PresentToAllOutlined');
	
	exports.default = _default;

/***/ },
/* 4871 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm-1 16.02H4c-.55 0-1-.45-1-1V5.98c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v12.04c0 .55-.45 1-1 1zM10 12H8l3.65-3.65c.2-.2.51-.2.71 0L16 12h-2v4h-4v-4z"
	}), 'PresentToAllRounded');
	
	exports.default = _default;

/***/ },
/* 4872 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 3H1v18h22V3zm-2 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z"
	}), 'PresentToAllSharp');
	
	exports.default = _default;

/***/ },
/* 4873 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 19.02h18V4.98H3v14.04zM12 8l4 4h-2v4h-4v-4H8l4-4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M10 16h4v-4h2l-4-4-4 4h2zM21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16.02H3V4.98h18v14.04z"
	})), 'PresentToAllTwoTone');
	
	exports.default = _default;

/***/ },
/* 4874 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
	}), 'Print');
	
	exports.default = _default;

/***/ },
/* 4875 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.1 17H22v-6c0-1.7-1.3-3-3-3h-9l9.1 9zm-.1-7c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-1-3V3H6v1.1L9 7zM1.2 1.8L0 3l4.9 5C3.3 8.1 2 9.4 2 11v6h4v4h11.9l3 3 1.3-1.3-21-20.9zM8 19v-5h2.9l5 5H8z"
	}), 'PrintDisabled');
	
	exports.default = _default;

/***/ },
/* 4876 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M1.41 1.6L0 3.01 5 8c-1.66 0-3 1.34-3 3v6h4v4h12l2.95 2.96 1.41-1.41L1.41 1.6zM6 15H4v-4c0-.55.45-1 1-1h2l3 3H6v2zm2 4v-4h4l4 4H8zM8 5h8v3h-5.34l2 2H19c.55 0 1 .45 1 1v4l-2 .01V13h-2.34l4 4H22v-6c0-1.66-1.34-3-3-3h-1V3H6v.36l2 2V5z"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "11.51",
	  r: "1"
	})), 'PrintDisabledOutlined');
	
	exports.default = _default;

/***/ },
/* 4877 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.12 2.32a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L4.98 8C3.33 8.01 2 9.35 2 11v4c0 1.1.9 2 2 2h2v2c0 1.1.9 2 2 2h8c.55 0 1.04-.22 1.4-.58l2.83 2.83c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L2.12 2.32zM15 19H9c-.55 0-1-.45-1-1v-4h2.98l4.72 4.72c-.19.17-.43.28-.7.28zm4-11h-8.37l9 9H20c1.1 0 2-.9 2-2v-4c0-1.66-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2-5c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1H7c-.37 0-.68.21-.85.51L9.63 7H17z"
	}), 'PrintDisabledRounded');
	
	exports.default = _default;

/***/ },
/* 4878 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.65 7H18V3.01H6v.35zm1.01 1.01l9 8.99H22v-5.99c0-1.66-1.34-3-3-3h-8.34zM19 10c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM1.41 1.6L0 3.01l5 5c-1.66 0-3 1.33-3 2.99v6h4v4h12l2.95 2.96 1.41-1.41L1.41 1.6zM8 19.01V15h4l4 4-8 .01z"
	}), 'PrintDisabledSharp');
	
	exports.default = _default;

/***/ },
/* 4879 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 10H5c-.55 0-1 .45-1 1v4h2v-2h4l-3-3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M1.41 1.6L0 3.01 5 8c-1.66 0-3 1.34-3 3v6h4v4h12l2.95 2.96 1.41-1.41L1.41 1.6zM6 15H4v-4c0-.55.45-1 1-1h2l3 3H6v2zm2 4v-4h4l4 4H8z"
	}), _react.default.createElement("path", {
	  d: "M18 15.01l2-.01v-4c0-.55-.45-1-1-1h-6.34l3 3H18v2.01zm-1-3.5c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "11.51",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M16 5H8v.35L10.66 8H16z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 8h-1V3H6v.36l2 2V5h8v3h-5.34l2 2H19c.55 0 1 .45 1 1v4l-2 .01V13h-2.34l4 4H22v-6c0-1.66-1.34-3-3-3z"
	})), 'PrintDisabledTwoTone');
	
	exports.default = _default;

/***/ },
/* 4880 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 8h-1V3H6v5H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zM8 5h8v3H8V5zm8 12v2H8v-4h8v2zm2-2v-2H6v2H4v-4c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v4h-2z"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "11.5",
	  r: "1"
	})), 'PrintOutlined');
	
	exports.default = _default;

/***/ },
/* 4881 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 8H5c-1.66 0-3 1.34-3 3v4c0 1.1.9 2 2 2h2v2c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-2h2c1.1 0 2-.9 2-2v-4c0-1.66-1.34-3-3-3zm-4 11H9c-.55 0-1-.45-1-1v-4h8v4c0 .55-.45 1-1 1zm4-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2-9H7c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
	}), 'PrintRounded');
	
	exports.default = _default;

/***/ },
/* 4882 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 8H2v9h4v4h12v-4h4V8zm-6 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
	}), 'PrintSharp');
	
	exports.default = _default;

/***/ },
/* 4883 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 5h8v3H8z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "11.5",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M19 8h-1V3H6v5H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zM8 5h8v3H8V5zm8 14H8v-4h8v4zm4-4h-2v-2H6v2H4v-4c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v4z"
	}), _react.default.createElement("path", {
	  d: "M6 13h12v2h2v-4c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4h2v-2zm12-2.5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z",
	  opacity: ".3"
	})), 'PrintTwoTone');
	
	exports.default = _default;

/***/ },
/* 4884 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "19",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M10 3h4v12h-4z"
	})), 'PriorityHigh');
	
	exports.default = _default;

/***/ },
/* 4885 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "19",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M10 3h4v12h-4z"
	})), 'PriorityHighOutlined');
	
	exports.default = _default;

/***/ },
/* 4886 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "19",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M12 3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2s2-.9 2-2V5c0-1.1-.9-2-2-2z"
	})), 'PriorityHighRounded');
	
	exports.default = _default;

/***/ },
/* 4887 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "19",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M10 3h4v12h-4z"
	})), 'PriorityHighSharp');
	
	exports.default = _default;

/***/ },
/* 4888 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "12",
	  cy: "19",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M10 3h4v12h-4z"
	})), 'PriorityHighTwoTone');
	
	exports.default = _default;

/***/ },
/* 4889 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
	}), 'Public');
	
	exports.default = _default;

/***/ },
/* 4890 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-.61.08-1.21.21-1.78L8.99 15v1c0 1.1.9 2 2 2v1.93C7.06 19.43 4 16.07 4 12zm13.89 5.4c-.26-.81-1-1.4-1.9-1.4h-1v-3c0-.55-.45-1-1-1h-6v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41C17.92 5.77 20 8.65 20 12c0 2.08-.81 3.98-2.11 5.4z"
	}), 'PublicOutlined');
	
	exports.default = _default;

/***/ },
/* 4891 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
	}), 'PublicRounded');
	
	exports.default = _default;

/***/ },
/* 4892 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
	}), 'PublicSharp');
	
	exports.default = _default;

/***/ },
/* 4893 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14.99 4.59V5c0 1.1-.9 2-2 2h-2v2c0 .55-.45 1-1 1h-2v2h6c.55 0 1 .45 1 1v3h1c.89 0 1.64.59 1.9 1.4C19.19 15.98 20 14.08 20 12c0-3.35-2.08-6.23-5.01-7.41zM8.99 16v-1l-4.78-4.78C4.08 10.79 4 11.39 4 12c0 4.07 3.06 7.43 6.99 7.93V18c-1.1 0-2-.9-2-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1.01 17.93C7.06 19.43 4 16.07 4 12c0-.61.08-1.21.21-1.78L8.99 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.53c-.26-.81-1-1.4-1.9-1.4h-1v-3c0-.55-.45-1-1-1h-6v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41C17.92 5.77 20 8.65 20 12c0 2.08-.81 3.98-2.11 5.4z"
	})), 'PublicTwoTone');
	
	exports.default = _default;

/***/ },
/* 4894 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z"
	}), 'Publish');
	
	exports.default = _default;

/***/ },
/* 4895 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 4h14v2H5zm0 10h4v6h6v-6h4l-7-7-7 7zm8-2v6h-2v-6H9.83L12 9.83 14.17 12H13z"
	}), 'PublishOutlined');
	
	exports.default = _default;

/***/ },
/* 4896 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 5c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1zm2.41 9H9v5c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-5h1.59c.89 0 1.34-1.08.71-1.71L12.71 7.7a.9959.9959 0 00-1.41 0l-4.59 4.59c-.63.63-.19 1.71.7 1.71z"
	}), 'PublishRounded');
	
	exports.default = _default;

/***/ },
/* 4897 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z"
	}), 'PublishSharp');
	
	exports.default = _default;

/***/ },
/* 4898 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9.83 12H11v6h2v-6h1.17L12 9.83z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 4h14v2H5zm7 3l-7 7h4v6h6v-6h4l-7-7zm1 5v6h-2v-6H9.83L12 9.83 14.17 12H13z"
	})), 'PublishTwoTone');
	
	exports.default = _default;

/***/ },
/* 4899 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), _react.default.createElement("path", {
	  d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
	})), 'QueryBuilder');
	
	exports.default = _default;

/***/ },
/* 4900 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
	}), 'QueryBuilderOutlined');
	
	exports.default = _default;

/***/ },
/* 4901 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-.22-13h-.06c-.4 0-.72.32-.72.72v4.72c0 .35.18.68.49.86l4.15 2.49c.34.2.78.1.98-.24.21-.34.1-.79-.25-.99l-3.87-2.3V7.72c0-.4-.32-.72-.72-.72z"
	}), 'QueryBuilderRounded');
	
	exports.default = _default;

/***/ },
/* 4902 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
	}), 'QueryBuilderSharp');
	
	exports.default = _default;

/***/ },
/* 4903 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm4.25 12.15L11 13V7h1.5v5.25l4.5 2.67-.75 1.23z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
	})), 'QueryBuilderTwoTone');
	
	exports.default = _default;

/***/ },
/* 4904 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"
	}), 'QuestionAnswer');
	
	exports.default = _default;

/***/ },
/* 4905 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 4v7H5.17l-.59.59-.58.58V4h11m1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1z"
	}), 'QuestionAnswerOutlined');
	
	exports.default = _default;

/***/ },
/* 4906 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-1v8c0 .55-.45 1-1 1H6v1c0 1.1.9 2 2 2h10l4 4V8c0-1.1-.9-2-2-2zm-3 5V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v13l4-4h9c1.1 0 2-.9 2-2z"
	}), 'QuestionAnswerRounded');
	
	exports.default = _default;

/***/ },
/* 4907 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6h-3v9H6v3h12l4 4V6zm-5 7V2H2v15l4-4h11z"
	}), 'QuestionAnswerSharp');
	
	exports.default = _default;

/***/ },
/* 4908 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15 11V4H4v8.17l.59-.58.58-.59H6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-5 7c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10zM4.59 11.59l-.59.58V4h11v7H5.17l-.58.59z"
	})), 'QuestionAnswerTwoTone');
	
	exports.default = _default;

/***/ },
/* 4909 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
	}), 'Queue');
	
	exports.default = _default;

/***/ },
/* 4910 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 6H3v2h12V6zm0 4H3v2h12v-2zM3 16h8v-2H3v2zM17 6v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5z"
	}), 'QueueMusic');
	
	exports.default = _default;

/***/ },
/* 4911 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6h-5v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6zm-7 0H3v2h12V6zm0 4H3v2h12v-2zm-4 4H3v2h8v-2zm4 3c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1z"
	}), 'QueueMusicOutlined');
	
	exports.default = _default;

/***/ },
/* 4912 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6H4c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zm0 4H4c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zM4 16h6c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM19 6c-1.1 0-2 .9-2 2v6.18c-.31-.11-.65-.18-1-.18-1.84 0-3.28 1.64-2.95 3.54.21 1.21 1.2 2.2 2.41 2.41 1.9.33 3.54-1.11 3.54-2.95V8h2c.55 0 1-.45 1-1s-.45-1-1-1h-2z"
	}), 'QueueMusicRounded');
	
	exports.default = _default;

/***/ },
/* 4913 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 6H3v2h12V6zm0 4H3v2h12v-2zM3 16h8v-2H3v2zM17 6v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5z"
	}), 'QueueMusicSharp');
	
	exports.default = _default;

/***/ },
/* 4914 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "16",
	  cy: "17",
	  r: "1",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 10h12v2H3zM3 14h8v2H3zM3 6h12v2H3z"
	}), _react.default.createElement("path", {
	  d: "M17 14.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5v8.18zM16 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	})), 'QueueMusicTwoTone');
	
	exports.default = _default;

/***/ },
/* 4915 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-7-1h2v-4h4V9h-4V5h-2v4H9v2h4z"
	}), 'QueueOutlined');
	
	exports.default = _default;

/***/ },
/* 4916 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h2v-2H3V5h18v8h2V5c0-1.11-.9-2-2-2zm-8 7V7h-2v3H8v2h3v3h2v-3h3v-2h-3zm11 8l-4.5 4.5L18 21l3-3-3-3 1.5-1.5L24 18z"
	}), 'QueuePlayNext');
	
	exports.default = _default;

/***/ },
/* 4917 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h2v-2H3V5h18v8h2V5c0-1.11-.9-2-2-2zm-8 7V7h-2v3H8v2h3v3h2v-3h3v-2h-3zm11 8l-4.5 4.5L18 21l3-3-3-3 1.5-1.5L24 18z"
	}), 'QueuePlayNextOutlined');
	
	exports.default = _default;

/***/ },
/* 4918 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v1c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-1h1c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v6c0 .55.45 1 1 1s1-.45 1-1V5c0-1.1-.9-2-2-2zm-8 7V8c0-.55-.45-1-1-1s-1 .45-1 1v2H9c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1h-2zm10.29 8.71l-3.04 3.04c-.41.41-1.09.41-1.5 0-.41-.41-.41-1.09 0-1.5L21 18l-2.25-2.25c-.41-.41-.41-1.09 0-1.5.41-.41 1.09-.41 1.5 0l3.04 3.04c.39.39.39 1.03 0 1.42z"
	}), 'QueuePlayNextRounded');
	
	exports.default = _default;

/***/ },
/* 4919 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 3H1v16h7v2h8v-2h2v-2H3V5h18v8h2V3zm-10 7V7h-2v3H8v2h3v3h2v-3h3v-2h-3zm11 8l-4.5 4.5L18 21l3-3-3-3 1.5-1.5L24 18z"
	}), 'QueuePlayNextSharp');
	
	exports.default = _default;

/***/ },
/* 4920 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 15v-3h3v-2h-3V7h-2v3H8v2h3v3zm5 0l3 3-3 3 1.5 1.5L24 18l-4.5-4.5zM8 19v2h8v-2h2v-2H3V5h18v8h2V5c0-1.11-.9-2-2-2H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5z"
	}), 'QueuePlayNextTwoTone');
	
	exports.default = _default;

/***/ },
/* 4921 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 6c-.55 0-1 .45-1 1v13c0 1.1.9 2 2 2h13c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1zm17-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 9h-3v3c0 .55-.45 1-1 1s-1-.45-1-1v-3h-3c-.55 0-1-.45-1-1s.45-1 1-1h3V6c0-.55.45-1 1-1s1 .45 1 1v3h3c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'QueueRounded');
	
	exports.default = _default;

/***/ },
/* 4922 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6H2v16h16v-2H4V6zm18-4H6v16h16V2zm-3 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
	}), 'QueueSharp');
	
	exports.default = _default;

/***/ },
/* 4923 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 16h12V4H8v12zm1-7h4V5h2v4h4v2h-4v4h-2v-4H9V9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M2 20c0 1.1.9 2 2 2h14v-2H4V6H2v14zM20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-7-1h2v-4h4V9h-4V5h-2v4H9v2h4z"
	})), 'QueueTwoTone');
	
	exports.default = _default;

/***/ },
/* 4924 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.24 6.15C2.51 6.43 2 7.17 2 8v12c0 1.1.89 2 2 2h16c1.11 0 2-.9 2-2V8c0-1.11-.89-2-2-2H8.3l8.26-3.34L15.88 1 3.24 6.15zM7 20c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-8h-2v-2h-2v2H4V8h16v4z"
	}), 'Radio');
	
	exports.default = _default;

/***/ },
/* 4925 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'RadioButtonChecked');
	
	exports.default = _default;

/***/ },
/* 4926 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "5"
	})), 'RadioButtonCheckedOutlined');
	
	exports.default = _default;

/***/ },
/* 4927 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "5"
	})), 'RadioButtonCheckedRounded');
	
	exports.default = _default;

/***/ },
/* 4928 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "5"
	})), 'RadioButtonCheckedSharp');
	
	exports.default = _default;

/***/ },
/* 4929 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "5"
	})), 'RadioButtonCheckedTwoTone');
	
	exports.default = _default;

/***/ },
/* 4930 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'RadioButtonUnchecked');
	
	exports.default = _default;

/***/ },
/* 4931 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'RadioButtonUncheckedOutlined');
	
	exports.default = _default;

/***/ },
/* 4932 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'RadioButtonUncheckedRounded');
	
	exports.default = _default;

/***/ },
/* 4933 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'RadioButtonUncheckedSharp');
	
	exports.default = _default;

/***/ },
/* 4934 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'RadioButtonUncheckedTwoTone');
	
	exports.default = _default;

/***/ },
/* 4935 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 6H8.3l8.26-3.34L15.88 1 3.24 6.15C2.51 6.43 2 7.17 2 8v12c0 1.1.89 2 2 2h16c1.11 0 2-.9 2-2V8c0-1.11-.89-2-2-2zm0 2v3h-2V9h-2v2H4V8h16zM4 20v-7h16v7H4z"
	}), _react.default.createElement("circle", {
	  cx: "8",
	  cy: "16.48",
	  r: "2.5"
	})), 'RadioOutlined');
	
	exports.default = _default;

/***/ },
/* 4936 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.24 6.15C2.51 6.43 2 7.17 2 8v12c0 1.1.9 2 2 2h16c1.11 0 2-.9 2-2V8c0-1.1-.9-2-2-2H8.3l7.43-3c.46-.19.68-.71.49-1.17-.19-.46-.71-.68-1.17-.49L3.24 6.15zM7 20c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-8h-2v-1c0-.55-.45-1-1-1s-1 .45-1 1v1H4V9c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v3z"
	}), 'RadioRounded');
	
	exports.default = _default;

/***/ },
/* 4937 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 6.67V22h20V6H8.3l8.26-3.34L15.88 1 2 6.67zM7 20c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-8h-2v-2h-2v2H4V8h16v4z"
	}), 'RadioSharp');
	
	exports.default = _default;

/***/ },
/* 4938 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 13H4v7h16v-7zM8 18.98c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M2 20c0 1.1.89 2 2 2h16c1.11 0 2-.9 2-2V8c0-1.11-.89-2-2-2H8.3l8.26-3.34L15.88 1 3.24 6.15C2.51 6.43 2 7.17 2 8v12zM4 8h16v3h-2V9h-2v2H4V8zm0 5h16v7H4v-7z"
	}), _react.default.createElement("circle", {
	  cx: "8",
	  cy: "16.48",
	  r: "2.5"
	})), 'RadioTwoTone');
	
	exports.default = _default;

/***/ },
/* 4939 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm12 0h-7.5l2-2H18v2z"
	}), 'RateReview');
	
	exports.default = _default;

/***/ },
/* 4940 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zm-9.5-2H18v-2h-5.5zm3.86-5.87c.2-.2.2-.51 0-.71l-1.77-1.77c-.2-.2-.51-.2-.71 0L6 11.53V14h2.47l5.89-5.87z"
	}), 'RateReviewOutlined');
	
	exports.default = _default;

/***/ },
/* 4941 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm11 0h-6.5l2-2H17c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'RateReviewRounded');
	
	exports.default = _default;

/***/ },
/* 4942 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H2v20l4-4h16V2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm12 0h-7.5l2-2H18v2z"
	}), 'RateReviewSharp');
	
	exports.default = _default;

/***/ },
/* 4943 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 17.17l.59-.59.58-.58H20V4H4v13.17zM18 14h-7.5l2-2H18v2zM6 11.53l5.88-5.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6v-2.47z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zm-9.5-2H18v-2h-5.5zm3.86-5.87c.2-.2.2-.51 0-.71l-1.77-1.77c-.2-.2-.51-.2-.71 0L6 11.53V14h2.47l5.89-5.87z"
	})), 'RateReviewTwoTone');
	
	exports.default = _default;

/***/ },
/* 4944 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z"
	}), 'Receipt');
	
	exports.default = _default;

/***/ },
/* 4945 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5zM19 19.09H5V4.91h14v14.18zM6 15h12v2H6zm0-4h12v2H6zm0-4h12v2H6z"
	}), 'ReceiptOutlined');
	
	exports.default = _default;

/***/ },
/* 4946 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 2.21c-.13 0-.26.05-.35.15l-.79.79c-.2.2-.51.2-.71 0l-.79-.79c-.2-.2-.51-.2-.71 0l-.79.79c-.2.2-.51.2-.71 0l-.79-.79c-.2-.2-.51-.2-.71 0l-.79.79c-.2.2-.51.2-.71 0l-.79-.79c-.2-.2-.51-.2-.71 0l-.79.79c-.2.2-.51.2-.71 0l-.8-.8c-.2-.2-.51-.2-.71 0l-.79.8c-.2.2-.51.2-.71 0l-.79-.8c-.2-.2-.51-.2-.71 0l-.79.8c-.2.2-.51.2-.71 0l-.79-.8c-.09-.09-.22-.14-.35-.14V21.8c.13 0 .26-.05.35-.15l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.1.1.23.15.35.15V2.21zM17 17H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1zm0-4H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1zm0-4H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'ReceiptRounded');
	
	exports.default = _default;

/***/ },
/* 4947 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z"
	}), 'ReceiptSharp');
	
	exports.default = _default;

/***/ },
/* 4948 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19.09h14V4.91H5v14.18zM6 7h12v2H6V7zm0 4h12v2H6v-2zm0 4h12v2H6v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5zM19 19.09H5V4.91h14v14.18zM6 15h12v2H6zm0-4h12v2H6zm0-4h12v2H6z"
	})), 'ReceiptTwoTone');
	
	exports.default = _default;

/***/ },
/* 4949 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 5v14h2V5h-2zm-4 14h2V5h-2v14zM14 5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75zM12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17z"
	}), 'RecentActors');
	
	exports.default = _default;

/***/ },
/* 4950 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21 5h2v14h-2zm-4 0h2v14h-2zm-3 0H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-1 12H3V7h10v10z"
	}), _react.default.createElement("circle", {
	  cx: "8",
	  cy: "9.94",
	  r: "1.95"
	}), _react.default.createElement("path", {
	  d: "M11.89 15.35c0-1.3-2.59-1.95-3.89-1.95s-3.89.65-3.89 1.95V16h7.78v-.65z"
	})), 'RecentActorsOutlined');
	
	exports.default = _default;

/***/ },
/* 4951 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 6v12c0 .55.45 1 1 1s1-.45 1-1V6c0-.55-.45-1-1-1s-1 .45-1 1zm-3 13c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1s-1 .45-1 1v12c0 .55.45 1 1 1zM14 5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75zM12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17z"
	}), 'RecentActorsRounded');
	
	exports.default = _default;

/***/ },
/* 4952 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 5v14h2V5h-2zm-4 14h2V5h-2v14zM15 5H1v14h14V5zM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75zM12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17z"
	}), 'RecentActorsSharp');
	
	exports.default = _default;

/***/ },
/* 4953 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M13 7H3v10h10V7zM8 8c1.07 0 1.95.87 1.95 1.95 0 1.07-.87 1.95-1.95 1.95s-1.95-.87-1.95-1.95S6.93 8 8 8zm3.89 8H4.11v-.65c0-1.3 2.59-1.95 3.89-1.95s3.89.65 3.89 1.95V16z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 5h2v14h-2zm-4 0h2v14h-2zm-3 14c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12zM3 7h10v10H3V7z"
	}), _react.default.createElement("circle", {
	  cx: "8",
	  cy: "9.94",
	  r: "1.95"
	}), _react.default.createElement("path", {
	  d: "M8 13.4c-1.3 0-3.89.65-3.89 1.95V16h7.78v-.65c0-1.3-2.59-1.95-3.89-1.95z"
	})), 'RecentActorsTwoTone');
	
	exports.default = _default;

/***/ },
/* 4954 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "9",
	  cy: "9",
	  r: "4"
	}), _react.default.createElement("path", {
	  d: "M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z"
	})), 'RecordVoiceOver');
	
	exports.default = _default;

/***/ },
/* 4955 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 13c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H3zM15.08 7.05c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27l-1.68 1.69zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z"
	}), 'RecordVoiceOverOutlined');
	
	exports.default = _default;

/***/ },
/* 4956 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "9",
	  cy: "9",
	  r: "4"
	}), _react.default.createElement("path", {
	  d: "M9 15c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4zm6.47-7.23c.32.79.32 1.67 0 2.46-.19.47-.11 1 .25 1.36l.03.03c.58.58 1.57.46 1.95-.27.76-1.45.76-3.15-.02-4.66-.38-.74-1.38-.88-1.97-.29l-.01.01c-.34.35-.42.89-.23 1.36zm3.71-4.88c-.4.4-.46 1.02-.13 1.48 1.97 2.74 1.96 6.41-.03 9.25-.32.45-.25 1.07.14 1.46l.03.03c.49.49 1.32.45 1.74-.1 2.75-3.54 2.76-8.37 0-12.02-.42-.55-1.26-.59-1.75-.1z"
	})), 'RecordVoiceOverRounded');
	
	exports.default = _default;

/***/ },
/* 4957 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "9",
	  cy: "9",
	  r: "4"
	}), _react.default.createElement("path", {
	  d: "M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm6.08-7.95c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27l-1.68 1.69zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z"
	})), 'RecordVoiceOverSharp');
	
	exports.default = _default;

/***/ },
/* 4958 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("g", {
	  opacity: ".3"
	}, _react.default.createElement("circle", {
	  cx: "9",
	  cy: "9",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M9 17c-2.69 0-5.77 1.28-6 2h12c-.2-.71-3.3-2-6-2z"
	})), _react.default.createElement("path", {
	  d: "M9 13c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H3zM16.76 5.36l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z"
	})), 'RecordVoiceOverTwoTone');
	
	exports.default = _default;

/***/ },
/* 4959 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 12.14a2.19 2.19 0 0 0-3.71-1.57 10.93 10.93 0 0 0-5.86-1.87l1-4.7 3.27.71a1.56 1.56 0 1 0 .16-.76l-3.64-.77c-.11-.02-.22 0-.29.06-.09.05-.14.14-.16.26l-1.11 5.22c-2.33.07-4.43.78-5.95 1.86A2.2 2.2 0 0 0 4.19 10a2.16 2.16 0 0 0-.9 4.15 3.6 3.6 0 0 0-.05.66c0 3.37 3.92 6.12 8.76 6.12s8.76-2.73 8.76-6.12c0-.21-.01-.44-.05-.66A2.21 2.21 0 0 0 22 12.14M7 13.7c0-.86.68-1.56 1.54-1.56s1.56.7 1.56 1.56a1.56 1.56 0 0 1-1.56 1.56c-.86.02-1.54-.7-1.54-1.56m8.71 4.14C14.63 18.92 12.59 19 12 19c-.61 0-2.65-.1-3.71-1.16a.4.4 0 0 1 0-.57.4.4 0 0 1 .57 0c.68.68 2.14.91 3.14.91s2.47-.23 3.14-.91a.4.4 0 0 1 .57 0c.14.16.14.41 0 .57m-.29-2.56c-.86 0-1.56-.7-1.56-1.56a1.56 1.56 0 0 1 1.56-1.56c.86 0 1.58.7 1.58 1.56a1.6 1.6 0 0 1-1.58 1.56z"
	}), 'Reddit');
	
	exports.default = _default;

/***/ },
/* 4960 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
	}), 'Redeem');
	
	exports.default = _default;

/***/ },
/* 4961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
	}), 'RedeemOutlined');
	
	exports.default = _default;

/***/ },
/* 4962 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm10 15H5c-.55 0-1-.45-1-1v-1h16v1c0 .55-.45 1-1 1zm1-5H4V9c0-.55.45-1 1-1h4.08L7.6 10.02c-.33.45-.23 1.08.22 1.4.44.32 1.07.22 1.39-.22L12 7.4l2.79 3.8c.32.44.95.54 1.39.22.45-.32.55-.95.22-1.4L14.92 8H19c.55 0 1 .45 1 1v5z"
	}), 'RedeemRounded');
	
	exports.default = _default;

/***/ },
/* 4963 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6h-4.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H2v15h20V6zm-7-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 12 7.4l3.38 4.6L17 10.83 14.92 8H20v6z"
	}), 'RedeemSharp');
	
	exports.default = _default;

/***/ },
/* 4964 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 17h16v2H4zm13-6.17L15.38 12 13 8.76 12 7.4l-1 1.36L8.62 12 7 10.83 9.08 8H4v6h16V8h-5.08z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
	})), 'RedeemTwoTone');
	
	exports.default = _default;

/***/ },
/* 4965 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"
	}), 'Redo');
	
	exports.default = _default;

/***/ },
/* 4966 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"
	}), 'RedoOutlined');
	
	exports.default = _default;

/***/ },
/* 4967 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.16 0-7.74 2.42-9.44 5.93-.32.67.04 1.47.75 1.71.59.2 1.23-.08 1.5-.64 1.3-2.66 4.03-4.5 7.19-4.5 1.95 0 3.73.72 5.12 1.88l-1.91 1.91c-.63.63-.19 1.71.7 1.71H21c.55 0 1-.45 1-1V9.41c0-.89-1.08-1.34-1.71-.71l-1.89 1.9z"
	}), 'RedoRounded');
	
	exports.default = _default;

/***/ },
/* 4968 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"
	}), 'RedoSharp');
	
	exports.default = _default;

/***/ },
/* 4969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"
	}), 'RedoTwoTone');
	
	exports.default = _default;

/***/ },
/* 4970 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
	}), 'Refresh');
	
	exports.default = _default;

/***/ },
/* 4971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
	}), 'RefreshOutlined');
	
	exports.default = _default;

/***/ },
/* 4972 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.65 6.35c-1.63-1.63-3.94-2.57-6.48-2.31-3.67.37-6.69 3.35-7.1 7.02C3.52 15.91 7.27 20 12 20c3.19 0 5.93-1.87 7.21-4.56.32-.67-.16-1.44-.9-1.44-.37 0-.72.2-.88.53-1.13 2.43-3.84 3.97-6.8 3.31-2.22-.49-4.01-2.3-4.48-4.52C5.31 9.44 8.26 6 12 6c1.66 0 3.14.69 4.22 1.78l-1.51 1.51c-.63.63-.19 1.71.7 1.71H19c.55 0 1-.45 1-1V6.41c0-.89-1.08-1.34-1.71-.71l-.64.65z"
	}), 'RefreshRounded');
	
	exports.default = _default;

/***/ },
/* 4973 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
	}), 'RefreshSharp');
	
	exports.default = _default;

/***/ },
/* 4974 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
	}), 'RefreshTwoTone');
	
	exports.default = _default;

/***/ },
/* 4975 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 13H5v-2h14v2z"
	}), 'Remove');
	
	exports.default = _default;

/***/ },
/* 4976 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
	}), 'RemoveCircle');
	
	exports.default = _default;

/***/ },
/* 4977 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'RemoveCircleOutline');
	
	exports.default = _default;

/***/ },
/* 4978 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'RemoveCircleOutlineOutlined');
	
	exports.default = _default;

/***/ },
/* 4979 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 12c0 .55.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1zm5-10C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'RemoveCircleOutlineRounded');
	
	exports.default = _default;

/***/ },
/* 4980 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'RemoveCircleOutlineSharp');
	
	exports.default = _default;

/***/ },
/* 4981 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 11h10v2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	}), 'RemoveCircleOutlineTwoTone');
	
	exports.default = _default;

/***/ },
/* 4982 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
	}), 'RemoveCircleOutlined');
	
	exports.default = _default;

/***/ },
/* 4983 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4 11H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'RemoveCircleRounded');
	
	exports.default = _default;

/***/ },
/* 4984 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
	}), 'RemoveCircleSharp');
	
	exports.default = _default;

/***/ },
/* 4985 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm5 9H7v-2h10v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M7 11h10v2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
	})), 'RemoveCircleTwoTone');
	
	exports.default = _default;

/***/ },
/* 4986 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-7v2H8v-2h8z"
	}), 'RemoveFromQueue');
	
	exports.default = _default;

/***/ },
/* 4987 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-7v2H8v-2h8z"
	}), 'RemoveFromQueueOutlined');
	
	exports.default = _default;

/***/ },
/* 4988 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v1c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-1h5c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm-1 14H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1zm-4-6c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1z"
	}), 'RemoveFromQueueRounded');
	
	exports.default = _default;

/***/ },
/* 4989 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 3H1v16h7v2h8v-2h7V3zm-2 14H3V5h18v12zm-5-7v2H8v-2h8z"
	}), 'RemoveFromQueueSharp');
	
	exports.default = _default;

/***/ },
/* 4990 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 17h18V5H3v12zm5-7h8v2H8v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zM8 10h8v2H8z"
	})), 'RemoveFromQueueTwoTone');
	
	exports.default = _default;

/***/ },
/* 4991 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 13H5v-2h14v2z"
	}), 'RemoveOutlined');
	
	exports.default = _default;

/***/ },
/* 4992 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
	}), 'RemoveRedEye');
	
	exports.default = _default;

/***/ },
/* 4993 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6.5c3.79 0 7.17 2.13 8.82 5.5-1.65 3.37-5.02 5.5-8.82 5.5S4.83 15.37 3.18 12C4.83 8.63 8.21 6.5 12 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5-2.5-1.12-2.5-2.5 1.12-2.5 2.5-2.5m0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5 4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5z"
	}), 'RemoveRedEyeOutlined');
	
	exports.default = _default;

/***/ },
/* 4994 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
	}), 'RemoveRedEyeRounded');
	
	exports.default = _default;

/***/ },
/* 4995 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
	}), 'RemoveRedEyeSharp');
	
	exports.default = _default;

/***/ },
/* 4996 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 6.5c-3.79 0-7.17 2.13-8.82 5.5 1.65 3.37 5.02 5.5 8.82 5.5s7.17-2.13 8.82-5.5C19.17 8.63 15.79 6.5 12 6.5zm0 10c-2.48 0-4.5-2.02-4.5-4.5S9.52 7.5 12 7.5s4.5 2.02 4.5 4.5-2.02 4.5-4.5 4.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 13c-3.79 0-7.17-2.13-8.82-5.5C4.83 8.63 8.21 6.5 12 6.5s7.17 2.13 8.82 5.5c-1.65 3.37-5.03 5.5-8.82 5.5zm0-10c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5 4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5zm0 7c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
	})), 'RemoveRedEyeTwoTone');
	
	exports.default = _default;

/***/ },
/* 4997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 13H6c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'RemoveRounded');
	
	exports.default = _default;

/***/ },
/* 4998 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 13H5v-2h14v2z"
	}), 'RemoveSharp');
	
	exports.default = _default;

/***/ },
/* 4999 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22.73 22.73L2.77 2.77 2 2l-.73-.73L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84L21.46 24l1.27-1.27zM7.42 15c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h2.36l2 2H7.42zm8.13-2c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H6.54l9.01 9zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"
	}), 'RemoveShoppingCart');
	
	exports.default = _default;

/***/ },
/* 5000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1.41 1.13L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84L21.46 24l1.41-1.41L1.41 1.13zM7 15l1.1-2h2.36l2 2H7zM20 4H7.12l2 2h9.19l-2.76 5h-1.44l1.94 1.94c.54-.14.99-.49 1.25-.97l3.58-6.49C21.25 4.82 20.76 4 20 4zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"
	}), 'RemoveShoppingCartOutlined');
	
	exports.default = _default;

/***/ },
/* 5001 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M.71 1.83c-.39.39-.39 1.02 0 1.41l3.68 3.68 2.21 4.66-1.35 2.45c-.19.33-.28.73-.24 1.15.1 1.06 1.06 1.82 2.12 1.82h7.33l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84l2.13 2.13c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L2.12 1.83a.9959.9959 0 00-1.41 0zM7 15l1.1-2h2.36l2 2H7zm9.05-2.06c.54-.14.99-.49 1.25-.97l3.58-6.49C21.25 4.82 20.76 4 20 4H7.12l8.93 8.94zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"
	}), 'RemoveShoppingCartRounded');
	
	exports.default = _default;

/***/ },
/* 5002 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1.41 1.13L0 2.54l4.39 4.39 2.21 4.66L3.62 17h10.84l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84L21.46 24l1.41-1.41L1.41 1.13zM7 15l1.1-2h2.36l2 2H7zm9.05-2.06h.73L21.7 4H7.12l8.93 8.94zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"
	}), 'RemoveShoppingCartSharp');
	
	exports.default = _default;

/***/ },
/* 5003 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M1.41 1.13L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84L21.46 24l1.41-1.41L1.41 1.13zM7 15l1.1-2h2.36l2 2H7z"
	}), _react.default.createElement("path", {
	  d: "M18.31 6H9.12l4.99 5h1.44z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 4H7.12l2 2h9.19l-2.76 5h-1.44l1.94 1.94c.54-.14.99-.49 1.25-.97l3.58-6.49C21.25 4.82 20.76 4 20 4zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"
	})), 'RemoveShoppingCartTwoTone');
	
	exports.default = _default;

/***/ },
/* 5004 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 13H5v-2h14v2z"
	}), 'RemoveTwoTone');
	
	exports.default = _default;

/***/ },
/* 5005 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"
	}), 'Reorder');
	
	exports.default = _default;

/***/ },
/* 5006 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"
	}), 'ReorderOutlined');
	
	exports.default = _default;

/***/ },
/* 5007 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 15h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0 4h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-8h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z"
	}), 'ReorderRounded');
	
	exports.default = _default;

/***/ },
/* 5008 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"
	}), 'ReorderSharp');
	
	exports.default = _default;

/***/ },
/* 5009 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"
	}), 'ReorderTwoTone');
	
	exports.default = _default;

/***/ },
/* 5010 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"
	}), 'Repeat');
	
	exports.default = _default;

/***/ },
/* 5011 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z"
	}), 'RepeatOne');
	
	exports.default = _default;

/***/ },
/* 5012 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z"
	}), 'RepeatOneOutlined');
	
	exports.default = _default;

/***/ },
/* 5013 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 7h10v1.79c0 .45.54.67.85.35l2.79-2.79c.2-.2.2-.51 0-.71l-2.79-2.79c-.31-.31-.85-.09-.85.36V5H6c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1V7zm10 10H7v-1.79c0-.45-.54-.67-.85-.35l-2.79 2.79c-.2.2-.2.51 0 .71l2.79 2.79c.31.31.85.09.85-.36V19h11c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1s-1 .45-1 1v3zm-4-2.75V9.81c0-.45-.36-.81-.81-.81-.13 0-.25.03-.36.09l-1.49.74c-.21.1-.34.32-.34.55 0 .34.28.62.62.62h.88v3.25c0 .41.34.75.75.75s.75-.34.75-.75z"
	}), 'RepeatOneRounded');
	
	exports.default = _default;

/***/ },
/* 5014 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z"
	}), 'RepeatOneSharp');
	
	exports.default = _default;

/***/ },
/* 5015 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 15V9h-1l-2 1v1h1.5v4zm6-2h-2v4H7v-3l-4 4 4 4v-3h12zM17 2v3H5v6h2V7h10v3l4-4z"
	}), 'RepeatOneTwoTone');
	
	exports.default = _default;

/***/ },
/* 5016 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"
	}), 'RepeatOutlined');
	
	exports.default = _default;

/***/ },
/* 5017 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 7h10v1.79c0 .45.54.67.85.35l2.79-2.79c.2-.2.2-.51 0-.71l-2.79-2.79c-.31-.31-.85-.09-.85.36V5H6c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1V7zm10 10H7v-1.79c0-.45-.54-.67-.85-.35l-2.79 2.79c-.2.2-.2.51 0 .71l2.79 2.79c.31.31.85.09.85-.36V19h11c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1s-1 .45-1 1v3z"
	}), 'RepeatRounded');
	
	exports.default = _default;

/***/ },
/* 5018 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"
	}), 'RepeatSharp');
	
	exports.default = _default;

/***/ },
/* 5019 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 22v-3h12v-6h-2v4H7v-3l-4 4zM21 6l-4-4v3H5v6h2V7h10v3z"
	}), 'RepeatTwoTone');
	
	exports.default = _default;

/***/ },
/* 5020 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
	}), 'Replay');
	
	exports.default = _default;

/***/ },
/* 5021 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.99 5V1l-5 5 5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6h-2c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
	}), _react.default.createElement("path", {
	  d: "M10.89 16h-.85v-3.26l-1.01.31v-.69l1.77-.63h.09V16zM15.17 14.24c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32.04-.29.04-.48v-.97z"
	})), 'Replay10');
	
	exports.default = _default;

/***/ },
/* 5022 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 5V1l-5 5 5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6h-2c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8zm-1.1 11h-.85v-3.26l-1.01.31v-.69l1.77-.63h.09V16zm4.28-1.76c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32.04-.29.04-.48v-.97z"
	}), 'Replay10Outlined');
	
	exports.default = _default;

/***/ },
/* 5023 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 5V2.21c0-.45-.54-.67-.85-.35L7.35 5.65c-.2.2-.2.51 0 .71l3.79 3.79c.31.31.85.09.85-.35V7c3.73 0 6.68 3.42 5.86 7.29-.47 2.27-2.31 4.1-4.57 4.57-3.57.75-6.75-1.7-7.23-5.01-.06-.48-.48-.85-.98-.85-.6 0-1.08.53-1 1.13.62 4.39 4.8 7.64 9.53 6.72 3.12-.61 5.63-3.12 6.24-6.24.99-5.13-2.9-9.61-7.85-9.61zm-1.1 11h-.85v-3.26l-1.01.31v-.69l1.77-.63h.09V16zm4.28-1.76c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32.04-.29.04-.48v-.97z"
	}), 'Replay10Rounded');
	
	exports.default = _default;

/***/ },
/* 5024 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 5V1l-5 5 5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6h-2c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8zm-1.1 11h-.85v-3.26l-1.01.31v-.69l1.77-.63h.09V16zm4.28-1.76c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32.04-.29.04-.48v-.97z"
	}), 'Replay10Sharp');
	
	exports.default = _default;

/***/ },
/* 5025 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 5V1l-5 5 5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6h-2c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8zm-1.1 11h-.85v-3.26l-1.01.31v-.69l1.77-.63h.09V16zm4.28-1.76c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32.04-.29.04-.48v-.97z"
	}), 'Replay10TwoTone');
	
	exports.default = _default;

/***/ },
/* 5026 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
	}), _react.default.createElement("path", {
	  d: "M9.56 13.49h.45c.21 0 .37-.05.48-.16s.16-.25.16-.43c0-.08-.01-.15-.04-.22s-.06-.12-.11-.17-.11-.09-.18-.11-.16-.04-.25-.04c-.08 0-.15.01-.22.03s-.13.05-.18.1-.09.09-.12.15-.05.13-.05.2h-.85c0-.18.04-.34.11-.48s.17-.27.3-.37.27-.18.44-.23.35-.08.54-.08c.21 0 .41.03.59.08s.33.13.46.23.23.23.3.38.11.33.11.53c0 .09-.01.18-.04.27s-.07.17-.13.25-.12.15-.2.22-.17.12-.28.17c.24.09.42.21.54.39s.18.38.18.61c0 .2-.04.38-.12.53s-.18.29-.32.39-.29.19-.48.24-.38.08-.6.08c-.18 0-.36-.02-.53-.07s-.33-.12-.46-.23-.25-.23-.33-.38-.12-.34-.12-.55h.85c0 .08.02.15.05.22s.07.12.13.17.12.09.2.11.16.04.25.04c.1 0 .19-.01.27-.04s.15-.07.2-.12.1-.11.13-.18.04-.15.04-.24c0-.11-.02-.21-.05-.29s-.08-.15-.14-.2-.13-.09-.22-.11-.18-.04-.29-.04h-.47v-.65zM15.3 14.24c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32c.03-.13.04-.29.04-.48v-.97z"
	})), 'Replay30');
	
	exports.default = _default;

/***/ },
/* 5027 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8zm-2.44 8.49h.45c.21 0 .37-.05.48-.16s.16-.25.16-.43c0-.08-.01-.15-.04-.22s-.06-.12-.11-.17-.11-.09-.18-.11-.16-.04-.25-.04c-.08 0-.15.01-.22.03s-.13.05-.18.1-.09.09-.12.15-.05.13-.05.2h-.85c0-.18.04-.34.11-.48s.17-.27.3-.37.27-.18.44-.23.35-.08.54-.08c.21 0 .41.03.59.08s.33.13.46.23.23.23.3.38.11.33.11.53c0 .09-.01.18-.04.27s-.07.17-.13.25-.12.15-.2.22-.17.12-.28.17c.24.09.42.21.54.39s.18.38.18.61c0 .2-.04.38-.12.53s-.18.29-.32.39-.29.19-.48.24-.38.08-.6.08c-.18 0-.36-.02-.53-.07s-.33-.12-.46-.23-.25-.23-.33-.38-.12-.34-.12-.55h.85c0 .08.02.15.05.22s.07.12.13.17.12.09.2.11.16.04.25.04c.1 0 .19-.01.27-.04s.15-.07.2-.12.1-.11.13-.18.04-.15.04-.24c0-.11-.02-.21-.05-.29s-.08-.15-.14-.2-.13-.09-.22-.11-.18-.04-.29-.04h-.47v-.65zm5.74.75c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32c.03-.13.04-.29.04-.48v-.97z"
	}), 'Replay30Outlined');
	
	exports.default = _default;

/***/ },
/* 5028 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5V2.21c0-.45-.54-.67-.85-.35l-3.8 3.79c-.2.2-.2.51 0 .71l3.79 3.79c.32.31.86.09.86-.36V7c3.73 0 6.68 3.42 5.86 7.29-.47 2.27-2.31 4.1-4.57 4.57-3.57.75-6.75-1.7-7.23-5.01-.07-.48-.49-.85-.98-.85-.6 0-1.08.53-1 1.13.62 4.39 4.8 7.64 9.53 6.72 3.12-.61 5.63-3.12 6.24-6.24C20.84 9.48 16.94 5 12 5zm-2.44 8.49h.45c.21 0 .37-.05.48-.16s.16-.25.16-.43c0-.08-.01-.15-.04-.22s-.06-.12-.11-.17-.11-.09-.18-.11-.16-.04-.25-.04c-.08 0-.15.01-.22.03s-.13.05-.18.1-.09.09-.12.15-.05.13-.05.2h-.85c0-.18.04-.34.11-.48s.17-.27.3-.37.27-.18.44-.23.35-.08.54-.08c.21 0 .41.03.59.08s.33.13.46.23.23.23.3.38.11.33.11.53c0 .09-.01.18-.04.27s-.07.17-.13.25-.12.15-.2.22-.17.12-.28.17c.24.09.42.21.54.39s.18.38.18.61c0 .2-.04.38-.12.53s-.18.29-.32.39-.29.19-.48.24-.38.08-.6.08c-.18 0-.36-.02-.53-.07s-.33-.12-.46-.23-.25-.23-.33-.38-.12-.34-.12-.55h.85c0 .08.02.15.05.22s.07.12.13.17.12.09.2.11.16.04.25.04c.1 0 .19-.01.27-.04s.15-.07.2-.12.1-.11.13-.18.04-.15.04-.24c0-.11-.02-.21-.05-.29s-.08-.15-.14-.2-.13-.09-.22-.11-.18-.04-.29-.04h-.47v-.65zm5.74.75c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32c.03-.13.04-.29.04-.48v-.97z"
	}), 'Replay30Rounded');
	
	exports.default = _default;

/***/ },
/* 5029 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8zm-2.44 8.49h.45c.21 0 .37-.05.48-.16s.16-.25.16-.43c0-.08-.01-.15-.04-.22s-.06-.12-.11-.17-.11-.09-.18-.11-.16-.04-.25-.04c-.08 0-.15.01-.22.03s-.13.05-.18.1-.09.09-.12.15-.05.13-.05.2h-.85c0-.18.04-.34.11-.48s.17-.27.3-.37.27-.18.44-.23.35-.08.54-.08c.21 0 .41.03.59.08s.33.13.46.23.23.23.3.38.11.33.11.53c0 .09-.01.18-.04.27s-.07.17-.13.25-.12.15-.2.22-.17.12-.28.17c.24.09.42.21.54.39s.18.38.18.61c0 .2-.04.38-.12.53s-.18.29-.32.39-.29.19-.48.24-.38.08-.6.08c-.18 0-.36-.02-.53-.07s-.33-.12-.46-.23-.25-.23-.33-.38-.12-.34-.12-.55h.85c0 .08.02.15.05.22s.07.12.13.17.12.09.2.11.16.04.25.04c.1 0 .19-.01.27-.04s.15-.07.2-.12.1-.11.13-.18.04-.15.04-.24c0-.11-.02-.21-.05-.29s-.08-.15-.14-.2-.13-.09-.22-.11-.18-.04-.29-.04h-.47v-.65zm5.74.75c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32c.03-.13.04-.29.04-.48v-.97z"
	}), 'Replay30Sharp');
	
	exports.default = _default;

/***/ },
/* 5030 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8zm-2.44 8.49h.45c.21 0 .37-.05.48-.16s.16-.25.16-.43c0-.08-.01-.15-.04-.22s-.06-.12-.11-.17-.11-.09-.18-.11-.16-.04-.25-.04c-.08 0-.15.01-.22.03s-.13.05-.18.1-.09.09-.12.15-.05.13-.05.2h-.85c0-.18.04-.34.11-.48s.17-.27.3-.37.27-.18.44-.23.35-.08.54-.08c.21 0 .41.03.59.08s.33.13.46.23.23.23.3.38.11.33.11.53c0 .09-.01.18-.04.27s-.07.17-.13.25-.12.15-.2.22-.17.12-.28.17c.24.09.42.21.54.39s.18.38.18.61c0 .2-.04.38-.12.53s-.18.29-.32.39-.29.19-.48.24-.38.08-.6.08c-.18 0-.36-.02-.53-.07s-.33-.12-.46-.23-.25-.23-.33-.38-.12-.34-.12-.55h.85c0 .08.02.15.05.22s.07.12.13.17.12.09.2.11.16.04.25.04c.1 0 .19-.01.27-.04s.15-.07.2-.12.1-.11.13-.18.04-.15.04-.24c0-.11-.02-.21-.05-.29s-.08-.15-.14-.2-.13-.09-.22-.11-.18-.04-.29-.04h-.47v-.65zm5.74.75c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32c.03-.13.04-.29.04-.48v-.97z"
	}), 'Replay30TwoTone');
	
	exports.default = _default;

/***/ },
/* 5031 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
	}), _react.default.createElement("path", {
	  d: "M10.69 13.9l.25-2.17h2.39v.71h-1.7l-.11.92c.03-.02.07-.03.11-.05s.09-.04.15-.05.12-.03.18-.04.13-.02.2-.02c.21 0 .39.03.55.1s.3.16.41.28.2.27.25.45.09.38.09.6c0 .19-.03.37-.09.54s-.15.32-.27.45-.27.24-.45.31-.39.12-.64.12c-.18 0-.36-.03-.53-.08s-.32-.14-.46-.24-.24-.24-.32-.39-.13-.33-.13-.53h.84c.02.18.08.32.19.41s.25.15.42.15c.11 0 .2-.02.27-.06s.14-.1.18-.17.08-.15.11-.25.03-.2.03-.31-.01-.21-.04-.31-.07-.17-.13-.24-.13-.12-.21-.15-.19-.05-.3-.05c-.08 0-.15.01-.2.02s-.11.03-.15.05-.08.05-.12.07-.07.06-.1.09l-.67-.16z"
	})), 'Replay5');
	
	exports.default = _default;

/***/ },
/* 5032 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8zm-1.31 8.9l.25-2.17h2.39v.71h-1.7l-.11.92c.03-.02.07-.03.11-.05s.09-.04.15-.05.12-.03.18-.04.13-.02.2-.02c.21 0 .39.03.55.1s.3.16.41.28.2.27.25.45.09.38.09.6c0 .19-.03.37-.09.54s-.15.32-.27.45-.27.24-.45.31-.39.12-.64.12c-.18 0-.36-.03-.53-.08s-.32-.14-.46-.24-.24-.24-.32-.39-.13-.33-.13-.53h.84c.02.18.08.32.19.41s.25.15.42.15c.11 0 .2-.02.27-.06s.14-.1.18-.17.08-.15.11-.25.03-.2.03-.31-.01-.21-.04-.31-.07-.17-.13-.24-.13-.12-.21-.15-.19-.05-.3-.05c-.08 0-.15.01-.2.02s-.11.03-.15.05-.08.05-.12.07-.07.06-.1.09l-.67-.16z"
	}), 'Replay5Outlined');
	
	exports.default = _default;

/***/ },
/* 5033 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5V2.21c0-.45-.54-.67-.85-.35l-3.8 3.79c-.2.2-.2.51 0 .71l3.79 3.79c.32.31.86.09.86-.36V7c3.73 0 6.68 3.42 5.86 7.29-.47 2.26-2.14 3.99-4.39 4.53-3.64.88-6.93-1.6-7.42-4.96-.06-.49-.48-.86-.97-.86-.6 0-1.08.53-1 1.13.63 4.47 4.94 7.75 9.77 6.67 3.09-.69 5.39-3.08 5.99-6.19C20.84 9.48 16.94 5 12 5zm-1.31 8.9l.25-2.17h2.39v.71h-1.7l-.11.92c.03-.02.07-.03.11-.05s.09-.04.15-.05.12-.03.18-.04.13-.02.2-.02c.21 0 .39.03.55.1s.3.16.41.28.2.27.25.45.09.38.09.6c0 .19-.03.37-.09.54s-.15.32-.27.45-.27.24-.45.31-.39.12-.64.12c-.18 0-.36-.03-.53-.08s-.32-.14-.46-.24-.24-.24-.32-.39-.13-.33-.13-.53h.84c.02.18.08.32.19.41s.25.15.42.15c.11 0 .2-.02.27-.06s.14-.1.18-.17.08-.15.11-.25.03-.2.03-.31-.01-.21-.04-.31-.07-.17-.13-.24-.13-.12-.21-.15-.19-.05-.3-.05c-.08 0-.15.01-.2.02s-.11.03-.15.05-.08.05-.12.07-.07.06-.1.09l-.67-.16z"
	}), 'Replay5Rounded');
	
	exports.default = _default;

/***/ },
/* 5034 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8zm-1.31 8.9l.25-2.17h2.39v.71h-1.7l-.11.92c.03-.02.07-.03.11-.05s.09-.04.15-.05.12-.03.18-.04.13-.02.2-.02c.21 0 .39.03.55.1s.3.16.41.28.2.27.25.45.09.38.09.6c0 .19-.03.37-.09.54s-.15.32-.27.45-.27.24-.45.31-.39.12-.64.12c-.18 0-.36-.03-.53-.08s-.32-.14-.46-.24-.24-.24-.32-.39-.13-.33-.13-.53h.84c.02.18.08.32.19.41s.25.15.42.15c.11 0 .2-.02.27-.06s.14-.1.18-.17.08-.15.11-.25.03-.2.03-.31-.01-.21-.04-.31-.07-.17-.13-.24-.13-.12-.21-.15-.19-.05-.3-.05c-.08 0-.15.01-.2.02s-.11.03-.15.05-.08.05-.12.07-.07.06-.1.09l-.67-.16z"
	}), 'Replay5Sharp');
	
	exports.default = _default;

/***/ },
/* 5035 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8zm-1.31 8.9l.25-2.17h2.39v.71h-1.7l-.11.92c.03-.02.07-.03.11-.05s.09-.04.15-.05.12-.03.18-.04.13-.02.2-.02c.21 0 .39.03.55.1s.3.16.41.28.2.27.25.45.09.38.09.6c0 .19-.03.37-.09.54s-.15.32-.27.45-.27.24-.45.31-.39.12-.64.12c-.18 0-.36-.03-.53-.08s-.32-.14-.46-.24-.24-.24-.32-.39-.13-.33-.13-.53h.84c.02.18.08.32.19.41s.25.15.42.15c.11 0 .2-.02.27-.06s.14-.1.18-.17.08-.15.11-.25.03-.2.03-.31-.01-.21-.04-.31-.07-.17-.13-.24-.13-.12-.21-.15-.19-.05-.3-.05c-.08 0-.15.01-.2.02s-.11.03-.15.05-.08.05-.12.07-.07.06-.1.09l-.67-.16z"
	}), 'Replay5TwoTone');
	
	exports.default = _default;

/***/ },
/* 5036 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
	}), 'ReplayOutlined');
	
	exports.default = _default;

/***/ },
/* 5037 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5V2.21c0-.45-.54-.67-.85-.35l-3.8 3.79c-.2.2-.2.51 0 .71l3.79 3.79c.32.31.86.09.86-.36V7c3.73 0 6.68 3.42 5.86 7.29-.47 2.27-2.31 4.1-4.57 4.57-3.57.75-6.75-1.7-7.23-5.01-.07-.48-.49-.85-.98-.85-.6 0-1.08.53-1 1.13.62 4.39 4.8 7.64 9.53 6.72 3.12-.61 5.63-3.12 6.24-6.24C20.84 9.48 16.94 5 12 5z"
	}), 'ReplayRounded');
	
	exports.default = _default;

/***/ },
/* 5038 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
	}), 'ReplaySharp');
	
	exports.default = _default;

/***/ },
/* 5039 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8V1L7 6z"
	}), 'ReplayTwoTone');
	
	exports.default = _default;

/***/ },
/* 5040 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
	}), 'Reply');
	
	exports.default = _default;

/***/ },
/* 5041 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
	}), 'ReplyAll');
	
	exports.default = _default;

/***/ },
/* 5042 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
	}), 'ReplyAllOutlined');
	
	exports.default = _default;

/***/ },
/* 5043 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 7.56c0-.94-1.14-1.42-1.81-.75L.71 11.29c-.39.39-.39 1.02 0 1.41l4.48 4.48c.67.68 1.81.2 1.81-.74 0-.28-.11-.55-.31-.75L3 12l3.69-3.69c.2-.2.31-.47.31-.75zM13 9V7.41c0-.89-1.08-1.34-1.71-.71L6.7 11.29c-.39.39-.39 1.02 0 1.41l4.59 4.59c.63.63 1.71.18 1.71-.71V14.9c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
	}), 'ReplyAllRounded');
	
	exports.default = _default;

/***/ },
/* 5044 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
	}), 'ReplyAllSharp');
	
	exports.default = _default;

/***/ },
/* 5045 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
	}), 'ReplyAllTwoTone');
	
	exports.default = _default;

/***/ },
/* 5046 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
	}), 'ReplyOutlined');
	
	exports.default = _default;

/***/ },
/* 5047 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 9V7.41c0-.89-1.08-1.34-1.71-.71L3.7 11.29c-.39.39-.39 1.02 0 1.41l4.59 4.59c.63.63 1.71.19 1.71-.7V14.9c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
	}), 'ReplyRounded');
	
	exports.default = _default;

/***/ },
/* 5048 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
	}), 'ReplySharp');
	
	exports.default = _default;

/***/ },
/* 5049 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
	}), 'ReplyTwoTone');
	
	exports.default = _default;

/***/ },
/* 5050 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z"
	}), 'Report');
	
	exports.default = _default;

/***/ },
/* 5051 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 7h2v2.92l6.91 6.91 1.09-1.1V8.27L15.73 3H8.27L7.18 4.1 11 7.92zm11.27 14.73l-20-20.01L1 2.99l3.64 3.64L3 8.27v7.46L8.27 21h7.46l1.64-1.63L21 23l1.27-1.27zM12 17.3c-.72 0-1.3-.58-1.3-1.3s.58-1.3 1.3-1.3 1.3.58 1.3 1.3-.58 1.3-1.3 1.3z"
	}), 'ReportOff');
	
	exports.default = _default;

/***/ },
/* 5052 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9.1 5h5.8L19 9.1v5.8l-.22.22 1.42 1.41.8-.8V8.27L15.73 3H8.27l-.8.8 1.41 1.42z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "16",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M13 9.33V7h-2v.33zM2.41 1.58L1 2.99l3.64 3.64L3 8.27v7.46L8.27 21h7.46l1.64-1.64L21.01 23l1.41-1.41L2.41 1.58zM14.9 19H9.1L5 14.9V9.1l1.05-1.05 9.9 9.9L14.9 19z"
	})), 'ReportOffOutlined');
	
	exports.default = _default;

/***/ },
/* 5053 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7c.55 0 1 .45 1 1v1.33l7.2 7.2.51-.51c.19-.19.29-.44.29-.71V8.68c0-.27-.11-.52-.29-.71l-4.68-4.68c-.19-.18-.45-.29-.71-.29H8.68c-.26 0-.52.11-.7.29l-.51.51 3.69 3.69c.17-.29.48-.49.84-.49zM2.41 1.58L1 2.99l3.64 3.64-1.35 1.35c-.18.18-.29.44-.29.7v6.63c0 .27.11.52.29.71l4.68 4.68c.19.19.45.3.71.3h6.63c.27 0 .52-.11.71-.29l1.35-1.35L21.01 23l1.41-1.41L2.41 1.58zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3s1.3.58 1.3 1.3c0 .72-.58 1.3-1.3 1.3z"
	}), 'ReportOffRounded');
	
	exports.default = _default;

/***/ },
/* 5054 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 7h2v2.33l7.2 7.2.8-.8V8.27L15.73 3H8.27l-.8.8L11 7.33zM2.41 1.58L1 2.99l3.64 3.64L3 8.27v7.46L8.27 21h7.46l1.64-1.64L21.01 23l1.41-1.41L2.41 1.58zM11 12.99l.01.01H11v-.01zm1 4.31c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3s1.3.58 1.3 1.3c0 .72-.58 1.3-1.3 1.3z"
	}), 'ReportOffSharp');
	
	exports.default = _default;

/***/ },
/* 5055 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 9.1L14.9 5H9.1l-.22.22L11 7.33V7h2v2.33l5.78 5.79.22-.22zM6.05 8.04L5 9.1v5.8L9.1 19h5.8l1.05-1.05-9.9-9.91zM13 16c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9.1 5h5.8L19 9.1v5.8l-.22.22 1.42 1.41.8-.8V8.27L15.73 3H8.27l-.8.8 1.41 1.42z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "16",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M13 7h-2v.33l2 2zM2.41 1.58L1 2.99l3.64 3.64L3 8.27v7.46L8.27 21h7.46l1.64-1.64L21.01 23l1.41-1.41L2.41 1.58zM14.9 19H9.1L5 14.9V9.1l1.05-1.05 9.9 9.9L14.9 19z"
	})), 'ReportOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 5056 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM19 14.9L14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1v5.8z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "16",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M11 7h2v7h-2z"
	})), 'ReportOutlined');
	
	exports.default = _default;

/***/ },
/* 5057 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
	}), 'ReportProblem');
	
	exports.default = _default;

/***/ },
/* 5058 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
	}), 'ReportProblemOutlined');
	
	exports.default = _default;

/***/ },
/* 5059 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.73 21h18.53c.77 0 1.25-.83.87-1.5l-9.27-16c-.39-.67-1.35-.67-1.73 0l-9.27 16c-.38.67.1 1.5.87 1.5zM13 18h-2v-2h2v2zm-1-4c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1z"
	}), 'ReportProblemRounded');
	
	exports.default = _default;

/***/ },
/* 5060 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
	}), 'ReportProblemSharp');
	
	exports.default = _default;

/***/ },
/* 5061 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 5.99L4.47 19h15.06L12 5.99zM13 18h-2v-2h2v2zm-2-4v-4h2v4h-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2L1 21h22L12 2zm0 3.99L19.53 19H4.47L12 5.99zM11 16h2v2h-2zm0-6h2v4h-2z"
	})), 'ReportProblemTwoTone');
	
	exports.default = _default;

/***/ },
/* 5062 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.32 3H8.68c-.26 0-.52.11-.7.29L3.29 7.98c-.18.18-.29.44-.29.7v6.63c0 .27.11.52.29.71l4.68 4.68c.19.19.45.3.71.3h6.63c.27 0 .52-.11.71-.29l4.68-4.68c.19-.19.29-.44.29-.71V8.68c0-.27-.11-.52-.29-.71l-4.68-4.68c-.18-.18-.44-.29-.7-.29zM12 17.3c-.72 0-1.3-.58-1.3-1.3s.58-1.3 1.3-1.3 1.3.58 1.3 1.3-.58 1.3-1.3 1.3zm0-4.3c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1z"
	}), 'ReportRounded');
	
	exports.default = _default;

/***/ },
/* 5063 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3s.58-1.3 1.3-1.3 1.3.58 1.3 1.3-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z"
	}), 'ReportSharp');
	
	exports.default = _default;

/***/ },
/* 5064 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9.1 5L5 9.1v5.8L9.1 19h5.8l4.1-4.1V9.1L14.9 5H9.1zM12 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm1-3h-2V7h2v7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM19 14.9L14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1v5.8z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "16",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M11 7h2v7h-2z"
	})), 'ReportTwoTone');
	
	exports.default = _default;

/***/ },
/* 5065 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z"
	}), 'Restaurant');
	
	exports.default = _default;

/***/ },
/* 5066 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
	}), 'RestaurantMenu');
	
	exports.default = _default;

/***/ },
/* 5067 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
	}), 'RestaurantMenuOutlined');
	
	exports.default = _default;

/***/ },
/* 5068 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.1 13.34l2.83-2.83-6.19-6.18c-.48-.48-1.31-.35-1.61.27-.71 1.49-.45 3.32.78 4.56l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L4.4 19.17c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 14.41l6.18 6.18c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 13l1.47-1.47z"
	}), 'RestaurantMenuRounded');
	
	exports.default = _default;

/***/ },
/* 5069 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
	}), 'RestaurantMenuSharp');
	
	exports.default = _default;

/***/ },
/* 5070 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm12.05-3.19c1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47c1.53.71 3.68.21 5.27-1.38z"
	}), 'RestaurantMenuTwoTone');
	
	exports.default = _default;

/***/ },
/* 5071 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 6v8h3v8h2V2c-2.76 0-5 2.24-5 4zm-5 3H9V2H7v7H5V2H3v7c0 2.21 1.79 4 4 4v9h2v-9c2.21 0 4-1.79 4-4V2h-2v7z"
	}), 'RestaurantOutlined');
	
	exports.default = _default;

/***/ },
/* 5072 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 6v6c0 1.1.9 2 2 2h1v7c0 .55.45 1 1 1s1-.45 1-1V3.13c0-.65-.61-1.13-1.24-.98C17.6 2.68 16 4.51 16 6zm-5 3H9V3c0-.55-.45-1-1-1s-1 .45-1 1v6H5V3c0-.55-.45-1-1-1s-1 .45-1 1v6c0 2.21 1.79 4 4 4v8c0 .55.45 1 1 1s1-.45 1-1v-8c2.21 0 4-1.79 4-4V3c0-.55-.45-1-1-1s-1 .45-1 1v6z"
	}), 'RestaurantRounded');
	
	exports.default = _default;

/***/ },
/* 5073 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 6v8h3v8h2V2c-2.76 0-5 2.24-5 4zm-5 3H9V2H7v7H5V2H3v7c0 2.21 1.79 4 4 4v9h2v-9c2.21 0 4-1.79 4-4V2h-2v7z"
	}), 'RestaurantSharp');
	
	exports.default = _default;

/***/ },
/* 5074 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 6v8h3v8h2V2c-2.76 0-5 2.24-5 4zm-5 3H9V2H7v7H5V2H3v7c0 2.21 1.79 4 4 4v9h2v-9c2.21 0 4-1.79 4-4V2h-2v7z"
	}), 'RestaurantTwoTone');
	
	exports.default = _default;

/***/ },
/* 5075 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
	}), 'Restore');
	
	exports.default = _default;

/***/ },
/* 5076 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4h-3.5l-1-1h-5l-1 1H5v2h14zM6 7v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zm8 7v4h-4v-4H8l4-4 4 4h-2z"
	}), 'RestoreFromTrash');
	
	exports.default = _default;

/***/ },
/* 5077 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 4l-1-1h-5l-1 1H5v2h14V4zM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2-5V9h8v10H8v-5zm2 4h4v-4h2l-4-4-4 4h2z"
	}), 'RestoreFromTrashOutlined');
	
	exports.default = _default;

/***/ },
/* 5078 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10zm5.65-8.65c.2-.2.51-.2.71 0L16 14h-2v4h-4v-4H8l3.65-3.65zM15.5 4l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5z"
	}), 'RestoreFromTrashRounded');
	
	exports.default = _default;

/***/ },
/* 5079 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 21h12V7H6v14zm6-11l4 4h-2v4h-4v-4H8l4-4zm3.5-6l-1-1h-5l-1 1H5v2h14V4z"
	}), 'RestoreFromTrashSharp');
	
	exports.default = _default;

/***/ },
/* 5080 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16 14h-2v4h-4v-4H8v5h8zm0 0V9H8v5l4-4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2-5V9h8v10H8v-5zm7.5-10l-1-1h-5l-1 1H5v2h14V4zM10 18h4v-4h2l-4-4-4 4h2z"
	})), 'RestoreFromTrashTwoTone');
	
	exports.default = _default;

/***/ },
/* 5081 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 3c-4.97 0-9 4.03-9 9H1l4 3.99L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8z"
	}), 'RestoreOutlined');
	
	exports.default = _default;

/***/ },
/* 5082 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm-2 16c-2.05 0-3.81-1.24-4.58-3h1.71c.63.9 1.68 1.5 2.87 1.5 1.93 0 3.5-1.57 3.5-3.5S13.93 9.5 12 9.5c-1.35 0-2.52.78-3.1 1.9l1.6 1.6h-4V9l1.3 1.3C8.69 8.92 10.23 8 12 8c2.76 0 5 2.24 5 5s-2.24 5-5 5z"
	}), 'RestorePage');
	
	exports.default = _default;

/***/ },
/* 5083 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7.17L18 8.83V20zm-9.55-9.43L7.28 9.4V13h3.6l-1.44-1.44c.52-1.01 1.58-1.71 2.79-1.71 1.74 0 3.15 1.41 3.15 3.15s-1.41 3.15-3.15 3.15c-1.07 0-2.02-.54-2.58-1.35H8.1c.69 1.58 2.28 2.7 4.12 2.7 2.48 0 4.5-2.02 4.5-4.5s-2.02-4.5-4.5-4.5c-1.59 0-2.97.83-3.77 2.07z"
	}), 'RestorePageOutlined');
	
	exports.default = _default;

/***/ },
/* 5084 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.41 7.41l-4.83-4.83c-.37-.37-.88-.58-1.41-.58H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8.83c0-.53-.21-1.04-.59-1.42zM12 18c-1.65 0-3.19-.81-4.12-2.17-.23-.34-.15-.81.19-1.04.34-.24.81-.15 1.04.19.65.95 1.73 1.52 2.88 1.52 1.93 0 3.5-1.57 3.5-3.5S13.93 9.5 12 9.5c-1.33 0-2.52.74-3.11 1.89L10.5 13H7c-.28 0-.5-.22-.5-.5V9l1.3 1.3C8.71 8.89 10.26 8 12 8c2.76 0 5 2.24 5 5s-2.24 5-5 5z"
	}), 'RestorePageRounded');
	
	exports.default = _default;

/***/ },
/* 5085 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 2H4v20h16V8l-6-6zm-2 16c-2.05 0-3.81-1.24-4.58-3h1.71c.63.9 1.68 1.5 2.87 1.5 1.93 0 3.5-1.57 3.5-3.5S13.93 9.5 12 9.5c-1.35 0-2.52.78-3.1 1.9l1.6 1.6h-4V9l1.3 1.3C8.69 8.92 10.23 8 12 8c2.76 0 5 2.24 5 5s-2.24 5-5 5z"
	}), 'RestorePageSharp');
	
	exports.default = _default;

/***/ },
/* 5086 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 4v16h12V8.83L13.17 4H6zm10.72 9c0 2.48-2.02 4.5-4.5 4.5-1.84 0-3.43-1.12-4.12-2.7h1.54c.57.81 1.51 1.35 2.58 1.35 1.74 0 3.15-1.41 3.15-3.15s-1.41-3.15-3.15-3.15c-1.21 0-2.27.7-2.79 1.71L10.88 13h-3.6V9.4l1.17 1.17c.8-1.24 2.19-2.07 3.78-2.07 2.48 0 4.49 2.02 4.49 4.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7.17L18 8.83V20zm-9.55-9.43L7.28 9.4V13h3.6l-1.44-1.44c.52-1.01 1.58-1.71 2.79-1.71 1.74 0 3.15 1.41 3.15 3.15s-1.41 3.15-3.15 3.15c-1.07 0-2.02-.54-2.58-1.35H8.1c.69 1.58 2.28 2.7 4.12 2.7 2.48 0 4.5-2.02 4.5-4.5s-2.02-4.5-4.5-4.5c-1.59 0-2.97.83-3.77 2.07z"
	})), 'RestorePageTwoTone');
	
	exports.default = _default;

/***/ },
/* 5087 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.25 3c-5.09-.14-9.26 3.94-9.26 9H2.2c-.45 0-.67.54-.35.85l2.79 2.8c.2.2.51.2.71 0l2.79-2.8c.32-.31.09-.85-.35-.85h-1.8c0-3.9 3.18-7.05 7.1-7 3.72.05 6.85 3.18 6.9 6.9.05 3.91-3.1 7.1-7 7.1-1.61 0-3.1-.55-4.28-1.48-.4-.31-.96-.28-1.32.08-.42.43-.39 1.13.08 1.5 1.52 1.19 3.44 1.9 5.52 1.9 5.05 0 9.14-4.17 9-9.26-.13-4.69-4.05-8.61-8.74-8.74zm-.51 5c-.41 0-.75.34-.75.75v3.68c0 .35.19.68.49.86l3.12 1.85c.36.21.82.09 1.03-.26.21-.36.09-.82-.26-1.03l-2.88-1.71v-3.4c0-.4-.33-.74-.75-.74z"
	}), 'RestoreRounded');
	
	exports.default = _default;

/***/ },
/* 5088 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 3c-4.97 0-9 4.03-9 9H1l4 3.99L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8z"
	}), 'RestoreSharp');
	
	exports.default = _default;

/***/ },
/* 5089 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 3c-4.97 0-9 4.03-9 9H1l4 3.99L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8z"
	}), 'RestoreTwoTone');
	
	exports.default = _default;

/***/ },
/* 5090 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23.71 16.67C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.27-.11-.52-.29-.7zM21.16 6.26l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM13 2h-2v5h2V2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z"
	}), 'RingVolume');
	
	exports.default = _default;

/***/ },
/* 5091 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23.71 16.67C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.27-.11-.52-.29-.7zm-18.31.56c-.66.37-1.29.8-1.87 1.27l-1.07-1.07c.91-.75 1.9-1.39 2.95-1.9v1.7zm15.07 1.26c-.59-.48-1.21-.9-1.87-1.27v-1.7c1.04.51 2.03 1.15 2.94 1.9l-1.07 1.07zm.69-12.23l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM11 2h2v5h-2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z"
	}), 'RingVolumeOutlined');
	
	exports.default = _default;

/***/ },
/* 5092 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.98 7h.03c.55 0 .99-.44.99-.98V2.98c0-.54-.44-.98-.98-.98h-.03c-.55 0-.99.44-.99.98v3.03c0 .55.44.99.98.99zm4.92 2.11c.39.39 1.01.39 1.4 0 .62-.63 1.52-1.54 2.15-2.17.39-.38.39-1.01 0-1.39-.38-.38-1.01-.38-1.39 0L16.89 7.7c-.39.38-.39 1.01 0 1.39l.01.02zM5.71 9.1c.38.39 1.01.39 1.4 0 .38-.38.38-1.01 0-1.39L4.96 5.54c-.38-.39-1.01-.39-1.39 0l-.02.01c-.39.39-.39 1.01 0 1.39.63.62 1.54 1.53 2.16 2.16zm17.58 7.13c-6.41-5.66-16.07-5.66-22.48 0-.85.75-.85 2.08-.05 2.88l1.22 1.22c.72.72 1.86.78 2.66.15l2-1.59c.48-.38.76-.96.76-1.57v-2.6c3.02-.98 6.29-.99 9.32 0v2.61c0 .61.28 1.19.76 1.57l1.99 1.58c.8.63 1.94.57 2.66-.15l1.22-1.22c.79-.8.79-2.13-.06-2.88z"
	}), 'RingVolumeRounded');
	
	exports.default = _default;

/***/ },
/* 5093 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.16 6.26l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM11 2h2v5h-2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55zM0 17.39l3.68 3.68 3.92-3.11v-3.37c2.85-.93 5.94-.93 8.8 0v3.38l3.91 3.1L24 17.39c-6.41-7.19-17.59-7.19-24 0z"
	}), 'RingVolumeSharp');
	
	exports.default = _default;

/***/ },
/* 5094 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18.6 17.22c.66.37 1.28.79 1.87 1.27l1.07-1.07c-.91-.75-1.9-1.38-2.94-1.9v1.7zM3.53 18.5c.58-.47 1.21-.89 1.87-1.27v-1.71c-1.05.51-2.03 1.15-2.95 1.9l1.08 1.08z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 12C7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.27-.11-.52-.29-.7C20.66 13.78 16.54 12 12 12zm-6.6 5.23c-.66.37-1.29.8-1.87 1.27l-1.07-1.07c.91-.75 1.9-1.39 2.95-1.9v1.7zm15.07 1.26c-.59-.48-1.21-.9-1.87-1.27v-1.7c1.04.51 2.03 1.15 2.94 1.9l-1.07 1.07zM16.19 8.4l1.41 1.41s3.45-3.52 3.56-3.55l-1.41-1.41-3.56 3.55zM11 2h2v5h-2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z"
	})), 'RingVolumeTwoTone');
	
	exports.default = _default;

/***/ },
/* 5095 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
	}), 'Room');
	
	exports.default = _default;

/***/ },
/* 5096 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "9",
	  r: "2.5"
	})), 'RoomOutlined');
	
	exports.default = _default;

/***/ },
/* 5097 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C8.13 2 5 5.13 5 9c0 4.17 4.42 9.92 6.24 12.11.4.48 1.13.48 1.53 0C14.58 18.92 19 13.17 19 9c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
	}), 'RoomRounded');
	
	exports.default = _default;

/***/ },
/* 5098 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 17h20v2H2zm11.84-9.21c.1-.24.16-.51.16-.79 0-1.1-.9-2-2-2s-2 .9-2 2c0 .28.06.55.16.79C6.25 8.6 3.27 11.93 3 16h18c-.27-4.07-3.25-7.4-7.16-8.21z"
	}), 'RoomService');
	
	exports.default = _default;

/***/ },
/* 5099 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.98 17H2v2h20v-2zM21 16c-.27-4.07-3.25-7.4-7.16-8.21.1-.24.16-.51.16-.79 0-1.1-.9-2-2-2s-2 .9-2 2c0 .28.06.55.16.79C6.25 8.6 3.27 11.93 3 16h18zm-9-6.42c2.95 0 5.47 1.83 6.5 4.41h-13c1.03-2.58 3.55-4.41 6.5-4.41z"
	}), 'RoomServiceOutlined');
	
	exports.default = _default;

/***/ },
/* 5100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 17h18c.55 0 1 .45 1 1s-.45 1-1 1H3c-.55 0-1-.45-1-1s.45-1 1-1zm10.84-9.21c.1-.24.16-.51.16-.79 0-1.1-.9-2-2-2s-2 .9-2 2c0 .28.06.55.16.79C6.25 8.6 3.27 11.93 3 16h18c-.27-4.07-3.25-7.4-7.16-8.21z"
	}), 'RoomServiceRounded');
	
	exports.default = _default;

/***/ },
/* 5101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 17h20v2H2v-2zm11.84-9.21c.1-.24.16-.51.16-.79 0-1.1-.9-2-2-2s-2 .9-2 2c0 .28.06.55.16.79C6.25 8.6 3.27 11.93 3 16h18c-.27-4.07-3.25-7.4-7.16-8.21z"
	}), 'RoomServiceSharp');
	
	exports.default = _default;

/***/ },
/* 5102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 9.58c-2.95 0-5.47 1.83-6.5 4.41h13c-1.03-2.58-3.55-4.41-6.5-4.41z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M2 17h20v2H2zm11.84-9.21c.1-.24.16-.51.16-.79 0-1.1-.9-2-2-2s-2 .9-2 2c0 .28.06.55.16.79C6.25 8.6 3.27 11.93 3 16h18c-.27-4.07-3.25-7.4-7.16-8.21zM12 9.58c2.95 0 5.47 1.83 6.5 4.41h-13c1.03-2.58 3.55-4.41 6.5-4.41z"
	})), 'RoomServiceTwoTone');
	
	exports.default = _default;

/***/ },
/* 5103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
	}), 'RoomSharp');
	
	exports.default = _default;

/***/ },
/* 5104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4C9.24 4 7 6.24 7 9c0 2.85 2.92 7.21 5 9.88 2.11-2.69 5-7 5-9.88 0-2.76-2.24-5-5-5zm0 7.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "9",
	  r: "2.5"
	})), 'RoomTwoTone');
	
	exports.default = _default;

/***/ },
/* 5105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.34 6.41L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm15.67-6.26C17.61 4.88 15.3 4 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05 2.73 2.73 2.73 7.17 0 9.9C16.58 19.32 14.79 20 13 20c-.97 0-1.94-.21-2.84-.61l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64 3.52-3.51 3.52-9.21 0-12.72z"
	}), 'Rotate90DegreesCcw');
	
	exports.default = _default;

/***/ },
/* 5106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.34 6.41L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm15.67-6.26C17.61 4.88 15.3 4 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05 2.73 2.73 2.73 7.17 0 9.9C16.58 19.32 14.79 20 13 20c-.97 0-1.94-.21-2.84-.61l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64 3.52-3.51 3.52-9.21 0-12.72z"
	}), 'Rotate90DegreesCcwOutlined');
	
	exports.default = _default;

/***/ },
/* 5107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.93 7.83l-3.65 3.66c-.78.78-.78 2.05 0 2.83l3.66 3.66c.78.78 2.05.78 2.83 0l3.66-3.65c.78-.78.78-2.05 0-2.83L8.76 7.82c-.79-.78-2.05-.78-2.83.01zM4.4 12.19l2.25-2.25c.39-.39 1.02-.39 1.42 0l2.24 2.24c.39.39.39 1.02 0 1.41l-2.25 2.25c-.39.39-1.02.39-1.42 0L4.4 13.61c-.39-.39-.39-1.03 0-1.42zm14.96-5.55C17.61 4.88 15.3 4 13 4v-.83c0-.89-1.08-1.34-1.71-.71L9.47 4.29c-.39.39-.39 1.02 0 1.41l1.83 1.83c.62.63 1.7.19 1.7-.7V6c2.02 0 4.03.86 5.45 2.61 2.05 2.52 2.05 6.27 0 8.79C17.03 19.14 15.02 20 13 20c-.78 0-1.55-.13-2.29-.39-.36-.12-.75-.01-1.02.26-.5.5-.34 1.39.34 1.62.96.34 1.96.51 2.97.51 2.3 0 4.61-.88 6.36-2.64 3.52-3.51 3.52-9.21 0-12.72z"
	}), 'Rotate90DegreesCcwRounded');
	
	exports.default = _default;

/***/ },
/* 5108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.34 6.41L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm15.67-6.26C17.61 4.88 15.3 4 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05 2.73 2.73 2.73 7.17 0 9.9C16.58 19.32 14.79 20 13 20c-.97 0-1.94-.21-2.84-.61l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64 3.52-3.51 3.52-9.21 0-12.72z"
	}), 'Rotate90DegreesCcwSharp');
	
	exports.default = _default;

/***/ },
/* 5109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7.35 9.24L3.69 12.9l3.65 3.66L11 12.9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M7.34 6.41L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zm0 10.15L3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66zm12.02-9.92C17.61 4.88 15.3 4 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05 2.73 2.73 2.73 7.17 0 9.9C16.58 19.32 14.79 20 13 20c-.97 0-1.94-.21-2.84-.61l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64 3.52-3.51 3.52-9.21 0-12.72z"
	})), 'Rotate90DegreesCcwTwoTone');
	
	exports.default = _default;

/***/ },
/* 5110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z"
	}), 'RotateLeft');
	
	exports.default = _default;

/***/ },
/* 5111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z"
	}), 'RotateLeftOutlined');
	
	exports.default = _default;

/***/ },
/* 5112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.56 7.98C6.1 7.52 5.31 7.6 5 8.17c-.28.51-.5 1.03-.67 1.58-.19.63.31 1.25.96 1.25h.01c.43 0 .82-.28.94-.7.12-.4.28-.79.48-1.17.22-.37.15-.84-.16-1.15zM5.31 13h-.02c-.65 0-1.15.62-.96 1.25.16.54.38 1.07.66 1.58.31.57 1.11.66 1.57.2.3-.31.38-.77.17-1.15-.2-.37-.36-.76-.48-1.16-.12-.44-.51-.72-.94-.72zm2.85 6.02c.51.28 1.04.5 1.59.66.62.18 1.24-.32 1.24-.96v-.03c0-.43-.28-.82-.7-.94-.4-.12-.78-.28-1.15-.48-.38-.21-.86-.14-1.16.17l-.03.03c-.45.45-.36 1.24.21 1.55zM13 4.07v-.66c0-.89-1.08-1.34-1.71-.71L9.17 4.83c-.4.4-.4 1.04 0 1.43l2.13 2.08c.63.62 1.7.17 1.7-.72V6.09c2.84.48 5 2.94 5 5.91 0 2.73-1.82 5.02-4.32 5.75-.41.12-.68.51-.68.94v.02c0 .65.61 1.14 1.23.96C17.57 18.71 20 15.64 20 12c0-4.08-3.05-7.44-7-7.93z"
	}), 'RotateLeftRounded');
	
	exports.default = _default;

/***/ },
/* 5113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z"
	}), 'RotateLeftSharp');
	
	exports.default = _default;

/***/ },
/* 5114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 17.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91zm-7.31-1.02l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47H4.07c.17 1.39.72 2.73 1.62 3.89zm1.42-8.36L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM11 17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32c1.16.9 2.51 1.44 3.9 1.61V17.9z"
	}), 'RotateLeftTwoTone');
	
	exports.default = _default;

/***/ },
/* 5115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z"
	}), 'RotateRight');
	
	exports.default = _default;

/***/ },
/* 5116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z"
	}), 'RotateRightOutlined');
	
	exports.default = _default;

/***/ },
/* 5117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.83 4.83L12.7 2.7c-.62-.62-1.7-.18-1.7.71v.66C7.06 4.56 4 7.92 4 12c0 3.64 2.43 6.71 5.77 7.68.62.18 1.23-.32 1.23-.96v-.03c0-.43-.27-.82-.68-.94C7.82 17.03 6 14.73 6 12c0-2.97 2.16-5.43 5-5.91v1.53c0 .89 1.07 1.33 1.7.71l2.13-2.08c.4-.38.4-1.02 0-1.42zm4.84 4.93c-.16-.55-.38-1.08-.66-1.59-.31-.57-1.1-.66-1.56-.2l-.01.01c-.31.31-.38.78-.17 1.16.2.37.36.76.48 1.16.12.42.51.7.94.7h.02c.65 0 1.15-.62.96-1.24zM13 18.68v.02c0 .65.62 1.14 1.24.96.55-.16 1.08-.38 1.59-.66.57-.31.66-1.1.2-1.56l-.02-.02c-.31-.31-.78-.38-1.16-.17-.37.21-.76.37-1.16.49-.41.12-.69.51-.69.94zm4.44-2.65c.46.46 1.25.37 1.56-.2.28-.51.5-1.04.67-1.59.18-.62-.31-1.24-.96-1.24h-.02c-.44 0-.82.28-.94.7-.12.4-.28.79-.48 1.17-.21.38-.13.86.17 1.16z"
	}), 'RotateRightRounded');
	
	exports.default = _default;

/***/ },
/* 5118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z"
	}), 'RotateRightSharp');
	
	exports.default = _default;

/***/ },
/* 5119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45L11 1zm4.46 15.87c-.75.54-1.59.89-2.46 1.03v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44zm2.85.02c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48l1.42 1.41z"
	}), 'RotateRightTwoTone');
	
	exports.default = _default;

/***/ },
/* 5120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z"
	}), 'RoundedCorner');
	
	exports.default = _default;

/***/ },
/* 5121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z"
	}), 'RoundedCornerOutlined');
	
	exports.default = _default;

/***/ },
/* 5122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z"
	}), 'RoundedCornerRounded');
	
	exports.default = _default;

/***/ },
/* 5123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 3H11v2h8v8h2V3z"
	}), 'RoundedCornerSharp');
	
	exports.default = _default;

/***/ },
/* 5124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z"
	}), 'RoundedCornerTwoTone');
	
	exports.default = _default;

/***/ },
/* 5125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.2 5.9l.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2s3 .6 4.2 1.7zm-.9.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4l.8.8c.7-.7 1.6-1 2.5-1 .9 0 1.8.3 2.5 1l.8-.8zM19 13h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM8 18H6v-2h2v2zm3.5 0h-2v-2h2v2zm3.5 0h-2v-2h2v2z"
	}), 'Router');
	
	exports.default = _default;

/***/ },
/* 5126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 4.2c1.5 0 3 .6 4.2 1.7l.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2zm-3.3 2.5l.8.8c.7-.7 1.6-1 2.5-1s1.8.3 2.5 1l.8-.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4zM19 13h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zm0 6H5v-4h14v4zM6 16h2v2H6zm3.5 0h2v2h-2zm3.5 0h2v2h-2z"
	}), 'RouterOutlined');
	
	exports.default = _default;

/***/ },
/* 5127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.45 5.55c.19.19.5.21.72.04C13.3 4.69 14.65 4.2 16 4.2s2.7.49 3.84 1.39c.21.17.52.15.72-.04l.04-.05c.22-.22.21-.59-.03-.8C19.24 3.57 17.62 3 16 3s-3.24.57-4.57 1.7c-.24.21-.26.57-.03.8l.05.05zm1.7.76c-.25.2-.26.58-.04.8l.04.04c.2.2.5.2.72.04.63-.48 1.38-.69 2.13-.69s1.5.21 2.13.68c.22.17.53.16.72-.04l.04-.04c.23-.23.21-.6-.04-.8-.83-.64-1.84-1-2.85-1s-2.02.36-2.85 1.01zM19 13h-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v3H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM8 18H6v-2h2v2zm3.5 0h-2v-2h2v2zm3.5 0h-2v-2h2v2z"
	}), 'RouterRounded');
	
	exports.default = _default;

/***/ },
/* 5128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.2 5.9l.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2s3 .6 4.2 1.7zm-.9.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4l.8.8c.7-.7 1.6-1 2.5-1s1.8.3 2.5 1l.8-.8zM21 13h-4V9h-2v4H3v8h18v-8zM8 18H6v-2h2v2zm3.5 0h-2v-2h2v2zm3.5 0h-2v-2h2v2z"
	}), 'RouterSharp');
	
	exports.default = _default;

/***/ },
/* 5129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15 15H5v4h14v-4h-4zm-7 3H6v-2h2v2zm3.5 0h-2v-2h2v2zm3.5 0h-2v-2h2v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16 4.2c1.5 0 3 .6 4.2 1.7l.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2zm-3.3 2.5l.8.8c.7-.7 1.6-1 2.5-1s1.8.3 2.5 1l.8-.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4zM19 13h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zm0 6H5v-4h14v4zM6 16h2v2H6zm3.5 0h2v2h-2zm3.5 0h2v2h-2z"
	})), 'RouterTwoTone');
	
	exports.default = _default;

/***/ },
/* 5130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.35-.39.99-.73 1.65-.73h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z"
	}), 'Rowing');
	
	exports.default = _default;

/***/ },
/* 5131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.21.43-.38.69-.5.29-.14.62-.23.96-.23h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z"
	}), 'RowingOutlined');
	
	exports.default = _default;

/***/ },
/* 5132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.75 18.25c-.41.41-.41 1.09 0 1.5.41.41 1.09.41 1.5 0L9 17h2l-2.5-2.5-3.75 3.75zM15 5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm5.29 15.3l-2-2.01c-.18-.18-.44-.29-.71-.29H16.5l-6.29-6.29c.79-.33 1.66-.87 2.29-1.39v2.27l3.58 3.58c.57-.55.92-1.32.92-2.16V8.26C17 7.02 15.98 6 14.74 6h-.02c-.34 0-.67.09-.96.23-.26.12-.5.29-.69.5l-1.4 1.55C10.61 9.45 8.66 10.35 7 10.32c-.6 0-1.08.48-1.08 1.08 0 .6.48 1.08 1.08 1.08.31 0 .61-.03.9-.07l7.11 7.09v1.08c0 .26.1.52.29.7l1.99 2.01c.39.39 1.02.39 1.42 0l1.58-1.58c.39-.38.39-1.02 0-1.41z"
	}), 'RowingRounded');
	
	exports.default = _default;

/***/ },
/* 5133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.21.43-.38.69-.5.29-.14.62-.23.96-.23h.03C15.99 6 17 7.01 17 8.25V17l-.92-.83-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z"
	}), 'RowingSharp');
	
	exports.default = _default;

/***/ },
/* 5134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.21.43-.38.69-.5.29-.14.62-.23.96-.23h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z"
	}), 'RowingTwoTone');
	
	exports.default = _default;

/***/ },
/* 5135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "6.18",
	  cy: "17.82",
	  r: "2.18"
	}), _react.default.createElement("path", {
	  d: "M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z"
	})), 'RssFeed');
	
	exports.default = _default;

/***/ },
/* 5136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "6.18",
	  cy: "17.82",
	  r: "2.18"
	}), _react.default.createElement("path", {
	  d: "M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z"
	})), 'RssFeedOutlined');
	
	exports.default = _default;

/***/ },
/* 5137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "6.18",
	  cy: "17.82",
	  r: "2.18"
	}), _react.default.createElement("path", {
	  d: "M5.59 10.23c-.84-.14-1.59.55-1.59 1.4 0 .71.53 1.28 1.23 1.4 2.92.51 5.22 2.82 5.74 5.74.12.7.69 1.23 1.4 1.23.85 0 1.54-.75 1.41-1.59-.68-4.2-3.99-7.51-8.19-8.18zm-.03-5.71C4.73 4.43 4 5.1 4 5.93c0 .73.55 1.33 1.27 1.4 6.01.6 10.79 5.38 11.39 11.39.07.73.67 1.28 1.4 1.28.84 0 1.5-.73 1.42-1.56-.73-7.34-6.57-13.19-13.92-13.92z"
	})), 'RssFeedRounded');
	
	exports.default = _default;

/***/ },
/* 5138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "6.18",
	  cy: "17.82",
	  r: "2.18"
	}), _react.default.createElement("path", {
	  d: "M4 10.1v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9zm0-5.66v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56z"
	})), 'RssFeedSharp');
	
	exports.default = _default;

/***/ },
/* 5139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "6.18",
	  cy: "17.82",
	  r: "2.18"
	}), _react.default.createElement("path", {
	  d: "M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z"
	})), 'RssFeedTwoTone');
	
	exports.default = _default;

/***/ },
/* 5140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3z"
	}), 'RvHookup');
	
	exports.default = _default;

/***/ },
/* 5141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3-3-3z"
	}), 'RvHookupOutlined');
	
	exports.default = _default;

/***/ },
/* 5142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 17h-1v-6c0-1.1-.9-2-2-2H7v-.74c0-.46-.56-.7-.89-.37L4.37 9.63c-.2.2-.2.53 0 .74l1.74 1.74c.33.33.89.1.89-.37V11h4v3H5c-.55 0-1 .45-1 1v2c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h7c.55 0 1-.45 1-1s-.45-1-1-1zm-10 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h3c.55 0 1 .45 1 1v2zm-8-8h7v.74c0 .46.56.7.89.37l1.74-1.74c.2-.2.2-.53 0-.74l-1.74-1.74c-.33-.33-.89-.1-.89.37V4h-7c-.55 0-1 .45-1 1s.45 1 1 1z"
	}), 'RvHookupRounded');
	
	exports.default = _default;

/***/ },
/* 5143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 17V9H7V7l-3 3 3 3v-2h4v3H4v5h4c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3-3-3z"
	}), 'RvHookupSharp');
	
	exports.default = _default;

/***/ },
/* 5144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3-3-3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3-3-3z"
	})), 'RvHookupTwoTone');
	
	exports.default = _default;

/***/ },
/* 5145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.99h3C8 6.65 6.66 8 5 8V4.99zM5 12v-2c2.76 0 5-2.25 5-5.01h2C12 8.86 8.87 12 5 12zm0 6l3.5-4.5 2.5 3.01L14.5 12l4.5 6H5z"
	}), 'Satellite');
	
	exports.default = _default;

/***/ },
/* 5146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM8.57 6H6v2.58c1.42 0 2.57-1.16 2.57-2.58zM12 6h-1.71c0 2.36-1.92 4.29-4.29 4.29V12c3.32 0 6-2.69 6-6zm2.14 5.86l-3 3.87L9 13.15 6 17h12z"
	}), 'SatelliteOutlined');
	
	exports.default = _default;

/***/ },
/* 5147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 5h3c0 1.66-1.34 3-3 3V5zm0 5.91c0-.49.36-.9.85-.98 2.08-.36 3.72-2 4.08-4.08.08-.49.49-.85.98-.85.61 0 1.09.53 1 1.13-.48 2.96-2.81 5.3-5.77 5.78-.6.1-1.14-.39-1.14-1zm.63 6.28l2.49-3.2c.2-.25.58-.26.78-.01l2.1 2.53 3.1-3.99c.2-.26.6-.26.8.01l3.51 4.68c.25.33.01.8-.4.8H6.02c-.41-.01-.65-.49-.39-.82z"
	}), 'SatelliteRounded');
	
	exports.default = _default;

/***/ },
/* 5148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zM5 4.99h3C8 6.65 6.66 8 5 8V4.99zM5 12v-2c2.76 0 5-2.25 5-5.01h2C12 8.86 8.87 12 5 12zm0 6l3.5-4.5 2.5 3.01L14.5 12l4.5 6H5z"
	}), 'SatelliteSharp');
	
	exports.default = _default;

/***/ },
/* 5149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14V5H5v14zM6 6h2.57c0 1.42-1.15 2.58-2.57 2.58V6zm0 4.29c2.37 0 4.28-1.93 4.28-4.29H12c0 3.31-2.68 6-6 6v-1.71zm3 2.86l2.14 2.58 3-3.86L18 17H6l3-3.85z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM8.57 6H6v2.58c1.42 0 2.57-1.16 2.57-2.58zM12 6h-1.72c0 2.36-1.91 4.29-4.28 4.29V12c3.32 0 6-2.69 6-6zm2.14 5.86l-3 3.87L9 13.15 6 17h12z"
	})), 'SatelliteTwoTone');
	
	exports.default = _default;

/***/ },
/* 5150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"
	}), 'Save');
	
	exports.default = _default;

/***/ },
/* 5151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
	}), 'SaveAlt');
	
	exports.default = _default;

/***/ },
/* 5152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2v9.67z"
	}), 'SaveAltOutlined');
	
	exports.default = _default;

/***/ },
/* 5153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 13v5c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-5c0-.55-.45-1-1-1s-1 .45-1 1v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6c0-.55-.45-1-1-1s-1 .45-1 1zm-6-.33l1.88-1.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-3.59 3.59c-.39.39-1.02.39-1.41 0L7.7 12.2a.9959.9959 0 010-1.41c.39-.39 1.02-.39 1.41 0L11 12.67V4c0-.55.45-1 1-1s1 .45 1 1v8.67z"
	}), 'SaveAltRounded');
	
	exports.default = _default;

/***/ },
/* 5154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 12v7H5v-7H3v9h18v-9h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2v9.67z"
	}), 'SaveAltSharp');
	
	exports.default = _default;

/***/ },
/* 5155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2v9.67z"
	}), 'SaveAltTwoTone');
	
	exports.default = _default;

/***/ },
/* 5156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm2 16H5V5h11.17L19 7.83V19zm-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zM6 6h9v4H6z"
	}), 'SaveOutlined');
	
	exports.default = _default;

/***/ },
/* 5157 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.59 3.59c-.38-.38-.89-.59-1.42-.59H5c-1.11 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7.83c0-.53-.21-1.04-.59-1.41l-2.82-2.83zM12 19c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm1-10H7c-1.1 0-2-.9-2-2s.9-2 2-2h6c1.1 0 2 .9 2 2s-.9 2-2 2z"
	}), 'SaveRounded');
	
	exports.default = _default;

/***/ },
/* 5158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H3v18h18V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"
	}), 'SaveSharp');
	
	exports.default = _default;

/***/ },
/* 5159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 5v14h14V7.83L16.17 5H5zm7 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-8H6V6h9v4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm2 16H5V5h11.17L19 7.83V19zm-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zM6 6h9v4H6z"
	})), 'SaveTwoTone');
	
	exports.default = _default;

/***/ },
/* 5160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.8 10.7L4.2 5l-.7 1.9L17.6 12H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5.5c0-.8-.5-1.6-1.2-1.8zM7 17H5v-2h2v2zm12 0H9v-2h10v2z"
	}), 'Scanner');
	
	exports.default = _default;

/***/ },
/* 5161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.8 10.7L4.2 5l-.7 1.9L17.6 12H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5.5c0-.8-.5-1.6-1.2-1.8zM19 18H5v-4h14v4zM6 15h2v2H6zm4 0h8v2h-8z"
	}), 'ScannerOutlined');
	
	exports.default = _default;

/***/ },
/* 5162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.8 10.7L5.15 5.35c-.52-.19-1.1.08-1.3.6-.19.53.08 1.11.6 1.3L17.6 12H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5.5c0-.8-.5-1.6-1.2-1.8zM7 17H5v-2h2v2zm11 0h-8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'ScannerRounded');
	
	exports.default = _default;

/***/ },
/* 5163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.2 5l-.7 1.9L17.6 12H3v8h18v-8.86L4.2 5zM7 17H5v-2h2v2zm12 0H9v-2h10v2z"
	}), 'ScannerSharp');
	
	exports.default = _default;

/***/ },
/* 5164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 14v4h14v-4H5zm3 3H6v-2h2v2zm10 0h-8v-2h8v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19.8 10.7L4.2 5l-.7 1.9L17.6 12H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5.5c0-.8-.5-1.6-1.2-1.8zM19 18H5v-4h14v4zM6 15h2v2H6zm4 0h8v2h-8z"
	})), 'ScannerTwoTone');
	
	exports.default = _default;

/***/ },
/* 5165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "7",
	  cy: "14",
	  r: "3"
	}), _react.default.createElement("circle", {
	  cx: "11",
	  cy: "6",
	  r: "3"
	}), _react.default.createElement("circle", {
	  cx: "16.6",
	  cy: "17.6",
	  r: "3"
	})), 'ScatterPlot');
	
	exports.default = _default;

/***/ },
/* 5166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 18c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-2c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm5.6 17.6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'ScatterPlotOutlined');
	
	exports.default = _default;

/***/ },
/* 5167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "7",
	  cy: "14",
	  r: "3"
	}), _react.default.createElement("circle", {
	  cx: "11",
	  cy: "6",
	  r: "3"
	}), _react.default.createElement("circle", {
	  cx: "16.6",
	  cy: "17.6",
	  r: "3"
	})), 'ScatterPlotRounded');
	
	exports.default = _default;

/***/ },
/* 5168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "7",
	  cy: "14",
	  r: "3"
	}), _react.default.createElement("circle", {
	  cx: "11",
	  cy: "6",
	  r: "3"
	}), _react.default.createElement("circle", {
	  cx: "16.6",
	  cy: "17.6",
	  r: "3"
	})), 'ScatterPlotSharp');
	
	exports.default = _default;

/***/ },
/* 5169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "11",
	  cy: "6",
	  r: "2",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "16.6",
	  cy: "17.6",
	  r: "2",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "7",
	  cy: "14",
	  r: "2",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M7 10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm8-10c0-2.21-1.79-4-4-4S7 3.79 7 6s1.79 4 4 4 4-1.79 4-4zm-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm5.6 5.6c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	})), 'ScatterPlotTwoTone');
	
	exports.default = _default;

/***/ },
/* 5170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), _react.default.createElement("path", {
	  d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
	})), 'Schedule');
	
	exports.default = _default;

/***/ },
/* 5171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
	}), 'ScheduleOutlined');
	
	exports.default = _default;

/***/ },
/* 5172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-.22-13h-.06c-.4 0-.72.32-.72.72v4.72c0 .35.18.68.49.86l4.15 2.49c.34.2.78.1.98-.24.21-.34.1-.79-.25-.99l-3.87-2.3V7.72c0-.4-.32-.72-.72-.72z"
	}), 'ScheduleRounded');
	
	exports.default = _default;

/***/ },
/* 5173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
	}), 'ScheduleSharp');
	
	exports.default = _default;

/***/ },
/* 5174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm4.25 12.15L11 13V7h1.5v5.25l4.5 2.67-.75 1.23z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
	})), 'ScheduleTwoTone');
	
	exports.default = _default;

/***/ },
/* 5175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"
	}), 'School');
	
	exports.default = _default;

/***/ },
/* 5176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z"
	}), 'SchoolOutlined');
	
	exports.default = _default;

/***/ },
/* 5177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 13.18v2.81c0 .73.4 1.41 1.04 1.76l5 2.73c.6.33 1.32.33 1.92 0l5-2.73c.64-.35 1.04-1.03 1.04-1.76v-2.81l-6.04 3.3c-.6.33-1.32.33-1.92 0L5 13.18zm6.04-9.66l-8.43 4.6c-.69.38-.69 1.38 0 1.76l8.43 4.6c.6.33 1.32.33 1.92 0L21 10.09V16c0 .55.45 1 1 1s1-.45 1-1V9.59c0-.37-.2-.7-.52-.88l-9.52-5.19a2.04 2.04 0 00-1.92 0z"
	}), 'SchoolRounded');
	
	exports.default = _default;

/***/ },
/* 5178 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"
	}), 'SchoolSharp');
	
	exports.default = _default;

/***/ },
/* 5179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 12.27v3.72l5 2.73 5-2.73v-3.72L12 15zM5.18 9L12 12.72 18.82 9 12 5.28z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm5 12.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72zm-5-3.27L5.18 9 12 5.28 18.82 9 12 12.72z"
	})), 'SchoolTwoTone');
	
	exports.default = _default;

/***/ },
/* 5180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 2h1.5v3l2-3h1.7l-2 3 2 3h-1.7l-2-3v3H12V5zM7 7.25h2.5V6.5H7V5h4v3.75H8.5v.75H11V11H7V7.25zM19 13l-6 6-4-4-4 4v-2.5l4-4 4 4 6-6V13z"
	}), 'Score');
	
	exports.default = _default;

/***/ },
/* 5181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5l4-4 4 4 6-6v6zm0-8.5l-6 6-4-4-4 4V5h14v5.5zM13.5 9V6H12v6h1.5zm3.7 3l-2-3 2-3h-1.7l-2 3 2 3zM11 10.5H8.5v-.75H11V6H7v1.5h2.5v.75H7V12h4z"
	}), 'ScoreOutlined');
	
	exports.default = _default;

/***/ },
/* 5182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 2.75c0-.41.34-.75.75-.75s.75.34.75.75V8l1.79-2.69c.13-.19.35-.31.59-.31.56 0 .9.63.59 1.1L15.2 8l1.27 1.9c.31.47-.02 1.1-.59 1.1-.24 0-.46-.12-.59-.31L13.5 8v2.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-4.5zm-5 2.5c0-.55.45-1 1-1h1.5V6.5H7.75c-.41 0-.75-.34-.75-.75S7.34 5 7.75 5H10c.55 0 1 .45 1 1v1.75c0 .55-.45 1-1 1H8.5v.75h1.75c.41 0 .75.34.75.75s-.34.75-.75.75H8c-.55 0-1-.45-1-1V8.25zm11.74 5.01l-5.03 5.03c-.39.39-1.02.39-1.41 0L9 15l-2.49 2.49c-.56.56-1.51.16-1.51-.62 0-.23.09-.46.26-.62l3.03-3.03c.39-.39 1.02-.39 1.41 0L13 16.5l4.49-4.49c.56-.56 1.51-.16 1.51.62 0 .24-.09.46-.26.63z"
	}), 'ScoreRounded');
	
	exports.default = _default;

/***/ },
/* 5183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3v18h18V3zm-9 2h1.5v3l2-3h1.7l-2 3 2 3h-1.7l-2-3v3H12V5zM7 7.25h2.5V6.5H7V5h4v3.75H8.5v.75H11V11H7V7.25zM19 13l-6 6-4-4-4 4v-2.5l4-4 4 4 6-6V13z"
	}), 'ScoreSharp');
	
	exports.default = _default;

/***/ },
/* 5184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h8l-4-4zm0-2.5l4-4 4 4 6-6V5H5v11.5zM12 6h1.5v3l2-3h1.7l-2 3 2 3h-1.7l-2-3v3H12V6zM7 8.25h2.5V7.5H7V6h4v3.75H8.5v.75H11V12H7V8.25zM19 19v-6l-6 6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5l4-4 4 4 6-6v6zm0-8.5l-6 6-4-4-4 4V5h14v5.5zM13.5 9V6H12v6h1.5zm3.7 3l-2-3 2-3h-1.7l-2 3 2 3zM11 10.5H8.5v-.75H11V6H7v1.5h2.5v.75H7V12h4z"
	})), 'ScoreTwoTone');
	
	exports.default = _default;

/***/ },
/* 5185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10zm-9-1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1z"
	}), 'ScreenLockLandscape');
	
	exports.default = _default;

/***/ },
/* 5186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10zm-9-1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2v1h-2.4v-1z"
	}), 'ScreenLockLandscapeOutlined');
	
	exports.default = _default;

/***/ },
/* 5187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10zm-9-1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2v1h-2.4v-1z"
	}), 'ScreenLockLandscapeRounded');
	
	exports.default = _default;

/***/ },
/* 5188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 5H1v14h22V5zm-4 12H5V7h14v10zM9 16h6v-5h-1v-.9c0-1-.69-1.92-1.68-2.08C11.07 7.83 10 8.79 10 10v1H9v5zm1.8-6c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2v1h-2.4v-1z"
	}), 'ScreenLockLandscapeSharp');
	
	exports.default = _default;

/***/ },
/* 5189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M13.2 10c0-.66-.54-1.2-1.2-1.2s-1.2.54-1.2 1.2v1h2.4v-1zM5 17h14V7H5v10zm4-5c0-.55.45-1 1-1v-1c0-1.1.89-2 2-2 1.1 0 2 .89 2 2v1c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1v-3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M10 16h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2v1h-2.4v-1zM21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10z"
	})), 'ScreenLockLandscapeTwoTone');
	
	exports.default = _default;

/***/ },
/* 5190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 16h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1zM17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z"
	}), 'ScreenLockPortrait');
	
	exports.default = _default;

/***/ },
/* 5191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 16h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2v1h-2.4v-1zM17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z"
	}), 'ScreenLockPortraitOutlined');
	
	exports.default = _default;

/***/ },
/* 5192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 16h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2v1h-2.4v-1zM17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z"
	}), 'ScreenLockPortraitRounded');
	
	exports.default = _default;

/***/ },
/* 5193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 16h6v-5h-1v-.9c0-1-.69-1.92-1.68-2.08C11.07 7.83 10 8.79 10 10v1H9v5zm1.8-6c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2v1h-2.4v-1zM19 1H5v22h14V1zm-2 18H7V5h10v14z"
	}), 'ScreenLockPortraitSharp');
	
	exports.default = _default;

/***/ },
/* 5194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M13.2 10c0-.66-.54-1.2-1.2-1.2s-1.2.54-1.2 1.2v1h2.4v-1zM7 19h10V5H7v14zm2-7c0-.55.45-1 1-1v-1c0-1.1.89-2 2-2 1.1 0 2 .89 2 2v1c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1v-3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M10 16h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2v1h-2.4v-1zM17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z"
	})), 'ScreenLockPortraitTwoTone');
	
	exports.default = _default;

/***/ },
/* 5195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23.25 12.77l-2.57-2.57-1.41 1.41 2.22 2.22-5.66 5.66L4.51 8.17l5.66-5.66 2.1 2.1 1.41-1.41L11.23.75c-.59-.59-1.54-.59-2.12 0L2.75 7.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12zM8.47 20.48C5.2 18.94 2.86 15.76 2.5 12H1c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.82-1.33 1.33zM16 9h5c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1v-.5C21 1.12 19.88 0 18.5 0S16 1.12 16 2.5V3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.8-6.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V3h-3.4v-.5z"
	}), 'ScreenLockRotation');
	
	exports.default = _default;

/***/ },
/* 5196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22.3 13.77l-2.57-2.57-1.41 1.41 2.22 2.22-5.66 5.66L3.56 9.17l5.66-5.66 2.1 2.1 1.41-1.41-2.45-2.45c-.59-.59-1.54-.59-2.12 0L1.8 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12zM7.52 21.48C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.82-1.33 1.33zM15.05 10h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1v-.5c0-1.38-1.12-2.5-2.5-2.5s-2.5 1.12-2.5 2.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.8-6.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4h-3.4v-.5z"
	}), 'ScreenLockRotationOutlined');
	
	exports.default = _default;

/***/ },
/* 5197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22.3 13.77l-1.86-1.87a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l1.51 1.52-5.66 5.66L3.56 9.17l5.66-5.66 1.4 1.4c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41l-1.75-1.75c-.59-.59-1.54-.59-2.12 0L1.8 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12zM15.05 10h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1v-.5c0-1.38-1.12-2.5-2.5-2.5s-2.5 1.12-2.5 2.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.8-6.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4h-3.4v-.5zm-7 16.65l-1.33 1.33c-3.09-1.46-5.34-4.37-5.89-7.86-.06-.41-.44-.69-.86-.62-.41.06-.69.45-.62.86.6 3.81 2.96 7.01 6.24 8.75 1.57.83 3.55 1.43 5.8 1.38.18 0 .26-.22.14-.35l-3.48-3.49z"
	}), 'ScreenLockRotationRounded');
	
	exports.default = _default;

/***/ },
/* 5198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.52 21.48C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.82-1.33 1.33zM20.05 4v-.36c0-1.31-.94-2.5-2.24-2.63-1.5-.15-2.76 1.02-2.76 2.49V4h-1v6h7V4h-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4zm.48 7.2l-1.41 1.41 2.22 2.22-5.66 5.66L3.56 9.17l5.66-5.66 2.1 2.1 1.41-1.41L9.22.69.74 9.17l14.14 14.14 8.48-8.48z"
	}), 'ScreenLockRotationSharp');
	
	exports.default = _default;

/***/ },
/* 5199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22.3 13.77l-2.57-2.57-1.41 1.41 2.22 2.22-5.66 5.66L3.56 9.17l5.66-5.66 2.1 2.1 1.41-1.41-2.45-2.45c-.59-.59-1.54-.59-2.12 0L1.8 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12zM7.52 21.48C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.82-1.33 1.33zM15.05 10h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1v-.5c0-1.38-1.12-2.5-2.5-2.5s-2.5 1.12-2.5 2.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.8-6.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4h-3.4v-.5z"
	}), 'ScreenLockRotationTwoTone');
	
	exports.default = _default;

/***/ },
/* 5200 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z"
	}), 'ScreenRotation');
	
	exports.default = _default;

/***/ },
/* 5201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z"
	}), 'ScreenRotationOutlined');
	
	exports.default = _default;

/***/ },
/* 5202 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.23 1.75c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm3.89 18.73L3.52 9.88a.9959.9959 0 010-1.41l4.95-4.95c.39-.39 1.02-.39 1.41 0l10.61 10.61c.39.39.39 1.02 0 1.41l-4.95 4.95c-.39.38-1.03.38-1.42-.01zM17.61 1.4C16.04.57 14.06-.03 11.81.02c-.18 0-.26.22-.14.35l3.48 3.48 1.33-1.33c3.09 1.46 5.34 4.37 5.89 7.86.06.41.44.69.86.62.41-.06.69-.45.62-.86-.6-3.8-2.96-7-6.24-8.74zM8.85 20.16l-1.33 1.33c-3.09-1.46-5.34-4.37-5.89-7.86-.06-.41-.44-.69-.86-.62-.41.06-.69.45-.62.86.6 3.81 2.96 7.01 6.24 8.75 1.57.83 3.55 1.43 5.8 1.38.18 0 .26-.22.14-.35l-3.48-3.49z"
	}), 'ScreenRotationRounded');
	
	exports.default = _default;

/***/ },
/* 5203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zM7.52 21.48C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32zM9.17.69L.69 9.17l14.14 14.14 8.48-8.48L9.17.69zm5.66 20.5L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36z"
	}), 'ScreenRotationSharp');
	
	exports.default = _default;

/***/ },
/* 5204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14.828 21.192L2.808 9.172l6.357-6.357 12.02 12.02z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z"
	})), 'ScreenRotationTwoTone');
	
	exports.default = _default;

/***/ },
/* 5205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.11-.9-2-2-2H4c-1.11 0-2 .89-2 2v10c0 1.1.89 2 2 2H0v2h24v-2h-4zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74z"
	}), 'ScreenShare');
	
	exports.default = _default;

/***/ },
/* 5206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.11-.9-2-2-2H4c-1.11 0-2 .89-2 2v10c0 1.1.89 2 2 2H0v2h24v-2h-4zM4 16V6h16v10.01L4 16zm9-6.87c-3.89.54-5.44 3.2-6 5.87 1.39-1.87 3.22-2.72 6-2.72v2.19l4-3.74L13 7v2.13z"
	}), 'ScreenShareOutlined');
	
	exports.default = _default;

/***/ },
/* 5207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.89 2 2 2H1c-.55 0-1 .45-1 1s.45 1 1 1h22c.55 0 1-.45 1-1s-.45-1-1-1h-3zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l3.61 3.36c.21.2.21.53 0 .73L13 14.47z"
	}), 'ScreenShareRounded');
	
	exports.default = _default;

/***/ },
/* 5208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18l2-2V4H2v12l2 2H0v2h24v-2h-4zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74z"
	}), 'ScreenShareSharp');
	
	exports.default = _default;

/***/ },
/* 5209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 16V6H4v10.01L20 16zm-7-1.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.11-.9-2-2-2H4c-1.11 0-2 .89-2 2v10c0 1.1.89 2 2 2H0v2h24v-2h-4zM4 16V6h16v10.01L4 16zm9-6.87c-3.89.54-5.44 3.2-6 5.87 1.39-1.87 3.22-2.72 6-2.72v2.19l4-3.74L13 7v2.13z"
	})), 'ScreenShareTwoTone');
	
	exports.default = _default;

/***/ },
/* 5210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z"
	}), 'SdCard');
	
	exports.default = _default;

/***/ },
/* 5211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 2h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H6V8.83L10.83 4H18v16zM9 7h2v4H9zm3 0h2v4h-2zm3 0h2v4h-2z"
	}), 'SdCardOutlined');
	
	exports.default = _default;

/***/ },
/* 5212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 2h-7.17c-.53 0-1.04.21-1.42.59L4.6 7.42c-.37.37-.6.88-.6 1.4V20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 6c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm3 0c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm3 0c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1z"
	}), 'SdCardRounded');
	
	exports.default = _default;

/***/ },
/* 5213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H10L4 8v14h16V2zm-8 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z"
	}), 'SdCardSharp');
	
	exports.default = _default;

/***/ },
/* 5214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 8.83V20h12V4h-7.17L6 8.83zM15 7h2v4h-2V7zm-3 0h2v4h-2V7zm-1 4H9V7h2v4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 2h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H6V8.83L10.83 4H18v16zM9 7h2v4H9zm3 0h2v4h-2zm3 0h2v4h-2z"
	})), 'SdCardTwoTone');
	
	exports.default = _default;

/***/ },
/* 5215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z"
	}), 'SdStorage');
	
	exports.default = _default;

/***/ },
/* 5216 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4v16H6V8.83L10.83 4H18m0-2h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 7h2v4H9zm3 0h2v4h-2zm3 0h2v4h-2z"
	}), 'SdStorageOutlined');
	
	exports.default = _default;

/***/ },
/* 5217 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 2h-7.17c-.53 0-1.04.21-1.42.59L4.6 7.42c-.37.37-.6.88-.6 1.4V20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 6c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm3 0c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm3 0c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1z"
	}), 'SdStorageRounded');
	
	exports.default = _default;

/***/ },
/* 5218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H10L4 8v14h16V2zm-8 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z"
	}), 'SdStorageSharp');
	
	exports.default = _default;

/***/ },
/* 5219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 8.83V20h12V4h-7.17L6 8.83zM15 7h2v4h-2V7zm-3 0h2v4h-2V7zm-1 4H9V7h2v4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 2h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H6V8.83L10.83 4H18v16zM9 7h2v4H9zm3 0h2v4h-2zm3 0h2v4h-2z"
	})), 'SdStorageTwoTone');
	
	exports.default = _default;

/***/ },
/* 5220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
	}), 'Search');
	
	exports.default = _default;

/***/ },
/* 5221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
	}), 'SearchOutlined');
	
	exports.default = _default;

/***/ },
/* 5222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 14h-.79l-.28-.27c1.2-1.4 1.82-3.31 1.48-5.34-.47-2.78-2.79-5-5.59-5.34-4.23-.52-7.79 3.04-7.27 7.27.34 2.8 2.56 5.12 5.34 5.59 2.03.34 3.94-.28 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
	}), 'SearchRounded');
	
	exports.default = _default;

/***/ },
/* 5223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
	}), 'SearchSharp');
	
	exports.default = _default;

/***/ },
/* 5224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
	}), 'SearchTwoTone');
	
	exports.default = _default;

/***/ },
/* 5225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
	}), 'Security');
	
	exports.default = _default;

/***/ },
/* 5226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
	}), 'SecurityOutlined');
	
	exports.default = _default;

/***/ },
/* 5227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.19 1.36l-7 3.11C3.47 4.79 3 5.51 3 6.3V11c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V6.3c0-.79-.47-1.51-1.19-1.83l-7-3.11c-.51-.23-1.11-.23-1.62 0zM12 11.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
	}), 'SecurityRounded');
	
	exports.default = _default;

/***/ },
/* 5228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
	}), 'SecuritySharp');
	
	exports.default = _default;

/***/ },
/* 5229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 3.19L5 6.3V12h7v8.93c3.72-1.15 6.47-4.82 7-8.94h-7v-8.8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 19.93V12H5V6.3l7-3.11v8.8h7c-.53 4.12-3.28 7.79-7 8.94z"
	})), 'SecurityTwoTone');
	
	exports.default = _default;

/***/ },
/* 5230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z"
	}), 'SelectAll');
	
	exports.default = _default;

/***/ },
/* 5231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z"
	}), 'SelectAllOutlined');
	
	exports.default = _default;

/***/ },
/* 5232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM8 17h8c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1zm1-8h6v6H9V9z"
	}), 'SelectAllRounded');
	
	exports.default = _default;

/***/ },
/* 5233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 13h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zM3 17h2v-2H3v2zM9 3H7v2h2V3zM5 3H3v2h2V3zm6 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0-4h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zm4 0h2V3h-2v2zm0 16h2v-2h-2v2zM3 21h2v-2H3v2zm4-4h10V7H7v10zm2-8h6v6H9V9z"
	}), 'SelectAllSharp');
	
	exports.default = _default;

/***/ },
/* 5234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z"
	}), 'SelectAllTwoTone');
	
	exports.default = _default;

/***/ },
/* 5235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
	}), 'Send');
	
	exports.default = _default;

/***/ },
/* 5236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.01 6.03l7.51 3.22-7.52-1 .01-2.22m7.5 8.72L4 17.97v-2.22l7.51-1M2.01 3L2 10l15 2-15 2 .01 7L23 12 2.01 3z"
	}), 'SendOutlined');
	
	exports.default = _default;

/***/ },
/* 5237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.4 20.4l17.45-7.48c.81-.35.81-1.49 0-1.84L3.4 3.6c-.66-.29-1.39.2-1.39.91L2 9.12c0 .5.37.93.87.99L17 12 2.87 13.88c-.5.07-.87.5-.87 1l.01 4.61c0 .71.73 1.2 1.39.91z"
	}), 'SendRounded');
	
	exports.default = _default;

/***/ },
/* 5238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2 .01 7z"
	}), 'SendSharp');
	
	exports.default = _default;

/***/ },
/* 5239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 8.25l7.51 1-7.5-3.22zm.01 9.72l7.5-3.22-7.51 1z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M2.01 3L2 10l15 2-15 2 .01 7L23 12 2.01 3zM4 8.25V6.03l7.51 3.22-7.51-1zm.01 9.72v-2.22l7.51-1-7.51 3.22z"
	})), 'SendTwoTone');
	
	exports.default = _default;

/***/ },
/* 5240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-3.5c.73 0 1.39.19 1.97.53.12-.14.86-.98 1.01-1.14-.85-.56-1.87-.89-2.98-.89-1.11 0-2.13.33-2.99.88.97 1.09.01.02 1.01 1.14.59-.33 1.25-.52 1.98-.52z"
	})), 'SentimentDissatisfied');
	
	exports.default = _default;

/***/ },
/* 5241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M12 14c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5zm-.01-12C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	})), 'SentimentDissatisfiedOutlined');
	
	exports.default = _default;

/***/ },
/* 5242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-1.9 0-3.63.97-4.65 2.58-.22.35-.11.81.24 1.03.35.22.81.11 1.03-.24.74-1.18 2-1.88 3.38-1.88s2.64.7 3.38 1.88c.14.23.39.35.64.35.14 0 .27-.04.4-.11.35-.22.46-.68.24-1.03C15.63 14.96 13.9 14 12 14z"
	})), 'SentimentDissatisfiedRounded');
	
	exports.default = _default;

/***/ },
/* 5243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M12 14c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5zm-.01-12C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	})), 'SentimentDissatisfiedSharp');
	
	exports.default = _default;

/***/ },
/* 5244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3.5 4c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-7 0c.83 0 1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5 7.67 8 8.5 8zm6.95 9.5c-.7-1.19-1.97-2-3.45-2s-2.76.81-3.45 2H6.88C7.68 15.45 9.67 14 12 14s4.32 1.45 5.12 3.5h-1.67z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z"
	})), 'SentimentDissatisfiedTwoTone');
	
	exports.default = _default;

/***/ },
/* 5245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-.73 0-1.38-.18-1.96-.52-.12.14-.86.98-1.01 1.15.86.55 1.87.87 2.97.87 1.11 0 2.12-.33 2.98-.88-.97-1.09-.01-.02-1.01-1.15-.59.35-1.24.53-1.97.53z"
	})), 'SentimentSatisfied');
	
	exports.default = _default;

/***/ },
/* 5246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-2.5c2.33 0 4.32-1.45 5.12-3.5h-1.67c-.69 1.19-1.97 2-3.45 2s-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5z"
	})), 'SentimentSatisfiedAlt');
	
	exports.default = _default;

/***/ },
/* 5247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M12 16c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.69 1.19-1.97 2-3.45 2zm-.01-14C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	})), 'SentimentSatisfiedAltOutlined');
	
	exports.default = _default;

/***/ },
/* 5248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4.41-6.11c-.35-.22-.82-.11-1.03.24-.74 1.17-2 1.87-3.38 1.87s-2.64-.7-3.38-1.88c-.22-.35-.68-.46-1.03-.24-.35.22-.46.68-.24 1.03C8.37 16.54 10.1 17.5 12 17.5s3.63-.97 4.65-2.58c.22-.35.11-.81-.24-1.03z"
	})), 'SentimentSatisfiedAltRounded');
	
	exports.default = _default;

/***/ },
/* 5249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.69 1.19-1.97 2-3.45 2z"
	})), 'SentimentSatisfiedAltSharp');
	
	exports.default = _default;

/***/ },
/* 5250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3.5 4c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-7 0c.83 0 1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5 7.67 8 8.5 8zm3.5 9.5c-2.33 0-4.32-1.45-5.12-3.5h1.67c.7 1.19 1.97 2 3.45 2s2.76-.81 3.45-2h1.67c-.8 2.05-2.79 3.5-5.12 3.5z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M12 16c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.69 1.19-1.97 2-3.45 2zm-.01-14C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	})), 'SentimentSatisfiedAltTwoTone');
	
	exports.default = _default;

/***/ },
/* 5251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M12 16c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.7 1.19-1.97 2-3.45 2zm-.01-14C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	})), 'SentimentSatisfiedOutlined');
	
	exports.default = _default;

/***/ },
/* 5252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4.41-6.11c-.35-.22-.82-.11-1.03.24-.74 1.17-2 1.87-3.38 1.87s-2.64-.7-3.38-1.88c-.22-.35-.68-.46-1.03-.24-.35.22-.46.68-.24 1.03C8.37 16.54 10.1 17.5 12 17.5s3.63-.97 4.65-2.58c.22-.35.11-.81-.24-1.03z"
	})), 'SentimentSatisfiedRounded');
	
	exports.default = _default;

/***/ },
/* 5253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.7 1.19-1.97 2-3.45 2z"
	})), 'SentimentSatisfiedSharp');
	
	exports.default = _default;

/***/ },
/* 5254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3.5 4c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-7 0c.83 0 1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5 7.67 8 8.5 8zm3.5 9.5c-2.33 0-4.32-1.45-5.12-3.5h1.67c.7 1.19 1.97 2 3.45 2s2.75-.81 3.45-2h1.67c-.8 2.05-2.79 3.5-5.12 3.5z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M12 16c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.7 1.19-1.97 2-3.45 2zm-.01-14C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	})), 'SentimentSatisfiedTwoTone');
	
	exports.default = _default;

/***/ },
/* 5255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z"
	})), 'SentimentVeryDissatisfied');
	
	exports.default = _default;

/***/ },
/* 5256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 13.5c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5zM7.82 12l1.06-1.06L9.94 12 11 10.94 9.94 9.88 11 8.82 9.94 7.76 8.88 8.82 7.82 7.76 6.76 8.82l1.06 1.06-1.06 1.06zm4.17-10C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4.18-12.24l-1.06 1.06-1.06-1.06L13 8.82l1.06 1.06L13 10.94 14.06 12l1.06-1.06L16.18 12l1.06-1.06-1.06-1.06 1.06-1.06z"
	}), 'SentimentVeryDissatisfiedOutlined');
	
	exports.default = _default;

/***/ },
/* 5257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 13.5c-2.03 0-3.8 1.11-4.75 2.75-.19.33.06.75.44.75h8.62c.38 0 .63-.42.44-.75-.95-1.64-2.72-2.75-4.75-2.75zm-3.65-2.03l.53-.53.53.53c.29.29.77.29 1.06 0 .29-.29.29-.77 0-1.06l-.53-.53.53-.53c.29-.29.29-.77 0-1.06-.29-.29-.77-.29-1.06 0l-.53.53-.53-.53c-.29-.29-.77-.29-1.06 0-.29.29-.29.77 0 1.06l.53.53-.53.53c-.29.29-.29.77 0 1.06.29.29.77.29 1.06 0zM11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.65-11.71l-.53.53-.53-.53c-.29-.29-.77-.29-1.06 0-.29.29-.29.77 0 1.06l.53.53-.53.53c-.29.29-.29.77 0 1.06.29.29.77.29 1.06 0l.53-.53.53.53c.29.29.77.29 1.06 0 .29-.29.29-.77 0-1.06l-.53-.53.53-.53c.29-.29.29-.77 0-1.06-.29-.29-.77-.29-1.06 0z"
	}), 'SentimentVeryDissatisfiedRounded');
	
	exports.default = _default;

/***/ },
/* 5258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 13.5c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5zM7.82 12l1.06-1.06L9.94 12 11 10.94 9.94 9.88 11 8.82 9.94 7.76 8.88 8.82 7.82 7.76 6.76 8.82l1.06 1.06-1.06 1.06zm4.17-10C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4.18-12.24l-1.06 1.06-1.06-1.06L13 8.82l1.06 1.06L13 10.94 14.06 12l1.06-1.06L16.18 12l1.06-1.06-1.06-1.06 1.06-1.06z"
	}), 'SentimentVeryDissatisfiedSharp');
	
	exports.default = _default;

/***/ },
/* 5259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zM6.76 8.82l1.06-1.06 1.06 1.06 1.06-1.06L11 8.82 9.94 9.88 11 10.94 9.94 12l-1.06-1.06L7.82 12l-1.06-1.06 1.06-1.06-1.06-1.06zM6.89 17c.8-2.04 2.78-3.5 5.11-3.5s4.31 1.46 5.11 3.5H6.89zm10.35-6.06L16.18 12l-1.06-1.06L14.06 12 13 10.94l1.06-1.06L13 8.82l1.06-1.06 1.06 1.06 1.06-1.06 1.06 1.06-1.06 1.06 1.06 1.06z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 13.5c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5zM7.82 12l1.06-1.06L9.94 12 11 10.94 9.94 9.88 11 8.82 9.94 7.76 8.88 8.82 7.82 7.76 6.76 8.82l1.06 1.06-1.06 1.06zm4.17-10C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4.18-12.24l-1.06 1.06-1.06-1.06L13 8.82l1.06 1.06L13 10.94 14.06 12l1.06-1.06L16.18 12l1.06-1.06-1.06-1.06 1.06-1.06z"
	})), 'SentimentVeryDissatisfiedTwoTone');
	
	exports.default = _default;

/***/ },
/* 5260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-5-6c.78 2.34 2.72 4 5 4s4.22-1.66 5-4H7z"
	})), 'SentimentVerySatisfied');
	
	exports.default = _default;

/***/ },
/* 5261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-10.06L14.06 11l1.06-1.06L16.18 11l1.06-1.06-2.12-2.12L13 9.94zm-4.12 0L9.94 11 11 9.94 8.88 7.82 6.76 9.94 7.82 11l1.06-1.06zM12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
	}), 'SentimentVerySatisfiedOutlined');
	
	exports.default = _default;

/***/ },
/* 5262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.88 9.94l.53.53c.29.29.77.29 1.06 0 .29-.29.29-.77 0-1.06l-.88-.88a.9959.9959 0 00-1.41 0l-.89.88c-.29.29-.29.77 0 1.06.29.29.77.29 1.06 0l.53-.53zM12 17.5c2.03 0 3.8-1.11 4.75-2.75.19-.33-.05-.75-.44-.75H7.69c-.38 0-.63.42-.44.75.95 1.64 2.72 2.75 4.75 2.75zm1.53-7.03c.29.29.77.29 1.06 0l.53-.53.53.53c.29.29.77.29 1.06 0 .29-.29.29-.77 0-1.06l-.88-.88a.9959.9959 0 00-1.41 0l-.88.88c-.3.29-.3.77-.01 1.06zM11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'SentimentVerySatisfiedRounded');
	
	exports.default = _default;

/***/ },
/* 5263 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.88 9.94L9.94 11 11 9.94 8.88 7.82 6.76 9.94 7.82 11zM12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5zm1-7.56L14.06 11l1.06-1.06L16.18 11l1.06-1.06-2.12-2.12zM11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'SentimentVerySatisfiedSharp');
	
	exports.default = _default;

/***/ },
/* 5264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zM8.88 7.82L11 9.94 9.94 11 8.88 9.94 7.82 11 6.76 9.94l2.12-2.12zM12 17.5c-2.33 0-4.31-1.46-5.11-3.5h10.22c-.8 2.04-2.78 3.5-5.11 3.5zm4.18-6.5l-1.06-1.06L14.06 11 13 9.94l2.12-2.12 2.12 2.12L16.18 11z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M8.88 9.94L9.94 11 11 9.94 8.88 7.82 6.76 9.94 7.82 11zm4.12 0L14.06 11l1.06-1.06L16.18 11l1.06-1.06-2.12-2.12zM11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-2.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
	})), 'SentimentVerySatisfiedTwoTone');
	
	exports.default = _default;

/***/ },
/* 5265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  transform: "scale(1.2, 1.2)",
	  d: "M15.95 10.78c.03-.25.05-.51.05-.78s-.02-.53-.06-.78l1.69-1.32c.15-.12.19-.34.1-.51l-1.6-2.77c-.1-.18-.31-.24-.49-.18l-1.99.8c-.42-.32-.86-.58-1.35-.78L12 2.34c-.03-.2-.2-.34-.4-.34H8.4c-.2 0-.36.14-.39.34l-.3 2.12c-.49.2-.94.47-1.35.78l-1.99-.8c-.18-.07-.39 0-.49.18l-1.6 2.77c-.1.18-.06.39.1.51l1.69 1.32c-.04.25-.07.52-.07.78s.02.53.06.78L2.37 12.1c-.15.12-.19.34-.1.51l1.6 2.77c.1.18.31.24.49.18l1.99-.8c.42.32.86.58 1.35.78l.3 2.12c.04.2.2.34.4.34h3.2c.2 0 .37-.14.39-.34l.3-2.12c.49-.2.94-.47 1.35-.78l1.99.8c.18.07.39 0 .49-.18l1.6-2.77c.1-.18.06-.39-.1-.51l-1.67-1.32zM10 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
	}), 'Settings');
	
	exports.default = _default;

/***/ },
/* 5266 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42c-.09-.15-.05-.34.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68l-1.48-1.16c-.13-.11-.17-.3-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z"
	}), 'SettingsApplications');
	
	exports.default = _default;

/***/ },
/* 5267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.21 13.97l1.2 2.07c.08.13.23.18.37.13l1.49-.6c.31.24.64.44 1.01.59l.22 1.59c.03.14.15.25.3.25h2.4c.15 0 .27-.11.3-.26l.22-1.59c.36-.15.7-.35 1.01-.59l1.49.6c.14.05.29 0 .37-.13l1.2-2.07c.08-.13.04-.29-.07-.39l-1.27-.99c.03-.19.04-.39.04-.58 0-.2-.02-.39-.04-.59l1.27-.99c.11-.09.15-.26.07-.39l-1.2-2.07c-.08-.13-.23-.18-.37-.13l-1.49.6c-.31-.24-.64-.44-1.01-.59l-.22-1.59c-.03-.14-.15-.25-.3-.25h-2.4c-.15 0-.27.11-.3.26l-.22 1.59c-.36.15-.71.34-1.01.58l-1.49-.6c-.14-.05-.29 0-.37.13l-1.2 2.07c-.08.13-.04.29.07.39l1.27.99c-.03.2-.05.39-.05.59 0 .2.02.39.04.59l-1.27.99c-.11.1-.14.26-.06.39zM12 10.29c.94 0 1.71.77 1.71 1.71s-.77 1.71-1.71 1.71-1.71-.77-1.71-1.71.77-1.71 1.71-1.71zM19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm0 16H5V5h14v14z"
	}), 'SettingsApplicationsOutlined');
	
	exports.default = _default;

/***/ },
/* 5268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42c-.09-.15-.05-.34.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69s.02-.46.05-.68l-1.48-1.16c-.13-.11-.17-.3-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z"
	}), 'SettingsApplicationsRounded');
	
	exports.default = _default;

/***/ },
/* 5269 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-1.75 9c0 .24-.02.47-.05.71l.01-.02 1.47 1.16c.14.1.23.18.23.18l-1.7 2.94-2.02-.8.02-.03c-.37.29-.77.53-1.21.71h.01l-.27 1.85c-.02.17-.04.3-.04.3h-3.4l-.31-2.15H10c-.44-.18-.84-.42-1.21-.71l.02.03-2.02.8-1.7-2.94s.1-.08.23-.18l1.47-1.16.01.02c-.03-.24-.05-.47-.05-.71s.02-.47.05-.69l-.01.01-1.7-1.34 1.7-2.95 2.01.81v.01c.37-.28.77-.52 1.2-.7h-.01L10.3 5h3.41l.3 2.15H14c.43.18.83.42 1.2.7v-.01l2.01-.81 1.7 2.95-1.71 1.34-.01-.01c.04.22.06.45.06.69z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "2.45"
	})), 'SettingsApplicationsSharp');
	
	exports.default = _default;

/***/ },
/* 5270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14V5H5v14zm2.5-7c0-.2.02-.39.04-.58l-1.27-.99c-.11-.09-.15-.26-.07-.39l1.2-2.07c.08-.13.23-.18.37-.13l1.49.6c.31-.25.66-.44 1.02-.6l.22-1.59c.03-.14.15-.25.3-.25h2.4c.15 0 .27.11.3.25l.22 1.59c.37.15.7.35 1.01.59l1.49-.6c.14-.05.29 0 .37.13l1.2 2.07c.08.13.04.29-.07.39l-1.27.99c.03.2.04.39.04.59 0 .2-.02.39-.04.58l1.27.99c.11.09.15.26.07.39l-1.2 2.07c-.08.13-.23.18-.37.13l-1.49-.6c-.31.24-.65.44-1.01.59l-.22 1.59c-.03.15-.15.26-.3.26h-2.4c-.15 0-.27-.11-.3-.25l-.22-1.59c-.37-.15-.7-.35-1.01-.59l-1.49.6c-.14.05-.29 0-.37-.13l-1.2-2.07c-.08-.13-.04-.29.07-.39l1.27-.99c-.03-.2-.05-.39-.05-.59z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M6.21 13.97l1.2 2.07c.08.13.23.18.37.13l1.49-.6c.31.24.64.44 1.01.59l.22 1.59c.03.14.15.25.3.25h2.4c.15 0 .27-.11.3-.26l.22-1.59c.36-.15.7-.35 1.01-.59l1.49.6c.14.05.29 0 .37-.13l1.2-2.07c.08-.13.04-.29-.07-.39l-1.27-.99c.03-.19.04-.39.04-.58 0-.2-.02-.39-.04-.59l1.27-.99c.11-.09.15-.26.07-.39l-1.2-2.07c-.08-.13-.23-.18-.37-.13l-1.49.6c-.31-.24-.64-.44-1.01-.59l-.22-1.59c-.03-.14-.15-.25-.3-.25h-2.4c-.15 0-.27.11-.3.26l-.22 1.59c-.36.15-.71.34-1.01.58l-1.49-.6c-.14-.05-.29 0-.37.13l-1.2 2.07c-.08.13-.04.29.07.39l1.27.99c-.03.2-.05.39-.05.59 0 .2.02.39.04.59l-1.27.99c-.11.1-.14.26-.06.39zM12 10.29c.94 0 1.71.77 1.71 1.71s-.77 1.71-1.71 1.71-1.71-.77-1.71-1.71.77-1.71 1.71-1.71zM19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm0 16H5V5h14v14z"
	})), 'SettingsApplicationsTwoTone');
	
	exports.default = _default;

/***/ },
/* 5271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9c-4.97 0-9 4.03-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.51 0-2.91-.49-4.06-1.3l-1.42 1.44C8.04 20.3 9.94 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z"
	}), 'SettingsBackupRestore');
	
	exports.default = _default;

/***/ },
/* 5272 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9c-4.97 0-9 4.03-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.51 0-2.91-.49-4.06-1.3l-1.42 1.44C8.04 20.3 9.94 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z"
	}), 'SettingsBackupRestoreOutlined');
	
	exports.default = _default;

/***/ },
/* 5273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-1.74-9C7.17 2.86 3 6.95 3 12H1.21c-.45 0-.67.54-.35.85l2.79 2.79c.2.2.51.2.71 0l2.79-2.79c.31-.31.09-.85-.36-.85H5c0-3.9 3.18-7.05 7.1-7 3.72.05 6.85 3.18 6.9 6.9.05 3.91-3.1 7.1-7 7.1-1.25 0-2.42-.34-3.44-.91-.39-.22-.87-.14-1.18.18-.46.46-.37 1.25.2 1.57C8.89 20.57 10.39 21 12 21c5.05 0 9.14-4.17 9-9.26-.13-4.69-4.05-8.61-8.74-8.74z"
	}), 'SettingsBackupRestoreRounded');
	
	exports.default = _default;

/***/ },
/* 5274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9c-4.97 0-9 4.03-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.51 0-2.91-.49-4.06-1.3l-1.42 1.44C8.04 20.3 9.94 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z"
	}), 'SettingsBackupRestoreSharp');
	
	exports.default = _default;

/***/ },
/* 5275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9c-4.97 0-9 4.03-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.51 0-2.91-.49-4.06-1.3l-1.42 1.44C8.04 20.3 9.94 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z"
	}), 'SettingsBackupRestoreTwoTone');
	
	exports.default = _default;

/***/ },
/* 5276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 24h2v-2h-2v2zm-4 0h2v-2H7v2zm8 0h2v-2h-2v2zm2.71-18.29L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 3.83l1.88 1.88L13 7.59V3.83zm1.88 10.46L13 16.17v-3.76l1.88 1.88z"
	}), 'SettingsBluetooth');
	
	exports.default = _default;

/***/ },
/* 5277 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 24h2v-2h-2v2zm-4 0h2v-2H7v2zm8 0h2v-2h-2v2zm2.71-18.29L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 3.83l1.88 1.88L13 7.59V3.83zm1.88 10.46L13 16.17v-3.76l1.88 1.88z"
	}), 'SettingsBluetoothOutlined');
	
	exports.default = _default;

/***/ },
/* 5278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 22h2v2h-2zm-4 0h2v2H7zm8 0h2v2h-2zm-1.59-12l3.62-3.62c.19-.19.29-.44.29-.71s-.11-.52-.29-.71L12.7.65c-.29-.29-.72-.37-1.09-.22-.37.15-.61.52-.61.92v6.23L7.14 3.73c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41L10.58 10l-4.85 4.85c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0L11 12.41v6.23c0 .4.24.77.62.92.12.05.25.08.38.08.26 0 .52-.1.71-.29l4.32-4.32c.19-.19.29-.44.29-.71s-.11-.52-.29-.71L13.41 10zM13 3.77l1.91 1.91L13 7.58V3.77zm0 12.46v-3.82l1.91 1.91L13 16.23z"
	}), 'SettingsBluetoothRounded');
	
	exports.default = _default;

/***/ },
/* 5279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 24h2v-2h-2v2zm-4 0h2v-2H7v2zm8 0h2v-2h-2v2zm2.71-18.29L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 3.83l1.88 1.88L13 7.59V3.83zm1.88 10.46L13 16.17v-3.76l1.88 1.88z"
	}), 'SettingsBluetoothSharp');
	
	exports.default = _default;

/***/ },
/* 5280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 24h2v-2h-2v2zm-4 0h2v-2H7v2zm8 0h2v-2h-2v2zm2.71-18.29L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 3.83l1.88 1.88L13 7.59V3.83zm1.88 10.46L13 16.17v-3.76l1.88 1.88z"
	}), 'SettingsBluetoothTwoTone');
	
	exports.default = _default;

/***/ },
/* 5281 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02zM8 16h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 13.5V16zm4-7c1.66 0 3 1.34 3 3s-1.34 3-3 3V9z"
	}), 'SettingsBrightness');
	
	exports.default = _default;

/***/ },
/* 5282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02zM8 16h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 13.5V16zm4-7c1.66 0 3 1.34 3 3s-1.34 3-3 3V9z"
	}), 'SettingsBrightnessOutlined');
	
	exports.default = _default;

/***/ },
/* 5283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16.01H4c-.55 0-1-.45-1-1V5.99c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v12.02c0 .55-.45 1-1 1zM8.5 16h2l1.15 1.15c.2.2.51.2.71 0L13.5 16h2c.28 0 .5-.22.5-.5v-2l1.15-1.15c.2-.2.2-.51 0-.71L16 10.5v-2c0-.28-.22-.5-.5-.5h-2l-1.15-1.15c-.2-.2-.51-.2-.71 0L10.5 8h-2c-.28 0-.5.22-.5.5v2l-1.15 1.15c-.2.2-.2.51 0 .71L8 13.5v2c0 .28.22.5.5.5zM12 9c1.66 0 3 1.34 3 3s-1.34 3-3 3V9z"
	}), 'SettingsBrightnessRounded');
	
	exports.default = _default;

/***/ },
/* 5284 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 3H1v18h22V3zm-2 16.01H3V4.99h18v14.02zM8 16h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 13.5V16zm4-7c1.66 0 3 1.34 3 3s-1.34 3-3 3V9z"
	}), 'SettingsBrightnessSharp');
	
	exports.default = _default;

/***/ },
/* 5285 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 19.01h18V4.99H3v14.02zm5-8.51V8h2.5L12 6.5 13.5 8H16v2.5l1.5 1.5-1.5 1.5V16h-2.5L12 17.5 10.5 16H8v-2.5L6.5 12 8 10.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M8 16h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 13.5V16zm4-7c1.66 0 3 1.34 3 3s-1.34 3-3 3V9zm9-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
	})), 'SettingsBrightnessTwoTone');
	
	exports.default = _default;

/***/ },
/* 5286 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99zM16 16H8V4h8v12z"
	}), 'SettingsCell');
	
	exports.default = _default;

/***/ },
/* 5287 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 22h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99zM16 18H8v-1h8v1zm0-3H8V5h8v10zm0-12H8V2h8v1z"
	}), 'SettingsCellOutlined');
	
	exports.default = _default;

/***/ },
/* 5288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99zM16 16H8V4h8v12z"
	}), 'SettingsCellRounded');
	
	exports.default = _default;

/***/ },
/* 5289 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM6 0v20h12V0H6zm10 16H8V4h8v12z"
	}), 'SettingsCellSharp');
	
	exports.default = _default;

/***/ },
/* 5290 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 17h8v1H8zM8 2h8v1H8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M7 22h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99zM16 18H8v-1h8v1zm0-3H8V5h8v10zm0-12H8V2h8v1z"
	})), 'SettingsCellTwoTone');
	
	exports.default = _default;

/***/ },
/* 5291 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z"
	}), 'SettingsEthernet');
	
	exports.default = _default;

/***/ },
/* 5292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z"
	}), 'SettingsEthernetOutlined');
	
	exports.default = _default;

/***/ },
/* 5293 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 6.12c-.43-.35-1.06-.3-1.41.13l-4.24 5.11c-.31.37-.31.91 0 1.28l4.24 5.11c.35.43.98.48 1.41.13.43-.35.48-.98.13-1.41L3.42 12l3.71-4.47c.35-.43.3-1.06-.13-1.41zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6-6.88c-.43.35-.48.98-.13 1.41L20.58 12l-3.71 4.47c-.35.43-.29 1.06.13 1.41.43.35 1.06.3 1.41-.13l4.24-5.11c.31-.37.31-.91 0-1.28l-4.24-5.11c-.35-.42-.99-.48-1.41-.13z"
	}), 'SettingsEthernetRounded');
	
	exports.default = _default;

/***/ },
/* 5294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z"
	}), 'SettingsEthernetSharp');
	
	exports.default = _default;

/***/ },
/* 5295 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z"
	}), 'SettingsEthernetTwoTone');
	
	exports.default = _default;

/***/ },
/* 5296 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29 0-1.38-1.12-2.5-2.5-2.5S9.5 10.62 9.5 12c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2c0-4.97 4.03-9 9-9s9 4.03 9 9h2c0-6.07-4.93-11-11-11z"
	}), 'SettingsInputAntenna');
	
	exports.default = _default;

/***/ },
/* 5297 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29 0-1.38-1.12-2.5-2.5-2.5S9.5 10.62 9.5 12c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2c0-4.97 4.03-9 9-9s9 4.03 9 9h2c0-6.07-4.93-11-11-11z"
	}), 'SettingsInputAntennaOutlined');
	
	exports.default = _default;

/***/ },
/* 5298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5c-3.48 0-6.37 2.54-6.91 5.87-.1.59.39 1.13 1 1.13.49 0 .9-.36.98-.85C7.48 8.79 9.53 7 12 7s4.52 1.79 4.93 4.15c.08.49.49.85.98.85.61 0 1.09-.54.99-1.13C18.37 7.54 15.48 5 12 5zm1 9.29c1.07-.48 1.76-1.66 1.41-2.99-.22-.81-.87-1.47-1.68-1.7-1.69-.48-3.23.78-3.23 2.4 0 1.02.62 1.9 1.5 2.29v3.3l-2.71 2.7c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l2.3-2.3 2.3 2.3c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13 17.59v-3.3zM12 1C6.3 1 1.61 5.34 1.05 10.9c-.05.59.41 1.1 1 1.1.51 0 .94-.38.99-.88C3.48 6.56 7.33 3 12 3s8.52 3.56 8.96 8.12c.05.5.48.88.99.88.59 0 1.06-.51 1-1.1C22.39 5.34 17.7 1 12 1z"
	}), 'SettingsInputAntennaRounded');
	
	exports.default = _default;

/***/ },
/* 5299 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29 0-1.38-1.12-2.5-2.5-2.5S9.5 10.62 9.5 12c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2c0-4.97 4.03-9 9-9s9 4.03 9 9h2c0-6.07-4.93-11-11-11z"
	}), 'SettingsInputAntennaSharp');
	
	exports.default = _default;

/***/ },
/* 5300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29 0-1.38-1.12-2.5-2.5-2.5S9.5 10.62 9.5 12c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2c0-4.97 4.03-9 9-9s9 4.03 9 9h2c0-6.07-4.93-11-11-11z"
	}), 'SettingsInputAntennaTwoTone');
	
	exports.default = _default;

/***/ },
/* 5301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z"
	}), 'SettingsInputComponent');
	
	exports.default = _default;

/***/ },
/* 5302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v10c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16V6H5V2zM4 17c-.55 0-1-.45-1-1v-2h2v2c0 .55-.45 1-1 1zm-1-5V8h2v4H3zM13 2c0-.55-.45-1-1-1s-1 .45-1 1v4H9v10c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.42 2-1.52 2-2.82V6h-2V2zm-1 15c-.55 0-1-.45-1-1v-2h2v2c0 .55-.45 1-1 1zm-1-5V8h2v4h-2zm10-6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v10c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.42 2-1.52 2-2.82V6h-2zm-1 11c-.55 0-1-.45-1-1v-2h2v2c0 .55-.45 1-1 1zm-1-5V8h2v4h-2z"
	}), 'SettingsInputComponentOutlined');
	
	exports.default = _default;

/***/ },
/* 5303 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H2c-.55 0-1 .45-1 1v5h6V7c0-.55-.45-1-1-1H5V2zm4 14c0 1.3.84 2.4 2 2.82V22c0 .55.45 1 1 1s1-.45 1-1v-3.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V22c0 .55.45 1 1 1s1-.45 1-1v-3.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-1c-.55 0-1 .45-1 1v5h6V7c0-.55-.45-1-1-1h-1zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4h-1c-.55 0-1 .45-1 1v5h6V7c0-.55-.45-1-1-1h-1V2zm4 14c0 1.3.84 2.4 2 2.82V22c0 .55.45 1 1 1s1-.45 1-1v-3.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z"
	}), 'SettingsInputComponentRounded');
	
	exports.default = _default;

/***/ },
/* 5304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 16.82h2V23h2v-4.18h2V14H9v4.82zm-8 0h2V23h2v-4.18h2V14H1v4.82zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 16.82h2V23h2v-4.18h2V14h-6v4.82z"
	}), 'SettingsInputComponentSharp');
	
	exports.default = _default;

/***/ },
/* 5305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11 16c0 .55.45 1 1 1s1-.45 1-1v-2h-2v2zm-8 0c0 .55.45 1 1 1s1-.45 1-1v-2H3v2zm16 0c0 .55.45 1 1 1s1-.45 1-1v-2h-2v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v10c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16V6H5V2zm0 14c0 .55-.45 1-1 1s-1-.45-1-1v-2h2v2zm0-4H3V8h2v4zm8-10c0-.55-.45-1-1-1s-1 .45-1 1v4H9v10c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.42 2-1.52 2-2.82V6h-2V2zm0 14c0 .55-.45 1-1 1s-1-.45-1-1v-2h2v2zm0-4h-2V8h2v4zm8-6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v10c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.42 2-1.52 2-2.82V6h-2zm0 10c0 .55-.45 1-1 1s-1-.45-1-1v-2h2v2zm0-4h-2V8h2v4z"
	})), 'SettingsInputComponentTwoTone');
	
	exports.default = _default;

/***/ },
/* 5306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z"
	}), 'SettingsInputComposite');
	
	exports.default = _default;

/***/ },
/* 5307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v10c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16V6H5V2zM4 17c-.55 0-1-.45-1-1v-2h2v2c0 .55-.45 1-1 1zm-1-5V8h2v4H3zM13 2c0-.55-.45-1-1-1s-1 .45-1 1v4H9v10c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.42 2-1.52 2-2.82V6h-2V2zm-1 15c-.55 0-1-.45-1-1v-2h2v2c0 .55-.45 1-1 1zm-1-5V8h2v4h-2zm10-6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v10c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.42 2-1.52 2-2.82V6h-2zm-1 11c-.55 0-1-.45-1-1v-2h2v2c0 .55-.45 1-1 1zm-1-5V8h2v4h-2z"
	}), 'SettingsInputCompositeOutlined');
	
	exports.default = _default;

/***/ },
/* 5308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H2c-.55 0-1 .45-1 1v5h6V7c0-.55-.45-1-1-1H5V2zm4 14c0 1.3.84 2.4 2 2.82V22c0 .55.45 1 1 1s1-.45 1-1v-3.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V22c0 .55.45 1 1 1s1-.45 1-1v-3.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-1c-.55 0-1 .45-1 1v5h6V7c0-.55-.45-1-1-1h-1zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4h-1c-.55 0-1 .45-1 1v5h6V7c0-.55-.45-1-1-1h-1V2zm4 14c0 1.3.84 2.4 2 2.82V22c0 .55.45 1 1 1s1-.45 1-1v-3.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z"
	}), 'SettingsInputCompositeRounded');
	
	exports.default = _default;

/***/ },
/* 5309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 16.82h2V23h2v-4.18h2V14H9v4.82zm-8 0h2V23h2v-4.18h2V14H1v4.82zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 16.82h2V23h2v-4.18h2V14h-6v4.82z"
	}), 'SettingsInputCompositeSharp');
	
	exports.default = _default;

/***/ },
/* 5310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 16c0 .55.45 1 1 1s1-.45 1-1v-2H3v2zm8 0c0 .55.45 1 1 1s1-.45 1-1v-2h-2v2zm8 0c0 .55.45 1 1 1s1-.45 1-1v-2h-2v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v10c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16V6H5V2zm0 14c0 .55-.45 1-1 1s-1-.45-1-1v-2h2v2zm0-4H3V8h2v4zm8-10c0-.55-.45-1-1-1s-1 .45-1 1v4H9v10c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.42 2-1.52 2-2.82V6h-2V2zm0 14c0 .55-.45 1-1 1s-1-.45-1-1v-2h2v2zm0-4h-2V8h2v4zm8-6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v10c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.42 2-1.52 2-2.82V6h-2zm0 10c0 .55-.45 1-1 1s-1-.45-1-1v-2h2v2zm0-4h-2V8h2v4z"
	})), 'SettingsInputCompositeTwoTone');
	
	exports.default = _default;

/***/ },
/* 5311 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2V5h-1v2h-2V5h-1v2H8V4z"
	}), 'SettingsInputHdmi');
	
	exports.default = _default;

/***/ },
/* 5312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2.01V5h-1v2H11V5h-1v2H8V4zm9 8.53l-3 6V20h-4v-1.47l-3-6V9h10v3.53z"
	}), 'SettingsInputHdmiOutlined');
	
	exports.default = _default;

/***/ },
/* 5313 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3c-.55 0-1 .45-1 1v4.7c0 .2.06.39.17.55L8 19v2c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2l2.83-5.75c.11-.16.17-.36.17-.55V8c0-.55-.45-1-1-1zm-2 0h-2V5.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5V7h-2V5.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5V7H8V4h8v3z"
	}), 'SettingsInputHdmiRounded');
	
	exports.default = _default;

/***/ },
/* 5314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 7V2H6v5H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2V5h-1v2h-2V5h-1v2H8V4z"
	}), 'SettingsInputHdmiSharp');
	
	exports.default = _default;

/***/ },
/* 5315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 9H7v3.53l2.79 5.58.21.42V20h4v-1.47l.21-.42L17 12.53V9h-1z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2.01V5h-1v2H11V5h-1v2H8V4zm9 8.53l-3 6V20h-4v-1.47l-3-6V9h10v3.53z"
	})), 'SettingsInputHdmiTwoTone');
	
	exports.default = _default;

/***/ },
/* 5316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5zm7-5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5zM8.5 15c-.83 0-1.5.67-1.5 1.5S7.67 18 8.5 18s1.5-.67 1.5-1.5S9.33 15 8.5 15zM12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9zm5.5-11c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-2 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
	}), 'SettingsInputSvideo');
	
	exports.default = _default;

/***/ },
/* 5317 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5zm7-5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5zM8.5 15c-.83 0-1.5.67-1.5 1.5S7.67 18 8.5 18s1.5-.67 1.5-1.5S9.33 15 8.5 15zM12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9zm5.5-11c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-2 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
	}), 'SettingsInputSvideoOutlined');
	
	exports.default = _default;

/***/ },
/* 5318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5zm7-5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5zM8.5 15c-.83 0-1.5.67-1.5 1.5S7.67 18 8.5 18s1.5-.67 1.5-1.5S9.33 15 8.5 15zM12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9zm5.5-11c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-2 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
	}), 'SettingsInputSvideoRounded');
	
	exports.default = _default;

/***/ },
/* 5319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5zm7-5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5zM8.5 15c-.83 0-1.5.67-1.5 1.5S7.67 18 8.5 18s1.5-.67 1.5-1.5S9.33 15 8.5 15zM12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9zm5.5-11c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-2 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
	}), 'SettingsInputSvideoSharp');
	
	exports.default = _default;

/***/ },
/* 5320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 3c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm-7 8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S7.33 13 6.5 13 5 12.33 5 11.5zM8.5 18c-.83 0-1.5-.67-1.5-1.5S7.67 15 8.5 15s1.5.67 1.5 1.5S9.33 18 8.5 18zm2-10C9.67 8 9 7.33 9 6.5S9.67 5 10.5 5h3c.83 0 1.5.67 1.5 1.5S14.33 8 13.5 8h-3zm5 10c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm2-5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M15 6.5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5z"
	}), _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "16.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "17.5",
	  cy: "11.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9z"
	}), _react.default.createElement("circle", {
	  cx: "6.5",
	  cy: "11.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "16.5",
	  r: "1.5"
	})), 'SettingsInputSvideoTwoTone');
	
	exports.default = _default;

/***/ },
/* 5321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'SettingsOutlined');
	
	exports.default = _default;

/***/ },
/* 5322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.01 5.5L10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
	}), 'SettingsOverscan');
	
	exports.default = _default;

/***/ },
/* 5323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.01 5.5L10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
	}), 'SettingsOverscanOutlined');
	
	exports.default = _default;

/***/ },
/* 5324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.62 5.99L10 8h4l-1.6-2.01c-.2-.25-.58-.25-.78 0zM18 10v4l2.01-1.6c.25-.2.25-.58 0-.78L18 10zM6 10l-2.01 1.62c-.25.2-.25.58 0 .78L6 14v-4zm8 6h-4l1.62 2.01c.2.25.58.25.78 0L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16.01H4c-.55 0-1-.45-1-1V5.99c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v12.02c0 .55-.45 1-1 1z"
	}), 'SettingsOverscanRounded');
	
	exports.default = _default;

/***/ },
/* 5325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.01 5.5L10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm9-13H1v18h22V3zm-2 16.01H3V4.99h18v14.02z"
	}), 'SettingsOverscanSharp');
	
	exports.default = _default;

/***/ },
/* 5326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 19.01h18V4.99H3v14.02zM18 10l2.5 2.01L18 14v-4zm-5.99-4.5L14 8h-4l2.01-2.5zM14 16l-1.99 2.5L10 16h4zm-8-6v4l-2.5-1.99L6 10z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M14 16h-4l2.01 2.5zm4-6v4l2.5-1.99zm3-7H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02zM6 10l-2.5 2.01L6 14zm6.01-4.5L10 8h4z"
	})), 'SettingsOverscanTwoTone');
	
	exports.default = _default;

/***/ },
/* 5327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 9h-2v2h2V9zm4 0h-2v2h2V9zm3 6.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 9v2h2V9h-2z"
	}), 'SettingsPhone');
	
	exports.default = _default;

/***/ },
/* 5328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 9h2v2h-2zm4 0h2v2h-2zm5 6.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.46 2.59L5.79 8.8c-.41-1.21-.67-2.48-.76-3.8zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM19 9h2v2h-2z"
	}), 'SettingsPhoneOutlined');
	
	exports.default = _default;

/***/ },
/* 5329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 9h2v2h-2zm4 0h2v2h-2zm4 0h2v2h-2zm.23 6.26l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z"
	}), 'SettingsPhoneRounded');
	
	exports.default = _default;

/***/ },
/* 5330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.21 17.37c-2.83-1.44-5.15-3.75-6.59-6.59l2.53-2.53L8.54 3H3.03C2.45 13.18 10.82 21.55 21 20.97v-5.51l-5.27-.61-2.52 2.52zM11 9h2v2h-2zm4 0h2v2h-2zm4 0h2v2h-2z"
	}), 'SettingsPhoneSharp');
	
	exports.default = _default;

/***/ },
/* 5331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6.54 5h-1.5c.09 1.32.35 2.59.75 3.79l1.2-1.21c-.24-.83-.39-1.7-.45-2.58zm8.66 13.21c1.21.41 2.48.67 3.8.76v-1.5c-.88-.07-1.75-.22-2.6-.45l-1.2 1.19z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11 9h2v2h-2zm4 0h2v2h-2zm5 6.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.46 2.59L5.79 8.8c-.41-1.21-.67-2.48-.76-3.8zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM19 9h2v2h-2z"
	})), 'SettingsPhoneTwoTone');
	
	exports.default = _default;

/***/ },
/* 5332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm2-22h-2v10h2V2zm3.56 2.44l-1.45 1.45C16.84 6.94 18 8.83 18 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44C5.36 5.88 4 8.28 4 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56zM15 24h2v-2h-2v2z"
	}), 'SettingsPower');
	
	exports.default = _default;

/***/ },
/* 5333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm2-22h-2v10h2V2zm3.56 2.44l-1.45 1.45C16.84 6.94 18 8.83 18 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44C5.36 5.88 4 8.28 4 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56zM15 24h2v-2h-2v2z"
	}), 'SettingsPowerOutlined');
	
	exports.default = _default;

/***/ },
/* 5334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm1-22c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1s1-.45 1-1V3c0-.55-.45-1-1-1zm3.94 3.06l-.02.02c-.41.41-.36 1.08.08 1.46 1.51 1.34 2.33 3.43 1.88 5.7-.46 2.28-2.29 4.14-4.56 4.62C9.43 17.69 6 14.74 6 11c0-1.78.78-3.37 2.01-4.47.43-.39.47-1.04.07-1.45l-.02-.02c-.37-.37-.96-.39-1.36-.04-2.01 1.77-3.12 4.53-2.56 7.52.59 3.15 3.11 5.7 6.26 6.31 5.12.99 9.6-2.9 9.6-7.85 0-2.38-1.05-4.52-2.71-5.99-.39-.34-.98-.32-1.35.05zM15 24h2v-2h-2v2z"
	}), 'SettingsPowerRounded');
	
	exports.default = _default;

/***/ },
/* 5335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm2-22h-2v10h2V2zm3.56 2.44l-1.45 1.45C16.84 6.94 18 8.83 18 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44C5.36 5.88 4 8.28 4 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56zM15 24h2v-2h-2v2z"
	}), 'SettingsPowerSharp');
	
	exports.default = _default;

/***/ },
/* 5336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm2-22h-2v10h2V2zm3.56 2.44l-1.45 1.45C16.84 6.94 18 8.83 18 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44C5.36 5.88 4 8.28 4 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56zM15 24h2v-2h-2v2z"
	}), 'SettingsPowerTwoTone');
	
	exports.default = _default;

/***/ },
/* 5337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-3 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM7.05 6.05l1.41 1.41C9.37 6.56 10.62 6 12 6s2.63.56 3.54 1.46l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z"
	}), 'SettingsRemote');
	
	exports.default = _default;

/***/ },
/* 5338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-1 12h-4V11h4v10z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "13",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M7.05 6.05l1.41 1.41C9.37 6.56 10.62 6 12 6s2.63.56 3.54 1.46l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z"
	})), 'SettingsRemoteOutlined');
	
	exports.default = _default;

/***/ },
/* 5339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-3 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM7.82 6.82c.35.35.9.38 1.3.1C9.93 6.34 10.93 6 12 6s2.07.34 2.88.91c.4.28.95.26 1.3-.09.43-.43.39-1.14-.09-1.5C14.94 4.49 13.53 4 12 4s-2.94.49-4.09 1.32c-.49.35-.52 1.07-.09 1.5zM12 0C9.36 0 6.94.93 5.05 2.47c-.46.38-.5 1.07-.08 1.49.36.36.93.39 1.32.07C7.84 2.77 9.83 2 12 2s4.16.77 5.7 2.04c.39.32.96.29 1.32-.07.42-.42.38-1.11-.08-1.49C17.06.93 14.64 0 12 0z"
	}), 'SettingsRemoteRounded');
	
	exports.default = _default;

/***/ },
/* 5340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 9H8v14h8V9zm-4 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM7.05 6.05l1.41 1.41C9.37 6.56 10.62 6 12 6s2.63.56 3.54 1.46l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z"
	}), 'SettingsRemoteSharp');
	
	exports.default = _default;

/***/ },
/* 5341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M10 21h4V11h-4v10zm2-9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-1 12h-4V11h4v10z"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "13",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M7.05 6.05l1.41 1.41C9.37 6.56 10.62 6 12 6s2.63.56 3.54 1.46l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z"
	})), 'SettingsRemoteTwoTone');
	
	exports.default = _default;

/***/ },
/* 5342 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
	}), 'SettingsRounded');
	
	exports.default = _default;

/***/ },
/* 5343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.44 12.99l-.01.02c.04-.33.08-.67.08-1.01 0-.34-.03-.66-.07-.99l.01.02 2.44-1.92-2.43-4.22-2.87 1.16.01.01c-.52-.4-1.09-.74-1.71-1h.01L14.44 2H9.57l-.44 3.07h.01c-.62.26-1.19.6-1.71 1l.01-.01-2.88-1.17-2.44 4.22 2.44 1.92.01-.02c-.04.33-.07.65-.07.99 0 .34.03.68.08 1.01l-.01-.02-2.1 1.65-.33.26 2.43 4.2 2.88-1.15-.02-.04c.53.41 1.1.75 1.73 1.01h-.03L9.58 22h4.85s.03-.18.06-.42l.38-2.65h-.01c.62-.26 1.2-.6 1.73-1.01l-.02.04 2.88 1.15 2.43-4.2s-.14-.12-.33-.26l-2.11-1.66zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
	}), 'SettingsSharp');
	
	exports.default = _default;

/***/ },
/* 5344 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 16h6.5c1.38 0 2.5-1.12 2.5-2.5S16.88 11 15.5 11h-.05c-.24-1.69-1.69-3-3.45-3-1.4 0-2.6.83-3.16 2.02h-.16C7.17 10.18 6 11.45 6 13c0 1.66 1.34 3 3 3zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
	}), 'SettingsSystemDaydream');
	
	exports.default = _default;

/***/ },
/* 5345 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 17H9c-2.21 0-4-1.79-4-4 0-1.93 1.36-3.56 3.22-3.92C9.04 7.8 10.47 7 12 7c1.95 0 3.66 1.28 4.26 3.09 1.58.36 2.74 1.75 2.74 3.41 0 1.93-1.57 3.5-3.5 3.5zm-6.76-5.98C7.74 11.15 7 11.99 7 13c0 1.1.9 2 2 2h6.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-.87l-.17-.86C14.29 9.92 13.23 9 12 9c-.96 0-1.84.57-2.26 1.45l-.27.57h-.73zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
	}), 'SettingsSystemDaydreamOutlined');
	
	exports.default = _default;

/***/ },
/* 5346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 16h6.5c1.38 0 2.5-1.12 2.5-2.5S16.88 11 15.5 11h-.05c-.24-1.69-1.69-3-3.45-3-1.4 0-2.6.83-3.16 2.02h-.16C7.17 10.18 6 11.45 6 13c0 1.66 1.34 3 3 3zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16.01H4c-.55 0-1-.45-1-1V5.99c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v12.02c0 .55-.45 1-1 1z"
	}), 'SettingsSystemDaydreamRounded');
	
	exports.default = _default;

/***/ },
/* 5347 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 16h6.5c1.38 0 2.5-1.12 2.5-2.5S16.88 11 15.5 11h-.05c-.24-1.69-1.69-3-3.45-3-1.4 0-2.6.83-3.16 2.02h-.16C7.17 10.18 6 11.45 6 13c0 1.66 1.34 3 3 3zM23 3H1v18h22V3zm-2 16.01H3V4.99h18v14.02z"
	}), 'SettingsSystemDaydreamSharp');
	
	exports.default = _default;

/***/ },
/* 5348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9 15h6.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-.87l-.17-.86C14.29 9.92 13.23 9 12 9c-.96 0-1.84.57-2.26 1.45l-.27.57h-.73C7.74 11.15 7 11.99 7 13c0 1.1.9 2 2 2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9 17h6.5c1.93 0 3.5-1.57 3.5-3.5 0-1.66-1.16-3.05-2.74-3.41C15.66 8.28 13.95 7 12 7c-1.53 0-2.96.8-3.78 2.08C6.36 9.44 5 11.07 5 13c0 2.21 1.79 4 4 4zm-.26-5.98h.74l.27-.57C10.16 9.57 11.04 9 12 9c1.23 0 2.29.92 2.46 2.14l.17.86h.87c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H9c-1.1 0-2-.9-2-2 0-1.01.74-1.85 1.74-1.98zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
	})), 'SettingsSystemDaydreamTwoTone');
	
	exports.default = _default;

/***/ },
/* 5349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19.28 8.6l-.7-1.21-1.27.51-1.06.43-.91-.7c-.39-.3-.8-.54-1.23-.71l-1.06-.43-.16-1.13L12.7 4h-1.4l-.19 1.35-.16 1.13-1.06.44c-.41.17-.82.41-1.25.73l-.9.68-1.05-.42-1.27-.52-.7 1.21 1.08.84.89.7-.14 1.13c-.03.3-.05.53-.05.73s.02.43.05.73l.14 1.13-.89.7-1.08.84.7 1.21 1.27-.51 1.06-.43.91.7c.39.3.8.54 1.23.71l1.06.43.16 1.13.19 1.36h1.39l.19-1.35.16-1.13 1.06-.43c.41-.17.82-.41 1.25-.73l.9-.68 1.04.42 1.27.51.7-1.21-1.08-.84-.89-.7.14-1.13c.04-.31.05-.52.05-.73 0-.21-.02-.43-.05-.73l-.14-1.13.89-.7 1.1-.84zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	})), 'SettingsTwoTone');
	
	exports.default = _default;

/***/ },
/* 5350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 24h2v-2H7v2zm5-11c1.66 0 2.99-1.34 2.99-3L15 4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1 11h2v-2h-2v2zm4 0h2v-2h-2v2zm4-14h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z"
	}), 'SettingsVoice');
	
	exports.default = _default;

/***/ },
/* 5351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 22h2v2H7zm5-9c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .56-.44 1-1 1-.55 0-1-.45-1-1V4zm0 18h2v2h-2zm4 0h2v2h-2zm4-12h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z"
	}), 'SettingsVoiceOutlined');
	
	exports.default = _default;

/***/ },
/* 5352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 24h2v-2H7v2zm5-11c1.66 0 2.99-1.34 2.99-3L15 4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1 11h2v-2h-2v2zm4 0h2v-2h-2v2zm3.08-14c-.42 0-.77.3-.83.71-.37 2.61-2.72 4.39-5.25 4.39s-4.88-1.77-5.25-4.39c-.06-.41-.42-.71-.83-.71-.52 0-.92.46-.85.97.46 2.96 2.96 5.3 5.93 5.75V19c0 .55.45 1 1 1s1-.45 1-1v-2.28c2.96-.44 5.47-2.79 5.93-5.75.07-.51-.33-.97-.85-.97z"
	}), 'SettingsVoiceRounded');
	
	exports.default = _default;

/***/ },
/* 5353 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 24h2v-2H7v2zm5-11c1.66 0 2.99-1.34 2.99-3L15 4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1 11h2v-2h-2v2zm4 0h2v-2h-2v2zm4-14h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z"
	}), 'SettingsVoiceSharp');
	
	exports.default = _default;

/***/ },
/* 5354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 11c.56 0 .99-.44.99-1L13 4c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M7 22h2v2H7zm5-9c1.66 0 2.99-1.34 2.99-3L15 4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .56-.44 1-1 1-.55 0-1-.45-1-1V4zm0 18h2v2h-2zm4 0h2v2h-2zm4-12h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z"
	})), 'SettingsVoiceTwoTone');
	
	exports.default = _default;

/***/ },
/* 5355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
	}), 'Share');
	
	exports.default = _default;

/***/ },
/* 5356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92zM18 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM6 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 7.02c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'ShareOutlined');
	
	exports.default = _default;

/***/ },
/* 5357 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z"
	}), 'ShareRounded');
	
	exports.default = _default;

/***/ },
/* 5358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z"
	}), 'ShareSharp');
	
	exports.default = _default;

/***/ },
/* 5359 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "18",
	  cy: "5",
	  r: "1",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "6",
	  cy: "12",
	  r: "1",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "19.02",
	  r: "1",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92zM18 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM6 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 7.02c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	})), 'ShareTwoTone');
	
	exports.default = _default;

/***/ },
/* 5360 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 6V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H2v13c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6h-6zm-6-2h4v2h-4V4zM9 18V9l7.5 4L9 18z"
	}), 'Shop');
	
	exports.default = _default;

/***/ },
/* 5361 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 6V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H2v13c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6h-6zm-6-2h4v2h-4V4zm10 15H4V8h16v11zM9 18l7.5-5L9 9z"
	}), 'ShopOutlined');
	
	exports.default = _default;

/***/ },
/* 5362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 6V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-4zm-6-2h4v2h-4V4zM9 17.07V9.83c0-.38.4-.62.74-.44l6.03 3.21c.33.18.36.65.04.86l-6.03 4.02c-.33.22-.78-.01-.78-.41z"
	}), 'ShopRounded');
	
	exports.default = _default;

/***/ },
/* 5363 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 6V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H2v15h20V6h-6zm-6-2h4v2h-4V4zM9 18V9l7.5 4L9 18z"
	}), 'ShopSharp');
	
	exports.default = _default;

/***/ },
/* 5364 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 9H1v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H3V9zm15-4V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm0 12V8l5.5 3-5.5 4z"
	}), 'ShopTwo');
	
	exports.default = _default;

/***/ },
/* 5365 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 9H1v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H3V9zm15-4V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm9 13H7V7h14v9zm-9-1l5.5-4L12 8z"
	}), 'ShopTwoOutlined');
	
	exports.default = _default;

/***/ },
/* 5366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 9c-.55 0-1 .45-1 1v10c0 1.1.9 2 2 2h14c1.11 0 2-.89 2-2H4c-.55 0-1-.45-1-1v-9c0-.55-.45-1-1-1zm16-4V3c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H7c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-3zm-6-2h4v2h-4V3zm0 11.02V8.84c0-.38.41-.62.74-.44l4.07 2.22c.32.18.35.63.05.84l-4.07 2.96c-.33.24-.79.01-.79-.4z"
	}), 'ShopTwoRounded');
	
	exports.default = _default;

/***/ },
/* 5367 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 9H1v13h18v-2H3V9zm15-4V3c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H5v13h18V5h-5zm-6-2h4v2h-4V3zm0 12V8l5.5 3-5.5 4z"
	}), 'ShopTwoSharp');
	
	exports.default = _default;

/***/ },
/* 5368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 19h16V8H4v11zM9 9l7.5 4L9 18V9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16 6V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H2v13c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6h-6zm-6-2h4v2h-4V4zm10 15H4V8h16v11zM9 9v9l7.5-5z"
	})), 'ShopTwoTone');
	
	exports.default = _default;

/***/ },
/* 5369 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 7v9h14V7H7zm5 8V8l5.5 3-5.5 4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 9H1v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H3V9zm15-4V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm9 13H7V7h14v9zm-9-1l5.5-4L12 8z"
	})), 'ShopTwoTwoTone');
	
	exports.default = _default;

/***/ },
/* 5370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.21 9l-4.38-6.56c-.19-.28-.51-.42-.83-.42-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'ShoppingBasket');
	
	exports.default = _default;

/***/ },
/* 5371 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 9h-4.79l-4.38-6.56c-.19-.28-.51-.42-.83-.42s-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1zM12 4.8L14.8 9H9.2L12 4.8zM18.5 19l-12.99.01L3.31 11H20.7l-2.2 8zM12 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'ShoppingBasketOutlined');
	
	exports.default = _default;

/***/ },
/* 5372 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 9h-4.79l-4.39-6.57c-.4-.59-1.27-.59-1.66 0L6.77 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1zM11.99 4.79L14.8 9H9.18l2.81-4.21zM12 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'ShoppingBasketRounded');
	
	exports.default = _default;

/***/ },
/* 5373 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.21 9l-4.39-6.57c-.4-.59-1.27-.59-1.66 0L6.77 9H.69L4 21h16.02l3.29-12h-6.1zm-5.22-4.21L14.8 9H9.18l2.81-4.21zM12 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'ShoppingBasketSharp');
	
	exports.default = _default;

/***/ },
/* 5374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3.31 11l2.2 8.01L18.5 19l2.2-8H3.31zM12 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M22 9h-4.79l-4.38-6.56c-.19-.28-.51-.42-.83-.42s-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1zM12 4.8L14.8 9H9.2L12 4.8zM18.5 19l-12.99.01L3.31 11H20.7l-2.2 8zM12 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	})), 'ShoppingBasketTwoTone');
	
	exports.default = _default;

/***/ },
/* 5375 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
	}), 'ShoppingCart');
	
	exports.default = _default;

/***/ },
/* 5376 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
	}), 'ShoppingCartOutlined');
	
	exports.default = _default;

/***/ },
/* 5377 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 3c0 .55.45 1 1 1h1l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h11c.55 0 1-.45 1-1s-.45-1-1-1H7l1.1-2h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.67-1.43c-.16-.35-.52-.57-.9-.57H2c-.55 0-1 .45-1 1zm16 15c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
	}), 'ShoppingCartRounded');
	
	exports.default = _default;

/***/ },
/* 5378 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 18c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm0-3l1.1-2h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H1v2h2l3.6 7.59L3.62 17H19v-2H7z"
	}), 'ShoppingCartSharp');
	
	exports.default = _default;

/***/ },
/* 5379 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.55 11l2.76-5H6.16l2.37 5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
	})), 'ShoppingCartTwoTone');
	
	exports.default = _default;

/***/ },
/* 5380 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 9h16v2H4V9zm0 4h10v2H4v-2z"
	}), 'ShortText');
	
	exports.default = _default;

/***/ },
/* 5381 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 9h16v2H4V9zm0 4h10v2H4v-2z"
	}), 'ShortTextOutlined');
	
	exports.default = _default;

/***/ },
/* 5382 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 9h14c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1zm0 4h8c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1z"
	}), 'ShortTextRounded');
	
	exports.default = _default;

/***/ },
/* 5383 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 9h16v2H4V9zm0 4h10v2H4v-2z"
	}), 'ShortTextSharp');
	
	exports.default = _default;

/***/ },
/* 5384 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 9h16v2H4zm0 4h10v2H4z"
	}), 'ShortTextTwoTone');
	
	exports.default = _default;

/***/ },
/* 5385 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"
	}), 'ShowChart');
	
	exports.default = _default;

/***/ },
/* 5386 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99l1.5 1.5z"
	}), 'ShowChartOutlined');
	
	exports.default = _default;

/***/ },
/* 5387 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.2 17.78l5.3-5.3 3.25 3.25c.41.41 1.07.39 1.45-.04l7.17-8.07c.35-.39.33-.99-.04-1.37-.4-.4-1.07-.39-1.45.04l-6.39 7.18-3.29-3.29a.9959.9959 0 00-1.41 0l-6.09 6.1c-.39.39-.39 1.02 0 1.41l.09.09c.39.39 1.03.39 1.41 0z"
	}), 'ShowChartRounded');
	
	exports.default = _default;

/***/ },
/* 5388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99l1.5 1.5z"
	}), 'ShowChartSharp');
	
	exports.default = _default;

/***/ },
/* 5389 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.5 13.48l-4-4L2 16.99l1.5 1.5 6-6.01 4 4L22 6.92l-1.41-1.41z"
	}), 'ShowChartTwoTone');
	
	exports.default = _default;

/***/ },
/* 5390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z"
	}), 'Shuffle');
	
	exports.default = _default;

/***/ },
/* 5391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z"
	}), 'ShuffleOutlined');
	
	exports.default = _default;

/***/ },
/* 5392 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.59 9.17L6.12 4.7a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l4.46 4.46 1.42-1.4zm4.76-4.32l1.19 1.19L4.7 17.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L17.96 7.46l1.19 1.19c.31.31.85.09.85-.36V4.5c0-.28-.22-.5-.5-.5h-3.79c-.45 0-.67.54-.36.85zm-.52 8.56l-1.41 1.41 3.13 3.13-1.2 1.2c-.31.31-.09.85.36.85h3.79c.28 0 .5-.22.5-.5v-3.79c0-.45-.54-.67-.85-.35l-1.19 1.19-3.13-3.14z"
	}), 'ShuffleRounded');
	
	exports.default = _default;

/***/ },
/* 5393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z"
	}), 'ShuffleSharp');
	
	exports.default = _default;

/***/ },
/* 5394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4h-5.5l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5zM5.41 4L4 5.41l5.17 5.17 1.42-1.41zM20 20v-5.5l-2.04 2.04-3.13-3.13-1.41 1.41 3.13 3.13L14.5 20z"
	}), 'ShuffleTwoTone');
	
	exports.default = _default;

/***/ },
/* 5395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 1H9v2h6V1zm4.03 6.39l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-.32-5H6.35c.57 1.62 1.82 2.92 3.41 3.56l-.11-.06 2.03-3.5zm5.97-4c-.57-1.6-1.78-2.89-3.34-3.54L12.26 11h5.39zm-7.04 7.83c.45.11.91.17 1.39.17 1.34 0 2.57-.45 3.57-1.19l-2.11-3.9-2.85 4.92zM7.55 8.99C6.59 10.05 6 11.46 6 13c0 .34.04.67.09 1h4.72L7.55 8.99zm8.79 8.14C17.37 16.06 18 14.6 18 13c0-.34-.04-.67-.09-1h-4.34l2.77 5.13zm-3.01-9.98C12.9 7.06 12.46 7 12 7c-1.4 0-2.69.49-3.71 1.29l2.32 3.56 2.72-4.7z"
	}), 'ShutterSpeed');
	
	exports.default = _default;

/***/ },
/* 5396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 1H9v2h6V1zm4.03 6.39l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-.32-5H6.35c.57 1.62 1.82 2.92 3.41 3.56l-.11-.06 2.03-3.5zm5.97-4c-.57-1.6-1.78-2.89-3.34-3.54L12.26 11h5.39zm-7.04 7.83c.45.11.91.17 1.39.17 1.34 0 2.57-.45 3.57-1.19l-2.11-3.9-2.85 4.92zM7.55 8.99C6.59 10.05 6 11.46 6 13c0 .34.04.67.09 1h4.72L7.55 8.99zm8.79 8.14C17.37 16.06 18 14.6 18 13c0-.34-.04-.67-.09-1h-4.34l2.77 5.13zm-3.01-9.98C12.9 7.06 12.46 7 12 7c-1.4 0-2.69.49-3.71 1.29l2.32 3.56 2.72-4.7z"
	}), 'ShutterSpeedOutlined');
	
	exports.default = _default;

/***/ },
/* 5397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 3h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1zm9.03 4.39l.75-.75c.38-.38.39-1.01 0-1.4l-.01-.01c-.39-.39-1.01-.38-1.4 0l-.75.75C16.07 4.74 14.12 4 12 4c-4.8 0-8.88 3.96-9 8.76C2.87 17.84 6.94 22 12 22c4.98 0 9-4.03 9-9 0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-1.19-5h-3.7c-.38 0-.62.4-.45.74.56 1.12 1.44 2.01 2.57 2.57.23.11.52.02.65-.21l1.37-2.35c.19-.33-.05-.75-.44-.75zm3.92-7.35c-.23-.12-.52-.02-.65.2l-1.38 2.39c-.2.34.04.76.43.76h3.76c.38 0 .62-.4.45-.73-.58-1.13-1.49-2.04-2.61-2.62zm-.85 7.05c-.19-.34-.68-.35-.87-.01l-2.04 3.52c-.18.32.02.72.39.75 1.34.14 2.69-.18 3.83-.89.22-.14.28-.43.16-.66l-1.47-2.71zm-3.57-1.47L7.93 9.57c-.2-.3-.64-.3-.84 0-.81 1.16-1.17 2.57-1.05 3.98.02.26.24.45.5.45h3.35c.39 0 .63-.44.42-.77zm3.66-.49l2.02 3.74c.18.33.64.35.86.05.86-1.18 1.24-2.62 1.12-4.08-.02-.26-.25-.45-.5-.45h-3.05c-.39 0-.63.4-.45.74zm-3.8-1.57c.2.31.66.3.85-.02l1.94-3.35c.19-.32-.03-.72-.4-.76-1.36-.12-2.73.21-3.88.97-.22.15-.27.46-.13.68l1.62 2.48z"
	}), 'ShutterSpeedRounded');
	
	exports.default = _default;

/***/ },
/* 5398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 1H9v2h6V1zm4.03 6.39l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-.32-5H6.35c.57 1.62 1.82 2.92 3.41 3.56l-.11-.06 2.03-3.5zm5.97-4c-.57-1.6-1.78-2.89-3.34-3.54L12.26 11h5.39zm-7.04 7.83c.45.11.91.17 1.39.17 1.34 0 2.57-.45 3.57-1.19l-2.11-3.9-2.85 4.92zM7.55 8.99C6.59 10.05 6 11.46 6 13c0 .34.04.67.09 1h4.72L7.55 8.99zm8.79 8.14C17.37 16.06 18 14.6 18 13c0-.34-.04-.67-.09-1h-4.34l2.77 5.13zm-3.01-9.98C12.9 7.06 12.46 7 12 7c-1.4 0-2.69.49-3.71 1.29l2.32 3.56 2.72-4.7z"
	}), 'ShutterSpeedSharp');
	
	exports.default = _default;

/***/ },
/* 5399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 6c-3.87 0-7 3.13-7 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm0 1c.46 0 .9.06 1.33.15l-2.72 4.7-2.32-3.56C9.31 7.49 10.6 7 12 7zm-6 6c0-1.54.59-2.95 1.55-4.01L10.81 14H6.09c-.05-.33-.09-.66-.09-1zm.35 2h5.33l-2.03 3.5.11.06c-1.59-.64-2.84-1.94-3.41-3.56zM12 19c-.48 0-.94-.06-1.39-.17l2.85-4.92 2.11 3.9c-1 .74-2.23 1.19-3.57 1.19zm6-6c0 1.6-.63 3.06-1.66 4.13L13.57 12h4.34c.05.33.09.66.09 1zm-5.74-2l2.05-3.54c1.56.65 2.77 1.94 3.34 3.54h-5.39z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M7.55 8.99C6.59 10.05 6 11.46 6 13c0 .34.04.67.09 1h4.72L7.55 8.99zm6.76-1.53L12.26 11h5.39c-.57-1.6-1.78-2.89-3.34-3.54zm-.98-.31C12.9 7.06 12.46 7 12 7c-1.4 0-2.69.49-3.71 1.29l2.32 3.56 2.72-4.7zM11.68 15H6.35c.57 1.62 1.82 2.92 3.41 3.56l-.11-.06 2.03-3.5zm7.35-7.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zM9 1h6v2H9zm7.34 16.13C17.37 16.06 18 14.6 18 13c0-.34-.04-.67-.09-1h-4.34l2.77 5.13zm-5.73 1.7c.45.11.91.17 1.39.17 1.34 0 2.57-.45 3.57-1.19l-2.11-3.9-2.85 4.92z"
	})), 'ShutterSpeedTwoTone');
	
	exports.default = _default;

/***/ },
/* 5400 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M2 22h20V2z"
	}), 'SignalCellular0Bar');
	
	exports.default = _default;

/***/ },
/* 5401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M2 22h20V2L2 22z"
	})), 'SignalCellular0BarOutlined');
	
	exports.default = _default;

/***/ },
/* 5402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M4.41 22H20c1.1 0 2-.9 2-2V4.41c0-.89-1.08-1.34-1.71-.71L3.71 20.29c-.63.63-.19 1.71.7 1.71z"
	}), 'SignalCellular0BarRounded');
	
	exports.default = _default;

/***/ },
/* 5403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M2 22h20V2L2 22z"
	}), 'SignalCellular0BarSharp');
	
	exports.default = _default;

/***/ },
/* 5404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M2 22h20V2L2 22z"
	}), 'SignalCellular0BarTwoTone');
	
	exports.default = _default;

/***/ },
/* 5405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M2 22h20V2z"
	}), _react.default.createElement("path", {
	  d: "M12 12L2 22h10z"
	})), 'SignalCellular1Bar');
	
	exports.default = _default;

/***/ },
/* 5406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M2 22h20V2L2 22z"
	}), _react.default.createElement("path", {
	  d: "M12 12L2 22h10V12z"
	})), 'SignalCellular1BarOutlined');
	
	exports.default = _default;

/***/ },
/* 5407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M4.41 22H20c1.1 0 2-.9 2-2V4.41c0-.89-1.08-1.34-1.71-.71L3.71 20.29c-.63.63-.19 1.71.7 1.71z"
	}), _react.default.createElement("path", {
	  d: "M12 12l-8.29 8.29c-.63.63-.19 1.71.7 1.71H12V12z"
	})), 'SignalCellular1BarRounded');
	
	exports.default = _default;

/***/ },
/* 5408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M2 22h20V2L2 22z"
	}), _react.default.createElement("path", {
	  d: "M12 12L2 22h10V12z"
	})), 'SignalCellular1BarSharp');
	
	exports.default = _default;

/***/ },
/* 5409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M2 22h20V2L2 22z"
	}), _react.default.createElement("path", {
	  d: "M12 12L2 22h10V12z"
	})), 'SignalCellular1BarTwoTone');
	
	exports.default = _default;

/***/ },
/* 5410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M2 22h20V2z"
	}), _react.default.createElement("path", {
	  d: "M14 10L2 22h12z"
	})), 'SignalCellular2Bar');
	
	exports.default = _default;

/***/ },
/* 5411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M2 22h20V2L2 22z"
	}), _react.default.createElement("path", {
	  d: "M14 10L2 22h12V10z"
	})), 'SignalCellular2BarOutlined');
	
	exports.default = _default;

/***/ },
/* 5412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M4.41 22H20c1.1 0 2-.9 2-2V4.41c0-.89-1.08-1.34-1.71-.71L3.71 20.29c-.63.63-.19 1.71.7 1.71z"
	}), _react.default.createElement("path", {
	  d: "M14 10L3.71 20.29c-.63.63-.19 1.71.7 1.71H14V10z"
	})), 'SignalCellular2BarRounded');
	
	exports.default = _default;

/***/ },
/* 5413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M2 22h20V2L2 22z"
	}), _react.default.createElement("path", {
	  d: "M14 10L2 22h12V10z"
	})), 'SignalCellular2BarSharp');
	
	exports.default = _default;

/***/ },
/* 5414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M2 22h20V2L2 22z"
	}), _react.default.createElement("path", {
	  d: "M14 10L2 22h12V10z"
	})), 'SignalCellular2BarTwoTone');
	
	exports.default = _default;

/***/ },
/* 5415 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M2 22h20V2z"
	}), _react.default.createElement("path", {
	  d: "M17 7L2 22h15z"
	})), 'SignalCellular3Bar');
	
	exports.default = _default;

/***/ },
/* 5416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M2 22h20V2L2 22z"
	}), _react.default.createElement("path", {
	  d: "M17 7L2 22h15V7z"
	})), 'SignalCellular3BarOutlined');
	
	exports.default = _default;

/***/ },
/* 5417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M4.41 22H20c1.1 0 2-.9 2-2V4.41c0-.89-1.08-1.34-1.71-.71L3.71 20.29c-.63.63-.19 1.71.7 1.71z"
	}), _react.default.createElement("path", {
	  d: "M17 7L3.71 20.29c-.63.63-.19 1.71.7 1.71H17V7z"
	})), 'SignalCellular3BarRounded');
	
	exports.default = _default;

/***/ },
/* 5418 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M2 22h20V2L2 22z"
	}), _react.default.createElement("path", {
	  d: "M17 7L2 22h15V7z"
	})), 'SignalCellular3BarSharp');
	
	exports.default = _default;

/***/ },
/* 5419 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M2 22h20V2L2 22z"
	}), _react.default.createElement("path", {
	  d: "M17 7L2 22h15V7z"
	})), 'SignalCellular3BarTwoTone');
	
	exports.default = _default;

/***/ },
/* 5420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 22h20V2z"
	}), 'SignalCellular4Bar');
	
	exports.default = _default;

/***/ },
/* 5421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 22h20V2L2 22z"
	}), 'SignalCellular4BarOutlined');
	
	exports.default = _default;

/***/ },
/* 5422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.41 22H20c1.1 0 2-.9 2-2V4.41c0-.89-1.08-1.34-1.71-.71L3.71 20.29c-.63.63-.19 1.71.7 1.71z"
	}), 'SignalCellular4BarRounded');
	
	exports.default = _default;

/***/ },
/* 5423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 22h20V2L2 22z"
	}), 'SignalCellular4BarSharp');
	
	exports.default = _default;

/***/ },
/* 5424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 22h20V2L2 22z"
	}), 'SignalCellular4BarTwoTone');
	
	exports.default = _default;

/***/ },
/* 5425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 4h3v16h-3zM5 14h3v6H5zm6-5h3v11h-3z"
	}), 'SignalCellularAlt');
	
	exports.default = _default;

/***/ },
/* 5426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 4h3v16h-3V4zM5 14h3v6H5v-6zm6-5h3v11h-3V9z"
	}), 'SignalCellularAltOutlined');
	
	exports.default = _default;

/***/ },
/* 5427 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.5 4c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5v-13c0-.83.67-1.5 1.5-1.5zm-12 10c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5S5 19.33 5 18.5v-3c0-.83.67-1.5 1.5-1.5zm6-5c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5v-8c0-.83.67-1.5 1.5-1.5z"
	}), 'SignalCellularAltRounded');
	
	exports.default = _default;

/***/ },
/* 5428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 4h3v16h-3V4zM5 14h3v6H5v-6zm6-5h3v11h-3V9z"
	}), 'SignalCellularAltSharp');
	
	exports.default = _default;

/***/ },
/* 5429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 4h3v16h-3V4zM5 14h3v6H5v-6zm6-5h3v11h-3V9z"
	}), 'SignalCellularAltTwoTone');
	
	exports.default = _default;

/***/ },
/* 5430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M22 8V2L2 22h16V8z"
	}), _react.default.createElement("path", {
	  d: "M20 22h2v-2h-2v2zm0-12v8h2v-8h-2z"
	})), 'SignalCellularConnectedNoInternet0Bar');
	
	exports.default = _default;

/***/ },
/* 5431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M22 8V2L2 22h16V8h4z"
	}), _react.default.createElement("path", {
	  d: "M20 22h2v-2h-2v2zm0-12v8h2v-8h-2z"
	})), 'SignalCellularConnectedNoInternet0BarOutlined');
	
	exports.default = _default;

/***/ },
/* 5432 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M22 8V4.41c0-.89-1.08-1.34-1.71-.71L3.71 20.29c-.63.63-.19 1.71.7 1.71H18V11c0-1.66 1.34-3 3-3h1z"
	}), _react.default.createElement("path", {
	  d: "M20 22h2v-2h-2v2zm0-11v6c0 .55.45 1 1 1s1-.45 1-1v-6c0-.55-.45-1-1-1s-1 .45-1 1z"
	})), 'SignalCellularConnectedNoInternet0BarRounded');
	
	exports.default = _default;

/***/ },
/* 5433 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M22 8V2L2 22h16V8h4z"
	}), _react.default.createElement("path", {
	  d: "M20 22h2v-2h-2v2zm0-12v8h2v-8h-2z"
	})), 'SignalCellularConnectedNoInternet0BarSharp');
	
	exports.default = _default;

/***/ },
/* 5434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M22 8V2L2 22h16V8h4z"
	}), _react.default.createElement("path", {
	  d: "M20 22h2v-2h-2v2zm0-12v8h2v-8h-2z"
	})), 'SignalCellularConnectedNoInternet0BarTwoTone');
	
	exports.default = _default;

/***/ },
/* 5435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M22 8V2L2 22h16V8z"
	}), _react.default.createElement("path", {
	  d: "M20 10v8h2v-8h-2zm-8 12V12L2 22h10zm8 0h2v-2h-2v2z"
	})), 'SignalCellularConnectedNoInternet1Bar');
	
	exports.default = _default;

/***/ },
/* 5436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M22 8V2L2 22h16V8h4z"
	}), _react.default.createElement("path", {
	  d: "M20 10v8h2v-8h-2zm-8 12V12L2 22h10zm8 0h2v-2h-2v2z"
	})), 'SignalCellularConnectedNoInternet1BarOutlined');
	
	exports.default = _default;

/***/ },
/* 5437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M22 8V4.41c0-.89-1.08-1.34-1.71-.71L3.71 20.29c-.63.63-.19 1.71.7 1.71H18V11c0-1.66 1.34-3 3-3h1z"
	}), _react.default.createElement("path", {
	  d: "M20 11v6c0 .55.45 1 1 1s1-.45 1-1v-6c0-.55-.45-1-1-1s-1 .45-1 1zm-8 11V12l-8.29 8.29c-.63.63-.19 1.71.7 1.71H12zm8 0h2v-2h-2v2z"
	})), 'SignalCellularConnectedNoInternet1BarRounded');
	
	exports.default = _default;

/***/ },
/* 5438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M22 8V2L2 22h16V8h4z"
	}), _react.default.createElement("path", {
	  d: "M20 10v8h2v-8h-2zm-8 12V12L2 22h10zm8 0h2v-2h-2v2z"
	})), 'SignalCellularConnectedNoInternet1BarSharp');
	
	exports.default = _default;

/***/ },
/* 5439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M22 8V2L2 22h16V8h4z"
	}), _react.default.createElement("path", {
	  d: "M20 10v8h2v-8h-2zm-8 12V12L2 22h10zm8 0h2v-2h-2v2z"
	})), 'SignalCellularConnectedNoInternet1BarTwoTone');
	
	exports.default = _default;

/***/ },
/* 5440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M22 8V2L2 22h16V8z"
	}), _react.default.createElement("path", {
	  d: "M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z"
	})), 'SignalCellularConnectedNoInternet2Bar');
	
	exports.default = _default;

/***/ },
/* 5441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M22 8V2L2 22h16V8h4z"
	}), _react.default.createElement("path", {
	  d: "M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z"
	})), 'SignalCellularConnectedNoInternet2BarOutlined');
	
	exports.default = _default;

/***/ },
/* 5442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M22 8V4.41c0-.89-1.08-1.34-1.71-.71L3.71 20.29c-.63.63-.19 1.71.7 1.71H18V11c0-1.66 1.34-3 3-3h1z"
	}), _react.default.createElement("path", {
	  d: "M14 22V10L3.71 20.29c-.63.63-.19 1.71.7 1.71H14zm6-11v6c0 .55.45 1 1 1s1-.45 1-1v-6c0-.55-.45-1-1-1s-1 .45-1 1zm0 11h2v-2h-2v2z"
	})), 'SignalCellularConnectedNoInternet2BarRounded');
	
	exports.default = _default;

/***/ },
/* 5443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M22 8V2L2 22h16V8h4z"
	}), _react.default.createElement("path", {
	  d: "M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z"
	})), 'SignalCellularConnectedNoInternet2BarSharp');
	
	exports.default = _default;

/***/ },
/* 5444 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M22 8V2L2 22h16V8h4z"
	}), _react.default.createElement("path", {
	  d: "M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z"
	})), 'SignalCellularConnectedNoInternet2BarTwoTone');
	
	exports.default = _default;

/***/ },
/* 5445 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M22 8V2L2 22h16V8z"
	}), _react.default.createElement("path", {
	  d: "M17 22V7L2 22h15zm3-12v8h2v-8h-2zm0 12h2v-2h-2v2z"
	})), 'SignalCellularConnectedNoInternet3Bar');
	
	exports.default = _default;

/***/ },
/* 5446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M22 8V2L2 22h16V8h4z"
	}), _react.default.createElement("path", {
	  d: "M18 22V6L2 22h16zm2-12v8h2v-8h-2zm0 12h2v-2h-2v2z"
	})), 'SignalCellularConnectedNoInternet3BarOutlined');
	
	exports.default = _default;

/***/ },
/* 5447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M22 8V4.41c0-.89-1.08-1.34-1.71-.71L3.71 20.29c-.63.63-.19 1.71.7 1.71H18V11c0-1.66 1.34-3 3-3h1z"
	}), _react.default.createElement("path", {
	  d: "M18 22V6L3.71 20.29c-.63.63-.19 1.71.7 1.71H18zm2-11v6c0 .55.45 1 1 1s1-.45 1-1v-6c0-.55-.45-1-1-1s-1 .45-1 1zm0 11h2v-2h-2v2z"
	})), 'SignalCellularConnectedNoInternet3BarRounded');
	
	exports.default = _default;

/***/ },
/* 5448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M22 8V2L2 22h16V8h4z"
	}), _react.default.createElement("path", {
	  d: "M18 22V6L2 22h16zm2-12v8h2v-8h-2zm0 12h2v-2h-2v2z"
	})), 'SignalCellularConnectedNoInternet3BarSharp');
	
	exports.default = _default;

/***/ },
/* 5449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M22 8V2L2 22h16V8h4z"
	}), _react.default.createElement("path", {
	  d: "M18 22V6L2 22h16zm2-12v8h2v-8h-2zm0 12h2v-2h-2v2z"
	})), 'SignalCellularConnectedNoInternet3BarTwoTone');
	
	exports.default = _default;

/***/ },
/* 5450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z"
	}), 'SignalCellularConnectedNoInternet4Bar');
	
	exports.default = _default;

/***/ },
/* 5451 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z"
	}), 'SignalCellularConnectedNoInternet4BarOutlined');
	
	exports.default = _default;

/***/ },
/* 5452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 18c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1zm-1 4h2v-2h-2v2zM4.41 22H18V11c0-1.66 1.34-3 3-3h1V4.41c0-.89-1.08-1.34-1.71-.71L3.71 20.29c-.63.63-.19 1.71.7 1.71z"
	}), 'SignalCellularConnectedNoInternet4BarRounded');
	
	exports.default = _default;

/***/ },
/* 5453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z"
	}), 'SignalCellularConnectedNoInternet4BarSharp');
	
	exports.default = _default;

/***/ },
/* 5454 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z"
	}), 'SignalCellularConnectedNoInternet4BarTwoTone');
	
	exports.default = _default;

/***/ },
/* 5455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z"
	}), 'SignalCellularNoSim');
	
	exports.default = _default;

/***/ },
/* 5456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.83 5H17v9.11l2 2V5c0-1.1-.9-2-2-2h-7L7.94 5.06l1.42 1.42L10.83 5zm10.43 16.21L3.79 3.74 2.38 5.15 5 7.77V19c0 1.11.9 2 2 2h11.23l1.62 1.62 1.41-1.41zM7 19V9.79L16.23 19H7z"
	}), 'SignalCellularNoSimOutlined');
	
	exports.default = _default;

/***/ },
/* 5457 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5c0-1.1-.9-2-2-2h-6.17c-.53 0-1.04.21-1.42.59L7.95 5.06 19 16.11V5zM3.09 4.44c-.39.39-.39 1.02 0 1.41L5 7.78V19c0 1.11.9 2 2 2h11.23l.91.91c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L4.5 4.44a.9959.9959 0 00-1.41 0z"
	}), 'SignalCellularNoSimRounded');
	
	exports.default = _default;

/***/ },
/* 5458 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-9L7.95 5.06 19 16.11zm-15.21.74L2.38 5.15 5 7.77V21h13.23l1.62 1.62 1.41-1.41z"
	}), 'SignalCellularNoSimSharp');
	
	exports.default = _default;

/***/ },
/* 5459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M10.83 5L9.36 6.47 17 14.11V5zM7 9.79V19h9.23z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M10.83 5H17v9.11l2 2V5c0-1.1-.9-2-2-2h-7L7.94 5.06l1.42 1.42L10.83 5zm10.43 16.21L3.79 3.74 2.38 5.15 5 7.77V19c0 1.11.9 2 2 2h11.23l1.62 1.62 1.41-1.41zM7 19V9.79L16.23 19H7z"
	})), 'SignalCellularNoSimTwoTone');
	
	exports.default = _default;

/***/ },
/* 5460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z"
	}), 'SignalCellularNull');
	
	exports.default = _default;

/***/ },
/* 5461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z"
	}), 'SignalCellularNullOutlined');
	
	exports.default = _default;

/***/ },
/* 5462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6.83V19c0 .55-.45 1-1 1H6.83L20 6.83m.29-3.12L3.71 20.29c-.63.63-.19 1.71.7 1.71H20c1.1 0 2-.9 2-2V4.41c0-.89-1.08-1.33-1.71-.7z"
	}), 'SignalCellularNullRounded');
	
	exports.default = _default;

/***/ },
/* 5463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z"
	}), 'SignalCellularNullSharp');
	
	exports.default = _default;

/***/ },
/* 5464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z"
	}), 'SignalCellularNullTwoTone');
	
	exports.default = _default;

/***/ },
/* 5465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 1l-8.59 8.59L21 18.18V1zM4.77 4.5L3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73 4.77 4.5z"
	}), 'SignalCellularOff');
	
	exports.default = _default;

/***/ },
/* 5466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 1l-8.31 8.31 8.31 8.3zM4.91 4.36L3.5 5.77l6.36 6.37L1 21h17.73l2 2 1.41-1.41z"
	}), 'SignalCellularOffOutlined');
	
	exports.default = _default;

/***/ },
/* 5467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3.41c0-.89-1.08-1.34-1.71-.71l-6.6 6.6L21 17.61V3.41zm.44 17.47L5.62 5.06a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l5.66 5.66-7.16 7.16c-.63.63-.19 1.71.7 1.71h15.32l1.29 1.29c.39.39 1.02.39 1.41 0 .4-.39.4-1.02.01-1.41z"
	}), 'SignalCellularOffRounded');
	
	exports.default = _default;

/***/ },
/* 5468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 1l-8.31 8.31 8.31 8.3zM4.91 4.36L3.5 5.77l6.36 6.37L1 21h17.73l2 2 1.41-1.41z"
	}), 'SignalCellularOffSharp');
	
	exports.default = _default;

/***/ },
/* 5469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 1l-8.31 8.31 8.31 8.3zM4.91 4.36L3.5 5.77l6.36 6.37L1 21h17.73l2 2 1.41-1.41z"
	}), 'SignalCellularOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 5470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
	}), 'SignalWifi0Bar');
	
	exports.default = _default;

/***/ },
/* 5471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
	})), 'SignalWifi0BarOutlined');
	
	exports.default = _default;

/***/ },
/* 5472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l10.08 12.56c.8 1 2.32 1 3.12 0L23.64 7z"
	})), 'SignalWifi0BarRounded');
	
	exports.default = _default;

/***/ },
/* 5473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
	})), 'SignalWifi0BarSharp');
	
	exports.default = _default;

/***/ },
/* 5474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
	})), 'SignalWifi0BarTwoTone');
	
	exports.default = _default;

/***/ },
/* 5475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
	}), _react.default.createElement("path", {
	  d: "M6.67 14.86L12 21.49v.01l.01-.01 5.33-6.63C17.06 14.65 15.03 13 12 13s-5.06 1.65-5.33 1.86z"
	})), 'SignalWifi1Bar');
	
	exports.default = _default;

/***/ },
/* 5476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
	}), _react.default.createElement("path", {
	  d: "M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M6.7 14.9l5.3 6.6 3.5-4.3v-2.6c0-.2 0-.5.1-.7-.9-.5-2.2-.9-3.6-.9-3 0-5.1 1.7-5.3 1.9z"
	})), 'SignalWifi1BarLock');
	
	exports.default = _default;

/***/ },
/* 5477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.5 14.5c0-2.8 2.2-5 5-5 .36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5l3.5-4.36V14.5z"
	}), _react.default.createElement("path", {
	  d: "M15.5 14.5c0-.23.04-.46.07-.68-.92-.43-2.14-.82-3.57-.82-3 0-5.1 1.7-5.3 1.9l5.3 6.6 3.5-4.36V14.5zM23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
	})), 'SignalWifi1BarLockOutlined');
	
	exports.default = _default;

/***/ },
/* 5478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.5 14.5c0-2.8 2.2-5 5-5 .36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l10.08 12.56c.8 1 2.32 1 3.12 0l1.94-2.42V14.5z"
	}), _react.default.createElement("path", {
	  d: "M15.5 14.5c0-.23.04-.46.07-.68-.92-.43-2.14-.82-3.57-.82-3 0-5.1 1.7-5.3 1.9l3.74 4.66c.8 1 2.32 1 3.12 0l1.94-2.42V14.5zM23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
	})), 'SignalWifi1BarLockRounded');
	
	exports.default = _default;

/***/ },
/* 5479 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M23 16v-1.34c0-1.47-1.2-2.75-2.66-2.66-1.33.09-2.34 1.16-2.34 2.5V16h-1v6h7v-6h-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.5 14.5c0-2.8 2.2-5 5-5 .36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5l3.5-4.36V14.5z"
	}), _react.default.createElement("path", {
	  d: "M15.5 14.5c0-.23.04-.46.07-.68-.92-.43-2.14-.82-3.57-.82-3 0-5.1 1.7-5.3 1.9l5.3 6.6 3.5-4.36V14.5z"
	})), 'SignalWifi1BarLockSharp');
	
	exports.default = _default;

/***/ },
/* 5480 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.5 14.5c0-2.8 2.2-5 5-5 .36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5l3.5-4.36V14.5z"
	}), _react.default.createElement("path", {
	  d: "M15.5 14.5c0-.23.04-.46.07-.68-.92-.43-2.14-.82-3.57-.82-3 0-5.1 1.7-5.3 1.9l5.3 6.6 3.5-4.36V14.5zM23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
	})), 'SignalWifi1BarLockTwoTone');
	
	exports.default = _default;

/***/ },
/* 5481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
	}), _react.default.createElement("path", {
	  d: "M6.67 14.86L12 21.49v.01l.01-.01 5.33-6.63C17.06 14.65 15.03 13 12 13s-5.06 1.65-5.33 1.86z"
	})), 'SignalWifi1BarOutlined');
	
	exports.default = _default;

/***/ },
/* 5482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6.67 14.86l3.77 4.7c.8 1 2.32 1 3.12 0l3.78-4.7C17.06 14.65 15.03 13 12 13s-5.06 1.65-5.33 1.86z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l10.08 12.56c.8 1 2.32 1 3.12 0L23.64 7z"
	})), 'SignalWifi1BarRounded');
	
	exports.default = _default;

/***/ },
/* 5483 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
	}), _react.default.createElement("path", {
	  d: "M6.67 14.86L12 21.49v.01l.01-.01 5.33-6.63C17.06 14.65 15.03 13 12 13s-5.06 1.65-5.33 1.86z"
	})), 'SignalWifi1BarSharp');
	
	exports.default = _default;

/***/ },
/* 5484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
	}), _react.default.createElement("path", {
	  d: "M6.67 14.86L12 21.49v.01l.01-.01 5.33-6.63C17.06 14.65 15.03 13 12 13s-5.06 1.65-5.33 1.86z"
	})), 'SignalWifi1BarTwoTone');
	
	exports.default = _default;

/***/ },
/* 5485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
	}), _react.default.createElement("path", {
	  d: "M4.79 12.52l7.2 8.98H12l.01-.01 7.2-8.98C18.85 12.24 16.1 10 12 10s-6.85 2.24-7.21 2.52z"
	})), 'SignalWifi2Bar');
	
	exports.default = _default;

/***/ },
/* 5486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
	}), _react.default.createElement("path", {
	  d: "M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4.8 12.5l7.2 9 3.5-4.4v-2.6c0-1.3.5-2.5 1.4-3.4C15.6 10.5 14 10 12 10c-4.1 0-6.8 2.2-7.2 2.5z"
	})), 'SignalWifi2BarLock');
	
	exports.default = _default;

/***/ },
/* 5487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.5 14.5c0-2.8 2.2-5 5-5 .36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5l3.5-4.36V14.5z"
	}), _react.default.createElement("path", {
	  d: "M15.5 14.5c0-1.34.51-2.53 1.34-3.42C15.62 10.51 13.98 10 12 10c-4.1 0-6.8 2.2-7.2 2.5l7.2 9 3.5-4.38V14.5zM23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
	})), 'SignalWifi2BarLockOutlined');
	
	exports.default = _default;

/***/ },
/* 5488 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.5 14.5c0-2.8 2.2-5 5-5 .36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l10.08 12.56c.8 1 2.32 1 3.12 0l1.94-2.42V14.5z"
	}), _react.default.createElement("path", {
	  d: "M15.5 14.5c0-1.34.51-2.53 1.34-3.42C15.62 10.51 13.98 10 12 10c-4.1 0-6.8 2.2-7.2 2.5l5.64 7.05c.8 1 2.32 1 3.12 0l1.94-2.42V14.5zM23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
	})), 'SignalWifi2BarLockRounded');
	
	exports.default = _default;

/***/ },
/* 5489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16h-1v6h7v-6h-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
	}), _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.5 14.5c0-2.8 2.2-5 5-5 .36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5l3.5-4.36V14.5z"
	}), _react.default.createElement("path", {
	  d: "M15.5 14.5c0-1.34.51-2.53 1.34-3.42C15.62 10.51 13.98 10 12 10c-4.1 0-6.8 2.2-7.2 2.5l7.2 9 3.5-4.38V14.5z"
	})), 'SignalWifi2BarLockSharp');
	
	exports.default = _default;

/***/ },
/* 5490 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.5 14.5c0-2.8 2.2-5 5-5 .36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5l3.5-4.36V14.5z"
	}), _react.default.createElement("path", {
	  d: "M15.5 14.5c0-1.34.51-2.53 1.34-3.42C15.62 10.51 13.98 10 12 10c-4.1 0-6.8 2.2-7.2 2.5l7.2 9 3.5-4.38V14.5zM23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
	})), 'SignalWifi2BarLockTwoTone');
	
	exports.default = _default;

/***/ },
/* 5491 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5 23.64 7z"
	}), _react.default.createElement("path", {
	  d: "M4.79 12.52L12 21.5l7.21-8.99C18.85 12.24 16.1 10 12 10s-6.85 2.24-7.21 2.52z"
	})), 'SignalWifi2BarOutlined');
	
	exports.default = _default;

/***/ },
/* 5492 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l10.08 12.56c.8 1 2.32 1 3.12 0L23.64 7z"
	}), _react.default.createElement("path", {
	  d: "M4.79 12.52l5.65 7.04c.8 1 2.32 1 3.12 0l5.65-7.05C18.85 12.24 16.1 10 12 10s-6.85 2.24-7.21 2.52z"
	})), 'SignalWifi2BarRounded');
	
	exports.default = _default;

/***/ },
/* 5493 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5 23.64 7z"
	}), _react.default.createElement("path", {
	  d: "M4.79 12.52L12 21.5l7.21-8.99C18.85 12.24 16.1 10 12 10s-6.85 2.24-7.21 2.52z"
	})), 'SignalWifi2BarSharp');
	
	exports.default = _default;

/***/ },
/* 5494 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5 23.64 7z"
	}), _react.default.createElement("path", {
	  d: "M4.79 12.52L12 21.5l7.21-8.99C18.85 12.24 16.1 10 12 10s-6.85 2.24-7.21 2.52z"
	})), 'SignalWifi2BarTwoTone');
	
	exports.default = _default;

/***/ },
/* 5495 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
	}), _react.default.createElement("path", {
	  d: "M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z"
	})), 'SignalWifi3Bar');
	
	exports.default = _default;

/***/ },
/* 5496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 3C5.3 3 .8 6.7.4 7l3.2 3.9L12 21.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7.3-.1.5-.2.8-.2.3-.1.6-.1.9-.1.4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-10 5.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7C17.3 9 14.9 8 12 8c-4.8 0-8 2.6-8.5 2.9"
	})), 'SignalWifi3BarLock');
	
	exports.default = _default;

/***/ },
/* 5497 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.5 14.5c0-2.8 2.2-5 5-5 .36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5l3.5-4.36V14.5z"
	}), _react.default.createElement("path", {
	  d: "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-6.5-1.5c0-2.19 1.35-3.99 3.27-4.68C17.29 8.98 14.94 8 12 8c-4.81 0-8.04 2.62-8.47 2.95L12 21.5l3.5-4.36V14.5z"
	})), 'SignalWifi3BarLockOutlined');
	
	exports.default = _default;

/***/ },
/* 5498 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.5 14.5c0-2.8 2.2-5 5-5 .36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l10.08 12.56c.8 1 2.32 1 3.12 0l1.94-2.42V14.5z"
	}), _react.default.createElement("path", {
	  d: "M15.5 14.5c0-2.19 1.35-3.99 3.27-4.68C17.29 8.98 14.94 8 12 8c-4.81 0-8.04 2.62-8.47 2.95l6.91 8.61c.8 1 2.32 1 3.12 0l1.94-2.42V14.5zM23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
	})), 'SignalWifi3BarLockRounded');
	
	exports.default = _default;

/***/ },
/* 5499 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.5 14.5c0-2.8 2.2-5 5-5 .36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5l3.5-4.36V14.5z"
	}), _react.default.createElement("path", {
	  d: "M23 16v-1.34c0-1.47-1.2-2.75-2.66-2.66-1.33.09-2.34 1.16-2.34 2.5V16h-1v6h7v-6h-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-6.5-1.5c0-2.19 1.35-3.99 3.27-4.68C17.29 8.98 14.94 8 12 8c-4.81 0-8.04 2.62-8.47 2.95L12 21.5l3.5-4.36V14.5z"
	})), 'SignalWifi3BarLockSharp');
	
	exports.default = _default;

/***/ },
/* 5500 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M15.5 14.5c0-2.8 2.2-5 5-5 .36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5l3.5-4.36V14.5z"
	}), _react.default.createElement("path", {
	  d: "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-6.5-1.5c0-2.19 1.35-3.99 3.27-4.68C17.29 8.98 14.94 8 12 8c-4.81 0-8.04 2.62-8.47 2.95L12 21.5l3.5-4.36V14.5z"
	})), 'SignalWifi3BarLockTwoTone');
	
	exports.default = _default;

/***/ },
/* 5501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5 23.64 7z"
	}), _react.default.createElement("path", {
	  d: "M3.53 10.95L12 21.5l8.47-10.55C20.04 10.62 16.81 8 12 8s-8.04 2.62-8.47 2.95z"
	})), 'SignalWifi3BarOutlined');
	
	exports.default = _default;

/***/ },
/* 5502 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l10.08 12.56c.8 1 2.32 1 3.12 0L23.64 7z"
	}), _react.default.createElement("path", {
	  d: "M3.53 10.95l6.91 8.61c.8 1 2.32 1 3.12 0l6.91-8.61C20.04 10.62 16.81 8 12 8s-8.04 2.62-8.47 2.95z"
	})), 'SignalWifi3BarRounded');
	
	exports.default = _default;

/***/ },
/* 5503 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5 23.64 7z"
	}), _react.default.createElement("path", {
	  d: "M3.53 10.95L12 21.5l8.47-10.55C20.04 10.62 16.81 8 12 8s-8.04 2.62-8.47 2.95z"
	})), 'SignalWifi3BarSharp');
	
	exports.default = _default;

/***/ },
/* 5504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  fillOpacity: ".3",
	  d: "M23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5 23.64 7z"
	}), _react.default.createElement("path", {
	  d: "M3.53 10.95L12 21.5l8.47-10.55C20.04 10.62 16.81 8 12 8s-8.04 2.62-8.47 2.95z"
	})), 'SignalWifi3BarTwoTone');
	
	exports.default = _default;

/***/ },
/* 5505 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
	}), 'SignalWifi4Bar');
	
	exports.default = _default;

/***/ },
/* 5506 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-6.5-1.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.4v-2.6z"
	}), 'SignalWifi4BarLock');
	
	exports.default = _default;

/***/ },
/* 5507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.5 9.5c.36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5l3.5-4.36V14.5c0-2.8 2.2-5 5-5zM23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
	}), 'SignalWifi4BarLockOutlined');
	
	exports.default = _default;

/***/ },
/* 5508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.55 9.61L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l10.08 12.56c.8 1 2.32 1 3.12 0l1.94-2.42V14.5c0-2.8 2.2-5 5-5 .36 0 .71.04 1.05.11zM23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
	}), 'SignalWifi4BarLockRounded');
	
	exports.default = _default;

/***/ },
/* 5509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.5 9.5c.36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5l3.5-4.36V14.5c0-2.8 2.2-5 5-5zM23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16h-1v6h7v-6h-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
	}), 'SignalWifi4BarLockSharp');
	
	exports.default = _default;

/***/ },
/* 5510 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.5 9.5c.36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5l3.5-4.36V14.5c0-2.8 2.2-5 5-5zM23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
	}), 'SignalWifi4BarLockTwoTone');
	
	exports.default = _default;

/***/ },
/* 5511 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
	}), 'SignalWifi4BarOutlined');
	
	exports.default = _default;

/***/ },
/* 5512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l10.08 12.56c.8 1 2.32 1 3.12 0L23.64 7z"
	}), 'SignalWifi4BarRounded');
	
	exports.default = _default;

/***/ },
/* 5513 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
	}), 'SignalWifi4BarSharp');
	
	exports.default = _default;

/***/ },
/* 5514 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
	}), 'SignalWifi4BarTwoTone');
	
	exports.default = _default;

/***/ },
/* 5515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23.64 7c-.45-.34-4.93-4-11.64-4-1.5 0-2.89.19-4.15.48L18.18 13.8 23.64 7zm-6.6 8.22L3.27 1.44 2 2.72l2.05 2.06C1.91 5.76.59 6.82.36 7l11.63 14.49.01.01.01-.01 3.9-4.86 3.32 3.32 1.27-1.27-3.46-3.46z"
	}), 'SignalWifiOff');
	
	exports.default = _default;

/***/ },
/* 5516 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23.64 7c-.45-.34-4.93-4-11.64-4-1.32 0-2.55.14-3.69.38L18.43 13.5 23.64 7zM3.41 1.31L2 2.72l2.05 2.05C1.91 5.76.59 6.82.36 7L12 21.5l3.91-4.87 3.32 3.32 1.41-1.41L3.41 1.31z"
	}), 'SignalWifiOffOutlined');
	
	exports.default = _default;

/***/ },
/* 5517 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23.64 7c-.45-.34-4.93-4-11.64-4-1.32 0-2.55.14-3.69.38L18.43 13.5 23.64 7zM4.12 2.01a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l1.35 1.35C1.91 5.76.59 6.82.36 7l10.08 12.56c.8 1 2.32 1 3.12 0l2.35-2.93 2.61 2.61c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L4.12 2.01z"
	}), 'SignalWifiOffRounded');
	
	exports.default = _default;

/***/ },
/* 5518 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23.64 7c-.45-.34-4.93-4-11.64-4-1.32 0-2.55.14-3.69.38L18.43 13.5 23.64 7zM3.41 1.31L2 2.72l2.05 2.05C1.91 5.76.59 6.82.36 7L12 21.5l3.91-4.87 3.32 3.32 1.41-1.41L3.41 1.31z"
	}), 'SignalWifiOffSharp');
	
	exports.default = _default;

/***/ },
/* 5519 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23.64 7c-.45-.34-4.93-4-11.64-4-1.32 0-2.55.14-3.69.38L18.43 13.5 23.64 7zM3.41 1.31L2 2.72l2.05 2.05C1.91 5.76.59 6.82.36 7L12 21.5l3.91-4.87 3.32 3.32 1.41-1.41L3.41 1.31z"
	}), 'SignalWifiOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 5520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.99 4c0-1.1-.89-2-1.99-2h-8L4 8v12c0 1.1.9 2 2 2h12.01c1.1 0 1.99-.9 1.99-2l-.01-16zM9 19H7v-2h2v2zm8 0h-2v-2h2v2zm-8-4H7v-4h2v4zm4 4h-2v-4h2v4zm0-6h-2v-2h2v2zm4 2h-2v-4h2v4z"
	}), 'SimCard');
	
	exports.default = _default;

/***/ },
/* 5521 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 2h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 2v16H6V8.83L10.83 4H18zM7 17h2v2H7zm8 0h2v2h-2zm-8-6h2v4H7zm4 4h2v4h-2zm0-4h2v2h-2zm4 0h2v4h-2z"
	}), 'SimCardOutlined');
	
	exports.default = _default;

/***/ },
/* 5522 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.99 4c0-1.1-.89-2-1.99-2h-7.17c-.53 0-1.04.21-1.42.59L4.59 7.41C4.21 7.79 4 8.3 4 8.83V20c0 1.1.9 2 2 2h12.01c1.1 0 1.99-.9 1.99-2l-.01-16zM8 19c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-8-4c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm4 4c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm0-6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm4 2c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1z"
	}), 'SimCardRounded');
	
	exports.default = _default;

/***/ },
/* 5523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.99 2H10L4 8v14h16l-.01-20zM9 19H7v-2h2v2zm8 0h-2v-2h2v2zm-8-4H7v-4h2v4zm4 4h-2v-4h2v4zm0-6h-2v-2h2v2zm4 2h-2v-4h2v4z"
	}), 'SimCardSharp');
	
	exports.default = _default;

/***/ },
/* 5524 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 8.83V20h12V4h-7.17L6 8.83zM9 19H7v-2h2v2zm0-4H7v-4h2v4zm6-4h2v4h-2v-4zm0 6h2v2h-2v-2zm-4-6h2v2h-2v-2zm0 4h2v4h-2v-4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 2h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 2v16H6V8.83L10.83 4H18zM7 17h2v2H7zm8 0h2v2h-2zm-8-6h2v4H7zm4 4h2v4h-2zm0-4h2v2h-2zm4 0h2v4h-2z"
	})), 'SimCardTwoTone');
	
	exports.default = _default;

/***/ },
/* 5525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 12c0-1.1-.9-2-2-2V7c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33L6 19h1l.67-2h8.67l.66 2h1l.67-2H20v-5zm-4-2h-3V7h3v3zM8 7h3v3H8V7zm-2 5h12v3H6v-3z"
	}), 'SingleBed');
	
	exports.default = _default;

/***/ },
/* 5526 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 12c0-1.1-.9-2-2-2V7c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33L6 19h1l.67-2h8.67l.66 2h1l.67-2H20v-5zm-4-2h-3V7h3v3zM8 7h3v3H8V7zm-2 5h12v3H6v-3z"
	}), 'SingleBedOutlined');
	
	exports.default = _default;

/***/ },
/* 5527 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 10V7c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33l.51 1.53c.1.28.36.47.66.47.3 0 .56-.19.66-.47L7.67 17h8.67l.51 1.53c.09.28.35.47.65.47.3 0 .56-.19.66-.47l.51-1.53H20v-5c0-1.1-.9-2-2-2zm-7 0H8V8c0-.55.45-1 1-1h2v3zm5 0h-3V7h2c.55 0 1 .45 1 1v2z"
	}), 'SingleBedRounded');
	
	exports.default = _default;

/***/ },
/* 5528 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 10V5H6v5H4v7h1.33L6 19h1l.67-2h8.67l.66 2h1l.67-2H20v-7h-2zm-7 0H8V7h3v3zm5 0h-3V7h3v3z"
	}), 'SingleBedSharp');
	
	exports.default = _default;

/***/ },
/* 5529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 12h12v3H6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 10V7c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33L6 19h1l.67-2h8.67l.66 2h1l.67-2H20v-5c0-1.1-.9-2-2-2zm-5-3h3v3h-3V7zM8 7h3v3H8V7zm10 8H6v-3h12v3z"
	})), 'SingleBedTwoTone');
	
	exports.default = _default;

/***/ },
/* 5530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"
	}), 'SkipNext');
	
	exports.default = _default;

/***/ },
/* 5531 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 18l8.5-6L6 6v12zm2-8.14L11.03 12 8 14.14V9.86zM16 6h2v12h-2z"
	}), 'SkipNextOutlined');
	
	exports.default = _default;

/***/ },
/* 5532 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.58 16.89l5.77-4.07c.56-.4.56-1.24 0-1.63L7.58 7.11C6.91 6.65 6 7.12 6 7.93v8.14c0 .81.91 1.28 1.58.82zM16 7v10c0 .55.45 1 1 1s1-.45 1-1V7c0-.55-.45-1-1-1s-1 .45-1 1z"
	}), 'SkipNextRounded');
	
	exports.default = _default;

/***/ },
/* 5533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"
	}), 'SkipNextSharp');
	
	exports.default = _default;

/***/ },
/* 5534 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 9.86v4.28L11.03 12z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M14.5 12L6 6v12l8.5-6zM8 9.86L11.03 12 8 14.14V9.86zM16 6h2v12h-2z"
	})), 'SkipNextTwoTone');
	
	exports.default = _default;

/***/ },
/* 5535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 6h2v12H6zm3.5 6l8.5 6V6z"
	}), 'SkipPrevious');
	
	exports.default = _default;

/***/ },
/* 5536 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 6h2v12H6zm3.5 6l8.5 6V6l-8.5 6zm6.5 2.14L12.97 12 16 9.86v4.28z"
	}), 'SkipPreviousOutlined');
	
	exports.default = _default;

/***/ },
/* 5537 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 6c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1s-1-.45-1-1V7c0-.55.45-1 1-1zm3.66 6.82l5.77 4.07c.66.47 1.58-.01 1.58-.82V7.93c0-.81-.91-1.28-1.58-.82l-5.77 4.07c-.57.4-.57 1.24 0 1.64z"
	}), 'SkipPreviousRounded');
	
	exports.default = _default;

/***/ },
/* 5538 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 6h2v12H6V6zm3.5 6l8.5 6V6l-8.5 6z"
	}), 'SkipPreviousSharp');
	
	exports.default = _default;

/***/ },
/* 5539 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16 14.14V9.86L12.97 12z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M6 6h2v12H6zm12 12V6l-8.5 6 8.5 6zm-2-3.86L12.97 12 16 9.86v4.28z"
	})), 'SkipPreviousTwoTone');
	
	exports.default = _default;

/***/ },
/* 5540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
	}), 'Slideshow');
	
	exports.default = _default;

/***/ },
/* 5541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
	}), 'SlideshowOutlined');
	
	exports.default = _default;

/***/ },
/* 5542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 9.04v5.92c0 .42.48.65.81.39l3.7-2.96c.25-.2.25-.58 0-.78l-3.7-2.96c-.33-.26-.81-.03-.81.39zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1z"
	}), 'SlideshowRounded');
	
	exports.default = _default;

/***/ },
/* 5543 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 8v8l5-4-5-4zm11-5H3v18h18V3zm-2 16H5V5h14v14z"
	}), 'SlideshowSharp');
	
	exports.default = _default;

/***/ },
/* 5544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14V5H5v14zm5-11l5 4-5 4V8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM10 8v8l5-4z"
	})), 'SlideshowTwoTone');
	
	exports.default = _default;

/***/ },
/* 5545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.05 9.79L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zM11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zm1.61 6.74C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43zM22 12c0 5.16-3.92 9.42-8.95 9.95v-2.02C16.97 19.41 20 16.05 20 12s-3.03-7.41-6.95-7.93V2.05C18.08 2.58 22 6.84 22 12z"
	}), 'SlowMotionVideo');
	
	exports.default = _default;

/***/ },
/* 5546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.05 9.79L10 7.5v9l3.05-2.29L16 12l-2.95-2.21zm0 0L10 7.5v9l3.05-2.29L16 12l-2.95-2.21zm0 0L10 7.5v9l3.05-2.29L16 12l-2.95-2.21zM11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zm1.61 6.74C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43zM22 12c0 5.16-3.92 9.42-8.95 9.95v-2.02C16.97 19.41 20 16.05 20 12s-3.03-7.41-6.95-7.93V2.05C18.08 2.58 22 6.84 22 12z"
	}), 'SlowMotionVideoOutlined');
	
	exports.default = _default;

/***/ },
/* 5547 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 8.5v7c0 .41.47.65.8.4l4.67-3.5c.27-.2.27-.6 0-.8L10.8 8.1c-.33-.25-.8-.01-.8.4zm1-5.27c0-.64-.59-1.13-1.21-.99-1.12.26-2.18.7-3.12 1.3-.53.34-.61 1.1-.16 1.55.32.32.83.4 1.21.16.77-.49 1.62-.85 2.54-1.05.44-.1.74-.51.74-.97zM5.1 6.51c-.46-.45-1.21-.38-1.55.16-.6.94-1.04 2-1.3 3.12-.14.62.34 1.21.98 1.21.45 0 .87-.3.96-.74.2-.91.57-1.77 1.05-2.53.26-.39.18-.9-.14-1.22zM3.23 13c-.64 0-1.13.59-.99 1.21.26 1.12.7 2.17 1.3 3.12.34.54 1.1.61 1.55.16.32-.32.4-.83.15-1.21-.49-.76-.85-1.61-1.05-2.53-.09-.45-.5-.75-.96-.75zm3.44 7.45c.95.6 2 1.04 3.12 1.3.62.14 1.21-.35 1.21-.98 0-.45-.3-.87-.74-.96-.91-.2-1.77-.57-2.53-1.05-.39-.24-.89-.17-1.21.16-.46.44-.39 1.19.15 1.53zM22 12c0 4.73-3.3 8.71-7.73 9.74-.62.15-1.22-.34-1.22-.98 0-.46.31-.86.75-.97 3.55-.82 6.2-4 6.2-7.79s-2.65-6.97-6.2-7.79c-.44-.1-.75-.51-.75-.97 0-.64.6-1.13 1.22-.98C18.7 3.29 22 7.27 22 12z"
	}), 'SlowMotionVideoRounded');
	
	exports.default = _default;

/***/ },
/* 5548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.05 9.79L10 7.5v9l3.05-2.29L16 12l-2.95-2.21zm0 0L10 7.5v9l3.05-2.29L16 12l-2.95-2.21zm0 0L10 7.5v9l3.05-2.29L16 12l-2.95-2.21zM11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zm1.61 6.74C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43zM22 12c0 5.16-3.92 9.42-8.95 9.95v-2.02C16.97 19.41 20 16.05 20 12s-3.03-7.41-6.95-7.93V2.05C18.08 2.58 22 6.84 22 12z"
	}), 'SlowMotionVideoSharp');
	
	exports.default = _default;

/***/ },
/* 5549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.26 18.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89H2.05c.2 2.01 1 3.84 2.21 5.32zM7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69zM2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11zm11-8.95v2.02C16.97 4.59 20 7.95 20 12s-3.03 7.41-6.95 7.93v2.02C18.08 21.42 22 17.16 22 12c0-5.16-3.92-9.42-8.95-9.95zM16 12l-2.95-2.21L10 7.5v9l3.05-2.29zM5.68 19.74C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43z"
	}), 'SlowMotionVideoTwoTone');
	
	exports.default = _default;

/***/ },
/* 5550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
	}), 'Smartphone');
	
	exports.default = _default;

/***/ },
/* 5551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
	}), 'SmartphoneOutlined');
	
	exports.default = _default;

/***/ },
/* 5552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
	}), 'SmartphoneRounded');
	
	exports.default = _default;

/***/ },
/* 5553 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 1v22h14V1H5zm12 18H7V5h10v14z"
	}), 'SmartphoneSharp');
	
	exports.default = _default;

/***/ },
/* 5554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 5h10v14H7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
	})), 'SmartphoneTwoTone');
	
	exports.default = _default;

/***/ },
/* 5555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 6l6.99 7H2v3h9.99l7 7 1.26-1.25-17-17zm18.5 7H22v3h-1.5zM18 13h1.5v3H18zm.85-8.12c.62-.61 1-1.45 1-2.38h-1.5c0 1.02-.83 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.92c0-2.23-1.28-4.15-3.15-5.04zM14.5 8.7h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.59c0-1.8-1.6-3.16-3.47-3.16H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75V2c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35zm2.5 7.23V13h-2.93z"
	}), 'SmokeFree');
	
	exports.default = _default;

/***/ },
/* 5556 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.5 13H22v3h-1.5zM18 13h1.5v3H18zm-1 0h-2.34L17 15.34zm-2.5-4.35h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35zm4.35-3.92c.62-.61 1-1.45 1-2.38h-1.5c0 1.02-.83 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.76c0-2.22-1.28-4.14-3.15-5.03zM3.41 4.59L2 6l7 7H2v3h10l7 7 1.41-1.41z"
	}), 'SmokeFreeOutlined');
	
	exports.default = _default;

/***/ },
/* 5557 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.5 13H22v3h-1.5zM18 13h1.5v3H18zm-1 1.5c0-.83-.67-1.5-1.5-1.5h-.84l2.18 2.18c.1-.21.16-.44.16-.68zm1.96-12.15H19h-.04zm-.11 2.38c.38-.38.67-.84.84-1.35.16-.5-.19-1.01-.71-1.02-.34.01-.61.25-.72.58-.18.55-.62.99-1.17 1.17-.34.11-.59.39-.59.74V5c0 .37.27.69.64.75 1.93.31 3.36 2 3.36 4.02v1.48c0 .41.34.75.75.75s.75-.34.75-.75V9.76c0-2.22-1.28-4.14-3.15-5.03zm-4.24 3.92h1.42c1.05 0 1.97.74 1.97 2.05v.55c0 .41.33.75.75.75h.01c.41 0 .75-.33.75-.75v-.89c0-1.81-1.6-3.16-3.47-3.16h-1.3c-1.02 0-1.94-.73-2.07-1.75-.12-.95.46-1.7 1.3-1.93.32-.09.54-.38.54-.72 0-.49-.46-.86-.93-.72-1.42.41-2.45 1.73-2.42 3.28.02 1.85 1.61 3.29 3.45 3.29zM4.12 5.29a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L9 13H3.5c-.83 0-1.5.67-1.5 1.5S2.67 16 3.5 16H12l6.29 6.29c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L4.12 5.29z"
	}), 'SmokeFreeRounded');
	
	exports.default = _default;

/***/ },
/* 5558 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.5 13H22v3h-1.5zm-6-4.35h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35zM17 13h-2.34L17 15.34zm1.85-8.27c.62-.61 1-1.45 1-2.38h-1.5c0 1.02-.83 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.76c0-2.22-1.28-4.14-3.15-5.03zM18 13h1.5v3H18zM3.41 4.59L2 6l7 7H2v3h10l7 7 1.41-1.41z"
	}), 'SmokeFreeSharp');
	
	exports.default = _default;

/***/ },
/* 5559 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.5 13H22v3h-1.5zM18 13h1.5v3H18zm.85-8.27c.62-.61 1-1.45 1-2.38h-1.5c0 1.02-.83 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.76c0-2.22-1.28-4.14-3.15-5.03zM14.5 8.65h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35zM17 13h-2.34L17 15.34zM3.41 4.59L2 6l7 7H2v3h10l7 7 1.41-1.41z"
	}), 'SmokeFreeTwoTone');
	
	exports.default = _default;

/***/ },
/* 5560 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 16h15v3H2zm18.5 0H22v3h-1.5zM18 16h1.5v3H18zm.85-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03zm-2.82 2.47H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16z"
	}), 'SmokingRooms');
	
	exports.default = _default;

/***/ },
/* 5561 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 16h1.5v3H18zM2 16h15v3H2zm14.03-5.8H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16zM20.5 16H22v3h-1.5zm-1.65-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03z"
	}), 'SmokingRoomsOutlined');
	
	exports.default = _default;

/***/ },
/* 5562 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 16h-12c-.83 0-1.5.67-1.5 1.5S2.67 19 3.5 19h12c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5zm3.35-8.27c.62-.61 1-1.45 1-2.38 0-1.51-1-2.79-2.38-3.21-.48-.14-.97.22-.97.72 0 .33.21.62.52.71.77.23 1.33.94 1.33 1.78 0 .82-.53 1.51-1.27 1.76-.33.11-.58.39-.58.74V8c0 .37.27.69.64.75 1.93.31 3.36 2 3.36 4.02v1.48c0 .41.34.75.75.75s.75-.34.75-.75v-1.49c0-2.22-1.28-4.14-3.15-5.03zm-2.82 2.47h-1.3c-1.02 0-1.94-.73-2.07-1.75-.12-.95.46-1.7 1.3-1.93.32-.09.54-.38.54-.72 0-.49-.46-.86-.93-.72-1.42.41-2.45 1.73-2.42 3.28.03 1.84 1.62 3.29 3.46 3.29h1.42c1.05 0 1.97.74 1.97 2.05v.55c0 .41.33.75.75.75h.01c.41 0 .75-.33.75-.75v-.89c-.01-1.81-1.61-3.16-3.48-3.16zM18 16h1.5v3H18zm2.5 0H22v3h-1.5z"
	}), 'SmokingRoomsRounded');
	
	exports.default = _default;

/***/ },
/* 5563 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 16h15v3H2v-3zm18.5 0H22v3h-1.5v-3zM18 16h1.5v3H18v-3zm.85-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03zm-2.82 2.47H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16z"
	}), 'SmokingRoomsSharp');
	
	exports.default = _default;

/***/ },
/* 5564 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M2 16h15v3H2v-3zm18.5 0H22v3h-1.5v-3zM18 16h1.5v3H18v-3zm.85-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03zm-2.82 2.47H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M2 16h15v3H2v-3zm18.5 0H22v3h-1.5v-3zM18 16h1.5v3H18v-3zm.85-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03zm-2.82 2.47H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16z"
	})), 'SmokingRoomsTwoTone');
	
	exports.default = _default;

/***/ },
/* 5565 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
	}), 'Sms');
	
	exports.default = _default;

/***/ },
/* 5566 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z"
	}), 'SmsFailed');
	
	exports.default = _default;

/***/ },
/* 5567 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-9-4h2v2h-2zm0-6h2v4h-2z"
	}), 'SmsFailedOutlined');
	
	exports.default = _default;

/***/ },
/* 5568 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm-1-4c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1z"
	}), 'SmsFailedRounded');
	
	exports.default = _default;

/***/ },
/* 5569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H2v20l4-4h16V2zm-9 12h-2v-2h2v2zm0-4h-2V6h2v4z"
	}), 'SmsFailedSharp');
	
	exports.default = _default;

/***/ },
/* 5570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 17.17L5.17 16H20V4H4v13.17zM11 6h2v4h-2V6zm0 6h2v2h-2v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-9-4h2v2h-2zm0-6h2v4h-2z"
	})), 'SmsFailedTwoTone');
	
	exports.default = _default;

/***/ },
/* 5571 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zM7 9h2v2H7zm8 0h2v2h-2zm-4 0h2v2h-2z"
	}), 'SmsOutlined');
	
	exports.default = _default;

/***/ },
/* 5572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
	}), 'SmsRounded');
	
	exports.default = _default;

/***/ },
/* 5573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H2v20l4-4h16V2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
	}), 'SmsSharp');
	
	exports.default = _default;

/***/ },
/* 5574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 17.17L5.17 16H20V4H4v13.17zM15 9h2v2h-2V9zm-4 0h2v2h-2V9zM7 9h2v2H7V9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zM7 9h2v2H7zm8 0h2v2h-2zm-4 0h2v2h-2z"
	})), 'SmsTwoTone');
	
	exports.default = _default;

/***/ },
/* 5575 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-3-9h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9v2z"
	}), 'Snooze');
	
	exports.default = _default;

/***/ },
/* 5576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 11h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9v2zm7.056-7.654l1.282-1.535 4.607 3.85-1.28 1.54zM3.336 7.19l-1.28-1.536L6.662 1.81l1.28 1.536zM12 6c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7m0-2c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9z"
	}), 'SnoozeOutlined');
	
	exports.default = _default;

/***/ },
/* 5577 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 11h2.63l-3.72 4.35C8.36 16 8.82 17 9.67 17H14c.55 0 1-.45 1-1s-.45-1-1-1h-2.63l3.72-4.35c.55-.65.09-1.65-.76-1.65H10c-.55 0-1 .45-1 1s.45 1 1 1zm11.3-4.58c-.35.42-.98.48-1.41.13l-3.07-2.56c-.42-.36-.48-.99-.12-1.41.35-.42.98-.48 1.41-.13l3.07 2.56c.42.36.48.99.12 1.41zm-18.6 0c.35.43.98.48 1.4.13l3.07-2.56c.43-.36.49-.99.13-1.41-.35-.43-.98-.48-1.4-.13L2.82 5.01c-.42.36-.48.99-.12 1.41zM12 6c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7m0-2c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9z"
	}), 'SnoozeRounded');
	
	exports.default = _default;

/***/ },
/* 5578 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 11h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9v2zm7.056-7.654l1.282-1.535 4.607 3.85-1.28 1.54zM3.336 7.19l-1.28-1.536L6.662 1.81l1.28 1.536zM12 6c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7m0-2c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9z"
	}), 'SnoozeSharp');
	
	exports.default = _default;

/***/ },
/* 5579 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 11h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9zm8.337-9.19l4.607 3.845-1.28 1.535-4.61-3.843zm-10.674 0l1.282 1.536L3.337 7.19l-1.28-1.536zM12 4c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
	}), 'SnoozeTwoTone');
	
	exports.default = _default;

/***/ },
/* 5580 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"
	}), 'Sort');
	
	exports.default = _default;

/***/ },
/* 5581 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.94 4.66h-4.72l2.36-2.36zm-4.69 14.71h4.66l-2.33 2.33zM6.1 6.27L1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27H6.1zm-1.13 7.37l1.94-5.18 1.94 5.18H4.97zm10.76 2.5h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26l-5.93 8.6z"
	}), 'SortByAlpha');
	
	exports.default = _default;

/***/ },
/* 5582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.94 4.66h-4.72l2.36-2.36 2.36 2.36zm-4.69 14.71h4.66l-2.33 2.33-2.33-2.33zM6.1 6.27L1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27H6.1zm-1.13 7.37l1.94-5.18 1.94 5.18H4.97zm10.76 2.5h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26l-5.93 8.6z"
	}), 'SortByAlphaOutlined');
	
	exports.default = _default;

/***/ },
/* 5583 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.93 2.65c-.2-.2-.51-.2-.71 0l-2.01 2.01h4.72l-2-2.01zm-.7 18.7c.2.2.51.2.71 0l1.98-1.98h-4.66l1.97 1.98zm-1.25-3.62c.6 0 1.01-.6.79-1.16L8.04 7.03c-.18-.46-.63-.76-1.12-.76-.49 0-.94.3-1.12.76l-3.74 9.53c-.22.56.19 1.16.79 1.16.35 0 .67-.22.8-.55l.71-1.9h5.11l.71 1.9c.13.34.45.56.8.56zm-6.01-4.09l1.94-5.18 1.94 5.18H4.97zm16.08 2.5h-5.33l5.72-8.29c.46-.66-.02-1.57-.82-1.57h-6.48c-.44 0-.79.36-.79.8v.01c0 .44.36.8.79.8h5.09l-5.73 8.28c-.46.66.02 1.57.82 1.57h6.72c.44 0 .79-.36.79-.79.02-.45-.34-.81-.78-.81z"
	}), 'SortByAlphaRounded');
	
	exports.default = _default;

/***/ },
/* 5584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.94 4.66h-4.72l2.36-2.36 2.36 2.36zm-4.69 14.71h4.66l-2.33 2.33-2.33-2.33zM6.1 6.27L1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27H6.1zm-1.13 7.37l1.94-5.18 1.94 5.18H4.97zm10.76 2.5h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26l-5.93 8.6z"
	}), 'SortByAlphaSharp');
	
	exports.default = _default;

/***/ },
/* 5585 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.94 4.66L12.58 2.3l-2.36 2.36zm-4.55 13.07h1.84L7.74 6.27H6.1L1.6 17.73h1.84l.92-2.45h5.11l.92 2.45zm-5.42-4.09l1.94-5.18 1.94 5.18H4.97zm7.61 8.06l2.33-2.33h-4.66zm9.08-14.16V6.28h-8.3v1.6h5.88l-5.92 8.56v1.29h8.53v-1.59h-6.12z"
	}), 'SortByAlphaTwoTone');
	
	exports.default = _default;

/***/ },
/* 5586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"
	}), 'SortOutlined');
	
	exports.default = _default;

/***/ },
/* 5587 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 18h4c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1zm1 6h10c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1z"
	}), 'SortRounded');
	
	exports.default = _default;

/***/ },
/* 5588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"
	}), 'SortSharp');
	
	exports.default = _default;

/***/ },
/* 5589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"
	}), 'SortTwoTone');
	
	exports.default = _default;

/***/ },
/* 5590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8.55 12c-1.07-.71-2.25-1.27-3.53-1.61 1.28.34 2.46.9 3.53 1.61zm10.43-1.61c-1.29.34-2.49.91-3.57 1.64 1.08-.73 2.28-1.3 3.57-1.64z"
	}), _react.default.createElement("path", {
	  d: "M15.49 9.63c-.18-2.79-1.31-5.51-3.43-7.63-2.14 2.14-3.32 4.86-3.55 7.63 1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-6.5 2.65c-.14-.1-.3-.19-.45-.29.15.11.31.19.45.29zm6.42-.25c-.13.09-.27.16-.4.26.13-.1.27-.17.4-.26zM12 15.45C9.85 12.17 6.18 10 2 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45z"
	})), 'Spa');
	
	exports.default = _default;

/***/ },
/* 5591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.49 9.63c-.18-2.79-1.31-5.51-3.43-7.63-2.14 2.14-3.32 4.86-3.55 7.63 1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-3.44-4.44c.63 1.03 1.07 2.18 1.3 3.38-.47.3-.91.63-1.34.98-.42-.34-.87-.67-1.33-.97.25-1.2.71-2.35 1.37-3.39zM12 15.45c-.82-1.25-1.86-2.34-3.06-3.2-.13-.09-.27-.16-.4-.26.13.09.27.17.39.25C6.98 10.83 4.59 10 2 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45zm1.32 4.15c-.44.15-.88.27-1.33.37-.44-.09-.87-.21-1.28-.36-3.29-1.18-5.7-3.99-6.45-7.35 1.1.26 2.15.71 3.12 1.33l-.02.01c.13.09.26.18.39.25l.07.04c.99.72 1.84 1.61 2.51 2.65L12 19.1l1.67-2.55c.69-1.05 1.55-1.95 2.53-2.66l.07-.05c.09-.05.18-.11.27-.17l-.01-.02c.98-.65 2.07-1.13 3.21-1.4-.75 3.37-3.15 6.18-6.42 7.35zm-4.33-7.32c-.02-.01-.04-.03-.05-.04 0 0 .01 0 .01.01.01.01.02.02.04.03z"
	}), 'SpaOutlined');
	
	exports.default = _default;

/***/ },
/* 5592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.49 9.63c-.16-2.42-1.03-4.79-2.64-6.76-.41-.5-1.16-.5-1.57 0-1.65 1.98-2.57 4.35-2.77 6.76 1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-6.5 2.65c-.14-.1-.3-.19-.45-.29.15.11.31.19.45.29zm6.42-.25c-.13.09-.27.16-.4.26.13-.1.27-.17.4-.26zM12 15.45c-1.95-2.97-5.14-5.03-8.83-5.39-.64-.06-1.17.47-1.11 1.11.45 4.8 3.65 8.78 7.98 10.33.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51 4.33-1.55 7.53-5.52 7.98-10.33.06-.64-.48-1.17-1.11-1.11-3.71.36-6.9 2.42-8.85 5.39z"
	}), 'SpaRounded');
	
	exports.default = _default;

/***/ },
/* 5593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.55 12c-1.07-.71-2.25-1.27-3.53-1.61 1.28.34 2.46.9 3.53 1.61zm10.43-1.61c-1.29.34-2.49.91-3.57 1.64 1.08-.73 2.28-1.3 3.57-1.64zm-3.49-.76c-.18-2.79-1.31-5.51-3.43-7.63-2.14 2.14-3.32 4.86-3.55 7.63 1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-6.5 2.65c-.14-.1-.3-.19-.45-.29.15.11.31.19.45.29zm6.42-.25c-.13.09-.27.16-.4.26.13-.1.27-.17.4-.26zM12 15.45C9.85 12.17 6.18 10 2 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45z"
	}), 'SpaSharp');
	
	exports.default = _default;

/***/ },
/* 5594 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8.55 12c-1.07-.71-2.25-1.27-3.53-1.61 1.28.34 2.46.9 3.53 1.61zm10.43-1.61c-1.29.34-2.49.91-3.57 1.64 1.08-.73 2.28-1.3 3.57-1.64z"
	}), _react.default.createElement("path", {
	  d: "M8.94 12.25c0-.01 0-.01 0 0-.13-.09-.27-.17-.4-.26.13.1.27.17.4.26zm4.41-3.67c-.22-1.21-.66-2.35-1.3-3.38-.66 1.04-1.12 2.19-1.37 3.39.46.3.9.62 1.33.97.42-.35.87-.68 1.34-.98zm3.19 5.08l.01.02c-.09.06-.18.12-.27.17l-.07.05c-.98.71-1.84 1.61-2.53 2.66L12 19.1l-1.67-2.55c-.68-1.03-1.52-1.92-2.51-2.65l-.07-.04c-.13-.08-.26-.16-.39-.25l.01-.01c-.96-.63-2.01-1.07-3.12-1.33.75 3.36 3.16 6.17 6.45 7.35.42.15.84.27 1.28.36.45-.09.89-.21 1.33-.37 3.27-1.17 5.67-3.98 6.43-7.34-1.14.26-2.23.73-3.2 1.39zm-7.55-1.38",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 15.45c-.82-1.25-1.86-2.34-3.06-3.2-.13-.09-.27-.16-.4-.26.13.09.27.17.39.25C6.98 10.83 4.59 10 2 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45zm1.32 4.15c-.44.15-.88.27-1.33.37-.44-.09-.87-.21-1.28-.36-3.29-1.18-5.7-3.99-6.45-7.35 1.1.26 2.15.71 3.12 1.33l-.02.01c.13.09.26.18.39.25l.07.04c.99.72 1.84 1.61 2.51 2.65L12 19.1l1.67-2.55c.69-1.05 1.55-1.95 2.53-2.66l.07-.05c.09-.05.18-.11.27-.17l-.01-.02c.98-.65 2.07-1.13 3.21-1.4-.75 3.37-3.15 6.18-6.42 7.35zm2.17-9.97c-.18-2.79-1.31-5.51-3.43-7.63-2.14 2.14-3.32 4.86-3.55 7.63 1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-3.44-4.44c.63 1.03 1.07 2.18 1.3 3.38-.47.3-.91.63-1.34.98-.42-.34-.87-.67-1.33-.97.25-1.2.71-2.35 1.37-3.39z"
	}), _react.default.createElement("path", {
	  d: "M8.99 12.28c-.02-.01-.04-.03-.05-.04 0 0 .01 0 .01.01.01.01.02.02.04.03z",
	  opacity: ".3"
	})), 'SpaTwoTone');
	
	exports.default = _default;

/***/ },
/* 5595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 9v4H6V9H4v6h16V9z"
	}), 'SpaceBar');
	
	exports.default = _default;

/***/ },
/* 5596 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 9v4H6V9H4v6h16V9h-2z"
	}), 'SpaceBarOutlined');
	
	exports.default = _default;

/***/ },
/* 5597 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 10v3H6v-3c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1s-1 .45-1 1z"
	}), 'SpaceBarRounded');
	
	exports.default = _default;

/***/ },
/* 5598 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 9v4H6V9H4v6h16V9h-2z"
	}), 'SpaceBarSharp');
	
	exports.default = _default;

/***/ },
/* 5599 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 13H6V9H4v6h16V9h-2z"
	}), 'SpaceBarTwoTone');
	
	exports.default = _default;

/***/ },
/* 5600 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 1.99 2 1.99L17 22c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 2c1.1 0 2 .9 2 2s-.9 2-2 2c-1.11 0-2-.9-2-2s.89-2 2-2zm0 16c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
	}), 'Speaker');
	
	exports.default = _default;

/***/ },
/* 5601 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18.2 1H9.8C8.81 1 8 1.81 8 2.8v14.4c0 .99.81 1.79 1.8 1.79l8.4.01c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8zM14 3c1.1 0 2 .89 2 2s-.9 2-2 2-2-.89-2-2 .9-2 2-2zm0 13.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
	}), _react.default.createElement("circle", {
	  cx: "14",
	  cy: "12.5",
	  r: "2.5"
	}), _react.default.createElement("path", {
	  d: "M6 5H4v16c0 1.1.89 2 2 2h10v-2H6V5z"
	})), 'SpeakerGroup');
	
	exports.default = _default;

/***/ },
/* 5602 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.2 1H9.8C8.81 1 8 1.81 8 2.8v14.4c0 .99.81 1.79 1.8 1.79l8.4.01c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8zM18 17l-8-.01V3h8v14zm-4-9c1.1 0 2-.89 2-2s-.9-2-2-2-2 .89-2 2 .9 2 2 2zm0 8c1.93 0 3.5-1.57 3.5-3.5S15.93 9 14 9s-3.5 1.57-3.5 3.5S12.07 16 14 16zm0-5c.83 0 1.5.67 1.5 1.5S14.83 14 14 14s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zM6 5H4v16c0 1.1.89 2 2 2h10v-2H6V5z"
	}), 'SpeakerGroupOutlined');
	
	exports.default = _default;

/***/ },
/* 5603 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18.2 1H9.8C8.81 1 8 1.81 8 2.8v14.4c0 .99.81 1.79 1.8 1.79l8.4.01c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8zM14 3c1.1 0 2 .89 2 2s-.9 2-2 2-2-.89-2-2 .9-2 2-2zm0 13.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
	}), _react.default.createElement("circle", {
	  cx: "14",
	  cy: "12.5",
	  r: "2.5"
	}), _react.default.createElement("path", {
	  d: "M5 5c-.55 0-1 .45-1 1v15c0 1.1.89 2 2 2h9c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1-.45-1-1V6c0-.55-.45-1-1-1z"
	})), 'SpeakerGroupRounded');
	
	exports.default = _default;

/***/ },
/* 5604 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 1H8v17.99h12V1zm-6 2c1.1 0 2 .89 2 2s-.9 2-2 2-2-.89-2-2 .9-2 2-2zm0 13.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
	}), _react.default.createElement("circle", {
	  cx: "14",
	  cy: "12.5",
	  r: "2.5"
	}), _react.default.createElement("path", {
	  d: "M6 5H4v18h12v-2H6z"
	})), 'SpeakerGroupSharp');
	
	exports.default = _default;

/***/ },
/* 5605 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M10 16.99l8 .01V3h-8v13.99zM14 4c1.1 0 2 .89 2 2s-.9 2-2 2-2-.89-2-2 .9-2 2-2zm0 5c1.93 0 3.5 1.57 3.5 3.5S15.93 16 14 16s-3.5-1.57-3.5-3.5S12.07 9 14 9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18.2 1H9.8C8.81 1 8 1.81 8 2.8v14.4c0 .99.81 1.79 1.8 1.79l8.4.01c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8zM18 17l-8-.01V3h8v14zm-4-9c1.1 0 2-.89 2-2s-.9-2-2-2-2 .89-2 2 .9 2 2 2zm0 8c1.93 0 3.5-1.57 3.5-3.5S15.93 9 14 9s-3.5 1.57-3.5 3.5S12.07 16 14 16zm0-5c.83 0 1.5.67 1.5 1.5S14.83 14 14 14s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zM6 5H4v16c0 1.1.89 2 2 2h10v-2H6V5z"
	})), 'SpeakerGroupTwoTone');
	
	exports.default = _default;

/***/ },
/* 5606 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 14H6v-2h2v2zm0-3H6V9h2v2zm0-3H6V6h2v2zm7 6h-5v-2h5v2zm3-3h-8V9h8v2zm0-3h-8V6h8v2z"
	}), 'SpeakerNotes');
	
	exports.default = _default;

/***/ },
/* 5607 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.54 11l-.54-.54L7.54 8 6 6.46 2.38 2.84 1.27 1.73 0 3l2.01 2.01L2 22l4-4h9l5.73 5.73L22 22.46 17.54 18l-7-7zM8 14H6v-2h2v2zm-2-3V9l2 2H6zm14-9H4.08L10 7.92V6h8v2h-7.92l1 1H18v2h-4.92l6.99 6.99C21.14 17.95 22 17.08 22 16V4c0-1.1-.9-2-2-2z"
	}), 'SpeakerNotesOff');
	
	exports.default = _default;

/***/ },
/* 5608 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4v12h-1.34l1.91 1.91C21.39 17.66 22 16.9 22 16V4c0-1.1-.9-2-2-2H4.66l2 2H20zM6 12h2v2H6zm12-3h-6.34l2 2H18zm0-3h-8v1.34l.66.66H18zM1.41 1.59L0 3l2.01 2.01L2 22l4-4h9l5.73 5.73 1.41-1.41L1.41 1.59zM5.17 16L4 17.17V7l2 2v2h2l5 5H5.17z"
	}), 'SpeakerNotesOffOutlined');
	
	exports.default = _default;

/***/ },
/* 5609 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1.91 2.36c-.35-.35-.92-.35-1.27 0s-.35.92 0 1.27l1.38 1.38L2 22l4-4h9l5.09 5.09c.35.35.92.35 1.27 0s.35-.92 0-1.27L1.91 2.36zM7 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm13-9H4.08l7 7H17c.55 0 1 .45 1 1s-.45 1-1 1h-3.92l6.99 6.99C21.14 17.95 22 17.08 22 16V4c0-1.1-.9-2-2-2zm-3 6h-6c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'SpeakerNotesOffRounded');
	
	exports.default = _default;

/***/ },
/* 5610 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1.27 1.73L0 3l2.01 2.01L2 22l4-4h9l5.73 5.73L22 22.46 1.27 1.73zM8 14H6v-2h2v2zm-2-3V9l2 2H6zm16-9H4.08L10 7.92V6h8v2h-7.92l1 1H18v2h-4.92l6.99 6.99H22V2z"
	}), 'SpeakerNotesOffSharp');
	
	exports.default = _default;

/***/ },
/* 5611 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 11V9L4 7v10.17L5.17 16H13l-5-5H6zm2 3H6v-2h2v2zM20 4H6.66L10 7.34V6h8v2h-7.34l1 1H18v2h-4.34l5 5H20z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 4v12h-1.34l1.91 1.91C21.39 17.66 22 16.9 22 16V4c0-1.1-.9-2-2-2H4.66l2 2H20zM6 12h2v2H6zm12-1V9h-6.34l2 2zm0-3V6h-8v1.34l.66.66zM1.41 1.59L0 3l2 2.01V22l4-4h9l5.73 5.73 1.41-1.41L1.41 1.59zM5.17 16L4 17.17V7l2 2v2h2l5 5H5.17z"
	})), 'SpeakerNotesOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 5612 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zM6 12h2v2H6zm0-3h2v2H6zm0-3h2v2H6zm4 6h5v2h-5zm0-3h8v2h-8zm0-3h8v2h-8z"
	}), 'SpeakerNotesOutlined');
	
	exports.default = _default;

/***/ },
/* 5613 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 14H6v-2h2v2zm0-3H6V9h2v2zm0-3H6V6h2v2zm6 6h-3c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1zm3-3h-6c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1zm0-3h-6c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'SpeakerNotesRounded');
	
	exports.default = _default;

/***/ },
/* 5614 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H2.01L2 22l4-4h16V2zM8 14H6v-2h2v2zm0-3H6V9h2v2zm0-3H6V6h2v2zm7 6h-5v-2h5v2zm3-3h-8V9h8v2zm0-3h-8V6h8v2z"
	}), 'SpeakerNotesSharp');
	
	exports.default = _default;

/***/ },
/* 5615 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 17.17l.59-.59.58-.58H20V4H4v13.17zM10 6h8v2h-8V6zm0 3h8v2h-8V9zm0 3h5v2h-5v-2zM6 6h2v2H6V6zm0 3h2v2H6V9zm0 3h2v2H6v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zM6 12h2v2H6zm0-3h2v2H6zm0-3h2v2H6zm4 6h5v2h-5zm0-3h8v2h-8zm0-3h8v2h-8z"
	})), 'SpeakerNotesTwoTone');
	
	exports.default = _default;

/***/ },
/* 5616 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 1.99 2 1.99L17 22c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM7 20V4h10v16H7zm5-11c1.1 0 2-.9 2-2s-.9-2-2-2c-1.11 0-2 .9-2 2s.89 2 2 2zm0 2c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'SpeakerOutlined');
	
	exports.default = _default;

/***/ },
/* 5617 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41C17.76 2.23 15.02 1 12 1zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z"
	}), 'SpeakerPhone');
	
	exports.default = _default;

/***/ },
/* 5618 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41C17.76 2.23 15.02 1 12 1zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z"
	}), 'SpeakerPhoneOutlined');
	
	exports.default = _default;

/***/ },
/* 5619 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.76 7.83l.02.02c.35.35.89.38 1.3.09.83-.57 1.84-.92 2.92-.92s2.09.35 2.92.93c.4.29.95.26 1.3-.09l.02-.02c.42-.42.39-1.14-.09-1.49C14.98 5.5 13.55 5 12 5s-2.98.5-4.14 1.34c-.49.35-.52 1.07-.1 1.49zM12 1c-2.62 0-5.03.93-6.92 2.47-.46.37-.51 1.06-.08 1.49.36.36.93.39 1.32.07C7.86 3.76 9.85 3 12 3s4.14.76 5.69 2.03c.39.32.96.29 1.32-.07.42-.42.38-1.11-.08-1.49C17.03 1.93 14.62 1 12 1zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z"
	}), 'SpeakerPhoneRounded');
	
	exports.default = _default;

/***/ },
/* 5620 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41C17.76 2.23 15.02 1 12 1zm3.99 9.01L8 10v11.99h7.99V10.01zM15 20H9v-8h6v8z"
	}), 'SpeakerPhoneSharp');
	
	exports.default = _default;

/***/ },
/* 5621 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9 12h6v8H9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41C17.76 2.23 15.02 1 12 1zM7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zm7.86 2.94L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z"
	})), 'SpeakerPhoneTwoTone');
	
	exports.default = _default;

/***/ },
/* 5622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 1.99 2 1.99L17 22c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 2c1.1 0 2 .9 2 2s-.9 2-2 2c-1.11 0-2-.9-2-2s.89-2 2-2zm0 16c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
	}), 'SpeakerRounded');
	
	exports.default = _default;

/***/ },
/* 5623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 2H5v19.99h14V2zm-7 2c1.1 0 2 .9 2 2s-.9 2-2 2c-1.11 0-2-.9-2-2s.89-2 2-2zm0 16c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
	}), 'SpeakerSharp');
	
	exports.default = _default;

/***/ },
/* 5624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 4v16h10V4H7zm5 1c1.1 0 2 .9 2 2s-.9 2-2 2c-1.11 0-2-.9-2-2s.89-2 2-2zm0 14c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 1.99 2 1.99L17 22c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM7 20V4h10v16H7zm5-11c1.1 0 2-.9 2-2s-.9-2-2-2c-1.11 0-2 .9-2 2s.89 2 2 2zm0 2c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	})), 'SpeakerTwoTone');
	
	exports.default = _default;

/***/ },
/* 5625 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.38 8.57l-1.23 1.85a8 8 0 01-.22 7.58H5.07A8 8 0 0115.58 6.85l1.85-1.23A10 10 0 003.35 19a2 2 0 001.72 1h13.85a2 2 0 001.74-1 10 10 0 00-.27-10.44zm-9.79 6.84a2 2 0 002.83 0l5.66-8.49-8.49 5.66a2 2 0 000 2.83z"
	}), 'Speed');
	
	exports.default = _default;

/***/ },
/* 5626 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20.38 8.57l-1.23 1.85a8 8 0 01-.22 7.58H5.07A8 8 0 0115.58 6.85l1.85-1.23A10 10 0 003.35 19a2 2 0 001.72 1h13.85a2 2 0 001.74-1 10 10 0 00-.27-10.44z"
	}), _react.default.createElement("path", {
	  d: "M10.59 15.41a2 2 0 002.83 0l5.66-8.49-8.49 5.66a2 2 0 000 2.83z"
	})), 'SpeedOutlined');
	
	exports.default = _default;

/***/ },
/* 5627 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19.46 10a1 1 0 00-.07 1 7.55 7.55 0 01.52 1.81 8 8 0 01-.69 4.73 1 1 0 01-.89.53H5.68a1 1 0 01-.89-.54A8 8 0 0113 6.06a7.69 7.69 0 012.11.56 1 1 0 001-.07 1 1 0 00-.17-1.76A10 10 0 003.35 19a2 2 0 001.72 1h13.85a2 2 0 001.74-1 10 10 0 00.55-8.89 1 1 0 00-1.75-.11z"
	}), _react.default.createElement("path", {
	  d: "M10.59 12.59a2 2 0 002.83 2.83l5.66-8.49z"
	})), 'SpeedRounded');
	
	exports.default = _default;

/***/ },
/* 5628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20.39 8.56l-1.24 1.86a8 8 0 01-.22 7.58H5.07A8 8 0 0115.58 6.85l1.86-1.24A10 10 0 004 20h16a10 10 0 00.38-11.44z"
	}), _react.default.createElement("path", {
	  d: "M10.59 15.41a2 2 0 002.83 0l5.66-8.49-8.49 5.66a2 2 0 000 2.83z"
	})), 'SpeedSharp');
	
	exports.default = _default;

/***/ },
/* 5629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20.38 8.57l-1.23 1.85a8 8 0 01-.22 7.58H5.07A8 8 0 0115.58 6.85l1.85-1.23A10 10 0 003.35 19a2 2 0 001.72 1h13.85a2 2 0 001.74-1 10 10 0 00-.27-10.44z"
	}), _react.default.createElement("path", {
	  d: "M10.59 15.41a2 2 0 002.83 0l5.66-8.49-8.49 5.66a2 2 0 000 2.83z"
	})), 'SpeedTwoTone');
	
	exports.default = _default;

/***/ },
/* 5630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z"
	}), 'Spellcheck');
	
	exports.default = _default;

/***/ },
/* 5631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z"
	}), 'SpellcheckOutlined');
	
	exports.default = _default;

/***/ },
/* 5632 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.12 16c.69 0 1.15-.69.9-1.32L9.77 3.87C9.56 3.34 9.06 3 8.5 3s-1.06.34-1.27.87L2.98 14.68c-.25.63.22 1.32.9 1.32.4 0 .76-.25.91-.63L5.67 13h5.64l.9 2.38c.15.37.51.62.91.62zm-6.69-5L8.5 5.48 10.57 11H6.43zm14.46 1.29l-7.39 7.39-2.97-2.97a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l3.68 3.68c.39.39 1.02.39 1.41 0l8.08-8.09c.39-.39.39-1.02 0-1.41-.38-.39-1.02-.39-1.4-.01z"
	}), 'SpellcheckRounded');
	
	exports.default = _default;

/***/ },
/* 5633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z"
	}), 'SpellcheckSharp');
	
	exports.default = _default;

/***/ },
/* 5634 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z"
	}), 'SpellcheckTwoTone');
	
	exports.default = _default;

/***/ },
/* 5635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.23 6c-1.66 0-3.22.66-4.36 1.73C6.54 6.73 5.61 6 4.5 6 3.12 6 2 7.12 2 8.5S3.12 11 4.5 11c.21 0 .41-.03.61-.08-.05.25-.09.51-.1.78-.18 3.68 2.95 6.68 6.68 6.27 2.55-.28 4.68-2.26 5.19-4.77.15-.71.15-1.4.06-2.06-.09-.6.38-1.13.99-1.13H22V6H11.23zM4.5 9c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zm6.5 6c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
	}), _react.default.createElement("circle", {
	  cx: "11",
	  cy: "12",
	  r: "2"
	})), 'Sports');
	
	exports.default = _default;

/***/ },
/* 5636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3.81 6.28C2.67 7.9 2 9.87 2 12s.67 4.1 1.81 5.72C6.23 16.95 8 14.68 8 12S6.23 7.05 3.81 6.28zM20.19 6.28C17.77 7.05 16 9.32 16 12s1.77 4.95 4.19 5.72C21.33 16.1 22 14.13 22 12s-.67-4.1-1.81-5.72z"
	}), _react.default.createElement("path", {
	  d: "M14 12c0-3.28 1.97-6.09 4.79-7.33C17.01 3.02 14.63 2 12 2S6.99 3.02 5.21 4.67C8.03 5.91 10 8.72 10 12s-1.97 6.09-4.79 7.33C6.99 20.98 9.37 22 12 22s5.01-1.02 6.79-2.67C15.97 18.09 14 15.28 14 12z"
	})), 'SportsBaseball');
	
	exports.default = _default;

/***/ },
/* 5637 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM5.61 16.78C4.6 15.45 4 13.8 4 12s.6-3.45 1.61-4.78C7.06 8.31 8 10.05 8 12s-.94 3.69-2.39 4.78zM12 20c-1.89 0-3.63-.66-5-1.76 1.83-1.47 3-3.71 3-6.24S8.83 7.23 7 5.76C8.37 4.66 10.11 4 12 4s3.63.66 5 1.76c-1.83 1.47-3 3.71-3 6.24s1.17 4.77 3 6.24c-1.37 1.1-3.11 1.76-5 1.76zm6.39-3.22C16.94 15.69 16 13.95 16 12s.94-3.69 2.39-4.78C19.4 8.55 20 10.2 20 12s-.6 3.45-1.61 4.78z"
	}), 'SportsBaseballOutlined');
	
	exports.default = _default;

/***/ },
/* 5638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3.81 6.28C2.67 7.9 2 9.87 2 12s.67 4.1 1.81 5.72C6.23 16.95 8 14.68 8 12S6.23 7.05 3.81 6.28zM20.19 6.28C17.77 7.05 16 9.32 16 12s1.77 4.95 4.19 5.72C21.33 16.1 22 14.13 22 12s-.67-4.1-1.81-5.72z"
	}), _react.default.createElement("path", {
	  d: "M14 12c0-3.28 1.97-6.09 4.79-7.33C17.01 3.02 14.63 2 12 2S6.99 3.02 5.21 4.67C8.03 5.91 10 8.72 10 12s-1.97 6.09-4.79 7.33C6.99 20.98 9.37 22 12 22s5.01-1.02 6.79-2.67C15.97 18.09 14 15.28 14 12z"
	})), 'SportsBaseballRounded');
	
	exports.default = _default;

/***/ },
/* 5639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3.81 6.28C2.67 7.9 2 9.87 2 12s.67 4.1 1.81 5.72C6.23 16.95 8 14.68 8 12S6.23 7.05 3.81 6.28zM20.19 6.28C17.77 7.05 16 9.32 16 12s1.77 4.95 4.19 5.72C21.33 16.1 22 14.13 22 12s-.67-4.1-1.81-5.72z"
	}), _react.default.createElement("path", {
	  d: "M14 12c0-3.28 1.97-6.09 4.79-7.33C17.01 3.02 14.63 2 12 2S6.99 3.02 5.21 4.67C8.03 5.91 10 8.72 10 12s-1.97 6.09-4.79 7.33C6.99 20.98 9.37 22 12 22s5.01-1.02 6.79-2.67C15.97 18.09 14 15.28 14 12z"
	})), 'SportsBaseballSharp');
	
	exports.default = _default;

/***/ },
/* 5640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5.61 7.22C4.6 8.55 4 10.2 4 12s.6 3.45 1.61 4.78C7.06 15.69 8 13.95 8 12s-.94-3.69-2.39-4.78z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M14 12c0-2.52 1.17-4.77 3-6.24C15.63 4.66 13.89 4 12 4s-3.63.66-5 1.76c1.83 1.47 3 3.71 3 6.24s-1.17 4.77-3 6.24c1.37 1.1 3.11 1.76 5 1.76s3.63-.66 5-1.76c-1.83-1.47-3-3.72-3-6.24z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18.39 7.22C16.94 8.31 16 10.05 16 12s.94 3.69 2.39 4.78C19.4 15.45 20 13.8 20 12s-.6-3.45-1.61-4.78z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM5.61 16.78C4.6 15.45 4 13.8 4 12s.6-3.45 1.61-4.78C7.06 8.31 8 10.05 8 12s-.94 3.69-2.39 4.78zM12 20c-1.89 0-3.63-.66-5-1.76 1.83-1.47 3-3.71 3-6.24S8.83 7.23 7 5.76C8.37 4.66 10.11 4 12 4s3.63.66 5 1.76c-1.83 1.47-3 3.71-3 6.24s1.17 4.77 3 6.24c-1.37 1.1-3.11 1.76-5 1.76zm6.39-3.22C16.94 15.69 16 13.95 16 12s.94-3.69 2.39-4.78C19.4 8.55 20 10.2 20 12s-.6 3.45-1.61 4.78z"
	})), 'SportsBaseballTwoTone');
	
	exports.default = _default;

/***/ },
/* 5641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.09 11h4.86c-.16-1.61-.71-3.11-1.54-4.4-1.73.83-2.99 2.45-3.32 4.4zM6.91 11c-.33-1.95-1.59-3.57-3.32-4.4-.83 1.29-1.38 2.79-1.54 4.4h4.86zM15.07 11c.32-2.59 1.88-4.79 4.06-6-1.6-1.63-3.74-2.71-6.13-2.95V11h2.07zM8.93 11H11V2.05C8.61 2.29 6.46 3.37 4.87 5c2.18 1.21 3.74 3.41 4.06 6zM15.07 13H13v8.95c2.39-.24 4.54-1.32 6.13-2.95-2.18-1.21-3.74-3.41-4.06-6zM3.59 17.4c1.72-.83 2.99-2.46 3.32-4.4H2.05c.16 1.61.71 3.11 1.54 4.4zM17.09 13c.33 1.95 1.59 3.57 3.32 4.4.83-1.29 1.38-2.79 1.54-4.4h-4.86zM8.93 13c-.32 2.59-1.88 4.79-4.06 6 1.6 1.63 3.74 2.71 6.13 2.95V13H8.93z"
	}), 'SportsBasketball');
	
	exports.default = _default;

/***/ },
/* 5642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM5.23 7.75C6.1 8.62 6.7 9.74 6.91 11H4.07c.15-1.18.56-2.28 1.16-3.25zM4.07 13h2.84c-.21 1.26-.81 2.38-1.68 3.25-.6-.97-1.01-2.07-1.16-3.25zM11 19.93c-1.73-.22-3.29-1-4.49-2.14 1.3-1.24 2.19-2.91 2.42-4.79H11v6.93zM11 11H8.93C8.69 9.12 7.81 7.44 6.5 6.2 7.71 5.06 9.27 4.29 11 4.07V11zm8.93 0h-2.84c.21-1.26.81-2.38 1.68-3.25.6.97 1.01 2.07 1.16 3.25zM13 4.07c1.73.22 3.29.99 4.5 2.13-1.31 1.24-2.19 2.92-2.43 4.8H13V4.07zm0 15.86V13h2.07c.24 1.88 1.12 3.55 2.42 4.79-1.2 1.14-2.76 1.92-4.49 2.14zm5.77-3.68c-.87-.86-1.46-1.99-1.68-3.25h2.84c-.15 1.18-.56 2.28-1.16 3.25z"
	}), 'SportsBasketballOutlined');
	
	exports.default = _default;

/***/ },
/* 5643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.09 11h4.86c-.16-1.61-.71-3.11-1.54-4.4-1.73.83-2.99 2.45-3.32 4.4zM6.91 11c-.33-1.95-1.59-3.57-3.32-4.4-.83 1.29-1.38 2.79-1.54 4.4h4.86zM15.07 11c.32-2.59 1.88-4.79 4.06-6-1.6-1.63-3.74-2.71-6.13-2.95V11h2.07zM8.93 11H11V2.05C8.61 2.29 6.46 3.37 4.87 5c2.18 1.21 3.74 3.41 4.06 6zM15.07 13H13v8.95c2.39-.24 4.54-1.32 6.13-2.95-2.18-1.21-3.74-3.41-4.06-6zM3.59 17.4c1.72-.83 2.99-2.46 3.32-4.4H2.05c.16 1.61.71 3.11 1.54 4.4zM17.09 13c.33 1.95 1.59 3.57 3.32 4.4.83-1.29 1.38-2.79 1.54-4.4h-4.86zM8.93 13c-.32 2.59-1.88 4.79-4.06 6 1.6 1.63 3.74 2.71 6.13 2.95V13H8.93z"
	}), 'SportsBasketballRounded');
	
	exports.default = _default;

/***/ },
/* 5644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.09 11h4.86c-.16-1.61-.71-3.11-1.54-4.4-1.73.83-2.99 2.45-3.32 4.4zM6.91 11c-.33-1.95-1.59-3.57-3.32-4.4-.83 1.29-1.38 2.79-1.54 4.4h4.86zM15.07 11c.32-2.59 1.88-4.79 4.06-6-1.6-1.63-3.74-2.71-6.13-2.95V11h2.07zM8.93 11H11V2.05C8.61 2.29 6.46 3.37 4.87 5c2.18 1.21 3.74 3.41 4.06 6zM15.07 13H13v8.95c2.39-.24 4.54-1.32 6.13-2.95-2.18-1.21-3.74-3.41-4.06-6zM3.59 17.4c1.72-.83 2.99-2.46 3.32-4.4H2.05c.16 1.61.71 3.11 1.54 4.4zM17.09 13c.33 1.95 1.59 3.57 3.32 4.4.83-1.29 1.38-2.79 1.54-4.4h-4.86zM8.93 13c-.32 2.59-1.88 4.79-4.06 6 1.6 1.63 3.74 2.71 6.13 2.95V13H8.93z"
	}), 'SportsBasketballSharp');
	
	exports.default = _default;

/***/ },
/* 5645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8.93 11H11V4.07c-1.73.22-3.29.99-4.5 2.13C7.81 7.44 8.69 9.12 8.93 11zM19.93 11c-.15-1.18-.56-2.28-1.16-3.25-.87.87-1.47 1.99-1.68 3.25h2.84zM5.23 7.75c-.6.97-1.01 2.07-1.16 3.25h2.84C6.7 9.74 6.1 8.62 5.23 7.75zM4.07 13c.15 1.18.56 2.28 1.16 3.25.87-.87 1.47-1.99 1.68-3.25H4.07zM6.51 17.79c1.2 1.14 2.76 1.92 4.49 2.14V13H8.93c-.23 1.88-1.12 3.55-2.42 4.79zM17.5 6.2c-1.21-1.14-2.77-1.92-4.5-2.13V11h2.07c.24-1.88 1.12-3.56 2.43-4.8zM18.77 16.25c.61-.96 1.02-2.07 1.16-3.25h-2.84c.21 1.26.81 2.38 1.68 3.25zM13 13v6.93c1.73-.22 3.29-1 4.49-2.14-1.3-1.24-2.19-2.91-2.42-4.79H13z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM5.23 7.75C6.1 8.62 6.7 9.74 6.91 11H4.07c.15-1.18.56-2.28 1.16-3.25zM4.07 13h2.84c-.21 1.26-.81 2.38-1.68 3.25-.6-.97-1.01-2.07-1.16-3.25zM11 19.93c-1.73-.22-3.29-1-4.49-2.14 1.3-1.24 2.19-2.91 2.42-4.79H11v6.93zM11 11H8.93C8.69 9.12 7.81 7.44 6.5 6.2 7.71 5.06 9.27 4.29 11 4.07V11zm8.93 0h-2.84c.21-1.26.81-2.38 1.68-3.25.6.97 1.01 2.07 1.16 3.25zM13 4.07c1.73.22 3.29.99 4.5 2.13-1.31 1.24-2.19 2.92-2.43 4.8H13V4.07zm0 15.86V13h2.07c.24 1.88 1.12 3.55 2.42 4.79-1.2 1.14-2.76 1.92-4.49 2.14zm5.77-3.68c-.87-.86-1.46-1.99-1.68-3.25h2.84c-.15 1.18-.56 2.28-1.16 3.25z"
	})), 'SportsBasketballTwoTone');
	
	exports.default = _default;

/***/ },
/* 5646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.05 12.81L6.56 4.32a.9959.9959 0 00-1.41 0L2.32 7.15c-.39.39-.39 1.02 0 1.41l8.49 8.49c.39.39 1.02.39 1.41 0l2.83-2.83c.39-.39.39-1.02 0-1.41zM14.3412 17.7562l1.4142-1.4142 4.2426 4.2426-1.4142 1.4142z"
	}), _react.default.createElement("circle", {
	  cx: "18.5",
	  cy: "5.5",
	  r: "3.5"
	})), 'SportsCricket');
	
	exports.default = _default;

/***/ },
/* 5647 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.04 12.79l-8.5-8.5C6.35 4.1 6.09 4 5.83 4s-.51.1-.7.29L2.29 7.13c-.39.39-.39 1.03 0 1.42l8.5 8.5c.2.2.45.29.71.29.26 0 .51-.1.71-.29l2.83-2.83c.39-.4.39-1.04 0-1.43zm-3.54 2.13L4.41 7.83l1.42-1.42 7.09 7.09-1.42 1.42zM14.3412 17.7562l1.4142-1.4142 4.2426 4.2426-1.4142 1.4142zM18.5 2C16.57 2 15 3.57 15 5.5S16.57 9 18.5 9 22 7.43 22 5.5 20.43 2 18.5 2zm0 5c-.83 0-1.5-.67-1.5-1.5S17.67 4 18.5 4s1.5.67 1.5 1.5S19.33 7 18.5 7z"
	}), 'SportsCricketOutlined');
	
	exports.default = _default;

/***/ },
/* 5648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.05 12.81L6.56 4.32a.9959.9959 0 00-1.41 0L2.32 7.15c-.39.39-.39 1.02 0 1.41l8.49 8.49c.39.39 1.02.39 1.41 0l2.83-2.83c.39-.39.39-1.02 0-1.41zM14.34 17.76l3.53 3.53c.39.39 1.03.39 1.42 0 .39-.39.39-1.03 0-1.42l-3.53-3.53-1.42 1.42z"
	}), _react.default.createElement("circle", {
	  cx: "18.5",
	  cy: "5.5",
	  r: "3.5"
	})), 'SportsCricketRounded');
	
	exports.default = _default;

/***/ },
/* 5649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.05 12.81L6.56 4.32a.9959.9959 0 00-1.41 0L2.32 7.15c-.39.39-.39 1.02 0 1.41l8.49 8.49c.39.39 1.02.39 1.41 0l2.83-2.83c.39-.39.39-1.02 0-1.41zM14.3412 17.7562l1.4142-1.4142 4.2426 4.2426-1.4142 1.4142z"
	}), _react.default.createElement("circle", {
	  cx: "18.5",
	  cy: "5.5",
	  r: "3.5"
	})), 'SportsCricketSharp');
	
	exports.default = _default;

/***/ },
/* 5650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4.414 7.8394l1.4213-1.4213 7.0852 7.0852-1.4213 1.4212z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "18.5",
	  cy: "5.5",
	  r: "1.5",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M15.04 12.79l-8.5-8.5C6.35 4.1 6.09 4 5.83 4s-.51.1-.7.29L2.29 7.13c-.39.39-.39 1.03 0 1.42l8.5 8.5c.2.2.45.29.71.29.26 0 .51-.1.71-.29l2.83-2.83c.39-.4.39-1.04 0-1.43zm-3.54 2.13L4.41 7.83l1.42-1.42 7.09 7.09-1.42 1.42zM14.3412 17.7562l1.4142-1.4142 4.2426 4.2426-1.4142 1.4142zM18.5 2C16.57 2 15 3.57 15 5.5S16.57 9 18.5 9 22 7.43 22 5.5 20.43 2 18.5 2zm0 5c-.83 0-1.5-.67-1.5-1.5S17.67 4 18.5 4s1.5.67 1.5 1.5S19.33 7 18.5 7z"
	})), 'SportsCricketTwoTone');
	
	exports.default = _default;

/***/ },
/* 5651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.58 16.09l-1.09-7.66C20.21 6.46 18.52 5 16.53 5H7.47C5.48 5 3.79 6.46 3.51 8.43l-1.09 7.66C2.2 17.63 3.39 19 4.94 19c.68 0 1.32-.27 1.8-.75L9 16h6l2.25 2.25c.48.48 1.13.75 1.8.75 1.56 0 2.75-1.37 2.53-2.91zM11 11H9v2H8v-2H6v-1h2V8h1v2h2v1zm4-1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'SportsEsports');
	
	exports.default = _default;

/***/ },
/* 5652 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21.58 16.09l-1.09-7.66C20.21 6.46 18.52 5 16.53 5H7.47C5.48 5 3.79 6.46 3.51 8.43l-1.09 7.66C2.2 17.63 3.39 19 4.94 19c.68 0 1.32-.27 1.8-.75L9 16h6l2.25 2.25c.48.48 1.13.75 1.8.75 1.56 0 2.75-1.37 2.53-2.91zm-2.1.72c-.08.09-.21.19-.42.19-.15 0-.29-.06-.39-.16L15.83 14H8.17l-2.84 2.84c-.1.1-.24.16-.39.16-.21 0-.34-.1-.42-.19-.08-.09-.16-.23-.13-.44l1.09-7.66C5.63 7.74 6.48 7 7.47 7h9.06c.99 0 1.84.74 1.98 1.72l1.09 7.66c.03.2-.05.34-.12.43z"
	}), _react.default.createElement("path", {
	  d: "M9 8H8v2H6v1h2v2h1v-2h2v-1H9z"
	}), _react.default.createElement("circle", {
	  cx: "17",
	  cy: "12",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "15",
	  cy: "9",
	  r: "1"
	})), 'SportsEsportsOutlined');
	
	exports.default = _default;

/***/ },
/* 5653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.58 16.09l-1.09-7.66C20.21 6.46 18.52 5 16.53 5H7.47C5.48 5 3.79 6.46 3.51 8.43l-1.09 7.66C2.2 17.63 3.39 19 4.94 19c.68 0 1.32-.27 1.8-.75L9 16h6l2.25 2.25c.48.48 1.13.75 1.8.75 1.56 0 2.75-1.37 2.53-2.91zM11 11H9v2H8v-2H6v-1h2V8h1v2h2v1zm4-1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'SportsEsportsRounded');
	
	exports.default = _default;

/***/ },
/* 5654 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 5H4L2 19h4l3-3h6l3 3h4L20 5zm-9 6H9v2H8v-2H6v-1h2V8h1v2h2v1zm4-1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	}), 'SportsEsportsSharp');
	
	exports.default = _default;

/***/ },
/* 5655 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16.53 7H7.47c-.99 0-1.84.74-1.98 1.72L4.4 16.37c-.03.21.05.35.13.44.07.09.2.19.41.19.15 0 .29-.06.39-.16L8.17 14h7.66l2.84 2.84c.1.1.24.16.39.16.21 0 .34-.1.42-.19.08-.09.16-.23.13-.44l-1.09-7.66c-.15-.97-1-1.71-1.99-1.71zM11 11H9v2H8v-2H6v-1h2V8h1v2h2v1zm4-1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21.58 16.09l-1.09-7.66C20.21 6.46 18.52 5 16.53 5H7.47C5.48 5 3.79 6.46 3.51 8.43l-1.09 7.66C2.2 17.63 3.39 19 4.94 19c.68 0 1.32-.27 1.8-.75L9 16h6l2.25 2.25c.48.48 1.13.75 1.8.75 1.56 0 2.75-1.37 2.53-2.91zm-2.1.72c-.08.09-.21.19-.42.19-.15 0-.29-.06-.39-.16L15.83 14H8.17l-2.84 2.84c-.1.1-.24.16-.39.16-.21 0-.34-.1-.42-.19-.08-.09-.16-.23-.13-.44l1.09-7.66C5.63 7.74 6.48 7 7.47 7h9.06c.99 0 1.84.74 1.98 1.72l1.09 7.66c.03.2-.05.34-.12.43z"
	}), _react.default.createElement("path", {
	  d: "M9 8H8v2H6v1h2v2h1v-2h2v-1H9z"
	}), _react.default.createElement("circle", {
	  cx: "17",
	  cy: "12",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "15",
	  cy: "9",
	  r: "1"
	})), 'SportsEsportsTwoTone');
	
	exports.default = _default;

/***/ },
/* 5656 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.02 15.62c-.08 2.42.32 4.34.67 4.69s2.28.76 4.69.67l-5.36-5.36zM13.08 3.28c-2.33.42-4.79 1.34-6.62 3.18s-2.76 4.29-3.18 6.62l7.63 7.63c2.34-.41 4.79-1.34 6.62-3.18s2.76-4.29 3.18-6.62l-7.63-7.63zM9.9 15.5l-1.4-1.4 5.6-5.6 1.4 1.4-5.6 5.6zM20.98 8.38c.08-2.42-.32-4.34-.67-4.69s-2.28-.76-4.69-.67l5.36 5.36z"
	}), 'SportsFootball');
	
	exports.default = _default;

/***/ },
/* 5657 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20.31 3.69c-.32-.33-1.94-.69-4.05-.69-3.03 0-7.09.75-9.8 3.46-4.59 4.59-3.56 13.06-2.77 13.85.32.33 1.94.69 4.05.69 3.03 0 7.09-.75 9.8-3.46 4.59-4.59 3.56-13.06 2.77-13.85zM7.74 19c-1.14 0-2.02-.12-2.53-.23-.18-.79-.3-2.21-.17-3.83l4.01 4.01c-.52.04-.97.05-1.31.05zm8.39-2.87c-1.33 1.33-3.06 2.05-4.66 2.44l-6.04-6.04c.42-1.68 1.16-3.37 2.45-4.65 1.32-1.32 3.05-2.04 4.64-2.43l6.05 6.05c-.42 1.67-1.17 3.35-2.44 4.63zm2.83-7.04l-4.03-4.03c.52-.05.98-.06 1.33-.06 1.14 0 2.02.12 2.53.23.18.79.3 2.22.17 3.86z"
	}), _react.default.createElement("path", {
	  d: "M8.4997 14.1002L14.0999 8.5l1.4 1.4-5.6002 5.6002z"
	})), 'SportsFootballOutlined');
	
	exports.default = _default;

/***/ },
/* 5658 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.02 15.62c-.08 2.42.32 4.34.67 4.69s2.28.76 4.69.67l-5.36-5.36zM13.08 3.28c-2.33.42-4.79 1.34-6.62 3.18s-2.76 4.29-3.18 6.62l7.63 7.63c2.34-.41 4.79-1.34 6.62-3.18s2.76-4.29 3.18-6.62l-7.63-7.63zm1.72 7.32l-4.2 4.2c-.39.39-1.01.39-1.4 0s-.39-1.01 0-1.4l4.2-4.2c.39-.39 1.01-.39 1.4 0s.39 1.01 0 1.4zM20.98 8.38c.08-2.42-.32-4.34-.67-4.69s-2.28-.76-4.69-.67l5.36 5.36z"
	}), 'SportsFootballRounded');
	
	exports.default = _default;

/***/ },
/* 5659 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.02 15.62c-.08 2.42.32 4.34.67 4.69s2.28.76 4.69.67l-5.36-5.36zM13.08 3.28c-2.33.42-4.79 1.34-6.62 3.18s-2.76 4.29-3.18 6.62l7.63 7.63c2.34-.41 4.79-1.34 6.62-3.18s2.76-4.29 3.18-6.62l-7.63-7.63zM9.9 15.5l-1.4-1.4 5.6-5.6 1.4 1.4-5.6 5.6zM20.98 8.38c.08-2.42-.32-4.34-.67-4.69s-2.28-.76-4.69-.67l5.36 5.36z"
	}), 'SportsFootballSharp');
	
	exports.default = _default;

/***/ },
/* 5660 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16.26 5c-.35 0-.8.01-1.33.06l4.03 4.03c.14-1.63.01-3.07-.17-3.86-.51-.11-1.39-.23-2.53-.23zM5.21 18.77c.51.11 1.39.23 2.53.23.34 0 .79-.01 1.3-.05l-4.01-4.01c-.12 1.62 0 3.04.18 3.83zM7.87 7.87c-1.28 1.28-2.03 2.97-2.45 4.65l6.04 6.04c1.6-.39 3.33-1.11 4.66-2.44 1.28-1.28 2.03-2.95 2.44-4.63l-6.05-6.05c-1.59.39-3.31 1.11-4.64 2.43zM15.5 9.9l-5.6 5.6-1.4-1.4 5.6-5.6 1.4 1.4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20.31 3.69c-.32-.33-1.94-.69-4.05-.69-3.03 0-7.09.75-9.8 3.46-4.59 4.59-3.56 13.06-2.77 13.85.32.33 1.94.69 4.05.69 3.03 0 7.09-.75 9.8-3.46 4.59-4.59 3.56-13.06 2.77-13.85zM7.74 19c-1.14 0-2.02-.12-2.53-.23-.18-.79-.3-2.21-.17-3.83l4.01 4.01c-.52.04-.97.05-1.31.05zm8.39-2.87c-1.33 1.33-3.06 2.05-4.66 2.44l-6.04-6.04c.42-1.68 1.16-3.37 2.45-4.65 1.32-1.32 3.05-2.04 4.64-2.43l6.05 6.05c-.42 1.67-1.17 3.35-2.44 4.63zm2.83-7.04l-4.03-4.03c.52-.05.98-.06 1.33-.06 1.14 0 2.02.12 2.53.23.18.79.3 2.22.17 3.86z"
	}), _react.default.createElement("path", {
	  d: "M8.4997 14.1002L14.0999 8.5l1.4 1.4-5.6002 5.6002z"
	})), 'SportsFootballTwoTone');
	
	exports.default = _default;

/***/ },
/* 5661 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 16c3.87 0 7-3.13 7-7s-3.13-7-7-7-7 3.13-7 7 3.13 7 7 7zm0-12c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5z"
	}), _react.default.createElement("circle", {
	  cx: "10",
	  cy: "8",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "14",
	  cy: "8",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M7 19h2c1.1 0 2 .9 2 2v1h2v-1c0-1.1.9-2 2-2h2v-2H7v2z"
	})), 'SportsGolf');
	
	exports.default = _default;

/***/ },
/* 5662 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 16c3.87 0 7-3.13 7-7s-3.13-7-7-7-7 3.13-7 7 3.13 7 7 7zm0-12c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5z"
	}), _react.default.createElement("circle", {
	  cx: "10",
	  cy: "8",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "14",
	  cy: "8",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M7 19h2c1.1 0 2 .9 2 2v1h2v-1c0-1.1.9-2 2-2h2v-2H7v2z"
	})), 'SportsGolfOutlined');
	
	exports.default = _default;

/***/ },
/* 5663 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 16c3.87 0 7-3.13 7-7s-3.13-7-7-7-7 3.13-7 7 3.13 7 7 7zm0-12c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5z"
	}), _react.default.createElement("circle", {
	  cx: "10",
	  cy: "8",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "14",
	  cy: "8",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M16 17H8c-.55 0-1 .45-1 1s.45 1 1 1h1c1.1 0 2 .9 2 2v1h2v-1c0-1.1.9-2 2-2h1c.55 0 1-.45 1-1s-.45-1-1-1z"
	})), 'SportsGolfRounded');
	
	exports.default = _default;

/***/ },
/* 5664 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 16c3.87 0 7-3.13 7-7s-3.13-7-7-7-7 3.13-7 7 3.13 7 7 7zm0-12c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5z"
	}), _react.default.createElement("circle", {
	  cx: "10",
	  cy: "8",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "14",
	  cy: "8",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M7 19h2c1.1 0 2 .9 2 2v1h2v-1c0-1.1.9-2 2-2h2v-2H7v2z"
	})), 'SportsGolfSharp');
	
	exports.default = _default;

/***/ },
/* 5665 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 14c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm2-7c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 16c3.87 0 7-3.13 7-7s-3.13-7-7-7-7 3.13-7 7 3.13 7 7 7zm0-12c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5z"
	}), _react.default.createElement("circle", {
	  cx: "10",
	  cy: "8",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "14",
	  cy: "8",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "12",
	  cy: "6",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M7 19h2c1.1 0 2 .9 2 2v1h2v-1c0-1.1.9-2 2-2h2v-2H7v2z"
	})), 'SportsGolfTwoTone');
	
	exports.default = _default;

/***/ },
/* 5666 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14.27 6c-.55.95-.22 2.18.73 2.73.95.55 2.18.22 2.73-.73.55-.95.22-2.18-.73-2.73-.95-.55-2.18-.22-2.73.73z"
	}), _react.default.createElement("path", {
	  d: "M15.84 10.41s-1.63-.94-2.6-1.5c-2.38-1.38-3.2-4.44-1.82-6.82l-1.73-1C8.1 3.83 8.6 7.21 10.66 9.4l-5.15 8.92 1.73 1 1.5-2.6 1.73 1-3 5.2 1.73 1 6.29-10.89c1.14 1.55 1.33 3.69.31 5.46l1.73 1c1.6-2.75 1.28-6.58-1.69-9.08z"
	}), _react.default.createElement("path", {
	  d: "M12.75 3.8c.72.41 1.63.17 2.05-.55.41-.72.17-1.63-.55-2.05-.72-.41-1.63-.17-2.05.55-.41.72-.17 1.64.55 2.05z"
	})), 'SportsHandball');
	
	exports.default = _default;

/***/ },
/* 5667 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14.27 6c-.55.95-.22 2.18.73 2.73.95.55 2.18.22 2.73-.73.55-.95.22-2.18-.73-2.73-.95-.55-2.18-.22-2.73.73z"
	}), _react.default.createElement("path", {
	  d: "M15.84 10.41s-1.63-.94-2.6-1.5c-2.38-1.38-3.2-4.44-1.82-6.82l-1.73-1C8.1 3.83 8.6 7.21 10.66 9.4l-5.15 8.92 1.73 1 1.5-2.6 1.73 1-3 5.2 1.73 1 6.29-10.89c1.14 1.55 1.33 3.69.31 5.46l1.73 1c1.6-2.75 1.28-6.58-1.69-9.08z"
	}), _react.default.createElement("path", {
	  d: "M12.75 3.8c.72.41 1.63.17 2.05-.55.41-.72.17-1.63-.55-2.05-.72-.41-1.63-.17-2.05.55-.41.72-.17 1.64.55 2.05z"
	})), 'SportsHandballOutlined');
	
	exports.default = _default;

/***/ },
/* 5668 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14.27 6c-.55.95-.22 2.18.73 2.73.95.55 2.18.22 2.73-.73.55-.95.22-2.18-.73-2.73-.95-.55-2.18-.22-2.73.73z"
	}), _react.default.createElement("path", {
	  d: "M15.84 10.41s-1.63-.94-2.6-1.5c-2.13-1.24-3.01-3.83-2.18-6.07.17-.46-.01-.97-.43-1.21-.53-.3-1.22-.07-1.43.5-.95 2.51-.35 5.35 1.46 7.27l-4.65 8.05c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l1-1.73 1.73 1-2.5 4.33c-.28.48-.11 1.09.37 1.37s1.09.11 1.37-.37l5.79-10.02c.98 1.34 1.26 3.12.66 4.72-.17.45.02.96.43 1.2.53.31 1.22.08 1.44-.5.97-2.62.41-5.84-2.2-8.04zM12.75 3.8c.72.41 1.63.17 2.05-.55.41-.72.17-1.63-.55-2.05-.72-.41-1.63-.17-2.05.55-.41.72-.17 1.64.55 2.05z"
	})), 'SportsHandballRounded');
	
	exports.default = _default;

/***/ },
/* 5669 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14.27 6c-.55.95-.22 2.18.73 2.73.95.55 2.18.22 2.73-.73.55-.95.22-2.18-.73-2.73-.95-.55-2.18-.22-2.73.73z"
	}), _react.default.createElement("path", {
	  d: "M15.84 10.41s-1.63-.94-2.6-1.5c-2.38-1.38-3.2-4.44-1.82-6.82l-1.73-1C8.1 3.83 8.6 7.21 10.66 9.4l-5.15 8.92 1.73 1 1.5-2.6 1.73 1-3 5.2 1.73 1 6.29-10.89c1.14 1.55 1.33 3.69.31 5.46l1.73 1c1.6-2.75 1.28-6.58-1.69-9.08z"
	}), _react.default.createElement("path", {
	  d: "M12.75 3.8c.72.41 1.63.17 2.05-.55.41-.72.17-1.63-.55-2.05-.72-.41-1.63-.17-2.05.55-.41.72-.17 1.64.55 2.05z"
	})), 'SportsHandballSharp');
	
	exports.default = _default;

/***/ },
/* 5670 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14.27 6c-.55.95-.22 2.18.73 2.73.95.55 2.18.22 2.73-.73.55-.95.22-2.18-.73-2.73-.95-.55-2.18-.22-2.73.73z"
	}), _react.default.createElement("path", {
	  d: "M15.84 10.41s-1.63-.94-2.6-1.5c-2.38-1.38-3.2-4.44-1.82-6.82l-1.73-1C8.1 3.83 8.6 7.21 10.66 9.4l-5.15 8.92 1.73 1 1.5-2.6 1.73 1-3 5.2 1.73 1 6.29-10.89c1.14 1.55 1.33 3.69.31 5.46l1.73 1c1.6-2.75 1.28-6.58-1.69-9.08z"
	}), _react.default.createElement("path", {
	  d: "M12.75 3.8c.72.41 1.63.17 2.05-.55.41-.72.17-1.63-.55-2.05-.72-.41-1.63-.17-2.05.55-.41.72-.17 1.64.55 2.05z"
	})), 'SportsHandballTwoTone');
	
	exports.default = _default;

/***/ },
/* 5671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 17v3h2v-4H3c-.55 0-1 .45-1 1zM9 16H5v4l4.69-.01c.38 0 .72-.21.89-.55l.87-1.9-1.59-3.48L9 16zM21.71 16.29c-.18-.18-.43-.29-.71-.29h-1v4h2v-3c0-.28-.11-.53-.29-.71zM13.6 12.84L17.65 4H14.3l-1.76 3.97-.49 1.1-.05.14L9.7 4H6.35l4.05 8.84 1.52 3.32.08.18 1.42 3.1c.17.34.51.55.89.55L19 20v-4h-4l-1.4-3.16z"
	}), 'SportsHockey');
	
	exports.default = _default;

/***/ },
/* 5672 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 17v3h2v-4H3c-.55 0-1 .45-1 1zM9 16H5v4l4.69-.01c.38 0 .72-.21.89-.55l.87-1.9-1.59-3.48L9 16zM21.71 16.29c-.18-.18-.43-.29-.71-.29h-1v4h2v-3c0-.28-.11-.53-.29-.71zM13.6 12.84L17.65 4H14.3l-1.76 3.97-.49 1.1-.05.14L9.7 4H6.35l4.05 8.84 1.52 3.32.08.18 1.42 3.1c.17.34.51.55.89.55L19 20v-4h-4l-1.4-3.16z"
	}), 'SportsHockeyOutlined');
	
	exports.default = _default;

/***/ },
/* 5673 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 17v3h2v-4H3c-.55 0-1 .45-1 1zM9 16H5v4l4.69-.01c.38 0 .72-.21.89-.55l.87-1.9-1.59-3.48L9 16zM21.71 16.29c-.18-.18-.43-.29-.71-.29h-1v4h2v-3c0-.28-.11-.53-.29-.71zM13.6 12.84L17.65 4H14.3l-1.76 3.97-.49 1.1-.05.14L9.7 4H6.35l4.05 8.84 1.52 3.32.08.18 1.42 3.1c.17.34.51.55.89.55L19 20v-4h-4l-1.4-3.16z"
	}), 'SportsHockeyRounded');
	
	exports.default = _default;

/***/ },
/* 5674 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 17v3h2v-4H3c-.55 0-1 .45-1 1zM9 16H5v4l4.69-.01c.38 0 .72-.21.89-.55l.87-1.9-1.59-3.48L9 16zM21.71 16.29c-.18-.18-.43-.29-.71-.29h-1v4h2v-3c0-.28-.11-.53-.29-.71zM13.6 12.84L17.65 4H14.3l-1.76 3.97-.49 1.1-.05.14L9.7 4H6.35l4.05 8.84 1.52 3.32.08.18 1.42 3.1c.17.34.51.55.89.55L19 20v-4h-4l-1.4-3.16z"
	}), 'SportsHockeySharp');
	
	exports.default = _default;

/***/ },
/* 5675 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 17v3h2v-4H3c-.55 0-1 .45-1 1zM9 16H5v4l4.69-.01c.38 0 .72-.21.89-.55l.87-1.9-1.59-3.48L9 16zM21.71 16.29c-.18-.18-.43-.29-.71-.29h-1v4h2v-3c0-.28-.11-.53-.29-.71zM13.6 12.84L17.65 4H14.3l-1.76 3.97-.49 1.1-.05.14L9.7 4H6.35l4.05 8.84 1.52 3.32.08.18 1.42 3.1c.17.34.51.55.89.55L19 20v-4h-4l-1.4-3.16z"
	}), 'SportsHockeyTwoTone');
	
	exports.default = _default;

/***/ },
/* 5676 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "2.38",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M24 11.88v-4.7l-5.05-2.14c-.97-.41-2.09-.06-2.65.84l-1 1.6c-.67 1.18-1.91 2.06-3.41 2.32l.06.06c.69.69 1.52 1.07 2.46 1.17.8-.42 1.52-.98 2.09-1.64l.6 3-1.16 1.1-.94.89v7.5h2v-6l2.1-2 1.8 8H23l-2.18-11-.62-3.1 1.8.7v3.4h2zM10.29 8.09c.22.15.47.24.72.29.13.02.25.04.38.04s.26-.01.38-.04c.13-.02.25-.06.37-.11.24-.1.47-.24.66-.44.49-.49.67-1.17.55-1.8-.07-.37-.25-.74-.55-1.03-.19-.19-.42-.34-.66-.44-.12-.05-.24-.09-.37-.11s-.25-.04-.38-.04c-.12 0-.23.01-.35.03-.14.02-.28.06-.41.11-.23.11-.46.26-.65.45-.3.29-.48.66-.55 1.03-.12.63.06 1.31.55 1.8.09.1.2.18.31.26z"
	}), _react.default.createElement("path", {
	  d: "M11.24 10.56l-2-2c-.1-.1-.2-.18-.31-.26-.22-.14-.47-.24-.72-.28-.13-.03-.25-.04-.38-.04-.51 0-1.02.2-1.41.59l-3.34 3.34c-.41.41-.62.98-.58 1.54 0 .18.04.37.11.55l1.07 2.95-3.63 3.63L1.46 22l4.24-4.24v-2.22L7 16.75v5.13h2v-6l-2.12-2.12 2.36-2.36.71.71c1.29 1.26 2.97 2.04 5.03 2.04l-.14-2.07c-1.5-.02-2.7-.62-3.6-1.52z"
	})), 'SportsKabaddi');
	
	exports.default = _default;

/***/ },
/* 5677 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "2.38",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M24 11.88v-4.7l-5.05-2.14c-.97-.41-2.09-.06-2.65.84l-1 1.6c-.67 1.18-1.91 2.06-3.41 2.32l.06.06c.69.69 1.52 1.07 2.46 1.17.8-.42 1.52-.98 2.09-1.64l.6 3-1.16 1.1-.94.89v7.5h2v-6l2.1-2 1.8 8H23l-2.18-11-.62-3.1 1.8.7v3.4h2zM10.29 8.09c.22.15.47.24.72.29.13.02.25.04.38.04s.26-.01.38-.04c.13-.02.25-.06.37-.11.24-.1.47-.24.66-.44.49-.49.67-1.17.55-1.8-.07-.37-.25-.74-.55-1.03-.19-.19-.42-.34-.66-.44-.12-.05-.24-.09-.37-.11s-.25-.04-.38-.04c-.12 0-.23.01-.35.03-.14.02-.28.06-.41.11-.23.11-.46.26-.65.45-.3.29-.48.66-.55 1.03-.12.63.06 1.31.55 1.8.09.1.2.18.31.26z"
	}), _react.default.createElement("path", {
	  d: "M11.24 10.56l-2-2c-.1-.1-.2-.18-.31-.26-.22-.14-.47-.24-.72-.28-.13-.03-.25-.04-.38-.04-.51 0-1.02.2-1.41.59l-3.34 3.34c-.41.41-.62.98-.58 1.54 0 .18.04.37.11.55l1.07 2.95-3.63 3.63L1.46 22l4.24-4.24v-2.22L7 16.75v5.13h2v-6l-2.12-2.12 2.36-2.36.71.71c1.29 1.26 2.97 2.04 5.03 2.04l-.14-2.07c-1.5-.02-2.7-.62-3.6-1.52z"
	})), 'SportsKabaddiOutlined');
	
	exports.default = _default;

/***/ },
/* 5678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "2.38",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M24 10.88v-3.7l-4.99-2.11c-.98-.41-2.12-.07-2.71.81l-1 1.6c-.67 1.18-1.91 2.06-3.41 2.32l.06.06c.69.69 1.52 1.07 2.46 1.17.8-.42 1.52-.98 2.09-1.64l.6 3-1.16 1.1-.94.89v6.5c0 .55.45 1 1 1s1-.45 1-1v-5l2.1-2 1.62 7.19c.11.47.53.81 1.02.81.66 0 1.15-.6 1.02-1.24l-1.94-9.76-.62-3.1 1.8.7v2.4c0 .55.45 1 1 1s1-.45 1-1zM10.29 8.09c.22.15.47.24.72.29.13.02.25.04.38.04s.26-.01.38-.04c.13-.02.25-.06.37-.11.24-.1.47-.24.66-.44.49-.49.67-1.17.55-1.8-.07-.37-.25-.74-.55-1.03-.19-.19-.42-.34-.66-.44-.12-.05-.24-.09-.37-.11s-.25-.04-.38-.04c-.12 0-.23.01-.35.03-.14.02-.28.06-.41.11-.23.11-.46.26-.65.45-.3.29-.48.66-.55 1.03-.12.63.06 1.31.55 1.8.09.1.2.18.31.26z"
	}), _react.default.createElement("path", {
	  d: "M11.24 10.56l-2-2c-.1-.1-.2-.18-.31-.26-.22-.14-.47-.24-.72-.28-.13-.03-.25-.04-.38-.04-.51 0-1.02.2-1.41.59l-3.34 3.34c-.41.41-.62.98-.58 1.54 0 .18.04.37.11.55l1.07 2.95-2.92 2.92c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l3.54-3.54v-2.22L7 16.75v4.13c0 .55.45 1 1 1s1-.45 1-1v-5l-2.12-2.12 2.36-2.36.71.71c1.02 1 2.28 1.69 3.79 1.94.64.11 1.21-.45 1.16-1.1-.03-.48-.4-.87-.87-.94-1.13-.18-2.06-.72-2.79-1.45z"
	})), 'SportsKabaddiRounded');
	
	exports.default = _default;

/***/ },
/* 5679 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "2.38",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M24 11.88v-4.7l-5.05-2.14c-.97-.41-2.09-.06-2.65.84l-1 1.6c-.67 1.18-1.91 2.06-3.41 2.32l.06.06c.69.69 1.52 1.07 2.46 1.17.8-.42 1.52-.98 2.09-1.64l.6 3-1.16 1.1-.94.89v7.5h2v-6l2.1-2 1.8 8H23l-2.18-11-.62-3.1 1.8.7v3.4h2zM10.29 8.09c.22.15.47.24.72.29.13.02.25.04.38.04s.26-.01.38-.04c.13-.02.25-.06.37-.11.24-.1.47-.24.66-.44.49-.49.67-1.17.55-1.8-.07-.37-.25-.74-.55-1.03-.19-.19-.42-.34-.66-.44-.12-.05-.24-.09-.37-.11s-.25-.04-.38-.04c-.12 0-.23.01-.35.03-.14.02-.28.06-.41.11-.23.11-.46.26-.65.45-.3.29-.48.66-.55 1.03-.12.63.06 1.31.55 1.8.09.1.2.18.31.26z"
	}), _react.default.createElement("path", {
	  d: "M11.24 10.56l-2-2c-.1-.1-.2-.18-.31-.26-.22-.14-.47-.24-.72-.28-.13-.03-.25-.04-.38-.04-.51 0-1.02.2-1.41.59l-3.34 3.34c-.41.41-.62.98-.58 1.54 0 .18.04.37.11.55l1.07 2.95-3.63 3.63L1.46 22l4.24-4.24v-2.22L7 16.75v5.13h2v-6l-2.12-2.12 2.36-2.36.71.71c1.29 1.26 2.97 2.04 5.03 2.04l-.14-2.07c-1.5-.02-2.7-.62-3.6-1.52z"
	})), 'SportsKabaddiSharp');
	
	exports.default = _default;

/***/ },
/* 5680 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "2.38",
	  r: "2"
	}), _react.default.createElement("path", {
	  d: "M24 11.88v-4.7l-5.05-2.14c-.97-.41-2.09-.06-2.65.84l-1 1.6c-.67 1.18-1.91 2.06-3.41 2.32l.06.06c.69.69 1.52 1.07 2.46 1.17.8-.42 1.52-.98 2.09-1.64l.6 3-1.16 1.1-.94.89v7.5h2v-6l2.1-2 1.8 8H23l-2.18-11-.62-3.1 1.8.7v3.4h2zM10.29 8.09c.22.15.47.24.72.29.13.02.25.04.38.04s.26-.01.38-.04c.13-.02.25-.06.37-.11.24-.1.47-.24.66-.44.49-.49.67-1.17.55-1.8-.07-.37-.25-.74-.55-1.03-.19-.19-.42-.34-.66-.44-.12-.05-.24-.09-.37-.11s-.25-.04-.38-.04c-.12 0-.23.01-.35.03-.14.02-.28.06-.41.11-.23.11-.46.26-.65.45-.3.29-.48.66-.55 1.03-.12.63.06 1.31.55 1.8.09.1.2.18.31.26z"
	}), _react.default.createElement("path", {
	  d: "M11.24 10.56l-2-2c-.1-.1-.2-.18-.31-.26-.22-.14-.47-.24-.72-.28-.13-.03-.25-.04-.38-.04-.51 0-1.02.2-1.41.59l-3.34 3.34c-.41.41-.62.98-.58 1.54 0 .18.04.37.11.55l1.07 2.95-3.63 3.63L1.46 22l4.24-4.24v-2.22L7 16.75v5.13h2v-6l-2.12-2.12 2.36-2.36.71.71c1.29 1.26 2.97 2.04 5.03 2.04l-.14-2.07c-1.5-.02-2.7-.62-3.6-1.52z"
	})), 'SportsKabaddiTwoTone');
	
	exports.default = _default;

/***/ },
/* 5681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-3H7v3zM18 7c-.55 0-1 .45-1 1V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v5.8c0 .13.01.26.04.39l.8 4c.09.47.5.8.98.8h10.36c.45 0 .89-.36.98-.8l.8-4c.03-.13.04-.26.04-.39V8c0-.55-.45-1-1-1zm-3 3H7V7h8v3z"
	}), 'SportsMma');
	
	exports.default = _default;

/***/ },
/* 5682 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-3H7v3zM18 7c-.55 0-1 .45-1 1V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v5.8c0 .13.01.26.04.39l.8 4c.09.47.5.8.98.8H17c.55 0 1.09-.44 1.2-.98l.77-3.83c.02-.12.03-.25.03-.38V8c0-.55-.45-1-1-1zm-1 3.6c0 .13-.64 3.4-.64 3.4H7.64S7 10.74 7 10.6V5h8v5h2v.6z"
	}), _react.default.createElement("path", {
	  d: "M8 7h6v3H8z"
	})), 'SportsMmaOutlined');
	
	exports.default = _default;

/***/ },
/* 5683 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-3H7v3zM18 7c-.55 0-1 .45-1 1V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v5.8c0 .13.01.26.04.39l.8 4c.09.47.5.8.98.8h10.36c.45 0 .89-.36.98-.8l.8-4c.03-.13.04-.26.04-.39V8c0-.55-.45-1-1-1zm-4 3H8c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1z"
	}), 'SportsMmaRounded');
	
	exports.default = _default;

/***/ },
/* 5684 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 17h10v4H7zM18 7c-.55 0-1 .45-1 1V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v5.8c0 .13.01.26.04.39l.8 4c.09.47.5.8.98.8h10.36c.45 0 .89-.36.98-.8l.8-4c.03-.13.04-.26.04-.39V8c0-.55-.45-1-1-1zm-3 3H7V7h8v3z"
	}), 'SportsMmaSharp');
	
	exports.default = _default;

/***/ },
/* 5685 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15 5H7v5.6c0 .14.64 3.4.64 3.4h8.72s.64-3.26.64-3.4V10h-2V5zm-1 5H8V7h6v3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M7 20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-3H7v3zM18 7c-.55 0-1 .45-1 1V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v5.8c0 .13.01.26.04.39l.8 4c.09.47.5.8.98.8H17c.55 0 1.09-.44 1.2-.98l.77-3.83c.02-.12.03-.25.03-.38V8c0-.55-.45-1-1-1zm-1 3.6c0 .13-.64 3.4-.64 3.4H7.64S7 10.74 7 10.6V5h8v5h2v.6z"
	}), _react.default.createElement("path", {
	  d: "M8 7h6v3H8z"
	})), 'SportsMmaTwoTone');
	
	exports.default = _default;

/***/ },
/* 5686 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 11.39c0-.65-.39-1.23-.98-1.48L5.44 7.55c-1.48 1.68-2.32 3.7-2.8 5.45h7.75c.89 0 1.61-.72 1.61-1.61z"
	}), _react.default.createElement("path", {
	  d: "M21.96 11.22c-.41-4.41-4.56-7.49-8.98-7.2-2.51.16-4.44.94-5.93 2.04l4.74 2.01c1.33.57 2.2 1.87 2.2 3.32 0 1.99-1.62 3.61-3.61 3.61H2.21C2 16.31 2 17.2 2 17.2v.8c0 1.1.9 2 2 2h10c4.67 0 8.41-4.01 7.96-8.78z"
	})), 'SportsMotorsports');
	
	exports.default = _default;

/***/ },
/* 5687 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.96 11.22C21.57 7.01 17.76 4 13.56 4c-.19 0-.38.01-.57.02C2 4.74 2 17.2 2 17.2v.8c0 1.1.9 2 2 2h10c4.67 0 8.41-4.01 7.96-8.78zm-16.7.34c.57-1.29 1.28-2.35 2.14-3.19l3.62 1.53c.6.25.98.83.98 1.48 0 .89-.72 1.61-1.61 1.61H4.72c.15-.46.32-.94.54-1.43zm13.18 4.48C17.3 17.29 15.68 18 14 18H4v-.8c0-.02.01-.92.24-2.2h6.15c1.99 0 3.61-1.62 3.61-3.61 0-1.45-.87-2.76-2.2-3.32L9.3 7.01c1.1-.57 2.37-.9 3.82-.99.15-.02.3-.02.44-.02 3.31 0 6.13 2.37 6.41 5.41.16 1.72-.38 3.36-1.53 4.63z"
	}), 'SportsMotorsportsOutlined');
	
	exports.default = _default;

/***/ },
/* 5688 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 11.39c0-.65-.39-1.23-.98-1.48L5.44 7.55c-1.48 1.68-2.32 3.7-2.8 5.45h7.75c.89 0 1.61-.72 1.61-1.61z"
	}), _react.default.createElement("path", {
	  d: "M21.96 11.22c-.41-4.41-4.56-7.49-8.98-7.2-2.51.16-4.44.94-5.93 2.04l4.74 2.01c1.33.57 2.2 1.87 2.2 3.32 0 1.99-1.62 3.61-3.61 3.61H2.21C2 16.31 2 17.2 2 17.2v.8c0 1.1.9 2 2 2h10c4.67 0 8.41-4.01 7.96-8.78z"
	})), 'SportsMotorsportsRounded');
	
	exports.default = _default;

/***/ },
/* 5689 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 11.39c0-.65-.39-1.23-.98-1.48L5.44 7.55c-1.48 1.68-2.32 3.7-2.8 5.45h7.75c.89 0 1.61-.72 1.61-1.61z"
	}), _react.default.createElement("path", {
	  d: "M21.96 11.22c-.41-4.41-4.56-7.49-8.98-7.2-2.51.16-4.44.94-5.93 2.04l4.74 2.01c1.33.57 2.2 1.87 2.2 3.32 0 1.99-1.62 3.61-3.61 3.61H2.21C2 16.31 2 17.2 2 17.2V20h12c4.67 0 8.41-4.01 7.96-8.78z"
	})), 'SportsMotorsportsSharp');
	
	exports.default = _default;

/***/ },
/* 5690 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M13.56 6c-.15 0-.29 0-.44.01-1.45.1-2.72.43-3.82.99l2.5 1.06c1.33.57 2.2 1.87 2.2 3.32 0 1.99-1.62 3.61-3.61 3.61H4.24C4.01 16.28 4 17.19 4 17.2v.8h10c1.68 0 3.3-.71 4.44-1.96 1.15-1.27 1.7-2.91 1.54-4.63C19.69 8.37 16.87 6 13.56 6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21.96 11.22C21.57 7.01 17.76 4 13.56 4c-.19 0-.38.01-.57.02C2 4.74 2 17.2 2 17.2v.8c0 1.1.9 2 2 2h10c4.67 0 8.41-4.01 7.96-8.78zm-16.7.34c.57-1.29 1.28-2.35 2.14-3.19l3.62 1.53c.6.25.98.83.98 1.48 0 .89-.72 1.61-1.61 1.61H4.72c.15-.46.32-.94.54-1.43zm13.18 4.48C17.3 17.29 15.68 18 14 18H4v-.8c0-.02.01-.92.24-2.2h6.15c1.99 0 3.61-1.62 3.61-3.61 0-1.45-.87-2.76-2.2-3.32L9.3 7.01c1.1-.57 2.37-.9 3.82-.99.15-.02.3-.02.44-.02 3.31 0 6.13 2.37 6.41 5.41.16 1.72-.38 3.36-1.53 4.63z"
	})), 'SportsMotorsportsTwoTone');
	
	exports.default = _default;

/***/ },
/* 5691 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.23 6c-1.66 0-3.22.66-4.36 1.73C6.54 6.73 5.61 6 4.5 6 3.12 6 2 7.12 2 8.5S3.12 11 4.5 11c.21 0 .41-.03.61-.08-.05.25-.09.51-.1.78-.18 3.68 2.95 6.68 6.68 6.27 2.55-.28 4.68-2.26 5.19-4.77.15-.71.15-1.4.06-2.06-.09-.6.38-1.13.99-1.13H22V6H11.23zM4.5 9c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zm6.5 6c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
	}), _react.default.createElement("circle", {
	  cx: "11",
	  cy: "12",
	  r: "2"
	})), 'SportsOutlined');
	
	exports.default = _default;

/***/ },
/* 5692 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21 6h-9.77c-1.66 0-3.22.66-4.36 1.73C6.54 6.73 5.61 6 4.5 6 3.12 6 2 7.12 2 8.5S3.12 11 4.5 11c.21 0 .41-.03.61-.08-.05.25-.09.51-.1.78-.18 3.68 2.95 6.68 6.68 6.27 2.55-.28 4.68-2.26 5.19-4.77.15-.71.15-1.4.06-2.06-.09-.6.38-1.13.99-1.13h2.76C21.56 10 22 9.55 22 9V7c0-.55-.45-1-1-1zM4.5 9c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zm6.5 6c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
	}), _react.default.createElement("circle", {
	  cx: "11",
	  cy: "12",
	  r: "2"
	})), 'SportsRounded');
	
	exports.default = _default;

/***/ },
/* 5693 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.49 3.51c-.56-.56-2.15-.97-4.16-.97-3.08 0-7.15.96-9.98 3.79-4.69 4.7-4.25 12.74-2.84 14.16.56.56 2.15.97 4.16.97 3.08 0 7.15-.96 9.98-3.79 4.69-4.7 4.25-12.74 2.84-14.16zM7.76 7.76c2.64-2.64 6.35-3.12 8.03-3.19-2.05.94-4.46 2.45-6.61 4.61-2.16 2.16-3.67 4.58-4.62 6.63.1-2.48.88-5.74 3.2-8.05zm8.48 8.48c-2.64 2.64-6.35 3.12-8.03 3.19 2.05-.94 4.46-2.45 6.61-4.61 2.16-2.16 3.67-4.58 4.62-6.63-.1 2.48-.88 5.74-3.2 8.05z"
	}), 'SportsRugby');
	
	exports.default = _default;

/***/ },
/* 5694 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.49 3.51c-.56-.56-2.15-.97-4.16-.97-3.08 0-7.15.96-9.98 3.79-4.69 4.7-4.25 12.74-2.84 14.16.56.56 2.15.97 4.16.97 3.08 0 7.15-.96 9.98-3.79 4.69-4.7 4.25-12.74 2.84-14.16zM5.71 18.29c.63-1.89 2.16-4.99 4.87-7.7 2.68-2.68 5.78-4.23 7.7-4.88-.63 1.89-2.16 4.99-4.88 7.7-2.66 2.68-5.76 4.23-7.69 4.88zM7.76 7.76c2.64-2.64 6.34-3.12 8.03-3.19-2.05.94-4.46 2.46-6.61 4.61-2.16 2.16-3.67 4.58-4.61 6.63.09-2.48.87-5.74 3.19-8.05zm8.48 8.48c-2.64 2.64-6.34 3.12-8.03 3.19 2.05-.94 4.46-2.46 6.61-4.61 2.16-2.16 3.67-4.58 4.62-6.63-.1 2.48-.88 5.74-3.2 8.05z"
	}), 'SportsRugbyOutlined');
	
	exports.default = _default;

/***/ },
/* 5695 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.49 3.51c-.56-.56-2.15-.97-4.16-.97-3.08 0-7.15.96-9.98 3.79-4.69 4.7-4.25 12.74-2.84 14.16.56.56 2.15.97 4.16.97 3.08 0 7.15-.96 9.98-3.79 4.69-4.7 4.25-12.74 2.84-14.16zM7.76 7.76c2.64-2.64 6.35-3.12 8.03-3.19-2.05.94-4.46 2.45-6.61 4.61-2.16 2.16-3.67 4.58-4.61 6.63.09-2.48.87-5.74 3.19-8.05zm8.48 8.48c-2.64 2.64-6.35 3.12-8.03 3.19 2.05-.94 4.46-2.45 6.61-4.61 2.16-2.16 3.67-4.58 4.62-6.63-.1 2.48-.88 5.74-3.2 8.05z"
	}), 'SportsRugbyRounded');
	
	exports.default = _default;

/***/ },
/* 5696 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.49 3.51c-.56-.56-2.15-.97-4.16-.97-3.08 0-7.15.96-9.98 3.79-4.69 4.7-4.25 12.74-2.84 14.16.56.56 2.15.97 4.16.97 3.08 0 7.15-.96 9.98-3.79 4.69-4.7 4.25-12.74 2.84-14.16zM7.76 7.76c2.64-2.64 6.35-3.12 8.03-3.19-2.05.94-4.46 2.45-6.61 4.61-2.16 2.16-3.67 4.58-4.61 6.63.09-2.48.87-5.74 3.19-8.05zm8.48 8.48c-2.64 2.64-6.35 3.12-8.03 3.19 2.05-.94 4.46-2.45 6.61-4.61 2.16-2.16 3.67-4.58 4.62-6.63-.1 2.48-.88 5.74-3.2 8.05z"
	}), 'SportsRugbySharp');
	
	exports.default = _default;

/***/ },
/* 5697 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18.29 5.71c-1.93.64-5.02 2.19-7.7 4.88-2.71 2.71-4.24 5.81-4.87 7.7 1.93-.64 5.03-2.2 7.7-4.87 2.71-2.72 4.24-5.82 4.87-7.71zM9.17 9.17c2.15-2.15 4.56-3.67 6.61-4.61-1.68.08-5.38.56-8.02 3.2-2.32 2.32-3.1 5.58-3.2 8.04.94-2.05 2.45-4.47 4.61-6.63zM14.83 14.83c-2.15 2.15-4.56 3.67-6.61 4.61 1.68-.08 5.39-.55 8.03-3.19 2.32-2.32 3.1-5.58 3.2-8.04-.95 2.04-2.46 4.46-4.62 6.62z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20.49 3.51c-.56-.56-2.15-.97-4.16-.97-3.08 0-7.15.96-9.98 3.79-4.69 4.7-4.25 12.74-2.84 14.16.56.56 2.15.97 4.16.97 3.08 0 7.15-.96 9.98-3.79 4.69-4.7 4.25-12.74 2.84-14.16zM5.71 18.29c.63-1.89 2.16-4.99 4.87-7.7 2.68-2.68 5.78-4.23 7.7-4.88-.63 1.89-2.16 4.99-4.88 7.7-2.66 2.68-5.76 4.23-7.69 4.88zM7.76 7.76c2.64-2.64 6.34-3.12 8.03-3.19-2.05.94-4.46 2.46-6.61 4.61-2.16 2.16-3.67 4.58-4.61 6.63.09-2.48.87-5.74 3.19-8.05zm8.48 8.48c-2.64 2.64-6.34 3.12-8.03 3.19 2.05-.94 4.46-2.46 6.61-4.61 2.16-2.16 3.67-4.58 4.62-6.63-.1 2.48-.88 5.74-3.2 8.05z"
	})), 'SportsRugbyTwoTone');
	
	exports.default = _default;

/***/ },
/* 5698 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.23 6c-1.66 0-3.22.66-4.36 1.73C6.54 6.73 5.61 6 4.5 6 3.12 6 2 7.12 2 8.5S3.12 11 4.5 11c.21 0 .41-.03.61-.08-.05.25-.09.51-.1.78-.18 3.68 2.95 6.68 6.68 6.27 2.55-.28 4.68-2.26 5.19-4.77.15-.71.15-1.4.06-2.06-.09-.6.38-1.13.99-1.13H22V6H11.23zM4.5 9c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zm6.5 6c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
	}), _react.default.createElement("circle", {
	  cx: "11",
	  cy: "12",
	  r: "2"
	})), 'SportsSharp');
	
	exports.default = _default;

/***/ },
/* 5699 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 3.3l1.35-.95c1.82.56 3.37 1.76 4.38 3.34l-.39 1.34-1.35.46L13 6.7V5.3zm-3.35-.95L11 5.3v1.4L7.01 9.49l-1.35-.46-.39-1.34c1.01-1.57 2.56-2.77 4.38-3.34zM7.08 17.11l-1.14.1C4.73 15.81 4 13.99 4 12c0-.12.01-.23.02-.35l1-.73 1.38.48 1.46 4.34-.78 1.37zm7.42 2.48c-.79.26-1.63.41-2.5.41s-1.71-.15-2.5-.41l-.69-1.49.64-1.1h5.11l.64 1.11-.7 1.48zM14.27 15H9.73l-1.35-4.02L12 8.44l3.63 2.54L14.27 15zm3.79 2.21l-1.14-.1-.79-1.37 1.46-4.34 1.39-.47 1 .73c.01.11.02.22.02.34 0 1.99-.73 3.81-1.94 5.21z"
	}), 'SportsSoccer');
	
	exports.default = _default;

/***/ },
/* 5700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 3.3l1.35-.95c1.82.56 3.37 1.76 4.38 3.34l-.39 1.34-1.35.46L13 6.7V5.3zm-3.35-.95L11 5.3v1.4L7.01 9.49l-1.35-.46-.39-1.34c1.01-1.57 2.56-2.77 4.38-3.34zM7.08 17.11l-1.14.1C4.73 15.81 4 13.99 4 12c0-.12.01-.23.02-.35l1-.73 1.38.48 1.46 4.34-.78 1.37zm7.42 2.48c-.79.26-1.63.41-2.5.41s-1.71-.15-2.5-.41l-.69-1.49.64-1.1h5.11l.64 1.11-.7 1.48zM14.27 15H9.73l-1.35-4.02L12 8.44l3.63 2.54L14.27 15zm3.79 2.21l-1.14-.1-.79-1.37 1.46-4.34 1.39-.47 1 .73c.01.11.02.22.02.34 0 1.99-.73 3.81-1.94 5.21z"
	}), 'SportsSoccerOutlined');
	
	exports.default = _default;

/***/ },
/* 5701 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 3.3l1.35-.95c1.82.56 3.37 1.76 4.38 3.34l-.39 1.34-1.35.46L13 6.7V5.3zm-3.35-.95L11 5.3v1.4L7.01 9.49l-1.35-.46-.39-1.34c1.01-1.57 2.56-2.77 4.38-3.34zM7.08 17.11l-1.14.1C4.73 15.81 4 13.99 4 12c0-.12.01-.23.02-.35l1-.73 1.38.48 1.46 4.34-.78 1.37zm7.42 2.48c-.79.26-1.63.41-2.5.41s-1.71-.15-2.5-.41l-.69-1.49.64-1.1h5.11l.64 1.11-.7 1.48zM14.27 15H9.73l-1.35-4.02L12 8.44l3.63 2.54L14.27 15zm3.79 2.21l-1.14-.1-.79-1.37 1.46-4.34 1.39-.47 1 .73c.01.11.02.22.02.34 0 1.99-.73 3.81-1.94 5.21z"
	}), 'SportsSoccerRounded');
	
	exports.default = _default;

/***/ },
/* 5702 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 3.3l1.35-.95c1.82.56 3.37 1.76 4.38 3.34l-.39 1.34-1.35.46L13 6.7V5.3zm-3.35-.95L11 5.3v1.4L7.01 9.49l-1.35-.46-.39-1.34c1.01-1.57 2.56-2.77 4.38-3.34zM7.08 17.11l-1.14.1C4.73 15.81 4 13.99 4 12c0-.12.01-.23.02-.35l1-.73 1.38.48 1.46 4.34-.78 1.37zm7.42 2.48c-.79.26-1.63.41-2.5.41s-1.71-.15-2.5-.41l-.69-1.49.64-1.1h5.11l.64 1.11-.7 1.48zM14.27 15H9.73l-1.35-4.02L12 8.44l3.63 2.54L14.27 15zm3.79 2.21l-1.14-.1-.79-1.37 1.46-4.34 1.39-.47 1 .73c.01.11.02.22.02.34 0 1.99-.73 3.81-1.94 5.21z"
	}), 'SportsSoccerSharp');
	
	exports.default = _default;

/***/ },
/* 5703 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7.01 9.49L11 6.7V5.3l-1.35-.95c-1.82.57-3.37 1.77-4.38 3.34l.39 1.34 1.35.46zM5.01 10.92l-1 .73c0 .12-.01.23-.01.35 0 1.99.73 3.81 1.94 5.21l1.14-.1.79-1.37L6.4 11.4l-1.39-.48zM18.34 9.03l.39-1.34c-1.01-1.57-2.55-2.77-4.38-3.34L13 5.3v1.4l3.99 2.79 1.35-.46zM8.37 10.98L9.73 15h4.54l1.36-4.02L12 8.44zM9.45 17l-.64 1.11.69 1.49c.79.25 1.63.4 2.5.4s1.71-.15 2.5-.41l.69-1.49-.64-1.1h-5.1zM19.98 11.65l-1-.73-1.38.48-1.46 4.34.79 1.37 1.14.1C19.27 15.81 20 13.99 20 12c0-.12-.01-.23-.02-.35z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 3.3l1.35-.95c1.82.56 3.37 1.76 4.38 3.34l-.39 1.34-1.35.46L13 6.7V5.3zm-3.35-.95L11 5.3v1.4L7.01 9.49l-1.35-.46-.39-1.34c1.01-1.57 2.56-2.77 4.38-3.34zM7.08 17.11l-1.14.1C4.73 15.81 4 13.99 4 12c0-.12.01-.23.02-.35l1-.73 1.38.48 1.46 4.34-.78 1.37zm7.42 2.48c-.79.26-1.63.41-2.5.41s-1.71-.15-2.5-.41l-.69-1.49.64-1.1h5.11l.64 1.11-.7 1.48zM14.27 15H9.73l-1.35-4.02L12 8.44l3.63 2.54L14.27 15zm3.79 2.21l-1.14-.1-.79-1.37 1.46-4.34 1.39-.47 1 .73c.01.11.02.22.02.34 0 1.99-.73 3.81-1.94 5.21z"
	})), 'SportsSoccerTwoTone');
	
	exports.default = _default;

/***/ },
/* 5704 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.52 2.49C17.18.15 12.9.62 9.97 3.55c-1.6 1.6-2.52 3.87-2.54 5.46-.02 1.58.26 3.89-1.35 5.5l-4.24 4.24 1.42 1.42 4.24-4.24c1.61-1.61 3.92-1.33 5.5-1.35s3.86-.94 5.46-2.54c2.92-2.93 3.4-7.21 1.06-9.55zm-9.2 9.19c-1.53-1.53-1.05-4.61 1.06-6.72s5.18-2.59 6.72-1.06c1.53 1.53 1.05 4.61-1.06 6.72s-5.18 2.59-6.72 1.06zM18 17c.53 0 1.04.21 1.41.59.78.78.78 2.05 0 2.83-.37.37-.88.58-1.41.58s-1.04-.21-1.41-.59c-.78-.78-.78-2.05 0-2.83.37-.37.88-.58 1.41-.58m0-2c-1.02 0-2.05.39-2.83 1.17-1.56 1.56-1.56 4.09 0 5.66.78.78 1.81 1.17 2.83 1.17s2.05-.39 2.83-1.17c1.56-1.56 1.56-4.09 0-5.66C20.05 15.39 19.02 15 18 15z"
	}), 'SportsTennis');
	
	exports.default = _default;

/***/ },
/* 5705 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.52 2.49C17.18.15 12.9.62 9.97 3.55c-1.6 1.6-2.52 3.87-2.54 5.46-.02 1.58.26 3.89-1.35 5.5l-4.24 4.24 1.42 1.42 4.24-4.24c1.61-1.61 3.92-1.33 5.5-1.35s3.86-.94 5.46-2.54c2.92-2.93 3.4-7.21 1.06-9.55zm-9.2 9.19c-1.53-1.53-1.05-4.61 1.06-6.72s5.18-2.59 6.72-1.06c1.53 1.53 1.05 4.61-1.06 6.72s-5.18 2.59-6.72 1.06zM18 17c.53 0 1.04.21 1.41.59.78.78.78 2.05 0 2.83-.37.37-.88.58-1.41.58s-1.04-.21-1.41-.59c-.78-.78-.78-2.05 0-2.83.37-.37.88-.58 1.41-.58m0-2c-1.02 0-2.05.39-2.83 1.17-1.56 1.56-1.56 4.09 0 5.66.78.78 1.81 1.17 2.83 1.17s2.05-.39 2.83-1.17c1.56-1.56 1.56-4.09 0-5.66C20.05 15.39 19.02 15 18 15z"
	}), 'SportsTennisOutlined');
	
	exports.default = _default;

/***/ },
/* 5706 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.52 2.49C17.18.15 12.9.62 9.97 3.55c-1.6 1.6-2.52 3.87-2.54 5.46-.02 1.58.26 3.89-1.35 5.5l-3.54 3.53c-.39.39-.39 1.02 0 1.42.39.39 1.02.39 1.42 0l3.53-3.54c1.61-1.61 3.92-1.33 5.5-1.35s3.86-.94 5.46-2.54c2.93-2.92 3.41-7.2 1.07-9.54zm-9.2 9.19c-1.53-1.53-1.05-4.61 1.06-6.72s5.18-2.59 6.72-1.06c1.53 1.53 1.05 4.61-1.06 6.72s-5.18 2.59-6.72 1.06zM18 17c.53 0 1.04.21 1.41.59.78.78.78 2.05 0 2.83-.37.37-.88.58-1.41.58s-1.04-.21-1.41-.59c-.78-.78-.78-2.05 0-2.83.37-.37.88-.58 1.41-.58m0-2c-1.02 0-2.05.39-2.83 1.17-1.56 1.56-1.56 4.09 0 5.66.78.78 1.81 1.17 2.83 1.17s2.05-.39 2.83-1.17c1.56-1.56 1.56-4.09 0-5.66C20.05 15.39 19.02 15 18 15z"
	}), 'SportsTennisRounded');
	
	exports.default = _default;

/***/ },
/* 5707 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.52 2.49C17.18.15 12.9.62 9.97 3.55c-1.6 1.6-2.52 3.87-2.54 5.46-.02 1.58.26 3.89-1.35 5.5l-4.24 4.24 1.42 1.42 4.24-4.24c1.61-1.61 3.92-1.33 5.5-1.35s3.86-.94 5.46-2.54c2.92-2.93 3.4-7.21 1.06-9.55zm-9.2 9.19c-1.53-1.53-1.05-4.61 1.06-6.72s5.18-2.59 6.72-1.06c1.53 1.53 1.05 4.61-1.06 6.72s-5.18 2.59-6.72 1.06zM18 17c.53 0 1.04.21 1.41.59.78.78.78 2.05 0 2.83-.37.37-.88.58-1.41.58s-1.04-.21-1.41-.59c-.78-.78-.78-2.05 0-2.83.37-.37.88-.58 1.41-.58m0-2c-1.02 0-2.05.39-2.83 1.17-1.56 1.56-1.56 4.09 0 5.66.78.78 1.81 1.17 2.83 1.17s2.05-.39 2.83-1.17c1.56-1.56 1.56-4.09 0-5.66C20.05 15.39 19.02 15 18 15z"
	}), 'SportsTennisSharp');
	
	exports.default = _default;

/***/ },
/* 5708 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.52 2.49C17.18.15 12.9.62 9.97 3.55c-1.6 1.6-2.52 3.87-2.54 5.46-.02 1.58.26 3.89-1.35 5.5l-4.24 4.24 1.42 1.42 4.24-4.24c1.61-1.61 3.92-1.33 5.5-1.35s3.86-.94 5.46-2.54c2.92-2.93 3.4-7.21 1.06-9.55zm-9.2 9.19c-1.53-1.53-1.05-4.61 1.06-6.72s5.18-2.59 6.72-1.06c1.53 1.53 1.05 4.61-1.06 6.72s-5.18 2.59-6.72 1.06zM18 17c.53 0 1.04.21 1.41.59.78.78.78 2.05 0 2.83-.37.37-.88.58-1.41.58s-1.04-.21-1.41-.59c-.78-.78-.78-2.05 0-2.83.37-.37.88-.58 1.41-.58m0-2c-1.02 0-2.05.39-2.83 1.17-1.56 1.56-1.56 4.09 0 5.66.78.78 1.81 1.17 2.83 1.17s2.05-.39 2.83-1.17c1.56-1.56 1.56-4.09 0-5.66C20.05 15.39 19.02 15 18 15z"
	}), 'SportsTennisTwoTone');
	
	exports.default = _default;

/***/ },
/* 5709 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.23 6c-1.66 0-3.22.66-4.36 1.73C6.54 6.73 5.61 6 4.5 6 3.12 6 2 7.12 2 8.5S3.12 11 4.5 11c.21 0 .41-.03.61-.08-.05.25-.09.51-.1.78-.18 3.68 2.95 6.68 6.68 6.27 2.55-.28 4.68-2.26 5.19-4.77.15-.71.15-1.4.06-2.06-.09-.6.38-1.13.99-1.13H22V6H11.23zM4.5 9c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zm6.5 6c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
	}), _react.default.createElement("circle", {
	  cx: "11",
	  cy: "12",
	  r: "2"
	})), 'SportsTwoTone');
	
	exports.default = _default;

/***/ },
/* 5710 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 4.01C3.58 5.84 2 8.73 2 12c0 1.46.32 2.85.89 4.11L6 14.31V4.01zM11 11.42V2.05c-1.06.11-2.07.38-3 .79v10.32l3-1.74zM12 13.15l-8.11 4.68c.61.84 1.34 1.59 2.18 2.2L15 14.89l-3-1.74zM13 7.96v3.46l8.11 4.68c.42-.93.7-1.93.82-2.98L13 7.96zM8.07 21.2c1.21.51 2.53.8 3.93.8 3.34 0 6.29-1.65 8.11-4.16L17 16.04 8.07 21.2zM21.92 10.81c-.55-4.63-4.26-8.3-8.92-8.76v3.6l8.92 5.16z"
	}), 'SportsVolleyball');
	
	exports.default = _default;

/***/ },
/* 5711 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 2.07c3.07.38 5.57 2.52 6.54 5.36L13 5.65V4.07zM8 5.08c1.18-.69 3.33-1.06 3-1.02v7.35l-3 1.73V5.08zM4.63 15.1c-.4-.96-.63-2-.63-3.1 0-2.02.76-3.86 2-5.27v7.58l-1.37.79zm1.01 1.73L12 13.15l3 1.73-6.98 4.03c-.93-.53-1.74-1.23-2.38-2.08zM12 20c-.54 0-1.07-.06-1.58-.16l6.58-3.8 1.36.78C16.9 18.75 14.6 20 12 20zm1-8.58V7.96l7 4.05c0 1.1-.23 2.14-.63 3.09L13 11.42z"
	}), 'SportsVolleyballOutlined');
	
	exports.default = _default;

/***/ },
/* 5712 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 4.01C3.58 5.84 2 8.73 2 12c0 1.46.32 2.85.89 4.11L6 14.31V4.01zM11 11.42V2.05c-1.06.11-2.07.38-3 .79v10.32l3-1.74zM12 13.15l-8.11 4.68c.61.84 1.34 1.59 2.18 2.2L15 14.89l-3-1.74zM13 7.96v3.46l8.11 4.68c.42-.93.7-1.93.82-2.98L13 7.96zM8.07 21.2c1.21.51 2.53.8 3.93.8 3.34 0 6.29-1.65 8.11-4.16L17 16.04 8.07 21.2zM21.92 10.81c-.55-4.63-4.26-8.3-8.92-8.76v3.6l8.92 5.16z"
	}), 'SportsVolleyballRounded');
	
	exports.default = _default;

/***/ },
/* 5713 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 4.01C3.58 5.84 2 8.73 2 12c0 1.46.32 2.85.89 4.11L6 14.31V4.01zM11 11.42V2.05c-1.06.11-2.07.38-3 .79v10.32l3-1.74zM12 13.15l-8.11 4.68c.61.84 1.34 1.59 2.18 2.2L15 14.89l-3-1.74zM13 7.96v3.46l8.11 4.68c.42-.93.7-1.93.82-2.98L13 7.96zM8.07 21.2c1.21.51 2.53.8 3.93.8 3.34 0 6.29-1.65 8.11-4.16L17 16.04 8.07 21.2zM21.92 10.81c-.55-4.63-4.26-8.3-8.92-8.76v3.6l8.92 5.16z"
	}), 'SportsVolleyballSharp');
	
	exports.default = _default;

/***/ },
/* 5714 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 6.73C4.76 8.14 4 9.98 4 12c0 1.1.23 2.14.63 3.1L6 14.31V6.73zM11 4.08c-.25.06-1.98.42-3 1.01v8.07l3-1.73V4.08zM13 4.07v1.58l6.54 3.79c-.97-2.85-3.47-4.99-6.54-5.37zM12 13.15l-6.36 3.67c.64.85 1.46 1.55 2.38 2.09L15 14.89l-3-1.74zM13 7.96v3.46l6.37 3.68c.4-.95.63-1.99.63-3.09l-7-4.05zM10.42 19.84c.51.1 1.04.16 1.58.16 2.6 0 4.9-1.25 6.36-3.17L17 16.04l-6.58 3.8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 2.07c3.07.38 5.57 2.52 6.54 5.36L13 5.65V4.07zM8 5.08c1.02-.59 2.75-.95 3-1.01v7.35l-3 1.73V5.08zM4.63 15.1c-.4-.96-.63-2-.63-3.1 0-2.02.76-3.86 2-5.27v7.58l-1.37.79zm1.01 1.73L12 13.15l3 1.73-6.98 4.03c-.93-.53-1.74-1.23-2.38-2.08zM12 20c-.54 0-1.07-.06-1.58-.16l6.58-3.8 1.36.78C16.9 18.75 14.6 20 12 20zm1-8.58V7.96l7 4.05c0 1.1-.23 2.14-.63 3.09L13 11.42z"
	})), 'SportsVolleyballTwoTone');
	
	exports.default = _default;

/***/ },
/* 5715 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.66 17.66l-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L9.7 9.7l-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L4 4v14c0 1.1.9 2 2 2h14l-2.34-2.34zM7 17v-5.76L12.76 17H7z"
	}), 'SquareFoot');
	
	exports.default = _default;

/***/ },
/* 5716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.66 17.66l-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L9.7 9.7l-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L4 4v14c0 1.1.9 2 2 2h14l-2.34-2.34zM7 17v-5.76L12.76 17H7z"
	}), 'SquareFootOutlined');
	
	exports.default = _default;

/***/ },
/* 5717 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.66 17.66l-.71.71c-.2.2-.51.2-.71 0-.2-.2-.2-.51 0-.71l.71-.71-1.94-1.94-.71.71c-.2.2-.51.2-.71 0-.2-.2-.2-.51 0-.71l.71-.71-1.94-1.94-.71.71c-.2.2-.51.2-.71 0-.2-.2-.2-.51 0-.71l.71-.71L9.7 9.7l-.71.71c-.2.2-.51.2-.71 0-.2-.2-.2-.51 0-.71l.71-.71-1.94-1.94-.71.71c-.2.2-.51.2-.71 0-.2-.2-.2-.51 0-.71l.71-.71-1.49-1.49c-.31-.31-.85-.09-.85.36V18c0 1.1.9 2 2 2h12.79c.45 0 .67-.54.35-.85l-1.48-1.49zM7 16v-4.76L12.76 17H8c-.55 0-1-.45-1-1z"
	}), 'SquareFootRounded');
	
	exports.default = _default;

/***/ },
/* 5718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.66 17.66l-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L9.7 9.7l-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L4 4v16h16l-2.34-2.34zM7 17v-5.76L12.76 17H7z"
	}), 'SquareFootSharp');
	
	exports.default = _default;

/***/ },
/* 5719 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 17h5.76L7 11.24z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17.66 17.66l-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L9.7 9.7l-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L4 4v14c0 1.1.9 2 2 2h14l-2.34-2.34zM7 17v-5.76L12.76 17H7z"
	})), 'SquareFootTwoTone');
	
	exports.default = _default;

/***/ },
/* 5720 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
	}), 'Star');
	
	exports.default = _default;

/***/ },
/* 5721 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
	}), 'StarBorder');
	
	exports.default = _default;

/***/ },
/* 5722 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
	}), 'StarBorderOutlined');
	
	exports.default = _default;

/***/ },
/* 5723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.65 9.04l-4.84-.42-1.89-4.45c-.34-.81-1.5-.81-1.84 0L9.19 8.63l-4.83.41c-.88.07-1.24 1.17-.57 1.75l3.67 3.18-1.1 4.72c-.2.86.73 1.54 1.49 1.08l4.15-2.5 4.15 2.51c.76.46 1.69-.22 1.49-1.08l-1.1-4.73 3.67-3.18c.67-.58.32-1.68-.56-1.75zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
	}), 'StarBorderRounded');
	
	exports.default = _default;

/***/ },
/* 5724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
	}), 'StarBorderSharp');
	
	exports.default = _default;

/***/ },
/* 5725 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
	}), 'StarBorderTwoTone');
	
	exports.default = _default;

/***/ },
/* 5726 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
	}), 'StarHalf');
	
	exports.default = _default;

/***/ },
/* 5727 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
	}), 'StarHalfOutlined');
	
	exports.default = _default;

/***/ },
/* 5728 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.65 9.04l-4.84-.42-1.89-4.45c-.34-.81-1.5-.81-1.84 0L9.19 8.63l-4.83.41c-.88.07-1.24 1.17-.57 1.75l3.67 3.18-1.1 4.72c-.2.86.73 1.54 1.49 1.08l4.15-2.5 4.15 2.51c.76.46 1.69-.22 1.49-1.08l-1.1-4.73 3.67-3.18c.67-.58.32-1.68-.56-1.75zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
	}), 'StarHalfRounded');
	
	exports.default = _default;

/***/ },
/* 5729 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
	}), 'StarHalfSharp');
	
	exports.default = _default;

/***/ },
/* 5730 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
	}), 'StarHalfTwoTone');
	
	exports.default = _default;

/***/ },
/* 5731 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27z"
	}), 'StarOutlined');
	
	exports.default = _default;

/***/ },
/* 5732 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  transform: "scale(1.33, 1.33)",
	  d: "M9 11.3l3.71 2.7-1.42-4.36L15 7h-4.55L9 2.5 7.55 7H3l3.71 2.64L5.29 14z"
	}), 'StarRate');
	
	exports.default = _default;

/***/ },
/* 5733 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  transform: "scale(1.33, 1.33)",
	  d: "M9 11.3l3.71 2.7-1.42-4.36L15 7h-4.55L9 2.5 7.55 7H3l3.71 2.64L5.29 14 9 11.3z"
	}), 'StarRateOutlined');
	
	exports.default = _default;

/***/ },
/* 5734 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  transform: "scale(1.33, 1.33)",
	  d: "M9 11.3l2.46 1.79c.39.29.92-.1.77-.56l-.94-2.89 2.43-1.73c.4-.28.2-.91-.29-.91h-2.98l-.97-3.02c-.15-.46-.8-.46-.95 0L7.55 7H4.57c-.49 0-.69.63-.29.91l2.43 1.73-.94 2.89c-.15.46.38.84.77.56L9 11.3z"
	}), 'StarRateRounded');
	
	exports.default = _default;

/***/ },
/* 5735 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  transform: "scale(1.33, 1.33)",
	  d: "M9 11.3l3.71 2.7-1.42-4.36L15 7h-4.55L9 2.5 7.55 7H3l3.71 2.64L5.29 14 9 11.3z"
	}), 'StarRateSharp');
	
	exports.default = _default;

/***/ },
/* 5736 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  transform: "scale(1.33, 1.33)",
	  d: "M9 11.3l3.71 2.7-1.42-4.36L15 7h-4.55L9 2.5 7.55 7H3l3.71 2.64L5.29 14 9 11.3z"
	}), 'StarRateTwoTone');
	
	exports.default = _default;

/***/ },
/* 5737 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 17.27l4.15 2.51c.76.46 1.69-.22 1.49-1.08l-1.1-4.72 3.67-3.18c.67-.58.31-1.68-.57-1.75l-4.83-.41-1.89-4.46c-.34-.81-1.5-.81-1.84 0L9.19 8.63l-4.83.41c-.88.07-1.24 1.17-.57 1.75l3.67 3.18-1.1 4.72c-.2.86.73 1.54 1.49 1.08l4.15-2.5z"
	}), 'StarRounded');
	
	exports.default = _default;

/***/ },
/* 5738 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27z"
	}), 'StarSharp');
	
	exports.default = _default;

/***/ },
/* 5739 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
	})), 'StarTwoTone');
	
	exports.default = _default;

/***/ },
/* 5740 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"
	}), 'Stars');
	
	exports.default = _default;

/***/ },
/* 5741 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm7.48 7.16l-5.01-.43-2-4.71c3.21.19 5.91 2.27 7.01 5.14zm-5.07 6.26L12 13.98l-2.39 1.44.63-2.72-2.11-1.83 2.78-.24L12 8.06l1.09 2.56 2.78.24-2.11 1.83.64 2.73zm-2.86-11.4l-2 4.72-5.02.43c1.1-2.88 3.8-4.97 7.02-5.15zM4 12c0-.64.08-1.26.23-1.86l3.79 3.28-1.11 4.75C5.13 16.7 4 14.48 4 12zm3.84 6.82L12 16.31l4.16 2.5c-1.22.75-2.64 1.19-4.17 1.19-1.52 0-2.94-.44-4.15-1.18zm9.25-.65l-1.11-4.75 3.79-3.28c.14.59.23 1.22.23 1.86 0 2.48-1.14 4.7-2.91 6.17z"
	}), 'StarsOutlined');
	
	exports.default = _default;

/***/ },
/* 5742 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm3.23 15.39L12 15.45l-3.22 1.94c-.38.23-.85-.11-.75-.54l.85-3.66-2.83-2.45c-.33-.29-.15-.84.29-.88l3.74-.32 1.46-3.45c.17-.41.75-.41.92 0l1.46 3.44 3.74.32c.44.04.62.59.28.88l-2.83 2.45.85 3.67c.1.43-.36.77-.74.54z"
	}), 'StarsRounded');
	
	exports.default = _default;

/***/ },
/* 5743 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"
	}), 'StarsSharp');
	
	exports.default = _default;

/***/ },
/* 5744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19.47 9.16c-1.1-2.87-3.8-4.95-7.01-5.14l2 4.71 5.01.43zm-7.93-5.14c-3.22.18-5.92 2.27-7.02 5.15l5.02-.43 2-4.72zm-7.31 6.12C4.08 10.74 4 11.36 4 12c0 2.48 1.14 4.7 2.91 6.17l1.11-4.75-3.79-3.28zm15.54-.01l-3.79 3.28 1.1 4.76C18.86 16.7 20 14.48 20 12c0-.64-.09-1.27-.23-1.87zM7.84 18.82c1.21.74 2.63 1.18 4.15 1.18 1.53 0 2.95-.44 4.17-1.18L12 16.31l-4.16 2.51z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm7.48 7.16l-5.01-.43-2-4.71c3.21.19 5.91 2.27 7.01 5.14zM12 8.06l1.09 2.56 2.78.24-2.11 1.83.63 2.73L12 13.98l-2.39 1.44.63-2.72-2.11-1.83 2.78-.24L12 8.06zm-.46-4.04l-2 4.72-5.02.43c1.1-2.88 3.8-4.97 7.02-5.15zM4 12c0-.64.08-1.26.23-1.86l3.79 3.28-1.11 4.75C5.14 16.7 4 14.48 4 12zm7.99 8c-1.52 0-2.94-.44-4.15-1.18L12 16.31l4.16 2.51c-1.22.74-2.64 1.18-4.17 1.18zm5.1-1.83l-1.1-4.76 3.79-3.28c.13.6.22 1.23.22 1.87 0 2.48-1.14 4.7-2.91 6.17z"
	})), 'StarsTwoTone');
	
	exports.default = _default;

/***/ },
/* 5745 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"
	}), 'StayCurrentLandscape');
	
	exports.default = _default;

/***/ },
/* 5746 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"
	}), 'StayCurrentLandscapeOutlined');
	
	exports.default = _default;

/***/ },
/* 5747 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"
	}), 'StayCurrentLandscapeRounded');
	
	exports.default = _default;

/***/ },
/* 5748 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 19h22V5H1v14zM19 7v10H5V7h14z"
	}), 'StayCurrentLandscapeSharp');
	
	exports.default = _default;

/***/ },
/* 5749 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 7h14v10H5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 5H3c-1.1 0-1.99.9-1.99 2L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10z"
	})), 'StayCurrentLandscapeTwoTone');
	
	exports.default = _default;

/***/ },
/* 5750 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
	}), 'StayCurrentPortrait');
	
	exports.default = _default;

/***/ },
/* 5751 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
	}), 'StayCurrentPortraitOutlined');
	
	exports.default = _default;

/***/ },
/* 5752 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
	}), 'StayCurrentPortraitRounded');
	
	exports.default = _default;

/***/ },
/* 5753 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 1.01L5.01 1v22H19V1.01zM17 19H7V5h10v14z"
	}), 'StayCurrentPortraitSharp');
	
	exports.default = _default;

/***/ },
/* 5754 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 5h10v14H7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
	})), 'StayCurrentPortraitTwoTone');
	
	exports.default = _default;

/***/ },
/* 5755 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"
	}), 'StayPrimaryLandscape');
	
	exports.default = _default;

/***/ },
/* 5756 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"
	}), 'StayPrimaryLandscapeOutlined');
	
	exports.default = _default;

/***/ },
/* 5757 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"
	}), 'StayPrimaryLandscapeRounded');
	
	exports.default = _default;

/***/ },
/* 5758 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 19h22V5H1v14zM19 7v10H5V7h14z"
	}), 'StayPrimaryLandscapeSharp');
	
	exports.default = _default;

/***/ },
/* 5759 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 7h14v10H5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 5H3c-1.1 0-1.99.9-1.99 2L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10z"
	})), 'StayPrimaryLandscapeTwoTone');
	
	exports.default = _default;

/***/ },
/* 5760 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
	}), 'StayPrimaryPortrait');
	
	exports.default = _default;

/***/ },
/* 5761 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
	}), 'StayPrimaryPortraitOutlined');
	
	exports.default = _default;

/***/ },
/* 5762 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
	}), 'StayPrimaryPortraitRounded');
	
	exports.default = _default;

/***/ },
/* 5763 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.01 1v22H19V1H5.01zM17 19H7V5h10v14z"
	}), 'StayPrimaryPortraitSharp');
	
	exports.default = _default;

/***/ },
/* 5764 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 5h10v14H7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
	})), 'StayPrimaryPortraitTwoTone');
	
	exports.default = _default;

/***/ },
/* 5765 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 6h12v12H6z"
	}), 'Stop');
	
	exports.default = _default;

/***/ },
/* 5766 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 8v8H8V8h8m2-2H6v12h12V6z"
	}), 'StopOutlined');
	
	exports.default = _default;

/***/ },
/* 5767 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 6h8c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2z"
	}), 'StopRounded');
	
	exports.default = _default;

/***/ },
/* 5768 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.22 18.02l2 2H24v-2h-2.78zm.77-2l.01-10c0-1.11-.9-2-2-2H7.22l5.23 5.23c.18-.04.36-.07.55-.1V7.02l4 3.73-1.58 1.47 5.54 5.54c.61-.33 1.03-.99 1.03-1.74zM2.39 1.73L1.11 3l1.54 1.54c-.4.36-.65.89-.65 1.48v10c0 1.1.89 2 2 2H0v2h18.13l2.71 2.71 1.27-1.27L2.39 1.73zM7 15.02c.31-1.48.92-2.95 2.07-4.06l1.59 1.59c-1.54.38-2.7 1.18-3.66 2.47z"
	}), 'StopScreenShare');
	
	exports.default = _default;

/***/ },
/* 5769 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.79 18l2 2H24v-2h-2.21zM1.11 2.98l1.55 1.56c-.41.37-.66.89-.66 1.48V16c0 1.1.9 2 2.01 2H0v2h18.13l2.71 2.71 1.41-1.41L2.52 1.57 1.11 2.98zM4 6.02h.13l4.95 4.93C7.94 12.07 7.31 13.52 7 15c.96-1.29 2.13-2.08 3.67-2.46l3.46 3.48H4v-10zm16 0v10.19l1.3 1.3c.42-.37.7-.89.7-1.49v-10c0-1.11-.9-2-2-2H7.8l2 2H20zm-7.07 3.13l2.79 2.78 1.28-1.2L13 7v2.13l-.07.02z"
	}), 'StopScreenShareOutlined');
	
	exports.default = _default;

/***/ },
/* 5770 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 18h-1.2l1.79 1.79c.24-.18.41-.46.41-.79 0-.55-.45-1-1-1zM3.23 2.28c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.02 0 1.41l.84.86s-.66.57-.66 1.47C2 6.92 2 16 2 16l.01.01c0 1.09.88 1.98 1.97 1.99H1c-.55 0-1 .45-1 1s.45 1 1 1h17.13l2 2c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L3.23 2.28zM7 15c.31-1.48.94-2.93 2.08-4.05l1.59 1.59C9.13 12.92 7.96 13.71 7 15zm6-5.87v-.98c0-.44.52-.66.84-.37L15 8.87l1.61 1.5c.21.2.21.53 0 .73l-.89.83 5.58 5.58c.43-.37.7-.9.7-1.51V6c0-1.09-.89-1.98-1.98-1.98H7.8l5.14 5.13c.02-.01.04-.02.06-.02z"
	}), 'StopScreenShareRounded');
	
	exports.default = _default;

/***/ },
/* 5771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.79 18l2 2H24v-2zM13 9.13V7l4 3.74-1.28 1.19 5.18 5.18L22 16V4.02H7.8l5.13 5.13c.03-.01.05-.02.07-.02zM1.11 2.98l.89.9v12.14l2 1.99L0 18v2h18.13l2.71 2.71 1.41-1.41L2.52 1.57 1.11 2.98zm7.97 7.97l1.59 1.59C9.13 12.92 7.96 13.71 7 15c.31-1.48.94-2.93 2.08-4.05z"
	}), 'StopScreenShareSharp');
	
	exports.default = _default;

/***/ },
/* 5772 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M10.67 12.54C9.13 12.92 7.96 13.71 7 15c.31-1.48.94-2.93 2.08-4.05L4.13 6.02H4v10.01h10.14l-3.47-3.49z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21.79 18l2 2H24v-2h-2.21zM1.11 2.98l1.55 1.56c-.41.37-.66.89-.66 1.48V16c0 1.1.9 2 2.01 2H0v2h18.13l2.71 2.71 1.41-1.41L2.52 1.57 1.11 2.98zM4 6.02h.13l4.95 4.93C7.94 12.07 7.31 13.52 7 15c.96-1.29 2.13-2.08 3.67-2.46l3.46 3.48H4v-10zm16 0v10.19l1.3 1.3c.42-.37.7-.89.7-1.49v-10c0-1.11-.9-2-2-2H7.8l2 2H20zm-7.07 3.13l2.79 2.78 1.28-1.2L13 7v2.13l-.07.02z"
	}), _react.default.createElement("path", {
	  d: "M20 6.02H9.8l3.13 3.13c.02 0 .04-.01.07-.02V7l4 3.73-1.28 1.2L20 16.21V6.02z",
	  opacity: ".3"
	})), 'StopScreenShareTwoTone');
	
	exports.default = _default;

/***/ },
/* 5773 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 6h12v12H6V6z"
	}), 'StopSharp');
	
	exports.default = _default;

/***/ },
/* 5774 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 8h8v8H8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M6 18h12V6H6v12zM8 8h8v8H8V8z"
	})), 'StopTwoTone');
	
	exports.default = _default;

/***/ },
/* 5775 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z"
	}), 'Storage');
	
	exports.default = _default;

/***/ },
/* 5776 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z"
	}), 'StorageOutlined');
	
	exports.default = _default;

/***/ },
/* 5777 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 20h16c1.1 0 2-.9 2-2s-.9-2-2-2H4c-1.1 0-2 .9-2 2s.9 2 2 2zm0-3h2v2H4v-2zM2 6c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2s-.9-2-2-2H4c-1.1 0-2 .9-2 2zm4 1H4V5h2v2zm-2 7h16c1.1 0 2-.9 2-2s-.9-2-2-2H4c-1.1 0-2 .9-2 2s.9 2 2 2zm0-3h2v2H4v-2z"
	}), 'StorageRounded');
	
	exports.default = _default;

/***/ },
/* 5778 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z"
	}), 'StorageSharp');
	
	exports.default = _default;

/***/ },
/* 5779 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z"
	}), 'StorageTwoTone');
	
	exports.default = _default;

/***/ },
/* 5780 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"
	}), 'Store');
	
	exports.default = _default;

/***/ },
/* 5781 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"
	}), 'StoreMallDirectory');
	
	exports.default = _default;

/***/ },
/* 5782 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.36 9l.6 3H5.04l.6-3h12.72M20 4H4v2h16V4zm0 3H4l-1 5v2h1v6h10v-6h4v6h2v-6h1v-2l-1-5zM6 18v-4h6v4H6z"
	}), 'StoreMallDirectoryOutlined');
	
	exports.default = _default;

/***/ },
/* 5783 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.16 7.8c-.09-.46-.5-.8-.98-.8H4.82c-.48 0-.89.34-.98.8L3 12v1c0 .55.45 1 1 1v5c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-5h4v5c0 .55.45 1 1 1s1-.45 1-1v-5c.55 0 1-.45 1-1v-1l-.84-4.2zM12 18H6v-4h6v4zM5 6h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1z"
	}), 'StoreMallDirectoryRounded');
	
	exports.default = _default;

/***/ },
/* 5784 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"
	}), 'StoreMallDirectorySharp');
	
	exports.default = _default;

/***/ },
/* 5785 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5.64 9l-.6 3h13.92l-.6-3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 7l-1 5v2h1v6h10v-6h4v6h2v-6h1v-2l-1-5H4zm8 11H6v-4h6v4zm-6.96-6l.6-3h12.72l.6 3H5.04zM4 4h16v2H4z"
	})), 'StoreMallDirectoryTwoTone');
	
	exports.default = _default;

/***/ },
/* 5786 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.36 9l.6 3H5.04l.6-3h12.72M20 4H4v2h16V4zm0 3H4l-1 5v2h1v6h10v-6h4v6h2v-6h1v-2l-1-5zM6 18v-4h6v4H6z"
	}), 'StoreOutlined');
	
	exports.default = _default;

/***/ },
/* 5787 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 6h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1zm15.16 1.8c-.09-.46-.5-.8-.98-.8H4.82c-.48 0-.89.34-.98.8l-1 5c-.12.62.35 1.2.98 1.2H4v5c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-5h4v5c0 .55.45 1 1 1s1-.45 1-1v-5h.18c.63 0 1.1-.58.98-1.2l-1-5zM12 18H6v-4h6v4z"
	}), 'StoreRounded');
	
	exports.default = _default;

/***/ },
/* 5788 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"
	}), 'StoreSharp');
	
	exports.default = _default;

/***/ },
/* 5789 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5.64 9l-.6 3h13.92l-.6-3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 4h16v2H4zm16 3H4l-1 5v2h1v6h10v-6h4v6h2v-6h1v-2l-1-5zm-8 11H6v-4h6v4zm-6.96-6l.6-3h12.72l.6 3H5.04z"
	})), 'StoreTwoTone');
	
	exports.default = _default;

/***/ },
/* 5790 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.9 8.89l-1.05-4.37c-.22-.9-1-1.52-1.91-1.52H5.05c-.9 0-1.69.63-1.9 1.52L2.1 8.89c-.24 1.02-.02 2.06.62 2.88.08.11.19.19.28.29V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6.94c.09-.09.2-.18.28-.28.64-.82.87-1.87.62-2.89zm-2.99-3.9l1.05 4.37c.1.42.01.84-.25 1.17-.14.18-.44.47-.94.47-.61 0-1.14-.49-1.21-1.14L16.98 5l1.93-.01zM13 5h1.96l.54 4.52c.05.39-.07.78-.33 1.07-.22.26-.54.41-.95.41-.67 0-1.22-.59-1.22-1.31V5zM8.49 9.52L9.04 5H11v4.69c0 .72-.55 1.31-1.29 1.31-.34 0-.65-.15-.89-.41-.25-.29-.37-.68-.33-1.07zm-4.45-.16L5.05 5h1.97l-.58 4.86c-.08.65-.6 1.14-1.21 1.14-.49 0-.8-.29-.93-.47-.27-.32-.36-.75-.26-1.17zM5 19v-6.03c.08.01.15.03.23.03.87 0 1.66-.36 2.24-.95.6.6 1.4.95 2.31.95.87 0 1.65-.36 2.23-.93.59.57 1.39.93 2.29.93.84 0 1.64-.35 2.24-.95.58.59 1.37.95 2.24.95.08 0 .15-.02.23-.03V19H5z"
	}), 'Storefront');
	
	exports.default = _default;

/***/ },
/* 5791 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.9 8.89l-1.05-4.37c-.22-.9-1-1.52-1.91-1.52H5.05c-.9 0-1.69.63-1.9 1.52L2.1 8.89c-.24 1.02-.02 2.06.62 2.88.08.11.19.19.28.29V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6.94c.09-.09.2-.18.28-.28.64-.82.87-1.87.62-2.89zm-2.99-3.9l1.05 4.37c.1.42.01.84-.25 1.17-.14.18-.44.47-.94.47-.61 0-1.14-.49-1.21-1.14L16.98 5l1.93-.01zM13 5h1.96l.54 4.52c.05.39-.07.78-.33 1.07-.22.26-.54.41-.95.41-.67 0-1.22-.59-1.22-1.31V5zM8.49 9.52L9.04 5H11v4.69c0 .72-.55 1.31-1.29 1.31-.34 0-.65-.15-.89-.41-.25-.29-.37-.68-.33-1.07zm-4.45-.16L5.05 5h1.97l-.58 4.86c-.08.65-.6 1.14-1.21 1.14-.49 0-.8-.29-.93-.47-.27-.32-.36-.75-.26-1.17zM5 19v-6.03c.08.01.15.03.23.03.87 0 1.66-.36 2.24-.95.6.6 1.4.95 2.31.95.87 0 1.65-.36 2.23-.93.59.57 1.39.93 2.29.93.84 0 1.64-.35 2.24-.95.58.59 1.37.95 2.24.95.08 0 .15-.02.23-.03V19H5z"
	}), 'StorefrontOutlined');
	
	exports.default = _default;

/***/ },
/* 5792 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.9 8.89l-1.05-4.37c-.22-.9-1-1.52-1.91-1.52H5.05c-.9 0-1.69.63-1.9 1.52L2.1 8.89c-.24 1.02-.02 2.06.62 2.88.08.11.19.19.28.29V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6.94c.09-.09.2-.18.28-.28.64-.82.87-1.87.62-2.89zM7.02 5l-.58 4.86c-.08.65-.6 1.14-1.21 1.14-.49 0-.8-.29-.93-.47-.26-.33-.35-.76-.25-1.17l1-4.36h1.97zm11.89-.01l1.05 4.37c.1.42.01.84-.25 1.17-.14.18-.44.47-.94.47-.61 0-1.14-.49-1.21-1.14L16.98 5l1.93-.01zm-3.4 4.53c.05.39-.07.78-.33 1.07-.23.26-.55.41-.96.41-.67 0-1.22-.59-1.22-1.31V5h1.96l.55 4.52zM11 9.69c0 .72-.55 1.31-1.29 1.31-.34 0-.65-.15-.89-.41-.25-.29-.37-.68-.33-1.07L9.04 5H11v4.69zM18 19H6c-.55 0-1-.45-1-1v-5.03c.08.01.15.03.23.03.87 0 1.66-.36 2.24-.95.6.6 1.4.95 2.31.95.87 0 1.65-.36 2.23-.93.59.57 1.39.93 2.29.93.84 0 1.64-.35 2.24-.95.58.59 1.37.95 2.24.95.08 0 .15-.02.23-.03V18c-.01.55-.46 1-1.01 1z"
	}), 'StorefrontRounded');
	
	exports.default = _default;

/***/ },
/* 5793 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.9 8.89L20.49 3H3.51L2.1 8.89c-.24 1.02-.02 2.06.62 2.88.08.11.19.19.28.29V21h18v-8.94c.09-.09.2-.18.28-.28.64-.82.87-1.87.62-2.89zM7.02 5l-.58 4.86c-.08.65-.6 1.14-1.21 1.14-.49 0-.8-.29-.93-.47-.26-.33-.35-.76-.25-1.17L5.09 5h1.93zm11.89 0l1.05 4.36c.1.42.01.84-.25 1.17-.14.18-.44.47-.94.47-.61 0-1.14-.49-1.21-1.14L16.98 5h1.93zm-3.4 4.52c.05.39-.07.78-.33 1.07-.23.26-.55.41-.96.41-.67 0-1.22-.59-1.22-1.31V5h1.96l.55 4.52zM11 9.69c0 .72-.55 1.31-1.29 1.31-.34 0-.65-.15-.89-.41-.25-.29-.37-.68-.33-1.07L9.04 5H11v4.69zM5 19v-6.03c.08.01.15.03.23.03.87 0 1.66-.36 2.24-.95.6.6 1.4.95 2.31.95.87 0 1.65-.36 2.23-.93.59.57 1.39.93 2.29.93.84 0 1.64-.35 2.24-.95.58.59 1.37.95 2.24.95.08 0 .15-.02.23-.03V19H5z"
	}), 'StorefrontSharp');
	
	exports.default = _default;

/***/ },
/* 5794 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6.44 9.86L7.02 5H5.05L4.04 9.36c-.1.42-.01.84.25 1.17.14.18.44.47.94.47.61 0 1.13-.49 1.21-1.14zM9.71 11c.74 0 1.29-.59 1.29-1.31V5H9.04l-.55 4.52c-.05.39.07.78.33 1.07.23.26.55.41.89.41zM14.22 11c.41 0 .72-.15.96-.41.25-.29.37-.68.33-1.07L14.96 5H13v4.69c0 .72.55 1.31 1.22 1.31zM18.91 4.99L16.98 5l.58 4.86c.08.65.6 1.14 1.21 1.14.49 0 .8-.29.93-.47.26-.33.35-.76.25-1.17l-1.04-4.37z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21.9 8.89l-1.05-4.37c-.22-.9-1-1.52-1.91-1.52H5.05c-.9 0-1.69.63-1.9 1.52L2.1 8.89c-.24 1.02-.02 2.06.62 2.88.08.11.19.19.28.29V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6.94c.09-.09.2-.18.28-.28.64-.82.87-1.87.62-2.89zM13 5h1.96l.54 4.52c.05.39-.07.78-.33 1.07-.22.26-.54.41-.95.41-.67 0-1.22-.59-1.22-1.31V5zM8.49 9.52L9.04 5H11v4.69c0 .72-.55 1.31-1.29 1.31-.34 0-.65-.15-.89-.41-.25-.29-.37-.68-.33-1.07zm-4.2 1.01c-.26-.33-.35-.76-.25-1.17L5.05 5h1.97l-.58 4.86c-.08.65-.6 1.14-1.21 1.14-.5 0-.8-.29-.94-.47zM19 19H5v-6.03c.08.01.15.03.23.03.87 0 1.66-.36 2.24-.95.6.6 1.4.95 2.31.95.87 0 1.65-.36 2.23-.93.59.57 1.39.93 2.29.93.84 0 1.64-.35 2.24-.95.58.59 1.37.95 2.24.95.08 0 .15-.02.23-.03V19zm.71-8.47c-.14.18-.44.47-.94.47-.61 0-1.14-.49-1.21-1.14L16.98 5l1.93-.01 1.05 4.37c.1.42.01.85-.25 1.17z"
	})), 'StorefrontTwoTone');
	
	exports.default = _default;

/***/ },
/* 5795 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z"
	}), 'Straighten');
	
	exports.default = _default;

/***/ },
/* 5796 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z"
	}), 'StraightenOutlined');
	
	exports.default = _default;

/***/ },
/* 5797 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-1 10H4c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h1v3c0 .55.45 1 1 1s1-.45 1-1V8h2v3c0 .55.45 1 1 1s1-.45 1-1V8h2v3c0 .55.45 1 1 1s1-.45 1-1V8h2v3c0 .55.45 1 1 1s1-.45 1-1V8h1c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1z"
	}), 'StraightenRounded');
	
	exports.default = _default;

/***/ },
/* 5798 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 6H1v12h22V6zm-2 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z"
	}), 'StraightenSharp');
	
	exports.default = _default;

/***/ },
/* 5799 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 12h-2V8h-2v4h-2V8h-2v4H9V8H7v4H5V8H3v8h18V8h-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z"
	})), 'StraightenTwoTone');
	
	exports.default = _default;

/***/ },
/* 5800 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "6",
	  r: "5"
	}), _react.default.createElement("path", {
	  d: "M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82C12.23 9.42 11.5 7.8 11.5 6z"
	})), 'Streetview');
	
	exports.default = _default;

/***/ },
/* 5801 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "6",
	  r: "5"
	}), _react.default.createElement("path", {
	  d: "M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82C12.23 9.42 11.5 7.8 11.5 6z"
	})), 'StreetviewOutlined');
	
	exports.default = _default;

/***/ },
/* 5802 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "6",
	  r: "5"
	}), _react.default.createElement("path", {
	  d: "M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82C12.23 9.42 11.5 7.8 11.5 6z"
	})), 'StreetviewRounded');
	
	exports.default = _default;

/***/ },
/* 5803 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "6",
	  r: "5"
	}), _react.default.createElement("path", {
	  d: "M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82C12.23 9.42 11.5 7.8 11.5 6z"
	})), 'StreetviewSharp');
	
	exports.default = _default;

/***/ },
/* 5804 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z"
	}), _react.default.createElement("circle", {
	  cx: "18",
	  cy: "6",
	  r: "5"
	}), _react.default.createElement("path", {
	  d: "M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82C12.23 9.42 11.5 7.8 11.5 6z"
	})), 'StreetviewTwoTone');
	
	exports.default = _default;

/***/ },
/* 5805 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.85 7.08C6.85 4.37 9.45 3 12.24 3c1.64 0 3 .49 3.9 1.28.77.65 1.46 1.73 1.46 3.24h-3.01c0-.31-.05-.59-.15-.85-.29-.86-1.2-1.28-2.25-1.28-1.86 0-2.34 1.02-2.34 1.7 0 .48.25.88.74 1.21.38.25.77.48 1.41.7H7.39c-.21-.34-.54-.89-.54-1.92zM21 12v-2H3v2h9.62c1.15.45 1.96.75 1.96 1.97 0 1-.81 1.67-2.28 1.67-1.54 0-2.93-.54-2.93-2.51H6.4c0 .55.08 1.13.24 1.58.81 2.29 3.29 3.3 5.67 3.3 2.27 0 5.3-.89 5.3-4.05 0-.3-.01-1.16-.48-1.94H21V12z"
	}), 'StrikethroughS');
	
	exports.default = _default;

/***/ },
/* 5806 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.24 8.75c-.26-.48-.39-1.03-.39-1.67 0-.61.13-1.16.4-1.67.26-.5.63-.93 1.11-1.29.48-.35 1.05-.63 1.7-.83.66-.19 1.39-.29 2.18-.29.81 0 1.54.11 2.21.34.66.22 1.23.54 1.69.94.47.4.83.88 1.08 1.43s.38 1.15.38 1.81h-3.01c0-.31-.05-.59-.15-.85-.09-.27-.24-.49-.44-.68-.2-.19-.45-.33-.75-.44-.3-.1-.66-.16-1.06-.16-.39 0-.74.04-1.03.13s-.53.21-.72.36c-.19.16-.34.34-.44.55-.1.21-.15.43-.15.66 0 .48.25.88.74 1.21.38.25.77.48 1.41.7H7.39c-.05-.08-.11-.17-.15-.25zM21 12v-2H3v2h9.62c.18.07.4.14.55.2.37.17.66.34.87.51s.35.36.43.57c.07.2.11.43.11.69 0 .23-.05.45-.14.66-.09.2-.23.38-.42.53-.19.15-.42.26-.71.35-.29.08-.63.13-1.01.13-.43 0-.83-.04-1.18-.13s-.66-.23-.91-.42c-.25-.19-.45-.44-.59-.75s-.25-.76-.25-1.21H6.4c0 .55.08 1.13.24 1.58s.37.85.65 1.21c.28.35.6.66.98.92.37.26.78.48 1.22.65.44.17.9.3 1.38.39.48.08.96.13 1.44.13.8 0 1.53-.09 2.18-.28s1.21-.45 1.67-.79c.46-.34.82-.77 1.07-1.27s.38-1.07.38-1.71c0-.6-.1-1.14-.31-1.61-.05-.11-.11-.23-.17-.33H21V12z"
	}), 'StrikethroughSOutlined');
	
	exports.default = _default;

/***/ },
/* 5807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.59 7.52c0-.31-.05-.59-.15-.85-.09-.27-.24-.49-.44-.68-.2-.19-.45-.33-.75-.44-.3-.1-.66-.16-1.06-.16-.39 0-.74.04-1.03.13s-.53.21-.72.36c-.19.16-.34.34-.44.55-.1.21-.15.43-.15.66 0 .48.25.88.74 1.21.38.25.77.48 1.41.7H7.39c-.05-.08-.11-.17-.15-.25-.26-.48-.39-1.03-.39-1.67 0-.61.13-1.16.4-1.67.26-.5.63-.93 1.11-1.29.48-.35 1.05-.63 1.7-.83.66-.19 1.39-.29 2.18-.29.81 0 1.54.11 2.21.34.66.22 1.23.54 1.69.94.47.4.83.88 1.08 1.43s.38 1.15.38 1.81h-3.01M20 10H4c-.55 0-1 .45-1 1s.45 1 1 1h8.62c.18.07.4.14.55.2.37.17.66.34.87.51s.35.36.43.57c.07.2.11.43.11.69 0 .23-.05.45-.14.66-.09.2-.23.38-.42.53-.19.15-.42.26-.71.35-.29.08-.63.13-1.01.13-.43 0-.83-.04-1.18-.13s-.66-.23-.91-.42c-.25-.19-.45-.44-.59-.75s-.25-.76-.25-1.21H6.4c0 .55.08 1.13.24 1.58s.37.85.65 1.21c.28.35.6.66.98.92.37.26.78.48 1.22.65.44.17.9.3 1.38.39.48.08.96.13 1.44.13.8 0 1.53-.09 2.18-.28s1.21-.45 1.67-.79c.46-.34.82-.77 1.07-1.27s.38-1.07.38-1.71c0-.6-.1-1.14-.31-1.61-.05-.11-.11-.23-.17-.33H20c.55 0 1-.45 1-1V11c0-.55-.45-1-1-1z"
	}), 'StrikethroughSRounded');
	
	exports.default = _default;

/***/ },
/* 5808 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.24 8.75c-.26-.48-.39-1.03-.39-1.67 0-.61.13-1.16.4-1.67.26-.5.63-.93 1.11-1.29.48-.35 1.05-.63 1.7-.83.66-.19 1.39-.29 2.18-.29.81 0 1.54.11 2.21.34.66.22 1.23.54 1.69.94.47.4.83.88 1.08 1.43s.38 1.15.38 1.81h-3.01c0-.31-.05-.59-.15-.85-.09-.27-.24-.49-.44-.68-.2-.19-.45-.33-.75-.44-.3-.1-.66-.16-1.06-.16-.39 0-.74.04-1.03.13s-.53.21-.72.36c-.19.16-.34.34-.44.55-.1.21-.15.43-.15.66 0 .48.25.88.74 1.21.38.25.77.48 1.41.7H7.39c-.05-.08-.11-.17-.15-.25zM21 12v-2H3v2h9.62c.18.07.4.14.55.2.37.17.66.34.87.51s.35.36.43.57c.07.2.11.43.11.69 0 .23-.05.45-.14.66-.09.2-.23.38-.42.53-.19.15-.42.26-.71.35-.29.08-.63.13-1.01.13-.43 0-.83-.04-1.18-.13s-.66-.23-.91-.42c-.25-.19-.45-.44-.59-.75s-.25-.76-.25-1.21H6.4c0 .55.08 1.13.24 1.58s.37.85.65 1.21c.28.35.6.66.98.92.37.26.78.48 1.22.65.44.17.9.3 1.38.39.48.08.96.13 1.44.13.8 0 1.53-.09 2.18-.28s1.21-.45 1.67-.79c.46-.34.82-.77 1.07-1.27s.38-1.07.38-1.71c0-.6-.1-1.14-.31-1.61-.05-.11-.11-.23-.17-.33H21V12z"
	}), 'StrikethroughSSharp');
	
	exports.default = _default;

/***/ },
/* 5809 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.44 5.88c.19-.15.43-.27.72-.36.29-.09.64-.13 1.03-.13.4 0 .76.06 1.06.16.3.11.55.25.75.44s.35.41.44.68c.1.26.15.54.15.85h3.01c0-.66-.13-1.26-.38-1.81s-.61-1.03-1.08-1.43c-.46-.4-1.03-.72-1.69-.94-.67-.23-1.4-.34-2.21-.34-.79 0-1.52.1-2.18.29-.65.2-1.22.48-1.7.83-.48.36-.85.79-1.11 1.29-.27.51-.4 1.06-.4 1.67 0 .64.13 1.19.39 1.67.04.08.1.17.15.25H12c-.64-.22-1.03-.45-1.41-.7-.49-.33-.74-.73-.74-1.21 0-.23.05-.45.15-.66s.25-.39.44-.55zM3 12h9.62c.18.07.4.14.55.2.37.17.66.34.87.51.21.17.35.36.43.57.07.2.11.43.11.69 0 .23-.05.45-.14.66-.09.2-.23.38-.42.53-.19.15-.42.26-.71.35-.29.08-.63.13-1.01.13-.43 0-.83-.04-1.18-.13s-.66-.23-.91-.42-.45-.44-.59-.75-.25-.76-.25-1.21H6.4c0 .55.08 1.13.24 1.58.16.45.37.85.65 1.21.28.35.6.66.98.92.37.26.78.48 1.22.65s.9.3 1.38.39c.48.08.96.13 1.44.13.8 0 1.53-.09 2.18-.28.65-.19 1.21-.45 1.67-.79.46-.34.82-.77 1.07-1.27s.38-1.07.38-1.71c0-.6-.1-1.14-.31-1.61-.05-.11-.11-.23-.17-.33H21V10H3v2z"
	}), 'StrikethroughSTwoTone');
	
	exports.default = _default;

/***/ },
/* 5810 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98c-.31-.75-1.04-1.21-1.81-1.23-.26 0-.53.04-.79.15L7.1 5.95c-.75.31-1.21 1.03-1.23 1.8-.01.27.04.54.15.8l4.96 11.97c.31.76 1.05 1.22 1.83 1.23.26 0 .52-.05.77-.15l7.36-3.05c1.02-.42 1.51-1.59 1.09-2.6zM7.88 8.75c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2 11c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z"
	}), 'Style');
	
	exports.default = _default;

/***/ },
/* 5811 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98c-.31-.75-1.04-1.21-1.81-1.23-.26 0-.53.04-.79.15L7.1 5.95c-.75.31-1.21 1.03-1.23 1.8-.01.27.04.54.15.8l4.96 11.97c.31.76 1.05 1.22 1.83 1.23.26 0 .52-.05.77-.15l7.36-3.05c1.02-.42 1.51-1.59 1.09-2.6zm-9.2 3.8L7.87 7.79l7.35-3.04h.01l4.95 11.95-7.35 3.05z"
	}), _react.default.createElement("circle", {
	  cx: "11",
	  cy: "9",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M5.88 19.75c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z"
	})), 'StyleOutlined');
	
	exports.default = _default;

/***/ },
/* 5812 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98c-.31-.75-1.04-1.21-1.81-1.23-.26 0-.53.04-.79.15L7.1 5.95c-.75.31-1.21 1.03-1.23 1.8-.01.27.04.54.15.8l4.96 11.97c.31.76 1.05 1.22 1.83 1.23.26 0 .52-.05.77-.15l7.36-3.05c1.02-.42 1.51-1.59 1.09-2.6zM7.88 8.75c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2 11c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z"
	}), 'StyleRounded');
	
	exports.default = _default;

/***/ },
/* 5813 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.87 20.21v-9.03l-3.19 7.7 3.19 1.33zm18.92-2.43L16.31 2.14 5.26 6.71l6.48 15.64 11.05-4.57zM7.88 8.75c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2 13h3.45l-3.45-8.34v8.34z"
	}), 'StyleSharp');
	
	exports.default = _default;

/***/ },
/* 5814 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.22 4.75L7.87 7.79l4.96 11.96 7.35-3.05-4.96-11.95zM11 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3.87 11.18l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61l1.34.56v-9.03zm18.16 4.77L17.07 3.98c-.31-.75-1.04-1.21-1.81-1.23-.26 0-.53.04-.79.15L7.1 5.95c-.75.31-1.21 1.03-1.23 1.8-.01.27.04.54.15.8l4.96 11.97c.31.76 1.05 1.22 1.83 1.23.26 0 .52-.05.77-.15l7.36-3.05c1.02-.42 1.51-1.59 1.09-2.6zm-9.2 3.8L7.87 7.79l7.35-3.04h.01l4.95 11.95-7.35 3.05z"
	}), _react.default.createElement("circle", {
	  cx: "11",
	  cy: "9",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M9.33 21.75l-3.45-8.34v6.34c0 1.1.9 2 2 2h1.45z"
	})), 'StyleTwoTone');
	
	exports.default = _default;

/***/ },
/* 5815 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z"
	}), 'SubdirectoryArrowLeft');
	
	exports.default = _default;

/***/ },
/* 5816 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z"
	}), 'SubdirectoryArrowLeftOutlined');
	
	exports.default = _default;

/***/ },
/* 5817 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.71 15.71l4.58 4.58c.39.39 1.03.39 1.42 0 .39-.39.39-1.03 0-1.42L8.83 16H19c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1s-1 .45-1 1v9H8.83l2.88-2.87c.39-.39.39-1.03 0-1.42-.39-.39-1.03-.39-1.42 0l-4.58 4.58c-.39.39-.39 1.03 0 1.42z"
	}), 'SubdirectoryArrowLeftRounded');
	
	exports.default = _default;

/***/ },
/* 5818 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z"
	}), 'SubdirectoryArrowLeftSharp');
	
	exports.default = _default;

/***/ },
/* 5819 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z"
	}), 'SubdirectoryArrowLeftTwoTone');
	
	exports.default = _default;

/***/ },
/* 5820 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z"
	}), 'SubdirectoryArrowRight');
	
	exports.default = _default;

/***/ },
/* 5821 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z"
	}), 'SubdirectoryArrowRightOutlined');
	
	exports.default = _default;

/***/ },
/* 5822 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.29 15.71l-4.58 4.58c-.39.39-1.03.39-1.42 0-.39-.39-.39-1.03 0-1.42L15.17 16H5c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v9h9.17l-2.88-2.87c-.39-.39-.39-1.03 0-1.42.39-.39 1.03-.39 1.42 0l4.58 4.58c.39.39.39 1.03 0 1.42z"
	}), 'SubdirectoryArrowRightRounded');
	
	exports.default = _default;

/***/ },
/* 5823 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z"
	}), 'SubdirectoryArrowRightSharp');
	
	exports.default = _default;

/***/ },
/* 5824 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z"
	}), 'SubdirectoryArrowRightTwoTone');
	
	exports.default = _default;

/***/ },
/* 5825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z"
	}), 'Subject');
	
	exports.default = _default;

/***/ },
/* 5826 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z"
	}), 'SubjectOutlined');
	
	exports.default = _default;

/***/ },
/* 5827 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 17H5c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1zm6-8H5c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1zM5 15h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1zM4 6c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1z"
	}), 'SubjectRounded');
	
	exports.default = _default;

/***/ },
/* 5828 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z"
	}), 'SubjectSharp');
	
	exports.default = _default;

/***/ },
/* 5829 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z"
	}), 'SubjectTwoTone');
	
	exports.default = _default;

/***/ },
/* 5830 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8H4V6h16v2zm-2-6H6v2h12V2zm4 10v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-6 4l-6-3.27v6.53L16 16z"
	}), 'Subscriptions');
	
	exports.default = _default;

/***/ },
/* 5831 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6h16v2H4zm2-4h12v2H6zm14 8H4c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2zm0 10H4v-8h16v8zm-10-7.27v6.53L16 16z"
	}), 'SubscriptionsOutlined');
	
	exports.default = _default;

/***/ },
/* 5832 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 8H5c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1zm-2-6H7c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1zm5 10v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-6.81 3.56L10 12.73v6.53l5.19-2.82c.35-.19.35-.69 0-.88z"
	}), 'SubscriptionsRounded');
	
	exports.default = _default;

/***/ },
/* 5833 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 8H4V6h16v2zm-2-6H6v2h12V2zm4 8v12H2V10h20zm-6 6l-6-3.27v6.53L16 16z"
	}), 'SubscriptionsSharp');
	
	exports.default = _default;

/***/ },
/* 5834 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 20h16v-8H4v8zm6-7.27L16 16l-6 3.26v-6.53z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 6h16v2H4zm2-4h12v2H6zm14 8H4c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2zm0 10H4v-8h16v8zm-10-7.27v6.53L16 16z"
	})), 'SubscriptionsTwoTone');
	
	exports.default = _default;

/***/ },
/* 5835 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 12h4v2H4v-2zm10 6H4v-2h10v2zm6 0h-4v-2h4v2zm0-4H10v-2h10v2z"
	}), 'Subtitles');
	
	exports.default = _default;

/***/ },
/* 5836 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12zM6 10h2v2H6zm0 4h8v2H6zm10 0h2v2h-2zm-6-4h8v2h-8z"
	}), 'SubtitlesOutlined');
	
	exports.default = _default;

/***/ },
/* 5837 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM5 12h2c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1zm8 6H5c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1zm6 0h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1zm0-4h-8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'SubtitlesRounded');
	
	exports.default = _default;

/***/ },
/* 5838 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 4H2v16h20V4zM4 12h4v2H4v-2zm10 6H4v-2h10v2zm6 0h-4v-2h4v2zm0-4H10v-2h10v2z"
	}), 'SubtitlesSharp');
	
	exports.default = _default;

/***/ },
/* 5839 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 18h16V6H4v12zm14-2h-2v-2h2v2zm-8-6h8v2h-8v-2zm-4 0h2v2H6v-2zm0 4h8v2H6v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12zM6 10h2v2H6zm0 4h8v2H6zm10 0h2v2h-2zm-6-4h8v2h-8z"
	})), 'SubtitlesTwoTone');
	
	exports.default = _default;

/***/ },
/* 5840 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "16",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "16",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M7.01 9h10v5h-10zM17.8 2.8C16 2.09 13.86 2 12 2c-1.86 0-4 .09-5.8.8C3.53 3.84 2 6.05 2 8.86V22h20V8.86c0-2.81-1.53-5.02-4.2-6.06zm.2 13.08c0 1.45-1.18 2.62-2.63 2.62l1.13 1.12V20H15l-1.5-1.5h-2.83L9.17 20H7.5v-.38l1.12-1.12C7.18 18.5 6 17.32 6 15.88V9c0-2.63 3-3 6-3 3.32 0 6 .38 6 3v6.88z"
	})), 'Subway');
	
	exports.default = _default;

/***/ },
/* 5841 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.8 2.8C16 2.09 13.86 2 12 2s-4 .09-5.8.8C3.53 3.84 2 6.05 2 8.86V22h20V8.86c0-2.81-1.53-5.02-4.2-6.06zM9.17 20l1.5-1.5h2.66l1.5 1.5H9.17zm-2.16-6V9h10v5h-10zm9.49 2c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm-8-1c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM20 20h-3.5v-.38l-1.15-1.16c1.49-.17 2.65-1.42 2.65-2.96V9c0-2.63-3-3-6-3s-6 .37-6 3v6.5c0 1.54 1.16 2.79 2.65 2.96L7.5 19.62V20H4V8.86c0-2 1.01-3.45 2.93-4.2C8.41 4.08 10.32 4 12 4s3.59.08 5.07.66c1.92.75 2.93 2.2 2.93 4.2V20z"
	}), 'SubwayOutlined');
	
	exports.default = _default;

/***/ },
/* 5842 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "16",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "16",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M7.01 9h10v5h-10zM17.8 2.8C16 2.09 13.86 2 12 2s-4 .09-5.8.8C3.53 3.84 2 6.05 2 8.86V22h20V8.86c0-2.81-1.53-5.02-4.2-6.06zm.2 12.7c0 1.54-1.16 2.79-2.65 2.96l1.15 1.16V20h-1.67l-1.5-1.5h-2.66L9.17 20H7.5v-.38l1.15-1.16C7.16 18.29 6 17.04 6 15.5V9c0-2.63 3-3 6-3s6 .37 6 3v6.5z"
	})), 'SubwayRounded');
	
	exports.default = _default;

/***/ },
/* 5843 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "16",
	  r: "1"
	}), _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "16",
	  r: "1"
	}), _react.default.createElement("path", {
	  d: "M7.01 9h10v5h-10zM17.8 2.8C16 2.09 13.86 2 12 2s-4 .09-5.8.8C3.53 3.84 2 6.05 2 8.86V22h20V8.86c0-2.81-1.53-5.02-4.2-6.06zm.2 12.7c0 1.54-1.16 2.79-2.65 2.96l1.15 1.16V20h-1.67l-1.5-1.5h-2.66L9.17 20H7.5v-.38l1.15-1.16C7.16 18.29 6 17.04 6 15.5V9c0-2.63 3-3 6-3s6 .37 6 3v6.5z"
	})), 'SubwaySharp');
	
	exports.default = _default;

/***/ },
/* 5844 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M10.67 18.5L9.17 20h5.66l-1.5-1.5zm6.4-13.84C15.59 4.08 13.68 4 12 4s-3.59.08-5.07.66C5.01 5.41 4 6.86 4 8.86V20h3.5v-.38l1.15-1.16C7.16 18.29 6 17.04 6 15.5V9c0-2.63 3-3 6-3s6 .37 6 3v6.5c0 1.54-1.16 2.79-2.65 2.96l1.15 1.16V20H20V8.86c0-2-1.01-3.45-2.93-4.2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17.8 2.8C16 2.09 13.86 2 12 2s-4 .09-5.8.8C3.53 3.84 2 6.05 2 8.86V22h20V8.86c0-2.81-1.53-5.02-4.2-6.06zM9.17 20l1.5-1.5h2.66l1.5 1.5H9.17zm-2.16-6V9h10v5h-10zm9.49 2c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm-8-1c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM20 20h-3.5v-.38l-1.15-1.16c1.49-.17 2.65-1.42 2.65-2.96V9c0-2.63-3-3-6-3s-6 .37-6 3v6.5c0 1.54 1.16 2.79 2.65 2.96L7.5 19.62V20H4V8.86c0-2 1.01-3.45 2.93-4.2C8.41 4.08 10.32 4 12 4s3.59.08 5.07.66c1.92.75 2.93 2.2 2.93 4.2V20z"
	})), 'SubwayTwoTone');
	
	exports.default = _default;

/***/ },
/* 5845 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm3.61 6.34c1.07 0 1.93.86 1.93 1.93 0 1.07-.86 1.93-1.93 1.93-1.07 0-1.93-.86-1.93-1.93-.01-1.07.86-1.93 1.93-1.93zm-6-1.58c1.3 0 2.36 1.06 2.36 2.36 0 1.3-1.06 2.36-2.36 2.36s-2.36-1.06-2.36-2.36c0-1.31 1.05-2.36 2.36-2.36zm0 9.13v3.75c-2.4-.75-4.3-2.6-5.14-4.96 1.05-1.12 3.67-1.69 5.14-1.69.53 0 1.2.08 1.9.22-1.64.87-1.9 2.02-1.9 2.68zM11.99 20c-.27 0-.53-.01-.79-.04v-4.07c0-1.42 2.94-2.13 4.4-2.13 1.07 0 2.92.39 3.84 1.15-1.17 2.97-4.06 5.09-7.45 5.09z"
	}), 'SupervisedUserCircle');
	
	exports.default = _default;

/***/ },
/* 5846 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.5 10c0-1.65-1.35-3-3-3s-3 1.35-3 3 1.35 3 3 3 3-1.35 3-3zm-3 1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6.5 2c1.11 0 2-.89 2-2 0-1.11-.89-2-2-2-1.11 0-2.01.89-2 2 0 1.11.89 2 2 2zM11.99 2.01c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zM5.84 17.12c.68-.54 2.27-1.11 3.66-1.11.07 0 .15.01.23.01.24-.64.67-1.29 1.3-1.86-.56-.1-1.09-.16-1.53-.16-1.3 0-3.39.45-4.73 1.43-.5-1.04-.78-2.2-.78-3.43 0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.2-.27 2.34-.75 3.37-1-.59-2.36-.87-3.24-.87-1.52 0-4.5.81-4.5 2.7v2.78c-2.27-.13-4.29-1.21-5.66-2.86z"
	}), 'SupervisedUserCircleOutlined');
	
	exports.default = _default;

/***/ },
/* 5847 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.61 6.34c1.07 0 1.93.86 1.93 1.93s-.86 1.93-1.93 1.93-1.93-.86-1.93-1.93c-.01-1.07.86-1.93 1.93-1.93zm-6-1.58c1.3 0 2.36 1.06 2.36 2.36s-1.06 2.36-2.36 2.36-2.36-1.06-2.36-2.36c0-1.31 1.05-2.36 2.36-2.36zm0 9.13v3.75c-2.4-.75-4.3-2.6-5.14-4.96 1.05-1.12 3.67-1.69 5.14-1.69.53 0 1.2.08 1.9.22-1.64.87-1.9 2.02-1.9 2.68zM12 20c-.27 0-.53-.01-.79-.04v-4.07c0-1.42 2.94-2.13 4.4-2.13 1.07 0 2.92.39 3.84 1.15C18.28 17.88 15.39 20 12 20z"
	}), 'SupervisedUserCircleRounded');
	
	exports.default = _default;

/***/ },
/* 5848 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.61 6.34c1.07 0 1.93.86 1.93 1.93s-.86 1.93-1.93 1.93-1.93-.86-1.93-1.93c-.01-1.07.86-1.93 1.93-1.93zm-6-1.58c1.3 0 2.36 1.06 2.36 2.36s-1.06 2.36-2.36 2.36-2.36-1.06-2.36-2.36c0-1.31 1.05-2.36 2.36-2.36zm0 9.13v3.75c-2.4-.75-4.3-2.6-5.14-4.96 1.05-1.12 3.67-1.69 5.14-1.69.53 0 1.2.08 1.9.22-1.64.87-1.9 2.02-1.9 2.68zM12 20c-.27 0-.53-.01-.79-.04v-4.07c0-1.42 2.94-2.13 4.4-2.13 1.07 0 2.92.39 3.84 1.15C18.28 17.88 15.39 20 12 20z"
	}), 'SupervisedUserCircleSharp');
	
	exports.default = _default;

/***/ },
/* 5849 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "9.5",
	  cy: "10",
	  r: "1",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11.5 17.21c0-1.88 2.98-2.7 4.5-2.7.88 0 2.24.27 3.24.87.48-1.02.75-2.16.75-3.37 0-4.41-3.59-8-8-8s-8 3.59-8 8c0 1.23.29 2.39.78 3.43 1.34-.98 3.43-1.43 4.73-1.43.44 0 .97.05 1.53.16-.63.57-1.06 1.22-1.3 1.86-.08 0-.15-.01-.23-.01-1.38 0-2.98.57-3.66 1.11 1.37 1.65 3.39 2.73 5.66 2.86v-2.78zM16 9c1.11 0 2 .89 2 2 0 1.11-.89 2-2 2-1.11 0-2-.89-2-2-.01-1.11.89-2 2-2zm-6.5 4c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12.5 10c0-1.65-1.35-3-3-3s-3 1.35-3 3 1.35 3 3 3 3-1.35 3-3zm-3 1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6.5 2c1.11 0 2-.89 2-2 0-1.11-.89-2-2-2-1.11 0-2.01.89-2 2 0 1.11.89 2 2 2zM11.99 2.01c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zM5.84 17.12c.68-.54 2.27-1.11 3.66-1.11.07 0 .15.01.23.01.24-.64.67-1.29 1.3-1.86-.56-.1-1.09-.16-1.53-.16-1.3 0-3.39.45-4.73 1.43-.5-1.04-.78-2.2-.78-3.43 0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.2-.27 2.34-.75 3.37-1-.59-2.36-.87-3.24-.87-1.52 0-4.5.81-4.5 2.7v2.78c-2.27-.13-4.29-1.21-5.66-2.86z"
	})), 'SupervisedUserCircleTwoTone');
	
	exports.default = _default;

/***/ },
/* 5850 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z"
	}), 'SupervisorAccount');
	
	exports.default = _default;

/***/ },
/* 5851 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm.05 10H4.77c.99-.5 2.7-1 4.23-1 .11 0 .23.01.34.01.34-.73.93-1.33 1.64-1.81-.73-.13-1.42-.2-1.98-.2-2.34 0-7 1.17-7 3.5V19h7v-1.5c0-.17.02-.34.05-.5zm7.45-2.5c-1.84 0-5.5 1.01-5.5 3V19h11v-1.5c0-1.99-3.66-3-5.5-3zm1.21-1.82c.76-.43 1.29-1.24 1.29-2.18C19 9.12 17.88 8 16.5 8S14 9.12 14 10.5c0 .94.53 1.75 1.29 2.18.36.2.77.32 1.21.32s.85-.12 1.21-.32z"
	}), 'SupervisorAccountOutlined');
	
	exports.default = _default;

/***/ },
/* 5852 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V18c0 .55.45 1 1 1h9c.55 0 1-.45 1-1v-1.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V18c0 .55.45 1 1 1h6v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z"
	}), 'SupervisorAccountRounded');
	
	exports.default = _default;

/***/ },
/* 5853 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z"
	}), 'SupervisorAccountSharp');
	
	exports.default = _default;

/***/ },
/* 5854 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "9",
	  cy: "8.5",
	  r: "1.5",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4.77 17h4.28c.01-.06.12-.58.29-.99-.11 0-.23-.01-.34-.01-1.53 0-3.25.5-4.23 1z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm.05 10H4.77c.99-.5 2.7-1 4.23-1 .11 0 .23.01.34.01.34-.73.93-1.33 1.64-1.81-.73-.13-1.42-.2-1.98-.2-2.34 0-7 1.17-7 3.5V19h7v-1.5c0-.17.02-.34.05-.5zm7.45-2.5c-1.84 0-5.5 1.01-5.5 3V19h11v-1.5c0-1.99-3.66-3-5.5-3zm1.21-1.82c.76-.43 1.29-1.24 1.29-2.18C19 9.12 17.88 8 16.5 8S14 9.12 14 10.5c0 .94.53 1.75 1.29 2.18.36.2.77.32 1.21.32s.85-.12 1.21-.32z"
	})), 'SupervisorAccountTwoTone');
	
	exports.default = _default;

/***/ },
/* 5855 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.76 16.24l-1.41 1.41C4.78 16.1 4 14.05 4 12c0-2.05.78-4.1 2.34-5.66l1.41 1.41C6.59 8.93 6 10.46 6 12s.59 3.07 1.76 4.24zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm5.66 1.66l-1.41-1.41C17.41 15.07 18 13.54 18 12s-.59-3.07-1.76-4.24l1.41-1.41C19.22 7.9 20 9.95 20 12c0 2.05-.78 4.1-2.34 5.66zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'SurroundSound');
	
	exports.default = _default;

/***/ },
/* 5856 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
	}), _react.default.createElement("path", {
	  d: "M8.29 15.71C7.27 14.69 6.75 13.35 6.75 12s.52-2.69 1.53-3.72L7.05 7.05C5.68 8.41 5 10.21 5 12s.68 3.59 2.06 4.94l1.23-1.23zM12 15.5c1.93 0 3.5-1.57 3.5-3.5S13.93 8.5 12 8.5 8.5 10.07 8.5 12s1.57 3.5 3.5 3.5zm0-5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zM15.72 15.72l1.23 1.23C18.32 15.59 19 13.79 19 12s-.68-3.59-2.06-4.94l-1.23 1.23c1.02 1.02 1.54 2.36 1.54 3.71s-.52 2.69-1.53 3.72z"
	})), 'SurroundSoundOutlined');
	
	exports.default = _default;

/***/ },
/* 5857 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.11 16.89c-.43.43-1.14.39-1.51-.09C4.53 15.39 4 13.69 4 12s.53-3.38 1.59-4.8c.37-.48 1.08-.53 1.51-.1.35.35.39.9.1 1.29C6.4 9.46 6 10.73 6 12s.4 2.53 1.2 3.6c.3.39.26.94-.09 1.29zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm4.9.9c-.35-.35-.39-.9-.09-1.29C17.6 14.54 18 13.27 18 12s-.4-2.53-1.2-3.6c-.3-.39-.26-.95.09-1.3.43-.43 1.14-.39 1.51.09 1.07 1.41 1.6 3.1 1.6 4.8 0 1.69-.53 3.38-1.59 4.8-.37.49-1.08.54-1.51.11zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'SurroundSoundRounded');
	
	exports.default = _default;

/***/ },
/* 5858 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 4H2v16h20V4zM7.76 16.24l-1.41 1.41C4.78 16.1 4 14.05 4 12s.78-4.1 2.34-5.66l1.41 1.41C6.59 8.93 6 10.46 6 12s.59 3.07 1.76 4.24zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm5.66 1.66l-1.41-1.41C17.41 15.07 18 13.54 18 12s-.59-3.07-1.76-4.24l1.41-1.41C19.22 7.9 20 9.95 20 12s-.78 4.1-2.34 5.66zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'SurroundSoundSharp');
	
	exports.default = _default;

/***/ },
/* 5859 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 18h16V6H4v12zM16.94 7.06C18.32 8.41 19 10.21 19 12s-.68 3.59-2.05 4.95l-1.23-1.23c1.02-1.03 1.53-2.37 1.53-3.72s-.52-2.69-1.54-3.71l1.23-1.23zM12 8.5c1.93 0 3.5 1.57 3.5 3.5s-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5 1.57-3.5 3.5-3.5zM7.05 7.05l1.23 1.23C7.27 9.31 6.75 10.65 6.75 12s.52 2.69 1.54 3.71l-1.23 1.23C5.68 15.59 5 13.79 5 12s.68-3.59 2.05-4.95z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
	}), _react.default.createElement("path", {
	  d: "M8.29 15.71C7.27 14.69 6.75 13.35 6.75 12s.52-2.69 1.53-3.72L7.05 7.05C5.68 8.41 5 10.21 5 12s.68 3.59 2.06 4.94l1.23-1.23zM12 15.5c1.93 0 3.5-1.57 3.5-3.5S13.93 8.5 12 8.5 8.5 10.07 8.5 12s1.57 3.5 3.5 3.5zm0-5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zM15.72 15.72l1.23 1.23C18.32 15.59 19 13.79 19 12s-.68-3.59-2.06-4.94l-1.23 1.23c1.02 1.02 1.54 2.36 1.54 3.71s-.52 2.69-1.53 3.72z"
	})), 'SurroundSoundTwoTone');
	
	exports.default = _default;

/***/ },
/* 5860 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z"
	}), 'SwapCalls');
	
	exports.default = _default;

/***/ },
/* 5861 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z"
	}), 'SwapCallsOutlined');
	
	exports.default = _default;

/***/ },
/* 5862 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.65 4.35l-2.79 2.79c-.32.32-.1.86.35.86H17v6.88c0 1-.67 1.93-1.66 2.09-1.25.21-2.34-.76-2.34-1.97V8.17c0-2.09-1.53-3.95-3.61-4.15C7.01 3.79 5 5.66 5 8v7H3.21c-.45 0-.67.54-.35.85l2.79 2.79c.2.2.51.2.71 0l2.79-2.79c.31-.31.09-.85-.36-.85H7V8.12c0-1 .67-1.93 1.66-2.09C9.91 5.82 11 6.79 11 8v6.83c0 2.09 1.53 3.95 3.61 4.15C16.99 19.21 19 17.34 19 15V8h1.79c.45 0 .67-.54.35-.85l-2.79-2.79c-.19-.2-.51-.2-.7-.01z"
	}), 'SwapCallsRounded');
	
	exports.default = _default;

/***/ },
/* 5863 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z"
	}), 'SwapCallsSharp');
	
	exports.default = _default;

/***/ },
/* 5864 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 8h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4-4 4z"
	}), 'SwapCallsTwoTone');
	
	exports.default = _default;

/***/ },
/* 5865 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"
	}), 'SwapHoriz');
	
	exports.default = _default;

/***/ },
/* 5866 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"
	}), 'SwapHorizOutlined');
	
	exports.default = _default;

/***/ },
/* 5867 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.14 11.86l-2.78 2.79c-.19.2-.19.51 0 .71l2.78 2.79c.31.32.85.09.85-.35V16H13c.55 0 1-.45 1-1s-.45-1-1-1H6.99v-1.79c0-.45-.54-.67-.85-.35zm14.51-3.21l-2.78-2.79c-.31-.32-.85-.09-.85.35V8H11c-.55 0-1 .45-1 1s.45 1 1 1h6.01v1.79c0 .45.54.67.85.35l2.78-2.79c.2-.19.2-.51.01-.7z"
	}), 'SwapHorizRounded');
	
	exports.default = _default;

/***/ },
/* 5868 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"
	}), 'SwapHorizSharp');
	
	exports.default = _default;

/***/ },
/* 5869 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"
	}), 'SwapHorizTwoTone');
	
	exports.default = _default;

/***/ },
/* 5870 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10zm-7-5.5l3.5 3.5-3.5 3.5V11h-4V9h4V6.5zm-6 11L5.5 14 9 10.5V13h4v2H9v2.5z"
	}), 'SwapHorizontalCircle');
	
	exports.default = _default;

/***/ },
/* 5871 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-13.5V9h-4v2h4v2.5l3.5-3.5zm-6 4L5.5 14 9 17.5V15h4v-2H9z"
	}), 'SwapHorizontalCircleOutlined');
	
	exports.default = _default;

/***/ },
/* 5872 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10zm-7-5.5l3.15 3.15c.2.2.2.51 0 .71L15 13.5V11h-4V9h4V6.5zm-6 11l-3.15-3.15c-.2-.2-.2-.51 0-.71L9 10.5V13h4v2H9v2.5z"
	}), 'SwapHorizontalCircleRounded');
	
	exports.default = _default;

/***/ },
/* 5873 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10zm-7-5.5l3.5 3.5-3.5 3.5V11h-4V9h4V6.5zm-6 11L5.5 14 9 10.5V13h4v2H9v2.5z"
	}), 'SwapHorizontalCircleSharp');
	
	exports.default = _default;

/***/ },
/* 5874 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm1 11H9v2.5L5.5 14 9 10.5V13h4v2zm2-1.5V11h-4V9h4V6.5l3.5 3.5-3.5 3.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-13.5V9h-4v2h4v2.5l3.5-3.5zm-6 4L5.5 14 9 17.5V15h4v-2H9z"
	})), 'SwapHorizontalCircleTwoTone');
	
	exports.default = _default;

/***/ },
/* 5875 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
	}), 'SwapVert');
	
	exports.default = _default;

/***/ },
/* 5876 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
	}), 'SwapVertOutlined');
	
	exports.default = _default;

/***/ },
/* 5877 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 17.01V11c0-.55-.45-1-1-1s-1 .45-1 1v6.01h-1.79c-.45 0-.67.54-.35.85l2.79 2.78c.2.19.51.19.71 0l2.79-2.78c.32-.31.09-.85-.35-.85H16zM8.65 3.35L5.86 6.14c-.32.31-.1.85.35.85H8V13c0 .55.45 1 1 1s1-.45 1-1V6.99h1.79c.45 0 .67-.54.35-.85L9.35 3.35c-.19-.19-.51-.19-.7 0z"
	}), 'SwapVertRounded');
	
	exports.default = _default;

/***/ },
/* 5878 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
	}), 'SwapVertSharp');
	
	exports.default = _default;

/***/ },
/* 5879 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
	}), 'SwapVertTwoTone');
	
	exports.default = _default;

/***/ },
/* 5880 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.5 9L10 5.5 13.5 9H11v4H9V9H6.5zm11 6L14 18.5 10.5 15H13v-4h2v4h2.5z"
	}), 'SwapVerticalCircle');
	
	exports.default = _default;

/***/ },
/* 5881 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM6.5 9L10 5.5 13.5 9H11v4H9V9zm11 6L14 18.5 10.5 15H13v-4h2v4z"
	}), 'SwapVerticalCircleOutlined');
	
	exports.default = _default;

/***/ },
/* 5882 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.5 9l3.15-3.15c.2-.2.51-.2.71 0L13.5 9H11v4H9V9H6.5zm7.85 9.15c-.2.2-.51.2-.71 0L10.5 15H13v-4h2v4h2.5l-3.15 3.15z"
	}), 'SwapVerticalCircleRounded');
	
	exports.default = _default;

/***/ },
/* 5883 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.5 9L10 5.5 13.5 9H11v4H9V9H6.5zm7.5 9.5L10.5 15H13v-4h2v4h2.5L14 18.5z"
	}), 'SwapVerticalCircleSharp');
	
	exports.default = _default;

/***/ },
/* 5884 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zM6.5 9L10 5.5 13.5 9H11v4H9V9H6.5zm7.5 9.5L10.5 15H13v-4h2v4h2.5L14 18.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-7V9h2.5L10 5.5 6.5 9H9v4zm4-2h-2v4h-2.5l3.5 3.5 3.5-3.5H15z"
	})), 'SwapVerticalCircleTwoTone');
	
	exports.default = _default;

/***/ },
/* 5885 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"
	}), 'SwitchCamera');
	
	exports.default = _default;

/***/ },
/* 5886 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM9.88 4h4.24l1.83 2H20v12H4V6h4.05"
	}), _react.default.createElement("path", {
	  d: "M15 11H9V8.5L5.5 12 9 15.5V13h6v2.5l3.5-3.5L15 8.5z"
	})), 'SwitchCameraOutlined');
	
	exports.default = _default;

/***/ },
/* 5887 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4h-3.17l-1.24-1.35c-.37-.41-.91-.65-1.47-.65H9.88c-.56 0-1.1.24-1.48.65L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5l-3.15-3.15c-.2-.2-.2-.51 0-.71L9 8.5V11h6V8.5l3.15 3.15c.2.2.2.51 0 .71L15 15.5z"
	}), 'SwitchCameraRounded');
	
	exports.default = _default;

/***/ },
/* 5888 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 4h-5.17L15 2H9L7.17 4H2v16h20V4zm-7 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"
	}), 'SwitchCameraSharp');
	
	exports.default = _default;

/***/ },
/* 5889 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14.12 4H9.88L8.05 6H4v12h16V6h-4.05l-1.83-2zM15 15.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h4.05l1.83-2h4.24l1.83 2H20v12zm-5-7H9V8.5L5.5 12 9 15.5V13h6v2.5l3.5-3.5L15 8.5z"
	})), 'SwitchCameraTwoTone');
	
	exports.default = _default;

/***/ },
/* 5890 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 9.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l4 4v-13l-4 4zm-5 6V13H7v2.5L3.5 12 7 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"
	}), 'SwitchVideo');
	
	exports.default = _default;

/***/ },
/* 5891 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 13h4v2l3-3-3-3v2H8V9l-3 3 3 3zm10-3.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l4 4v-13l-4 4zM16 17H4V7h12v10z"
	}), 'SwitchVideoOutlined');
	
	exports.default = _default;

/***/ },
/* 5892 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 9.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l2.29 2.29c.63.63 1.71.18 1.71-.71V7.91c0-.89-1.08-1.34-1.71-.71L18 9.5zm-5 6V13H7v2.5l-3.15-3.15c-.2-.2-.2-.51 0-.71L7 8.5V11h6V8.5l3.15 3.15c.2.2.2.51 0 .71L13 15.5z"
	}), 'SwitchVideoRounded');
	
	exports.default = _default;

/***/ },
/* 5893 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 9.5V5H2v14h16v-4.5l4 4v-13l-4 4zm-5 6V13H7v2.5L3.5 12 7 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"
	}), 'SwitchVideoSharp');
	
	exports.default = _default;

/***/ },
/* 5894 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 17h12V7H4v10zm4-8v2h4V9l3 3-3 3v-2H8v2l-3-3 3-3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M8 13h4v2l3-3-3-3v2H8V9l-3 3 3 3zm10-3.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l4 4v-13l-4 4zM16 17H4V7h12v10z"
	})), 'SwitchVideoTwoTone');
	
	exports.default = _default;

/***/ },
/* 5895 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
	}), 'Sync');
	
	exports.default = _default;

/***/ },
/* 5896 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 8l-4-4v3H3v2h15v3l4-4zM2 16l4 4v-3h15v-2H6v-3l-4 4z"
	}), 'SyncAlt');
	
	exports.default = _default;

/***/ },
/* 5897 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 8l-4-4v3H3v2h15v3l4-4zM2 16l4 4v-3h15v-2H6v-3l-4 4z"
	}), 'SyncAltOutlined');
	
	exports.default = _default;

/***/ },
/* 5898 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.65 7.65l-2.79-2.79c-.32-.32-.86-.1-.86.35V7H4c-.55 0-1 .45-1 1s.45 1 1 1h14v1.79c0 .45.54.67.85.35l2.79-2.79c.2-.19.2-.51.01-.7zM2.35 16.35l2.79 2.79c.32.32.86.1.86-.35V17h14c.55 0 1-.45 1-1s-.45-1-1-1H6v-1.79c0-.45-.54-.67-.85-.35l-2.79 2.79c-.2.19-.2.51-.01.7z"
	}), 'SyncAltRounded');
	
	exports.default = _default;

/***/ },
/* 5899 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 8l-4-4v3H3v2h15v3l4-4zM2 16l4 4v-3h15v-2H6v-3l-4 4z"
	}), 'SyncAltSharp');
	
	exports.default = _default;

/***/ },
/* 5900 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 8l-4-4v3H3v2h15v3l4-4zM2 16l4 4v-3h15v-2H6v-3l-4 4z"
	}), 'SyncAltTwoTone');
	
	exports.default = _default;

/***/ },
/* 5901 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 6.35V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.25-.12.5-.24.77-.33zm-7.14-.94l2.36 2.36C4.45 8.99 4 10.44 4 12c0 2.21.91 4.2 2.36 5.64L4 20h6v-6l-2.24 2.24C6.68 15.15 6 13.66 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.25-.77.34v2.09c.8-.21 1.55-.54 2.23-.96l2.36 2.36 1.27-1.27L4.14 4.14 2.86 5.41zM20 4h-6v6l2.24-2.24C17.32 8.85 18 10.34 18 12c0 1-.25 1.94-.68 2.77l1.46 1.46C19.55 15.01 20 13.56 20 12c0-2.21-.91-4.2-2.36-5.64L20 4z"
	}), 'SyncDisabled');
	
	exports.default = _default;

/***/ },
/* 5902 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 6.35V4.26c-.66.17-1.29.43-1.88.75l1.5 1.5c.13-.05.25-.11.38-.16zM20 12c0-2.21-.91-4.2-2.36-5.64L20 4h-6v6l2.24-2.24C17.32 8.85 18 10.34 18 12c0 .85-.19 1.65-.51 2.38l1.5 1.5C19.63 14.74 20 13.41 20 12zM4.27 4L2.86 5.41l2.36 2.36C4.45 8.99 4 10.44 4 12c0 2.21.91 4.2 2.36 5.64L4 20h6v-6l-2.24 2.24C6.68 15.15 6 13.66 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.24-.76.34v2.09c.8-.21 1.55-.54 2.23-.96l2.58 2.58 1.41-1.41L4.27 4z"
	}), 'SyncDisabledOutlined');
	
	exports.default = _default;

/***/ },
/* 5903 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 5.74v-.19c0-.68-.71-1.11-1.32-.82-.19.09-.36.2-.54.3L9.6 6.49c.24-.18.4-.45.4-.75zM20 12c0-2.21-.91-4.2-2.36-5.64l1.51-1.51c.31-.31.09-.85-.36-.85H14v4.79c0 .45.54.67.85.35l1.39-1.39C17.32 8.85 18 10.34 18 12c0 .85-.18 1.66-.5 2.39l1.48 1.48C19.62 14.72 20 13.41 20 12zM3.57 4.7c-.39.39-.39 1.02 0 1.41l1.65 1.65C4.45 9 4 10.44 4 12c0 2.21.91 4.2 2.36 5.64l-1.51 1.51c-.31.31-.09.85.36.85H9.5c.28 0 .5-.22.5-.5v-4.29c0-.45-.54-.67-.85-.35l-1.39 1.39C6.68 15.15 6 13.66 6 12c0-1 .26-1.93.69-2.76l8.07 8.07c-.01.02-.01.02-.01.04-.43.12-.75.48-.75.91v.18c0 .68.71 1.11 1.32.82.31-.14.61-.31.9-.49l1.87 1.87c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L4.98 4.7a.9959.9959 0 00-1.41 0z"
	}), 'SyncDisabledRounded');
	
	exports.default = _default;

/***/ },
/* 5904 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 6.35V4.26c-.66.17-1.29.43-1.88.75l1.5 1.5c.13-.05.25-.11.38-.16zM20 12c0-2.21-.91-4.2-2.36-5.64L20 4h-6v6l2.24-2.24C17.32 8.85 18 10.34 18 12c0 .85-.19 1.65-.51 2.38l1.5 1.5C19.63 14.74 20 13.41 20 12zM4.27 4L2.86 5.41l2.36 2.36C4.45 8.99 4 10.44 4 12c0 2.21.91 4.2 2.36 5.64L4 20h6v-6l-2.24 2.24C6.68 15.15 6 13.66 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.24-.76.34v2.09c.8-.21 1.55-.54 2.23-.96l2.58 2.58 1.41-1.41L4.27 4z"
	}), 'SyncDisabledSharp');
	
	exports.default = _default;

/***/ },
/* 5905 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 6.35V4.26c-.66.17-1.29.43-1.88.75l1.5 1.5c.13-.05.25-.11.38-.16zM20 12c0-2.21-.91-4.2-2.36-5.64L20 4h-6v6l2.24-2.24C17.32 8.85 18 10.34 18 12c0 .85-.19 1.65-.51 2.38l1.5 1.5C19.63 14.74 20 13.41 20 12zM4.27 4L2.86 5.41l2.36 2.36C4.45 8.99 4 10.44 4 12c0 2.21.91 4.2 2.36 5.64L4 20h6v-6l-2.24 2.24C6.68 15.15 6 13.66 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.24-.76.34v2.09c.8-.21 1.55-.54 2.23-.96l2.58 2.58 1.41-1.41L4.27 4z"
	}), 'SyncDisabledTwoTone');
	
	exports.default = _default;

/***/ },
/* 5906 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
	}), 'SyncOutlined');
	
	exports.default = _default;

/***/ },
/* 5907 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24C5.68 15.15 5 13.66 5 12c0-2.61 1.67-4.83 4-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24C18.32 8.85 19 10.34 19 12c0 2.61-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z"
	}), 'SyncProblem');
	
	exports.default = _default;

/***/ },
/* 5908 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24C5.68 15.15 5 13.66 5 12c0-2.61 1.67-4.83 4-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24C18.32 8.85 19 10.34 19 12c0 2.61-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z"
	}), 'SyncProblemOutlined');
	
	exports.default = _default;

/***/ },
/* 5909 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 12c0 2.21.91 4.2 2.36 5.64l-1.51 1.51c-.31.31-.09.85.36.85H8.5c.28 0 .5-.22.5-.5v-4.29c0-.45-.54-.67-.85-.35l-1.39 1.39C5.68 15.15 5 13.66 5 12c0-2.39 1.4-4.46 3.43-5.42.34-.16.57-.47.57-.84v-.19c0-.68-.71-1.11-1.32-.82C4.92 5.99 3 8.77 3 12zm8 5h2v-2h-2v2zm8.79-13H15.5c-.28 0-.5.22-.5.5v4.29c0 .45.54.67.85.35l1.39-1.39C18.32 8.85 19 10.34 19 12c0 2.39-1.4 4.46-3.43 5.42-.34.16-.57.47-.57.84v.18c0 .68.71 1.11 1.32.82C19.08 18.01 21 15.23 21 12c0-2.21-.91-4.2-2.36-5.64l1.51-1.51c.31-.31.09-.85-.36-.85zM12 13c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1z"
	}), 'SyncProblemRounded');
	
	exports.default = _default;

/***/ },
/* 5910 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24C5.68 15.15 5 13.66 5 12c0-2.61 1.67-4.83 4-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24C18.32 8.85 19 10.34 19 12c0 2.61-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z"
	}), 'SyncProblemSharp');
	
	exports.default = _default;

/***/ },
/* 5911 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24C5.68 15.15 5 13.66 5 12c0-2.61 1.67-4.83 4-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24C18.32 8.85 19 10.34 19 12c0 2.61-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z"
	}), 'SyncProblemTwoTone');
	
	exports.default = _default;

/***/ },
/* 5912 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4V2.21c0-.45-.54-.67-.85-.35l-2.8 2.79c-.2.2-.2.51 0 .71l2.79 2.79c.32.31.86.09.86-.36V6c3.31 0 6 2.69 6 6 0 .79-.15 1.56-.44 2.25-.15.36-.04.77.23 1.04.51.51 1.37.33 1.64-.34.37-.91.57-1.91.57-2.95 0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-.79.15-1.56.44-2.25.15-.36.04-.77-.23-1.04-.51-.51-1.37-.33-1.64.34C4.2 9.96 4 10.96 4 12c0 4.42 3.58 8 8 8v1.79c0 .45.54.67.85.35l2.79-2.79c.2-.2.2-.51 0-.71l-2.79-2.79c-.31-.31-.85-.09-.85.36V18z"
	}), 'SyncRounded');
	
	exports.default = _default;

/***/ },
/* 5913 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
	}), 'SyncSharp');
	
	exports.default = _default;

/***/ },
/* 5914 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.01 4V1l-4 4 4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46c.78-1.23 1.24-2.69 1.24-4.26 0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.25 7.74C4.47 8.97 4.01 10.43 4.01 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
	}), 'SyncTwoTone');
	
	exports.default = _default;

/***/ },
/* 5915 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-1-6h-3V8h-2v5H8l4 4 4-4z"
	}), 'SystemUpdate');
	
	exports.default = _default;

/***/ },
/* 5916 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z"
	}), 'SystemUpdateAlt');
	
	exports.default = _default;

/***/ },
/* 5917 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 16l4-4h-3V3h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V4.99h6V3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 13l4-4h-3V3h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V4.99h6V3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'SystemUpdateAltOutlined');
	
	exports.default = _default;

/***/ },
/* 5918 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.35 15.65l2.79-2.79c.31-.31.09-.85-.35-.85H13V4c0-.55-.45-1-1-1s-1 .45-1 1v8H9.21c-.45 0-.67.54-.35.85l2.79 2.79c.19.2.51.2.7.01zM21 3h-5.01c-.54 0-.99.45-.99.99 0 .55.45.99.99.99H20c.55 0 1 .45 1 1v12.03c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V5.99c0-.55.45-1 1-1h4.01c.54 0 .99-.45.99-.99 0-.55-.45-1-.99-1H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'SystemUpdateAltRounded');
	
	exports.default = _default;

/***/ },
/* 5919 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 16l4-4h-3V3h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V4.99h6V3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 13l4-4h-3V3h-2v9H8l4 4zM23 3h-8v1.99h6v14.03H3V4.99h6V3H1v18h22V3z"
	}), 'SystemUpdateAltSharp');
	
	exports.default = _default;

/***/ },
/* 5920 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 16l4-4h-3V3h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V4.99h6V3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'SystemUpdateAltTwoTone');
	
	exports.default = _default;

/***/ },
/* 5921 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-1-6h-3V8h-2v5H8l4 4 4-4z"
	}), 'SystemUpdateOutlined');
	
	exports.default = _default;

/***/ },
/* 5922 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-2.21-6H13V9c0-.55-.45-1-1-1s-1 .45-1 1v4H9.21c-.45 0-.67.54-.35.85l2.79 2.79c.2.2.51.2.71 0l2.79-2.79c.31-.31.09-.85-.36-.85z"
	}), 'SystemUpdateRounded');
	
	exports.default = _default;

/***/ },
/* 5923 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 1v22h14V1H5zm12 18H7V5h10v14zm-1-6h-3V8h-2v5H8l4 4 4-4z"
	}), 'SystemUpdateSharp');
	
	exports.default = _default;

/***/ },
/* 5924 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 19h10V5H7v14zm4-6V8h2v5h3l-4 4-4-4h3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16 13h-3V8h-2v5H8l4 4zm1-11.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
	})), 'SystemUpdateTwoTone');
	
	exports.default = _default;

/***/ },
/* 5925 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z"
	}), 'Tab');
	
	exports.default = _default;

/***/ },
/* 5926 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z"
	}), 'TabOutlined');
	
	exports.default = _default;

/***/ },
/* 5927 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h9v3c0 .55.45 1 1 1h7v9c0 .55-.45 1-1 1z"
	}), 'TabRounded');
	
	exports.default = _default;

/***/ },
/* 5928 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10zm2-16H1v18h22V3zm-2 16H3V5h10v4h8v10z"
	}), 'TabSharp');
	
	exports.default = _default;

/***/ },
/* 5929 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z"
	}), 'TabTwoTone');
	
	exports.default = _default;

/***/ },
/* 5930 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 9h2V7H1v2zm0 4h2v-2H1v2zm0-8h2V3c-1.1 0-2 .9-2 2zm8 16h2v-2H9v2zm-8-4h2v-2H1v2zm2 4v-2H1c0 1.1.9 2 2 2zM21 3h-8v6h10V5c0-1.1-.9-2-2-2zm0 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zm16 16c1.1 0 2-.9 2-2h-2v2zm0-8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2z"
	}), 'TabUnselected');
	
	exports.default = _default;

/***/ },
/* 5931 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 9h2V7H1v2zm0 4h2v-2H1v2zm0-8h2V3c-1.1 0-2 .9-2 2zm8 16h2v-2H9v2zm-8-4h2v-2H1v2zm2 4v-2H1c0 1.1.9 2 2 2zM21 3h-8v6h10V5c0-1.1-.9-2-2-2zm0 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zm16 16c1.1 0 2-.9 2-2h-2v2zm0-8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2z"
	}), 'TabUnselectedOutlined');
	
	exports.default = _default;

/***/ },
/* 5932 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 9h2V7H1v2zm0 4h2v-2H1v2zm0-8h2V3c-1.1 0-2 .9-2 2zm8 16h2v-2H9v2zm-8-4h2v-2H1v2zm2 4v-2H1c0 1.1.9 2 2 2zM21 3h-8v5c0 .55.45 1 1 1h9V5c0-1.1-.9-2-2-2zm0 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zm16 16c1.1 0 2-.9 2-2h-2v2zm0-8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2z"
	}), 'TabUnselectedRounded');
	
	exports.default = _default;

/***/ },
/* 5933 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 9h2V7H1v2zm0 4h2v-2H1v2zm8 8h2v-2H9v2zm-8-4h2v-2H1v2zm0 4h2v-2H1v2zM23 3H13v6h10V3zm-2 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zM1 5h2V3H1v2zm20 8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2z"
	}), 'TabUnselectedSharp');
	
	exports.default = _default;

/***/ },
/* 5934 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 9h2V7H1v2zm0 4h2v-2H1v2zm0-8h2V3c-1.1 0-2 .9-2 2zm8 16h2v-2H9v2zm-8-4h2v-2H1v2zm2 4v-2H1c0 1.1.9 2 2 2zM21 3h-8v6h10V5c0-1.1-.9-2-2-2zm0 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zm16 16c1.1 0 2-.9 2-2h-2v2zm0-8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2z"
	}), 'TabUnselectedTwoTone');
	
	exports.default = _default;

/***/ },
/* 5935 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 10.02h5V21h-5zM17 21h3c1.1 0 2-.9 2-2v-9h-5v11zm3-18H5c-1.1 0-2 .9-2 2v3h19V5c0-1.1-.9-2-2-2zM3 19c0 1.1.9 2 2 2h3V10H3v9z"
	}), 'TableChart');
	
	exports.default = _default;

/***/ },
/* 5936 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 2v3H5V5h15zm-5 14h-5v-9h5v9zM5 10h3v9H5v-9zm12 9v-9h3v9h-3z"
	}), 'TableChartOutlined');
	
	exports.default = _default;

/***/ },
/* 5937 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 10.02h5V21h-5V10.02zM17 21h3c1.1 0 2-.9 2-2v-9h-5v11zm3-18H5c-1.1 0-2 .9-2 2v3h19V5c0-1.1-.9-2-2-2zM3 19c0 1.1.9 2 2 2h3V10H3v9z"
	}), 'TableChartRounded');
	
	exports.default = _default;

/***/ },
/* 5938 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 10.02h5V21h-5V10.02zM17 21h5V10h-5v11zm5-18H3v5h19V3zM3 21h5V10H3v11z"
	}), 'TableChartSharp');
	
	exports.default = _default;

/***/ },
/* 5939 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 5h15v3H5zm12 5h3v9h-3zm-7 0h5v9h-5zm-5 0h3v9H5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM8 19H5v-9h3v9zm7 0h-5v-9h5v9zm5 0h-3v-9h3v9zm0-11H5V5h15v3z"
	})), 'TableChartTwoTone');
	
	exports.default = _default;

/***/ },
/* 5940 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z"
	}), 'Tablet');
	
	exports.default = _default;

/***/ },
/* 5941 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z"
	}), 'TabletAndroid');
	
	exports.default = _default;

/***/ },
/* 5942 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z"
	}), 'TabletAndroidOutlined');
	
	exports.default = _default;

/***/ },
/* 5943 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4.5 22h-3c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h3c.28 0 .5.22.5.5s-.22.5-.5.5zm5.75-3H4.75V3h14.5v16z"
	}), 'TabletAndroidRounded');
	
	exports.default = _default;

/***/ },
/* 5944 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 0H3v24h18V0zm-7 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z"
	}), 'TabletAndroidSharp');
	
	exports.default = _default;

/***/ },
/* 5945 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4.75 3h14.5v16H4.75z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z"
	})), 'TabletAndroidTwoTone');
	
	exports.default = _default;

/***/ },
/* 5946 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.5 0h-14C3.12 0 2 1.12 2 2.5v19C2 22.88 3.12 24 4.5 24h14c1.38 0 2.5-1.12 2.5-2.5v-19C21 1.12 19.88 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z"
	}), 'TabletMac');
	
	exports.default = _default;

/***/ },
/* 5947 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.5 0h-14C3.12 0 2 1.12 2 2.5v19C2 22.88 3.12 24 4.5 24h14c1.38 0 2.5-1.12 2.5-2.5v-19C21 1.12 19.88 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z"
	}), 'TabletMacOutlined');
	
	exports.default = _default;

/***/ },
/* 5948 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.5 0h-14C3.12 0 2 1.12 2 2.5v19C2 22.88 3.12 24 4.5 24h14c1.38 0 2.5-1.12 2.5-2.5v-19C21 1.12 19.88 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z"
	}), 'TabletMacRounded');
	
	exports.default = _default;

/***/ },
/* 5949 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 0H2v24h19V0zm-9.5 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z"
	}), 'TabletMacSharp');
	
	exports.default = _default;

/***/ },
/* 5950 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 3h15v16H4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18.5 0h-14C3.12 0 2 1.12 2 2.5v19C2 22.88 3.12 24 4.5 24h14c1.38 0 2.5-1.12 2.5-2.5v-19C21 1.12 19.88 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z"
	})), 'TabletMacTwoTone');
	
	exports.default = _default;

/***/ },
/* 5951 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z"
	}), 'TabletOutlined');
	
	exports.default = _default;

/***/ },
/* 5952 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z"
	}), 'TabletRounded');
	
	exports.default = _default;

/***/ },
/* 5953 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 4H1v16h21.99L23 4zm-4 14H5V6h14v12z"
	}), 'TabletSharp');
	
	exports.default = _default;

/***/ },
/* 5954 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 6h14v12H5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z"
	})), 'TabletTwoTone');
	
	exports.default = _default;

/***/ },
/* 5955 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
	}), 'TagFaces');
	
	exports.default = _default;

/***/ },
/* 5956 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
	}), 'TagFacesOutlined');
	
	exports.default = _default;

/***/ },
/* 5957 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.01 2C6.49 2 2.02 6.48 2.02 12s4.47 10 9.99 10c5.53 0 10.01-4.48 10.01-10S17.54 2 12.01 2zm.01 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.35 8 15.52 8s-1.5.67-1.5 1.5.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.35 8 8.52 8s-1.5.67-1.5 1.5.67 1.5 1.5 1.5zm3.5 6.5c2.03 0 3.8-1.11 4.75-2.75.19-.33-.05-.75-.44-.75H7.71c-.38 0-.63.42-.44.75.95 1.64 2.72 2.75 4.75 2.75z"
	}), 'TagFacesRounded');
	
	exports.default = _default;

/***/ },
/* 5958 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.01 2C6.49 2 2.02 6.48 2.02 12s4.47 10 9.99 10c5.53 0 10.01-4.48 10.01-10S17.54 2 12.01 2zm.01 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.35 8 15.52 8s-1.5.67-1.5 1.5.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.35 8 8.52 8s-1.5.67-1.5 1.5.67 1.5 1.5 1.5zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.91c.8 2.04 2.78 3.5 5.11 3.5z"
	}), 'TagFacesSharp');
	
	exports.default = _default;

/***/ },
/* 5959 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3.5 4c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-7 0c.83 0 1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5 7.67 8 8.5 8zm3.5 9.5c-2.33 0-4.31-1.46-5.11-3.5h10.22c-.8 2.04-2.78 3.5-5.11 3.5z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
	}), _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "9.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	})), 'TagFacesTwoTone');
	
	exports.default = _default;

/***/ },
/* 5960 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0 4v3h3c0-1.66-1.34-3-3-3zm0-8v2c4.97 0 9 4.03 9 9h2c0-6.08-4.92-11-11-11zM17 1.01L7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"
	}), 'TapAndPlay');
	
	exports.default = _default;

/***/ },
/* 5961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0 4v3h3c0-1.66-1.34-3-3-3zm0-8v2c4.97 0 9 4.03 9 9h2c0-6.08-4.92-11-11-11zM17 1.01L7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"
	}), 'TapAndPlayOutlined');
	
	exports.default = _default;

/***/ },
/* 5962 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.14 16.09c-.6-.1-1.14.39-1.14 1 0 .49.36.9.85.98 2.08.36 3.72 2 4.08 4.08.08.49.49.85.98.85.61 0 1.09-.54 1-1.14-.48-2.95-2.81-5.29-5.77-5.77zM2 20v3h3c0-1.66-1.34-3-3-3zm1.11-7.94c-.59-.06-1.11.4-1.11.99 0 .5.37.94.87.99 4.27.41 7.67 3.81 8.08 8.08.05.5.48.88.99.88.59 0 1.06-.51 1-1.1-.51-5.2-4.63-9.32-9.83-9.84zM17 1.01L7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"
	}), 'TapAndPlayRounded');
	
	exports.default = _default;

/***/ },
/* 5963 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0 4v3h3c0-1.66-1.34-3-3-3zm0-8v2c4.97 0 9 4.03 9 9h2c0-6.08-4.92-11-11-11zM5 1v9.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H19V1H5z"
	}), 'TapAndPlaySharp');
	
	exports.default = _default;

/***/ },
/* 5964 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0 4v3h3c0-1.66-1.34-3-3-3zm0-8v2c4.97 0 9 4.03 9 9h2c0-6.08-4.92-11-11-11zM17 1.01L7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"
	}), 'TapAndPlayTwoTone');
	
	exports.default = _default;

/***/ },
/* 5965 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z"
	}), 'Telegram');
	
	exports.default = _default;

/***/ },
/* 5966 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
	}), 'Terrain');
	
	exports.default = _default;

/***/ },
/* 5967 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6l-4.22 5.63 1.25 1.67L14 9.33 19 16h-8.46l-4.01-5.37L1 18h22L14 6zM5 16l1.52-2.03L8.04 16H5z"
	}), 'TerrainOutlined');
	
	exports.default = _default;

/***/ },
/* 5968 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.2 7.07L10.25 11l2.25 3c.33.44.24 1.07-.2 1.4-.44.33-1.07.25-1.4-.2-1.05-1.4-2.31-3.07-3.1-4.14-.4-.53-1.2-.53-1.6 0l-4 5.33c-.49.67-.02 1.61.8 1.61h18c.82 0 1.29-.94.8-1.6l-7-9.33c-.4-.54-1.2-.54-1.6 0z"
	}), 'TerrainRounded');
	
	exports.default = _default;

/***/ },
/* 5969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
	}), 'TerrainSharp');
	
	exports.default = _default;

/***/ },
/* 5970 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 16h3.04l-1.52-2.03z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9.78 11.63l1.25 1.67L14 9.33 19 16h-8.46l-4.01-5.37L1 18h22L14 6l-4.22 5.63zM5 16l1.52-2.03L8.04 16H5z"
	})), 'TerrainTwoTone');
	
	exports.default = _default;

/***/ },
/* 5971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z"
	}), 'TextFields');
	
	exports.default = _default;

/***/ },
/* 5972 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z"
	}), 'TextFieldsOutlined');
	
	exports.default = _default;

/***/ },
/* 5973 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.5 5.5C2.5 6.33 3.17 7 4 7h3.5v10.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V7H14c.83 0 1.5-.67 1.5-1.5S14.83 4 14 4H4c-.83 0-1.5.67-1.5 1.5zM20 9h-6c-.83 0-1.5.67-1.5 1.5S13.17 12 14 12h1.5v5.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V12H20c.83 0 1.5-.67 1.5-1.5S20.83 9 20 9z"
	}), 'TextFieldsRounded');
	
	exports.default = _default;

/***/ },
/* 5974 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z"
	}), 'TextFieldsSharp');
	
	exports.default = _default;

/***/ },
/* 5975 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.5 12h3v7h3v-7h3V9h-9zm3-8h-13v3h5v12h3V7h5z"
	}), 'TextFieldsTwoTone');
	
	exports.default = _default;

/***/ },
/* 5976 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z"
	}), 'TextFormat');
	
	exports.default = _default;

/***/ },
/* 5977 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z"
	}), 'TextFormatOutlined');
	
	exports.default = _default;

/***/ },
/* 5978 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 18c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1zm4.5-5.2h5l.66 1.6c.15.36.5.6.89.6.69 0 1.15-.71.88-1.34l-3.88-8.97C12.87 4.27 12.46 4 12 4c-.46 0-.87.27-1.05.69l-3.88 8.97c-.27.63.2 1.34.89 1.34.39 0 .74-.24.89-.6l.65-1.6zM12 5.98L13.87 11h-3.74L12 5.98z"
	}), 'TextFormatRounded');
	
	exports.default = _default;

/***/ },
/* 5979 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z"
	}), 'TextFormatSharp');
	
	exports.default = _default;

/***/ },
/* 5980 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z"
	}), 'TextFormatTwoTone');
	
	exports.default = _default;

/***/ },
/* 5981 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 12v1.5l11 4.75v-2.1l-2.2-.9v-5l2.2-.9v-2.1L3 12zm7 2.62l-5.02-1.87L10 10.88v3.74zm8-10.37l-3 3h2v12.5h2V7.25h2l-3-3z"
	}), 'TextRotateUp');
	
	exports.default = _default;

/***/ },
/* 5982 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4l-3 3h2v13h2V7h2l-3-3zm-6.2 11.5v-5l2.2-.9V7.5L3 12.25v1.5l11 4.75v-2.1l-2.2-.9zM4.98 13L10 11.13v3.74L4.98 13z"
	}), 'TextRotateUpOutlined');
	
	exports.default = _default;

/***/ },
/* 5983 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.35 4.35c-.2-.2-.51-.2-.71 0l-1.79 1.79c-.31.32-.09.86.36.86H17v12c0 .55.45 1 1 1s1-.45 1-1V7h.79c.45 0 .67-.54.35-.85l-1.79-1.8zM11.8 15.5v-5l1.6-.66c.36-.14.6-.49.6-.88 0-.69-.71-1.15-1.34-.88l-8.97 3.88c-.42.17-.69.58-.69 1.04 0 .46.27.87.69 1.05l8.97 3.88c.63.27 1.34-.2 1.34-.89 0-.39-.24-.74-.6-.89l-1.6-.65zM4.98 13L10 11.13v3.74L4.98 13z"
	}), 'TextRotateUpRounded');
	
	exports.default = _default;

/***/ },
/* 5984 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4l-3 3h2v13h2V7h2l-3-3zm-6.2 11.5v-5l2.2-.9V7.5L3 12.25v1.5l11 4.75v-2.1l-2.2-.9zM4.98 13L10 11.13v3.74L4.98 13z"
	}), 'TextRotateUpSharp');
	
	exports.default = _default;

/***/ },
/* 5985 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4l-3 3h2v13h2V7h2l-3-3zm-6.2 11.5v-5l2.2-.9V7.5L3 12.25v1.5l11 4.75v-2.1l-2.2-.9zM4.98 13L10 11.13v3.74L4.98 13z"
	}), 'TextRotateUpTwoTone');
	
	exports.default = _default;

/***/ },
/* 5986 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.75 5h-1.5L9.5 16h2.1l.9-2.2h5l.9 2.2h2.1L15.75 5zm-2.62 7L15 6.98 16.87 12h-3.74zM6 19.75l3-3H7V4.25H5v12.5H3l3 3z"
	}), 'TextRotateVertical');
	
	exports.default = _default;

/***/ },
/* 5987 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.75 5h-1.5L9.5 16h2.1l.9-2.2h5l.9 2.2h2.1L15.75 5zm-2.62 7L15 6.98 16.87 12h-3.74zM6 20l3-3H7V4H5v13H3l3 3z"
	}), 'TextRotateVerticalOutlined');
	
	exports.default = _default;

/***/ },
/* 5988 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 5c-.46 0-.87.27-1.05.69l-3.88 8.97c-.27.63.2 1.34.89 1.34.39 0 .74-.24.89-.6l.66-1.6h5l.66 1.6c.15.36.5.6.89.6.69 0 1.15-.71.88-1.34l-3.88-8.97C15.87 5.27 15.46 5 15 5zm-1.87 7L15 6.98 16.87 12h-3.74zm-6.78 7.64l1.79-1.79c.32-.31.1-.85-.35-.85H7V5c0-.55-.45-1-1-1s-1 .44-1 1v12h-.79c-.45 0-.67.54-.35.85l1.79 1.79c.19.2.51.2.7 0z"
	}), 'TextRotateVerticalRounded');
	
	exports.default = _default;

/***/ },
/* 5989 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.75 5h-1.5L9.5 16h2.1l.9-2.2h5l.9 2.2h2.1L15.75 5zm-2.62 7L15 6.98 16.87 12h-3.74zM6 20l3-3H7V4H5v13H3l3 3z"
	}), 'TextRotateVerticalSharp');
	
	exports.default = _default;

/***/ },
/* 5990 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.75 5h-1.5L9.5 16h2.1l.9-2.2h5l.9 2.2h2.1L15.75 5zm-2.62 7L15 6.98 16.87 12h-3.74zM6 20l3-3H7V4H5v13H3l3 3z"
	}), 'TextRotateVerticalTwoTone');
	
	exports.default = _default;

/***/ },
/* 5991 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.4 4.91l-1.06-1.06L7.2 8.27l1.48 1.48 2.19-.92 3.54 3.54-.92 2.19 1.48 1.48L19.4 4.91zm-6.81 3.1l4.87-2.23-2.23 4.87-2.64-2.64zM14.27 21v-4.24l-1.41 1.41-8.84-8.84-1.42 1.42 8.84 8.84L10.03 21h4.24z"
	}), 'TextRotationAngledown');
	
	exports.default = _default;

/***/ },
/* 5992 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 21v-4.24l-1.41 1.41-9.2-9.19-1.41 1.41 9.19 9.19L10.76 21H15zM11.25 8.48l3.54 3.54-.92 2.19 1.48 1.48 4.42-11.14-1.06-1.05L7.57 7.92 9.06 9.4l2.19-.92zm6.59-3.05l-2.23 4.87-2.64-2.64 4.87-2.23z"
	}), 'TextRotationAngledownOutlined');
	
	exports.default = _default;

/***/ },
/* 5993 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 20.5v-2.54c0-.45-.54-.67-.85-.35l-.56.56L5.1 9.68a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l8.49 8.49-.56.56c-.32.32-.1.86.34.86h2.54c.28 0 .5-.23.5-.5zM11.25 8.48l3.54 3.54-.67 1.6c-.15.36-.07.77.21 1.05.49.49 1.31.32 1.57-.32l3.61-9.09c.17-.42.07-.91-.25-1.23-.32-.32-.8-.42-1.23-.25l-9.1 3.6c-.64.25-.81 1.08-.32 1.57.27.27.68.35 1.04.2l1.6-.67zm6.59-3.05l-2.23 4.87-2.64-2.64 4.87-2.23z"
	}), 'TextRotationAngledownRounded');
	
	exports.default = _default;

/***/ },
/* 5994 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 21v-4.24l-1.41 1.41-9.2-9.19-1.41 1.41 9.19 9.19L10.76 21H15zM11.25 8.48l3.54 3.54-.92 2.19 1.48 1.48 4.42-11.14-1.06-1.05L7.57 7.92 9.06 9.4l2.19-.92zm6.59-3.05l-2.23 4.87-2.64-2.64 4.87-2.23z"
	}), 'TextRotationAngledownSharp');
	
	exports.default = _default;

/***/ },
/* 5995 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 21v-4.24l-1.41 1.41-9.2-9.19-1.41 1.41 9.19 9.19L10.76 21H15zM11.25 8.48l3.54 3.54-.92 2.19 1.48 1.48 4.42-11.14-1.06-1.05L7.57 7.92 9.06 9.4l2.19-.92zm6.59-3.05l-2.23 4.87-2.64-2.64 4.87-2.23z"
	}), 'TextRotationAngledownTwoTone');
	
	exports.default = _default;

/***/ },
/* 5996 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.49 4.21L3.43 5.27 7.85 16.4l1.48-1.48-.92-2.19 3.54-3.54 2.19.92 1.48-1.48L4.49 4.21zm3.09 6.8L5.36 6.14l4.87 2.23-2.65 2.64zm12.99-1.68h-4.24l1.41 1.41-8.84 8.84L10.32 21l8.84-8.84 1.41 1.41V9.33z"
	}), 'TextRotationAngleup');
	
	exports.default = _default;

/***/ },
/* 5997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.76 9l1.41 1.41-9.19 9.19 1.41 1.41 9.19-9.19L21 13.24V9h-4.24zm-8.28 3.75l3.54-3.54 2.19.92 1.48-1.48L4.56 4.23 3.5 5.29l4.42 11.14 1.48-1.48-.92-2.2zm-.82-1.72L5.43 6.16l4.87 2.23-2.64 2.64z"
	}), 'TextRotationAngleupOutlined');
	
	exports.default = _default;

/***/ },
/* 5998 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.61 9.85l.56.56-8.48 8.49c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l8.49-8.49.56.56c.31.32.85.1.85-.34V9.5c0-.28-.22-.5-.5-.5h-2.54c-.44 0-.66.54-.35.85zm-9.13 2.9l3.54-3.54 1.6.67c.36.15.77.07 1.05-.21.49-.49.32-1.31-.32-1.57L5.26 4.5c-.43-.16-.91-.06-1.23.26-.32.32-.42.8-.25 1.23l3.61 9.09c.25.64 1.08.81 1.57.32.28-.28.36-.69.21-1.05l-.69-1.6zm-.82-1.72L5.43 6.16l4.87 2.23-2.64 2.64z"
	}), 'TextRotationAngleupRounded');
	
	exports.default = _default;

/***/ },
/* 5999 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.76 9l1.41 1.41-9.19 9.19 1.41 1.41 9.19-9.19L21 13.24V9h-4.24zm-8.28 3.75l3.54-3.54 2.19.92 1.48-1.48L4.56 4.23 3.5 5.29l4.42 11.14 1.48-1.48-.92-2.2zm-.82-1.72L5.43 6.16l4.87 2.23-2.64 2.64z"
	}), 'TextRotationAngleupSharp');
	
	exports.default = _default;

/***/ },
/* 6000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.76 9l1.41 1.41-9.19 9.19 1.41 1.41 9.19-9.19L21 13.24V9h-4.24zm-8.28 3.75l3.54-3.54 2.19.92 1.48-1.48L4.56 4.23 3.5 5.29l4.42 11.14 1.48-1.48-.92-2.2zm-.82-1.72L5.43 6.16l4.87 2.23-2.64 2.64z"
	}), 'TextRotationAngleupTwoTone');
	
	exports.default = _default;

/***/ },
/* 6001 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 12v-1.5L10 5.75v2.1l2.2.9v5l-2.2.9v2.1L21 12zm-7-2.62l5.02 1.87L14 13.12V9.38zM6 19.75l3-3H7V4.25H5v12.5H3l3 3z"
	}), 'TextRotationDown');
	
	exports.default = _default;

/***/ },
/* 6002 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 20l3-3H7V4H5v13H3l3 3zm6.2-11.5v5l-2.2.9v2.1l11-4.75v-1.5L10 5.5v2.1l2.2.9zm6.82 2.5L14 12.87V9.13L19.02 11z"
	}), 'TextRotationDownOutlined');
	
	exports.default = _default;

/***/ },
/* 6003 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.35 19.65l1.79-1.79c.32-.32.1-.86-.35-.86H7V5c0-.55-.45-1-1-1s-1 .45-1 1v12h-.79c-.45 0-.67.54-.35.85l1.79 1.79c.19.2.51.2.7.01zM12.2 8.5v5l-1.6.66c-.36.15-.6.5-.6.89 0 .69.71 1.15 1.34.88l8.97-3.88c.42-.18.69-.59.69-1.05 0-.46-.27-.87-.69-1.05l-8.97-3.88c-.63-.27-1.34.2-1.34.89 0 .39.24.74.6.89l1.6.65zm6.82 2.5L14 12.87V9.13L19.02 11z"
	}), 'TextRotationDownRounded');
	
	exports.default = _default;

/***/ },
/* 6004 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 20l3-3H7V4H5v13H3l3 3zm6.2-11.5v5l-2.2.9v2.1l11-4.75v-1.5L10 5.5v2.1l2.2.9zm6.82 2.5L14 12.87V9.13L19.02 11z"
	}), 'TextRotationDownSharp');
	
	exports.default = _default;

/***/ },
/* 6005 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 20l3-3H7V4H5v13H3l3 3zm6.2-11.5v5l-2.2.9v2.1l11-4.75v-1.5L10 5.5v2.1l2.2.9zm6.82 2.5L14 12.87V9.13L19.02 11z"
	}), 'TextRotationDownTwoTone');
	
	exports.default = _default;

/***/ },
/* 6006 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.75 3h-1.5L6.5 14h2.1l.9-2.2h5l.9 2.2h2.1L12.75 3zm-2.62 7L12 4.98 13.87 10h-3.74zm10.37 8l-3-3v2H5v2h12.5v2l3-3z"
	}), 'TextRotationNone');
	
	exports.default = _default;

/***/ },
/* 6007 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 18l-3-3v2H5v2h13v2l3-3zM9.5 11.8h5l.9 2.2h2.1L12.75 3h-1.5L6.5 14h2.1l.9-2.2zM12 4.98L13.87 10h-3.74L12 4.98z"
	}), 'TextRotationNoneOutlined');
	
	exports.default = _default;

/***/ },
/* 6008 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.65 17.65l-1.79-1.79c-.32-.32-.86-.1-.86.35V17H6c-.55 0-1 .45-1 1s.45 1 1 1h12v.79c0 .45.54.67.85.35l1.79-1.79c.2-.19.2-.51.01-.7zM9.5 11.8h5l.66 1.6c.15.36.5.6.89.6.69 0 1.15-.71.88-1.34l-3.88-8.97C12.87 3.27 12.46 3 12 3c-.46 0-.87.27-1.05.69l-3.88 8.97c-.27.63.2 1.34.89 1.34.39 0 .74-.24.89-.6l.65-1.6zM12 4.98L13.87 10h-3.74L12 4.98z"
	}), 'TextRotationNoneRounded');
	
	exports.default = _default;

/***/ },
/* 6009 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 18l-3-3v2H5v2h13v2l3-3zM9.5 11.8h5l.9 2.2h2.1L12.75 3h-1.5L6.5 14h2.1l.9-2.2zM12 4.98L13.87 10h-3.74L12 4.98z"
	}), 'TextRotationNoneSharp');
	
	exports.default = _default;

/***/ },
/* 6010 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 18l-3-3v2H5v2h13v2l3-3zM9.5 11.8h5l.9 2.2h2.1L12.75 3h-1.5L6.5 14h2.1l.9-2.2zM12 4.98L13.87 10h-3.74L12 4.98z"
	}), 'TextRotationNoneTwoTone');
	
	exports.default = _default;

/***/ },
/* 6011 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
	}), 'Textsms');
	
	exports.default = _default;

/***/ },
/* 6012 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12zM7 9h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"
	}), 'TextsmsOutlined');
	
	exports.default = _default;

/***/ },
/* 6013 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
	}), 'TextsmsRounded');
	
	exports.default = _default;

/***/ },
/* 6014 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H2.01L2 22l4-4h16V2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
	}), 'TextsmsSharp');
	
	exports.default = _default;

/***/ },
/* 6015 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 18l2-2h14V4H4v14zm11-9h2v2h-2V9zm-4 0h2v2h-2V9zM7 9h2v2H7V9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12zM7 9h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"
	})), 'TextsmsTwoTone');
	
	exports.default = _default;

/***/ },
/* 6016 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.51 3.08L3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41zM11.88 3L3 11.88v2.83L14.71 3h-2.83zM5 3c-1.1 0-2 .9-2 2v2l4-4H5zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2zm-9.71 0h2.83L21 12.12V9.29L9.29 21z"
	}), 'Texture');
	
	exports.default = _default;

/***/ },
/* 6017 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.51 3.08L3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41zM11.88 3L3 11.88v2.83L14.71 3h-2.83zM5 3c-1.1 0-2 .9-2 2v2l4-4H5zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2zm-9.71 0h2.83L21 12.12V9.29L9.29 21z"
	}), 'TextureOutlined');
	
	exports.default = _default;

/***/ },
/* 6018 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.58 3.08L3.15 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L21 4.49c-.19-.69-.73-1.23-1.42-1.41zM11.95 3l-8.88 8.88v2.83L14.78 3h-2.83zM5.07 3c-1.1 0-2 .9-2 2v2l4-4h-2zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2zm-9.71 0h2.83l8.88-8.88V9.29L9.36 21z"
	}), 'TextureRounded');
	
	exports.default = _default;

/***/ },
/* 6019 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.66 3L3.07 19.59V21h1.41L21.07 4.42V3zm-7.71 0l-8.88 8.88v2.83L14.78 3zM3.07 3v4l4-4zm18 18v-4l-4 4zm-8.88 0l8.88-8.88V9.29L9.36 21z"
	}), 'TextureSharp');
	
	exports.default = _default;

/***/ },
/* 6020 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.88 3L3 11.88v2.83L14.71 3zM3 5v2l4-4H5c-1.1 0-2 .9-2 2zm16.51-1.92L3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41zM21 9.29L9.29 21h2.83L21 12.12zm-.59 11.12c.37-.36.59-.86.59-1.41v-2l-4 4h2c.55 0 1.05-.22 1.41-.59z"
	}), 'TextureTwoTone');
	
	exports.default = _default;

/***/ },
/* 6021 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
	}), 'Theaters');
	
	exports.default = _default;

/***/ },
/* 6022 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm6 10h-4V5h4v14zm4-2h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
	}), 'TheatersOutlined');
	
	exports.default = _default;

/***/ },
/* 6023 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 4v1h-2V4c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v1H6V4c0-.55-.45-1-1-1s-1 .45-1 1v16c0 .55.45 1 1 1s1-.45 1-1v-1h2v1c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-1h2v1c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1s-1 .45-1 1zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
	}), 'TheatersRounded');
	
	exports.default = _default;

/***/ },
/* 6024 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
	}), 'TheatersSharp');
	
	exports.default = _default;

/***/ },
/* 6025 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm6 10h-4V5h4v14zm4-2h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
	}), _react.default.createElement("path", {
	  d: "M10 5h4v14h-4z",
	  opacity: ".3"
	})), 'TheatersTwoTone');
	
	exports.default = _default;

/***/ },
/* 6026 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.52 21.48C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08-.16-.06-.29-.13-.4-.24-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72c.13-.29.2-.61.2-.97 0-.19-.02-.38-.07-.56-.05-.18-.12-.35-.23-.51-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31.2-.09.37-.2.52-.33.15-.13.27-.27.37-.42.1-.15.17-.3.22-.46.05-.16.07-.32.07-.48 0-.36-.06-.68-.18-.96-.12-.28-.29-.51-.51-.69-.2-.19-.47-.33-.77-.43C9.1 8.05 8.76 8 8.39 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34c.11-.09.23-.17.38-.22.15-.05.3-.08.48-.08.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49-.05.15-.14.27-.25.37-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09H7.5v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4.07.16.1.35.1.57 0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.43-.18-.92-.27-1.46-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27.45-.18.84-.43 1.16-.76.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57-.18-.47-.43-.87-.75-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.44 4.84 18.29 0 12 0z"
	}), 'ThreeDRotation');
	
	exports.default = _default;

/***/ },
/* 6027 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.53 21.48C4.26 19.94 1.92 16.76 1.56 13H.06c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08-.16-.06-.29-.13-.4-.24-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72.2-.61.2-.97c0-.19-.02-.38-.07-.56-.05-.18-.12-.35-.23-.51-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31.2-.09.37-.2.52-.33.15-.13.27-.27.37-.42.1-.15.17-.3.22-.46s.07-.32.07-.48c0-.36-.06-.68-.18-.96s-.29-.51-.51-.69c-.2-.19-.47-.33-.77-.43C9.11 8.05 8.77 8 8.4 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34.23-.17.38-.22.3-.08.48-.08c.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49s-.14.27-.25.37c-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09h-.77v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4s.1.35.1.57c0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.44-.18-.93-.27-1.47-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27s.84-.43 1.16-.76c.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57s-.42-.87-.74-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12.01 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.45 4.84 18.3 0 12.01 0z"
	}), 'ThreeDRotationOutlined');
	
	exports.default = _default;

/***/ },
/* 6028 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.41 14.96c-.19 0-.37-.03-.52-.08-.16-.06-.29-.13-.4-.24-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72.2-.61.2-.97c0-.19-.02-.38-.07-.56-.05-.18-.12-.35-.23-.51-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31.2-.09.37-.2.52-.33.15-.13.27-.27.37-.42.1-.15.17-.3.22-.46s.07-.32.07-.48c0-.36-.06-.68-.18-.96s-.29-.51-.51-.69c-.2-.19-.47-.33-.77-.43C9.1 8.05 8.76 8 8.39 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34.23-.17.38-.22.3-.08.48-.08c.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49s-.14.27-.25.37c-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09H7.5v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4s.1.35.1.57c0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm9.3-4.72c-.18-.47-.43-.87-.75-1.2-.32-.33-.7-.59-1.14-.77-.43-.18-.92-.27-1.46-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27s.84-.43 1.16-.76c.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57zm-1.13 1.96c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85s-.43.41-.71.53c-.29.12-.62.18-.99.18h-.91V9.11h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.41zm-1.43-8.36l1.33-1.33c3.09 1.46 5.34 4.37 5.89 7.86.06.41.44.69.86.62.41-.06.69-.45.62-.86-.6-3.81-2.96-7.01-6.24-8.75C15.94.49 13.78-.13 11.34.02l3.81 3.82zm-6.3 16.31l-1.33 1.33c-3.09-1.46-5.34-4.37-5.89-7.86-.06-.41-.44-.69-.86-.62-.41.06-.69.45-.62.86.6 3.81 2.96 7.01 6.24 8.75 1.67.89 3.83 1.51 6.27 1.36l-3.81-3.82z"
	}), 'ThreeDRotationRounded');
	
	exports.default = _default;

/***/ },
/* 6029 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.53 21.48C4.26 19.94 1.92 16.76 1.56 13H.06c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08-.16-.06-.29-.13-.4-.24-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72.2-.61.2-.97c0-.19-.02-.38-.07-.56-.05-.18-.12-.35-.23-.51-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31.2-.09.37-.2.52-.33.15-.13.27-.27.37-.42.1-.15.17-.3.22-.46s.07-.32.07-.48c0-.36-.06-.68-.18-.96s-.29-.51-.51-.69c-.2-.19-.47-.33-.77-.43C9.11 8.05 8.77 8 8.4 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34.23-.17.38-.22.3-.08.48-.08c.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49s-.14.27-.25.37c-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09h-.77v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4s.1.35.1.57c0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.44-.18-.93-.27-1.47-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27s.84-.43 1.16-.76c.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57s-.42-.87-.74-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12.01 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.45 4.84 18.3 0 12.01 0z"
	}), 'ThreeDRotationSharp');
	
	exports.default = _default;

/***/ },
/* 6030 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.53 21.48C4.26 19.94 1.92 16.76 1.56 13H.06c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08-.16-.06-.29-.13-.4-.24-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72.2-.61.2-.97c0-.19-.02-.38-.07-.56-.05-.18-.12-.35-.23-.51-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31.2-.09.37-.2.52-.33.15-.13.27-.27.37-.42.1-.15.17-.3.22-.46s.07-.32.07-.48c0-.36-.06-.68-.18-.96s-.29-.51-.51-.69c-.2-.19-.47-.33-.77-.43C9.11 8.05 8.77 8 8.4 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34.23-.17.38-.22.3-.08.48-.08c.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49s-.14.27-.25.37c-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09h-.77v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4s.1.35.1.57c0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.44-.18-.93-.27-1.47-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27s.84-.43 1.16-.76c.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57s-.42-.87-.74-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12.01 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.45 4.84 18.3 0 12.01 0z"
	}), 'ThreeDRotationTwoTone');
	
	exports.default = _default;

/***/ },
/* 6031 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7C6.48 7 2 9.24 2 12c0 2.24 2.94 4.13 7 4.77V20l4-4-4-4v2.73c-3.15-.56-5-1.9-5-2.73 0-1.06 3.04-3 8-3s8 1.94 8 3c0 .73-1.46 1.89-4 2.53v2.05c3.53-.77 6-2.53 6-4.58 0-2.76-4.48-5-10-5z"
	}), 'ThreeSixty');
	
	exports.default = _default;

/***/ },
/* 6032 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7C6.48 7 2 9.24 2 12c0 2.24 2.94 4.13 7 4.77V20l4-4-4-4v2.73c-3.15-.56-5-1.9-5-2.73 0-1.06 3.04-3 8-3s8 1.94 8 3c0 .73-1.46 1.89-4 2.53v2.05c3.53-.77 6-2.53 6-4.58 0-2.76-4.48-5-10-5z"
	}), 'ThreeSixtyOutlined');
	
	exports.default = _default;

/***/ },
/* 6033 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7C6.48 7 2 9.24 2 12c0 2.24 2.94 4.13 7 4.77v2.02c0 .45.54.67.85.35l2.79-2.79c.2-.2.2-.51 0-.71l-2.79-2.79c-.31-.31-.85-.09-.85.36v1.52c-3.15-.56-5-1.9-5-2.73 0-1.06 3.04-3 8-3s8 1.94 8 3c0 .66-1.2 1.68-3.32 2.34-.41.13-.68.51-.68.94 0 .67.65 1.16 1.28.96C20.11 15.36 22 13.79 22 12c0-2.76-4.48-5-10-5z"
	}), 'ThreeSixtyRounded');
	
	exports.default = _default;

/***/ },
/* 6034 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7C6.48 7 2 9.24 2 12c0 2.24 2.94 4.13 7 4.77V20l4-4-4-4v2.73c-3.15-.56-5-1.9-5-2.73 0-1.06 3.04-3 8-3s8 1.94 8 3c0 .73-1.46 1.89-4 2.53v2.05c3.53-.77 6-2.53 6-4.58 0-2.76-4.48-5-10-5z"
	}), 'ThreeSixtySharp');
	
	exports.default = _default;

/***/ },
/* 6035 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 16.77V20l4-4-4-4v2.73c-3.15-.56-5-1.9-5-2.73 0-1.06 3.04-3 8-3s8 1.94 8 3c0 .73-1.46 1.89-4 2.53v2.05c3.53-.77 6-2.53 6-4.58 0-2.76-4.48-5-10-5S2 9.24 2 12c0 2.24 2.94 4.13 7 4.77z"
	}), 'ThreeSixtyTwoTone');
	
	exports.default = _default;

/***/ },
/* 6036 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z"
	}), 'ThumbDown');
	
	exports.default = _default;

/***/ },
/* 6037 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 4h-2c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h2V4zM2.17 11.12c-.11.25-.17.52-.17.8V13c0 1.1.9 2 2 2h5.5l-.92 4.65c-.05.22-.02.46.08.66.23.45.52.86.88 1.22L10 22l6.41-6.41c.38-.38.59-.89.59-1.42V6.34C17 5.05 15.95 4 14.66 4h-8.1c-.71 0-1.36.37-1.72.97l-2.67 6.15z"
	}), 'ThumbDownAlt');
	
	exports.default = _default;

/***/ },
/* 6038 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.58-6.59c.37-.36.59-.86.59-1.41V5c0-1.1-.9-2-2-2zm0 12l-4.34 4.34L11.77 14H3v-2l3-7h9v10zm4-12h4v12h-4z"
	}), 'ThumbDownAltOutlined');
	
	exports.default = _default;

/***/ },
/* 6039 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.88 21.94l5.53-5.54c.37-.37.58-.88.58-1.41V5c0-1.1-.9-2-2-2H6c-.8 0-1.52.48-1.83 1.21L.91 11.82C.06 13.8 1.51 16 3.66 16h5.65l-.95 4.58c-.1.5.05 1.01.41 1.37.59.58 1.53.58 2.11-.01zM21 3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2s2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'ThumbDownAltRounded');
	
	exports.default = _default;

/***/ },
/* 6040 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 11.6V16h8.31l-1.12 5.38L9.83 23 17 15.82V3H4.69zM19 3h4v12h-4z"
	}), 'ThumbDownAltSharp');
	
	exports.default = _default;

/***/ },
/* 6041 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 12v2h8.77l-1.11 5.34L15 15V5H6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.58-6.59c.37-.36.59-.86.59-1.41V5c0-1.1-.9-2-2-2zm0 12l-4.34 4.34L11.77 14H3v-2l3-7h9v10zm4-12h4v12h-4z"
	})), 'ThumbDownAltTwoTone');
	
	exports.default = _default;

/***/ },
/* 6042 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm0 12l-4.34 4.34L12 14H3v-2l3-7h9v10zm4-12h4v12h-4z"
	}), 'ThumbDownOutlined');
	
	exports.default = _default;

/***/ },
/* 6043 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.88 21.94l5.53-5.54c.37-.37.58-.88.58-1.41V5c0-1.1-.9-2-2-2H6c-.8 0-1.52.48-1.83 1.21L.91 11.82C.06 13.8 1.51 16 3.66 16h5.65l-.95 4.58c-.1.5.05 1.01.41 1.37.59.58 1.53.58 2.11-.01zM21 3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2s2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'ThumbDownRounded');
	
	exports.default = _default;

/***/ },
/* 6044 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.83 23L17 15.82V3H4.69L1 11.6V16h8.31l-1.12 5.38zM19 3h4v12h-4z"
	}), 'ThumbDownSharp');
	
	exports.default = _default;

/***/ },
/* 6045 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 12v2h9l-1.34 5.34L15 15V5H6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm0 12l-4.34 4.34L12 14H3v-2l3-7h9v10zm4-12h4v12h-4z"
	})), 'ThumbDownTwoTone');
	
	exports.default = _default;

/***/ },
/* 6046 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"
	}), 'ThumbUp');
	
	exports.default = _default;

/***/ },
/* 6047 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 20h2c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1H2v11zm19.83-7.12c.11-.25.17-.52.17-.8V11c0-1.1-.9-2-2-2h-5.5l.92-4.65c.05-.22.02-.46-.08-.66-.23-.45-.52-.86-.88-1.22L14 2 7.59 8.41C7.21 8.79 7 9.3 7 9.83v7.84C7 18.95 8.05 20 9.34 20h8.11c.7 0 1.36-.37 1.72-.97l2.66-6.15z"
	}), 'ThumbUpAlt');
	
	exports.default = _default;

/***/ },
/* 6048 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 8h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2c0-1.1-.9-2-2-2zm0 4l-3 7H9V9l4.34-4.34L12.23 10H21v2zM1 9h4v12H1z"
	}), 'ThumbUpAltOutlined');
	
	exports.default = _default;

/***/ },
/* 6049 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.12 2.06L7.58 7.6c-.37.37-.58.88-.58 1.41V19c0 1.1.9 2 2 2h9c.8 0 1.52-.48 1.84-1.21l3.26-7.61C23.94 10.2 22.49 8 20.34 8h-5.65l.95-4.58c.1-.5-.05-1.01-.41-1.37-.59-.58-1.53-.58-2.11.01zM3 21c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2s-2 .9-2 2v8c0 1.1.9 2 2 2z"
	}), 'ThumbUpAltRounded');
	
	exports.default = _default;

/***/ },
/* 6050 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.17 1L7 8.18V21h12.31L23 12.4V8h-8.31l1.12-5.38zM1 9h4v12H1z"
	}), 'ThumbUpAltSharp');
	
	exports.default = _default;

/***/ },
/* 6051 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M13.34 4.66L9 9v10h9l3-7v-2h-8.77z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 8h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2c0-1.1-.9-2-2-2zm0 4l-3 7H9V9l4.34-4.34L12.23 10H21v2zM1 9h4v12H1z"
	})), 'ThumbUpAltTwoTone');
	
	exports.default = _default;

/***/ },
/* 6052 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 21h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.58 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2zM9 9l4.34-4.34L12 10h9v2l-3 7H9V9zM1 9h4v12H1z"
	}), 'ThumbUpOutlined');
	
	exports.default = _default;

/***/ },
/* 6053 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.12 2.06L7.58 7.6c-.37.37-.58.88-.58 1.41V19c0 1.1.9 2 2 2h9c.8 0 1.52-.48 1.84-1.21l3.26-7.61C23.94 10.2 22.49 8 20.34 8h-5.65l.95-4.58c.1-.5-.05-1.01-.41-1.37-.59-.58-1.53-.58-2.11.01zM3 21c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2s-2 .9-2 2v8c0 1.1.9 2 2 2z"
	}), 'ThumbUpRounded');
	
	exports.default = _default;

/***/ },
/* 6054 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.17 1L7 8.18V21h12.31L23 12.4V8h-8.31l1.12-5.38zM1 9h4v12H1z"
	}), 'ThumbUpSharp');
	
	exports.default = _default;

/***/ },
/* 6055 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21 12v-2h-9l1.34-5.34L9 9v10h9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9 21h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.58 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2zM9 9l4.34-4.34L12 10h9v2l-3 7H9V9zM1 9h4v12H1z"
	})), 'ThumbUpTwoTone');
	
	exports.default = _default;

/***/ },
/* 6056 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm10.5 4h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5z"
	}), 'ThumbsUpDown');
	
	exports.default = _default;

/***/ },
/* 6057 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm-2 1.13L7.92 12H2V6.21l1.93-1.93L3.36 7H10v.13zM22.5 10h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5zm-.5 7.79l-1.93 1.93.57-2.72H14v-.13L16.08 12H22v5.79z"
	}), 'ThumbsUpDownOutlined');
	
	exports.default = _default;

/***/ },
/* 6058 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10.06 5H5.82l.66-3.18c.08-.37-.04-.75-.3-1.02C5.74.36 5.03.36 4.6.8l-4 4c-.39.37-.6.88-.6 1.41V12c0 1.1.9 2 2 2h5.92c.8 0 1.52-.48 1.84-1.21l2.14-5C12.46 6.47 11.49 5 10.06 5zM22 10h-5.92c-.8 0-1.52.48-1.84 1.21l-2.14 5c-.56 1.32.4 2.79 1.84 2.79h4.24l-.66 3.18c-.08.37.04.75.3 1.02.44.44 1.15.44 1.58 0l4-4c.38-.38.59-.88.59-1.41V12c.01-1.1-.89-2-1.99-2z"
	}), 'ThumbsUpDownRounded');
	
	exports.default = _default;

/***/ },
/* 6059 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5H5.82l.78-3.78L5.38 0 0 5.38V14h9.24L12 7.54zm2.76 5L12 16.46V19h6.18l-.78 3.78L18.62 24 24 18.62V10z"
	}), 'ThumbsUpDownSharp');
	
	exports.default = _default;

/***/ },
/* 6060 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm-2 1.13L7.92 12H2V6.21l1.93-1.93L3.36 7H10v.13zM22.5 10h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5zm-.5 7.79l-1.93 1.93.57-2.72H14v-.13L16.08 12H22v5.79z"
	}), _react.default.createElement("path", {
	  d: "M3.93 4.28L2 6.21V12h5.92L10 7.13V7H3.36zM14 16.87V17h6.64l-.57 2.72L22 17.79V12h-5.92z",
	  opacity: ".3"
	})), 'ThumbsUpDownTwoTone');
	
	exports.default = _default;

/***/ },
/* 6061 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z"
	}), 'TimeToLeave');
	
	exports.default = _default;

/***/ },
/* 6062 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 6h10.29l1.04 3H5.81l1.04-3zM19 16H5v-4.66l.12-.34h13.77l.11.34V16z"
	}), _react.default.createElement("circle", {
	  cx: "7.5",
	  cy: "13.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "13.5",
	  r: "1.5"
	})), 'TimeToLeaveOutlined');
	
	exports.default = _default;

/***/ },
/* 6063 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01l-1.97 5.67c-.07.21-.11.43-.11.66v7.16c0 .83.67 1.5 1.5 1.5S6 19.33 6 18.5V18h12v.5c0 .82.67 1.5 1.5 1.5.82 0 1.5-.67 1.5-1.5v-7.16c0-.22-.04-.45-.11-.66l-1.97-5.67zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.27-3.82c.14-.4.52-.68.95-.68h9.56c.43 0 .81.28.95.68L19 10H5z"
	}), 'TimeToLeaveRounded');
	
	exports.default = _default;

/***/ },
/* 6064 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.57 4H5.43L3 11v9h3v-2h12v2h3v-9l-2.43-7zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z"
	}), 'TimeToLeaveSharp');
	
	exports.default = _default;

/***/ },
/* 6065 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5.12 11l-.12.34V16h14v-4.66l-.12-.34H5.12zm2.38 4c-.83 0-1.5-.67-1.5-1.5S6.67 12 7.5 12s1.5.67 1.5 1.5S8.33 15 7.5 15zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 6h10.29l1.04 3H5.81l1.04-3zM19 16H5v-4.66l.12-.34h13.77l.11.34V16z"
	}), _react.default.createElement("circle", {
	  cx: "7.5",
	  cy: "13.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "16.5",
	  cy: "13.5",
	  r: "1.5"
	})), 'TimeToLeaveTwoTone');
	
	exports.default = _default;

/***/ },
/* 6066 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.24 7.76C15.07 6.59 13.54 6 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'Timelapse');
	
	exports.default = _default;

/***/ },
/* 6067 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.24 7.75c-1.17-1.17-2.7-1.76-4.24-1.76v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48zM12 1.99c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'TimelapseOutlined');
	
	exports.default = _default;

/***/ },
/* 6068 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.24 7.76C15.07 6.59 13.54 6 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'TimelapseRounded');
	
	exports.default = _default;

/***/ },
/* 6069 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.24 7.76C15.07 6.59 13.54 6 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'TimelapseSharp');
	
	exports.default = _default;

/***/ },
/* 6070 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 3.99c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm4.25 12.24c-2.35 2.34-6.15 2.34-8.49 0L12 11.99v-6c1.54 0 3.07.59 4.24 1.76 2.35 2.34 2.35 6.14.01 8.48z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16.24 7.75c-1.17-1.17-2.7-1.76-4.24-1.76v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48zM12 1.99c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	})), 'TimelapseTwoTone');
	
	exports.default = _default;

/***/ },
/* 6071 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z"
	}), 'Timeline');
	
	exports.default = _default;

/***/ },
/* 6072 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z"
	}), 'TimelineOutlined');
	
	exports.default = _default;

/***/ },
/* 6073 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2zm0 0c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z"
	}), 'TimelineRounded');
	
	exports.default = _default;

/***/ },
/* 6074 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2zm0 0c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z"
	}), 'TimelineSharp');
	
	exports.default = _default;

/***/ },
/* 6075 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z"
	}), 'TimelineTwoTone');
	
	exports.default = _default;

/***/ },
/* 6076 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'Timer');
	
	exports.default = _default;

/***/ },
/* 6077 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M0 7.72V9.4l3-1V18h2V6h-.25L0 7.72zm23.78 6.65c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39 0-.14.03-.28.09-.41.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59C21.49 9.07 21 9 20.46 9c-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.69.23.96c.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02zm-9.96-7.32c-.34-.4-.75-.7-1.23-.88-.47-.18-1.01-.27-1.59-.27-.58 0-1.11.09-1.59.27-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89.48.18 1.01.28 1.59.28.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89.34-.41.6-.94.78-1.6.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59zm-.92 6.17c0 .6-.04 1.11-.12 1.53-.08.42-.2.76-.36 1.02-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02-.09-.42-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52.09-.41.21-.74.38-1 .16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99.08.41.13.92.13 1.52v2.51z"
	}), 'Timer10');
	
	exports.default = _default;

/***/ },
/* 6078 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M-.01 7.72V9.4l3-1V18h2V6h-.25L-.01 7.72zm23.78 6.65c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25s-.23-.19-.28-.3c-.05-.11-.08-.24-.08-.39 0-.14.03-.28.09-.41s.15-.25.27-.34c.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11s.35.17.48.29.22.26.29.42c.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09s-.39-.63-.69-.88c-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21s-.77.33-1.06.57c-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.69.23.96c.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77s-.66.29-1.17.29c-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05s.39.65.7.93c.31.27.69.49 1.15.66s.98.25 1.58.25c.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02zm-9.96-7.32c-.34-.4-.75-.7-1.23-.88-.47-.18-1.01-.27-1.59-.27s-1.11.09-1.59.27c-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89s1.01.28 1.59.28c.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89s.6-.94.78-1.6c.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59zm-.92 6.17c0 .6-.04 1.11-.12 1.53s-.2.76-.36 1.02c-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02s-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52s.21-.74.38-1c.16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99s.13.92.13 1.52v2.51h-.01z"
	}), 'Timer10Outlined');
	
	exports.default = _default;

/***/ },
/* 6079 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M-.01 7.72V9.4l3-1V18h2V6h-.25L-.01 7.72zm23.78 6.65c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25s-.23-.19-.28-.3c-.05-.11-.08-.24-.08-.39 0-.14.03-.28.09-.41s.15-.25.27-.34c.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11s.35.17.48.29.22.26.29.42c.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09s-.39-.63-.69-.88c-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21s-.77.33-1.06.57c-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.69.23.96c.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77s-.66.29-1.17.29c-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05s.39.65.7.93c.31.27.69.49 1.15.66s.98.25 1.58.25c.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02zm-9.96-7.32c-.34-.4-.75-.7-1.23-.88-.47-.18-1.01-.27-1.59-.27s-1.11.09-1.59.27c-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89s1.01.28 1.59.28c.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89s.6-.94.78-1.6c.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59zm-.92 6.17c0 .6-.04 1.11-.12 1.53s-.2.76-.36 1.02c-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02s-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52s.21-.74.38-1c.16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99s.13.92.13 1.52v2.51h-.01z"
	}), 'Timer10Rounded');
	
	exports.default = _default;

/***/ },
/* 6080 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M-.01 7.72V9.4l3-1V18h2V6h-.25L-.01 7.72zm23.78 6.65c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25s-.23-.19-.28-.3c-.05-.11-.08-.24-.08-.39 0-.14.03-.28.09-.41s.15-.25.27-.34c.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11s.35.17.48.29.22.26.29.42c.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09s-.39-.63-.69-.88c-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21s-.77.33-1.06.57c-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.69.23.96c.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77s-.66.29-1.17.29c-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05s.39.65.7.93c.31.27.69.49 1.15.66s.98.25 1.58.25c.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02zm-9.96-7.32c-.34-.4-.75-.7-1.23-.88-.47-.18-1.01-.27-1.59-.27s-1.11.09-1.59.27c-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89s1.01.28 1.59.28c.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89s.6-.94.78-1.6c.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59zm-.92 6.17c0 .6-.04 1.11-.12 1.53s-.2.76-.36 1.02c-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02s-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52s.21-.74.38-1c.16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99s.13.92.13 1.52v2.51h-.01z"
	}), 'Timer10Sharp');
	
	exports.default = _default;

/***/ },
/* 6081 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.99 18h2V6h-.25L-.01 7.72V9.4l3-1zm9.59-11.83c-.47-.18-1.01-.27-1.59-.27s-1.11.09-1.59.27c-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89.48.18 1.01.28 1.59.28.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89.34-.41.6-.94.78-1.6.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59s-.75-.7-1.23-.88zm.32 7.05h-.01c0 .6-.04 1.11-.12 1.53-.08.42-.2.76-.36 1.02-.16.26-.36.45-.59.57s-.51.18-.82.18c-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02-.09-.42-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52.09-.41.21-.74.38-1 .16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99.08.41.13.92.13 1.52v2.51zm10.24.41c-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39 0-.14.03-.28.09-.41.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88s-.66-.44-1.09-.59c-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57s-.51.52-.67.84c-.16.32-.23.65-.23 1.01s.08.69.23.96c.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34s.07.25.07.39c0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19s.8-.31 1.11-.54c.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02-.14-.28-.35-.53-.63-.74z"
	}), 'Timer10TwoTone');
	
	exports.default = _default;

/***/ },
/* 6082 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.61 12.97c-.16-.24-.36-.46-.62-.65-.25-.19-.56-.35-.93-.48.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33.22-.08.46-.12.73-.12.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57-.17.16-.38.28-.63.37-.25.09-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36-.17-.16-.3-.34-.39-.56-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23.49-.15.91-.38 1.26-.68.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76zm9.26 1.4c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39s.03-.28.09-.41c.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.68.23.96c.15.28.37.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z"
	}), 'Timer3');
	
	exports.default = _default;

/***/ },
/* 6083 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.61 12.97c-.16-.24-.36-.46-.62-.65-.25-.19-.56-.35-.93-.48.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33s.46-.12.73-.12c.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57s-.38.28-.63.37-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36s-.3-.34-.39-.56c-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23s.91-.38 1.26-.68c.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76zm9.26 1.4c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25s-.23-.19-.28-.3c-.05-.11-.08-.24-.08-.39s.03-.28.09-.41.15-.25.27-.34c.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11s.35.17.48.29.22.26.29.42c.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09s-.39-.63-.69-.88c-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21s-.77.33-1.06.57c-.29.24-.51.52-.67.84s-.23.65-.23 1.01.08.68.23.96.37.52.64.73c.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77s-.66.29-1.17.29c-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05s.39.65.7.93c.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z"
	}), 'Timer3Outlined');
	
	exports.default = _default;

/***/ },
/* 6084 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.61 12.97c-.16-.24-.36-.46-.62-.65-.25-.19-.56-.35-.93-.48.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33s.46-.12.73-.12c.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57s-.38.28-.63.37-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36s-.3-.34-.39-.56c-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23s.91-.38 1.26-.68c.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76zm9.26 1.4c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25s-.23-.19-.28-.3c-.05-.11-.08-.24-.08-.39s.03-.28.09-.41.15-.25.27-.34c.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11s.35.17.48.29.22.26.29.42c.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09s-.39-.63-.69-.88c-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21s-.77.33-1.06.57c-.29.24-.51.52-.67.84s-.23.65-.23 1.01.08.68.23.96.37.52.64.73c.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77s-.66.29-1.17.29c-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05s.39.65.7.93c.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z"
	}), 'Timer3Rounded');
	
	exports.default = _default;

/***/ },
/* 6085 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.61 12.97c-.16-.24-.36-.46-.62-.65-.25-.19-.56-.35-.93-.48.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33s.46-.12.73-.12c.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57s-.38.28-.63.37-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36s-.3-.34-.39-.56c-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23s.91-.38 1.26-.68c.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76zm9.26 1.4c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25s-.23-.19-.28-.3c-.05-.11-.08-.24-.08-.39s.03-.28.09-.41.15-.25.27-.34c.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11s.35.17.48.29.22.26.29.42c.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09s-.39-.63-.69-.88c-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21s-.77.33-1.06.57c-.29.24-.51.52-.67.84s-.23.65-.23 1.01.08.68.23.96.37.52.64.73c.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77s-.66.29-1.17.29c-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05s.39.65.7.93c.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z"
	}), 'Timer3Sharp');
	
	exports.default = _default;

/***/ },
/* 6086 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.46 10.8c.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29s.22.26.29.42c.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.68.23.96c.15.28.37.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34s.07.25.07.39c0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44s-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23s-.41-.16-.55-.25c-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39s.03-.28.09-.41c.06-.13.15-.25.27-.34zm-8.34 5.71c-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36-.17-.16-.3-.34-.39-.56-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23.49-.15.91-.38 1.26-.68.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76-.16-.24-.36-.46-.62-.65-.25-.19-.56-.35-.93-.48.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33.22-.08.46-.12.73-.12.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57-.17.16-.38.28-.63.37-.25.09-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49z"
	}), 'Timer3TwoTone');
	
	exports.default = _default;

/***/ },
/* 6087 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.04 4.55l-1.42 1.42C16.07 4.74 14.12 4 12 4c-1.83 0-3.53.55-4.95 1.48l1.46 1.46C9.53 6.35 10.73 6 12 6c3.87 0 7 3.13 7 7 0 1.27-.35 2.47-.94 3.49l1.45 1.45C20.45 16.53 21 14.83 21 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42-1.41-1.42zM15 1H9v2h6V1zm-4 8.44l2 2V8h-2v1.44zM3.02 4L1.75 5.27 4.5 8.03C3.55 9.45 3 11.16 3 13c0 4.97 4.02 9 9 9 1.84 0 3.55-.55 4.98-1.5l2.5 2.5 1.27-1.27-7.71-7.71L3.02 4zM12 20c-3.87 0-7-3.13-7-7 0-1.28.35-2.48.95-3.52l9.56 9.56c-1.03.61-2.23.96-3.51.96z"
	}), 'TimerOff');
	
	exports.default = _default;

/***/ },
/* 6088 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 8v.86l2 2V8zM9 1h6v2H9zm3 5c3.87 0 7 3.13 7 7 0 1.12-.27 2.18-.74 3.12l1.47 1.47C20.53 16.25 21 14.68 21 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-1.68 0-3.25.47-4.59 1.27l1.47 1.47c.94-.47 2-.74 3.12-.74zM3.16 3.86L1.75 5.27 4.5 8.02C3.56 9.45 3 11.16 3 13c0 4.97 4.02 9 9 9 1.84 0 3.55-.55 4.98-1.5l2.5 2.5 1.41-1.41L3.16 3.86zM12 20c-3.87 0-7-3.13-7-7 0-1.29.35-2.49.96-3.52l9.57 9.57c-1.04.6-2.24.95-3.53.95z"
	}), 'TimerOffOutlined');
	
	exports.default = _default;

/***/ },
/* 6089 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 3h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1zm2 5c-.51 0-.92.39-.98.89L13 10.86V9c0-.55-.45-1-1-1zm0-2c3.87 0 7 3.13 7 7 0 1.12-.27 2.18-.74 3.12l1.47 1.47C20.53 16.25 21 14.68 21 13c0-2.12-.74-4.07-1.97-5.61l.75-.75c.38-.38.39-1.01 0-1.4l-.01-.01c-.39-.39-1.01-.38-1.4 0l-.75.75C16.07 4.74 14.12 4 12 4c-1.66 0-3.22.48-4.57 1.29l1.45 1.45c.94-.47 2-.74 3.12-.74zm8.19 14.88L3.87 4.56a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l2.07 2.07C3.61 9.42 3.05 11.03 3 12.76 2.87 17.84 6.94 22 12 22c1.84 0 3.55-.55 4.98-1.5l1.79 1.79c.39.39 1.02.39 1.41 0 .4-.39.4-1.02.01-1.41zM12 20c-3.87 0-7-3.13-7-7 0-1.29.35-2.49.96-3.52l9.57 9.57c-1.04.6-2.24.95-3.53.95z"
	}), 'TimerOffRounded');
	
	exports.default = _default;

/***/ },
/* 6090 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6c3.87 0 7 3.13 7 7 0 1.12-.27 2.18-.74 3.12l1.47 1.47C20.53 16.25 21 14.68 21 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-1.68 0-3.25.47-4.59 1.27l1.47 1.47c.94-.47 2-.74 3.12-.74zm-1 2v.86l2 2V8zM9 1h6v2H9zM3.16 3.86L1.75 5.27 4.5 8.02C3.56 9.45 3 11.16 3 13c0 4.97 4.02 9 9 9 1.84 0 3.55-.55 4.98-1.5l2.5 2.5 1.41-1.41L3.16 3.86zM12 20c-3.87 0-7-3.13-7-7 0-1.29.35-2.49.96-3.52l9.57 9.57c-1.04.6-2.24.95-3.53.95z"
	}), 'TimerOffSharp');
	
	exports.default = _default;

/***/ },
/* 6091 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 6c-1.12 0-2.18.27-3.12.74L11 8.86V8h2v2.86l5.26 5.26c.47-.94.74-2 .74-3.12 0-3.87-3.13-7-7-7zm0 14c1.29 0 2.49-.35 3.52-.96L5.96 9.48C5.35 10.51 5 11.71 5 13c0 3.87 3.13 7 7 7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 6c3.87 0 7 3.13 7 7 0 1.12-.27 2.18-.74 3.12l1.47 1.47C20.53 16.25 21 14.68 21 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-1.68 0-3.25.47-4.59 1.27l1.47 1.47c.94-.47 2-.74 3.12-.74zm-1 2v.86l2 2V8zM9 1h6v2H9zM3.16 3.86L1.75 5.27 4.5 8.02C3.56 9.45 3 11.16 3 13c0 4.97 4.02 9 9 9 1.84 0 3.55-.55 4.98-1.5l2.5 2.5 1.41-1.41L3.16 3.86zM12 20c-3.87 0-7-3.13-7-7 0-1.29.35-2.49.96-3.52l9.57 9.57c-1.04.6-2.24.95-3.53.95z"
	})), 'TimerOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 6092 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.07 1.01h-6v2h6v-2zm-4 13h2v-6h-2v6zm8.03-6.62l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.14 4.74 14.19 4 12.07 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.11-.74-4.06-1.97-5.61zm-7.03 12.62c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'TimerOutlined');
	
	exports.default = _default;

/***/ },
/* 6093 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 1h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1zm-2 13c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1zm7.03-6.61l.75-.75c.38-.38.39-1.01 0-1.4l-.01-.01c-.39-.39-1.01-.38-1.4 0l-.75.75C16.07 4.74 14.12 4 12 4c-4.8 0-8.88 3.96-9 8.76C2.87 17.84 6.94 22 12 22c4.98 0 9-4.03 9-9 0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'TimerRounded');
	
	exports.default = _default;

/***/ },
/* 6094 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	}), 'TimerSharp');
	
	exports.default = _default;

/***/ },
/* 6095 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12.07 6.01c-3.87 0-7 3.13-7 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm1 8h-2v-6h2v6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M9.07 1.01h6v2h-6zm2 7h2v6h-2zm8.03-.62l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.14 4.74 14.19 4 12.07 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.11-.74-4.07-1.97-5.61zm-7.03 12.62c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
	})), 'TimerTwoTone');
	
	exports.default = _default;

/***/ },
/* 6096 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 4v3h5.5v12h3V7H19V4z"
	}), 'Title');
	
	exports.default = _default;

/***/ },
/* 6097 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 4v3h5.5v12h3V7H19V4H5z"
	}), 'TitleOutlined');
	
	exports.default = _default;

/***/ },
/* 6098 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 5.5C5 6.33 5.67 7 6.5 7h4v10.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V7h4c.83 0 1.5-.67 1.5-1.5S18.33 4 17.5 4h-11C5.67 4 5 4.67 5 5.5z"
	}), 'TitleRounded');
	
	exports.default = _default;

/***/ },
/* 6099 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 4v3h5.5v12h3V7H19V4H5z"
	}), 'TitleSharp');
	
	exports.default = _default;

/***/ },
/* 6100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 7h5.5v12h3V7H19V4H5z"
	}), 'TitleTwoTone');
	
	exports.default = _default;

/***/ },
/* 6101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z"
	}), 'Toc');
	
	exports.default = _default;

/***/ },
/* 6102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z"
	}), 'TocOutlined');
	
	exports.default = _default;

/***/ },
/* 6103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 9h12c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0 4h12c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0 4h12c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm15 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z"
	}), 'TocRounded');
	
	exports.default = _default;

/***/ },
/* 6104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2zM3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z"
	}), 'TocSharp');
	
	exports.default = _default;

/***/ },
/* 6105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z"
	}), 'TocTwoTone');
	
	exports.default = _default;

/***/ },
/* 6106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"
	}), 'Today');
	
	exports.default = _default;

/***/ },
/* 6107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2zM7 11h5v5H7z"
	}), 'TodayOutlined');
	
	exports.default = _default;

/***/ },
/* 6108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1H8V2c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 16H6c-.55 0-1-.45-1-1V8h14v10c0 .55-.45 1-1 1zM8 10h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1z"
	}), 'TodayRounded');
	
	exports.default = _default;

/***/ },
/* 6109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3h-3V1h-2v2H8V1H6v2H3v18h18V3zm-2 16H5V8h14v11zM7 10h5v5H7v-5z"
	}), 'TodaySharp');
	
	exports.default = _default;

/***/ },
/* 6110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2zm-7 4H7v5h5v-5z"
	}), _react.default.createElement("path", {
	  d: "M5 5h14v2H5z",
	  opacity: ".3"
	})), 'TodayTwoTone');
	
	exports.default = _default;

/***/ },
/* 6111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h10c2.76 0 5-2.24 5-5s-2.24-5-5-5zM7 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
	}), 'ToggleOff');
	
	exports.default = _default;

/***/ },
/* 6112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 6H7c-3.31 0-6 2.69-6 6s2.69 6 6 6h10c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 10H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4zM7 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
	}), 'ToggleOffOutlined');
	
	exports.default = _default;

/***/ },
/* 6113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h10c2.76 0 5-2.24 5-5s-2.24-5-5-5zM7 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
	}), 'ToggleOffRounded');
	
	exports.default = _default;

/***/ },
/* 6114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h10c2.76 0 5-2.24 5-5s-2.24-5-5-5zM7 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
	}), 'ToggleOffSharp');
	
	exports.default = _default;

/***/ },
/* 6115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17 8H7c-2.21 0-4 1.79-4 4s1.79 4 4 4h10c2.21 0 4-1.79 4-4s-1.79-4-4-4zM7 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 6H7c-3.31 0-6 2.69-6 6s2.69 6 6 6h10c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 10H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4zM7 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
	})), 'ToggleOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 6116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h10c2.76 0 5-2.24 5-5s-2.24-5-5-5zm0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
	}), 'ToggleOn');
	
	exports.default = _default;

/***/ },
/* 6117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 6H7c-3.31 0-6 2.69-6 6s2.69 6 6 6h10c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 10H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4zm0-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
	}), 'ToggleOnOutlined');
	
	exports.default = _default;

/***/ },
/* 6118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h10c2.76 0 5-2.24 5-5s-2.24-5-5-5zm0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
	}), 'ToggleOnRounded');
	
	exports.default = _default;

/***/ },
/* 6119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h10c2.76 0 5-2.24 5-5s-2.24-5-5-5zm0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
	}), 'ToggleOnSharp');
	
	exports.default = _default;

/***/ },
/* 6120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17 8H7c-2.21 0-4 1.79-4 4s1.79 4 4 4h10c2.21 0 4-1.79 4-4s-1.79-4-4-4zm0 7c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 6H7c-3.31 0-6 2.69-6 6s2.69 6 6 6h10c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 10H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4zm0-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
	})), 'ToggleOnTwoTone');
	
	exports.default = _default;

/***/ },
/* 6121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12c0-2.61 1.67-4.83 4-5.65V4.26C3.55 5.15 1 8.27 1 12s2.55 6.85 6 7.74v-2.09c-2.33-.82-4-3.04-4-5.65z"
	}), 'Toll');
	
	exports.default = _default;

/***/ },
/* 6122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12c0-2.61 1.67-4.83 4-5.65V4.26C3.55 5.15 1 8.27 1 12s2.55 6.85 6 7.74v-2.09c-2.33-.82-4-3.04-4-5.65z"
	}), 'TollOutlined');
	
	exports.default = _default;

/***/ },
/* 6123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12c0-2.39 1.4-4.46 3.43-5.42.34-.16.57-.47.57-.84v-.19c0-.68-.71-1.11-1.32-.82C2.92 5.99 1 8.77 1 12s1.92 6.01 4.68 7.27c.61.28 1.32-.14 1.32-.82v-.18c0-.37-.23-.69-.57-.85C4.4 16.46 3 14.39 3 12z"
	}), 'TollRounded');
	
	exports.default = _default;

/***/ },
/* 6124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12c0-2.61 1.67-4.83 4-5.65V4.26C3.55 5.15 1 8.27 1 12s2.55 6.85 6 7.74v-2.09c-2.33-.82-4-3.04-4-5.65z"
	}), 'TollSharp');
	
	exports.default = _default;

/***/ },
/* 6125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12c0-2.61 1.67-4.83 4-5.65V4.26C3.55 5.15 1 8.27 1 12c0 3.73 2.55 6.85 6 7.74v-2.09c-2.33-.82-4-3.04-4-5.65z"
	})), 'TollTwoTone');
	
	exports.default = _default;

/***/ },
/* 6126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z"
	}), 'Tonality');
	
	exports.default = _default;

/***/ },
/* 6127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z"
	}), 'TonalityOutlined');
	
	exports.default = _default;

/***/ },
/* 6128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z"
	}), 'TonalityRounded');
	
	exports.default = _default;

/***/ },
/* 6129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z"
	}), 'TonalitySharp');
	
	exports.default = _default;

/***/ },
/* 6130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 12c0 4.08 3.06 7.44 7 7.93V4.07C7.05 4.56 4 7.92 4 12z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z"
	})), 'TonalityTwoTone');
	
	exports.default = _default;

/***/ },
/* 6131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9 11.24V7.5C9 6.12 10.12 5 11.5 5S14 6.12 14 7.5v3.74c1.21-.81 2-2.18 2-3.74C16 5.01 13.99 3 11.5 3S7 5.01 7 7.5c0 1.56.79 2.93 2 3.74zm9.84 4.63l-4.54-2.26c-.17-.07-.35-.11-.54-.11H13v-6c0-.83-.67-1.5-1.5-1.5S10 6.67 10 7.5v10.74c-3.6-.76-3.54-.75-3.67-.75-.31 0-.59.13-.79.33l-.79.8 4.94 4.94c.27.27.65.44 1.06.44h6.79c.75 0 1.33-.55 1.44-1.28l.75-5.27c.01-.07.02-.14.02-.2 0-.62-.38-1.16-.91-1.38z"
	}), 'TouchApp');
	
	exports.default = _default;

/***/ },
/* 6132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.19 12.44l-3.24-1.62c1.29-1 2.12-2.56 2.12-4.32 0-3.03-2.47-5.5-5.5-5.5s-5.5 2.47-5.5 5.5c0 2.13 1.22 3.98 3 4.89v3.26c-2.15-.46-2.02-.44-2.26-.44-.53 0-1.03.21-1.41.59L4 16.22l5.09 5.09c.43.44 1.03.69 1.65.69h6.3c.98 0 1.81-.7 1.97-1.67l.8-4.71c.22-1.3-.43-2.58-1.62-3.18zm-.35 2.85l-.8 4.71h-6.3c-.09 0-.17-.04-.24-.1l-3.68-3.68 4.25.89V6.5c0-.28.22-.5.5-.5s.5.22.5.5v6h1.76l3.46 1.73c.4.2.62.63.55 1.06zM8.07 6.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5c0 .95-.38 1.81-1 2.44V6.5c0-1.38-1.12-2.5-2.5-2.5s-2.5 1.12-2.5 2.5v2.44c-.62-.63-1-1.49-1-2.44z"
	}), 'TouchAppOutlined');
	
	exports.default = _default;

/***/ },
/* 6133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.79 9.24V5.5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v3.74c1.21-.81 2-2.18 2-3.74 0-2.49-2.01-4.5-4.5-4.5s-4.5 2.01-4.5 4.5c0 1.56.79 2.93 2 3.74zm5.5 2.47c-.28-.14-.58-.21-.89-.21h-.61v-6c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v10.74l-3.44-.72c-.37-.08-.76.04-1.03.31-.43.44-.43 1.14 0 1.58l4.01 4.01c.38.37.89.58 1.42.58h6.1c1 0 1.84-.73 1.98-1.72l.63-4.47c.12-.85-.32-1.69-1.09-2.07l-4.08-2.03z"
	}), 'TouchAppRounded');
	
	exports.default = _default;

/***/ },
/* 6134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.25 9.24V5.5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v3.74c1.21-.81 2-2.18 2-3.74 0-2.49-2.01-4.5-4.5-4.5s-4.5 2.01-4.5 4.5c0 1.56.79 2.93 2 3.74zm5.08 2.26h-1.08v-6c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v10.74l-4.04-.85L4 16.62 9.38 22h8.67l1.07-7.62-5.79-2.88z"
	}), 'TouchAppSharp');
	
	exports.default = _default;

/***/ },
/* 6135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18.19 12.44l-3.24-1.62c1.29-1 2.12-2.56 2.12-4.32 0-3.03-2.47-5.5-5.5-5.5s-5.5 2.47-5.5 5.5c0 2.13 1.22 3.98 3 4.89v3.26c-2.08-.44-2.01-.44-2.26-.44-.53 0-1.03.21-1.41.59L4 16.22l5.09 5.09c.43.44 1.03.69 1.65.69h6.3c.98 0 1.81-.7 1.97-1.67l.8-4.71c.22-1.3-.43-2.58-1.62-3.18zM8.07 6.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5c0 .95-.38 1.81-1 2.44V6.5c0-1.38-1.12-2.5-2.5-2.5s-2.5 1.12-2.5 2.5v2.44c-.62-.63-1-1.49-1-2.44zm9.77 8.79l-.8 4.71h-6.3c-.09 0-.17-.04-.24-.1l-3.68-3.68 4.25.89V6.5c0-.28.22-.5.5-.5s.5.22.5.5v6h1.76l3.46 1.73c.4.2.62.63.55 1.06z"
	}), _react.default.createElement("path", {
	  d: "M17.3 14.23l-3.46-1.73h-1.77v-6c0-.28-.22-.5-.5-.5s-.5.22-.5.5v10.61l-4.25-.89 3.68 3.68c.06.06.15.1.24.1h6.3l.8-4.71c.07-.43-.15-.86-.54-1.06z",
	  opacity: ".3"
	})), 'TouchAppTwoTone');
	
	exports.default = _default;

/***/ },
/* 6136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 12c0-3 2.5-5.5 5.5-5.5S23 9 23 12H12zm0 0c0 3-2.5 5.5-5.5 5.5S1 15 1 12h11zm0 0c-3 0-5.5-2.5-5.5-5.5S9 1 12 1v11zm0 0c3 0 5.5 2.5 5.5 5.5S15 23 12 23V12z"
	}), 'Toys');
	
	exports.default = _default;

/***/ },
/* 6137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 23h-1v-6.57C9.93 17.4 8.52 18 7 18c-3.25 0-6-2.75-6-6v-1h6.57C6.6 9.93 6 8.52 6 7c0-3.25 2.75-6 6-6h1v6.57C14.07 6.6 15.48 6 17 6c3.25 0 6 2.75 6 6v1h-6.57c.97 1.07 1.57 2.48 1.57 4 0 3.25-2.75 6-6 6zm1-9.87v7.74c1.7-.46 3-2.04 3-3.87s-1.3-3.41-3-3.87zM3.13 13c.46 1.7 2.04 3 3.87 3s3.41-1.3 3.87-3H3.13zm10-2h7.74c-.46-1.7-2.05-3-3.87-3s-3.41 1.3-3.87 3zM11 3.13C9.3 3.59 8 5.18 8 7s1.3 3.41 3 3.87V3.13z"
	}), 'ToysOutlined');
	
	exports.default = _default;

/***/ },
/* 6138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 12c0-3 2.5-5.5 5.5-5.5 2.57 0 4.77 1.83 5.35 4.24.15.64-.32 1.26-.97 1.26H12zm0 0c0 3-2.5 5.5-5.5 5.5-2.57 0-4.77-1.83-5.35-4.24-.15-.64.32-1.26.97-1.26H12zm0 0c-3 0-5.5-2.5-5.5-5.5 0-2.57 1.83-4.77 4.24-5.35.64-.15 1.26.32 1.26.97V12zm0 0c3 0 5.5 2.5 5.5 5.5 0 2.57-1.83 4.77-4.24 5.35-.64.15-1.26-.32-1.26-.97V12z"
	}), 'ToysRounded');
	
	exports.default = _default;

/***/ },
/* 6139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 12c0-3 2.5-5.5 5.5-5.5S23 9 23 12H12zm0 0c0 3-2.5 5.5-5.5 5.5S1 15 1 12h11zm0 0c-3 0-5.5-2.5-5.5-5.5S9 1 12 1v11zm0 0c3 0 5.5 2.5 5.5 5.5S15 23 12 23V12z"
	}), 'ToysSharp');
	
	exports.default = _default;

/***/ },
/* 6140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 16c1.82 0 3.41-1.3 3.87-3H3.13c.46 1.7 2.05 3 3.87 3zm1-9c0 1.82 1.3 3.41 3 3.87V3.13C9.3 3.59 8 5.18 8 7zm9 1c-1.82 0-3.41 1.3-3.87 3h7.74c-.46-1.7-2.05-3-3.87-3zm-4 5.13v7.74c1.7-.46 3-2.04 3-3.87s-1.3-3.41-3-3.87z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M23 12c0-3.25-2.75-6-6-6-1.52 0-2.93.6-4 1.57V1h-1C8.75 1 6 3.75 6 7c0 1.52.6 2.93 1.57 4H1v1c0 3.25 2.75 6 6 6 1.52 0 2.93-.6 4-1.57V23h1c3.25 0 6-2.75 6-6 0-1.52-.6-2.93-1.57-4H23v-1zM7 16c-1.82 0-3.41-1.3-3.87-3h7.74c-.46 1.7-2.05 3-3.87 3zm4-5.13C9.3 10.41 8 8.82 8 7s1.3-3.41 3-3.87v7.74zm2 10v-7.74c1.7.46 3 2.04 3 3.87s-1.3 3.41-3 3.87zm.13-9.87c.46-1.7 2.04-3 3.87-3s3.41 1.3 3.87 3h-7.74z"
	})), 'ToysTwoTone');
	
	exports.default = _default;

/***/ },
/* 6141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.07 4.93l-1.41 1.41C19.1 7.79 20 9.79 20 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z"
	}), 'TrackChanges');
	
	exports.default = _default;

/***/ },
/* 6142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.07 4.93l-1.41 1.41C19.1 7.79 20 9.79 20 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z"
	}), 'TrackChangesOutlined');
	
	exports.default = _default;

/***/ },
/* 6143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.32 5.68c-.36.36-.39.92-.07 1.32 1.45 1.82 2.21 4.31 1.53 6.92-.79 3.05-3.18 5.33-6.21 5.94C8.47 20.87 4 16.93 4 12c0-4.08 3.05-7.44 7-7.93v2.02c-3.13.53-5.43 3.46-4.93 6.83.39 2.61 2.56 4.71 5.18 5.03C14.89 18.4 18 15.56 18 12c0-1.25-.38-2.4-1.03-3.36-.34-.5-1.07-.53-1.5-.11l-.01.01c-.34.34-.37.87-.11 1.27.6.92.84 2.1.49 3.32-.39 1.37-1.54 2.46-2.94 2.77-2.6.57-4.9-1.39-4.9-3.9 0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2.71c0-.39-.32-.71-.71-.71-5.36-.2-9.98 4.06-10.27 9.4-.36 6.55 5.41 11.82 12.01 10.4 3.88-.83 6.88-3.8 7.75-7.67.71-3.16-.2-6.16-1.97-8.37-.37-.47-1.07-.5-1.49-.08z"
	}), 'TrackChangesRounded');
	
	exports.default = _default;

/***/ },
/* 6144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.07 4.93l-1.41 1.41C19.1 7.79 20 9.79 20 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z"
	}), 'TrackChangesSharp');
	
	exports.default = _default;

/***/ },
/* 6145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.07 4.93l-1.41 1.41C19.1 7.79 20 9.79 20 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z"
	}), 'TrackChangesTwoTone');
	
	exports.default = _default;

/***/ },
/* 6146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-8 9c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2 0-1.11.89-2 2-2 1.1 0 2 .89 2 2 0 1.1-.89 2-2 2z"
	}), 'Traffic');
	
	exports.default = _default;

/***/ },
/* 6147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-5 9H9V5h6v14zm-3-1c.83 0 1.5-.67 1.5-1.5S12.83 15 12 15s-1.5.67-1.5 1.5.67 1.5 1.5 1.5zm0-4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM12 9c.83 0 1.5-.67 1.5-1.5S12.83 6 12 6s-1.5.67-1.5 1.5S11.17 9 12 9z"
	}), 'TrafficOutlined');
	
	exports.default = _default;

/***/ },
/* 6148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.96 10.59c.04-.31-.19-.59-.5-.59H17V8.86c1.54-.4 2.72-1.68 2.96-3.27.04-.31-.19-.59-.5-.59H17V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4.54c-.31 0-.54.28-.5.59C4.28 7.18 5.46 8.46 7 8.86V10H4.54c-.31 0-.54.28-.5.59.24 1.59 1.42 2.87 2.96 3.27V15H4.54c-.31 0-.54.28-.5.59.24 1.59 1.42 2.87 2.96 3.27V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.54-.4 2.72-1.68 2.96-3.27.04-.31-.19-.59-.5-.59H17v-1.14c1.54-.4 2.72-1.68 2.96-3.27zM12 19c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2 0-1.11.89-2 2-2 1.1 0 2 .89 2 2 0 1.1-.89 2-2 2z"
	}), 'TrafficRounded');
	
	exports.default = _default;

/***/ },
/* 6149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V3H7v2H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V21h10v-2.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-8 9c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2 0-1.11.89-2 2-2 1.1 0 2 .89 2 2 0 1.1-.89 2-2 2z"
	}), 'TrafficSharp');
	
	exports.default = _default;

/***/ },
/* 6150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9 19h6V5H9v14zm3-13c.83 0 1.5.67 1.5 1.5S12.83 9 12 9s-1.5-.67-1.5-1.5S11.17 6 12 6zm0 4.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm0 4.5c.83 0 1.5.67 1.5 1.5S12.83 18 12 18s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 5h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86h-3V8.86c1.72-.45 3-2 3-3.86zm-5 14H9V5h6v14zm-3-1c.83 0 1.5-.67 1.5-1.5S12.83 15 12 15s-1.5.67-1.5 1.5.67 1.5 1.5 1.5zm0-4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM12 9c.83 0 1.5-.67 1.5-1.5S12.83 6 12 6s-1.5.67-1.5 1.5S11.17 9 12 9z"
	})), 'TrafficTwoTone');
	
	exports.default = _default;

/***/ },
/* 6151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'Train');
	
	exports.default = _default;

/***/ },
/* 6152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "14.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "14.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2l2-2h4l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-4-4-8-4zm0 2c3.51 0 4.96.48 5.57 1H6.43c.61-.52 2.06-1 5.57-1zM6 7h5v3H6V7zm12 8.5c0 .83-.67 1.5-1.5 1.5h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5zm0-5.5h-5V7h5v3z"
	})), 'TrainOutlined');
	
	exports.default = _default;

/***/ },
/* 6153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19l-1.15 1.15c-.31.31-.09.85.36.85H7.8c.13 0 .26-.05.35-.15L10 19h4l1.85 1.85c.09.09.22.15.35.15h1.09c.45 0 .67-.54.35-.85L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-4-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm5.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-7h-5V6h5v4z"
	}), 'TrainRounded');
	
	exports.default = _default;

/***/ },
/* 6154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2l2-2h4l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-4-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm5.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-7h-5V6h5v4z"
	}), 'TrainSharp');
	
	exports.default = _default;

/***/ },
/* 6155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-3.51 0-4.96.48-5.57 1h11.13c-.6-.52-2.05-1-5.56-1zM6 15.5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V12H6v3.5zm9.5-2.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-7 0c.83 0 1.5.67 1.5 1.5S9.33 16 8.5 16 7 15.33 7 14.5 7.67 13 8.5 13z",
	  opacity: ".3"
	}), _react.default.createElement("circle", {
	  cx: "8.5",
	  cy: "14.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "15.5",
	  cy: "14.5",
	  r: "1.5"
	}), _react.default.createElement("path", {
	  d: "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2l2-2h4l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-4-4-8-4zm0 2c3.51 0 4.96.48 5.57 1H6.43c.61-.52 2.06-1 5.57-1zM6 7h5v3H6V7zm12 8.5c0 .83-.67 1.5-1.5 1.5h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5zm0-5.5h-5V7h5v3z"
	})), 'TrainTwoTone');
	
	exports.default = _default;

/***/ },
/* 6156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 16.94V8.5c0-2.79-2.61-3.4-6.01-3.49l.76-1.51H17V2H7v1.5h4.75l-.76 1.52C7.86 5.11 5 5.73 5 8.5v8.44c0 1.45 1.19 2.66 2.59 2.97L6 21.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 20h-.08c1.69 0 2.58-1.37 2.58-3.06zm-7 1.56c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5-4.5H7V9h10v5z"
	}), 'Tram');
	
	exports.default = _default;

/***/ },
/* 6157 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 5l.75-1.5H17V2H7v1.5h4.75L11 5c-3.13.09-6 .73-6 3.5V17c0 1.5 1.11 2.73 2.55 2.95L6 21.5v.5h2l2-2h4l2 2h2v-.5l-1.55-1.55h-.01.01C17.89 19.73 19 18.5 19 17V8.5c0-2.77-2.87-3.41-6-3.5zm-1.97 2h1.94c2.75.08 3.62.58 3.9 1H7.13c.28-.42 1.15-.92 3.9-1zm-.18 10.95H7.74C7.3 17.84 7 17.45 7 17v-1h3.89c-.24.27-.39.61-.39 1 0 .36.13.69.35.95zM17 17c0 .45-.3.84-.74.95h-3.11c.22-.26.35-.59.35-.95 0-.39-.15-.73-.39-1H17v1zm0-3H7v-4h10v4z"
	}), 'TramOutlined');
	
	exports.default = _default;

/***/ },
/* 6158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 5l.75-1.5H17V2H7v1.5h4.75L11 5c-3.13.09-6 .73-6 3.5V17c0 1.5 1.11 2.73 2.55 2.95l-1.19 1.19c-.32.32-.1.86.35.86H7.8c.13 0 .26-.05.35-.15L10 20h4l1.85 1.85c.09.09.22.15.35.15h1.09c.45 0 .67-.54.35-.85l-1.19-1.19C17.89 19.73 19 18.5 19 17V8.5c0-2.77-2.87-3.41-6-3.5zm-1 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5-4.5H7V9h10v5z"
	}), 'TramRounded');
	
	exports.default = _default;

/***/ },
/* 6159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 5l.75-1.5H17V2H7v1.5h4.75L11 5c-3.13.09-6 .73-6 3.5V17c0 1.5 1.11 2.73 2.55 2.95L6 21.5v.5h2l2-2h4l2 2h2v-.5l-1.55-1.55C17.89 19.73 19 18.5 19 17V8.5c0-2.77-2.87-3.41-6-3.5zm-1 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5-4.5H7V9h10v5z"
	}), 'TramSharp');
	
	exports.default = _default;

/***/ },
/* 6160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12.97 7h-1.94c-2.75.08-3.62.58-3.9 1h9.74c-.28-.42-1.15-.92-3.9-1zM7 16v1c0 .45.3.84.74.95h3.11c-.22-.26-.35-.59-.35-.95 0-.39.15-.73.39-1H7zm6.5 1c0 .36-.13.69-.35.95h3.11c.44-.11.74-.5.74-.95v-1h-3.89c.24.27.39.61.39 1z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M13 5l.75-1.5H17V2H7v1.5h4.75L11 5c-3.13.09-6 .73-6 3.5V17c0 1.5 1.11 2.73 2.55 2.95L6 21.5v.5h2l2-2h4l2 2h2v-.5l-1.55-1.55h-.01.01C17.89 19.73 19 18.5 19 17V8.5c0-2.77-2.87-3.41-6-3.5zm-1.97 2h1.94c2.75.08 3.62.58 3.9 1H7.13c.28-.42 1.15-.92 3.9-1zm-.18 10.95H7.74C7.3 17.84 7 17.45 7 17v-1h3.89c-.24.27-.39.61-.39 1 0 .36.13.69.35.95zM17 17c0 .45-.3.84-.74.95h-3.11c.22-.26.35-.59.35-.95 0-.39-.15-.73-.39-1H17v1zm0-3H7v-4h10v4z"
	})), 'TramTwoTone');
	
	exports.default = _default;

/***/ },
/* 6161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.49 15.5v-1.75L14 16.25l2.49 2.5V17H22v-1.5zm3.02 4.25H14v1.5h5.51V23L22 20.5 19.51 18zM9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75"
	}), 'TransferWithinAStation');
	
	exports.default = _default;

/***/ },
/* 6162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.49 15.5v-1.75L14 16.25l2.49 2.5V17H22v-1.5h-5.51zm3.02 4.25H14v1.5h5.51V23L22 20.5 19.51 18v1.75zM9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75"
	}), 'TransferWithinAStationOutlined');
	
	exports.default = _default;

/***/ },
/* 6163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 15.5h-5.52v-.77c0-.36-.44-.54-.69-.29l-1.51 1.52c-.16.16-.16.41 0 .57l1.51 1.52c.26.26.69.08.69-.29V17H22v-1.5zm-.28 4.71l-1.51-1.52c-.26-.26-.69-.08-.69.29v.77H14v1.5h5.52v.77c0 .36.44.54.69.29l1.51-1.52c.16-.16.16-.42 0-.58zM9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3.23 21.81c-.12.62.35 1.19.98 1.19h.09c.47 0 .88-.33.98-.79L6.85 15 9 17v5c0 .55.45 1 1 1s1-.45 1-1v-5.72c0-.53-.21-1.04-.59-1.41L8.95 13.4l.6-3c1.07 1.32 2.58 2.23 4.31 2.51.6.1 1.14-.39 1.14-1 0-.49-.36-.9-.84-.98-1.49-.25-2.75-1.15-3.51-2.38l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L3.24 7.79C2.49 8.1 2 8.83 2 9.64V12c0 .55.45 1 1 1s1-.45 1-1V9.65l1.75-.75"
	}), 'TransferWithinAStationRounded');
	
	exports.default = _default;

/***/ },
/* 6164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.49 15.5v-1.75L14 16.25l2.49 2.5V17H22v-1.5h-5.51zm3.02 4.25H14v1.5h5.51V23L22 20.5 19.51 18v1.75zM9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75"
	}), 'TransferWithinAStationSharp');
	
	exports.default = _default;

/***/ },
/* 6165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.49 13.75L14 16.25l2.49 2.5V17H22v-1.5h-5.51zm3.02 6H14v1.5h5.51V23L22 20.5 19.51 18zM7.5 3.5c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2zm2.05 6.9C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3z"
	}), 'TransferWithinAStationTwoTone');
	
	exports.default = _default;

/***/ },
/* 6166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2z"
	}), 'Transform');
	
	exports.default = _default;

/***/ },
/* 6167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2z"
	}), 'TransformOutlined');
	
	exports.default = _default;

/***/ },
/* 6168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 16H9c-.55 0-1-.45-1-1V4h.79c.45 0 .67-.54.35-.85l-1.79-1.8c-.2-.2-.51-.2-.71 0l-1.79 1.8c-.31.31-.09.85.36.85H6v2H3c-.55 0-1 .45-1 1s.45 1 1 1h3v8c0 1.1.9 2 2 2h8v2h-.79c-.45 0-.67.54-.35.85l1.79 1.79c.2.2.51.2.71 0l1.79-1.79c.32-.31.09-.85-.35-.85H18v-2h3c.55 0 1-.45 1-1s-.45-1-1-1zm-5-2h2V8c0-1.1-.9-2-2-2h-6v2h5c.55 0 1 .45 1 1v5z"
	}), 'TransformRounded');
	
	exports.default = _default;

/***/ },
/* 6169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v10h10v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V6h-8v2z"
	}), 'TransformSharp');
	
	exports.default = _default;

/***/ },
/* 6170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4v-2H8V4zm10 10V8c0-1.1-.9-2-2-2h-6v2h6v6h2z"
	}), 'TransformTwoTone');
	
	exports.default = _default;

/***/ },
/* 6171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 18H6V8h3v4.77L15.98 6 18 8.03 11.15 15H16v3z"
	}), 'TransitEnterexit');
	
	exports.default = _default;

/***/ },
/* 6172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 18H6V8h3v4.77L15.98 6 18 8.03 11.15 15H16v3z"
	}), 'TransitEnterexitOutlined');
	
	exports.default = _default;

/***/ },
/* 6173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.5 18H8c-1.1 0-2-.9-2-2V9.5C6 8.67 6.67 8 7.5 8S9 8.67 9 9.5v3.27L14.95 7c.57-.55 1.48-.54 2.04.02s.56 1.47.01 2.04L11.15 15h3.35c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
	}), 'TransitEnterexitRounded');
	
	exports.default = _default;

/***/ },
/* 6174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 18H6V8h3v4.77L15.98 6 18 8.03 11.15 15H16v3z"
	}), 'TransitEnterexitSharp');
	
	exports.default = _default;

/***/ },
/* 6175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.98 6L9 12.77V8H6v10h10v-3h-4.85L18 8.03z"
	}), 'TransitEnterexitTwoTone');
	
	exports.default = _default;

/***/ },
/* 6176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
	}), 'Translate');
	
	exports.default = _default;

/***/ },
/* 6177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
	}), 'TranslateOutlined');
	
	exports.default = _default;

/***/ },
/* 6178 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.65 15.67c.14-.36.05-.77-.23-1.05l-2.09-2.06.03-.03c1.74-1.94 2.98-4.17 3.71-6.53h1.94c.54 0 .99-.45.99-.99v-.02c0-.54-.45-.99-.99-.99H10V3c0-.55-.45-1-1-1s-1 .45-1 1v1H1.99c-.54 0-.99.45-.99.99 0 .55.45.99.99.99h10.18C11.5 7.92 10.44 9.75 9 11.35c-.81-.89-1.49-1.86-2.06-2.88-.16-.29-.45-.47-.78-.47-.69 0-1.13.75-.79 1.35.63 1.13 1.4 2.21 2.3 3.21L3.3 16.87c-.4.39-.4 1.03 0 1.42.39.39 1.02.39 1.42 0L9 14l2.02 2.02c.51.51 1.38.32 1.63-.35zM17.5 10c-.6 0-1.14.37-1.35.94l-3.67 9.8c-.24.61.22 1.26.87 1.26.39 0 .74-.24.88-.61l.89-2.39h4.75l.9 2.39c.14.36.49.61.88.61.65 0 1.11-.65.88-1.26l-3.67-9.8c-.22-.57-.76-.94-1.36-.94zm-1.62 7l1.62-4.33L19.12 17h-3.24z"
	}), 'TranslateRounded');
	
	exports.default = _default;

/***/ },
/* 6179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
	}), 'TranslateSharp');
	
	exports.default = _default;

/***/ },
/* 6180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
	}), 'TranslateTwoTone');
	
	exports.default = _default;

/***/ },
/* 6181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z"
	}), 'TrendingDown');
	
	exports.default = _default;

/***/ },
/* 6182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6h-6z"
	}), 'TrendingDownOutlined');
	
	exports.default = _default;

/***/ },
/* 6183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.85 17.15l1.44-1.44-4.88-4.88-3.29 3.29c-.39.39-1.02.39-1.41 0l-6-6.01a.9959.9959 0 010-1.41c.39-.39 1.02-.39 1.41 0L9.41 12l3.29-3.29c.39-.39 1.02-.39 1.41 0l5.59 5.58 1.44-1.44c.31-.31.85-.09.85.35v4.29c0 .28-.22.5-.5.5H17.2c-.44.01-.66-.53-.35-.84z"
	}), 'TrendingDownRounded');
	
	exports.default = _default;

/***/ },
/* 6184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6h-6z"
	}), 'TrendingDownSharp');
	
	exports.default = _default;

/***/ },
/* 6185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6h-6z"
	}), 'TrendingDownTwoTone');
	
	exports.default = _default;

/***/ },
/* 6186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 12l-4-4v3H3v2h15v3z"
	}), 'TrendingFlat');
	
	exports.default = _default;

/***/ },
/* 6187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 12l-4-4v3H3v2h15v3l4-4z"
	}), 'TrendingFlatOutlined');
	
	exports.default = _default;

/***/ },
/* 6188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.65 11.65l-2.79-2.79c-.32-.32-.86-.1-.86.35V11H4c-.55 0-1 .45-1 1s.45 1 1 1h14v1.79c0 .45.54.67.85.35l2.79-2.79c.2-.19.2-.51.01-.7z"
	}), 'TrendingFlatRounded');
	
	exports.default = _default;

/***/ },
/* 6189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 12l-4-4v3H3v2h15v3l4-4z"
	}), 'TrendingFlatSharp');
	
	exports.default = _default;

/***/ },
/* 6190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 12l-4-4v3H3v2h15v3l4-4z"
	}), 'TrendingFlatTwoTone');
	
	exports.default = _default;

/***/ },
/* 6191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
	}), 'TrendingUp');
	
	exports.default = _default;

/***/ },
/* 6192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6h-6z"
	}), 'TrendingUpOutlined');
	
	exports.default = _default;

/***/ },
/* 6193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.85 6.85l1.44 1.44-4.88 4.88-3.29-3.29a.9959.9959 0 00-1.41 0l-6 6.01c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L9.41 12l3.29 3.29c.39.39 1.02.39 1.41 0l5.59-5.58 1.44 1.44c.31.31.85.09.85-.35V6.5c.01-.28-.21-.5-.49-.5h-4.29c-.45 0-.67.54-.36.85z"
	}), 'TrendingUpRounded');
	
	exports.default = _default;

/***/ },
/* 6194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6h-6z"
	}), 'TrendingUpSharp');
	
	exports.default = _default;

/***/ },
/* 6195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6h-6z"
	}), 'TrendingUpTwoTone');
	
	exports.default = _default;

/***/ },
/* 6196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm10 6c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6z"
	}), 'TripOrigin');
	
	exports.default = _default;

/***/ },
/* 6197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm10 6c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6z"
	}), 'TripOriginOutlined');
	
	exports.default = _default;

/***/ },
/* 6198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm10 6c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6z"
	}), 'TripOriginRounded');
	
	exports.default = _default;

/***/ },
/* 6199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm10 6c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6z"
	}), 'TripOriginSharp');
	
	exports.default = _default;

/***/ },
/* 6200 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
	}), 'TripOriginTwoTone');
	
	exports.default = _default;

/***/ },
/* 6201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
	}), 'Tune');
	
	exports.default = _default;

/***/ },
/* 6202 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
	}), 'TuneOutlined');
	
	exports.default = _default;

/***/ },
/* 6203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 18c0 .55.45 1 1 1h5v-2H4c-.55 0-1 .45-1 1zM3 6c0 .55.45 1 1 1h9V5H4c-.55 0-1 .45-1 1zm10 14v-1h7c.55 0 1-.45 1-1s-.45-1-1-1h-7v-1c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1zM7 10v1H4c-.55 0-1 .45-1 1s.45 1 1 1h3v1c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1s-1 .45-1 1zm14 2c0-.55-.45-1-1-1h-9v2h9c.55 0 1-.45 1-1zm-5-3c.55 0 1-.45 1-1V7h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1z"
	}), 'TuneRounded');
	
	exports.default = _default;

/***/ },
/* 6204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
	}), 'TuneSharp');
	
	exports.default = _default;

/***/ },
/* 6205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5h10v2H3zm4 6H3v2h4v2h2V9H7zm6 4h-2v6h2v-2h8v-2h-8zM3 17h6v2H3zm8-6h10v2H11zm6-8h-2v6h2V7h4V5h-4z"
	}), 'TuneTwoTone');
	
	exports.default = _default;

/***/ },
/* 6206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"
	}), 'TurnedIn');
	
	exports.default = _default;

/***/ },
/* 6207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
	}), 'TurnedInNot');
	
	exports.default = _default;

/***/ },
/* 6208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
	}), 'TurnedInNotOutlined');
	
	exports.default = _default;

/***/ },
/* 6209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V6c0-.55.45-1 1-1h8c.55 0 1 .45 1 1v12z"
	}), 'TurnedInNotRounded');
	
	exports.default = _default;

/***/ },
/* 6210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5.01L5 21l7-3 7 3V3zm-2 15l-5-2.18L7 18V5h10v13z"
	}), 'TurnedInNotSharp');
	
	exports.default = _default;

/***/ },
/* 6211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
	}), 'TurnedInNotTwoTone');
	
	exports.default = _default;

/***/ },
/* 6212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"
	}), 'TurnedInOutlined');
	
	exports.default = _default;

/***/ },
/* 6213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"
	}), 'TurnedInRounded');
	
	exports.default = _default;

/***/ },
/* 6214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 3H5v18l7-3 7 3V3z"
	}), 'TurnedInSharp');
	
	exports.default = _default;

/***/ },
/* 6215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 14.97l-4.21-1.81-.79-.34-.79.34L7 17.97V5h10v12.97z"
	}), _react.default.createElement("path", {
	  d: "M7 17.97l4.21-1.81.79-.34.79.34L17 17.97V5H7z",
	  opacity: ".3"
	})), 'TurnedInTwoTone');
	
	exports.default = _default;

/***/ },
/* 6216 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"
	}), 'Tv');
	
	exports.default = _default;

/***/ },
/* 6217 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 3.54l1.53 1.53C1.65 5.28 1 6.06 1 7v12c0 1.1.9 2 2 2h15.46l2 2 1.26-1.27L2.27 2.27 1 3.54zM3 19V7h1.46l12 12H3zM21 5h-7.58l3.29-3.3L16 1l-4 4-4-4-.7.7L10.58 5H7.52l2 2H21v11.48l1.65 1.65c.22-.32.35-.71.35-1.13V7c0-1.11-.89-2-2-2z"
	}), 'TvOff');
	
	exports.default = _default;

/***/ },
/* 6218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 7v10.88l1.85 1.85c.09-.23.15-.47.15-.73V7c0-1.11-.89-2-2-2h-7.58l3.29-3.3L16 1l-4 4-4-4-.7.7L10.58 5H8.12l2 2H21zm-.54 16l1.26-1.27-1.26 1.26zM2.41 2.13l-.14.14L1 3.54l1.53 1.53C1.65 5.28 1 6.06 1 7v12c0 1.1.9 2 2 2h15.46l1.99 1.99 1.26-1.26.15-.15L2.41 2.13zM3 19V7h1.46l12 12H3z"
	}), 'TvOffOutlined');
	
	exports.default = _default;

/***/ },
/* 6219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 8v9.88l1.85 1.85c.1-.22.15-.47.15-.73V7c0-1.11-.9-2-2-2h-7.59l2.94-2.94c.2-.2.2-.51 0-.71s-.51-.2-.71 0L12 4.99 8.36 1.35c-.2-.2-.51-.2-.71 0s-.2.51 0 .71L10.59 5H8.12l2 2H20c.55 0 1 .45 1 1zM3.12 2.83a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l.82.82C1.65 5.28 1 6.06 1 7v12c0 1.1.9 2 2 2h15.46l1.29 1.29c.39.39 1.02.39 1.41 0 .36-.36.37-.92.07-1.31h.03L3.12 2.83zM3 18V8c0-.55.45-1 1-1h.46l12 12H4c-.55 0-1-.45-1-1z"
	}), 'TvOffRounded');
	
	exports.default = _default;

/***/ },
/* 6220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 7v10.88l2 2V5h-9.58l3.29-3.3L16 1l-4 4-4-4-.7.7L10.58 5H8.12l2 2zM2.41 2.13l-.14.14L1 3.54l1.53 1.53H1V21h17.46l1.99 1.99 1.26-1.26.15-.15L2.41 2.13zM3 19V7h1.46l12 12H3z"
	}), 'TvOffSharp');
	
	exports.default = _default;

/***/ },
/* 6221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 19h13.46l-12-12H3zm7.12-12L21 17.88V7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 7v10.88l1.85 1.85c.09-.23.15-.47.15-.73V7c0-1.11-.89-2-2-2h-7.58l3.29-3.3L16 1l-4 4-4-4-.7.7L10.58 5H8.12l2 2H21zm-.54 16l1.26-1.27-1.26 1.26zM2.41 2.13l-.14.14L1 3.54l1.53 1.53C1.65 5.28 1 6.06 1 7v12c0 1.1.9 2 2 2h15.46l1.99 1.99 1.26-1.26.15-.15L2.41 2.13zM3 19V7h1.46l12 12H3z"
	})), 'TvOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 6222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"
	}), 'TvOutlined');
	
	exports.default = _default;

/***/ },
/* 6223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v1c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-1h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm-1 14H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1z"
	}), 'TvRounded');
	
	exports.default = _default;

/***/ },
/* 6224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 3H1v16h7v2h8v-2h6.99L23 3zm-2 14H3V5h18v12z"
	}), 'TvSharp');
	
	exports.default = _default;

/***/ },
/* 6225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 5h18v12H3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"
	})), 'TvTwoTone');
	
	exports.default = _default;

/***/ },
/* 6226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"
	}), 'Twitter');
	
	exports.default = _default;

/***/ },
/* 6227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.55 5.22l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28zM12 9.5l5.5 5.5H14v2h-4v-2H6.5L12 9.5zM5.12 5l.82-1h12l.93 1H5.12z"
	}), 'Unarchive');
	
	exports.default = _default;

/***/ },
/* 6228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM6.24 5h11.52l.83 1H5.42l.82-1zM5 19V8h14v11H5zm3-5h2.55v3h2.9v-3H16l-4-4z"
	}), 'UnarchiveOutlined');
	
	exports.default = _default;

/***/ },
/* 6229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.55 5.22l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28zm-8.2 4.63L17.5 15H14v2h-4v-2H6.5l5.15-5.15c.19-.19.51-.19.7 0zM5.12 5l.82-1h12l.93 1H5.12z"
	}), 'UnarchiveRounded');
	
	exports.default = _default;

/***/ },
/* 6230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.71 3H5.29L3 5.79V21h18V5.79L18.71 3zM14 15v2h-4v-2H6.5L12 9.5l5.5 5.5H14zM5.12 5l.81-1h12l.94 1H5.12z"
	}), 'UnarchiveSharp');
	
	exports.default = _default;

/***/ },
/* 6231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 19h14V8H5v11zm7-9l4 4h-2.55v3h-2.91v-3H8l4-4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM6.24 5h11.52l.83 1H5.42l.82-1zM19 19H5V8h14v11zm-8.45-2h2.9v-3H16l-4-4-4 4h2.55z"
	})), 'UnarchiveTwoTone');
	
	exports.default = _default;

/***/ },
/* 6232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
	}), 'Undo');
	
	exports.default = _default;

/***/ },
/* 6233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
	}), 'UndoOutlined');
	
	exports.default = _default;

/***/ },
/* 6234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L3.71 8.71C3.08 8.08 2 8.52 2 9.41V15c0 .55.45 1 1 1h5.59c.89 0 1.34-1.08.71-1.71l-1.91-1.91c1.39-1.16 3.16-1.88 5.12-1.88 3.16 0 5.89 1.84 7.19 4.5.27.56.91.84 1.5.64.71-.23 1.07-1.04.75-1.72C20.23 10.42 16.65 8 12.5 8z"
	}), 'UndoRounded');
	
	exports.default = _default;

/***/ },
/* 6235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
	}), 'UndoSharp');
	
	exports.default = _default;

/***/ },
/* 6236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
	}), 'UndoTwoTone');
	
	exports.default = _default;

/***/ },
/* 6237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z"
	}), 'UnfoldLess');
	
	exports.default = _default;

/***/ },
/* 6238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z"
	}), 'UnfoldLessOutlined');
	
	exports.default = _default;

/***/ },
/* 6239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8.12 19.3c.39.39 1.02.39 1.41 0L12 16.83l2.47 2.47c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41l-3.17-3.17a.9959.9959 0 00-1.41 0l-3.17 3.17c-.4.38-.4 1.02-.01 1.41zm7.76-14.6a.9959.9959 0 00-1.41 0L12 7.17 9.53 4.7a.9959.9959 0 00-1.41 0c-.39.39-.39 1.03 0 1.42l3.17 3.17c.39.39 1.02.39 1.41 0l3.17-3.17c.4-.39.4-1.03.01-1.42z"
	}), 'UnfoldLessRounded');
	
	exports.default = _default;

/***/ },
/* 6240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z"
	}), 'UnfoldLessSharp');
	
	exports.default = _default;

/***/ },
/* 6241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z"
	}), 'UnfoldLessTwoTone');
	
	exports.default = _default;

/***/ },
/* 6242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
	}), 'UnfoldMore');
	
	exports.default = _default;

/***/ },
/* 6243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
	}), 'UnfoldMoreOutlined');
	
	exports.default = _default;

/***/ },
/* 6244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5.83l2.46 2.46c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L12.7 3.7a.9959.9959 0 00-1.41 0L8.12 6.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 5.83zm0 12.34l-2.46-2.46a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l3.17 3.18c.39.39 1.02.39 1.41 0l3.17-3.17c.39-.39.39-1.02 0-1.41a.9959.9959 0 00-1.41 0L12 18.17z"
	}), 'UnfoldMoreRounded');
	
	exports.default = _default;

/***/ },
/* 6245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
	}), 'UnfoldMoreSharp');
	
	exports.default = _default;

/***/ },
/* 6246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
	}), 'UnfoldMoreTwoTone');
	
	exports.default = _default;

/***/ },
/* 6247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.5 13c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm2 4h-4v-1h4v1zm-6.95 0c-.02-.17-.05-.33-.05-.5 0-2.76 2.24-5 5-5 .92 0 1.76.26 2.5.69V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h8.55zM12 10.5L5 7V5l7 3.5L19 5v2l-7 3.5z"
	}), 'Unsubscribe');
	
	exports.default = _default;

/***/ },
/* 6248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.99 14.04V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10.05c.28 1.92 2.1 3.35 4.18 2.93 1.34-.27 2.43-1.37 2.7-2.71.25-1.24-.16-2.39-.94-3.18zm-2-9.04L12 8.5 5 5h13.99zm-3.64 10H5V7l7 3.5L19 7v6.05c-.16-.02-.33-.05-.5-.05-1.39 0-2.59.82-3.15 2zm5.15 2h-4v-1h4v1z"
	}), 'UnsubscribeOutlined');
	
	exports.default = _default;

/***/ },
/* 6249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.5 11.5c.92 0 1.75.26 2.49.69V5c0-1.1-.89-2-1.99-2H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h8.55c-.02-.17-.05-.33-.05-.5 0-2.76 2.24-5 5-5zm-5.61-1.45c-.56.28-1.23.28-1.79 0l-5.61-2.8c-.3-.15-.49-.46-.49-.8 0-.66.7-1.1 1.29-.8L12 8.5l5.71-2.85c.59-.3 1.29.13 1.29.8 0 .34-.19.65-.49.8l-5.62 2.8zM18.5 13c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm2 3.5c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h3c.28 0 .5.22.5.5z"
	}), 'UnsubscribeRounded');
	
	exports.default = _default;

/***/ },
/* 6250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.5 13c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm2 4h-4v-1h4v1zm-6.95 0c-.02-.17-.05-.33-.05-.5 0-2.76 2.24-5 5-5 .92 0 1.75.26 2.49.69V3H3v14h10.55zM12 10.5L5 7V5l7 3.5L19 5v2l-7 3.5z"
	}), 'UnsubscribeSharp');
	
	exports.default = _default;

/***/ },
/* 6251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18.99 5H5l7 3.5zm.01 8.05V7l-7 3.5L5 7v8h10.35c.56-1.18 1.76-2 3.15-2 .17 0 .34.03.5.05z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20.99 14.04V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10.05c.28 1.92 2.1 3.35 4.18 2.93 1.34-.27 2.43-1.37 2.7-2.71.25-1.24-.16-2.39-.94-3.18zm-2-9.04L12 8.5 5 5h13.99zm-3.64 10H5V7l7 3.5L19 7v6.05c-.16-.02-.33-.05-.5-.05-1.39 0-2.59.82-3.15 2zm5.15 2h-4v-1h4v1z"
	})), 'UnsubscribeTwoTone');
	
	exports.default = _default;

/***/ },
/* 6252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79s7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58s9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z"
	}), 'Update');
	
	exports.default = _default;

/***/ },
/* 6253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 8v5l4.25 2.52.77-1.28-3.52-2.09V8H11zm10 2V3l-2.64 2.64C16.74 4.01 14.49 3 12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9h-2c0 3.86-3.14 7-7 7s-7-3.14-7-7 3.14-7 7-7c1.93 0 3.68.79 4.95 2.05L14 10h7z"
	}), 'UpdateOutlined');
	
	exports.default = _default;

/***/ },
/* 6254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 8.75v3.68c0 .35.19.68.49.86l3.12 1.85c.36.21.82.09 1.03-.26.21-.36.1-.82-.26-1.03l-2.87-1.71v-3.4c-.01-.4-.35-.74-.76-.74s-.75.34-.75.75zm10 .75V4.21c0-.45-.54-.67-.85-.35l-1.78 1.78c-1.81-1.81-4.39-2.85-7.21-2.6-4.19.38-7.64 3.75-8.1 7.94C2.46 16.4 6.69 21 12 21c4.59 0 8.38-3.44 8.93-7.88.07-.6-.4-1.12-1-1.12-.5 0-.92.37-.98.86-.43 3.49-3.44 6.19-7.05 6.14-3.71-.05-6.84-3.18-6.9-6.9C4.94 8.2 8.11 5 12 5c1.93 0 3.68.79 4.95 2.05l-2.09 2.09c-.32.32-.1.86.35.86h5.29c.28 0 .5-.22.5-.5z"
	}), 'UpdateRounded');
	
	exports.default = _default;

/***/ },
/* 6255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 8v5l4.25 2.52.77-1.28-3.52-2.09V8H11zm10 2V3l-2.64 2.64C16.74 4.01 14.49 3 12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9h-2c0 3.86-3.14 7-7 7s-7-3.14-7-7 3.14-7 7-7c1.93 0 3.68.79 4.95 2.05L14 10h7z"
	}), 'UpdateSharp');
	
	exports.default = _default;

/***/ },
/* 6256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 8v5l4.25 2.52.77-1.28-3.52-2.09V8H11zm10 2V3l-2.64 2.64C16.74 4.01 14.49 3 12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9h-2c0 3.86-3.14 7-7 7s-7-3.14-7-7 3.14-7 7-7c1.93 0 3.68.79 4.95 2.05L14 10h7z"
	}), 'UpdateTwoTone');
	
	exports.default = _default;

/***/ },
/* 6257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2-1.21 0-2.2.99-2.2 2.2 0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95 0 1.22.99 2.2 2.2 2.2 1.21 0 2.2-.98 2.2-2.2 0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7h-4z"
	}), 'Usb');
	
	exports.default = _default;

/***/ },
/* 6258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2S4.8 7.79 4.8 9c0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95 0 1.22.99 2.2 2.2 2.2s2.2-.98 2.2-2.2c0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7h-4z"
	}), 'UsbOutlined');
	
	exports.default = _default;

/***/ },
/* 6259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18 7h-2c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1v2h-3V5h1c.41 0 .65-.47.4-.8l-2-2.67c-.2-.27-.6-.27-.8 0l-2 2.67c-.25.33-.01.8.4.8h1v8H8v-2.07c.83-.44 1.38-1.36 1.14-2.43-.17-.77-.77-1.4-1.52-1.61C6.15 6.48 4.8 7.59 4.8 9c0 .85.5 1.56 1.2 1.93V13c0 1.1.9 2 2 2h3v3.05c-.86.45-1.39 1.42-1.13 2.49.18.75.79 1.38 1.54 1.58 1.46.39 2.8-.7 2.8-2.12 0-.85-.49-1.58-1.2-1.95V15h3c1.1 0 2-.9 2-2v-2c.55 0 1-.45 1-1V8C19 7.45 18.55 7 18 7z"
	}), 'UsbRounded');
	
	exports.default = _default;

/***/ },
/* 6260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2S4.8 7.79 4.8 9c0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95 0 1.22.99 2.2 2.2 2.2s2.2-.98 2.2-2.2c0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7h-4z"
	}), 'UsbSharp');
	
	exports.default = _default;

/***/ },
/* 6261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2S4.8 7.79 4.8 9c0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95 0 1.22.99 2.2 2.2 2.2s2.2-.98 2.2-2.2c0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7h-4z"
	}), 'UsbTwoTone');
	
	exports.default = _default;

/***/ },
/* 6262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
	}), 'VerifiedUser');
	
	exports.default = _default;

/***/ },
/* 6263 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm7 10c0 4.52-2.98 8.69-7 9.93-4.02-1.24-7-5.41-7-9.93V6.3l7-3.11 7 3.11V11zm-11.59.59L6 13l4 4 8-8-1.41-1.42L10 14.17z"
	}), 'VerifiedUserOutlined');
	
	exports.default = _default;

/***/ },
/* 6264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.19 1.36l-7 3.11C3.47 4.79 3 5.51 3 6.3V11c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V6.3c0-.79-.47-1.51-1.19-1.83l-7-3.11c-.51-.23-1.11-.23-1.62 0zm-1.9 14.93L6.7 13.7a.9959.9959 0 010-1.41c.39-.39 1.02-.39 1.41 0L10 14.17l5.88-5.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-6.59 6.59c-.38.39-1.02.39-1.41 0z"
	}), 'VerifiedUserRounded');
	
	exports.default = _default;

/***/ },
/* 6265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
	}), 'VerifiedUserSharp');
	
	exports.default = _default;

/***/ },
/* 6266 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm7 10c0 4.52-2.98 8.69-7 9.93-4.02-1.24-7-5.41-7-9.93V6.3l7-3.11 7 3.11V11zm-11.59.59L6 13l4 4 8-8-1.41-1.42L10 14.17z"
	}), _react.default.createElement("path", {
	  d: "M5 6.3V11c0 4.52 2.98 8.69 7 9.93 4.02-1.23 7-5.41 7-9.93V6.3l-7-3.11L5 6.3zM18 9l-8 8-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9z",
	  opacity: ".3"
	})), 'VerifiedUserTwoTone');
	
	exports.default = _default;

/***/ },
/* 6267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z"
	}), 'VerticalAlignBottom');
	
	exports.default = _default;

/***/ },
/* 6268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z"
	}), 'VerticalAlignBottomOutlined');
	
	exports.default = _default;

/***/ },
/* 6269 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.79 13H13V4c0-.55-.45-1-1-1s-1 .45-1 1v9H9.21c-.45 0-.67.54-.35.85l2.79 2.79c.2.2.51.2.71 0l2.79-2.79c.31-.31.09-.85-.36-.85zM4 20c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1z"
	}), 'VerticalAlignBottomRounded');
	
	exports.default = _default;

/***/ },
/* 6270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z"
	}), 'VerticalAlignBottomSharp');
	
	exports.default = _default;

/***/ },
/* 6271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 3v10H8l4 4 4-4h-3V3zM4 19h16v2H4z"
	}), 'VerticalAlignBottomTwoTone');
	
	exports.default = _default;

/***/ },
/* 6272 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z"
	}), 'VerticalAlignCenter');
	
	exports.default = _default;

/***/ },
/* 6273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z"
	}), 'VerticalAlignCenterOutlined');
	
	exports.default = _default;

/***/ },
/* 6274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.21 19H11v3c0 .55.45 1 1 1s1-.45 1-1v-3h1.79c.45 0 .67-.54.35-.85l-2.79-2.79c-.2-.2-.51-.2-.71 0l-2.79 2.79c-.31.31-.09.85.36.85zm5.58-14H13V2c0-.55-.45-1-1-1s-1 .45-1 1v3H9.21c-.45 0-.67.54-.36.85l2.79 2.79c.2.2.51.2.71 0l2.79-2.79c.32-.31.1-.85-.35-.85zM4 12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1z"
	}), 'VerticalAlignCenterRounded');
	
	exports.default = _default;

/***/ },
/* 6275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z"
	}), 'VerticalAlignCenterSharp');
	
	exports.default = _default;

/***/ },
/* 6276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 1v4H8l4 4 4-4h-3V1zM4 11h16v2H4zm4 8h3v4h2v-4h3l-4-4z"
	}), 'VerticalAlignCenterTwoTone');
	
	exports.default = _default;

/***/ },
/* 6277 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z"
	}), 'VerticalAlignTop');
	
	exports.default = _default;

/***/ },
/* 6278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z"
	}), 'VerticalAlignTopOutlined');
	
	exports.default = _default;

/***/ },
/* 6279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.21 11H11v9c0 .55.45 1 1 1s1-.45 1-1v-9h1.79c.45 0 .67-.54.35-.85l-2.79-2.79c-.2-.2-.51-.2-.71 0l-2.79 2.79c-.31.31-.09.85.36.85zM4 4c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1z"
	}), 'VerticalAlignTopRounded');
	
	exports.default = _default;

/***/ },
/* 6280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z"
	}), 'VerticalAlignTopSharp');
	
	exports.default = _default;

/***/ },
/* 6281 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 3h16v2H4zm4 8h3v10h2V11h3l-4-4z"
	}), 'VerticalAlignTopTwoTone');
	
	exports.default = _default;

/***/ },
/* 6282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 15h8v-2H3v2zm0 4h8v-2H3v2zm0-8h8V9H3v2zm0-6v2h8V5H3zm10 0h8v14h-8V5z"
	}), 'VerticalSplit');
	
	exports.default = _default;

/***/ },
/* 6283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 13h8v2H3zm0 4h8v2H3zm0-8h8v2H3zm0-4h8v2H3zm16 2v10h-4V7h4m2-2h-8v14h8V5z"
	}), 'VerticalSplitOutlined');
	
	exports.default = _default;

/***/ },
/* 6284 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 15h6c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0 4h6c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-8h6c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 6c0 .55.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1zm11-1h6c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1h-6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1z"
	}), 'VerticalSplitRounded');
	
	exports.default = _default;

/***/ },
/* 6285 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 15h8v-2H3v2zm0 4h8v-2H3v2zm0-8h8V9H3v2zm0-6v2h8V5H3zm10 0h8v14h-8V5z"
	}), 'VerticalSplitSharp');
	
	exports.default = _default;

/***/ },
/* 6286 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15 7h4v10h-4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 13h8v2H3zm0 4h8v2H3zm0-8h8v2H3zm0-4h8v2H3zm10 0v14h8V5h-8zm6 12h-4V7h4v10z"
	})), 'VerticalSplitTwoTone');
	
	exports.default = _default;

/***/ },
/* 6287 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M0 15h2V9H0v6zm3 2h2V7H3v10zm19-8v6h2V9h-2zm-3 8h2V7h-2v10zM16.5 3h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM16 19H8V5h8v14z"
	}), 'Vibration');
	
	exports.default = _default;

/***/ },
/* 6288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M0 15h2V9H0v6zm3 2h2V7H3v10zm19-8v6h2V9h-2zm-3 8h2V7h-2v10zM16.5 3h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM16 19H8V5h8v14z"
	}), 'VibrationOutlined');
	
	exports.default = _default;

/***/ },
/* 6289 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 15c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1zm3 2c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1s-1 .45-1 1v8c0 .55.45 1 1 1zm18-7v4c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1s-1 .45-1 1zm-2 7c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1s-1 .45-1 1v8c0 .55.45 1 1 1zM16.5 3h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM16 19H8V5h8v14z"
	}), 'VibrationRounded');
	
	exports.default = _default;

/***/ },
/* 6290 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M0 15h2V9H0v6zm3 2h2V7H3v10zm19-8v6h2V9h-2zm-3 8h2V7h-2v10zM18 3H6v18h12V3zm-2 16H8V5h8v14z"
	}), 'VibrationSharp');
	
	exports.default = _default;

/***/ },
/* 6291 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 5h8v14H8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 7h2v10h-2zm3 2h2v6h-2zM0 9h2v6H0zm16.5-6h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM16 19H8V5h8v14zM3 7h2v10H3z"
	})), 'VibrationTwoTone');
	
	exports.default = _default;

/***/ },
/* 6292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2z"
	}), 'VideoCall');
	
	exports.default = _default;

/***/ },
/* 6293 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM15 16H5V8h10v8zm-6-1h2v-2h2v-2h-2V9H9v2H7v2h2z"
	}), 'VideoCallOutlined');
	
	exports.default = _default;

/***/ },
/* 6294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l2.29 2.29c.63.63 1.71.18 1.71-.71V8.91c0-.89-1.08-1.34-1.71-.71L17 10.5zM13 13h-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2H7c-.55 0-1-.45-1-1s.45-1 1-1h2V9c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1s-.45 1-1 1z"
	}), 'VideoCallRounded');
	
	exports.default = _default;

/***/ },
/* 6295 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 10.5V6H3v12h14v-4.5l4 4v-11l-4 4zM14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2z"
	}), 'VideoCallSharp');
	
	exports.default = _default;

/***/ },
/* 6296 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 16h10V8H5v8zm2-5h2V9h2v2h2v2h-2v2H9v-2H7v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4V7zm-2 9H5V8h10v8zm-6-1h2v-2h2v-2h-2V9H9v2H7v2h2z"
	})), 'VideoCallTwoTone');
	
	exports.default = _default;

/***/ },
/* 6297 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V5h18v11z"
	}), 'VideoLabel');
	
	exports.default = _default;

/***/ },
/* 6298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V5h18v11z"
	}), 'VideoLabelOutlined');
	
	exports.default = _default;

/***/ },
/* 6299 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V6c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v10z"
	}), 'VideoLabelRounded');
	
	exports.default = _default;

/***/ },
/* 6300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 3H1v18h22V3zm-2 13H3V5h18v11z"
	}), 'VideoLabelSharp');
	
	exports.default = _default;

/***/ },
/* 6301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 5h18v11H3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V5h18v11z"
	})), 'VideoLabelTwoTone');
	
	exports.default = _default;

/***/ },
/* 6302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z"
	}), 'VideoLibrary');
	
	exports.default = _default;

/***/ },
/* 6303 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zM12 5.5v9l6-4.5z"
	}), 'VideoLibraryOutlined');
	
	exports.default = _default;

/***/ },
/* 6304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 6c-.55 0-1 .45-1 1v13c0 1.1.9 2 2 2h13c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1zm17-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l5.47 4.1c.27.2.27.6 0 .8L12 14.5z"
	}), 'VideoLibraryRounded');
	
	exports.default = _default;

/***/ },
/* 6305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6H2v16h16v-2H4V6zm18-4H6v16h16V2zM12 14.5v-9l6 4.5-6 4.5z"
	}), 'VideoLibrarySharp');
	
	exports.default = _default;

/***/ },
/* 6306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 16h12V4H8v12zm4-10.5l6 4.5-6 4.5v-9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zM12 5.5v9l6-4.5z"
	})), 'VideoLibraryTwoTone');
	
	exports.default = _default;

/***/ },
/* 6307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"
	}), 'Videocam');
	
	exports.default = _default;

/***/ },
/* 6308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"
	}), 'VideocamOff');
	
	exports.default = _default;

/***/ },
/* 6309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.56 8l-2-2-4.15-4.14L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.55-.18L19.73 21l1.41-1.41-8.86-8.86L9.56 8zM5 16V8h1.73l8 8H5zm10-8v2.61l6 6V6.5l-4 4V7c0-.55-.45-1-1-1h-5.61l2 2H15z"
	}), 'VideocamOffOutlined');
	
	exports.default = _default;

/***/ },
/* 6310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 14.2V8.91c0-.89-1.08-1.34-1.71-.71L17 10.5V7c0-.55-.45-1-1-1h-5.61l8.91 8.91c.62.63 1.7.18 1.7-.71zM2.71 2.56c-.39.39-.39 1.02 0 1.41L4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.55-.18l2.48 2.48c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L4.12 2.56a.9959.9959 0 00-1.41 0z"
	}), 'VideocamOffRounded');
	
	exports.default = _default;

/***/ },
/* 6311 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 16.61V6.5l-4 4V6h-6.61zM3.41 1.86L2 3.27 4.73 6H3v12h13.73l3 3 1.41-1.41z"
	}), 'VideocamOffSharp');
	
	exports.default = _default;

/***/ },
/* 6312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12.39 8L15 10.61V8zM5 8v8h9.73l-8-8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3.41 1.86L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.55-.18L19.73 21l1.41-1.41L3.41 1.86zM5 16V8h1.73l8 8H5zm10-8v2.61l6 6V6.5l-4 4V7c0-.55-.45-1-1-1h-5.61l2 2H15z"
	})), 'VideocamOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 6313 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 8v8H5V8h10m1-2H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4V7c0-.55-.45-1-1-1z"
	}), 'VideocamOutlined');
	
	exports.default = _default;

/***/ },
/* 6314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l2.29 2.29c.63.63 1.71.18 1.71-.71V8.91c0-.89-1.08-1.34-1.71-.71L17 10.5z"
	}), 'VideocamRounded');
	
	exports.default = _default;

/***/ },
/* 6315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 10.5V6H3v12h14v-4.5l4 4v-11l-4 4z"
	}), 'VideocamSharp');
	
	exports.default = _default;

/***/ },
/* 6316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 8h10v8H5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M17 7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4V7zm-2 9H5V8h10v8z"
	})), 'VideocamTwoTone');
	
	exports.default = _default;

/***/ },
/* 6317 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'VideogameAsset');
	
	exports.default = _default;

/***/ },
/* 6318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h18v8zM6 15h2v-2h2v-2H8V9H6v2H4v2h2z"
	}), _react.default.createElement("circle", {
	  cx: "14.5",
	  cy: "13.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "18.5",
	  cy: "10.5",
	  r: "1.5"
	})), 'VideogameAssetOutlined');
	
	exports.default = _default;

/***/ },
/* 6319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-11 7H8v2c0 .55-.45 1-1 1s-1-.45-1-1v-2H4c-.55 0-1-.45-1-1s.45-1 1-1h2V9c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1s-.45 1-1 1zm5.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'VideogameAssetRounded');
	
	exports.default = _default;

/***/ },
/* 6320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 6H1v12h22V6zm-12 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
	}), 'VideogameAssetSharp');
	
	exports.default = _default;

/***/ },
/* 6321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 16h18V8H3v8zm15.5-7c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-4 3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zM4 11h2V9h2v2h2v2H8v2H6v-2H4v-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h18v8zM6 15h2v-2h2v-2H8V9H6v2H4v2h2z"
	}), _react.default.createElement("circle", {
	  cx: "14.5",
	  cy: "13.5",
	  r: "1.5"
	}), _react.default.createElement("circle", {
	  cx: "18.5",
	  cy: "10.5",
	  r: "1.5"
	})), 'VideogameAssetTwoTone');
	
	exports.default = _default;

/***/ },
/* 6322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 13H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm0-10H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
	}), 'ViewAgenda');
	
	exports.default = _default;

/***/ },
/* 6323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 5v4H4V5h15m0 10v4H4v-4h15m1-12H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm0 10H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1z"
	}), 'ViewAgendaOutlined');
	
	exports.default = _default;

/***/ },
/* 6324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 13H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm0-10H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
	}), 'ViewAgendaRounded');
	
	exports.default = _default;

/***/ },
/* 6325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 13H2v8h19v-8zm0-10H2v8h19V3z"
	}), 'ViewAgendaSharp');
	
	exports.default = _default;

/***/ },
/* 6326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M20 3H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm-1 6H4V5h15v4zm1 4H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm-1 6H4v-4h15v4z"
	}), _react.default.createElement("path", {
	  d: "M4 15h15v4H4zM4 5h15v4H4z",
	  opacity: ".3"
	})), 'ViewAgendaTwoTone');
	
	exports.default = _default;

/***/ },
/* 6327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 18h3V5H4v13zM18 5v13h3V5h-3zM8 18h9V5H8v13z"
	}), 'ViewArray');
	
	exports.default = _default;

/***/ },
/* 6328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 7v9h-5V7h5m6-2h-3v13h3V5zm-4 0H8v13h9V5zM7 5H4v13h3V5z"
	}), 'ViewArrayOutlined');
	
	exports.default = _default;

/***/ },
/* 6329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 18h1c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1zM18 6v11c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1zM9 18h7c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1z"
	}), 'ViewArrayRounded');
	
	exports.default = _default;

/***/ },
/* 6330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 18h3V5H4v13zM18 5v13h3V5h-3zM8 18h9V5H8v13z"
	}), 'ViewArraySharp');
	
	exports.default = _default;

/***/ },
/* 6331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 5h3v13H4zm14 0h3v13h-3zM8 18h9V5H8v13zm2-11h5v9h-5V7z"
	}), _react.default.createElement("path", {
	  d: "M10 7h5v9h-5z",
	  opacity: ".3"
	})), 'ViewArrayTwoTone');
	
	exports.default = _default;

/***/ },
/* 6332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 19h10V4H7v15zm-5-2h4V6H2v11zM18 6v11h4V6h-4z"
	}), 'ViewCarousel');
	
	exports.default = _default;

/***/ },
/* 6333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 6h4v11H2zm5 13h10V4H7v15zM9 6h6v11H9V6zm9 0h4v11h-4z"
	}), 'ViewCarouselOutlined');
	
	exports.default = _default;

/***/ },
/* 6334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M8 19h8c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v13c0 .55.45 1 1 1zm-5-2h2c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1zM18 7v9c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1z"
	}), 'ViewCarouselRounded');
	
	exports.default = _default;

/***/ },
/* 6335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 19h10V4H7v15zm-5-2h4V6H2v11zM18 6v11h4V6h-4z"
	}), 'ViewCarouselSharp');
	
	exports.default = _default;

/***/ },
/* 6336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M18 6h4v11h-4zM7 19h10V4H7v15zM9 6h6v11H9V6zM2 6h4v11H2z"
	}), _react.default.createElement("path", {
	  d: "M9 6h6v11H9z",
	  opacity: ".3"
	})), 'ViewCarouselTwoTone');
	
	exports.default = _default;

/***/ },
/* 6337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z"
	}), 'ViewColumn');
	
	exports.default = _default;

/***/ },
/* 6338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 5v13h17V5H4zm10 2v9h-3V7h3zM6 7h3v9H6V7zm13 9h-3V7h3v9z"
	}), 'ViewColumnOutlined');
	
	exports.default = _default;

/***/ },
/* 6339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 18h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1zm-6 0h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1zM16 6v11c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1z"
	}), 'ViewColumnRounded');
	
	exports.default = _default;

/***/ },
/* 6340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z"
	}), 'ViewColumnSharp');
	
	exports.default = _default;

/***/ },
/* 6341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 7h3v9H6zm5 0h3v9h-3zm5 0h3v9h-3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 5v13h17V5H4zm5 11H6V7h3v9zm5 0h-3V7h3v9zm5 0h-3V7h3v9z"
	})), 'ViewColumnTwoTone');
	
	exports.default = _default;

/***/ },
/* 6342 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 9h4V5H3v4zm0 5h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zM8 9h4V5H8v4zm5-4v4h4V5h-4zm5 9h4v-4h-4v4zM3 19h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zm5 0h4v-4h-4v4zm0-14v4h4V5h-4z"
	}), 'ViewComfy');
	
	exports.default = _default;

/***/ },
/* 6343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5v14h19V5H3zm17 4h-2.25V7H20v2zM9.25 11h2.25v2H9.25v-2zm-2 2H5v-2h2.25v2zm4.25-4H9.25V7h2.25v2zm2-2h2.25v2H13.5V7zm-2 8v2H9.25v-2h2.25zm2 0h2.25v2H13.5v-2zm0-2v-2h2.25v2H13.5zm4.25-2H20v2h-2.25v-2zM7.25 7v2H5V7h2.25zM5 15h2.25v2H5v-2zm12.75 2v-2H20v2h-2.25z"
	}), 'ViewComfyOutlined');
	
	exports.default = _default;

/***/ },
/* 6344 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 9h4V5H5c-1.1 0-2 .9-2 2v2zm0 5h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zM8 9h4V5H8v4zm5-4v4h4V5h-4zm5 9h4v-4h-4v4zM5 19h2v-4H3v2c0 1.1.9 2 2 2zm3 0h4v-4H8v4zm5 0h4v-4h-4v4zm5 0h2c1.1 0 2-.9 2-2v-2h-4v4zm0-14v4h4V7c0-1.1-.9-2-2-2h-2z"
	}), 'ViewComfyRounded');
	
	exports.default = _default;

/***/ },
/* 6345 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 9h4V5H3v4zm0 5h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zM8 9h4V5H8v4zm5-4v4h4V5h-4zm5 9h4v-4h-4v4zM3 19h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zm5 0h4v-4h-4v4zm0-14v4h4V5h-4z"
	}), 'ViewComfySharp');
	
	exports.default = _default;

/***/ },
/* 6346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9.25 11h2.25v2H9.25zm0 4h2.25v2H9.25zm0-8h2.25v2H9.25zm4.25 8h2.25v2H13.5zM5 15h2.25v2H5zm0-4h2.25v2H5zm0-4h2.25v2H5zm12.75 0H20v2h-2.25zm-4.25 4h2.25v2H13.5zm0-4h2.25v2H13.5zm4.25 8H20v2h-2.25zm0-4H20v2h-2.25z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 5v14h19V5H3zm4.25 12H5v-2h2.25v2zm0-4H5v-2h2.25v2zm0-4H5V7h2.25v2zm4.25 8H9.25v-2h2.25v2zm0-4H9.25v-2h2.25v2zm0-4H9.25V7h2.25v2zm4.25 8H13.5v-2h2.25v2zm0-4H13.5v-2h2.25v2zm0-4H13.5V7h2.25v2zM20 17h-2.25v-2H20v2zm0-4h-2.25v-2H20v2zm0-4h-2.25V7H20v2z"
	})), 'ViewComfyTwoTone');
	
	exports.default = _default;

/***/ },
/* 6347 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 19h6v-7H3v7zm7 0h12v-7H10v7zM3 5v6h19V5H3z"
	}), 'ViewCompact');
	
	exports.default = _default;

/***/ },
/* 6348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5v14h19V5H3zm2 2h15v4H5V7zm0 10v-4h4v4H5zm6 0v-4h9v4h-9z"
	}), 'ViewCompactOutlined');
	
	exports.default = _default;

/***/ },
/* 6349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 19h4v-7H3v5c0 1.1.9 2 2 2zm5 0h10c1.1 0 2-.9 2-2v-5H10v7zM3 7v4h19V7c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2z"
	}), 'ViewCompactRounded');
	
	exports.default = _default;

/***/ },
/* 6350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 19h6v-7H3v7zm7 0h12v-7H10v7zM3 5v6h19V5H3z"
	}), 'ViewCompactSharp');
	
	exports.default = _default;

/***/ },
/* 6351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11 13h9v4h-9zm-6 0h4v4H5zm0-6h15v4H5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 5v14h19V5H3zm6 12H5v-4h4v4zm11 0h-9v-4h9v4zm0-6H5V7h15v4z"
	})), 'ViewCompactTwoTone');
	
	exports.default = _default;

/***/ },
/* 6352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 21h19v-3H2v3zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 3v3h19V3H2z"
	}), 'ViewDay');
	
	exports.default = _default;

/***/ },
/* 6353 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 18H2v2h19v-2zm-2-8v4H4v-4h15m1-2H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm1-4H2v2h19V4z"
	}), 'ViewDayOutlined');
	
	exports.default = _default;

/***/ },
/* 6354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 21h17c.55 0 1-.45 1-1v-1c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 4v1c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1z"
	}), 'ViewDayRounded');
	
	exports.default = _default;

/***/ },
/* 6355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2 21h19v-3H2v3zM21 8H2v8h19V8zM2 3v3h19V3H2z"
	}), 'ViewDaySharp');
	
	exports.default = _default;

/***/ },
/* 6356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 10h15v4H4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M2 18h19v2H2zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 6H4v-4h15v4zM2 4h19v2H2z"
	})), 'ViewDayTwoTone');
	
	exports.default = _default;

/***/ },
/* 6357 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
	}), 'ViewHeadline');
	
	exports.default = _default;

/***/ },
/* 6358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
	}), 'ViewHeadlineOutlined');
	
	exports.default = _default;

/***/ },
/* 6359 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 15h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1zm0 4h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1zm0-8h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1zM4 6c0 .55.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1z"
	}), 'ViewHeadlineRounded');
	
	exports.default = _default;

/***/ },
/* 6360 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
	}), 'ViewHeadlineSharp');
	
	exports.default = _default;

/***/ },
/* 6361 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
	}), 'ViewHeadlineTwoTone');
	
	exports.default = _default;

/***/ },
/* 6362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z"
	}), 'ViewList');
	
	exports.default = _default;

/***/ },
/* 6363 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 5v14h17V5H3zm4 2v2H5V7h2zm-2 6v-2h2v2H5zm0 2h2v2H5v-2zm13 2H9v-2h9v2zm0-4H9v-2h9v2zm0-4H9V7h9v2z"
	}), 'ViewListOutlined');
	
	exports.default = _default;

/***/ },
/* 6364 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 14h2c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1zm0 5h2c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1zM4 9h2c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1zm5 5h10c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1zm0 5h10c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1zM8 6v2c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1z"
	}), 'ViewListRounded');
	
	exports.default = _default;

/***/ },
/* 6365 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 14h4v-4H3v4zm0 5h4v-4H3v4zM3 9h4V5H3v4zm5 5h12v-4H8v4zm0 5h12v-4H8v4zM8 5v4h12V5H8z"
	}), 'ViewListSharp');
	
	exports.default = _default;

/***/ },
/* 6366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 11h2v2H5zm0 4h2v2H5zm0-8h2v2H5zm4 0h9v2H9zm0 8h9v2H9zm0-4h9v2H9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 5v14h17V5H3zm4 12H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V7h2v2zm11 8H9v-2h9v2zm0-4H9v-2h9v2zm0-4H9V7h9v2z"
	})), 'ViewListTwoTone');
	
	exports.default = _default;

/***/ },
/* 6367 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z"
	}), 'ViewModule');
	
	exports.default = _default;

/***/ },
/* 6368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 5v13h17V5H4zm10 2v3.5h-3V7h3zM6 7h3v3.5H6V7zm0 9v-3.5h3V16H6zm5 0v-3.5h3V16h-3zm8 0h-3v-3.5h3V16zm-3-5.5V7h3v3.5h-3z"
	}), 'ViewModuleOutlined');
	
	exports.default = _default;

/***/ },
/* 6369 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 11h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm0 7h3c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm6 0h3c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm6 0h3c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm-6-7h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm5-5v4c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1z"
	}), 'ViewModuleRounded');
	
	exports.default = _default;

/***/ },
/* 6370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z"
	}), 'ViewModuleSharp');
	
	exports.default = _default;

/***/ },
/* 6371 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11 12.5h3V16h-3zM11 7h3v3.5h-3zm-5 5.5h3V16H6zM6 7h3v3.5H6zm10 0h3v3.5h-3zm0 5.5h3V16h-3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 5v13h17V5H4zm5 11H6v-3.5h3V16zm0-5.5H6V7h3v3.5zm5 5.5h-3v-3.5h3V16zm0-5.5h-3V7h3v3.5zm5 5.5h-3v-3.5h3V16zm0-5.5h-3V7h3v3.5z"
	})), 'ViewModuleTwoTone');
	
	exports.default = _default;

/***/ },
/* 6372 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z"
	}), 'ViewQuilt');
	
	exports.default = _default;

/***/ },
/* 6373 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 5v13h17V5H4zm2 11V7h3v9H6zm5 0v-3.5h3V16h-3zm8 0h-3v-3.5h3V16zm-8-5.5V7h8v3.5h-8z"
	}), 'ViewQuiltOutlined');
	
	exports.default = _default;

/***/ },
/* 6374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11 18h3c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm-6 0h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1zm12 0h3c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zM10 6v4c0 .55.45 1 1 1h9c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1h-9c-.55 0-1 .45-1 1z"
	}), 'ViewQuiltRounded');
	
	exports.default = _default;

/***/ },
/* 6375 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z"
	}), 'ViewQuiltSharp');
	
	exports.default = _default;

/***/ },
/* 6376 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16 12.5h3V16h-3zM6 7h3v9H6zm5 5.5h3V16h-3zM11 7h8v3.5h-8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 5v13h17V5H4zm5 11H6V7h3v9zm5 0h-3v-3.5h3V16zm5 0h-3v-3.5h3V16zm0-5.5h-8V7h8v3.5z"
	})), 'ViewQuiltTwoTone');
	
	exports.default = _default;

/***/ },
/* 6377 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
	}), 'ViewStream');
	
	exports.default = _default;

/***/ },
/* 6378 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 6v12h17V6H4zm15 10H6v-3h13v3zM6 11V8h13v3H6z"
	}), 'ViewStreamOutlined');
	
	exports.default = _default;

/***/ },
/* 6379 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 18h15c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zM4 6v4c0 .55.45 1 1 1h15c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1z"
	}), 'ViewStreamRounded');
	
	exports.default = _default;

/***/ },
/* 6380 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
	}), 'ViewStreamSharp');
	
	exports.default = _default;

/***/ },
/* 6381 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M6 13h13v3H6zm0-5h13v3H6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4 6v12h17V6H4zm15 10H6v-3h13v3zm0-5H6V8h13v3z"
	})), 'ViewStreamTwoTone');
	
	exports.default = _default;

/***/ },
/* 6382 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
	}), 'ViewWeek');
	
	exports.default = _default;

/***/ },
/* 6383 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 4H3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zM8 18H4V6h4v12zm6 0h-4V6h4v12zm6 0h-4V6h4v12z"
	}), 'ViewWeekOutlined');
	
	exports.default = _default;

/***/ },
/* 6384 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
	}), 'ViewWeekRounded');
	
	exports.default = _default;

/***/ },
/* 6385 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 5H2v14h5V5zm14 0h-5v14h5V5zm-7 0H9v14h5V5z"
	}), 'ViewWeekSharp');
	
	exports.default = _default;

/***/ },
/* 6386 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21 4H3c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zM8 18H4V6h4v12zm6 0h-4V6h4v12zm6 0h-4V6h4v12z"
	}), _react.default.createElement("path", {
	  d: "M10 6h4v12h-4zm6 0h4v12h-4zM4 6h4v12H4z",
	  opacity: ".3"
	})), 'ViewWeekTwoTone');
	
	exports.default = _default;

/***/ },
/* 6387 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 15c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6z"
	}), 'Vignette');
	
	exports.default = _default;

/***/ },
/* 6388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 5v14H3V5h18m0-2H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 5c3.25 0 6 1.83 6 4s-2.75 4-6 4-6-1.83-6-4 2.75-4 6-4m0-2c-4.42 0-8 2.69-8 6s3.58 6 8 6 8-2.69 8-6-3.58-6-8-6z"
	}), 'VignetteOutlined');
	
	exports.default = _default;

/***/ },
/* 6389 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 15c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6z"
	}), 'VignetteRounded');
	
	exports.default = _default;

/***/ },
/* 6390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 3H1v18h22V3zM12 18c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6z"
	}), 'VignetteSharp');
	
	exports.default = _default;

/***/ },
/* 6391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M3 19h18V5H3v14zm9-13c4.42 0 8 2.69 8 6s-3.58 6-8 6-8-2.69-8-6 3.58-6 8-6z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zm-9-1c4.42 0 8-2.69 8-6s-3.58-6-8-6-8 2.69-8 6 3.58 6 8 6zm0-10c3.25 0 6 1.83 6 4s-2.75 4-6 4-6-1.83-6-4 2.75-4 6-4z"
	})), 'VignetteTwoTone');
	
	exports.default = _default;

/***/ },
/* 6392 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
	}), 'Visibility');
	
	exports.default = _default;

/***/ },
/* 6393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
	}), 'VisibilityOff');
	
	exports.default = _default;

/***/ },
/* 6394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z"
	}), 'VisibilityOffOutlined');
	
	exports.default = _default;

/***/ },
/* 6395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6.5c2.76 0 5 2.24 5 5 0 .51-.1 1-.24 1.46l3.06 3.06c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l2.17 2.17c.47-.14.96-.24 1.47-.24zM2.71 3.16c-.39.39-.39 1.02 0 1.41l1.97 1.97C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.97-.3 4.31-.82l2.72 2.72c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L4.13 3.16c-.39-.39-1.03-.39-1.42 0zM12 16.5c-2.76 0-5-2.24-5-5 0-.77.18-1.5.49-2.14l1.57 1.57c-.03.18-.06.37-.06.57 0 1.66 1.34 3 3 3 .2 0 .38-.03.57-.07L14.14 16c-.65.32-1.37.5-2.14.5zm2.97-5.33c-.15-1.4-1.25-2.49-2.64-2.64l2.64 2.64z"
	}), 'VisibilityOffRounded');
	
	exports.default = _default;

/***/ },
/* 6396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6.5c2.76 0 5 2.24 5 5 0 .51-.1 1-.24 1.46l3.06 3.06c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l2.17 2.17c.47-.14.96-.24 1.47-.24zM3.42 2.45L2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.97-.3 4.31-.82l3.43 3.43 1.41-1.41L3.42 2.45zM12 16.5c-2.76 0-5-2.24-5-5 0-.77.18-1.5.49-2.14l1.57 1.57c-.03.18-.06.37-.06.57 0 1.66 1.34 3 3 3 .2 0 .38-.03.57-.07L14.14 16c-.65.32-1.37.5-2.14.5zm2.97-5.33c-.15-1.4-1.25-2.49-2.64-2.64l2.64 2.64z"
	}), 'VisibilityOffSharp');
	
	exports.default = _default;

/***/ },
/* 6397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 14c.04 0 .08-.01.12-.01l-2.61-2.61c0 .04-.01.08-.01.12 0 1.38 1.12 2.5 2.5 2.5zm1.01-4.79l1.28 1.28c-.26-.57-.71-1.03-1.28-1.28zm7.81 2.29C19.17 8.13 15.79 6 12 6c-.68 0-1.34.09-1.99.22l.92.92c.35-.09.7-.14 1.07-.14 2.48 0 4.5 2.02 4.5 4.5 0 .37-.06.72-.14 1.07l2.05 2.05c.98-.86 1.81-1.91 2.41-3.12zM12 17c.95 0 1.87-.13 2.75-.39l-.98-.98c-.54.24-1.14.37-1.77.37-2.48 0-4.5-2.02-4.5-4.5 0-.63.13-1.23.36-1.77L6.11 7.97c-1.22.91-2.23 2.1-2.93 3.52C4.83 14.86 8.21 17 12 17z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm2.28 4.49l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.06-1.07.14L13 9.21c.58.25 1.03.71 1.28 1.28zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z"
	})), 'VisibilityOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 6398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"
	}), 'VisibilityOutlined');
	
	exports.default = _default;

/***/ },
/* 6399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
	}), 'VisibilityRounded');
	
	exports.default = _default;

/***/ },
/* 6400 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
	}), 'VisibilitySharp');
	
	exports.default = _default;

/***/ },
/* 6401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 6c-3.79 0-7.17 2.13-8.82 5.5C4.83 14.87 8.21 17 12 17s7.17-2.13 8.82-5.5C19.17 8.13 15.79 6 12 6zm0 10c-2.48 0-4.5-2.02-4.5-4.5S9.52 7 12 7s4.5 2.02 4.5 4.5S14.48 16 12 16z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 13c-3.79 0-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6s7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17zm0-10c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7zm0 7c-1.38 0-2.5-1.12-2.5-2.5S10.62 9 12 9s2.5 1.12 2.5 2.5S13.38 14 12 14z"
	})), 'VisibilityTwoTone');
	
	exports.default = _default;

/***/ },
/* 6402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12l-4-3.2V14H6V6h8v3.2L18 6v8z"
	}), 'VoiceChat');
	
	exports.default = _default;

/***/ },
/* 6403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-6-5.4l3 2.4V7l-3 2.4V7H7v6h7z"
	}), 'VoiceChatOutlined');
	
	exports.default = _default;

/***/ },
/* 6404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-3.62 10.7L14 10.8V13c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v2.2l2.38-1.9c.65-.52 1.62-.06 1.62.78v3.84c0 .84-.97 1.3-1.62.78z"
	}), 'VoiceChatRounded');
	
	exports.default = _default;

/***/ },
/* 6405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 2H2.01L2 22l4-4h16V2zm-4 12l-4-3.2V14H6V6h8v3.2L18 6v8z"
	}), 'VoiceChatSharp');
	
	exports.default = _default;

/***/ },
/* 6406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 17.17L5.17 16H20V4H4v13.17zM7 7h7v2.4L17 7v6l-3-2.4V13H7V7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-6-5.4l3 2.4V7l-3 2.4V7H7v6h7z"
	})), 'VoiceChatTwoTone');
	
	exports.default = _default;

/***/ },
/* 6407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.99 9.18c0-.06.01-.12.01-.18 0-2.21-1.79-4-4-4-.06 0-.12.01-.18.01l4.17 4.17zm-6.1-3.56L4.27 3 3 4.27l2.62 2.62C5.23 7.5 5 8.22 5 9c0 2.21 1.79 4 4 4 .78 0 1.5-.23 2.11-.62L19.73 21 21 19.73l-8.62-8.62-5.49-5.49zM9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z"
	}), 'VoiceOverOff');
	
	exports.default = _default;

/***/ },
/* 6408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.76 5.36l-1.68 1.69c.8 1.13.83 2.58.09 3.74l1.7 1.7c1.9-2.02 1.87-4.98-.11-7.13zM20.07 2l-1.63 1.63c2.72 2.97 2.76 7.39.14 10.56l1.64 1.64c3.74-3.89 3.71-9.84-.15-13.83zM9.43 5.04l3.53 3.53c-.2-1.86-1.67-3.33-3.53-3.53zM4.41 2.86L3 4.27l2.62 2.62C5.23 7.5 5 8.22 5 9c0 2.21 1.79 4 4 4 .78 0 1.5-.23 2.11-.62l4.4 4.4C13.74 15.6 10.78 15 9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-.37-.11-.7-.29-1.02L19.73 21l1.41-1.41L4.41 2.86zM3 19c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H3zm6-8c-1.1 0-2-.9-2-2 0-.22.04-.42.11-.62l2.51 2.51c-.2.07-.4.11-.62.11z"
	}), 'VoiceOverOffOutlined');
	
	exports.default = _default;

/***/ },
/* 6409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.72 6.41c-.35.35-.44.88-.25 1.35.3.75.32 1.58.05 2.34-.16.46-.06.98.29 1.32.6.6 1.66.47 2.02-.31.64-1.39.6-2.99-.12-4.41-.4-.75-1.41-.88-1.99-.29zm3.46-3.52c-.4.4-.46 1.02-.13 1.48 1.93 2.68 1.95 6.25.09 9.07-.31.46-.23 1.08.16 1.47.51.51 1.38.46 1.81-.13 2.57-3.51 2.52-8.2-.17-11.77-.43-.56-1.26-.62-1.76-.12zM9.43 5.04l3.53 3.53c-.2-1.86-1.67-3.33-3.53-3.53zM3.71 3.56c-.39.39-.39 1.02 0 1.41l1.91 1.91c-.56.89-.79 2.01-.47 3.2.36 1.33 1.44 2.4 2.77 2.77 1.19.33 2.31.09 3.2-.47l4.4 4.4C13.74 15.6 10.78 15 9 15c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-.37-.11-.7-.29-1.02l2.31 2.31c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L5.12 3.56a.9959.9959 0 00-1.41 0z"
	}), 'VoiceOverOffRounded');
	
	exports.default = _default;

/***/ },
/* 6410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.76 5.36l-1.68 1.69c.8 1.13.83 2.58.09 3.74l1.7 1.7c1.9-2.02 1.87-4.98-.11-7.13zM20.07 2l-1.63 1.63c2.72 2.97 2.76 7.39.14 10.56l1.64 1.64c3.74-3.89 3.71-9.84-.15-13.83zM9.43 5.04l3.53 3.53c-.2-1.86-1.67-3.33-3.53-3.53zM4.41 2.86L3 4.27l2.62 2.62C5.23 7.5 5 8.22 5 9c0 2.21 1.79 4 4 4 .78 0 1.5-.23 2.11-.62l4.4 4.4C13.74 15.6 10.78 15 9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-.37-.11-.7-.29-1.02L19.73 21l1.41-1.41L4.41 2.86z"
	}), 'VoiceOverOffSharp');
	
	exports.default = _default;

/***/ },
/* 6411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9 17c-2.69 0-5.77 1.28-6 2h12c-.2-.71-3.3-2-6-2zM7 9c0 1.1.9 2 2 2 .22 0 .42-.04.62-.11L7.11 8.38c-.07.2-.11.4-.11.62z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16.76 5.36l-1.68 1.69c.8 1.13.83 2.58.09 3.74l1.7 1.7c1.9-2.02 1.87-4.98-.11-7.13zM20.07 2l-1.63 1.63c2.72 2.97 2.76 7.39.14 10.56l1.64 1.64c3.74-3.89 3.71-9.84-.15-13.83zM9.43 5.04l3.53 3.53c-.2-1.86-1.67-3.33-3.53-3.53zM4.41 2.86L3 4.27l2.62 2.62C5.23 7.5 5 8.22 5 9c0 2.21 1.79 4 4 4 .78 0 1.5-.23 2.11-.62l4.4 4.4C13.74 15.6 10.78 15 9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-.37-.11-.7-.29-1.02L19.73 21l1.41-1.41L4.41 2.86zM3 19c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H3zm6-8c-1.1 0-2-.9-2-2 0-.22.04-.42.11-.62l2.51 2.51c-.2.07-.4.11-.62.11z"
	})), 'VoiceOverOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 6412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z"
	}), 'Voicemail');
	
	exports.default = _default;

/***/ },
/* 6413 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z"
	}), 'VoicemailOutlined');
	
	exports.default = _default;

/***/ },
/* 6414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z"
	}), 'VoicemailRounded');
	
	exports.default = _default;

/***/ },
/* 6415 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z"
	}), 'VoicemailSharp');
	
	exports.default = _default;

/***/ },
/* 6416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z"
	}), 'VoicemailTwoTone');
	
	exports.default = _default;

/***/ },
/* 6417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z"
	}), 'VolumeDown');
	
	exports.default = _default;

/***/ },
/* 6418 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02 0-1.77-1.02-3.29-2.5-4.03zM5 9v6h4l5 5V4L9 9H5zm7-.17v6.34L9.83 13H7v-2h2.83L12 8.83z"
	}), 'VolumeDownOutlined');
	
	exports.default = _default;

/***/ },
/* 6419 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 10v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.41c0-.89-1.08-1.34-1.71-.71L9 9H6c-.55 0-1 .45-1 1z"
	}), 'VolumeDownRounded');
	
	exports.default = _default;

/***/ },
/* 6420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z"
	}), 'VolumeDownSharp');
	
	exports.default = _default;

/***/ },
/* 6421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 13h2.83L12 15.17V8.83L9.83 11H7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02 0-1.77-1.02-3.29-2.5-4.03zM5 9v6h4l5 5V4L9 9H5zm7-.17v6.34L9.83 13H7v-2h2.83L12 8.83z"
	})), 'VolumeDownTwoTone');
	
	exports.default = _default;

/***/ },
/* 6422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 9v6h4l5 5V4l-5 5H7z"
	}), 'VolumeMute');
	
	exports.default = _default;

/***/ },
/* 6423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 8.83v6.34L11.83 13H9v-2h2.83L14 8.83M16 4l-5 5H7v6h4l5 5V4z"
	}), 'VolumeMuteOutlined');
	
	exports.default = _default;

/***/ },
/* 6424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 10v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.41c0-.89-1.08-1.34-1.71-.71L11 9H8c-.55 0-1 .45-1 1z"
	}), 'VolumeMuteRounded');
	
	exports.default = _default;

/***/ },
/* 6425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 9v6h4l5 5V4l-5 5H7z"
	}), 'VolumeMuteSharp');
	
	exports.default = _default;

/***/ },
/* 6426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M9 13h2.83L14 15.17V8.83L11.83 11H9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M7 9v6h4l5 5V4l-5 5H7zm7-.17v6.34L11.83 13H9v-2h2.83L14 8.83z"
	})), 'VolumeMuteTwoTone');
	
	exports.default = _default;

/***/ },
/* 6427 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
	}), 'VolumeOff');
	
	exports.default = _default;

/***/ },
/* 6428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.34 2.93L2.93 4.34 7.29 8.7 7 9H3v6h4l5 5v-6.59l4.18 4.18c-.65.49-1.38.88-2.18 1.11v2.06c1.34-.3 2.57-.92 3.61-1.75l2.05 2.05 1.41-1.41L4.34 2.93zM10 15.17L7.83 13H5v-2h2.83l.88-.88L10 11.41v3.76zM19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87 0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zm-7-8l-1.88 1.88L12 7.76zm4.5 8c0-1.77-1.02-3.29-2.5-4.03v1.79l2.48 2.48c.01-.08.02-.16.02-.24z"
	}), 'VolumeOffOutlined');
	
	exports.default = _default;

/***/ },
/* 6429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.63 3.63c-.39.39-.39 1.02 0 1.41L7.29 8.7 7 9H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71v-4.17l4.18 4.18c-.49.37-1.02.68-1.6.91-.36.15-.58.53-.58.92 0 .72.73 1.18 1.39.91.8-.33 1.55-.77 2.22-1.31l1.34 1.34c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L5.05 3.63c-.39-.39-1.02-.39-1.42 0zM19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87 0-3.83-2.4-7.11-5.78-8.4-.59-.23-1.22.23-1.22.86v.19c0 .38.25.71.61.85C17.18 6.54 19 9.06 19 12zm-8.71-6.29l-.17.17L12 7.76V6.41c0-.89-1.08-1.33-1.71-.7zM16.5 12c0-1.77-1.02-3.29-2.5-4.03v1.79l2.48 2.48c.01-.08.02-.16.02-.24z"
	}), 'VolumeOffRounded');
	
	exports.default = _default;

/***/ },
/* 6430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.34 2.93L2.93 4.34 7.29 8.7 7 9H3v6h4l5 5v-6.59l4.18 4.18c-.65.49-1.38.88-2.18 1.11v2.06c1.34-.3 2.57-.92 3.61-1.75l2.05 2.05 1.41-1.41L4.34 2.93zM19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87 0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zm-7-8l-1.88 1.88L12 7.76zm4.5 8c0-1.77-1.02-3.29-2.5-4.03v1.79l2.48 2.48c.01-.08.02-.16.02-.24z"
	}), 'VolumeOffSharp');
	
	exports.default = _default;

/***/ },
/* 6431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7.83 11H5v2h2.83L10 15.17v-3.76l-1.29-1.29z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M4.34 2.93L2.93 4.34 7.29 8.7 7 9H3v6h4l5 5v-6.59l4.18 4.18c-.65.49-1.38.88-2.18 1.11v2.06c1.34-.3 2.57-.92 3.61-1.75l2.05 2.05 1.41-1.41L4.34 2.93zM10 15.17L7.83 13H5v-2h2.83l.88-.88L10 11.41v3.76zM19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87 0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zm-7-8l-1.88 1.88L12 7.76zm4.5 8c0-1.77-1.02-3.29-2.5-4.03v1.79l2.48 2.48c.01-.08.02-.16.02-.24z"
	})), 'VolumeOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 6432 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
	}), 'VolumeUp');
	
	exports.default = _default;

/***/ },
/* 6433 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 9v6h4l5 5V4L7 9H3zm7-.17v6.34L7.83 13H5v-2h2.83L10 8.83zM16.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77 0-4.28-2.99-7.86-7-8.77z"
	}), 'VolumeUpOutlined');
	
	exports.default = _default;

/***/ },
/* 6434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 10v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.41c0-.89-1.08-1.34-1.71-.71L7 9H4c-.55 0-1 .45-1 1zm13.5 2c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 4.45v.2c0 .38.25.71.6.85C17.18 6.53 19 9.06 19 12s-1.82 5.47-4.4 6.5c-.36.14-.6.47-.6.85v.2c0 .63.63 1.07 1.21.85C18.6 19.11 21 15.84 21 12s-2.4-7.11-5.79-8.4c-.58-.23-1.21.22-1.21.85z"
	}), 'VolumeUpRounded');
	
	exports.default = _default;

/***/ },
/* 6435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
	}), 'VolumeUpSharp');
	
	exports.default = _default;

/***/ },
/* 6436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 13h2.83L10 15.17V8.83L7.83 11H5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3 9v6h4l5 5V4L7 9H3zm7-.17v6.34L7.83 13H5v-2h2.83L10 8.83zm4-.86v8.05c1.48-.73 2.5-2.25 2.5-4.02 0-1.77-1.02-3.29-2.5-4.03zm0-4.74v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77 0-4.28-2.99-7.86-7-8.77z"
	})), 'VolumeUpTwoTone');
	
	exports.default = _default;

/***/ },
/* 6437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'VpnKey');
	
	exports.default = _default;

/***/ },
/* 6438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 19h-6v-4h-2.68c-1.14 2.42-3.6 4-6.32 4-3.86 0-7-3.14-7-7s3.14-7 7-7c2.72 0 5.17 1.58 6.32 4H24v6h-2v4zm-4-2h2v-4h2v-2H11.94l-.23-.67C11.01 8.34 9.11 7 7 7c-2.76 0-5 2.24-5 5s2.24 5 5 5c2.11 0 4.01-1.34 4.71-3.33l.23-.67H18v4zM7 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
	}), 'VpnKeyOutlined');
	
	exports.default = _default;

/***/ },
/* 6439 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.65 10C11.7 7.31 8.9 5.5 5.77 6.12c-2.29.46-4.15 2.29-4.63 4.58C.32 14.57 3.26 18 7 18c2.61 0 4.83-1.67 5.65-4H17v2c0 1.1.9 2 2 2s2-.9 2-2v-2c1.1 0 2-.9 2-2s-.9-2-2-2h-8.35zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'VpnKeyRounded');
	
	exports.default = _default;

/***/ },
/* 6440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
	}), 'VpnKeySharp');
	
	exports.default = _default;

/***/ },
/* 6441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M11.71 10.33C11.01 8.34 9.11 7 7 7c-2.76 0-5 2.24-5 5s2.24 5 5 5c2.11 0 4.01-1.34 4.71-3.33l.23-.67H18v4h2v-4h2v-2H11.94l-.23-.67zM7 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M7 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c2.72 0 5.17-1.58 6.32-4H16v4h6v-4h2V9H13.32C12.17 6.58 9.72 5 7 5zm15 8h-2v4h-2v-4h-6.06l-.23.67C11.01 15.66 9.11 17 7 17c-2.76 0-5-2.24-5-5s2.24-5 5-5c2.11 0 4.01 1.34 4.71 3.33l.23.67H22v2zM7 9c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
	})), 'VpnKeyTwoTone');
	
	exports.default = _default;

/***/ },
/* 6442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 4v-.5C22 2.12 20.88 1 19.5 1S17 2.12 17 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4zm-2.28 8c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03zM10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2v1.93z"
	}), 'VpnLock');
	
	exports.default = _default;

/***/ },
/* 6443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.92 12c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03zM10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2v1.93zM22 4v-.5C22 2.12 20.88 1 19.5 1S17 2.12 17 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V4z"
	}), 'VpnLockOutlined');
	
	exports.default = _default;

/***/ },
/* 6444 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M18.92 12c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03zM10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2v1.93zM22 4v-.5C22 2.12 20.88 1 19.5 1S17 2.12 17 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V4z"
	}), 'VpnLockRounded');
	
	exports.default = _default;

/***/ },
/* 6445 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 13c0 2.08-.8 3.97-2.1 5.39V17H14v-4H7v-2h3V8h4V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03c.04.33.08.66.08 1zm-9 7.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v3h2v1.93zM22 4v-.36c0-1.31-.94-2.5-2.24-2.63C18.26.86 17 2.03 17 3.5V4h-1v6h7V4h-1zm-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V4z"
	}), 'VpnLockSharp');
	
	exports.default = _default;

/***/ },
/* 6446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 8h-2v2c0 .55-.45 1-1 1H7v2h6c.55 0 1 .45 1 1v3h1c.9 0 1.64.58 1.9 1.39C18.2 16.97 19 15.08 19 13c0-.34-.04-.67-.08-1H17c-1.65 0-3-1.35-3-3V6c0 1.1-.9 2-2 2zm-4 9v-1l-4.79-4.79C3.08 11.79 3 12.38 3 13c0 4.08 3.05 7.44 7 7.93V19c-1.1 0-2-.9-2-2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M18.92 12c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03zM10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2v1.93zM22 4v-.5C22 2.12 20.88 1 19.5 1S17 2.12 17 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V4z"
	})), 'VpnLockTwoTone');
	
	exports.default = _default;

/***/ },
/* 6447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z"
	}), 'Wallpaper');
	
	exports.default = _default;

/***/ },
/* 6448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z"
	}), 'WallpaperOutlined');
	
	exports.default = _default;

/***/ },
/* 6449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 5c0-.55.45-1 1-1h5c.55 0 1-.45 1-1s-.45-1-1-1H4c-1.1 0-2 .9-2 2v6c0 .55.45 1 1 1s1-.45 1-1V5zm5.61 8.49l-2.96 3.7c-.26.33-.03.81.39.81H17c.41 0 .65-.47.4-.8l-2-2.67c-.2-.27-.6-.27-.8 0l-1.63 2.18-2.58-3.22c-.2-.25-.58-.25-.78 0zM17 8.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-6c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1 .45 1 1v5c0 .55.45 1 1 1s1-.45 1-1V4c0-1.1-.9-2-2-2zm0 17c0 .55-.45 1-1 1h-5c-.55 0-1 .45-1 1s.45 1 1 1h6c1.1 0 2-.9 2-2v-6c0-.55-.45-1-1-1s-1 .45-1 1v5zM3 13c-.55 0-1 .45-1 1v6c0 1.1.9 2 2 2h6c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1-.45-1-1v-5c0-.55-.45-1-1-1z"
	}), 'WallpaperRounded');
	
	exports.default = _default;

/***/ },
/* 6450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 4h7V2H2v9h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM22 2h-9v2h7v7h2V2zm-2 18h-7v2h9v-9h-2v7zM4 13H2v9h9v-2H4v-7z"
	}), 'WallpaperSharp');
	
	exports.default = _default;

/***/ },
/* 6451 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z"
	}), 'WallpaperTwoTone');
	
	exports.default = _default;

/***/ },
/* 6452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
	}), 'Warning');
	
	exports.default = _default;

/***/ },
/* 6453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
	}), 'WarningOutlined');
	
	exports.default = _default;

/***/ },
/* 6454 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.47 21h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18c-.77 1.33.19 3 1.73 3zM12 14c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z"
	}), 'WarningRounded');
	
	exports.default = _default;

/***/ },
/* 6455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
	}), 'WarningSharp');
	
	exports.default = _default;

/***/ },
/* 6456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4.47 19h15.06L12 5.99 4.47 19zM13 18h-2v-2h2v2zm0-4h-2v-4h2v4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M1 21h22L12 2 1 21zm3.47-2L12 5.99 19.53 19H4.47zM11 16h2v2h-2zm0-6h2v4h-2z"
	})), 'WarningTwoTone');
	
	exports.default = _default;

/***/ },
/* 6457 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 12c0-2.54-1.19-4.81-3.04-6.27L16 0H8l-.95 5.73C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27L8 24h8l.96-5.73C18.81 16.81 20 14.54 20 12zM6 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6z"
	}), 'Watch');
	
	exports.default = _default;

/***/ },
/* 6458 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z"
	}), 'WatchLater');
	
	exports.default = _default;

/***/ },
/* 6459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.2 3.2.8-1.3-4.5-2.7V7z"
	}), 'WatchLaterOutlined');
	
	exports.default = _default;

/***/ },
/* 6460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm3.55 13.8l-4.08-2.51c-.3-.18-.48-.5-.48-.85V7.75c.01-.41.35-.75.76-.75s.75.34.75.75v4.45l3.84 2.31c.36.22.48.69.26 1.05-.22.35-.69.46-1.05.24z"
	}), 'WatchLaterRounded');
	
	exports.default = _default;

/***/ },
/* 6461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z"
	}), 'WatchLaterSharp');
	
	exports.default = _default;

/***/ },
/* 6462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm4.2 12.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.2 3.2.8-1.3-4.5-2.7V7z"
	})), 'WatchLaterTwoTone');
	
	exports.default = _default;

/***/ },
/* 6463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14.31 2l.41 2.48C13.87 4.17 12.96 4 12 4c-.95 0-1.87.17-2.71.47L9.7 2h4.61m.41 17.52L14.31 22H9.7l-.41-2.47c.84.3 1.76.47 2.71.47.96 0 1.87-.17 2.72-.48M16 0H8l-.95 5.73C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27L8 24h8l.96-5.73C18.81 16.81 20 14.54 20 12s-1.19-4.81-3.04-6.27L16 0zm-4 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
	}), 'WatchOutlined');
	
	exports.default = _default;

/***/ },
/* 6464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 12c0-2.54-1.19-4.81-3.04-6.27l-.68-4.06C16.12.71 15.28 0 14.31 0H9.7c-.98 0-1.82.71-1.98 1.67l-.67 4.06C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27l.67 4.06c.16.96 1 1.67 1.98 1.67h4.61c.98 0 1.81-.71 1.97-1.67l.68-4.06C18.81 16.81 20 14.54 20 12zM6 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6z"
	}), 'WatchRounded');
	
	exports.default = _default;

/***/ },
/* 6465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 12c0-2.54-1.19-4.81-3.04-6.27L16 0H8l-.95 5.73C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27L8 24h8l.96-5.73C18.81 16.81 20 14.54 20 12zM6 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6z"
	}), 'WatchSharp');
	
	exports.default = _default;

/***/ },
/* 6466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14.72 4.48L14.31 2H9.7l-.41 2.47C10.13 4.17 11.05 4 12 4c.96 0 1.87.17 2.72.48zM9.29 19.53L9.7 22h4.61l.41-2.48c-.85.31-1.76.48-2.72.48-.95 0-1.87-.17-2.71-.47z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16.96 5.73L16 0H8l-.95 5.73C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27L8 24h8l.96-5.73C18.81 16.81 20 14.54 20 12s-1.19-4.81-3.04-6.27zM9.7 2h4.61l.41 2.48C13.87 4.17 12.96 4 12 4c-.95 0-1.87.17-2.71.47L9.7 2zm4.61 20H9.7l-.41-2.47c.84.3 1.76.47 2.71.47.96 0 1.87-.17 2.72-.48L14.31 22zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
	})), 'WatchTwoTone');
	
	exports.default = _default;

/***/ },
/* 6467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 16.99c-1.35 0-2.2.42-2.95.8-.65.33-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.38-1.57-.8-2.95-.8s-2.2.42-2.95.8c-.65.33-1.17.6-2.05.6v1.95c1.35 0 2.2-.42 2.95-.8.65-.33 1.17-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.42 2.95-.8c.65-.33 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8v-1.95c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8zm0-4.45c-1.35 0-2.2.43-2.95.8-.65.32-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.38-1.57-.8-2.95-.8s-2.2.43-2.95.8c-.65.32-1.17.6-2.05.6v1.95c1.35 0 2.2-.43 2.95-.8.65-.35 1.15-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.35 1.15-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.58.8 2.95.8v-1.95c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8zm2.95-8.08c-.75-.38-1.58-.8-2.95-.8s-2.2.42-2.95.8c-.65.32-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.37-1.57-.8-2.95-.8s-2.2.42-2.95.8c-.65.33-1.17.6-2.05.6v1.93c1.35 0 2.2-.43 2.95-.8.65-.33 1.17-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.32 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8V5.04c-.9 0-1.4-.25-2.05-.58zM17 8.09c-1.35 0-2.2.43-2.95.8-.65.35-1.15.6-2.05.6s-1.4-.25-2.05-.6c-.75-.38-1.57-.8-2.95-.8s-2.2.43-2.95.8c-.65.35-1.15.6-2.05.6v1.95c1.35 0 2.2-.43 2.95-.8.65-.32 1.18-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.32 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8V9.49c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8z"
	}), 'Waves');
	
	exports.default = _default;

/***/ },
/* 6468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 16.99c-1.35 0-2.2.42-2.95.8-.65.33-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.38-1.57-.8-2.95-.8s-2.2.42-2.95.8c-.65.33-1.17.6-2.05.6v1.95c1.35 0 2.2-.42 2.95-.8.65-.33 1.17-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.42 2.95-.8c.65-.33 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8v-1.95c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8zm0-4.45c-1.35 0-2.2.43-2.95.8-.65.32-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.38-1.57-.8-2.95-.8s-2.2.43-2.95.8c-.65.32-1.17.6-2.05.6v1.95c1.35 0 2.2-.43 2.95-.8.65-.35 1.15-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.35 1.15-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.58.8 2.95.8v-1.95c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8zm2.95-8.08c-.75-.38-1.58-.8-2.95-.8s-2.2.42-2.95.8c-.65.32-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.37-1.57-.8-2.95-.8s-2.2.42-2.95.8c-.65.33-1.17.6-2.05.6v1.93c1.35 0 2.2-.43 2.95-.8.65-.33 1.17-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.32 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8V5.04c-.9 0-1.4-.25-2.05-.58zM17 8.09c-1.35 0-2.2.43-2.95.8-.65.35-1.15.6-2.05.6s-1.4-.25-2.05-.6c-.75-.38-1.57-.8-2.95-.8s-2.2.43-2.95.8c-.65.35-1.15.6-2.05.6v1.95c1.35 0 2.2-.43 2.95-.8.65-.32 1.18-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.32 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8V9.49c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8z"
	}), 'WavesOutlined');
	
	exports.default = _default;

/***/ },
/* 6469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 16.99c-1.35 0-2.2.42-2.95.8-.65.33-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.38-1.57-.8-2.95-.8s-2.2.42-2.95.8c-.43.22-.81.41-1.27.52-.45.1-.78.46-.78.91v.1c0 .6.56 1.03 1.14.91.74-.15 1.3-.43 1.81-.69.65-.33 1.17-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.42 2.95-.8c.65-.33 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.52.26 1.08.55 1.83.7.58.11 1.12-.33 1.12-.91v-.09c0-.46-.34-.82-.79-.92-.46-.1-.83-.29-1.26-.52-.75-.39-1.6-.81-2.95-.81zm0-4.45c-1.35 0-2.2.43-2.95.8-.65.32-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.38-1.57-.8-2.95-.8s-2.2.43-2.95.8c-.43.21-.81.41-1.28.52-.44.1-.77.46-.77.91v.1c0 .59.54 1.03 1.12.91.75-.15 1.31-.44 1.83-.69.65-.35 1.15-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.35 1.15-.6 2.05-.6s1.4.25 2.05.6c.52.26 1.08.55 1.83.7.58.11 1.12-.33 1.12-.92v-.09c0-.46-.34-.82-.79-.92-.46-.1-.83-.29-1.26-.52-.75-.38-1.6-.8-2.95-.8zm2.95-8.08c-.75-.38-1.58-.8-2.95-.8s-2.2.42-2.95.8c-.65.32-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.37-1.57-.8-2.95-.8s-2.2.42-2.95.8c-.43.22-.81.41-1.27.52-.45.1-.78.46-.78.91v.07c0 .6.54 1.04 1.12.92.75-.15 1.31-.44 1.83-.69.65-.33 1.17-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.32 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.52.26 1.08.55 1.83.7.58.11 1.12-.33 1.12-.92v-.09c0-.46-.34-.82-.79-.92-.46-.1-.83-.28-1.26-.5zM17 8.09c-1.35 0-2.2.43-2.95.8-.65.35-1.15.6-2.05.6s-1.4-.25-2.05-.6c-.75-.38-1.57-.8-2.95-.8s-2.2.43-2.95.8c-.43.23-.8.42-1.26.52-.45.1-.79.46-.79.92v.09c0 .59.54 1.03 1.12.91.75-.15 1.31-.44 1.83-.69.65-.32 1.18-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.32 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.52.26 1.08.55 1.83.7.58.11 1.12-.33 1.12-.91v-.09c0-.46-.34-.82-.79-.92-.46-.1-.83-.29-1.26-.52-.75-.39-1.6-.81-2.95-.81z"
	}), 'WavesRounded');
	
	exports.default = _default;

/***/ },
/* 6470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 16.99c-1.35 0-2.2.42-2.95.8-.65.33-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.38-1.57-.8-2.95-.8s-2.2.42-2.95.8c-.65.33-1.17.6-2.05.6v1.95c1.35 0 2.2-.42 2.95-.8.65-.33 1.17-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.42 2.95-.8c.65-.33 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8v-1.95c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8zm0-4.45c-1.35 0-2.2.43-2.95.8-.65.32-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.38-1.57-.8-2.95-.8s-2.2.43-2.95.8c-.65.32-1.17.6-2.05.6v1.95c1.35 0 2.2-.43 2.95-.8.65-.35 1.15-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.35 1.15-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.58.8 2.95.8v-1.95c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8zm2.95-8.08c-.75-.38-1.58-.8-2.95-.8s-2.2.42-2.95.8c-.65.32-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.37-1.57-.8-2.95-.8s-2.2.42-2.95.8c-.65.33-1.17.6-2.05.6v1.93c1.35 0 2.2-.43 2.95-.8.65-.33 1.17-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.32 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8V5.04c-.9 0-1.4-.25-2.05-.58zM17 8.09c-1.35 0-2.2.43-2.95.8-.65.35-1.15.6-2.05.6s-1.4-.25-2.05-.6c-.75-.38-1.57-.8-2.95-.8s-2.2.43-2.95.8c-.65.35-1.15.6-2.05.6v1.95c1.35 0 2.2-.43 2.95-.8.65-.32 1.18-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.32 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8V9.49c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8z"
	}), 'WavesSharp');
	
	exports.default = _default;

/***/ },
/* 6471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17 16.99c-1.35 0-2.2.42-2.95.8-.65.33-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.38-1.57-.8-2.95-.8s-2.2.42-2.95.8c-.65.33-1.17.6-2.05.6v1.95c1.35 0 2.2-.42 2.95-.8.65-.33 1.17-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.42 2.95-.8c.65-.33 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8v-1.95c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8zm0-4.45c-1.35 0-2.2.43-2.95.8-.65.32-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.38-1.57-.8-2.95-.8s-2.2.43-2.95.8c-.65.32-1.17.6-2.05.6v1.95c1.35 0 2.2-.43 2.95-.8.65-.35 1.15-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.35 1.15-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.58.8 2.95.8v-1.95c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8zm2.95-8.08c-.75-.38-1.58-.8-2.95-.8s-2.2.42-2.95.8c-.65.32-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.37-1.57-.8-2.95-.8s-2.2.42-2.95.8c-.65.33-1.17.6-2.05.6v1.93c1.35 0 2.2-.43 2.95-.8.65-.33 1.17-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.32 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8V5.04c-.9 0-1.4-.25-2.05-.58zM17 8.09c-1.35 0-2.2.43-2.95.8-.65.35-1.15.6-2.05.6s-1.4-.25-2.05-.6c-.75-.38-1.57-.8-2.95-.8s-2.2.43-2.95.8c-.65.35-1.15.6-2.05.6v1.95c1.35 0 2.2-.43 2.95-.8.65-.32 1.18-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.32 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8V9.49c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8z"
	}), 'WavesTwoTone');
	
	exports.default = _default;

/***/ },
/* 6472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.85 12.65h2.3L8 9l-1.15 3.65zM22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76C12.77 5.17 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c3.13 0 5.84-1.81 7.15-4.43l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22zm-11.7 9l-.7-2H6.4l-.7 2H3.8L7 7h2l3.2 9h-1.9z"
	}), 'WbAuto');
	
	exports.default = _default;

/***/ },
/* 6473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 7l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L9 7H7zm-.15 5.65L8 9l1.15 3.65h-2.3zM22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76l-.01.01C12.76 5.18 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c2.96 0 5.55-1.61 6.93-4 .03-.06.05-.12.08-.18.05-.08.09-.17.14-.25l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22zm-8.63 7.67C12.38 16.64 10.35 18 8 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6c0 .96-.23 1.86-.63 2.67z"
	}), 'WbAutoOutlined');
	
	exports.default = _default;

/***/ },
/* 6474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.85 12.65h2.3L8 9zM22.72 7c-.42 0-.77.3-.85.7l-1.07 5.59-1.31-5.51c-.11-.46-.52-.78-.99-.78s-.88.32-.98.78l-1.31 5.51-1.07-5.59c-.08-.4-.44-.7-.85-.7-.01 0-.03.01-.04.01C12.78 5.18 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c3.17 0 5.9-1.85 7.2-4.52.2.32.55.52.94.52.51 0 .95-.35 1.07-.84L18.5 9.9l1.29 5.26c.12.49.57.84 1.07.84.52 0 .96-.36 1.08-.86l1.61-7.08c.13-.54-.28-1.06-.83-1.06zm-11.79 9c-.38 0-.72-.24-.84-.6L9.6 14H6.4l-.49 1.4c-.13.36-.46.6-.84.6-.62 0-1.05-.61-.84-1.19l2.44-6.86C6.87 7.38 7.4 7 8 7s1.13.38 1.34.94l2.44 6.86c.2.59-.23 1.2-.85 1.2z"
	}), 'WbAutoRounded');
	
	exports.default = _default;

/***/ },
/* 6475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.85 12.65h2.3L8 9l-1.15 3.65zM22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76C12.77 5.17 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c3.13 0 5.84-1.81 7.15-4.43l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22zm-11.7 9l-.7-2H6.4l-.7 2H3.8L7 7h2l3.2 9h-1.9z"
	}), 'WbAutoSharp');
	
	exports.default = _default;

/***/ },
/* 6476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M8 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.35 0 4.38-1.36 5.36-3.32l.01-.01c.4-.81.63-1.71.63-2.67 0-3.31-2.69-6-6-6zm2.3 10l-.7-2H6.4l-.7 2H3.8L7 7h2l3.2 9h-1.9zm-3.45-3.35h2.3L8 9z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M7 7l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L9 7H7zm-.15 5.65L8 9l1.15 3.65h-2.3zm13.95.64L19.3 7h-1.6l-1.49 6.29L15 7h-.76l-.01.01C12.76 5.18 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c2.96 0 5.55-1.61 6.93-4 .03-.06.05-.12.08-.18.05-.08.09-.17.14-.25l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22l-1.2 6.29zm-7.43 1.38C12.38 16.64 10.35 18 8 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6c0 .96-.23 1.86-.63 2.67z"
	})), 'WbAutoTwoTone');
	
	exports.default = _default;

/***/ },
/* 6477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.36 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96z"
	}), 'WbCloudy');
	
	exports.default = _default;

/***/ },
/* 6478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12.01 6c2.61 0 4.89 1.86 5.4 4.43l.3 1.5 1.52.11c1.56.11 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3h-13c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.95 6 12.01 6m0-2C9.12 4 6.6 5.64 5.35 8.04 2.35 8.36.01 10.91.01 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96C18.68 6.59 15.65 4 12.01 4z"
	}), 'WbCloudyOutlined');
	
	exports.default = _default;

/***/ },
/* 6479 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.37 10.04C18.68 6.59 15.65 4 12.01 4c-2.89 0-5.4 1.64-6.65 4.04C2.35 8.36.01 10.91.01 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96z"
	}), 'WbCloudyRounded');
	
	exports.default = _default;

/***/ },
/* 6480 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19.37 10.04C18.68 6.59 15.65 4 12.01 4c-2.89 0-5.4 1.64-6.65 4.04C2.35 8.36.01 10.91.01 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96z"
	}), 'WbCloudySharp');
	
	exports.default = _default;

/***/ },
/* 6481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M19.23 12.04l-1.52-.11-.3-1.5C16.89 7.86 14.62 6 12.01 6 9.95 6 8.08 7.14 7.13 8.96l-.5.95-1.07.11c-2.02.22-3.55 1.93-3.55 3.98 0 2.21 1.79 4 4 4h13c1.65 0 3-1.35 3-3 0-1.55-1.23-2.86-2.78-2.96z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19.36 10.04C18.67 6.59 15.65 4 12.01 4 9.11 4 6.6 5.64 5.35 8.04 2.35 8.36.01 10.91.01 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19.01 18h-13c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.95 6 12.01 6c2.61 0 4.89 1.86 5.4 4.43l.3 1.5 1.52.11c1.56.11 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3z"
	})), 'WbCloudyTwoTone');
	
	exports.default = _default;

/***/ },
/* 6482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.55 18.54l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8zM11 22.45h2V19.5h-2v2.95zM4 10.5H1v2h3v-2zm11-4.19V1.5H9v4.81C7.21 7.35 6 9.28 6 11.5c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19zm5 4.19v2h3v-2h-3zm-2.76 7.66l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4z"
	}), 'WbIncandescent');
	
	exports.default = _default;

/***/ },
/* 6483 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.55 19.09l1.41 1.41 1.79-1.8-1.41-1.41zM11 20h2v3h-2zM1 11h3v2H1zm12-6.95v3.96l1 .58c1.24.72 2 2.04 2 3.46 0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.42.77-2.74 2-3.46l1-.58V4.05h2m2-2H9v4.81C7.21 7.9 6 9.83 6 12.05c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19V2.05zM20 11h3v2h-3zm-2.76 7.71l1.79 1.8 1.41-1.41-1.8-1.79z"
	}), 'WbIncandescentOutlined');
	
	exports.default = _default;

/***/ },
/* 6484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.25 19.79c.39.39 1.02.39 1.41 0l.39-.39c.39-.39.38-1.02 0-1.4l-.01-.01a.9959.9959 0 00-1.41 0l-.39.39c-.38.4-.38 1.02.01 1.41zM11.99 23H12c.55 0 .99-.44.99-.99v-.96c0-.55-.44-.99-.99-.99h-.01c-.55 0-.99.44-.99.99v.96c0 .55.44.99.99.99zM3.01 11.05H1.99c-.55 0-.99.44-.99.99v.01c0 .55.44.99.99.99H3c.55 0 .99-.44.99-.99v-.01c.01-.55-.43-.99-.98-.99zM15 6.86V3.05c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v3.81c-2.04 1.18-3.32 3.52-2.93 6.13.4 2.61 2.56 4.7 5.18 5.02 3.64.44 6.75-2.4 6.75-5.95 0-2.23-1.21-4.16-3-5.2zm5 5.18v.01c0 .55.44.99.99.99H22c.55 0 .99-.44.99-.99v-.01c0-.55-.44-.99-.99-.99h-1.01c-.55 0-.99.44-.99.99zm-2.06 7.37l.39.39c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41l-.39-.39c-.39-.39-1.02-.38-1.4 0-.4.4-.4 1.02-.01 1.41z"
	}), 'WbIncandescentRounded');
	
	exports.default = _default;

/***/ },
/* 6485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3.55 19.09l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8zM11 23h2v-2.95h-2V23zM4 11.05H1v2h3v-2zm11-4.19V2.05H9v4.81C7.21 7.9 6 9.83 6 12.05c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19zm5 4.19v2h3v-2h-3zm-2.76 7.66l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4z"
	}), 'WbIncandescentSharp');
	
	exports.default = _default;

/***/ },
/* 6486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M14 8.59l-1-.58V4.05h-2v3.96l-1 .58c-1.24.72-2 2.04-2 3.46 0 2.21 1.79 4 4 4s4-1.79 4-4c0-1.42-.77-2.74-2-3.46z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M3.55 19.09l1.41 1.41 1.79-1.8-1.41-1.41zM11 20h2v3h-2zM1 11h3v2H1zm14-4.14V2.05H9v4.81C7.21 7.9 6 9.83 6 12.05c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19zm-3 9.19c-2.21 0-4-1.79-4-4 0-1.42.77-2.74 2-3.46l1-.58V4.05h2v3.96l1 .58c1.24.72 2 2.04 2 3.46 0 2.21-1.79 4-4 4zM20 11h3v2h-3zm-2.76 7.71l1.79 1.8 1.41-1.41-1.8-1.79z"
	})), 'WbIncandescentTwoTone');
	
	exports.default = _default;

/***/ },
/* 6487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 14.5h14v-6H5v6zM11 .55V3.5h2V.55h-2zm8.04 2.5l-1.79 1.79 1.41 1.41 1.8-1.79-1.42-1.41zM13 22.45V19.5h-2v2.95h2zm7.45-3.91l-1.8-1.79-1.41 1.41 1.79 1.8 1.42-1.42zM3.55 4.46l1.79 1.79 1.41-1.41-1.79-1.79-1.41 1.41zm1.41 15.49l1.79-1.8-1.41-1.41-1.79 1.79 1.41 1.42z"
	}), 'WbIridescent');
	
	exports.default = _default;

/***/ },
/* 6488 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 15h14V9H5v6zm2-4h10v2H7v-2zm4-10h2v3h-2zm9.46 4.01L19.04 3.6l-1.79 1.79 1.41 1.41zM11 20h2v3h-2zm6.24-1.29l1.79 1.8 1.42-1.42-1.8-1.79zM4.96 3.595l1.788 1.79L5.34 6.79 3.553 5.003zM3.55 19.08l1.41 1.42 1.79-1.8-1.41-1.41z"
	}), 'WbIridescentOutlined');
	
	exports.default = _default;

/***/ },
/* 6489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 15h12c.55 0 1-.45 1-1v-3.95c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1V14c0 .55.45 1 1 1zm5-13v1.05c0 .55.45.95 1 .95s1-.4 1-.95V2c0-.55-.45-1-1-1s-1 .45-1 1zm7.34 2.3l-.38.38c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l.38-.38c.39-.39.39-1.02 0-1.41a.9959.9959 0 00-1.41 0zM13 22v-.96c0-.55-.45-1-1-1s-1 .45-1 1V22c0 .55.45 1 1 1s1-.45 1-1zm6.74-3.61l-.39-.39a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41l.38.39c.39.39 1.02.39 1.41 0l.01-.01c.39-.38.39-1.02 0-1.4zM4.25 5.71l.39.39c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41l-.39-.39a.9959.9959 0 00-1.41 0c-.38.39-.38 1.03 0 1.41zm1.42 14.08l.38-.38c.39-.39.39-1.02 0-1.41a.9959.9959 0 00-1.41 0l-.38.38c-.39.39-.39 1.02 0 1.41.38.39 1.02.39 1.41 0z"
	}), 'WbIridescentRounded');
	
	exports.default = _default;

/***/ },
/* 6490 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 15h14V9.05H5V15zm6-14v3h2V1h-2zm8.04 2.6l-1.79 1.79 1.41 1.41 1.8-1.79-1.42-1.41zM13 23v-2.95h-2V23h2zm7.45-3.91l-1.8-1.79-1.41 1.41 1.79 1.8 1.42-1.42zM3.55 5.01L5.34 6.8l1.41-1.41L4.96 3.6 3.55 5.01zM4.96 20.5l1.79-1.8-1.41-1.41-1.79 1.79 1.41 1.42z"
	}), 'WbIridescentSharp');
	
	exports.default = _default;

/***/ },
/* 6491 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M7 11h10v2H7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5 15h14V9H5v6zm2-4h10v2H7v-2zm4-10h2v3h-2zm6.25 4.39l1.41 1.41 1.8-1.79-1.42-1.41zM11 20h2v3h-2zm6.24-1.29l1.79 1.8 1.42-1.42-1.8-1.79zM5.34 6.805l-1.788-1.79L4.96 3.61l1.788 1.788zM3.55 19.08l1.41 1.42 1.79-1.8-1.41-1.41z"
	})), 'WbIridescentTwoTone');
	
	exports.default = _default;

/***/ },
/* 6492 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z"
	}), 'WbSunny');
	
	exports.default = _default;

/***/ },
/* 6493 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79zM1 10.5h3v2H1zM11 .55h2V3.5h-2zm8.04 2.495l1.408 1.407-1.79 1.79-1.407-1.408zm-1.8 15.115l1.79 1.8 1.41-1.41-1.8-1.79zM20 10.5h3v2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm-1 4h2v2.95h-2zm-7.45-.96l1.41 1.41 1.79-1.8-1.41-1.41z"
	}), 'WbSunnyOutlined');
	
	exports.default = _default;

/***/ },
/* 6494 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.05 4.14l-.39-.39c-.39-.39-1.02-.38-1.4 0l-.01.01c-.39.39-.39 1.02 0 1.4l.39.39c.39.39 1.01.39 1.4 0l.01-.01c.39-.38.39-1.02 0-1.4zM3.01 10.5H1.99c-.55 0-.99.44-.99.99v.01c0 .55.44.99.99.99H3c.56.01 1-.43 1-.98v-.01c0-.56-.44-1-.99-1zm9-9.95H12c-.56 0-1 .44-1 .99v.96c0 .55.44.99.99.99H12c.56.01 1-.43 1-.98v-.97c0-.55-.44-.99-.99-.99zm7.74 3.21c-.39-.39-1.02-.39-1.41-.01l-.39.39c-.39.39-.39 1.02 0 1.4l.01.01c.39.39 1.02.39 1.4 0l.39-.39c.39-.39.39-1.01 0-1.4zm-1.81 15.1l.39.39c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41l-.39-.39c-.39-.39-1.02-.38-1.4 0-.4.4-.4 1.02-.01 1.41zM20 11.49v.01c0 .55.44.99.99.99H22c.55 0 .99-.44.99-.99v-.01c0-.55-.44-.99-.99-.99h-1.01c-.55 0-.99.44-.99.99zM12 5.5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-.01 16.95H12c.55 0 .99-.44.99-.99v-.96c0-.55-.44-.99-.99-.99h-.01c-.55 0-.99.44-.99.99v.96c0 .55.44.99.99.99zm-7.74-3.21c.39.39 1.02.39 1.41 0l.39-.39c.39-.39.38-1.02 0-1.4l-.01-.01a.9959.9959 0 00-1.41 0l-.39.39c-.38.4-.38 1.02.01 1.41z"
	}), 'WbSunnyRounded');
	
	exports.default = _default;

/***/ },
/* 6495 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z"
	}), 'WbSunnySharp');
	
	exports.default = _default;

/***/ },
/* 6496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 7.5c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M5.34 6.25l1.42-1.41-1.8-1.79-1.41 1.41zM1 10.5h3v2H1zM11 .55h2V3.5h-2zm7.66 5.705l-1.41-1.407 1.79-1.79 1.406 1.41zM17.24 18.16l1.79 1.8 1.41-1.41-1.8-1.79zM20 10.5h3v2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm-1 4h2v2.95h-2zm-7.45-.96l1.41 1.41 1.79-1.8-1.41-1.41z"
	})), 'WbSunnyTwoTone');
	
	exports.default = _default;

/***/ },
/* 6497 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63C18.18 7.55 17.42 7 16.56 7h-.12c-.86 0-1.63.55-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z"
	}), 'Wc');
	
	exports.default = _default;

/***/ },
/* 6498 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63C18.18 7.55 17.42 7 16.56 7h-.12c-.86 0-1.63.55-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z"
	}), 'WcOutlined');
	
	exports.default = _default;

/***/ },
/* 6499 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.5 21v-6.5H5c-.55 0-1-.45-1-1V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v4.5c0 .55-.45 1-1 1h-.5V21c0 .55-.45 1-1 1h-2c-.55 0-1-.45-1-1zM18 21v-5h1.61c.68 0 1.16-.67.95-1.32l-2.1-6.31C18.18 7.55 17.42 7 16.56 7h-.12c-.86 0-1.63.55-1.9 1.37l-2.1 6.31c-.22.65.26 1.32.95 1.32H15v5c0 .55.45 1 1 1h1c.55 0 1-.45 1-1zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z"
	}), 'WcRounded');
	
	exports.default = _default;

/***/ },
/* 6500 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.5 22v-7.5H4V7h7v7.5H9.5V22h-4zM18 22v-6h3l-3-9h-3l-3 9h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z"
	}), 'WcSharp');
	
	exports.default = _default;

/***/ },
/* 6501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63C18.18 7.55 17.42 7 16.56 7h-.12c-.86 0-1.63.55-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z"
	}), 'WcTwoTone');
	
	exports.default = _default;

/***/ },
/* 6502 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z"
	}), 'Web');
	
	exports.default = _default;

/***/ },
/* 6503 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm0 14H5V8h14v10z"
	}), 'WebAsset');
	
	exports.default = _default;

/***/ },
/* 6504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm0 14H5V8h14v10z"
	}), 'WebAssetOutlined');
	
	exports.default = _default;

/***/ },
/* 6505 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm-1 14H6c-.55 0-1-.45-1-1V8h14v9c0 .55-.45 1-1 1z"
	}), 'WebAssetRounded');
	
	exports.default = _default;

/***/ },
/* 6506 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M3 4v16h18V4H3zm16 14H5V8h14v10z"
	}), 'WebAssetSharp');
	
	exports.default = _default;

/***/ },
/* 6507 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 8h14v10H5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm0 14H5V8h14v10z"
	})), 'WebAssetTwoTone');
	
	exports.default = _default;

/***/ },
/* 6508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 9h10.5v3.5H4V9zm0 5.5h10.5V18H4v-3.5zM20 18h-3.5V9H20v9z"
	}), 'WebOutlined');
	
	exports.default = _default;

/***/ },
/* 6509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 9h10.5v3.5H4V9zm0 5.5h10.5V18H5c-.55 0-1-.45-1-1v-2.5zM19 18h-2.5V9H20v8c0 .55-.45 1-1 1z"
	}), 'WebRounded');
	
	exports.default = _default;

/***/ },
/* 6510 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 4H2v16h20V4zM4 9h10.5v3.5H4V9zm0 5.5h10.5V18H4v-3.5zM20 18h-3.5V9H20v9z"
	}), 'WebSharp');
	
	exports.default = _default;

/***/ },
/* 6511 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 9h10.5v3.5H4zM4 14.5h10.5V18H4zM16.5 9H20v9h-3.5z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5.5 14H4v-3.5h10.5V18zm0-5.5H4V9h10.5v3.5zM20 18h-3.5V9H20v9z"
	})), 'WebTwoTone');
	
	exports.default = _default;

/***/ },
/* 6512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  transform: "scale(0.5, 0.5)",
	  d: "M42 20c-2.21 0-4 1.79-4 4v6H10v-6c0-2.21-1.79-4-4-4s-4 1.79-4 4v10c0 2.2 1.8 4 4 4h36c2.2 0 4-1.8 4-4V24c0-2.21-1.79-4-4-4zm-6-10H12c-2.2 0-4 1.8-4 4v4.31c2.32.83 4 3.03 4 5.63V28h24v-4.06c0-2.6 1.68-4.8 4-5.63V14c0-2.2-1.8-4-4-4z"
	}), 'Weekend');
	
	exports.default = _default;

/***/ },
/* 6513 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 9V7c0-1.65-1.35-3-3-3H6C4.35 4 3 5.35 3 7v2c-1.65 0-3 1.35-3 3v5c0 1.65 1.35 3 3 3h18c1.65 0 3-1.35 3-3v-5c0-1.65-1.35-3-3-3zM5 7c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v2.78c-.61.55-1 1.34-1 2.22v2H6v-2c0-.88-.39-1.67-1-2.22V7zm17 10c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v4h16v-4c0-.55.45-1 1-1s1 .45 1 1v5z"
	}), 'WeekendOutlined');
	
	exports.default = _default;

/***/ },
/* 6514 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 10c-1.1 0-2 .9-2 2v3H5v-3c0-1.1-.9-2-2-2s-2 .9-2 2v5c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2zm-3-5H6c-1.1 0-2 .9-2 2v2.15c1.16.41 2 1.51 2 2.82V14h12v-2.03c0-1.3.84-2.4 2-2.82V7c0-1.1-.9-2-2-2z"
	}), 'WeekendRounded');
	
	exports.default = _default;

/***/ },
/* 6515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M6 9.03V14h12V9.03h2V5H4v4.03zM19 15H5v-4.97H1V19h22v-8.97h-4z"
	}), 'WeekendSharp');
	
	exports.default = _default;

/***/ },
/* 6516 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M21 11c-.55 0-1 .45-1 1v4H4v-4c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55.45 1 1 1h18c.55 0 1-.45 1-1v-5c0-.55-.45-1-1-1zM6 14h12v-2c0-.88.39-1.67 1-2.22V7c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v2.78c.61.55 1 1.34 1 2.22v2z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M21 9V7c0-1.65-1.35-3-3-3H6C4.35 4 3 5.35 3 7v2c-1.65 0-3 1.35-3 3v5c0 1.65 1.35 3 3 3h18c1.65 0 3-1.35 3-3v-5c0-1.65-1.35-3-3-3zM5 7c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v2.78c-.61.55-1 1.34-1 2.22v2H6v-2c0-.88-.39-1.67-1-2.22V7zm17 10c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v4h16v-4c0-.55.45-1 1-1s1 .45 1 1v5z"
	})), 'WeekendTwoTone');
	
	exports.default = _default;

/***/ },
/* 6517 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.75 13.96c.25.13.41.2.46.3.06.11.04.61-.21 1.18-.2.56-1.24 1.1-1.7 1.12-.46.02-.47.36-2.96-.73-2.49-1.09-3.99-3.75-4.11-3.92-.12-.17-.96-1.38-.92-2.61.05-1.22.69-1.8.95-2.04.24-.26.51-.29.68-.26h.47c.15 0 .36-.06.55.45l.69 1.87c.06.13.1.28.01.44l-.27.41-.39.42c-.12.12-.26.25-.12.5.12.26.62 1.09 1.32 1.78.91.88 1.71 1.17 1.95 1.3.24.14.39.12.54-.04l.81-.94c.19-.25.35-.19.58-.11l1.67.88M12 2a10 10 0 0 1 10 10 10 10 0 0 1-10 10c-1.97 0-3.8-.57-5.35-1.55L2 22l1.55-4.65A9.969 9.969 0 0 1 2 12 10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8c0 1.72.54 3.31 1.46 4.61L4.5 19.5l2.89-.96A7.95 7.95 0 0 0 12 20a8 8 0 0 0 8-8 8 8 0 0 0-8-8z"
	}), 'WhatsApp');
	
	exports.default = _default;

/***/ },
/* 6518 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z"
	}), 'Whatshot');
	
	exports.default = _default;

/***/ },
/* 6519 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M11.57 13.16c-1.36.28-2.17 1.16-2.17 2.41 0 1.34 1.11 2.42 2.49 2.42 2.05 0 3.71-1.66 3.71-3.71 0-1.07-.15-2.12-.46-3.12-.79 1.07-2.2 1.72-3.57 2zM13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM12 20c-3.31 0-6-2.69-6-6 0-1.53.3-3.04.86-4.43 1.01 1.01 2.41 1.63 3.97 1.63 2.66 0 4.75-1.83 5.28-4.43C17.34 8.97 18 11.44 18 14c0 3.31-2.69 6-6 6z"
	}), 'WhatshotOutlined');
	
	exports.default = _default;

/***/ },
/* 6520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.09 4.56c-.7-1.03-1.5-1.99-2.4-2.85-.35-.34-.94-.02-.84.46.19.94.39 2.18.39 3.29 0 2.06-1.35 3.73-3.41 3.73-1.54 0-2.8-.93-3.35-2.26-.1-.2-.14-.32-.2-.54-.11-.42-.66-.55-.9-.18-.18.27-.35.54-.51.83C4.68 9.08 4 11.46 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8c0-3.49-1.08-6.73-2.91-9.44zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.47-.3 2.98-.93 4.03-1.92.28-.26.74-.14.82.23.23 1.02.35 2.08.35 3.15.01 2.65-2.14 4.8-4.79 4.8z"
	}), 'WhatshotRounded');
	
	exports.default = _default;

/***/ },
/* 6521 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z"
	}), 'WhatshotSharp');
	
	exports.default = _default;

/***/ },
/* 6522 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M16.11 6.77c-.53 2.6-2.62 4.43-5.28 4.43-1.56 0-2.96-.62-3.97-1.63C6.3 10.96 6 12.47 6 14c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.56-.66-5.03-1.89-7.23zm-4.22 11.22c-1.37 0-2.49-1.08-2.49-2.42 0-1.25.81-2.13 2.17-2.41 1.37-.28 2.78-.93 3.57-1.99.3 1 .46 2.05.46 3.12 0 2.04-1.66 3.7-3.71 3.7z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M11.57 13.16c-1.36.28-2.17 1.16-2.17 2.41 0 1.34 1.11 2.42 2.49 2.42 2.05 0 3.71-1.66 3.71-3.71 0-1.07-.15-2.12-.46-3.12-.79 1.07-2.2 1.72-3.57 2zM13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM12 20c-3.31 0-6-2.69-6-6 0-1.53.3-3.04.86-4.43 1.01 1.01 2.41 1.63 3.97 1.63 2.66 0 4.75-1.83 5.28-4.43C17.34 8.97 18 11.44 18 14c0 3.31-2.69 6-6 6z"
	})), 'WhatshotTwoTone');
	
	exports.default = _default;

/***/ },
/* 6523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2c3.86 0 7 3.14 7 7 0 5.25-7 13-7 13S5 14.25 5 9c0-3.86 3.14-7 7-7zm-1.53 12L17 7.41 15.6 6l-5.13 5.18L8.4 9.09 7 10.5l3.47 3.5z"
	}), 'WhereToVote');
	
	exports.default = _default;

/***/ },
/* 6524 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 1C7.59 1 4 4.59 4 9c0 5.57 6.96 13.34 7.26 13.67l.74.82.74-.82C13.04 22.34 20 14.57 20 9c0-4.41-3.59-8-8-8zm0 19.47C9.82 17.86 6 12.54 6 9c0-3.31 2.69-6 6-6s6 2.69 6 6c0 3.83-4.25 9.36-6 11.47zm-1.53-9.3L8.71 9.4l-1.42 1.42L10.47 14l6.01-6.01-1.41-1.42z"
	}), 'WhereToVoteOutlined');
	
	exports.default = _default;

/***/ },
/* 6525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C8.14 2 5 5.14 5 9c0 4.17 4.42 9.92 6.23 12.11.4.48 1.13.48 1.53 0C14.58 18.92 19 13.17 19 9c0-3.86-3.14-7-7-7zm4.31 6.16l-5.13 5.13c-.39.39-1.02.39-1.41 0L7.7 11.22c-.39-.39-.39-1.03 0-1.42.39-.39 1.03-.39 1.42 0l1.36 1.36 4.42-4.42c.39-.39 1.03-.39 1.42 0 .38.4.38 1.03-.01 1.42z"
	}), 'WhereToVoteRounded');
	
	exports.default = _default;

/***/ },
/* 6526 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm-1.53 12l-3.48-3.48L8.4 9.1l2.07 2.07 5.13-5.14 1.41 1.42L10.47 14z"
	}), 'WhereToVoteSharp');
	
	exports.default = _default;

/***/ },
/* 6527 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M12 3C8.69 3 6 5.69 6 9c0 3.54 3.82 8.86 6 11.47 1.75-2.11 6-7.63 6-11.47 0-3.31-2.69-6-6-6zm-1.53 11l-3.18-3.18L8.71 9.4l1.77 1.77 4.6-4.6 1.41 1.41L10.47 14z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M12 1C7.59 1 4 4.59 4 9c0 5.57 6.96 13.34 7.26 13.67l.74.82.74-.82C13.04 22.34 20 14.57 20 9c0-4.41-3.59-8-8-8zm0 19.47C9.82 17.86 6 12.54 6 9c0-3.31 2.69-6 6-6s6 2.69 6 6c0 3.83-4.25 9.36-6 11.47zm3.07-13.9l-4.6 4.6L8.71 9.4l-1.42 1.42L10.47 14l6.01-6.01z"
	})), 'WhereToVoteTwoTone');
	
	exports.default = _default;

/***/ },
/* 6528 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z"
	}), 'Widgets');
	
	exports.default = _default;

/***/ },
/* 6529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M16.66 4.52l2.83 2.83-2.83 2.83-2.83-2.83 2.83-2.83M9 5v4H5V5h4m10 10v4h-4v-4h4M9 15v4H5v-4h4m7.66-13.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65zM11 3H3v8h8V3zm10 10h-8v8h8v-8zm-10 0H3v8h8v-8z"
	}), 'WidgetsOutlined');
	
	exports.default = _default;

/***/ },
/* 6530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 14v6c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1zm-9 7h6c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1zM3 4v6c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1zm12.95-1.6L11.7 6.64c-.39.39-.39 1.02 0 1.41l4.25 4.25c.39.39 1.02.39 1.41 0l4.25-4.25c.39-.39.39-1.02 0-1.41L17.37 2.4c-.39-.39-1.03-.39-1.42 0z"
	}), 'WidgetsRounded');
	
	exports.default = _default;

/***/ },
/* 6531 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z"
	}), 'WidgetsSharp');
	
	exports.default = _default;

/***/ },
/* 6532 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M5 5h4v4H5zm10 10h4v4h-4zM5 15h4v4H5zM16.66 4.52l-2.83 2.82 2.83 2.83 2.83-2.83z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M16.66 1.69L11 7.34 16.66 13l5.66-5.66-5.66-5.65zm-2.83 5.65l2.83-2.83 2.83 2.83-2.83 2.83-2.83-2.83zM3 3v8h8V3H3zm6 6H5V5h4v4zM3 21h8v-8H3v8zm2-6h4v4H5v-4zm8-2v8h8v-8h-8zm6 6h-4v-4h4v4z"
	})), 'WidgetsTwoTone');
	
	exports.default = _default;

/***/ },
/* 6533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z"
	}), 'Wifi');
	
	exports.default = _default;

/***/ },
/* 6534 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.5 9.5c.28 0 .55.04.81.08L24 6c-3.34-2.51-7.5-4-12-4S3.34 3.49 0 6l12 16 3.5-4.67V14.5c0-2.76 2.24-5 5-5zM23 16v-1.5c0-1.38-1.12-2.5-2.5-2.5S18 13.12 18 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z"
	}), 'WifiLock');
	
	exports.default = _default;

/***/ },
/* 6535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.31 9.58L24 6c-3.34-2.51-7.5-4-12-4S3.34 3.49 0 6l12 16 3.5-4.67V14.5c0-2.76 2.24-5 5-5 .28 0 .55.04.81.08zM23 16v-1.5c0-1.38-1.12-2.5-2.5-2.5S18 13.12 18 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z"
	}), 'WifiLockOutlined');
	
	exports.default = _default;

/***/ },
/* 6536 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.31 9.58L24 6c-3.34-2.51-7.5-4-12-4S3.34 3.49 0 6l10.4 13.87c.8 1.07 2.4 1.07 3.2 0l1.9-2.53V14.5c0-2.76 2.24-5 5-5 .28 0 .55.04.81.08zM23 16v-1.5c0-1.38-1.12-2.5-2.5-2.5S18 13.12 18 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z"
	}), 'WifiLockRounded');
	
	exports.default = _default;

/***/ },
/* 6537 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 14.64c0-1.31-.94-2.5-2.24-2.63-1.5-.15-2.76 1.02-2.76 2.49V16h-1v6h7v-6h-1v-1.36zM22 16h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16zm-.69-6.42L24 6c-3.34-2.51-7.5-4-12-4S3.34 3.49 0 6l12 16 3.5-4.67V14.5c0-2.76 2.24-5 5-5 .28 0 .55.04.81.08z"
	}), 'WifiLockSharp');
	
	exports.default = _default;

/***/ },
/* 6538 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21.31 9.58L24 6c-3.34-2.51-7.5-4-12-4S3.34 3.49 0 6l12 16 3.5-4.67V14.5c0-2.76 2.24-5 5-5 .28 0 .55.04.81.08zM23 16v-1.5c0-1.38-1.12-2.5-2.5-2.5S18 13.12 18 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z"
	}), 'WifiLockTwoTone');
	
	exports.default = _default;

/***/ },
/* 6539 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22.99 9C19.15 5.16 13.8 3.76 8.84 4.78l2.52 2.52c3.47-.17 6.99 1.05 9.63 3.7l2-2zm-4 4c-1.29-1.29-2.84-2.13-4.49-2.56l3.53 3.53.96-.97zM2 3.05L5.07 6.1C3.6 6.82 2.22 7.78 1 9l1.99 2c1.24-1.24 2.67-2.16 4.2-2.77l2.24 2.24C7.81 10.89 6.27 11.73 5 13v.01L6.99 15c1.36-1.36 3.14-2.04 4.92-2.06L18.98 20l1.27-1.26L3.29 1.79 2 3.05zM9 17l3 3 3-3c-1.65-1.66-4.34-1.66-6 0z"
	}), 'WifiOff');
	
	exports.default = _default;

/***/ },
/* 6540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 11l2-2c-3.73-3.73-8.87-5.15-13.7-4.31l2.58 2.58c3.3-.02 6.61 1.22 9.12 3.73zm-2 2c-1.08-1.08-2.36-1.85-3.72-2.33l3.02 3.02.7-.69zM9 17l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zM3.41 1.64L2 3.05 5.05 6.1C3.59 6.83 2.22 7.79 1 9l2 2c1.23-1.23 2.65-2.16 4.17-2.78l2.24 2.24C7.79 10.89 6.27 11.74 5 13l2 2c1.35-1.35 3.11-2.04 4.89-2.06l7.08 7.08 1.41-1.41L3.41 1.64z"
	}), 'WifiOffOutlined');
	
	exports.default = _default;

/***/ },
/* 6541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20.06 10.14c.56.46 1.38.42 1.89-.09.59-.59.55-1.57-.1-2.1-3.59-2.94-8.2-4.03-12.55-3.26l2.59 2.59c2.89-.03 5.8.92 8.17 2.86zm-2.27 1.83c-.78-.57-1.63-1-2.52-1.3l2.95 2.95c.24-.58.1-1.27-.43-1.65zm-3.84 4.26c-1.22-.63-2.68-.63-3.91 0-.59.31-.7 1.12-.23 1.59l1.47 1.47c.39.39 1.02.39 1.41 0l1.47-1.47c.49-.47.39-1.28-.21-1.59zm5.73 1.67L4.12 2.34a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L5.05 6.1c-1.01.5-1.99 1.11-2.89 1.85-.65.53-.69 1.51-.1 2.1.51.51 1.32.56 1.87.1 1-.82 2.1-1.46 3.25-1.93l2.23 2.23c-1.13.3-2.21.8-3.19 1.51-.69.5-.73 1.51-.13 2.11l.01.01c.49.49 1.26.54 1.83.13 1.19-.84 2.58-1.26 3.97-1.29l6.37 6.37c.39.39 1.02.39 1.41 0 .39-.37.39-1 0-1.39z"
	}), 'WifiOffRounded');
	
	exports.default = _default;

/***/ },
/* 6542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 11l2-2c-3.73-3.73-8.87-5.15-13.7-4.31l2.58 2.58c3.3-.02 6.61 1.22 9.12 3.73zM9 17l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm10-4c-1.08-1.08-2.36-1.85-3.72-2.33l3.02 3.02.7-.69zM3.41 1.64L2 3.05 5.05 6.1C3.59 6.83 2.22 7.79 1 9l2 2c1.23-1.23 2.65-2.16 4.17-2.78l2.24 2.24C7.79 10.89 6.27 11.74 5 13l2 2c1.35-1.35 3.11-2.04 4.89-2.06l7.08 7.08 1.41-1.41L3.41 1.64z"
	}), 'WifiOffSharp');
	
	exports.default = _default;

/***/ },
/* 6543 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M21 11l2-2c-3.73-3.73-8.87-5.15-13.7-4.31l2.58 2.58c3.3-.02 6.61 1.22 9.12 3.73zm-2 2c-1.08-1.08-2.36-1.85-3.72-2.33l3.02 3.02.7-.69zM9 17l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zM3.41 1.64L2 3.05 5.05 6.1C3.59 6.83 2.22 7.79 1 9l2 2c1.23-1.23 2.65-2.16 4.17-2.78l2.24 2.24C7.79 10.89 6.27 11.74 5 13l2 2c1.35-1.35 3.11-2.04 4.89-2.06l7.08 7.08 1.41-1.41L3.41 1.64z"
	}), 'WifiOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 6544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z"
	}), 'WifiOutlined');
	
	exports.default = _default;

/***/ },
/* 6545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M2.06 10.06c.51.51 1.32.56 1.87.1 4.67-3.84 11.45-3.84 16.13-.01.56.46 1.38.42 1.89-.09.59-.59.55-1.57-.1-2.1-5.71-4.67-13.97-4.67-19.69 0-.65.52-.7 1.5-.1 2.1zm7.76 7.76l1.47 1.47c.39.39 1.02.39 1.41 0l1.47-1.47c.47-.47.37-1.28-.23-1.59-1.22-.63-2.68-.63-3.91 0-.57.31-.68 1.12-.21 1.59zm-3.73-3.73c.49.49 1.26.54 1.83.13 2.44-1.73 5.72-1.73 8.16 0 .57.4 1.34.36 1.83-.13l.01-.01c.6-.6.56-1.62-.13-2.11-3.44-2.49-8.13-2.49-11.58 0-.69.5-.73 1.51-.12 2.12z"
	}), 'WifiRounded');
	
	exports.default = _default;

/***/ },
/* 6546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z"
	}), 'WifiSharp');
	
	exports.default = _default;

/***/ },
/* 6547 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z"
	}), 'WifiTethering');
	
	exports.default = _default;

/***/ },
/* 6548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z"
	}), 'WifiTetheringOutlined');
	
	exports.default = _default;

/***/ },
/* 6549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.56-3.11-6.4-6.75-5.95-2.62.32-4.78 2.41-5.18 5.02-.33 2.15.49 4.11 1.93 5.4.48.43 1.23.33 1.56-.23l.01-.01c.24-.42.14-.93-.22-1.26-1.03-.93-1.59-2.37-1.22-3.94.33-1.42 1.48-2.57 2.9-2.91C13.65 8.49 16 10.47 16 13c0 1.18-.52 2.23-1.33 2.96-.36.32-.47.84-.23 1.26l.01.01c.31.53 1.03.69 1.5.28C17.2 16.41 18 14.8 18 13zm-7.17-9.93c-4.62.52-8.35 4.33-8.78 8.96-.35 3.7 1.32 7.02 4.02 9.01.48.35 1.16.2 1.46-.31.25-.43.14-.99-.26-1.29-2.28-1.69-3.65-4.55-3.16-7.7.54-3.5 3.46-6.29 6.98-6.68C15.91 4.51 20 8.28 20 13c0 2.65-1.29 4.98-3.27 6.44-.4.3-.51.85-.26 1.29.3.52.98.66 1.46.31C20.4 19.22 22 16.3 22 13c0-5.91-5.13-10.62-11.17-9.93z"
	}), 'WifiTetheringRounded');
	
	exports.default = _default;

/***/ },
/* 6550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z"
	}), 'WifiTetheringSharp');
	
	exports.default = _default;

/***/ },
/* 6551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z"
	}), 'WifiTetheringTwoTone');
	
	exports.default = _default;

/***/ },
/* 6552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z"
	}), 'WifiTwoTone');
	
	exports.default = _default;

/***/ },
/* 6553 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"
	}), 'Work');
	
	exports.default = _default;

/***/ },
/* 6554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M23 21.74l-1.46-1.46L7.21 5.95 3.25 1.99 1.99 3.25l2.7 2.7h-.64c-1.11 0-1.99.89-1.99 2l-.01 11c0 1.11.89 2 2 2h15.64L21.74 23 23 21.74zM22 7.95c.05-1.11-.84-2-1.95-1.95h-4V3.95c0-1.11-.89-2-2-1.95h-4c-1.11-.05-2 .84-2 1.95v.32l13.95 14V7.95zM14.05 6H10V3.95h4.05V6z"
	}), 'WorkOff');
	
	exports.default = _default;

/***/ },
/* 6555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 4h4v2h-3.6l2 2H20v7.6l2 2V8c0-1.11-.89-2-2-2h-4V4c0-1.11-.89-2-2-2h-4c-.99 0-1.8.7-1.96 1.64L10 5.6V4zM3.4 1.84L1.99 3.25 4.74 6H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h15.74l2 2 1.41-1.41L3.4 1.84zM4 19V8h2.74l11 11H4z"
	}), 'WorkOffOutlined');
	
	exports.default = _default;

/***/ },
/* 6556 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4.11 2.54a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L4.74 6H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h15.74l1.29 1.29c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L4.11 2.54zM10 4h4v2h-3.6L22 17.6V8c0-1.11-.89-2-2-2h-4V4c0-1.11-.89-2-2-2h-4c-.99 0-1.8.7-1.96 1.64L10 5.6V4z"
	}), 'WorkOffRounded');
	
	exports.default = _default;

/***/ },
/* 6557 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 4h4v2h-3.6L22 17.6V6h-6V4c0-1.1-.9-2-2-2h-4c-.98 0-1.79.71-1.96 1.64L10 5.6V4zM3.4 1.84L1.99 3.25 4.74 6H2.01L2 21h17.74l2 2 1.41-1.41z"
	}), 'WorkOffSharp');
	
	exports.default = _default;

/***/ },
/* 6558 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 8v11h13.74l-11-11zm8.4 0l7.6 7.6V8z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M10 4h4v2h-3.6l2 2H20v7.6l2 2V8c0-1.11-.89-2-2-2h-4V4c0-1.11-.89-2-2-2h-4c-.99 0-1.8.7-1.96 1.64L10 5.6V4zM3.4 1.84L1.99 3.25 4.74 6H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h15.74l2 2 1.41-1.41L3.4 1.84zM4 19V8h2.74l11 11H4z"
	})), 'WorkOffTwoTone');
	
	exports.default = _default;

/***/ },
/* 6559 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  fillRule: "evenodd",
	  d: "M14 6V4h-4v2h4zM4 8v11h16V8H4zm16-2c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h4V4c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2h4z"
	}), 'WorkOutline');
	
	exports.default = _default;

/***/ },
/* 6560 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6V4h-4v2h4zM4 8v11h16V8H4zm16-2c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h4V4c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2h4z"
	}), 'WorkOutlineOutlined');
	
	exports.default = _default;

/***/ },
/* 6561 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6V4h-4v2h4zM4 9v9c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1zm16-3c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h4V4c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2h4z"
	}), 'WorkOutlineRounded');
	
	exports.default = _default;

/***/ },
/* 6562 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M14 6V4h-4v2h4zM4 8v11h16V8H4zm18-2v15H2.01V6H8V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2v2h6z"
	}), 'WorkOutlineSharp');
	
	exports.default = _default;

/***/ },
/* 6563 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM10 4h4v2h-4V4zm10 15H4V8h16v11z"
	}), 'WorkOutlineTwoTone');
	
	exports.default = _default;

/***/ },
/* 6564 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"
	}), 'WorkOutlined');
	
	exports.default = _default;

/***/ },
/* 6565 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"
	}), 'WorkRounded');
	
	exports.default = _default;

/***/ },
/* 6566 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M22 6h-6V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H2v15h20V6zm-8 0h-4V4h4v2z"
	}), 'WorkSharp');
	
	exports.default = _default;

/***/ },
/* 6567 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M4 8h16v11H4z",
	  opacity: ".3"
	}), _react.default.createElement("path", {
	  d: "M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM10 4h4v2h-4V4zm10 15H4V8h16v11z"
	})), 'WorkTwoTone');
	
	exports.default = _default;

/***/ },
/* 6568 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 19h6v-2H4v2zM20 5H4v2h16V5zm-3 6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z"
	}), 'WrapText');
	
	exports.default = _default;

/***/ },
/* 6569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 19h6v-2H4v2zM20 5H4v2h16V5zm-3 6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z"
	}), 'WrapTextOutlined');
	
	exports.default = _default;

/***/ },
/* 6570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M5 7h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1zm11.83 4H5c-.55 0-1 .45-1 1s.45 1 1 1h12.13c1 0 1.93.67 2.09 1.66.21 1.25-.76 2.34-1.97 2.34H15v-.79c0-.45-.54-.67-.85-.35l-1.79 1.79c-.2.2-.2.51 0 .71l1.79 1.79c.32.32.85.09.85-.35V19h2c2.34 0 4.21-2.01 3.98-4.39-.2-2.08-2.06-3.61-4.15-3.61zM9 17H5c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1z"
	}), 'WrapTextRounded');
	
	exports.default = _default;

/***/ },
/* 6571 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 19h6v-2H4v2zM20 5H4v2h16V5zm-3 6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z"
	}), 'WrapTextSharp');
	
	exports.default = _default;

/***/ },
/* 6572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M4 17h6v2H4zm13-6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4zM4 5h16v2H4z"
	}), 'WrapTextTwoTone');
	
	exports.default = _default;

/***/ },
/* 6573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M10 15l5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83-.25.9-.83 1.48-1.73 1.73-.47.13-1.33.22-2.65.28-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44-.9-.25-1.48-.83-1.73-1.73-.13-.47-.22-1.1-.28-1.9-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83.25-.9.83-1.48 1.73-1.73.47-.13 1.33-.22 2.65-.28 1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44.9.25 1.48.83 1.73 1.73z"
	}), 'YouTube');
	
	exports.default = _default;

/***/ },
/* 6574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.01 14h-.8l-.27-.27c.98-1.14 1.57-2.61 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51C6.51 7 8.53 5 11.01 5s4.5 2.01 4.5 4.5c0 2.48-2.02 4.5-4.5 4.5-.65 0-1.26-.14-1.82-.38L7.71 15.1c.97.57 2.09.9 3.3.9 1.61 0 3.08-.59 4.22-1.57l.27.27v.79l5.01 4.99L22 19l-4.99-5z"
	}), 'YoutubeSearchedFor');
	
	exports.default = _default;

/***/ },
/* 6575 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.01 14h-.8l-.27-.27c.98-1.14 1.57-2.61 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51C6.51 7 8.53 5 11.01 5s4.5 2.01 4.5 4.5c0 2.48-2.02 4.5-4.5 4.5-.65 0-1.26-.14-1.82-.38L7.71 15.1c.97.57 2.09.9 3.3.9 1.61 0 3.08-.59 4.22-1.57l.27.27v.79l5.01 4.99L22 19l-4.99-5z"
	}), 'YoutubeSearchedForOutlined');
	
	exports.default = _default;

/***/ },
/* 6576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.01 14h-.8l-.27-.27c1.15-1.34 1.76-3.14 1.51-5.09C17.11 6 15.1 3.78 12.5 3.18 8.26 2.2 4.51 5.53 4.51 9.5h-2.1c-.47 0-.68.59-.31.89l3.4 2.75c.19.2.51.21.71.01l2.9-2.79c.32-.31.1-.86-.35-.86H6.51c0-2.49 2-4.48 4.46-4.5 2.44-.02 4.54 2.05 4.54 4.49 0 2.48-2.02 4.51-4.5 4.51-.45 0-.89-.07-1.3-.19-.34-.1-.71 0-.96.26-.53.53-.32 1.45.39 1.66.59.17 1.22.27 1.87.27 1.61 0 3.08-.59 4.22-1.57l.27.27v.79l4.27 4.25c.41.41 1.07.41 1.48 0 .41-.41.41-1.08 0-1.49L17.01 14z"
	}), 'YoutubeSearchedForRounded');
	
	exports.default = _default;

/***/ },
/* 6577 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.01 14h-.8l-.27-.27c.98-1.14 1.57-2.61 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51C6.51 7 8.53 5 11.01 5s4.5 2.01 4.5 4.5c0 2.48-2.02 4.5-4.5 4.5-.65 0-1.26-.14-1.82-.38L7.71 15.1c.97.57 2.09.9 3.3.9 1.61 0 3.08-.59 4.22-1.57l.27.27v.79l5.01 4.99L22 19l-4.99-5z"
	}), 'YoutubeSearchedForSharp');
	
	exports.default = _default;

/***/ },
/* 6578 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.01 14h-.8l-.27-.27c.98-1.14 1.57-2.61 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51C6.51 7 8.53 5 11.01 5s4.5 2.01 4.5 4.5c0 2.48-2.02 4.5-4.5 4.5-.65 0-1.26-.14-1.82-.38L7.71 15.1c.97.57 2.09.9 3.3.9 1.61 0 3.08-.59 4.22-1.57l.27.27v.79l5.01 4.99L22 19l-4.99-5z"
	}), 'YoutubeSearchedForTwoTone');
	
	exports.default = _default;

/***/ },
/* 6579 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
	  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
	}), _react.default.createElement("path", {
	  d: "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"
	})), 'ZoomIn');
	
	exports.default = _default;

/***/ },
/* 6580 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm.5-7H9v2H7v1h2v2h1v-2h2V9h-2z"
	}), 'ZoomInOutlined');
	
	exports.default = _default;

/***/ },
/* 6581 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 14h-.79l-.28-.27c1.2-1.4 1.82-3.31 1.48-5.34-.47-2.78-2.79-5-5.59-5.34-4.23-.52-7.78 3.04-7.27 7.27.34 2.8 2.56 5.12 5.34 5.59 2.03.34 3.94-.28 5.34-1.48l.27.28v.79l4.26 4.25c.41.41 1.07.41 1.48 0l.01-.01c.41-.41.41-1.07 0-1.48L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm0-7c-.28 0-.5.22-.5.5V9H7.5c-.28 0-.5.22-.5.5s.22.5.5.5H9v1.5c0 .28.22.5.5.5s.5-.22.5-.5V10h1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H10V7.5c0-.28-.22-.5-.5-.5z"
	}), 'ZoomInRounded');
	
	exports.default = _default;

/***/ },
/* 6582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm.5-7H9v2H7v1h2v2h1v-2h2V9h-2z"
	}), 'ZoomInSharp');
	
	exports.default = _default;

/***/ },
/* 6583 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm.5-7H9v2H7v1h2v2h1v-2h2V9h-2z"
	}), 'ZoomInTwoTone');
	
	exports.default = _default;

/***/ },
/* 6584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
	}), 'ZoomOut');
	
	exports.default = _default;

/***/ },
/* 6585 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3h-6zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3v6zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6h6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6v-6z"
	}), 'ZoomOutMap');
	
	exports.default = _default;

/***/ },
/* 6586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3h-6zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3v6zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6h6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6v-6z"
	}), 'ZoomOutMapOutlined');
	
	exports.default = _default;

/***/ },
/* 6587 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.85 3.85L17.3 5.3l-2.18 2.16c-.39.39-.39 1.03 0 1.42.39.39 1.03.39 1.42 0L18.7 6.7l1.45 1.45c.31.31.85.09.85-.36V3.5c0-.28-.22-.5-.5-.5h-4.29c-.45 0-.67.54-.36.85zm-12 4.3L5.3 6.7l2.16 2.18c.39.39 1.03.39 1.42 0 .39-.39.39-1.03 0-1.42L6.7 5.3l1.45-1.45c.31-.31.09-.85-.36-.85H3.5c-.28 0-.5.22-.5.5v4.29c0 .45.54.67.85.36zm4.3 12L6.7 18.7l2.18-2.16c.39-.39.39-1.03 0-1.42-.39-.39-1.03-.39-1.42 0L5.3 17.3l-1.45-1.45c-.31-.31-.85-.09-.85.36v4.29c0 .28.22.5.5.5h4.29c.45 0 .67-.54.36-.85zm12-4.3L18.7 17.3l-2.16-2.18c-.39-.39-1.03-.39-1.42 0-.39.39-.39 1.03 0 1.42l2.18 2.16-1.45 1.45c-.31.31-.09.85.36.85h4.29c.28 0 .5-.22.5-.5v-4.29c0-.45-.54-.67-.85-.36z"
	}), 'ZoomOutMapRounded');
	
	exports.default = _default;

/***/ },
/* 6588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3h-6zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3v6zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6h6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6v-6z"
	}), 'ZoomOutMapSharp');
	
	exports.default = _default;

/***/ },
/* 6589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M17.3 5.3l-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3h-6zM9 3H3v6l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3zm-.83 11.41L5.3 17.3 3 15v6h6l-2.3-2.3 2.89-2.87zm7.66 0l-1.42 1.42 2.89 2.87L15 21h6v-6l-2.3 2.3z"
	}), 'ZoomOutMapTwoTone');
	
	exports.default = _default;

/***/ },
/* 6590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
	}), 'ZoomOutOutlined');
	
	exports.default = _default;

/***/ },
/* 6591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 14h-.79l-.28-.27c1.2-1.4 1.82-3.31 1.48-5.34-.47-2.78-2.79-5-5.59-5.34-4.23-.52-7.79 3.04-7.27 7.27.34 2.8 2.56 5.12 5.34 5.59 2.03.34 3.94-.28 5.34-1.48l.27.28v.79l4.26 4.25c.41.41 1.07.41 1.48 0l.01-.01c.41-.41.41-1.07 0-1.48L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm-2-5h4c.28 0 .5.22.5.5s-.22.5-.5.5h-4c-.28 0-.5-.22-.5-.5s.22-.5.5-.5z"
	}), 'ZoomOutRounded');
	
	exports.default = _default;

/***/ },
/* 6592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7V9z"
	}), 'ZoomOutSharp');
	
	exports.default = _default;

/***/ },
/* 6593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(3));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
	}), 'ZoomOutTwoTone');
	
	exports.default = _default;

/***/ },
/* 6594 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _jss = __webpack_require__(97);
	
	var _StylesProvider = _interopRequireDefault(__webpack_require__(241));
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(242));
	
	var ServerStyleSheets = /*#__PURE__*/function () {
	  function ServerStyleSheets() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck2.default)(this, ServerStyleSheets);
	    this.options = options;
	  }
	
	  (0, _createClass2.default)(ServerStyleSheets, [{
	    key: "collect",
	    value: function collect(children) {
	      // This is needed in order to deduplicate the injection of CSS in the page.
	      var sheetsManager = new Map(); // This is needed in order to inject the critical CSS.
	
	      this.sheetsRegistry = new _jss.SheetsRegistry(); // A new class name generator
	
	      var generateClassName = (0, _createGenerateClassName.default)();
	      return /*#__PURE__*/_react.default.createElement(_StylesProvider.default, (0, _extends2.default)({
	        sheetsManager: sheetsManager,
	        serverGenerateClassName: generateClassName,
	        sheetsRegistry: this.sheetsRegistry
	      }, this.options), children);
	    }
	  }, {
	    key: "toString",
	    value: function toString() {
	      return this.sheetsRegistry ? this.sheetsRegistry.toString() : '';
	    }
	  }, {
	    key: "getStyleElement",
	    value: function getStyleElement(props) {
	      return /*#__PURE__*/_react.default.createElement('style', (0, _extends2.default)({
	        id: 'jss-server-side',
	        key: 'jss-server-side',
	        dangerouslySetInnerHTML: {
	          __html: this.toString()
	        }
	      }, props));
	    }
	  }]);
	  return ServerStyleSheets;
	}();
	
	exports.default = ServerStyleSheets;

/***/ },
/* 6595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ServerStyleSheets.default;
	  }
	});
	
	var _ServerStyleSheets = _interopRequireDefault(__webpack_require__(6594));

/***/ },
/* 6596 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StylesProvider;
	exports.StylesContext = exports.sheetsManager = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _utils = __webpack_require__(22);
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(242));
	
	var _jss = __webpack_require__(97);
	
	var _jssPreset = _interopRequireDefault(__webpack_require__(403));
	
	// Default JSS instance.
	var jss = (0, _jss.create)((0, _jssPreset.default)()); // Use a singleton or the provided one by the context.
	//
	// The counter-based approach doesn't tolerate any mistake.
	// It's much safer to use the same counter everywhere.
	
	var generateClassName = (0, _createGenerateClassName.default)(); // Exported for test purposes
	
	var sheetsManager = new Map();
	exports.sheetsManager = sheetsManager;
	var defaultOptions = {
	  disableGeneration: false,
	  generateClassName: generateClassName,
	  jss: jss,
	  sheetsCache: null,
	  sheetsManager: sheetsManager,
	  sheetsRegistry: null
	};
	
	var StylesContext = _react.default.createContext(defaultOptions);
	
	exports.StylesContext = StylesContext;
	
	if (false) {
	  StylesContext.displayName = 'StylesContext';
	}
	
	var injectFirstNode;
	
	function StylesProvider(props) {
	  var children = props.children,
	      _props$injectFirst = props.injectFirst,
	      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
	      _props$disableGenerat = props.disableGeneration,
	      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
	      localOptions = (0, _objectWithoutProperties2.default)(props, ["children", "injectFirst", "disableGeneration"]);
	
	  var outerOptions = _react.default.useContext(StylesContext);
	
	  var context = (0, _extends2.default)({}, outerOptions, {
	    disableGeneration: disableGeneration
	  }, localOptions);
	
	  if (false) {
	    if (typeof window === 'undefined' && !context.sheetsManager) {
	      console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
	    }
	  }
	
	  if (false) {
	    if (context.jss.options.insertionPoint && injectFirst) {
	      console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
	    }
	  }
	
	  if (false) {
	    if (injectFirst && localOptions.jss) {
	      console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
	    }
	  }
	
	  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
	    if (!injectFirstNode) {
	      var head = document.head;
	      injectFirstNode = document.createComment('mui-inject-first');
	      head.insertBefore(injectFirstNode, head.firstChild);
	    }
	
	    context.jss = (0, _jss.create)({
	      plugins: (0, _jssPreset.default)().plugins,
	      insertionPoint: injectFirstNode
	    });
	  }
	
	  return /*#__PURE__*/_react.default.createElement(StylesContext.Provider, {
	    value: context
	  }, children);
	}
	
	 false ? StylesProvider.propTypes = {
	  /**
	   * Your component tree.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * You can disable the generation of the styles with this option.
	   * It can be useful when traversing the React tree outside of the HTML
	   * rendering step on the server.
	   * Let's say you are using react-apollo to extract all
	   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
	   */
	  disableGeneration: _propTypes.default.bool,
	
	  /**
	   * JSS's class name generator.
	   */
	  generateClassName: _propTypes.default.func,
	
	  /**
	   * By default, the styles are injected last in the <head> element of the page.
	   * As a result, they gain more specificity than any other style sheet.
	   * If you want to override Material-UI's styles, set this prop.
	   */
	  injectFirst: _propTypes.default.bool,
	
	  /**
	   * JSS's instance.
	   */
	  jss: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  serverGenerateClassName: _propTypes.default.func,
	
	  /**
	   * @ignore
	   *
	   * Beta feature.
	   *
	   * Cache for the sheets.
	   */
	  sheetsCache: _propTypes.default.object,
	
	  /**
	   * @ignore
	   *
	   * The sheetsManager is used to deduplicate style sheet injection in the page.
	   * It's deduplicating using the (theme, styles) couple.
	   * On the server, you should provide a new instance for each request.
	   */
	  sheetsManager: _propTypes.default.object,
	
	  /**
	   * @ignore
	   *
	   * Collect the sheets.
	   */
	  sheetsRegistry: _propTypes.default.object
	} : void 0;
	
	if (false) {
	  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = (0, _utils.exactProp)(StylesProvider.propTypes) : void 0;
	}

/***/ },
/* 6597 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _utils = __webpack_require__(22);
	
	var _ThemeContext = _interopRequireDefault(__webpack_require__(405));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(132));
	
	var _nested = _interopRequireDefault(__webpack_require__(400));
	
	// To support composition of theme.
	function mergeOuterLocalTheme(outerTheme, localTheme) {
	  if (typeof localTheme === 'function') {
	    var mergedTheme = localTheme(outerTheme);
	
	    if (false) {
	      if (!mergedTheme) {
	        console.error(['Material-UI: You should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
	      }
	    }
	
	    return mergedTheme;
	  }
	
	  return (0, _extends2.default)({}, outerTheme, localTheme);
	}
	/**
	 * This component takes a `theme` prop.
	 * It makes the `theme` available down the React tree thanks to React context.
	 * This component should preferably be used at **the root of your component tree**.
	 */
	
	
	function ThemeProvider(props) {
	  var children = props.children,
	      localTheme = props.theme;
	  var outerTheme = (0, _useTheme.default)();
	
	  if (false) {
	    if (outerTheme === null && typeof localTheme === 'function') {
	      console.error(['Material-UI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
	    }
	  }
	
	  var theme = _react.default.useMemo(function () {
	    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);
	
	    if (output != null) {
	      output[_nested.default] = outerTheme !== null;
	    }
	
	    return output;
	  }, [localTheme, outerTheme]);
	
	  return /*#__PURE__*/_react.default.createElement(_ThemeContext.default.Provider, {
	    value: theme
	  }, children);
	}
	
	 false ? ThemeProvider.propTypes = {
	  /**
	   * Your component tree.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * A theme object. You can provide a function to extend the outer theme.
	   */
	  theme: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]).isRequired
	} : void 0;
	
	if (false) {
	  process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = (0, _utils.exactProp)(ThemeProvider.propTypes) : void 0;
	}
	
	var _default = ThemeProvider;
	exports.default = _default;

/***/ },
/* 6598 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ThemeProvider.default;
	  }
	});
	
	var _ThemeProvider = _interopRequireDefault(__webpack_require__(6597));

/***/ },
/* 6599 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createGenerateClassName;
	
	var _nested = _interopRequireDefault(__webpack_require__(400));
	
	/**
	 * This is the list of the style rule name we use as drop in replacement for the built-in
	 * pseudo classes (:checked, :disabled, :focused, etc.).
	 *
	 * Why do they exist in the first place?
	 * These classes are used at a specificity of 2.
	 * It allows them to override previously definied styles as well as
	 * being untouched by simple user overrides.
	 */
	var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
	// When new generator function is created, rule counter is reset.
	// We need to reset the rule counter for SSR for each request.
	//
	// It's inspired by
	// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js
	
	function createGenerateClassName() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$disableGloba = options.disableGlobal,
	      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
	      _options$productionPr = options.productionPrefix,
	      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
	      _options$seed = options.seed,
	      seed = _options$seed === void 0 ? '' : _options$seed;
	  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
	  var ruleCounter = 0;
	
	  var getNextCounterId = function getNextCounterId() {
	    ruleCounter += 1;
	
	    if (false) {
	      if (ruleCounter >= 1e10) {
	        console.warn(['Material-UI: You might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
	      }
	    }
	
	    return ruleCounter;
	  };
	
	  return function (rule, styleSheet) {
	    var name = styleSheet.options.name; // Is a global static MUI style?
	
	    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
	      // We can use a shorthand class name, we never use the keys to style the components.
	      if (pseudoClasses.indexOf(rule.key) !== -1) {
	        return "Mui-".concat(rule.key);
	      }
	
	      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
	
	      if (!styleSheet.options.theme[_nested.default] || seed !== '') {
	        return prefix;
	      }
	
	      return "".concat(prefix, "-").concat(getNextCounterId());
	    }
	
	    if (true) {
	      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
	    }
	
	    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.
	
	    if (styleSheet.options.classNamePrefix) {
	      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
	    }
	
	    return "".concat(seedPrefix).concat(suffix);
	  };
	}

/***/ },
/* 6600 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createStyles;
	
	function createStyles(styles) {
	  return styles;
	}

/***/ },
/* 6601 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	
	var _createStyles = _interopRequireDefault(__webpack_require__(6600));

/***/ },
/* 6602 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getStylesCreator;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(55));
	
	var _utils = __webpack_require__(22);
	
	var _noopTheme = _interopRequireDefault(__webpack_require__(401));
	
	function getStylesCreator(stylesOrCreator) {
	  var themingEnabled = typeof stylesOrCreator === 'function';
	
	  if (false) {
	    if ((0, _typeof2.default)(stylesOrCreator) !== 'object' && !themingEnabled) {
	      console.error(['Material-UI: The `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
	    }
	  }
	
	  return {
	    create: function create(theme, name) {
	      var styles;
	
	      try {
	        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
	      } catch (err) {
	        if (false) {
	          if (themingEnabled === true && theme === _noopTheme.default) {
	            // TODO: prepend error message/name instead
	            console.error(['Material-UI: The `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
	          }
	        }
	
	        throw err;
	      }
	
	      if (!name || !theme.overrides || !theme.overrides[name]) {
	        return styles;
	      }
	
	      var overrides = theme.overrides[name];
	      var stylesWithOverrides = (0, _extends2.default)({}, styles);
	      Object.keys(overrides).forEach(function (key) {
	        if (false) {
	          if (!stylesWithOverrides[key]) {
	            console.warn(['Material-UI: You are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
	          }
	        }
	
	        stylesWithOverrides[key] = (0, _utils.deepmerge)(stylesWithOverrides[key], overrides[key]);
	      });
	      return stylesWithOverrides;
	    },
	    options: {}
	  };
	}

/***/ },
/* 6603 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _getStylesCreator.default;
	  }
	});
	
	var _getStylesCreator = _interopRequireDefault(__webpack_require__(6602));

/***/ },
/* 6604 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getThemeProps;
	
	/* eslint-disable no-restricted-syntax */
	function getThemeProps(params) {
	  var theme = params.theme,
	      name = params.name,
	      props = params.props;
	
	  if (!theme || !theme.props || !theme.props[name]) {
	    return props;
	  } // Resolve default props, code borrow from React source.
	  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
	
	
	  var defaultProps = theme.props[name];
	  var propName;
	
	  for (propName in defaultProps) {
	    if (props[propName] === undefined) {
	      props[propName] = defaultProps[propName];
	    }
	  }
	
	  return props;
	}

/***/ },
/* 6605 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = jssPreset;
	
	var _jssPluginRuleValueFunction = _interopRequireDefault(__webpack_require__(6751));
	
	var _jssPluginGlobal = _interopRequireDefault(__webpack_require__(6748));
	
	var _jssPluginNested = _interopRequireDefault(__webpack_require__(6749));
	
	var _jssPluginCamelCase = _interopRequireDefault(__webpack_require__(6746));
	
	var _jssPluginDefaultUnit = _interopRequireDefault(__webpack_require__(6747));
	
	var _jssPluginVendorPrefixer = _interopRequireDefault(__webpack_require__(6752));
	
	var _jssPluginPropsSort = _interopRequireDefault(__webpack_require__(6750));
	
	// Subset of jss-preset-default with only the plugins the Material-UI components are using.
	function jssPreset() {
	  return {
	    plugins: [(0, _jssPluginRuleValueFunction.default)(), (0, _jssPluginGlobal.default)(), (0, _jssPluginNested.default)(), (0, _jssPluginCamelCase.default)(), (0, _jssPluginDefaultUnit.default)(), // Disable the vendor prefixer server-side, it does nothing.
	    // This way, we can get a performance boost.
	    // In the documentation, we are using `autoprefixer` to solve this problem.
	    typeof window === 'undefined' ? null : (0, _jssPluginVendorPrefixer.default)(), (0, _jssPluginPropsSort.default)()]
	  };
	}

/***/ },
/* 6606 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.increment = increment;
	
	/* eslint-disable import/prefer-default-export */
	// Global index counter to preserve source order.
	// We create the style sheet during the creation of the component,
	// children are handled after the parents, so the order of style elements would be parent->child.
	// It is a problem though when a parent passes a className
	// which needs to override any child's styles.
	// StyleSheet of the child has a higher specificity, because of the source order.
	// So our solution is to render sheets them in the reverse order child->sheet, so
	// that parent has a higher specificity.
	var indexCounter = -1e9;
	
	function increment() {
	  indexCounter += 1;
	
	  if (false) {
	    if (indexCounter >= 0) {
	      console.warn(['Material-UI: You might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
	    }
	  }
	
	  return indexCounter;
	}

/***/ },
/* 6607 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = makeStyles;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _jss = __webpack_require__(97);
	
	var _mergeClasses = _interopRequireDefault(__webpack_require__(404));
	
	var _multiKeyStore = _interopRequireDefault(__webpack_require__(6608));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(132));
	
	var _StylesProvider = __webpack_require__(241);
	
	var _indexCounter = __webpack_require__(6606);
	
	var _getStylesCreator = _interopRequireDefault(__webpack_require__(6603));
	
	var _noopTheme = _interopRequireDefault(__webpack_require__(401));
	
	function getClasses(_ref, classes, Component) {
	  var state = _ref.state,
	      stylesOptions = _ref.stylesOptions;
	
	  if (stylesOptions.disableGeneration) {
	    return classes || {};
	  }
	
	  if (!state.cacheClasses) {
	    state.cacheClasses = {
	      // Cache for the finalized classes value.
	      value: null,
	      // Cache for the last used classes prop pointer.
	      lastProp: null,
	      // Cache for the last used rendered classes pointer.
	      lastJSS: {}
	    };
	  } // Tracks if either the rendered classes or classes prop has changed,
	  // requiring the generation of a new finalized classes object.
	
	
	  var generate = false;
	
	  if (state.classes !== state.cacheClasses.lastJSS) {
	    state.cacheClasses.lastJSS = state.classes;
	    generate = true;
	  }
	
	  if (classes !== state.cacheClasses.lastProp) {
	    state.cacheClasses.lastProp = classes;
	    generate = true;
	  }
	
	  if (generate) {
	    state.cacheClasses.value = (0, _mergeClasses.default)({
	      baseClasses: state.cacheClasses.lastJSS,
	      newClasses: classes,
	      Component: Component
	    });
	  }
	
	  return state.cacheClasses.value;
	}
	
	function attach(_ref2, props) {
	  var state = _ref2.state,
	      theme = _ref2.theme,
	      stylesOptions = _ref2.stylesOptions,
	      stylesCreator = _ref2.stylesCreator,
	      name = _ref2.name;
	
	  if (stylesOptions.disableGeneration) {
	    return;
	  }
	
	  var sheetManager = _multiKeyStore.default.get(stylesOptions.sheetsManager, stylesCreator, theme);
	
	  if (!sheetManager) {
	    sheetManager = {
	      refs: 0,
	      staticSheet: null,
	      dynamicStyles: null
	    };
	
	    _multiKeyStore.default.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
	  }
	
	  var options = (0, _extends2.default)({}, stylesCreator.options, stylesOptions, {
	    theme: theme,
	    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
	  });
	  options.generateId = options.serverGenerateClassName || options.generateClassName;
	  var sheetsRegistry = stylesOptions.sheetsRegistry;
	
	  if (sheetManager.refs === 0) {
	    var staticSheet;
	
	    if (stylesOptions.sheetsCache) {
	      staticSheet = _multiKeyStore.default.get(stylesOptions.sheetsCache, stylesCreator, theme);
	    }
	
	    var styles = stylesCreator.create(theme, name);
	
	    if (!staticSheet) {
	      staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, _extends2.default)({
	        link: false
	      }, options));
	      staticSheet.attach();
	
	      if (stylesOptions.sheetsCache) {
	        _multiKeyStore.default.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
	      }
	    }
	
	    if (sheetsRegistry) {
	      sheetsRegistry.add(staticSheet);
	    }
	
	    sheetManager.staticSheet = staticSheet;
	    sheetManager.dynamicStyles = (0, _jss.getDynamicStyles)(styles);
	  }
	
	  if (sheetManager.dynamicStyles) {
	    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, _extends2.default)({
	      link: true
	    }, options));
	    dynamicSheet.update(props);
	    dynamicSheet.attach();
	    state.dynamicSheet = dynamicSheet;
	    state.classes = (0, _mergeClasses.default)({
	      baseClasses: sheetManager.staticSheet.classes,
	      newClasses: dynamicSheet.classes
	    });
	
	    if (sheetsRegistry) {
	      sheetsRegistry.add(dynamicSheet);
	    }
	  } else {
	    state.classes = sheetManager.staticSheet.classes;
	  }
	
	  sheetManager.refs += 1;
	}
	
	function update(_ref3, props) {
	  var state = _ref3.state;
	
	  if (state.dynamicSheet) {
	    state.dynamicSheet.update(props);
	  }
	}
	
	function detach(_ref4) {
	  var state = _ref4.state,
	      theme = _ref4.theme,
	      stylesOptions = _ref4.stylesOptions,
	      stylesCreator = _ref4.stylesCreator;
	
	  if (stylesOptions.disableGeneration) {
	    return;
	  }
	
	  var sheetManager = _multiKeyStore.default.get(stylesOptions.sheetsManager, stylesCreator, theme);
	
	  sheetManager.refs -= 1;
	  var sheetsRegistry = stylesOptions.sheetsRegistry;
	
	  if (sheetManager.refs === 0) {
	    _multiKeyStore.default.delete(stylesOptions.sheetsManager, stylesCreator, theme);
	
	    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
	
	    if (sheetsRegistry) {
	      sheetsRegistry.remove(sheetManager.staticSheet);
	    }
	  }
	
	  if (state.dynamicSheet) {
	    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
	
	    if (sheetsRegistry) {
	      sheetsRegistry.remove(state.dynamicSheet);
	    }
	  }
	}
	
	function useSynchronousEffect(func, values) {
	  var key = _react.default.useRef([]);
	
	  var output; // Store "generation" key. Just returns a new object every time
	
	  var currentKey = _react.default.useMemo(function () {
	    return {};
	  }, values); // eslint-disable-line react-hooks/exhaustive-deps
	  // "the first render", or "memo dropped the value"
	
	
	  if (key.current !== currentKey) {
	    key.current = currentKey;
	    output = func();
	  }
	
	  _react.default.useEffect(function () {
	    return function () {
	      if (output) {
	        output();
	      }
	    };
	  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
	  );
	}
	
	function makeStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var name = options.name,
	      classNamePrefixOption = options.classNamePrefix,
	      Component = options.Component,
	      _options$defaultTheme = options.defaultTheme,
	      defaultTheme = _options$defaultTheme === void 0 ? _noopTheme.default : _options$defaultTheme,
	      stylesOptions2 = (0, _objectWithoutProperties2.default)(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);
	  var stylesCreator = (0, _getStylesCreator.default)(stylesOrCreator);
	  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
	  stylesCreator.options = {
	    index: (0, _indexCounter.increment)(),
	    name: name,
	    meta: classNamePrefix,
	    classNamePrefix: classNamePrefix
	  };
	
	  var useStyles = function useStyles() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var theme = (0, _useTheme.default)() || defaultTheme;
	    var stylesOptions = (0, _extends2.default)({}, _react.default.useContext(_StylesProvider.StylesContext), stylesOptions2);
	
	    var instance = _react.default.useRef();
	
	    var shouldUpdate = _react.default.useRef();
	
	    useSynchronousEffect(function () {
	      var current = {
	        name: name,
	        state: {},
	        stylesCreator: stylesCreator,
	        stylesOptions: stylesOptions,
	        theme: theme
	      };
	      attach(current, props);
	      shouldUpdate.current = false;
	      instance.current = current;
	      return function () {
	        detach(current);
	      };
	    }, [theme, stylesCreator]);
	
	    _react.default.useEffect(function () {
	      if (shouldUpdate.current) {
	        update(instance.current, props);
	      }
	
	      shouldUpdate.current = true;
	    });
	
	    var classes = getClasses(instance.current, props.classes, Component);
	
	    if (false) {
	      // eslint-disable-next-line react-hooks/rules-of-hooks
	      _react.default.useDebugValue(classes);
	    }
	
	    return classes;
	  };
	
	  return useStyles;
	}

/***/ },
/* 6608 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// Used https://github.com/thinkloop/multi-key-cache as inspiration
	var multiKeyStore = {
	  set: function set(cache, key1, key2, value) {
	    var subCache = cache.get(key1);
	
	    if (!subCache) {
	      subCache = new Map();
	      cache.set(key1, subCache);
	    }
	
	    subCache.set(key2, value);
	  },
	  get: function get(cache, key1, key2) {
	    var subCache = cache.get(key1);
	    return subCache ? subCache.get(key2) : undefined;
	  },
	  delete: function _delete(cache, key1, key2) {
	    var subCache = cache.get(key1);
	    subCache.delete(key2);
	  }
	};
	var _default = multiKeyStore;
	exports.default = _default;

/***/ },
/* 6609 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mergeClasses;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(22);
	
	function mergeClasses() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var baseClasses = options.baseClasses,
	      newClasses = options.newClasses,
	      Component = options.Component;
	
	  if (!newClasses) {
	    return baseClasses;
	  }
	
	  var nextClasses = (0, _extends2.default)({}, baseClasses);
	
	  if (false) {
	    if (typeof newClasses === 'string') {
	      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat((0, _utils.getDisplayName)(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
	      return baseClasses;
	    }
	  }
	
	  Object.keys(newClasses).forEach(function (key) {
	    if (false) {
	      if (!baseClasses[key] && newClasses[key]) {
	        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat((0, _utils.getDisplayName)(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
	      }
	
	      if (newClasses[key] && typeof newClasses[key] !== 'string') {
	        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat((0, _utils.getDisplayName)(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
	      }
	    }
	
	    if (newClasses[key]) {
	      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
	    }
	  });
	  return nextClasses;
	}

/***/ },
/* 6610 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	
	var _styled = _interopRequireDefault(__webpack_require__(6611));

/***/ },
/* 6611 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = styled;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _clsx = _interopRequireDefault(__webpack_require__(18));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _utils = __webpack_require__(22);
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(137));
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(243));
	
	function omit(input, fields) {
	  var output = {};
	  Object.keys(input).forEach(function (prop) {
	    if (fields.indexOf(prop) === -1) {
	      output[prop] = input[prop];
	    }
	  });
	  return output;
	} // styled-components's API removes the mapping between components and styles.
	// Using components as a low-level styling construct can be simpler.
	
	
	function styled(Component) {
	  var componentCreator = function componentCreator(style) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var name = options.name,
	        stylesOptions = (0, _objectWithoutProperties2.default)(options, ["name"]);
	
	    if (false) {
	      throw new Error(['You are calling styled(Component)(style) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	    }
	
	    var classNamePrefix = name;
	
	    if (false) {
	      if (!name) {
	        // Provide a better DX outside production.
	        var displayName = (0, _utils.getDisplayName)(Component);
	
	        if (displayName !== undefined) {
	          classNamePrefix = displayName;
	        }
	      }
	    }
	
	    var stylesOrCreator = typeof style === 'function' ? function (theme) {
	      return {
	        root: function root(props) {
	          return style((0, _extends2.default)({
	            theme: theme
	          }, props));
	        }
	      };
	    } : {
	      root: style
	    };
	    var useStyles = (0, _makeStyles.default)(stylesOrCreator, (0, _extends2.default)({
	      Component: Component,
	      name: name || Component.displayName,
	      classNamePrefix: classNamePrefix
	    }, stylesOptions));
	    var filterProps;
	    var propTypes = {};
	
	    if (style.filterProps) {
	      filterProps = style.filterProps;
	      delete style.filterProps;
	    }
	    /* eslint-disable react/forbid-foreign-prop-types */
	
	
	    if (style.propTypes) {
	      propTypes = style.propTypes;
	      delete style.propTypes;
	    }
	    /* eslint-enable react/forbid-foreign-prop-types */
	
	
	    var StyledComponent = /*#__PURE__*/_react.default.forwardRef(function StyledComponent(props, ref) {
	      var children = props.children,
	          classNameProp = props.className,
	          clone = props.clone,
	          ComponentProp = props.component,
	          other = (0, _objectWithoutProperties2.default)(props, ["children", "className", "clone", "component"]);
	      var classes = useStyles(props);
	      var className = (0, _clsx.default)(classes.root, classNameProp);
	      var spread = other;
	
	      if (filterProps) {
	        spread = omit(spread, filterProps);
	      }
	
	      if (clone) {
	        return /*#__PURE__*/_react.default.cloneElement(children, (0, _extends2.default)({
	          className: (0, _clsx.default)(children.props.className, className)
	        }, spread));
	      }
	
	      if (typeof children === 'function') {
	        return children((0, _extends2.default)({
	          className: className
	        }, spread));
	      }
	
	      var FinalComponent = ComponentProp || Component;
	      return /*#__PURE__*/_react.default.createElement(FinalComponent, (0, _extends2.default)({
	        ref: ref,
	        className: className
	      }, spread), children);
	    });
	
	     false ? StyledComponent.propTypes = (0, _extends2.default)({
	      /**
	       * A render function or node.
	       */
	      children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	
	      /**
	       * @ignore
	       */
	      className: _propTypes.default.string,
	
	      /**
	       * If `true`, the component will recycle it's children HTML element.
	       * It's using `React.cloneElement` internally.
	       *
	       * This prop will be deprecated and removed in v5
	       */
	      clone: (0, _utils.chainPropTypes)(_propTypes.default.bool, function (props) {
	        if (props.clone && props.component) {
	          return new Error('You can not use the clone and component prop at the same time.');
	        }
	
	        return null;
	      }),
	
	      /**
	       * The component used for the root node.
	       * Either a string to use a HTML element or a component.
	       */
	      component: _propTypes.default
	      /* @typescript-to-proptypes-ignore */
	      .elementType
	    }, propTypes) : void 0;
	
	    if (false) {
	      StyledComponent.displayName = "Styled(".concat(classNamePrefix, ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(StyledComponent, Component);
	    return StyledComponent;
	  };
	
	  return componentCreator;
	}

/***/ },
/* 6612 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useTheme;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeContext = _interopRequireDefault(__webpack_require__(405));
	
	function useTheme() {
	  var theme = _react.default.useContext(_ThemeContext.default);
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    _react.default.useDebugValue(theme);
	  }
	
	  return theme;
	}

/***/ },
/* 6613 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	
	var _withStyles = _interopRequireDefault(__webpack_require__(6614));

/***/ },
/* 6614 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(137));
	
	var _utils = __webpack_require__(22);
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(243));
	
	var _getThemeProps = _interopRequireDefault(__webpack_require__(402));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(132));
	
	// Link a style sheet with a component.
	// It does not modify the component passed to it;
	// instead, it returns a new component, with a `classes` property.
	var withStyles = function withStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return function (Component) {
	    var defaultTheme = options.defaultTheme,
	        _options$withTheme = options.withTheme,
	        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
	        name = options.name,
	        stylesOptions = (0, _objectWithoutProperties2.default)(options, ["defaultTheme", "withTheme", "name"]);
	
	    if (false) {
	      if (Component === undefined) {
	        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	      }
	    }
	
	    var classNamePrefix = name;
	
	    if (false) {
	      if (!name) {
	        // Provide a better DX outside production.
	        var displayName = (0, _utils.getDisplayName)(Component);
	
	        if (displayName !== undefined) {
	          classNamePrefix = displayName;
	        }
	      }
	    }
	
	    var useStyles = (0, _makeStyles.default)(stylesOrCreator, (0, _extends2.default)({
	      defaultTheme: defaultTheme,
	      Component: Component,
	      name: name || Component.displayName,
	      classNamePrefix: classNamePrefix
	    }, stylesOptions));
	
	    var WithStyles = /*#__PURE__*/_react.default.forwardRef(function WithStyles(props, ref) {
	      var classesProp = props.classes,
	          innerRef = props.innerRef,
	          other = (0, _objectWithoutProperties2.default)(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
	      // the actual props Component might receive due to merging with defaultProps.
	      // So copying it here would give us the same result in the wrapper as well.
	
	      var classes = useStyles((0, _extends2.default)({}, Component.defaultProps, props));
	      var theme;
	      var more = other;
	
	      if (typeof name === 'string' || withTheme) {
	        // name and withTheme are invariant in the outer scope
	        // eslint-disable-next-line react-hooks/rules-of-hooks
	        theme = (0, _useTheme.default)() || defaultTheme;
	
	        if (name) {
	          more = (0, _getThemeProps.default)({
	            theme: theme,
	            name: name,
	            props: other
	          });
	        } // Provide the theme to the wrapped component.
	        // So we don't have to use the `withTheme()` Higher-order Component.
	
	
	        if (withTheme && !more.theme) {
	          more.theme = theme;
	        }
	      }
	
	      return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	        ref: innerRef || ref,
	        classes: classes
	      }, more));
	    });
	
	     false ? WithStyles.propTypes = {
	      /**
	       * Override or extend the styles applied to the component.
	       */
	      classes: _propTypes.default.object,
	
	      /**
	       * Use that prop to pass a ref to the decorated component.
	       * @deprecated
	       */
	      innerRef: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]), function (props) {
	        if (props.innerRef == null) {
	          return null;
	        }
	
	        return null; // return new Error(
	        //   'Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' +
	        //     'Refs are now automatically forwarded to the inner component.',
	        // );
	      })
	    } : void 0;
	
	    if (false) {
	      WithStyles.displayName = "WithStyles(".concat((0, _utils.getDisplayName)(Component), ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(WithStyles, Component);
	
	    if (false) {
	      // Exposed for test purposes.
	      WithStyles.Naked = Component;
	      WithStyles.options = options;
	      WithStyles.useStyles = useStyles;
	    }
	
	    return WithStyles;
	  };
	};
	
	var _default = withStyles;
	exports.default = _default;

/***/ },
/* 6615 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	
	var _withTheme = _interopRequireWildcard(__webpack_require__(6616));
	
	Object.keys(_withTheme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withTheme[key];
	    }
	  });
	});

/***/ },
/* 6616 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withThemeCreator = withThemeCreator;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(137));
	
	var _utils = __webpack_require__(22);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(132));
	
	function withThemeCreator() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaultTheme = options.defaultTheme;
	
	  var withTheme = function withTheme(Component) {
	    if (false) {
	      if (Component === undefined) {
	        throw new Error(['You are calling withTheme(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	      }
	    }
	
	    var WithTheme = /*#__PURE__*/_react.default.forwardRef(function WithTheme(props, ref) {
	      var innerRef = props.innerRef,
	          other = (0, _objectWithoutProperties2.default)(props, ["innerRef"]);
	      var theme = (0, _useTheme.default)() || defaultTheme;
	      return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	        theme: theme,
	        ref: innerRef || ref
	      }, other));
	    });
	
	     false ? WithTheme.propTypes = {
	      /**
	       * Use that prop to pass a ref to the decorated component.
	       * @deprecated
	       */
	      innerRef: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]), function (props) {
	        if (props.innerRef == null) {
	          return null;
	        }
	
	        return new Error('Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' + 'Refs are now automatically forwarded to the inner component.');
	      })
	    } : void 0;
	
	    if (false) {
	      WithTheme.displayName = "WithTheme(".concat((0, _utils.getDisplayName)(Component), ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(WithTheme, Component);
	
	    if (false) {
	      // Exposed for test purposes.
	      WithTheme.Naked = Component;
	    }
	
	    return WithTheme;
	  };
	
	  return withTheme;
	} // Provide the theme object as a prop to the input component.
	// It's an alternative API to useTheme().
	// We encourage the usage of useTheme() where possible.
	
	
	var withTheme = withThemeCreator();
	var _default = withTheme;
	exports.default = _default;

/***/ },
/* 6617 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.borderRadius = exports.borderColor = exports.borderLeft = exports.borderBottom = exports.borderRight = exports.borderTop = exports.border = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(75));
	
	var _compose = _interopRequireDefault(__webpack_require__(80));
	
	function getBorder(value) {
	  if (typeof value !== 'number') {
	    return value;
	  }
	
	  return "".concat(value, "px solid");
	}
	
	var border = (0, _style.default)({
	  prop: 'border',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.border = border;
	var borderTop = (0, _style.default)({
	  prop: 'borderTop',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderTop = borderTop;
	var borderRight = (0, _style.default)({
	  prop: 'borderRight',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderRight = borderRight;
	var borderBottom = (0, _style.default)({
	  prop: 'borderBottom',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderBottom = borderBottom;
	var borderLeft = (0, _style.default)({
	  prop: 'borderLeft',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderLeft = borderLeft;
	var borderColor = (0, _style.default)({
	  prop: 'borderColor',
	  themeKey: 'palette'
	});
	exports.borderColor = borderColor;
	var borderRadius = (0, _style.default)({
	  prop: 'borderRadius',
	  themeKey: 'shape'
	});
	exports.borderRadius = borderRadius;
	var borders = (0, _compose.default)(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderRadius);
	var _default = borders;
	exports.default = _default;

/***/ },
/* 6618 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.whiteSpace = exports.visibility = exports.textOverflow = exports.overflow = exports.displayRaw = exports.displayPrint = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(75));
	
	var _compose = _interopRequireDefault(__webpack_require__(80));
	
	var displayPrint = (0, _style.default)({
	  prop: 'displayPrint',
	  cssProperty: false,
	  transform: function transform(value) {
	    return {
	      '@media print': {
	        display: value
	      }
	    };
	  }
	});
	exports.displayPrint = displayPrint;
	var displayRaw = (0, _style.default)({
	  prop: 'display'
	});
	exports.displayRaw = displayRaw;
	var overflow = (0, _style.default)({
	  prop: 'overflow'
	});
	exports.overflow = overflow;
	var textOverflow = (0, _style.default)({
	  prop: 'textOverflow'
	});
	exports.textOverflow = textOverflow;
	var visibility = (0, _style.default)({
	  prop: 'visibility'
	});
	exports.visibility = visibility;
	var whiteSpace = (0, _style.default)({
	  prop: 'whiteSpace'
	});
	exports.whiteSpace = whiteSpace;
	
	var _default = (0, _compose.default)(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace);
	
	exports.default = _default;

/***/ },
/* 6619 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.justifySelf = exports.justifyItems = exports.alignSelf = exports.flexShrink = exports.flexGrow = exports.flex = exports.order = exports.alignContent = exports.alignItems = exports.justifyContent = exports.flexWrap = exports.flexDirection = exports.flexBasis = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(75));
	
	var _compose = _interopRequireDefault(__webpack_require__(80));
	
	var flexBasis = (0, _style.default)({
	  prop: 'flexBasis'
	});
	exports.flexBasis = flexBasis;
	var flexDirection = (0, _style.default)({
	  prop: 'flexDirection'
	});
	exports.flexDirection = flexDirection;
	var flexWrap = (0, _style.default)({
	  prop: 'flexWrap'
	});
	exports.flexWrap = flexWrap;
	var justifyContent = (0, _style.default)({
	  prop: 'justifyContent'
	});
	exports.justifyContent = justifyContent;
	var alignItems = (0, _style.default)({
	  prop: 'alignItems'
	});
	exports.alignItems = alignItems;
	var alignContent = (0, _style.default)({
	  prop: 'alignContent'
	});
	exports.alignContent = alignContent;
	var order = (0, _style.default)({
	  prop: 'order'
	});
	exports.order = order;
	var flex = (0, _style.default)({
	  prop: 'flex'
	});
	exports.flex = flex;
	var flexGrow = (0, _style.default)({
	  prop: 'flexGrow'
	});
	exports.flexGrow = flexGrow;
	var flexShrink = (0, _style.default)({
	  prop: 'flexShrink'
	});
	exports.flexShrink = flexShrink;
	var alignSelf = (0, _style.default)({
	  prop: 'alignSelf'
	});
	exports.alignSelf = alignSelf;
	var justifyItems = (0, _style.default)({
	  prop: 'justifyItems'
	});
	exports.justifyItems = justifyItems;
	var justifySelf = (0, _style.default)({
	  prop: 'justifySelf'
	});
	exports.justifySelf = justifySelf;
	var flexbox = (0, _compose.default)(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
	var _default = flexbox;
	exports.default = _default;

/***/ },
/* 6620 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.gridArea = exports.gridTemplateAreas = exports.gridTemplateRows = exports.gridTemplateColumns = exports.gridAutoRows = exports.gridAutoColumns = exports.gridAutoFlow = exports.gridRow = exports.gridColumn = exports.gridRowGap = exports.gridColumnGap = exports.gridGap = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(75));
	
	var _compose = _interopRequireDefault(__webpack_require__(80));
	
	var gridGap = (0, _style.default)({
	  prop: 'gridGap'
	});
	exports.gridGap = gridGap;
	var gridColumnGap = (0, _style.default)({
	  prop: 'gridColumnGap'
	});
	exports.gridColumnGap = gridColumnGap;
	var gridRowGap = (0, _style.default)({
	  prop: 'gridRowGap'
	});
	exports.gridRowGap = gridRowGap;
	var gridColumn = (0, _style.default)({
	  prop: 'gridColumn'
	});
	exports.gridColumn = gridColumn;
	var gridRow = (0, _style.default)({
	  prop: 'gridRow'
	});
	exports.gridRow = gridRow;
	var gridAutoFlow = (0, _style.default)({
	  prop: 'gridAutoFlow'
	});
	exports.gridAutoFlow = gridAutoFlow;
	var gridAutoColumns = (0, _style.default)({
	  prop: 'gridAutoColumns'
	});
	exports.gridAutoColumns = gridAutoColumns;
	var gridAutoRows = (0, _style.default)({
	  prop: 'gridAutoRows'
	});
	exports.gridAutoRows = gridAutoRows;
	var gridTemplateColumns = (0, _style.default)({
	  prop: 'gridTemplateColumns'
	});
	exports.gridTemplateColumns = gridTemplateColumns;
	var gridTemplateRows = (0, _style.default)({
	  prop: 'gridTemplateRows'
	});
	exports.gridTemplateRows = gridTemplateRows;
	var gridTemplateAreas = (0, _style.default)({
	  prop: 'gridTemplateAreas'
	});
	exports.gridTemplateAreas = gridTemplateAreas;
	var gridArea = (0, _style.default)({
	  prop: 'gridArea'
	});
	exports.gridArea = gridArea;
	var grid = (0, _compose.default)(gridGap, gridColumnGap, gridRowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
	var _default = grid;
	exports.default = _default;

/***/ },
/* 6621 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = memoize;
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) {
	      cache[arg] = fn(arg);
	    }
	
	    return cache[arg];
	  };
	}

/***/ },
/* 6622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.bgcolor = exports.color = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(75));
	
	var _compose = _interopRequireDefault(__webpack_require__(80));
	
	var color = (0, _style.default)({
	  prop: 'color',
	  themeKey: 'palette'
	});
	exports.color = color;
	var bgcolor = (0, _style.default)({
	  prop: 'bgcolor',
	  cssProperty: 'backgroundColor',
	  themeKey: 'palette'
	});
	exports.bgcolor = bgcolor;
	var palette = (0, _compose.default)(color, bgcolor);
	var _default = palette;
	exports.default = _default;

/***/ },
/* 6623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.left = exports.bottom = exports.right = exports.top = exports.zIndex = exports.position = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(75));
	
	var _compose = _interopRequireDefault(__webpack_require__(80));
	
	var position = (0, _style.default)({
	  prop: 'position'
	});
	exports.position = position;
	var zIndex = (0, _style.default)({
	  prop: 'zIndex',
	  themeKey: 'zIndex'
	});
	exports.zIndex = zIndex;
	var top = (0, _style.default)({
	  prop: 'top'
	});
	exports.top = top;
	var right = (0, _style.default)({
	  prop: 'right'
	});
	exports.right = right;
	var bottom = (0, _style.default)({
	  prop: 'bottom'
	});
	exports.bottom = bottom;
	var left = (0, _style.default)({
	  prop: 'left'
	});
	exports.left = left;
	
	var _default = (0, _compose.default)(position, zIndex, top, right, bottom, left);
	
	exports.default = _default;

/***/ },
/* 6624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(75));
	
	var boxShadow = (0, _style.default)({
	  prop: 'boxShadow',
	  themeKey: 'shadows'
	});
	var _default = boxShadow;
	exports.default = _default;

/***/ },
/* 6625 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.boxSizing = exports.sizeHeight = exports.sizeWidth = exports.minHeight = exports.maxHeight = exports.height = exports.minWidth = exports.maxWidth = exports.width = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(75));
	
	var _compose = _interopRequireDefault(__webpack_require__(80));
	
	function transform(value) {
	  return value <= 1 ? "".concat(value * 100, "%") : value;
	}
	
	var width = (0, _style.default)({
	  prop: 'width',
	  transform: transform
	});
	exports.width = width;
	var maxWidth = (0, _style.default)({
	  prop: 'maxWidth',
	  transform: transform
	});
	exports.maxWidth = maxWidth;
	var minWidth = (0, _style.default)({
	  prop: 'minWidth',
	  transform: transform
	});
	exports.minWidth = minWidth;
	var height = (0, _style.default)({
	  prop: 'height',
	  transform: transform
	});
	exports.height = height;
	var maxHeight = (0, _style.default)({
	  prop: 'maxHeight',
	  transform: transform
	});
	exports.maxHeight = maxHeight;
	var minHeight = (0, _style.default)({
	  prop: 'minHeight',
	  transform: transform
	});
	exports.minHeight = minHeight;
	var sizeWidth = (0, _style.default)({
	  prop: 'size',
	  cssProperty: 'width',
	  transform: transform
	});
	exports.sizeWidth = sizeWidth;
	var sizeHeight = (0, _style.default)({
	  prop: 'size',
	  cssProperty: 'height',
	  transform: transform
	});
	exports.sizeHeight = sizeHeight;
	var boxSizing = (0, _style.default)({
	  prop: 'boxSizing'
	});
	exports.boxSizing = boxSizing;
	var sizing = (0, _compose.default)(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
	var _default = sizing;
	exports.default = _default;

/***/ },
/* 6626 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createUnarySpacing = createUnarySpacing;
	exports.default = void 0;
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
	
	var _responsivePropType = _interopRequireDefault(__webpack_require__(407));
	
	var _breakpoints = __webpack_require__(244);
	
	var _merge = _interopRequireDefault(__webpack_require__(171));
	
	var _memoize = _interopRequireDefault(__webpack_require__(6621));
	
	var properties = {
	  m: 'margin',
	  p: 'padding'
	};
	var directions = {
	  t: 'Top',
	  r: 'Right',
	  b: 'Bottom',
	  l: 'Left',
	  x: ['Left', 'Right'],
	  y: ['Top', 'Bottom']
	};
	var aliases = {
	  marginX: 'mx',
	  marginY: 'my',
	  paddingX: 'px',
	  paddingY: 'py'
	}; // memoize() impact:
	// From 300,000 ops/sec
	// To 350,000 ops/sec
	
	var getCssProperties = (0, _memoize.default)(function (prop) {
	  // It's not a shorthand notation.
	  if (prop.length > 2) {
	    if (aliases[prop]) {
	      prop = aliases[prop];
	    } else {
	      return [prop];
	    }
	  }
	
	  var _prop$split = prop.split(''),
	      _prop$split2 = (0, _slicedToArray2.default)(_prop$split, 2),
	      a = _prop$split2[0],
	      b = _prop$split2[1];
	
	  var property = properties[a];
	  var direction = directions[b] || '';
	  return Array.isArray(direction) ? direction.map(function (dir) {
	    return property + dir;
	  }) : [property + direction];
	});
	var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
	
	function createUnarySpacing(theme) {
	  var themeSpacing = theme.spacing || 8;
	
	  if (typeof themeSpacing === 'number') {
	    return function (abs) {
	      if (false) {
	        if (typeof abs !== 'number') {
	          console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
	        }
	      }
	
	      return themeSpacing * abs;
	    };
	  }
	
	  if (Array.isArray(themeSpacing)) {
	    return function (abs) {
	      if (false) {
	        if (abs > themeSpacing.length - 1) {
	          console.error(["Material-UI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
	        }
	      }
	
	      return themeSpacing[abs];
	    };
	  }
	
	  if (typeof themeSpacing === 'function') {
	    return themeSpacing;
	  }
	
	  if (false) {
	    console.error(["Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
	  }
	
	  return function () {
	    return undefined;
	  };
	}
	
	function getValue(transformer, propValue) {
	  if (typeof propValue === 'string' || propValue == null) {
	    return propValue;
	  }
	
	  var abs = Math.abs(propValue);
	  var transformed = transformer(abs);
	
	  if (propValue >= 0) {
	    return transformed;
	  }
	
	  if (typeof transformed === 'number') {
	    return -transformed;
	  }
	
	  return "-".concat(transformed);
	}
	
	function getStyleFromPropValue(cssProperties, transformer) {
	  return function (propValue) {
	    return cssProperties.reduce(function (acc, cssProperty) {
	      acc[cssProperty] = getValue(transformer, propValue);
	      return acc;
	    }, {});
	  };
	}
	
	function spacing(props) {
	  var theme = props.theme;
	  var transformer = createUnarySpacing(theme);
	  return Object.keys(props).map(function (prop) {
	    // Using a hash computation over an array iteration could be faster, but with only 28 items,
	    // it's doesn't worth the bundle size.
	    if (spacingKeys.indexOf(prop) === -1) {
	      return null;
	    }
	
	    var cssProperties = getCssProperties(prop);
	    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
	    var propValue = props[prop];
	    return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
	  }).reduce(_merge.default, {});
	}
	
	spacing.propTypes =  false ? spacingKeys.reduce(function (obj, key) {
	  obj[key] = _responsivePropType.default;
	  return obj;
	}, {}) : {};
	spacing.filterProps = spacingKeys;
	var _default = spacing;
	exports.default = _default;

/***/ },
/* 6627 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.css = css;
	exports.default = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(46));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _utils = __webpack_require__(22);
	
	var _merge = _interopRequireDefault(__webpack_require__(171));
	
	function omit(input, fields) {
	  var output = {};
	  Object.keys(input).forEach(function (prop) {
	    if (fields.indexOf(prop) === -1) {
	      output[prop] = input[prop];
	    }
	  });
	  return output;
	}
	
	var warnedOnce = false;
	
	function styleFunctionSx(styleFunction) {
	  var newStyleFunction = function newStyleFunction(props) {
	    var output = styleFunction(props);
	
	    if (props.css) {
	      return (0, _extends2.default)({}, (0, _merge.default)(output, styleFunction((0, _extends2.default)({
	        theme: props.theme
	      }, props.css))), omit(props.css, [styleFunction.filterProps]));
	    }
	
	    if (props.sx) {
	      return (0, _extends2.default)({}, (0, _merge.default)(output, styleFunction((0, _extends2.default)({
	        theme: props.theme
	      }, props.sx))), omit(props.sx, [styleFunction.filterProps]));
	    }
	
	    return output;
	  };
	
	  newStyleFunction.propTypes =  false ? (0, _extends2.default)({}, styleFunction.propTypes, {
	    css: (0, _utils.chainPropTypes)(_propTypes.default.object, function (props) {
	      if (!warnedOnce && props.css !== undefined) {
	        warnedOnce = true;
	        return new Error('Material-UI: The `css` prop is deprecated, please use the `sx` prop instead.');
	      }
	
	      return null;
	    }),
	    sx: _propTypes.default.object
	  }) : {};
	  newStyleFunction.filterProps = ['css', 'sx'].concat((0, _toConsumableArray2.default)(styleFunction.filterProps));
	  return newStyleFunction;
	}
	/**
	 *
	 * @deprecated
	 * The css style function is deprecated. Use the `styleFunctionSx` instead.
	 */
	
	
	function css(styleFunction) {
	  if (false) {
	    console.warn('Material-UI: The `css` function is deprecated. Use the `styleFunctionSx` instead.');
	  }
	
	  return styleFunctionSx(styleFunction);
	}
	
	var _default = styleFunctionSx;
	exports.default = _default;

/***/ },
/* 6628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.textAlign = exports.lineHeight = exports.letterSpacing = exports.fontWeight = exports.fontStyle = exports.fontSize = exports.fontFamily = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(75));
	
	var _compose = _interopRequireDefault(__webpack_require__(80));
	
	var fontFamily = (0, _style.default)({
	  prop: 'fontFamily',
	  themeKey: 'typography'
	});
	exports.fontFamily = fontFamily;
	var fontSize = (0, _style.default)({
	  prop: 'fontSize',
	  themeKey: 'typography'
	});
	exports.fontSize = fontSize;
	var fontStyle = (0, _style.default)({
	  prop: 'fontStyle',
	  themeKey: 'typography'
	});
	exports.fontStyle = fontStyle;
	var fontWeight = (0, _style.default)({
	  prop: 'fontWeight',
	  themeKey: 'typography'
	});
	exports.fontWeight = fontWeight;
	var letterSpacing = (0, _style.default)({
	  prop: 'letterSpacing'
	});
	exports.letterSpacing = letterSpacing;
	var lineHeight = (0, _style.default)({
	  prop: 'lineHeight'
	});
	exports.lineHeight = lineHeight;
	var textAlign = (0, _style.default)({
	  prop: 'textAlign'
	});
	exports.textAlign = textAlign;
	var typography = (0, _compose.default)(fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign);
	var _default = typography;
	exports.default = _default;

/***/ },
/* 6629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HTMLElementType;
	
	function HTMLElementType(props, propName, componentName, location, propFullName) {
	  if (true) {
	    return null;
	  }
	
	  var propValue = props[propName];
	  var safePropName = propFullName || propName;
	
	  if (propValue == null) {
	    return null;
	  }
	
	  if (propValue && propValue.nodeType !== 1) {
	    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an HTMLElement.");
	  }
	
	  return null;
	}

/***/ },
/* 6630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isPlainObject = isPlainObject;
	exports.default = deepmerge;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(55));
	
	function isPlainObject(item) {
	  return item && (0, _typeof2.default)(item) === 'object' && item.constructor === Object;
	}
	
	function deepmerge(target, source) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    clone: true
	  };
	  var output = options.clone ? (0, _extends2.default)({}, target) : target;
	
	  if (isPlainObject(target) && isPlainObject(source)) {
	    Object.keys(source).forEach(function (key) {
	      // Avoid prototype pollution
	      if (key === '__proto__') {
	        return;
	      }
	
	      if (isPlainObject(source[key]) && key in target) {
	        output[key] = deepmerge(target[key], source[key], options);
	      } else {
	        output[key] = source[key];
	      }
	    });
	  }
	
	  return output;
	}

/***/ },
/* 6631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(245));
	
	function isClassComponent(elementType) {
	  // elementType.prototype?.isReactComponent
	  var _elementType$prototyp = elementType.prototype,
	      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
	  return Boolean(prototype.isReactComponent);
	}
	
	function acceptingRef(props, propName, componentName, location, propFullName) {
	  var element = props[propName];
	  var safePropName = propFullName || propName;
	
	  if (element == null) {
	    return null;
	  }
	
	  var warningHint;
	  var elementType = element.type;
	  /**
	   * Blacklisting instead of whitelisting
	   *
	   * Blacklisting will miss some components, such as React.Fragment. Those will at least
	   * trigger a warning in React.
	   * We can't whitelist because there is no safe way to detect React.forwardRef
	   * or class components. "Safe" means there's no public API.
	   *
	   */
	
	  if (typeof elementType === 'function' && !isClassComponent(elementType)) {
	    warningHint = 'Did you accidentally use a plain function component for an element instead?';
	  }
	
	  if (warningHint !== undefined) {
	    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://mui.com/r/caveat-with-refs-guide');
	  }
	
	  return null;
	}
	
	var elementAcceptingRef = (0, _chainPropTypes.default)(_propTypes.default.element, acceptingRef);
	elementAcceptingRef.isRequired = (0, _chainPropTypes.default)(_propTypes.default.element.isRequired, acceptingRef);
	var _default = elementAcceptingRef;
	exports.default = _default;

/***/ },
/* 6632 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(5));
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(245));
	
	function isClassComponent(elementType) {
	  // elementType.prototype?.isReactComponent
	  var _elementType$prototyp = elementType.prototype,
	      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
	  return Boolean(prototype.isReactComponent);
	}
	
	function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var safePropName = propFullName || propName;
	
	  if (propValue == null) {
	    return null;
	  }
	
	  var warningHint;
	  /**
	   * Blacklisting instead of whitelisting
	   *
	   * Blacklisting will miss some components, such as React.Fragment. Those will at least
	   * trigger a warning in React.
	   * We can't whitelist because there is no safe way to detect React.forwardRef
	   * or class components. "Safe" means there's no public API.
	   *
	   */
	
	  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
	    warningHint = 'Did you accidentally provide a plain function component instead?';
	  }
	
	  if (warningHint !== undefined) {
	    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://mui.com/r/caveat-with-refs-guide');
	  }
	
	  return null;
	}
	
	var _default = (0, _chainPropTypes.default)(PropTypes.elementType, elementTypeAcceptingRef);
	
	exports.default = _default;

/***/ },
/* 6633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exactProp;
	exports.specialProperty = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(4));
	
	// This module is based on https://github.com/airbnb/prop-types-exact repository.
	// However, in order to reduce the number of dependencies and to remove some extra safe checks
	// the module was forked.
	// Only exported for test purposes.
	var specialProperty = "exact-prop: \u200B";
	exports.specialProperty = specialProperty;
	
	function exactProp(propTypes) {
	  if (true) {
	    return propTypes;
	  }
	
	  return (0, _extends3.default)({}, propTypes, (0, _defineProperty2.default)({}, specialProperty, function (props) {
	    var unsupportedProps = Object.keys(props).filter(function (prop) {
	      return !propTypes.hasOwnProperty(prop);
	    });
	
	    if (unsupportedProps.length > 0) {
	      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
	        return "`".concat(prop, "`");
	      }).join(', '), ". Please remove them."));
	    }
	
	    return null;
	  }));
	}

/***/ },
/* 6634 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatMuiErrorMessage;
	
	/**
	 * WARNING: Don't import this directly.
	 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
	 * @param {number} code
	 */
	function formatMuiErrorMessage(code) {
	  // Apply babel-plugin-transform-template-literals in loose mode
	  // loose mode is safe iff we're concatenating primitives
	  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
	
	  /* eslint-disable prefer-template */
	  var url = 'https://mui.com/production-error/?code=' + code;
	
	  for (var i = 1; i < arguments.length; i += 1) {
	    // rest params over-transpile for this case
	    // eslint-disable-next-line prefer-rest-params
	    url += '&args[]=' + encodeURIComponent(arguments[i]);
	  }
	
	  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
	  /* eslint-enable prefer-template */
	}

/***/ },
/* 6635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFunctionName = getFunctionName;
	exports.default = getDisplayName;
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(55));
	
	var _reactIs = __webpack_require__(6637);
	
	// Simplified polyfill for IE 11 support
	// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
	var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
	
	function getFunctionName(fn) {
	  var match = "".concat(fn).match(fnNameMatchRegex);
	  var name = match && match[1];
	  return name || '';
	}
	/**
	 * @param {function} Component
	 * @param {string} fallback
	 * @returns {string | undefined}
	 */
	
	
	function getFunctionComponentName(Component) {
	  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
	}
	
	function getWrappedName(outerType, innerType, wrapperName) {
	  var functionName = getFunctionComponentName(innerType);
	  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
	}
	/**
	 * cherry-pick from
	 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
	 * originally forked from recompose/getDisplayName with added IE 11 support
	 *
	 * @param {React.ReactType} Component
	 * @returns {string | undefined}
	 */
	
	
	function getDisplayName(Component) {
	  if (Component == null) {
	    return undefined;
	  }
	
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (typeof Component === 'function') {
	    return getFunctionComponentName(Component, 'Component');
	  }
	
	  if ((0, _typeof2.default)(Component) === 'object') {
	    switch (Component.$$typeof) {
	      case _reactIs.ForwardRef:
	        return getWrappedName(Component, Component.render, 'ForwardRef');
	
	      case _reactIs.Memo:
	        return getWrappedName(Component, Component.type, 'memo');
	
	      default:
	        return undefined;
	    }
	  }
	
	  return undefined;
	}

/***/ },
/* 6636 */
/***/ function(module, exports) {

	/** @license React v17.0.2
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
	if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
	function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;exports.ContextConsumer=h;exports.ContextProvider=z;exports.Element=A;exports.ForwardRef=B;exports.Fragment=C;exports.Lazy=D;exports.Memo=E;exports.Portal=F;exports.Profiler=G;exports.StrictMode=H;
	exports.Suspense=I;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};exports.isContextProvider=function(a){return y(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return y(a)===k};exports.isFragment=function(a){return y(a)===d};exports.isLazy=function(a){return y(a)===p};exports.isMemo=function(a){return y(a)===n};
	exports.isPortal=function(a){return y(a)===c};exports.isProfiler=function(a){return y(a)===f};exports.isStrictMode=function(a){return y(a)===e};exports.isSuspense=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
	exports.typeOf=y;


/***/ },
/* 6637 */
[7344, 6636],
/* 6638 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/* eslint-disable */
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var _default = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	
	exports.default = _default;

/***/ },
/* 6639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var refType = _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]);
	
	var _default = refType;
	exports.default = _default;

/***/ },
/* 6640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = forwardRef;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function forwardRef(renderFn, _temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      propTypes = _ref.propTypes,
	      defaultProps = _ref.defaultProps,
	      _ref$allowFallback = _ref.allowFallback,
	      allowFallback = _ref$allowFallback === void 0 ? false : _ref$allowFallback,
	      _ref$displayName = _ref.displayName,
	      displayName = _ref$displayName === void 0 ? renderFn.name || renderFn.displayName : _ref$displayName;
	
	  var render = function render(props, ref) {
	    return renderFn(props, ref);
	  };
	
	  return Object.assign(_react.default.forwardRef || !allowFallback ? _react.default.forwardRef(render) : function (props) {
	    return render(props, null);
	  }, {
	    displayName: displayName,
	    propTypes: propTypes,
	    defaultProps: defaultProps
	  });
	}

/***/ },
/* 6641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = __webpack_require__(2);
	
	/**
	 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
	 * value is the one rendered with. Generally only required for Concurrent mode usage
	 * where previous work in `render()` may be discarded befor being used.
	 *
	 * This is safe to access in an event handler.
	 *
	 * @param value The `Ref` value
	 */
	function useCommittedRef(value) {
	  var ref = (0, _react.useRef)(value);
	  (0, _react.useEffect)(function () {
	    ref.current = value;
	  }, [value]);
	  return ref;
	}
	
	var _default = useCommittedRef;
	exports.default = _default;

/***/ },
/* 6642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = useMounted;
	
	var _react = __webpack_require__(2);
	
	/**
	 * Track whether a component is current mounted. Generally less preferable than
	 * properlly canceling effects so they don't run after a component is unmounted,
	 * but helpful in cases where that isn't feasible, such as a `Promise` resolution.
	 *
	 * @returns a function that returns the current isMounted state of the component
	 *
	 * ```ts
	 * const [data, setData] = useState(null)
	 * const isMounted = useMounted()
	 *
	 * useEffect(() => {
	 *   fetchdata().then((newData) => {
	 *      if (isMounted()) {
	 *        setData(newData);
	 *      }
	 *   })
	 * })
	 * ```
	 */
	function useMounted() {
	  var mounted = (0, _react.useRef)(true);
	  var isMounted = (0, _react.useRef)(function () {
	    return mounted.current;
	  });
	  (0, _react.useEffect)(function () {
	    return function () {
	      mounted.current = false;
	    };
	  }, []);
	  return isMounted.current;
	}

/***/ },
/* 6643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = usePrevious;
	
	var _react = __webpack_require__(2);
	
	/**
	 * Store the last of some value. Tracked via a `Ref` only updating it
	 * after the component renders.
	 *
	 * Helpful if you need to compare a prop value to it's previous value during render.
	 *
	 * ```ts
	 * function Component(props) {
	 *   const lastProps = usePrevious(props)
	 *
	 *   if (lastProps.foo !== props.foo)
	 *     resetValueFromProps(props.foo)
	 * }
	 * ```
	 *
	 * @param value the value to track
	 */
	function usePrevious(value) {
	  var ref = (0, _react.useRef)(null);
	  (0, _react.useEffect)(function () {
	    ref.current = value;
	  });
	  return ref.current;
	}

/***/ },
/* 6644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = useUpdatedRef;
	
	var _react = __webpack_require__(2);
	
	/**
	 * Returns a ref that is immediately updated with the new value
	 *
	 * @param value The Ref value
	 * @category refs
	 */
	function useUpdatedRef(value) {
	  var valueRef = (0, _react.useRef)(value);
	  valueRef.current = value;
	  return valueRef;
	}

/***/ },
/* 6645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = useWillUnmount;
	
	var _useUpdatedRef = _interopRequireDefault(__webpack_require__(6644));
	
	var _react = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Attach a callback that fires when a component unmounts
	 *
	 * @param fn Handler to run when the component unmounts
	 * @category effects
	 */
	function useWillUnmount(fn) {
	  var onUnmount = (0, _useUpdatedRef.default)(fn);
	  (0, _react.useEffect)(function () {
	    return function () {
	      return onUnmount.current();
	    };
	  }, []);
	}

/***/ },
/* 6646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var env=__webpack_require__(6731);__webpack_require__(5);var React=__webpack_require__(2);function _typeof(e){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function _defineProperties(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function _createClass(e,t,n){return t&&_defineProperties(e.prototype,t),n&&_defineProperties(e,n),e}function _defineProperty(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&_setPrototypeOf(e,t)}function _getPrototypeOf(e){return(_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function _setPrototypeOf(e,t){return(_setPrototypeOf=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function _assertThisInitialized(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function _possibleConstructorReturn(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?_assertThisInitialized(e):t}var EventSet=function(){function e(t){_classCallCheck(this,e),_defineProperty(this,"handlers",void 0),this.handlers=t.slice(0)}return _createClass(e,[{key:"addHandlers",value:function(t){for(var n=this.handlers.slice(0),r=t.length,o=0;o<r;o+=1)n.push(t[o]);return new e(n)}},{key:"dispatchEvent",value:function(e,t){var n=this.handlers.length-1;if(t){for(var r=n;r>=0;r-=1)this.handlers[r].called||(this.handlers[r].called=!0,this.handlers[r](e));for(var o=n;o>=0;o-=1)this.handlers[o].called=!1}else{(0,this.handlers[n])(e)}}},{key:"hasHandlers",value:function(){return this.handlers.length>0}},{key:"removeHandlers",value:function(t){for(var n=[],r=this.handlers.length,o=0;o<r;o+=1){var a=this.handlers[o];-1===t.indexOf(a)&&n.push(a)}return new e(n)}}]),e}();function cloneMap(e){var t=new Map;return e.forEach(function(e,n){t.set(n,e)}),t}function normalizeHandlers(e){return Array.isArray(e)?e:[e]}var isRefObject=function(e){return null!==e&&"object"===_typeof(e)&&e.hasOwnProperty("current")};function normalizeTarget(e){return"document"===e?document:"window"===e?window:isRefObject(e)?e.current||document:e||document}var EventPool=function(){function e(t,n){_classCallCheck(this,e),_defineProperty(this,"handlerSets",void 0),_defineProperty(this,"poolName",void 0),this.handlerSets=n,this.poolName=t}return _createClass(e,[{key:"addHandlers",value:function(t,n){var r=cloneMap(this.handlerSets);if(r.has(t)){var o=r.get(t);r.set(t,o.addHandlers(n))}else r.set(t,new EventSet(n));return new e(this.poolName,r)}},{key:"dispatchEvent",value:function(e,t){var n=this.handlerSets.get(e),r="default"===this.poolName;n&&n.dispatchEvent(t,r)}},{key:"hasHandlers",value:function(e){if(!e)return this.handlerSets.size>0;var t=this.handlerSets.get(e);return!!t&&t.hasHandlers()}},{key:"removeHandlers",value:function(t,n){var r=cloneMap(this.handlerSets);if(!r.has(t))return new e(this.poolName,r);var o=r.get(t).removeHandlers(n);return o.hasHandlers()?r.set(t,o):r.delete(t),new e(this.poolName,r)}}]),e}();_defineProperty(EventPool,"createByType",function(e,t,n){var r=new Map;return r.set(t,new EventSet(n)),new EventPool(e,r)});var EventTarget=function(){function e(t){var n=this;_classCallCheck(this,e),_defineProperty(this,"handlers",new Map),_defineProperty(this,"pools",new Map),_defineProperty(this,"target",void 0),_defineProperty(this,"createEmitter",function(e){return function(t){n.pools.forEach(function(n){n.dispatchEvent(e,t)})}}),this.target=t}return _createClass(e,[{key:"addHandlers",value:function(e,t,n){if(this.pools.has(e)){var r=this.pools.get(e);this.pools.set(e,r.addHandlers(t,n))}else this.pools.set(e,EventPool.createByType(e,t,n));this.handlers.has(t)||this.addTargetHandler(t)}},{key:"hasHandlers",value:function(){return this.handlers.size>0}},{key:"removeHandlers",value:function(e,t,n){if(this.pools.has(e)){var r=this.pools.get(e).removeHandlers(t,n);r.hasHandlers()?this.pools.set(e,r):this.pools.delete(e);var o=!1;this.pools.forEach(function(e){return o=o||e.hasHandlers(t)}),o||this.removeTargetHandler(t)}}},{key:"addTargetHandler",value:function(e){var t=this.createEmitter(e);this.handlers.set(e,t),this.target.addEventListener(e,t,!0)}},{key:"removeTargetHandler",value:function(e){this.handlers.has(e)&&(this.target.removeEventListener(e,this.handlers.get(e),!0),this.handlers.delete(e))}}]),e}(),EventStack=function(){function e(){var t=this;_classCallCheck(this,e),_defineProperty(this,"targets",new Map),_defineProperty(this,"getTarget",function(e){var n=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],r=normalizeTarget(e);if(t.targets.has(r))return t.targets.get(r);if(!n)return null;var o=new EventTarget(r);return t.targets.set(r,o),o}),_defineProperty(this,"removeTarget",function(e){t.targets.delete(normalizeTarget(e))})}return _createClass(e,[{key:"sub",value:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(env.canUseDOM){var r=n.target,o=void 0===r?document:r,a=n.pool,s=void 0===a?"default":a;this.getTarget(o).addHandlers(s,e,normalizeHandlers(t))}}},{key:"unsub",value:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(env.canUseDOM){var r=n.target,o=void 0===r?document:r,a=n.pool,s=void 0===a?"default":a,i=this.getTarget(o,!1);i&&(i.removeHandlers(s,e,normalizeHandlers(t)),i.hasHandlers()||this.removeTarget(o))}}}]),e}(),instance=new EventStack,EventStack$1=function(e){function t(){return _classCallCheck(this,t),_possibleConstructorReturn(this,_getPrototypeOf(t).apply(this,arguments))}return _inherits(t,React.PureComponent),_createClass(t,[{key:"componentDidMount",value:function(){this.subscribe(this.props)}},{key:"componentDidUpdate",value:function(e){this.unsubscribe(e),this.subscribe(this.props)}},{key:"componentWillUnmount",value:function(){this.unsubscribe(this.props)}},{key:"subscribe",value:function(e){var t=e.name,n=e.on,r=e.pool,o=e.target;instance.sub(t,n,{pool:r,target:o})}},{key:"unsubscribe",value:function(e){var t=e.name,n=e.on,r=e.pool,o=e.target;instance.unsub(t,n,{pool:r,target:o})}},{key:"render",value:function(){return null}}]),t}();_defineProperty(EventStack$1,"defaultProps",{pool:"default",target:"document"}),EventStack$1.propTypes={},exports.instance=instance,exports.default=EventStack$1;


/***/ },
/* 6647 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(5));
	
	var _useEventListener = _interopRequireDefault(__webpack_require__(409));
	
	function EventListener(props) {
	  (0, _useEventListener.default)(props);
	  return null;
	}
	
	EventListener.displayName = 'EventListener'; // TODO: use Babel plugin for this
	
	EventListener.propTypes =  false ? {
	  capture: PropTypes.bool,
	  listener: PropTypes.func.isRequired,
	  targetRef: PropTypes.shape({
	    current: PropTypes.object
	  }).isRequired,
	  type: PropTypes.string.isRequired
	} : {};
	EventListener.defaultProps = {
	  capture: false
	};
	var _default = EventListener;
	exports.default = _default;

/***/ },
/* 6648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  documentRef: true,
	  windowRef: true,
	  EventListener: true,
	  useEventListener: true
	};
	Object.defineProperty(exports, "EventListener", {
	  enumerable: true,
	  get: function get() {
	    return _EventListener.default;
	  }
	});
	Object.defineProperty(exports, "useEventListener", {
	  enumerable: true,
	  get: function get() {
	    return _useEventListener.default;
	  }
	});
	exports.windowRef = exports.documentRef = void 0;
	
	var _EventListener = _interopRequireDefault(__webpack_require__(6647));
	
	var _types = __webpack_require__(6649);
	
	Object.keys(_types).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _types[key];
	    }
	  });
	});
	
	var _useEventListener = _interopRequireDefault(__webpack_require__(409));
	
	var documentRef = {
	  current: typeof document === 'undefined' ? null : document
	};
	exports.documentRef = documentRef;
	var windowRef = {
	  current: typeof window === 'undefined' ? null : window
	};
	exports.windowRef = windowRef;

/***/ },
/* 6649 */
/***/ function(module, exports) {

	"use strict";

/***/ },
/* 6650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactIs = _interopRequireWildcard(__webpack_require__(6654));
	
	var _RefFindNode = _interopRequireDefault(__webpack_require__(410));
	
	var _RefForward = _interopRequireDefault(__webpack_require__(411));
	
	var _types = __webpack_require__(173);
	
	var Ref = function Ref(props) {
	  var children = props.children,
	      innerRef = props.innerRef;
	  var child = React.Children.only(children);
	  var ElementType = ReactIs.isForwardRef(child) ? _RefForward.default : _RefFindNode.default;
	  return React.createElement(ElementType, {
	    innerRef: innerRef
	  }, child);
	};
	
	Ref.displayName = 'Ref'; // TODO: use Babel plugin for this
	
	if (false) {
	  Ref.propTypes = {
	    children: PropTypes.element.isRequired,
	    innerRef: _types.refPropType.isRequired
	  };
	}
	
	var _default = Ref;
	exports.default = _default;

/***/ },
/* 6651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(55));
	
	/** Checks that the passed object is a valid React ref object. */
	var isRefObject = function isRefObject(ref) {
	  return (// https://github.com/facebook/react/blob/v16.8.2/packages/react-reconciler/src/ReactFiberCommitWork.js#L665
	    ref !== null && (0, _typeof2.default)(ref) === 'object' && ref.hasOwnProperty('current')
	  );
	};
	
	var _default = isRefObject;
	exports.default = _default;

/***/ },
/* 6652 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var nullRefObject = {
	  current: null // A map of created ref objects to provide memoization.
	
	};
	var refObjects = new WeakMap();
	/** Creates a React ref object from existing DOM node. */
	
	var toRefObject = function toRefObject(node) {
	  // A "null" is not valid key for a WeakMap
	  if (node === null) {
	    return nullRefObject;
	  }
	
	  if (refObjects.has(node)) {
	    return refObjects.get(node);
	  }
	
	  var refObject = {
	    current: node
	  };
	  refObjects.set(node, refObject);
	  return refObject;
	};
	
	var _default = toRefObject;
	exports.default = _default;

/***/ },
/* 6653 */
1027,
/* 6654 */
[7344, 6653],
/* 6655 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 6656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(61);
	var bind = __webpack_require__(418);
	var Axios = __webpack_require__(6658);
	var mergeConfig = __webpack_require__(416);
	var defaults = __webpack_require__(417);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(mergeConfig(axios.defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(413);
	axios.CancelToken = __webpack_require__(6657);
	axios.isCancel = __webpack_require__(414);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(6671);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 6657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(413);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 6658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(61);
	var buildURL = __webpack_require__(419);
	var InterceptorManager = __webpack_require__(6659);
	var dispatchRequest = __webpack_require__(6661);
	var mergeConfig = __webpack_require__(416);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = arguments[1] || {};
	    config.url = arguments[0];
	  } else {
	    config = config || {};
	  }
	
	  config = mergeConfig(this.defaults, config);
	
	  // Set config.method
	  if (config.method) {
	    config.method = config.method.toLowerCase();
	  } else if (this.defaults.method) {
	    config.method = this.defaults.method.toLowerCase();
	  } else {
	    config.method = 'get';
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	Axios.prototype.getUri = function getUri(config) {
	  config = mergeConfig(this.defaults, config);
	  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 6659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(61);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 6660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isAbsoluteURL = __webpack_require__(6667);
	var combineURLs = __webpack_require__(6665);
	
	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */
	module.exports = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }
	  return requestedURL;
	};


/***/ },
/* 6661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(61);
	var transformData = __webpack_require__(6664);
	var isCancel = __webpack_require__(414);
	var defaults = __webpack_require__(417);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 6662 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	
	  error.request = request;
	  error.response = response;
	  error.isAxiosError = true;
	
	  error.toJSON = function toJSON() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code
	    };
	  };
	  return error;
	};


/***/ },
/* 6663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(415);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ },
/* 6664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(61);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 6665 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ },
/* 6666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(61);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));
	
	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }
	
	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }
	
	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }
	
	          if (secure === true) {
	            cookie.push('secure');
	          }
	
	          document.cookie = cookie.join('; ');
	        },
	
	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },
	
	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);


/***/ },
/* 6667 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 6668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(61);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;
	
	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;
	
	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }
	
	        urlParsingNode.setAttribute('href', href);
	
	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }
	
	      originURL = resolveURL(window.location.href);
	
	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);


/***/ },
/* 6669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(61);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 6670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(61);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 6671 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 6672 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(6673);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 6673 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 6674 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 6675 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(247);
	var Transform = __webpack_require__(248);
	var inherits = __webpack_require__(76);
	var modes = __webpack_require__(249);
	var StreamCipher = __webpack_require__(426);
	var ebtk = __webpack_require__(420);
	
	inherits(Decipher, Transform);
	function Decipher(mode, key, iv) {
	  if (!(this instanceof Decipher)) {
	    return new Decipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._last = void 0;
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Decipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.decrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Decipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  if (!chunk) {
	    return next;
	  }
	
	  this.push(unpad(this._mode.decrypt(this, chunk)));
	
	  next();
	};
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 16) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  if (this.cache.length) {
	    return this.cache;
	  }
	};
	function unpad(last) {
	  var padded = last[15];
	  if (padded === 16) {
	    return;
	  }
	  return last.slice(0, 16 - padded);
	}
	
	var modelist = {
	  ECB: __webpack_require__(424),
	  CBC: __webpack_require__(421),
	  CFB: __webpack_require__(422),
	  OFB: __webpack_require__(425),
	  CTR: __webpack_require__(423)
	};
	
	module.exports = function (crypto) {
	  function createDecipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv, true);
	    }
	    return new Decipher(modelist[config.mode], password, iv);
	  }
	
	  function createDecipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createDecipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createDecipher: createDecipher,
	    createDecipheriv: createDecipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39).Buffer))

/***/ },
/* 6676 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(247);
	var Transform = __webpack_require__(248);
	var inherits = __webpack_require__(76);
	var modes = __webpack_require__(249);
	var ebtk = __webpack_require__(420);
	var StreamCipher = __webpack_require__(426);
	inherits(Cipher, Transform);
	function Cipher(mode, key, iv) {
	  if (!(this instanceof Cipher)) {
	    return new Cipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Cipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.encrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Cipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  this.push(this._mode.encrypt(this, chunk));
	  this._cipher.scrub();
	  next();
	};
	
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length;
	  var padBuff = new Buffer(len);
	
	  var i = -1;
	  while (++i < len) {
	    padBuff.writeUInt8(len, i);
	  }
	  var out = Buffer.concat([this.cache, padBuff]);
	  return out;
	};
	var modelist = {
	  ECB: __webpack_require__(424),
	  CBC: __webpack_require__(421),
	  CFB: __webpack_require__(422),
	  OFB: __webpack_require__(425),
	  CTR: __webpack_require__(423)
	};
	module.exports = function (crypto) {
	  function createCipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv);
	    }
	    return new Cipher(modelist[config.mode], password, iv);
	  }
	  function createCipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createCipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createCipher: createCipher,
	    createCipheriv: createCipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39).Buffer))

/***/ },
/* 6677 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function (crypto, exports) {
	  exports = exports || {};
	  var ciphers = __webpack_require__(6676)(crypto);
	  exports.createCipher = ciphers.createCipher;
	  exports.createCipheriv = ciphers.createCipheriv;
	  var deciphers = __webpack_require__(6675)(crypto);
	  exports.createDecipher = deciphers.createDecipher;
	  exports.createDecipheriv = deciphers.createDecipheriv;
	  var modes = __webpack_require__(249);
	  function listCiphers () {
	    return Object.keys(modes);
	  }
	  exports.listCiphers = listCiphers;
	};
	


/***/ },
/* 6678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(136);
	var $apply = __webpack_require__(250);
	var actualApply = __webpack_require__(427);
	
	/** @type {import('./applyBind')} */
	module.exports = function applyBind() {
		return actualApply(bind, $apply, arguments);
	};


/***/ },
/* 6679 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./reflectApply')} */
	module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ },
/* 6680 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(431)
	
	var zeroBuffer = new Buffer(128)
	zeroBuffer.fill(0)
	
	module.exports = Hmac
	
	function Hmac (alg, key) {
	  if(!(this instanceof Hmac)) return new Hmac(alg, key)
	  this._opad = opad
	  this._alg = alg
	
	  var blocksize = (alg === 'sha512') ? 128 : 64
	
	  key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key
	
	  if(key.length > blocksize) {
	    key = createHash(alg).update(key).digest()
	  } else if(key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize)
	  }
	
	  var ipad = this._ipad = new Buffer(blocksize)
	  var opad = this._opad = new Buffer(blocksize)
	
	  for(var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  this._hash = createHash(alg).update(ipad)
	}
	
	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc)
	  return this
	}
	
	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest()
	  return createHash(this._alg).update(this._opad).update(h).digest(enc)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39).Buffer))

/***/ },
/* 6681 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;
	
	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}
	
	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}
	
	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}
	
	module.exports = { hash: hash };
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39).Buffer))

/***/ },
/* 6682 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var rng = __webpack_require__(6685)
	
	function error () {
	  var m = [].slice.call(arguments).join(' ')
	  throw new Error([
	    m,
	    'we accept pull requests',
	    'http://github.com/dominictarr/crypto-browserify'
	    ].join('\n'))
	}
	
	exports.createHash = __webpack_require__(431)
	
	exports.createHmac = __webpack_require__(6680)
	
	exports.randomBytes = function(size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)))
	    } catch (err) { callback(err) }
	  } else {
	    return new Buffer(rng(size))
	  }
	}
	
	function each(a, f) {
	  for(var i in a)
	    f(a[i], i)
	}
	
	exports.getHashes = function () {
	  return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160']
	}
	
	var p = __webpack_require__(6684)(exports)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	__webpack_require__(6677)(exports, module.exports);
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials'
	, 'createSign'
	, 'createVerify'
	, 'createDiffieHellman'
	], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet')
	  }
	})
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39).Buffer))

/***/ },
/* 6683 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var helpers = __webpack_require__(6681);
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;
	
	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
	
	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ },
/* 6684 */
/***/ function(module, exports, __webpack_require__) {

	var pbkdf2Export = __webpack_require__(6968)
	
	module.exports = function (crypto, exports) {
	  exports = exports || {}
	
	  var exported = pbkdf2Export(crypto)
	
	  exports.pbkdf2 = exported.pbkdf2
	  exports.pbkdf2Sync = exported.pbkdf2Sync
	
	  return exports
	}


/***/ },
/* 6685 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function() {
	  var g = ('undefined' === typeof window ? global : window) || {}
	  _crypto = (
	    g.crypto || g.msCrypto || __webpack_require__(7340)
	  )
	  module.exports = function(size) {
	    // Modern Browsers
	    if(_crypto.getRandomValues) {
	      var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
	      /* This will not work in older browsers.
	       * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	       */
	    
	      _crypto.getRandomValues(bytes);
	      return bytes;
	    }
	    else if (_crypto.randomBytes) {
	      return _crypto.randomBytes(size)
	    }
	    else
	      throw new Error(
	        'secure random number generation not supported by this browser\n'+
	        'use chrome, FireFox or Internet Explorer 11'
	      )
	  }
	}())
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(39).Buffer))

/***/ },
/* 6686 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(112), __webpack_require__(113), __webpack_require__(96), __webpack_require__(50));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var BlockCipher = C_lib.BlockCipher;
		    var C_algo = C.algo;
	
		    // Lookup tables
		    var SBOX = [];
		    var INV_SBOX = [];
		    var SUB_MIX_0 = [];
		    var SUB_MIX_1 = [];
		    var SUB_MIX_2 = [];
		    var SUB_MIX_3 = [];
		    var INV_SUB_MIX_0 = [];
		    var INV_SUB_MIX_1 = [];
		    var INV_SUB_MIX_2 = [];
		    var INV_SUB_MIX_3 = [];
	
		    // Compute lookup tables
		    (function () {
		        // Compute double table
		        var d = [];
		        for (var i = 0; i < 256; i++) {
		            if (i < 128) {
		                d[i] = i << 1;
		            } else {
		                d[i] = (i << 1) ^ 0x11b;
		            }
		        }
	
		        // Walk GF(2^8)
		        var x = 0;
		        var xi = 0;
		        for (var i = 0; i < 256; i++) {
		            // Compute sbox
		            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
		            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
		            SBOX[x] = sx;
		            INV_SBOX[sx] = x;
	
		            // Compute multiplication
		            var x2 = d[x];
		            var x4 = d[x2];
		            var x8 = d[x4];
	
		            // Compute sub bytes, mix columns tables
		            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
		            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
		            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
		            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
		            SUB_MIX_3[x] = t;
	
		            // Compute inv sub bytes, inv mix columns tables
		            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
		            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
		            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
		            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
		            INV_SUB_MIX_3[sx] = t;
	
		            // Compute next counter
		            if (!x) {
		                x = xi = 1;
		            } else {
		                x = x2 ^ d[d[d[x8 ^ x2]]];
		                xi ^= d[d[xi]];
		            }
		        }
		    }());
	
		    // Precomputed Rcon lookup
		    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	
		    /**
		     * AES block cipher algorithm.
		     */
		    var AES = C_algo.AES = BlockCipher.extend({
		        _doReset: function () {
		            var t;
	
		            // Skip reset of nRounds has been set before and key did not change
		            if (this._nRounds && this._keyPriorReset === this._key) {
		                return;
		            }
	
		            // Shortcuts
		            var key = this._keyPriorReset = this._key;
		            var keyWords = key.words;
		            var keySize = key.sigBytes / 4;
	
		            // Compute number of rounds
		            var nRounds = this._nRounds = keySize + 6;
	
		            // Compute number of key schedule rows
		            var ksRows = (nRounds + 1) * 4;
	
		            // Compute key schedule
		            var keySchedule = this._keySchedule = [];
		            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
		                if (ksRow < keySize) {
		                    keySchedule[ksRow] = keyWords[ksRow];
		                } else {
		                    t = keySchedule[ksRow - 1];
	
		                    if (!(ksRow % keySize)) {
		                        // Rot word
		                        t = (t << 8) | (t >>> 24);
	
		                        // Sub word
		                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	
		                        // Mix Rcon
		                        t ^= RCON[(ksRow / keySize) | 0] << 24;
		                    } else if (keySize > 6 && ksRow % keySize == 4) {
		                        // Sub word
		                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
		                    }
	
		                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
		                }
		            }
	
		            // Compute inv key schedule
		            var invKeySchedule = this._invKeySchedule = [];
		            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
		                var ksRow = ksRows - invKsRow;
	
		                if (invKsRow % 4) {
		                    var t = keySchedule[ksRow];
		                } else {
		                    var t = keySchedule[ksRow - 4];
		                }
	
		                if (invKsRow < 4 || ksRow <= 4) {
		                    invKeySchedule[invKsRow] = t;
		                } else {
		                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
		                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
		                }
		            }
		        },
	
		        encryptBlock: function (M, offset) {
		            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
		        },
	
		        decryptBlock: function (M, offset) {
		            // Swap 2nd and 4th rows
		            var t = M[offset + 1];
		            M[offset + 1] = M[offset + 3];
		            M[offset + 3] = t;
	
		            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
	
		            // Inv swap 2nd and 4th rows
		            var t = M[offset + 1];
		            M[offset + 1] = M[offset + 3];
		            M[offset + 3] = t;
		        },
	
		        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
		            // Shortcut
		            var nRounds = this._nRounds;
	
		            // Get input, add round key
		            var s0 = M[offset]     ^ keySchedule[0];
		            var s1 = M[offset + 1] ^ keySchedule[1];
		            var s2 = M[offset + 2] ^ keySchedule[2];
		            var s3 = M[offset + 3] ^ keySchedule[3];
	
		            // Key schedule row counter
		            var ksRow = 4;
	
		            // Rounds
		            for (var round = 1; round < nRounds; round++) {
		                // Shift rows, sub bytes, mix columns, add round key
		                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
		                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
		                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
		                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
	
		                // Update state
		                s0 = t0;
		                s1 = t1;
		                s2 = t2;
		                s3 = t3;
		            }
	
		            // Shift rows, sub bytes, add round key
		            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
		            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
		            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
		            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	
		            // Set output
		            M[offset]     = t0;
		            M[offset + 1] = t1;
		            M[offset + 2] = t2;
		            M[offset + 3] = t3;
		        },
	
		        keySize: 256/32
		    });
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
		     */
		    C.AES = BlockCipher._createHelper(AES);
		}());
	
	
		return CryptoJS.AES;
	
	}));

/***/ },
/* 6687 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_enc = C.enc;
	
		    /**
		     * UTF-16 BE encoding strategy.
		     */
		    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
		        /**
		         * Converts a word array to a UTF-16 BE string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-16 BE string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var utf16Chars = [];
		            for (var i = 0; i < sigBytes; i += 2) {
		                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
		                utf16Chars.push(String.fromCharCode(codePoint));
		            }
	
		            return utf16Chars.join('');
		        },
	
		        /**
		         * Converts a UTF-16 BE string to a word array.
		         *
		         * @param {string} utf16Str The UTF-16 BE string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
		         */
		        parse: function (utf16Str) {
		            // Shortcut
		            var utf16StrLength = utf16Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < utf16StrLength; i++) {
		                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
		            }
	
		            return WordArray.create(words, utf16StrLength * 2);
		        }
		    };
	
		    /**
		     * UTF-16 LE encoding strategy.
		     */
		    C_enc.Utf16LE = {
		        /**
		         * Converts a word array to a UTF-16 LE string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-16 LE string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var utf16Chars = [];
		            for (var i = 0; i < sigBytes; i += 2) {
		                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
		                utf16Chars.push(String.fromCharCode(codePoint));
		            }
	
		            return utf16Chars.join('');
		        },
	
		        /**
		         * Converts a UTF-16 LE string to a word array.
		         *
		         * @param {string} utf16Str The UTF-16 LE string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
		         */
		        parse: function (utf16Str) {
		            // Shortcut
		            var utf16StrLength = utf16Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < utf16StrLength; i++) {
		                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
		            }
	
		            return WordArray.create(words, utf16StrLength * 2);
		        }
		    };
	
		    function swapEndian(word) {
		        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
		    }
		}());
	
	
		return CryptoJS.enc.Utf16;
	
	}));

/***/ },
/* 6688 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(50));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (undefined) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var CipherParams = C_lib.CipherParams;
		    var C_enc = C.enc;
		    var Hex = C_enc.Hex;
		    var C_format = C.format;
	
		    var HexFormatter = C_format.Hex = {
		        /**
		         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
		         *
		         * @param {CipherParams} cipherParams The cipher params object.
		         *
		         * @return {string} The hexadecimally encoded string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
		         */
		        stringify: function (cipherParams) {
		            return cipherParams.ciphertext.toString(Hex);
		        },
	
		        /**
		         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
		         *
		         * @param {string} input The hexadecimally encoded string.
		         *
		         * @return {CipherParams} The cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
		         */
		        parse: function (input) {
		            var ciphertext = Hex.parse(input);
		            return CipherParams.create({ ciphertext: ciphertext });
		        }
		    };
		}());
	
	
		return CryptoJS.format.Hex;
	
	}));

/***/ },
/* 6689 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(175), __webpack_require__(6690), __webpack_require__(6687), __webpack_require__(112), __webpack_require__(113), __webpack_require__(255), __webpack_require__(432), __webpack_require__(6706), __webpack_require__(433), __webpack_require__(6708), __webpack_require__(6707), __webpack_require__(6705), __webpack_require__(254), __webpack_require__(6701), __webpack_require__(96), __webpack_require__(50), __webpack_require__(6691), __webpack_require__(6693), __webpack_require__(6692), __webpack_require__(6695), __webpack_require__(6694), __webpack_require__(6696), __webpack_require__(6697), __webpack_require__(6698), __webpack_require__(6700), __webpack_require__(6699), __webpack_require__(6688), __webpack_require__(6686), __webpack_require__(6709), __webpack_require__(6704), __webpack_require__(6703), __webpack_require__(6702));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core", "./lib-typedarrays", "./enc-utf16", "./enc-base64", "./md5", "./sha1", "./sha256", "./sha224", "./sha512", "./sha384", "./sha3", "./ripemd160", "./hmac", "./pbkdf2", "./evpkdf", "./cipher-core", "./mode-cfb", "./mode-ctr", "./mode-ctr-gladman", "./mode-ofb", "./mode-ecb", "./pad-ansix923", "./pad-iso10126", "./pad-iso97971", "./pad-zeropadding", "./pad-nopadding", "./format-hex", "./aes", "./tripledes", "./rc4", "./rabbit", "./rabbit-legacy"], factory);
		}
		else {
			// Global (browser)
			root.CryptoJS = factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		return CryptoJS;
	
	}));

/***/ },
/* 6690 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Check if typed arrays are supported
		    if (typeof ArrayBuffer != 'function') {
		        return;
		    }
	
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
	
		    // Reference original init
		    var superInit = WordArray.init;
	
		    // Augment WordArray.init to handle typed arrays
		    var subInit = WordArray.init = function (typedArray) {
		        // Convert buffers to uint8
		        if (typedArray instanceof ArrayBuffer) {
		            typedArray = new Uint8Array(typedArray);
		        }
	
		        // Convert other array views to uint8
		        if (
		            typedArray instanceof Int8Array ||
		            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
		            typedArray instanceof Int16Array ||
		            typedArray instanceof Uint16Array ||
		            typedArray instanceof Int32Array ||
		            typedArray instanceof Uint32Array ||
		            typedArray instanceof Float32Array ||
		            typedArray instanceof Float64Array
		        ) {
		            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
		        }
	
		        // Handle Uint8Array
		        if (typedArray instanceof Uint8Array) {
		            // Shortcut
		            var typedArrayByteLength = typedArray.byteLength;
	
		            // Extract bytes
		            var words = [];
		            for (var i = 0; i < typedArrayByteLength; i++) {
		                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
		            }
	
		            // Initialize this word array
		            superInit.call(this, words, typedArrayByteLength);
		        } else {
		            // Else call normal init
		            superInit.apply(this, arguments);
		        }
		    };
	
		    subInit.prototype = WordArray;
		}());
	
	
		return CryptoJS.lib.WordArray;
	
	}));

/***/ },
/* 6691 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(50));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Cipher Feedback block mode.
		 */
		CryptoJS.mode.CFB = (function () {
		    var CFB = CryptoJS.lib.BlockCipherMode.extend();
	
		    CFB.Encryptor = CFB.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher;
		            var blockSize = cipher.blockSize;
	
		            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
	
		            // Remember this block to use with next block
		            this._prevBlock = words.slice(offset, offset + blockSize);
		        }
		    });
	
		    CFB.Decryptor = CFB.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher;
		            var blockSize = cipher.blockSize;
	
		            // Remember this block to use with next block
		            var thisBlock = words.slice(offset, offset + blockSize);
	
		            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
	
		            // This block becomes the previous block
		            this._prevBlock = thisBlock;
		        }
		    });
	
		    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
		        var keystream;
	
		        // Shortcut
		        var iv = this._iv;
	
		        // Generate keystream
		        if (iv) {
		            keystream = iv.slice(0);
	
		            // Remove IV for subsequent blocks
		            this._iv = undefined;
		        } else {
		            keystream = this._prevBlock;
		        }
		        cipher.encryptBlock(keystream, 0);
	
		        // Encrypt
		        for (var i = 0; i < blockSize; i++) {
		            words[offset + i] ^= keystream[i];
		        }
		    }
	
		    return CFB;
		}());
	
	
		return CryptoJS.mode.CFB;
	
	}));

/***/ },
/* 6692 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(50));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/** @preserve
		 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
		 * derived from CryptoJS.mode.CTR
		 * Jan Hruby jhruby.web@gmail.com
		 */
		CryptoJS.mode.CTRGladman = (function () {
		    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
	
			function incWord(word)
			{
				if (((word >> 24) & 0xff) === 0xff) { //overflow
				var b1 = (word >> 16)&0xff;
				var b2 = (word >> 8)&0xff;
				var b3 = word & 0xff;
	
				if (b1 === 0xff) // overflow b1
				{
				b1 = 0;
				if (b2 === 0xff)
				{
					b2 = 0;
					if (b3 === 0xff)
					{
						b3 = 0;
					}
					else
					{
						++b3;
					}
				}
				else
				{
					++b2;
				}
				}
				else
				{
				++b1;
				}
	
				word = 0;
				word += (b1 << 16);
				word += (b2 << 8);
				word += b3;
				}
				else
				{
				word += (0x01 << 24);
				}
				return word;
			}
	
			function incCounter(counter)
			{
				if ((counter[0] = incWord(counter[0])) === 0)
				{
					// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
					counter[1] = incWord(counter[1]);
				}
				return counter;
			}
	
		    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher
		            var blockSize = cipher.blockSize;
		            var iv = this._iv;
		            var counter = this._counter;
	
		            // Generate keystream
		            if (iv) {
		                counter = this._counter = iv.slice(0);
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            }
	
					incCounter(counter);
	
					var keystream = counter.slice(0);
		            cipher.encryptBlock(keystream, 0);
	
		            // Encrypt
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= keystream[i];
		            }
		        }
		    });
	
		    CTRGladman.Decryptor = Encryptor;
	
		    return CTRGladman;
		}());
	
	
	
	
		return CryptoJS.mode.CTRGladman;
	
	}));

/***/ },
/* 6693 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(50));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Counter block mode.
		 */
		CryptoJS.mode.CTR = (function () {
		    var CTR = CryptoJS.lib.BlockCipherMode.extend();
	
		    var Encryptor = CTR.Encryptor = CTR.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher
		            var blockSize = cipher.blockSize;
		            var iv = this._iv;
		            var counter = this._counter;
	
		            // Generate keystream
		            if (iv) {
		                counter = this._counter = iv.slice(0);
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            }
		            var keystream = counter.slice(0);
		            cipher.encryptBlock(keystream, 0);
	
		            // Increment counter
		            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0
	
		            // Encrypt
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= keystream[i];
		            }
		        }
		    });
	
		    CTR.Decryptor = Encryptor;
	
		    return CTR;
		}());
	
	
		return CryptoJS.mode.CTR;
	
	}));

/***/ },
/* 6694 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(50));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Electronic Codebook block mode.
		 */
		CryptoJS.mode.ECB = (function () {
		    var ECB = CryptoJS.lib.BlockCipherMode.extend();
	
		    ECB.Encryptor = ECB.extend({
		        processBlock: function (words, offset) {
		            this._cipher.encryptBlock(words, offset);
		        }
		    });
	
		    ECB.Decryptor = ECB.extend({
		        processBlock: function (words, offset) {
		            this._cipher.decryptBlock(words, offset);
		        }
		    });
	
		    return ECB;
		}());
	
	
		return CryptoJS.mode.ECB;
	
	}));

/***/ },
/* 6695 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(50));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Output Feedback block mode.
		 */
		CryptoJS.mode.OFB = (function () {
		    var OFB = CryptoJS.lib.BlockCipherMode.extend();
	
		    var Encryptor = OFB.Encryptor = OFB.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher
		            var blockSize = cipher.blockSize;
		            var iv = this._iv;
		            var keystream = this._keystream;
	
		            // Generate keystream
		            if (iv) {
		                keystream = this._keystream = iv.slice(0);
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            }
		            cipher.encryptBlock(keystream, 0);
	
		            // Encrypt
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= keystream[i];
		            }
		        }
		    });
	
		    OFB.Decryptor = Encryptor;
	
		    return OFB;
		}());
	
	
		return CryptoJS.mode.OFB;
	
	}));

/***/ },
/* 6696 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(50));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * ANSI X.923 padding strategy.
		 */
		CryptoJS.pad.AnsiX923 = {
		    pad: function (data, blockSize) {
		        // Shortcuts
		        var dataSigBytes = data.sigBytes;
		        var blockSizeBytes = blockSize * 4;
	
		        // Count padding bytes
		        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
	
		        // Compute last byte position
		        var lastBytePos = dataSigBytes + nPaddingBytes - 1;
	
		        // Pad
		        data.clamp();
		        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
		        data.sigBytes += nPaddingBytes;
		    },
	
		    unpad: function (data) {
		        // Get number of padding bytes from last byte
		        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;
	
		        // Remove padding
		        data.sigBytes -= nPaddingBytes;
		    }
		};
	
	
		return CryptoJS.pad.Ansix923;
	
	}));

/***/ },
/* 6697 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(50));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * ISO 10126 padding strategy.
		 */
		CryptoJS.pad.Iso10126 = {
		    pad: function (data, blockSize) {
		        // Shortcut
		        var blockSizeBytes = blockSize * 4;
	
		        // Count padding bytes
		        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
	
		        // Pad
		        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
		             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
		    },
	
		    unpad: function (data) {
		        // Get number of padding bytes from last byte
		        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;
	
		        // Remove padding
		        data.sigBytes -= nPaddingBytes;
		    }
		};
	
	
		return CryptoJS.pad.Iso10126;
	
	}));

/***/ },
/* 6698 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(50));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * ISO/IEC 9797-1 Padding Method 2.
		 */
		CryptoJS.pad.Iso97971 = {
		    pad: function (data, blockSize) {
		        // Add 0x80 byte
		        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));
	
		        // Zero pad the rest
		        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
		    },
	
		    unpad: function (data) {
		        // Remove zero padding
		        CryptoJS.pad.ZeroPadding.unpad(data);
	
		        // Remove one more byte -- the 0x80 byte
		        data.sigBytes--;
		    }
		};
	
	
		return CryptoJS.pad.Iso97971;
	
	}));

/***/ },
/* 6699 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(50));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * A noop padding strategy.
		 */
		CryptoJS.pad.NoPadding = {
		    pad: function () {
		    },
	
		    unpad: function () {
		    }
		};
	
	
		return CryptoJS.pad.NoPadding;
	
	}));

/***/ },
/* 6700 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(50));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Zero padding strategy.
		 */
		CryptoJS.pad.ZeroPadding = {
		    pad: function (data, blockSize) {
		        // Shortcut
		        var blockSizeBytes = blockSize * 4;
	
		        // Pad
		        data.clamp();
		        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
		    },
	
		    unpad: function (data) {
		        // Shortcut
		        var dataWords = data.words;
	
		        // Unpad
		        var i = data.sigBytes - 1;
		        for (var i = data.sigBytes - 1; i >= 0; i--) {
		            if (((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
		                data.sigBytes = i + 1;
		                break;
		            }
		        }
		    }
		};
	
	
		return CryptoJS.pad.ZeroPadding;
	
	}));

/***/ },
/* 6701 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(255), __webpack_require__(254));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./sha1", "./hmac"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var WordArray = C_lib.WordArray;
		    var C_algo = C.algo;
		    var SHA1 = C_algo.SHA1;
		    var HMAC = C_algo.HMAC;
	
		    /**
		     * Password-Based Key Derivation Function 2 algorithm.
		     */
		    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
		         * @property {Hasher} hasher The hasher to use. Default: SHA1
		         * @property {number} iterations The number of iterations to perform. Default: 1
		         */
		        cfg: Base.extend({
		            keySize: 128/32,
		            hasher: SHA1,
		            iterations: 1
		        }),
	
		        /**
		         * Initializes a newly created key derivation function.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
		         *
		         * @example
		         *
		         *     var kdf = CryptoJS.algo.PBKDF2.create();
		         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
		         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
		         */
		        init: function (cfg) {
		            this.cfg = this.cfg.extend(cfg);
		        },
	
		        /**
		         * Computes the Password-Based Key Derivation Function 2.
		         *
		         * @param {WordArray|string} password The password.
		         * @param {WordArray|string} salt A salt.
		         *
		         * @return {WordArray} The derived key.
		         *
		         * @example
		         *
		         *     var key = kdf.compute(password, salt);
		         */
		        compute: function (password, salt) {
		            // Shortcut
		            var cfg = this.cfg;
	
		            // Init HMAC
		            var hmac = HMAC.create(cfg.hasher, password);
	
		            // Initial values
		            var derivedKey = WordArray.create();
		            var blockIndex = WordArray.create([0x00000001]);
	
		            // Shortcuts
		            var derivedKeyWords = derivedKey.words;
		            var blockIndexWords = blockIndex.words;
		            var keySize = cfg.keySize;
		            var iterations = cfg.iterations;
	
		            // Generate key
		            while (derivedKeyWords.length < keySize) {
		                var block = hmac.update(salt).finalize(blockIndex);
		                hmac.reset();
	
		                // Shortcuts
		                var blockWords = block.words;
		                var blockWordsLength = blockWords.length;
	
		                // Iterations
		                var intermediate = block;
		                for (var i = 1; i < iterations; i++) {
		                    intermediate = hmac.finalize(intermediate);
		                    hmac.reset();
	
		                    // Shortcut
		                    var intermediateWords = intermediate.words;
	
		                    // XOR intermediate with block
		                    for (var j = 0; j < blockWordsLength; j++) {
		                        blockWords[j] ^= intermediateWords[j];
		                    }
		                }
	
		                derivedKey.concat(block);
		                blockIndexWords[0]++;
		            }
		            derivedKey.sigBytes = keySize * 4;
	
		            return derivedKey;
		        }
		    });
	
		    /**
		     * Computes the Password-Based Key Derivation Function 2.
		     *
		     * @param {WordArray|string} password The password.
		     * @param {WordArray|string} salt A salt.
		     * @param {Object} cfg (Optional) The configuration options to use for this computation.
		     *
		     * @return {WordArray} The derived key.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var key = CryptoJS.PBKDF2(password, salt);
		     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
		     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
		     */
		    C.PBKDF2 = function (password, salt, cfg) {
		        return PBKDF2.create(cfg).compute(password, salt);
		    };
		}());
	
	
		return CryptoJS.PBKDF2;
	
	}));

/***/ },
/* 6702 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(112), __webpack_require__(113), __webpack_require__(96), __webpack_require__(50));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var StreamCipher = C_lib.StreamCipher;
		    var C_algo = C.algo;
	
		    // Reusable objects
		    var S  = [];
		    var C_ = [];
		    var G  = [];
	
		    /**
		     * Rabbit stream cipher algorithm.
		     *
		     * This is a legacy version that neglected to convert the key to little-endian.
		     * This error doesn't affect the cipher's security,
		     * but it does affect its compatibility with other implementations.
		     */
		    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var K = this._key.words;
		            var iv = this.cfg.iv;
	
		            // Generate initial state values
		            var X = this._X = [
		                K[0], (K[3] << 16) | (K[2] >>> 16),
		                K[1], (K[0] << 16) | (K[3] >>> 16),
		                K[2], (K[1] << 16) | (K[0] >>> 16),
		                K[3], (K[2] << 16) | (K[1] >>> 16)
		            ];
	
		            // Generate initial counter values
		            var C = this._C = [
		                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
		                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
		                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
		                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
		            ];
	
		            // Carry bit
		            this._b = 0;
	
		            // Iterate the system four times
		            for (var i = 0; i < 4; i++) {
		                nextState.call(this);
		            }
	
		            // Modify the counters
		            for (var i = 0; i < 8; i++) {
		                C[i] ^= X[(i + 4) & 7];
		            }
	
		            // IV setup
		            if (iv) {
		                // Shortcuts
		                var IV = iv.words;
		                var IV_0 = IV[0];
		                var IV_1 = IV[1];
	
		                // Generate four subvectors
		                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
		                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
		                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
		                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);
	
		                // Modify counter values
		                C[0] ^= i0;
		                C[1] ^= i1;
		                C[2] ^= i2;
		                C[3] ^= i3;
		                C[4] ^= i0;
		                C[5] ^= i1;
		                C[6] ^= i2;
		                C[7] ^= i3;
	
		                // Iterate the system four times
		                for (var i = 0; i < 4; i++) {
		                    nextState.call(this);
		                }
		            }
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var X = this._X;
	
		            // Iterate the system
		            nextState.call(this);
	
		            // Generate four keystream words
		            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
		            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
		            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
		            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);
	
		            for (var i = 0; i < 4; i++) {
		                // Swap endian
		                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
		                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);
	
		                // Encrypt
		                M[offset + i] ^= S[i];
		            }
		        },
	
		        blockSize: 128/32,
	
		        ivSize: 64/32
		    });
	
		    function nextState() {
		        // Shortcuts
		        var X = this._X;
		        var C = this._C;
	
		        // Save old counter values
		        for (var i = 0; i < 8; i++) {
		            C_[i] = C[i];
		        }
	
		        // Calculate new counter values
		        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
		        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
		        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
		        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
		        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
		        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
		        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
		        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
		        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;
	
		        // Calculate the g-values
		        for (var i = 0; i < 8; i++) {
		            var gx = X[i] + C[i];
	
		            // Construct high and low argument for squaring
		            var ga = gx & 0xffff;
		            var gb = gx >>> 16;
	
		            // Calculate high and low result of squaring
		            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
		            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);
	
		            // High XOR low
		            G[i] = gh ^ gl;
		        }
	
		        // Calculate new state values
		        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
		        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
		        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
		        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
		        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
		        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
		        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
		        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
		     */
		    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
		}());
	
	
		return CryptoJS.RabbitLegacy;
	
	}));

/***/ },
/* 6703 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(112), __webpack_require__(113), __webpack_require__(96), __webpack_require__(50));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var StreamCipher = C_lib.StreamCipher;
		    var C_algo = C.algo;
	
		    // Reusable objects
		    var S  = [];
		    var C_ = [];
		    var G  = [];
	
		    /**
		     * Rabbit stream cipher algorithm
		     */
		    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var K = this._key.words;
		            var iv = this.cfg.iv;
	
		            // Swap endian
		            for (var i = 0; i < 4; i++) {
		                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
		                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
		            }
	
		            // Generate initial state values
		            var X = this._X = [
		                K[0], (K[3] << 16) | (K[2] >>> 16),
		                K[1], (K[0] << 16) | (K[3] >>> 16),
		                K[2], (K[1] << 16) | (K[0] >>> 16),
		                K[3], (K[2] << 16) | (K[1] >>> 16)
		            ];
	
		            // Generate initial counter values
		            var C = this._C = [
		                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
		                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
		                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
		                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
		            ];
	
		            // Carry bit
		            this._b = 0;
	
		            // Iterate the system four times
		            for (var i = 0; i < 4; i++) {
		                nextState.call(this);
		            }
	
		            // Modify the counters
		            for (var i = 0; i < 8; i++) {
		                C[i] ^= X[(i + 4) & 7];
		            }
	
		            // IV setup
		            if (iv) {
		                // Shortcuts
		                var IV = iv.words;
		                var IV_0 = IV[0];
		                var IV_1 = IV[1];
	
		                // Generate four subvectors
		                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
		                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
		                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
		                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);
	
		                // Modify counter values
		                C[0] ^= i0;
		                C[1] ^= i1;
		                C[2] ^= i2;
		                C[3] ^= i3;
		                C[4] ^= i0;
		                C[5] ^= i1;
		                C[6] ^= i2;
		                C[7] ^= i3;
	
		                // Iterate the system four times
		                for (var i = 0; i < 4; i++) {
		                    nextState.call(this);
		                }
		            }
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var X = this._X;
	
		            // Iterate the system
		            nextState.call(this);
	
		            // Generate four keystream words
		            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
		            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
		            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
		            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);
	
		            for (var i = 0; i < 4; i++) {
		                // Swap endian
		                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
		                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);
	
		                // Encrypt
		                M[offset + i] ^= S[i];
		            }
		        },
	
		        blockSize: 128/32,
	
		        ivSize: 64/32
		    });
	
		    function nextState() {
		        // Shortcuts
		        var X = this._X;
		        var C = this._C;
	
		        // Save old counter values
		        for (var i = 0; i < 8; i++) {
		            C_[i] = C[i];
		        }
	
		        // Calculate new counter values
		        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
		        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
		        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
		        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
		        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
		        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
		        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
		        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
		        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;
	
		        // Calculate the g-values
		        for (var i = 0; i < 8; i++) {
		            var gx = X[i] + C[i];
	
		            // Construct high and low argument for squaring
		            var ga = gx & 0xffff;
		            var gb = gx >>> 16;
	
		            // Calculate high and low result of squaring
		            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
		            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);
	
		            // High XOR low
		            G[i] = gh ^ gl;
		        }
	
		        // Calculate new state values
		        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
		        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
		        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
		        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
		        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
		        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
		        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
		        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
		     */
		    C.Rabbit = StreamCipher._createHelper(Rabbit);
		}());
	
	
		return CryptoJS.Rabbit;
	
	}));

/***/ },
/* 6704 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(112), __webpack_require__(113), __webpack_require__(96), __webpack_require__(50));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var StreamCipher = C_lib.StreamCipher;
		    var C_algo = C.algo;
	
		    /**
		     * RC4 stream cipher algorithm.
		     */
		    var RC4 = C_algo.RC4 = StreamCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var key = this._key;
		            var keyWords = key.words;
		            var keySigBytes = key.sigBytes;
	
		            // Init sbox
		            var S = this._S = [];
		            for (var i = 0; i < 256; i++) {
		                S[i] = i;
		            }
	
		            // Key setup
		            for (var i = 0, j = 0; i < 256; i++) {
		                var keyByteIndex = i % keySigBytes;
		                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;
	
		                j = (j + S[i] + keyByte) % 256;
	
		                // Swap
		                var t = S[i];
		                S[i] = S[j];
		                S[j] = t;
		            }
	
		            // Counters
		            this._i = this._j = 0;
		        },
	
		        _doProcessBlock: function (M, offset) {
		            M[offset] ^= generateKeystreamWord.call(this);
		        },
	
		        keySize: 256/32,
	
		        ivSize: 0
		    });
	
		    function generateKeystreamWord() {
		        // Shortcuts
		        var S = this._S;
		        var i = this._i;
		        var j = this._j;
	
		        // Generate keystream word
		        var keystreamWord = 0;
		        for (var n = 0; n < 4; n++) {
		            i = (i + 1) % 256;
		            j = (j + S[i]) % 256;
	
		            // Swap
		            var t = S[i];
		            S[i] = S[j];
		            S[j] = t;
	
		            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
		        }
	
		        // Update counters
		        this._i = i;
		        this._j = j;
	
		        return keystreamWord;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
		     */
		    C.RC4 = StreamCipher._createHelper(RC4);
	
		    /**
		     * Modified RC4 stream cipher algorithm.
		     */
		    var RC4Drop = C_algo.RC4Drop = RC4.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} drop The number of keystream words to drop. Default 192
		         */
		        cfg: RC4.cfg.extend({
		            drop: 192
		        }),
	
		        _doReset: function () {
		            RC4._doReset.call(this);
	
		            // Drop
		            for (var i = this.cfg.drop; i > 0; i--) {
		                generateKeystreamWord.call(this);
		            }
		        }
		    });
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
		     */
		    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
		}());
	
	
		return CryptoJS.RC4;
	
	}));

/***/ },
/* 6705 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/** @preserve
		(c) 2012 by Cédric Mesnil. All rights reserved.
	
		Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
		    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
		    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
		THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
		*/
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Constants table
		    var _zl = WordArray.create([
		        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
		        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
		        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
		        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
		        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
		    var _zr = WordArray.create([
		        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
		        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
		        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
		        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
		        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
		    var _sl = WordArray.create([
		         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
		        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
		        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
		          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
		        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
		    var _sr = WordArray.create([
		        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
		        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
		        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
		        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
		        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);
	
		    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
		    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);
	
		    /**
		     * RIPEMD160 hash algorithm.
		     */
		    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
		        _doReset: function () {
		            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
		        },
	
		        _doProcessBlock: function (M, offset) {
	
		            // Swap endian
		            for (var i = 0; i < 16; i++) {
		                // Shortcuts
		                var offset_i = offset + i;
		                var M_offset_i = M[offset_i];
	
		                // Swap
		                M[offset_i] = (
		                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
		                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
		                );
		            }
		            // Shortcut
		            var H  = this._hash.words;
		            var hl = _hl.words;
		            var hr = _hr.words;
		            var zl = _zl.words;
		            var zr = _zr.words;
		            var sl = _sl.words;
		            var sr = _sr.words;
	
		            // Working variables
		            var al, bl, cl, dl, el;
		            var ar, br, cr, dr, er;
	
		            ar = al = H[0];
		            br = bl = H[1];
		            cr = cl = H[2];
		            dr = dl = H[3];
		            er = el = H[4];
		            // Computation
		            var t;
		            for (var i = 0; i < 80; i += 1) {
		                t = (al +  M[offset+zl[i]])|0;
		                if (i<16){
			            t +=  f1(bl,cl,dl) + hl[0];
		                } else if (i<32) {
			            t +=  f2(bl,cl,dl) + hl[1];
		                } else if (i<48) {
			            t +=  f3(bl,cl,dl) + hl[2];
		                } else if (i<64) {
			            t +=  f4(bl,cl,dl) + hl[3];
		                } else {// if (i<80) {
			            t +=  f5(bl,cl,dl) + hl[4];
		                }
		                t = t|0;
		                t =  rotl(t,sl[i]);
		                t = (t+el)|0;
		                al = el;
		                el = dl;
		                dl = rotl(cl, 10);
		                cl = bl;
		                bl = t;
	
		                t = (ar + M[offset+zr[i]])|0;
		                if (i<16){
			            t +=  f5(br,cr,dr) + hr[0];
		                } else if (i<32) {
			            t +=  f4(br,cr,dr) + hr[1];
		                } else if (i<48) {
			            t +=  f3(br,cr,dr) + hr[2];
		                } else if (i<64) {
			            t +=  f2(br,cr,dr) + hr[3];
		                } else {// if (i<80) {
			            t +=  f1(br,cr,dr) + hr[4];
		                }
		                t = t|0;
		                t =  rotl(t,sr[i]) ;
		                t = (t+er)|0;
		                ar = er;
		                er = dr;
		                dr = rotl(cr, 10);
		                cr = br;
		                br = t;
		            }
		            // Intermediate hash value
		            t    = (H[1] + cl + dr)|0;
		            H[1] = (H[2] + dl + er)|0;
		            H[2] = (H[3] + el + ar)|0;
		            H[3] = (H[4] + al + br)|0;
		            H[4] = (H[0] + bl + cr)|0;
		            H[0] =  t;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
		                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
		            );
		            data.sigBytes = (dataWords.length + 1) * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Shortcuts
		            var hash = this._hash;
		            var H = hash.words;
	
		            // Swap endian
		            for (var i = 0; i < 5; i++) {
		                // Shortcut
		                var H_i = H[i];
	
		                // Swap
		                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
		                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
		            }
	
		            // Return final computed hash
		            return hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
	
		    function f1(x, y, z) {
		        return ((x) ^ (y) ^ (z));
	
		    }
	
		    function f2(x, y, z) {
		        return (((x)&(y)) | ((~x)&(z)));
		    }
	
		    function f3(x, y, z) {
		        return (((x) | (~(y))) ^ (z));
		    }
	
		    function f4(x, y, z) {
		        return (((x) & (z)) | ((y)&(~(z))));
		    }
	
		    function f5(x, y, z) {
		        return ((x) ^ ((y) |(~(z))));
	
		    }
	
		    function rotl(x,n) {
		        return (x<<n) | (x>>>(32-n));
		    }
	
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.RIPEMD160('message');
		     *     var hash = CryptoJS.RIPEMD160(wordArray);
		     */
		    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
		     */
		    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
		}(Math));
	
	
		return CryptoJS.RIPEMD160;
	
	}));

/***/ },
/* 6706 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(432));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./sha256"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_algo = C.algo;
		    var SHA256 = C_algo.SHA256;
	
		    /**
		     * SHA-224 hash algorithm.
		     */
		    var SHA224 = C_algo.SHA224 = SHA256.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
		                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
		            ]);
		        },
	
		        _doFinalize: function () {
		            var hash = SHA256._doFinalize.call(this);
	
		            hash.sigBytes -= 4;
	
		            return hash;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA224('message');
		     *     var hash = CryptoJS.SHA224(wordArray);
		     */
		    C.SHA224 = SHA256._createHelper(SHA224);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA224(message, key);
		     */
		    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
		}());
	
	
		return CryptoJS.SHA224;
	
	}));

/***/ },
/* 6707 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(175));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_x64 = C.x64;
		    var X64Word = C_x64.Word;
		    var C_algo = C.algo;
	
		    // Constants tables
		    var RHO_OFFSETS = [];
		    var PI_INDEXES  = [];
		    var ROUND_CONSTANTS = [];
	
		    // Compute Constants
		    (function () {
		        // Compute rho offset constants
		        var x = 1, y = 0;
		        for (var t = 0; t < 24; t++) {
		            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;
	
		            var newX = y % 5;
		            var newY = (2 * x + 3 * y) % 5;
		            x = newX;
		            y = newY;
		        }
	
		        // Compute pi index constants
		        for (var x = 0; x < 5; x++) {
		            for (var y = 0; y < 5; y++) {
		                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
		            }
		        }
	
		        // Compute round constants
		        var LFSR = 0x01;
		        for (var i = 0; i < 24; i++) {
		            var roundConstantMsw = 0;
		            var roundConstantLsw = 0;
	
		            for (var j = 0; j < 7; j++) {
		                if (LFSR & 0x01) {
		                    var bitPosition = (1 << j) - 1;
		                    if (bitPosition < 32) {
		                        roundConstantLsw ^= 1 << bitPosition;
		                    } else /* if (bitPosition >= 32) */ {
		                        roundConstantMsw ^= 1 << (bitPosition - 32);
		                    }
		                }
	
		                // Compute next LFSR
		                if (LFSR & 0x80) {
		                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
		                    LFSR = (LFSR << 1) ^ 0x71;
		                } else {
		                    LFSR <<= 1;
		                }
		            }
	
		            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
		        }
		    }());
	
		    // Reusable objects for temporary values
		    var T = [];
		    (function () {
		        for (var i = 0; i < 25; i++) {
		            T[i] = X64Word.create();
		        }
		    }());
	
		    /**
		     * SHA-3 hash algorithm.
		     */
		    var SHA3 = C_algo.SHA3 = Hasher.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} outputLength
		         *   The desired number of bits in the output hash.
		         *   Only values permitted are: 224, 256, 384, 512.
		         *   Default: 512
		         */
		        cfg: Hasher.cfg.extend({
		            outputLength: 512
		        }),
	
		        _doReset: function () {
		            var state = this._state = []
		            for (var i = 0; i < 25; i++) {
		                state[i] = new X64Word.init();
		            }
	
		            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcuts
		            var state = this._state;
		            var nBlockSizeLanes = this.blockSize / 2;
	
		            // Absorb
		            for (var i = 0; i < nBlockSizeLanes; i++) {
		                // Shortcuts
		                var M2i  = M[offset + 2 * i];
		                var M2i1 = M[offset + 2 * i + 1];
	
		                // Swap endian
		                M2i = (
		                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
		                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
		                );
		                M2i1 = (
		                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
		                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
		                );
	
		                // Absorb message into state
		                var lane = state[i];
		                lane.high ^= M2i1;
		                lane.low  ^= M2i;
		            }
	
		            // Rounds
		            for (var round = 0; round < 24; round++) {
		                // Theta
		                for (var x = 0; x < 5; x++) {
		                    // Mix column lanes
		                    var tMsw = 0, tLsw = 0;
		                    for (var y = 0; y < 5; y++) {
		                        var lane = state[x + 5 * y];
		                        tMsw ^= lane.high;
		                        tLsw ^= lane.low;
		                    }
	
		                    // Temporary values
		                    var Tx = T[x];
		                    Tx.high = tMsw;
		                    Tx.low  = tLsw;
		                }
		                for (var x = 0; x < 5; x++) {
		                    // Shortcuts
		                    var Tx4 = T[(x + 4) % 5];
		                    var Tx1 = T[(x + 1) % 5];
		                    var Tx1Msw = Tx1.high;
		                    var Tx1Lsw = Tx1.low;
	
		                    // Mix surrounding columns
		                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
		                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
		                    for (var y = 0; y < 5; y++) {
		                        var lane = state[x + 5 * y];
		                        lane.high ^= tMsw;
		                        lane.low  ^= tLsw;
		                    }
		                }
	
		                // Rho Pi
		                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
		                    var tMsw;
		                    var tLsw;
	
		                    // Shortcuts
		                    var lane = state[laneIndex];
		                    var laneMsw = lane.high;
		                    var laneLsw = lane.low;
		                    var rhoOffset = RHO_OFFSETS[laneIndex];
	
		                    // Rotate lanes
		                    if (rhoOffset < 32) {
		                        tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
		                        tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
		                    } else /* if (rhoOffset >= 32) */ {
		                        tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
		                        tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
		                    }
	
		                    // Transpose lanes
		                    var TPiLane = T[PI_INDEXES[laneIndex]];
		                    TPiLane.high = tMsw;
		                    TPiLane.low  = tLsw;
		                }
	
		                // Rho pi at x = y = 0
		                var T0 = T[0];
		                var state0 = state[0];
		                T0.high = state0.high;
		                T0.low  = state0.low;
	
		                // Chi
		                for (var x = 0; x < 5; x++) {
		                    for (var y = 0; y < 5; y++) {
		                        // Shortcuts
		                        var laneIndex = x + 5 * y;
		                        var lane = state[laneIndex];
		                        var TLane = T[laneIndex];
		                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
		                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];
	
		                        // Mix rows
		                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
		                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
		                    }
		                }
	
		                // Iota
		                var lane = state[0];
		                var roundConstant = ROUND_CONSTANTS[round];
		                lane.high ^= roundConstant.high;
		                lane.low  ^= roundConstant.low;
		            }
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
		            var blockSizeBits = this.blockSize * 32;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
		            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Shortcuts
		            var state = this._state;
		            var outputLengthBytes = this.cfg.outputLength / 8;
		            var outputLengthLanes = outputLengthBytes / 8;
	
		            // Squeeze
		            var hashWords = [];
		            for (var i = 0; i < outputLengthLanes; i++) {
		                // Shortcuts
		                var lane = state[i];
		                var laneMsw = lane.high;
		                var laneLsw = lane.low;
	
		                // Swap endian
		                laneMsw = (
		                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
		                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
		                );
		                laneLsw = (
		                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
		                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
		                );
	
		                // Squeeze state to retrieve hash
		                hashWords.push(laneLsw);
		                hashWords.push(laneMsw);
		            }
	
		            // Return final computed hash
		            return new WordArray.init(hashWords, outputLengthBytes);
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
	
		            var state = clone._state = this._state.slice(0);
		            for (var i = 0; i < 25; i++) {
		                state[i] = state[i].clone();
		            }
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA3('message');
		     *     var hash = CryptoJS.SHA3(wordArray);
		     */
		    C.SHA3 = Hasher._createHelper(SHA3);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA3(message, key);
		     */
		    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
		}(Math));
	
	
		return CryptoJS.SHA3;
	
	}));

/***/ },
/* 6708 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(175), __webpack_require__(433));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core", "./sha512"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_x64 = C.x64;
		    var X64Word = C_x64.Word;
		    var X64WordArray = C_x64.WordArray;
		    var C_algo = C.algo;
		    var SHA512 = C_algo.SHA512;
	
		    /**
		     * SHA-384 hash algorithm.
		     */
		    var SHA384 = C_algo.SHA384 = SHA512.extend({
		        _doReset: function () {
		            this._hash = new X64WordArray.init([
		                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
		                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
		                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
		                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
		            ]);
		        },
	
		        _doFinalize: function () {
		            var hash = SHA512._doFinalize.call(this);
	
		            hash.sigBytes -= 16;
	
		            return hash;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA384('message');
		     *     var hash = CryptoJS.SHA384(wordArray);
		     */
		    C.SHA384 = SHA512._createHelper(SHA384);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA384(message, key);
		     */
		    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
		}());
	
	
		return CryptoJS.SHA384;
	
	}));

/***/ },
/* 6709 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(33), __webpack_require__(112), __webpack_require__(113), __webpack_require__(96), __webpack_require__(50));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var BlockCipher = C_lib.BlockCipher;
		    var C_algo = C.algo;
	
		    // Permuted Choice 1 constants
		    var PC1 = [
		        57, 49, 41, 33, 25, 17, 9,  1,
		        58, 50, 42, 34, 26, 18, 10, 2,
		        59, 51, 43, 35, 27, 19, 11, 3,
		        60, 52, 44, 36, 63, 55, 47, 39,
		        31, 23, 15, 7,  62, 54, 46, 38,
		        30, 22, 14, 6,  61, 53, 45, 37,
		        29, 21, 13, 5,  28, 20, 12, 4
		    ];
	
		    // Permuted Choice 2 constants
		    var PC2 = [
		        14, 17, 11, 24, 1,  5,
		        3,  28, 15, 6,  21, 10,
		        23, 19, 12, 4,  26, 8,
		        16, 7,  27, 20, 13, 2,
		        41, 52, 31, 37, 47, 55,
		        30, 40, 51, 45, 33, 48,
		        44, 49, 39, 56, 34, 53,
		        46, 42, 50, 36, 29, 32
		    ];
	
		    // Cumulative bit shift constants
		    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];
	
		    // SBOXes and round permutation constants
		    var SBOX_P = [
		        {
		            0x0: 0x808200,
		            0x10000000: 0x8000,
		            0x20000000: 0x808002,
		            0x30000000: 0x2,
		            0x40000000: 0x200,
		            0x50000000: 0x808202,
		            0x60000000: 0x800202,
		            0x70000000: 0x800000,
		            0x80000000: 0x202,
		            0x90000000: 0x800200,
		            0xa0000000: 0x8200,
		            0xb0000000: 0x808000,
		            0xc0000000: 0x8002,
		            0xd0000000: 0x800002,
		            0xe0000000: 0x0,
		            0xf0000000: 0x8202,
		            0x8000000: 0x0,
		            0x18000000: 0x808202,
		            0x28000000: 0x8202,
		            0x38000000: 0x8000,
		            0x48000000: 0x808200,
		            0x58000000: 0x200,
		            0x68000000: 0x808002,
		            0x78000000: 0x2,
		            0x88000000: 0x800200,
		            0x98000000: 0x8200,
		            0xa8000000: 0x808000,
		            0xb8000000: 0x800202,
		            0xc8000000: 0x800002,
		            0xd8000000: 0x8002,
		            0xe8000000: 0x202,
		            0xf8000000: 0x800000,
		            0x1: 0x8000,
		            0x10000001: 0x2,
		            0x20000001: 0x808200,
		            0x30000001: 0x800000,
		            0x40000001: 0x808002,
		            0x50000001: 0x8200,
		            0x60000001: 0x200,
		            0x70000001: 0x800202,
		            0x80000001: 0x808202,
		            0x90000001: 0x808000,
		            0xa0000001: 0x800002,
		            0xb0000001: 0x8202,
		            0xc0000001: 0x202,
		            0xd0000001: 0x800200,
		            0xe0000001: 0x8002,
		            0xf0000001: 0x0,
		            0x8000001: 0x808202,
		            0x18000001: 0x808000,
		            0x28000001: 0x800000,
		            0x38000001: 0x200,
		            0x48000001: 0x8000,
		            0x58000001: 0x800002,
		            0x68000001: 0x2,
		            0x78000001: 0x8202,
		            0x88000001: 0x8002,
		            0x98000001: 0x800202,
		            0xa8000001: 0x202,
		            0xb8000001: 0x808200,
		            0xc8000001: 0x800200,
		            0xd8000001: 0x0,
		            0xe8000001: 0x8200,
		            0xf8000001: 0x808002
		        },
		        {
		            0x0: 0x40084010,
		            0x1000000: 0x4000,
		            0x2000000: 0x80000,
		            0x3000000: 0x40080010,
		            0x4000000: 0x40000010,
		            0x5000000: 0x40084000,
		            0x6000000: 0x40004000,
		            0x7000000: 0x10,
		            0x8000000: 0x84000,
		            0x9000000: 0x40004010,
		            0xa000000: 0x40000000,
		            0xb000000: 0x84010,
		            0xc000000: 0x80010,
		            0xd000000: 0x0,
		            0xe000000: 0x4010,
		            0xf000000: 0x40080000,
		            0x800000: 0x40004000,
		            0x1800000: 0x84010,
		            0x2800000: 0x10,
		            0x3800000: 0x40004010,
		            0x4800000: 0x40084010,
		            0x5800000: 0x40000000,
		            0x6800000: 0x80000,
		            0x7800000: 0x40080010,
		            0x8800000: 0x80010,
		            0x9800000: 0x0,
		            0xa800000: 0x4000,
		            0xb800000: 0x40080000,
		            0xc800000: 0x40000010,
		            0xd800000: 0x84000,
		            0xe800000: 0x40084000,
		            0xf800000: 0x4010,
		            0x10000000: 0x0,
		            0x11000000: 0x40080010,
		            0x12000000: 0x40004010,
		            0x13000000: 0x40084000,
		            0x14000000: 0x40080000,
		            0x15000000: 0x10,
		            0x16000000: 0x84010,
		            0x17000000: 0x4000,
		            0x18000000: 0x4010,
		            0x19000000: 0x80000,
		            0x1a000000: 0x80010,
		            0x1b000000: 0x40000010,
		            0x1c000000: 0x84000,
		            0x1d000000: 0x40004000,
		            0x1e000000: 0x40000000,
		            0x1f000000: 0x40084010,
		            0x10800000: 0x84010,
		            0x11800000: 0x80000,
		            0x12800000: 0x40080000,
		            0x13800000: 0x4000,
		            0x14800000: 0x40004000,
		            0x15800000: 0x40084010,
		            0x16800000: 0x10,
		            0x17800000: 0x40000000,
		            0x18800000: 0x40084000,
		            0x19800000: 0x40000010,
		            0x1a800000: 0x40004010,
		            0x1b800000: 0x80010,
		            0x1c800000: 0x0,
		            0x1d800000: 0x4010,
		            0x1e800000: 0x40080010,
		            0x1f800000: 0x84000
		        },
		        {
		            0x0: 0x104,
		            0x100000: 0x0,
		            0x200000: 0x4000100,
		            0x300000: 0x10104,
		            0x400000: 0x10004,
		            0x500000: 0x4000004,
		            0x600000: 0x4010104,
		            0x700000: 0x4010000,
		            0x800000: 0x4000000,
		            0x900000: 0x4010100,
		            0xa00000: 0x10100,
		            0xb00000: 0x4010004,
		            0xc00000: 0x4000104,
		            0xd00000: 0x10000,
		            0xe00000: 0x4,
		            0xf00000: 0x100,
		            0x80000: 0x4010100,
		            0x180000: 0x4010004,
		            0x280000: 0x0,
		            0x380000: 0x4000100,
		            0x480000: 0x4000004,
		            0x580000: 0x10000,
		            0x680000: 0x10004,
		            0x780000: 0x104,
		            0x880000: 0x4,
		            0x980000: 0x100,
		            0xa80000: 0x4010000,
		            0xb80000: 0x10104,
		            0xc80000: 0x10100,
		            0xd80000: 0x4000104,
		            0xe80000: 0x4010104,
		            0xf80000: 0x4000000,
		            0x1000000: 0x4010100,
		            0x1100000: 0x10004,
		            0x1200000: 0x10000,
		            0x1300000: 0x4000100,
		            0x1400000: 0x100,
		            0x1500000: 0x4010104,
		            0x1600000: 0x4000004,
		            0x1700000: 0x0,
		            0x1800000: 0x4000104,
		            0x1900000: 0x4000000,
		            0x1a00000: 0x4,
		            0x1b00000: 0x10100,
		            0x1c00000: 0x4010000,
		            0x1d00000: 0x104,
		            0x1e00000: 0x10104,
		            0x1f00000: 0x4010004,
		            0x1080000: 0x4000000,
		            0x1180000: 0x104,
		            0x1280000: 0x4010100,
		            0x1380000: 0x0,
		            0x1480000: 0x10004,
		            0x1580000: 0x4000100,
		            0x1680000: 0x100,
		            0x1780000: 0x4010004,
		            0x1880000: 0x10000,
		            0x1980000: 0x4010104,
		            0x1a80000: 0x10104,
		            0x1b80000: 0x4000004,
		            0x1c80000: 0x4000104,
		            0x1d80000: 0x4010000,
		            0x1e80000: 0x4,
		            0x1f80000: 0x10100
		        },
		        {
		            0x0: 0x80401000,
		            0x10000: 0x80001040,
		            0x20000: 0x401040,
		            0x30000: 0x80400000,
		            0x40000: 0x0,
		            0x50000: 0x401000,
		            0x60000: 0x80000040,
		            0x70000: 0x400040,
		            0x80000: 0x80000000,
		            0x90000: 0x400000,
		            0xa0000: 0x40,
		            0xb0000: 0x80001000,
		            0xc0000: 0x80400040,
		            0xd0000: 0x1040,
		            0xe0000: 0x1000,
		            0xf0000: 0x80401040,
		            0x8000: 0x80001040,
		            0x18000: 0x40,
		            0x28000: 0x80400040,
		            0x38000: 0x80001000,
		            0x48000: 0x401000,
		            0x58000: 0x80401040,
		            0x68000: 0x0,
		            0x78000: 0x80400000,
		            0x88000: 0x1000,
		            0x98000: 0x80401000,
		            0xa8000: 0x400000,
		            0xb8000: 0x1040,
		            0xc8000: 0x80000000,
		            0xd8000: 0x400040,
		            0xe8000: 0x401040,
		            0xf8000: 0x80000040,
		            0x100000: 0x400040,
		            0x110000: 0x401000,
		            0x120000: 0x80000040,
		            0x130000: 0x0,
		            0x140000: 0x1040,
		            0x150000: 0x80400040,
		            0x160000: 0x80401000,
		            0x170000: 0x80001040,
		            0x180000: 0x80401040,
		            0x190000: 0x80000000,
		            0x1a0000: 0x80400000,
		            0x1b0000: 0x401040,
		            0x1c0000: 0x80001000,
		            0x1d0000: 0x400000,
		            0x1e0000: 0x40,
		            0x1f0000: 0x1000,
		            0x108000: 0x80400000,
		            0x118000: 0x80401040,
		            0x128000: 0x0,
		            0x138000: 0x401000,
		            0x148000: 0x400040,
		            0x158000: 0x80000000,
		            0x168000: 0x80001040,
		            0x178000: 0x40,
		            0x188000: 0x80000040,
		            0x198000: 0x1000,
		            0x1a8000: 0x80001000,
		            0x1b8000: 0x80400040,
		            0x1c8000: 0x1040,
		            0x1d8000: 0x80401000,
		            0x1e8000: 0x400000,
		            0x1f8000: 0x401040
		        },
		        {
		            0x0: 0x80,
		            0x1000: 0x1040000,
		            0x2000: 0x40000,
		            0x3000: 0x20000000,
		            0x4000: 0x20040080,
		            0x5000: 0x1000080,
		            0x6000: 0x21000080,
		            0x7000: 0x40080,
		            0x8000: 0x1000000,
		            0x9000: 0x20040000,
		            0xa000: 0x20000080,
		            0xb000: 0x21040080,
		            0xc000: 0x21040000,
		            0xd000: 0x0,
		            0xe000: 0x1040080,
		            0xf000: 0x21000000,
		            0x800: 0x1040080,
		            0x1800: 0x21000080,
		            0x2800: 0x80,
		            0x3800: 0x1040000,
		            0x4800: 0x40000,
		            0x5800: 0x20040080,
		            0x6800: 0x21040000,
		            0x7800: 0x20000000,
		            0x8800: 0x20040000,
		            0x9800: 0x0,
		            0xa800: 0x21040080,
		            0xb800: 0x1000080,
		            0xc800: 0x20000080,
		            0xd800: 0x21000000,
		            0xe800: 0x1000000,
		            0xf800: 0x40080,
		            0x10000: 0x40000,
		            0x11000: 0x80,
		            0x12000: 0x20000000,
		            0x13000: 0x21000080,
		            0x14000: 0x1000080,
		            0x15000: 0x21040000,
		            0x16000: 0x20040080,
		            0x17000: 0x1000000,
		            0x18000: 0x21040080,
		            0x19000: 0x21000000,
		            0x1a000: 0x1040000,
		            0x1b000: 0x20040000,
		            0x1c000: 0x40080,
		            0x1d000: 0x20000080,
		            0x1e000: 0x0,
		            0x1f000: 0x1040080,
		            0x10800: 0x21000080,
		            0x11800: 0x1000000,
		            0x12800: 0x1040000,
		            0x13800: 0x20040080,
		            0x14800: 0x20000000,
		            0x15800: 0x1040080,
		            0x16800: 0x80,
		            0x17800: 0x21040000,
		            0x18800: 0x40080,
		            0x19800: 0x21040080,
		            0x1a800: 0x0,
		            0x1b800: 0x21000000,
		            0x1c800: 0x1000080,
		            0x1d800: 0x40000,
		            0x1e800: 0x20040000,
		            0x1f800: 0x20000080
		        },
		        {
		            0x0: 0x10000008,
		            0x100: 0x2000,
		            0x200: 0x10200000,
		            0x300: 0x10202008,
		            0x400: 0x10002000,
		            0x500: 0x200000,
		            0x600: 0x200008,
		            0x700: 0x10000000,
		            0x800: 0x0,
		            0x900: 0x10002008,
		            0xa00: 0x202000,
		            0xb00: 0x8,
		            0xc00: 0x10200008,
		            0xd00: 0x202008,
		            0xe00: 0x2008,
		            0xf00: 0x10202000,
		            0x80: 0x10200000,
		            0x180: 0x10202008,
		            0x280: 0x8,
		            0x380: 0x200000,
		            0x480: 0x202008,
		            0x580: 0x10000008,
		            0x680: 0x10002000,
		            0x780: 0x2008,
		            0x880: 0x200008,
		            0x980: 0x2000,
		            0xa80: 0x10002008,
		            0xb80: 0x10200008,
		            0xc80: 0x0,
		            0xd80: 0x10202000,
		            0xe80: 0x202000,
		            0xf80: 0x10000000,
		            0x1000: 0x10002000,
		            0x1100: 0x10200008,
		            0x1200: 0x10202008,
		            0x1300: 0x2008,
		            0x1400: 0x200000,
		            0x1500: 0x10000000,
		            0x1600: 0x10000008,
		            0x1700: 0x202000,
		            0x1800: 0x202008,
		            0x1900: 0x0,
		            0x1a00: 0x8,
		            0x1b00: 0x10200000,
		            0x1c00: 0x2000,
		            0x1d00: 0x10002008,
		            0x1e00: 0x10202000,
		            0x1f00: 0x200008,
		            0x1080: 0x8,
		            0x1180: 0x202000,
		            0x1280: 0x200000,
		            0x1380: 0x10000008,
		            0x1480: 0x10002000,
		            0x1580: 0x2008,
		            0x1680: 0x10202008,
		            0x1780: 0x10200000,
		            0x1880: 0x10202000,
		            0x1980: 0x10200008,
		            0x1a80: 0x2000,
		            0x1b80: 0x202008,
		            0x1c80: 0x200008,
		            0x1d80: 0x0,
		            0x1e80: 0x10000000,
		            0x1f80: 0x10002008
		        },
		        {
		            0x0: 0x100000,
		            0x10: 0x2000401,
		            0x20: 0x400,
		            0x30: 0x100401,
		            0x40: 0x2100401,
		            0x50: 0x0,
		            0x60: 0x1,
		            0x70: 0x2100001,
		            0x80: 0x2000400,
		            0x90: 0x100001,
		            0xa0: 0x2000001,
		            0xb0: 0x2100400,
		            0xc0: 0x2100000,
		            0xd0: 0x401,
		            0xe0: 0x100400,
		            0xf0: 0x2000000,
		            0x8: 0x2100001,
		            0x18: 0x0,
		            0x28: 0x2000401,
		            0x38: 0x2100400,
		            0x48: 0x100000,
		            0x58: 0x2000001,
		            0x68: 0x2000000,
		            0x78: 0x401,
		            0x88: 0x100401,
		            0x98: 0x2000400,
		            0xa8: 0x2100000,
		            0xb8: 0x100001,
		            0xc8: 0x400,
		            0xd8: 0x2100401,
		            0xe8: 0x1,
		            0xf8: 0x100400,
		            0x100: 0x2000000,
		            0x110: 0x100000,
		            0x120: 0x2000401,
		            0x130: 0x2100001,
		            0x140: 0x100001,
		            0x150: 0x2000400,
		            0x160: 0x2100400,
		            0x170: 0x100401,
		            0x180: 0x401,
		            0x190: 0x2100401,
		            0x1a0: 0x100400,
		            0x1b0: 0x1,
		            0x1c0: 0x0,
		            0x1d0: 0x2100000,
		            0x1e0: 0x2000001,
		            0x1f0: 0x400,
		            0x108: 0x100400,
		            0x118: 0x2000401,
		            0x128: 0x2100001,
		            0x138: 0x1,
		            0x148: 0x2000000,
		            0x158: 0x100000,
		            0x168: 0x401,
		            0x178: 0x2100400,
		            0x188: 0x2000001,
		            0x198: 0x2100000,
		            0x1a8: 0x0,
		            0x1b8: 0x2100401,
		            0x1c8: 0x100401,
		            0x1d8: 0x400,
		            0x1e8: 0x2000400,
		            0x1f8: 0x100001
		        },
		        {
		            0x0: 0x8000820,
		            0x1: 0x20000,
		            0x2: 0x8000000,
		            0x3: 0x20,
		            0x4: 0x20020,
		            0x5: 0x8020820,
		            0x6: 0x8020800,
		            0x7: 0x800,
		            0x8: 0x8020000,
		            0x9: 0x8000800,
		            0xa: 0x20800,
		            0xb: 0x8020020,
		            0xc: 0x820,
		            0xd: 0x0,
		            0xe: 0x8000020,
		            0xf: 0x20820,
		            0x80000000: 0x800,
		            0x80000001: 0x8020820,
		            0x80000002: 0x8000820,
		            0x80000003: 0x8000000,
		            0x80000004: 0x8020000,
		            0x80000005: 0x20800,
		            0x80000006: 0x20820,
		            0x80000007: 0x20,
		            0x80000008: 0x8000020,
		            0x80000009: 0x820,
		            0x8000000a: 0x20020,
		            0x8000000b: 0x8020800,
		            0x8000000c: 0x0,
		            0x8000000d: 0x8020020,
		            0x8000000e: 0x8000800,
		            0x8000000f: 0x20000,
		            0x10: 0x20820,
		            0x11: 0x8020800,
		            0x12: 0x20,
		            0x13: 0x800,
		            0x14: 0x8000800,
		            0x15: 0x8000020,
		            0x16: 0x8020020,
		            0x17: 0x20000,
		            0x18: 0x0,
		            0x19: 0x20020,
		            0x1a: 0x8020000,
		            0x1b: 0x8000820,
		            0x1c: 0x8020820,
		            0x1d: 0x20800,
		            0x1e: 0x820,
		            0x1f: 0x8000000,
		            0x80000010: 0x20000,
		            0x80000011: 0x800,
		            0x80000012: 0x8020020,
		            0x80000013: 0x20820,
		            0x80000014: 0x20,
		            0x80000015: 0x8020000,
		            0x80000016: 0x8000000,
		            0x80000017: 0x8000820,
		            0x80000018: 0x8020820,
		            0x80000019: 0x8000020,
		            0x8000001a: 0x8000800,
		            0x8000001b: 0x0,
		            0x8000001c: 0x20800,
		            0x8000001d: 0x820,
		            0x8000001e: 0x20020,
		            0x8000001f: 0x8020800
		        }
		    ];
	
		    // Masks that select the SBOX input
		    var SBOX_MASK = [
		        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
		        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
		    ];
	
		    /**
		     * DES block cipher algorithm.
		     */
		    var DES = C_algo.DES = BlockCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var key = this._key;
		            var keyWords = key.words;
	
		            // Select 56 bits according to PC1
		            var keyBits = [];
		            for (var i = 0; i < 56; i++) {
		                var keyBitPos = PC1[i] - 1;
		                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
		            }
	
		            // Assemble 16 subkeys
		            var subKeys = this._subKeys = [];
		            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
		                // Create subkey
		                var subKey = subKeys[nSubKey] = [];
	
		                // Shortcut
		                var bitShift = BIT_SHIFTS[nSubKey];
	
		                // Select 48 bits according to PC2
		                for (var i = 0; i < 24; i++) {
		                    // Select from the left 28 key bits
		                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);
	
		                    // Select from the right 28 key bits
		                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
		                }
	
		                // Since each subkey is applied to an expanded 32-bit input,
		                // the subkey can be broken into 8 values scaled to 32-bits,
		                // which allows the key to be used without expansion
		                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
		                for (var i = 1; i < 7; i++) {
		                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
		                }
		                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
		            }
	
		            // Compute inverse subkeys
		            var invSubKeys = this._invSubKeys = [];
		            for (var i = 0; i < 16; i++) {
		                invSubKeys[i] = subKeys[15 - i];
		            }
		        },
	
		        encryptBlock: function (M, offset) {
		            this._doCryptBlock(M, offset, this._subKeys);
		        },
	
		        decryptBlock: function (M, offset) {
		            this._doCryptBlock(M, offset, this._invSubKeys);
		        },
	
		        _doCryptBlock: function (M, offset, subKeys) {
		            // Get input
		            this._lBlock = M[offset];
		            this._rBlock = M[offset + 1];
	
		            // Initial permutation
		            exchangeLR.call(this, 4,  0x0f0f0f0f);
		            exchangeLR.call(this, 16, 0x0000ffff);
		            exchangeRL.call(this, 2,  0x33333333);
		            exchangeRL.call(this, 8,  0x00ff00ff);
		            exchangeLR.call(this, 1,  0x55555555);
	
		            // Rounds
		            for (var round = 0; round < 16; round++) {
		                // Shortcuts
		                var subKey = subKeys[round];
		                var lBlock = this._lBlock;
		                var rBlock = this._rBlock;
	
		                // Feistel function
		                var f = 0;
		                for (var i = 0; i < 8; i++) {
		                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
		                }
		                this._lBlock = rBlock;
		                this._rBlock = lBlock ^ f;
		            }
	
		            // Undo swap from last round
		            var t = this._lBlock;
		            this._lBlock = this._rBlock;
		            this._rBlock = t;
	
		            // Final permutation
		            exchangeLR.call(this, 1,  0x55555555);
		            exchangeRL.call(this, 8,  0x00ff00ff);
		            exchangeRL.call(this, 2,  0x33333333);
		            exchangeLR.call(this, 16, 0x0000ffff);
		            exchangeLR.call(this, 4,  0x0f0f0f0f);
	
		            // Set output
		            M[offset] = this._lBlock;
		            M[offset + 1] = this._rBlock;
		        },
	
		        keySize: 64/32,
	
		        ivSize: 64/32,
	
		        blockSize: 64/32
		    });
	
		    // Swap bits across the left and right words
		    function exchangeLR(offset, mask) {
		        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
		        this._rBlock ^= t;
		        this._lBlock ^= t << offset;
		    }
	
		    function exchangeRL(offset, mask) {
		        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
		        this._lBlock ^= t;
		        this._rBlock ^= t << offset;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
		     */
		    C.DES = BlockCipher._createHelper(DES);
	
		    /**
		     * Triple-DES block cipher algorithm.
		     */
		    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var key = this._key;
		            var keyWords = key.words;
		            // Make sure the key length is valid (64, 128 or >= 192 bit)
		            if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) {
		                throw new Error('Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.');
		            }
	
		            // Extend the key according to the keying options defined in 3DES standard
		            var key1 = keyWords.slice(0, 2);
		            var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
		            var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);
	
		            // Create DES instances
		            this._des1 = DES.createEncryptor(WordArray.create(key1));
		            this._des2 = DES.createEncryptor(WordArray.create(key2));
		            this._des3 = DES.createEncryptor(WordArray.create(key3));
		        },
	
		        encryptBlock: function (M, offset) {
		            this._des1.encryptBlock(M, offset);
		            this._des2.decryptBlock(M, offset);
		            this._des3.encryptBlock(M, offset);
		        },
	
		        decryptBlock: function (M, offset) {
		            this._des3.decryptBlock(M, offset);
		            this._des2.encryptBlock(M, offset);
		            this._des1.decryptBlock(M, offset);
		        },
	
		        keySize: 192/32,
	
		        ivSize: 64/32,
	
		        blockSize: 64/32
		    });
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
		     */
		    C.TripleDES = BlockCipher._createHelper(TripleDES);
		}());
	
	
		return CryptoJS.TripleDES;
	
	}));

/***/ },
/* 6710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var isInBrowser = _interopDefault(__webpack_require__(449));
	var _toConsumableArray = _interopDefault(__webpack_require__(46));
	
	// Export javascript style and css style vendor prefixes.
	var js = '';
	var css = '';
	var vendor = '';
	var browser = '';
	var isTouch = isInBrowser && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
	
	if (isInBrowser) {
	  // Order matters. We need to check Webkit the last one because
	  // other vendors use to add Webkit prefixes to some properties
	  var jsCssMap = {
	    Moz: '-moz-',
	    ms: '-ms-',
	    O: '-o-',
	    Webkit: '-webkit-'
	  };
	
	  var _document$createEleme = document.createElement('p'),
	      style = _document$createEleme.style;
	
	  var testProp = 'Transform';
	
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      js = key;
	      css = jsCssMap[key];
	      break;
	    }
	  } // Correctly detect the Edge browser.
	
	
	  if (js === 'Webkit' && 'msHyphens' in style) {
	    js = 'ms';
	    css = jsCssMap.ms;
	    browser = 'edge';
	  } // Correctly detect the Safari browser.
	
	
	  if (js === 'Webkit' && '-apple-trailing-word' in style) {
	    vendor = 'apple';
	  }
	}
	/**
	 * Vendor prefix string for the current browser.
	 *
	 * @type {{js: String, css: String, vendor: String, browser: String}}
	 * @api public
	 */
	
	
	var prefix = {
	  js: js,
	  css: css,
	  vendor: vendor,
	  browser: browser,
	  isTouch: isTouch
	};
	
	/**
	 * Test if a keyframe at-rule should be prefixed or not
	 *
	 * @param {String} vendor prefix string for the current browser.
	 * @return {String}
	 * @api public
	 */
	
	function supportedKeyframes(key) {
	  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
	  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
	  // https://caniuse.com/#search=keyframes
	
	  if (prefix.js === 'ms') return key;
	  return "@" + prefix.css + "keyframes" + key.substr(10);
	}
	
	// https://caniuse.com/#search=appearance
	
	var appearence = {
	  noPrefill: ['appearance'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'appearance') return false;
	    if (prefix.js === 'ms') return "-webkit-" + prop;
	    return prefix.css + prop;
	  }
	};
	
	// https://caniuse.com/#search=color-adjust
	
	var colorAdjust = {
	  noPrefill: ['color-adjust'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'color-adjust') return false;
	    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
	    return prop;
	  }
	};
	
	var regExp = /[-\s]+(.)?/g;
	/**
	 * Replaces the letter with the capital letter
	 *
	 * @param {String} match
	 * @param {String} c
	 * @return {String}
	 * @api private
	 */
	
	function toUpper(match, c) {
	  return c ? c.toUpperCase() : '';
	}
	/**
	 * Convert dash separated strings to camel-cased.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	
	function camelize(str) {
	  return str.replace(regExp, toUpper);
	}
	
	/**
	 * Convert dash separated strings to pascal cased.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function pascalize(str) {
	  return camelize("-" + str);
	}
	
	// but we can use a longhand property instead.
	// https://caniuse.com/#search=mask
	
	var mask = {
	  noPrefill: ['mask'],
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^mask/.test(prop)) return false;
	
	    if (prefix.js === 'Webkit') {
	      var longhand = 'mask-image';
	
	      if (camelize(longhand) in style) {
	        return prop;
	      }
	
	      if (prefix.js + pascalize(longhand) in style) {
	        return prefix.css + prop;
	      }
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=text-orientation
	
	var textOrientation = {
	  noPrefill: ['text-orientation'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'text-orientation') return false;
	
	    if (prefix.vendor === 'apple' && !prefix.isTouch) {
	      return prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=transform
	
	var transform = {
	  noPrefill: ['transform'],
	  supportedProperty: function supportedProperty(prop, style, options) {
	    if (prop !== 'transform') return false;
	
	    if (options.transform) {
	      return prop;
	    }
	
	    return prefix.css + prop;
	  }
	};
	
	// https://caniuse.com/#search=transition
	
	var transition = {
	  noPrefill: ['transition'],
	  supportedProperty: function supportedProperty(prop, style, options) {
	    if (prop !== 'transition') return false;
	
	    if (options.transition) {
	      return prop;
	    }
	
	    return prefix.css + prop;
	  }
	};
	
	// https://caniuse.com/#search=writing-mode
	
	var writingMode = {
	  noPrefill: ['writing-mode'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'writing-mode') return false;
	
	    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
	      return prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=user-select
	
	var userSelect = {
	  noPrefill: ['user-select'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'user-select') return false;
	
	    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
	      return prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=multicolumn
	// https://github.com/postcss/autoprefixer/issues/491
	// https://github.com/postcss/autoprefixer/issues/177
	
	var breakPropsOld = {
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^break-/.test(prop)) return false;
	
	    if (prefix.js === 'Webkit') {
	      var jsProp = "WebkitColumn" + pascalize(prop);
	      return jsProp in style ? prefix.css + "column-" + prop : false;
	    }
	
	    if (prefix.js === 'Moz') {
	      var _jsProp = "page" + pascalize(prop);
	
	      return _jsProp in style ? "page-" + prop : false;
	    }
	
	    return false;
	  }
	};
	
	// See https://github.com/postcss/autoprefixer/issues/324.
	
	var inlineLogicalOld = {
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
	    if (prefix.js === 'Moz') return prop;
	    var newProp = prop.replace('-inline', '');
	    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	  }
	};
	
	// Camelization is required because we can't test using.
	// CSS syntax for e.g. in FF.
	
	var unprefixed = {
	  supportedProperty: function supportedProperty(prop, style) {
	    return camelize(prop) in style ? prop : false;
	  }
	};
	
	var prefixed = {
	  supportedProperty: function supportedProperty(prop, style) {
	    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.
	
	    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
	
	    if (prop[0] === '-' && prop[1] === '-') return prop;
	    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.
	
	    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
	    return false;
	  }
	};
	
	// https://caniuse.com/#search=scroll-snap
	
	var scrollSnap = {
	  supportedProperty: function supportedProperty(prop) {
	    if (prop.substring(0, 11) !== 'scroll-snap') return false;
	
	    if (prefix.js === 'ms') {
	      return "" + prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=overscroll-behavior
	
	var overscrollBehavior = {
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'overscroll-behavior') return false;
	
	    if (prefix.js === 'ms') {
	      return prefix.css + "scroll-chaining";
	    }
	
	    return prop;
	  }
	};
	
	var propMap = {
	  'flex-grow': 'flex-positive',
	  'flex-shrink': 'flex-negative',
	  'flex-basis': 'flex-preferred-size',
	  'justify-content': 'flex-pack',
	  order: 'flex-order',
	  'align-items': 'flex-align',
	  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
	
	}; // Support old flex spec from 2012.
	
	var flex2012 = {
	  supportedProperty: function supportedProperty(prop, style) {
	    var newProp = propMap[prop];
	    if (!newProp) return false;
	    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	  }
	};
	
	var propMap$1 = {
	  flex: 'box-flex',
	  'flex-grow': 'box-flex',
	  'flex-direction': ['box-orient', 'box-direction'],
	  order: 'box-ordinal-group',
	  'align-items': 'box-align',
	  'flex-flow': ['box-orient', 'box-direction'],
	  'justify-content': 'box-pack'
	};
	var propKeys = Object.keys(propMap$1);
	
	var prefixCss = function prefixCss(p) {
	  return prefix.css + p;
	}; // Support old flex spec from 2009.
	
	
	var flex2009 = {
	  supportedProperty: function supportedProperty(prop, style, _ref) {
	    var multiple = _ref.multiple;
	
	    if (propKeys.indexOf(prop) > -1) {
	      var newProp = propMap$1[prop];
	
	      if (!Array.isArray(newProp)) {
	        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	      }
	
	      if (!multiple) return false;
	
	      for (var i = 0; i < newProp.length; i++) {
	        if (!(prefix.js + pascalize(newProp[0]) in style)) {
	          return false;
	        }
	      }
	
	      return newProp.map(prefixCss);
	    }
	
	    return false;
	  }
	};
	
	// plugins = [
	//   ...plugins,
	//    breakPropsOld,
	//    inlineLogicalOld,
	//    unprefixed,
	//    prefixed,
	//    scrollSnap,
	//    flex2012,
	//    flex2009
	// ]
	// Plugins without 'noPrefill' value, going last.
	// 'flex-*' plugins should be at the bottom.
	// 'flex2009' going after 'flex2012'.
	// 'prefixed' going after 'unprefixed'
	
	var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
	var propertyDetectors = plugins.filter(function (p) {
	  return p.supportedProperty;
	}).map(function (p) {
	  return p.supportedProperty;
	});
	var noPrefill = plugins.filter(function (p) {
	  return p.noPrefill;
	}).reduce(function (a, p) {
	  a.push.apply(a, _toConsumableArray(p.noPrefill));
	  return a;
	}, []);
	
	var el;
	var cache = {};
	
	if (isInBrowser) {
	  el = document.createElement('p'); // We test every property on vendor prefix requirement.
	  // Once tested, result is cached. It gives us up to 70% perf boost.
	  // http://jsperf.com/element-style-object-access-vs-plain-object
	  //
	  // Prefill cache with known css properties to reduce amount of
	  // properties we need to feature test at runtime.
	  // http://davidwalsh.name/vendor-prefix
	
	  var computed = window.getComputedStyle(document.documentElement, '');
	
	  for (var key$1 in computed) {
	    // eslint-disable-next-line no-restricted-globals
	    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
	  } // Properties that cannot be correctly detected using the
	  // cache prefill method.
	
	
	  noPrefill.forEach(function (x) {
	    return delete cache[x];
	  });
	}
	/**
	 * Test if a property is supported, returns supported property with vendor
	 * prefix if required. Returns `false` if not supported.
	 *
	 * @param {String} prop dash separated
	 * @param {Object} [options]
	 * @return {String|Boolean}
	 * @api public
	 */
	
	
	function supportedProperty(prop, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  // For server-side rendering.
	  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.
	
	  if (("production") !== 'benchmark' && cache[prop] != null) {
	    return cache[prop];
	  } // Check if 'transition' or 'transform' natively supported in browser.
	
	
	  if (prop === 'transition' || prop === 'transform') {
	    options[prop] = prop in el.style;
	  } // Find a plugin for current prefix property.
	
	
	  for (var i = 0; i < propertyDetectors.length; i++) {
	    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.
	
	    if (cache[prop]) break;
	  } // Reset styles for current property.
	  // Firefox can even throw an error for invalid properties, e.g., "0".
	
	
	  try {
	    el.style[prop] = '';
	  } catch (err) {
	    return false;
	  }
	
	  return cache[prop];
	}
	
	var cache$1 = {};
	var transitionProperties = {
	  transition: 1,
	  'transition-property': 1,
	  '-webkit-transition': 1,
	  '-webkit-transition-property': 1
	};
	var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
	var el$1;
	/**
	 * Returns prefixed value transition/transform if needed.
	 *
	 * @param {String} match
	 * @param {String} p1
	 * @param {String} p2
	 * @return {String}
	 * @api private
	 */
	
	function prefixTransitionCallback(match, p1, p2) {
	  if (p1 === 'var') return 'var';
	  if (p1 === 'all') return 'all';
	  if (p2 === 'all') return ', all';
	  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
	  if (!prefixedValue) return p1 || p2;
	  return prefixedValue;
	}
	
	if (isInBrowser) el$1 = document.createElement('p');
	/**
	 * Returns prefixed value if needed. Returns `false` if value is not supported.
	 *
	 * @param {String} property
	 * @param {String} value
	 * @return {String|Boolean}
	 * @api public
	 */
	
	function supportedValue(property, value) {
	  // For server-side rendering.
	  var prefixedValue = value;
	  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
	  // We want only prefixable values here.
	  // eslint-disable-next-line no-restricted-globals
	
	  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
	    return prefixedValue;
	  } // Create cache key for current value.
	
	
	  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
	
	  if (("production") !== 'benchmark' && cache$1[cacheKey] != null) {
	    return cache$1[cacheKey];
	  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
	
	
	  try {
	    // Test value as it is.
	    el$1.style[property] = prefixedValue;
	  } catch (err) {
	    // Return false if value not supported.
	    cache$1[cacheKey] = false;
	    return false;
	  } // If 'transition' or 'transition-property' property.
	
	
	  if (transitionProperties[property]) {
	    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
	  } else if (el$1.style[property] === '') {
	    // Value with a vendor prefix.
	    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
	
	    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
	
	    el$1.style[property] = prefixedValue; // Return false if value not supported.
	
	    if (el$1.style[property] === '') {
	      cache$1[cacheKey] = false;
	      return false;
	    }
	  } // Reset styles for current property.
	
	
	  el$1.style[property] = ''; // Write current value to cache.
	
	  cache$1[cacheKey] = prefixedValue;
	  return cache$1[cacheKey];
	}
	
	exports.prefix = prefix;
	exports.supportedKeyframes = supportedKeyframes;
	exports.supportedProperty = supportedProperty;
	exports.supportedValue = supportedValue;


/***/ },
/* 6711 */
/***/ function(module, exports, __webpack_require__) {

	var objectKeys = __webpack_require__(644);
	var isArguments = __webpack_require__(6742);
	var is = __webpack_require__(6965);
	var isRegex = __webpack_require__(6744);
	var flags = __webpack_require__(7211);
	var isDate = __webpack_require__(6743);
	
	var getTime = Date.prototype.getTime;
	
	function deepEqual(actual, expected, options) {
	  var opts = options || {};
	
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (opts.strict ? is(actual, expected) : actual === expected) {
	    return true;
	  }
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
	  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
	    return opts.strict ? is(actual, expected) : actual == expected;
	  }
	
	  /*
	   * 7.4. For all other Object pairs, including Array objects, equivalence is
	   * determined by having the same number of owned properties (as verified
	   * with Object.prototype.hasOwnProperty.call), the same set of keys
	   * (although not necessarily the same order), equivalent values for every
	   * corresponding key, and an identical 'prototype' property. Note: this
	   * accounts for both named and indexed properties on Arrays.
	   */
	  // eslint-disable-next-line no-use-before-define
	  return objEquiv(actual, expected, opts);
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer(x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
	    return false;
	  }
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') {
	    return false;
	  }
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  /* eslint max-statements: [2, 50] */
	  var i, key;
	  if (typeof a !== typeof b) { return false; }
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }
	
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) { return false; }
	
	  if (isArguments(a) !== isArguments(b)) { return false; }
	
	  var aIsRegex = isRegex(a);
	  var bIsRegex = isRegex(b);
	  if (aIsRegex !== bIsRegex) { return false; }
	  if (aIsRegex || bIsRegex) {
	    return a.source === b.source && flags(a) === flags(b);
	  }
	
	  if (isDate(a) && isDate(b)) {
	    return getTime.call(a) === getTime.call(b);
	  }
	
	  var aIsBuffer = isBuffer(a);
	  var bIsBuffer = isBuffer(b);
	  if (aIsBuffer !== bIsBuffer) { return false; }
	  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
	    if (a.length !== b.length) { return false; }
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) { return false; }
	    }
	    return true;
	  }
	
	  if (typeof a !== typeof b) { return false; }
	
	  try {
	    var ka = objectKeys(a);
	    var kb = objectKeys(b);
	  } catch (e) { // happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates hasOwnProperty)
	  if (ka.length !== kb.length) { return false; }
	
	  // the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  // ~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i]) { return false; }
	  }
	  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) { return false; }
	  }
	
	  return true;
	}
	
	module.exports = deepEqual;


/***/ },
/* 6712 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = activeElement;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(135));
	
	/**
	 * Returns the actively focused element safely.
	 *
	 * @param doc the document to check
	 */
	function activeElement(doc) {
	  if (doc === void 0) {
	    doc = (0, _ownerDocument.default)();
	  }
	
	  // Support: IE 9 only
	  // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
	  try {
	    var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
	    // document.activeElement from an <iframe>
	
	    if (!active || !active.nodeName) return null;
	    return active;
	  } catch (e) {
	    /* ie throws if no active element */
	    return doc.body;
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 6713 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	
	module.exports = exports["default"];

/***/ },
/* 6714 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = contains;
	
	/* eslint-disable no-bitwise, no-cond-assign */
	
	/**
	 * Checks if an element contains another given element.
	 * 
	 * @param context the context element
	 * @param node the element to check
	 */
	function contains(context, node) {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  if (context.contains) return context.contains(node);
	  if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
	}
	
	module.exports = exports["default"];

/***/ },
/* 6715 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = getComputedStyle;
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(6722));
	
	/**
	 * Returns one or all computed style properties of an element.
	 * 
	 * @param node the element
	 * @param psuedoElement the style property
	 */
	function getComputedStyle(node, psuedoElement) {
	  return (0, _ownerWindow.default)(node).getComputedStyle(node, psuedoElement);
	}
	
	module.exports = exports["default"];

/***/ },
/* 6716 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	/**
	 * Checks if a given element has a CSS class.
	 * 
	 * @param element the element
	 * @param className the CSS class name
	 */
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);
	  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 6717 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hyphenate;
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	
	module.exports = exports["default"];

/***/ },
/* 6718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = hyphenateStyleName;
	
	var _hyphenate = _interopRequireDefault(__webpack_require__(6717));
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
	}
	
	module.exports = exports["default"];

/***/ },
/* 6719 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isDocument;
	
	function isDocument(element) {
	  return 'nodeType' in element && element.nodeType === document.DOCUMENT_NODE;
	}
	
	module.exports = exports["default"];

/***/ },
/* 6720 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(value) {
	  return !!(value && supportedTransforms.test(value));
	}
	
	module.exports = exports["default"];

/***/ },
/* 6721 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = isWindow;
	
	var _isDocument = _interopRequireDefault(__webpack_require__(6719));
	
	function isWindow(node) {
	  if ('window' in node && node.window === node) return node;
	  if ((0, _isDocument.default)(node)) return node.defaultView || false;
	  return false;
	}
	
	module.exports = exports["default"];

/***/ },
/* 6722 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = ownerWindow;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(135));
	
	/**
	 * Returns the owner window of a given element.
	 * 
	 * @param node the element
	 */
	function ownerWindow(node) {
	  var doc = (0, _ownerDocument.default)(node);
	  return doc && doc.defaultView || window;
	}
	
	module.exports = exports["default"];

/***/ },
/* 6723 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = qsa;
	var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	/**
	 * Runs `querySelectorAll` on a given element.
	 * 
	 * @param element the element
	 * @param selector the selector
	 */
	
	function qsa(element, selector) {
	  return toArray(element.querySelectorAll(selector));
	}
	
	module.exports = exports["default"];

/***/ },
/* 6724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = transitionEnd;
	
	var _css = _interopRequireDefault(__webpack_require__(257));
	
	var _listen = _interopRequireDefault(__webpack_require__(436));
	
	var _triggerEvent = _interopRequireDefault(__webpack_require__(6725));
	
	function parseDuration(node) {
	  var str = (0, _css.default)(node, 'transitionDuration') || '';
	  var mult = str.indexOf('ms') === -1 ? 1000 : 1;
	  return parseFloat(str) * mult;
	}
	
	function emulateTransitionEnd(element, duration, padding) {
	  if (padding === void 0) {
	    padding = 5;
	  }
	
	  var called = false;
	  var handle = setTimeout(function () {
	    if (!called) (0, _triggerEvent.default)(element, 'transitionend', true);
	  }, duration + padding);
	  var remove = (0, _listen.default)(element, 'transitionend', function () {
	    called = true;
	  }, {
	    once: true
	  });
	  return function () {
	    clearTimeout(handle);
	    remove();
	  };
	}
	
	function transitionEnd(element, handler, duration, padding) {
	  if (duration == null) duration = parseDuration(element) || 0;
	  var removeEmulate = emulateTransitionEnd(element, duration, padding);
	  var remove = (0, _listen.default)(element, 'transitionend', handler);
	  return function () {
	    removeEmulate();
	    remove();
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 6725 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = triggerEvent;
	
	/**
	 * Triggers an event on a given element.
	 * 
	 * @param node the element
	 * @param eventName the event name to trigger
	 * @param bubbles whether the event should bubble up
	 * @param cancelable whether the event should be cancelable
	 */
	function triggerEvent(node, eventName, bubbles, cancelable) {
	  if (bubbles === void 0) {
	    bubbles = false;
	  }
	
	  if (cancelable === void 0) {
	    cancelable = true;
	  }
	
	  if (node) {
	    var event = document.createEvent('HTMLEvents');
	    event.initEvent(eventName, bubbles, cancelable);
	    node.dispatchEvent(event);
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 6726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBind = __webpack_require__(252);
	var gOPD = __webpack_require__(115);
	
	var hasProtoAccessor;
	try {
		// eslint-disable-next-line no-extra-parens, no-proto
		hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
	} catch (e) {
		if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
			throw e;
		}
	}
	
	// eslint-disable-next-line no-extra-parens
	var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));
	
	var $Object = Object;
	var $getPrototypeOf = $Object.getPrototypeOf;
	
	/** @type {import('./get')} */
	module.exports = desc && typeof desc.get === 'function'
		? callBind([desc.get])
		: typeof $getPrototypeOf === 'function'
			? /** @type {import('./get')} */ function getDunder(value) {
				// eslint-disable-next-line eqeqeq
				return $getPrototypeOf(value == null ? value : $Object(value));
			}
			: false;


/***/ },
/* 6727 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./eval')} */
	module.exports = EvalError;


/***/ },
/* 6728 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./range')} */
	module.exports = RangeError;


/***/ },
/* 6729 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./ref')} */
	module.exports = ReferenceError;


/***/ },
/* 6730 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./uri')} */
	module.exports = URIError;


/***/ },
/* 6731 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 6732 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var toStr = Object.prototype.toString;
	var max = Math.max;
	var funcType = '[object Function]';
	
	var concatty = function concatty(a, b) {
	    var arr = [];
	
	    for (var i = 0; i < a.length; i += 1) {
	        arr[i] = a[i];
	    }
	    for (var j = 0; j < b.length; j += 1) {
	        arr[j + a.length] = b[j];
	    }
	
	    return arr;
	};
	
	var slicy = function slicy(arrLike, offset) {
	    var arr = [];
	    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
	        arr[j] = arrLike[i];
	    }
	    return arr;
	};
	
	var joiny = function (arr, joiner) {
	    var str = '';
	    for (var i = 0; i < arr.length; i += 1) {
	        str += arr[i];
	        if (i + 1 < arr.length) {
	            str += joiner;
	        }
	    }
	    return str;
	};
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slicy(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                concatty(args, arguments)
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        }
	        return target.apply(
	            that,
	            concatty(args, arguments)
	        );
	
	    };
	
	    var boundLength = max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs[i] = '$' + i;
	    }
	
	    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 6733 */
/***/ function(module, exports) {

	'use strict';
	
	var functionsHaveNames = function functionsHaveNames() {
		return typeof function f() {}.name === 'string';
	};
	
	var gOPD = Object.getOwnPropertyDescriptor;
	if (gOPD) {
		try {
			gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			gOPD = null;
		}
	}
	
	functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
		if (!functionsHaveNames() || !gOPD) {
			return false;
		}
		var desc = gOPD(function () {}, 'name');
		return !!desc && !!desc.configurable;
	};
	
	var $bind = Function.prototype.bind;
	
	functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
		return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
	};
	
	module.exports = functionsHaveNames;


/***/ },
/* 6734 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./gOPD')} */
	module.exports = Object.getOwnPropertyDescriptor;


/***/ },
/* 6735 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 6736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var origSymbol = typeof Symbol !== 'undefined' && Symbol;
	var hasSymbolSham = __webpack_require__(446);
	
	/** @type {import('.')} */
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};


/***/ },
/* 6737 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(7214)),valueEqual=_interopDefault(__webpack_require__(7338));__webpack_require__(108);var invariant=_interopDefault(__webpack_require__(338));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ },
/* 6738 */
1027,
/* 6739 */
[7344, 6738],
/* 6740 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable no-var, prefer-template */
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function toHyphenLower(match) {
	  return '-' + match.toLowerCase()
	}
	
	function hyphenateStyleName(name) {
	  if (cache.hasOwnProperty(name)) {
	    return cache[name]
	  }
	
	  var hName = name.replace(uppercasePattern, toHyphenLower);
	  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
	}
	
	module.exports = hyphenateStyleName;


/***/ },
/* 6741 */
/***/ function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 6742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasToStringTag = __webpack_require__(261)();
	var callBound = __webpack_require__(253);
	
	var $toString = callBound('Object.prototype.toString');
	
	/** @type {import('.')} */
	var isStandardArguments = function isArguments(value) {
		if (
			hasToStringTag
			&& value
			&& typeof value === 'object'
			&& Symbol.toStringTag in value
		) {
			return false;
		}
		return $toString(value) === '[object Arguments]';
	};
	
	/** @type {import('.')} */
	var isLegacyArguments = function isArguments(value) {
		if (isStandardArguments(value)) {
			return true;
		}
		return value !== null
			&& typeof value === 'object'
			&& 'length' in value
			&& typeof value.length === 'number'
			&& value.length >= 0
			&& $toString(value) !== '[object Array]'
			&& 'callee' in value
			&& $toString(value.callee) === '[object Function]';
	};
	
	var supportsStandardArguments = (function () {
		return isStandardArguments(arguments);
	}());
	
	// @ts-expect-error TODO make this not error
	isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
	
	/** @type {import('.')} */
	module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ },
/* 6743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBound = __webpack_require__(253);
	
	var getDay = callBound('Date.prototype.getDay');
	/** @type {import('.')} */
	var tryDateObject = function tryDateGetDayCall(value) {
		try {
			getDay(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	/** @type {(value: unknown) => string} */
	var toStr = callBound('Object.prototype.toString');
	var dateClass = '[object Date]';
	var hasToStringTag = __webpack_require__(261)();
	
	/** @type {import('.')} */
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) {
			return false;
		}
		return hasToStringTag ? tryDateObject(value) : toStr(value) === dateClass;
	};


/***/ },
/* 6744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBound = __webpack_require__(253);
	var hasToStringTag = __webpack_require__(261)();
	var hasOwn = __webpack_require__(447);
	var gOPD = __webpack_require__(115);
	
	/** @type {import('.')} */
	var fn;
	
	if (hasToStringTag) {
		/** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */
		var $exec = callBound('RegExp.prototype.exec');
		/** @type {object} */
		var isRegexMarker = {};
	
		var throwRegexMarker = function () {
			throw isRegexMarker;
		};
		/** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */
		var badStringifier = {
			toString: throwRegexMarker,
			valueOf: throwRegexMarker
		};
	
		if (typeof Symbol.toPrimitive === 'symbol') {
			badStringifier[Symbol.toPrimitive] = throwRegexMarker;
		}
	
		/** @type {import('.')} */
		// @ts-expect-error TS can't figure out that the $exec call always throws
		// eslint-disable-next-line consistent-return
		fn = function isRegex(value) {
			if (!value || typeof value !== 'object') {
				return false;
			}
	
			// eslint-disable-next-line no-extra-parens
			var descriptor = /** @type {NonNullable<typeof gOPD>} */ (gOPD)(/** @type {{ lastIndex?: unknown }} */ (value), 'lastIndex');
			var hasLastIndexDataProperty = descriptor && hasOwn(descriptor, 'value');
			if (!hasLastIndexDataProperty) {
				return false;
			}
	
			try {
				// eslint-disable-next-line no-extra-parens
				$exec(value, /** @type {string} */ (/** @type {unknown} */ (badStringifier)));
			} catch (e) {
				return e === isRegexMarker;
			}
		};
	} else {
		/** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */
		var $toString = callBound('Object.prototype.toString');
		/** @const @type {'[object RegExp]'} */
		var regexClass = '[object RegExp]';
	
		/** @type {import('.')} */
		fn = function isRegex(value) {
			// In older browsers, typeof regex incorrectly returns 'function'
			if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
				return false;
			}
	
			return $toString(value) === regexClass;
		};
	}
	
	module.exports = fn;


/***/ },
/* 6745 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.7.1
	 * https://jquery.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2023-08-28T13:37Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket trac-14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
		};
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var version = "3.7.1",
	
		rhtmlSuffix = /HTML$/i,
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
	
		// Retrieve the text value of an array of DOM nodes
		text: function( elem ) {
			var node,
				ret = "",
				i = 0,
				nodeType = elem.nodeType;
	
			if ( !nodeType ) {
	
				// If no nodeType, this is expected to be an array
				while ( ( node = elem[ i++ ] ) ) {
	
					// Do not traverse comment nodes
					ret += jQuery.text( node );
				}
			}
			if ( nodeType === 1 || nodeType === 11 ) {
				return elem.textContent;
			}
			if ( nodeType === 9 ) {
				return elem.documentElement.textContent;
			}
			if ( nodeType === 3 || nodeType === 4 ) {
				return elem.nodeValue;
			}
	
			// Do not include comment or processing instruction nodes
	
			return ret;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
							[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		isXMLDoc: function( elem ) {
			var namespace = elem && elem.namespaceURI,
				docElem = elem && ( elem.ownerDocument || elem ).documentElement;
	
			// Assume HTML when documentElement doesn't yet exist, such as inside
			// document fragments.
			return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
		function( _i, name ) {
			class2type[ "[object " + name + "]" ] = name.toLowerCase();
		} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	
	
	function nodeName( elem, name ) {
	
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	}
	var pop = arr.pop;
	
	
	var sort = arr.sort;
	
	
	var splice = arr.splice;
	
	
	var whitespace = "[\\x20\\t\\r\\n\\f]";
	
	
	var rtrimCSS = new RegExp(
		"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
		"g"
	);
	
	
	
	
	// Note: an element does not contain itself
	jQuery.contains = function( a, b ) {
		var bup = b && b.parentNode;
	
		return a === bup || !!( bup && bup.nodeType === 1 && (
	
			// Support: IE 9 - 11+
			// IE doesn't have `contains` on SVG.
			a.contains ?
				a.contains( bup ) :
				a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
		) );
	};
	
	
	
	
	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
	
	function fcssescape( ch, asCodePoint ) {
		if ( asCodePoint ) {
	
			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}
	
			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}
	
		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	}
	
	jQuery.escapeSelector = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	
	
	
	var preferredDoc = document,
		pushNative = push;
	
	( function() {
	
	var i,
		Expr,
		outermostContext,
		sortInput,
		hasDuplicate,
		push = pushNative,
	
		// Local document vars
		document,
		documentElement,
		documentIsHTML,
		rbuggyQSA,
		matches,
	
		// Instance-specific data
		expando = jQuery.expando,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
			"loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
			whitespace + "*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			ID: new RegExp( "^#(" + identifier + ")" ),
			CLASS: new RegExp( "^\\.(" + identifier + ")" ),
			TAG: new RegExp( "^(" + identifier + "|[*])" ),
			ATTR: new RegExp( "^" + attributes ),
			PSEUDO: new RegExp( "^" + pseudos ),
			CHILD: new RegExp(
				"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
					whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
					whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			bool: new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			needsContext: new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			if ( nonHex ) {
	
				// Strip the backslash prefix from a non-hex escape sequence
				return nonHex;
			}
	
			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			return high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes; see `setDocument`.
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE/Edge.
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && nodeName( elem, "fieldset" );
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android <=4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = {
			apply: function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			},
			call: function( target ) {
				pushNative.apply( target, slice.call( arguments, 1 ) );
			}
		};
	}
	
	function find( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE 9 only
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									push.call( results, elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								find.contains( context, elem ) &&
								elem.id === m ) {
	
								push.call( results, elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( !nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when
						// strict-comparing two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( newContext != context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = jQuery.escapeSelector( nid );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties
			// (see https://github.com/jquery/sizzle/issues/157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by jQuery selector module
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			return nodeName( elem, "input" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
				elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11+
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						elem.isDisabled !== !disabled &&
							inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a jQuery selector context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [node] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	function setDocument( node ) {
		var subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		documentElement = document.documentElement;
		documentIsHTML = !jQuery.isXMLDoc( document );
	
		// Support: iOS 7 only, IE 9 - 11+
		// Older browsers didn't support unprefixed `matches`.
		matches = documentElement.matches ||
			documentElement.webkitMatchesSelector ||
			documentElement.msMatchesSelector;
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors
		// (see trac-13936).
		// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
		// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
		if ( documentElement.msMatchesSelector &&
	
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 9 - 11+, Edge 12 - 18+
			subWindow.addEventListener( "unload", unloadHandler );
		}
	
		// Support: IE <10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			documentElement.appendChild( el ).id = jQuery.expando;
			return !document.getElementsByName ||
				!document.getElementsByName( jQuery.expando ).length;
		} );
	
		// Support: IE 9 only
		// Check to see if it's possible to do matchesSelector
		// on a disconnected node.
		support.disconnectedMatch = assert( function( el ) {
			return matches.call( el, "*" );
		} );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// IE/Edge don't support the :scope pseudo-class.
		support.scope = assert( function() {
			return document.querySelectorAll( ":scope" );
		} );
	
		// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
		// Make sure the `:has()` argument is parsed unforgivingly.
		// We include `*` in the test to detect buggy implementations that are
		// _selectively_ forgiving (specifically when the list includes at least
		// one valid selector).
		// Note that we treat complete lack of support for `:has()` as if it were
		// spec-compliant support, which is fine because use of `:has()` in such
		// environments will fail in the qSA path and fall back to jQuery traversal
		// anyway.
		support.cssHas = assert( function() {
			try {
				document.querySelector( ":has(*,:jqfake)" );
				return false;
			} catch ( e ) {
				return true;
			}
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter.ID = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find.ID = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter.ID =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find.ID = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find.TAG = function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );
	
			// DocumentFragment nodes don't have gEBTN
			} else {
				return context.querySelectorAll( tag );
			}
		};
	
		// Class
		Expr.find.CLASS = function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		rbuggyQSA = [];
	
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {
	
			var input;
	
			documentElement.appendChild( el ).innerHTML =
				"<a id='" + expando + "' href='' disabled='disabled'></a>" +
				"<select id='" + expando + "-\r\\' disabled='disabled'>" +
				"<option selected=''></option></select>";
	
			// Support: iOS <=7 - 8 only
			// Boolean attributes and "value" are not treated correctly in some XML documents
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}
	
			// Support: iOS <=7 - 8 only
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}
	
			// Support: iOS 8 only
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}
	
			// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
			// In some of the document kinds, these selectors wouldn't work natively.
			// This is probably OK but for backwards compatibility we want to maintain
			// handling them through jQuery traversal in jQuery 3.x.
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}
	
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );
	
			// Support: IE 9 - 11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
			// In some of the document kinds, these selectors wouldn't work natively.
			// This is probably OK but for backwards compatibility we want to maintain
			// handling them through jQuery traversal in jQuery 3.x.
			documentElement.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}
	
			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}
		} );
	
		if ( !support.cssHas ) {
	
			// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
			// Our regular `try-catch` mechanism fails to detect natively-unsupported
			// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
			// in browsers that parse the `:has()` argument as a forgiving selector list.
			// https://drafts.csswg.org/selectors/#relational now requires the argument
			// to be parsed unforgivingly, but browsers have not yet fully adjusted.
			rbuggyQSA.push( ":has" );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a === document || a.ownerDocument == preferredDoc &&
					find.contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b === document || b.ownerDocument == preferredDoc &&
					find.contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		};
	
		return document;
	}
	
	find.matches = function( expr, elements ) {
		return find( expr, null, null, elements );
	};
	
	find.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return find( expr, document, null, [ elem ] ).length > 0;
	};
	
	find.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return jQuery.contains( context, elem );
	};
	
	
	find.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (see trac-13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		if ( val !== undefined ) {
			return val;
		}
	
		return elem.getAttribute( name );
	};
	
	find.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	jQuery.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		//
		// Support: Android <=4.0+
		// Testing for detecting duplicates is unpredictable so instead assume we can't
		// depend on duplicate detection in all browsers without a stable sort.
		hasDuplicate = !support.sortStable;
		sortInput = !support.sortStable && slice.call( results, 0 );
		sort.call( results, sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				splice.call( results, duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	jQuery.fn.uniqueSort = function() {
		return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
	};
	
	Expr = jQuery.expr = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			ATTR: function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
					.replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			CHILD: function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						find.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
					);
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					find.error( match[ 0 ] );
				}
	
				return match;
			},
	
			PSEUDO: function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			TAG: function( nodeNameSelector ) {
				var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return nodeName( elem, expectedNodeName );
					};
			},
	
			CLASS: function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace + ")" + className +
						"(" + whitespace + "|$)" ) ) &&
					classCache( className, function( elem ) {
						return pattern.test(
							typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
						);
					} );
			},
	
			ATTR: function( name, operator, check ) {
				return function( elem ) {
					var result = find.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					if ( operator === "=" ) {
						return result === check;
					}
					if ( operator === "!=" ) {
						return result !== check;
					}
					if ( operator === "^=" ) {
						return check && result.indexOf( check ) === 0;
					}
					if ( operator === "*=" ) {
						return check && result.indexOf( check ) > -1;
					}
					if ( operator === "$=" ) {
						return check && result.slice( -check.length ) === check;
					}
					if ( operator === "~=" ) {
						return ( " " + result.replace( rwhitespace, " " ) + " " )
							.indexOf( check ) > -1;
					}
					if ( operator === "|=" ) {
						return result === check || result.slice( 0, check.length + 1 ) === check + "-";
					}
	
					return false;
				};
			},
	
			CHILD: function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											nodeName( node, name ) :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
								outerCache = parent[ expando ] || ( parent[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										outerCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
									outerCache = elem[ expando ] || ( elem[ expando ] = {} );
									cache = outerCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											nodeName( node, name ) :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
												outerCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			PSEUDO: function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// https://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						find.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as jQuery does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf.call( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			not: markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrimCSS, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element
						// (see https://github.com/jquery/sizzle/issues/299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			has: markFunction( function( selector ) {
				return function( elem ) {
					return find( selector, elem ).length > 0;
				};
			} ),
	
			contains: markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// https://www.w3.org/TR/selectors/#lang-pseudo
			lang: markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					find.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			target: function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			root: function( elem ) {
				return elem === documentElement;
			},
	
			focus: function( elem ) {
				return elem === safeActiveElement() &&
					document.hasFocus() &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			enabled: createDisabledPseudo( false ),
			disabled: createDisabledPseudo( true ),
	
			checked: function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				return ( nodeName( elem, "input" ) && !!elem.checked ) ||
					( nodeName( elem, "option" ) && !!elem.selected );
			},
	
			selected: function( elem ) {
	
				// Support: IE <=11+
				// Accessing the selectedIndex property
				// forces the browser to treat the default option as
				// selected when in an optgroup.
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			empty: function( elem ) {
	
				// https://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			parent: function( elem ) {
				return !Expr.pseudos.empty( elem );
			},
	
			// Element/input types
			header: function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			input: function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			button: function( elem ) {
				return nodeName( elem, "input" ) && elem.type === "button" ||
					nodeName( elem, "button" );
			},
	
			text: function( elem ) {
				var attr;
				return nodeName( elem, "input" ) && elem.type === "text" &&
	
					// Support: IE <10 only
					// New HTML5 attribute values (e.g., "search") appear
					// with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			first: createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			last: createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			even: createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			odd: createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i;
	
				if ( argument < 0 ) {
					i = argument + length;
				} else if ( argument > length ) {
					i = length;
				} else {
					i = argument;
				}
	
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos.nth = Expr.pseudos.eq;
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	function tokenize( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrimCSS, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		if ( parseOnly ) {
			return soFar.length;
		}
	
		return soFar ?
			find.error( selector ) :
	
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
	}
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							if ( skip && nodeName( elem, skip ) ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = outerCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								outerCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			find( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem, matcherOut,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed ||
					multipleContexts( selector || "*",
						context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems;
	
			if ( matcher ) {
	
				// If we have a postFinder, or filtered seed, or non-seed postFilter
				// or preexisting results,
				matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
					// ...intermediate processing is necessary
					[] :
	
					// ...otherwise use results directly
					results;
	
				// Find primary matches
				matcher( matcherIn, matcherOut, context, xml );
			} else {
				matcherOut = matcherIn;
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf.call( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element
				// (see https://github.com/jquery/sizzle/issues/299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 )
								.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrimCSS, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find.TAG( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: iOS <=7 - 9 only
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
				// elements by id. (see trac-14142)
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								push.call( results, elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						jQuery.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	function compile( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	}
	
	/**
	 * A low-level selection function that works with jQuery's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with jQuery selector compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	function select( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find.ID(
					token.matches[ 0 ].replace( runescape, funescape ),
					context
				) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) &&
							testContext( context.parentNode ) || context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	}
	
	// One-time assignments
	
	// Support: Android <=4.0 - 4.1+
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Android <=4.0 - 4.1+
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	jQuery.find = find;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.unique = jQuery.uniqueSort;
	
	// These have always been private, but they used to be documented as part of
	// Sizzle so let's maintain them for now for backwards compatibility purposes.
	find.compile = compile;
	find.select = select;
	find.setDocument = setDocument;
	find.tokenize = tokenize;
	
	find.escape = jQuery.escapeSelector;
	find.getText = jQuery.text;
	find.isXML = jQuery.isXMLDoc;
	find.selectors = jQuery.expr;
	find.support = jQuery.support;
	find.uniqueSort = jQuery.uniqueSort;
	
		/* eslint-enable */
	
	} )();
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
		// Strict HTML recognition (trac-11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to jQuery#find
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.error );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the error, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getErrorHook ) {
										process.error = jQuery.Deferred.getErrorHook();
	
									// The deprecated alias of the above. While the name suggests
									// returning the stack, not an error instance, jQuery just passes
									// it directly to `console.warn` so both will work; an instance
									// just better cooperates with source maps.
									} else if ( jQuery.Deferred.getStackHook ) {
										process.error = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the primary Deferred
				primary = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							primary.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return primary.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}
	
			return primary.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
	// captured before the async barrier to get the original error cause
	// which may otherwise be hidden.
	jQuery.Deferred.exceptionHook = function( error, asyncError ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message,
				error.stack, asyncError );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See trac-6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
							value :
							value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (trac-9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see trac-8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (trac-14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (trac-11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (trac-14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (trac-13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (trac-12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (trac-13208)
					// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (trac-13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
							return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
							return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", true );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, isSetup ) {
	
		// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
		if ( !isSetup ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					if ( !saved ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						this[ type ]();
						result = dataPriv.get( this, type );
						dataPriv.set( this, type, false );
	
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
	
							return result;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering
					// the native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved ) {
	
					// ...and capture the result
					dataPriv.set( this, type, jQuery.event.trigger(
						saved[ 0 ],
						saved.slice( 1 ),
						this
					) );
	
					// Abort handling of the native event by all jQuery handlers while allowing
					// native handlers on the same element to run. On target, this is achieved
					// by stopping immediate propagation just on the jQuery event. However,
					// the native event is re-wrapped by a jQuery one on each level of the
					// propagation so the only way to stop it for jQuery is to stop it for
					// everyone via native `stopPropagation()`. This is not a problem for
					// focus/blur which don't bubble, but it does also stop click on checkboxes
					// and radios. We accept this limitation.
					event.stopPropagation();
					event.isImmediatePropagationStopped = returnTrue;
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (trac-504, trac-13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	
		function focusMappedHandler( nativeEvent ) {
			if ( document.documentMode ) {
	
				// Support: IE 11+
				// Attach a single focusin/focusout handler on the document while someone wants
				// focus/blur. This is because the former are synchronous in IE while the latter
				// are async. In other browsers, all those handlers are invoked synchronously.
	
				// `handle` from private data would already wrap the event, but we need
				// to change the `type` here.
				var handle = dataPriv.get( this, "handle" ),
					event = jQuery.event.fix( nativeEvent );
				event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
				event.isSimulated = true;
	
				// First, handle focusin/focusout
				handle( nativeEvent );
	
				// ...then, handle focus/blur
				//
				// focus/blur don't bubble while focusin/focusout do; simulate the former by only
				// invoking the handler at the lower level.
				if ( event.target === event.currentTarget ) {
	
					// The setup part calls `leverageNative`, which, in turn, calls
					// `jQuery.event.add`, so event handle will already have been set
					// by this point.
					handle( event );
				}
			} else {
	
				// For non-IE browsers, attach a single capturing handler on the document
				// while someone wants focusin/focusout.
				jQuery.event.simulate( delegateType, nativeEvent.target,
					jQuery.event.fix( nativeEvent ) );
			}
		}
	
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				var attaches;
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, true );
	
				if ( document.documentMode ) {
	
					// Support: IE 9 - 11+
					// We use the same native handler for focusin & focus (and focusout & blur)
					// so we need to coordinate setup & teardown parts between those events.
					// Use `delegateType` as the key as `type` is already used by `leverageNative`.
					attaches = dataPriv.get( this, delegateType );
					if ( !attaches ) {
						this.addEventListener( delegateType, focusMappedHandler );
					}
					dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
				} else {
	
					// Return false to allow normal processing in the caller
					return false;
				}
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			teardown: function() {
				var attaches;
	
				if ( document.documentMode ) {
					attaches = dataPriv.get( this, delegateType ) - 1;
					if ( !attaches ) {
						this.removeEventListener( delegateType, focusMappedHandler );
						dataPriv.remove( this, delegateType );
					} else {
						dataPriv.set( this, delegateType, attaches );
					}
				} else {
	
					// Return false to indicate standard teardown should be applied
					return false;
				}
			},
	
			// Suppress native focus or blur if we're currently inside
			// a leveraged native-event stack
			_default: function( event ) {
				return dataPriv.get( event.target, type );
			},
	
			delegateType: delegateType
		};
	
		// Support: Firefox <=44
		// Firefox doesn't have focus(in | out) events
		// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
		//
		// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
		// focus(in | out) events fire after focus & blur events,
		// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
		// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
		//
		// Support: IE 9 - 11+
		// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
		// attach a single handler for both events in IE.
		jQuery.event.special[ delegateType ] = {
			setup: function() {
	
				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					dataHolder = document.documentMode ? this : doc,
					attaches = dataPriv.get( dataHolder, delegateType );
	
				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.addEventListener( delegateType, focusMappedHandler );
					} else {
						doc.addEventListener( type, focusMappedHandler, true );
					}
				}
				dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					dataHolder = document.documentMode ? this : doc,
					attaches = dataPriv.get( dataHolder, delegateType ) - 1;
	
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.removeEventListener( delegateType, focusMappedHandler );
					} else {
						doc.removeEventListener( type, focusMappedHandler, true );
					}
					dataPriv.remove( dataHolder, delegateType );
				} else {
					dataPriv.set( dataHolder, delegateType, attaches );
				}
			}
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	
		rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (trac-8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Re-enable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
	
								// Unwrap a CDATA section containing script contents. This shouldn't be
								// needed as in XML documents they're already not visible when
								// inspecting element contents and in HTML documents they have no
								// meaning but we're preserving that logic for backwards compatibility.
								// This will be removed completely in 4.0. See gh-4904.
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew jQuery#find here for performance reasons:
				// https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var rcustomProp = /^--/;
	
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (trac-8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "box-sizing:content-box;border:1px solid";
	
					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is `display: block`
					// gets around this issue.
					trChild.style.display = "block";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
						parseInt( trStyle.borderTopWidth, 10 ) +
						parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			isCustomProp = rcustomProp.test( name ),
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, trac-12537)
		//   .css('--customProperty) (gh-3144)
		if ( computed ) {
	
			// Support: IE <=9 - 11+
			// IE only supports `"float"` in `getPropertyValue`; in computed styles
			// it's only available as `"cssFloat"`. We no longer modify properties
			// sent to `.css()` apart from camelCasing, so we need to check both.
			// Normally, this would create difference in behavior: if
			// `getPropertyValue` returns an empty string, the value returned
			// by `.css()` would be `undefined`. This is usually the case for
			// disconnected elements. However, in IE even disconnected elements
			// with no styles return `"none"` for `getPropertyValue( "float" )`
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( isCustomProp && ret ) {
	
				// Support: Firefox 105+, Chrome <=105+
				// Spec requires trimming whitespace for custom properties (gh-4926).
				// Firefox only trims leading whitespace. Chrome just collapses
				// both leading & trailing whitespace to a single space.
				//
				// Fall back to `undefined` if empty string returned.
				// This collapses a missing definition with property defined
				// and set to an empty string but there's no standard API
				// allowing us to differentiate them without a performance penalty
				// and returning `undefined` aligns with older jQuery.
				//
				// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
				// as whitespace while CSS does not, but this is not a problem
				// because CSS preprocessing replaces them with U+000A LINE FEED
				// (which *is* CSS whitespace)
				// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
				ret = ret.replace( rtrimCSS, "$1" ) || undefined;
			}
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0,
			marginDelta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			// Count margin delta separately to only add it after scroll gutter adjustment.
			// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
			if ( box === "margin" ) {
				marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta + marginDelta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			animationIterationCount: true,
			aspectRatio: true,
			borderImageSlice: true,
			columnCount: true,
			flexGrow: true,
			flexShrink: true,
			fontWeight: true,
			gridArea: true,
			gridColumn: true,
			gridColumnEnd: true,
			gridColumnStart: true,
			gridRow: true,
			gridRowEnd: true,
			gridRowStart: true,
			lineHeight: true,
			opacity: true,
			order: true,
			orphans: true,
			scale: true,
			widows: true,
			zIndex: true,
			zoom: true,
	
			// SVG-related
			fillOpacity: true,
			floodOpacity: true,
			stopOpacity: true,
			strokeMiterlimit: true,
			strokeOpacity: true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (trac-7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug trac-9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (trac-7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
					/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
	
			doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// Use proper attribute retrieval (trac-12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
							if ( cur.indexOf( " " + className + " " ) < 0 ) {
								cur += className + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
	
					// This expression is here for better compressibility (see addClass)
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
	
							// Remove *all* instances
							while ( cur.indexOf( " " + className + " " ) > -1 ) {
								cur = cur.replace( " " + className + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var classNames, className, i, self,
				type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			classNames = classesToArray( value );
	
			return this.each( function() {
				if ( isValidValue ) {
	
					// Toggle individual class names
					self = jQuery( this );
	
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
								"" :
								dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (trac-14686, trac-14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (trac-2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}
	
		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
				parserErrorElem ?
					jQuery.map( parserErrorElem.childNodes, function( el ) {
						return el.textContent;
					} ).join( "\n" ) :
					data
			) );
		}
		return xml;
	};
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (trac-9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (trac-6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// trac-7653, trac-8125, trac-8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
	
	originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes trac-9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (trac-10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket trac-12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// trac-9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
					jQuery.inArray( "script", s.dataTypes ) > -1 &&
					jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (trac-11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// trac-1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see trac-8605, trac-14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// trac-14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this
				.on( "mouseenter", fnOver )
				.on( "mouseleave", fnOut || fnOver );
		}
	} );
	
	jQuery.each(
		( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		}
	);
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	// Require that the "whitespace run" starts from a non-whitespace
	// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
	var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "$1" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (trac-13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ },
/* 6746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var hyphenate = __webpack_require__(6740);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var hyphenate__default = /*#__PURE__*/_interopDefaultLegacy(hyphenate);
	
	/**
	 * Convert camel cased property names to dash separated.
	 */
	
	function convertCase(style) {
	  var converted = {};
	
	  for (var prop in style) {
	    var key = prop.indexOf('--') === 0 ? prop : hyphenate__default['default'](prop);
	    converted[key] = style[prop];
	  }
	
	  if (style.fallbacks) {
	    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
	  }
	
	  return converted;
	}
	/**
	 * Allow camel cased property names by converting them back to dasherized.
	 */
	
	
	function camelCase() {
	  function onProcessStyle(style) {
	    if (Array.isArray(style)) {
	      // Handle rules like @font-face, which can have multiple styles in an array
	      for (var index = 0; index < style.length; index++) {
	        style[index] = convertCase(style[index]);
	      }
	
	      return style;
	    }
	
	    return convertCase(style);
	  }
	
	  function onChangeValue(value, prop, rule) {
	    if (prop.indexOf('--') === 0) {
	      return value;
	    }
	
	    var hyphenatedProp = hyphenate__default['default'](prop); // There was no camel case in place
	
	    if (prop === hyphenatedProp) return value;
	    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
	
	    return null;
	  }
	
	  return {
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = camelCase;


/***/ },
/* 6747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var jss = __webpack_require__(97);
	
	var px = jss.hasCSSTOMSupport && CSS ? CSS.px : 'px';
	var ms = jss.hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
	var percent = jss.hasCSSTOMSupport && CSS ? CSS.percent : '%';
	/**
	 * Generated jss-plugin-default-unit CSS property units
	 */
	
	var defaultUnits = {
	  // Animation properties
	  'animation-delay': ms,
	  'animation-duration': ms,
	  // Background properties
	  'background-position': px,
	  'background-position-x': px,
	  'background-position-y': px,
	  'background-size': px,
	  // Border Properties
	  border: px,
	  'border-bottom': px,
	  'border-bottom-left-radius': px,
	  'border-bottom-right-radius': px,
	  'border-bottom-width': px,
	  'border-left': px,
	  'border-left-width': px,
	  'border-radius': px,
	  'border-right': px,
	  'border-right-width': px,
	  'border-top': px,
	  'border-top-left-radius': px,
	  'border-top-right-radius': px,
	  'border-top-width': px,
	  'border-width': px,
	  'border-block': px,
	  'border-block-end': px,
	  'border-block-end-width': px,
	  'border-block-start': px,
	  'border-block-start-width': px,
	  'border-block-width': px,
	  'border-inline': px,
	  'border-inline-end': px,
	  'border-inline-end-width': px,
	  'border-inline-start': px,
	  'border-inline-start-width': px,
	  'border-inline-width': px,
	  'border-start-start-radius': px,
	  'border-start-end-radius': px,
	  'border-end-start-radius': px,
	  'border-end-end-radius': px,
	  // Margin properties
	  margin: px,
	  'margin-bottom': px,
	  'margin-left': px,
	  'margin-right': px,
	  'margin-top': px,
	  'margin-block': px,
	  'margin-block-end': px,
	  'margin-block-start': px,
	  'margin-inline': px,
	  'margin-inline-end': px,
	  'margin-inline-start': px,
	  // Padding properties
	  padding: px,
	  'padding-bottom': px,
	  'padding-left': px,
	  'padding-right': px,
	  'padding-top': px,
	  'padding-block': px,
	  'padding-block-end': px,
	  'padding-block-start': px,
	  'padding-inline': px,
	  'padding-inline-end': px,
	  'padding-inline-start': px,
	  // Mask properties
	  'mask-position-x': px,
	  'mask-position-y': px,
	  'mask-size': px,
	  // Width and height properties
	  height: px,
	  width: px,
	  'min-height': px,
	  'max-height': px,
	  'min-width': px,
	  'max-width': px,
	  // Position properties
	  bottom: px,
	  left: px,
	  top: px,
	  right: px,
	  inset: px,
	  'inset-block': px,
	  'inset-block-end': px,
	  'inset-block-start': px,
	  'inset-inline': px,
	  'inset-inline-end': px,
	  'inset-inline-start': px,
	  // Shadow properties
	  'box-shadow': px,
	  'text-shadow': px,
	  // Column properties
	  'column-gap': px,
	  'column-rule': px,
	  'column-rule-width': px,
	  'column-width': px,
	  // Font and text properties
	  'font-size': px,
	  'font-size-delta': px,
	  'letter-spacing': px,
	  'text-decoration-thickness': px,
	  'text-indent': px,
	  'text-stroke': px,
	  'text-stroke-width': px,
	  'word-spacing': px,
	  // Motion properties
	  motion: px,
	  'motion-offset': px,
	  // Outline properties
	  outline: px,
	  'outline-offset': px,
	  'outline-width': px,
	  // Perspective properties
	  perspective: px,
	  'perspective-origin-x': percent,
	  'perspective-origin-y': percent,
	  // Transform properties
	  'transform-origin': percent,
	  'transform-origin-x': percent,
	  'transform-origin-y': percent,
	  'transform-origin-z': percent,
	  // Transition properties
	  'transition-delay': ms,
	  'transition-duration': ms,
	  // Alignment properties
	  'vertical-align': px,
	  'flex-basis': px,
	  // Some random properties
	  'shape-margin': px,
	  size: px,
	  gap: px,
	  // Grid properties
	  grid: px,
	  'grid-gap': px,
	  'row-gap': px,
	  'grid-row-gap': px,
	  'grid-column-gap': px,
	  'grid-template-rows': px,
	  'grid-template-columns': px,
	  'grid-auto-rows': px,
	  'grid-auto-columns': px,
	  // Not existing properties.
	  // Used to avoid issues with jss-plugin-expand integration.
	  'box-shadow-x': px,
	  'box-shadow-y': px,
	  'box-shadow-blur': px,
	  'box-shadow-spread': px,
	  'font-line-height': px,
	  'text-shadow-x': px,
	  'text-shadow-y': px,
	  'text-shadow-blur': px
	};
	
	/**
	 * Clones the object and adds a camel cased property version.
	 */
	
	function addCamelCasedVersion(obj) {
	  var regExp = /(-[a-z])/g;
	
	  var replace = function replace(str) {
	    return str[1].toUpperCase();
	  };
	
	  var newObj = {};
	
	  for (var key in obj) {
	    newObj[key] = obj[key];
	    newObj[key.replace(regExp, replace)] = obj[key];
	  }
	
	  return newObj;
	}
	
	var units = addCamelCasedVersion(defaultUnits);
	/**
	 * Recursive deep style passing function
	 */
	
	function iterate(prop, value, options) {
	  if (value == null) return value;
	
	  if (Array.isArray(value)) {
	    for (var i = 0; i < value.length; i++) {
	      value[i] = iterate(prop, value[i], options);
	    }
	  } else if (typeof value === 'object') {
	    if (prop === 'fallbacks') {
	      for (var innerProp in value) {
	        value[innerProp] = iterate(innerProp, value[innerProp], options);
	      }
	    } else {
	      for (var _innerProp in value) {
	        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
	      }
	    } // eslint-disable-next-line no-restricted-globals
	
	  } else if (typeof value === 'number' && isNaN(value) === false) {
	    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.
	
	    if (unit && !(value === 0 && unit === px)) {
	      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
	    }
	
	    return value.toString();
	  }
	
	  return value;
	}
	/**
	 * Add unit to numeric values.
	 */
	
	
	function defaultUnit(options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var camelCasedOptions = addCamelCasedVersion(options);
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	
	    for (var prop in style) {
	      style[prop] = iterate(prop, style[prop], camelCasedOptions);
	    }
	
	    return style;
	  }
	
	  function onChangeValue(value, prop) {
	    return iterate(prop, value, camelCasedOptions);
	  }
	
	  return {
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = defaultUnit;


/***/ },
/* 6748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _extends = __webpack_require__(4);
	var jss = __webpack_require__(97);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	
	var at = '@global';
	var atPrefix = '@global ';
	
	var GlobalContainerRule =
	/*#__PURE__*/
	function () {
	  function GlobalContainerRule(key, styles, options) {
	    this.type = 'global';
	    this.at = at;
	    this.isProcessed = false;
	    this.key = key;
	    this.options = options;
	    this.rules = new jss.RuleList(_extends__default['default']({}, options, {
	      parent: this
	    }));
	
	    for (var selector in styles) {
	      this.rules.add(selector, styles[selector]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Get a rule.
	   */
	
	
	  var _proto = GlobalContainerRule.prototype;
	
	  _proto.getRule = function getRule(name) {
	    return this.rules.get(name);
	  }
	  /**
	   * Create and register rule, run plugins.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, style, options) {
	    var rule = this.rules.add(name, style, options);
	    if (rule) this.options.jss.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Replace rule, run plugins.
	   */
	  ;
	
	  _proto.replaceRule = function replaceRule(name, style, options) {
	    var newRule = this.rules.replace(name, style, options);
	    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
	    return newRule;
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    return this.rules.toString(options);
	  };
	
	  return GlobalContainerRule;
	}();
	
	var GlobalPrefixedRule =
	/*#__PURE__*/
	function () {
	  function GlobalPrefixedRule(key, style, options) {
	    this.type = 'global';
	    this.at = at;
	    this.isProcessed = false;
	    this.key = key;
	    this.options = options;
	    var selector = key.substr(atPrefix.length);
	    this.rule = options.jss.createRule(selector, style, _extends__default['default']({}, options, {
	      parent: this
	    }));
	  }
	
	  var _proto2 = GlobalPrefixedRule.prototype;
	
	  _proto2.toString = function toString(options) {
	    return this.rule ? this.rule.toString(options) : '';
	  };
	
	  return GlobalPrefixedRule;
	}();
	
	var separatorRegExp = /\s*,\s*/g;
	
	function addScope(selector, scope) {
	  var parts = selector.split(separatorRegExp);
	  var scoped = '';
	
	  for (var i = 0; i < parts.length; i++) {
	    scoped += scope + " " + parts[i].trim();
	    if (parts[i + 1]) scoped += ', ';
	  }
	
	  return scoped;
	}
	
	function handleNestedGlobalContainerRule(rule, sheet) {
	  var options = rule.options,
	      style = rule.style;
	  var rules = style ? style[at] : null;
	  if (!rules) return;
	
	  for (var name in rules) {
	    sheet.addRule(name, rules[name], _extends__default['default']({}, options, {
	      selector: addScope(name, rule.selector)
	    }));
	  }
	
	  delete style[at];
	}
	
	function handlePrefixedGlobalRule(rule, sheet) {
	  var options = rule.options,
	      style = rule.style;
	
	  for (var prop in style) {
	    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
	    var selector = addScope(prop.substr(at.length), rule.selector);
	    sheet.addRule(selector, style[prop], _extends__default['default']({}, options, {
	      selector: selector
	    }));
	    delete style[prop];
	  }
	}
	/**
	 * Convert nested rules to separate, remove them from original styles.
	 */
	
	
	function jssGlobal() {
	  function onCreateRule(name, styles, options) {
	    if (!name) return null;
	
	    if (name === at) {
	      return new GlobalContainerRule(name, styles, options);
	    }
	
	    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
	      return new GlobalPrefixedRule(name, styles, options);
	    }
	
	    var parent = options.parent;
	
	    if (parent) {
	      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
	        options.scoped = false;
	      }
	    }
	
	    if (!options.selector && options.scoped === false) {
	      options.selector = name;
	    }
	
	    return null;
	  }
	
	  function onProcessRule(rule, sheet) {
	    if (rule.type !== 'style' || !sheet) return;
	    handleNestedGlobalContainerRule(rule, sheet);
	    handlePrefixedGlobalRule(rule, sheet);
	  }
	
	  return {
	    onCreateRule: onCreateRule,
	    onProcessRule: onProcessRule
	  };
	}
	
	exports.default = jssGlobal;


/***/ },
/* 6749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _extends = __webpack_require__(4);
	var warning = __webpack_require__(108);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
	var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
	
	var separatorRegExp = /\s*,\s*/g;
	var parentRegExp = /&/g;
	var refRegExp = /\$([\w-]+)/g;
	/**
	 * Convert nested rules to separate, remove them from original styles.
	 */
	
	function jssNested() {
	  // Get a function to be used for $ref replacement.
	  function getReplaceRef(container, sheet) {
	    return function (match, key) {
	      var rule = container.getRule(key) || sheet && sheet.getRule(key);
	
	      if (rule) {
	        return rule.selector;
	      }
	
	       false ? warning__default['default'](false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
	      return key;
	    };
	  }
	
	  function replaceParentRefs(nestedProp, parentProp) {
	    var parentSelectors = parentProp.split(separatorRegExp);
	    var nestedSelectors = nestedProp.split(separatorRegExp);
	    var result = '';
	
	    for (var i = 0; i < parentSelectors.length; i++) {
	      var parent = parentSelectors[i];
	
	      for (var j = 0; j < nestedSelectors.length; j++) {
	        var nested = nestedSelectors[j];
	        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
	
	        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
	      }
	    }
	
	    return result;
	  }
	
	  function getOptions(rule, container, prevOptions) {
	    // Options has been already created, now we only increase index.
	    if (prevOptions) return _extends__default['default']({}, prevOptions, {
	      index: prevOptions.index + 1
	    });
	    var nestingLevel = rule.options.nestingLevel;
	    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
	
	    var options = _extends__default['default']({}, rule.options, {
	      nestingLevel: nestingLevel,
	      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
	
	    });
	
	    delete options.name;
	    return options;
	  }
	
	  function onProcessStyle(style, rule, sheet) {
	    if (rule.type !== 'style') return style;
	    var styleRule = rule;
	    var container = styleRule.options.parent;
	    var options;
	    var replaceRef;
	
	    for (var prop in style) {
	      var isNested = prop.indexOf('&') !== -1;
	      var isNestedConditional = prop[0] === '@';
	      if (!isNested && !isNestedConditional) continue;
	      options = getOptions(styleRule, container, options);
	
	      if (isNested) {
	        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
	        // all nested rules within the sheet.
	
	        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
	
	        selector = selector.replace(refRegExp, replaceRef);
	        var name = styleRule.key + "-" + prop;
	
	        if ('replaceRule' in container) {
	          // for backward compatibility
	          container.replaceRule(name, style[prop], _extends__default['default']({}, options, {
	            selector: selector
	          }));
	        } else {
	          container.addRule(name, style[prop], _extends__default['default']({}, options, {
	            selector: selector
	          }));
	        }
	      } else if (isNestedConditional) {
	        // Place conditional right after the parent rule to ensure right ordering.
	        container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
	          selector: styleRule.selector
	        });
	      }
	
	      delete style[prop];
	    }
	
	    return style;
	  }
	
	  return {
	    onProcessStyle: onProcessStyle
	  };
	}
	
	exports.default = jssNested;


/***/ },
/* 6750 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Sort props by length.
	 */
	function jssPropsSort() {
	  var sort = function sort(prop0, prop1) {
	    if (prop0.length === prop1.length) {
	      return prop0 > prop1 ? 1 : -1;
	    }
	
	    return prop0.length - prop1.length;
	  };
	
	  return {
	    onProcessStyle: function onProcessStyle(style, rule) {
	      if (rule.type !== 'style') return style;
	      var newStyle = {};
	      var props = Object.keys(style).sort(sort);
	
	      for (var i = 0; i < props.length; i++) {
	        newStyle[props[i]] = style[props[i]];
	      }
	
	      return newStyle;
	    }
	  };
	}
	
	exports.default = jssPropsSort;


/***/ },
/* 6751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var warning = __webpack_require__(108);
	var jss = __webpack_require__(97);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
	
	var now = Date.now();
	var fnValuesNs = "fnValues" + now;
	var fnRuleNs = "fnStyle" + ++now;
	
	var functionPlugin = function functionPlugin() {
	  return {
	    onCreateRule: function onCreateRule(name, decl, options) {
	      if (typeof decl !== 'function') return null;
	      var rule = jss.createRule(name, {}, options);
	      rule[fnRuleNs] = decl;
	      return rule;
	    },
	    onProcessStyle: function onProcessStyle(style, rule) {
	      // We need to extract function values from the declaration, so that we can keep core unaware of them.
	      // We need to do that only once.
	      // We don't need to extract functions on each style update, since this can happen only once.
	      // We don't support function values inside of function rules.
	      if (fnValuesNs in rule || fnRuleNs in rule) return style;
	      var fnValues = {};
	
	      for (var prop in style) {
	        var value = style[prop];
	        if (typeof value !== 'function') continue;
	        delete style[prop];
	        fnValues[prop] = value;
	      }
	
	      rule[fnValuesNs] = fnValues;
	      return style;
	    },
	    onUpdate: function onUpdate(data, rule, sheet, options) {
	      var styleRule = rule;
	      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
	      // will be returned from that function.
	
	      if (fnRule) {
	        // Empty object will remove all currently defined props
	        // in case function rule returns a falsy value.
	        styleRule.style = fnRule(data) || {};
	
	        if (false) {
	          for (var prop in styleRule.style) {
	            if (typeof styleRule.style[prop] === 'function') {
	              process.env.NODE_ENV !== "production" ? warning__default['default'](false, '[JSS] Function values inside function rules are not supported.') : void 0;
	              break;
	            }
	          }
	        }
	      }
	
	      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.
	
	      if (fnValues) {
	        for (var _prop in fnValues) {
	          styleRule.prop(_prop, fnValues[_prop](data), options);
	        }
	      }
	    }
	  };
	};
	
	exports.default = functionPlugin;


/***/ },
/* 6752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var vendor = __webpack_require__(6710);
	var jss = __webpack_require__(97);
	
	/**
	 * Add vendor prefix to a property name when needed.
	 */
	
	function jssVendorPrefixer() {
	  function onProcessRule(rule) {
	    if (rule.type === 'keyframes') {
	      var atRule = rule;
	      atRule.at = vendor.supportedKeyframes(atRule.at);
	    }
	  }
	
	  function prefixStyle(style) {
	    for (var prop in style) {
	      var value = style[prop];
	
	      if (prop === 'fallbacks' && Array.isArray(value)) {
	        style[prop] = value.map(prefixStyle);
	        continue;
	      }
	
	      var changeProp = false;
	      var supportedProp = vendor.supportedProperty(prop);
	      if (supportedProp && supportedProp !== prop) changeProp = true;
	      var changeValue = false;
	      var supportedValue = vendor.supportedValue(supportedProp, jss.toCssValue(value));
	      if (supportedValue && supportedValue !== value) changeValue = true;
	
	      if (changeProp || changeValue) {
	        if (changeProp) delete style[prop];
	        style[supportedProp || prop] = supportedValue || value;
	      }
	    }
	
	    return style;
	  }
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	    return prefixStyle(style);
	  }
	
	  function onChangeValue(value, prop) {
	    return vendor.supportedValue(prop, jss.toCssValue(value)) || value;
	  }
	
	  return {
	    onProcessRule: onProcessRule,
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = jssVendorPrefixer;


/***/ },
/* 6753 */
/***/ function(module, exports) {

	/**
	 * The code was extracted from:
	 * https://github.com/davidchambers/Base64.js
	 */
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function InvalidCharacterError(message) {
	  this.message = message;
	}
	
	InvalidCharacterError.prototype = new Error();
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
	function polyfill (input) {
	  var str = String(input).replace(/=+$/, '');
	  if (str.length % 4 == 1) {
	    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
	  }
	  for (
	    // initialize result and counters
	    var bc = 0, bs, buffer, idx = 0, output = '';
	    // get next character
	    buffer = str.charAt(idx++);
	    // character found in table? initialize bit storage and add its ascii value;
	    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
	      // and if not first of each 4 characters,
	      // convert the first 8 bits to one ascii character
	      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
	  ) {
	    // try to find character in table (0-63, not found => -1)
	    buffer = chars.indexOf(buffer);
	  }
	  return output;
	}
	
	
	module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ },
/* 6754 */
/***/ function(module, exports, __webpack_require__) {

	var atob = __webpack_require__(6753);
	
	function b64DecodeUnicode(str) {
	  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
	    var code = p.charCodeAt(0).toString(16).toUpperCase();
	    if (code.length < 2) {
	      code = '0' + code;
	    }
	    return '%' + code;
	  }));
	}
	
	module.exports = function(str) {
	  var output = str.replace(/-/g, "+").replace(/_/g, "/");
	  switch (output.length % 4) {
	    case 0:
	      break;
	    case 2:
	      output += "==";
	      break;
	    case 3:
	      output += "=";
	      break;
	    default:
	      throw "Illegal base64url string!";
	  }
	
	  try{
	    return b64DecodeUnicode(output);
	  } catch (err) {
	    return atob(output);
	  }
	};


/***/ },
/* 6755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var base64_url_decode = __webpack_require__(6754);
	
	function InvalidTokenError(message) {
	  this.message = message;
	}
	
	InvalidTokenError.prototype = new Error();
	InvalidTokenError.prototype.name = 'InvalidTokenError';
	
	module.exports = function (token,options) {
	  if (typeof token !== 'string') {
	    throw new InvalidTokenError('Invalid token specified');
	  }
	
	  options = options || {};
	  var pos = options.header === true ? 0 : 1;
	  try {
	    return JSON.parse(base64_url_decode(token.split('.')[pos]));
	  } catch (e) {
	    throw new InvalidTokenError('Invalid token specified: ' + e.message);
	  }
	};
	
	module.exports.InvalidTokenError = InvalidTokenError;


/***/ },
/* 6756 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(101),
	    root = __webpack_require__(58);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 6757 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(6836),
	    hashDelete = __webpack_require__(6837),
	    hashGet = __webpack_require__(6838),
	    hashHas = __webpack_require__(6839),
	    hashSet = __webpack_require__(6840);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 6758 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(101),
	    root = __webpack_require__(58);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 6759 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayAggregator;


/***/ },
/* 6760 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.every` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = arrayEvery;


/***/ },
/* 6761 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(468);
	
	/**
	 * Gets the size of an ASCII `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	var asciiSize = baseProperty('length');
	
	module.exports = asciiSize;


/***/ },
/* 6762 */
/***/ function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ },
/* 6763 */
/***/ function(module, exports) {

	/** Used to match words composed of alphanumeric characters. */
	var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	/**
	 * Splits an ASCII `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function asciiWords(string) {
	  return string.match(reAsciiWord) || [];
	}
	
	module.exports = asciiWords;


/***/ },
/* 6764 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(99);
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseAggregator;


/***/ },
/* 6765 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(145),
	    keysIn = __webpack_require__(152);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },
/* 6766 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(99);
	
	/**
	 * The base implementation of `_.every` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`
	 */
	function baseEvery(collection, predicate) {
	  var result = true;
	  baseEach(collection, function(value, index, collection) {
	    result = !!predicate(value, index, collection);
	    return result;
	  });
	  return result;
	}
	
	module.exports = baseEvery;


/***/ },
/* 6767 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(103);
	
	/**
	 * The base implementation of methods like `_.max` and `_.min` which accepts a
	 * `comparator` to determine the extremum value.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The iteratee invoked per iteration.
	 * @param {Function} comparator The comparator used to compare values.
	 * @returns {*} Returns the extremum value.
	 */
	function baseExtremum(array, iteratee, comparator) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index],
	        current = iteratee(value);
	
	    if (current != null && (computed === undefined
	          ? (current === current && !isSymbol(current))
	          : comparator(current, computed)
	        )) {
	      var computed = current,
	          result = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseExtremum;


/***/ },
/* 6768 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(99);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 6769 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  return object != null && hasOwnProperty.call(object, key);
	}
	
	module.exports = baseHas;


/***/ },
/* 6770 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 6771 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * The base implementation of `_.inRange` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to check.
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	 */
	function baseInRange(number, start, end) {
	  return number >= nativeMin(start, end) && number < nativeMax(start, end);
	}
	
	module.exports = baseInRange;


/***/ },
/* 6772 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(179),
	    arrayIncludes = __webpack_require__(182),
	    arrayIncludesWith = __webpack_require__(266),
	    arrayMap = __webpack_require__(81),
	    baseUnary = __webpack_require__(100),
	    cacheHas = __webpack_require__(189);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ },
/* 6773 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(184);
	
	/**
	 * The base implementation of `_.invert` and `_.invertBy` which inverts
	 * `object` with values transformed by `iteratee` and set by `setter`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform values.
	 * @param {Object} accumulator The initial inverted object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseInverter(object, setter, iteratee, accumulator) {
	  baseForOwn(object, function(value, key, object) {
	    setter(accumulator, iteratee(value), key, object);
	  });
	  return accumulator;
	}
	
	module.exports = baseInverter;


/***/ },
/* 6774 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(181),
	    castPath = __webpack_require__(144),
	    last = __webpack_require__(6926),
	    parent = __webpack_require__(6863),
	    toKey = __webpack_require__(102);
	
	/**
	 * The base implementation of `_.invoke` without support for individual
	 * method arguments.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the method to invoke.
	 * @param {Array} args The arguments to invoke the method with.
	 * @returns {*} Returns the result of the invoked method.
	 */
	function baseInvoke(object, path, args) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  var func = object == null ? object : object[toKey(last(path))];
	  return func == null ? undefined : apply(func, object, args);
	}
	
	module.exports = baseInvoke;


/***/ },
/* 6775 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(70),
	    isObjectLike = __webpack_require__(53);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 6776 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(180),
	    equalArrays = __webpack_require__(482),
	    equalByTag = __webpack_require__(6829),
	    equalObjects = __webpack_require__(6830),
	    getTag = __webpack_require__(87),
	    isArray = __webpack_require__(35),
	    isBuffer = __webpack_require__(120),
	    isTypedArray = __webpack_require__(151);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 6777 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(87),
	    isObjectLike = __webpack_require__(53);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ },
/* 6778 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(180),
	    baseIsEqual = __webpack_require__(269);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 6779 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 6780 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(89),
	    isMasked = __webpack_require__(6846),
	    isObject = __webpack_require__(59),
	    toSource = __webpack_require__(502);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 6781 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(70),
	    isObjectLike = __webpack_require__(53);
	
	/** `Object#toString` result references. */
	var regexpTag = '[object RegExp]';
	
	/**
	 * The base implementation of `_.isRegExp` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	 */
	function baseIsRegExp(value) {
	  return isObjectLike(value) && baseGetTag(value) == regexpTag;
	}
	
	module.exports = baseIsRegExp;


/***/ },
/* 6782 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(87),
	    isObjectLike = __webpack_require__(53);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ },
/* 6783 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(70),
	    isLength = __webpack_require__(281),
	    isObjectLike = __webpack_require__(53);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 6784 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(59),
	    isPrototype = __webpack_require__(195),
	    nativeKeysIn = __webpack_require__(6861);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 6785 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.lt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is less than `other`,
	 *  else `false`.
	 */
	function baseLt(value, other) {
	  return value < other;
	}
	
	module.exports = baseLt;


/***/ },
/* 6786 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(6778),
	    getMatchData = __webpack_require__(6831),
	    matchesStrictComparable = __webpack_require__(493);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 6787 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(269),
	    get = __webpack_require__(72),
	    hasIn = __webpack_require__(511),
	    isKey = __webpack_require__(277),
	    isStrictComparable = __webpack_require__(491),
	    matchesStrictComparable = __webpack_require__(493),
	    toKey = __webpack_require__(102);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 6788 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(180),
	    assignMergeValue = __webpack_require__(458),
	    baseFor = __webpack_require__(464),
	    baseMergeDeep = __webpack_require__(6789),
	    isObject = __webpack_require__(59),
	    keysIn = __webpack_require__(152),
	    safeGet = __webpack_require__(497);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ },
/* 6789 */
/***/ function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(458),
	    cloneBuffer = __webpack_require__(475),
	    cloneTypedArray = __webpack_require__(476),
	    copyArray = __webpack_require__(116),
	    initCloneObject = __webpack_require__(489),
	    isArguments = __webpack_require__(148),
	    isArray = __webpack_require__(35),
	    isArrayLikeObject = __webpack_require__(149),
	    isBuffer = __webpack_require__(120),
	    isFunction = __webpack_require__(89),
	    isObject = __webpack_require__(59),
	    isPlainObject = __webpack_require__(150),
	    isTypedArray = __webpack_require__(151),
	    safeGet = __webpack_require__(497),
	    toPlainObject = __webpack_require__(6948);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ },
/* 6790 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(81),
	    baseGet = __webpack_require__(143),
	    baseIteratee = __webpack_require__(62),
	    baseMap = __webpack_require__(466),
	    baseSortBy = __webpack_require__(6798),
	    baseUnary = __webpack_require__(100),
	    compareMultiple = __webpack_require__(6808),
	    identity = __webpack_require__(77),
	    isArray = __webpack_require__(35);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  if (iteratees.length) {
	    iteratees = arrayMap(iteratees, function(iteratee) {
	      if (isArray(iteratee)) {
	        return function(value) {
	          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	        }
	      }
	      return iteratee;
	    });
	  } else {
	    iteratees = [identity];
	  }
	
	  var index = -1;
	  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 6791 */
/***/ function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(467),
	    hasIn = __webpack_require__(511);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, paths) {
	  return basePickBy(object, paths, function(value, path) {
	    return hasIn(object, path);
	  });
	}
	
	module.exports = basePick;


/***/ },
/* 6792 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(143);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 6793 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = basePropertyOf;


/***/ },
/* 6794 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the range of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	module.exports = baseRange;


/***/ },
/* 6795 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ },
/* 6796 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(504),
	    defineProperty = __webpack_require__(481),
	    identity = __webpack_require__(77);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 6797 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(99);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ },
/* 6798 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 6799 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ },
/* 6800 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(81);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ },
/* 6801 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(149);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ },
/* 6802 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(185);
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the last unmatched string symbol.
	 */
	function charsEndIndex(strSymbols, chrSymbols) {
	  var index = strSymbols.length;
	
	  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	module.exports = charsEndIndex;


/***/ },
/* 6803 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(185);
	
	/**
	 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the first unmatched string symbol.
	 */
	function charsStartIndex(strSymbols, chrSymbols) {
	  var index = -1,
	      length = strSymbols.length;
	
	  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	module.exports = charsStartIndex;


/***/ },
/* 6804 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(272);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 6805 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 6806 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(98);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 6807 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(103);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 6808 */
/***/ function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(6807);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 6809 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(145),
	    getSymbols = __webpack_require__(276);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 6810 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(145),
	    getSymbolsIn = __webpack_require__(487);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },
/* 6811 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(58);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 6812 */
/***/ function(module, exports) {

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      ++result;
	    }
	  }
	  return result;
	}
	
	module.exports = countHolders;


/***/ },
/* 6813 */
/***/ function(module, exports, __webpack_require__) {

	var arrayAggregator = __webpack_require__(6759),
	    baseAggregator = __webpack_require__(6764),
	    baseIteratee = __webpack_require__(62),
	    isArray = __webpack_require__(35);
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
	  };
	}
	
	module.exports = createAggregator;


/***/ },
/* 6814 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(86),
	    isIterateeCall = __webpack_require__(117);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 6815 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(73);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 6816 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 6817 */
/***/ function(module, exports, __webpack_require__) {

	var createCtor = __webpack_require__(190),
	    root = __webpack_require__(58);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBind;


/***/ },
/* 6818 */
/***/ function(module, exports, __webpack_require__) {

	var castSlice = __webpack_require__(271),
	    hasUnicode = __webpack_require__(194),
	    stringToArray = __webpack_require__(200),
	    toString = __webpack_require__(78);
	
	/**
	 * Creates a function like `_.lowerFirst`.
	 *
	 * @private
	 * @param {string} methodName The name of the `String` case method to use.
	 * @returns {Function} Returns the new case function.
	 */
	function createCaseFirst(methodName) {
	  return function(string) {
	    string = toString(string);
	
	    var strSymbols = hasUnicode(string)
	      ? stringToArray(string)
	      : undefined;
	
	    var chr = strSymbols
	      ? strSymbols[0]
	      : string.charAt(0);
	
	    var trailing = strSymbols
	      ? castSlice(strSymbols, 1).join('')
	      : string.slice(1);
	
	    return chr[methodName]() + trailing;
	  };
	}
	
	module.exports = createCaseFirst;


/***/ },
/* 6819 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(456),
	    deburr = __webpack_require__(505),
	    words = __webpack_require__(6953);
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]";
	
	/** Used to match apostrophes. */
	var reApos = RegExp(rsApos, 'g');
	
	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	  };
	}
	
	module.exports = createCompounder;


/***/ },
/* 6820 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(181),
	    createCtor = __webpack_require__(190),
	    createHybrid = __webpack_require__(479),
	    createRecurry = __webpack_require__(480),
	    getHolder = __webpack_require__(275),
	    replaceHolders = __webpack_require__(198),
	    root = __webpack_require__(58);
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createCurry;


/***/ },
/* 6821 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(62),
	    isArrayLike = __webpack_require__(73),
	    keys = __webpack_require__(63);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 6822 */
/***/ function(module, exports, __webpack_require__) {

	var LodashWrapper = __webpack_require__(263),
	    flatRest = __webpack_require__(273),
	    getData = __webpack_require__(274),
	    getFuncName = __webpack_require__(486),
	    isArray = __webpack_require__(35),
	    isLaziable = __webpack_require__(490);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/**
	 * Creates a `_.flow` or `_.flowRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new flow function.
	 */
	function createFlow(fromRight) {
	  return flatRest(function(funcs) {
	    var length = funcs.length,
	        index = length,
	        prereq = LodashWrapper.prototype.thru;
	
	    if (fromRight) {
	      funcs.reverse();
	    }
	    while (index--) {
	      var func = funcs[index];
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	        var wrapper = new LodashWrapper([], true);
	      }
	    }
	    index = wrapper ? index : length;
	    while (++index < length) {
	      func = funcs[index];
	
	      var funcName = getFuncName(func),
	          data = funcName == 'wrapper' ? getData(func) : undefined;
	
	      if (data && isLaziable(data[0]) &&
	            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	            !data[4].length && data[9] == 1
	          ) {
	        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	      } else {
	        wrapper = (func.length == 1 && isLaziable(func))
	          ? wrapper[funcName]()
	          : wrapper.thru(func);
	      }
	    }
	    return function() {
	      var args = arguments,
	          value = args[0];
	
	      if (wrapper && args.length == 1 && isArray(value)) {
	        return wrapper.plant(value).value();
	      }
	      var index = 0,
	          result = length ? funcs[index].apply(this, args) : value;
	
	      while (++index < length) {
	        result = funcs[index].call(this, result);
	      }
	      return result;
	    };
	  });
	}
	
	module.exports = createFlow;


/***/ },
/* 6823 */
/***/ function(module, exports, __webpack_require__) {

	var baseInverter = __webpack_require__(6773);
	
	/**
	 * Creates a function like `_.invertBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} toIteratee The function to resolve iteratees.
	 * @returns {Function} Returns the new inverter function.
	 */
	function createInverter(setter, toIteratee) {
	  return function(object, iteratee) {
	    return baseInverter(object, setter, toIteratee(iteratee), {});
	  };
	}
	
	module.exports = createInverter;


/***/ },
/* 6824 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(181),
	    createCtor = __webpack_require__(190),
	    root = __webpack_require__(58);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartial;


/***/ },
/* 6825 */
/***/ function(module, exports, __webpack_require__) {

	var baseRange = __webpack_require__(6794),
	    isIterateeCall = __webpack_require__(117),
	    toFinite = __webpack_require__(285);
	
	/**
	 * Creates a `_.range` or `_.rangeRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new range function.
	 */
	function createRange(fromRight) {
	  return function(start, end, step) {
	    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	      end = step = undefined;
	    }
	    // Ensure the sign of `-0` is preserved.
	    start = toFinite(start);
	    if (end === undefined) {
	      end = start;
	      start = 0;
	    } else {
	      end = toFinite(end);
	    }
	    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	    return baseRange(start, end, step, fromRight);
	  };
	}
	
	module.exports = createRange;


/***/ },
/* 6826 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(58),
	    toInteger = __webpack_require__(82),
	    toNumber = __webpack_require__(207),
	    toString = __webpack_require__(78);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsFinite = root.isFinite,
	    nativeMin = Math.min;
	
	/**
	 * Creates a function like `_.round`.
	 *
	 * @private
	 * @param {string} methodName The name of the `Math` method to use when rounding.
	 * @returns {Function} Returns the new round function.
	 */
	function createRound(methodName) {
	  var func = Math[methodName];
	  return function(number, precision) {
	    number = toNumber(number);
	    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	    if (precision && nativeIsFinite(number)) {
	      // Shift with exponential notation to avoid floating-point issues.
	      // See [MDN](https://mdn.io/round#Examples) for more details.
	      var pair = (toString(number) + 'e').split('e'),
	          value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	      pair = (toString(value) + 'e').split('e');
	      return +(pair[0] + 'e' + (+pair[1] - precision));
	    }
	    return func(number);
	  };
	}
	
	module.exports = createRound;


/***/ },
/* 6827 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(451),
	    noop = __webpack_require__(283),
	    setToArray = __webpack_require__(199);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ },
/* 6828 */
/***/ function(module, exports, __webpack_require__) {

	var basePropertyOf = __webpack_require__(6793);
	
	/** Used to map Latin Unicode letters to basic Latin letters. */
	var deburredLetters = {
	  // Latin-1 Supplement block.
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss',
	  // Latin Extended-A block.
	  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	  '\u0134': 'J',  '\u0135': 'j',
	  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	  '\u0174': 'W',  '\u0175': 'w',
	  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	  '\u0132': 'IJ', '\u0133': 'ij',
	  '\u0152': 'Oe', '\u0153': 'oe',
	  '\u0149': "'n", '\u017f': 's'
	};
	
	/**
	 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	 * letters to basic Latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	var deburrLetter = basePropertyOf(deburredLetters);
	
	module.exports = deburrLetter;


/***/ },
/* 6829 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(98),
	    Uint8Array = __webpack_require__(452),
	    eq = __webpack_require__(147),
	    equalArrays = __webpack_require__(482),
	    mapToArray = __webpack_require__(492),
	    setToArray = __webpack_require__(199);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 6830 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(484);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 6831 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(491),
	    keys = __webpack_require__(63);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 6832 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(98);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 6833 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 6834 */
/***/ function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;
	
	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}
	
	module.exports = getWrapDetails;


/***/ },
/* 6835 */
/***/ function(module, exports) {

	/** Used to detect strings that need a more robust regexp to match words. */
	var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	/**
	 * Checks if `string` contains a word composed of Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a word is found, else `false`.
	 */
	function hasUnicodeWord(string) {
	  return reHasUnicodeWord.test(string);
	}
	
	module.exports = hasUnicodeWord;


/***/ },
/* 6836 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(196);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 6837 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 6838 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(196);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 6839 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(196);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 6840 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(196);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 6841 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 6842 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(272),
	    cloneDataView = __webpack_require__(6804),
	    cloneRegExp = __webpack_require__(6805),
	    cloneSymbol = __webpack_require__(6806),
	    cloneTypedArray = __webpack_require__(476);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 6843 */
/***/ function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
	
	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length;
	  if (!length) {
	    return source;
	  }
	  var lastIndex = length - 1;
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}
	
	module.exports = insertWrapDetails;


/***/ },
/* 6844 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(98),
	    isArguments = __webpack_require__(148),
	    isArray = __webpack_require__(35);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 6845 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 6846 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(6811);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 6847 */
/***/ function(module, exports) {

	/**
	 * Converts `iterator` to an array.
	 *
	 * @private
	 * @param {Object} iterator The iterator to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function iteratorToArray(iterator) {
	  var data,
	      result = [];
	
	  while (!(data = iterator.next()).done) {
	    result.push(data.value);
	  }
	  return result;
	}
	
	module.exports = iteratorToArray;


/***/ },
/* 6848 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 6849 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(183);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 6850 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(183);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 6851 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(183);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 6852 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(183);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 6853 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(6757),
	    ListCache = __webpack_require__(178),
	    Map = __webpack_require__(264);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 6854 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(192);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 6855 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(192);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 6856 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(192);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 6857 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(192);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 6858 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(282);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 6859 */
/***/ function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(477),
	    composeArgsRight = __webpack_require__(478),
	    replaceHolders = __webpack_require__(198);
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and
	 * `_.rearg` modify function arguments, making the order in which they are
	 * executed important, preventing the merging of metadata. However, we make
	 * an exception for a safe combined case where curried functions have `_.ary`
	 * and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	  var isCombo =
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & WRAP_BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = value;
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & WRAP_ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ },
/* 6860 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(495);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 6861 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 6862 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 6863 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(143),
	    baseSlice = __webpack_require__(187);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ },
/* 6864 */
/***/ function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ },
/* 6865 */
/***/ function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(116),
	    isIndex = __webpack_require__(146);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ },
/* 6866 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 6867 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 6868 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(178);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 6869 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 6870 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 6871 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 6872 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(178),
	    Map = __webpack_require__(264),
	    MapCache = __webpack_require__(265);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 6873 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 6874 */
/***/ function(module, exports, __webpack_require__) {

	var asciiSize = __webpack_require__(6761),
	    hasUnicode = __webpack_require__(194),
	    unicodeSize = __webpack_require__(6876);
	
	/**
	 * Gets the number of symbols in `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the string size.
	 */
	function stringSize(string) {
	  return hasUnicode(string)
	    ? unicodeSize(string)
	    : asciiSize(string);
	}
	
	module.exports = stringSize;


/***/ },
/* 6875 */
/***/ function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ },
/* 6876 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Gets the size of a Unicode `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	function unicodeSize(string) {
	  var result = reUnicode.lastIndex = 0;
	  while (reUnicode.test(string)) {
	    ++result;
	  }
	  return result;
	}
	
	module.exports = unicodeSize;


/***/ },
/* 6877 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ },
/* 6878 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsPunctuationRange = '\\u2000-\\u206f',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]",
	    rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;
	
	/** Used to match complex or compound words. */
	var reUnicodeWord = RegExp([
	  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	  rsUpper + '+' + rsOptContrUpper,
	  rsOrdUpper,
	  rsOrdLower,
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');
	
	/**
	 * Splits a Unicode `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function unicodeWords(string) {
	  return string.match(reUnicodeWord) || [];
	}
	
	module.exports = unicodeWords;


/***/ },
/* 6879 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(139),
	    arrayIncludes = __webpack_require__(182);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256,
	    WRAP_FLIP_FLAG = 512;
	
	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', WRAP_ARY_FLAG],
	  ['bind', WRAP_BIND_FLAG],
	  ['bindKey', WRAP_BIND_KEY_FLAG],
	  ['curry', WRAP_CURRY_FLAG],
	  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	  ['flip', WRAP_FLIP_FLAG],
	  ['partial', WRAP_PARTIAL_FLAG],
	  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	  ['rearg', WRAP_REARG_FLAG]
	];
	
	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}
	
	module.exports = updateWrapDetails;


/***/ },
/* 6880 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(262),
	    LodashWrapper = __webpack_require__(263),
	    copyArray = __webpack_require__(116);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ },
/* 6881 */
/***/ function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(191);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_ARY_FLAG = 128;
	
	/**
	 * Creates a function that invokes `func`, with up to `n` arguments,
	 * ignoring any additional arguments.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} [n=func.length] The arity cap.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new capped function.
	 * @example
	 *
	 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	 * // => [6, 8, 10]
	 */
	function ary(func, n, guard) {
	  n = guard ? undefined : n;
	  n = (func && n == null) ? func.length : n;
	  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	}
	
	module.exports = ary;


/***/ },
/* 6882 */
/***/ function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(460),
	    toNumber = __webpack_require__(207);
	
	/**
	 * Clamps `number` within the inclusive `lower` and `upper` bounds.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Number
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 * @example
	 *
	 * _.clamp(-10, -5, 5);
	 * // => -5
	 *
	 * _.clamp(10, -5, 5);
	 * // => 5
	 */
	function clamp(number, lower, upper) {
	  if (upper === undefined) {
	    upper = lower;
	    lower = undefined;
	  }
	  if (upper !== undefined) {
	    upper = toNumber(upper);
	    upper = upper === upper ? upper : 0;
	  }
	  if (lower !== undefined) {
	    lower = toNumber(lower);
	    lower = lower === lower ? lower : 0;
	  }
	  return baseClamp(toNumber(number), lower, upper);
	}
	
	module.exports = clamp;


/***/ },
/* 6883 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(461);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * Creates a shallow clone of `value`.
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	 * and supports cloning arrays, array buffers, booleans, date objects, maps,
	 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	 * arrays. The own enumerable properties of `arguments` objects are cloned
	 * as plain objects. An empty object is returned for uncloneable values such
	 * as error objects, functions, DOM nodes, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @returns {*} Returns the cloned value.
	 * @see _.cloneDeep
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var shallow = _.clone(objects);
	 * console.log(shallow[0] === objects[0]);
	 * // => true
	 */
	function clone(value) {
	  return baseClone(value, CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = clone;


/***/ },
/* 6884 */
/***/ function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(191);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_CURRY_FLAG = 8;
	
	/**
	 * Creates a function that accepts arguments of `func` and either invokes
	 * `func` returning its result, if at least `arity` number of arguments have
	 * been provided, or returns a function that accepts the remaining `func`
	 * arguments, and so on. The arity of `func` may be specified if `func.length`
	 * is not sufficient.
	 *
	 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for provided arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of curried functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Function
	 * @param {Function} func The function to curry.
	 * @param {number} [arity=func.length] The arity of `func`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new curried function.
	 * @example
	 *
	 * var abc = function(a, b, c) {
	 *   return [a, b, c];
	 * };
	 *
	 * var curried = _.curry(abc);
	 *
	 * curried(1)(2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2, 3);
	 * // => [1, 2, 3]
	 *
	 * // Curried with placeholders.
	 * curried(1)(_, 3)(2);
	 * // => [1, 2, 3]
	 */
	function curry(func, arity, guard) {
	  arity = guard ? undefined : arity;
	  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	  result.placeholder = curry.placeholder;
	  return result;
	}
	
	// Assign default placeholders.
	curry.placeholder = {};
	
	module.exports = curry;


/***/ },
/* 6885 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(187),
	    toInteger = __webpack_require__(82);
	
	/**
	 * Creates a slice of `array` with `n` elements dropped from the end.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to drop.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.dropRight([1, 2, 3]);
	 * // => [1, 2]
	 *
	 * _.dropRight([1, 2, 3], 2);
	 * // => [1]
	 *
	 * _.dropRight([1, 2, 3], 5);
	 * // => []
	 *
	 * _.dropRight([1, 2, 3], 0);
	 * // => [1, 2, 3]
	 */
	function dropRight(array, n, guard) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  n = length - n;
	  return baseSlice(array, 0, n < 0 ? 0 : n);
	}
	
	module.exports = dropRight;


/***/ },
/* 6886 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(78);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	    reHasRegExpChar = RegExp(reRegExpChar.source);
	
	/**
	 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to escape.
	 * @returns {string} Returns the escaped string.
	 * @example
	 *
	 * _.escapeRegExp('[lodash](https://lodash.com/)');
	 * // => '\[lodash\]\(https://lodash\.com/\)'
	 */
	function escapeRegExp(string) {
	  string = toString(string);
	  return (string && reHasRegExpChar.test(string))
	    ? string.replace(reRegExpChar, '\\$&')
	    : string;
	}
	
	module.exports = escapeRegExp;


/***/ },
/* 6887 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEvery = __webpack_require__(6760),
	    baseEvery = __webpack_require__(6766),
	    baseIteratee = __webpack_require__(62),
	    isArray = __webpack_require__(35),
	    isIterateeCall = __webpack_require__(117);
	
	/**
	 * Checks if `predicate` returns truthy for **all** elements of `collection`.
	 * Iteration is stopped once `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * **Note:** This method returns `true` for
	 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	 * elements of empty collections.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.every([true, 1, null, 'yes'], Boolean);
	 * // => false
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.every(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.every(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.every(users, 'active');
	 * // => false
	 */
	function every(collection, predicate, guard) {
	  var func = isArray(collection) ? arrayEvery : baseEvery;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = every;


/***/ },
/* 6888 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(6915);


/***/ },
/* 6889 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(142),
	    map = __webpack_require__(41);
	
	/**
	 * Creates a flattened array of values by running each element in `collection`
	 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	 * with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * function duplicate(n) {
	 *   return [n, n];
	 * }
	 *
	 * _.flatMap([1, 2], duplicate);
	 * // => [1, 1, 2, 2]
	 */
	function flatMap(collection, iteratee) {
	  return baseFlatten(map(collection, iteratee), 1);
	}
	
	module.exports = flatMap;


/***/ },
/* 6890 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(142);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 6891 */
/***/ function(module, exports, __webpack_require__) {

	var createFlow = __webpack_require__(6822);
	
	/**
	 * Creates a function that returns the result of invoking the given functions
	 * with the `this` binding of the created function, where each successive
	 * invocation is supplied the return value of the previous.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Util
	 * @param {...(Function|Function[])} [funcs] The functions to invoke.
	 * @returns {Function} Returns the new composite function.
	 * @see _.flowRight
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var addSquare = _.flow([_.add, square]);
	 * addSquare(1, 2);
	 * // => 9
	 */
	var flow = createFlow();
	
	module.exports = flow;


/***/ },
/* 6892 */
/***/ function(module, exports, __webpack_require__) {

	var mapping = __webpack_require__(6893),
	    fallbackHolder = __webpack_require__(38);
	
	/** Built-in value reference. */
	var push = Array.prototype.push;
	
	/**
	 * Creates a function, with an arity of `n`, that invokes `func` with the
	 * arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} n The arity of the new function.
	 * @returns {Function} Returns the new function.
	 */
	function baseArity(func, n) {
	  return n == 2
	    ? function(a, b) { return func.apply(undefined, arguments); }
	    : function(a) { return func.apply(undefined, arguments); };
	}
	
	/**
	 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
	 * any additional arguments.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} n The arity cap.
	 * @returns {Function} Returns the new function.
	 */
	function baseAry(func, n) {
	  return n == 2
	    ? function(a, b) { return func(a, b); }
	    : function(a) { return func(a); };
	}
	
	/**
	 * Creates a clone of `array`.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the cloned array.
	 */
	function cloneArray(array) {
	  var length = array ? array.length : 0,
	      result = Array(length);
	
	  while (length--) {
	    result[length] = array[length];
	  }
	  return result;
	}
	
	/**
	 * Creates a function that clones a given object using the assignment `func`.
	 *
	 * @private
	 * @param {Function} func The assignment function.
	 * @returns {Function} Returns the new cloner function.
	 */
	function createCloner(func) {
	  return function(object) {
	    return func({}, object);
	  };
	}
	
	/**
	 * A specialized version of `_.spread` which flattens the spread array into
	 * the arguments of the invoked `func`.
	 *
	 * @private
	 * @param {Function} func The function to spread arguments over.
	 * @param {number} start The start position of the spread.
	 * @returns {Function} Returns the new function.
	 */
	function flatSpread(func, start) {
	  return function() {
	    var length = arguments.length,
	        lastIndex = length - 1,
	        args = Array(length);
	
	    while (length--) {
	      args[length] = arguments[length];
	    }
	    var array = args[start],
	        otherArgs = args.slice(0, start);
	
	    if (array) {
	      push.apply(otherArgs, array);
	    }
	    if (start != lastIndex) {
	      push.apply(otherArgs, args.slice(start + 1));
	    }
	    return func.apply(this, otherArgs);
	  };
	}
	
	/**
	 * Creates a function that wraps `func` and uses `cloner` to clone the first
	 * argument it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} cloner The function to clone arguments.
	 * @returns {Function} Returns the new immutable function.
	 */
	function wrapImmutable(func, cloner) {
	  return function() {
	    var length = arguments.length;
	    if (!length) {
	      return;
	    }
	    var args = Array(length);
	    while (length--) {
	      args[length] = arguments[length];
	    }
	    var result = args[0] = cloner.apply(undefined, args);
	    func.apply(undefined, args);
	    return result;
	  };
	}
	
	/**
	 * The base implementation of `convert` which accepts a `util` object of methods
	 * required to perform conversions.
	 *
	 * @param {Object} util The util object.
	 * @param {string} name The name of the function to convert.
	 * @param {Function} func The function to convert.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
	 * @param {boolean} [options.curry=true] Specify currying.
	 * @param {boolean} [options.fixed=true] Specify fixed arity.
	 * @param {boolean} [options.immutable=true] Specify immutable operations.
	 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
	 * @returns {Function|Object} Returns the converted function or object.
	 */
	function baseConvert(util, name, func, options) {
	  var isLib = typeof name == 'function',
	      isObj = name === Object(name);
	
	  if (isObj) {
	    options = func;
	    func = name;
	    name = undefined;
	  }
	  if (func == null) {
	    throw new TypeError;
	  }
	  options || (options = {});
	
	  var config = {
	    'cap': 'cap' in options ? options.cap : true,
	    'curry': 'curry' in options ? options.curry : true,
	    'fixed': 'fixed' in options ? options.fixed : true,
	    'immutable': 'immutable' in options ? options.immutable : true,
	    'rearg': 'rearg' in options ? options.rearg : true
	  };
	
	  var defaultHolder = isLib ? func : fallbackHolder,
	      forceCurry = ('curry' in options) && options.curry,
	      forceFixed = ('fixed' in options) && options.fixed,
	      forceRearg = ('rearg' in options) && options.rearg,
	      pristine = isLib ? func.runInContext() : undefined;
	
	  var helpers = isLib ? func : {
	    'ary': util.ary,
	    'assign': util.assign,
	    'clone': util.clone,
	    'curry': util.curry,
	    'forEach': util.forEach,
	    'isArray': util.isArray,
	    'isError': util.isError,
	    'isFunction': util.isFunction,
	    'isWeakMap': util.isWeakMap,
	    'iteratee': util.iteratee,
	    'keys': util.keys,
	    'rearg': util.rearg,
	    'toInteger': util.toInteger,
	    'toPath': util.toPath
	  };
	
	  var ary = helpers.ary,
	      assign = helpers.assign,
	      clone = helpers.clone,
	      curry = helpers.curry,
	      each = helpers.forEach,
	      isArray = helpers.isArray,
	      isError = helpers.isError,
	      isFunction = helpers.isFunction,
	      isWeakMap = helpers.isWeakMap,
	      keys = helpers.keys,
	      rearg = helpers.rearg,
	      toInteger = helpers.toInteger,
	      toPath = helpers.toPath;
	
	  var aryMethodKeys = keys(mapping.aryMethod);
	
	  var wrappers = {
	    'castArray': function(castArray) {
	      return function() {
	        var value = arguments[0];
	        return isArray(value)
	          ? castArray(cloneArray(value))
	          : castArray.apply(undefined, arguments);
	      };
	    },
	    'iteratee': function(iteratee) {
	      return function() {
	        var func = arguments[0],
	            arity = arguments[1],
	            result = iteratee(func, arity),
	            length = result.length;
	
	        if (config.cap && typeof arity == 'number') {
	          arity = arity > 2 ? (arity - 2) : 1;
	          return (length && length <= arity) ? result : baseAry(result, arity);
	        }
	        return result;
	      };
	    },
	    'mixin': function(mixin) {
	      return function(source) {
	        var func = this;
	        if (!isFunction(func)) {
	          return mixin(func, Object(source));
	        }
	        var pairs = [];
	        each(keys(source), function(key) {
	          if (isFunction(source[key])) {
	            pairs.push([key, func.prototype[key]]);
	          }
	        });
	
	        mixin(func, Object(source));
	
	        each(pairs, function(pair) {
	          var value = pair[1];
	          if (isFunction(value)) {
	            func.prototype[pair[0]] = value;
	          } else {
	            delete func.prototype[pair[0]];
	          }
	        });
	        return func;
	      };
	    },
	    'nthArg': function(nthArg) {
	      return function(n) {
	        var arity = n < 0 ? 1 : (toInteger(n) + 1);
	        return curry(nthArg(n), arity);
	      };
	    },
	    'rearg': function(rearg) {
	      return function(func, indexes) {
	        var arity = indexes ? indexes.length : 0;
	        return curry(rearg(func, indexes), arity);
	      };
	    },
	    'runInContext': function(runInContext) {
	      return function(context) {
	        return baseConvert(util, runInContext(context), options);
	      };
	    }
	  };
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Casts `func` to a function with an arity capped iteratee if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @returns {Function} Returns the cast function.
	   */
	  function castCap(name, func) {
	    if (config.cap) {
	      var indexes = mapping.iterateeRearg[name];
	      if (indexes) {
	        return iterateeRearg(func, indexes);
	      }
	      var n = !isLib && mapping.iterateeAry[name];
	      if (n) {
	        return iterateeAry(func, n);
	      }
	    }
	    return func;
	  }
	
	  /**
	   * Casts `func` to a curried function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity of `func`.
	   * @returns {Function} Returns the cast function.
	   */
	  function castCurry(name, func, n) {
	    return (forceCurry || (config.curry && n > 1))
	      ? curry(func, n)
	      : func;
	  }
	
	  /**
	   * Casts `func` to a fixed arity function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the cast function.
	   */
	  function castFixed(name, func, n) {
	    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
	      var data = mapping.methodSpread[name],
	          start = data && data.start;
	
	      return start  === undefined ? ary(func, n) : flatSpread(func, start);
	    }
	    return func;
	  }
	
	  /**
	   * Casts `func` to an rearged function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity of `func`.
	   * @returns {Function} Returns the cast function.
	   */
	  function castRearg(name, func, n) {
	    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
	      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
	      : func;
	  }
	
	  /**
	   * Creates a clone of `object` by `path`.
	   *
	   * @private
	   * @param {Object} object The object to clone.
	   * @param {Array|string} path The path to clone by.
	   * @returns {Object} Returns the cloned object.
	   */
	  function cloneByPath(object, path) {
	    path = toPath(path);
	
	    var index = -1,
	        length = path.length,
	        lastIndex = length - 1,
	        result = clone(Object(object)),
	        nested = result;
	
	    while (nested != null && ++index < length) {
	      var key = path[index],
	          value = nested[key];
	
	      if (value != null &&
	          !(isFunction(value) || isError(value) || isWeakMap(value))) {
	        nested[key] = clone(index == lastIndex ? value : Object(value));
	      }
	      nested = nested[key];
	    }
	    return result;
	  }
	
	  /**
	   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
	   * version with conversion `options` applied.
	   *
	   * @param {Object} [options] The options object. See `baseConvert` for more details.
	   * @returns {Function} Returns the converted `lodash`.
	   */
	  function convertLib(options) {
	    return _.runInContext.convert(options)(undefined);
	  }
	
	  /**
	   * Create a converter function for `func` of `name`.
	   *
	   * @param {string} name The name of the function to convert.
	   * @param {Function} func The function to convert.
	   * @returns {Function} Returns the new converter function.
	   */
	  function createConverter(name, func) {
	    var realName = mapping.aliasToReal[name] || name,
	        methodName = mapping.remap[realName] || realName,
	        oldOptions = options;
	
	    return function(options) {
	      var newUtil = isLib ? pristine : helpers,
	          newFunc = isLib ? pristine[methodName] : func,
	          newOptions = assign(assign({}, oldOptions), options);
	
	      return baseConvert(newUtil, realName, newFunc, newOptions);
	    };
	  }
	
	  /**
	   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
	   * arguments, ignoring any additional arguments.
	   *
	   * @private
	   * @param {Function} func The function to cap iteratee arguments for.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeAry(func, n) {
	    return overArg(func, function(func) {
	      return typeof func == 'function' ? baseAry(func, n) : func;
	    });
	  }
	
	  /**
	   * Creates a function that wraps `func` to invoke its iteratee with arguments
	   * arranged according to the specified `indexes` where the argument value at
	   * the first index is provided as the first argument, the argument value at
	   * the second index is provided as the second argument, and so on.
	   *
	   * @private
	   * @param {Function} func The function to rearrange iteratee arguments for.
	   * @param {number[]} indexes The arranged argument indexes.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeRearg(func, indexes) {
	    return overArg(func, function(func) {
	      var n = indexes.length;
	      return baseArity(rearg(baseAry(func, n), indexes), n);
	    });
	  }
	
	  /**
	   * Creates a function that invokes `func` with its first argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function() {
	      var length = arguments.length;
	      if (!length) {
	        return func();
	      }
	      var args = Array(length);
	      while (length--) {
	        args[length] = arguments[length];
	      }
	      var index = config.rearg ? 0 : (length - 1);
	      args[index] = transform(args[index]);
	      return func.apply(undefined, args);
	    };
	  }
	
	  /**
	   * Creates a function that wraps `func` and applys the conversions
	   * rules by `name`.
	   *
	   * @private
	   * @param {string} name The name of the function to wrap.
	   * @param {Function} func The function to wrap.
	   * @returns {Function} Returns the converted function.
	   */
	  function wrap(name, func, placeholder) {
	    var result,
	        realName = mapping.aliasToReal[name] || name,
	        wrapped = func,
	        wrapper = wrappers[realName];
	
	    if (wrapper) {
	      wrapped = wrapper(func);
	    }
	    else if (config.immutable) {
	      if (mapping.mutate.array[realName]) {
	        wrapped = wrapImmutable(func, cloneArray);
	      }
	      else if (mapping.mutate.object[realName]) {
	        wrapped = wrapImmutable(func, createCloner(func));
	      }
	      else if (mapping.mutate.set[realName]) {
	        wrapped = wrapImmutable(func, cloneByPath);
	      }
	    }
	    each(aryMethodKeys, function(aryKey) {
	      each(mapping.aryMethod[aryKey], function(otherName) {
	        if (realName == otherName) {
	          var data = mapping.methodSpread[realName],
	              afterRearg = data && data.afterRearg;
	
	          result = afterRearg
	            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
	            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
	
	          result = castCap(realName, result);
	          result = castCurry(realName, result, aryKey);
	          return false;
	        }
	      });
	      return !result;
	    });
	
	    result || (result = wrapped);
	    if (result == func) {
	      result = forceCurry ? curry(result, 1) : function() {
	        return func.apply(this, arguments);
	      };
	    }
	    result.convert = createConverter(realName, func);
	    result.placeholder = func.placeholder = placeholder;
	
	    return result;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  if (!isObj) {
	    return wrap(name, func, defaultHolder);
	  }
	  var _ = func;
	
	  // Convert methods by ary cap.
	  var pairs = [];
	  each(aryMethodKeys, function(aryKey) {
	    each(mapping.aryMethod[aryKey], function(key) {
	      var func = _[mapping.remap[key] || key];
	      if (func) {
	        pairs.push([key, wrap(key, func, _)]);
	      }
	    });
	  });
	
	  // Convert remaining methods.
	  each(keys(_), function(key) {
	    var func = _[key];
	    if (typeof func == 'function') {
	      var length = pairs.length;
	      while (length--) {
	        if (pairs[length][0] == key) {
	          return;
	        }
	      }
	      func.convert = createConverter(key, func);
	      pairs.push([key, func]);
	    }
	  });
	
	  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
	  each(pairs, function(pair) {
	    _[pair[0]] = pair[1];
	  });
	
	  _.convert = convertLib;
	  _.placeholder = _;
	
	  // Assign aliases.
	  each(keys(_), function(key) {
	    each(mapping.realToAlias[key] || [], function(alias) {
	      _[alias] = _[key];
	    });
	  });
	
	  return _;
	}
	
	module.exports = baseConvert;


/***/ },
/* 6893 */
/***/ function(module, exports) {

	/** Used to map aliases to their real names. */
	exports.aliasToReal = {
	
	  // Lodash aliases.
	  'each': 'forEach',
	  'eachRight': 'forEachRight',
	  'entries': 'toPairs',
	  'entriesIn': 'toPairsIn',
	  'extend': 'assignIn',
	  'extendAll': 'assignInAll',
	  'extendAllWith': 'assignInAllWith',
	  'extendWith': 'assignInWith',
	  'first': 'head',
	
	  // Methods that are curried variants of others.
	  'conforms': 'conformsTo',
	  'matches': 'isMatch',
	  'property': 'get',
	
	  // Ramda aliases.
	  '__': 'placeholder',
	  'F': 'stubFalse',
	  'T': 'stubTrue',
	  'all': 'every',
	  'allPass': 'overEvery',
	  'always': 'constant',
	  'any': 'some',
	  'anyPass': 'overSome',
	  'apply': 'spread',
	  'assoc': 'set',
	  'assocPath': 'set',
	  'complement': 'negate',
	  'compose': 'flowRight',
	  'contains': 'includes',
	  'dissoc': 'unset',
	  'dissocPath': 'unset',
	  'dropLast': 'dropRight',
	  'dropLastWhile': 'dropRightWhile',
	  'equals': 'isEqual',
	  'identical': 'eq',
	  'indexBy': 'keyBy',
	  'init': 'initial',
	  'invertObj': 'invert',
	  'juxt': 'over',
	  'omitAll': 'omit',
	  'nAry': 'ary',
	  'path': 'get',
	  'pathEq': 'matchesProperty',
	  'pathOr': 'getOr',
	  'paths': 'at',
	  'pickAll': 'pick',
	  'pipe': 'flow',
	  'pluck': 'map',
	  'prop': 'get',
	  'propEq': 'matchesProperty',
	  'propOr': 'getOr',
	  'props': 'at',
	  'symmetricDifference': 'xor',
	  'symmetricDifferenceBy': 'xorBy',
	  'symmetricDifferenceWith': 'xorWith',
	  'takeLast': 'takeRight',
	  'takeLastWhile': 'takeRightWhile',
	  'unapply': 'rest',
	  'unnest': 'flatten',
	  'useWith': 'overArgs',
	  'where': 'conformsTo',
	  'whereEq': 'isMatch',
	  'zipObj': 'zipObject'
	};
	
	/** Used to map ary to method names. */
	exports.aryMethod = {
	  '1': [
	    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
	    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
	    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
	    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
	    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
	    'uniqueId', 'words', 'zipAll'
	  ],
	  '2': [
	    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
	    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
	    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
	    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
	    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
	    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
	    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
	    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
	    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
	    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
	    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
	    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
	    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
	    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
	    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
	    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
	    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
	    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
	    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
	    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
	    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
	    'zipObjectDeep'
	  ],
	  '3': [
	    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
	    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
	    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
	    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
	    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
	    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
	    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
	    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
	    'xorWith', 'zipWith'
	  ],
	  '4': [
	    'fill', 'setWith', 'updateWith'
	  ]
	};
	
	/** Used to map ary to rearg configs. */
	exports.aryRearg = {
	  '2': [1, 0],
	  '3': [2, 0, 1],
	  '4': [3, 2, 0, 1]
	};
	
	/** Used to map method names to their iteratee ary. */
	exports.iterateeAry = {
	  'dropRightWhile': 1,
	  'dropWhile': 1,
	  'every': 1,
	  'filter': 1,
	  'find': 1,
	  'findFrom': 1,
	  'findIndex': 1,
	  'findIndexFrom': 1,
	  'findKey': 1,
	  'findLast': 1,
	  'findLastFrom': 1,
	  'findLastIndex': 1,
	  'findLastIndexFrom': 1,
	  'findLastKey': 1,
	  'flatMap': 1,
	  'flatMapDeep': 1,
	  'flatMapDepth': 1,
	  'forEach': 1,
	  'forEachRight': 1,
	  'forIn': 1,
	  'forInRight': 1,
	  'forOwn': 1,
	  'forOwnRight': 1,
	  'map': 1,
	  'mapKeys': 1,
	  'mapValues': 1,
	  'partition': 1,
	  'reduce': 2,
	  'reduceRight': 2,
	  'reject': 1,
	  'remove': 1,
	  'some': 1,
	  'takeRightWhile': 1,
	  'takeWhile': 1,
	  'times': 1,
	  'transform': 2
	};
	
	/** Used to map method names to iteratee rearg configs. */
	exports.iterateeRearg = {
	  'mapKeys': [1],
	  'reduceRight': [1, 0]
	};
	
	/** Used to map method names to rearg configs. */
	exports.methodRearg = {
	  'assignInAllWith': [1, 0],
	  'assignInWith': [1, 2, 0],
	  'assignAllWith': [1, 0],
	  'assignWith': [1, 2, 0],
	  'differenceBy': [1, 2, 0],
	  'differenceWith': [1, 2, 0],
	  'getOr': [2, 1, 0],
	  'intersectionBy': [1, 2, 0],
	  'intersectionWith': [1, 2, 0],
	  'isEqualWith': [1, 2, 0],
	  'isMatchWith': [2, 1, 0],
	  'mergeAllWith': [1, 0],
	  'mergeWith': [1, 2, 0],
	  'padChars': [2, 1, 0],
	  'padCharsEnd': [2, 1, 0],
	  'padCharsStart': [2, 1, 0],
	  'pullAllBy': [2, 1, 0],
	  'pullAllWith': [2, 1, 0],
	  'rangeStep': [1, 2, 0],
	  'rangeStepRight': [1, 2, 0],
	  'setWith': [3, 1, 2, 0],
	  'sortedIndexBy': [2, 1, 0],
	  'sortedLastIndexBy': [2, 1, 0],
	  'unionBy': [1, 2, 0],
	  'unionWith': [1, 2, 0],
	  'updateWith': [3, 1, 2, 0],
	  'xorBy': [1, 2, 0],
	  'xorWith': [1, 2, 0],
	  'zipWith': [1, 2, 0]
	};
	
	/** Used to map method names to spread configs. */
	exports.methodSpread = {
	  'assignAll': { 'start': 0 },
	  'assignAllWith': { 'start': 0 },
	  'assignInAll': { 'start': 0 },
	  'assignInAllWith': { 'start': 0 },
	  'defaultsAll': { 'start': 0 },
	  'defaultsDeepAll': { 'start': 0 },
	  'invokeArgs': { 'start': 2 },
	  'invokeArgsMap': { 'start': 2 },
	  'mergeAll': { 'start': 0 },
	  'mergeAllWith': { 'start': 0 },
	  'partial': { 'start': 1 },
	  'partialRight': { 'start': 1 },
	  'without': { 'start': 1 },
	  'zipAll': { 'start': 0 }
	};
	
	/** Used to identify methods which mutate arrays or objects. */
	exports.mutate = {
	  'array': {
	    'fill': true,
	    'pull': true,
	    'pullAll': true,
	    'pullAllBy': true,
	    'pullAllWith': true,
	    'pullAt': true,
	    'remove': true,
	    'reverse': true
	  },
	  'object': {
	    'assign': true,
	    'assignAll': true,
	    'assignAllWith': true,
	    'assignIn': true,
	    'assignInAll': true,
	    'assignInAllWith': true,
	    'assignInWith': true,
	    'assignWith': true,
	    'defaults': true,
	    'defaultsAll': true,
	    'defaultsDeep': true,
	    'defaultsDeepAll': true,
	    'merge': true,
	    'mergeAll': true,
	    'mergeAllWith': true,
	    'mergeWith': true,
	  },
	  'set': {
	    'set': true,
	    'setWith': true,
	    'unset': true,
	    'update': true,
	    'updateWith': true
	  }
	};
	
	/** Used to map real names to their aliases. */
	exports.realToAlias = (function() {
	  var hasOwnProperty = Object.prototype.hasOwnProperty,
	      object = exports.aliasToReal,
	      result = {};
	
	  for (var key in object) {
	    var value = object[key];
	    if (hasOwnProperty.call(result, value)) {
	      result[value].push(key);
	    } else {
	      result[value] = [key];
	    }
	  }
	  return result;
	}());
	
	/** Used to map method names to other names. */
	exports.remap = {
	  'assignAll': 'assign',
	  'assignAllWith': 'assignWith',
	  'assignInAll': 'assignIn',
	  'assignInAllWith': 'assignInWith',
	  'curryN': 'curry',
	  'curryRightN': 'curryRight',
	  'defaultsAll': 'defaults',
	  'defaultsDeepAll': 'defaultsDeep',
	  'findFrom': 'find',
	  'findIndexFrom': 'findIndex',
	  'findLastFrom': 'findLast',
	  'findLastIndexFrom': 'findLastIndex',
	  'getOr': 'get',
	  'includesFrom': 'includes',
	  'indexOfFrom': 'indexOf',
	  'invokeArgs': 'invoke',
	  'invokeArgsMap': 'invokeMap',
	  'lastIndexOfFrom': 'lastIndexOf',
	  'mergeAll': 'merge',
	  'mergeAllWith': 'mergeWith',
	  'padChars': 'pad',
	  'padCharsEnd': 'padEnd',
	  'padCharsStart': 'padStart',
	  'propertyOf': 'get',
	  'rangeStep': 'range',
	  'rangeStepRight': 'rangeRight',
	  'restFrom': 'rest',
	  'spreadFrom': 'spread',
	  'trimChars': 'trim',
	  'trimCharsEnd': 'trimEnd',
	  'trimCharsStart': 'trimStart',
	  'zipAll': 'zip'
	};
	
	/** Used to track methods that skip fixing their arity. */
	exports.skipFixed = {
	  'castArray': true,
	  'flow': true,
	  'flowRight': true,
	  'iteratee': true,
	  'mixin': true,
	  'rearg': true,
	  'runInContext': true
	};
	
	/** Used to track methods that skip rearranging arguments. */
	exports.skipRearg = {
	  'add': true,
	  'assign': true,
	  'assignIn': true,
	  'bind': true,
	  'bindKey': true,
	  'concat': true,
	  'difference': true,
	  'divide': true,
	  'eq': true,
	  'gt': true,
	  'gte': true,
	  'isEqual': true,
	  'lt': true,
	  'lte': true,
	  'matchesProperty': true,
	  'merge': true,
	  'multiply': true,
	  'overArgs': true,
	  'partial': true,
	  'partialRight': true,
	  'propertyOf': true,
	  'random': true,
	  'range': true,
	  'rangeRight': true,
	  'subtract': true,
	  'zip': true,
	  'zipObject': true,
	  'zipObjectDeep': true
	};


/***/ },
/* 6894 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  'ary': __webpack_require__(6881),
	  'assign': __webpack_require__(459),
	  'clone': __webpack_require__(6883),
	  'curry': __webpack_require__(6884),
	  'forEach': __webpack_require__(139),
	  'isArray': __webpack_require__(35),
	  'isError': __webpack_require__(6919),
	  'isFunction': __webpack_require__(89),
	  'isWeakMap': __webpack_require__(6924),
	  'iteratee': __webpack_require__(6925),
	  'keys': __webpack_require__(186),
	  'rearg': __webpack_require__(6934),
	  'toInteger': __webpack_require__(82),
	  'toPath': __webpack_require__(6947)
	};


/***/ },
/* 6895 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('compact', __webpack_require__(503), __webpack_require__(71));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 6896 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('difference', __webpack_require__(279));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 6897 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('filter', __webpack_require__(201));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 6898 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('flatMap', __webpack_require__(6889));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 6899 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('identity', __webpack_require__(77), __webpack_require__(71));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 6900 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('isFunction', __webpack_require__(89), __webpack_require__(71));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 6901 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('isNil', __webpack_require__(43), __webpack_require__(71));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 6902 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('isObject', __webpack_require__(59), __webpack_require__(71));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 6903 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('isPlainObject', __webpack_require__(150), __webpack_require__(71));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 6904 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('keys', __webpack_require__(63), __webpack_require__(71));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 6905 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('memoize', __webpack_require__(282));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 6906 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('min', __webpack_require__(6929), __webpack_require__(71));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 6907 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('pick', __webpack_require__(205));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 6908 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('sortBy', __webpack_require__(6938));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 6909 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('split', __webpack_require__(6939));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 6910 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('sum', __webpack_require__(6943), __webpack_require__(71));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 6911 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('take', __webpack_require__(6944));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 6912 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('toArray', __webpack_require__(6946), __webpack_require__(71));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 6913 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('trim', __webpack_require__(6950));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 6914 */
/***/ function(module, exports, __webpack_require__) {

	var convert = __webpack_require__(40),
	    func = convert('uniq', __webpack_require__(286), __webpack_require__(71));
	
	func.placeholder = __webpack_require__(38);
	module.exports = func;


/***/ },
/* 6915 */
/***/ function(module, exports) {

	/**
	 * Gets the first element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias first
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the first element of `array`.
	 * @example
	 *
	 * _.head([1, 2, 3]);
	 * // => 1
	 *
	 * _.head([]);
	 * // => undefined
	 */
	function head(array) {
	  return (array && array.length) ? array[0] : undefined;
	}
	
	module.exports = head;


/***/ },
/* 6916 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(81),
	    baseIntersection = __webpack_require__(6772),
	    baseRest = __webpack_require__(86),
	    castArrayLikeObject = __webpack_require__(6801);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ },
/* 6917 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(504),
	    createInverter = __webpack_require__(6823),
	    identity = __webpack_require__(77);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Creates an object composed of the inverted keys and values of `object`.
	 * If `object` contains duplicate values, subsequent values overwrite
	 * property assignments of previous values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.7.0
	 * @category Object
	 * @param {Object} object The object to invert.
	 * @returns {Object} Returns the new inverted object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2, 'c': 1 };
	 *
	 * _.invert(object);
	 * // => { '1': 'c', '2': 'b' }
	 */
	var invert = createInverter(function(result, value, key) {
	  if (value != null &&
	      typeof value.toString != 'function') {
	    value = nativeObjectToString.call(value);
	  }
	
	  result[value] = key;
	}, constant(identity));
	
	module.exports = invert;


/***/ },
/* 6918 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(70),
	    isObjectLike = __webpack_require__(53);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]';
	
	/**
	 * Checks if `value` is classified as a boolean primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	 * @example
	 *
	 * _.isBoolean(false);
	 * // => true
	 *
	 * _.isBoolean(null);
	 * // => false
	 */
	function isBoolean(value) {
	  return value === true || value === false ||
	    (isObjectLike(value) && baseGetTag(value) == boolTag);
	}
	
	module.exports = isBoolean;


/***/ },
/* 6919 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(70),
	    isObjectLike = __webpack_require__(53),
	    isPlainObject = __webpack_require__(150);
	
	/** `Object#toString` result references. */
	var domExcTag = '[object DOMException]',
	    errorTag = '[object Error]';
	
	/**
	 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	 * `SyntaxError`, `TypeError`, or `URIError` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	 * @example
	 *
	 * _.isError(new Error);
	 * // => true
	 *
	 * _.isError(Error);
	 * // => false
	 */
	function isError(value) {
	  if (!isObjectLike(value)) {
	    return false;
	  }
	  var tag = baseGetTag(value);
	  return tag == errorTag || tag == domExcTag ||
	    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	}
	
	module.exports = isError;


/***/ },
/* 6920 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(6777),
	    baseUnary = __webpack_require__(100),
	    nodeUtil = __webpack_require__(197);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ },
/* 6921 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(70),
	    isObjectLike = __webpack_require__(53);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ },
/* 6922 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsRegExp = __webpack_require__(6781),
	    baseUnary = __webpack_require__(100),
	    nodeUtil = __webpack_require__(197);
	
	/* Node.js helper references. */
	var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;
	
	/**
	 * Checks if `value` is classified as a `RegExp` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	 * @example
	 *
	 * _.isRegExp(/abc/);
	 * // => true
	 *
	 * _.isRegExp('/abc/');
	 * // => false
	 */
	var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	module.exports = isRegExp;


/***/ },
/* 6923 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(6782),
	    baseUnary = __webpack_require__(100),
	    nodeUtil = __webpack_require__(197);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ },
/* 6924 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(87),
	    isObjectLike = __webpack_require__(53);
	
	/** `Object#toString` result references. */
	var weakMapTag = '[object WeakMap]';
	
	/**
	 * Checks if `value` is classified as a `WeakMap` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	 * @example
	 *
	 * _.isWeakMap(new WeakMap);
	 * // => true
	 *
	 * _.isWeakMap(new Map);
	 * // => false
	 */
	function isWeakMap(value) {
	  return isObjectLike(value) && getTag(value) == weakMapTag;
	}
	
	module.exports = isWeakMap;


/***/ },
/* 6925 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(461),
	    baseIteratee = __webpack_require__(62);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a function that invokes `func` with the arguments of the created
	 * function. If `func` is a property name, the created function returns the
	 * property value for a given element. If `func` is an array or object, the
	 * created function returns `true` for elements that contain the equivalent
	 * source properties, otherwise it returns `false`.
	 *
	 * @static
	 * @since 4.0.0
	 * @memberOf _
	 * @category Util
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @returns {Function} Returns the callback.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, _.iteratee(['user', 'fred']));
	 * // => [{ 'user': 'fred', 'age': 40 }]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, _.iteratee('user'));
	 * // => ['barney', 'fred']
	 *
	 * // Create custom iteratee shorthands.
	 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	 *     return func.test(string);
	 *   };
	 * });
	 *
	 * _.filter(['abc', 'def'], /ef/);
	 * // => ['def']
	 */
	function iteratee(func) {
	  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	}
	
	module.exports = iteratee;


/***/ },
/* 6926 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 6927 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(140),
	    baseForOwn = __webpack_require__(184),
	    baseIteratee = __webpack_require__(62);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 6928 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(6788),
	    createAssigner = __webpack_require__(6814);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ },
/* 6929 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(6767),
	    baseLt = __webpack_require__(6785),
	    identity = __webpack_require__(77);
	
	/**
	 * Computes the minimum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * _.min([4, 2, 8, 6]);
	 * // => 2
	 *
	 * _.min([]);
	 * // => undefined
	 */
	function min(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseLt)
	    : undefined;
	}
	
	module.exports = min;


/***/ },
/* 6930 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(86),
	    createWrap = __webpack_require__(191),
	    getHolder = __webpack_require__(275),
	    replaceHolders = __webpack_require__(198);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * This method is like `_.partial` except that partially applied arguments
	 * are appended to the arguments it receives.
	 *
	 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of partially
	 * applied functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Function
	 * @param {Function} func The function to partially apply arguments to.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new partially applied function.
	 * @example
	 *
	 * function greet(greeting, name) {
	 *   return greeting + ' ' + name;
	 * }
	 *
	 * var greetFred = _.partialRight(greet, 'fred');
	 * greetFred('hi');
	 * // => 'hi fred'
	 *
	 * // Partially applied with placeholders.
	 * var sayHelloTo = _.partialRight(greet, 'hello', _);
	 * sayHelloTo('fred');
	 * // => 'hello fred'
	 */
	var partialRight = baseRest(function(func, partials) {
	  var holders = replaceHolders(partials, getHolder(partialRight));
	  return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	});
	
	// Assign default placeholders.
	partialRight.placeholder = {};
	
	module.exports = partialRight;


/***/ },
/* 6931 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(81),
	    baseIteratee = __webpack_require__(62),
	    basePickBy = __webpack_require__(467),
	    getAllKeysIn = __webpack_require__(485);
	
	/**
	 * Creates an object composed of the `object` properties `predicate` returns
	 * truthy for. The predicate is invoked with two arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pickBy(object, _.isNumber);
	 * // => { 'a': 1, 'c': 3 }
	 */
	function pickBy(object, predicate) {
	  if (object == null) {
	    return {};
	  }
	  var props = arrayMap(getAllKeysIn(object), function(prop) {
	    return [prop];
	  });
	  predicate = baseIteratee(predicate);
	  return basePickBy(object, props, function(value, path) {
	    return predicate(value, path[0]);
	  });
	}
	
	module.exports = pickBy;


/***/ },
/* 6932 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(468),
	    basePropertyDeep = __webpack_require__(6792),
	    isKey = __webpack_require__(277),
	    toKey = __webpack_require__(102);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 6933 */
/***/ function(module, exports, __webpack_require__) {

	var createRange = __webpack_require__(6825);
	
	/**
	 * Creates an array of numbers (positive and/or negative) progressing from
	 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	 * `start` is specified without an `end` or `step`. If `end` is not specified,
	 * it's set to `start` with `start` then set to `0`.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} [step=1] The value to increment or decrement by.
	 * @returns {Array} Returns the range of numbers.
	 * @see _.inRange, _.rangeRight
	 * @example
	 *
	 * _.range(4);
	 * // => [0, 1, 2, 3]
	 *
	 * _.range(-4);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 5);
	 * // => [1, 2, 3, 4]
	 *
	 * _.range(0, 20, 5);
	 * // => [0, 5, 10, 15]
	 *
	 * _.range(0, -4, -1);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * _.range(0);
	 * // => []
	 */
	var range = createRange();
	
	module.exports = range;


/***/ },
/* 6934 */
/***/ function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(191),
	    flatRest = __webpack_require__(273);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_REARG_FLAG = 256;
	
	/**
	 * Creates a function that invokes `func` with arguments arranged according
	 * to the specified `indexes` where the argument value at the first index is
	 * provided as the first argument, the argument value at the second index is
	 * provided as the second argument, and so on.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} func The function to rearrange arguments for.
	 * @param {...(number|number[])} indexes The arranged argument indexes.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var rearged = _.rearg(function(a, b, c) {
	 *   return [a, b, c];
	 * }, [2, 0, 1]);
	 *
	 * rearged('b', 'c', 'a')
	 * // => ['a', 'b', 'c']
	 */
	var rearg = flatRest(function(func, indexes) {
	  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	});
	
	module.exports = rearg;


/***/ },
/* 6935 */
/***/ function(module, exports, __webpack_require__) {

	var createRound = __webpack_require__(6826);
	
	/**
	 * Computes `number` rounded to `precision`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.10.0
	 * @category Math
	 * @param {number} number The number to round.
	 * @param {number} [precision=0] The precision to round to.
	 * @returns {number} Returns the rounded number.
	 * @example
	 *
	 * _.round(4.006);
	 * // => 4
	 *
	 * _.round(4.006, 2);
	 * // => 4.01
	 *
	 * _.round(4060, -2);
	 * // => 4100
	 */
	var round = createRound('round');
	
	module.exports = round;


/***/ },
/* 6936 */
/***/ function(module, exports, __webpack_require__) {

	var baseSet = __webpack_require__(469);
	
	/**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */
	function set(object, path, value) {
	  return object == null ? object : baseSet(object, path, value);
	}
	
	module.exports = set;


/***/ },
/* 6937 */
/***/ function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(186),
	    getTag = __webpack_require__(87),
	    isArrayLike = __webpack_require__(73),
	    isString = __webpack_require__(203),
	    stringSize = __webpack_require__(6874);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/**
	 * Gets the size of `collection` by returning its length for array-like
	 * values or the number of own enumerable string keyed properties for objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @returns {number} Returns the collection size.
	 * @example
	 *
	 * _.size([1, 2, 3]);
	 * // => 3
	 *
	 * _.size({ 'a': 1, 'b': 2 });
	 * // => 2
	 *
	 * _.size('pebbles');
	 * // => 7
	 */
	function size(collection) {
	  if (collection == null) {
	    return 0;
	  }
	  if (isArrayLike(collection)) {
	    return isString(collection) ? stringSize(collection) : collection.length;
	  }
	  var tag = getTag(collection);
	  if (tag == mapTag || tag == setTag) {
	    return collection.size;
	  }
	  return baseKeys(collection).length;
	}
	
	module.exports = size;


/***/ },
/* 6938 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(142),
	    baseOrderBy = __webpack_require__(6790),
	    baseRest = __webpack_require__(86),
	    isIterateeCall = __webpack_require__(117);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 30 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ },
/* 6939 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(188),
	    castSlice = __webpack_require__(271),
	    hasUnicode = __webpack_require__(194),
	    isIterateeCall = __webpack_require__(117),
	    isRegExp = __webpack_require__(6922),
	    stringToArray = __webpack_require__(200),
	    toString = __webpack_require__(78);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Splits `string` by `separator`.
	 *
	 * **Note:** This method is based on
	 * [`String#split`](https://mdn.io/String/split).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to split.
	 * @param {RegExp|string} separator The separator pattern to split by.
	 * @param {number} [limit] The length to truncate results to.
	 * @returns {Array} Returns the string segments.
	 * @example
	 *
	 * _.split('a-b-c', '-', 2);
	 * // => ['a', 'b']
	 */
	function split(string, separator, limit) {
	  if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	    separator = limit = undefined;
	  }
	  limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	  if (!limit) {
	    return [];
	  }
	  string = toString(string);
	  if (string && (
	        typeof separator == 'string' ||
	        (separator != null && !isRegExp(separator))
	      )) {
	    separator = baseToString(separator);
	    if (!separator && hasUnicode(string)) {
	      return castSlice(stringToArray(string), 0, limit);
	    }
	  }
	  return string.split(separator, limit);
	}
	
	module.exports = split;


/***/ },
/* 6940 */
/***/ function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(6819),
	    upperFirst = __webpack_require__(6952);
	
	/**
	 * Converts `string` to
	 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.1.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the start cased string.
	 * @example
	 *
	 * _.startCase('--foo-bar--');
	 * // => 'Foo Bar'
	 *
	 * _.startCase('fooBar');
	 * // => 'Foo Bar'
	 *
	 * _.startCase('__FOO_BAR__');
	 * // => 'FOO BAR'
	 */
	var startCase = createCompounder(function(result, word, index) {
	  return result + (index ? ' ' : '') + upperFirst(word);
	});
	
	module.exports = startCase;


/***/ },
/* 6941 */
/***/ function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(460),
	    baseToString = __webpack_require__(188),
	    toInteger = __webpack_require__(82),
	    toString = __webpack_require__(78);
	
	/**
	 * Checks if `string` starts with the given target string.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {string} [target] The string to search for.
	 * @param {number} [position=0] The position to search from.
	 * @returns {boolean} Returns `true` if `string` starts with `target`,
	 *  else `false`.
	 * @example
	 *
	 * _.startsWith('abc', 'a');
	 * // => true
	 *
	 * _.startsWith('abc', 'b');
	 * // => false
	 *
	 * _.startsWith('abc', 'b', 1);
	 * // => true
	 */
	function startsWith(string, target, position) {
	  string = toString(string);
	  position = position == null
	    ? 0
	    : baseClamp(toInteger(position), 0, string.length);
	
	  target = baseToString(target);
	  return string.slice(position, position + target.length) == target;
	}
	
	module.exports = startsWith;


/***/ },
/* 6942 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 6943 */
/***/ function(module, exports, __webpack_require__) {

	var baseSum = __webpack_require__(6799),
	    identity = __webpack_require__(77);
	
	/**
	 * Computes the sum of the values in `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.4.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * _.sum([4, 2, 8, 6]);
	 * // => 20
	 */
	function sum(array) {
	  return (array && array.length)
	    ? baseSum(array, identity)
	    : 0;
	}
	
	module.exports = sum;


/***/ },
/* 6944 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(187),
	    toInteger = __webpack_require__(82);
	
	/**
	 * Creates a slice of `array` with `n` elements taken from the beginning.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to take.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.take([1, 2, 3]);
	 * // => [1]
	 *
	 * _.take([1, 2, 3], 2);
	 * // => [1, 2]
	 *
	 * _.take([1, 2, 3], 5);
	 * // => [1, 2, 3]
	 *
	 * _.take([1, 2, 3], 0);
	 * // => []
	 */
	function take(array, n, guard) {
	  if (!(array && array.length)) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  return baseSlice(array, 0, n < 0 ? 0 : n);
	}
	
	module.exports = take;


/***/ },
/* 6945 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(471),
	    castFunction = __webpack_require__(474),
	    toInteger = __webpack_require__(82);
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Invokes the iteratee `n` times, returning an array of the results of
	 * each invocation. The iteratee is invoked with one argument; (index).
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 * @example
	 *
	 * _.times(3, String);
	 * // => ['0', '1', '2']
	 *
	 *  _.times(4, _.constant(0));
	 * // => [0, 0, 0, 0]
	 */
	function times(n, iteratee) {
	  n = toInteger(n);
	  if (n < 1 || n > MAX_SAFE_INTEGER) {
	    return [];
	  }
	  var index = MAX_ARRAY_LENGTH,
	      length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	  iteratee = castFunction(iteratee);
	  n -= MAX_ARRAY_LENGTH;
	
	  var result = baseTimes(length, iteratee);
	  while (++index < n) {
	    iteratee(index);
	  }
	  return result;
	}
	
	module.exports = times;


/***/ },
/* 6946 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(98),
	    copyArray = __webpack_require__(116),
	    getTag = __webpack_require__(87),
	    isArrayLike = __webpack_require__(73),
	    isString = __webpack_require__(203),
	    iteratorToArray = __webpack_require__(6847),
	    mapToArray = __webpack_require__(492),
	    setToArray = __webpack_require__(199),
	    stringToArray = __webpack_require__(200),
	    values = __webpack_require__(153);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Built-in value references. */
	var symIterator = Symbol ? Symbol.iterator : undefined;
	
	/**
	 * Converts `value` to an array.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the converted array.
	 * @example
	 *
	 * _.toArray({ 'a': 1, 'b': 2 });
	 * // => [1, 2]
	 *
	 * _.toArray('abc');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toArray(1);
	 * // => []
	 *
	 * _.toArray(null);
	 * // => []
	 */
	function toArray(value) {
	  if (!value) {
	    return [];
	  }
	  if (isArrayLike(value)) {
	    return isString(value) ? stringToArray(value) : copyArray(value);
	  }
	  if (symIterator && value[symIterator]) {
	    return iteratorToArray(value[symIterator]());
	  }
	  var tag = getTag(value),
	      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	  return func(value);
	}
	
	module.exports = toArray;


/***/ },
/* 6947 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(81),
	    copyArray = __webpack_require__(116),
	    isArray = __webpack_require__(35),
	    isSymbol = __webpack_require__(103),
	    stringToPath = __webpack_require__(501),
	    toKey = __webpack_require__(102),
	    toString = __webpack_require__(78);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	}
	
	module.exports = toPath;


/***/ },
/* 6948 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(145),
	    keysIn = __webpack_require__(152);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 6949 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(139),
	    baseCreate = __webpack_require__(141),
	    baseForOwn = __webpack_require__(184),
	    baseIteratee = __webpack_require__(62),
	    getPrototype = __webpack_require__(193),
	    isArray = __webpack_require__(35),
	    isBuffer = __webpack_require__(120),
	    isFunction = __webpack_require__(89),
	    isObject = __webpack_require__(59),
	    isTypedArray = __webpack_require__(151);
	
	/**
	 * An alternative to `_.reduce`; this method transforms `object` to a new
	 * `accumulator` object which is the result of running each of its own
	 * enumerable string keyed properties thru `iteratee`, with each invocation
	 * potentially mutating the `accumulator` object. If `accumulator` is not
	 * provided, a new object with the same `[[Prototype]]` will be used. The
	 * iteratee is invoked with four arguments: (accumulator, value, key, object).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The custom accumulator value.
	 * @returns {*} Returns the accumulated value.
	 * @example
	 *
	 * _.transform([2, 3, 4], function(result, n) {
	 *   result.push(n *= n);
	 *   return n % 2 == 0;
	 * }, []);
	 * // => [4, 9]
	 *
	 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] }
	 */
	function transform(object, iteratee, accumulator) {
	  var isArr = isArray(object),
	      isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	  iteratee = baseIteratee(iteratee, 4);
	  if (accumulator == null) {
	    var Ctor = object && object.constructor;
	    if (isArrLike) {
	      accumulator = isArr ? new Ctor : [];
	    }
	    else if (isObject(object)) {
	      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	    }
	    else {
	      accumulator = {};
	    }
	  }
	  (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	    return iteratee(accumulator, value, index, object);
	  });
	  return accumulator;
	}
	
	module.exports = transform;


/***/ },
/* 6950 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(188),
	    baseTrim = __webpack_require__(472),
	    castSlice = __webpack_require__(271),
	    charsEndIndex = __webpack_require__(6802),
	    charsStartIndex = __webpack_require__(6803),
	    stringToArray = __webpack_require__(200),
	    toString = __webpack_require__(78);
	
	/**
	 * Removes leading and trailing whitespace or specified characters from `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to trim.
	 * @param {string} [chars=whitespace] The characters to trim.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {string} Returns the trimmed string.
	 * @example
	 *
	 * _.trim('  abc  ');
	 * // => 'abc'
	 *
	 * _.trim('-_-abc-_-', '_-');
	 * // => 'abc'
	 *
	 * _.map(['  foo  ', '  bar  '], _.trim);
	 * // => ['foo', 'bar']
	 */
	function trim(string, chars, guard) {
	  string = toString(string);
	  if (string && (guard || chars === undefined)) {
	    return baseTrim(string);
	  }
	  if (!string || !(chars = baseToString(chars))) {
	    return string;
	  }
	  var strSymbols = stringToArray(string),
	      chrSymbols = stringToArray(chars),
	      start = charsStartIndex(strSymbols, chrSymbols),
	      end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	  return castSlice(strSymbols, start, end).join('');
	}
	
	module.exports = trim;


/***/ },
/* 6951 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(142),
	    baseRest = __webpack_require__(86),
	    baseUniq = __webpack_require__(473),
	    isArrayLikeObject = __webpack_require__(149);
	
	/**
	 * Creates an array of unique values, in order, from all given arrays using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([2], [1, 2]);
	 * // => [2, 1]
	 */
	var union = baseRest(function(arrays) {
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	});
	
	module.exports = union;


/***/ },
/* 6952 */
/***/ function(module, exports, __webpack_require__) {

	var createCaseFirst = __webpack_require__(6818);
	
	/**
	 * Converts the first character of `string` to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.upperFirst('fred');
	 * // => 'Fred'
	 *
	 * _.upperFirst('FRED');
	 * // => 'FRED'
	 */
	var upperFirst = createCaseFirst('toUpperCase');
	
	module.exports = upperFirst;


/***/ },
/* 6953 */
/***/ function(module, exports, __webpack_require__) {

	var asciiWords = __webpack_require__(6763),
	    hasUnicodeWord = __webpack_require__(6835),
	    toString = __webpack_require__(78),
	    unicodeWords = __webpack_require__(6878);
	
	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  string = toString(string);
	  pattern = guard ? undefined : pattern;
	
	  if (pattern === undefined) {
	    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	  }
	  return string.match(pattern) || [];
	}
	
	module.exports = words;


/***/ },
/* 6954 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(262),
	    LodashWrapper = __webpack_require__(263),
	    baseLodash = __webpack_require__(270),
	    isArray = __webpack_require__(35),
	    isObjectLike = __webpack_require__(53),
	    wrapperClone = __webpack_require__(6880);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array and iteratees accept only
	 * one argument. The heuristic for whether a section qualifies for shortcut
	 * fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ },
/* 6955 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./abs')} */
	module.exports = Math.abs;


/***/ },
/* 6956 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./floor')} */
	module.exports = Math.floor;


/***/ },
/* 6957 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./isNaN')} */
	module.exports = Number.isNaN || function isNaN(a) {
		return a !== a;
	};


/***/ },
/* 6958 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./max')} */
	module.exports = Math.max;


/***/ },
/* 6959 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./min')} */
	module.exports = Math.min;


/***/ },
/* 6960 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./pow')} */
	module.exports = Math.pow;


/***/ },
/* 6961 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./round')} */
	module.exports = Math.round;


/***/ },
/* 6962 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $isNaN = __webpack_require__(6957);
	
	/** @type {import('./sign')} */
	module.exports = function sign(number) {
		if ($isNaN(number) || number === 0) {
			return number;
		}
		return number < 0 ? -1 : +1;
	};


/***/ },
/* 6963 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';var React=__webpack_require__(2),_inheritsLoose=__webpack_require__(92),PropTypes=__webpack_require__(5),warning=__webpack_require__(108);function _interopDefaultLegacy(e){return e&&typeof e==='object'&&'default'in e?e:{'default':e}}var React__default=/*#__PURE__*/_interopDefaultLegacy(React);var _inheritsLoose__default=/*#__PURE__*/_interopDefaultLegacy(_inheritsLoose);var PropTypes__default=/*#__PURE__*/_interopDefaultLegacy(PropTypes);var warning__default=/*#__PURE__*/_interopDefaultLegacy(warning);var MAX_SIGNED_31_BIT_INT = 1073741823;
	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};
	
	function getUniqueId() {
	  var key = '__global_unique_id__';
	  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
	}
	
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + getUniqueId() + '__';
	
	  var Provider = /*#__PURE__*/function (_Component) {
	    _inheritsLoose__default['default'](Provider, _Component);
	
	    function Provider() {
	      var _this;
	
	      _this = _Component.apply(this, arguments) || this;
	      _this.emitter = createEventEmitter(_this.props.value);
	      return _this;
	    }
	
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0;
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	
	          if (false) {
	            warning__default['default']((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    _proto.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(React.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = PropTypes__default['default'].object.isRequired, _Provider$childContex);
	
	  var Consumer = /*#__PURE__*/function (_Component2) {
	    _inheritsLoose__default['default'](Consumer, _Component2);
	
	    function Consumer() {
	      var _this2;
	
	      _this2 = _Component2.apply(this, arguments) || this;
	      _this2.state = {
	        value: _this2.getValue()
	      };
	
	      _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({
	            value: _this2.getValue()
	          });
	        }
	      };
	
	      return _this2;
	    }
	
	    var _proto2 = Consumer.prototype;
	
	    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	
	      var observedBits = this.props.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    _proto2.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    _proto2.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(React.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = PropTypes__default['default'].object, _Consumer$contextType);
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}var index = React__default['default'].createContext || createReactContext;module.exports=index;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 6964 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 515,
		"./af.js": 515,
		"./ar": 522,
		"./ar-dz": 516,
		"./ar-dz.js": 516,
		"./ar-kw": 517,
		"./ar-kw.js": 517,
		"./ar-ly": 518,
		"./ar-ly.js": 518,
		"./ar-ma": 519,
		"./ar-ma.js": 519,
		"./ar-sa": 520,
		"./ar-sa.js": 520,
		"./ar-tn": 521,
		"./ar-tn.js": 521,
		"./ar.js": 522,
		"./az": 523,
		"./az.js": 523,
		"./be": 524,
		"./be.js": 524,
		"./bg": 525,
		"./bg.js": 525,
		"./bm": 526,
		"./bm.js": 526,
		"./bn": 527,
		"./bn.js": 527,
		"./bo": 528,
		"./bo.js": 528,
		"./br": 529,
		"./br.js": 529,
		"./bs": 530,
		"./bs.js": 530,
		"./ca": 531,
		"./ca.js": 531,
		"./cs": 532,
		"./cs.js": 532,
		"./cv": 533,
		"./cv.js": 533,
		"./cy": 534,
		"./cy.js": 534,
		"./da": 535,
		"./da.js": 535,
		"./de": 538,
		"./de-at": 536,
		"./de-at.js": 536,
		"./de-ch": 537,
		"./de-ch.js": 537,
		"./de.js": 538,
		"./dv": 539,
		"./dv.js": 539,
		"./el": 540,
		"./el.js": 540,
		"./en-SG": 541,
		"./en-SG.js": 541,
		"./en-au": 542,
		"./en-au.js": 542,
		"./en-ca": 543,
		"./en-ca.js": 543,
		"./en-gb": 544,
		"./en-gb.js": 544,
		"./en-ie": 545,
		"./en-ie.js": 545,
		"./en-il": 546,
		"./en-il.js": 546,
		"./en-nz": 547,
		"./en-nz.js": 547,
		"./eo": 548,
		"./eo.js": 548,
		"./es": 551,
		"./es-do": 549,
		"./es-do.js": 549,
		"./es-us": 550,
		"./es-us.js": 550,
		"./es.js": 551,
		"./et": 552,
		"./et.js": 552,
		"./eu": 553,
		"./eu.js": 553,
		"./fa": 554,
		"./fa.js": 554,
		"./fi": 555,
		"./fi.js": 555,
		"./fo": 556,
		"./fo.js": 556,
		"./fr": 559,
		"./fr-ca": 557,
		"./fr-ca.js": 557,
		"./fr-ch": 558,
		"./fr-ch.js": 558,
		"./fr.js": 559,
		"./fy": 560,
		"./fy.js": 560,
		"./ga": 561,
		"./ga.js": 561,
		"./gd": 562,
		"./gd.js": 562,
		"./gl": 563,
		"./gl.js": 563,
		"./gom-latn": 564,
		"./gom-latn.js": 564,
		"./gu": 565,
		"./gu.js": 565,
		"./he": 566,
		"./he.js": 566,
		"./hi": 567,
		"./hi.js": 567,
		"./hr": 568,
		"./hr.js": 568,
		"./hu": 569,
		"./hu.js": 569,
		"./hy-am": 570,
		"./hy-am.js": 570,
		"./id": 571,
		"./id.js": 571,
		"./is": 572,
		"./is.js": 572,
		"./it": 574,
		"./it-ch": 573,
		"./it-ch.js": 573,
		"./it.js": 574,
		"./ja": 575,
		"./ja.js": 575,
		"./jv": 576,
		"./jv.js": 576,
		"./ka": 577,
		"./ka.js": 577,
		"./kk": 578,
		"./kk.js": 578,
		"./km": 579,
		"./km.js": 579,
		"./kn": 580,
		"./kn.js": 580,
		"./ko": 581,
		"./ko.js": 581,
		"./ku": 582,
		"./ku.js": 582,
		"./ky": 583,
		"./ky.js": 583,
		"./lb": 584,
		"./lb.js": 584,
		"./lo": 585,
		"./lo.js": 585,
		"./lt": 586,
		"./lt.js": 586,
		"./lv": 587,
		"./lv.js": 587,
		"./me": 588,
		"./me.js": 588,
		"./mi": 589,
		"./mi.js": 589,
		"./mk": 590,
		"./mk.js": 590,
		"./ml": 591,
		"./ml.js": 591,
		"./mn": 592,
		"./mn.js": 592,
		"./mr": 593,
		"./mr.js": 593,
		"./ms": 595,
		"./ms-my": 594,
		"./ms-my.js": 594,
		"./ms.js": 595,
		"./mt": 596,
		"./mt.js": 596,
		"./my": 597,
		"./my.js": 597,
		"./nb": 598,
		"./nb.js": 598,
		"./ne": 599,
		"./ne.js": 599,
		"./nl": 601,
		"./nl-be": 600,
		"./nl-be.js": 600,
		"./nl.js": 601,
		"./nn": 602,
		"./nn.js": 602,
		"./pa-in": 603,
		"./pa-in.js": 603,
		"./pl": 604,
		"./pl.js": 604,
		"./pt": 606,
		"./pt-br": 605,
		"./pt-br.js": 605,
		"./pt.js": 606,
		"./ro": 607,
		"./ro.js": 607,
		"./ru": 608,
		"./ru.js": 608,
		"./sd": 609,
		"./sd.js": 609,
		"./se": 610,
		"./se.js": 610,
		"./si": 611,
		"./si.js": 611,
		"./sk": 612,
		"./sk.js": 612,
		"./sl": 613,
		"./sl.js": 613,
		"./sq": 614,
		"./sq.js": 614,
		"./sr": 616,
		"./sr-cyrl": 615,
		"./sr-cyrl.js": 615,
		"./sr.js": 616,
		"./ss": 617,
		"./ss.js": 617,
		"./sv": 618,
		"./sv.js": 618,
		"./sw": 619,
		"./sw.js": 619,
		"./ta": 620,
		"./ta.js": 620,
		"./te": 621,
		"./te.js": 621,
		"./tet": 622,
		"./tet.js": 622,
		"./tg": 623,
		"./tg.js": 623,
		"./th": 624,
		"./th.js": 624,
		"./tl-ph": 625,
		"./tl-ph.js": 625,
		"./tlh": 626,
		"./tlh.js": 626,
		"./tr": 627,
		"./tr.js": 627,
		"./tzl": 628,
		"./tzl.js": 628,
		"./tzm": 630,
		"./tzm-latn": 629,
		"./tzm-latn.js": 629,
		"./tzm.js": 630,
		"./ug-cn": 631,
		"./ug-cn.js": 631,
		"./uk": 632,
		"./uk.js": 632,
		"./ur": 633,
		"./ur.js": 633,
		"./uz": 635,
		"./uz-latn": 634,
		"./uz-latn.js": 634,
		"./uz.js": 635,
		"./vi": 636,
		"./vi.js": 636,
		"./x-pseudo": 637,
		"./x-pseudo.js": 637,
		"./yo": 638,
		"./yo.js": 638,
		"./zh-cn": 639,
		"./zh-cn.js": 639,
		"./zh-hk": 640,
		"./zh-hk.js": 640,
		"./zh-tw": 641,
		"./zh-tw.js": 641
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 6964;


/***/ },
/* 6965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(134);
	var callBind = __webpack_require__(428);
	
	var implementation = __webpack_require__(642);
	var getPolyfill = __webpack_require__(643);
	var shim = __webpack_require__(6966);
	
	var polyfill = callBind(getPolyfill(), Object);
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ },
/* 6966 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(643);
	var define = __webpack_require__(134);
	
	module.exports = function shimObjectIs() {
		var polyfill = getPolyfill();
		define(Object, { is: polyfill }, {
			is: function testObjectIs() {
				return Object.is !== polyfill;
			}
		});
		return polyfill;
	};


/***/ },
/* 6967 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(645); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ },
/* 6968 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function(crypto) {
	  function pbkdf2(password, salt, iterations, keylen, digest, callback) {
	    if ('function' === typeof digest) {
	      callback = digest
	      digest = undefined
	    }
	
	    if ('function' !== typeof callback)
	      throw new Error('No callback provided to pbkdf2')
	
	    setTimeout(function() {
	      var result
	
	      try {
	        result = pbkdf2Sync(password, salt, iterations, keylen, digest)
	      } catch (e) {
	        return callback(e)
	      }
	
	      callback(undefined, result)
	    })
	  }
	
	  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
	    if ('number' !== typeof iterations)
	      throw new TypeError('Iterations not a number')
	
	    if (iterations < 0)
	      throw new TypeError('Bad iterations')
	
	    if ('number' !== typeof keylen)
	      throw new TypeError('Key length not a number')
	
	    if (keylen < 0)
	      throw new TypeError('Bad key length')
	
	    digest = digest || 'sha1'
	
	    if (!Buffer.isBuffer(password)) password = new Buffer(password)
	    if (!Buffer.isBuffer(salt)) salt = new Buffer(salt)
	
	    var hLen, l = 1, r, T
	    var DK = new Buffer(keylen)
	    var block1 = new Buffer(salt.length + 4)
	    salt.copy(block1, 0, 0, salt.length)
	
	    for (var i = 1; i <= l; i++) {
	      block1.writeUInt32BE(i, salt.length)
	
	      var U = crypto.createHmac(digest, password).update(block1).digest()
	
	      if (!hLen) {
	        hLen = U.length
	        T = new Buffer(hLen)
	        l = Math.ceil(keylen / hLen)
	        r = keylen - (l - 1) * hLen
	
	        if (keylen > (Math.pow(2, 32) - 1) * hLen)
	          throw new TypeError('keylen exceeds maximum length')
	      }
	
	      U.copy(T, 0, 0, hLen)
	
	      for (var j = 1; j < iterations; j++) {
	        U = crypto.createHmac(digest, password).update(U).digest()
	
	        for (var k = 0; k < hLen; k++) {
	          T[k] ^= U[k]
	        }
	      }
	
	      var destPos = (i - 1) * hLen
	      var len = (i == l ? r : hLen)
	      T.copy(DK, destPos, 0, len)
	    }
	
	    return DK
	  }
	
	  return {
	    pbkdf2: pbkdf2,
	    pbkdf2Sync: pbkdf2Sync
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39).Buffer))

/***/ },
/* 6969 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.1
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
	
	var timeoutDuration = function () {
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      return 1;
	    }
	  }
	  return 0;
	}();
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the reference node of the reference object, or the reference object itself.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	 * @returns {Element} parent
	 */
	function getReferenceNode(reference) {
	  return reference && reference.referenceNode ? reference.referenceNode : reference;
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.width;
	  var height = sizes.height || element.clientHeight || result.height;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop);
	    var marginLeft = parseFloat(styles.marginLeft);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicitly asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 6970 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	module.exports = exports['default'];

/***/ },
/* 6971 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(6972);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 6972 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 6973 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(92));
	
	var _css3 = _interopRequireDefault(__webpack_require__(257));
	
	var _querySelectorAll = _interopRequireDefault(__webpack_require__(6723));
	
	var _scrollbarSize = _interopRequireDefault(__webpack_require__(258));
	
	var _ModalManager2 = _interopRequireDefault(__webpack_require__(648));
	
	var Selector = {
	  FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
	  STICKY_CONTENT: '.sticky-top',
	  NAVBAR_TOGGLER: '.navbar-toggler'
	};
	
	var BootstrapModalManager = /*#__PURE__*/function (_ModalManager) {
	  (0, _inheritsLoose2.default)(BootstrapModalManager, _ModalManager);
	
	  function BootstrapModalManager() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _ModalManager.call.apply(_ModalManager, [this].concat(args)) || this;
	
	    _this.adjustAndStore = function (prop, element, adjust) {
	      var _css;
	
	      var actual = element.style[prop];
	      element.dataset[prop] = actual;
	      (0, _css3.default)(element, (_css = {}, _css[prop] = parseFloat((0, _css3.default)(element, prop)) + adjust + "px", _css));
	    };
	
	    _this.restore = function (prop, element) {
	      var value = element.dataset[prop];
	
	      if (value !== undefined) {
	        var _css2;
	
	        delete element.dataset[prop];
	        (0, _css3.default)(element, (_css2 = {}, _css2[prop] = value, _css2));
	      }
	    };
	
	    return _this;
	  }
	
	  var _proto = BootstrapModalManager.prototype;
	
	  _proto.setContainerStyle = function setContainerStyle(containerState, container) {
	    var _this2 = this;
	
	    _ModalManager.prototype.setContainerStyle.call(this, containerState, container);
	
	    if (!containerState.overflowing) return;
	    var size = (0, _scrollbarSize.default)();
	    (0, _querySelectorAll.default)(container, Selector.FIXED_CONTENT).forEach(function (el) {
	      return _this2.adjustAndStore('paddingRight', el, size);
	    });
	    (0, _querySelectorAll.default)(container, Selector.STICKY_CONTENT).forEach(function (el) {
	      return _this2.adjustAndStore('margingRight', el, -size);
	    });
	    (0, _querySelectorAll.default)(container, Selector.NAVBAR_TOGGLER).forEach(function (el) {
	      return _this2.adjustAndStore('margingRight', el, size);
	    });
	  };
	
	  _proto.removeContainerStyle = function removeContainerStyle(containerState, container) {
	    var _this3 = this;
	
	    _ModalManager.prototype.removeContainerStyle.call(this, containerState, container);
	
	    (0, _querySelectorAll.default)(container, Selector.FIXED_CONTENT).forEach(function (el) {
	      return _this3.restore('paddingRight', el);
	    });
	    (0, _querySelectorAll.default)(container, Selector.STICKY_CONTENT).forEach(function (el) {
	      return _this3.restore('margingRight', el);
	    });
	    (0, _querySelectorAll.default)(container, Selector.NAVBAR_TOGGLER).forEach(function (el) {
	      return _this3.restore('margingRight', el);
	    });
	  };
	
	  return BootstrapModalManager;
	}(_ModalManager2.default);
	
	exports.default = BootstrapModalManager;
	module.exports = exports["default"];

/***/ },
/* 6974 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(48);
	
	var _SafeAnchor = _interopRequireDefault(__webpack_require__(6994));
	
	var defaultProps = {
	  variant: 'primary',
	  active: false,
	  disabled: false,
	  type: 'button'
	};
	
	var Button = _react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      variant = _ref.variant,
	      size = _ref.size,
	      active = _ref.active,
	      className = _ref.className,
	      block = _ref.block,
	      type = _ref.type,
	      as = _ref.as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "variant", "size", "active", "className", "block", "type", "as"]);
	  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'btn');
	  var classes = (0, _classnames.default)(className, prefix, active && 'active', prefix + "-" + variant, block && prefix + "-block", size && prefix + "-" + size);
	
	  if (props.href) {
	    return /*#__PURE__*/_react.default.createElement(_SafeAnchor.default, (0, _extends2.default)({}, props, {
	      as: as,
	      ref: ref,
	      className: (0, _classnames.default)(classes, props.disabled && 'disabled')
	    }));
	  }
	
	  if (ref) {
	    props.ref = ref;
	  }
	
	  if (!as) {
	    props.type = type;
	  }
	
	  var Component = as || 'button';
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    className: classes
	  }));
	});
	
	Button.displayName = 'Button';
	Button.defaultProps = defaultProps;
	var _default = Button;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6975 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var propTypes = {
	  label: _propTypes.default.string.isRequired,
	  onClick: _propTypes.default.func
	};
	var defaultProps = {
	  label: 'Close'
	};
	
	var CloseButton = _react.default.forwardRef(function (_ref, ref) {
	  var label = _ref.label,
	      onClick = _ref.onClick,
	      className = _ref.className,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["label", "onClick", "className"]);
	  return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
	    ref: ref,
	    type: "button",
	    className: (0, _classnames.default)('close', className),
	    onClick: onClick
	  }, props), /*#__PURE__*/_react.default.createElement("span", {
	    "aria-hidden": "true"
	  }, "\xD7"), /*#__PURE__*/_react.default.createElement("span", {
	    className: "sr-only"
	  }, label));
	});
	
	CloseButton.displayName = 'CloseButton';
	CloseButton.propTypes = propTypes;
	CloseButton.defaultProps = defaultProps;
	var _default = CloseButton;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6976 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(48);
	
	var DEVICE_SIZES = ['xl', 'lg', 'md', 'sm', 'xs'];
	
	var Col = _react.default.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
	function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "className", "as"]);
	  var prefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'col');
	  var spans = [];
	  var classes = [];
	  DEVICE_SIZES.forEach(function (brkPoint) {
	    var propValue = props[brkPoint];
	    delete props[brkPoint];
	    var span, offset, order;
	
	    if (propValue != null && typeof propValue === 'object') {
	      var _propValue$span = propValue.span;
	      span = _propValue$span === void 0 ? true : _propValue$span;
	      offset = propValue.offset;
	      order = propValue.order;
	    } else {
	      span = propValue;
	    }
	
	    var infix = brkPoint !== 'xs' ? "-" + brkPoint : '';
	    if (span != null) spans.push(span === true ? "" + prefix + infix : "" + prefix + infix + "-" + span);
	    if (order != null) classes.push("order" + infix + "-" + order);
	    if (offset != null) classes.push("offset" + infix + "-" + offset);
	  });
	
	  if (!spans.length) {
	    spans.push(prefix); // plain 'col'
	  }
	
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    ref: ref,
	    className: _classnames.default.apply(void 0, [className].concat(spans, classes))
	  }));
	});
	
	Col.displayName = 'Col';
	var _default = Col;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6977 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _transitionEnd = _interopRequireDefault(__webpack_require__(6724));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _Transition = _interopRequireWildcard(__webpack_require__(216));
	
	var _triggerBrowserReflow = _interopRequireDefault(__webpack_require__(6998));
	
	var _fadeStyles;
	
	var defaultProps = {
	  in: false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false
	};
	var fadeStyles = (_fadeStyles = {}, _fadeStyles[_Transition.ENTERING] = 'show', _fadeStyles[_Transition.ENTERED] = 'show', _fadeStyles);
	
	var Fade = _react.default.forwardRef(function (_ref, ref) {
	  var className = _ref.className,
	      children = _ref.children,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["className", "children"]);
	  var handleEnter = (0, _react.useCallback)(function (node) {
	    (0, _triggerBrowserReflow.default)(node);
	    if (props.onEnter) props.onEnter(node);
	  }, [props]);
	  return /*#__PURE__*/_react.default.createElement(_Transition.default, (0, _extends2.default)({
	    ref: ref,
	    addEndListener: _transitionEnd.default
	  }, props, {
	    onEnter: handleEnter
	  }), function (status, innerProps) {
	    return _react.default.cloneElement(children, (0, _extends2.default)({}, innerProps, {
	      className: (0, _classnames.default)('fade', className, children.props.className, fadeStyles[status])
	    }));
	  });
	});
	
	Fade.defaultProps = defaultProps;
	Fade.displayName = 'Fade';
	var _default = Fade;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6978 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _FormCheck = _interopRequireDefault(__webpack_require__(646));
	
	var _FormFile = _interopRequireDefault(__webpack_require__(6982));
	
	var _FormControl = _interopRequireDefault(__webpack_require__(6981));
	
	var _FormGroup = _interopRequireDefault(__webpack_require__(6985));
	
	var _FormLabel = _interopRequireDefault(__webpack_require__(6986));
	
	var _FormText = _interopRequireDefault(__webpack_require__(6987));
	
	var _Switch = _interopRequireDefault(__webpack_require__(6995));
	
	var _ThemeProvider = __webpack_require__(48);
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(154));
	
	var defaultProps = {
	  inline: false
	};
	
	var Form = _react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      inline = _ref.inline,
	      className = _ref.className,
	      validated = _ref.validated,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'form' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "inline", "className", "validated", "as"]);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'form');
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    ref: ref,
	    className: (0, _classnames.default)(className, validated && 'was-validated', inline && bsPrefix + "-inline")
	  }));
	});
	
	Form.displayName = 'Form';
	Form.defaultProps = defaultProps;
	Form.Row = (0, _createWithBsPrefix.default)('form-row');
	Form.Group = _FormGroup.default;
	Form.Control = _FormControl.default;
	Form.Check = _FormCheck.default;
	Form.File = _FormFile.default;
	Form.Switch = _Switch.default;
	Form.Label = _FormLabel.default;
	Form.Text = _FormText.default;
	var _default = Form;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6979 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _FormContext = _interopRequireDefault(__webpack_require__(83));
	
	var _ThemeProvider = __webpack_require__(48);
	
	var defaultProps = {
	  type: 'checkbox'
	};
	
	var FormCheckInput = _react.default.forwardRef(function (_ref, ref) {
	  var id = _ref.id,
	      bsPrefix = _ref.bsPrefix,
	      bsCustomPrefix = _ref.bsCustomPrefix,
	      className = _ref.className,
	      isValid = _ref.isValid,
	      isInvalid = _ref.isInvalid,
	      isStatic = _ref.isStatic,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'input' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["id", "bsPrefix", "bsCustomPrefix", "className", "isValid", "isInvalid", "isStatic", "as"]);
	
	  var _useContext = (0, _react.useContext)(_FormContext.default),
	      controlId = _useContext.controlId,
	      custom = _useContext.custom;
	
	  var _ref2 = custom ? [bsCustomPrefix, 'custom-control-input'] : [bsPrefix, 'form-check-input'],
	      prefix = _ref2[0],
	      defaultPrefix = _ref2[1];
	
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(prefix, defaultPrefix);
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    ref: ref,
	    id: id || controlId,
	    className: (0, _classnames.default)(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid', isStatic && 'position-static')
	  }));
	});
	
	FormCheckInput.displayName = 'FormCheckInput';
	FormCheckInput.defaultProps = defaultProps;
	var _default = FormCheckInput;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6980 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _FormContext = _interopRequireDefault(__webpack_require__(83));
	
	var _ThemeProvider = __webpack_require__(48);
	
	var FormCheckLabel = _react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      bsCustomPrefix = _ref.bsCustomPrefix,
	      className = _ref.className,
	      htmlFor = _ref.htmlFor,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "bsCustomPrefix", "className", "htmlFor"]);
	
	  var _useContext = (0, _react.useContext)(_FormContext.default),
	      controlId = _useContext.controlId,
	      custom = _useContext.custom;
	
	  var _ref2 = custom ? [bsCustomPrefix, 'custom-control-label'] : [bsPrefix, 'form-check-label'],
	      prefix = _ref2[0],
	      defaultPrefix = _ref2[1];
	
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(prefix, defaultPrefix);
	  return /*#__PURE__*/_react.default.createElement("label", (0, _extends2.default)({}, props, {
	    ref: ref,
	    htmlFor: htmlFor || controlId,
	    className: (0, _classnames.default)(className, bsPrefix)
	  }));
	});
	
	FormCheckLabel.displayName = 'FormCheckLabel';
	var _default = FormCheckLabel;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6981 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _all = _interopRequireDefault(__webpack_require__(288));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _warning = _interopRequireDefault(__webpack_require__(227));
	
	var _Feedback = _interopRequireDefault(__webpack_require__(289));
	
	var _FormContext = _interopRequireDefault(__webpack_require__(83));
	
	var _ThemeProvider = __webpack_require__(48);
	
	var FormControl = _react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      bsCustomPrefix = _ref.bsCustomPrefix,
	      type = _ref.type,
	      size = _ref.size,
	      id = _ref.id,
	      className = _ref.className,
	      isValid = _ref.isValid,
	      isInvalid = _ref.isInvalid,
	      plaintext = _ref.plaintext,
	      readOnly = _ref.readOnly,
	      custom = _ref.custom,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'input' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "bsCustomPrefix", "type", "size", "id", "className", "isValid", "isInvalid", "plaintext", "readOnly", "custom", "as"]);
	
	  var _useContext = (0, _react.useContext)(_FormContext.default),
	      controlId = _useContext.controlId;
	
	  var _ref2 = custom ? [bsCustomPrefix, 'custom'] : [bsPrefix, 'form-control'],
	      prefix = _ref2[0],
	      defaultPrefix = _ref2[1];
	
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(prefix, defaultPrefix);
	  var classes;
	
	  if (plaintext) {
	    var _classes;
	
	    classes = (_classes = {}, _classes[bsPrefix + "-plaintext"] = true, _classes);
	  } else if (type === 'file') {
	    var _classes2;
	
	    classes = (_classes2 = {}, _classes2[bsPrefix + "-file"] = true, _classes2);
	  } else if (type === 'range') {
	    var _classes3;
	
	    classes = (_classes3 = {}, _classes3[bsPrefix + "-range"] = true, _classes3);
	  } else if (Component === 'select' && custom) {
	    var _classes4;
	
	    classes = (_classes4 = {}, _classes4[bsPrefix + "-select"] = true, _classes4[bsPrefix + "-select-" + size] = size, _classes4);
	  } else {
	    var _classes5;
	
	    classes = (_classes5 = {}, _classes5[bsPrefix] = true, _classes5[bsPrefix + "-" + size] = size, _classes5);
	  }
	
	   false ? (0, _warning.default)(controlId == null || !id, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    type: type,
	    ref: ref,
	    readOnly: readOnly,
	    id: id || controlId,
	    className: (0, _classnames.default)(className, classes, isValid && "is-valid", isInvalid && "is-invalid")
	  }));
	});
	
	FormControl.displayName = 'FormControl';
	FormControl.Feedback = _Feedback.default;
	var _default = FormControl;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6982 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _all = _interopRequireDefault(__webpack_require__(288));
	
	var _Feedback = _interopRequireDefault(__webpack_require__(289));
	
	var _FormFileInput = _interopRequireDefault(__webpack_require__(6983));
	
	var _FormFileLabel = _interopRequireDefault(__webpack_require__(6984));
	
	var _FormContext = _interopRequireDefault(__webpack_require__(83));
	
	var _ThemeProvider = __webpack_require__(48);
	
	var defaultProps = {
	  disabled: false,
	  isValid: false,
	  isInvalid: false
	};
	
	var FormFile = _react.default.forwardRef(function (_ref, ref) {
	  var id = _ref.id,
	      bsPrefix = _ref.bsPrefix,
	      bsCustomPrefix = _ref.bsCustomPrefix,
	      disabled = _ref.disabled,
	      isValid = _ref.isValid,
	      isInvalid = _ref.isInvalid,
	      feedback = _ref.feedback,
	      className = _ref.className,
	      style = _ref.style,
	      label = _ref.label,
	      children = _ref.children,
	      custom = _ref.custom,
	      lang = _ref.lang,
	      dataBrowse = _ref['data-browse'],
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      _ref$inputAs = _ref.inputAs,
	      inputAs = _ref$inputAs === void 0 ? 'input' : _ref$inputAs,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["id", "bsPrefix", "bsCustomPrefix", "disabled", "isValid", "isInvalid", "feedback", "className", "style", "label", "children", "custom", "lang", "data-browse", "as", "inputAs"]);
	
	  var _ref2 = custom ? [bsCustomPrefix, 'custom'] : [bsPrefix, 'form-file'],
	      prefix = _ref2[0],
	      defaultPrefix = _ref2[1];
	
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(prefix, defaultPrefix);
	  var type = 'file';
	
	  var _useContext = (0, _react.useContext)(_FormContext.default),
	      controlId = _useContext.controlId;
	
	  var innerFormContext = (0, _react.useMemo)(function () {
	    return {
	      controlId: id || controlId,
	      custom: custom
	    };
	  }, [controlId, custom, id]);
	  var hasLabel = label != null && label !== false && !children;
	
	  var input = /*#__PURE__*/_react.default.createElement(_FormFileInput.default, (0, _extends2.default)({}, props, {
	    ref: ref,
	    isValid: isValid,
	    isInvalid: isInvalid,
	    disabled: disabled,
	    as: inputAs,
	    lang: lang
	  }));
	
	  return /*#__PURE__*/_react.default.createElement(_FormContext.default.Provider, {
	    value: innerFormContext
	  }, /*#__PURE__*/_react.default.createElement(Component, {
	    style: style,
	    className: (0, _classnames.default)(className, bsPrefix, custom && "custom-" + type)
	  }, children || /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, custom ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, input, hasLabel && /*#__PURE__*/_react.default.createElement(_FormFileLabel.default, {
	    "data-browse": dataBrowse
	  }, label)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasLabel && /*#__PURE__*/_react.default.createElement(_FormFileLabel.default, null, label), input), (isValid || isInvalid) && /*#__PURE__*/_react.default.createElement(_Feedback.default, {
	    type: isValid ? 'valid' : 'invalid'
	  }, feedback))));
	});
	
	FormFile.displayName = 'FormFile';
	FormFile.defaultProps = defaultProps;
	FormFile.Input = _FormFileInput.default;
	FormFile.Label = _FormFileLabel.default;
	var _default = FormFile;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6983 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _FormContext = _interopRequireDefault(__webpack_require__(83));
	
	var _ThemeProvider = __webpack_require__(48);
	
	var FormFileInput = _react.default.forwardRef(function (_ref, ref) {
	  var id = _ref.id,
	      bsPrefix = _ref.bsPrefix,
	      bsCustomPrefix = _ref.bsCustomPrefix,
	      className = _ref.className,
	      isValid = _ref.isValid,
	      isInvalid = _ref.isInvalid,
	      lang = _ref.lang,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'input' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["id", "bsPrefix", "bsCustomPrefix", "className", "isValid", "isInvalid", "lang", "as"]);
	
	  var _useContext = (0, _react.useContext)(_FormContext.default),
	      controlId = _useContext.controlId,
	      custom = _useContext.custom;
	
	  var type = 'file';
	
	  var _ref2 = custom ? [bsCustomPrefix, 'custom-file-input'] : [bsPrefix, 'form-control-file'],
	      prefix = _ref2[0],
	      defaultPrefix = _ref2[1];
	
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(prefix, defaultPrefix);
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    ref: ref,
	    id: id || controlId,
	    type: type,
	    lang: lang,
	    className: (0, _classnames.default)(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
	  }));
	});
	
	FormFileInput.displayName = 'FormFileInput';
	var _default = FormFileInput;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6984 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _FormContext = _interopRequireDefault(__webpack_require__(83));
	
	var _ThemeProvider = __webpack_require__(48);
	
	var FormFileLabel = _react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      bsCustomPrefix = _ref.bsCustomPrefix,
	      className = _ref.className,
	      htmlFor = _ref.htmlFor,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "bsCustomPrefix", "className", "htmlFor"]);
	
	  var _useContext = (0, _react.useContext)(_FormContext.default),
	      controlId = _useContext.controlId,
	      custom = _useContext.custom;
	
	  var _ref2 = custom ? [bsCustomPrefix, 'custom-file-label'] : [bsPrefix, 'form-file-label'],
	      prefix = _ref2[0],
	      defaultPrefix = _ref2[1];
	
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(prefix, defaultPrefix);
	  return /*#__PURE__*/_react.default.createElement("label", (0, _extends2.default)({}, props, {
	    ref: ref,
	    htmlFor: htmlFor || controlId,
	    className: (0, _classnames.default)(className, bsPrefix),
	    "data-browse": props['data-browse']
	  }));
	});
	
	FormFileLabel.displayName = 'FormFileLabel';
	var _default = FormFileLabel;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6985 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _FormContext = _interopRequireDefault(__webpack_require__(83));
	
	var _ThemeProvider = __webpack_require__(48);
	
	var FormGroup = _react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      children = _ref.children,
	      controlId = _ref.controlId,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "className", "children", "controlId", "as"]);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'form-group');
	  var context = (0, _react.useMemo)(function () {
	    return {
	      controlId: controlId
	    };
	  }, [controlId]);
	  return /*#__PURE__*/_react.default.createElement(_FormContext.default.Provider, {
	    value: context
	  }, /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    ref: ref,
	    className: (0, _classnames.default)(className, bsPrefix)
	  }), children));
	});
	
	FormGroup.displayName = 'FormGroup';
	var _default = FormGroup;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6986 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _warning = _interopRequireDefault(__webpack_require__(227));
	
	var _Col = _interopRequireDefault(__webpack_require__(6976));
	
	var _FormContext = _interopRequireDefault(__webpack_require__(83));
	
	var _ThemeProvider = __webpack_require__(48);
	
	var defaultProps = {
	  column: false,
	  srOnly: false
	};
	
	var FormLabel = _react.default.forwardRef(function (_ref, ref) {
	  var _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'label' : _ref$as,
	      bsPrefix = _ref.bsPrefix,
	      column = _ref.column,
	      srOnly = _ref.srOnly,
	      className = _ref.className,
	      htmlFor = _ref.htmlFor,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["as", "bsPrefix", "column", "srOnly", "className", "htmlFor"]);
	
	  var _useContext = (0, _react.useContext)(_FormContext.default),
	      controlId = _useContext.controlId;
	
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'form-label');
	  var columnClass = 'col-form-label';
	  if (typeof column === 'string') columnClass = columnClass + "-" + column;
	  var classes = (0, _classnames.default)(className, bsPrefix, srOnly && 'sr-only', column && columnClass);
	   false ? (0, _warning.default)(controlId == null || !htmlFor, '`controlId` is ignored on `<FormLabel>` when `htmlFor` is specified.') : void 0;
	  htmlFor = htmlFor || controlId;
	  if (column) return /*#__PURE__*/_react.default.createElement(_Col.default, (0, _extends2.default)({
	    as: "label",
	    className: classes,
	    htmlFor: htmlFor
	  }, props));
	  return (
	    /*#__PURE__*/
	    // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
	    _react.default.createElement(Component, (0, _extends2.default)({
	      ref: ref,
	      className: classes,
	      htmlFor: htmlFor
	    }, props))
	  );
	});
	
	FormLabel.displayName = 'FormLabel';
	FormLabel.defaultProps = defaultProps;
	var _default = FormLabel;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6987 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(48);
	
	var FormText = _react.default.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
	function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'small' : _ref$as,
	      muted = _ref.muted,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "className", "as", "muted"]);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'form-text');
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
	    ref: ref,
	    className: (0, _classnames.default)(className, bsPrefix, muted && 'text-muted')
	  }));
	});
	
	FormText.displayName = 'FormText';
	var _default = FormText;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6988 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(154));
	
	var _ThemeProvider = __webpack_require__(48);
	
	/**
	 *
	 * @property {InputGroupAppend} Append
	 * @property {InputGroupPrepend} Prepend
	 * @property {InputGroupText} Text
	 * @property {InputGroupRadio} Radio
	 * @property {InputGroupCheckbox} Checkbox
	 */
	var InputGroup = _react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      size = _ref.size,
	      className = _ref.className,
	      _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'div' : _ref$as,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "size", "className", "as"]);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'input-group');
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    className: (0, _classnames.default)(className, bsPrefix, size && bsPrefix + "-" + size)
	  }));
	});
	
	var InputGroupAppend = (0, _createWithBsPrefix.default)('input-group-append');
	var InputGroupPrepend = (0, _createWithBsPrefix.default)('input-group-prepend');
	var InputGroupText = (0, _createWithBsPrefix.default)('input-group-text', {
	  Component: 'span'
	});
	
	var InputGroupCheckbox = function InputGroupCheckbox(props) {
	  return /*#__PURE__*/_react.default.createElement(InputGroupText, null, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
	    type: "checkbox"
	  }, props)));
	};
	
	var InputGroupRadio = function InputGroupRadio(props) {
	  return /*#__PURE__*/_react.default.createElement(InputGroupText, null, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
	    type: "radio"
	  }, props)));
	};
	
	InputGroup.displayName = 'InputGroup';
	InputGroup.Text = InputGroupText;
	InputGroup.Radio = InputGroupRadio;
	InputGroup.Checkbox = InputGroupCheckbox;
	InputGroup.Append = InputGroupAppend;
	InputGroup.Prepend = InputGroupPrepend;
	var _default = InputGroup;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6989 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(154));
	
	var _default = (0, _createWithBsPrefix.default)('modal-body');
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6990 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeProvider = __webpack_require__(48);
	
	var ModalDialog = _react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      className = _ref.className,
	      centered = _ref.centered,
	      size = _ref.size,
	      children = _ref.children,
	      scrollable = _ref.scrollable,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "className", "centered", "size", "children", "scrollable"]);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'modal');
	  var dialogClass = bsPrefix + "-dialog";
	  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
	    ref: ref,
	    className: (0, _classnames.default)(dialogClass, className, size && bsPrefix + "-" + size, centered && dialogClass + "-centered", scrollable && dialogClass + "-scrollable")
	  }), /*#__PURE__*/_react.default.createElement("div", {
	    className: bsPrefix + "-content"
	  }, children));
	});
	
	ModalDialog.displayName = 'ModalDialog';
	var _default = ModalDialog;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6991 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(154));
	
	var _default = (0, _createWithBsPrefix.default)('modal-footer');
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6992 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(408));
	
	var _ThemeProvider = __webpack_require__(48);
	
	var _CloseButton = _interopRequireDefault(__webpack_require__(6975));
	
	var _ModalContext = _interopRequireDefault(__webpack_require__(647));
	
	var defaultProps = {
	  closeLabel: 'Close',
	  closeButton: false
	};
	
	var ModalHeader = _react.default.forwardRef(function (_ref, ref) {
	  var bsPrefix = _ref.bsPrefix,
	      closeLabel = _ref.closeLabel,
	      closeButton = _ref.closeButton,
	      onHide = _ref.onHide,
	      className = _ref.className,
	      children = _ref.children,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["bsPrefix", "closeLabel", "closeButton", "onHide", "className", "children"]);
	  bsPrefix = (0, _ThemeProvider.useBootstrapPrefix)(bsPrefix, 'modal-header');
	  var context = (0, _react.useContext)(_ModalContext.default);
	  var handleClick = (0, _useEventCallback.default)(function () {
	    if (context) context.onHide();
	    if (onHide) onHide();
	  });
	  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    className: (0, _classnames.default)(className, bsPrefix)
	  }), children, closeButton && /*#__PURE__*/_react.default.createElement(_CloseButton.default, {
	    label: closeLabel,
	    onClick: handleClick
	  }));
	});
	
	ModalHeader.displayName = 'ModalHeader';
	ModalHeader.defaultProps = defaultProps;
	var _default = ModalHeader;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6993 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _createWithBsPrefix = _interopRequireDefault(__webpack_require__(154));
	
	var _divWithClassName = _interopRequireDefault(__webpack_require__(6997));
	
	var DivStyledAsH4 = (0, _divWithClassName.default)('h4');
	
	var _default = (0, _createWithBsPrefix.default)('modal-title', {
	  Component: DivStyledAsH4
	});
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6994 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(6996));
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, DropdownItems, etc.
	 */
	
	
	var SafeAnchor = _react.default.forwardRef(function (_ref, ref) {
	  var _ref$as = _ref.as,
	      Component = _ref$as === void 0 ? 'a' : _ref$as,
	      disabled = _ref.disabled,
	      onKeyDown = _ref.onKeyDown,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["as", "disabled", "onKeyDown"]);
	
	  var handleClick = function handleClick(event) {
	    var href = props.href,
	        onClick = props.onClick;
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    if (event.key === ' ') {
	      event.preventDefault();
	      handleClick(event);
	    }
	  };
	
	  if (isTrivialHref(props.href)) {
	    props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
	    // otherwise, the cursor incorrectly styled (except with role='button')
	
	    props.href = props.href || '#';
	  }
	
	  if (disabled) {
	    props.tabIndex = -1;
	    props['aria-disabled'] = true;
	  }
	
	  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	    ref: ref
	  }, props, {
	    onClick: handleClick,
	    onKeyDown: (0, _createChainedFunction.default)(handleKeyDown, onKeyDown)
	  }));
	});
	
	SafeAnchor.displayName = 'SafeAnchor';
	var _default = SafeAnchor;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6995 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _FormCheck = _interopRequireDefault(__webpack_require__(646));
	
	var Switch = _react.default.forwardRef(function (props, ref) {
	  return /*#__PURE__*/_react.default.createElement(_FormCheck.default, (0, _extends2.default)({}, props, {
	    ref: ref,
	    type: "switch"
	  }));
	});
	
	Switch.displayName = 'Switch';
	Switch.Input = _FormCheck.default.Input;
	Switch.Label = _FormCheck.default.Label;
	var _default = Switch;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6996 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) return f;
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	var _default = createChainedFunction;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _default = function _default(className) {
	  return _react.default.forwardRef(function (p, ref) {
	    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, p, {
	      ref: ref,
	      className: (0, _classnames.default)(p.className, className)
	    }));
	  });
	};
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 6998 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = triggerBrowserReflow;
	
	// reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	function triggerBrowserReflow(node) {
	  node.offsetHeight; // eslint-disable-line no-unused-expressions
	}
	
	module.exports = exports["default"];

/***/ },
/* 6999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _canvasGauges = __webpack_require__(429);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactLinearGauge = function (_React$Component) {
	  _inherits(ReactLinearGauge, _React$Component);
	
	  function ReactLinearGauge() {
	    _classCallCheck(this, ReactLinearGauge);
	
	    return _possibleConstructorReturn(this, (ReactLinearGauge.__proto__ || Object.getPrototypeOf(ReactLinearGauge)).apply(this, arguments));
	  }
	
	  _createClass(ReactLinearGauge, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var options = Object.assign({}, this.props, {
	        renderTo: this.el
	      });
	      this.gauge = new _canvasGauges.LinearGauge(options).draw();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.gauge.update(nextProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement('canvas', { ref: function ref(canvas) {
	          _this2.el = canvas;
	        } });
	    }
	  }]);
	
	  return ReactLinearGauge;
	}(_react2.default.Component);
	
	exports.default = ReactLinearGauge;

/***/ },
/* 7000 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _canvasGauges = __webpack_require__(429);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactRadialGauge = function (_React$Component) {
	  _inherits(ReactRadialGauge, _React$Component);
	
	  function ReactRadialGauge() {
	    _classCallCheck(this, ReactRadialGauge);
	
	    return _possibleConstructorReturn(this, (ReactRadialGauge.__proto__ || Object.getPrototypeOf(ReactRadialGauge)).apply(this, arguments));
	  }
	
	  _createClass(ReactRadialGauge, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var options = Object.assign({}, this.props, {
	        renderTo: this.el
	      });
	      this.gauge = new _canvasGauges.RadialGauge(options).draw();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.gauge.update(nextProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement('canvas', { ref: function ref(canvas) {
	          _this2.el = canvas;
	        } });
	    }
	  }]);
	
	  return ReactRadialGauge;
	}(_react2.default.Component);
	
	exports.default = ReactRadialGauge;

/***/ },
/* 7001 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RadialGauge = exports.LinearGauge = undefined;
	
	var _LinearGauge = __webpack_require__(6999);
	
	var _LinearGauge2 = _interopRequireDefault(_LinearGauge);
	
	var _RadialGauge = __webpack_require__(7000);
	
	var _RadialGauge2 = _interopRequireDefault(_RadialGauge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.LinearGauge = _LinearGauge2.default;
	exports.RadialGauge = _RadialGauge2.default;

/***/ },
/* 7002 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.13.1
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(2),n=__webpack_require__(287),r=__webpack_require__(7217);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
	function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
	function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
	function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
	function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
	function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
	function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
	function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
	Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
	C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
	function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
	60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
	function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
	function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
	function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
	ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
	var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
	function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
	function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
	function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
	function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
	function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
	function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
	ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
	var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
	function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
	function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
	function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
	function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
	function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
	var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
	"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
	ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
	ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
	var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
	function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
	function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
	var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
	function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
	function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
	function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
	function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
	function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
	function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
	function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
	b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
	function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
	function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
	function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
	n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
	var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
	function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
	function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
	var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
	b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
	var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
	function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
	var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
	Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
	var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
	a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
	k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
	function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
	var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
	function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
	var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
	case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
	a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
	Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
	We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
	function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
	function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
	var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
	function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
	function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
	function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
	function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
	function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
	function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
	function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
	ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
	(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
	function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
	var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
	c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
	function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
	function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
	(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
	function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
	function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
	nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
	m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
	if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
	q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
	k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
	d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
	function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
	function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
	var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
	function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
	function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
	function vh(a,b){return"function"===typeof b?b(a):b}
	function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
	(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
	function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
	function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
	function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
	function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
	function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
	d)}}
	var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
	b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
	c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
	wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
	b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
	function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
	function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
	function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
	typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
	typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
	x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
	("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
	function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
	var ii={dehydrated:null,retryTime:0};
	function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
	c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
	function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
	ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
	pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
	qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
	return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
	{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
	(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
	a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
	d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
	break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
	c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
	e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
	64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
	e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
	b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
	b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
	var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
	function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
	function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
	function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
	case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
	function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
	function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
	function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
	function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
	function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
	case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
	d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
	f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
	function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
	function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
	function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
	function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
	function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
	function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
	c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
	d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
	Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
	function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
	function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
	function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
	function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
	null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
	break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
	jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
	function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
	function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
	a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
	function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
	d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
	m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
	null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
	-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
	(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
	top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
	null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
	function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
	function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
	Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
	if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
	b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
	null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
	case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
	null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
	b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
	k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
	g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
	b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
	function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
	function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
	10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
	function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
	function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
	function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
	function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
	za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
	Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
	(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.13.1",
	rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
	exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
	exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.13.1";


/***/ },
/* 7003 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _activeElement = _interopRequireDefault(__webpack_require__(6712));
	
	var _contains = _interopRequireDefault(__webpack_require__(6714));
	
	var _canUseDOM = _interopRequireDefault(__webpack_require__(176));
	
	var _listen = _interopRequireDefault(__webpack_require__(436));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(45));
	
	var _useMounted = _interopRequireDefault(__webpack_require__(6642));
	
	var _useWillUnmount = _interopRequireDefault(__webpack_require__(6645));
	
	var _usePrevious = _interopRequireDefault(__webpack_require__(6643));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(408));
	
	var _ModalManager = _interopRequireDefault(__webpack_require__(648));
	
	var _useWaitForDOMRef = _interopRequireDefault(__webpack_require__(7006));
	
	/* eslint-disable @typescript-eslint/no-use-before-define */
	
	/* eslint-disable react/prop-types */
	var manager;
	
	function getManager() {
	  if (!manager) manager = new _ModalManager["default"]();
	  return manager;
	}
	
	function useModalManager(provided) {
	  var modalManager = provided || getManager();
	  var modal = (0, _react.useRef)({
	    dialog: null,
	    backdrop: null
	  });
	  return Object.assign(modal.current, {
	    add: function add(container, className) {
	      return modalManager.add(modal.current, container, className);
	    },
	    remove: function remove() {
	      return modalManager.remove(modal.current);
	    },
	    isTopModal: function isTopModal() {
	      return modalManager.isTopModal(modal.current);
	    },
	    setDialogRef: (0, _react.useCallback)(function (ref) {
	      modal.current.dialog = ref;
	    }, []),
	    setBackdropRef: (0, _react.useCallback)(function (ref) {
	      modal.current.backdrop = ref;
	    }, [])
	  });
	}
	
	var Modal = (0, _react.forwardRef)(function (_ref, ref) {
	  var _ref$show = _ref.show,
	      show = _ref$show === void 0 ? false : _ref$show,
	      _ref$role = _ref.role,
	      role = _ref$role === void 0 ? 'dialog' : _ref$role,
	      className = _ref.className,
	      style = _ref.style,
	      children = _ref.children,
	      _ref$backdrop = _ref.backdrop,
	      backdrop = _ref$backdrop === void 0 ? true : _ref$backdrop,
	      _ref$keyboard = _ref.keyboard,
	      keyboard = _ref$keyboard === void 0 ? true : _ref$keyboard,
	      onBackdropClick = _ref.onBackdropClick,
	      onEscapeKeyDown = _ref.onEscapeKeyDown,
	      transition = _ref.transition,
	      backdropTransition = _ref.backdropTransition,
	      _ref$autoFocus = _ref.autoFocus,
	      autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus,
	      _ref$enforceFocus = _ref.enforceFocus,
	      enforceFocus = _ref$enforceFocus === void 0 ? true : _ref$enforceFocus,
	      _ref$restoreFocus = _ref.restoreFocus,
	      restoreFocus = _ref$restoreFocus === void 0 ? true : _ref$restoreFocus,
	      restoreFocusOptions = _ref.restoreFocusOptions,
	      renderDialog = _ref.renderDialog,
	      _ref$renderBackdrop = _ref.renderBackdrop,
	      renderBackdrop = _ref$renderBackdrop === void 0 ? function (props) {
	    return /*#__PURE__*/_react["default"].createElement("div", props);
	  } : _ref$renderBackdrop,
	      providedManager = _ref.manager,
	      containerRef = _ref.container,
	      containerClassName = _ref.containerClassName,
	      onShow = _ref.onShow,
	      _ref$onHide = _ref.onHide,
	      onHide = _ref$onHide === void 0 ? function () {} : _ref$onHide,
	      onExit = _ref.onExit,
	      onExited = _ref.onExited,
	      onExiting = _ref.onExiting,
	      onEnter = _ref.onEnter,
	      onEntering = _ref.onEntering,
	      onEntered = _ref.onEntered,
	      rest = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["show", "role", "className", "style", "children", "backdrop", "keyboard", "onBackdropClick", "onEscapeKeyDown", "transition", "backdropTransition", "autoFocus", "enforceFocus", "restoreFocus", "restoreFocusOptions", "renderDialog", "renderBackdrop", "manager", "container", "containerClassName", "onShow", "onHide", "onExit", "onExited", "onExiting", "onEnter", "onEntering", "onEntered"]);
	  var container = (0, _useWaitForDOMRef["default"])(containerRef);
	  var modal = useModalManager(providedManager);
	  var isMounted = (0, _useMounted["default"])();
	  var prevShow = (0, _usePrevious["default"])(show);
	
	  var _useState = (0, _react.useState)(!show),
	      exited = _useState[0],
	      setExited = _useState[1];
	
	  var lastFocusRef = (0, _react.useRef)(null);
	  (0, _react.useImperativeHandle)(ref, function () {
	    return modal;
	  }, [modal]);
	
	  if (_canUseDOM["default"] && !prevShow && show) {
	    lastFocusRef.current = (0, _activeElement["default"])();
	  }
	
	  if (!transition && !show && !exited) {
	    setExited(true);
	  } else if (show && exited) {
	    setExited(false);
	  }
	
	  var handleShow = (0, _useEventCallback["default"])(function () {
	    modal.add(container, containerClassName);
	    removeKeydownListenerRef.current = (0, _listen["default"])(document, 'keydown', handleDocumentKeyDown);
	    removeFocusListenerRef.current = (0, _listen["default"])(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
	    // and so steals focus from it
	    function () {
	      return setTimeout(handleEnforceFocus);
	    }, true);
	
	    if (onShow) {
	      onShow();
	    } // autofocus after onShow to not trigger a focus event for previous
	    // modals before this one is shown.
	
	
	    if (autoFocus) {
	      var currentActiveElement = (0, _activeElement["default"])(document);
	
	      if (modal.dialog && currentActiveElement && !(0, _contains["default"])(modal.dialog, currentActiveElement)) {
	        lastFocusRef.current = currentActiveElement;
	        modal.dialog.focus();
	      }
	    }
	  });
	  var handleHide = (0, _useEventCallback["default"])(function () {
	    modal.remove();
	    removeKeydownListenerRef.current == null ? void 0 : removeKeydownListenerRef.current();
	    removeFocusListenerRef.current == null ? void 0 : removeFocusListenerRef.current();
	
	    if (restoreFocus) {
	      var _lastFocusRef$current;
	
	      // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	      (_lastFocusRef$current = lastFocusRef.current) == null ? void 0 : _lastFocusRef$current.focus == null ? void 0 : _lastFocusRef$current.focus(restoreFocusOptions);
	      lastFocusRef.current = null;
	    }
	  }); // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
	  // Show logic when:
	  //  - show is `true` _and_ `container` has resolved
	
	  (0, _react.useEffect)(function () {
	    if (!show || !container) return;
	    handleShow();
	  }, [show, container,
	  /* should never change: */
	  handleShow]); // Hide cleanup logic when:
	  //  - `exited` switches to true
	  //  - component unmounts;
	
	  (0, _react.useEffect)(function () {
	    if (!exited) return;
	    handleHide();
	  }, [exited, handleHide]);
	  (0, _useWillUnmount["default"])(function () {
	    handleHide();
	  }); // --------------------------------
	
	  var handleEnforceFocus = (0, _useEventCallback["default"])(function () {
	    if (!enforceFocus || !isMounted() || !modal.isTopModal()) {
	      return;
	    }
	
	    var currentActiveElement = (0, _activeElement["default"])();
	
	    if (modal.dialog && currentActiveElement && !(0, _contains["default"])(modal.dialog, currentActiveElement)) {
	      modal.dialog.focus();
	    }
	  });
	  var handleBackdropClick = (0, _useEventCallback["default"])(function (e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    onBackdropClick == null ? void 0 : onBackdropClick(e);
	
	    if (backdrop === true) {
	      onHide();
	    }
	  });
	  var handleDocumentKeyDown = (0, _useEventCallback["default"])(function (e) {
	    if (keyboard && e.keyCode === 27 && modal.isTopModal()) {
	      onEscapeKeyDown == null ? void 0 : onEscapeKeyDown(e);
	
	      if (!e.defaultPrevented) {
	        onHide();
	      }
	    }
	  });
	  var removeFocusListenerRef = (0, _react.useRef)();
	  var removeKeydownListenerRef = (0, _react.useRef)();
	
	  var handleHidden = function handleHidden() {
	    setExited(true);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    onExited == null ? void 0 : onExited.apply(void 0, args);
	  };
	
	  var Transition = transition;
	
	  if (!container || !(show || Transition && !exited)) {
	    return null;
	  }
	
	  var dialogProps = (0, _extends2["default"])((0, _extends2["default"])({
	    role: role,
	    ref: modal.setDialogRef,
	    // apparently only works on the dialog role element
	    'aria-modal': role === 'dialog' ? true : undefined
	  }, rest), {}, {
	    style: style,
	    className: className,
	    tabIndex: -1
	  });
	  var dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/_react["default"].createElement("div", dialogProps, _react["default"].cloneElement(children, {
	    role: 'document'
	  }));
	
	  if (Transition) {
	    dialog = /*#__PURE__*/_react["default"].createElement(Transition, {
	      appear: true,
	      unmountOnExit: true,
	      "in": !!show,
	      onExit: onExit,
	      onExiting: onExiting,
	      onExited: handleHidden,
	      onEnter: onEnter,
	      onEntering: onEntering,
	      onEntered: onEntered
	    }, dialog);
	  }
	
	  var backdropElement = null;
	
	  if (backdrop) {
	    var BackdropTransition = backdropTransition;
	    backdropElement = renderBackdrop({
	      ref: modal.setBackdropRef,
	      onClick: handleBackdropClick
	    });
	
	    if (BackdropTransition) {
	      backdropElement = /*#__PURE__*/_react["default"].createElement(BackdropTransition, {
	        appear: true,
	        "in": !!show
	      }, backdropElement);
	    }
	  }
	
	  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, _reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, backdropElement, dialog), container));
	});
	var propTypes = {
	  /**
	   * Set the visibility of the Modal
	   */
	  show: _propTypes["default"].bool,
	
	  /**
	   * A DOM element, a `ref` to an element, or function that returns either. The Modal is appended to it's `container` element.
	   *
	   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	   * page content can be placed behind a virtual backdrop as well as a visual one.
	   */
	  container: _propTypes["default"].any,
	
	  /**
	   * A callback fired when the Modal is opening.
	   */
	  onShow: _propTypes["default"].func,
	
	  /**
	   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	   *
	   * The `onHide` callback only signals intent from the Modal,
	   * you must actually set the `show` prop to `false` for the Modal to close.
	   */
	  onHide: _propTypes["default"].func,
	
	  /**
	   * Include a backdrop component.
	   */
	  backdrop: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['static'])]),
	
	  /**
	   * A function that returns the dialog component. Useful for custom
	   * rendering. **Note:** the component should make sure to apply the provided ref.
	   *
	   * ```js static
	   * renderDialog={props => <MyDialog {...props} />}
	   * ```
	   */
	  renderDialog: _propTypes["default"].func,
	
	  /**
	   * A function that returns a backdrop component. Useful for custom
	   * backdrop rendering.
	   *
	   * ```js
	   *  renderBackdrop={props => <MyBackdrop {...props} />}
	   * ```
	   */
	  renderBackdrop: _propTypes["default"].func,
	
	  /**
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   *
	   * If preventDefault() is called on the keyboard event, closing the modal will be cancelled.
	   */
	  onEscapeKeyDown: _propTypes["default"].func,
	
	  /**
	   * A callback fired when the backdrop, if specified, is clicked.
	   */
	  onBackdropClick: _propTypes["default"].func,
	
	  /**
	   * A css class or set of classes applied to the modal container when the modal is open,
	   * and removed when it is closed.
	   */
	  containerClassName: _propTypes["default"].string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes["default"].bool,
	
	  /**
	   * A `react-transition-group@2.0.0` `<Transition/>` component used
	   * to control animations for the dialog component.
	   */
	  transition: _propTypes["default"].elementType,
	
	  /**
	   * A `react-transition-group@2.0.0` `<Transition/>` component used
	   * to control animations for the backdrop components.
	   */
	  backdropTransition: _propTypes["default"].elementType,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes. This also
	   * works correctly with any Modal children that have the `autoFocus` prop.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  autoFocus: _propTypes["default"].bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while open.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  enforceFocus: _propTypes["default"].bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes["default"].bool,
	
	  /**
	   * Options passed to focus function when `restoreFocus` is set to `true`
	   *
	   * @link  https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#Parameters
	   */
	  restoreFocusOptions: _propTypes["default"].shape({
	    preventScroll: _propTypes["default"].bool
	  }),
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes["default"].func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes["default"].func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes["default"].func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes["default"].func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes["default"].func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes["default"].func,
	
	  /**
	   * A ModalManager instance used to track and manage the state of open
	   * Modals. Useful when customizing how modals interact within a container
	   */
	  manager: _propTypes["default"].instanceOf(_ModalManager["default"])
	};
	Modal.displayName = 'Modal';
	Modal.propTypes = propTypes;
	
	var _default = Object.assign(Modal, {
	  Manager: _ModalManager["default"]
	});
	
	exports["default"] = _default;
	module.exports = exports.default;

/***/ },
/* 7004 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports["default"] = isOverflowing;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(6721));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(135));
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _isWindow["default"])(node) ? (0, _ownerDocument["default"])() : (0, _ownerDocument["default"])(node);
	  var win = (0, _isWindow["default"])(node) || doc.defaultView;
	  return doc.body.clientWidth < win.innerWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow["default"])(container);
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	
	module.exports = exports.default;

/***/ },
/* 7005 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, exclude, cb) {
	  [].forEach.call(container.children, function (node) {
	    if (exclude.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) return;
	
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, _ref2) {
	  var dialog = _ref2.dialog,
	      backdrop = _ref2.backdrop;
	  siblings(container, [dialog, backdrop], function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, _ref3) {
	  var dialog = _ref3.dialog,
	      backdrop = _ref3.backdrop;
	  siblings(container, [dialog, backdrop], function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ },
/* 7006 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	exports.__esModule = true;
	exports["default"] = useWaitForDOMRef;
	exports.resolveContainerRef = void 0;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(135));
	
	var _react = __webpack_require__(2);
	
	var resolveContainerRef = function resolveContainerRef(ref) {
	  var _ref;
	
	  if (typeof document === 'undefined') return null;
	  if (ref == null) return (0, _ownerDocument["default"])().body;
	  if (typeof ref === 'function') ref = ref();
	  if (ref && 'current' in ref) ref = ref.current;
	  if ((_ref = ref) == null ? void 0 : _ref.nodeType) return ref || null;
	  return null;
	};
	
	exports.resolveContainerRef = resolveContainerRef;
	
	function useWaitForDOMRef(ref, onResolved) {
	  var _useState = (0, _react.useState)(function () {
	    return resolveContainerRef(ref);
	  }),
	      resolvedRef = _useState[0],
	      setRef = _useState[1];
	
	  if (!resolvedRef) {
	    var earlyRef = resolveContainerRef(ref);
	    if (earlyRef) setRef(earlyRef);
	  }
	
	  (0, _react.useEffect)(function () {
	    if (onResolved && resolvedRef) {
	      onResolved(resolvedRef);
	    }
	  }, [onResolved, resolvedRef]);
	  (0, _react.useEffect)(function () {
	    var nextRef = resolveContainerRef(ref);
	
	    if (nextRef !== resolvedRef) {
	      setRef(nextRef);
	    }
	  }, [ref, resolvedRef]);
	  return resolvedRef;
	}

/***/ },
/* 7007 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(o){return o&&o.__esModule?o:{default:o}}function _objectWithoutProperties(o,e){var r={};for(var t in o)e.indexOf(t)>=0||Object.prototype.hasOwnProperty.call(o,t)&&(r[t]=o[t]);return r}function make(o,e){var r=e.distance,t=e.left,p=e.right,a=e.up,l=e.down,i=e.top,u=e.bottom,n=e.big,s=e.mirror,d=e.opposite,_=(r?r.toString():0)+((t?1:0)|(p?2:0)|(i||l?4:0)|(u||a?8:0)|(s?16:0)|(d?32:0)|(o?64:0)|(n?128:0));if(lookup.hasOwnProperty(_))return lookup[_];var f=t||p||a||l||i||u,y=void 0,b=void 0;if(f){if(!s!=!(o&&d)){var v=[p,t,u,i,l,a];t=v[0],p=v[1],i=v[2],u=v[3],a=v[4],l=v[5]}var c=r||(n?"2000px":"100%");y=t?"-"+c:p?c:"0",b=l||i?"-"+c:a||u?c:"0"}return lookup[_]=(0,_globals.animation)((o?"to":"from")+" {opacity: 0;"+(f?" transform: translate3d("+y+", "+b+", 0);":"")+"}\n     "+(o?"from":"to")+" {opacity: 1;transform: none;} "),lookup[_]}function Fade(){var o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:_globals.defaults,e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],r=o.children,t=(o.out,o.forever),p=o.timeout,a=o.duration,l=void 0===a?_globals.defaults.duration:a,i=o.delay,u=void 0===i?_globals.defaults.delay:i,n=o.count,s=void 0===n?_globals.defaults.count:n,d=_objectWithoutProperties(o,["children","out","forever","timeout","duration","delay","count"]),_={make:make,duration:void 0===p?l:p,delay:u,forever:t,count:s,style:{animationFillMode:"both"},reverse:d.left};return e?(0,_wrap2.default)(d,_,_,r):_}Object.defineProperty(exports,"__esModule",{value:!0});var _propTypes=__webpack_require__(5),_globals=__webpack_require__(290),_wrap=__webpack_require__(649),_wrap2=_interopRequireDefault(_wrap),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,big:_propTypes.bool,mirror:_propTypes.bool,opposite:_propTypes.bool,duration:_propTypes.number,timeout:_propTypes.number,distance:_propTypes.string,delay:_propTypes.number,count:_propTypes.number,forever:_propTypes.bool},lookup={};Fade.propTypes=propTypes,exports.default=Fade,module.exports=exports.default;

/***/ },
/* 7008 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e}}function _defineProperty(e,t,i){return t in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(exports,"__esModule",{value:!0});var _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},_slicedToArray=function(){function e(e,t){var i=[],s=!0,o=!1,n=void 0;try{for(var r,a=e[Symbol.iterator]();!(s=(r=a.next()).done)&&(i.push(r.value),!t||i.length!==t);s=!0);}catch(e){o=!0,n=e}finally{try{!s&&a.return&&a.return()}finally{if(o)throw n}}return i}return function(t,i){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,i);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var i=arguments[t];for(var s in i)Object.prototype.hasOwnProperty.call(i,s)&&(e[s]=i[s])}return e},_createClass=function(){function e(e,t){for(var i=0;i<t.length;i++){var s=t[i];s.enumerable=s.enumerable||!1,s.configurable=!0,"value"in s&&(s.writable=!0),Object.defineProperty(e,s.key,s)}}return function(t,i,s){return i&&e(t.prototype,i),s&&e(t,s),t}}(),_react=__webpack_require__(2),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(5),_globals=__webpack_require__(290),inOut=(0,_propTypes.shape)({make:_propTypes.func,duration:_propTypes.number.isRequired,delay:_propTypes.number.isRequired,forever:_propTypes.bool,count:_propTypes.number.isRequired,style:_propTypes.object.isRequired,reverse:_propTypes.bool}),propTypes={collapse:_propTypes.bool,collapseEl:_propTypes.element,cascade:_propTypes.bool,wait:_propTypes.number,force:_propTypes.bool,disabled:_propTypes.bool,appear:_propTypes.bool,enter:_propTypes.bool,exit:_propTypes.bool,fraction:_propTypes.number,refProp:_propTypes.string,innerRef:_propTypes.func,onReveal:_propTypes.func,unmountOnExit:_propTypes.bool,mountOnEnter:_propTypes.bool,inEffect:inOut.isRequired,outEffect:(0,_propTypes.oneOfType)([inOut,(0,_propTypes.oneOf)([!1])]).isRequired,ssrReveal:_propTypes.bool,collapseOnly:_propTypes.bool,ssrFadeout:_propTypes.bool},defaultProps={fraction:.2,refProp:"ref"},contextTypes={transitionGroup:_propTypes.object},RevealBase=function(e){function t(e,i){_classCallCheck(this,t);var s=_possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e,i));return s.isOn=void 0===e.when||!!e.when,s.state={collapse:e.collapse?t.getInitialCollapseStyle(e):void 0,style:{opacity:s.isOn&&!e.ssrReveal||!e.outEffect?void 0:0}},s.savedChild=!1,s.isShown=!1,_globals.observerMode?s.handleObserve=s.handleObserve.bind(s):(s.revealHandler=s.makeHandler(s.reveal),s.resizeHandler=s.makeHandler(s.resize)),s.saveRef=s.saveRef.bind(s),s}return _inherits(t,e),_createClass(t,[{key:"saveRef",value:function(e){this.childRef&&this.childRef(e),this.props.innerRef&&this.props.innerRef(e),this.el!==e&&(this.el=e&&"offsetHeight"in e?e:void 0,this.observe(this.props,!0))}},{key:"invisible",value:function(){this&&this.el&&(this.savedChild=!1,this.isShown||(this.setState({hasExited:!0,collapse:this.props.collapse?_extends({},this.state.collapse,{visibility:"hidden"}):null,style:{opacity:0}}),!_globals.observerMode&&this.props.collapse&&window.document.dispatchEvent(_globals.collapseend)))}},{key:"animationEnd",value:function(e,t,i){var s=this,o=i.forever,n=i.count,r=i.delay,a=i.duration;if(!o){var l=function(){s&&s.el&&(s.animationEndTimeout=void 0,e.call(s))};this.animationEndTimeout=window.setTimeout(l,r+(a+(t?a:0)*n))}}},{key:"getDimensionValue",value:function(){return this.el.offsetHeight+parseInt(window.getComputedStyle(this.el,null).getPropertyValue("margin-top"),10)+parseInt(window.getComputedStyle(this.el,null).getPropertyValue("margin-bottom"),10)}},{key:"collapse",value:function(e,t,i){var s=i.duration+(t.cascade?i.duration:0),o=this.isOn?this.getDimensionValue():0,n=void 0,r=void 0;if(t.collapseOnly)n=i.duration/3,r=i.delay;else{var a=s>>2,l=a>>1;n=a,r=i.delay+(this.isOn?0:s-a-l),e.style.animationDuration=s-a+(this.isOn?l:-l)+"ms",e.style.animationDelay=i.delay+(this.isOn?a-l:0)+"ms"}return e.collapse={height:o,transition:"height "+n+"ms ease "+r+"ms",overflow:t.collapseOnly?"hidden":void 0},e}},{key:"animate",value:function(e){if(this&&this.el&&(this.unlisten(),this.isShown!==this.isOn)){this.isShown=this.isOn;var t=!this.isOn&&e.outEffect,i=e[t?"outEffect":"inEffect"],s="style"in i&&i.style.animationName||void 0,o=void 0;e.collapseOnly?o={hasAppeared:!0,hasExited:!1,style:{opacity:1}}:((e.outEffect||this.isOn)&&i.make&&(s=i.make),o={hasAppeared:!0,hasExited:!1,collapse:void 0,style:_extends({},i.style,{animationDuration:i.duration+"ms",animationDelay:i.delay+"ms",animationIterationCount:i.forever?"infinite":i.count,opacity:1,animationName:s}),className:i.className}),this.setState(e.collapse?this.collapse(o,e,i):o),t?(this.savedChild=_react2.default.cloneElement(this.getChild()),this.animationEnd(this.invisible,e.cascade,i)):this.savedChild=!1,this.onReveal(e)}}},{key:"onReveal",value:function(e){e.onReveal&&this.isOn&&(this.onRevealTimeout&&(this.onRevealTimeout=window.clearTimeout(this.onRevealTimeout)),e.wait?this.onRevealTimeout=window.setTimeout(e.onReveal,e.wait):e.onReveal())}},{key:"componentWillUnmount",value:function(){this.unlisten(),_globals.ssr&&(0,_globals.disableSsr)()}},{key:"handleObserve",value:function(e,t){_slicedToArray(e,1)[0].intersectionRatio>0&&(t.disconnect(),this.observer=null,this.reveal(this.props,!0))}},{key:"observe",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(this.el&&_globals.observerMode){if(this.observer){if(!t)return;this.observer.disconnect()}else if(t)return;this.observer=new IntersectionObserver(this.handleObserve,{threshold:e.fraction}),this.observer.observe(this.el)}}},{key:"reveal",value:function(e){var t=this,i=arguments.length>1&&void 0!==arguments[1]&&arguments[1];_globals.globalHide||(0,_globals.hideAll)(),this&&this.el&&(e||(e=this.props),_globals.ssr&&(0,_globals.disableSsr)(),this.isOn&&this.isShown&&void 0!==e.spy?(this.isShown=!1,this.setState({style:{}}),window.setTimeout(function(){return t.reveal(e)},200)):i||this.inViewport(e)||e.force?this.animate(e):_globals.observerMode?this.observe(e):this.listen())}},{key:"componentDidMount",value:function(){var e=this;if(this.el&&!this.props.disabled){this.props.collapseOnly||("make"in this.props.inEffect&&this.props.inEffect.make(!1,this.props),void 0!==this.props.when&&this.props.outEffect&&"make"in this.props.outEffect&&this.props.outEffect.make(!0,this.props));var i=this.context.transitionGroup,s=i&&!i.isMounting?!("enter"in this.props&&!1===this.props.enter):this.props.appear;return this.isOn&&((void 0!==this.props.when||void 0!==this.props.spy)&&!s||_globals.ssr&&!_globals.fadeOutEnabled&&!this.props.ssrFadeout&&this.props.outEffect&&!this.props.ssrReveal&&t.getTop(this.el)<window.pageYOffset+window.innerHeight)?(this.isShown=!0,this.setState({hasAppeared:!0,collapse:this.props.collapse?{height:this.getDimensionValue()}:this.state.collapse,style:{opacity:1}}),void this.onReveal(this.props)):_globals.ssr&&(_globals.fadeOutEnabled||this.props.ssrFadeout)&&this.props.outEffect&&t.getTop(this.el)<window.pageYOffset+window.innerHeight?(this.setState({style:{opacity:0,transition:"opacity 1000ms 1000ms"}}),void window.setTimeout(function(){return e.reveal(e.props,!0)},2e3)):void(this.isOn&&(this.props.force?this.animate(this.props):this.reveal(this.props)))}}},{key:"cascade",value:function(e){var t=this,i=void 0;i="string"==typeof e?e.split("").map(function(e,t){return _react2.default.createElement("span",{key:t,style:{display:"inline-block",whiteSpace:"pre"}},e)}):_react2.default.Children.toArray(e);var s=this.props[this.isOn||!this.props.outEffect?"inEffect":"outEffect"],o=s.duration,n=s.reverse,r=i.length,a=2*o;this.props.collapse&&(a=parseInt(this.state.style.animationDuration,10),o=a/2);var l=n?r:0;return i=i.map(function(e){return"object"===(void 0===e?"undefined":_typeof(e))&&e?_react2.default.cloneElement(e,{style:_extends({},e.props.style,t.state.style,{animationDuration:Math.round((0,_globals.cascade)(n?l--:l++,0,r,o,a))+"ms"})}):e})}},{key:"componentWillReceiveProps",value:function(e){if(void 0!==e.when&&(this.isOn=!!e.when),e.fraction!==this.props.fraction&&this.observe(e,!0),!this.isOn&&e.onExited&&"exit"in e&&!1===e.exit)return void e.onExited();e.disabled||(e.collapse&&!this.props.collapse&&(this.setState({style:{},collapse:t.getInitialCollapseStyle(e)}),this.isShown=!1),e.when===this.props.when&&e.spy===this.props.spy||this.reveal(e),this.onRevealTimeout&&!this.isOn&&(this.onRevealTimeout=window.clearTimeout(this.onRevealTimeout)))}},{key:"getChild",value:function(){if(this.savedChild&&!this.props.disabled)return this.savedChild;if("object"===_typeof(this.props.children)){var e=_react2.default.Children.only(this.props.children);return"type"in e&&"string"==typeof e.type||"ref"!==this.props.refProp?e:_react2.default.createElement("div",null,e)}return _react2.default.createElement("div",null,this.props.children)}},{key:"render",value:function(){var e=void 0;e=this.state.hasAppeared?!this.props.unmountOnExit||!this.state.hasExited||this.isOn:!this.props.mountOnEnter||this.isOn;var t=this.getChild();"function"==typeof t.ref&&(this.childRef=t.ref);var i=!1,s=t.props,o=s.style,n=s.className,r=s.children,a=this.props.disabled?n:(this.props.outEffect?_globals.namespace:"")+(this.state.className?" "+this.state.className:"")+(n?" "+n:"")||void 0,l=void 0;"function"==typeof this.state.style.animationName&&(this.state.style.animationName=this.state.style.animationName(!this.isOn,this.props)),this.props.cascade&&!this.props.disabled&&r&&this.state.style.animationName?(i=this.cascade(r),l=_extends({},o,{opacity:1})):l=this.props.disabled?o:_extends({},o,this.state.style);var p=_extends({},this.props.props,_defineProperty({className:a,style:l},this.props.refProp,this.saveRef)),h=_react2.default.cloneElement(t,p,e?i||r:void 0);return void 0!==this.props.collapse?this.props.collapseEl?_react2.default.cloneElement(this.props.collapseEl,{style:_extends({},this.props.collapseEl.style,this.props.disabled?void 0:this.state.collapse),children:h}):_react2.default.createElement("div",{style:this.props.disabled?void 0:this.state.collapse,children:h}):h}},{key:"makeHandler",value:function(e){var t=this,i=function(){e.call(t,t.props),t.ticking=!1};return function(){t.ticking||((0,_globals.raf)(i),t.ticking=!0)}}},{key:"inViewport",value:function(e){if(!this.el||window.document.hidden)return!1;var i=this.el.offsetHeight,s=window.pageYOffset-t.getTop(this.el),o=Math.min(i,window.innerHeight)*(_globals.globalHide?e.fraction:0);return s>o-window.innerHeight&&s<i-o}},{key:"resize",value:function(e){this&&this.el&&this.isOn&&this.inViewport(e)&&(this.unlisten(),this.isShown=this.isOn,this.setState({hasExited:!this.isOn,hasAppeared:!0,collapse:void 0,style:{opacity:this.isOn||!e.outEffect?1:0}}),this.onReveal(e))}},{key:"listen",value:function(){_globals.observerMode||this.isListener||(this.isListener=!0,window.addEventListener("scroll",this.revealHandler,{passive:!0}),window.addEventListener("orientationchange",this.revealHandler,{passive:!0}),window.document.addEventListener("visibilitychange",this.revealHandler,{passive:!0}),window.document.addEventListener("collapseend",this.revealHandler,{passive:!0}),window.addEventListener("resize",this.resizeHandler,{passive:!0}))}},{key:"unlisten",value:function(){!_globals.observerMode&&this.isListener&&(window.removeEventListener("scroll",this.revealHandler,{passive:!0}),window.removeEventListener("orientationchange",this.revealHandler,{passive:!0}),window.document.removeEventListener("visibilitychange",this.revealHandler,{passive:!0}),window.document.removeEventListener("collapseend",this.revealHandler,{passive:!0}),window.removeEventListener("resize",this.resizeHandler,{passive:!0}),this.isListener=!1),this.onRevealTimeout&&(this.onRevealTimeout=window.clearTimeout(this.onRevealTimeout)),this.animationEndTimeout&&(this.animationEndTimeout=window.clearTimeout(this.animationEndTimeout))}}],[{key:"getInitialCollapseStyle",value:function(e){return{height:0,visibility:e.when?void 0:"hidden"}}},{key:"getTop",value:function(e){for(;void 0===e.offsetTop;)e=e.parentNode;for(var t=e.offsetTop;e.offsetParent;t+=e.offsetTop)e=e.offsetParent;return t}}]),t}(_react2.default.Component);RevealBase.propTypes=propTypes,RevealBase.defaultProps=defaultProps,RevealBase.contextTypes=contextTypes,RevealBase.displayName="RevealBase",exports.default=RevealBase,module.exports=exports.default;

/***/ },
/* 7009 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopRequireDefault(o){return o&&o.__esModule?o:{default:o}}function _objectWithoutProperties(o,e){var r={};for(var t in o)e.indexOf(t)>=0||Object.prototype.hasOwnProperty.call(o,t)&&(r[t]=o[t]);return r}function make(o,e){var r=e.left,t=e.right,p=e.up,n=e.down,a=e.top,i=e.bottom,l=e.mirror,u=e.opposite,s=(r?1:0)|(t?2:0)|(a||n?4:0)|(i||p?8:0)|(l?16:0)|(u?32:0)|(o?64:0);if(lookup.hasOwnProperty(s))return lookup[s];if(!l!=!(o&&u)){var d=[t,r,i,a,n,p];r=d[0],t=d[1],a=d[2],i=d[3],p=d[4],n=d[5]}var f=r||t,c=a||i||p||n,m=f||c,y=void 0,b=void 0,_=void 0,v=void 0,T=void 0;return m?o?(b=f?(r?"":"-")+"42px":"0",_=c?(n||a?"-":"")+"60px":"0",v=f?(t?"":"-")+"2000px":"0",T=c?(p||i?"":"-")+"2000px":"0",y="40% {\n          opacity: 1;\n          transform: scale3d(.475, .475, .475) translate3d("+b+", "+_+", 0);\n        }\n        to {\n          opacity: 0;\n          transform: scale(.1) translate3d("+v+", "+T+", 0);\n          transform-origin: "+(c?"center bottom":(r?"left":"right")+" center")+";\n        }"):(b=f?(r?"-":"")+"1000px":"0",_=c?(n||a?"-":"")+"1000px":"0",v=f?(t?"-":"")+"10px":"0",T=c?(p||i?"-":"")+"60px":"0",y="from {\n          opacity: 0;\n          transform: scale3d(.1, .1, .1) translate3d("+b+", "+_+", 0);\n          animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);\n        }\n        60% {\n          opacity: 1;\n          transform: scale3d(.475, .475, .475) translate3d("+v+", "+T+", 0);\n          animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);\n        }"):y=(o?"to":"from")+" {opacity: 0; transform: scale3d(.1, .1, .1);} "+(o?"from":"to")+" { opacity: 1; transform: none;}",lookup[s]=(0,_globals.animation)(y),lookup[s]}function Zoom(){var o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:_globals.defaults,e=o.children,r=(o.out,o.forever),t=o.timeout,p=o.duration,n=void 0===p?_globals.defaults.duration:p,a=o.delay,i=void 0===a?_globals.defaults.delay:a,l=o.count,u=void 0===l?_globals.defaults.count:l,s=_objectWithoutProperties(o,["children","out","forever","timeout","duration","delay","count"]),d={make:make,duration:void 0===t?n:t,delay:i,forever:r,count:u,style:{animationFillMode:"both"},reverse:s.left};return(0,_wrap2.default)(s,d,d,e)}Object.defineProperty(exports,"__esModule",{value:!0});var _propTypes=__webpack_require__(5),_wrap=__webpack_require__(649),_wrap2=_interopRequireDefault(_wrap),_globals=__webpack_require__(290),propTypes={out:_propTypes.bool,left:_propTypes.bool,right:_propTypes.bool,top:_propTypes.bool,bottom:_propTypes.bool,mirror:_propTypes.bool,opposite:_propTypes.bool,duration:_propTypes.number,timeout:_propTypes.number,delay:_propTypes.number,count:_propTypes.number,forever:_propTypes.bool},lookup={};Zoom.propTypes=propTypes,exports.default=Zoom,module.exports=exports.default;

/***/ },
/* 7010 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var reactRouter=__webpack_require__(7012),React=_interopDefault(__webpack_require__(2)),history=__webpack_require__(448);__webpack_require__(5),__webpack_require__(108);var invariant=_interopDefault(__webpack_require__(338));function _extends(){return(_extends=Object.assign||function(e){for(var r=1;r<arguments.length;r++){var t=arguments[r];for(var o in t)Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o])}return e}).apply(this,arguments)}function _inheritsLoose(e,r){e.prototype=Object.create(r.prototype),(e.prototype.constructor=e).__proto__=r}function _objectWithoutPropertiesLoose(e,r){if(null==e)return{};var t,o,n={},a=Object.keys(e);for(o=0;o<a.length;o++)t=a[o],0<=r.indexOf(t)||(n[t]=e[t]);return n}var BrowserRouter=function(n){function e(){for(var e,r=arguments.length,t=new Array(r),o=0;o<r;o++)t[o]=arguments[o];return(e=n.call.apply(n,[this].concat(t))||this).history=history.createBrowserHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),HashRouter=function(n){function e(){for(var e,r=arguments.length,t=new Array(r),o=0;o<r;o++)t[o]=arguments[o];return(e=n.call.apply(n,[this].concat(t))||this).history=history.createHashHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),resolveToLocation=function(e,r){return"function"==typeof e?e(r):e},normalizeToLocation=function(e,r){return"string"==typeof e?history.createLocation(e,null,null,r):e},forwardRefShim=function(e){return e},forwardRef=React.forwardRef;function isModifiedEvent(e){return!!(e.metaKey||e.altKey||e.ctrlKey||e.shiftKey)}void 0===forwardRef&&(forwardRef=forwardRefShim);var LinkAnchor=forwardRef(function(e,r){var t=e.innerRef,o=e.navigate,n=e.onClick,a=_objectWithoutPropertiesLoose(e,["innerRef","navigate","onClick"]),i=a.target,c=_extends({},a,{onClick:function(r){try{n&&n(r)}catch(e){throw r.preventDefault(),e}r.defaultPrevented||0!==r.button||i&&"_self"!==i||isModifiedEvent(r)||(r.preventDefault(),o())}});return c.ref=forwardRefShim!==forwardRef&&r||t,React.createElement("a",c)}),Link=forwardRef(function(e,a){var r=e.component,i=void 0===r?LinkAnchor:r,c=e.replace,f=e.to,u=e.innerRef,s=_objectWithoutPropertiesLoose(e,["component","replace","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(r){r||invariant(!1);var t=r.history,e=normalizeToLocation(resolveToLocation(f,r.location),r.location),o=e?t.createHref(e):"",n=_extends({},s,{href:o,navigate:function(){var e=resolveToLocation(f,r.location);(c?t.replace:t.push)(e)}});return forwardRefShim!==forwardRef?n.ref=a||u:n.innerRef=u,React.createElement(i,n)})}),forwardRefShim$1=function(e){return e},forwardRef$1=React.forwardRef;function joinClassnames(){for(var e=arguments.length,r=new Array(e),t=0;t<e;t++)r[t]=arguments[t];return r.filter(function(e){return e}).join(" ")}void 0===forwardRef$1&&(forwardRef$1=forwardRefShim$1);var NavLink=forwardRef$1(function(e,s){var r=e["aria-current"],l=void 0===r?"page":r,t=e.activeClassName,p=void 0===t?"active":t,h=e.activeStyle,R=e.className,d=e.exact,v=e.isActive,y=e.location,m=e.strict,w=e.style,_=e.to,L=e.innerRef,x=_objectWithoutPropertiesLoose(e,["aria-current","activeClassName","activeStyle","className","exact","isActive","location","strict","style","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(e){e||invariant(!1);var r=y||e.location,t=normalizeToLocation(resolveToLocation(_,r),r),o=t.pathname,n=o&&o.replace(/([.+*?=^!:${}()[\]|/\\])/g,"\\$1"),a=n?reactRouter.matchPath(r.pathname,{path:n,exact:d,strict:m}):null,i=!!(v?v(a,r):a),c=i?joinClassnames(R,p):R,f=i?_extends({},w,{},h):w,u=_extends({"aria-current":i&&l||null,className:c,style:f,to:t},x);return forwardRefShim$1!==forwardRef$1?u.ref=s||L:u.innerRef=L,React.createElement(Link,u)})});Object.keys(reactRouter).forEach(function(e){"default"!==e&&Object.defineProperty(exports,e,{enumerable:!0,get:function(){return reactRouter[e]}})}),exports.BrowserRouter=BrowserRouter,exports.HashRouter=HashRouter,exports.Link=Link,exports.NavLink=NavLink;
	//# sourceMappingURL=react-router-dom.min.js.map


/***/ },
/* 7011 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(2));__webpack_require__(5);var history=__webpack_require__(448);__webpack_require__(108);var createContext=_interopDefault(__webpack_require__(6963)),invariant=_interopDefault(__webpack_require__(338)),pathToRegexp=_interopDefault(__webpack_require__(7014));__webpack_require__(7016);var hoistStatics=_interopDefault(__webpack_require__(137));function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),(t.prototype.constructor=t).__proto__=e}function _objectWithoutPropertiesLoose(t,e){if(null==t)return{};var n,o,r={},a=Object.keys(t);for(o=0;o<a.length;o++)n=a[o],0<=e.indexOf(n)||(r[n]=t[n]);return r}var createNamedContext=function(t){var e=createContext();return e.displayName=t,e},context=createNamedContext("Router"),Router=function(n){function t(t){var e;return(e=n.call(this,t)||this).state={location:t.history.location},e._isMounted=!1,e._pendingLocation=null,t.staticContext||(e.unlisten=t.history.listen(function(t){e._isMounted?e.setState({location:t}):e._pendingLocation=t})),e}_inheritsLoose(t,n),t.computeRootMatch=function(t){return{path:"/",url:"/",params:{},isExact:"/"===t}};var e=t.prototype;return e.componentDidMount=function(){this._isMounted=!0,this._pendingLocation&&this.setState({location:this._pendingLocation})},e.componentWillUnmount=function(){this.unlisten&&this.unlisten()},e.render=function(){return React.createElement(context.Provider,{children:this.props.children||null,value:{history:this.props.history,location:this.state.location,match:t.computeRootMatch(this.state.location.pathname),staticContext:this.props.staticContext}})},t}(React.Component),MemoryRouter=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).history=history.createMemoryHistory(t.props),t}return _inheritsLoose(t,r),t.prototype.render=function(){return React.createElement(Router,{history:this.history,children:this.props.children})},t}(React.Component),Lifecycle=function(t){function e(){return t.apply(this,arguments)||this}_inheritsLoose(e,t);var n=e.prototype;return n.componentDidMount=function(){this.props.onMount&&this.props.onMount.call(this,this)},n.componentDidUpdate=function(t){this.props.onUpdate&&this.props.onUpdate.call(this,this,t)},n.componentWillUnmount=function(){this.props.onUnmount&&this.props.onUnmount.call(this,this)},n.render=function(){return null},e}(React.Component);function Prompt(t){var o=t.message,e=t.when,r=void 0===e||e;return React.createElement(context.Consumer,null,function(t){if(t||invariant(!1),!r||t.staticContext)return null;var n=t.history.block;return React.createElement(Lifecycle,{onMount:function(t){t.release=n(o)},onUpdate:function(t,e){e.message!==o&&(t.release(),t.release=n(o))},onUnmount:function(t){t.release()},message:o})})}var cache={},cacheLimit=1e4,cacheCount=0;function compilePath(t){if(cache[t])return cache[t];var e=pathToRegexp.compile(t);return cacheCount<cacheLimit&&(cache[t]=e,cacheCount++),e}function generatePath(t,e){return void 0===t&&(t="/"),void 0===e&&(e={}),"/"===t?t:compilePath(t)(e,{pretty:!0})}function Redirect(t){var a=t.computedMatch,i=t.to,e=t.push,c=void 0!==e&&e;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=t.history,n=t.staticContext,o=c?e.push:e.replace,r=history.createLocation(a?"string"==typeof i?generatePath(i,a.params):_extends({},i,{pathname:generatePath(i.pathname,a.params)}):i);return n?(o(r),null):React.createElement(Lifecycle,{onMount:function(){o(r)},onUpdate:function(t,e){var n=history.createLocation(e.to);history.locationsAreEqual(n,_extends({},r,{key:n.key}))||o(r)},to:i})})}var cache$1={},cacheLimit$1=1e4,cacheCount$1=0;function compilePath$1(t,e){var n=""+e.end+e.strict+e.sensitive,o=cache$1[n]||(cache$1[n]={});if(o[t])return o[t];var r=[],a={regexp:pathToRegexp(t,r,e),keys:r};return cacheCount$1<cacheLimit$1&&(o[t]=a,cacheCount$1++),a}function matchPath(u,t){void 0===t&&(t={}),"string"!=typeof t&&!Array.isArray(t)||(t={path:t});var e=t,n=e.path,o=e.exact,p=void 0!==o&&o,r=e.strict,h=void 0!==r&&r,a=e.sensitive,l=void 0!==a&&a;return[].concat(n).reduce(function(t,e){if(!e&&""!==e)return null;if(t)return t;var n=compilePath$1(e,{end:p,strict:h,sensitive:l}),o=n.regexp,r=n.keys,a=o.exec(u);if(!a)return null;var i=a[0],c=a.slice(1),s=u===i;return p&&!s?null:{path:e,url:"/"===e&&""===i?"/":i,isExact:s,params:r.reduce(function(t,e,n){return t[e.name]=c[n],t},{})}},null)}var Route=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var c=this;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=c.props.location||t.location,n=_extends({},t,{location:e,match:c.props.computedMatch?c.props.computedMatch:c.props.path?matchPath(e.pathname,c.props):t.match}),o=c.props,r=o.children,a=o.component,i=o.render;return Array.isArray(r)&&0===r.length&&(r=null),React.createElement(context.Provider,{value:n},n.match?r?"function"==typeof r?r(n):r:a?React.createElement(a,n):i?i(n):null:"function"==typeof r?r(n):null)})},e}(React.Component);function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function addBasename(t,e){return t?_extends({},e,{pathname:addLeadingSlash(t)+e.pathname}):e}function stripBasename(t,e){if(!t)return e;var n=addLeadingSlash(t);return 0!==e.pathname.indexOf(n)?e:_extends({},e,{pathname:e.pathname.substr(n.length)})}function createURL(t){return"string"==typeof t?t:history.createPath(t)}function staticHandler(t){return function(){invariant(!1)}}function noop(){}var StaticRouter=function(r){function t(){for(var e,t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))||this).handlePush=function(t){return e.navigateTo(t,"PUSH")},e.handleReplace=function(t){return e.navigateTo(t,"REPLACE")},e.handleListen=function(){return noop},e.handleBlock=function(){return noop},e}_inheritsLoose(t,r);var e=t.prototype;return e.navigateTo=function(t,e){var n=this.props,o=n.basename,r=void 0===o?"":o,a=n.context,i=void 0===a?{}:a;i.action=e,i.location=addBasename(r,history.createLocation(t)),i.url=createURL(i.location)},e.render=function(){var t=this.props,e=t.basename,n=void 0===e?"":e,o=t.context,r=void 0===o?{}:o,a=t.location,i=void 0===a?"/":a,c=_objectWithoutPropertiesLoose(t,["basename","context","location"]),s={createHref:function(t){return addLeadingSlash(n+createURL(t))},action:"POP",location:stripBasename(n,history.createLocation(i)),push:this.handlePush,replace:this.handleReplace,go:staticHandler(),goBack:staticHandler(),goForward:staticHandler(),listen:this.handleListen,block:this.handleBlock};return React.createElement(Router,_extends({},c,{history:s,staticContext:r}))},t}(React.Component),Switch=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var t=this;return React.createElement(context.Consumer,null,function(n){n||invariant(!1);var o,r,a=t.props.location||n.location;return React.Children.forEach(t.props.children,function(t){if(null==r&&React.isValidElement(t)){var e=(o=t).props.path||t.props.from;r=e?matchPath(a.pathname,_extends({},t.props,{path:e})):n.match}}),r?React.cloneElement(o,{location:a,computedMatch:r}):null})},e}(React.Component);function withRouter(o){function t(t){var e=t.wrappedComponentRef,n=_objectWithoutPropertiesLoose(t,["wrappedComponentRef"]);return React.createElement(context.Consumer,null,function(t){return t||invariant(!1),React.createElement(o,_extends({},n,t,{ref:e}))})}var e="withRouter("+(o.displayName||o.name)+")";return t.displayName=e,t.WrappedComponent=o,hoistStatics(t,o)}var useContext=React.useContext;function useHistory(){return useContext(context).history}function useLocation(){return useContext(context).location}function useParams(){var t=useContext(context).match;return t?t.params:{}}function useRouteMatch(t){return t?matchPath(useLocation().pathname,t):useContext(context).match}exports.MemoryRouter=MemoryRouter,exports.Prompt=Prompt,exports.Redirect=Redirect,exports.Route=Route,exports.Router=Router,exports.StaticRouter=StaticRouter,exports.Switch=Switch,exports.__RouterContext=context,exports.generatePath=generatePath,exports.matchPath=matchPath,exports.useHistory=useHistory,exports.useLocation=useLocation,exports.useParams=useParams,exports.useRouteMatch=useRouteMatch,exports.withRouter=withRouter;
	//# sourceMappingURL=react-router.min.js.map


/***/ },
/* 7012 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(7011);
	} else {
	  module.exports = require("./cjs/react-router.js");
	}


/***/ },
/* 7013 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 7014 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(7013)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = prefix || defaultDelimiter
	    var pattern = capture || group
	    var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '')
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : restrictBacktrack(delimiter, prevText))
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	function restrictBacktrack(delimiter, prevText) {
	  if (!prevText || prevText.indexOf(delimiter) > -1) {
	    return '[^' + escapeString(delimiter) + ']+?'
	  }
	
	  return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?'
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options), options)
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens, options) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options && options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 7015 */
1027,
/* 7016 */
[7344, 7015],
/* 7017 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(7198).enable();
	  window.Promise = __webpack_require__(7197);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(7199);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(287);


/***/ },
/* 7018 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(155);
	
	__webpack_require__(7193);
	
	__webpack_require__(7194);
	
	var _auth = __webpack_require__(106);
	
	var _login = __webpack_require__(7187);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _escritorio = __webpack_require__(7185);
	
	var _escritorio2 = _interopRequireDefault(_escritorio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function App() {
	
	  var pathname = window.location.pathname;
	
	  return _react2.default.createElement(
	    _auth.AuthProvider,
	    null,
	    _react2.default.createElement(
	      _reactRouterDom.BrowserRouter,
	      null,
	      _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', component: _login2.default }),
	      pathname !== '/' && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_escritorio2.default, null)
	      )
	    )
	  );
	}
	
	exports.default = App;

/***/ },
/* 7019 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _catalogoPersona = __webpack_require__(64);
	
	var _catalogoPersona2 = _interopRequireDefault(_catalogoPersona);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegistrarClientes = function RegistrarClientes(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var anio = JSON.parse(sessionStorage.getItem('anioactu'));
	    var fechaTope = (0, _moment2.default)(JSON.parse(sessionStorage.getItem('fechasistema'))).format('YYYY-MM-DD').replace(anio.toString(), (anio - 18).toString());
	    var registrado = false;
	    var muni = '';
	    var ciu = '';
	    var valrif = 0;
	
	    var btnCancela = (0, _react.useRef)();
	    var btnAcepta = (0, _react.useRef)();
	    var chkNatural = (0, _react.useRef)();
	    var chkJuridico = (0, _react.useRef)();
	    var txtId = (0, _react.useRef)();
	    var cmbRif = (0, _react.useRef)();
	    var txtRif = (0, _react.useRef)();
	    var txtRazon = (0, _react.useRef)();
	    var txtDirClient = (0, _react.useRef)();
	    var txtEmailClient = (0, _react.useRef)();
	    var txtTlf1Client = (0, _react.useRef)();
	    var txtTlf2Client = (0, _react.useRef)();
	    var txtEstado = (0, _react.useRef)();
	    var txtMunicipio = (0, _react.useRef)();
	    var txtCiudad = (0, _react.useRef)();
	    var txtStatus = (0, _react.useRef)();
	    var txtGrupoCLiente = (0, _react.useRef)();
	    var txtIrsl = (0, _react.useRef)();
	    var txtRetencion = (0, _react.useRef)();
	
	    var cmbNacionalidad = (0, _react.useRef)();
	    var txtCedRes = (0, _react.useRef)();
	    var cmbSexo = (0, _react.useRef)();
	    var txtFechaNac = (0, _react.useRef)();
	    var txtNomResp = (0, _react.useRef)();
	    var txtApeResp = (0, _react.useRef)();
	    var txtDireccion = (0, _react.useRef)();
	    var txtEmail = (0, _react.useRef)();
	    var txtTlf1 = (0, _react.useRef)();
	    var txtTlf2 = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        body = _useState2[0],
	        setBody = _useState2[1];
	
	    var _useState3 = (0, _react.useState)('visible'),
	        _useState4 = _slicedToArray(_useState3, 2),
	        visibleBtn = _useState4[0],
	        setVisibleBtn = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(0),
	        _useState6 = _slicedToArray(_useState5, 2),
	        ops = _useState6[0],
	        setOps = _useState6[1];
	
	    var _useState7 = (0, _react.useState)('Gestionar Proveedores.'),
	        _useState8 = _slicedToArray(_useState7, 2),
	        tituloHeader = _useState8[0],
	        setTituloHeader = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(false),
	        _useState10 = _slicedToArray(_useState9, 2),
	        catalogoPersona = _useState10[0],
	        setCatalogoPersona = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(0),
	        _useState12 = _slicedToArray(_useState11, 2),
	        operacionPer = _useState12[0],
	        setOperacionPer = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(true),
	        _useState14 = _slicedToArray(_useState13, 2),
	        activob = _useState14[0],
	        setActivob = _useState14[1];
	
	    var _useState15 = (0, _react.useState)([]),
	        _useState16 = _slicedToArray(_useState15, 2),
	        estados = _useState16[0],
	        setEstados = _useState16[1];
	
	    var _useState17 = (0, _react.useState)([]),
	        _useState18 = _slicedToArray(_useState17, 2),
	        municipios = _useState18[0],
	        setMunicipios = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(),
	        _useState20 = _slicedToArray(_useState19, 2),
	        nacnalidad = _useState20[0],
	        setNacnalidad = _useState20[1];
	
	    var _useState21 = (0, _react.useState)([]),
	        _useState22 = _slicedToArray(_useState21, 2),
	        ciudades = _useState22[0],
	        setCiudades = _useState22[1];
	
	    var _useState23 = (0, _react.useState)(false),
	        _useState24 = _slicedToArray(_useState23, 2),
	        catalogoCliente = _useState24[0],
	        setCatalogoCliente = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(true),
	        _useState26 = _slicedToArray(_useState25, 2),
	        habilitado = _useState26[0],
	        setHabilitado = _useState26[1];
	
	    var _useState27 = (0, _react.useState)(true),
	        _useState28 = _slicedToArray(_useState27, 2),
	        habilitadoNU = _useState28[0],
	        setHabilitadoNU = _useState28[1];
	
	    var _useState29 = (0, _react.useState)(1),
	        _useState30 = _slicedToArray(_useState29, 2),
	        select = _useState30[0],
	        setSelect = _useState30[1];
	
	    var _useState31 = (0, _react.useState)(true),
	        _useState32 = _slicedToArray(_useState31, 2),
	        activo = _useState32[0],
	        setActivo = _useState32[1];
	
	    var _useState33 = (0, _react.useState)(false),
	        _useState34 = _slicedToArray(_useState33, 2),
	        activate = _useState34[0],
	        setActivate = _useState34[1];
	
	    var _useState35 = (0, _react.useState)({
	        incluir: false,
	        consultar: false,
	        modificar: false,
	        eliminar: false,
	        aceptar: true,
	        cancelar: true,
	        catalogo: true,
	        catalogoper: true
	    }),
	        _useState36 = _slicedToArray(_useState35, 2),
	        botones = _useState36[0],
	        setBotones = _useState36[1];
	
	    var _useState37 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState38 = _slicedToArray(_useState37, 2),
	        mensaje = _useState38[0],
	        setMensaje = _useState38[1];
	
	    var _useState39 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState40 = _slicedToArray(_useState39, 2),
	        mensajesino = _useState40[0],
	        setMensajesino = _useState40[1];
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = '*';
	        var nomtab = 'estado';
	        var orden = 'idestado';
	
	        var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setEstados(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var selectMunicipios = function selectMunicipios(id) {
	        var campos = '*';
	        var nomtab = 'municipio';
	        var nomid = 'idestado';
	        var endpoint = op.conexion + '/api/consulta/modelirows?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid;
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                setMunicipios(response.data);
	                if (registrado || !botones.consultar || !botones.modificar || !botones.eliminar) {
	                    txtMunicipio.current.value = muni;
	                }
	            }
	        }).catch(function (error) {
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	        });
	    };
	
	    var selectCiudad = function selectCiudad(id) {
	        var campos = '*';
	        var nomtab = 'ciudad';
	        var nomid = 'idmunicipio';
	        var endpoint = op.conexion + '/api/consulta/modelirows?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid;
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                setCiudades(response.data);
	                if (registrado || !botones.consultar || !botones.modificar || !botones.eliminar) {
	                    txtCiudad.current.value = ciu;
	                }
	            }
	        }).catch(function (error) {
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setTituloHeader('Gestionar Proveedores.');
	
	        setVisibleBtn('visible');
	        setActivate(false);
	        setActivo(true);
	        setActivob(true);
	        setBody(null);
	        setOperacionPer(0);
	        setHabilitado(true);
	        setHabilitadoNU(true);
	        setMunicipios([]);
	        setCiudades([]);
	        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        setBotones({
	            incluir: false,
	            consultar: false,
	            modificar: false,
	            eliminar: false,
	            aceptar: true,
	            cancelar: true,
	            catalogo: true,
	            catalogoper: true
	        });
	        chkJuridico.current.checked = true;
	        cmbRif.current.value = '';
	        txtRif.current.value = '';
	        txtId.current.value = 0;
	        txtRazon.current.value = '';
	        txtDirClient.current.value = '';
	        txtTlf1Client.current.value = '';
	        txtTlf2Client.current.value = '';
	        txtEmailClient.current.value = '';
	        txtStatus.current.value = '';
	        txtEstado.current.value = '';
	        txtMunicipio.current.value = '';
	        txtCiudad.current.value = '';
	
	        cmbNacionalidad.current.value = '';
	        txtCedRes.current.value = '';
	        cmbSexo.current.value = '';
	        txtFechaNac.current.value = '';
	        txtNomResp.current.value = '';
	        txtApeResp.current.value = '';
	        txtDireccion.current.value = '';
	        txtEmail.current.value = '';
	        txtTlf1.current.value = '';
	        txtTlf2.current.value = '';
	
	        setSelect(1);
	        setNacnalidad();
	    };
	
	    var onChangeValidar = function onChangeValidar() {
	
	        var sigue = true;
	        if (ops === 1) {
	
	            var nom = void 0;
	            nom = select === 1 ? 'Nombre/Razón Social' : 'Nombres y Apellidos';
	
	            var ced = void 0;
	            ced = select === 1 ? 'R.I.F' : 'Cédula';
	
	            if (txtStatus.current.value === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione el Estatus del Cliente', icono: 'informacion' });
	                txtStatus.current.focus();
	                sigue = false;
	            } else if (txtRazon.current.value === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El campo' + ' ' + nom + ' ' + 'no debe ir Vacio', icono: 'informacion' });
	                txtRazon.current.focus();
	                sigue = false;
	            } else if (txtDirClient.current.value === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Describa la Dirección del Cliente', icono: 'informacion' });
	                txtDirClient.current.focus();
	                sigue = false;
	            } else if (txtEmailClient.current.value === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Describa el Correo del Cliente', icono: 'informacion' });
	                txtEmailClient.current.focus();
	                sigue = false;
	            } else if (txtEstado.current.value === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione el Estado del Cliente', icono: 'informacion' });
	                txtEstado.current.focus();
	                sigue = false;
	            } else if (txtMunicipio.current.value === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione el Municipio del Cliente', icono: 'informacion' });
	                txtMunicipio.current.focus();
	                sigue = false;
	            } else if (txtCiudad.current.value === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione la Ciudad del Cliente', icono: 'informacion' });
	                txtCiudad.current.focus();
	                sigue = false;
	            } else if (txtCedRes.current.value === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar el Responsable', icono: 'informacion' });
	                txtCedRes.current.focus();
	                sigue = false;
	            } else if (txtGrupoCLiente.current.value === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione el Tipo de Grupo del Cliente', icono: 'informacion' });
	                txtGrupoCLiente.current.focus();
	                sigue = false;
	            }
	        }
	
	        if (sigue) {
	
	            var cliente = [];
	            var repre = [];
	            cliente.push({
	                idagente: !botones.incluir ? 0 : txtId.current.value,
	                nombre: txtRazon.current.value.trim(),
	                direccion: txtDirClient.current.value.trim(),
	                tipoper: chkNatural.current.checked ? 0 : 1,
	                rif: nacnalidad + txtRif.current.value,
	                reprelegal: cmbNacionalidad.current.value + txtCedRes.current.value,
	                telefono: txtTlf1Client.current.value,
	                celular: txtTlf2Client.current.value,
	                email: txtEmailClient.current.value.trim(),
	                cliente: true,
	                statuscliente: txtStatus.current.value.trim(),
	                estado: txtEstado.current.value.trim(),
	                municipio: txtMunicipio.current.value.trim(),
	                ciudad: txtCiudad.current.value.trim(),
	                islr: txtIrsl.current.value.trim(),
	                grupcli: txtGrupoCLiente.current.value.trim(),
	                agenteretencion: txtRetencion.current.checked ? true : false
	            });
	            repre.push({
	                cedula: parseInt(txtCedRes.current.value),
	                correoe: txtEmail.current.value.trim(),
	                tlf1: txtTlf1.current.value.trim(),
	                tlf2: txtTlf2.current.value.trim(),
	                apellidos: txtApeResp.current.value.trim(),
	                direccion: txtDireccion.current.value.trim(),
	                fnacimiento: txtFechaNac.current.value.trim(),
	                nacionalidad: cmbNacionalidad.current.value.trim(),
	                nombres: txtNomResp.current.value.trim(),
	                sexo: cmbSexo.current.value.trim()
	            });
	
	            setBody({
	                operacionper: operacionPer,
	                agente: cliente,
	                repre: repre,
	                client: []
	            });
	
	            var msg = '';
	            if (!botones.incluir) {
	                msg = 'Esta Seguro de Registrar estos Datos.';
	            } else if (!botones.modificar) {
	                msg = 'Esta Seguro de Modificar estos Datos.';
	            } else if (!botones.eliminar) {
	                msg = 'Esta Seguro de Eliminar estos Datos.';
	            }
	
	            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	        }
	    };
	
	    var procesarRegistro = function procesarRegistro() {
	        setActivate(true);
	        var endpoint = op.conexion + '/api/agente/actualizar/' + ops;
	        _axios2.default.post(endpoint, body, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	
	                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Creado Correctamente', icono: 'exito' });
	
	                setActivate(false);
	            }
	        }).catch(function (error) {
	            var mensaje = '';
	            if (error.response === undefined) {
	                mensaje = 'Error de Conexion';
	            } else {
	                if (error.response.data.message === 'duplicate key value violates unique constraint "agente_rif_key"') {
	                    mensaje = 'Ya existe un Registro con este rif';
	                } else if (error.response.data.message === 'duplicate key value violates unique constraint "agente_email_key"') {
	                    mensaje = 'Ya existe un Registro con este correo';
	                } else {
	                    mensaje = error.response.data.message;
	                }
	            }
	            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	            setActivate(false);
	        });
	    };
	
	    var handleCloseSi = function handleCloseSi() {
	        setActivate(false);
	        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        procesarRegistro();
	    };
	
	    var handleInputNumChange = function handleInputNumChange(event) {
	        event.preventDefault();
	        (0, _varios.validaSoloNumero)(event);
	
	        if (event.which === 46) {
	            return false;
	        } else if (event.which >= 48 && event.which <= 57) {
	            return true;
	        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	            return true;
	        } else return false;
	    };
	
	    var datosRes = function datosRes() {
	        var campos = '*';
	        var nomtab = 'persona';
	        var nomid = 'cedula';
	        var nomid2 = 'nacionalidad';
	        var id = txtCedRes.current.value;
	        var id2 = cmbNacionalidad.current.value;
	        var endpoint = op.conexion + '/api/consulta/modeli2?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id + '&nomid2=' + nomid2 + '&id2=' + id2;
	
	        setActivate(true);
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	
	                cmbSexo.current.value = '';
	                txtFechaNac.current.value = '';
	                txtNomResp.current.value = '';
	                txtApeResp.current.value = '';
	                txtDireccion.current.value = '';
	                txtEmail.current.value = '';
	                txtTlf1.current.value = '';
	                txtTlf2.current.value = '';
	
	                if (response.data !== '') {
	                    setHabilitadoNU(true);
	                    setOperacionPer(0);
	                    cmbSexo.current.value = response.data.sexo;
	                    txtFechaNac.current.value = (0, _moment2.default)(response.data.fnacimiento).format('YYYY-MM-DD');
	                    txtNomResp.current.value = response.data.nombres;
	                    txtApeResp.current.value = response.data.apellidos;
	                    txtDireccion.current.value = response.data.direccion;
	                    txtEmail.current.value = response.data.correoe;
	                    txtTlf1.current.value = response.data.tlf1;
	                    txtTlf2.current.value = response.data.tlf2;
	                    if (!botones.consultar) {
	                        btnCancela.current.focus();
	                    } else {
	                        btnAcepta.current.focus();
	                    }
	                } else {
	                    txtNomResp.current.focus();
	                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una persona con este N° de Cédula/RIF', icono: 'informacion' });
	                    setOperacionPer(1);
	                    setHabilitadoNU(false);
	                }
	            }
	            setActivate(false);
	        }).catch(function (error) {
	            setActivate(false);
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	        });
	    };
	
	    var datosPro = function datosPro(rif) {
	
	        var campos = '*';
	        var nomtab = 'agente';
	        var nomid = 'rif';
	        var id = rif;
	        var endpoint = '';
	
	        endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status == 200) {
	
	                if (response.data !== '') {
	
	                    if (response.data.cliente && response.data.rif === valrif) {
	
	                        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡El Cliente con el N° de Cédula o RIF' + ' ' + response.data.rif + ' ' + 'ya Existe!', icono: 'informacion' });
	                        setOps(2);
	                        txtId.current.value = '';
	                        txtStatus.current.value = '';
	                        txtRazon.current.value = '';
	                        txtDirClient.current.value = '';
	                        txtEmailClient.current.value = '';
	                        txtTlf1Client.current.value = '';
	                        txtTlf2Client.current.value = '';
	                        txtEstado.current.value = '';
	                        txtMunicipio.current.value = '';
	                        txtCiudad.current.value = '';
	                        txtRif.current.value = '';
	                        cmbRif.current.value = '--';
	
	                        cmbNacionalidad.current.value = '';
	                        txtCedRes.current.value = '';
	
	                        muni = '';
	                        ciu = '';
	
	                        cmbSexo.current.value = '';
	                        txtFechaNac.current.value = '';
	                        txtNomResp.current.value = '';
	                        txtApeResp.current.value = '';
	                        txtDireccion.current.value = '';
	                        txtEmail.current.value = '';
	                        txtTlf1.current.value = '';
	                        txtTlf2.current.value = '';
	                    } else if (!response.data.cliente) {
	                        txtId.current.value = response.data.idagente;
	                        txtStatus.current.value = response.data.statuscliente;
	                        txtRazon.current.value = response.data.nombre;
	                        txtDirClient.current.value = response.data.direccion;
	                        txtEmailClient.current.value = response.data.email;
	                        txtTlf1Client.current.value = response.data.telefono;
	                        txtTlf2Client.current.value = response.data.celular;
	                        txtEstado.current.value = response.data.estado;
	                        txtMunicipio.current.value = response.data.municipio;
	                        txtCiudad.current.value = response.data.ciudad;
	
	                        cmbNacionalidad.current.value = response.data.reprelegal.substring(0, 1);
	                        txtCedRes.current.value = response.data.reprelegal.substring(1, 9);
	
	                        muni = response.data.municipio.trim();
	                        ciu = response.data.ciudad.trim();
	
	                        selectMunicipios(response.data.estado.trim());
	                        selectCiudad(response.data.municipio.trim());
	                        datosRes();
	                        setNacnalidad(response.data.rif.substring(0, 1));
	
	                        var tip = response.data.tipoper;
	                        if (tip === 1) {
	                            chkJuridico.current.checked = true;
	                            chkNatural.current.checked = false;
	                        } else {
	                            chkNatural.current.checked = true;
	                            chkJuridico.current.checked = false;
	                        }
	
	                        setSelect(response.data.tipoper);
	                    }
	                } else {
	
	                    txtRazon.current.focus();
	                }
	            }
	
	            setActivate(false);
	        }).catch(function (error) {
	
	            setActivate(false);
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	        });
	    };
	
	    var validarPersona = function validarPersona(event) {
	        event.preventDefault();
	        (0, _varios.validaSoloNumero)(event);
	        if (event.which === 13 || typeof event.which === 'undefined') {
	            if (event.target.value !== '') {
	                if (cmbNacionalidad.current.value !== '') {
	                    datosRes();
	                } else {
	                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'debe seleccionar la nacionalidad', icono: 'informacion' });
	                    cmbNacionalidad.current.focus();
	                }
	            } else {
	                cmbNacionalidad.current.value = '';
	                cmbSexo.current.value = '';
	                txtFechaNac.current.value = '';
	                txtNomResp.current.value = '';
	                txtApeResp.current.value = '';
	                txtDireccion.current.value = '';
	                txtEmail.current.value = '';
	                txtTlf1.current.value = '';
	                txtTlf2.current.value = '';
	                setHabilitadoNU(true);
	            }
	        }
	    };
	
	    var validarCliente = function validarCliente(event) {
	        event.preventDefault();
	        if (event.which === 13 || typeof event.which === 'undefined') {
	            if (event.target.value !== '') {
	                if (cmbRif.current.value !== "") {
	                    datosPro(nacnalidad + event.target.value);
	                } else {
	                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar el Tipo de Nacionalidad', icono: 'informacion' });
	                    cmbRif.current.focus();
	                }
	            }
	        }
	    };
	
	    var cancelar = function cancelar() {
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var onChangeCliente = function onChangeCliente(e) {
	
	        var n = void 0;
	        var r = void 0;
	
	        if (e.target.name === 'estado') {
	            setMunicipios([]);
	            setCiudades([]);
	            if (e.target.value !== '') {
	                selectMunicipios(e.target.value);
	            }
	        } else if (e.target.name === 'municipio') {
	            setCiudades([]);
	            if (e.target.value !== '') {
	                selectCiudad(e.target.value);
	            }
	        } else if (e.target.name === 'tipoper') {
	            if (chkNatural.current.checked) {
	                setSelect(0);
	            } else if (chkJuridico.current.checked) {
	                setSelect(1);
	            }
	        } else if (e.target.name === 'cmbrif') {
	            var nac = cmbRif.current.value;
	            txtRif.current.value = '';
	            setNacnalidad(nac);
	        } else if (e.target.name === 'cedula') {
	            n = cmbRif.current.value;
	            r = txtRif.current.value;
	        }
	        valrif = n + r;
	    };
	
	    var onChange = function onChange(e) {
	
	        if (e.target.name === 'correoe' || e.target.name === 'apellidos' || e.target.name === 'direccion' || e.target.name === 'nombres' || e.target.name === 'descripcion') {
	            e.target.value = e.target.value.toUpperCase();
	        } else if (e.target.name === 'nacionalidad' && txtCedRes.current.value !== '') {
	            if (e.target.value !== '') {
	                datosRes();
	            } else {
	                txtCedRes.current.value = '';
	                cmbSexo.current.value = '';
	                txtFechaNac.current.value = '';
	                txtNomResp.current.value = '';
	                txtApeResp.current.value = '';
	                txtDireccion.current.value = '';
	                txtEmail.current.value = '';
	                txtTlf1.current.value = '';
	                txtTlf2.current.value = '';
	            }
	        }
	    };
	
	    var onCatalogoCliente = function onCatalogoCliente(values) {
	        setCatalogoCliente(false);
	
	        txtRazon.current.value = values.nombre;
	        cmbRif.current.value = values.rif.substring(0, 1);
	        txtRif.current.value = values.rifs;
	        cmbNacionalidad.current.value = values.reprelegal.substring(0, 1);
	        txtCedRes.current.value = values.repre;
	        setNacnalidad(values.rif.substring(0, 1));
	        datosPro(values.rif);
	        if (!botones.modificar) {
	            setBotones(Object.assign({}, botones, { catalogoper: false }));
	        }
	    };
	
	    var onCatalogoPersona = function onCatalogoPersona(cedPer, nomPer, apePer, correoPer, tlf1Per, tlf2Per, fnacPer, nacPer, sexoPer, direPer) {
	        setCatalogoPersona(false);
	        setHabilitadoNU(true);
	        setOperacionPer(0);
	        cmbNacionalidad.current.value = nacPer;
	        txtCedRes.current.value = cedPer;
	        cmbSexo.current.value = sexoPer;
	        txtFechaNac.current.value = (0, _moment2.default)(fnacPer).format('YYYY-MM-DD');
	        txtNomResp.current.value = nomPer;
	        txtApeResp.current.value = apePer;
	        txtDireccion.current.value = direPer;
	        txtEmail.current.value = correoPer;
	        txtTlf1.current.value = tlf1Per;
	        txtTlf2.current.value = tlf2Per;
	    };
	
	    (0, _react.useEffect)(function () {
	        seleccionarRegistros();
	    }, []);
	
	    var cerrarModal = function cerrarModal() {
	        props.onHideCancelar();
	        blanquear();
	        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            size: 'xl',
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                setOps(props.op);
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Registrar Cliente'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'row col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'fieldset',
	                        { className: ' row col-sm-12 mx-auto border-azul rounded' },
	                        _react2.default.createElement(
	                            'legend',
	                            { className: 'float-none w-auto fw-bold m-0', style: { fontSize: '15px' } },
	                            'Datos del Cliente'
	                        ),
	                        _react2.default.createElement('input', { ref: txtId, autoComplete: 'off', type: 'hidden', className: 'form-control', name: 'idagente', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-3 mb-3' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'input-group input-group-sm' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                    select === 1 ? "R.I.F" : "Cédula",
	                                    ' '
	                                ),
	                                select === 1 ? _react2.default.createElement(
	                                    'select',
	                                    { disabled: ops === 1 ? false : true, ref: cmbRif, name: 'cmbrif', onChange: onChangeCliente, value: nacnalidad, className: 'col-sm-3 form-select form-control-sm' },
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '' },
	                                        '-'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { key: '0', value: 'V' },
	                                        'V'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { key: '1', value: 'J' },
	                                        'J'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { key: '2', value: 'G' },
	                                        'G'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { key: '3', value: 'P' },
	                                        'P'
	                                    )
	                                ) : _react2.default.createElement(
	                                    'select',
	                                    { disabled: ops === 1 ? false : true, ref: cmbRif, name: 'cmbrif', onChange: onChangeCliente, value: nacnalidad, className: 'col-sm-3 form-select form-control-sm' },
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '' },
	                                        '-'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { key: '0', value: 'V' },
	                                        'V'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { key: '1', value: 'E' },
	                                        'E'
	                                    )
	                                ),
	                                _react2.default.createElement('input', { ref: txtRif, onChangeCapture: onChangeCliente, autoComplete: 'off', maxLength: 9, type: 'text', disabled: ops === 1 ? false : true, className: 'form-control col-4 px-1', name: 'cedula', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: validarCliente, onBlur: validarCliente, onChange: onChange })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-3 mt-15m mx-auto' },
	                            _react2.default.createElement(
	                                'fieldset',
	                                { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	                                _react2.default.createElement(
	                                    'legend',
	                                    { className: 'float-none m-0 w-auto', style: { fontSize: '14px' } },
	                                    'Tipo Persona:'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-5 ml-auto' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-check' },
	                                        _react2.default.createElement('input', { className: 'form-check-input', disabled: ops === 1 ? false : true, name: 'tipoper', value: '1', ref: chkNatural, onChange: onChangeCliente, id: 'tipoper', type: 'radio' }),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'form-check-label', 'for': 'exampleRadi4' },
	                                            'Natural'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-5 ml-auto' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-check' },
	                                        _react2.default.createElement('input', { className: 'form-check-input', disabled: ops === 1 ? false : true, name: 'tipoper', value: '2', ref: chkJuridico, onChange: onChangeCliente, id: 'tipoper', defaultChecked: true, type: 'radio' }),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'form-check-label', 'for': 'exampleRadi5' },
	                                            'Juridico'
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-2 ml-auto' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'input-group input-group-sm' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                    'Estatus:'
	                                ),
	                                _react2.default.createElement(
	                                    'select',
	                                    { ref: txtStatus, disabled: ops === 1 ? false : true, className: 'form-select form-select-sm', 'aria-label': '.form-select-sm example' },
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '' },
	                                        'Seleccione'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '51' },
	                                        'Activo'
	                                    ),
	                                    _react2.default.createElement(
	                                        'option',
	                                        { value: '52' },
	                                        'Inactivo'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-12 py-1' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                select === 1 ? "Nombre/Razón Social" : "Nombres y Apellidos"
	                            ),
	                            _react2.default.createElement('input', { type: 'text', autoComplete: 'off', ref: txtRazon, disabled: ops === 1 ? false : true, name: 'nombres', className: 'form-control', onChange: onChange, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-12' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Direcci\xF3n:'
	                            ),
	                            _react2.default.createElement('textarea', { type: 'area', autoComplete: 'off', ref: txtDirClient, disabled: ops === 1 ? false : true, name: 'direccion', className: 'form-control', onChange: onChange, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', style: { height: 40 } })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-4' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Email:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', autoComplete: 'off', ref: txtEmailClient, disabled: ops === 1 ? false : true, className: 'form-control', name: 'correoe', 'aria-label': 'Sizing example input', onChange: onChange, 'aria-describedby': 'inputGroup-sizing-sm' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-4' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Telefono:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', autoComplete: 'off', maxLength: 12, ref: txtTlf1Client, disabled: ops === 1 ? false : true, className: 'form-control', name: 'tlf1', 'aria-label': 'Sizing example input', onChange: onChange, 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: handleInputNumChange })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-4' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Celular:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', autoComplete: 'off', maxLength: 12, ref: txtTlf2Client, disabled: ops === 1 ? false : true, className: 'form-control', name: 'tlf2', 'aria-label': 'Sizing example input', onChange: onChange, 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: handleInputNumChange })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-4' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Estado:'
	                            ),
	                            _react2.default.createElement(
	                                'select',
	                                { ref: txtEstado, disabled: ops === 1 ? false : true, onChange: onChangeCliente, name: 'estado', idciudad: 'estado', className: 'form-select form-select-sm', 'aria-label': '.form-select-sm example' },
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: '' },
	                                    'seleccione'
	                                ),
	                                estados && estados.map(function (item, index) {
	                                    return _react2.default.createElement(
	                                        'option',
	                                        { key: index, value: item.idestado },
	                                        item.nombre
	                                    );
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-4' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Municipio:'
	                            ),
	                            _react2.default.createElement(
	                                'select',
	                                { ref: txtMunicipio, disabled: ops === 1 ? false : true, onChange: onChangeCliente, name: 'municipio', id: 'municipio', className: 'form-select form-select-sm', 'aria-label': '.form-select-sm example' },
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: '' },
	                                    'seleccione'
	                                ),
	                                municipios && municipios.map(function (item, index) {
	                                    return _react2.default.createElement(
	                                        'option',
	                                        { key: index, value: item.idmunicipio },
	                                        item.nombre
	                                    );
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-4' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Ciudad:'
	                            ),
	                            _react2.default.createElement(
	                                'select',
	                                { ref: txtCiudad, disabled: ops === 1 ? false : true, name: 'ciudad', id: 'ciudad', className: 'form-select form-select-sm', 'aria-label': '.form-select-sm example' },
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: '' },
	                                    'seleccione'
	                                ),
	                                ciudades && ciudades.map(function (item, index) {
	                                    return _react2.default.createElement(
	                                        'option',
	                                        { key: index, value: item.idciudad },
	                                        item.nombre
	                                    );
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'fieldset',
	                        { className: ' row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between' },
	                        _react2.default.createElement(
	                            'legend',
	                            { className: 'float-none w-auto fw-bold', style: { fontSize: '15px' } },
	                            'Responsable'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-3' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Cedula:'
	                            ),
	                            _react2.default.createElement(
	                                'select',
	                                { ref: cmbNacionalidad, name: 'nacionalidad', className: 'form-select form-select-sm col-md-3', disabled: ops === 1 ? false : true, 'aria-label': '.form-select-sm example', onChange: onChange },
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: '' },
	                                    '--'
	                                ),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'V' },
	                                    'V'
	                                ),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'E' },
	                                    'E'
	                                )
	                            ),
	                            _react2.default.createElement('input', { ref: txtCedRes, maxLength: 8, autoComplete: 'off', type: 'text', disabled: ops === 1 ? false : true, className: 'form-control col-4 px-1', name: 'cedula', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: validarPersona, onBlur: validarPersona, onChange: onChange }),
	                            _react2.default.createElement(
	                                'button',
	                                { disabled: ops === 1 ? false : true, type: 'button', onClick: function onClick() {
	                                        return setCatalogoPersona(true);
	                                    }, className: 'btn btn-success' },
	                                _react2.default.createElement('i', { className: 'fas fa-search' })
	                            )
	                        ),
	                        _react2.default.createElement('div', { className: 'col-md-2' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-2' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Sexo:'
	                            ),
	                            _react2.default.createElement(
	                                'select',
	                                { ref: cmbSexo, className: 'form-select form-select-sm col-5', name: 'sexo', disabled: habilitadoNU, onChange: onChange, 'aria-label': '.form-select-sm example' },
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: '' },
	                                    '--'
	                                ),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'M' },
	                                    'M'
	                                ),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: 'F' },
	                                    'F'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-3 ml-auto' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Fecha de Nacimiento'
	                            ),
	                            _react2.default.createElement('input', { type: 'date', ref: txtFechaNac, max: fechaTope, className: 'form-control', name: 'fnacimiento', 'aria-label': 'Sizing example input', onChange: onChange, disabled: habilitadoNU, 'aria-describedby': 'inputGroup-sizing-sm' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-6' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Nombres:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', autoComplete: 'off', ref: txtNomResp, name: 'nombres', className: 'form-control', onChange: onChange, 'aria-label': 'Sizing example input', disabled: habilitadoNU, 'aria-describedby': 'inputGroup-sizing-sm' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-6' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Apellidos:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', autoComplete: 'off', ref: txtApeResp, name: 'apellidos', className: 'form-control', onChange: onChange, 'aria-label': 'Sizing example input', disabled: habilitadoNU, 'aria-describedby': 'inputGroup-sizing-sm' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-12' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Direcci\xF3n:'
	                            ),
	                            _react2.default.createElement('textarea', { type: 'area', autoComplete: 'off', ref: txtDireccion, name: 'direccion', className: 'form-control', onChange: onChange, 'aria-label': 'Sizing example input', disabled: habilitadoNU, 'aria-describedby': 'inputGroup-sizing-sm', style: { height: 40 } })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-4' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Email:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', autoComplete: 'off', ref: txtEmail, className: 'form-control', name: 'correoe', 'aria-label': 'Sizing example input', onChange: onChange, disabled: habilitadoNU, 'aria-describedby': 'inputGroup-sizing-sm' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-4' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Telefono:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', autoComplete: 'off', maxLength: 12, ref: txtTlf1, className: 'form-control', name: 'tlf1', 'aria-label': 'Sizing example input', onChange: onChange, disabled: habilitadoNU, 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: handleInputNumChange })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-4' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Celular:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', autoComplete: 'off', maxLength: 12, ref: txtTlf2, className: 'form-control', name: 'tlf2', 'aria-label': 'Sizing example input', onChange: onChange, disabled: habilitadoNU, 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: handleInputNumChange })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'fieldset',
	                        { className: ' row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between' },
	                        _react2.default.createElement(
	                            'legend',
	                            { className: 'float-none w-auto fw-bold', style: { fontSize: '15px' } },
	                            'Otros Datos'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-4' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                '% Retenci\xF3n I.S.L.R:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', ref: txtIrsl, disabled: ops === 1 ? false : true, className: 'form-control px-0', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2 col-md-5' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'Grupo de Cliente:'
	                            ),
	                            _react2.default.createElement(
	                                'select',
	                                { ref: txtGrupoCLiente, disabled: ops === 1 ? false : true, className: 'form-select form-select-sm', 'aria-label': '.form-select-sm example' },
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: '' },
	                                    'seleccione'
	                                ),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: '1' },
	                                    'VIP'
	                                ),
	                                _react2.default.createElement(
	                                    'option',
	                                    { value: '2' },
	                                    'REGULAR'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-3' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'form-check' },
	                                _react2.default.createElement('input', { ref: txtRetencion, disabled: ops === 1 ? false : true, className: 'form-check-input', type: 'checkbox', value: '', id: 'flexCheckDefault' }),
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'form-check-label', htmlFor: 'flexCheckDefault' },
	                                    'Agente de Retenci\xF3n'
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { className: 'btn btn-sm btn-success rounded-pill', onClick: onChangeValidar, style: { margin: "5px" } },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        ),
	        _react2.default.createElement(_catalogoCliente2.default, {
	            show: catalogoCliente,
	            nomid: 'cliente',
	            onHideCancelar: function onHideCancelar() {
	                return setCatalogoCliente(false);
	            },
	            onHideAceptaCatalogo: onCatalogoCliente
	        }),
	        _react2.default.createElement(_catalogoPersona2.default, {
	            show: catalogoPersona,
	            onHideCancelaCatPer: function onHideCancelaCatPer() {
	                return setCatalogoPersona(false);
	            },
	            onHideAceptaCatPer: onCatalogoPersona
	        }),
	        _react2.default.createElement(
	            _semanticUiReact.Dimmer,
	            { active: activate, inverted: true },
	            _react2.default.createElement(
	                _semanticUiReact.Loader,
	                { inverted: true },
	                'Cargando...'
	            )
	        ),
	        _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	            onHide: function onHide() {
	                mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	            } }),
	        _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	            onHideNo: function onHideNo() {
	                return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	            }, onHideSi: handleCloseSi })
	    );
	};
	exports.default = RegistrarClientes;

/***/ },
/* 7020 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoAsientos = function CatalogoAsientos(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var idefiscal = JSON.parse(sessionStorage.getItem('idefiscal'));
	
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        records = _useState6[0],
	        setRecords = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({
	        idalmacen: '',
	        descripcion: '',
	        responsable: '',
	        ventas: false
	    }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        values = _useState8[0],
	        setValues = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(-1),
	        _useState10 = _slicedToArray(_useState9, 2),
	        itemSelect = _useState10[0],
	        setItemSelect = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filterFn = _useState12[0],
	        setFilterFn = _useState12[1];
	
	    var headCells = [{ label: 'CODIGO', textAlign: 'center' }, { label: 'DESCRIPCION', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (props.tabla === 0 ? x.idasiento.includes(target.value) : '' || props.tabla === 0 ? x.descripcion.toLowerCase().includes(target.value.toLowerCase()) : '') {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = 'idasiento,descripcion';
	        var nomtab = 'asiento';
	        var orden = 'idasiento';
	
	        var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setRecords([]);
	        setValues({
	            idalmacen: '',
	            descripcion: '',
	            responsable: '',
	            ventas: false
	        });
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	        props.onHideCancelar();
	        blanquear();
	    };
	
	    var seleccionarAlmacen = function seleccionarAlmacen() {
	
	        props.onHideAceptaCatalogo(values.idasiento);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	
	            setValues({
	                idasiento: item.idasiento
	
	            });
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Almacen'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group col-md-2 input-group-sm mb-3' },
	                        _react2.default.createElement('input', { type: 'text',
	                            onChange: handleSearch, className: 'form-control' }),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-info', style: { pointerEvents: 'none' } },
	                            _react2.default.createElement('i', { className: 'fa fa-search' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.idasiento === item.idasiento ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.idasiento
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.descripcion
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: seleccionarAlmacen },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoAsientos;

/***/ },
/* 7021 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoCuentasAsientos = function CatalogoCuentasAsientos(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var idefiscal = JSON.parse(sessionStorage.getItem('idefiscal'));
	
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        records = _useState6[0],
	        setRecords = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({
	        idalmacen: '',
	        descripcion: '',
	        responsable: '',
	        ventas: false
	    }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        values = _useState8[0],
	        setValues = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(-1),
	        _useState10 = _slicedToArray(_useState9, 2),
	        itemSelect = _useState10[0],
	        setItemSelect = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filterFn = _useState12[0],
	        setFilterFn = _useState12[1];
	
	    var headCells = [{ label: 'CODIGO', textAlign: 'center' }, { label: 'DESCRIPCION', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (props.tabla === 0 ? x.idplancuenta.includes(target.value) : '' || props.tabla === 0 ? x.descripcion.toLowerCase().includes(target.value.toLowerCase()) : '' || props.tabla === 0 ? x.codigocuenta.toLowerCase().includes(target.value.toLowerCase()) : '') {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var endpoint = void 0;
	
	        if (props.tabla === 0) {
	
	            var campos = '*';
	            var nomtab = 'plancuenta';
	            var condi = 'cargable = true';
	            var orden = 'idplancuenta';
	
	            endpoint = op.conexion + '/api/consulta/selecionarregistrocondi?campos=' + campos + '&nomtab=' + nomtab + '&condi=' + condi + '&orden=' + orden;
	        } else {
	
	            endpoint = op.conexion + '/api/contabilidad/ctaconta3/?idefiscal=' + parseInt(idefiscal);
	        }
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setRecords([]);
	        setValues({
	            idalmacen: '',
	            descripcion: '',
	            responsable: '',
	            ventas: false
	        });
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var seleccionarAlmacen = function seleccionarAlmacen() {
	
	        props.onHideAceptaCatalogo(values);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	            var idcuenta = void 0;
	
	            if (parseInt(props.tabla) === 0) {
	                setValues({
	                    idplancuenta: item.idplancuenta,
	                    codigocuenta: item.codigocuenta,
	                    descripcion: item.descripcion
	
	                });
	            } else {
	                setValues({
	                    idplancuenta: item.idplancuenta,
	                    codigocuenta: item.codigocuenta,
	                    descripcion: item.descripcion,
	                    idcuentacontable: item.idcuentacontable
	
	                });
	            }
	
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Almacen'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group col-md-2 input-group-sm mb-3' },
	                        _react2.default.createElement('input', { type: 'text',
	                            onChange: handleSearch, className: 'form-control' }),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-info', style: { pointerEvents: 'none' } },
	                            _react2.default.createElement('i', { className: 'fa fa-search' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.idplancuenta === item.idplancuenta ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.codigocuenta
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.descripcion
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: seleccionarAlmacen },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoCuentasAsientos;

/***/ },
/* 7022 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoBanco = function CatalogoBanco(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	    var txtBuscar = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        records = _useState6[0],
	        setRecords = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({
	        idbanco: '',
	        nombre: '' }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        values = _useState8[0],
	        setValues = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(-1),
	        _useState10 = _slicedToArray(_useState9, 2),
	        itemSelect = _useState10[0],
	        setItemSelect = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filterFn = _useState12[0],
	        setFilterFn = _useState12[1];
	
	    var headCells = [{ label: 'CODIGO', textAlign: 'center' }, { label: 'DESCRIPCION', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.idbanco.includes(target.value) || x.nombre.toLowerCase().includes(target.value.toLowerCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = 'idbanco, trim(nombre) as nombre';
	        var nomtab = 'bancos';
	        var orden = 'idbanco';
	
	        var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setRecords([]);
	        setValues({
	            idmarca: '',
	            descripcion: ''
	        });
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var seleccionarMarca = function seleccionarMarca() {
	
	        props.onHideAceptaCatalogo(values);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	
	            setValues({
	                idbanco: item.idbanco,
	                nombre: item.nombre
	            });
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	                txtBuscar.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Banco'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group col-md-6 input-group-sm mb-3' },
	                        _react2.default.createElement('input', { type: 'text',
	                            onChange: handleSearch, className: 'form-control text-uppercase', ref: txtBuscar }),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-info', style: { pointerEvents: 'none' } },
	                            _react2.default.createElement('i', { className: 'fa fa-search' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.idbanco === item.idbanco ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.idbanco
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-start' },
	                                    item.nombre
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', onClick: seleccionarMarca },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoBanco;

/***/ },
/* 7023 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _varios = __webpack_require__(14);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoBaseDatos = function CatalogoBaseDatos(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      records = _useState6[0],
	      setRecords = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    idbasedatos: "",
	    nombre: "",
	    ip: "",
	    puerto: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      values = _useState8[0],
	      setValues = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(-1),
	      _useState10 = _slicedToArray(_useState9, 2),
	      itemSelect = _useState10[0],
	      setItemSelect = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      filterFn = _useState12[0],
	      setFilterFn = _useState12[1];
	
	  var headCells = [{ label: "CODIGO", textAlign: "center" }, { label: "NOMBRE", textAlign: "center" }, { label: "IP", textAlign: "center" }, { label: "PUERTO", textAlign: "center" }];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.idbasedatos.includes(target.value) || x.puerto.toString().includes(target.value) || x.ip.includes(target.value) || x.nombre.toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "idbasedatos, trim(nombre) as nombre, trim(ip) as ip, puerto";
	    var nomtab = "basedatos";
	    var orden = "idbasedatos";
	
	    var endpoint = op.conexion + "/api/athos/consulta/seleccionarregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setItemSelect("");
	    setActivate(false);
	    setRecords([]);
	    setValues({
	      idbasedatos: "",
	      nombre: "",
	      ip: "",
	      puerto: ""
	    });
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var seleccionarBaseDatos = function seleccionarBaseDatos() {
	    props.onHideAceptaCatalogo(values);
	  };
	
	  var seleccionarFila = function seleccionarFila(item) {
	    return function (e) {
	      e.preventDefault();
	
	      setValues({
	        idbasedatos: item.idbasedatos,
	        nombre: item.nombre,
	        ip: item.ip,
	        puerto: item.puerto
	      });
	      btnAcepta.current.focus();
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        seleccionarRegistros();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Seleccionar Base de Datos"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-2 input-group-sm mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control"
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  style: {
	                    padding: "0",
	                    cursor: "pointer",
	                    background: values.idbasedatos === item.idbasedatos ? "lightskyblue" : "white"
	                  },
	                  onClick: seleccionarFila(item)
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.idbasedatos
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.nombre
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.ip
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.puerto
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          style: { margin: "5px" },
	          onClick: seleccionarBaseDatos
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoBaseDatos;

/***/ },
/* 7024 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoBeneficiarios = function CatalogoBeneficiarios(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	    var txtBuscar = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        records = _useState6[0],
	        setRecords = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({
	        idbanco: '',
	        nombre: '' }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        values = _useState8[0],
	        setValues = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(-1),
	        _useState10 = _slicedToArray(_useState9, 2),
	        itemSelect = _useState10[0],
	        setItemSelect = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filterFn = _useState12[0],
	        setFilterFn = _useState12[1];
	
	    var headCells = [{ label: 'CODIGO', textAlign: 'center' }, { label: 'DESCRIPCION', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.idbanco.includes(target.value) || x.nombre.toLowerCase().includes(target.value.toLowerCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = '*';
	        var nomtab = 'agente';
	        var condi = "beneficiario = true";
	        var orden = 'idagente';
	
	        var endpoint = op.conexion + '/api/consulta/selecionarregistrocondi?&campos=' + campos + '&nomtab=' + nomtab + '&condi=' + condi + '&orden=' + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setRecords([]);
	        setValues({
	            idmarca: '',
	            descripcion: ''
	        });
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var seleccionarMarca = function seleccionarMarca() {
	
	        props.onHideAceptaCatalogo(values);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	
	            setValues({
	                idagente: item.idagente,
	                nombre: item.nombre
	            });
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	                txtBuscar.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Beneficiario'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group col-md-6 input-group-sm mb-3' },
	                        _react2.default.createElement('input', { type: 'text',
	                            onChange: handleSearch, className: 'form-control text-uppercase', ref: txtBuscar }),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-info', style: { pointerEvents: 'none' } },
	                            _react2.default.createElement('i', { className: 'fa fa-search' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.idagente === item.idagente ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.idagente
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.nombre
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', onClick: seleccionarMarca },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoBeneficiarios;

/***/ },
/* 7025 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _varios = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoCrearMoneda = function CatalogoCrearMoneda(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var fechaSistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState4 = _slicedToArray(_useState3, 2),
	        mensajesino = _useState4[0],
	        setMensajesino = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(false),
	        _useState6 = _slicedToArray(_useState5, 2),
	        activate = _useState6[0],
	        setActivate = _useState6[1];
	
	    var _useState7 = (0, _react.useState)([]),
	        _useState8 = _slicedToArray(_useState7, 2),
	        body = _useState8[0],
	        setBody = _useState8[1];
	
	    var txtCodigo = (0, _react.useRef)();
	    var txtDescrip = (0, _react.useRef)();
	    var txtSimbolo = (0, _react.useRef)();
	    var txtTasa = (0, _react.useRef)();
	
	    var procesarRegistro = function procesarRegistro() {
	        setActivate(true);
	
	        var opera = props.operacion;
	
	        var endpoint = op.conexion + '/api/moneda/actualizar/' + opera;
	        _axios2.default.post(endpoint, body, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                if (opera === 1) {
	                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Creado Correctamente', icono: 'exito' });
	                } else if (opera === 2) {
	                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Modificado Correctamente', icono: 'exito' });
	                } else if (opera === 3) {
	                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Eliminado Correctamente', icono: 'exito' });
	                }
	                setActivate(false);
	            }
	        }).catch(function (error) {
	            var mensaje = '';
	            if (error.response === undefined) {
	                mensaje = 'Error de Conexion';
	            } else {
	
	                if (error.response.data.message === 'duplicate key value violates unique constraint "nombre_moneda_ukey"') {
	                    mensaje = 'Ya existe una moneda Con ese nombre';
	                } else {
	                    mensaje = error.response.data.message;
	                }
	            }
	            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	            setActivate(false);
	        });
	    };
	
	    var onChangeValidar = function onChangeValidar() {
	
	        var sigue = true;
	        if (props.operacion === 1 || props.operacion === 2 || props.operacion === 3) {
	
	            if (txtDescrip.current.value.trim() === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Campo Descripción no debe ir Vacio', icono: 'informacion' });
	                sigue = false;
	                txtDescrip.current.focus();
	            } else if (txtSimbolo.current.value.trim() === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Ingrese el Simbolo', icono: 'informacion' });
	                sigue = false;
	                txtSimbolo.current.focus();
	            } else if (txtTasa.current.value.trim() === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Introduzca la Tasa de Cambio', icono: 'informacion' });
	                sigue = false;
	                txtTasa.current.focus();
	            }
	
	            if (sigue) {
	
	                var moneda = [{
	                    idmoneda: props.operacion === 1 ? 0 : txtCodigo.current.value,
	                    descripcion: txtDescrip.current.value.toUpperCase().trim(),
	                    simbolo: txtSimbolo.current.value.trim(),
	                    valormoneda: txtTasa.current.value.replace(/\./g, '').replace(',', '.')
	                }];
	
	                /*  var monedeta = [
	                     {
	                         idmoneda: props.operacion === 1 ? 0 : txtCodigo.current.value,
	                         valormoneda: txtTasa.current.value.replace(/\./g, '').replace(',', '.'),
	                         fecha: moment(fechaSistema).format('YYYY-MM-DD')
	                     }
	                 ]; */
	
	                setBody({
	                    moneda: moneda
	                    /* monedeta */
	                });
	
	                var msg = '';
	                if (props.operacion === 1) {
	                    msg = 'Esta Seguro de Registrar estos Datos.';
	                } else if (props.operacion === 2) {
	                    msg = 'Esta Seguro de Modificar estos Datos.';
	                } else if (props.operacion === 3) {
	                    msg = 'Esta Seguro de Eliminar estos Datos.';
	                }
	
	                setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	            }
	        }
	    };
	
	    var handleCloseSi = function handleCloseSi() {
	        setActivate(false);
	        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        procesarRegistro();
	    };
	
	    var blanquear = function blanquear() {
	        setActivate(false);
	    };
	
	    var cerrarModal = function cerrarModal() {
	        blanquear();
	        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        props.onHideCancelar();
	        props.onHideAcepta();
	    };
	
	    var cancelar = function cancelar() {
	        blanquear();
	        props.onHideCancelar();
	        props.onHideAcepta();
	    };
	
	    var handleInputMontoChange = function handleInputMontoChange(event) {
	        (0, _varios.validaMonto)(event);
	        if (event.which === 13 || typeof event.which === 'undefined') {
	            if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
	                event.target.value = '0,00';
	            }
	            event.target.value = (0, _varios.formatoMonto)(event.target.value);
	            var char1 = event.target.value.substring(0, 1);
	            var char2 = event.target.value.substring(1, 2);
	            if (char1 === '0' && char2 !== ',') {
	                event.target.value = event.target.value.substring(1, event.target.value.legth);
	            }
	        } else if (event.which === 46) {
	            return false;
	        } else if (event.which >= 48 && event.which <= 57) {
	            return true;
	        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	            return true;
	        } else return false;
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'md',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	
	                if (props.operacion === 1) {
	                    txtCodigo.current.value = '';
	                    txtDescrip.current.value = '';
	                    txtSimbolo.current.value = '';
	                    txtTasa.current.value = '';
	                }
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    props.operacion === 1 ? 'Registrar Moneda' : props.operacion === 2 ? 'Modificar Moneda' : props.operacion === 3 ? 'Eliminar Moneda' : 'Consultar Moneda'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	                onHideNo: function onHideNo() {
	                    return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	                }, onHideSi: handleCloseSi }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 row m-0 border-azul py-2 rounded' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-pd-150 input-group input-group-sm mb-2 px-1' },
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                        'CODIGO:'
	                    ),
	                    _react2.default.createElement('input', { type: 'text', autoComplete: 'off', ref: txtCodigo, disabled: true, defaultValue: props.datos ? props.datos.idmoneda : '', className: 'form-control fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-pd-300 input-group input-group-sm mb-2 px-0' },
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                        'DESCRIPCION:'
	                    ),
	                    _react2.default.createElement('input', { type: 'text', autoComplete: 'off', ref: txtDescrip, disabled: props.operacion === 3 || props.operacion === 4 ? true : false, defaultValue: props.datos ? props.datos.descripcion : '', className: 'form-control fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-pd-150 input-group input-group-sm px-1' },
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                        'SIMBOLO:'
	                    ),
	                    _react2.default.createElement('input', { type: 'text', autoComplete: 'off', ref: txtSimbolo, disabled: props.operacion === 3 || props.operacion === 4 ? true : false, defaultValue: props.datos ? props.datos.simbolo : '', className: 'form-control fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-pd-230 input-group input-group-sm px-0' },
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                        'TASA DE CAMBIO:'
	                    ),
	                    _react2.default.createElement('input', { type: 'text', autoComplete: 'off', ref: txtTasa, disabled: props.operacion !== 1 ? true : false, defaultValue: props.datos ? (0, _varios.formatMoneda)(props.datos.valormoneda.toString().replace('.', ','), ',', '.', 2) : '', onFocus: _varios.seleccionarCampo, className: 'form-control text-right', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', placeholder: '0,00', onKeyUp: handleInputMontoChange, onBlur: handleInputMontoChange })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: onChangeValidar },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoCrearMoneda;

/***/ },
/* 7026 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _varios = __webpack_require__(14);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoCambiarTasa = function CatalogoCambiarTasa(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var fechaSistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState4 = _slicedToArray(_useState3, 2),
	        mensajesino = _useState4[0],
	        setMensajesino = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(false),
	        _useState6 = _slicedToArray(_useState5, 2),
	        activate = _useState6[0],
	        setActivate = _useState6[1];
	
	    var _useState7 = (0, _react.useState)([]),
	        _useState8 = _slicedToArray(_useState7, 2),
	        body = _useState8[0],
	        setBody = _useState8[1];
	
	    var txtTasa = (0, _react.useRef)();
	    var txtFecha = (0, _react.useRef)();
	
	    var procesarRegistro = function procesarRegistro() {
	        setActivate(true);
	
	        var opera = props.ope;
	
	        var endpoint = op.conexion + '/api/moneda/actualizar/' + opera;
	        _axios2.default.post(endpoint, body, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                if (opera === 1) {
	                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Creado Correctamente', icono: 'exito' });
	                } else if (opera === 2) {
	                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Modificado Correctamente', icono: 'exito' });
	                } else if (opera === 3) {
	                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Eliminado Correctamente', icono: 'exito' });
	                }
	                setActivate(false);
	            }
	        }).catch(function (error) {
	            var mensaje = '';
	            if (error.response === undefined) {
	                mensaje = 'Error de Conexion';
	            } else {
	
	                if (error.response.data.message === 'duplicate key value violates unique constraint "nombre_moneda_ukey"') {
	                    mensaje = 'Ya existe una moneda Con ese nombre';
	                } else {
	                    mensaje = error.response.data.message;
	                }
	            }
	            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	            setActivate(false);
	        });
	    };
	
	    var onChangeValidar = function onChangeValidar() {
	
	        var sigue = true;
	        if (props.ope === 1 || props.ope === 2) {
	
	            if (txtTasa.current.value.trim() === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Campo Descripción no debe ir Vacio', icono: 'informacion' });
	                sigue = false;
	                txtTasa.current.focus();
	            } else if (txtFecha.current.value.trim() === '') {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Ingrese el Simbolo', icono: 'informacion' });
	                sigue = false;
	                txtFecha.current.focus();
	            }
	
	            if (sigue) {
	
	                var moneda = [{
	                    idmoneda: props.ope === 1 ? 0 : props.idd,
	                    valormoneda: txtTasa.current.value.replace(/\./g, '').replace(',', '.'),
	                    fecha: txtFecha.current.value
	                }];
	
	                setBody({
	                    moneda: moneda
	                });
	
	                var msg = '';
	                if (props.ope === 1) {
	                    msg = 'Esta Seguro de Registrar estos Datos.';
	                } else if (props.ope === 2) {
	                    msg = 'Esta Seguro de Registrar estos Datos.';
	                } else if (props.ope === 3) {
	                    msg = 'Esta Seguro de Eliminar estos Datos.';
	                }
	
	                setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	            }
	        }
	    };
	
	    var handleCloseSi = function handleCloseSi() {
	        setActivate(false);
	        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        procesarRegistro();
	    };
	
	    var blanquear = function blanquear() {
	        setActivate(false);
	    };
	
	    var cerrarModal = function cerrarModal() {
	        blanquear();
	        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        props.onHideCancelar();
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var handleInputMontoChange = function handleInputMontoChange(event) {
	        (0, _varios.validaMonto)(event);
	        if (event.which === 13 || typeof event.which === 'undefined') {
	            if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
	                event.target.value = '0,00';
	            }
	            event.target.value = (0, _varios.formatoMonto)(event.target.value);
	            var char1 = event.target.value.substring(0, 1);
	            var char2 = event.target.value.substring(1, 2);
	            if (char1 === '0' && char2 !== ',') {
	                event.target.value = event.target.value.substring(1, event.target.value.legth);
	            }
	        } else if (event.which === 46) {
	            return false;
	        } else if (event.which >= 48 && event.which <= 57) {
	            return true;
	        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	            return true;
	        } else return false;
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'md',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	
	                txtFecha.current.value = (0, _moment2.default)(fechaSistema).format('YYYY-MM-DD');
	                txtTasa.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    props.ope === 1 ? 'Registrar Moneda' : props.ope === 2 ? 'Modificar Moneda' : 'Eliminar Moneda'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	                onHideNo: function onHideNo() {
	                    return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	                }, onHideSi: handleCloseSi }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 row m-0 border-azul py-2 rounded' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-pd-230 input-group input-group-sm mb-2' },
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                        'TASA DE CAMBIO:'
	                    ),
	                    _react2.default.createElement('input', { type: 'text', autoComplete: 'off', ref: txtTasa, onFocus: _varios.seleccionarCampo, className: 'form-control text-right', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', placeholder: '0,00', onKeyUp: handleInputMontoChange, onBlur: handleInputMontoChange })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-pd-220 input-group input-group-sm mb-2' },
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                        'FECHA:'
	                    ),
	                    _react2.default.createElement('input', { type: 'date', autoComplete: 'off', ref: txtFecha, className: 'form-control fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: onChangeValidar },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoCambiarTasa;

/***/ },
/* 7027 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoFabricantes = function CatalogoFabricantes(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	    var txtBuscar = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        records = _useState6[0],
	        setRecords = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({
	        idmodelo: '',
	        descripcion: ''
	    }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        values = _useState8[0],
	        setValues = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(-1),
	        _useState10 = _slicedToArray(_useState9, 2),
	        itemSelect = _useState10[0],
	        setItemSelect = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filterFn = _useState12[0],
	        setFilterFn = _useState12[1];
	
	    var headCells = [{ label: 'CODIGO', textAlign: 'center' }, { label: 'DESCRIPCION', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.idfabricante.includes(target.value) || x.descripcion.toLowerCase().includes(target.value.toLowerCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = 'idfabricante, trim(descripcion) as descripcion';
	        var nomtab = 'fabricante';
	        var orden = 'idfabricante';
	
	        var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setRecords([]);
	        setValues({
	            idfabricante: '',
	            descripcion: ''
	        });
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var seleccionarModelo = function seleccionarModelo() {
	
	        props.onHideAceptaCatalogo(values);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	
	            setValues({
	                idfabricante: item.idfabricante,
	                descripcion: item.descripcion
	            });
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	                txtBuscar.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Fabricante'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group col-md-6 input-group-sm mb-3' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'BUSCAR:'
	                            ),
	                            _react2.default.createElement('input', { type: 'text', onChange: handleSearch, ref: txtBuscar, className: 'form-control text-uppercase', autoComplete: 'off', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.idfabricante === item.idfabricante ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.idfabricante
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-start' },
	                                    item.descripcion
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: seleccionarModelo },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoFabricantes;

/***/ },
/* 7028 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoFacturasdCompra = function CatalogoFacturasdCompra(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	    var txtBuscar = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(true),
	        _useState6 = _slicedToArray(_useState5, 2),
	        activo = _useState6[0],
	        setActivo = _useState6[1];
	
	    var _useState7 = (0, _react.useState)([]),
	        _useState8 = _slicedToArray(_useState7, 2),
	        records = _useState8[0],
	        setRecords = _useState8[1];
	
	    var _useState9 = (0, _react.useState)({
	        idpedido: '',
	        numpedido: ''
	    }),
	        _useState10 = _slicedToArray(_useState9, 2),
	        values = _useState10[0],
	        setValues = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(-1),
	        _useState12 = _slicedToArray(_useState11, 2),
	        itemSelect = _useState12[0],
	        setItemSelect = _useState12[1];
	
	    var _useState13 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState14 = _slicedToArray(_useState13, 2),
	        filterFn = _useState14[0],
	        setFilterFn = _useState14[1];
	
	    var headCells = [{ label: 'N° FACTURA', textAlign: 'center' }, { label: 'CEDULA/RIF', textAlign: 'center' }, { label: 'NOMBRE', textAlign: 'center' }, { label: 'FECHA', textAlign: 'center' }, { label: 'ESTATUS', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.numfactura.toLowerCase().includes(target.value.toLowerCase()) || (0, _moment2.default)(x.fechafactura).format('DD/MM/YYYY').toLowerCase().includes(target.value.toLowerCase()) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.cedularif.toLowerCase().includes(target.value.toLowerCase()) || (x.status !== 4 ? 'PROCESADA' : 'ANULADA').toLowerCase().includes(target.value.toLowerCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = 'idfacturacompra, numfactura, fechafactura, nombre, cedularif, status';
	        var condicion = props.condicion;
	        var nomtab = 'facturacompra';
	        var endpoint = op.conexion + '/api/retenciones/catalogofacturascompra?campos=' + campos + '&condicion=' + condicion + '&nomtab=' + nomtab;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setActivo(true);
	        setRecords([]);
	        setValues({
	            idfacturacompra: '',
	            numfactura: ''
	        });
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var seleccionarProducto = function seleccionarProducto() {
	
	        props.onHideAceptaCatalogo(values);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	            setActivo(false);
	            setValues({
	                idfacturacompra: item.idfacturacompra,
	                numfactura: item.numfactura
	            });
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	                txtBuscar.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Factura de Compra'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group col-md-8 input-group-sm mb-3' },
	                        _react2.default.createElement('input', { type: 'text',
	                            onChange: handleSearch, ref: txtBuscar, className: 'form-control border-azul border-2 text-uppercase' }),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-info', style: { pointerEvents: 'none' } },
	                            _react2.default.createElement('i', { className: 'fa fa-search' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.idfacturacompra === item.idfacturacompra ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.numfactura
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.cedularif
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-start' },
	                                    item.nombre
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    (0, _moment2.default)(item.fechafactura).format('DD/MM/YYYY')
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: item.status !== 4 ? 'py-2 text-center text-bold' : 'py-2 text-center text-danger text-bold' },
	                                    item.status !== 4 ? 'PROCESADA' : 'ANULADA'
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, disabled: activo, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: seleccionarProducto },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoFacturasdCompra;

/***/ },
/* 7029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoMarca = function CatalogoMarca(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	    var txtBuscar = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        records = _useState6[0],
	        setRecords = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({
	        idmarca: '',
	        descripcion: '' }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        values = _useState8[0],
	        setValues = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(-1),
	        _useState10 = _slicedToArray(_useState9, 2),
	        itemSelect = _useState10[0],
	        setItemSelect = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filterFn = _useState12[0],
	        setFilterFn = _useState12[1];
	
	    var headCells = [{ label: 'CODIGO', textAlign: 'center' }, { label: 'DESCRIPCION', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.idmarca.includes(target.value) || x.descripcion.toLowerCase().includes(target.value.toLowerCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = 'idmarca, trim(descripcion) as descripcion';
	        var nomtab = 'marca';
	        var orden = 'idmarca';
	
	        var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setRecords([]);
	        setValues({
	            idmarca: '',
	            descripcion: ''
	        });
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var seleccionarMarca = function seleccionarMarca() {
	
	        props.onHideAceptaCatalogo(values);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	
	            setValues({
	                idmarca: item.idmarca,
	                descripcion: item.descripcion
	            });
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	                txtBuscar.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Marca'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group col-md-6 input-group-sm mb-3' },
	                        _react2.default.createElement('input', { type: 'text',
	                            onChange: handleSearch, className: 'form-control text-uppercase', ref: txtBuscar }),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-info', style: { pointerEvents: 'none' } },
	                            _react2.default.createElement('i', { className: 'fa fa-search' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.idmarca === item.idmarca ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.idmarca
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-start' },
	                                    item.descripcion
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: seleccionarMarca },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoMarca;

/***/ },
/* 7030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _varios = __webpack_require__(14);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoMoneda = function CatalogoMoneda(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        records = _useState6[0],
	        setRecords = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({
	        idmoneda: '',
	        descripcion: '',
	        simbolo: '',
	        predeterminada: false,
	        valormoneda: '' }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        values = _useState8[0],
	        setValues = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(-1),
	        _useState10 = _slicedToArray(_useState9, 2),
	        itemSelect = _useState10[0],
	        setItemSelect = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filterFn = _useState12[0],
	        setFilterFn = _useState12[1];
	
	    var headCells = [{ label: 'CODIGO', textAlign: 'center' }, { label: 'DESCRIPCION', textAlign: 'center' }, { label: 'SIMBOLO', textAlign: 'center' }, { label: 'PREDETERMINADA', textAlign: 'center' }, { label: 'TASA', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.idmoneda.includes(target.value) || x.descripcion.toLowerCase().includes(target.value.toLowerCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = 'idmoneda, trim(descripcion) as descripcion, simbolo, predeterminada, valormoneda';
	        var nomtab = 'moneda';
	        var orden = 'idmoneda';
	
	        var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setRecords([]);
	        setValues({
	            idmoneda: '',
	            descripcion: '',
	            simbolo: '',
	            predeterminada: false,
	            valormoneda: ''
	        });
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var seleccionarMoneda = function seleccionarMoneda() {
	
	        props.onHideAceptaCatalogo(values);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	
	            setValues({
	                idmoneda: item.idmoneda,
	                descripcion: item.descripcion,
	                simbolo: item.simbolo,
	                predeterminada: item.predeterminada,
	                valormoneda: item.valormoneda
	            });
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Moneda'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group col-md-2 input-group-sm mb-3' },
	                        _react2.default.createElement('input', { type: 'text',
	                            onChange: handleSearch, className: 'form-control' }),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-info', style: { pointerEvents: 'none' } },
	                            _react2.default.createElement('i', { className: 'fa fa-search' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.idmoneda === item.idmoneda ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.idmoneda
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-start' },
	                                    item.descripcion
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.simbolo
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.predeterminada ? _react2.default.createElement('i', { className: 'fas text-success fa-check-double' }) : _react2.default.createElement('i', { className: 'fas text-danger fa-exclamation-triangle' })
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-end' },
	                                    (0, _varios.formatMoneda)(item.valormoneda.replace('.', ','), ',', '.', 2)
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: seleccionarMoneda },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoMoneda;

/***/ },
/* 7031 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoNotaEntregaVacios = function CatalogoNotaEntregaVacios(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtBuscar = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      records = _useState6[0],
	      setRecords = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    idnotaentrega: "",
	    numnotaentrega: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      values = _useState8[0],
	      setValues = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(-1),
	      _useState10 = _slicedToArray(_useState9, 2),
	      itemSelect = _useState10[0],
	      setItemSelect = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      filterFn = _useState12[0],
	      setFilterFn = _useState12[1];
	
	  var headCells = [{ label: "FECHA", textAlign: "center" }, { label: "NÙMERO", textAlign: "center" }, { label: "CEDULA/RIF", textAlign: "center" }, { label: "NOMBRE", textAlign: "center" }];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.numnotaentrega.toLowerCase().includes(target.value.toLowerCase()) || (0, _moment2.default)(x.fecha).format("DD/MM/YYYY").toLowerCase().includes(target.value.toLowerCase()) || x.cliente.toLowerCase().includes(target.value.toLowerCase()) || x.rifcliente.toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	
	    var endpoint = op.conexion + "/api/inventariovacio/selecnotaentregavaciocatalogo";
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setItemSelect("");
	    setActivate(false);
	    setRecords([]);
	    setValues({
	      idnotaentrega: "",
	      numnotaentrega: ""
	    });
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var seleccionarProducto = function seleccionarProducto() {
	    props.onHideAceptaCatalogo(values);
	  };
	
	  var seleccionarFila = function seleccionarFila(item) {
	    return function (e) {
	      e.preventDefault();
	
	      setValues({
	        idnotaentrega: item.idnotaentrega,
	        numnotaentrega: item.numnotaentrega
	      });
	      btnAcepta.current.focus();
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "xl",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        seleccionarRegistros();
	        txtBuscar.current.focus();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Seleccionar Nota de ",
	          props.tipo === "ND" ? "Debito" : "Entrega"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-6 input-group-sm mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control text-uppercase",
	              ref: txtBuscar
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  style: {
	                    padding: "0",
	                    cursor: "pointer",
	                    background: values.idnotaentrega === item.idnotaentrega ? "lightskyblue" : "white"
	                  },
	                  onClick: seleccionarFila(item)
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  (0, _moment2.default)(item.fecha).format("DD/MM/YYYY")
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.numnotaentrega
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.rifcliente
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.cliente
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          onClick: seleccionarProducto
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoNotaEntregaVacios;

/***/ },
/* 7032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoOperacionInventario = function CatalogoOperacionInventario(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	    var txtBuscar = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        records = _useState6[0],
	        setRecords = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({
	        idoperacioninventario: '',
	        tipooperacion: '' }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        values = _useState8[0],
	        setValues = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(-1),
	        _useState10 = _slicedToArray(_useState9, 2),
	        itemSelect = _useState10[0],
	        setItemSelect = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filterFn = _useState12[0],
	        setFilterFn = _useState12[1];
	
	    var headCells = [{ label: 'CODIGO', textAlign: 'center' }, { label: 'FECHA', textAlign: 'center' }, { label: 'TIPO OPERACION', textAlign: 'center' }, { label: 'OBSERVACION', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.idoperacioninventario.includes(target.value) || x.tipooperacion.toLowerCase().includes(target.value.toLowerCase()) || (0, _moment2.default)(x.fecha).format('DD/MM/YYYY').toLowerCase().includes(target.value.toLowerCase()) || x.observacion.toLowerCase().includes(target.value.toLowerCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = 'idoperacioninventario, trim(tipooperacion) as tipooperacion, fecha, trim(observacion) as observacion';
	        var nomtab = 'operacioninventario';
	        var orden = 'idoperacioninventario desc';
	
	        var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setRecords([]);
	        setValues({
	            idoperacioninventario: '',
	            tipooperacion: ''
	        });
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var seleccionarProducto = function seleccionarProducto() {
	
	        props.onHideAceptaCatalogo(values);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	
	            setValues({
	                idoperacioninventario: item.idoperacioninventario,
	                tipooperacion: item.tipooperacion
	            });
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	                txtBuscar.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Operaci\xF3n de Inventario'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group col-md-6 input-group-sm mb-3' },
	                        _react2.default.createElement('input', { type: 'text',
	                            onChange: handleSearch, className: 'form-control text-uppercase', ref: txtBuscar }),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-info', style: { pointerEvents: 'none' } },
	                            _react2.default.createElement('i', { className: 'fa fa-search' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.idoperacioninventario === item.idoperacioninventario ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.idoperacioninventario
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    (0, _moment2.default)(item.fecha).format('DD/MM/YYYY')
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.tipooperacion
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2' },
	                                    item.observacion
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: seleccionarProducto },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoOperacionInventario;

/***/ },
/* 7033 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoOperacionInventario = function CatalogoOperacionInventario(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtBuscar = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      records = _useState6[0],
	      setRecords = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    idoperacioninventario: "",
	    tipooperacion: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      values = _useState8[0],
	      setValues = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(-1),
	      _useState10 = _slicedToArray(_useState9, 2),
	      itemSelect = _useState10[0],
	      setItemSelect = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      filterFn = _useState12[0],
	      setFilterFn = _useState12[1];
	
	  var headCells = [{ label: "CODIGO", textAlign: "center" }, { label: "FECHA", textAlign: "center" }, { label: "TIPO OPERACION", textAlign: "center" }, { label: "OBSERVACION", textAlign: "center" }];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.idoperacioninventario.includes(target.value) || x.tipooperacion.toLowerCase().includes(target.value.toLowerCase()) || (0, _moment2.default)(x.fecha).format("DD/MM/YYYY").toLowerCase().includes(target.value.toLowerCase()) || x.observacion.toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "idoperacioninventario, trim(tipooperacion) as tipooperacion, fecha, trim(observacion) as observacion";
	    var nomtab = "operacioninventariovacio";
	    var orden = "idoperacioninventario desc";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setItemSelect("");
	    setActivate(false);
	    setRecords([]);
	    setValues({
	      idoperacioninventario: "",
	      tipooperacion: ""
	    });
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var seleccionarProducto = function seleccionarProducto() {
	    props.onHideAceptaCatalogo(values);
	  };
	
	  var seleccionarFila = function seleccionarFila(item) {
	    return function (e) {
	      e.preventDefault();
	
	      setValues({
	        idoperacioninventario: item.idoperacioninventario,
	        tipooperacion: item.tipooperacion
	      });
	      btnAcepta.current.focus();
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        seleccionarRegistros();
	        txtBuscar.current.focus();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Seleccionar Operaci\xF3n de Inventario"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-6 input-group-sm mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control text-uppercase",
	              ref: txtBuscar
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  style: {
	                    padding: "0",
	                    cursor: "pointer",
	                    background: values.idoperacioninventario === item.idoperacioninventario ? "lightskyblue" : "white"
	                  },
	                  onClick: seleccionarFila(item)
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.idoperacioninventario
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  (0, _moment2.default)(item.fecha).format("DD/MM/YYYY")
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.tipooperacion
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2" },
	                  item.observacion
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          style: { margin: "5px" },
	          onClick: seleccionarProducto
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoOperacionInventario;

/***/ },
/* 7034 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoPersonaAthos = function CatalogoPersonaAthos(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtPersona = (0, _react.useRef)([]);
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      activate = _useState2[0],
	      setActivate = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      records = _useState4[0],
	      setRecords = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mensaje = _useState6[0],
	      setMensaje = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      filterFn = _useState8[0],
	      setFilterFn = _useState8[1];
	
	  var headCells = [{ label: "CÉDULA", textAlign: "center" }, { label: "NOMBRES", textAlign: "center" }, { label: "APELLIDOS", textAlign: "center" }];
	
	  var values = {};
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if ((x.nacionalidad + x.cedula).toLowerCase().includes(target.value) || x.apellidos.toLowerCase().includes(target.value.toLowerCase()) || x.nombres.toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarPersonasTodas = function seleccionarPersonasTodas() {
	    var campos = "cedula, trim(nombres) as nombres, trim(apellidos) as apellidos, trim(direccion) as direccion, trim(correoe) as correoe, trim(tlf1) as tlf1, trim(tlf2) as tlf2, nacionalidad, sexo, fnacimiento";
	    var nomtab = "persona";
	    var orden = "cedula";
	
	    var endpoint = op.conexion + "/api/athos/consulta/seleccionarregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setActivate(false);
	        var perso = [];
	        for (var i = 0; i < response.data.length; i++) {
	          perso.push({
	            cedula: response.data[i].cedula,
	            nombres: response.data[i].nombres,
	            apellidos: response.data[i].apellidos,
	            correoe: response.data[i].correoe,
	            tlf1: response.data[i].tlf1,
	            tlf2: response.data[i].tlf2,
	            fnacimiento: response.data[i].fnacimiento,
	            nacionalidad: response.data[i].nacionalidad,
	            sexo: response.data[i].sexo,
	            direccion: response.data[i].direccion
	          });
	        }
	        setRecords(perso);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: "error al cargar los registros",
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setRecords([]);
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelaCatPer();
	  };
	
	  var seleccionarPersona = function seleccionarPersona() {
	    blanquear();
	    props.onHideAceptaCatPer(values);
	  };
	
	  var seleccionarFila = function seleccionarFila(item, index) {
	    var cedPer = item.cedula;
	    var nomPer = item.nombres;
	    var apePer = item.apellidos;
	    var correoPer = item.correoe;
	    var tlf1Per = item.tlf1;
	    var tlf2Per = item.tlf2;
	    var fnacPer = item.fnacimiento;
	    var nacPer = item.nacionalidad;
	    var sexoPer = item.sexo;
	    var direPer = item.direccion;
	
	    values = {
	      cedPer: cedPer,
	      nomPer: nomPer,
	      apePer: apePer,
	      correoPer: correoPer,
	      tlf1Per: tlf1Per,
	      tlf2Per: tlf2Per,
	      fnacPer: fnacPer,
	      nacPer: nacPer,
	      sexoPer: sexoPer,
	      direPer: direPer
	    };
	
	    for (var i = 0; i < txtPersona.current.length; i++) {
	      if (i === index) {
	        txtPersona.current[i].style.backgroundColor = "lightskyblue";
	      } else {
	        txtPersona.current[i].style.backgroundColor = "white";
	      }
	    }
	
	    btnAcepta.current.focus();
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        seleccionarPersonasTodas();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Seleccionar Persona"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-6 input-group-sm mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control"
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  ref: function ref(el) {
	                    return txtPersona.current[index] = el;
	                  },
	                  onClick: function onClick() {
	                    return seleccionarFila(item, index);
	                  }
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.nacionalidad + item.cedula
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.nombres
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.apellidos
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          style: { margin: "5px" },
	          onClick: seleccionarPersona
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoPersonaAthos;

/***/ },
/* 7035 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoPresupuesto = function CatalogoPresupuesto(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtBuscar = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(true),
	      _useState6 = _slicedToArray(_useState5, 2),
	      activo = _useState6[0],
	      setActivo = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      records = _useState8[0],
	      setRecords = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({
	    idpedido: "",
	    numpedido: ""
	  }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      values = _useState10[0],
	      setValues = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(-1),
	      _useState12 = _slicedToArray(_useState11, 2),
	      itemSelect = _useState12[0],
	      setItemSelect = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      filterFn = _useState14[0],
	      setFilterFn = _useState14[1];
	
	  var headCells = [{ label: "ID", textAlign: "center" }, { label: "NÙMERO", textAlign: "center" }, { label: "CEDULA/RIF", textAlign: "center" }, { label: "NOMBRE", textAlign: "center" }, { label: "MONTO TOTAL", textAlign: "center" }, { label: "ESTATUS", textAlign: "center" }, { label: "FECHA", textAlign: "center" }];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.idpresupuesto.includes(target.value) || x.codigo.toLowerCase().includes(target.value.toLowerCase()) || (0, _moment2.default)(x.fecha).format("DD/MM/YYYY").toLowerCase().includes(target.value.toLowerCase()) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.cedularif.toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "idpresupuesto, codigo, fecha, nombre, cedularif, montototal, status";
	    var condicion = props.condicion;
	    var nomtab = "presupuesto";
	    var endpoint = op.conexion + "/api/presupuestos/catalogopresupuesto?campos=" + campos + "&condicion=" + condicion + "&nomtab=" + nomtab;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setItemSelect("");
	    setActivate(false);
	    setActivo(true);
	    setRecords([]);
	    setValues({
	      idpresupuesto: "",
	      codigo: ""
	    });
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var seleccionarProducto = function seleccionarProducto() {
	    props.onHideAceptaCatalogo(values);
	  };
	
	  var seleccionarFila = function seleccionarFila(item) {
	    return function (e) {
	      e.preventDefault();
	      setActivo(false);
	      setValues({
	        idpresupuesto: item.idpresupuesto,
	        codigo: item.codigo
	      });
	      btnAcepta.current.focus();
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        seleccionarRegistros();
	        txtBuscar.current.focus();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Seleccionar Presupuesto"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-6 input-group-sm mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control text-uppercase",
	              ref: txtBuscar
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  style: {
	                    padding: "0",
	                    cursor: "pointer",
	                    background: values.idpresupuesto === item.idpresupuesto ? "lightskyblue" : "white"
	                  },
	                  onClick: seleccionarFila(item)
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.idpresupuesto
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.codigo
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.cedularif
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.nombre
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-end" },
	                  (0, _varios.formatMoneda)(item.montototal.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      style: {
	                        fontWeight: "bold",
	                        color: item.status === 0 ? "#007bff" : item.status === 1 ? "#28a745" : item.status === 4 ? "#dc3545" : "#000000"
	                      },
	                      disabled: true,
	                      defaultValue: item.status,
	                      className: "form-select form-select-sm text-uppercase px-1",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "0" },
	                      "PENDIENTE"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "PROCESADO"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "4" },
	                      "ANULADO"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  (0, _moment2.default)(item.fecha).format("DD/MM/YYYY")
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          disabled: activo,
	          className: "btn btn-sm btn-success rounded-pill",
	          onClick: seleccionarProducto
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoPresupuesto;

/***/ },
/* 7036 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoProductoServ = function CatalogoProductoServ(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtBuscar = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      records = _useState6[0],
	      setRecords = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    idproducto: "",
	    codigo: "",
	    nombre: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      values = _useState8[0],
	      setValues = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(-1),
	      _useState10 = _slicedToArray(_useState9, 2),
	      itemSelect = _useState10[0],
	      setItemSelect = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      filterFn = _useState12[0],
	      setFilterFn = _useState12[1];
	
	  var headCells = [{ label: "CODIGO", textAlign: "center" }, { label: "DESCRIPCION", textAlign: "center" }, { label: "EXISTENCIA", textAlign: "center" }];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.codigo.toLowerCase().includes(target.value.toLowerCase()) || x.nombre.toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	
	    var endpoint = op.conexion + "/api/inventario/productosyservicioscat?idalmacen=" + props.idalmacen;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        console.log(response.data);
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setItemSelect("");
	    setActivate(false);
	    setRecords([]);
	    setValues({
	      idproducto: "",
	      codigo: "",
	      nombre: "",
	      preciomax: "",
	      unidadalterna: "",
	      unidadmedida: ""
	    });
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var seleccionarProducto = function seleccionarProducto() {
	    if (values.codigo === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "Debe Seleccionar un Producto.",
	        icono: "informacion"
	      });
	    } else {
	      props.onHideAceptaCatalogo(values);
	    }
	  };
	
	  var seleccionarFila = function seleccionarFila(item) {
	    return function (e) {
	      e.preventDefault();
	
	      setValues({
	        idproducto: item.idproducto,
	        codigo: item.codigo,
	        nombre: item.nombre,
	        ivaventa: item.ivaventa,
	        nombrecorto: item.nombrecorto,
	        preciomax: item.utipreciomaxi,
	        unidadalterna: item.idunidadalterna,
	        unidadmedida: item.idunidadmedida
	      });
	      btnAcepta.current.focus();
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        seleccionarRegistros();
	        txtBuscar.current.focus();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          props.esservicio === "1" ? 'Seleccionar Servicio' : 'Seleccionar Producto'
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-6 mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control fs-5 h-100 text-uppercase",
	              ref: txtBuscar
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  style: {
	                    padding: "0",
	                    cursor: "pointer",
	                    background: values.idproducto === item.idproducto ? "lightskyblue" : "white"
	                  },
	                  onClick: seleccionarFila(item)
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.codigo
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.nombre
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.cantidad
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          style: { margin: "5px" },
	          onClick: seleccionarProducto
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoProductoServ;

/***/ },
/* 7037 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable = __webpack_require__(20);
	
	var _useTable2 = _interopRequireDefault(_useTable);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _varios = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoProductoUpdate = function CatalogoProductoUpdate(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtCliente = (0, _react.useRef)([]);
	  var txtBuscar = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      listaClientes = _useState6[0],
	      setListaClientes = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      clientesTodos = _useState8[0],
	      setClientesTodos = _useState8[1];
	
	  var values = {
	    idproducto: "",
	    codigo: "",
	    nombre: "",
	    idtipoproducto: "",
	    idunidadmedida: "",
	    ivaventa: 0.0,
	    tipoprecio: "",
	    idunidadalterna: "",
	    idunidadventa: "",
	    valorfactor: 0.0,
	    tipofactor: "",
	    idmoneda: "",
	    valormoneda: 0.0,
	    costo: 0.0,
	    costoalter: 0.0,
	    precio: 0.0,
	    precioalter: 0.0,
	    utilidad: 0.0,
	    utilidadalter: 0.0,
	    descripcionuni: "",
	    descripcionunialt: "",
	    imagen: ""
	  };
	
	  var headCells = [{ label: "CODIGO", textAlign: "center" }, { label: "NOMBRE", textAlign: "center" }, { label: "UNIDAD", textAlign: "center" }, { label: "PRECIO", textAlign: "center" }];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	    var lista = [];
	
	    if (target.value === "") {
	      lista = clientesTodos;
	    } else {
	      lista = clientesTodos.filter(function (x) {
	        if (x.idproducto.includes(target.value) || x.codigo.toLowerCase().includes(target.value.toLowerCase()) || x.nombre.toLowerCase().includes(target.value.toLowerCase())) {
	          return x;
	        }
	      });
	    }
	
	    setListaClientes(lista);
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "*";
	    var nomtab = "seleccionar_productos_update()";
	    var orden = "idproducto";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setListaClientes(response.data);
	          setClientesTodos(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setListaClientes([]);
	    setClientesTodos([]);
	    values = {
	      idproducto: "",
	      codigo: "",
	      nombre: "",
	      idtipoproducto: "",
	      idunidadmedida: "",
	      ivaventa: 0.0,
	      tipoprecio: "",
	      idunidadalterna: "",
	      idunidadventa: "",
	      valorfactor: 0.0,
	      tipofactor: "",
	      idmoneda: "",
	      valormoneda: 0.0,
	      costo: 0.0,
	      costoalter: 0.0,
	      precio: 0.0,
	      precioalter: 0.0,
	      utilidad: 0.0,
	      utilidadalter: 0.0,
	      descripcionuni: "",
	      descripcionunialt: "",
	      imagen: ""
	    };
	  };
	
	  var seleccionarFila = function seleccionarFila(item, index) {
	    values = {
	      idproducto: item.idproducto,
	      codigo: item.codigo,
	      nombre: item.nombre,
	      idtipoproducto: item.idtipoproducto,
	      idunidadmedida: item.idunidadmedida,
	      ivaventa: item.ivaventa,
	      tipoprecio: item.tipoprecio,
	      idunidadalterna: item.idunidadalterna,
	      idunidadventa: item.idunidadventa,
	      valorfactor: item.valorfactor,
	      tipofactor: item.tipofactor,
	      idmoneda: item.idmoneda,
	      valormoneda: item.valormoneda,
	      costo: item.costo,
	      costoalter: item.costoalter,
	      precio: item.precio,
	      precioalter: item.precioalter,
	      utilidad: item.utilidad,
	      utilidadalter: item.utilidadalter,
	      descripcionuni: item.descripcionuni,
	      descripcionunialt: item.descripcionunialt,
	      imagen: item.imagen
	    };
	
	    for (var i = 0; i < txtCliente.current.length; i++) {
	      if (i === index) {
	        txtCliente.current[i].style.backgroundColor = "lightskyblue";
	      } else {
	        if (txtCliente.current[i]) {
	          txtCliente.current[i].style.backgroundColor = "white";
	        }
	      }
	    }
	
	    btnAcepta.current.focus();
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var seleccionarCliente = function seleccionarCliente() {
	    props.onHideAceptaCatalogo(values);
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        seleccionarRegistros();
	        txtBuscar.current.focus();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Seleccionar Productos"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-6 input-group-sm mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control text-uppercase",
	              ref: txtBuscar
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          {
	            container: {
	              height: 200,
	              width: "100%",
	              overflow: "auto",
	              padding: "2px",
	              fontSizeAdjust: "0.6"
	            }
	          },
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            listaClientes && listaClientes.map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  ref: function ref(el) {
	                    return txtCliente.current[index] = el;
	                  },
	                  style: { backgroundColor: "white" },
	                  onClick: function onClick() {
	                    return seleccionarFila(item, index);
	                  }
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.codigo
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.nombre
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.descripcionuni
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  (0, _varios.formatMoneda)(item.precio.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                )
	              );
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          style: { margin: "5px" },
	          onClick: seleccionarCliente
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoProductoUpdate;

/***/ },
/* 7038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoSupervisor = function CatalogoSupervisor(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	
	    var btnCancela = (0, _react.useRef)();
	    var btnAcepta = (0, _react.useRef)();
	    var btnSalir = (0, _react.useRef)();
	    var txtCodigo = (0, _react.useRef)();
	    var txtCedula = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        idusu = _useState2[0],
	        setIdusu = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(true),
	        _useState4 = _slicedToArray(_useState3, 2),
	        vinpurt = _useState4[0],
	        setVinput = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(false),
	        _useState6 = _slicedToArray(_useState5, 2),
	        mostrarClavesup = _useState6[0],
	        setMostrarClavesup = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        mensaje = _useState8[0],
	        setMensaje = _useState8[1];
	
	    var _useState9 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState10 = _slicedToArray(_useState9, 2),
	        mensajesino = _useState10[0],
	        setMensajesino = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(false),
	        _useState12 = _slicedToArray(_useState11, 2),
	        activate = _useState12[0],
	        setActivate = _useState12[1];
	
	    var blanquear = function blanquear() {
	        setIdusu(null);
	        setVinput(true);
	    };
	
	    var cancelar = function cancelar() {
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var onChangeValidar = function onChangeValidar(e) {
	        e.preventDefault();
	        var sigue = true;
	        if (props.ope === 3) {
	
	            if (txtCedula.current.value === '') {
	                setMensaje({
	                    mostrar: true,
	                    titulo: "Notificación",
	                    texto: "¡ Introduzca el Número de Cédula del Supervisor !",
	                    icono: "informacion"
	                });
	                sigue = false;
	                txtCedula.current.focus();
	            }
	
	            if (sigue === true) {
	                var cedu = txtCedula.current.value.trim();
	                var clav = txtCodigo.current.value.trim();
	                seleccionarAcceso(cedu, clav);
	            }
	        }
	    };
	
	    var seleccionarAcceso = function seleccionarAcceso(cedula, clave) {
	
	        var endpoint = op.conexion + '/api/athos/usuario/supervisor?cedula=' + cedula + '&clave=' + clave;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                "x-access-token": '' + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                if (response.data.idusuario > 0) {
	                    props.onHideAceptaCatalogo("AUTORIZADO");
	                    props.onHideCancelar();
	                } else {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Notificacion",
	                        texto: "¡ Cédula y/o Clave Incorrecto !",
	                        icono: "informacion"
	                    });
	                }
	            }
	            setActivate(false);
	        }).catch(function (error) {
	            setMensaje({
	                mostrar: true,
	                titulo: "Error",
	                texto: error.response.data.message,
	                icono: "error"
	            });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var onChange = function onChange(e) {
	
	        if (e.target.name === 'clave') {
	            if (e.target.value !== '') {
	                setVinput(false);
	            }
	        }
	    };
	
	    var handleCloseSi = function handleCloseSi() {
	        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    };
	
	    var cerrarModal = function cerrarModal() {
	        blanquear();
	        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	    };
	
	    var handleInputNumeroChange = function handleInputNumeroChange(event) {
	        event.preventDefault();
	        if (event.which === 13 || typeof event.which === "undefined") {
	            if (event.target.value !== "") {
	                if (event.target.name === "cedula") {
	                    txtCodigo.current.focus();
	                } else if (event.target.name === "clave") {
	                    btnAcepta.current.focus();
	                }
	            }
	        }
	    };
	
	    var mostrarPasswordsup = function mostrarPasswordsup() {
	        return setMostrarClavesup(!mostrarClavesup);
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'md',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                if (props.ope === 3) {
	                    txtCedula.current.focus();
	                }
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'SUPERVISOR'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	                onHideNo: function onHideNo() {
	                    return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	                }, onHideSi: handleCloseSi }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    'fieldset',
	                    { className: 'row col-sm-12 mx-auto mb-1 px-0' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm mb-2' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'CEDULA: '
	                            ),
	                            _react2.default.createElement('input', { autoComplete: 'off', type: 'text', name: 'cedula', ref: txtCedula, onKeyUp: handleInputNumeroChange, onBlur: handleInputNumeroChange, className: 'form-control bg-transparent fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'input-group input-group-sm' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                'CLAVE DE SUPERVISOR: '
	                            ),
	                            _react2.default.createElement('input', { autoComplete: 'off', type: mostrarClavesup ? "text" : "password", onChange: onChange, name: 'clave', ref: txtCodigo, onKeyUp: handleInputNumeroChange, className: 'form-control bg-transparent fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    style: { textAlign: "center", color: "white" },
	                                    onClick: mostrarPasswordsup,
	                                    className: 'btn btn-sm btn-info'
	                                },
	                                _react2.default.createElement('i', {
	                                    className: 'fa fa-eye-slash'
	                                }),
	                                " "
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: onChangeValidar },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoSupervisor;

/***/ },
/* 7039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoTipoProducto = function CatalogoTipoProducto(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	    var txtBuscar = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        records = _useState6[0],
	        setRecords = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({
	        idtipoproducto: '',
	        descripcion: '',
	        informatica: '' }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        values = _useState8[0],
	        setValues = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(-1),
	        _useState10 = _slicedToArray(_useState9, 2),
	        itemSelect = _useState10[0],
	        setItemSelect = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filterFn = _useState12[0],
	        setFilterFn = _useState12[1];
	
	    var headCells = [{ label: 'CODIGO', textAlign: 'center' }, { label: 'DESCRIPCION', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.idtipoproducto.includes(target.value) || x.descripcion.toLowerCase().includes(target.value.toLowerCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = 'idtipoproducto, trim(descripcion) as descripcion, informatica';
	        var nomtab = 'tipoproducto';
	        var orden = 'idtipoproducto';
	
	        var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setRecords([]);
	        setValues({
	            idtipoproducto: '',
	            descripcion: '',
	            informatica: ''
	        });
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var seleccionarTipoProducto = function seleccionarTipoProducto() {
	
	        props.onHideAceptaCatalogo(values);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	
	            setValues({
	                idtipoproducto: item.idtipoproducto,
	                descripcion: item.descripcion,
	                informatica: item.informatica
	            });
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	                txtBuscar.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Tipo Producto'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group col-md-6 input-group-sm mb-3' },
	                        _react2.default.createElement('input', { type: 'text',
	                            onChange: handleSearch, className: 'form-control text-uppercase', ref: txtBuscar }),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-info', style: { pointerEvents: 'none' } },
	                            _react2.default.createElement('i', { className: 'fa fa-search' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.idtipoproducto === item.idtipoproducto ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.idtipoproducto
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-start' },
	                                    item.descripcion
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: seleccionarTipoProducto },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoTipoProducto;

/***/ },
/* 7040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoUnidadMedida = function CatalogoUnidadMedida(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	    var txtBuscar = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        records = _useState6[0],
	        setRecords = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({
	        idunidadmedida: '',
	        descripcion: '' }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        values = _useState8[0],
	        setValues = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(-1),
	        _useState10 = _slicedToArray(_useState9, 2),
	        itemSelect = _useState10[0],
	        setItemSelect = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        filterFn = _useState12[0],
	        setFilterFn = _useState12[1];
	
	    var headCells = [{ label: 'CODIGO', textAlign: 'center' }, { label: 'DESCRIPCION', textAlign: 'center' }];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.idunidadmedida.includes(target.value) || x.descripcion.toLowerCase().includes(target.value.toLowerCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var campos = 'idunidadmedida, trim(descripcion) as descripcion';
	        var nomtab = 'unidadmedida';
	        var orden = 'idunidadmedida';
	
	        var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setItemSelect("");
	        setActivate(false);
	        setRecords([]);
	        setValues({
	            idunidadmedida: '',
	            descripcion: ''
	        });
	        setFilterFn({ fn: function fn(items) {
	                return items;
	            } });
	    };
	
	    var cancelar = function cancelar() {
	
	        blanquear();
	        props.onHideCancelar();
	    };
	
	    var seleccionarUnidadMedida = function seleccionarUnidadMedida() {
	
	        props.onHideAceptaCatalogo(values);
	    };
	
	    var seleccionarFila = function seleccionarFila(item) {
	        return function (e) {
	            e.preventDefault();
	
	            setValues({
	                idunidadmedida: item.idunidadmedida,
	                descripcion: item.descripcion
	            });
	            btnAcepta.current.focus();
	        };
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'lg',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                seleccionarRegistros();
	                txtBuscar.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Seleccionar Unidad de Medida'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'Cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { marginBottom: "10px" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group col-md-6 input-group-sm mb-3' },
	                        _react2.default.createElement('input', { type: 'text',
	                            onChange: handleSearch, className: 'form-control text-uppercase', ref: txtBuscar }),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-info', style: { pointerEvents: 'none' } },
	                            _react2.default.createElement('i', { className: 'fa fa-search' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: 'pointer', background: values.idunidadmedida === item.idunidadmedida ? "lightskyblue" : "white" }, onClick: seleccionarFila(item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-center' },
	                                    item.idunidadmedida
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'py-2 text-start' },
	                                    item.descripcion
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(TblPagination, null)
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, className: 'btn btn-sm btn-success rounded-pill', style: { margin: "5px" }, onClick: seleccionarUnidadMedida },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                ),
	                ' '
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoUnidadMedida;

/***/ },
/* 7041 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoSErviDescrip = function CatalogoSErviDescrip(props) {
	
	    var btnAcepta = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	    var txtDescripcion = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({
	        mostrar: false,
	        titulo: "",
	        texto: "",
	        icono: ""
	    }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var blanquear = function blanquear() {
	        setActivate(false);
	    };
	
	    var cancelar = function cancelar() {
	        blanquear();
	        props.onHideAceptaCatalogo(null);
	    };
	
	    var seleccionarCliente = function seleccionarCliente() {
	        props.onHideAceptaCatalogo(txtDescripcion.current.value.trim());
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: "lg",
	            "aria-labelledby": "contained-modal-title-vcenter",
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: "static",
	            keyboard: false,
	            onShow: function onShow() {
	                blanquear();
	                txtDescripcion.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: "azulGradiant2 header-modal" },
	            _react2.default.createElement(
	                "div",
	                { className: "fw-bold text-light" },
	                _react2.default.createElement(
	                    "h3",
	                    null,
	                    "Descripci\xF3n del Servicio"
	                )
	            ),
	            _react2.default.createElement(
	                "button",
	                {
	                    ref: btnCancela,
	                    className: "bg-transparent",
	                    style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	                    onClick: cancelar
	                },
	                _react2.default.createElement("i", { className: "far fa-window-close" })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_mensajes.Mensaje, {
	                mensaje: mensaje,
	                onHide: function onHide() {
	                    return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	                }
	            }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    "Cargando..."
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "col-md-12", style: { margin: "auto" } },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 mx-auto row mb-1 py-2 border-azul rounded " },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-12" },
	                        _react2.default.createElement(
	                            "label",
	                            {
	                                className: "input-group-text",
	                                id: "inputGroup-sizing-sm"
	                            },
	                            "DESCRIPCION:",
	                            " "
	                        ),
	                        _react2.default.createElement("textarea", {
	                            autoComplete: "off",
	                            type: "text",
	                            ref: txtDescripcion,
	                            className: "form-control fs-6 text-uppercase",
	                            style: { height: 50 },
	                            "aria-label": "Sizing example input",
	                            "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                "button",
	                {
	                    ref: btnAcepta,
	                    className: "btn btn-sm btn-success rounded-pill",
	                    style: { margin: "5px" },
	                    onClick: seleccionarCliente
	                },
	                _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-check-circle" },
	                    " Aceptar"
	                ),
	                " "
	            ),
	            _react2.default.createElement(
	                "button",
	                {
	                    ref: btnCancela,
	                    onClick: cancelar,
	                    className: "btn btn-sm btn-danger rounded-pill"
	                },
	                _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-window-close" },
	                    " Cancelar"
	                )
	            )
	        )
	    );
	};
	
	exports.default = CatalogoSErviDescrip;

/***/ },
/* 7042 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoListPagos = function CatalogoListPagos(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtBuscar = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      records = _useState6[0],
	      setRecords = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    idpago: "",
	    numpago: "",
	    monto: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      values = _useState8[0],
	      setValues = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(-1),
	      _useState10 = _slicedToArray(_useState9, 2),
	      itemSelect = _useState10[0],
	      setItemSelect = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      filterFn = _useState12[0],
	      setFilterFn = _useState12[1];
	
	  var headCells = [{ label: "FECHA", textAlign: "center" }, { label: "NÙMERO", textAlign: "center" }, { label: "CEDULA/RIF", textAlign: "center" }, { label: "NOMBRE", textAlign: "center" }, { label: "MONTO", textAlign: "center" }, { label: "TIPO", textAlign: "center" }];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.idpago.includes(target.value) || x.numpago.toLowerCase().includes(target.value.toLowerCase()) || (0, _moment2.default)(x.fecha).format("DD/MM/YYYY").toLowerCase().includes(target.value.toLowerCase()) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.rif.toLowerCase().includes(target.value.toLowerCase()) || (x.tipofac === "AN" ? "ANTICIPO" : "PAGO").toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "r.*, ag.nombre, ag.rif";
	    var nomtab = "registropago as r left join agente as ag on r.idcliente=ag.idagente";
	    var condi = props.condi;
	    var orden = "r.idpago desc";
	
	    var endpoint = op.conexion + "/api/consulta/selecionarregistrocondi?campos=" + campos + "&nomtab=" + nomtab + "&condi=" + condi + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setItemSelect("");
	    setActivate(false);
	    setRecords([]);
	    setValues({
	      idpago: "",
	      numpago: "",
	      monto: ""
	    });
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var seleccionarAnticipo = function seleccionarAnticipo() {
	    props.onHideAceptaCatalogo(values);
	  };
	
	  var seleccionarFila = function seleccionarFila(item) {
	    return function (e) {
	      e.preventDefault();
	      setValues({
	        idpago: item.idpago,
	        numpago: item.numpago,
	        monto: item.total
	      });
	      btnAcepta.current.focus();
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        seleccionarRegistros();
	        txtBuscar.current.focus();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Seleccionar Pago/Anticipo"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-6 input-group-sm mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control text-uppercase",
	              ref: txtBuscar
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  style: {
	                    padding: "0",
	                    cursor: "pointer",
	                    background: values.idpago === item.idpago ? "lightskyblue" : "white"
	                  },
	                  onClick: seleccionarFila(item)
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  (0, _moment2.default)(item.fecharegistro).format("DD/MM/YYYY")
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.numpago
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.rif
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.nombre
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-right" },
	                  (0, _varios.formatMoneda)(item.total.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.tipofac === "AN" ? "ANTICIPO" : "PAGO"
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null)
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          style: { margin: "5px" },
	          onClick: seleccionarAnticipo
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoListPagos;

/***/ },
/* 7043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CatPermisosUsuarios = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _modalPermisos = __webpack_require__(7060);
	
	var _modalPermisosv = __webpack_require__(7166);
	
	var _modalPermisosc = __webpack_require__(7076);
	
	var _modalPermisosContabilidad = __webpack_require__(7106);
	
	var _modalPermisosFinanzas = __webpack_require__(7124);
	
	var _modalPermisosVacios = __webpack_require__(7153);
	
	var _modalPermisosServicios = __webpack_require__(673);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatPermisosUsuarios = exports.CatPermisosUsuarios = function CatPermisosUsuarios(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
	
	  var headCells = [{ id: '', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CEDULA', textAlign: 'center' }, { id: '', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'USUARIO', textAlign: 'center' }, { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }];
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtTodasFechas = (0, _react.useRef)();
	  var txtBuscar = (0, _react.useRef)();
	  var txtTodosDispo = (0, _react.useRef)();
	  var txtCanceladas = (0, _react.useRef)();
	  var txtDeudas = (0, _react.useRef)();
	  var txtAnuladas = (0, _react.useRef)();
	  var txtTodosCliente = (0, _react.useRef)();
	  var txtPorCliente = (0, _react.useRef)();
	  var txtIdProducto = (0, _react.useRef)();
	  var txtRifrespon = (0, _react.useRef)();
	  var txtNomrespon = (0, _react.useRef)();
	  var txtDesde = (0, _react.useRef)();
	  var txtHasta = (0, _react.useRef)();
	  var txtCbmrif = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({ fn: function fn(items) {
	      return items;
	    } }),
	      _useState2 = _slicedToArray(_useState, 2),
	      filterFn = _useState2[0],
	      setFilterFn = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      inputalmacen = _useState4[0],
	      setInputalmacen = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      inputproducto = _useState6[0],
	      setInputproducto = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      tiporif = _useState8[0],
	      setTipofic = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(''),
	      _useState10 = _slicedToArray(_useState9, 2),
	      tituloc = _useState10[0],
	      setTituloc = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mostrar = _useState12[0],
	      setMostrar = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      operacion = _useState14[0],
	      setOperacion = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(),
	      _useState16 = _slicedToArray(_useState15, 2),
	      persona = _useState16[0],
	      setPersona = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(),
	      _useState18 = _slicedToArray(_useState17, 2),
	      usuario = _useState18[0],
	      setUsuario = _useState18[1];
	
	  var _useState19 = (0, _react.useState)([]),
	      _useState20 = _slicedToArray(_useState19, 2),
	      records = _useState20[0],
	      setRecords = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(''),
	      _useState22 = _slicedToArray(_useState21, 2),
	      paracliente = _useState22[0],
	      setParacliente = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(''),
	      _useState24 = _slicedToArray(_useState23, 2),
	      idclient = _useState24[0],
	      setIdclient = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(''),
	      _useState26 = _slicedToArray(_useState25, 2),
	      report = _useState26[0],
	      setReport = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(false),
	      _useState28 = _slicedToArray(_useState27, 2),
	      activate = _useState28[0],
	      setActivate = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(true),
	      _useState30 = _slicedToArray(_useState29, 2),
	      habilitado = _useState30[0],
	      setHabilitado = _useState30[1];
	
	  var _useState31 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState32 = _slicedToArray(_useState31, 2),
	      mensaje = _useState32[0],
	      setMensaje = _useState32[1];
	
	  var _useState33 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState34 = _slicedToArray(_useState33, 2),
	      mensajesino = _useState34[0],
	      setMensajesino = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(''),
	      _useState36 = _slicedToArray(_useState35, 2),
	      tituid = _useState36[0],
	      setTituid = _useState36[1];
	
	  var _useState37 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState38 = _slicedToArray(_useState37, 2),
	      botones = _useState38[0],
	      setBotones = _useState38[1];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting,
	      TblPagination = _useTable.TblPagination;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	    var st = '';
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") return items;else return items.filter(function (x) {
	          if (x.persona.includes(target.value) || x.login.toLowerCase().includes(target.value.toLowerCase())) {
	            return x;
	          }
	        });
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	
	    var define = "";
	
	    if (props.nom === 'Inventario') {
	      define = 'accinventario != ' + "'000000000000'";
	    } else if (props.nom === 'Ventas') {
	      define = 'accventas != ' + "'000000000'";
	    } else if (props.nom === 'Compras') {
	      define = 'acccompras != ' + "'00000'";
	    } else if (props.nom === 'Contabilidad') {
	      define = 'acccontabilidad != ' + "'000000'";
	    } else if (props.nom === 'Finanzas') {
	      define = 'accfinanzas != ' + "'00000000000'";
	    } else if (props.nom === 'Vacios') {
	      define = 'accvacios != ' + "'000000'";
	    } else if (props.nom === 'Servicios') {
	      define = 'accservicios != ' + "'0000000000'";
	    }
	
	    var endpoint = op.conexion + '/api/athos/consulta/consultausuariospermi?&idorganizacion=' + idorganizacion + '&parameter=' + define;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	          txtBuscar.current.focus();
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var SelectUsuario = function SelectUsuario(idusuario) {
	    var endpoint = op.conexion + '/api/athos/usuario/getuser?id=' + idusuario;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.idusuario > 0) {
	          setPersona({
	            cedula: response.data.cedula,
	            nombres: response.data.nombres,
	            apellidos: response.data.apellidos,
	            correoe: response.data.correoe,
	            tlf1: response.data.tlf1,
	            tlf2: response.data.tlf2,
	            fnacimiento: response.data.fnacimiento,
	            nacionalidad: response.data.nacionalidad,
	            sexo: response.data.sexo,
	            direccion: response.data.direccion,
	            nombreorg: response.data.nombreorg,
	            idorganizacion: response.data.idorganizacion
	          });
	          setUsuario(response.data);
	          setMostrar(true);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "Error al cargar el usuario",
	            icono: "informacion"
	          });
	          setUsuario([]);
	          setPersona([]);
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setInputalmacen(0);
	    setRecords([]);
	    setParacliente('');
	    setInputproducto(0);
	    setReport('');
	    setIdclient('');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    if (props.llamado === 2) {
	      props.onHideRenderizar();
	      props.onHideCancela();
	    }
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var gestionarUsuarios = function gestionarUsuarios(op, item) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        setOperacion(op);
	        SelectUsuario(item.idusuario);
	      }
	    };
	  };
	
	  var cerrarModalActualizar = function cerrarModalActualizar() {
	    setMostrar(false);
	    seleccionarRegistros();
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.op === 1) {
	          seleccionarRegistros();
	          txtBuscar.current.focus();
	          setHabilitado(false);
	        } else {
	
	          setHabilitado(true);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Permisos de Usuario'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      props.nom === 'Inventario' ? _react2.default.createElement(_modalPermisos.ModalPermisosUsuarios, {
	        show: mostrar,
	        op: operacion,
	        usuario: usuario,
	        persona: persona,
	        onHideCancela: cerrarModalActualizar
	      }) : props.nom === 'Ventas' ? _react2.default.createElement(_modalPermisosv.ModalPermisosUsuariosv, {
	        show: mostrar,
	        op: operacion,
	        usuario: usuario,
	        persona: persona,
	        onHideCancela: cerrarModalActualizar
	      }) : props.nom === 'Compras' ? _react2.default.createElement(_modalPermisosc.ModalPermisosUsuariosc, {
	        show: mostrar,
	        op: operacion,
	        usuario: usuario,
	        persona: persona,
	        onHideCancela: cerrarModalActualizar
	      }) : props.nom === 'Contabilidad' ? _react2.default.createElement(_modalPermisosContabilidad.ModalPermisosUsuariosContabilidad, {
	        show: mostrar,
	        op: operacion,
	        usuario: usuario,
	        persona: persona,
	        onHideCancela: cerrarModalActualizar
	      }) : props.nom === 'Finanzas' ? _react2.default.createElement(_modalPermisosFinanzas.ModalPermisosUsuariosFinanzas, {
	        show: mostrar,
	        op: operacion,
	        usuario: usuario,
	        persona: persona,
	        onHideCancela: cerrarModalActualizar
	      }) : props.nom === 'Vacios' ? _react2.default.createElement(_modalPermisosVacios.ModalPermisosUsuarisVacios, {
	        show: mostrar,
	        op: operacion,
	        usuario: usuario,
	        persona: persona,
	        onHideCancela: cerrarModalActualizar
	      }) : props.nom === 'Servicios' ? _react2.default.createElement(_modalPermisosServicios.ModalPermisosUsuarisServicios, {
	        show: mostrar,
	        op: operacion,
	        usuario: usuario,
	        persona: persona,
	        onHideCancela: cerrarModalActualizar
	      }) : '',
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto' },
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Usuarios Autorizados(',
	              props.nom === 'Inventario' ? 'Almacen' : props.nom,
	              ')'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-250 px-2 mb-1' },
	              _react2.default.createElement('input', { type: 'text', ref: txtBuscar, className: 'form-control form-control-sm rounded-pill border-azul text-uppercase', onChange: handleSearch, placeholder: 'BUSCAR' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12', style: { margin: "auto" } },
	              _react2.default.createElement(
	                TblContainer,
	                null,
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _semanticUiReact.TableBody,
	                  null,
	                  records && recordsAfterPagingAndSorting().map(function (item, index) {
	                    return _react2.default.createElement(
	                      _semanticUiReact.TableRow,
	                      { key: index, style: { padding: "0" } },
	                      _react2.default.createElement(
	                        _semanticUiReact.TableCell,
	                        { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                        item.persona
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.TableCell,
	                        { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center', width: '270px' } },
	                        item.login
	                      ),
	                      _react2.default.createElement(
	                        _semanticUiReact.TableCell,
	                        { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                        _react2.default.createElement(
	                          'button',
	                          { onClick: gestionarUsuarios(1, item), className: 'btn btn-sm mx-1 btn-warning rounded-circle' },
	                          _react2.default.createElement('i', { className: 'fa fa-edit' }),
	                          ' '
	                        )
	                      )
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(TblPagination, null)
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-4 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7044 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CatalogoSistema = function CatalogoSistema(_ref) {
	  var show = _ref.show,
	      idfranquicia = _ref.idfranquicia,
	      onHide = _ref.onHide;
	
	  var op = __webpack_require__(8);
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtCliente = (0, _react.useRef)([]);
	  var txtBuscar = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      listaAfiliados = _useState6[0],
	      setListaAfiliados = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      afiliadosTodos = _useState8[0],
	      setAfiliadosTodos = _useState8[1];
	
	  var values = {
	    idorganizacion: "",
	    rif: "",
	    nombre: "",
	    logo: "athos.png"
	  };
	
	  var headCells = [{ label: "ID", textAlign: "center" }, { label: "RIF", textAlign: "center" }, { label: "NOMBRE", textAlign: "center" }];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	    var lista = [];
	
	    if (target.value === "") {
	      lista = afiliadosTodos;
	    } else {
	      lista = afiliadosTodos.filter(function (x) {
	        if (x.idorganizacion.includes(target.value) || x.rif.includes(target.value) || x.nombre.toLowerCase().includes(target.value.toLowerCase())) {
	          return x;
	        }
	      });
	    }
	
	    setListaAfiliados(lista);
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros(id) {
	    var endpoint = op.conexion + "/api/athos/organizacion/obtener?idfranquicia=" + id;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          console.log(response.data);
	
	          setListaAfiliados(response.data);
	          setAfiliadosTodos(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setListaAfiliados([]);
	    setAfiliadosTodos([]);
	    values = {
	      idorganizacion: "",
	      rif: "",
	      nombre: "",
	      logo: "athos.png"
	    };
	  };
	
	  var seleccionarFila = function seleccionarFila(item, index) {
	    values = {
	      idorganizacion: item.idorganizacion,
	      rif: item.rif,
	      nombre: item.nombre,
	      logo: item.logo
	    };
	
	    for (var i = 0; i < txtCliente.current.length; i++) {
	      if (i === index) {
	        txtCliente.current[i].style.backgroundColor = "lightskyblue";
	      } else {
	        if (txtCliente.current[i]) {
	          txtCliente.current[i].style.backgroundColor = "white";
	        }
	      }
	    }
	
	    btnAcepta.current.focus();
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    onHide();
	  };
	
	  var seleccionarAfiliados = function seleccionarAfiliados() {
	    onHide(values);
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      show: show,
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        seleccionarRegistros(idfranquicia);
	        txtBuscar.current.focus();
	      }
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement("h3", null)
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "Cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { marginBottom: "10px" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group col-md-6 input-group-sm mb-3" },
	            _react2.default.createElement("input", {
	              type: "text",
	              onChange: handleSearch,
	              className: "form-control text-uppercase",
	              ref: txtBuscar
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                className: "btn btn-info",
	                style: { pointerEvents: "none" }
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12", style: { margin: "auto" } },
	        _react2.default.createElement(
	          TblContainer,
	          {
	            container: {
	              height: 200,
	              width: "100%",
	              overflow: "auto",
	              padding: "2px",
	              fontSizeAdjust: "0.6"
	            }
	          },
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _core.TableBody,
	            null,
	            listaAfiliados && listaAfiliados.map(function (item, index) {
	              return _react2.default.createElement(
	                _core.TableRow,
	                {
	                  key: index,
	                  ref: function ref(el) {
	                    return txtCliente.current[index] = el;
	                  },
	                  style: { backgroundColor: "white" },
	                  onClick: function onClick() {
	                    return seleccionarFila(item, index);
	                  }
	                },
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.idorganizacion
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-center" },
	                  item.rif
	                ),
	                _react2.default.createElement(
	                  _core.TableCell,
	                  { className: "py-2 text-start" },
	                  item.nombre
	                )
	              );
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          className: "btn btn-sm btn-success rounded-pill",
	          style: { margin: "5px" },
	          onClick: seleccionarAfiliados
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};
	
	exports.default = CatalogoSistema;

/***/ },
/* 7045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalVentasGanancias = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoProductosExistencias = __webpack_require__(91);
	
	var _catalogoProductosExistencias2 = _interopRequireDefault(_catalogoProductosExistencias);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalVentasGanancias = exports.ModalVentasGanancias = function ModalVentasGanancias(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtCodigo = (0, _react.useRef)();
	  var txtDesde = (0, _react.useRef)();
	  var txtHasta = (0, _react.useRef)();
	  var txtPorProduct = (0, _react.useRef)();
	  var txtNombreProducto = (0, _react.useRef)();
	  var txtTodosProduct = (0, _react.useRef)();
	  var txtReferencia = (0, _react.useRef)();
	  var txtFechaPago = (0, _react.useRef)();
	  var txtMoneda = (0, _react.useRef)();
	  var txtBanco = (0, _react.useRef)();
	  var txtNombre = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtCbmrif = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      inputalmacen = _useState2[0],
	      setInputalmacen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      inputproducto = _useState4[0],
	      setInputproducto = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      tiporif = _useState6[0],
	      setTipofic = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mostrar1 = _useState8[0],
	      setMostrar1 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mostrar2 = _useState10[0],
	      setMostrar2 = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(''),
	      _useState12 = _slicedToArray(_useState11, 2),
	      parafecha = _useState12[0],
	      setParafecha = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(''),
	      _useState14 = _slicedToArray(_useState13, 2),
	      desde = _useState14[0],
	      setDesde = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(''),
	      _useState16 = _slicedToArray(_useState15, 2),
	      hasta = _useState16[0],
	      setHasta = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(''),
	      _useState18 = _slicedToArray(_useState17, 2),
	      disponiblec = _useState18[0],
	      setDisponiblec = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(''),
	      _useState20 = _slicedToArray(_useState19, 2),
	      numnota = _useState20[0],
	      setNumNota = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(''),
	      _useState22 = _slicedToArray(_useState21, 2),
	      idclient = _useState22[0],
	      setIdclient = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(true),
	      _useState24 = _slicedToArray(_useState23, 2),
	      vinpurt = _useState24[0],
	      setVinput = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(0),
	      _useState26 = _slicedToArray(_useState25, 2),
	      valida2 = _useState26[0],
	      setValida2 = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(false),
	      _useState28 = _slicedToArray(_useState27, 2),
	      activate = _useState28[0],
	      setActivate = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(''),
	      _useState30 = _slicedToArray(_useState29, 2),
	      idproduct = _useState30[0],
	      setIdproduct = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(' and n.status != 4'),
	      _useState32 = _slicedToArray(_useState31, 2),
	      estatus = _useState32[0],
	      setEstatus = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(0),
	      _useState34 = _slicedToArray(_useState33, 2),
	      valida = _useState34[0],
	      setValida = _useState34[1];
	
	  var _useState35 = (0, _react.useState)({ fn: function fn(items) {
	      return items;
	    } }),
	      _useState36 = _slicedToArray(_useState35, 2),
	      filterFn = _useState36[0],
	      setFilterFn = _useState36[1];
	
	  var _useState37 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState38 = _slicedToArray(_useState37, 2),
	      mensaje = _useState38[0],
	      setMensaje = _useState38[1];
	
	  var _useState39 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState40 = _slicedToArray(_useState39, 2),
	      mensajesino = _useState40[0],
	      setMensajesino = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(''),
	      _useState42 = _slicedToArray(_useState41, 2),
	      tituid = _useState42[0],
	      setTituid = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      botones = _useState44[0],
	      setBotones = _useState44[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setInputalmacen(0);
	    setParafecha('');
	    setDisponiblec('');
	    setNumNota('');
	    setInputproducto(0);
	    setValida(0);
	    setValida2(0);
	    setIdclient('');
	    setIdproduct('');
	    setVinput(true);
	    setMostrar1(false);
	    setMostrar2(false);
	    setEstatus(' and n.status != 4');
	    setDesde('');
	    setHasta('');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope === 1) {
	
	      if (valida2 === 1 && txtTodosProduct.current.checked === false) {
	        if (txtPorProduct.current.checked === true && txtCodigo.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Código del Producto a Consultar !', icono: 'informacion' });
	          txtCodigo.current.focus();
	          sigue = false;
	        } else if (txtPorProduct.current.checked === false && txtTodosProduct.current.checked === false) {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Operación !', icono: 'informacion' });
	          txtTodosProduct.current.focus();
	          sigue = false;
	        } else {
	          imprimirMovimientosVentas();
	        }
	      } else if (sigue === true) {
	
	        imprimirMovimientosVentas();
	      }
	    }
	  };
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'desde') {
	      if (e.target.value > (0, _moment2.default)(fechasistema).format('YYYY-MM-DD')) {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !', icono: 'informacion' });
	        txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        txtDesde.current.focus();
	      } else {
	        setDesde(e.target.value);
	      }
	    } else if (e.target.name === 'hasta') {
	      setHasta(e.target.value);
	    }
	
	    if (e.target.name === 'inlineRadioOptions') {
	
	      if (e.target.value === '1') {
	        setVinput(false);
	        setValida2(0);
	        setValida(0);
	      } else {
	        setVinput(true);
	        setValida2(0);
	        setValida(1);
	      }
	    } else if (e.target.name === 'inlineRadioOptionst') {
	
	      if (e.target.value === '1') {
	        setValida2(0);
	        setVinput(false);
	        setIdproduct(' and nt.idproducto > 0');
	      } else {
	        setValida2(1);
	      }
	    }
	
	    if (e.target.name === 'inlineRadioOptionsd') {
	
	      if (e.target.value === '2') {
	        setEstatus(' and n.status = 1');
	      } else if (e.target.value === '3') {
	        setEstatus(' and n.status = 0');
	      } else {
	        setEstatus(' and n.status != 4');
	      }
	    }
	  };
	
	  var imprimirMovimientosVentas = function imprimirMovimientosVentas() {
	
	    var reporte = "";
	    var desdec = "'" + (0, _moment2.default)(desde).format('DD-MM-YYYY') + "'";
	    var hastac = "'" + (0, _moment2.default)(hasta).format('DD-MM-YYYY') + "'";
	    var condicion = void 0;
	    var oper = 0;
	
	    if (valida === 0) {
	      condicion = estatus;
	      reporte = "ReporteVentasGanancias";
	      oper = 1;
	    } else if (valida === 1 && valida2 === 0) {
	      condicion = idproduct + estatus;
	      reporte = "ReporteVentasGananciasTodosProductos";
	      oper = 3;
	    } else if (valida === 1 && valida2 === 1) {
	      condicion = idproduct + estatus;
	      reporte = "ReporteVentasGananciasXProducto";
	      oper = 2;
	    }
	
	    window.open(op.reportes + "/almacen?afiliado=" + afiliado + "&reporte=" + reporte + "&condi=" + condicion + "&desde=" + desdec + "&hasta=" + hastac + "&valida=" + oper, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  var handleAceptaProducto = function handleAceptaProducto(values) {
	    setMostrar2(false);
	    setVinput(false);
	    txtNombreProducto.current.value = values.nombrecorto;
	    txtCodigo.current.value = values.codigo;
	    setIdproduct(' and nt.idproducto = ' + values.idproducto);
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var seleccionarProducto = function seleccionarProducto(id) {
	    var campos = "idproducto, nombre";
	    var nomtab = "producto";
	    var nomid = "codigo";
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idproducto > 0) {
	          setIdproduct(' and nt.idproducto = ' + response.data.idproducto);
	          txtNombreProducto.current.value = response.data.nombre;
	          setVinput(false);
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Código y/o Producto no Existe !', icono: 'informacion' });
	          setVinput(true);
	          txtCodigo.current.value = "";
	          setIdproduct('');
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var handleInputNumeroChange = function handleInputNumeroChange(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "notaentrega") {
	          seleccionarProducto(event.target.value.toUpperCase());
	        } /* else if (event.target.name === "nalmacen") {
	          seleccionarAlmacen(event.target.value);
	          } */
	      }
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.ope === 1) {
	          txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	          txtHasta.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	          setDesde((0, _moment2.default)(fechasistema).format('YYYY-MM-DD'));
	          setHasta((0, _moment2.default)(fechasistema).format('YYYY-MM-DD'));
	          setVinput(false);
	          setEstatus(' and n.status != 4');
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Imprimir Movimientos de Ventas'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0 m-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 row m-0 px-0 py-2' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-pd-220 px-1 mb-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'DESDE:'
	              ),
	              _react2.default.createElement('input', { type: 'date', disabled: props.ope === 0 ? true : false, onChange: onChange, ref: txtDesde, name: 'desde', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-pd-220 px-1 mb-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'HASTA:'
	              ),
	              _react2.default.createElement('input', { type: 'date', disabled: props.ope === 0 ? true : false, onChange: onChange, ref: txtHasta, name: 'hasta', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fw-bold', style: { fontSize: '0.8rem' } },
	              'AGRUPADOS POR:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-400 px-0 mb-3 row m-0 d-flex justify-content-around' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check form-check-inline col-pd-120 mx-1 px-1' },
	                _react2.default.createElement('input', { className: 'form-check-input', type: 'radio', name: 'inlineRadioOptions', defaultChecked: true, onChange: onChange, id: 'inlineRadio1', value: '1' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'inlineRadio1', style: { fontSize: '0.8rem' } },
	                  'NOTAS DE ENTREGA'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check form-check-inline col-pd-150' },
	                _react2.default.createElement('input', { className: 'form-check-input', type: 'radio', name: 'inlineRadioOptions', onChange: onChange, id: 'inlineRadio2', value: '2' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'inlineRadio2', style: { fontSize: '0.8rem' } },
	                  'PRODUCTOS'
	                )
	              )
	            ),
	            valida === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'col-pd-400 px-0 mb-2 row m-0 d-flex justify-content-around' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check form-check-inline col-pd-120 mx-2 px-1' },
	                _react2.default.createElement('input', { className: 'form-check-input', type: 'radio', ref: txtTodosProduct, name: 'inlineRadioOptionst', onChange: onChange, id: 'inlineRadiot1', value: '1' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'inlineRadiot1', style: { fontSize: '0.8rem' } },
	                  'TODOS'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check form-check-inline col-pd-160 ml-1 px-1' },
	                _react2.default.createElement('input', { className: 'form-check-input', type: 'radio', ref: txtPorProduct, name: 'inlineRadioOptionst', onChange: onChange, id: 'inlineRadiot2', value: '2' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'inlineRadiot2', style: { fontSize: '0.8rem' } },
	                  'PRODUCTO POR CLIENTES'
	                )
	              )
	            ) : '',
	            valida2 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'col-pd-300 px-0 mb-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'CODIGO PRODUCTO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: props.ope === 0 ? true : false, name: 'notaentrega', onKeyUp: handleInputNumeroChange, onBlur: handleInputNumeroChange, ref: txtCodigo, className: 'form-control bg-transparent fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', onClick: function onClick() {
	                      return setMostrar2(true);
	                    }, disabled: props.ope === 0 ? true : false, className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ) : '',
	            valida2 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'col-12 px-0 mb-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'NOMBRE PRODUCTO:'
	                ),
	                _react2.default.createElement('textarea', { type: 'text', disabled: true, ref: txtNombreProducto, name: 'nombre', style: { height: idproduct !== '' ? '47px' : '30px' }, className: 'form-control fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ) : ''
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fw-bold', style: { fontSize: '0.8rem' } },
	              'ESTATUS:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-460 px-0 mb-2 row m-0 d-flex justify-content-around' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check form-check-inline col-pd-120 mx-2 px-1' },
	                _react2.default.createElement('input', { className: 'form-check-input', type: 'radio', name: 'inlineRadioOptionsd', defaultChecked: true, onChange: onChange, id: 'inlineRadiod1', value: '1' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'inlineRadiod1', style: { fontSize: '0.8rem' } },
	                  'TODOS'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check form-check-inline col-2 ml-2' },
	                _react2.default.createElement('input', { className: 'form-check-input', type: 'radio', name: 'inlineRadioOptionsd', onChange: onChange, id: 'inlineRadiod2', value: '2' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'inlineRadiod2', style: { fontSize: '0.8rem' } },
	                  'PAGADAS'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check form-check-inline col-2' },
	                _react2.default.createElement('input', { className: 'form-check-input', type: 'radio', name: 'inlineRadioOptionsd', onChange: onChange, id: 'inlineRadiod3', value: '3' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'inlineRadiod3', style: { fontSize: '0.8rem' } },
	                  'POR PAGAR'
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-11 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: vinpurt, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-primary mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-print' },
	              '  Imprimir'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoProductosExistencias2.default, {
	      show: mostrar2,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar2(false);
	      },
	      onHideAceptaCatalogo: handleAceptaProducto
	    })
	  );
	};

/***/ },
/* 7046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalOperacionesInventario = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoRecibosdePagos = __webpack_require__(656);
	
	var _catalogoRecibosdePagos2 = _interopRequireDefault(_catalogoRecibosdePagos);
	
	var _catalogoAlmacen = __webpack_require__(51);
	
	var _catalogoAlmacen2 = _interopRequireDefault(_catalogoAlmacen);
	
	var _catalogoProductosExistencias = __webpack_require__(91);
	
	var _catalogoProductosExistencias2 = _interopRequireDefault(_catalogoProductosExistencias);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ModalOperacionesInventario = exports.ModalOperacionesInventario = function ModalOperacionesInventario(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtCodigo = (0, _react.useRef)();
	  var txtDesde = (0, _react.useRef)();
	  var txtHasta = (0, _react.useRef)();
	  var txtNumAlmacen = (0, _react.useRef)();
	  var txtNombreAlmacen = (0, _react.useRef)();
	  var txtChkTodos = (0, _react.useRef)();
	  var txtNombre = (0, _react.useRef)();
	  var txtChekTodos = (0, _react.useRef)();
	  var txtChekIngreso = (0, _react.useRef)();
	  var txtChekSalida = (0, _react.useRef)();
	  var txtChekTraslado = (0, _react.useRef)();
	  var txtTipoproducto = (0, _react.useRef)();
	  var txtMarca = (0, _react.useRef)();
	  var txtCbmrif = (0, _react.useRef)();
	  var txtRifrespon = (0, _react.useRef)();
	  var txtNomrespon = (0, _react.useRef)();
	  var txtTodosCliente = (0, _react.useRef)();
	  var txtPorCliente = (0, _react.useRef)();
	  var txtChekPrestamo = (0, _react.useRef)();
	  var txtChekDonacion = (0, _react.useRef)();
	  var txtChekResguardo = (0, _react.useRef)();
	  var txtChekAjuste = (0, _react.useRef)();
	  var txtChekCompra = (0, _react.useRef)();
	  var txtChekVence = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      validatipo = _useState2[0],
	      setValidatipo = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      combocliente = _useState4[0],
	      setCombocliente = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(''),
	      _useState6 = _slicedToArray(_useState5, 2),
	      clientvende = _useState6[0],
	      setClientvende = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(''),
	      _useState8 = _slicedToArray(_useState7, 2),
	      idtproduct = _useState8[0],
	      setIdtproduct = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(''),
	      _useState10 = _slicedToArray(_useState9, 2),
	      idmarca = _useState10[0],
	      setIdmarca = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      tipoproducto = _useState12[0],
	      setTipoproducto = _useState12[1];
	
	  var _useState13 = (0, _react.useState)([]),
	      _useState14 = _slicedToArray(_useState13, 2),
	      marca = _useState14[0],
	      setMarca = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(null),
	      _useState16 = _slicedToArray(_useState15, 2),
	      tiporif = _useState16[0],
	      setTipofic = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(null),
	      _useState18 = _slicedToArray(_useState17, 2),
	      mostrar1 = _useState18[0],
	      setMostrar1 = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(null),
	      _useState20 = _slicedToArray(_useState19, 2),
	      mostrar2 = _useState20[0],
	      setMostrar2 = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(null),
	      _useState22 = _slicedToArray(_useState21, 2),
	      mostrar3 = _useState22[0],
	      setMostrar3 = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(true),
	      _useState24 = _slicedToArray(_useState23, 2),
	      habimarcatipopro = _useState24[0],
	      setHabimarcatipopro = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(''),
	      _useState26 = _slicedToArray(_useState25, 2),
	      parafecha = _useState26[0],
	      setParafecha = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(''),
	      _useState28 = _slicedToArray(_useState27, 2),
	      desde = _useState28[0],
	      setDesde = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(''),
	      _useState30 = _slicedToArray(_useState29, 2),
	      hasta = _useState30[0],
	      setHasta = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(''),
	      _useState32 = _slicedToArray(_useState31, 2),
	      disponiblec = _useState32[0],
	      setDisponiblec = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(''),
	      _useState34 = _slicedToArray(_useState33, 2),
	      numnota = _useState34[0],
	      setNumNota = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(''),
	      _useState36 = _slicedToArray(_useState35, 2),
	      idclient = _useState36[0],
	      setIdclient = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(true),
	      _useState38 = _slicedToArray(_useState37, 2),
	      vinput = _useState38[0],
	      setVinput = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(false),
	      _useState40 = _slicedToArray(_useState39, 2),
	      validainput = _useState40[0],
	      setValidainput = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(false),
	      _useState42 = _slicedToArray(_useState41, 2),
	      activate = _useState42[0],
	      setActivate = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(null),
	      _useState44 = _slicedToArray(_useState43, 2),
	      idproduct = _useState44[0],
	      setIdproduct = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(null),
	      _useState46 = _slicedToArray(_useState45, 2),
	      idalmacen = _useState46[0],
	      setIdalmacen = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(0),
	      _useState48 = _slicedToArray(_useState47, 2),
	      valida = _useState48[0],
	      setValida = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(0),
	      _useState50 = _slicedToArray(_useState49, 2),
	      filter = _useState50[0],
	      setFilter = _useState50[1];
	
	  var _useState51 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState52 = _slicedToArray(_useState51, 2),
	      mensaje = _useState52[0],
	      setMensaje = _useState52[1];
	
	  var _useState53 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState54 = _slicedToArray(_useState53, 2),
	      mensajesino = _useState54[0],
	      setMensajesino = _useState54[1];
	
	  var _useState55 = (0, _react.useState)(''),
	      _useState56 = _slicedToArray(_useState55, 2),
	      tipoope = _useState56[0],
	      setTipoope = _useState56[1];
	
	  var _useState57 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState58 = _slicedToArray(_useState57, 2),
	      botones = _useState58[0],
	      setBotones = _useState58[1];
	
	  var _useState59 = (0, _react.useState)({
	    ingreso: '',
	    salida: '',
	    traslado: '',
	    donacion: '',
	    prestamo: '',
	    ajuste: '',
	    resguardo: '',
	    compra: '',
	    vencimiento: ''
	  }),
	      _useState60 = _slicedToArray(_useState59, 2),
	      tip = _useState60[0],
	      setTip = _useState60[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setParafecha('');
	    setDisponiblec('');
	    setNumNota('');
	    setValidatipo(0);
	    setValida(0);
	    setIdclient('');
	    setIdproduct(null);
	    setVinput(true);
	    setMostrar1(false);
	    setMostrar2(false);
	    setIdalmacen("");
	    setDesde('');
	    setHasta('');
	    setFilter(0);
	    setValidainput(false);
	    setTipoope('');
	    setTip({
	      ingreso: '',
	      salida: '',
	      traslado: '',
	      donacion: '',
	      prestamo: '',
	      ajuste: '',
	      resguardo: '',
	      compra: '',
	      vencimiento: ''
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope === 1) {
	
	      if (validainput !== true) {
	        if (txtNombre.current.value === '' || txtCodigo.current.value === "" || valida === 1 && txtNumAlmacen.current.value === '') {
	          if (valida === 1) {
	            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Código del Almacen !', icono: 'informacion' });
	            txtNumAlmacen.current.focus();
	          } else {
	            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Código del Producto a Consultar !', icono: 'informacion' });
	            txtCodigo.current.focus();
	          }
	          sigue = false;
	        } else {
	
	          imprimirOperacionInventario();
	        }
	      } else {
	
	        if (valida === 1 && txtNumAlmacen.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Código del Almacen !', icono: 'informacion' });
	          txtNumAlmacen.current.focus();
	        } else {
	          imprimirOperacionInventario();
	        }
	      }
	    }
	  };
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'desde') {
	      if (e.target.value > (0, _moment2.default)(fechasistema).format('YYYY-MM-DD')) {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !', icono: 'informacion' });
	        txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        txtDesde.current.focus();
	      } else {
	        setDesde(e.target.value);
	      }
	    } else if (e.target.name === 'hasta') {
	      setHasta(e.target.value);
	    }
	
	    if (e.target.name === 'inlineRadioOptions') {
	
	      if (e.target.value === '1') {
	        setValida(0);
	        setIdalmacen('');
	      } else {
	        setValida(1);
	      }
	    }
	
	    if (e.target.name === 'chektodos') {
	      if (e.target.checked) {
	        setValidainput(true);
	        setVinput(false);
	        setValidatipo(0);
	        txtCodigo.current.value = "";
	        txtNombre.current.value = "";
	        setIdproduct(null);
	        setTipoope('');
	        setFilter(0);
	        setTip({
	          ingreso: '',
	          salida: '',
	          traslado: '',
	          donacion: '',
	          prestamo: '',
	          ajuste: '',
	          resguardo: '',
	          compra: '',
	          vencimiento: ''
	        });
	        txtChekTodos.current.checked = true;
	        txtChekIngreso.current.checked = false;
	        txtChekSalida.current.checked = false;
	        txtChekTraslado.current.checked = false;
	        txtChekAjuste.current.checked = false;
	        txtChekDonacion.current.checked = false;
	        txtChekPrestamo.current.checked = false;
	        txtChekResguardo.current.checked = false;
	        txtChekCompra.current.checked = false;
	        txtChekVence.current.checked = false;
	      } else {
	        setValidainput(false);
	        setVinput(true);
	        setTipoope('');
	        setFilter(1);
	        setValidatipo(0);
	        setTip({
	          ingreso: '',
	          salida: '',
	          traslado: '',
	          donacion: '',
	          prestamo: '',
	          ajuste: '',
	          resguardo: '',
	          compra: '',
	          vencimiento: ''
	        });
	        txtChekTodos.current.checked = true;
	        txtChekIngreso.current.checked = false;
	        txtChekSalida.current.checked = false;
	        txtChekTraslado.current.checked = false;
	        txtChekAjuste.current.checked = false;
	        txtChekDonacion.current.checked = false;
	        txtChekPrestamo.current.checked = false;
	        txtChekResguardo.current.checked = false;
	        txtChekCompra.current.checked = false;
	        txtChekVence.current.checked = false;
	      }
	    }
	
	    if (e.target.name === 'todos') {
	      if (e.target.checked) {
	        setValidatipo(0);
	        setTipoope('');
	        setFilter(1);
	        setTip({
	          ingreso: '',
	          salida: '',
	          traslado: '',
	          donacion: '',
	          prestamo: '',
	          ajuste: '',
	          resguardo: '',
	          compra: '',
	          vencimiento: ''
	        });
	        txtChekIngreso.current.checked = false;
	        txtChekSalida.current.checked = false;
	        txtChekTraslado.current.checked = false;
	        txtChekAjuste.current.checked = false;
	        txtChekDonacion.current.checked = false;
	        txtChekPrestamo.current.checked = false;
	        txtChekResguardo.current.checked = false;
	        txtChekCompra.current.checked = false;
	        txtChekVence.current.checked = false;
	      } else {
	        setValidatipo(1);
	        setTipoope('');
	        setFilter(0);
	        setTip({
	          ingreso: '',
	          salida: '',
	          traslado: '',
	          donacion: '',
	          prestamo: '',
	          ajuste: '',
	          resguardo: '',
	          compra: '',
	          vencimiento: ''
	        });
	        txtChekIngreso.current.checked = false;
	        txtChekSalida.current.checked = false;
	        txtChekTraslado.current.checked = false;
	        txtChekAjuste.current.checked = false;
	        txtChekDonacion.current.checked = false;
	        txtChekPrestamo.current.checked = false;
	        txtChekResguardo.current.checked = false;
	        txtChekCompra.current.checked = false;
	        txtChekVence.current.checked = false;
	      }
	    }
	
	    if (e.target.name === 'ingreso') {
	      setTipoope(' and opdeta.tipomovimiento in ');
	      setFilter(2);
	    } else if (e.target.name === 'salida') {
	      setTipoope(' and opdeta.tipomovimiento in ');
	      setFilter(3);
	    } else if (e.target.name === 'traslado') {
	      setTipoope(' and opdeta.tipomovimiento in ');
	      setFilter(4);
	    } else if (e.target.name === 'donacion') {
	      setTipoope(' and opdeta.tipomovimiento in ');
	      setFilter(5);
	    } else if (e.target.name === 'prestamo') {
	      setTipoope(' and opdeta.tipomovimiento in ');
	      setFilter(6);
	    } else if (e.target.name === 'ajuste') {
	      setTipoope(' and opdeta.tipomovimiento in ');
	      setFilter(7);
	    } else if (e.target.name === 'resguardo') {
	      setTipoope(' and opdeta.tipomovimiento in ');
	      setFilter(8);
	    } else if (e.target.name === 'compra') {
	      setTipoope(' and opdeta.tipomovimiento in ');
	      setFilter(9);
	    } else if (e.target.name === 'vencimiento') {
	      setTipoope(' and opdeta.tipomovimiento in ');
	      setFilter(10);
	    }
	
	    if (e.target.name !== 'todos' && e.target.name !== 'chektodos') {
	      setTip(Object.assign({}, tip, _defineProperty({}, e.target.name, e.target.checked ? e.target.value : '')));
	    }
	
	    if (e.target.name === 'tproducto') {
	      if (e.target.value === '0') {
	        setIdtproduct('');
	      } else {
	        var valor = ' and p.idtipoproducto = ' + e.target.value;
	        setIdtproduct(valor);
	      }
	    } else if (e.target.name === 'marca') {
	      if (e.target.value === '0') {
	        setIdmarca('');
	      } else {
	        var _valor = ' and p.idfabricante = ' + e.target.value;
	        setIdmarca(_valor);
	      }
	    }
	  };
	
	  var imprimirOperacionInventario = function imprimirOperacionInventario() {
	
	    var almacen = void 0;
	    var reporte = "";
	    var tipooperacion = '';
	
	    var tiparray = Object.entries(tip).map(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          key = _ref2[0],
	          value = _ref2[1];
	
	      return value;
	    });
	
	    if (tipoope !== '' && tiparray.length > 0) {
	      var tipos = [];
	      for (var i = 0; i < tiparray.length; i++) {
	        if (tiparray[i].length > 0) {
	          tipos.push("'" + tiparray[i] + "'");
	        }
	      }
	      tipooperacion = tipoope + '(' + tipos + ')';
	    }
	
	    if (valida === 1 && validainput === false) {
	      if (filter === 1) {
	        almacen = idclient + ' and OI.idalmacen = ' + idalmacen + idtproduct + idmarca;
	      } else {
	        var condiproducto = ' and p.codigo = ' + "'" + txtCodigo.current.value + "'";
	        almacen = idclient + condiproducto + ' and op.idalmacenorigen = ' + idalmacen + tipooperacion + idtproduct + idmarca;
	      }
	    } else if (valida === 1 && validainput === true) {
	      almacen = idclient + ' and op.idalmacenorigen = ' + idalmacen + tipooperacion + idtproduct + idmarca;
	    } else {
	      var _condiproducto = "";
	      if (filter !== 1 && validainput === false) {
	        _condiproducto = ' and p.codigo = ' + "'" + txtCodigo.current.value + "'";
	      } else {
	        _condiproducto = '';
	      }
	      almacen = idclient + _condiproducto + tipooperacion + idtproduct + idmarca;
	    }
	
	    var reporte = "ReporteOperacionesInventario";
	    var desdec = "'" + (0, _moment2.default)(desde).format('DD-MM-YYYY') + "'";
	    var hastac = "'" + (0, _moment2.default)(hasta).format('DD-MM-YYYY') + "'";
	    var id = idproduct;
	
	    if (validainput === true) {
	      window.open(op.reportes + '/almacen?afiliado=' + afiliado + '&reporte=ReporteDetaOpeInventarioTodos&condi=' + almacen + '&desde=' + desdec + '&hasta=' + hastac + '&valida=' + valida, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	    } else {
	      if (filter !== 1) {
	        window.open(op.reportes + '/almacen?afiliado=' + afiliado + '&reporte=ReporteDetaOpeInventarioPorProductos&condi=' + almacen + '&desde=' + desdec + '&hasta=' + hastac + '&valida=' + valida, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      } else {
	        window.open(op.reportes + "/almacen?afiliado=" + afiliado + "&reporte=" + reporte + "&codigo=" + id + "&desde=" + desdec + "&hasta=" + hastac + "&almacen=" + almacen + "&valida=" + valida, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      }
	    }
	  };
	
	  var handleAceptaProducto = function handleAceptaProducto(values) {
	    setMostrar1(false);
	    setVinput(false);
	    txtNombre.current.value = values.nombrecorto;
	    txtCodigo.current.value = values.codigo;
	    setIdproduct(values.idproducto);
	    setHabimarcatipopro(false);
	  };
	
	  var handleAceptaAlmacen = function handleAceptaAlmacen(values) {
	    setMostrar2(false);
	
	    txtNombreAlmacen.current.value = values.descripcion;
	    txtNumAlmacen.current.value = values.idalmacen;
	    setIdalmacen(values.idalmacen);
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var seleccionarProducto = function seleccionarProducto(id) {
	    var campos = "idproducto, nombre";
	    var nomtab = "producto";
	    var nomid = "codigo";
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idproducto > 0) {
	          setIdproduct(response.data.idproducto);
	          txtNombre.current.value = response.data.nombre;
	          setVinput(false);
	          setHabimarcatipopro(false);
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Código y/o Producto no Existe !', icono: 'informacion' });
	          setVinput(true);
	          setHabimarcatipopro(true);
	          txtCodigo.current.value = "";
	          setIdproduct(null);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var handleInputNumeroChange = function handleInputNumeroChange(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "codigo") {
	          seleccionarProducto(event.target.value.toUpperCase());
	        } else if (event.target.name === "nalmacen") {
	          seleccionarAlmacen(event.target.value);
	        }
	      }
	    }
	  };
	
	  var seleccionarAlmacen = function seleccionarAlmacen(id) {
	    var campos = "idalmacen, descripcion";
	    var nomtab = "almacen";
	    var nomid = "idalmacen";
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idalmacen > 0) {
	          setIdalmacen(response.data.idalmacen);
	          txtNombreAlmacen.current.value = response.data.descripcion;
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Código y/o Almacen no Existe !', icono: 'informacion' });
	          txtNumAlmacen.current.value = "";
	          setIdalmacen('');
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarTipoProductos = function seleccionarTipoProductos() {
	
	    var campos = 'idtipoproducto, trim(descripcion) as descripcion';
	    var nomtab = 'tipoproducto';
	    var orden = 'idtipoproducto';
	
	    var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	
	          var datos = [];
	
	          for (var i = 0; i < response.data.length; i++) {
	
	            if (response.data[i].idtipoproducto !== '0') {
	              datos.push({
	                idtipoproducto: response.data[i].idtipoproducto,
	                descripcion: response.data[i].descripcion
	              });
	            }
	          }
	          setTipoproducto(datos);
	        }
	      }
	    }).catch(function (error) {
	
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarFabricante = function seleccionarFabricante() {
	
	    var campos = 'idfabricante, trim(descripcion) as descripcion';
	    var nomtab = 'fabricante';
	    var orden = 'idfabricante';
	
	    var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	
	          var datos = [];
	
	          for (var i = 0; i < response.data.length; i++) {
	
	            if (response.data[i].idfabricante !== '0') {
	              datos.push({
	                idfabricante: response.data[i].idfabricante,
	                descripcion: response.data[i].descripcion
	              });
	            }
	          }
	          setMarca(datos);
	        }
	      }
	    }).catch(function (error) {
	
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChekval = function onChekval(e) {
	
	    if (e.target.id === 'cliente') {
	      if (txtTodosCliente.current.checked === true) {
	        setCombocliente(0);
	        setIdclient('');
	        txtNomrespon.current.value = '';
	        txtRifrespon.current.value = '';
	        txtCbmrif.current.value = '';
	      } else {
	        setCombocliente(1);
	        setClientvende('cliente');
	      }
	    }
	  };
	
	  var handleCliente = function handleCliente(e) {
	    e.preventDefault();
	    if (e.which === 13 || typeof e.which === 'undefined') {
	      if (e.target.value !== '') {
	        setClientvende('cliente');
	        if (clientvende === 'cliente') {
	          selectResponsable(tiporif + e.target.value);
	        }
	      }
	    }
	  };
	
	  var selectResponsable = function selectResponsable(id) {
	
	    var campos = '*';
	    var nomtab = 'agente';
	    var nomid = 'rif';
	    var nomid2 = clientvende;
	    var endpoint = op.conexion + '/api/consulta/modeli2?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id + '&nomid2=' + nomid2 + '&id2=true';
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idagente > 0) {
	          if (clientvende === 'cliente') {
	            txtNomrespon.current.value = response.data.nombre;
	            setIdclient(' and ag.idagente = ' + response.data.idagente);
	            btnAcepta.current.focus();
	          } else {}
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ RIF y/o Cliente no Registrado !', icono: 'informacion' });
	          txtRifrespon.current.value = '';
	          txtNomrespon.current.value = '';
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var catalogoClienteVendedor = function catalogoClienteVendedor(ope) {
	    return function (e) {
	      e.preventDefault();
	      if (ope === 1) {
	        setClientvende('cliente');
	        setMostrar3(true);
	      } else {
	        setClientvende('vendedor');
	        setMostrar3(true);
	      }
	    };
	  };
	
	  var handleAceptaCliente = function handleAceptaCliente(values) {
	    setMostrar3(false);
	    if (clientvende === 'cliente') {
	      txtCbmrif.current.value = values.rif.substring(0, 1);
	      txtRifrespon.current.value = values.rif.substring(1, 11);
	      txtNomrespon.current.value = values.nombre;
	      selectResponsable(values.rif);
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.ope === 1) {
	          seleccionarTipoProductos();
	          seleccionarFabricante();
	          txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	          txtHasta.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	          setDesde((0, _moment2.default)(fechasistema).format('YYYY-MM-DD'));
	          setHasta((0, _moment2.default)(fechasistema).format('YYYY-MM-DD'));
	          setFilter(1);
	          txtChekTodos.current.checked = true;
	          txtCodigo.current.focus();
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Imprimir Operaciones de Inventario'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto m-0 border-azul px-1' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 row m-0 px-0 py-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 m-0 px-0 row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-pd-310 px-1 mb-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm mb-2' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'TIPO PRODUCTO:'
	                  ),
	                  _react2.default.createElement(
	                    'select',
	                    { ref: txtTipoproducto, name: 'tproducto', onChange: onChange, className: 'form-select form-select-sm text-center', 'aria-label': '.form-select-sm example' },
	                    _react2.default.createElement(
	                      'option',
	                      { value: '0' },
	                      'TODOS'
	                    ),
	                    tipoproducto && tipoproducto.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'option',
	                        { key: index, value: item.idtipoproducto },
	                        ' ',
	                        item.descripcion,
	                        ' '
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-pd-280 mb-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm mb-2' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'FABRICANTE:'
	                  ),
	                  _react2.default.createElement(
	                    'select',
	                    { ref: txtMarca, name: 'marca', onChange: onChange, className: 'form-select form-select-sm text-center', 'aria-label': '.form-select-sm example' },
	                    _react2.default.createElement(
	                      'option',
	                      { value: '0' },
	                      'TODOS'
	                    ),
	                    marca && marca.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'option',
	                        { key: index, value: item.idfabricante },
	                        ' ',
	                        item.descripcion,
	                        ' '
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-pd-100 mb-3 ml-auto' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-check' },
	                  _react2.default.createElement('input', { className: 'form-check-input', ref: txtChkTodos, onChange: onChange, name: 'chektodos', type: 'checkbox', id: 'flexCheckDefault' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-check-label fw-bold text-black', 'for': 'flexCheckDefault', style: { fontSize: '0.9rem' } },
	                    'TODOS'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-1 mb-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text fw-bold text-black', id: 'inputGroup-sizing-sm' },
	                  'CODIGO PRODUCTO:'
	                ),
	                _react2.default.createElement('input', { type: 'text', disabled: validainput, onKeyUp: handleInputNumeroChange, onBlur: handleInputNumeroChange, ref: txtCodigo, name: 'codigo', className: 'form-control fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', onClick: function onClick() {
	                      return setMostrar1(true);
	                    }, disabled: validainput, className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-220 px-1 mb-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text fw-bold text-black', id: 'inputGroup-sizing-sm' },
	                  'DESDE:'
	                ),
	                _react2.default.createElement('input', { type: 'date', disabled: props.ope === 0 ? true : false, onChange: onChange, ref: txtDesde, name: 'desde', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-220 px-1 mb-3 ml-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text fw-bold text-black', id: 'inputGroup-sizing-sm' },
	                  'HASTA:'
	                ),
	                _react2.default.createElement('input', { type: 'date', disabled: props.ope === 0 ? true : false, onChange: onChange, ref: txtHasta, name: 'hasta', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 px-1 mb-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text fw-bold text-black', id: 'inputGroup-sizing-sm' },
	                  'NOMBRE PRODUCTO:'
	                ),
	                _react2.default.createElement('textarea', { type: 'text', disabled: true, ref: txtNombre, name: 'nombre' /* style={{ height: idproduct !== null ? '47px' : '30px' }} */, className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'fieldset',
	              { className: 'row col-sm-12 mx-auto border-azul rounded mb-3' },
	              _react2.default.createElement(
	                'legend',
	                { className: 'float-none m-0 w-auto fw-bold text-black', style: { fontSize: '0.8rem' } },
	                'TIPO DE OPERACION:'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 px-0 mb-2 row m-0 d-flex justify-content-around' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-check form-check-inline col-pd-100' },
	                  _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtChekTodos, name: 'todos', onChange: onChange, id: 'flexCheckDefault77' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-check-label', 'for': 'flexCheckDefault77', style: { fontSize: '0.8rem' } },
	                    'TODOS'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-check form-check-inline col-pd-100' },
	                  _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', value: 'INVENTARIO INICIAL', disabled: validatipo === 1 ? false : true, ref: txtChekIngreso, name: 'ingreso', onChange: onChange, id: 'flexCheckDefault1' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-check-label', 'for': 'flexCheckDefault1', style: { fontSize: '0.8rem' } },
	                    'INGRESO'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-check form-check-inline col-pd-100' },
	                  _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', value: 'COMPRA', disabled: validatipo === 1 ? false : true, ref: txtChekCompra, name: 'compra', onChange: onChange, id: 'flexCheckDefault7' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-check-label', 'for': 'flexCheckDefault7', style: { fontSize: '0.8rem' } },
	                    'COMPRA'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-check form-check-inline col-pd-110' },
	                  _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', value: 'VENTA', disabled: validatipo === 1 ? false : true, ref: txtChekSalida, name: 'salida', onChange: onChange, id: 'flexCheckDefault2' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-check-label', 'for': 'flexCheckDefault2', style: { fontSize: '0.8rem' } },
	                    'SALIDA'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-check form-check-inline col-pd-110 px-1' },
	                  _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', value: 'TRASLADO', disabled: validatipo === 1 ? false : true, ref: txtChekTraslado, name: 'traslado', onChange: onChange, id: 'flexCheckDefault3' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-check-label', 'for': 'flexCheckDefault3', style: { fontSize: '0.8rem' } },
	                    'TRASLADO'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 px-0 mb-2 row m-0 d-flex justify-content-around' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-check form-check-inline col-pd-100' },
	                  _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', value: 'OBSEQUIO/DONACI\xD3N\',\'DONACI\xD3N', disabled: validatipo === 1 ? false : true, ref: txtChekDonacion, name: 'donacion', onChange: onChange, id: 'flexCheckDefault4' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-check-label', 'for': 'flexCheckDefault4', style: { fontSize: '0.8rem' } },
	                    'OBSEQUIO'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-check form-check-inline col-pd-100' },
	                  _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', value: 'PRESTAMO', disabled: validatipo === 1 ? false : true, ref: txtChekPrestamo, name: 'prestamo', onChange: onChange, id: 'flexCheckDefault5' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-check-label', 'for': 'flexCheckDefault5', style: { fontSize: '0.8rem' } },
	                    'PRESTAMO'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-check form-check-inline col-pd-100' },
	                  _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', value: 'AJUSTE', disabled: validatipo === 1 ? false : true, ref: txtChekAjuste, name: 'ajuste', onChange: onChange, id: 'flexCheckDefault6' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-check-label', 'for': 'flexCheckDefault6', style: { fontSize: '0.8rem' } },
	                    'AJUSTE'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-check form-check-inline col-pd-110' },
	                  _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', value: 'RESGUARDO', disabled: validatipo === 1 ? false : true, ref: txtChekResguardo, name: 'resguardo', onChange: onChange, id: 'flexCheckDefault6' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-check-label', 'for': 'flexCheckDefault6', style: { fontSize: '0.8rem' } },
	                    'RESGUARDO'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-check form-check-inline col-pd-110 px-1' },
	                  _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', value: 'VENCIMIENTO', disabled: validatipo === 1 ? false : true, ref: txtChekVence, name: 'vencimiento', onChange: onChange, id: 'flexCheckDefault8' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-check-label', 'for': 'flexCheckDefault8', style: { fontSize: '0.8rem' } },
	                    'VENCIMIENTO'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 row m-0 border-azul rounded py-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-pd-400 px-0 mb-3 row m-0' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label col-pd-104 text-left px-1 d-flex align-items-center fw-bold text-black', 'for': 'flexSwitchCheckDefault', style: { fontSize: '0.8rem' } },
	                  'ALMACEN:'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-check form-check-inline col-pd-145' },
	                  _react2.default.createElement('input', { className: 'form-check-input', type: 'radio', name: 'inlineRadioOptions', defaultChecked: true, onChange: onChange, id: 'inlineRadio1', value: '1' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-check-label', 'for': 'inlineRadio1', style: { fontSize: '0.8rem' } },
	                    'TODOS'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-check form-check-inline col-pd-130' },
	                  _react2.default.createElement('input', { className: 'form-check-input', type: 'radio', name: 'inlineRadioOptions', onChange: onChange, id: 'inlineRadio2', value: '2' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-check-label', 'for': 'inlineRadio2', style: { fontSize: '0.8rem' } },
	                    'POR ALMACEN'
	                  )
	                )
	              ),
	              valida === 1 ? _react2.default.createElement(
	                'div',
	                { className: 'col-pd-220 px-0 mb-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'CODIGO ALMACEN: '
	                  ),
	                  _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: props.ope === 0 ? true : false, name: 'nalmacen', onKeyUp: handleInputNumeroChange, onBlur: handleInputNumeroChange, ref: txtNumAlmacen, className: 'form-control bg-transparent fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                  _react2.default.createElement(
	                    'button',
	                    { type: 'button', onClick: function onClick() {
	                        return setMostrar2(true);
	                      }, disabled: props.ope === 0 ? true : false, className: 'btn btn-success' },
	                    _react2.default.createElement('i', { className: 'fas fa-search' })
	                  )
	                )
	              ) : '',
	              valida === 1 ? _react2.default.createElement(
	                'div',
	                { className: 'col-12 px-0 mb-3' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'NOMBRE ALMACEN:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', disabled: true, ref: txtNombreAlmacen, name: 'nombre', className: 'form-control fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              ) : ''
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-11 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: vinput, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-primary mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-print' },
	              '  Imprimir'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoAlmacen2.default, {
	      show: mostrar2,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar2(false);
	      },
	      onHideAceptaCatalogo: handleAceptaAlmacen
	    }),
	    _react2.default.createElement(_catalogoProductosExistencias2.default, {
	      show: mostrar1,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar1(false);
	      },
	      onHideAceptaCatalogo: handleAceptaProducto
	    }),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: mostrar3,
	      nomid: clientvende,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar3(false);
	      },
	      onHideAceptaCatalogo: handleAceptaCliente
	    })
	  );
	};

/***/ },
/* 7047 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _varios = __webpack_require__(14);
	
	var _core = __webpack_require__(19);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _xlsx = __webpack_require__(160);
	
	var XLSX = _interopRequireWildcard(_xlsx);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActualizarPreciosExcel = function ActualizarPreciosExcel() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var organizacion = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var txtFile = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      updateProduct = _useState2[0],
	      setUpdateProduct = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      mensaje = _useState4[0],
	      setMensaje = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mensajesino = _useState6[0],
	      setMensajesino = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      activate = _useState8[0],
	      setActivate = _useState8[1];
	
	  var headCells = [{ label: "CODIGO PRODUCTO", textAlign: "center" }, { label: "DESCRIPCIÓN", textAlign: "center" }, { label: "UNIDAD", textAlign: "center" }, { label: "COSTO", textAlign: "center" }, { label: "PRECIO", textAlign: "center" }];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setUpdateProduct([]);
	    txtFile.current.value = "";
	  };
	
	  var procesarRegistro = function procesarRegistro(body) {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/cerveceria/actualizar/2";
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setUpdateProduct([]);
	        setMensaje({
	          mostrar: true,
	          titulo: "Exito.",
	          texto: response.data.contar + " registro modificado correctamente",
	          icono: "exito"
	        });
	
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros(productFile) {
	    var campos = "codigo";
	    var nomtab = "producto";
	    var orden = "idproducto";
	    var datos = [];
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          for (var index = 0; index < response.data.length; index++) {
	            datos.push(response.data[index].codigo);
	          }
	          procesarPrecioProd(datos, productFile);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var calcularUtilidadxValor = function calcularUtilidadxValor(producto) {
	    var iva = producto[5];
	    var costo = producto[6];
	    var venta = producto[8];
	
	    var mon = costo * iva / 100;
	    mon = mon + costo;
	    var mon3 = 0.0;
	
	    mon3 = (venta - mon) / mon;
	    mon3 = mon3 * 100;
	    return mon3;
	  };
	
	  var calcularUtilidadxValorAlter = function calcularUtilidadxValorAlter(producto) {
	    var iva = producto[5];
	    var costo = producto[4];
	    var venta = producto[7];
	
	    var mon = costo * iva / 100;
	    mon = mon + costo;
	    var mon3 = 0.0;
	
	    mon3 = (venta - mon) / mon;
	    mon3 = mon3 * 100;
	    return mon3;
	  };
	
	  var updateProcess = function updateProcess() {
	    var productos = [];
	    for (var i = 0; i < updateProduct.length; i++) {
	      productos.push({
	        codigo: updateProduct[i][1],
	        nombre: updateProduct[i][2],
	        nombrecorto: updateProduct[i][2],
	        ivacompra: updateProduct[i][5],
	        ivaventa: updateProduct[i][9],
	        exento: parseFloat(updateProduct[i][9]) > 0.0 ? false : true,
	        valorfactor: updateProduct[i][3],
	        tipofactor: parseInt(updateProduct[i][3]) > 1 ? 1 : 0,
	        costoproveedor: updateProduct[i][6],
	        costocalculado: updateProduct[i][6],
	        ultimocosto: updateProduct[i][6],
	        costopromedio: updateProduct[i][6],
	        costoproveedoralter: updateProduct[i][4],
	        costocalculadoalter: updateProduct[i][4],
	        ultimocostoalter: updateProduct[i][4],
	        costopromedioalter: updateProduct[i][4],
	        utipreciomaxi: calcularUtilidadxValor(updateProduct[i]),
	        utiprecioofe: calcularUtilidadxValor(updateProduct[i]),
	        utipreciomayor: calcularUtilidadxValor(updateProduct[i]),
	        utipreciomini: calcularUtilidadxValor(updateProduct[i]),
	        utipreciomaxialter: calcularUtilidadxValorAlter(updateProduct[i]),
	        utiprecioofealter: calcularUtilidadxValorAlter(updateProduct[i]),
	        utipreciomayoralter: calcularUtilidadxValorAlter(updateProduct[i]),
	        utipreciominialter: calcularUtilidadxValorAlter(updateProduct[i])
	      });
	    }
	    procesarRegistro(2, { productos: JSON.stringify(productos) });
	  };
	
	  var handleInputChange = function handleInputChange(e) {
	    if (e.target.name === "file" && e.target.files.length > 0) {
	      setActivate(true);
	      setUpdateProduct([]);
	      var hojas = [];
	      var reader = new FileReader();
	      reader.readAsArrayBuffer(e.target.files[0]);
	      reader.onload = function (e) {
	        var data = new Uint8Array(e.target.result);
	        var workbook = XLSX.read(data, { type: "array" });
	
	        workbook.SheetNames.forEach(function (SheetName) {
	          var objData = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[SheetName]);
	          hojas.push({
	            data: objData,
	            SheetName: SheetName
	          });
	        });
	
	        var titulos = [];
	        var produc = [];
	        var titulo_sigue = false;
	        var produc_sigue = false;
	        var rueda = Object.keys(hojas[0].data[0]);
	        try {
	          for (var i = 0; i < rueda.length; i++) {
	            titulos.push({
	              label: rueda[i].toUpperCase(),
	              textAlign: "center"
	            });
	          }
	          titulo_sigue = true;
	        } catch (error) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Error",
	            texto: "el archivo xlsx esta mal formado",
	            icono: "error"
	          });
	          setActivate(false);
	        }
	
	        try {
	          for (var l = 1; l < hojas[0].data.length - 1; l++) {
	            var obj = {};
	            var array = Object.values(hojas[0].data[l]);
	            for (var k = 0; k < array.length; k++) {
	              obj[k] = array[k];
	            }
	            produc.push(obj);
	          }
	          produc_sigue = true;
	        } catch (error) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Error",
	            texto: "el archivo xlsx esta mal formado",
	            icono: "error"
	          });
	          setActivate(false);
	        }
	
	        if (titulo_sigue === true && produc_sigue === true) {
	          seleccionarRegistros(produc);
	        } else {
	          setUpdateProduct([]);
	        }
	      };
	    }
	  };
	
	  var procesarPrecioProd = function procesarPrecioProd(cursorProduct, fileProduct) {
	    var element = fileProduct;
	    var element0 = [];
	    var viejos = [];
	
	    for (var i = 0; i < fileProduct.length; i++) {
	      for (var x = 0; x < cursorProduct.length; x++) {
	        if (cursorProduct[x].toString().trim().toUpperCase() === fileProduct[i][0].toString().trim().toUpperCase()) {
	          viejos.push(fileProduct[i][0]);
	          element0.push(fileProduct[i]);
	        }
	      }
	    }
	
	    var _loop = function _loop(_i) {
	      for (var _x = 0; _x < viejos.length; _x++) {
	        if (viejos[_x].toString().trim().toUpperCase() === element[_i][0].toString().trim().toUpperCase()) {
	          element = element.filter(function (value) {
	            return value[0].toString().trim().toUpperCase() !== element[_i][0].toString().trim().toUpperCase();
	          });
	        }
	      }
	    };
	
	    for (var _i = 0; _i < element.length; _i++) {
	      _loop(_i);
	    }
	
	    setUpdateProduct(element0);
	    setActivate(false);
	  };
	
	  var descargarxlsx = function descargarxlsx() {
	    setActivate(true);
	    var endpoint = op.reportes + "/productos?afiliado=" + organizacion + "&reporte=ReporteProductosExcel";
	    _axios2.default.get(endpoint, {
	      responseType: "arraybuffer",
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      var url = window.URL.createObjectURL(new Blob([response.data]));
	      var link = document.createElement("a");
	      link.href = url;
	      link.setAttribute("download", "LISTA PRECIOS PRODUCTOS.xlsx");
	      document.body.appendChild(link);
	      link.click();
	      document.body.removeChild(link);
	    }).catch(function (error) {
	      console.error(error);
	    }).finally(function () {
	      return setActivate(false);
	    });
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12 py-3 mx-auto card shadow " },
	          _react2.default.createElement(
	            _semanticUiReact.Dimmer,
	            { active: activate, inverted: true },
	            _react2.default.createElement(
	              _semanticUiReact.Loader,
	              { inverted: true },
	              "cargando..."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row col-md-12 mx-auto " },
	            _react2.default.createElement(
	              "h1",
	              null,
	              "ACTUALIZAR PRECIOS"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group input-group-sm mb-2 col-md-12 justify-content-between" },
	              _react2.default.createElement("input", {
	                required: true,
	                type: "file",
	                name: "file",
	                id: "file",
	                ref: txtFile,
	                className: "form-control col-md-3",
	                onChange: handleInputChange,
	                placeholder: "Ingrese Archivo Excel."
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 mx-auto mb-3" },
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 350,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden" },
	                  updateProduct.length > 0 && updateProduct.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      {
	                        key: index,
	                        style: {
	                          padding: "0",
	                          backgroundColor: "transparent"
	                        }
	                      },
	                      Object.values(item) && Object.values(item).map(function (item2, x) {
	                        return _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            key: x,
	                            className: "align-baseline p-0",
	                            style: {
	                              textAlign: "center",
	                              border: "solid 1px #000000"
	                            }
	                          },
	                          item2
	                        );
	                      })
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row col-md-12 mt-3" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    onClick: descargarxlsx,
	                    className: "btn btn-sm btn-success rounded-pill col-md-2 mb-3"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-file-excel" },
	                    " Descargar"
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    disabled: updateProduct.length === 0,
	                    className: "btn btn-warning btn-sm rounded-pill col-md-2 mb-3",
	                    onClick: updateProcess
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-edit" },
	                    " Actualizar"
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-danger btn-sm rounded-pill col-md-2 mb-3",
	                    onClick: blanquear
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-times" },
	                    " Cancelar"
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = ActualizarPreciosExcel;

/***/ },
/* 7048 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actualizarPreciosExcel = __webpack_require__(7047);
	
	var _actualizarPreciosExcel2 = _interopRequireDefault(_actualizarPreciosExcel);
	
	var _incluirProductosExcel = __webpack_require__(7054);
	
	var _incluirProductosExcel2 = _interopRequireDefault(_incluirProductosExcel);
	
	var _archivosExcelCliente = __webpack_require__(659);
	
	var _archivosExcelCliente2 = _interopRequireDefault(_archivosExcelCliente);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fileExcel = function fileExcel() {
	  var _useState = (0, _react.useState)(1),
	      _useState2 = _slicedToArray(_useState, 2),
	      pantalla = _useState2[0],
	      setPantalla = _useState2[1];
	
	  var cambiarpantalla = function cambiarpantalla(p) {
	    setPantalla(p);
	  };
	
	  var PANTALLAS = {
	    1: _react2.default.createElement(_actualizarPreciosExcel2.default, null),
	    2: _react2.default.createElement(_incluirProductosExcel2.default, null),
	    3: _react2.default.createElement(_archivosExcelCliente2.default, null)
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 ", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-11 mx-auto py-2 card shadow" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row border-azul mx-auto rounded py-1" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-2 azulGradiant shadow text-light justify-content-between" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-4" },
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  "Actualizaci\xF3n por Archivo XLSX"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 d-flex justify-content-end" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "/inicio", className: "text-light " },
	                  _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "fw-bold" },
	                    "Salir"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6 row mt-3 d-flex  justify-content-between" },
	              _react2.default.createElement(
	                "button",
	                {
	                  onClick: function onClick() {
	                    return cambiarpantalla(1);
	                  },
	                  className: "btn btn-sm btn-info col"
	                },
	                _react2.default.createElement(
	                  "i",
	                  { className: "fas fa-check-circle" },
	                  " Actualizar Precios"
	                )
	              ),
	              _react2.default.createElement(
	                "button",
	                {
	                  onClick: function onClick() {
	                    return cambiarpantalla(2);
	                  },
	                  className: "btn btn-sm btn-primary col"
	                },
	                _react2.default.createElement(
	                  "i",
	                  { className: "fas fa-check-circle" },
	                  " Incluir Productos"
	                )
	              ),
	              _react2.default.createElement(
	                "button",
	                {
	                  onClick: function onClick() {
	                    return cambiarpantalla(3);
	                  },
	                  className: "btn btn-sm btn-secondary col"
	                },
	                _react2.default.createElement(
	                  "i",
	                  { className: "fas fa-check-circle" },
	                  " Incluir Clientes"
	                )
	              )
	            ),
	            PANTALLAS[pantalla]
	          )
	        )
	      )
	    )
	  );
	};
	exports.default = fileExcel;

/***/ },
/* 7049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GestionarTipoVacio = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoDepartamento = __webpack_require__(650);
	
	var _catalogoDepartamento2 = _interopRequireDefault(_catalogoDepartamento);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GestionarTipoVacio = exports.GestionarTipoVacio = function GestionarTipoVacio(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var accbtntvacios = JSON.parse(sessionStorage.getItem('accbtntvaciosc'));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtIdDepartamento = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)('Gestion de Vacios.'),
	      _useState2 = _slicedToArray(_useState, 2),
	      tituloHeader = _useState2[0],
	      setTituloHeader = _useState2[1];
	
	  var _useState3 = (0, _react.useState)('visible'),
	      _useState4 = _slicedToArray(_useState3, 2),
	      visibleBtn = _useState4[0],
	      setVisibleBtn = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      body = _useState6[0],
	      setBody = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      activate = _useState8[0],
	      setActivate = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(true),
	      _useState10 = _slicedToArray(_useState9, 2),
	      habilitado = _useState10[0],
	      setHabilitado = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mensaje = _useState12[0],
	      setMensaje = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensajesino = _useState14[0],
	      setMensajesino = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      catalogoDepartamento = _useState16[0],
	      setCatalogoDepartamento = _useState16[1];
	
	  var _useState17 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState18 = _slicedToArray(_useState17, 2),
	      botones = _useState18[0],
	      setBotones = _useState18[1];
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'descripcion') {
	      e.target.value = e.target.value.toUpperCase();
	    } else {
	      e.target.value = e.target.value;
	    }
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = 'iddepartamento, trim(descripcion) as descripcion';
	    var nomtab = 'departamento';
	    var nomid = 'iddepartamento';
	    var id = txtIdDepartamento.current.value;
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        txtDescripcion.current.value = '';
	
	        if (response.data !== '') {
	
	          txtDescripcion.current.value = response.data.descripcion.trim();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe un departamento con este codigo', icono: 'informacion' });
	          txtDescripcion.current.value = '';
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var validarDepartamento = function validarDepartamento(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value !== '') {
	
	        seleccionarRegistro();
	      }
	    }
	  };
	
	  var onCatalogoDepartamento = function onCatalogoDepartamento(values) {
	    setCatalogoDepartamento(false);
	    txtIdDepartamento.current.value = values.iddepartamento;
	    txtDescripcion.current.value = values.descripcion;
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	
	    var sigue = true;
	    if (!botones.incluir || !botones.modificar) {
	
	      if (txtDescripcion.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar una descripción', icono: 'informacion' });
	        txtDescripcion.current.focus();
	        sigue = false;
	      }
	    }
	
	    if (sigue) {
	
	      var departamento = [];
	      departamento.push({
	        iddepartamento: txtIdDepartamento.current.value === '' ? 0 : txtIdDepartamento.current.value,
	        descripcion: txtDescripcion.current.value.trim()
	      });
	
	      setBody({
	        departamento: departamento
	      });
	
	      var msg = '';
	      if (!botones.incluir) {
	        msg = 'Esta Seguro de Registrar estos Datos.';
	      } else if (!botones.modificar) {
	        msg = 'Esta Seguro de Modificar estos Datos.';
	      } else if (!botones.eliminar) {
	        msg = 'Esta Seguro de Eliminar estos Datos.';
	      }
	
	      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + '/api/departamento/actualizar/' + ope;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (ope === 1) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
	        } else if (ope === 2) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
	        } else if (ope === 3) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = '';
	      if (error.response === undefined) {
	        mensaje = 'Error de Conexion';
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
	          mensaje = 'Ya existe un Registro con este rif';
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setTituloHeader('Gestionar de Tipos Vacios.');
	    setActivate(false);
	    setBody(null);
	    setHabilitado(true);
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      salir: false
	    });
	    txtIdDepartamento.current.setAttribute("disabled", true);
	    txtIdDepartamento.current.value = '';
	    txtDescripcion.current.value = '';
	    setVisibleBtn('visible');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var handleInputMontoChange = function handleInputMontoChange(event) {
	    (0, _varios.validaMonto)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
	        event.target.value = '0,00';
	      }
	      event.target.value = (0, _varios.formatoMonto)(event.target.value);
	      var char1 = event.target.value.substring(0, 1);
	      var char2 = event.target.value.substring(1, 2);
	      if (char1 === '0' && char2 !== ',') {
	        event.target.value = event.target.value.substring(1, event.target.value.legth);
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    procesarRegistro();
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	
	      e.preventDefault();
	
	      if (op === 1) {
	
	        if (accbtntvacios && accbtntvacios.toString().substring(0, 1) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Incluir Tipo Vacio.');
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	          txtIdDepartamento.current.setAttribute("disabled", true);
	          setTimeout(function () {
	            return txtDescripcion.current.focus();
	          }, 200);
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 2) {
	
	        if (accbtntvacios && accbtntvacios.toString().substring(1, 2) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Editar Tipo Vacio.');
	          txtIdDepartamento.current.removeAttribute("disabled");
	          setHabilitado(false);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdDepartamento.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 3) {
	
	        if (accbtntvacios && accbtntvacios.toString().substring(3, 4) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Eliminar Tipo Vacio.');
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdDepartamento.current.removeAttribute("disabled");
	          txtIdDepartamento.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 4) {
	
	        if (accbtntvacios && accbtntvacios.toString().substring(2, 3) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Consultar Tipo Vacio.');
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdDepartamento.current.removeAttribute("disabled");
	          txtIdDepartamento.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 5) {
	        /*     onChangeValidar(); */
	      } else if (op === 6) {
	        blanquear();
	      } else if (op === 7) {
	        setVisibleBtn('visible');
	        cancelar();
	      }
	    };
	  };
	
	  var cerrarModal = function cerrarModal() {
	    props.onHideRenderizar();
	    props.onHideCancela();
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var imprimirDepartamentos = function imprimirDepartamentos() {
	
	    window.open(op.reportes + "reporte=listDepartamento", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {}
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        _Modal2.default.Title,
	        { style: { color: "#fff" } },
	        tituloHeader,
	        ' '
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: onBotones(7), className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 mx-auto px-0' },
	          _react2.default.createElement(
	            'div',
	            { className: 'mb-3 col-pd-140 ml-auto' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'FECHA: ',
	              _react2.default.createElement(
	                'span',
	                { className: 'fw-bold fs-6' },
	                (0, _moment2.default)(fechasistema).format('DD-MM-YYYY'),
	                ' '
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'border-azul col-md-12 py-3 rounded mx-1', style: { fontSizeAdjust: '0.6' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'row col-md-12 rounded mx-auto' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-3 col-md-6' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'CODIGO:'
	              ),
	              _react2.default.createElement('input', { type: 'text', ref: txtIdDepartamento, disabled: true, onKeyUp: validarDepartamento, onBlur: validarDepartamento, className: 'form-control fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	              _react2.default.createElement(
	                'button',
	                { disabled: botones.catalogo, type: 'button', onClick: function onClick() {
	                    return setCatalogoDepartamento(true);
	                  }, className: 'btn btn-success' },
	                _react2.default.createElement('i', { className: 'fas fa-search' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-3 col-md-12' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'DESCRIPCION:'
	              ),
	              _react2.default.createElement('input', { type: 'text', ref: txtDescripcion, name: 'descripcion', autoComplete: 'off', disabled: habilitado, className: 'form-control fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onChange: onChange })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 mx-auto' },
	        visibleBtn === 'visible' ? _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 mx-auto row justify-content-between', style: { visibility: props.llamado === 2 ? 'collapse' : props.llamado !== 2 ? visibleBtn : 'visible' } },
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.incluir, onClick: onBotones(1), className: 'btn btn-sm mx-1 my-1 col btn-primary rounded-pill', title: 'Incluir Departamento' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-plus' },
	              ' Incluir '
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.consultar, onClick: onBotones(4), className: 'btn btn-sm mx-1 my-1 col btn-info rounded-pill', title: 'Consultar Departamento' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-eye' },
	              'Consultar'
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.modificar, onClick: onBotones(2), className: 'btn btn-sm mx-1 my-1 col btn-warning rounded-pill', title: 'Modificar Departamento' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fa fa-edit' },
	              'Modificar'
	            ),
	            ' '
	          ),
	          _react2.default.createElement(
	            'button',
	            { disabled: botones.eliminar, onClick: onBotones(3), className: 'btn btn-sm mx-1 my-1 col btn-danger rounded-pill', title: 'Eliminar Departamento' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fa fa-trash' },
	              'Eliminar'
	            ),
	            ' '
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 row mx-auto justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: botones.aceptar, onClick: onBotones(5), className: 'btn col-md-3 mx-1 my-1 btn-sm rounded-pill btn-success ' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check-circle' },
	              '  Aceptar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, disabled: botones.cancelar, onClick: onBotones(6), className: 'btn col-md-3 mx-1 my-1 btn-danger btn-sm rounded-pill ' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoDepartamento2.default, {
	      show: catalogoDepartamento,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoDepartamento(false);
	      },
	      onHideAceptaCatalogo: onCatalogoDepartamento
	    })
	  );
	};

/***/ },
/* 7050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GestionarUbicaciones = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _catalogoPersona = __webpack_require__(64);
	
	var _catalogoPersona2 = _interopRequireDefault(_catalogoPersona);
	
	var _mensajes = __webpack_require__(9);
	
	var _cartas = __webpack_require__(660);
	
	var _cartas2 = _interopRequireDefault(_cartas);
	
	var _catalogoubicacion = __webpack_require__(657);
	
	var _catalogoubicacion2 = _interopRequireDefault(_catalogoubicacion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GestionarUbicaciones = exports.GestionarUbicaciones = function GestionarUbicaciones(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var accbtnubialmacen = JSON.parse(sessionStorage.getItem('accbtnubialmacenc'));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtCodUbicacion = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	  var txtVentas = (0, _react.useRef)();
	  var cmbAlmacen = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)('visible'),
	      _useState2 = _slicedToArray(_useState, 2),
	      visibleBtn = _useState2[0],
	      setVisibleBtn = _useState2[1];
	
	  var _useState3 = (0, _react.useState)('Gestion Ubicación.'),
	      _useState4 = _slicedToArray(_useState3, 2),
	      tituloHeader = _useState4[0],
	      setTituloHeader = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      activate = _useState6[0],
	      setActivate = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      catalogoUbicacion = _useState8[0],
	      setCatalogoUbicacion = _useState8[1];
	
	  var _useState9 = (0, _react.useState)([]),
	      _useState10 = _slicedToArray(_useState9, 2),
	      almacen = _useState10[0],
	      setAlmacen = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(null),
	      _useState12 = _slicedToArray(_useState11, 2),
	      body = _useState12[0],
	      setBody = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(true),
	      _useState14 = _slicedToArray(_useState13, 2),
	      habilitado = _useState14[0],
	      setHabilitado = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true
	  }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      botones = _useState16[0],
	      setBotones = _useState16[1];
	
	  var _useState17 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState18 = _slicedToArray(_useState17, 2),
	      mensaje = _useState18[0],
	      setMensaje = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      mensajesino = _useState20[0],
	      setMensajesino = _useState20[1];
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'descripcionubicacion') {
	      e.target.value = e.target.value;
	    } else {
	      e.target.value = e.target.value;
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + '/api/ubicacion/actualizar/' + ope;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (ope === 1) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
	        } else if (ope === 2) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
	        } else if (ope === 3) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
	        }
	
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = '';
	      if (error.response === undefined) {
	        mensaje = 'Error de Conexion';
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
	          mensaje = 'Ya existe un Registro con este rif';
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	      setActivate(false);
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	
	    var campos = 'idalmacen, trim(descripcion) as descripcion, trim(responsable) as responsable';
	    var nomtab = 'almacen';
	    var orden = 'idalmacen';
	
	    var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setAlmacen(response.data);
	        }
	      }
	    }).catch(function (error) {
	
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = 'idubicacion, trim(descripcionubicacion) as descripcionubicacion, idalmacen, ventas';
	    var nomtab = 'ubicacion';
	    var nomid = 'idubicacion';
	    var id = txtCodUbicacion.current.value;
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        txtDescripcion.current.value = '';
	
	        if (response.data !== '') {
	
	          txtDescripcion.current.value = response.data.descripcionubicacion.trim();
	          cmbAlmacen.current.value = response.data.idalmacen;
	          txtVentas.current.checked = response.data.ventas ? true : false;
	          if (!botones.modificar) {
	            setBotones(Object.assign({}, botones, { catalogoper: false }));
	          }
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una ubicacion con este codigo', icono: 'informacion' });
	          txtDescripcion.current.value = '';
	          cmbAlmacen.current.value = '';
	          txtVentas.current.checked = false;
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setTituloHeader('Gestionar Ubicación.');
	    setBody(null);
	    setHabilitado(true);
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true
	    });
	    txtCodUbicacion.current.setAttribute("disabled", true);
	    txtCodUbicacion.current.value = '';
	    txtDescripcion.current.value = '';
	    cmbAlmacen.current.value = '';
	    txtVentas.current.checked = false;
	    setVisibleBtn('visible');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	
	    var sigue = true;
	    if (!botones.incluir || !botones.modificar) {
	
	      if (txtDescripcion.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar una descripción a la ubicacion', icono: 'informacion' });
	        txtDescripcion.current.focus();
	        sigue = false;
	      } else if (cmbAlmacen.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe seleccionar el almacen', icono: 'informacion' });
	        cmbAlmacen.current.focus();
	        sigue = false;
	      }
	    }
	
	    if (sigue) {
	
	      var ubicacion = [];
	      ubicacion.push({
	        idubicacion: txtCodUbicacion.current.value === '' ? 0 : txtCodUbicacion.current.value,
	        descripcionubicacion: txtDescripcion.current.value.toUpperCase().trim(),
	        idalmacen: cmbAlmacen.current.value,
	        ventas: txtVentas.current.checked ? true : false
	      });
	
	      setBody({
	        ubicacion: ubicacion
	      });
	
	      var msg = '';
	      if (!botones.incluir) {
	        msg = 'Esta Seguro de Registrar estos Datos.';
	      } else if (!botones.modificar) {
	        msg = 'Esta Seguro de Modificar estos Datos.';
	      } else if (!botones.eliminar) {
	        msg = 'Esta Seguro de Eliminar estos Datos.';
	      }
	
	      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	    }
	  };
	
	  var cerrar = function cerrar() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    /*     props.onHideRenderizar(); */
	    props.onHideCancela();
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    procesarRegistro();
	  };
	
	  var validarUbicacion = function validarUbicacion(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value !== '') {
	
	        seleccionarRegistro();
	      }
	    }
	  };
	
	  var onCatalogoUbicacion = function onCatalogoUbicacion(values) {
	    setCatalogoUbicacion(false);
	    txtCodUbicacion.current.value = values.idubicacion;
	    txtDescripcion.current.value = values.descripcionubicacion;
	    cmbAlmacen.current.value = values.idalmacen;
	    txtVentas.current.checked = values.ventas ? true : false;
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	
	      e.preventDefault();
	
	      if (op === 1) {
	
	        if (accbtnubialmacen && accbtnubialmacen.toString().substring(0, 1) === '1') {
	          setVisibleBtn('hidden');
	          setHabilitado(false);
	          setTituloHeader('Incluir Ubicación.');
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true
	          });
	          txtCodUbicacion.current.setAttribute("disabled", true);
	          setTimeout(function () {
	            return txtDescripcion.current.focus();
	          }, 200);
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 2) {
	
	        if (accbtnubialmacen && accbtnubialmacen.toString().substring(1, 2) === '1') {
	          setVisibleBtn('hidden');
	          setTituloHeader('Editar Ubicación.');
	          txtCodUbicacion.current.removeAttribute("disabled");
	          setHabilitado(false);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false
	          });
	          txtCodUbicacion.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 3) {
	
	        if (accbtnubialmacen && accbtnubialmacen.toString().substring(3, 4) === '1') {
	          setVisibleBtn('hidden');
	          setTituloHeader('Eliminar Ubicación.');
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false
	          });
	          txtCodUbicacion.current.removeAttribute("disabled");
	          txtCodUbicacion.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 4) {
	
	        if (accbtnubialmacen && accbtnubialmacen.toString().substring(2, 3) === '1') {
	          setVisibleBtn('hidden');
	          setTituloHeader('Consultar Ubicación.');
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false
	          });
	          txtCodUbicacion.current.removeAttribute("disabled");
	          txtCodUbicacion.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        blanquear();
	      } else if (op === 7) {
	        setVisibleBtn('visible');
	        cancelar();
	      }
	    };
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarRegistros();
	  }, []);
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {}
	
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        _Modal2.default.Title,
	        { style: { color: "#fff" } },
	        tituloHeader,
	        ' '
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: onBotones(7), className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'border-azul py-2 rounded' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 mx-auto' },
	          _react2.default.createElement(
	            'div',
	            { className: 'border-azul  py-3 rounded mb-2' },
	            _react2.default.createElement(
	              'div',
	              { style: { fontFamily: 'Times New Roman, Times, serif', fontSizeAdjust: '0.6' } },
	              _react2.default.createElement(
	                'div',
	                { className: ' row rounded mx-auto' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm mb-2 col-5' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'CODIGO DE UBICACION:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', autoComplete: 'off', ref: txtCodUbicacion, disabled: true, onKeyUp: validarUbicacion, onBlur: validarUbicacion, name: 'idubicacion', className: 'form-control fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                  _react2.default.createElement(
	                    'button',
	                    { disabled: botones.catalogo, onClick: function onClick() {
	                        return setCatalogoUbicacion(true);
	                      }, type: 'button', className: 'btn btn-success' },
	                    _react2.default.createElement('i', { className: 'fas fa-search' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'form-check form-check-inline col-md-2 p-0 m-0' },
	                  _react2.default.createElement('input', { ref: txtVentas, disabled: habilitado, className: 'form-check-input py-1', type: 'checkbox', id: 'inlineCheckbox1' }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'form-check-label px-1', htmlFor: 'inlineCheckbox1' },
	                    'VENTAS'
	                  )
	                ),
	                _react2.default.createElement('div', { className: 'col-md-7' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-8 input-group input-group-sm mb-2' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'DESCRIPCION:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', autoComplete: 'off', disabled: habilitado, ref: txtDescripcion, onChange: onChange, name: 'descripcionubicacion', className: 'form-control text-uppercase fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm mb-2 col-4' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'ALMACEN:'
	                  ),
	                  _react2.default.createElement(
	                    'select',
	                    { ref: cmbAlmacen, name: 'almacen', className: 'form-select form-select-sm px-0 text-center', disabled: habilitado, 'aria-label': '.form-select-sm example', onChange: onChange },
	                    _react2.default.createElement(
	                      'option',
	                      { value: '' },
	                      '--'
	                    ),
	                    almacen && almacen.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'option',
	                        { key: index, value: item.idalmacen },
	                        ' ',
	                        item.descripcion,
	                        ' '
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 mx-auto px-0' },
	            visibleBtn === 'visible' ? _react2.default.createElement(
	              'div',
	              { className: 'col-md-8 row m-0 px-0' },
	              _react2.default.createElement(
	                'button',
	                { disabled: botones.incluir, onClick: onBotones(1), className: 'btn btn-sm mx-1 col btn-primary rounded-pill', title: 'Incluir Almacen' },
	                _react2.default.createElement(
	                  'i',
	                  { className: 'fas fa-plus' },
	                  ' Incluir '
	                ),
	                ' '
	              ),
	              _react2.default.createElement(
	                'button',
	                { disabled: botones.consultar, onClick: onBotones(4), className: 'btn btn-sm mx-1 col btn-info rounded-pill', title: 'Consultar Almacen' },
	                _react2.default.createElement(
	                  'i',
	                  { className: 'fas fa-eye' },
	                  'Consultar'
	                ),
	                ' '
	              ),
	              _react2.default.createElement(
	                'button',
	                { disabled: botones.modificar, onClick: onBotones(2), className: 'btn btn-sm mx-1 col btn-warning rounded-pill', title: 'Modificar Almacen' },
	                _react2.default.createElement(
	                  'i',
	                  { className: 'fa fa-edit' },
	                  'Modificar'
	                ),
	                ' '
	              ),
	              _react2.default.createElement(
	                'button',
	                { disabled: botones.eliminar, onClick: onBotones(3), className: 'btn btn-sm mx-1 col btn-danger rounded-pill', title: 'Eliminar Almacen' },
	                _react2.default.createElement(
	                  'i',
	                  { className: 'fa fa-trash' },
	                  'Eliminar'
	                ),
	                ' '
	              )
	            ) : '',
	            visibleBtn === 'visible' ? '' : _react2.default.createElement(
	              'div',
	              { className: 'col-md-4  ml-auto d-flex justify-content-end px-0' },
	              _react2.default.createElement(
	                'button',
	                { disabled: botones.aceptar, onClick: onBotones(5), ref: btnAcepta, className: 'ml-2 btn btn-sm rounded-pill btn-success' },
	                _react2.default.createElement(
	                  'i',
	                  { className: 'fas fa-check-circle' },
	                  '  Aceptar'
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { disabled: botones.cancelar, onClick: onBotones(6), ref: btnCancela, className: 'ml-2 btn btn-danger btn-sm rounded-pill' },
	                _react2.default.createElement(
	                  'i',
	                  { className: 'fas fa-window-close' },
	                  ' Cancelar'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_catalogoubicacion2.default, {
	          show: catalogoUbicacion,
	          onHideCancelar: function onHideCancelar() {
	            return setCatalogoUbicacion(false);
	          },
	          onHideAceptaCatalogo: onCatalogoUbicacion
	        }),
	        _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	          onHide: function onHide() {
	            mensaje.titulo === 'Exito.' ? cerrar() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	          } }),
	        _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	          onHideNo: function onHideNo() {
	            return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	          }, onHideSi: handleCloseSi }),
	        _react2.default.createElement(
	          _semanticUiReact.Dimmer,
	          { active: activate, inverted: true },
	          _react2.default.createElement(
	            _semanticUiReact.Loader,
	            { inverted: true },
	            'cargando...'
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalImprimirOpObsequio = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalImprimirOpObsequio = exports.ModalImprimirOpObsequio = function ModalImprimirOpObsequio(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtDesde = (0, _react.useRef)();
	  var txtHasta = (0, _react.useRef)();
	  var txtTodos = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      desde = _useState2[0],
	      setDesde = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = _slicedToArray(_useState3, 2),
	      hasta = _useState4[0],
	      setHasta = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      activate = _useState6[0],
	      setActivate = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      todasfechas = _useState8[0],
	      setTodasfechas = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mensaje = _useState10[0],
	      setMensaje = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mensajesino = _useState12[0],
	      setMensajesino = _useState12[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setDesde('');
	    setHasta('');
	    setTodasfechas(0);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope === 1) {
	
	      if (txtDesde.current.value === "" || txtHasta.current.value === "") {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Las Fechas a Consultar no deben ir Vacias !', icono: 'informacion' });
	        txtDesde.current.focus();
	        sigue = false;
	      } else {
	
	        imprimirRecibo();
	      }
	    }
	  };
	
	  var imprimirRecibo = function imprimirRecibo() {
	
	    var reporte = 'OperacionesInventarioObsequioDonaciones';
	    var fechas = "";
	
	    if (todasfechas !== 0) {
	      fechas = '';
	    } else {
	      fechas = 'and n.fechatipomovimiento between ' + "'" + desde + "'" + ' and ' + "'" + hasta + "'";
	    }
	
	    window.open(op.reportes + "/almacen?afiliado=" + afiliado + "&reporte=" + reporte + "&desde=" + desde + "&hasta=" + hasta + "&condi=" + fechas, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'todos') {
	      if (e.target.checked) {
	        setTodasfechas(1);
	        setDesde('');
	        setHasta('');
	        txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        txtHasta.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	      } else {
	        var fh = (0, _moment2.default)(fechasistema).format('DD-MM-YYYY');
	        setTodasfechas(0);
	        setDesde(fh);
	        setHasta(fh);
	      }
	    }
	
	    if (e.target.name === "desde" && todasfechas !== 1) {
	      var desdec = (0, _moment2.default)(e.target.value).format('DD-MM-YYYY');
	      if (e.target.value > (0, _moment2.default)(fechasistema).format('YYYY-MM-DD')) {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !', icono: 'informacion' });
	        txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        txtDesde.current.focus();
	      } else {
	        setDesde(desdec);
	      }
	    } else if (e.target.name === "hasta") {
	      var hastac = (0, _moment2.default)(e.target.value).format('DD-MM-YYYY');
	      setHasta(hastac);
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'md',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        txtHasta.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        setDesde('');
	        setHasta('');
	        txtTodos.current.checked = true;
	        setTodasfechas(1);
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          "Operaciones de Inventario Obsequio/Donaciones"
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto m-0 border-azul px-1' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 row m-0 px-0 py-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-8 px-3 mb-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', ref: txtTodos, onChange: onChange, name: 'todos', type: 'checkbox', value: '', id: 'flexCheckDefault' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'flexCheckDefault' },
	                  'TODOS'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-6 px-1 mb-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'DESDE:'
	                ),
	                _react2.default.createElement('input', { type: 'date', ref: txtDesde, disabled: todasfechas !== 0 ? true : false, name: 'desde', onChange: onChange, className: 'form-control fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-6 px-1 mb-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'HASTA:'
	                ),
	                _react2.default.createElement('input', { type: 'date', ref: txtHasta, disabled: todasfechas !== 0 ? true : false, name: 'hasta', onChange: onChange, className: 'form-control fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-11 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: props.ope !== 0 ? false : true, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-primary mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-print' },
	              '  Imprimir'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7052 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IncluirProducOper = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoProductoExistencia = __webpack_require__(105);
	
	var _catalogoProductoExistencia2 = _interopRequireDefault(_catalogoProductoExistencia);
	
	var _catalogoProducto = __webpack_require__(104);
	
	var _catalogoProducto2 = _interopRequireDefault(_catalogoProducto);
	
	var _modalEditarProductoporOpe = __webpack_require__(7057);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var IncluirProducOper = exports.IncluirProducOper = function IncluirProducOper(props) {
	  var _useState27;
	
	  var token = sessionStorage.getItem("jwtToken");
	  var op = __webpack_require__(8);
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	
	  /*  variables de referencias */
	  var btnCancelar = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var txtIdproducto = (0, _react.useRef)();
	  var txtNombre = (0, _react.useRef)();
	  var txtCantidad = (0, _react.useRef)();
	  var txtCantidadExistente = (0, _react.useRef)();
	  var txtPrecio = (0, _react.useRef)();
	  var cmbTipoMovimiento = (0, _react.useRef)();
	  var txtFechaVenc = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtNumFactura = (0, _react.useRef)();
	  var cmbUnidad = (0, _react.useRef)();
	  var txtCosto = (0, _react.useRef)();
	
	  /*  variables de estados */
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      body = _useState2[0],
	      setBody = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      tipoIngreso = _useState4[0],
	      setTipoIngreso = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(),
	      _useState6 = _slicedToArray(_useState5, 2),
	      tipoIngr = _useState6[0],
	      setTipoIngr = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      catalogoediproduct = _useState8[0],
	      setCatalogoediproduct = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      catalogoProducto = _useState10[0],
	      setCatalogoProducto = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      catalogoProductoE = _useState12[0],
	      setCatalogoProductoE = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      activate = _useState14[0],
	      setActivate = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      operacion = _useState16[0],
	      setOperacion = _useState16[1];
	
	  var _useState17 = (0, _react.useState)("FECHA:"),
	      _useState18 = _slicedToArray(_useState17, 2),
	      labelFecha = _useState18[0],
	      setLabelFecha = _useState18[1];
	
	  var _useState19 = (0, _react.useState)([]),
	      _useState20 = _slicedToArray(_useState19, 2),
	      unidadCombo = _useState20[0],
	      setUnidadCombo = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(1),
	      _useState22 = _slicedToArray(_useState21, 2),
	      tipounidadc = _useState22[0],
	      setTipounidadc = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(),
	      _useState24 = _slicedToArray(_useState23, 2),
	      unidadc = _useState24[0],
	      setUnidadc = _useState24[1];
	
	  var _useState25 = (0, _react.useState)((_useState27 = {
	    idproducto: null,
	    codigo: null,
	    cantidad: 1.0,
	    cantidadE: 0.0,
	    cantidadEA: 0.0,
	    nombrecorto: null,
	    precio: 0.0,
	    preciomaxi: 0.0,
	    precioofe: 0.0,
	    preciomayor: 0.0,
	    preciomini: 0.0,
	    preciomaxialter: 0.0,
	    precioofealter: 0.0,
	    preciomayoralter: 0.0,
	    preciominialter: 0.0,
	    costoproveedor: 0.0,
	    costocalculado: 0.0,
	    ultimocosto: 0.0,
	    costopromedio: 0.0,
	    preciobs: 0.0,
	    iva: 0.0,
	    montoiva: 0.0,
	    descuento: 0.0,
	    total: 0.0,
	    unidad: [],
	    idunidadmedida: null,
	    idunidadalterna: null,
	    descripcionuni: "",
	    descripcionunialt: "",
	    precioconiva: 0.0,
	    idmoneda: null,
	    valormoneda: 0.0,
	    tipounidad: null,
	    tipofactor: null,
	    valorfactor: 0.0,
	    tipoprecio: null,
	    fechavencimiento: null,
	    tipomovimiento: null,
	    fechatipomovimiento: null,
	    numfactura: null
	  }, _defineProperty(_useState27, "costocalculado", 0.00), _defineProperty(_useState27, "costo", 0.00), _useState27)),
	      _useState26 = _slicedToArray(_useState25, 2),
	      producto = _useState26[0],
	      setProducto = _useState26[1];
	
	  var _useState28 = (0, _react.useState)(true),
	      _useState29 = _slicedToArray(_useState28, 2),
	      habilitadoFec = _useState29[0],
	      setHabilitadoFec = _useState29[1];
	
	  var _useState30 = (0, _react.useState)(true),
	      _useState31 = _slicedToArray(_useState30, 2),
	      habilitadoFac = _useState31[0],
	      setHabilitadoFac = _useState31[1];
	
	  var _useState32 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState33 = _slicedToArray(_useState32, 2),
	      mensaje = _useState33[0],
	      setMensaje = _useState33[1];
	
	  var _useState34 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState35 = _slicedToArray(_useState34, 2),
	      mensajesino = _useState35[0],
	      setMensajesino = _useState35[1];
	
	  var handleInputChange = function handleInputChange(event) {
	    event.preventDefault();
	    if (event.which === 13) {
	      if (event.target.name === "fechaven") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	        cmbTipoMovimiento.current.focus();
	      } else if (event.target.name === "fecha") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	        if (habilitadoFac) {
	          txtNumFactura.current.focus();
	        } else {
	          btnAcepta.current.focus();
	        }
	      }
	      if (event.target.name === "numfactura") {
	        btnAcepta.current.focus();
	      }
	    } else if (typeof event.which === "undefined") {
	      if (event.target.name === "fechaven") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	      } else if (event.target.name === "fecha") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false; //alert(e.which);
	  };
	
	  var validarCantidadP = function validarCantidadP(event) {
	    event.preventDefault();
	    (0, _varios.validaMonto)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      var cantidades = (0, _varios.validarCantidad)({
	        index: 0,
	        event: event,
	        productos: [producto],
	        tipo: props.tipo
	      });
	
	      setMensaje(cantidades.msm);
	      setProducto(cantidades.data[0]);
	
	      if (cantidades.msm.mostrar) {
	        btnCancelar.current.focus();
	      } else {
	        if (event.which === 13) {
	          txtFechaVenc.current.focus();
	        }
	      }
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var valido = true;
	    if (txtIdproducto.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El código no debe estar vacio",
	        ICONO: "INFORMACION"
	      });
	      valido = false;
	      txtIdproducto.current.focus();
	    } else if (txtNombre.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Descripción del Producto no debe estar vacia",
	        ICONO: "INFORMACION"
	      });
	      valido = false;
	      txtNombre.current.focus();
	    } else if (txtCantidad.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Cantidad no debe estar vacio",
	        ICONO: "INFORMACION"
	      });
	      valido = false;
	      txtCantidad.current.focus();
	    } else if (txtCantidad.current.value.trim() === "0,00") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Cantidad no debe cero",
	        ICONO: "INFORMACION"
	      });
	      valido = false;
	      txtCantidad.current.focus();
	    } else if (props.tipo >= 2 && parseFloat(txtCantidad.current.value.replace(".", "").replace(",", ".")) > parseFloat(txtCantidadExistente.current.value.replace(".", "").replace(",", "."))) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La  cantidad no debe ser mayor a la cantidad existente",
	        ICONO: "INFORMACION"
	      });
	      valido = false;
	      txtCantidad.current.focus();
	    } else if (txtPrecio.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Precio no debe estar vacio",
	        ICONO: "INFORMACION"
	      });
	      valido = false;
	      txtPrecio.current.focus();
	    } else if (props.tipo >= 2 & txtFecha.current.value.trim() === "" & cmbTipoMovimiento.current.selectedIndex === 0) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha no debe estar vacia",
	        ICONO: "INFORMACION"
	      });
	      valido = false;
	      txtFecha.current.focus();
	    } else if (txtFecha.current.value.trim() === "" & cmbTipoMovimiento.current.selectedIndex >= 1) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha no debe estar vacia",
	        ICONO: "INFORMACION"
	      });
	      valido = false;
	      txtFecha.current.focus();
	    } else if (txtFecha.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha no debe estar vacia",
	        ICONO: "INFORMACION"
	      });
	      valido = false;
	      txtFecha.current.focus();
	    } else if (txtNumFactura.current.value.trim() === "" & habilitadoFac) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Numero de factura no debe estar vacio",
	        ICONO: "INFORMACION"
	      });
	      valido = false;
	      txtNumFactura.current.focus();
	    }
	
	    if (valido) {
	      var datos = [];
	      datos.push({
	        idproducto: producto.idproducto,
	        codigo: producto.codigo,
	        nombre: producto.nombrecorto,
	        cantidad: parseFloat(txtCantidad.current.value.replace(".", "").replace(",", ".")),
	        precio: tipoIngr === 1 || tipoIngr === 5 ? producto.costo : producto.precio,
	        fechavencimiento: txtFechaVenc.current.value,
	        tipomovimiento: cmbTipoMovimiento.current[cmbTipoMovimiento.current.selectedIndex].text,
	        fechatipomovimiento: txtFecha.current.value,
	        numfactura: txtNumFactura.current.value,
	        tipounidad: producto.tipounidad,
	        idunidadmedida: producto.idunidadmedida,
	        idunidadalterna: producto.idunidadalterna,
	        descripcionuni: producto.descripcionuni,
	        descripcionunialt: producto.descripcionunialt,
	        tipofactor: producto.tipofactor,
	        valorfactor: producto.valorfactor,
	        valormoneda: producto.valormoneda
	      });
	
	      setBody(datos);
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: "Esta Seguro de Agregar este Producto.",
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    props.onHideAcepta(body);
	    blanquear();
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setOperacion(0);
	    setTipoIngreso([]);
	    setLabelFecha("FECHA:");
	    setUnidadCombo([]);
	    setUnidadc();
	    setTipoIngr();
	    setTipounidadc(1);
	    setProducto({
	      idproducto: null,
	      codigo: null,
	      cantidad: 1.0,
	      cantidadE: 0.0,
	      cantidadEA: 0.0,
	      nombrecorto: null,
	      precio: 0.0,
	      preciomaxi: 0.0,
	      precioofe: 0.0,
	      preciomayor: 0.0,
	      preciomini: 0.0,
	      preciomaxialter: 0.0,
	      precioofealter: 0.0,
	      preciomayoralter: 0.0,
	      preciominialter: 0.0,
	      preciobs: 0.0,
	      iva: 0.0,
	      montoiva: 0.0,
	      descuento: 0.0,
	      total: 0.0,
	      unidad: [],
	      idunidadmedida: null,
	      idunidadalterna: null,
	      descripcionuni: "",
	      descripcionunialt: "",
	      precioconiva: 0.0,
	      idmoneda: null,
	      valormoneda: 0.0,
	      tipounidad: null,
	      tipofactor: null,
	      valorfactor: 0.0,
	      tipoprecio: null,
	      fechavencimiento: null,
	      tipomovimiento: null,
	      fechatipomovimiento: null,
	      numfactura: null,
	      costocalculado: 0.00,
	      costo: 0.00
	    });
	    cmbUnidad.current.value = "";
	  };
	
	  var habilitarCampoTipoMov = function habilitarCampoTipoMov() {
	    switch (parseInt(cmbTipoMovimiento.current.value)) {
	      case 1:
	        if (props.tipo == 1) {
	          setLabelFecha("FECHA:");
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          setHabilitadoFec(true);
	          setHabilitadoFac(false);
	          btnAcepta.current.focus();
	        } else {
	          setLabelFecha("FECHA DE VENTA:");
	          setHabilitadoFec(true);
	          setHabilitadoFac(false);
	          txtFecha.current.focus();
	        }
	
	        break;
	      case 2:
	      case 3:
	      case 4:
	        if (props.tipo == 1) {
	          if (cmbTipoMovimiento.current.selectedIndex === 1) {
	            setLabelFecha("FECHA DE DONACION:");
	          } else if (cmbTipoMovimiento.current.selectedIndex === 2) {
	            setLabelFecha("FECHA DE PRESTAMO:");
	          } else {
	            setLabelFecha("FECHA DE RESGUARDO:");
	          }
	          setHabilitadoFec(true);
	          setHabilitadoFac(false);
	          txtFecha.current.focus();
	        } else if (props.tipo == 3) {
	          setLabelFecha("FECHA DE TRASLADO:");
	          setHabilitadoFec(true);
	          setHabilitadoFac(true);
	          txtFecha.current.focus();
	        } else {
	          if (cmbTipoMovimiento.current.selectedIndex === 1) {
	            setLabelFecha("FECHA DE VENCIMIENTO:");
	          } else if (cmbTipoMovimiento.current.selectedIndex === 2) {
	            setLabelFecha("FECHA DE DEVOLUCION:");
	          } else {
	            setLabelFecha("FECHA DE PRESTAMO:");
	          }
	          setHabilitadoFec(true);
	          setHabilitadoFac(false);
	          txtFecha.current.focus();
	        }
	
	        break;
	
	      case 5:
	        if (props.tipo == 1) {
	          setLabelFecha("FECHA DE ADQUISICION:");
	          setHabilitadoFec(true);
	          setHabilitadoFac(true);
	          txtFecha.current.focus();
	        } else {
	          setLabelFecha("FECHA DE DONACION:");
	          setHabilitadoFec(true);
	          setHabilitadoFac(false);
	          txtFecha.current.focus();
	        }
	
	        break;
	
	      case 6:
	        if (props.tipo == 1) {
	          setLabelFecha("FECHA DE PRODUCCION:");
	          setHabilitadoFec(true);
	          setHabilitadoFac(false);
	          txtFecha.current.focus();
	        } else if (props.tipo == 2) {
	          setLabelFecha("FECHA DE AJUSTE:");
	          setHabilitadoFec(true);
	          setHabilitadoFac(false);
	          txtFecha.current.focus();
	        }
	        break;
	      case 7:
	        if (props.tipo == 1) {
	          setLabelFecha("FECHA DE AJUSTE:");
	          setHabilitadoFec(true);
	          setHabilitadoFac(false);
	          txtFecha.current.focus();
	        }
	        break;
	    }
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "tipom") {
	      habilitarCampoTipoMov();
	      if (e.target.value === '1' || e.target.value === '5') {
	        setTipoIngr(parseInt(e.target.value));
	        var data = producto;
	        var precio = 0.0;
	        var montoiva = 0.0;
	        var montoivacosto = 0.0;
	        var tipounidad = 0;
	        var cantie = data.cantidadEA;
	        var idunidad = unidadc;
	        var costo = 0.00;
	
	        if (parseInt(idunidad) === parseInt(data.idunidadalterna)) {
	          tipounidad = 1;
	          cantie = parseFloat(data.cantidadEA);
	          cantie = Math.trunc(cantie);
	
	          if (parseInt(data.metodocosto) === 1) {
	            costo = data.costoproveedor / data.valorfactor;
	          }
	          if (parseInt(data.metodocosto) === 2) {
	            costo = data.costocalculado / data.valorfactor;
	          }
	          if (parseInt(data.metodocosto) === 3) {
	            costo = data.ultimocosto / data.valorfactor;
	          }
	          if (parseInt(data.metodocosto) === 4) {
	            costo = data.costopromedio / data.valorfactor;
	          }
	
	          if (parseInt(data.tipoprecio) === 1) {
	            precio = parseFloat(data.preciomaxialter);
	          } else if (parseInt(data.tipoprecio) === 2) {
	            precio = parseFloat(data.precioofealter);
	          } else if (parseInt(data.tipoprecio) === 3) {
	            precio = parseFloat(data.preciomayoralter);
	          } else if (parseInt(data.tipoprecio) === 4) {
	            precio = parseFloat(data.preciominialter);
	          }
	        } else if (parseInt(idunidad) === parseInt(data.idunidadmedida)) {
	          tipounidad = 0;
	          cantie = parseFloat(data.cantidadEA / data.valorfactor);
	          cantie = Math.trunc(cantie);
	
	          if (parseInt(data.metodocosto) === 1) {
	            costo = data.costoproveedor;
	          }
	          if (parseInt(data.metodocosto) === 2) {
	            costo = data.costocalculado;
	          }
	          if (parseInt(data.metodocosto) === 3) {
	            costo = data.ultimocosto;
	          }
	          if (parseInt(data.metodocosto) === 4) {
	            costo = data.costopromedio;
	          }
	
	          if (parseInt(data.tipoprecio) === 1) {
	            precio = parseFloat(data.preciomaxi);
	          } else if (parseInt(data.tipoprecio) === 2) {
	            precio = parseFloat(data.precioofe);
	          } else if (parseInt(data.tipoprecio) === 3) {
	            precio = parseFloat(data.preciomayor);
	          } else if (parseInt(data.tipoprecio) === 4) {
	            precio = parseFloat(data.preciomini);
	          }
	        }
	
	        montoiva = precio * parseFloat(data.iva) / 100;
	        montoiva = (0, _varios.round)(montoiva, 2);
	
	        montoivacosto = costo * parseFloat(data.iva) / 100;
	        montoivacosto = (0, _varios.round)(montoivacosto, 2);
	
	        if (props.tipo === 2 || props.tipo === 3) {
	          if (parseFloat(data.cantidad) > cantie) {
	            data.cantidad = 1.0;
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La  cantidad no debe ser mayor a la cantidad existente",
	              icono: "informacion"
	            });
	          }
	        }
	
	        data.tipounidad = tipounidad;
	        data.precio = precio + montoiva;
	        data.total = precio * data.cantidad;
	        data.montoiva = montoiva * data.cantidad;
	        data.cantidadE = cantie;
	        data.costo = parseFloat(costo) + montoivacosto;
	
	        setProducto(data);
	
	        cmbUnidad.current.value = idunidad;
	
	        txtCantidadExistente.current.value = (0, _varios.formatMoneda)(cantie.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        var topreciiva = precio + montoiva;
	        txtPrecio.current.value = (0, _varios.formatMoneda)(topreciiva.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        var precicosto = parseFloat(costo) + montoivacosto;
	        txtCosto.current.value = (0, _varios.formatMoneda)(precicosto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	      } else {
	        setTipoIngr(parseInt(e.target.value));
	        var _data = producto;
	        var _precio = 0.0;
	        var _montoiva = 0.0;
	        var _montoivacosto = 0.0;
	        var _tipounidad = 0;
	        var _cantie = _data.cantidadEA;
	        var _idunidad = unidadc;
	        var _costo = 0.00;
	
	        if (parseInt(_idunidad) === parseInt(_data.idunidadalterna)) {
	          _tipounidad = 1;
	          _cantie = parseFloat(_data.cantidadEA);
	          _cantie = Math.trunc(_cantie);
	
	          if (parseInt(_data.metodocosto) === 1) {
	            _costo = _data.costoproveedor / _data.valorfactor;
	          }
	          if (parseInt(_data.metodocosto) === 2) {
	            _costo = _data.costocalculado / _data.valorfactor;
	          }
	          if (parseInt(_data.metodocosto) === 3) {
	            _costo = _data.ultimocosto / _data.valorfactor;
	          }
	          if (parseInt(_data.metodocosto) === 4) {
	            _costo = _data.costopromedio / _data.valorfactor;
	          }
	
	          if (parseInt(_data.tipoprecio) === 1) {
	            _precio = parseFloat(_data.preciomaxialter);
	          } else if (parseInt(_data.tipoprecio) === 2) {
	            _precio = parseFloat(_data.precioofealter);
	          } else if (parseInt(_data.tipoprecio) === 3) {
	            _precio = parseFloat(_data.preciomayoralter);
	          } else if (parseInt(_data.tipoprecio) === 4) {
	            _precio = parseFloat(_data.preciominialter);
	          }
	        } else if (parseInt(_idunidad) === parseInt(_data.idunidadmedida)) {
	          _tipounidad = 0;
	          _cantie = parseFloat(_data.cantidadEA / _data.valorfactor);
	          _cantie = Math.trunc(_cantie);
	
	          if (parseInt(_data.metodocosto) === 1) {
	            _costo = _data.costoproveedor;
	          }
	          if (parseInt(_data.metodocosto) === 2) {
	            _costo = _data.costocalculado;
	          }
	          if (parseInt(_data.metodocosto) === 3) {
	            _costo = _data.ultimocosto;
	          }
	          if (parseInt(_data.metodocosto) === 4) {
	            _costo = _data.costopromedio;
	          }
	
	          if (parseInt(_data.tipoprecio) === 1) {
	            _precio = parseFloat(_data.preciomaxi);
	          } else if (parseInt(_data.tipoprecio) === 2) {
	            _precio = parseFloat(_data.precioofe);
	          } else if (parseInt(_data.tipoprecio) === 3) {
	            _precio = parseFloat(_data.preciomayor);
	          } else if (parseInt(_data.tipoprecio) === 4) {
	            _precio = parseFloat(_data.preciomini);
	          }
	        }
	
	        _montoiva = _precio * parseFloat(_data.iva) / 100;
	        _montoiva = (0, _varios.round)(_montoiva, 2);
	
	        _montoivacosto = _costo * parseFloat(_data.iva) / 100;
	        _montoivacosto = (0, _varios.round)(_montoivacosto, 2);
	
	        if (props.tipo === 2 || props.tipo === 3) {
	          if (parseFloat(_data.cantidad) > _cantie) {
	            _data.cantidad = 1.0;
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La  cantidad no debe ser mayor a la cantidad existente",
	              icono: "informacion"
	            });
	          }
	        }
	
	        _data.tipounidad = _tipounidad;
	        _data.precio = _precio + _montoiva;
	        _data.total = _precio * _data.cantidad;
	        _data.montoiva = _montoiva * _data.cantidad;
	        _data.cantidadE = _cantie;
	        _data.costo = parseFloat(_costo) + _montoivacosto;
	
	        setProducto(_data);
	
	        cmbUnidad.current.value = _idunidad;
	
	        txtCantidadExistente.current.value = (0, _varios.formatMoneda)(_cantie.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        var _topreciiva = _precio + _montoiva;
	        txtPrecio.current.value = (0, _varios.formatMoneda)(_topreciiva.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        var _precicosto = parseFloat(_costo) + _montoivacosto;
	        txtCosto.current.value = (0, _varios.formatMoneda)(_precicosto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	      }
	    }
	  };
	
	  var onCambioUnidad = function onCambioUnidad(e) {
	
	    if (e.target.name === 'tipou') {
	      var data = producto;
	      var precio = 0.0;
	      var costo = 0.0;
	      var montoiva = 0.0;
	      var montoivacosto = 0.0;
	      var tipounidad = 0;
	      var cantie = data.cantidadEA;
	      var idunidad = e.target.value;
	      setTipounidadc(e.target.value);
	
	      if (parseInt(idunidad) === parseInt(data.idunidadalterna)) {
	        tipounidad = 1;
	        cantie = parseFloat(data.cantidadEA);
	        cantie = Math.trunc(cantie);
	
	        if (tipoIngr === 1 || tipoIngr === 5) {
	          if (parseInt(data.metodocosto) === 1) {
	            costo = data.costoproveedor / data.valorfactor;
	          }
	          if (parseInt(data.metodocosto) === 2) {
	            costo = data.costocalculado / data.valorfactor;
	          }
	          if (parseInt(data.metodocosto) === 3) {
	            costo = data.ultimocosto / data.valorfactor;
	          }
	          if (parseInt(data.metodocosto) === 4) {
	            costo = data.costopromedio / data.valorfactor;
	          }
	
	          if (parseInt(data.tipoprecio) === 1) {
	            precio = parseFloat(data.preciomaxialter);
	          } else if (parseInt(data.tipoprecio) === 2) {
	            precio = parseFloat(data.precioofealter);
	          } else if (parseInt(data.tipoprecio) === 3) {
	            precio = parseFloat(data.preciomayoralter);
	          } else if (parseInt(data.tipoprecio) === 4) {
	            precio = parseFloat(data.preciominialter);
	          }
	        } else {
	          if (parseInt(data.metodocosto) === 1) {
	            costo = data.costoproveedor / data.valorfactor;
	          }
	          if (parseInt(data.metodocosto) === 2) {
	            costo = data.costocalculado / data.valorfactor;
	          }
	          if (parseInt(data.metodocosto) === 3) {
	            costo = data.ultimocosto / data.valorfactor;
	          }
	          if (parseInt(data.metodocosto) === 4) {
	            costo = data.costopromedio / data.valorfactor;
	          }
	
	          if (parseInt(data.tipoprecio) === 1) {
	            precio = parseFloat(data.preciomaxialter);
	          } else if (parseInt(data.tipoprecio) === 2) {
	            precio = parseFloat(data.precioofealter);
	          } else if (parseInt(data.tipoprecio) === 3) {
	            precio = parseFloat(data.preciomayoralter);
	          } else if (parseInt(data.tipoprecio) === 4) {
	            precio = parseFloat(data.preciominialter);
	          }
	        }
	        setUnidadc(e.target.value);
	      } else if (parseInt(idunidad) === parseInt(data.idunidadmedida)) {
	        tipounidad = 0;
	        cantie = parseFloat(data.cantidadEA / data.valorfactor);
	        cantie = Math.trunc(cantie);
	
	        if (tipoIngr === 1 || tipoIngr === 5) {
	          if (parseInt(data.metodocosto) === 1) {
	            costo = data.costoproveedor;
	          }
	          if (parseInt(data.metodocosto) === 2) {
	            costo = data.costocalculado;
	          }
	          if (parseInt(data.metodocosto) === 3) {
	            costo = data.ultimocosto;
	          }
	          if (parseInt(data.metodocosto) === 4) {
	            costo = data.costopromedio;
	          }
	
	          if (parseInt(data.tipoprecio) === 1) {
	            precio = parseFloat(data.preciomaxi);
	          } else if (parseInt(data.tipoprecio) === 2) {
	            precio = parseFloat(data.precioofe);
	          } else if (parseInt(data.tipoprecio) === 3) {
	            precio = parseFloat(data.preciomayor);
	          } else if (parseInt(data.tipoprecio) === 4) {
	            precio = parseFloat(data.preciomini);
	          }
	        } else {
	          if (parseInt(data.metodocosto) === 1) {
	            costo = data.costoproveedor;
	          }
	          if (parseInt(data.metodocosto) === 2) {
	            costo = data.costocalculado;
	          }
	          if (parseInt(data.metodocosto) === 3) {
	            costo = data.ultimocosto;
	          }
	          if (parseInt(data.metodocosto) === 4) {
	            costo = data.costopromedio;
	          }
	
	          if (parseInt(data.tipoprecio) === 1) {
	            precio = parseFloat(data.preciomaxi);
	          } else if (parseInt(data.tipoprecio) === 2) {
	            precio = parseFloat(data.precioofe);
	          } else if (parseInt(data.tipoprecio) === 3) {
	            precio = parseFloat(data.preciomayor);
	          } else if (parseInt(data.tipoprecio) === 4) {
	            precio = parseFloat(data.preciomini);
	          }
	        }
	        setUnidadc(e.target.value);
	      }
	
	      montoivacosto = costo * parseFloat(data.iva) / 100;
	      montoivacosto = (0, _varios.round)(montoivacosto, 2);
	
	      montoiva = precio * parseFloat(data.iva) / 100;
	      montoiva = (0, _varios.round)(montoiva, 2);
	
	      if (props.tipo === 2 || props.tipo === 3) {
	        if (parseFloat(data.cantidad) > cantie) {
	          data.cantidad = 1.0;
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "La  cantidad no debe ser mayor a la cantidad existente",
	            icono: "informacion"
	          });
	        }
	      }
	
	      data.tipounidad = tipounidad;
	      data.precio = precio;
	      data.total = precio * data.cantidad;
	      data.montoiva = montoiva * data.cantidad;
	      data.cantidadE = cantie;
	      data.costo = parseFloat(costo) + montoivacosto;
	
	      setProducto(data);
	
	      cmbUnidad.current.value = idunidad;
	
	      txtCantidadExistente.current.value = (0, _varios.formatMoneda)(cantie.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	      var topreciiva = precio + montoiva;
	      var precicosto = parseFloat(costo) + montoivacosto;
	      txtPrecio.current.value = (0, _varios.formatMoneda)(topreciiva.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	      txtCosto.current.value = (0, _varios.formatMoneda)(precicosto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var seleccionarProductoInv = function seleccionarProductoInv(tecla, idubi) {
	    var codigoproduct = "'" + txtIdproducto.current.value.toUpperCase() + "'";
	    var endpoint = op.conexion + "/api/inventario/seleccionarproductoinv?idproducto=" + codigoproduct + "&idalmacen=" + idubi;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var prod = void 0;
	        if (response.data !== "") {
	          if (response.data.servicio) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "no existe un producto con ese codigo en el almacen.",
	              icono: "error"
	            });
	          } else {
	            var _prod;
	
	            if (operacion === 1) {
	              for (var i = 0; i < props.productos.length; i++) {
	                if (props.productos[i].codigo === txtIdproducto.current.value.toUpperCase()) {
	                  setActivate(false);
	                  setMensaje({
	                    mostrar: true,
	                    titulo: "Notificacion",
	                    texto: "El PRODUCTO YA EXISTE",
	                    icono: "error"
	                  });
	                  txtIdproducto.current.value = "";
	                  txtPrecio.current.value = "0,00";
	                  txtCosto.current.value = "0,00";
	                  txtIdproducto.current.focus();
	                  txtCantidadExistente.current.value = "0,00";
	                  txtCantidad.current.value = "0,00";
	                  return;
	                }
	              }
	            }
	
	            var uni = [];
	            var precio = 0.0;
	            var costo = 0.00;
	            var montoiva = 0.0;
	            var montoivacosto = 0.0;
	            var cantie = response.data.cantidad;
	            var tipouni = 0;
	            var tiene_iva = false;
	            var tipoprecio = parseInt(response.data.tipoprecio);
	
	            if (parseFloat(response.data.ivaventa) > 0.0) {
	              tiene_iva = true;
	            }
	
	            if (parseInt(response.data.tipofactor) === 0 || response.data.tipofactor === null) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data.idunidadmedida,
	                descripcion: response.data.descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data.cantidad);
	              cantie = Math.trunc(cantie);
	
	              if (tipoIngr === 1) {
	                if (parseInt(response.data.metodocosto) === 1) {
	                  costo = response.data.costoproveedor;
	                }
	                if (parseInt(response.data.metodocosto) === 2) {
	                  costo = response.data.costocalculado;
	                }
	                if (parseInt(response.data.metodocosto) === 3) {
	                  costo = response.data.ultimocosto;
	                }
	                if (parseInt(response.data.metodocosto) === 4) {
	                  costo = response.data.costopromedio;
	                }
	
	                if (tipoprecio === 1) {
	                  precio = parseFloat(response.data.preciomaxi);
	                } else if (tipoprecio === 2) {
	                  precio = parseFloat(response.data.precioofe);
	                } else if (tipoprecio === 3) {
	                  precio = parseFloat(response.data.preciomayor);
	                } else if (tipoprecio === 4) {
	                  precio = parseFloat(response.data.preciomini);
	                }
	              } else {
	                if (parseInt(response.data.metodocosto) === 1) {
	                  costo = response.data.costoproveedor;
	                }
	                if (parseInt(response.data.metodocosto) === 2) {
	                  costo = response.data.costocalculado;
	                }
	                if (parseInt(response.data.metodocosto) === 3) {
	                  costo = response.data.ultimocosto;
	                }
	                if (parseInt(response.data.metodocosto) === 4) {
	                  costo = response.data.costopromedio;
	                }
	
	                if (tipoprecio === 1) {
	                  precio = parseFloat(response.data.preciomaxi);
	                } else if (tipoprecio === 2) {
	                  precio = parseFloat(response.data.precioofe);
	                } else if (tipoprecio === 3) {
	                  precio = parseFloat(response.data.preciomayor);
	                } else if (tipoprecio === 4) {
	                  precio = parseFloat(response.data.preciomini);
	                }
	              }
	              montoivacosto = costo * response.data.ivaventa / 100;
	              montoiva = precio * response.data.ivaventa / 100;
	            } else {
	              if (tipounidadc !== 1) {
	                if (tipounidadc === response.data.idunidadalterna) {
	                  tipouni = 1;
	                  uni = [{
	                    idunidad: response.data.idunidadmedida,
	                    descripcion: response.data.descripcionuni,
	                    tipo: "medida"
	                  }, {
	                    idunidad: response.data.idunidadalterna,
	                    descripcion: response.data.descripcionunialt,
	                    tipo: "alterna"
	                  }];
	
	                  cantie = parseFloat(response.data.cantidad);
	                  cantie = Math.trunc(cantie);
	
	                  if (tipoIngr === 1) {
	                    if (parseInt(response.data.metodocosto) === 1) {
	                      costo = response.data.costoproveedor / response.data.valorfactor;
	                    }
	                    if (parseInt(response.data.metodocosto) === 2) {
	                      costo = response.data.costocalculado / response.data.valorfactor;
	                    }
	                    if (parseInt(response.data.metodocosto) === 3) {
	                      costo = response.data.ultimocosto / response.data.valorfactor;
	                    }
	                    if (parseInt(response.data.metodocosto) === 4) {
	                      costo = response.data.costopromedio / response.data.valorfactor;
	                    }
	
	                    if (tipoprecio === 1) {
	                      precio = parseFloat(response.data.preciomaxialter);
	                    } else if (tipoprecio === 2) {
	                      precio = parseFloat(response.data.precioofealter);
	                    } else if (tipoprecio === 3) {
	                      precio = parseFloat(response.data.preciomayoralter);
	                    } else if (tipoprecio === 4) {
	                      precio = parseFloat(response.data.preciominialter);
	                    }
	                  } else {
	                    if (parseInt(response.data.metodocosto) === 1) {
	                      costo = response.data.costoproveedor / response.data.valorfactor;
	                    }
	                    if (parseInt(response.data.metodocosto) === 2) {
	                      costo = response.data.costocalculado / response.data.valorfactor;
	                    }
	                    if (parseInt(response.data.metodocosto) === 3) {
	                      costo = response.data.ultimocosto / response.data.valorfactor;
	                    }
	                    if (parseInt(response.data.metodocosto) === 4) {
	                      costo = response.data.costopromedio / response.data.valorfactor;
	                    }
	
	                    if (tipoprecio === 1) {
	                      precio = parseFloat(response.data.preciomaxialter);
	                    } else if (tipoprecio === 2) {
	                      precio = parseFloat(response.data.precioofealter);
	                    } else if (tipoprecio === 3) {
	                      precio = parseFloat(response.data.preciomayoralter);
	                    } else if (tipoprecio === 4) {
	                      precio = parseFloat(response.data.preciominialter);
	                    }
	                  }
	                  montoivacosto = costo * response.data.ivaventa / 100;
	                  montoiva = precio * response.data.ivaventa / 100;
	                } else if (tipounidadc === response.data.idunidadmedida) {
	                  tipouni = 0;
	                  uni = [{
	                    idunidad: response.data.idunidadmedida,
	                    descripcion: response.data.descripcionuni,
	                    tipo: "medida"
	                  }, {
	                    idunidad: response.data.idunidadalterna,
	                    descripcion: response.data.descripcionunialt,
	                    tipo: "alterna"
	                  }];
	
	                  cantie = parseFloat(response.data.cantidad / response.data.valorfactor);
	                  cantie = Math.trunc(cantie);
	
	                  if (tipoIngr === 1) {
	                    if (parseInt(response.data.metodocosto) === 1) {
	                      costo = response.data.costoproveedor;
	                    }
	                    if (parseInt(response.data.metodocosto) === 2) {
	                      costo = response.data.costocalculado;
	                    }
	                    if (parseInt(response.data.metodocosto) === 3) {
	                      costo = response.data.ultimocosto;
	                    }
	                    if (parseInt(response.data.metodocosto) === 4) {
	                      costo = response.data.costopromedio;
	                    }
	
	                    if (tipoprecio === 1) {
	                      precio = parseFloat(response.data.preciomaxi);
	                    } else if (tipoprecio === 2) {
	                      precio = parseFloat(response.data.precioofe);
	                    } else if (tipoprecio === 3) {
	                      precio = parseFloat(response.data.preciomayor);
	                    } else if (tipoprecio === 4) {
	                      precio = parseFloat(response.data.preciomini);
	                    }
	                  } else {
	                    if (parseInt(response.data.metodocosto) === 1) {
	                      costo = response.data.costoproveedor;
	                    }
	                    if (parseInt(response.data.metodocosto) === 2) {
	                      costo = response.data.costocalculado;
	                    }
	                    if (parseInt(response.data.metodocosto) === 3) {
	                      costo = response.data.ultimocosto;
	                    }
	                    if (parseInt(response.data.metodocosto) === 4) {
	                      costo = response.data.costopromedio;
	                    }
	
	                    if (tipoprecio === 1) {
	                      precio = parseFloat(response.data.preciomaxi);
	                    } else if (tipoprecio === 2) {
	                      precio = parseFloat(response.data.precioofe);
	                    } else if (tipoprecio === 3) {
	                      precio = parseFloat(response.data.preciomayor);
	                    } else if (tipoprecio === 4) {
	                      precio = parseFloat(response.data.preciomini);
	                    }
	                  }
	                  montoivacosto = costo * response.data.ivaventa / 100;
	                  montoiva = precio * response.data.ivaventa / 100;
	                }
	              } else {
	                if (response.data.idunidadventa === response.data.idunidadalterna) {
	                  tipouni = 1;
	                  uni = [{
	                    idunidad: response.data.idunidadalterna,
	                    descripcion: response.data.descripcionunialt,
	                    tipo: "alterna"
	                  }, {
	                    idunidad: response.data.idunidadmedida,
	                    descripcion: response.data.descripcionuni,
	                    tipo: "medida"
	                  }];
	
	                  cantie = parseFloat(response.data.cantidad);
	                  cantie = Math.trunc(cantie);
	
	                  if (tipoIngr === 1) {
	                    if (parseInt(response.data.metodocosto) === 1) {
	                      costo = response.data.costoproveedor / response.data.valorfactor;
	                    }
	                    if (parseInt(response.data.metodocosto) === 2) {
	                      costo = response.data.costocalculado / response.data.valorfactor;
	                    }
	                    if (parseInt(response.data.metodocosto) === 3) {
	                      costo = response.data.ultimocosto / response.data.valorfactor;
	                    }
	                    if (parseInt(response.data.metodocosto) === 4) {
	                      costo = response.data.costopromedio / response.data.valorfactor;
	                    }
	
	                    if (tipoprecio === 1) {
	                      precio = parseFloat(response.data.preciomaxialter);
	                    } else if (tipoprecio === 2) {
	                      precio = parseFloat(response.data.precioofealter);
	                    } else if (tipoprecio === 3) {
	                      precio = parseFloat(response.data.preciomayoralter);
	                    } else if (tipoprecio === 4) {
	                      precio = parseFloat(response.data.preciominialter);
	                    }
	                  } else {
	                    if (parseInt(response.data.metodocosto) === 1) {
	                      costo = response.data.costoproveedor / response.data.valorfactor;
	                    }
	                    if (parseInt(response.data.metodocosto) === 2) {
	                      costo = response.data.costocalculado / response.data.valorfactor;
	                    }
	                    if (parseInt(response.data.metodocosto) === 3) {
	                      costo = response.data.ultimocosto / response.data.valorfactor;
	                    }
	                    if (parseInt(response.data.metodocosto) === 4) {
	                      costo = response.data.costopromedio / response.data.valorfactor;
	                    }
	
	                    if (tipoprecio === 1) {
	                      precio = parseFloat(response.data.preciomaxialter);
	                    } else if (tipoprecio === 2) {
	                      precio = parseFloat(response.data.precioofealter);
	                    } else if (tipoprecio === 3) {
	                      precio = parseFloat(response.data.preciomayoralter);
	                    } else if (tipoprecio === 4) {
	                      precio = parseFloat(response.data.preciominialter);
	                    }
	                  }
	                  montoivacosto = costo * response.data.ivaventa / 100;
	                  montoiva = precio * response.data.ivaventa / 100;
	                } else if (response.data.idunidadventa === response.data.idunidadmedida) {
	                  tipouni = 0;
	                  uni = [{
	                    idunidad: response.data.idunidadmedida,
	                    descripcion: response.data.descripcionuni,
	                    tipo: "medida"
	                  }, {
	                    idunidad: response.data.idunidadalterna,
	                    descripcion: response.data.descripcionunialt,
	                    tipo: "alterna"
	                  }];
	
	                  cantie = parseFloat(response.data.cantidad / response.data.valorfactor);
	                  cantie = Math.trunc(cantie);
	
	                  if (tipoIngr === 1) {
	                    if (parseInt(response.data.metodocosto) === 1) {
	                      costo = response.data.costoproveedor;
	                    }
	                    if (parseInt(response.data.metodocosto) === 2) {
	                      costo = response.data.costocalculado;
	                    }
	                    if (parseInt(response.data.metodocosto) === 3) {
	                      costo = response.data.ultimocosto;
	                    }
	                    if (parseInt(response.data.metodocosto) === 4) {
	                      costo = response.data.costopromedio;
	                    }
	
	                    if (tipoprecio === 1) {
	                      precio = parseFloat(response.data.preciomaxi);
	                    } else if (tipoprecio === 2) {
	                      precio = parseFloat(response.data.precioofe);
	                    } else if (tipoprecio === 3) {
	                      precio = parseFloat(response.data.preciomayor);
	                    } else if (tipoprecio === 4) {
	                      precio = parseFloat(response.data.preciomini);
	                    }
	                  } else {
	                    if (parseInt(response.data.metodocosto) === 1) {
	                      costo = response.data.costoproveedor;
	                    }
	                    if (parseInt(response.data.metodocosto) === 2) {
	                      costo = response.data.costocalculado;
	                    }
	                    if (parseInt(response.data.metodocosto) === 3) {
	                      costo = response.data.ultimocosto;
	                    }
	                    if (parseInt(response.data.metodocosto) === 4) {
	                      costo = response.data.costopromedio;
	                    }
	
	                    if (tipoprecio === 1) {
	                      precio = parseFloat(response.data.preciomaxi);
	                    } else if (tipoprecio === 2) {
	                      precio = parseFloat(response.data.precioofe);
	                    } else if (tipoprecio === 3) {
	                      precio = parseFloat(response.data.preciomayor);
	                    } else if (tipoprecio === 4) {
	                      precio = parseFloat(response.data.preciomini);
	                    }
	                  }
	                  montoivacosto = costo * response.data.ivaventa / 100;
	                  montoiva = precio * response.data.ivaventa / 100;
	                }
	              }
	            }
	
	            setUnidadCombo(uni);
	            setUnidadc(response.data.idunidadventa);
	            var topreciiva = precio + montoiva;
	            var precicosto = parseFloat(costo) + montoivacosto;
	            txtNombre.current.value = response.data.nombre.trim();
	            txtPrecio.current.value = (0, _varios.formatMoneda)(topreciiva.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtCosto.current.value = (0, _varios.formatMoneda)(precicosto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtCantidadExistente.current.value = (0, _varios.formatMoneda)(cantie.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            if (tecla === 13) {
	              txtCantidad.current.focus();
	            }
	
	            prod = (_prod = {
	              idproducto: response.data.idproducto,
	              codigo: response.data.codigo,
	              cantidad: 1.0,
	              cantidadE: cantie,
	              cantidadEA: parseFloat(response.data.cantidad),
	              nombrecorto: response.data.nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	              precio: topreciiva,
	              precious: precio,
	              preciobs: 0.0,
	              iva: response.data.ivaventa,
	              preciomaxi: response.data.preciomaxi,
	              precioofe: response.data.precioofe,
	              preciomayor: response.data.preciomayor,
	              preciomini: response.data.preciomini,
	              preciomaxialter: response.data.preciomaxialter,
	              precioofealter: response.data.precioofealter,
	              preciomayoralter: response.data.preciomayoralter,
	              preciominialter: response.data.preciominialter,
	              costoproveedor: response.data.costoproveedor,
	              costocalculado: response.data.costocalculado,
	              ultimocosto: response.data.ultimocosto,
	              costopromedio: response.data.costopromedio,
	              montoiva: montoiva,
	              descuento: 0.0,
	              total: precio,
	              unidad: uni,
	              idunidadmedida: response.data.idunidadmedida,
	              idunidadalterna: response.data.idunidadalterna,
	              descripcionuni: response.data.descripcionuni,
	              descripcionunialt: response.data.descripcionunialt,
	              idmoneda: response.data.idmoneda,
	              valormoneda: response.data.valormoneda,
	              tipounidad: tipouni,
	              tipofactor: response.data.tipofactor,
	              valorfactor: response.data.valorfactor
	            }, _defineProperty(_prod, "costocalculado", response.data.costocalculado), _defineProperty(_prod, "costo", precicosto), _defineProperty(_prod, "metodocosto", parseInt(response.data.metodocosto)), _defineProperty(_prod, "tipoprecio", tipoprecio), _defineProperty(_prod, "precioconiva", (0, _varios.round)(parseFloat(precio * response.data.ivaventa / 100) + parseFloat(precio), 2)), _prod);
	
	            setProducto(prod);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "no existe un producto con ese codigo en el almacen.",
	            icono: "error"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var validarProducto = function validarProducto(event) {
	    event.preventDefault();
	    txtNombre.current.value = "";
	    txtPrecio.current.value = "0,00";
	    txtCantidadExistente.current.value = "0,00";
	    txtCantidad.current.value = "0,00";
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        seleccionarProductoInv(event.which, props.idalmacen);
	      }
	    }
	  };
	
	  var onCatalogoProducto = function onCatalogoProducto(values) {
	    setCatalogoProducto(false);
	    setCatalogoProductoE(false);
	    txtIdproducto.current.value = values.codigo;
	    if (props.tipo === 1) {
	      seleccionarProductoInv(13, props.idalmacen);
	    } else {
	      seleccionarProductoInv(13, values.idalmacen);
	    }
	  };
	
	  var cancelar = function cancelar(e) {
	    e.preventDefault();
	    blanquear();
	    props.onHideCancela();
	  };
	
	  (0, _react.useEffect)(function () {
	    if (props.tipoingreso) {
	      setTipoIngreso(props.tipoingreso);
	    }
	  }, [props.tipoingreso]);
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "xl",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      style: { backgroundColor: "rgb(0, 0, 0,0.5)" },
	      centered: true,
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        setOperacion(props.operacion);
	        if (props.operacion === 1) {
	          txtIdproducto.current.focus();
	        } else {
	          txtIdproducto.current.value = props.registro.idproducto;
	          txtCantidad.current.value = (0, _varios.formatMoneda)(props.registro.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtFechaVenc.current.value = props.registro.fechavencimiento === "" ? "" : (0, _moment2.default)(props.registro.fechavencimiento).format("DD/MM/YYYY");
	          txtFecha.current.value = props.registro.fechatipomovimiento === "" ? "" : (0, _moment2.default)(props.registro.fechatipomovimiento).format("DD/MM/YYYY");
	          txtNumFactura.current.value = props.registro.numfactura.trim();
	          for (var i = 0; i < props.tipoingreso.length; i++) {
	            if (props.tipoingreso[i].descripcion === props.registro.tipomovimiento) {
	              cmbTipoMovimiento.current.selectedIndex = i; //props.tipoingreso[i].idtipo;
	              break;
	            }
	          }
	          habilitarCampoTipoMov();
	          //txtCantidad.current.focus();
	          seleccionarProductoInv(13, props.idalmacen);
	        }
	        setTipoIngreso(props.tipoingreso);
	        setTipoIngr(1);
	        if (props.tipo === 1) {
	          // txtFecha.current.value = "";
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          setHabilitadoFec(true);
	          setHabilitadoFac(false);
	        } else if (props.tipo == 3) {
	          setLabelFecha("FECHA DE TRASLADO:");
	          setHabilitadoFec(true);
	          setHabilitadoFac(false);
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	        } else {
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          // txtFecha.current.value = "";
	          setHabilitadoFec(true);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        _Modal2.default.Title,
	        { style: { color: "#fff" } },
	        props.operacion === 1 ? "Agregar Productos." : props.operacion === 2 ? "Editar Productos." : props.operacion === 3 ? "Eliminar Productos." : "Consultar Productos."
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancelar,
	          className: "btn",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({
	            mostrar: false,
	            titulo: "",
	            texto: "",
	            icono: ""
	          });
	        }
	      }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, {
	        mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	        },
	        onHideSi: handleCloseSi
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "cargando..."
	        )
	      ),
	      _react2.default.createElement(_catalogoProductoExistencia2.default, {
	        show: catalogoProductoE,
	        onHideCancelar: function onHideCancelar() {
	          return setCatalogoProductoE(false);
	        },
	        onHideAceptaCatalogo: onCatalogoProducto,
	        idalmacen: props.idalmacen
	      }),
	      _react2.default.createElement(_modalEditarProductoporOpe.ModalEditarProductosOperacion, {
	        show: catalogoediproduct,
	        idproduct: producto.codigo,
	        ope: 2,
	        onHideCancela: function onHideCancela() {
	          return setCatalogoediproduct(false);
	        },
	        onHideAceptaProduct: onCatalogoProducto
	      }),
	      _react2.default.createElement(_catalogoProducto2.default, {
	        show: catalogoProducto,
	        onHideCancelar: function onHideCancelar() {
	          return setCatalogoProducto(false);
	        },
	        onHideAceptaCatalogo: onCatalogoProducto
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "border-azul py-3 rounded" },
	        _react2.default.createElement(
	          "div",
	          { style: { fontFamily: "Times New Roman, Times, serif" } },
	          _react2.default.createElement(
	            "div",
	            { className: "row rounded m-0" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 mb-2" },
	              _react2.default.createElement(
	                "fieldset",
	                { className: " row col-sm-12 mx-auto border-azul rounded d-lflex justify-content-between" },
	                _react2.default.createElement(
	                  "legend",
	                  { className: "float-none w-auto fw-bold" },
	                  "Productos"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-2 col-pd-260 px-1" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-default"
	                    },
	                    "CODIGO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    ref: txtIdproducto,
	                    autoComplete: "off",
	                    className: "form-control text-uppercase h-100 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-default",
	                    onChange: function onChange(e) {
	                      return e.target.value = e.target.value.toUpperCase();
	                    },
	                    onKeyUp: validarProducto,
	                    onBlur: validarProducto
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      type: "button",
	                      onClick: function onClick() {
	                        if (props.tipo === 1) {
	                          setCatalogoProducto(true);
	                        } else {
	                          setCatalogoProductoE(true);
	                        }
	                      },
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-2 col-pd-700 px-0" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-default"
	                    },
	                    "DESCRIPCION:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtNombre,
	                    className: "form-control h-100 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-default"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-2 col-pd-410 px-1" },
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "input-group-text",
	                  id: "inputGroup-sizing-default"
	                },
	                "TIPO DE MOVIMIENTO:"
	              ),
	              _react2.default.createElement(
	                "select",
	                {
	                  ref: cmbTipoMovimiento,
	                  className: "form-select px-1 fs-5",
	                  "aria-label": "Default select example",
	                  name: "tipom",
	                  onChange: onChange
	                },
	                tipoIngreso && tipoIngreso.map(function (tipo) {
	                  return _react2.default.createElement(
	                    "option",
	                    { key: tipo.idtipo, value: tipo.idtipo },
	                    tipo.descripcion
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-2 col-pd-300 px-1 mx-auto" },
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "input-group-text",
	                  id: "inputGroup-sizing-default"
	                },
	                "CANTIDAD ACTUAL:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                disabled: true,
	                ref: txtCantidadExistente,
	                className: "form-control text-right h-100 fs-5",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-default",
	                defaultValue: "0,00"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-2 col-pd-270 px-1 ml-auto" },
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "input-group-text",
	                  id: "inputGroup-sizing-default"
	                },
	                "UNIDAD/MEDIDA:"
	              ),
	              _react2.default.createElement(
	                "select",
	                {
	                  ref: cmbUnidad,
	                  className: "form-select fs-5",
	                  "aria-label": "Default select example",
	                  name: "tipou",
	                  onChange: onCambioUnidad
	                },
	                unidadCombo.map(function (unid, x) {
	                  return _react2.default.createElement(
	                    "option",
	                    { key: x, value: unid.idunidad },
	                    " ",
	                    unid.descripcion,
	                    " "
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-2 col-pd-240 px-1" },
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "input-group-text",
	                  id: "inputGroup-sizing-default"
	                },
	                "CANTIDAD:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                ref: txtCantidad,
	                autoComplete: "off",
	                className: "form-control text-right h-100 fs-5",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-default",
	                id: "cantidad",
	                onFocus: _varios.seleccionarCampo,
	                onKeyUp: validarCantidadP,
	                onBlur: validarCantidadP,
	                defaultValue: "0,00"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-2 col-pd-210 px-1 mx-auto" },
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "input-group-text",
	                  id: "inputGroup-sizing-default"
	                },
	                "COSTO:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                disabled: true,
	                ref: txtCosto,
	                className: "form-control text-right h-100 fs-5",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-default",
	                defaultValue: "0,00"
	              }),
	              producto.idproducto !== null && tipoIngr === 5 ? _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  onClick: function onClick() {
	                    return setCatalogoediproduct(true);
	                  },
	                  className: "btn btn-warning"
	                },
	                _react2.default.createElement("i", { className: "fas fa-edit" })
	              ) : ''
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-2 col-pd-250 px-1" },
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "input-group-text",
	                  id: "inputGroup-sizing-default"
	                },
	                "PRECIO DE VENTA:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                disabled: true,
	                ref: txtPrecio,
	                className: "form-control text-right h-100 fs-5",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-default",
	                defaultValue: "0,00"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-2 col-pd-360 px-1 ml-auto" },
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "input-group-text",
	                  id: "inputGroup-sizing-default"
	                },
	                "FECHA/VENCIMIENTO:"
	              ),
	              _react2.default.createElement("input", {
	                type: "date",
	                ref: txtFechaVenc,
	                className: "form-control h-100 fs-5",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-default",
	                name: "fechaven",
	                onKeyUp: handleInputChange,
	                onBlur: handleInputChange
	              })
	            ),
	            labelFecha === "FECHA:" ? _react2.default.createElement(
	              "div",
	              { className: "input-group mb-2 col-pd-250 px-1" },
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "input-group-text",
	                  id: "inputGroup-sizing-default"
	                },
	                labelFecha
	              ),
	              _react2.default.createElement("input", {
	                type: "date",
	                disabled: !habilitadoFec,
	                ref: txtFecha,
	                defaultValue: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	                className: "form-control h-100 fs-5",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-default",
	                name: "fecha",
	                onKeyUp: handleInputChange,
	                onBlur: handleInputChange
	              })
	            ) : _react2.default.createElement(
	              "div",
	              { className: "input-group mb-2 col-pd-360 px-1" },
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "input-group-text",
	                  id: "inputGroup-sizing-default"
	                },
	                labelFecha
	              ),
	              _react2.default.createElement("input", {
	                type: "date",
	                disabled: !habilitadoFec,
	                ref: txtFecha,
	                defaultValue: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	                className: "form-control h-100 fs-5",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-default",
	                name: "fecha",
	                onKeyUp: handleInputChange,
	                onBlur: handleInputChange
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-2 col-pd-300 px-1" },
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "input-group-text",
	                  id: "inputGroup-sizing-default"
	                },
	                "FACTURA N\xB0:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                disabled: labelFecha === 'FECHA DE DONACION:' ? false : true,
	                ref: txtNumFactura,
	                className: "form-control text-uppercase h-100 fs-5",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-default",
	                name: "numfactura",
	                onKeyUp: handleInputChange
	              })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          disabled: operacion === 4 ? true : false,
	          onClick: onChangeValidar,
	          className: "btn btn-sm rounded-pill btn-success "
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancelar,
	          onClick: cancelar,
	          className: "btn btn-danger btn-sm rounded-pill "
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7053 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IncluirProducOper = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoClassVacios = __webpack_require__(292);
	
	var _catalogoClassVacios2 = _interopRequireDefault(_catalogoClassVacios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IncluirProducOper = exports.IncluirProducOper = function IncluirProducOper(props) {
	  var token = sessionStorage.getItem("jwtToken");
	  var op = __webpack_require__(8);
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	
	  /*  variables de referencias */
	  var btnCancelar = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	
	  var txtIdproducto = (0, _react.useRef)();
	  var txtNombre = (0, _react.useRef)();
	  var txtCantidad = (0, _react.useRef)();
	  var txtCantidadExistente = (0, _react.useRef)();
	  var cmbTipoMovimiento = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtNumFactura = (0, _react.useRef)();
	
	  /*  variables de estados */
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      tipoIngreso = _useState2[0],
	      setTipoIngreso = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      catalogoProducto = _useState4[0],
	      setCatalogoProducto = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      activate = _useState6[0],
	      setActivate = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      operacion = _useState8[0],
	      setOperacion = _useState8[1];
	
	  var _useState9 = (0, _react.useState)("FECHA:"),
	      _useState10 = _slicedToArray(_useState9, 2),
	      labelFecha = _useState10[0],
	      setLabelFecha = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    idclasevacio: null,
	    cantidad: 1.0,
	    cantidadE: 0.0,
	    cantidadEA: 0.0,
	    descripcion: null,
	    tipomovimiento: null,
	    fechatipomovimiento: null,
	    numfactura: null
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      producto = _useState12[0],
	      setProducto = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(true),
	      _useState14 = _slicedToArray(_useState13, 2),
	      habilitadoFec = _useState14[0],
	      setHabilitadoFec = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(true),
	      _useState16 = _slicedToArray(_useState15, 2),
	      habilitadoFac = _useState16[0],
	      setHabilitadoFac = _useState16[1];
	
	  var _useState17 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState18 = _slicedToArray(_useState17, 2),
	      mensaje = _useState18[0],
	      setMensaje = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      mensajesino = _useState20[0],
	      setMensajesino = _useState20[1];
	
	  var handleInputChange = function handleInputChange(event) {
	    event.preventDefault();
	    if (event.which === 13) {
	      if (event.target.name === "fechaven") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	        cmbTipoMovimiento.current.focus();
	      } else if (event.target.name === "fecha") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	        if (habilitadoFac) {
	          txtNumFactura.current.focus();
	        } else {
	          btnAcepta.current.focus();
	        }
	      }
	      if (event.target.name === "numfactura") {
	        btnAcepta.current.focus();
	      }
	    } else if (typeof event.which === "undefined") {
	      if (event.target.name === "fechaven") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	      } else if (event.target.name === "fecha") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false; //alert(e.which);
	  };
	
	  var validarCantidadP = function validarCantidadP(event) {
	    event.preventDefault();
	    (0, _varios.validaMonto)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      var cantidades = (0, _varios.validarCantidad)({
	        index: 0,
	        event: event,
	        productos: [producto],
	        tipo: props.tipo
	      });
	
	      setMensaje(cantidades.msm);
	      setProducto(cantidades.data[0]);
	
	      if (cantidades.msm.mostrar) {
	        btnCancelar.current.focus();
	      }
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var valido = true;
	    if (txtIdproducto.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El código no debe estar vacio",
	        ICONO: "INFORMACION"
	      });
	      valido = false;
	      txtIdproducto.current.focus();
	    } else if (txtNombre.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Descripción del Producto no debe estar vacia",
	        ICONO: "INFORMACION"
	      });
	      valido = false;
	      txtNombre.current.focus();
	    } else if (txtCantidad.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Cantidad no debe estar vacio",
	        ICONO: "INFORMACION"
	      });
	      valido = false;
	      txtCantidad.current.focus();
	    } else if (txtCantidad.current.value.trim() === "0,00") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Cantidad no debe cero",
	        ICONO: "INFORMACION"
	      });
	      valido = false;
	      txtCantidad.current.focus();
	    } else if (props.tipo >= 2 && parseFloat(txtCantidad.current.value.replace(".", "").replace(",", ".")) > parseFloat(txtCantidadExistente.current.value.replace(".", "").replace(",", "."))) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La  cantidad no debe ser mayor a la cantidad existente",
	        ICONO: "INFORMACION"
	      });
	      valido = false;
	      txtCantidad.current.focus();
	    } else if (props.tipo >= 2 & txtFecha.current.value.trim() === "" & cmbTipoMovimiento.current.selectedIndex === 0) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha no debe estar vacia",
	        ICONO: "INFORMACION"
	      });
	      valido = false;
	      txtFecha.current.focus();
	    } else if (txtFecha.current.value.trim() === "" & cmbTipoMovimiento.current.selectedIndex >= 1) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha no debe estar vacia",
	        ICONO: "INFORMACION"
	      });
	      valido = false;
	      txtFecha.current.focus();
	    } else if (txtFecha.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha no debe estar vacia",
	        ICONO: "INFORMACION"
	      });
	      valido = false;
	      txtFecha.current.focus();
	    } else if (txtNumFactura.current.value.trim() === "" & habilitadoFac) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Numero de factura no debe estar vacio",
	        ICONO: "INFORMACION"
	      });
	      valido = false;
	      txtNumFactura.current.focus();
	    }
	
	    if (valido) {
	      var msg = "";
	      msg = "El registro fue actualizado.";
	      setMensaje({
	        mostrar: true,
	        titulo: "Exito.",
	        texto: msg,
	        icono: "exito"
	      });
	    }
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setOperacion(0);
	    setTipoIngreso([]);
	    setLabelFecha("FECHA:");
	    setProducto({
	      idclasevacio: null,
	      cantidad: 1.0,
	      cantidadE: 0.0,
	      cantidadEA: 0.0,
	      descripcion: null,
	      tipomovimiento: null,
	      fechatipomovimiento: null,
	      numfactura: null
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var cancelar = function cancelar(e) {
	    e.preventDefault();
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var habilitarCampoTipoMov = function habilitarCampoTipoMov() {
	    switch (parseInt(cmbTipoMovimiento.current.value)) {
	      case 1:
	        if (props.tipo == 1) {
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          setLabelFecha("FECHA:");
	          setHabilitadoFec(true);
	          setHabilitadoFac(false);
	          btnAcepta.current.focus();
	        } else if (props.tipo == 2) {
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          setLabelFecha("FECHA DE DESPACHO:");
	          setHabilitadoFec(true);
	          setHabilitadoFac(true);
	          txtFecha.current.focus();
	        }
	
	        break;
	      case 2:
	        if (props.tipo == 1) {
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          setLabelFecha("FECHA DE RECEPCION:");
	          setHabilitadoFec(true);
	          setHabilitadoFac(true);
	          txtFecha.current.focus();
	        } else if (props.tipo == 2) {
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          setLabelFecha("FECHA DE AJUSTE:");
	          setHabilitadoFec(true);
	          setHabilitadoFac(false);
	          txtFecha.current.focus();
	        }
	        break;
	      case 3:
	        if (props.tipo == 1) {
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          setLabelFecha("FECHA DE AJUSTE:");
	          setHabilitadoFec(true);
	          setHabilitadoFac(false);
	          txtFecha.current.focus();
	        }
	        break;
	    }
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "tipo") {
	      habilitarCampoTipoMov();
	    }
	  };
	
	  var cerrarModal = function cerrarModal() {
	    var datos = [];
	    datos.push({
	      idclasevacio: producto.idclasevacio,
	      descripcion: producto.descripcion,
	      cantidad: parseFloat(txtCantidad.current.value.replace(".", "").replace(",", ".")),
	      tipomovimiento: cmbTipoMovimiento.current[cmbTipoMovimiento.current.selectedIndex].text,
	      fechatipomovimiento: txtFecha.current.value,
	      numfactura: txtNumFactura.current.value
	    });
	    props.onHideAcepta(datos);
	    blanquear();
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var seleccionarProductoInv = function seleccionarProductoInv(tecla, idubi) {
	    var codigoproduct = txtIdproducto.current.value.toUpperCase();
	    var endpoint = op.conexion + "/api/inventariovacio/seleccionarproductoinv?idproducto=" + codigoproduct + "&idalmacen=" + idubi;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var prod = void 0;
	        if (response.data !== "") {
	          if (response.data.servicio) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "no existe un producto con ese codigo en el almacen.",
	              icono: "error"
	            });
	          } else {
	            if (operacion === 1) {
	              for (var i = 0; i < props.productos.length; i++) {
	                if (props.productos[i].idclasevacio === txtIdproducto.current.value.toUpperCase()) {
	                  setActivate(false);
	                  setMensaje({
	                    mostrar: true,
	                    titulo: "Notificacion",
	                    texto: "El PRODUCTO YA EXISTE",
	                    icono: "error"
	                  });
	                  txtIdproducto.current.value = "";
	                  txtIdproducto.current.focus();
	                  txtCantidadExistente.current.value = "0,00";
	                  txtCantidad.current.value = "0,00";
	                  return;
	                }
	              }
	            }
	
	            var cantie = response.data.cantidad;
	
	            txtNombre.current.value = response.data.descripcion.trim();
	            txtCantidadExistente.current.value = (0, _varios.formatMoneda)(cantie.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            if (tecla === 13) {
	              txtCantidad.current.focus();
	            }
	
	            prod = {
	              idclasevacio: response.data.idclasevacio,
	              cantidad: 1.0,
	              cantidadE: cantie,
	              cantidadEA: parseFloat(response.data.cantidad),
	              descripcion: response.data.descripcion
	            };
	
	            setProducto(prod);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "no existe un vacio con ese codigo en el almacen.",
	            icono: "error"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      console.log(error);
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var validarProducto = function validarProducto(event) {
	    event.preventDefault();
	    txtNombre.current.value = "";
	    txtCantidadExistente.current.value = "0,00";
	    txtCantidad.current.value = "0,00";
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        seleccionarProductoInv(event.which, props.idalmacen);
	      }
	    }
	  };
	
	  var onCatalogoProducto = function onCatalogoProducto(values) {
	    setCatalogoProducto(false);
	
	    txtIdproducto.current.value = values.idclasevacio;
	    seleccionarProductoInv(13, props.idalmacen);
	  };
	
	  (0, _react.useEffect)(function () {
	    if (props.tipoingreso) {
	      setTipoIngreso(props.tipoingreso);
	    }
	  }, [props.tipoingreso]);
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "xl",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      style: { backgroundColor: "rgb(0, 0, 0,0.5)" },
	      centered: true,
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        setOperacion(props.operacion);
	        if (props.operacion === 1) {
	          txtIdproducto.current.focus();
	        } else {
	          txtIdproducto.current.value = props.registro.idproducto;
	          txtCantidad.current.value = (0, _varios.formatMoneda)(props.registro.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtFecha.current.value = props.registro.fechatipomovimiento === "" ? "" : (0, _moment2.default)(props.registro.fechatipomovimiento).format("DD/MM/YYYY");
	          txtNumFactura.current.value = props.registro.numfactura.trim();
	          for (var i = 0; i < props.tipoingreso.length; i++) {
	            if (props.tipoingreso[i].descripcion === props.registro.tipomovimiento) {
	              cmbTipoMovimiento.current.selectedIndex = i; //props.tipoingreso[i].idtipo;
	              break;
	            }
	          }
	          habilitarCampoTipoMov();
	          //txtCantidad.current.focus();
	          seleccionarProductoInv(13, props.idalmacen);
	        }
	        setTipoIngreso(props.tipoingreso);
	        if (props.tipo === 1) {
	          setHabilitadoFec(true);
	          setHabilitadoFac(false);
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	        } else if (props.tipo == 2) {
	          setLabelFecha("FECHA DE SALIDA:");
	          setHabilitadoFec(true);
	          setHabilitadoFac(true);
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	        } else if (props.tipo == 3) {
	          setLabelFecha("FECHA DE TRASLADO:");
	          setHabilitadoFec(true);
	          setHabilitadoFac(false);
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	        } else {
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          // txtFecha.current.value = "";
	          setHabilitadoFec(true);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        _Modal2.default.Title,
	        { style: { color: "#fff" } },
	        props.operacion === 1 ? "Agregar Vacios." : props.operacion === 2 ? "Editar Vacios." : props.operacion === 3 ? "Eliminar Vacios." : "Consultar Vacios."
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancelar,
	          className: "btn",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({
	            mostrar: false,
	            titulo: "",
	            texto: "",
	            icono: ""
	          });
	        }
	      }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, {
	        mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	        },
	        onHideSi: handleCloseSi
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "cargando..."
	        )
	      ),
	      _react2.default.createElement(_catalogoClassVacios2.default, {
	        show: catalogoProducto,
	        idalmacen: props.tipo === 1 ? null : props.idalmacen,
	        onHideCancelar: function onHideCancelar() {
	          return setCatalogoProducto(false);
	        },
	        onHideAceptaCatalogo: onCatalogoProducto
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "border-azul py-3 rounded" },
	        _react2.default.createElement(
	          "div",
	          { style: { fontFamily: "Times New Roman, Times, serif" } },
	          _react2.default.createElement(
	            "div",
	            { className: "row rounded m-0" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 mb-2" },
	              _react2.default.createElement(
	                "fieldset",
	                { className: " row col-sm-12 mx-auto border-azul rounded d-lflex justify-content-between" },
	                _react2.default.createElement(
	                  "legend",
	                  { className: "float-none w-auto fw-bold" },
	                  "Vacios"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-2 col-pd-260 px-1" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-default"
	                    },
	                    "CODIGO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    ref: txtIdproducto,
	                    autoComplete: "off",
	                    className: "form-control text-uppercase h-100 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-default",
	                    onChange: function onChange(e) {
	                      return e.target.value = e.target.value.toUpperCase();
	                    },
	                    onKeyUp: validarProducto,
	                    onBlur: validarProducto
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      type: "button",
	                      onClick: function onClick() {
	                        setCatalogoProducto(true);
	                      },
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-2 col-pd-700 px-0" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-default"
	                    },
	                    "DESCRIPCION:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtNombre,
	                    className: "form-control h-100 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-default"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-2 col-pd-300 px-1" },
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "input-group-text",
	                  id: "inputGroup-sizing-default"
	                },
	                "CANTIDAD ACTUAL:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                disabled: true,
	                ref: txtCantidadExistente,
	                className: "form-control text-right h-100 fs-5",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-default",
	                defaultValue: "0,00"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-2 col-pd-250 mx-auto" },
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "input-group-text",
	                  id: "inputGroup-sizing-default"
	                },
	                "CANTIDAD:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                ref: txtCantidad,
	                autoComplete: "off",
	                className: "form-control text-right h-100 fs-5",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-default",
	                id: "cantidad",
	                onFocus: _varios.seleccionarCampo,
	                onKeyUp: validarCantidadP,
	                onBlur: validarCantidadP,
	                defaultValue: "0,00"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-2 col-pd-410 px-1" },
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "input-group-text",
	                  id: "inputGroup-sizing-default"
	                },
	                "TIPO DE MOVIMIENTO:"
	              ),
	              _react2.default.createElement(
	                "select",
	                {
	                  ref: cmbTipoMovimiento,
	                  className: "form-select px-1 fs-5",
	                  "aria-label": "Default select example",
	                  name: "tipo",
	                  onChange: onChange
	                },
	                tipoIngreso && tipoIngreso.map(function (tipo) {
	                  return _react2.default.createElement(
	                    "option",
	                    { key: tipo.idtipo, value: tipo.idtipo },
	                    tipo.descripcion
	                  );
	                })
	              )
	            ),
	            labelFecha === "FECHA:" ? _react2.default.createElement(
	              "div",
	              { className: "input-group mb-2 col-pd-250 px-1" },
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "input-group-text",
	                  id: "inputGroup-sizing-default"
	                },
	                labelFecha
	              ),
	              _react2.default.createElement("input", {
	                type: "date",
	                disabled: !habilitadoFec,
	                ref: txtFecha,
	                defaultValue: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	                className: "form-control h-100 fs-5",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-default",
	                name: "fecha",
	                onKeyUp: handleInputChange,
	                onBlur: handleInputChange
	              })
	            ) : _react2.default.createElement(
	              "div",
	              { className: "input-group mb-2 col-pd-360 px-1" },
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "input-group-text",
	                  id: "inputGroup-sizing-default"
	                },
	                labelFecha
	              ),
	              _react2.default.createElement("input", {
	                type: "date",
	                disabled: !habilitadoFec,
	                ref: txtFecha,
	                defaultValue: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	                className: "form-control h-100 fs-5",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-default",
	                name: "fecha",
	                onKeyUp: handleInputChange,
	                onBlur: handleInputChange
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-2 col-pd-300 px-1" },
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "input-group-text",
	                  id: "inputGroup-sizing-default"
	                },
	                "FACTURA N\xB0:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                disabled: !habilitadoFac,
	                ref: txtNumFactura,
	                className: "form-control text-uppercase h-100 fs-5",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-default",
	                name: "numfactura",
	                onKeyUp: handleInputChange
	              })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnAcepta,
	          disabled: operacion === 4 ? true : false,
	          onClick: onChangeValidar,
	          className: "btn btn-sm rounded-pill btn-success "
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Aceptar"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancelar,
	          onClick: cancelar,
	          className: "btn btn-danger btn-sm rounded-pill "
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7054 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _varios = __webpack_require__(14);
	
	var _core = __webpack_require__(19);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _xlsx = __webpack_require__(160);
	
	var XLSX = _interopRequireWildcard(_xlsx);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IncluirProductosExcel = function IncluirProductosExcel() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  //const anio = JSON.parse(sessionStorage.getItem("anioactu"));
	  //const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	
	  var chkSi = (0, _react.useRef)();
	  var chkNo = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)("visible"),
	      _useState2 = _slicedToArray(_useState, 2),
	      visibleBtn = _useState2[0],
	      setVisibleBtn = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(true),
	      _useState4 = _slicedToArray(_useState3, 2),
	      habilitado = _useState4[0],
	      setHabilitado = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      insertProduct = _useState6[0],
	      setInsertProduct = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      updateProduct = _useState8[0],
	      setUpdateProduct = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mensaje = _useState10[0],
	      setMensaje = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mensajesino = _useState12[0],
	      setMensajesino = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      activate = _useState14[0],
	      setActivate = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    catalogoper: true
	  }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      botones = _useState16[0],
	      setBotones = _useState16[1];
	
	  var _useState17 = (0, _react.useState)([]),
	      _useState18 = _slicedToArray(_useState17, 2),
	      headCells = _useState18[0],
	      setHeadCells = _useState18[1];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var blanquear = function blanquear() {
	    chkSi.current.checked = false;
	    chkNo.current.checked = false;
	    setVisibleBtn("visible");
	    setActivate(false);
	    setHabilitado(true);
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      catalogoper: true
	    });
	  };
	
	  var procesarRegistro = function procesarRegistro(operacion, body) {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/cerveceria/actualizar/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setInsertProduct([]);
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: response.data.contar + " registro creado correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 2) {
	          setUpdateProduct([]);
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: response.data.contar + " registro modificado correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: response.data.contar + " registro eliminado correctamente",
	            icono: "exito"
	          });
	        }
	
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros(productFile) {
	    var campos = "codigo";
	    var nomtab = "producto";
	    var orden = "idproducto";
	    var datos = [];
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          for (var index = 0; index < response.data.length; index++) {
	            datos.push(response.data[index].codigo);
	          }
	          procesarPrecioProd(datos, productFile);
	        } else {
	          setInsertProduct(productFile);
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var calcularUtilidadxValor = function calcularUtilidadxValor(producto) {
	    var iva = producto[5];
	    var costo = producto[6];
	    var venta = producto[8];
	
	    var mon = costo * iva / 100;
	    mon = mon + costo;
	    var mon3 = 0.0;
	
	    mon3 = (venta - mon) / mon;
	    mon3 = mon3 * 100;
	    return mon3;
	  };
	
	  var calcularUtilidadxValorAlter = function calcularUtilidadxValorAlter(producto) {
	    var iva = producto[5];
	    var costo = producto[4];
	    var venta = producto[7];
	
	    var mon = costo * iva / 100;
	    mon = mon + costo;
	    var mon3 = 0.0;
	
	    mon3 = (venta - mon) / mon;
	    mon3 = mon3 * 100;
	    return mon3;
	  };
	
	  var updateProcess = function updateProcess() {
	    var productos = [];
	    for (var i = 0; i < updateProduct.length; i++) {
	      productos.push({
	        codigo: updateProduct[i][1],
	        nombre: updateProduct[i][2],
	        nombrecorto: updateProduct[i][2],
	        ivacompra: updateProduct[i][5],
	        ivaventa: updateProduct[i][9],
	        exento: parseFloat(updateProduct[i][9]) > 0.0 ? false : true,
	        valorfactor: updateProduct[i][3],
	        tipofactor: parseInt(updateProduct[i][3]) > 1 ? 1 : 0,
	        costoproveedor: updateProduct[i][6],
	        costocalculado: updateProduct[i][6],
	        ultimocosto: updateProduct[i][6],
	        costopromedio: updateProduct[i][6],
	        costoproveedoralter: updateProduct[i][4],
	        costocalculadoalter: updateProduct[i][4],
	        ultimocostoalter: updateProduct[i][4],
	        costopromedioalter: updateProduct[i][4],
	        utipreciomaxi: calcularUtilidadxValor(updateProduct[i]),
	        utiprecioofe: calcularUtilidadxValor(updateProduct[i]),
	        utipreciomayor: calcularUtilidadxValor(updateProduct[i]),
	        utipreciomini: calcularUtilidadxValor(updateProduct[i]),
	        utipreciomaxialter: calcularUtilidadxValorAlter(updateProduct[i]),
	        utiprecioofealter: calcularUtilidadxValorAlter(updateProduct[i]),
	        utipreciomayoralter: calcularUtilidadxValorAlter(updateProduct[i]),
	        utipreciominialter: calcularUtilidadxValorAlter(updateProduct[i])
	      });
	    }
	    procesarRegistro(2, { productos: JSON.stringify(productos) });
	  };
	
	  var insertProcess = function insertProcess() {
	    var productos = [];
	    for (var i = 0; i < insertProduct.length; i++) {
	      productos.push({
	        codigo: insertProduct[i][1],
	        nombre: insertProduct[i][2],
	        nombrecorto: insertProduct[i][2],
	        ivacompra: insertProduct[i][5],
	        ivaventa: insertProduct[i][9],
	        exento: parseFloat(insertProduct[i][9]) > 0.0 ? false : true,
	        valorfactor: insertProduct[i][3],
	        tipofactor: parseInt(insertProduct[i][3]) > 1 ? 1 : 0,
	        costoproveedor: insertProduct[i][6],
	        costocalculado: insertProduct[i][6],
	        ultimocosto: insertProduct[i][6],
	        costopromedio: insertProduct[i][6],
	        costoproveedoralter: insertProduct[i][4],
	        costocalculadoalter: insertProduct[i][4],
	        ultimocostoalter: insertProduct[i][4],
	        costopromedioalter: insertProduct[i][4],
	        utipreciomaxi: calcularUtilidadxValor(insertProduct[i]),
	        utiprecioofe: calcularUtilidadxValor(insertProduct[i]),
	        utipreciomayor: calcularUtilidadxValor(insertProduct[i]),
	        utipreciomini: calcularUtilidadxValor(insertProduct[i]),
	        utipreciomaxialter: calcularUtilidadxValorAlter(insertProduct[i]),
	        utiprecioofealter: calcularUtilidadxValorAlter(insertProduct[i]),
	        utipreciomayoralter: calcularUtilidadxValorAlter(insertProduct[i]),
	        utipreciominialter: calcularUtilidadxValorAlter(insertProduct[i])
	      });
	    }
	    procesarRegistro(1, { productos: JSON.stringify(productos) });
	  };
	
	  var handleInputChange = function handleInputChange(e) {
	    if (e.target.name === "file" && e.target.files.length > 0) {
	      setActivate(true);
	      setHeadCells([]);
	      setInsertProduct([]);
	      setUpdateProduct([]);
	      var hojas = [];
	      var reader = new FileReader();
	      reader.readAsArrayBuffer(e.target.files[0]);
	      reader.onload = function (e) {
	        var data = new Uint8Array(e.target.result);
	        var workbook = XLSX.read(data, { type: "array" });
	
	        workbook.SheetNames.forEach(function (SheetName) {
	          var objData = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[SheetName]);
	
	          hojas.push({
	            data: objData,
	            SheetName: SheetName
	          });
	        });
	
	        var titulos = [];
	        var produc = [];
	        var titulo_sigue = false;
	        var produc_sigue = false;
	        var rueda = Object.keys(hojas[0].data[0]);
	
	        try {
	          for (var i = 0; i < rueda.length; i++) {
	            titulos.push({
	              label: rueda[i].toUpperCase(),
	              textAlign: "center"
	            });
	          }
	          titulo_sigue = true;
	        } catch (error) {
	          console.log(error);
	
	          setMensaje({
	            mostrar: true,
	            titulo: "Error",
	            texto: "el archivo xlsx esta mal formado",
	            icono: "error"
	          });
	          setActivate(false);
	        }
	
	        try {
	          for (var l = 0; l < hojas[0].data.length; l++) {
	            console.log("pase" + l);
	            var obj = {};
	            var array = Object.values(hojas[0].data[l]);
	            for (var k = 0; k < array.length; k++) {
	              obj[k] = array[k];
	            }
	            produc.push(obj);
	          }
	          produc_sigue = true;
	          setActivate(false);
	        } catch (error) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Error",
	            texto: "el archivo xlsx esta mal formado",
	            icono: "error"
	          });
	          setActivate(false);
	        }
	
	        if (titulo_sigue === true && produc_sigue === true) {
	          seleccionarRegistros(produc);
	          setHeadCells(titulos);
	        } else {
	          setHeadCells([]);
	          setInsertProduct([]);
	          setUpdateProduct([]);
	        }
	      };
	    }
	  };
	
	  var procesarPrecioProd = function procesarPrecioProd(cursorProduct, fileProduct) {
	    var element = fileProduct;
	    var element0 = [];
	    var viejos = [];
	    var nuevos = [];
	
	    for (var i = 0; i < fileProduct.length; i++) {
	      for (var x = 0; x < cursorProduct.length; x++) {
	        if (cursorProduct[x].toString().trim().toUpperCase() === fileProduct[i][1].toString().trim().toUpperCase()) {
	          viejos.push(fileProduct[i][1]);
	          element0.push(fileProduct[i]);
	        }
	      }
	    }
	
	    var _loop = function _loop(_i) {
	      for (var _x = 0; _x < viejos.length; _x++) {
	        if (viejos[_x].toString().trim().toUpperCase() === element[_i][1].toString().trim().toUpperCase()) {
	          element = element.filter(function (value) {
	            return value[1].toString().trim().toUpperCase() !== element[_i][1].toString().trim().toUpperCase();
	          });
	        }
	      }
	    };
	
	    for (var _i = 0; _i < element.length; _i++) {
	      _loop(_i);
	    }
	    nuevos = element;
	
	    setInsertProduct(nuevos);
	    setUpdateProduct(element0);
	    setActivate(false);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12", style: { margin: 0 } },
	      _react2.default.createElement(
	        "h1",
	        null,
	        "PRODUCTOS POR ACTUALIZAR"
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12 py-3 mx-auto card shadow " },
	          _react2.default.createElement(
	            _semanticUiReact.Dimmer,
	            { active: activate, inverted: true },
	            _react2.default.createElement(
	              _semanticUiReact.Loader,
	              { inverted: true },
	              "cargando..."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "row col-md-12 mx-auto " },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group input-group-sm mb-2 col-md-12 justify-content-between" },
	              _react2.default.createElement("input", {
	                required: true,
	                type: "file",
	                name: "file",
	                id: "file",
	                className: "form-control col-md-3",
	                onChange: handleInputChange,
	                placeholder: "Ingrese Archivo Excel."
	              })
	            ),
	            updateProduct.length > 0 && _react2.default.createElement(
	              "div",
	              { className: "col-md-6 mx-auto mb-3" },
	              _react2.default.createElement(
	                "div",
	                { className: "row col-md-12" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-warning btn-sm rounded-pill col-md-2 mb-3",
	                    onClick: updateProcess
	                  },
	                  " ",
	                  "Actualizar"
	                )
	              ),
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 350,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden" },
	                  updateProduct && updateProduct.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      {
	                        key: index,
	                        style: {
	                          padding: "0",
	                          backgroundColor: "transparent"
	                        }
	                      },
	                      Object.values(item) && Object.values(item).map(function (item2, x) {
	                        return _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            key: x,
	                            className: "align-baseline p-0",
	                            style: {
	                              textAlign: "center",
	                              border: "solid 1px #000000"
	                            }
	                          },
	                          item2
	                        );
	                      })
	                    );
	                  })
	                )
	              )
	            ),
	            insertProduct.length > 0 && _react2.default.createElement(
	              "div",
	              { className: "col-md-6 mx-auto mb-3" },
	              _react2.default.createElement(
	                "div",
	                { className: "row col-md-12" },
	                _react2.default.createElement(
	                  "h1",
	                  null,
	                  "PRODUCTOS POR REGISTRAR"
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-primary btn-sm rounded-pill col-md-2 mb-3",
	                    onClick: insertProcess
	                  },
	                  " ",
	                  "Registrar"
	                )
	              ),
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 350,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden" },
	                  insertProduct && insertProduct.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      {
	                        key: index,
	                        style: {
	                          padding: "0",
	                          backgroundColor: "transparent"
	                        }
	                      },
	                      Object.values(item) && Object.values(item).map(function (item2, x) {
	                        return _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            key: x,
	                            className: "align-baseline p-0",
	                            style: {
	                              textAlign: "center",
	                              border: "solid 1px #000000"
	                            }
	                          },
	                          item2
	                        );
	                      })
	                    );
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = IncluirProductosExcel;

/***/ },
/* 7055 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActualizarProductosExcel = undefined;
	
	var _regenerator = __webpack_require__(69);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _core = __webpack_require__(19);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _varios = __webpack_require__(14);
	
	var _xlsx = __webpack_require__(160);
	
	var XLSX = _interopRequireWildcard(_xlsx);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ActualizarProductosExcel = exports.ActualizarProductosExcel = function ActualizarProductosExcel(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	
	  var txtCosto = (0, _react.useRef)([]);
	  var txtPrecio = (0, _react.useRef)([]);
	  var btnIncluir = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(true),
	      _useState2 = _slicedToArray(_useState, 2),
	      habilitadoBot = _useState2[0],
	      setHabilitadoBot = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      jsonData = _useState6[0],
	      setJsonData = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      productosData = _useState8[0],
	      setProductosData = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      file = _useState10[0],
	      setFile = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(null),
	      _useState12 = _slicedToArray(_useState11, 2),
	      body = _useState12[0],
	      setBody = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensaje = _useState14[0],
	      setMensaje = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mensajesino = _useState16[0],
	      setMensajesino = _useState16[1];
	
	  var headCells = [{ label: "CODIGO", textAlign: "center", width: "0px" }, { label: "DESCRIPCION", textAlign: "center" }, { label: "COSTO", textAlign: "center" }, { label: "PRECIO", textAlign: "center" }, {
	    label: _react2.default.createElement("i", { className: "fas fa-trash" }),
	    textAlign: "center",
	    width: "20px"
	  }];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/inventario/actualizarpreciosexcel/";
	
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token,
	        "Content-Type": "application/json"
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setJsonData([]);
	        setMensaje({
	          mostrar: true,
	          titulo: "Éxito",
	          texto: response.data.registros_actualizados + " registro(s) modificado(s) correctamente",
	          icono: "exito"
	        });
	      }
	    }).catch(function (error) {
	      var errorMsg = error.message;
	      if (error.response) {
	        errorMsg = error.response.data.message || error.response.statusText;
	      }
	
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: "Error al procesar: " + errorMsg,
	        icono: "error"
	      });
	    }).finally(function () {
	      return setActivate(false);
	    });
	  };
	
	  var validarCosto = function validarCosto(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        var data = [].concat(_toConsumableArray(jsonData));
	        if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	          event.target.value = "0,00";
	        }
	        event.target.value = (0, _varios.formatoMonto)(event.target.value);
	        var char1 = event.target.value.substring(0, 1);
	        var char2 = event.target.value.substring(1, 2);
	        if (char1 === "0" && char2 !== ",") {
	          event.target.value = event.target.value.substring(1, event.target.value.length);
	        }
	        var canti = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	        data[index].costoproveedor = canti;
	        setJsonData(data);
	      }
	    };
	  };
	
	  var validarPrecio = function validarPrecio(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        var data = [].concat(_toConsumableArray(jsonData));
	        if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	          event.target.value = "0,00";
	        }
	        event.target.value = (0, _varios.formatoMonto)(event.target.value);
	        var char1 = event.target.value.substring(0, 1);
	        var char2 = event.target.value.substring(1, 2);
	        if (char1 === "0" && char2 !== ",") {
	          event.target.value = event.target.value.substring(1, event.target.value.length);
	        }
	        var canti = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	        data[index].preciomaxi = canti;
	        setJsonData(data);
	      }
	    };
	  };
	
	  var eliminarProducto = function eliminarProducto(producto) {
	    return function (e) {
	      e.preventDefault();
	      var data = [].concat(_toConsumableArray(jsonData));
	      var elementos = [];
	
	      for (var i = 0; i < data.length; i++) {
	        if (producto.codigo !== data[i].codigo) {
	          elementos.push(data[i]);
	        }
	      }
	      setJsonData(elementos);
	    };
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var productos = [];
	    for (var i = 0; i < jsonData.length; i++) {
	
	      var costo = parseFloat(jsonData[i].costoproveedor);
	      var precio = parseFloat(jsonData[i].preciomaxi);
	      // El factor de la unidad alterna ahora se trae de la base de datos
	      // (campo valorfactor) y ya no del archivo Excel.
	      var valorfactor = parseFloat(jsonData[i].valorfactor) || 1;
	      var utilidad = costo > 0 ? (0, _varios.round)((precio - costo) / costo * 100) : 0;
	
	      if (valorfactor > 1) {
	        productos.push({
	          codigo: jsonData[i].codigo,
	          costoproveedor: costo,
	          costoproveedoralter: (0, _varios.round)(costo / valorfactor),
	          preciomaxi: precio,
	          preciomaxialter: (0, _varios.round)(precio / valorfactor),
	          utipreciomaxi: utilidad,
	          utipreciomaxialter: utilidad
	        });
	      } else {
	        productos.push({
	          codigo: jsonData[i].codigo,
	          costoproveedor: costo,
	          costoproveedoralter: costo,
	          preciomaxi: precio,
	          preciomaxialter: precio,
	          utipreciomaxi: utilidad,
	          utipreciomaxialter: utilidad
	        });
	      }
	    }
	    setBody({ datos_actualizacion: productos });
	    if (productos.length > 0) {
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: "Esta Seguro de Modificar el Precio de estos Productos?",
	        icono: "confirmacion"
	      });
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificacion",
	        texto: "No hay Productos Incluidos para Actualizar Precios",
	        icono: "error"
	      });
	    }
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setHabilitadoBot(true);
	    setJsonData([]);
	    setBody(null);
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        setHabilitadoBot(false);
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        var selectedFile = '';
	        setFile(selectedFile);
	        blanquear();
	      }
	    };
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHide();
	  };
	
	  var handleFileChange = function handleFileChange(e) {
	    var selectedFile = e.target.files[0];
	    setFile(selectedFile);
	  };
	
	  var esNumeroValido = function esNumeroValido(valor) {
	    // Si es un string vacío o solo espacios, no es un número
	    if (typeof valor === "string" && valor.trim() === "") return false;
	
	    return !isNaN(parseFloat(valor)) && isFinite(valor);
	  };
	
	  var seleccionarRegistrosProductos = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var campos, nomtab, orden, endpoint, response, errorMsg;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              // Se trae el valorfactor (y las unidades) de la base de datos para no
	              // depender de la unidad alterna cargada en el Excel.
	              campos = "idproducto, idunidadmedida, idunidadalterna, codigo, valorfactor, tipofactor";
	              nomtab = "producto";
	              orden = "idproducto";
	              endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	              _context.prev = 4;
	              _context.next = 7;
	              return _axios2.default.get(endpoint, {
	                headers: {
	                  "x-access-token": "" + token
	                }
	              });
	
	            case 7:
	              response = _context.sent;
	
	              if (!(response.status === 200 && Array.isArray(response.data))) {
	                _context.next = 11;
	                break;
	              }
	
	              setProductosData(response.data);
	              return _context.abrupt("return", response.data);
	
	            case 11:
	
	              setProductosData([]);
	              return _context.abrupt("return", []);
	
	            case 15:
	              _context.prev = 15;
	              _context.t0 = _context["catch"](4);
	              errorMsg = _context.t0.message;
	
	              if (_context.t0.response) {
	                errorMsg = _context.t0.response.data.message || _context.t0.response.statusText;
	              }
	
	              setMensaje({
	                mostrar: true,
	                titulo: "Error",
	                texto: "Error al consultar los productos: " + errorMsg,
	                icono: "error"
	              });
	              setProductosData([]);
	              return _context.abrupt("return", []);
	
	            case 22:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[4, 15]]);
	    }));
	
	    return function seleccionarRegistrosProductos() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var convertToJson = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var reader;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              if (file) {
	                _context3.next = 3;
	                break;
	              }
	
	              setMensaje({
	                mostrar: true,
	                titulo: "Notificacion",
	                texto: "Por favor selecciona un archivo Excel.",
	                icono: "informacion"
	              });
	              return _context3.abrupt("return");
	
	            case 3:
	
	              setActivate(true);
	
	              reader = new FileReader();
	
	
	              reader.onload = function () {
	                var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(e) {
	                  var data, workbook, firstSheet, jsonResult, requiredColumns, missingColumns, productos, productosPorCodigo, i, prod, enrichedData, noencontrado, _i, codigo, producto;
	
	                  return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                      switch (_context2.prev = _context2.next) {
	                        case 0:
	                          _context2.prev = 0;
	                          data = new Uint8Array(e.target.result);
	                          workbook = XLSX.read(data, { type: 'array' });
	                          firstSheet = workbook.Sheets[workbook.SheetNames[0]];
	
	                          // Ya no se lee la columna 'unidadalterna': el factor se obtiene
	                          // de la consulta de productos (campo valorfactor).
	
	                          jsonResult = XLSX.utils.sheet_to_json(firstSheet, {
	                            header: ['codigo', 'nombrecorto', 'costoproveedor', 'preciomaxi'],
	                            range: 1
	                          });
	                          requiredColumns = ['codigo', 'nombrecorto', 'costoproveedor', 'preciomaxi'];
	
	                          if (!(jsonResult.length > 0)) {
	                            _context2.next = 12;
	                            break;
	                          }
	
	                          missingColumns = requiredColumns.filter(function (col) {
	                            return !Object.keys(jsonResult[0]).includes(col);
	                          });
	
	                          if (!(missingColumns.length > 0)) {
	                            _context2.next = 12;
	                            break;
	                          }
	
	                          setMensaje({
	                            mostrar: true,
	                            titulo: "Notificacion",
	                            texto: "Faltan columnas requeridas: " + missingColumns.join(', '),
	                            icono: "error"
	                          });
	                          setActivate(false);
	                          return _context2.abrupt("return");
	
	                        case 12:
	
	                          // Asegurar que los productos estén cargados. Si por algún motivo
	                          // aún no se han consultado, se traen en este momento.
	                          productos = productosData;
	
	                          if (!(!productos || productos.length === 0)) {
	                            _context2.next = 17;
	                            break;
	                          }
	
	                          _context2.next = 16;
	                          return seleccionarRegistrosProductos();
	
	                        case 16:
	                          productos = _context2.sent;
	
	                        case 17:
	
	                          // Indexar los productos por código para que la búsqueda sea eficiente
	                          // incluso con cientos o miles de registros (más de 40 productos).
	                          productosPorCodigo = new Map();
	
	                          for (i = 0; i < productos.length; i++) {
	                            prod = productos[i];
	
	                            if (prod && prod.codigo !== undefined && prod.codigo !== null) {
	                              productosPorCodigo.set(prod.codigo.toString().trim().toUpperCase(), prod);
	                            }
	                          }
	
	                          enrichedData = [];
	                          noencontrado = [];
	
	
	                          for (_i = 0; _i < jsonResult.length; _i++) {
	                            codigo = jsonResult[_i].codigo !== undefined && jsonResult[_i].codigo !== null ? jsonResult[_i].codigo.toString().trim().toUpperCase() : "";
	                            producto = productosPorCodigo.get(codigo);
	
	
	                            if (producto) {
	                              enrichedData.push(Object.assign({}, jsonResult[_i], {
	                                idproducto: producto.idproducto,
	                                idunidadmedida: producto.idunidadmedida,
	                                idunidadalterna: producto.idunidadalterna,
	                                // El valorfactor siempre viene de la base de datos.
	                                valorfactor: esNumeroValido(producto.valorfactor) ? parseFloat(producto.valorfactor) : 1,
	                                tipofactor: producto.tipofactor,
	                                costoproveedor: esNumeroValido(jsonResult[_i].costoproveedor) ? jsonResult[_i].costoproveedor : 0,
	                                preciomaxi: esNumeroValido(jsonResult[_i].preciomaxi) ? jsonResult[_i].preciomaxi : 0
	                              }));
	                            } else {
	                              noencontrado.push(jsonResult[_i].codigo);
	                            }
	                          }
	
	                          setJsonData(enrichedData);
	                          //console.log(`producto(s) no se encontraron;${noencontrado}`);
	                          setMensaje({
	                            mostrar: true,
	                            titulo: "Éxito",
	                            texto: "Archivo convertido. " + enrichedData.length + " registros listos." + (noencontrado.length > 0 ? " " + noencontrado.length + " producto(s) no se encontraron en la base de datos." : ""),
	                            icono: "exito"
	                          });
	                          _context2.next = 29;
	                          break;
	
	                        case 26:
	                          _context2.prev = 26;
	                          _context2.t0 = _context2["catch"](0);
	
	                          setMensaje({
	                            mostrar: true,
	                            titulo: "Notificacion",
	                            texto: "Error al procesar el archivo: " + _context2.t0.message,
	                            icono: "error"
	                          });
	
	                        case 29:
	                          _context2.prev = 29;
	
	                          setActivate(false);
	                          return _context2.finish(29);
	
	                        case 32:
	                        case "end":
	                          return _context2.stop();
	                      }
	                    }
	                  }, _callee2, undefined, [[0, 26, 29, 32]]);
	                }));
	
	                return function (_x) {
	                  return _ref3.apply(this, arguments);
	                };
	              }();
	
	              reader.readAsArrayBuffer(file);
	
	            case 7:
	            case "end":
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined);
	    }));
	
	    return function convertToJson() {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "xl",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      backdrop: "static",
	      keyboard: false,
	      onShow: _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _context4.next = 2;
	                return seleccionarRegistrosProductos();
	
	              case 2:
	              case "end":
	                return _context4.stop();
	            }
	          }
	        }, _callee4, undefined);
	      }))
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        _Modal2.default.Title,
	        { style: { color: "#fff" } },
	        "Actualizar Precios "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          onClick: cancelar,
	          ref: btnCancela,
	          className: "btn btn-sm text-light"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-share-square" },
	          " Salir"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(
	        "div",
	        { style: { height: "100%", width: "100%" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row col-md-12 ", style: { margin: 0 } },
	          _react2.default.createElement(
	            "div",
	            { className: "row col-md-12 py-2", style: { margin: 0 } },
	            _react2.default.createElement(
	              "div",
	              { className: "col-pd-520" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 row m-0 mb-2 row m-0" },
	                _react2.default.createElement("input", {
	                  type: "file",
	                  accept: ".xlsx, .xls",
	                  className: "col-8",
	                  onChange: handleFileChange,
	                  style: { marginBottom: '10px' }
	                }),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: !habilitadoBot,
	                    ref: btnIncluir,
	                    onClick: convertToJson,
	                    className: "btn btn-sm col-4 btn-success rounded-pill",
	                    title: "Carga la tabla con los productos"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-long-arrow-alt-down" },
	                    " Cargar Excel "
	                  ),
	                  " "
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 border-azul px-0 rounded",
	                style: { backgroundColor: "#d5e9ff" }
	              },
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 400,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px",
	                    fontSizeAdjust: "0.6"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden" },
	                  jsonData && jsonData.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      { key: index, style: { padding: "0" } },
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "bg-light d-flex align-items-between px-0",
	                          style: { maxWidth: "500px" }
	                        },
	                        item.codigo
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-start p-0 pl-2"
	                        },
	                        item.nombrecorto
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-center p-0 col-pd-90" },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control form-control-sm bg-light text-right fs-6",
	                          id: "costo",
	                          disabled: !habilitadoBot,
	                          defaultValue: (0, _varios.formatMoneda)(item.costoproveedor.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtCosto.current[index] = el;
	                          },
	                          onFocus: _varios.seleccionarCampo,
	                          onKeyUp: validarCosto(index),
	                          onBlur: validarCosto(index),
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-center p-0 col-pd-90" },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control form-control-sm bg-light text-right fs-6",
	                          id: "precio",
	                          disabled: !habilitadoBot,
	                          defaultValue: (0, _varios.formatMoneda)(item.preciomaxi.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtPrecio.current[index] = el;
	                          },
	                          onFocus: _varios.seleccionarCampo,
	                          onKeyUp: validarPrecio(index),
	                          onBlur: validarPrecio(index),
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-center p-0",
	                          style: { width: "30px" }
	                        },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            disabled: !habilitadoBot,
	                            onClick: eliminarProducto(item),
	                            className: "btn btn-sm btn-danger"
	                          },
	                          _react2.default.createElement("i", { className: "fa fa-trash" }),
	                          " "
	                        )
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Dimmer,
	          { active: activate, inverted: true },
	          _react2.default.createElement(
	            _semanticUiReact.Loader,
	            { inverted: true },
	            "cargando..."
	          )
	        ),
	        _react2.default.createElement(_mensajes.Mensaje, {
	          mensaje: mensaje,
	          onHide: function onHide() {
	            return mensaje.titulo === "Exito." ? blanquear() : setMensaje({
	              mostrar: false,
	              titulo: "",
	              texto: "",
	              icono: ""
	            });
	          }
	        }),
	        _react2.default.createElement(_mensajes.MensajeSiNo, {
	          mensaje: mensajesino,
	          onHideNo: function onHideNo() {
	            return setMensajesino({
	              mostrar: false,
	              titulo: "",
	              texto: "",
	              icono: ""
	            });
	          },
	          onHideSi: handleCloseSi
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12 row mt-3" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12 row m-0" },
	          _react2.default.createElement(
	            "button",
	            {
	              disabled: !habilitadoBot,
	              ref: btnIncluir,
	              onClick: onBotones(5),
	              className: "btn btn-sm col-2 btn-primary rounded-pill",
	              title: "Actualizar Precios"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-edit" },
	              " Actualizar "
	            ),
	            " "
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              ref: btnCancela,
	              disabled: !habilitadoBot,
	              onClick: onBotones(6),
	              className: "btn btn-sm rounded-pill btn-danger col-2 ml-auto"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-window-close" },
	              " Cancelar"
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7056 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActualizarProductos = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _core = __webpack_require__(19);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _varios = __webpack_require__(14);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _catalogoProductoUpdate = __webpack_require__(7037);
	
	var _catalogoProductoUpdate2 = _interopRequireDefault(_catalogoProductoUpdate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ActualizarProductos = exports.ActualizarProductos = function ActualizarProductos(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	
	  var txtId = (0, _react.useRef)([]);
	  var txtIdproducto = (0, _react.useRef)([]);
	  var txtCosto = (0, _react.useRef)([]);
	  var txtPrecio = (0, _react.useRef)([]);
	  var btnIncluir = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(true),
	      _useState2 = _slicedToArray(_useState, 2),
	      habilitadoBot = _useState2[0],
	      setHabilitadoBot = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(true),
	      _useState4 = _slicedToArray(_useState3, 2),
	      habilitadoProductos = _useState4[0],
	      setHabilitadoProductos = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      habilitadoMod = _useState6[0],
	      setHabilitadoMod = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      indice = _useState8[0],
	      setIndice = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mostrar = _useState10[0],
	      setMostrar = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      records = _useState12[0],
	      setRecords = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      activate = _useState14[0],
	      setActivate = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(null),
	      _useState16 = _slicedToArray(_useState15, 2),
	      body = _useState16[0],
	      setBody = _useState16[1];
	
	  var _useState17 = (0, _react.useState)("visible"),
	      _useState18 = _slicedToArray(_useState17, 2),
	      visibleBtn = _useState18[0],
	      setVisibleBtn = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      mensaje = _useState20[0],
	      setMensaje = _useState20[1];
	
	  var _useState21 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState22 = _slicedToArray(_useState21, 2),
	      mensajesino = _useState22[0],
	      setMensajesino = _useState22[1];
	
	  var headCells = [{ label: "CODIGO", textAlign: "center", width: "0px" }, { label: "DESCRIPCION", textAlign: "center" }, { label: "UNIDAD", textAlign: "center" }, { label: "COSTO", textAlign: "center" }, { label: "PRECIO", textAlign: "center" }, {
	    label: _react2.default.createElement("i", { className: "fas fa-trash" }),
	    textAlign: "center",
	    width: "20px"
	  }];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var seleccionarProducto = function seleccionarProducto(index, idprod) {
	    var campos = "*";
	    var nomtab = "seleccionar_productos_update_codigo('" + idprod + "')";
	    var orden = "idproducto";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var data = [].concat(_toConsumableArray(records));
	        if (response.data.length > 0) {
	          for (var i = 0; i < records.length; i++) {
	            if (records[i].idproducto === response.data[0].idproducto) {
	              setActivate(false);
	              setMensaje({
	                mostrar: true,
	                titulo: "Notificacion",
	                texto: "el producto ya ha sido seleccionado.",
	                icono: "error"
	              });
	              return;
	            }
	          }
	
	          if (index !== null) {
	            data[index] = {
	              idproducto: response.data[0].idproducto,
	              codigo: response.data[0].codigo,
	              nombre: response.data[0].nombre,
	              idtipoproducto: response.data[0].idtipoproducto,
	              idunidadmedida: response.data[0].idunidadmedida,
	              ivaventa: response.data[0].ivaventa,
	              tipoprecio: response.data[0].tipoprecio,
	              idunidadalterna: response.data[0].idunidadalterna,
	              idunidadventa: response.data[0].idunidadventa,
	              valorfactor: response.data[0].valorfactor,
	              tipofactor: response.data[0].tipofactor,
	              idmoneda: response.data[0].idmoneda,
	              valormoneda: response.data[0].valormoneda,
	              costo: response.data[0].costo,
	              costoalter: response.data[0].costoalter,
	              precio: response.data[0].precio,
	              precioalter: response.data[0].precioalter,
	              utilidad: response.data[0].utilidad,
	              utilidadalter: response.data[0].utilidadalter,
	              descripcionuni: response.data[0].descripcionuni,
	              descripcionunialt: response.data[0].descripcionunialt,
	              imagen: response.data[0].imagen
	            };
	          } else {
	            data.push({
	              idproducto: response.data[0].idproducto,
	              codigo: response.data[0].codigo,
	              nombre: response.data[0].nombre,
	              idtipoproducto: response.data[0].idtipoproducto,
	              idunidadmedida: response.data[0].idunidadmedida,
	              ivaventa: response.data[0].ivaventa,
	              tipoprecio: response.data[0].tipoprecio,
	              idunidadalterna: response.data[0].idunidadalterna,
	              idunidadventa: response.data[0].idunidadventa,
	              valorfactor: response.data[0].valorfactor,
	              tipofactor: response.data[0].tipofactor,
	              idmoneda: response.data[0].idmoneda,
	              valormoneda: response.data[0].valormoneda,
	              costo: response.data[0].costo,
	              costoalter: response.data[0].costoalter,
	              precio: response.data[0].precio,
	              precioalter: response.data[0].precioalter,
	              utilidad: response.data[0].utilidad,
	              utilidadalter: response.data[0].utilidadalter,
	              descripcionuni: response.data[0].descripcionuni,
	              descripcionunialt: response.data[0].descripcionunialt,
	              imagen: response.data[0].imagen
	            });
	          }
	          setRecords(data);
	          setIndice(index);
	
	          /*               if (index !== null) {
	              setTimeout(() => txtCantidad.current[index].focus(), 300);
	            } else {
	              setTimeout(
	                () => txtCantidad.current[data.length - 1].focus(),
	                300
	              );
	            } */
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "no existe un producto con ese codigo.",
	            icono: "error"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/cerveceria/actualizar/2";
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setRecords([]);
	        setMensaje({
	          mostrar: true,
	          titulo: "Exito.",
	          texto: response.data.contar + " registro modificado correctamente",
	          icono: "exito"
	        });
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.message,
	        icono: "error"
	      });
	    }).finally(function () {
	      return setActivate(false);
	    });
	  };
	
	  var validarCosto = function validarCosto(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        var data = [].concat(_toConsumableArray(records));
	        if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	          event.target.value = "0,00";
	        }
	        event.target.value = (0, _varios.formatoMonto)(event.target.value);
	        var char1 = event.target.value.substring(0, 1);
	        var char2 = event.target.value.substring(1, 2);
	        if (char1 === "0" && char2 !== ",") {
	          event.target.value = event.target.value.substring(1, event.target.value.length);
	        }
	        var canti = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	        data[index].costo = canti;
	        setRecords(data);
	      }
	    };
	  };
	
	  var validarPrecio = function validarPrecio(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        var data = [].concat(_toConsumableArray(records));
	        if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	          event.target.value = "0,00";
	        }
	        event.target.value = (0, _varios.formatoMonto)(event.target.value);
	        var char1 = event.target.value.substring(0, 1);
	        var char2 = event.target.value.substring(1, 2);
	        if (char1 === "0" && char2 !== ",") {
	          event.target.value = event.target.value.substring(1, event.target.value.length);
	        }
	        var canti = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	        data[index].precio = canti;
	        setRecords(data);
	      }
	    };
	  };
	
	  var validarIdProducto = function validarIdProducto(index) {
	    return function (event) {
	      if (event.which === 13 || typeof event.which === "undefined") {
	        if (event.target.value !== "") {
	          seleccionarProducto(index, event.target.value);
	          event.target.value = "";
	        }
	      }
	    };
	  };
	
	  var agregarProducto = function agregarProducto(producto) {
	    var data = [].concat(_toConsumableArray(records));
	    var sigue = true;
	    for (var i = 0; i < records.length; i++) {
	      if (records[i].idproducto === producto.idproducto) {
	        sigue = false;
	      }
	    }
	
	    if (sigue) {
	      if (indice !== null) {
	        data[indice] = producto;
	      } else {
	        data.push(producto);
	      }
	      setRecords(data);
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificacion",
	        texto: "el producto ya ha sido seleccionado.",
	        icono: "error"
	      });
	    }
	
	    setMostrar(false);
	  };
	
	  var seleccionarxIndice = function seleccionarxIndice(index) {
	    return function (e) {
	      e.preventDefault();
	      setMostrar(true);
	      setIndice(index);
	    };
	  };
	
	  var eliminarProducto = function eliminarProducto(producto) {
	    return function (e) {
	      e.preventDefault();
	      var data = [].concat(_toConsumableArray(records));
	      var elementos = [];
	
	      for (var i = 0; i < data.length; i++) {
	        if (producto.idproducto !== data[i].idproducto) {
	          elementos.push(data[i]);
	        }
	      }
	      setRecords(elementos);
	    };
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var productos = [];
	    for (var i = 0; i < records.length; i++) {
	      console.log(records[i]);
	
	      var labelcosto = "costoproveedor";
	      var labelprecio = "preciomaxi";
	      var labeluti = "utipreciomaxi";
	      var labelprecioalter = "preciomaxialter";
	      var labelcostoalter = "costoproveedoralter";
	      var labelutialter = "utipreciomaxialter";
	
	      var costo = parseFloat(records[i].costo);
	      var precio = parseFloat(records[i].precio);
	      var valorfactor = parseFloat(records[i].valorfactor);
	      var utilidad = (0, _varios.round)((precio - costo) / costo * 100);
	
	      if (parseInt(records[i].metodocosto) === 1) {
	        labelcosto = "costoproveedor";
	        labelcostoalter = "costoproveedoralter";
	      }
	      if (parseInt(records[i].metodocosto) === 2) {
	        labelcosto = "costocalculado";
	        labelcostoalter = "costocalculadoalter";
	      }
	      if (parseInt(records[i].metodocosto) === 3) {
	        labelcosto = "ultimocosto";
	        labelcostoalter = "ultimocostoalter";
	      }
	      if (parseInt(records[i].metodocosto) === 4) {
	        labelcosto = "costopromedio";
	        labelcostoalter = "costopromedioalter";
	      }
	
	      if (parseInt(records[i].tipoprecio) === 1) {
	        labelprecio = "preciomaxi";
	        labelprecioalter = "preciomaxialter";
	        labeluti = "utipreciomaxi";
	        labelutialter = "utipreciomaxialter";
	      }
	      if (parseInt(records[i].tipoprecio) === 2) {
	        labelprecio = "precioofe";
	        labelprecioalter = "precioofealter";
	        labeluti = "utiprecioofe";
	        labelutialter = "utiprecioofealter";
	      }
	      if (parseInt(records[i].tipoprecio) === 3) {
	        labelprecio = "preciomayor";
	        labelprecioalter = "preciomayoralter";
	        labeluti = "utipreciomayor";
	        labelutialter = "utipreciomayoralter";
	      }
	      if (parseInt(records[i].tipoprecio) === 4) {
	        labelprecio = "preciomini";
	        labelprecioalter = "preciominialter";
	        labeluti = "utipreciomini";
	        labelutialter = "utipreciominialter";
	      }
	
	      if (parseInt(records[i].tipofactor) === 1) {
	        var _productos$push;
	
	        productos.push((_productos$push = {
	          codigo: records[i].codigo
	        }, _defineProperty(_productos$push, labelcosto, costo), _defineProperty(_productos$push, labelprecio, precio), _defineProperty(_productos$push, labeluti, utilidad), _defineProperty(_productos$push, labelcostoalter, (0, _varios.round)(costo / valorfactor)), _defineProperty(_productos$push, labelprecioalter, (0, _varios.round)(precio / valorfactor)), _defineProperty(_productos$push, labelutialter, utilidad), _productos$push));
	      } else {
	        var _productos$push2;
	
	        productos.push((_productos$push2 = {
	          codigo: records[i].codigo
	        }, _defineProperty(_productos$push2, labelcosto, costo), _defineProperty(_productos$push2, labelprecio, precio), _defineProperty(_productos$push2, labeluti, utilidad), _productos$push2));
	      }
	    }
	
	    setBody({ productos: JSON.stringify(productos) });
	
	    setMensajesino({
	      mostrar: true,
	      titulo: "Confirmación.",
	      texto: "Esta Seguro de Modificar estos Productos?",
	      icono: "confirmacion"
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setHabilitadoBot(true);
	    setHabilitadoProductos(true);
	    setVisibleBtn("visible");
	    setRecords([]);
	    setBody(null);
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        setHabilitadoBot(false);
	        setVisibleBtn("hidden");
	        setHabilitadoMod(true);
	        setHabilitadoProductos(false);
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        blanquear();
	      }
	    };
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHide();
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "xl",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {}
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        _Modal2.default.Title,
	        { style: { color: "#fff" } },
	        "Actualizar Precios "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          onClick: cancelar,
	          ref: btnCancela,
	          className: "btn btn-sm text-light"
	        },
	        _react2.default.createElement("i", { className: "fas fa-times fa-1x shadow" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(
	        "div",
	        { style: { height: "100%", width: "100%" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row col-md-12 ", style: { margin: 0 } },
	          _react2.default.createElement(
	            "div",
	            { className: "row col-md-12 py-2", style: { margin: 0 } },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 border-azul px-0 rounded",
	                style: { backgroundColor: "#d5e9ff" }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "input-group input-group-sm m-2",
	                  style: { width: 150 }
	                },
	                _react2.default.createElement("input", {
	                  type: "text",
	                  disabled: habilitadoProductos,
	                  ref: txtIdproducto,
	                  placeholder: "CODIGO",
	                  style: {
	                    borderBottomRightRadius: 0,
	                    borderTopRightRadius: 0
	                  },
	                  className: "form-control form-control-sm bg-light text-right fs-6 col-pd-110",
	                  onChange: function onChange(e) {
	                    return e.target.value = e.target.value.toUpperCase();
	                  },
	                  onKeyUp: validarIdProducto(null),
	                  onBlur: validarIdProducto(null)
	                }),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    disabled: habilitadoProductos,
	                    style: {
	                      borderBottomLeftRadius: 0,
	                      borderTopLeftRadius: 0
	                    },
	                    onClick: function onClick() {
	                      return setMostrar(true);
	                    },
	                    className: "btn btn-sm btn-primary"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas " },
	                    "-"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 400,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px",
	                    fontSizeAdjust: "0.6"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden" },
	                  records && records.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      { key: index, style: { padding: "0" } },
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "bg-light d-flex align-items-between px-0",
	                          style: { maxWidth: "500px" }
	                        },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          style: {
	                            borderBottomRightRadius: 0,
	                            borderTopRightRadius: 0
	                          },
	                          disabled: habilitadoProductos,
	                          ref: function ref(el) {
	                            return txtId.current[index] = el;
	                          },
	                          className: "form-control form-control-sm bg-light fs-6 col-pd-110",
	                          defaultValue: item.codigo,
	                          onChange: function onChange(e) {
	                            return e.target.value = e.target.value.toUpperCase();
	                          },
	                          onKeyUp: validarIdProducto(index),
	                          onBlur: validarIdProducto(index)
	                        }),
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            type: "button",
	                            style: {
	                              borderBottomLeftRadius: 0,
	                              borderTopLeftRadius: 0
	                            },
	                            disabled: habilitadoProductos,
	                            onClick: seleccionarxIndice(index),
	                            className: "btn btn-sm btn-primary"
	                          },
	                          _react2.default.createElement(
	                            "i",
	                            { className: "fas " },
	                            "-"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-start p-0 pl-2"
	                        },
	                        item.nombre
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-center p-0 col-pd-100" },
	                        item.descripcionuni
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-center p-0 col-pd-90" },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control form-control-sm bg-light text-right fs-6",
	                          id: "costo",
	                          disabled: !habilitadoMod,
	                          defaultValue: (0, _varios.formatMoneda)(item.costo.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtCosto.current[index] = el;
	                          },
	                          onFocus: _varios.seleccionarCampo,
	                          onKeyUp: validarCosto(index),
	                          onBlur: validarCosto(index),
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-center p-0 col-pd-90" },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control form-control-sm bg-light text-right fs-6",
	                          id: "precio",
	                          disabled: !habilitadoMod,
	                          defaultValue: (0, _varios.formatMoneda)(item.precio.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtPrecio.current[index] = el;
	                          },
	                          onFocus: _varios.seleccionarCampo,
	                          onKeyUp: validarPrecio(index),
	                          onBlur: validarPrecio(index),
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-center p-0",
	                          style: { width: "30px" }
	                        },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            disabled: habilitadoProductos,
	                            onClick: eliminarProducto(item),
	                            className: "btn btn-sm btn-danger"
	                          },
	                          _react2.default.createElement("i", { className: "fa fa-trash" }),
	                          " "
	                        )
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_catalogoProductoUpdate2.default, {
	          show: mostrar,
	          onHideCancelar: function onHideCancelar() {
	            setMostrar(false);
	          },
	          onHideAceptaCatalogo: agregarProducto
	        }),
	        _react2.default.createElement(
	          _semanticUiReact.Dimmer,
	          { active: activate, inverted: true },
	          _react2.default.createElement(
	            _semanticUiReact.Loader,
	            { inverted: true },
	            "cargando..."
	          )
	        ),
	        _react2.default.createElement(_mensajes.Mensaje, {
	          mensaje: mensaje,
	          onHide: function onHide() {
	            return mensaje.titulo === "Exito." ? blanquear() : setMensaje({
	              mostrar: false,
	              titulo: "",
	              texto: "",
	              icono: ""
	            });
	          }
	        }),
	        _react2.default.createElement(_mensajes.MensajeSiNo, {
	          mensaje: mensajesino,
	          onHideNo: function onHideNo() {
	            return setMensajesino({
	              mostrar: false,
	              titulo: "",
	              texto: "",
	              icono: ""
	            });
	          },
	          onHideSi: handleCloseSi
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12 row mt-3" },
	        visibleBtn === "visible" ? _react2.default.createElement(
	          "div",
	          { className: "col-pd-520" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row m-0" },
	            _react2.default.createElement(
	              "button",
	              {
	                disabled: !habilitadoBot,
	                ref: btnIncluir,
	                onClick: onBotones(1),
	                className: "btn btn-sm col btn-primary rounded-pill",
	                title: "Actualizar Precios"
	              },
	              _react2.default.createElement(
	                "i",
	                { className: "fas fa-edit" },
	                " Actualizar "
	              ),
	              " "
	            )
	          )
	        ) : _react2.default.createElement(
	          "div",
	          { className: "col-pd-540 row m-0 ml-auto" },
	          _react2.default.createElement(
	            "button",
	            {
	              ref: btnAcepta,
	              onClick: onBotones(5),
	              className: "btn btn-sm rounded-pill btn-success col mx-1"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-check-circle" },
	              " Aceptar"
	            )
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              ref: btnCancela,
	              disabled: habilitadoBot,
	              onClick: onBotones(6),
	              className: "btn btn-sm rounded-pill btn-danger col"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-window-close" },
	              " Cancelar"
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalEditarProductosOperacion = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _gestionarTipoProducto = __webpack_require__(297);
	
	var _gestionarMarca = __webpack_require__(211);
	
	var _gestionarModelo = __webpack_require__(212);
	
	var _varios = __webpack_require__(14);
	
	var _gestionarUnidadMedida = __webpack_require__(213);
	
	var _gestionarFabricante = __webpack_require__(296);
	
	var _gestionarClasificadorVacios = __webpack_require__(302);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalEditarProductosOperacion = exports.ModalEditarProductosOperacion = function ModalEditarProductosOperacion(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var organizacion = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var accbtnproducto = JSON.parse(sessionStorage.getItem("accbtnproductoc"));
	  /* bloquear tab */
	
	  var _useState = (0, _react.useState)({ tab1: "tab", tab2: "" }),
	      _useState2 = _slicedToArray(_useState, 2),
	      tabIndex = _useState2[0],
	      setTabIndex = _useState2[1];
	  /* activar tab */
	
	
	  var _useState3 = (0, _react.useState)({
	    tab1: "nav-link active text-light bg-blue-100 rounded",
	    tab2: "nav-link text-light bg-blue-200 rounded"
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activeTab = _useState4[0],
	      setACtiveTab = _useState4[1];
	  /* mostar tabPanel */
	
	
	  var _useState5 = (0, _react.useState)({
	    tab1: "tab-pane fade show active",
	    tab2: "tab-pane fade"
	  }),
	      _useState6 = _slicedToArray(_useState5, 2),
	      tabPanel = _useState6[0],
	      setTabPanel = _useState6[1];
	  /* validar tab */
	
	
	  var _useState7 = (0, _react.useState)({ tab1: "true", tab2: "false" }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      tabvalid = _useState8[0],
	      setTabValid = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({
	    max: 0,
	    ofe: 0,
	    may: 0,
	    min: 0,
	    maxalt: 0,
	    ofealt: 0,
	    mayalt: 0,
	    minalt: 0
	  }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      alerta = _useState10[0],
	      setAlerta = _useState10[1];
	
	  var btnIncluir = (0, _react.useRef)();
	  var btnEditar = (0, _react.useRef)();
	  var btnEliminar = (0, _react.useRef)();
	  var btnConsultar = (0, _react.useRef)();
	  var btnAceptar = (0, _react.useRef)();
	  var btnCancelar = (0, _react.useRef)();
	  var txtIdproducto = (0, _react.useRef)();
	  var txtIdproductoHidden = (0, _react.useRef)();
	  //const txtCodigo = useRef();
	  var txtNombre = (0, _react.useRef)();
	  var txtNombreCorto = (0, _react.useRef)();
	  var cmbMarca = (0, _react.useRef)();
	  var cmbModelo = (0, _react.useRef)();
	  var cmbMoneda = (0, _react.useRef)();
	  var cmbTipoProd = (0, _react.useRef)();
	  var cmbFabricante = (0, _react.useRef)();
	  var txtReferencia = (0, _react.useRef)();
	  var txtDiasGar = (0, _react.useRef)();
	  var cmbUnidMedida = (0, _react.useRef)();
	  var txtCostoProveSinImp = (0, _react.useRef)();
	  var txtCostoCalcuSinImp = (0, _react.useRef)();
	  var txtUltimoCostoSinImp = (0, _react.useRef)();
	  var txtCostoPromeSinImp = (0, _react.useRef)();
	  var cmbMetodoCosto = (0, _react.useRef)();
	  var cmbPrecioVenta = (0, _react.useRef)();
	  var txtCostoProveConImp = (0, _react.useRef)();
	  var txtCostoCalcuConImp = (0, _react.useRef)();
	  var txtUltimoCostoConImp = (0, _react.useRef)();
	  var txtCostoPromeConImp = (0, _react.useRef)();
	  var txtIvaCompra = (0, _react.useRef)();
	  var txtIvaVenta = (0, _react.useRef)();
	  var txtPrecioMaxiSinImp = (0, _react.useRef)();
	  var txtPrecioOfeSinImp = (0, _react.useRef)();
	  var txtPrecioMayorSinImp = (0, _react.useRef)();
	  var txtPrecioMiniSinImp = (0, _react.useRef)();
	  var txtUtilidadMaxi = (0, _react.useRef)();
	  var txtUtilidadOfe = (0, _react.useRef)();
	  var txtUtilidadMayor = (0, _react.useRef)();
	  var txtUtilidadMini = (0, _react.useRef)();
	  var txtPrecioMaxiConImp = (0, _react.useRef)();
	  var txtPrecioOfeConImp = (0, _react.useRef)();
	  var txtPrecioMayorConImp = (0, _react.useRef)();
	  var txtPrecioMiniConImp = (0, _react.useRef)();
	  var radioSi = (0, _react.useRef)();
	  var radioNo = (0, _react.useRef)();
	  var chkServicio = (0, _react.useRef)();
	  var txtVacio = (0, _react.useRef)();
	  var txtCodigoVacio = (0, _react.useRef)();
	  var txtStockMini = (0, _react.useRef)();
	  var cmbUniVenta = (0, _react.useRef)();
	  var cmbUniCompra = (0, _react.useRef)();
	  var cmbUniPrincipal = (0, _react.useRef)();
	  var cmbUniAlterna = (0, _react.useRef)();
	  var cmbAlmacen = (0, _react.useRef)();
	  var txtFactor = (0, _react.useRef)();
	  var cmbUniFactor = (0, _react.useRef)();
	  var txtCostoProveSinImpAlter = (0, _react.useRef)();
	  var txtCostoCalcuSinImpAlter = (0, _react.useRef)();
	  var txtUltimoCostoSinImpAlter = (0, _react.useRef)();
	  var txtCostoPromeSinImpAlter = (0, _react.useRef)();
	  var txtCostoProveConImpAlter = (0, _react.useRef)();
	  var txtCostoCalcuConImpAlter = (0, _react.useRef)();
	  var txtUltimoCostoConImpAlter = (0, _react.useRef)();
	  var txtCostoPromeConImpAlter = (0, _react.useRef)();
	  var txtPrecioMaxiSinImpAlter = (0, _react.useRef)();
	  var txtPrecioOfeSinImpAlter = (0, _react.useRef)();
	  var txtPrecioMayorSinImpAlter = (0, _react.useRef)();
	  var txtPrecioMiniSinImpAlter = (0, _react.useRef)();
	  var txtUtilidadMaxiAlter = (0, _react.useRef)();
	  var txtUtilidadOfeAlter = (0, _react.useRef)();
	  var txtUtilidadMayorAlter = (0, _react.useRef)();
	  var txtUtilidadMiniAlter = (0, _react.useRef)();
	  var txtPrecioMaxiConImpAlter = (0, _react.useRef)();
	  var txtPrecioOfeConImpAlter = (0, _react.useRef)();
	  var txtPrecioMayorConImpAlter = (0, _react.useRef)();
	  var txtPrecioMiniConImpAlter = (0, _react.useRef)();
	
	  var _useState11 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mensaje = _useState12[0],
	      setMensaje = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensajesino = _useState14[0],
	      setMensajesino = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      activate = _useState16[0],
	      setActivate = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      habilitado = _useState18[0],
	      setHabilitado = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(false),
	      _useState20 = _slicedToArray(_useState19, 2),
	      body = _useState20[0],
	      setBody = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(false),
	      _useState22 = _slicedToArray(_useState21, 2),
	      habilitadoAlter = _useState22[0],
	      setHabilitadoAlter = _useState22[1];
	
	  var _useState23 = (0, _react.useState)("visible"),
	      _useState24 = _slicedToArray(_useState23, 2),
	      visibleA = _useState24[0],
	      setVisibleA = _useState24[1];
	
	  var _useState25 = (0, _react.useState)("1"),
	      _useState26 = _slicedToArray(_useState25, 2),
	      costoSelect = _useState26[0],
	      setCostoSelect = _useState26[1];
	
	  var _useState27 = (0, _react.useState)("1"),
	      _useState28 = _slicedToArray(_useState27, 2),
	      precioSelect = _useState28[0],
	      setPrecioSelect = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(["0", "10", "20", "30", "40", "50", "60", "70", "80", "90", "100"]),
	      _useState30 = _slicedToArray(_useState29, 2),
	      flujo = _useState30[0],
	      setFlujo = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(false),
	      _useState32 = _slicedToArray(_useState31, 2),
	      mostrarMarca = _useState32[0],
	      setMostrarMarca = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(false),
	      _useState34 = _slicedToArray(_useState33, 2),
	      mostrarModelo = _useState34[0],
	      setMostrarModelo = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(false),
	      _useState36 = _slicedToArray(_useState35, 2),
	      mostrarTipoP = _useState36[0],
	      setMostrarTipoP = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(false),
	      _useState38 = _slicedToArray(_useState37, 2),
	      mostrarFabricante = _useState38[0],
	      setMostrarFabricante = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(false),
	      _useState40 = _slicedToArray(_useState39, 2),
	      mostrarclassvacio = _useState40[0],
	      setMostrarclassvacio = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(false),
	      _useState42 = _slicedToArray(_useState41, 2),
	      mostrarMedida = _useState42[0],
	      setMostrarMedida = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(1),
	      _useState44 = _slicedToArray(_useState43, 2),
	      operacion = _useState44[0],
	      setOperacion = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(0),
	      _useState46 = _slicedToArray(_useState45, 2),
	      valvacio = _useState46[0],
	      setValvacio = _useState46[1];
	
	  var _useState47 = (0, _react.useState)([]),
	      _useState48 = _slicedToArray(_useState47, 2),
	      unidadM = _useState48[0],
	      setUnidadM = _useState48[1];
	
	  var _useState49 = (0, _react.useState)([]),
	      _useState50 = _slicedToArray(_useState49, 2),
	      classvacios = _useState50[0],
	      setClassvacios = _useState50[1];
	
	  var _useState51 = (0, _react.useState)([]),
	      _useState52 = _slicedToArray(_useState51, 2),
	      tipoP = _useState52[0],
	      setTipoP = _useState52[1];
	
	  var _useState53 = (0, _react.useState)([]),
	      _useState54 = _slicedToArray(_useState53, 2),
	      fabri = _useState54[0],
	      setFabri = _useState54[1];
	
	  var _useState55 = (0, _react.useState)([]),
	      _useState56 = _slicedToArray(_useState55, 2),
	      marca = _useState56[0],
	      setMarca = _useState56[1];
	
	  var _useState57 = (0, _react.useState)([]),
	      _useState58 = _slicedToArray(_useState57, 2),
	      modelo = _useState58[0],
	      setModelo = _useState58[1];
	
	  var _useState59 = (0, _react.useState)([]),
	      _useState60 = _slicedToArray(_useState59, 2),
	      unidadV = _useState60[0],
	      setUnidadV = _useState60[1];
	
	  var _useState61 = (0, _react.useState)([]),
	      _useState62 = _slicedToArray(_useState61, 2),
	      unidadC = _useState62[0],
	      setUnidadC = _useState62[1];
	
	  var _useState63 = (0, _react.useState)([]),
	      _useState64 = _slicedToArray(_useState63, 2),
	      factor = _useState64[0],
	      setFactor = _useState64[1];
	
	  var _useState65 = (0, _react.useState)([]),
	      _useState66 = _slicedToArray(_useState65, 2),
	      combomoneda = _useState66[0],
	      setComboMoneda = _useState66[1];
	
	  var _useState67 = (0, _react.useState)({
	    idmoneda: "1",
	    descripcion: "BOLIVARES",
	    simbolo: "Bs",
	    predeterminada: true,
	    subpredeterminada: false,
	    valormoneda: 1.0
	  }),
	      _useState68 = _slicedToArray(_useState67, 2),
	      moneda = _useState68[0],
	      setMoneda = _useState68[1];
	
	  var _useState69 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState70 = _slicedToArray(_useState69, 2),
	      monedaSub = _useState70[0],
	      setMonedaSub = _useState70[1];
	
	  var _useState71 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState72 = _slicedToArray(_useState71, 2),
	      monedaCambio = _useState72[0],
	      setMonedaCambio = _useState72[1];
	
	  var _useState73 = (0, _react.useState)({
	    imagen: "subir.png",
	    imagenactual: "subir.png"
	  }),
	      _useState74 = _slicedToArray(_useState73, 2),
	      imagen = _useState74[0],
	      setImagen = _useState74[1];
	
	  var _useState75 = (0, _react.useState)({
	    imagen: op.conexion + '/imagen?img=subir.png'
	  }),
	      _useState76 = _slicedToArray(_useState75, 2),
	      pathImage = _useState76[0],
	      setPathImage = _useState76[1];
	
	  var _useState77 = (0, _react.useState)("visible"),
	      _useState78 = _slicedToArray(_useState77, 2),
	      visibleBtn = _useState78[0],
	      setVisibleBtn = _useState78[1];
	
	  var _useState79 = (0, _react.useState)(window.innerWidth),
	      _useState80 = _slicedToArray(_useState79, 2),
	      windowWidth = _useState80[0],
	      setWindowWidth = _useState80[1];
	
	  var _useState81 = (0, _react.useState)({
	    idproducto: "",
	    codigo: "",
	    nombre: "",
	    preciomax: "",
	    unidadalterna: "",
	    unidadmedida: ""
	  }),
	      _useState82 = _slicedToArray(_useState81, 2),
	      producto = _useState82[0],
	      setProducto = _useState82[1];
	
	  var seleccionarMonedas = function seleccionarMonedas() {
	    var campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	    var nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	    var orden = "m.idmoneda";
	
	    var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var x = 0;
	        if (response.data.length > 0) {
	          setComboMoneda(response.data);
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].subpredeterminada) {
	              setMonedaSub(response.data[i]);
	              setMonedaCambio({
	                idmoneda: response.data[i].idmoneda,
	                descripcion: response.data[i].descripcion,
	                simbolo: response.data[i].simbolo,
	                predeterminada: response.data[i].predeterminada,
	                subpredeterminada: response.data[i].subpredeterminada,
	                valormoneda: 1.0
	              });
	              x = i;
	            } else if (response.data[i].predeterminada) {
	              setMoneda(response.data[i]);
	            }
	          }
	          seleccionarUnidadMedida(props.ope);
	        }
	        setTimeout(function () {
	          return cmbMoneda.current.selectedIndex = x;
	        }, 200);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	  var seleccionarTipoProd = function seleccionarTipoProd() {
	    var campos = "*";
	    var nomtab = "tipoproducto";
	    var orden = "descripcion";
	    var endpoint = op.conexion + ('/api/comun/seleccionaregistros?campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden);
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setTipoP(response.data);
	        cmbTipoProd.current.selectedIndex = -1;
	      }
	      seleccionarFabricante();
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	  var seleccionarFabricante = function seleccionarFabricante() {
	    var campos = "*";
	    var nomtab = "fabricante";
	    var orden = "descripcion";
	    var endpoint = op.conexion + ('/api/comun/seleccionaregistros?campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden);
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setFabri(response.data);
	        cmbFabricante.current.selectedIndex = -1;
	      }
	      seleccionarMarca();
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	  var seleccionarUnidadMedida = function seleccionarUnidadMedida(ope) {
	    var campos = "*";
	    var nomtab = "unidadmedida";
	    var orden = "idunidadmedida";
	    var endpoint = op.conexion + ('/api/comun/seleccionaregistros?campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden);
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setUnidadM(response.data);
	        if (ope === 1) {
	          cmbUniPrincipal.current.selectedIndex = 0;
	          cmbUnidMedida.current.selectedIndex = 0;
	        } else {
	          cmbUniPrincipal.current.selectedIndex = -1;
	          cmbUnidMedida.current.selectedIndex = -1;
	        }
	        cmbUniAlterna.current.selectedIndex = -1;
	      }
	      seleccionarTipoProd();
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var agregarUnidad = function agregarUnidad() {
	    seleccionarUnidadMedida(1);
	  };
	
	  var seleccionarClassVacios = function seleccionarClassVacios(ope, idclas) {
	    var campos = "*";
	    var nomtab = "clasevacio";
	    var orden = "idclasevacio";
	    var endpoint = op.conexion + ('/api/comun/seleccionaregistros?campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden);
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setClassvacios(response.data);
	        txtCodigoVacio.current.selectedIndex = -1;
	        if (ope === 1) {
	          txtCodigoVacio.current.value = idclas;
	        } else {
	          txtCodigoVacio.current.value = "";
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var seleccionarMarca = function seleccionarMarca() {
	    var campos = "*";
	    var nomtab = "marca";
	    var orden = "descripcion";
	    var endpoint = op.conexion + ('/api/comun/seleccionaregistros?campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden);
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setMarca(response.data);
	        cmbMarca.current.selectedIndex = 0;
	      }
	      seleccionarModelo();
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var seleccionarModelo = function seleccionarModelo() {
	    var campos = "*";
	    var nomtab = "modelo";
	    var orden = "descripcion";
	    var endpoint = op.conexion + ('/api/comun/seleccionaregistros?campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden);
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setModelo(response.data);
	        cmbModelo.current.selectedIndex = 0;
	        if (response.data !== '') {
	          seleccionarRegistro(props.idproduct);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var abrirModal = function abrirModal(tipo) {
	    return function (e) {
	      e.preventDefault();
	      if (tipo === "marca") {
	        setMostrarMarca(true);
	      } else if (tipo === "modelo") {
	        setMostrarModelo(true);
	      } else if (tipo === "tipop") {
	        setMostrarTipoP(true);
	      } else if (tipo === "medida") {
	        setMostrarMedida(true);
	      } else if (tipo === "fabricante") {
	        setMostrarFabricante(true);
	      } else if (tipo === "classvacios") {
	        setMostrarclassvacio(true);
	      }
	    };
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var blanquear = function blanquear() {
	    setFlujo(["0", "10", "20", "30", "40", "50", "60", "70", "80", "90", "100"]);
	    setValvacio(0);
	    setActivate(false);
	    setBody();
	    setHabilitado(false);
	    setUnidadM([]);
	    setTipoP([]);
	    setFabri([]);
	    setMarca([]);
	    setModelo([]);
	    setAlerta({
	      max: 0,
	      ofe: 0,
	      may: 0,
	      min: 0,
	      maxalt: 0,
	      ofealt: 0,
	      mayalt: 0,
	      minalt: 0
	    });
	    setCostoSelect("1");
	    setPrecioSelect("1");
	    setMonedaCambio({
	      idmoneda: "4",
	      descripcion: "DOLAR",
	      simbolo: "$",
	      predeterminada: false,
	      subpredeterminada: true,
	      valormoneda: 1.0
	    });
	
	    for (var i = 0; i < combomoneda.length; i++) {
	      if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
	        cmbMoneda.current.selectedIndex = i;
	      }
	    }
	    setVisibleBtn("visible");
	    txtIdproducto.current.value = "";
	    txtVacio.current.checked = false;
	    txtNombre.current.value = "";
	    txtNombreCorto.current.value = "";
	    txtReferencia.current.value = "";
	    txtDiasGar.current.value = "";
	    txtIvaCompra.current.value = "";
	    txtIvaVenta.current.value = "";
	    txtCostoProveSinImp.current.value = "";
	    txtCostoCalcuSinImp.current.value = "";
	    txtUltimoCostoSinImp.current.value = "";
	    txtCostoPromeSinImp.current.value = "";
	    txtCostoProveConImp.current.value = "";
	    txtCostoCalcuConImp.current.value = "";
	    txtUltimoCostoConImp.current.value = "";
	    txtCostoPromeConImp.current.value = "";
	    txtPrecioMaxiSinImp.current.value = "";
	    txtPrecioOfeSinImp.current.value = "";
	    txtPrecioMayorSinImp.current.value = "";
	    txtPrecioMiniSinImp.current.value = "";
	    txtPrecioMaxiSinImp.current.style.color = "#000000";
	    txtPrecioOfeSinImp.current.style.color = "#000000";
	    txtPrecioMayorSinImp.current.style.color = "#000000";
	    txtPrecioMiniSinImp.current.style.color = "#000000";
	    txtPrecioMaxiConImp.current.value = "";
	    txtPrecioOfeConImp.current.value = "";
	    txtPrecioMayorConImp.current.value = "";
	    txtPrecioMiniConImp.current.value = "";
	    txtUtilidadMaxi.current.value = "";
	    txtUtilidadOfe.current.value = "";
	    txtUtilidadMayor.current.value = "";
	    txtUtilidadMini.current.value = "";
	    chkServicio.current.checked = false;
	    cmbAlmacen.current.value = "true";
	    txtStockMini.current.value = "0,00";
	    setVisibleA("visible");
	    cmbPrecioVenta.current.value = "1";
	    cmbMetodoCosto.current.value = "1";
	    cmbMarca.current.selectedIndex = -1;
	    cmbModelo.current.selectedIndex = -1;
	
	    radioSi.current.checked = false;
	    radioNo.current.checked = false;
	  };
	
	  var blanquearAlter = function blanquearAlter() {
	    setValvacio(0);
	    setAlerta(Object.assign({}, alerta, {
	      maxalt: 0,
	      ofealt: 0,
	      mayalt: 0,
	      minalt: 0
	    }));
	    setHabilitadoAlter(false);
	    txtCostoProveSinImpAlter.current.value = "";
	    txtCostoCalcuSinImpAlter.current.value = "";
	    txtUltimoCostoSinImpAlter.current.value = "";
	    txtCostoPromeSinImpAlter.current.value = "";
	    txtCostoProveConImpAlter.current.value = "";
	    txtCostoCalcuConImpAlter.current.value = "";
	    txtUltimoCostoConImpAlter.current.value = "";
	    txtCostoPromeConImpAlter.current.value = "";
	    txtPrecioMaxiSinImpAlter.current.value = "";
	    txtPrecioOfeSinImpAlter.current.value = "";
	    txtPrecioMayorSinImpAlter.current.value = "";
	    txtPrecioMiniSinImpAlter.current.value = "";
	    txtPrecioMaxiConImpAlter.current.value = "";
	    txtPrecioOfeConImpAlter.current.value = "";
	    txtPrecioMayorConImpAlter.current.value = "";
	    txtPrecioMiniConImpAlter.current.value = "";
	    txtUtilidadMaxiAlter.current.value = "";
	    txtUtilidadOfeAlter.current.value = "";
	    txtUtilidadMayorAlter.current.value = "";
	    txtUtilidadMiniAlter.current.value = "";
	    txtFactor.current.value = "";
	    txtPrecioMaxiSinImpAlter.current.style.color = "#000000";
	    txtPrecioOfeSinImpAlter.current.style.color = "#000000";
	    txtPrecioMayorSinImpAlter.current.style.color = "#000000";
	    txtPrecioMiniSinImpAlter.current.style.color = "#000000";
	    txtVacio.current.checked = false;
	    setFactor([]);
	    setUnidadC([]);
	    setUnidadV([]);
	    cmbUniPrincipal.current.selectedIndex = -1;
	    cmbUniAlterna.current.selectedIndex = -1;
	  };
	
	  var handleInputMontoChange = function handleInputMontoChange(event) {
	    (0, _varios.validaMonto)(event);
	
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	        event.target.value = "0,00";
	      }
	      event.target.value = (0, _varios.formatoMonto)(event.target.value);
	      var char1 = event.target.value.substring(0, 1);
	      var char2 = event.target.value.substring(1, 2);
	      if (char1 === "0" && char2 !== ",") {
	        event.target.value = event.target.value.substring(1, event.target.value.legth);
	      }
	
	      if (event.target.id === "costoProveSinImpu") {
	        calcularImpuestosCostos();
	        if (event.which === 13) {
	          txtCostoCalcuSinImp.current.focus();
	        }
	      } else if (event.target.id === "costoCalcuSinImpu") {
	        calcularImpuestosCostos();
	        if (event.which === 13) {
	          txtUltimoCostoSinImp.current.focus();
	        }
	      } else if (event.target.id === "costoUltiSinImpu") {
	        calcularImpuestosCostos();
	        if (event.which === 13) {
	          txtCostoPromeSinImp.current.focus();
	        }
	      } else if (event.target.id === "costoPromeSinImpu") {
	        calcularImpuestosCostos();
	        if (event.which === 13) {
	          txtPrecioMaxiSinImp.current.focus();
	        }
	      } else if (event.target.id === "preciomaximo") {
	        calcularUtilidadxValor(1);
	        if (event.which === 13) {
	          txtPrecioOfeSinImp.current.focus();
	        }
	      } else if (event.target.id === "preciooferta") {
	        calcularUtilidadxValor(2);
	        if (event.which === 13) {
	          txtPrecioMayorSinImp.current.focus();
	        }
	      } else if (event.target.id === "preciomayor") {
	        calcularUtilidadxValor(3);
	        if (event.which === 13) {
	          txtPrecioMiniSinImp.current.focus();
	        }
	      } else if (event.target.id === "preciominimo") {
	        calcularUtilidadxValor(4);
	      } else if (event.target.id === "utilidadMaxi") {
	        calcularUtilidadxPorce(1);
	      } else if (event.target.id === "utilidadOfe") {
	        calcularUtilidadxPorce(2);
	      } else if (event.target.id === "utilidadMayor") {
	        calcularUtilidadxPorce(3);
	      } else if (event.target.id === "utilidadMini") {
	        calcularUtilidadxPorce(4);
	      } else if (event.target.id === "costoProveSinImpuAlter") {
	        calcularImpuestosCostosAlter();
	        if (event.which === 13) {
	          txtCostoCalcuSinImpAlter.current.focus();
	        }
	      } else if (event.target.id === "costoCalcuSinImpuAlter") {
	        calcularImpuestosCostosAlter();
	        if (event.which === 13) {
	          txtUltimoCostoSinImpAlter.current.focus();
	        }
	      } else if (event.target.id === "costoUltiSinImpuAlter") {
	        calcularImpuestosCostosAlter();
	        if (event.which === 13) {
	          txtCostoPromeSinImpAlter.current.focus();
	        }
	      } else if (event.target.id === "costoPromeSinImpuAlter") {
	        calcularImpuestosCostosAlter();
	        if (event.which === 13) {
	          txtUtilidadMaxiAlter.current.focus();
	        }
	      } else if (event.target.id === "preciomaximoalter") {
	        calcularUtilidadxValorAlter(1);
	      } else if (event.target.id === "precioofertaalter") {
	        calcularUtilidadxValorAlter(2);
	      } else if (event.target.id === "preciomayoralter") {
	        calcularUtilidadxValorAlter(3);
	      } else if (event.target.id === "preciominialter") {
	        calcularUtilidadxValorAlter(4);
	      } else if (event.target.id === "utilidadMaxiAlter") {
	        calcularUtilidadAlter(1);
	      } else if (event.target.id === "utilidadOfeAlter") {
	        calcularUtilidadAlter(2);
	      } else if (event.target.id === "utilidadMayorAlter") {
	        calcularUtilidadAlter(3);
	      } else if (event.target.id === "utilidadMiniAlter") {
	        calcularUtilidadAlter(4);
	      } else if (event.target.id === "ivaCompra") {
	        calcularImpuestosCostos();
	        if (cmbUniFactor.current.selectedIndex >= 0) {
	          calcularFactorConversion();
	          calcularImpuestosCostosAlter();
	        }
	        if (event.which === 13) {
	          txtIvaVenta.current.focus();
	        }
	      } else if (event.target.id === "ivaVenta") {
	        calcularUtilidadxValor(5);
	        if (cmbUniFactor.current.selectedIndex >= 0) {
	          calcularFactorConversion();
	          calcularImpuestosCostosAlter();
	        }
	      } else if (event.target.id === "stockminimo") {
	        txtCostoProveSinImp.current.focus();
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    if (event.which === 13) {
	      if (event.target.id === "inputCodigo") {
	        txtNombre.current.focus();
	      } else if (event.target.id === "inputNombre") {
	        txtReferencia.current.focus();
	      } else if (event.target.id === "inputRefe") {
	        txtNombreCorto.current.focus();
	      } else if (event.target.id === "inputNombreCorto") {
	        cmbTipoProd.current.focus();
	      } else if (event.target.id === "inputDiasGar") {
	        cmbMarca.current.focus();
	      }
	    } else if (typeof event.which === "undefined") {
	      return false;
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var calcularImpuestosCostos = function calcularImpuestosCostos() {
	    var costoProv = 0.0,
	        costoCal = 0.0,
	        costoUlt = 0.0,
	        costoProm = 0.0;
	    var valIva = parseFloat(txtIvaCompra.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	    if (txtCostoProveSinImp.current.value.trim() !== "") {
	      costoProv = (1 + valIva) * parseFloat(txtCostoProveSinImp.current.value.replace(/\./g, "").replace(",", "."));
	      txtCostoProveConImp.current.value = (0, _varios.formatMoneda)(costoProv.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtCostoCalcuSinImp.current.value.trim() !== "") {
	      costoCal = (1 + valIva) * parseFloat(txtCostoCalcuSinImp.current.value.replace(/\./g, "").replace(",", "."));
	      txtCostoCalcuConImp.current.value = (0, _varios.formatMoneda)(costoCal.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtUltimoCostoSinImp.current.value.trim() !== "") {
	      costoUlt = (1 + valIva) * parseFloat(txtUltimoCostoSinImp.current.value.replace(/\./g, "").replace(",", "."));
	      txtUltimoCostoConImp.current.value = (0, _varios.formatMoneda)(costoUlt.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtCostoPromeSinImp.current.value.trim() !== "") {
	      costoProm = (1 + valIva) * parseFloat(txtCostoPromeSinImp.current.value.replace(/\./g, "").replace(",", "."));
	      txtCostoPromeConImp.current.value = (0, _varios.formatMoneda)(costoProm.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    calcularPrecioSinImpuestos();
	  };
	
	  var calcularPrecioSinImpuestos = function calcularPrecioSinImpuestos() {
	    var mon = "0,00";
	
	    if (cmbMetodoCosto.current.value === "1") {
	      mon = txtCostoProveSinImp.current.value;
	    }
	
	    if (cmbMetodoCosto.current.value === "2") {
	      mon = txtCostoCalcuSinImp.current.value;
	    }
	
	    if (cmbMetodoCosto.current.value === "3") {
	      mon = txtUltimoCostoSinImp.current.value;
	    }
	
	    if (cmbMetodoCosto.current.value === "4") {
	      mon = txtCostoPromeSinImp.current.value;
	    }
	
	    txtPrecioMaxiSinImp.current.value = mon;
	    txtPrecioOfeSinImp.current.value = mon;
	    txtPrecioMayorSinImp.current.value = mon;
	    txtPrecioMiniSinImp.current.value = mon;
	
	    calcularUtilidadxValor(5);
	  };
	
	  var calcularPrecioSinImpuestosAlter = function calcularPrecioSinImpuestosAlter() {
	    var mon = "0,00";
	
	    if (cmbMetodoCosto.current.value === "1") {
	      mon = txtCostoProveSinImpAlter.current.value;
	    }
	
	    if (cmbMetodoCosto.current.value === "2") {
	      mon = txtCostoCalcuSinImpAlter.current.value;
	    }
	
	    if (cmbMetodoCosto.current.value === "3") {
	      mon = txtUltimoCostoSinImpAlter.current.value;
	    }
	
	    if (cmbMetodoCosto.current.value === "4") {
	      mon = txtCostoPromeSinImpAlter.current.value;
	    }
	
	    txtPrecioMaxiSinImpAlter.current.value = mon;
	    txtPrecioOfeSinImpAlter.current.value = mon;
	    txtPrecioMayorSinImpAlter.current.value = mon;
	    txtPrecioMiniSinImpAlter.current.value = mon;
	
	    calcularUtilidadxValorAlter(5);
	    calcularImpuestosVentasAlter();
	  };
	
	  var calcularImpuestosVentas = function calcularImpuestosVentas() {
	    var costo = 0.0;
	    var uti = 0.0;
	    var monto = 0.0;
	    var valIva = parseFloat(txtIvaVenta.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	    if (txtPrecioMaxiSinImp.current.value.trim() !== "") {
	      var costoMaxi = costo;
	      if (costoMaxi <= 0.0) {
	        costoMaxi = parseFloat(txtPrecioMaxiSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        monto = (1 + valIva) * costoMaxi;
	      } else {
	        uti = parseFloat(txtUtilidadMaxi.current.value.replace(/\./g, "").replace(",", ".")) * costoMaxi / 100;
	        monto = (1 + valIva) * costoMaxi; //+ uti;
	      }
	
	      txtPrecioMaxiConImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtPrecioOfeSinImp.current.value.trim() !== "") {
	      var costoOfe = costo;
	      if (costoOfe <= 0.0) {
	        costoOfe = parseFloat(txtPrecioOfeSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        monto = (1 + valIva) * costoOfe;
	      } else {
	        uti = parseFloat(txtUtilidadOfe.current.value.replace(/\./g, "").replace(",", ".")) * costoOfe / 100;
	        monto = (1 + valIva) * costoOfe; // + uti;
	      }
	
	      txtPrecioOfeConImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtPrecioMayorSinImp.current.value.trim() !== "") {
	      var costoMayor = costo;
	      if (costoMayor <= 0.0) {
	        costoMayor = parseFloat(txtPrecioMayorSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        monto = (1 + valIva) * costoMayor;
	      } else {
	        uti = parseFloat(txtUtilidadMayor.current.value.replace(/\./g, "").replace(",", ".")) * costoMayor / 100;
	        monto = (1 + valIva) * costoMayor; //+ uti;
	      }
	
	      txtPrecioMayorConImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtPrecioMiniSinImp.current.value.trim() !== "") {
	      var costoMini = costo;
	      if (costoMini <= 0.0) {
	        costoMini = parseFloat(txtPrecioMiniSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        monto = (1 + valIva) * costoMini;
	      } else {
	        uti = parseFloat(txtUtilidadMini.current.value.replace(/\./g, "").replace(",", ".")) * costoMini / 100;
	        monto = (1 + valIva) * costoMini; //+ uti;
	      }
	
	      txtPrecioMiniConImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	
	    if (radioSi.current.checked) {
	      calcularPrecioSinImpuestosAlter();
	    }
	  };
	
	  var calcularUtilidadxValor = function calcularUtilidadxValor(desde) {
	    var mon = 0.0;
	    var mon2 = 0.0;
	    var utiMax = 0.0,
	        utiOfe = 0.0,
	        utiMay = 0.0,
	        utiMin = 0.0;
	    if (cmbMetodoCosto.current.value === "1") {
	      mon = parseFloat(txtCostoProveSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "2") {
	      mon = parseFloat(txtCostoCalcuSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "3") {
	      mon = parseFloat(txtUltimoCostoSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "4") {
	      mon = parseFloat(txtCostoPromeSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    switch (desde) {
	      case 1:
	        mon2 = parseFloat(txtPrecioMaxiSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon2 > 0.0) {
	          if (mon > 0.0) {
	            utiMax = (mon2 - mon) / mon;
	            utiMax = utiMax * 100;
	          } else {
	            utiMax = 100.0;
	          }
	        }
	
	        if (mon > mon2) {
	          txtPrecioMaxiSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMaxiSinImp.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMaxiSinImp.current.value.trim() !== "") {
	          txtUtilidadMaxi.current.value = (0, _varios.formatMoneda)(utiMax.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	        break;
	      case 2:
	        mon2 = parseFloat(txtPrecioOfeSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon2 > 0.0) {
	          if (mon > 0.0) {
	            utiOfe = (mon2 - mon) / mon;
	            utiOfe = utiOfe * 100;
	          } else {
	            utiOfe = 100.0;
	          }
	        }
	
	        if (mon > mon2) {
	          txtPrecioOfeSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioOfeSinImp.current.style.color = "#000000";
	        }
	
	        if (txtPrecioOfeSinImp.current.value.trim() !== "") {
	          txtUtilidadOfe.current.value = (0, _varios.formatMoneda)(utiOfe.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	        break;
	      case 3:
	        mon2 = parseFloat(txtPrecioMayorSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon2 > 0.0) {
	          if (mon > 0.0) {
	            utiMay = (mon2 - mon) / mon;
	            utiMay = utiMay * 100;
	          } else {
	            utiMay = 100.0;
	          }
	        }
	
	        if (mon > mon2) {
	          txtPrecioMayorSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMayorSinImp.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMayorSinImp.current.value.trim() !== "") {
	          txtUtilidadMayor.current.value = (0, _varios.formatMoneda)(utiMay.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	        break;
	      case 4:
	        mon2 = parseFloat(txtPrecioMiniSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon2 > 0.0) {
	          if (mon > 0.0) {
	            utiMin = (mon2 - mon) / mon;
	            utiMin = utiMin * 100;
	          } else {
	            utiMin = 100.0;
	          }
	        }
	
	        if (mon > mon2) {
	          txtPrecioMiniSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMiniSinImp.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMiniSinImp.current.value.trim() !== "") {
	          txtUtilidadMini.current.value = (0, _varios.formatMoneda)(utiMin.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	        break;
	      case 5:
	        mon2 = parseFloat(txtPrecioMaxiSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon > 0.0) {
	          utiMax = (mon2 - mon) / mon;
	          utiMax = utiMax * 100;
	        }
	
	        if (mon > mon2) {
	          txtPrecioMaxiSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMaxiSinImp.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMaxiSinImp.current.value.trim() !== "") {
	          txtUtilidadMaxi.current.value = (0, _varios.formatMoneda)(utiMax.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	
	        mon2 = parseFloat(txtPrecioOfeSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon > 0.0) {
	          utiOfe = (mon2 - mon) / mon;
	          utiOfe = utiOfe * 100;
	        }
	
	        if (mon > mon2) {
	          txtPrecioOfeSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioOfeSinImp.current.style.color = "#000000";
	        }
	
	        if (txtPrecioOfeSinImp.current.value.trim() !== "") {
	          txtUtilidadOfe.current.value = (0, _varios.formatMoneda)(utiOfe.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	
	        mon2 = parseFloat(txtPrecioMayorSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon > 0.0) {
	          utiMay = (mon2 - mon) / mon;
	          utiMay = utiMay * 100;
	        }
	
	        if (mon > mon2) {
	          txtPrecioMayorSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMayorSinImp.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMayorSinImp.current.value.trim() !== "") {
	          txtUtilidadMayor.current.value = (0, _varios.formatMoneda)(utiMay.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	
	        mon2 = parseFloat(txtPrecioMiniSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon > 0.0) {
	          utiMin = (mon2 - mon) / mon;
	          utiMin = utiMin * 100;
	        }
	
	        if (mon > mon2) {
	          txtPrecioMiniSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMiniSinImp.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMiniSinImp.current.value.trim() !== "") {
	          txtUtilidadMini.current.value = (0, _varios.formatMoneda)(utiMin.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	
	        break;
	    }
	    calcularImpuestosVentas();
	  };
	
	  var calcularUtilidadxPorce = function calcularUtilidadxPorce(desde) {
	    var monto = 0.0,
	        valUti = 0.0;
	    var mon = 0.0;
	    if (cmbMetodoCosto.current.value === "1") {
	      mon = parseFloat(txtCostoProveSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "2") {
	      mon = parseFloat(txtCostoCalcuSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "3") {
	      mon = parseFloat(txtUltimoCostoSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "4") {
	      mon = parseFloat(txtCostoPromeSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    switch (desde) {
	      case 1:
	        valUti = parseFloat(txtUtilidadMaxi.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	        if (mon > 0.0) {
	          monto = (1 + valUti) * mon;
	          txtPrecioMaxiSinImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          //txtUtilidadOfe.current.focus();
	        } else if (parseFloat(txtPrecioMaxiSinImp.current.value.replace(/\./g, "").replace(",", ".")) <= 0.0) {
	          txtUtilidadMaxi.current.value = "0,00";
	          txtPrecioMaxiSinImp.current.focus();
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Precio Maximo no puede ser 0,00.",
	            icono: "informacion"
	          });
	        } else {
	          txtUtilidadMaxi.current.value = "100,00";
	          //txtUtilidadOfe.current.focus();
	        }
	
	        if (mon > monto) {
	          txtPrecioMaxiSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMaxiSinImp.current.style.color = "#000000";
	        }
	
	        break;
	      case 2:
	        valUti = parseFloat(txtUtilidadOfe.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	        if (mon > 0.0) {
	          monto = (1 + valUti) * mon;
	          txtPrecioOfeSinImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          //txtUtilidadMayor.current.focus();
	        } else if (parseFloat(txtPrecioOfeSinImp.current.value.replace(/\./g, "").replace(",", ".")) <= 0.0) {
	          txtUtilidadOfe.current.value = "0,00";
	          txtPrecioOfeSinImp.current.focus();
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Precio Oferta no puede ser 0,00.",
	            icono: "informacion"
	          });
	        } else {
	          txtUtilidadOfe.current.value = "100,00";
	          //txtUtilidadMayor.current.focus();
	        }
	
	        if (mon > monto) {
	          txtPrecioOfeSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioOfeSinImp.current.style.color = "#000000";
	        }
	
	        break;
	      case 3:
	        valUti = parseFloat(txtUtilidadMayor.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	        if (mon > 0.0) {
	          monto = (1 + valUti) * mon;
	          txtPrecioMayorSinImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          //txtUtilidadMini.current.focus();
	        } else if (parseFloat(txtPrecioMayorSinImp.current.value.replace(/\./g, "").replace(",", ".")) <= 0.0) {
	          txtUtilidadMayor.current.value = "0,00";
	          txtPrecioMayorSinImp.current.focus();
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Precio Mayor no puede ser 0,00.",
	            icono: "informacion"
	          });
	        } else {
	          txtUtilidadMayor.current.value = "100,00";
	          //txtUtilidadMini.current.focus();
	        }
	
	        if (mon > monto) {
	          txtPrecioMayorSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMayorSinImp.current.style.color = "#000000";
	        }
	
	        break;
	      case 4:
	        valUti = parseFloat(txtUtilidadMini.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	        if (mon > 0.0) {
	          monto = (1 + valUti) * mon;
	          txtPrecioMiniSinImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          //radioNo.current.focus();
	        } else if (parseFloat(txtPrecioMiniSinImp.current.value.replace(/\./g, "").replace(",", ".")) <= 0.0) {
	          txtUtilidadMini.current.value = "0,00";
	          txtPrecioMiniSinImp.current.focus();
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Precio Minimo no puede ser 0,00.",
	            icono: "informacion"
	          });
	        } else {
	          txtUtilidadMini.current.value = "100,00";
	          // radioNo.current.focus();
	        }
	
	        if (mon > monto) {
	          txtPrecioMiniSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMiniSinImp.current.style.color = "#000000";
	        }
	
	        break;
	      case 5:
	        if (mon > 0.0) {
	          valUti = parseFloat(txtUtilidadMaxi.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	          if (txtPrecioMaxiSinImp.current.value.trim() !== "") {
	            monto = (1 + valUti) * mon;
	            txtPrecioMaxiSinImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          }
	          valUti = parseFloat(txtUtilidadOfe.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	          if (txtPrecioOfeSinImp.current.value.trim() !== "") {
	            monto = (1 + valUti) * mon;
	            txtPrecioOfeSinImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          }
	          valUti = parseFloat(txtUtilidadMayor.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	          if (txtPrecioMayorSinImp.current.value.trim() !== "") {
	            monto = (1 + valUti) * mon;
	            txtPrecioMayorSinImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          }
	          valUti = parseFloat(txtUtilidadMini.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	          if (txtPrecioMiniSinImp.current.value.trim() !== "") {
	            monto = (1 + valUti) * mon;
	            txtPrecioMiniSinImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          }
	        }
	
	        break;
	    }
	
	    calcularImpuestosVentas();
	  };
	
	  var calcularFactorConversion = function calcularFactorConversion() {
	    var unifactor = cmbUniFactor.current.selectedIndex;
	    var precio = 0.0,
	        costoProv = 0.0,
	        costoCal = 0.0,
	        costoUlt = 0.0,
	        costoProm = 0.0;
	    var valor = parseFloat(txtFactor.current.value.replace(/\./g, "").replace(",", "."));
	    var mon = 0.0;
	
	    if (cmbMetodoCosto.current.value === "1") {
	      mon = parseFloat(txtCostoProveConImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "2") {
	      mon = parseFloat(txtCostoCalcuConImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "3") {
	      mon = parseFloat(txtUltimoCostoConImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "4") {
	      mon = parseFloat(txtCostoPromeConImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    costoProv = parseFloat(txtCostoProveSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    costoCal = parseFloat(txtCostoCalcuSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    costoUlt = parseFloat(txtUltimoCostoSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    costoProm = parseFloat(txtCostoPromeSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	    if (unifactor === 0) {
	      precio = mon * valor;
	      costoProv = costoProv * valor;
	      costoCal = costoCal * valor;
	      costoUlt = costoUlt * valor;
	      costoProm = costoProm * valor;
	    } else {
	      precio = mon / valor;
	      costoProv = costoProv / valor;
	      costoCal = costoCal / valor;
	      costoUlt = costoUlt / valor;
	      costoProm = costoProm / valor;
	    }
	
	    if (mon > 0.0) {
	      txtCostoProveSinImpAlter.current.value = (0, _varios.formatMoneda)(costoProv.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	      txtCostoCalcuSinImpAlter.current.value = (0, _varios.formatMoneda)(costoCal.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	      txtUltimoCostoSinImpAlter.current.value = (0, _varios.formatMoneda)(costoUlt.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	      txtCostoPromeSinImpAlter.current.value = (0, _varios.formatMoneda)(costoProm.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	      txtPrecioMaxiSinImpAlter.current.value = (0, _varios.formatMoneda)(precio.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	      txtPrecioOfeSinImpAlter.current.value = (0, _varios.formatMoneda)(precio.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	      txtPrecioMayorSinImpAlter.current.value = (0, _varios.formatMoneda)(precio.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	      txtPrecioMiniSinImpAlter.current.value = (0, _varios.formatMoneda)(precio.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	
	    calcularImpuestosCostosAlter();
	  };
	
	  var calcularImpuestosCostosAlter = function calcularImpuestosCostosAlter() {
	    var costoProv = 0.0,
	        costoCal = 0.0,
	        costoUlt = 0.0,
	        costoProm = 0.0;
	    var valIva = parseFloat(txtIvaCompra.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	    if (txtCostoProveSinImpAlter.current.value.trim() !== "") {
	      costoProv = (1 + valIva) * parseFloat(txtCostoProveSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	      txtCostoProveConImpAlter.current.value = (0, _varios.formatMoneda)(costoProv.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtCostoCalcuSinImpAlter.current.value.trim() !== "") {
	      costoCal = (1 + valIva) * parseFloat(txtCostoCalcuSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	      txtCostoCalcuConImpAlter.current.value = (0, _varios.formatMoneda)(costoCal.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtUltimoCostoSinImpAlter.current.value.trim() !== "") {
	      costoUlt = (1 + valIva) * parseFloat(txtUltimoCostoSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	      txtUltimoCostoConImpAlter.current.value = (0, _varios.formatMoneda)(costoUlt.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtCostoPromeSinImpAlter.current.value.trim() !== "") {
	      costoProm = (1 + valIva) * parseFloat(txtCostoPromeSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	      txtCostoPromeConImpAlter.current.value = (0, _varios.formatMoneda)(costoProm.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    calcularPrecioSinImpuestosAlter();
	  };
	
	  var calcularImpuestosVentasAlter = function calcularImpuestosVentasAlter() {
	    var costo = 0.0;
	    var uti = 0.0;
	    var monto = 0.0;
	    var valIva = parseFloat(txtIvaVenta.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	    /*     if (cmbMetodoCosto.current.value === "1") {
	      costo = parseFloat(
	        txtCostoProveConImpAlter.current.value
	          .replace(/\./g, "")
	          .replace(",", ".")
	      );
	    }
	     if (cmbMetodoCosto.current.value === "2") {
	      costo = parseFloat(
	        txtCostoCalcuConImpAlter.current.value
	          .replace(/\./g, "")
	          .replace(",", ".")
	      );
	    }
	     if (cmbMetodoCosto.current.value === "3") {
	      costo = parseFloat(
	        txtUltimoCostoConImpAlter.current.value
	          .replace(/\./g, "")
	          .replace(",", ".")
	      );
	    }
	     if (cmbMetodoCosto.current.value === "4") {
	      costo = parseFloat(
	        txtCostoPromeConImpAlter.current.value
	          .replace(/\./g, "")
	          .replace(",", ".")
	      );
	    } */
	
	    if (txtPrecioMaxiSinImpAlter.current.value.trim() !== "") {
	      var costoMaxi = costo;
	      if (costoMaxi <= 0.0) {
	        costoMaxi = parseFloat(txtPrecioMaxiSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        monto = (1 + valIva) * costoMaxi;
	      } else {
	        uti = parseFloat(txtUtilidadMaxiAlter.current.value.replace(/\./g, "").replace(",", ".")) * costoMaxi / 100;
	        monto = (1 + valIva) * costoMaxi + uti;
	      }
	
	      txtPrecioMaxiConImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtPrecioOfeSinImpAlter.current.value.trim() !== "") {
	      var costoOfe = costo;
	      if (costoOfe <= 0.0) {
	        costoOfe = parseFloat(txtPrecioOfeSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        monto = (1 + valIva) * costoOfe;
	      } else {
	        uti = parseFloat(txtUtilidadOfeAlter.current.value.replace(/\./g, "").replace(",", ".")) * costoOfe / 100;
	        monto = (1 + valIva) * costoOfe + uti;
	      }
	
	      txtPrecioOfeConImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtPrecioMayorSinImpAlter.current.value.trim() !== "") {
	      var costoMayor = costo;
	      if (costoMayor <= 0.0) {
	        costoMayor = parseFloat(txtPrecioMayorSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        monto = (1 + valIva) * costoMayor;
	      } else {
	        uti = parseFloat(txtUtilidadMayorAlter.current.value.replace(/\./g, "").replace(",", ".")) * costoMayor / 100;
	        monto = (1 + valIva) * costoMayor + uti;
	      }
	
	      txtPrecioMayorConImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtPrecioMiniSinImpAlter.current.value.trim() !== "") {
	      var costoMini = costo;
	      if (costoMini <= 0.0) {
	        costoMini = parseFloat(txtPrecioMiniSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        monto = (1 + valIva) * costoMini;
	      } else {
	        uti = parseFloat(txtUtilidadMiniAlter.current.value.replace(/\./g, "").replace(",", ".")) * costoMini / 100;
	        monto = (1 + valIva) * costoMini + uti;
	      }
	
	      txtPrecioMiniConImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	  };
	
	  var calcularUtilidadAlter = function calcularUtilidadAlter(desde) {
	    var monto = 0.0,
	        valUti = 0.0;
	    var mon = 0.0;
	    if (cmbMetodoCosto.current.value === "1") {
	      mon = parseFloat(txtCostoProveSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "2") {
	      mon = parseFloat(txtCostoCalcuSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "3") {
	      mon = parseFloat(txtUltimoCostoSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "4") {
	      mon = parseFloat(txtCostoPromeSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    switch (desde) {
	      case 1:
	        valUti = parseFloat(txtUtilidadMaxiAlter.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	        if (mon > 0.0) {
	          monto = (1 + valUti) * mon;
	          txtPrecioMaxiSinImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          //txtUtilidadOfe.current.focus();
	        } else if (parseFloat(txtPrecioMaxiSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) <= 0.0) {
	          txtUtilidadMaxiAlter.current.value = "0,00";
	          txtPrecioMaxiSinImpAlter.current.focus();
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Precio Maximo no puede ser 0,00.",
	            icono: "informacion"
	          });
	        } else {
	          txtUtilidadMaxiAlter.current.value = "100,00";
	          //txtUtilidadOfe.current.focus();
	        }
	
	        if (mon > monto) {
	          txtPrecioMaxiSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMaxiSinImpAlter.current.style.color = "#000000";
	        }
	
	        break;
	      case 2:
	        valUti = parseFloat(txtUtilidadOfeAlter.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	        if (mon > 0.0) {
	          monto = (1 + valUti) * mon;
	          txtPrecioOfeSinImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          //txtUtilidadMayor.current.focus();
	        } else if (parseFloat(txtPrecioOfeSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) <= 0.0) {
	          txtUtilidadOfeAlter.current.value = "0,00";
	          txtPrecioOfeSinImpAlter.current.focus();
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Precio Oferta no puede ser 0,00.",
	            icono: "informacion"
	          });
	        } else {
	          txtUtilidadOfeAlter.current.value = "100,00";
	          //txtUtilidadMayor.current.focus();
	        }
	
	        if (mon > monto) {
	          txtPrecioOfeSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioOfeSinImpAlter.current.style.color = "#000000";
	        }
	
	        break;
	      case 3:
	        valUti = parseFloat(txtUtilidadMayorAlter.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	        if (mon > 0.0) {
	          monto = (1 + valUti) * mon;
	          txtPrecioMayorSinImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          //txtUtilidadMini.current.focus();
	        } else if (parseFloat(txtPrecioMayorSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) <= 0.0) {
	          txtUtilidadMayorAlter.current.value = "0,00";
	          txtPrecioMayorSinImpAlter.current.focus();
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Precio Mayor no puede ser 0,00.",
	            icono: "informacion"
	          });
	        } else {
	          txtUtilidadMayorAlter.current.value = "100,00";
	          //txtUtilidadMini.current.focus();
	        }
	
	        if (mon > monto) {
	          txtPrecioMayorSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMayorSinImpAlter.current.style.color = "#000000";
	        }
	
	        break;
	      case 4:
	        valUti = parseFloat(txtUtilidadMiniAlter.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	        if (mon > 0.0) {
	          monto = (1 + valUti) * mon;
	          txtPrecioMiniSinImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          //radioNo.current.focus();
	        } else if (parseFloat(txtPrecioMiniSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) <= 0.0) {
	          txtUtilidadMiniAlter.current.value = "0,00";
	          txtPrecioMiniSinImpAlter.current.focus();
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Precio Minimo no puede ser 0,00.",
	            icono: "informacion"
	          });
	        } else {
	          txtUtilidadMiniAlter.current.value = "100,00";
	          // radioNo.current.focus();
	        }
	
	        if (mon > monto) {
	          txtPrecioMiniSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMiniSinImpAlter.current.style.color = "#000000";
	        }
	
	        break;
	      case 5:
	        if (mon > 0.0) {
	          valUti = parseFloat(txtUtilidadMaxiAlter.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	          if (txtPrecioMaxiSinImpAlter.current.value.trim() !== "") {
	            monto = (1 + valUti) * mon;
	            txtPrecioMaxiSinImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          }
	          valUti = parseFloat(txtUtilidadOfeAlter.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	          if (txtPrecioOfeSinImpAlter.current.value.trim() !== "") {
	            monto = (1 + valUti) * mon;
	            txtPrecioOfeSinImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          }
	          valUti = parseFloat(txtUtilidadMayorAlter.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	          if (txtPrecioMayorSinImpAlter.current.value.trim() !== "") {
	            monto = (1 + valUti) * mon;
	            txtPrecioMayorSinImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          }
	          valUti = parseFloat(txtUtilidadMiniAlter.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	          if (txtPrecioMiniSinImpAlter.current.value.trim() !== "") {
	            monto = (1 + valUti) * mon;
	            txtPrecioMiniSinImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          }
	        }
	
	        break;
	    }
	
	    calcularImpuestosVentasAlter();
	  };
	
	  var calcularUtilidadxValorAlter = function calcularUtilidadxValorAlter(desde) {
	    var mon = 0.0;
	    if (cmbMetodoCosto.current.value === "1") {
	      mon = parseFloat(txtCostoProveSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "2") {
	      mon = parseFloat(txtCostoCalcuSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "3") {
	      mon = parseFloat(txtUltimoCostoSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "4") {
	      mon = parseFloat(txtCostoPromeSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    var mon2 = 0.0;
	    var mon3 = 0.0;
	
	    switch (desde) {
	      case 1:
	        mon2 = parseFloat(txtPrecioMaxiSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon2 > 0.0) {
	          if (mon > 0.0) {
	            mon3 = (mon2 - mon) / mon;
	            mon3 = mon3 * 100;
	          } else {
	            mon3 = 100.0;
	          }
	        }
	
	        if (mon > mon2) {
	          txtPrecioMaxiSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMaxiSinImpAlter.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMaxiSinImpAlter.current.value.trim() !== "") {
	          txtUtilidadMaxiAlter.current.value = (0, _varios.formatMoneda)(mon3.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	        break;
	      case 2:
	        mon2 = parseFloat(txtPrecioOfeSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon2 > 0.0) {
	          if (mon > 0.0) {
	            mon3 = (mon2 - mon) / mon;
	            mon3 = mon3 * 100;
	          } else {
	            mon3 = 100.0;
	          }
	        }
	
	        if (mon > mon2) {
	          txtPrecioOfeSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioOfeSinImpAlter.current.style.color = "#000000";
	        }
	
	        if (txtPrecioOfeSinImpAlter.current.value.trim() !== "") {
	          txtUtilidadOfeAlter.current.value = (0, _varios.formatMoneda)(mon3.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	        break;
	      case 3:
	        mon2 = parseFloat(txtPrecioMayorSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon2 > 0.0) {
	          if (mon > 0.0) {
	            mon3 = (mon2 - mon) / mon;
	            mon3 = mon3 * 100;
	          } else {
	            mon3 = 100.0;
	          }
	        }
	
	        if (mon > mon2) {
	          txtPrecioMayorSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMayorSinImpAlter.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMayorSinImpAlter.current.value.trim() !== "") {
	          txtUtilidadMayorAlter.current.value = (0, _varios.formatMoneda)(mon3.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	        break;
	      case 4:
	        mon2 = parseFloat(txtPrecioMiniSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon2 > 0.0) {
	          if (mon > 0.0) {
	            mon3 = (mon2 - mon) / mon;
	            mon3 = mon3 * 100;
	          } else {
	            mon3 = 100.0;
	          }
	        }
	
	        if (mon > mon2) {
	          txtPrecioMiniSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMiniSinImpAlter.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMiniSinImpAlter.current.value.trim() !== "") {
	          txtUtilidadMiniAlter.current.value = (0, _varios.formatMoneda)(mon3.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	        break;
	      case 5:
	        mon2 = parseFloat(txtPrecioMaxiSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon > 0.0) {
	          mon3 = (mon2 - mon) / mon;
	          mon3 = mon3 * 100;
	        }
	
	        if (mon > mon2) {
	          txtPrecioMaxiSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMaxiSinImpAlter.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMaxiSinImpAlter.current.value.trim() !== "") {
	          txtUtilidadMaxiAlter.current.value = (0, _varios.formatMoneda)(mon3.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	
	        mon2 = parseFloat(txtPrecioOfeSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon > 0.0) {
	          mon3 = (mon2 - mon) / mon;
	          mon3 = mon3 * 100;
	        }
	
	        if (mon > mon2) {
	          txtPrecioOfeSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioOfeSinImpAlter.current.style.color = "#000000";
	        }
	
	        if (txtPrecioOfeSinImpAlter.current.value.trim() !== "") {
	          txtUtilidadOfeAlter.current.value = (0, _varios.formatMoneda)(mon3.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	
	        mon2 = parseFloat(txtPrecioMayorSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon > 0.0) {
	          mon3 = (mon2 - mon) / mon;
	          mon3 = mon3 * 100;
	        }
	
	        if (mon > mon2) {
	          txtPrecioMayorSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMayorSinImpAlter.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMayorSinImpAlter.current.value.trim() !== "") {
	          txtUtilidadMayorAlter.current.value = (0, _varios.formatMoneda)(mon3.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	
	        mon2 = parseFloat(txtPrecioMiniSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon > 0.0) {
	          mon3 = (mon2 - mon) / mon;
	          mon3 = mon3 * 100;
	        }
	
	        if (mon > mon2) {
	          txtPrecioMiniSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMiniSinImpAlter.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMiniSinImpAlter.current.value.trim() !== "") {
	          txtUtilidadMiniAlter.current.value = (0, _varios.formatMoneda)(mon3.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	
	        break;
	    }
	
	    calcularImpuestosVentasAlter();
	  };
	
	  var unidadAlterna = function unidadAlterna(event) {
	    if (radioSi.current.checked) {
	      setTabIndex({ tab1: "tab", tab2: "tab" });
	      setACtiveTab({
	        tab1: "nav-link text-light bg-blue-100 rounded",
	        tab2: "nav-link active text-light bg-blue-200 rounded"
	      });
	      setTabValid({ tab1: "false", tab2: "true" });
	      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
	      setHabilitadoAlter(true);
	      txtCostoProveSinImpAlter.current.value = "0,00";
	      txtCostoCalcuSinImpAlter.current.value = "0,00";
	      txtUltimoCostoSinImpAlter.current.value = "0,00";
	      txtCostoPromeSinImpAlter.current.value = "0,00";
	      txtCostoProveConImpAlter.current.value = "0,00";
	      txtCostoCalcuConImpAlter.current.value = "0,00";
	      txtUltimoCostoConImpAlter.current.value = "0,00";
	      txtCostoPromeConImpAlter.current.value = "0,00";
	      txtPrecioMaxiSinImpAlter.current.value = "0,00";
	      txtPrecioOfeSinImpAlter.current.value = "0,00";
	      txtPrecioMayorSinImpAlter.current.value = "0,00";
	      txtPrecioMiniSinImpAlter.current.value = "0,00";
	      txtPrecioMaxiConImpAlter.current.value = "0,00";
	      txtPrecioOfeConImpAlter.current.value = "0,00";
	      txtPrecioMayorConImpAlter.current.value = "0,00";
	      txtPrecioMiniConImpAlter.current.value = "0,00";
	      txtUtilidadMaxiAlter.current.value = "0,00";
	      txtUtilidadOfeAlter.current.value = "0,00";
	      txtUtilidadMayorAlter.current.value = "0,00";
	      txtUtilidadMiniAlter.current.value = "0,00";
	      txtFactor.current.value = "1,00";
	      cmbUniPrincipal.current.value = cmbUnidMedida.current.value;
	      cmbUniPrincipal.current.focus();
	    } else {
	      setTabIndex({ tab1: "tab", tab2: "" });
	      setHabilitadoAlter(false);
	      blanquearAlter();
	    }
	  };
	
	  var manesillas = function manesillas(stock, existencia) {
	    if (existencia === undefined) {}
	
	    if (stock === undefined) {} else {
	      var array = [0];
	      var n = parseFloat(stock) * 4;
	      var n1 = 0;
	      var n2 = 0;
	      if (parseFloat(existencia) > parseFloat(n)) {
	        n1 = parseFloat(existencia) / 10;
	        for (var i = 0; i < 12; i++) {
	          n2 = n2 + n1;
	          array.push(parseFloat(n2.toFixed(2)));
	        }
	      } else {
	        n1 = n / 10;
	        for (var _i = 0; _i < 10; _i++) {
	          n2 = n2 + n1;
	          array.push(parseFloat(n2.toFixed(2)));
	        }
	      }
	
	      setFlujo(array);
	    }
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "codigo") {
	      e.target.value = e.target.value.toUpperCase();
	    } else if (e.target.name === "unidadP" || e.target.name === "unidadA" || e.target.name === "idunidadmedida") {
	      if (cmbUniPrincipal.current.selectedIndex >= 0) {
	        var unic = [];
	        var univ = [];
	        setUnidadC([]);
	        setUnidadV([]);
	        if (e.target.name === "idunidadmedida") {
	          cmbUniPrincipal.current.selectedIndex = cmbUnidMedida.current.selectedIndex;
	        } else {
	          cmbUnidMedida.current.selectedIndex = cmbUniPrincipal.current.selectedIndex;
	        }
	
	        unic.push({
	          idunidadmedida: cmbUniPrincipal.current.value,
	          descripcion: cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex].text
	        });
	
	        univ.push({
	          idunidadmedida: cmbUniPrincipal.current.value,
	          descripcion: cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex].text
	        });
	
	        if (cmbUniAlterna.current.selectedIndex >= 0) {
	          unic.push({
	            idunidadmedida: cmbUniAlterna.current.value,
	            descripcion: cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text
	          });
	
	          univ.push({
	            idunidadmedida: cmbUniAlterna.current.value,
	            descripcion: cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text
	          });
	
	          var uni = [];
	          uni.push({
	            iduni: "0",
	            descripcion: cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex].text + "X" + cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text
	          });
	          uni.push({
	            iduni: "1",
	            descripcion: cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text + "X" + cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex].text
	          });
	          setFactor(uni);
	          cmbUniFactor.current.selectedIndex = -1;
	        }
	        setUnidadC(unic);
	        setUnidadV(univ);
	        cmbUniVenta.current.selectedIndex = -1;
	        cmbUniCompra.current.selectedIndex = -1;
	      }
	    } else if (e.target.name === "almacen") {
	      if (e.target.value === "true") {
	        setVisibleA("visible");
	        txtStockMini.current.value = "0,00";
	      } else {
	        setVisibleA("hidden");
	        txtStockMini.current.value = "0,00";
	      }
	    } else if (e.target.name === "unifactor") {
	      calcularFactorConversion();
	    } else if (e.target.name === "metodocosto") {
	      setCostoSelect(e.target.value);
	      calcularPrecioSinImpuestos();
	    } else if (e.target.id === "chekvacio") {
	      if (e.target.checked === true) {
	        setValvacio(1);
	        seleccionarClassVacios(2, "");
	      } else {
	        setValvacio(0);
	        txtCodigoVacio.current.value = "";
	      }
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	
	    if (txtIdproducto.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Id no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtIdproducto.current.focus();
	    } else if (txtNombre.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "Por Favor Introduzca la Descripción",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtNombre.current.focus();
	    } else if (txtNombreCorto.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Nombre Corto no deben estar Vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtNombreCorto.current.focus();
	    } else if (cmbTipoProd.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Tipo de Producto o Servicio no deben estar Vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      cmbTipoProd.current.focus();
	    } else if (cmbFabricante.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "Seleccione el Fabricante del Producto",
	        icono: "informacion"
	      });
	      sigue = false;
	      cmbFabricante.current.focus();
	    } else if (cmbUnidMedida.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Unidad de Medida no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      cmbUnidMedida.current.focus();
	    } else if (txtIvaCompra.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El % de Iva Para la Compra no deben estar Vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtIvaCompra.current.focus();
	    } else if (txtIvaVenta.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El % de Iva Para la Venta no deben estar Vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtIvaVenta.current.focus();
	    } else if (cmbPrecioVenta.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Tipo de precio de venta no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      cmbPrecioVenta.current.focus();
	    } else if (cmbAlmacen.current.value === "true" && txtStockMini.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Stock Minimo no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtStockMini.current.focus();
	    } else if (cmbAlmacen.current.value === "true" && txtStockMini.current.value.trim() === "0,00") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Stock Minimo debe ser mayor a Cero(0)",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtStockMini.current.focus();
	    } else if (cmbMetodoCosto.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Metodo de costo no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      cmbMetodoCosto.current.focus();
	    } else if (txtCostoProveSinImp.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Costo del Proveedoor no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtCostoProveSinImp.current.focus();
	    } else if (txtCostoCalcuSinImp.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Costo Calculado no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtCostoCalcuSinImp.current.focus();
	    } else if (txtUltimoCostoSinImp.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Ùltimo Costo no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtUltimoCostoSinImp.current.focus();
	    } else if (txtCostoPromeSinImp.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Costo Promedio no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtCostoPromeSinImp.current.focus();
	    } else if (txtUtilidadMaxi.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Utilidad del Precio Maximo no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtUtilidadMaxi.current.focus();
	    } else if (txtUtilidadOfe.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Utilidad del Precio Oferta no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtUtilidadOfe.current.focus();
	    } else if (txtUtilidadMayor.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Utilidad del Precio al Mayor no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtUtilidadMayor.current.focus();
	    } else if (txtUtilidadMini.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Utilidad del Precio Minimo no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtUtilidadMini.current.focus();
	    } else if (radioSi.current.checked) {
	      if (cmbUniAlterna.current.value.trim() === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "La Unidad de Medida Alterna no debe estar vacia",
	          icono: "informacion"
	        });
	        sigue = false;
	        setTabIndex({ tab1: "tab", tab2: "tab" });
	        setACtiveTab({
	          tab1: "nav-link text-light bg-blue-100 rounded",
	          tab2: "nav-link active text-light bg-blue-200 rounded"
	        });
	        setTabValid({ tab1: "false", tab2: "true" });
	        setTabPanel({
	          tab1: "tab-pane fade",
	          tab2: "tab-pane fade show active"
	        });
	        cmbUniAlterna.current.focus();
	      } else if (cmbUniVenta.current.value.trim() === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "La Unidad de Venta no debe estar vacia",
	          icono: "informacion"
	        });
	        sigue = false;
	        setTabIndex({ tab1: "tab", tab2: "tab" });
	        setACtiveTab({
	          tab1: "nav-link text-light bg-blue-100 rounded",
	          tab2: "nav-link active text-light bg-blue-200 rounded"
	        });
	        setTabValid({ tab1: "false", tab2: "true" });
	        setTabPanel({
	          tab1: "tab-pane fade",
	          tab2: "tab-pane fade show active"
	        });
	        cmbUniVenta.current.focus();
	      } else if (cmbUniCompra.current.value.trim() === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "La Unidad de Compra no debe estar vacia",
	          icono: "informacion"
	        });
	        sigue = false;
	        setTabIndex({ tab1: "tab", tab2: "tab" });
	        setACtiveTab({
	          tab1: "nav-link text-light bg-blue-100 rounded",
	          tab2: "nav-link active text-light bg-blue-200 rounded"
	        });
	        setTabValid({ tab1: "false", tab2: "true" });
	        setTabPanel({
	          tab1: "tab-pane fade",
	          tab2: "tab-pane fade show active"
	        });
	        cmbUniCompra.current.focus();
	      } else if (txtFactor.current.value.trim() === "" || txtFactor.current.value.trim() === "0.00") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "El Factor de Conversion no deben estar Vacio ni ser cero(0,00)",
	          icono: "informacion"
	        });
	        sigue = false;
	        setTabIndex({ tab1: "tab", tab2: "tab" });
	        setACtiveTab({
	          tab1: "nav-link text-light bg-blue-100 rounded",
	          tab2: "nav-link active text-light bg-blue-200 rounded"
	        });
	        setTabValid({ tab1: "false", tab2: "true" });
	        setTabPanel({
	          tab1: "tab-pane fade",
	          tab2: "tab-pane fade show active"
	        });
	        txtFactor.current.focus();
	      } else if (cmbUniFactor.current.value.trim() === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "La Unidad del Factor de Conversion no debe estar vacia",
	          icono: "informacion"
	        });
	        sigue = false;
	        setTabIndex({ tab1: "tab", tab2: "tab" });
	        setACtiveTab({
	          tab1: "nav-link text-light bg-blue-100 rounded",
	          tab2: "nav-link active text-light bg-blue-200 rounded"
	        });
	        setTabValid({ tab1: "false", tab2: "true" });
	        setTabPanel({
	          tab1: "tab-pane fade",
	          tab2: "tab-pane fade show active"
	        });
	        cmbUniFactor.current.focus();
	      } else if (txtCostoProveSinImpAlter.current.value === "0,00" || txtCostoProveSinImpAlter.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "El Costo del Proveedoor de la Unidad Alterna no debe estar vacio ni ser cero (0,00)",
	          icono: "informacion"
	        });
	        sigue = false;
	        setTabIndex({ tab1: "tab", tab2: "tab" });
	        setACtiveTab({
	          tab1: "nav-link text-light bg-blue-100 rounded",
	          tab2: "nav-link active text-light bg-blue-200 rounded"
	        });
	        setTabValid({ tab1: "false", tab2: "true" });
	        setTabPanel({
	          tab1: "tab-pane fade",
	          tab2: "tab-pane fade show active"
	        });
	        txtCostoProveSinImpAlter.current.focus();
	      } else if (txtCostoCalcuSinImpAlter.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "El Costo Calculado de la Unidad Alterna no debe estar vacio",
	          icono: "informacion"
	        });
	        sigue = false;
	        setTabIndex({ tab1: "tab", tab2: "tab" });
	        setACtiveTab({
	          tab1: "nav-link text-light bg-blue-100 rounded",
	          tab2: "nav-link active text-light bg-blue-200 rounded"
	        });
	        setTabValid({ tab1: "false", tab2: "true" });
	        setTabPanel({
	          tab1: "tab-pane fade",
	          tab2: "tab-pane fade show active"
	        });
	        txtCostoCalcuSinImpAlter.current.focus();
	      } else if (txtUltimoCostoSinImpAlter.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "El Ùltimo Costo de la Unidad Alterna no debe estar vacio",
	          icono: "informacion"
	        });
	        sigue = false;
	        setTabIndex({ tab1: "tab", tab2: "tab" });
	        setACtiveTab({
	          tab1: "nav-link text-light bg-blue-100 rounded",
	          tab2: "nav-link active text-light bg-blue-200 rounded"
	        });
	        setTabValid({ tab1: "false", tab2: "true" });
	        setTabPanel({
	          tab1: "tab-pane fade",
	          tab2: "tab-pane fade show active"
	        });
	        txtUltimoCostoSinImpAlter.current.focus();
	      } else if (txtCostoPromeSinImpAlter.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "El Costo Promedio de la Unidad Alterna no debe estar vacio",
	          icono: "informacion"
	        });
	        sigue = false;
	        setTabIndex({ tab1: "tab", tab2: "tab" });
	        setACtiveTab({
	          tab1: "nav-link text-light bg-blue-100 rounded",
	          tab2: "nav-link active text-light bg-blue-200 rounded"
	        });
	        setTabValid({ tab1: "false", tab2: "true" });
	        setTabPanel({
	          tab1: "tab-pane fade",
	          tab2: "tab-pane fade show active"
	        });
	        txtCostoPromeSinImpAlter.current.focus();
	      } else if (txtUtilidadMaxiAlter.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "La Utilidad del Precio Maximo de la Unidad Alterna no debe estar vacia",
	          icono: "informacion"
	        });
	        sigue = false;
	        setTabIndex({ tab1: "tab", tab2: "tab" });
	        setACtiveTab({
	          tab1: "nav-link text-light bg-blue-100 rounded",
	          tab2: "nav-link active text-light bg-blue-200 rounded"
	        });
	        setTabValid({ tab1: "false", tab2: "true" });
	        setTabPanel({
	          tab1: "tab-pane fade",
	          tab2: "tab-pane fade show active"
	        });
	        txtUtilidadMaxiAlter.current.focus();
	      } else if (txtUtilidadOfeAlter.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "La Utilidad del Precio Oferta de la Unidad Alterna no debe estar vacia",
	          icono: "informacion"
	        });
	        sigue = false;
	        setTabIndex({ tab1: "tab", tab2: "tab" });
	        setACtiveTab({
	          tab1: "nav-link text-light bg-blue-100 rounded",
	          tab2: "nav-link active text-light bg-blue-200 rounded"
	        });
	        setTabValid({ tab1: "false", tab2: "true" });
	        setTabPanel({
	          tab1: "tab-pane fade",
	          tab2: "tab-pane fade show active"
	        });
	        txtUtilidadOfeAlter.current.focus();
	      } else if (txtUtilidadMayorAlter.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "La Utilidad del Precio al Mayor de la Unidad Alterna no debe estar vacia",
	          icono: "informacion"
	        });
	        sigue = false;
	        setTabIndex({ tab1: "tab", tab2: "tab" });
	        setACtiveTab({
	          tab1: "nav-link text-light bg-blue-100 rounded",
	          tab2: "nav-link active text-light bg-blue-200 rounded"
	        });
	        setTabValid({ tab1: "false", tab2: "true" });
	        setTabPanel({
	          tab1: "tab-pane fade",
	          tab2: "tab-pane fade show active"
	        });
	        txtUtilidadMayorAlter.current.focus();
	      } else if (txtUtilidadMiniAlter.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "La Utilidad del Precio Minimo de la Unidad Alterna no debe estar vacia",
	          icono: "informacion"
	        });
	        sigue = false;
	        setTabIndex({ tab1: "tab", tab2: "tab" });
	        setACtiveTab({
	          tab1: "nav-link text-light bg-blue-100 rounded",
	          tab2: "nav-link active text-light bg-blue-200 rounded"
	        });
	        setTabValid({ tab1: "false", tab2: "true" });
	        setTabPanel({
	          tab1: "tab-pane fade",
	          tab2: "tab-pane fade show active"
	        });
	        txtUtilidadMiniAlter.current.focus();
	      }
	    }
	
	    var tasa = 0.0;
	    if (monedaCambio.idmoneda === monedaSub.idmoneda) {
	      tasa = 1.0;
	    } else if (monedaCambio.idmoneda === moneda.idmoneda) {
	      tasa = monedaSub.valormoneda;
	    } else {
	      tasa = (0, _varios.round)(monedaSub.valormoneda / monedaCambio.valormoneda);
	    }
	    var costoproveedor = parseFloat(txtCostoProveSinImp.current.value.replace(/\./g, "").replace(",", ".")) / tasa;
	    var costocalculado = parseFloat(txtCostoCalcuSinImp.current.value.replace(/\./g, "").replace(",", ".")) / tasa;
	    var ultimocosto = parseFloat(txtUltimoCostoSinImp.current.value.replace(/\./g, "").replace(",", ".")) / tasa;
	    var costopromedio = parseFloat(txtCostoPromeSinImp.current.value.replace(/\./g, "").replace(",", ".")) / tasa;
	    var utipreciomaxi = parseFloat(txtUtilidadMaxi.current.value.replace(/\./g, "").replace(",", "."));
	    var utiprecioofe = parseFloat(txtUtilidadOfe.current.value.replace(/\./g, "").replace(",", "."));
	    var utipreciomayor = parseFloat(txtUtilidadMayor.current.value.replace(/\./g, "").replace(",", "."));
	    var utipreciomini = parseFloat(txtUtilidadMini.current.value.replace(/\./g, "").replace(",", "."));
	    var preciomaxi = parseFloat(txtPrecioMaxiSinImp.current.value.replace(/\./g, "").replace(",", ".")) / tasa;
	    var precioofe = parseFloat(txtPrecioOfeSinImp.current.value.replace(/\./g, "").replace(",", ".")) / tasa;
	    var preciomayor = parseFloat(txtPrecioMayorSinImp.current.value.replace(/\./g, "").replace(",", ".")) / tasa;
	    var preciomini = parseFloat(txtPrecioMiniSinImp.current.value.replace(/\./g, "").replace(",", ".")) / tasa;
	
	    /* unidad alterna */
	    var costoproveedoralter = radioSi.current.checked ? parseFloat(txtCostoProveSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) / tasa : "0.00";
	    var costocalculadoalter = radioSi.current.checked ? parseFloat(txtCostoCalcuSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) / tasa : "0.00";
	    var ultimocostoalter = radioSi.current.checked ? parseFloat(txtUltimoCostoSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) / tasa : "0.00";
	    var costopromedioalter = radioSi.current.checked ? parseFloat(txtCostoPromeSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) / tasa : "0.00";
	    var utipreciomaxialter = radioSi.current.checked ? parseFloat(txtUtilidadMaxiAlter.current.value.replace(/\./g, "").replace(",", ".")) : "0.00";
	    var utiprecioofealter = radioSi.current.checked ? parseFloat(txtUtilidadOfeAlter.current.value.replace(/\./g, "").replace(",", ".")) : "0.00";
	    var utipreciomayoralter = radioSi.current.checked ? parseFloat(txtUtilidadMayorAlter.current.value.replace(/\./g, "").replace(",", ".")) : "0.00";
	    var utipreciominialter = radioSi.current.checked ? parseFloat(txtUtilidadMiniAlter.current.value.replace(/\./g, "").replace(",", ".")) : "0.00";
	
	    ///precio venta alterna
	    var preciomaxialter = radioSi.current.checked ? parseFloat(txtPrecioMaxiSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) / tasa : "0.00";
	    var precioofealter = radioSi.current.checked ? parseFloat(txtPrecioOfeSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) / tasa : "0.00";
	    var preciomayoralter = radioSi.current.checked ? parseFloat(txtPrecioMayorSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) / tasa : "0.00";
	    var preciominialter = radioSi.current.checked ? parseFloat(txtPrecioMiniSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) / tasa : "0.00";
	
	    if (sigue) {
	      var prod = [];
	      prod.push({
	        idproducto: txtIdproductoHidden.current.value,
	        codigo: txtIdproducto.current.value.toUpperCase(),
	        nombre: txtNombre.current.value.toUpperCase(),
	        servicio: chkServicio.current.checked,
	        nombrecorto: txtNombreCorto.current.value.toUpperCase(),
	        idtipoproducto: cmbTipoProd.current.value,
	        marca: cmbMarca.current.value === "" ? 0 : cmbMarca.current.value,
	        modelo: cmbModelo.current.value === "" ? 0 : cmbModelo.current.value,
	        referencia: txtReferencia.current.value.toUpperCase(),
	        diasgarantia: txtDiasGar.current.value === "" ? null : txtDiasGar.current.value,
	        idunidadmedida: cmbUnidMedida.current.value,
	        idmoneda: monedaSub.idmoneda,
	        ivacompra: parseFloat(txtIvaCompra.current.value.replace(/\./g, "").replace(",", ".")),
	        ivaventa: parseFloat(txtIvaVenta.current.value.replace(/\./g, "").replace(",", ".")),
	        exento: parseFloat(txtIvaVenta.current.value.replace(/\./g, "").replace(",", ".")) > 0.0 ? false : true,
	        tipoprecio: cmbPrecioVenta.current.value,
	        almacen: cmbAlmacen.current.value = "true" ? true : false,
	        stockminimo: parseFloat(txtStockMini.current.value.replace(/\./g, "").replace(",", ".")),
	        metodocosto: cmbMetodoCosto.current.value,
	        costoproveedor: costoproveedor,
	        costocalculado: costocalculado,
	        ultimocosto: ultimocosto,
	        costopromedio: costopromedio,
	        utipreciomaxi: utipreciomaxi,
	        utiprecioofe: utiprecioofe,
	        utipreciomayor: utipreciomayor,
	        utipreciomini: utipreciomini,
	        preciomaxi: preciomaxi,
	        precioofe: precioofe,
	        preciomayor: preciomayor,
	        preciomini: preciomini,
	
	        idunidadalterna: radioSi.current.checked ? cmbUniAlterna.current.value : "0",
	        idunidadcompra: radioSi.current.checked ? cmbUniCompra.current.value : "0",
	        idunidadventa: radioSi.current.checked ? cmbUniVenta.current.value : "0",
	        valorfactor: radioSi.current.checked ? parseFloat(txtFactor.current.value.replace(/\./g, "").replace(",", ".")) : "0.00",
	        tipofactor: radioSi.current.checked ? cmbUniFactor.current.value : "",
	        costoproveedoralter: costoproveedoralter,
	        costocalculadoalter: costocalculadoalter,
	        ultimocostoalter: ultimocostoalter,
	        costopromedioalter: costopromedioalter,
	        utipreciomaxialter: utipreciomaxialter,
	        utiprecioofealter: utiprecioofealter,
	        utipreciomayoralter: utipreciomayoralter,
	        utipreciominialter: utipreciominialter,
	        preciomaxialter: preciomaxialter,
	        precioofealter: precioofealter,
	        preciomayoralter: preciomayoralter,
	        preciominialter: preciominialter,
	        idtipoingreso: "0",
	        idfabricante: cmbFabricante.current.value,
	        vacio: txtVacio.current.checked,
	        idclasevacio: valvacio === 1 ? txtCodigoVacio.current.value : null
	      });
	
	      setProducto({
	        codigo: txtIdproducto.current.value.toUpperCase(),
	        idproducto: txtIdproductoHidden.current.value,
	        ivaventa: parseFloat(txtIvaVenta.current.value.replace(/\./g, "").replace(",", ".")),
	        nombre: txtNombre.current.value.toUpperCase(),
	        nombrecorto: txtNombreCorto.current.value.toUpperCase(),
	        preciomax: preciomaxi,
	        unidadalterna: radioSi.current.checked ? cmbUniAlterna.current.value : "0",
	        unidadmedida: cmbUnidMedida.current.value
	      });
	
	      var upload = new FormData();
	
	      upload.append("producto", JSON.stringify(prod));
	      upload.append("codigo", txtIdproducto.current.value.toUpperCase());
	      upload.append("imagenactual", imagen.imagenactual);
	      upload.append("imagennueva", imagen.imagen);
	
	      setBody(upload);
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var tabs = function tabs(vl) {
	    return function (e) {
	      e.preventDefault();
	
	      if (vl === 2 && tabIndex.tab2 !== "") {
	        setACtiveTab({
	          tab1: "nav-link text-light bg-blue-100 rounded",
	          tab2: "nav-link active text-light bg-blue-200 rounded"
	        });
	        setTabValid({ tab1: "false", tab2: "true" });
	        setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
	      } else {
	        setACtiveTab({
	          tab1: "nav-link active text-light bg-blue-100 rounded",
	          tab2: "nav-link text-light bg-blue-200 rounded"
	        });
	        setTabValid({ tab1: "true", tab2: "false" });
	        setTabPanel({
	          tab1: "tab-pane fade show active",
	          tab2: "tab-pane fade "
	        });
	      }
	    };
	  };
	
	  var onChangeMoneda = function onChangeMoneda(e) {
	    var i = e.target.value;
	    var cambio = (0, _varios.onCambioMoneda)({
	      moneda: combomoneda[i],
	      productos: [],
	      monedaPre: moneda,
	      monedaSub: monedaSub
	    });
	    setMonedaCambio(cambio.monedacambio);
	    txtNombre.current.focus();
	  };
	
	  var seleccionarExistencia = function seleccionarExistencia(id, stock) {
	    var campos = "cantidad";
	    var nomtab = "existencia";
	    var nomid = "idproducto";
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token,
	        "Content-Type": "multipart/form-data"
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var cantidad = "";
	
	        if (response.data === "") {
	          cantidad = 0;
	        } else {
	          cantidad = response.data.cantidad;
	        }
	        manesillas(stock, cantidad);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro(idp) {
	    var campos = "*";
	    var nomtab = "producto";
	    var nomid = "codigo";
	    var id = idp.toUpperCase();
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token,
	        "Content-Type": "multipart/form-data"
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          if (response.data.imagen.trim() !== "subir.png" && response.data.imagen.trim() !== null && response.data.imagen.trim() !== "") {
	            setImagen(Object.assign({}, imagen, {
	              imagenactual: response.data.imagen.trim()
	            }));
	            setPathImage({
	              imagen: op.conexion + '/imagen?img=' + organizacion + '/productos/' + response.data.imagen.trim()
	            });
	          }
	
	          if (response.data.vacio !== false) {
	            setValvacio(1);
	            seleccionarClassVacios(1, response.data.idclasevacio);
	          } else {
	            setValvacio(0);
	          }
	
	          txtIdproductoHidden.current.value = response.data.idproducto;
	          chkServicio.current.checked = response.data.servicio;
	          txtIdproducto.current.value = response.data.codigo.trim();
	          txtNombre.current.value = response.data.nombre.trim();
	          txtReferencia.current.value = response.data.referencia;
	          txtNombreCorto.current.value = response.data.nombrecorto.trim();
	          cmbTipoProd.current.value = response.data.idtipoproducto;
	          cmbFabricante.current.value = response.data.idfabricante;
	          txtVacio.current.checked = response.data.vacio;
	          txtDiasGar.current.value = response.data.diasgarantia;
	          cmbMarca.current.value = response.data.marca;
	          cmbModelo.current.value = response.data.modelo;
	          // cmbMoneda.current.value = response.data.idmoneda;
	          cmbUnidMedida.current.value = response.data.idunidadmedida;
	
	          txtIvaCompra.current.value = (0, _varios.formatMoneda)(response.data.ivacompra.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtIvaVenta.current.value = (0, _varios.formatMoneda)(response.data.ivaventa.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          //chkExento.current.checked = response.data.exento;
	          cmbPrecioVenta.current.value = response.data.tipoprecio;
	          cmbMetodoCosto.current.value = response.data.metodocosto;
	          setCostoSelect(response.data.metodocosto);
	          setPrecioSelect(response.data.tipoprecio);
	          //chkAlmacen.current.checked = response.data.almacen;
	          cmbAlmacen.current.value = response.data.almacen ? "true" : "false";
	          txtStockMini.current.value = response.data.stockminimo === null ? "0,00" : (0, _varios.formatMoneda)(response.data.stockminimo.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	          var IvaCompra = response.data.ivacompra / 100;
	          var IvaVenta = response.data.ivaventa / 100;
	
	          txtCostoProveSinImp.current.value = (0, _varios.formatMoneda)(response.data.costoproveedor.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtCostoCalcuSinImp.current.value = (0, _varios.formatMoneda)(response.data.costocalculado.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtUltimoCostoSinImp.current.value = (0, _varios.formatMoneda)(response.data.ultimocosto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtCostoPromeSinImp.current.value = (0, _varios.formatMoneda)(response.data.costopromedio.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	          txtCostoProveConImp.current.value = (0, _varios.formatMoneda)(((1 + IvaCompra) * response.data.costoproveedor).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtCostoCalcuConImp.current.value = (0, _varios.formatMoneda)(((1 + IvaCompra) * response.data.costocalculado).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtUltimoCostoConImp.current.value = (0, _varios.formatMoneda)(((1 + IvaCompra) * response.data.ultimocosto).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtCostoPromeConImp.current.value = (0, _varios.formatMoneda)(((1 + IvaCompra) * response.data.costopromedio).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	          txtPrecioMaxiSinImp.current.value = (0, _varios.formatearMonto)(response.data.preciomaxi, 3);
	          txtPrecioOfeSinImp.current.value = (0, _varios.formatearMonto)(response.data.precioofe, 3);
	          txtPrecioMayorSinImp.current.value = (0, _varios.formatearMonto)(response.data.preciomayor, 3);
	          txtPrecioMiniSinImp.current.value = (0, _varios.formatearMonto)(response.data.preciomini, 3);
	
	          txtUtilidadMaxi.current.value = (0, _varios.formatMoneda)(response.data.utipreciomaxi.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtUtilidadOfe.current.value = (0, _varios.formatMoneda)(response.data.utiprecioofe.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtUtilidadMayor.current.value = (0, _varios.formatMoneda)(response.data.utipreciomayor.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtUtilidadMini.current.value = (0, _varios.formatMoneda)(response.data.utipreciomini.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	          var costo = 0.0;
	
	          if (parseInt(response.data.metodocosto) === 1) {
	            costo = (1 + IvaCompra) * response.data.costoproveedor * IvaVenta;
	          }
	          if (parseInt(response.data.metodocosto) === 2) {
	            costo = (1 + IvaCompra) * response.data.costocalculado * IvaVenta;
	          }
	          if (parseInt(response.data.metodocosto) === 3) {
	            costo = (1 + IvaCompra) * response.data.ultimocosto * IvaVenta;
	          }
	          if (parseInt(response.data.metodocosto) === 4) {
	            costo = (1 + IvaCompra) * response.data.costopromedio * IvaVenta;
	          }
	
	          /*             if (costo > monto) {
	            setAlerta({ ...alerta, maxalt: 1 });
	          } else {
	            setAlerta({ ...alerta, maxalt: 0 });
	          }
	          */
	          txtPrecioMaxiConImp.current.value = (0, _varios.formatMoneda)(((1 + IvaVenta) * parseFloat(response.data.preciomaxi)).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtPrecioOfeConImp.current.value = (0, _varios.formatMoneda)(((1 + IvaVenta) * parseFloat(response.data.precioofe)).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtPrecioMayorConImp.current.value = (0, _varios.formatMoneda)(((1 + IvaVenta) * parseFloat(response.data.preciomayor)).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtPrecioMiniConImp.current.value = (0, _varios.formatMoneda)(((1 + IvaVenta) * parseFloat(response.data.preciomini)).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	          seleccionarExistencia(response.data.idproducto, response.data.stockminimo);
	          //seleccionarSimboloId(response.data.idmoneda);
	          if (response.data.idunidadalterna > 0) {
	            radioSi.current.checked = true;
	            radioNo.current.checked = false;
	            setTabIndex({ tab1: "tab", tab2: "tab" });
	            if (operacion === 2) {
	              setHabilitadoAlter(false);
	            }
	            cmbUniPrincipal.current.value = response.data.idunidadmedida;
	            cmbUniAlterna.current.value = response.data.idunidadalterna;
	            txtFactor.current.value = (0, _varios.formatMoneda)(response.data.valorfactor.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            var uni = [];
	            uni.push({
	              iduni: "0",
	              descripcion: cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex].text + "X" + cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text
	            });
	            uni.push({
	              iduni: "1",
	              descripcion: cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text + "X" + cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex].text
	            });
	            setFactor(uni);
	            /*for (let i = 0; i < uni.length; i++) {
	                          if (uni[i].descripcion === response.data.tipofactor) {
	                              cmbUniFactor.current.value = uni[i].iduni;
	                              break;
	                          }
	                      }*/
	            cmbUniFactor.current.value = response.data.tipofactor;
	            var unic = [];
	            var univ = [];
	            setUnidadC([]);
	            setUnidadV([]);
	
	            unic.push({
	              idunidadmedida: cmbUniPrincipal.current.value,
	              descripcion: cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex].text
	            });
	
	            univ.push({
	              idunidadmedida: cmbUniPrincipal.current.value,
	              descripcion: cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex].text
	            });
	
	            unic.push({
	              idunidadmedida: cmbUniAlterna.current.value,
	              descripcion: cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text
	            });
	            univ.push({
	              idunidadmedida: cmbUniAlterna.current.value,
	              descripcion: cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text
	            });
	            setUnidadC(unic);
	            setUnidadV(univ);
	
	            cmbUniCompra.current.value = response.data.idunidadcompra;
	            cmbUniVenta.current.value = response.data.idunidadventa;
	            /////////////////////////////////////////
	
	            txtCostoProveSinImpAlter.current.value = (0, _varios.formatMoneda)(response.data.costoproveedoralter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtCostoCalcuSinImpAlter.current.value = (0, _varios.formatMoneda)(response.data.costocalculadoalter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtUltimoCostoSinImpAlter.current.value = (0, _varios.formatMoneda)(response.data.ultimocostoalter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtCostoPromeSinImpAlter.current.value = (0, _varios.formatMoneda)(response.data.costopromedioalter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	            txtCostoProveConImpAlter.current.value = (0, _varios.formatMoneda)(((1 + IvaCompra) * response.data.costoproveedoralter).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtCostoCalcuConImpAlter.current.value = (0, _varios.formatMoneda)(((1 + IvaCompra) * response.data.costocalculadoalter).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtUltimoCostoConImpAlter.current.value = (0, _varios.formatMoneda)(((1 + IvaCompra) * response.data.ultimocostoalter).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtCostoPromeConImpAlter.current.value = (0, _varios.formatMoneda)(((1 + IvaCompra) * response.data.costopromedioalter).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	            txtPrecioMaxiSinImpAlter.current.value = (0, _varios.formatMoneda)(response.data.preciomaxialter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtPrecioOfeSinImpAlter.current.value = (0, _varios.formatMoneda)(response.data.precioofealter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtPrecioMayorSinImpAlter.current.value = (0, _varios.formatMoneda)(response.data.preciomayoralter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtPrecioMiniSinImpAlter.current.value = (0, _varios.formatMoneda)(response.data.preciominialter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	            txtUtilidadMaxiAlter.current.value = (0, _varios.formatMoneda)(response.data.utipreciomaxialter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtUtilidadOfeAlter.current.value = (0, _varios.formatMoneda)(response.data.utiprecioofealter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtUtilidadMayorAlter.current.value = (0, _varios.formatMoneda)(response.data.utipreciomayoralter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtUtilidadMiniAlter.current.value = (0, _varios.formatMoneda)(response.data.utipreciominialter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	            var _costo = 0.0;
	
	            if (parseInt(response.data.metodocosto) === 1) {
	              _costo = (1 + IvaCompra) * response.data.costoproveedoralter * IvaVenta;
	            }
	            if (parseInt(response.data.metodocosto) === 2) {
	              _costo = (1 + IvaCompra) * response.data.costocalculadoalter * IvaVenta;
	            }
	            if (parseInt(response.data.metodocosto) === 3) {
	              _costo = (1 + IvaCompra) * response.data.ultimocostoalter * IvaVenta;
	            }
	            if (parseInt(response.data.metodocosto) === 3) {
	              _costo = (1 + IvaCompra) * response.data.costopromedioalter * IvaVenta;
	            }
	
	            txtPrecioMaxiConImpAlter.current.value = (0, _varios.formatMoneda)(((1 + IvaVenta) * parseFloat(response.data.preciomaxialter)).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtPrecioOfeConImpAlter.current.value = (0, _varios.formatMoneda)(((1 + IvaVenta) * parseFloat(response.data.precioofealter)).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtPrecioMayorConImpAlter.current.value = (0, _varios.formatMoneda)(((1 + IvaVenta) * parseFloat(response.data.preciomayoralter)).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtPrecioMiniConImpAlter.current.value = (0, _varios.formatMoneda)(((1 + IvaVenta) * parseFloat(response.data.preciominialter)).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	            txtPrecioMaxiSinImp.current.style.color = parseFloat(response.data.utipreciomaxi) < 0.0 ? "#FB0000" : "#000000";
	            txtPrecioOfeSinImp.current.style.color = parseFloat(response.data.utiprecioofe) < 0.0 ? "#FB0000" : "#000000";
	            txtPrecioMayorSinImp.current.style.color = parseFloat(response.data.utipreciomayor) < 0.0 ? "#FB0000" : "#000000";
	            txtPrecioMiniSinImp.current.style.color = parseFloat(response.data.utipreciomini) < 0.0 ? "#FB0000" : "#000000";
	
	            txtPrecioMaxiSinImpAlter.current.style.color = parseFloat(response.data.utipreciomaxialter) < 0.0 ? "#FB0000" : "#000000";
	            txtPrecioOfeSinImpAlter.current.style.color = parseFloat(response.data.utiprecioofealter) < 0.0 ? "#FB0000" : "#000000";
	            txtPrecioMayorSinImpAlter.current.style.color = parseFloat(response.data.utipreciomayoralter) < 0.0 ? "#FB0000" : "#000000";
	            txtPrecioMiniSinImpAlter.current.style.color = parseFloat(response.data.utipreciominialter) < 0.0 ? "#FB0000" : "#000000";
	          } else {
	            txtPrecioMaxiSinImp.current.style.color = parseFloat(response.data.utipreciomaxi) < 0.0 ? "#FB0000" : "#000000";
	            txtPrecioOfeSinImp.current.style.color = parseFloat(response.data.utiprecioofe) < 0.0 ? "#FB0000" : "#000000";
	            txtPrecioMayorSinImp.current.style.color = parseFloat(response.data.utipreciomayor) < 0.0 ? "#FB0000" : "#000000";
	            txtPrecioMiniSinImp.current.style.color = parseFloat(response.data.utipreciomini) < 0.0 ? "#FB0000" : "#000000";
	
	            radioSi.current.checked = false;
	            radioNo.current.checked = true;
	            setTabIndex({ tab1: "tab", tab2: "" });
	            setHabilitadoAlter(false);
	            blanquearAlter();
	          }
	
	          if (response.data.almacen) {
	            setVisibleA("visible");
	          }
	
	          if (operacion === 2) {
	            setHabilitado(false);
	            // txtCodigo.current.focus();
	          } else {
	            btnAceptar.current.focus();
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Producto no existe.",
	            icono: "informacion"
	          });
	          txtIdproducto.current.value = "";
	          txtIdproducto.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      console.log(error);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + '/api/producto/actualizar/' + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro creado correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro modificado correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro eliminado correctamente",
	            icono: "exito"
	          });
	        }
	        blanquear();
	        blanquearAlter();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = "";
	      if (error.response === undefined) {
	        mensaje = error;
	      } else {
	        mensaje = error.response.data.message;
	      }
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var imprimirAlmacen = function imprimirAlmacen() {
	    if (accbtnproducto && accbtnproducto.toString().substring(4, 5) === "1") {
	      window.open(op.reportes + '/productos?afiliado=' + organizacion + '&reporte=ListaProducto', "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	    props.onHideAceptaProduct(producto);
	    props.onHideCancela();
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'xl',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.ope === 2) {
	          seleccionarMonedas();
	          setVisibleBtn("hidden");
	          setOperacion(props.ope);
	          setHabilitado(false);
	          setHabilitadoAlter(false);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Modificar Producto'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row col-md-12 px-0', style: { margin: 0 } },
	        _react2.default.createElement(
	          'div',
	          { className: 'tipo-letra row mx-auto col-lg-12 mx-auto mt-2 px-0' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav mb-1', id: 'ex-with-icons', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { className: 'nav-item', role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                {
	                  className: activeTab.tab1,
	                  id: 'ex-with-icons-tab-1',
	                  onClick: tabs(1),
	                  'data-mdb-toggle': tabIndex.tab1,
	                  href: '#tab1',
	                  role: 'tab',
	                  'aria-controls': 'tab1',
	                  'aria-selected': tabvalid.tab1
	                },
	                _react2.default.createElement('i', { className: 'fas fa-chart-pie fa-fw me-2' }),
	                'Informaci\xF3n'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'nav-item', role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                {
	                  className: activeTab.tab2,
	                  id: 'ex-with-icons-tab-2',
	                  onClick: tabs(2),
	                  'data-mdb-toggle': tabIndex.tab2,
	                  href: '#tab2',
	                  role: 'tab',
	                  'aria-controls': 'tabs2',
	                  'aria-selected': tabvalid.tab1
	                },
	                _react2.default.createElement('i', { className: 'fas fa-highlighter fa-fw me-2' }),
	                'Unidad Alterna'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'nav-item py-1 px-2' },
	              _react2.default.createElement(
	                'button',
	                {
	                  type: 'button',
	                  className: 'btn btn-sm btn-info rounded-pill',
	                  onClick: imprimirAlmacen
	                },
	                _react2.default.createElement(
	                  'i',
	                  { className: 'fas fa-print' },
	                  ' Productos'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'tab-content',
	              id: 'ex-with-icons-content',
	              style: { fontFamily: "Times New Roman, Times, serif" }
	            },
	            _react2.default.createElement(
	              'div',
	              {
	                className: tabPanel.tab1,
	                id: 'ex-with-icons-tabs-1',
	                role: 'tabpanel',
	                'aria-labelledby': 'ex-with-icons-tab-1'
	              },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'col-md-12 row mx-auto bg-light rounded shadow',
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12 mx-auto row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-2 col-12' },
	                    _react2.default.createElement('input', {
	                      type: 'hidden',
	                      ref: txtIdproductoHidden,
	                      className: 'form-control',
	                      'aria-label': 'Sizing example input',
	                      'aria-describedby': 'inputGroup-sizing-sm'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-2 col-xl-3 col-lg-3 col-md-3 col-sm-3' },
	                    _react2.default.createElement(
	                      'label',
	                      {
	                        className: 'input-group-text',
	                        id: 'inputGroup-sizing-sm'
	                      },
	                      'CODIGO:'
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      disabled: true,
	                      autoComplete: 'off',
	                      ref: txtIdproducto,
	                      onChange: onChange,
	                      name: 'codigo',
	                      className: 'form-control uppercase fs-6',
	                      'aria-label': 'Sizing example input',
	                      'aria-describedby': 'inputGroup-sizing-sm'
	                    })
	                  ),
	                  _react2.default.createElement('div', { className: 'col' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-2 col-pd-260' },
	                    _react2.default.createElement(
	                      'label',
	                      {
	                        className: 'input-group-text',
	                        id: 'inputGroup-sizing-sm'
	                      },
	                      'MONEDA:'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      {
	                        disabled: habilitado,
	                        ref: cmbMoneda,
	                        onChange: onChangeMoneda,
	                        className: 'form-select form-select-sm fw-bold',
	                        'aria-label': '.form-select-sm example'
	                      },
	                      combomoneda && combomoneda.map(function (item, index) {
	                        return _react2.default.createElement(
	                          'option',
	                          { key: index, value: index },
	                          " ",
	                          item.descripcion + ' ' + item.simbolo + ' ' + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xl-4 col-lg-4 col-md-4 col-sm-4' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-check', style: { float: "right" } },
	                      _react2.default.createElement('input', {
	                        className: 'form-check-input',
	                        type: 'checkbox',
	                        disabled: habilitado,
	                        ref: chkServicio,
	                        value: '',
	                        id: 'flexCheckServicio'
	                      }),
	                      _react2.default.createElement(
	                        'label',
	                        {
	                          className: 'form-check-label',
	                          htmlFor: 'flexCheckServicio'
	                        },
	                        'Es un Servicio?'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-2 col-xl-9 col-lg-8 col-md-8 col-sm-8' },
	                    _react2.default.createElement(
	                      'label',
	                      {
	                        className: 'input-group-text',
	                        id: 'inputGroup-sizing-sm'
	                      },
	                      'NOMBRE:'
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      ref: txtNombre,
	                      autoComplete: 'off',
	                      disabled: habilitado,
	                      className: 'form-control text-uppercase fs-6',
	                      'aria-label': 'Sizing example input',
	                      'aria-describedby': 'inputGroup-sizing-sm',
	                      id: 'inputNombre',
	                      onKeyUp: handleInputChange,
	                      onBlur: handleInputChange
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-2 col-xl-3 col-lg-4 col-md-5 col-sm-5' },
	                    _react2.default.createElement(
	                      'label',
	                      {
	                        className: 'input-group-text',
	                        id: 'inputGroup-sizing-sm'
	                      },
	                      'REFERENCIA:'
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      autoComplete: 'off',
	                      ref: txtReferencia,
	                      disabled: habilitado,
	                      className: 'form-control text-uppercase fs-6',
	                      'aria-label': 'Sizing example input',
	                      'aria-describedby': 'inputGroup-sizing-sm',
	                      id: 'inputRefe',
	                      onKeyUp: handleInputChange,
	                      onBlur: handleInputChange
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-2 col-xl-9 col-lg-8 col-md-7 col-sm-7' },
	                    _react2.default.createElement(
	                      'label',
	                      {
	                        className: 'input-group-text',
	                        id: 'inputGroup-sizing-sm'
	                      },
	                      'NOMBRE CORTO:'
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      autoComplete: 'off',
	                      ref: txtNombreCorto,
	                      disabled: habilitado,
	                      className: 'form-control text-uppercase fs-6',
	                      'aria-label': 'Sizing example input',
	                      'aria-describedby': 'inputGroup-sizing-sm',
	                      id: 'inputNombreCorto',
	                      onKeyUp: handleInputChange,
	                      onBlur: handleInputChange
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12 mx-auto mb-1' },
	                  _react2.default.createElement(
	                    'fieldset',
	                    { className: ' row col-sm-12 mx-auto border-azul rounded justify-content-between' },
	                    _react2.default.createElement(
	                      'legend',
	                      {
	                        className: 'float-none w-auto fw-bold',
	                        style: { fontSize: "15px" }
	                      },
	                      'Configuraci\xF3n'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'input-group input-group-sm mb-2 col-xl-6 col-lg-8 col-md-8 col-sm-12' },
	                      _react2.default.createElement(
	                        'label',
	                        {
	                          className: 'input-group-text',
	                          id: 'inputGroup-sizing-sm'
	                        },
	                        'TIPO PRODUCTO/SERVICIO:'
	                      ),
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          disabled: habilitado,
	                          ref: cmbTipoProd,
	                          className: 'form-select form-select-sm ',
	                          'aria-label': '.form-select-sm example'
	                        },
	                        tipoP && tipoP.map(function (tipo) {
	                          return _react2.default.createElement(
	                            'option',
	                            {
	                              key: tipo.idtipoproducto,
	                              value: tipo.idtipoproducto
	                            },
	                            " ",
	                            tipo.descripcion
	                          );
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          disabled: habilitado,
	                          onClick: abrirModal("tipop"),
	                          className: 'btn btn-sm btn-primary rounded-circle mx-1'
	                        },
	                        _react2.default.createElement('i', { className: 'fas fa-plus' }),
	                        " "
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'input-group input-group-sm mb-2 col-xl-6 col-lg-8 col-md-8 col-sm-12' },
	                      _react2.default.createElement(
	                        'label',
	                        {
	                          className: 'input-group-text',
	                          id: 'inputGroup-sizing-sm'
	                        },
	                        'FABRICANTE:'
	                      ),
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          disabled: habilitado,
	                          ref: cmbFabricante,
	                          className: 'form-select form-select-sm ',
	                          'aria-label': '.form-select-sm example'
	                        },
	                        fabri && fabri.map(function (tipo) {
	                          return _react2.default.createElement(
	                            'option',
	                            {
	                              key: tipo.idfabricante,
	                              value: tipo.idfabricante
	                            },
	                            " ",
	                            tipo.descripcion
	                          );
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          disabled: habilitado,
	                          onClick: abrirModal("fabricante"),
	                          className: 'btn btn-sm btn-primary rounded-circle mx-1'
	                        },
	                        _react2.default.createElement('i', { className: 'fas fa-plus' }),
	                        " "
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'input-group input-group-sm mb-2 col-xl-4 col-lg-6 col-md-6 col-sm-6' },
	                      _react2.default.createElement(
	                        'label',
	                        {
	                          className: 'input-group-text',
	                          id: 'inputGroup-sizing-sm'
	                        },
	                        'MARCA:'
	                      ),
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          disabled: habilitado,
	                          ref: cmbMarca,
	                          className: 'form-select form-select-sm',
	                          'aria-label': '.form-select-sm example'
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '0' },
	                          '--seleccione--'
	                        ),
	                        marca && marca.map(function (mark) {
	                          return _react2.default.createElement(
	                            'option',
	                            { key: mark.idmarca, value: mark.idmarca },
	                            " ",
	                            mark.descripcion
	                          );
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          disabled: habilitado,
	                          onClick: abrirModal("marca"),
	                          className: 'btn btn-sm btn-primary rounded-circle mx-1'
	                        },
	                        _react2.default.createElement('i', { className: 'fas fa-plus' }),
	                        " "
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'input-group input-group-sm mb-2 col-xl-4 col-lg-6 col-md-6 col-sm-6' },
	                      _react2.default.createElement(
	                        'label',
	                        {
	                          className: 'input-group-text',
	                          id: 'inputGroup-sizing-sm'
	                        },
	                        'MODELO:'
	                      ),
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          disabled: habilitado,
	                          ref: cmbModelo,
	                          className: 'form-select form-select-sm',
	                          'aria-label': '.form-select-sm example'
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '0' },
	                          '--seleccione--'
	                        ),
	                        modelo && modelo.map(function (mod) {
	                          return _react2.default.createElement(
	                            'option',
	                            { key: mod.idmodelo, value: mod.idmodelo },
	                            " ",
	                            mod.descripcion
	                          );
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          disabled: habilitado,
	                          onClick: abrirModal("modelo"),
	                          className: 'btn btn-sm btn-primary rounded-circle mx-1'
	                        },
	                        _react2.default.createElement('i', { className: 'fas fa-plus' }),
	                        " "
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'input-group input-group-sm mb-2 col-xl-4 col-lg-6 col-md-6 col-sm-6' },
	                      _react2.default.createElement(
	                        'label',
	                        {
	                          className: 'input-group-text',
	                          id: 'inputGroup-sizing-sm'
	                        },
	                        'UNID. MEDIDA:'
	                      ),
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          disabled: habilitado,
	                          ref: cmbUnidMedida,
	                          onChange: onChange,
	                          name: 'idunidadmedida',
	                          id: 'idunidadmedida',
	                          className: 'form-select form-select-sm ',
	                          'aria-label': '.form-select-sm example'
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          '--seleccione--'
	                        ),
	                        unidadM && unidadM.map(function (unimedi) {
	                          return _react2.default.createElement(
	                            'option',
	                            {
	                              key: unimedi.idunidadmedida,
	                              value: unimedi.idunidadmedida
	                            },
	                            " ",
	                            unimedi.descripcion
	                          );
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          disabled: habilitado,
	                          onClick: abrirModal("medida"),
	                          className: 'btn btn-sm btn-primary rounded-circle mx-1'
	                        },
	                        _react2.default.createElement('i', { className: 'fas fa-plus' }),
	                        " "
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'input-group input-group-sm mb-2 col-pd-210 px-1' },
	                      _react2.default.createElement(
	                        'label',
	                        {
	                          className: 'input-group-text text-right',
	                          id: 'inputGroup-sizing-sm'
	                        },
	                        '% IVA COMPRA:'
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'text',
	                        autoComplete: 'off',
	                        disabled: habilitado,
	                        ref: txtIvaCompra,
	                        className: 'form-control form-control-sm text-right fs-6',
	                        'aria-label': 'Sizing example input',
	                        'aria-describedby': 'inputGroup-sizing-sm',
	                        id: 'ivaCompra',
	                        onFocus: _varios.seleccionarCampo,
	                        onKeyUp: handleInputMontoChange,
	                        onBlur: handleInputMontoChange
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'input-group input-group-sm mb-2 col-pd-210 px-2' },
	                      _react2.default.createElement(
	                        'label',
	                        {
	                          className: 'input-group-text text-right',
	                          id: 'inputGroup-sizing-sm'
	                        },
	                        '% IVA VENTA:'
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'text',
	                        autoComplete: 'off',
	                        disabled: habilitado,
	                        ref: txtIvaVenta,
	                        className: 'form-control form-control-sm text-right fs-6',
	                        'aria-label': 'Sizing example input',
	                        'aria-describedby': 'inputGroup-sizing-sm',
	                        id: 'ivaVenta',
	                        onFocus: _varios.seleccionarCampo,
	                        onKeyUp: handleInputMontoChange,
	                        onBlur: handleInputMontoChange
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'input-group input-group-sm mb-2 col-xl-3 col-lg-4 col-md-4 col-sm-4' },
	                      _react2.default.createElement(
	                        'label',
	                        {
	                          className: 'input-group-text',
	                          id: 'inputGroup-sizing-sm'
	                        },
	                        'DIAS GARANTIA:'
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'number',
	                        disabled: habilitado,
	                        ref: txtDiasGar,
	                        className: 'form-control fs-6',
	                        'aria-label': 'Sizing example input',
	                        'aria-describedby': 'inputGroup-sizing-sm',
	                        id: 'inputDiasGar',
	                        onKeyUp: handleInputChange,
	                        onBlur: handleInputChange
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'input-group input-group-sm mb-2 col-xl-4 col-lg-6 col-md-6 col-sm-6' },
	                      _react2.default.createElement(
	                        'label',
	                        {
	                          className: 'input-group-text',
	                          id: 'inputGroup-sizing-sm'
	                        },
	                        'DESTINO:'
	                      ),
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          disabled: habilitado,
	                          ref: cmbAlmacen,
	                          name: 'almacen',
	                          onChange: onChange,
	                          className: 'form-select form-select-sm ',
	                          'aria-label': '.form-select-sm example'
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'true' },
	                          'ALMACEN'
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 'false' },
	                          'USO INTERNO'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        className: 'input-group input-group-sm mb-2 col-pd-230',
	                        style: { visibility: visibleA }
	                      },
	                      _react2.default.createElement(
	                        'label',
	                        {
	                          className: 'input-group-text text-right',
	                          id: 'inputGroup-sizing-sm'
	                        },
	                        'STOCK MINIMO:'
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'text',
	                        autoComplete: 'off',
	                        disabled: true,
	                        ref: txtStockMini,
	                        className: 'form-control form-control-sm text-right fs-6',
	                        'aria-label': 'Sizing example input',
	                        'aria-describedby': 'inputGroup-sizing-sm',
	                        id: 'stockminimo',
	                        defaultValue: '0,00',
	                        onFocus: _varios.seleccionarCampo,
	                        onKeyUp: handleInputMontoChange,
	                        onBlur: handleInputMontoChange
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-pd-230' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check' },
	                        _react2.default.createElement('input', {
	                          className: 'form-check-input',
	                          type: 'checkbox',
	                          disabled: habilitado,
	                          ref: txtVacio,
	                          onChange: onChange,
	                          value: '',
	                          id: 'chekvacio'
	                        }),
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'form-check-label',
	                            htmlFor: 'chekvacio'
	                          },
	                          'Vacio?'
	                        )
	                      )
	                    ),
	                    valvacio === 1 ? _react2.default.createElement(
	                      'div',
	                      { className: 'input-group input-group-sm mb-2 col-pd-350 px-2' },
	                      _react2.default.createElement(
	                        'label',
	                        {
	                          className: 'input-group-text',
	                          id: 'inputGroup-sizing-sm'
	                        },
	                        'TIPO VACIO:'
	                      ),
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          disabled: habilitado,
	                          ref: txtCodigoVacio,
	                          onChange: onChange,
	                          name: 'idclasevacio',
	                          id: 'idclasevacio',
	                          className: 'form-select form-select-sm ',
	                          'aria-label': '.form-select-sm example'
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          '--seleccione--'
	                        ),
	                        classvacios && classvacios.map(function (unimedi) {
	                          return _react2.default.createElement(
	                            'option',
	                            {
	                              key: unimedi.idclasevacio,
	                              value: unimedi.idclasevacio
	                            },
	                            " ",
	                            unimedi.descripcion
	                          );
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          disabled: habilitado,
	                          onClick: abrirModal("classvacios"),
	                          className: 'btn btn-sm btn-primary rounded-circle mx-1'
	                        },
	                        _react2.default.createElement('i', { className: 'fas fa-plus' }),
	                        " "
	                      )
	                    ) : ""
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    className: 'col-md-12 mx-auto row mb-1',
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xl-6 px-0' },
	                    _react2.default.createElement(
	                      'fieldset',
	                      { className: ' row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between pb-0' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'input-group input-group-sm mb-2 col-sm-12 px-2' },
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'input-group-text',
	                            id: 'inputGroup-sizing-sm'
	                          },
	                          'METODO DE COSTO:'
	                        ),
	                        _react2.default.createElement(
	                          'select',
	                          {
	                            disabled: habilitado,
	                            ref: cmbMetodoCosto,
	                            className: 'form-select form-select-sm bg-info',
	                            'aria-label': '.form-select-sm example',
	                            name: 'metodocosto',
	                            onChange: onChange,
	                            defaultValue: 1
	                          },
	                          _react2.default.createElement(
	                            'option',
	                            { value: '1' },
	                            'COSTO PROVEEDOR'
	                          ),
	                          _react2.default.createElement(
	                            'option',
	                            { value: '2' },
	                            'COSTO CALCULADO'
	                          ),
	                          _react2.default.createElement(
	                            'option',
	                            { value: '3' },
	                            'ULTIMO COSTO'
	                          ),
	                          _react2.default.createElement(
	                            'option',
	                            { value: '4' },
	                            'COSTO PROMEDIO'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'table',
	                        { className: 'table table-sm col-md-12 border bg-light' },
	                        _react2.default.createElement(
	                          'thead',
	                          { className: 'azulGradiant text-light fw-bold' },
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'th',
	                              { className: 'text-center', scope: 'col' },
	                              _react2.default.createElement(
	                                'label',
	                                { style: { fontSize: "11px" } },
	                                'COSTOS'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'th',
	                              { className: 'text-center', scope: 'col' },
	                              _react2.default.createElement(
	                                'label',
	                                { style: { fontSize: "11px" } },
	                                'SIN IMPUESTO'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'th',
	                              {
	                                className: 'text-center border-right border-light',
	                                scope: 'col'
	                              },
	                              _react2.default.createElement(
	                                'label',
	                                { style: { fontSize: "11px" } },
	                                'CON IMPUESTO'
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'tbody',
	                          null,
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'text-center border-left' },
	                              costoSelect === "1" && _react2.default.createElement('i', { className: 'fas fa-arrow-right text-danger' }),
	                              " ",
	                              'Costo Proveedor: ',
	                              _react2.default.createElement(
	                                'b',
	                                null,
	                                monedaCambio.simbolo
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { style: { width: "30%" } },
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                autoComplete: 'off',
	                                disabled: habilitado,
	                                ref: txtCostoProveSinImp,
	                                className: 'form-control form-control-sm text-right fs-6',
	                                id: 'costoProveSinImpu',
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange
	                              })
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              {
	                                className: 'border-right',
	                                style: { width: "30%" }
	                              },
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                disabled: true,
	                                ref: txtCostoProveConImp,
	                                className: 'form-control form-control-sm text-right fs-6'
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'text-center border-left' },
	                              costoSelect === "2" && _react2.default.createElement('i', { className: 'fas fa-arrow-right text-danger' }),
	                              " ",
	                              'Costo Calculado: ',
	                              _react2.default.createElement(
	                                'b',
	                                null,
	                                monedaCambio.simbolo
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                autoComplete: 'off',
	                                disabled: habilitado,
	                                ref: txtCostoCalcuSinImp,
	                                className: 'form-control form-control-sm text-right fs-6',
	                                id: 'costoCalcuSinImpu',
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange
	                              })
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'border-right' },
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                disabled: true,
	                                ref: txtCostoCalcuConImp,
	                                className: 'form-control form-control-sm text-right fs-6'
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'text-center border-left' },
	                              costoSelect === "3" && _react2.default.createElement('i', { className: 'fas fa-arrow-right text-danger' }),
	                              " ",
	                              'Ultimo Costo: ',
	                              _react2.default.createElement(
	                                'b',
	                                null,
	                                monedaCambio.simbolo
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                autoComplete: 'off',
	                                disabled: habilitado,
	                                ref: txtUltimoCostoSinImp,
	                                className: 'form-control form-control-sm text-right fs-6',
	                                id: 'costoUltiSinImpu',
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange
	                              })
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'border-right' },
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                disabled: true,
	                                ref: txtUltimoCostoConImp,
	                                className: 'form-control form-control-sm text-right fs-6'
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'text-center border-left' },
	                              costoSelect === "4" && _react2.default.createElement('i', { className: 'fas fa-arrow-right text-danger' }),
	                              " ",
	                              'Costo Promedio: ',
	                              _react2.default.createElement(
	                                'b',
	                                null,
	                                monedaCambio.simbolo
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                autoComplete: 'off',
	                                disabled: habilitado,
	                                ref: txtCostoPromeSinImp,
	                                className: 'form-control form-control-sm text-right fs-6',
	                                id: 'costoPromeSinImpu',
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange
	                              })
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'border-right' },
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                disabled: true,
	                                ref: txtCostoPromeConImp,
	                                className: 'form-control form-control-sm text-right fs-6'
	                              })
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-xl-6 px-0' },
	                    _react2.default.createElement(
	                      'fieldset',
	                      { className: ' row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between pb-0' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'input-group input-group-sm mb-2 col-sm-12 px-2' },
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'input-group-text',
	                            id: 'inputGroup-sizing-sm'
	                          },
	                          'PRECIO VENTA:'
	                        ),
	                        _react2.default.createElement(
	                          'select',
	                          {
	                            disabled: habilitado,
	                            ref: cmbPrecioVenta,
	                            onChange: function onChange(e) {
	                              return setPrecioSelect(e.target.value);
	                            },
	                            className: 'form-select form-select-sm bg-success',
	                            'aria-label': '.form-select-sm example',
	                            defaultValue: '1'
	                          },
	                          _react2.default.createElement(
	                            'option',
	                            { value: '1' },
	                            'MAXIMO'
	                          ),
	                          _react2.default.createElement(
	                            'option',
	                            { value: '2' },
	                            'OFERTA'
	                          ),
	                          _react2.default.createElement(
	                            'option',
	                            { value: '3' },
	                            'MAYOR'
	                          ),
	                          _react2.default.createElement(
	                            'option',
	                            { value: '4' },
	                            'MINIMO'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'table',
	                        { className: 'table table-sm col-md-12 border bg-light' },
	                        _react2.default.createElement(
	                          'thead',
	                          { className: 'azulGradiant text-light fw-bold' },
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'th',
	                              { className: 'text-center', scope: 'col' },
	                              _react2.default.createElement(
	                                'label',
	                                { style: { fontSize: "11px" } },
	                                'PRECIOS'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'th',
	                              { className: 'text-center ', scope: 'col' },
	                              _react2.default.createElement(
	                                'label',
	                                { style: { fontSize: "11px" } },
	                                'SIN IMPUESTO'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'th',
	                              { className: 'text-center', scope: 'col' },
	                              _react2.default.createElement(
	                                'label',
	                                { style: { fontSize: "11px" } },
	                                'UTILIDAD %'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'th',
	                              { className: 'text-center', scope: 'col' },
	                              _react2.default.createElement(
	                                'label',
	                                { style: { fontSize: "11px" } },
	                                'CON IMPUESTO'
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'tbody',
	                          null,
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              {
	                                style: { width: "15%" },
	                                className: 'text-center'
	                              },
	                              precioSelect === "1" && _react2.default.createElement('i', { className: 'fas fa-arrow-right text-danger' }),
	                              " ",
	                              'Maximo: ',
	                              _react2.default.createElement(
	                                'b',
	                                null,
	                                monedaCambio.simbolo
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              {
	                                style: {
	                                  width: "12%"
	                                }
	                              },
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                autoComplete: 'off',
	                                disabled: habilitado,
	                                style: {
	                                  color: "#000000"
	                                },
	                                id: 'preciomaximo',
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange,
	                                ref: txtPrecioMaxiSinImp,
	                                className: 'form-control form-control-sm text-right fs-6'
	                              })
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { style: { width: "12%" } },
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                autoComplete: 'off',
	                                disabled: habilitado,
	                                ref: txtUtilidadMaxi,
	                                className: 'form-control form-control-sm text-right fs-6',
	                                id: 'utilidadMaxi',
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange
	                              })
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              {
	                                className: 'border-right',
	                                style: { width: "15%" }
	                              },
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                disabled: true,
	                                ref: txtPrecioMaxiConImp,
	                                className: 'form-control form-control-sm text-right fs-6'
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              {
	                                style: { width: "15%" },
	                                className: 'text-center'
	                              },
	                              precioSelect === "2" && _react2.default.createElement('i', { className: 'fas fa-arrow-right text-danger' }),
	                              " ",
	                              'Oferta: ',
	                              _react2.default.createElement(
	                                'b',
	                                null,
	                                monedaCambio.simbolo
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                autoComplete: 'off',
	                                disabled: habilitado,
	                                style: {
	                                  color: "#000000"
	                                },
	                                id: 'preciooferta',
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange,
	                                ref: txtPrecioOfeSinImp,
	                                className: 'form-control form-control-sm text-right fs-6'
	                              })
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                autoComplete: 'off',
	                                disabled: habilitado,
	                                ref: txtUtilidadOfe,
	                                className: 'form-control form-control-sm text-right fs-6',
	                                id: 'utilidadOfe',
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange
	                              })
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'border-right' },
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                disabled: true,
	                                ref: txtPrecioOfeConImp,
	                                className: 'form-control form-control-sm text-right fs-6'
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              {
	                                style: { width: "15%" },
	                                className: 'text-center'
	                              },
	                              precioSelect === "3" && _react2.default.createElement('i', { className: 'fas fa-arrow-right text-danger' }),
	                              " ",
	                              'Mayor: ',
	                              _react2.default.createElement(
	                                'b',
	                                null,
	                                monedaCambio.simbolo
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                autoComplete: 'off',
	                                disabled: habilitado,
	                                style: {
	                                  color: "#000000"
	                                },
	                                id: 'preciomayor',
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange,
	                                ref: txtPrecioMayorSinImp,
	                                className: 'form-control form-control-sm text-right fs-6'
	                              })
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                autoComplete: 'off',
	                                disabled: habilitado,
	                                ref: txtUtilidadMayor,
	                                className: 'form-control form-control-sm text-right fs-6',
	                                id: 'utilidadMayor',
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange
	                              })
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'border-right' },
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                disabled: true,
	                                ref: txtPrecioMayorConImp,
	                                className: 'form-control form-control-sm text-right fs-6'
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                              'td',
	                              {
	                                style: { width: "15%" },
	                                className: 'text-center'
	                              },
	                              precioSelect === "4" && _react2.default.createElement('i', { className: 'fas fa-arrow-right text-danger' }),
	                              " ",
	                              'Minimo: ',
	                              _react2.default.createElement(
	                                'b',
	                                null,
	                                monedaCambio.simbolo
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                autoComplete: 'off',
	                                disabled: habilitado,
	                                style: {
	                                  color: "#000000"
	                                },
	                                id: 'preciominimo',
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange,
	                                ref: txtPrecioMiniSinImp,
	                                className: 'form-control form-control-sm text-right fs-6'
	                              })
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              null,
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                autoComplete: 'off',
	                                disabled: habilitado,
	                                ref: txtUtilidadMini,
	                                className: 'form-control form-control-sm text-right fs-6',
	                                id: 'utilidadMini',
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange
	                              })
	                            ),
	                            _react2.default.createElement(
	                              'td',
	                              { className: 'border-right' },
	                              _react2.default.createElement('input', {
	                                type: 'text',
	                                disabled: true,
	                                ref: txtPrecioMiniConImp,
	                                className: 'form-control form-control-sm text-right fs-6'
	                              })
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12 row mx-auto m-0 mb-1' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-5 ml-auto' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'row align-items-center rounded py-1' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: ' fw-bold col-md-6 mb-0 fs-6' },
	                        'Unidad Alterna'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col row align-items-center' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-check col' },
	                          _react2.default.createElement('input', {
	                            className: 'form-check-input mt-0',
	                            type: 'radio',
	                            disabled: habilitado,
	                            ref: radioSi,
	                            name: 'flexRadioDefault',
	                            id: 'flexRadioDefault1',
	                            onChange: unidadAlterna
	                          }),
	                          _react2.default.createElement(
	                            'label',
	                            {
	                              className: 'form-check-label fs-6',
	                              htmlFor: 'flexRadioDefault1'
	                            },
	                            'Si'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'col row align-items-center' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-check col' },
	                          _react2.default.createElement('input', {
	                            className: 'form-check-input mt-0',
	                            type: 'radio',
	                            disabled: habilitado,
	                            ref: radioNo,
	                            name: 'flexRadioDefault',
	                            id: 'flexRadioDefault1',
	                            onChange: unidadAlterna
	                          }),
	                          _react2.default.createElement(
	                            'label',
	                            {
	                              className: 'form-check-label fs-6',
	                              htmlFor: 'flexRadioDefault1'
	                            },
	                            'No'
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: tabPanel.tab2,
	                id: 'ex-with-icons-tabs-2',
	                role: 'tabpanel',
	                'aria-labelledby': 'ex-with-icons-tab-2'
	              },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'col-md-12 row m-0 px-0',
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12 row mx-auto bg-light rounded shadow py-3' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 mx-auto mb-' },
	                    _react2.default.createElement(
	                      'fieldset',
	                      { className: ' row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between' },
	                      _react2.default.createElement(
	                        'legend',
	                        {
	                          className: 'float-none w-auto fw-bold',
	                          style: { fontSize: "15px" }
	                        },
	                        'Configuraci\xF3n'
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'input-group input-group-sm mb-2 col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'input-group-text',
	                            id: 'inputGroup-sizing-sm'
	                          },
	                          'UNID. PRINCIPAL:'
	                        ),
	                        _react2.default.createElement(
	                          'select',
	                          {
	                            disabled: habilitadoAlter,
	                            ref: cmbUniPrincipal,
	                            className: 'form-select form-select-sm ',
	                            'aria-label': '.form-select-sm example',
	                            name: 'unidadP',
	                            onChange: onChange
	                          },
	                          _react2.default.createElement(
	                            'option',
	                            { value: '' },
	                            '--seleccione--'
	                          ),
	                          unidadM && unidadM.map(function (unimedi) {
	                            return _react2.default.createElement(
	                              'option',
	                              {
	                                key: unimedi.idunidadmedida,
	                                value: unimedi.idunidadmedida
	                              },
	                              " ",
	                              unimedi.descripcion
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'input-group input-group-sm mb-2 col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'input-group-text',
	                            id: 'inputGroup-sizing-sm'
	                          },
	                          'UNID. ALTERNA:'
	                        ),
	                        _react2.default.createElement(
	                          'select',
	                          {
	                            disabled: habilitadoAlter,
	                            ref: cmbUniAlterna,
	                            className: 'form-select form-select-sm ',
	                            'aria-label': '.form-select-sm example',
	                            name: 'unidadA',
	                            onChange: onChange
	                          },
	                          unidadM && unidadM.map(function (unimedi) {
	                            return _react2.default.createElement(
	                              'option',
	                              {
	                                key: unimedi.idunidadmedida,
	                                value: unimedi.idunidadmedida
	                              },
	                              " ",
	                              unimedi.descripcion
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'input-group input-group-sm mb-2 col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'input-group-text',
	                            id: 'inputGroup-sizing-sm'
	                          },
	                          'UNID. VENTA:'
	                        ),
	                        _react2.default.createElement(
	                          'select',
	                          {
	                            disabled: habilitadoAlter,
	                            ref: cmbUniVenta,
	                            className: 'form-select form-select-sm ',
	                            'aria-label': '.form-select-sm example'
	                          },
	                          unidadV && unidadV.map(function (univ) {
	                            return _react2.default.createElement(
	                              'option',
	                              {
	                                key: univ.idunidadmedida,
	                                value: univ.idunidadmedida
	                              },
	                              univ.descripcion
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'input-group input-group-sm mb-2 col-md-7' },
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'input-group-text',
	                            id: 'inputGroup-sizing-sm'
	                          },
	                          " ",
	                          'FACTOR CONVERSION:'
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'text',
	                          autoComplete: 'off',
	                          disabled: habilitadoAlter,
	                          ref: txtFactor,
	                          className: 'form-control col-md-3 form-control-sm text-right fs-6',
	                          'aria-label': 'Sizing example input',
	                          'aria-describedby': 'inputGroup-sizing-sm',
	                          id: 'factorConver',
	                          onFocus: _varios.seleccionarCampo,
	                          onKeyUp: handleInputMontoChange,
	                          onBlur: handleInputMontoChange
	                        }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'px-2' },
	                          'x'
	                        ),
	                        _react2.default.createElement(
	                          'select',
	                          {
	                            disabled: habilitadoAlter,
	                            ref: cmbUniFactor,
	                            className: 'form-select form-select-sm ',
	                            'aria-label': '.form-select-sm example',
	                            name: 'unifactor',
	                            onChange: onChange
	                          },
	                          factor && factor.map(function (fac) {
	                            return _react2.default.createElement(
	                              'option',
	                              { key: fac.iduni, value: fac.iduni },
	                              " ",
	                              fac.descripcion
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'input-group input-group-sm mb-2 col-md-4' },
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'input-group-text',
	                            id: 'inputGroup-sizing-sm'
	                          },
	                          'UNID. COMPRA:'
	                        ),
	                        _react2.default.createElement(
	                          'select',
	                          {
	                            disabled: habilitadoAlter,
	                            ref: cmbUniCompra,
	                            className: 'form-select form-select-sm ',
	                            'aria-label': '.form-select-sm example'
	                          },
	                          unidadC && unidadC.map(function (unic) {
	                            return _react2.default.createElement(
	                              'option',
	                              {
	                                key: unic.idunidadmedida,
	                                value: unic.idunidadmedida
	                              },
	                              unic.descripcion
	                            );
	                          })
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement('div', { className: 'input-group input-group-sm mb-2 col-md-8' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-1 col-md-5 ml-auto' },
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        className: 'btn btn-primary w-100',
	                        id: 'inputGroup-sizing-sm',
	                        onClick: function onClick() {
	                          txtUtilidadMaxiAlter.current.value = txtUtilidadMaxi.current.value;
	                          txtUtilidadOfeAlter.current.value = txtUtilidadOfe.current.value;
	                          txtUtilidadMayorAlter.current.value = txtUtilidadMayor.current.value;
	                          txtUtilidadMiniAlter.current.value = txtUtilidadMini.current.value;
	                          txtPrecioMaxiSinImpAlter.current.style.color = txtPrecioMaxiSinImp.current.style.color;
	                          txtPrecioOfeSinImpAlter.current.style.color = txtPrecioOfeSinImp.current.style.color;
	                          txtPrecioMayorSinImpAlter.current.style.color = txtPrecioMayorSinImp.current.style.color;
	                          txtPrecioMiniSinImpAlter.current.style.color = txtPrecioMiniSinImp.current.style.color;
	                          calcularUtilidadAlter(5);
	                        }
	                      },
	                      _react2.default.createElement(
	                        'i',
	                        { className: 'fas fa-exchange-alt' },
	                        " ",
	                        'APLICAR % DE UTILIDAD DE LA UNIDAD PRINCIPAL'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 mx-auto row mt-2 mb-2' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-6 px-0' },
	                      _react2.default.createElement(
	                        'fieldset',
	                        { className: 'row col-sm-12 border-azul rounded d-flex justify-content-between' },
	                        _react2.default.createElement(
	                          'table',
	                          { className: 'table table-sm col-md-12 border bg-light' },
	                          _react2.default.createElement(
	                            'thead',
	                            { className: 'azulGradiant text-light fw-bold' },
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'th',
	                                { className: 'text-center', scope: 'col' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { style: { fontSize: "11px" } },
	                                  'COSTOS'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'th',
	                                { className: 'text-center', scope: 'col' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { style: { fontSize: "11px" } },
	                                  'SIN IMPUESTO'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'th',
	                                {
	                                  className: 'text-center border-right border-light',
	                                  scope: 'col'
	                                },
	                                _react2.default.createElement(
	                                  'label',
	                                  { style: { fontSize: "11px" } },
	                                  'CON IMPUESTO'
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'tbody',
	                            null,
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                { className: 'text-center border-left' },
	                                costoSelect === "1" && _react2.default.createElement('i', { className: 'fas fa-arrow-right text-danger' }),
	                                " ",
	                                'Costo Proveedor:',
	                                " ",
	                                _react2.default.createElement(
	                                  'b',
	                                  null,
	                                  monedaCambio.simbolo
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                { style: { width: "30%" } },
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  autoComplete: 'off',
	                                  disabled: habilitadoAlter,
	                                  ref: txtCostoProveSinImpAlter,
	                                  className: 'form-control form-control-sm text-right fs-6',
	                                  id: 'costoProveSinImpuAlter',
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange
	                                })
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                {
	                                  className: 'border-right',
	                                  style: { width: "30%" }
	                                },
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  disabled: true,
	                                  ref: txtCostoProveConImpAlter,
	                                  className: 'form-control form-control-sm text-right fs-6'
	                                })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                { className: 'text-center border-left' },
	                                costoSelect === "2" && _react2.default.createElement('i', { className: 'fas fa-arrow-right text-danger' }),
	                                " ",
	                                'Costo Calculado:',
	                                " ",
	                                _react2.default.createElement(
	                                  'b',
	                                  null,
	                                  monedaCambio.simbolo
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  autoComplete: 'off',
	                                  disabled: habilitadoAlter,
	                                  ref: txtCostoCalcuSinImpAlter,
	                                  className: 'form-control form-control-sm text-right fs-6',
	                                  id: 'costoCalcuSinImpuAlter',
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange
	                                })
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                { className: 'border-right' },
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  disabled: true,
	                                  ref: txtCostoCalcuConImpAlter,
	                                  className: 'form-control form-control-sm text-right fs-6'
	                                })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                { className: 'text-center border-left' },
	                                costoSelect === "3" && _react2.default.createElement('i', { className: 'fas fa-arrow-right text-danger' }),
	                                " ",
	                                'Ultimo Costo: ',
	                                _react2.default.createElement(
	                                  'b',
	                                  null,
	                                  monedaCambio.simbolo
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  autoComplete: 'off',
	                                  disabled: habilitadoAlter,
	                                  ref: txtUltimoCostoSinImpAlter,
	                                  className: 'form-control form-control-sm text-right fs-6',
	                                  id: 'costoUltiSinImpuAlter',
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange
	                                })
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                { className: 'border-right' },
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  disabled: true,
	                                  ref: txtUltimoCostoConImpAlter,
	                                  className: 'form-control form-control-sm text-right fs-6'
	                                })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                { className: 'text-center border-left' },
	                                costoSelect === "4" && _react2.default.createElement('i', { className: 'fas fa-arrow-right text-danger' }),
	                                " ",
	                                'Costo Promedio:',
	                                " ",
	                                _react2.default.createElement(
	                                  'b',
	                                  null,
	                                  monedaCambio.simbolo
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  autoComplete: 'off',
	                                  disabled: habilitadoAlter,
	                                  ref: txtCostoPromeSinImpAlter,
	                                  className: 'form-control form-control-sm text-right fs-6',
	                                  id: 'costoPromeSinImpuAlter',
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange
	                                })
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                { className: 'border-right' },
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  disabled: true,
	                                  ref: txtCostoPromeConImpAlter,
	                                  className: 'form-control form-control-sm text-right fs-6'
	                                })
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-6 px-0' },
	                      _react2.default.createElement(
	                        'fieldset',
	                        { className: ' row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between' },
	                        _react2.default.createElement(
	                          'table',
	                          { className: 'table table-sm col-md-12 border bg-light' },
	                          _react2.default.createElement(
	                            'thead',
	                            { className: 'azulGradiant text-light fw-bold' },
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'th',
	                                { className: 'text-center', scope: 'col' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { style: { fontSize: "11px" } },
	                                  'PRECIOS'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'th',
	                                { className: 'text-center ', scope: 'col' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { style: { fontSize: "11px" } },
	                                  'SIN IMPUESTO'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'th',
	                                { className: 'text-center', scope: 'col' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { style: { fontSize: "11px" } },
	                                  'UTILIDAD %'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'th',
	                                { className: 'text-center', scope: 'col' },
	                                _react2.default.createElement(
	                                  'label',
	                                  { style: { fontSize: "11px" } },
	                                  'CON IMPUESTO'
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'tbody',
	                            null,
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                {
	                                  style: { width: "15%" },
	                                  className: 'text-center'
	                                },
	                                precioSelect === "1" && _react2.default.createElement('i', { className: 'fas fa-arrow-right text-danger' }),
	                                " ",
	                                'Maximo: ',
	                                _react2.default.createElement(
	                                  'b',
	                                  null,
	                                  monedaCambio.simbolo
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                { style: { width: "15%" } },
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  autoComplete: 'off',
	                                  disabled: habilitadoAlter,
	                                  style: {
	                                    color: "#000000"
	                                  },
	                                  id: 'preciomaximoalter',
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange,
	                                  ref: txtPrecioMaxiSinImpAlter,
	                                  className: 'form-control form-control-sm text-right fs-6'
	                                })
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                { style: { width: "12%" } },
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  autoComplete: 'off',
	                                  disabled: habilitadoAlter,
	                                  ref: txtUtilidadMaxiAlter,
	                                  className: 'form-control form-control-sm text-right fs-6',
	                                  id: 'utilidadMaxiAlter',
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange
	                                })
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                {
	                                  className: 'border-right',
	                                  style: { width: "18%" }
	                                },
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  disabled: true,
	                                  ref: txtPrecioMaxiConImpAlter,
	                                  className: 'form-control form-control-sm text-right fs-6'
	                                })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                {
	                                  style: { width: "15%" },
	                                  className: 'text-center'
	                                },
	                                precioSelect === "2" && _react2.default.createElement('i', { className: 'fas fa-arrow-right text-danger' }),
	                                " ",
	                                'Oferta: ',
	                                _react2.default.createElement(
	                                  'b',
	                                  null,
	                                  monedaCambio.simbolo
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  autoComplete: 'off',
	                                  disabled: habilitadoAlter,
	                                  style: {
	                                    color: "#000000"
	                                  },
	                                  id: 'precioofertaalter',
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange,
	                                  ref: txtPrecioOfeSinImpAlter,
	                                  className: 'form-control form-control-sm text-right fs-6'
	                                })
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  autoComplete: 'off',
	                                  disabled: habilitadoAlter,
	                                  ref: txtUtilidadOfeAlter,
	                                  className: 'form-control form-control-sm text-right fs-6',
	                                  id: 'utilidadOfeAlter',
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange
	                                })
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                { className: 'border-right' },
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  disabled: true,
	                                  ref: txtPrecioOfeConImpAlter,
	                                  className: 'form-control form-control-sm text-right fs-6'
	                                })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                {
	                                  style: { width: "15%" },
	                                  className: 'text-center'
	                                },
	                                precioSelect === "3" && _react2.default.createElement('i', { className: 'fas fa-arrow-right text-danger' }),
	                                " ",
	                                'Mayor: ',
	                                _react2.default.createElement(
	                                  'b',
	                                  null,
	                                  monedaCambio.simbolo
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  autoComplete: 'off',
	                                  disabled: habilitadoAlter,
	                                  id: 'preciomayoralter',
	                                  style: {
	                                    color: "#000000"
	                                  },
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange,
	                                  ref: txtPrecioMayorSinImpAlter,
	                                  className: 'form-control form-control-sm text-right fs-6'
	                                })
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  autoComplete: 'off',
	                                  disabled: habilitadoAlter,
	                                  ref: txtUtilidadMayorAlter,
	                                  className: 'form-control form-control-sm text-right fs-6',
	                                  id: 'utilidadMayorAlter',
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange
	                                })
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                { className: 'border-right' },
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  disabled: true,
	                                  ref: txtPrecioMayorConImpAlter,
	                                  className: 'form-control form-control-sm text-right fs-6'
	                                })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'tr',
	                              null,
	                              _react2.default.createElement(
	                                'td',
	                                {
	                                  style: { width: "15%" },
	                                  className: 'text-center'
	                                },
	                                precioSelect === "4" && _react2.default.createElement('i', { className: 'fas fa-arrow-right text-danger' }),
	                                " ",
	                                'Minimo: ',
	                                _react2.default.createElement(
	                                  'b',
	                                  null,
	                                  monedaCambio.simbolo
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  autoComplete: 'off',
	                                  disabled: habilitadoAlter,
	                                  id: 'preciominialter',
	                                  style: {
	                                    color: "#000000"
	                                  },
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange,
	                                  ref: txtPrecioMiniSinImpAlter,
	                                  className: 'form-control form-control-sm text-right fs-6'
	                                })
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  autoComplete: 'off',
	                                  disabled: habilitadoAlter,
	                                  ref: txtUtilidadMiniAlter,
	                                  className: 'form-control form-control-sm text-right fs-6',
	                                  id: 'utilidadMiniAlter',
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange
	                                })
	                              ),
	                              _react2.default.createElement(
	                                'td',
	                                { className: 'border-right' },
	                                _react2.default.createElement('input', {
	                                  type: 'text',
	                                  disabled: true,
	                                  ref: txtPrecioMiniConImpAlter,
	                                  className: 'form-control form-control-sm text-right fs-6'
	                                })
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement('div', {
	              className: 'tab-pane fade',
	              id: 'ex-with-icons-tabs-3',
	              role: 'tabpanel',
	              'aria-labelledby': 'ex-with-icons-tab-3'
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-11 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAceptar, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-success mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check-circle' },
	              '  Modificar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_gestionarMarca.GestionarMarca, {
	      show: mostrarMarca,
	      onHideCancela: function onHideCancela() {
	        setMostrarMarca(false);
	      },
	      onHideRenderizar: seleccionarMarca,
	      llamado: 2
	    }),
	    _react2.default.createElement(_gestionarModelo.GestionarModelo, {
	      show: mostrarModelo,
	      onHideCancela: function onHideCancela() {
	        setMostrarModelo(false);
	      },
	      onHideRenderizar: seleccionarModelo,
	      llamado: 2
	    }),
	    _react2.default.createElement(_gestionarTipoProducto.GestionarTipoProducto, {
	      show: mostrarTipoP,
	      onHideCancela: function onHideCancela() {
	        setMostrarTipoP(false);
	      },
	      onHideRenderizar: seleccionarTipoProd,
	      llamado: 2
	    }),
	    _react2.default.createElement(_gestionarFabricante.GestionarFabricantes, {
	      show: mostrarFabricante,
	      onHideCancela: function onHideCancela() {
	        setMostrarFabricante(false);
	      },
	      onHideRenderizar: seleccionarFabricante,
	      llamado: 2
	    }),
	    _react2.default.createElement(_gestionarClasificadorVacios.GestionarClasificadorVacios, {
	      show: mostrarclassvacio,
	      onHideCancela: function onHideCancela() {
	        setMostrarclassvacio(false);
	      },
	      onHideRenderizar: seleccionarClassVacios,
	      llamado: 2
	    }),
	    _react2.default.createElement(_gestionarUnidadMedida.GestionarMedida, {
	      show: mostrarMedida,
	      onHideRenderizar: agregarUnidad,
	      onHideCancela: function onHideCancela() {
	        setMostrarMedida(false);
	      },
	      llamado: 2
	    })
	  );
	};

/***/ },
/* 7058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ImprimirProductos = undefined;
	
	var _regenerator = __webpack_require__(69);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoModelo = __webpack_require__(652);
	
	var _catalogoModelo2 = _interopRequireDefault(_catalogoModelo);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoAlmacen = __webpack_require__(51);
	
	var _catalogoAlmacen2 = _interopRequireDefault(_catalogoAlmacen);
	
	var _catalogoProductosExistencias = __webpack_require__(91);
	
	var _catalogoProductosExistencias2 = _interopRequireDefault(_catalogoProductosExistencias);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var ImprimirProductos = exports.ImprimirProductos = function ImprimirProductos(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtInputAlmacen = (0, _react.useRef)();
	  var txtInputProducto = (0, _react.useRef)();
	  var txtTodosAlmacen = (0, _react.useRef)();
	  var txtPorAlmacen = (0, _react.useRef)();
	  var txtTodosDispo = (0, _react.useRef)();
	  var txtEnStock = (0, _react.useRef)();
	  var txtAgotados = (0, _react.useRef)();
	  var txtTodosProductos = (0, _react.useRef)();
	  var txtPorProductos = (0, _react.useRef)();
	  var txtIdProducto = (0, _react.useRef)();
	  var txtRifrespon = (0, _react.useRef)();
	  var txtNomrespon = (0, _react.useRef)();
	  var txtNombreAlmacen = (0, _react.useRef)();
	  var txtNombreProducto = (0, _react.useRef)();
	  var txtTipoproducto = (0, _react.useRef)();
	  var txtMarca = (0, _react.useRef)();
	  var txtFabricante = (0, _react.useRef)();
	  var txtCheckPrecio = (0, _react.useRef)();
	  var txtHistorico = (0, _react.useRef)();
	  var txtFechaal = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      inputalmacen = _useState2[0],
	      setInputalmacen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      inputproducto = _useState4[0],
	      setInputproducto = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      validaprecio = _useState6[0],
	      setValidaprecio = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      tipoproducto = _useState8[0],
	      setTipoproducto = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mostrar = _useState10[0],
	      setMostrar = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(null),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mostrar1 = _useState12[0],
	      setMostrar1 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(''),
	      _useState14 = _slicedToArray(_useState13, 2),
	      almacenc = _useState14[0],
	      setAlmacenc = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(''),
	      _useState16 = _slicedToArray(_useState15, 2),
	      disponiblec = _useState16[0],
	      setDisponiblec = _useState16[1];
	
	  var _useState17 = (0, _react.useState)('0'),
	      _useState18 = _slicedToArray(_useState17, 2),
	      cantis = _useState18[0],
	      setCantis = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(''),
	      _useState20 = _slicedToArray(_useState19, 2),
	      productoc = _useState20[0],
	      setProductoc = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(''),
	      _useState22 = _slicedToArray(_useState21, 2),
	      idproductos = _useState22[0],
	      setIdproductos = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(''),
	      _useState24 = _slicedToArray(_useState23, 2),
	      idalmacenc = _useState24[0],
	      setIdalmacenc = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(false),
	      _useState26 = _slicedToArray(_useState25, 2),
	      activate = _useState26[0],
	      setActivate = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(true),
	      _useState28 = _slicedToArray(_useState27, 2),
	      habilitado = _useState28[0],
	      setHabilitado = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      habimarcatipopro = _useState30[0],
	      setHabimarcatipopro = _useState30[1];
	
	  var _useState31 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState32 = _slicedToArray(_useState31, 2),
	      mensaje = _useState32[0],
	      setMensaje = _useState32[1];
	
	  var _useState33 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState34 = _slicedToArray(_useState33, 2),
	      mensajesino = _useState34[0],
	      setMensajesino = _useState34[1];
	
	  var _useState35 = (0, _react.useState)([]),
	      _useState36 = _slicedToArray(_useState35, 2),
	      marca = _useState36[0],
	      setMarca = _useState36[1];
	
	  var _useState37 = (0, _react.useState)([]),
	      _useState38 = _slicedToArray(_useState37, 2),
	      fabricante = _useState38[0],
	      setFabricante = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(''),
	      _useState40 = _slicedToArray(_useState39, 2),
	      idmarca = _useState40[0],
	      setIdmarca = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(''),
	      _useState42 = _slicedToArray(_useState41, 2),
	      idfabricante = _useState42[0],
	      setIdfabricante = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(''),
	      _useState44 = _slicedToArray(_useState43, 2),
	      idtproduct = _useState44[0],
	      setIdtproduct = _useState44[1];
	
	  var _useState45 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState46 = _slicedToArray(_useState45, 2),
	      botones = _useState46[0],
	      setBotones = _useState46[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setInputalmacen(0);
	    setAlmacenc('');
	    setDisponiblec('');
	    setCantis('0');
	    setProductoc('');
	    setInputproducto(0);
	    setValidaprecio(0);
	    setIdalmacenc('');
	    setIdproductos('');
	    setIdmarca('');
	    setIdfabricante('');
	    setIdtproduct('');
	    setHabimarcatipopro(false);
	    setMarca([]);
	    setFabricante([]);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.op === 1) {
	
	      if (txtPorAlmacen.current.checked === true && txtPorProductos.current.checked === false) {
	        if (txtInputAlmacen.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Almacen a Consultar !', icono: 'informacion' });
	          txtInputAlmacen.current.focus();
	          sigue = false;
	        } else {
	          imprimirGeneral();
	        }
	      } else if (txtPorAlmacen.current.checked === false && txtPorProductos.current.checked === true) {
	        if (txtInputProducto.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Producto a Consultar !', icono: 'informacion' });
	          txtInputProducto.current.focus();
	          sigue = false;
	        } else {
	          imprimirGeneral();
	        }
	      } else if (txtPorAlmacen.current.checked === true && txtPorProductos.current.checked === true) {
	        if (txtInputProducto.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Producto a Consultar !', icono: 'informacion' });
	          txtInputProducto.current.focus();
	          sigue = false;
	        } else if (txtInputAlmacen.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Almacen a Consultar !', icono: 'informacion' });
	          txtInputAlmacen.current.focus();
	          sigue = false;
	        } else {
	          imprimirGeneral();
	        }
	      } else {
	        imprimirGeneral();
	      }
	    }
	  };
	
	  var onChekval = function onChekval(e) {
	
	    if (e.target.id === 'tipoalmacen') {
	
	      if (txtTodosAlmacen.current.checked === true) {
	
	        setInputalmacen(0);
	        setAlmacenc('');
	        setIdalmacenc('');
	        txtNomrespon.current.value = '';
	        txtRifrespon.current.value = '';
	        txtNombreAlmacen.current.value = '';
	      } else if (txtPorAlmacen.current.checked === true) {
	
	        setInputalmacen(1);
	        setAlmacenc(' and a.idalmacen =');
	      }
	    } else if (e.target.id === 'tipodisponible') {
	
	      if (e.target.value === '1') {
	        setDisponiblec('');
	      } else if (e.target.value === '2') {
	        setDisponiblec(' and e.cantidad > 0.00');
	      } else if (e.target.value === '3') {
	        setDisponiblec(' and e.cantidad = 0.00');
	      }
	    } else if (e.target.id === 'tipoproducto') {
	
	      if (txtTodosProductos.current.checked === true) {
	        setInputproducto(0);
	        setProductoc('');
	        setIdproductos('');
	        setHabimarcatipopro(false);
	        txtNombreProducto.current.value = '';
	      } else if (txtPorProductos.current.checked === true) {
	        setInputproducto(1);
	        setHabimarcatipopro(true);
	        setProductoc(' and p.idproducto =');
	      }
	    }
	
	    if (e.target.name === 'valprecio') {
	      if (txtCheckPrecio.current.checked === true) {
	        setValidaprecio(1);
	        setCantis('0');
	        txtHistorico.current.checked = false;
	      } else {
	        setValidaprecio(0);
	        setCantis('0');
	        txtHistorico.current.checked = false;
	      }
	    }
	
	    if (e.target.name === 'historico') {
	      if (txtHistorico.current.checked === true) {
	        setCantis('1');
	        setValidaprecio(0);
	        txtCheckPrecio.current.checked = false;
	      } else {
	        setCantis('0');
	        setValidaprecio(0);
	        txtCheckPrecio.current.checked = false;
	      }
	    }
	  };
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'tproducto') {
	      if (e.target.value === '0') {
	        setIdtproduct('');
	      } else {
	        var valor = ' and p.idtipoproducto = ' + e.target.value;
	        setIdtproduct(valor);
	      }
	    } else if (e.target.name === 'fabricante') {
	      if (e.target.value === '0') {
	        setIdfabricante('');
	      } else {
	        var _valor = ' and p.idfabricante = ' + e.target.value;
	        setIdfabricante(_valor);
	      }
	    } else if (e.target.name === 'marca') {
	      if (e.target.value === '0') {
	        setIdmarca('');
	      } else {
	        var _valor2 = ' and p.marca = ' + e.target.value;
	        setIdmarca(_valor2);
	      }
	    }
	  };
	
	  var imprimirGeneral = function imprimirGeneral() {
	
	    var reporte = "";
	    var valc = cantis === '1' ? '' : disponiblec;
	    var condi = almacenc + idalmacenc + valc + productoc + idproductos + idtproduct + idmarca + idfabricante;
	
	    if (validaprecio === 1 && cantis === '0') {
	      reporte = "ListProductoExistenciaDos";
	    } else if (validaprecio === 0 && cantis === '1') {
	      reporte = "ListaProductoExistencia";
	    } else {
	      reporte = "ListaProductoExistenciareal";
	    }
	
	    var tipo = 0;
	    var alafecha = txtFechaal.current.value;
	
	    if (idtproduct !== '' && idmarca !== '' && idfabricante !== '') {
	      tipo = 4;
	    } else if (idtproduct !== '' && idmarca !== '' && idfabricante === '') {
	      tipo = 3;
	    } else if (idtproduct !== '' && idmarca === '' && idfabricante !== '') {
	      tipo = 2;
	    } else if (idtproduct === '' && idmarca !== '' && idfabricante !== '') {
	      tipo = 1;
	    } else {
	      tipo = 0;
	    }
	    window.open(op.reportes + "/productos?afiliado=" + afiliado + "&reporte=" + reporte + "&condicion=" + condi + "&alafecha=" + (0, _moment2.default)(alafecha).format('DD-MM-YYYY') + "&tipo=" + tipo, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    if (props.llamado === 2) {
	      props.onHideRenderizar();
	      props.onHideCancela();
	    }
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var handleAceptaAlmacen = function handleAceptaAlmacen(values) {
	    setMostrar(false);
	    txtInputAlmacen.current.value = values.idalmacen;
	    txtNombreAlmacen.current.value = values.descripcion;
	    selectResponsable(values.responsable.substring(1, 9));
	    setIdalmacenc(values.idalmacen);
	  };
	
	  var handleAceptaProducto = function handleAceptaProducto(values) {
	    setMostrar1(false);
	    txtInputProducto.current.value = values.codigo;
	    txtNombreProducto.current.value = values.nombrecorto;
	    setIdproductos(values.idproducto);
	  };
	
	  var catalogoAlmacenc = function catalogoAlmacenc(e) {
	    e.preventDefault();
	    setMostrar(true);
	  };
	
	  var catalogoProductoc = function catalogoProductoc(e) {
	    e.preventDefault();
	    setMostrar1(true);
	  };
	
	  var selectAlmacen = function selectAlmacen(id) {
	
	    var campos = '*';
	    var nomtab = 'almacen';
	    var nomid = 'idalmacen';
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid;
	
	    //let endpoint = `${op.conexion}/api/inventario/almacenpordescripcion?descripcion=${"'"+descrip.toUpperCase()+"'"}`;
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idalmacen > 0) {
	          txtInputAlmacen.current.value = response.data.idalmacen;
	          txtNombreAlmacen.current.value = response.data.descripcion;
	          setIdalmacenc(response.data.idalmacen);
	          selectResponsable(response.data.responsable.substring(1, 9));
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Código y/o Almacen no Registrado !', icono: 'error' });
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var selectResponsable = function selectResponsable(id) {
	    var campos = '*';
	    var nomtab = 'persona';
	    var nomid = 'cedula';
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid;
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.cedula > 0) {
	          txtNomrespon.current.value = response.data.nombres.trim() + ' ' + response.data.apellidos.trim();
	          txtRifrespon.current.value = response.data.cedula;
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var seleccionarProducto = function seleccionarProducto(id) {
	
	    var endpoint = op.conexion + '/api/inventario/productosenexistenciaid?id=' + id;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	
	      if (response.status === 200) {
	        if (response.data.idproducto > 0) {
	          txtInputProducto.current.value = response.data.codigo;
	          txtNombreProducto.current.value = response.data.nombrecorto;
	          setIdproductos(response.data.idproducto);
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Código y/o Producto no Registrado !', icono: 'error' });
	        }
	      }
	    }).catch(function (error) {
	
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var handleProducto = function handleProducto(e) {
	    e.preventDefault();
	    if (e.which === 13 || typeof e.which === 'undefined') {
	      if (e.target.value !== '') {
	        seleccionarProducto("'" + e.target.value.toUpperCase() + "'");
	      }
	    }
	  };
	
	  var handleAlmacen = function handleAlmacen(e) {
	    e.preventDefault();
	    if (e.which === 13 || typeof e.which === 'undefined') {
	      if (e.target.value !== '') {
	        selectAlmacen(e.target.value);
	      }
	    }
	  };
	
	  var seleccionarTipoProductos = function seleccionarTipoProductos() {
	
	    var campos = 'idtipoproducto, trim(descripcion) as descripcion';
	    var nomtab = 'tipoproducto';
	    var orden = 'idtipoproducto';
	
	    var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	
	          var datos = [];
	
	          for (var i = 0; i < response.data.length; i++) {
	
	            if (response.data[i].idtipoproducto !== '0') {
	              datos.push({
	                idtipoproducto: response.data[i].idtipoproducto,
	                descripcion: response.data[i].descripcion
	              });
	            }
	          }
	          setTipoproducto(datos);
	        }
	      }
	    }).catch(function (error) {
	
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarMarca = function seleccionarMarca() {
	
	    var campos = 'idmarca, trim(descripcion) as descripcion';
	    var nomtab = 'marca';
	    var orden = 'idmarca';
	
	    var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	
	          var datos = [];
	
	          for (var i = 0; i < response.data.length; i++) {
	
	            if (response.data[i].idmarca !== '0') {
	              datos.push({
	                idmarca: response.data[i].idmarca,
	                descripcion: response.data[i].descripcion
	              });
	            }
	          }
	          setMarca(datos);
	        }
	      }
	    }).catch(function (error) {
	
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarFabricante = function seleccionarFabricante() {
	
	    var campos = 'idfabricante, trim(descripcion) as descripcion';
	    var nomtab = 'fabricante';
	    var orden = 'idfabricante';
	
	    var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	
	          var datos = [];
	
	          for (var i = 0; i < response.data.length; i++) {
	
	            if (response.data[i].idfabricante !== '0') {
	              datos.push({
	                idfabricante: response.data[i].idfabricante,
	                descripcion: response.data[i].descripcion
	              });
	            }
	          }
	          setFabricante(datos);
	        }
	      }
	    }).catch(function (error) {
	
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var imprimir2 = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var valc, condi, tipo;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              valc = cantis === '1' ? '' : disponiblec;
	              condi = almacenc + idalmacenc + valc + productoc + idproductos + idtproduct + idmarca + idfabricante;
	              tipo = 0;
	
	              window.open(op.reportes + "/productos?afiliado=" + afiliado + "&reporte=ListProductoExistenciaCatalogo" + "&condicion=" + condi + "&tipo=" + tipo, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function imprimir2() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.op === 1) {
	          txtTodosAlmacen.current.checked = true;
	          txtTodosDispo.current.checked = true;
	          txtTodosProductos.current.checked = true;
	          setAlmacenc('');
	          setDisponiblec('');
	          setProductoc('');
	          seleccionarTipoProductos();
	          seleccionarFabricante();
	          seleccionarMarca();
	          txtPorAlmacen.current.checked = false;
	          txtEnStock.current.checked = false;
	          txtAgotados.current.checked = false;
	          txtPorProductos.current.checked = false;
	          setHabilitado(false);
	          txtFechaal.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        } else {
	          txtTodosAlmacen.current.checked = false;
	          txtTodosDispo.current.checked = false;
	          txtTodosProductos.current.checked = false;
	
	          txtPorAlmacen.current.checked = false;
	          txtEnStock.current.checked = false;
	          txtAgotados.current.checked = false;
	          txtPorProductos.current.checked = false;
	          setHabilitado(true);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Imprimir Lista de Productos'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-7 ml-auto row m-0' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-check col-6' },
	              _react2.default.createElement('input', { className: 'form-check-input', ref: txtHistorico, name: 'historico', onChange: onChekval, type: 'checkbox', value: '', id: 'flexCheckDefault1' }),
	              _react2.default.createElement(
	                'label',
	                { className: 'form-check-label', 'for': 'flexCheckDefault1' },
	                'Historico Existencia'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-check col-5 ml-auto' },
	              _react2.default.createElement('input', { className: 'form-check-input', ref: txtCheckPrecio, name: 'valprecio', onChange: onChekval, type: 'checkbox', value: '', id: 'flexCheckDefault' }),
	              _react2.default.createElement(
	                'label',
	                { className: 'form-check-label', 'for': 'flexCheckDefault' },
	                'Solo Precio de Venta'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Almac\xE9n:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-3 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipoalmacen', value: '1', ref: txtTodosAlmacen, onChange: onChekval, id: 'tipoalmacen', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRadi1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-3 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipoalmacen', value: '2', ref: txtPorAlmacen, onChange: onChekval, id: 'tipoalmacen', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRadi2' },
	                  'Por Almacen'
	                )
	              )
	            ),
	            inputalmacen === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'col-4 mr-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'C\xF3digo Almac\xE9n:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtInputAlmacen, disabled: inputalmacen === 1 ? false : true, onKeyUp: handleAlmacen, onBlur: handleAlmacen, className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: inputalmacen === 1 ? false : true, type: 'button', onClick: catalogoAlmacenc, className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ) : '',
	            inputalmacen === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'col-12 row m-0 py-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'Nombre del Almac\xE9n:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', ref: txtNombreAlmacen, disabled: true, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12 row m-0' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm col-9 px-0' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'Responsable:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', ref: txtNomrespon, disabled: true, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm col-3 px-0' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'C\xE9dula:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', ref: txtRifrespon, disabled: true, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            ) : ''
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1 d-flex justify-content-between' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Disponibilidad:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '1', ref: txtTodosDispo, onChange: onChekval, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-3 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '2', ref: txtEnStock, onChange: onChekval, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai2' },
	                  'En Existencia'
	                )
	              ),
	              cantis === '0' ? _react2.default.createElement('input', { type: 'hidden', ref: txtFechaal }) : ''
	            ),
	            cantis === '1' ? '' : _react2.default.createElement(
	              'div',
	              { className: 'col-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '3', ref: txtAgotados, onChange: onChekval, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai3' },
	                  'Agotados'
	                )
	              )
	            ),
	            cantis === '1' ? _react2.default.createElement(
	              'div',
	              { className: 'col-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'mr-auto' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'A la Fecha:'
	                  ),
	                  _react2.default.createElement('input', { type: 'date', ref: txtFechaal, className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            ) : ''
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Producto:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-3 mx-auto mb-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipoproducto', value: '1', ref: txtTodosProductos, onChange: onChekval, id: 'tipoproducto', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-3 mx-auto mb-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipoproducto', value: '2', ref: txtPorProductos, onChange: onChekval, id: 'tipoproducto', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa2' },
	                  'Por Producto'
	                )
	              )
	            ),
	            _react2.default.createElement('input', { type: 'hidden', ref: txtIdProducto }),
	            inputproducto === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'col-4 mr-auto mb-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'C\xF3digo:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtInputProducto, disabled: inputproducto === 1 ? false : true, onKeyUp: handleProducto, onBlur: handleProducto, className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: inputproducto === 1 ? false : true, type: 'button', onClick: catalogoProductoc, className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ) : '',
	            inputproducto === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'col-12 row m-0 mb-1 py-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'Nombre del Producto:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', ref: txtNombreProducto, disabled: true, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            ) : '',
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 row m-0 px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-4 px-1' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm mb-2' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'TIPO PRODUCTO:'
	                  ),
	                  _react2.default.createElement(
	                    'select',
	                    { ref: txtTipoproducto, name: 'tproducto', onChange: onChange, className: 'form-select form-select-sm text-center', disabled: habimarcatipopro, 'aria-label': '.form-select-sm example' },
	                    _react2.default.createElement(
	                      'option',
	                      { value: '0' },
	                      'TODOS'
	                    ),
	                    tipoproducto && tipoproducto.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'option',
	                        { key: index, value: item.idtipoproducto },
	                        ' ',
	                        item.descripcion,
	                        ' '
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-4 px-1' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm mb-2' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'MARCA:'
	                  ),
	                  _react2.default.createElement(
	                    'select',
	                    { ref: txtMarca, name: 'marca', onChange: onChange, className: 'form-select form-select-sm text-center', disabled: habimarcatipopro, 'aria-label': '.form-select-sm example' },
	                    _react2.default.createElement(
	                      'option',
	                      { value: '0' },
	                      'TODOS'
	                    ),
	                    marca && marca.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'option',
	                        { key: index, value: item.idmarca },
	                        ' ',
	                        item.descripcion,
	                        ' '
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-4 px-1' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm mb-2' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'FABRICANTE:'
	                  ),
	                  _react2.default.createElement(
	                    'select',
	                    { ref: txtFabricante, name: 'fabricante', onChange: onChange, className: 'form-select form-select-sm text-center', disabled: habimarcatipopro, 'aria-label': '.form-select-sm example' },
	                    _react2.default.createElement(
	                      'option',
	                      { value: '0' },
	                      'TODOS'
	                    ),
	                    fabricante && fabricante.map(function (item, index) {
	                      return _react2.default.createElement(
	                        'option',
	                        { key: index, value: item.idfabricante },
	                        ' ',
	                        item.descripcion,
	                        ' '
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            {
	              onClick: imprimir2,
	              className: 'btn btn-sm rounded-pill btn-primary mx-1'
	            },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-print' },
	              ' Catalogo'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: habilitado, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-primary mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-print' },
	              '  Imprimir'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoAlmacen2.default, {
	      show: mostrar,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar(false);
	      },
	      onHideAceptaCatalogo: handleAceptaAlmacen
	    }),
	    _react2.default.createElement(_catalogoProductosExistencias2.default, {
	      show: mostrar1,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar1(false);
	      },
	      onHideAceptaCatalogo: handleAceptaProducto
	    })
	  );
	};

/***/ },
/* 7059 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OperacionInvPorExcel = undefined;
	
	var _regenerator = __webpack_require__(69);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _core = __webpack_require__(19);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _varios = __webpack_require__(14);
	
	var _xlsx = __webpack_require__(160);
	
	var XLSX = _interopRequireWildcard(_xlsx);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var OperacionInvPorExcel = exports.OperacionInvPorExcel = function OperacionInvPorExcel(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var organizacion = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var fechaSistema = (0, _moment2.default)(JSON.parse(sessionStorage.getItem("fechasistema"))).format("YYYY-MM-DD");
	  var txtCosto = (0, _react.useRef)([]);
	  var txtPrecio = (0, _react.useRef)([]);
	  var btnIncluir = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtAlmacen = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(true),
	      _useState2 = _slicedToArray(_useState, 2),
	      habilitadoBot = _useState2[0],
	      setHabilitadoBot = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      jsonData = _useState6[0],
	      setJsonData = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      almacenData = _useState8[0],
	      setAlmacenData = _useState8[1];
	
	  var _useState9 = (0, _react.useState)([]),
	      _useState10 = _slicedToArray(_useState9, 2),
	      productosData = _useState10[0],
	      setProductosData = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(null),
	      _useState12 = _slicedToArray(_useState11, 2),
	      file = _useState12[0],
	      setFile = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(null),
	      _useState14 = _slicedToArray(_useState13, 2),
	      body = _useState14[0],
	      setBody = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mensaje = _useState16[0],
	      setMensaje = _useState16[1];
	
	  var _useState17 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState18 = _slicedToArray(_useState17, 2),
	      mensajesino = _useState18[0],
	      setMensajesino = _useState18[1];
	
	  var headCells = [{ label: "CODIGO", textAlign: "center", width: "0px" }, { label: "DESCRIPCION", textAlign: "center" }, { label: "PRECIO VENTA", textAlign: "center" }, { label: "CANTD CAJA/BULTO...", textAlign: "center" }, { label: "CANTD UNIDADES/L/G...", textAlign: "center" }, {
	    label: _react2.default.createElement("i", { className: "fas fa-trash" }),
	    textAlign: "center",
	    width: "20px"
	  }];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var seleccionarRegistros = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var campos, nomtab, orden, endpoint;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              campos = "idalmacen, trim(descripcion) as descripcion, trim(responsable) as responsable, ventas";
	              nomtab = "almacen";
	              orden = "idalmacen";
	              endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	              setActivate(true);
	              _axios2.default.get(endpoint, {
	                headers: {
	                  "x-access-token": "" + token
	                }
	              }).then(function (response) {
	                if (response.status === 200) {
	                  if (response.data.length > 0) {
	                    setAlmacenData(response.data);
	                  }
	                }
	              }).catch(function (error) {
	                setMensaje({
	                  mostrar: true,
	                  titulo: "Error",
	                  texto: error.response.data.message,
	                  icono: "error"
	                });
	                setActivate(false);
	              }).finally(function () {
	                setActivate(false);
	              });
	
	            case 6:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function seleccionarRegistros() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var seleccionarRegistrosProductos = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var campos, nomtab, orden, endpoint;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              campos = "idproducto, idunidadmedida, idunidadalterna, codigo, valorfactor";
	              nomtab = "producto";
	              orden = "idproducto";
	              endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	              setActivate(true);
	              _axios2.default.get(endpoint, {
	                headers: {
	                  "x-access-token": "" + token
	                }
	              }).then(function (response) {
	                if (response.status === 200) {
	                  if (response.data.length > 0) {
	                    setProductosData(response.data);
	                  } else {
	                    setProductosData([]);
	                  }
	                }
	              }).catch(function (error) {
	                setMensaje({
	                  mostrar: true,
	                  titulo: "Error",
	                  texto: error.response.data.message,
	                  icono: "error"
	                });
	                setActivate(false);
	              }).finally(function () {
	                setActivate(false);
	              });
	
	            case 6:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));
	
	    return function seleccionarRegistrosProductos() {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/inventario/actualizaropeinv/" + 1;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setMensaje({
	          mostrar: true,
	          titulo: "Exito.",
	          texto: "registro " + response.data.idopeinv + " creado correctamente",
	          icono: "exito"
	        });
	        window.open(op.reportes + ("/almacen?afiliado=" + organizacion + "&reporte=ReporteDetaOpeInventario&codigo=" + response.data.idopeinv), "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	        blanquear();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = "";
	      if (error.response === undefined) {
	        mensaje = "Error de Conexion";
	      } else {
	        mensaje = error.response.data.message;
	      }
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var validarCosto = function validarCosto(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        var data = [].concat(_toConsumableArray(jsonData));
	        if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	          event.target.value = "0,00";
	        }
	        event.target.value = (0, _varios.formatoMonto)(event.target.value);
	        var char1 = event.target.value.substring(0, 1);
	        var char2 = event.target.value.substring(1, 2);
	        if (char1 === "0" && char2 !== ",") {
	          event.target.value = event.target.value.substring(1, event.target.value.length);
	        }
	        var canti = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	        data[index].cantidadc = canti;
	        setJsonData(data);
	      }
	    };
	  };
	
	  var validarPrecio = function validarPrecio(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        var data = [].concat(_toConsumableArray(jsonData));
	        if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	          event.target.value = "0,00";
	        }
	        event.target.value = (0, _varios.formatoMonto)(event.target.value);
	        var char1 = event.target.value.substring(0, 1);
	        var char2 = event.target.value.substring(1, 2);
	        if (char1 === "0" && char2 !== ",") {
	          event.target.value = event.target.value.substring(1, event.target.value.length);
	        }
	        var canti = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	        data[index].cantidadu = canti;
	        setJsonData(data);
	      }
	    };
	  };
	
	  var eliminarProducto = function eliminarProducto(producto) {
	    return function (e) {
	      e.preventDefault();
	      var data = [].concat(_toConsumableArray(jsonData));
	      var elementos = [];
	
	      for (var i = 0; i < data.length; i++) {
	        if (producto.codigo !== data[i].codigo) {
	          elementos.push(data[i]);
	        }
	      }
	      setJsonData(elementos);
	    };
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var opeinv = [];
	    var opeinvdet = [];
	
	    opeinv.push({
	      idoperacioninventario: 0,
	      tipooperacion: "INGRESO",
	      idalmacenorigen: txtAlmacen.current.value,
	      idalmacendestino: "",
	      fecha: fechaSistema,
	      idmoneda: props.idmoney,
	      observacion: "INGRESO EXISTENCIA DESDE ARCHIVO EXCEL"
	    });
	
	    for (var i = 0; i < jsonData.length; i++) {
	      if (jsonData[i].idproducto !== null && (parseFloat(jsonData[i].cantidadc) > 0 || parseFloat(jsonData[i].cantidadu) > 0)) {
	        var canti = 0.0;
	        var tipo = null;
	        if (parseFloat(jsonData[i].cantidadc) > 0 && parseFloat(jsonData[i].cantidadu) > 0) {
	          canti = parseFloat(jsonData[i].cantidadc) * parseFloat(jsonData[i].valorfactor) + parseFloat(jsonData[i].cantidadu);
	          tipo = 1;
	        } else {
	          if (jsonData[i].cantidadc > 0 && jsonData[i].cantidadu <= 0) {
	            canti = jsonData[i].cantidadc;
	            tipo = 0;
	          } else if (jsonData[i].cantidadc <= 0 && jsonData[i].cantidadu > 0) {
	            canti = jsonData[i].cantidadu;
	            tipo = 1;
	          }
	        }
	
	        opeinvdet.push({
	          idproducto: jsonData[i].idproducto,
	          nombre: jsonData[i].nombrecorto,
	          cantidad: canti,
	          precio: jsonData[i].precioventa,
	          fechavencimiento: null,
	          tipomovimiento: "INVENTARIO INICIAL",
	          fechatipomovimiento: fechaSistema,
	          numfactura: "",
	          idalmacen: txtAlmacen.current.value,
	          tipounidad: tipo,
	          idunidadmedida: jsonData[i].idunidadmedida,
	          idunidadalterna: jsonData[i].idunidadalterna,
	          tipofactor: jsonData[i].tipofactor,
	          valorfactor: jsonData[i].valorfactor,
	          tasa: props.valormo,
	          preciobs: (0, _varios.round)(jsonData[i].precioventa * props.valormo)
	        });
	      }
	    }
	    setBody({
	      idtipopeinv: 1,
	      opeinv: opeinv,
	      opeinvdet: opeinvdet
	    });
	
	    if (opeinv.length > 0 && opeinvdet.length > 0) {
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: "Esta Segur@ de Procesar esta Operación de Inventario?",
	        icono: "confirmacion"
	      });
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificacion",
	        texto: "No hay Productos Incluidos",
	        icono: "error"
	      });
	    }
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setHabilitadoBot(true);
	    setJsonData([]);
	    setAlmacenData([]);
	    setBody(null);
	    seleccionarRegistros();
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        setHabilitadoBot(false);
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        var selectedFile = "";
	        setFile(selectedFile);
	        blanquear();
	      }
	    };
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHide();
	  };
	
	  var handleFileChange = function handleFileChange(e) {
	    var selectedFile = e.target.files[0];
	    setFile(selectedFile);
	  };
	
	  function esNumeroValido(valor) {
	    // Si es un string vacío o solo espacios, no es un número
	    if (typeof valor === 'string' && valor.trim() === '') return false;
	
	    return !isNaN(parseFloat(valor)) && isFinite(valor);
	  }
	
	  var convertToJson = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var reader;
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              if (file) {
	                _context4.next = 3;
	                break;
	              }
	
	              setMensaje({
	                mostrar: true,
	                titulo: "Notificacion",
	                texto: "Por favor selecciona un archivo Excel.",
	                icono: "informacion"
	              });
	              return _context4.abrupt("return");
	
	            case 3:
	              reader = new FileReader();
	
	
	              reader.onload = function () {
	                var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(e) {
	                  var _ret;
	
	                  return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                      switch (_context3.prev = _context3.next) {
	                        case 0:
	                          _context3.prev = 0;
	
	                          _ret = function () {
	                            var data = new Uint8Array(e.target.result);
	                            var workbook = XLSX.read(data, { type: "array" });
	
	                            var firstSheet = workbook.Sheets[workbook.SheetNames[0]];
	
	                            var jsonResult = XLSX.utils.sheet_to_json(firstSheet, {
	                              header: ["codigo", "nombrecorto", "precioventa", "cantidadc", "cantidadu", "unidadalterna"],
	                              range: 1
	                            });
	
	                            var requiredColumns = ["codigo", "nombrecorto", "precioventa", "cantidadc", "cantidadu", "unidadalterna"];
	
	                            var noencontrado = [];
	                            if (jsonResult.length > 0) {
	                              var missingColumns = requiredColumns.filter(function (col) {
	                                return !Object.keys(jsonResult[0]).includes(col);
	                              });
	
	                              if (missingColumns.length > 0) {
	                                setMensaje({
	                                  mostrar: true,
	                                  titulo: "Notificacion",
	                                  texto: "Faltan columnas requeridas: " + missingColumns.join(", "),
	                                  icono: "error"
	                                });
	                                return {
	                                  v: void 0
	                                };
	                              }
	                            }
	
	                            var enrichedData = [];
	
	                            var _loop = function _loop(i) {
	                              var response = productosData.filter(function (p) {
	                                return p.codigo === jsonResult[i].codigo.toString();
	                              });
	
	                              if (response && response.length > 0) {
	                                console.log(jsonResult[i].cantidadc);
	
	                                enrichedData.push(Object.assign({}, jsonResult[i], {
	                                  idproducto: response[0].idproducto,
	                                  cantidad: esNumeroValido(jsonResult[i].cantidadc) ? jsonResult[i].cantidadc : 0,
	                                  cantidadc: esNumeroValido(jsonResult[i].cantidadc) ? jsonResult[i].cantidadc : 0,
	                                  cantidadu: esNumeroValido(jsonResult[i].cantidadu) ? jsonResult[i].cantidadu : 0,
	                                  precioventa: esNumeroValido(jsonResult[i].precioventa) ? jsonResult[i].precioventa : 0,
	                                  tipounidad: 0,
	                                  idunidadmedida: response[0].idunidadmedida,
	                                  idunidadalterna: response[0].idunidadalterna,
	                                  tipofactor: parseFloat(response[0].valorfactor) > 1.0 ? "1" : "0",
	                                  valorfactor: response[0].valorfactor
	                                }));
	                              } else {
	                                noencontrado.push(jsonResult[i].codigo);
	                              }
	                            };
	
	                            for (var i = 0; i < jsonResult.length; i++) {
	                              _loop(i);
	                            }
	
	                            setJsonData(enrichedData);
	                            setMensaje({
	                              mostrar: true,
	                              titulo: "Éxito",
	                              texto: "Archivo convertido. " + enrichedData.length + " registros listos, y " + noencontrado.length + " productos no se encontraron en la base de datos",
	                              icono: "exito"
	                            });
	                          }();
	
	                          if (!((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object")) {
	                            _context3.next = 4;
	                            break;
	                          }
	
	                          return _context3.abrupt("return", _ret.v);
	
	                        case 4:
	                          _context3.next = 9;
	                          break;
	
	                        case 6:
	                          _context3.prev = 6;
	                          _context3.t0 = _context3["catch"](0);
	
	                          setMensaje({
	                            mostrar: true,
	                            titulo: "Notificacion",
	                            texto: "Error al procesar el archivo: " + _context3.t0.message,
	                            icono: "error"
	                          });
	
	                        case 9:
	                        case "end":
	                          return _context3.stop();
	                      }
	                    }
	                  }, _callee3, undefined, [[0, 6]]);
	                }));
	
	                return function (_x) {
	                  return _ref4.apply(this, arguments);
	                };
	              }();
	
	              reader.readAsArrayBuffer(file);
	
	            case 6:
	            case "end":
	              return _context4.stop();
	          }
	        }
	      }, _callee4, undefined);
	    }));
	
	    return function convertToJson() {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  var seleccionarProductos = function () {
	    var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(codigo) {
	      var campos, nomtab, nomid, id, endpoint, _response;
	
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              campos = "idproducto, idunidadmedida, idunidadalterna";
	              nomtab = "producto";
	              nomid = "codigo";
	              id = codigo;
	              endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	              _context5.prev = 5;
	              _context5.next = 8;
	              return _axios2.default.get(endpoint, {
	                headers: {
	                  "x-access-token": "" + token
	                }
	              });
	
	            case 8:
	              _response = _context5.sent;
	
	              if (!(_response.status === 200 && _response.data && _response.data.length > 0)) {
	                _context5.next = 11;
	                break;
	              }
	
	              return _context5.abrupt("return", _response.data[0]);
	
	            case 11:
	              throw new Error("Producto no encontrado");
	
	            case 14:
	              _context5.prev = 14;
	              _context5.t0 = _context5["catch"](5);
	
	              console.error("Error buscando producto " + codigo + ":", _context5.t0);
	              throw _context5.t0;
	
	            case 18:
	            case "end":
	              return _context5.stop();
	          }
	        }
	      }, _callee5, undefined, [[5, 14]]);
	    }));
	
	    return function seleccionarProductos(_x2) {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "xl",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      backdrop: "static",
	      keyboard: false,
	      onShow: _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                _context6.next = 2;
	                return seleccionarRegistros();
	
	              case 2:
	                _context6.next = 4;
	                return seleccionarRegistrosProductos();
	
	              case 4:
	              case "end":
	                return _context6.stop();
	            }
	          }
	        }, _callee6, undefined);
	      }))
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        _Modal2.default.Title,
	        { style: { color: "#fff" } },
	        "Registro Existencia de Productos por Excel",
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          onClick: cancelar,
	          ref: btnCancela,
	          className: "btn btn-sm text-light"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-share-square" },
	          " Salir"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(
	        "div",
	        { style: { height: "100%", width: "100%" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row col-md-12 ", style: { margin: 0 } },
	          _react2.default.createElement(
	            "div",
	            { className: "row col-md-12 py-2", style: { margin: 0 } },
	            _react2.default.createElement(
	              "div",
	              { className: "col-pd-520" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 row m-0 mb-2 row m-0" },
	                _react2.default.createElement("input", {
	                  type: "file",
	                  accept: ".xlsx, .xls",
	                  className: "col-8",
	                  onChange: handleFileChange,
	                  style: { marginBottom: "10px" }
	                }),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: !habilitadoBot,
	                    ref: btnIncluir,
	                    onClick: convertToJson,
	                    className: "btn btn-sm col-4 btn-success rounded-pill",
	                    title: "Carga la tabla con los productos"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-long-arrow-alt-down" },
	                    " ",
	                    "Cargar Excel",
	                    " "
	                  ),
	                  " "
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group input-group-sm mb-2 col-xl-6 col-lg-8 col-md-8 col-sm-12" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "ALMACEN:"
	              ),
	              _react2.default.createElement(
	                "select",
	                {
	                  disabled: !habilitadoBot,
	                  ref: txtAlmacen,
	                  className: "form-select form-select-sm ",
	                  "aria-label": ".form-select-sm example"
	                },
	                almacenData && almacenData.map(function (almacen) {
	                  return _react2.default.createElement(
	                    "option",
	                    { key: almacen.idalmacen, value: almacen.idalmacen },
	                    " ",
	                    almacen.descripcion
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 border-azul px-0 rounded",
	                style: { backgroundColor: "#d5e9ff" }
	              },
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 400,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px",
	                    fontSizeAdjust: "0.6"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden" },
	                  jsonData && jsonData.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      { key: index, style: { padding: "0" } },
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "bg-light d-flex align-items-between px-0",
	                          style: { maxWidth: "200px" }
	                        },
	                        item.codigo
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-start p-0 pl-2"
	                        },
	                        item.nombrecorto
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-center p-0 col-pd-150" },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control form-control-sm bg-light text-right fs-6",
	                          id: "precio",
	                          disabled: true,
	                          defaultValue: (0, _varios.formatMoneda)(item.precioventa.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtPrecio.current[index] = el;
	                          },
	                          onFocus: _varios.seleccionarCampo,
	                          onKeyUp: validarPrecio(index),
	                          onBlur: validarPrecio(index),
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-center p-0 col-pd-150" },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control form-control-sm bg-light text-right fs-6",
	                          id: "costo",
	                          disabled: !habilitadoBot,
	                          defaultValue: (0, _varios.formatMoneda)(item.cantidadc.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtCosto.current[index] = el;
	                          },
	                          onFocus: _varios.seleccionarCampo,
	                          onKeyUp: validarCosto(index),
	                          onBlur: validarCosto(index),
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-center p-0 col-pd-150" },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control form-control-sm bg-light text-right fs-6",
	                          id: "precio",
	                          disabled: !habilitadoBot,
	                          defaultValue: (0, _varios.formatMoneda)(item.cantidadu.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtPrecio.current[index] = el;
	                          },
	                          onFocus: _varios.seleccionarCampo,
	                          onKeyUp: validarPrecio(index),
	                          onBlur: validarPrecio(index),
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-center p-0",
	                          style: { width: "30px" }
	                        },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            disabled: !habilitadoBot,
	                            onClick: eliminarProducto(item),
	                            className: "btn btn-sm btn-danger"
	                          },
	                          _react2.default.createElement("i", { className: "fa fa-trash" }),
	                          " "
	                        )
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _semanticUiReact.Dimmer,
	          { active: activate, inverted: true },
	          _react2.default.createElement(
	            _semanticUiReact.Loader,
	            { inverted: true },
	            "cargando..."
	          )
	        ),
	        _react2.default.createElement(_mensajes.Mensaje, {
	          mensaje: mensaje,
	          onHide: function onHide() {
	            return mensaje.titulo === "Exito." ? blanquear() : setMensaje({
	              mostrar: false,
	              titulo: "",
	              texto: "",
	              icono: ""
	            });
	          }
	        }),
	        _react2.default.createElement(_mensajes.MensajeSiNo, {
	          mensaje: mensajesino,
	          onHideNo: function onHideNo() {
	            return setMensajesino({
	              mostrar: false,
	              titulo: "",
	              texto: "",
	              icono: ""
	            });
	          },
	          onHideSi: handleCloseSi
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12 row mt-3" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12 row m-0" },
	          _react2.default.createElement(
	            "button",
	            {
	              disabled: !habilitadoBot,
	              ref: btnIncluir,
	              onClick: onBotones(5),
	              className: "btn btn-sm col-2 btn-primary rounded-pill",
	              title: "Actualizar Precios"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-edit" },
	              " Actualizar "
	            ),
	            " "
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              ref: btnCancela,
	              disabled: !habilitadoBot,
	              onClick: onBotones(6),
	              className: "btn btn-sm rounded-pill btn-danger col-2 ml-auto"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-window-close" },
	              " Cancelar"
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalPermisosUsuarios = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTable = __webpack_require__(20);
	
	var _useTable2 = _interopRequireDefault(_useTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalPermisosUsuarios = exports.ModalPermisosUsuarios = function ModalPermisosUsuarios(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
	  var idusuario = JSON.parse(sessionStorage.getItem("idusuario"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtLogin = (0, _react.useRef)();
	  var txtCedula = (0, _react.useRef)();
	  var txtStatus = (0, _react.useRef)();
	  var txtIduser = (0, _react.useRef)();
	
	  var txtuTodos = (0, _react.useRef)();
	  var txtuIncluir = (0, _react.useRef)();
	  var txtuModificar = (0, _react.useRef)();
	  var txtuCosultar = (0, _react.useRef)();
	  var txtuEliminar = (0, _react.useRef)();
	  var txtuImprimir = (0, _react.useRef)();
	
	  var txtdTodos = (0, _react.useRef)();
	  var txtdIncluir = (0, _react.useRef)();
	  var txtdModificar = (0, _react.useRef)();
	  var txtdCosultar = (0, _react.useRef)();
	  var txtdEliminar = (0, _react.useRef)();
	  var txtdImprimir = (0, _react.useRef)();
	
	  var txttTodos = (0, _react.useRef)();
	  var txttIncluir = (0, _react.useRef)();
	  var txttModificar = (0, _react.useRef)();
	  var txttCosultar = (0, _react.useRef)();
	  var txttEliminar = (0, _react.useRef)();
	  var txttImprimir = (0, _react.useRef)();
	
	  var txtcTodos = (0, _react.useRef)();
	  var txtcIncluir = (0, _react.useRef)();
	  var txtcModificar = (0, _react.useRef)();
	  var txtcCosultar = (0, _react.useRef)();
	  var txtcEliminar = (0, _react.useRef)();
	  var txtcImprimir = (0, _react.useRef)();
	
	  var txtcoTodos = (0, _react.useRef)();
	  var txtcoIncluir = (0, _react.useRef)();
	  var txtcoModificar = (0, _react.useRef)();
	  var txtcoCosultar = (0, _react.useRef)();
	  var txtcoEliminar = (0, _react.useRef)();
	  var txtcoImprimir = (0, _react.useRef)();
	
	  var txtsTodos = (0, _react.useRef)();
	  var txtsIncluir = (0, _react.useRef)();
	  var txtsModificar = (0, _react.useRef)();
	  var txtsCosultar = (0, _react.useRef)();
	  var txtsEliminar = (0, _react.useRef)();
	  var txtsImprimir = (0, _react.useRef)();
	
	  var txtsiTodos = (0, _react.useRef)();
	  var txtsiIncluir = (0, _react.useRef)();
	  var txtsiModificar = (0, _react.useRef)();
	  var txtsiCosultar = (0, _react.useRef)();
	  var txtsiEliminar = (0, _react.useRef)();
	  var txtsiImprimir = (0, _react.useRef)();
	
	  var txtoTodos = (0, _react.useRef)();
	  var txtoIncluir = (0, _react.useRef)();
	  var txtoModificar = (0, _react.useRef)();
	  var txtoCosultar = (0, _react.useRef)();
	  var txtoEliminar = (0, _react.useRef)();
	  var txtoImprimir = (0, _react.useRef)();
	  var txtIngreso = (0, _react.useRef)();
	  var txtSalida = (0, _react.useRef)();
	  var txtTraslado = (0, _react.useRef)();
	  var txtObsequio = (0, _react.useRef)();
	  var txtPrestamo = (0, _react.useRef)();
	  var txtAjuste = (0, _react.useRef)();
	
	  var txtnTodos = (0, _react.useRef)();
	  var txtnIncluir = (0, _react.useRef)();
	  var txtnModificar = (0, _react.useRef)();
	  var txtnCosultar = (0, _react.useRef)();
	  var txtnEliminar = (0, _react.useRef)();
	  var txtnImprimir = (0, _react.useRef)();
	
	  var txtdzTodos = (0, _react.useRef)();
	  var txtdzIncluir = (0, _react.useRef)();
	  var txtdzModificar = (0, _react.useRef)();
	  var txtdzCosultar = (0, _react.useRef)();
	  var txtdzEliminar = (0, _react.useRef)();
	  var txtdzImprimir = (0, _react.useRef)();
	
	  var txtocTodos = (0, _react.useRef)();
	  var txtocIncluir = (0, _react.useRef)();
	  var txtocModificar = (0, _react.useRef)();
	  var txtocCosultar = (0, _react.useRef)();
	  var txtocEliminar = (0, _react.useRef)();
	  var txtocImprimir = (0, _react.useRef)();
	
	  var txtReportTodos = (0, _react.useRef)();
	  var txtReport1 = (0, _react.useRef)();
	  var txtReport2 = (0, _react.useRef)();
	  var txtReport3 = (0, _react.useRef)();
	  var txtReport4 = (0, _react.useRef)();
	  var txtReport5 = (0, _react.useRef)();
	  var txtReport6 = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      modu1 = _useState2[0],
	      setModu1 = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      modu2 = _useState4[0],
	      setModu2 = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      modu3 = _useState6[0],
	      setModu3 = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      modu4 = _useState8[0],
	      setModu4 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      modu5 = _useState10[0],
	      setModu5 = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      modu6 = _useState12[0],
	      setModu6 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      modu7 = _useState14[0],
	      setModu7 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      modu8 = _useState16[0],
	      setModu8 = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      modu9 = _useState18[0],
	      setModu9 = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      modu10 = _useState20[0],
	      setModu10 = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      modu11 = _useState22[0],
	      setModu11 = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0),
	      _useState24 = _slicedToArray(_useState23, 2),
	      modu12 = _useState24[0],
	      setModu12 = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(),
	      _useState26 = _slicedToArray(_useState25, 2),
	      datos1 = _useState26[0],
	      setDatos1 = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(),
	      _useState28 = _slicedToArray(_useState27, 2),
	      datos2 = _useState28[0],
	      setDatos2 = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(),
	      _useState30 = _slicedToArray(_useState29, 2),
	      datos3 = _useState30[0],
	      setDatos3 = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(),
	      _useState32 = _slicedToArray(_useState31, 2),
	      datos4 = _useState32[0],
	      setDatos4 = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(),
	      _useState34 = _slicedToArray(_useState33, 2),
	      datos5 = _useState34[0],
	      setDatos5 = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(),
	      _useState36 = _slicedToArray(_useState35, 2),
	      datos6 = _useState36[0],
	      setDatos6 = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(),
	      _useState38 = _slicedToArray(_useState37, 2),
	      datos7 = _useState38[0],
	      setDatos7 = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(),
	      _useState40 = _slicedToArray(_useState39, 2),
	      datos8 = _useState40[0],
	      setDatos8 = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(),
	      _useState42 = _slicedToArray(_useState41, 2),
	      datos9 = _useState42[0],
	      setDatos9 = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(),
	      _useState44 = _slicedToArray(_useState43, 2),
	      datos10 = _useState44[0],
	      setDatos10 = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(),
	      _useState46 = _slicedToArray(_useState45, 2),
	      datos11 = _useState46[0],
	      setDatos11 = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(),
	      _useState48 = _slicedToArray(_useState47, 2),
	      datos12 = _useState48[0],
	      setDatos12 = _useState48[1];
	
	  var _useState49 = (0, _react.useState)({}),
	      _useState50 = _slicedToArray(_useState49, 2),
	      body = _useState50[0],
	      setBody = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(0),
	      _useState52 = _slicedToArray(_useState51, 2),
	      operacion = _useState52[0],
	      setOperacion = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(false),
	      _useState54 = _slicedToArray(_useState53, 2),
	      activate = _useState54[0],
	      setActivate = _useState54[1];
	
	  var _useState55 = (0, _react.useState)(true),
	      _useState56 = _slicedToArray(_useState55, 2),
	      habilitado = _useState56[0],
	      setHabilitado = _useState56[1];
	
	  var _useState57 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState58 = _slicedToArray(_useState57, 2),
	      mensaje = _useState58[0],
	      setMensaje = _useState58[1];
	
	  var _useState59 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState60 = _slicedToArray(_useState59, 2),
	      mensajesino = _useState60[0],
	      setMensajesino = _useState60[1];
	
	  var _useState61 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState62 = _slicedToArray(_useState61, 2),
	      botones = _useState62[0],
	      setBotones = _useState62[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var SelectUsuario = function SelectUsuario(idusuario) {
	    var endpoint = op.conexion + '/api/athos/usuario/getuser?id=' + idusuario;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.idusuario > 0) {
	
	          var rinv = response.data.accbtnregalmacen;
	          var ubiinv = response.data.accbtnubialmacen;
	          var udmedida = response.data.accbtnumedida;
	          var marca = response.data.accbtnmarca;
	          var modelo = response.data.accbtnmodelo;
	          var tproducto = response.data.accbtntproducto;
	          var producto = response.data.accbtnproducto;
	          var opinv = response.data.accbtnopinventario;
	          var actuxlsx = response.data.accbtnactxlsx;
	          var gvacios = response.data.accbtntvacios;
	          var reports = response.data.accbtnireports;
	
	          sessionStorage.setItem("accbtnregalmacenc", JSON.stringify(rinv));
	          sessionStorage.setItem("accbtnubialmacenc", JSON.stringify(ubiinv));
	          sessionStorage.setItem("accbtnumedidac", JSON.stringify(udmedida));
	          sessionStorage.setItem("accbtnmarcac", JSON.stringify(marca));
	          sessionStorage.setItem("accbtnmodeloc", JSON.stringify(modelo));
	          sessionStorage.setItem("accbtntproductoc", JSON.stringify(tproducto));
	          sessionStorage.setItem("accbtnproductoc", JSON.stringify(producto));
	          sessionStorage.setItem("accbtnopinventarioc", JSON.stringify(opinv));
	          sessionStorage.setItem("accbtnactxlsxc", JSON.stringify(actuxlsx));
	          sessionStorage.setItem("accbtntvaciosc", JSON.stringify(gvacios));
	          sessionStorage.setItem("accbtnireportsc", JSON.stringify(reports));
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "Error al cargar el usuario",
	            icono: "informacion"
	          });
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var ralmacen = "";
	    var ubialmacen = "";
	    var udmedidas = "";
	    var marca = "";
	    var modelo = "";
	    var tipoproducto = "";
	    var producto = "";
	    var opinventario = "";
	    var actuxlsx = "";
	    var gvacios = "";
	    var reportes = "";
	
	    if (props.usuario.accinventario.toString().substring(0, 1) === '1') {
	
	      var val1 = txtuIncluir.current.checked === true ? "1" : "0";
	      var val2 = txtuModificar.current.checked === true ? "1" : "0";
	      var val3 = txtuCosultar.current.checked === true ? "1" : "0";
	      var val4 = txtuEliminar.current.checked === true ? "1" : "0";
	      var val5 = txtuImprimir.current.checked === true ? "1" : "0";
	
	      ralmacen = val1 + val2 + val3 + val4 + val5;
	    } else {
	
	      ralmacen = '000000';
	    }
	
	    if (props.usuario.accinventario.toString().substring(1, 2) === '1') {
	
	      var _val = txtdIncluir.current.checked === true ? "1" : "0";
	      var _val2 = txtdModificar.current.checked === true ? "1" : "0";
	      var _val3 = txtdCosultar.current.checked === true ? "1" : "0";
	      var _val4 = txtdEliminar.current.checked === true ? "1" : "0";
	      var _val5 = txtdImprimir.current.checked === true ? "1" : "0";
	
	      ubialmacen = _val + _val2 + _val3 + _val4 + _val5;
	    } else {
	
	      ubialmacen = '000000';
	    }
	
	    if (props.usuario.accinventario.toString().substring(2, 3) === '1') {
	
	      var _val6 = txttIncluir.current.checked === true ? "1" : "0";
	      var _val7 = txttModificar.current.checked === true ? "1" : "0";
	      var _val8 = txttCosultar.current.checked === true ? "1" : "0";
	      var _val9 = txttEliminar.current.checked === true ? "1" : "0";
	      var _val10 = txttImprimir.current.checked === true ? "1" : "0";
	
	      udmedidas = _val6 + _val7 + _val8 + _val9 + _val10;
	    } else {
	
	      udmedidas = '000000';
	    }
	
	    if (props.usuario.accinventario.toString().substring(3, 4) === '1') {
	
	      var _val11 = txtcIncluir.current.checked === true ? "1" : "0";
	      var _val12 = txtcModificar.current.checked === true ? "1" : "0";
	      var _val13 = txtcCosultar.current.checked === true ? "1" : "0";
	      var _val14 = txtcEliminar.current.checked === true ? "1" : "0";
	      var _val15 = txtcImprimir.current.checked === true ? "1" : "0";
	
	      marca = _val11 + _val12 + _val13 + _val14 + _val15;
	    } else {
	
	      marca = '000000';
	    }
	
	    if (props.usuario.accinventario.toString().substring(4, 5) === '1') {
	
	      var _val16 = txtcoIncluir.current.checked === true ? "1" : "0";
	      var _val17 = txtcoModificar.current.checked === true ? "1" : "0";
	      var _val18 = txtcoCosultar.current.checked === true ? "1" : "0";
	      var _val19 = txtcoEliminar.current.checked === true ? "1" : "0";
	      var _val20 = txtcoImprimir.current.checked === true ? "1" : "0";
	
	      modelo = _val16 + _val17 + _val18 + _val19 + _val20;
	    } else {
	
	      modelo = '000000';
	    }
	
	    if (props.usuario.accinventario.toString().substring(5, 6) === '1') {
	
	      var _val21 = txtsIncluir.current.checked === true ? "1" : "0";
	      var _val22 = txtsModificar.current.checked === true ? "1" : "0";
	      var _val23 = txtsCosultar.current.checked === true ? "1" : "0";
	      var _val24 = txtsEliminar.current.checked === true ? "1" : "0";
	      var _val25 = txtsImprimir.current.checked === true ? "1" : "0";
	
	      tipoproducto = _val21 + _val22 + _val23 + _val24 + _val25;
	    } else {
	
	      tipoproducto = '000000';
	    }
	
	    if (props.usuario.accinventario.toString().substring(6, 7) === '1') {
	
	      var _val26 = txtsiIncluir.current.checked === true ? "1" : "0";
	      var _val27 = txtsiModificar.current.checked === true ? "1" : "0";
	      var _val28 = txtsiCosultar.current.checked === true ? "1" : "0";
	      var _val29 = txtsiEliminar.current.checked === true ? "1" : "0";
	      var _val30 = txtsiImprimir.current.checked === true ? "1" : "0";
	
	      producto = _val26 + _val27 + _val28 + _val29 + _val30;
	    } else {
	
	      producto = '000000';
	    }
	
	    if (props.usuario.accinventario.toString().substring(7, 8) === '1') {
	
	      var _val31 = txtoIncluir.current.checked === true ? "1" : "0";
	      var _val32 = txtoModificar.current.checked === true ? "1" : "0";
	      var _val33 = txtoCosultar.current.checked === true ? "1" : "0";
	      var _val34 = txtoEliminar.current.checked === true ? "1" : "0";
	      var _val35 = txtoImprimir.current.checked === true ? "1" : "0";
	      var val6 = txtIngreso.current.checked === true ? "1" : "0";
	      var val7 = txtSalida.current.checked === true ? "1" : "0";
	      var val8 = txtTraslado.current.checked === true ? "1" : "0";
	      var val9 = txtObsequio.current.checked === true ? "1" : "0";
	      var val10 = txtPrestamo.current.checked === true ? "1" : "0";
	      var val11 = txtAjuste.current.checked === true ? "1" : "0";
	
	      opinventario = _val31 + _val32 + _val33 + _val34 + _val35 + val6 + val7 + val8 + val9 + val10 + val11;
	    } else {
	
	      opinventario = '000000000000';
	    }
	
	    if (props.usuario.accinventario.toString().substring(8, 9) === '1') {
	
	      var _val36 = txtnIncluir.current.checked === true ? "1" : "0";
	      var _val37 = txtnModificar.current.checked === true ? "1" : "0";
	
	      actuxlsx = _val36 + _val37;
	    } else {
	
	      actuxlsx = '000000';
	    }
	
	    if (props.usuario.accinventario.toString().substring(9, 10) === '1') {
	
	      /* let val1 = txtdzIncluir.current.checked === true ? "1" : "0";
	      let val2 = txtdzModificar.current.checked === true ? "1" : "0";
	      let val3 = txtdzCosultar.current.checked === true ? "1" : "0";
	      let val4 = txtdzEliminar.current.checked === true ? "1" : "0";
	      let val5 = txtdzImprimir.current.checked === true ? "1" : "0"; */
	
	      gvacios = '000000';
	    } else {
	
	      gvacios = '000000';
	    }
	
	    if (props.usuario.accinventario.toString().substring(11, 12) === '1') {
	
	      var _val38 = txtReport1.current.checked === true ? "1" : "0";
	      var _val39 = txtReport2.current.checked === true ? "1" : "0";
	      var _val40 = txtReport3.current.checked === true ? "1" : "0";
	      var _val41 = txtReport4.current.checked === true ? "1" : "0";
	
	      reportes = _val38 + _val39 + _val40 + _val41;
	    } else {
	
	      reportes = '0000000';
	    }
	
	    var sigue = true;
	    var mensaje = "";
	
	    if (sigue) {
	      var user = [];
	      user.push({
	        idusuario: txtIduser.current.value,
	        login: txtLogin.current.value,
	        persona: txtCedula.current.value,
	        status: txtStatus.current.value === 'ACTIVO' ? 1 : 0,
	        idorganizacion: idorganizacion,
	        accbtnregalmacen: ralmacen,
	        accbtnubialmacen: ubialmacen,
	        accbtnumedida: udmedidas,
	        accbtnmarca: marca,
	        accbtnmodelo: modelo,
	        accbtntproducto: tipoproducto,
	        accbtnproducto: producto,
	        accbtnopinventario: opinventario,
	        accbtnactxlsx: actuxlsx,
	        accbtntvacios: gvacios,
	        accbtnireports: reportes
	      });
	
	      var _body = {
	        usu: JSON.stringify(user)
	      };
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	      setBody(_body);
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: mensaje,
	        icono: "informacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    var endpoint = op.conexion + '/api/athos/usuario/actualizar/' + operacion;
	
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setActivate(false);
	
	        if (parseInt(response.data.iduser) > 0) {
	          if (parseInt(response.data.iduser) === parseInt(idusuario)) {
	            SelectUsuario(parseInt(response.data.iduser));
	          }
	        }
	
	        var mensaje = "";
	        if (operacion === 1) {
	          mensaje = "El Usuario " + response.data.iduser + " ha sido registrada de manera satisfactoria.";
	        } else if (operacion === 2) {
	          mensaje = "El Usuario " + response.data.iduser + " ha sido Modificada de manera Satisfactoria.";
	        } else if (operacion === 3) {
	          mensaje = "El usuario " + response.data.iduser + " ha sido eliminada de manera satisfactoria.";
	        }
	
	        setMensaje({
	          mostrar: true,
	          titulo: "Exito.",
	          texto: mensaje,
	          icono: "exito"
	        });
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    procesarRegistro();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    props.onHideCancela();
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var checkBlank = function checkBlank(e) {
	
	    if (modu1 === 1) {
	      if (txtuIncluir.current.checked && txtuModificar.current.checked && txtuCosultar.current.checked && txtuEliminar.current.checked && txtuImprimir.current.checked) {
	        txtuTodos.current.checked = true;
	      } else {
	        txtuTodos.current.checked = false;
	      }
	    }
	
	    if (modu2 === 1) {
	      if (txtdIncluir.current.checked && txtdModificar.current.checked && txtdCosultar.current.checked && txtdEliminar.current.checked && txtdImprimir.current.checked) {
	        txtdTodos.current.checked = true;
	      } else {
	        txtdTodos.current.checked = false;
	      }
	    }
	
	    if (modu3 === 1) {
	      if (txttIncluir.current.checked && txttModificar.current.checked && txttCosultar.current.checked && txttEliminar.current.checked && txttImprimir.current.checked) {
	        txttTodos.current.checked = true;
	      } else {
	        txttTodos.current.checked = false;
	      }
	    }
	
	    if (modu4 === 1) {
	      if (txtcIncluir.current.checked && txtcModificar.current.checked && txtcCosultar.current.checked && txtcEliminar.current.checked && txtcImprimir.current.checked) {
	        txtcTodos.current.checked = true;
	      } else {
	        txtcTodos.current.checked = false;
	      }
	    }
	
	    if (modu5 === 1) {
	      if (txtcoIncluir.current.checked && txtcoModificar.current.checked && txtcoCosultar.current.checked && txtcoEliminar.current.checked && txtcoImprimir.current.checked) {
	        txtcoTodos.current.checked = true;
	      } else {
	        txtcoTodos.current.checked = false;
	      }
	    }
	
	    if (modu6 === 1) {
	      if (txtsIncluir.current.checked && txtsModificar.current.checked && txtsCosultar.current.checked && txtsEliminar.current.checked && txtsImprimir.current.checked) {
	        txtsTodos.current.checked = true;
	      } else {
	        txtsTodos.current.checked = false;
	      }
	    }
	
	    if (modu7 === 1) {
	      if (txtsiIncluir.current.checked && txtsiModificar.current.checked && txtsiCosultar.current.checked && txtsiEliminar.current.checked && txtsiImprimir.current.checked) {
	        txtsiTodos.current.checked = true;
	      } else {
	        txtsiTodos.current.checked = false;
	      }
	    }
	
	    if (modu8 === 1) {
	      if (txtoIncluir.current.checked && txtoModificar.current.checked && txtoCosultar.current.checked && txtoEliminar.current.checked && txtoImprimir.current.checked && txtIngreso.current.checked && txtSalida.current.checked && txtTraslado.current.checked && txtObsequio.current.checked && txtPrestamo.current.checked && txtAjuste.current.checked) {
	        txtoTodos.current.checked = true;
	      } else {
	        txtoTodos.current.checked = false;
	      }
	    }
	
	    if (modu9 === 1) {
	      if (txtnIncluir.current.checked && txtnModificar.current.checked) {
	        txtnTodos.current.checked = true;
	      } else {
	        txtnTodos.current.checked = false;
	      }
	    }
	
	    /* if (modu10 === 1) {
	      if (txtdzIncluir.current.checked && txtdzModificar.current.checked && txtdzCosultar.current.checked && txtdzEliminar.current.checked &&
	        txtdzImprimir.current.checked) {
	        txtdzTodos.current.checked = true;
	      } else {
	        txtdzTodos.current.checked = false;
	      }
	    } */
	
	    if (modu11 === 1) {
	      if (txtReport1.current.checked && txtReport2.current.checked && txtReport3.current.checked && txtReport4.current.checked) {
	        txtReportTodos.current.checked = true;
	      } else {
	        txtReportTodos.current.checked = false;
	      }
	    }
	  };
	
	  var checkTodo = function checkTodo(e) {
	    if (e.target.name === "todosralmacen") {
	      if (txtuTodos.current.checked) {
	        txtuIncluir.current.checked = true;
	        txtuModificar.current.checked = true;
	        txtuCosultar.current.checked = true;
	        txtuEliminar.current.checked = true;
	        txtuImprimir.current.checked = true;
	      } else {
	        txtuIncluir.current.checked = false;
	        txtuModificar.current.checked = false;
	        txtuCosultar.current.checked = false;
	        txtuEliminar.current.checked = false;
	        txtuImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todosubialmacen") {
	      if (txtdTodos.current.checked) {
	        txtdIncluir.current.checked = true;
	        txtdModificar.current.checked = true;
	        txtdCosultar.current.checked = true;
	        txtdEliminar.current.checked = true;
	        txtdImprimir.current.checked = true;
	      } else {
	        txtdIncluir.current.checked = false;
	        txtdModificar.current.checked = false;
	        txtdCosultar.current.checked = false;
	        txtdEliminar.current.checked = false;
	        txtdImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todosumedidas") {
	      if (txttTodos.current.checked) {
	        txttIncluir.current.checked = true;
	        txttModificar.current.checked = true;
	        txttCosultar.current.checked = true;
	        txttEliminar.current.checked = true;
	        txttImprimir.current.checked = true;
	      } else {
	        txttIncluir.current.checked = false;
	        txttModificar.current.checked = false;
	        txttCosultar.current.checked = false;
	        txttEliminar.current.checked = false;
	        txttImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todosmarca") {
	      if (txtcTodos.current.checked) {
	        txtcIncluir.current.checked = true;
	        txtcModificar.current.checked = true;
	        txtcCosultar.current.checked = true;
	        txtcEliminar.current.checked = true;
	        txtcImprimir.current.checked = true;
	      } else {
	        txtcIncluir.current.checked = false;
	        txtcModificar.current.checked = false;
	        txtcCosultar.current.checked = false;
	        txtcEliminar.current.checked = false;
	        txtcImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todosmodelo") {
	      if (txtcoTodos.current.checked) {
	        txtcoIncluir.current.checked = true;
	        txtcoModificar.current.checked = true;
	        txtcoCosultar.current.checked = true;
	        txtcoEliminar.current.checked = true;
	        txtcoImprimir.current.checked = true;
	      } else {
	        txtcoIncluir.current.checked = false;
	        txtcoModificar.current.checked = false;
	        txtcoCosultar.current.checked = false;
	        txtcoEliminar.current.checked = false;
	        txtcoImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todostproductos") {
	      if (txtsTodos.current.checked) {
	        txtsIncluir.current.checked = true;
	        txtsModificar.current.checked = true;
	        txtsCosultar.current.checked = true;
	        txtsEliminar.current.checked = true;
	        txtsImprimir.current.checked = true;
	      } else {
	        txtsIncluir.current.checked = false;
	        txtsModificar.current.checked = false;
	        txtsCosultar.current.checked = false;
	        txtsEliminar.current.checked = false;
	        txtsImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todosproductos") {
	      if (txtsiTodos.current.checked) {
	        txtsiIncluir.current.checked = true;
	        txtsiModificar.current.checked = true;
	        txtsiCosultar.current.checked = true;
	        txtsiEliminar.current.checked = true;
	        txtsiImprimir.current.checked = true;
	      } else {
	        txtsiIncluir.current.checked = false;
	        txtsiModificar.current.checked = false;
	        txtsiCosultar.current.checked = false;
	        txtsiEliminar.current.checked = false;
	        txtsiImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todosopinventario") {
	      if (txtoTodos.current.checked) {
	        txtoIncluir.current.checked = true;
	        txtoModificar.current.checked = true;
	        txtoCosultar.current.checked = true;
	        txtoEliminar.current.checked = true;
	        txtoImprimir.current.checked = true;
	        txtIngreso.current.checked = true;
	        txtSalida.current.checked = true;
	        txtTraslado.current.checked = true;
	        txtObsequio.current.checked = true;
	        txtPrestamo.current.checked = true;
	        txtAjuste.current.checked = true;
	      } else {
	        txtoIncluir.current.checked = false;
	        txtoModificar.current.checked = false;
	        txtoCosultar.current.checked = false;
	        txtoEliminar.current.checked = false;
	        txtoImprimir.current.checked = false;
	        txtIngreso.current.checked = false;
	        txtSalida.current.checked = false;
	        txtTraslado.current.checked = false;
	        txtObsequio.current.checked = false;
	        txtPrestamo.current.checked = false;
	        txtAjuste.current.checked = false;
	      }
	    } else if (e.target.name === "todosactuxlsx") {
	      if (txtnTodos.current.checked) {
	        txtnIncluir.current.checked = true;
	        txtnModificar.current.checked = true;
	      } else {
	        txtnIncluir.current.checked = false;
	        txtnModificar.current.checked = false;
	      }
	    } else if (e.target.name === "todosubialmacen") {
	      if (txtocTodos.current.checked) {
	        txtocIncluir.current.checked = true;
	        txtocModificar.current.checked = true;
	        txtocCosultar.current.checked = true;
	        txtocEliminar.current.checked = true;
	        txtocImprimir.current.checked = true;
	      } else {
	        txtocIncluir.current.checked = false;
	        txtocModificar.current.checked = false;
	        txtocCosultar.current.checked = false;
	        txtocEliminar.current.checked = false;
	        txtocImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todoslosreportes") {
	      if (txtReportTodos.current.checked) {
	        txtReport1.current.checked = true;
	        txtReport2.current.checked = true;
	        txtReport3.current.checked = true;
	        txtReport4.current.checked = true;
	      } else {
	        txtReport1.current.checked = false;
	        txtReport2.current.checked = false;
	        txtReport3.current.checked = false;
	        txtReport4.current.checked = false;
	      }
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'xl',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.op === 1) {
	          setOperacion(2);
	          if (props.usuario.accinventario.toString().substring(0, 1) === '1') {
	            setModu1(1);
	          } else {
	            setModu1(0);
	          }
	
	          if (props.usuario.accinventario.toString().substring(1, 2) === '1') {
	            setModu2(1);
	          } else {
	            setModu2(0);
	          }
	
	          if (props.usuario.accinventario.toString().substring(2, 3) === '1') {
	            setModu3(1);
	          } else {
	            setModu3(0);
	          }
	
	          if (props.usuario.accinventario.toString().substring(3, 4) === '1') {
	            setModu4(1);
	          } else {
	            setModu4(0);
	          }
	
	          if (props.usuario.accinventario.toString().substring(4, 5) === '1') {
	            setModu5(1);
	          } else {
	            setModu5(0);
	          }
	
	          if (props.usuario.accinventario.toString().substring(5, 6) === '1') {
	            setModu6(1);
	          } else {
	            setModu6(0);
	          }
	
	          if (props.usuario.accinventario.toString().substring(6, 7) === '1') {
	            setModu7(1);
	          } else {
	            setModu7(0);
	          }
	
	          if (props.usuario.accinventario.toString().substring(7, 8) === '1') {
	            setModu8(1);
	          } else {
	            setModu8(0);
	          }
	
	          if (props.usuario.accinventario.toString().substring(8, 9) === '1') {
	            setModu9(1);
	          } else {
	            setModu9(0);
	          }
	
	          /* if (props.usuario.accinventario.toString().substring(9, 10) === '1') {
	            setModu10(1);
	          } else {
	            setModu10(0);
	          } */
	
	          if (props.usuario.accinventario.toString().substring(11, 12) === '1') {
	            setModu11(1);
	          } else {
	            setModu11(0);
	          }
	          setHabilitado(false);
	        } else {
	          setHabilitado(true);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Permisos de Usuario (Almacen)'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto m-0' },
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1 d-flex justify-content-around', style: { fontSizeAdjust: '0.6' } },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-6 fw-bold' },
	              'Datos del Usuarios'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-200 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'USUARIO:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtLogin, defaultValue: props.usuario && props.usuario.login, className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement('input', { type: 'hidden', ref: txtIduser, defaultValue: props.usuario && props.usuario.idusuario }),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-180 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'CEDULA:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtCedula, defaultValue: props.persona && props.persona.cedula, className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-500 px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'NOMBRES Y APELLIDOS:'
	                ),
	                _react2.default.createElement('input', { type: 'text', defaultValue: props.persona && props.persona.nombres.trim() + " " + props.persona.apellidos.trim(), className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-170 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'ESTATUS:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtStatus, defaultValue: props.usuario && props.usuario.status === '1' ? 'ACTIVO' : 'INACTIVO', className: 'form-control text-uppercase fs-6 text-center', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-5 fw-bold' },
	              'Modulos Autorizados'
	            ),
	            modu1 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Registro de Almacen'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuTodos,
	                          defaultChecked: props.usuario.accbtnregalmacen.substring(0, 1) === '1' && props.usuario.accbtnregalmacen.substring(1, 2) === '1' && props.usuario.accbtnregalmacen.substring(2, 3) === '1' && props.usuario.accbtnregalmacen.substring(3, 4) === '1' && props.usuario.accbtnregalmacen.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todosralmacen', id: 'inlineCheckboxu' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuIncluir, defaultChecked: props.usuario.accbtnregalmacen.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuModificar, defaultChecked: props.usuario.accbtnregalmacen.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuCosultar, defaultChecked: props.usuario.accbtnregalmacen.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuEliminar, defaultChecked: props.usuario.accbtnregalmacen.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuImprimir, defaultChecked: props.usuario.accbtnregalmacen.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu2 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Ubicaciones de Almacen'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdTodos,
	                          defaultChecked: props.usuario.accbtnubialmacen.substring(0, 1) === '1' && props.usuario.accbtnubialmacen.substring(1, 2) === '1' && props.usuario.accbtnubialmacen.substring(2, 3) === '1' && props.usuario.accbtnubialmacen.substring(3, 4) === '1' && props.usuario.accbtnubialmacen.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todosubialmacen', id: 'inlineCheckboxd' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdIncluir, defaultChecked: props.usuario.accbtnubialmacen.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdModificar, defaultChecked: props.usuario.accbtnubialmacen.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdCosultar, defaultChecked: props.usuario.accbtnubialmacen.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdEliminar, defaultChecked: props.usuario.accbtnubialmacen.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdImprimir, defaultChecked: props.usuario.accbtnubialmacen.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu3 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Unidades de Medida'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttTodos,
	                          defaultChecked: props.usuario.accbtnumedida.substring(0, 1) === '1' && props.usuario.accbtnumedida.substring(1, 2) === '1' && props.usuario.accbtnumedida.substring(2, 3) === '1' && props.usuario.accbtnumedida.substring(3, 4) === '1' && props.usuario.accbtnumedida.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todosumedidas', id: 'inlineCheckboxt' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttIncluir, defaultChecked: props.usuario.accbtnumedida.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttModificar, defaultChecked: props.usuario.accbtnumedida.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttCosultar, defaultChecked: props.usuario.accbtnumedida.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttEliminar, defaultChecked: props.usuario.accbtnumedida.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttImprimir, defaultChecked: props.usuario.accbtnumedida.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu4 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Marca'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcTodos,
	                          defaultChecked: props.usuario.accbtnmarca.substring(0, 1) === '1' && props.usuario.accbtnmarca.substring(1, 2) === '1' && props.usuario.accbtnmarca.substring(2, 3) === '1' && props.usuario.accbtnmarca.substring(3, 4) === '1' && props.usuario.accbtnmarca.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todosmarca', id: 'inlineCheckboxc' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcIncluir, defaultChecked: props.usuario.accbtnmarca.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcModificar, defaultChecked: props.usuario.accbtnmarca.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcCosultar, defaultChecked: props.usuario.accbtnmarca.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcEliminar, defaultChecked: props.usuario.accbtnmarca.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcImprimir, defaultChecked: props.usuario.accbtnmarca.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu5 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Modelo'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcoTodos,
	                          defaultChecked: props.usuario.accbtnmodelo.substring(0, 1) === '1' && props.usuario.accbtnmodelo.substring(1, 2) === '1' && props.usuario.accbtnmodelo.substring(2, 3) === '1' && props.usuario.accbtnmodelo.substring(3, 4) === '1' && props.usuario.accbtnmodelo.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todosmodelo', id: 'inlineCheckboxco' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxco' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcoIncluir, defaultChecked: props.usuario.accbtnmodelo.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxco1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxco1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcoModificar, defaultChecked: props.usuario.accbtnmodelo.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxco2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxco2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcoCosultar, defaultChecked: props.usuario.accbtnmodelo.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxco3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxco3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcoEliminar, defaultChecked: props.usuario.accbtnmodelo.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxco4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxco4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcoImprimir, defaultChecked: props.usuario.accbtnmodelo.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxco5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxco5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu6 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Tipo de Producto'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsTodos,
	                          defaultChecked: props.usuario.accbtntproducto.substring(0, 1) === '1' && props.usuario.accbtntproducto.substring(1, 2) === '1' && props.usuario.accbtntproducto.substring(2, 3) === '1' && props.usuario.accbtntproducto.substring(3, 4) === '1' && props.usuario.accbtntproducto.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todostproductos', id: 'inlineCheckboxs' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxs' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsIncluir, defaultChecked: props.usuario.accbtntproducto.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxs1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxs1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsModificar, defaultChecked: props.usuario.accbtntproducto.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxs2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxs2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsCosultar, defaultChecked: props.usuario.accbtntproducto.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxs3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxs3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsEliminar, defaultChecked: props.usuario.accbtntproducto.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxs4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxs4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsImprimir, defaultChecked: props.usuario.accbtntproducto.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxs5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxs5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu7 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Productos'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsiTodos,
	                          defaultChecked: props.usuario.accbtnproducto.substring(0, 1) === '1' && props.usuario.accbtnproducto.substring(1, 2) === '1' && props.usuario.accbtnproducto.substring(2, 3) === '1' && props.usuario.accbtnproducto.substring(3, 4) === '1' && props.usuario.accbtnproducto.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todosproductos', id: 'inlineCheckboxsi' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsi' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsiIncluir, defaultChecked: props.usuario.accbtnproducto.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxsi1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsi1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsiModificar, defaultChecked: props.usuario.accbtnproducto.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxsi2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsi2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsiCosultar, defaultChecked: props.usuario.accbtnproducto.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxsi3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsi3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsiEliminar, defaultChecked: props.usuario.accbtnproducto.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxsi4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsi4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsiImprimir, defaultChecked: props.usuario.accbtnproducto.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxsi5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsi5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu8 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Operaci\xF3n de Inventario'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtoTodos,
	                          defaultChecked: props.usuario.accbtnopinventario.substring(0, 1) === '1' && props.usuario.accbtnopinventario.substring(1, 2) === '1' && props.usuario.accbtnopinventario.substring(2, 3) === '1' && props.usuario.accbtnopinventario.substring(3, 4) === '1' && props.usuario.accbtnopinventario.substring(4, 5) === '1' && props.usuario.accbtnopinventario.substring(5, 6) === '1' && props.usuario.accbtnopinventario.substring(6, 7) === '1' && props.usuario.accbtnopinventario.substring(7, 8) === '1' && props.usuario.accbtnopinventario.substring(8, 9) === '1' && props.usuario.accbtnopinventario.substring(9, 10) === '1' && props.usuario.accbtnopinventario.substring(10, 11) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todosopinventario', id: 'inlineCheckboxo' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxo' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtoIncluir, defaultChecked: props.usuario.accbtnopinventario.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxo1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxo1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtoModificar, defaultChecked: props.usuario.accbtnopinventario.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxo2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxo2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtoCosultar, defaultChecked: props.usuario.accbtnopinventario.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxo3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxo3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtoEliminar, defaultChecked: props.usuario.accbtnopinventario.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxo4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxo4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtoImprimir, defaultChecked: props.usuario.accbtnopinventario.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxo5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxo5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtIngreso, defaultChecked: props.usuario.accbtnopinventario.substring(5, 6) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxo6' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxo6' },
	                          'INGRESO'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtSalida, defaultChecked: props.usuario.accbtnopinventario.substring(6, 7) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxo7' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxo7' },
	                          'SALIDA'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtTraslado, defaultChecked: props.usuario.accbtnopinventario.substring(7, 8) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxo8' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxo8' },
	                          'TRASLADO'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtObsequio, defaultChecked: props.usuario.accbtnopinventario.substring(8, 9) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxo9' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxo9' },
	                          'OBSEQUIO/DONACION'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtPrestamo, defaultChecked: props.usuario.accbtnopinventario.substring(9, 10) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxo10' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxo10' },
	                          'PRESTAMO'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtAjuste, defaultChecked: props.usuario.accbtnopinventario.substring(10, 11) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxo11' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxo11' },
	                          'AJUSTE'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu9 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Actualizar por XLSX'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtnTodos,
	                          defaultChecked: props.usuario.accbtnactxlsx.substring(0, 1) === '1' && props.usuario.accbtnactxlsx.substring(1, 2) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todosactuxlsx', id: 'inlineCheckboxn' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxn' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtnIncluir, defaultChecked: props.usuario.accbtnactxlsx.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxn1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxn1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtnModificar, defaultChecked: props.usuario.accbtnactxlsx.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxn2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxn2' },
	                          'PROCESAR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu11 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Reportes'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReportTodos,
	                          defaultChecked: props.usuario.accbtnireports.substring(0, 1) === '1' && props.usuario.accbtnireports.substring(1, 2) === '1' && props.usuario.accbtnireports.substring(2, 3) === '1' && props.usuario.accbtnireports.substring(3, 4) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todoslosreportes', id: 'inlineCheckboxr' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport1, defaultChecked: props.usuario.accbtnireports.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr1' },
	                          'LISTA DE PRODUCTOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport2, defaultChecked: props.usuario.accbtnireports.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr2' },
	                          'LISTA DE PRODUCTOS EN EXISTENCIA'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport3, defaultChecked: props.usuario.accbtnireports.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr3' },
	                          'REPORTE DE OPERACIONES DE INVENTARIO'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport4, defaultChecked: props.usuario.accbtnireports.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr4' },
	                          'REPORTE DE OPERACIONES DE INVENTARIO OBSEQUIO/DONACIONES'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : ''
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-4 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: props.usuario && props.usuario.status === '0' ? true : false, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-success' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check-circle' },
	              '  Aceptar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7061 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoPersona = __webpack_require__(64);
	
	var _catalogoPersona2 = _interopRequireDefault(_catalogoPersona);
	
	var _varios = __webpack_require__(14);
	
	var _catalogoAlmacen = __webpack_require__(51);
	
	var _catalogoAlmacen2 = _interopRequireDefault(_catalogoAlmacen);
	
	var _core = __webpack_require__(19);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TablaAlmacen = function TablaAlmacen(props) {
	  var headCells = [{
	    id: "1",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "CODIGO",
	    textAlign: "center"
	  }, {
	    id: "2",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "DESCRIPCION",
	    textAlign: "center"
	  }, {
	    id: "3",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "RESPONSABLE",
	    textAlign: "center"
	  }];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var anio = JSON.parse(sessionStorage.getItem("anioactu"));
	  var fechaTope = (0, _moment2.default)(JSON.parse(sessionStorage.getItem("fechasistema"))).format("YYYY-MM-DD").replace(anio.toString(), (anio - 18).toString());
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var accbtnregalmacen = JSON.parse(sessionStorage.getItem("accbtnregalmacenc"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var txtVentas = (0, _react.useRef)();
	  var txtCodAlmacen = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	  var cmbNacionalidad = (0, _react.useRef)();
	  var txtCedRes = (0, _react.useRef)();
	  var cmbSexo = (0, _react.useRef)();
	  var txtFechaNac = (0, _react.useRef)();
	  var txtNomResp = (0, _react.useRef)();
	  var txtApeResp = (0, _react.useRef)();
	  var txtDireccion = (0, _react.useRef)();
	  var txtEmail = (0, _react.useRef)();
	  var txtTlf1 = (0, _react.useRef)();
	  var txtTlf2 = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      body = _useState2[0],
	      setBody = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(true),
	      _useState6 = _slicedToArray(_useState5, 2),
	      habilitadoNU = _useState6[0],
	      setHabilitadoNU = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(true),
	      _useState8 = _slicedToArray(_useState7, 2),
	      habilitado = _useState8[0],
	      setHabilitado = _useState8[1];
	
	  var _useState9 = (0, _react.useState)("Gestionar Almacenes."),
	      _useState10 = _slicedToArray(_useState9, 2),
	      tituloHeader = _useState10[0],
	      setTituloHeader = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mensaje = _useState12[0],
	      setMensaje = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensajesino = _useState14[0],
	      setMensajesino = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      catalogoAlmacen = _useState16[0],
	      setCatalogoAlmacen = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      catalogoPersona = _useState18[0],
	      setCatalogoPersona = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      operacionPer = _useState20[0],
	      setOperacionPer = _useState20[1];
	
	  var _useState21 = (0, _react.useState)("visible"),
	      _useState22 = _slicedToArray(_useState21, 2),
	      visibleBtn = _useState22[0],
	      setVisibleBtn = _useState22[1];
	
	  var _useState23 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    catalogoper: true
	  }),
	      _useState24 = _slicedToArray(_useState23, 2),
	      botones = _useState24[0],
	      setBotones = _useState24[1];
	
	  var _useState25 = (0, _react.useState)([]),
	      _useState26 = _slicedToArray(_useState25, 2),
	      records = _useState26[0],
	      setRecords = _useState26[1];
	
	  var _useState27 = (0, _react.useState)([]),
	      _useState28 = _slicedToArray(_useState27, 2),
	      Stock = _useState28[0],
	      setStock = _useState28[1];
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "correoe" || e.target.name === "apellidos" || e.target.name === "direccion" || e.target.name === "nombres" || e.target.name === "descripcion") {
	      /*  e.target.value = e.target.value.toUpperCase(); */
	    } else if (e.target.name === "nacionalidad" && txtCedRes.current.value !== "") {
	      if (e.target.value !== "") {
	        datosRes();
	      } else {
	        txtCedRes.current.value = "";
	        cmbSexo.current.value = "";
	        txtFechaNac.current.value = "";
	        txtNomResp.current.value = "";
	        txtApeResp.current.value = "";
	        txtDireccion.current.value = "";
	        txtEmail.current.value = "";
	        txtTlf1.current.value = "";
	        txtTlf2.current.value = "";
	        setHabilitadoNU(true);
	      }
	    }
	  };
	
	  var handleInputNumChange = function handleInputNumChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	
	    if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false; //alert(e.which);
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = "idalmacen, trim(descripcion) as descripcion, responsable, ventas";
	    var nomtab = "almacen";
	    var nomid = "idalmacen";
	    var id = txtCodAlmacen.current.value;
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        txtDescripcion.current.value = "";
	        txtVentas.current.checked = false;
	
	        if (response.data !== "") {
	          setOperacionPer(0);
	          txtDescripcion.current.value = response.data.descripcion.trim();
	          cmbNacionalidad.current.value = response.data.responsable.trim().substring(0, 1);
	          txtCedRes.current.value = response.data.responsable.trim().substring(1, 9);
	          txtVentas.current.checked = response.data.ventas ? true : false;
	          datosRes();
	          if (!botones.modificar) {
	            setBotones(Object.assign({}, botones, { catalogoper: false }));
	          }
	          seleccionarStock(response.data.idalmacen);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un almacen con este codigo",
	            icono: "informacion"
	          });
	          txtVentas.current.checked = false;
	          txtDescripcion.current.value = "";
	          cmbNacionalidad.current.value = "";
	          txtCedRes.current.value = "";
	          cmbSexo.current.value = "";
	          txtFechaNac.current.value = "";
	          txtNomResp.current.value = "";
	          txtApeResp.current.value = "";
	          txtDireccion.current.value = "";
	          txtEmail.current.value = "";
	          txtTlf1.current.value = "";
	          txtTlf2.current.value = "";
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var validarAlmacen = function validarAlmacen(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        seleccionarRegistro();
	      }
	    }
	  };
	
	  var datosRes = function datosRes() {
	    var campos = "*";
	    var nomtab = "persona";
	    var nomid = "cedula";
	    var nomid2 = "nacionalidad";
	    var id = txtCedRes.current.value;
	    var id2 = cmbNacionalidad.current.value;
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=" + id2;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        cmbSexo.current.value = "";
	        txtFechaNac.current.value = "";
	        txtNomResp.current.value = "";
	        txtApeResp.current.value = "";
	        txtDireccion.current.value = "";
	        txtEmail.current.value = "";
	        txtTlf1.current.value = "";
	        txtTlf2.current.value = "";
	
	        if (response.data !== "") {
	          setHabilitadoNU(true);
	          setOperacionPer(0);
	          cmbSexo.current.value = response.data.sexo;
	          txtFechaNac.current.value = (0, _moment2.default)(response.data.fnacimiento).format("YYYY-MM-DD");
	          txtNomResp.current.value = response.data.nombres;
	          txtApeResp.current.value = response.data.apellidos;
	          txtDireccion.current.value = response.data.direccion;
	          txtEmail.current.value = response.data.correoe;
	          txtTlf1.current.value = response.data.tlf1;
	          txtTlf2.current.value = response.data.tlf2;
	          if (!botones.consultar) {
	            btnCancela.current.focus();
	          } else {
	            btnAcepta.current.focus();
	          }
	        } else {
	          txtNomResp.current.focus();
	          setOperacionPer(1);
	          setHabilitadoNU(false);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var validarPersona = function validarPersona(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (cmbNacionalidad.current.value !== "") {
	          datosRes();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "debe seleccionar la nacionalidad",
	            icono: "informacion"
	          });
	          cmbNacionalidad.current.focus();
	        }
	      } else {
	        cmbNacionalidad.current.value = "";
	        cmbSexo.current.value = "";
	        txtFechaNac.current.value = "";
	        txtNomResp.current.value = "";
	        txtApeResp.current.value = "";
	        txtDireccion.current.value = "";
	        txtEmail.current.value = "";
	        txtTlf1.current.value = "";
	        txtTlf2.current.value = "";
	        setHabilitadoNU(true);
	      }
	    }
	  };
	
	  var onCatalogoAlmacen = function onCatalogoAlmacen(values) {
	    setCatalogoAlmacen(false);
	    txtCodAlmacen.current.value = values.idalmacen;
	    txtVentas.current.checked = values.ventas ? true : false;
	    txtDescripcion.current.value = values.descripcion;
	    cmbNacionalidad.current.value = values.responsable.substring(0, 1);
	    txtCedRes.current.value = values.responsable.substring(1, 8);
	    seleccionarStock(values.idalmacen);
	    datosRes();
	    if (!botones.modificar) {
	      setBotones(Object.assign({}, botones, { catalogoper: false }));
	    }
	  };
	
	  var onCatalogoPersona = function onCatalogoPersona(values) {
	    setCatalogoPersona(false);
	    setHabilitadoNU(true);
	    setOperacionPer(0);
	    cmbNacionalidad.current.value = values.nacPer;
	    txtCedRes.current.value = values.cedPer;
	    cmbSexo.current.value = values.sexoPer;
	    txtFechaNac.current.value = (0, _moment2.default)(values.fnacPer).format("YYYY-MM-DD");
	    txtNomResp.current.value = values.nomPer;
	    txtApeResp.current.value = values.apePer;
	    txtDireccion.current.value = values.direPer;
	    txtEmail.current.value = values.correoPer;
	    txtTlf1.current.value = values.tlf1Per;
	    txtTlf2.current.value = values.tlf2Per;
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	    if (!botones.incluir || !botones.modificar) {
	      if (txtDescripcion.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Debe ingresar una descripción al Almacen",
	          icono: "informacion"
	        });
	        txtDescripcion.current.focus();
	        sigue = false;
	      } else if (txtCedRes.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Debe ingresar la cedula el responsable",
	          icono: "informacion"
	        });
	        txtCedRes.current.focus();
	        sigue = false;
	      } else if (operacionPer === 1) {
	        if (cmbNacionalidad.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe seleccionar la nacionalidad del responsable",
	            icono: "informacion"
	          });
	          cmbNacionalidad.current.focus();
	          sigue = false;
	        } else if (cmbSexo.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe seleccionar el Sexo del responsable",
	            icono: "informacion"
	          });
	          cmbSexo.current.focus();
	          sigue = false;
	        } else if (txtFechaNac.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar fecha nacimiento del responsable",
	            icono: "informacion"
	          });
	          txtFechaNac.current.focus();
	          sigue = false;
	        } else if (txtNomResp.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar el nombre del responsable",
	            icono: "informacion"
	          });
	          txtNomResp.current.focus();
	          sigue = false;
	        } else if (txtApeResp.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar el apellido del responsable",
	            icono: "informacion"
	          });
	          txtApeResp.current.focus();
	          sigue = false;
	        } else if (txtDireccion.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar la dirección del responsable",
	            icono: "informacion"
	          });
	          txtDireccion.current.focus();
	          sigue = false;
	        } else if (txtEmail.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar el correo del responsable",
	            icono: "informacion"
	          });
	          txtEmail.current.focus();
	          sigue = false;
	        } else if (txtTlf1.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar el Telefono del responsable",
	            icono: "informacion"
	          });
	          txtTlf1.current.focus();
	          sigue = false;
	        } else if (txtTlf2.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar el Celular del responsable",
	            icono: "informacion"
	          });
	          txtTlf2.current.focus();
	          sigue = false;
	        }
	      }
	    }
	    if (sigue) {
	      var almacen = [];
	      var repre = [];
	      almacen.push({
	        idalmacen: txtCodAlmacen.current.value === "" ? 0 : txtCodAlmacen.current.value,
	        descripcion: txtDescripcion.current.value.trim(),
	        idorganizacion: "1",
	        responsable: cmbNacionalidad.current.value + txtCedRes.current.value,
	        ventas: txtVentas.current.checked ? true : false
	      });
	      repre.push({
	        cedula: parseInt(txtCedRes.current.value),
	        correoe: txtEmail.current.value.trim(),
	        tlf1: txtTlf1.current.value.trim(),
	        tlf2: txtTlf2.current.value.trim(),
	        apellidos: txtApeResp.current.value.trim(),
	        direccion: txtDireccion.current.value.trim(),
	        fnacimiento: txtFechaNac.current.value.trim(),
	        nacionalidad: cmbNacionalidad.current.value.trim(),
	        nombres: txtNomResp.current.value.trim(),
	        sexo: cmbSexo.current.value.trim()
	      });
	
	      setBody({
	        operacionper: operacionPer,
	        almacen: almacen,
	        repre: repre
	      });
	
	      var msg = "";
	      if (!botones.incluir) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (!botones.modificar) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (!botones.eliminar) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + "/api/almacen/actualizar/" + ope;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (ope === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro creado correctamente",
	            icono: "exito"
	          });
	        } else if (ope === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro modificado correctamente",
	            icono: "exito"
	          });
	        } else if (ope === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro eliminado correctamente",
	            icono: "exito"
	          });
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = "";
	      if (error.response === undefined) {
	        mensaje = "Error de Conexion";
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "agente_rif_key"') {
	          mensaje = "Ya existe un Registro con este rif";
	        } else if (error.response.data.message === 'duplicate key value violates unique constraint "agente_email_key"') {
	          mensaje = "Ya existe un Registro con este correo";
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var blanquear = function blanquear() {
	    setTituloHeader("Gestionar Almacenes.");
	
	    setActivate(false);
	    setBody(null);
	    setOperacionPer(0);
	    setHabilitado(true);
	    setHabilitadoNU(true);
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      catalogoper: true
	    });
	    txtCodAlmacen.current.setAttribute("disabled", true);
	    txtCodAlmacen.current.value = "";
	    txtDescripcion.current.value = "";
	    cmbNacionalidad.current.value = "";
	    txtCedRes.current.value = "";
	    cmbSexo.current.value = "";
	    txtFechaNac.current.value = "";
	    txtNomResp.current.value = "";
	    txtApeResp.current.value = "";
	    txtDireccion.current.value = "";
	    txtEmail.current.value = "";
	    txtTlf1.current.value = "";
	    txtTlf2.current.value = "";
	    txtVentas.current.checked = false;
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    //props.onHideCancela();
	  };
	
	  var cerrar = function cerrar() {
	    blanquear();
	    seleccionarRegistros();
	    setVisibleBtn("visible");
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "almacen.*, persona.nombres, persona.apellidos";
	    var nomtab = "almacen, persona";
	    var condi = "persona.cedula = CAST(TRIM(REPLACE(REPLACE(responsable,'V',''),'E','')) AS BIGINT)";
	    var orden = "idalmacen";
	
	    var endpoint = op.conexion + "/api/consulta/selecionarregistrocondi?&campos=" + campos + "&nomtab=" + nomtab + "&condi=" + condi + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarStock = function seleccionarStock(idalmacen) {
	    var endpoint = op.conexion + "/api/inventario/productoexisselectubi?idalmacen=" + idalmacen;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setStock(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    }).finally(function () {});
	  };
	
	  var seleccionarUbicaciones = function seleccionarUbicaciones(almacen) {
	    var campos = "*";
	    var nomtab = "ubicacion";
	    var condi = "idalmacen = " + almacen;
	    var orden = "idubicacion desc";
	
	    var endpoint = op.conexion + "/api/consulta/selecionarregistrocondi?&campos=" + campos + "&nomtab=" + nomtab + "&condi=" + condi + "&orden=" + orden;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    }).finally(function () {});
	  };
	
	  var imprimirAlmacen = function imprimirAlmacen(tipo) {
	    return function (e) {
	      e.preventDefault();
	      if (accbtnregalmacen && accbtnregalmacen.toString().substring(4, 5) === "1") {
	        if (tipo === 1) {
	          window.open(op.reportes + "/almacen?afiliado=" + afiliado + "&reporte=ListaAlmacen", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	        } else {
	          window.open(op.reportes + "/productos?afiliado=" + afiliado + "&reporte=ListaProducto", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	        }
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación.",
	          texto: "¡No Posee Permiso para Realizar esta Acción!",
	          icono: "error"
	        });
	      }
	    };
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (accbtnregalmacen && accbtnregalmacen.toString().substring(0, 1) === "1") {
	          setVisibleBtn("collapse");
	          setTituloHeader("Incluir Almacenes.");
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            catalogoper: false
	          });
	          txtCodAlmacen.current.setAttribute("disabled", true);
	          setTimeout(function () {
	            return txtDescripcion.current.focus();
	          }, 200);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (accbtnregalmacen && accbtnregalmacen.toString().substring(1, 2) === "1") {
	          setVisibleBtn("collapse");
	          setTituloHeader("Editar Almacenes.");
	          txtCodAlmacen.current.removeAttribute("disabled");
	          setHabilitado(false);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          txtCodAlmacen.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (accbtnregalmacen && accbtnregalmacen.toString().substring(3, 4) === "1") {
	          setVisibleBtn("collapse");
	          setTituloHeader("Eliminar Almacenes.");
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          txtCodAlmacen.current.removeAttribute("disabled");
	          txtCodAlmacen.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (accbtnregalmacen && accbtnregalmacen.toString().substring(2, 3) === "1") {
	          setVisibleBtn("collapse");
	          setTituloHeader("Consultar Almacenes.");
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          txtCodAlmacen.current.removeAttribute("disabled");
	          txtCodAlmacen.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        setVisibleBtn("visible");
	        cancelar();
	      }
	    };
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarRegistros();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { className: "w-100 h-100" },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 m-0" },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 m-0" },
	        _react2.default.createElement(
	          "div",
	          { className: " col-xl-7 col-lg-7 col-md-12 mx-auto py-5" },
	          _react2.default.createElement(
	            "div",
	            { className: "card px-3 py-3" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 mx-auto" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light justify-content-between" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-4 col-lg-5" },
	                  _react2.default.createElement(
	                    "h3",
	                    null,
	                    tituloHeader
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-3 d-flex justify-content-end" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/inicio", className: "text-light " },
	                    _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "fw-bold" },
	                      "Salir"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "border-azul  py-3 rounded",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: " row rounded mx-auto d-flex justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2 col-md-6 col-lg-5 col-sm-4 col-xl-4" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "CODIGO ALMACEN:"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      autoComplete: "off",
	                      ref: txtCodAlmacen,
	                      disabled: true,
	                      onKeyUp: validarAlmacen,
	                      onBlur: validarAlmacen,
	                      name: "idalmacen",
	                      className: "form-control fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    }),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: botones.catalogo,
	                        onClick: function onClick() {
	                          return setCatalogoAlmacen(true);
	                        },
	                        type: "button",
	                        className: "btn btn-success"
	                      },
	                      _react2.default.createElement("i", { className: "fas fa-search" })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-check form-check-inline col-md-3 p-0 col-sm-4 col-lg-4" },
	                    _react2.default.createElement("input", {
	                      ref: txtVentas,
	                      disabled: habilitado,
	                      className: "form-check-input py-1",
	                      type: "checkbox",
	                      id: "inlineCheckbox1"
	                    }),
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "form-check-label px-1",
	                        htmlFor: "inlineCheckbox1"
	                      },
	                      "VENTAS"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "DESCRIPCION:"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      autoComplete: "off",
	                      disabled: habilitado,
	                      ref: txtDescripcion,
	                      onChange: onChange,
	                      name: "descripcion",
	                      className: "form-control text-uppercase fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12" },
	                    _react2.default.createElement(
	                      "fieldset",
	                      { className: " row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between" },
	                      _react2.default.createElement(
	                        "legend",
	                        {
	                          className: "float-none w-auto fw-bold",
	                          style: { fontSize: "15px" }
	                        },
	                        "Responsable"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-6 col-lg-5 col-sm-4 col-xl-4" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "CEDULA:"
	                        ),
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            ref: cmbNacionalidad,
	                            name: "nacionalidad",
	                            className: "form-select form-select-sm col-3",
	                            disabled: habilitado,
	                            "aria-label": ".form-select-sm example",
	                            onChange: onChange
	                          },
	                          _react2.default.createElement(
	                            "option",
	                            { value: "V" },
	                            "V"
	                          ),
	                          _react2.default.createElement(
	                            "option",
	                            { value: "E" },
	                            "E"
	                          )
	                        ),
	                        _react2.default.createElement("input", {
	                          ref: txtCedRes,
	                          autoComplete: "off",
	                          maxLength: 9,
	                          type: "text",
	                          disabled: habilitado,
	                          className: "form-control fs-6",
	                          name: "cedula",
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm",
	                          onKeyUp: validarPersona,
	                          onBlur: validarPersona,
	                          onChange: onChange
	                        }),
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            disabled: botones.catalogoper,
	                            type: "button",
	                            onClick: function onClick() {
	                              return setCatalogoPersona(true);
	                            },
	                            className: "btn btn-success"
	                          },
	                          _react2.default.createElement("i", { className: "fas fa-search" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-2 mx-auto" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "SEXO:"
	                        ),
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            ref: cmbSexo,
	                            className: "form-select form-select-sm",
	                            name: "sexo",
	                            disabled: habilitadoNU,
	                            onChange: onChange,
	                            "aria-label": ".form-select-sm example"
	                          },
	                          _react2.default.createElement(
	                            "option",
	                            { value: "M" },
	                            "M"
	                          ),
	                          _react2.default.createElement(
	                            "option",
	                            { value: "F" },
	                            "F"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-sm-5 col-md-7 col-lg-5 col-xl-5" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "FECHA DE NACIMIENTO"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "date",
	                          ref: txtFechaNac,
	                          max: fechaTope,
	                          className: "form-control text-uppercase fs-6",
	                          name: "fnacimiento",
	                          "aria-label": "Sizing example input",
	                          onChange: onChange,
	                          disabled: habilitadoNU,
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-sm-12 col-md-12 col-lg-6 col-xl-6" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "NOMBRES:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          autoComplete: "off",
	                          ref: txtNomResp,
	                          name: "nombres",
	                          className: "form-control text-uppercase fs-6",
	                          onChange: onChange,
	                          "aria-label": "Sizing example input",
	                          disabled: habilitadoNU,
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-sm-12 col-md-12 col-lg-6 col-xl-6" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "APELLIDOS:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          autoComplete: "off",
	                          ref: txtApeResp,
	                          name: "apellidos",
	                          className: "form-control text-uppercase fs-6",
	                          onChange: onChange,
	                          "aria-label": "Sizing example input",
	                          disabled: habilitadoNU,
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-12" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "DIRECCION:"
	                        ),
	                        _react2.default.createElement("textarea", {
	                          type: "area",
	                          autoComplete: "off",
	                          ref: txtDireccion,
	                          name: "direccion",
	                          className: "form-control text-uppercase fs-6",
	                          onChange: onChange,
	                          "aria-label": "Sizing example input",
	                          disabled: habilitadoNU,
	                          "aria-describedby": "inputGroup-sizing-sm",
	                          style: { height: 40 }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-5" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "EMAIL:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          autoComplete: "off",
	                          ref: txtEmail,
	                          className: "form-control text-uppercase fs-6",
	                          name: "correoe",
	                          "aria-label": "Sizing example input",
	                          onChange: onChange,
	                          disabled: habilitadoNU,
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-pd-220 px-1" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "TELEFONO:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          autoComplete: "off",
	                          maxLength: 11,
	                          ref: txtTlf1,
	                          className: "form-control fs-6",
	                          name: "tlf1",
	                          "aria-label": "Sizing example input",
	                          onChange: onChange,
	                          disabled: habilitadoNU,
	                          "aria-describedby": "inputGroup-sizing-sm",
	                          onKeyUp: handleInputNumChange
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-pd-220 px-2" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "CELULAR:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          autoComplete: "off",
	                          maxLength: 11,
	                          ref: txtTlf2,
	                          className: "form-control fs-6",
	                          name: "tlf2",
	                          "aria-label": "Sizing example input",
	                          onChange: onChange,
	                          disabled: habilitadoNU,
	                          "aria-describedby": "inputGroup-sizing-sm",
	                          onKeyUp: handleInputNumChange
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-xl-12 mt-2 mx-auto d-flex justify-content-end d-xl-none d-lg-none d-md-block d-sm-block" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        type: "button",
	                        className: "btn btn-sm mx-1 btn-primary rounded-pill",
	                        onClick: imprimirAlmacen(1)
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-print" },
	                        "Almacenes"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        type: "button",
	                        className: "btn btn-sm mx-1 btn-primary rounded-pill",
	                        onClick: imprimirAlmacen(2)
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-print" },
	                        "Productos"
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 d-flex justify-content-between mt-2" },
	                visibleBtn === "visible" ? _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 col-sm-12 col-lg-12 col-12  justify-content-start" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: botones.incluir,
	                      onClick: onBotones(1),
	                      className: "btn btn-sm mx-1 btn-primary rounded-pill",
	                      title: "Incluir Almacen"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-plus" },
	                      " ",
	                      "Incluir",
	                      " "
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: botones.consultar,
	                      onClick: onBotones(4),
	                      className: "btn btn-sm mx-1 btn-info rounded-pill",
	                      title: "Consultar Almacen"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-eye" },
	                      "Consultar"
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: botones.modificar,
	                      onClick: onBotones(2),
	                      className: "btn btn-sm mx-1 btn-warning rounded-pill",
	                      title: "Modificar Almacen"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-edit" },
	                      "Modificar"
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: botones.eliminar,
	                      onClick: onBotones(3),
	                      className: "btn btn-sm mx-1 btn-danger rounded-pill",
	                      title: "Eliminar Almacen"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-trash" },
	                      "Eliminar"
	                    ),
	                    " "
	                  )
	                ) : "",
	                visibleBtn === "visible" ? "" : _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 d-flex justify-content-end" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: botones.aceptar,
	                      onClick: onBotones(5),
	                      ref: btnAcepta,
	                      className: "mx-2 btn btn-sm rounded-pill btn-success"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      {
	                        className: "fas fa-check-circle"
	                      },
	                      " ",
	                      "Aceptar"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: botones.cancelar,
	                      onClick: onBotones(6),
	                      ref: btnCancela,
	                      className: "mx-2 btn btn-danger btn-sm rounded-pill"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      {
	                        className: "fas fa-window-close"
	                      },
	                      " ",
	                      "Cancelar"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-xl-5 col-lg-5 mx-auto py-5 h-100 d-sm-none d-md-none d-lg-block d-xl-block" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 mx-auto card" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 mx-auto h-100 row" },
	              _react2.default.createElement(
	                "div",
	                { className: "row mt-3 mb-3" },
	                _react2.default.createElement(
	                  "h5",
	                  { className: "m-0 titulo-content", style: { fontSize: 20 } },
	                  "Listado de Almacenes",
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      type: "button",
	                      className: "btn btn-sm btn-primary rounded-pill ml-2",
	                      onClick: imprimirAlmacen(1)
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-print" },
	                      " ",
	                      "Almacenes"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      type: "button",
	                      className: "btn btn-sm btn-primary rounded-pill ml-2",
	                      onClick: imprimirAlmacen(2)
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-print" },
	                      " ",
	                      "Productos"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row mb-3" },
	                _react2.default.createElement(
	                  TblContainer,
	                  {
	                    container: {
	                      height: 220,
	                      width: "100%",
	                      overflow: "auto",
	                      padding: "2px",
	                      backgroundColor: "white",
	                      fontSizeAdjust: "0.6"
	                    }
	                  },
	                  _react2.default.createElement(TblHead, null),
	                  _react2.default.createElement(
	                    _core.TableBody,
	                    { className: "overflow-hidden table-bordered" },
	                    records && records.map(function (item, index) {
	                      return _react2.default.createElement(
	                        _core.TableRow,
	                        { key: index, style: { padding: "0" } },
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseBar bg-light",
	                            style: { textAlign: "center", width: "20px" }
	                          },
	                          item.idalmacen
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseline bg-light",
	                            style: { textAlign: "center", width: "80px" }
	                          },
	                          item.descripcion
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseline bg-light",
	                            style: { textAlign: "center", width: "80px" }
	                          },
	                          item.nombres + " " + item.apellidos
	                        )
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row h-100 py-2 px-0 " },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-4 mx-auto d-none d-xl-block" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 mx-auto py-2 px-2 card bg-success" },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      "Total Ubicaciones:"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 row mx-auto px-0" },
	                      _react2.default.createElement(
	                        "h1",
	                        { className: "col text-right" },
	                        records.length,
	                        " "
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-4 mx-auto d-none d-xl-block" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 mx-auto py-2 px-2 card bg-info" },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      "Productos en Stock:"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 row mx-auto px-0" },
	                      _react2.default.createElement(
	                        "h1",
	                        { className: "col text-right" },
	                        Stock.length,
	                        " "
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-4 mx-auto d-none d-xl-block" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 mx-auto py-2 px-2 card bg-warning" },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      "Total:"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 row mx-auto px-0" },
	                      _react2.default.createElement(
	                        "h1",
	                        { className: "col text-right" },
	                        "0"
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoAlmacen2.default, {
	      show: catalogoAlmacen,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoAlmacen(false);
	      },
	      onHideAceptaCatalogo: onCatalogoAlmacen
	    }),
	    _react2.default.createElement(_catalogoPersona2.default, {
	      show: catalogoPersona,
	      onHideCancelaCatPer: function onHideCancelaCatPer() {
	        return setCatalogoPersona(false);
	      },
	      onHideAceptaCatPer: onCatalogoPersona
	    }),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        mensaje.titulo === "Exito." ? cerrar() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    )
	  );
	};
	exports.default = TablaAlmacen;

/***/ },
/* 7062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _varios = __webpack_require__(14);
	
	var _cartas = __webpack_require__(660);
	
	var _cartas2 = _interopRequireDefault(_cartas);
	
	var _catalogoubicacion = __webpack_require__(657);
	
	var _catalogoubicacion2 = _interopRequireDefault(_catalogoubicacion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TablaAlmacen = function TablaAlmacen(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var txtCodUbicacion = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	  var txtVentas = (0, _react.useRef)();
	  var cmbAlmacen = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      body = _useState2[0],
	      setBody = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(true),
	      _useState6 = _slicedToArray(_useState5, 2),
	      habilitado = _useState6[0],
	      setHabilitado = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mensaje = _useState8[0],
	      setMensaje = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mensajesino = _useState10[0],
	      setMensajesino = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      catalogoUbicacion = _useState12[0],
	      setCatalogoUbicacion = _useState12[1];
	
	  var _useState13 = (0, _react.useState)([]),
	      _useState14 = _slicedToArray(_useState13, 2),
	      almacen = _useState14[0],
	      setAlmacen = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true
	  }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      botones = _useState16[0],
	      setBotones = _useState16[1];
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'descripcionubicacion') {
	      e.target.value = e.target.value.toUpperCase();
	    } else {
	      e.target.value = e.target.value;
	    }
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	
	    var campos = 'idalmacen, trim(descripcion) as descripcion, trim(responsable) as responsable';
	    var nomtab = 'almacen';
	    var orden = 'idalmacen';
	
	    var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setAlmacen(response.data);
	        }
	      }
	    }).catch(function (error) {
	
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = 'idubicacion, trim(descripcionubicacion) as descripcionubicacion, idalmacen, ventas';
	    var nomtab = 'ubicacion';
	    var nomid = 'idubicacion';
	    var id = txtCodUbicacion.current.value;
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        txtDescripcion.current.value = '';
	
	        if (response.data !== '') {
	
	          txtDescripcion.current.value = response.data.descripcionubicacion.trim();
	          cmbAlmacen.current.value = response.data.idalmacen;
	          txtVentas.current.checked = response.data.ventas ? true : false;
	          if (!botones.modificar) {
	            setBotones(Object.assign({}, botones, { catalogoper: false }));
	          }
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una ubicacion con este codigo', icono: 'informacion' });
	          txtDescripcion.current.value = '';
	          cmbAlmacen.current.value = '';
	          txtVentas.current.checked = false;
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var validarUbicacion = function validarUbicacion(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value !== '') {
	
	        seleccionarRegistro();
	      }
	    }
	  };
	
	  var onCatalogoUbicacion = function onCatalogoUbicacion(values) {
	    setCatalogoUbicacion(false);
	    txtCodUbicacion.current.value = values.idubicacion;
	    txtDescripcion.current.value = values.descripcionubicacion;
	    cmbAlmacen.current.value = values.idalmacen;
	    txtVentas.current.checked = values.ventas ? true : false;
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	
	    var sigue = true;
	    if (!botones.incluir || !botones.modificar) {
	
	      if (txtDescripcion.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar una descripción a la ubicacion', icono: 'informacion' });
	        txtDescripcion.current.focus();
	        sigue = false;
	      } else if (cmbAlmacen.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe seleccionar el almacen', icono: 'informacion' });
	        cmbAlmacen.current.focus();
	        sigue = false;
	      }
	    }
	
	    if (sigue) {
	
	      var ubicacion = [];
	      ubicacion.push({
	        idubicacion: txtCodUbicacion.current.value === '' ? 0 : txtCodUbicacion.current.value,
	        descripcionubicacion: txtDescripcion.current.value.trim(),
	        idalmacen: cmbAlmacen.current.value,
	        ventas: txtVentas.current.checked ? true : false
	      });
	
	      setBody({
	        ubicacion: ubicacion
	      });
	
	      var msg = '';
	      if (!botones.incluir) {
	        msg = 'Esta Seguro de Registrar estos Datos.';
	      } else if (!botones.modificar) {
	        msg = 'Esta Seguro de Modificar estos Datos.';
	      } else if (!botones.eliminar) {
	        msg = 'Esta Seguro de Eliminar estos Datos.';
	      }
	
	      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + '/api/ubicacion/actualizar/' + ope;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (ope === 1) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
	        } else if (ope === 2) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
	        } else if (ope === 3) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = '';
	      if (error.response === undefined) {
	        mensaje = 'Error de Conexion';
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
	          mensaje = 'Ya existe un Registro con este rif';
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    procesarRegistro();
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setBody(null);
	    setHabilitado(true);
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true
	    });
	    txtCodUbicacion.current.setAttribute("disabled", true);
	    txtCodUbicacion.current.value = '';
	    txtDescripcion.current.value = '';
	    cmbAlmacen.current.value = '';
	    txtVentas.current.checked = false;
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var cerrar = function cerrar() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	
	      e.preventDefault();
	
	      if (op === 1) {
	        setHabilitado(false);
	        setBotones({
	          incluir: false,
	          consultar: true,
	          modificar: true,
	          eliminar: true,
	          aceptar: false,
	          cancelar: false,
	          catalogo: true
	        });
	        txtCodUbicacion.current.setAttribute("disabled", true);
	        setTimeout(function () {
	          return txtDescripcion.current.focus();
	        }, 200);
	      } else if (op === 2) {
	        txtCodUbicacion.current.removeAttribute("disabled");
	        setHabilitado(false);
	        setBotones({
	          incluir: true,
	          consultar: true,
	          modificar: false,
	          eliminar: true,
	          aceptar: false,
	          cancelar: false,
	          catalogo: false
	        });
	        txtCodUbicacion.current.focus();
	      } else if (op === 3) {
	        setHabilitado(true);
	        setBotones({
	          incluir: true,
	          consultar: true,
	          modificar: true,
	          eliminar: false,
	          aceptar: false,
	          cancelar: false,
	          catalogo: false
	        });
	        txtCodUbicacion.current.removeAttribute("disabled");
	        txtCodUbicacion.current.focus();
	      } else if (op === 4) {
	        setHabilitado(true);
	        setBotones({
	          incluir: true,
	          consultar: false,
	          modificar: true,
	          eliminar: true,
	          aceptar: true,
	          cancelar: false,
	          catalogo: false
	        });
	        txtCodUbicacion.current.removeAttribute("disabled");
	        txtCodUbicacion.current.focus();
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        cancelar();
	      }
	    };
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarRegistros();
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'w-100 h-100' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row col-md-12 m-0' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row col-md-12 m-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container px-5' },
	          _react2.default.createElement(
	            'div',
	            { className: 'px-5 py-5 col-md-10 mx-auto' },
	            _react2.default.createElement(_cartas2.default, null),
	            _react2.default.createElement(
	              'div',
	              { className: 'card px-3 py-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'border-azul  py-3 rounded' },
	                _react2.default.createElement(
	                  'div',
	                  { style: { fontFamily: 'Times New Roman, Times, serif' } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: ' row rounded mx-auto d-flex justify-content-between' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'input-group input-group-sm mb-2 col-md-4' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                        'CODIGO DE UBICACION:'
	                      ),
	                      _react2.default.createElement('input', { type: 'text', autoComplete: 'off', ref: txtCodUbicacion, disabled: true, onKeyUp: validarUbicacion, onBlur: validarUbicacion, name: 'idubicacion', className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                      _react2.default.createElement(
	                        'button',
	                        { disabled: botones.catalogo, onClick: function onClick() {
	                            return setCatalogoUbicacion(true);
	                          }, type: 'button', className: 'btn btn-success' },
	                        _react2.default.createElement('i', { className: 'fas fa-search' })
	                      )
	                    ),
	                    _react2.default.createElement('div', { className: 'col-md-7' }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-md-6 input-group input-group-sm mb-2' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                        'DESCRIPCION:'
	                      ),
	                      _react2.default.createElement('input', { type: 'text', autoComplete: 'off', disabled: habilitado, ref: txtDescripcion, onChange: onChange, name: 'descripcionubicacion', className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'input-group input-group-sm mb-2 col-md-4' },
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                        'ALMACEN:'
	                      ),
	                      _react2.default.createElement(
	                        'select',
	                        { ref: cmbAlmacen, name: 'almacen', className: 'form-select form-select-sm px-0', disabled: habilitado, 'aria-label': '.form-select-sm example', onChange: onChange },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '' },
	                          '--'
	                        ),
	                        almacen && almacen.map(function (item, index) {
	                          return _react2.default.createElement(
	                            'option',
	                            { key: index, value: item.idalmacen },
	                            ' ',
	                            item.descripcion,
	                            ' '
	                          );
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-check form-check-inline col-md-2 p-0 m-0' },
	                      _react2.default.createElement('input', { ref: txtVentas, disabled: habilitado, className: 'form-check-input py-1', type: 'checkbox', id: 'inlineCheckbox1' }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'form-check-label px-1', htmlFor: 'inlineCheckbox1' },
	                        'VENTAS'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 d-flex justify-content-between mt-2' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-7 d-flex justify-content-start' },
	                  _react2.default.createElement(
	                    'button',
	                    { disabled: botones.incluir, onClick: onBotones(1), className: 'btn btn-sm mx-1 btn-primary rounded-pill', style: { height: '27px' }, title: 'Incluir Almacen' },
	                    _react2.default.createElement(
	                      'i',
	                      { style: { fontSize: '9px' }, className: 'fas fa-plus' },
	                      ' Incluir '
	                    ),
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    { disabled: botones.consultar, onClick: onBotones(4), className: 'btn btn-sm mx-1 btn-info rounded-pill', style: { height: '27px' }, title: 'Consultar Almacen' },
	                    _react2.default.createElement(
	                      'i',
	                      { style: { fontSize: '9px' }, className: 'fas fa-eye' },
	                      'Consultar'
	                    ),
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    { disabled: botones.modificar, onClick: onBotones(2), className: 'btn btn-sm mx-1 btn-warning rounded-pill', style: { height: '27px' }, title: 'Modificar Almacen' },
	                    _react2.default.createElement(
	                      'i',
	                      { style: { fontSize: '9px' }, className: 'fa fa-edit' },
	                      'Modificar'
	                    ),
	                    ' '
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    { disabled: botones.eliminar, onClick: onBotones(3), className: 'btn btn-sm mx-1 btn-danger rounded-pill', style: { height: '27px' }, title: 'Eliminar Almacen' },
	                    _react2.default.createElement(
	                      'i',
	                      { style: { fontSize: '9px' }, className: 'fa fa-trash' },
	                      'Eliminar'
	                    ),
	                    ' '
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-4 d-flex justify-content-end' },
	                  _react2.default.createElement(
	                    'button',
	                    { disabled: botones.aceptar, onClick: onBotones(5), ref: btnAcepta, style: { height: '27px' }, className: 'mx-2 btn btn-sm rounded-pill btn-success' },
	                    _react2.default.createElement(
	                      'i',
	                      { className: 'fas fa-check-circle', style: { fontSize: '9px' } },
	                      'Aceptar'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    { disabled: botones.cancelar, onClick: onBotones(6), ref: btnCancela, style: { height: '27px' }, className: 'mx-2 btn btn-danger btn-sm rounded-pill' },
	                    _react2.default.createElement(
	                      'i',
	                      { className: 'fas fa-window-close', style: { fontSize: '9px' } },
	                      ' Cancelar'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoubicacion2.default, {
	      show: catalogoUbicacion,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoUbicacion(false);
	      },
	      onHideAceptaCatalogo: onCatalogoUbicacion
	    }),
	    _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	      onHide: function onHide() {
	        mensaje.titulo === 'Exito.' ? cerrar() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	      } }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	      }, onHideSi: handleCloseSi }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        'cargando...'
	      )
	    )
	  );
	};
	exports.default = TablaAlmacen;

/***/ },
/* 7063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(19);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _gestionarDepartamento = __webpack_require__(661);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _varios = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TablaDepartamento = function TablaDepartamento(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var municipios = [];
	
	  var headCells = [{ id: '', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'COD.', textAlign: 'center' }, { id: '', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' }, { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }];
	
	  var colores = ['#17a2b8', '#ffae00', '#dc3545', '#BDB76B', '#7B68EE', '#4B0082', '#00ffff', '#0080ff', '#0000ff', '#8000ff', '#ff00ff', '#ff0080'];
	
	  var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      mensajesino = _useState4[0],
	      setMensajesino = _useState4[1];
	
	  var txtBuscador = (0, _react.useRef)();
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mostrar = _useState6[0],
	      setMostrar = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mostrar2 = _useState8[0],
	      setMostrar2 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      activate = _useState10[0],
	      setActivate = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([{
	    codigo: 1,
	    nombre: 'JESUS',
	    descripcion: 'ALMACEN 1'
	  }]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      records = _useState12[0],
	      setRecords = _useState12[1];
	
	  var _useState13 = (0, _react.useState)([]),
	      _useState14 = _slicedToArray(_useState13, 2),
	      expendedor = _useState14[0],
	      setExpendedor = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(1),
	      _useState16 = _slicedToArray(_useState15, 2),
	      operacion = _useState16[0],
	      setOperacion = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(),
	      _useState18 = _slicedToArray(_useState17, 2),
	      persona = _useState18[0],
	      setPersona = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({ fn: function fn(items) {
	      return items;
	    } }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      filterFn = _useState20[0],
	      setFilterFn = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(),
	      _useState22 = _slicedToArray(_useState21, 2),
	      ciudades = _useState22[0],
	      setCiudades = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(),
	      _useState24 = _slicedToArray(_useState23, 2),
	      credito = _useState24[0],
	      setCredito = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(0),
	      _useState26 = _slicedToArray(_useState25, 2),
	      total = _useState26[0],
	      setTotal = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      activos = _useState28[0],
	      setActivos = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(0),
	      _useState30 = _slicedToArray(_useState29, 2),
	      inactivos = _useState30[0],
	      setInactivos = _useState30[1];
	
	  var _useState31 = (0, _react.useState)([]),
	      _useState32 = _slicedToArray(_useState31, 2),
	      municipiosEx = _useState32[0],
	      setMunicipiosEx = _useState32[1];
	
	  var _useState33 = (0, _react.useState)([]),
	      _useState34 = _slicedToArray(_useState33, 2),
	      municipiosData = _useState34[0],
	      setMunicipiosData = _useState34[1];
	
	  var _useState35 = (0, _react.useState)([]),
	      _useState36 = _slicedToArray(_useState35, 2),
	      datos = _useState36[0],
	      setDatos = _useState36[1];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting,
	      TblPagination = _useTable.TblPagination;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	    var st = '';
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") return items;else return items.filter(function (x) {
	          st = x.status === '51' ? 'activo' : 'inactivo';
	          if (x.idagente.includes(target.value) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.rif.toLowerCase().includes(target.value.toLowerCase()) || x.nrolicencia.toLowerCase().includes(target.value.toLowerCase()) || st.toLowerCase().includes(target.value.toLowerCase())) {
	            return x;
	          }
	        });
	      }
	    });
	  };
	
	  var gestionarExpendedor = function gestionarExpendedor(op, id) {
	    return function (e) {
	      if (op === 4) {
	        setOperacion(4);
	        /*    getExpendedor(id); */
	      } else if (op === 1) {
	        setOperacion(op);
	        setMostrar(true);
	      } else if (op === 2) {
	        setOperacion(op);
	        /*   getExpendedor(id); */
	      } else if (op === 3) {
	        setOperacion(op);
	        /*       getExpendedor(id); */
	      }
	    };
	  };
	
	  var selectCiudad = function selectCiudad(id) {
	    var campos = '*';
	    var nomtab = 'ciudad';
	    var nomid = 'idmunicipio';
	    var endpoint = op.conexion + '/api/consulta/modelirows?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid;
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setCiudades(response.data);
	        setMostrar2(true);
	      }
	    }).catch(function (error) {
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var handleCancela2 = function handleCancela2() {
	    setMostrar2(false);
	    setExpendedor('');
	    setCredito('');
	  };
	
	  var cerramodal = function cerramodal() {
	
	    setMostrar(false);
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    /*  getExpendedor(); */
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  (0, _react.useEffect)(function () {
	
	    /*  setActivate(true); */
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', width: '100%' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'row col-md-12', style: { margin: 0 } },
	      _react2.default.createElement(
	        'div',
	        { className: 'row col-md-12', style: { margin: 0 } },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-8 py-3 mx-auto mt-5' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 p-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row col-12 d-flex justify-content-between' },
	              _react2.default.createElement('input', { type: 'text', className: ' col-3 form-control form-control-sm rounded-pill', ref: txtBuscador, onChange: handleSearch, placeholder: 'Buscar' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-3 d-flex justify-content-end' },
	                _react2.default.createElement(
	                  'button',
	                  { onClick: gestionarExpendedor(1, ''), style: { marginBottom: "5px" }, className: 'btn btn-sm btn-primary rounded-circle' },
	                  _react2.default.createElement('i', { className: 'fas fa-plus' }),
	                  ' '
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12', style: { margin: "auto" } },
	            _react2.default.createElement(
	              TblContainer,
	              null,
	              _react2.default.createElement(TblHead, null),
	              _react2.default.createElement(
	                _core.TableBody,
	                null,
	                records && recordsAfterPagingAndSorting().map(function (item, index) {
	                  return _react2.default.createElement(
	                    _core.TableRow,
	                    { key: index, style: { padding: "0" } },
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                      item.codigo
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center', width: '270px' } },
	                      item.descripcion
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: gestionarExpendedor(4, item.codigo), className: 'btn btn-sm mx-1 btn-info rounded-circle' },
	                        _react2.default.createElement('i', { className: 'fas fa-eye' }),
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: gestionarExpendedor(2, item.codigo), className: 'btn btn-sm mx-1 btn-warning rounded-circle' },
	                        _react2.default.createElement('i', { className: 'fa fa-edit' }),
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: gestionarExpendedor(3, item.codigo), className: 'btn btn-sm mx-1 btn-danger rounded-circle' },
	                        _react2.default.createElement('i', { className: 'fa fa-trash' }),
	                        ' '
	                      )
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(TblPagination, null)
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_gestionarDepartamento.GestionarDepartamento, {
	      show: mostrar,
	      onHideCancela: cerramodal,
	      operacion: operacion
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        'cargando...'
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	      } }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	      }, onHideSi: handleCloseSi })
	  );
	};
	exports.default = TablaDepartamento;

/***/ },
/* 7064 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(19);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _gestionarMarca = __webpack_require__(211);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _varios = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TablaMarca = function TablaMarca(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var municipios = [];
	
	  var headCells = [{ id: '', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'COD.', textAlign: 'center' }, { id: '', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' }, { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }];
	
	  var colores = ['#17a2b8', '#ffae00', '#dc3545', '#BDB76B', '#7B68EE', '#4B0082', '#00ffff', '#0080ff', '#0000ff', '#8000ff', '#ff00ff', '#ff0080'];
	
	  var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      mensajesino = _useState4[0],
	      setMensajesino = _useState4[1];
	
	  var txtBuscador = (0, _react.useRef)();
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mostrar = _useState6[0],
	      setMostrar = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mostrar2 = _useState8[0],
	      setMostrar2 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      activate = _useState10[0],
	      setActivate = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([{
	    codigo: 1,
	    nombre: 'JESUS',
	    descripcion: 'ALMACEN 1'
	  }]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      records = _useState12[0],
	      setRecords = _useState12[1];
	
	  var _useState13 = (0, _react.useState)([]),
	      _useState14 = _slicedToArray(_useState13, 2),
	      expendedor = _useState14[0],
	      setExpendedor = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(1),
	      _useState16 = _slicedToArray(_useState15, 2),
	      operacion = _useState16[0],
	      setOperacion = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(),
	      _useState18 = _slicedToArray(_useState17, 2),
	      persona = _useState18[0],
	      setPersona = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({ fn: function fn(items) {
	      return items;
	    } }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      filterFn = _useState20[0],
	      setFilterFn = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(),
	      _useState22 = _slicedToArray(_useState21, 2),
	      ciudades = _useState22[0],
	      setCiudades = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(),
	      _useState24 = _slicedToArray(_useState23, 2),
	      credito = _useState24[0],
	      setCredito = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(0),
	      _useState26 = _slicedToArray(_useState25, 2),
	      total = _useState26[0],
	      setTotal = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      activos = _useState28[0],
	      setActivos = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(0),
	      _useState30 = _slicedToArray(_useState29, 2),
	      inactivos = _useState30[0],
	      setInactivos = _useState30[1];
	
	  var _useState31 = (0, _react.useState)([]),
	      _useState32 = _slicedToArray(_useState31, 2),
	      municipiosEx = _useState32[0],
	      setMunicipiosEx = _useState32[1];
	
	  var _useState33 = (0, _react.useState)([]),
	      _useState34 = _slicedToArray(_useState33, 2),
	      municipiosData = _useState34[0],
	      setMunicipiosData = _useState34[1];
	
	  var _useState35 = (0, _react.useState)([]),
	      _useState36 = _slicedToArray(_useState35, 2),
	      datos = _useState36[0],
	      setDatos = _useState36[1];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting,
	      TblPagination = _useTable.TblPagination;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	    var st = '';
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") return items;else return items.filter(function (x) {
	          st = x.status === '51' ? 'activo' : 'inactivo';
	          if (x.idagente.includes(target.value) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.rif.toLowerCase().includes(target.value.toLowerCase()) || x.nrolicencia.toLowerCase().includes(target.value.toLowerCase()) || st.toLowerCase().includes(target.value.toLowerCase())) {
	            return x;
	          }
	        });
	      }
	    });
	  };
	
	  var gestionarExpendedor = function gestionarExpendedor(op, id) {
	    return function (e) {
	      if (op === 4) {
	        setOperacion(4);
	        /*    getExpendedor(id); */
	      } else if (op === 1) {
	        setOperacion(op);
	        setMostrar(true);
	      } else if (op === 2) {
	        setOperacion(op);
	        /*   getExpendedor(id); */
	      } else if (op === 3) {
	        setOperacion(op);
	        /*       getExpendedor(id); */
	      }
	    };
	  };
	
	  var selectCiudad = function selectCiudad(id) {
	    var campos = '*';
	    var nomtab = 'ciudad';
	    var nomid = 'idmunicipio';
	    var endpoint = op.conexion + '/api/consulta/modelirows?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid;
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setCiudades(response.data);
	        setMostrar2(true);
	      }
	    }).catch(function (error) {
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var handleCancela2 = function handleCancela2() {
	    setMostrar2(false);
	    setExpendedor('');
	    setCredito('');
	  };
	
	  var cerramodal = function cerramodal() {
	
	    setMostrar(false);
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    /*  getExpendedor(); */
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  (0, _react.useEffect)(function () {
	
	    /*  setActivate(true); */
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', width: '100%' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'row col-md-12', style: { margin: 0 } },
	      _react2.default.createElement(
	        'div',
	        { className: 'row col-md-12', style: { margin: 0 } },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-8 py-3 mx-auto mt-5' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 p-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row col-12 d-flex justify-content-between' },
	              _react2.default.createElement('input', { type: 'text', className: ' col-3 form-control form-control-sm rounded-pill', ref: txtBuscador, onChange: handleSearch, placeholder: 'Buscar' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-3 d-flex justify-content-end' },
	                _react2.default.createElement(
	                  'button',
	                  { onClick: gestionarExpendedor(1, ''), style: { marginBottom: "5px" }, className: 'btn btn-sm btn-primary rounded-circle' },
	                  _react2.default.createElement('i', { className: 'fas fa-plus' }),
	                  ' '
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12', style: { margin: "auto" } },
	            _react2.default.createElement(
	              TblContainer,
	              null,
	              _react2.default.createElement(TblHead, null),
	              _react2.default.createElement(
	                _core.TableBody,
	                null,
	                records && recordsAfterPagingAndSorting().map(function (item, index) {
	                  return _react2.default.createElement(
	                    _core.TableRow,
	                    { key: index, style: { padding: "0" } },
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                      item.codigo
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center', width: '270px' } },
	                      item.descripcion
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: gestionarExpendedor(4, item.codigo), className: 'btn btn-sm mx-1 btn-info rounded-circle' },
	                        _react2.default.createElement('i', { className: 'fas fa-eye' }),
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: gestionarExpendedor(2, item.codigo), className: 'btn btn-sm mx-1 btn-warning rounded-circle' },
	                        _react2.default.createElement('i', { className: 'fa fa-edit' }),
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: gestionarExpendedor(3, item.codigo), className: 'btn btn-sm mx-1 btn-danger rounded-circle' },
	                        _react2.default.createElement('i', { className: 'fa fa-trash' }),
	                        ' '
	                      )
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(TblPagination, null)
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_gestionarMarca.GestionarMarca, {
	      show: mostrar,
	      onHideCancela: cerramodal,
	      operacion: operacion
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        'cargando...'
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	      } }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	      }, onHideSi: handleCloseSi })
	  );
	};
	exports.default = TablaMarca;

/***/ },
/* 7065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(19);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _gestionarModelo = __webpack_require__(212);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _varios = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TablaModelo = function TablaModelo(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var municipios = [];
	
	  var headCells = [{ id: '', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'COD.', textAlign: 'center' }, { id: '', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' }, { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }];
	
	  var colores = ['#17a2b8', '#ffae00', '#dc3545', '#BDB76B', '#7B68EE', '#4B0082', '#00ffff', '#0080ff', '#0000ff', '#8000ff', '#ff00ff', '#ff0080'];
	
	  var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      mensajesino = _useState4[0],
	      setMensajesino = _useState4[1];
	
	  var txtBuscador = (0, _react.useRef)();
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mostrar = _useState6[0],
	      setMostrar = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mostrar2 = _useState8[0],
	      setMostrar2 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      activate = _useState10[0],
	      setActivate = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([{
	    codigo: 1,
	    nombre: 'JESUS',
	    descripcion: 'ALMACEN 1'
	  }]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      records = _useState12[0],
	      setRecords = _useState12[1];
	
	  var _useState13 = (0, _react.useState)([]),
	      _useState14 = _slicedToArray(_useState13, 2),
	      expendedor = _useState14[0],
	      setExpendedor = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(1),
	      _useState16 = _slicedToArray(_useState15, 2),
	      operacion = _useState16[0],
	      setOperacion = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(),
	      _useState18 = _slicedToArray(_useState17, 2),
	      persona = _useState18[0],
	      setPersona = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({ fn: function fn(items) {
	      return items;
	    } }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      filterFn = _useState20[0],
	      setFilterFn = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(),
	      _useState22 = _slicedToArray(_useState21, 2),
	      ciudades = _useState22[0],
	      setCiudades = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(),
	      _useState24 = _slicedToArray(_useState23, 2),
	      credito = _useState24[0],
	      setCredito = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(0),
	      _useState26 = _slicedToArray(_useState25, 2),
	      total = _useState26[0],
	      setTotal = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      activos = _useState28[0],
	      setActivos = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(0),
	      _useState30 = _slicedToArray(_useState29, 2),
	      inactivos = _useState30[0],
	      setInactivos = _useState30[1];
	
	  var _useState31 = (0, _react.useState)([]),
	      _useState32 = _slicedToArray(_useState31, 2),
	      municipiosEx = _useState32[0],
	      setMunicipiosEx = _useState32[1];
	
	  var _useState33 = (0, _react.useState)([]),
	      _useState34 = _slicedToArray(_useState33, 2),
	      municipiosData = _useState34[0],
	      setMunicipiosData = _useState34[1];
	
	  var _useState35 = (0, _react.useState)([]),
	      _useState36 = _slicedToArray(_useState35, 2),
	      datos = _useState36[0],
	      setDatos = _useState36[1];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting,
	      TblPagination = _useTable.TblPagination;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	    var st = '';
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") return items;else return items.filter(function (x) {
	          st = x.status === '51' ? 'activo' : 'inactivo';
	          if (x.idagente.includes(target.value) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.rif.toLowerCase().includes(target.value.toLowerCase()) || x.nrolicencia.toLowerCase().includes(target.value.toLowerCase()) || st.toLowerCase().includes(target.value.toLowerCase())) {
	            return x;
	          }
	        });
	      }
	    });
	  };
	
	  var gestionarExpendedor = function gestionarExpendedor(op, id) {
	    return function (e) {
	      if (op === 4) {
	        setOperacion(4);
	        /*    getExpendedor(id); */
	      } else if (op === 1) {
	        setOperacion(op);
	        setMostrar(true);
	      } else if (op === 2) {
	        setOperacion(op);
	        /*   getExpendedor(id); */
	      } else if (op === 3) {
	        setOperacion(op);
	        /*       getExpendedor(id); */
	      }
	    };
	  };
	
	  var selectCiudad = function selectCiudad(id) {
	    var campos = '*';
	    var nomtab = 'ciudad';
	    var nomid = 'idmunicipio';
	    var endpoint = op.conexion + '/api/consulta/modelirows?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid;
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setCiudades(response.data);
	        setMostrar2(true);
	      }
	    }).catch(function (error) {
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var handleCancela2 = function handleCancela2() {
	    setMostrar2(false);
	    setExpendedor('');
	    setCredito('');
	  };
	
	  var cerramodal = function cerramodal() {
	
	    setMostrar(false);
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    /*  getExpendedor(); */
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  (0, _react.useEffect)(function () {
	
	    /*  setActivate(true); */
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', width: '100%' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'row col-md-12', style: { margin: 0 } },
	      _react2.default.createElement(
	        'div',
	        { className: 'row col-md-12', style: { margin: 0 } },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-8 py-3 mx-auto mt-5' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 p-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row col-12 d-flex justify-content-between' },
	              _react2.default.createElement('input', { type: 'text', className: ' col-3 form-control form-control-sm rounded-pill', ref: txtBuscador, onChange: handleSearch, placeholder: 'Buscar' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-3 d-flex justify-content-end' },
	                _react2.default.createElement(
	                  'button',
	                  { onClick: gestionarExpendedor(1, ''), style: { marginBottom: "5px" }, className: 'btn btn-sm btn-primary rounded-circle' },
	                  _react2.default.createElement('i', { className: 'fas fa-plus' }),
	                  ' '
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12', style: { margin: "auto" } },
	            _react2.default.createElement(
	              TblContainer,
	              null,
	              _react2.default.createElement(TblHead, null),
	              _react2.default.createElement(
	                _core.TableBody,
	                null,
	                records && recordsAfterPagingAndSorting().map(function (item, index) {
	                  return _react2.default.createElement(
	                    _core.TableRow,
	                    { key: index, style: { padding: "0" } },
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                      item.codigo
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center', width: '270px' } },
	                      item.descripcion
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: gestionarExpendedor(4, item.codigo), className: 'btn btn-sm mx-1 btn-info rounded-circle' },
	                        _react2.default.createElement('i', { className: 'fas fa-eye' }),
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: gestionarExpendedor(2, item.codigo), className: 'btn btn-sm mx-1 btn-warning rounded-circle' },
	                        _react2.default.createElement('i', { className: 'fa fa-edit' }),
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: gestionarExpendedor(3, item.codigo), className: 'btn btn-sm mx-1 btn-danger rounded-circle' },
	                        _react2.default.createElement('i', { className: 'fa fa-trash' }),
	                        ' '
	                      )
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(TblPagination, null)
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_gestionarModelo.GestionarModelo, {
	      show: mostrar,
	      onHideCancela: cerramodal,
	      operacion: operacion
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        'cargando...'
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	      } }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	      }, onHideSi: handleCloseSi })
	  );
	};
	exports.default = TablaModelo;

/***/ },
/* 7066 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(19);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _incluirProducto = __webpack_require__(7052);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoAlmacen = __webpack_require__(51);
	
	var _catalogoAlmacen2 = _interopRequireDefault(_catalogoAlmacen);
	
	var _catalogoOperacionInventario = __webpack_require__(7032);
	
	var _catalogoOperacionInventario2 = _interopRequireDefault(_catalogoOperacionInventario);
	
	var _modalOpeinveProductExcel = __webpack_require__(7059);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TablaOperInventario = function TablaOperInventario() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var organizacion = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var accbtnopinventario = JSON.parse(sessionStorage.getItem("accbtnopinventarioc"));
	  var fechaSistema = (0, _moment2.default)(JSON.parse(sessionStorage.getItem("fechasistema"))).format("YYYY-MM-DD");
	
	  var headCells = [{ label: "COD.", textAlign: "center", width: "40px" }, { label: "PRODUCTO", textAlign: "center", width: "50px" }, { label: "CANTIDAD", textAlign: "center", width: "30px" }, { label: "PRECIO", textAlign: "center", width: "50px" }, { label: "UND. ALT.", textAlign: "center", width: "50px" }, { label: "FECHA VEN.", textAlign: "center", width: "50px" }, { label: "TIPO MOVIMIENTO", textAlign: "center", width: "50px" }, { label: "FECHA", textAlign: "center", width: "50px" }, { label: "N° FACTURA", textAlign: "center", width: "50px" }, {
	    label: _react2.default.createElement("i", { className: "fas fa-trash" }),
	    textAlign: "center",
	    width: "20px"
	  }];
	
	  var btnIncluir = (0, _react.useRef)();
	  var btnEditar = (0, _react.useRef)();
	  var btnEliminar = (0, _react.useRef)();
	  var btnConsultar = (0, _react.useRef)();
	  var btnCancelar = (0, _react.useRef)();
	  var btnAceptar = (0, _react.useRef)();
	  var txtIdOpeInv = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtCodAlmaOrigen = (0, _react.useRef)();
	  var txtDescripAlmaOrigen = (0, _react.useRef)();
	  var txtCodAlmaDestino = (0, _react.useRef)();
	  var txtDescripAlmaDestino = (0, _react.useRef)();
	  var txtObservacion = (0, _react.useRef)();
	  var cmbTipoOperacion = (0, _react.useRef)();
	  var cmbMoneda = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)("visible"),
	      _useState2 = _slicedToArray(_useState, 2),
	      visibleBtn = _useState2[0],
	      setVisibleBtn = _useState2[1];
	
	  var _useState3 = (0, _react.useState)("Gestionar Operaciones de Inventario."),
	      _useState4 = _slicedToArray(_useState3, 2),
	      tituloHeader = _useState4[0],
	      setTituloHeader = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mensaje = _useState6[0],
	      setMensaje = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mensajesino = _useState8[0],
	      setMensajesino = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mostrarActualizar = _useState10[0],
	      setMostrarActualizar = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(true),
	      _useState12 = _slicedToArray(_useState11, 2),
	      habilitadoBot = _useState12[0],
	      setHabilitadoBot = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(true),
	      _useState14 = _slicedToArray(_useState13, 2),
	      habilitarCat = _useState14[0],
	      setHabilitarCat = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      habilitado = _useState16[0],
	      setHabilitado = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      habilitadoM = _useState18[0],
	      setHabilitadoM = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(false),
	      _useState20 = _slicedToArray(_useState19, 2),
	      habilitarMoneda = _useState20[0],
	      setHabilitarMoneda = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(1),
	      _useState22 = _slicedToArray(_useState21, 2),
	      operacion = _useState22[0],
	      setOperacion = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(false),
	      _useState24 = _slicedToArray(_useState23, 2),
	      catalogoOpeInv = _useState24[0],
	      setCatalogoOpeInv = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(false),
	      _useState26 = _slicedToArray(_useState25, 2),
	      catalogoAlmacen = _useState26[0],
	      setCatalogoAlmacen = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(1),
	      _useState28 = _slicedToArray(_useState27, 2),
	      cualCat = _useState28[0],
	      setCualCat = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(null),
	      _useState30 = _slicedToArray(_useState29, 2),
	      body = _useState30[0],
	      setBody = _useState30[1];
	
	  var _useState31 = (0, _react.useState)("hidden"),
	      _useState32 = _slicedToArray(_useState31, 2),
	      visibleAlma = _useState32[0],
	      setVisibleAlma = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(0),
	      _useState34 = _slicedToArray(_useState33, 2),
	      idProd = _useState34[0],
	      setIdPro = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(0),
	      _useState36 = _slicedToArray(_useState35, 2),
	      desde = _useState36[0],
	      setDesde = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(),
	      _useState38 = _slicedToArray(_useState37, 2),
	      regDet = _useState38[0],
	      setRegDet = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(false),
	      _useState40 = _slicedToArray(_useState39, 2),
	      mostrar = _useState40[0],
	      setMostrar = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(false),
	      _useState42 = _slicedToArray(_useState41, 2),
	      activate = _useState42[0],
	      setActivate = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(),
	      _useState44 = _slicedToArray(_useState43, 2),
	      operacionOper = _useState44[0],
	      setOperacionOper = _useState44[1];
	
	  var _useState45 = (0, _react.useState)([]),
	      _useState46 = _slicedToArray(_useState45, 2),
	      records = _useState46[0],
	      setRecords = _useState46[1];
	
	  var _useState47 = (0, _react.useState)([]),
	      _useState48 = _slicedToArray(_useState47, 2),
	      combomoneda = _useState48[0],
	      setComboMoneda = _useState48[1];
	
	  var _useState49 = (0, _react.useState)({
	    idmoneda: "1",
	    descripcion: "BOLIVARES",
	    simbolo: "Bs",
	    predeterminada: true,
	    subpredeterminada: false,
	    valormoneda: 1.0
	  }),
	      _useState50 = _slicedToArray(_useState49, 2),
	      moneda = _useState50[0],
	      setMoneda = _useState50[1];
	
	  var _useState51 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 0.0
	  }),
	      _useState52 = _slicedToArray(_useState51, 2),
	      monedaSub = _useState52[0],
	      setMonedaSub = _useState52[1];
	
	  var _useState53 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState54 = _slicedToArray(_useState53, 2),
	      monedaCambio = _useState54[0],
	      setMonedaCambio = _useState54[1];
	
	  var _useState55 = (0, _react.useState)([]),
	      _useState56 = _slicedToArray(_useState55, 2),
	      tipoIngreso = _useState56[0],
	      setTipoIngreso = _useState56[1];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, {
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead;
	
	  var seleccionarMonedas = function seleccionarMonedas() {
	    var campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	    var nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	    var orden = "m.idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var x = 0;
	        if (response.data.length > 0) {
	          setComboMoneda(response.data);
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].subpredeterminada) {
	              setMonedaSub(response.data[i]);
	              setMonedaCambio({
	                idmoneda: response.data[i].idmoneda,
	                descripcion: response.data[i].descripcion,
	                simbolo: response.data[i].simbolo,
	                predeterminada: response.data[i].predeterminada,
	                subpredeterminada: response.data[i].subpredeterminada,
	                valormoneda: 1.0
	              });
	              x = i;
	            } else if (response.data[i].predeterminada) {
	              setMoneda(response.data[i]);
	            }
	          }
	        }
	        setTimeout(function () {
	          return cmbMoneda.current.selectedIndex = x;
	        }, 200);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = "*";
	    var nomtab = "operacioninventario";
	    var nomid = "idoperacioninventario";
	    var id = txtIdOpeInv.current.value;
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtIdOpeInv.current.setAttribute("disabled", true);
	          setHabilitarCat(true);
	          txtFecha.current.value = (0, _moment2.default)(response.data.fecha).format("YYYY-MM-DD");
	          txtObservacion.current.value = response.data.observacion.trim();
	          if (response.data.tipooperacion === "INGRESO") {
	            cmbTipoOperacion.current.value = "1";
	          } else if (response.data.tipooperacion === "SALIDA") {
	            cmbTipoOperacion.current.value = "2";
	          } else if (response.data.tipooperacion === "TRASLADO") {
	            cmbTipoOperacion.current.value = "3";
	          }
	
	          llenarTipoIngreso(parseInt(cmbTipoOperacion.current.value));
	
	          seleccionarAlmacen(response.data.idalmacenorigen, 1);
	          txtCodAlmaOrigen.current.value = response.data.idalmacenorigen;
	          if (response.data.idalmacendestino === null) {
	            setVisibleAlma("hidden");
	            //txtCodAlmaDestino.current.value = "";
	          } else {
	            setVisibleAlma("visible");
	            txtCodAlmaDestino.current.value = response.data.idalmacendestino;
	            seleccionarAlmacen(response.data.idalmacendestino, 2);
	          }
	          // seleccionarMoneda(response.data.idmoneda);
	          seleccionarDetalle();
	          for (var i = 0; i < combomoneda.length; i++) {
	            if (response.data.idmoneda === combomoneda[i].idmoneda) {
	              cmbMoneda.current.selectedIndex = i;
	              break;
	            }
	          }
	          if (operacion === 2) {
	            setHabilitado(true);
	            setHabilitarMoneda(true);
	            setTimeout(function () {
	              return txtFecha.current.focus();
	            }, 200);
	          } else {
	            setTimeout(function () {
	              return btnCancelar.current.focus();
	            }, 200);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "ID no existe.",
	            icono: "informacion"
	          });
	          txtIdOpeInv.current.value = "";
	          txtIdOpeInv.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarDetalle = function seleccionarDetalle() {
	    var nomtab = "operacioninventariodetalle";
	    var nomid = "idoperacioninventario";
	    var id = txtIdOpeInv.current.value;
	    var endpoint = op.conexion + "/api/inventario/selectdetalleopeinv?nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var prod = [];
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].idalmacen === txtCodAlmaOrigen.current.value) {
	              var cantie = response.data[i].cantidade;
	
	              if (response.data[i].tipounidad === 0) {
	                if (response.data[i].tipofactor === "1") {
	                  cantie = parseFloat(response.data[i].cantidade / response.data[i].valorfactor);
	                  cantie = Math.trunc(cantie);
	                }
	              } else {
	                if (response.data[i].tipofactor === "0") {
	                  cantie = parseFloat(response.data[i].cantidade / response.data[i].valorfactor);
	                  cantie = Math.trunc(cantie);
	                }
	              }
	
	              prod.push({
	                idproducto: response.data[i].idproducto,
	                codigo: response.data[i].codigo,
	                nombre: response.data[i].nombre,
	                cantidad: response.data[i].cantidad < 0 ? response.data[i].cantidad * -1 : response.data[i].cantidad,
	                precio: response.data[i].precio,
	                fechavencimiento: response.data[i].fechavencimiento === null ? "" : response.data[i].fechavencimiento,
	                tipomovimiento: response.data[i].tipomovimiento,
	                fechatipomovimiento: response.data[i].fechatipomovimiento === null ? "" : response.data[i].fechatipomovimiento,
	                numfactura: response.data[i].numfactura,
	                tipounidad: response.data[i].tipounidad,
	                idmoneda: response.data[i].idmoneda,
	                idunidadmedida: response.data[i].idunidadmedida,
	                idunidadalterna: response.data[i].idunidadalterna,
	                descripcionuni: response.data[i].descripcionuni,
	                descripcionunialt: response.data[i].descripcionunialt,
	                preciomaxi: response.data[i].preciomaxi,
	                precioofe: response.data[i].precioofe,
	                preciomayor: response.data[i].preciomayor,
	                preciomini: response.data[i].preciomini,
	                preciomaxialter: response.data[i].preciomaxialter,
	                precioofealter: response.data[i].precioofealter,
	                preciomayoralter: response.data[i].preciomayoralter,
	                preciominialter: response.data[i].preciominialter,
	                tipofactor: response.data[i].tipofactor,
	                valorfactor: response.data[i].valorfactor,
	                valormoneda: response.data[i].valormoneda
	              });
	            }
	          }
	          setRecords(prod);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarAlmacen = function seleccionarAlmacen(cod, llamado) {
	    var campos = "*";
	    var nomtab = "almacen";
	    var nomid = "idalmacen";
	    var id = cod;
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          if (llamado === 1) {
	            txtDescripAlmaOrigen.current.value = response.data.descripcion.trim();
	            if (cmbTipoOperacion.current.value === "3") {
	              txtCodAlmaDestino.current.focus();
	            } else {
	              btnAceptar.current.focus();
	            }
	          } else {
	            txtDescripAlmaDestino.current.value = response.data.descripcion.trim();
	          }
	        } else {
	          if (llamado === 1) {
	            txtCodAlmaOrigen.current.value = "";
	            txtCodAlmaOrigen.current.focus();
	          } else {
	            txtCodAlmaDestino.current.value = "";
	            txtCodAlmaDestino.current.focus();
	          }
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Almacen no esxite",
	            icono: "informacion"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      if (llamado === 1) {
	        txtCodAlmaOrigen.current.value = "";
	        txtCodAlmaOrigen.current.focus();
	      } else {
	        txtCodAlmaDestino.current.value = "";
	        txtCodAlmaDestino.current.focus();
	      }
	    });
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/inventario/actualizaropeinv/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idopeinv + " creado correctamente",
	            icono: "exito"
	          });
	          window.open(op.reportes + ("/almacen?afiliado=" + organizacion + "&reporte=ReporteDetaOpeInventario&codigo=" + response.data.idopeinv), "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	        } else if (operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idopeinv + " modificado correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idopeinv + " eliminado correctamente",
	            icono: "exito"
	          });
	        }
	        blanquear();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = "";
	      if (error.response === undefined) {
	        mensaje = "Error de Conexion";
	      } else {
	        mensaje = error.response.data.message;
	      }
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var gestionOper = function gestionOper(op, id, index) {
	    return function (e) {
	      e.preventDefault();
	      setOperacionOper(op);
	      if (op === 1) {
	        if (txtCodAlmaOrigen.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe seleccionar el almacen",
	            icono: "informacion"
	          });
	          txtCodAlmaOrigen.current.focus();
	          return;
	        }
	        setMostrar(true);
	      } else if (op === 2) {
	        setRegDet(records[index]);
	        setMostrar(true);
	      } else if (op === 3) {
	        setIdPro(id);
	        setDesde(1);
	        setMensajesino({
	          mostrar: true,
	          titulo: "Confirmación.",
	          texto: "Esta seguro de eliminar el registro?",
	          icono: "confirmacion"
	        });
	      }
	    };
	  };
	
	  var closeGestionOper = function closeGestionOper(op) {
	    setMostrar(false);
	  };
	
	  var closeAceptarGestionOper = function closeAceptarGestionOper(datos) {
	    var prod = [];
	
	    for (var i = 0; i < records.length; i++) {
	      prod.push({
	        idproducto: records[i].idproducto,
	        codigo: records[i].codigo,
	        nombre: records[i].nombre,
	        cantidad: records[i].cantidad,
	        precio: records[i].precio,
	        fechavencimiento: records[i].fechavencimiento,
	        tipomovimiento: records[i].tipomovimiento,
	        fechatipomovimiento: records[i].fechatipomovimiento,
	        numfactura: records[i].numfactura,
	        tipounidad: records[i].tipounidad,
	        idmoneda: records[i].idmoneda,
	        idunidadmedida: records[i].idunidadmedida,
	        idunidadalterna: records[i].idunidadalterna,
	        descripcionuni: records[i].descripcionuni,
	        descripcionunialt: records[i].descripcionunialt,
	        tipofactor: records[i].tipofactor,
	        valorfactor: records[i].valorfactor,
	        valormoneda: records[i].valormoneda
	      });
	    }
	    prod.push({
	      idproducto: datos[0].idproducto,
	      codigo: datos[0].codigo,
	      nombre: datos[0].nombre,
	      cantidad: datos[0].cantidad,
	      precio: datos[0].precio,
	      fechavencimiento: datos[0].fechavencimiento,
	      tipomovimiento: datos[0].tipomovimiento,
	      fechatipomovimiento: datos[0].fechatipomovimiento,
	      numfactura: datos[0].numfactura,
	      idmoneda: datos[0].idmoneda,
	      tipounidad: datos[0].tipounidad,
	      idunidadmedida: datos[0].idunidadmedida,
	      idunidadalterna: datos[0].idunidadalterna,
	      descripcionuni: datos[0].descripcionuni,
	      descripcionunialt: datos[0].descripcionunialt,
	      tipofactor: datos[0].tipofactor,
	      valorfactor: datos[0].valorfactor,
	      valormoneda: datos[0].valormoneda
	    });
	    setMostrar(false);
	    setRecords(prod);
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    if (desde === 1) {
	      var prod = records;
	      var prod = prod.filter(function (prod) {
	        return prod.idproducto !== idProd;
	      });
	      setDesde(0);
	      setRecords(prod);
	    } else if (desde === 2) {
	      setDesde(0);
	      procesarRegistro();
	    }
	    /*  getExpendedor(); */
	  };
	
	  var handleInputNumeroChange = function handleInputNumeroChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.target.name === "codalmaorigen") {
	      txtDescripAlmaOrigen.current.value = "";
	      setRecords([]);
	    } else if (event.target.name === "codalmadestino") {
	      txtDescripAlmaDestino.current.value = "";
	    }
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "idopeinv") {
	          seleccionarRegistro();
	        } else if (event.target.name === "codalmaorigen") {
	          seleccionarAlmacen(event.target.value, 1);
	        } else if (event.target.name === "codalmadestino") {
	          seleccionarAlmacen(event.target.value, 2);
	        }
	      }
	    }
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    event.preventDefault();
	    if (event.which === 13) {
	      if (event.target.name === "fechaope") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	        cmbTipoOperacion.current.focus();
	      } else if (event.target.name === "codalmaorigen") {} else if (event.target.name === "codalmadestino") {}
	    } else if (typeof event.which === "undefined") {
	      if (event.target.name === "fechaope") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (accbtnopinventario && accbtnopinventario.toString().substring(0, 1) === "1") {
	          setTituloHeader("Incluir Operacion de Inventario.");
	          setVisibleBtn("hidden");
	          setHabilitadoBot(false);
	          setOperacion(op);
	          setHabilitadoM(true);
	          setHabilitado(true);
	          setHabilitarMoneda(true);
	          txtIdOpeInv.current.value = "0";
	          txtIdOpeInv.current.setAttribute("disabled", true);
	          setHabilitarCat(true);
	          txtFecha.current.value = fechaSistema;
	          cmbTipoOperacion.current.selectedIndex = 0;
	          llenarTipoIngreso(1);
	          setTimeout(function () {
	            return txtFecha.current.focus();
	          }, 200);
	        } else {
	          setHabilitadoBot(true);
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (accbtnopinventario && accbtnopinventario.toString().substring(1, 2) === "1") {
	          setVisibleBtn("hidden");
	          setTituloHeader("Editar Operacion de Inventario.");
	          setOperacion(op);
	          setHabilitadoBot(false);
	          txtIdOpeInv.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitadoM(false);
	          setHabilitado(false);
	          txtIdOpeInv.current.focus();
	        } else {
	          setHabilitadoBot(true);
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (accbtnopinventario && accbtnopinventario.toString().substring(3, 4) === "1") {
	          setTituloHeader("Eliminar Operacion de Inventario.");
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          setHabilitadoBot(false);
	          txtIdOpeInv.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitarMoneda(false);
	          setHabilitadoM(false);
	          setHabilitado(false);
	          txtIdOpeInv.current.focus();
	        } else {
	          setHabilitadoBot(true);
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (accbtnopinventario && accbtnopinventario.toString().substring(2, 3) === "1") {
	          setTituloHeader("Consultar Operacion de Inventario.");
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          setHabilitadoM(false);
	          setHabilitado(false);
	          setHabilitarMoneda(true);
	          setHabilitadoBot(false);
	          txtIdOpeInv.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          txtIdOpeInv.current.focus();
	        } else {
	          setHabilitadoBot(true);
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 5) {
	        if (operacion !== 4) {
	          onChangeValidar();
	        }
	      } else if (op === 6) {
	        setVisibleBtn("visible");
	        blanquear();
	      } else if (op === 7) {
	        //setCatalogoProducto(true);
	      }
	    };
	  };
	
	  var blanquear = function blanquear() {
	    setTituloHeader("Gestionar Operaciones de Inventario.");
	
	    setActivate(false);
	    setBody(null);
	    setHabilitado(false);
	    setHabilitadoM(false);
	    setHabilitadoBot(true);
	    setHabilitarMoneda(false);
	    txtIdOpeInv.current.setAttribute("disabled", true);
	    setHabilitarCat(true);
	
	    //btnBuscar.current.setAttribute("disabled", true);
	    txtIdOpeInv.current.value = "";
	    txtFecha.current.value = "";
	    txtObservacion.current.value = "";
	    txtCodAlmaOrigen.current.value = "";
	    txtDescripAlmaOrigen.current.value = "";
	    if (cmbTipoOperacion.current.value === "3") {
	      txtCodAlmaDestino.current.value = "";
	      txtDescripAlmaDestino.current.value = "";
	    }
	    cmbTipoOperacion.current.selectedIndex = -1;
	    setMoneda({
	      idmoneda: "1",
	      descripcion: "BOLIVARES",
	      simbolo: "Bs",
	      predeterminada: false,
	      valormoneda: 1.0
	    });
	    setMonedaCambio({
	      idmoneda: "4",
	      descripcion: "DOLAR",
	      simbolo: "$",
	      predeterminada: false,
	      subpredeterminada: true,
	      valormoneda: 1.0
	    });
	    for (var i = 0; i < combomoneda.length; i++) {
	      if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
	        cmbMoneda.current.selectedIndex = i;
	      }
	    }
	    setVisibleAlma("hidden");
	    setRecords([]);
	    setVisibleBtn("visible");
	  };
	
	  var llenarTipoIngreso = function llenarTipoIngreso(tipoing) {
	    var tipo = [];
	    if (tipoing === 1) {
	      setVisibleAlma("hidden");
	
	      tipo.push({
	        idtipo: "1",
	        descripcion: "INVENTARIO INICIAL"
	      });
	      {
	        accbtnopinventario && accbtnopinventario.toString().substring(8, 9) === "1" ? tipo.push({
	          idtipo: "2",
	          descripcion: "OBSEQUIO/DONACIÓN"
	        }) : '';
	      }
	      {
	        accbtnopinventario && accbtnopinventario.toString().substring(9, 10) === "1" ? tipo.push({
	          idtipo: "3",
	          descripcion: "PRESTAMO"
	        }) : '';
	      }
	      tipo.push({
	        idtipo: "4",
	        descripcion: "RESGUARDO"
	      });
	      tipo.push({
	        idtipo: "6",
	        descripcion: "PRODUCCIÓN"
	      });
	      {
	        accbtnopinventario && accbtnopinventario.toString().substring(10, 11) === "1" ? tipo.push({
	          idtipo: "7",
	          descripcion: "AJUSTE"
	        }) : '';
	      }
	    } else if (tipoing === 2) {
	      tipo.push({
	        idtipo: "2",
	        descripcion: "VENCIMIENTO"
	      });
	      tipo.push({
	        idtipo: "3",
	        descripcion: "DEVOLUCION"
	      });
	      {
	        accbtnopinventario && accbtnopinventario.toString().substring(9, 10) === "1" ? tipo.push({
	          idtipo: "4",
	          descripcion: "PRESTAMO"
	        }) : '';
	      }
	      {
	        accbtnopinventario && accbtnopinventario.toString().substring(8, 9) === "1" ? tipo.push({
	          idtipo: "5",
	          descripcion: "DONACIÓN"
	        }) : '';
	      }
	      {
	        accbtnopinventario && accbtnopinventario.toString().substring(10, 11) === "1" ? tipo.push({
	          idtipo: "6",
	          descripcion: "AJUSTE"
	        }) : '';
	      }
	      setVisibleAlma("hidden");
	    } else if (tipoing === 3) {
	      tipo.push({
	        idtipo: "1",
	        descripcion: "TRASLADO"
	      });
	      setVisibleAlma("visible");
	    }
	    setTipoIngreso(tipo);
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "tipoopeinv") {
	      if (e.target.value === "3") {
	        setVisibleAlma("visible");
	      } else {
	        setVisibleAlma("hidden");
	      }
	      llenarTipoIngreso(parseInt(e.target.value));
	    } else if (e.target.name === "fechaope") {}
	  };
	
	  var onCatalogoOperacionInv = function onCatalogoOperacionInv(values) {
	    setCatalogoOpeInv(false);
	    txtIdOpeInv.current.value = values.idoperacioninventario;
	    seleccionarRegistro();
	  };
	
	  var onChangeMoneda = function onChangeMoneda(e) {
	    var i = e.target.value;
	    var cambio = (0, _varios.onCambioMoneda)({
	      moneda: combomoneda[i],
	      productos: records,
	      monedaPre: moneda,
	      monedaSub: monedaSub
	    });
	    setMonedaCambio(cambio.monedacambio);
	  };
	
	  var onCatalogoAlmacen = function onCatalogoAlmacen(values) {
	    setCatalogoAlmacen(false);
	    if (cualCat === 1) {
	      txtCodAlmaOrigen.current.value = values.idalmacen;
	      //txtDescripUbiOrigen.current.value = values.descripcion.trim() + ' Almacen: ' + response.data[0].descripcion.trim();
	    } else {
	      txtCodAlmaDestino.current.value = values.idalmacen;
	      //txtDescripUbiDestino.current.value = values.descripcion;
	    }
	    seleccionarAlmacen(values.idalmacen, cualCat);
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	
	    if (txtIdOpeInv.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Código no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtIdOpeInv.current.focus();
	    } else if (txtFecha.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtFecha.current.focus();
	    } else if (txtObservacion.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Observación no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtObservacion.current.focus();
	    } else if (txtCodAlmaOrigen.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Código del Almacen no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtCodAlmaOrigen.current.focus();
	    } else if (cmbTipoOperacion.current.value === "3" && txtCodAlmaDestino.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Código del Almacen Destino no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtCodAlmaDestino.current.focus();
	    } else if (cmbTipoOperacion.current.value === "3" && txtCodAlmaOrigen.current.value.trim() === txtCodAlmaDestino.current.value.trim()) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Código del Almacen Oriregen y Destino no deben ser iguales",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtCodAlmaDestino.current.focus();
	    } else if (records.length === 0) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "No hay Producto agregados",
	        icono: "informacion"
	      });
	      sigue = false;
	      btnCancelar.current.focus();
	    }
	
	    if (sigue) {
	      var opeinv = [];
	      var opeinvdet = [];
	
	      opeinv.push({
	        idoperacioninventario: txtIdOpeInv.current.value,
	        tipooperacion: cmbTipoOperacion.current[cmbTipoOperacion.current.selectedIndex].text,
	        idalmacenorigen: txtCodAlmaOrigen.current.value,
	        idalmacendestino: cmbTipoOperacion.current.value === "3" ? txtCodAlmaDestino.current.value : "",
	        fecha: txtFecha.current.value,
	        idmoneda: monedaSub.idmoneda,
	        observacion: txtObservacion.current.value
	      });
	
	      for (var i = 0; i < records.length; i++) {
	        opeinvdet.push({
	          idproducto: records[i].idproducto,
	          nombre: records[i].nombre,
	          cantidad: records[i].cantidad,
	          precio: records[i].precio,
	          fechavencimiento: records[i].fechavencimiento,
	          tipomovimiento: records[i].tipomovimiento,
	          fechatipomovimiento: records[i].fechatipomovimiento,
	          numfactura: records[i].numfactura,
	          idalmacen: txtCodAlmaOrigen.current.value,
	          tipounidad: records[i].tipounidad,
	          idunidadmedida: records[i].idunidadmedida,
	          idunidadalterna: records[i].idunidadalterna,
	          tipofactor: records[i].tipofactor,
	          valorfactor: records[i].valorfactor,
	          tasa: monedaSub.valormoneda,
	          preciobs: (0, _varios.round)(records[i].precio * monedaSub.valormoneda)
	        });
	      }
	
	      setBody({
	        idtipopeinv: cmbTipoOperacion.current.value,
	        opeinv: opeinv,
	        opeinvdet: opeinvdet
	      });
	      setDesde(2);
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var imprimirReporte = function imprimirReporte() {
	    if (txtIdOpeInv.current.value !== "") {
	      window.open(op.reportes + "/almacen?afiliado=" + organizacion + "&reporte=ReporteDetaOpeInventario&codigo=" + txtIdOpeInv.current.value, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarMonedas();
	    if (cmbTipoOperacion) {
	      cmbTipoOperacion.current.selectedIndex = -1;
	    }
	  }, []);
	
	  var onDescargarFormato = function onDescargarFormato(e) {
	    e.preventDefault();
	    getDescargar();
	  };
	
	  var getDescargar = function getDescargar() {
	    setActivate(true);
	    var nomformat = 'formatoproductoinventario.xlsx';
	    var endpoint = op.conexion + "/imagen?img=" + nomformat.trim();
	    _axios2.default.get(endpoint, {
	      responseType: "arraybuffer",
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      var url = window.URL.createObjectURL(new Blob([response.data]));
	      var link = document.createElement("a");
	      link.href = url;
	      link.setAttribute("download", "" + nomformat.trim());
	      document.body.appendChild(link);
	      link.click();
	      document.body.removeChild(link);
	    }).catch(function (error) {
	      console.error(error);
	    }).finally(function () {
	      return setActivate(false);
	    });
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 py-5 px-5", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 px-5", style: { margin: 0 } },
	        _react2.default.createElement(_incluirProducto.IncluirProducOper, {
	          show: mostrar,
	          onHideCancela: closeGestionOper,
	          onHideAcepta: closeAceptarGestionOper,
	          operacion: operacionOper,
	          idalmacen: txtCodAlmaOrigen.current ? txtCodAlmaOrigen.current.value : "",
	          tipoingreso: tipoIngreso,
	          tipo: cmbTipoOperacion.current ? parseInt(cmbTipoOperacion.current.value) : "",
	          productos: records,
	          registro: regDet,
	          moneda: moneda
	        }),
	        _react2.default.createElement(_mensajes.Mensaje, {
	          mensaje: mensaje,
	          onHide: function onHide() {
	            mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({
	              mostrar: false,
	              titulo: "",
	              texto: "",
	              icono: ""
	            });
	          }
	        }),
	        _react2.default.createElement(_mensajes.MensajeSiNo, {
	          mensaje: mensajesino,
	          onHideNo: function onHideNo() {
	            return setMensajesino({
	              mostrar: false,
	              titulo: "",
	              texto: "",
	              icono: ""
	            });
	          },
	          onHideSi: handleCloseSi
	        }),
	        _react2.default.createElement(
	          _semanticUiReact.Dimmer,
	          { active: activate, inverted: true },
	          _react2.default.createElement(
	            _semanticUiReact.Loader,
	            { inverted: true },
	            "cargando..."
	          )
	        ),
	        _react2.default.createElement(_catalogoAlmacen2.default, {
	          show: catalogoAlmacen,
	          onHideCancelar: function onHideCancelar() {
	            return setCatalogoAlmacen(false);
	          },
	          onHideAceptaCatalogo: onCatalogoAlmacen
	        }),
	        _react2.default.createElement(_catalogoOperacionInventario2.default, {
	          show: catalogoOpeInv,
	          onHideCancelar: function onHideCancelar() {
	            return setCatalogoOpeInv(false);
	          },
	          onHideAceptaCatalogo: onCatalogoOperacionInv
	        }),
	        _react2.default.createElement(_modalOpeinveProductExcel.OperacionInvPorExcel, {
	          show: mostrarActualizar,
	          idmoney: monedaSub.idmoneda,
	          valormo: monedaSub.valormoneda,
	          onHide: function onHide() {
	            setMostrarActualizar(false);
	          }
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "py-3" },
	          _react2.default.createElement(
	            "div",
	            { className: "p-0 col-md-11 mx-auto shadow row m-0 border-azul border-4" },
	            _react2.default.createElement(
	              "ul",
	              { className: "nav mb-1", id: "ex-with-icons", role: "tablist" },
	              _react2.default.createElement(
	                "li",
	                { className: "nav-item py-1 px-2" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-sm btn-success rounded-pill",
	                    onClick: function onClick() {
	                      return setMostrarActualizar(true);
	                    }
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-edit" },
	                    " Operaci\xF3n Inventario por Excel"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                { className: "nav-item py-1 px-2" },
	                _react2.default.createElement("i", { className: "fas fa-long-arrow-alt-right fs-2" })
	              ),
	              _react2.default.createElement(
	                "li",
	                { className: "nav-item py-1 px-2" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-sm rounded-pill",
	                    style: { background: '#008B8B', color: '#FFFF' },
	                    onClick: onDescargarFormato
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-file-excel" },
	                    " Formato"
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "p-3 col-md-11 mx-auto card shadow row m-0" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light justify-content-between" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-4" },
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  tituloHeader
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 d-flex justify-content-end" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "/inicio", className: "text-light " },
	                  _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "fw-bold" },
	                    "Salir"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 row mx-auto row m-0",
	                style: { fontSizeAdjust: "0,6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group mb-3 col-pd-280" },
	                _react2.default.createElement(
	                  "span",
	                  {
	                    className: "input-group-text fw-bold",
	                    id: "inputGroup-sizing-default"
	                  },
	                  "CODIGO:"
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  className: "form-control fs-5 h-100",
	                  autoComplete: "off",
	                  disabled: true,
	                  ref: txtIdOpeInv,
	                  name: "idopeinv",
	                  onKeyUp: handleInputNumeroChange,
	                  onBlur: handleInputNumeroChange,
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-default"
	                }),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: habilitarCat,
	                    type: "button",
	                    onClick: function onClick() {
	                      return setCatalogoOpeInv(true);
	                    },
	                    className: "btn btn-success"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-search" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: { marginLeft: "auto" },
	                  className: "input-group mb-3 col-pd-350"
	                },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text fw-bold",
	                    id: "inputGroup-sizing-default"
	                  },
	                  "TIPO MONEDA:"
	                ),
	                _react2.default.createElement(
	                  "select",
	                  {
	                    className: "form-select fw-bold text-center",
	                    disabled: !habilitarMoneda,
	                    ref: cmbMoneda,
	                    onChange: onChangeMoneda,
	                    "aria-label": "Default select example"
	                  },
	                  combomoneda && combomoneda.map(function (item, index) {
	                    return _react2.default.createElement(
	                      "option",
	                      { key: index, value: index },
	                      " ",
	                      item.descripcion + " " + item.simbolo + " " + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                      " "
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "border-azul py-3 rounded row rounded mx-auto tipo-letra" },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "input-group mb-2 col-pd-360",
	                  style: { fontSizeAdjust: "0,6" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text",
	                    id: "inputGroup-sizing-default"
	                  },
	                  "FECHA DE INGRESO:"
	                ),
	                _react2.default.createElement("input", {
	                  type: "date",
	                  disabled: !habilitado,
	                  ref: txtFecha,
	                  max: (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD"),
	                  name: "fechaope",
	                  onKeyUp: handleInputChange,
	                  onBlur: handleInputChange,
	                  className: "form-control fs-5 text-uppercase h-100",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-default"
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "input-group mb-2 col-pd-340",
	                  style: { fontSizeAdjust: "0,6", marginLeft: "auto" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text",
	                    id: "inputGroup-sizing-default"
	                  },
	                  "TIPO DE OPERACION:"
	                ),
	                _react2.default.createElement(
	                  "select",
	                  {
	                    disabled: !habilitadoM,
	                    ref: cmbTipoOperacion,
	                    className: "form-select",
	                    "aria-label": "Default select example",
	                    name: "tipoopeinv",
	                    onChange: onChange
	                  },
	                  accbtnopinventario && accbtnopinventario.toString().substring(5, 6) === "1" ? _react2.default.createElement(
	                    "option",
	                    { value: "1" },
	                    "INGRESO"
	                  ) : '',
	                  accbtnopinventario && accbtnopinventario.toString().substring(6, 7) === "1" ? _react2.default.createElement(
	                    "option",
	                    { value: "2" },
	                    "SALIDA"
	                  ) : '',
	                  accbtnopinventario && accbtnopinventario.toString().substring(7, 8) === "1" ? _react2.default.createElement(
	                    "option",
	                    { value: "3" },
	                    "TRASLADO"
	                  ) : ''
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "input-group mb-2 col-xl-12 col-lg-12 col-md-12 col-sm-12 mx-auto",
	                  style: { fontSizeAdjust: "0,6" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text",
	                    id: "inputGroup-sizing-default"
	                  },
	                  "OBSERVACION:"
	                ),
	                _react2.default.createElement("textarea", {
	                  type: "area",
	                  disabled: !habilitado,
	                  maxLength: "500",
	                  style: {
	                    height: 80
	                  },
	                  autoComplete: "off",
	                  ref: txtObservacion,
	                  className: "form-control text-uppercase fs-5",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-default"
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12", style: { fontSizeAdjust: "0,6" } },
	                _react2.default.createElement(
	                  "fieldset",
	                  { className: " row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between" },
	                  _react2.default.createElement(
	                    "legend",
	                    { className: "float-none w-auto fw-bold" },
	                    "ALMAC\xC9N ",
	                    visibleAlma !== "hidden" && "ORIGEN"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group mb-2 col-md-12" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group mb-1 col-xl-3 col-lg-4 col-md-5 col-sm-6" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-default"
	                        },
	                        "CODIGO:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        disabled: !habilitadoM,
	                        ref: txtCodAlmaOrigen,
	                        autoComplete: "off",
	                        className: "form-control fs-5 text-uppercase h-100",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-default",
	                        name: "codalmaorigen",
	                        onKeyUp: handleInputNumeroChange,
	                        onBlur: handleInputNumeroChange
	                      }),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          disabled: !habilitado,
	                          onClick: function onClick() {
	                            setCualCat(1);
	                            setCatalogoAlmacen(true);
	                          },
	                          className: "btn btn-success"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-search" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group mb-1 col-xl-9 col-lg-12 col-md-12 col-sm-12" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-default"
	                        },
	                        "DESCRIPCION:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        disabled: true,
	                        ref: txtDescripAlmaOrigen,
	                        className: "form-control fs-5 text-uppercase h-100",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-default"
	                      })
	                    )
	                  )
	                )
	              ),
	              visibleAlma !== "hidden" && _react2.default.createElement(
	                "div",
	                { className: "col-md-12", style: { fontSizeAdjust: "0,6" } },
	                _react2.default.createElement(
	                  "fieldset",
	                  { className: " row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between" },
	                  _react2.default.createElement(
	                    "legend",
	                    { className: "float-none w-auto fw-bold" },
	                    "ALMAC\xC9N DESTINO"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group mb-2 col-md-12" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group mb-1 col-xl-3 col-lg-4 col-md-5 col-sm-6" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-default"
	                        },
	                        "CODIGO:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        disabled: !habilitadoM,
	                        ref: txtCodAlmaDestino,
	                        className: "form-control fs-6",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-default",
	                        name: "codalmadestino",
	                        onKeyUp: handleInputNumeroChange,
	                        onBlur: handleInputNumeroChange
	                      }),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          disabled: !habilitado,
	                          onClick: function onClick() {
	                            setCualCat(2);
	                            setCatalogoAlmacen(true);
	                          },
	                          className: "btn btn-success"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-search" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group mb-1 col-xl-9 col-lg-12 col-md-12 col-sm-12" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-default"
	                        },
	                        "DESCRIPCION:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        disabled: true,
	                        ref: txtDescripAlmaDestino,
	                        className: "form-control fs-6 text-uppercase",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-default"
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-12 p-2" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row col-12 d-flex justify-content-end" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-3 d-flex justify-content-end" },
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          disabled: !habilitado,
	                          onClick: gestionOper(1, 0, 0),
	                          className: "btn btn-sm mx-1 btn-primary rounded-pill",
	                          title: "Incluir Producto"
	                        },
	                        _react2.default.createElement(
	                          "i",
	                          { className: "fas fa-plus" },
	                          " Incluir Producto"
	                        ),
	                        " "
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12", style: { margin: "auto" } },
	                  _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                      _core.TableBody,
	                      null,
	                      records && records.map(function (item, index) {
	                        return _react2.default.createElement(
	                          _core.TableRow,
	                          {
	                            key: item.idproducto,
	                            style: { padding: "0", fontSizeAdjust: "0.6" }
	                          },
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            {
	                              className: "align-middle bg-light text-center p-0",
	                              style: { width: "40px" }
	                            },
	                            item.codigo,
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            {
	                              className: "align-middle bg-light text-start p-0 pl-2",
	                              style: { width: "50px" }
	                            },
	                            item.nombre,
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            {
	                              className: "align-middle bg-light text-end p-0 pr-2",
	                              style: { width: "30px" }
	                            },
	                            (0, _varios.formatMoneda)(item.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            {
	                              className: "align-middle bg-light text-end p-0 pr-2",
	                              style: { width: "50px" }
	                            },
	                            (0, _varios.formatMoneda)((item.precio * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            {
	                              className: "align-middle bg-light text-center p-0",
	                              style: { width: 50 }
	                            },
	                            item.tipounidad === 0 ? item.descripcionuni : item.descripcionunialt
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            {
	                              className: "align-middle bg-light text-center p-0",
	                              style: { width: "50px" }
	                            },
	                            item.fechavencimiento === "" ? "" : (0, _moment2.default)(item.fechavencimiento).format("DD/MM/YYYY"),
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            {
	                              className: "align-middle bg-light text-center p-0",
	                              style: { width: "50px" }
	                            },
	                            item.tipomovimiento,
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            {
	                              className: "align-middle bg-light text-center p-0",
	                              style: { width: "50px" }
	                            },
	                            item.fechatipomovimiento === "" ? "" : (0, _moment2.default)(item.fechatipomovimiento).format("DD/MM/YYYY"),
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            {
	                              className: "align-middle bg-light text-center p-0",
	                              style: { width: "50px" }
	                            },
	                            item.numfactura,
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            {
	                              className: "align-middle bg-light text-center p-0",
	                              style: { width: "20px" }
	                            },
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                disabled: !habilitado,
	                                style: {
	                                  visibility: (operacion === 4 || operacion === 3) && "collapse"
	                                },
	                                onClick: gestionOper(3, item.idproducto, index),
	                                className: "btn btn-sm btn-danger"
	                              },
	                              _react2.default.createElement("i", { className: "fa fa-trash" }),
	                              " "
	                            )
	                          )
	                        );
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 d-flex justify-content-between mt-2" },
	                visibleBtn === "visible" ? _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 col-sm-12 col-lg-12 col-12  justify-content-start" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnIncluir,
	                      onClick: onBotones(1),
	                      disabled: !habilitadoBot,
	                      className: "btn btn-sm mx-1 btn-primary rounded-pill",
	                      title: "Incluir Operacion de Inventario"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-plus" },
	                      " Incluir "
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnConsultar,
	                      onClick: onBotones(4),
	                      disabled: !habilitadoBot,
	                      className: "btn btn-sm mx-1 btn-info rounded-pill",
	                      title: "Consultar Operacion de Inventario"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-eye" },
	                      "Consultar"
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnEditar,
	                      onClick: onBotones(2),
	                      disabled: !habilitadoBot,
	                      className: "btn btn-sm mx-1 btn-warning rounded-pill",
	                      title: "Modificar Operacion de Inventario"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-edit" },
	                      "Modificar"
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnEliminar,
	                      onClick: onBotones(3),
	                      className: "btn btn-sm mx-1 btn-danger rounded-pill",
	                      title: "Eliminar Operacion de Inventario"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-trash" },
	                      "Eliminar"
	                    ),
	                    " "
	                  )
	                ) : "",
	                visibleBtn === "visible" ? "" : _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 d-flex justify-content-end" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      onClick: imprimirReporte,
	                      disabled: operacion === 4 ? false : true,
	                      className: "btn btn-sm btn-primary rounded-pill",
	                      title: "Imprimir operacion de inventario"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-print" },
	                      " Imprimir"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: habilitadoBot,
	                      onClick: onBotones(5),
	                      ref: btnAceptar,
	                      className: "mx-2 btn btn-sm rounded-pill btn-success",
	                      title: "Aceptar"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-check-circle" },
	                      " Aceptar"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: habilitadoBot,
	                      onClick: onBotones(6),
	                      ref: btnCancelar,
	                      className: "mx-2 btn btn-danger btn-sm rounded-pill",
	                      title: "Cancelar"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-window-close" },
	                      " Cancelar"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	exports.default = TablaOperInventario;

/***/ },
/* 7067 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(19);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _incluirProductoVacio = __webpack_require__(7053);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoAlmacen = __webpack_require__(51);
	
	var _catalogoAlmacen2 = _interopRequireDefault(_catalogoAlmacen);
	
	var _catalogoOperacionInventariovacio = __webpack_require__(7033);
	
	var _catalogoOperacionInventariovacio2 = _interopRequireDefault(_catalogoOperacionInventariovacio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TablaOperInventarioVacio = function TablaOperInventarioVacio() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var organizacion = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var btnopvacios = JSON.parse(sessionStorage.getItem("btnopvaciosc"));
	  var fechaSistema = (0, _moment2.default)(JSON.parse(sessionStorage.getItem("fechasistema"))).format("YYYY-MM-DD");
	
	  var headCells = [{ label: "COD.", textAlign: "center", width: "40px" }, { label: "DESCRIPCION", textAlign: "center", width: "50px" }, { label: "CANTIDAD", textAlign: "center", width: "30px" }, { label: "TIPO MOVIMIENTO", textAlign: "center", width: "50px" }, { label: "FECHA", textAlign: "center", width: "50px" }, { label: "N° FACTURA", textAlign: "center", width: "50px" }, {
	    label: _react2.default.createElement("i", { className: "fas fa-trash" }),
	    textAlign: "center",
	    width: "20px"
	  }];
	
	  var btnIncluir = (0, _react.useRef)();
	  var btnEditar = (0, _react.useRef)();
	  var btnEliminar = (0, _react.useRef)();
	  var btnConsultar = (0, _react.useRef)();
	  var btnCancelar = (0, _react.useRef)();
	  var btnAceptar = (0, _react.useRef)();
	
	  var txtIdOpeInv = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtCodAlmaOrigen = (0, _react.useRef)();
	  var txtDescripAlmaOrigen = (0, _react.useRef)();
	  var txtCodAlmaDestino = (0, _react.useRef)();
	  var txtDescripAlmaDestino = (0, _react.useRef)();
	  var txtObservacion = (0, _react.useRef)();
	  var cmbTipoOperacion = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)("visible"),
	      _useState2 = _slicedToArray(_useState, 2),
	      visibleBtn = _useState2[0],
	      setVisibleBtn = _useState2[1];
	
	  var _useState3 = (0, _react.useState)("Gestionar Operaciones de Inventario Vacios."),
	      _useState4 = _slicedToArray(_useState3, 2),
	      tituloHeader = _useState4[0],
	      setTituloHeader = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mensaje = _useState6[0],
	      setMensaje = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mensajesino = _useState8[0],
	      setMensajesino = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(true),
	      _useState10 = _slicedToArray(_useState9, 2),
	      habilitadoBot = _useState10[0],
	      setHabilitadoBot = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(true),
	      _useState12 = _slicedToArray(_useState11, 2),
	      habilitarCat = _useState12[0],
	      setHabilitarCat = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      habilitado = _useState14[0],
	      setHabilitado = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      habilitadoM = _useState16[0],
	      setHabilitadoM = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(1),
	      _useState18 = _slicedToArray(_useState17, 2),
	      operacion = _useState18[0],
	      setOperacion = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(false),
	      _useState20 = _slicedToArray(_useState19, 2),
	      catalogoOpeInv = _useState20[0],
	      setCatalogoOpeInv = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(false),
	      _useState22 = _slicedToArray(_useState21, 2),
	      catalogoAlmacen = _useState22[0],
	      setCatalogoAlmacen = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(1),
	      _useState24 = _slicedToArray(_useState23, 2),
	      cualCat = _useState24[0],
	      setCualCat = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(null),
	      _useState26 = _slicedToArray(_useState25, 2),
	      body = _useState26[0],
	      setBody = _useState26[1];
	
	  var _useState27 = (0, _react.useState)("hidden"),
	      _useState28 = _slicedToArray(_useState27, 2),
	      visibleAlma = _useState28[0],
	      setVisibleAlma = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(0),
	      _useState30 = _slicedToArray(_useState29, 2),
	      idProd = _useState30[0],
	      setIdPro = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(0),
	      _useState32 = _slicedToArray(_useState31, 2),
	      desde = _useState32[0],
	      setDesde = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(),
	      _useState34 = _slicedToArray(_useState33, 2),
	      regDet = _useState34[0],
	      setRegDet = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(false),
	      _useState36 = _slicedToArray(_useState35, 2),
	      mostrar = _useState36[0],
	      setMostrar = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(false),
	      _useState38 = _slicedToArray(_useState37, 2),
	      activate = _useState38[0],
	      setActivate = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(),
	      _useState40 = _slicedToArray(_useState39, 2),
	      operacionOper = _useState40[0],
	      setOperacionOper = _useState40[1];
	
	  var _useState41 = (0, _react.useState)([]),
	      _useState42 = _slicedToArray(_useState41, 2),
	      records = _useState42[0],
	      setRecords = _useState42[1];
	
	  var _useState43 = (0, _react.useState)([]),
	      _useState44 = _slicedToArray(_useState43, 2),
	      tipoIngreso = _useState44[0],
	      setTipoIngreso = _useState44[1];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, {
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead;
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = "*";
	    var nomtab = "operacioninventariovacio";
	    var nomid = "idoperacioninventario";
	    var id = txtIdOpeInv.current.value;
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtIdOpeInv.current.setAttribute("disabled", true);
	          setHabilitarCat(true);
	          txtFecha.current.value = (0, _moment2.default)(response.data.fecha).format("YYYY-MM-DD");
	          txtObservacion.current.value = response.data.observacion.trim();
	          if (response.data.tipooperacion === "INGRESO") {
	            cmbTipoOperacion.current.value = "1";
	          } else if (response.data.tipooperacion === "SALIDA") {
	            cmbTipoOperacion.current.value = "2";
	          } else if (response.data.tipooperacion === "TRASLADO") {
	            cmbTipoOperacion.current.value = "3";
	          }
	
	          llenarTipoIngreso(parseInt(cmbTipoOperacion.current.value));
	
	          seleccionarAlmacen(response.data.idalmacenorigen, 1);
	          txtCodAlmaOrigen.current.value = response.data.idalmacenorigen;
	          if (response.data.idalmacendestino === null) {
	            setVisibleAlma("hidden");
	          } else {
	            setVisibleAlma("visible");
	            txtCodAlmaDestino.current.value = response.data.idalmacendestino;
	            seleccionarAlmacen(response.data.idalmacendestino, 2);
	          }
	          seleccionarDetalle();
	          if (operacion === 2) {
	            setHabilitado(true);
	            setTimeout(function () {
	              return txtFecha.current.focus();
	            }, 200);
	          } else {
	            setTimeout(function () {
	              return btnCancelar.current.focus();
	            }, 200);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "ID no existe.",
	            icono: "informacion"
	          });
	          txtIdOpeInv.current.value = "";
	          txtIdOpeInv.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarDetalle = function seleccionarDetalle() {
	    var nomtab = "operacioninventariovaciodetalle";
	    var nomid = "idoperacioninventario";
	    var id = txtIdOpeInv.current.value;
	    var endpoint = op.conexion + "/api/inventariovacio/selectdetalleopeinv?nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var prod = [];
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].idalmacen === txtCodAlmaOrigen.current.value) {
	              prod.push({
	                idclasevacio: response.data[i].idclasevacio,
	                descripcion: response.data[i].descripcion,
	                cantidad: response.data[i].cantidad < 0 ? response.data[i].cantidad * -1 : response.data[i].cantidad,
	                tipomovimiento: response.data[i].tipomovimiento,
	                fechatipomovimiento: response.data[i].fechatipomovimiento === null ? "" : response.data[i].fechatipomovimiento,
	                numfactura: response.data[i].numfactura
	              });
	            }
	          }
	          setRecords(prod);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarAlmacen = function seleccionarAlmacen(cod, llamado) {
	    var campos = "*";
	    var nomtab = "almacen";
	    var nomid = "idalmacen";
	    var id = cod;
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          if (llamado === 1) {
	            txtDescripAlmaOrigen.current.value = response.data.descripcion.trim();
	            if (cmbTipoOperacion.current.value === "3") {
	              txtCodAlmaDestino.current.focus();
	            } else {
	              btnAceptar.current.focus();
	            }
	          } else {
	            txtDescripAlmaDestino.current.value = response.data.descripcion.trim();
	          }
	        } else {
	          if (llamado === 1) {
	            txtCodAlmaOrigen.current.value = "";
	            txtCodAlmaOrigen.current.focus();
	          } else {
	            txtCodAlmaDestino.current.value = "";
	            txtCodAlmaDestino.current.focus();
	          }
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Almacen no esxite",
	            icono: "informacion"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      if (llamado === 1) {
	        txtCodAlmaOrigen.current.value = "";
	        txtCodAlmaOrigen.current.focus();
	      } else {
	        txtCodAlmaDestino.current.value = "";
	        txtCodAlmaDestino.current.focus();
	      }
	    });
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/inventariovacio/actualizaropeinv/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idopeinv + " creado correctamente",
	            icono: "exito"
	          });
	          /*             window.open(
	                        op.reportes +
	                          `/almacen?afiliado=${organizacion}&reporte=ReporteDetaOpeInventario&codigo=${response.data.idopeinv}`,
	                        "Planilla",
	                        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
	                      ); */
	        } else if (operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idopeinv + " modificado correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idopeinv + " eliminado correctamente",
	            icono: "exito"
	          });
	        }
	        blanquear();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = "";
	      if (error.response === undefined) {
	        mensaje = "Error de Conexion";
	      } else {
	        mensaje = error.response.data.message;
	      }
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var gestionOper = function gestionOper(op, id, index) {
	    return function (e) {
	      e.preventDefault();
	      setOperacionOper(op);
	      if (op === 1) {
	        if (txtCodAlmaOrigen.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe seleccionar el almacen",
	            icono: "informacion"
	          });
	          txtCodAlmaOrigen.current.focus();
	          return;
	        }
	        setMostrar(true);
	      } else if (op === 2) {
	        setRegDet(records[index]);
	        setMostrar(true);
	      } else if (op === 3) {
	        setIdPro(id);
	        setDesde(1);
	        setMensajesino({
	          mostrar: true,
	          titulo: "Confirmación.",
	          texto: "Esta seguro de eliminar el registro?",
	          icono: "confirmacion"
	        });
	      }
	    };
	  };
	
	  var closeGestionOper = function closeGestionOper(op) {
	    setMostrar(false);
	  };
	
	  var closeAceptarGestionOper = function closeAceptarGestionOper(datos) {
	    var prod = [];
	
	    for (var i = 0; i < records.length; i++) {
	      prod.push({
	        idclasevacio: records[i].idclasevacio,
	        descripcion: records[i].descripcion,
	        cantidad: records[i].cantidad,
	        tipomovimiento: records[i].tipomovimiento,
	        fechatipomovimiento: records[i].fechatipomovimiento,
	        numfactura: records[i].numfactura
	      });
	    }
	    prod.push({
	      idclasevacio: datos[0].idclasevacio,
	      descripcion: datos[0].descripcion,
	      cantidad: datos[0].cantidad,
	      tipomovimiento: datos[0].tipomovimiento,
	      fechatipomovimiento: datos[0].fechatipomovimiento,
	      numfactura: datos[0].numfactura
	    });
	    setMostrar(false);
	    setRecords(prod);
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    if (desde === 1) {
	      var prod = [];
	      prod = records.filter(function (prod) {
	        return prod.idclasevacio !== idProd;
	      });
	      setDesde(0);
	      setRecords(prod);
	    } else if (desde === 2) {
	      setDesde(0);
	      procesarRegistro();
	    }
	    /*  getExpendedor(); */
	  };
	
	  var handleInputNumeroChange = function handleInputNumeroChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.target.name === "codalmaorigen") {
	      txtDescripAlmaOrigen.current.value = "";
	      setRecords([]);
	    } else if (event.target.name === "codalmadestino") {
	      txtDescripAlmaDestino.current.value = "";
	    }
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "idopeinv") {
	          seleccionarRegistro();
	        } else if (event.target.name === "codalmaorigen") {
	          seleccionarAlmacen(event.target.value, 1);
	        } else if (event.target.name === "codalmadestino") {
	          seleccionarAlmacen(event.target.value, 2);
	        }
	      }
	    }
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    event.preventDefault();
	    if (event.which === 13) {
	      if (event.target.name === "fechaope") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	        cmbTipoOperacion.current.focus();
	      } else if (event.target.name === "codalmaorigen") {} else if (event.target.name === "codalmadestino") {}
	    } else if (typeof event.which === "undefined") {
	      if (event.target.name === "fechaope") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (btnopvacios && btnopvacios.toString().substring(0, 1) === "1") {
	          setTituloHeader("Incluir Operacion de Inventario Vacio.");
	          setVisibleBtn("hidden");
	          setHabilitadoBot(false);
	          setOperacion(op);
	          setHabilitadoM(true);
	          setHabilitado(true);
	          txtIdOpeInv.current.value = "0";
	          txtIdOpeInv.current.setAttribute("disabled", true);
	          setHabilitarCat(true);
	          txtFecha.current.value = fechaSistema;
	          cmbTipoOperacion.current.selectedIndex = 0;
	          llenarTipoIngreso(1);
	          setTimeout(function () {
	            return txtFecha.current.focus();
	          }, 200);
	        } else {
	          setHabilitadoBot(true);
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (btnopvacios && btnopvacios.toString().substring(1, 2) === "1") {
	          setVisibleBtn("hidden");
	          setTituloHeader("Editar Operacion de Inventario Vacio.");
	          setOperacion(op);
	          setHabilitadoBot(false);
	          txtIdOpeInv.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitadoM(false);
	          setHabilitado(false);
	          txtIdOpeInv.current.focus();
	        } else {
	          setHabilitadoBot(true);
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (btnopvacios && btnopvacios.toString().substring(3, 4) === "1") {
	          setTituloHeader("Eliminar Operacion de Inventario Vacio.");
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          setHabilitadoBot(false);
	          txtIdOpeInv.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitadoM(false);
	          setHabilitado(false);
	          txtIdOpeInv.current.focus();
	        } else {
	          setHabilitadoBot(true);
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (btnopvacios && btnopvacios.toString().substring(2, 3) === "1") {
	          setTituloHeader("Consultar Operacion de Inventario Vacio.");
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          setHabilitadoM(false);
	          setHabilitado(false);
	          setHabilitadoBot(false);
	          txtIdOpeInv.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          txtIdOpeInv.current.focus();
	        } else {
	          setHabilitadoBot(true);
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 5) {
	        if (operacion !== 4) {
	          onChangeValidar();
	        }
	      } else if (op === 6) {
	        setVisibleBtn("visible");
	        blanquear();
	      }
	    };
	  };
	
	  var blanquear = function blanquear() {
	    setTituloHeader("Gestionar Operaciones de Inventario Vacio.");
	    setActivate(false);
	    setBody(null);
	    setHabilitado(false);
	    setHabilitadoM(false);
	    setHabilitadoBot(true);
	    setHabilitarCat(true);
	    txtIdOpeInv.current.setAttribute("disabled", true);
	    txtIdOpeInv.current.value = "";
	    txtFecha.current.value = "";
	    txtObservacion.current.value = "";
	    txtCodAlmaOrigen.current.value = "";
	    txtDescripAlmaOrigen.current.value = "";
	    if (cmbTipoOperacion.current.value === "3") {
	      txtCodAlmaDestino.current.value = "";
	      txtDescripAlmaDestino.current.value = "";
	    }
	    cmbTipoOperacion.current.selectedIndex = -1;
	    setVisibleAlma("hidden");
	    setRecords([]);
	    setVisibleBtn("visible");
	  };
	
	  var llenarTipoIngreso = function llenarTipoIngreso(tipoing) {
	    var tipo = [];
	    if (tipoing === 1) {
	      setVisibleAlma("hidden");
	
	      tipo.push({
	        idtipo: "1",
	        descripcion: "INVENTARIO INICIAL"
	      });
	      tipo.push({
	        idtipo: "2",
	        descripcion: "RECEPCION"
	      });
	      tipo.push({
	        idtipo: "3",
	        descripcion: "AJUSTE"
	      });
	    } else if (tipoing === 2) {
	      tipo.push({
	        idtipo: "1",
	        descripcion: "DESPACHO"
	      });
	      tipo.push({
	        idtipo: "2",
	        descripcion: "AJUSTE"
	      });
	      setVisibleAlma("hidden");
	    } else if (tipoing === 3) {
	      tipo.push({
	        idtipo: "1",
	        descripcion: "TRASLADO"
	      });
	      setVisibleAlma("visible");
	    }
	    setTipoIngreso(tipo);
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "tipoopeinv") {
	      if (e.target.value === "3") {
	        setVisibleAlma("visible");
	      } else {
	        setVisibleAlma("hidden");
	      }
	      llenarTipoIngreso(parseInt(e.target.value));
	    } else if (e.target.name === "fechaope") {}
	  };
	
	  var onCatalogoOperacionInv = function onCatalogoOperacionInv(values) {
	    setCatalogoOpeInv(false);
	    txtIdOpeInv.current.value = values.idoperacioninventario;
	    seleccionarRegistro();
	  };
	
	  var onCatalogoAlmacen = function onCatalogoAlmacen(values) {
	    setCatalogoAlmacen(false);
	    if (cualCat === 1) {
	      txtCodAlmaOrigen.current.value = values.idalmacen;
	      //txtDescripUbiOrigen.current.value = values.descripcion.trim() + ' Almacen: ' + response.data[0].descripcion.trim();
	    } else {
	      txtCodAlmaDestino.current.value = values.idalmacen;
	      //txtDescripUbiDestino.current.value = values.descripcion;
	    }
	    seleccionarAlmacen(values.idalmacen, cualCat);
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	
	    if (txtIdOpeInv.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Código no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtIdOpeInv.current.focus();
	    } else if (txtFecha.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtFecha.current.focus();
	    } else if (txtObservacion.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Observación no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtObservacion.current.focus();
	    } else if (txtCodAlmaOrigen.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Código del Almacen no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtCodAlmaOrigen.current.focus();
	    } else if (cmbTipoOperacion.current.value === "3" && txtCodAlmaDestino.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Código del Almacen Destino no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtCodAlmaDestino.current.focus();
	    } else if (cmbTipoOperacion.current.value === "3" && txtCodAlmaOrigen.current.value.trim() === txtCodAlmaDestino.current.value.trim()) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Código del Almacen Oriregen y Destino no deben ser iguales",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtCodAlmaDestino.current.focus();
	    } else if (records.length === 0) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "No hay Producto agregados",
	        icono: "informacion"
	      });
	      sigue = false;
	      btnCancelar.current.focus();
	    }
	
	    if (sigue) {
	      var opeinv = [];
	      var opeinvdet = [];
	
	      opeinv.push({
	        idoperacioninventario: txtIdOpeInv.current.value,
	        tipooperacion: cmbTipoOperacion.current[cmbTipoOperacion.current.selectedIndex].text,
	        idalmacenorigen: txtCodAlmaOrigen.current.value,
	        idalmacendestino: cmbTipoOperacion.current.value === "3" ? txtCodAlmaDestino.current.value : "",
	        fecha: txtFecha.current.value,
	        observacion: txtObservacion.current.value
	      });
	
	      for (var i = 0; i < records.length; i++) {
	        opeinvdet.push({
	          idclasevacio: records[i].idclasevacio,
	          descripcion: records[i].descripcion,
	          cantidad: records[i].cantidad,
	          tipomovimiento: records[i].tipomovimiento,
	          fechatipomovimiento: records[i].fechatipomovimiento,
	          numfactura: records[i].numfactura,
	          idalmacen: txtCodAlmaOrigen.current.value
	        });
	      }
	
	      setBody({
	        idtipopeinv: cmbTipoOperacion.current.value,
	        opeinv: opeinv,
	        opeinvdet: opeinvdet
	      });
	      setDesde(2);
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var imprimirReporte = function imprimirReporte() {
	    if (txtIdOpeInv.current.value !== "") {
	      window.open(op.reportes + "/almacen?afiliado=" + organizacion + "&reporte=ReporteDetaOpeInventario&codigo=" + txtIdOpeInv.current.value, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    if (cmbTipoOperacion) {
	      cmbTipoOperacion.current.selectedIndex = -1;
	    }
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 py-5 px-5", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 px-5", style: { margin: 0 } },
	        _react2.default.createElement(_incluirProductoVacio.IncluirProducOper, {
	          show: mostrar,
	          onHideCancela: closeGestionOper,
	          onHideAcepta: closeAceptarGestionOper,
	          operacion: operacionOper,
	          idalmacen: txtCodAlmaOrigen.current ? txtCodAlmaOrigen.current.value : "",
	          tipoingreso: tipoIngreso,
	          tipo: cmbTipoOperacion.current ? parseInt(cmbTipoOperacion.current.value) : "",
	          productos: records,
	          registro: regDet
	        }),
	        _react2.default.createElement(_mensajes.Mensaje, {
	          mensaje: mensaje,
	          onHide: function onHide() {
	            mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({
	              mostrar: false,
	              titulo: "",
	              texto: "",
	              icono: ""
	            });
	          }
	        }),
	        _react2.default.createElement(_mensajes.MensajeSiNo, {
	          mensaje: mensajesino,
	          onHideNo: function onHideNo() {
	            return setMensajesino({
	              mostrar: false,
	              titulo: "",
	              texto: "",
	              icono: ""
	            });
	          },
	          onHideSi: handleCloseSi
	        }),
	        _react2.default.createElement(
	          _semanticUiReact.Dimmer,
	          { active: activate, inverted: true },
	          _react2.default.createElement(
	            _semanticUiReact.Loader,
	            { inverted: true },
	            "cargando..."
	          )
	        ),
	        _react2.default.createElement(_catalogoAlmacen2.default, {
	          show: catalogoAlmacen,
	          onHideCancelar: function onHideCancelar() {
	            return setCatalogoAlmacen(false);
	          },
	          onHideAceptaCatalogo: onCatalogoAlmacen
	        }),
	        _react2.default.createElement(_catalogoOperacionInventariovacio2.default, {
	          show: catalogoOpeInv,
	          onHideCancelar: function onHideCancelar() {
	            return setCatalogoOpeInv(false);
	          },
	          onHideAceptaCatalogo: onCatalogoOperacionInv
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "py-3" },
	          _react2.default.createElement(
	            "div",
	            { className: "p-3 col-md-11 mx-auto card shadow row m-0" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light justify-content-between" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-4" },
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  tituloHeader
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 d-flex justify-content-end" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "/inicio", className: "text-light " },
	                  _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "fw-bold" },
	                    "Salir"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 row mx-auto row m-0",
	                style: { fontSizeAdjust: "0,6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group mb-3 col-pd-280" },
	                _react2.default.createElement(
	                  "span",
	                  {
	                    className: "input-group-text fw-bold",
	                    id: "inputGroup-sizing-default"
	                  },
	                  "CODIGO:"
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  className: "form-control fs-5 h-100",
	                  autoComplete: "off",
	                  disabled: true,
	                  ref: txtIdOpeInv,
	                  name: "idopeinv",
	                  onKeyUp: handleInputNumeroChange,
	                  onBlur: handleInputNumeroChange,
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-default"
	                }),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: habilitarCat,
	                    type: "button",
	                    onClick: function onClick() {
	                      return setCatalogoOpeInv(true);
	                    },
	                    className: "btn btn-success"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-search" })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "border-azul py-3 rounded row rounded mx-auto tipo-letra" },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "input-group mb-2 col-pd-360",
	                  style: { fontSizeAdjust: "0,6" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text",
	                    id: "inputGroup-sizing-default"
	                  },
	                  "FECHA DE INGRESO:"
	                ),
	                _react2.default.createElement("input", {
	                  type: "date",
	                  disabled: !habilitado,
	                  ref: txtFecha,
	                  max: (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD"),
	                  name: "fechaope",
	                  onKeyUp: handleInputChange,
	                  onBlur: handleInputChange,
	                  className: "form-control fs-5 text-uppercase h-100",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-default"
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "input-group mb-2 col-pd-340",
	                  style: { fontSizeAdjust: "0,6", marginLeft: "auto" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text",
	                    id: "inputGroup-sizing-default"
	                  },
	                  "TIPO DE OPERACION:"
	                ),
	                _react2.default.createElement(
	                  "select",
	                  {
	                    disabled: !habilitadoM,
	                    ref: cmbTipoOperacion,
	                    className: "form-select",
	                    "aria-label": "Default select example",
	                    name: "tipoopeinv",
	                    onChange: onChange
	                  },
	                  _react2.default.createElement(
	                    "option",
	                    { value: "1" },
	                    "INGRESO"
	                  ),
	                  _react2.default.createElement(
	                    "option",
	                    { value: "2" },
	                    "SALIDA"
	                  ),
	                  _react2.default.createElement(
	                    "option",
	                    { value: "3" },
	                    "TRASLADO"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "input-group mb-2 col-xl-12 col-lg-12 col-md-12 col-sm-12 mx-auto",
	                  style: { fontSizeAdjust: "0,6" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text",
	                    id: "inputGroup-sizing-default"
	                  },
	                  "OBSERVACION:"
	                ),
	                _react2.default.createElement("textarea", {
	                  type: "area",
	                  disabled: !habilitado,
	                  maxLength: "500",
	                  style: {
	                    height: 80
	                  },
	                  autoComplete: "off",
	                  ref: txtObservacion,
	                  className: "form-control text-uppercase fs-5",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-default"
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12", style: { fontSizeAdjust: "0,6" } },
	                _react2.default.createElement(
	                  "fieldset",
	                  { className: " row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between" },
	                  _react2.default.createElement(
	                    "legend",
	                    { className: "float-none w-auto fw-bold" },
	                    "ALMAC\xC9N ",
	                    visibleAlma !== "hidden" && "ORIGEN"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group mb-2 col-md-12" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group mb-1 col-xl-3 col-lg-4 col-md-5 col-sm-6" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-default"
	                        },
	                        "CODIGO:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        disabled: !habilitadoM,
	                        ref: txtCodAlmaOrigen,
	                        autoComplete: "off",
	                        className: "form-control fs-5 text-uppercase h-100",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-default",
	                        name: "codalmaorigen",
	                        onKeyUp: handleInputNumeroChange,
	                        onBlur: handleInputNumeroChange
	                      }),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          disabled: !habilitado,
	                          onClick: function onClick() {
	                            setCualCat(1);
	                            setCatalogoAlmacen(true);
	                          },
	                          className: "btn btn-success"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-search" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group mb-1 col-xl-9 col-lg-12 col-md-12 col-sm-12" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-default"
	                        },
	                        "DESCRIPCION:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        disabled: true,
	                        ref: txtDescripAlmaOrigen,
	                        className: "form-control fs-5 text-uppercase h-100",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-default"
	                      })
	                    )
	                  )
	                )
	              ),
	              visibleAlma !== "hidden" && _react2.default.createElement(
	                "div",
	                { className: "col-md-12", style: { fontSizeAdjust: "0,6" } },
	                _react2.default.createElement(
	                  "fieldset",
	                  { className: " row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between" },
	                  _react2.default.createElement(
	                    "legend",
	                    { className: "float-none w-auto fw-bold" },
	                    "ALMAC\xC9N DESTINO"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group mb-2 col-md-12" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group mb-1 col-xl-3 col-lg-4 col-md-5 col-sm-6" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-default"
	                        },
	                        "CODIGO:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        disabled: !habilitadoM,
	                        ref: txtCodAlmaDestino,
	                        className: "form-control fs-6",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-default",
	                        name: "codalmadestino",
	                        onKeyUp: handleInputNumeroChange,
	                        onBlur: handleInputNumeroChange
	                      }),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          disabled: !habilitado,
	                          onClick: function onClick() {
	                            setCualCat(2);
	                            setCatalogoAlmacen(true);
	                          },
	                          className: "btn btn-success"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-search" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group mb-1 col-xl-9 col-lg-12 col-md-12 col-sm-12" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-default"
	                        },
	                        "DESCRIPCION:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        disabled: true,
	                        ref: txtDescripAlmaDestino,
	                        className: "form-control fs-6 text-uppercase",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-default"
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-12 p-2" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row col-12 d-flex justify-content-end" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-3 d-flex justify-content-end" },
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          disabled: !habilitado,
	                          onClick: gestionOper(1, 0, 0),
	                          className: "btn btn-sm mx-1 btn-primary rounded-pill",
	                          title: "Incluir Vacio"
	                        },
	                        _react2.default.createElement(
	                          "i",
	                          { className: "fas fa-plus" },
	                          " Incluir Vacio"
	                        ),
	                        " "
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12", style: { margin: "auto" } },
	                  _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                      _core.TableBody,
	                      null,
	                      records && records.map(function (item, index) {
	                        return _react2.default.createElement(
	                          _core.TableRow,
	                          {
	                            key: index,
	                            style: { padding: "0", fontSizeAdjust: "0.6" }
	                          },
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            {
	                              className: "align-middle bg-light text-center p-0",
	                              style: { width: "40px" }
	                            },
	                            item.idclasevacio,
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            {
	                              className: "align-middle bg-light text-start p-0 pl-2",
	                              style: { width: "50px" }
	                            },
	                            item.descripcion,
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            {
	                              className: "align-middle bg-light text-end p-0 pr-2",
	                              style: { width: "30px" }
	                            },
	                            (0, _varios.formatMoneda)(item.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            {
	                              className: "align-middle bg-light text-center p-0",
	                              style: { width: "50px" }
	                            },
	                            item.tipomovimiento,
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            {
	                              className: "align-middle bg-light text-center p-0",
	                              style: { width: "50px" }
	                            },
	                            item.fechatipomovimiento === "" ? "" : (0, _moment2.default)(item.fechatipomovimiento).format("DD/MM/YYYY"),
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            {
	                              className: "align-middle bg-light text-center p-0",
	                              style: { width: "50px" }
	                            },
	                            item.numfactura,
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            {
	                              className: "align-middle bg-light text-center p-0",
	                              style: { width: "20px" }
	                            },
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                disabled: !habilitado,
	                                style: {
	                                  visibility: (operacion === 4 || operacion === 3) && "collapse"
	                                },
	                                onClick: gestionOper(3, item.idclasevacio, index),
	                                className: "btn btn-sm btn-danger"
	                              },
	                              _react2.default.createElement("i", { className: "fa fa-trash" }),
	                              " "
	                            )
	                          )
	                        );
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 d-flex justify-content-between mt-2" },
	                visibleBtn === "visible" ? _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 col-sm-12 col-lg-12 col-12  justify-content-start" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnIncluir,
	                      onClick: onBotones(1),
	                      disabled: !habilitadoBot,
	                      className: "btn btn-sm mx-1 btn-primary rounded-pill",
	                      title: "Incluir Operacion de Inventario"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-plus" },
	                      " Incluir "
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnConsultar,
	                      onClick: onBotones(4),
	                      disabled: !habilitadoBot,
	                      className: "btn btn-sm mx-1 btn-info rounded-pill",
	                      title: "Consultar Operacion de Inventario"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-eye" },
	                      "Consultar"
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnEditar,
	                      onClick: onBotones(2),
	                      disabled: !habilitadoBot,
	                      className: "btn btn-sm mx-1 btn-warning rounded-pill",
	                      title: "Modificar Operacion de Inventario"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-edit" },
	                      "Modificar"
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnEliminar,
	                      onClick: onBotones(3),
	                      className: "btn btn-sm mx-1 btn-danger rounded-pill",
	                      title: "Eliminar Operacion de Inventario"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-trash" },
	                      "Eliminar"
	                    ),
	                    " "
	                  )
	                ) : "",
	                visibleBtn === "visible" ? "" : _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 d-flex justify-content-end" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: habilitadoBot,
	                      onClick: onBotones(5),
	                      ref: btnAceptar,
	                      className: "mx-2 btn btn-sm rounded-pill btn-success",
	                      title: "Aceptar"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-check-circle" },
	                      " Aceptar"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: habilitadoBot,
	                      onClick: onBotones(6),
	                      ref: btnCancelar,
	                      className: "mx-2 btn btn-danger btn-sm rounded-pill",
	                      title: "Cancelar"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-window-close" },
	                      " Cancelar"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	exports.default = TablaOperInventarioVacio;

/***/ },
/* 7068 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(69);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _gestionarTipoProducto = __webpack_require__(297);
	
	var _catalogoProducto = __webpack_require__(104);
	
	var _catalogoProducto2 = _interopRequireDefault(_catalogoProducto);
	
	var _gestionarMarca = __webpack_require__(211);
	
	var _gestionarModelo = __webpack_require__(212);
	
	var _varios = __webpack_require__(14);
	
	var _gestionarUnidadMedida = __webpack_require__(213);
	
	var _reactCanvasGauges = __webpack_require__(7001);
	
	var _gestionarFabricante = __webpack_require__(296);
	
	var _gestionarClasificadorVacios = __webpack_require__(302);
	
	var _modalActualizarProductos = __webpack_require__(7056);
	
	var _modalActualizarProductExcel = __webpack_require__(7055);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var TablaProdTerminadoe = function TablaProdTerminadoe() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var organizacion = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var accbtnproducto = JSON.parse(sessionStorage.getItem("accbtnproductoc"));
	  /* bloquear tab */
	
	  var _useState = (0, _react.useState)({ tab1: "tab", tab2: "" }),
	      _useState2 = _slicedToArray(_useState, 2),
	      tabIndex = _useState2[0],
	      setTabIndex = _useState2[1];
	  /* activar tab */
	
	
	  var _useState3 = (0, _react.useState)({
	    tab1: "nav-link active text-light bg-blue-100 rounded",
	    tab2: "nav-link text-light bg-blue-200 rounded"
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activeTab = _useState4[0],
	      setACtiveTab = _useState4[1];
	  /* mostar tabPanel */
	
	
	  var _useState5 = (0, _react.useState)({
	    tab1: "tab-pane fade show active",
	    tab2: "tab-pane fade"
	  }),
	      _useState6 = _slicedToArray(_useState5, 2),
	      tabPanel = _useState6[0],
	      setTabPanel = _useState6[1];
	  /* validar tab */
	
	
	  var _useState7 = (0, _react.useState)({ tab1: "true", tab2: "false" }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      tabvalid = _useState8[0],
	      setTabValid = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({
	    max: 0,
	    ofe: 0,
	    may: 0,
	    min: 0,
	    maxalt: 0,
	    ofealt: 0,
	    mayalt: 0,
	    minalt: 0
	  }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      alerta = _useState10[0],
	      setAlerta = _useState10[1];
	
	  var btnIncluir = (0, _react.useRef)();
	  var btnEditar = (0, _react.useRef)();
	  var btnEliminar = (0, _react.useRef)();
	  var btnConsultar = (0, _react.useRef)();
	  var btnAceptar = (0, _react.useRef)();
	  var btnCancelar = (0, _react.useRef)();
	  var txtIdproducto = (0, _react.useRef)();
	  var txtIdproductoHidden = (0, _react.useRef)();
	  //const txtCodigo = useRef();
	  var txtNombre = (0, _react.useRef)();
	  var txtNombreCorto = (0, _react.useRef)();
	  var cmbMarca = (0, _react.useRef)();
	  var cmbModelo = (0, _react.useRef)();
	  var cmbMoneda = (0, _react.useRef)();
	  var cmbTipoProd = (0, _react.useRef)();
	  var cmbFabricante = (0, _react.useRef)();
	  var txtReferencia = (0, _react.useRef)();
	  var txtDiasGar = (0, _react.useRef)();
	  var cmbUnidMedida = (0, _react.useRef)();
	  var txtCostoProveSinImp = (0, _react.useRef)();
	  var txtCostoCalcuSinImp = (0, _react.useRef)();
	  var txtUltimoCostoSinImp = (0, _react.useRef)();
	  var txtCostoPromeSinImp = (0, _react.useRef)();
	  var cmbMetodoCosto = (0, _react.useRef)();
	  var cmbPrecioVenta = (0, _react.useRef)();
	  var txtCostoProveConImp = (0, _react.useRef)();
	  var txtCostoCalcuConImp = (0, _react.useRef)();
	  var txtUltimoCostoConImp = (0, _react.useRef)();
	  var txtCostoPromeConImp = (0, _react.useRef)();
	  var txtIvaCompra = (0, _react.useRef)();
	  var txtIvaVenta = (0, _react.useRef)();
	  var txtPrecioMaxiSinImp = (0, _react.useRef)();
	  var txtPrecioOfeSinImp = (0, _react.useRef)();
	  var txtPrecioMayorSinImp = (0, _react.useRef)();
	  var txtPrecioMiniSinImp = (0, _react.useRef)();
	  var txtUtilidadMaxi = (0, _react.useRef)();
	  var txtUtilidadOfe = (0, _react.useRef)();
	  var txtUtilidadMayor = (0, _react.useRef)();
	  var txtUtilidadMini = (0, _react.useRef)();
	  var txtPrecioMaxiConImp = (0, _react.useRef)();
	  var txtPrecioOfeConImp = (0, _react.useRef)();
	  var txtPrecioMayorConImp = (0, _react.useRef)();
	  var txtPrecioMiniConImp = (0, _react.useRef)();
	  var radioSi = (0, _react.useRef)();
	  var radioNo = (0, _react.useRef)();
	  var chkServicio = (0, _react.useRef)();
	  var chkActivo = (0, _react.useRef)();
	  var txtVacio = (0, _react.useRef)();
	  var txtCodigoVacio = (0, _react.useRef)();
	  var txtStockMini = (0, _react.useRef)();
	  var cmbUniVenta = (0, _react.useRef)();
	  var cmbUniCompra = (0, _react.useRef)();
	  var cmbUniPrincipal = (0, _react.useRef)();
	  var cmbUniAlterna = (0, _react.useRef)();
	  var cmbAlmacen = (0, _react.useRef)();
	  var txtFactor = (0, _react.useRef)();
	  var cmbUniFactor = (0, _react.useRef)();
	  var txtCostoProveSinImpAlter = (0, _react.useRef)();
	  var txtCostoCalcuSinImpAlter = (0, _react.useRef)();
	  var txtUltimoCostoSinImpAlter = (0, _react.useRef)();
	  var txtCostoPromeSinImpAlter = (0, _react.useRef)();
	  var txtCostoProveConImpAlter = (0, _react.useRef)();
	  var txtCostoCalcuConImpAlter = (0, _react.useRef)();
	  var txtUltimoCostoConImpAlter = (0, _react.useRef)();
	  var txtCostoPromeConImpAlter = (0, _react.useRef)();
	  var txtPrecioMaxiSinImpAlter = (0, _react.useRef)();
	  var txtPrecioOfeSinImpAlter = (0, _react.useRef)();
	  var txtPrecioMayorSinImpAlter = (0, _react.useRef)();
	  var txtPrecioMiniSinImpAlter = (0, _react.useRef)();
	  var txtUtilidadMaxiAlter = (0, _react.useRef)();
	  var txtUtilidadOfeAlter = (0, _react.useRef)();
	  var txtUtilidadMayorAlter = (0, _react.useRef)();
	  var txtUtilidadMiniAlter = (0, _react.useRef)();
	  var txtPrecioMaxiConImpAlter = (0, _react.useRef)();
	  var txtPrecioOfeConImpAlter = (0, _react.useRef)();
	  var txtPrecioMayorConImpAlter = (0, _react.useRef)();
	  var txtPrecioMiniConImpAlter = (0, _react.useRef)();
	
	  var _useState11 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mensaje = _useState12[0],
	      setMensaje = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensajesino = _useState14[0],
	      setMensajesino = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      activate = _useState16[0],
	      setActivate = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(true),
	      _useState18 = _slicedToArray(_useState17, 2),
	      habilitadoBot = _useState18[0],
	      setHabilitadoBot = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      cantidadProd = _useState20[0],
	      setCantidadProd = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      stockMinimo = _useState22[0],
	      setStockMinimo = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(),
	      _useState24 = _slicedToArray(_useState23, 2),
	      nomProducto = _useState24[0],
	      setNomProducto = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(true),
	      _useState26 = _slicedToArray(_useState25, 2),
	      habilitarCat = _useState26[0],
	      setHabilitarCat = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(false),
	      _useState28 = _slicedToArray(_useState27, 2),
	      habilitado = _useState28[0],
	      setHabilitado = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      body = _useState30[0],
	      setBody = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(false),
	      _useState32 = _slicedToArray(_useState31, 2),
	      habilitadoAlter = _useState32[0],
	      setHabilitadoAlter = _useState32[1];
	
	  var _useState33 = (0, _react.useState)("visible"),
	      _useState34 = _slicedToArray(_useState33, 2),
	      visibleA = _useState34[0],
	      setVisibleA = _useState34[1];
	
	  var _useState35 = (0, _react.useState)("1"),
	      _useState36 = _slicedToArray(_useState35, 2),
	      costoSelect = _useState36[0],
	      setCostoSelect = _useState36[1];
	
	  var _useState37 = (0, _react.useState)("1"),
	      _useState38 = _slicedToArray(_useState37, 2),
	      precioSelect = _useState38[0],
	      setPrecioSelect = _useState38[1];
	
	  var _useState39 = (0, _react.useState)("Gestionar Producto Terminado."),
	      _useState40 = _slicedToArray(_useState39, 2),
	      tituloHeader = _useState40[0],
	      setTituloHeader = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(["0", "10", "20", "30", "40", "50", "60", "70", "80", "90", "100"]),
	      _useState42 = _slicedToArray(_useState41, 2),
	      flujo = _useState42[0],
	      setFlujo = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(false),
	      _useState44 = _slicedToArray(_useState43, 2),
	      mostrarActualizar = _useState44[0],
	      setMostrarActualizar = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(false),
	      _useState46 = _slicedToArray(_useState45, 2),
	      mostrarActualizar2 = _useState46[0],
	      setMostrarActualizar2 = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(false),
	      _useState48 = _slicedToArray(_useState47, 2),
	      mostrarMarca = _useState48[0],
	      setMostrarMarca = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(false),
	      _useState50 = _slicedToArray(_useState49, 2),
	      mostrarModelo = _useState50[0],
	      setMostrarModelo = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(false),
	      _useState52 = _slicedToArray(_useState51, 2),
	      mostrarTipoP = _useState52[0],
	      setMostrarTipoP = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(false),
	      _useState54 = _slicedToArray(_useState53, 2),
	      mostrarFabricante = _useState54[0],
	      setMostrarFabricante = _useState54[1];
	
	  var _useState55 = (0, _react.useState)(false),
	      _useState56 = _slicedToArray(_useState55, 2),
	      mostrarclassvacio = _useState56[0],
	      setMostrarclassvacio = _useState56[1];
	
	  var _useState57 = (0, _react.useState)(false),
	      _useState58 = _slicedToArray(_useState57, 2),
	      mostrarMedida = _useState58[0],
	      setMostrarMedida = _useState58[1];
	
	  var _useState59 = (0, _react.useState)(false),
	      _useState60 = _slicedToArray(_useState59, 2),
	      catalogoProducto = _useState60[0],
	      setCatalogoProducto = _useState60[1];
	
	  var _useState61 = (0, _react.useState)(1),
	      _useState62 = _slicedToArray(_useState61, 2),
	      operacion = _useState62[0],
	      setOperacion = _useState62[1];
	
	  var _useState63 = (0, _react.useState)(0),
	      _useState64 = _slicedToArray(_useState63, 2),
	      valvacio = _useState64[0],
	      setValvacio = _useState64[1];
	
	  var _useState65 = (0, _react.useState)([]),
	      _useState66 = _slicedToArray(_useState65, 2),
	      unidadM = _useState66[0],
	      setUnidadM = _useState66[1];
	
	  var _useState67 = (0, _react.useState)([]),
	      _useState68 = _slicedToArray(_useState67, 2),
	      classvacios = _useState68[0],
	      setClassvacios = _useState68[1];
	
	  var _useState69 = (0, _react.useState)([]),
	      _useState70 = _slicedToArray(_useState69, 2),
	      tipoP = _useState70[0],
	      setTipoP = _useState70[1];
	
	  var _useState71 = (0, _react.useState)([]),
	      _useState72 = _slicedToArray(_useState71, 2),
	      fabri = _useState72[0],
	      setFabri = _useState72[1];
	
	  var _useState73 = (0, _react.useState)([]),
	      _useState74 = _slicedToArray(_useState73, 2),
	      marca = _useState74[0],
	      setMarca = _useState74[1];
	
	  var _useState75 = (0, _react.useState)([]),
	      _useState76 = _slicedToArray(_useState75, 2),
	      modelo = _useState76[0],
	      setModelo = _useState76[1];
	
	  var _useState77 = (0, _react.useState)([]),
	      _useState78 = _slicedToArray(_useState77, 2),
	      unidadV = _useState78[0],
	      setUnidadV = _useState78[1];
	
	  var _useState79 = (0, _react.useState)([]),
	      _useState80 = _slicedToArray(_useState79, 2),
	      unidadC = _useState80[0],
	      setUnidadC = _useState80[1];
	
	  var _useState81 = (0, _react.useState)([]),
	      _useState82 = _slicedToArray(_useState81, 2),
	      factor = _useState82[0],
	      setFactor = _useState82[1];
	
	  var _useState83 = (0, _react.useState)([]),
	      _useState84 = _slicedToArray(_useState83, 2),
	      combomoneda = _useState84[0],
	      setComboMoneda = _useState84[1];
	
	  var _useState85 = (0, _react.useState)({
	    idmoneda: "1",
	    descripcion: "BOLIVARES",
	    simbolo: "Bs",
	    predeterminada: true,
	    subpredeterminada: false,
	    valormoneda: 1.0
	  }),
	      _useState86 = _slicedToArray(_useState85, 2),
	      moneda = _useState86[0],
	      setMoneda = _useState86[1];
	
	  var _useState87 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState88 = _slicedToArray(_useState87, 2),
	      monedaSub = _useState88[0],
	      setMonedaSub = _useState88[1];
	
	  var _useState89 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState90 = _slicedToArray(_useState89, 2),
	      monedaCambio = _useState90[0],
	      setMonedaCambio = _useState90[1];
	
	  var _useState91 = (0, _react.useState)({
	    imagen: "subir.png",
	    imagenactual: "subir.png"
	  }),
	      _useState92 = _slicedToArray(_useState91, 2),
	      imagen = _useState92[0],
	      setImagen = _useState92[1];
	
	  var _useState93 = (0, _react.useState)({
	    imagen: op.conexion + "/imagen?img=subir.png"
	  }),
	      _useState94 = _slicedToArray(_useState93, 2),
	      pathImage = _useState94[0],
	      setPathImage = _useState94[1];
	
	  var _useState95 = (0, _react.useState)("visible"),
	      _useState96 = _slicedToArray(_useState95, 2),
	      visibleBtn = _useState96[0],
	      setVisibleBtn = _useState96[1];
	
	  var _useState97 = (0, _react.useState)(window.innerWidth),
	      _useState98 = _slicedToArray(_useState97, 2),
	      windowWidth = _useState98[0],
	      setWindowWidth = _useState98[1];
	
	  var _useState99 = (0, _react.useState)({
	    idproducto: "",
	    codigo: "",
	    nombre: "",
	    servicio: false,
	    nombrecorto: "",
	    idtipoproducto: "",
	    marca: "",
	    modelo: "",
	    referencia: "",
	    diasgarantia: "",
	    idunidadmedida: "",
	    idmoneda: "",
	    ivacompra: 0.0,
	    ivaventa: 0.0,
	    exento: false,
	    tipoprecio: "1",
	    almacen: true,
	    stockminimo: 1.0,
	    metodocosto: "1",
	    costoproveedor: 0.0,
	    costocalculado: 0.0,
	    ultimocosto: 0.0,
	    costopromedio: 0.0,
	    utipreciomaxi: 0.0,
	    utiprecioofe: 0.0,
	    utipreciomayor: 0.0,
	    utipreciomini: 0.0,
	    preciomaxi: 0.0,
	    precioofe: 0.0,
	    preciomayor: 0.0,
	    preciomini: 0.0,
	    idunidadalterna: "",
	    idunidadcompra: "",
	    idunidadventa: "",
	    valorfactor: 0.0,
	    tipofactor: "",
	    costoproveedoralter: 0.0,
	    costocalculadoalter: 0.0,
	    ultimocostoalter: 0.0,
	    costopromedioalter: 0.0,
	    utipreciomaxialter: 0.0,
	    utiprecioofealter: 0.0,
	    utipreciomayoralter: 0.0,
	    utipreciominialter: 0.0,
	    preciomaxialter: 0.0,
	    precioofealter: 0.0,
	    preciomayoralter: 0.0,
	    preciominialter: 0.0,
	    idtipoingreso: "0",
	    idfabricante: ""
	  }),
	      _useState100 = _slicedToArray(_useState99, 2),
	      producto = _useState100[0],
	      setProducto = _useState100[1];
	
	  window.addEventListener("resize", function () {
	    setWindowWidth(window.innerWidth);
	  });
	
	  var seleccionarMonedas = function seleccionarMonedas() {
	    var campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	    var nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	    var orden = "m.idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var x = 0;
	        if (response.data.length > 0) {
	          setComboMoneda(response.data);
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].subpredeterminada) {
	              setMonedaSub(response.data[i]);
	              setMonedaCambio({
	                idmoneda: response.data[i].idmoneda,
	                descripcion: response.data[i].descripcion,
	                simbolo: response.data[i].simbolo,
	                predeterminada: response.data[i].predeterminada,
	                subpredeterminada: response.data[i].subpredeterminada,
	                valormoneda: 1.0
	              });
	              x = i;
	            } else if (response.data[i].predeterminada) {
	              setMoneda(response.data[i]);
	            }
	          }
	        }
	        setTimeout(function () {
	          return cmbMoneda.current.selectedIndex = x;
	        }, 200);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	  var seleccionarTipoProd = function seleccionarTipoProd() {
	    var campos = "*";
	    var nomtab = "tipoproducto";
	    var orden = "descripcion";
	    var endpoint = op.conexion + ("/api/comun/seleccionaregistros?campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden);
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setTipoP(response.data);
	        cmbTipoProd.current.selectedIndex = -1;
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	  var seleccionarFabricante = function seleccionarFabricante() {
	    var campos = "*";
	    var nomtab = "fabricante";
	    var orden = "descripcion";
	    var endpoint = op.conexion + ("/api/comun/seleccionaregistros?campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden);
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setFabri(response.data);
	        cmbFabricante.current.selectedIndex = -1;
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	  var seleccionarUnidadMedida = function seleccionarUnidadMedida(ope) {
	    var campos = "*";
	    var nomtab = "unidadmedida";
	    var orden = "idunidadmedida";
	    var endpoint = op.conexion + ("/api/comun/seleccionaregistros?campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden);
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setUnidadM(response.data);
	        if (ope === 1) {
	          cmbUniPrincipal.current.selectedIndex = 0;
	          cmbUnidMedida.current.selectedIndex = 0;
	        } else {
	          cmbUniPrincipal.current.selectedIndex = -1;
	          cmbUnidMedida.current.selectedIndex = -1;
	        }
	        cmbUniAlterna.current.selectedIndex = -1;
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	  var agregarUnidad = function agregarUnidad() {
	    seleccionarUnidadMedida(1);
	  };
	
	  var seleccionarClassVacios = function seleccionarClassVacios(ope) {
	    var idclas = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    var callback = arguments[2];
	
	    var campos = "*";
	    var nomtab = "clasevacio";
	    var orden = "idclasevacio";
	    var endpoint = op.conexion + ("/api/comun/seleccionaregistros?campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden);
	
	    _axios2.default.get(endpoint, {
	      headers: { "x-access-token": "" + token }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setClassvacios(response.data);
	        if (ope === 1 && idclas !== null && txtCodigoVacio.current) {
	          txtCodigoVacio.current.value = idclas;
	        }
	      }
	      setActivate(false);
	      if (callback) callback();
	    }).catch(function (error) {
	      console.log(error);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message || "Error al cargar clases vacías",
	        icono: "error"
	      });
	      setActivate(false);
	      if (callback) callback();
	    });
	  };
	
	  var seleccionarMarca = function seleccionarMarca() {
	    var campos = "*";
	    var nomtab = "marca";
	    var orden = "descripcion";
	    var endpoint = op.conexion + ("/api/comun/seleccionaregistros?campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden);
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setMarca(response.data);
	        cmbMarca.current.selectedIndex = 0;
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var seleccionarModelo = function seleccionarModelo() {
	    var campos = "*";
	    var nomtab = "modelo";
	    var orden = "descripcion";
	    var endpoint = op.conexion + ("/api/comun/seleccionaregistros?campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden);
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setModelo(response.data);
	        cmbModelo.current.selectedIndex = 0;
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var abrirModal = function abrirModal(tipo) {
	    return function (e) {
	      e.preventDefault();
	      if (tipo === "marca") {
	        setMostrarMarca(true);
	      } else if (tipo === "modelo") {
	        setMostrarModelo(true);
	      } else if (tipo === "tipop") {
	        setMostrarTipoP(true);
	      } else if (tipo === "medida") {
	        setMostrarMedida(true);
	      } else if (tipo === "fabricante") {
	        setMostrarFabricante(true);
	      } else if (tipo === "classvacios") {
	        setMostrarclassvacio(true);
	      }
	    };
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var handleUpload = function handleUpload(e) {
	    if (e.target.files && e.target.files.length > 0) {
	      var file = e.target.files[0];
	      var name = e.target;
	
	      if (file.type.includes("image")) {
	        var reader = new FileReader();
	        reader.readAsDataURL(file);
	
	        if (name.name === "imagen") {
	          reader.onload = function load() {
	            setPathImage(Object.assign({}, pathImage, { imagen: reader.result }));
	          };
	        }
	      }
	    }
	
	    setImagen(Object.assign({}, imagen, _defineProperty({}, e.target.name, e.target.files[0])));
	  };
	
	  var blanquear = function blanquear() {
	    setFlujo(["0", "10", "20", "30", "40", "50", "60", "70", "80", "90", "100"]);
	    setValvacio(0);
	    setTituloHeader("Gestionar Producto Terminado.");
	    setNomProducto();
	    setCantidadProd(0);
	    setStockMinimo(0);
	    setActivate(false);
	    setBody();
	    setHabilitado(false);
	    setHabilitadoBot(true);
	    setUnidadM([]);
	    setTipoP([]);
	    setFabri([]);
	    setMarca([]);
	    setModelo([]);
	    setAlerta({
	      max: 0,
	      ofe: 0,
	      may: 0,
	      min: 0,
	      maxalt: 0,
	      ofealt: 0,
	      mayalt: 0,
	      minalt: 0
	    });
	    setCostoSelect("1");
	    setPrecioSelect("1");
	    setMonedaCambio({
	      idmoneda: "4",
	      descripcion: "DOLAR",
	      simbolo: "$",
	      predeterminada: false,
	      subpredeterminada: true,
	      valormoneda: 1.0
	    });
	
	    for (var i = 0; i < combomoneda.length; i++) {
	      if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
	        cmbMoneda.current.selectedIndex = i;
	      }
	    }
	    setImagen({ imagen: "subir.png", imagenactual: "subir.png" });
	    setPathImage({ imagen: op.conexion + "/imagen?img=subir.png" });
	    txtIdproducto.current.setAttribute("disabled", true);
	    setHabilitarCat(true);
	    setVisibleBtn("visible");
	    //btnBuscar.current.setAttribute("disabled", true);
	    txtIdproducto.current.value = "";
	    txtVacio.current.checked = false;
	    txtNombre.current.value = "";
	    txtNombreCorto.current.value = "";
	    txtReferencia.current.value = "";
	    txtDiasGar.current.value = "";
	    txtIvaCompra.current.value = "";
	    txtIvaVenta.current.value = "";
	    txtCostoProveSinImp.current.value = "";
	    txtCostoCalcuSinImp.current.value = "";
	    txtUltimoCostoSinImp.current.value = "";
	    txtCostoPromeSinImp.current.value = "";
	    txtCostoProveConImp.current.value = "";
	    txtCostoCalcuConImp.current.value = "";
	    txtUltimoCostoConImp.current.value = "";
	    txtCostoPromeConImp.current.value = "";
	    txtPrecioMaxiSinImp.current.value = "";
	    txtPrecioOfeSinImp.current.value = "";
	    txtPrecioMayorSinImp.current.value = "";
	    txtPrecioMiniSinImp.current.value = "";
	    txtPrecioMaxiSinImp.current.style.color = "#000000";
	    txtPrecioOfeSinImp.current.style.color = "#000000";
	    txtPrecioMayorSinImp.current.style.color = "#000000";
	    txtPrecioMiniSinImp.current.style.color = "#000000";
	    txtPrecioMaxiConImp.current.value = "";
	    txtPrecioOfeConImp.current.value = "";
	    txtPrecioMayorConImp.current.value = "";
	    txtPrecioMiniConImp.current.value = "";
	    txtUtilidadMaxi.current.value = "";
	    txtUtilidadOfe.current.value = "";
	    txtUtilidadMayor.current.value = "";
	    txtUtilidadMini.current.value = "";
	    chkServicio.current.checked = false;
	    chkActivo.current.checked = true;
	    // chkExento.current.checked = false;
	    // chkAlmacen.current.checked = false;
	    cmbAlmacen.current.value = "true";
	    txtStockMini.current.value = "0,00";
	    setVisibleA("visible");
	    cmbPrecioVenta.current.value = "1";
	    cmbMetodoCosto.current.value = "1";
	    cmbMarca.current.selectedIndex = -1;
	    cmbModelo.current.selectedIndex = -1;
	
	    radioSi.current.checked = false;
	    radioNo.current.checked = false;
	  };
	
	  var blanquearAlter = function blanquearAlter() {
	    setValvacio(0);
	    setAlerta(Object.assign({}, alerta, {
	      maxalt: 0,
	      ofealt: 0,
	      mayalt: 0,
	      minalt: 0
	    }));
	    setHabilitadoAlter(false);
	    txtCostoProveSinImpAlter.current.value = "";
	    txtCostoCalcuSinImpAlter.current.value = "";
	    txtUltimoCostoSinImpAlter.current.value = "";
	    txtCostoPromeSinImpAlter.current.value = "";
	    txtCostoProveConImpAlter.current.value = "";
	    txtCostoCalcuConImpAlter.current.value = "";
	    txtUltimoCostoConImpAlter.current.value = "";
	    txtCostoPromeConImpAlter.current.value = "";
	    txtPrecioMaxiSinImpAlter.current.value = "";
	    txtPrecioOfeSinImpAlter.current.value = "";
	    txtPrecioMayorSinImpAlter.current.value = "";
	    txtPrecioMiniSinImpAlter.current.value = "";
	    txtPrecioMaxiConImpAlter.current.value = "";
	    txtPrecioOfeConImpAlter.current.value = "";
	    txtPrecioMayorConImpAlter.current.value = "";
	    txtPrecioMiniConImpAlter.current.value = "";
	    txtUtilidadMaxiAlter.current.value = "";
	    txtUtilidadOfeAlter.current.value = "";
	    txtUtilidadMayorAlter.current.value = "";
	    txtUtilidadMiniAlter.current.value = "";
	    txtFactor.current.value = "";
	    txtPrecioMaxiSinImpAlter.current.style.color = "#000000";
	    txtPrecioOfeSinImpAlter.current.style.color = "#000000";
	    txtPrecioMayorSinImpAlter.current.style.color = "#000000";
	    txtPrecioMiniSinImpAlter.current.style.color = "#000000";
	    txtVacio.current.checked = false;
	    setFactor([]);
	    setUnidadC([]);
	    setUnidadV([]);
	    cmbUniPrincipal.current.selectedIndex = -1;
	    cmbUniAlterna.current.selectedIndex = -1;
	  };
	
	  var handleInputMontoChange = function handleInputMontoChange(event) {
	    (0, _varios.validaMonto)(event);
	
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	        event.target.value = "0,00";
	      }
	      event.target.value = (0, _varios.formatoMonto)(event.target.value);
	      var char1 = event.target.value.substring(0, 1);
	      var char2 = event.target.value.substring(1, 2);
	      if (char1 === "0" && char2 !== ",") {
	        event.target.value = event.target.value.substring(1, event.target.value.legth);
	      }
	
	      if (event.target.id === "costoProveSinImpu") {
	        calcularImpuestosCostos();
	        if (event.which === 13) {
	          txtCostoCalcuSinImp.current.focus();
	        }
	      } else if (event.target.id === "costoCalcuSinImpu") {
	        calcularImpuestosCostos();
	        if (event.which === 13) {
	          txtUltimoCostoSinImp.current.focus();
	        }
	      } else if (event.target.id === "costoUltiSinImpu") {
	        calcularImpuestosCostos();
	        if (event.which === 13) {
	          txtCostoPromeSinImp.current.focus();
	        }
	      } else if (event.target.id === "costoPromeSinImpu") {
	        calcularImpuestosCostos();
	        if (event.which === 13) {
	          txtPrecioMaxiSinImp.current.focus();
	        }
	      } else if (event.target.id === "preciomaximo") {
	        calcularUtilidadxValor(1);
	        if (event.which === 13) {
	          txtPrecioOfeSinImp.current.focus();
	        }
	      } else if (event.target.id === "preciooferta") {
	        calcularUtilidadxValor(2);
	        if (event.which === 13) {
	          txtPrecioMayorSinImp.current.focus();
	        }
	      } else if (event.target.id === "preciomayor") {
	        calcularUtilidadxValor(3);
	        if (event.which === 13) {
	          txtPrecioMiniSinImp.current.focus();
	        }
	      } else if (event.target.id === "preciominimo") {
	        calcularUtilidadxValor(4);
	      } else if (event.target.id === "utilidadMaxi") {
	        calcularUtilidadxPorce(1);
	      } else if (event.target.id === "utilidadOfe") {
	        calcularUtilidadxPorce(2);
	      } else if (event.target.id === "utilidadMayor") {
	        calcularUtilidadxPorce(3);
	      } else if (event.target.id === "utilidadMini") {
	        calcularUtilidadxPorce(4);
	      } else if (event.target.id === "costoProveSinImpuAlter") {
	        calcularImpuestosCostosAlter();
	        if (event.which === 13) {
	          txtCostoCalcuSinImpAlter.current.focus();
	        }
	      } else if (event.target.id === "costoCalcuSinImpuAlter") {
	        calcularImpuestosCostosAlter();
	        if (event.which === 13) {
	          txtUltimoCostoSinImpAlter.current.focus();
	        }
	      } else if (event.target.id === "costoUltiSinImpuAlter") {
	        calcularImpuestosCostosAlter();
	        if (event.which === 13) {
	          txtCostoPromeSinImpAlter.current.focus();
	        }
	      } else if (event.target.id === "costoPromeSinImpuAlter") {
	        calcularImpuestosCostosAlter();
	        if (event.which === 13) {
	          txtUtilidadMaxiAlter.current.focus();
	        }
	      } else if (event.target.id === "preciomaximoalter") {
	        calcularUtilidadxValorAlter(1);
	      } else if (event.target.id === "precioofertaalter") {
	        calcularUtilidadxValorAlter(2);
	      } else if (event.target.id === "preciomayoralter") {
	        calcularUtilidadxValorAlter(3);
	      } else if (event.target.id === "preciominialter") {
	        calcularUtilidadxValorAlter(4);
	      } else if (event.target.id === "utilidadMaxiAlter") {
	        calcularUtilidadAlter(1);
	      } else if (event.target.id === "utilidadOfeAlter") {
	        calcularUtilidadAlter(2);
	      } else if (event.target.id === "utilidadMayorAlter") {
	        calcularUtilidadAlter(3);
	      } else if (event.target.id === "utilidadMiniAlter") {
	        calcularUtilidadAlter(4);
	      } else if (event.target.id === "ivaCompra") {
	        calcularImpuestosCostos();
	        if (cmbUniFactor.current.selectedIndex >= 0) {
	          calcularFactorConversion();
	          calcularImpuestosCostosAlter();
	        }
	        if (event.which === 13) {
	          txtIvaVenta.current.focus();
	        }
	      } else if (event.target.id === "ivaVenta") {
	        calcularUtilidadxValor(5);
	        if (cmbUniFactor.current.selectedIndex >= 0) {
	          calcularFactorConversion();
	          calcularImpuestosCostosAlter();
	        }
	        /*         if (event.which === 13 || typeof event.which === "undefined") {
	          if (
	            parseFloat(
	              event.target.value.replace(/\./g, "").replace(",", ".")
	            ) > 0.0
	          ) {
	            chkExento.current.checked = false;
	          } else {
	            chkExento.current.checked = true;
	          }
	        } */
	      } else if (event.target.id === "stockminimo") {
	        txtCostoProveSinImp.current.focus();
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    if (event.which === 13) {
	      if (event.target.id === "inputCodigo") {
	        txtNombre.current.focus();
	      } else if (event.target.id === "inputNombre") {
	        txtReferencia.current.focus();
	      } else if (event.target.id === "inputRefe") {
	        txtNombreCorto.current.focus();
	      } else if (event.target.id === "inputNombreCorto") {
	        cmbTipoProd.current.focus();
	      } else if (event.target.id === "inputDiasGar") {
	        cmbMarca.current.focus();
	      }
	    } else if (typeof event.which === "undefined") {
	      return false;
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var calcularImpuestosCostos = function calcularImpuestosCostos() {
	    var costoProv = 0.0,
	        costoCal = 0.0,
	        costoUlt = 0.0,
	        costoProm = 0.0;
	    var valIva = parseFloat(txtIvaCompra.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	    if (txtCostoProveSinImp.current.value.trim() !== "") {
	      costoProv = (1 + valIva) * parseFloat(txtCostoProveSinImp.current.value.replace(/\./g, "").replace(",", "."));
	      txtCostoProveConImp.current.value = (0, _varios.formatMoneda)(costoProv.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtCostoCalcuSinImp.current.value.trim() !== "") {
	      costoCal = (1 + valIva) * parseFloat(txtCostoCalcuSinImp.current.value.replace(/\./g, "").replace(",", "."));
	      txtCostoCalcuConImp.current.value = (0, _varios.formatMoneda)(costoCal.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtUltimoCostoSinImp.current.value.trim() !== "") {
	      costoUlt = (1 + valIva) * parseFloat(txtUltimoCostoSinImp.current.value.replace(/\./g, "").replace(",", "."));
	      txtUltimoCostoConImp.current.value = (0, _varios.formatMoneda)(costoUlt.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtCostoPromeSinImp.current.value.trim() !== "") {
	      costoProm = (1 + valIva) * parseFloat(txtCostoPromeSinImp.current.value.replace(/\./g, "").replace(",", "."));
	      txtCostoPromeConImp.current.value = (0, _varios.formatMoneda)(costoProm.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    calcularPrecioSinImpuestos();
	  };
	
	  var calcularPrecioSinImpuestos = function calcularPrecioSinImpuestos() {
	    var mon = "0,00";
	
	    if (cmbMetodoCosto.current.value === "1") {
	      mon = txtCostoProveSinImp.current.value;
	    }
	
	    if (cmbMetodoCosto.current.value === "2") {
	      mon = txtCostoCalcuSinImp.current.value;
	    }
	
	    if (cmbMetodoCosto.current.value === "3") {
	      mon = txtUltimoCostoSinImp.current.value;
	    }
	
	    if (cmbMetodoCosto.current.value === "4") {
	      mon = txtCostoPromeSinImp.current.value;
	    }
	
	    txtPrecioMaxiSinImp.current.value = mon;
	    txtPrecioOfeSinImp.current.value = mon;
	    txtPrecioMayorSinImp.current.value = mon;
	    txtPrecioMiniSinImp.current.value = mon;
	
	    calcularUtilidadxValor(5);
	  };
	
	  var calcularPrecioSinImpuestosAlter = function calcularPrecioSinImpuestosAlter() {
	    var mon = "0,00";
	
	    if (cmbMetodoCosto.current.value === "1") {
	      mon = txtCostoProveSinImpAlter.current.value;
	    }
	
	    if (cmbMetodoCosto.current.value === "2") {
	      mon = txtCostoCalcuSinImpAlter.current.value;
	    }
	
	    if (cmbMetodoCosto.current.value === "3") {
	      mon = txtUltimoCostoSinImpAlter.current.value;
	    }
	
	    if (cmbMetodoCosto.current.value === "4") {
	      mon = txtCostoPromeSinImpAlter.current.value;
	    }
	
	    txtPrecioMaxiSinImpAlter.current.value = mon;
	    txtPrecioOfeSinImpAlter.current.value = mon;
	    txtPrecioMayorSinImpAlter.current.value = mon;
	    txtPrecioMiniSinImpAlter.current.value = mon;
	
	    calcularUtilidadxValorAlter(5);
	    calcularImpuestosVentasAlter();
	  };
	
	  var calcularImpuestosVentas = function calcularImpuestosVentas() {
	    var costo = 0.0;
	    var uti = 0.0;
	    var monto = 0.0;
	    var valIva = parseFloat(txtIvaVenta.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	    if (txtPrecioMaxiSinImp.current.value.trim() !== "") {
	      var costoMaxi = costo;
	      if (costoMaxi <= 0.0) {
	        costoMaxi = parseFloat(txtPrecioMaxiSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        monto = (1 + valIva) * costoMaxi;
	      } else {
	        uti = parseFloat(txtUtilidadMaxi.current.value.replace(/\./g, "").replace(",", ".")) * costoMaxi / 100;
	        monto = (1 + valIva) * costoMaxi; //+ uti;
	      }
	
	      txtPrecioMaxiConImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtPrecioOfeSinImp.current.value.trim() !== "") {
	      var costoOfe = costo;
	      if (costoOfe <= 0.0) {
	        costoOfe = parseFloat(txtPrecioOfeSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        monto = (1 + valIva) * costoOfe;
	      } else {
	        uti = parseFloat(txtUtilidadOfe.current.value.replace(/\./g, "").replace(",", ".")) * costoOfe / 100;
	        monto = (1 + valIva) * costoOfe; // + uti;
	      }
	
	      txtPrecioOfeConImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtPrecioMayorSinImp.current.value.trim() !== "") {
	      var costoMayor = costo;
	      if (costoMayor <= 0.0) {
	        costoMayor = parseFloat(txtPrecioMayorSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        monto = (1 + valIva) * costoMayor;
	      } else {
	        uti = parseFloat(txtUtilidadMayor.current.value.replace(/\./g, "").replace(",", ".")) * costoMayor / 100;
	        monto = (1 + valIva) * costoMayor; //+ uti;
	      }
	
	      txtPrecioMayorConImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtPrecioMiniSinImp.current.value.trim() !== "") {
	      var costoMini = costo;
	      if (costoMini <= 0.0) {
	        costoMini = parseFloat(txtPrecioMiniSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        monto = (1 + valIva) * costoMini;
	      } else {
	        uti = parseFloat(txtUtilidadMini.current.value.replace(/\./g, "").replace(",", ".")) * costoMini / 100;
	        monto = (1 + valIva) * costoMini; //+ uti;
	      }
	
	      txtPrecioMiniConImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	
	    if (radioSi.current.checked) {
	      calcularPrecioSinImpuestosAlter();
	    }
	  };
	
	  var calcularUtilidadxValor = function calcularUtilidadxValor(desde) {
	    var mon = 0.0;
	    var mon2 = 0.0;
	    var utiMax = 0.0,
	        utiOfe = 0.0,
	        utiMay = 0.0,
	        utiMin = 0.0;
	    if (cmbMetodoCosto.current.value === "1") {
	      mon = parseFloat(txtCostoProveSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "2") {
	      mon = parseFloat(txtCostoCalcuSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "3") {
	      mon = parseFloat(txtUltimoCostoSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "4") {
	      mon = parseFloat(txtCostoPromeSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    switch (desde) {
	      case 1:
	        mon2 = parseFloat(txtPrecioMaxiSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon2 > 0.0) {
	          if (mon > 0.0) {
	            utiMax = (mon2 - mon) / mon;
	            utiMax = utiMax * 100;
	          } else {
	            utiMax = 100.0;
	          }
	        }
	
	        if (mon > mon2) {
	          txtPrecioMaxiSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMaxiSinImp.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMaxiSinImp.current.value.trim() !== "") {
	          txtUtilidadMaxi.current.value = (0, _varios.formatMoneda)(utiMax.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	        break;
	      case 2:
	        mon2 = parseFloat(txtPrecioOfeSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon2 > 0.0) {
	          if (mon > 0.0) {
	            utiOfe = (mon2 - mon) / mon;
	            utiOfe = utiOfe * 100;
	          } else {
	            utiOfe = 100.0;
	          }
	        }
	
	        if (mon > mon2) {
	          txtPrecioOfeSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioOfeSinImp.current.style.color = "#000000";
	        }
	
	        if (txtPrecioOfeSinImp.current.value.trim() !== "") {
	          txtUtilidadOfe.current.value = (0, _varios.formatMoneda)(utiOfe.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	        break;
	      case 3:
	        mon2 = parseFloat(txtPrecioMayorSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon2 > 0.0) {
	          if (mon > 0.0) {
	            utiMay = (mon2 - mon) / mon;
	            utiMay = utiMay * 100;
	          } else {
	            utiMay = 100.0;
	          }
	        }
	
	        if (mon > mon2) {
	          txtPrecioMayorSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMayorSinImp.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMayorSinImp.current.value.trim() !== "") {
	          txtUtilidadMayor.current.value = (0, _varios.formatMoneda)(utiMay.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	        break;
	      case 4:
	        mon2 = parseFloat(txtPrecioMiniSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon2 > 0.0) {
	          if (mon > 0.0) {
	            utiMin = (mon2 - mon) / mon;
	            utiMin = utiMin * 100;
	          } else {
	            utiMin = 100.0;
	          }
	        }
	
	        if (mon > mon2) {
	          txtPrecioMiniSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMiniSinImp.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMiniSinImp.current.value.trim() !== "") {
	          txtUtilidadMini.current.value = (0, _varios.formatMoneda)(utiMin.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	        break;
	      case 5:
	        mon2 = parseFloat(txtPrecioMaxiSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon > 0.0) {
	          utiMax = (mon2 - mon) / mon;
	          utiMax = utiMax * 100;
	        }
	
	        if (mon > mon2) {
	          txtPrecioMaxiSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMaxiSinImp.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMaxiSinImp.current.value.trim() !== "") {
	          txtUtilidadMaxi.current.value = (0, _varios.formatMoneda)(utiMax.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	
	        mon2 = parseFloat(txtPrecioOfeSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon > 0.0) {
	          utiOfe = (mon2 - mon) / mon;
	          utiOfe = utiOfe * 100;
	        }
	
	        if (mon > mon2) {
	          txtPrecioOfeSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioOfeSinImp.current.style.color = "#000000";
	        }
	
	        if (txtPrecioOfeSinImp.current.value.trim() !== "") {
	          txtUtilidadOfe.current.value = (0, _varios.formatMoneda)(utiOfe.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	
	        mon2 = parseFloat(txtPrecioMayorSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon > 0.0) {
	          utiMay = (mon2 - mon) / mon;
	          utiMay = utiMay * 100;
	        }
	
	        if (mon > mon2) {
	          txtPrecioMayorSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMayorSinImp.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMayorSinImp.current.value.trim() !== "") {
	          txtUtilidadMayor.current.value = (0, _varios.formatMoneda)(utiMay.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	
	        mon2 = parseFloat(txtPrecioMiniSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon > 0.0) {
	          utiMin = (mon2 - mon) / mon;
	          utiMin = utiMin * 100;
	        }
	
	        if (mon > mon2) {
	          txtPrecioMiniSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMiniSinImp.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMiniSinImp.current.value.trim() !== "") {
	          txtUtilidadMini.current.value = (0, _varios.formatMoneda)(utiMin.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	
	        break;
	    }
	    calcularImpuestosVentas();
	  };
	
	  var calcularUtilidadxPorce = function calcularUtilidadxPorce(desde) {
	    var monto = 0.0,
	        valUti = 0.0;
	    var mon = 0.0;
	    if (cmbMetodoCosto.current.value === "1") {
	      mon = parseFloat(txtCostoProveSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "2") {
	      mon = parseFloat(txtCostoCalcuSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "3") {
	      mon = parseFloat(txtUltimoCostoSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "4") {
	      mon = parseFloat(txtCostoPromeSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	    switch (desde) {
	      case 1:
	        valUti = parseFloat(txtUtilidadMaxi.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	        if (mon > 0.0) {
	          monto = (1 + valUti) * mon;
	          txtPrecioMaxiSinImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          //txtUtilidadOfe.current.focus();
	        } else if (parseFloat(txtPrecioMaxiSinImp.current.value.replace(/\./g, "").replace(",", ".")) <= 0.0) {
	          txtUtilidadMaxi.current.value = "0,00";
	          txtPrecioMaxiSinImp.current.focus();
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Precio Maximo no puede ser 0,00.",
	            icono: "informacion"
	          });
	        } else {
	          txtUtilidadMaxi.current.value = "100,00";
	          //txtUtilidadOfe.current.focus();
	        }
	
	        if (mon > monto) {
	          txtPrecioMaxiSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMaxiSinImp.current.style.color = "#000000";
	        }
	
	        break;
	      case 2:
	        valUti = parseFloat(txtUtilidadOfe.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	        if (mon > 0.0) {
	          monto = (1 + valUti) * mon;
	          txtPrecioOfeSinImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          //txtUtilidadMayor.current.focus();
	        } else if (parseFloat(txtPrecioOfeSinImp.current.value.replace(/\./g, "").replace(",", ".")) <= 0.0) {
	          txtUtilidadOfe.current.value = "0,00";
	          txtPrecioOfeSinImp.current.focus();
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Precio Oferta no puede ser 0,00.",
	            icono: "informacion"
	          });
	        } else {
	          txtUtilidadOfe.current.value = "100,00";
	          //txtUtilidadMayor.current.focus();
	        }
	
	        if (mon > monto) {
	          txtPrecioOfeSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioOfeSinImp.current.style.color = "#000000";
	        }
	
	        break;
	      case 3:
	        valUti = parseFloat(txtUtilidadMayor.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	        if (mon > 0.0) {
	          monto = (1 + valUti) * mon;
	          txtPrecioMayorSinImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          //txtUtilidadMini.current.focus();
	        } else if (parseFloat(txtPrecioMayorSinImp.current.value.replace(/\./g, "").replace(",", ".")) <= 0.0) {
	          txtUtilidadMayor.current.value = "0,00";
	          txtPrecioMayorSinImp.current.focus();
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Precio Mayor no puede ser 0,00.",
	            icono: "informacion"
	          });
	        } else {
	          txtUtilidadMayor.current.value = "100,00";
	          //txtUtilidadMini.current.focus();
	        }
	
	        if (mon > monto) {
	          txtPrecioMayorSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMayorSinImp.current.style.color = "#000000";
	        }
	
	        break;
	      case 4:
	        valUti = parseFloat(txtUtilidadMini.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	        if (mon > 0.0) {
	          monto = (1 + valUti) * mon;
	          txtPrecioMiniSinImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          //radioNo.current.focus();
	        } else if (parseFloat(txtPrecioMiniSinImp.current.value.replace(/\./g, "").replace(",", ".")) <= 0.0) {
	          txtUtilidadMini.current.value = "0,00";
	          txtPrecioMiniSinImp.current.focus();
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Precio Minimo no puede ser 0,00.",
	            icono: "informacion"
	          });
	        } else {
	          txtUtilidadMini.current.value = "100,00";
	          // radioNo.current.focus();
	        }
	
	        if (mon > monto) {
	          txtPrecioMiniSinImp.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMiniSinImp.current.style.color = "#000000";
	        }
	
	        break;
	      case 5:
	        if (mon > 0.0) {
	          valUti = parseFloat(txtUtilidadMaxi.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	          if (txtPrecioMaxiSinImp.current.value.trim() !== "") {
	            monto = (1 + valUti) * mon;
	            txtPrecioMaxiSinImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          }
	          valUti = parseFloat(txtUtilidadOfe.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	          if (txtPrecioOfeSinImp.current.value.trim() !== "") {
	            monto = (1 + valUti) * mon;
	            txtPrecioOfeSinImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          }
	          valUti = parseFloat(txtUtilidadMayor.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	          if (txtPrecioMayorSinImp.current.value.trim() !== "") {
	            monto = (1 + valUti) * mon;
	            txtPrecioMayorSinImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          }
	          valUti = parseFloat(txtUtilidadMini.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	          if (txtPrecioMiniSinImp.current.value.trim() !== "") {
	            monto = (1 + valUti) * mon;
	            txtPrecioMiniSinImp.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          }
	        }
	
	        break;
	    }
	
	    calcularImpuestosVentas();
	  };
	
	  var calcularFactorConversion = function calcularFactorConversion() {
	    var unifactor = cmbUniFactor.current.selectedIndex;
	    var precio = 0.0,
	        costoProv = 0.0,
	        costoCal = 0.0,
	        costoUlt = 0.0,
	        costoProm = 0.0;
	    var valor = parseFloat(txtFactor.current.value.replace(/\./g, "").replace(",", "."));
	    var mon = 0.0;
	
	    if (cmbMetodoCosto.current.value === "1") {
	      mon = parseFloat(txtCostoProveConImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "2") {
	      mon = parseFloat(txtCostoCalcuConImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "3") {
	      mon = parseFloat(txtUltimoCostoConImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "4") {
	      mon = parseFloat(txtCostoPromeConImp.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    costoProv = parseFloat(txtCostoProveSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    costoCal = parseFloat(txtCostoCalcuSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    costoUlt = parseFloat(txtUltimoCostoSinImp.current.value.replace(/\./g, "").replace(",", "."));
	    costoProm = parseFloat(txtCostoPromeSinImp.current.value.replace(/\./g, "").replace(",", "."));
	
	    if (unifactor === 0) {
	      precio = mon * valor;
	      costoProv = costoProv * valor;
	      costoCal = costoCal * valor;
	      costoUlt = costoUlt * valor;
	      costoProm = costoProm * valor;
	    } else {
	      precio = mon / valor;
	      costoProv = costoProv / valor;
	      costoCal = costoCal / valor;
	      costoUlt = costoUlt / valor;
	      costoProm = costoProm / valor;
	    }
	
	    if (mon > 0.0) {
	      txtCostoProveSinImpAlter.current.value = (0, _varios.formatMoneda)(costoProv.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	      txtCostoCalcuSinImpAlter.current.value = (0, _varios.formatMoneda)(costoCal.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	      txtUltimoCostoSinImpAlter.current.value = (0, _varios.formatMoneda)(costoUlt.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	      txtCostoPromeSinImpAlter.current.value = (0, _varios.formatMoneda)(costoProm.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	      txtPrecioMaxiSinImpAlter.current.value = (0, _varios.formatMoneda)(precio.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	      txtPrecioOfeSinImpAlter.current.value = (0, _varios.formatMoneda)(precio.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	      txtPrecioMayorSinImpAlter.current.value = (0, _varios.formatMoneda)(precio.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	      txtPrecioMiniSinImpAlter.current.value = (0, _varios.formatMoneda)(precio.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	
	    calcularImpuestosCostosAlter();
	  };
	
	  var calcularImpuestosCostosAlter = function calcularImpuestosCostosAlter() {
	    var costoProv = 0.0,
	        costoCal = 0.0,
	        costoUlt = 0.0,
	        costoProm = 0.0;
	    var valIva = parseFloat(txtIvaCompra.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	    if (txtCostoProveSinImpAlter.current.value.trim() !== "") {
	      costoProv = (1 + valIva) * parseFloat(txtCostoProveSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	      txtCostoProveConImpAlter.current.value = (0, _varios.formatMoneda)(costoProv.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtCostoCalcuSinImpAlter.current.value.trim() !== "") {
	      costoCal = (1 + valIva) * parseFloat(txtCostoCalcuSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	      txtCostoCalcuConImpAlter.current.value = (0, _varios.formatMoneda)(costoCal.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtUltimoCostoSinImpAlter.current.value.trim() !== "") {
	      costoUlt = (1 + valIva) * parseFloat(txtUltimoCostoSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	      txtUltimoCostoConImpAlter.current.value = (0, _varios.formatMoneda)(costoUlt.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtCostoPromeSinImpAlter.current.value.trim() !== "") {
	      costoProm = (1 + valIva) * parseFloat(txtCostoPromeSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	      txtCostoPromeConImpAlter.current.value = (0, _varios.formatMoneda)(costoProm.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    calcularPrecioSinImpuestosAlter();
	  };
	
	  var calcularImpuestosVentasAlter = function calcularImpuestosVentasAlter() {
	    var costo = 0.0;
	    var uti = 0.0;
	    var monto = 0.0;
	    var valIva = parseFloat(txtIvaVenta.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	    /*     if (cmbMetodoCosto.current.value === "1") {
	      costo = parseFloat(
	        txtCostoProveConImpAlter.current.value
	          .replace(/\./g, "")
	          .replace(",", ".")
	      );
	    }
	     if (cmbMetodoCosto.current.value === "2") {
	      costo = parseFloat(
	        txtCostoCalcuConImpAlter.current.value
	          .replace(/\./g, "")
	          .replace(",", ".")
	      );
	    }
	     if (cmbMetodoCosto.current.value === "3") {
	      costo = parseFloat(
	        txtUltimoCostoConImpAlter.current.value
	          .replace(/\./g, "")
	          .replace(",", ".")
	      );
	    }
	     if (cmbMetodoCosto.current.value === "4") {
	      costo = parseFloat(
	        txtCostoPromeConImpAlter.current.value
	          .replace(/\./g, "")
	          .replace(",", ".")
	      );
	    } */
	
	    if (txtPrecioMaxiSinImpAlter.current.value.trim() !== "") {
	      var costoMaxi = costo;
	      if (costoMaxi <= 0.0) {
	        costoMaxi = parseFloat(txtPrecioMaxiSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        monto = (1 + valIva) * costoMaxi;
	      } else {
	        uti = parseFloat(txtUtilidadMaxiAlter.current.value.replace(/\./g, "").replace(",", ".")) * costoMaxi / 100;
	        monto = (1 + valIva) * costoMaxi + uti;
	      }
	
	      txtPrecioMaxiConImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtPrecioOfeSinImpAlter.current.value.trim() !== "") {
	      var costoOfe = costo;
	      if (costoOfe <= 0.0) {
	        costoOfe = parseFloat(txtPrecioOfeSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        monto = (1 + valIva) * costoOfe;
	      } else {
	        uti = parseFloat(txtUtilidadOfeAlter.current.value.replace(/\./g, "").replace(",", ".")) * costoOfe / 100;
	        monto = (1 + valIva) * costoOfe + uti;
	      }
	
	      txtPrecioOfeConImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtPrecioMayorSinImpAlter.current.value.trim() !== "") {
	      var costoMayor = costo;
	      if (costoMayor <= 0.0) {
	        costoMayor = parseFloat(txtPrecioMayorSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        monto = (1 + valIva) * costoMayor;
	      } else {
	        uti = parseFloat(txtUtilidadMayorAlter.current.value.replace(/\./g, "").replace(",", ".")) * costoMayor / 100;
	        monto = (1 + valIva) * costoMayor + uti;
	      }
	
	      txtPrecioMayorConImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	    if (txtPrecioMiniSinImpAlter.current.value.trim() !== "") {
	      var costoMini = costo;
	      if (costoMini <= 0.0) {
	        costoMini = parseFloat(txtPrecioMiniSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        monto = (1 + valIva) * costoMini;
	      } else {
	        uti = parseFloat(txtUtilidadMiniAlter.current.value.replace(/\./g, "").replace(",", ".")) * costoMini / 100;
	        monto = (1 + valIva) * costoMini + uti;
	      }
	
	      txtPrecioMiniConImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    }
	  };
	
	  var calcularUtilidadAlter = function calcularUtilidadAlter(desde) {
	    var monto = 0.0,
	        valUti = 0.0;
	    var mon = 0.0;
	    if (cmbMetodoCosto.current.value === "1") {
	      mon = parseFloat(txtCostoProveSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "2") {
	      mon = parseFloat(txtCostoCalcuSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "3") {
	      mon = parseFloat(txtUltimoCostoSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "4") {
	      mon = parseFloat(txtCostoPromeSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	    }
	    switch (desde) {
	      case 1:
	        valUti = parseFloat(txtUtilidadMaxiAlter.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	        if (mon > 0.0) {
	          monto = (1 + valUti) * mon;
	          txtPrecioMaxiSinImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          //txtUtilidadOfe.current.focus();
	        } else if (parseFloat(txtPrecioMaxiSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) <= 0.0) {
	          txtUtilidadMaxiAlter.current.value = "0,00";
	          txtPrecioMaxiSinImpAlter.current.focus();
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Precio Maximo no puede ser 0,00.",
	            icono: "informacion"
	          });
	        } else {
	          txtUtilidadMaxiAlter.current.value = "100,00";
	          //txtUtilidadOfe.current.focus();
	        }
	
	        if (mon > monto) {
	          txtPrecioMaxiSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMaxiSinImpAlter.current.style.color = "#000000";
	        }
	
	        break;
	      case 2:
	        valUti = parseFloat(txtUtilidadOfeAlter.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	        if (mon > 0.0) {
	          monto = (1 + valUti) * mon;
	          txtPrecioOfeSinImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          //txtUtilidadMayor.current.focus();
	        } else if (parseFloat(txtPrecioOfeSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) <= 0.0) {
	          txtUtilidadOfeAlter.current.value = "0,00";
	          txtPrecioOfeSinImpAlter.current.focus();
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Precio Oferta no puede ser 0,00.",
	            icono: "informacion"
	          });
	        } else {
	          txtUtilidadOfeAlter.current.value = "100,00";
	          //txtUtilidadMayor.current.focus();
	        }
	
	        if (mon > monto) {
	          txtPrecioOfeSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioOfeSinImpAlter.current.style.color = "#000000";
	        }
	
	        break;
	      case 3:
	        valUti = parseFloat(txtUtilidadMayorAlter.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	        if (mon > 0.0) {
	          monto = (1 + valUti) * mon;
	          txtPrecioMayorSinImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          //txtUtilidadMini.current.focus();
	        } else if (parseFloat(txtPrecioMayorSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) <= 0.0) {
	          txtUtilidadMayorAlter.current.value = "0,00";
	          txtPrecioMayorSinImpAlter.current.focus();
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Precio Mayor no puede ser 0,00.",
	            icono: "informacion"
	          });
	        } else {
	          txtUtilidadMayorAlter.current.value = "100,00";
	          //txtUtilidadMini.current.focus();
	        }
	
	        if (mon > monto) {
	          txtPrecioMayorSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMayorSinImpAlter.current.style.color = "#000000";
	        }
	
	        break;
	      case 4:
	        valUti = parseFloat(txtUtilidadMiniAlter.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	
	        if (mon > 0.0) {
	          monto = (1 + valUti) * mon;
	          txtPrecioMiniSinImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          //radioNo.current.focus();
	        } else if (parseFloat(txtPrecioMiniSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) <= 0.0) {
	          txtUtilidadMiniAlter.current.value = "0,00";
	          txtPrecioMiniSinImpAlter.current.focus();
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Precio Minimo no puede ser 0,00.",
	            icono: "informacion"
	          });
	        } else {
	          txtUtilidadMiniAlter.current.value = "100,00";
	          // radioNo.current.focus();
	        }
	
	        if (mon > monto) {
	          txtPrecioMiniSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMiniSinImpAlter.current.style.color = "#000000";
	        }
	
	        break;
	      case 5:
	        if (mon > 0.0) {
	          valUti = parseFloat(txtUtilidadMaxiAlter.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	          var precioStr = txtPrecioMaxiSinImp.current.value.replace(",", ".");
	          var factorStr = txtFactor.current.value.replace(",", ".");
	
	          var precio = Number(precioStr);
	          var _factor = Number(factorStr);
	          if (txtPrecioMaxiSinImpAlter.current.value.trim() !== "") {
	            monto = precio / _factor;
	            txtPrecioMaxiSinImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          }
	          valUti = parseFloat(txtUtilidadOfeAlter.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	          if (txtPrecioOfeSinImpAlter.current.value.trim() !== "") {
	            monto = (1 + valUti) * mon;
	            txtPrecioOfeSinImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          }
	          valUti = parseFloat(txtUtilidadMayorAlter.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	          if (txtPrecioMayorSinImpAlter.current.value.trim() !== "") {
	            monto = (1 + valUti) * mon;
	            txtPrecioMayorSinImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          }
	          valUti = parseFloat(txtUtilidadMiniAlter.current.value.replace(/\./g, "").replace(",", ".")) / 100;
	          if (txtPrecioMiniSinImpAlter.current.value.trim() !== "") {
	            monto = (1 + valUti) * mon;
	            txtPrecioMiniSinImpAlter.current.value = (0, _varios.formatMoneda)(monto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          }
	        }
	
	        break;
	    }
	
	    calcularImpuestosVentasAlter();
	  };
	
	  var calcularUtilidadxValorAlter = function calcularUtilidadxValorAlter(desde) {
	    var mon = 0.0;
	    if (cmbMetodoCosto.current.value === "1") {
	      mon = parseFloat(txtCostoProveSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "2") {
	      mon = parseFloat(txtCostoCalcuSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "3") {
	      mon = parseFloat(txtUltimoCostoSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    if (cmbMetodoCosto.current.value === "4") {
	      mon = parseFloat(txtCostoPromeSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	    }
	
	    var mon2 = 0.0;
	    var mon3 = 0.0;
	
	    switch (desde) {
	      case 1:
	        mon2 = parseFloat(txtPrecioMaxiSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon2 > 0.0) {
	          if (mon > 0.0) {
	            mon3 = (mon2 - mon) / mon;
	            mon3 = mon3 * 100;
	          } else {
	            mon3 = 100.0;
	          }
	        }
	
	        if (mon > mon2) {
	          txtPrecioMaxiSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMaxiSinImpAlter.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMaxiSinImpAlter.current.value.trim() !== "") {
	          txtUtilidadMaxiAlter.current.value = (0, _varios.formatMoneda)(mon3.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	        break;
	      case 2:
	        mon2 = parseFloat(txtPrecioOfeSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon2 > 0.0) {
	          if (mon > 0.0) {
	            mon3 = (mon2 - mon) / mon;
	            mon3 = mon3 * 100;
	          } else {
	            mon3 = 100.0;
	          }
	        }
	
	        if (mon > mon2) {
	          txtPrecioOfeSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioOfeSinImpAlter.current.style.color = "#000000";
	        }
	
	        if (txtPrecioOfeSinImpAlter.current.value.trim() !== "") {
	          txtUtilidadOfeAlter.current.value = (0, _varios.formatMoneda)(mon3.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	        break;
	      case 3:
	        mon2 = parseFloat(txtPrecioMayorSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon2 > 0.0) {
	          if (mon > 0.0) {
	            mon3 = (mon2 - mon) / mon;
	            mon3 = mon3 * 100;
	          } else {
	            mon3 = 100.0;
	          }
	        }
	
	        if (mon > mon2) {
	          txtPrecioMayorSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMayorSinImpAlter.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMayorSinImpAlter.current.value.trim() !== "") {
	          txtUtilidadMayorAlter.current.value = (0, _varios.formatMoneda)(mon3.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	        break;
	      case 4:
	        mon2 = parseFloat(txtPrecioMiniSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon2 > 0.0) {
	          if (mon > 0.0) {
	            mon3 = (mon2 - mon) / mon;
	            mon3 = mon3 * 100;
	          } else {
	            mon3 = 100.0;
	          }
	        }
	
	        if (mon > mon2) {
	          txtPrecioMiniSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMiniSinImpAlter.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMiniSinImpAlter.current.value.trim() !== "") {
	          txtUtilidadMiniAlter.current.value = (0, _varios.formatMoneda)(mon3.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	        break;
	      case 5:
	        mon2 = parseFloat(txtPrecioMaxiSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon > 0.0) {
	          mon3 = (mon2 - mon) / mon;
	          mon3 = mon3 * 100;
	        }
	
	        if (mon > mon2) {
	          txtPrecioMaxiSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMaxiSinImpAlter.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMaxiSinImpAlter.current.value.trim() !== "") {
	          txtUtilidadMaxiAlter.current.value = (0, _varios.formatMoneda)(mon3.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	
	        mon2 = parseFloat(txtPrecioOfeSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon > 0.0) {
	          mon3 = (mon2 - mon) / mon;
	          mon3 = mon3 * 100;
	        }
	
	        if (mon > mon2) {
	          txtPrecioOfeSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioOfeSinImpAlter.current.style.color = "#000000";
	        }
	
	        if (txtPrecioOfeSinImpAlter.current.value.trim() !== "") {
	          txtUtilidadOfeAlter.current.value = (0, _varios.formatMoneda)(mon3.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	
	        mon2 = parseFloat(txtPrecioMayorSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon > 0.0) {
	          mon3 = (mon2 - mon) / mon;
	          mon3 = mon3 * 100;
	        }
	
	        if (mon > mon2) {
	          txtPrecioMayorSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMayorSinImpAlter.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMayorSinImpAlter.current.value.trim() !== "") {
	          txtUtilidadMayorAlter.current.value = (0, _varios.formatMoneda)(mon3.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	
	        mon2 = parseFloat(txtPrecioMiniSinImpAlter.current.value.replace(/\./g, "").replace(",", "."));
	
	        if (mon > 0.0) {
	          mon3 = (mon2 - mon) / mon;
	          mon3 = mon3 * 100;
	        }
	
	        if (mon > mon2) {
	          txtPrecioMiniSinImpAlter.current.style.color = "#FB0000";
	        } else {
	          txtPrecioMiniSinImpAlter.current.style.color = "#000000";
	        }
	
	        if (txtPrecioMiniSinImpAlter.current.value.trim() !== "") {
	          txtUtilidadMiniAlter.current.value = (0, _varios.formatMoneda)(mon3.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	
	        break;
	    }
	
	    calcularImpuestosVentasAlter();
	  };
	
	  var unidadAlterna = function unidadAlterna(event) {
	    if (radioSi.current.checked) {
	      setTabIndex({ tab1: "tab", tab2: "tab" });
	      setACtiveTab({
	        tab1: "nav-link text-light bg-blue-100 rounded",
	        tab2: "nav-link active text-light bg-blue-200 rounded"
	      });
	      setTabValid({ tab1: "false", tab2: "true" });
	      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
	      setHabilitadoAlter(true);
	      txtCostoProveSinImpAlter.current.value = "0,00";
	      txtCostoCalcuSinImpAlter.current.value = "0,00";
	      txtUltimoCostoSinImpAlter.current.value = "0,00";
	      txtCostoPromeSinImpAlter.current.value = "0,00";
	      txtCostoProveConImpAlter.current.value = "0,00";
	      txtCostoCalcuConImpAlter.current.value = "0,00";
	      txtUltimoCostoConImpAlter.current.value = "0,00";
	      txtCostoPromeConImpAlter.current.value = "0,00";
	      txtPrecioMaxiSinImpAlter.current.value = "0,00";
	      txtPrecioOfeSinImpAlter.current.value = "0,00";
	      txtPrecioMayorSinImpAlter.current.value = "0,00";
	      txtPrecioMiniSinImpAlter.current.value = "0,00";
	      txtPrecioMaxiConImpAlter.current.value = "0,00";
	      txtPrecioOfeConImpAlter.current.value = "0,00";
	      txtPrecioMayorConImpAlter.current.value = "0,00";
	      txtPrecioMiniConImpAlter.current.value = "0,00";
	      txtUtilidadMaxiAlter.current.value = "0,00";
	      txtUtilidadOfeAlter.current.value = "0,00";
	      txtUtilidadMayorAlter.current.value = "0,00";
	      txtUtilidadMiniAlter.current.value = "0,00";
	      txtFactor.current.value = "1,00";
	      cmbUniPrincipal.current.value = cmbUnidMedida.current.value;
	      cmbUniPrincipal.current.focus();
	    } else {
	      setTabIndex({ tab1: "tab", tab2: "" });
	      setHabilitadoAlter(false);
	      blanquearAlter();
	    }
	  };
	
	  var manesillas = function manesillas(stock, existencia) {
	    if (existencia === undefined) {}
	
	    if (stock === undefined) {
	      setCantidadProd(0);
	    } else {
	      var array = [0];
	      var n = parseFloat(stock) * 4;
	      var n1 = 0;
	      var n2 = 0;
	      if (parseFloat(existencia) > parseFloat(n)) {
	        n1 = parseFloat(existencia) / 10;
	        for (var i = 0; i < 12; i++) {
	          n2 = n2 + n1;
	          array.push(parseFloat(n2.toFixed(2)));
	        }
	      } else {
	        n1 = n / 10;
	        for (var _i = 0; _i < 10; _i++) {
	          n2 = n2 + n1;
	          array.push(parseFloat(n2.toFixed(2)));
	        }
	      }
	
	      setFlujo(array);
	    }
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "codigo") {
	      e.target.value = e.target.value.toUpperCase();
	    } else if (e.target.name === "unidadP" || e.target.name === "unidadA" || e.target.name === "idunidadmedida") {
	      if (cmbUniPrincipal.current.selectedIndex >= 0) {
	        var unic = [];
	        var univ = [];
	        setUnidadC([]);
	        setUnidadV([]);
	        if (e.target.name === "idunidadmedida") {
	          cmbUniPrincipal.current.selectedIndex = cmbUnidMedida.current.selectedIndex;
	        } else {
	          cmbUnidMedida.current.selectedIndex = cmbUniPrincipal.current.selectedIndex;
	        }
	
	        unic.push({
	          idunidadmedida: cmbUniPrincipal.current.value,
	          descripcion: cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex].text
	        });
	
	        univ.push({
	          idunidadmedida: cmbUniPrincipal.current.value,
	          descripcion: cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex].text
	        });
	
	        if (cmbUniAlterna.current.selectedIndex >= 0) {
	          unic.push({
	            idunidadmedida: cmbUniAlterna.current.value,
	            descripcion: cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text
	          });
	
	          univ.push({
	            idunidadmedida: cmbUniAlterna.current.value,
	            descripcion: cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text
	          });
	
	          var uni = [];
	          uni.push({
	            iduni: "0",
	            descripcion: cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex].text + "X" + cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text
	          });
	          uni.push({
	            iduni: "1",
	            descripcion: cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text + "X" + cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex].text
	          });
	          setFactor(uni);
	          cmbUniFactor.current.selectedIndex = -1;
	        }
	        setUnidadC(unic);
	        setUnidadV(univ);
	        cmbUniVenta.current.selectedIndex = -1;
	        cmbUniCompra.current.selectedIndex = -1;
	      }
	    } else if (e.target.name === "almacen") {
	      if (e.target.value === "true") {
	        setVisibleA("visible");
	        txtStockMini.current.value = "0,00";
	      } else {
	        setVisibleA("hidden");
	        txtStockMini.current.value = "0,00";
	      }
	      /*       if (e.target.checked === true) {
	        setVisibleA("visible");
	        txtStockMini.current.value = "0,00";
	      } else {
	        setVisibleA("hidden");
	        txtStockMini.current.value = "0,00";
	      } */
	    } else if (e.target.name === "unifactor") {
	      calcularFactorConversion();
	      // calcularImpuestosCostosAlter();
	      // calcularUtilidadAlter(5);
	      // calcularImpuestosVentasAlter();
	    } else if (e.target.name === "metodocosto") {
	      setCostoSelect(e.target.value);
	      calcularPrecioSinImpuestos();
	    } else if (e.target.id === "chekvacio") {
	      if (e.target.checked === true) {
	        setValvacio(1);
	        seleccionarClassVacios(2);
	      } else {
	        setValvacio(0);
	        if (txtCodigoVacio.current) {
	          txtCodigoVacio.current.value = "";
	        }
	      }
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	
	    if (txtIdproducto.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Id no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtIdproducto.current.focus();
	    } /*  else if (txtCodigo.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El código no debe estar vacio",
	        icono: "informacion",
	      });
	      sigue = false;
	      txtCodigo.current.focus();
	      } */else if (txtNombre.current.value.trim() === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Por Favor Introduzca la Descripción",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtNombre.current.focus();
	      } else if (txtNombreCorto.current.value.trim() === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "El Nombre Corto no deben estar Vacio",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtNombreCorto.current.focus();
	      } else if (cmbTipoProd.current.value.trim() === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "El Tipo de Producto o Servicio no deben estar Vacio",
	          icono: "informacion"
	        });
	        sigue = false;
	        cmbTipoProd.current.focus();
	      } else if (cmbFabricante.current.value.trim() === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Seleccione el Fabricante del Producto",
	          icono: "informacion"
	        });
	        sigue = false;
	        cmbFabricante.current.focus();
	      } else if (cmbUnidMedida.current.value.trim() === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "La Unidad de Medida no debe estar vacia",
	          icono: "informacion"
	        });
	        sigue = false;
	        cmbUnidMedida.current.focus();
	      } else if (txtIvaCompra.current.value.trim() === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "El % de Iva Para la Compra no deben estar Vacio",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtIvaCompra.current.focus();
	      } else if (txtIvaVenta.current.value.trim() === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "El % de Iva Para la Venta no deben estar Vacio",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtIvaVenta.current.focus();
	      } else if (cmbPrecioVenta.current.value.trim() === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "El Tipo de precio de venta no debe estar vacio",
	          icono: "informacion"
	        });
	        sigue = false;
	        cmbPrecioVenta.current.focus();
	      } /*  else if (txtCodigo.current.value.trim() === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Por favor Seleccione el Representante Legal",
	          icono: "informacion",
	        });
	        sigue = false;
	        txtCodigo.current.value = "";
	        txtCodigo.current.focus();
	        } */else if (cmbAlmacen.current.value === "true" && txtStockMini.current.value.trim() === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Stock Minimo no debe estar vacio",
	            icono: "informacion"
	          });
	          sigue = false;
	          txtStockMini.current.focus();
	        } else if (cmbAlmacen.current.value === "true" && txtStockMini.current.value.trim() === "0,00") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Stock Minimo debe ser mayor a Cero(0)",
	            icono: "informacion"
	          });
	          sigue = false;
	          txtStockMini.current.focus();
	        } else if (cmbMetodoCosto.current.value.trim() === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Metodo de costo no debe estar vacio",
	            icono: "informacion"
	          });
	          sigue = false;
	          cmbMetodoCosto.current.focus();
	        } else if (txtCostoProveSinImp.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Costo del Proveedoor no debe estar vacio",
	            icono: "informacion"
	          });
	          sigue = false;
	          txtCostoProveSinImp.current.focus();
	        } else if (txtCostoCalcuSinImp.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Costo Calculado no debe estar vacio",
	            icono: "informacion"
	          });
	          sigue = false;
	          txtCostoCalcuSinImp.current.focus();
	        } else if (txtUltimoCostoSinImp.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Ùltimo Costo no debe estar vacio",
	            icono: "informacion"
	          });
	          sigue = false;
	          txtUltimoCostoSinImp.current.focus();
	        } else if (txtCostoPromeSinImp.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Costo Promedio no debe estar vacio",
	            icono: "informacion"
	          });
	          sigue = false;
	          txtCostoPromeSinImp.current.focus();
	        } else if (txtUtilidadMaxi.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "La Utilidad del Precio Maximo no debe estar vacia",
	            icono: "informacion"
	          });
	          sigue = false;
	          txtUtilidadMaxi.current.focus();
	        } else if (txtUtilidadOfe.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "La Utilidad del Precio Oferta no debe estar vacia",
	            icono: "informacion"
	          });
	          sigue = false;
	          txtUtilidadOfe.current.focus();
	        } else if (txtUtilidadMayor.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "La Utilidad del Precio al Mayor no debe estar vacia",
	            icono: "informacion"
	          });
	          sigue = false;
	          txtUtilidadMayor.current.focus();
	        } else if (txtUtilidadMini.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "La Utilidad del Precio Minimo no debe estar vacia",
	            icono: "informacion"
	          });
	          sigue = false;
	          txtUtilidadMini.current.focus();
	        } else if (radioSi.current.checked) {
	          if (cmbUniAlterna.current.value.trim() === "") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La Unidad de Medida Alterna no debe estar vacia",
	              icono: "informacion"
	            });
	            sigue = false;
	            setTabIndex({ tab1: "tab", tab2: "tab" });
	            setACtiveTab({
	              tab1: "nav-link text-light bg-blue-100 rounded",
	              tab2: "nav-link active text-light bg-blue-200 rounded"
	            });
	            setTabValid({ tab1: "false", tab2: "true" });
	            setTabPanel({
	              tab1: "tab-pane fade",
	              tab2: "tab-pane fade show active"
	            });
	            cmbUniAlterna.current.focus();
	          } else if (cmbUniVenta.current.value.trim() === "") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La Unidad de Venta no debe estar vacia",
	              icono: "informacion"
	            });
	            sigue = false;
	            setTabIndex({ tab1: "tab", tab2: "tab" });
	            setACtiveTab({
	              tab1: "nav-link text-light bg-blue-100 rounded",
	              tab2: "nav-link active text-light bg-blue-200 rounded"
	            });
	            setTabValid({ tab1: "false", tab2: "true" });
	            setTabPanel({
	              tab1: "tab-pane fade",
	              tab2: "tab-pane fade show active"
	            });
	            cmbUniVenta.current.focus();
	          } else if (cmbUniCompra.current.value.trim() === "") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La Unidad de Compra no debe estar vacia",
	              icono: "informacion"
	            });
	            sigue = false;
	            setTabIndex({ tab1: "tab", tab2: "tab" });
	            setACtiveTab({
	              tab1: "nav-link text-light bg-blue-100 rounded",
	              tab2: "nav-link active text-light bg-blue-200 rounded"
	            });
	            setTabValid({ tab1: "false", tab2: "true" });
	            setTabPanel({
	              tab1: "tab-pane fade",
	              tab2: "tab-pane fade show active"
	            });
	            cmbUniCompra.current.focus();
	          } else if (txtFactor.current.value.trim() === "" || txtFactor.current.value.trim() === "0.00") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "El Factor de Conversion no deben estar Vacio ni ser cero(0,00)",
	              icono: "informacion"
	            });
	            sigue = false;
	            setTabIndex({ tab1: "tab", tab2: "tab" });
	            setACtiveTab({
	              tab1: "nav-link text-light bg-blue-100 rounded",
	              tab2: "nav-link active text-light bg-blue-200 rounded"
	            });
	            setTabValid({ tab1: "false", tab2: "true" });
	            setTabPanel({
	              tab1: "tab-pane fade",
	              tab2: "tab-pane fade show active"
	            });
	            txtFactor.current.focus();
	          } else if (cmbUniFactor.current.value.trim() === "") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La Unidad del Factor de Conversion no debe estar vacia",
	              icono: "informacion"
	            });
	            sigue = false;
	            setTabIndex({ tab1: "tab", tab2: "tab" });
	            setACtiveTab({
	              tab1: "nav-link text-light bg-blue-100 rounded",
	              tab2: "nav-link active text-light bg-blue-200 rounded"
	            });
	            setTabValid({ tab1: "false", tab2: "true" });
	            setTabPanel({
	              tab1: "tab-pane fade",
	              tab2: "tab-pane fade show active"
	            });
	            cmbUniFactor.current.focus();
	          } else if (txtCostoProveSinImpAlter.current.value === "0,00" || txtCostoProveSinImpAlter.current.value === "") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "El Costo del Proveedoor de la Unidad Alterna no debe estar vacio ni ser cero (0,00)",
	              icono: "informacion"
	            });
	            sigue = false;
	            setTabIndex({ tab1: "tab", tab2: "tab" });
	            setACtiveTab({
	              tab1: "nav-link text-light bg-blue-100 rounded",
	              tab2: "nav-link active text-light bg-blue-200 rounded"
	            });
	            setTabValid({ tab1: "false", tab2: "true" });
	            setTabPanel({
	              tab1: "tab-pane fade",
	              tab2: "tab-pane fade show active"
	            });
	            txtCostoProveSinImpAlter.current.focus();
	          } else if (txtCostoCalcuSinImpAlter.current.value === "") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "El Costo Calculado de la Unidad Alterna no debe estar vacio",
	              icono: "informacion"
	            });
	            sigue = false;
	            setTabIndex({ tab1: "tab", tab2: "tab" });
	            setACtiveTab({
	              tab1: "nav-link text-light bg-blue-100 rounded",
	              tab2: "nav-link active text-light bg-blue-200 rounded"
	            });
	            setTabValid({ tab1: "false", tab2: "true" });
	            setTabPanel({
	              tab1: "tab-pane fade",
	              tab2: "tab-pane fade show active"
	            });
	            txtCostoCalcuSinImpAlter.current.focus();
	          } else if (txtUltimoCostoSinImpAlter.current.value === "") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "El Ùltimo Costo de la Unidad Alterna no debe estar vacio",
	              icono: "informacion"
	            });
	            sigue = false;
	            setTabIndex({ tab1: "tab", tab2: "tab" });
	            setACtiveTab({
	              tab1: "nav-link text-light bg-blue-100 rounded",
	              tab2: "nav-link active text-light bg-blue-200 rounded"
	            });
	            setTabValid({ tab1: "false", tab2: "true" });
	            setTabPanel({
	              tab1: "tab-pane fade",
	              tab2: "tab-pane fade show active"
	            });
	            txtUltimoCostoSinImpAlter.current.focus();
	          } else if (txtCostoPromeSinImpAlter.current.value === "") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "El Costo Promedio de la Unidad Alterna no debe estar vacio",
	              icono: "informacion"
	            });
	            sigue = false;
	            setTabIndex({ tab1: "tab", tab2: "tab" });
	            setACtiveTab({
	              tab1: "nav-link text-light bg-blue-100 rounded",
	              tab2: "nav-link active text-light bg-blue-200 rounded"
	            });
	            setTabValid({ tab1: "false", tab2: "true" });
	            setTabPanel({
	              tab1: "tab-pane fade",
	              tab2: "tab-pane fade show active"
	            });
	            txtCostoPromeSinImpAlter.current.focus();
	          } else if (txtUtilidadMaxiAlter.current.value === "") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La Utilidad del Precio Maximo de la Unidad Alterna no debe estar vacia",
	              icono: "informacion"
	            });
	            sigue = false;
	            setTabIndex({ tab1: "tab", tab2: "tab" });
	            setACtiveTab({
	              tab1: "nav-link text-light bg-blue-100 rounded",
	              tab2: "nav-link active text-light bg-blue-200 rounded"
	            });
	            setTabValid({ tab1: "false", tab2: "true" });
	            setTabPanel({
	              tab1: "tab-pane fade",
	              tab2: "tab-pane fade show active"
	            });
	            txtUtilidadMaxiAlter.current.focus();
	          } else if (txtUtilidadOfeAlter.current.value === "") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La Utilidad del Precio Oferta de la Unidad Alterna no debe estar vacia",
	              icono: "informacion"
	            });
	            sigue = false;
	            setTabIndex({ tab1: "tab", tab2: "tab" });
	            setACtiveTab({
	              tab1: "nav-link text-light bg-blue-100 rounded",
	              tab2: "nav-link active text-light bg-blue-200 rounded"
	            });
	            setTabValid({ tab1: "false", tab2: "true" });
	            setTabPanel({
	              tab1: "tab-pane fade",
	              tab2: "tab-pane fade show active"
	            });
	            txtUtilidadOfeAlter.current.focus();
	          } else if (txtUtilidadMayorAlter.current.value === "") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La Utilidad del Precio al Mayor de la Unidad Alterna no debe estar vacia",
	              icono: "informacion"
	            });
	            sigue = false;
	            setTabIndex({ tab1: "tab", tab2: "tab" });
	            setACtiveTab({
	              tab1: "nav-link text-light bg-blue-100 rounded",
	              tab2: "nav-link active text-light bg-blue-200 rounded"
	            });
	            setTabValid({ tab1: "false", tab2: "true" });
	            setTabPanel({
	              tab1: "tab-pane fade",
	              tab2: "tab-pane fade show active"
	            });
	            txtUtilidadMayorAlter.current.focus();
	          } else if (txtUtilidadMiniAlter.current.value === "") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La Utilidad del Precio Minimo de la Unidad Alterna no debe estar vacia",
	              icono: "informacion"
	            });
	            sigue = false;
	            setTabIndex({ tab1: "tab", tab2: "tab" });
	            setACtiveTab({
	              tab1: "nav-link text-light bg-blue-100 rounded",
	              tab2: "nav-link active text-light bg-blue-200 rounded"
	            });
	            setTabValid({ tab1: "false", tab2: "true" });
	            setTabPanel({
	              tab1: "tab-pane fade",
	              tab2: "tab-pane fade show active"
	            });
	            txtUtilidadMiniAlter.current.focus();
	          }
	        }
	
	    var tasa = 0.0;
	    if (monedaCambio.idmoneda === monedaSub.idmoneda) {
	      tasa = 1.0;
	    } else if (monedaCambio.idmoneda === moneda.idmoneda) {
	      tasa = monedaSub.valormoneda;
	    } else {
	      tasa = (0, _varios.round)(monedaSub.valormoneda / monedaCambio.valormoneda);
	    }
	    var costoproveedor = parseFloat(txtCostoProveSinImp.current.value.replace(/\./g, "").replace(",", ".")) / tasa;
	    var costocalculado = parseFloat(txtCostoCalcuSinImp.current.value.replace(/\./g, "").replace(",", ".")) / tasa;
	    var ultimocosto = parseFloat(txtUltimoCostoSinImp.current.value.replace(/\./g, "").replace(",", ".")) / tasa;
	    var costopromedio = parseFloat(txtCostoPromeSinImp.current.value.replace(/\./g, "").replace(",", ".")) / tasa;
	    var utipreciomaxi = parseFloat(txtUtilidadMaxi.current.value.replace(/\./g, "").replace(",", "."));
	    var utiprecioofe = parseFloat(txtUtilidadOfe.current.value.replace(/\./g, "").replace(",", "."));
	    var utipreciomayor = parseFloat(txtUtilidadMayor.current.value.replace(/\./g, "").replace(",", "."));
	    var utipreciomini = parseFloat(txtUtilidadMini.current.value.replace(/\./g, "").replace(",", "."));
	    var preciomaxi = parseFloat(txtPrecioMaxiSinImp.current.value.replace(/\./g, "").replace(",", ".")) / tasa;
	    var precioofe = parseFloat(txtPrecioOfeSinImp.current.value.replace(/\./g, "").replace(",", ".")) / tasa;
	    var preciomayor = parseFloat(txtPrecioMayorSinImp.current.value.replace(/\./g, "").replace(",", ".")) / tasa;
	    var preciomini = parseFloat(txtPrecioMiniSinImp.current.value.replace(/\./g, "").replace(",", ".")) / tasa;
	
	    /* unidad alterna */
	    var costoproveedoralter = radioSi.current.checked ? parseFloat(txtCostoProveSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) / tasa : "0.00";
	    var costocalculadoalter = radioSi.current.checked ? parseFloat(txtCostoCalcuSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) / tasa : "0.00";
	    var ultimocostoalter = radioSi.current.checked ? parseFloat(txtUltimoCostoSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) / tasa : "0.00";
	    var costopromedioalter = radioSi.current.checked ? parseFloat(txtCostoPromeSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) / tasa : "0.00";
	    var utipreciomaxialter = radioSi.current.checked ? parseFloat(txtUtilidadMaxiAlter.current.value.replace(/\./g, "").replace(",", ".")) : "0.00";
	    var utiprecioofealter = radioSi.current.checked ? parseFloat(txtUtilidadOfeAlter.current.value.replace(/\./g, "").replace(",", ".")) : "0.00";
	    var utipreciomayoralter = radioSi.current.checked ? parseFloat(txtUtilidadMayorAlter.current.value.replace(/\./g, "").replace(",", ".")) : "0.00";
	    var utipreciominialter = radioSi.current.checked ? parseFloat(txtUtilidadMiniAlter.current.value.replace(/\./g, "").replace(",", ".")) : "0.00";
	
	    ///precio venta alterna
	    var preciomaxialter = radioSi.current.checked ? parseFloat(txtPrecioMaxiSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) / tasa : "0.00";
	    var precioofealter = radioSi.current.checked ? parseFloat(txtPrecioOfeSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) / tasa : "0.00";
	    var preciomayoralter = radioSi.current.checked ? parseFloat(txtPrecioMayorSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) / tasa : "0.00";
	    var preciominialter = radioSi.current.checked ? parseFloat(txtPrecioMiniSinImpAlter.current.value.replace(/\./g, "").replace(",", ".")) / tasa : "0.00";
	
	    if (sigue) {
	      var prod = [];
	      prod.push({
	        idproducto: txtIdproductoHidden.current.value,
	        codigo: txtIdproducto.current.value.toUpperCase(),
	        nombre: txtNombre.current.value.toUpperCase(),
	        servicio: chkServicio.current.checked,
	        nombrecorto: txtNombreCorto.current.value.toUpperCase(),
	        idtipoproducto: cmbTipoProd.current.value,
	        marca: cmbMarca.current.value === "" ? 0 : cmbMarca.current.value,
	        modelo: cmbModelo.current.value === "" ? 0 : cmbModelo.current.value,
	        referencia: txtReferencia.current.value.toUpperCase(),
	        diasgarantia: txtDiasGar.current.value === "" ? null : txtDiasGar.current.value,
	        idunidadmedida: cmbUnidMedida.current.value,
	        idmoneda: monedaSub.idmoneda,
	        ivacompra: parseFloat(txtIvaCompra.current.value.replace(/\./g, "").replace(",", ".")),
	        ivaventa: parseFloat(txtIvaVenta.current.value.replace(/\./g, "").replace(",", ".")),
	        exento: parseFloat(txtIvaVenta.current.value.replace(/\./g, "").replace(",", ".")) > 0.0 ? false : true,
	        tipoprecio: cmbPrecioVenta.current.value,
	        almacen: cmbAlmacen.current.value = "true" ? true : false,
	        stockminimo: parseFloat(txtStockMini.current.value.replace(/\./g, "").replace(",", ".")),
	        metodocosto: cmbMetodoCosto.current.value,
	        costoproveedor: costoproveedor,
	        costocalculado: costocalculado,
	        ultimocosto: ultimocosto,
	        costopromedio: costopromedio,
	        utipreciomaxi: utipreciomaxi,
	        utiprecioofe: utiprecioofe,
	        utipreciomayor: utipreciomayor,
	        utipreciomini: utipreciomini,
	        preciomaxi: preciomaxi,
	        precioofe: precioofe,
	        preciomayor: preciomayor,
	        preciomini: preciomini,
	
	        idunidadalterna: radioSi.current.checked ? cmbUniAlterna.current.value : "0",
	        idunidadcompra: radioSi.current.checked ? cmbUniCompra.current.value : "0",
	        idunidadventa: radioSi.current.checked ? cmbUniVenta.current.value : "0",
	        valorfactor: radioSi.current.checked ? parseFloat(txtFactor.current.value.replace(/\./g, "").replace(",", ".")) : "0.00",
	        tipofactor: radioSi.current.checked ? cmbUniFactor.current.value : "",
	        costoproveedoralter: costoproveedoralter,
	        costocalculadoalter: costocalculadoalter,
	        ultimocostoalter: ultimocostoalter,
	        costopromedioalter: costopromedioalter,
	        utipreciomaxialter: utipreciomaxialter,
	        utiprecioofealter: utiprecioofealter,
	        utipreciomayoralter: utipreciomayoralter,
	        utipreciominialter: utipreciominialter,
	        preciomaxialter: preciomaxialter,
	        precioofealter: precioofealter,
	        preciomayoralter: preciomayoralter,
	        preciominialter: preciominialter,
	        idtipoingreso: "0",
	        idfabricante: cmbFabricante.current.value,
	        vacio: txtVacio.current.checked,
	        idclasevacio: valvacio === 1 ? txtCodigoVacio.current.value : null,
	        activo: chkActivo.current.checked
	      });
	
	      var upload = new FormData();
	
	      upload.append("producto", JSON.stringify(prod));
	      upload.append("codigo", txtIdproducto.current.value.toUpperCase());
	      upload.append("imagenactual", imagen.imagenactual);
	      upload.append("imagennueva", imagen.imagen);
	
	      setBody(upload);
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var tabs = function tabs(vl) {
	    return function (e) {
	      e.preventDefault();
	
	      if (vl === 2 && tabIndex.tab2 !== "") {
	        setACtiveTab({
	          tab1: "nav-link text-light bg-blue-100 rounded",
	          tab2: "nav-link active text-light bg-blue-200 rounded"
	        });
	        setTabValid({ tab1: "false", tab2: "true" });
	        setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
	      } else {
	        setACtiveTab({
	          tab1: "nav-link active text-light bg-blue-100 rounded",
	          tab2: "nav-link text-light bg-blue-200 rounded"
	        });
	        setTabValid({ tab1: "true", tab2: "false" });
	        setTabPanel({
	          tab1: "tab-pane fade show active",
	          tab2: "tab-pane fade "
	        });
	      }
	    };
	  };
	
	  var onChangeMoneda = function onChangeMoneda(e) {
	    var i = e.target.value;
	    var cambio = (0, _varios.onCambioMoneda)({
	      moneda: combomoneda[i],
	      productos: [],
	      monedaPre: moneda,
	      monedaSub: monedaSub
	    });
	    setMonedaCambio(cambio.monedacambio);
	    txtNombre.current.focus();
	  };
	
	  var seleccionarExistencia = function seleccionarExistencia(id, stock) {
	    var campos = "cantidad";
	    var nomtab = "existencia";
	    var nomid = "idproducto";
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token,
	        "Content-Type": "multipart/form-data"
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var cantidad = "";
	
	        if (response.data === "") {
	          cantidad = 0;
	        } else {
	          cantidad = response.data.cantidad;
	        }
	
	        setCantidadProd(cantidad);
	        manesillas(stock, cantidad);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarRegistro = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var campos, nomtab, nomid, id, endpoint;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              campos = "*";
	              nomtab = "producto";
	              nomid = "codigo";
	              id = txtIdproducto.current.value.toUpperCase();
	              endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	
	              setActivate(true);
	              _axios2.default.get(endpoint, {
	                headers: {
	                  "x-access-token": "" + token,
	                  "Content-Type": "multipart/form-data"
	                }
	              }).then(function () {
	                var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(response) {
	                  var IvaCompra, IvaVenta, costo, uni, unic, univ, _costo, esVacio;
	
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          if (response.status === 200) {
	                            if (response.data !== "") {
	                              txtIdproducto.current.setAttribute("disabled", true);
	                              setHabilitarCat(true);
	
	                              if (response.data.imagen.trim() !== "subir.png" && response.data.imagen.trim() !== null && response.data.imagen.trim() !== "") {
	                                setImagen(Object.assign({}, imagen, {
	                                  imagenactual: response.data.imagen.trim()
	                                }));
	                                setPathImage({
	                                  imagen: op.conexion + "/imagen?img=" + organizacion + "/productos/" + response.data.imagen.trim()
	                                });
	                              }
	
	                              txtIdproductoHidden.current.value = response.data.idproducto;
	                              chkServicio.current.checked = response.data.servicio;
	                              chkActivo.current.checked = response.data.activo;
	                              txtIdproducto.current.value = response.data.codigo.trim();
	                              txtNombre.current.value = response.data.nombre.trim();
	                              txtReferencia.current.value = response.data.referencia;
	                              txtNombreCorto.current.value = response.data.nombrecorto.trim();
	                              cmbTipoProd.current.value = response.data.idtipoproducto;
	                              cmbFabricante.current.value = response.data.idfabricante;
	                              txtDiasGar.current.value = response.data.diasgarantia;
	                              cmbMarca.current.value = response.data.marca;
	                              cmbModelo.current.value = response.data.modelo;
	                              // cmbMoneda.current.value = response.data.idmoneda;
	                              cmbUnidMedida.current.value = response.data.idunidadmedida;
	
	                              txtIvaCompra.current.value = (0, _varios.formatMoneda)(response.data.ivacompra.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                              txtIvaVenta.current.value = (0, _varios.formatMoneda)(response.data.ivaventa.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                              //chkExento.current.checked = response.data.exento;
	                              cmbPrecioVenta.current.value = response.data.tipoprecio;
	                              cmbMetodoCosto.current.value = response.data.metodocosto;
	                              setCostoSelect(response.data.metodocosto);
	                              setPrecioSelect(response.data.tipoprecio);
	                              //chkAlmacen.current.checked = response.data.almacen;
	                              cmbAlmacen.current.value = response.data.almacen ? "true" : "false";
	                              txtStockMini.current.value = response.data.stockminimo === null ? "0,00" : (0, _varios.formatMoneda)(response.data.stockminimo.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	                              IvaCompra = response.data.ivacompra / 100;
	                              IvaVenta = response.data.ivaventa / 100;
	
	
	                              txtCostoProveSinImp.current.value = (0, _varios.formatMoneda)(response.data.costoproveedor.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                              txtCostoCalcuSinImp.current.value = (0, _varios.formatMoneda)(response.data.costocalculado.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                              txtUltimoCostoSinImp.current.value = (0, _varios.formatMoneda)(response.data.ultimocosto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                              txtCostoPromeSinImp.current.value = (0, _varios.formatMoneda)(response.data.costopromedio.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	                              txtCostoProveConImp.current.value = (0, _varios.formatMoneda)(((1 + IvaCompra) * response.data.costoproveedor).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                              txtCostoCalcuConImp.current.value = (0, _varios.formatMoneda)(((1 + IvaCompra) * response.data.costocalculado).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                              txtUltimoCostoConImp.current.value = (0, _varios.formatMoneda)(((1 + IvaCompra) * response.data.ultimocosto).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                              txtCostoPromeConImp.current.value = (0, _varios.formatMoneda)(((1 + IvaCompra) * response.data.costopromedio).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                              /* 
	                              txtPrecioMaxiSinImp.current.value = formatearMonto(
	                                response.data.preciomaxi,
	                                3
	                              );
	                              txtPrecioOfeSinImp.current.value = formatearMonto(
	                                response.data.precioofe,
	                                3
	                              );
	                              txtPrecioMayorSinImp.current.value = formatearMonto(
	                                response.data.preciomayor,
	                                3
	                              );
	                              txtPrecioMiniSinImp.current.value = formatearMonto(
	                                response.data.preciomini,
	                                3
	                              ); */
	
	                              txtPrecioMaxiSinImp.current.value = (0, _varios.formatMoneda)(response.data.preciomaxi.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                              txtPrecioOfeSinImp.current.value = (0, _varios.formatMoneda)(response.data.precioofe.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                              txtPrecioMayorSinImp.current.value = (0, _varios.formatMoneda)(response.data.preciomayor.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                              txtPrecioMiniSinImp.current.value = (0, _varios.formatMoneda)(response.data.preciomini.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	                              txtUtilidadMaxi.current.value = (0, _varios.formatMoneda)(response.data.utipreciomaxi.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                              txtUtilidadOfe.current.value = (0, _varios.formatMoneda)(response.data.utiprecioofe.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                              txtUtilidadMayor.current.value = (0, _varios.formatMoneda)(response.data.utipreciomayor.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                              txtUtilidadMini.current.value = (0, _varios.formatMoneda)(response.data.utipreciomini.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	                              costo = 0.0;
	
	
	                              if (parseInt(response.data.metodocosto) === 1) {
	                                costo = (1 + IvaCompra) * response.data.costoproveedor * IvaVenta;
	                              }
	                              if (parseInt(response.data.metodocosto) === 2) {
	                                costo = (1 + IvaCompra) * response.data.costocalculado * IvaVenta;
	                              }
	                              if (parseInt(response.data.metodocosto) === 3) {
	                                costo = (1 + IvaCompra) * response.data.ultimocosto * IvaVenta;
	                              }
	                              if (parseInt(response.data.metodocosto) === 4) {
	                                costo = (1 + IvaCompra) * response.data.costopromedio * IvaVenta;
	                              }
	
	                              /*             if (costo > monto) {
	                                setAlerta({ ...alerta, maxalt: 1 });
	                              } else {
	                                setAlerta({ ...alerta, maxalt: 0 });
	                              }
	                              */
	                              txtPrecioMaxiConImp.current.value = (0, _varios.formatMoneda)(((1 + IvaVenta) * parseFloat(response.data.preciomaxi)).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                              txtPrecioOfeConImp.current.value = (0, _varios.formatMoneda)(((1 + IvaVenta) * parseFloat(response.data.precioofe)).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                              txtPrecioMayorConImp.current.value = (0, _varios.formatMoneda)(((1 + IvaVenta) * parseFloat(response.data.preciomayor)).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                              txtPrecioMiniConImp.current.value = (0, _varios.formatMoneda)(((1 + IvaVenta) * parseFloat(response.data.preciomini)).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	                              seleccionarExistencia(response.data.idproducto, response.data.stockminimo);
	
	                              setStockMinimo(response.data.stockminimo);
	                              setNomProducto(response.data.nombre);
	                              //seleccionarSimboloId(response.data.idmoneda);
	                              if (response.data.idunidadalterna > 0) {
	                                radioSi.current.checked = true;
	                                radioNo.current.checked = false;
	                                setTabIndex({ tab1: "tab", tab2: "tab" });
	                                if (operacion === 2) {
	                                  setHabilitadoAlter(true);
	                                }
	                                cmbUniPrincipal.current.value = response.data.idunidadmedida;
	                                cmbUniAlterna.current.value = response.data.idunidadalterna;
	                                txtFactor.current.value = (0, _varios.formatMoneda)(response.data.valorfactor.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                                uni = [];
	
	                                uni.push({
	                                  iduni: "0",
	                                  descripcion: cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex].text + "X" + cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text
	                                });
	                                uni.push({
	                                  iduni: "1",
	                                  descripcion: cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text + "X" + cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex].text
	                                });
	                                setFactor(uni);
	                                /*for (let i = 0; i < uni.length; i++) {
	                                              if (uni[i].descripcion === response.data.tipofactor) {
	                                                  cmbUniFactor.current.value = uni[i].iduni;
	                                                  break;
	                                              }
	                                          }*/
	                                cmbUniFactor.current.value = response.data.tipofactor;
	                                unic = [];
	                                univ = [];
	
	                                setUnidadC([]);
	                                setUnidadV([]);
	
	                                unic.push({
	                                  idunidadmedida: cmbUniPrincipal.current.value,
	                                  descripcion: cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex].text
	                                });
	
	                                univ.push({
	                                  idunidadmedida: cmbUniPrincipal.current.value,
	                                  descripcion: cmbUniPrincipal.current[cmbUniPrincipal.current.selectedIndex].text
	                                });
	
	                                unic.push({
	                                  idunidadmedida: cmbUniAlterna.current.value,
	                                  descripcion: cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text
	                                });
	                                univ.push({
	                                  idunidadmedida: cmbUniAlterna.current.value,
	                                  descripcion: cmbUniAlterna.current[cmbUniAlterna.current.selectedIndex].text
	                                });
	                                setUnidadC(unic);
	                                setUnidadV(univ);
	
	                                cmbUniCompra.current.value = response.data.idunidadcompra;
	                                cmbUniVenta.current.value = response.data.idunidadventa;
	                                /////////////////////////////////////////
	
	                                txtCostoProveSinImpAlter.current.value = (0, _varios.formatMoneda)(response.data.costoproveedoralter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                                txtCostoCalcuSinImpAlter.current.value = (0, _varios.formatMoneda)(response.data.costocalculadoalter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                                txtUltimoCostoSinImpAlter.current.value = (0, _varios.formatMoneda)(response.data.ultimocostoalter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                                txtCostoPromeSinImpAlter.current.value = (0, _varios.formatMoneda)(response.data.costopromedioalter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	                                txtCostoProveConImpAlter.current.value = (0, _varios.formatMoneda)(((1 + IvaCompra) * response.data.costoproveedoralter).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                                txtCostoCalcuConImpAlter.current.value = (0, _varios.formatMoneda)(((1 + IvaCompra) * response.data.costocalculadoalter).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                                txtUltimoCostoConImpAlter.current.value = (0, _varios.formatMoneda)(((1 + IvaCompra) * response.data.ultimocostoalter).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                                txtCostoPromeConImpAlter.current.value = (0, _varios.formatMoneda)(((1 + IvaCompra) * response.data.costopromedioalter).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	                                txtPrecioMaxiSinImpAlter.current.value = (0, _varios.formatMoneda)(response.data.preciomaxialter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                                txtPrecioOfeSinImpAlter.current.value = (0, _varios.formatMoneda)(response.data.precioofealter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                                txtPrecioMayorSinImpAlter.current.value = (0, _varios.formatMoneda)(response.data.preciomayoralter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                                txtPrecioMiniSinImpAlter.current.value = (0, _varios.formatMoneda)(response.data.preciominialter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	                                txtUtilidadMaxiAlter.current.value = (0, _varios.formatMoneda)(response.data.utipreciomaxialter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                                txtUtilidadOfeAlter.current.value = (0, _varios.formatMoneda)(response.data.utiprecioofealter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                                txtUtilidadMayorAlter.current.value = (0, _varios.formatMoneda)(response.data.utipreciomayoralter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                                txtUtilidadMiniAlter.current.value = (0, _varios.formatMoneda)(response.data.utipreciominialter.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	                                _costo = 0.0;
	
	
	                                if (parseInt(response.data.metodocosto) === 1) {
	                                  _costo = (1 + IvaCompra) * response.data.costoproveedoralter * IvaVenta;
	                                }
	                                if (parseInt(response.data.metodocosto) === 2) {
	                                  _costo = (1 + IvaCompra) * response.data.costocalculadoalter * IvaVenta;
	                                }
	                                if (parseInt(response.data.metodocosto) === 3) {
	                                  _costo = (1 + IvaCompra) * response.data.ultimocostoalter * IvaVenta;
	                                }
	                                if (parseInt(response.data.metodocosto) === 3) {
	                                  _costo = (1 + IvaCompra) * response.data.costopromedioalter * IvaVenta;
	                                }
	
	                                txtPrecioMaxiConImpAlter.current.value = (0, _varios.formatMoneda)(((1 + IvaVenta) * parseFloat(response.data.preciomaxialter)).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                                txtPrecioOfeConImpAlter.current.value = (0, _varios.formatMoneda)(((1 + IvaVenta) * parseFloat(response.data.precioofealter)).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                                txtPrecioMayorConImpAlter.current.value = (0, _varios.formatMoneda)(((1 + IvaVenta) * parseFloat(response.data.preciomayoralter)).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	                                txtPrecioMiniConImpAlter.current.value = (0, _varios.formatMoneda)(((1 + IvaVenta) * parseFloat(response.data.preciominialter)).toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	                                txtPrecioMaxiSinImp.current.style.color = parseFloat(response.data.utipreciomaxi) < 0.0 ? "#FB0000" : "#000000";
	                                txtPrecioOfeSinImp.current.style.color = parseFloat(response.data.utiprecioofe) < 0.0 ? "#FB0000" : "#000000";
	                                txtPrecioMayorSinImp.current.style.color = parseFloat(response.data.utipreciomayor) < 0.0 ? "#FB0000" : "#000000";
	                                txtPrecioMiniSinImp.current.style.color = parseFloat(response.data.utipreciomini) < 0.0 ? "#FB0000" : "#000000";
	
	                                txtPrecioMaxiSinImpAlter.current.style.color = parseFloat(response.data.utipreciomaxialter) < 0.0 ? "#FB0000" : "#000000";
	                                txtPrecioOfeSinImpAlter.current.style.color = parseFloat(response.data.utiprecioofealter) < 0.0 ? "#FB0000" : "#000000";
	                                txtPrecioMayorSinImpAlter.current.style.color = parseFloat(response.data.utipreciomayoralter) < 0.0 ? "#FB0000" : "#000000";
	                                txtPrecioMiniSinImpAlter.current.style.color = parseFloat(response.data.utipreciominialter) < 0.0 ? "#FB0000" : "#000000";
	                              } else {
	                                txtPrecioMaxiSinImp.current.style.color = parseFloat(response.data.utipreciomaxi) < 0.0 ? "#FB0000" : "#000000";
	                                txtPrecioOfeSinImp.current.style.color = parseFloat(response.data.utiprecioofe) < 0.0 ? "#FB0000" : "#000000";
	                                txtPrecioMayorSinImp.current.style.color = parseFloat(response.data.utipreciomayor) < 0.0 ? "#FB0000" : "#000000";
	                                txtPrecioMiniSinImp.current.style.color = parseFloat(response.data.utipreciomini) < 0.0 ? "#FB0000" : "#000000";
	
	                                radioSi.current.checked = false;
	                                radioNo.current.checked = true;
	                                setTabIndex({ tab1: "tab", tab2: "" });
	                                setHabilitadoAlter(false);
	                                blanquearAlter();
	                              }
	
	                              if (response.data.almacen) {
	                                setVisibleA("visible");
	                              }
	
	                              if (operacion === 2) {
	                                setHabilitado(true);
	                                // txtCodigo.current.focus();
	                              } else {
	                                btnAceptar.current.focus();
	                              }
	
	                              esVacio = response.data.vacio === true ? true : false;
	
	                              txtVacio.current.checked = esVacio;
	
	                              if (esVacio) {
	                                setValvacio(1);
	                                seleccionarClassVacios(1, response.data.idclasevacio, function () {
	                                  console.log("Datos de clases vacías cargados completamente");
	                                });
	                              } else {
	                                setActivate(false);
	                                setValvacio(0);
	                              }
	                            } else {
	                              setMensaje({
	                                mostrar: true,
	                                titulo: "Notificación",
	                                texto: "El Producto no existe.",
	                                icono: "informacion"
	                              });
	                              txtIdproducto.current.value = "";
	                              txtIdproducto.current.focus();
	                              setActivate(false);
	                            }
	                          }
	
	                        case 1:
	                        case "end":
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, this);
	                }));
	
	                return function (_x2) {
	                  return _ref2.apply(this, arguments);
	                };
	              }()).catch(function (error) {
	                setActivate(false);
	                setMensaje({
	                  mostrar: true,
	                  titulo: "Error",
	                  texto: error.response.data.message,
	                  icono: "error"
	                });
	              });
	
	            case 7:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));
	
	    return function seleccionarRegistro() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var validarProducto = function validarProducto(event) {
	    event.preventDefault();
	    // validaSoloNumero(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "" && operacion !== 1) {
	        seleccionarRegistro();
	      } else {
	        cmbMoneda.current.focus();
	      }
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/producto/actualizar/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro creado correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro modificado correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro eliminado correctamente",
	            icono: "exito"
	          });
	        }
	        blanquear();
	        blanquearAlter();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = "";
	      if (error.response === undefined) {
	        mensaje = error;
	      } else {
	        mensaje = error.response.data.message;
	      }
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var onCatalogoProducto = function onCatalogoProducto(values) {
	    setCatalogoProducto(false);
	    if (values.codigo !== "") {
	      txtIdproducto.current.value = values.codigo;
	      seleccionarRegistro();
	    }
	  };
	
	  var imprimirAlmacen = function imprimirAlmacen() {
	    if (accbtnproducto && accbtnproducto.toString().substring(4, 5) === "1") {
	      window.open(op.reportes + "/productos?afiliado=" + organizacion + "&reporte=ListaProducto", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (accbtnproducto && accbtnproducto.toString().substring(0, 1) === "1") {
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setTituloHeader("Incluir Producto Terminado.");
	          setOperacion(op);
	          setHabilitado(true);
	          seleccionarUnidadMedida(op);
	          seleccionarTipoProd();
	          seleccionarFabricante();
	          seleccionarMarca();
	          seleccionarModelo();
	          // seleccionarMoneda();
	          txtIdproducto.current.value = "";
	          txtIdproductoHidden.current.value = "0";
	          txtIdproducto.current.removeAttribute("disabled");
	          setHabilitarCat(true);
	          txtDiasGar.current.value = "0";
	          txtIvaCompra.current.value = "0,00";
	          txtIvaVenta.current.value = "0,00";
	          txtCostoProveSinImp.current.value = "0,00";
	          txtCostoCalcuSinImp.current.value = "0,00";
	          txtUltimoCostoSinImp.current.value = "0,00";
	          txtCostoPromeSinImp.current.value = "0,00";
	          txtCostoProveConImp.current.value = "0,00";
	          txtCostoCalcuConImp.current.value = "0,00";
	          txtUltimoCostoConImp.current.value = "0,00";
	          txtCostoPromeConImp.current.value = "0,00";
	          txtPrecioMaxiSinImp.current.value = "0,00";
	          txtPrecioOfeSinImp.current.value = "0,00";
	          txtPrecioMayorSinImp.current.value = "0,00";
	          txtPrecioMiniSinImp.current.value = "0,00";
	          txtPrecioMaxiConImp.current.value = "0,00";
	          txtPrecioOfeConImp.current.value = "0,00";
	          txtPrecioMayorConImp.current.value = "0,00";
	          txtPrecioMiniConImp.current.value = "0,00";
	          txtUtilidadMaxi.current.value = "0,00";
	          txtUtilidadOfe.current.value = "0,00";
	          txtUtilidadMayor.current.value = "0,00";
	          txtUtilidadMini.current.value = "0,00";
	          radioNo.current.checked = true;
	          radioSi.current.checked = false;
	          cmbPrecioVenta.current.value = "1";
	          cmbMetodoCosto.current.value = "1";
	          //cmbMoneda.current.selectedIndex = 0;
	          setTimeout(function () {
	            return txtIdproducto.current.focus();
	          }, 200);
	        } else {
	          setHabilitadoBot(true);
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (accbtnproducto && accbtnproducto.toString().substring(1, 2) === "1") {
	          setVisibleBtn("hidden");
	          setTituloHeader("Editar Producto Terminado.");
	          setOperacion(op);
	          seleccionarUnidadMedida(op);
	          seleccionarTipoProd();
	          seleccionarFabricante();
	          seleccionarMarca();
	          seleccionarModelo();
	          //seleccionarMoneda();
	          txtIdproducto.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitado(false);
	          setHabilitadoBot(false);
	          txtIdproducto.current.focus();
	        } else {
	          setHabilitadoBot(true);
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (accbtnproducto && accbtnproducto.toString().substring(3, 4) === "1") {
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setTituloHeader("Eliminar Producto Terminado.");
	          setOperacion(op);
	          seleccionarUnidadMedida(op);
	          seleccionarTipoProd();
	          seleccionarFabricante();
	          seleccionarMarca();
	          seleccionarModelo();
	          //seleccionarMoneda();
	          setHabilitado(false);
	          txtIdproducto.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          txtIdproducto.current.focus();
	        } else {
	          setHabilitadoBot(true);
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (accbtnproducto && accbtnproducto.toString().substring(2, 3) === "1") {
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setTituloHeader("Consultar Producto Terminado.");
	          setOperacion(op);
	          seleccionarUnidadMedida(op);
	          seleccionarTipoProd();
	          seleccionarFabricante();
	          seleccionarMarca();
	          seleccionarModelo();
	          //seleccionarMoneda();
	          setHabilitado(false);
	          txtIdproducto.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          txtIdproducto.current.focus();
	        } else {
	          setHabilitadoBot(true);
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 5) {
	        if (operacion !== 4) {
	          onChangeValidar();
	        }
	      } else if (op === 6) {
	        blanquear();
	        blanquearAlter();
	      } else if (op === 7) {
	        //setCatalogoProducto(true);
	      }
	    };
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarMonedas();
	  }, []);
	
	  var onDescargarFormato = function onDescargarFormato(e) {
	    e.preventDefault();
	    getDescargar();
	  };
	
	  var getDescargar = function getDescargar() {
	    setActivate(true);
	    var nomformat = "preciosproductos.xlsx";
	    var endpoint = op.conexion + "/imagen?img=" + nomformat.trim();
	    _axios2.default.get(endpoint, {
	      responseType: "arraybuffer",
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      var url = window.URL.createObjectURL(new Blob([response.data]));
	      var link = document.createElement("a");
	      link.href = url;
	      link.setAttribute("download", "" + nomformat.trim());
	      document.body.appendChild(link);
	      link.click();
	      document.body.removeChild(link);
	    }).catch(function (error) {
	      console.error(error);
	    }).finally(function () {
	      return setActivate(false);
	    });
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 m-0 mt-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-xl-9 mb-2 col-lg-9 col-md-12 row mx-auto" },
	          _react2.default.createElement(
	            "ul",
	            { className: "nav mb-1", id: "ex-with-icons", role: "tablist" },
	            _react2.default.createElement(
	              "li",
	              { className: "nav-item", role: "presentation" },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: activeTab.tab1,
	                  id: "ex-with-icons-tab-1",
	                  onClick: tabs(1),
	                  "data-mdb-toggle": tabIndex.tab1,
	                  href: "#tab1",
	                  role: "tab",
	                  "aria-controls": "tab1",
	                  "aria-selected": tabvalid.tab1
	                },
	                _react2.default.createElement("i", { className: "fas fa-chart-pie fa-fw me-2" }),
	                "Informaci\xF3n"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { className: "nav-item", role: "presentation" },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: activeTab.tab2,
	                  id: "ex-with-icons-tab-2",
	                  onClick: tabs(2),
	                  "data-mdb-toggle": tabIndex.tab2,
	                  href: "#tab2",
	                  role: "tab",
	                  "aria-controls": "tabs2",
	                  "aria-selected": tabvalid.tab1
	                },
	                _react2.default.createElement("i", { className: "fas fa-highlighter fa-fw me-2" }),
	                "Unidad Alterna"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { className: "nav-item py-1 px-2" },
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  className: "btn btn-sm btn-info rounded-pill",
	                  onClick: imprimirAlmacen
	                },
	                _react2.default.createElement(
	                  "i",
	                  { className: "fas fa-print" },
	                  " Productos"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { className: "nav-item py-1 px-2" },
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  className: "btn btn-sm btn-warning rounded-pill",
	                  onClick: function onClick() {
	                    return setMostrarActualizar(true);
	                  }
	                },
	                _react2.default.createElement(
	                  "i",
	                  { className: "fas fa-edit" },
	                  " Actualizar Precios"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { className: "nav-item py-1 px-2" },
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  className: "btn btn-sm btn-success rounded-pill",
	                  onClick: function onClick() {
	                    return setMostrarActualizar2(true);
	                  }
	                },
	                _react2.default.createElement(
	                  "i",
	                  { className: "fas fa-edit" },
	                  " Actualizar Precios por Excel"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { className: "nav-item py-1 px-2" },
	              _react2.default.createElement("i", { className: "fas fa-long-arrow-alt-right fs-2" })
	            ),
	            _react2.default.createElement(
	              "li",
	              { className: "nav-item py-1 px-2" },
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  className: "btn btn-sm rounded-pill",
	                  style: { background: "#008B8B", color: "#FFFF" },
	                  onClick: onDescargarFormato
	                },
	                _react2.default.createElement(
	                  "i",
	                  { className: "fas fa-file-excel" },
	                  " Formato"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "tab-content",
	              id: "ex-with-icons-content",
	              style: { fontFamily: "Times New Roman, Times, serif" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 border-azul rounded py-2 row mx-auto azulGradiant shadow text-light justify-content-between" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-xl-4 col-lg-6 col-md-7 col-sm-8" },
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  tituloHeader
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-xl-3 col-sm-4 d-flex justify-content-end" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "/inicio", className: "text-light " },
	                  _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "fw-bold" },
	                    "Salir"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: tabPanel.tab1,
	                id: "ex-with-icons-tabs-1",
	                role: "tabpanel",
	                "aria-labelledby": "ex-with-icons-tab-1"
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-md-12 row mx-auto bg-light rounded shadow",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                windowWidth < 1600 && _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 mx-auto py-2" },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: " mb-2 col-xl-6 col-lg-6 col-md-6 mx-auto d-flex justify-content-center",
	                      style: { height: 150, width: 100 }
	                    },
	                    _react2.default.createElement("img", {
	                      src: pathImage.imagen,
	                      className: "shadow position-absolute",
	                      style: {
	                        height: 150,
	                        width: 150,
	                        objectFit: "none",
	                        backgroundColor: "#FFFFFF"
	                      },
	                      alt: ""
	                    }),
	                    _react2.default.createElement("input", {
	                      type: "file",
	                      disabled: !habilitado,
	                      style: { opacity: 0, height: 150, width: 100 },
	                      onChange: handleUpload,
	                      name: "imagen",
	                      accept: "image/jpeg, image/png",
	                      className: "btn"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 mx-auto row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2 col-12" },
	                    _react2.default.createElement("input", {
	                      type: "hidden",
	                      ref: txtIdproductoHidden,
	                      className: "form-control",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2 col-xl-3 col-lg-3 col-md-3 col-sm-3" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "CODIGO:"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      disabled: true,
	                      autoComplete: "off",
	                      ref: txtIdproducto,
	                      onChange: onChange,
	                      onKeyUp: validarProducto,
	                      onBlur: validarProducto,
	                      name: "codigo",
	                      className: "form-control uppercase fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    }),
	                    operacion !== 1 && _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: habilitarCat,
	                        type: "button",
	                        onClick: function onClick() {
	                          return setCatalogoProducto(true);
	                        },
	                        className: "btn btn-success"
	                      },
	                      _react2.default.createElement("i", { className: "fas fa-search" })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2 col-pd-260" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "MONEDA:"
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        disabled: !habilitado,
	                        ref: cmbMoneda,
	                        onChange: onChangeMoneda,
	                        className: "form-select form-select-sm fw-bold",
	                        "aria-label": ".form-select-sm example"
	                      },
	                      combomoneda && combomoneda.map(function (item, index) {
	                        return _react2.default.createElement(
	                          "option",
	                          { key: index, value: index },
	                          " ",
	                          item.descripcion + " " + item.simbolo + " " + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-xl-3 col-lg-3 col-md-3 col-sm-3" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check", style: { float: "right" } },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "checkbox",
	                        disabled: !habilitado,
	                        ref: chkActivo,
	                        value: "",
	                        id: "flexCheckActivo"
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "form-check-label",
	                          htmlFor: "flexCheckActivo"
	                        },
	                        "ACTIVO?"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-xl-3 col-lg-3 col-md-3 col-sm-3" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check", style: { float: "right" } },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "checkbox",
	                        disabled: !habilitado,
	                        ref: chkServicio,
	                        value: "",
	                        id: "flexCheckServicio"
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "form-check-label",
	                          htmlFor: "flexCheckServicio"
	                        },
	                        "Es un Servicio?"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2 col-xl-9 col-lg-8 col-md-8 col-sm-8" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "NOMBRE:"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      ref: txtNombre,
	                      autoComplete: "off",
	                      disabled: !habilitado,
	                      className: "form-control text-uppercase fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm",
	                      id: "inputNombre",
	                      onKeyUp: handleInputChange,
	                      onBlur: handleInputChange
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2 col-xl-3 col-lg-4 col-md-5 col-sm-5" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "REFERENCIA:"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      autoComplete: "off",
	                      ref: txtReferencia,
	                      disabled: !habilitado,
	                      className: "form-control text-uppercase fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm",
	                      id: "inputRefe",
	                      onKeyUp: handleInputChange,
	                      onBlur: handleInputChange
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2 col-xl-9 col-lg-8 col-md-7 col-sm-7" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "NOMBRE CORTO:"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      autoComplete: "off",
	                      ref: txtNombreCorto,
	                      disabled: !habilitado,
	                      className: "form-control text-uppercase fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm",
	                      id: "inputNombreCorto",
	                      onKeyUp: handleInputChange,
	                      onBlur: handleInputChange
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 mx-auto mb-1" },
	                  _react2.default.createElement(
	                    "fieldset",
	                    { className: " row col-sm-12 mx-auto border-azul rounded justify-content-between" },
	                    _react2.default.createElement(
	                      "legend",
	                      {
	                        className: "float-none w-auto fw-bold",
	                        style: { fontSize: "15px" }
	                      },
	                      "Configuraci\xF3n"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm mb-2 col-xl-6 col-lg-8 col-md-8 col-sm-12" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        "TIPO PRODUCTO/SERVICIO:"
	                      ),
	                      _react2.default.createElement(
	                        "select",
	                        {
	                          disabled: !habilitado,
	                          ref: cmbTipoProd,
	                          className: "form-select form-select-sm ",
	                          "aria-label": ".form-select-sm example"
	                        },
	                        tipoP && tipoP.map(function (tipo) {
	                          return _react2.default.createElement(
	                            "option",
	                            {
	                              key: tipo.idtipoproducto,
	                              value: tipo.idtipoproducto
	                            },
	                            " ",
	                            tipo.descripcion
	                          );
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          disabled: !habilitado,
	                          onClick: abrirModal("tipop"),
	                          className: "btn btn-sm btn-primary rounded-circle mx-1"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-plus" }),
	                        " "
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm mb-2 col-xl-6 col-lg-8 col-md-8 col-sm-12" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        "FABRICANTE:"
	                      ),
	                      _react2.default.createElement(
	                        "select",
	                        {
	                          disabled: !habilitado,
	                          ref: cmbFabricante,
	                          className: "form-select form-select-sm ",
	                          "aria-label": ".form-select-sm example"
	                        },
	                        fabri && fabri.map(function (tipo) {
	                          return _react2.default.createElement(
	                            "option",
	                            {
	                              key: tipo.idfabricante,
	                              value: tipo.idfabricante
	                            },
	                            " ",
	                            tipo.descripcion
	                          );
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          disabled: !habilitado,
	                          onClick: abrirModal("fabricante"),
	                          className: "btn btn-sm btn-primary rounded-circle mx-1"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-plus" }),
	                        " "
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm mb-2 col-xl-4 col-lg-6 col-md-6 col-sm-6" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        "MARCA:"
	                      ),
	                      _react2.default.createElement(
	                        "select",
	                        {
	                          disabled: !habilitado,
	                          ref: cmbMarca,
	                          className: "form-select form-select-sm",
	                          "aria-label": ".form-select-sm example"
	                        },
	                        _react2.default.createElement(
	                          "option",
	                          { value: "0" },
	                          "--seleccione--"
	                        ),
	                        marca && marca.map(function (mark) {
	                          return _react2.default.createElement(
	                            "option",
	                            { key: mark.idmarca, value: mark.idmarca },
	                            " ",
	                            mark.descripcion
	                          );
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          disabled: !habilitado,
	                          onClick: abrirModal("marca"),
	                          className: "btn btn-sm btn-primary rounded-circle mx-1"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-plus" }),
	                        " "
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm mb-2 col-xl-4 col-lg-6 col-md-6 col-sm-6" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        "MODELO:"
	                      ),
	                      _react2.default.createElement(
	                        "select",
	                        {
	                          disabled: !habilitado,
	                          ref: cmbModelo,
	                          className: "form-select form-select-sm",
	                          "aria-label": ".form-select-sm example"
	                        },
	                        _react2.default.createElement(
	                          "option",
	                          { value: "0" },
	                          "--seleccione--"
	                        ),
	                        modelo && modelo.map(function (mod) {
	                          return _react2.default.createElement(
	                            "option",
	                            { key: mod.idmodelo, value: mod.idmodelo },
	                            " ",
	                            mod.descripcion
	                          );
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          disabled: !habilitado,
	                          onClick: abrirModal("modelo"),
	                          className: "btn btn-sm btn-primary rounded-circle mx-1"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-plus" }),
	                        " "
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm mb-2 col-xl-4 col-lg-6 col-md-6 col-sm-6" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        "UNID. MEDIDA:"
	                      ),
	                      _react2.default.createElement(
	                        "select",
	                        {
	                          disabled: !habilitado,
	                          ref: cmbUnidMedida,
	                          onChange: onChange,
	                          name: "idunidadmedida",
	                          id: "idunidadmedida",
	                          className: "form-select form-select-sm ",
	                          "aria-label": ".form-select-sm example"
	                        },
	                        _react2.default.createElement(
	                          "option",
	                          { value: "" },
	                          "--seleccione--"
	                        ),
	                        unidadM && unidadM.map(function (unimedi) {
	                          return _react2.default.createElement(
	                            "option",
	                            {
	                              key: unimedi.idunidadmedida,
	                              value: unimedi.idunidadmedida
	                            },
	                            " ",
	                            unimedi.descripcion
	                          );
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          disabled: !habilitado,
	                          onClick: abrirModal("medida"),
	                          className: "btn btn-sm btn-primary rounded-circle mx-1"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-plus" }),
	                        " "
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm mb-2 col-pd-210 px-1" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text text-right",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        "% IVA COMPRA:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        autoComplete: "off",
	                        disabled: !habilitado,
	                        ref: txtIvaCompra,
	                        className: "form-control form-control-sm text-right fs-6",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        id: "ivaCompra",
	                        onFocus: _varios.seleccionarCampo,
	                        onKeyUp: handleInputMontoChange,
	                        onBlur: handleInputMontoChange
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm mb-2 col-pd-210 px-2" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text text-right",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        "% IVA VENTA:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        autoComplete: "off",
	                        disabled: !habilitado,
	                        ref: txtIvaVenta,
	                        className: "form-control form-control-sm text-right fs-6",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        id: "ivaVenta",
	                        onFocus: _varios.seleccionarCampo,
	                        onKeyUp: handleInputMontoChange,
	                        onBlur: handleInputMontoChange
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm mb-2 col-xl-3 col-lg-4 col-md-4 col-sm-4" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        "DIAS GARANTIA:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "number",
	                        disabled: !habilitado,
	                        ref: txtDiasGar,
	                        className: "form-control fs-6",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        id: "inputDiasGar",
	                        onKeyUp: handleInputChange,
	                        onBlur: handleInputChange
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm mb-2 col-xl-4 col-lg-6 col-md-6 col-sm-6" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        "DESTINO:"
	                      ),
	                      _react2.default.createElement(
	                        "select",
	                        {
	                          disabled: !habilitado,
	                          ref: cmbAlmacen,
	                          name: "almacen",
	                          onChange: onChange,
	                          className: "form-select form-select-sm ",
	                          "aria-label": ".form-select-sm example"
	                        },
	                        _react2.default.createElement(
	                          "option",
	                          { value: "true" },
	                          "ALMACEN"
	                        ),
	                        _react2.default.createElement(
	                          "option",
	                          { value: "false" },
	                          "USO INTERNO"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "input-group input-group-sm mb-2 col-pd-230",
	                        style: { visibility: visibleA }
	                      },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text text-right",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        "STOCK MINIMO:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        autoComplete: "off",
	                        disabled: !habilitado,
	                        ref: txtStockMini,
	                        className: "form-control form-control-sm text-right fs-6",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        id: "stockminimo",
	                        defaultValue: "0,00",
	                        onFocus: _varios.seleccionarCampo,
	                        onKeyUp: handleInputMontoChange,
	                        onBlur: handleInputMontoChange
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-pd-230" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          type: "checkbox",
	                          disabled: !habilitado,
	                          ref: txtVacio,
	                          onChange: onChange,
	                          value: "",
	                          id: "chekvacio"
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "form-check-label",
	                            htmlFor: "chekvacio"
	                          },
	                          "Vacio?"
	                        )
	                      )
	                    ),
	                    valvacio === 1 ? _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm mb-2 col-pd-350 px-2" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        "TIPO VACIO:"
	                      ),
	                      _react2.default.createElement(
	                        "select",
	                        {
	                          disabled: !habilitado,
	                          ref: txtCodigoVacio,
	                          onChange: onChange,
	                          name: "idclasevacio",
	                          id: "idclasevacio",
	                          className: "form-select form-select-sm ",
	                          "aria-label": ".form-select-sm example"
	                        },
	                        _react2.default.createElement(
	                          "option",
	                          { value: "" },
	                          "--seleccione--"
	                        ),
	                        classvacios && classvacios.map(function (unimedi) {
	                          return _react2.default.createElement(
	                            "option",
	                            {
	                              key: unimedi.idclasevacio,
	                              value: unimedi.idclasevacio
	                            },
	                            " ",
	                            unimedi.descripcion
	                          );
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          disabled: !habilitado,
	                          onClick: abrirModal("classvacios"),
	                          className: "btn btn-sm btn-primary rounded-circle mx-1"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-plus" }),
	                        " "
	                      )
	                    ) : ""
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "col-md-12 mx-auto row mb-1",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-xl-6 px-0" },
	                    _react2.default.createElement(
	                      "fieldset",
	                      { className: " row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between pb-0" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-sm-12 px-2" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "METODO DE COSTO:"
	                        ),
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            disabled: !habilitado,
	                            ref: cmbMetodoCosto,
	                            className: "form-select form-select-sm bg-info",
	                            "aria-label": ".form-select-sm example",
	                            name: "metodocosto",
	                            onChange: onChange,
	                            defaultValue: 1
	                          },
	                          _react2.default.createElement(
	                            "option",
	                            { value: "1" },
	                            "COSTO PROVEEDOR"
	                          ),
	                          _react2.default.createElement(
	                            "option",
	                            { value: "2" },
	                            "COSTO CALCULADO"
	                          ),
	                          _react2.default.createElement(
	                            "option",
	                            { value: "3" },
	                            "ULTIMO COSTO"
	                          ),
	                          _react2.default.createElement(
	                            "option",
	                            { value: "4" },
	                            "COSTO PROMEDIO"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "table",
	                        { className: "table table-sm col-md-12 border bg-light" },
	                        _react2.default.createElement(
	                          "thead",
	                          { className: "azulGradiant text-light fw-bold" },
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "th",
	                              { className: "text-center", scope: "col" },
	                              _react2.default.createElement(
	                                "label",
	                                { style: { fontSize: "11px" } },
	                                "COSTOS"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "th",
	                              { className: "text-center", scope: "col" },
	                              _react2.default.createElement(
	                                "label",
	                                { style: { fontSize: "11px" } },
	                                "SIN IMPUESTO"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "th",
	                              {
	                                className: "text-center border-right border-light",
	                                scope: "col"
	                              },
	                              _react2.default.createElement(
	                                "label",
	                                { style: { fontSize: "11px" } },
	                                "CON IMPUESTO"
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "tbody",
	                          null,
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "td",
	                              { className: "text-center border-left" },
	                              costoSelect === "1" && _react2.default.createElement("i", { className: "fas fa-arrow-right text-danger" }),
	                              " ",
	                              "Costo Proveedor: ",
	                              _react2.default.createElement(
	                                "b",
	                                null,
	                                monedaCambio.simbolo
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              { style: { width: "30%" } },
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                autoComplete: "off",
	                                disabled: !habilitado,
	                                ref: txtCostoProveSinImp,
	                                className: "form-control form-control-sm text-right fs-6",
	                                id: "costoProveSinImpu",
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              {
	                                className: "border-right",
	                                style: { width: "30%" }
	                              },
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                disabled: true,
	                                ref: txtCostoProveConImp,
	                                className: "form-control form-control-sm text-right fs-6"
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "td",
	                              { className: "text-center border-left" },
	                              costoSelect === "2" && _react2.default.createElement("i", { className: "fas fa-arrow-right text-danger" }),
	                              " ",
	                              "Costo Calculado: ",
	                              _react2.default.createElement(
	                                "b",
	                                null,
	                                monedaCambio.simbolo
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                autoComplete: "off",
	                                disabled: !habilitado,
	                                ref: txtCostoCalcuSinImp,
	                                className: "form-control form-control-sm text-right fs-6",
	                                id: "costoCalcuSinImpu",
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              { className: "border-right" },
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                disabled: true,
	                                ref: txtCostoCalcuConImp,
	                                className: "form-control form-control-sm text-right fs-6"
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "td",
	                              { className: "text-center border-left" },
	                              costoSelect === "3" && _react2.default.createElement("i", { className: "fas fa-arrow-right text-danger" }),
	                              " ",
	                              "Ultimo Costo: ",
	                              _react2.default.createElement(
	                                "b",
	                                null,
	                                monedaCambio.simbolo
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                autoComplete: "off",
	                                disabled: !habilitado,
	                                ref: txtUltimoCostoSinImp,
	                                className: "form-control form-control-sm text-right fs-6",
	                                id: "costoUltiSinImpu",
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              { className: "border-right" },
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                disabled: true,
	                                ref: txtUltimoCostoConImp,
	                                className: "form-control form-control-sm text-right fs-6"
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "td",
	                              { className: "text-center border-left" },
	                              costoSelect === "4" && _react2.default.createElement("i", { className: "fas fa-arrow-right text-danger" }),
	                              " ",
	                              "Costo Promedio: ",
	                              _react2.default.createElement(
	                                "b",
	                                null,
	                                monedaCambio.simbolo
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                autoComplete: "off",
	                                disabled: !habilitado,
	                                ref: txtCostoPromeSinImp,
	                                className: "form-control form-control-sm text-right fs-6",
	                                id: "costoPromeSinImpu",
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              { className: "border-right" },
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                disabled: true,
	                                ref: txtCostoPromeConImp,
	                                className: "form-control form-control-sm text-right fs-6"
	                              })
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-xl-6 px-0" },
	                    _react2.default.createElement(
	                      "fieldset",
	                      { className: " row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between pb-0" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-sm-12 px-2" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "PRECIO VENTA:"
	                        ),
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            disabled: !habilitado,
	                            ref: cmbPrecioVenta,
	                            onChange: function onChange(e) {
	                              return setPrecioSelect(e.target.value);
	                            },
	                            className: "form-select form-select-sm bg-success",
	                            "aria-label": ".form-select-sm example",
	                            defaultValue: "1"
	                          },
	                          _react2.default.createElement(
	                            "option",
	                            { value: "1" },
	                            "MAXIMO"
	                          ),
	                          _react2.default.createElement(
	                            "option",
	                            { value: "2" },
	                            "OFERTA"
	                          ),
	                          _react2.default.createElement(
	                            "option",
	                            { value: "3" },
	                            "MAYOR"
	                          ),
	                          _react2.default.createElement(
	                            "option",
	                            { value: "4" },
	                            "MINIMO"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "table",
	                        { className: "table table-sm col-md-12 border bg-light" },
	                        _react2.default.createElement(
	                          "thead",
	                          { className: "azulGradiant text-light fw-bold" },
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "th",
	                              { className: "text-center", scope: "col" },
	                              _react2.default.createElement(
	                                "label",
	                                { style: { fontSize: "11px" } },
	                                "PRECIOS"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "th",
	                              { className: "text-center ", scope: "col" },
	                              _react2.default.createElement(
	                                "label",
	                                { style: { fontSize: "11px" } },
	                                "SIN IMPUESTO"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "th",
	                              { className: "text-center", scope: "col" },
	                              _react2.default.createElement(
	                                "label",
	                                { style: { fontSize: "11px" } },
	                                "UTILIDAD %"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "th",
	                              { className: "text-center", scope: "col" },
	                              _react2.default.createElement(
	                                "label",
	                                { style: { fontSize: "11px" } },
	                                "CON IMPUESTO"
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "tbody",
	                          null,
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "td",
	                              {
	                                style: { width: "15%" },
	                                className: "text-center"
	                              },
	                              precioSelect === "1" && _react2.default.createElement("i", { className: "fas fa-arrow-right text-danger" }),
	                              " ",
	                              "Maximo: ",
	                              _react2.default.createElement(
	                                "b",
	                                null,
	                                monedaCambio.simbolo
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              {
	                                style: {
	                                  width: "12%"
	                                }
	                              },
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                autoComplete: "off",
	                                disabled: !habilitado,
	                                style: {
	                                  color: "#000000"
	                                },
	                                id: "preciomaximo",
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange,
	                                ref: txtPrecioMaxiSinImp,
	                                className: "form-control form-control-sm text-right fs-6"
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              { style: { width: "12%" } },
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                autoComplete: "off",
	                                disabled: !habilitado,
	                                ref: txtUtilidadMaxi,
	                                className: "form-control form-control-sm text-right fs-6",
	                                id: "utilidadMaxi",
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              {
	                                className: "border-right",
	                                style: { width: "15%" }
	                              },
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                disabled: true,
	                                ref: txtPrecioMaxiConImp,
	                                className: "form-control form-control-sm text-right fs-6"
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "td",
	                              {
	                                style: { width: "15%" },
	                                className: "text-center"
	                              },
	                              precioSelect === "2" && _react2.default.createElement("i", { className: "fas fa-arrow-right text-danger" }),
	                              " ",
	                              "Oferta: ",
	                              _react2.default.createElement(
	                                "b",
	                                null,
	                                monedaCambio.simbolo
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                autoComplete: "off",
	                                disabled: !habilitado,
	                                style: {
	                                  color: "#000000"
	                                },
	                                id: "preciooferta",
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange,
	                                ref: txtPrecioOfeSinImp,
	                                className: "form-control form-control-sm text-right fs-6"
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                autoComplete: "off",
	                                disabled: !habilitado,
	                                ref: txtUtilidadOfe,
	                                className: "form-control form-control-sm text-right fs-6",
	                                id: "utilidadOfe",
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              { className: "border-right" },
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                disabled: true,
	                                ref: txtPrecioOfeConImp,
	                                className: "form-control form-control-sm text-right fs-6"
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "td",
	                              {
	                                style: { width: "15%" },
	                                className: "text-center"
	                              },
	                              precioSelect === "3" && _react2.default.createElement("i", { className: "fas fa-arrow-right text-danger" }),
	                              " ",
	                              "Mayor: ",
	                              _react2.default.createElement(
	                                "b",
	                                null,
	                                monedaCambio.simbolo
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                autoComplete: "off",
	                                disabled: !habilitado,
	                                style: {
	                                  color: "#000000"
	                                },
	                                id: "preciomayor",
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange,
	                                ref: txtPrecioMayorSinImp,
	                                className: "form-control form-control-sm text-right fs-6"
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                autoComplete: "off",
	                                disabled: !habilitado,
	                                ref: txtUtilidadMayor,
	                                className: "form-control form-control-sm text-right fs-6",
	                                id: "utilidadMayor",
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              { className: "border-right" },
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                disabled: true,
	                                ref: txtPrecioMayorConImp,
	                                className: "form-control form-control-sm text-right fs-6"
	                              })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                              "td",
	                              {
	                                style: { width: "15%" },
	                                className: "text-center"
	                              },
	                              precioSelect === "4" && _react2.default.createElement("i", { className: "fas fa-arrow-right text-danger" }),
	                              " ",
	                              "Minimo: ",
	                              _react2.default.createElement(
	                                "b",
	                                null,
	                                monedaCambio.simbolo
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                autoComplete: "off",
	                                disabled: !habilitado,
	                                style: {
	                                  color: "#000000"
	                                },
	                                id: "preciominimo",
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange,
	                                ref: txtPrecioMiniSinImp,
	                                className: "form-control form-control-sm text-right fs-6"
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              null,
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                autoComplete: "off",
	                                disabled: !habilitado,
	                                ref: txtUtilidadMini,
	                                className: "form-control form-control-sm text-right fs-6",
	                                id: "utilidadMini",
	                                onFocus: _varios.seleccionarCampo,
	                                onKeyUp: handleInputMontoChange,
	                                onBlur: handleInputMontoChange
	                              })
	                            ),
	                            _react2.default.createElement(
	                              "td",
	                              { className: "border-right" },
	                              _react2.default.createElement("input", {
	                                type: "text",
	                                disabled: true,
	                                ref: txtPrecioMiniConImp,
	                                className: "form-control form-control-sm text-right fs-6"
	                              })
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 row mx-auto m-0 mb-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-5 ml-auto" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row align-items-center rounded py-1" },
	                      _react2.default.createElement(
	                        "span",
	                        { className: " fw-bold col-md-6 mb-0 fs-6" },
	                        "Unidad Alterna"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col row align-items-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check col" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input mt-0",
	                            type: "radio",
	                            disabled: !habilitado,
	                            ref: radioSi,
	                            name: "flexRadioDefault",
	                            id: "flexRadioDefault1",
	                            onChange: unidadAlterna
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label fs-6",
	                              htmlFor: "flexRadioDefault1"
	                            },
	                            "Si"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col row align-items-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check col" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input mt-0",
	                            type: "radio",
	                            disabled: !habilitado,
	                            ref: radioNo,
	                            name: "flexRadioDefault",
	                            id: "flexRadioDefault1",
	                            onChange: unidadAlterna
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label fs-6",
	                              htmlFor: "flexRadioDefault1"
	                            },
	                            "No"
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 d-flex justify-content-between py-1" },
	                  visibleBtn === "visible" ? _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 col-sm-12 col-lg-12 col-12  justify-content-start px-0" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        ref: btnIncluir,
	                        onClick: onBotones(1),
	                        disabled: !habilitadoBot,
	                        className: "btn btn-sm mx-1 btn-primary rounded-pill",
	                        title: "Incluir Producto"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-plus" },
	                        " Incluir "
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        ref: btnConsultar,
	                        onClick: onBotones(4),
	                        disabled: !habilitadoBot,
	                        className: "btn btn-sm mx-1 btn-info rounded-pill",
	                        title: "Consultar Producto"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-eye" },
	                        "Consultar"
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        ref: btnEditar,
	                        onClick: onBotones(2),
	                        disabled: !habilitadoBot,
	                        className: "btn btn-sm mx-1 btn-warning rounded-pill",
	                        title: "Modificar Producto"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fa fa-edit" },
	                        "Modificar"
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        ref: btnEliminar,
	                        onClick: onBotones(3),
	                        disabled: !habilitadoBot,
	                        className: "btn btn-sm mx-1 btn-danger rounded-pill",
	                        title: "Eliminar Producto"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fa fa-trash" },
	                        "Eliminar"
	                      ),
	                      " "
	                    )
	                  ) : "",
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-md-12 d-flex justify-content-end",
	                      style: {
	                        visibility: visibleBtn === "visible" ? "collapse" : "visible"
	                      }
	                    },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        ref: btnAceptar,
	                        onClick: onBotones(5),
	                        disabled: operacion === 4 ? true : habilitadoBot,
	                        className: "mx-2 btn btn-sm rounded-pill btn-success"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-check-circle" },
	                        " Aceptar"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        ref: btnCancelar,
	                        onClick: onBotones(6),
	                        disabled: habilitadoBot,
	                        className: "mx-2 btn btn-danger btn-sm rounded-pill"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-window-close" },
	                        " Cancelar"
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: tabPanel.tab2,
	                id: "ex-with-icons-tabs-2",
	                role: "tabpanel",
	                "aria-labelledby": "ex-with-icons-tab-2"
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-md-12 row m-0 px-0",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 row mx-auto bg-light rounded shadow py-3" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 mx-auto mb-" },
	                    _react2.default.createElement(
	                      "fieldset",
	                      { className: " row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between" },
	                      _react2.default.createElement(
	                        "legend",
	                        {
	                          className: "float-none w-auto fw-bold",
	                          style: { fontSize: "15px" }
	                        },
	                        "Configuraci\xF3n"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-4" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "UNID. PRINCIPAL:"
	                        ),
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            disabled: !habilitadoAlter,
	                            ref: cmbUniPrincipal,
	                            className: "form-select form-select-sm ",
	                            "aria-label": ".form-select-sm example",
	                            name: "unidadP",
	                            onChange: onChange
	                          },
	                          _react2.default.createElement(
	                            "option",
	                            { value: "" },
	                            "--seleccione--"
	                          ),
	                          unidadM && unidadM.map(function (unimedi) {
	                            return _react2.default.createElement(
	                              "option",
	                              {
	                                key: unimedi.idunidadmedida,
	                                value: unimedi.idunidadmedida
	                              },
	                              " ",
	                              unimedi.descripcion
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-4" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "UNID. ALTERNA:"
	                        ),
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            disabled: !habilitadoAlter,
	                            ref: cmbUniAlterna,
	                            className: "form-select form-select-sm ",
	                            "aria-label": ".form-select-sm example",
	                            name: "unidadA",
	                            onChange: onChange
	                          },
	                          unidadM && unidadM.map(function (unimedi) {
	                            return _react2.default.createElement(
	                              "option",
	                              {
	                                key: unimedi.idunidadmedida,
	                                value: unimedi.idunidadmedida
	                              },
	                              " ",
	                              unimedi.descripcion
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-4" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "UNID. VENTA:"
	                        ),
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            disabled: !habilitadoAlter,
	                            ref: cmbUniVenta,
	                            className: "form-select form-select-sm ",
	                            "aria-label": ".form-select-sm example"
	                          },
	                          unidadV && unidadV.map(function (univ) {
	                            return _react2.default.createElement(
	                              "option",
	                              {
	                                key: univ.idunidadmedida,
	                                value: univ.idunidadmedida
	                              },
	                              univ.descripcion
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-7" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          " ",
	                          "FACTOR CONVERSION:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          autoComplete: "off",
	                          disabled: !habilitadoAlter,
	                          ref: txtFactor,
	                          className: "form-control col-md-3 form-control-sm text-right fs-6",
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm",
	                          id: "factorConver",
	                          onFocus: _varios.seleccionarCampo,
	                          onKeyUp: handleInputMontoChange,
	                          onBlur: handleInputMontoChange
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          { className: "px-2" },
	                          "x"
	                        ),
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            disabled: !habilitadoAlter,
	                            ref: cmbUniFactor,
	                            className: "form-select form-select-sm ",
	                            "aria-label": ".form-select-sm example",
	                            name: "unifactor",
	                            onChange: onChange
	                          },
	                          factor && factor.map(function (fac) {
	                            return _react2.default.createElement(
	                              "option",
	                              { key: fac.iduni, value: fac.iduni },
	                              " ",
	                              fac.descripcion
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-4" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "UNID. COMPRA:"
	                        ),
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            disabled: !habilitadoAlter,
	                            ref: cmbUniCompra,
	                            className: "form-select form-select-sm ",
	                            "aria-label": ".form-select-sm example"
	                          },
	                          unidadC && unidadC.map(function (unic) {
	                            return _react2.default.createElement(
	                              "option",
	                              {
	                                key: unic.idunidadmedida,
	                                value: unic.idunidadmedida
	                              },
	                              unic.descripcion
	                            );
	                          })
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement("div", { className: "input-group input-group-sm mb-2 col-md-8" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-1 col-md-5 ml-auto" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        className: "btn btn-primary w-100",
	                        id: "inputGroup-sizing-sm",
	                        onClick: function onClick() {
	                          txtUtilidadMaxiAlter.current.value = txtUtilidadMaxi.current.value;
	                          txtUtilidadOfeAlter.current.value = txtUtilidadOfe.current.value;
	                          txtUtilidadMayorAlter.current.value = txtUtilidadMayor.current.value;
	                          txtUtilidadMiniAlter.current.value = txtUtilidadMini.current.value;
	                          txtPrecioMaxiSinImpAlter.current.style.color = txtPrecioMaxiSinImp.current.style.color;
	                          txtPrecioOfeSinImpAlter.current.style.color = txtPrecioOfeSinImp.current.style.color;
	                          txtPrecioMayorSinImpAlter.current.style.color = txtPrecioMayorSinImp.current.style.color;
	                          txtPrecioMiniSinImpAlter.current.style.color = txtPrecioMiniSinImp.current.style.color;
	                          calcularUtilidadAlter(5);
	                        }
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-exchange-alt" },
	                        " ",
	                        "APLICAR % DE UTILIDAD DE LA UNIDAD PRINCIPAL"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 mx-auto row mt-2 mb-2" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-6 px-0" },
	                      _react2.default.createElement(
	                        "fieldset",
	                        { className: "row col-sm-12 border-azul rounded d-flex justify-content-between" },
	                        _react2.default.createElement(
	                          "table",
	                          { className: "table table-sm col-md-12 border bg-light" },
	                          _react2.default.createElement(
	                            "thead",
	                            { className: "azulGradiant text-light fw-bold" },
	                            _react2.default.createElement(
	                              "tr",
	                              null,
	                              _react2.default.createElement(
	                                "th",
	                                { className: "text-center", scope: "col" },
	                                _react2.default.createElement(
	                                  "label",
	                                  { style: { fontSize: "11px" } },
	                                  "COSTOS"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "th",
	                                { className: "text-center", scope: "col" },
	                                _react2.default.createElement(
	                                  "label",
	                                  { style: { fontSize: "11px" } },
	                                  "SIN IMPUESTO"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "th",
	                                {
	                                  className: "text-center border-right border-light",
	                                  scope: "col"
	                                },
	                                _react2.default.createElement(
	                                  "label",
	                                  { style: { fontSize: "11px" } },
	                                  "CON IMPUESTO"
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "tbody",
	                            null,
	                            _react2.default.createElement(
	                              "tr",
	                              null,
	                              _react2.default.createElement(
	                                "td",
	                                { className: "text-center border-left" },
	                                costoSelect === "1" && _react2.default.createElement("i", { className: "fas fa-arrow-right text-danger" }),
	                                " ",
	                                "Costo Proveedor: ",
	                                _react2.default.createElement(
	                                  "b",
	                                  null,
	                                  monedaCambio.simbolo
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "td",
	                                { style: { width: "30%" } },
	                                _react2.default.createElement("input", {
	                                  type: "text",
	                                  autoComplete: "off",
	                                  disabled: !habilitadoAlter,
	                                  ref: txtCostoProveSinImpAlter,
	                                  className: "form-control form-control-sm text-right fs-6",
	                                  id: "costoProveSinImpuAlter",
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "td",
	                                {
	                                  className: "border-right",
	                                  style: { width: "30%" }
	                                },
	                                _react2.default.createElement("input", {
	                                  type: "text",
	                                  disabled: true,
	                                  ref: txtCostoProveConImpAlter,
	                                  className: "form-control form-control-sm text-right fs-6"
	                                })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "tr",
	                              null,
	                              _react2.default.createElement(
	                                "td",
	                                { className: "text-center border-left" },
	                                costoSelect === "2" && _react2.default.createElement("i", { className: "fas fa-arrow-right text-danger" }),
	                                " ",
	                                "Costo Calculado: ",
	                                _react2.default.createElement(
	                                  "b",
	                                  null,
	                                  monedaCambio.simbolo
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement("input", {
	                                  type: "text",
	                                  autoComplete: "off",
	                                  disabled: !habilitadoAlter,
	                                  ref: txtCostoCalcuSinImpAlter,
	                                  className: "form-control form-control-sm text-right fs-6",
	                                  id: "costoCalcuSinImpuAlter",
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "td",
	                                { className: "border-right" },
	                                _react2.default.createElement("input", {
	                                  type: "text",
	                                  disabled: true,
	                                  ref: txtCostoCalcuConImpAlter,
	                                  className: "form-control form-control-sm text-right fs-6"
	                                })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "tr",
	                              null,
	                              _react2.default.createElement(
	                                "td",
	                                { className: "text-center border-left" },
	                                costoSelect === "3" && _react2.default.createElement("i", { className: "fas fa-arrow-right text-danger" }),
	                                " ",
	                                "Ultimo Costo: ",
	                                _react2.default.createElement(
	                                  "b",
	                                  null,
	                                  monedaCambio.simbolo
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement("input", {
	                                  type: "text",
	                                  autoComplete: "off",
	                                  disabled: !habilitadoAlter,
	                                  ref: txtUltimoCostoSinImpAlter,
	                                  className: "form-control form-control-sm text-right fs-6",
	                                  id: "costoUltiSinImpuAlter",
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "td",
	                                { className: "border-right" },
	                                _react2.default.createElement("input", {
	                                  type: "text",
	                                  disabled: true,
	                                  ref: txtUltimoCostoConImpAlter,
	                                  className: "form-control form-control-sm text-right fs-6"
	                                })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "tr",
	                              null,
	                              _react2.default.createElement(
	                                "td",
	                                { className: "text-center border-left" },
	                                costoSelect === "4" && _react2.default.createElement("i", { className: "fas fa-arrow-right text-danger" }),
	                                " ",
	                                "Costo Promedio: ",
	                                _react2.default.createElement(
	                                  "b",
	                                  null,
	                                  monedaCambio.simbolo
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement("input", {
	                                  type: "text",
	                                  autoComplete: "off",
	                                  disabled: !habilitadoAlter,
	                                  ref: txtCostoPromeSinImpAlter,
	                                  className: "form-control form-control-sm text-right fs-6",
	                                  id: "costoPromeSinImpuAlter",
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "td",
	                                { className: "border-right" },
	                                _react2.default.createElement("input", {
	                                  type: "text",
	                                  disabled: true,
	                                  ref: txtCostoPromeConImpAlter,
	                                  className: "form-control form-control-sm text-right fs-6"
	                                })
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-6 px-0" },
	                      _react2.default.createElement(
	                        "fieldset",
	                        { className: " row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between" },
	                        _react2.default.createElement(
	                          "table",
	                          { className: "table table-sm col-md-12 border bg-light" },
	                          _react2.default.createElement(
	                            "thead",
	                            { className: "azulGradiant text-light fw-bold" },
	                            _react2.default.createElement(
	                              "tr",
	                              null,
	                              _react2.default.createElement(
	                                "th",
	                                { className: "text-center", scope: "col" },
	                                _react2.default.createElement(
	                                  "label",
	                                  { style: { fontSize: "11px" } },
	                                  "PRECIOS"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "th",
	                                { className: "text-center ", scope: "col" },
	                                _react2.default.createElement(
	                                  "label",
	                                  { style: { fontSize: "11px" } },
	                                  "SIN IMPUESTO"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "th",
	                                { className: "text-center", scope: "col" },
	                                _react2.default.createElement(
	                                  "label",
	                                  { style: { fontSize: "11px" } },
	                                  "UTILIDAD %"
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "th",
	                                { className: "text-center", scope: "col" },
	                                _react2.default.createElement(
	                                  "label",
	                                  { style: { fontSize: "11px" } },
	                                  "CON IMPUESTO"
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "tbody",
	                            null,
	                            _react2.default.createElement(
	                              "tr",
	                              null,
	                              _react2.default.createElement(
	                                "td",
	                                {
	                                  style: { width: "15%" },
	                                  className: "text-center"
	                                },
	                                precioSelect === "1" && _react2.default.createElement("i", { className: "fas fa-arrow-right text-danger" }),
	                                " ",
	                                "Maximo: ",
	                                _react2.default.createElement(
	                                  "b",
	                                  null,
	                                  monedaCambio.simbolo
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "td",
	                                { style: { width: "15%" } },
	                                _react2.default.createElement("input", {
	                                  type: "text",
	                                  autoComplete: "off",
	                                  disabled: !habilitadoAlter,
	                                  style: {
	                                    color: "#000000"
	                                  },
	                                  id: "preciomaximoalter",
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange,
	                                  ref: txtPrecioMaxiSinImpAlter,
	                                  className: "form-control form-control-sm text-right fs-6"
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "td",
	                                { style: { width: "12%" } },
	                                _react2.default.createElement("input", {
	                                  type: "text",
	                                  autoComplete: "off",
	                                  disabled: !habilitadoAlter,
	                                  ref: txtUtilidadMaxiAlter,
	                                  className: "form-control form-control-sm text-right fs-6",
	                                  id: "utilidadMaxiAlter",
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "td",
	                                {
	                                  className: "border-right",
	                                  style: { width: "18%" }
	                                },
	                                _react2.default.createElement("input", {
	                                  type: "text",
	                                  disabled: true,
	                                  ref: txtPrecioMaxiConImpAlter,
	                                  className: "form-control form-control-sm text-right fs-6"
	                                })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "tr",
	                              null,
	                              _react2.default.createElement(
	                                "td",
	                                {
	                                  style: { width: "15%" },
	                                  className: "text-center"
	                                },
	                                precioSelect === "2" && _react2.default.createElement("i", { className: "fas fa-arrow-right text-danger" }),
	                                " ",
	                                "Oferta: ",
	                                _react2.default.createElement(
	                                  "b",
	                                  null,
	                                  monedaCambio.simbolo
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement("input", {
	                                  type: "text",
	                                  autoComplete: "off",
	                                  disabled: !habilitadoAlter,
	                                  style: {
	                                    color: "#000000"
	                                  },
	                                  id: "precioofertaalter",
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange,
	                                  ref: txtPrecioOfeSinImpAlter,
	                                  className: "form-control form-control-sm text-right fs-6"
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement("input", {
	                                  type: "text",
	                                  autoComplete: "off",
	                                  disabled: !habilitadoAlter,
	                                  ref: txtUtilidadOfeAlter,
	                                  className: "form-control form-control-sm text-right fs-6",
	                                  id: "utilidadOfeAlter",
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "td",
	                                { className: "border-right" },
	                                _react2.default.createElement("input", {
	                                  type: "text",
	                                  disabled: true,
	                                  ref: txtPrecioOfeConImpAlter,
	                                  className: "form-control form-control-sm text-right fs-6"
	                                })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "tr",
	                              null,
	                              _react2.default.createElement(
	                                "td",
	                                {
	                                  style: { width: "15%" },
	                                  className: "text-center"
	                                },
	                                precioSelect === "3" && _react2.default.createElement("i", { className: "fas fa-arrow-right text-danger" }),
	                                " ",
	                                "Mayor: ",
	                                _react2.default.createElement(
	                                  "b",
	                                  null,
	                                  monedaCambio.simbolo
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement("input", {
	                                  type: "text",
	                                  autoComplete: "off",
	                                  disabled: !habilitadoAlter,
	                                  id: "preciomayoralter",
	                                  style: {
	                                    color: "#000000"
	                                  },
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange,
	                                  ref: txtPrecioMayorSinImpAlter,
	                                  className: "form-control form-control-sm text-right fs-6"
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement("input", {
	                                  type: "text",
	                                  autoComplete: "off",
	                                  disabled: !habilitadoAlter,
	                                  ref: txtUtilidadMayorAlter,
	                                  className: "form-control form-control-sm text-right fs-6",
	                                  id: "utilidadMayorAlter",
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "td",
	                                { className: "border-right" },
	                                _react2.default.createElement("input", {
	                                  type: "text",
	                                  disabled: true,
	                                  ref: txtPrecioMayorConImpAlter,
	                                  className: "form-control form-control-sm text-right fs-6"
	                                })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              "tr",
	                              null,
	                              _react2.default.createElement(
	                                "td",
	                                {
	                                  style: { width: "15%" },
	                                  className: "text-center"
	                                },
	                                precioSelect === "4" && _react2.default.createElement("i", { className: "fas fa-arrow-right text-danger" }),
	                                " ",
	                                "Minimo: ",
	                                _react2.default.createElement(
	                                  "b",
	                                  null,
	                                  monedaCambio.simbolo
	                                )
	                              ),
	                              _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement("input", {
	                                  type: "text",
	                                  autoComplete: "off",
	                                  disabled: !habilitadoAlter,
	                                  id: "preciominialter",
	                                  style: {
	                                    color: "#000000"
	                                  },
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange,
	                                  ref: txtPrecioMiniSinImpAlter,
	                                  className: "form-control form-control-sm text-right fs-6"
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "td",
	                                null,
	                                _react2.default.createElement("input", {
	                                  type: "text",
	                                  autoComplete: "off",
	                                  disabled: !habilitadoAlter,
	                                  ref: txtUtilidadMiniAlter,
	                                  className: "form-control form-control-sm text-right fs-6",
	                                  id: "utilidadMiniAlter",
	                                  onFocus: _varios.seleccionarCampo,
	                                  onKeyUp: handleInputMontoChange,
	                                  onBlur: handleInputMontoChange
	                                })
	                              ),
	                              _react2.default.createElement(
	                                "td",
	                                { className: "border-right" },
	                                _react2.default.createElement("input", {
	                                  type: "text",
	                                  disabled: true,
	                                  ref: txtPrecioMiniConImpAlter,
	                                  className: "form-control form-control-sm text-right fs-6"
	                                })
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement("div", {
	              className: "tab-pane fade",
	              id: "ex-with-icons-tabs-3",
	              role: "tabpanel",
	              "aria-labelledby": "ex-with-icons-tab-3"
	            })
	          )
	        ),
	        windowWidth >= 1600 && _react2.default.createElement(
	          "div",
	          { className: " col-xl-3 col-lg-3 col-md-12 row mx-auto" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 mx-auto mx-0" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: " mb-2 col-xl-6 col-lg-6 col-md-6 mx-auto d-flex justify-content-center",
	                style: { height: 150, width: 100 }
	              },
	              _react2.default.createElement("img", {
	                src: pathImage.imagen,
	                className: "shadow position-absolute",
	                style: {
	                  height: 150,
	                  width: 150,
	                  objectFit: "none",
	                  backgroundColor: "#FFFFFF"
	                },
	                alt: ""
	              }),
	              _react2.default.createElement("input", {
	                type: "file",
	                disabled: !habilitado,
	                style: { opacity: 0, height: 150, width: 100 },
	                onChange: handleUpload,
	                name: "imagen",
	                accept: "image/jpeg, image/png",
	                className: "btn"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-xl-12 col-lg-12 h-70 col-md-6 card mx-auto " /*  style={{ height: '72%' }} */
	              },
	              _react2.default.createElement(
	                "label",
	                { className: "text-center mt-2 azulGradiant py-2 text-light rounded" },
	                "Stock Producto: ",
	                _react2.default.createElement("br", null),
	                " \"",
	                nomProducto,
	                "\""
	              ),
	              _react2.default.createElement(
	                "span",
	                { className: "mb-2" },
	                _react2.default.createElement("span", {
	                  className: "mx-2 py-1 px-4 rounded",
	                  style: { backgroundColor: "rgba(251, 0, 0, 0.67)" }
	                }),
	                "Stock Minimo"
	              ),
	              _react2.default.createElement(
	                "span",
	                { className: "mb-2" },
	                _react2.default.createElement("span", {
	                  className: "mx-2 py-1 px-4 rounded",
	                  style: { backgroundColor: "rgba(23, 185, 0, 0.79)" }
	                }),
	                "Stock Maximo"
	              ),
	              _react2.default.createElement(
	                "span",
	                { className: "mb-2" },
	                _react2.default.createElement(
	                  "span",
	                  {
	                    className: " rounded px-3 fw-bold",
	                    style: { color: "rgb(239, 127, 92)" }
	                  },
	                  "-----"
	                ),
	                "Existencia del Producto"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-12 my-0 mx-auto py-2 justify-content-center px-0" },
	                _react2.default.createElement(_reactCanvasGauges.RadialGauge, {
	                  key: "radialGauge",
	                  height: 180,
	                  maxValue: flujo[12] ? flujo[12] : flujo[10],
	                  majorTicks: flujo,
	                  minorTicks: 2,
	                  strokeTicks: true,
	                  highlights: [{
	                    from: 0,
	                    to: stockMinimo,
	                    color: "rgba(251, 0, 0, 0.67)"
	                  }, {
	                    from: stockMinimo,
	                    to: flujo[12] ? flujo[12] : flujo[10],
	                    color: "rgba(23, 185, 0, 0.79)"
	                  }],
	                  value: cantidadProd,
	                  gaugeType: "RADIAL",
	                  borderShadowWidth: 1,
	                  borders: true,
	                  needleType: "arrow",
	                  needleWidth: 2,
	                  needleCircleSize: 7,
	                  needleCircleOuter: true,
	                  needleCircleInner: false,
	                  animationDuration: 1500,
	                  animationRule: "linear"
	                })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_modalActualizarProductos.ActualizarProductos, {
	      show: mostrarActualizar,
	      onHide: function onHide() {
	        setMostrarActualizar(false);
	      }
	    }),
	    _react2.default.createElement(_modalActualizarProductExcel.ActualizarProductosExcel, {
	      show: mostrarActualizar2,
	      onHide: function onHide() {
	        setMostrarActualizar2(false);
	      }
	    }),
	    _react2.default.createElement(_gestionarMarca.GestionarMarca, {
	      show: mostrarMarca,
	      onHideCancela: function onHideCancela() {
	        setMostrarMarca(false);
	      },
	      onHideRenderizar: seleccionarMarca,
	      llamado: 2
	    }),
	    _react2.default.createElement(_gestionarModelo.GestionarModelo, {
	      show: mostrarModelo,
	      onHideCancela: function onHideCancela() {
	        setMostrarModelo(false);
	      },
	      onHideRenderizar: seleccionarModelo,
	      llamado: 2
	    }),
	    _react2.default.createElement(_gestionarTipoProducto.GestionarTipoProducto, {
	      show: mostrarTipoP,
	      onHideCancela: function onHideCancela() {
	        setMostrarTipoP(false);
	      },
	      onHideRenderizar: seleccionarTipoProd,
	      llamado: 2
	    }),
	    _react2.default.createElement(_gestionarFabricante.GestionarFabricantes, {
	      show: mostrarFabricante,
	      onHideCancela: function onHideCancela() {
	        setMostrarFabricante(false);
	      },
	      onHideRenderizar: seleccionarFabricante,
	      llamado: 2
	    }),
	    _react2.default.createElement(_gestionarClasificadorVacios.GestionarClasificadorVacios, {
	      show: mostrarclassvacio,
	      onHideCancela: function onHideCancela() {
	        setMostrarclassvacio(false);
	      },
	      onHideRenderizar: seleccionarClassVacios,
	      llamado: 2
	    }),
	    _react2.default.createElement(_gestionarUnidadMedida.GestionarMedida, {
	      show: mostrarMedida,
	      onHideRenderizar: agregarUnidad,
	      onHideCancela: function onHideCancela() {
	        setMostrarMedida(false);
	      },
	      llamado: 2
	    }),
	    _react2.default.createElement(_catalogoProducto2.default, {
	      show: catalogoProducto,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoProducto(false);
	      },
	      onHideAceptaCatalogo: onCatalogoProducto
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = TablaProdTerminadoe;

/***/ },
/* 7069 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(19);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _gestionarProducto = __webpack_require__(662);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _varios = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TablaTipoProducto = function TablaTipoProducto(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var municipios = [];
	
	  var headCells = [{ id: 'codigo', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'COD.', textAlign: 'center' }, { id: 'nombre', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'TIPO PRODUCTO', textAlign: 'center' }, { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }];
	
	  var colores = ['#17a2b8', '#ffae00', '#dc3545', '#BDB76B', '#7B68EE', '#4B0082', '#00ffff', '#0080ff', '#0000ff', '#8000ff', '#ff00ff', '#ff0080'];
	
	  var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      mensajesino = _useState4[0],
	      setMensajesino = _useState4[1];
	
	  var txtBuscador = (0, _react.useRef)();
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mostrar = _useState6[0],
	      setMostrar = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mostrar2 = _useState8[0],
	      setMostrar2 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      activate = _useState10[0],
	      setActivate = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([{
	    codigo: 1,
	    nombre: 'JESUS',
	    descripcion: 'ALMACEN 1'
	  }]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      records = _useState12[0],
	      setRecords = _useState12[1];
	
	  var _useState13 = (0, _react.useState)([]),
	      _useState14 = _slicedToArray(_useState13, 2),
	      expendedor = _useState14[0],
	      setExpendedor = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(1),
	      _useState16 = _slicedToArray(_useState15, 2),
	      operacion = _useState16[0],
	      setOperacion = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(),
	      _useState18 = _slicedToArray(_useState17, 2),
	      persona = _useState18[0],
	      setPersona = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({ fn: function fn(items) {
	      return items;
	    } }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      filterFn = _useState20[0],
	      setFilterFn = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(),
	      _useState22 = _slicedToArray(_useState21, 2),
	      ciudades = _useState22[0],
	      setCiudades = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(),
	      _useState24 = _slicedToArray(_useState23, 2),
	      credito = _useState24[0],
	      setCredito = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(0),
	      _useState26 = _slicedToArray(_useState25, 2),
	      total = _useState26[0],
	      setTotal = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      activos = _useState28[0],
	      setActivos = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(0),
	      _useState30 = _slicedToArray(_useState29, 2),
	      inactivos = _useState30[0],
	      setInactivos = _useState30[1];
	
	  var _useState31 = (0, _react.useState)([]),
	      _useState32 = _slicedToArray(_useState31, 2),
	      municipiosEx = _useState32[0],
	      setMunicipiosEx = _useState32[1];
	
	  var _useState33 = (0, _react.useState)([]),
	      _useState34 = _slicedToArray(_useState33, 2),
	      municipiosData = _useState34[0],
	      setMunicipiosData = _useState34[1];
	
	  var _useState35 = (0, _react.useState)([]),
	      _useState36 = _slicedToArray(_useState35, 2),
	      datos = _useState36[0],
	      setDatos = _useState36[1];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting,
	      TblPagination = _useTable.TblPagination;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	    var st = '';
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") return items;else return items.filter(function (x) {
	          st = x.status === '51' ? 'activo' : 'inactivo';
	          if (x.idagente.includes(target.value) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.rif.toLowerCase().includes(target.value.toLowerCase()) || x.nrolicencia.toLowerCase().includes(target.value.toLowerCase()) || st.toLowerCase().includes(target.value.toLowerCase())) {
	            return x;
	          }
	        });
	      }
	    });
	  };
	
	  var gestionarExpendedor = function gestionarExpendedor(op, id) {
	    return function (e) {
	      if (op === 4) {
	        setOperacion(4);
	        /*    getExpendedor(id); */
	      } else if (op === 1) {
	        setOperacion(op);
	        setMostrar(true);
	      } else if (op === 2) {
	        setOperacion(op);
	        /*   getExpendedor(id); */
	      } else if (op === 3) {
	        setOperacion(op);
	        /*       getExpendedor(id); */
	      }
	    };
	  };
	
	  var selectCiudad = function selectCiudad(id) {
	    var campos = '*';
	    var nomtab = 'ciudad';
	    var nomid = 'idmunicipio';
	    var endpoint = op.conexion + '/api/consulta/modelirows?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid;
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setCiudades(response.data);
	        setMostrar2(true);
	      }
	    }).catch(function (error) {
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var handleCancela2 = function handleCancela2() {
	    setMostrar2(false);
	    setExpendedor('');
	    setCredito('');
	  };
	
	  var cerramodal = function cerramodal() {
	
	    setMostrar(false);
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    /*  getExpendedor(); */
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  (0, _react.useEffect)(function () {
	
	    /*  setActivate(true); */
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', width: '100%' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'row col-md-12', style: { margin: 0 } },
	      _react2.default.createElement(
	        'div',
	        { className: 'row col-md-12', style: { margin: 0 } },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-8 py-3 mx-auto mt-5' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 p-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row col-12 d-flex justify-content-between' },
	              _react2.default.createElement('input', { type: 'text', className: ' col-3 form-control form-control-sm rounded-pill', ref: txtBuscador, onChange: handleSearch, placeholder: 'Buscar' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-3 d-flex justify-content-end' },
	                _react2.default.createElement(
	                  'button',
	                  { onClick: gestionarExpendedor(1, ''), style: { marginBottom: "5px" }, className: 'btn btn-sm btn-primary rounded-circle' },
	                  _react2.default.createElement('i', { className: 'fas fa-plus' }),
	                  ' '
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12', style: { margin: "auto" } },
	            _react2.default.createElement(
	              TblContainer,
	              null,
	              _react2.default.createElement(TblHead, null),
	              _react2.default.createElement(
	                _core.TableBody,
	                null,
	                records && recordsAfterPagingAndSorting().map(function (item, index) {
	                  return _react2.default.createElement(
	                    _core.TableRow,
	                    { key: index, style: { padding: "0" } },
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                      item.codigo
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center', width: '270px' } },
	                      item.descripcion
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: gestionarExpendedor(4, item.codigo), className: 'btn btn-sm mx-1 btn-info rounded-circle' },
	                        _react2.default.createElement('i', { className: 'fas fa-eye' }),
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: gestionarExpendedor(2, item.codigo), className: 'btn btn-sm mx-1 btn-warning rounded-circle' },
	                        _react2.default.createElement('i', { className: 'fa fa-edit' }),
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: gestionarExpendedor(3, item.codigo), className: 'btn btn-sm mx-1 btn-danger rounded-circle' },
	                        _react2.default.createElement('i', { className: 'fa fa-trash' }),
	                        ' '
	                      )
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(TblPagination, null)
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_gestionarProducto.GestionarProducto, {
	      show: mostrar,
	      onHideCancela: cerramodal,
	      operacion: operacion
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        'cargando...'
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	      } }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	      }, onHideSi: handleCloseSi })
	  );
	};
	exports.default = TablaTipoProducto;

/***/ },
/* 7070 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(19);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _gestionarUnidadMedida = __webpack_require__(213);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _varios = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TablaUnidMedidas = function TablaUnidMedidas(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var municipios = [];
	
	  var headCells = [{ id: '', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'COD.', textAlign: 'center' }, { id: '', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' }, { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }];
	
	  var colores = ['#17a2b8', '#ffae00', '#dc3545', '#BDB76B', '#7B68EE', '#4B0082', '#00ffff', '#0080ff', '#0000ff', '#8000ff', '#ff00ff', '#ff0080'];
	
	  var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      mensajesino = _useState4[0],
	      setMensajesino = _useState4[1];
	
	  var txtBuscador = (0, _react.useRef)();
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mostrar = _useState6[0],
	      setMostrar = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mostrar2 = _useState8[0],
	      setMostrar2 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      activate = _useState10[0],
	      setActivate = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([{
	    codigo: 1,
	    nombre: 'JESUS',
	    descripcion: 'ALMACEN 1'
	  }]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      records = _useState12[0],
	      setRecords = _useState12[1];
	
	  var _useState13 = (0, _react.useState)([]),
	      _useState14 = _slicedToArray(_useState13, 2),
	      expendedor = _useState14[0],
	      setExpendedor = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(1),
	      _useState16 = _slicedToArray(_useState15, 2),
	      operacion = _useState16[0],
	      setOperacion = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(),
	      _useState18 = _slicedToArray(_useState17, 2),
	      persona = _useState18[0],
	      setPersona = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({ fn: function fn(items) {
	      return items;
	    } }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      filterFn = _useState20[0],
	      setFilterFn = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(),
	      _useState22 = _slicedToArray(_useState21, 2),
	      ciudades = _useState22[0],
	      setCiudades = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(),
	      _useState24 = _slicedToArray(_useState23, 2),
	      credito = _useState24[0],
	      setCredito = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(0),
	      _useState26 = _slicedToArray(_useState25, 2),
	      total = _useState26[0],
	      setTotal = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      activos = _useState28[0],
	      setActivos = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(0),
	      _useState30 = _slicedToArray(_useState29, 2),
	      inactivos = _useState30[0],
	      setInactivos = _useState30[1];
	
	  var _useState31 = (0, _react.useState)([]),
	      _useState32 = _slicedToArray(_useState31, 2),
	      municipiosEx = _useState32[0],
	      setMunicipiosEx = _useState32[1];
	
	  var _useState33 = (0, _react.useState)([]),
	      _useState34 = _slicedToArray(_useState33, 2),
	      municipiosData = _useState34[0],
	      setMunicipiosData = _useState34[1];
	
	  var _useState35 = (0, _react.useState)([]),
	      _useState36 = _slicedToArray(_useState35, 2),
	      datos = _useState36[0],
	      setDatos = _useState36[1];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting,
	      TblPagination = _useTable.TblPagination;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	    var st = '';
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") return items;else return items.filter(function (x) {
	          st = x.status === '51' ? 'activo' : 'inactivo';
	          if (x.idagente.includes(target.value) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.rif.toLowerCase().includes(target.value.toLowerCase()) || x.nrolicencia.toLowerCase().includes(target.value.toLowerCase()) || st.toLowerCase().includes(target.value.toLowerCase())) {
	            return x;
	          }
	        });
	      }
	    });
	  };
	
	  var gestionarExpendedor = function gestionarExpendedor(op, id) {
	    return function (e) {
	      if (op === 4) {
	        setOperacion(4);
	        /*    getExpendedor(id); */
	      } else if (op === 1) {
	        setOperacion(op);
	        setMostrar(true);
	      } else if (op === 2) {
	        setOperacion(op);
	        /*   getExpendedor(id); */
	      } else if (op === 3) {
	        setOperacion(op);
	        /*       getExpendedor(id); */
	      }
	    };
	  };
	
	  var selectCiudad = function selectCiudad(id) {
	    var campos = '*';
	    var nomtab = 'ciudad';
	    var nomid = 'idmunicipio';
	    var endpoint = op.conexion + '/api/consulta/modelirows?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid;
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setCiudades(response.data);
	        setMostrar2(true);
	      }
	    }).catch(function (error) {
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var handleCancela2 = function handleCancela2() {
	    setMostrar2(false);
	    setExpendedor('');
	    setCredito('');
	  };
	
	  var cerramodal = function cerramodal() {
	
	    setMostrar(false);
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    /*  getExpendedor(); */
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  (0, _react.useEffect)(function () {
	
	    /*  setActivate(true); */
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', width: '100%' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'row col-md-12', style: { margin: 0 } },
	      _react2.default.createElement(
	        'div',
	        { className: 'row col-md-12', style: { margin: 0 } },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-8 py-3 mx-auto mt-5' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 p-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row col-12 d-flex justify-content-between' },
	              _react2.default.createElement('input', { type: 'text', className: ' col-3 form-control form-control-sm rounded-pill', ref: txtBuscador, onChange: handleSearch, placeholder: 'Buscar' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-3 d-flex justify-content-end' },
	                _react2.default.createElement(
	                  'button',
	                  { onClick: gestionarExpendedor(1, ''), style: { marginBottom: "5px" }, className: 'btn btn-sm btn-primary rounded-circle' },
	                  _react2.default.createElement('i', { className: 'fas fa-plus' }),
	                  ' '
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12', style: { margin: "auto" } },
	            _react2.default.createElement(
	              TblContainer,
	              null,
	              _react2.default.createElement(TblHead, null),
	              _react2.default.createElement(
	                _core.TableBody,
	                null,
	                records && recordsAfterPagingAndSorting().map(function (item, index) {
	                  return _react2.default.createElement(
	                    _core.TableRow,
	                    { key: index, style: { padding: "0" } },
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                      item.codigo
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center', width: '270px' } },
	                      item.descripcion
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: gestionarExpendedor(4, item.codigo), className: 'btn btn-sm mx-1 btn-info rounded-circle' },
	                        _react2.default.createElement('i', { className: 'fas fa-eye' }),
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: gestionarExpendedor(2, item.codigo), className: 'btn btn-sm mx-1 btn-warning rounded-circle' },
	                        _react2.default.createElement('i', { className: 'fa fa-edit' }),
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: gestionarExpendedor(3, item.codigo), className: 'btn btn-sm mx-1 btn-danger rounded-circle' },
	                        _react2.default.createElement('i', { className: 'fa fa-trash' }),
	                        ' '
	                      )
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(TblPagination, null)
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_gestionarUnidadMedida.GestionarMedida, {
	      show: mostrar,
	      onHideCancela: cerramodal,
	      operacion: operacion
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        'cargando...'
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	      } }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	      }, onHideSi: handleCloseSi })
	  );
	};
	exports.default = TablaUnidMedidas;

/***/ },
/* 7071 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CartasBancos(props) {
	
	  return _react2.default.createElement(
	    "div",
	    { className: "row" },
	    _react2.default.createElement(
	      "div",
	      { className: "col-xl-4 col-sm-4 col-12 mb-4" },
	      _react2.default.createElement(
	        "div",
	        { className: "card" },
	        _react2.default.createElement(
	          "div",
	          { className: "card-body bg-card-info", style: { height: '120px' } },
	          _react2.default.createElement(
	            "div",
	            { className: "d-flex justify-content-between px-md-1" },
	            _react2.default.createElement(
	              "div",
	              { className: "align-self-center" },
	              _react2.default.createElement("i", { className: "fas fa-users  fa-3x" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "text-end" },
	              _react2.default.createElement(
	                "p",
	                { className: "mb-0 fw-bold" },
	                "Total ",
	                props.nombre
	              ),
	              _react2.default.createElement(
	                "h2",
	                null,
	                props.total
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement("div", { className: "col-xl-4 col-sm-4 col-12 mb-4" }),
	    _react2.default.createElement("div", { className: "col-xl-4 col-sm-4 col-12 mb-4" })
	  );
	}
	
	exports.default = CartasBancos;

/***/ },
/* 7072 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GestionarBancos = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var GestionarBancos = exports.GestionarBancos = function GestionarBancos(props) {
	
	    var token = sessionStorage.getItem('jwtToken');
	    var op = __webpack_require__(8);
	    var anio = JSON.parse(sessionStorage.getItem('anioactu'));
	    var fechaTope = (0, _moment2.default)(JSON.parse(sessionStorage.getItem('fechasistema'))).format('YYYY-MM-DD').replace(anio.toString(), (anio - 18).toString());
	    var deshabilitado = false;
	
	    /*  variables de referencias */
	    var btnCancela = (0, _react.useRef)();
	    var btnAcepta = (0, _react.useRef)();
	    var txtId = (0, _react.useRef)();
	    var txtDescripcion = (0, _react.useRef)();
	
	    /*  variables de estados */
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState4 = _slicedToArray(_useState3, 2),
	        mensajesino = _useState4[0],
	        setMensajesino = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(false),
	        _useState6 = _slicedToArray(_useState5, 2),
	        activate = _useState6[0],
	        setActivate = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(0),
	        _useState8 = _slicedToArray(_useState7, 2),
	        operacion = _useState8[0],
	        setOperacion = _useState8[1];
	
	    var _useState9 = (0, _react.useState)({
	        idbanco: '',
	        nombre: ''
	    }),
	        _useState10 = _slicedToArray(_useState9, 2),
	        values = _useState10[0],
	        setValues = _useState10[1];
	
	    var styleInput = {
	        backgroundColor: '#ffff',
	        color: '#444242'
	    };
	
	    var styleInputDirec = {
	        backgroundColor: '#ffff',
	        color: '#444242',
	        height: 50
	
	    };
	
	    var onChange = function onChange(event) {
	        if (event.target.name === 'rif' || event.target.name === 'nombre' || event.target.name === 'direccionage' || event.target.name === 'email' || event.target.name === 'nombrerespo' || event.target.name === 'aperespo' || event.target.name === 'propiEmail' || event.target.name === 'licencia' || event.target.name === 'resolucion') {
	            event.target.value = event.target.value.toUpperCase();
	            setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value.toUpperCase())));
	        }
	    };
	
	    var handleInputNumChange = function handleInputNumChange(event) {
	        event.preventDefault();
	        (0, _varios.validaSoloNumero)(event);
	        var valido;
	        if (event.which === 13 || typeof event.which === 'undefined') {
	
	            setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value)));
	        } else if (event.which === 46) {
	            return false;
	        } else if (event.which >= 48 && event.which <= 57) {
	            return true;
	        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	            return true;
	        } else return false; //alert(e.which);
	    };
	
	    var handleInputMontoChange = function handleInputMontoChange(event) {
	        (0, _varios.validaMonto)(event);
	        if (event.which === 13 || typeof event.which === 'undefined') {
	            if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
	                event.target.value = '0,00';
	            }
	            event.target.value = (0, _varios.formatoMonto)(event.target.value);
	            var char1 = event.target.value.substring(0, 1);
	            var char2 = event.target.value.substring(1, 2);
	            if (char1 === '0' && char2 !== ',') {
	                event.target.value = event.target.value.substring(1, event.target.value.legth);
	            }
	        } else if (event.which === 46) {
	            return false;
	        } else if (event.which >= 48 && event.which <= 57) {
	            return true;
	        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	            return true;
	        } else return false;
	    };
	
	    var onChangeValidar = function onChangeValidar() {
	
	        var sigue = true;
	
	        if (values.nombre === '') {
	
	            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar la Descripcion del Banco.', icono: 'informacion' });
	
	            sigue = false;
	
	            txtDescripcion.current.focus();
	        } else if (sigue) {
	
	            var msg = '';
	
	            if (operacion === 1) {
	                msg = 'Esta Seguro de Registrar estos Datos.';
	            } else if (operacion === 2) {
	                msg = 'Esta Seguro de Modificar estos Datos.';
	            } else if (operacion === 3) {
	                msg = 'Esta Seguro de Eliminar estos Datos.';
	            }
	            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	        }
	    };
	
	    var procesarRegistro = function procesarRegistro() {
	
	        setActivate(true);
	        var endpoint = op.conexion + '/api/banco/actualizarbanco';
	        var body = void 0;
	
	        body = {
	            operacion: operacion,
	            nid: values.idbanco !== '' ? values.idbanco : 0,
	            nom: values.nombre !== '' ? values.nombre.trim() : ''
	        };
	
	        _axios2.default.post(endpoint, body, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                if (props.operacion === 1) {
	                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
	                } else if (props.operacion === 2) {
	                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
	                } else if (props.operacion === 3) {
	                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
	                }
	                setActivate(false);
	            }
	        }).catch(function (error) {
	            var mensaje = '';
	            if (error.response === undefined) {
	                mensaje = 'Error de Conexion';
	            } else {
	                if (error.response.data.message === 'duplicate key value violates unique constraint "agente_rif_key"') {
	                    mensaje = 'Ya existe un Registro con este rif';
	                } else if (error.response.data.message === 'duplicate key value violates unique constraint "agente_email_key"') {
	                    mensaje = 'Ya existe un Registro con este correo';
	                } else {
	                    mensaje = error.response.data.message;
	                }
	            }
	            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setValues({
	            idbanco: '',
	            nombre: ''
	        });
	    };
	
	    var handleCloseSi = function handleCloseSi() {
	        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        procesarRegistro();
	    };
	
	    var cancelar = function cancelar(e) {
	        e.preventDefault();
	        blanquear();
	        props.onHideCancela();
	    };
	
	    var cerrarModal = function cerrarModal() {
	        props.onHideRenderizar();
	        props.onHideCancela();
	        blanquear();
	        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'md',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                setOperacion(props.operacion);
	                if (props.operacion !== 1) {
	                    setValues(props.bancos);
	                }
	            }
	
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                { style: { color: "#fff" } },
	                props.operacion === 1 ? 'Agregar Banco.' : props.operacion === 2 ? 'Editar Banco.' : props.operacion === 3 ? 'Eliminar Banco.' : 'Consultar Banco.'
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'btn', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            { style: { backgroundColor: "#FFF" } },
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	                onHideNo: function onHideNo() {
	                    return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	                }, onHideSi: handleCloseSi }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row mx-auto' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-2 col-md-4' },
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                        'Codigo:'
	                    ),
	                    _react2.default.createElement('input', { type: 'text', className: 'form-control bg-light', ref: txtId, style: styleInput, defaultValue: values.idbanco, disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-2 col-md-12' },
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                        'Descripci\xF3n:'
	                    ),
	                    _react2.default.createElement('textarea', { type: 'area', className: 'form-control rounded bg-light', ref: txtDescripcion, disabled: operacion === 1 || operacion === 2 ? false : true, style: styleInputDirec, defaultValue: values.nombre !== null ? values.nombre.trim() : '', 'aria-label': 'With textarea', name: 'nombre', onChange: onChange })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, disabled: operacion === 4 ? true : false, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-success' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    '  Aceptar'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};

/***/ },
/* 7073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	/* import CartasAgentes from './cartasAgentes'; */
	
	/* import { GestionarExpendedor } from './modalExpendedor'; */
	
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(19);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _graficos = __webpack_require__(301);
	
	var _mensajes = __webpack_require__(9);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _varios = __webpack_require__(14);
	
	var _modalRegistrarBancos = __webpack_require__(7072);
	
	var _cartasBancos = __webpack_require__(7071);
	
	var _cartasBancos2 = _interopRequireDefault(_cartasBancos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TablaBancos = function TablaBancos(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var municipios = [];
	
	  var headCells = [{ id: 'codigo', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'COD.', textAlign: 'center' }, { id: 'descripcion', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' }, { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }];
	
	  var colores = ['#17a2b8', '#ffae00', '#dc3545', '#BDB76B', '#7B68EE', '#4B0082', '#00ffff', '#0080ff', '#0000ff', '#8000ff', '#ff00ff', '#ff0080'];
	
	  var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      mensajesino = _useState4[0],
	      setMensajesino = _useState4[1];
	
	  var txtBuscador = (0, _react.useRef)();
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mostrar2 = _useState6[0],
	      setMostrar2 = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      activate = _useState8[0],
	      setActivate = _useState8[1];
	
	  var _useState9 = (0, _react.useState)([]),
	      _useState10 = _slicedToArray(_useState9, 2),
	      records = _useState10[0],
	      setRecords = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      expendedor = _useState12[0],
	      setExpendedor = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(1),
	      _useState14 = _slicedToArray(_useState13, 2),
	      operacion = _useState14[0],
	      setOperacion = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(),
	      _useState16 = _slicedToArray(_useState15, 2),
	      persona = _useState16[0],
	      setPersona = _useState16[1];
	
	  var _useState17 = (0, _react.useState)({ fn: function fn(items) {
	      return items;
	    } }),
	      _useState18 = _slicedToArray(_useState17, 2),
	      filterFn = _useState18[0],
	      setFilterFn = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(),
	      _useState20 = _slicedToArray(_useState19, 2),
	      ciudades = _useState20[0],
	      setCiudades = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(),
	      _useState22 = _slicedToArray(_useState21, 2),
	      credito = _useState22[0],
	      setCredito = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0),
	      _useState24 = _slicedToArray(_useState23, 2),
	      total = _useState24[0],
	      setTotal = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(0),
	      _useState26 = _slicedToArray(_useState25, 2),
	      activos = _useState26[0],
	      setActivos = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      inactivos = _useState28[0],
	      setInactivos = _useState28[1];
	
	  var _useState29 = (0, _react.useState)([]),
	      _useState30 = _slicedToArray(_useState29, 2),
	      municipiosEx = _useState30[0],
	      setMunicipiosEx = _useState30[1];
	
	  var _useState31 = (0, _react.useState)([]),
	      _useState32 = _slicedToArray(_useState31, 2),
	      municipiosData = _useState32[0],
	      setMunicipiosData = _useState32[1];
	
	  var _useState33 = (0, _react.useState)([]),
	      _useState34 = _slicedToArray(_useState33, 2),
	      datos = _useState34[0],
	      setDatos = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(),
	      _useState36 = _slicedToArray(_useState35, 2),
	      bancos = _useState36[0],
	      setBancos = _useState36[1];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting,
	      TblPagination = _useTable.TblPagination;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") return items;else return items.filter(function (x) {
	          if ((x.idbanco !== null ? x.idbanco.includes(target.value) : '') || (x.nombre !== null ? x.nombre.toLowerCase().includes(target.value.toLowerCase()) : '')) {
	            return x;
	          }
	        });
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "*";
	    var nomtab = "bancos";
	    var orden = "idbanco";
	    var municipioss = [];
	    var idmunicipioss = [];
	    var results = [];
	    var element = [];
	
	    var endpoint = op.conexion + ('/api/consulta/seleccionaregistros?campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden);
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        setRecords(response.data);
	
	        for (var i = 0; i < response.data.length; i++) {
	          element.push({ nombre: response.data[i].nombre, valor: results[i], color: colores[i] });
	        }
	      }
	      setMunicipiosEx(municipioss);
	      setMunicipiosData(results);
	      setDatos(element);
	
	      setActivate(false);
	    }).catch(function (error) {
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	      setActivate(false);
	    });
	  };
	
	  var seleccionarBanco = function seleccionarBanco(id) {
	
	    var campos = "*";
	    var nomtab = "bancos";
	    var nomid = "idbanco";
	
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid;
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	
	      if (response.status == 200) {
	
	        if (response.data.idbanco !== '') {
	
	          setBancos(response.data);
	          setMostrar2(true);
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	      setActivate(false);
	    });
	  };
	
	  var handleCancela2 = function handleCancela2() {
	    setMostrar2(false);
	    setExpendedor('');
	    setCredito('');
	  };
	
	  var cerrarModal = function cerrarModal() {
	    setMostrar2(false);
	  };
	
	  var gestionarBanco = function gestionarBanco(op, id) {
	    return function (e) {
	      e.preventDefault();
	      setOperacion(op);
	      if (op !== 1) {
	        seleccionarBanco(id);
	      } else {
	        setMostrar2(true);
	      }
	    };
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    /*     getExpendedor(); */
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarRegistros();
	    // getExpendedores();
	    setActivate(true);
	  }, []);
	
	  var data = {
	    labels: municipiosEx,
	    leyend: true,
	    datasets: [{
	      label: '#',
	      data: municipiosData,
	      backgroundColor: colores,
	      borderColor: colores,
	      borderWidth: 1,
	      hoverBorderWidth: 15
	    }]
	  };
	
	  var options = {
	    responsive: true,
	    legend: {
	      position: 'top',
	      display: false
	    },
	    title: {
	      display: true,
	      text: 'Municipios con Expendedores Activos: ' + municipiosData.length
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', width: '100%' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'row col-md-12', style: { margin: 0 } },
	      _react2.default.createElement(
	        'div',
	        { className: 'row col-md-12', style: { margin: 0 } },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-8 py-3 mx-auto mt-5' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 p-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row col-12 d-flex justify-content-between' },
	              _react2.default.createElement('input', { type: 'text', className: ' col-3 form-control form-control-sm rounded-pill', ref: txtBuscador, onChange: handleSearch, placeholder: 'Buscar' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-3 d-flex justify-content-end' },
	                _react2.default.createElement(
	                  'button',
	                  { onClick: gestionarBanco(1, ''), style: { marginBottom: "5px" }, className: 'btn btn-sm btn-primary rounded-circle' },
	                  _react2.default.createElement('i', { className: 'fas fa-plus' }),
	                  ' '
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12', style: { margin: "auto" } },
	            _react2.default.createElement(
	              TblContainer,
	              null,
	              _react2.default.createElement(TblHead, null),
	              _react2.default.createElement(
	                _core.TableBody,
	                null,
	                records && recordsAfterPagingAndSorting().map(function (item, index) {
	                  return _react2.default.createElement(
	                    _core.TableRow,
	                    { key: index, style: { padding: "0" } },
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                      item.idbanco
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center', width: '270px' } },
	                      item.nombre
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: gestionarBanco(4, item.idbanco), className: 'btn btn-sm mx-1 btn-info rounded-circle' },
	                        _react2.default.createElement('i', { className: 'fas fa-eye' }),
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: gestionarBanco(2, item.idbanco), className: 'btn btn-sm mx-1 btn-warning rounded-circle' },
	                        _react2.default.createElement('i', { className: 'fa fa-edit' }),
	                        ' '
	                      ),
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: gestionarBanco(3, item.idbanco), className: 'btn btn-sm mx-1 btn-danger rounded-circle' },
	                        _react2.default.createElement('i', { className: 'fa fa-trash' }),
	                        ' '
	                      )
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(TblPagination, null)
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_modalRegistrarBancos.GestionarBancos, {
	      show: mostrar2,
	      onHideCancela: cerrarModal,
	      operacion: operacion,
	      bancos: bancos,
	      onHideRenderizar: seleccionarRegistros
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        'cargando...'
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	      } }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	      }, onHideSi: handleCloseSi })
	  );
	};
	exports.default = TablaBancos;

/***/ },
/* 7074 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalImprimirFacturasCompras = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoProductosExistencias = __webpack_require__(91);
	
	var _catalogoProductosExistencias2 = _interopRequireDefault(_catalogoProductosExistencias);
	
	var _catalogoAlmacen = __webpack_require__(51);
	
	var _catalogoAlmacen2 = _interopRequireDefault(_catalogoAlmacen);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalImprimirFacturasCompras = exports.ModalImprimirFacturasCompras = function ModalImprimirFacturasCompras(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtCodigo = (0, _react.useRef)();
	  var txtDesde = (0, _react.useRef)();
	  var txtHasta = (0, _react.useRef)();
	  var txtPorProduct = (0, _react.useRef)();
	  var txtNombreProducto = (0, _react.useRef)();
	  var txtTodosProduct = (0, _react.useRef)();
	  var txtTodosAlmacen = (0, _react.useRef)();
	  var txtPorAlmacen = (0, _react.useRef)();
	  var txtNombreAlmacen = (0, _react.useRef)();
	  var txtCodigoAlmacen = (0, _react.useRef)();
	  var txtNombreProveedor = (0, _react.useRef)();
	  var txtSrifp = (0, _react.useRef)();
	  var txtRifp = (0, _react.useRef)();
	  var txtTodosStatus = (0, _react.useRef)();
	  var txtPorpagar = (0, _react.useRef)();
	  var txtPagadas = (0, _react.useRef)();
	  var txtAnuladas = (0, _react.useRef)();
	  var txtGeneral = (0, _react.useRef)();
	  var txtEspecifico = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      inputalmacen = _useState2[0],
	      setInputalmacen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      valalmacen = _useState4[0],
	      setValalmacen = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      valproducto = _useState6[0],
	      setValproducto = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      opera = _useState8[0],
	      setOpera = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      tiporif = _useState10[0],
	      setTipofic = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      valproveedor = _useState12[0],
	      setValproveedor = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(null),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mostrar1 = _useState14[0],
	      setMostrar1 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(null),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mostrar2 = _useState16[0],
	      setMostrar2 = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(null),
	      _useState18 = _slicedToArray(_useState17, 2),
	      mostrar3 = _useState18[0],
	      setMostrar3 = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(''),
	      _useState20 = _slicedToArray(_useState19, 2),
	      parafecha = _useState20[0],
	      setParafecha = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(''),
	      _useState22 = _slicedToArray(_useState21, 2),
	      desde = _useState22[0],
	      setDesde = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(''),
	      _useState24 = _slicedToArray(_useState23, 2),
	      hasta = _useState24[0],
	      setHasta = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(''),
	      _useState26 = _slicedToArray(_useState25, 2),
	      disponiblec = _useState26[0],
	      setDisponiblec = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(''),
	      _useState28 = _slicedToArray(_useState27, 2),
	      nreport = _useState28[0],
	      setNreport = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(''),
	      _useState30 = _slicedToArray(_useState29, 2),
	      idclient = _useState30[0],
	      setIdclient = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(true),
	      _useState32 = _slicedToArray(_useState31, 2),
	      vinpurt = _useState32[0],
	      setVinput = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(0),
	      _useState34 = _slicedToArray(_useState33, 2),
	      valida2 = _useState34[0],
	      setValida2 = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(false),
	      _useState36 = _slicedToArray(_useState35, 2),
	      activate = _useState36[0],
	      setActivate = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(''),
	      _useState38 = _slicedToArray(_useState37, 2),
	      idproduct = _useState38[0],
	      setIdproduct = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(''),
	      _useState40 = _slicedToArray(_useState39, 2),
	      estatus = _useState40[0],
	      setEstatus = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(0),
	      _useState42 = _slicedToArray(_useState41, 2),
	      valida = _useState42[0],
	      setValida = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({ fn: function fn(items) {
	      return items;
	    } }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      filterFn = _useState44[0],
	      setFilterFn = _useState44[1];
	
	  var _useState45 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState46 = _slicedToArray(_useState45, 2),
	      mensaje = _useState46[0],
	      setMensaje = _useState46[1];
	
	  var _useState47 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState48 = _slicedToArray(_useState47, 2),
	      mensajesino = _useState48[0],
	      setMensajesino = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(''),
	      _useState50 = _slicedToArray(_useState49, 2),
	      tituid = _useState50[0],
	      setTituid = _useState50[1];
	
	  var _useState51 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState52 = _slicedToArray(_useState51, 2),
	      botones = _useState52[0],
	      setBotones = _useState52[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setInputalmacen('');
	    setParafecha('');
	    setDisponiblec('');
	    setNreport('');
	    setOpera(0);
	    setValida(0);
	    setValida2(0);
	    setIdclient('');
	    setIdproduct('');
	    setVinput(true);
	    setMostrar1(false);
	    setMostrar2(false);
	    setEstatus("");
	    setDesde('');
	    setHasta('');
	    setValalmacen(0);
	    setValproducto(0);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope === 1) {
	
	      if (valida2 === 1 && txtTodosProduct.current.checked === false) {
	        if (txtPorProduct.current.checked === true && txtCodigo.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Código del Producto a Consultar !', icono: 'informacion' });
	          txtCodigo.current.focus();
	          sigue = false;
	        } else if (txtPorProduct.current.checked === false && txtTodosProduct.current.checked === false) {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Operación !', icono: 'informacion' });
	          txtTodosProduct.current.focus();
	          sigue = false;
	        } else {
	          imprimirMovimientosVentas();
	        }
	      } else if (sigue === true) {
	
	        imprimirMovimientosVentas();
	      }
	    }
	  };
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'desde') {
	      if (e.target.value > (0, _moment2.default)(fechasistema).format('YYYY-MM-DD')) {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !', icono: 'informacion' });
	        txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        txtDesde.current.focus();
	      } else {
	        setDesde(e.target.value);
	      }
	    } else if (e.target.name === 'hasta') {
	      setHasta(e.target.value);
	    }
	
	    var valida = 1;
	
	    if (e.target.name === 'inlineRadioOptionstipo') {
	      if (e.target.value === '1') {
	        valida = 1;
	        setNreport('ReporteGeneralFacturasCompras');
	        setOpera(2);
	      } else {
	        valida = 2;
	        setNreport('ReporteFacturasdeCompras');
	        setOpera(1);
	      }
	    }
	
	    if (e.target.name === 'nci') {
	      setTipofic(e.target.value);
	    }
	
	    if (e.target.name === 'inlineRadioOptionst') {
	
	      if (e.target.value === '1') {
	        setValproducto(0);
	        setIdproduct("'" + ' and nd.idproducto > 0' + "'");
	
	        if (valida === 1) {
	          setNreport('ReporteGeneralFacturasCompras');
	          setOpera(2);
	        } else {
	          setNreport('ReporteFacturasdeCompras');
	          setOpera(1);
	        }
	
	        txtCodigo.current.value = "";
	        txtNombreProducto.current.value = "";
	      } else {
	        setValproducto(1);
	        setOpera(2);
	        setNreport('ReporteFacturaComprasxProductos');
	      }
	    }
	
	    if (e.target.name === 'alamcen') {
	
	      if (e.target.value === '1') {
	        setValalmacen(0);
	        setInputalmacen('');
	        txtCodigoAlmacen.current.value = "";
	        txtNombreAlmacen.current.value = "";
	      } else {
	        setValalmacen(1);
	      }
	    }
	
	    if (e.target.name === 'inlineRadioProveedor') {
	      if (e.target.value === '1') {
	        setValproveedor(0);
	        setIdclient("'" + 'n.idproveedor > 0' + "'");
	        txtSrifp.current.value = '';
	        txtRifp.current.value = '';
	        txtNombreProveedor.current.value = '';
	      } else {
	        setValproveedor(1);
	      }
	    }
	  };
	
	  var imprimirMovimientosVentas = function imprimirMovimientosVentas() {
	
	    var reporte = "";
	    var desdec = "'" + (0, _moment2.default)(desde).format('DD-MM-YYYY') + "'";
	    var hastac = "'" + (0, _moment2.default)(hasta).format('DD-MM-YYYY') + "'";
	    var condicion = void 0;
	    var oper = 0;
	    var val = 0;
	
	    if (inputalmacen !== '') {
	      val = 1;
	    } else {
	      val = 0;
	    }
	
	    var espa1 = idclient && idproduct !== '' ? '||' : '';
	
	    var espa2 = idclient && idproduct && estatus !== '' || idclient && estatus !== '' && idproduct === '' ? '||' : '';
	
	    var espa3 = idclient && inputalmacen !== '' && idproduct === '' && estatus === '' || idclient && idproduct && inputalmacen !== '' & estatus === '' || idclient && inputalmacen && estatus !== '' && idproduct === '' || idclient && idproduct && estatus && inputalmacen !== '' ? '||' : '';
	
	    condicion = idclient + espa1 + idproduct + espa2 + estatus + espa3 + inputalmacen;
	    reporte = nreport;
	    oper = opera;
	    var orden = 'n.fechafactura';
	
	    window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&condicion=" + condicion + "&desde=" + desdec + "&hasta=" + hastac + "&ope=" + oper + "&orden=" + orden + "&valalmacen=" + val, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  var handleAceptaProducto = function handleAceptaProducto(values) {
	    setMostrar1(false);
	    setVinput(false);
	    txtNombreProducto.current.value = values.nombrecorto;
	    txtCodigo.current.value = values.codigo;
	    setIdproduct("'" + ' and nd.idproducto = ' + values.idproducto + "'");
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var seleccionarProducto = function seleccionarProducto(id) {
	    var campos = "idproducto, nombre";
	    var nomtab = "producto";
	    var nomid = "codigo";
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idproducto > 0) {
	          setIdproduct("'" + ' and nd.idproducto = ' + response.data.idproducto + "'");
	          txtNombreProducto.current.value = response.data.nombre;
	          setVinput(false);
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Código y/o Producto no Existe !', icono: 'informacion' });
	          setVinput(true);
	          txtCodigo.current.value = "";
	          setIdproduct('');
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var handleInputNumeroChange = function handleInputNumeroChange(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "notaentrega") {
	          seleccionarProducto(event.target.value.toUpperCase());
	        } /* else if (event.target.name === "nalmacen") {
	          seleccionarAlmacen(event.target.value);
	          } */
	      }
	    }
	  };
	
	  var handleAceptaAlmacen = function handleAceptaAlmacen(values) {
	    setMostrar2(false);
	    txtNombreAlmacen.current.value = values.descripcion;
	    txtCodigoAlmacen.current.value = values.idalmacen;
	    setInputalmacen("'" + ' and n.idalmacen = ' + values.idalmacen + "'");
	  };
	
	  var onChekval = function onChekval(e) {
	
	    if (e.target.name === 'tipodisponible') {
	      if (e.target.value === '1') {
	        setEstatus('');
	      } else if (e.target.value === '2') {
	        setEstatus("'" + 'and n.status = 1' + "'");
	      } else if (e.target.value === '3') {
	        setEstatus("'" + ' and n.status = 0' + "'");
	      } else if (e.target.value === '4') {
	        setEstatus("'" + ' and n.status = 4' + "'");
	      }
	    }
	  };
	
	  var selectResponsable = function selectResponsable(id) {
	
	    var campos = '*';
	    var nomtab = 'agente';
	    var nomid = 'rif';
	    var nomid2 = 'proveedor';
	
	    var endpoint = op.conexion + '/api/consulta/modeli2?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id + '&nomid2=' + nomid2 + '&id2=true';
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idagente > 0) {
	          txtNombreProveedor.current.value = response.data.nombre;
	          setIdclient("'" + 'n.cedularif = ' + "'" + '||' + "quote_literal(" + "'" + response.data.rif + "'" + ")");
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ RIF y/o Proveedor no Registrado !', icono: 'informacion' });
	          txtNombreProveedor.current.value = '';
	          txtRifp.current.value = '';
	          txtSrifp.current.value = '';
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var handleCliente = function handleCliente(e) {
	    e.preventDefault();
	    if (e.which === 13 || typeof e.which === 'undefined') {
	      if (e.target.value !== '') {
	        selectResponsable(tiporif + e.target.value);
	      }
	    }
	  };
	
	  var catalogoProveedor = function catalogoProveedor(ope) {
	    return function (e) {
	      e.preventDefault();
	      setMostrar3(true);
	    };
	  };
	
	  var handleAceptaProveedor = function handleAceptaProveedor(values) {
	    setMostrar3(false);
	
	    txtSrifp.current.value = values.rif.substring(0, 1);
	    txtRifp.current.value = values.rif.substring(1, 10);
	    txtNombreProveedor.current.value = values.nombre;
	    setTipofic(values.rif.substring(0, 1));
	    setIdclient("'" + 'n.cedularif = ' + "'" + '||' + "quote_literal(" + "'" + values.rif + "'" + ")");
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.ope === 1) {
	          txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	          txtHasta.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	          setDesde((0, _moment2.default)(fechasistema).format('YYYY-MM-DD'));
	          setHasta((0, _moment2.default)(fechasistema).format('YYYY-MM-DD'));
	          setVinput(false);
	          setTipofic('V');
	          setIdclient("'" + 'n.idproveedor > 0' + "'");
	          setNreport('ReporteGeneralFacturasCompras');
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Imprimir Movimientos (Facturas de Compras)'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0 m-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 row m-0 px-0 py-2' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-pd-220 px-1 mb-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'DESDE:'
	              ),
	              _react2.default.createElement('input', { type: 'date', disabled: props.ope === 0 ? true : false, onChange: onChange, ref: txtDesde, name: 'desde', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-pd-220 px-1 mb-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'HASTA:'
	              ),
	              _react2.default.createElement('input', { type: 'date', disabled: props.ope === 0 ? true : false, onChange: onChange, ref: txtHasta, name: 'hasta', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-pd-300 px-0 mb-2 row m-0 d-flex justify-content-around mb-2 ml-auto' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-check form-check-inline col-pd-100 mx-2 px-1' },
	              _react2.default.createElement('input', { className: 'form-check-input', type: 'radio', ref: txtGeneral, name: 'inlineRadioOptionstipo', onChange: onChange, id: 'inlineRadiotipo1', value: '1', defaultChecked: true }),
	              _react2.default.createElement(
	                'label',
	                { className: 'form-check-label', 'for': 'inlineRadiotipo1', style: { fontSize: '0.8rem' } },
	                'GENERAL'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-check form-check-inline col-pd-130 ml-1 px-1' },
	              _react2.default.createElement('input', { className: 'form-check-input', type: 'radio', ref: txtEspecifico, name: 'inlineRadioOptionstipo', onChange: onChange, id: 'inlineRadiotipo2', value: '2' }),
	              _react2.default.createElement(
	                'label',
	                { className: 'form-check-label', 'for': 'inlineRadiotipo2', style: { fontSize: '0.8rem' } },
	                'ESPECIFICO'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fw-bold', style: { fontSize: '0.8rem' } },
	              'PROVEEDOR:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-400 px-0 mb-2 row m-0 d-flex justify-content-around' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check form-check-inline col-pd-120 mx-2 px-1' },
	                _react2.default.createElement('input', { className: 'form-check-input', type: 'radio', ref: txtTodosProduct, name: 'inlineRadioProveedor', onChange: onChange, defaultChecked: true, id: 'inlineRadiotP1', value: '1' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'inlineRadiotP1', style: { fontSize: '0.8rem' } },
	                  'TODOS'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check form-check-inline col-pd-160 ml-1 px-1' },
	                _react2.default.createElement('input', { className: 'form-check-input', type: 'radio', ref: txtPorProduct, name: 'inlineRadioProveedor', onChange: onChange, id: 'inlineRadiotP2', value: '2' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'inlineRadiotP2', style: { fontSize: '0.8rem' } },
	                  'POR PROVEEDOR'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-300 px-0 mb-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'CEDULA/RIF:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-select col-3', disabled: valproveedor === 1 ? false : true, ref: txtSrifp, name: 'nci', onChange: onChange, 'aria-label': 'Default select example' },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'V' },
	                    'V'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'E' },
	                    'E'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'J' },
	                    'J'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'P' },
	                    'P'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'G' },
	                    'G'
	                  )
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtRifp, disabled: valproveedor === 1 ? false : true, onKeyUp: handleCliente, onBlur: handleCliente, className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: valproveedor === 1 ? false : true, type: 'button', onClick: catalogoProveedor(1), className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 px-0 mb-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'NOMBRE:'
	                ),
	                _react2.default.createElement('textarea', { type: 'text', disabled: true, ref: txtNombreProveedor, name: 'nombre', style: { height: idproduct !== '' ? '47px' : '30px' }, className: 'form-control fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fw-bold', style: { fontSize: '0.8rem' } },
	              'PRODUCTOS:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-400 px-0 mb-2 row m-0 d-flex justify-content-around' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check form-check-inline col-pd-120 mx-2 px-1' },
	                _react2.default.createElement('input', { className: 'form-check-input', type: 'radio', ref: txtTodosProduct, name: 'inlineRadioOptionst', onChange: onChange, id: 'inlineRadiot1', value: '1', defaultChecked: true }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'inlineRadiot1', style: { fontSize: '0.8rem' } },
	                  'TODOS'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check form-check-inline col-pd-160 ml-1 px-1' },
	                _react2.default.createElement('input', { className: 'form-check-input', type: 'radio', ref: txtPorProduct, name: 'inlineRadioOptionst', onChange: onChange, id: 'inlineRadiot2', value: '2' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'inlineRadiot2', style: { fontSize: '0.8rem' } },
	                  'POR PRODUCTO'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-300 px-0 mb-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'CODIGO PRODUCTO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: valproducto === 1 ? false : true, name: 'notaentrega', onKeyUp: handleInputNumeroChange, onBlur: handleInputNumeroChange, ref: txtCodigo, className: 'form-control fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', onClick: function onClick() {
	                      return setMostrar1(true);
	                    }, disabled: valproducto === 1 ? false : true, className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 px-0 mb-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'NOMBRE PRODUCTO:'
	                ),
	                _react2.default.createElement('textarea', { type: 'text', disabled: true, ref: txtNombreProducto, name: 'nombre', style: { height: idproduct !== '' ? '47px' : '30px' }, className: 'form-control fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1 d-flex justify-content-center' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fw-bold', style: { fontSize: '0.8rem' } },
	              'STATUS:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '1', ref: txtTodosStatus, onChange: onChekval, defaultChecked: true, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai1', style: { fontSize: '0.8rem' } },
	                  'TOD@S'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-3 mr-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '2', ref: txtPagadas, onChange: onChekval, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai2', style: { fontSize: '0.8rem' } },
	                  'PAGADAS'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '3', ref: txtPorpagar, onChange: onChekval, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai3', style: { fontSize: '0.8rem' } },
	                  'POR PAGAR'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '4', ref: txtAnuladas, onChange: onChekval, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai4', style: { fontSize: '0.8rem' } },
	                  'ANULADAS'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fw-bold', style: { fontSize: '0.8rem' } },
	              'ALMACEN:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-400 px-0 mb-2 row m-0 d-flex justify-content-around' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check form-check-inline col-pd-120 mx-2 px-1' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'alamcen', value: '1', ref: txtTodosAlmacen, onChange: onChange, id: 'alamcen', type: 'radio', defaultChecked: true }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa1', style: { fontSize: '0.8rem' } },
	                  'TODOS'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check form-check-inline col-pd-160 ml-1 px-1' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'alamcen', value: '2', ref: txtPorAlmacen, onChange: onChange, id: 'alamcen', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa2', style: { fontSize: '0.8rem' } },
	                  'POR ALMACEN'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-300 px-0 mb-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'CODIGO ALMACEN:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtCodigoAlmacen, disabled: true /* onKeyUp={handleCliente} onBlur={handleCliente} */, className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: valalmacen === 1 ? false : true, type: 'button', onClick: function onClick() {
	                      return setMostrar2(true);
	                    }, className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 px-0 mb-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'NOMBRE DEL ALMACEN:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtNombreAlmacen, disabled: true, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-11 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: vinpurt, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-primary mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-print' },
	              '  Imprimir'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoProductosExistencias2.default, {
	      show: mostrar1,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar1(false);
	      },
	      onHideAceptaCatalogo: handleAceptaProducto
	    }),
	    _react2.default.createElement(_catalogoAlmacen2.default, {
	      show: mostrar2,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar2(false);
	      },
	      onHideAceptaCatalogo: handleAceptaAlmacen
	    }),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: mostrar3,
	      nomid: 'proveedor',
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar3(false);
	      },
	      onHideAceptaCatalogo: handleAceptaProveedor
	    })
	  );
	};

/***/ },
/* 7075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalIncluirFactura = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoPersona = __webpack_require__(64);
	
	var _catalogoPersona2 = _interopRequireDefault(_catalogoPersona);
	
	var _icons = __webpack_require__(399);
	
	var _catalogoTipoRetenciones = __webpack_require__(294);
	
	var _catalogoTipoRetenciones2 = _interopRequireDefault(_catalogoTipoRetenciones);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ModalIncluirFactura = exports.ModalIncluirFactura = function ModalIncluirFactura(props) {
	
	    var fechaSistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	
	    var txtBase = (0, _react.useRef)();
	    var txtIva = (0, _react.useRef)();
	    var txtTotal = (0, _react.useRef)();
	    var txtCodigo = (0, _react.useRef)();
	    var txtDescrip = (0, _react.useRef)();
	    var txtFecha = (0, _react.useRef)();
	    var txtMontoIva = (0, _react.useRef)();
	    var txtAlicuota = (0, _react.useRef)();
	    var txtCompromiso = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        activate = _useState2[0],
	        setActivate = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        mostrar = _useState4[0],
	        setMostrar = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        Datati = _useState6[0],
	        setDatati = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(null),
	        _useState8 = _slicedToArray(_useState7, 2),
	        activo = _useState8[0],
	        setActivo = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(0),
	        _useState10 = _slicedToArray(_useState9, 2),
	        operacion = _useState10[0],
	        setOperacion = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        mensaje = _useState12[0],
	        setMensaje = _useState12[1];
	
	    var _useState13 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState14 = _slicedToArray(_useState13, 2),
	        mensajesino = _useState14[0],
	        setMensajesino = _useState14[1];
	
	    var _useState15 = (0, _react.useState)({
	        codigo: 0,
	        alicuota: 0.00,
	        baseimponible: 0.00,
	        descripcion: '',
	        fecha: '',
	        iva: 0.00,
	        montoiva: 0.00,
	        total: 0.00,
	        totalf: 0.00,
	        unidad: 0
	    }),
	        _useState16 = _slicedToArray(_useState15, 2),
	        values = _useState16[0],
	        setValues = _useState16[1];
	
	    var _useState17 = (0, _react.useState)([]),
	        _useState18 = _slicedToArray(_useState17, 2),
	        datos = _useState18[0],
	        setDatos = _useState18[1];
	
	    var btnCancela = (0, _react.useRef)();
	    var btnAcepta = (0, _react.useRef)();
	
	    var cancelar = function cancelar() {
	
	        if (props.operacion === 2) {
	            var data = [];
	            var op = 6;
	            data.push({
	                codigo: txtCodigo.current.value,
	                descripcion: txtDescrip.current.value,
	                baseimponible: txtBase.current.value.trim().replace(/\./g, '').replace(',', '.'),
	                alicuota: txtAlicuota.current.value.trim().replace(/\./g, '').replace(',', '.'),
	                total: txtTotal.current.value.trim().replace(/\./g, '').replace(',', '.'),
	                fecha: txtFecha.current.value,
	                iva: txtIva.current.value,
	                totalf: txtCompromiso.current.value.trim().replace(/\./g, '').replace(',', '.'),
	                montoiva: txtMontoIva.current.value.trim().replace(/\./g, '').replace(',', '.')
	            });
	            props.inf(data, op);
	            props.onHideCancelar();
	            blanquear();
	        } else {
	            props.onHideCancelar();
	            blanquear();
	        }
	    };
	
	    var blanquear = function blanquear() {
	        setActivate(false);
	        txtCodigo.current.value = '';
	        txtDescrip.current.value = '';
	        txtBase.current.value = '';
	        txtIva.current.value = '';
	        txtMontoIva.current.value = '';
	        txtCompromiso.current.value = '';
	        txtAlicuota.current.value = '';
	        txtTotal.current.value = '';
	        setDatati([]);
	        setActivo(null);
	    };
	
	    var handleInputNumChange = function handleInputNumChange(event) {
	        event.preventDefault();
	        (0, _varios.validaSoloNumero)(event);
	
	        if (event.which === 13 || typeof event.which === 'undefined') {
	
	            setDatos(Object.assign({}, datos, _defineProperty({}, event.target.name, event.target.value)));
	        } else if (event.which === 46) {
	            return false;
	        } else if (event.which >= 48 && event.which <= 57) {
	            return true;
	        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	            return true;
	        } else return false;
	    };
	
	    var onCalculo = function onCalculo(datos) {
	
	        var data = [];
	        var totaliv = 0.00;
	        var baseimpo = 0.00;
	        var miv = 0.00;
	        var ali = 0.00;
	        var fecha = txtFecha.current.value;
	        var iva = 0.00;
	        var totalfact = 0.00;
	
	        if (datos.unidad !== 3) {
	
	            miv = txtMontoIva.current.value === '' ? '0.00' : txtMontoIva.current.value.trim().replace(/\./g, '').replace(',', '.');
	            ali = txtAlicuota.current.value === '' ? '0.00' : txtAlicuota.current.value.trim().replace(/\./g, '').replace(',', '.');
	            iva = txtIva.current.value === '' ? '0.00' : txtIva.current.value.trim().replace(/\./g, '').replace(',', '.');
	            totalfact = txtBase.current.value === '' ? '0.00' : txtBase.current.value.trim().replace(/\./g, '').replace(',', '.');
	        } else {
	
	            totalfact = props.data[0].base;
	            baseimpo = props.data[0].base;
	            iva = props.data[0].iva;
	            miv = props.data[0].montoiva;
	            totaliv = txtTotal.current.value.trim().replace(/\./g, '').replace(',', '.');
	        }
	
	        if (datos.idtiporetencion === '1') {
	            totaliv = miv * ali / 100;
	            baseimpo = miv;
	            txtTotal.current.value = (0, _varios.formatMoneda)(totaliv.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	        } else if (datos.tipo === 1) {
	            totaliv = totalfact * ali / 100;
	            baseimpo = totalfact;
	            txtTotal.current.value = (0, _varios.formatMoneda)(totaliv.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	        } else if (datos.unidad === 4) {
	            totaliv = totalfact / ali;
	            baseimpo = totalfact;
	            txtTotal.current.value = (0, _varios.formatMoneda)(totaliv.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	        }
	
	        data.push({
	            codigo: datos.idtiporetencion,
	            descripcion: datos.descripcion,
	            baseimponible: baseimpo,
	            alicuota: ali,
	            total: totaliv,
	            fecha: fecha,
	            iva: iva,
	            totalf: totalfact,
	            montoiva: props.data[0].montoiva,
	            unidad: datos.unidad
	        });
	        setDatos(data);
	    };
	
	    var handleInputMontoChange = function handleInputMontoChange(event) {
	        (0, _varios.validaMonto)(event);
	        if (event.which === 13 || typeof event.which === 'undefined') {
	
	            if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
	                event.target.value = '0,00';
	            }
	            event.target.value = (0, _varios.formatoMonto)(event.target.value);
	            var char1 = event.target.value.substring(0, 1);
	            var char2 = event.target.value.substring(1, 2);
	            if (char1 === '0' && char2 !== ',') {
	                event.target.value = event.target.value.substring(1, event.target.value.legth);
	            }
	            if (event.which === 13) {
	                if (event.target.id === 'alicuota') {
	                    onCalculo(Datati);
	                    txtAlicuota.current.focus();
	                } else if (event.target.id === 'total') {
	                    onCalculo(Datati);
	                    setOperacion(1);
	                    btnAcepta.current.focus();
	                }
	            }
	        } else if (event.which === 46) {
	            return false;
	        } else if (event.which >= 48 && event.which <= 57) {
	            return true;
	        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	            return true;
	        } else return false;
	    };
	
	    var cerrarModal = function cerrarModal() {
	        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        props.onHideCancelar();
	        blanquear();
	    };
	
	    var datosFactura = function datosFactura() {
	        props.onHideDatos(datos);
	        setActivo(0);
	    };
	
	    var onCatalogoCerrar = function onCatalogoCerrar() {
	        setMostrar(false);
	    };
	
	    var onCatalogoTipoRentas = function onCatalogoTipoRentas() {
	        setMostrar(true);
	    };
	
	    var onCatalogoTipoRentasData = function onCatalogoTipoRentasData(infor) {
	        setMostrar(false);
	
	        var idv = void 0;
	        for (var i = 0; i < values.length; i++) {
	            idv = values[i].codigo;
	        }
	        if (infor.idtiporetencion === idv) {
	            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Este Tipo de Retención ya fue Cargada', icono: 'error' });
	        } else {
	            txtCodigo.current.value = infor.idtiporetencion;
	            txtDescrip.current.value = infor.descripcion;
	            setDatati(infor);
	            if (infor.idtiporetencion === '1') {
	                var m = 75;
	                txtAlicuota.current.value = (0, _varios.formatMoneda)(m.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	                onCalculo(infor);
	            } else if (infor.tipo === 1) {
	                txtAlicuota.current.value = (0, _varios.formatMoneda)(infor.deducible.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	                onCalculo(infor);
	            } else if (parseInt(infor.unidad) === 3) {
	                setActivo(1);
	                setOperacion(4);
	            } else if (parseInt(infor.unidad) === 4) {
	                txtAlicuota.current.value = (0, _varios.formatMoneda)(infor.otro.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	                onCalculo(infor);
	            }
	        }
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'xl',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	
	                if (props.operacion === 1) {
	                    txtCodigo.current.focus();
	                    setValues(props.idc);
	                    txtBase.current.value = (0, _varios.formatMoneda)(props.data[0].base.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	                    txtIva.current.value = (0, _varios.formatMoneda)(props.data[0].iva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	                    txtMontoIva.current.value = (0, _varios.formatMoneda)(props.data[0].montoiva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	                    txtCompromiso.current.value = (0, _varios.formatMoneda)(props.data[0].totalc.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	                } else if (props.operacion === 2) {
	
	                    if (props.datos[0].codigo === '3') {
	                        setActivo(1);
	                    } else {
	                        setActivo(0);
	                    }
	
	                    var montototal = parseFloat(props.datos[0].totalf) + parseFloat(props.datos[0].montoiva);
	                    txtCodigo.current.value = props.datos[0].codigo;
	                    txtDescrip.current.value = props.datos[0].descripcion;
	                    txtBase.current.value = (0, _varios.formatMoneda)(props.datos[0].totalf.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	                    txtIva.current.value = (0, _varios.formatMoneda)(props.datos[0].iva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	                    txtMontoIva.current.value = (0, _varios.formatMoneda)(props.datos[0].montoiva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	                    txtCompromiso.current.value = (0, _varios.formatMoneda)(montototal.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	                    txtAlicuota.current.value = (0, _varios.formatMoneda)(props.datos[0].alicuota.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	                    txtTotal.current.value = (0, _varios.formatMoneda)(props.datos[0].total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	                } else {
	                    txtCodigo.current.value = '';
	                    txtDescrip.current.value = '';
	                    txtBase.current.value = '';
	                    txtIva.current.value = '';
	                    txtMontoIva.current.value = '';
	                    txtCompromiso.current.value = '';
	                    txtAlicuota.current.value = '';
	                    txtTotal.current.value = '';
	                }
	            }
	
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Incluir Retenciones'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_catalogoTipoRetenciones2.default, {
	                show: mostrar,
	                onHideCancelar: onCatalogoCerrar,
	                onHideAceptaCatalogo: onCatalogoTipoRentasData
	            }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'container-fluid  rounded row mx-auto' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 mb-2 mx-auto px-0' },
	                    _react2.default.createElement(
	                        'fieldset',
	                        { className: ' row col-sm-12 mx-auto border-azul rounded' },
	                        _react2.default.createElement(
	                            'legend',
	                            { className: 'float-none w-auto fw-bold', style: { fontSize: '15px' } },
	                            'Datos de la Retenci\xF3n'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 row m-0' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'input-group input-group-sm mb-2 col-md-2' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                    'C\xF3digo:'
	                                ),
	                                _react2.default.createElement('input', { type: 'text', ref: txtCodigo, name: 'codigo', id: 'codigo', className: 'form-control', onKeyUp: handleInputNumChange, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                                _react2.default.createElement(
	                                    'button',
	                                    { type: 'button', onClick: function onClick() {
	                                            return onCatalogoTipoRentas();
	                                        }, className: 'btn btn-sm btn-primary' },
	                                    _react2.default.createElement('i', { className: 'fas fa-search' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'input-group input-group-sm mb-2 col-md-7' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                    'Descripci\xF3n:'
	                                ),
	                                _react2.default.createElement('input', { type: 'text', ref: txtDescrip, name: 'otros', id: 'otros', className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'input-group input-group-sm mb-2 col-md-3' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                    'Fecha de Retenci\xF3n:'
	                                ),
	                                _react2.default.createElement('input', { type: 'date', ref: txtFecha, name: 'ajustes', id: 'ajustes', className: 'form-control text-right', defaultValue: (0, _moment2.default)(fechaSistema).format('YYYY-MM-DD'), 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'fieldset',
	                            { className: 'row col-sm-12 mx-auto border-azul rounded px-1' },
	                            activo !== 1 ? _react2.default.createElement(
	                                'div',
	                                { className: 'row m-0' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-3' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'input-group input-group-sm mb-2' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                            'Base Imponible:'
	                                        ),
	                                        _react2.default.createElement('input', { type: 'text', ref: txtBase, name: 'base', className: 'form-control text-right', disabled: true, placeholder: '0,00', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'input-group input-group-sm mb-2 col-md-9 mx-auto' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                            '% IVA:'
	                                        ),
	                                        _react2.default.createElement('input', { type: 'text', ref: txtIva, disabled: true, name: 'iva', id: 'iva', className: 'form-control text-center', onKeyUp: handleInputMontoChange, onBlur: handleInputMontoChange, placeholder: '0,00', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'input-group input-group-sm mb-2' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                            'Monto IVA:'
	                                        ),
	                                        _react2.default.createElement('input', { type: 'text', ref: txtMontoIva, name: 'totaliva', disabled: true, className: 'form-control text-right', placeholder: '0,00', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-3' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'input-group input-group-sm mb-2' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                            'Total Factura:'
	                                        ),
	                                        _react2.default.createElement('input', { type: 'text', ref: txtCompromiso, disabled: true, name: 'exento', id: 'exento', className: 'form-control text-right', onKeyUp: handleInputMontoChange, onBlur: handleInputMontoChange, placeholder: '0,00', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'input-group input-group-sm mb-2' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                            'Alicuota:'
	                                        ),
	                                        _react2.default.createElement('input', { type: 'text', ref: txtAlicuota, name: 'alicuota', id: 'alicuota', className: 'form-control text-right', onKeyUp: handleInputMontoChange, onBlur: handleInputMontoChange, placeholder: '0,00', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-3 ml-auto' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'input-group input-group-sm mb-2' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                            'Total Retenci\xF3n:'
	                                        ),
	                                        _react2.default.createElement('input', { type: 'text', ref: txtTotal, disabled: activo !== 1 ? true : false, name: 'exento', id: 'exento', className: 'form-control text-right', onKeyUp: handleInputMontoChange, onBlur: handleInputMontoChange, placeholder: '0,00', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                                    )
	                                )
	                            ) : _react2.default.createElement(
	                                'div',
	                                { className: 'row m-0' },
	                                _react2.default.createElement('input', { type: 'hidden', ref: txtBase, name: 'base' }),
	                                _react2.default.createElement('input', { type: 'hidden', ref: txtIva, name: 'iva' }),
	                                _react2.default.createElement('input', { type: 'hidden', ref: txtMontoIva, name: 'totaliva' }),
	                                _react2.default.createElement('input', { type: 'hidden', ref: txtCompromiso, name: 'exento' }),
	                                _react2.default.createElement('input', { type: 'hidden', ref: txtAlicuota, name: 'alicuota' }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-3 ml-auto' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'input-group input-group-sm mb-2' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                            'Total Retenci\xF3n:'
	                                        ),
	                                        _react2.default.createElement('input', { type: 'text', ref: txtTotal, disabled: activo !== 1 ? true : false, name: 'total', id: 'total', onBlur: handleInputMontoChange, onKeyUp: handleInputMontoChange, className: 'form-control text-right', placeholder: '0,00', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { type: 'button', ref: btnAcepta, onClick: datosFactura, disabled: operacion === 4 ? true : false, style: { margin: '1px' }, className: ' btn btn-success btn-sm rounded-pill' },
	                _react2.default.createElement('i', { className: 'far fa-check-circle' }),
	                ' Aceptar'
	            ),
	            _react2.default.createElement(
	                'button',
	                { type: 'button', ref: btnCancela, onClick: cancelar, style: { margin: '1px' }, className: ' btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement('i', { className: 'fas fa-window-close' }),
	                ' Cancelar'
	            )
	        ),
	        _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	            onHide: function onHide() {
	                mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	            } }),
	        _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	            onHideNo: function onHideNo() {
	                return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	            } })
	    );
	};

/***/ },
/* 7076 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalPermisosUsuariosc = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTable = __webpack_require__(20);
	
	var _useTable2 = _interopRequireDefault(_useTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalPermisosUsuariosc = exports.ModalPermisosUsuariosc = function ModalPermisosUsuariosc(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
	  var idusuario = JSON.parse(sessionStorage.getItem("idusuario"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtLogin = (0, _react.useRef)();
	  var txtCedula = (0, _react.useRef)();
	  var txtStatus = (0, _react.useRef)();
	  var txtIduser = (0, _react.useRef)();
	
	  var txtuTodos = (0, _react.useRef)();
	  var txtuIncluir = (0, _react.useRef)();
	  var txtuModificar = (0, _react.useRef)();
	  var txtuCosultar = (0, _react.useRef)();
	  var txtuEliminar = (0, _react.useRef)();
	  var txtuImprimir = (0, _react.useRef)();
	
	  var txtdTodos = (0, _react.useRef)();
	  var txtdIncluir = (0, _react.useRef)();
	  var txtdModificar = (0, _react.useRef)();
	  var txtdCosultar = (0, _react.useRef)();
	  var txtdEliminar = (0, _react.useRef)();
	  var txtdImprimir = (0, _react.useRef)();
	
	  var txttTodos = (0, _react.useRef)();
	  var txttIncluir = (0, _react.useRef)();
	  var txttModificar = (0, _react.useRef)();
	  var txttCosultar = (0, _react.useRef)();
	  var txttEliminar = (0, _react.useRef)();
	  var txttImprimir = (0, _react.useRef)();
	
	  var txtcTodos = (0, _react.useRef)();
	  var txtcIncluir = (0, _react.useRef)();
	  var txtcModificar = (0, _react.useRef)();
	  var txtcCosultar = (0, _react.useRef)();
	  var txtcEliminar = (0, _react.useRef)();
	  var txtcImprimir = (0, _react.useRef)();
	
	  var txtcoTodos = (0, _react.useRef)();
	  var txtcoIncluir = (0, _react.useRef)();
	  var txtcoModificar = (0, _react.useRef)();
	  var txtcoCosultar = (0, _react.useRef)();
	  var txtcoEliminar = (0, _react.useRef)();
	  var txtcoImprimir = (0, _react.useRef)();
	
	  var txtsTodos = (0, _react.useRef)();
	  var txtsIncluir = (0, _react.useRef)();
	  var txtsModificar = (0, _react.useRef)();
	  var txtsCosultar = (0, _react.useRef)();
	  var txtsEliminar = (0, _react.useRef)();
	  var txtsImprimir = (0, _react.useRef)();
	
	  var txtsiTodos = (0, _react.useRef)();
	  var txtsiIncluir = (0, _react.useRef)();
	  var txtsiModificar = (0, _react.useRef)();
	  var txtsiCosultar = (0, _react.useRef)();
	  var txtsiEliminar = (0, _react.useRef)();
	  var txtsiImprimir = (0, _react.useRef)();
	
	  var txtoTodos = (0, _react.useRef)();
	  var txtoIncluir = (0, _react.useRef)();
	  var txtoModificar = (0, _react.useRef)();
	  var txtoCosultar = (0, _react.useRef)();
	  var txtoEliminar = (0, _react.useRef)();
	  var txtoImprimir = (0, _react.useRef)();
	
	  var txtnTodos = (0, _react.useRef)();
	  var txtnIncluir = (0, _react.useRef)();
	  var txtnModificar = (0, _react.useRef)();
	  var txtnCosultar = (0, _react.useRef)();
	  var txtnEliminar = (0, _react.useRef)();
	  var txtnImprimir = (0, _react.useRef)();
	
	  var txtdzTodos = (0, _react.useRef)();
	  var txtdzIncluir = (0, _react.useRef)();
	  var txtdzModificar = (0, _react.useRef)();
	  var txtdzCosultar = (0, _react.useRef)();
	  var txtdzEliminar = (0, _react.useRef)();
	  var txtdzImprimir = (0, _react.useRef)();
	
	  var txtocTodos = (0, _react.useRef)();
	  var txtocIncluir = (0, _react.useRef)();
	  var txtocModificar = (0, _react.useRef)();
	  var txtocCosultar = (0, _react.useRef)();
	  var txtocEliminar = (0, _react.useRef)();
	  var txtocImprimir = (0, _react.useRef)();
	
	  var txtReportTodos = (0, _react.useRef)();
	  var txtReport1 = (0, _react.useRef)();
	  var txtReport2 = (0, _react.useRef)();
	  var txtReport3 = (0, _react.useRef)();
	  var txtReport4 = (0, _react.useRef)();
	  var txtReport5 = (0, _react.useRef)();
	  var txtReport6 = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      modu1 = _useState2[0],
	      setModu1 = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      modu2 = _useState4[0],
	      setModu2 = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      modu3 = _useState6[0],
	      setModu3 = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      modu4 = _useState8[0],
	      setModu4 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      modu5 = _useState10[0],
	      setModu5 = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      modu6 = _useState12[0],
	      setModu6 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      modu7 = _useState14[0],
	      setModu7 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      modu8 = _useState16[0],
	      setModu8 = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      modu9 = _useState18[0],
	      setModu9 = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      modu10 = _useState20[0],
	      setModu10 = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      modu11 = _useState22[0],
	      setModu11 = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0),
	      _useState24 = _slicedToArray(_useState23, 2),
	      modu12 = _useState24[0],
	      setModu12 = _useState24[1];
	
	  var _useState25 = (0, _react.useState)({}),
	      _useState26 = _slicedToArray(_useState25, 2),
	      body = _useState26[0],
	      setBody = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      operacion = _useState28[0],
	      setOperacion = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      activate = _useState30[0],
	      setActivate = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(true),
	      _useState32 = _slicedToArray(_useState31, 2),
	      habilitado = _useState32[0],
	      setHabilitado = _useState32[1];
	
	  var _useState33 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState34 = _slicedToArray(_useState33, 2),
	      mensaje = _useState34[0],
	      setMensaje = _useState34[1];
	
	  var _useState35 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState36 = _slicedToArray(_useState35, 2),
	      mensajesino = _useState36[0],
	      setMensajesino = _useState36[1];
	
	  var _useState37 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState38 = _slicedToArray(_useState37, 2),
	      botones = _useState38[0],
	      setBotones = _useState38[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var SelectUsuario = function SelectUsuario(idusuario) {
	    var endpoint = op.conexion + '/api/athos/usuario/getuser?id=' + idusuario;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.idusuario > 0) {
	
	          var para1 = response.data.accbtnproveedores;
	          var para2 = response.data.accbtnordencompra;
	          var para3 = response.data.accbtnfactucompra;
	          var para4 = response.data.accbtncreports;
	
	          sessionStorage.setItem("accbtnproveedoresc", JSON.stringify(para1));
	          sessionStorage.setItem("accbtnordencomprac", JSON.stringify(para2));
	          sessionStorage.setItem("accbtnfactucomprac", JSON.stringify(para3));
	          sessionStorage.setItem("accbtncreportsc", JSON.stringify(para4));
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "Error al cargar el usuario",
	            icono: "informacion"
	          });
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var parameter1 = "";
	    var parameter2 = "";
	    var parameter3 = "";
	    var parameter4 = "";
	    var parameter5 = "";
	    var parameter6 = "";
	    var parameter7 = "";
	    var parameter8 = "";
	    var parameter9 = "";
	    var parameter10 = "";
	    var reportes = "";
	
	    if (props.usuario.acccompras.toString().substring(0, 1) === '1') {
	
	      var val1 = txtuIncluir.current.checked === true ? "1" : "0";
	      var val2 = txtuModificar.current.checked === true ? "1" : "0";
	      var val3 = txtuCosultar.current.checked === true ? "1" : "0";
	      var val4 = txtuEliminar.current.checked === true ? "1" : "0";
	      var val5 = txtuImprimir.current.checked === true ? "1" : "0";
	
	      parameter1 = val1 + val2 + val3 + val4 + val5;
	    } else {
	
	      parameter1 = '000000';
	    }
	
	    if (props.usuario.acccompras.toString().substring(1, 2) === '1') {
	
	      var _val = txtdIncluir.current.checked === true ? "1" : "0";
	      var _val2 = txtdModificar.current.checked === true ? "1" : "0";
	      var _val3 = txtdCosultar.current.checked === true ? "1" : "0";
	      var _val4 = txtdEliminar.current.checked === true ? "1" : "0";
	      var _val5 = txtdImprimir.current.checked === true ? "1" : "0";
	
	      parameter2 = _val + _val2 + _val3 + _val4 + _val5;
	    } else {
	
	      parameter2 = '000000';
	    }
	
	    if (props.usuario.acccompras.toString().substring(2, 3) === '1') {
	
	      var _val6 = txttIncluir.current.checked === true ? "1" : "0";
	      var _val7 = txttModificar.current.checked === true ? "1" : "0";
	      var _val8 = txttCosultar.current.checked === true ? "1" : "0";
	      var _val9 = txttEliminar.current.checked === true ? "1" : "0";
	      var _val10 = txttImprimir.current.checked === true ? "1" : "0";
	
	      parameter3 = _val6 + _val7 + _val8 + _val9 + _val10;
	    } else {
	
	      parameter3 = '000000';
	    }
	
	    if (props.usuario.acccompras.toString().substring(4, 5) === '1') {
	
	      var _val11 = txtReport1.current.checked === true ? "1" : "0";
	      var _val12 = txtReport2.current.checked === true ? "1" : "0";
	      var _val13 = txtReport3.current.checked === true ? "1" : "0";
	      var _val14 = txtReport4.current.checked === true ? "1" : "0";
	      var _val15 = txtReport5.current.checked === true ? "1" : "0";
	      var val6 = txtReport6.current.checked === true ? "1" : "0";
	
	      reportes = _val11 + _val12 + _val13 + _val14 + _val15 + val6;
	    } else {
	
	      reportes = '000000';
	    }
	
	    var sigue = true;
	    var mensaje = "";
	
	    if (sigue) {
	      var user = [];
	      user.push({
	        idusuario: txtIduser.current.value,
	        login: txtLogin.current.value,
	        persona: txtCedula.current.value,
	        status: txtStatus.current.value === 'ACTIVO' ? 1 : 0,
	        idorganizacion: idorganizacion,
	        accbtnproveedores: parameter1,
	        accbtnordencompra: parameter2,
	        accbtnfactucompra: parameter3,
	        accbtncreports: reportes
	      });
	
	      var _body = {
	        usu: JSON.stringify(user)
	      };
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	      setBody(_body);
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: mensaje,
	        icono: "informacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    var endpoint = op.conexion + '/api/athos/usuario/actualizar/' + operacion;
	
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setActivate(false);
	
	        if (parseInt(response.data.iduser) > 0) {
	          if (parseInt(response.data.iduser) === parseInt(idusuario)) {
	            SelectUsuario(parseInt(response.data.iduser));
	          }
	        }
	
	        var mensaje = "";
	        if (operacion === 1) {
	          mensaje = "El Usuario " + response.data.iduser + " ha sido registrada de manera satisfactoria.";
	        } else if (operacion === 2) {
	          mensaje = "El Usuario " + response.data.iduser + " ha sido Modificada de manera Satisfactoria.";
	        } else if (operacion === 3) {
	          mensaje = "El usuario " + response.data.iduser + " ha sido eliminada de manera satisfactoria.";
	        }
	
	        setMensaje({
	          mostrar: true,
	          titulo: "Exito.",
	          texto: mensaje,
	          icono: "exito"
	        });
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    procesarRegistro();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    props.onHideCancela();
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var checkBlank = function checkBlank(e) {
	
	    if (modu1 === 1) {
	      if (txtuIncluir.current.checked && txtuModificar.current.checked && txtuCosultar.current.checked && txtuEliminar.current.checked && txtuImprimir.current.checked) {
	        txtuTodos.current.checked = true;
	      } else {
	        txtuTodos.current.checked = false;
	      }
	    }
	
	    if (modu2 === 1) {
	      if (txtdIncluir.current.checked && txtdModificar.current.checked && txtdCosultar.current.checked && txtdEliminar.current.checked && txtdImprimir.current.checked) {
	        txtdTodos.current.checked = true;
	      } else {
	        txtdTodos.current.checked = false;
	      }
	    }
	
	    if (modu3 === 1) {
	      if (txttIncluir.current.checked && txttModificar.current.checked && txttCosultar.current.checked && txttEliminar.current.checked && txttImprimir.current.checked) {
	        txttTodos.current.checked = true;
	      } else {
	        txttTodos.current.checked = false;
	      }
	    }
	
	    if (modu4 === 1) {
	      if (txtReport1.current.checked && txtReport2.current.checked && txtReport3.current.checked && txtReport4.current.checked && txtReport5.current.checked && txtReport6.current.checked) {
	        txtReportTodos.current.checked = true;
	      } else {
	        txtReportTodos.current.checked = false;
	      }
	    }
	  };
	
	  var checkTodo = function checkTodo(e) {
	    if (e.target.name === "todos1") {
	      if (txtuTodos.current.checked) {
	        txtuIncluir.current.checked = true;
	        txtuModificar.current.checked = true;
	        txtuCosultar.current.checked = true;
	        txtuEliminar.current.checked = true;
	        txtuImprimir.current.checked = true;
	      } else {
	        txtuIncluir.current.checked = false;
	        txtuModificar.current.checked = false;
	        txtuCosultar.current.checked = false;
	        txtuEliminar.current.checked = false;
	        txtuImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos2") {
	      if (txtdTodos.current.checked) {
	        txtdIncluir.current.checked = true;
	        txtdModificar.current.checked = true;
	        txtdCosultar.current.checked = true;
	        txtdEliminar.current.checked = true;
	        txtdImprimir.current.checked = true;
	      } else {
	        txtdIncluir.current.checked = false;
	        txtdModificar.current.checked = false;
	        txtdCosultar.current.checked = false;
	        txtdEliminar.current.checked = false;
	        txtdImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos3") {
	      if (txttTodos.current.checked) {
	        txttIncluir.current.checked = true;
	        txttModificar.current.checked = true;
	        txttCosultar.current.checked = true;
	        txttEliminar.current.checked = true;
	        txttImprimir.current.checked = true;
	      } else {
	        txttIncluir.current.checked = false;
	        txttModificar.current.checked = false;
	        txttCosultar.current.checked = false;
	        txttEliminar.current.checked = false;
	        txttImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todosreportes") {
	      if (txtReportTodos.current.checked) {
	        txtReport1.current.checked = true;
	        txtReport2.current.checked = true;
	        txtReport3.current.checked = true;
	        txtReport4.current.checked = true;
	        txtReport5.current.checked = true;
	        txtReport6.current.checked = true;
	      } else {
	        txtReport1.current.checked = false;
	        txtReport2.current.checked = false;
	        txtReport3.current.checked = false;
	        txtReport4.current.checked = false;
	        txtReport5.current.checked = false;
	        txtReport6.current.checked = false;
	      }
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'xl',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.op === 1) {
	          setOperacion(2);
	          if (props.usuario.acccompras.toString().substring(0, 1) === '1') {
	            setModu1(1);
	          } else {
	            setModu1(0);
	          }
	
	          if (props.usuario.acccompras.toString().substring(1, 2) === '1') {
	            setModu2(1);
	          } else {
	            setModu2(0);
	          }
	
	          if (props.usuario.acccompras.toString().substring(2, 3) === '1') {
	            setModu3(1);
	          } else {
	            setModu3(0);
	          }
	
	          if (props.usuario.acccompras.toString().substring(4, 5) === '1') {
	            setModu4(1);
	          } else {
	            setModu4(0);
	          }
	          setHabilitado(false);
	        } else {
	
	          setHabilitado(true);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Permisos de Usuario (Compras)'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto m-0' },
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1 d-flex justify-content-around', style: { fontSizeAdjust: '0.6' } },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-6 fw-bold' },
	              'Datos del Usuarios'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-200 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'USUARIO:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtLogin, defaultValue: props.usuario && props.usuario.login, className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement('input', { type: 'hidden', ref: txtIduser, defaultValue: props.usuario && props.usuario.idusuario }),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-180 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'CEDULA:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtCedula, defaultValue: props.persona && props.persona.cedula, className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-500 px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'NOMBRES Y APELLIDOS:'
	                ),
	                _react2.default.createElement('input', { type: 'text', defaultValue: props.persona && props.persona.nombres.trim() + " " + props.persona.apellidos.trim(), className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-170 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'ESTATUS:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtStatus, defaultValue: props.usuario && props.usuario.status === '1' ? 'ACTIVO' : 'INACTIVO', className: 'form-control text-uppercase fs-6 text-center', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-5 fw-bold' },
	              'Modulos Autorizados'
	            ),
	            modu1 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Proveedores'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuTodos,
	                          defaultChecked: props.usuario.accbtnproveedores.substring(0, 1) === '1' && props.usuario.accbtnproveedores.substring(1, 2) === '1' && props.usuario.accbtnproveedores.substring(2, 3) === '1' && props.usuario.accbtnproveedores.substring(3, 4) === '1' && props.usuario.accbtnproveedores.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos1', id: 'inlineCheckboxu' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuIncluir, defaultChecked: props.usuario.accbtnproveedores.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuModificar, defaultChecked: props.usuario.accbtnproveedores.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuCosultar, defaultChecked: props.usuario.accbtnproveedores.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuEliminar, defaultChecked: props.usuario.accbtnproveedores.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuImprimir, defaultChecked: props.usuario.accbtnproveedores.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu2 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Ordenes de Compra'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdTodos,
	                          defaultChecked: props.usuario.accbtnordencompra.substring(0, 1) === '1' && props.usuario.accbtnordencompra.substring(1, 2) === '1' && props.usuario.accbtnordencompra.substring(2, 3) === '1' && props.usuario.accbtnordencompra.substring(3, 4) === '1' && props.usuario.accbtnordencompra.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos2', id: 'inlineCheckboxd' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdIncluir, defaultChecked: props.usuario.accbtnordencompra.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdModificar, defaultChecked: props.usuario.accbtnordencompra.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdCosultar, defaultChecked: props.usuario.accbtnordencompra.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdEliminar, defaultChecked: props.usuario.accbtnordencompra.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdImprimir, defaultChecked: props.usuario.accbtnordencompra.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu3 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Facturas de Compra'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttTodos,
	                          defaultChecked: props.usuario.accbtnfactucompra.substring(0, 1) === '1' && props.usuario.accbtnfactucompra.substring(1, 2) === '1' && props.usuario.accbtnfactucompra.substring(2, 3) === '1' && props.usuario.accbtnfactucompra.substring(3, 4) === '1' && props.usuario.accbtnfactucompra.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos3', id: 'inlineCheckboxt' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttIncluir, defaultChecked: props.usuario.accbtnfactucompra.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttModificar, defaultChecked: props.usuario.accbtnfactucompra.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttCosultar, defaultChecked: props.usuario.accbtnfactucompra.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttEliminar, defaultChecked: props.usuario.accbtnfactucompra.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttImprimir, defaultChecked: props.usuario.accbtnfactucompra.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu4 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Reportes'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReportTodos,
	                          defaultChecked: props.usuario.accbtncreports.substring(0, 1) === '1' /* && props.usuario.accbtncreports.substring(1, 2) === '1' &&
	                                                                                               props.usuario.accbtncreports.substring(2, 3) === '1' && props.usuario.accbtncreports.substring(3, 4) === '1' &&
	                                                                                               props.usuario.accbtncreports.substring(4, 5) === '1' && props.usuario.accbtncreports.substring(5, 6) === '1' */ ? true : false,
	                          onChange: checkTodo, name: 'todosreportes', id: 'inlineCheckboxr' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport1, defaultChecked: props.usuario.accbtncreports.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr1' },
	                          'MOVIMIENTOS (FACTURAS DE COMPRAS)'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement('input', { type: 'hidden', ref: txtReport2, value: 'false' }),
	                    _react2.default.createElement('input', { type: 'hidden', ref: txtReport3, value: 'false' }),
	                    _react2.default.createElement('input', { type: 'hidden', ref: txtReport4, value: 'false' }),
	                    _react2.default.createElement('input', { type: 'hidden', ref: txtReport5, value: 'false' }),
	                    _react2.default.createElement('input', { type: 'hidden', ref: txtReport6, value: 'false' })
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : ''
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-4 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: props.usuario && props.usuario.status === '0' ? true : false, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-success' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check-circle' },
	              '  Aceptar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7077 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _core = __webpack_require__(19);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _catalogoMoneda = __webpack_require__(7030);
	
	var _catalogoMoneda2 = _interopRequireDefault(_catalogoMoneda);
	
	var _catalogoProducto = __webpack_require__(104);
	
	var _catalogoProducto2 = _interopRequireDefault(_catalogoProducto);
	
	var _catalogoOrdenesdCompra = __webpack_require__(654);
	
	var _catalogoOrdenesdCompra2 = _interopRequireDefault(_catalogoOrdenesdCompra);
	
	var _catalogoAgregarProveedor = __webpack_require__(291);
	
	var _catalogoAgregarProveedor2 = _interopRequireDefault(_catalogoAgregarProveedor);
	
	var _tablaRetenciones = __webpack_require__(7079);
	
	var _tablaRetenciones2 = _interopRequireDefault(_tablaRetenciones);
	
	var _catalogoFacturasCompra = __webpack_require__(7028);
	
	var _catalogoFacturasCompra2 = _interopRequireDefault(_catalogoFacturasCompra);
	
	var _catalogoAlmacen = __webpack_require__(51);
	
	var _catalogoAlmacen2 = _interopRequireDefault(_catalogoAlmacen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var TablaFacturarOrdenCompra = function TablaFacturarOrdenCompra() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var idusuario = JSON.parse(sessionStorage.getItem("idusuario"));
	  var usuario = JSON.parse(sessionStorage.getItem("login"));
	  var accbtnfactucompra = JSON.parse(sessionStorage.getItem("accbtnfactucomprac"));
	
	  var headCells = [{ label: "COD/PRODUCTO", width: "0px" }, { label: "PRODUCTO", textAlign: "center" }, { label: "CNTD", textAlign: "center" }, { label: "UNI.ALT.", textAlign: "center" }, { label: "PRECIO PVDR.", textAlign: "center" }, { label: "IVA", textAlign: "center" }, { label: "MONTO IVA.", textAlign: "center" }, { label: "MONTO TOTAL", textAlign: "center" }, {
	    label: _react2.default.createElement("i", { className: "fas fa-trash" }),
	    textAlign: "center",
	    width: "20px"
	  }];
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var txtNombreCliente = (0, _react.useRef)();
	  var txtSubTotal = (0, _react.useRef)();
	  var txtTotalIva = (0, _react.useRef)();
	  var txtTotalconIva = (0, _react.useRef)();
	  var txtTotal = (0, _react.useRef)();
	  var txtDirClient = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtIdfactura = (0, _react.useRef)();
	  var txtCantidad = (0, _react.useRef)([]);
	  var txtPrecio = (0, _react.useRef)([]);
	  var txtId = (0, _react.useRef)([]);
	  var txtCedRif = (0, _react.useRef)();
	  var txtCodigo = (0, _react.useRef)();
	  var txtTotalRetencion = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtExento = (0, _react.useRef)();
	  var txtAlmacen = (0, _react.useRef)();
	  var txtIdmoneda = (0, _react.useRef)();
	  var txtIdmonedados = (0, _react.useRef)();
	  var txtAfectaInventario = (0, _react.useRef)();
	  var txtOrdenCompra = (0, _react.useRef)();
	  var txtNumControl = (0, _react.useRef)();
	  var txtCodigoProducto = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(""),
	      _useState2 = _slicedToArray(_useState, 2),
	      idCliente = _useState2[0],
	      setIdCliente = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      datosfact = _useState4[0],
	      setDatosfact = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(true),
	      _useState6 = _slicedToArray(_useState5, 2),
	      habilitarCat = _useState6[0],
	      setHabilitarCat = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      desde = _useState8[0],
	      setDesde = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      catalogoPresu = _useState10[0],
	      setCatalogoPresu = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      catalogoFactura = _useState12[0],
	      setCatalogoFactura = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      catalogoalmacen = _useState14[0],
	      setCatalogoalmacen = _useState14[1];
	
	  var _useState15 = (0, _react.useState)("Gestionar Facturas de Compra."),
	      _useState16 = _slicedToArray(_useState15, 2),
	      tituloHeader = _useState16[0],
	      setTituloHeader = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(null),
	      _useState18 = _slicedToArray(_useState17, 2),
	      numNota = _useState18[0],
	      setNumNota = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      tipou = _useState20[0],
	      setTipou = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      valalmacen = _useState22[0],
	      setValalmacen = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(null),
	      _useState24 = _slicedToArray(_useState23, 2),
	      rif = _useState24[0],
	      setRif = _useState24[1];
	
	  var _useState25 = (0, _react.useState)("visible"),
	      _useState26 = _slicedToArray(_useState25, 2),
	      visibleBtn = _useState26[0],
	      setVisibleBtn = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      statusordencompra = _useState28[0],
	      setStatusordencompra = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(0),
	      _useState30 = _slicedToArray(_useState29, 2),
	      tasaor = _useState30[0],
	      setTasaor = _useState30[1];
	
	  var _useState31 = (0, _react.useState)([]),
	      _useState32 = _slicedToArray(_useState31, 2),
	      records = _useState32[0],
	      setRecords = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(false),
	      _useState34 = _slicedToArray(_useState33, 2),
	      mostrar = _useState34[0],
	      setMostrar = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(true),
	      _useState36 = _slicedToArray(_useState35, 2),
	      consulp = _useState36[0],
	      setConsulp = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(true),
	      _useState38 = _slicedToArray(_useState37, 2),
	      habilitado = _useState38[0],
	      setHabilitado = _useState38[1];
	
	  var _useState39 = (0, _react.useState)([]),
	      _useState40 = _slicedToArray(_useState39, 2),
	      items = _useState40[0],
	      setItems = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(0),
	      _useState42 = _slicedToArray(_useState41, 2),
	      idmoney = _useState42[0],
	      setIdmoney = _useState42[1];
	
	  var _useState43 = (0, _react.useState)([]),
	      _useState44 = _slicedToArray(_useState43, 2),
	      datareten = _useState44[0],
	      setDatareten = _useState44[1];
	
	  var _useState45 = (0, _react.useState)([]),
	      _useState46 = _slicedToArray(_useState45, 2),
	      datosret = _useState46[0],
	      setDatosret = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(null),
	      _useState48 = _slicedToArray(_useState47, 2),
	      body = _useState48[0],
	      setBody = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(false),
	      _useState50 = _slicedToArray(_useState49, 2),
	      catregistrarcliente = _useState50[0],
	      setCatregistrarcliente = _useState50[1];
	
	  var _useState51 = (0, _react.useState)([]),
	      _useState52 = _slicedToArray(_useState51, 2),
	      combomoneda = _useState52[0],
	      setComboMoneda = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(false),
	      _useState54 = _slicedToArray(_useState53, 2),
	      catalogoCliente = _useState54[0],
	      setCatalogoCliente = _useState54[1];
	
	  var _useState55 = (0, _react.useState)(false),
	      _useState56 = _slicedToArray(_useState55, 2),
	      catalogoMoneda = _useState56[0],
	      setCatalogoMoneda = _useState56[1];
	
	  var _useState57 = (0, _react.useState)(""),
	      _useState58 = _slicedToArray(_useState57, 2),
	      valparametro = _useState58[0],
	      setValparametro = _useState58[1];
	
	  var _useState59 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState60 = _slicedToArray(_useState59, 2),
	      mensaje = _useState60[0],
	      setMensaje = _useState60[1];
	
	  var _useState61 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState62 = _slicedToArray(_useState61, 2),
	      mensajesino = _useState62[0],
	      setMensajesino = _useState62[1];
	
	  var _useState63 = (0, _react.useState)(null),
	      _useState64 = _slicedToArray(_useState63, 2),
	      idorden = _useState64[0],
	      setIdorden = _useState64[1];
	
	  var _useState65 = (0, _react.useState)(0),
	      _useState66 = _slicedToArray(_useState65, 2),
	      idalmacen = _useState66[0],
	      setIdAlmacen = _useState66[1];
	
	  var _useState67 = (0, _react.useState)(null),
	      _useState68 = _slicedToArray(_useState67, 2),
	      indice = _useState68[0],
	      setIndice = _useState68[1];
	
	  var _useState69 = (0, _react.useState)(""),
	      _useState70 = _slicedToArray(_useState69, 2),
	      idOpeInve = _useState70[0],
	      setIdOpeInve = _useState70[1];
	
	  var _useState71 = (0, _react.useState)(false),
	      _useState72 = _slicedToArray(_useState71, 2),
	      activate = _useState72[0],
	      setActivate = _useState72[1];
	
	  var _useState73 = (0, _react.useState)(true),
	      _useState74 = _slicedToArray(_useState73, 2),
	      castabla = _useState74[0],
	      setCastabla = _useState74[1];
	
	  var _useState75 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLARES",
	    simbolo: "$",
	    predeterminada: true,
	    valormoneda: 0.0
	  }),
	      _useState76 = _slicedToArray(_useState75, 2),
	      moneda = _useState76[0],
	      setMoneda = _useState76[1];
	
	  var _useState77 = (0, _react.useState)({
	    idmoneda: "2",
	    descripcion: "DOLARES",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 0.0
	  }),
	      _useState78 = _slicedToArray(_useState77, 2),
	      monedaSub = _useState78[0],
	      setMonedaSub = _useState78[1];
	
	  var _useState79 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    catalogoper: true
	  }),
	      _useState80 = _slicedToArray(_useState79, 2),
	      botones = _useState80[0],
	      setBotones = _useState80[1];
	
	  var _useState81 = (0, _react.useState)(false),
	      _useState82 = _slicedToArray(_useState81, 2),
	      acpt = _useState82[0],
	      setAcpt = _useState82[1];
	
	  var _useState83 = (0, _react.useState)(false),
	      _useState84 = _slicedToArray(_useState83, 2),
	      habilitadoNU = _useState84[0],
	      setHabilitadoNU = _useState84[1];
	
	  var _useState85 = (0, _react.useState)(0),
	      _useState86 = _slicedToArray(_useState85, 2),
	      operacion = _useState86[0],
	      setOperacion = _useState86[1];
	
	  var _useState87 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState88 = _slicedToArray(_useState87, 2),
	      filterFn = _useState88[0],
	      setFilterFn = _useState88[1];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells, filterFn),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var opf = operacion === 0 ? 0 : operacion === 8 ? 8 : operacion === 4 ? 4 : operacion === 3 ? 3 : operacion === 1 && records.length === 0 ? 1 : operacion === 2 && records.length === 0 ? 1 : 2;
	
	  var seleccionarAlmacen = function seleccionarAlmacen(id, val) {
	    var campos = "*";
	    var nomtab = "almacen";
	    var nomid = "idalmacen";
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	
	          if (val === 7) {
	            txtAlmacen.current.value = response.data.idalmacen;
	          } else {
	            setIdAlmacen(response.data.idalmacen);
	            txtAlmacen.current.value = response.data.idalmacen;
	          }
	        } else {
	          setDesde(3);
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un Almacen de venta",
	            icono: "informacion"
	          });
	          blanquear();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var validarIdProductoM = function validarIdProductoM(index) {
	    return function (event) {
	      if (event.which === 13 || typeof event.which === "undefined") {
	        if (event.target.value !== "") {
	          seleccionarEditarProducto(index, idalmacen, event.target.value);
	        }
	      }
	    };
	  };
	
	  var validarIdProducto = function validarIdProducto(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        seleccionarProducto(idalmacen, event.target.value);
	      }
	    }
	  };
	
	  var editarProducto = function editarProducto(index) {
	    return function (e) {
	      e.preventDefault();
	      setMostrar(true);
	      setIndice(index);
	    };
	  };
	
	  var agregarProducto = function agregarProducto(producto) {
	    setMostrar(false);
	    if (indice === null) {
	      seleccionarProducto(idalmacen, producto.codigo);
	    } else {
	      seleccionarEditarProducto(indice, idalmacen, producto.codigo);
	    }
	  };
	
	  var eliminarProducto = function eliminarProducto(producto) {
	    return function (e) {
	      e.preventDefault();
	      var data = [].concat(_toConsumableArray(records));
	      var elementos = [];
	
	      for (var i = 0; i < data.length; i++) {
	        if (producto.idproducto !== data[i].idproducto) {
	          elementos.push(data[i]);
	        }
	      }
	      setRecords(elementos);
	      calcularTotales(elementos);
	    };
	  };
	
	  var seleccionarProducto = function seleccionarProducto(idubi, idprod) {
	
	    var endpoint = op.conexion + "/api/pedido/seleccionarproductoinv?idproducto=" + idprod.toUpperCase() + "&idalmacen=" + idubi;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var data = [].concat(_toConsumableArray(records));
	
	        if (response.data !== "") {
	          if (response.data.servicio) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "El producto no existe o esta Inactivo",
	              icono: "error"
	            });
	            txtCantidad.current[records.length - 1].value = "1,00";
	          } else {
	            for (var i = 0; i < records.length; i++) {
	              if (records[i].idproducto === response.data.idproducto) {
	                setActivate(false);
	                setMensaje({
	                  mostrar: true,
	                  titulo: "Notificacion",
	                  texto: "El PRODUCTO YA EXISTE",
	                  icono: "error"
	                });
	                return;
	              }
	            }
	
	            var uni = [];
	
	            if (parseInt(response.data.idunidadalterna) === 0) {
	              uni = [{
	                idunidad: response.data.idunidadmedida,
	                descripcion: response.data.descripcionuni,
	                tipo: "medida"
	              }];
	            } else {
	              uni = [{
	                idunidad: response.data.idunidadmedida,
	                descripcion: response.data.descripcionuni,
	                tipo: "medida"
	              }, {
	                idunidad: response.data.idunidadalterna,
	                descripcion: response.data.descripcionunialt,
	                tipo: "alterna"
	              }];
	            }
	
	            var precio = response.data.costoproveedor;
	
	            var montoiva = precio * response.data.ivaventa / 100;
	
	            data.push({
	              idproducto: response.data.idproducto,
	              codigo: response.data.codigo,
	              cantidad: 1.0,
	              nombrecorto: response.data.nombrecorto,
	              precio: precio,
	              iva: response.data.ivaventa,
	              motoiva: montoiva,
	              descuento: "",
	              total: parseFloat(precio) + parseFloat(montoiva),
	              totald: precio,
	              unidad: uni,
	              idunidadmedida: response.data.idunidadmedida,
	              idunidadalterna: response.data.idunidadalterna,
	              idmoneda: response.data.idmoneda,
	              valormoneda: (0, _varios.round)(monedaSub.valormoneda, 2),
	              tipounidad: 0,
	              valorfactor: response.data.valorfactor,
	              costoproveedor: response.data.costoproveedor,
	              tipofactor: response.data.tipofactor
	            });
	            setRecords(data);
	            if (operacion === 1) {
	              calcularTotales(data);
	              setDatosfact([]);
	              txtTotalRetencion.current.value = "";
	            } else {
	              setTipou(1);
	              var subtot = 0.0,
	                  totr = 0.0,
	                  totalm = 0.0,
	                  toivss = 0.0,
	                  totalexento = 0.0;
	
	              for (var _i = 0; _i < data.length; _i++) {
	                toivss = parseFloat(toivss) + data[_i].motoiva;
	                subtot = parseFloat(subtot) + parseFloat(data[_i].totald);
	                if (parseInt(data[_i].iva) === 0) {
	                  totalexento = parseFloat(totalexento) + parseFloat(data[_i].totald);
	                }
	              }
	
	              totalm = subtot + toivss;
	              txtSubTotal.current.value = (0, _varios.formatMoneda)(subtot.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	              txtExento.current.value = (0, _varios.formatMoneda)(totalexento.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	              txtTotalIva.current.value = (0, _varios.formatMoneda)(toivss.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	              txtTotalconIva.current.value = (0, _varios.formatMoneda)(totalm.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	              txtTotal.current.value = (0, _varios.formatMoneda)(totalm.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	              var ret = [].concat(_toConsumableArray(datosret));
	              var info = [];
	              info.push({
	                base: txtSubTotal.current.value.replace(/\./g, "").replace(",", "."),
	                iva: response.data.ivaventa,
	                montoiva: txtTotalIva.current.value.replace(/\./g, "").replace(",", "."),
	                totalc: txtTotal.current.value.replace(/\./g, "").replace(",", "."),
	                id: ret.length > 0 ? ret[0].codigo : ""
	              });
	              setDatosfact(info);
	            }
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "El producto no existe o esta Inactivo",
	            icono: "error"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      txtId.current.value = "";
	      txtId.current.focus();
	    });
	  };
	
	  var seleccionarEditarProducto = function seleccionarEditarProducto(index, idubi, idprod) {
	
	    var endpoint = op.conexion + "/api/pedido/seleccionarproductoinv?idproducto=" + idprod.toUpperCase() + "&idalmacen=" + idubi;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var data = [].concat(_toConsumableArray(records));
	
	        if (response.data !== "") {
	          if (response.data.servicio) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "El producto no existe o esta Inactivo",
	              icono: "error"
	            });
	            txtCantidad.current[records.length - 1].value = "1,00";
	          } else {
	            for (var i = 0; i < records.length; i++) {
	              if (records[i].idproducto === response.data.idproducto) {
	                setActivate(false);
	                setMensaje({
	                  mostrar: true,
	                  titulo: "Notificacion",
	                  texto: "El PRODUCTO YA EXISTE",
	                  icono: "error"
	                });
	                return;
	              }
	            }
	
	            var uni = [];
	
	            if (parseInt(response.data.idunidadalterna) === 0) {
	              uni = [{
	                idunidad: response.data.idunidadmedida,
	                descripcion: response.data.descripcionuni,
	                tipo: "medida"
	              }];
	            } else {
	              uni = [{
	                idunidad: response.data.idunidadmedida,
	                descripcion: response.data.descripcionuni,
	                tipo: "medida"
	              }, {
	                idunidad: response.data.idunidadalterna,
	                descripcion: response.data.descripcionunialt,
	                tipo: "alterna"
	              }];
	            }
	
	            var precio = response.data.costoproveedor;
	
	            precio = precio * response.data.valormoneda;
	            precio = precio / moneda.valormoneda;
	
	            var montoiva = precio * response.data.ivaventa / 100;
	
	            data[index] = {
	              idproducto: response.data.idproducto,
	              codigo: response.data.codigo,
	              cantidad: 1.0,
	              cantidadE: response.data.cantidad,
	              nombrecorto: response.data.nombrecorto,
	              precio: precio,
	              iva: response.data.ivaventa,
	              motoiva: montoiva,
	              descuento: "",
	              total: precio + montoiva,
	              totald: precio,
	              unidad: uni,
	              idunidadmedida: response.data.idunidadmedida,
	              idunidadalterna: response.data.idunidadalterna,
	              idmoneda: response.data.idmoneda,
	              valormoneda: response.data.valormoneda,
	              valorfactor: response.data.valorfactor,
	              costoproveedor: response.data.costoproveedor,
	              tipofactor: response.data.tipofactor
	            };
	            setIndice(null);
	            setRecords(data);
	            if (operacion === 1) {
	              calcularTotales(data);
	              setDatosfact([]);
	              txtTotalRetencion.current.value = "";
	            } else {
	              setTipou(1);
	              var subtot = 0.0,
	                  totr = 0.0,
	                  totalm = 0.0,
	                  toivss = 0.0,
	                  totalexento = 0.0;
	
	              for (var _i2 = 0; _i2 < data.length; _i2++) {
	                toivss = parseFloat(toivss) + data[_i2].motoiva;
	                subtot = parseFloat(subtot) + data[_i2].totald;
	                if (parseInt(data[_i2].iva) === 0) {
	                  totalexento = parseFloat(totalexento) + parseFloat(data[_i2].totald);
	                }
	              }
	
	              totalm = subtot + toivss;
	              txtSubTotal.current.value = (0, _varios.formatMoneda)(subtot.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	              txtExento.current.value = (0, _varios.formatMoneda)(totalexento.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	              txtTotalIva.current.value = (0, _varios.formatMoneda)(toivss.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	              txtTotalconIva.current.value = (0, _varios.formatMoneda)(totalm.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	              txtTotal.current.value = (0, _varios.formatMoneda)(totalm.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	              var ret = [].concat(_toConsumableArray(datosret));
	              var info = [];
	              info.push({
	                base: txtSubTotal.current.value.replace(/\./g, "").replace(",", "."),
	                iva: response.data.ivaventa,
	                montoiva: txtTotalIva.current.value.replace(/\./g, "").replace(",", "."),
	                totalc: txtTotal.current.value.replace(/\./g, "").replace(",", "."),
	                id: ret.length > 0 ? ret[0].codigo : ""
	              });
	              setDatosfact(info);
	            }
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "El producto no existe o esta Inactivo",
	            icono: "error"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      txtId.current.value = "";
	      txtId.current.focus();
	    });
	  };
	
	  var seleccionarDetalleOrdenCompra = function seleccionarDetalleOrdenCompra(id) {
	    var endpoint = op.conexion + "/api/ordencompra/seleccionarordencompra?idordendecompra=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	
	          var prod = [];
	
	          var uni = [];
	          var precio = 0.0;
	
	          for (var i = 0; i < response.data.length; i++) {
	            if (parseInt(response.data[i].idunidadalterna) === 0) {
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	            } else {
	              if (response.data[i].tipounidad === 0) {
	                uni = [{
	                  idunidad: response.data[i].idunidadmedida,
	                  descripcion: response.data[i].descripcionuni,
	                  tipo: "medida"
	                }, {
	                  idunidad: response.data[i].idunidadalterna,
	                  descripcion: response.data[i].descripcionunialt,
	                  tipo: "alterna"
	                }];
	              } else {
	                uni = [{
	                  idunidad: response.data[i].idunidadalterna,
	                  descripcion: response.data[i].descripcionunialt,
	                  tipo: "alterna"
	                }, {
	                  idunidad: response.data[i].idunidadmedida,
	                  descripcion: response.data[i].descripcionuni,
	                  tipo: "medida"
	                }];
	              }
	            }
	
	            var tasa = 0.0;
	
	            if (statusordencompra === 1) {
	              tasa = tasaor;
	            } else {
	              tasa = response.data[i].valormoneda;
	            }
	
	            var mont = (0, _varios.round)(response.data[i].punitario * response.data[i].ivaventa / 100, 2);
	
	            precio = response.data[i].punitario;
	
	            var montoiva = mont;
	            montoiva = montoiva * response.data[i].cantidad;
	
	            prod.push({
	              idproducto: response.data[i].idproducto,
	              codigo: response.data[i].codigo,
	              cantidad: response.data[i].cantidad,
	              nombrecorto: response.data[i].nombrecorto,
	              precio: precio,
	              iva: response.data[i].iva,
	              ivaventa: response.data[i].ivaventa,
	              motoiva: montoiva,
	              descuento: response.data[i].descuento,
	              total: (0, _varios.round)(precio * response.data[i].cantidad, 2) + montoiva,
	              totald: response.data[i].cantidad * precio,
	              unidad: uni,
	              idunidadmedida: response.data[i].idunidadmedida,
	              idunidadalterna: response.data[i].idunidadalterna,
	              costocalculado: response.data[i].costocalculado,
	              costocalculadoalter: response.data[i].costocalculadoalter,
	              utipreciomaxi: response.data[i].utipreciomaxi,
	              utipreciomaxialter: response.data[i].utipreciomaxialter,
	              tipounidad: response.data[i].tipounidad,
	              valormoneda: response.data[i].valormoneda,
	              idmoneda: response.data[i].idmoneda,
	              costoproveedor: response.data[i].punitario,
	              tasa: tasa,
	              valorfactor: response.data[i].valorfactor,
	              tipofactor: response.data[i].tipofactor
	            });
	          }
	          setRecords(prod);
	          calcularTotales(prod);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarDetalleFactura = function seleccionarDetalleFactura(id, data, tasav, idope) {
	    var endpoint = op.conexion + "/api/retenciones/consultarcompra?idfacturacompra=" + id + "&idope=" + idope;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        if (response.data.length > 0 && data.length > 0) {
	          var prod = [];
	          var ret = [].concat(_toConsumableArray(data));
	          var rets = [];
	          var uni = [];
	          var precio = 0.0;
	
	          for (var c = 0; c < ret.length; c++) {
	            rets.push({ total: ret[c].total });
	          }
	
	          for (var i = 0; i < response.data.length; i++) {
	            if (parseInt(response.data[i].idunidadalterna) === 0) {
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	            } else {
	              if (response.data[i].tipounidad === 0) {
	                uni = [{
	                  idunidad: response.data[i].idunidadmedida,
	                  descripcion: response.data[i].descripcionuni,
	                  tipo: "medida"
	                }, {
	                  idunidad: response.data[i].idunidadalterna,
	                  descripcion: response.data[i].descripcionunialt,
	                  tipo: "alterna"
	                }];
	              } else {
	                uni = [{
	                  idunidad: response.data[i].idunidadalterna,
	                  descripcion: response.data[i].descripcionunialt,
	                  tipo: "alterna"
	                }, {
	                  idunidad: response.data[i].idunidadmedida,
	                  descripcion: response.data[i].descripcionuni,
	                  tipo: "medida"
	                }];
	              }
	            }
	
	            var tasa = 0.0;
	
	            if (operacion !== 1) {
	              tasa = tasav;
	            } else {
	              tasa = response.data[i].valormoneda;
	            }
	
	            var mont = (0, _varios.round)(response.data[i].punitario * response.data[i].ivaventa / 100, 2);
	
	            precio = response.data[i].punitario;
	
	            var montoiva = mont;
	            montoiva = montoiva * response.data[i].cantidad;
	
	            prod.push({
	              idproducto: response.data[i].idproducto,
	              codigo: response.data[i].codigo,
	              cantidad: response.data[i].cantidad,
	              nombrecorto: response.data[i].nombrecorto,
	              precio: precio,
	              iva: response.data[i].iva,
	              ivaventa: response.data[i].ivaventa,
	              motoiva: montoiva,
	              descuento: response.data[i].descuento,
	              total: (0, _varios.round)(precio * response.data[i].cantidad, 2) + montoiva,
	              totald: response.data[i].cantidad * precio,
	              unidad: uni,
	              idunidadmedida: response.data[i].idunidadmedida,
	              idunidadalterna: response.data[i].idunidadalterna,
	              costocalculado: response.data[i].costocalculado,
	              costocalculadoalter: response.data[i].costocalculadoalter,
	              utipreciomaxi: response.data[i].utipreciomaxi,
	              utipreciomaxialter: response.data[i].utipreciomaxialter,
	              tipounidad: response.data[i].tipounidad,
	              valormoneda: response.data[i].valormoneda,
	              idmoneda: response.data[i].idmoneda,
	              costoproveedor: response.data[i].punitario,
	              tasa: tasa,
	              tipofactor: response.data[i].tipofactor,
	              valorfactor: response.data[i].valorfactor
	            });
	          }
	          setRecords(prod);
	          calcularTotalesReten(prod, rets);
	          seleccionarRetenciones(id);
	        } else {
	          var prod = [];
	          var _rets = [];
	          var _uni = [];
	          var _precio = 0.0;
	
	          for (var _i3 = 0; _i3 < response.data.length; _i3++) {
	
	            if (parseInt(response.data[_i3].idunidadalterna) === 0) {
	              _uni = [{
	                idunidad: response.data[_i3].idunidadmedida,
	                descripcion: response.data[_i3].descripcionuni,
	                tipo: "medida"
	              }];
	            } else {
	              if (response.data[_i3].tipounidad === 0) {
	                _uni = [{
	                  idunidad: response.data[_i3].idunidadmedida,
	                  descripcion: response.data[_i3].descripcionuni,
	                  tipo: "medida"
	                }, {
	                  idunidad: response.data[_i3].idunidadalterna,
	                  descripcion: response.data[_i3].descripcionunialt,
	                  tipo: "alterna"
	                }];
	              } else {
	                _uni = [{
	                  idunidad: response.data[_i3].idunidadalterna,
	                  descripcion: response.data[_i3].descripcionunialt,
	                  tipo: "alterna"
	                }, {
	                  idunidad: response.data[_i3].idunidadmedida,
	                  descripcion: response.data[_i3].descripcionuni,
	                  tipo: "medida"
	                }];
	              }
	            }
	
	            var _tasa = 0.0;
	
	            if (operacion !== 1) {
	              _tasa = tasav;
	            } else {
	              _tasa = response.data[_i3].valormoneda;
	            }
	
	            var _mont = (0, _varios.round)(response.data[_i3].punitario * response.data[_i3].ivaventa / 100, 2);
	
	            _precio = response.data[_i3].punitario;
	
	            var _montoiva = _mont;
	            _montoiva = _montoiva * response.data[_i3].cantidad;
	
	            prod.push({
	              idproducto: response.data[_i3].idproducto,
	              codigo: response.data[_i3].codigo,
	              cantidad: response.data[_i3].cantidad,
	              nombrecorto: response.data[_i3].nombrecorto,
	              precio: _precio,
	              iva: response.data[_i3].iva,
	              ivaventa: response.data[_i3].ivaventa,
	              motoiva: _montoiva,
	              descuento: response.data[_i3].descuento,
	              total: response.data[_i3].cantidad * _precio + _montoiva,
	              totald: response.data[_i3].cantidad * _precio,
	              unidad: _uni,
	              idunidadmedida: response.data[_i3].idunidadmedida,
	              idunidadalterna: response.data[_i3].idunidadalterna,
	              costocalculado: response.data[_i3].costocalculado,
	              costocalculadoalter: response.data[_i3].costocalculadoalter,
	              utipreciomaxi: response.data[_i3].utipreciomaxi,
	              utipreciomaxialter: response.data[_i3].utipreciomaxialter,
	              tipounidad: response.data[_i3].tipounidad,
	              valormoneda: response.data[_i3].valormoneda,
	              idmoneda: response.data[_i3].idmoneda,
	              costoproveedor: response.data[_i3].punitario,
	              tasa: _tasa,
	              tipofactor: response.data[_i3].tipofactor,
	              valorfactor: response.data[_i3].valorfactor
	            });
	          }
	          setRecords(prod);
	          calcularTotalesReten(prod, _rets);
	          //seleccionarRetenciones(response.data[0].idfacturacompra);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var retenciones = function retenciones(id, tasa, idope) {
	    var endpoint = op.conexion + "/api/retenciones/seleccionarretenciones?idfacturacompra=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var data = [];
	
	          for (var i = 0; i < response.data.length; i++) {
	            data.push({
	              codigo: response.data[i].codigo,
	              descripcion: response.data[i].descripcion,
	              baseimponible: response.data[i].baseimponible,
	              alicuota: response.data[i].alicuota,
	              total: response.data[i].total,
	              fecha: txtFecha.current.value,
	              iva: response.data[i].iva,
	              totalf: response.data[i].totalfactura,
	              montoiva: response.data[i].totaliva,
	              idtiporetencion: response.data[i].idtiporetencion,
	              deducible: response.data[i].deducible,
	              unidad: response.data.unidad
	            });
	          }
	          seleccionarDetalleFactura(response.data[0].idfacturacompra, data, tasa, idope);
	        } else {
	          seleccionarDetalleFactura(id, [''], tasa, idope);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarRetenciones = function seleccionarRetenciones(id) {
	    var endpoint = op.conexion + "/api/retenciones/seleccionarretenciones?idfacturacompra=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var data = [];
	
	          for (var i = 0; i < response.data.length; i++) {
	            data.push({
	              codigo: response.data[i].codigo,
	              descripcion: response.data[i].descripcion,
	              baseimponible: response.data[i].baseimponible,
	              alicuota: response.data[i].alicuota,
	              total: response.data[i].total,
	              fecha: txtFecha.current.value,
	              iva: response.data[i].iva,
	              totalf: response.data[i].totalfactura,
	              montoiva: response.data[i].totaliva,
	              idtiporetencion: response.data[i].idtiporetencion,
	              deducible: response.data[i].deducible,
	              unidad: response.data[i].unidad
	            });
	          }
	          setDatosret(data);
	          setDatareten(data);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setTituloHeader("Gestionar Facturas de Compra.");
	    setIdorden(0);
	    setTipou(0);
	    setRif(null);
	    setTasaor(0);
	    setIdmoney(0);
	    setConsulp(true);
	    setIndice(null);
	    setDatosret([]);
	    setDatareten([]);
	    setDatosfact([]);
	    setItems([]);
	    setBody(null);
	    setStatusordencompra(0);
	    setIdCliente("");
	    setIdAlmacen(0);
	    setIdOpeInve("");
	    setValalmacen(0);
	    setValparametro("");
	    setDesde(0);
	    cmbRif.current.value = "";
	    txtIdfactura.current.value = "";
	    txtNombreCliente.current.value = "";
	    txtCedRif.current.value = "";
	    txtDirClient.current.value = "";
	    txtTotal.current.value = "";
	    txtTotalconIva.current.value = "";
	    txtTotalIva.current.value = "";
	    txtSubTotal.current.value = "";
	    txtExento.current.value = "";
	    txtCodigo.current.value = "";
	    txtFecha.current.value = (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD");
	    txtAfectaInventario.current.checked = false;
	    txtTotalRetencion.current.value = "";
	    txtNumControl.current.value = "";
	    txtOrdenCompra.current.value = "";
	    txtAlmacen.current.value = "";
	    // Campo de captura de producto de la tabla: es un input no controlado,
	    // por lo que se limpia explicitamente para no conservar el codigo anterior.
	    if (txtCodigoProducto.current) txtCodigoProducto.current.value = "";
	    // Los refs de las filas son arreglos: se vacian para no conservar
	    // referencias a los inputs de la factura anterior.
	    txtId.current = [];
	    txtCantidad.current = [];
	    txtPrecio.current = [];
	    setActivate(false);
	    setRecords([]);
	    setAcpt(false);
	    setComboMoneda([]);
	    setHabilitarCat(true);
	    setNumNota(null);
	    setVisibleBtn("visible");
	    setCastabla(true);
	    setOperacion(0);
	    setHabilitado(true);
	    setHabilitadoNU(false);
	    setMostrar(false);
	    setCatalogoPresu(false);
	    setCatalogoFactura(false);
	    setCatalogoalmacen(false);
	    setCatalogoCliente(false);
	    setCatalogoMoneda(false);
	    setCatregistrarcliente(false);
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: false,
	      cancelar: false,
	      catalogo: true,
	      catalogoper: true
	    });
	    setMoneda({
	      idmoneda: "4",
	      descripcion: "DOLARES",
	      simbolo: "$",
	      predeterminada: false,
	      valormoneda: 1.0
	    });
	    setMonedaSub({
	      idmoneda: "2",
	      descripcion: "DOLARES",
	      simbolo: "$",
	      predeterminada: false,
	      subpredeterminada: true,
	      valormoneda: 0.0
	    });
	  };
	
	  var onCatalogoCliente = function onCatalogoCliente(values) {
	    setCatalogoCliente(false);
	
	    if (valparametro === "proveedor") {
	      txtNombreCliente.current.value = values.nombre;
	      txtDirClient.current.value = values.direccion;
	      cmbRif.current.value = values.rif.substring(0, 1);
	      setRif(values.rif.substring(0, 1));
	      txtCedRif.current.value = values.rif.substring(1, 10);
	      setIdCliente(values.idagente);
	    }
	  };
	
	  var onCatalogo = function onCatalogo(val) {
	    if (val === 1) {
	      setValparametro("proveedor");
	      setCatalogoCliente(true);
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	
	    if (txtCedRif.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "Seleccione el Proveedor",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtCedRif.current.focus();
	    } else if (txtCodigo.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "Debe Introducir el Número de Factura",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtCodigo.current.focus();
	    } else if (txtNumControl.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "Introduzca el Número de Control",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtNumControl.current.focus();
	    } else if (txtAlmacen.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "Introduzca el Código de Almacen",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtAlmacen.current.focus();
	    } else if (txtFecha.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtFecha.current.focus();
	    } else if (records.length === 0) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "No hay Producto agregados",
	        icono: "informacion"
	      });
	      sigue = false;
	      btnCancela.current.focus();
	    }
	
	    if (sigue) {
	      var factucompra = [];
	      var factucompradeta = [];
	      var factuxfactucompra = [];
	      var opeinv = [];
	      var opeinvdet = [];
	      var tasa = 0.0;
	
	      tasa = monedaSub.valormoneda;
	
	      factucompra.push({
	        idfacturacompra: operacion === 1 && txtIdfactura.current.value !== null ? 0 : operacion === 2 ? txtIdfactura.current.value : txtIdfactura.current.value,
	        numfactura: txtCodigo.current.value,
	        numcontrol: txtNumControl.current.value.trim(),
	        cedularif: rif + txtCedRif.current.value,
	        subtotal: parseFloat(txtSubTotal.current.value.replace(/\./g, "").replace(",", ".")),
	        totaliva: parseFloat(txtTotalIva.current.value.replace(/\./g, "").replace(",", ".")),
	        montoretenido: parseFloat(txtTotalRetencion.current.value) > 0 ? parseFloat(txtTotalRetencion.current.value.replace(/\./g, "").replace(",", ".")) : 0.00,
	        montototal: txtTotalRetencion.current.value !== '' ? (0, _varios.round)(parseFloat(txtSubTotal.current.value.replace(/\./g, "").replace(",", ".")) + parseFloat(txtTotalIva.current.value.replace(/\./g, "").replace(",", ".")) - parseFloat(txtTotalRetencion.current.value.replace(/\./g, "").replace(",", ".")), 2) : (0, _varios.round)(parseFloat(txtSubTotal.current.value.replace(/\./g, "").replace(",", ".")) + parseFloat(txtTotalIva.current.value.replace(/\./g, "").replace(",", ".")), 2),
	        idproveedor: idCliente,
	        fechafactura: txtFecha.current.value,
	        idmoneda: idmoney,
	        tasa: tasa,
	        idordencompra: idorden !== null ? parseInt(idorden) : 0,
	        status: 0,
	        descripcion: 'REGISTRO DE LA FACTURA N° - ' + txtCodigo.current.value + ' - DEL PROVEEDOR - ' + txtNombreCliente.current.value,
	        idalmacen: idalmacen,
	        idusuario: idusuario,
	        usuario: usuario
	      });
	
	      opeinv.push({
	        idoperacioninventario: idOpeInve === null || idOpeInve === "" ? "0" : idOpeInve,
	        tipooperacion: "INGRESO",
	        idalmacenorigen: idalmacen,
	        idalmacendestino: "",
	        fecha: txtFecha.current.value,
	        idmoneda: moneda.idmoneda,
	        observacion: "COMPRA"
	      });
	
	      for (var i = 0; i < records.length; i++) {
	
	        if (records[i].tipounidad === null || records[i].tipounidad === undefined) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe seleccionar la unidad de medida del producto " + records[i].nombrecorto,
	            icono: "informacion"
	          });
	          return;
	        }
	
	        factucompradeta.push({
	          idproducto: records[i].idproducto,
	          cantidad: records[i].cantidad,
	          punitario: records[i].precio,
	          iva: records[i].iva,
	          tipounidad: records[i].tipounidad,
	          idunidadmedida: records[i].idunidadmedida,
	          idunidadalterna: records[i].idunidadalterna
	        });
	
	        opeinvdet.push({
	          idproducto: records[i].idproducto,
	          nombre: records[i].nombre,
	          cantidad: records[i].cantidad,
	          precio: (0, _varios.round)(parseFloat(records[i].precio), 2),
	          fechavencimiento: "",
	          tipomovimiento: "COMPRA",
	          fechatipomovimiento: txtFecha.current.value,
	          numfactura: txtCodigo.current.value,
	          idalmacen: idalmacen,
	          tipounidad: records[i].tipounidad,
	          idunidadmedida: records[i].idunidadmedida,
	          idunidadalterna: records[i].idunidadalterna,
	          tipofactor: records[i].tipofactor,
	          valorfactor: records[i].valorfactor
	        });
	      }
	
	      for (var _i4 = 0; _i4 < datosret.length; _i4++) {
	        factuxfactucompra.push({
	          codigo: datosret[_i4].codigo,
	          baseimponible: datosret[_i4].baseimponible,
	          alicuota: datosret[_i4].alicuota,
	          total: datosret[_i4].total,
	          codigofact: txtCodigo.current.value,
	          totalfactura: datosret[_i4].totalf,
	          iva: datosret[_i4].iva,
	          totaliva: datosret[_i4].montoiva,
	          unidad: datosret[_i4].unidad
	        });
	      }
	
	      setBody({
	        factucompra: factucompra,
	        factucompradeta: factucompradeta,
	        factuxfactucompra: factuxfactucompra,
	        idtipopeinv: "1",
	        opeinv: opeinv,
	        opeinvdet: opeinvdet,
	        afinventario: txtAfectaInventario.current.checked
	      });
	
	      setDesde(2);
	      var msg = "";
	      if (operacion === 1) {
	        msg = "¿Esta Seguro de Registrar estos Datos?.";
	      } else if (operacion === 2) {
	        msg = "¿Esta Seguro de Modificar estos Datos?.";
	      } else if (operacion === 3) {
	        msg = "¿Esta Seguro de Eliminar estos Datos?.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/retenciones/actualizarretenciones/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "¡Registro " + response.data.idpe + " Creado Correctamente!",
	            icono: "exito"
	          });
	          imprimirOrdendeCompra(response.data.idpe);
	        } else if (operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "¡Registro " + response.data.idpe + " Modificado Correctamente!",
	            icono: "exito"
	          });
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "¡Registro " + response.data.idpe + " Eliminado Correctamente!",
	            icono: "exito"
	          });
	        }
	
	        blanquear();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = "";
	      if (error.response === undefined) {
	        mensaje = "Error de Conexion";
	      } else {
	        mensaje = error.response.data.message;
	      }
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    if (desde === 1) {
	      var prod = records;
	      setDesde(0);
	      setRecords(prod);
	    } else if (desde === 2) {
	      setDesde(0);
	      procesarRegistro();
	    }
	  };
	
	  var onCambioMoneda = function onCambioMoneda(values) {
	    var tasa = 0.0;
	    var data = [].concat(_toConsumableArray(records));
	    var ret = [].concat(_toConsumableArray(datosret));
	    var precio = 0.0;
	    var montoiva = 0.0;
	    var precib = 0.0;
	    var base = 0.0;
	    var totalr = 0.0;
	
	    if (operacion !== 4) {
	      if (values.simbolo === "$") {
	        setAcpt(false);
	        setIdmoney(values.idmoneda);
	      } else {
	        setAcpt(true);
	      }
	    }
	
	    for (var i = 0; i < data.length; i++) {
	
	      if (data[i].idmoneda === values.idmoneda) {
	        tasa = data[i].valormoneda;
	      } else {
	        tasa = values.valormoneda;
	      }
	
	      var montoiv = (0, _varios.round)(data[i].costoproveedor * data[i].iva / 100, 2);
	
	      precio = data[i].costoproveedor;
	      precib = precio * data[i].valormoneda;
	      precib = (0, _varios.round)(precib / tasa, 2);
	
	      if (values.subpredeterminada === true) {
	        montoiva = montoiv;
	      } else {
	        (0, _varios.round)(montoiva = montoiv * data[i].valormoneda, 2);
	      }
	
	      var totalivas = (0, _varios.round)(montoiva * data[i].cantidad, 2);
	
	      data[i].precio = precib;
	      data[i].total = (0, _varios.round)(precib * data[i].cantidad, 2) + totalivas;
	      data[i].motoiva = montoiva * data[i].cantidad;
	      data[i].totald = precib * data[i].cantidad;
	    }
	
	    for (var c = 0; c < ret.length; c++) {
	
	      if (data[0].idmoneda === values.idmoneda) {
	        base = (0, _varios.round)(ret[c].baseimponible, 2);
	        base = base / values.valormoneda;
	
	        totalr = (0, _varios.round)(ret[c].total, 2);
	        totalr = totalr / values.valormoneda;
	      } else {
	        base = (0, _varios.round)(ret[c].baseimponible, 2);
	        base = base / values.valormoneda;
	        base = base * data[0].valormoneda;
	
	        totalr = (0, _varios.round)(ret[c].total, 2);
	        totalr = totalr / values.valormoneda;
	        totalr = totalr * data[0].valormoneda;
	      }
	
	      ret[c].baseimponible = base;
	      ret[c].total = totalr;
	    }
	
	    setRecords(data);
	    calcularTotalesReten(data, ret);
	  };
	
	  var onCambioMonedados = function onCambioMonedados(values) {
	    var tasa = 0.0;
	    var data = [].concat(_toConsumableArray(records));
	    var ret = [].concat(_toConsumableArray(datosret));
	    var precio = 0.0;
	    var montoiva = 0.0;
	    var precib = 0.0;
	    var base = 0.0;
	    var totalr = 0.0;
	
	    if (operacion !== 4) {
	      if (values === "1") {
	        setAcpt(false);
	      } else {
	        setAcpt(true);
	      }
	    }
	
	    if (values === "1") {
	      tasa = 1.0;
	    } else {
	      tasa = tasaor;
	    }
	
	    for (var i = 0; i < data.length; i++) {
	
	      var montoiv = (0, _varios.round)(data[i].costoproveedor * data[i].iva / 100, 2);
	
	      precio = data[i].costoproveedor;
	      precib = precio * tasaor;
	      precib = (0, _varios.round)(precib / tasa, 2);
	
	      if (values === '1') {
	        montoiva = (0, _varios.round)(montoiv * tasaor, 2);
	      } else {
	        montoiva = montoiv;
	      }
	
	      var totalivas = (0, _varios.round)(montoiva * data[i].cantidad, 2);
	
	      data[i].precio = precib;
	      data[i].total = (0, _varios.round)(precib * data[i].cantidad, 2) + totalivas;
	      data[i].motoiva = montoiva * data[i].cantidad;
	      data[i].totald = precib * data[i].cantidad;
	    }
	
	    for (var c = 0; c < ret.length; c++) {
	      if (values !== "1") {
	        base = ret[c].baseimponible;
	        base = base;
	
	        totalr = ret[c].total;
	        totalr = totalr;
	      } else {
	        base = ret[c].baseimponible;
	        base = base * tasaor;
	
	        totalr = ret[c].total;
	        totalr = totalr * tasaor;
	      }
	
	      ret[c].baseimponible = base;
	      ret[c].total = totalr;
	    }
	    setRecords(data);
	    calcularTotalesReten(data, ret);
	  };
	
	  var validarCantidad = function validarCantidad(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	          event.target.value = "1,00";
	        }
	        event.target.value = (0, _varios.formatoMonto)(event.target.value);
	        var char1 = event.target.value.substring(0, 1);
	        var char2 = event.target.value.substring(1, 2);
	        if (char1 === "0" && char2 !== ",") {
	          event.target.value = event.target.value.substring(1, event.target.value.length);
	        }
	        if (event.target.id === "cantidad") {
	          var canti = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	          var data = [].concat(_toConsumableArray(records));
	          var info = [];
	
	          var montoiv = data[index].precio * data[index].iva / 100;
	
	          var ivss = (0, _varios.round)(montoiv * canti, 2);
	
	          data[index].cantidad = canti;
	          data[index].motoiva = ivss;
	          data[index].total = data[index].precio * canti + ivss;
	          data[index].totald = data[index].precio * canti;
	
	          var subtot = 0.0,
	              totalm = 0.0,
	              toivss = 0.0;
	          var totalexento = 0.00;
	
	          for (var i = 0; i < data.length; i++) {
	            toivss = parseFloat(toivss) + data[i].motoiva;
	            subtot = parseFloat(subtot) + data[i].totald;
	            if (parseInt(data[i].iva) === 0) {
	              totalexento = parseFloat(totalexento) + parseFloat(data[i].totald);
	            }
	          }
	
	          totalm = subtot + toivss;
	
	          if (totalm > 0) {
	            txtSubTotal.current.value = (0, _varios.formatMoneda)(subtot.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtExento.current.value = (0, _varios.formatMoneda)(totalexento.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtTotalIva.current.value = (0, _varios.formatMoneda)(toivss.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtTotalconIva.current.value = (0, _varios.formatMoneda)(totalm.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	            txtTotal.current.value = (0, _varios.formatMoneda)(totalm.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          }
	
	          setRecords(data);
	
	          if (operacion === 2 && parseFloat(txtTotalRetencion.current.value) > 0.00) {
	            info.push({
	              base: txtSubTotal.current.value.replace(/\./g, "").replace(",", "."),
	              iva: data[index].iva,
	              montoiva: txtTotalIva.current.value.replace(/\./g, "").replace(",", "."),
	              totalc: txtTotal.current.value.replace(/\./g, "").replace(",", ".")
	            });
	            setDatosfact(info);
	          } else if (operacion === 1 && datosret.length > 0) {
	            var ret = [].concat(_toConsumableArray(datosret));
	
	            info.push({
	              base: txtSubTotal.current.value.replace(/\./g, "").replace(",", "."),
	              iva: data[index].iva,
	              montoiva: txtTotalIva.current.value.replace(/\./g, "").replace(",", "."),
	              totalc: txtTotal.current.value.replace(/\./g, "").replace(",", "."),
	              id: ret.length > 0 ? ret[0].codigo : "",
	              unidad: ret[0].unidad
	            });
	            setDatosfact(info);
	          } else {
	            var ddt = [];
	            ddt.push({
	              base: subtot,
	              iva: data[index].iva,
	              montoiva: toivss,
	              totalc: totalm
	            });
	            setItems(ddt);
	          }
	
	          if (event.which === 13) {
	            if (index < data.length - 1) {
	              setTimeout(function () {
	                return txtCantidad.current[index + 1].focus();
	              }, 300);
	            }
	          }
	        }
	      } else if (event.which === 46) {
	        return false;
	      } else if (event.which >= 48 && event.which <= 57) {
	        return true;
	      } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	        return true;
	      } else return false;
	    };
	  };
	
	  var validarPrecio = function validarPrecio(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	          event.target.value = "1,00";
	        }
	        event.target.value = (0, _varios.formatoMonto)(event.target.value);
	        var char1 = event.target.value.substring(0, 1);
	        var char2 = event.target.value.substring(1, 2);
	        if (char1 === "0" && char2 !== ",") {
	          event.target.value = event.target.value.substring(1, event.target.value.length);
	        }
	        if (event.target.id === "precio") {
	          var data = [].concat(_toConsumableArray(records));
	          var info = [];
	
	          var preci = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	          var montoiv = (0, _varios.round)(preci * data[index].iva / 100, 2);
	          var ivss = montoiv * data[index].cantidad;
	
	          data[index].precio = preci;
	          data[index].motoiva = ivss;
	          data[index].total = preci * data[index].cantidad + ivss;
	          data[index].totald = preci * data[index].cantidad;
	
	          var subtot = 0.0,
	              totalm = 0.0,
	              toivss = 0.0;
	          var totalexento = 0.00;
	
	          for (var i = 0; i < data.length; i++) {
	            toivss = parseFloat(toivss) + data[i].motoiva;
	            subtot = parseFloat(subtot) + data[i].totald;
	
	            if (parseInt(data[i].iva) === 0) {
	              totalexento = parseFloat(totalexento) + parseFloat(data[i].totald);
	            }
	          }
	
	          totalm = subtot + toivss;
	          txtSubTotal.current.value = (0, _varios.formatMoneda)(subtot.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtExento.current.value = (0, _varios.formatMoneda)(totalexento.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtTotalIva.current.value = (0, _varios.formatMoneda)(toivss.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtTotalconIva.current.value = (0, _varios.formatMoneda)(totalm.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtTotal.current.value = (0, _varios.formatMoneda)(totalm.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	          setRecords(data);
	          if (operacion === 2 && txtTotalRetencion.current.value > 0.00) {
	            info.push({
	              base: txtSubTotal.current.value.replace(/\./g, "").replace(",", "."),
	              iva: data[index].iva,
	              montoiva: txtTotalIva.current.value.replace(/\./g, "").replace(",", "."),
	              totalc: txtTotal.current.value.replace(/\./g, "").replace(",", ".")
	            });
	            setDatosfact(info);
	          } else if (operacion === 1 && datosret.length > 0) {
	            var ret = [].concat(_toConsumableArray(datosret));
	            info.push({
	              base: txtSubTotal.current.value.replace(/\./g, "").replace(",", "."),
	              iva: data[index].iva,
	              montoiva: txtTotalIva.current.value.replace(/\./g, "").replace(",", "."),
	              totalc: txtTotal.current.value.replace(/\./g, "").replace(",", "."),
	              id: ret.length > 0 ? ret[0].codigo : ""
	            });
	            setDatosfact(info);
	          } else {
	            var ddt = [];
	            ddt.push({
	              base: subtot,
	              iva: data[index].iva,
	              montoiva: toivss,
	              totalc: totalm
	            });
	            setItems(ddt);
	          }
	        }
	      } else if (event.which === 46) {
	        return false;
	      } else if (event.which >= 48 && event.which <= 57) {
	        return true;
	      } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	        return true;
	      } else return false;
	    };
	  };
	
	  var BaseRetencion = function BaseRetencion(retencion, n, p) {
	    /**
	     * Cuando no hay retenciones que aplicar (factura sin retenciones, o
	     * ninguna retencion coincide con los codigos/unidades que calcula la
	     * tabla de retenciones) no existe monto que descontar: el total debe
	     * quedar en su valor bruto (subtotal + iva) y el monto retenido en
	     * cero. Antes se sobreescribian ambos montos con 0,00.
	     */
	    if (Array.isArray(retencion) && retencion.length === 0) {
	      setDatosret(retencion);
	      txtTotalRetencion.current.value = "";
	
	      var subtot = parseFloat(txtSubTotal.current.value.replace(/\./g, "").replace(",", "."));
	      var toivss = parseFloat(txtTotalIva.current.value.replace(/\./g, "").replace(",", "."));
	
	      if (!isNaN(subtot) && !isNaN(toivss)) {
	        var _mtotal = (0, _varios.round)(subtot + toivss, 2);
	
	        txtTotal.current.value = (0, _varios.formatMoneda)(_mtotal.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	      }
	
	      return;
	    }
	
	    var total = 0.0;
	    var mtotal = 0.0;
	    var resta = 0.0;
	    var montr = txtTotalRetencion.current.value.trim().replace(/\./g, "").replace(",", ".");
	    var val = p === undefined ? 0 : p;
	    var dats = n === undefined ? [] : n;
	    var mt = 0.0;
	
	    if (operacion === 2 && val === 7) {
	      mt = n[0].total;
	      var ret = txtTotalRetencion.current.value.trim().replace(/\./g, "").replace(",", ".");
	      var tot = txtTotal.current.value.trim().replace(/\./g, "").replace(",", ".");
	      mtotal = (0, _varios.round)(parseFloat(tot), 2) + (0, _varios.round)(parseFloat(mt), 2);
	      total = parseFloat(ret) - parseFloat(mt);
	    } else {
	      if (val !== 0) {
	        var totalm = txtTotal.current.value.trim().replace(/\./g, "").replace(",", ".");
	
	        for (var i = 0; i < dats.length; i++) {
	          resta = parseFloat(resta) + n[i].total;
	          mtotal = parseFloat(totalm) + (0, _varios.round)(parseFloat(n[i].total), 2);
	        }
	
	        total = montr - resta;
	      } else {
	        var _totalm = txtTotal.current.value.trim().replace(/\./g, "").replace(",", ".");
	
	        for (var _i5 = 0; _i5 < retencion.length; _i5++) {
	          if (operacion === 1 && n === 5) {
	            total = parseFloat(montr) + parseFloat(retencion[_i5].total);
	          } else {
	            total = parseFloat(total) + parseFloat(retencion[_i5].total);
	          }
	
	          if (n !== 4) {
	            mtotal = (0, _varios.round)(parseFloat(_totalm), 2) - (0, _varios.round)(parseFloat(retencion[_i5].total), 2);
	          } else {
	            mtotal = (0, _varios.round)(parseFloat(_totalm), 2) - (0, _varios.round)(total, 2);
	          }
	        }
	      }
	    }
	    setDatosret(retencion);
	    txtTotalRetencion.current.value = (0, _varios.formatMoneda)(total.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    txtTotal.current.value = (0, _varios.formatMoneda)(mtotal.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	  };
	
	  var calcularTotalesReten = function calcularTotalesReten(data, ret) {
	    var datos = [];
	    var subtot = 0.0,
	        totr = 0.0,
	        totalm = 0.0,
	        toivss = 0.0,
	        totalexento = 0.0;
	
	    for (var c = 0; c < ret.length; c++) {
	      totr = parseFloat(totr) + parseFloat(ret[c].total);
	    }
	
	    for (var i = 0; i < data.length; i++) {
	      toivss = parseFloat(toivss) + data[i].motoiva;
	      subtot = parseFloat(subtot) + data[i].totald;
	
	      if (parseInt(data[i].iva) === 0) {
	        totalexento = parseFloat(totalexento) + parseFloat(data[i].totald);
	      }
	    }
	
	    var totalciv = 0.0;
	
	    if (totr > 0) {
	      totalm = (0, _varios.round)(subtot, 2) + (0, _varios.round)(toivss, 2) - (0, _varios.round)(totr, 2);
	    } else {
	      totalm = subtot + toivss;
	    }
	
	    totalciv = subtot + toivss;
	
	    txtSubTotal.current.value = (0, _varios.formatMoneda)(subtot.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    txtExento.current.value = (0, _varios.formatMoneda)(totalexento.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    txtTotalIva.current.value = (0, _varios.formatMoneda)(toivss.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    txtTotalRetencion.current.value = totr > 0 ? (0, _varios.formatMoneda)(totr.toString().replace(",", "").replace(".", ","), ",", ".", 2) : '';
	    txtTotalconIva.current.value = (0, _varios.formatMoneda)(totalciv.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    txtTotal.current.value = (0, _varios.formatMoneda)(totalm.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	    datos.push({
	      base: subtot,
	      iva: data[0].iva,
	      montoiva: toivss,
	      totalc: totalm
	    });
	    setItems(datos);
	  };
	
	  var calcularTotales = function calcularTotales(data) {
	    var datos = [];
	    var subtot = 0.0,
	        totalm = 0.0,
	        toivss = 0.0;
	    var totalexento = 0.00;
	
	    for (var i = 0; i < data.length; i++) {
	      toivss = parseFloat(toivss) + data[i].motoiva;
	      subtot = parseFloat(subtot) + parseFloat(data[i].totald);
	
	      if (parseInt(data[i].iva) === 0) {
	        totalexento = parseFloat(totalexento) + parseFloat(data[i].totald);
	      }
	    }
	
	    totalm = subtot + toivss;
	    txtSubTotal.current.value = (0, _varios.formatMoneda)(subtot.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    txtExento.current.value = (0, _varios.formatMoneda)(totalexento.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    txtTotalIva.current.value = (0, _varios.formatMoneda)(toivss.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    txtTotalconIva.current.value = (0, _varios.formatMoneda)(totalm.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    txtTotal.current.value = (0, _varios.formatMoneda)(totalm.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	    datos.push({
	      base: subtot,
	      iva: data[0].iva,
	      montoiva: toivss,
	      totalc: totalm
	    });
	    setItems(datos);
	  };
	
	  var onCatalogoMoneda = function onCatalogoMoneda(values) {
	    setCatalogoMoneda(false);
	    setMoneda(values);
	    onCambioMoneda(values);
	  };
	
	  var onRegistrarClientes = function onRegistrarClientes() {
	    setCatregistrarcliente(false);
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      if (op === 1) {
	        if (accbtnfactucompra && accbtnfactucompra.toString().substring(0, 1) === "1") {
	          // Cada factura nueva debe iniciarse con el formulario totalmente
	          // limpio, sin datos de la factura registrada previamente.
	          blanquear();
	          setVisibleBtn("hidden");
	          setTituloHeader("Incluir Factura de Compra.");
	          setHabilitado(false);
	          seleccionarMonedas();
	          setCastabla(false);
	          setConsulp(false);
	          setHabilitarCat(false);
	          setOperacion(1);
	          setAcpt(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            catalogoper: false
	          });
	          txtAfectaInventario.current.checked = true;
	          setTimeout(function () {
	            return txtCodigo.current.focus();
	          }, 200);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (accbtnfactucompra && accbtnfactucompra.toString().substring(1, 2) === "1") {
	          setVisibleBtn("hidden");
	          setTituloHeader("Editar Factura de Compra.");
	          setHabilitado(false);
	          seleccionarMonedas();
	          setHabilitarCat(true);
	          setConsulp(true);
	          setCastabla(false);
	          setAcpt(false);
	          setOperacion(2);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          txtAfectaInventario.current.checked = false;
	          setTimeout(function () {
	            return txtCodigo.current.focus();
	          }, 200);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (accbtnfactucompra && accbtnfactucompra.toString().substring(3, 4) === "1") {
	          setVisibleBtn("hidden");
	          setTituloHeader("Eliminar Factura de Compra.");
	          setConsulp(true);
	          setHabilitado(false);
	          seleccionarMonedas();
	          setAcpt(false);
	          setHabilitarCat(true);
	          setCastabla(true);
	          setOperacion(3);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          txtAfectaInventario.current.checked = false;
	          setTimeout(function () {
	            return txtCodigo.current.focus();
	          }, 200);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (accbtnfactucompra && accbtnfactucompra.toString().substring(2, 3) === "1") {
	          setVisibleBtn("hidden");
	          setTituloHeader("Consultar Factura de Compra.");
	          setConsulp(true);
	          seleccionarMonedas();
	          setAcpt(true);
	          setHabilitado(false);
	          setCastabla(true);
	          setOperacion(4);
	          setHabilitarCat(true);
	          setHabilitadoNU(true);
	          setDesde(7);
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          txtAfectaInventario.current.checked = false;
	          setTimeout(function () {
	            return txtCodigo.current.focus();
	          }, 200);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 6) {
	        setVisibleBtn("visible");
	        blanquear();
	        setOperacion(0);
	      }
	    };
	  };
	
	  var seleccionarMonedas = function seleccionarMonedas() {
	    var campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	    var nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	    var orden = "m.idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setComboMoneda(response.data);
	          if (operacion === 1) {
	            txtAfectaInventario.current.checked = true;
	          }
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].subpredeterminada) {
	              setMonedaSub(response.data[i]);
	              setIdmoney(response.data[i].idmoneda);
	            }
	          }
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChangeMoneda = function onChangeMoneda(e) {
	    var i = e.target.value;
	    setMoneda(combomoneda[i]);
	    onCambioMoneda(combomoneda[i]);
	  };
	
	  var onChangeMonedaAn = function onChangeMonedaAn(e) {
	    var i = e.target.value;
	    onCambioMonedados(i);
	  };
	
	  var seleccionarOp = function seleccionarOp(numfact, idalmacen) {
	    var campos = "*";
	    var nomtab = "operacioninventariodetalle";
	    var nomid = "numfactura";
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + numfact;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          seleccionarAlmacen(response.data.idalmacen, 7);
	        } else {
	          seleccionarAlmacen(idalmacen, 7);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarMoneda = function seleccionarMoneda(id) {
	    var campos = "*";
	    var nomtab = "moneda";
	    var nomid = "idmoneda";
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setMoneda(response.data);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarProveedor = function seleccionarProveedor(rif) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "rif";
	    var nomid2 = "proveedor";
	
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + rif + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          cmbRif.current.value = response.data.rif.substring(0, 1);
	          txtCedRif.current.value = response.data.rif.substring(1, 10);
	          txtNombreCliente.current.value = response.data.nombre;
	          txtDirClient.current.value = response.data.direccion;
	          setRif(response.data.rif.substring(0, 1));
	          setIdCliente(response.data.idagente);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un cliente con este codigo",
	            icono: "informacion"
	          });
	          cmbRif.current.value = "";
	          txtCedRif.current.value = "";
	          txtNombreCliente.current.value = "";
	          txtDirClient.current.value = "";
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro(id) {
	    var campos = "*";
	    var nomtab = "ordendecompra";
	    var nomid = "codigo";
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          if (response.data.status === 0) {
	            txtFecha.current.value = (0, _moment2.default)(response.data.fecha).format("YYYY-MM-DD");
	            txtCedRif.current.value = response.data.cedularif;
	            txtOrdenCompra.current.value = response.data.codigo;
	            seleccionarProveedor(response.data.cedularif);
	            seleccionarMoneda(response.data.idmoneda);
	            setIdorden(response.data.idordendecompra);
	            seleccionarDetalleOrdenCompra(response.data.idordendecompra);
	          } else {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "Esta Orden de Compra ya fue Fácturada!.",
	              icono: "informacion"
	            });
	            txtOrdenCompra.current.value = "";
	            txtOrdenCompra.current.focus();
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No Existe Orden de Compra con este Código!.",
	            icono: "error"
	          });
	          txtOrdenCompra.current.value = "";
	          txtOrdenCompra.current.focus();
	          txtFecha.current.value = "";
	          txtCedRif.current.value = "";
	          txtNombreCliente.current.value = "";
	          txtDirClient.current.value = "";
	          txtSubTotal.current.value = "";
	          txtTotalIva.current.value = "";
	          txtTotalconIva.current.value = "";
	          txtTotalRetencion.current.value = "";
	          txtTotal.current.value = "";
	          setRecords([]);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarRegistroFactura = function seleccionarRegistroFactura(numfactura) {
	    var campos = "*";
	    var nomtab = "facturacompra";
	    var nomid = "numfactura";
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + numfactura;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          var tasa = response.data.tasa;
	          setTasaor(response.data.tasa);
	          txtFecha.current.value = (0, _moment2.default)(response.data.fechafactura).format("YYYY-MM-DD");
	          setNumNota(response.data.codigo);
	          txtCedRif.current.value = response.data.cedularif;
	          txtCodigo.current.value = response.data.numfactura;
	          txtNumControl.current.value = response.data.numcontrol;
	          txtIdfactura.current.value = response.data.idfacturacompra;
	          setIdOpeInve(response.data.idoperacioninventario);
	          seleccionarProveedor(response.data.cedularif);
	          setStatusordencompra(1);
	          setIdAlmacen(response.data.idalmacen);
	          if (operacion === 3) {
	            setIdorden(response.data.idordencompra);
	          } else {
	            setIdorden(null);
	          }
	
	          if (parseInt(response.data.idoperacioninventario) > 0) {
	            txtAfectaInventario.current.checked = true;
	          } else {
	            txtAfectaInventario.current.checked = false;
	          }
	
	          seleccionarMoneda(response.data.idmoneda);
	          retenciones(response.data.idfacturacompra, tasa, response.data.idoperacioninventario);
	          seleccionarOp(response.data.codigo, response.data.idalmacen);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No Existe una Fáctura con este Código!.",
	            icono: "informacion"
	          });
	          txtCodigo.current.value = "";
	          txtCodigo.current.focus();
	          txtNumControl.current.value = "";
	          txtAlmacen.current.value = "";
	          txtFecha.current.value = "";
	          txtCedRif.current.value = "";
	          txtNombreCliente.current.value = "";
	          txtDirClient.current.value = "";
	          txtSubTotal.current.value = "";
	          txtTotalIva.current.value = "";
	          txtTotalconIva.current.value = "";
	          txtTotalRetencion.current.value = "";
	          txtTotal.current.value = "";
	          txtExento.current.value = "";
	          txtAfectaInventario.current.checked = false;
	          setRecords([]);
	          // Al no encontrar la factura no deben quedar retenciones ni
	          // identificadores de la consulta anterior.
	          setDatosret([]);
	          setDatareten([]);
	          setDatosfact([]);
	          setItems([]);
	          setIndice(null);
	          setIdOpeInve("");
	          setIdCliente("");
	          setIdAlmacen(0);
	          setValalmacen(0);
	          setStatusordencompra(0);
	          setIdorden(null);
	          setTasaor(0);
	          txtIdfactura.current.value = "";
	          setNumNota(null);
	          cmbRif.current.value = "";
	          setRif(null);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var handleInputNumeroChange = function handleInputNumeroChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "idordendecompra") {
	          seleccionarRegistro(event.target.value);
	        }
	      }
	    }
	  };
	
	  var handleInputNumeroFactura = function handleInputNumeroFactura(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "codigo") {
	          seleccionarRegistroFactura(event.target.value);
	        }
	      }
	    }
	  };
	
	  var handleInputAlmacen = function handleInputAlmacen(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "almacen") {
	          seleccionarAlmacen(event.target.value);
	        }
	      }
	    }
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "cmbrif") {
	      setRif(e.target.value);
	    }
	  };
	
	  var handleCliente = function handleCliente(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (rif !== null) {
	          seleccionarProveedor(rif + event.target.value);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe Seleccionar el Tipo de Nacionalidad!.",
	            icono: "informacion"
	          });
	        }
	      }
	    }
	  };
	
	  var onCatalogoPresupuesto = function onCatalogoPresupuesto(values) {
	    setCatalogoPresu(false);
	    seleccionarRegistro(values.codigo);
	    setIdorden(values.idordendecompra);
	  };
	
	  var onCatalogoFacturaCompra = function onCatalogoFacturaCompra(values) {
	    setCatalogoFactura(false);
	    txtCodigo.current.value = values.numfactura;
	    seleccionarRegistroFactura(values.numfactura);
	  };
	
	  var onCatalogoAlmacen = function onCatalogoAlmacen(values) {
	    setCatalogoalmacen(false);
	    txtAlmacen.current.value = values.idalmacen;
	    setIdAlmacen(values.idalmacen);
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarMonedas();
	  }, []);
	
	  var imprimirOrdendeCompra = function imprimirOrdendeCompra(id) {
	    if (accbtnfactucompra && accbtnfactucompra.toString().substring(4, 5) === "1") {
	      if (txtCodigo.current.value !== "") {
	        var reporte = "FacturadeCompra";
	        var desdec = "'" + "'";
	        var hastac = "'" + "'";
	        var idfactu = operacion === 1 ? id : txtIdfactura.current.value;
	        var condicion = "'" + 'n.idfacturacompra = ' + "'" + '||quote_literal(' + "'" + idfactu + "'" + ')';
	        var orden = "'" + 'n.fechafactura' + "'";
	        var oper = 2;
	
	        window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&condicion=" + condicion + "&desde=" + desdec + "&hasta=" + hastac + "&ope=" + oper + "&orden=" + orden, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      }
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var onCambioUnidad = function onCambioUnidad(index) {
	    return function (event) {
	      var data = [].concat(_toConsumableArray(records));
	      var tipounidad = 0;
	
	      if (event.target.value !== "") {
	        var factor = parseFloat(data[index].valorfactor);
	        if (isNaN(factor) || factor <= 0) {
	          factor = 1.0;
	        }
	
	        // Costo del proveedor por unidad de medida (base del precio de la fila)
	        var costo = parseFloat(data[index].costoproveedor);
	        var precioactual = parseFloat(data[index].precio);
	        var tipounidadactual = parseInt(data[index].tipounidad) === 1 ? 1 : 0;
	
	        if (isNaN(costo) || costo <= 0) {
	          costo = isNaN(precioactual) ? 0.0 : precioactual;
	        }
	
	        // Factor de conversion de moneda que ya tiene aplicado el precio actual:
	        // precio = costo / (valorfactor, cuando es unidad alterna) * conversion
	        var conversion = 1.0;
	        if (costo > 0 && !isNaN(precioactual)) {
	          conversion = tipounidadactual === 1 ? precioactual * factor / costo : precioactual / costo;
	        }
	        if (isNaN(conversion) || conversion <= 0) {
	          conversion = 1.0;
	        }
	
	        var precio = 0.0;
	
	        if (parseInt(event.target.value) === parseInt(data[index].idunidadmedida)) {
	          // Unidad de medida
	          tipounidad = 0;
	          precio = costo * conversion;
	        } else {
	          // Unidad alterna
	          tipounidad = 1;
	          precio = costo / factor * conversion;
	        }
	
	        precio = (0, _varios.round)(precio, 2);
	
	        var cantidad = parseFloat(data[index].cantidad);
	        if (isNaN(cantidad)) {
	          cantidad = 0.0;
	        }
	
	        var montoiva = (0, _varios.round)(precio * data[index].iva / 100, 2);
	
	        // El arreglo de unidades no cambia: solo se marca cual esta activa
	        data[index].precio = precio;
	        data[index].tipounidad = tipounidad;
	        data[index].motoiva = (0, _varios.round)(montoiva * cantidad, 2);
	        data[index].totald = (0, _varios.round)(precio * cantidad, 2);
	        data[index].total = (0, _varios.round)(data[index].totald + data[index].motoiva, 2);
	
	        if (txtPrecio.current[index]) {
	          txtPrecio.current[index].value = (0, _varios.formatMoneda)(precio.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	      }
	
	      calcularTotales(data);
	
	      // Recalcula la base de las retenciones con los nuevos montos
	      var subtot = 0.0,
	          toivss = 0.0;
	
	      for (var i = 0; i < data.length; i++) {
	        toivss = parseFloat(toivss) + parseFloat(data[i].motoiva);
	        subtot = parseFloat(subtot) + parseFloat(data[i].totald);
	      }
	
	      var totalm = subtot + toivss;
	
	      if (operacion === 2 && parseFloat(txtTotalRetencion.current.value) > 0.0) {
	        var info = [];
	        info.push({
	          base: subtot,
	          iva: data[index].iva,
	          montoiva: toivss,
	          totalc: totalm
	        });
	        setDatosfact(info);
	      } else if (operacion === 1 && datosret.length > 0) {
	        var ret = [].concat(_toConsumableArray(datosret));
	        var _info = [];
	        _info.push({
	          base: subtot,
	          iva: data[index].iva,
	          montoiva: toivss,
	          totalc: totalm,
	          id: ret.length > 0 ? ret[0].codigo : "",
	          unidad: ret.length > 0 ? ret[0].unidad : ""
	        });
	        setDatosfact(_info);
	      }
	
	      setRecords(data);
	    };
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 ", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-1", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-11 mx-auto py-2 card shadow " },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row border-azul mx-auto justify-content-between rounded py-1" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 border-azul rounded py-1 row mx-auto mb-1 azulGradiant text-light justify-content-between" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3" },
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  tituloHeader
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 mx-auto row m-0" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "col-pd-350 py-1",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "CODIGO COMPRA:",
	                      " "
	                    ),
	                    _react2.default.createElement("input", {
	                      autoComplete: "off",
	                      type: "text",
	                      name: "idordendecompra",
	                      onKeyUp: handleInputNumeroChange,
	                      disabled: operacion !== 1 ? true : false,
	                      ref: txtOrdenCompra,
	                      className: "form-control",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    }),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        type: "button",
	                        onClick: function onClick() {
	                          return setCatalogoPresu(true);
	                        },
	                        disabled: habilitarCat,
	                        className: "btn btn-success"
	                      },
	                      _react2.default.createElement("i", { className: "fas fa-search" })
	                    )
	                  )
	                ),
	                statusordencompra === 1 ? _react2.default.createElement(
	                  "div",
	                  {
	                    className: "col-p-195 py-1 ml-auto bg-light rounded",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        className: "form-control form-control-sm form-select fw-bold",
	                        disabled: operacion === 3 || operacion === 0 ? true : false,
	                        ref: txtIdmonedados,
	                        onChange: onChangeMonedaAn
	                      },
	                      _react2.default.createElement(
	                        "option",
	                        { value: 1 },
	                        "BOLIVARES 1,00 Bs"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: 2 },
	                        "DOLAR $ = ",
	                        tasaor,
	                        " Bs"
	                      )
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  "div",
	                  {
	                    className: "col-p-195 py-1 ml-auto bg-light rounded",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        className: "form-control form-control-sm form-select fw-bold",
	                        disabled: operacion === 3 || operacion === 0 ? true : false,
	                        ref: txtIdmoneda,
	                        onChange: onChangeMoneda
	                      },
	                      combomoneda && combomoneda.map(function (item, index) {
	                        return _react2.default.createElement(
	                          "option",
	                          { key: index, value: index },
	                          " ",
	                          item.descripcion + " " + item.simbolo + " " + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          " "
	                        );
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-2 d-flex justify-content-end" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "/inicio", className: "text-light " },
	                  _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "fw-bold" },
	                    "Salir"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "fieldset",
	              { className: "row col-sm-5 mx-auto border-azul rounded mb-1" },
	              _react2.default.createElement(
	                "legend",
	                { className: "float-none m-0 w-auto fw-bold", style: { fontSize: '0.9rem' } },
	                "DATOS DE LA FACTURA:"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-12 px-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-200 px-1 ml-auto mt-5m mb-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { "class": "form-check" },
	                    _react2.default.createElement("input", { "class": "form-check-input", ref: txtAfectaInventario, onChange: onChange, disabled: operacion === 0 || operacion === 4 ? true : false, name: "afectainventario", type: "checkbox", value: "", id: "flexCheckChecked" }),
	                    _react2.default.createElement(
	                      "label",
	                      { "class": "form-check-label", "for": "flexCheckChecked" },
	                      "\xBFAFECTA INVENTARIO?"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 px-1 mb-2" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "N\xB0 FACTURA:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "hidden",
	                    ref: txtIdfactura
	                  }),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "text",
	                    name: "codigo",
	                    onKeyUp: handleInputNumeroFactura,
	                    disabled: operacion === 0 || operacion === 8 ? true : false,
	                    ref: txtCodigo,
	                    className: "form-control fs-6 bg-transparent",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      type: "button",
	                      onClick: function onClick() {
	                        return setCatalogoFactura(true);
	                      },
	                      disabled: operacion === 1 || operacion === 0 || operacion === 8 ? true : false,
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 px-1 mb-2" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "N\xB0 CONTROL:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "text",
	                    disabled: castabla,
	                    ref: txtNumControl,
	                    className: "form-control bg-transparent fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 px-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "ALMACEN:"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "text",
	                    disabled: castabla,
	                    className: "form-control fs-6 text-uppercase",
	                    ref: txtAlmacen,
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: handleInputAlmacen,
	                    name: "almacen"
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      type: "button",
	                      onClick: function onClick() {
	                        return setCatalogoalmacen(true);
	                      },
	                      disabled: castabla,
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 ml-auto px-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA FACTURA:"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "date",
	                    disabled: castabla,
	                    className: "form-control fs-6 text-uppercase",
	                    ref: txtFecha,
	                    "aria-label": "Sizing example input",
	                    defaultValue: (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD"),
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "fieldset",
	              { className: "row col-sm-7 mx-auto border-azul rounded mb-1" },
	              _react2.default.createElement(
	                "legend",
	                { className: "float-none m-0 w-auto fw-bold", style: { fontSize: '0.9rem' } },
	                "DATOS DEL PROVEEDOR:"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-12 px-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-50 ml-auto mt-11m mb-1" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      style: {
	                        pointerEvents: botones.catalogoper === true ? "none" : false,
	                        color: botones.catalogoper ? "rgb(183, 183, 183)" : "#1d0345",
	                        backgroundColor: botones.catalogoper ? "#fff" : "transparent"
	                      },
	                      type: "button",
	                      onClick: function onClick() {
	                        return setCatregistrarcliente(true);
	                      },
	                      className: "btn btn-sm text-linght rounded-circle ml-2 bg-primary",
	                      title: "Registrar Proveedor"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-plus" })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-5 mb-2 px-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      disabled: consulp,
	                      ref: cmbRif,
	                      name: "cmbrif",
	                      onChange: onChange,
	                      className: "col-sm-3 col-3 form-select form-control-sm text-center"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "-"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { key: "0", value: "V" },
	                      "V"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { key: "1", value: "J" },
	                      "J"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { key: "2", value: "G" },
	                      "G"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { key: "3", value: "P" },
	                      "P"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { key: "4", value: "E" },
	                      "E"
	                    )
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "text",
	                    disabled: consulp,
	                    maxLength: 9,
	                    ref: txtCedRif,
	                    onKeyUp: handleCliente,
	                    className: "form-control fs-6 bg-transparent",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      type: "button",
	                      onClick: function onClick() {
	                        return onCatalogo(1);
	                      },
	                      style: {
	                        pointerEvents: botones.catalogoper === true ? "none" : false
	                      },
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-7 mb-2 px-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "NOMBRE:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "text",
	                    disabled: true,
	                    ref: txtNombreCliente,
	                    className: "form-control bg-transparent text-uppercase fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-12 mx-auto px-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "DIRECCION:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "text",
	                    disabled: true,
	                    ref: txtDirClient,
	                    className: "form-control bg-transparent text-uppercase fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 border-azul px-0 rounded row m-0",
	                style: { backgroundColor: "#d5e9ff" }
	              },
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 270,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px",
	                    fontSizeAdjust: "0.6"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden table-bordered" },
	                  records && records.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      {
	                        key: index,
	                        style: { padding: "0", fontSizeAdjust: "0.6" }
	                      },
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "bg-light" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row m-0" },
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            style: {
	                              borderBottomRightRadius: 0,
	                              borderTopRightRadius: 0,
	                              maxWidth: 140
	                            },
	                            disabled: castabla,
	                            ref: function ref(el) {
	                              return txtId.current[index] = el;
	                            },
	                            className: "form-control form-control-sm bg-light fs-6 text-uppercase col-10",
	                            defaultValue: item.codigo,
	                            onChange: function onChange(e) {
	                              return e.target.value = e.target.value.toUpperCase();
	                            },
	                            onKeyUp: validarIdProductoM(index),
	                            onBlur: validarIdProductoM(index)
	                          }),
	                          (operacion === 1 || operacion === 2) && _react2.default.createElement(
	                            "button",
	                            {
	                              type: "button",
	                              style: {
	                                borderBottomLeftRadius: 0,
	                                borderTopLeftRadius: 0
	                              },
	                              disabled: castabla,
	                              onClick: editarProducto(index),
	                              className: "btn btn-sm btn-primary col-2"
	                            },
	                            _react2.default.createElement(
	                              "i",
	                              { className: "fas " },
	                              "-"
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-baseline bg-light"
	                        },
	                        item.nombrecorto
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light p-0",
	                          style: { width: "90px" }
	                        },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          disabled: castabla,
	                          className: "form-control form-control-sm bg-light text-right fs-6",
	                          id: "cantidad",
	                          defaultValue: (0, _varios.formatMoneda)(item.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtCantidad.current[index] = el;
	                          },
	                          onFocus: _varios.seleccionarCampo,
	                          onKeyUp: validarCantidad(index),
	                          onBlur: validarCantidad(index)
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-baseline bg-light p-0",
	                          style: { width: "110px" }
	                        },
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            className: "form-select form-select-sm fs-6",
	                            disabled: castabla,
	                            value: parseInt(item.tipounidad) === 1 && item.idunidadalterna ? item.idunidadalterna : item.idunidadmedida,
	                            onChange: onCambioUnidad(index),
	                            "aria-label": ".form-select-sm example"
	                          },
	                          item.unidad && item.unidad.map(function (item2, x) {
	                            return _react2.default.createElement(
	                              "option",
	                              { key: x, value: item2.idunidad },
	                              " ",
	                              item2.descripcion,
	                              " "
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-center p-0",
	                          style: { width: "120px" }
	                        },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          disabled: castabla,
	                          onKeyUp: validarPrecio(index),
	                          onBlur: validarPrecio(index),
	                          className: "form-control form-control-sm bg-light text-right fs-6",
	                          id: "precio",
	                          defaultValue: (0, _varios.formatMoneda)(item.precio.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtPrecio.current[index] = el;
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-baseline bg-light text-center",
	                          style: { width: "90px" }
	                        },
	                        (0, _varios.formatMoneda)(item.iva.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-baseline bg-light text-right",
	                          style: { width: "130px" }
	                        },
	                        (0, _varios.formatMoneda)(item.motoiva.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-baseline bg-light text-right",
	                          style: { width: "150px" }
	                        },
	                        (0, _varios.formatMoneda)(item.total.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-baseline bg-light p-0",
	                          style: { textAlign: "center", width: "50px" }
	                        },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            disabled: castabla,
	                            style: {
	                              visibility: (operacion === 4 || operacion === 3) && "collapse"
	                            },
	                            className: "btn btn-sm mx-1 btn-danger rounded-circle",
	                            onClick: eliminarProducto(item)
	                          },
	                          _react2.default.createElement("i", { className: "fa fa-trash" }),
	                          " "
	                        )
	                      )
	                    );
	                  }),
	                  _react2.default.createElement(
	                    _core.TableRow,
	                    {
	                      style: {
	                        padding: "0",
	                        visibility: (operacion === 4 || operacion === 0 || operacion === 3 || operacion === 8 || operacion === 2 && numNota === null) && "collapse"
	                      }
	                    },
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: "bg-light d-flex align-items-between px-0", style: { maxWidth: '500px' } },
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        ref: txtCodigoProducto,
	                        style: {
	                          borderBottomRightRadius: 0,
	                          borderTopRightRadius: 0
	                        },
	                        className: "form-control form-control-sm bg-light text-right fs-6 col-pd-150 text-uppercase",
	                        onKeyUp: validarIdProducto,
	                        onBlur: validarIdProducto
	                      }),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          style: {
	                            borderBottomLeftRadius: 0,
	                            borderTopLeftRadius: 0
	                          },
	                          onClick: function onClick() {
	                            return setMostrar(true);
	                          },
	                          className: "btn btn-sm btn-primary"
	                        },
	                        _react2.default.createElement(
	                          "i",
	                          { className: "fas " },
	                          "-"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-baseline bg-light"
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-baseline bg-light",
	                      style: { textAlign: "center", width: "90px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-baseline bg-light text-center",
	                      style: { width: "110px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-baseline bg-light text-center",
	                      style: { width: "120px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-baseline bg-light text-center",
	                      style: { width: "90px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-baseline bg-light text-right",
	                      style: { width: "130px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-baseline bg-light text-right",
	                      style: { width: "150px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-baseline bg-light",
	                      style: { width: "50px" }
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 py-1 border-azul rounded",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "span",
	                { className: "fw-bold" },
	                "Datos de las Retenciones"
	              ),
	              _react2.default.createElement(_tablaRetenciones2.default, {
	                datosfact: items,
	                op: opf,
	                baser: BaseRetencion,
	                renderiza: operacion,
	                render: datosfact,
	                datostabla: datareten
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row m-0 px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-full col-pd-9 mt-auto" },
	                visibleBtn === "visible" ? _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-650" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 row m-0" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: botones.incluir,
	                        onClick: onBotones(1),
	                        className: "btn btn-sm col ml-1 mb-1 btn-primary rounded-pill",
	                        title: "Incluir Almacen"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-plus" },
	                        " Incluir "
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: botones.consultar,
	                        onClick: onBotones(4),
	                        className: "btn btn-sm col ml-1 mb-1 btn-info rounded-pill",
	                        title: "Consultar Almacen"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-eye" },
	                        " Consultar"
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: botones.modificar,
	                        onClick: onBotones(2),
	                        className: "btn btn-sm col ml-1 mb-1 btn-warning rounded-pill",
	                        title: "Modificar Almacen"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fa fa-edit" },
	                        " Modificar"
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: botones.eliminar,
	                        onClick: onBotones(3),
	                        className: "btn btn-sm col ml-1 mb-1 btn-danger rounded-pill",
	                        title: "Eliminar Almacen"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fa fa-trash" },
	                        " Eliminar"
	                      ),
	                      " "
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-400 row m-0 ml-auto" },
	                  habilitadoNU === true ? _react2.default.createElement(
	                    "div",
	                    { className: "col-md-2" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        ref: btnAcepta,
	                        onClick: imprimirOrdendeCompra,
	                        disabled: txtCodigo.current.value !== "" ? false : true,
	                        className: "btn btn-sm rounded-circle btn-primary mb-1"
	                      },
	                      _react2.default.createElement("i", { className: "fas fa-print" })
	                    )
	                  ) : _react2.default.createElement("div", { className: "col-md-2" }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnAcepta,
	                      disabled: acpt,
	                      onClick: onChangeValidar,
	                      className: "btn btn-sm col ml-1 rounded-pill btn-success"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-check-circle" },
	                      " Aceptar"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnCancela,
	                      disabled: habilitado,
	                      onClick: onBotones(6),
	                      className: "btn btn-sm btn-danger col ml-1 rounded-pill"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-window-close" },
	                      " Cancelar"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-pd-full col-pd-3 border-azul rounded px-0 shadow",
	                  style: { backgroundColor: "#dbeeff", fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0 fs-6",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "SUBTOTAL: ",
	                    moneda.simbolo
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    className: "form-control bg-transparent rounded border-0 col-8 ml-auto text-right fs-5 fw-bold",
	                    placeholder: "0,00",
	                    ref: txtSubTotal,
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm  col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0 fs-6",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "EXENTO: ",
	                    moneda.simbolo
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    className: "form-control bg-transparent rounded border-0 col-8 ml-auto text-right fs-5 fw-bold",
	                    placeholder: "0,00",
	                    ref: txtExento,
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm  col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0 fs-6",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "IVA Sobre(16,00%): ",
	                    moneda.simbolo,
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    className: "form-control bg-transparent rounded border-0 col-8 ml-auto text-right fs-5 fw-bold",
	                    placeholder: "0,00",
	                    ref: txtTotalIva,
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm  col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0 fs-6",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TOTAL FACTURA: ",
	                    moneda.simbolo
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    className: "form-control bg-transparent rounded border-0 col-8 ml-auto text-right fs-5 fw-bold",
	                    placeholder: "0,00",
	                    ref: txtTotalconIva,
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm  col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0 fs-6",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TOTAL RETENIDO: ",
	                    moneda.simbolo
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    className: "form-control bg-transparent rounded border-0 col-8 ml-auto text-right fs-5 fw-bold",
	                    placeholder: "0,00",
	                    ref: txtTotalRetencion,
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm  col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0 fs-6",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TOTAL: ",
	                    moneda.simbolo
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    className: "form-control bg-transparent rounded border-0 col-8 ml-auto text-right fs-5 fw-bold",
	                    placeholder: "0,00",
	                    ref: txtTotal,
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: catalogoCliente,
	      nomid: valparametro,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoCliente(false);
	      },
	      onHideAceptaCatalogo: onCatalogoCliente
	    }),
	    _react2.default.createElement(_catalogoMoneda2.default, {
	      show: catalogoMoneda,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoMoneda(false);
	      },
	      onHideAceptaCatalogo: onCatalogoMoneda
	    }),
	    _react2.default.createElement(_catalogoProducto2.default, {
	      show: mostrar,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar(false);
	      },
	      onHideAceptaCatalogo: agregarProducto
	    }),
	    _react2.default.createElement(_catalogoOrdenesdCompra2.default, {
	      show: catalogoPresu,
	      nomid: "ordencompra",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoPresu(false);
	      },
	      onHideAceptaCatalogo: onCatalogoPresupuesto,
	      condicion: "true",
	      op: "7"
	    }),
	    _react2.default.createElement(_catalogoFacturasCompra2.default, {
	      show: catalogoFactura,
	      nomid: "facturacompra",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoFactura(false);
	      },
	      onHideAceptaCatalogo: onCatalogoFacturaCompra,
	      condicion: "true"
	    }),
	    _react2.default.createElement(_catalogoAlmacen2.default, {
	      show: catalogoalmacen,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoalmacen(false);
	      },
	      onHideAceptaCatalogo: onCatalogoAlmacen
	    }),
	    _react2.default.createElement(_catalogoAgregarProveedor2.default, {
	      show: catregistrarcliente,
	      op: operacion,
	      onHideCancelar: function onHideCancelar() {
	        return setCatregistrarcliente(false);
	      },
	      onHideAceptaCatalogo: onRegistrarClientes
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = TablaFacturarOrdenCompra;

/***/ },
/* 7078 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _core = __webpack_require__(19);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _catalogoProducto = __webpack_require__(104);
	
	var _catalogoProducto2 = _interopRequireDefault(_catalogoProducto);
	
	var _catalogoOrdenesdCompra = __webpack_require__(654);
	
	var _catalogoOrdenesdCompra2 = _interopRequireDefault(_catalogoOrdenesdCompra);
	
	var _catalogoAgregarProveedor = __webpack_require__(291);
	
	var _catalogoAgregarProveedor2 = _interopRequireDefault(_catalogoAgregarProveedor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var TablaOrdenCompra = function TablaOrdenCompra() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var anio = JSON.parse(sessionStorage.getItem("anioactu"));
	  var idagente = JSON.parse(sessionStorage.getItem("idagente"));
	  var fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var accbtnordencompra = JSON.parse(sessionStorage.getItem("accbtnordencomprac"));
	
	  var headCells = [{ label: "COD.", textAlign: "center", width: "40px" }, { label: "PRODUCTO", textAlign: "center", width: "160px" }, { label: "CNTD", textAlign: "center", width: "20px" }, { label: "UNI.ALT.", textAlign: "center", width: "50px" }, { label: "PRECIO PVDR.", textAlign: "center", width: "50px" }, { label: "IVA", textAlign: "center", width: "20px" }, { label: "MONTO IVA.", textAlign: "center", width: "50px" }, { label: "MONTO TOTAL", textAlign: "center", width: "50px" }, {
	    label: _react2.default.createElement("i", { className: "fas fa-trash" }),
	    textAlign: "center",
	    width: "20px"
	  }];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var txtNombreCliente = (0, _react.useRef)();
	  var txtDescuento = (0, _react.useRef)();
	  var txtSubTotal = (0, _react.useRef)();
	  var txtTotalIva = (0, _react.useRef)();
	  var txtExentoTotal = (0, _react.useRef)();
	  var txtTotal = (0, _react.useRef)();
	  var txtDirClient = (0, _react.useRef)();
	  var txtCedRifv = (0, _react.useRef)();
	  var txtNombreVendedor = (0, _react.useRef)();
	  var txtCantidad = (0, _react.useRef)([]);
	  var txtPrecio = (0, _react.useRef)([]);
	  var txtId = (0, _react.useRef)([]);
	  var txtCedRif = (0, _react.useRef)();
	  var txtCodigo = (0, _react.useRef)();
	  var txtNumPresupuesto = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtFechaVencimiento = (0, _react.useRef)();
	  var btnProducto = (0, _react.useRef)();
	  var txtIdmoneda = (0, _react.useRef)();
	  var txtTipoOrdenCompra = (0, _react.useRef)();
	  var txtFormaPago = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(""),
	      _useState2 = _slicedToArray(_useState, 2),
	      idCliente = _useState2[0],
	      setIdCliente = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(""),
	      _useState4 = _slicedToArray(_useState3, 2),
	      idVendedor = _useState4[0],
	      setIdVendedor = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(true),
	      _useState6 = _slicedToArray(_useState5, 2),
	      habilitarCat = _useState6[0],
	      setHabilitarCat = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      desde = _useState8[0],
	      setDesde = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      catalogoPresu = _useState10[0],
	      setCatalogoPresu = _useState10[1];
	
	  var _useState11 = (0, _react.useState)("Gestionar Orden de Compra/Servicio."),
	      _useState12 = _slicedToArray(_useState11, 2),
	      tituloHeader = _useState12[0],
	      setTituloHeader = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(""),
	      _useState14 = _slicedToArray(_useState13, 2),
	      numNota = _useState14[0],
	      setNumNota = _useState14[1];
	
	  var _useState15 = (0, _react.useState)("visible"),
	      _useState16 = _slicedToArray(_useState15, 2),
	      visibleBtn = _useState16[0],
	      setVisibleBtn = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      statusordencompra = _useState18[0],
	      setStatusordencompra = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      tasaor = _useState20[0],
	      setTasaor = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      idmoney = _useState22[0],
	      setIdmoney = _useState22[1];
	
	  var _useState23 = (0, _react.useState)([]),
	      _useState24 = _slicedToArray(_useState23, 2),
	      records = _useState24[0],
	      setRecords = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(null),
	      _useState26 = _slicedToArray(_useState25, 2),
	      idalmacen = _useState26[0],
	      setIdAlmacen = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(false),
	      _useState28 = _slicedToArray(_useState27, 2),
	      mostrar = _useState28[0],
	      setMostrar = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(true),
	      _useState30 = _slicedToArray(_useState29, 2),
	      habilitado = _useState30[0],
	      setHabilitado = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(null),
	      _useState32 = _slicedToArray(_useState31, 2),
	      indice = _useState32[0],
	      setIndice = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(null),
	      _useState34 = _slicedToArray(_useState33, 2),
	      body = _useState34[0],
	      setBody = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(false),
	      _useState36 = _slicedToArray(_useState35, 2),
	      catregistrarcliente = _useState36[0],
	      setCatregistrarcliente = _useState36[1];
	
	  var _useState37 = (0, _react.useState)([]),
	      _useState38 = _slicedToArray(_useState37, 2),
	      combomoneda = _useState38[0],
	      setComboMoneda = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(false),
	      _useState40 = _slicedToArray(_useState39, 2),
	      catalogoCliente = _useState40[0],
	      setCatalogoCliente = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(""),
	      _useState42 = _slicedToArray(_useState41, 2),
	      valparametro = _useState42[0],
	      setValparametro = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      mensaje = _useState44[0],
	      setMensaje = _useState44[1];
	
	  var _useState45 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState46 = _slicedToArray(_useState45, 2),
	      mensajesino = _useState46[0],
	      setMensajesino = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(0),
	      _useState48 = _slicedToArray(_useState47, 2),
	      fechav = _useState48[0],
	      setFechav = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(false),
	      _useState50 = _slicedToArray(_useState49, 2),
	      activate = _useState50[0],
	      setActivate = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(true),
	      _useState52 = _slicedToArray(_useState51, 2),
	      castabla = _useState52[0],
	      setCastabla = _useState52[1];
	
	  var _useState53 = (0, _react.useState)({
	    idmoneda: "1",
	    descripcion: "BOLIVARES",
	    simbolo: "Bs",
	    predeterminada: true,
	    subpredeterminada: false,
	    valormoneda: 1.0
	  }),
	      _useState54 = _slicedToArray(_useState53, 2),
	      moneda = _useState54[0],
	      setMoneda = _useState54[1];
	
	  var _useState55 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState56 = _slicedToArray(_useState55, 2),
	      monedaSub = _useState56[0],
	      setMonedaSub = _useState56[1];
	
	  var _useState57 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState58 = _slicedToArray(_useState57, 2),
	      monedaCambio = _useState58[0],
	      setMonedaCambio = _useState58[1];
	
	  var _useState59 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    catalogoper: true
	  }),
	      _useState60 = _slicedToArray(_useState59, 2),
	      botones = _useState60[0],
	      setBotones = _useState60[1];
	
	  var _useState61 = (0, _react.useState)(false),
	      _useState62 = _slicedToArray(_useState61, 2),
	      acpt = _useState62[0],
	      setAcpt = _useState62[1];
	
	  var _useState63 = (0, _react.useState)(false),
	      _useState64 = _slicedToArray(_useState63, 2),
	      habilitadoNU = _useState64[0],
	      setHabilitadoNU = _useState64[1];
	
	  var _useState65 = (0, _react.useState)(0),
	      _useState66 = _slicedToArray(_useState65, 2),
	      operacion = _useState66[0],
	      setOperacion = _useState66[1];
	
	  var _useState67 = (0, _react.useState)({
	    subtotal: 0.0,
	    descuento: 0.0,
	    exento: 0.0,
	    sujeto: 0.0,
	    iva: 16.0,
	    totaliva: 0.0,
	    total: 0.0
	  }),
	      _useState68 = _slicedToArray(_useState67, 2),
	      totales = _useState68[0],
	      setTotales = _useState68[1];
	
	  var seleccionarAgente = function seleccionarAgente() {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "idagente";
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + idagente;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtNombreVendedor.current.value = response.data.nombre;
	          txtCedRifv.current.value = response.data.rif;
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarAlmacen = function seleccionarAlmacen() {
	    var campos = "*";
	    var nomtab = "almacen";
	    var nomid = "ventas";
	    var id = "true";
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setIdAlmacen(response.data.idalmacen);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un Almacen de venta",
	            icono: "informacion"
	          });
	          blanquear();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setTituloHeader("Gestionar Orden de Compra/Servicio.");
	    setFechav(0);
	    setTasaor(0);
	    setStatusordencompra(0);
	    txtId.current.value = "";
	    txtNombreCliente.current.value = "";
	    txtNombreVendedor.current.value = "";
	    txtCedRif.current.value = "";
	    txtCedRifv.current.value = "";
	    txtDirClient.current.value = "";
	    txtTotal.current.value = "";
	    txtTotalIva.current.value = "";
	    txtSubTotal.current.value = "";
	    txtCodigo.current.value = "";
	    txtFecha.current.value = (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD");
	    txtFormaPago.current.value = "3";
	    txtTipoOrdenCompra.current.value = "1";
	    setActivate(false);
	    setRecords([]);
	    setIndice(null);
	    setAcpt(false);
	    setComboMoneda([]);
	    setHabilitarCat(true);
	    setNumNota("");
	    setVisibleBtn("visible");
	    setCastabla(true);
	    setOperacion(0);
	    setHabilitado(true);
	    setHabilitadoNU(false);
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: false,
	      cancelar: false,
	      catalogo: true,
	      catalogoper: true
	    });
	    setMoneda({
	      idmoneda: "1",
	      descripcion: "BOLIVARES",
	      simbolo: "Bs",
	      predeterminada: false,
	      valormoneda: 1.0
	    });
	    setMonedaCambio({
	      idmoneda: "4",
	      descripcion: "DOLAR",
	      simbolo: "$",
	      predeterminada: false,
	      subpredeterminada: true,
	      valormoneda: 1.0
	    });
	    for (var i = 0; i < combomoneda.length; i++) {
	      if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
	        txtIdmoneda.current.selectedIndex = i;
	      }
	    }
	
	    setTotales({
	      subtotal: 0.0,
	      descuento: 0.0,
	      exento: 0.0,
	      sujeto: 0.0,
	      iva: 16.0,
	      totaliva: 0.0,
	      total: 0.0
	    });
	  };
	
	  var eliminarProducto = function eliminarProducto(producto) {
	    return function (e) {
	      e.preventDefault();
	      var data = [].concat(_toConsumableArray(records));
	      var elementos = [];
	
	      for (var i = 0; i < data.length; i++) {
	        if (producto.idproducto !== data[i].idproducto) {
	          elementos.push(data[i]);
	        }
	      }
	      setRecords(elementos);
	      setTotales((0, _varios.calcularTotales)(elementos));
	    };
	  };
	
	  var onCatalogoCliente = function onCatalogoCliente(values) {
	    setCatalogoCliente(false);
	    if (valparametro === "proveedor") {
	      txtNombreCliente.current.value = values.nombre;
	      txtDirClient.current.value = values.direccion;
	      txtCedRif.current.value = values.rif;
	      setIdCliente(values.idagente);
	    }
	  };
	
	  var onCatalogo = function onCatalogo(val) {
	    if (val === 1) {
	      setValparametro("proveedor");
	      setCatalogoCliente(true);
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	
	    if (txtTipoOrdenCompra.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Tipo de Orden no debe ir Vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtTipoOrdenCompra.current.focus();
	    } else if (txtFormaPago.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Forma de Pago no debe ir Vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtFormaPago.current.focus();
	    } else if (txtCedRif.current.value.trim() === "" || txtNombreCliente.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "Debe seleccionar el Proveedor",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtCedRif.current.focus();
	    } else if (txtCedRifv.current.value === "" || txtCedRifv.current.value.trim() === "" || txtNombreVendedor.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "Debe seleccionar el Vendedor",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtCedRifv.current.focus();
	    } else if (txtFecha.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtFecha.current.focus();
	    } else if (records.length === 0) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "No hay Producto agregados",
	        icono: "informacion"
	      });
	      sigue = false;
	      btnCancela.current.focus();
	    }
	
	    if (sigue) {
	      var orden = [];
	      var ordendeta = [];
	      var tasa = 0.0;
	
	      tasa = monedaSub.valormoneda;
	
	      orden.push({
	        idordendecompra: operacion === 1 && txtCodigo.current.value !== null ? 0 : operacion === 2 ? txtCodigo.current.value : txtCodigo.current.value,
	        codigo: numNota,
	        cedularif: txtCedRif.current.value,
	        montototal: parseFloat(txtSubTotal.current.value.replace(/\./g, "").replace(",", ".")) / tasa,
	        totaliva: parseFloat(txtTotalIva.current.value.replace(/\./g, "").replace(",", ".")) / tasa,
	        idproveedor: idCliente,
	        idcomprador: operacion === 1 ? idagente : idVendedor,
	        fecha: txtFecha.current.value,
	        idmoneda: idmoney,
	        status: "0",
	        tipoorden: txtTipoOrdenCompra.current.value,
	        formapago: txtFormaPago.current.value,
	        fechavencimiento: txtFormaPago.current.value === "4" ? txtFechaVencimiento.current.value : null,
	        tasa: tasa
	      });
	
	      for (var i = 0; i < records.length; i++) {
	        ordendeta.push({
	          idproducto: records[i].idproducto,
	          cantidad: records[i].cantidad,
	          punitario: records[i].precio / records[i].valormoneda,
	          iva: records[i].iva,
	          tipounidad: records[i].tipounidad,
	          idunidadmedida: records[i].idunidadmedida,
	          idunidadalterna: records[i].idunidadalterna
	        });
	      }
	
	      setBody({
	        orden: orden,
	        ordendeta: ordendeta
	      });
	
	      setDesde(2);
	      var msg = "";
	      if (operacion === 1) {
	        msg = "¿Esta Seguro de Registrar estos Datos?.";
	      } else if (operacion === 2) {
	        msg = "¿Esta Seguro de Modificar estos Datos?.";
	      } else if (operacion === 3) {
	        msg = "¿Esta Seguro de Eliminar estos Datos?.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/ordencompra/actualizarordencompra/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "¡Registro " + response.data.idpe + " Creado Correctamente!",
	            icono: "exito"
	          });
	          /* window.open(op.reportes + "reporte=Pedido" + "&CODIGO=" + response.data.idpe, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"); */
	          if (txtFormaPago.current.value === "4") {
	            txtFechaVencimiento.current.value = (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD");
	          }
	        } else if (operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "¡Registro " + response.data.idpe + " Modificado Correctamente!",
	            icono: "exito"
	          });
	          if (txtFormaPago.current.value === "4") {
	            txtFechaVencimiento.current.value = (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD");
	          }
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "¡Registro " + response.data.idpe + " Eliminado Correctamente!",
	            icono: "exito"
	          });
	        }
	
	        blanquear();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = "";
	      if (error.response === undefined) {
	        mensaje = "Error de Conexion";
	      } else {
	        mensaje = error.response.data.message;
	      }
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    if (desde === 1) {
	      var prod = records;
	      setDesde(0);
	      setRecords(prod);
	    } else if (desde === 2) {
	      setDesde(0);
	      procesarRegistro();
	    }
	  };
	
	  var seleccionarProducto = function seleccionarProducto(index, idubi, idprod) {
	    var campos = "p.*, (select trim(descripcion) as descripcionuni from unidadmedida where idunidadmedida = p.idunidadmedida) as descripcionuni," + "(select trim(descripcion) as descripcionunialt from unidadmedida where idunidadmedida = p.idunidadalterna) as descripcionunialt ";
	    var nomtab = "producto as p";
	    var nomid = "p.codigo";
	    var nomid2 = 'activo';
	    var id = idprod;
	    var id2 = true;
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=" + id2;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var data = [].concat(_toConsumableArray(records));
	
	        if (response.data !== "") {
	          if (response.data.servicio) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "El producto no existe o esta Inactivo",
	              icono: "error"
	            });
	            txtCantidad.current[records.length - 1].value = "1,00";
	          } else {
	            for (var i = 0; i < records.length; i++) {
	              if (records[i].idproducto === response.data.idproducto) {
	                setActivate(false);
	                setMensaje({
	                  mostrar: true,
	                  titulo: "Notificacion",
	                  texto: "El PRODUCTO YA EXISTE",
	                  icono: "error"
	                });
	                return;
	              }
	            }
	
	            var uni = [];
	
	            if (parseInt(response.data.idunidadalterna) === 0) {
	              uni = [{
	                idunidad: response.data.idunidadmedida,
	                descripcion: response.data.descripcionuni,
	                tipo: "medida"
	              }];
	            } else {
	              uni = [{
	                idunidad: response.data.idunidadmedida,
	                descripcion: response.data.descripcionuni,
	                tipo: "medida"
	              }, {
	                idunidad: response.data.idunidadalterna,
	                descripcion: response.data.descripcionunialt,
	                tipo: "alterna"
	              }];
	            }
	
	            var precio = 0.0;
	            var tipounidad = 0;
	
	            if (response.data.idunidadcompra === response.data.idunidadalterna) {
	              precio = response.data.costoproveedoralter;
	              tipounidad = 1;
	            } else {
	              precio = response.data.costoproveedor;
	              tipounidad = 0;
	            }
	
	            // precio = precio * response.data.valormoneda;
	            //  precio = precio / moneda.valormoneda;
	
	            var montoiva = (0, _varios.round)(precio * response.data.ivaventa / 100, 2);
	
	            if (index !== null) {
	              data[index] = {
	                idproducto: response.data.idproducto,
	                codigo: response.data.codigo,
	                cantidad: 1.0,
	                nombrecorto: response.data.nombrecorto,
	                precio: precio,
	                iva: response.data.ivaventa,
	                motoiva: montoiva,
	                descuento: "",
	                total: precio,
	                totald: precio,
	                unidad: uni,
	                idunidadmedida: response.data.idunidadmedida,
	                idunidadalterna: response.data.idunidadalterna,
	                idmoneda: response.data.idmoneda,
	                valormoneda: monedaCambio.valormoneda,
	                tipounidad: tipounidad,
	                valorfactor: response.data.valorfactor,
	                costoproveedor: response.data.costoproveedor
	              };
	            } else {
	              data.push({
	                idproducto: response.data.idproducto,
	                codigo: response.data.codigo,
	                cantidad: 1.0,
	                nombrecorto: response.data.nombrecorto,
	                precio: precio,
	                iva: response.data.ivaventa,
	                motoiva: montoiva,
	                descuento: "",
	                total: precio,
	                totald: precio,
	                unidad: uni,
	                idunidadmedida: response.data.idunidadmedida,
	                idunidadalterna: response.data.idunidadalterna,
	                idmoneda: response.data.idmoneda,
	                valormoneda: monedaCambio.valormoneda,
	                tipounidad: tipounidad,
	                valorfactor: response.data.valorfactor,
	                costoproveedor: response.data.costoproveedor
	              });
	            }
	
	            setRecords(data);
	            setTotales((0, _varios.calcularTotales)(data));
	            setIndice(index);
	
	            if (index !== null) {
	              setTimeout(function () {
	                return txtCantidad.current[index].focus();
	              }, 300);
	            } else {
	              setTimeout(function () {
	                return txtCantidad.current[data.length - 1].focus();
	              }, 300);
	            }
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "El producto no existe o esta Inactivo",
	            icono: "error"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      txtId.current.value = "";
	      txtId.current.focus();
	    });
	  };
	
	  var seleccionarDetalle = function seleccionarDetalle() {
	    var id = txtCodigo.current.value;
	    var endpoint = op.conexion + "/api/ordencompra/seleccionarordencompra?idordendecompra=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var prod = [];
	          var uni = [];
	
	          for (var i = 0; i < response.data.length; i++) {
	            if (parseInt(response.data[i].idunidadalterna) === 0) {
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	            } else {
	              if (response.data[i].tipounidad === 0) {
	                uni = [{
	                  idunidad: response.data[i].idunidadmedida,
	                  descripcion: response.data[i].descripcionuni,
	                  tipo: "medida"
	                }, {
	                  idunidad: response.data[i].idunidadalterna,
	                  descripcion: response.data[i].descripcionunialt,
	                  tipo: "alterna"
	                }];
	              } else {
	                uni = [{
	                  idunidad: response.data[i].idunidadalterna,
	                  descripcion: response.data[i].descripcionunialt,
	                  tipo: "alterna"
	                }, {
	                  idunidad: response.data[i].idunidadmedida,
	                  descripcion: response.data[i].descripcionuni,
	                  tipo: "medida"
	                }];
	              }
	            }
	
	            var montoiva = parseFloat(response.data[i].punitario) * parseFloat(response.data[i].ivaventa) / 100;
	            montoiva = (0, _varios.round)(montoiva, 2) * parseFloat(response.data[i].cantidad);
	
	            prod.push({
	              idproducto: response.data[i].idproducto,
	              codigo: response.data[i].codigo,
	              cantidad: parseFloat(response.data[i].cantidad),
	              nombrecorto: response.data[i].nombrecorto,
	              precio: parseFloat(response.data[i].punitario),
	              iva: parseFloat(response.data[i].iva),
	              ivaventa: parseFloat(response.data[i].ivaventa),
	              motoiva: montoiva,
	              descuento: response.data[i].descuento,
	              total: parseFloat(response.data[i].cantidad) * parseFloat(response.data[i].punitario),
	              totald: parseFloat(response.data[i].cantidad) * parseFloat(response.data[i].punitario),
	              unidad: uni,
	              idunidadmedida: response.data[i].idunidadmedida,
	              idunidadalterna: response.data[i].idunidadalterna,
	              costocalculado: response.data[i].costocalculado,
	              costocalculadoalter: response.data[i].costocalculadoalter,
	              utipreciomaxi: response.data[i].utipreciomaxi,
	              utipreciomaxialter: response.data[i].utipreciomaxialter,
	              tipounidad: response.data[i].tipounidad,
	              valormoneda: monedaCambio.valormoneda,
	              idmoneda: response.data[i].idmoneda,
	              costoproveedor: parseFloat(response.data[i].punitario),
	              tasa: monedaCambio.valormoneda
	            });
	          }
	          setRecords(prod);
	          setTotales((0, _varios.calcularTotales)(prod));
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var agregarProducto = function agregarProducto(producto) {
	    setMostrar(false);
	    seleccionarProducto(indice, idalmacen, producto.codigo);
	  };
	
	  var editarProducto = function editarProducto(index) {
	    return function (e) {
	      e.preventDefault();
	      setMostrar(true);
	      setIndice(index);
	    };
	  };
	
	  var validarCantidad = function validarCantidad(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	          event.target.value = "1,00";
	        }
	        event.target.value = (0, _varios.formatoMonto)(event.target.value);
	        var char1 = event.target.value.substring(0, 1);
	        var char2 = event.target.value.substring(1, 2);
	        if (char1 === "0" && char2 !== ",") {
	          event.target.value = event.target.value.substring(1, event.target.value.length);
	        }
	        if (event.target.id === "cantidad") {
	          var canti = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	          var data = [].concat(_toConsumableArray(records));
	          if (canti > data[index].cantidadE) {
	            data[index].cantidad = 1.0;
	            canti = 1.0;
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La  cantidad no debe ser mayor a la cantidad existente",
	              icono: "informacion"
	            });
	          }
	
	          // let ivss = (data[index].precio * canti * data[index].iva) / 100;
	          //  let ivb = ivss * data[index].valormoneda;
	
	          data[index].cantidad = canti;
	          data[index].motoiva = (0, _varios.round)(data[index].precio * data[index].iva / 100, 2) * canti;
	          data[index].total = data[index].precio * canti;
	          //  data[index].totald = data[index].precio * canti;
	
	          setRecords(data);
	          setTotales((0, _varios.calcularTotales)(data));
	          if (event.which === 13) {
	            if (index < data.length - 1) {
	              setTimeout(function () {
	                return txtCantidad.current[index + 1].focus();
	              }, 300);
	            } else {
	              btnProducto.current.focus();
	            }
	          }
	        }
	      } else if (event.which === 46) {
	        return false;
	      } else if (event.which >= 48 && event.which <= 57) {
	        return true;
	      } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	        return true;
	      } else return false;
	    };
	  };
	
	  var validarIdProducto = function validarIdProducto(index) {
	    return function (event) {
	      event.preventDefault();
	      if (event.which === 13 || typeof event.which === "undefined") {
	        if (event.target.value !== "") {
	          seleccionarProducto(index, idalmacen, event.target.value);
	        }
	      }
	    };
	  };
	
	  var onRegistrarClientes = function onRegistrarClientes(values) {
	    setCatregistrarcliente(false);
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (accbtnordencompra && accbtnordencompra.toString().substring(0, 1) === "1") {
	          setVisibleBtn("hidden");
	          setTituloHeader("Incluir Orden de Compra/Servicio.");
	          setHabilitado(false);
	          seleccionarMonedas();
	          seleccionarAgente();
	          seleccionarCidgoorden("idordendecompra");
	          setCastabla(false);
	          setOperacion(1);
	          setAcpt(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            catalogoper: false
	          });
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (accbtnordencompra && accbtnordencompra.toString().substring(1, 2) === "1") {
	          setTituloHeader("Editar Orden de Compra/Servicio.");
	          setVisibleBtn("hidden");
	          setHabilitado(false);
	          seleccionarMonedas();
	          setHabilitarCat(false);
	          setCastabla(false);
	          setAcpt(false);
	          setOperacion(2);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (accbtnordencompra && accbtnordencompra.toString().substring(3, 4) === "1") {
	          setTituloHeader("Eliminar Orden de Compra/Servicio.");
	          setVisibleBtn("hidden");
	          setHabilitado(false);
	          seleccionarMonedas();
	          setAcpt(false);
	          setHabilitarCat(false);
	          setCastabla(true);
	          setOperacion(3);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (accbtnordencompra && accbtnordencompra.toString().substring(2, 3) === "1") {
	          setTituloHeader("Consultar Orden de Compra/Servicio.");
	          setVisibleBtn("hidden");
	          seleccionarMonedas();
	          setAcpt(true);
	          setHabilitado(false);
	          setCastabla(true);
	          setOperacion(4);
	          setHabilitarCat(false);
	          setHabilitadoNU(true);
	          setDesde(7);
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 6) {
	        setVisibleBtn("visible");
	        blanquear();
	      }
	    };
	  };
	
	  var seleccionarMonedas = function seleccionarMonedas() {
	    var campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	    var nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	    var orden = "m.idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var x = 0;
	        if (response.data.length > 0) {
	          setComboMoneda(response.data);
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].subpredeterminada) {
	              setMonedaSub(response.data[i]);
	              setIdmoney(response.data[i].idmoneda);
	              setMonedaCambio({
	                idmoneda: response.data[i].idmoneda,
	                descripcion: response.data[i].descripcion,
	                simbolo: response.data[i].simbolo,
	                predeterminada: response.data[i].predeterminada,
	                subpredeterminada: response.data[i].subpredeterminada,
	                valormoneda: 1.0
	              });
	              x = i;
	            } else if (response.data[i].predeterminada) {
	              setMoneda(response.data[i]);
	            }
	          }
	        }
	        setTimeout(function () {
	          return txtIdmoneda.current.selectedIndex = x;
	        }, 200);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarProveedor = function seleccionarProveedor(rif) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "rif";
	    var nomid2 = "proveedor";
	    var id = rif;
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtCedRif.current.value = response.data.rif;
	          txtNombreCliente.current.value = response.data.nombre;
	          txtDirClient.current.value = response.data.direccion;
	          setIdCliente(response.data.idagente);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un cliente con este codigo",
	            icono: "informacion"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarResponsable = function seleccionarResponsable(id) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "idagente";
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtCedRifv.current.value = response.data.rif;
	          txtNombreVendedor.current.value = response.data.nombre;
	          setIdVendedor(response.data.idagente);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un vendedor con este codigo",
	            icono: "informacion"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = "*";
	    var nomtab = "ordendecompra";
	    var nomid = "idordendecompra";
	    var id = txtCodigo.current.value;
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setStatusordencompra(response.data.status);
	          setTasaor(response.data.tasa);
	          txtFecha.current.value = (0, _moment2.default)(response.data.fecha).format("YYYY-MM-DD");
	          setNumNota(response.data.codigo);
	          txtCedRif.current.value = response.data.cedularif;
	          txtTipoOrdenCompra.current.value = parseInt(response.data.tipoorden);
	          txtFormaPago.current.value = parseInt(response.data.formapago);
	          if (parseInt(response.data.formapago) === 4) {
	            setFechav(1);
	            txtFechaVencimiento.current.value = (0, _moment2.default)(response.data.fechavencimiento).format("YYYY-MM-DD");
	          } else {
	            setFechav(0);
	          }
	          seleccionarProveedor(response.data.cedularif);
	          seleccionarResponsable(response.data.idcomprador);
	          //seleccionarMoneda(response.data.idmoneda);
	          seleccionarDetalle();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "ID no existe.",
	            icono: "informacion"
	          });
	          txtCodigo.current.value = "";
	          txtCodigo.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var handleInputNumeroChange = function handleInputNumeroChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "idordendecompra") {
	          seleccionarRegistro();
	        }
	      }
	    }
	  };
	
	  var seleccionarCidgoorden = function seleccionarCidgoorden(id) {
	    var tabla = "ordendecompra";
	    var endpoint = op.conexion + "/api/ordencompra/consultacodigos?tabla=" + tabla + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.numeroasignado > 0) {
	          var to = parseFloat(response.data.numeroasignado) + 1;
	          var cerrrou = '00000';
	          var paddedNumber = (0, _varios.lpad)(to.toString(), cerrrou, 5);
	          setNumNota("OC" + paddedNumber);
	        } else {
	          setNumNota("OC00001");
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var onCatalogoPresupuesto = function onCatalogoPresupuesto(values) {
	    setCatalogoPresu(false);
	    txtCodigo.current.value = values.idordendecompra;
	    seleccionarRegistro();
	  };
	
	  var onChangeFecha = function onChangeFecha(e) {
	    if (e.target.name === "formapago") {
	      if (e.target.value === "4") {
	        setFechav(1);
	      } else if (e.target.value === "3") {
	        setFechav(0);
	      }
	    }
	  };
	
	  var onChangeMoneda = function onChangeMoneda(e) {
	    var i = e.target.value;
	    var cambio = (0, _varios.onCambioMoneda)({
	      moneda: combomoneda[i],
	      productos: records,
	      monedaPre: moneda,
	      monedaSub: monedaSub
	    });
	    setMonedaCambio(cambio.monedacambio);
	    setRecords(cambio.data);
	  };
	
	  var onChangeUnidad = function onChangeUnidad(index) {
	    return function (e) {
	      e.preventDefault();
	      var data = [].concat(_toConsumableArray(records));
	      var precio = 0.0;
	      var montoiva = 0.0;
	      var tipounidad = 0;
	
	      if (parseInt(e.target.value) === parseInt(data[index].idunidadalterna)) {
	        tipounidad = 1;
	        precio = parseFloat(data[index].precio) / parseFloat(data[index].valorfactor);
	      } else if (parseInt(e.target.value) === parseInt(data[index].idunidadmedida)) {
	        tipounidad = 0;
	        precio = parseFloat(data[index].precio) * parseFloat(data[index].valorfactor);
	      }
	
	      montoiva = precio * parseFloat(data[index].iva) / 100;
	
	      data[index].tipounidad = tipounidad;
	      data[index].precio = precio;
	      data[index].unidad = data[index].unidad.reverse();
	      data[index].total = precio * data[index].cantidad;
	      data[index].montoiva = montoiva * data[index].cantidad;
	
	      setRecords(data);
	      setTotales((0, _varios.calcularTotales)(data));
	    };
	  };
	
	  var imprimirOrdendeCompra = function imprimirOrdendeCompra() {
	    if (accbtnordencompra && accbtnordencompra.toString().substring(4, 5) === "1") {
	      if (txtCodigo.current.value !== "") {
	        var id = txtCodigo.current.value;
	        window.open(op.reportes + "reporte=Ordencompra" + "&CODIGO=" + id, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      }
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarAlmacen();
	    seleccionarMonedas();
	  }, []);
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === "tipoorden") {
	
	      var tipoorden = txtNumPresupuesto.current.value.substring(2, 8);
	
	      if (e.target.value === "1") {
	        var compra = "OC" + tipoorden;
	        setNumNota(compra);
	      } else {
	        var _compra = "OS" + tipoorden;
	        setNumNota(_compra);
	      }
	    }
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 ", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-11 mx-auto py-2 card shadow " },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "col-md-12 row border-azul mx-auto justify-content-between rounded py-2",
	              style: { fontSizeAdjust: "0.6" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light d-flex align-items-center" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-5" },
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  tituloHeader
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-450 mx-auto px-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0 fs-6 fw-bold text-light",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    numNota.substring(0, 2) === 'OC' ? 'N° Order de Compra:' : numNota.substring(0, 2) === 'OS' ? 'N° Order de Servicio:' : '',
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "text",
	                    ref: txtNumPresupuesto,
	                    disabled: true,
	                    className: "form-control mt-1 bg-transparent border-0 text-light fw-bold fs-5",
	                    value: numNota,
	                    name: "numpresu",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 d-flex justify-content-end" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "/inicio", className: "text-light " },
	                  _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "fw-bold" },
	                    "Salir"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row px-0 m-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-220 mb-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CODIGO:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "text",
	                    name: "idordendecompra",
	                    onKeyUp: handleInputNumeroChange,
	                    disabled: operacion === 1 || operacion === 0 ? true : false,
	                    ref: txtCodigo,
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      type: "button",
	                      onClick: function onClick() {
	                        return setCatalogoPresu(true);
	                      },
	                      disabled: habilitarCat,
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-260 mb-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO DE ORDEN:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-select",
	                      ref: txtTipoOrdenCompra,
	                      onChange: onChange,
	                      name: "tipoorden",
	                      disabled: operacion === 4 || operacion === 3 || operacion === 0 ? true : false,
	                      "aria-label": "Default select example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "COMPRA"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "2" },
	                      "SERVICIO"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-270 mb-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO DE PAGO:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-select",
	                      ref: txtFormaPago,
	                      name: "formapago",
	                      onChangeCapture: onChangeFecha,
	                      disabled: operacion === 4 || operacion === 3 || operacion === 0 ? true : false,
	                      "aria-label": "Default select example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "3" },
	                      "CONTADO"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "4" },
	                      "CR\xC9DITO"
	                    )
	                  )
	                )
	              ),
	              fechav === 1 ? _react2.default.createElement(
	                "div",
	                { className: "col-pd-350 mb-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA DE VENCIMIENTO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "date",
	                    disabled: castabla,
	                    className: "form-control text-uppercase fs-6",
	                    ref: txtFechaVencimiento,
	                    "aria-label": "Sizing example input",
	                    defaultValue: (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD"),
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              ) : "",
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-220 ml-auto mb-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA:"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "date",
	                    disabled: castabla,
	                    className: "form-control text-uppercase fs-6",
	                    ref: txtFecha,
	                    "aria-label": "Sizing example input",
	                    defaultValue: (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD"),
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-8 mb-2 py-1" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row border-azul rounded py-2" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold col-md-12" },
	                  "Datos del Proveedor",
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      style: {
	                        pointerEvents: botones.catalogoper === true ? "none" : false,
	                        color: botones.catalogoper ? "rgb(183, 183, 183)" : "#1d0345",
	                        backgroundColor: botones.catalogoper ? "#fff" : "transparent"
	                      },
	                      type: "button",
	                      onClick: function onClick() {
	                        return onCatalogo(1);
	                      },
	                      className: "text-info rounded-circle",
	                      title: "Buscar Proveedor"
	                    },
	                    _react2.default.createElement("i", { className: " fas fa-search" })
	                  ),
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      style: {
	                        pointerEvents: botones.catalogoper === true ? "none" : false,
	                        color: botones.catalogoper ? "rgb(183, 183, 183)" : "#1d0345",
	                        backgroundColor: botones.catalogoper ? "#fff" : "transparent"
	                      },
	                      type: "button",
	                      onClick: function onClick() {
	                        return setCatregistrarcliente(true);
	                      },
	                      className: "text-info rounded-circle ml-2",
	                      title: "Registrar Proveedor"
	                    },
	                    _react2.default.createElement("i", { className: " fas fa-plus" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-3 mb-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "CEDULA/RIF:",
	                      " "
	                    ),
	                    _react2.default.createElement("input", {
	                      autoComplete: "off",
	                      type: "text",
	                      disabled: true,
	                      ref: txtCedRif,
	                      className: "form-control bg-transparent fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-9 mb-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "NOMBRE:",
	                      " "
	                    ),
	                    _react2.default.createElement("input", {
	                      autoComplete: "off",
	                      type: "text",
	                      disabled: true,
	                      ref: txtNombreCliente,
	                      className: "form-control bg-transparent fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 mb-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "DIRECCION:",
	                      " "
	                    ),
	                    _react2.default.createElement("input", {
	                      autoComplete: "off",
	                      type: "text",
	                      disabled: true,
	                      ref: txtDirClient,
	                      className: "form-control bg-transparent fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4 mb-2 py-1 row m-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto border-azul rounded row py-2" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold" },
	                  "Datos del Responsable"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-6 py-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "CEDULA/RIF:",
	                      " "
	                    ),
	                    _react2.default.createElement("input", {
	                      autoComplete: "off",
	                      type: "text",
	                      disabled: true,
	                      ref: txtCedRifv,
	                      className: "form-control bg-transparent fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "NOMBRE:",
	                      " "
	                    ),
	                    _react2.default.createElement("input", {
	                      autoComplete: "off",
	                      type: "text",
	                      disabled: true,
	                      ref: txtNombreVendedor,
	                      className: "form-control bg-transparent fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-330 py-1 ml-auto px-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO DE MONEDA:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-control form-control-sm form-select fw-bold fs-6",
	                      disabled: operacion === 3 || operacion === 0 ? true : false,
	                      ref: txtIdmoneda,
	                      onChange: onChangeMoneda
	                    },
	                    combomoneda && combomoneda.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: index },
	                        " ",
	                        item.descripcion + " " + item.simbolo + " " + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                        " "
	                      );
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 border-azul rounded px-0",
	                style: { backgroundColor: "#d5e9ff" }
	              },
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 250,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px",
	                    fontSizeAdjust: "0.6"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden table-bordered" },
	                  records && records.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      { key: index, style: { padding: "0" } },
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-center p-0 d-flex" },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          style: {
	                            borderBottomRightRadius: 0,
	                            borderTopRightRadius: 0
	                          },
	                          disabled: castabla,
	                          ref: function ref(el) {
	                            return txtId.current[index] = el;
	                          },
	                          className: "form-control form-control-sm bg-light text-right text-center fs-6",
	                          defaultValue: item.codigo,
	                          onChange: function onChange(e) {
	                            return e.target.value = e.target.value.toUpperCase();
	                          },
	                          onKeyUp: validarIdProducto(index),
	                          onBlur: validarIdProducto(index)
	                        }),
	                        (operacion === 1 || operacion === 2) && _react2.default.createElement(
	                          "button",
	                          {
	                            type: "button",
	                            style: {
	                              borderBottomLeftRadius: 0,
	                              borderTopLeftRadius: 0
	                            },
	                            disabled: castabla,
	                            onClick: editarProducto(index),
	                            className: "btn btn-sm btn-primary"
	                          },
	                          _react2.default.createElement(
	                            "i",
	                            { className: "fas " },
	                            "-"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-baseline bg-light",
	                          style: { textAlign: "center", width: "160px" }
	                        },
	                        item.nombrecorto
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light p-0",
	                          style: { width: "20px" }
	                        },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          disabled: castabla,
	                          className: "form-control form-control-sm bg-light text-right fs-6",
	                          id: "cantidad",
	                          defaultValue: (0, _varios.formatMoneda)(item.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtCantidad.current[index] = el;
	                          },
	                          onFocus: _varios.seleccionarCampo,
	                          onKeyUp: validarCantidad(index),
	                          onBlur: validarCantidad(index)
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-baseline bg-light p-0",
	                          style: { width: "50px" }
	                        },
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            className: "form-select form-select-sm fs-6",
	                            disabled: castabla,
	                            onChange: onChangeUnidad(index),
	                            "aria-label": ".form-select-sm example"
	                          },
	                          item.unidad && item.unidad.map(function (item2, x) {
	                            return _react2.default.createElement(
	                              "option",
	                              { key: x, value: item2.idunidad },
	                              " ",
	                              item2.descripcion,
	                              " "
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-center p-0",
	                          style: { width: "50px" }
	                        },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          disabled: castabla
	                          //onKeyUp={validarPrecio(index)}
	                          //onBlur={validarPrecio(index)}
	                          , className: "form-control form-control-sm bg-light text-right fs-6",
	                          id: "precio",
	                          defaultValue: (0, _varios.formatMoneda)((item.precio * item.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtPrecio.current[index] = el;
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-baseline bg-light text-center",
	                          style: { width: "20px" }
	                        },
	                        (0, _varios.formatMoneda)(item.iva.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-baseline bg-light text-right",
	                          style: { width: "50px" }
	                        },
	                        (0, _varios.formatMoneda)((item.motoiva * item.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-baseline bg-light text-right",
	                          style: { width: "50px" }
	                        },
	                        (0, _varios.formatMoneda)((item.precio * item.cantidad * item.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-baseline bg-light p-0",
	                          style: { textAlign: "center", width: "20px" }
	                        },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            disabled: castabla,
	                            style: {
	                              visibility: (operacion === 4 || operacion === 3) && "collapse"
	                            },
	                            className: "btn btn-sm mx-1 btn-danger rounded-circle",
	                            onClick: eliminarProducto(item)
	                          },
	                          _react2.default.createElement("i", { className: "fa fa-trash" }),
	                          " "
	                        )
	                      )
	                    );
	                  }),
	                  _react2.default.createElement(
	                    _core.TableRow,
	                    {
	                      style: {
	                        padding: "0",
	                        visibility: (operacion === 4 || operacion === 0 || operacion === 3) && "collapse"
	                      }
	                    },
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: "align-middle bg-light text-center p-0 d-flex" },
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        style: {
	                          borderBottomRightRadius: 0,
	                          borderTopRightRadius: 0
	                        },
	                        className: "form-control form-control-sm bg-light text-right",
	                        onChange: function onChange(e) {
	                          return e.target.value = e.target.value.toUpperCase();
	                        },
	                        onKeyUp: validarIdProducto(null),
	                        onBlur: validarIdProducto(null)
	                      }),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          style: {
	                            borderBottomLeftRadius: 0,
	                            borderTopLeftRadius: 0
	                          },
	                          onClick: function onClick() {
	                            return setMostrar(true);
	                          },
	                          className: "btn btn-sm btn-primary"
	                        },
	                        _react2.default.createElement(
	                          "i",
	                          { className: "fas " },
	                          "-"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-baseline bg-light",
	                      style: { textAlign: "center", width: "160px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-baseline bg-light",
	                      style: { textAlign: "center", width: "20px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-baseline bg-light text-center",
	                      style: { width: "50px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-baseline bg-light text-center",
	                      style: { width: "50px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-baseline bg-light text-center",
	                      style: { width: "20px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-baseline bg-light text-right",
	                      style: { width: "50px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-baseline bg-light text-right",
	                      style: { width: "50px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-baseline bg-light",
	                      style: { width: "20px" }
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row m-0 px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-8 mt-auto" },
	                visibleBtn === "visible" ? _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-botones" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 row m-0" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: botones.incluir,
	                        onClick: onBotones(1),
	                        className: "btn btn-sm col ml-1 mb-1 btn-primary rounded-pill",
	                        title: "Incluir Almacen"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-plus" },
	                        " Incluir "
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: botones.consultar,
	                        onClick: onBotones(4),
	                        className: "btn btn-sm col ml-1 mb-1 btn-info rounded-pill",
	                        title: "Consultar Almacen"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-eye" },
	                        " Consultar"
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: botones.modificar,
	                        onClick: onBotones(2),
	                        className: "btn btn-sm col ml-1 mb-1 btn-warning rounded-pill",
	                        title: "Modificar Almacen"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fa fa-edit" },
	                        " Modificar"
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: botones.eliminar,
	                        onClick: onBotones(3),
	                        className: "btn btn-sm col ml-1 mb-1 btn-danger rounded-pill",
	                        title: "Eliminar Almacen"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fa fa-trash" },
	                        " Eliminar"
	                      ),
	                      " "
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-360 row m-0 ml-auto" },
	                  habilitadoNU === true ? _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnAcepta,
	                      onClick: imprimirOrdendeCompra,
	                      disabled: txtCodigo.current.value !== "" ? false : true,
	                      className: "btn btn-sm rounded-pill col ml-1 btn-primary"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-print" },
	                      " Imprimir"
	                    )
	                  ) : "",
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnAcepta,
	                      disabled: acpt,
	                      onClick: onChangeValidar,
	                      className: "btn btn-sm col ml-1 rounded-pill btn-success"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-check-circle" },
	                      " Aceptar"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnCancela,
	                      disabled: habilitado,
	                      onClick: onBotones(6),
	                      className: "btn btn-danger col ml-1 btn-sm rounded-pill"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-window-close" },
	                      " Cancelar"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-lg-4 border-azul rounded shadow",
	                  style: { backgroundColor: "#dbeeff" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "SUBTOTAL ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtSubTotal,
	                    value: (0, _varios.formatMoneda)((totales.subtotal * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "EXENTO ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtExentoTotal,
	                    value: (0, _varios.formatMoneda)((totales.exento * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "DESCUENTO ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtDescuento,
	                    value: (0, _varios.formatMoneda)((totales.descuento * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "IVA Sobre(",
	                    (0, _varios.formatMoneda)(totales.iva.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    "%) ",
	                    monedaCambio.simbolo,
	                    ":",
	                    " ",
	                    (0, _varios.formatMoneda)((totales.sujeto * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtTotalIva,
	                    value: (0, _varios.formatMoneda)((totales.totaliva * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "TOTAL ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtTotal,
	                    value: (0, _varios.formatMoneda)((totales.total * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: catalogoCliente,
	      nomid: valparametro,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoCliente(false);
	      },
	      onHideAceptaCatalogo: onCatalogoCliente
	    }),
	    _react2.default.createElement(_catalogoProducto2.default, {
	      show: mostrar,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar(false);
	      },
	      onHideAceptaCatalogo: agregarProducto
	    }),
	    _react2.default.createElement(_catalogoOrdenesdCompra2.default, {
	      show: catalogoPresu,
	      nomid: "ordencompra",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoPresu(false);
	      },
	      onHideAceptaCatalogo: onCatalogoPresupuesto,
	      condicion: "true"
	    }),
	    _react2.default.createElement(_catalogoAgregarProveedor2.default, {
	      show: catregistrarcliente,
	      op: operacion,
	      onHideCancelar: function onHideCancelar() {
	        return setCatregistrarcliente(false);
	      },
	      onHideAceptaCatalogo: onRegistrarClientes
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = TablaOrdenCompra;

/***/ },
/* 7079 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _varios = __webpack_require__(14);
	
	var _core = __webpack_require__(19);
	
	var _useTableScrollcesar = __webpack_require__(674);
	
	var _useTableScrollcesar2 = _interopRequireDefault(_useTableScrollcesar);
	
	var _mensajes = __webpack_require__(9);
	
	var _modalIncluirFactura = __webpack_require__(7075);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var TablaRetenciones = function TablaRetenciones(props) {
	
	    var headCells = [{ label: 'Código', textAlign: 'center' }, { label: 'Descripción', textAlign: 'center' }, { label: 'Base Imponible', textAlign: 'center' }, { label: 'Alicuota', textAlign: 'center' }, { label: 'Total Retenido', textAlign: 'center' }];
	
	    var _useTableScroll = (0, _useTableScrollcesar2.default)(headCells),
	        TblContainer = _useTableScroll.TblContainer,
	        TblHead = _useTableScroll.TblHead;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        mostrar2 = _useState2[0],
	        setMostrar2 = _useState2[1];
	
	    var _useState3 = (0, _react.useState)([]),
	        _useState4 = _slicedToArray(_useState3, 2),
	        records = _useState4[0],
	        setRecords = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        datos = _useState6[0],
	        setDatos = _useState6[1];
	
	    var _useState7 = (0, _react.useState)([]),
	        _useState8 = _slicedToArray(_useState7, 2),
	        idcor = _useState8[0],
	        setIdcor = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(null),
	        _useState10 = _slicedToArray(_useState9, 2),
	        itemSelect = _useState10[0],
	        setItemSelect = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(0),
	        _useState12 = _slicedToArray(_useState11, 2),
	        opr = _useState12[0],
	        setOpr = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(null),
	        _useState14 = _slicedToArray(_useState13, 2),
	        idope = _useState14[0],
	        setIdope = _useState14[1];
	
	    var _useState15 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState16 = _slicedToArray(_useState15, 2),
	        mensaje = _useState16[0],
	        setMensaje = _useState16[1];
	
	    var _useState17 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState18 = _slicedToArray(_useState17, 2),
	        mensajesino = _useState18[0],
	        setMensajesino = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(true),
	        _useState20 = _slicedToArray(_useState19, 2),
	        activ = _useState20[0],
	        setActiv = _useState20[1];
	
	    (0, _react.useEffect)(function () {
	
	        if (props.renderiza === 0 || props.renderiza === 8) {
	            setRecords([]);
	            setDatos([]);
	            setIdcor([]);
	            setItemSelect(null);
	            setIdope(null);
	            setOpr(0);
	            setActiv(true);
	            setMostrar2(false);
	        }
	    }, [props.renderiza]);
	
	    (0, _react.useEffect)(function () {
	
	        if (props.render.length > 0) {
	
	            var datarend = [].concat(_toConsumableArray(props.render));
	            var _datos = [];
	
	            for (var i = 0; i < records.length; i++) {
	
	                if (records[i].codigo === '1') {
	
	                    var base = datarend[0].base * records[i].iva / 100;
	                    var totalr = base * records[i].alicuota / 100;
	
	                    _datos.push({
	                        codigo: records[i].codigo,
	                        descripcion: records[i].descripcion,
	                        baseimponible: base,
	                        alicuota: records[i].alicuota,
	                        total: totalr,
	                        fecha: records[i].fecha,
	                        iva: records[i].iva,
	                        totalf: datarend[0].base,
	                        montoiva: datarend[0].montoiva,
	                        unidad: records[i].unidad
	                    });
	                } else if (records[i].codigo === '2') {
	
	                    var _base = datarend[0].base * records[i].alicuota / 100;
	
	                    _datos.push({
	                        codigo: records[i].codigo,
	                        descripcion: records[i].descripcion,
	                        baseimponible: datarend[0].base,
	                        alicuota: records[i].alicuota,
	                        total: _base,
	                        fecha: records[i].fecha,
	                        iva: records[i].iva,
	                        totalf: datarend[0].base,
	                        montoiva: datarend[0].montoiva,
	                        unidad: records[i].unidad
	                    });
	                } else if (parseInt(records[i].unidad) === 3) {
	
	                    _datos.push({
	                        codigo: records[i].codigo,
	                        descripcion: records[i].descripcion,
	                        baseimponible: datarend[0].base,
	                        alicuota: records[i].alicuota,
	                        total: records[i].total,
	                        fecha: records[i].fecha,
	                        iva: records[i].iva,
	                        totalf: datarend[0].base,
	                        montoiva: datarend[0].montoiva,
	                        unidad: records[i].unidad
	                    });
	                } else if (parseInt(records[i].unidad) === 4) {
	
	                    var _base2 = datarend[0].base / records[i].alicuota;
	
	                    _datos.push({
	                        codigo: records[i].codigo,
	                        descripcion: records[i].descripcion,
	                        baseimponible: datarend[0].base,
	                        alicuota: records[i].alicuota,
	                        total: _base2,
	                        fecha: records[i].fecha,
	                        iva: records[i].iva,
	                        totalf: datarend[0].base,
	                        montoiva: datarend[0].montoiva,
	                        unidad: records[i].unidad
	                    });
	                }
	            }
	            setRecords(_datos);
	            props.baser(_datos, 4);
	        } else {
	            setRecords([]);
	        }
	    }, [props.render]);
	
	    (0, _react.useEffect)(function () {
	
	        if (props.datostabla.length > 0) {
	            setRecords(props.datostabla);
	        };
	    }, [props.datostabla]);
	
	    var datoopcal = function datoopcal(datos, op) {
	
	        if (opr === 2 && op === 6) {
	            props.baser(datos, 5);
	        };
	    };
	
	    var handleCloseSi = function handleCloseSi() {
	        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    };
	
	    var ModalFact = function ModalFact(datos) {
	        setMostrar2(false);
	        var data = [];
	
	        for (var i = 0; i < records.length; i++) {
	
	            data.push({
	                codigo: records[i].codigo,
	                descripcion: records[i].descripcion,
	                baseimponible: records[i].baseimponible,
	                alicuota: records[i].alicuota,
	                total: records[i].total,
	                fecha: records[i].fecha,
	                iva: records[i].iva,
	                totalf: records[i].totalf,
	                montoiva: records[i].montoiva,
	                unidad: records[i].unidad
	            });
	        }
	
	        if (opr === 2) {
	            data[idope] = {
	
	                codigo: datos[0].codigo,
	                descripcion: datos[0].descripcion,
	                baseimponible: datos[0].baseimponible,
	                alicuota: datos[0].alicuota,
	                total: datos[0].total,
	                fecha: datos[0].fecha,
	                iva: datos[0].iva,
	                totalf: datos[0].totalf,
	                montoiva: datos[0].montoiva,
	                unidad: datos[0].unidad
	
	            };
	            setItemSelect(null);
	        } else {
	            data.push({
	                codigo: datos[0].codigo,
	                descripcion: datos[0].descripcion,
	                baseimponible: datos[0].baseimponible,
	                alicuota: datos[0].alicuota,
	                total: datos[0].total,
	                fecha: datos[0].fecha,
	                iva: datos[0].iva,
	                totalf: datos[0].totalf,
	                montoiva: datos[0].montoiva,
	                unidad: datos[0].unidad
	            });
	        }
	        setRecords(data);
	        props.baser(data);
	    };
	
	    var eliminarFact = function eliminarFact(n, index) {
	        return function (e) {
	            e.preventDefault();
	            var data = [].concat(_toConsumableArray(records));
	            var elementos = [];
	            var paraeli = [];
	
	            for (var i = 0; i < data.length; i++) {
	
	                if (n !== data[i].codigo) {
	                    elementos.push(data[i]);
	                }
	            }
	
	            paraeli.push({
	
	                codigo: data[index].codigo,
	                descripcion: data[index].descripcion,
	                baseimponible: data[index].baseimponible,
	                alicuota: data[index].alicuota,
	                total: data[index].total,
	                fecha: data[index].fecha,
	                iva: data[index].iva,
	                totalf: data[index].totalf,
	                montoiva: data[index].montoiva,
	                unidad: data[index].unidad
	
	            });
	            setItemSelect(null);
	            setRecords(elementos);
	            props.baser(elementos, paraeli, n);
	        };
	    };
	
	    var seleccionarFila = function seleccionarFila(index, item) {
	        return function () {
	            setItemSelect(item.codigo);
	            if (item.codigo !== '') {
	                setActiv(false);
	            } else {
	                setActiv(true);
	            }
	            setIdope(index);
	        };
	    };
	
	    var gestionar = function gestionar(index, op) {
	        return function (e) {
	            e.preventDefault();
	
	            if (op === 1) {
	                var p = [].concat(_toConsumableArray(records));
	                if (p.length > 0) {
	                    setIdcor(p);
	                } else {
	                    setIdcor([]);
	                }
	                setMostrar2(true);
	                setOpr(op);
	            } else if (op === 2) {
	                setOpr(op);
	                var data = [].concat(_toConsumableArray(records));
	                var info = [];
	                info.push({
	
	                    codigo: data[index].codigo,
	                    descripcion: data[index].descripcion,
	                    baseimponible: data[index].baseimponible,
	                    alicuota: data[index].alicuota,
	                    total: data[index].total,
	                    fecha: data[index].fecha,
	                    iva: data[index].iva,
	                    totalf: data[index].totalf,
	                    montoiva: data[index].montoiva,
	                    idtiporetencion: data[index].codigo,
	                    deducible: data[index].deducible,
	                    unidad: data[index].unidad
	
	                });
	                setDatos(info);
	                setMostrar2(true);
	                props.baser(0, info, 7);
	            }
	        };
	    };
	
	    var hanCancelar = function hanCancelar() {
	        setMostrar2(false);
	        setItemSelect(null);
	        setIdope(null);
	        setActiv(true);
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: '' },
	        _react2.default.createElement(_modalIncluirFactura.ModalIncluirFactura, {
	            show: mostrar2,
	            onHideCancelar: hanCancelar,
	            onHideDatos: ModalFact,
	            data: props.datosfact,
	            datos: datos,
	            idc: idcor,
	            operacion: opr,
	            inf: datoopcal
	        }),
	        _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	            onHide: function onHide() {
	                return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	            } }),
	        _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	            onHideNo: function onHideNo() {
	                return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	            }, onHideSi: handleCloseSi }),
	        _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 row m-0' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-11' },
	                _react2.default.createElement(
	                    TblContainer,
	                    { container: { height: 120, width: '100%', overflow: 'auto', padding: '2px' } },
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        { className: 'overflow-hidden table-bordered' },
	                        records && records.map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0", cursor: props.op === 4 || props.op === 3 ? 'none' : 'pointer', background: itemSelect === item.codigo ? "lightskyblue" : "white" }, onClick: props.op === 4 || props.op === 3 ? '' : seleccionarFila(index, item) },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'align-baseline', style: { textAlign: "center", width: '30px' } },
	                                    item.codigo
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'align-baseline', style: { textAlign: "center", width: '120px' } },
	                                    item.descripcion
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'align-baseline text-right', style: { width: '80px' } },
	                                    (0, _varios.formatMoneda)(item.baseimponible.toString().replace(',', '').replace('.', ','), ',', '.', 2)
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'align-baseline text-right', style: { width: '30px' } },
	                                    (0, _varios.formatMoneda)(item.alicuota.toString().replace(',', '').replace('.', ','), ',', '.', 2)
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'align-baseline text-right', style: { width: '80px' } },
	                                    (0, _varios.formatMoneda)(item.total.toString().replace(',', '').replace('.', ','), ',', '.', 2)
	                                )
	                            );
	                        })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-1 m-auto px-0' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 mb-1 px-0' },
	                    _react2.default.createElement(
	                        'button',
	                        { onClick: gestionar(idope, 1), disabled: props.op === 0 || props.op === 8 || props.op === 1 || props.op === 4 || props.op === 3 ? true : false, className: 'btn btn-sm btn-primary rounded-pill w-100', title: 'Incluir' },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'fas fa-plus' },
	                            ' ',
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'ocultabotones' },
	                                'Incluir'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 mb-1 px-0' },
	                    _react2.default.createElement(
	                        'button',
	                        { onClick: gestionar(idope, 2), disabled: activ, className: 'btn btn-sm btn-warning rounded-pill w-100', title: 'Modificar' },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'fa fa-edit' },
	                            ' ',
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'ocultabotones' },
	                                'Modificar'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 px-0' },
	                    _react2.default.createElement(
	                        'button',
	                        { onClick: eliminarFact(itemSelect, idope), disabled: activ, className: 'btn btn-sm btn-danger rounded-pill w-100', title: 'Eliminar' },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'fa fa-trash' },
	                            ' ',
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'ocultabotones' },
	                                'Eliminar'
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	exports.default = TablaRetenciones;

/***/ },
/* 7080 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(19);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _mensajes = __webpack_require__(9);
	
	var _modalVerAuditoria = __webpack_require__(7092);
	
	var _modalRestaurarAuditoria = __webpack_require__(7091);
	
	var _reporteAuditoriaPDF = __webpack_require__(7093);
	
	var _detalleNotaEntrega = __webpack_require__(298);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/*
	 * Modulo de Auditoria.
	 *
	 * Las consultas se ejecutan con el endpoint generico de la API:
	 *   GET /api/comun/seleccionarfunciones?funcion=<funcion>&parametros=<argumentos>
	 * el cual ejecuta:  SELECT * FROM <funcion>(<argumentos>)
	 *
	 * Funciones de la base de datos
	 * (el script de la tercera esta en public/sql/auditoria3_consultar.sql):
	 *   fn_auditoria_consultar  -> tabla audit_log           (tabla, accion, desde, hasta, usuario uuid, registro text, limite)
	 *   fn_auditoria2_consultar -> tabla auditoria           (tabla, accion, desde, hasta, usuario bigint, idtabla bigint, limite)
	 *   fn_auditoria3_consultar -> tabla auditadataeliminada (documento, status, desde, hasta, usuario bigint, idauditoria bigint, limite)
	 *
	 * Los filtros se envian siempre en el mismo orden (ver armarParametros); cada
	 * funcion los recibe con el significado que le corresponde.
	 */
	var FUNCION_LOG = "fn_auditoria_consultar";
	var FUNCION_HISTORICA = "fn_auditoria2_consultar";
	var FUNCION_ELIMINADOS = "fn_auditoria3_consultar";
	
	/* Funcion de consulta que corresponde a cada pestaña */
	var FUNCIONES = {
	  log: FUNCION_LOG,
	  historica: FUNCION_HISTORICA,
	  eliminados: FUNCION_ELIMINADOS
	};
	
	/* Funcion que devuelve las tablas de la base de datos (filtro TABLA) */
	var FUNCION_TABLAS = "fn_auditoria_tablas_consultar";
	
	/*
	 * Funcion que devuelve la data completa (cabecera + detalle) de una nota de
	 * entrega desde las tablas de respaldo (notaentregarespaldo +
	 * notaentregadetallerespaldo). Se usa en la pestaña "Datos Eliminados" para
	 * comparar el registro de auditoria con su respaldo
	 * (ver public/sql/fn_notaentrega_respaldo_consultar.sql).
	 */
	var FUNCION_RESPALDO_NOTA = "fn_notaentrega_respaldo_consultar";
	
	/*
	 * Grupos de documento junto con su tabla de detalle. Al elegirlos se consultan
	 * las dos tablas a la vez (las funciones de consulta aceptan varias tablas
	 * separadas por coma). Solo se muestran los grupos cuyas tablas existan en la
	 * base de datos.
	 */
	var GRUPOS_TABLAS = [{
	  label: "NOTAS DE ENTREGA (+ detalle)",
	  tablas: ["notaentrega", "notaentregadetalle"]
	}, {
	  label: "PEDIDOS (+ detalle)",
	  tablas: ["pedido", "pedidodetalle"]
	}, {
	  label: "OPERACIONES DE INVENTARIO (+ detalle)",
	  tablas: ["operacioninventario", "operacioninventariodetalle"]
	}];
	
	/*
	 * Tablas que quedan seleccionadas por defecto en el filtro TABLA: factura de
	 * compra junto con su detalle.
	 */
	var TABLA_POR_DEFECTO = {
	  label: "FACTURAS DE COMPRA (+ detalle)",
	  tablas: ["facturacompra", "facturacompra_detalle"]
	};
	
	/* Status de los documentos de la pestaña "Datos Eliminados" */
	var ESTADOS_DOCUMENTO = [{ value: "0", label: "PENDIENTE" }, { value: "1", label: "PROCESADO" }, { value: "4", label: "ANULADO" }];
	
	/* Icono y titulo del detalle/reporte segun la accion del registro */
	var ACCIONES_ICONO = {
	  INSERT: { icono: "fas fa-plus-circle", titulo: "Registro insertado" },
	  UPDATE: { icono: "fas fa-edit", titulo: "Registro modificado" },
	  DELETE: { icono: "fas fa-trash-alt", titulo: "Registro eliminado" }
	};
	
	/*
	 * Filtros que cada pestaña NO muestra; su argumento se envia como NULL a la
	 * funcion de consulta:
	 *   - "Auditoría LOG":    no muestra USUARIO
	 *   - "Datos Eliminados": no muestra REG. AUDITORÍA
	 * (la pestaña "Auditoría" muestra todos los filtros)
	 */
	var FILTROS_OCULTOS = {
	  log: { usuario: true },
	  eliminados: { registro: true }
	};
	
	var ACCIONES = ["INSERT", "UPDATE", "DELETE"];
	
	var TABS = [{ key: "log", label: "Auditoría LOG", icono: "fas fa-history" }, { key: "historica", label: "Auditoría", icono: "fas fa-clipboard-list" }, { key: "eliminados", label: "Datos Eliminados", icono: "fas fa-trash-alt" }];
	
	var ESTILO_CABECERA = {
	  backgroundColor: "rgba(5, 81, 130, 1)",
	  color: "#ffffff",
	  textAlign: "center"
	};
	
	var cabecera = function cabecera(id, label) {
	  return Object.assign({}, ESTILO_CABECERA, { id: id, label: label });
	};
	
	var headCellsLog = [cabecera("1", "FECHA"), cabecera("2", "ACCIÓN"), cabecera("3", "TABLA"), cabecera("4", "REGISTRO"), cabecera("5", "USUARIO"), cabecera("6", "CAMPOS CAMBIADOS"), cabecera("opciones", "DETALLE")];
	
	var headCellsHistorica = [cabecera("1", "FECHA"), cabecera("2", "ACCIÓN"), cabecera("3", "TABLA"), cabecera("4", "REGISTRO"), cabecera("5", "USUARIO"), cabecera("6", "CONCEPTO"), cabecera("opciones", "DETALLE")];
	
	/* Columnas de la pestaña "Datos Eliminados" (tabla auditadataeliminada) */
	var headCellsEliminados = [cabecera("1", "FECHA"), cabecera("2", "DOCUMENTO"), cabecera("3", "STATUS"), cabecera("4", "USUARIO"), cabecera("5", "REG. AUDITORÍA"), cabecera("opciones", "DETALLE")];
	
	function Auditoria() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	
	  var fechaSistema = (0, _moment2.default)(JSON.parse(sessionStorage.getItem("fechasistema")) || undefined);
	
	  var _useState = (0, _react.useState)("log"),
	      _useState2 = _slicedToArray(_useState, 2),
	      tab = _useState2[0],
	      setTab = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      records = _useState6[0],
	      setRecords = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      tablas = _useState8[0],
	      setTablas = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mostrarDetalle = _useState10[0],
	      setMostrarDetalle = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    campos: [],
	    cambios: [],
	    bloques: []
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      detalle = _useState12[0],
	      setDetalle = _useState12[1];
	  /*
	   * Columnas de comparacion (registro de auditoria vs. respaldo) que se muestran
	   * lado a lado en el modal/reporte. Solo aplica a "Datos Eliminados" cuando el
	   * documento es una nota de entrega con datos en las tablas de respaldo.
	   */
	
	
	  var _useState13 = (0, _react.useState)(null),
	      _useState14 = _slicedToArray(_useState13, 2),
	      comparacion = _useState14[0],
	      setComparacion = _useState14[1];
	  /*
	   * Registros eliminados (ACCIÓN = DELETE) con los que se arma el INSERT de
	   * restauracion (ver modalRestaurarAuditoria).
	   */
	
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mostrarRestaurar = _useState16[0],
	      setMostrarRestaurar = _useState16[1];
	
	  var _useState17 = (0, _react.useState)([]),
	      _useState18 = _slicedToArray(_useState17, 2),
	      registrosRestaurar = _useState18[0],
	      setRegistrosRestaurar = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({
	    tabla: TABLA_POR_DEFECTO.tablas.join(","),
	    accion: "",
	    desde: (0, _moment2.default)(fechaSistema).startOf("day").format("YYYY-MM-DD"),
	    hasta: (0, _moment2.default)(fechaSistema).endOf("day").format("YYYY-MM-DD"),
	    usuario: "",
	    registro: "",
	    limite: "1000"
	  }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      filtros = _useState20[0],
	      setFiltros = _useState20[1];
	
	  var _useState21 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState22 = _slicedToArray(_useState21, 2),
	      mensaje = _useState22[0],
	      setMensaje = _useState22[1];
	
	  var _useState23 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState24 = _slicedToArray(_useState23, 2),
	      filterFn = _useState24[0],
	      setFilterFn = _useState24[1];
	
	  /* Cabeceras de la tabla segun la pestaña activa */
	
	
	  var headCells = tab === "log" ? headCellsLog : tab === "historica" ? headCellsHistorica : headCellsEliminados;
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting,
	      TblPagination = _useTable.TblPagination;
	
	  /* Fecha del registro (fecha_ve = fecha de Venezuela) */
	
	
	  var formatoFecha = function formatoFecha(item) {
	    return item && item.fecha_ve ? (0, _moment2.default)(item.fecha_ve).format("DD-MM-YYYY hh:mm A") : "";
	  };
	
	  /* Quita comillas simples para no inyectar argumentos dentro de la funcion */
	  var limpiar = function limpiar(valor) {
	    return String(valor === null || valor === undefined ? "" : valor).replace(/'/g, "").trim();
	  };
	
	  /* Los argumentos se envian como literales SQL: NULL o 'texto' */
	  var argumentoTexto = function argumentoTexto(valor) {
	    var limpio = limpiar(valor);
	    return limpio === "" ? "NULL" : "'" + limpio + "'";
	  };
	
	  var argumentoNumero = function argumentoNumero(valor, porDefecto) {
	    var limpio = limpiar(valor).replace(/[^0-9]/g, "");
	    return limpio === "" ? porDefecto : limpio;
	  };
	
	  /*
	   * Filtros que se envian a la funcion de consulta, siempre en este orden:
	   *   1) tabla     -> TABLA (audit_log, auditoria)   | DOCUMENTO (auditadataeliminada)
	   *   2) accion    -> ACCIÓN (audit_log, auditoria)  | STATUS (auditadataeliminada)
	   *   3) desde        4) hasta        5) usuario
	   *   6) registro  -> texto a buscar en el registro de auditoria (nro. de
	   *                   documento o RIF). En audit_log se compara contra
	   *                   registro_id, valor_anterior y valor_nuevo; en la tabla
	   *                   auditoria contra nombretabla, concepto, usuario, idtabla
	   *                   y data. La pestaña "Datos Eliminados" no lo envia.
	   *   7) limite    (numerico)
	   * Los seis primeros van como literales SQL ('texto' o NULL). El argumento de
	   * los filtros que la pestaña no muestra se envia como NULL (FILTROS_OCULTOS).
	   */
	  var armarParametros = function armarParametros(f, tabUsar) {
	    var ocultos = FILTROS_OCULTOS[tabUsar || tab] || {};
	    var valor = function valor(clave) {
	      return ocultos[clave] ? "" : f[clave];
	    };
	
	    return [argumentoTexto(valor("tabla")), argumentoTexto(valor("accion")), argumentoTexto(valor("desde")), argumentoTexto(valor("hasta")), argumentoTexto(valor("usuario")), argumentoTexto(valor("registro")), argumentoNumero(valor("limite"), "1000")].join(",");
	  };
	
	  /*
	   * Tablas de la base de datos para el filtro TABLA.
	   * Si la funcion no existe en la base de datos la lista queda vacia y el
	   * filtro se muestra como caja de texto (ver el JSX del filtro).
	   */
	  var seleccionarTablas = function seleccionarTablas() {
	    var endpoint = op.conexion + "/api/comun/seleccionarfunciones?funcion=" + FUNCION_TABLAS + "&parametros=false";
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200 && Array.isArray(response.data)) {
	        setTablas(response.data.map(function (item) {
	          return item.tabla;
	        }).filter(function (tabla) {
	          return tabla !== null && tabla !== undefined;
	        }));
	      }
	    }).catch(function () {
	      setTablas([]);
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros(filtrosUsar, tabUsar) {
	    var t = tabUsar || tab;
	    var f = filtrosUsar || filtros;
	    var funcion = FUNCIONES[t];
	    var endpoint = op.conexion + "/api/comun/seleccionarfunciones?funcion=" + funcion + "&parametros=" + encodeURIComponent(armarParametros(f, t));
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var filas = Array.isArray(response.data) ? response.data : [];
	        setRecords(filas);
	
	        /*
	         * Si se busco un numero/RIF y no hay resultados se avisa, porque lo
	         * mas comun es que el rango de fechas o la tabla elegida no incluyan
	         * el movimiento que se busca.
	         */
	        var buscado = String(t === "eliminados" ? f.tabla : f.registro).trim();
	
	        if (filas.length === 0 && buscado !== "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Sin resultados",
	            texto: "No se encontró «" + buscado + "» con los filtros actuales. Revise que el rango DESDE/HASTA " + "incluya la fecha del movimiento y que la tabla seleccionada " + "sea la correcta (o elija TODAS).",
	            icono: "informacion"
	          });
	        }
	      }
	    }).catch(function (error) {
	      setRecords([]);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response === undefined ? "Error de Conexion" : error.response.data.message,
	        icono: "error"
	      });
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var cambiarFiltro = function cambiarFiltro(e) {
	    var _e$target = e.target,
	        name = _e$target.name,
	        value = _e$target.value;
	
	    setFiltros(function (anteriores) {
	      return Object.assign({}, anteriores, _defineProperty({}, name, value));
	    });
	  };
	
	  /*
	   * Los dos primeros filtros se comparten entre pestañas:
	   *   - "Datos Eliminados": 1) numero de documento (texto libre), 2) status
	   *   - las otras dos:      1) TABLA (select de la BD),        2) ACCIÓN (select)
	   * Devuelve los filtros limpios para la pestaña indicada, de forma que al
	   * cambiar de pestaña no se arrastre un valor que no aplica al destino.
	   */
	  var filtrosDeTab = function filtrosDeTab(key) {
	    var filtrosTab = Object.assign({}, filtros);
	
	    if (key === "eliminados") {
	      if (tablas.indexOf(filtrosTab.tabla) >= 0 || filtrosTab.tabla.indexOf(",") >= 0) {
	        filtrosTab.tabla = "";
	      }
	      if (filtrosTab.accion !== "" && isNaN(Number(filtrosTab.accion))) {
	        filtrosTab.accion = "";
	      }
	    } else {
	      if (key === "historica") {
	        /* La pestaña "Auditoría" solo consulta la factura de compra + detalle */
	        filtrosTab.tabla = TABLA_POR_DEFECTO.tablas.join(",");
	      } else if (tablas.length > 0 && filtrosTab.tabla !== "" && tablas.indexOf(filtrosTab.tabla) < 0 && filtrosTab.tabla.indexOf(",") < 0) {
	        filtrosTab.tabla = "";
	      }
	      if (filtrosTab.accion !== "" && ACCIONES.indexOf(filtrosTab.accion) < 0) {
	        filtrosTab.accion = "";
	      }
	    }
	
	    return filtrosTab;
	  };
	
	  var cambiarTab = function cambiarTab(key) {
	    setTab(key);
	    setRecords([]);
	    setComparacion(null);
	    setFilterFn({
	      fn: function fn(items) {
	        return items;
	      }
	    });
	
	    var filtrosTab = filtrosDeTab(key);
	    if (filtrosTab.tabla !== filtros.tabla || filtrosTab.accion !== filtros.accion) {
	      setFiltros(filtrosTab);
	    }
	
	    seleccionarRegistros(filtrosTab, key);
	  };
	
	  var handleSearch = function handleSearch(e) {
	    var valor = e.target.value.toUpperCase();
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (valor === "") {
	          return items;
	        }
	        return items.filter(function (x) {
	          var texto = [x.accion, x.tabla_afectada, x.nombretabla, x.usuario, x.usuario_id, x.concepto, x.registro_id, x.idtabla, x.idauditoria, x.caja, x.numdocumento, x.status, x.hora, (x.campos_cambiados || []).join(" ")].join(" ").toUpperCase();
	          return texto.includes(valor);
	        });
	      }
	    });
	  };
	
	  var texto = function texto(valor) {
	    return valor === null || valor === undefined ? "" : String(valor);
	  };
	
	  var esObjeto = function esObjeto(valor) {
	    return valor !== null && (typeof valor === "undefined" ? "undefined" : _typeof(valor)) === "object" && !Array.isArray(valor);
	  };
	
	  /*
	   * Los registros de auditoria pueden venir envueltos en el nombre de la tabla
	   * o en el tipo de dato, por ejemplo:
	   *   { data_nueva: { facturacompra: { numfactura: '8415332552', ... } } }
	   *   { facturacompra: { numfactura: '8415332552', ... } }
	   * Esta funcion quita esas envolturas (hasta 3 niveles) para poder comparar
	   * los campos reales de la fila.
	   */
	  var desenvolver = function desenvolver(valor, nivel) {
	    var nivelActual = nivel || 0;
	
	    if (nivelActual >= 3 || !esObjeto(valor)) {
	      return valor;
	    }
	
	    var claves = Object.keys(valor);
	    if (claves.length !== 1) {
	      return valor;
	    }
	
	    var interno = valor[claves[0]];
	    return esObjeto(interno) ? desenvolver(interno, nivelActual + 1) : valor;
	  };
	
	  /* Campos modificados del registro (valor anterior contra valor nuevo) */
	  var cambiosDe = function cambiosDe(item) {
	    var anterior = desenvolver(item.valor_anterior);
	    var nuevo = desenvolver(item.valor_nuevo);
	
	    if (!esObjeto(anterior) && !esObjeto(nuevo)) {
	      return [];
	    }
	
	    var estaEn = function estaEn(origen, clave) {
	      return esObjeto(origen) && clave in origen;
	    };
	
	    /* claves que informa la funcion, descartando las de envoltura */
	    var claves = (Array.isArray(item.campos_cambiados) ? item.campos_cambiados : []).filter(function (clave) {
	      return estaEn(anterior, clave) || estaEn(nuevo, clave);
	    });
	
	    if (claves.length === 0) {
	      var unicas = {};
	      [anterior, nuevo].forEach(function (valor) {
	        if (esObjeto(valor)) {
	          Object.keys(valor).forEach(function (clave) {
	            unicas[clave] = true;
	          });
	        }
	      });
	
	      /* sin lista de la funcion, se muestran solo los campos que cambiaron */
	      claves = Object.keys(unicas).filter(function (clave) {
	        return JSON.stringify(esObjeto(anterior) ? anterior[clave] : undefined) !== JSON.stringify(esObjeto(nuevo) ? nuevo[clave] : undefined);
	      });
	    }
	
	    return claves.map(function (campo) {
	      return {
	        campo: campo,
	        anterior: esObjeto(anterior) ? anterior[campo] : undefined,
	        nuevo: esObjeto(nuevo) ? nuevo[campo] : undefined
	      };
	    });
	  };
	
	  /*
	   * Arma el detalle del registro (modal y reporte) segun la pestaña activa:
	   * titulo, subtitulo, icono, datos, campos modificados y campos JSON.
	   */
	  var detalleDe = function detalleDe(item) {
	    var fecha = formatoFecha(item);
	    var accion = texto(item.accion).toUpperCase();
	    var estilo = ACCIONES_ICONO[accion] || { icono: "fas fa-history", titulo: "Registro de auditoría" };
	
	    if (tab === "log") {
	      var cambios = cambiosDe(item);
	
	      return {
	        registro: item,
	        titulo: estilo.titulo + " en " + texto(item.tabla_afectada),
	        subtitulo: "audit_log · " + fecha,
	        icono: estilo.icono,
	        campos: [{ label: "Fecha", valor: fecha }, { label: "Acción", valor: item.accion }, { label: "Tabla", valor: item.tabla_afectada }, { label: "Registro", valor: item.registro_id }, { label: "Usuario", valor: item.usuario_id }, {
	          label: "Campos cambiados",
	          valor: cambios.map(function (cambio) {
	            return cambio.campo;
	          }).join(", ")
	        }],
	        cambios: cambios,
	        bloques: [{ label: "Valor anterior", valor: item.valor_anterior }, { label: "Valor nuevo", valor: item.valor_nuevo }]
	      };
	    }
	
	    if (tab === "historica") {
	      return {
	        registro: item,
	        titulo: "Registro en " + texto(item.nombretabla),
	        subtitulo: "auditoria · " + fecha,
	        icono: estilo.icono,
	        campos: [{ label: "Fecha", valor: fecha }, { label: "Acción", valor: item.accion }, { label: "Tabla", valor: item.nombretabla }, { label: "Registro", valor: item.idtabla }, { label: "Usuario", valor: item.usuario }, { label: "Caja", valor: item.caja }, { label: "Concepto", valor: item.concepto }],
	        cambios: [],
	        bloques: [{ label: "Datos", valor: item.data }]
	      };
	    }
	
	    return {
	      registro: item,
	      titulo: "Documento eliminado " + texto(item.numdocumento),
	      subtitulo: "auditadataeliminada · " + fecha,
	      icono: "fas fa-trash-alt",
	      campos: [{ label: "Fecha", valor: fecha }, { label: "Hora", valor: item.hora }, { label: "Documento", valor: item.numdocumento }, { label: "Status", valor: etiquetaStatus(item.status) }, { label: "Usuario", valor: item.idusuario }, { label: "Reg. auditoría", valor: item.idauditoria }],
	      cambios: [],
	      bloques: []
	    };
	  };
	
	  /*
	   * Consulta la data completa de una nota de entrega en las tablas de respaldo
	   * (notaentregarespaldo + notaentregadetallerespaldo) por su numero de
	   * documento. Devuelve una promesa con el arreglo de coincidencias (puede
	   * venir vacio si el documento no es una nota de entrega o no tiene respaldo).
	   */
	  var consultarRespaldoNota = function consultarRespaldoNota(numdocumento) {
	    var documento = limpiar(numdocumento);
	    if (documento === "") {
	      return Promise.resolve([]);
	    }
	
	    var endpoint = op.conexion + "/api/comun/seleccionarfunciones?funcion=" + FUNCION_RESPALDO_NOTA + "&parametros=" + encodeURIComponent(argumentoTexto(documento));
	
	    return _axios2.default.get(endpoint, { headers: { "x-access-token": "" + token } }).then(function (response) {
	      return response.status === 200 && Array.isArray(response.data) ? response.data : [];
	    }).catch(function () {
	      return [];
	    });
	  };
	
	  /*
	   * Arma la comparacion de un documento eliminado: el primer elemento es el
	   * registro de auditoria (tipo "auditoria") y los siguientes son cada
	   * coincidencia del respaldo de la nota de entrega (tipo "notaentrega", con su
	   * cabecera `nota` y sus renglones `detalle`). El modal y el reporte dibujan
	   * el ticket con esos renglones. La funcion SQL ya devuelve una sola fila por
	   * idnotaentrega y una linea por producto, de modo que cada nota se muestra una
	   * vez con sus productos (sin repetirlos).
	   * Devuelve null si no hay respaldo que comparar.
	   */
	  var comparacionDe = function comparacionDe(item, filas) {
	    if (!Array.isArray(filas) || filas.length === 0) {
	      return null;
	    }
	
	    var columnas = [{
	      tipo: "auditoria",
	      titulo: "Documento eliminado (auditoría)",
	      subtitulo: "auditadataeliminada",
	      icono: "fas fa-trash-alt",
	      campos: [{ label: "Fecha", valor: formatoFecha(item) }, { label: "Hora", valor: item.hora }, { label: "Documento", valor: item.numdocumento }, { label: "Status", valor: etiquetaStatus(item.status) }, { label: "Usuario", valor: item.idusuario }, { label: "Reg. auditoría", valor: item.idauditoria }],
	      bloques: []
	    }];
	
	    filas.forEach(function (fila, indice) {
	      var numero = texto(fila.numnotaentrega).trim();
	      columnas.push({
	        tipo: "notaentrega",
	        titulo: "Nota de entrega (respaldo " + (indice + 1) + ")",
	        subtitulo: "notaentregarespaldo" + (numero === "" ? "" : " · N° " + numero),
	        icono: "fas fa-file-invoice",
	        nota: fila.nota,
	        campos: (0, _detalleNotaEntrega.camposCabeceraNota)(fila.nota),
	        detalle: fila.detalle
	      });
	    });
	
	    return columnas;
	  };
	
	  var hanVer = function hanVer(item) {
	    return function (e) {
	      e.preventDefault();
	      setDetalle(detalleDe(item));
	      setComparacion(null);
	      setMostrarDetalle(true);
	
	      /* En "Datos Eliminados" se busca el respaldo del documento para comparar */
	      if (tab === "eliminados") {
	        consultarRespaldoNota(item.numdocumento).then(function (filas) {
	          return setComparacion(comparacionDe(item, filas));
	        });
	      }
	    };
	  };
	
	  /* Datos de la empresa para el encabezado del reporte */
	  var metadatosReporte = function metadatosReporte() {
	    var logo = JSON.parse(sessionStorage.getItem("logo"));
	    return {
	      empresa: JSON.parse(sessionStorage.getItem("organizacion")),
	      rif: JSON.parse(sessionStorage.getItem("riforganizacion")),
	      usuario: JSON.parse(sessionStorage.getItem("login")),
	      urlLogo: logo ? op.conexion + "/imagen?img=athos/organizacion/" + logo : ""
	    };
	  };
	
	  /*
	   * Genera y muestra el reporte (un registro = detalle, varios = listado).
	   * La ventana se abre en el clic para que el navegador no la bloquee y el
	   * reporte se imprima/guarde desde el visor de PDF del navegador.
	   */
	  var imprimirReporte = function imprimirReporte(registros, detalleRegistro, ventanaAbierta, comparacionUsar) {
	    var ventana = ventanaAbierta || (0, _reporteAuditoriaPDF.abrirVentanaReporte)();
	    setActivate(true);
	    (0, _reporteAuditoriaPDF.mostrarReporteAuditoria)({
	      tipo: tab,
	      registros: registros,
	      filtros: filtros,
	      detalle: detalleRegistro,
	      comparacion: comparacionUsar || null,
	      metadatos: metadatosReporte()
	    }, ventana).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.message,
	        icono: "error"
	      });
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var hanImprimir = function hanImprimir(item) {
	    return function (e) {
	      e.preventDefault();
	      var ventana = (0, _reporteAuditoriaPDF.abrirVentanaReporte)();
	      var detalleItem = detalleDe(item);
	
	      /* Las otras pestañas no tienen respaldo con que comparar */
	      if (tab !== "eliminados") {
	        imprimirReporte([item], detalleItem, ventana, null);
	        return;
	      }
	
	      consultarRespaldoNota(item.numdocumento).then(function (filas) {
	        return imprimirReporte([item], detalleItem, ventana, comparacionDe(item, filas));
	      });
	    };
	  };
	
	  /* Imprime el listado que se esta viendo (ya filtrado por el buscador) */
	  var imprimirListado = function imprimirListado() {
	    var lista = filterFn.fn(records);
	    if (lista.length === 0) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "¡ No hay registros para imprimir !",
	        icono: "informacion"
	      });
	      return;
	    }
	    imprimirReporte(lista, null);
	  };
	
	  /*
	   * Abre el modal para restaurar los registros eliminados del listado actual
	   * (filtro ACCIÓN = DELETE). El modal muestra el valor anterior de cada uno y
	   * arma el INSERT para volver a cargarlos en la tabla afectada.
	   */
	  var restaurarEliminados = function restaurarEliminados() {
	    var lista = filterFn.fn(records).filter(function (item) {
	      return texto(item.accion).toUpperCase() === "DELETE";
	    });
	
	    if (lista.length === 0) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "¡ No hay registros eliminados para restaurar !",
	        icono: "informacion"
	      });
	      return;
	    }
	
	    setRegistrosRestaurar(lista);
	    setMostrarRestaurar(true);
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarTablas();
	    seleccionarRegistros();
	  }, []);
	
	  /*
	   * Grupos de documento + detalle. El de factura de compra va siempre primero
	   * porque es el que queda seleccionado por defecto; los demás se muestran solo
	   * si sus tablas existen en la base de datos.
	   */
	  var gruposTablas = [TABLA_POR_DEFECTO].concat(GRUPOS_TABLAS.map(function (grupo) {
	    return {
	      label: grupo.label,
	      tablas: grupo.tablas.filter(function (tabla) {
	        return tablas.indexOf(tabla) >= 0;
	      })
	    };
	  }).filter(function (grupo) {
	    return grupo.tablas.length > 0;
	  }));
	
	  /*
	   * Opciones del select TABLA. La pestaña "Auditoría" solo permite la factura de
	   * compra + su detalle; en "Auditoría LOG" se muestran los grupos y todas las
	   * tablas de la base de datos.
	   */
	  var gruposFiltro = tab === "historica" ? [TABLA_POR_DEFECTO] : gruposTablas;
	  var tablasFiltro = tab === "historica" ? [] : tablas;
	
	  /* Etiquetas de los filtros que cambian segun la pestaña */
	  var etiquetaFiltro1 = tab === "eliminados" ? "DOCUMENTO:" : "TABLA:";
	  var marcadorFiltro1 = tab === "eliminados" ? "numdocumento" : "nombretabla";
	  var etiquetaFiltro2 = tab === "eliminados" ? "STATUS:" : "ACCIÓN:";
	
	  /* Etiqueta del status: 0 = PENDIENTE, 1 = PROCESADO, 4 = ANULADO */
	  var etiquetaStatus = function etiquetaStatus(valor) {
	    var estado = ESTADOS_DOCUMENTO.filter(function (item) {
	      return item.value === String(valor);
	    })[0];
	    return estado ? estado.label : valor;
	  };
	
	  /*
	   * Valores de cada fila segun la pestaña. Los filtros se envian por posicion
	   * a la funcion de consulta (ver armarParametros).
	   */
	  var celdasFila = function celdasFila(item) {
	    if (tab === "log") {
	      return [formatoFecha(item), item.accion, item.tabla_afectada, item.registro_id, item.usuario_id, cambiosDe(item).map(function (cambio) {
	        return cambio.campo;
	      }).join(", ")];
	    }
	    if (tab === "historica") {
	      return [formatoFecha(item), item.accion, item.nombretabla, item.idtabla, item.usuario, item.concepto];
	    }
	    return [formatoFecha(item), item.numdocumento, etiquetaStatus(item.status), item.idusuario, item.idauditoria];
	  };
	
	  var estiloCelda = {
	    textAlign: "center",
	    padding: "8px 4px",
	    fontSize: "12px"
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "container-fluid rounded" },
	    _react2.default.createElement(
	      "div",
	      { className: "container-fluid" },
	      _react2.default.createElement(
	        "div",
	        { className: "card" },
	        _react2.default.createElement(
	          _semanticUiReact.Dimmer,
	          { active: activate, inverted: true },
	          _react2.default.createElement(
	            _semanticUiReact.Loader,
	            { inverted: true },
	            "cargando..."
	          )
	        ),
	        _react2.default.createElement(_modalVerAuditoria.VerAuditoria, {
	          show: mostrarDetalle,
	          datos: detalle.registro,
	          titulo: detalle.titulo,
	          subtitulo: detalle.subtitulo,
	          icono: detalle.icono,
	          campos: detalle.campos,
	          cambios: detalle.cambios,
	          bloques: detalle.bloques,
	          comparacion: comparacion,
	          onImprimir: function onImprimir() {
	            return imprimirReporte([detalle.registro], detalle, null, comparacion);
	          },
	          onHideCancela: function onHideCancela() {
	            return setMostrarDetalle(false);
	          }
	        }),
	        _react2.default.createElement(_modalRestaurarAuditoria.RestaurarAuditoria, {
	          show: mostrarRestaurar,
	          registros: registrosRestaurar,
	          onHideCancela: function onHideCancela() {
	            return setMostrarRestaurar(false);
	          }
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "content" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 row m-0 pt-3" },
	                _react2.default.createElement(
	                  "ul",
	                  {
	                    className: "nav nav-tabs mb-2",
	                    id: "tabsAuditoria",
	                    role: "tablist"
	                  },
	                  TABS.map(function (t) {
	                    return _react2.default.createElement(
	                      "li",
	                      { className: "nav-item", key: t.key },
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          className: "nav-link py-2 " + (tab === t.key ? "active" : ""),
	                          onClick: function onClick() {
	                            return cambiarTab(t.key);
	                          }
	                        },
	                        _react2.default.createElement("i", { className: t.icono + " me-2" }),
	                        t.label
	                      )
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 row m-0 py-2" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-4 px-1 mb-2" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        etiquetaFiltro1
	                      ),
	                      tablas.length > 0 && tab !== "eliminados" ? _react2.default.createElement(
	                        "select",
	                        {
	                          name: "tabla",
	                          value: filtros.tabla,
	                          onChange: cambiarFiltro,
	                          className: "form-select form-select-sm text-uppercase"
	                        },
	                        tab !== "historica" && _react2.default.createElement(
	                          "option",
	                          { value: "" },
	                          "TODAS"
	                        ),
	                        _react2.default.createElement(
	                          "optgroup",
	                          { label: "Documento + detalle" },
	                          gruposFiltro.map(function (grupo, index) {
	                            return _react2.default.createElement(
	                              "option",
	                              {
	                                value: grupo.tablas.join(","),
	                                key: index
	                              },
	                              grupo.label
	                            );
	                          })
	                        ),
	                        tablasFiltro.length > 0 && _react2.default.createElement(
	                          "optgroup",
	                          { label: "Tablas" },
	                          tablasFiltro.map(function (tabla, index) {
	                            return _react2.default.createElement(
	                              "option",
	                              { value: tabla, key: index },
	                              tabla
	                            );
	                          })
	                        )
	                      ) : _react2.default.createElement("input", {
	                        autoComplete: "off",
	                        type: "text",
	                        name: "tabla",
	                        value: filtros.tabla,
	                        onChange: cambiarFiltro,
	                        placeholder: marcadorFiltro1,
	                        className: "form-control text-uppercase",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm"
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-4 px-1 mb-2" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        etiquetaFiltro2
	                      ),
	                      tab === "eliminados" ? _react2.default.createElement(
	                        "select",
	                        {
	                          name: "accion",
	                          value: filtros.accion,
	                          onChange: cambiarFiltro,
	                          className: "form-select form-select-sm text-uppercase"
	                        },
	                        _react2.default.createElement(
	                          "option",
	                          { value: "" },
	                          "TODOS"
	                        ),
	                        ESTADOS_DOCUMENTO.map(function (estado, index) {
	                          return _react2.default.createElement(
	                            "option",
	                            { value: estado.value, key: index },
	                            estado.label
	                          );
	                        })
	                      ) : _react2.default.createElement(
	                        "select",
	                        {
	                          name: "accion",
	                          value: filtros.accion,
	                          onChange: cambiarFiltro,
	                          className: "form-select form-select-sm text-uppercase"
	                        },
	                        _react2.default.createElement(
	                          "option",
	                          { value: "" },
	                          "TODAS"
	                        ),
	                        ACCIONES.map(function (accion, index) {
	                          return _react2.default.createElement(
	                            "option",
	                            { value: accion, key: index },
	                            accion
	                          );
	                        })
	                      )
	                    )
	                  ),
	                  tab !== "eliminados" && _react2.default.createElement(
	                    "div",
	                    { className: "col-md-4 px-1 mb-2" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        "N\xDAMERO / RIF:"
	                      ),
	                      _react2.default.createElement("input", {
	                        autoComplete: "off",
	                        type: "text",
	                        name: "registro",
	                        value: filtros.registro,
	                        onChange: cambiarFiltro,
	                        onKeyDown: function onKeyDown(e) {
	                          if (e.key === "Enter") seleccionarRegistros();
	                        },
	                        placeholder: "nro. doc. o RIF",
	                        title: "Busca este valor dentro del registro de auditor\xEDa: numero de nota de entrega, factura de compra, pedido, registro de pago o RIF del agente/persona",
	                        className: "form-control",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm"
	                      })
	                    )
	                  ),
	                  tab !== "log" && _react2.default.createElement(
	                    "div",
	                    { className: "col-md-4 px-1 mb-2" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        "USUARIO:"
	                      ),
	                      _react2.default.createElement("input", {
	                        autoComplete: "off",
	                        type: "text",
	                        name: "usuario",
	                        value: filtros.usuario,
	                        onChange: cambiarFiltro,
	                        placeholder: "id del usuario",
	                        className: "form-control",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm"
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-4 px-1 mb-2" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        "DESDE:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "date",
	                        name: "desde",
	                        value: filtros.desde,
	                        onChange: cambiarFiltro,
	                        className: "form-control",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm"
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-4 px-1 mb-2" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        "HASTA:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "date",
	                        name: "hasta",
	                        value: filtros.hasta,
	                        onChange: cambiarFiltro,
	                        className: "form-control",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm"
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-3 px-1 mb-2" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        "L\xCDMITE:"
	                      ),
	                      _react2.default.createElement("input", {
	                        autoComplete: "off",
	                        type: "number",
	                        min: "1",
	                        name: "limite",
	                        value: filtros.limite,
	                        onChange: cambiarFiltro,
	                        className: "form-control text-end",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm"
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-3 px-1 mb-2 d-flex align-items-center" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        onClick: function onClick() {
	                          return seleccionarRegistros();
	                        },
	                        disabled: activate,
	                        className: "btn btn-sm btn-primary rounded-pill px-4"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-search" },
	                        " CONSULTAR"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        onClick: imprimirListado,
	                        disabled: activate,
	                        className: "btn btn-sm btn-outline-secondary rounded-pill px-3 ms-1",
	                        title: "Imprimir el listado de registros consultados"
	                      },
	                      _react2.default.createElement("i", { className: "fas fa-print" })
	                    ),
	                    filtros.accion === "DELETE" && _react2.default.createElement(
	                      "button",
	                      {
	                        onClick: restaurarEliminados,
	                        disabled: activate,
	                        className: "btn btn-sm btn-outline-danger rounded-pill px-3 ms-1",
	                        title: "Armar el INSERT de los registros eliminados (valor anterior)"
	                      },
	                      _react2.default.createElement("i", { className: "fas fa-trash-restore" })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-4 px-1 mb-2" },
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control form-control-sm rounded-pill",
	                      onChange: handleSearch,
	                      placeholder: "Buscar"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-2 px-1 mb-2 d-flex align-items-center justify-content-end" },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "badge bg-secondary" },
	                      "Registros: ",
	                      records.length
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12" },
	                  _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                      _core.TableBody,
	                      null,
	                      records && recordsAfterPagingAndSorting().map(function (item, index) {
	                        return _react2.default.createElement(
	                          _core.TableRow,
	                          { key: index, style: { padding: "0" } },
	                          celdasFila(item).map(function (valor, i) {
	                            return _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-baseline text-break",
	                                style: estiloCelda,
	                                key: i
	                              },
	                              valor === null || valor === undefined ? "" : valor
	                            );
	                          }),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            {
	                              className: "align-baseline",
	                              style: { textAlign: "center", width: "110px" }
	                            },
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                onClick: hanVer(item),
	                                className: "btn btn-sm btn-info rounded-circle me-1",
	                                title: "Ver detalle"
	                              },
	                              _react2.default.createElement("i", { className: "fas fa-eye" })
	                            ),
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                onClick: hanImprimir(item),
	                                className: "btn btn-sm btn-secondary rounded-circle",
	                                title: "Imprimir reporte"
	                              },
	                              _react2.default.createElement("i", { className: "fas fa-print" })
	                            )
	                          )
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(TblPagination, null)
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_mensajes.Mensaje, {
	          mensaje: mensaje,
	          onHide: function onHide() {
	            return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	          }
	        })
	      )
	    )
	  );
	}
	
	exports.default = Auditoria;

/***/ },
/* 7081 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _varios = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GenerarVersion = function GenerarVersion() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	
	  var RefFile = (0, _react.useRef)();
	  var cmbStatus = (0, _react.useRef)();
	  var cmbTipo = (0, _react.useRef)();
	  var txtVersion = (0, _react.useRef)();
	  var txtNotav = (0, _react.useRef)();
	  var txtParrafo1 = (0, _react.useRef)();
	  var txtParrafo2 = (0, _react.useRef)();
	  var txtParrafo3 = (0, _react.useRef)();
	
	  var headCells = [{ label: "NOMBRE", textAlign: "center", with: 300 }, { label: "TAMAÑO", textAlign: "center", with: 100 }, { label: "FECHA", textAlign: "center", with: 100 }, { label: "DESCARGAR", textAlign: "center", with: 50 }, { label: "ELIMINAR", textAlign: "center", with: 50 }];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      lista = _useState2[0],
	      setLista = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(""),
	      _useState4 = _slicedToArray(_useState3, 2),
	      apk = _useState4[0],
	      setApk = _useState4[1];
	
	  var _useState5 = (0, _react.useState)("Seleccionar Archivo"),
	      _useState6 = _slicedToArray(_useState5, 2),
	      pathApk = _useState6[0],
	      setPathApk = _useState6[1];
	
	  var _useState7 = (0, _react.useState)("visible"),
	      _useState8 = _slicedToArray(_useState7, 2),
	      visibleBtn = _useState8[0],
	      setVisibleBtn = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(true),
	      _useState10 = _slicedToArray(_useState9, 2),
	      habilitado = _useState10[0],
	      setHabilitado = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mensaje = _useState12[0],
	      setMensaje = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensajesino = _useState14[0],
	      setMensajesino = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      activate = _useState16[0],
	      setActivate = _useState16[1];
	
	  var _useState17 = (0, _react.useState)({
	    incluir: false,
	    aceptar: true,
	    cancelar: true
	  }),
	      _useState18 = _slicedToArray(_useState17, 2),
	      botones = _useState18[0],
	      setBotones = _useState18[1];
	
	  var handleUpload = function handleUpload(e) {
	    if (e.target.files && e.target.files.length > 0) {
	      var file = e.target.files[0];
	      setPathApk(file.name);
	      setApk(e.target.files[0]);
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	    var upload = new FormData();
	    if (RefFile.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "debe seleccionar un archivo apk",
	        icono: "informacion"
	      });
	      sigue = false;
	      RefFile.current.focus();
	    } else if (txtVersion.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "el campo version no debe estar vacio.",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtVersion.current.focus();
	    } else {
	      upload.append("operacion", 1);
	      upload.append("version", JSON.stringify([{
	        idversion: "0",
	        version: txtVersion.current.value,
	        tipo: cmbTipo.current.value,
	        status: cmbStatus.current.value,
	        notaversion: txtNotav.current.value.trim(),
	        notauno: txtParrafo1.current.value.trim(),
	        notados: txtParrafo2.current.value.trim(),
	        notatres: txtParrafo3.current.value.trim()
	      }]));
	      upload.append("nueva", apk);
	    }
	
	    if (sigue) {
	      procesarRegistro(upload);
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro(body) {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/athos/version/actualizar";
	
	    _axios2.default.post(endpoint, body, {
	      responseType: "arraybuffer",
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      getFTP();
	      txtNotav.current.value = "";
	      txtParrafo1.current.value = "";
	      txtParrafo2.current.value = "";
	      txtParrafo3.current.value = "";
	      txtVersion.current.value = "";
	      setMensaje({
	        mostrar: true,
	        titulo: "Exito.",
	        texto: "Proceso ejecutado correctamente",
	        icono: "exito"
	      });
	    }).catch(function (error) {
	      console.error(error);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: "Error Al Crear El Respaldo",
	        icono: "error"
	      });
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op !== 6) {
	        setVisibleBtn("hidden");
	      } else {
	        setVisibleBtn("visible");
	      }
	
	      if (op === 1) {
	        setHabilitado(false);
	        setBotones({
	          incluir: false,
	          aceptar: false,
	          cancelar: false
	        });
	      } else if (op === 5) {
	        onChangeValidar();
	      }
	    };
	  };
	
	  var getFTP = function getFTP() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/athos/version/listar?dir=version";
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setLista(response.data);
	      }
	    }).catch(function (error) {
	      console.log(error);
	    }).finally(function () {
	      return setActivate(false);
	    });
	  };
	
	  var getDescargar = function getDescargar(ruta, file) {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/athos/version/descargar?ruta=" + ruta + "&archivo=" + file;
	    _axios2.default.get(endpoint, {
	      responseType: "arraybuffer",
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      var url = window.URL.createObjectURL(new Blob([response.data]));
	      var link = document.createElement("a");
	      link.href = url;
	      link.setAttribute("download", "" + file);
	      document.body.appendChild(link);
	      link.click();
	      document.body.removeChild(link);
	    }).catch(function (error) {
	      console.error(error);
	    }).finally(function () {
	      return setActivate(false);
	    });
	  };
	
	  var eliminar = function eliminar(ruta) {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/athos/version/eliminar?ruta=" + ruta;
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        getFTP();
	        setMensaje({
	          mostrar: true,
	          titulo: "Exito.",
	          texto: response.data,
	          icono: "exito"
	        });
	      }
	    }).catch(function (error) {
	      console.error(error);
	    }).finally(function () {
	      return setActivate(false);
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    getFTP();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "col-md-12 mx-auto row" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12 py-2 row card" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12 mx-auto rounded py-2  border-azul " },
	          _react2.default.createElement(
	            "div",
	            { className: " row rounded px-0 d-flex justify-content-between" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-3" },
	              _react2.default.createElement("input", {
	                className: "form-control",
	                ref: RefFile,
	                name: "apk",
	                accept: "*",
	                onChange: handleUpload,
	                type: "file",
	                id: "apk"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-3 input-group-sm  col-md-12" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "version" },
	                "Nota de la Version:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                autoComplete: "off",
	                ref: txtNotav,
	                name: "version",
	                placeholder: "Titulo de la nota de la version",
	                className: "form-control",
	                "aria-label": "version",
	                "aria-describedby": "version"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-3 input-group-sm  col-md-12" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "version" },
	                "Parrafo 1:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                autoComplete: "off",
	                ref: txtParrafo1,
	                name: "version",
	                placeholder: "Descripcion de la nota de la version 1",
	                className: "form-control",
	                "aria-label": "version",
	                "aria-describedby": "version"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-3 input-group-sm  col-md-12" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "version" },
	                "Parrafo 2:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                autoComplete: "off",
	                ref: txtParrafo2,
	                name: "version",
	                placeholder: "Descripcion de la nota de la version 2",
	                className: "form-control",
	                "aria-label": "version",
	                "aria-describedby": "version"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-3 input-group-sm  col-md-12" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "version" },
	                "Parrafo 3:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                autoComplete: "off",
	                ref: txtParrafo3,
	                name: "version",
	                placeholder: "Descripcion de la nota de la version 3",
	                className: "form-control",
	                "aria-label": "version",
	                "aria-describedby": "version"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-3 input-group-sm  col-md-3" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "version" },
	                "Version:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                autoComplete: "off",
	                ref: txtVersion,
	                name: "version",
	                placeholder: "1.0.0",
	                className: "form-control uppercase",
	                "aria-label": "version",
	                "aria-describedby": "version"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-3 input-group-sm col-sm-3" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "ESTATUS:"
	              ),
	              _react2.default.createElement(
	                "select",
	                {
	                  className: "form-select",
	                  "aria-label": "Default select example col-md-4",
	                  name: "status",
	                  ref: cmbStatus
	                },
	                _react2.default.createElement(
	                  "option",
	                  { value: "ESTABLE" },
	                  "ESTABLE"
	                ),
	                _react2.default.createElement(
	                  "option",
	                  { value: "BETA" },
	                  "BETA"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-3 input-group-sm col-sm-3" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "TIPO:"
	              ),
	              _react2.default.createElement(
	                "select",
	                {
	                  className: "form-select",
	                  "aria-label": "Default select example col-md-4",
	                  name: "tipo",
	                  ref: cmbTipo
	                },
	                _react2.default.createElement(
	                  "option",
	                  { value: "APK" },
	                  "APK"
	                ),
	                _react2.default.createElement(
	                  "option",
	                  { value: "OTRO" },
	                  "OTRO"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-sm-3" },
	              _react2.default.createElement(
	                "button",
	                {
	                  disabled: botones.incluir,
	                  onClick: onBotones(5),
	                  className: "btn btn-sm mx-1 btn-primary rounded-pill",
	                  style: { height: "27px" },
	                  title: "Guardar"
	                },
	                _react2.default.createElement(
	                  "i",
	                  { style: { fontSize: "9px" }, className: "fas fa-plus" },
	                  " ",
	                  "Guardar"
	                ),
	                " "
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 mt-2 d-flex justify-content-end" },
	
	            /* visibleBtn === "visible" ?  */_react2.default.createElement("div", {
	              className: "col-md-12 d-flex justify-content-start"
	              /* style={{ visibility: visibleBtn }} */
	            }) /* : (
	               <div
	               className="col-md-5 d-flex justify-content-end"
	               style={{
	               visibility: visibleBtn === "visible" ? "hidden" : "visible",
	               }}
	               >
	               <button
	               disabled={botones.aceptar}
	               onClick={onBotones(5)}
	               ref={btnAcepta}
	               style={{ height: "27px" }}
	               className="mx-2 btn btn-sm rounded-pill btn-success"
	               >
	               <i
	               className="fas fa-check-circle"
	               style={{ fontSize: "9px" }}
	               >
	               {" "}
	               Aceptar
	               </i>
	               </button>
	               <button
	               disabled={botones.cancelar}
	               onClick={onBotones(6)}
	               ref={btnCancela}
	               style={{ height: "27px" }}
	               className="mx-2 btn btn-danger btn-sm rounded-pill"
	               >
	               <i
	               className="fas fa-window-close"
	               style={{ fontSize: "9px" }}
	               >
	               {" "}
	               Cancelar
	               </i>
	               </button>
	               </div>
	               ) */
	
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12" },
	        _react2.default.createElement(
	          TblContainer,
	          {
	            container: {
	              maxHeight: 300,
	              minHeight: 300,
	              width: "100%",
	              overflow: "auto"
	            }
	          },
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            "tbody",
	            null,
	            lista && lista.map(function (item, index) {
	              return _react2.default.createElement(
	                "tr",
	                {
	                  style: {
	                    cursor: "pointer"
	                  },
	                  key: index
	                },
	                _react2.default.createElement(
	                  "td",
	                  {
	                    className: "align-baseline letra-tabla-td text-start",
	                    style: { width: 100 }
	                  },
	                  item.type === "dir" ? _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-folder" },
	                    " " + item.name
	                  ) : item.name
	                ),
	                _react2.default.createElement(
	                  "td",
	                  {
	                    className: "align-baseline letra-tabla-td text-right",
	                    style: { width: 40 }
	                  },
	                  (0, _varios.formatBytes)(item.size)
	                ),
	                _react2.default.createElement(
	                  "td",
	                  {
	                    className: "align-baseline letra-tabla-td text-center",
	                    style: { width: 100 }
	                  },
	                  (0, _moment2.default)(item.date).format("DD-MM-YYYY")
	                ),
	                _react2.default.createElement(
	                  "td",
	                  {
	                    className: "align-baseline letra-tabla-td text-center",
	                    style: { width: 10 }
	                  },
	                  item.type !== "dir" && _react2.default.createElement(
	                    "button",
	                    {
	                      className: "btn btn-sm  btn-info rounded-circle ml-2",
	                      onClick: function onClick() {
	                        return getDescargar(item.route, item.name);
	                      }
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-download" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "td",
	                  {
	                    className: "align-baseline letra-tabla-td text-center",
	                    style: { width: 10 }
	                  },
	                  item.type !== "dir" && _react2.default.createElement(
	                    "button",
	                    {
	                      className: "btn btn-sm  btn-danger rounded-circle ml-2",
	                      onClick: function onClick() {
	                        return eliminar(item.route);
	                      }
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-trash" })
	                  )
	                )
	              );
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = GenerarVersion;

/***/ },
/* 7082 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _varios = __webpack_require__(14);
	
	var _catalogoBaseDatos = __webpack_require__(7023);
	
	var _catalogoBaseDatos2 = _interopRequireDefault(_catalogoBaseDatos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GestionarBaseDatos = function GestionarBaseDatos() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnCatalogo = (0, _react.useRef)();
	  var txtCodBase = (0, _react.useRef)();
	  var txtBaseDatos = (0, _react.useRef)();
	  var txtIp = (0, _react.useRef)();
	  var txtPuerto = (0, _react.useRef)();
	  var cmbPlantilla = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)("visible"),
	      _useState2 = _slicedToArray(_useState, 2),
	      visibleBtn = _useState2[0],
	      setVisibleBtn = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      body = _useState4[0],
	      setBody = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(true),
	      _useState6 = _slicedToArray(_useState5, 2),
	      habilitado = _useState6[0],
	      setHabilitado = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mensaje = _useState8[0],
	      setMensaje = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mensajesino = _useState10[0],
	      setMensajesino = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      activate = _useState12[0],
	      setActivate = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      catalogo = _useState14[0],
	      setCatalogo = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    catalogoper: true,
	    tab1: false,
	    tab2: true
	  }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      botones = _useState16[0],
	      setBotones = _useState16[1];
	
	  var blanquear = function blanquear() {
	    if (botones.incluir) {
	      txtCodBase.current.value = "";
	    }
	
	    txtBaseDatos.current.value = "";
	    txtIp.current.value = "";
	    txtPuerto.current.value = "";
	
	    setActivate(false);
	    setBody(null);
	    setHabilitado(true);
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    setVisibleBtn("visible");
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      catalogoper: true,
	      tab1: false,
	      tab2: true
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	    if (!botones.incluir || !botones.modificar) {
	      if (txtBaseDatos.current.value.trim() === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Ingrese el nombre de la base de datos",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtBaseDatos.current.focus();
	      } else if (txtIp.current.value.trim() === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Ingrese la ip",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtIp.current.focus();
	      } else if (txtPuerto.current.value.trim() === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Ingrese el puerto",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtPuerto.current.focus();
	      }
	    }
	
	    if (sigue) {
	      var base = [{
	        idbasedatos: !botones.incluir ? 0 : txtCodBase.current.value,
	        nombre: txtBaseDatos.current.value.trim(),
	        ip: txtIp.current.value.trim(),
	        puerto: parseInt(txtPuerto.current.value)
	      }];
	
	      setBody({
	        base: base,
	        plantilla: botones.incluir === false ? cmbPlantilla.current.value.trim() : ""
	      });
	
	      var msg = "";
	      if (!botones.incluir) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (!botones.modificar) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (!botones.eliminar) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + "/api/athos/base/actualizar/" + ope;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (ope === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro creado correctamente",
	            icono: "exito"
	          });
	        } else if (ope === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro modificado correctamente",
	            icono: "exito"
	          });
	        } else if (ope === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro eliminado correctamente",
	            icono: "exito"
	          });
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = "";
	      if (error.response === undefined) {
	        mensaje = "Error de Conexion";
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "nombre_basedatos_ukey"') {
	          mensaje = "Ya existe una base de datos Con ese nombre";
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro(id) {
	    var campos = "idbasedatos, trim(nombre) as nombre, trim(ip) as ip, puerto";
	    var nomtab = "basedatos";
	    var nomid = "idbasedatos";
	
	    var endpoint = op.conexion + "/api/athos/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        txtBaseDatos.current.value = response.data.nombre;
	        txtIp.current.value = response.data.ip;
	        txtPuerto.current.value = response.data.puerto;
	      }
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var validarCodigo = function validarCodigo(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      seleccionarRegistro(txtCodBase.current.value);
	    }
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "nombre" || e.target.name === "ip") {
	      e.target.value = e.target.value.trim();
	      e.target.value = e.target.value.toLowerCase();
	    }
	  };
	
	  var onCatalogoBaseDatos = function onCatalogoBaseDatos(values) {
	    setCatalogo(false);
	
	    txtCodBase.current.value = values.idbasedatos;
	    seleccionarRegistro(values.idbasedatos);
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op !== 6) {
	        setVisibleBtn("hidden");
	      } else {
	        setVisibleBtn("visible");
	      }
	
	      if (op === 1) {
	        setHabilitado(false);
	        setBotones({
	          incluir: false,
	          consultar: true,
	          modificar: true,
	          eliminar: true,
	          aceptar: false,
	          cancelar: false,
	          catalogo: true,
	          catalogoper: false,
	          tab1: true,
	          tab2: true
	        });
	        txtBaseDatos.current.focus();
	      } else if (op === 2) {
	        setHabilitado(false);
	        setBotones({
	          incluir: true,
	          consultar: true,
	          modificar: false,
	          eliminar: true,
	          aceptar: false,
	          cancelar: false,
	          catalogo: false,
	          catalogoper: true,
	          tab1: false,
	          tab2: false
	        });
	        btnCatalogo.current.focus();
	      } else if (op === 3) {
	        setHabilitado(true);
	        setBotones({
	          incluir: true,
	          consultar: true,
	          modificar: true,
	          eliminar: false,
	          aceptar: false,
	          cancelar: false,
	          catalogo: false,
	          catalogoper: true,
	          tab1: false,
	          tab2: false
	        });
	        btnCatalogo.current.focus();
	      } else if (op === 4) {
	        setHabilitado(true);
	        setBotones({
	          incluir: true,
	          consultar: false,
	          modificar: true,
	          eliminar: true,
	          aceptar: true,
	          cancelar: false,
	          catalogo: false,
	          catalogoper: true,
	          tab1: false,
	          tab2: false
	        });
	
	        btnCatalogo.current.focus();
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        blanquear();
	      }
	    };
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "col-md-12 mx-auto row" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12 py-2 row card" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12 mx-auto rounded py-2  border-azul " },
	          _react2.default.createElement(
	            "div",
	            { className: " row rounded px-0 d-flex justify-content-between" },
	            botones.tab1 === true && _react2.default.createElement(
	              "div",
	              { className: "input-group mb-2 input-group-sm col-sm-4" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "Plantilla"
	              ),
	              _react2.default.createElement(
	                "select",
	                {
	                  className: "form-select",
	                  "aria-label": "Default select example col-md-4",
	                  name: "plantilla",
	                  disabled: habilitado,
	                  ref: cmbPlantilla
	                },
	                _react2.default.createElement(
	                  "option",
	                  { value: "plantilla" },
	                  "POLAR"
	                ),
	                _react2.default.createElement(
	                  "option",
	                  { value: "plantilla" },
	                  "TIENDA"
	                ),
	                _react2.default.createElement(
	                  "option",
	                  { value: "plantilla" },
	                  "FERRETERIA"
	                )
	              )
	            ),
	            botones.tab1 === false && _react2.default.createElement(
	              "div",
	              { className: "input-group input-group-sm mb-2 col-md-4" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "C\xF3digo:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                autoComplete: "off",
	                ref: txtCodBase,
	                disabled: true,
	                onKeyUp: validarCodigo,
	                onBlur: validarCodigo,
	                name: "idubicacion",
	                className: "form-control",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-sm"
	              }),
	              _react2.default.createElement(
	                "button",
	                {
	                  disabled: botones.catalogo,
	                  ref: btnCatalogo,
	                  onClick: function onClick() {
	                    return setCatalogo(true);
	                  },
	                  type: "button",
	                  className: "btn btn-success"
	                },
	                _react2.default.createElement("i", { className: "fas fa-search" })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-8 input-group input-group-sm mb-2" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "Base de Datos:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                autoComplete: "off",
	                ref: txtBaseDatos,
	                disabled: habilitado,
	                name: "nombre",
	                placeholder: "j123456789",
	                onChange: onChange,
	                className: "form-control lowercase",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-sm"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6 input-group input-group-sm mb-2" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "Ip:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                autoComplete: "off",
	                ref: txtIp,
	                disabled: habilitado,
	                name: "ip",
	                placeholder: "3.144.143.71",
	                onChange: onChange,
	                className: "form-control",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-sm"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6 input-group input-group-sm mb-2" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "Puerto:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                autoComplete: "off",
	                ref: txtPuerto,
	                disabled: habilitado,
	                placeholder: "5432",
	                onChange: _varios.validaSoloNumero,
	                className: "form-control text-right",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-sm"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 mt-2 d-flex justify-content-end" },
	            visibleBtn === "visible" ? _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 d-flex justify-content-start",
	                style: { visibility: visibleBtn }
	              },
	              _react2.default.createElement(
	                "button",
	                {
	                  disabled: botones.incluir,
	                  onClick: onBotones(1),
	                  className: "btn btn-sm mx-1 btn-primary rounded-pill",
	                  style: { height: "27px" },
	                  title: "Incluir Moneda"
	                },
	                _react2.default.createElement(
	                  "i",
	                  { style: { fontSize: "9px" }, className: "fas fa-plus" },
	                  " ",
	                  "Incluir",
	                  " "
	                ),
	                " "
	              ),
	              _react2.default.createElement(
	                "button",
	                {
	                  disabled: botones.consultar,
	                  onClick: onBotones(4),
	                  className: "btn btn-sm mx-1 btn-info rounded-pill",
	                  style: { height: "27px" },
	                  title: "Consultar Moneda"
	                },
	                _react2.default.createElement(
	                  "i",
	                  { style: { fontSize: "9px" }, className: "fas fa-eye" },
	                  "Consultar"
	                ),
	                " "
	              ),
	              _react2.default.createElement(
	                "button",
	                {
	                  disabled: botones.modificar,
	                  onClick: onBotones(2),
	                  className: "btn btn-sm mx-1 btn-warning rounded-pill",
	                  style: { height: "27px" },
	                  title: "Modificar Moneda"
	                },
	                _react2.default.createElement(
	                  "i",
	                  { style: { fontSize: "9px" }, className: "fa fa-edit" },
	                  "Modificar"
	                ),
	                " "
	              ),
	              _react2.default.createElement(
	                "button",
	                {
	                  disabled: botones.eliminar,
	                  onClick: onBotones(3),
	                  className: "btn btn-sm mx-1 btn-danger rounded-pill",
	                  style: { height: "27px" },
	                  title: "Eliminar Moneda"
	                },
	                _react2.default.createElement(
	                  "i",
	                  { style: { fontSize: "9px" }, className: "fa fa-trash" },
	                  "Eliminar"
	                ),
	                " "
	              )
	            ) : _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-5 d-flex justify-content-end",
	                style: {
	                  visibility: visibleBtn === "visible" ? "hidden" : "visible"
	                }
	              },
	              _react2.default.createElement(
	                "button",
	                {
	                  disabled: botones.aceptar,
	                  onClick: onBotones(5),
	                  ref: btnAcepta,
	                  style: { height: "27px" },
	                  className: "mx-2 btn btn-sm rounded-pill btn-success"
	                },
	                _react2.default.createElement(
	                  "i",
	                  {
	                    className: "fas fa-check-circle",
	                    style: { fontSize: "9px" }
	                  },
	                  " ",
	                  "Aceptar"
	                )
	              ),
	              _react2.default.createElement(
	                "button",
	                {
	                  disabled: botones.cancelar,
	                  onClick: onBotones(6),
	                  ref: btnCancela,
	                  style: { height: "27px" },
	                  className: "mx-2 btn btn-danger btn-sm rounded-pill"
	                },
	                _react2.default.createElement(
	                  "i",
	                  {
	                    className: "fas fa-window-close",
	                    style: { fontSize: "9px" }
	                  },
	                  " ",
	                  "Cancelar"
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_catalogoBaseDatos2.default, {
	      show: catalogo,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogo(false);
	      },
	      onHideAceptaCatalogo: onCatalogoBaseDatos
	    }),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return mensaje.titulo === "Exito." ? blanquear() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = GestionarBaseDatos;

/***/ },
/* 7083 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GestionarCp = function GestionarCp() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var cmbBaseDatos = (0, _react.useRef)();
	  var cmbCarpeta = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)("visible"),
	      _useState2 = _slicedToArray(_useState, 2),
	      visibleBtn = _useState2[0],
	      setVisibleBtn = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      body = _useState4[0],
	      setBody = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      baseDatos = _useState6[0],
	      setBaseDatos = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(true),
	      _useState8 = _slicedToArray(_useState7, 2),
	      habilitado = _useState8[0],
	      setHabilitado = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mensaje = _useState10[0],
	      setMensaje = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mensajesino = _useState12[0],
	      setMensajesino = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      activate = _useState14[0],
	      setActivate = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({
	    incluir: false,
	    aceptar: true,
	    cancelar: true
	  }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      botones = _useState16[0],
	      setBotones = _useState16[1];
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	    if (!botones.incluir || !botones.modificar) {
	      if (cmbCarpeta.current.value.trim() === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "debe seleccionar la carpeta",
	          icono: "informacion"
	        });
	        sigue = false;
	        cmbCarpeta.current.focus();
	      } else if (baseDatos.length === 0) {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "debe seleccionar una base de datos",
	          icono: "informacion"
	        });
	        sigue = false;
	        cmbBaseDatos.current.focus();
	      }
	    }
	
	    if (sigue) {
	      setBody({
	        origen: cmbCarpeta.current.value.trim(),
	        destino: cmbBaseDatos.current.value.trim()
	      });
	
	      var msg = "";
	      if (!botones.incluir) {
	        msg = "Esta Seguro de Copiar la carpeta " + cmbCarpeta.current.value + " con el nombre " + cmbBaseDatos.current.value + ".";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/athos/base/cp";
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setMensaje({
	          mostrar: true,
	          titulo: "Exito.",
	          texto: response.data,
	          icono: "exito"
	        });
	      }
	    }).catch(function (error) {
	      console.log(error);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: "Error al Copiar la Carpeta.",
	        icono: "error"
	      });
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var seleccionarBasedeDatos = function seleccionarBasedeDatos() {
	    var campos = "*";
	    var nomtab = "basedatos";
	    var orden = "idbasedatos";
	    var endpoint = op.conexion + "/api/athos/consulta/seleccionarregistros?campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setBaseDatos(response.data);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op !== 6) {
	        setVisibleBtn("hidden");
	      } else {
	        setVisibleBtn("visible");
	      }
	
	      if (op === 1) {
	        setHabilitado(false);
	        setBotones({
	          incluir: false,
	          aceptar: false,
	          cancelar: false
	        });
	        cmbBaseDatos.current.focus();
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        blanquear();
	      }
	    };
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setBody(null);
	    setHabilitado(true);
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    setVisibleBtn("visible");
	    setBotones({
	      incluir: false,
	      aceptar: true,
	      cancelar: true
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarBasedeDatos();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "col-md-12 mx-auto row" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12 py-2 row card" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12 mx-auto rounded py-2  border-azul " },
	          _react2.default.createElement(
	            "div",
	            { className: " row rounded px-0 d-flex justify-content-between" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-3 input-group-sm col-sm-6" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "AFILIADOS:"
	              ),
	              _react2.default.createElement(
	                "select",
	                {
	                  className: "form-select",
	                  "aria-label": "Default select example col-md-4",
	                  name: "conexion",
	                  disabled: habilitado,
	                  ref: cmbBaseDatos
	                },
	                baseDatos && baseDatos.map(function (item, index) {
	                  return _react2.default.createElement(
	                    "option",
	                    { key: index, value: item.nombre.toUpperCase() },
	                    " ",
	                    item.nombre.toUpperCase(),
	                    " "
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-3 input-group-sm col-sm-6" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "IMAGENES:"
	              ),
	              _react2.default.createElement(
	                "select",
	                {
	                  className: "form-select",
	                  "aria-label": "Default select example col-md-4",
	                  name: "carpeta",
	                  disabled: habilitado,
	                  ref: cmbCarpeta
	                },
	                _react2.default.createElement(
	                  "option",
	                  { value: "polar" },
	                  "POLAR"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 mt-2 d-flex justify-content-end" },
	            visibleBtn === "visible" ? _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 d-flex justify-content-start",
	                style: { visibility: visibleBtn }
	              },
	              _react2.default.createElement(
	                "button",
	                {
	                  disabled: botones.incluir,
	                  onClick: onBotones(1),
	                  className: "btn btn-sm mx-1 btn-primary rounded-pill",
	                  style: { height: "27px" },
	                  title: "Correr Script"
	                },
	                _react2.default.createElement(
	                  "i",
	                  { style: { fontSize: "9px" }, className: "fas fa-plus" },
	                  " ",
	                  "Copiar"
	                ),
	                " "
	              )
	            ) : _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-5 d-flex justify-content-end",
	                style: {
	                  visibility: visibleBtn === "visible" ? "hidden" : "visible"
	                }
	              },
	              _react2.default.createElement(
	                "button",
	                {
	                  disabled: botones.aceptar,
	                  onClick: onBotones(5),
	                  ref: btnAcepta,
	                  style: { height: "27px" },
	                  className: "mx-2 btn btn-sm rounded-pill btn-success"
	                },
	                _react2.default.createElement(
	                  "i",
	                  {
	                    className: "fas fa-check-circle",
	                    style: { fontSize: "9px" }
	                  },
	                  " ",
	                  "Aceptar"
	                )
	              ),
	              _react2.default.createElement(
	                "button",
	                {
	                  disabled: botones.cancelar,
	                  onClick: onBotones(6),
	                  ref: btnCancela,
	                  style: { height: "27px" },
	                  className: "mx-2 btn btn-danger btn-sm rounded-pill"
	                },
	                _react2.default.createElement(
	                  "i",
	                  {
	                    className: "fas fa-window-close",
	                    style: { fontSize: "9px" }
	                  },
	                  " ",
	                  "Cancelar"
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return mensaje.titulo === "Exito." ? blanquear() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = GestionarCp;

/***/ },
/* 7084 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GestionarScript = function GestionarScript() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var txtScript = (0, _react.useRef)();
	  var cmbBaseDatos = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)("visible"),
	      _useState2 = _slicedToArray(_useState, 2),
	      visibleBtn = _useState2[0],
	      setVisibleBtn = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      body = _useState4[0],
	      setBody = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      baseDatos = _useState6[0],
	      setBaseDatos = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(true),
	      _useState8 = _slicedToArray(_useState7, 2),
	      habilitado = _useState8[0],
	      setHabilitado = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mensaje = _useState10[0],
	      setMensaje = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mensajesino = _useState12[0],
	      setMensajesino = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      activate = _useState14[0],
	      setActivate = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({
	    incluir: false,
	    aceptar: true,
	    cancelar: true
	  }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      botones = _useState16[0],
	      setBotones = _useState16[1];
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	    if (!botones.incluir || !botones.modificar) {
	      if (txtScript.current.value.trim() === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Ingrese el Script",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtScript.current.focus();
	      } else if (baseDatos.length === 0) {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "debe seleccionar una base de datos",
	          icono: "informacion"
	        });
	        sigue = false;
	        cmbBaseDatos.current.focus();
	      }
	    }
	
	    if (sigue) {
	      var database = [];
	
	      if (cmbBaseDatos.current.value === "") {
	        database = baseDatos;
	        database.push({
	          idbasedatos: "0",
	          nombre: "plantilla",
	          ip: "3.144.143.71",
	          puerto: "5432"
	        });
	      } else {
	        for (var i = 0; i < baseDatos.length; i++) {
	          if (cmbBaseDatos.current.value === baseDatos[i].idbasedatos) {
	            database.push(baseDatos[i]);
	          }
	        }
	      }
	
	      setBody({
	        database: database,
	        comando: txtScript.current.value.trim()
	      });
	
	      var msg = "";
	      if (!botones.incluir) {
	        msg = "Esta Seguro de Correr este Script.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/athos/base/psql";
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setMensaje({
	          mostrar: true,
	          titulo: "Exito.",
	          texto: "Proceso ejecutado correctamente",
	          icono: "exito"
	        });
	      }
	    }).catch(function (error) {
	      console.log(error);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: "Error al Ejecutar el Script",
	        icono: "error"
	      });
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var seleccionarBasedeDatos = function seleccionarBasedeDatos() {
	    var campos = "*";
	    var nomtab = "basedatos";
	    var orden = "idbasedatos";
	    var endpoint = op.conexion + "/api/athos/consulta/seleccionarregistros?campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setBaseDatos(response.data);
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op !== 6) {
	        setVisibleBtn("hidden");
	      } else {
	        setVisibleBtn("visible");
	      }
	
	      if (op === 1) {
	        setHabilitado(false);
	        setBotones({
	          incluir: false,
	          aceptar: false,
	          cancelar: false
	        });
	        cmbBaseDatos.current.focus();
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        blanquear();
	      }
	    };
	  };
	
	  var blanquear = function blanquear() {
	    txtScript.current.value = "";
	    cmbBaseDatos.current.value = "";
	
	    setActivate(false);
	    setBody(null);
	    setHabilitado(true);
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    setVisibleBtn("visible");
	    setBotones({
	      incluir: false,
	      aceptar: true,
	      cancelar: true
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarBasedeDatos();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "col-md-12 mx-auto row" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12 py-2 row card" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12 mx-auto rounded py-2  border-azul " },
	          _react2.default.createElement(
	            "div",
	            { className: " row rounded px-0 d-flex justify-content-between" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-3 input-group-sm col-sm-12" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "Base de Datos:"
	              ),
	              _react2.default.createElement(
	                "select",
	                {
	                  className: "form-select",
	                  "aria-label": "Default select example col-md-4",
	                  name: "conexion",
	                  disabled: habilitado,
	                  ref: cmbBaseDatos
	                },
	                _react2.default.createElement(
	                  "option",
	                  { value: "" },
	                  "TODAS LAS BASES DE DATOS"
	                ),
	                baseDatos && baseDatos.map(function (item, index) {
	                  return _react2.default.createElement(
	                    "option",
	                    { key: index, value: item.idbasedatos },
	                    " ",
	                    item.nombre.toUpperCase(),
	                    " "
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group mb-3 input-group-sm col-sm-12" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                " ",
	                "Script:"
	              ),
	              _react2.default.createElement("textarea", {
	                disabled: habilitado,
	                name: "script",
	                ref: txtScript,
	                style: { height: 300 },
	                className: "form-control text-uppercase",
	                id: "textAreaExample"
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 mt-2 d-flex justify-content-end" },
	            visibleBtn === "visible" ? _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 d-flex justify-content-start",
	                style: { visibility: visibleBtn }
	              },
	              _react2.default.createElement(
	                "button",
	                {
	                  disabled: botones.incluir,
	                  onClick: onBotones(1),
	                  className: "btn btn-sm mx-1 btn-primary rounded-pill",
	                  style: { height: "27px" },
	                  title: "Correr Script"
	                },
	                _react2.default.createElement(
	                  "i",
	                  { style: { fontSize: "9px" }, className: "fas fa-plus" },
	                  " ",
	                  "Correr Script"
	                ),
	                " "
	              )
	            ) : _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-5 d-flex justify-content-end",
	                style: {
	                  visibility: visibleBtn === "visible" ? "hidden" : "visible"
	                }
	              },
	              _react2.default.createElement(
	                "button",
	                {
	                  disabled: botones.aceptar,
	                  onClick: onBotones(5),
	                  ref: btnAcepta,
	                  style: { height: "27px" },
	                  className: "mx-2 btn btn-sm rounded-pill btn-success"
	                },
	                _react2.default.createElement(
	                  "i",
	                  {
	                    className: "fas fa-check-circle",
	                    style: { fontSize: "9px" }
	                  },
	                  " ",
	                  "Aceptar"
	                )
	              ),
	              _react2.default.createElement(
	                "button",
	                {
	                  disabled: botones.cancelar,
	                  onClick: onBotones(6),
	                  ref: btnCancela,
	                  style: { height: "27px" },
	                  className: "mx-2 btn btn-danger btn-sm rounded-pill"
	                },
	                _react2.default.createElement(
	                  "i",
	                  {
	                    className: "fas fa-window-close",
	                    style: { fontSize: "9px" }
	                  },
	                  " ",
	                  "Cancelar"
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return mensaje.titulo === "Exito." ? blanquear() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = GestionarScript;

/***/ },
/* 7085 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _core = __webpack_require__(19);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _mensajes = __webpack_require__(9);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _graficos = __webpack_require__(301);
	
	var _reactChartjs = __webpack_require__(121);
	
	var _catalogoCrearTasa = __webpack_require__(7026);
	
	var _catalogoCrearTasa2 = _interopRequireDefault(_catalogoCrearTasa);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GestionarMoneda = function GestionarMoneda() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	
	  var colores = ["#17a2b8", "#ffae00", "#dc3545", "#BDB76B", "#7B68EE", "#4B0082", "#00ffff", "#0080ff", "#0000ff", "#8000ff", "#ff00ff", "#ff0080"];
	
	  var btnCatalogo = (0, _react.useRef)();
	  var txtCodMoneda = (0, _react.useRef)();
	  var txtMoneda = (0, _react.useRef)();
	  var txtLogo = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      body = _useState2[0],
	      setBody = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      colorG = _useState4[0],
	      setColorG = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      valor = _useState6[0],
	      setValor = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      label = _useState8[0],
	      setLabel = _useState8[1];
	
	  var _useState9 = (0, _react.useState)([]),
	      _useState10 = _slicedToArray(_useState9, 2),
	      tipo = _useState10[0],
	      setTipo = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      rmoney = _useState12[0],
	      setRmoney = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      idm = _useState14[0],
	      setIdm = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      idmonedadeta = _useState16[0],
	      setIdmonedadeta = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(""),
	      _useState18 = _slicedToArray(_useState17, 2),
	      fecha = _useState18[0],
	      setFecha = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0.0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      total = _useState20[0],
	      setTotal = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0.0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      menor = _useState22[0],
	      setMenor = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0),
	      _useState24 = _slicedToArray(_useState23, 2),
	      operacion = _useState24[0],
	      setOperacion = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(true),
	      _useState26 = _slicedToArray(_useState25, 2),
	      bloqueado = _useState26[0],
	      setBloqueado = _useState26[1];
	
	  var _useState27 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState28 = _slicedToArray(_useState27, 2),
	      mensaje = _useState28[0],
	      setMensaje = _useState28[1];
	
	  var _useState29 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState30 = _slicedToArray(_useState29, 2),
	      mensajesino = _useState30[0],
	      setMensajesino = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(false),
	      _useState32 = _slicedToArray(_useState31, 2),
	      activate = _useState32[0],
	      setActivate = _useState32[1];
	
	  var _useState33 = (0, _react.useState)([]),
	      _useState34 = _slicedToArray(_useState33, 2),
	      records = _useState34[0],
	      setRecords = _useState34[1];
	
	  var _useState35 = (0, _react.useState)([]),
	      _useState36 = _slicedToArray(_useState35, 2),
	      monedas = _useState36[0],
	      setMonedas = _useState36[1];
	
	  var _useState37 = (0, _react.useState)([]),
	      _useState38 = _slicedToArray(_useState37, 2),
	      info = _useState38[0],
	      setInfo = _useState38[1];
	
	  var _useState39 = (0, _react.useState)([]),
	      _useState40 = _slicedToArray(_useState39, 2),
	      datos = _useState40[0],
	      setDatos = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(false),
	      _useState42 = _slicedToArray(_useState41, 2),
	      catalogo = _useState42[0],
	      setCatalogo = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    catalogoper: true,
	    tab1: true,
	    tab2: true
	  }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      botones = _useState44[0],
	      setBotones = _useState44[1];
	
	  var nomtabla = void 0;
	
	  if (operacion === 3) {
	    nomtabla = [{
	      id: "1",
	      backgroundColor: "rgba(5, 81, 130, 1)",
	      color: "#ffffff",
	      label: "FECHA DE REGISTRO",
	      textAlign: "center"
	    }, {
	      id: "2",
	      backgroundColor: "rgba(5, 81, 130, 1)",
	      color: "#ffffff",
	      label: "TASA",
	      textAlign: "center"
	    }, {
	      id: "3",
	      backgroundColor: "rgba(5, 81, 130, 1)",
	      color: "#ffffff",
	      label: "-",
	      textAlign: "center"
	    }];
	  } else {
	    nomtabla = [{
	      id: "1",
	      backgroundColor: "rgba(5, 81, 130, 1)",
	      color: "#ffffff",
	      label: "FECHA DE REGISTRO",
	      textAlign: "center"
	    }, {
	      id: "2",
	      backgroundColor: "rgba(5, 81, 130, 1)",
	      color: "#ffffff",
	      label: "TASA",
	      textAlign: "center"
	    }, {
	      id: "3",
	      backgroundColor: "rgba(5, 81, 130, 1)",
	      color: "#ffffff",
	      label: "-",
	      textAlign: "center"
	    }];
	  }
	
	  var headCells = nomtabla;
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var seleccionarRegistrosm = function seleccionarRegistrosm(opera) {
	    var campos = "idmoneda, trim(descripcion) as descripcion, simbolo, predeterminada, valormoneda";
	    var nomtab = "moneda";
	    var orden = "idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var _datos = [];
	
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].predeterminada !== true) {
	              _datos.push({
	                idmoneda: response.data[i].idmoneda,
	                descripcion: response.data[i].descripcion,
	                simbolo: response.data[i].simbolo,
	                predeterminada: response.data[i].predeterminada,
	                valormoneda: response.data[i].valormoneda,
	                subpredeterminada: response.data[i].subpredeterminada
	              });
	            }
	          }
	
	          setRmoney(_datos);
	          var idmoney = txtCodMoneda.current.value;
	          if (opera !== 2) {
	            selectDetallesMoneda(idmoney);
	          }
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 2;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + "/api/moneda/actualizar/" + ope;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (ope === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Registro Creado Correctamente",
	            icono: "exito"
	          });
	          seleccionarRegistros();
	        } else if (ope === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Registro Modificado Correctamente",
	            icono: "exito"
	          });
	          seleccionarRegistros();
	        } else if (ope === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Registro Eliminado Correctamente",
	            icono: "exito"
	          });
	          seleccionarRegistros();
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = "";
	      if (error.response === undefined) {
	        mensaje = "Error de Conexion";
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "nombre_moneda_ukey"') {
	          mensaje = "Ya existe una moneda Con ese nombre";
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var procesarEliminar = function procesarEliminar(id) {
	    setActivate(true);
	
	    var endpoint = op.conexion + "/api/moneda/eliminarmonedas/" + id;
	
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setMensaje({
	          mostrar: true,
	          titulo: "Exito.",
	          texto: "Registro Eliminado Correctamente",
	          icono: "exito"
	        });
	        seleccionarRegistros();
	
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = "";
	      if (error.response === undefined) {
	        mensaje = "Error de Conexion";
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "nombre_moneda_ukey"') {
	          mensaje = "Ya existe una moneda Con ese nombre";
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    if (operacion !== 3) {
	      procesarRegistro();
	    } else {
	      procesarEliminar(idmonedadeta);
	    }
	  };
	
	  var selectDetallesMoneda = function selectDetallesMoneda(id) {
	    var anio = (0, _moment2.default)(fechaSistema).format("YYYY");
	    var ms = (0, _moment2.default)(fechaSistema).format("MM");
	
	    var endpoint = op.conexion + "/api/consulta/seleccionarmonedadetalle?id=" + id;
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setRecords(response.data);
	        seleccionarMesMoneda(ms, id, anio);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "nombre") {
	      e.target.value = e.target.value.toUpperCase();
	    }
	
	    if (e.target.name === "moneda") {
	      selectDetallesMoneda(e.target.value);
	    }
	
	    if (e.target.name === "mes") {
	      var m = e.target.value;
	      var val = txtLogo.current.value;
	      var a = (0, _moment2.default)(fechaSistema).format("YYYY");
	      seleccionarMesMoneda(m, val, a);
	      setValor([]);
	      setLabel([]);
	      setMenor([]);
	      setTotal(0.0);
	    } else if (e.target.name === "logo") {
	      var _val = txtLogo.current.value;
	      txtMoneda.current.value = "";
	      setValor([]);
	      setLabel([]);
	      setMenor([]);
	      if (_val > 0) {
	        setBloqueado(false);
	        setTotal(0.0);
	        txtMoneda.current.focus();
	      } else {
	        setBloqueado(true);
	      }
	    }
	  };
	
	  var onSimbolo = function onSimbolo(e) {
	    return function () {
	      setIdm(e);
	    };
	  };
	
	  var onCerrar = function onCerrar() {
	    setCatalogo(false);
	    seleccionarRegistrosm();
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var a = (0, _moment2.default)(fechaSistema).format("YYYY");
	
	    var endpoint = op.conexion + "/api/moneda/seleccionarmonedas";
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setTipo(response.data);
	        seleccionarMonedaCal(a);
	
	        var idmonedaa = [];
	        var results = [];
	        var element = [];
	        var unicos = [];
	        var color = [];
	
	        if (response.data.length > 0) {
	          for (var _i = 0; _i < response.data.length; _i++) {
	            idmonedaa.push(response.data[_i]);
	          }
	
	          for (var i = 0; i < idmonedaa.length; i++) {
	            var elemento = idmonedaa[i].descripcion;
	            var _valor = idmonedaa[i].valor;
	            var _total = 1;
	
	            if (!unicos.includes(idmonedaa[i].descripcion)) {
	              unicos.push(elemento);
	              results.push(_total);
	              color.push(colores[i]);
	              element.push({
	                nombre: idmonedaa[i].descripcion,
	                valor: _valor,
	                color: colores[i]
	              });
	            }
	          }
	          setColorG(color);
	          setMonedas(unicos);
	          setInfo(results);
	          setDatos(element);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarMonedaCal = function seleccionarMonedaCal(a) {
	    var endpoint = op.conexion + "/api/moneda/tipomoneda?a=" + a;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idmoneda > 0) {
	          txtLogo.current.value = response.data.idmoneda;
	          var m = response.data.mes.substring(0, 2);
	          var id = response.data.idmoneda;
	          var _a = response.data.mes.substring(3, 7);
	          seleccionarMesMoneda(m, id, _a);
	          setIdm(response.data.simbolo);
	          txtMoneda.current.value = parseInt(m);
	        }
	      }
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarMesMoneda = function seleccionarMesMoneda(m, id, a) {
	    var endpoint = op.conexion + "/api/moneda/seleccionarmoneda?m=" + m.toString() + "&id=" + id + "&a=" + a;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.length > 0) {
	          txtMoneda.current.value = (0, _moment2.default)(response.data[0].fecha).format("MM");
	          txtLogo.current.value = response.data[0].idmoneda;
	          setBloqueado(false);
	
	          var to = 0;
	          var te = 0;
	          var contar = 0;
	          var label = [];
	          var datos = [];
	
	          for (var i = 0; i < response.data.length; i++) {
	            contar = contar + 1;
	            label.push((0, _moment2.default)(response.data[i].fecha).format("DD-MM"));
	            datos.push(response.data[i].valor);
	          }
	
	          if (contar > 1) {
	            to = contar - 2;
	            te = contar - 1;
	          }
	
	          setValor(datos);
	          setLabel(label);
	
	          var porcp = 0.0;
	          var totalpcp = 0.0;
	          var totalreal = 0.0;
	
	          if (datos[to] > datos[te]) {
	            porcp = datos[to] / datos[te] * 100;
	            totalreal = 100 - porcp;
	            totalpcp = (0, _varios.formatMoneda)(totalreal.toString().replace(".", ","), ",", ".", 2);
	            setTotal(totalpcp);
	          } else if (datos[to] < datos[te]) {
	            porcp = datos[to] / datos[te] * 100;
	            totalreal = 100 - porcp;
	            totalpcp = (0, _varios.formatMoneda)(totalreal.toString().replace(".", ","), ",", ".", 2);
	            setTotal(totalpcp);
	          }
	        } else {
	          setValor([]);
	          setLabel([]);
	          setMenor(0.0);
	          setTotal(0.0);
	          setBloqueado(false);
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var data = {
	    labels: monedas,
	    leyend: true,
	    datasets: [{
	      label: "#",
	      data: info,
	      backgroundColor: colorG,
	      borderColor: colorG,
	      borderWidth: 1,
	      hoverBorderWidth: 15
	    }]
	  };
	
	  var options = {
	    responsive: true,
	    legend: {
	      position: "top",
	      display: false
	    },
	    title: {
	      display: true,
	      text: "Tipos de Monedas Registradas: " + info.length
	    }
	  };
	
	  var optionsn = {
	    responsive: true,
	    plugins: {
	      legend: {
	        position: "top"
	      },
	      title: {
	        display: true,
	        text: "Chart.js Line Chart"
	      }
	    }
	  };
	
	  var datan = {
	    labels: label,
	    datasets: [{
	      label: "Variación" + " " + idm,
	      data: valor,
	      borderColor: "rgba(0, 98, 204)"
	    }]
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarRegistros();
	    seleccionarRegistrosm();
	  }, []);
	
	  var gestionar = function gestionar(data, op) {
	    return function (event) {
	      event.preventDefault();
	      if (op === 3) {
	        setIdmonedadeta(data.idmonedadetalle);
	        setOperacion(op);
	        setFecha((0, _moment2.default)(data.fecha).format("YYYY-MM-DD"));
	        setMensajesino({
	          mostrar: true,
	          titulo: "Confirmación.",
	          texto: "¡Esta Seguro de Eliminar este Registro!",
	          icono: "confirmacion"
	        });
	      } else if (op === 2) {
	        var idmoney = txtCodMoneda.current.value;
	        setIdmonedadeta(idmoney);
	        setOperacion(op);
	        setCatalogo(true);
	      }
	    };
	  };
	
	  var cerrarModal = function cerrarModal() {
	    seleccionarRegistrosm();
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "col-md-12 mx-auto row m-0" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-6 py-1 h-100 row card" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12 mx-auto rounded py-2  border-azul " },
	          _react2.default.createElement(
	            "div",
	            { className: "row rounded px-0 m-0" },
	            _react2.default.createElement(
	              "div",
	              { className: "colfull col-pd-300 px-3" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "TIPO MONEDA:"
	                ),
	                _react2.default.createElement(
	                  "select",
	                  {
	                    className: "form-control form-control-sm form-select fs-6 px-1 fw-bold",
	                    ref: txtCodMoneda,
	                    name: "moneda",
	                    onChange: onChange
	                  },
	                  rmoney && rmoney.map(function (item, index) {
	                    return _react2.default.createElement(
	                      "option",
	                      { key: index, value: item.idmoneda },
	                      " ",
	                      item.descripcion + " " + item.simbolo
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-pd-100 ml-auto d-flex justify-content-end px-3" },
	              _react2.default.createElement(
	                "button",
	                {
	                  ref: btnCatalogo,
	                  onClick: gestionar("r", 2),
	                  type: "button",
	                  className: "btn btn-sm mb-2 btn-primary"
	                },
	                _react2.default.createElement("i", { className: "fas fa-plus" })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 MT-2", style: { height: "230px" } },
	            _react2.default.createElement(
	              TblContainer,
	              {
	                container: {
	                  height: 230,
	                  width: "100%",
	                  overflow: "auto",
	                  padding: "2px"
	                }
	              },
	              _react2.default.createElement(TblHead, null),
	              _react2.default.createElement(
	                _core.TableBody,
	                { className: "overflow-hidden table-bordered" },
	                records && records.map(function (item, index) {
	                  return _react2.default.createElement(
	                    _core.TableRow,
	                    { key: index, style: { padding: "0" } },
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      {
	                        className: "align-baseline bg-light",
	                        style: { textAlign: "center", width: "180px" }
	                      },
	                      (0, _moment2.default)(item.fecha).format("DD/MM/YYYY")
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      {
	                        className: "align-baseline bg-light",
	                        style: { textAlign: "center", width: "180px" }
	                      },
	                      (0, _varios.formatMoneda)(item.valor.replace(".", ","), ",", ".", 2)
	                    ),
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      {
	                        className: "align-center",
	                        style: { textAlign: "center", width: "50px" }
	                      },
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          onClick: gestionar(item, 3),
	                          className: "btn btn-sm  btn-danger"
	                        },
	                        _react2.default.createElement("i", { className: "fa fa-trash" }),
	                        " "
	                      )
	                    )
	                  );
	                })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-6 h-100 w-100" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12" },
	          _react2.default.createElement(_graficos.TortaMoneda, {
	            data: data,
	            height: 160,
	            options: options,
	            datos: datos
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "card-body row m-0" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4 row m-0 px-1" },
	              _react2.default.createElement(
	                "div",
	                { className: "row justify-content-center m-0 px-1" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "card text-black m-0",
	                    style: { boxShadow: "0px 0px 10px 1px #aaaaaa" }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "card-img-top" },
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        ref: txtLogo,
	                        name: "logo",
	                        onChange: onChange,
	                        className: "form-select form-select-sm border-transparent",
	                        "aria-label": ".form-select-sm example"
	                      },
	                      tipo && tipo.map(function (item, index) {
	                        return _react2.default.createElement(
	                          "option",
	                          {
	                            key: index,
	                            value: item.idmoneda,
	                            onClick: onSimbolo(item.simbolo)
	                          },
	                          item.simbolo,
	                          ".",
	                          item.descripcion
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "text-center" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "d-flex justify-content-center" },
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        total.toString().includes("-") ? _react2.default.createElement("i", { className: "fas fa-arrow-down text-danger me-2" }) : _react2.default.createElement("i", { className: "fas fa-arrow-up text-success me-2" })
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        {
	                          style: {
	                            color: total.toString().includes("-") ? "#F93154" : "#00B74A"
	                          },
	                          className: "fw-bold"
	                        },
	                        total
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        total.toString().includes("-") ? _react2.default.createElement("i", { className: "fas fa-percent text-danger" }) : _react2.default.createElement("i", { className: "fas fa-percent text-success" })
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4 ml-auto" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-10 ml-auto mt-3" },
	                _react2.default.createElement(
	                  "select",
	                  {
	                    className: "form-select form-select-sm",
	                    disabled: bloqueado,
	                    ref: txtMoneda,
	                    name: "mes",
	                    "aria-label": ".form-select-sm example",
	                    onChange: onChange
	                  },
	                  _react2.default.createElement(
	                    "option",
	                    { value: "" },
	                    "Mes"
	                  ),
	                  _react2.default.createElement(
	                    "option",
	                    { value: "01" },
	                    "Enero"
	                  ),
	                  _react2.default.createElement(
	                    "option",
	                    { value: "02" },
	                    "Febrero"
	                  ),
	                  _react2.default.createElement(
	                    "option",
	                    { value: "03" },
	                    "Marzo"
	                  ),
	                  _react2.default.createElement(
	                    "option",
	                    { value: "04" },
	                    "Abril"
	                  ),
	                  _react2.default.createElement(
	                    "option",
	                    { value: "05" },
	                    "Mayo"
	                  ),
	                  _react2.default.createElement(
	                    "option",
	                    { value: "06" },
	                    "Junio"
	                  ),
	                  _react2.default.createElement(
	                    "option",
	                    { value: "07" },
	                    "Julio"
	                  ),
	                  _react2.default.createElement(
	                    "option",
	                    { value: "08" },
	                    "Agosto"
	                  ),
	                  _react2.default.createElement(
	                    "option",
	                    { value: "09" },
	                    "Septiembre"
	                  ),
	                  _react2.default.createElement(
	                    "option",
	                    { value: "10" },
	                    "Octubre"
	                  ),
	                  _react2.default.createElement(
	                    "option",
	                    { value: "11" },
	                    "Noviembre"
	                  ),
	                  _react2.default.createElement(
	                    "option",
	                    { value: "12" },
	                    "Diciembre"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12" },
	              _react2.default.createElement(_reactChartjs.Line, { options: optionsn, height: 120, data: datan })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_catalogoCrearTasa2.default, {
	      show: catalogo,
	      ope: operacion,
	      idd: idmonedadeta,
	      onHideCancelar: function onHideCancelar() {
	        return onCerrar();
	      }
	    }),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = GestionarMoneda;

/***/ },
/* 7086 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActualizarAfiliados = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoPersonaAthos = __webpack_require__(7034);
	
	var _catalogoPersonaAthos2 = _interopRequireDefault(_catalogoPersonaAthos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ActualizarAfiliados = exports.ActualizarAfiliados = function ActualizarAfiliados(props) {
	  _moment2.default.locale("es-us");
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var fecha = (0, _moment2.default)(fechaSistema).subtract(18, "year").calendar();
	
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var cmbStatus = (0, _react.useRef)();
	  var txtIdOrg = (0, _react.useRef)();
	  var txtNomOrg = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtDomicilio = (0, _react.useRef)();
	  var cmbEstado = (0, _react.useRef)();
	  var cmbMunicipio = (0, _react.useRef)();
	  var cmbCiudad = (0, _react.useRef)();
	  var cmbBaseDatos = (0, _react.useRef)();
	  var txtEmailOrg = (0, _react.useRef)();
	  var txtTlfOrg = (0, _react.useRef)();
	  var txtCelOrg = (0, _react.useRef)();
	  var txtFaxOrg = (0, _react.useRef)();
	  var txtCedula = (0, _react.useRef)();
	  var txtNombreRespon = (0, _react.useRef)();
	  var txtApellidoRespon = (0, _react.useRef)();
	  var txtDireccionRespon = (0, _react.useRef)();
	  var txtEmailRespon = (0, _react.useRef)();
	  var txtTlfRespon = (0, _react.useRef)();
	  var txtCelRespon = (0, _react.useRef)();
	  var txtFechaNac = (0, _react.useRef)();
	  var cmbNacionalidad = (0, _react.useRef)();
	  var cmbSexo = (0, _react.useRef)();
	  var txtItemsfactu = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      activate = _useState2[0],
	      setActivate = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      deshabilitado = _useState4[0],
	      setDeshabilitado = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      habilitadoNU = _useState6[0],
	      setHabilitadoNU = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(),
	      _useState8 = _slicedToArray(_useState7, 2),
	      ciudad = _useState8[0],
	      setCiudad = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(),
	      _useState10 = _slicedToArray(_useState9, 2),
	      municipio = _useState10[0],
	      setMunicipio = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(),
	      _useState12 = _slicedToArray(_useState11, 2),
	      estado = _useState12[0],
	      setEstado = _useState12[1];
	
	  var _useState13 = (0, _react.useState)([]),
	      _useState14 = _slicedToArray(_useState13, 2),
	      baseDatos = _useState14[0],
	      setBaseDatos = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(null),
	      _useState16 = _slicedToArray(_useState15, 2),
	      body = _useState16[0],
	      setBody = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      mostrar3 = _useState18[0],
	      setMostrar3 = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      operacion = _useState20[0],
	      setOperacion = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      operacionPer = _useState22[0],
	      setOperacionPer = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(),
	      _useState24 = _slicedToArray(_useState23, 2),
	      tecla = _useState24[0],
	      setTecla = _useState24[1];
	
	  var _useState25 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState26 = _slicedToArray(_useState25, 2),
	      mensaje = _useState26[0],
	      setMensaje = _useState26[1];
	
	  var _useState27 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState28 = _slicedToArray(_useState27, 2),
	      mensajesino = _useState28[0],
	      setMensajesino = _useState28[1];
	
	  var _useState29 = (0, _react.useState)({
	    imagen: "subir.png",
	    imagenactual: "subir.png"
	  }),
	      _useState30 = _slicedToArray(_useState29, 2),
	      imagen = _useState30[0],
	      setImagen = _useState30[1];
	
	  var _useState31 = (0, _react.useState)({
	    ticketnuevo: "athos.jpg",
	    ticketactual: "athos.jpg"
	  }),
	      _useState32 = _slicedToArray(_useState31, 2),
	      ticket = _useState32[0],
	      setTicket = _useState32[1];
	
	  var _useState33 = (0, _react.useState)({
	    imagen: op.conexion + "/imagen?img=subir.png"
	  }),
	      _useState34 = _slicedToArray(_useState33, 2),
	      pathImage = _useState34[0],
	      setPathImage = _useState34[1];
	
	  var _useState35 = (0, _react.useState)({
	    ticket: op.conexion + "/imagen?img=athos.jpg"
	  }),
	      _useState36 = _slicedToArray(_useState35, 2),
	      pathTicket = _useState36[0],
	      setPathTicket = _useState36[1];
	
	  /* bloquear tab */
	
	
	  var _useState37 = (0, _react.useState)({
	    tab1: "tab",
	    tab2: ""
	  }),
	      _useState38 = _slicedToArray(_useState37, 2),
	      tabIndex = _useState38[0],
	      setTabIndex = _useState38[1];
	  /* activar tab */
	
	
	  var _useState39 = (0, _react.useState)({
	    tab1: "nav-link active",
	    tab2: "nav-link"
	  }),
	      _useState40 = _slicedToArray(_useState39, 2),
	      activeTab = _useState40[0],
	      setACtiveTab = _useState40[1];
	  /* mostar tabPanel */
	
	
	  var _useState41 = (0, _react.useState)({
	    tab1: "tab-pane fade show active",
	    tab2: "tab-pane fade"
	  }),
	      _useState42 = _slicedToArray(_useState41, 2),
	      tabPanel = _useState42[0],
	      setTabPanel = _useState42[1];
	  /* validar tab */
	
	
	  var _useState43 = (0, _react.useState)({
	    tab1: "true",
	    tab2: "false"
	  }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      tabvalid = _useState44[0],
	      setTabValid = _useState44[1];
	
	  var CatalogoEstado = function CatalogoEstado() {
	    var campos = "*";
	    var nomtab = "estado";
	    var orden = "idestado";
	    var endpoint = op.conexion + "/api/athos/consulta/seleccionarregistros?campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setEstado(response.data);
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var seleccionarBasedeDatos = function seleccionarBasedeDatos() {
	    var campos = "*";
	    var nomtab = "basedatos";
	    var orden = "idbasedatos";
	    var endpoint = op.conexion + "/api/athos/consulta/seleccionarregistros?campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setBaseDatos(response.data);
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var seleccionarCiudad = function seleccionarCiudad(id, idciu) {
	    var campos = "*";
	    var nomtab = "ciudad";
	    var nomid = "idmunicipio";
	    var endpoint = op.conexion + "/api/athos/consulta/modelirows?campos=" + campos + "&id=" + id + "&nomtab=" + nomtab + "&nomid=" + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.length > 0) {
	          setCiudad(response.data);
	          cmbCiudad.current.value = idciu;
	          seleccionarMunicipio(cmbEstado.current.value, id);
	        }
	      }
	
	      setActivate(false);
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var seleccionarMunicipio = function seleccionarMunicipio(id, idmun) {
	    setActivate(true);
	    var campos = "*";
	    var nomtab = "municipio";
	    var nomid = "idestado";
	
	    var endpoint = op.conexion + "/api/athos/consulta/modelirows?campos=" + campos + "&id=" + id + "&nomtab=" + nomtab + "&nomid=" + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.length > 0) {
	          setMunicipio(response.data);
	          cmbMunicipio.current.value = idmun;
	        }
	      }
	
	      setActivate(false);
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var seleccionarCiudadCampos = function seleccionarCiudadCampos(data, dataper) {
	    var campos = "*";
	    var nomtab = "ciudad";
	    var nomid = "idmunicipio";
	    var endpoint = op.conexion + "/api/athos/consulta/modelirows?campos=" + campos + "&id=" + data.municipio.trim() + "&nomtab=" + nomtab + "&nomid=" + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.length > 0) {
	          setCiudad(response.data);
	          llenarCampos(data, dataper);
	        }
	      }
	
	      setActivate(false);
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var seleccionarMunicipioCampos = function seleccionarMunicipioCampos(data, dataper) {
	    var campos = "*";
	    var nomtab = "municipio";
	    var nomid = "idestado";
	
	    var endpoint = op.conexion + "/api/athos/consulta/modelirows?campos=" + campos + "&id=" + data.estado.trim() + "&nomtab=" + nomtab + "&nomid=" + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.length > 0) {
	          setMunicipio(response.data);
	          seleccionarCiudadCampos(data, dataper);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var datosPersona = function datosPersona(data) {
	    var campos = "*";
	    var nomtab = "persona";
	    var nomid = "cedula";
	
	    var endpoint = op.conexion + "/api/athos/consulta/modeli?campos=" + campos + "&id=" + data.responsable + "&nomtab=" + nomtab + "&nomid=" + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        seleccionarMunicipioCampos(data, response);
	      }
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarOrganizacion = function seleccionarOrganizacion(id) {
	    setActivate(true);
	    var campos = "*";
	    var nomtab = "organizacion";
	    var nomid = "idorganizacion";
	    var endpoint = op.conexion + "/api/athos/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        datosPersona(response.data);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleUpload = function handleUpload(e) {
	    if (e.target.files && e.target.files.length > 0) {
	      var file = e.target.files[0];
	      var name = e.target;
	
	      if (file.type.includes("image")) {
	        var reader = new FileReader();
	        reader.readAsDataURL(file);
	
	        if (name.name === "imagen") {
	          reader.onload = function load() {
	            setPathImage(Object.assign({}, pathImage, { imagen: reader.result }));
	          };
	        }
	
	        if (name.name === "ticket") {
	          reader.onload = function load() {
	            setPathTicket(Object.assign({}, pathTicket, { ticket: reader.result }));
	          };
	        }
	      }
	
	      if (name.name === "imagen") {
	        setImagen(Object.assign({}, imagen, _defineProperty({}, e.target.name, e.target.files[0])));
	      }
	
	      if (name.name === "ticket") {
	        setTicket(Object.assign({}, ticket, { ticketnuevo: e.target.files[0] }));
	      }
	    }
	  };
	
	  var cancelar = function cancelar() {
	    setTabIndex({ tab1: "tab", tab2: "" });
	    props.onHideCancela();
	    blanquear();
	  };
	
	  var blanquear = function blanquear() {
	    txtIdOrg.current.value = "";
	    txtNomOrg.current.value = "";
	    txtDomicilio.current.value = "";
	    cmbRif.current.value = "";
	    txtRif.current.value = "";
	    txtEmailOrg.current.value = "";
	    txtTlfOrg.current.value = "";
	    txtCelOrg.current.value = "";
	    cmbCiudad.current.value = "";
	    cmbMunicipio.current.value = "";
	    cmbEstado.current.value = "";
	    cmbBaseDatos.current.value = "";
	    cmbStatus.current.value = "";
	    txtItemsfactu.current.value = "";
	
	    txtCedula.current.value = "";
	    txtNombreRespon.current.value = "";
	    txtApellidoRespon.current.value = "";
	    txtDireccionRespon.current.value = "";
	    txtEmailRespon.current.value = "";
	    txtTlfRespon.current.value = "";
	    txtCelRespon.current.value = "";
	    txtFechaNac.current.value = "";
	    cmbNacionalidad.current.value = "";
	    cmbSexo.current.value = "";
	
	    setMunicipio();
	    setCiudad();
	    setDeshabilitado(true);
	    setImagen({ imagen: "subir.png", imagenactual: "subir.png" });
	    setPathImage({ imagen: op.conexion + "/imagen?img=subir.png" });
	
	    setTicket({ ticketnuevo: "subir.png", ticketactual: "athos.jpg" });
	    setPathTicket({ ticket: op.conexion + "/imagen?img=athos.jpg" });
	  };
	
	  var onChange = function onChange(event) {
	    if (event.target.name === "idestado") {
	      cmbEstado.current.value = event.target.value;
	      setMunicipio();
	      setCiudad();
	
	      if (event.target.value !== "") {
	        seleccionarMunicipio(event.target.value, "");
	      }
	    } else if (event.target.name === "idmunicipio") {
	      cmbMunicipio.current.value = event.target.value;
	      setCiudad();
	
	      if (event.target.value !== "") {
	        seleccionarCiudad(event.target.value, "");
	      }
	    } else if (event.target.name === "idciudad") {
	      cmbCiudad.current.value = event.target.value;
	    } else if (event.target.name === "riforg" || event.target.name === "telefonoorg" || event.target.name === "celularorg" || event.target.name === "items") {
	      (0, _varios.validaSoloNumero)(event);
	    } /*  else if(event.target.name === 'inputRif'){
	            validarRif()
	        } */
	  };
	
	  var handleCloseCatalogoPer = function handleCloseCatalogoPer() {
	    setMostrar3(false);
	  };
	
	  var handleAceptaCatalogoPer = function handleAceptaCatalogoPer(values) {
	    setMostrar3(false);
	    txtCedula.current.value = values.cedPer;
	    txtNombreRespon.current.value = values.nomPer;
	    txtApellidoRespon.current.value = values.apePer;
	    txtDireccionRespon.current.value = values.direPer;
	    txtEmailRespon.current.value = values.correoPer;
	    txtTlfRespon.current.value = values.tlf1Per;
	    txtCelRespon.current.value = values.tlf2Per;
	    txtFechaNac.current.value = (0, _moment2.default)(values.fnacPer).format("YYYY-MM-DD");
	    cmbNacionalidad.current.value = values.nacPer;
	    cmbSexo.current.value = values.sexoPer;
	  };
	
	  var validarPersona = function validarPersona(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        setTecla(event.which);
	        datosRes(event.target.value);
	      } else {
	        txtNombreRespon.current.value = "";
	      }
	    }
	  };
	
	  var datosRes = function datosRes(cedula) {
	    var campos = "*";
	    var nomtab = "persona";
	    var nomid = "cedula";
	
	    var endpoint = op.conexion + "/api/athos/consulta/modeli?campos=" + campos + "&id=" + cedula + "&nomtab=" + nomtab + "&nomid=" + nomid;
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setHabilitadoNU(true);
	        txtNombreRespon.current.value = "";
	        txtApellidoRespon.current.value = "";
	        txtDireccionRespon.current.value = "";
	        txtEmailRespon.current.value = "";
	        txtTlfRespon.current.value = "";
	        txtCelRespon.current.value = "";
	        txtFechaNac.current.value = "";
	        cmbNacionalidad.current.value = "V";
	        cmbSexo.current.value = "M";
	        if (response.data !== "") {
	          setHabilitadoNU(false);
	          setOperacionPer(0);
	          txtNombreRespon.current.value = response.data.nombres;
	          txtApellidoRespon.current.value = response.data.apellidos;
	          txtDireccionRespon.current.value = response.data.direccion;
	          txtEmailRespon.current.value = response.data.correoe;
	          txtTlfRespon.current.value = response.data.tlf1;
	          txtCelRespon.current.value = response.data.tlf2;
	          txtFechaNac.current.value = (0, _moment2.default)(response.data.fnacimiento).format("YYYY-MM-DD");
	          cmbNacionalidad.current.value = response.data.nacionalidad;
	          cmbSexo.current.value = response.data.sexo;
	          if (tecla === 13) {
	            btnAcepta.current.focus();
	          }
	        } else {
	          setOperacionPer(1);
	          setHabilitadoNU(true);
	          if (tecla === 13) {
	            setTimeout(function () {
	              txtNombreRespon.current.focus();
	            }, 100);
	          }
	        }
	      }
	
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    if (event.which === 13) {
	      var valido;
	      if (event.target.id === "inputRazonSoc") {
	        txtNomOrg.current.focus();
	      } else if (event.target.id === "inputNombre") {
	        cmbRif.current.focus();
	      } else if (event.target.id === "inputRif") {
	        txtDomicilio.current.focus();
	      } else if (event.target.id === "inputDomicilio") {
	        cmbEstado.current.focus();
	      } else if (event.target.id === "inputEmailOrg") {
	        txtTlfOrg.current.focus();
	      } else if (event.target.id === "inputTlfOrg") {
	        txtCelOrg.current.focus();
	      } else if (event.target.id === "inputNombreRespon") {
	        txtApellidoRespon.current.focus();
	      } else if (event.target.id === "inputApellidoRespon") {
	        txtDireccionRespon.current.focus();
	      } else if (event.target.id === "inputEmailRespon") {
	        valido = (0, _varios.validaEmail)(event.target.value);
	        if (valido) {
	          txtTlfRespon.current.focus();
	        } else {
	          if (event.target.value !== "") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "Formato de Email invalido.",
	              icono: "informacion"
	            });
	            event.target.value = "";
	          } else {
	            txtTlfRespon.current.focus();
	          }
	        }
	      } else if (event.target.id === "inputTlfRespon") {
	        txtCelRespon.current.focus();
	      } else if (event.target.id === "inputCelRespon") {
	        txtFechaNac.current.focus();
	      } else if (event.target.id === "inputFechaNac") {
	        cmbNacionalidad.current.focus();
	      }
	    } else if (typeof event.which === "undefined") {
	      if (event.target.id === "inputEmailOrg") {
	        valido = (0, _varios.validaEmail)(event.target.value);
	        if (valido) {
	          txtTlfOrg.current.focus();
	        } else {
	          if (event.target.value !== "") {
	            event.target.value = "";
	          } else {
	            txtTlfOrg.current.focus();
	          }
	        }
	      } else if (event.target.id === "inputTlfOrg") {
	        txtCelOrg.current.focus();
	      } else if (event.target.id === "inputCelOrg") {
	        txtFaxOrg.current.focus();
	      } else if (event.target.id === "inputEmailRespon") {
	        valido = (0, _varios.validaEmail)(event.target.value);
	        if (valido) {
	          txtTlfRespon.current.focus();
	        } else {
	          if (event.target.value !== "") {
	            event.target.value = "";
	          } else {
	            txtTlfRespon.current.focus();
	          }
	        }
	      } else if (event.target.id === "inputTlfRespon") {
	        txtCelRespon.current.focus();
	      } else if (event.target.id === "inputCelRespon") {
	        txtFechaNac.current.focus();
	      } else {
	        return false;
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	    var sigue = true;
	    var mensaje = "";
	    if (txtNomOrg.current.value.trim() === "") {
	      mensaje = "El Nombre de la Organizacion no debe estar vacio";
	      sigue = false;
	      setTabIndex(0);
	      txtNomOrg.current.focus();
	    } else if (txtRif.current.value.trim() === "") {
	      mensaje = "El Rif de la Organizacion no debe estar vacio";
	      sigue = false;
	      setTabIndex(0);
	      txtRif.current.focus();
	    } else if (txtDomicilio.current.value.trim() === "") {
	      mensaje = "El Domicilio de la Organizacion no debe estar vacio";
	      sigue = false;
	      setTabIndex(0);
	      txtDomicilio.current.focus();
	    } else if (cmbEstado.current.value.trim() === "") {
	      mensaje = "Por Favor Seleccione el Estado";
	      sigue = false;
	      setTabIndex(0);
	      cmbEstado.current.focus();
	    } else if (cmbMunicipio.current.value.trim() === "") {
	      mensaje = "Por Favor Seleccione el Municipio";
	      sigue = false;
	      setTabIndex(0);
	      cmbMunicipio.current.focus();
	    } else if (cmbCiudad.current.value.trim() === "") {
	      mensaje = "Por Favor Seleccione la Ciudad";
	      sigue = false;
	      setTabIndex(0);
	      cmbCiudad.current.focus();
	    } else if (cmbBaseDatos.current.value.trim() === "") {
	      mensaje = "Por Favor Seleccione la base de Datos";
	      sigue = false;
	      setTabIndex(0);
	      cmbBaseDatos.current.focus();
	    } else if (cmbStatus.current.value.trim() === "") {
	      mensaje = "Por Favor Seleccione el Estatus";
	      sigue = false;
	      setTabIndex(0);
	      cmbStatus.current.focus();
	    } else if (txtCedula.current.value.trim() === "") {
	      mensaje = "La cedula no debe estar vacia";
	      sigue = false;
	      setTabIndex(Object.assign({ tab1: "tab" }, tabIndex));
	      txtCedula.current.focus();
	    } else if (txtNombreRespon.current.value.trim() === "") {
	      mensaje = "Los nombres no deben estar vacios";
	      sigue = false;
	      setTabIndex({ tab1: "", tab2: "tab" });
	      setTabIndex(Object.assign({ tab1: "tab" }, tabIndex));
	      setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
	      setTabValid({ tab1: "false", tab2: "true" });
	      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
	      txtNombreRespon.current.focus();
	    } else if (txtApellidoRespon.current.value.trim() === "") {
	      mensaje = "Los Apellidos no deben estar vacio";
	      sigue = false;
	      setTabIndex({ tab1: "", tab2: "tab" });
	      setTabIndex(Object.assign({ tab1: "tab" }, tabIndex));
	      setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
	      setTabValid({ tab1: "false", tab2: "true" });
	      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
	
	      setTabIndex(1);
	      txtApellidoRespon.current.focus();
	    } else if (txtDireccionRespon.current.value.trim() === "") {
	      mensaje = "La direccion del Responsable no debe estar vacia";
	      sigue = false;
	      setTabIndex({ tab1: "", tab2: "tab" });
	      setTabIndex(Object.assign({ tab1: "tab" }, tabIndex));
	      setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
	      setTabValid({ tab1: "false", tab2: "true" });
	      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
	
	      setTabIndex(1);
	      txtDireccionRespon.current.focus();
	    } else if (txtFechaNac.current.value.trim() === "") {
	      mensaje = "La fecha de nacimiento no debe estar vacia";
	      sigue = false;
	      setTabIndex({ tab1: "", tab2: "tab" });
	      setTabIndex(Object.assign({ tab1: "tab" }, tabIndex));
	      setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
	      setTabValid({ tab1: "false", tab2: "true" });
	      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
	
	      setTabIndex(1);
	      txtFechaNac.current.focus();
	    }
	
	    if (sigue) {
	      var org = [];
	      var datoPer = [];
	
	      org.push({
	        idorganizacion: txtIdOrg.current.value === "" ? 0 : txtIdOrg.current.value,
	        estado: cmbEstado.current.value,
	        municipio: cmbMunicipio.current.value,
	        ciudad: cmbCiudad.current.value,
	        nombre: txtNomOrg.current.value,
	        direccion: txtDomicilio.current.value,
	        tlf1: txtTlfOrg.current.value,
	        tlf2: txtCelOrg.current.value,
	        correoe: txtEmailOrg.current.value,
	        rif: cmbRif.current.value + txtRif.current.value,
	        responsable: txtCedula.current.value,
	        idbasedatos: cmbBaseDatos.current.value,
	        statusorg: cmbStatus.current.value,
	        c_items: parseInt(txtItemsfactu.current.value)
	      });
	      datoPer.push({
	        apellidos: txtApellidoRespon.current.value.trim(),
	        cedula: txtCedula.current.value,
	        correoe: txtEmailRespon.current.value,
	        direccion: txtDireccionRespon.current.value.trim(),
	        fnacimiento: txtFechaNac.current.value,
	        nacionalidad: cmbNacionalidad.current.value,
	        nombres: txtNombreRespon.current.value.trim(),
	        sexo: cmbSexo.current.value,
	        tlf1: txtTlfRespon.current.value,
	        tlf2: txtCelRespon.current.value
	      });
	
	      var upload = new FormData();
	
	      upload.append("operacionper", operacionPer);
	      upload.append("org", JSON.stringify(org));
	      upload.append("perso", JSON.stringify(datoPer));
	      upload.append("organizacion", cmbRif.current.value + txtRif.current.value);
	      upload.append("imagenactual", imagen.imagenactual);
	      upload.append("imagennueva", imagen.imagen);
	
	      upload.append("ticketactual", ticket.ticketactual);
	      upload.append("ticketnuevo", ticket.ticketnuevo);
	
	      setBody(upload);
	
	      var msg = "";
	      if (props.operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (props.operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (props.operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificacion",
	        texto: mensaje,
	        icono: "informacion"
	      });
	      setTimeout(function () {
	        txtNombreRespon.current.focus();
	      }, 500);
	    }
	  };
	
	  var procesarAfiliado = function procesarAfiliado() {
	    setActivate(true);
	
	    var endpoint = op.conexion + "/api/athos/organizacion/actualizarorganizacion/" + props.operacion;
	
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token,
	        "Content-Type": "multipart/form-data"
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (props.operacion === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro creado correctamente",
	            icono: "exito"
	          });
	        } else if (props.operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro modificado correctamente",
	            icono: "exito"
	          });
	        } else if (props.operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro eliminado correctamente",
	            icono: "exito"
	          });
	        }
	      }
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var tabs = function tabs(vl) {
	    return function (e) {
	      e.preventDefault();
	
	      if (vl === 2) {
	        setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
	        setTabValid({ tab1: "false", tab2: "true" });
	        setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
	      } else {
	        setACtiveTab({ tab1: "nav-link active", tab2: "nav-link " });
	        setTabValid({ tab1: "true", tab2: "false" });
	        setTabPanel({
	          tab1: "tab-pane fade show active",
	          tab2: "tab-pane fade "
	        });
	      }
	    };
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarAfiliado();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    props.onHideAcepta();
	    cancelar();
	  };
	
	  var llenarCampos = function llenarCampos(data, dataper) {
	    if (data.logo.trim() !== "subir.png" && data.logo.trim() !== null && data.logo.trim() !== "") {
	      setImagen(Object.assign({}, imagen, { imagenactual: data.logo.trim() }));
	      setPathImage({
	        imagen: op.conexion + "/imagen?img=athos/organizacion/" + data.logo.trim()
	      });
	    }
	
	    if (data.ticket.trim() !== "athos.jpg" && data.ticket.trim() !== null && data.ticket.trim() !== "") {
	      setTicket(Object.assign({}, ticket, { ticketactual: data.ticket.trim() }));
	      setPathTicket({
	        ticket: op.conexion + "/imagen?img=athos/organizacion/" + data.ticket.trim()
	      });
	    }
	
	    if (props.operacion === 4 || props.operacion === 3) {
	      setDeshabilitado(true);
	    } else {
	      setDeshabilitado(false);
	    }
	    setHabilitadoNU(false);
	    txtIdOrg.current.value = data.idorganizacion;
	    txtItemsfactu.current.value = data.c_items;
	    txtNomOrg.current.value = data.nombre.trim();
	    txtDomicilio.current.value = data.direccion.trim();
	    cmbRif.current.value = isNaN(data.rif.substring(0, 1)) ? data.rif.substring(0, 1) : "";
	    txtRif.current.value = isNaN(data.rif.substring(0, 1)) ? data.rif.substring(1, data.rif.trim().length) : !isNaN(data.rif.substring(0, 1)) ? data.rif.substring(0, data.rif.trim().length) : "";
	    txtEmailOrg.current.value = data.correoe === null ? data.correoe : data.correoe.trim();
	    txtTlfOrg.current.value = data.tlf1 === null ? data.tlf1 : data.tlf1.trim();
	    txtCelOrg.current.value = data.tlf2 === null ? data.tlf2 : data.tlf2.trim();
	    cmbCiudad.current.value = data.ciudad === null ? "" : data.ciudad.trim();
	    cmbMunicipio.current.value = data.municipio === null ? "" : data.municipio.trim();
	    cmbEstado.current.value = data.estado === null ? "" : data.estado.trim();
	    cmbBaseDatos.current.value = data.idbasedatos === null ? "" : data.idbasedatos.trim();
	    cmbStatus.current.value = data.statusorg === null ? "" : data.statusorg;
	    txtCedula.current.value = data.responsable;
	
	    setHabilitadoNU(true);
	    txtNombreRespon.current.value = "";
	    txtApellidoRespon.current.value = "";
	    txtDireccionRespon.current.value = "";
	    txtEmailRespon.current.value = "";
	    txtTlfRespon.current.value = "";
	    txtCelRespon.current.value = "";
	    txtFechaNac.current.value = "";
	    cmbNacionalidad.current.value = "V";
	    cmbSexo.current.value = "M";
	    if (dataper.data !== "") {
	      setHabilitadoNU(false);
	      setOperacionPer(0);
	      txtNombreRespon.current.value = dataper.data.nombres;
	      txtApellidoRespon.current.value = dataper.data.apellidos;
	      txtDireccionRespon.current.value = dataper.data.direccion;
	      txtEmailRespon.current.value = dataper.data.correoe;
	      txtTlfRespon.current.value = dataper.data.tlf1;
	      txtCelRespon.current.value = dataper.data.tlf2;
	      txtFechaNac.current.value = (0, _moment2.default)(dataper.data.fnacimiento).format("YYYY-MM-DD");
	      cmbNacionalidad.current.value = dataper.data.nacionalidad;
	      cmbSexo.current.value = dataper.data.sexo;
	      btnAcepta.current.focus();
	    } else {
	      setOperacionPer(1);
	      setHabilitadoNU(true);
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarBasedeDatos();
	    CatalogoEstado();
	  }, []);
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        setOperacion(props.operacion);
	        if (props.operacion !== 1) {
	          seleccionarOrganizacion(props.organizacion.idorganizacion);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          operacion === 1 ? "Agregar Afiliado." : operacion === 2 ? "Editar Afiliado." : operacion === 3 ? "Eliminar Afiliado." : "Consultar Afiliado."
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "ul",
	            { className: "nav nav-tabs mb-3", id: "ex-with-icons", role: "tablist" },
	            _react2.default.createElement(
	              "li",
	              { className: "nav-item", role: "presentation" },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: activeTab.tab1,
	                  id: "ex-with-icons-tab-1",
	                  style: { backgroundColor: "#25d366" },
	                  onClick: tabs(1),
	                  "data-mdb-toggle": tabIndex.tab1,
	                  href: "#tab1",
	                  role: "tab",
	                  "aria-controls": "tab1",
	                  "aria-selected": tabvalid.tab1
	                },
	                _react2.default.createElement("i", { className: "fas fa-chart-pie fa-fw me-2" }),
	                "Datos Gnr."
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { className: "nav-item", role: "presentation" },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: activeTab.tab2,
	                  id: "ex-with-icons-tab-2",
	                  style: { backgroundColor: "#55acee" },
	                  onClick: tabs(2),
	                  "data-mdb-toggle": tabIndex.tab2,
	                  href: "#tab2",
	                  role: "tab",
	                  "aria-controls": "tab2",
	                  "aria-selected": tabvalid.tab2
	                },
	                _react2.default.createElement("i", { className: "fas fa-chart-line fa-fw me-2" }),
	                "Responsable"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "tab-content", id: "ex-with-icons-content" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: tabPanel.tab1,
	                id: "tab1",
	                role: "tabpanel",
	                "aria-labelledby": "ex-with-icons-tab-1"
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "container-fluid row bg-light h-100 py-4 px-4 rounded mx-auto" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group mb-3 input-group-sm col-sm-3",
	                    style: {
	                      visibility: props.menu === "sistema" ? "visible" : "hidden"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Codigo:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    className: "form-control",
	                    disabled: true,
	                    ref: txtIdOrg,
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group mb-3 input-group-sm col-sm-3 px-1",
	                    style: {
	                      visibility: props.menu === "sistema" ? "visible" : "hidden"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Cantidad Items Factura:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    className: "form-control",
	                    disabled: operacion === 1 || operacion === 2 ? false : true,
	                    ref: txtItemsfactu,
	                    name: "items",
	                    onChange: onChange,
	                    maxLength: 2,
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement("div", { className: "col-md-4" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Rif:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      disabled: operacion === 1 ? false : true,
	                      ref: cmbRif,
	                      className: "col-2 form-control form-control-sm",
	                      id: "inputLetraRif"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "J" },
	                      "J"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "V" },
	                      "V"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "G" },
	                      "G"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "E" },
	                      "E"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "P" },
	                      "P"
	                    )
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: operacion === 1 ? false : true,
	                    ref: txtRif,
	                    maxLength: 9,
	                    className: "form-control form-control-sm",
	                    name: "riforg",
	                    placeholder: "123456789",
	                    id: "inputRif",
	                    onChange: onChange,
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-8" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Nombre:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    className: "form-control uppercase",
	                    disabled: deshabilitado,
	                    ref: txtNomOrg,
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputNombre",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Direcci\xF3n:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: deshabilitado,
	                    ref: txtDomicilio,
	                    className: "form-control uppercase",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputDomicilio",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Estado:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-select",
	                      "aria-label": "Default select example col-md-4",
	                      name: "idestado",
	                      disabled: deshabilitado,
	                      ref: cmbEstado,
	                      onChange: onChange,
	                      id: "inputFechaReg"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "SELECCIONAR ESTADO"
	                    ),
	                    estado && estado.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idestado },
	                        " ",
	                        item.nombre,
	                        " "
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Municipio:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-select",
	                      "aria-label": "Default select example col-md-4",
	                      name: "idmunicipio",
	                      disabled: deshabilitado,
	                      ref: cmbMunicipio,
	                      onChange: onChange
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "SELECCIONAR MUNICIPIO"
	                    ),
	                    municipio && municipio.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idmunicipio },
	                        " ",
	                        item.nombre,
	                        " "
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Ciudad:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-select",
	                      "aria-label": "Default select example col-md-4",
	                      name: "idciudad",
	                      disabled: deshabilitado,
	                      ref: cmbCiudad,
	                      onChange: onChange
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "SELECCIONAR CIUDAD"
	                    ),
	                    ciudad && ciudad.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idciudad },
	                        " ",
	                        item.nombre,
	                        " "
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-6" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "E-mail:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: deshabilitado,
	                    ref: txtEmailOrg,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputEmailOrg",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-3" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Telefono:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: deshabilitado,
	                    maxLength: 11,
	                    ref: txtTlfOrg,
	                    name: "telefonoorg",
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputTlfOrg",
	                    onChange: onChange,
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-3" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Celular:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: deshabilitado,
	                    maxLength: 11,
	                    ref: txtCelOrg,
	                    name: "celularorg",
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputCelOrg",
	                    onChange: onChange,
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group mb-3 input-group-sm col-sm-5",
	                    style: {
	                      visibility: props.menu === "sistema" ? "visible" : "hidden"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Base de Datos:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-select",
	                      "aria-label": "Default select example col-md-4",
	                      name: "conexion",
	                      disabled: deshabilitado,
	                      ref: cmbBaseDatos,
	                      onChange: onChange
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "SELECCIONAR CONEXION"
	                    ),
	                    baseDatos && baseDatos.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idbasedatos },
	                        " ",
	                        item.nombre.toUpperCase(),
	                        " "
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group mb-3 input-group-sm col-sm-5",
	                    style: {
	                      visibility: props.menu === "sistema" ? "visible" : "hidden"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Estatus:",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-select",
	                      "aria-label": "Default select example col-md-4",
	                      name: "status",
	                      disabled: deshabilitado,
	                      ref: cmbStatus,
	                      onChange: onChange
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "SELECCIONAR ESTATUS"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: true },
	                      "ACTIVO"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: false },
	                      "INACTIVO"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row col-md-12" },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "row col-md-6 mx-auto d-flex justify-content-center py-2",
	                      style: { height: 150, width: 150 }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 mx-auto d-flex justify-content-center" },
	                      _react2.default.createElement("img", {
	                        src: pathImage.imagen,
	                        className: "rounded-circle shadow position-absolute",
	                        style: { height: 150, width: 150 },
	                        alt: ""
	                      }),
	                      _react2.default.createElement("input", {
	                        type: "file",
	                        disabled: deshabilitado,
	                        style: {
	                          opacity: 0,
	                          height: 150,
	                          width: 150
	                        },
	                        onChange: handleUpload,
	                        name: "imagen",
	                        accept: "image/jpeg, image/png",
	                        className: "btn rounded-circle"
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 mx-auto d-flex justify-content-center" },
	                      _react2.default.createElement(
	                        "h2",
	                        null,
	                        "Logo"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "row col-md-6 mx-auto d-flex justify-content-center py-2",
	                      style: { height: 150, width: 150 }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 mx-auto d-flex justify-content-center" },
	                      _react2.default.createElement("img", {
	                        src: pathTicket.ticket,
	                        className: "rounded-circle shadow position-absolute",
	                        style: { height: 150, width: 150 },
	                        alt: ""
	                      }),
	                      _react2.default.createElement("input", {
	                        type: "file",
	                        disabled: deshabilitado,
	                        style: {
	                          opacity: 0,
	                          height: 150,
	                          width: 150
	                        },
	                        onChange: handleUpload,
	                        name: "ticket",
	                        accept: "image/jpeg, image/png",
	                        className: "btn rounded-circle"
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-12 mx-auto d-flex justify-content-center" },
	                      _react2.default.createElement(
	                        "h2",
	                        null,
	                        "Ticket"
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: tabPanel.tab2,
	                id: "tab2",
	                role: "tabpanel",
	                "aria-labelledby": "ex-with-icons-tab-2"
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "container-fluid row bg-light h-100 py-4 px-2 rounded mx-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-5" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Cedula:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      disabled: !habilitadoNU,
	                      ref: cmbNacionalidad,
	                      className: "form-select col-md-3",
	                      "aria-label": "Default select example "
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { key: "0", value: "V" },
	                      "V"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { key: "1", value: "E" },
	                      "E"
	                    )
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: deshabilitado,
	                    ref: txtCedula,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: validarPersona,
	                    onBlur: validarPersona
	                  })
	                ),
	                _react2.default.createElement("div", { className: "col-md-1" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Sexo:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      disabled: !habilitadoNU,
	                      ref: cmbSexo,
	                      className: "form-select",
	                      "aria-label": "Default select example "
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { key: "0", value: "M" },
	                      "M"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { key: "1", value: "F" },
	                      "F"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Fecha Nacimiento:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "date",
	                    disabled: !habilitadoNU,
	                    ref: txtFechaNac,
	                    max: (0, _moment2.default)(fecha).format("YYYY-MM-DD"),
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputFechaNac",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-6" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Nombres:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: !habilitadoNU,
	                    ref: txtNombreRespon,
	                    className: "form-control text-uppercase",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputNombreRespon",
	                    name: "inputNombreRespon",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-6" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Apellidos:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: !habilitadoNU,
	                    ref: txtApellidoRespon,
	                    className: "form-control text-uppercase",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputApellidoRespon",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Direccion:"
	                  ),
	                  _react2.default.createElement("textarea", {
	                    disabled: !habilitadoNU,
	                    ref: txtDireccionRespon,
	                    className: "form-control text-uppercase",
	                    id: "textAreaExample",
	                    rows: "3"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "E-mail:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: !habilitadoNU,
	                    ref: txtEmailRespon,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputEmailRespon",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Telefono:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: !habilitadoNU,
	                    maxLength: 11,
	                    ref: txtTlfRespon,
	                    onChange: _varios.validaSoloNumero,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputTlfRespon",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Celular:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: !habilitadoNU,
	                    ref: txtCelRespon,
	                    maxLength: 11,
	                    onChange: _varios.validaSoloNumero,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputCelRespon",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          type: "button",
	          ref: btnAcepta,
	          onClick: onChangeValidar,
	          disabled: operacion === 4 ? true : false,
	          style: {
	            margin: "1px",
	            visibility: operacion === 4 ? "hidden" : "visible"
	          },
	          className: "col-sm-2 btn btn-success btn-sm rounded-pill"
	        },
	        _react2.default.createElement("i", { className: "far fa-check-circle" }),
	        "Aceptar"
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          type: "button",
	          ref: btnCancela,
	          onClick: cancelar,
	          style: { margin: "1px" },
	          className: "col-sm-2 btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement("i", { className: "fas fa-window-close" }),
	        "Cancelar"
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_catalogoPersonaAthos2.default, {
	      titulo: "",
	      mensaje: "",
	      show: mostrar3,
	      onHideCancelaCatPer: handleCloseCatalogoPer,
	      onHideAceptaCatPer: handleAceptaCatalogoPer
	    })
	  );
	};

/***/ },
/* 7087 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActualizarOrganizacion = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoPersona = __webpack_require__(64);
	
	var _catalogoPersona2 = _interopRequireDefault(_catalogoPersona);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ActualizarOrganizacion = exports.ActualizarOrganizacion = function ActualizarOrganizacion(props) {
	  _moment2.default.locale("es-us");
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var organizacion = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var fecha = (0, _moment2.default)(fechaSistema).subtract(18, "year").calendar();
	
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtIdOrg = (0, _react.useRef)();
	  var txtNomOrg = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtDomicilio = (0, _react.useRef)();
	  var cmbEstado = (0, _react.useRef)();
	  var cmbMunicipio = (0, _react.useRef)();
	  var cmbCiudad = (0, _react.useRef)();
	  var txtEmailOrg = (0, _react.useRef)();
	  var txtTlfOrg = (0, _react.useRef)();
	  var txtCelOrg = (0, _react.useRef)();
	  var txtFaxOrg = (0, _react.useRef)();
	  var txtCedula = (0, _react.useRef)();
	  var txtNombreRespon = (0, _react.useRef)();
	  var txtApellidoRespon = (0, _react.useRef)();
	  var txtDireccionRespon = (0, _react.useRef)();
	  var txtEmailRespon = (0, _react.useRef)();
	  var txtTlfRespon = (0, _react.useRef)();
	  var txtCelRespon = (0, _react.useRef)();
	  var txtFechaNac = (0, _react.useRef)();
	  var cmbNacionalidad = (0, _react.useRef)();
	  var cmbSexo = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      activate = _useState2[0],
	      setActivate = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      deshabilitado = _useState4[0],
	      setDeshabilitado = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      habilitadoNU = _useState6[0],
	      setHabilitadoNU = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(),
	      _useState8 = _slicedToArray(_useState7, 2),
	      ciudad = _useState8[0],
	      setCiudad = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(),
	      _useState10 = _slicedToArray(_useState9, 2),
	      municipio = _useState10[0],
	      setMunicipio = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(),
	      _useState12 = _slicedToArray(_useState11, 2),
	      estado = _useState12[0],
	      setEstado = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(null),
	      _useState14 = _slicedToArray(_useState13, 2),
	      body = _useState14[0],
	      setBody = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mostrar3 = _useState16[0],
	      setMostrar3 = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      operacion = _useState18[0],
	      setOperacion = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      operacionPer = _useState20[0],
	      setOperacionPer = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(),
	      _useState22 = _slicedToArray(_useState21, 2),
	      tecla = _useState22[0],
	      setTecla = _useState22[1];
	
	  var _useState23 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState24 = _slicedToArray(_useState23, 2),
	      mensaje = _useState24[0],
	      setMensaje = _useState24[1];
	
	  var _useState25 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState26 = _slicedToArray(_useState25, 2),
	      mensajesino = _useState26[0],
	      setMensajesino = _useState26[1];
	
	  var _useState27 = (0, _react.useState)({
	    imagen: "subir.png",
	    imagenactual: "subir.png"
	  }),
	      _useState28 = _slicedToArray(_useState27, 2),
	      imagen = _useState28[0],
	      setImagen = _useState28[1];
	
	  var _useState29 = (0, _react.useState)({
	    imagen: op.conexion + "/imagen?img=subir.png"
	  }),
	      _useState30 = _slicedToArray(_useState29, 2),
	      pathImage = _useState30[0],
	      setPathImage = _useState30[1];
	
	  /* bloquear tab */
	
	
	  var _useState31 = (0, _react.useState)({
	    tab1: "tab",
	    tab2: ""
	  }),
	      _useState32 = _slicedToArray(_useState31, 2),
	      tabIndex = _useState32[0],
	      setTabIndex = _useState32[1];
	  /* activar tab */
	
	
	  var _useState33 = (0, _react.useState)({
	    tab1: "nav-link active",
	    tab2: "nav-link"
	  }),
	      _useState34 = _slicedToArray(_useState33, 2),
	      activeTab = _useState34[0],
	      setACtiveTab = _useState34[1];
	  /* mostar tabPanel */
	
	
	  var _useState35 = (0, _react.useState)({
	    tab1: "tab-pane fade show active",
	    tab2: "tab-pane fade"
	  }),
	      _useState36 = _slicedToArray(_useState35, 2),
	      tabPanel = _useState36[0],
	      setTabPanel = _useState36[1];
	  /* validar tab */
	
	
	  var _useState37 = (0, _react.useState)({
	    tab1: "true",
	    tab2: "false"
	  }),
	      _useState38 = _slicedToArray(_useState37, 2),
	      tabvalid = _useState38[0],
	      setTabValid = _useState38[1];
	
	  var validarRif = function validarRif(event) {
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        setActivate(true);
	        var endpoint = op.seniat + "/rif=" + cmbRif + txtRif.current.value;
	        _axios2.default.get(endpoint).then(function (response) {
	          if (response.status == 200) {
	            response.data.rif === "error de conexion al seniat" ? (setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "Error interno de Conexión",
	              icono: "informacion"
	            }), txtDomicilio.current.focus()) : txtRif.current.value = response.data.rif;
	          }
	        }).catch(function (err) {
	          if (err) {
	            txtDomicilio.current.focus();
	          }
	        }).then(function () {
	          setActivate(false);
	        });
	      } else {}
	    }
	  };
	
	  var CatalogoEstado = function CatalogoEstado() {
	    var campos = "*";
	    var nomtab = "estado";
	    var orden = "idestado";
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setEstado(response.data);
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var seleccionarCiudad = function seleccionarCiudad(id, idciu) {
	    var campos = "*";
	    var nomtab = "ciudad";
	    var nomid = "idmunicipio";
	    var endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&id=" + id + "&nomtab=" + nomtab + "&nomid=" + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.length > 0) {
	          setCiudad(response.data);
	          cmbCiudad.current.value = idciu;
	          seleccionarMunicipio(cmbEstado.current.value, id);
	        }
	      }
	
	      setActivate(false);
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var seleccionarMunicipio = function seleccionarMunicipio(id, idmun) {
	    setActivate(true);
	    var campos = "*";
	    var nomtab = "municipio";
	    var nomid = "idestado";
	
	    var endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&id=" + id + "&nomtab=" + nomtab + "&nomid=" + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.length > 0) {
	          setMunicipio(response.data);
	          cmbMunicipio.current.value = idmun;
	        }
	      }
	
	      setActivate(false);
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var seleccionarCiudadCampos = function seleccionarCiudadCampos(data, dataper) {
	    var campos = "*";
	    var nomtab = "ciudad";
	    var nomid = "idmunicipio";
	    var endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&id=" + data.municipio.trim() + "&nomtab=" + nomtab + "&nomid=" + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.length > 0) {
	          setCiudad(response.data);
	          llenarCampos(data, dataper);
	        }
	      }
	
	      setActivate(false);
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var seleccionarMunicipioCampos = function seleccionarMunicipioCampos(data, dataper) {
	    var campos = "*";
	    var nomtab = "municipio";
	    var nomid = "idestado";
	
	    var endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&id=" + data.estado.trim() + "&nomtab=" + nomtab + "&nomid=" + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.length > 0) {
	          setMunicipio(response.data);
	          seleccionarCiudadCampos(data, dataper);
	          // cmbMunicipio.current.value = idmun;
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var datosPersona = function datosPersona(data) {
	    var campos = "*";
	    var nomtab = "persona";
	    var nomid = "cedula";
	
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&id=" + data.responsable + "&nomtab=" + nomtab + "&nomid=" + nomid;
	    // setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        seleccionarMunicipioCampos(data, response);
	
	        /*                 setHabilitadoNU(true);
	                              txtNombreRespon.current.value = '';
	                              txtApellidoRespon.current.value = '';
	                              txtDireccionRespon.current.value = '';
	                              txtEmailRespon.current.value = '';
	                              txtTlfRespon.current.value = '';
	                              txtCelRespon.current.value = '';
	                              txtFechaNac.current.value = '';
	                              cmbNacionalidad.current.value = 'V';
	                              cmbSexo.current.value = 'M';
	                              if (response.data !== '') {
	                                  setHabilitadoNU(false);
	                                  setOperacionPer(0);
	                                  txtNombreRespon.current.value = response.data.nombres;
	                                  txtApellidoRespon.current.value = response.data.apellidos;
	                                  txtDireccionRespon.current.value = response.data.direccion;
	                                  txtEmailRespon.current.value = response.data.correoe;
	                                  txtTlfRespon.current.value = response.data.tlf1;
	                                  txtCelRespon.current.value = response.data.tlf2;
	                                  txtFechaNac.current.value = moment(response.data.fnacimiento).format('YYYY-MM-DD');
	                                  cmbNacionalidad.current.value = response.data.nacionalidad;
	                                  cmbSexo.current.value = response.data.sexo;
	                                  if (tecla === 13) {
	                                      btnAcepta.current.focus();
	                                  }
	              
	                              } else {
	                                  setOperacionPer(1);
	                                  setHabilitadoNU(true);
	                                  if (tecla === 13) {
	                                      setTimeout(() => {
	                                          txtNombreRespon.current.focus();
	                                      }, 100);
	              
	              
	                                  }
	                              } */
	      }
	
	      //  setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarOrganizacion = function seleccionarOrganizacion(id) {
	    setActivate(true);
	    var campos = "*";
	    var nomtab = "organizacion";
	    var nomid = "idorganizacion";
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        datosPersona(response.data);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleUpload = function handleUpload(e) {
	    if (e.target.files && e.target.files.length > 0) {
	      var file = e.target.files[0];
	      var name = e.target;
	
	      if (file.type.includes("image")) {
	        var reader = new FileReader();
	        reader.readAsDataURL(file);
	
	        if (name.name === "imagen") {
	          reader.onload = function load() {
	            setPathImage(Object.assign({}, pathImage, { imagen: reader.result }));
	          };
	        }
	      }
	    }
	
	    setImagen(Object.assign({}, imagen, _defineProperty({}, e.target.name, e.target.files[0])));
	  };
	
	  var cancelar = function cancelar() {
	    setTabIndex({ tab1: "tab", tab2: "" });
	    props.onHideCancela();
	    blanquear();
	  };
	
	  var blanquear = function blanquear() {
	    txtIdOrg.current.value = "";
	    txtNomOrg.current.value = "";
	    txtDomicilio.current.value = "";
	    cmbRif.current.value = "";
	    txtRif.current.value = "";
	    txtEmailOrg.current.value = "";
	    txtTlfOrg.current.value = "";
	    txtCelOrg.current.value = "";
	    cmbCiudad.current.value = "";
	    cmbMunicipio.current.value = "";
	    cmbEstado.current.value = "";
	
	    txtCedula.current.value = "";
	    txtNombreRespon.current.value = "";
	    txtApellidoRespon.current.value = "";
	    txtDireccionRespon.current.value = "";
	    txtEmailRespon.current.value = "";
	    txtTlfRespon.current.value = "";
	    txtCelRespon.current.value = "";
	    txtFechaNac.current.value = "";
	    cmbNacionalidad.current.value = "";
	    cmbSexo.current.value = "";
	
	    setMunicipio();
	    setCiudad();
	    setDeshabilitado(true);
	    setImagen({ imagen: "subir.png", imagenactual: "subir.png" });
	    setPathImage({ imagen: op.conexion + "/imagen?img=subir.png" });
	  };
	
	  var onChange = function onChange(event) {
	    if (event.target.name === "idestado") {
	      cmbEstado.current.value = event.target.value;
	      setMunicipio();
	      setCiudad();
	
	      if (event.target.value !== "") {
	        seleccionarMunicipio(event.target.value, "");
	      }
	    } else if (event.target.name === "idmunicipio") {
	      cmbMunicipio.current.value = event.target.value;
	      setCiudad();
	
	      if (event.target.value !== "") {
	        seleccionarCiudad(event.target.value, "");
	      }
	    } else if (event.target.name === "idciudad") {
	      cmbCiudad.current.value = event.target.value;
	    } else if (event.target.name === "riforg" || event.target.name === "telefonoorg" || event.target.name === "celularorg") {
	      (0, _varios.validaSoloNumero)(event);
	    } else if (event.target.name === "NombreRespon" || event.target.name === "ApellidoRespon" || event.target.name === "direccionRespen") {
	      event.target.value = event.targte.value.toUpperCase();
	    }
	  };
	
	  var handleCloseCatalogoPer = function handleCloseCatalogoPer() {
	    setMostrar3(false);
	  };
	
	  var handleAceptaCatalogoPer = function handleAceptaCatalogoPer(values) {
	    setMostrar3(false);
	    txtCedula.current.value = values.cedPer;
	    txtNombreRespon.current.value = values.nomPer;
	    txtApellidoRespon.current.value = values.apePer;
	    txtDireccionRespon.current.value = values.direPer;
	    txtEmailRespon.current.value = values.correoPer;
	    txtTlfRespon.current.value = values.tlf1Per;
	    txtCelRespon.current.value = values.tlf2Per;
	    txtFechaNac.current.value = (0, _moment2.default)(values.fnacPer).format("YYYY-MM-DD");
	    cmbNacionalidad.current.value = values.nacPer;
	    cmbSexo.current.value = values.sexoPer;
	  };
	
	  var catalogoPer = function catalogoPer(e) {
	    e.preventDefault();
	    setMostrar3(true);
	  };
	
	  var validarPersona = function validarPersona(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        setTecla(event.which);
	        datosRes(event.target.value);
	      } else {
	        txtNombreRespon.current.value = "";
	      }
	    }
	  };
	
	  var datosRes = function datosRes(cedula) {
	    var campos = "*";
	    var nomtab = "persona";
	    var nomid = "cedula";
	
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&id=" + cedula + "&nomtab=" + nomtab + "&nomid=" + nomid;
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setHabilitadoNU(true);
	        txtNombreRespon.current.value = "";
	        txtApellidoRespon.current.value = "";
	        txtDireccionRespon.current.value = "";
	        txtEmailRespon.current.value = "";
	        txtTlfRespon.current.value = "";
	        txtCelRespon.current.value = "";
	        txtFechaNac.current.value = "";
	        cmbNacionalidad.current.value = "V";
	        cmbSexo.current.value = "M";
	        if (response.data !== "") {
	          setHabilitadoNU(false);
	          setOperacionPer(0);
	          txtNombreRespon.current.value = response.data.nombres;
	          txtApellidoRespon.current.value = response.data.apellidos;
	          txtDireccionRespon.current.value = response.data.direccion;
	          txtEmailRespon.current.value = response.data.correoe;
	          txtTlfRespon.current.value = response.data.tlf1;
	          txtCelRespon.current.value = response.data.tlf2;
	          txtFechaNac.current.value = (0, _moment2.default)(response.data.fnacimiento).format("YYYY-MM-DD");
	          cmbNacionalidad.current.value = response.data.nacionalidad;
	          cmbSexo.current.value = response.data.sexo;
	          if (tecla === 13) {
	            btnAcepta.current.focus();
	          }
	        } else {
	          setOperacionPer(1);
	          setHabilitadoNU(true);
	          if (tecla === 13) {
	            setTimeout(function () {
	              txtNombreRespon.current.focus();
	            }, 100);
	          }
	        }
	      }
	
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    if (event.which === 13) {
	      var valido;
	      if (event.target.id === "inputRazonSoc") {
	        txtNomOrg.current.focus();
	      } else if (event.target.id === "inputNombre") {
	        cmbRif.current.focus();
	      } else if (event.target.id === "inputRif") {
	        txtDomicilio.current.focus();
	      } else if (event.target.id === "inputDomicilio") {
	        cmbEstado.current.focus();
	      } else if (event.target.id === "inputEmailOrg") {
	        txtTlfOrg.current.focus();
	      } else if (event.target.id === "inputTlfOrg") {
	        txtCelOrg.current.focus();
	      } else if (event.target.id === "inputNombreRespon") {
	        txtApellidoRespon.current.focus();
	      } else if (event.target.id === "inputApellidoRespon") {
	        txtDireccionRespon.current.focus();
	      } else if (event.target.id === "inputEmailRespon") {
	        valido = (0, _varios.validaEmail)(event.target.value);
	        if (valido) {
	          txtTlfRespon.current.focus();
	        } else {
	          if (event.target.value !== "") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "Formato de Email invalido.",
	              icono: "informacion"
	            });
	            event.target.value = "";
	          } else {
	            txtTlfRespon.current.focus();
	          }
	        }
	      } else if (event.target.id === "inputTlfRespon") {
	        txtCelRespon.current.focus();
	      } else if (event.target.id === "inputCelRespon") {
	        txtFechaNac.current.focus();
	      } else if (event.target.id === "inputFechaNac") {
	        cmbNacionalidad.current.focus();
	      }
	    } else if (typeof event.which === "undefined") {
	      if (event.target.id === "inputEmailOrg") {
	        valido = (0, _varios.validaEmail)(event.target.value);
	        if (valido) {
	          txtTlfOrg.current.focus();
	        } else {
	          if (event.target.value !== "") {
	            event.target.value = "";
	          } else {
	            txtTlfOrg.current.focus();
	          }
	        }
	      } else if (event.target.id === "inputTlfOrg") {
	        txtCelOrg.current.focus();
	      } else if (event.target.id === "inputCelOrg") {
	        txtFaxOrg.current.focus();
	      } else if (event.target.id === "inputEmailRespon") {
	        valido = (0, _varios.validaEmail)(event.target.value);
	        if (valido) {
	          txtTlfRespon.current.focus();
	        } else {
	          if (event.target.value !== "") {
	            event.target.value = "";
	          } else {
	            txtTlfRespon.current.focus();
	          }
	        }
	      } else if (event.target.id === "inputTlfRespon") {
	        txtCelRespon.current.focus();
	      } else if (event.target.id === "inputCelRespon") {
	        txtFechaNac.current.focus();
	      } else {
	        return false;
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	    var sigue = true;
	    var mensaje = "";
	    if (txtNomOrg.current.value.trim() === "") {
	      mensaje = "El Nombre de la Organizacion no debe estar vacio";
	      sigue = false;
	      setTabIndex(0);
	      txtNomOrg.current.focus();
	    } else if (txtRif.current.value.trim() === "") {
	      mensaje = "El Rif de la Organizacion no debe estar vacio";
	      sigue = false;
	      setTabIndex(0);
	      txtRif.current.focus();
	    } else if (txtDomicilio.current.value.trim() === "") {
	      mensaje = "El Domicilio de la Organizacion no debe estar vacio";
	      sigue = false;
	      setTabIndex(0);
	      txtDomicilio.current.focus();
	    } else if (cmbEstado.current.value.trim() === "") {
	      mensaje = "Por Favor Seleccione el Estado";
	      sigue = false;
	      setTabIndex(0);
	      cmbEstado.current.focus();
	    } else if (cmbMunicipio.current.value.trim() === "") {
	      mensaje = "Por Favor Seleccione el Municipio";
	      sigue = false;
	      setTabIndex(0);
	      cmbMunicipio.current.focus();
	    } else if (cmbCiudad.current.value.trim() === "") {
	      mensaje = "Por Favor Seleccione la Ciudad";
	      sigue = false;
	      setTabIndex(0);
	      cmbCiudad.current.focus();
	    } else if (txtCedula.current.value.trim() === "") {
	      mensaje = "La cedula no debe estar vacia";
	      sigue = false;
	      setTabIndex(Object.assign({ tab1: "tab" }, tabIndex));
	      txtCedula.current.focus();
	    } else if (txtNombreRespon.current.value.trim() === "") {
	      mensaje = "Los nombres no deben estar vacios";
	      sigue = false;
	      setTabIndex({ tab1: "", tab2: "tab" });
	      setTabIndex(Object.assign({ tab1: "tab" }, tabIndex));
	      setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
	      setTabValid({ tab1: "false", tab2: "true" });
	      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
	      txtNombreRespon.current.focus();
	    } else if (txtApellidoRespon.current.value.trim() === "") {
	      mensaje = "Los Apellidos no deben estar vacio";
	      sigue = false;
	      setTabIndex({ tab1: "", tab2: "tab" });
	      setTabIndex(Object.assign({ tab1: "tab" }, tabIndex));
	      setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
	      setTabValid({ tab1: "false", tab2: "true" });
	      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
	
	      setTabIndex(1);
	      txtApellidoRespon.current.focus();
	    } else if (txtDireccionRespon.current.value.trim() === "") {
	      mensaje = "La direccion del Responsable no debe estar vacia";
	      sigue = false;
	      setTabIndex({ tab1: "", tab2: "tab" });
	      setTabIndex(Object.assign({ tab1: "tab" }, tabIndex));
	      setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
	      setTabValid({ tab1: "false", tab2: "true" });
	      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
	
	      setTabIndex(1);
	      txtDireccionRespon.current.focus();
	    } else if (txtFechaNac.current.value.trim() === "") {
	      mensaje = "La fecha de nacimiento no debe estar vacia";
	      sigue = false;
	      setTabIndex({ tab1: "", tab2: "tab" });
	      setTabIndex(Object.assign({ tab1: "tab" }, tabIndex));
	      setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
	      setTabValid({ tab1: "false", tab2: "true" });
	      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
	
	      setTabIndex(1);
	      txtFechaNac.current.focus();
	    }
	
	    if (sigue) {
	      var org = [];
	      var datoPer = [];
	
	      org.push({
	        idorganizacion: txtIdOrg.current.value === "" ? 0 : txtIdOrg.current.value,
	        estado: cmbEstado.current.value,
	        municipio: cmbMunicipio.current.value,
	        ciudad: cmbCiudad.current.value,
	        nombre: txtNomOrg.current.value,
	        direccion: txtDomicilio.current.value,
	        tlf1: txtTlfOrg.current.value,
	        tlf2: txtCelOrg.current.value,
	        correoe: txtEmailOrg.current.value,
	        rif: cmbRif.current.value + txtRif.current.value,
	        responsable: txtCedula.current.value
	      });
	      datoPer.push({
	        apellidos: txtApellidoRespon.current.value.trim(),
	        cedula: txtCedula.current.value,
	        correoe: txtEmailRespon.current.value,
	        direccion: txtDireccionRespon.current.value.trim(),
	        fnacimiento: txtFechaNac.current.value,
	        nacionalidad: cmbNacionalidad.current.value,
	        nombres: txtNombreRespon.current.value.trim(),
	        sexo: cmbSexo.current.value,
	        tlf1: txtTlfRespon.current.value,
	        tlf2: txtCelRespon.current.value
	      });
	
	      var upload = new FormData();
	
	      upload.append("operacionper", operacionPer);
	      upload.append("org", JSON.stringify(org));
	      upload.append("perso", JSON.stringify(datoPer));
	      upload.append("organizacion", cmbRif.current.value + txtRif.current.value);
	      upload.append("imagenactual", imagen.imagenactual);
	      upload.append("imagennueva", imagen.imagen);
	
	      setBody(upload);
	
	      /*             setBody({
	                            operacionper: operacionPer,
	                            org: JSON.stringify(org),
	                            perso: JSON.stringify(datoPer)
	                        }); */
	
	      var msg = "";
	      if (props.operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (props.operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (props.operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificacion",
	        texto: mensaje,
	        icono: "informacion"
	      });
	      setTimeout(function () {
	        txtNombreRespon.current.focus();
	      }, 500);
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	
	    var endpoint = op.conexion + "/api/organizacion/actualizar/" + props.operacion;
	
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token,
	        "Content-Type": "multipart/form-data"
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (props.operacion === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro creado correctamente",
	            icono: "exito"
	          });
	        } else if (props.operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro modificado correctamente",
	            icono: "exito"
	          });
	        } else if (props.operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro eliminado correctamente",
	            icono: "exito"
	          });
	        }
	      }
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var tabs = function tabs(vl) {
	    return function (e) {
	      e.preventDefault();
	
	      if (vl === 2) {
	        setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
	        setTabValid({ tab1: "false", tab2: "true" });
	        setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
	      } else {
	        setACtiveTab({ tab1: "nav-link active", tab2: "nav-link " });
	        setTabValid({ tab1: "true", tab2: "false" });
	        setTabPanel({
	          tab1: "tab-pane fade show active",
	          tab2: "tab-pane fade "
	        });
	      }
	    };
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    props.onHideAcepta();
	    cancelar();
	  };
	
	  var llenarCampos = function llenarCampos(data, dataper) {
	    if (data.logo.trim() !== "subir.png" && data.logo.trim() !== null && data.logo.trim() !== "") {
	      setImagen(Object.assign({}, imagen, { imagenactual: data.logo.trim() }));
	      setPathImage({
	        imagen: op.conexion + "/imagen?img=" + organizacion + "/organizacion/" + data.logo.trim()
	      });
	    }
	
	    setDeshabilitado(false);
	    setHabilitadoNU(false);
	    txtIdOrg.current.value = data.idorganizacion;
	    txtNomOrg.current.value = data.nombre.trim();
	    txtDomicilio.current.value = data.direccion.trim();
	    cmbRif.current.value = isNaN(data.rif.substring(0, 1)) ? data.rif.substring(0, 1) : "";
	    txtRif.current.value = isNaN(data.rif.substring(0, 1)) ? data.rif.substring(1, data.rif.trim().length) : !isNaN(data.rif.substring(0, 1)) ? data.rif.substring(0, data.rif.trim().length) : "";
	    txtEmailOrg.current.value = data.correoe === null ? data.correoe : data.correoe.trim();
	    txtTlfOrg.current.value = data.tlf1 === null ? data.tlf1 : data.tlf1.trim();
	    txtCelOrg.current.value = data.tlf2 === null ? data.tlf2 : data.tlf2.trim();
	    cmbCiudad.current.value = data.ciudad === null ? "" : data.ciudad.trim();
	    cmbMunicipio.current.value = data.municipio === null ? "" : data.municipio.trim();
	    cmbEstado.current.value = data.estado === null ? "" : data.estado.trim();
	    txtCedula.current.value = data.responsable;
	
	    setHabilitadoNU(true);
	    txtNombreRespon.current.value = "";
	    txtApellidoRespon.current.value = "";
	    txtDireccionRespon.current.value = "";
	    txtEmailRespon.current.value = "";
	    txtTlfRespon.current.value = "";
	    txtCelRespon.current.value = "";
	    txtFechaNac.current.value = "";
	    cmbNacionalidad.current.value = "V";
	    cmbSexo.current.value = "M";
	    if (dataper.data !== "") {
	      setHabilitadoNU(false);
	      setOperacionPer(0);
	      txtNombreRespon.current.value = dataper.data.nombres;
	      txtApellidoRespon.current.value = dataper.data.apellidos;
	      txtDireccionRespon.current.value = dataper.data.direccion;
	      txtEmailRespon.current.value = dataper.data.correoe;
	      txtTlfRespon.current.value = dataper.data.tlf1;
	      txtCelRespon.current.value = dataper.data.tlf2;
	      txtFechaNac.current.value = (0, _moment2.default)(dataper.data.fnacimiento).format("YYYY-MM-DD");
	      cmbNacionalidad.current.value = dataper.data.nacionalidad;
	      cmbSexo.current.value = dataper.data.sexo;
	      btnAcepta.current.focus();
	    } else {
	      setOperacionPer(1);
	      setHabilitadoNU(true);
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    setDeshabilitado(true);
	    CatalogoEstado();
	  }, []);
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        if (props.operacion !== 1) {
	          seleccionarOrganizacion(props.organizacion.idorganizacion);
	        }
	        setOperacion(props.operacion);
	        setDeshabilitado(props.deshabilitado);
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          operacion === 1 ? "Agregar Organizacion." : operacion === 2 ? "Editar Organizacion." : operacion === 3 ? "Eliminar Organizacion." : "Consultar Organizacion."
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "ul",
	            { className: "nav nav-tabs mb-3", id: "ex-with-icons", role: "tablist" },
	            _react2.default.createElement(
	              "li",
	              { className: "nav-item", role: "presentation" },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: activeTab.tab1,
	                  id: "ex-with-icons-tab-1",
	                  style: { backgroundColor: "#25d366" },
	                  onClick: tabs(1),
	                  "data-mdb-toggle": tabIndex.tab1,
	                  href: "#tab1",
	                  role: "tab",
	                  "aria-controls": "tab1",
	                  "aria-selected": tabvalid.tab1
	                },
	                _react2.default.createElement("i", { className: "fas fa-chart-pie fa-fw me-2" }),
	                "Datos Gnr."
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { className: "nav-item", role: "presentation" },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: activeTab.tab2,
	                  id: "ex-with-icons-tab-2",
	                  style: { backgroundColor: "#55acee" },
	                  onClick: tabs(2),
	                  "data-mdb-toggle": tabIndex.tab2,
	                  href: "#tab2",
	                  role: "tab",
	                  "aria-controls": "tab2",
	                  "aria-selected": tabvalid.tab2
	                },
	                _react2.default.createElement("i", { className: "fas fa-chart-line fa-fw me-2" }),
	                "Responsable"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "tab-content", id: "ex-with-icons-content" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: tabPanel.tab1,
	                id: "tab1",
	                role: "tabpanel",
	                "aria-labelledby": "ex-with-icons-tab-1"
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "container-fluid row bg-light h-100 py-4 rounded mx-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-3" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Codigo:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    className: "form-control",
	                    disabled: true,
	                    ref: txtIdOrg,
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement("div", { className: "col-md-8" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm "
	                    },
	                    "Rif:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      disabled: deshabilitado,
	                      ref: cmbRif,
	                      className: "col-3 form-select form-select-sm",
	                      id: "inputLetraRif"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "J" },
	                      "J"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "V" },
	                      "V"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "G" },
	                      "G"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "E" },
	                      "E"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "P" },
	                      "P"
	                    )
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: deshabilitado,
	                    ref: txtRif,
	                    maxLength: 9,
	                    className: "form-control form-control-sm",
	                    name: "riforg",
	                    placeholder: "123456789",
	                    id: "inputRif"
	                    /*onKeyUp={validarRif} onBlur={validarRif}*/, onChange: onChange,
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-8" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Nombre:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    className: "form-control uppercase",
	                    disabled: deshabilitado,
	                    ref: txtNomOrg,
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputNombre",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Direcci\xF3n:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: deshabilitado,
	                    ref: txtDomicilio,
	                    className: "form-control uppercase",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputDomicilio",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Estado:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-select",
	                      "aria-label": "Default select example col-md-4",
	                      name: "idestado",
	                      disabled: deshabilitado,
	                      ref: cmbEstado
	                      /*value={valuest && valuest.idestado}*/, onChange: onChange,
	                      id: "inputFechaReg"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "SELECCIONAR ESTADO"
	                    ),
	                    estado && estado.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idestado },
	                        " ",
	                        item.nombre,
	                        " "
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Municipio:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-select",
	                      "aria-label": "Default select example col-md-4",
	                      name: "idmunicipio",
	                      disabled: deshabilitado,
	                      ref: cmbMunicipio
	                      /*value={valuest && valuest.idmunicipio}*/, onChange: onChange
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "SELECCIONAR MUNICIPIO"
	                    ),
	                    municipio && municipio.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idmunicipio },
	                        " ",
	                        item.nombre,
	                        " "
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Ciudad:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-select",
	                      "aria-label": "Default select example col-md-4",
	                      name: "idciudad",
	                      disabled: deshabilitado,
	                      ref: cmbCiudad
	                      /*value={valuest && valuest.idciudad}*/, onChange: onChange
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "SELECCIONAR CIUDAD"
	                    ),
	                    ciudad && ciudad.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idciudad },
	                        " ",
	                        item.nombre,
	                        " "
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-6" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "E-mail:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: deshabilitado,
	                    ref: txtEmailOrg,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputEmailOrg",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-3" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Telefono:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: deshabilitado,
	                    maxLength: 11,
	                    ref: txtTlfOrg,
	                    name: "telefonoorg",
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputTlfOrg",
	                    onChange: onChange,
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-3" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Celular:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: deshabilitado,
	                    maxLength: 11,
	                    ref: txtCelOrg,
	                    name: "celularorg",
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputCelOrg",
	                    onChange: onChange,
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "col-md-12 mx-auto d-flex justify-content-start py-2",
	                    style: { height: 150, width: 150 }
	                  },
	                  _react2.default.createElement("img", {
	                    src: pathImage.imagen,
	                    className: "rounded-circle shadow position-absolute",
	                    style: { height: 150, width: 150 },
	                    alt: ""
	                  }),
	                  _react2.default.createElement("input", {
	                    type: "file"
	                    /* disabled={!habilitado} */, style: {
	                      opacity: 0,
	                      height: 150,
	                      width: 150
	                    },
	                    onChange: handleUpload,
	                    name: "imagen",
	                    accept: "image/jpeg, image/png",
	                    className: "btn rounded-circle"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: tabPanel.tab2,
	                id: "tab2",
	                role: "tabpanel",
	                "aria-labelledby": "ex-with-icons-tab-2"
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "container-fluid row bg-light h-100 py-4  rounded mx-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-5" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Cedula:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      disabled: !habilitadoNU,
	                      ref: cmbNacionalidad,
	                      className: "form-select col-md-3",
	                      "aria-label": "Default select example "
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { key: "0", value: "V" },
	                      "V"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { key: "1", value: "E" },
	                      "E"
	                    )
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: deshabilitado,
	                    ref: txtCedula,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: validarPersona,
	                    onBlur: validarPersona
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      type: "button",
	                      disabled: deshabilitado,
	                      onClick: catalogoPer,
	                      className: "btn btn-success",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                ),
	                _react2.default.createElement("div", { className: "col-sm-1" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Sexo:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      disabled: !habilitadoNU,
	                      ref: cmbSexo,
	                      className: "form-select",
	                      "aria-label": "Default select example "
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { key: "0", value: "M" },
	                      "M"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { key: "1", value: "F" },
	                      "F"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Fecha Nacimiento:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "date",
	                    disabled: !habilitadoNU,
	                    ref: txtFechaNac,
	                    max: (0, _moment2.default)(fecha).format("YYYY-MM-DD"),
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputFechaNac",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-6" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Nombres:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: !habilitadoNU,
	                    ref: txtNombreRespon,
	                    className: "form-control text-uppercase",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputNombreRespon",
	                    name: "NombreRespon",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange,
	                    onChange: onChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-6" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Apellidos:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: !habilitadoNU,
	                    ref: txtApellidoRespon,
	                    className: "form-control text-uppercase",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputApellidoRespon",
	                    name: "ApellidoRespon",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange,
	                    onChange: onChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Direccion:"
	                  ),
	                  _react2.default.createElement("textarea", {
	                    disabled: !habilitadoNU,
	                    ref: txtDireccionRespon,
	                    className: "form-control text-uppercase",
	                    id: "textAreaExample",
	                    name: "direccionRespen",
	                    rows: "3",
	                    onChange: onChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "E-mail:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: !habilitadoNU,
	                    ref: txtEmailRespon,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputEmailRespon",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Telefono:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: !habilitadoNU,
	                    maxLength: 11,
	                    ref: txtTlfRespon,
	                    onChange: _varios.validaSoloNumero,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputTlfRespon",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3 input-group-sm col-sm-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Celular:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: !habilitadoNU,
	                    ref: txtCelRespon,
	                    maxLength: 11,
	                    onChange: _varios.validaSoloNumero,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputCelRespon",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          type: "button",
	          ref: btnAcepta,
	          onClick: onChangeValidar,
	          disabled: operacion === 4 ? true : false,
	          style: { margin: "1px" },
	          className: "col-sm-2 btn btn-success btn-sm rounded-pill"
	        },
	        _react2.default.createElement("i", { className: "far fa-check-circle" }),
	        "Aceptar"
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          type: "button",
	          ref: btnCancela,
	          onClick: cancelar,
	          style: { margin: "1px" },
	          className: "col-sm-2 btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement("i", { className: "fas fa-window-close" }),
	        "Cancelar"
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_catalogoPersona2.default, {
	      titulo: "",
	      mensaje: "",
	      show: mostrar3,
	      onHideCancelaCatPer: handleCloseCatalogoPer,
	      onHideAceptaCatPer: handleAceptaCatalogoPer
	    })
	  );
	};

/***/ },
/* 7088 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActualizarPersonaAthos = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mensajes = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActualizarPersonaAthos = exports.ActualizarPersonaAthos = function ActualizarPersonaAthos(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      activate = _useState2[0],
	      setActivate = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      deshabilitado = _useState4[0],
	      setDeshabilitado = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      operacion = _useState6[0],
	      setOperacion = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(),
	      _useState8 = _slicedToArray(_useState7, 2),
	      tecla = _useState8[0],
	      setTecla = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(sessionStorage.getItem("fechasistema")),
	      _useState10 = _slicedToArray(_useState9, 2),
	      fechaSistema = _useState10[0],
	      setFechaSistema = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mensaje = _useState12[0],
	      setMensaje = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensajesino = _useState14[0],
	      setMensajesino = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({}),
	      _useState16 = _slicedToArray(_useState15, 2),
	      body = _useState16[0],
	      setBody = _useState16[1];
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var txtCedula = (0, _react.useRef)();
	  var txtNombre = (0, _react.useRef)();
	  var txtApellido = (0, _react.useRef)();
	  var txtDireccion = (0, _react.useRef)();
	  var txtEmail = (0, _react.useRef)();
	  var txtTlf = (0, _react.useRef)();
	  var txtCel = (0, _react.useRef)();
	  var txtFechaNac = (0, _react.useRef)();
	  var cmbNacionalidad = (0, _react.useRef)();
	  var cmbSexo = (0, _react.useRef)();
	
	  (0, _react.useEffect)(function () {
	    var obj = JSON.parse(sessionStorage.getItem("post"));
	    setFechaSistema(obj.fechasistema);
	
	    if (props.operacion) {
	      setOperacion(props.operacion);
	    }
	  }, [props.operacion]);
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	    var sigue = true;
	    var mensaje = "";
	    if (txtCedula.current.value.trim() === "") {
	      mensaje = "La cedula no debe estar vacia";
	      sigue = false;
	      txtCedula.current.focus();
	    } else if (txtCedula.current.value.trim().length > 8) {
	      mensaje = "La cedula no debe exceder 8 caracteres";
	      sigue = false;
	      txtCedula.current.focus();
	    } else if (txtNombre.current.value.trim() === "") {
	      mensaje = "Los nombres no deben estar vacios";
	      sigue = false;
	      txtNombre.current.focus();
	    } else if (txtApellido.current.value.trim() === "") {
	      mensaje = "Los Apellidos no deben estar vacio";
	      sigue = false;
	      txtApellido.current.focus();
	    } else if (txtDireccion.current.value.trim() === "") {
	      mensaje = "La direccion del  no debe estar vacia";
	      sigue = false;
	      txtDireccion.current.focus();
	    } else if (txtFechaNac.current.value.trim() === "") {
	      mensaje = "La fecha de nacimiento no debe estar vacia";
	      sigue = false;
	      txtFechaNac.current.focus();
	    }
	
	    if (sigue) {
	      var datoPer = [];
	      datoPer.push({
	        apellidos: txtApellido.current.value.trim().toUpperCase(),
	        cedula: txtCedula.current.value,
	        correoe: txtEmail.current.value,
	        direccion: txtDireccion.current.value.trim().toUpperCase(),
	        fnacimiento: txtFechaNac.current.value.toUpperCase(),
	        nacionalidad: cmbNacionalidad.current.value,
	        nombres: txtNombre.current.value.trim().toUpperCase(),
	        sexo: cmbSexo.current.value,
	        tlf1: txtTlf.current.value,
	        tlf2: txtCel.current.value
	      });
	
	      var _body = {
	        cedula: txtCedula.current.value,
	        correoe: txtEmail.current.value,
	        tlf1: txtTlf.current.value,
	        tlf2: txtCel.current.value,
	        apellidos: txtApellido.current.value.trim(),
	        direccion: txtDireccion.current.value.trim(),
	        fnacimiento: txtFechaNac.current.value,
	        nacionalidad: cmbNacionalidad.current.value,
	        nombres: txtNombre.current.value.trim(),
	        sexo: cmbSexo.current.value
	      };
	
	      setBody(_body);
	
	      var msg = "";
	      if (props.operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (props.operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (props.operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	
	    props.onHideCancela();
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    var endpoint = op.conexion + "/api/athos/personas/actualizarpersona/" + operacion;
	
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setActivate(false);
	        var mensaje = "";
	        if (operacion === 1) {
	          mensaje = "La Persona " + txtCedula.current.value + " ha sido registrada de manera satisfactoria.";
	        } else if (operacion === 2) {
	          mensaje = "La Persona " + txtCedula.current.value + " ha sido modificada de manera satisfactoria.";
	        } else if (operacion === 3) {
	          mensaje = "La Persona " + txtCedula.current.value + " ha sido eliminada de manera satisfactoria.";
	        }
	
	        setMensaje({
	          mostrar: true,
	          titulo: "Exito.",
	          texto: mensaje,
	          icono: "exito"
	        });
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var validarPersona = function validarPersona(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        setTecla(event.which);
	      } else {
	        txtNombre.current.value = "";
	      }
	    }
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    props.onHideAcepta();
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        setOperacion(props.operacion);
	        setDeshabilitado(props.deshabilitado);
	        btnAcepta.current.focus();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          operacion === 1 ? "Agregar Persona." : operacion === 2 ? "Editar Persona." : operacion === 3 ? "Eliminar Persona." : "Consultar Persona."
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "container-fluid bg-light rounded" },
	        _react2.default.createElement(
	          "div",
	          { className: "container row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group py-1 input-group-sm col-sm-3" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "Nacionalidad:"
	            ),
	            _react2.default.createElement(
	              "select",
	              {
	                className: "form-select",
	                disabled: deshabilitado,
	                ref: cmbNacionalidad,
	                style: { maxWidth: 70 },
	                "aria-label": "Default select example ",
	                defaultValue: props.persona && props.persona.nacionalidad !== null ? props.persona.nacionalidad.trim() : "",
	                id: "inputNac"
	              },
	              _react2.default.createElement(
	                "option",
	                { value: "V" },
	                "V"
	              ),
	              _react2.default.createElement(
	                "option",
	                { value: "E" },
	                "E"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group py-1 input-group-sm col-sm-4" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "Cedula:"
	            ),
	            _react2.default.createElement("input", {
	              type: "text",
	              className: "form-control",
	              maxLength: 8,
	              autoComplete: "off",
	              style: { maxWidth: 80 },
	              disabled: operacion === 2 ? true : deshabilitado,
	              ref: txtCedula,
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm",
	              defaultValue: props.persona ? props.persona.cedula : "",
	              id: "inputCedula",
	              onKeyUp: validarPersona,
	              onBlur: validarPersona
	            })
	          ),
	          _react2.default.createElement("div", { className: "col-sm-8" })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group py-1 input-group-sm col-sm-6" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "Nombres:"
	            ),
	            _react2.default.createElement("input", {
	              type: "text",
	              autoComplete: "off",
	              className: "form-control uppercase",
	              disabled: deshabilitado,
	              ref: txtNombre,
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm",
	              defaultValue: props.persona ? props.persona.nombres.trim() : "",
	              id: "inputNombres"
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group py-1 input-group-sm col-sm-6" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "Apellidos:"
	            ),
	            _react2.default.createElement("input", {
	              type: "text",
	              autoComplete: "off",
	              className: "form-control uppercase",
	              disabled: deshabilitado,
	              ref: txtApellido,
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm",
	              defaultValue: props.persona ? props.persona.apellidos.trim() : "",
	              id: "inputApellidos"
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group py-1 input-group-sm col-sm-12" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "Direccion:"
	            ),
	            _react2.default.createElement("input", {
	              type: "text",
	              autoComplete: "off",
	              className: "form-control uppercase",
	              disabled: deshabilitado,
	              ref: txtDireccion,
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm",
	              defaultValue: props.persona ? props.persona.direccion.trim() : "",
	              id: "inputDireccion"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group py-1 input-group-sm col-sm-6" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "E-mail:"
	            ),
	            _react2.default.createElement("input", {
	              type: "text",
	              autoComplete: "off",
	              className: "form-control uppercase",
	              disabled: deshabilitado,
	              ref: txtEmail,
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm",
	              defaultValue: props.persona ? props.persona.correoe : "",
	              id: "inputEmail"
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group py-1 input-group-sm col-sm-3" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "Telefono:"
	            ),
	            _react2.default.createElement("input", {
	              type: "text",
	              autoComplete: "off",
	              className: "form-control",
	              disabled: deshabilitado,
	              maxLength: 11,
	              onChange: _varios.validaSoloNumero,
	              ref: txtTlf,
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm",
	              defaultValue: props.persona ? props.persona.tlf1 : "",
	              id: "inputTlf"
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group py-1 input-group-sm col-sm-3" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "Celular:"
	            ),
	            _react2.default.createElement("input", {
	              type: "text",
	              autoComplete: "off",
	              className: "form-control",
	              disabled: deshabilitado,
	              ref: txtCel,
	              maxLength: 11,
	              onChange: _varios.validaSoloNumero,
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm",
	              defaultValue: props.persona ? props.persona.tlf2 : "",
	              id: "inputCel"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container row" },
	          _react2.default.createElement(
	            "div",
	            { className: "input-group py-1 input-group-sm col-sm-4" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "Fecha Nacimiento:"
	            ),
	            _react2.default.createElement("input", {
	              type: "date",
	              autoComplete: "off",
	              className: "form-control",
	              disabled: deshabilitado,
	              ref: txtFechaNac,
	              max: (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD"),
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm",
	              defaultValue: props.persona ? (0, _moment2.default)(props.persona.fnacimiento).format("YYYY-MM-DD") : "",
	              id: "inputFnac"
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group py-1 input-group-sm col-sm-4" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "Sexo:"
	            ),
	            _react2.default.createElement(
	              "select",
	              {
	                className: "form-select",
	                disabled: deshabilitado,
	                ref: cmbSexo,
	                style: { maxWidth: 70 },
	                "aria-label": "Default select example ",
	                defaultValue: props.persona ? props.persona.sexo.trim() : "",
	                id: "inputSexo"
	              },
	              _react2.default.createElement(
	                "option",
	                { key: "0", value: "M" },
	                "M"
	              ),
	              _react2.default.createElement(
	                "option",
	                { key: "1", value: "F" },
	                "F"
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          type: "button",
	          ref: btnAcepta,
	          onClick: onChangeValidar,
	          disabled: operacion === 4 ? true : false,
	          style: { margin: "1px" },
	          className: "col-sm-2 btn btn-success btn-sm rounded-pill"
	        },
	        _react2.default.createElement("i", { className: "far fa-check-circle" }),
	        "Aceptar"
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          type: "button",
	          ref: btnCancela,
	          onClick: cancelar,
	          style: { margin: "1px" },
	          className: "col-sm-2 btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement("i", { className: "fas fa-window-close" }),
	        "Cancelar"
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};

/***/ },
/* 7089 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _catalogoPersona = __webpack_require__(64);
	
	var _catalogoPersona2 = _interopRequireDefault(_catalogoPersona);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _catalogoOrganizacion = __webpack_require__(658);
	
	var _catalogoOrganizacion2 = _interopRequireDefault(_catalogoOrganizacion);
	
	var _modalCambiarClave = __webpack_require__(299);
	
	var _mensajes = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ModalActualizarUsuario = function ModalActualizarUsuario(props) {
	  var _useState75;
	
	  var idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
	  var idusuario = JSON.parse(sessionStorage.getItem("idusuario"));
	
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtRazon = (0, _react.useRef)();
	  var txtIdVendedor = (0, _react.useRef)();
	  var cmbCaja = (0, _react.useRef)();
	
	  var chkPerCon = (0, _react.useRef)();
	  var chkPerIn = (0, _react.useRef)();
	  var chkPerMod = (0, _react.useRef)();
	  var chkPerEli = (0, _react.useRef)();
	  var chkPerTodo = (0, _react.useRef)();
	
	  var chkUsuCon = (0, _react.useRef)();
	  var chkUsuIn = (0, _react.useRef)();
	  var chkUsuMod = (0, _react.useRef)();
	  var chkUsuEli = (0, _react.useRef)();
	  var chkUsuTodo = (0, _react.useRef)();
	
	  var chkUsuappCon = (0, _react.useRef)();
	  var chkUsuappIn = (0, _react.useRef)();
	  var chkUsuappMod = (0, _react.useRef)();
	  var chkUsuappEli = (0, _react.useRef)();
	  var chkUsuappTodo = (0, _react.useRef)();
	
	  var chkMoneCon = (0, _react.useRef)();
	  var chkMoneIn = (0, _react.useRef)();
	  var chkMoneMod = (0, _react.useRef)();
	  var chkMoneEli = (0, _react.useRef)();
	  var chkMoneTodo = (0, _react.useRef)();
	
	  var chkPorCon = (0, _react.useRef)();
	  var chkPorIn = (0, _react.useRef)();
	  var chkPorMod = (0, _react.useRef)();
	  var chkPorEli = (0, _react.useRef)();
	  var chkPorTodo = (0, _react.useRef)();
	
	  var chkUWebCon = (0, _react.useRef)();
	  var chkUWebIn = (0, _react.useRef)();
	  var chkUWebMod = (0, _react.useRef)();
	  var chkUWebEli = (0, _react.useRef)();
	  var chkUWebTodo = (0, _react.useRef)();
	
	  var chkUAppCon = (0, _react.useRef)();
	  var chkUAppIn = (0, _react.useRef)();
	  var chkUAppMod = (0, _react.useRef)();
	  var chkUAppEli = (0, _react.useRef)();
	  var chkUAppTodo = (0, _react.useRef)();
	
	  var chkOrgCon = (0, _react.useRef)();
	  var chkOrgIn = (0, _react.useRef)();
	  var chkOrgMod = (0, _react.useRef)();
	  var chkOrgEli = (0, _react.useRef)();
	  var chkOrgTodo = (0, _react.useRef)();
	
	  var chkralmacen = (0, _react.useRef)();
	  var chkubialmacen = (0, _react.useRef)();
	  var chkudmedida = (0, _react.useRef)();
	  var chkmarca = (0, _react.useRef)();
	  var chkmodelo = (0, _react.useRef)();
	  var chktpproduct = (0, _react.useRef)();
	  var chkproducto = (0, _react.useRef)();
	  var chkopinventario = (0, _react.useRef)();
	  var chkactxlsx = (0, _react.useRef)();
	  var chkgvacios = (0, _react.useRef)();
	  var chkiconfigura = (0, _react.useRef)();
	  var chkireports = (0, _react.useRef)();
	  var chkitodos = (0, _react.useRef)();
	
	  var chkvtodos = (0, _react.useRef)();
	  var chkclientes = (0, _react.useRef)();
	  var chkvendedores = (0, _react.useRef)();
	  var chkpedidos = (0, _react.useRef)();
	  var chknentrega = (0, _react.useRef)();
	  var chkndebito = (0, _react.useRef)();
	  var chkfactura = (0, _react.useRef)();
	  var chkfacturaxnotas = (0, _react.useRef)();
	  var chkpresupuesto = (0, _react.useRef)();
	  var chkvconfi = (0, _react.useRef)();
	  var chkvreports = (0, _react.useRef)();
	
	  var chkcptodos = (0, _react.useRef)();
	  var chkproveedores = (0, _react.useRef)();
	  var chkordencompra = (0, _react.useRef)();
	  var chkfactucompra = (0, _react.useRef)();
	  var chkcpconfig = (0, _react.useRef)();
	  var chkcpreports = (0, _react.useRef)();
	
	  var chkcnttodos = (0, _react.useRef)();
	  var chkcatctcontable = (0, _react.useRef)();
	  var chkasientcntable = (0, _react.useRef)();
	  var chkvincuenta = (0, _react.useRef)();
	  var chkmovibancot = (0, _react.useRef)();
	  var chkcntconfig = (0, _react.useRef)();
	  var chkcntreports = (0, _react.useRef)();
	
	  var chkftodos = (0, _react.useRef)();
	  var chkbancos = (0, _react.useRef)();
	  var chkbeneficiarios = (0, _react.useRef)();
	  var chkctasbancarias = (0, _react.useRef)();
	  var chkmovibancarios = (0, _react.useRef)();
	  var chkmovitransito = (0, _react.useRef)();
	  var chkconciliacionbanco = (0, _react.useRef)();
	  var chkctasxcobrar = (0, _react.useRef)();
	  var chkReverPagoAnti = (0, _react.useRef)();
	  var chkctasxpagar = (0, _react.useRef)();
	  var chktiporetenciones = (0, _react.useRef)();
	  var chkfconfig = (0, _react.useRef)();
	  var chkfreports = (0, _react.useRef)();
	
	  var chkvaciostodos = (0, _react.useRef)();
	  var chkopvacios = (0, _react.useRef)();
	  var chkcontrolvacios = (0, _react.useRef)();
	  var chkclassvacios = (0, _react.useRef)();
	  var chkvaciosconfig = (0, _react.useRef)();
	  var chkvaciosreports = (0, _react.useRef)();
	
	  var chkpostventtodos = (0, _react.useRef)();
	  var chkpostventventa = (0, _react.useRef)();
	  var chksupervisor = (0, _react.useRef)();
	  var cmbTipoPrecioGlobal = (0, _react.useRef)();
	
	  var chkinicio = (0, _react.useRef)();
	
	  var chkservtodos = (0, _react.useRef)();
	  var chkordenservi = (0, _react.useRef)();
	  var chkmovilesservi = (0, _react.useRef)();
	  var chkgservicios = (0, _react.useRef)();
	  var chkservconfig = (0, _react.useRef)();
	  var chkservreports = (0, _react.useRef)();
	  var chkservnotaent = (0, _react.useRef)();
	
	  var moduinventariosi = (0, _react.useRef)();
	  var moduinventariono = (0, _react.useRef)();
	  var moduventassi = (0, _react.useRef)();
	  var moduventasno = (0, _react.useRef)();
	  var moducomprassi = (0, _react.useRef)();
	  var moducomprasno = (0, _react.useRef)();
	  var moducontabsi = (0, _react.useRef)();
	  var moducontabno = (0, _react.useRef)();
	  var modufinanzassi = (0, _react.useRef)();
	  var modufinanzasno = (0, _react.useRef)();
	  var moduconfigsi = (0, _react.useRef)();
	  var moduconfigno = (0, _react.useRef)();
	  var moduvaciossi = (0, _react.useRef)();
	  var moduvaciosno = (0, _react.useRef)();
	  var moduserviciossi = (0, _react.useRef)();
	  var moduserviciosno = (0, _react.useRef)();
	  var modupostventasi = (0, _react.useRef)();
	  var modupostventano = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(),
	      _useState2 = _slicedToArray(_useState, 2),
	      aplica = _useState2[0],
	      setAplica = _useState2[1];
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnEnviar = (0, _react.useRef)();
	
	  var _useState3 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      mensaje = _useState4[0],
	      setMensaje = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mensajesino = _useState6[0],
	      setMensajesino = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mostrar = _useState8[0],
	      setMostrar = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      modu1 = _useState10[0],
	      setModu1 = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      modu2 = _useState12[0],
	      setModu2 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      modu3 = _useState14[0],
	      setModu3 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      modu4 = _useState16[0],
	      setModu4 = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      modu5 = _useState18[0],
	      setModu5 = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      modu6 = _useState20[0],
	      setModu6 = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      modu7 = _useState22[0],
	      setModu7 = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0),
	      _useState24 = _slicedToArray(_useState23, 2),
	      modu8 = _useState24[0],
	      setModu8 = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(0),
	      _useState26 = _slicedToArray(_useState25, 2),
	      modu9 = _useState26[0],
	      setModu9 = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      modu10 = _useState28[0],
	      setModu10 = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      mostrar2 = _useState30[0],
	      setMostrar2 = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(false),
	      _useState32 = _slicedToArray(_useState31, 2),
	      mostrar3 = _useState32[0],
	      setMostrar3 = _useState32[1];
	
	  var _useState33 = (0, _react.useState)({}),
	      _useState34 = _slicedToArray(_useState33, 2),
	      body = _useState34[0],
	      setBody = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(0),
	      _useState36 = _slicedToArray(_useState35, 2),
	      essupervisor = _useState36[0],
	      setEssupervisor = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(),
	      _useState38 = _slicedToArray(_useState37, 2),
	      titulo = _useState38[0],
	      setTitulo = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(),
	      _useState40 = _slicedToArray(_useState39, 2),
	      msg = _useState40[0],
	      setMsg = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(0),
	      _useState42 = _slicedToArray(_useState41, 2),
	      contar = _useState42[0],
	      setContar = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(0),
	      _useState44 = _slicedToArray(_useState43, 2),
	      contar2 = _useState44[0],
	      setContar2 = _useState44[1];
	
	  var _useState45 = (0, _react.useState)("0000"),
	      _useState46 = _slicedToArray(_useState45, 2),
	      perusu = _useState46[0],
	      setPerusu = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(),
	      _useState48 = _slicedToArray(_useState47, 2),
	      msg2 = _useState48[0],
	      setMsg2 = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(""),
	      _useState50 = _slicedToArray(_useState49, 2),
	      password = _useState50[0],
	      setPassword = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(false),
	      _useState52 = _slicedToArray(_useState51, 2),
	      activate = _useState52[0],
	      setActivate = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(),
	      _useState54 = _slicedToArray(_useState53, 2),
	      usuario = _useState54[0],
	      setUsuario = _useState54[1];
	
	  var _useState55 = (0, _react.useState)(false),
	      _useState56 = _slicedToArray(_useState55, 2),
	      catalogoCliente = _useState56[0],
	      setCatalogoCliente = _useState56[1];
	
	  var cmbCedula = [{ value: "V" }, { value: "E" }, { value: "J" }, { value: "P" }, { value: "G" }];
	
	  var _useState57 = (0, _react.useState)({
	    cedula: "",
	    nombres: "",
	    apellidos: "",
	    direccion: "",
	    correoe: "",
	    tlf1: "",
	    tlf2: "",
	    fnacimiento: "",
	    nacionalidad: "",
	    sexo: ""
	  }),
	      _useState58 = _slicedToArray(_useState57, 2),
	      persona = _useState58[0],
	      setPersona = _useState58[1];
	
	  var _useState59 = (0, _react.useState)(false),
	      _useState60 = _slicedToArray(_useState59, 2),
	      mostrarClave = _useState60[0],
	      setMostrarClave = _useState60[1];
	
	  var _useState61 = (0, _react.useState)(false),
	      _useState62 = _slicedToArray(_useState61, 2),
	      mostrarClave1 = _useState62[0],
	      setMostrarClave1 = _useState62[1];
	
	  var _useState63 = (0, _react.useState)(false),
	      _useState64 = _slicedToArray(_useState63, 2),
	      mostrarClavesup = _useState64[0],
	      setMostrarClavesup = _useState64[1];
	
	  var _useState65 = (0, _react.useState)(""),
	      _useState66 = _slicedToArray(_useState65, 2),
	      correo = _useState66[0],
	      setCorreo = _useState66[1];
	
	  var _useState67 = (0, _react.useState)({
	    opcion1: "",
	    opcion2: "",
	    opcion3: "",
	    opcion4: "",
	    opcion5: "",
	    opcion6: "",
	    opcion7: ""
	  }),
	      _useState68 = _slicedToArray(_useState67, 2),
	      modulosConfig = _useState68[0],
	      setModulosConfig = _useState68[1];
	
	  var _useState69 = (0, _react.useState)({
	    moduini: null
	  }),
	      _useState70 = _slicedToArray(_useState69, 2),
	      modulosini = _useState70[0],
	      setModulosini = _useState70[1];
	
	  var _useState71 = (0, _react.useState)({
	    acccontribuyente: "0000",
	    accactividad: "0000",
	    accdeclaraciones: "000",
	    accacticontri: "00",
	    accagente: "0000",
	    accusuariocome: "0000"
	  }),
	      _useState72 = _slicedToArray(_useState71, 2),
	      permisos = _useState72[0],
	      setPermisos = _useState72[1];
	
	  var _useState73 = (0, _react.useState)((_useState75 = {
	    personas1: " ",
	    personas2: " ",
	    personas3: " ",
	    personas4: " ",
	    usuarios1: " ",
	    usuarios2: " ",
	    usuarios3: " ",
	    usuarios4: " ",
	    usuarioapp1: "",
	    usuarioapp2: "",
	    usuarioapp3: "",
	    usuarioapp4: "",
	    unidadcontable1: " ",
	    unidadcontable2: " ",
	    unidadcontable3: " ",
	    unidadcontable4: " ",
	    valorute1: " ",
	    valorute2: " ",
	    valorute3: " ",
	    valorute4: " ",
	    porcentaje1: " ",
	    porcentaje2: " ",
	    porcentaje3: " ",
	    porcentaje4: " ",
	    usuarioweb1: " ",
	    usuarioweb2: " ",
	    usuarioweb3: " ",
	    usuarioweb4: " "
	  }, _defineProperty(_useState75, "usuarioapp1", " "), _defineProperty(_useState75, "usuarioapp2", " "), _defineProperty(_useState75, "usuarioapp3", " "), _defineProperty(_useState75, "usuarioapp4", " "), _defineProperty(_useState75, "organizacion1", " "), _defineProperty(_useState75, "organizacion2", " "), _defineProperty(_useState75, "organizacion3", " "), _defineProperty(_useState75, "organizacion4", " "), _useState75)),
	      _useState74 = _slicedToArray(_useState73, 2),
	      operacionesMod = _useState74[0],
	      setOperacionesMod = _useState74[1];
	
	  var _useState76 = (0, _react.useState)({
	    inve1: null,
	    inve2: null,
	    inve3: null,
	    inve4: null,
	    inve5: null,
	    inve6: null,
	    inve7: null,
	    inve8: null,
	    inve9: null,
	    inve10: null,
	    inve11: null,
	    inve12: null
	  }),
	      _useState77 = _slicedToArray(_useState76, 2),
	      moduloinventario = _useState77[0],
	      setModuloinventario = _useState77[1];
	
	  var _useState78 = (0, _react.useState)({
	    vents1: null,
	    vents2: null,
	    vents3: null,
	    vents4: null,
	    vents5: null,
	    vents6: null,
	    vents7: null,
	    vents8: null,
	    vents9: null,
	    vents10: null
	  }),
	      _useState79 = _slicedToArray(_useState78, 2),
	      moduloventas = _useState79[0],
	      setModuloventas = _useState79[1];
	
	  var _useState80 = (0, _react.useState)({
	    mcompras1: null,
	    mcompras2: null,
	    mcompras3: null,
	    mcompras4: null,
	    mcompras5: null
	  }),
	      _useState81 = _slicedToArray(_useState80, 2),
	      modulocompras = _useState81[0],
	      setModulocompras = _useState81[1];
	
	  var _useState82 = (0, _react.useState)({
	    vacios1: null,
	    vacios2: null,
	    vacios3: null,
	    vacios4: null,
	    vacios5: null
	  }),
	      _useState83 = _slicedToArray(_useState82, 2),
	      modulovacios = _useState83[0],
	      setModulovacios = _useState83[1];
	
	  var _useState84 = (0, _react.useState)({
	    servicio1: null,
	    servicio2: null,
	    servicio3: null,
	    servicio4: null,
	    servicio5: null,
	    servicio6: null
	  }),
	      _useState85 = _slicedToArray(_useState84, 2),
	      moduloservicios = _useState85[0],
	      setModuloservicios = _useState85[1];
	
	  var _useState86 = (0, _react.useState)({
	    postventa1: null,
	    postventa2: null,
	    postventa3: null,
	    postventa4: null,
	    postventa5: null,
	    postventa6: null
	  }),
	      _useState87 = _slicedToArray(_useState86, 2),
	      modulopostventa = _useState87[0],
	      setModulopostventa = _useState87[1];
	
	  var _useState88 = (0, _react.useState)({
	    mcontab1: null,
	    mcontab2: null,
	    mcontab3: null,
	    mcontab4: null,
	    mcontab5: null,
	    mcontab6: null
	  }),
	      _useState89 = _slicedToArray(_useState88, 2),
	      modulocontabilidad = _useState89[0],
	      setModulocontabilidad = _useState89[1];
	
	  var _useState90 = (0, _react.useState)({
	    mfinanzas1: null,
	    mfinanzas2: null,
	    mfinanzas3: null,
	    mfinanzas4: null,
	    mfinanzas5: null,
	    mfinanzas6: null,
	    mfinanzas7: null,
	    mfinanzas8: null,
	    mfinanzas9: null,
	    mfinanzas10: null,
	    mfinanzas11: null,
	    mfinanzas12: null
	  }),
	      _useState91 = _slicedToArray(_useState90, 2),
	      modulofinanzas = _useState91[0],
	      setModulofinanzas = _useState91[1];
	
	  var _useState92 = (0, _react.useState)(""),
	      _useState93 = _slicedToArray(_useState92, 2),
	      url = _useState93[0],
	      setUrl = _useState93[1];
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	
	  var _useState94 = (0, _react.useState)(false),
	      _useState95 = _slicedToArray(_useState94, 2),
	      deshabilitado = _useState95[0],
	      setDeshabilitado = _useState95[1];
	
	  var _useState96 = (0, _react.useState)(false),
	      _useState97 = _slicedToArray(_useState96, 2),
	      habilitadoNU = _useState97[0],
	      setHabilitadoNU = _useState97[1];
	
	  var _useState98 = (0, _react.useState)(0),
	      _useState99 = _slicedToArray(_useState98, 2),
	      operacion = _useState99[0],
	      setOperacion = _useState99[1];
	
	  var _useState100 = (0, _react.useState)(0),
	      _useState101 = _slicedToArray(_useState100, 2),
	      operacionPer = _useState101[0],
	      setOperacionPer = _useState101[1];
	
	  var _useState102 = (0, _react.useState)(),
	      _useState103 = _slicedToArray(_useState102, 2),
	      tecla = _useState103[0],
	      setTecla = _useState103[1];
	
	  var _useState104 = (0, _react.useState)(0),
	      _useState105 = _slicedToArray(_useState104, 2),
	      tabIndex = _useState105[0],
	      setTabIndex = _useState105[1];
	
	  var _useState106 = (0, _react.useState)(0),
	      _useState107 = _slicedToArray(_useState106, 2),
	      tabIndex1 = _useState107[0],
	      setTabIndex1 = _useState107[1];
	
	  var _useState108 = (0, _react.useState)(sessionStorage.getItem("fechasistema")),
	      _useState109 = _slicedToArray(_useState108, 2),
	      fechaSistema = _useState109[0],
	      setFechaSistema = _useState109[1];
	
	  var txtIdUsuario = (0, _react.useRef)();
	  var txtLogin = (0, _react.useRef)();
	  var txtPassword = (0, _react.useRef)();
	  var txtPasswordsuv = (0, _react.useRef)();
	  var txtConfirmPassword = (0, _react.useRef)();
	  var txtIdAgente = (0, _react.useRef)();
	  var txtNombreAgente = (0, _react.useRef)();
	  var txtCedula = (0, _react.useRef)();
	  var txtNombreUsuario = (0, _react.useRef)();
	  var txtApellidoUsuario = (0, _react.useRef)();
	  var txtDireccionUsuario = (0, _react.useRef)();
	  var txtEmailUsuario = (0, _react.useRef)();
	  var txtTlfUsuario = (0, _react.useRef)();
	  var txtCelUsuario = (0, _react.useRef)();
	  var txtFechaNac = (0, _react.useRef)();
	  var cmbNacionalidad = (0, _react.useRef)();
	  var cmbSexo = (0, _react.useRef)();
	  var cmbStatus = (0, _react.useRef)();
	
	  (0, _react.useEffect)(function () {
	    var obj = JSON.parse(sessionStorage.getItem("post"));
	    setFechaSistema(obj.fechasistema);
	    if (props.operacion) {
	      setOperacion(props.operacion);
	    }
	
	    if (op.reportes != null) {
	      setUrl(op.reportes.trim());
	    } else {
	      setUrl("");
	    }
	  }, [props.operacion]);
	
	  var SelectUsuario = function SelectUsuario(idusuario) {
	    var endpoint = op.conexion + "/api/athos/usuario/getuser?id=" + idusuario;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.idusuario > 0) {
	          var orgaz = response.data.accconfiggene;
	
	          var inv = response.data.accinventario;
	          var vntas = response.data.accventas;
	          var cmpras = response.data.acccompras;
	          var cntbild = response.data.acccontabilidad;
	          var finazs = response.data.accfinanzas;
	          var aplic = response.data.accaplicaciones;
	          var vaci = response.data.accvacios;
	          var servi = response.data.accservicios;
	          var postvent = response.data.accpostventas;
	          var perinicio = response.data.accinicio;
	          var tipoprec = response.data.tipoprecio;
	
	          var btn1 = response.data.accbtnregalmacen;
	          var btn2 = response.data.accbtnubialmacen;
	          var btn3 = response.data.accbtnumedida;
	          var btn4 = response.data.accbtnmarca;
	          var btn5 = response.data.accbtnmodelo;
	          var btn6 = response.data.accbtntproducto;
	          var btn7 = response.data.accbtnproducto;
	          var btn8 = response.data.accbtnopinventario;
	          var btn9 = response.data.accbtnactxlsx;
	          var btn10 = response.data.accbtntvacios;
	          var btn11 = response.data.accbtnireports;
	          var btn12 = response.data.accbtnclientes;
	          var btn13 = response.data.accbtnvendedor;
	          var btn14 = response.data.accbtnpedidos;
	          var btn15 = response.data.accbtnnentrega;
	          var btn16 = response.data.accbtnndebito;
	          var btn17 = response.data.accbtnfacturas;
	          var btn18 = response.data.accbtnpresupuesto;
	          var btn19 = response.data.accbtnvreports;
	          var btn20 = response.data.accbtnproveedores;
	          var btn21 = response.data.accbtnordencompra;
	          var btn22 = response.data.accbtnfactucompra;
	          var btn23 = response.data.accbtncreports;
	          var btn24 = response.data.accbtncntcontable;
	          var btn25 = response.data.accbtnastcntable;
	          var btn26 = response.data.accbtnmvbancarios;
	          var btn27 = response.data.accbtnmvbancariost;
	          var btn28 = response.data.accbtnvinculacuenta;
	          var btn29 = response.data.accbtncntreports;
	          var btn30 = response.data.accbtnbancos;
	          var btn31 = response.data.accbtnbeneficiarios;
	          var btn32 = response.data.accbtnctsbancarias;
	          var btn33 = response.data.accbtncnciliabancaria;
	          var btn34 = response.data.accbtncntxcobrar;
	          var btn35 = response.data.accbtncntxpagar;
	          var btn36 = response.data.accbtntipretenciones;
	          var btn37 = response.data.accbtnfreports;
	          var btn38 = response.data.btnopvacios;
	          var btn39 = response.data.btncontvacios;
	          var btn40 = response.data.btnclasvacios;
	          var btn41 = response.data.btnreportvacios;
	          var btn42 = response.data.btnreportserv;
	          var btn43 = response.data.ordservicios;
	          var btn44 = response.data.accmoviles;
	          var btn45 = response.data.accgservicios;
	          var btn46 = response.data.accservnota;
	          var btn47 = response.data.postventa;
	          var btn48 = response.data.accbtnfacturaxnotas;
	
	          sessionStorage.setItem("accconfiggene", JSON.stringify(orgaz));
	
	          sessionStorage.setItem("accinventarioc", JSON.stringify(inv));
	          sessionStorage.setItem("accventasc", JSON.stringify(vntas));
	          sessionStorage.setItem("acccomprasc", JSON.stringify(cmpras));
	          sessionStorage.setItem("acccontabilidadc", JSON.stringify(cntbild));
	          sessionStorage.setItem("accfinanzasc", JSON.stringify(finazs));
	          sessionStorage.setItem("permisos", JSON.stringify(aplic));
	          sessionStorage.setItem("accvaciosc", JSON.stringify(vaci));
	          sessionStorage.setItem("accserviciosc", JSON.stringify(servi));
	          sessionStorage.setItem("accpostventasc", JSON.stringify(postvent));
	          sessionStorage.setItem("accinicioc", JSON.stringify(perinicio));
	
	          sessionStorage.setItem("accbtnregalmacenc", JSON.stringify(btn1));
	          sessionStorage.setItem("accbtnubialmacenc", JSON.stringify(btn2));
	          sessionStorage.setItem("accbtnumedidac", JSON.stringify(btn3));
	          sessionStorage.setItem("accbtnmarcac", JSON.stringify(btn4));
	          sessionStorage.setItem("accbtnmodeloc", JSON.stringify(btn5));
	          sessionStorage.setItem("accbtntproductoc", JSON.stringify(btn6));
	          sessionStorage.setItem("accbtnproductoc", JSON.stringify(btn7));
	          sessionStorage.setItem("accbtnopinventarioc", JSON.stringify(btn8));
	          sessionStorage.setItem("accbtnactxlsxc", JSON.stringify(btn9));
	          sessionStorage.setItem("accbtntvaciosc", JSON.stringify(btn10));
	          sessionStorage.setItem("accbtnireportsc", JSON.stringify(btn11));
	          sessionStorage.setItem("accbtnclientesc", JSON.stringify(btn12));
	          sessionStorage.setItem("accbtnvendedorc", JSON.stringify(btn13));
	          sessionStorage.setItem("accbtnpedidosc", JSON.stringify(btn14));
	          sessionStorage.setItem("accbtnnentregac", JSON.stringify(btn15));
	          sessionStorage.setItem("accbtnndebitoc", JSON.stringify(btn16));
	          sessionStorage.setItem("accbtnfacturasc", JSON.stringify(btn17));
	          sessionStorage.setItem("accbtnpresupuestoc", JSON.stringify(btn18));
	          sessionStorage.setItem("accbtnvreportsc", JSON.stringify(btn19));
	          sessionStorage.setItem("accbtnproveedoresc", JSON.stringify(btn20));
	          sessionStorage.setItem("accbtnordencomprac", JSON.stringify(btn21));
	          sessionStorage.setItem("accbtnfactucomprac", JSON.stringify(btn22));
	          sessionStorage.setItem("accbtncreportsc", JSON.stringify(btn23));
	          sessionStorage.setItem("accbtncntcontablec", JSON.stringify(btn24));
	          sessionStorage.setItem("accbtnastcntablec", JSON.stringify(btn25));
	          sessionStorage.setItem("accbtnmvbancariosc", JSON.stringify(btn26));
	          sessionStorage.setItem("accbtnmvbancariostc", JSON.stringify(btn27));
	          sessionStorage.setItem("accbtnvinculacuentac", JSON.stringify(btn28));
	          sessionStorage.setItem("accbtncntreportsc", JSON.stringify(btn29));
	          sessionStorage.setItem("accbtnbancosc", JSON.stringify(btn30));
	          sessionStorage.setItem("accbtnbeneficiariosc", JSON.stringify(btn31));
	          sessionStorage.setItem("accbtnctsbancariasc", JSON.stringify(btn32));
	          sessionStorage.setItem("accbtnfacturaxnotasc", JSON.stringify(btn48));
	          sessionStorage.setItem("accbtncnciliabancariac", JSON.stringify(btn33));
	          sessionStorage.setItem("accbtncntxcobrarc", JSON.stringify(btn34));
	          sessionStorage.setItem("accbtncntxpagarc", JSON.stringify(btn35));
	          sessionStorage.setItem("accbtntipretencionesc", JSON.stringify(btn36));
	          sessionStorage.setItem("accbtnfreportsc", JSON.stringify(btn37));
	          sessionStorage.setItem("btnopvaciosc", JSON.stringify(btn38));
	          sessionStorage.setItem("btncontvaciosc", JSON.stringify(btn39));
	          sessionStorage.setItem("btnclasvaciosc", JSON.stringify(btn40));
	          sessionStorage.setItem("btnreportvaciosc", JSON.stringify(btn41));
	          sessionStorage.setItem("ordserviciosc", JSON.stringify(btn42));
	          sessionStorage.setItem("btnreportservc", JSON.stringify(btn43));
	          sessionStorage.setItem("accmovilesc", JSON.stringify(btn44));
	          sessionStorage.setItem("accgserviciosc", JSON.stringify(btn45));
	          sessionStorage.setItem("accservnotac", JSON.stringify(btn46));
	          sessionStorage.setItem("postventac", JSON.stringify(btn47));
	          sessionStorage.setItem("post", JSON.stringify({ tipoprecio: tipoprec }));
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "Error al cargar el usuario",
	            icono: "informacion"
	          });
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    var endpoint = op.conexion + "/api/athos/usuario/actualizar/" + operacion;
	
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setActivate(false);
	
	        if (operacion === 1 || operacion === 2) {
	          if (parseInt(response.data.iduser) > 0) {
	            if (parseInt(response.data.iduser) === parseInt(idusuario)) {
	              SelectUsuario(parseInt(response.data.iduser));
	            }
	          }
	        }
	
	        var mensaje = "";
	        if (operacion === 1) {
	          mensaje = "El usuario " + response.data.iduser + " ha sido registrada de manera satisfactoria.";
	        } else if (operacion === 2) {
	          mensaje = "El usuario " + response.data.iduser + " ha sido modificada de manera satisfactoria.";
	        } else if (operacion === 3) {
	          mensaje = "El usuario " + response.data.iduser + " ha sido eliminada de manera satisfactoria.";
	        }
	
	        setMensaje({
	          mostrar: true,
	          titulo: "Exito.",
	          texto: mensaje,
	          icono: "exito"
	        });
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var datosRes = function datosRes(cedula) {
	    var campos = "*";
	    var nomtab = "persona";
	    var nomid = "cedula";
	
	    var endpoint = op.conexion + "/api/athos/consulta/modeli?campos=" + campos + "&id=" + cedula + "&nomtab=" + nomtab + "&nomid=" + nomid;
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (props.ingresa === 0) {
	          txtNombreUsuario.current.value = "";
	          txtApellidoUsuario.current.value = "";
	          txtDireccionUsuario.current.value = "";
	          txtEmailUsuario.current.value = "";
	          txtTlfUsuario.current.value = "";
	          txtCelUsuario.current.value = "";
	          txtFechaNac.current.value = "";
	          cmbNacionalidad.current.value = "V";
	          cmbSexo.current.value = "M";
	        }
	
	        setHabilitadoNU(true);
	
	        if (response.data !== "") {
	          setHabilitadoNU(false);
	          setOperacionPer(0);
	          txtNombreUsuario.current.value = response.data.nombres;
	          txtApellidoUsuario.current.value = response.data.apellidos;
	          txtDireccionUsuario.current.value = response.data.direccion;
	          txtEmailUsuario.current.value = response.data.correoe;
	          txtTlfUsuario.current.value = response.data.tlf1;
	          txtCelUsuario.current.value = response.data.tlf2;
	          txtFechaNac.current.value = (0, _moment2.default)(response.data.fnacimiento).format("YYYY-MM-DD");
	          cmbNacionalidad.current.value = response.data.nacionalidad;
	          cmbSexo.current.value = response.data.sexo;
	          if (tecla === 13) {
	            setTabIndex(1);
	            setTabIndex1(0);
	            btnAcepta.current.focus();
	          }
	        } else {
	          setOperacionPer(1);
	          setHabilitadoNU(true);
	          if (tecla === 13) {
	            setTimeout(function () {
	              txtNombreUsuario.current.focus();
	            }, 100);
	          }
	        }
	      }
	
	      setActivate(false);
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseCatalogoPer = function handleCloseCatalogoPer() {
	    setMostrar3(false);
	  };
	
	  var handleAceptaCatalogoPer = function handleAceptaCatalogoPer(values) {
	    setMostrar3(false);
	    txtCedula.current.value = values.cedPer;
	    txtNombreUsuario.current.value = values.nomPer;
	    txtApellidoUsuario.current.value = values.apePer;
	    txtDireccionUsuario.current.value = values.direPer;
	    txtEmailUsuario.current.value = values.correoPer;
	    txtTlfUsuario.current.value = values.tlf1Per;
	    txtCelUsuario.current.value = values.tlf2Per;
	    txtFechaNac.current.value = (0, _moment2.default)(values.fnacPer).format("YYYY-MM-DD");
	    cmbNacionalidad.current.value = values.nacPer;
	    cmbSexo.current.value = values.sexoPer;
	    btnAcepta.current.focus();
	  };
	
	  var handleAceptaCatalogoOrg = function handleAceptaCatalogoOrg(values) {
	    setMostrar(false);
	    txtIdAgente.current.value = values.idorganizacion;
	    txtNombreAgente.current.value = values.nombre;
	    txtCedula.current.focus();
	  };
	
	  var blanquear = function blanquear() {
	    setPassword("");
	    setActivate(false);
	    setCorreo("");
	    setOperacionPer(0);
	    setEssupervisor(0);
	    setPermisos({
	      acccontribuyente: "0000",
	      accactividad: "0000",
	      accdeclaraciones: "000",
	      accacticontri: "00",
	      accagente: "0000",
	      accusuariocome: "0000"
	    });
	    setModu1(0);
	    setModu2(0);
	    setModu3(0);
	    setModu4(0);
	    setModu5(0);
	    setModu6(0);
	    setModu7(0);
	    setModu8(0);
	    setModu9(0);
	    setModu10(0);
	    setModulopostventa("");
	    setModuloventas("");
	    setModulocompras("");
	    setModulovacios("");
	    setModuloservicios("");
	    setModulocontabilidad("");
	    setModulofinanzas("");
	    setModulosini("");
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var handleChangeOtro = function handleChangeOtro(event) {
	    if (event.target.name === "permodtimbre") {
	      if (moduinventariosi.current.checked) {
	        setModuloinventario({
	          inve1: "0",
	          inve2: "0",
	          inve3: "0",
	          inve4: "0",
	          inve5: "0",
	          inve6: "0",
	          inve7: "0",
	          inve8: "0",
	          inve9: "0",
	          inve10: "0",
	          inve11: "0",
	          inve12: "0"
	        });
	        setModu1(1);
	      } else if (moduinventariono.current.checked) {
	        setModuloinventario({
	          inve1: "0",
	          inve2: "0",
	          inve3: "0",
	          inve4: "0",
	          inve5: "0",
	          inve6: "0",
	          inve7: "0",
	          inve8: "0",
	          inve9: "0",
	          inve10: "0",
	          inve11: "0",
	          inve12: "0"
	        });
	        setModu1(0);
	      }
	    } else if (event.target.name === "permodminas") {
	      if (event.target.value === "true") {
	        setModuloventas({
	          vents1: "0",
	          vents2: "0",
	          vents3: "0",
	          vents4: "0",
	          vents5: "0",
	          vents6: "0",
	          vents7: "0",
	          vents8: "0",
	          vents9: "0"
	        });
	        setModu2(1);
	      } else if (event.target.value === "false") {
	        setModuloventas({
	          vents1: "0",
	          vents2: "0",
	          vents3: "0",
	          vents4: "0",
	          vents5: "0",
	          vents6: "0",
	          vents7: "0",
	          vents8: "0",
	          vents9: "0"
	        });
	        setModu2(0);
	      }
	    } else if (event.target.name === "permod1x500") {
	      if (event.target.value === "true") {
	        setModulocompras({
	          mcompras1: "0",
	          mcompras2: "0",
	          mcompras3: "0",
	          mcompras4: "0",
	          mcompras5: "0"
	        });
	        setModu3(1);
	      } else if (event.target.value === "false") {
	        setModulocompras({
	          mcompras1: "0",
	          mcompras2: "0",
	          mcompras3: "0",
	          mcompras4: "0",
	          mcompras5: "0"
	        });
	        setModu3(0);
	      }
	    } else if (event.target.name === "permodprod") {
	      if (event.target.value === "true") {
	        setModulocontabilidad({
	          mcontab1: "0",
	          mcontab2: "0",
	          mcontab3: "0",
	          mcontab4: "0",
	          mcontab5: "0",
	          mcontab6: "0"
	        });
	        setModu4(1);
	      } else if (event.target.value === "false") {
	        setModulocontabilidad({
	          mcontab1: "0",
	          mcontab2: "0",
	          mcontab3: "0",
	          mcontab4: "0",
	          mcontab5: "0",
	          mcontab6: "0"
	        });
	        setModu4(0);
	      }
	    } else if (event.target.name === "permodfiscal") {
	      if (event.target.value === "true") {
	        setModulofinanzas({
	          mfinanzas1: "0",
	          mfinanzas2: "0",
	          mfinanzas3: "0",
	          mfinanzas4: "0",
	          mfinanzas5: "0",
	          mfinanzas6: "0",
	          mfinanzas7: "0",
	          mfinanzas8: "0",
	          mfinanzas9: "0",
	          mfinanzas10: "0",
	          mfinanzas11: "0",
	          mfinanzas12: "0"
	        });
	        setModu5(1);
	      } else if (event.target.value === "false") {
	        setModulofinanzas({
	          mfinanzas1: "0",
	          mfinanzas2: "0",
	          mfinanzas3: "0",
	          mfinanzas4: "0",
	          mfinanzas5: "0",
	          mfinanzas6: "0",
	          mfinanzas7: "0",
	          mfinanzas8: "0",
	          mfinanzas9: "0",
	          mfinanzas10: "0",
	          mfinanzas11: "0",
	          mfinanzas12: "0"
	        });
	        setModu5(0);
	      }
	    } else if (event.target.name === "vacios") {
	      if (event.target.value === "true") {
	        setModulovacios({
	          vacios1: "0",
	          vacios2: "0",
	          vacios3: "0",
	          vacios4: "0",
	          vacios5: "0"
	        });
	        setModu7(1);
	      } else if (event.target.value === "false") {
	        setModulovacios({
	          vacios1: "0",
	          vacios2: "0",
	          vacios3: "0",
	          vacios4: "0",
	          vacios5: "0"
	        });
	        setModu7(0);
	      }
	    } else if (event.target.name === "servicios") {
	      if (event.target.value === "true") {
	        setModuloservicios({
	          servicio1: "0",
	          servicio2: "0",
	          servicio3: "0",
	          servicio4: "0",
	          servicio5: "0",
	          servicio6: "0"
	        });
	        setModu8(1);
	      } else if (event.target.value === "false") {
	        setModuloservicios({
	          servicio1: "0",
	          servicio2: "0",
	          servicio3: "0",
	          servicio4: "0",
	          servicio5: "0"
	        });
	        setModu8(0);
	      }
	    } else if (event.target.name === 'ptventa') {
	      if (event.target.value === "true") {
	        setModulopostventa({
	          postventa1: "0",
	          postventa2: "0",
	          postventa3: "0",
	          postventa4: "0",
	          postventa5: "0"
	        });
	        setModu9(1);
	      } else if (event.target.value === "false") {
	        setModulopostventa({
	          postventa1: "0",
	          postventa2: "0",
	          postventa3: "0",
	          postventa4: "0",
	          postventa5: "0"
	        });
	        setModu9(0);
	      }
	    }
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    if (event.which === 13) {
	      var valido;
	      if (event.target.id === "inputCodigo") {
	        txtLogin.current.focus();
	      } else if (event.target.id === "inputLogin") {
	        txtPassword.current.focus();
	      } else if (event.target.id === "inputPassword") {
	        if (txtConfirmPassword.current.value !== "" && txtPassword.current.value !== txtConfirmPassword.current.value) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Las Contraseñas no coinciden.",
	            icono: "informacion"
	          });
	          txtPassword.current.focus();
	        } else {
	          txtConfirmPassword.current.focus();
	        }
	      } else if (event.target.id === "inputConfirmPassword") {
	        if (txtConfirmPassword.current.value !== "" && txtPassword.current.value !== txtConfirmPassword.current.value) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Las Contraseñas no coinciden.",
	            icono: "informacion"
	          });
	          txtConfirmPassword.current.focus();
	        } else {
	          txtIdAgente.current.focus();
	        }
	      } else if (event.target.id === "inputNomUsuario") {
	        txtApellidoUsuario.current.focus();
	      } else if (event.target.id === "inputApeUsuario") {
	        txtDireccionUsuario.current.focus();
	      } else if (event.target.id === "inputDireUsuario") {
	        txtEmailUsuario.current.focus();
	      } else if (event.target.id === "inputEmailUsuario") {
	        valido = (0, _varios.validaEmail)(event.target.value);
	        if (valido) {
	          txtTlfUsuario.current.focus();
	        } else {
	          if (event.target.value !== "") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "Formato de Email invalido.",
	              icono: "informacion"
	            });
	            event.target.value = "";
	          } else {
	            txtTlfUsuario.current.focus();
	          }
	        }
	      } else if (event.target.id === "inputTlfUsuario") {
	        txtCelUsuario.current.focus();
	      } else if (event.target.id === "inputCelUsuario") {
	        txtFechaNac.current.focus();
	      } else if (event.target.id === "inputFechaNac") {
	        cmbNacionalidad.current.focus();
	      }
	    } else if (typeof event.which === "undefined") {
	      if (event.target.id === "inputPassword") {
	        if (txtConfirmPassword.current.value !== "" && txtPassword.current.value !== txtConfirmPassword.current.value) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Las Contraseñas no coinciden.",
	            icono: "informacion"
	          });
	        }
	      } else if (event.target.id === "inputConfirmPassword") {
	        if (txtConfirmPassword.current.value !== "" && txtPassword.current.value !== txtConfirmPassword.current.value) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Las Contraseñas no coinciden.",
	            icono: "informacion"
	          });
	        }
	      } else if (event.target.id === "inputEmailUsuario") {
	        valido = (0, _varios.validaEmail)(event.target.value);
	        if (valido) {
	          txtTlfUsuario.current.focus();
	        } else {
	          if (event.target.value !== "") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "Formato de Email invalido.",
	              icono: "informacion"
	            });
	            event.target.value = "";
	          } else {
	            txtTlfUsuario.current.focus();
	          }
	        }
	      } else if (event.target.id === "inputTlfUsuario") {
	        txtCelUsuario.current.focus();
	      } else if (event.target.id === "inputCelUsuario") {
	        txtFechaNac.current.focus();
	      } else {
	        return false;
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var validarPersona = function validarPersona(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        setContar(0);
	        setTecla(event.which);
	        datosRes(event.target.value);
	      } else {
	        txtNombreUsuario.current.value = "";
	      }
	    }
	  };
	
	  var seleccionarVendedor = function seleccionarVendedor(rif, desde) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = desde === 1 ? "idagente" : "rif";
	    var nomid2 = "vendedor";
	    var id = rif;
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200 && response.data !== "") {
	        txtIdVendedor.current.value = response.data.idagente;
	        cmbRif.current.value = response.data.rif.trim().substring(0, 1);
	        txtRif.current.value = response.data.rif.trim().substring(1, 10);
	        txtRazon.current.value = response.data.nombre.trim();
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      console.log(error);
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var onCatalogoCliente = function onCatalogoCliente(values) {
	    setCatalogoCliente(false);
	    txtIdVendedor.current.value = "";
	    txtRazon.current.value = "";
	    seleccionarVendedor(values.rif.trim(), 2);
	  };
	
	  var validarCliente = function validarCliente(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (cmbRif.current.value !== "" && event.target.value !== "") {
	        var rif = cmbRif.current.value + event.target.value;
	        txtIdVendedor.current.value = "";
	        txtRazon.current.value = "";
	        seleccionarVendedor(rif, 2);
	      }
	    }
	  };
	
	  var checkTodo = function checkTodo(event) {
	    if (event.target.name === "todopersonas") {
	      if (chkPerTodo.current.checked) {
	        chkPerCon.current.checked = true;
	        chkPerIn.current.checked = true;
	        chkPerMod.current.checked = true;
	        chkPerEli.current.checked = true;
	      } else {
	        chkPerCon.current.checked = false;
	        chkPerIn.current.checked = false;
	        chkPerMod.current.checked = false;
	        chkPerEli.current.checked = false;
	      }
	    } else if (event.target.name === "todousuarios") {
	      if (chkUsuTodo.current.checked) {
	        chkUsuCon.current.checked = true;
	        chkUsuIn.current.checked = true;
	        chkUsuMod.current.checked = true;
	        chkUsuEli.current.checked = true;
	      } else {
	        chkUsuCon.current.checked = false;
	        chkUsuIn.current.checked = false;
	        chkUsuMod.current.checked = false;
	        chkUsuEli.current.checked = false;
	      }
	    } else if (event.target.name === "todousuariosapp") {
	      if (chkUsuappTodo.current.checked) {
	        chkUsuappCon.current.checked = true;
	        chkUsuappIn.current.checked = true;
	        chkUsuappMod.current.checked = true;
	        chkUsuappEli.current.checked = true;
	      } else {
	        chkUsuappCon.current.checked = false;
	        chkUsuappIn.current.checked = false;
	        chkUsuappMod.current.checked = false;
	        chkUsuappEli.current.checked = false;
	      }
	    } else if (event.target.name === "todomonedas") {
	      if (chkMoneTodo.current.checked) {
	        chkMoneCon.current.checked = true;
	        chkMoneIn.current.checked = true;
	        chkMoneMod.current.checked = true;
	        chkMoneEli.current.checked = true;
	      } else {
	        chkMoneCon.current.checked = false;
	        chkMoneIn.current.checked = false;
	        chkMoneMod.current.checked = false;
	        chkMoneEli.current.checked = false;
	      }
	    } else if (event.target.name === "todoporcentaje") {
	      if (chkPorTodo.current.checked) {
	        chkPorCon.current.checked = true;
	        chkPorIn.current.checked = true;
	        chkPorMod.current.checked = true;
	        chkPorEli.current.checked = true;
	      } else {
	        chkPorCon.current.checked = false;
	        chkPorIn.current.checked = false;
	        chkPorMod.current.checked = false;
	        chkPorEli.current.checked = false;
	      }
	    } else if (event.target.name === "todouserweb") {
	      if (chkUWebTodo.current.checked) {
	        /*   chkUWebCon.current.checked = true; */
	        chkUWebIn.current.checked = true;
	        chkUWebMod.current.checked = true;
	        /*    chkUWebEli.current.checked = true; */
	      } else {
	        chkUWebCon.current.checked = false;
	        chkUWebIn.current.checked = false;
	        chkUWebMod.current.checked = false;
	        chkUWebEli.current.checked = false;
	      }
	    } else if (event.target.name === "todoapp") {
	      if (chkUAppTodo.current.checked) {
	        chkUAppCon.current.checked = true;
	        chkUAppIn.current.checked = true;
	        chkUAppMod.current.checked = true;
	        chkUAppEli.current.checked = true;
	      } else {
	        chkUAppCon.current.checked = false;
	        chkUAppIn.current.checked = false;
	        chkUAppMod.current.checked = false;
	        chkUAppEli.current.checked = false;
	      }
	    } else if (event.target.name === "todoorg") {
	      if (chkOrgTodo.current.checked) {
	        chkOrgCon.current.checked = true;
	        chkOrgIn.current.checked = true;
	        chkOrgMod.current.checked = true;
	        chkOrgEli.current.checked = true;
	      } else {
	        chkOrgCon.current.checked = false;
	        chkOrgIn.current.checked = false;
	        chkOrgMod.current.checked = false;
	        chkOrgEli.current.checked = false;
	      }
	    } else if (event.target.name === "todosinventario") {
	      if (chkitodos.current.checked) {
	        chkralmacen.current.checked = true;
	        chkubialmacen.current.checked = true;
	        chkudmedida.current.checked = true;
	        chkmarca.current.checked = true;
	        chkmodelo.current.checked = true;
	        chktpproduct.current.checked = true;
	        chkproducto.current.checked = true;
	        chkopinventario.current.checked = true;
	        chkactxlsx.current.checked = true;
	        chkgvacios.current.checked = true;
	        chkiconfigura.current.checked = true;
	        chkireports.current.checked = true;
	      } else {
	        chkralmacen.current.checked = false;
	        chkubialmacen.current.checked = false;
	        chkudmedida.current.checked = false;
	        chkmarca.current.checked = false;
	        chkmodelo.current.checked = false;
	        chktpproduct.current.checked = false;
	        chkproducto.current.checked = false;
	        chkopinventario.current.checked = false;
	        chkactxlsx.current.checked = false;
	        chkgvacios.current.checked = false;
	        chkiconfigura.current.checked = false;
	        chkireports.current.checked = false;
	      }
	    } else if (event.target.name === "todosventas") {
	      if (chkvtodos.current.checked) {
	        chkclientes.current.checked = true;
	        chkvendedores.current.checked = true;
	        chkpedidos.current.checked = true;
	        chknentrega.current.checked = true;
	        chkndebito.current.checked = true;
	        chkfactura.current.checked = true;
	        chkpresupuesto.current.checked = true;
	        chkvconfi.current.checked = true;
	        chkvreports.current.checked = true;
	        chkfacturaxnotas.current.checked = true;
	      } else {
	        chkclientes.current.checked = false;
	        chkvendedores.current.checked = false;
	        chkpedidos.current.checked = false;
	        chknentrega.current.checked = false;
	        chkndebito.current.checked = false;
	        chkfactura.current.checked = false;
	        chkpresupuesto.current.checked = false;
	        chkvconfi.current.checked = false;
	        chkvreports.current.checked = false;
	        chkfacturaxnotas.current.checked = false;
	      }
	    } else if (event.target.name === "todoscompras") {
	      if (chkcptodos.current.checked) {
	        chkproveedores.current.checked = true;
	        chkordencompra.current.checked = true;
	        chkfactucompra.current.checked = true;
	        chkcpconfig.current.checked = true;
	        chkcpreports.current.checked = true;
	      } else {
	        chkproveedores.current.checked = false;
	        chkordencompra.current.checked = false;
	        chkfactucompra.current.checked = false;
	        chkcpconfig.current.checked = false;
	        chkcpreports.current.checked = false;
	      }
	    } else if (event.target.name === "todoscontabilidad") {
	      if (chkcnttodos.current.checked) {
	        chkcatctcontable.current.checked = true;
	        chkasientcntable.current.checked = true;
	        chkvincuenta.current.checked = true;
	        chkmovibancot.current.checked = true;
	        chkcntconfig.current.checked = true;
	        chkcntreports.current.checked = true;
	      } else {
	        chkcatctcontable.current.checked = false;
	        chkasientcntable.current.checked = false;
	        chkvincuenta.current.checked = false;
	        chkmovibancot.current.checked = false;
	        chkcntconfig.current.checked = false;
	        chkcntreports.current.checked = false;
	      }
	    } else if (event.target.name === "todosfinanzas") {
	      if (chkftodos.current.checked) {
	        chkbancos.current.checked = true;
	        chkbeneficiarios.current.checked = true;
	        chkctasbancarias.current.checked = true;
	        chkmovibancarios.current.checked = true;
	        chkmovitransito.current.checked = true;
	        chkconciliacionbanco.current.checked = true;
	        chkctasxcobrar.current.checked = true;
	        chkctasxpagar.current.checked = true;
	        chktiporetenciones.current.checked = true;
	        chkfconfig.current.checked = true;
	        chkfreports.current.checked = true;
	        chkReverPagoAnti.current.checked = true;
	      } else {
	        chkbancos.current.checked = false;
	        chkbeneficiarios.current.checked = false;
	        chkctasbancarias.current.checked = false;
	        chkmovibancarios.current.checked = false;
	        chkmovitransito.current.checked = false;
	        chkconciliacionbanco.current.checked = false;
	        chkctasxcobrar.current.checked = false;
	        chkctasxpagar.current.checked = false;
	        chktiporetenciones.current.checked = false;
	        chkfconfig.current.checked = false;
	        chkfreports.current.checked = false;
	        chkReverPagoAnti.current.checked = false;
	      }
	    } else if (event.target.name === "todosvacios") {
	      if (chkvaciostodos.current.checked) {
	        chkopvacios.current.checked = true;
	        chkcontrolvacios.current.checked = true;
	        chkclassvacios.current.checked = true;
	        chkvaciosconfig.current.checked = true;
	        chkvaciosreports.current.checked = true;
	      } else {
	        chkopvacios.current.checked = false;
	        chkcontrolvacios.current.checked = false;
	        chkclassvacios.current.checked = false;
	        chkvaciosconfig.current.checked = false;
	        chkvaciosreports.current.checked = false;
	      }
	    } else if (event.target.name === "todosservicios") {
	      if (chkservtodos.current.checked) {
	        chkordenservi.current.checked = true;
	        chkservconfig.current.checked = true;
	        chkservreports.current.checked = true;
	        chkmovilesservi.current.checked = true;
	        chkgservicios.current.checked = true;
	        chkservnotaent.current.checked = true;
	      } else {
	        chkordenservi.current.checked = false;
	        chkservconfig.current.checked = false;
	        chkservreports.current.checked = false;
	        chkmovilesservi.current.checked = false;
	        chkgservicios.current.checked = false;
	        chkservnotaent.current.checked = false;
	      }
	    } else if (event.target.name === "todospostventa") {
	      if (chkpostventtodos.current.checked) {
	        chkpostventventa.current.checked = true;
	      } else {
	        chkpostventventa.current.checked = false;
	      }
	    }
	  };
	
	  var checkBlank = function checkBlank(e) {
	    if (modu1 === 1) {
	      if (chkralmacen.current.checked && chkubialmacen.current.checked && chkudmedida.current.checked && chkmarca.current.checked && chkmodelo.current.checked && chktpproduct.current.checked && chkproducto.current.checked && chkopinventario.current.checked && chkactxlsx.current.checked && chkgvacios.current.checked && chkiconfigura.current.checked && chkireports.current.checked) {
	        chkitodos.current.checked = true;
	      } else {
	        chkitodos.current.checked = false;
	      }
	    }
	
	    if (modulosConfig.opcion2 === "1") {
	      if (chkPerCon.current.checked && chkPerIn.current.checked && chkPerMod.current.checked && chkPerEli.current.checked) {
	        chkPerTodo.current.checked = true;
	      } else {
	        chkPerTodo.current.checked = false;
	      }
	    }
	
	    if (modulosConfig.opcion3 === "1") {
	      if (chkUsuCon.current.checked && chkUsuIn.current.checked && chkUsuMod.current.checked && chkUsuEli.current.checked) {
	        chkUsuTodo.current.checked = true;
	      } else {
	        chkUsuTodo.current.checked = false;
	      }
	    }
	
	    if (modulosConfig.opcion6 === "1") {
	      if (chkUsuappCon.current.checked && chkUsuappIn.current.checked && chkUsuappMod.current.checked && chkUsuappEli.current.checked) {
	        chkUsuappTodo.current.checked = true;
	      } else {
	        chkUsuappTodo.current.checked = false;
	      }
	    }
	
	    if (modulosConfig.opcion4 === "1") {
	      if (chkMoneCon.current.checked && chkMoneIn.current.checked && chkMoneMod.current.checked && chkMoneEli.current.checked) {
	        chkMoneTodo.current.checked = true;
	      } else {
	        chkMoneTodo.current.checked = false;
	      }
	    }
	
	    if (chkclientes.current.checked && chkvendedores.current.checked && chkpedidos.current.checked && chknentrega.current.checked && chkndebito.current.checked && chkfactura.current.checked && chkfacturaxnotas.current.checked && chkpresupuesto.current.checked && chkvconfi.current.checked && chkvreports.current.checked) {
	      chkvtodos.current.checked = true;
	    } else {
	      chkvtodos.current.checked = false;
	    }
	
	    if (chkproveedores.current.checked && chkordencompra.current.checked && chkfactucompra.current.checked && chkcpconfig.current.checked && chkcpreports.current.checked) {
	      chkcptodos.current.checked = true;
	    } else {
	      chkcptodos.current.checked = false;
	    }
	
	    if (chkcatctcontable.current.checked && chkasientcntable.current.checked && chkvincuenta.current.checked && chkmovibancot.current.checked && chkcntconfig.current.checked && chkcntreports.current.checked) {
	      chkcnttodos.current.checked = true;
	    } else {
	      chkcnttodos.current.checked = false;
	    }
	
	    if (chkbancos.current.checked === true && chkbeneficiarios.current.checked === true && chkctasbancarias.current.checked === true && chkmovibancarios.current.checked === true && chkmovitransito.current.checked === true && chkconciliacionbanco.current.checked === true && chkctasxcobrar.current.checked === true && chkctasxpagar.current.checked === true && chktiporetenciones.current.checked === true && chkfconfig.current.checked === true && chkfreports.current.checked === true && chkReverPagoAnti.current.checked === true) {
	      chkftodos.current.checked = true;
	    } else {
	      chkftodos.current.checked = false;
	    }
	
	    if (modu7 === 1) {
	      if (chkopvacios.current.checked && chkcontrolvacios.current.checked && chkclassvacios.current.checked && chkvaciosconfig.current.checked && chkvaciosreports.current.checked) {
	        chkvaciostodos.current.checked = true;
	      } else {
	        chkvaciostodos.current.checked = false;
	      }
	    }
	
	    if (modu8 === 1) {
	      if (chkordenservi.current.checked && chkservconfig.current.checked && chkservreports.current.checked && chkmovilesservi.current.checked && chkgservicios.current.checked && chkservnotaent.current.checked) {
	        chkservtodos.current.checked = true;
	      } else {
	        chkservtodos.current.checked = false;
	      }
	    }
	
	    if (modu9 === 1) {
	      if (chkpostventventa.current.checked) {
	        chkpostventtodos.current.checked = true;
	      } else {
	        chkpostventtodos.current.checked = false;
	      }
	    }
	    if (props.usuario && props.usuario.passwsupervisor !== false) {
	      if (chksupervisor.current.checked === true) {
	        setEssupervisor(1);
	      } else {
	        setEssupervisor(0);
	      }
	    }
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.id === "modulo") {
	      setModulosConfig(Object.assign({}, modulosConfig, _defineProperty({}, e.target.name, e.target.value)));
	    }
	  };
	
	  var onChangeMonuini = function onChangeMonuini(e) {
	    if (e.target.name === "inicio") {
	      if (e.target.value === "1") {
	        setModulosini({ moduini: e.target.value });
	      } else {
	        setModulosini({ moduini: e.target.value });
	      }
	    }
	  };
	
	  var validarAgente = function validarAgente(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        setContar(0);
	        setTecla(event.which);
	        datosAgente(event.target.value);
	      } else {
	        txtNombreUsuario.current.value = "";
	      }
	    }
	  };
	
	  var datosAgente = function datosAgente(idagente) {
	    var campos = "*";
	    var nomtab = "organizacion";
	    var nomid = "idorganizacion";
	
	    var endpoint = op.conexion + "/api/athos/consulta/modeli?campos=" + campos + "&id=" + idagente + "&nomtab=" + nomtab + "&nomid=" + nomid;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data !== "") {
	          txtNombreAgente.current.value = response.data.nombre;
	          txtCedula.current.focus();
	          setContar(contar + 1);
	        } else {
	          txtNombreAgente.current.value = "";
	          txtIdAgente.current.value = "";
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El Agente no existe.",
	            icono: "informacion"
	          });
	        }
	      }
	
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var personas = "";
	    var usuarios = "";
	    var usuariosapp = "";
	    var moneda = "";
	    var minventario = "";
	    var mventas = "";
	    var mcompras = "";
	    var mcontabilidad = "";
	    var mfinanzas = "";
	    var moduloss = "";
	    var vacios = "";
	    var servicios = "";
	    var postventas = "";
	    var permiinicio = "";
	
	    var inv1 = "";
	    var inv2 = "";
	    var inv3 = "";
	    var inv4 = "";
	    var inv5 = "";
	    var inv6 = "";
	    var inv7 = "";
	    var inv8 = "";
	    var inv9 = "";
	    var inv10 = "";
	    var inv11 = "";
	
	    var vent1 = "";
	    var vent2 = "";
	    var vent3 = "";
	    var vent4 = "";
	    var vent5 = "";
	    var vent6 = "";
	    var vent7 = "";
	    var vent8 = "";
	    var vent9 = "";
	
	    var compr1 = "";
	    var compr2 = "";
	    var compr3 = "";
	    var compr4 = "";
	
	    var vacio1 = "";
	    var vacio2 = "";
	    var vacio3 = "";
	    var vacio4 = "";
	
	    var servicio1 = "";
	    var servicio2 = "";
	    var servicio3 = "";
	    var servicio4 = "";
	    var servicio5 = "";
	
	    var postventa1 = "";
	    var postventa2 = false;
	    var postventa3 = "";
	    var postventa4 = "";
	    var postventa5 = "";
	
	    var contb1 = "";
	    var contb2 = "";
	    var contb3 = "";
	    var contb4 = "";
	    var contb5 = "";
	
	    var finaz1 = "";
	    var finaz2 = "";
	    var finaz3 = "";
	    var finaz4 = "";
	    var finaz5 = "";
	    var finaz6 = "";
	    var finaz7 = "";
	    var finaz8 = "";
	    var finaz9 = "";
	    var finaz10 = "";
	
	    if (modulosConfig.opcion2 === "1") {
	      var permiso1 = chkPerCon.current.checked === true ? "1" : "0";
	      var permiso2 = chkPerIn.current.checked === true ? "1" : "0";
	      var permiso3 = chkPerMod.current.checked === true ? "1" : "0";
	      var permiso4 = chkPerEli.current.checked === true ? "1" : "0";
	
	      personas = permiso1 + permiso2 + permiso3 + permiso4;
	    } else {
	      personas = "0000";
	    }
	
	    if (modulosConfig.opcion3 === "1") {
	      var _permiso = chkUsuCon.current.checked === true ? "1" : "0";
	      var _permiso2 = chkUsuIn.current.checked === true ? "1" : "0";
	      var _permiso3 = chkUsuMod.current.checked === true ? "1" : "0";
	      var _permiso4 = chkUsuEli.current.checked === true ? "1" : "0";
	
	      usuarios = _permiso + _permiso2 + _permiso3 + _permiso4;
	    } else {
	      usuarios = "0000";
	    }
	
	    if (modulosConfig.opcion6 === "1") {
	      var _permiso5 = chkUsuappCon.current.checked === true ? "1" : "0";
	      var _permiso6 = chkUsuappIn.current.checked === true ? "1" : "0";
	      var _permiso7 = chkUsuappMod.current.checked === true ? "1" : "0";
	      var _permiso8 = chkUsuappEli.current.checked === true ? "1" : "0";
	
	      usuariosapp = _permiso5 + _permiso6 + _permiso7 + _permiso8;
	    } else {
	      usuariosapp = "0000";
	    }
	
	    if (modulosConfig.opcion4 === "1") {
	      var _permiso9 = chkMoneCon.current.checked === true ? "1" : "0";
	      var _permiso10 = chkMoneIn.current.checked === true ? "1" : "0";
	      var _permiso11 = chkMoneMod.current.checked === true ? "1" : "0";
	      var _permiso12 = chkMoneEli.current.checked === true ? "1" : "0";
	
	      moneda = _permiso9 + _permiso10 + _permiso11 + _permiso12;
	    } else {
	      moneda = "0000";
	    }
	
	    if (aplica.toString().substring(0, 1) === "1" && operacion !== 4 && modu1 === 1 || operacion === 1 && modu1 === 1) {
	      var val1 = chkralmacen.current.checked === true ? "1" : "0";
	      var val2 = chkubialmacen.current.checked === true ? "1" : "0";
	      var val3 = chkudmedida.current.checked === true ? "1" : "0";
	      var val4 = chkmarca.current.checked === true ? "1" : "0";
	      var val5 = chkmodelo.current.checked === true ? "1" : "0";
	      var val6 = chktpproduct.current.checked === true ? "1" : "0";
	      var val7 = chkproducto.current.checked === true ? "1" : "0";
	      var val8 = chkopinventario.current.checked === true ? "1" : "0";
	      var val9 = chkactxlsx.current.checked === true ? "1" : "0";
	      var val10 = chkgvacios.current.checked === true ? "1" : "0";
	      var val11 = chkiconfigura.current.checked === true ? "1" : "0";
	      var val12 = chkireports.current.checked === true ? "1" : "0";
	
	      minventario = val1 + val2 + val3 + val4 + val5 + val6 + val7 + val8 + val9 + val10 + val11 + val12;
	
	      if (val1 === "0") {
	        inv1 = "000000";
	      } else {
	        if (operacion === 1) {
	          inv1 = "000000";
	        } else {
	          inv1 = props.usuario.accbtnregalmacen;
	        }
	      }
	
	      if (val2 === "0") {
	        inv2 = "000000";
	      } else {
	        if (operacion === 1) {
	          inv2 = "000000";
	        } else {
	          inv2 = props.usuario.accbtnubialmacen;
	        }
	      }
	
	      if (val3 === "0") {
	        inv3 = "000000";
	      } else {
	        if (operacion === 1) {
	          inv3 = "000000";
	        } else {
	          inv3 = props.usuario.accbtnumedida;
	        }
	      }
	
	      if (val4 === "0") {
	        inv4 = "000000";
	      } else {
	        if (operacion === 1) {
	          inv4 = "000000";
	        } else {
	          inv4 = props.usuario.accbtnmarca;
	        }
	      }
	
	      if (val5 === "0") {
	        inv5 = "000000";
	      } else {
	        if (operacion === 1) {
	          inv5 = "000000";
	        } else {
	          inv5 = props.usuario.accbtnmodelo;
	        }
	      }
	
	      if (val6 === "0") {
	        inv6 = "000000";
	      } else {
	        if (operacion === 1) {
	          inv6 = "000000";
	        } else {
	          inv6 = props.usuario.accbtntproducto;
	        }
	      }
	
	      if (val7 === "0") {
	        inv7 = "000000";
	      } else {
	        if (operacion === 1) {
	          inv7 = "000000";
	        } else {
	          inv7 = props.usuario.accbtnproducto;
	        }
	      }
	
	      if (val8 === "0") {
	        inv8 = "000000";
	      } else {
	        if (operacion === 1) {
	          inv8 = "000000";
	        } else {
	          inv8 = props.usuario.accbtnopinventario;
	        }
	      }
	
	      if (val9 === "0") {
	        inv9 = "000000";
	      } else {
	        if (operacion === 1) {
	          inv9 = "000000";
	        } else {
	          inv9 = props.usuario.accbtnactxlsx;
	        }
	      }
	
	      if (val10 === "0") {
	        inv10 = "000000";
	      } else {
	        if (operacion === 1) {
	          inv10 = "000000";
	        } else {
	          inv10 = props.usuario.accbtntvacios;
	        }
	      }
	
	      if (val12 === "0") {
	        inv11 = "000000";
	      } else {
	        if (operacion === 1) {
	          inv11 = "000000";
	        } else {
	          inv11 = props.usuario.accbtnireports;
	        }
	      }
	    } else {
	      minventario = "000000000000";
	      inv1 = "000000";
	      inv2 = "000000";
	      inv3 = "000000";
	      inv4 = "000000";
	      inv5 = "000000";
	      inv6 = "000000";
	      inv7 = "000000";
	      inv8 = "000000";
	      inv9 = "000000";
	      inv10 = "000000";
	      inv11 = "000000";
	    }
	
	    if (aplica.toString().substring(1, 2) === "1" && operacion !== 4 && modu2 === 1 || operacion === 1 && modu2 === 1) {
	      var _val = chkclientes.current.checked === true ? "1" : "0";
	      var _val2 = chkvendedores.current.checked === true ? "1" : "0";
	      var _val3 = chkpedidos.current.checked === true ? "1" : "0";
	      var _val4 = chknentrega.current.checked === true ? "1" : "0";
	      var _val5 = chkndebito.current.checked === true ? "1" : "0";
	      var _val6 = chkfactura.current.checked === true ? "1" : "0";
	      var _val7 = chkpresupuesto.current.checked === true ? "1" : "0";
	      var _val8 = chkvconfi.current.checked === true ? "1" : "0";
	      var _val9 = chkvreports.current.checked === true ? "1" : "0";
	      var _val10 = chkfacturaxnotas.current.checked === true ? "1" : "0";
	
	      mventas = _val + _val2 + _val3 + _val4 + _val5 + _val6 + _val7 + _val8 + _val9 + _val10;
	
	      if (_val === "0") {
	        vent1 = "000000";
	      } else {
	        if (operacion === 1) {
	          vent1 = "000000";
	        } else {
	          vent1 = props.usuario.accbtnclientes;
	        }
	      }
	
	      if (_val2 === "0") {
	        vent2 = "000000";
	      } else {
	        if (operacion === 1) {
	          vent2 = "000000";
	        } else {
	          vent2 = props.usuario.accbtnvendedor;
	        }
	      }
	
	      if (_val3 === "0") {
	        vent3 = "000000";
	      } else {
	        if (operacion === 1) {
	          vent3 = "000000";
	        } else {
	          vent3 = props.usuario.accbtnpedidos;
	        }
	      }
	
	      if (_val4 === "0") {
	        vent4 = "000000";
	      } else {
	        if (operacion === 1) {
	          vent4 = "000000";
	        } else {
	          vent4 = props.usuario.accbtnnentrega;
	        }
	      }
	
	      if (_val5 === "0") {
	        vent5 = "000000";
	      } else {
	        if (operacion === 1) {
	          vent5 = "000000";
	        } else {
	          vent5 = props.usuario.accbtnndebito;
	        }
	      }
	
	      if (_val6 === "0") {
	        vent6 = "000000";
	      } else {
	        if (operacion === 1) {
	          vent6 = "000000";
	        } else {
	          vent6 = props.usuario.accbtnfacturas;
	        }
	      }
	
	      if (_val7 === "0") {
	        vent7 = "000000";
	      } else {
	        if (operacion === 1) {
	          vent7 = "000000";
	        } else {
	          vent7 = props.usuario.accbtnpresupuesto;
	        }
	      }
	
	      if (_val9 === "0") {
	        vent8 = "000000";
	      } else {
	        if (operacion === 1) {
	          vent8 = "000000";
	        } else {
	          vent8 = props.usuario.accbtnvreports;
	        }
	      }
	
	      if (_val10 === "0") {
	        vent9 = "000000";
	      } else {
	        if (operacion === 1) {
	          vent9 = "000000";
	        } else {
	          vent9 = props.usuario.accbtnfacturaxnotas;
	        }
	      }
	    } else {
	      mventas = "000000000";
	      vent1 = "000000";
	      vent2 = "000000";
	      vent3 = "000000";
	      vent4 = "000000";
	      vent5 = "000000";
	      vent6 = "000000";
	      vent7 = "000000";
	      vent8 = "000000";
	      vent9 = "000000";
	    }
	
	    if (aplica.toString().substring(2, 3) === "1" && operacion !== 4 && modu3 === 1 || operacion === 1 && modu3 === 1) {
	      var _val11 = chkproveedores.current.checked === true ? "1" : "0";
	      var _val12 = chkordencompra.current.checked === true ? "1" : "0";
	      var _val13 = chkfactucompra.current.checked === true ? "1" : "0";
	      var _val14 = chkcpconfig.current.checked === true ? "1" : "0";
	      var _val15 = chkcpreports.current.checked === true ? "1" : "0";
	
	      mcompras = _val11 + _val12 + _val13 + _val14 + _val15;
	
	      if (_val11 === "0") {
	        compr1 = "000000";
	      } else {
	        if (operacion === 1) {
	          compr1 = "000000";
	        } else {
	          compr1 = props.usuario.accbtnproveedores;
	        }
	      }
	
	      if (_val12 === "0") {
	        compr2 = "000000";
	      } else {
	        if (operacion === 1) {
	          compr2 = "000000";
	        } else {
	          compr2 = props.usuario.accbtnordencompra;
	        }
	      }
	
	      if (_val13 === "0") {
	        compr3 = "000000";
	      } else {
	        if (operacion === 1) {
	          compr3 = "000000";
	        } else {
	          compr3 = props.usuario.accbtnfactucompra;
	        }
	      }
	
	      if (_val15 === "0") {
	        compr4 = "000000";
	      } else {
	        if (operacion === 1) {
	          compr4 = "000000";
	        } else {
	          compr4 = props.usuario.accbtncreports;
	        }
	      }
	    } else {
	      mcompras = "00000";
	      compr1 = "000000";
	      compr2 = "000000";
	      compr3 = "000000";
	      compr4 = "000000";
	    }
	
	    if (aplica.toString().substring(3, 4) === "1" && operacion !== 4 && modu4 === 1 || operacion === 1 && modu4 === 1) {
	      var _val16 = chkcatctcontable.current.checked === true ? "1" : "0";
	      var _val17 = chkasientcntable.current.checked === true ? "1" : "0";
	      var _val18 = chkvincuenta.current.checked === true ? "1" : "0";
	      var _val19 = chkmovibancot.current.checked === true ? "1" : "0";
	      var _val20 = chkcntconfig.current.checked === true ? "1" : "0";
	      var _val21 = chkcntreports.current.checked === true ? "1" : "0";
	
	      mcontabilidad = _val16 + _val17 + _val18 + _val19 + _val20 + _val21;
	
	      if (_val16 === "0") {
	        contb1 = "000000";
	      } else {
	        if (operacion === 1) {
	          contb1 = "000000";
	        } else {
	          contb1 = props.usuario.accbtncntcontable;
	        }
	      }
	
	      if (_val17 === "0") {
	        contb2 = "000000";
	      } else {
	        if (operacion === 1) {
	          contb2 = "000000";
	        } else {
	          contb2 = props.usuario.accbtnastcntable;
	        }
	      }
	
	      if (_val18 === "0") {
	        contb3 = "000000";
	      } else {
	        if (operacion === 1) {
	          contb3 = "000000";
	        } else {
	          contb3 = props.usuario.accbtnmvbancariost;
	        }
	      }
	
	      if (_val19 === "0") {
	        contb4 = "000000";
	      } else {
	        if (operacion === 1) {
	          contb4 = "000000";
	        } else {
	          contb4 = props.usuario.accbtnvinculacuenta;
	        }
	      }
	
	      if (_val21 === "0") {
	        contb5 = "000000";
	      } else {
	        if (operacion === 1) {
	          contb5 = "000000";
	        } else {
	          contb5 = props.usuario.accbtncntreports;
	        }
	      }
	    } else {
	      mcontabilidad = "000000";
	      contb1 = "000000";
	      contb2 = "000000";
	      contb3 = "000000";
	      contb4 = "000000";
	      contb5 = "000000";
	    }
	
	    if (aplica.toString().substring(4, 5) === "1" && operacion !== 4 && modu5 === 1 || operacion === 1 && modu5 === 1) {
	      var _val22 = chkbancos.current.checked === true ? "1" : "0";
	      var _val23 = chkbeneficiarios.current.checked === true ? "1" : "0";
	      var _val24 = chkctasbancarias.current.checked === true ? "1" : "0";
	      var _val25 = chkmovibancarios.current.checked === true ? "1" : "0";
	      var _val26 = chkmovitransito.current.checked === true ? "1" : "0";
	      var _val27 = chkconciliacionbanco.current.checked === true ? "1" : "0";
	      var _val28 = chkctasxcobrar.current.checked === true ? "1" : "0";
	      var _val29 = chkctasxpagar.current.checked === true ? "1" : "0";
	      var _val30 = chktiporetenciones.current.checked === true ? "1" : "0";
	      var _val31 = chkfconfig.current.checked === true ? "1" : "0";
	      var _val32 = chkfreports.current.checked === true ? "1" : "0";
	      var _val33 = chkReverPagoAnti.current.checked === true ? "1" : "0";
	
	      mfinanzas = _val22 + _val23 + _val24 + _val25 + _val26 + _val27 + _val28 + _val29 + _val30 + _val31 + _val32 + _val33;
	
	      if (_val22 === "0") {
	        finaz1 = "000000";
	      } else {
	        if (operacion === 1) {
	          finaz1 = "000000";
	        } else {
	          finaz1 = props.usuario.accbtnmvbancarios;
	        }
	      }
	
	      if (_val23 === "0") {
	        finaz2 = "000000";
	      } else {
	        if (operacion === 1) {
	          finaz2 = "000000";
	        } else {
	          finaz2 = props.usuario.accbtnmvbancariost;
	        }
	      }
	
	      if (_val24 === "0") {
	        finaz3 = "000000";
	      } else {
	        if (operacion === 1) {
	          finaz3 = "000000";
	        } else {
	          finaz3 = props.usuario.accbtnbancos;
	        }
	      }
	
	      if (_val25 === "0") {
	        finaz4 = "000000";
	      } else {
	        if (operacion === 1) {
	          finaz4 = "000000";
	        } else {
	          finaz4 = props.usuario.accbtnbeneficiarios;
	        }
	      }
	
	      if (_val26 === "0") {
	        finaz5 = "000000";
	      } else {
	        if (operacion === 1) {
	          finaz5 = "000000";
	        } else {
	          finaz5 = props.usuario.accbtnctsbancarias;
	        }
	      }
	
	      if (_val27 === "0") {
	        finaz6 = "000000";
	      } else {
	        if (operacion === 1) {
	          finaz6 = "000000";
	        } else {
	          finaz6 = props.usuario.accbtncnciliabancaria;
	        }
	      }
	
	      if (_val28 === "0") {
	        finaz7 = "000000";
	      } else {
	        if (operacion === 1) {
	          finaz7 = "000000";
	        } else {
	          finaz7 = props.usuario.accbtncntxcobrar;
	        }
	      }
	
	      if (_val29 === "0") {
	        finaz8 = "000000";
	      } else {
	        if (operacion === 1) {
	          finaz8 = "000000";
	        } else {
	          finaz8 = props.usuario.accbtncntxpagar;
	        }
	      }
	
	      if (_val30 === "0") {
	        finaz9 = "000000";
	      } else {
	        if (operacion === 1) {
	          finaz9 = "000000";
	        } else {
	          finaz9 = props.usuario.accbtntipretenciones;
	        }
	      }
	
	      if (_val32 === "0") {
	        finaz10 = "00000000";
	      } else {
	        if (operacion === 1) {
	          finaz10 = "000000000";
	        } else {
	          finaz10 = props.usuario.accbtnfreports;
	        }
	      }
	    } else {
	      mfinanzas = "00000000000";
	      finaz1 = "000000";
	      finaz2 = "000000";
	      finaz3 = "000000";
	      finaz4 = "000000";
	      finaz5 = "000000";
	      finaz6 = "000000";
	      finaz7 = "000000";
	      finaz8 = "000000";
	      finaz9 = "000000";
	      finaz10 = "00000000";
	    }
	
	    if (aplica !== "00000000" || operacion === 1) {
	      var _val34 = moduinventariosi.current.checked === true ? "1" : "0";
	      var _val35 = moduventassi.current.checked === true ? "1" : "0";
	      var _val36 = moducomprassi.current.checked === true ? "1" : "0";
	      var _val37 = moducontabsi.current.checked === true ? "1" : "0";
	      var _val38 = modufinanzassi.current.checked === true ? "1" : "0";
	      var _val39 = moduconfigsi.current.checked === true ? "1" : "0";
	      var _val40 = moduvaciossi.current.checked === true ? "1" : "0";
	      var _val41 = moduserviciossi.current.checked === true ? "1" : "0";
	      var _val42 = modupostventasi.current.checked === true ? "1" : "0";
	
	      moduloss = _val34 + _val35 + _val36 + _val37 + _val38 + _val39 + _val40 + _val41 + _val42;
	    } else {
	      moduloss = "0000000000";
	    }
	
	    if (modulosini.moduini !== "" || operacion === 1) {
	      var _val43 = modulosini.moduini;
	      permiinicio = _val43;
	    } else {
	      permiinicio = "0";
	    }
	
	    if (aplica.toString().substring(6, 7) === "1" && operacion !== 4 && modu7 === 1 || operacion === 1 && modu7 === 1) {
	      var _val44 = chkopvacios.current.checked === true ? "1" : "0";
	      var _val45 = chkcontrolvacios.current.checked === true ? "1" : "0";
	      var _val46 = chkclassvacios.current.checked === true ? "1" : "0";
	      var _val47 = chkvaciosconfig.current.checked === true ? "1" : "0";
	      var _val48 = chkvaciosreports.current.checked === true ? "1" : "0";
	
	      vacios = _val44 + _val45 + _val46 + _val47 + _val48;
	
	      if (_val44 === "0") {
	        vacio1 = "000000";
	      } else {
	        if (operacion === 1) {
	          vacio1 = "000000";
	        } else {
	          vacio1 = props.usuario.btnopvacios;
	        }
	      }
	
	      if (_val45 === "0") {
	        vacio2 = "000000";
	      } else {
	        if (operacion === 1) {
	          vacio2 = "000000";
	        } else {
	          vacio2 = props.usuario.btncontvacios;
	        }
	      }
	
	      if (_val46 === "0") {
	        vacio3 = "000000";
	      } else {
	        if (operacion === 1) {
	          vacio3 = "000000";
	        } else {
	          vacio3 = props.usuario.btnclasvacios;
	        }
	      }
	
	      if (_val48 === "0") {
	        vacio4 = "000000";
	      } else {
	        if (operacion === 1) {
	          vacio4 = "000000";
	        } else {
	          vacio4 = props.usuario.btnreportvacios;
	        }
	      }
	    } else {
	      vacios = "00000";
	      vacio1 = "000000";
	      vacio2 = "000000";
	      vacio3 = "000000";
	      vacio4 = "000000";
	    }
	
	    if (aplica.toString().substring(7, 8) === "1" && operacion !== 4 && modu8 === 1 || operacion === 1 && modu8 === 1) {
	      var _val49 = chkordenservi.current.checked === true ? "1" : "0";
	      var _val50 = chkmovilesservi.current.checked === true ? "1" : "0";
	      var _val51 = chkgservicios.current.checked === true ? "1" : "0";
	      var _val52 = chkservnotaent.current.checked === true ? "1" : "0";
	      var _val53 = chkservconfig.current.checked === true ? "1" : "0";
	      var _val54 = chkservreports.current.checked === true ? "1" : "0";
	
	      servicios = _val49 + _val50 + _val51 + _val52 + _val53 + _val54;
	
	      if (_val49 === "0") {
	        servicio1 = "000000";
	      } else {
	        if (operacion === 1) {
	          servicio1 = "000000";
	        } else {
	          servicio1 = props.usuario.ordservicios;
	        }
	      }
	
	      if (_val50 === "0") {
	        servicio2 = "000000";
	      } else {
	        if (operacion === 1) {
	          servicio2 = "000000";
	        } else {
	          servicio2 = props.usuario.accmoviles;
	        }
	      }
	
	      if (_val51 === "0") {
	        servicio3 = "000000";
	      } else {
	        if (operacion === 1) {
	          servicio3 = "000000";
	        } else {
	          servicio3 = props.usuario.accgservicios;
	        }
	      }
	
	      if (_val52 === "0") {
	        servicio4 = "000000";
	      } else {
	        if (operacion === 1) {
	          servicio4 = "000000";
	        } else {
	          servicio4 = props.usuario.accservnota;
	        }
	      }
	
	      if (_val54 === "0") {
	        servicio5 = "000000";
	      } else {
	        if (operacion === 1) {
	          servicio5 = "000000";
	        } else {
	          servicio5 = props.usuario.btnreportserv;
	        }
	      }
	    } else {
	      servicios = "00000";
	      servicio1 = "000000";
	      servicio2 = "000000";
	      servicio3 = "000000";
	      servicio4 = "000000";
	      servicio5 = "000000";
	    }
	
	    if (aplica.toString().substring(8, 9) === "1" && operacion !== 4 && modu9 === 1 || operacion === 1 && modu9 === 1) {
	      var _val55 = chkpostventventa.current.checked === true ? "1" : "0";
	      postventa2 = chksupervisor.current.checked === true ? true : false;
	
	      postventas = _val55;
	
	      if (_val55 === "0") {
	        postventa1 = "000000";
	      } else {
	        if (operacion === 1) {
	          postventa1 = "000000";
	        } else {
	          postventa1 = props.usuario.postventa;
	        }
	      }
	    } else {
	      postventas = "00000";
	      postventa1 = "000000";
	    }
	
	    var sigue = true;
	    var mensaje = "";
	    if (txtLogin.current.value.trim() === "") {
	      mensaje = "El Usuario no debe estar vacio";
	      sigue = false;
	      setTabIndex(0);
	      txtLogin.current.focus();
	    } else if (txtPassword.current.value.trim() === "" && operacion === 1) {
	      mensaje = "La Contraseña no debe estar vacia";
	      sigue = false;
	      setTabIndex(0);
	      txtPassword.current.focus();
	    } else if (txtConfirmPassword.current.value.trim() === "" && operacion === 1) {
	      mensaje = "La Confirmación de la Contraseña no debe estar vacia";
	      sigue = false;
	      setTabIndex(0);
	      txtConfirmPassword.current.focus();
	    } else if (txtPassword.current.value.trim() !== txtConfirmPassword.current.value.trim() && operacion === 1) {
	      mensaje = "Las Contraseñas no coinciden";
	      sigue = false;
	      setTabIndex(0);
	      txtConfirmPassword.current.focus();
	    } else if (txtCedula.current.value.trim() === "") {
	      mensaje = "La cedula no debe estar vacia";
	      sigue = false;
	      txtCedula.current.focus();
	    } else if (txtNombreUsuario.current.value.trim() === "") {
	      mensaje = "Los nombres no deben estar vacios";
	      sigue = false;
	      txtNombreUsuario.current.focus();
	    } else if (txtApellidoUsuario.current.value.trim() === "") {
	      mensaje = "Los Apellidos no deben estar vacio";
	      sigue = false;
	      txtApellidoUsuario.current.focus();
	    } else if (txtDireccionUsuario.current.value.trim() === "") {
	      mensaje = "La direccion del Usuario no debe estar vacia";
	      sigue = false;
	      txtDireccionUsuario.current.focus();
	    } else if (txtFechaNac.current.value.trim() === "") {
	      mensaje = "La fecha de nacimiento no debe estar vacia";
	      sigue = false;
	      txtFechaNac.current.focus();
	    }
	
	    if (sigue) {
	      var _Object$assign2;
	
	      var user = [];
	      var datoPer = [];
	
	      user.push(Object.assign({
	        idusuario: txtIdUsuario.current.value === "" ? "0" : txtIdUsuario.current.value,
	        login: txtLogin.current.value,
	        passwd: txtPassword.current.value,
	        persona: txtCedula.current.value,
	        status: cmbStatus.current.value
	      }, props.menu !== "sistema" && {
	        idagente: txtIdVendedor.current.value
	      }, props.menu !== "sistema" && { numcaja: cmbCaja.current.value }, (_Object$assign2 = {
	        idorganizacion: props.menu === "sistema" ? txtIdAgente.current.value : idorganizacion,
	        accaplicaciones: moduloss,
	        accconfiggene: modulosConfig.opcion1 + modulosConfig.opcion2 + modulosConfig.opcion3 + modulosConfig.opcion4 + modulosConfig.opcion5 + modulosConfig.opcion6 + modulosConfig.opcion7,
	        accopuser: usuarios,
	        accopperson: personas,
	        accopmoneda: moneda,
	        accinventario: minventario,
	        accventas: mventas,
	        acccompras: mcompras,
	        acccontabilidad: mcontabilidad,
	        accfinanzas: mfinanzas,
	        accbtnregalmacen: inv1,
	        accbtnubialmacen: inv2,
	        accbtnumedida: inv3,
	        accbtnmarca: inv4,
	        accbtnmodelo: inv5,
	        accbtntproducto: inv6,
	        accbtnproducto: inv7,
	        accbtnopinventario: inv8,
	        accbtnactxlsx: inv9,
	        accbtntvacios: inv10,
	        accbtnireports: inv11,
	        accbtnclientes: vent1,
	        accbtnvendedor: vent2,
	        accbtnpedidos: vent3,
	        accbtnnentrega: vent4,
	        accbtnndebito: vent5,
	        accbtnfacturas: vent6,
	        accbtnpresupuesto: vent7,
	        accbtnvreports: vent8,
	        accbtnproveedores: compr1,
	        accbtnordencompra: compr2,
	        accbtnfactucompra: compr3,
	        accbtncreports: compr4,
	        accbtncntcontable: contb1,
	        accbtnastcntable: contb2,
	        accbtnmvbancariost: contb3,
	        accbtnvinculacuenta: contb4,
	        accbtncntreports: contb5,
	        accbtnmvbancarios: finaz1
	      }, _defineProperty(_Object$assign2, "accbtnmvbancariost", finaz2), _defineProperty(_Object$assign2, "accbtnbancos", finaz3), _defineProperty(_Object$assign2, "accbtnbeneficiarios", finaz4), _defineProperty(_Object$assign2, "accbtnctsbancarias", finaz5), _defineProperty(_Object$assign2, "accbtncnciliabancaria", finaz6), _defineProperty(_Object$assign2, "accbtncntxcobrar", finaz7), _defineProperty(_Object$assign2, "accbtncntxpagar", finaz8), _defineProperty(_Object$assign2, "accbtntipretenciones", finaz9), _defineProperty(_Object$assign2, "accbtnfreports", finaz10), _defineProperty(_Object$assign2, "accopuserapp", usuariosapp), _defineProperty(_Object$assign2, "accvacios", vacios), _defineProperty(_Object$assign2, "btnopvacios", vacio1), _defineProperty(_Object$assign2, "btncontvacios", vacio2), _defineProperty(_Object$assign2, "btnclasvacios", vacio3), _defineProperty(_Object$assign2, "btnreportvacios", vacio4), _defineProperty(_Object$assign2, "accservicios", servicios), _defineProperty(_Object$assign2, "btnreportserv", servicio5), _defineProperty(_Object$assign2, "ordservicios", servicio1), _defineProperty(_Object$assign2, "accmoviles", servicio2), _defineProperty(_Object$assign2, "accgservicios", servicio3), _defineProperty(_Object$assign2, "accservnota", servicio4), _defineProperty(_Object$assign2, "accpostventas", postventas), _defineProperty(_Object$assign2, "postventa", postventa1), _defineProperty(_Object$assign2, "accinicio", permiinicio), _defineProperty(_Object$assign2, "supervisor", essupervisor === 1 ? true : false), _defineProperty(_Object$assign2, "passwsupervisor", postventa2 === true ? txtPasswordsuv.current.value : null), _defineProperty(_Object$assign2, "accbtnfacturaxnotas", vent9), _defineProperty(_Object$assign2, "tipoprecio", cmbTipoPrecioGlobal.current.value), _Object$assign2)));
	      datoPer.push({
	        apellidos: txtApellidoUsuario.current.value.trim(),
	        cedula: txtCedula.current.value,
	        correoe: txtEmailUsuario.current.value,
	        direccion: txtDireccionUsuario.current.value.trim(),
	        fnacimiento: txtFechaNac.current.value,
	        nacionalidad: cmbNacionalidad.current.value,
	        nombres: txtNombreUsuario.current.value.trim(),
	        sexo: cmbSexo.current.value,
	        tlf1: txtTlfUsuario.current.value,
	        tlf2: txtCelUsuario.current.value
	      });
	
	      setUsuario(user);
	      setPersona(datoPer);
	      var _body = {
	        operacionper: operacionPer,
	        usu: JSON.stringify(user),
	        perso: JSON.stringify(datoPer)
	      };
	      var _msg = "";
	      if (props.operacion === 1) {
	        _msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (props.operacion === 2) {
	        _msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (props.operacion === 3) {
	        _msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: _msg,
	        icono: "confirmacion"
	      });
	      setBody(_body);
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: mensaje,
	        icono: "informacion"
	      });
	    }
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	    blanquear();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    props.onHideAcepta();
	  };
	
	  var mostrarPassword = function mostrarPassword() {
	    return setMostrarClave(!mostrarClave);
	  };
	  var mostrarPassword1 = function mostrarPassword1() {
	    return setMostrarClave1(!mostrarClave1);
	  };
	  var mostrarPasswordsup = function mostrarPasswordsup() {
	    return setMostrarClavesup(!mostrarClavesup);
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "xl",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        setOperacion(props.operacion);
	        setDeshabilitado(props.deshabilitado);
	        setTabIndex(0);
	        setTabIndex1(0);
	
	        if (props.operacion !== 1) {
	          setOperacionPer(0);
	          if (props.usuario.idagente !== null && props.usuario.idagente !== "") {
	            seleccionarVendedor(props.usuario.idagente, 1);
	          }
	
	          if (props.usuario.accaplicaciones !== "") {
	            setAplica(props.usuario.accaplicaciones);
	            var essuper = props.usuario && props.usuario.supervisor === true ? 1 : 0;
	            setEssupervisor(essuper);
	            if (props.usuario.accaplicaciones.toString().substring(0, 1) === "1") {
	              if (props.usuario && props.usuario.accinventario !== "") {
	                setModuloinventario({
	                  inve1: props.usuario.accinventario.toString().substring(0, 1),
	                  inve2: props.usuario.accinventario.toString().substring(1, 2),
	                  inve3: props.usuario.accinventario.toString().substring(2, 3),
	                  inve4: props.usuario.accinventario.toString().substring(3, 4),
	                  inve5: props.usuario.accinventario.toString().substring(4, 5),
	                  inve6: props.usuario.accinventario.toString().substring(5, 6),
	                  inve7: props.usuario.accinventario.toString().substring(6, 7),
	                  inve8: props.usuario.accinventario.toString().substring(7, 8),
	                  inve9: props.usuario.accinventario.toString().substring(8, 9),
	                  inve10: props.usuario.accinventario.toString().substring(9, 10),
	                  inve11: props.usuario.accinventario.toString().substring(10, 11),
	                  inve12: props.usuario.accinventario.toString().substring(11, 12)
	                });
	              } else {}
	
	              moduinventariosi.current.checked = true;
	              moduinventariono.current.checked = false;
	              setModu1(1);
	            } else {
	              moduinventariono.current.checked = true;
	              moduinventariosi.current.checked = false;
	              setModu1(0);
	            }
	
	            if (props.usuario.accaplicaciones.toString().substring(1, 2) === "1") {
	              if (props.usuario && props.usuario.accventas !== "") {
	                setModuloventas({
	                  vents1: props.usuario.accventas.toString().substring(0, 1),
	                  vents2: props.usuario.accventas.toString().substring(1, 2),
	                  vents3: props.usuario.accventas.toString().substring(2, 3),
	                  vents4: props.usuario.accventas.toString().substring(3, 4),
	                  vents5: props.usuario.accventas.toString().substring(4, 5),
	                  vents6: props.usuario.accventas.toString().substring(5, 6),
	                  vents7: props.usuario.accventas.toString().substring(6, 7),
	                  vents8: props.usuario.accventas.toString().substring(7, 8),
	                  vents9: props.usuario.accventas.toString().substring(8, 9),
	                  vents10: props.usuario.accventas.toString().substring(9, 10)
	                });
	              }
	
	              moduventassi.current.checked = true;
	              moduventasno.current.checked = false;
	              setModu2(1);
	            } else {
	              moduventasno.current.checked = true;
	              moduventassi.current.checked = false;
	              setModu2(0);
	            }
	
	            if (props.usuario.accaplicaciones.toString().substring(2, 3) === "1") {
	              if (props.usuario && props.usuario.acccompras !== "") {
	                setModulocompras({
	                  mcompras1: props.usuario.acccompras.toString().substring(0, 1),
	                  mcompras2: props.usuario.acccompras.toString().substring(1, 2),
	                  mcompras3: props.usuario.acccompras.toString().substring(2, 3),
	                  mcompras4: props.usuario.acccompras.toString().substring(3, 4),
	                  mcompras5: props.usuario.acccompras.toString().substring(4, 5)
	                });
	              }
	
	              moducomprassi.current.checked = true;
	              moducomprasno.current.checked = false;
	              setModu3(1);
	            } else {
	              moducomprasno.current.checked = true;
	              moducomprassi.current.checked = false;
	              setModu3(0);
	            }
	
	            if (props.usuario.accaplicaciones.toString().substring(3, 4) === "1") {
	              if (props.usuario && props.usuario.acccontabilidad !== "") {
	                setModulocontabilidad({
	                  mcontab1: props.usuario.acccontabilidad.toString().substring(0, 1),
	                  mcontab2: props.usuario.acccontabilidad.toString().substring(1, 2),
	                  mcontab3: props.usuario.acccontabilidad.toString().substring(2, 3),
	                  mcontab4: props.usuario.acccontabilidad.toString().substring(3, 4),
	                  mcontab5: props.usuario.acccontabilidad.toString().substring(4, 5),
	                  mcontab6: props.usuario.acccontabilidad.toString().substring(5, 6)
	                });
	              }
	
	              moducontabsi.current.checked = true;
	              moducontabno.current.checked = false;
	              setModu4(1);
	            } else {
	              moducontabno.current.checked = true;
	              moducontabsi.current.checked = false;
	              setModu4(0);
	            }
	
	            if (props.usuario.accaplicaciones.toString().substring(4, 5) === "1") {
	              if (props.usuario && props.usuario.accfinanzas !== "") {
	                setModulofinanzas({
	                  mfinanzas1: props.usuario.accfinanzas.toString().substring(0, 1),
	                  mfinanzas2: props.usuario.accfinanzas.toString().substring(1, 2),
	                  mfinanzas3: props.usuario.accfinanzas.toString().substring(2, 3),
	                  mfinanzas4: props.usuario.accfinanzas.toString().substring(3, 4),
	                  mfinanzas5: props.usuario.accfinanzas.toString().substring(4, 5),
	                  mfinanzas6: props.usuario.accfinanzas.toString().substring(5, 6),
	                  mfinanzas7: props.usuario.accfinanzas.toString().substring(6, 7),
	                  mfinanzas8: props.usuario.accfinanzas.toString().substring(7, 8),
	                  mfinanzas9: props.usuario.accfinanzas.toString().substring(8, 9),
	                  mfinanzas10: props.usuario.accfinanzas.toString().substring(9, 10),
	                  mfinanzas11: props.usuario.accfinanzas.toString().substring(10, 11),
	                  mfinanzas12: props.usuario.accfinanzas.toString().substring(11, 12)
	                });
	              }
	
	              modufinanzassi.current.checked = true;
	              modufinanzasno.current.checked = false;
	              setModu5(1);
	            } else {
	              modufinanzasno.current.checked = true;
	              modufinanzassi.current.checked = false;
	              setModu5(0);
	            }
	
	            if (props.usuario.accaplicaciones.toString().substring(5, 6) === "1") {
	              moduconfigsi.current.checked = true;
	              moduconfigno.current.checked = false;
	              setModu6(1);
	            } else {
	              moduconfigno.current.checked = true;
	              moduconfigsi.current.checked = false;
	              setModu6(0);
	            }
	
	            if (props.usuario.accaplicaciones.toString().substring(6, 7) === "1") {
	              if (props.usuario && props.usuario.accvacios !== "") {
	
	                var data = [];
	                data.push({
	                  vacios1: props.usuario.accvacios.toString().substring(0, 1),
	                  vacios2: props.usuario.accvacios.toString().substring(1, 2),
	                  vacios3: props.usuario.accvacios.toString().substring(2, 3),
	                  vacios4: props.usuario.accvacios.toString().substring(3, 4),
	                  vacios5: props.usuario.accvacios.toString().substring(4, 5)
	                });
	
	                setModulovacios({
	                  vacios1: data[0].vacios1,
	                  vacios2: data[0].vacios2,
	                  vacios3: data[0].vacios3,
	                  vacios4: data[0].vacios4,
	                  vacios5: data[0].vacios5
	                });
	              }
	
	              moduvaciossi.current.checked = true;
	              moduvaciosno.current.checked = false;
	              setModu7(1);
	            } else {
	              moduvaciosno.current.checked = true;
	              moduvaciossi.current.checked = false;
	              setModu7(0);
	            }
	
	            if (props.usuario.accaplicaciones.toString().substring(7, 8) === "1") {
	              if (props.usuario && props.usuario.accservicios !== "") {
	
	                var _data = [];
	                _data.push({
	                  servicios1: props.usuario.accservicios.toString().substring(0, 1),
	                  servicios2: props.usuario.accservicios.toString().substring(1, 2),
	                  servicios3: props.usuario.accservicios.toString().substring(2, 3),
	                  servicios4: props.usuario.accservicios.toString().substring(3, 4),
	                  servicios5: props.usuario.accservicios.toString().substring(4, 5),
	                  servicios6: props.usuario.accservicios.toString().substring(5, 6)
	                });
	
	                setModuloservicios({
	                  servicio1: _data[0].servicios1,
	                  servicio2: _data[0].servicios2,
	                  servicio3: _data[0].servicios3,
	                  servicio4: _data[0].servicios4,
	                  servicio5: _data[0].servicios5,
	                  servicio6: _data[0].servicios6
	                });
	              }
	
	              moduserviciossi.current.checked = true;
	              moduserviciosno.current.checked = false;
	              setModu8(1);
	            } else {
	              moduserviciosno.current.checked = true;
	              moduserviciossi.current.checked = false;
	              setModu8(0);
	            }
	
	            if (props.usuario.accaplicaciones.toString().substring(8, 9) === "1") {
	
	              if (props.usuario && props.usuario.accpostventas !== "") {
	
	                var _data2 = [];
	                _data2.push({
	                  postventa1: props.usuario.accpostventas.toString().substring(0, 1),
	                  postventa2: props.usuario.supervisor === true ? "1" : "0",
	                  postventa3: props.usuario.accpostventas.toString().substring(2, 3),
	                  postventa4: props.usuario.accpostventas.toString().substring(3, 4),
	                  postventa5: props.usuario.accpostventas.toString().substring(4, 5),
	                  postventa6: props.usuario.accpostventas.toString().substring(5, 6)
	                });
	                setModulopostventa({
	                  postventa1: _data2[0].postventa1,
	                  postventa2: _data2[0].postventa2,
	                  postventa3: _data2[0].postventa3,
	                  postventa4: _data2[0].postventa4,
	                  postventa5: _data2[0].postventa5,
	                  postventa6: _data2[0].postventa6
	                });
	              }
	              modupostventasi.current.checked = true;
	              modupostventano.current.checked = false;
	              setModu9(1);
	            } else {
	              modupostventano.current.checked = true;
	              modupostventasi.current.checked = false;
	              setModu9(0);
	            }
	
	            if (props.usuario && props.usuario.supervisor) {
	              if (essuper !== 1) {
	                chksupervisor.current.checked = false;
	              } else {
	                chksupervisor.current.checked = true;
	              }
	            }
	          } else {
	            moduinventariosi.current.checked = false;
	            moduinventariono.current.checked = false;
	            moduconfigno.current.checked = false;
	            moduconfigsi.current.checked = false;
	            modufinanzasno.current.checked = false;
	            modufinanzassi.current.checked = false;
	            moducontabno.current.checked = false;
	            moducontabsi.current.checked = false;
	            moducomprasno.current.checked = false;
	            moducomprassi.current.checked = false;
	            moduventasno.current.checked = false;
	            moduventassi.current.checked = false;
	            moduvaciosno.current.checked = false;
	            moduvaciossi.current.checked = false;
	            moduserviciosno.current.checked = false;
	            moduserviciossi.current.checked = false;
	            modupostventano.current.checked = false;
	            modupostventasi.current.checked = false;
	          }
	
	          setModulosini({
	            moduini: props.usuario.accinicio.toString().substring(0, 1)
	          });
	
	          setModulosConfig({
	            opcion1: props.usuario.accconfiggene.toString().substring(0, 1),
	            opcion2: props.usuario.accconfiggene.toString().substring(1, 2),
	            opcion3: props.usuario.accconfiggene.toString().substring(2, 3),
	            opcion4: props.usuario.accconfiggene.toString().substring(3, 4),
	            opcion5: props.usuario.accconfiggene.toString().substring(4, 5),
	            opcion6: props.usuario.accconfiggene.toString().substring(5, 6),
	            opcion7: props.usuario.accconfiggene.toString().substring(6, 7)
	          });
	
	          setOperacionesMod({
	            personas1: props.usuario.accopperson.toString().substring(0, 1),
	            personas2: props.usuario.accopperson.toString().substring(1, 2),
	            personas3: props.usuario.accopperson.toString().substring(2, 3),
	            personas4: props.usuario.accopperson.toString().substring(3, 4),
	
	            usuarios1: props.usuario.accopuser.toString().substring(0, 1),
	            usuarios2: props.usuario.accopuser.toString().substring(1, 2),
	            usuarios3: props.usuario.accopuser.toString().substring(2, 3),
	            usuarios4: props.usuario.accopuser.toString().substring(3, 4),
	
	            usuarioapp1: props.usuario.accopuserapp.toString().substring(0, 1),
	            usuarioapp2: props.usuario.accopuserapp.toString().substring(1, 2),
	            usuarioapp3: props.usuario.accopuserapp.toString().substring(2, 3),
	            usuarioapp4: props.usuario.accopuserapp.toString().substring(3, 4),
	
	            unidadcontable1: props.usuario.accopmoneda.toString().substring(0, 1),
	            unidadcontable2: props.usuario.accopmoneda.toString().substring(1, 2),
	            unidadcontable3: props.usuario.accopmoneda.toString().substring(2, 3),
	            unidadcontable4: props.usuario.accopmoneda.toString().substring(3, 4)
	          });
	        } else {
	          setModu1(0);
	          setModu2(0);
	          setModu3(0);
	          setModu4(0);
	          setModu5(0);
	          setModu6(0);
	          setModu7(0);
	          setModu8(0);
	          setModu9(0);
	          setModu10(0);
	          setModulosConfig({
	            opcion1: "0",
	            opcion2: "0",
	            opcion3: "0",
	            opcion4: "0",
	            opcion5: "0",
	            opcion6: "0",
	            opcion7: "0"
	          });
	          setAplica("0000000000");
	          setModuloinventario({
	            inve1: "0",
	            inve2: "0",
	            inve3: "0",
	            inve4: "0",
	            inve5: "0",
	            inve6: "0",
	            inve7: "0",
	            inve8: "0",
	            inve9: "0",
	            inve10: "0",
	            inve11: "0",
	            inve12: "0"
	          });
	          setModuloventas({
	            vents1: "0",
	            vents2: "0",
	            vents3: "0",
	            vents4: "0",
	            vents5: "0",
	            vents6: "0",
	            vents7: "0",
	            vents8: "0",
	            vents9: "0",
	            vents10: "0"
	          });
	          setModulocompras({
	            mcompras1: "0",
	            mcompras2: "0",
	            mcompras3: "0",
	            mcompras4: "0",
	            mcompras5: "0"
	          });
	          setModulovacios({
	            vacios1: "0",
	            vacios2: "0",
	            vacios3: "0",
	            vacios4: "0",
	            vacios5: "0"
	          });
	          setModuloservicios({
	            servicio1: "0",
	            servicio2: "0",
	            servicio3: "0",
	            servicio4: "0",
	            servicio5: "0",
	            servicio6: "0"
	          });
	          setModulopostventa({
	            postventa1: "0",
	            postventa2: "0",
	            postventa3: "0",
	            postventa4: "0",
	            postventa5: "0",
	            postventa6: "0"
	          });
	          setModulocontabilidad({
	            mcontab1: "0",
	            mcontab2: "0",
	            mcontab3: "0",
	            mcontab4: "0",
	            mcontab5: "0",
	            mcontab6: "0"
	          });
	          setModulofinanzas({
	            mfinanzas1: "0",
	            mfinanzas2: "0",
	            mfinanzas3: "0",
	            mfinanzas4: "0",
	            mfinanzas5: "0",
	            mfinanzas6: "0",
	            mfinanzas7: "0",
	            mfinanzas8: "0",
	            mfinanzas9: "0",
	            mfinanzas10: "0",
	            mfinanzas11: "0",
	            mfinanzas12: "0"
	          });
	          setModulosini({
	            moduini: "0"
	          });
	          moduinventariosi.current.checked = false;
	          moduinventariono.current.checked = true;
	          moduconfigno.current.checked = true;
	          moduconfigsi.current.checked = false;
	          modufinanzasno.current.checked = true;
	          modufinanzassi.current.checked = false;
	          moducontabno.current.checked = true;
	          moducontabsi.current.checked = false;
	          moducomprasno.current.checked = true;
	          moducomprassi.current.checked = false;
	          moduventasno.current.checked = true;
	          moduventassi.current.checked = false;
	          moduvaciosno.current.checked = true;
	          moduvaciossi.current.checked = false;
	          modupostventasi.current.checked = false;
	          modupostventano.current.checked = true;
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          operacion === 1 ? "Registrar Usuario" : operacion === 2 ? "Modificar Usurario" : operacion === 3 ? "Eliminar Usuario" : "Consultar Usuario"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { padding: 0 } },
	      _react2.default.createElement(_modalCambiarClave.CambiarClave, {
	        usuario: props.usuario && props.usuario.login.trim(),
	        show: mostrar2,
	        onHide: function onHide() {
	          setMostrar2(false);
	        }
	      }),
	      _react2.default.createElement(_catalogoCliente2.default, {
	        show: catalogoCliente,
	        nomid: "vendedor",
	        onHideCancelar: function onHideCancelar() {
	          return setCatalogoCliente(false);
	        },
	        onHideAceptaCatalogo: onCatalogoCliente
	      }),
	      _react2.default.createElement(_catalogoPersona2.default, {
	        titulo: titulo,
	        mensaje: msg,
	        show: mostrar3,
	        onHideCancelaCatPer: handleCloseCatalogoPer,
	        onHideAceptaCatPer: handleAceptaCatalogoPer
	      }),
	      _react2.default.createElement(_catalogoOrganizacion2.default, {
	        show: mostrar,
	        onHideCancelar: function onHideCancelar() {
	          setMostrar(false);
	        },
	        onHideAceptaCatalogo: handleAceptaCatalogoOrg
	      }),
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({
	            mostrar: false,
	            titulo: "",
	            texto: "",
	            icono: ""
	          });
	        }
	      }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, {
	        mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	        },
	        onHideSi: handleCloseSi
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "" },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "ul",
	            { className: "nav nav-tabs mb-3", id: "ex-with-icons", role: "tablist" },
	            _react2.default.createElement(
	              "li",
	              { className: "nav-item", role: "presentation" },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "nav-link active ",
	                  style: { backgroundColor: "#25d366" },
	                  id: "ex-with-icons-tab-1",
	                  "data-mdb-toggle": "tab",
	                  href: "#tab-1",
	                  role: "tab",
	                  "aria-controls": "tab-1",
	                  "aria-selected": "true"
	                },
	                _react2.default.createElement("i", { className: "fas fa-user-edit fa-fw me-2" }),
	                "Usuario"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { className: "nav-item", role: "presentation" },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "nav-link",
	                  id: "ex-with-icons-tab-2",
	                  style: { backgroundColor: "#55acee" },
	                  "data-mdb-toggle": "tab",
	                  href: "#tab-2",
	                  role: "tab",
	                  "aria-controls": "tab-2",
	                  "aria-selected": "false"
	                },
	                _react2.default.createElement("i", { className: "fas fa-vote-yea fa-fw me-2" }),
	                "Permisos Aplicaciones"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { className: "nav-item", role: "presentation" },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "nav-link",
	                  id: "ex-with-icons-tab-3",
	                  style: { backgroundColor: "rgb(238, 85, 85)" },
	                  "data-mdb-toggle": "tab",
	                  href: "#tab-3",
	                  role: "tab",
	                  "aria-controls": "tab-3",
	                  "aria-selected": "false"
	                },
	                _react2.default.createElement("i", { className: "fas fa-vote-yea fa-fw me-2" }),
	                "Permisos Config. General"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "tab-content", id: "ex-with-icons-content" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "tab-pane fade show active",
	                id: "tab-1",
	                role: "tabpanel",
	                "aria-labelledby": "ex-with-icons-tab-1"
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "container-fluid row m-0 h-100 py-2 px-4  mx-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group py-1 input-group-sm col-sm-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    _react2.default.createElement("i", { className: "far fa-lg px-1 fa-id-card" }),
	                    "Codigo:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtIdUsuario,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: props.usuario ? props.usuario.idusuario : "",
	                    id: "inputCodigo",
	                    onKeyUp: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group py-1 input-group-sm col-sm-8" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-file-signature" }),
	                    "Nom. Usuario:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autocomplete: "off",
	                    disabled: operacion === 2 ? true : deshabilitado,
	                    ref: txtLogin,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: props.usuario ? props.usuario.login : "",
	                    id: "inputLogin",
	                    onKeyUp: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group py-1 input-group-sm col-sm-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    " ",
	                    "Estatus"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      disabled: deshabilitado,
	                      ref: cmbStatus,
	                      className: "form-select",
	                      "aria-label": "Default select example",
	                      defaultValue: props.usuario ? props.usuario.status : ""
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "Activo"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "2" },
	                      "Inactivo"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group py-1 input-group-sm col-sm-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-unlock-alt" }),
	                    "Contrase\xF1a:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: mostrarClave ? "text" : "password",
	                    disabled: operacion === 2 ? true : deshabilitado,
	                    ref: txtPassword,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputPassword",
	                    onKeyUp: handleInputChange
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      style: { textAlign: "center", color: "white" },
	                      disabled: operacion === 2 ? true : deshabilitado,
	                      onClick: mostrarPassword,
	                      className: "btn btn-sm btn-info"
	                    },
	                    _react2.default.createElement("i", {
	                      disabled: deshabilitado,
	                      className: "fa fa-eye-slash"
	                    }),
	                    " "
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group py-1 input-group-sm col-sm-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-unlock-alt" }),
	                    "Confir. Contr.:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: mostrarClave1 ? "text" : "password",
	                    disabled: operacion === 2 ? true : deshabilitado,
	                    ref: txtConfirmPassword,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputConfirmPassword",
	                    onKeyUp: handleInputChange
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      style: { textAlign: "center", color: "white" },
	                      disabled: operacion === 2 ? true : deshabilitado,
	                      onClick: mostrarPassword1,
	                      className: "btn btn-sm btn-info"
	                    },
	                    _react2.default.createElement("i", {
	                      disabled: deshabilitado,
	                      className: "fa fa-eye-slash"
	                    }),
	                    " "
	                  )
	                ),
	                _react2.default.createElement("div", { className: "col-md-12 py-1" }),
	                props.menu === "sistema" && _react2.default.createElement(
	                  "fieldset",
	                  { className: "row border-azul rounded mx-auto" },
	                  _react2.default.createElement(
	                    "legend",
	                    { className: "float-none m-0 w-auto" },
	                    "Organizaci\xF3n"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group py-1 input-group-sm col-sm-4" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      _react2.default.createElement("i", { className: "far fa-lg px-1 fa-id-card" }),
	                      "C\xF3digo:"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      disabled: deshabilitado,
	                      ref: txtIdAgente,
	                      className: "form-control",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm",
	                      id: "inputIdAgente",
	                      defaultValue: props.usuario ? props.usuario.idorganizacion : "",
	                      onKeyUp: validarAgente,
	                      onBlur: validarAgente
	                    }),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: deshabilitado,
	                        onClick: function onClick() {
	                          setMostrar(true);
	                        },
	                        className: "btn btn-sm  btn-success"
	                      },
	                      _react2.default.createElement("i", {
	                        disabled: deshabilitado,
	                        className: "fa fa-search"
	                      }),
	                      " "
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group py-1 input-group-sm col-sm-8" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-file-signature" }),
	                      "Nombres:"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      disabled: true,
	                      ref: txtNombreAgente,
	                      className: "form-control",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm",
	                      id: "inputNomUsuario",
	                      defaultValue: props.usuario ? props.usuario.nombreorg.trim() : ""
	                    })
	                  )
	                ),
	                props.menu !== "sistema" && _react2.default.createElement(
	                  "fieldset",
	                  { className: "row border-azul rounded mx-auto" },
	                  _react2.default.createElement(
	                    "legend",
	                    { className: "float-none m-0 w-auto" },
	                    "Vendedor"
	                  ),
	                  _react2.default.createElement("input", {
	                    ref: txtIdVendedor,
	                    type: "hidden",
	                    name: "idvendedor"
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "mb-1 col-pd-260 px-2" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        "Cedula/Rif"
	                      ),
	                      _react2.default.createElement(
	                        "select",
	                        {
	                          ref: cmbRif,
	                          name: "cmbrif",
	                          disabled: deshabilitado,
	                          className: "form-select form-select-sm text-center col-3",
	                          "aria-label": ".form-select-sm example",
	                          onChange: onChange
	                        },
	                        _react2.default.createElement(
	                          "option",
	                          { value: "" },
	                          "--"
	                        ),
	                        cmbCedula && cmbCedula.map(function (item, index) {
	                          return _react2.default.createElement(
	                            "option",
	                            { key: index, value: item.value },
	                            " ",
	                            item.value,
	                            " "
	                          );
	                        })
	                      ),
	                      _react2.default.createElement("input", {
	                        ref: txtRif,
	                        autoComplete: "off",
	                        disabled: deshabilitado,
	                        maxLength: 9,
	                        type: "text",
	                        className: "form-control",
	                        name: "cedula",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        onKeyUp: validarCliente,
	                        onBlur: validarCliente,
	                        onChange: onChange
	                      }),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          disabled: deshabilitado,
	                          onClick: function onClick() {
	                            setCatalogoCliente(true);
	                          },
	                          className: "btn btn-success"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-search" })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group pb-1 input-group-sm col-pd-130" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "Caja:"
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        disabled: deshabilitado,
	                        ref: cmbCaja,
	                        className: "form-select",
	                        "aria-label": "numero de caja",
	                        defaultValue: props.usuario ? props.usuario.numcaja : ""
	                      },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "" },
	                        "--"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "01" },
	                        "01"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "02" },
	                        "02"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "03" },
	                        "03"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "04" },
	                        "04"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "05" },
	                        "05"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "06" },
	                        "06"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "07" },
	                        "07"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "08" },
	                        "08"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "09" },
	                        "09"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "10" },
	                        "10"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2 col-md-12" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "Nombre/Raz\xF3n Social"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      autoComplete: "off",
	                      ref: txtRazon,
	                      disabled: true,
	                      name: "nombres",
	                      className: "form-control text-uppercase",
	                      onChange: onChange,
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                ),
	                _react2.default.createElement("div", { className: "col-md-12 py-1" }),
	                _react2.default.createElement(
	                  "fieldset",
	                  { className: "row border-azul rounded mx-auto" },
	                  _react2.default.createElement(
	                    "legend",
	                    { className: "float-none m-0 w-auto" },
	                    "Datos Personales del Usuario"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "container col-md-12 row m-0 justify-content-between" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group py-1 input-group-sm px-1 col-pd-170" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        _react2.default.createElement("i", { className: "far fa-lg px-1 fa-id-card" }),
	                        "Cedula:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        autoComplete: "off",
	                        maxLength: 8,
	                        disabled: deshabilitado,
	                        ref: txtCedula,
	                        className: "form-control",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        id: "inputCedula",
	                        defaultValue: props.datospersonales ? props.datospersonales.cedula : "",
	                        onKeyUp: validarPersona,
	                        onBlur: validarPersona
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        style: { width: 210 },
	                        className: "input-group py-1 input-group-sm px-2"
	                      },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          style: { width: 110 },
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-map-marked-alt" }),
	                        "Nacionalidad:"
	                      ),
	                      _react2.default.createElement(
	                        "select",
	                        {
	                          style: { minWidth: 70, maxWidth: 70 },
	                          disabled: !habilitadoNU,
	                          ref: cmbNacionalidad,
	                          defaultValue: props.datospersonales ? props.datospersonales.nacionalidad : "",
	                          className: "form-select",
	                          "aria-label": "Default select example col-md-"
	                        },
	                        _react2.default.createElement(
	                          "option",
	                          { key: "0", value: "V" },
	                          "V"
	                        ),
	                        _react2.default.createElement(
	                          "option",
	                          { key: "1", value: "E" },
	                          "E"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        style: { width: 160 },
	                        className: "input-group py-1 input-group-sm px-1"
	                      },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          style: { width: 80 },
	                          className: "input-group-text ml-2",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        "Sexo:"
	                      ),
	                      _react2.default.createElement(
	                        "select",
	                        {
	                          style: { width: 50 },
	                          disabled: !habilitadoNU,
	                          ref: cmbSexo,
	                          defaultValue: props.datospersonales ? props.datospersonales.sexo : "",
	                          className: "form-select",
	                          "aria-label": "Default select example"
	                        },
	                        _react2.default.createElement(
	                          "option",
	                          { key: "0", value: "M" },
	                          "M"
	                        ),
	                        _react2.default.createElement(
	                          "option",
	                          { key: "1", value: "F" },
	                          "F"
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "container col-md-12 row m-0 justify-content-between" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group py-1 input-group-sm px-1 col-sm-6" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-file-signature" }),
	                        "Nombres:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        autoComplete: "off",
	                        disabled: !habilitadoNU,
	                        ref: txtNombreUsuario,
	                        className: "form-control text-uppercase",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        id: "inputNomUsuario",
	                        defaultValue: props.datospersonales ? props.datospersonales.nombres.trim() : "",
	                        onKeyUp: handleInputChange,
	                        onBlur: handleInputChange
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group py-1 input-group-sm px-1 col-sm-6" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-file-signature" }),
	                        "apellidos:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        autoComplete: "off",
	                        disabled: !habilitadoNU,
	                        ref: txtApellidoUsuario,
	                        className: "form-control text-uppercase",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        id: "inputApeUsuario",
	                        defaultValue: props.datospersonales ? props.datospersonales.apellidos.trim() : "",
	                        onKeyUp: handleInputChange,
	                        onBlur: handleInputChange
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group py-1 input-group-sm col-sm-12 px-1" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-file-signature" }),
	                        "Direccion:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        autoComplete: "off",
	                        disabled: !habilitadoNU,
	                        ref: txtDireccionUsuario,
	                        className: "form-control text-uppercase",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        id: "inputApeUsuario",
	                        defaultValue: props.datospersonales ? props.datospersonales.direccion.trim() : "",
	                        onKeyUp: handleInputChange,
	                        onBlur: handleInputChange
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "container col-md-12 row m-0" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group py-1 input-group-sm px-1 col-pd-250" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        _react2.default.createElement("i", { className: "far fa-lg px-1 fa-calendar-alt" }),
	                        "Fecha Nacimiento:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "date",
	                        disabled: !habilitadoNU,
	                        ref: txtFechaNac,
	                        className: "form-control px-0",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        id: "inputFechaNac",
	                        max: (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD"),
	                        defaultValue: props.datospersonales ? (0, _moment2.default)(props.datospersonales.fnacimiento).format("YYYY-MM-DD") : "",
	                        onKeyUp: handleInputChange
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group py-1 input-group-sm col-pd-210" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-phone" }),
	                        "Telefono:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        autoComplete: "off",
	                        disabled: !habilitadoNU,
	                        ref: txtTlfUsuario,
	                        className: "form-control",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        id: "inputTlfUsuario",
	                        placeholder: "0000-0000000",
	                        defaultValue: props.datospersonales ? props.datospersonales.tlf1 !== null ? props.datospersonales.tlf1.trim() : "" : "",
	                        onKeyUp: handleInputChange,
	                        onBlur: handleInputChange
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        style: { width: 180 },
	                        className: "input-group py-1 input-group-sm px-1"
	                      },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          style: { width: 70 },
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-mobile-alt" }),
	                        "Celular:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        autoComplete: "off",
	                        style: { width: 80 },
	                        disabled: !habilitadoNU,
	                        ref: txtCelUsuario,
	                        className: "form-control",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        id: "inputCelUsuario",
	                        placeholder: "0000-0000000",
	                        defaultValue: props.datospersonales ? props.datospersonales.tlf2 !== null ? props.datospersonales.tlf2.trim() : "" : "",
	                        onKeyUp: handleInputChange,
	                        onBlur: handleInputChange
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group py-1 input-group-sm col-pd-410 px-1 ml-auto" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        " ",
	                        _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-at" }),
	                        "E-mail:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        autoComplete: "off",
	                        disabled: !habilitadoNU,
	                        ref: txtEmailUsuario,
	                        className: "form-control text-uppercase",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        id: "inputEmailUsuario",
	                        defaultValue: props.datospersonales ? props.datospersonales.correoe !== null ? props.datospersonales.correoe.trim() : "" : "",
	                        onKeyUp: handleInputChange,
	                        onBlur: handleInputChange
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "tab-pane fade",
	                id: "tab-2",
	                role: "tabpanel",
	                "aria-labelledby": "ex-with-icons-tab-2"
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "container-fluid row  justify-content-between h-100 py-2 px-4  mx-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group col-sm-12 w-100" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-5" },
	                      "Modulo Inventario"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2 mb-1" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permodtimbre",
	                        disabled: deshabilitado,
	                        id: "inlineRadio1",
	                        value: true,
	                        ref: moduinventariosi,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadio1" },
	                        "Disponible"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2 mb-1" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permodtimbre",
	                        disabled: deshabilitado,
	                        id: "inlineRadio2",
	                        value: false,
	                        ref: moduinventariono,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadio2" },
	                        "No Disponible"
	                      )
	                    ),
	                    modu1 === 1 ? _react2.default.createElement(
	                      "table",
	                      { className: "col-12 table table-sm table-bordered m-0 px-0" },
	                      _react2.default.createElement(
	                        "thead",
	                        { className: "col-12 m-0 px-0" },
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                type: "checkbox",
	                                disabled: deshabilitado,
	                                ref: chkitodos,
	                                defaultChecked: moduloinventario.inve1 === "1" && moduloinventario.inve2 === "1" && moduloinventario.inve3 === "1" && moduloinventario.inve4 === "1" && moduloinventario.inve5 === "1" && moduloinventario.inve6 === "1" && moduloinventario.inve7 === "1" && moduloinventario.inve8 === "1" && moduloinventario.inve9 === "1" && moduloinventario.inve10 === "1" && moduloinventario.inve11 === "1" && moduloinventario.inve12 === "1" ? true : false,
	                                onChange: checkTodo,
	                                name: "todosinventario",
	                                id: "inlineCheckbox"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineCheckbox"
	                                },
	                                "Todos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                type: "checkbox",
	                                disabled: deshabilitado,
	                                ref: chkralmacen,
	                                defaultChecked: moduloinventario.inve1 === "1" ? true : false,
	                                onChange: checkBlank,
	                                id: "inlineCheckbox1"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineCheckbox1"
	                                },
	                                "Reg. Almacen"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                type: "checkbox",
	                                disabled: deshabilitado,
	                                ref: chkubialmacen,
	                                defaultChecked: moduloinventario.inve2 === "1" ? true : false,
	                                onChange: checkBlank,
	                                id: "inlineCheckbox2"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineCheckbox2"
	                                },
	                                "Ubi. Almacen"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                type: "checkbox",
	                                disabled: deshabilitado,
	                                ref: chkudmedida,
	                                defaultChecked: moduloinventario.inve3 === "1" ? true : false,
	                                onChange: checkBlank,
	                                id: "inlineCheckbox3"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineCheckbox3"
	                                },
	                                "Unda. Medida"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                type: "checkbox",
	                                disabled: deshabilitado,
	                                ref: chkmarca,
	                                defaultChecked: moduloinventario.inve4 === "1" ? true : false,
	                                onChange: checkBlank,
	                                id: "inlineCheckbox4"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineCheckbox4"
	                                },
	                                "Marca"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                type: "checkbox",
	                                disabled: deshabilitado,
	                                ref: chkmodelo,
	                                defaultChecked: moduloinventario.inve5 === "1" ? true : false,
	                                onChange: checkBlank,
	                                id: "inlineCheckbox5"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineCheckbox5"
	                                },
	                                "Modelo"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                type: "checkbox",
	                                disabled: deshabilitado,
	                                ref: chktpproduct,
	                                defaultChecked: moduloinventario.inve6 === "1" ? true : false,
	                                onChange: checkBlank,
	                                id: "inlineCheckbox6"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineCheckbox6"
	                                },
	                                "Tipo. Producto"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                type: "checkbox",
	                                disabled: deshabilitado,
	                                ref: chkproducto,
	                                defaultChecked: moduloinventario.inve7 === "1" ? true : false,
	                                onChange: checkBlank,
	                                id: "inlineCheckbox7"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineCheckbox7"
	                                },
	                                "Productos"
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                type: "checkbox",
	                                disabled: deshabilitado,
	                                ref: chkopinventario,
	                                defaultChecked: moduloinventario.inve8 === "1" ? true : false,
	                                onChange: checkBlank,
	                                id: "inlineCheckbox8"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineCheckbox8"
	                                },
	                                "Op. Inventario"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                type: "checkbox",
	                                disabled: deshabilitado,
	                                ref: chkactxlsx,
	                                defaultChecked: moduloinventario.inve9 === "1" ? true : false,
	                                onChange: checkBlank,
	                                id: "inlineCheckbox9"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineCheckbox9"
	                                },
	                                "Actu. XLSX"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                type: "checkbox",
	                                disabled: deshabilitado,
	                                ref: chkgvacios,
	                                defaultChecked: moduloinventario.inve10 === "1" ? true : false,
	                                onChange: checkBlank,
	                                id: "inlineCheckbox10"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineCheckbox10"
	                                },
	                                "Gest. Vacios"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                type: "checkbox",
	                                disabled: deshabilitado,
	                                ref: chkiconfigura,
	                                defaultChecked: moduloinventario.inve11 === "1" ? true : false,
	                                onChange: checkBlank,
	                                id: "inlineCheckbox11"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineCheckbox11"
	                                },
	                                "Configuraci\xF3n"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                type: "checkbox",
	                                disabled: deshabilitado,
	                                ref: chkireports,
	                                defaultChecked: moduloinventario.inve12 === "1" ? true : false,
	                                onChange: checkBlank,
	                                id: "inlineCheckbox12"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineCheckbox12"
	                                },
	                                "Reportes"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ) : "",
	                    _react2.default.createElement("div", null)
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group col-sm-12 w-100" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-5" },
	                      "Modulo Ventas"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permodminas",
	                        disabled: deshabilitado,
	                        id: "inlineRadiov1",
	                        value: true,
	                        ref: moduventassi,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadiov1" },
	                        "Disponible"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permodminas",
	                        disabled: deshabilitado,
	                        id: "inlineRadiov2",
	                        value: false,
	                        ref: moduventasno,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadiov2" },
	                        "No Disponible"
	                      )
	                    ),
	                    modu2 === 1 ? _react2.default.createElement(
	                      "table",
	                      { className: "col-12 table table-sm table-bordered m-0 px-0" },
	                      _react2.default.createElement(
	                        "thead",
	                        { className: "col-12 m-0 px-0" },
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkvtodos,
	                                disabled: deshabilitado,
	                                onChange: checkTodo,
	                                defaultChecked: moduloventas.vents1 === "1" && moduloventas.vents2 === "1" && moduloventas.vents3 === "1" && moduloventas.vents4 === "1" && moduloventas.vents5 === "1" && moduloventas.vents6 === "1" && moduloventas.vents7 === "1" && moduloventas.vents8 === "1" && moduloventas.vents9 === "1" && moduloventas.vents10 === "1" ? true : false,
	                                name: "todosventas",
	                                type: "checkbox",
	                                id: "checkVentas"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVentas"
	                                },
	                                "Todos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkclientes,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloventas.vents1 === "1" ? true : false,
	                                onChange: checkBlank,
	                                type: "checkbox",
	                                id: "checkVentas1"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVentas1"
	                                },
	                                "Clientes"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkvendedores,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloventas.vents2 === "1" ? true : false,
	                                onChange: checkBlank,
	                                type: "checkbox",
	                                id: "checkVentas2"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVentas2"
	                                },
	                                "Vendedores"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkpedidos,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloventas.vents3 === "1" ? true : false,
	                                onChange: checkBlank,
	                                type: "checkbox",
	                                id: "checkVentas3"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVentas3"
	                                },
	                                "Pedidos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chknentrega,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloventas.vents4 === "1" ? true : false,
	                                onChange: checkBlank,
	                                type: "checkbox",
	                                id: "checkVentas4"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVentas4"
	                                },
	                                "Notas/Entrega"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkndebito,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloventas.vents5 === "1" ? true : false,
	                                onChange: checkBlank,
	                                type: "checkbox",
	                                id: "checkVentas5"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVentas5"
	                                },
	                                "Notas/Debito"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkfactura,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloventas.vents6 === "1" ? true : false,
	                                onChange: checkBlank,
	                                type: "checkbox",
	                                id: "checkVentas6"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVentas6"
	                                },
	                                "Facturas"
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkfacturaxnotas,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloventas.vents10 === "1" ? true : false,
	                                onChange: checkBlank,
	                                type: "checkbox",
	                                id: "checkVentas10"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVentas10"
	                                },
	                                "Facturas por Notas de Entrega"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkpresupuesto,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloventas.vents7 === "1" ? true : false,
	                                onChange: checkBlank,
	                                type: "checkbox",
	                                id: "checkVentas7"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVentas7"
	                                },
	                                "Presupuestos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkvconfi,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloventas.vents8 === "1" ? true : false,
	                                onChange: checkBlank,
	                                type: "checkbox",
	                                id: "checkVentas8"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVentas8"
	                                },
	                                "Configuraci\xF3n"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkvreports,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloventas.vents9 === "1" ? true : false,
	                                onChange: checkBlank,
	                                type: "checkbox",
	                                id: "checkVentas9"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVentas9"
	                                },
	                                "Reportes"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ) : "",
	                    _react2.default.createElement("div", null)
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group col-sm-12 w-100" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-5" },
	                      "Modulo Compras"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permod1x500",
	                        disabled: deshabilitado,
	                        id: "inlineRadioc1",
	                        value: true,
	                        ref: moducomprassi,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadioc1" },
	                        "Disponible"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permod1x500",
	                        disabled: deshabilitado,
	                        id: "inlineRadioc2",
	                        value: false,
	                        ref: moducomprasno,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadioc2" },
	                        "No Disponible"
	                      )
	                    ),
	                    modu3 === 1 ? _react2.default.createElement(
	                      "table",
	                      { className: "col-12 table table-sm table-bordered m-0 px-0" },
	                      _react2.default.createElement(
	                        "thead",
	                        { className: "col-12 m-0 px-0" },
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkcptodos,
	                                disabled: deshabilitado,
	                                type: "checkbox",
	                                onChange: checkTodo,
	                                defaultChecked: modulocompras.mcompras1 === "1" && modulocompras.mcompras2 === "1" && modulocompras.mcompras3 === "1" && modulocompras.mcompras4 === "1" && modulocompras.mcompras5 === "1" ? true : false,
	                                name: "todoscompras",
	                                id: "checkCompras"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkCompras"
	                                },
	                                "Todos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkproveedores,
	                                disabled: deshabilitado,
	                                defaultChecked: modulocompras.mcompras1 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkCompras1"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkCompras1"
	                                },
	                                "Proveedores"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkordencompra,
	                                disabled: deshabilitado,
	                                defaultChecked: modulocompras.mcompras2 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkCompras2"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkCompras2"
	                                },
	                                "Ordenes/Compras"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkfactucompra,
	                                disabled: deshabilitado,
	                                defaultChecked: modulocompras.mcompras3 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkCompras3"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkCompras3"
	                                },
	                                "Facturas/Compras"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkcpconfig,
	                                disabled: deshabilitado,
	                                defaultChecked: modulocompras.mcompras4 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkCompras4"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkCompras4"
	                                },
	                                "Configuraci\xF3n"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkcpreports,
	                                disabled: deshabilitado,
	                                defaultChecked: modulocompras.mcompras5 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkCompras5"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkCompras5"
	                                },
	                                "Reportes"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ) : "",
	                    _react2.default.createElement("div", null)
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group col-sm-12 w-100" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-5" },
	                      " Modulo Contabilidad"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permodprod",
	                        disabled: deshabilitado,
	                        id: "inlineRadiocb1",
	                        value: true,
	                        ref: moducontabsi,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "form-check-label",
	                          "for": "inlineRadiocb1"
	                        },
	                        "Disponible"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permodprod",
	                        disabled: deshabilitado,
	                        id: "inlineRadiocb2",
	                        value: false,
	                        ref: moducontabno,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "form-check-label",
	                          "for": "inlineRadiocb2"
	                        },
	                        "No Disponible"
	                      )
	                    ),
	                    modu4 === 1 ? _react2.default.createElement(
	                      "table",
	                      { className: "col-12 table table-sm table-bordered m-0 px-0" },
	                      _react2.default.createElement(
	                        "thead",
	                        { className: "col-12 m-0 px-0" },
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkcnttodos,
	                                disabled: deshabilitado,
	                                type: "checkbox",
	                                onChange: checkTodo,
	                                defaultChecked: modulocontabilidad.mcontab1 === "1" && modulocontabilidad.mcontab2 === "1" && modulocontabilidad.mcontab3 === "1" && modulocontabilidad.mcontab4 === "1" && modulocontabilidad.mcontab5 === "1" && modulocontabilidad.mcontab6 === "1" ? true : false,
	                                name: "todoscontabilidad",
	                                id: "checkContabilidad"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkContabilidad"
	                                },
	                                "Todos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkcatctcontable,
	                                disabled: deshabilitado,
	                                defaultChecked: modulocontabilidad.mcontab1 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkContabilidad1"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkContabilidad1"
	                                },
	                                "Cat. Cuentas Contable"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkasientcntable,
	                                disabled: deshabilitado,
	                                defaultChecked: modulocontabilidad.mcontab2 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkContabilidad2"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkContabilidad2"
	                                },
	                                "Asientos Contables"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkvincuenta,
	                                disabled: deshabilitado,
	                                defaultChecked: modulocontabilidad.mcontab3 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkContabilidad3"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkContabilidad3"
	                                },
	                                "Vinculaci\xF3n/Cuentas"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkmovibancot,
	                                disabled: deshabilitado,
	                                defaultChecked: modulocontabilidad.mcontab4 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkContabilidad4"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkContabilidad4"
	                                },
	                                "Movimientos Bancarios"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkcntconfig,
	                                disabled: deshabilitado,
	                                defaultChecked: modulocontabilidad.mcontab5 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkContabilidad5"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkContabilidad5"
	                                },
	                                "Configuraci\xF3n"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkcntreports,
	                                disabled: deshabilitado,
	                                defaultChecked: modulocontabilidad.mcontab6 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkContabilidad6"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkContabilidad6"
	                                },
	                                "Reportes"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ) : "",
	                    _react2.default.createElement("div", null)
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-sm-12 py-1 mb-1 border-azul d-flex justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group col-sm-12 w-100" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-5" },
	                      " Modulo Finanzas"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permodfiscal",
	                        disabled: deshabilitado,
	                        id: "inlineRadiof1",
	                        value: true,
	                        ref: modufinanzassi,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadiof1" },
	                        "Disponible"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permodfiscal",
	                        disabled: deshabilitado,
	                        id: "inlineRadiof2",
	                        value: false,
	                        ref: modufinanzasno,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadiof2" },
	                        "No Disponible"
	                      )
	                    ),
	                    modu5 === 1 ? _react2.default.createElement(
	                      "table",
	                      { className: "col-12 table table-sm table-bordered m-0 px-0" },
	                      _react2.default.createElement(
	                        "thead",
	                        { className: "col-12 m-0 px-0" },
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkftodos,
	                                disabled: deshabilitado,
	                                type: "checkbox",
	                                onChange: checkTodo,
	                                defaultChecked: modulofinanzas.mfinanzas1 === "1" && modulofinanzas.mfinanzas2 === "1" && modulofinanzas.mfinanzas3 === "1" && modulofinanzas.mfinanzas4 === "1" && modulofinanzas.mfinanzas5 === "1" && modulofinanzas.mfinanzas6 === "1" && modulofinanzas.mfinanzas7 === "1" && modulofinanzas.mfinanzas8 === "1" && modulofinanzas.mfinanzas9 === "1" && modulofinanzas.mfinanzas10 === "1" && modulofinanzas.mfinanzas11 === "1" && modulofinanzas.mfinanzas12 === "1" ? true : false,
	                                name: "todosfinanzas",
	                                id: "inlineFinanzas"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineFinanzas"
	                                },
	                                "Todos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkbancos,
	                                disabled: deshabilitado,
	                                defaultChecked: modulofinanzas.mfinanzas1 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "inlineFinanzas1"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineFinanzas1"
	                                },
	                                "Bancos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkbeneficiarios,
	                                disabled: deshabilitado,
	                                defaultChecked: modulofinanzas.mfinanzas2 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "inlineFinanzas2"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineFinanzas2"
	                                },
	                                "Beneficiarios"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkctasbancarias,
	                                disabled: deshabilitado,
	                                defaultChecked: modulofinanzas.mfinanzas3 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "inlineFinanzas3"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineFinanzas3"
	                                },
	                                "Cuentas Bancarias"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkmovibancarios,
	                                disabled: deshabilitado,
	                                defaultChecked: modulofinanzas.mfinanzas4 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "inlineFinanzas4"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineFinanzas4"
	                                },
	                                "Movimientos Bancarios"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkmovitransito,
	                                disabled: deshabilitado,
	                                defaultChecked: modulofinanzas.mfinanzas5 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "inlineFinanzas5"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineFinanzas5"
	                                },
	                                "Movimientos/Transito"
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkconciliacionbanco,
	                                disabled: deshabilitado,
	                                defaultChecked: modulofinanzas.mfinanzas6 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "inlineFinanzas6"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineFinanzas6"
	                                },
	                                "Conciliaci\xF3n Bancaria"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkctasxcobrar,
	                                disabled: deshabilitado,
	                                defaultChecked: modulofinanzas.mfinanzas7 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "inlineFinanzas7"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineFinanzas7"
	                                },
	                                "Cuentas x Cobrar"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkReverPagoAnti,
	                                disabled: deshabilitado,
	                                defaultChecked: modulofinanzas.mfinanzas12 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "inlineFinanzas12"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineFinanzas12"
	                                },
	                                "Reverzar Pago / Anticipo"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkctasxpagar,
	                                disabled: deshabilitado,
	                                defaultChecked: modulofinanzas.mfinanzas8 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "inlineFinanzas8"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineFinanzas8"
	                                },
	                                "Cuentas x Pagar"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chktiporetenciones,
	                                disabled: deshabilitado,
	                                defaultChecked: modulofinanzas.mfinanzas9 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "inlineFinanzas9"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineFinanzas9"
	                                },
	                                "Tipo/Retenciones"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkfconfig,
	                                disabled: deshabilitado,
	                                defaultChecked: modulofinanzas.mfinanzas10 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "inlineFinanzas10"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineFinanzas10"
	                                },
	                                "Configuraci\xF3n"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkfreports,
	                                disabled: deshabilitado,
	                                defaultChecked: modulofinanzas.mfinanzas11 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "inlineFinanzas11"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineFinanzas11"
	                                },
	                                "Reportes"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ) : "",
	                    _react2.default.createElement("div", null)
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group col-sm-12 w-100" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-5" },
	                      "Modulo Gesti\xF3n de Vacios"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "vacios",
	                        disabled: deshabilitado,
	                        id: "inlineRadiovacio1",
	                        value: true,
	                        ref: moduvaciossi,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadiovacio1" },
	                        "Disponible"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "vacios",
	                        disabled: deshabilitado,
	                        id: "inlineRadiovacio2",
	                        value: false,
	                        ref: moduvaciosno,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadiovacio2" },
	                        "No Disponible"
	                      )
	                    ),
	                    modu7 === 1 ? _react2.default.createElement(
	                      "table",
	                      { className: "col-12 table table-sm table-bordered m-0 px-0" },
	                      _react2.default.createElement(
	                        "thead",
	                        { className: "col-12 m-0 px-0" },
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkvaciostodos,
	                                disabled: deshabilitado,
	                                type: "checkbox",
	                                onChange: checkTodo,
	                                defaultChecked: modulovacios.vacios1 === "1" && modulovacios.vacios2 === "1" && modulovacios.vacios3 === "1" && modulovacios.vacios4 === "1" && modulovacios.vacios5 === "1" ? true : false,
	                                name: "todosvacios",
	                                id: "checkVacios"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVacios"
	                                },
	                                "Todos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkopvacios,
	                                disabled: deshabilitado,
	                                defaultChecked: modulovacios.vacios1 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkVacios1"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVacios1"
	                                },
	                                "Operaciones de Inventario (Vacios)"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkcontrolvacios,
	                                disabled: deshabilitado,
	                                defaultChecked: modulovacios.vacios2 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkVacios2"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVacios2"
	                                },
	                                "Control de Vacios"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkclassvacios,
	                                disabled: deshabilitado,
	                                defaultChecked: modulovacios.vacios3 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkVacios3"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVacios3"
	                                },
	                                "Clasificador de Vacios"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkvaciosconfig,
	                                disabled: deshabilitado,
	                                defaultChecked: modulovacios.vacios4 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkVacios4"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVacios4"
	                                },
	                                "Configuraci\xF3n"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkvaciosreports,
	                                disabled: deshabilitado,
	                                defaultChecked: modulovacios.vacios5 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkVacios5"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVacios5"
	                                },
	                                "Reportes"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ) : "",
	                    _react2.default.createElement("div", null)
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group col-sm-12 w-100" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-5" },
	                      "Modulo Servicios"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "servicios",
	                        disabled: deshabilitado,
	                        id: "inlineRadioservicio1",
	                        value: true,
	                        ref: moduserviciossi,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadioservicio1" },
	                        "Disponible"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "servicios",
	                        disabled: deshabilitado,
	                        id: "inlineRadioservicio2",
	                        value: false,
	                        ref: moduserviciosno,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadioservicio2" },
	                        "No Disponible"
	                      )
	                    ),
	                    modu8 === 1 ? _react2.default.createElement(
	                      "table",
	                      { className: "col-12 table table-sm table-bordered m-0 px-0" },
	                      _react2.default.createElement(
	                        "thead",
	                        { className: "col-12 m-0 px-0" },
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkservtodos,
	                                disabled: deshabilitado,
	                                type: "checkbox",
	                                onChange: checkTodo,
	                                defaultChecked: moduloservicios.servicio1 === "1" && moduloservicios.servicio2 === "1" && moduloservicios.servicio3 === "1" && moduloservicios.servicio4 === "1" && moduloservicios.servicio5 === "1" && moduloservicios.servicio6 === "1" ? true : false,
	                                name: "todosservicios",
	                                id: "checkServicios"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkServicios"
	                                },
	                                "Todos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkordenservi,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloservicios.servicio1 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkServicios1"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkServicios1"
	                                },
	                                "Gesti\xF3n (Ordenes de Servicio)"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkmovilesservi,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloservicios.servicio2 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkServicios2"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkServicios2"
	                                },
	                                "Gesti\xF3n de Moviles"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkgservicios,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloservicios.servicio3 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkServicios3"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkServicios3"
	                                },
	                                "Gesti\xF3n de Servicios"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkservnotaent,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloservicios.servicio4 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkServicios4"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkServicios4"
	                                },
	                                "Nota de Entrega"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkservconfig,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloservicios.servicio5 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkServicios5"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkServicios5"
	                                },
	                                "Configuraci\xF3n"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkservreports,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloservicios.servicio6 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkServicios6"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkServicios6"
	                                },
	                                "Reportes"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ) : "",
	                    _react2.default.createElement("div", null)
	                  )
	                ),
	                idorganizacion === '1' ? _react2.default.createElement(
	                  "div",
	                  { className: "border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group col-sm-12 w-100" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-5" },
	                      "Modulo Post-Venta"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "ptventa",
	                        disabled: deshabilitado,
	                        id: "inlineRadiopostventa1",
	                        value: true,
	                        ref: modupostventasi,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadiopostventa1" },
	                        "Disponible"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "ptventa",
	                        disabled: deshabilitado,
	                        id: "inlineRadiopostventa2",
	                        value: false,
	                        ref: modupostventano,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadiopostventa2" },
	                        "No Disponible"
	                      )
	                    ),
	                    modu9 === 1 ? _react2.default.createElement(
	                      "table",
	                      { className: "col-12 table table-sm table-bordered m-0 px-0" },
	                      _react2.default.createElement(
	                        "thead",
	                        { className: "col-12 m-0 px-0" },
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkpostventtodos,
	                                disabled: deshabilitado,
	                                type: "checkbox",
	                                onChange: checkTodo,
	                                defaultChecked: modulopostventa.postventa1 === "1" ? true : false,
	                                name: "todospostventa",
	                                id: "checkPostventa"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkPostventa"
	                                },
	                                "Todos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: chkpostventventa,
	                                disabled: deshabilitado,
	                                defaultChecked: modulopostventa.postventa1 === "1" ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                id: "checkPostventa1"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkPostventa1"
	                                },
	                                "Ventas"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline mx-auto" },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "col-pd-250 px-0 m-0" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "input-group input-group-sm" },
	                                  _react2.default.createElement(
	                                    "label",
	                                    { className: "input-group-text fw-bold text-black" },
	                                    "TIPO DE PRECIO:"
	                                  ),
	                                  _react2.default.createElement(
	                                    "select",
	                                    {
	                                      ref: cmbTipoPrecioGlobal,
	                                      className: "form-control form-control-sm",
	                                      defaultValue: props.usuario && props.usuario.tipoprecio,
	                                      disabled: deshabilitado
	                                    },
	                                    _react2.default.createElement(
	                                      "option",
	                                      { value: "1" },
	                                      "PRECIO MAXIMO"
	                                    ),
	                                    _react2.default.createElement(
	                                      "option",
	                                      { value: "2" },
	                                      "PRECIO OFERTA"
	                                    ),
	                                    _react2.default.createElement(
	                                      "option",
	                                      { value: "3" },
	                                      "PRECIO MAYOR"
	                                    ),
	                                    _react2.default.createElement(
	                                      "option",
	                                      { value: "4" },
	                                      "PRECIO MINIMO"
	                                    )
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ) : _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement("input", { type: "hidden", ref: cmbTipoPrecioGlobal, value: "1" })
	                    ),
	                    _react2.default.createElement("div", null)
	                  )
	                ) : _react2.default.createElement(
	                  "div",
	                  null,
	                  _react2.default.createElement("input", { type: "hidden", ref: modupostventasi }),
	                  _react2.default.createElement("input", { type: "hidden", ref: modupostventano }),
	                  _react2.default.createElement("input", { type: "hidden", ref: cmbTipoPrecioGlobal, value: "1" })
	                ),
	                essupervisor === 1 || idorganizacion === '1' ? _react2.default.createElement(
	                  "div",
	                  { className: "border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between" },
	                  _react2.default.createElement(
	                    "table",
	                    { className: "col-12 table table-sm table-bordered m-0 px-0" },
	                    _react2.default.createElement(
	                      "thead",
	                      { className: "col-12 m-0 px-0" },
	                      _react2.default.createElement(
	                        "tr",
	                        null,
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "form-check form-check-inline" },
	                            _react2.default.createElement("input", {
	                              className: "form-check-input",
	                              ref: chksupervisor,
	                              disabled: essupervisor === 1 || idorganizacion === '1' ? false : true,
	                              defaultChecked: essupervisor === 1 ? true : false,
	                              type: "checkbox",
	                              onChange: checkBlank,
	                              id: "checkSupervisor"
	                            }),
	                            _react2.default.createElement(
	                              "label",
	                              {
	                                className: "form-check-label",
	                                "for": "checkSupervisor"
	                              },
	                              "Supervisor"
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "th",
	                          { scope: "col" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "form-check form-check-inline" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "input-group input-group-sm" },
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "input-group-text",
	                                  id: "inputGroup-sizing-sm"
	                                },
	                                _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-unlock-alt" }),
	                                "Clave:"
	                              ),
	                              _react2.default.createElement("input", {
	                                type: mostrarClavesup ? "text" : "password",
	                                disabled: essupervisor === 1 ? false : true,
	                                ref: txtPasswordsuv,
	                                className: "form-control",
	                                "aria-label": "Sizing example input",
	                                "aria-describedby": "inputGroup-sizing-sm",
	                                id: "inputPasswordsup",
	                                defaultValue: essupervisor === 1 ? props.usuario && props.usuario.passwsupervisor : '',
	                                onKeyUp: handleInputChange
	                              }),
	                              _react2.default.createElement(
	                                "button",
	                                {
	                                  style: { textAlign: "center", color: "white" },
	                                  disabled: essupervisor === 1 ? false : true,
	                                  onClick: mostrarPasswordsup,
	                                  className: "btn btn-sm btn-info"
	                                },
	                                _react2.default.createElement("i", {
	                                  disabled: deshabilitado,
	                                  className: "fa fa-eye-slash"
	                                }),
	                                " "
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  " "
	                ) : '',
	                _react2.default.createElement(
	                  "div",
	                  { className: "border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group col-sm-12 w-100" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-5" },
	                      " Modulo Configuraci\xF3n"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permodingresos",
	                        disabled: deshabilitado,
	                        id: "inlineRadiocg1",
	                        value: true,
	                        ref: moduconfigsi,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "form-check-label",
	                          "for": "inlineRadiocg1"
	                        },
	                        "Disponible"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permodingresos",
	                        disabled: deshabilitado,
	                        id: "inlineRadiocg2",
	                        value: false,
	                        ref: moduconfigno,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "form-check-label",
	                          "for": "inlineRadiocg2"
	                        },
	                        "No Disponible"
	                      )
	                    ),
	                    _react2.default.createElement("div", null)
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "tab-pane fade",
	                id: "tab-3",
	                role: "tabpanel",
	                "aria-labelledby": "ex-with-icons-tab-3"
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "row mx-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-6 row mx-auto mb-1" },
	                  _react2.default.createElement(
	                    "fieldset",
	                    { className: " row col-sm-12 mx-auto border-azul rounded py-0" },
	                    _react2.default.createElement(
	                      "legend",
	                      {
	                        className: "float-none fw-bold w-auto",
	                        style: { fontSize: "15px" }
	                      },
	                      "Organizaci\xF3n"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-6 pl-3 mb-2" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: operacion === 1 || operacion === 2 ? false : true,
	                          type: "radio",
	                          name: "opcion1",
	                          value: "1",
	                          id: "modulo",
	                          onChange: onChange,
	                          checked: modulosConfig.opcion1 === "1" ? true : false
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          { className: "form-check-label py-1" },
	                          "Disponible"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-6 mb-2" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: operacion === 1 || operacion === 2 ? false : true,
	                          type: "radio",
	                          name: "opcion1",
	                          value: "0",
	                          id: "modulo",
	                          onChange: onChange,
	                          checked: modulosConfig.opcion1 === "0" ? true : false
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          { className: "form-check-label py-1" },
	                          "No Disponible"
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-6 row mx-auto mb-1" },
	                  _react2.default.createElement(
	                    "fieldset",
	                    { className: " row col-sm-12 mx-auto border-azul rounded py-0" },
	                    _react2.default.createElement(
	                      "legend",
	                      {
	                        className: "float-none fw-bold w-auto",
	                        style: { fontSize: "15px" }
	                      },
	                      "Ajustes"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-6 pl-3 mb-2" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: operacion === 1 || operacion === 2 ? false : true,
	                          type: "radio",
	                          name: "opcion7",
	                          value: "1",
	                          id: "modulo",
	                          onChange: onChange,
	                          checked: modulosConfig.opcion7 === "1" ? true : false
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          { className: "form-check-label py-1" },
	                          "Disponible"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-6 mb-2" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: operacion === 1 || operacion === 2 ? false : true,
	                          type: "radio",
	                          name: "opcion7",
	                          value: "0",
	                          id: "modulo",
	                          onChange: onChange,
	                          checked: modulosConfig.opcion7 === "0" ? true : false
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          { className: "form-check-label py-1" },
	                          "No Disponible"
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-6 row mx-auto mb-1" },
	                  _react2.default.createElement(
	                    "fieldset",
	                    { className: " row col-sm-12 mx-auto border-azul rounded py-0" },
	                    _react2.default.createElement(
	                      "legend",
	                      {
	                        className: "float-none fw-bold w-auto",
	                        style: { fontSize: "15px" }
	                      },
	                      "Respaldo-BD"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-6 pl-3 mb-2" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: operacion === 1 || operacion === 2 ? false : true,
	                          type: "radio",
	                          name: "opcion5",
	                          value: "1",
	                          id: "modulo",
	                          onChange: onChange,
	                          checked: modulosConfig.opcion5 === "1" ? true : false
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          { className: "form-check-label py-1" },
	                          "Disponible"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-6 mb-2" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: operacion === 1 || operacion === 2 ? false : true,
	                          type: "radio",
	                          name: "opcion5",
	                          value: "0",
	                          id: "modulo",
	                          onChange: onChange,
	                          checked: modulosConfig.opcion5 === "0" ? true : false
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          { className: "form-check-label py-1" },
	                          "No Disponible"
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-6 row mx-auto mb-1" },
	                  _react2.default.createElement(
	                    "fieldset",
	                    { className: " row col-sm-12 mx-auto border-azul rounded py-0" },
	                    _react2.default.createElement(
	                      "legend",
	                      {
	                        className: "float-none fw-bold w-auto",
	                        style: { fontSize: "15px" }
	                      },
	                      "Vista-Inicio"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-6 pl-3 mb-2" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: operacion === 1 || operacion === 2 ? false : true,
	                          type: "radio",
	                          name: "inicio",
	                          value: "1",
	                          id: "moduloini",
	                          onChange: onChangeMonuini,
	                          checked: modulosini.moduini === "1" ? true : false
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          { className: "form-check-label py-1" },
	                          "Disponible"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-6 mb-2" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: operacion === 1 || operacion === 2 ? false : true,
	                          type: "radio",
	                          name: "inicio",
	                          value: "0",
	                          id: "moduloini",
	                          onChange: onChangeMonuini,
	                          checked: modulosini.moduini === "0" ? true : false
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          { className: "form-check-label py-1" },
	                          "No Disponible"
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 row mx-auto mb-1" },
	                  _react2.default.createElement(
	                    "fieldset",
	                    { className: " row col-sm-12 mx-auto border-azul rounded py-0" },
	                    _react2.default.createElement(
	                      "legend",
	                      {
	                        className: "float-none fw-bold w-auto",
	                        style: { fontSize: "15px" }
	                      },
	                      "Personas"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-2 pl-3 mb-2" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: operacion === 1 || operacion === 2 ? false : true,
	                          type: "radio",
	                          name: "opcion2",
	                          value: "1",
	                          id: "modulo",
	                          onChange: onChange,
	                          checked: modulosConfig.opcion2 === "1" ? true : false
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          { className: "form-check-label py-1" },
	                          "Disponible"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-2 mb-2" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: operacion === 1 || operacion === 2 ? false : true,
	                          type: "radio",
	                          name: "opcion2",
	                          value: "0",
	                          id: "modulo",
	                          onChange: onChange,
	                          checked: modulosConfig.opcion2 === "0" ? true : false
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          { className: "form-check-label py-1" },
	                          "No Disponible"
	                        )
	                      )
	                    ),
	                    modulosConfig.opcion2 === "1" ? _react2.default.createElement(
	                      "div",
	                      { className: "col-md-8 row mb-3 rounded" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            type: "checkbox",
	                            value: "1",
	                            id: "flexCheckDefault",
	                            onChange: checkBlank,
	                            ref: chkPerCon,
	                            defaultChecked: operacionesMod.personas1 === "1" ? true : false
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label py-1",
	                              "for": "flexCheckDefault"
	                            },
	                            "Consultar"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            type: "checkbox",
	                            value: "1",
	                            id: "flexCheckDefault",
	                            onChange: checkBlank,
	                            ref: chkPerIn,
	                            defaultChecked: operacionesMod.personas2 === "1" ? true : false
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label py-1",
	                              "for": "flexCheckDefault"
	                            },
	                            "Incluir"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            type: "checkbox",
	                            value: "1",
	                            id: "flexCheckDefault",
	                            onChange: checkBlank,
	                            ref: chkPerMod,
	                            defaultChecked: operacionesMod.personas3 === "1" ? true : false
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label py-1",
	                              "for": "flexCheckDefault"
	                            },
	                            "Modificar"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            type: "checkbox",
	                            value: "1",
	                            id: "flexCheckDefault",
	                            onChange: checkBlank,
	                            ref: chkPerEli,
	                            defaultChecked: operacionesMod.personas4 === "1" ? true : false
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label py-1",
	                              "for": "flexCheckDefault"
	                            },
	                            "Eliminar"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            type: "checkbox",
	                            value: "1",
	                            id: "flexCheckDefault",
	                            name: "todopersonas",
	                            ref: chkPerTodo,
	                            defaultChecked: operacionesMod.personas1 === "1" && operacionesMod.personas2 === "1" && operacionesMod.personas3 === "1" && operacionesMod.personas4 === "1" ? true : false,
	                            onChange: checkTodo
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label py-1",
	                              "for": "flexCheckDefault"
	                            },
	                            "Todo"
	                          )
	                        )
	                      )
	                    ) : ""
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 row mx-auto mb-1" },
	                  _react2.default.createElement(
	                    "fieldset",
	                    { className: " row col-sm-12 mx-auto border-azul rounded py-0" },
	                    _react2.default.createElement(
	                      "legend",
	                      {
	                        className: "float-none fw-bold w-auto",
	                        style: { fontSize: "15px" }
	                      },
	                      "Usuarios"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-2 pl-3 mb-2" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: operacion === 1 || operacion === 2 ? false : true,
	                          type: "radio",
	                          name: "opcion3",
	                          value: "1",
	                          id: "modulo",
	                          onChange: onChange,
	                          checked: modulosConfig.opcion3 === "1" ? true : false
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          { className: "form-check-label py-1" },
	                          "Disponible"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-2 mb-2" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: operacion === 1 || operacion === 2 ? false : true,
	                          type: "radio",
	                          name: "opcion3",
	                          value: "0",
	                          id: "modulo",
	                          onChange: onChange,
	                          checked: modulosConfig.opcion3 === "0" ? true : false
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          { className: "form-check-label py-1" },
	                          "No Disponible"
	                        )
	                      )
	                    ),
	                    modulosConfig.opcion3 === "1" ? _react2.default.createElement(
	                      "div",
	                      { className: "col-md-8 row mb-3 rounded" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            type: "checkbox",
	                            value: "1",
	                            id: "flexCheckDefault",
	                            onChange: checkBlank,
	                            ref: chkUsuCon,
	                            defaultChecked: operacionesMod.usuarios1 === "1" ? true : false
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label py-1",
	                              "for": "flexCheckDefault"
	                            },
	                            "Consultar"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            type: "checkbox",
	                            value: "1",
	                            id: "flexCheckDefault",
	                            onChange: checkBlank,
	                            ref: chkUsuIn,
	                            defaultChecked: operacionesMod.usuarios2 === "1" ? true : false
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label py-1",
	                              "for": "flexCheckDefault"
	                            },
	                            "Incluir"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            type: "checkbox",
	                            value: "1",
	                            id: "flexCheckDefault",
	                            onChange: checkBlank,
	                            ref: chkUsuMod,
	                            defaultChecked: operacionesMod.usuarios3 === "1" ? true : false
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label py-1",
	                              "for": "flexCheckDefault"
	                            },
	                            "Modificar"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            type: "checkbox",
	                            value: "1",
	                            id: "flexCheckDefault",
	                            onChange: checkBlank,
	                            ref: chkUsuEli,
	                            defaultChecked: operacionesMod.usuarios4 === "1" ? true : false
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label py-1",
	                              "for": "flexCheckDefault"
	                            },
	                            "Eliminar"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            type: "checkbox",
	                            value: "1",
	                            name: "todousuarios",
	                            id: "flexCheckDefault",
	                            ref: chkUsuTodo,
	                            defaultChecked: operacionesMod.usuarios1 === "1" && operacionesMod.usuarios2 === "1" && operacionesMod.usuarios3 === "1" && operacionesMod.usuarios4 === "1" ? true : false,
	                            onChange: checkTodo
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label py-1",
	                              "for": "flexCheckDefault"
	                            },
	                            "Todo"
	                          )
	                        )
	                      )
	                    ) : ""
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 row mx-auto mb-1" },
	                  _react2.default.createElement(
	                    "fieldset",
	                    { className: " row col-sm-12 mx-auto border-azul rounded py-0" },
	                    _react2.default.createElement(
	                      "legend",
	                      {
	                        className: "float-none fw-bold w-auto",
	                        style: { fontSize: "15px" }
	                      },
	                      "Usuarios-APP"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-2 pl-3 mb-2" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: operacion === 1 || operacion === 2 ? false : true,
	                          type: "radio",
	                          name: "opcion6",
	                          value: "1",
	                          id: "modulo",
	                          onChange: onChange,
	                          checked: modulosConfig.opcion6 === "1" ? true : false
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          { className: "form-check-label py-1" },
	                          "Disponible"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-2 mb-2" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: operacion === 1 || operacion === 2 ? false : true,
	                          type: "radio",
	                          name: "opcion6",
	                          value: "0",
	                          id: "modulo",
	                          onChange: onChange,
	                          checked: modulosConfig.opcion6 === "0" ? true : false
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          { className: "form-check-label py-1" },
	                          "No Disponible"
	                        )
	                      )
	                    ),
	                    modulosConfig.opcion6 === "1" ? _react2.default.createElement(
	                      "div",
	                      { className: "col-md-8 row mb-3 rounded" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            type: "checkbox",
	                            value: "1",
	                            id: "flexCheckDefault",
	                            onChange: checkBlank,
	                            ref: chkUsuappCon,
	                            defaultChecked: operacionesMod.usuarioapp1 === "1" ? true : false
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label py-1",
	                              "for": "flexCheckDefault"
	                            },
	                            "Consultar"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            type: "checkbox",
	                            value: "1",
	                            id: "flexCheckDefault",
	                            onChange: checkBlank,
	                            ref: chkUsuappIn,
	                            defaultChecked: operacionesMod.usuarioapp2 === "1" ? true : false
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label py-1",
	                              "for": "flexCheckDefault"
	                            },
	                            "Incluir"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            type: "checkbox",
	                            value: "1",
	                            id: "flexCheckDefault",
	                            onChange: checkBlank,
	                            ref: chkUsuappMod,
	                            defaultChecked: operacionesMod.usuarioapp3 === "1" ? true : false
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label py-1",
	                              "for": "flexCheckDefault"
	                            },
	                            "Modificar"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            type: "checkbox",
	                            value: "1",
	                            id: "flexCheckDefault",
	                            onChange: checkBlank,
	                            ref: chkUsuappEli,
	                            defaultChecked: operacionesMod.usuarioapp4 === "1" ? true : false
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label py-1",
	                              "for": "flexCheckDefault"
	                            },
	                            "Eliminar"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            type: "checkbox",
	                            value: "1",
	                            name: "todousuariosapp",
	                            id: "flexCheckDefault",
	                            ref: chkUsuappTodo,
	                            defaultChecked: operacionesMod.usuarioapp1 === "1" && operacionesMod.usuarioapp2 === "1" && operacionesMod.usuarioapp3 === "1" && operacionesMod.usuarioapp4 === "1" ? true : false,
	                            onChange: checkTodo
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label py-1",
	                              "for": "flexCheckDefault"
	                            },
	                            "Todo"
	                          )
	                        )
	                      )
	                    ) : ""
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 row mx-auto mb-1" },
	                  _react2.default.createElement(
	                    "fieldset",
	                    { className: " row col-sm-12 mx-auto border-azul rounded py-0" },
	                    _react2.default.createElement(
	                      "legend",
	                      {
	                        className: "float-none fw-bold w-auto",
	                        style: { fontSize: "15px" }
	                      },
	                      "Monedas"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-2 pl-3 mb-2" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: operacion === 1 || operacion === 2 ? false : true,
	                          type: "radio",
	                          name: "opcion4",
	                          value: "1",
	                          id: "modulo",
	                          onChange: onChange,
	                          checked: modulosConfig.opcion4 === "1" ? true : false
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          { className: "form-check-label py-1" },
	                          "Disponible"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-md-2 mb-2" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: operacion === 1 || operacion === 2 ? false : true,
	                          type: "radio",
	                          name: "opcion4",
	                          value: "0",
	                          id: "modulo",
	                          onChange: onChange,
	                          checked: modulosConfig.opcion4 === "0" ? true : false
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          { className: "form-check-label py-1" },
	                          "No Disponible"
	                        )
	                      )
	                    ),
	                    modulosConfig.opcion4 === "1" ? _react2.default.createElement(
	                      "div",
	                      { className: "col-md-8 row mb-3 rounded" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            type: "checkbox",
	                            value: "1",
	                            id: "flexCheckDefault",
	                            onChange: checkBlank,
	                            ref: chkMoneCon,
	                            defaultChecked: operacionesMod.unidadcontable1 === "1" ? true : false
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label py-1",
	                              "for": "flexCheckDefault"
	                            },
	                            "Consultar"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            type: "checkbox",
	                            value: "1",
	                            id: "flexCheckDefault",
	                            onChange: checkBlank,
	                            ref: chkMoneIn,
	                            defaultChecked: operacionesMod.unidadcontable2 === "1" ? true : false
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label py-1",
	                              "for": "flexCheckDefault"
	                            },
	                            "Incluir"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            type: "checkbox",
	                            value: "1",
	                            id: "flexCheckDefault",
	                            onChange: checkBlank,
	                            ref: chkMoneMod,
	                            defaultChecked: operacionesMod.unidadcontable3 === "1" ? true : false
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label py-1",
	                              "for": "flexCheckDefault"
	                            },
	                            "Modificar"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            type: "checkbox",
	                            value: "1",
	                            id: "flexCheckDefault",
	                            onChange: checkBlank,
	                            ref: chkMoneEli,
	                            defaultChecked: operacionesMod.unidadcontable4 === "1" ? true : false
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label py-1",
	                              "for": "flexCheckDefault"
	                            },
	                            "Eliminar"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col d-flex justify-content-center" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "form-check" },
	                          _react2.default.createElement("input", {
	                            className: "form-check-input",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            type: "checkbox",
	                            value: "1",
	                            name: "todomonedas",
	                            id: "flexCheckDefault",
	                            ref: chkMoneTodo,
	                            defaultChecked: operacionesMod.unidadcontable1 === "1" && operacionesMod.unidadcontable2 === "1" && operacionesMod.unidadcontable3 === "1" && operacionesMod.unidadcontable4 === "1" ? true : false,
	                            onChange: checkTodo
	                          }),
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "form-check-label py-1",
	                              "for": "flexCheckDefault"
	                            },
	                            "Todo"
	                          )
	                        )
	                      )
	                    ) : ""
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "col-sm-12 d-flex justify-content-end row mx-auto py-1" },
	        _react2.default.createElement(
	          "button",
	          {
	            type: "button",
	            onClick: function onClick() {
	              setMostrar2(true);
	            },
	            style: { visibility: operacion === 2 ? "visible" : "collapse" },
	            className: "btn col-sm-3 mx-1 btn-warning btn-sm rounded-pill"
	          },
	          _react2.default.createElement(
	            "i",
	            { className: "fas fa-key" },
	            " Cambiar Clave"
	          ),
	          " "
	        ),
	        _react2.default.createElement(
	          "button",
	          {
	            type: "button",
	            ref: btnAcepta,
	            disabled: operacion === 4 ? true : false,
	            onClick: onChangeValidar,
	            className: "col-sm-3 mx-1 btn-sm btn btn-success rounded-pill"
	          },
	          _react2.default.createElement("i", { className: "far fa-check-circle" }),
	          "Aceptar"
	        ),
	        _react2.default.createElement(
	          "button",
	          {
	            type: "button",
	            ref: btnCancela,
	            onClick: cancelar,
	            className: "col-sm-3 mx-1 btn-sm btn btn-danger rounded-pill"
	          },
	          _react2.default.createElement("i", { className: "fas fa-window-close" }),
	          "Cancelar"
	        )
	      )
	    )
	  );
	};
	exports.default = ModalActualizarUsuario;

/***/ },
/* 7090 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _InputGroup = __webpack_require__(6988);
	
	var _InputGroup2 = _interopRequireDefault(_InputGroup);
	
	var _Form = __webpack_require__(6978);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _catalogoPersona = __webpack_require__(64);
	
	var _catalogoPersona2 = _interopRequireDefault(_catalogoPersona);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _catalogoOrganizacion = __webpack_require__(658);
	
	var _catalogoOrganizacion2 = _interopRequireDefault(_catalogoOrganizacion);
	
	var _modalCambiarClaveApp = __webpack_require__(665);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalActualizarUsuarioApp = function ModalActualizarUsuarioApp(props) {
	  var idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var idusuario = JSON.parse(sessionStorage.getItem("idusuario"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnEnviar = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      mensajesino = _useState4[0],
	      setMensajesino = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mostrar = _useState6[0],
	      setMostrar = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mostrar1 = _useState8[0],
	      setMostrar1 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mostrar2 = _useState10[0],
	      setMostrar2 = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mostrar3 = _useState12[0],
	      setMostrar3 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({}),
	      _useState14 = _slicedToArray(_useState13, 2),
	      body = _useState14[0],
	      setBody = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mostrar4 = _useState16[0],
	      setMostrar4 = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(),
	      _useState18 = _slicedToArray(_useState17, 2),
	      titulo = _useState18[0],
	      setTitulo = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(),
	      _useState20 = _slicedToArray(_useState19, 2),
	      msg = _useState20[0],
	      setMsg = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      contar = _useState22[0],
	      setContar = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0),
	      _useState24 = _slicedToArray(_useState23, 2),
	      contar2 = _useState24[0],
	      setContar2 = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(),
	      _useState26 = _slicedToArray(_useState25, 2),
	      titulo2 = _useState26[0],
	      setTitulo2 = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(),
	      _useState28 = _slicedToArray(_useState27, 2),
	      msg2 = _useState28[0],
	      setMsg2 = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(""),
	      _useState30 = _slicedToArray(_useState29, 2),
	      password = _useState30[0],
	      setPassword = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(false),
	      _useState32 = _slicedToArray(_useState31, 2),
	      activate = _useState32[0],
	      setActivate = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(),
	      _useState34 = _slicedToArray(_useState33, 2),
	      usuario = _useState34[0],
	      setUsuario = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(false),
	      _useState36 = _slicedToArray(_useState35, 2),
	      catalogoCliente = _useState36[0],
	      setCatalogoCliente = _useState36[1];
	
	  var cmbCedula = [{ value: "V" }, { value: "E" }, { value: "J" }, { value: "P" }, { value: "G" }];
	
	  var _useState37 = (0, _react.useState)({
	    cedula: "",
	    nombres: "",
	    apellidos: "",
	    direccion: "",
	    correoe: "",
	    tlf1: "",
	    tlf2: "",
	    fnacimiento: "",
	    nacionalidad: "",
	    sexo: ""
	  }),
	      _useState38 = _slicedToArray(_useState37, 2),
	      persona = _useState38[0],
	      setPersona = _useState38[1];
	
	  var _useState39 = (0, _react.useState)({
	    sincro1: null,
	    sincro2: null
	  }),
	      _useState40 = _slicedToArray(_useState39, 2),
	      modulosincroniza = _useState40[0],
	      setModulosincroniza = _useState40[1];
	
	  var _useState41 = (0, _react.useState)({
	    pedidos1: null,
	    pedidos2: null,
	    pedidos3: null,
	    pedidos4: null,
	    pedidos5: null
	  }),
	      _useState42 = _slicedToArray(_useState41, 2),
	      modulopedidos = _useState42[0],
	      setModulopedidos = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({
	    entrega1: null,
	    entrega2: null
	  }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      modulonataentrega = _useState44[0],
	      setModulonataentrega = _useState44[1];
	
	  var _useState45 = (0, _react.useState)({
	    antic1: null,
	    antic2: null,
	    antic3: null
	  }),
	      _useState46 = _slicedToArray(_useState45, 2),
	      moduloanticipo = _useState46[0],
	      setModuloanticipo = _useState46[1];
	
	  var _useState47 = (0, _react.useState)({
	    clients1: null,
	    clients2: null,
	    clients3: null
	  }),
	      _useState48 = _slicedToArray(_useState47, 2),
	      moduloclientes = _useState48[0],
	      setModuloclientes = _useState48[1];
	
	  var _useState49 = (0, _react.useState)({
	    config1: null,
	    config2: null,
	    config3: null
	  }),
	      _useState50 = _slicedToArray(_useState49, 2),
	      moduloconfigura = _useState50[0],
	      setModuloconfigura = _useState50[1];
	
	  var _useState51 = (0, _react.useState)({
	    compras1: null,
	    compras2: null
	  }),
	      _useState52 = _slicedToArray(_useState51, 2),
	      modulofcompras = _useState52[0],
	      setModulofcompras = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(false),
	      _useState54 = _slicedToArray(_useState53, 2),
	      mostrarClave = _useState54[0],
	      setMostrarClave = _useState54[1];
	
	  var _useState55 = (0, _react.useState)(false),
	      _useState56 = _slicedToArray(_useState55, 2),
	      mostrarClave1 = _useState56[0],
	      setMostrarClave1 = _useState56[1];
	
	  var _useState57 = (0, _react.useState)(false),
	      _useState58 = _slicedToArray(_useState57, 2),
	      deshabilitado = _useState58[0],
	      setDeshabilitado = _useState58[1];
	
	  var _useState59 = (0, _react.useState)(false),
	      _useState60 = _slicedToArray(_useState59, 2),
	      habilitadoNU = _useState60[0],
	      setHabilitadoNU = _useState60[1];
	
	  var _useState61 = (0, _react.useState)(0),
	      _useState62 = _slicedToArray(_useState61, 2),
	      operacion = _useState62[0],
	      setOperacion = _useState62[1];
	
	  var _useState63 = (0, _react.useState)(0),
	      _useState64 = _slicedToArray(_useState63, 2),
	      operacionPer = _useState64[0],
	      setOperacionPer = _useState64[1];
	
	  var _useState65 = (0, _react.useState)(),
	      _useState66 = _slicedToArray(_useState65, 2),
	      tecla = _useState66[0],
	      setTecla = _useState66[1];
	
	  var _useState67 = (0, _react.useState)(0),
	      _useState68 = _slicedToArray(_useState67, 2),
	      tabIndex = _useState68[0],
	      setTabIndex = _useState68[1];
	
	  var _useState69 = (0, _react.useState)(0),
	      _useState70 = _slicedToArray(_useState69, 2),
	      tabIndex1 = _useState70[0],
	      setTabIndex1 = _useState70[1];
	
	  var _useState71 = (0, _react.useState)(sessionStorage.getItem("fechasistema")),
	      _useState72 = _slicedToArray(_useState71, 2),
	      fechaSistema = _useState72[0],
	      setFechaSistema = _useState72[1];
	
	  var _useState73 = (0, _react.useState)(0),
	      _useState74 = _slicedToArray(_useState73, 2),
	      modu1 = _useState74[0],
	      setModu1 = _useState74[1];
	
	  var _useState75 = (0, _react.useState)(0),
	      _useState76 = _slicedToArray(_useState75, 2),
	      modu2 = _useState76[0],
	      setModu2 = _useState76[1];
	
	  var _useState77 = (0, _react.useState)(0),
	      _useState78 = _slicedToArray(_useState77, 2),
	      modu3 = _useState78[0],
	      setModu3 = _useState78[1];
	
	  var _useState79 = (0, _react.useState)(0),
	      _useState80 = _slicedToArray(_useState79, 2),
	      modu4 = _useState80[0],
	      setModu4 = _useState80[1];
	
	  var _useState81 = (0, _react.useState)(0),
	      _useState82 = _slicedToArray(_useState81, 2),
	      modu5 = _useState82[0],
	      setModu5 = _useState82[1];
	
	  var _useState83 = (0, _react.useState)(0),
	      _useState84 = _slicedToArray(_useState83, 2),
	      modu6 = _useState84[0],
	      setModu6 = _useState84[1];
	
	  var _useState85 = (0, _react.useState)(0),
	      _useState86 = _slicedToArray(_useState85, 2),
	      modu7 = _useState86[0],
	      setModu7 = _useState86[1];
	
	  var _useState87 = (0, _react.useState)(0),
	      _useState88 = _slicedToArray(_useState87, 2),
	      tipov = _useState88[0],
	      setTipov = _useState88[1];
	
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtRazon = (0, _react.useRef)();
	  var txtIdVendedor = (0, _react.useRef)();
	  var cmbCaja = (0, _react.useRef)();
	  var cmbStatus = (0, _react.useRef)();
	
	  var txtIdUsuario = (0, _react.useRef)();
	  var txtLogin = (0, _react.useRef)();
	  var txtPassword = (0, _react.useRef)();
	  var txtConfirmPassword = (0, _react.useRef)();
	  var txtIdAgente = (0, _react.useRef)();
	  var txtNombreAgente = (0, _react.useRef)();
	  var txtCedula = (0, _react.useRef)();
	  var txtNombreUsuario = (0, _react.useRef)();
	  var txtApellidoUsuario = (0, _react.useRef)();
	  var txtDireccionUsuario = (0, _react.useRef)();
	  var txtEmailUsuario = (0, _react.useRef)();
	  var txtTlfUsuario = (0, _react.useRef)();
	  var txtCelUsuario = (0, _react.useRef)();
	  var txtFechaNac = (0, _react.useRef)();
	  var cmbNacionalidad = (0, _react.useRef)();
	  var cmbSexo = (0, _react.useRef)();
	  var txtSincronizarsi = (0, _react.useRef)();
	  var txtSincronizarno = (0, _react.useRef)();
	  var txtPedidossi = (0, _react.useRef)();
	  var txtPedidosno = (0, _react.useRef)();
	  var txtNotasentregasi = (0, _react.useRef)();
	  var txtNotasentregano = (0, _react.useRef)();
	  var txtAnticipossi = (0, _react.useRef)();
	  var txtAnticiposno = (0, _react.useRef)();
	  var txtConfiguracionsi = (0, _react.useRef)();
	  var txtConfiguracionno = (0, _react.useRef)();
	  var txtTodosSincronizar = (0, _react.useRef)();
	  var txtTodosPedidos = (0, _react.useRef)();
	  var txtTodosnotasentrega = (0, _react.useRef)();
	  var txtTodosanticipos = (0, _react.useRef)();
	  var txtTodosConfiguracion = (0, _react.useRef)();
	  var txtRecibirProductos = (0, _react.useRef)();
	  var txtEnviarPedidos = (0, _react.useRef)();
	  var txtCrearPedidos = (0, _react.useRef)();
	  var txtListaPedidos = (0, _react.useRef)();
	  var txtListaPedidosClientes = (0, _react.useRef)();
	  var txtEditarPedido = (0, _react.useRef)();
	  var txtPedidoGnotaentrega = (0, _react.useRef)();
	  var txtListaNotasEntregas = (0, _react.useRef)();
	  var txtCrearAnticipos = (0, _react.useRef)();
	  var txtListaAnticipos = (0, _react.useRef)();
	  var txtImprimirAnticipos = (0, _react.useRef)();
	  var txtEliminarRegistros = (0, _react.useRef)();
	  var txtListaMonedas = (0, _react.useRef)();
	  var txtFactucompras = (0, _react.useRef)();
	  var txtListaFactucompras = (0, _react.useRef)();
	  var txtClientessi = (0, _react.useRef)();
	  var txtClientesno = (0, _react.useRef)();
	  var txtTodosClientes = (0, _react.useRef)();
	  var txtListaClientes = (0, _react.useRef)();
	  var txtDeudas = (0, _react.useRef)();
	  var txtComprassi = (0, _react.useRef)();
	  var txtComprasno = (0, _react.useRef)();
	  var txtTodosCompras = (0, _react.useRef)();
	  var txtVaciosapp = (0, _react.useRef)();
	  var txtVaciosClient = (0, _react.useRef)();
	  var txtPrestamoVacios = (0, _react.useRef)();
	  var txtObsequio = (0, _react.useRef)();
	  var txtCierreVacios = (0, _react.useRef)();
	  var txtCierreVaciosPlus = (0, _react.useRef)();
	  var txtTipoventasi = (0, _react.useRef)();
	  var txtTipoventano = (0, _react.useRef)();
	  var txtUbiCLientes = (0, _react.useRef)();
	
	  var procesarRegistro = function procesarRegistro() {
	    var endpoint = op.conexion + "/api/athos/usuarioapp/actualizar/" + operacion;
	
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setActivate(false);
	
	        var mensaje = "";
	        if (operacion === 1) {
	          mensaje = "El Usuario " + response.data.iduser + " ha sido Registrada Correctamente.";
	        } else if (operacion === 2) {
	          mensaje = "El usuario " + response.data.iduser + " ha sido Modificado Correctamente.";
	        } else if (operacion === 3) {
	          mensaje = "El usuario " + response.data.iduser + " ha sido Eliminado Correctamente.";
	        }
	
	        setMensaje({
	          mostrar: true,
	          titulo: "Exito.",
	          texto: mensaje,
	          icono: "exito"
	        });
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var datosRes = function datosRes(cedula) {
	    var campos = "*";
	    var nomtab = "persona";
	    var nomid = "cedula";
	
	    var endpoint = op.conexion + "/api/athos/consulta/modeli?campos=" + campos + "&id=" + cedula + "&nomtab=" + nomtab + "&nomid=" + nomid;
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (props.ingresa === 0) {
	          txtNombreUsuario.current.value = "";
	          txtApellidoUsuario.current.value = "";
	          txtDireccionUsuario.current.value = "";
	          txtEmailUsuario.current.value = "";
	          txtTlfUsuario.current.value = "";
	          txtCelUsuario.current.value = "";
	          txtFechaNac.current.value = "";
	          cmbNacionalidad.current.value = "V";
	          cmbSexo.current.value = "M";
	        }
	
	        setHabilitadoNU(true);
	
	        if (response.data !== "") {
	          setHabilitadoNU(false);
	          setOperacionPer(0);
	          txtNombreUsuario.current.value = response.data.nombres;
	          txtApellidoUsuario.current.value = response.data.apellidos;
	          txtDireccionUsuario.current.value = response.data.direccion;
	          txtEmailUsuario.current.value = response.data.correoe;
	          txtTlfUsuario.current.value = response.data.tlf1;
	          txtCelUsuario.current.value = response.data.tlf2;
	          txtFechaNac.current.value = (0, _moment2.default)(response.data.fnacimiento).format("YYYY-MM-DD");
	          cmbNacionalidad.current.value = response.data.nacionalidad;
	          cmbSexo.current.value = response.data.sexo;
	          if (tecla === 13) {
	            setTabIndex(1);
	            btnAcepta.current.focus();
	          }
	        } else {
	          setOperacionPer(1);
	          setHabilitadoNU(true);
	          if (tecla === 13) {
	            setTimeout(function () {
	              txtNombreUsuario.current.focus();
	            }, 100);
	          }
	        }
	      }
	
	      setActivate(false);
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseCatalogoPer = function handleCloseCatalogoPer() {
	    setMostrar3(false);
	  };
	
	  var handleAceptaCatalogoPer = function handleAceptaCatalogoPer(values) {
	    setMostrar3(false);
	    txtCedula.current.value = values.cedPer;
	    txtNombreUsuario.current.value = values.nomPer;
	    txtApellidoUsuario.current.value = values.apePer;
	    txtDireccionUsuario.current.value = values.direPer;
	    txtEmailUsuario.current.value = values.correoPer;
	    txtTlfUsuario.current.value = values.tlf1Per;
	    txtCelUsuario.current.value = values.tlf2Per;
	    txtFechaNac.current.value = (0, _moment2.default)(values.fnacPer).format("YYYY-MM-DD");
	    cmbNacionalidad.current.value = values.nacPer;
	    cmbSexo.current.value = values.sexoPer;
	    btnAcepta.current.focus();
	  };
	
	  var handleAceptaCatalogoOrg = function handleAceptaCatalogoOrg(values) {
	    setMostrar(false);
	    txtIdAgente.current.value = values.idorganizacion;
	    txtNombreAgente.current.value = values.nombre;
	    txtCedula.current.focus();
	  };
	
	  var blanquear = function blanquear() {
	    setPassword("");
	    setActivate(false);
	    setOperacionPer(0);
	    setModu1(0);
	    setModu2(0);
	    setModu3(0);
	    setModu4(0);
	    setModu5(0);
	    setModu6(0);
	    setTipov(0);
	    setModulosincroniza("");
	    setModulopedidos("");
	    setModulonataentrega("");
	    setModuloanticipo("");
	    setModuloclientes("");
	    setModuloconfigura("");
	    setModulofcompras("");
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    if (event.which === 13) {
	      var valido;
	      if (event.target.id === "inputCodigo") {
	        txtLogin.current.focus();
	      } else if (event.target.id === "inputLogin") {
	        txtPassword.current.focus();
	      } else if (event.target.id === "inputPassword") {
	        if (txtConfirmPassword.current.value !== "" && txtPassword.current.value !== txtConfirmPassword.current.value) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Las Contraseñas no coinciden.",
	            icono: "informacion"
	          });
	          txtPassword.current.focus();
	        } else {
	          txtConfirmPassword.current.focus();
	        }
	      } else if (event.target.id === "inputConfirmPassword") {
	        if (txtConfirmPassword.current.value !== "" && txtPassword.current.value !== txtConfirmPassword.current.value) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Las Contraseñas no coinciden.",
	            icono: "informacion"
	          });
	          txtConfirmPassword.current.focus();
	        } else {
	          txtIdAgente.current.focus();
	        }
	      } else if (event.target.id === "inputNomUsuario") {
	        txtApellidoUsuario.current.focus();
	      } else if (event.target.id === "inputApeUsuario") {
	        txtDireccionUsuario.current.focus();
	      } else if (event.target.id === "inputDireUsuario") {
	        txtEmailUsuario.current.focus();
	      } else if (event.target.id === "inputEmailUsuario") {
	        valido = (0, _varios.validaEmail)(event.target.value);
	        if (valido) {
	          txtTlfUsuario.current.focus();
	        } else {
	          if (event.target.value !== "") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "Formato de Email invalido.",
	              icono: "informacion"
	            });
	            event.target.value = "";
	          } else {
	            txtTlfUsuario.current.focus();
	          }
	        }
	      } else if (event.target.id === "inputTlfUsuario") {
	        txtCelUsuario.current.focus();
	      } else if (event.target.id === "inputCelUsuario") {
	        txtFechaNac.current.focus();
	      } else if (event.target.id === "inputFechaNac") {
	        cmbNacionalidad.current.focus();
	      }
	    } else if (typeof event.which === "undefined") {
	      if (event.target.id === "inputPassword") {
	        if (txtConfirmPassword.current.value !== "" && txtPassword.current.value !== txtConfirmPassword.current.value) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Las Contraseñas no coinciden.",
	            icono: "informacion"
	          });
	        }
	      } else if (event.target.id === "inputConfirmPassword") {
	        if (txtConfirmPassword.current.value !== "" && txtPassword.current.value !== txtConfirmPassword.current.value) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Las Contraseñas no coinciden.",
	            icono: "informacion"
	          });
	        }
	      } else if (event.target.id === "inputEmailUsuario") {
	        valido = (0, _varios.validaEmail)(event.target.value);
	        if (valido) {
	          txtTlfUsuario.current.focus();
	        } else {
	          if (event.target.value !== "") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "Formato de Email invalido.",
	              icono: "informacion"
	            });
	            event.target.value = "";
	          } else {
	            txtTlfUsuario.current.focus();
	          }
	        }
	      } else if (event.target.id === "inputTlfUsuario") {
	        txtCelUsuario.current.focus();
	      } else if (event.target.id === "inputCelUsuario") {
	        txtFechaNac.current.focus();
	      } else {
	        return false;
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var validarPersona = function validarPersona(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        setContar(0);
	        setTecla(event.which);
	        datosRes(event.target.value);
	      } else {
	        txtNombreUsuario.current.value = "";
	      }
	    }
	  };
	
	  var validarAgente = function validarAgente(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        setContar(0);
	        setTecla(event.which);
	        datosAgente(event.target.value);
	      } else {
	        txtNombreUsuario.current.value = "";
	      }
	    }
	  };
	
	  var datosAgente = function datosAgente(idagente) {
	    var campos = "*";
	    var nomtab = "organizacion";
	    var nomid = "idorganizacion";
	
	    var endpoint = op.conexion + "/api/athos/consulta/modeli?campos=" + campos + "&id=" + idagente + "&nomtab=" + nomtab + "&nomid=" + nomid;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data !== "") {
	          txtNombreAgente.current.value = response.data.nombre;
	          txtCedula.current.focus();
	          setContar(contar + 1);
	        } else {
	          txtNombreAgente.current.value = "";
	          txtIdAgente.current.value = "";
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "la organizacion no existe.",
	            icono: "informacion"
	          });
	        }
	      }
	
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	    var sigue = true;
	    var mensaje = "";
	
	    if (txtLogin.current.value.trim() === "") {
	      mensaje = "El Usuario no debe estar vacio";
	      sigue = false;
	      setTabIndex(0);
	      txtLogin.current.focus();
	    } else if (txtPassword.current.value.trim() === "" && operacion === 1) {
	      mensaje = "La Contraseña no debe estar vacia";
	      sigue = false;
	      setTabIndex(0);
	      txtPassword.current.focus();
	    } else if (txtConfirmPassword.current.value.trim() === "" && operacion === 1) {
	      mensaje = "La Confirmación de la Contraseña no debe estar vacia";
	      sigue = false;
	      setTabIndex(0);
	      txtConfirmPassword.current.focus();
	    } else if (txtPassword.current.value.trim() !== txtConfirmPassword.current.value.trim() && operacion === 1) {
	      mensaje = "Las Contraseñas no coinciden";
	      sigue = false;
	      setTabIndex(0);
	      txtConfirmPassword.current.focus();
	    } else if (txtCedula.current.value.trim() === "") {
	      mensaje = "La cedula no debe estar vacia";
	      sigue = false;
	      txtCedula.current.focus();
	    } else if (txtNombreUsuario.current.value.trim() === "") {
	      mensaje = "Los nombres no deben estar vacios";
	      sigue = false;
	      txtNombreUsuario.current.focus();
	    } else if (txtApellidoUsuario.current.value.trim() === "") {
	      mensaje = "Los Apellidos no deben estar vacio";
	      sigue = false;
	      txtApellidoUsuario.current.focus();
	    } else if (txtDireccionUsuario.current.value.trim() === "") {
	      mensaje = "La direccion del Usuario no debe estar vacia";
	      sigue = false;
	      txtDireccionUsuario.current.focus();
	    } else if (txtFechaNac.current.value.trim() === "") {
	      mensaje = "La fecha de nacimiento no debe estar vacia";
	      sigue = false;
	      txtFechaNac.current.focus();
	    }
	
	    if (sigue) {
	      var user = [];
	      var datoPer = [];
	      var parameter1 = "";
	      var parameter2 = "";
	      var parameter3 = "";
	      var parameter4 = "";
	      var parameter5 = "";
	      var parameter6 = "";
	      var parameter7 = "";
	      var parameter8 = "";
	      var parameter9 = "";
	      var parameter10 = "";
	
	      if (modu1 === 1 || modu2 === 1 || modu3 === 1 || modu4 === 1 || modu5 === 1 || modu6 === 1 || modu7) {
	
	        var val1 = txtSincronizarsi.current.checked === true ? "1" : "0";
	        var val2 = txtPedidossi.current.checked === true ? "1" : "0";
	        var val3 = txtNotasentregasi.current.checked === true ? "1" : "0";
	        var val4 = txtAnticipossi.current.checked === true ? "1" : "0";
	        var val5 = txtConfiguracionsi.current.checked === true ? "1" : "0";
	        var val6 = txtClientessi.current.checked === true ? "1" : "0";
	        var val7 = txtComprassi.current.checked === true ? "1" : "0";
	
	        parameter1 = val1 + val2 + val3 + val4 + val5 + val6 + val7;
	      } else {
	
	        parameter1 = '0000000';
	      }
	
	      if (modu1 === 1) {
	
	        var _val = txtRecibirProductos.current.checked === true ? "1" : "0";
	        var _val2 = txtEnviarPedidos.current.checked === true ? "1" : "0";
	
	        parameter2 = _val + _val2;
	      } else {
	
	        parameter2 = '0000';
	      }
	
	      if (modu2 === 1) {
	
	        var _val3 = txtCrearPedidos.current.checked === true ? "1" : "0";
	        var _val4 = txtListaPedidos.current.checked === true ? "1" : "0";
	        var _val5 = txtListaPedidosClientes.current.checked === true ? "1" : "0";
	        var _val6 = txtPedidoGnotaentrega.current.checked === true ? "1" : "0";
	        var _val7 = txtEditarPedido.current.checked === true ? "1" : "0";
	
	        parameter3 = _val3 + _val4 + _val5 + _val6 + _val7;
	      } else {
	
	        parameter3 = '00000';
	      }
	
	      if (modu3 === 1) {
	
	        var _val8 = txtListaNotasEntregas.current.checked === true ? "1" : "0";
	        var _val9 = txtObsequio.current.checked === true ? "1" : "0";
	
	        parameter10 = _val9;
	        parameter4 = _val8;
	      } else {
	
	        parameter10 = '0';
	        parameter4 = '0000';
	      }
	
	      if (modu4 === 1) {
	
	        var _val10 = txtCrearAnticipos.current.checked === true ? "1" : "0";
	        var _val11 = txtListaAnticipos.current.checked === true ? "1" : "0";
	        var _val12 = txtImprimirAnticipos.current.checked === true ? "1" : "0";
	
	        parameter5 = _val10 + _val11 + _val12;
	      } else {
	
	        parameter5 = '0000';
	      }
	
	      if (modu5 === 1) {
	
	        var _val13 = txtEliminarRegistros.current.checked === true ? "1" : "0";
	        var _val14 = txtListaMonedas.current.checked === true ? "1" : "0";
	        var _val15 = "0";
	
	        parameter6 = _val13 + _val14 + _val15;
	      } else {
	
	        parameter6 = '0000';
	      }
	
	      if (modu6 === 1) {
	
	        var _val16 = txtListaClientes.current.checked === true ? "1" : "0";
	        var _val17 = txtDeudas.current.checked === true ? "1" : "0";
	        var _val18 = txtUbiCLientes.current.checked === true ? "1" : "0";
	
	        parameter7 = _val16 + _val17 + _val18;
	      } else {
	
	        parameter7 = '0000';
	      }
	
	      if (modu7 === 1) {
	
	        var _val19 = txtFactucompras.current.checked === true ? "1" : "0";
	        var _val20 = txtListaFactucompras.current.checked === true ? "1" : "0";
	
	        parameter8 = _val19 + _val20;
	      } else {
	        parameter8 = '00000';
	      }
	
	      if (tabIndex1 === 1) {
	        var _val21 = txtVaciosapp.current.checked === true ? "1" : "0";
	        var _val22 = txtVaciosClient.current.checked === true ? "1" : "0";
	        var _val23 = txtCierreVacios.current.checked === true ? "1" : "0";
	        var _val24 = txtCierreVaciosPlus.current.checked === true ? "1" : "0";
	        var _val25 = txtPrestamoVacios.current.checked === true ? "1" : "0";
	
	        parameter9 = _val21 + _val22 + _val23 + _val24 + _val25;
	      } else {
	        parameter9 = '00000';
	      }
	
	      user.push(Object.assign({
	        idusuario: txtIdUsuario.current.value === "" ? "0" : txtIdUsuario.current.value,
	        login: txtLogin.current.value,
	        passwd: txtPassword.current.value,
	        persona: txtCedula.current.value,
	        status: cmbStatus.current.value
	      }, props.menu !== "sistema" && {
	        idagente: txtIdVendedor.current.value
	      }, props.menu !== "sistema" && { numcaja: cmbCaja.current.value }, {
	        idorganizacion: props.menu === "sistema" ? txtIdAgente.current.value : idorganizacion,
	        accaplicaciones: parameter1,
	        accpedidos: parameter3,
	        accnotaentregas: parameter4,
	        accconfig: parameter6,
	        accanticipos: parameter5,
	        accsincronizar: parameter2,
	        accclientes: parameter7,
	        acccompras: parameter8,
	        accvacios: parameter9,
	        obsequio: parameter10,
	        tipotransaccion: tipov
	      }));
	
	      datoPer.push({
	        apellidos: txtApellidoUsuario.current.value.trim(),
	        cedula: txtCedula.current.value,
	        correoe: txtEmailUsuario.current.value,
	        direccion: txtDireccionUsuario.current.value.trim(),
	        fnacimiento: txtFechaNac.current.value,
	        nacionalidad: cmbNacionalidad.current.value,
	        nombres: txtNombreUsuario.current.value.trim(),
	        sexo: cmbSexo.current.value,
	        tlf1: txtTlfUsuario.current.value,
	        tlf2: txtCelUsuario.current.value
	      });
	
	      setUsuario(user);
	      setPersona(datoPer);
	      setContar2(0);
	      var _body = {
	        operacionper: operacionPer,
	        usu: JSON.stringify(user),
	        perso: JSON.stringify(datoPer)
	      };
	      var _msg = "";
	      if (props.operacion === 1) {
	        _msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (props.operacion === 2) {
	        _msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (props.operacion === 3) {
	        _msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: _msg,
	        icono: "confirmacion"
	      });
	      setBody(_body);
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: mensaje,
	        icono: "informacion"
	      });
	    }
	  };
	
	  var seleccionarVendedor = function seleccionarVendedor(rif, desde) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = desde === 1 ? "idagente" : "rif";
	    var nomid2 = "vendedor";
	    var id = rif;
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200 && response.data !== "") {
	        txtIdVendedor.current.value = response.data.idagente;
	        cmbRif.current.value = response.data.rif.trim().substring(0, 1);
	        txtRif.current.value = response.data.rif.trim().substring(1, 10);
	        txtRazon.current.value = response.data.nombre.trim();
	      }
	      if (desde === 1) {
	        vaciosApp();
	      } else {
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      console.error(error);
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var onCatalogoCliente = function onCatalogoCliente(values) {
	    setCatalogoCliente(false);
	    txtRazon.current.value = "";
	    txtIdVendedor.current.value = "";
	    seleccionarVendedor(values.rif.trim(), 2);
	  };
	
	  var validarCliente = function validarCliente(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (cmbRif.current.value !== "" && event.target.value !== "") {
	        var rif = cmbRif.current.value + event.target.value;
	        txtRazon.current.value = "";
	        txtIdVendedor.current.value = "";
	        seleccionarVendedor(rif, 2);
	      }
	    }
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    props.render();
	    props.onHideAcepta();
	    blanquear();
	  };
	
	  var mostrarPassword = function mostrarPassword() {
	    return setMostrarClave(!mostrarClave);
	  };
	  var mostrarPassword1 = function mostrarPassword1() {
	    return setMostrarClave1(!mostrarClave1);
	  };
	
	  var handleChangeOtro = function handleChangeOtro(event) {
	
	    if (event.target.name === "tipoventa") {
	      if (txtTipoventasi.current.checked === true) {
	        setTipov(0);
	        setModu3(1);
	        setModulonataentrega({
	          entrega1: "0",
	          entrega2: "0"
	        });
	        txtNotasentregasi.current.checked = true;
	        txtNotasentregano.current.checked = false;
	      } else if (txtTipoventano.current.checked === true) {
	        setTipov(1);
	        setModu3(0);
	        setModulonataentrega({
	          entrega1: "0",
	          entrega2: "0"
	        });
	        txtNotasentregasi.current.checked = false;
	        txtNotasentregano.current.checked = true;
	      }
	    } else if (event.target.name === "permisincroniza") {
	      if (txtSincronizarsi.current.checked === true) {
	        setModu1(1);
	      } else if (txtSincronizarno.current.checked === true) {
	        setModu1(0);
	        setModulosincroniza({
	          sincro1: "0",
	          sincro2: "0"
	        });
	      }
	    } else if (event.target.name === "permipedidos") {
	      if (txtPedidossi.current.checked === true) {
	        setModu2(1);
	        setModulopedidos({
	          pedidos1: "0",
	          pedidos2: "0",
	          pedidos3: "0",
	          pedidos4: "0",
	          pedidos5: "0"
	        });
	      } else if (txtPedidosno.current.checked === true) {
	        setModu2(0);
	      }
	    } else if (event.target.name === 'perminotaentrega') {
	      if (txtNotasentregasi.current.checked === true) {
	        setModu3(1);
	        setModulonataentrega({
	          entrega1: "0",
	          entrega2: "0"
	        });
	      } else if (txtNotasentregano.current.checked === true) {
	        setModu3(0);
	      }
	    } else if (event.target.name === 'permianticipos') {
	      if (txtAnticipossi.current.checked === true) {
	        setModu4(1);
	        setModuloanticipo({
	          antic1: "0",
	          antic2: "0",
	          antic3: "0"
	        });
	      } else if (txtAnticiposno.current.checked === true) {
	        setModu4(0);
	      }
	    } else if (event.target.name === 'permiconfiguracion') {
	      if (txtConfiguracionsi.current.checked === true) {
	        setModu5(1);
	        setModuloconfigura({
	          config1: "0",
	          config2: "0",
	          config3: "0"
	        });
	      } else if (txtConfiguracionno.current.checked === true) {
	        setModu5(0);
	      }
	    } else if (event.target.name === 'permiclientes') {
	      if (txtClientessi.current.checked === true) {
	        setModu6(1);
	        setModuloclientes({
	          clients1: "0",
	          clients2: "0"
	        });
	      } else if (txtClientesno.current.checked === true) {
	        setModu6(0);
	      }
	    } else if (event.target.name === 'factucompras') {
	      if (txtComprassi.current.checked === true) {
	        setModu7(1);
	        setModulofcompras({
	          compras1: "0",
	          compras2: "0"
	        });
	      } else if (txtComprasno.current.checked === true) {
	        setModu7(0);
	      }
	    }
	  };
	
	  var checkBlank = function checkBlank(e) {
	
	    if (e.target.name === 'sincroniza' && modu1 === 1) {
	
	      if (txtRecibirProductos.current.checked && txtEnviarPedidos.current.checked) {
	        txtTodosSincronizar.current.checked = true;
	      } else {
	        txtTodosSincronizar.current.checked = false;
	      }
	    } else if (e.target.name === 'pedidos' && modu2 === 1) {
	
	      if (txtCrearPedidos.current.checked && txtListaPedidos.current.checked && txtListaPedidosClientes.current.checked && txtPedidoGnotaentrega.current.checked && txtEditarPedido.current.checked) {
	        txtTodosPedidos.current.checked = true;
	      } else {
	        txtTodosPedidos.current.checked = false;
	      }
	    } else if (e.target.name === 'notasentrega' && modu3 === 1) {
	
	      if (txtListaNotasEntregas.current.checked && txtObsequio.current.checked) {
	        txtTodosnotasentrega.current.checked = true;
	      } else {
	        txtTodosnotasentrega.current.checked = false;
	      }
	    } else if (e.target.name === 'anticipos' && modu4 === 1) {
	
	      if (txtCrearAnticipos.current.checked && txtListaAnticipos.current.checked && txtImprimirAnticipos.current.checked) {
	        txtTodosanticipos.current.checked = true;
	      } else {
	        txtTodosanticipos.current.checked = false;
	      }
	    } else if (e.target.name === 'configura' && modu5 === 1) {
	
	      if (txtEliminarRegistros.current.checked && txtListaMonedas.current.checked) {
	        txtTodosConfiguracion.current.checked = true;
	      } else {
	        txtTodosConfiguracion.current.checked = false;
	      }
	    } else if (e.target.name === 'clientes' && modu6 === 1) {
	
	      if (txtListaClientes.current.checked && txtDeudas.current.checked && txtUbiCLientes.current.checked) {
	        txtTodosClientes.current.checked = true;
	      } else {
	        txtTodosClientes.current.checked = false;
	      }
	    } else if (e.target.name === 'factucompra' && modu7 === 1) {
	      if (txtFactucompras.current.checked && txtListaFactucompras.current.checked) {
	        txtTodosCompras.current.checked = true;
	      } else {
	        txtTodosCompras.current.checked = false;
	      }
	    }
	  };
	
	  var checkTodo = function checkTodo(event) {
	    if (event.target.name === "todossincroniza") {
	      if (txtTodosSincronizar.current.checked) {
	        txtRecibirProductos.current.checked = true;
	        txtEnviarPedidos.current.checked = true;
	      } else {
	        txtRecibirProductos.current.checked = false;
	        txtEnviarPedidos.current.checked = false;
	      }
	    } else if (event.target.name === "todospedidos") {
	      if (txtTodosPedidos.current.checked) {
	        txtCrearPedidos.current.checked = true;
	        txtListaPedidos.current.checked = true;
	        txtListaPedidosClientes.current.checked = true;
	        txtPedidoGnotaentrega.current.checked = true;
	        txtEditarPedido.current.checked = true;
	      } else {
	        txtCrearPedidos.current.checked = false;
	        txtListaPedidos.current.checked = false;
	        txtListaPedidosClientes.current.checked = false;
	        txtPedidoGnotaentrega.current.checked = false;
	        txtEditarPedido.current.checked = false;
	      }
	    } else if (event.target.name === "todosnotaentregas") {
	      if (txtTodosnotasentrega.current.checked) {
	        txtListaNotasEntregas.current.checked = true;
	        txtObsequio.current.checked = true;
	      } else {
	        txtListaNotasEntregas.current.checked = false;
	        txtObsequio.current.checked = false;
	      }
	    } else if (event.target.name === "todosanticipos") {
	      if (txtTodosanticipos.current.checked) {
	        txtCrearAnticipos.current.checked = true;
	        txtListaAnticipos.current.checked = true;
	        txtImprimirAnticipos.current.checked = true;
	      } else {
	        txtCrearAnticipos.current.checked = false;
	        txtListaAnticipos.current.checked = false;
	        txtImprimirAnticipos.current.checked = false;
	      }
	    } else if (event.target.name === "todosconfigura") {
	      if (txtTodosConfiguracion.current.checked) {
	        txtEliminarRegistros.current.checked = true;
	        txtListaMonedas.current.checked = true;
	      } else {
	        txtEliminarRegistros.current.checked = false;
	        txtListaMonedas.current.checked = false;
	      }
	    } else if (event.target.name === 'todosclientes') {
	      if (txtTodosClientes.current.checked) {
	        txtListaClientes.current.checked = true;
	        txtDeudas.current.checked = true;
	        txtUbiCLientes.current.checked = true;
	      } else {
	        txtListaClientes.current.checked = false;
	        txtDeudas.current.checked = false;
	        txtUbiCLientes.current.checked = false;
	      }
	    } else if (event.target.name === 'todoscompras') {
	      if (txtTodosCompras.current.checked) {
	        txtFactucompras.current.checked = true;
	        txtListaFactucompras.current.checked = true;
	      } else {
	        txtFactucompras.current.checked = false;
	        txtListaFactucompras.current.checked = false;
	      }
	    }
	  };
	
	  var vaciosApp = function vaciosApp() {
	
	    var endpoint = op.conexion + "/api/consulta/vacios";
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.vacios !== "NO") {
	          setTabIndex1(1);
	          if (props.usuario.accvacios.toString().substring(0, 1) === "1") {
	            txtVaciosapp.current.checked = true;
	            if (props.usuario.accvacios.toString().substring(1, 2) === "1") {
	              txtVaciosClient.current.checked = true;
	            } else {
	              txtVaciosClient.current.checked = false;
	            }
	
	            if (props.usuario.accvacios.toString().substring(2, 3) === "1") {
	              txtCierreVacios.current.checked = true;
	            } else {
	              txtCierreVacios.current.checked = false;
	            }
	
	            if (props.usuario.accvacios.toString().substring(3, 4) === "1") {
	              txtCierreVaciosPlus.current.checked = true;
	            } else {
	              txtCierreVaciosPlus.current.checked = false;
	            }
	
	            if (props.usuario.accvacios.toString().substring(4, 5) === "1") {
	              txtPrestamoVacios.current.checked = true;
	            } else {
	              txtPrestamoVacios.current.checked = false;
	            }
	          } else {
	            txtVaciosapp.current.checked = false;
	            txtVaciosClient.current.checked = false;
	            txtCierreVacios.current.checked = false;
	            txtCierreVaciosPlus.current.checked = false;
	            txtPrestamoVacios.current.checked = false;
	          }
	        } else {
	          setTabIndex1(0);
	          txtVaciosapp.current.checked = false;
	          txtVaciosClient.current.checked = false;
	          txtCierreVacios.current.checked = false;
	          txtCierreVaciosPlus.current.checked = false;
	          txtPrestamoVacios.current.checked = false;
	        }
	      }
	
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	    });
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "xl",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        setOperacion(props.operacion);
	        setDeshabilitado(props.deshabilitado);
	        setTabIndex(0);
	        if (props.operacion !== 1) {
	
	          if (props.usuario.idagente !== null && props.usuario.idagente !== "") {
	            seleccionarVendedor(props.usuario.idagente, 1);
	          }
	
	          if (props.usuario.accaplicaciones !== "00000000") {
	
	            if (props.usuario.tipotransaccion === '1') {
	              txtTipoventasi.current.checked = false;
	              txtTipoventano.current.checked = true;
	              setTipov(1);
	            } else {
	              txtTipoventasi.current.checked = true;
	              txtTipoventano.current.checked = false;
	              setTipov(0);
	            }
	
	            if (props.usuario.accaplicaciones.toString().substring(0, 1) === "1") {
	
	              if (props.usuario && props.usuario.accsincronizar !== "") {
	                setModulosincroniza({
	                  sincro1: props.usuario.accsincronizar.toString().substring(0, 1),
	                  sincro2: props.usuario.accsincronizar.toString().substring(1, 2)
	                });
	              }
	
	              txtSincronizarsi.current.checked = true;
	              txtSincronizarno.current.checked = false;
	              setModu1(1);
	            } else {
	              txtSincronizarsi.current.checked = false;
	              txtSincronizarno.current.checked = true;
	              setModu1(0);
	            }
	
	            if (props.usuario.accaplicaciones.toString().substring(1, 2) === "1") {
	
	              if (props.usuario && props.usuario.accpedidos !== "") {
	                setModulopedidos({
	                  pedidos1: props.usuario.accpedidos.toString().substring(0, 1),
	                  pedidos2: props.usuario.accpedidos.toString().substring(1, 2),
	                  pedidos3: props.usuario.accpedidos.toString().substring(2, 3),
	                  pedidos4: props.usuario.accpedidos.toString().substring(4, 5),
	                  pedidos5: props.usuario.accpedidos.toString().substring(3, 4)
	                });
	              } else {}
	
	              txtPedidossi.current.checked = true;
	              txtPedidosno.current.checked = false;
	              setModu2(1);
	            } else {
	              txtPedidossi.current.checked = false;
	              txtPedidosno.current.checked = true;
	              setModu2(0);
	            }
	
	            if (props.usuario.accaplicaciones.toString().substring(2, 3) === "1") {
	
	              if (props.usuario && props.usuario.accnotaentregas !== "") {
	                setModulonataentrega({
	                  entrega1: props.usuario.accnotaentregas.toString().substring(0, 1),
	                  entrega2: props.usuario.obsequio.toString().substring(0, 1)
	                });
	              } else {}
	
	              txtNotasentregasi.current.checked = true;
	              txtNotasentregano.current.checked = false;
	              setModu3(1);
	            } else {
	              txtNotasentregasi.current.checked = false;
	              txtNotasentregano.current.checked = true;
	              setModu3(0);
	            }
	
	            if (props.usuario.accaplicaciones.toString().substring(3, 4) === "1") {
	
	              if (props.usuario && props.usuario.accanticipos !== "") {
	                setModuloanticipo({
	                  antic1: props.usuario.accanticipos.toString().substring(0, 1),
	                  antic2: props.usuario.accanticipos.toString().substring(1, 2),
	                  antic3: props.usuario.accanticipos.toString().substring(2, 3)
	                });
	              } else {}
	
	              txtAnticipossi.current.checked = true;
	              txtAnticiposno.current.checked = false;
	              setModu4(1);
	            } else {
	              txtAnticipossi.current.checked = false;
	              txtAnticiposno.current.checked = true;
	              setModu4(0);
	            }
	
	            if (props.usuario.accaplicaciones.toString().substring(4, 5) === "1") {
	
	              if (props.usuario && props.usuario.accconfig !== "") {
	                setModuloconfigura({
	                  config1: props.usuario.accconfig.toString().substring(0, 1),
	                  config2: props.usuario.accconfig.toString().substring(1, 2)
	                });
	              } else {}
	
	              txtConfiguracionsi.current.checked = true;
	              txtConfiguracionno.current.checked = false;
	              setModu5(1);
	            } else {
	              txtConfiguracionsi.current.checked = false;
	              txtConfiguracionno.current.checked = true;
	              setModu5(0);
	            }
	
	            if (props.usuario.accaplicaciones.toString().substring(5, 6) === "1") {
	
	              if (props.usuario && props.usuario.accclientes !== "") {
	                setModuloclientes({
	                  clients1: props.usuario.accclientes.toString().substring(0, 1),
	                  clients2: props.usuario.accclientes.toString().substring(1, 2),
	                  clients3: props.usuario.accclientes.toString().substring(2, 3)
	                });
	              } else {}
	
	              txtClientessi.current.checked = true;
	              txtClientesno.current.checked = false;
	              setModu6(1);
	            } else {
	              txtClientessi.current.checked = false;
	              txtClientesno.current.checked = true;
	              setModu6(0);
	            }
	
	            if (props.usuario.accaplicaciones.toString().substring(6, 7) === "1") {
	              if (props.usuario && props.usuario.acccompras !== "") {
	                setModulofcompras({
	                  compras1: props.usuario.acccompras.toString().substring(0, 1),
	                  compras2: props.usuario.acccompras.toString().substring(1, 2)
	                });
	              } else {}
	
	              txtComprassi.current.checked = true;
	              txtComprasno.current.checked = false;
	              setModu7(1);
	            } else {
	              txtComprassi.current.checked = false;
	              txtComprasno.current.checked = true;
	              setModu7(0);
	            }
	          }
	
	          setOperacionPer(0);
	        } else {
	          setModulosincroniza({
	            sincro1: "0",
	            sincro2: "0"
	          });
	          setModulopedidos({
	            pedidos1: "0",
	            pedidos2: "0",
	            pedidos3: "0",
	            pedidos4: "0",
	            pedidos5: "0"
	          });
	          setModulonataentrega({
	            entrega1: "0",
	            entrega2: "0"
	          });
	          setModuloanticipo({
	            antic1: "0",
	            antic2: "0",
	            antic3: "0"
	          });
	          setModuloclientes({
	            clients1: "0",
	            clients2: "0",
	            clients3: "0"
	          });
	          setModuloconfigura({
	            config1: "0",
	            config2: "0",
	            config3: "0"
	          });
	          setModulofcompras({
	            compras1: "0",
	            compras2: "0"
	          });
	          txtClientessi.current.checked = false;
	          txtClientesno.current.checked = true;
	          txtConfiguracionsi.current.checked = false;
	          txtConfiguracionno.current.checked = true;
	          txtAnticipossi.current.checked = false;
	          txtAnticiposno.current.checked = true;
	          txtNotasentregasi.current.checked = false;
	          txtNotasentregano.current.checked = true;
	          txtPedidossi.current.checked = false;
	          txtPedidosno.current.checked = true;
	          txtSincronizarsi.current.checked = false;
	          txtSincronizarno.current.checked = true;
	          txtComprassi.current.checked = false;
	          txtComprasno.current.checked = true;
	          txtTipoventasi.current.checked = false;
	          txtTipoventano.current.checked = true;
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          operacion === 1 ? "Registrar Usuario" : operacion === 2 ? "Modificar Usurario" : operacion === 3 ? "Eliminar Usuario" : "Consultar Usuario"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { padding: 0 } },
	      _react2.default.createElement(_catalogoCliente2.default, {
	        show: catalogoCliente,
	        nomid: "vendedor",
	        onHideCancelar: function onHideCancelar() {
	          return setCatalogoCliente(false);
	        },
	        onHideAceptaCatalogo: onCatalogoCliente
	      }),
	      _react2.default.createElement(_modalCambiarClaveApp.CambiarClaveApp, {
	        usuario: props.usuario && props.usuario.login.trim(),
	        show: mostrar2,
	        onHide: function onHide() {
	          setMostrar2(false);
	        }
	      }),
	      _react2.default.createElement(_catalogoPersona2.default, {
	        titulo: titulo,
	        mensaje: msg,
	        show: mostrar3,
	        onHideCancelaCatPer: handleCloseCatalogoPer,
	        onHideAceptaCatPer: handleAceptaCatalogoPer
	      }),
	      _react2.default.createElement(_catalogoOrganizacion2.default, {
	        show: mostrar,
	        onHideCancelar: function onHideCancelar() {
	          setMostrar(false);
	        },
	        onHideAceptaCatalogo: handleAceptaCatalogoOrg
	      }),
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({
	            mostrar: false,
	            titulo: "",
	            texto: "",
	            icono: ""
	          });
	        }
	      }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, {
	        mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	        },
	        onHideSi: handleCloseSi
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "" },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "ul",
	            { className: "nav nav-tabs mb-3", id: "ex-with-icons", role: "tablist" },
	            _react2.default.createElement(
	              "li",
	              { className: "nav-item", role: "presentation" },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "nav-link active ",
	                  style: { backgroundColor: "#25d366" },
	                  id: "ex-with-icons-tab-1",
	                  "data-mdb-toggle": "tab",
	                  href: "#tab-1",
	                  role: "tab",
	                  "aria-controls": "tab-1",
	                  "aria-selected": "true"
	                },
	                _react2.default.createElement("i", { className: "fas fa-user-edit fa-fw me-2" }),
	                "Usuario"
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { className: "nav-item", role: "presentation" },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "nav-link",
	                  id: "ex-with-icons-tab-2",
	                  style: { backgroundColor: "#55acee" },
	                  "data-mdb-toggle": "tab",
	                  href: "#tab-2",
	                  role: "tab",
	                  "aria-controls": "tab-2",
	                  "aria-selected": "false"
	                },
	                _react2.default.createElement("i", { className: "fas fa-vote-yea fa-fw me-2" }),
	                "Permisos Aplicaciones"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "tab-content", id: "ex-with-icons-content" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "tab-pane fade show active",
	                id: "tab-1",
	                role: "tabpanel",
	                "aria-labelledby": "ex-with-icons-tab-1"
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "container-fluid row  justify-content-between h-100 py-2 px-4  mx-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group py-1 input-group-sm col-sm-3" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    _react2.default.createElement("i", { className: "far fa-lg px-1 fa-id-card" }),
	                    "Codigo:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtIdUsuario,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: props.usuario ? props.usuario.idusuario : "",
	                    id: "inputCodigo",
	                    onKeyUp: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group py-1 input-group-sm col-sm-5" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-file-signature" }),
	                    "Nom. Usuario:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autocomplete: "off",
	                    disabled: operacion === 2 ? true : deshabilitado,
	                    ref: txtLogin,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: props.usuario ? props.usuario.login : "",
	                    id: "inputLogin",
	                    onKeyUp: handleInputChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group py-1 input-group-sm col-sm-3 px-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    " ",
	                    "Estatus"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      disabled: deshabilitado,
	                      ref: cmbStatus,
	                      className: "form-select",
	                      "aria-label": "Default select example",
	                      defaultValue: props.usuario ? props.usuario.status : ""
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "Activo"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "2" },
	                      "Inactivo"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group py-1 input-group-sm col-sm-6" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-unlock-alt" }),
	                    "Contrase\xF1a:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: mostrarClave ? "text" : "password",
	                    disabled: operacion === 2 ? true : deshabilitado,
	                    ref: txtPassword,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputPassword",
	                    onKeyUp: handleInputChange
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      style: { textAlign: "center", color: "white" },
	                      disabled: operacion === 2 ? true : deshabilitado,
	                      onClick: mostrarPassword,
	                      className: "btn btn-sm btn-info"
	                    },
	                    _react2.default.createElement("i", {
	                      disabled: deshabilitado,
	                      className: "fa fa-eye-slash"
	                    }),
	                    " "
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group py-1 input-group-sm col-sm-6" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-unlock-alt" }),
	                    "Confir. Contr.:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: mostrarClave1 ? "text" : "password",
	                    disabled: operacion === 2 ? true : deshabilitado,
	                    ref: txtConfirmPassword,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    id: "inputConfirmPassword",
	                    onKeyUp: handleInputChange
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      style: { textAlign: "center", color: "white" },
	                      disabled: operacion === 2 ? true : deshabilitado,
	                      onClick: mostrarPassword1,
	                      className: "btn btn-sm btn-info"
	                    },
	                    _react2.default.createElement("i", {
	                      disabled: deshabilitado,
	                      className: "fa fa-eye-slash"
	                    }),
	                    " "
	                  )
	                ),
	                _react2.default.createElement("div", { className: "col-md-12 py-1" }),
	                props.menu === "sistema" && _react2.default.createElement(
	                  "fieldset",
	                  { className: "row border-azul rounded mx-auto" },
	                  _react2.default.createElement(
	                    "legend",
	                    { className: "float-none m-0 w-auto" },
	                    "Organizaci\xF3n"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group py-1 input-group-sm col-sm-4" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      _react2.default.createElement("i", { className: "far fa-lg px-1 fa-id-card" }),
	                      "C\xF3digo:"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      disabled: deshabilitado,
	                      ref: txtIdAgente,
	                      className: "form-control",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm",
	                      id: "inputIdAgente",
	                      defaultValue: props.usuario ? props.usuario.idorganizacion : "",
	                      onKeyUp: validarAgente,
	                      onBlur: validarAgente
	                    }),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: deshabilitado,
	                        onClick: function onClick() {
	                          setMostrar(true);
	                        },
	                        className: "btn btn-sm  btn-success"
	                      },
	                      _react2.default.createElement("i", {
	                        disabled: deshabilitado,
	                        className: "fa fa-search"
	                      }),
	                      " "
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group py-1 input-group-sm col-sm-8" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-file-signature" }),
	                      "Nombres:"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      disabled: true,
	                      ref: txtNombreAgente,
	                      className: "form-control",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm",
	                      id: "inputNomUsuario",
	                      defaultValue: props.usuario ? props.usuario.nombreorg.trim() : ""
	                    })
	                  )
	                ),
	                props.menu !== "sistema" && _react2.default.createElement(
	                  "fieldset",
	                  { className: "row border-azul rounded mx-auto" },
	                  _react2.default.createElement(
	                    "legend",
	                    { className: "float-none m-0 w-auto" },
	                    "Vendedor"
	                  ),
	                  _react2.default.createElement("input", {
	                    ref: txtIdVendedor,
	                    type: "hidden",
	                    name: "idvendedor"
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "mb-1 col-pd-260" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        "Cedula/Rif"
	                      ),
	                      _react2.default.createElement(
	                        "select",
	                        {
	                          ref: cmbRif,
	                          name: "cmbrif",
	                          disabled: deshabilitado,
	                          className: "form-select form-select-sm text-center col-3",
	                          "aria-label": ".form-select-sm example"
	                        },
	                        _react2.default.createElement(
	                          "option",
	                          { value: "" },
	                          "--"
	                        ),
	                        cmbCedula && cmbCedula.map(function (item, index) {
	                          return _react2.default.createElement(
	                            "option",
	                            { key: index, value: item.value },
	                            " ",
	                            item.value,
	                            " "
	                          );
	                        })
	                      ),
	                      _react2.default.createElement("input", {
	                        ref: txtRif,
	                        autoComplete: "off",
	                        disabled: deshabilitado,
	                        maxLength: 9,
	                        type: "text",
	                        className: "form-control",
	                        name: "cedula",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        onKeyUp: validarCliente,
	                        onBlur: validarCliente
	                      }),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          disabled: deshabilitado,
	                          onClick: function onClick() {
	                            setCatalogoCliente(true);
	                          },
	                          className: "btn btn-success"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-search" })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group pb-1 input-group-sm col-sm-3 px-4" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "Caja:"
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        disabled: deshabilitado,
	                        ref: cmbCaja,
	                        className: "form-select",
	                        "aria-label": "numero de caja",
	                        defaultValue: props.usuario ? props.usuario.numcaja : ""
	                      },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "" },
	                        "--"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "01" },
	                        "01"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "02" },
	                        "02"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "03" },
	                        "03"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "04" },
	                        "04"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "05" },
	                        "05"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "06" },
	                        "06"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "07" },
	                        "07"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "08" },
	                        "08"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "09" },
	                        "09"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "10" },
	                        "10"
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2 col-md-12" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "Nombre/Raz\xF3n Social"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      autoComplete: "off",
	                      ref: txtRazon,
	                      disabled: true,
	                      name: "nombres",
	                      className: "form-control text-uppercase",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                ),
	                _react2.default.createElement("div", { className: "col-md-12 py-1" }),
	                _react2.default.createElement(
	                  "fieldset",
	                  { className: "row border-azul rounded mx-auto" },
	                  _react2.default.createElement(
	                    "legend",
	                    { className: "float-none m-0 w-auto" },
	                    "Datos Personales del Usuario"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "container col-md-12 row m-0" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group py-1 input-group-sm col-sm-3 px-1" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        _react2.default.createElement("i", { className: "far fa-lg px-1 fa-id-card" }),
	                        "Cedula:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        disabled: deshabilitado,
	                        style: { minWidth: 80, maxWidth: 80 },
	                        autoComplete: "off",
	                        maxLength: 8,
	                        ref: txtCedula,
	                        className: "form-control",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        id: "inputCedula",
	                        defaultValue: props.datospersonales ? props.datospersonales.cedula : "",
	                        onKeyUp: validarPersona,
	                        onBlur: validarPersona
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group py-1 input-group-sm col-sm-4 mx-auto px-2" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-map-marked-alt" }),
	                        "Nacionalidad:"
	                      ),
	                      _react2.default.createElement(
	                        "select",
	                        {
	                          disabled: !habilitadoNU,
	                          ref: cmbNacionalidad,
	                          style: { minWidth: 70, maxWidth: 70 },
	                          defaultValue: props.datospersonales ? props.datospersonales.nacionalidad : "",
	                          className: "form-select",
	                          "aria-label": "Default select example col-md-"
	                        },
	                        _react2.default.createElement(
	                          "option",
	                          { key: "0", value: "V" },
	                          "V"
	                        ),
	                        _react2.default.createElement(
	                          "option",
	                          { key: "1", value: "E" },
	                          "E"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group py-1 input-group-sm col-sm-2 ml-auto px-1" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text ml-2",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        "Sexo:"
	                      ),
	                      _react2.default.createElement(
	                        "select",
	                        {
	                          disabled: !habilitadoNU,
	                          ref: cmbSexo,
	                          defaultValue: props.datospersonales ? props.datospersonales.sexo : "",
	                          className: "form-select",
	                          "aria-label": "Default select example"
	                        },
	                        _react2.default.createElement(
	                          "option",
	                          { key: "0", value: "M" },
	                          "M"
	                        ),
	                        _react2.default.createElement(
	                          "option",
	                          { key: "1", value: "F" },
	                          "F"
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "container col-md-12 row m-0" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group py-1 input-group-sm col-sm-6 px-1" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-file-signature" }),
	                        "Nombres:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        disabled: !habilitadoNU,
	                        ref: txtNombreUsuario,
	                        className: "form-control",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        id: "inputNomUsuario",
	                        defaultValue: props.datospersonales ? props.datospersonales.nombres.trim() : "",
	                        onKeyUp: handleInputChange,
	                        onBlur: handleInputChange
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group py-1 input-group-sm col-sm-6 px-1" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-file-signature" }),
	                        "apellidos:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        disabled: !habilitadoNU,
	                        ref: txtApellidoUsuario,
	                        className: "form-control",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        id: "inputApeUsuario",
	                        defaultValue: props.datospersonales ? props.datospersonales.apellidos.trim() : "",
	                        onKeyUp: handleInputChange,
	                        onBlur: handleInputChange
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group py-1 input-group-sm col-sm-12 px-1" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-file-signature" }),
	                        "Direccion:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        disabled: !habilitadoNU,
	                        ref: txtDireccionUsuario,
	                        className: "form-control",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        id: "inputApeUsuario",
	                        defaultValue: props.datospersonales ? props.datospersonales.direccion.trim() : "",
	                        onKeyUp: handleInputChange,
	                        onBlur: handleInputChange
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "container col-md-12 row m-0" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group py-1 input-group-sm col-sm-4 px-1" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        _react2.default.createElement("i", { className: "far fa-lg px-1 fa-calendar-alt" }),
	                        "Fecha Nacimiento:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "date",
	                        disabled: !habilitadoNU,
	                        ref: txtFechaNac,
	                        className: "form-control px-0",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        id: "inputFechaNac",
	                        max: (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD"),
	                        defaultValue: props.datospersonales ? (0, _moment2.default)(props.datospersonales.fnacimiento).format("YYYY-MM-DD") : "",
	                        onKeyUp: handleInputChange
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group py-1 input-group-sm col-sm-4" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-phone" }),
	                        "Telefono:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        disabled: !habilitadoNU,
	                        ref: txtTlfUsuario,
	                        className: "form-control",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        id: "inputTlfUsuario",
	                        placeholder: "0000-0000000",
	                        defaultValue: props.datospersonales ? props.datospersonales.tlf1 !== null ? props.datospersonales.tlf1.trim() : "" : "",
	                        onKeyUp: handleInputChange,
	                        onBlur: handleInputChange
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group py-1 input-group-sm col-sm-4 px-1" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-mobile-alt" }),
	                        "Celular:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        disabled: !habilitadoNU,
	                        ref: txtCelUsuario,
	                        className: "form-control",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        id: "inputCelUsuario",
	                        placeholder: "0000-0000000",
	                        defaultValue: props.datospersonales ? props.datospersonales.tlf2 !== null ? props.datospersonales.tlf2.trim() : "" : "",
	                        onKeyUp: handleInputChange,
	                        onBlur: handleInputChange
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "container col-md-12 row m-0" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group py-1 input-group-sm col-sm-12 px-1" },
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "input-group-text",
	                          id: "inputGroup-sizing-sm"
	                        },
	                        " ",
	                        _react2.default.createElement("i", { className: "fas fa-lg px-1 fa-at" }),
	                        "E-mail:"
	                      ),
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        disabled: !habilitadoNU,
	                        ref: txtEmailUsuario,
	                        className: "form-control",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm",
	                        id: "inputEmailUsuario",
	                        defaultValue: props.datospersonales ? props.datospersonales.correoe !== null ? props.datospersonales.correoe.trim() : "" : "",
	                        onKeyUp: handleInputChange,
	                        onBlur: handleInputChange
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "tab-pane fade",
	                id: "tab-2",
	                role: "tabpanel",
	                "aria-labelledby": "ex-with-icons-tab-2"
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "container-fluid row  justify-content-between h-100 py-2 px-4  mx-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group col-sm-12 w-100" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-5" },
	                      "Tipo de Venta"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2 mb-1" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "tipoventa",
	                        disabled: deshabilitado,
	                        id: "inlineRadiotv",
	                        value: true,
	                        ref: txtTipoventasi,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadiotv" },
	                        "De Contado"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2 mb-1" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "tipoventa",
	                        disabled: deshabilitado,
	                        id: "inlineRadiotv1",
	                        value: false,
	                        ref: txtTipoventano,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadiotv1" },
	                        "Preventa"
	                      )
	                    ),
	                    _react2.default.createElement("div", null)
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group col-sm-12 w-100" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-5" },
	                      "Modulo Sincronizar"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2 mb-1" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permisincroniza",
	                        disabled: deshabilitado,
	                        id: "inlineRadio1",
	                        value: true,
	                        ref: txtSincronizarsi,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadio1" },
	                        "Disponible"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2 mb-1" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permisincroniza",
	                        disabled: deshabilitado,
	                        id: "inlineRadio2",
	                        value: false,
	                        ref: txtSincronizarno,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadio2" },
	                        "No Disponible"
	                      )
	                    ),
	                    modu1 === 1 ? _react2.default.createElement(
	                      "table",
	                      { className: "col-12 table table-sm table-bordered m-0 px-0" },
	                      _react2.default.createElement(
	                        "thead",
	                        { className: "col-12 m-0 px-0" },
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                type: "checkbox",
	                                disabled: deshabilitado,
	                                ref: txtTodosSincronizar,
	                                defaultChecked: modulosincroniza.sincro1 === "1" && modulosincroniza.sincro2 === "1" ? true : false,
	                                onChange: checkTodo,
	                                name: "todossincroniza",
	                                id: "inlineCheckbox"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineCheckbox"
	                                },
	                                "Todos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                type: "checkbox",
	                                disabled: deshabilitado,
	                                ref: txtRecibirProductos,
	                                defaultChecked: modulosincroniza.sincro1 === "1" ? true : false,
	                                onChange: checkBlank,
	                                name: "sincroniza",
	                                id: "inlineCheckbox1"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineCheckbox1"
	                                },
	                                "Recibir. Productos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                type: "checkbox",
	                                disabled: deshabilitado,
	                                ref: txtEnviarPedidos,
	                                defaultChecked: modulosincroniza.sincro2 === "1" ? true : false,
	                                onChange: checkBlank,
	                                name: "sincroniza",
	                                id: "inlineCheckbox2"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineCheckbox2"
	                                },
	                                "Enviar. Pedidos"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ) : "",
	                    _react2.default.createElement("div", null)
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group col-sm-12 w-100" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-5" },
	                      "Modulo Pedidos"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permipedidos",
	                        disabled: deshabilitado,
	                        id: "inlineRadiov1",
	                        value: true,
	                        ref: txtPedidossi,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadiov1" },
	                        "Disponible"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permipedidos",
	                        disabled: deshabilitado,
	                        id: "inlineRadiov2",
	                        value: false,
	                        ref: txtPedidosno,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadiov2" },
	                        "No Disponible"
	                      )
	                    ),
	                    modu2 === 1 ? _react2.default.createElement(
	                      "table",
	                      { className: "col-12 table table-sm table-bordered m-0 px-0" },
	                      _react2.default.createElement(
	                        "thead",
	                        { className: "col-12 m-0 px-0" },
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtTodosPedidos,
	                                disabled: deshabilitado,
	                                onChange: checkTodo,
	                                defaultChecked: modulopedidos.pedidos1 === "1" && modulopedidos.pedidos2 === "1" && modulopedidos.pedidos3 === "1" && modulopedidos.pedidos4 === "1" && modulopedidos.pedidos5 === "1" ? true : false,
	                                name: "todospedidos",
	                                type: "checkbox",
	                                id: "checkVentas"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVentas"
	                                },
	                                "Todos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtCrearPedidos,
	                                disabled: deshabilitado,
	                                defaultChecked: modulopedidos.pedidos1 === '1' ? true : false,
	                                onChange: checkBlank,
	                                type: "checkbox",
	                                name: "pedidos",
	                                id: "checkVentas1"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVentas1"
	                                },
	                                "Crear Pedido"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtListaPedidos,
	                                disabled: deshabilitado,
	                                defaultChecked: modulopedidos.pedidos2 === '1' ? true : false,
	                                onChange: checkBlank,
	                                type: "checkbox",
	                                name: "pedidos",
	                                id: "checkVentas2"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVentas2"
	                                },
	                                "Lista Pedidos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtListaPedidosClientes,
	                                disabled: deshabilitado,
	                                defaultChecked: modulopedidos.pedidos3 === '1' ? true : false,
	                                onChange: checkBlank,
	                                type: "checkbox",
	                                name: "pedidos",
	                                id: "checkVentas3"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVentas3"
	                                },
	                                "Lista Pedidos Pendientes"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtEditarPedido,
	                                disabled: deshabilitado,
	                                defaultChecked: modulopedidos.pedidos4 === '1' ? true : false,
	                                onChange: checkBlank,
	                                type: "checkbox",
	                                name: "pedidos",
	                                id: "checkVentas4"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVentas4"
	                                },
	                                "Editar Pedido On-Line"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtPedidoGnotaentrega,
	                                disabled: deshabilitado,
	                                defaultChecked: modulopedidos.pedidos5 === '1' ? true : false,
	                                onChange: checkBlank,
	                                type: "checkbox",
	                                name: "pedidos",
	                                id: "checkVentas5"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVentas5"
	                                },
	                                "Generar Nota de Entrega"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ) : "",
	                    _react2.default.createElement("div", null)
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group col-sm-12 w-100" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-5" },
	                      "Modulo Notas de Entrega"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "perminotaentrega",
	                        disabled: tipov !== 1 ? false : true,
	                        id: "inlineRadioc1",
	                        value: true,
	                        ref: txtNotasentregasi,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadioc1" },
	                        "Disponible"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "perminotaentrega",
	                        disabled: tipov !== 1 ? false : true,
	                        id: "inlineRadioc2",
	                        value: false,
	                        ref: txtNotasentregano,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadioc2" },
	                        "No Disponible"
	                      )
	                    ),
	                    modu3 === 1 ? _react2.default.createElement(
	                      "table",
	                      { className: "col-12 table table-sm table-bordered m-0 px-0" },
	                      _react2.default.createElement(
	                        "thead",
	                        { className: "col-12 m-0 px-0" },
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtTodosnotasentrega,
	                                disabled: deshabilitado,
	                                type: "checkbox",
	                                onChange: checkTodo,
	                                defaultChecked: modulonataentrega.entrega1 === '1' && modulonataentrega.entrega2 === '1' ? true : false,
	                                name: "todosnotaentregas",
	                                id: "checkCompras"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkCompras"
	                                },
	                                "Todos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtListaNotasEntregas,
	                                disabled: deshabilitado,
	                                defaultChecked: modulonataentrega.entrega1 === '1' ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                name: "notasentrega",
	                                id: "checkCompras1"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkCompras1"
	                                },
	                                "Lista Notas de Entrega"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtObsequio,
	                                disabled: deshabilitado,
	                                defaultChecked: modulonataentrega.entrega2 === '1' ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                name: "notasentrega",
	                                id: "checkCompras2"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkCompras2"
	                                },
	                                "Obsequi-Donaci\xF3n"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ) : "",
	                    _react2.default.createElement("div", null)
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group col-sm-12 w-100" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-5" },
	                      "Modulo Vacios"
	                    ),
	                    _react2.default.createElement(
	                      "table",
	                      { className: "col-12 table table-sm table-bordered m-0 px-0" },
	                      _react2.default.createElement(
	                        "thead",
	                        { className: "col-12 m-0 px-0" },
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtVaciosapp,
	                                disabled: tabIndex1 === 1 ? false : true,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                name: "vacios",
	                                id: "checkVacios1"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVacios1"
	                                },
	                                "Acceso a Vacios"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtVaciosClient,
	                                disabled: tabIndex1 === 1 ? false : true,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                name: "vacios",
	                                id: "checkVacios2"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVacios2"
	                                },
	                                "Lista Cientes Vacios"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtPrestamoVacios,
	                                disabled: tabIndex1 === 1 ? false : true,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                name: "vacios",
	                                id: "checkVacios5"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVacios5"
	                                },
	                                "Prestamo de Vacios"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtCierreVacios,
	                                disabled: tabIndex1 === 1 ? false : true,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                name: "vacios",
	                                id: "checkVacios3"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVacios3"
	                                },
	                                "Imprimir Cierre Vacios"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtCierreVaciosPlus,
	                                disabled: tabIndex1 === 1 ? false : true,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                name: "vacios",
	                                id: "checkVacios4"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkVacios4"
	                                },
	                                "Cierre Vacios Permiso Adicional"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("div", null)
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "border-azul col-sm-12 py-1 mb-1 d-flex justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group col-sm-12 w-100" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-5" },
	                      " Modulo Anticipos"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permianticipos",
	                        disabled: deshabilitado,
	                        id: "inlineRadiocb1",
	                        value: true,
	                        ref: txtAnticipossi,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "form-check-label",
	                          "for": "inlineRadiocb1"
	                        },
	                        "Disponible"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permianticipos",
	                        disabled: deshabilitado,
	                        id: "inlineRadiocb2",
	                        value: false,
	                        ref: txtAnticiposno,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "form-check-label",
	                          "for": "inlineRadiocb2"
	                        },
	                        "No Disponible"
	                      )
	                    ),
	                    modu4 === 1 ? _react2.default.createElement(
	                      "table",
	                      { className: "col-12 table table-sm table-bordered m-0 px-0" },
	                      _react2.default.createElement(
	                        "thead",
	                        { className: "col-12 m-0 px-0" },
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtTodosanticipos,
	                                disabled: deshabilitado,
	                                type: "checkbox",
	                                onChange: checkTodo,
	                                defaultChecked: moduloanticipo.antic1 === "1" && moduloanticipo.antic2 === "1" && moduloanticipo.antic3 === "1" ? true : false,
	                                name: "todosanticipos",
	                                id: "checkContabilidad"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkContabilidad"
	                                },
	                                "Todos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtCrearAnticipos,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloanticipo.antic1 === '1' ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                name: "anticipos",
	                                id: "checkContabilidad1"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkContabilidad1"
	                                },
	                                "Crear. Anticipo"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtListaAnticipos,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloanticipo.antic2 === '1' ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                name: "anticipos",
	                                id: "checkContabilidad2"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkContabilidad2"
	                                },
	                                "Lista Anticipos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtImprimirAnticipos,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloanticipo.antic3 === '1' ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                name: "anticipos",
	                                id: "checkContabilidad3"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "checkContabilidad3"
	                                },
	                                "Imprimir Anticipos por Vendedor"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ) : "",
	                    _react2.default.createElement("div", null)
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-sm-12 py-1 mb-1 border-azul d-flex justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group col-sm-12 w-100" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-5" },
	                      " Modulo Clientes"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permiclientes",
	                        disabled: deshabilitado,
	                        id: "inlineRadioCliente1",
	                        value: true,
	                        ref: txtClientessi,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadioCliente1" },
	                        "Disponible"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permiclientes",
	                        disabled: deshabilitado,
	                        id: "inlineRadioCliente2",
	                        value: false,
	                        ref: txtClientesno,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadioCliente2" },
	                        "No Disponible"
	                      )
	                    ),
	                    modu6 === 1 ? _react2.default.createElement(
	                      "table",
	                      { className: "col-12 table table-sm table-bordered m-0 px-0" },
	                      _react2.default.createElement(
	                        "thead",
	                        { className: "col-12 m-0 px-0" },
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtTodosClientes,
	                                disabled: deshabilitado,
	                                type: "checkbox",
	                                onChange: checkTodo,
	                                defaultChecked: moduloclientes.clients1 === '1' && moduloclientes.clients2 === '1' ? true : false,
	                                name: "todosclientes",
	                                id: "inlineClientes"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineClientes"
	                                },
	                                "Todos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtListaClientes,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloclientes.clients1 === '1' ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                name: "clientes",
	                                id: "inlineClientes1"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineClientes1"
	                                },
	                                "Lista Clientes"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtDeudas,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloclientes.clients2 === '1' ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                name: "clientes",
	                                id: "inlineClientes2"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineClientes2"
	                                },
	                                "Lista Clientes Deudas"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtUbiCLientes,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloclientes.clients3 === '1' ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                name: "clientes",
	                                id: "inlineClientes3"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineClientes3"
	                                },
	                                "Registrar Ubicaci\xF3n Clientes"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ) : "",
	                    _react2.default.createElement("div", null)
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-sm-12 py-1 mb-1 border-azul d-flex justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group col-sm-12 w-100" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-5" },
	                      " Modulo Facturas-Compra"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "factucompras",
	                        disabled: deshabilitado,
	                        id: "inlineRadioCompra1",
	                        value: true,
	                        ref: txtComprassi,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadioCompra1" },
	                        "Disponible"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "factucompras",
	                        disabled: deshabilitado,
	                        id: "inlineRadioCompra2",
	                        value: false,
	                        ref: txtComprasno,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadioCompra2" },
	                        "No Disponible"
	                      )
	                    ),
	                    modu7 === 1 ? _react2.default.createElement(
	                      "table",
	                      { className: "col-12 table table-sm table-bordered m-0 px-0" },
	                      _react2.default.createElement(
	                        "thead",
	                        { className: "col-12 m-0 px-0" },
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtTodosCompras,
	                                disabled: deshabilitado,
	                                type: "checkbox",
	                                onChange: checkTodo,
	                                defaultChecked: modulofcompras.compras1 === '1' && modulofcompras.compras2 === '1' ? true : false,
	                                name: "todoscompras",
	                                id: "inlineCompras"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineCompras"
	                                },
	                                "Todos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtFactucompras,
	                                disabled: deshabilitado,
	                                defaultChecked: modulofcompras.compras1 === '1' ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                name: "factucompra",
	                                id: "inlineCompras1"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineCompras1"
	                                },
	                                "Factura Compras"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtListaFactucompras,
	                                disabled: deshabilitado,
	                                defaultChecked: modulofcompras.compras2 === '1' ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                name: "factucompra",
	                                id: "inlineCompras2"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineCompras2"
	                                },
	                                "Lista Facturas-Compra"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ) : "",
	                    _react2.default.createElement("div", null)
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-sm-12 py-1 mb-1 border-azul d-flex justify-content-between" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group col-sm-12 w-100" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-5" },
	                      " Modulo Configuraci\xF3n"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permiconfiguracion",
	                        disabled: deshabilitado,
	                        id: "inlineRadiof1",
	                        value: true,
	                        ref: txtConfiguracionsi,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadiof1" },
	                        "Disponible"
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check col px-3 form-check-inline px-2" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input",
	                        type: "radio",
	                        name: "permiconfiguracion",
	                        disabled: deshabilitado,
	                        id: "inlineRadiof2",
	                        value: false,
	                        ref: txtConfiguracionno,
	                        onChange: handleChangeOtro
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", "for": "inlineRadiof2" },
	                        "No Disponible"
	                      )
	                    ),
	                    modu5 === 1 ? _react2.default.createElement(
	                      "table",
	                      { className: "col-12 table table-sm table-bordered m-0 px-0" },
	                      _react2.default.createElement(
	                        "thead",
	                        { className: "col-12 m-0 px-0" },
	                        _react2.default.createElement(
	                          "tr",
	                          null,
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtTodosConfiguracion,
	                                disabled: deshabilitado,
	                                type: "checkbox",
	                                onChange: checkTodo,
	                                defaultChecked: moduloconfigura.config1 === "1" && moduloconfigura.config2 === "1" ? true : false,
	                                name: "todosconfigura",
	                                id: "inlineFinanzas"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineFinanzas"
	                                },
	                                "Todos"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtEliminarRegistros,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloconfigura.config1 === '1' ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                name: "configura",
	                                id: "inlineFinanzas1"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineFinanzas1"
	                                },
	                                "Eliminar Registros"
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "th",
	                            { scope: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check form-check-inline" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input",
	                                ref: txtListaMonedas,
	                                disabled: deshabilitado,
	                                defaultChecked: moduloconfigura.config2 === '1' ? true : false,
	                                type: "checkbox",
	                                onChange: checkBlank,
	                                name: "configura",
	                                id: "inlineFinanzas2"
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  "for": "inlineFinanzas2"
	                                },
	                                "Lista Monedas"
	                              )
	                            )
	                          )
	                        )
	                      )
	                    ) : "",
	                    _react2.default.createElement("div", null)
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "col-sm-12 d-flex justify-content-end row mx-auto py-1" },
	        _react2.default.createElement(
	          "button",
	          {
	            type: "button",
	            onClick: function onClick() {
	              setMostrar2(true);
	            },
	            style: { visibility: operacion === 2 ? "visible" : "collapse" },
	            className: "btn col-sm-3 mx-1 btn-warning btn-sm rounded-pill"
	          },
	          _react2.default.createElement(
	            "i",
	            { className: "fas fa-key" },
	            " Cambiar Clave"
	          ),
	          " "
	        ),
	        _react2.default.createElement(
	          "button",
	          {
	            type: "button",
	            ref: btnAcepta,
	            disabled: operacion === 4 ? true : false,
	            onClick: onChangeValidar,
	            className: "col-sm-3 mx-1 btn-sm btn btn-success rounded-pill"
	          },
	          _react2.default.createElement("i", { className: "far fa-check-circle" }),
	          "Aceptar"
	        ),
	        _react2.default.createElement(
	          "button",
	          {
	            type: "button",
	            ref: btnCancela,
	            onClick: cancelar,
	            className: "col-sm-3 mx-1 btn-sm btn btn-danger rounded-pill"
	          },
	          _react2.default.createElement("i", { className: "fas fa-window-close" }),
	          "Cancelar"
	        )
	      )
	    )
	  );
	};
	exports.default = ModalActualizarUsuarioApp;

/***/ },
/* 7091 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RestaurarAuditoria = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/*
	 * Modal para armar el INSERT de los registros eliminados (ACCIÓN = DELETE) que
	 * se consultan en el modulo de Auditoria.
	 *
	 * Cada registro eliminado guarda en `valor_anterior` (jsonb) la fila completa
	 * que se borro de la tabla indicada en `tabla_afectada`. El modal muestra esos
	 * datos agrupados por tabla, permite seleccionar las filas y arma el INSERT que
	 * se copia para ejecutarlo en la base de datos y restaurarlas.
	 *
	 * Recibe:
	 *  - show:          muestra u oculta el modal
	 *  - registros:     arreglo con los registros de auditoria de accion DELETE
	 *  - onHideCancela: cierra el modal
	 */
	
	var esObjeto = function esObjeto(valor) {
	  return valor !== null && (typeof valor === "undefined" ? "undefined" : _typeof(valor)) === "object" && !Array.isArray(valor);
	};
	
	/*
	 * Los registros de auditoria pueden venir envueltos en el nombre de la tabla o
	 * en el tipo de dato, por ejemplo:
	 *   { data_nueva: { facturacompra: { numfactura: '8415332552', ... } } }
	 *   { facturacompra: { numfactura: '8415332552', ... } }
	 * Esta funcion quita esas envolturas (hasta 3 niveles), igual que el modulo de
	 * auditoria, para quedarse con los campos reales de la fila.
	 */
	var desenvolver = function desenvolver(valor, nivel) {
	  var nivelActual = nivel || 0;
	
	  if (nivelActual >= 3 || !esObjeto(valor)) {
	    return valor;
	  }
	
	  var claves = Object.keys(valor);
	  if (claves.length !== 1) {
	    return valor;
	  }
	
	  var interno = valor[claves[0]];
	  return esObjeto(interno) ? desenvolver(interno, nivelActual + 1) : valor;
	};
	
	/* Texto de una celda de la tabla (los objetos se muestran como JSON) */
	var valorTexto = function valorTexto(valor) {
	  if (valor === null || valor === undefined) {
	    return "";
	  }
	  if ((typeof valor === "undefined" ? "undefined" : _typeof(valor)) === "object") {
	    try {
	      return JSON.stringify(valor);
	    } catch (error) {
	      return String(valor);
	    }
	  }
	  return String(valor);
	};
	
	/* Valor de un campo de la fila (sin romper si la fila no es un objeto) */
	var datoDe = function datoDe(fila, columna) {
	  return esObjeto(fila.datos) ? fila.datos[columna] : undefined;
	};
	
	/* Literal SQL de un valor: NULL, numero, booleano o texto entre comillas */
	var valorSql = function valorSql(valor) {
	  if (valor === null || valor === undefined) {
	    return "NULL";
	  }
	  if (typeof valor === "boolean") {
	    return valor ? "true" : "false";
	  }
	  if (typeof valor === "number") {
	    return String(valor);
	  }
	  var texto = (typeof valor === "undefined" ? "undefined" : _typeof(valor)) === "object" ? JSON.stringify(valor) : String(valor);
	  return "'" + texto.replace(/'/g, "''") + "'";
	};
	
	/*
	 * Identificador SQL (tabla o columna). Se entrecomilla siempre para conservar
	 * el nombre exacto del campo y evitar problemas con palabras reservadas.
	 */
	var identificador = function identificador(nombre) {
	  return String(nombre).split(".").map(function (parte) {
	    return '"' + parte.replace(/"/g, '""') + '"';
	  }).join(".");
	};
	
	/* Fecha del registro de auditoria */
	var formatearFecha = function formatearFecha(valor) {
	  return valor ? (0, _moment2.default)(valor).format("DD-MM-YYYY hh:mm A") : "";
	};
	
	/* ------------------------- fin de los ayudantes ------------------------- */
	
	var RestaurarAuditoria = exports.RestaurarAuditoria = function RestaurarAuditoria(props) {
	  var show = props.show,
	      registros = props.registros,
	      onHideCancela = props.onHideCancela;
	
	  var _useState = (0, _react.useState)({}),
	      _useState2 = _slicedToArray(_useState, 2),
	      seleccion = _useState2[0],
	      setSeleccion = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(""),
	      _useState4 = _slicedToArray(_useState3, 2),
	      sql = _useState4[0],
	      setSql = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      copiado = _useState6[0],
	      setCopiado = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(""),
	      _useState8 = _slicedToArray(_useState7, 2),
	      aviso = _useState8[0],
	      setAviso = _useState8[1];
	
	  var sqlRef = (0, _react.useRef)(null);
	
	  var lista = Array.isArray(registros) ? registros : [];
	
	  /* Al abrir se seleccionan todos los registros y se limpia el INSERT */
	  (0, _react.useEffect)(function () {
	    if (!show) {
	      return;
	    }
	    var inicial = {};
	    lista.forEach(function (item, indice) {
	      inicial[indice] = true;
	    });
	    setSeleccion(inicial);
	    setSql("");
	    setCopiado(false);
	    setAviso("");
	  }, [show, registros]);
	
	  /* Al armar el INSERT se lleva la vista al bloque del SQL */
	  (0, _react.useEffect)(function () {
	    if (sql && sqlRef.current) {
	      sqlRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
	    }
	  }, [sql]);
	
	  /*
	   * Agrupa los registros por tabla afectada. De cada registro se toma el valor
	   * anterior (o `data` en la pestaña "Auditoría") ya desenvuelto, y se calculan
	   * las columnas como la union de los campos de todas las filas del grupo.
	   */
	  var grupos = [];
	  var indiceGrupos = {};
	  lista.forEach(function (item, indice) {
	    var tabla = String(item.tabla_afectada || item.nombretabla || "tabla").trim() || "tabla";
	
	    if (!indiceGrupos[tabla]) {
	      indiceGrupos[tabla] = { tabla: tabla, filas: [], columnas: [] };
	      grupos.push(indiceGrupos[tabla]);
	    }
	
	    var grupo = indiceGrupos[tabla];
	    var crudo = item.valor_anterior !== undefined && item.valor_anterior !== null ? item.valor_anterior : item.data;
	    var datos = desenvolver(crudo);
	
	    grupo.filas.push({
	      indice: indice,
	      fecha: formatearFecha(item.fecha_ve),
	      registro: item.registro_id !== undefined && item.registro_id !== null ? item.registro_id : item.idtabla,
	      datos: datos
	    });
	
	    if (esObjeto(datos)) {
	      Object.keys(datos).forEach(function (clave) {
	        if (grupo.columnas.indexOf(clave) < 0) {
	          grupo.columnas.push(clave);
	        }
	      });
	    }
	  });
	
	  var totalSeleccionados = lista.filter(function (item, indice) {
	    return seleccion[indice];
	  }).length;
	
	  var alternar = function alternar(indice) {
	    return function (e) {
	      var marcado = e.target.checked;
	      setSeleccion(function (anteriores) {
	        return Object.assign({}, anteriores, _defineProperty({}, indice, marcado));
	      });
	    };
	  };
	
	  var alternarGrupo = function alternarGrupo(filas, marcado) {
	    return function () {
	      setSeleccion(function (anteriores) {
	        var siguiente = Object.assign({}, anteriores);
	        filas.forEach(function (fila) {
	          siguiente[fila.indice] = marcado;
	        });
	        return siguiente;
	      });
	    };
	  };
	
	  /* Arma el INSERT de las filas seleccionadas, agrupadas por tabla */
	  var armarInsert = function armarInsert() {
	    var sentencias = [];
	    var sinDatos = [];
	
	    grupos.forEach(function (grupo) {
	      var elegidas = grupo.filas.filter(function (fila) {
	        return seleccion[fila.indice];
	      });
	      if (elegidas.length === 0) {
	        return;
	      }
	
	      var columnas = [];
	      var filasValidas = [];
	
	      elegidas.forEach(function (fila) {
	        if (!esObjeto(fila.datos) || Object.keys(fila.datos).length === 0) {
	          sinDatos.push(grupo.tabla + " (" + valorTexto(fila.registro) + ")");
	          return;
	        }
	        Object.keys(fila.datos).forEach(function (clave) {
	          if (columnas.indexOf(clave) < 0) {
	            columnas.push(clave);
	          }
	        });
	        filasValidas.push(fila);
	      });
	
	      if (filasValidas.length === 0) {
	        return;
	      }
	
	      var valores = filasValidas.map(function (fila) {
	        return "  (" + columnas.map(function (clave) {
	          return valorSql(fila.datos[clave]);
	        }).join(", ") + ")";
	      });
	
	      sentencias.push("INSERT INTO " + identificador(grupo.tabla) + " (" + columnas.map(identificador).join(", ") + ") VALUES\n" + valores.join(",\n") + ";");
	    });
	
	    if (sentencias.length === 0) {
	      setSql("");
	      setAviso("No hay datos en el valor anterior de los registros seleccionados.");
	      return;
	    }
	
	    setAviso(sinDatos.length > 0 ? "Se omitieron " + sinDatos.length + " registro(s) sin datos en el valor anterior: " + sinDatos.join(", ") + "." : "");
	    setSql(sentencias.join("\n\n"));
	  };
	
	  var copiarSql = function copiarSql() {
	    try {
	      if (navigator.clipboard) {
	        navigator.clipboard.writeText(sql);
	      }
	      setCopiado(true);
	      setTimeout(function () {
	        return setCopiado(false);
	      }, 1500);
	    } catch (error) {
	      /* si el navegador no permite copiar no se hace nada */
	    }
	  };
	
	  /* --------------------------- fin de la logica --------------------------- */
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      show: show,
	      onHide: onHideCancela,
	      size: "xl",
	      dialogClassName: "modal-auditoria-detalle",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      backdrop: "static",
	      keyboard: false,
	      scrollable: true
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "d-flex align-items-center" },
	        _react2.default.createElement("i", { className: "fas fa-trash-restore fa-fw me-2 fs-4 text-light" }),
	        _react2.default.createElement(
	          "div",
	          { className: "text-light" },
	          _react2.default.createElement(
	            "h6",
	            { className: "mb-0 fw-bold" },
	            "Restaurar registros eliminados (INSERT)"
	          ),
	          _react2.default.createElement(
	            "small",
	            { className: "fw-normal" },
	            "ACCI\xD3N DELETE \xB7 ",
	            lista.length,
	            " registro",
	            lista.length === 1 ? "" : "s",
	            " \xB7 ",
	            totalSeleccionados,
	            " seleccionado",
	            totalSeleccionados === 1 ? "" : "s"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: onHideCancela
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { className: "bg-light" },
	      lista.length === 0 ? _react2.default.createElement(
	        "p",
	        { className: "text-center mb-0" },
	        "Sin datos."
	      ) : _react2.default.createElement(
	        "div",
	        { className: "container-fluid px-0" },
	        _react2.default.createElement(
	          "span",
	          { className: "aud-seccion-titulo d-block" },
	          "Datos eliminados (valor anterior)"
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "small text-muted mb-2" },
	          "Seleccione las filas que desea restaurar. La columna TABLA indica la tabla afectada y las dem\xE1s columnas son los campos guardados en el valor anterior de cada registro de auditor\xEDa."
	        ),
	        grupos.map(function (grupo) {
	          var marcadas = grupo.filas.filter(function (fila) {
	            return seleccion[fila.indice];
	          }).length;
	          var todos = marcadas === grupo.filas.length;
	
	          return _react2.default.createElement(
	            "div",
	            { className: "mb-3", key: grupo.tabla },
	            _react2.default.createElement(
	              "div",
	              { className: "aud-ticket-cabecera" },
	              _react2.default.createElement("i", { className: "fas fa-table me-1" }),
	              _react2.default.createElement(
	                "span",
	                null,
	                grupo.tabla
	              ),
	              _react2.default.createElement(
	                "span",
	                { className: "ms-1 fw-normal" },
	                "(",
	                grupo.filas.length,
	                ")"
	              ),
	              _react2.default.createElement(
	                "span",
	                { className: "ms-auto fw-normal" },
	                marcadas,
	                " seleccionado",
	                marcadas === 1 ? "" : "s"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "aud-ticket-tabla-wrap" },
	              _react2.default.createElement(
	                "table",
	                { className: "aud-ticket-tabla" },
	                _react2.default.createElement(
	                  "thead",
	                  null,
	                  _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                      "th",
	                      { className: "aud-col-check" },
	                      _react2.default.createElement("input", {
	                        type: "checkbox",
	                        className: "form-check-input mt-0",
	                        checked: todos,
	                        ref: function ref(el) {
	                          if (el) {
	                            el.indeterminate = !todos && marcadas > 0;
	                          }
	                        },
	                        onChange: alternarGrupo(grupo.filas, !todos),
	                        title: "Seleccionar todo el grupo"
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "th",
	                      null,
	                      "FECHA"
	                    ),
	                    _react2.default.createElement(
	                      "th",
	                      null,
	                      "REGISTRO"
	                    ),
	                    grupo.columnas.map(function (columna) {
	                      return _react2.default.createElement(
	                        "th",
	                        { key: columna },
	                        columna
	                      );
	                    }),
	                    grupo.columnas.length === 0 && _react2.default.createElement(
	                      "th",
	                      null,
	                      "VALOR ANTERIOR"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "tbody",
	                  null,
	                  grupo.filas.map(function (fila) {
	                    return _react2.default.createElement(
	                      "tr",
	                      {
	                        key: fila.indice,
	                        className: seleccion[fila.indice] ? "aud-fila-marcada" : ""
	                      },
	                      _react2.default.createElement(
	                        "td",
	                        { className: "aud-col-check" },
	                        _react2.default.createElement("input", {
	                          type: "checkbox",
	                          className: "form-check-input mt-0",
	                          checked: !!seleccion[fila.indice],
	                          onChange: alternar(fila.indice)
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        null,
	                        fila.fecha
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        null,
	                        valorTexto(fila.registro)
	                      ),
	                      grupo.columnas.map(function (columna) {
	                        return _react2.default.createElement(
	                          "td",
	                          {
	                            key: columna,
	                            className: "aud-celda-dato",
	                            title: valorTexto(datoDe(fila, columna))
	                          },
	                          valorTexto(datoDe(fila, columna))
	                        );
	                      }),
	                      grupo.columnas.length === 0 && _react2.default.createElement(
	                        "td",
	                        { className: "text-muted" },
	                        "Sin datos"
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          );
	        }),
	        aviso ? _react2.default.createElement(
	          "div",
	          { className: "alert alert-warning py-1 px-2 small mb-2" },
	          _react2.default.createElement("i", { className: "fas fa-exclamation-triangle me-1" }),
	          aviso
	        ) : null,
	        sql ? _react2.default.createElement(
	          "div",
	          { className: "aud-json mt-2", ref: sqlRef },
	          _react2.default.createElement(
	            "div",
	            { className: "aud-json-cabecera" },
	            _react2.default.createElement(
	              "span",
	              { className: "aud-json-titulo" },
	              "INSERT para la base de datos"
	            ),
	            _react2.default.createElement(
	              "button",
	              {
	                type: "button",
	                className: "btn btn-sm btn-link py-0 px-1 text-decoration-none",
	                onClick: copiarSql,
	                title: "Copiar al portapapeles"
	              },
	              copiado ? _react2.default.createElement(
	                "span",
	                { className: "text-success" },
	                _react2.default.createElement("i", { className: "fas fa-check me-1" }),
	                "Copiado"
	              ) : _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement("i", { className: "far fa-copy me-1" }),
	                "Copiar"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "pre",
	            null,
	            sql
	          )
	        ) : null
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      { className: "py-1" },
	      _react2.default.createElement(
	        "span",
	        { className: "me-auto small text-muted" },
	        totalSeleccionados,
	        " de ",
	        lista.length,
	        " registro(s) seleccionado(s)"
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          type: "button",
	          className: "btn btn-sm btn-success rounded-pill px-3",
	          onClick: armarInsert,
	          disabled: lista.length === 0,
	          title: "Armar el INSERT con las filas seleccionadas"
	        },
	        _react2.default.createElement("i", { className: "fas fa-code me-1" }),
	        " Armar INSERT"
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          className: "btn btn-sm btn-primary rounded-pill px-4",
	          onClick: onHideCancela
	        },
	        "Cerrar"
	      )
	    )
	  );
	};

/***/ },
/* 7092 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VerAuditoria = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _tablaDetalleNota = __webpack_require__(7097);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Modal de detalle para el modulo de Auditoria.
	 *
	 * Recibe:
	 *  - show:       muestra u oculta el modal
	 *  - datos:      registro seleccionado (objeto). Si es null no se muestra nada.
	 *  - titulo:     titulo del registro (ej. "Registro UPDATE en facturacompra")
	 *  - subtitulo:  linea secundaria (ej. "audit_log · 24-09-2026 10:35 AM")
	 *  - icono:      clase del icono del encabezado (fontawesome)
	 *  - campos:     arreglo [{ label, valor }] con los datos planos del registro
	 *  - cambios:    arreglo [{ campo, anterior, nuevo }] con los campos modificados
	 *  - bloques:    arreglo [{ label, valor }] con los campos JSON (jsonb)
	 *  - comparacion: (opcional) arreglo de columnas [{ titulo, subtitulo, icono,
	 *                campos, bloques }] para mostrar lado a lado el registro de
	 *                auditoria y su respaldo. Si viene, reemplaza la ficha simple.
	 *  - onImprimir: si viene, se muestra el boton para imprimir el reporte
	 *  - onHideCancela: cierra el modal
	 */
	var VerAuditoria = exports.VerAuditoria = function VerAuditoria(props) {
	  var show = props.show,
	      onHideCancela = props.onHideCancela,
	      onImprimir = props.onImprimir,
	      datos = props.datos,
	      campos = props.campos,
	      cambios = props.cambios,
	      bloques = props.bloques,
	      comparacion = props.comparacion,
	      titulo = props.titulo,
	      subtitulo = props.subtitulo,
	      icono = props.icono;
	
	  var _useState = (0, _react.useState)(-1),
	      _useState2 = _slicedToArray(_useState, 2),
	      copiado = _useState2[0],
	      setCopiado = _useState2[1];
	
	  var formatearJson = function formatearJson(valor) {
	    if (valor === null || valor === undefined || valor === "") {
	      return "";
	    }
	    try {
	      return typeof valor === "string" ? JSON.stringify(JSON.parse(valor), null, 2) : JSON.stringify(valor, null, 2);
	    } catch (error) {
	      return String(valor);
	    }
	  };
	
	  var valorTexto = function valorTexto(valor) {
	    if (valor === null || valor === undefined || valor === "") {
	      return "-";
	    }
	    return (typeof valor === "undefined" ? "undefined" : _typeof(valor)) === "object" ? JSON.stringify(valor) : String(valor);
	  };
	
	  var copiar = function copiar(valor, indice) {
	    return function () {
	      try {
	        if (navigator.clipboard) {
	          navigator.clipboard.writeText(formatearJson(valor));
	        }
	        setCopiado(indice);
	        setTimeout(function () {
	          return setCopiado(-1);
	        }, 1500);
	      } catch (error) {
	        /* si el navegador no permite copiar no se hace nada */
	      }
	    };
	  };
	
	  /*
	   * Tarjeta de la comparacion con el respaldo. Muestra el encabezado, los
	   * datos de la cabecera y, si la columna trae renglones (`detalle`), el ticket
	   * de productos (codigo, nombre, cantidad, precio, IVA e importe + totales).
	   */
	  var tarjetaComparacion = function tarjetaComparacion(columna, key) {
	    return _react2.default.createElement(
	      "div",
	      { className: "aud-ticket", key: key },
	      _react2.default.createElement(
	        "div",
	        { className: "aud-ticket-cabecera" },
	        _react2.default.createElement("i", { className: (columna.icono || "fas fa-folder-open") + " me-1" }),
	        _react2.default.createElement(
	          "span",
	          null,
	          columna.titulo
	        )
	      ),
	      columna.subtitulo ? _react2.default.createElement(
	        "small",
	        { className: "aud-ticket-subtitulo d-block" },
	        columna.subtitulo
	      ) : null,
	      (columna.campos || []).length > 0 ? _react2.default.createElement(
	        "div",
	        { className: "aud-ficha aud-ficha-nota mt-2" },
	        (columna.campos || []).map(function (campo, i) {
	          return _react2.default.createElement(
	            "div",
	            { className: "aud-ficha-item", key: i },
	            _react2.default.createElement(
	              "span",
	              { className: "aud-ficha-label" },
	              campo.label
	            ),
	            _react2.default.createElement(
	              "span",
	              { className: "aud-ficha-valor" },
	              valorTexto(campo.valor)
	            )
	          );
	        })
	      ) : null,
	      (columna.bloques || []).map(function (bloque, i) {
	        return formatearJson(bloque.valor) === "" ? null : _react2.default.createElement(
	          "div",
	          { className: "aud-json mt-2", key: i },
	          _react2.default.createElement(
	            "div",
	            { className: "aud-json-cabecera" },
	            _react2.default.createElement(
	              "span",
	              { className: "aud-json-titulo" },
	              bloque.label
	            )
	          ),
	          _react2.default.createElement(
	            "pre",
	            null,
	            formatearJson(bloque.valor)
	          )
	        );
	      }),
	      columna.detalle !== undefined ? _react2.default.createElement(
	        "div",
	        { className: "aud-ticket-detalle" },
	        _react2.default.createElement(
	          "span",
	          { className: "aud-ticket-detalle-titulo" },
	          "Detalle de la nota"
	        ),
	        _react2.default.createElement(_tablaDetalleNota.TablaDetalleNota, { detalle: columna.detalle })
	      ) : null
	    );
	  };
	
	  var comparacionLista = comparacion || [];
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      show: show,
	      onHide: onHideCancela,
	      size: "lg",
	      dialogClassName: "modal-auditoria-detalle",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      backdrop: "static",
	      keyboard: false,
	      scrollable: true
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "d-flex align-items-center" },
	        _react2.default.createElement("i", {
	          className: (icono || "fas fa-search") + " fa-fw me-2 fs-4 text-light"
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "text-light" },
	          _react2.default.createElement(
	            "h6",
	            { className: "mb-0 fw-bold" },
	            titulo || "Detalle de Auditoría"
	          ),
	          subtitulo ? _react2.default.createElement(
	            "small",
	            { className: "fw-normal" },
	            subtitulo
	          ) : null
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: onHideCancela
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      {
	        className: "bg-light",
	        style: { maxHeight: "72vh", overflowY: "auto" }
	      },
	      !datos ? _react2.default.createElement(
	        "p",
	        { className: "text-center mb-0" },
	        "Sin datos."
	      ) : _react2.default.createElement(
	        "div",
	        { className: "container-fluid px-0" },
	        comparacionLista.length > 0 ? _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "span",
	            { className: "aud-seccion-titulo d-block" },
	            "Comparaci\xF3n con el respaldo"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "aud-comparacion" },
	            _react2.default.createElement(
	              "div",
	              { className: "aud-comparacion-registro" },
	              tarjetaComparacion(comparacionLista[0], "registro")
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "aud-comparacion-respaldos" },
	              comparacionLista.slice(1).map(function (columna, index) {
	                return tarjetaComparacion(columna, "respaldo-" + index);
	              })
	            )
	          )
	        ) : _react2.default.createElement(
	          _react2.default.Fragment,
	          null,
	          _react2.default.createElement(
	            "span",
	            { className: "aud-seccion-titulo d-block" },
	            "Datos del registro"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "aud-ficha" },
	            (campos || []).map(function (campo, index) {
	              return _react2.default.createElement(
	                "div",
	                { className: "aud-ficha-item", key: index },
	                _react2.default.createElement(
	                  "span",
	                  { className: "aud-ficha-label" },
	                  campo.label
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "aud-ficha-valor" },
	                  valorTexto(campo.valor)
	                )
	              );
	            })
	          ),
	          (cambios || []).length > 0 && _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "span",
	              { className: "aud-seccion-titulo d-block" },
	              "Campos modificados (",
	              cambios.length,
	              ")"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "table-responsive" },
	              _react2.default.createElement(
	                "table",
	                { className: "aud-cambios mb-0" },
	                _react2.default.createElement(
	                  "thead",
	                  null,
	                  _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                      "th",
	                      { style: { width: "30%" } },
	                      "Campo"
	                    ),
	                    _react2.default.createElement(
	                      "th",
	                      null,
	                      "Valor anterior"
	                    ),
	                    _react2.default.createElement(
	                      "th",
	                      null,
	                      "Valor nuevo"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "tbody",
	                  null,
	                  cambios.map(function (cambio, index) {
	                    return _react2.default.createElement(
	                      "tr",
	                      { key: index },
	                      _react2.default.createElement(
	                        "td",
	                        { className: "aud-campo" },
	                        cambio.campo
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { className: "aud-anterior" },
	                        valorTexto(cambio.anterior)
	                      ),
	                      _react2.default.createElement(
	                        "td",
	                        { className: "aud-nuevo" },
	                        valorTexto(cambio.nuevo)
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          ),
	          (bloques || []).map(function (bloque, index) {
	            return formatearJson(bloque.valor) === "" ? null : _react2.default.createElement(
	              "div",
	              { className: "aud-json mt-3", key: index },
	              _react2.default.createElement(
	                "div",
	                { className: "aud-json-cabecera" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "aud-json-titulo" },
	                  bloque.label
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    className: "btn btn-sm btn-link py-0 px-1 text-decoration-none",
	                    onClick: copiar(bloque.valor, index),
	                    title: "Copiar al portapapeles"
	                  },
	                  copiado === index ? _react2.default.createElement("i", { className: "fas fa-check text-success" }) : _react2.default.createElement("i", { className: "far fa-copy" })
	                )
	              ),
	              _react2.default.createElement(
	                "pre",
	                null,
	                formatearJson(bloque.valor)
	              )
	            );
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      { className: "py-1" },
	      typeof onImprimir === "function" ? _react2.default.createElement(
	        "button",
	        {
	          className: "btn btn-sm btn-outline-secondary rounded-pill px-3 me-auto",
	          onClick: onImprimir
	        },
	        _react2.default.createElement("i", { className: "fas fa-print me-1" }),
	        " Imprimir reporte"
	      ) : null,
	      _react2.default.createElement(
	        "button",
	        {
	          className: "btn btn-sm btn-primary rounded-pill px-4",
	          onClick: onHideCancela
	        },
	        "Cerrar"
	      )
	    )
	  );
	};

/***/ },
/* 7093 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mostrarReporteAuditoria = exports.abrirVentanaReporte = exports.crearDocumentoAuditoria = undefined;
	
	var _regenerator = __webpack_require__(69);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reportePickingPDF = __webpack_require__(675);
	
	var _reporteNotaEntregaRespaldoPDF = __webpack_require__(7094);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/*
	 * Reporte profesional de auditoria en PDF (react-pdf).
	 *
	 * Usa el mismo bundle que el reporte de Picking: public/lib/reactpdf.bundle.js
	 * (ver tools/reactpdf/README.md), cargado con cargarReactPDF().
	 *
	 * opciones = {
	 *   tipo,        'log' | 'historica' | 'eliminados'
	 *   registros,   arreglo con los registros consultados
	 *   filtros,     filtros aplicados en pantalla (tabla, accion, desde, hasta, ...)
	 *   detalle,     (opcional) resumen del registro: { titulo, subtitulo, campos, cambios, bloques }
	 *   comparacion, (opcional) solo en "Datos Eliminados": respaldo de la nota de
	 *                entrega con que se compara. Cuando viene informada, el reporte
	 *                se genera con el documento dedicado de nota de entrega (ver
	 *                reporteNotaEntregaRespaldoPDF.js); si no, el reporte generico
	 *                de auditoria.
	 *   metadatos,   { empresa, rif, usuario, urlLogo }
	 * }
	 *
	 * Si registros tiene un solo elemento se imprime el detalle del registro
	 * (datos, campos modificados y JSON); con varios, un listado con las columnas
	 * de la pestaña.
	 */
	
	var TIPOS = {
	  log: {
	    titulo: "REPORTE DE AUDITORÍA",
	    subtitulo: "Auditoría LOG (tabla audit_log)",
	    archivo: "Auditoria-LOG"
	  },
	  historica: {
	    titulo: "REPORTE DE AUDITORÍA",
	    subtitulo: "Auditoría (tabla auditoria)",
	    archivo: "Auditoria"
	  },
	  eliminados: {
	    titulo: "REPORTE DE DOCUMENTOS ELIMINADOS",
	    subtitulo: "Datos Eliminados (tabla auditadataeliminada)",
	    archivo: "Datos-Eliminados"
	  }
	};
	
	var texto = function texto(valor) {
	  if (valor === undefined || valor === null) return "";
	  if (valor instanceof Date) return (0, _moment2.default)(valor).format("DD-MM-YYYY hh:mm a");
	  if ((typeof valor === "undefined" ? "undefined" : _typeof(valor)) === "object") {
	    try {
	      return JSON.stringify(valor);
	    } catch (error) {
	      return "";
	    }
	  }
	  return String(valor);
	};
	
	var jsonTexto = function jsonTexto(valor) {
	  if (valor === null || valor === undefined || valor === "") return "";
	  try {
	    return typeof valor === "string" ? JSON.stringify(JSON.parse(valor), null, 2) : JSON.stringify(valor, null, 2);
	  } catch (error) {
	    return String(valor);
	  }
	};
	
	/* Descarga el logo de la organizacion para incrustarlo en el PDF (si falla,
	 * el reporte se genera igual sin logo). */
	var cargarLogo = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(url) {
	    var respuesta, bytes, binario, i, tipo;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            if (url) {
	              _context.next = 2;
	              break;
	            }
	
	            return _context.abrupt("return", null);
	
	          case 2:
	            _context.prev = 2;
	            _context.next = 5;
	            return _axios2.default.get(url, { responseType: "arraybuffer" });
	
	          case 5:
	            respuesta = _context.sent;
	            bytes = new Uint8Array(respuesta.data);
	            binario = "";
	
	            for (i = 0; i < bytes.length; i++) {
	              binario += String.fromCharCode(bytes[i]);
	            }
	            tipo = respuesta.headers && respuesta.headers["content-type"] || "image/png";
	            return _context.abrupt("return", "data:" + tipo + ";base64," + window.btoa(binario));
	
	          case 13:
	            _context.prev = 13;
	            _context.t0 = _context["catch"](2);
	            return _context.abrupt("return", null);
	
	          case 16:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined, [[2, 13]]);
	  }));
	
	  return function cargarLogo(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	/* Columnas del listado cuando el reporte lleva varios registros */
	var columnasListado = function columnasListado(tipo) {
	  if (tipo === "eliminados") {
	    return [{ label: "FECHA", flex: 1.6, valor: function valor(item) {
	        return item.fecha_ve ? (0, _moment2.default)(item.fecha_ve).format("DD-MM-YYYY hh:mm a") : "";
	      } }, { label: "DOCUMENTO", flex: 1.6, valor: function valor(item) {
	        return texto(item.numdocumento);
	      } }, { label: "STATUS", flex: 1.2, valor: function valor(item) {
	        return texto(item.status);
	      } }, { label: "USUARIO", flex: 1.2, valor: function valor(item) {
	        return texto(item.idusuario);
	      } }, { label: "REG. AUDITORÍA", flex: 1.2, valor: function valor(item) {
	        return texto(item.idauditoria);
	      } }];
	  }
	  return [{ label: "FECHA", flex: 1.6, valor: function valor(item) {
	      return item.fecha_ve ? (0, _moment2.default)(item.fecha_ve).format("DD-MM-YYYY hh:mm a") : "";
	    } }, { label: "ACCIÓN", flex: 1, valor: function valor(item) {
	      return texto(item.accion);
	    } }, { label: "TABLA", flex: 1.6, valor: function valor(item) {
	      return texto(tipo === "log" ? item.tabla_afectada : item.nombretabla);
	    } }, { label: "REGISTRO", flex: 1.4, valor: function valor(item) {
	      return texto(tipo === "log" ? item.registro_id : item.idtabla);
	    } }, { label: "USUARIO", flex: 1.6, valor: function valor(item) {
	      return texto(tipo === "log" ? item.usuario_id : item.usuario);
	    } }, { label: "DETALLE", flex: 2.4, valor: function valor(item) {
	      return texto(tipo === "log" ? (item.campos_cambiados || []).join(", ") : item.concepto);
	    } }];
	};
	
	var crearEstilos = function crearEstilos(StyleSheet) {
	  return StyleSheet.create({
	    pagina: {
	      paddingTop: 76,
	      paddingBottom: 40,
	      paddingHorizontal: 24,
	      fontSize: 8,
	      fontFamily: "Helvetica",
	      color: "#232323"
	    },
	    encabezado: {
	      position: "absolute",
	      top: 16,
	      left: 24,
	      right: 24,
	      flexDirection: "row",
	      justifyContent: "space-between",
	      alignItems: "flex-end",
	      borderBottomWidth: 1.5,
	      borderBottomColor: "#0b3d63",
	      paddingBottom: 5
	    },
	    encabezadoIzq: {
	      flexDirection: "row",
	      alignItems: "center"
	    },
	    logo: {
	      width: 46,
	      height: 46,
	      marginRight: 8,
	      objectFit: "contain"
	    },
	    titulo: {
	      fontSize: 14,
	      fontFamily: "Helvetica-Bold",
	      color: "#0b3d63"
	    },
	    subtitulo: {
	      fontSize: 8,
	      color: "#4d4d4d"
	    },
	    resumen: {
	      borderWidth: 1,
	      borderColor: "#d5dee6",
	      backgroundColor: "#f2f6fa",
	      paddingVertical: 5,
	      paddingHorizontal: 6,
	      marginBottom: 10
	    },
	    resumenTitulo: {
	      fontSize: 8,
	      fontFamily: "Helvetica-Bold",
	      color: "#0b3d63",
	      marginBottom: 3
	    },
	    resumenFila: {
	      flexDirection: "row",
	      flexWrap: "wrap"
	    },
	    meta: {
	      fontSize: 7.5,
	      color: "#4d4d4d",
	      marginRight: 12
	    },
	    seccion: {
	      marginBottom: 10
	    },
	    seccionTitulo: {
	      fontSize: 8.5,
	      fontFamily: "Helvetica-Bold",
	      color: "#0b3d63",
	      borderBottomWidth: 0.8,
	      borderBottomColor: "#d5dee6",
	      paddingBottom: 2,
	      marginBottom: 4
	    },
	    datos: {
	      flexDirection: "row",
	      flexWrap: "wrap"
	    },
	    dato: {
	      width: "50%",
	      paddingRight: 10,
	      marginBottom: 4
	    },
	    datoLabel: {
	      fontSize: 6.5,
	      color: "#6c757d"
	    },
	    datoValor: {
	      fontSize: 8,
	      fontFamily: "Helvetica-Bold",
	      color: "#232323"
	    },
	    filaTitulos: {
	      flexDirection: "row",
	      backgroundColor: "#0b3d63"
	    },
	    tituloColumna: {
	      fontSize: 7.5,
	      fontFamily: "Helvetica-Bold",
	      color: "#ffffff",
	      paddingVertical: 4,
	      paddingHorizontal: 3
	    },
	    fila: {
	      flexDirection: "row",
	      borderBottomWidth: 0.5,
	      borderBottomColor: "#dfe6ec"
	    },
	    filaPar: {
	      backgroundColor: "#f7f9fb"
	    },
	    celda: {
	      fontSize: 7.5,
	      paddingVertical: 3,
	      paddingHorizontal: 3
	    },
	    negrita: {
	      fontFamily: "Helvetica-Bold"
	    },
	    anterior: {
	      color: "#b00020"
	    },
	    nuevo: {
	      color: "#0b6b3a"
	    },
	    json: {
	      fontSize: 6.5,
	      color: "#333333",
	      backgroundColor: "#f7f9fb",
	      borderWidth: 0.5,
	      borderColor: "#d5dee6",
	      padding: 4
	    },
	    firmas: {
	      flexDirection: "row",
	      justifyContent: "space-between",
	      marginTop: 30
	    },
	    firma: {
	      width: "30%",
	      borderTopWidth: 0.8,
	      borderTopColor: "#8a99a8",
	      paddingTop: 3
	    },
	    firmaTexto: {
	      fontSize: 7,
	      color: "#5c6b7a",
	      textAlign: "center"
	    },
	    pieFijo: {
	      position: "absolute",
	      bottom: 16,
	      left: 24,
	      right: 24,
	      flexDirection: "row",
	      justifyContent: "space-between",
	      borderTopWidth: 0.5,
	      borderTopColor: "#d5dee6",
	      paddingTop: 3
	    },
	    pieTexto: {
	      fontSize: 7,
	      color: "#6c757d"
	    },
	    sinDatos: {
	      marginTop: 30,
	      textAlign: "center",
	      fontSize: 10,
	      color: "#6c757d"
	    }
	  });
	};
	
	var metaTexto = function metaTexto(nombre, valor, vacio) {
	  return nombre + ": " + (texto(valor) === "" ? vacio || "TODAS" : texto(valor));
	};
	
	/**
	 * Documento react-pdf del reporte de auditoria. R = window.ReactPDF
	 */
	var crearDocumentoAuditoria = exports.crearDocumentoAuditoria = function crearDocumentoAuditoria(R, opciones) {
	  var Document = R.Document,
	      Page = R.Page,
	      View = R.View,
	      Text = R.Text,
	      Image = R.Image;
	
	  var estilos = crearEstilos(R.StyleSheet);
	
	  var datos = opciones || {};
	  var tipo = TIPOS[datos.tipo] ? datos.tipo : "log";
	  var info = TIPOS[tipo];
	  var metadatos = datos.metadatos || {};
	  var filtros = datos.filtros || {};
	  var lista = Array.isArray(datos.registros) ? datos.registros : [];
	  var detalle = lista.length === 1 ? datos.detalle : null;
	
	  var campos = detalle && Array.isArray(detalle.campos) ? detalle.campos : [];
	  var cambios = detalle && Array.isArray(detalle.cambios) ? detalle.cambios : [];
	  var bloques = (detalle && Array.isArray(detalle.bloques) ? detalle.bloques : []).filter(function (bloque) {
	    return jsonTexto(bloque.valor) !== "";
	  });
	  var columnas = columnasListado(tipo);
	  var etiquetas = tipo === "eliminados" ? ["DOCUMENTO", "STATUS"] : ["TABLA", "ACCIÓN"];
	
	  return _react2.default.createElement(
	    Document,
	    {
	      title: info.titulo,
	      author: texto(metadatos.empresa),
	      subject: info.subtitulo,
	      creator: "ATHOS ERP",
	      producer: "ATHOS ERP"
	    },
	    _react2.default.createElement(
	      Page,
	      { size: "A4", orientation: "portrait", style: estilos.pagina },
	      _react2.default.createElement(
	        View,
	        { style: estilos.encabezado, fixed: true },
	        _react2.default.createElement(
	          View,
	          { style: estilos.encabezadoIzq },
	          metadatos.logo ? _react2.default.createElement(Image, { src: metadatos.logo, style: estilos.logo }) : null,
	          _react2.default.createElement(
	            View,
	            null,
	            _react2.default.createElement(
	              Text,
	              { style: estilos.titulo },
	              info.titulo
	            ),
	            _react2.default.createElement(
	              Text,
	              { style: estilos.subtitulo },
	              texto(metadatos.empresa)
	            ),
	            texto(metadatos.rif) === "" ? null : _react2.default.createElement(
	              Text,
	              { style: estilos.subtitulo },
	              "RIF: " + texto(metadatos.rif)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          View,
	          null,
	          _react2.default.createElement(
	            Text,
	            { style: estilos.subtitulo },
	            "Emitido: " + (0, _moment2.default)().format("DD-MM-YYYY hh:mm a")
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: estilos.subtitulo },
	            "Usuario: " + texto(metadatos.usuario)
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: estilos.subtitulo },
	            info.subtitulo
	          )
	        )
	      ),
	      _react2.default.createElement(
	        View,
	        { style: estilos.resumen },
	        _react2.default.createElement(
	          Text,
	          { style: estilos.resumenTitulo },
	          detalle ? "DETALLE DEL REGISTRO" : "LISTADO DE REGISTROS"
	        ),
	        _react2.default.createElement(
	          View,
	          { style: estilos.resumenFila },
	          _react2.default.createElement(
	            Text,
	            { style: estilos.meta },
	            metaTexto(etiquetas[0], filtros.tabla)
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: estilos.meta },
	            metaTexto(etiquetas[1], filtros.accion)
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: estilos.meta },
	            metaTexto("DESDE", filtros.desde, "-")
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: estilos.meta },
	            metaTexto("HASTA", filtros.hasta, "-")
	          ),
	          tipo === "eliminados" ? null : _react2.default.createElement(
	            Text,
	            { style: estilos.meta },
	            metaTexto("USUARIO", filtros.usuario)
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: estilos.meta },
	            "REGISTROS: " + lista.length
	          )
	        )
	      ),
	      lista.length === 0 && _react2.default.createElement(
	        Text,
	        { style: estilos.sinDatos },
	        "No hay informacion por mostrar"
	      ),
	      detalle && _react2.default.createElement(
	        View,
	        { style: estilos.seccion },
	        _react2.default.createElement(
	          Text,
	          { style: estilos.seccionTitulo },
	          texto(detalle.titulo).toUpperCase()
	        ),
	        _react2.default.createElement(
	          View,
	          { style: estilos.datos },
	          campos.map(function (campo, indice) {
	            return _react2.default.createElement(
	              View,
	              { style: estilos.dato, key: indice, wrap: false },
	              _react2.default.createElement(
	                Text,
	                { style: estilos.datoLabel },
	                texto(campo.label).toUpperCase()
	              ),
	              _react2.default.createElement(
	                Text,
	                { style: estilos.datoValor },
	                texto(campo.valor)
	              )
	            );
	          })
	        )
	      ),
	      cambios.length > 0 && _react2.default.createElement(
	        View,
	        { style: estilos.seccion },
	        _react2.default.createElement(
	          Text,
	          { style: estilos.seccionTitulo },
	          "CAMPOS MODIFICADOS (" + cambios.length + ")"
	        ),
	        _react2.default.createElement(
	          View,
	          { style: estilos.filaTitulos, wrap: false },
	          _react2.default.createElement(
	            Text,
	            { style: [estilos.tituloColumna, { flex: 1.6 }] },
	            "CAMPO"
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: [estilos.tituloColumna, { flex: 3 }] },
	            "VALOR ANTERIOR"
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: [estilos.tituloColumna, { flex: 3 }] },
	            "VALOR NUEVO"
	          )
	        ),
	        cambios.map(function (cambio, indice) {
	          return _react2.default.createElement(
	            View,
	            {
	              key: indice,
	              style: [estilos.fila, indice % 2 === 1 ? estilos.filaPar : null],
	              wrap: false
	            },
	            _react2.default.createElement(
	              Text,
	              { style: [estilos.celda, { flex: 1.6 }, estilos.negrita] },
	              texto(cambio.campo)
	            ),
	            _react2.default.createElement(
	              Text,
	              { style: [estilos.celda, { flex: 3 }, estilos.anterior] },
	              texto(cambio.anterior) === "" ? "-" : texto(cambio.anterior)
	            ),
	            _react2.default.createElement(
	              Text,
	              { style: [estilos.celda, { flex: 3 }, estilos.nuevo] },
	              texto(cambio.nuevo) === "" ? "-" : texto(cambio.nuevo)
	            )
	          );
	        })
	      ),
	      bloques.map(function (bloque, indice) {
	        return _react2.default.createElement(
	          View,
	          { style: estilos.seccion, key: indice },
	          _react2.default.createElement(
	            Text,
	            { style: estilos.seccionTitulo },
	            texto(bloque.label).toUpperCase()
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: estilos.json },
	            jsonTexto(bloque.valor)
	          )
	        );
	      }),
	      !detalle && lista.length > 0 && _react2.default.createElement(
	        View,
	        null,
	        _react2.default.createElement(
	          View,
	          { style: estilos.filaTitulos, wrap: false },
	          columnas.map(function (columna, indice) {
	            return _react2.default.createElement(
	              Text,
	              {
	                key: indice,
	                style: [estilos.tituloColumna, { flex: columna.flex }]
	              },
	              columna.label
	            );
	          })
	        ),
	        lista.map(function (item, indice) {
	          return _react2.default.createElement(
	            View,
	            {
	              key: indice,
	              style: [estilos.fila, indice % 2 === 1 ? estilos.filaPar : null],
	              wrap: false
	            },
	            columnas.map(function (columna, posicion) {
	              return _react2.default.createElement(
	                Text,
	                {
	                  key: posicion,
	                  style: [estilos.celda, { flex: columna.flex }]
	                },
	                columna.valor(item)
	              );
	            })
	          );
	        })
	      ),
	      _react2.default.createElement(
	        View,
	        { style: estilos.firmas, wrap: false },
	        _react2.default.createElement(
	          View,
	          { style: estilos.firma },
	          _react2.default.createElement(
	            Text,
	            { style: estilos.firmaTexto },
	            "ELABORADO POR"
	          )
	        ),
	        _react2.default.createElement(
	          View,
	          { style: estilos.firma },
	          _react2.default.createElement(
	            Text,
	            { style: estilos.firmaTexto },
	            "REVISADO POR"
	          )
	        ),
	        _react2.default.createElement(
	          View,
	          { style: estilos.firma },
	          _react2.default.createElement(
	            Text,
	            { style: estilos.firmaTexto },
	            "AUTORIZADO POR"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        View,
	        { style: estilos.pieFijo, fixed: true },
	        _react2.default.createElement(
	          Text,
	          { style: estilos.pieTexto },
	          "ATHOS ERP | " + info.subtitulo
	        ),
	        _react2.default.createElement(Text, {
	          style: estilos.pieTexto,
	          render: function render(_ref2) {
	            var pageNumber = _ref2.pageNumber,
	                totalPages = _ref2.totalPages;
	            return "Pagina " + pageNumber + " de " + totalPages;
	          }
	        })
	      )
	    )
	  );
	};
	
	/*
	 * Abre en blanco la ventana del reporte. Se llama en el clic del boton (no
	 * despues) para que el navegador no bloquee la ventana como popup.
	 */
	var abrirVentanaReporte = exports.abrirVentanaReporte = function abrirVentanaReporte() {
	  var ventana = window.open("", "ReporteAuditoria", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	
	  if (ventana) {
	    try {
	      ventana.document.write('<!doctype html><html><head><meta charset="utf-8">' + "<title>Reporte de Auditoria</title></head>" + '<body style="font-family:Arial,Helvetica,sans-serif;color:#0b3d63;' + 'text-align:center;margin-top:60px;font-size:15px">' + "Generando reporte, espere un momento...</body></html>");
	    } catch (error) {
	      /* si no se puede escribir se deja la ventana en blanco */
	    }
	  }
	
	  return ventana;
	};
	
	/*
	 * Muestra el PDF en la ventana del reporte. El visor de PDF del navegador ya
	 * trae su propio boton de impresion, por eso NO se abre el dialogo de
	 * impresion automaticamente (asi el reporte sale una sola vez).
	 */
	var mostrarPdf = function mostrarPdf(url, ventana) {
	  if (ventana && !ventana.closed) {
	    ventana.location.href = url;
	    return true;
	  }
	
	  var nueva = window.open(url, "ReporteAuditoria", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	
	  return !!(nueva && !nueva.closed);
	};
	
	/* Descarga el reporte cuando el navegador no permite abrir la ventana */
	var descargarPdf = function descargarPdf(url, nombre) {
	  var enlace = document.createElement("a");
	  enlace.href = url;
	  enlace.download = nombre;
	  document.body.appendChild(enlace);
	  enlace.click();
	  document.body.removeChild(enlace);
	};
	
	/**
	 * Genera el reporte de auditoria y lo muestra en la ventana indicada.
	 * opciones = { tipo, registros, filtros, detalle, metadatos }
	 * ventana  = ventana devuelta por abrirVentanaReporte() (opcional)
	 */
	var mostrarReporteAuditoria = exports.mostrarReporteAuditoria = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(opciones, ventana) {
	    var datos, metadatos, tipo, R, logo, opcionesDoc, comparacion, documento, blob, url;
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            datos = opciones || {};
	            metadatos = datos.metadatos || {};
	            tipo = TIPOS[datos.tipo] ? datos.tipo : "log";
	            _context2.next = 5;
	            return (0, _reportePickingPDF.cargarReactPDF)();
	
	          case 5:
	            R = _context2.sent;
	            _context2.next = 8;
	            return cargarLogo(metadatos.urlLogo);
	
	          case 8:
	            logo = _context2.sent;
	            opcionesDoc = Object.assign({}, datos, { metadatos: Object.assign({}, metadatos, { logo: logo }) });
	            comparacion = Array.isArray(datos.comparacion) ? datos.comparacion : [];
	
	            /* Cuando hay respaldo con que comparar (Datos Eliminados) se usa el reporte
	             * dedicado de nota de entrega (ver reporteNotaEntregaRespaldoPDF.js); en el
	             * resto de los casos, el reporte generico de auditoria. */
	
	            documento = comparacion.length > 0 ? (0, _reporteNotaEntregaRespaldoPDF.crearDocumentoNotaEntregaRespaldo)(R, opcionesDoc) : crearDocumentoAuditoria(R, opcionesDoc);
	            _context2.next = 14;
	            return R.pdf(documento).toBlob();
	
	          case 14:
	            blob = _context2.sent;
	            url = URL.createObjectURL(blob);
	
	
	            if (!mostrarPdf(url, ventana)) {
	              descargarPdf(url, TIPOS[tipo].archivo + "-" + (0, _moment2.default)().format("DD-MM-YYYY-hhmm") + ".pdf");
	            }
	
	            /* el PDF se libera cuando ya no se necesita */
	            setTimeout(function () {
	              return URL.revokeObjectURL(url);
	            }, 600000);
	
	          case 18:
	          case "end":
	            return _context2.stop();
	        }
	      }
	    }, _callee2, undefined);
	  }));
	
	  return function mostrarReporteAuditoria(_x2, _x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();

/***/ },
/* 7094 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.crearDocumentoNotaEntregaRespaldo = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _detalleNotaEntrega = __webpack_require__(298);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Reporte PDF (react-pdf) dedicado a la comparacion de una nota de entrega
	 * eliminada contra su respaldo (tablas notaentregarespaldo +
	 * notaentregadetallerespaldo).
	 *
	 * Se genera con el mismo bundle de react-pdf que el resto de reportes
	 * (public/lib/reactpdf.bundle.js) y se muestra/imprime desde
	 * reporteAuditoriaPDF.mostrarReporteAuditoria cuando la opcion `comparacion`
	 * viene informada (ver src/components/configuracionGeneral/auditoria.js).
	 *
	 * opciones = {
	 *   registros,   arreglo con los registros consultados (incluye el eliminado)
	 *   filtros,     filtros aplicados en pantalla (documento, status, desde, hasta)
	 *   comparacion, arreglo [{ tipo, titulo, subtitulo, icono, campos, nota, detalle }]
	 *                el primero es el registro de auditoria y el resto los respaldos
	 *   metadatos,   { empresa, rif, usuario, logo }
	 * }
	 */
	
	var texto = function texto(valor) {
	  if (valor === undefined || valor === null) {
	    return "";
	  }
	  if (valor instanceof Date) {
	    return (0, _moment2.default)(valor).format("DD-MM-YYYY hh:mm a");
	  }
	  if ((typeof valor === "undefined" ? "undefined" : _typeof(valor)) === "object") {
	    try {
	      return JSON.stringify(valor);
	    } catch (error) {
	      return "";
	    }
	  }
	  return String(valor);
	};
	
	var metaTexto = function metaTexto(nombre, valor, vacio) {
	  return nombre + ": " + (texto(valor) === "" ? vacio || "TODAS" : texto(valor));
	};
	
	var crearEstilos = function crearEstilos(StyleSheet) {
	  return StyleSheet.create({
	    pagina: {
	      paddingTop: 76,
	      paddingBottom: 40,
	      paddingHorizontal: 24,
	      fontSize: 8,
	      fontFamily: "Helvetica",
	      color: "#232323"
	    },
	    encabezado: {
	      position: "absolute",
	      top: 16,
	      left: 24,
	      right: 24,
	      flexDirection: "row",
	      justifyContent: "space-between",
	      alignItems: "flex-end",
	      borderBottomWidth: 1.5,
	      borderBottomColor: "#0b3d63",
	      paddingBottom: 5
	    },
	    encabezadoIzq: {
	      flexDirection: "row",
	      alignItems: "center"
	    },
	    logo: {
	      width: 46,
	      height: 46,
	      marginRight: 8,
	      objectFit: "contain"
	    },
	    titulo: {
	      fontSize: 14,
	      fontFamily: "Helvetica-Bold",
	      color: "#0b3d63"
	    },
	    subtitulo: {
	      fontSize: 8,
	      color: "#4d4d4d"
	    },
	    barra: {
	      borderWidth: 1,
	      borderColor: "#d5dee6",
	      backgroundColor: "#f2f6fa",
	      paddingVertical: 5,
	      paddingHorizontal: 6,
	      marginBottom: 10
	    },
	    barraTitulo: {
	      fontSize: 8,
	      fontFamily: "Helvetica-Bold",
	      color: "#0b3d63",
	      marginBottom: 3
	    },
	    barraFila: {
	      flexDirection: "row",
	      flexWrap: "wrap"
	    },
	    meta: {
	      fontSize: 7.5,
	      color: "#4d4d4d",
	      marginRight: 12
	    },
	    seccion: {
	      marginBottom: 12
	    },
	    seccionTitulo: {
	      fontSize: 9,
	      fontFamily: "Helvetica-Bold",
	      color: "#ffffff",
	      backgroundColor: "#0b3d63",
	      paddingVertical: 3,
	      paddingHorizontal: 5,
	      marginBottom: 5
	    },
	    datos: {
	      flexDirection: "row",
	      flexWrap: "wrap"
	    },
	    dato: {
	      width: "33.33%",
	      paddingRight: 10,
	      marginBottom: 4
	    },
	    datoLabel: {
	      fontSize: 6.5,
	      color: "#6c757d"
	    },
	    datoValor: {
	      fontSize: 8,
	      fontFamily: "Helvetica-Bold",
	      color: "#232323"
	    },
	    filaTitulos: {
	      flexDirection: "row",
	      backgroundColor: "#055182",
	      marginTop: 4
	    },
	    tituloColumna: {
	      fontSize: 7.5,
	      fontFamily: "Helvetica-Bold",
	      color: "#ffffff",
	      paddingVertical: 4,
	      paddingHorizontal: 4
	    },
	    fila: {
	      flexDirection: "row",
	      borderBottomWidth: 0.5,
	      borderBottomColor: "#dfe6ec"
	    },
	    filaPar: {
	      backgroundColor: "#f7f9fb"
	    },
	    celda: {
	      fontSize: 7.5,
	      paddingVertical: 3,
	      paddingHorizontal: 4
	    },
	    celdaDer: {
	      textAlign: "right"
	    },
	    negrita: {
	      fontFamily: "Helvetica-Bold"
	    },
	    filaTotal: {
	      flexDirection: "row",
	      borderTopWidth: 1,
	      borderTopColor: "#0b3d63",
	      backgroundColor: "#eef3f8"
	    },
	    celdaTotal: {
	      fontSize: 8,
	      fontFamily: "Helvetica-Bold",
	      color: "#0b3d63",
	      paddingVertical: 4,
	      paddingHorizontal: 4
	    },
	    sinDetalle: {
	      fontSize: 7.5,
	      color: "#6c757d",
	      marginTop: 3
	    },
	    firmas: {
	      flexDirection: "row",
	      justifyContent: "space-between",
	      marginTop: 30
	    },
	    firma: {
	      width: "30%",
	      borderTopWidth: 0.8,
	      borderTopColor: "#8a99a8",
	      paddingTop: 3
	    },
	    firmaTexto: {
	      fontSize: 7,
	      color: "#5c6b7a",
	      textAlign: "center"
	    },
	    pieFijo: {
	      position: "absolute",
	      bottom: 16,
	      left: 24,
	      right: 24,
	      flexDirection: "row",
	      justifyContent: "space-between",
	      borderTopWidth: 0.5,
	      borderTopColor: "#d5dee6",
	      paddingTop: 3
	    },
	    pieTexto: {
	      fontSize: 7,
	      color: "#6c757d"
	    },
	    sinDatos: {
	      marginTop: 30,
	      textAlign: "center",
	      fontSize: 10,
	      color: "#6c757d"
	    }
	  });
	};
	
	/*
	 * Documento react-pdf del reporte de comparacion de una nota de entrega
	 * eliminada contra su respaldo. R = window.ReactPDF
	 */
	var crearDocumentoNotaEntregaRespaldo = exports.crearDocumentoNotaEntregaRespaldo = function crearDocumentoNotaEntregaRespaldo(R, opciones) {
	  var Document = R.Document,
	      Page = R.Page,
	      View = R.View,
	      Text = R.Text,
	      Image = R.Image;
	
	  var estilos = crearEstilos(R.StyleSheet);
	
	  var datos = opciones || {};
	  var metadatos = datos.metadatos || {};
	  var filtros = datos.filtros || {};
	  var lista = Array.isArray(datos.registros) ? datos.registros : [];
	  var comparacion = Array.isArray(datos.comparacion) ? datos.comparacion : [];
	
	  var registro = comparacion.filter(function (columna) {
	    return columna.tipo === "auditoria";
	  })[0] || comparacion[0] || null;
	  var respaldos = comparacion.filter(function (columna) {
	    return columna.tipo === "notaentrega";
	  });
	  var camposRegistro = registro && Array.isArray(registro.campos) ? registro.campos : [];
	
	  return _react2.default.createElement(
	    Document,
	    {
	      title: "Reporte de Nota de Entrega (Respaldo)",
	      author: texto(metadatos.empresa),
	      subject: "Datos Eliminados (tabla auditadataeliminada)",
	      creator: "ATHOS ERP",
	      producer: "ATHOS ERP"
	    },
	    _react2.default.createElement(
	      Page,
	      { size: "A4", orientation: "portrait", style: estilos.pagina },
	      _react2.default.createElement(
	        View,
	        { style: estilos.encabezado, fixed: true },
	        _react2.default.createElement(
	          View,
	          { style: estilos.encabezadoIzq },
	          metadatos.logo ? _react2.default.createElement(Image, { src: metadatos.logo, style: estilos.logo }) : null,
	          _react2.default.createElement(
	            View,
	            null,
	            _react2.default.createElement(
	              Text,
	              { style: estilos.titulo },
	              "REPORTE DE NOTA DE ENTREGA"
	            ),
	            _react2.default.createElement(
	              Text,
	              { style: estilos.subtitulo },
	              texto(metadatos.empresa)
	            ),
	            texto(metadatos.rif) === "" ? null : _react2.default.createElement(
	              Text,
	              { style: estilos.subtitulo },
	              "RIF: " + texto(metadatos.rif)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          View,
	          null,
	          _react2.default.createElement(
	            Text,
	            { style: estilos.subtitulo },
	            "Emitido: " + (0, _moment2.default)().format("DD-MM-YYYY hh:mm a")
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: estilos.subtitulo },
	            "Usuario: " + texto(metadatos.usuario)
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: estilos.subtitulo },
	            "Datos Eliminados (tabla auditadataeliminada)"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        View,
	        { style: estilos.barra },
	        _react2.default.createElement(
	          Text,
	          { style: estilos.barraTitulo },
	          "COMPARACIÓN CON EL RESPALDO (" + respaldos.length + ")"
	        ),
	        _react2.default.createElement(
	          View,
	          { style: estilos.barraFila },
	          _react2.default.createElement(
	            Text,
	            { style: estilos.meta },
	            metaTexto("DOCUMENTO", filtros.tabla)
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: estilos.meta },
	            metaTexto("STATUS", filtros.accion)
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: estilos.meta },
	            metaTexto("DESDE", filtros.desde, "-")
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: estilos.meta },
	            metaTexto("HASTA", filtros.hasta, "-")
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: estilos.meta },
	            "REGISTROS: " + lista.length
	          )
	        )
	      ),
	      !registro && _react2.default.createElement(
	        Text,
	        { style: estilos.sinDatos },
	        "No hay informacion por mostrar"
	      ),
	      registro && _react2.default.createElement(
	        View,
	        { style: estilos.seccion },
	        _react2.default.createElement(
	          Text,
	          { style: estilos.seccionTitulo },
	          texto(registro.titulo || "DOCUMENTO ELIMINADO (AUDITORÍA)").toUpperCase()
	        ),
	        _react2.default.createElement(
	          View,
	          { style: estilos.datos },
	          camposRegistro.map(function (campo, indice) {
	            return _react2.default.createElement(
	              View,
	              { style: estilos.dato, key: indice, wrap: false },
	              _react2.default.createElement(
	                Text,
	                { style: estilos.datoLabel },
	                texto(campo.label).toUpperCase()
	              ),
	              _react2.default.createElement(
	                Text,
	                { style: estilos.datoValor },
	                texto(campo.valor)
	              )
	            );
	          })
	        )
	      ),
	      respaldos.map(function (respaldo, indice) {
	        var _detalleTicket = (0, _detalleNotaEntrega.detalleTicket)(respaldo.detalle),
	            filas = _detalleTicket.filas,
	            totales = _detalleTicket.totales;
	
	        return _react2.default.createElement(
	          View,
	          { style: estilos.seccion, key: indice },
	          _react2.default.createElement(
	            Text,
	            { style: estilos.seccionTitulo },
	            texto(respaldo.titulo || "NOTA DE ENTREGA (RESPALDO)").toUpperCase()
	          ),
	          texto(respaldo.subtitulo) === "" ? null : _react2.default.createElement(
	            Text,
	            { style: estilos.meta },
	            texto(respaldo.subtitulo)
	          ),
	          _react2.default.createElement(
	            View,
	            { style: estilos.datos },
	            (respaldo.campos || []).map(function (campo, posicion) {
	              return _react2.default.createElement(
	                View,
	                { style: estilos.dato, key: posicion, wrap: false },
	                _react2.default.createElement(
	                  Text,
	                  { style: estilos.datoLabel },
	                  texto(campo.label).toUpperCase()
	                ),
	                _react2.default.createElement(
	                  Text,
	                  { style: estilos.datoValor },
	                  texto(campo.valor)
	                )
	              );
	            })
	          ),
	          filas.length === 0 ? _react2.default.createElement(
	            Text,
	            { style: estilos.sinDetalle },
	            "La nota no tiene renglones para mostrar."
	          ) : _react2.default.createElement(
	            View,
	            null,
	            _react2.default.createElement(
	              View,
	              { style: estilos.filaTitulos, wrap: false },
	              _detalleNotaEntrega.COLUMNAS_DETALLE.map(function (columna, posicion) {
	                return _react2.default.createElement(
	                  Text,
	                  {
	                    key: posicion,
	                    style: [estilos.tituloColumna, { flex: columna.flex }]
	                  },
	                  columna.label
	                );
	              })
	            ),
	            filas.map(function (fila, posicion) {
	              return _react2.default.createElement(
	                View,
	                {
	                  key: posicion,
	                  style: [estilos.fila, posicion % 2 === 1 ? estilos.filaPar : null],
	                  wrap: false
	                },
	                _detalleNotaEntrega.COLUMNAS_DETALLE.map(function (columna, celda) {
	                  return _react2.default.createElement(
	                    Text,
	                    {
	                      key: celda,
	                      style: [estilos.celda, { flex: columna.flex }, columna.align === "right" ? estilos.celdaDer : null, columna.key === "producto" ? estilos.negrita : null]
	                    },
	                    (0, _detalleNotaEntrega.celdaTexto)(columna, fila)
	                  );
	                })
	              );
	            }),
	            _react2.default.createElement(
	              View,
	              { style: estilos.filaTotal, wrap: false },
	              _react2.default.createElement(
	                Text,
	                { style: [estilos.celdaTotal, { flex: 4.7 }] },
	                "Total (" + filas.length + " renglón" + (filas.length === 1 ? "" : "es") + ")"
	              ),
	              _react2.default.createElement(
	                Text,
	                {
	                  style: [estilos.celdaTotal, estilos.celdaDer, { flex: 0.9 }]
	                },
	                (0, _detalleNotaEntrega.formatearCantidad)(totales.cantidad)
	              ),
	              _react2.default.createElement(Text, { style: [estilos.celdaTotal, { flex: 1.3 }] }),
	              _react2.default.createElement(Text, { style: [estilos.celdaTotal, { flex: 0.8 }] }),
	              _react2.default.createElement(
	                Text,
	                {
	                  style: [estilos.celdaTotal, estilos.celdaDer, { flex: 1.4 }]
	                },
	                (0, _detalleNotaEntrega.formatearMonto)(totales.importe)
	              )
	            )
	          )
	        );
	      }),
	      _react2.default.createElement(
	        View,
	        { style: estilos.firmas, wrap: false },
	        _react2.default.createElement(
	          View,
	          { style: estilos.firma },
	          _react2.default.createElement(
	            Text,
	            { style: estilos.firmaTexto },
	            "ELABORADO POR"
	          )
	        ),
	        _react2.default.createElement(
	          View,
	          { style: estilos.firma },
	          _react2.default.createElement(
	            Text,
	            { style: estilos.firmaTexto },
	            "REVISADO POR"
	          )
	        ),
	        _react2.default.createElement(
	          View,
	          { style: estilos.firma },
	          _react2.default.createElement(
	            Text,
	            { style: estilos.firmaTexto },
	            "AUTORIZADO POR"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        View,
	        { style: estilos.pieFijo, fixed: true },
	        _react2.default.createElement(
	          Text,
	          { style: estilos.pieTexto },
	          "ATHOS ERP | Datos Eliminados (respaldo de nota de entrega)"
	        ),
	        _react2.default.createElement(Text, {
	          style: estilos.pieTexto,
	          render: function render(_ref) {
	            var pageNumber = _ref.pageNumber,
	                totalPages = _ref.totalPages;
	            return "Pagina " + pageNumber + " de " + totalPages;
	          }
	        })
	      )
	    )
	  );
	};

/***/ },
/* 7095 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(69);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _mensajes = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function ReportesConfig(props) {
	    var _this = this;
	
	    var op = __webpack_require__(8);
	
	    var _useState = (0, _react.useState)("HOJA"),
	        _useState2 = _slicedToArray(_useState, 2),
	        reporteOption = _useState2[0],
	        setReporteOption = _useState2[1];
	
	    var _useState3 = (0, _react.useState)("HOJA"),
	        _useState4 = _slicedToArray(_useState3, 2),
	        notaOption = _useState4[0],
	        setNotaOption = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(false),
	        _useState6 = _slicedToArray(_useState5, 2),
	        activate = _useState6[0],
	        setActivate = _useState6[1];
	
	    var _useState7 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState8 = _slicedToArray(_useState7, 2),
	        mensaje = _useState8[0],
	        setMensaje = _useState8[1];
	
	    var token = sessionStorage.getItem("jwtToken");
	
	    var guardarConfiguracion = function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var endpoint, response, _mensaje;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	
	                            setActivate(true);
	                            endpoint = op.conexion + "/api/comun/updateconfig";
	                            _context.next = 5;
	                            return _axios2.default.post(endpoint, {
	                                tiporeppedido: reporteOption,
	                                tiporepnotaentrega: notaOption
	                            }, {
	                                headers: { 'x-access-token': token }
	                            });
	
	                        case 5:
	                            response = _context.sent;
	
	
	                            if (response.status === 200) {
	                                setMensaje({
	                                    mostrar: true,
	                                    titulo: "Éxito",
	                                    texto: "Configuración guardada correctamente",
	                                    icono: "exito"
	                                });
	                                seleccionarRegistro();
	                            }
	                            _context.next = 13;
	                            break;
	
	                        case 9:
	                            _context.prev = 9;
	                            _context.t0 = _context["catch"](0);
	                            _mensaje = _context.t0.response.data.message || "Error de conexión";
	
	                            setMensaje({
	                                mostrar: true,
	                                titulo: "Error",
	                                texto: _mensaje,
	                                icono: "error"
	                            });
	
	                        case 13:
	                            _context.prev = 13;
	
	                            setActivate(false);
	                            return _context.finish(13);
	
	                        case 16:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this, [[0, 9, 13, 16]]);
	        }));
	
	        return function guardarConfiguracion() {
	            return _ref.apply(this, arguments);
	        };
	    }();
	
	    var seleccionarRegistro = function seleccionarRegistro() {
	        var campos = "*";
	        var nomtab = "configsistema";
	
	        var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=idconfig&id=1";
	
	        setActivate(true);
	        _axios2.default.get(endpoint, {
	            headers: {
	                "x-access-token": "" + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                console.log(response.data);
	                setReporteOption(response.data.tiporeppedido);
	                setNotaOption(response.data.tiporepnotaentrega);
	                sessionStorage.setItem("tiporeppedido", JSON.stringify(response.data.tiporeppedido));
	                sessionStorage.setItem("tiporepnotaentrega", JSON.stringify(response.data.tiporepnotaentrega));
	            }
	            setActivate(false);
	        }).catch(function (error) {
	            setActivate(false);
	            console.log(error);
	            setMensaje({
	                mostrar: true,
	                titulo: "Error",
	                texto: error.response.data.message,
	                icono: "error"
	            });
	        });
	    };
	
	    (0, _react.useEffect)(function () {
	        seleccionarRegistro();
	    }, []);
	    return _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	            "div",
	            { className: "row justify-content-center" },
	            _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row px-0" },
	                _react2.default.createElement(_semanticUiReact.Dimmer, { active: activate }),
	                _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                    onHide: function onHide() {
	                        return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                    } }),
	                _react2.default.createElement(
	                    "div",
	                    { className: "card shadow-sm mt-4 px-0" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "card-header azulGradiant text-white" },
	                        _react2.default.createElement(
	                            "h2",
	                            { className: "h5 mb-0 text-center" },
	                            "Configuraci\xF3n de Formatos de Impresi\xF3n"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "card-body" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "mb-1 row align-items-center" },
	                            _react2.default.createElement(
	                                "h3",
	                                { className: "h6 col-md-3 fw-bold mb-0" },
	                                "Formato Reporte Pedido"
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "form-check col-md-4" },
	                                _react2.default.createElement("input", {
	                                    className: "form-check-input",
	                                    type: "radio",
	                                    id: "reporteFull",
	                                    name: "reporteOption",
	                                    value: "HOJA",
	                                    checked: reporteOption.toString() === "HOJA",
	                                    onChange: function onChange(e) {
	                                        return setReporteOption(e.target.value);
	                                    }
	                                }),
	                                _react2.default.createElement(
	                                    "label",
	                                    { className: "form-check-label", htmlFor: "reporteFull" },
	                                    "Hoja Completa"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "form-check col-md-4" },
	                                _react2.default.createElement("input", {
	                                    className: "form-check-input",
	                                    type: "radio",
	                                    id: "reporteHalf",
	                                    name: "reporteOption",
	                                    value: "MEDIA",
	                                    checked: reporteOption.toString() === "MEDIA",
	                                    onChange: function onChange(e) {
	                                        return setReporteOption(e.target.value);
	                                    }
	                                }),
	                                _react2.default.createElement(
	                                    "label",
	                                    { className: "form-check-label", htmlFor: "reporteHalf" },
	                                    "Media Hoja"
	                                )
	                            )
	                        ),
	                        _react2.default.createElement("hr", { className: "my-3" }),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "row align-items-center" },
	                            _react2.default.createElement(
	                                "h3",
	                                { className: "h6 fw-bold mb-0 col-md-3" },
	                                "Formato Nota de Entrega"
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "form-check col-md-4" },
	                                _react2.default.createElement("input", {
	                                    className: "form-check-input",
	                                    type: "radio",
	                                    id: "notaFull",
	                                    name: "notaOption",
	                                    value: "HOJA",
	                                    checked: notaOption === "HOJA",
	                                    onChange: function onChange(e) {
	                                        return setNotaOption(e.target.value);
	                                    }
	                                }),
	                                _react2.default.createElement(
	                                    "label",
	                                    { className: "form-check-label", htmlFor: "notaFull" },
	                                    "Hoja Completa"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "form-check col-md-4" },
	                                _react2.default.createElement("input", {
	                                    className: "form-check-input",
	                                    type: "radio",
	                                    id: "notaHalf",
	                                    name: "notaOption",
	                                    value: "MEDIA",
	                                    checked: notaOption === "MEDIA",
	                                    onChange: function onChange(e) {
	                                        return setNotaOption(e.target.value);
	                                    }
	                                }),
	                                _react2.default.createElement(
	                                    "label",
	                                    { className: "form-check-label", htmlFor: "notaHalf" },
	                                    "Media Hoja"
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "row mt-4" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-md-12 text-end" },
	                                _react2.default.createElement(
	                                    "button",
	                                    {
	                                        className: "btn btn-primary",
	                                        onClick: guardarConfiguracion,
	                                        disabled: activate
	                                    },
	                                    activate ? _react2.default.createElement("span", { className: "spinner-border spinner-border-sm", role: "status", "aria-hidden": "true" }) : "Guardar Cambios"
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}
	
	exports.default = ReportesConfig;

/***/ },
/* 7096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _mensajes = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TablaAjustesSistema() {
	
	    var txtDescripcion = (0, _react.useRef)();
	    var btnAcepta = (0, _react.useRef)();
	    var txtLogo = (0, _react.useRef)();
	    var txtNombre = (0, _react.useRef)();
	    var txtRif = (0, _react.useRef)();
	    var txtVacios = (0, _react.useRef)();
	    var txtTicket = (0, _react.useRef)();
	    var txtIdajuste = (0, _react.useRef)();
	    var txtObser = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        body = _useState2[0],
	        setBody = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(true),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activaaceptar = _useState4[0],
	        setActivaaceptar = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(0),
	        _useState6 = _slicedToArray(_useState5, 2),
	        opera = _useState6[0],
	        setOpera = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(true),
	        _useState8 = _slicedToArray(_useState7, 2),
	        valdescrip = _useState8[0],
	        setValdescrip = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(false),
	        _useState10 = _slicedToArray(_useState9, 2),
	        activate = _useState10[0],
	        setActivate = _useState10[1];
	
	    var _useState11 = (0, _react.useState)({
	        mostrar: false,
	        titulo: "",
	        texto: "",
	        icono: ""
	    }),
	        _useState12 = _slicedToArray(_useState11, 2),
	        mensajesino = _useState12[0],
	        setMensajesino = _useState12[1];
	
	    var _useState13 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState14 = _slicedToArray(_useState13, 2),
	        mensaje = _useState14[0],
	        setMensaje = _useState14[1];
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	
	    var seleccionarRegistro = function seleccionarRegistro(id) {
	        setActivate(true);
	        var campos = '*';
	        var nomtab = 'ajustes';
	        var nomid = 'idajuste';
	        var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status == 200) {
	
	                if (response.data.idajuste > 0) {
	
	                    txtLogo.current.checked = response.data.logo === 'SI' ? true : false;
	                    txtRif.current.checked = response.data.rif === 'SI' ? true : false;
	                    txtNombre.current.checked = response.data.nombre === 'SI' ? true : false;
	                    txtVacios.current.checked = response.data.vacios === 'SI' ? true : false;
	                    txtTicket.current.checked = response.data.ticket === 'SI' ? true : false;
	                    txtDescripcion.current.value = response.data.descripcion;
	                    txtIdajuste.current.value = response.data.idajuste;
	                    txtObser.current.value = response.data.observacion;
	                    setActivaaceptar(false);
	                } else {
	                    setActivaaceptar(true);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response === undefined ? 'Error de Conexion' : error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	
	            setActivate(false);
	        });
	    };
	
	    var onGestionar = function onGestionar(op) {
	        return function (e) {
	
	            if (op === 1) {
	                seleccionarRegistro(1);
	                setOpera(2);
	                setTimeout(function () {
	                    return txtObser.current.focus();
	                }, 300);
	            } else if (op === 2) {
	                blanquear();
	            }
	        };
	    };
	
	    var onChange = function onChange(e) {
	        if (e.target.name === "nombre") {
	            if (e.target.checked === true) {
	                setValdescrip(true);
	                if (e.target.checked === true) {
	                    setTimeout(function () {
	                        return txtObser.current.focus();
	                    }, 300);
	                }
	            } else {
	                setValdescrip(false);
	                if (e.target.checked === false) {
	                    setTimeout(function () {
	                        return txtDescripcion.current.focus();
	                    }, 300);
	                }
	            }
	        }
	    };
	
	    var blanquear = function blanquear() {
	        txtLogo.current.checked = false;
	        txtRif.current.checked = false;
	        txtNombre.current.checked = false;
	        txtVacios.current.checked = false;
	        txtTicket.current.checked = false;
	        txtDescripcion.current.value = "";
	        txtIdajuste.current.value = "";
	        txtObser.current.value = "";
	        setActivaaceptar(true);
	        setValdescrip(true);
	        setOpera(0);
	    };
	
	    var onChangeValidar = function onChangeValidar() {
	        var sigue = true;
	        if (opera === 2) {
	            if (txtDescripcion.current.value === "") {
	                setMensaje({
	                    mostrar: true,
	                    titulo: "Notificación",
	                    texto: "El Campo Descripción no debe ir Vacio",
	                    icono: "informacion"
	                });
	                txtDescripcion.current.focus();
	                sigue = false;
	            }
	        }
	
	        if (sigue) {
	            var ajuste = [];
	            ajuste.push({
	                idajuste: txtIdajuste.current.value,
	                logo: txtLogo.current.checked === true ? 'SI' : 'NO',
	                nombre: txtNombre.current.checked === true ? 'SI' : 'NO',
	                rif: txtRif.current.checked === true ? 'SI' : 'NO',
	                vacios: txtVacios.current.checked === true ? 'SI' : 'NO',
	                ticket: txtTicket.current.checked === true ? 'SI' : 'NO',
	                descripcion: txtDescripcion.current.value.toUpperCase().trim(),
	                observacion: txtObser.current.value.toUpperCase().trim()
	            });
	
	            setBody({
	                ajuste: ajuste
	            });
	
	            var msg = "";
	            if (opera === 1) {
	                msg = "Esta Seguro de Registrar estos Datos.";
	            } else if (opera === 2) {
	                msg = "Esta Seguro de Modificar estos Datos.";
	            } else if (opera === 3) {
	                msg = "Esta Seguro de Eliminar estos Datos.";
	            }
	
	            setMensajesino({
	                mostrar: true,
	                titulo: "Confirmación.",
	                texto: msg,
	                icono: "confirmacion"
	            });
	        }
	    };
	
	    var procesarRegistro = function procesarRegistro() {
	        setActivate(true);
	        var endpoint = op.conexion + '/api/organizacion/actualizarajustes/' + opera;
	        _axios2.default.post(endpoint, body, {
	            headers: {
	                "x-access-token": '' + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                if (opera === 1) {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Exito.",
	                        texto: "Registro Creado Correctamente",
	                        icono: "exito"
	                    });
	                } else if (opera === 2) {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Exito.",
	                        texto: "Registro Modificado Correctamente",
	                        icono: "exito"
	                    });
	                } else if (opera === 3) {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Exito.",
	                        texto: "Registro Eliminado Correctamente",
	                        icono: "exito"
	                    });
	                }
	                setActivate(false);
	            }
	        }).catch(function (error) {
	            var mensaje = "";
	            if (error.response === undefined) {
	                mensaje = "Error de Conexion";
	            } else {
	                if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
	                    mensaje = "Ya existe un Registro Actualmente";
	                } else {
	                    mensaje = error.response.data.message;
	                }
	            }
	            setMensaje({
	                mostrar: true,
	                titulo: "Error",
	                texto: mensaje,
	                icono: "error"
	            });
	            setActivate(false);
	        });
	    };
	
	    var handleCloseSi = function handleCloseSi() {
	        setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	        procesarRegistro();
	    };
	
	    var cerrarModal = function cerrarModal() {
	        blanquear();
	        setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'container-fluid rounded' },
	        _react2.default.createElement(
	            'div',
	            { className: 'container-fluid' },
	            _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                    _semanticUiReact.Dimmer,
	                    { active: activate, inverted: true },
	                    _react2.default.createElement(
	                        _semanticUiReact.Loader,
	                        { inverted: true },
	                        'cargando...'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'container' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 row m-0 py-3 d-flex justify-content-between' },
	                                _react2.default.createElement('input', { type: 'hidden', ref: txtIdajuste }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-check form-switch col-pd-130 row m-0 border-azul rounded px-1 mb-2' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'form-check-label col-10', 'for': 'flexSwitchCheckDefault1' },
	                                        'LOGO:'
	                                    ),
	                                    _react2.default.createElement('input', { className: 'form-check-input col-2', disabled: opera === 2 ? false : true, ref: txtLogo, type: 'checkbox', id: 'flexSwitchCheckDefault1' })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-check form-switch col-pd-140 row m-0 border-azul rounded px-1 mb-2' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'form-check-label col-10', 'for': 'flexSwitchCheckDefault2' },
	                                        'NOMBRE:'
	                                    ),
	                                    _react2.default.createElement('input', { className: 'form-check-input col-2', disabled: opera === 2 ? false : true, onChange: onChange, name: 'nombre', ref: txtNombre, type: 'checkbox', id: 'flexSwitchCheckDefault2' })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-check form-switch col-pd-120 row m-0 border-azul rounded px-1 mb-2' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'form-check-label col-10', 'for': 'flexSwitchCheckDefault3' },
	                                        'RIF:'
	                                    ),
	                                    _react2.default.createElement('input', { className: 'form-check-input col-2', disabled: opera === 2 ? false : true, ref: txtRif, type: 'checkbox', id: 'flexSwitchCheckDefault3' })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-check form-switch col-pd-130 row m-0 border-azul rounded px-1 mb-2' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'form-check-label col-10', 'for': 'flexSwitchCheckDefault4' },
	                                        'VACIOS:'
	                                    ),
	                                    _react2.default.createElement('input', { className: 'form-check-input col-2', disabled: opera === 2 ? false : true, ref: txtVacios, type: 'checkbox', id: 'flexSwitchCheckDefault4' })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-check form-switch col-pd-130 row m-0 border-azul rounded px-1 mb-2' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'form-check-label col-10', 'for': 'flexSwitchCheckDefault5' },
	                                        'TICKET:'
	                                    ),
	                                    _react2.default.createElement('input', { className: 'form-check-input col-2', disabled: opera === 2 ? false : true, ref: txtTicket, type: 'checkbox', id: 'flexSwitchCheckDefault5' })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-12 px-0 mb-2' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'input-group input-group-sm' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                            'DESCRIPCION: '
	                                        ),
	                                        _react2.default.createElement('input', { autoComplete: 'off', type: 'text', ref: txtDescripcion, disabled: valdescrip, placeholder: '', className: 'form-control bg-transparent fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-12 px-0' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'input-group input-group-sm' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                            'OBSERVACION: '
	                                        ),
	                                        _react2.default.createElement('input', { autoComplete: 'off', type: 'text', ref: txtObser, disabled: opera === 2 ? false : true, placeholder: '', className: 'form-control bg-transparent fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-12 mb-3 row m-0' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-12 d-flex justify-content-end' },
	                            _react2.default.createElement(
	                                'button',
	                                { onClick: onGestionar(1), disabled: activaaceptar === false ? true : false, className: 'btn btn-sm  btn-warning rounded-pill mx-1' },
	                                _react2.default.createElement(
	                                    'i',
	                                    { className: 'fa fa-edit' },
	                                    ' MODIFICAR'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    ref: btnAcepta,
	                                    disabled: activaaceptar,
	                                    onClick: onChangeValidar,
	                                    className: 'btn btn-sm rounded-pill btn-success mx-1'
	                                },
	                                _react2.default.createElement(
	                                    'i',
	                                    { className: 'fas fa-check' },
	                                    " ",
	                                    'ACEPTAR'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                { disabled: activaaceptar, onClick: onGestionar(2), className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	                                _react2.default.createElement(
	                                    'i',
	                                    { className: 'fas fa-window-close' },
	                                    ' CANCELAR'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_mensajes.Mensaje, {
	                    mensaje: mensaje,
	                    onHide: function onHide() {
	                        mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({
	                            mostrar: false,
	                            titulo: "",
	                            texto: "",
	                            icono: ""
	                        });
	                    }
	                }),
	                _react2.default.createElement(_mensajes.MensajeSiNo, {
	                    mensaje: mensajesino,
	                    onHideNo: function onHideNo() {
	                        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	                    },
	                    onHideSi: handleCloseSi
	                })
	            )
	        )
	    );
	}
	
	exports.default = TablaAjustesSistema;

/***/ },
/* 7097 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TablaDetalleNota = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _detalleNotaEntrega = __webpack_require__(298);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Tabla del detalle de una nota de entrega en forma de "ticket": una linea por
	 * producto con su codigo, nombre, cantidad, precio unitario, IVA e importe, y
	 * al pie los totales.
	 *
	 * Se usa en el modal de auditoria (pestaña "Datos Eliminados") para mostrar el
	 * detalle del respaldo de la nota. El mismo criterio de columnas lo replica el
	 * reporte PDF (reporteNotaEntregaRespaldoPDF).
	 */
	/* Alineacion Bootstrap del texto de la columna */
	var alinear = function alinear(columna) {
	  return "text-" + (columna.align === "right" ? "end" : "start");
	};
	
	var TablaDetalleNota = exports.TablaDetalleNota = function TablaDetalleNota(props) {
	  var detalle = props.detalle,
	      vacio = props.vacio;
	
	  var _detalleTicket = (0, _detalleNotaEntrega.detalleTicket)(detalle),
	      filas = _detalleTicket.filas,
	      totales = _detalleTicket.totales;
	
	  if (filas.length === 0) {
	    return _react2.default.createElement(
	      "div",
	      { className: "aud-ticket-vacio" },
	      _react2.default.createElement("i", { className: "far fa-file me-1" }),
	      vacio || "La nota no tiene renglones para mostrar."
	    );
	  }
	
	  return _react2.default.createElement(
	    "div",
	    { className: "aud-ticket-tabla-wrap" },
	    _react2.default.createElement(
	      "table",
	      { className: "aud-ticket-tabla" },
	      _react2.default.createElement(
	        "colgroup",
	        null,
	        _detalleNotaEntrega.COLUMNAS_DETALLE.map(function (columna, indice) {
	          return _react2.default.createElement("col", { key: indice, className: "aud-col-" + columna.key });
	        })
	      ),
	      _react2.default.createElement(
	        "thead",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _detalleNotaEntrega.COLUMNAS_DETALLE.map(function (columna, indice) {
	            return _react2.default.createElement(
	              "th",
	              { key: indice, className: alinear(columna) },
	              columna.label
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        "tbody",
	        null,
	        filas.map(function (fila, indice) {
	          return _react2.default.createElement(
	            "tr",
	            { key: indice },
	            _detalleNotaEntrega.COLUMNAS_DETALLE.map(function (columna, posicion) {
	              return _react2.default.createElement(
	                "td",
	                {
	                  key: posicion,
	                  className: alinear(columna) + " " + (columna.key === "producto" ? "aud-ticket-producto" : "")
	                },
	                (0, _detalleNotaEntrega.celdaTexto)(columna, fila)
	              );
	            })
	          );
	        })
	      ),
	      _react2.default.createElement(
	        "tfoot",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "td",
	            { className: "text-start fw-bold", colSpan: "2" },
	            "Total (",
	            filas.length,
	            " rengl\xF3n",
	            filas.length === 1 ? "" : "es",
	            ")"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "text-end fw-bold" },
	            (0, _detalleNotaEntrega.formatearCantidad)(totales.cantidad)
	          ),
	          _react2.default.createElement("td", { className: "text-end" }),
	          _react2.default.createElement("td", { className: "text-end" }),
	          _react2.default.createElement(
	            "td",
	            { className: "text-end fw-bold" },
	            (0, _detalleNotaEntrega.formatearMonto)(totales.importe)
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(19);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoCrearMonedas = __webpack_require__(7025);
	
	var _catalogoCrearMonedas2 = _interopRequireDefault(_catalogoCrearMonedas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headCells = [{ id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CODIGO', textAlign: 'center' }, { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'NOMBRE DE LA MONEDA', textAlign: 'center' }, { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'SIMBOLO', textAlign: 'center' }, { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }];
	
	function TablaMonedas() {
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        mostrar = _useState2[0],
	        setMostrar = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        activate = _useState4[0],
	        setActivate = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(0),
	        _useState6 = _slicedToArray(_useState5, 2),
	        operacion = _useState6[0],
	        setOperacion = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(),
	        _useState8 = _slicedToArray(_useState7, 2),
	        datos = _useState8[0],
	        setDatos = _useState8[1];
	
	    var _useState9 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState10 = _slicedToArray(_useState9, 2),
	        mensaje = _useState10[0],
	        setMensaje = _useState10[1];
	
	    var _useState11 = (0, _react.useState)([]),
	        _useState12 = _slicedToArray(_useState11, 2),
	        records = _useState12[0],
	        setRecords = _useState12[1];
	
	    var _useState13 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState14 = _slicedToArray(_useState13, 2),
	        filterFn = _useState14[0],
	        setFilterFn = _useState14[1];
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting,
	        TblPagination = _useTable.TblPagination;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.idmoneda.includes(target.value) || x.descripcion.toUpperCase().includes(target.value.toUpperCase()) || x.simbolo.toUpperCase().includes(target.value.toUpperCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    (0, _react.useEffect)(function () {
	        seleccionarRegistros();
	    }, []);
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	        setActivate(true);
	        var campos = '*';
	        var nomtab = 'moneda';
	        var orden = 'idmoneda';
	        var endpoint = op.conexion + '/api/comun/seleccionaregistros?campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status == 200) {
	
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                    setActivate(false);
	                } else {
	                    setRecords([]);
	                }
	            }
	
	            setActivate(false);
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response === undefined ? 'Error de Conexion' : error.response.data.message, icono: 'error' });
	            setActivate(false);
	        });
	    };
	
	    var seleccionarRegistro = function seleccionarRegistro(id) {
	        setActivate(true);
	        var campos = '*';
	        var nomtab = 'moneda';
	        var nomid = 'idmoneda';
	        var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status == 200) {
	
	                if (response.data.idmoneda > 0) {
	                    setDatos(response.data);
	                    setMostrar(true);
	                } else {
	                    setDatos([]);
	                    setMostrar(true);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response === undefined ? 'Error de Conexion' : error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	
	            setActivate(false);
	        });
	    };
	
	    var gestionarMonedas = function gestionarMonedas(id, ope) {
	        return function (event) {
	
	            event.preventDefault();
	            setOperacion(ope);
	            if (ope === 1) {
	                setMostrar(true);
	            } else if (ope === 2) {
	                seleccionarRegistro(id);
	            } else if (ope === 3) {
	                seleccionarRegistro(id);
	            } else if (ope === 4) {
	                seleccionarRegistro(id);
	            }
	        };
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'container-fluid rounded' },
	        _react2.default.createElement(
	            'div',
	            { className: 'container-fluid' },
	            _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                    _semanticUiReact.Dimmer,
	                    { active: activate, inverted: true },
	                    _react2.default.createElement(
	                        _semanticUiReact.Loader,
	                        { inverted: true },
	                        'cargando...'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'container' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 row m-0 py-2' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2' },
	                                    _react2.default.createElement('input', { type: 'text', className: 'form-control form-control-sm rounded-pill', onChange: handleSearch, placeholder: 'Buscar' })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-1 ml-auto' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { onClick: gestionarMonedas('', 1), className: 'btn btn-sm btn-primary rounded-circle' },
	                                        _react2.default.createElement('i', { className: 'fas fa-plus' }),
	                                        ' '
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react2.default.createElement(
	                                    TblContainer,
	                                    null,
	                                    _react2.default.createElement(TblHead, null),
	                                    _react2.default.createElement(
	                                        _core.TableBody,
	                                        null,
	                                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                                            return _react2.default.createElement(
	                                                _core.TableRow,
	                                                { key: index, style: { padding: "0" } },
	                                                _react2.default.createElement(
	                                                    _core.TableCell,
	                                                    { className: 'align-baseline', style: { textAlign: "center", width: "50px" } },
	                                                    item.idmoneda
	                                                ),
	                                                _react2.default.createElement(
	                                                    _core.TableCell,
	                                                    { className: 'align-baseline', style: { textAlign: "center", width: "250px" } },
	                                                    item.descripcion
	                                                ),
	                                                _react2.default.createElement(
	                                                    _core.TableCell,
	                                                    { className: 'align-baseline', style: { textAlign: "center", width: "250px" } },
	                                                    item.simbolo
	                                                ),
	                                                _react2.default.createElement(
	                                                    _core.TableCell,
	                                                    { className: 'align-baseline', style: { textAlign: "center", width: "100px" } },
	                                                    _react2.default.createElement(
	                                                        'button',
	                                                        { onClick: gestionarMonedas(item.idmoneda, 4), className: 'btn btn-sm  btn-info rounded-circle ml-2' },
	                                                        _react2.default.createElement('i', { className: 'fas fa-eye' }),
	                                                        ' '
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'button',
	                                                        { onClick: gestionarMonedas(item.idmoneda, 2), className: 'btn btn-sm  btn-warning rounded-circle ml-2' },
	                                                        _react2.default.createElement('i', { className: 'fa fa-edit' }),
	                                                        ' '
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'button',
	                                                        { onClick: gestionarMonedas(item.idmoneda, 3), className: 'btn btn-sm  btn-danger rounded-circle ml-2' },
	                                                        _react2.default.createElement('i', { className: 'fa fa-trash' }),
	                                                        ' '
	                                                    )
	                                                )
	                                            );
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(TblPagination, null)
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                    onHide: function onHide() {
	                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                    } }),
	                _react2.default.createElement(_catalogoCrearMonedas2.default, {
	                    show: mostrar,
	                    operacion: operacion,
	                    datos: datos,
	                    onHideCancelar: function onHideCancelar() {
	                        return setMostrar(false);
	                    },
	                    onHideAcepta: seleccionarRegistros
	                })
	            )
	        )
	    );
	}
	
	exports.default = TablaMonedas;

/***/ },
/* 7099 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(19);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _modalActualizarPersona = __webpack_require__(664);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _mensajes = __webpack_require__(9);
	
	var _modalActualizarOrganizacion = __webpack_require__(7087);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headCells = [{ id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CODIGO', textAlign: 'center' }, { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'NOMBRES/RAZON SOCIAL', textAlign: 'center' }, { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'RIF', textAlign: 'center' }, { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }];
	
	function TablaOrganizacion() {
	    var _useState = (0, _react.useState)(),
	        _useState2 = _slicedToArray(_useState, 2),
	        titulo1 = _useState2[0],
	        setTitulo1 = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(),
	        _useState4 = _slicedToArray(_useState3, 2),
	        msg1 = _useState4[0],
	        setMsg1 = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(false),
	        _useState6 = _slicedToArray(_useState5, 2),
	        mostrar5 = _useState6[0],
	        setMostrar5 = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(false),
	        _useState8 = _slicedToArray(_useState7, 2),
	        mostrarOrganizacion = _useState8[0],
	        setMostrarOrganizacion = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(false),
	        _useState10 = _slicedToArray(_useState9, 2),
	        activate = _useState10[0],
	        setActivate = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(0),
	        _useState12 = _slicedToArray(_useState11, 2),
	        operacion = _useState12[0],
	        setOperacion = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(),
	        _useState14 = _slicedToArray(_useState13, 2),
	        persona = _useState14[0],
	        setPersona = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(),
	        _useState16 = _slicedToArray(_useState15, 2),
	        organizacion = _useState16[0],
	        setOrganizacion = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(false),
	        _useState18 = _slicedToArray(_useState17, 2),
	        deshabilitado = _useState18[0],
	        setDeshabilitado = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(),
	        _useState20 = _slicedToArray(_useState19, 2),
	        permiso = _useState20[0],
	        setPermiso = _useState20[1];
	
	    var _useState21 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState22 = _slicedToArray(_useState21, 2),
	        mensaje = _useState22[0],
	        setMensaje = _useState22[1];
	
	    var _useState23 = (0, _react.useState)([]),
	        _useState24 = _slicedToArray(_useState23, 2),
	        records = _useState24[0],
	        setRecords = _useState24[1];
	
	    var _useState25 = (0, _react.useState)({ fn: function fn(items) {
	            return items;
	        } }),
	        _useState26 = _slicedToArray(_useState25, 2),
	        filterFn = _useState26[0],
	        setFilterFn = _useState26[1];
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting,
	        TblPagination = _useTable.TblPagination;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.idorganizacion.includes(target.value) || x.nombre.toUpperCase().includes(target.value.toUpperCase()) || x.rif.toUpperCase().includes(target.value.toUpperCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    (0, _react.useEffect)(function () {
	        seleccionarRegistros();
	    }, []);
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	        setActivate(true);
	        var campos = '*';
	        var nomtab = 'organizacion';
	        var orden = 'idorganizacion';
	        var endpoint = op.conexion + '/api/comun/seleccionaregistros?campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status == 200) {
	
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                    setActivate(false);
	                } else {
	                    setRecords([]);
	                }
	            }
	
	            setActivate(false);
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response === undefined ? 'Error de Conexion' : error.response.data.message, icono: 'error' });
	            setActivate(false);
	        });
	    };
	
	    var seleccionarRegistro = function seleccionarRegistro(id) {
	        setActivate(true);
	        var campos = '*';
	        var nomtab = 'organizacion';
	        var nomid = 'idorganizacion';
	        var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status == 200) {
	
	                setOrganizacion(response.data);
	                setMostrarOrganizacion(true);
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response === undefined ? 'Error de Conexion' : error.response.data.message, icono: 'error' });
	            setActivate(false);
	        }).finally(function () {
	
	            setActivate(false);
	        });
	    };
	
	    var gestionarOrganizacion = function gestionarOrganizacion(id, ope) {
	        return function (event) {
	
	            event.preventDefault();
	            setOperacion(ope);
	            if (ope === 1) {
	                setMostrarOrganizacion(true);
	                setDeshabilitado(false);
	            } else if (ope === 2) {
	                seleccionarRegistro(id);
	                setDeshabilitado(true);
	            } else if (ope === 3) {
	                seleccionarRegistro(id);
	                setDeshabilitado(true);
	            } else if (ope === 4) {
	                seleccionarRegistro(id);
	                setDeshabilitado(true);
	            }
	        };
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'container-fluid rounded' },
	        _react2.default.createElement(
	            'div',
	            { className: 'container-fluid' },
	            _react2.default.createElement(
	                'div',
	                { className: 'card' },
	                _react2.default.createElement(
	                    _semanticUiReact.Dimmer,
	                    { active: activate, inverted: true },
	                    _react2.default.createElement(
	                        _semanticUiReact.Loader,
	                        { inverted: true },
	                        'cargando...'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'container' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 row m-0 py-2' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2' },
	                                    _react2.default.createElement('input', { type: 'text', className: 'form-control form-control-sm rounded-pill', onChange: handleSearch, placeholder: 'Buscar' })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-1 ml-auto' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { onClick: gestionarOrganizacion('', 1), className: 'btn btn-sm btn-primary rounded-circle' },
	                                        _react2.default.createElement('i', { className: 'fas fa-plus' }),
	                                        ' '
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12' },
	                                _react2.default.createElement(
	                                    TblContainer,
	                                    null,
	                                    _react2.default.createElement(TblHead, null),
	                                    _react2.default.createElement(
	                                        _core.TableBody,
	                                        null,
	                                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                                            return _react2.default.createElement(
	                                                _core.TableRow,
	                                                { key: index, style: { padding: "0" } },
	                                                _react2.default.createElement(
	                                                    _core.TableCell,
	                                                    { className: 'align-baseline', style: { textAlign: "center", width: "50px" } },
	                                                    item.idorganizacion
	                                                ),
	                                                _react2.default.createElement(
	                                                    _core.TableCell,
	                                                    { className: 'align-baseline', style: { textAlign: "start", width: "250px" } },
	                                                    item.nombre
	                                                ),
	                                                _react2.default.createElement(
	                                                    _core.TableCell,
	                                                    { className: 'align-baseline', style: { textAlign: "center", width: "250px" } },
	                                                    item.rif
	                                                ),
	                                                _react2.default.createElement(
	                                                    _core.TableCell,
	                                                    { className: 'align-baseline', style: { textAlign: "center", width: "100px" } },
	                                                    _react2.default.createElement(
	                                                        'button',
	                                                        { onClick: gestionarOrganizacion(item.idorganizacion, 4), className: 'btn btn-sm  btn-info rounded-circle ml-2' },
	                                                        _react2.default.createElement('i', { className: 'fas fa-eye' }),
	                                                        ' '
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'button',
	                                                        { onClick: gestionarOrganizacion(item.idorganizacion, 2), className: 'btn btn-sm  btn-warning rounded-circle ml-2' },
	                                                        _react2.default.createElement('i', { className: 'fa fa-edit' }),
	                                                        ' '
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        'button',
	                                                        { onClick: gestionarOrganizacion(item.idorganizacion, 3), className: 'btn btn-sm  btn-danger rounded-circle ml-2' },
	                                                        _react2.default.createElement('i', { className: 'fa fa-trash' }),
	                                                        ' '
	                                                    )
	                                                )
	                                            );
	                                        })
	                                    )
	                                ),
	                                _react2.default.createElement(TblPagination, null)
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                    onHide: function onHide() {
	                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                    } }),
	                _react2.default.createElement(_modalActualizarOrganizacion.ActualizarOrganizacion, { show: mostrarOrganizacion, operacion: operacion, organizacion: organizacion, onHideCancela: function onHideCancela() {
	                        return setMostrarOrganizacion(false);
	                    }, onHideAcepta: seleccionarRegistros })
	            )
	        )
	    );
	}
	
	exports.default = TablaOrganizacion;

/***/ },
/* 7100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(19);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _modalActualizarPersona = __webpack_require__(664);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _mensajes = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headCells = [{
	  id: "1",
	  backgroundColor: "rgba(5, 81, 130, 1)",
	  color: "#ffffff",
	  label: "CÉDULA",
	  textAlign: "center"
	}, {
	  id: "2",
	  backgroundColor: "rgba(5, 81, 130, 1)",
	  color: "#ffffff",
	  label: "NOMBRES",
	  textAlign: "center"
	}, {
	  id: "3",
	  backgroundColor: "rgba(5, 81, 130, 1)",
	  color: "#ffffff",
	  label: "APELLIDOS",
	  textAlign: "center"
	}, {
	  id: "opciones",
	  backgroundColor: "rgba(5, 81, 130, 1)",
	  color: "#ffffff",
	  label: " OPCIONES",
	  textAlign: "center"
	}];
	
	function TablaPersonas() {
	  var _useState = (0, _react.useState)(),
	      _useState2 = _slicedToArray(_useState, 2),
	      titulo = _useState2[0],
	      setTitulo = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = _slicedToArray(_useState3, 2),
	      msg = _useState4[0],
	      setMsg = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(),
	      _useState6 = _slicedToArray(_useState5, 2),
	      titulo1 = _useState6[0],
	      setTitulo1 = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(),
	      _useState8 = _slicedToArray(_useState7, 2),
	      msg1 = _useState8[0],
	      setMsg1 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mostrar5 = _useState10[0],
	      setMostrar5 = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      contar = _useState12[0],
	      setContar = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      contar1 = _useState14[0],
	      setContar1 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      contar2 = _useState16[0],
	      setContar2 = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      contar3 = _useState18[0],
	      setContar3 = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      contar4 = _useState20[0],
	      setContar4 = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      contar5 = _useState22[0],
	      setContar5 = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0),
	      _useState24 = _slicedToArray(_useState23, 2),
	      contarRet = _useState24[0],
	      setContarRet = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(false),
	      _useState26 = _slicedToArray(_useState25, 2),
	      activate = _useState26[0],
	      setActivate = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      operacion = _useState28[0],
	      setOperacion = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(),
	      _useState30 = _slicedToArray(_useState29, 2),
	      usuarioH = _useState30[0],
	      setUsuarioH = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(),
	      _useState32 = _slicedToArray(_useState31, 2),
	      persona = _useState32[0],
	      setPersona = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(),
	      _useState34 = _slicedToArray(_useState33, 2),
	      organizacion = _useState34[0],
	      setOrganizacion = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(),
	      _useState36 = _slicedToArray(_useState35, 2),
	      configCome = _useState36[0],
	      setConfigCome = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(),
	      _useState38 = _slicedToArray(_useState37, 2),
	      usuariow = _useState38[0],
	      setUsuariow = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(),
	      _useState40 = _slicedToArray(_useState39, 2),
	      idUsuario = _useState40[0],
	      setIdUsuario = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(),
	      _useState42 = _slicedToArray(_useState41, 2),
	      deuda = _useState42[0],
	      setDeuda = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(),
	      _useState44 = _slicedToArray(_useState43, 2),
	      historico = _useState44[0],
	      setHistorico = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(),
	      _useState46 = _slicedToArray(_useState45, 2),
	      pagow = _useState46[0],
	      setPagow = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(),
	      _useState48 = _slicedToArray(_useState47, 2),
	      retencion = _useState48[0],
	      setRetencion = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(sessionStorage.getItem("espiritu")),
	      _useState50 = _slicedToArray(_useState49, 2),
	      espiritu = _useState50[0],
	      setEspiritu = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(sessionStorage.getItem("fechasistema")),
	      _useState52 = _slicedToArray(_useState51, 2),
	      fechaSistema = _useState52[0],
	      setFechaSistema = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(sessionStorage.getItem("anioactu")),
	      _useState54 = _slicedToArray(_useState53, 2),
	      anioActu = _useState54[0],
	      setAnioActu = _useState54[1];
	
	  var _useState55 = (0, _react.useState)(false),
	      _useState56 = _slicedToArray(_useState55, 2),
	      deshabilitado = _useState56[0],
	      setDeshabilitado = _useState56[1];
	
	  var _useState57 = (0, _react.useState)(),
	      _useState58 = _slicedToArray(_useState57, 2),
	      permiso = _useState58[0],
	      setPermiso = _useState58[1];
	
	  var _useState59 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState60 = _slicedToArray(_useState59, 2),
	      mensaje = _useState60[0],
	      setMensaje = _useState60[1];
	
	  var _useState61 = (0, _react.useState)([]),
	      _useState62 = _slicedToArray(_useState61, 2),
	      records = _useState62[0],
	      setRecords = _useState62[1];
	
	  var _useState63 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState64 = _slicedToArray(_useState63, 2),
	      filterFn = _useState64[0],
	      setFilterFn = _useState64[1];
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting,
	      TblPagination = _useTable.TblPagination;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.cedula.includes(target.value) || x.nombres.toUpperCase().includes(target.value.toUpperCase()) || x.apellidos.toUpperCase().includes(target.value.toUpperCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    var obj = JSON.parse(sessionStorage.getItem("post"));
	    setFechaSistema(obj.fechasistema);
	    seleccionarPersonas();
	  }, []);
	
	  var cerrarModalActualizar = function cerrarModalActualizar() {
	    setPersona();
	    setActivate(false);
	    setMostrar5(false);
	  };
	
	  var renderizar = function renderizar() {
	    seleccionarPersonas();
	  };
	
	  var seleccionarPersonas = function seleccionarPersonas() {
	    setActivate(true);
	    var campos = "cedula, trim(nombres) AS nombres, trim(apellidos) AS apellidos";
	    var nomtab = "persona";
	    var orden = "cedula";
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	          setContar4(contar4 + 1);
	          setActivate(false);
	        } else {
	          setRecords([]);
	        }
	      }
	
	      setActivate(false);
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response === undefined ? "Error de Conexion" : error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var SelectPersona = function SelectPersona(cedula) {
	    var endpoint = op.conexion + "/api/personas/selectpersona/" + cedula;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.cedula >= 0) {
	          setPersona({
	            cedula: response.data.cedula,
	            nombres: response.data.nombres && response.data.nombres.trim(),
	            apellidos: response.data.apellidos && response.data.apellidos.trim(),
	            correoe: response.data.correoe && response.data.correoe.trim(),
	            tlf1: response.data.tlf1 && response.data.tlf1.trim(),
	            tlf2: response.data.tlf2 && response.data.tlf2.trim(),
	            fnacimiento: response.data.fnacimiento,
	            nacionalidad: response.data.nacionalidad,
	            sexo: response.data.sexo,
	            direccion: response.data.direccion && response.data.direccion.trim()
	          });
	          setMostrar5(true);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "error al cargar el usuario",
	            icono: "informacion"
	          });
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response === undefined ? "Error de Conexion" : error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var agregarPersona = function agregarPersona() {
	    setOperacion(1);
	    setPersona();
	    setDeshabilitado(false);
	    setMostrar5(true);
	  };
	
	  var validarActuPersona = function validarActuPersona() {
	    if (operacion === 4) {
	      setMostrar5(false);
	      return;
	    }
	    setMostrar5(false);
	    renderizar();
	  };
	
	  var gestionarPersona = function gestionarPersona(id, ope) {
	    return function (event) {
	      event.preventDefault();
	      setOperacion(ope);
	      if (ope === 2) {
	        setDeshabilitado(false);
	      } else if (ope === 3 || ope === 4) {
	        setDeshabilitado(true);
	      }
	      setActivate(true);
	      SelectPersona(id);
	    };
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "container-fluid rounded" },
	    _react2.default.createElement(
	      "div",
	      { className: "container-fluid" },
	      _react2.default.createElement(
	        "div",
	        { className: "card" },
	        _react2.default.createElement(_modalActualizarPersona.ActualizarPersona, {
	          show: mostrar5,
	          titulo: titulo1,
	          mensaje: msg1,
	          onHideCancela: cerrarModalActualizar,
	          onHideAcepta: validarActuPersona,
	          persona: persona,
	          deshabilitado: deshabilitado ? deshabilitado : undefined,
	          operacion: operacion
	        }),
	        _react2.default.createElement(
	          _semanticUiReact.Dimmer,
	          { active: activate, inverted: true },
	          _react2.default.createElement(
	            _semanticUiReact.Loader,
	            { inverted: true },
	            "cargando..."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "content" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 row m-0 py-2" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-2" },
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    className: "form-control form-control-sm rounded-pill",
	                    onChange: handleSearch,
	                    placeholder: "Buscar"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-1 ml-auto" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      onClick: agregarPersona,
	                      disabled: permiso && permiso.substring(1, 2) !== "1",
	                      className: "btn btn-sm btn-primary rounded-circle"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-plus" }),
	                    " "
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12" },
	                _react2.default.createElement(
	                  TblContainer,
	                  null,
	                  _react2.default.createElement(TblHead, null),
	                  _react2.default.createElement(
	                    _core.TableBody,
	                    null,
	                    records && recordsAfterPagingAndSorting().map(function (item, index) {
	                      return _react2.default.createElement(
	                        _core.TableRow,
	                        { key: index, style: { padding: "0" } },
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseline",
	                            style: { textAlign: "center", width: "50px" }
	                          },
	                          item.cedula
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseline",
	                            style: { textAlign: "left", width: "250px" }
	                          },
	                          item.nombres
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseline",
	                            style: { textAlign: "left", width: "250px" }
	                          },
	                          item.apellidos
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseline",
	                            style: { textAlign: "center", width: "100px" }
	                          },
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              onClick: gestionarPersona(item.cedula, 4),
	                              className: "btn btn-sm  btn-info rounded-circle ml-2"
	                            },
	                            _react2.default.createElement("i", { className: "fas fa-eye" }),
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              onClick: gestionarPersona(item.cedula, 2),
	                              className: "btn btn-sm  btn-warning rounded-circle ml-2"
	                            },
	                            _react2.default.createElement("i", { className: "fa fa-edit" }),
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              onClick: gestionarPersona(item.cedula, 3),
	                              className: "btn btn-sm  btn-danger rounded-circle ml-2"
	                            },
	                            _react2.default.createElement("i", { className: "fa fa-trash" }),
	                            " "
	                          )
	                        )
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(TblPagination, null)
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_mensajes.Mensaje, {
	          mensaje: mensaje,
	          onHide: function onHide() {
	            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	          }
	        })
	      )
	    )
	  );
	}
	
	exports.default = TablaPersonas;

/***/ },
/* 7101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(19);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _modalActualizarPersonaAthos = __webpack_require__(7088);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _mensajes = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headCells = [{
	  id: "1",
	  backgroundColor: "rgba(5, 81, 130, 1)",
	  color: "#ffffff",
	  label: "CÉDULA",
	  textAlign: "center"
	}, {
	  id: "2",
	  backgroundColor: "rgba(5, 81, 130, 1)",
	  color: "#ffffff",
	  label: "NOMBRES",
	  textAlign: "center"
	}, {
	  id: "3",
	  backgroundColor: "rgba(5, 81, 130, 1)",
	  color: "#ffffff",
	  label: "APELLIDOS",
	  textAlign: "center"
	}, {
	  id: "opciones",
	  backgroundColor: "rgba(5, 81, 130, 1)",
	  color: "#ffffff",
	  label: " OPCIONES",
	  textAlign: "center"
	}];
	
	function TablaPersonaAthos() {
	  var _useState = (0, _react.useState)(),
	      _useState2 = _slicedToArray(_useState, 2),
	      titulo = _useState2[0],
	      setTitulo = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = _slicedToArray(_useState3, 2),
	      msg = _useState4[0],
	      setMsg = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(),
	      _useState6 = _slicedToArray(_useState5, 2),
	      titulo1 = _useState6[0],
	      setTitulo1 = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(),
	      _useState8 = _slicedToArray(_useState7, 2),
	      msg1 = _useState8[0],
	      setMsg1 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mostrar5 = _useState10[0],
	      setMostrar5 = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      contar = _useState12[0],
	      setContar = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      contar1 = _useState14[0],
	      setContar1 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      contar2 = _useState16[0],
	      setContar2 = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      contar3 = _useState18[0],
	      setContar3 = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      contar4 = _useState20[0],
	      setContar4 = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      contar5 = _useState22[0],
	      setContar5 = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0),
	      _useState24 = _slicedToArray(_useState23, 2),
	      contarRet = _useState24[0],
	      setContarRet = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(false),
	      _useState26 = _slicedToArray(_useState25, 2),
	      activate = _useState26[0],
	      setActivate = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      operacion = _useState28[0],
	      setOperacion = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(),
	      _useState30 = _slicedToArray(_useState29, 2),
	      usuarioH = _useState30[0],
	      setUsuarioH = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(),
	      _useState32 = _slicedToArray(_useState31, 2),
	      persona = _useState32[0],
	      setPersona = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(),
	      _useState34 = _slicedToArray(_useState33, 2),
	      organizacion = _useState34[0],
	      setOrganizacion = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(),
	      _useState36 = _slicedToArray(_useState35, 2),
	      configCome = _useState36[0],
	      setConfigCome = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(),
	      _useState38 = _slicedToArray(_useState37, 2),
	      usuariow = _useState38[0],
	      setUsuariow = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(),
	      _useState40 = _slicedToArray(_useState39, 2),
	      idUsuario = _useState40[0],
	      setIdUsuario = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(),
	      _useState42 = _slicedToArray(_useState41, 2),
	      deuda = _useState42[0],
	      setDeuda = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(),
	      _useState44 = _slicedToArray(_useState43, 2),
	      historico = _useState44[0],
	      setHistorico = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(),
	      _useState46 = _slicedToArray(_useState45, 2),
	      pagow = _useState46[0],
	      setPagow = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(),
	      _useState48 = _slicedToArray(_useState47, 2),
	      retencion = _useState48[0],
	      setRetencion = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(sessionStorage.getItem("espiritu")),
	      _useState50 = _slicedToArray(_useState49, 2),
	      espiritu = _useState50[0],
	      setEspiritu = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(sessionStorage.getItem("fechasistema")),
	      _useState52 = _slicedToArray(_useState51, 2),
	      fechaSistema = _useState52[0],
	      setFechaSistema = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(sessionStorage.getItem("anioactu")),
	      _useState54 = _slicedToArray(_useState53, 2),
	      anioActu = _useState54[0],
	      setAnioActu = _useState54[1];
	
	  var _useState55 = (0, _react.useState)(false),
	      _useState56 = _slicedToArray(_useState55, 2),
	      deshabilitado = _useState56[0],
	      setDeshabilitado = _useState56[1];
	
	  var _useState57 = (0, _react.useState)(),
	      _useState58 = _slicedToArray(_useState57, 2),
	      permiso = _useState58[0],
	      setPermiso = _useState58[1];
	
	  var _useState59 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState60 = _slicedToArray(_useState59, 2),
	      mensaje = _useState60[0],
	      setMensaje = _useState60[1];
	
	  var _useState61 = (0, _react.useState)([]),
	      _useState62 = _slicedToArray(_useState61, 2),
	      records = _useState62[0],
	      setRecords = _useState62[1];
	
	  var _useState63 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState64 = _slicedToArray(_useState63, 2),
	      filterFn = _useState64[0],
	      setFilterFn = _useState64[1];
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting,
	      TblPagination = _useTable.TblPagination;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.cedula.includes(target.value) || x.nombres.toUpperCase().includes(target.value.toUpperCase()) || x.apellidos.toUpperCase().includes(target.value.toUpperCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    var obj = JSON.parse(sessionStorage.getItem("post"));
	    setFechaSistema(obj.fechasistema);
	    seleccionarPersonas();
	  }, []);
	
	  var cerrarModalActualizar = function cerrarModalActualizar() {
	    setPersona();
	    setActivate(false);
	    setMostrar5(false);
	  };
	
	  var renderizar = function renderizar() {
	    seleccionarPersonas();
	  };
	
	  var seleccionarPersonas = function seleccionarPersonas() {
	    setActivate(true);
	    var campos = "cedula, trim(nombres) AS nombres, trim(apellidos) AS apellidos";
	    var nomtab = "persona";
	    var orden = "cedula";
	    var endpoint = op.conexion + "/api/athos/consulta/seleccionarregistros?campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	          setContar4(contar4 + 1);
	          setActivate(false);
	        } else {
	          setRecords([]);
	        }
	      }
	
	      setActivate(false);
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response === undefined ? "Error de Conexion" : error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var SelectPersona = function SelectPersona(cedula) {
	    var endpoint = op.conexion + "/api/athos/personas/selectpersona/" + cedula;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.cedula >= 0) {
	          setPersona({
	            cedula: response.data.cedula,
	            nombres: response.data.nombres && response.data.nombres.trim(),
	            apellidos: response.data.apellidos && response.data.apellidos.trim(),
	            correoe: response.data.correoe && response.data.correoe.trim(),
	            tlf1: response.data.tlf1 && response.data.tlf1.trim(),
	            tlf2: response.data.tlf2 && response.data.tlf2.trim(),
	            fnacimiento: response.data.fnacimiento,
	            nacionalidad: response.data.nacionalidad,
	            sexo: response.data.sexo,
	            direccion: response.data.direccion && response.data.direccion.trim()
	          });
	          setMostrar5(true);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "error al cargar el usuario",
	            icono: "informacion"
	          });
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response === undefined ? "Error de Conexion" : error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var agregarPersona = function agregarPersona() {
	    setOperacion(1);
	    setPersona();
	    setDeshabilitado(false);
	    setMostrar5(true);
	  };
	
	  var validarActuPersona = function validarActuPersona() {
	    if (operacion === 4) {
	      setMostrar5(false);
	      return;
	    }
	    setMostrar5(false);
	    renderizar();
	  };
	
	  var gestionarPersona = function gestionarPersona(id, ope) {
	    return function (event) {
	      event.preventDefault();
	      setOperacion(ope);
	      if (ope === 2) {
	        setDeshabilitado(false);
	      } else if (ope === 3 || ope === 4) {
	        setDeshabilitado(true);
	      }
	      setActivate(true);
	      SelectPersona(id);
	    };
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "container-fluid rounded" },
	    _react2.default.createElement(
	      "div",
	      { className: "container-fluid" },
	      _react2.default.createElement(
	        "div",
	        { className: "card" },
	        _react2.default.createElement(_modalActualizarPersonaAthos.ActualizarPersonaAthos, {
	          show: mostrar5,
	          titulo: titulo1,
	          mensaje: msg1,
	          onHideCancela: cerrarModalActualizar,
	          onHideAcepta: validarActuPersona,
	          persona: persona,
	          deshabilitado: deshabilitado ? deshabilitado : undefined,
	          operacion: operacion
	        }),
	        _react2.default.createElement(
	          _semanticUiReact.Dimmer,
	          { active: activate, inverted: true },
	          _react2.default.createElement(
	            _semanticUiReact.Loader,
	            { inverted: true },
	            "cargando..."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "content" },
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 row m-0 py-2" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-2" },
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    className: "form-control form-control-sm rounded-pill",
	                    onChange: handleSearch,
	                    placeholder: "Buscar"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-1 ml-auto" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      onClick: agregarPersona,
	                      disabled: permiso && permiso.substring(1, 2) !== "1",
	                      className: "btn btn-sm btn-primary rounded-circle"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-plus" }),
	                    " "
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12" },
	                _react2.default.createElement(
	                  TblContainer,
	                  null,
	                  _react2.default.createElement(TblHead, null),
	                  _react2.default.createElement(
	                    _core.TableBody,
	                    null,
	                    records && recordsAfterPagingAndSorting().map(function (item, index) {
	                      return _react2.default.createElement(
	                        _core.TableRow,
	                        { key: index, style: { padding: "0" } },
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseline",
	                            style: { textAlign: "center", width: "50px" }
	                          },
	                          item.cedula
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseline",
	                            style: { textAlign: "left", width: "250px" }
	                          },
	                          item.nombres
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseline",
	                            style: { textAlign: "left", width: "250px" }
	                          },
	                          item.apellidos
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-baseline",
	                            style: { textAlign: "center", width: "100px" }
	                          },
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              onClick: gestionarPersona(item.cedula, 4),
	                              className: "btn btn-sm  btn-info rounded-circle ml-2"
	                            },
	                            _react2.default.createElement("i", { className: "fas fa-eye" }),
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              onClick: gestionarPersona(item.cedula, 2),
	                              className: "btn btn-sm  btn-warning rounded-circle ml-2"
	                            },
	                            _react2.default.createElement("i", { className: "fa fa-edit" }),
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              onClick: gestionarPersona(item.cedula, 3),
	                              className: "btn btn-sm  btn-danger rounded-circle ml-2"
	                            },
	                            _react2.default.createElement("i", { className: "fa fa-trash" }),
	                            " "
	                          )
	                        )
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(TblPagination, null)
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_mensajes.Mensaje, {
	          mensaje: mensaje,
	          onHide: function onHide() {
	            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	          }
	        })
	      )
	    )
	  );
	}
	
	exports.default = TablaPersonaAthos;

/***/ },
/* 7102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _cartas = __webpack_require__(300);
	
	var _cartas2 = _interopRequireDefault(_cartas);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoPlanCuenta = __webpack_require__(655);
	
	var _catalogoPlanCuenta2 = _interopRequireDefault(_catalogoPlanCuenta);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _modalIncluirCuentas = __webpack_require__(7105);
	
	var _catalogoAsientos = __webpack_require__(7020);
	
	var _catalogoAsientos2 = _interopRequireDefault(_catalogoAsientos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var TablaAsientosContables = function TablaAsientosContables() {
	
	  var headCells = [{ id: 'codigo', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CUENTA', textAlign: 'center' }, { id: 'nombre', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' }, { id: 'rif', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DEBE', textAlign: 'center' }, { id: 'nrolicencia', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'HABER', textAlign: 'center' }, { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }];
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var anio = JSON.parse(sessionStorage.getItem('anioactu'));
	  var inputElement = document.getElementById('codigocuenta');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var idefiscal = JSON.parse(sessionStorage.getItem('idefiscal'));
	  var accbtnastcntable = JSON.parse(sessionStorage.getItem('accbtnastcntablec'));
	
	  var fechaTope = (0, _moment2.default)(JSON.parse(sessionStorage.getItem('fechasistema'))).format('YYYY-MM-DD').replace(anio.toString(), (anio - 18).toString());
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	    var st = '';
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") return items;else return items.filter(function (x) {
	          st = x.status === '51' ? 'activo' : 'inactivo';
	          if (x.idagente.includes(target.value) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.rif.toLowerCase().includes(target.value.toLowerCase()) || x.nrolicencia.toLowerCase().includes(target.value.toLowerCase()) || st.toLowerCase().includes(target.value.toLowerCase())) {
	            return x;
	          }
	        });
	      }
	    });
	  };
	  var txtDebe = (0, _react.useRef)();
	  var txtHaber = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var cmbTipoAsiento = (0, _react.useRef)();
	  var txtOrdenPago = (0, _react.useRef)();
	  var txtEgreso = (0, _react.useRef)();
	  var txtAsiento = (0, _react.useRef)();
	  var txtId = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	  var cmbTipo = (0, _react.useRef)();
	  var txtDeducible = (0, _react.useRef)();
	  var chkPorcen = (0, _react.useRef)();
	  var chkMilPorcen = (0, _react.useRef)();
	  var chkUniTri = (0, _react.useRef)();
	  var chkMontFij = (0, _react.useRef)();
	  var chkOtroPor = (0, _react.useRef)();
	  var txtOtroPorcen = (0, _react.useRef)();
	  var txtIdAgente = (0, _react.useRef)();
	  var txtCuentaContable = (0, _react.useRef)();
	  var cmbNaturaleza = (0, _react.useRef)();
	  var cmbTipoPago = (0, _react.useRef)();
	  var cmbTipoRecurso = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      mostrar = _useState2[0],
	      setMostrar = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      operacion = _useState4[0],
	      setOperacion = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(),
	      _useState6 = _slicedToArray(_useState5, 2),
	      cuentaContable = _useState6[0],
	      setCuentaContable = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      records = _useState8[0],
	      setRecords = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({ fn: function fn(items) {
	      return items;
	    } }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      filterFn = _useState10[0],
	      setFilterFn = _useState10[1];
	
	  var _useState11 = (0, _react.useState)('visible'),
	      _useState12 = _slicedToArray(_useState11, 2),
	      visibleBtn = _useState12[0],
	      setVisibleBtn = _useState12[1];
	
	  var _useState13 = (0, _react.useState)('visible'),
	      _useState14 = _slicedToArray(_useState13, 2),
	      visibleId = _useState14[0],
	      setVisibleId = _useState14[1];
	
	  var _useState15 = (0, _react.useState)('collapse'),
	      _useState16 = _slicedToArray(_useState15, 2),
	      visibleOtro = _useState16[0],
	      setVisibleOtro = _useState16[1];
	
	  var _useState17 = (0, _react.useState)('hidden'),
	      _useState18 = _slicedToArray(_useState17, 2),
	      visibleISLR = _useState18[0],
	      setVisibleISLR = _useState18[1];
	
	  var _useState19 = (0, _react.useState)('Gestionar Asientos Contables.'),
	      _useState20 = _slicedToArray(_useState19, 2),
	      tituloHeader = _useState20[0],
	      setTituloHeader = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(''),
	      _useState22 = _slicedToArray(_useState21, 2),
	      agregar = _useState22[0],
	      setAgregar = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(true),
	      _useState24 = _slicedToArray(_useState23, 2),
	      habilitado = _useState24[0],
	      setHabilitado = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(false),
	      _useState26 = _slicedToArray(_useState25, 2),
	      catalogoBene = _useState26[0],
	      setCatalogoBene = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(false),
	      _useState28 = _slicedToArray(_useState27, 2),
	      catalogoCuenta = _useState28[0],
	      setCatalogoCuenta = _useState28[1];
	
	  var _useState29 = (0, _react.useState)({
	    idagente: '',
	    nombre: ''
	  }),
	      _useState30 = _slicedToArray(_useState29, 2),
	      tercero = _useState30[0],
	      setTercero = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(0),
	      _useState32 = _slicedToArray(_useState31, 2),
	      tablaCata = _useState32[0],
	      setTablaCata = _useState32[1];
	
	  var _useState33 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState34 = _slicedToArray(_useState33, 2),
	      mensaje = _useState34[0],
	      setMensaje = _useState34[1];
	
	  var _useState35 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState36 = _slicedToArray(_useState35, 2),
	      mensajesino = _useState36[0],
	      setMensajesino = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(false),
	      _useState38 = _slicedToArray(_useState37, 2),
	      activate = _useState38[0],
	      setActivate = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(),
	      _useState40 = _slicedToArray(_useState39, 2),
	      idmovi = _useState40[0],
	      setIdmovi = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(false),
	      _useState42 = _slicedToArray(_useState41, 2),
	      catalogoAsi = _useState42[0],
	      setCatalogoAsi = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    catalogoBene: true
	  }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      botones = _useState44[0],
	      setBotones = _useState44[1];
	
	  var _useState45 = (0, _react.useState)({
	    codigocuenta: '',
	    debe: '',
	    descripcion: '',
	    haber: '',
	    idplancuenta: '',
	    idcuentacontable: '',
	    tipo: 0
	  }),
	      _useState46 = _slicedToArray(_useState45, 2),
	      values = _useState46[0],
	      setValues = _useState46[1];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting,
	      TblPagination = _useTable.TblPagination;
	
	  var handleInputNumChange = function handleInputNumChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    /* setValues({...values, [inputElement.name]:maskIt('00-000-00-00-000', event.target.value)});
	    txtCuentaContable.current.value = maskIt('00-000-00-00-000', event.target.value);
	    */
	    if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57 || event.which >= 96 && event.which <= 105) {
	
	      /* if(cod.length == 2 || cod.length == 6 || cod.length == 9 || cod.length == 12 ){
	       
	       num = cod.trim() + '-';
	       txtCuentaContable.current.value = num;
	       
	           }
	      setValues({ ...values, [event.target.name]:num}); */
	
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false; //alert(e.which);
	  };
	
	  var _useState47 = (0, _react.useState)(),
	      _useState48 = _slicedToArray(_useState47, 2),
	      ciudades = _useState48[0],
	      setCiudades = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(true),
	      _useState50 = _slicedToArray(_useState49, 2),
	      habilitadoNU = _useState50[0],
	      setHabilitadoNU = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(0),
	      _useState52 = _slicedToArray(_useState51, 2),
	      operacionPer = _useState52[0],
	      setOperacionPer = _useState52[1];
	
	  var blanquear = function blanquear() {
	
	    txtDebe.current.value = '';
	    txtHaber.current.value = '';
	    setRecords('');
	    txtId.current.setAttribute("disabled", true);
	    setOperacion(0);
	    setTituloHeader('Gestionar Asientos Contables.');
	    setVisibleISLR('hidden');
	    setVisibleOtro('collapse');
	    setVisibleBtn('visible');
	    setVisibleId('visible');
	
	    setValues({
	      codigocuenta: '',
	      debe: '',
	      descripcion: '',
	      haber: '',
	      idplancuenta: '',
	      idcuentacontable: '',
	      tipo: 0
	    });
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      catalogoBene: true
	    });
	
	    txtId.current.value = '';
	    txtDescripcion.current.value = '';
	    setActivate(false);
	    setHabilitado(true);
	    setHabilitadoNU(true);
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + '/api/contabilidad/actualizarasiento';
	
	    var body = void 0;
	
	    body = {
	
	      operacion: ope,
	      idasi: txtId.current.value !== '' ? txtId.current.value : 0,
	      fec: txtFecha.current.value,
	      descri: txtDescripcion.current.value.toUpperCase().trim(),
	      idorden: 0,
	      idefi: parseInt(idefiscal),
	      rever: 0,
	      idasireve: 0,
	      llamado: 0,
	      nTipo: parseInt(tablaCata),
	      asientos: records,
	      operasiento: 1
	    };
	
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (ope === 1) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
	        } else if (ope === 2) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
	        } else if (ope === 3) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
	        }
	
	        blanquear();
	
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = '';
	      if (error.response === undefined) {
	        mensaje = 'Error de Conexion';
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
	          mensaje = 'Ya existe un Registro';
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	
	    if (mensajesino.texto === 'Desea Eliminar Esta Cuenta de la Lista.') {
	      var array2 = [];
	      for (var i = 0; i < records.length; i++) {
	
	        if (parseInt(records[i].idplancuenta) !== parseInt(cuentaContable.idplancuenta)) {
	          array2.push(records[i]);
	        }
	      }
	      setRecords(array2);
	
	      var debe = 0;
	      var haber = 0;
	
	      for (var _i = 0; _i < array2.length; _i++) {
	        debe = parseFloat(debe) + parseFloat(array2[_i].debe.toString());
	        haber = parseFloat(haber) + parseFloat(array2[_i].haber.toString());
	      }
	
	      txtDebe.current.value = (0, _varios.formatMoneda)(debe.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	      txtHaber.current.value = (0, _varios.formatMoneda)(haber.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	    } else {
	      procesarRegistro();
	    }
	
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var onChange = function onChange(event) {
	
	    if (event.target.name === 'descripcion') {
	      event.target.value = event.target.value;
	      setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value)));
	    } else if (event.target.name === 'unidad') {
	      if (event.target.value === '4') {
	        setVisibleOtro('visible');
	      } else {
	        setVisibleOtro('collapse');
	        txtOtroPorcen.current.value = '';
	      }
	      setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value)));
	    } else if (event.target.name === 'tipo') {
	
	      setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value)));
	    } else if (event.target.name === 'tipoasiento') {
	      setTablaCata(event.target.value);
	    } else {
	      setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value)));
	    }
	  };
	
	  var cargarTabla = function cargarTabla(values) {
	    setMostrar(false);
	
	    var sigue = true;
	    var debe = 0;
	    var haber = 0;
	
	    for (var i = 0; i < records.length; i++) {
	      if (values.idplancuenta === records[i].idplancuenta) {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Esta Cuenta ya se encuentra Agregada.', icono: 'informacion' });
	        sigue = false;
	      }
	    }
	    if (sigue) {
	
	      var arreglo = [];
	
	      if (parseInt(tablaCata) === 0) {
	        arreglo.push({
	          codigocuenta: values.codigocuenta,
	          debe: values.debe,
	          descripcion: values.descripcion,
	          haber: values.haber,
	          idplancuenta: values.idplancuenta
	
	        });
	      } else {
	        arreglo.push({
	          codigocuenta: values.codigocuenta,
	          debe: values.debe,
	          descripcion: values.descripcion,
	          haber: values.haber,
	          idplancuenta: values.idplancuenta,
	          idcuentacontable: values.idcuentacontable
	        });
	      }
	
	      setRecords(arreglo);
	    }
	
	    for (var _i2 = 0; _i2 < records.length; _i2++) {
	      debe = parseFloat(debe) + parseFloat(records[_i2].debe.toString());
	      haber = parseFloat(haber) + parseFloat(records[_i2].haber.toString());
	    }
	
	    txtDebe.current.value = (0, _varios.formatMoneda)(debe.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	    txtHaber.current.value = (0, _varios.formatMoneda)(haber.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	
	    /*  if(tablaCata === 0){
	       let endpoint = `${op.conexion}/api/contabilidad/validarcuenta?idplancuenta=${parseInt(values.idplancuenta)}`;
	      
	       axios.get(endpoint, {
	         headers: {
	           'x-access-token': `${token}`
	         }
	       }).then(function (response) {
	         if (response.status === 200) {
	           setMostrar(false)
	               if (response.data !== '') {
	               setActivate(false)
	             setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Esta Cuenta ya se encuentra Aperturada.', icono: 'informacion' });
	             } else {
	             let sigue = true;
	     
	             for (let i = 0; i < records.length; i++) {
	               if (values.idplancuenta === records[i].idplancuenta) {
	                 setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Esta Cuenta ya se encuentra Agregada.', icono: 'informacion' });
	                 sigue = false;
	               }
	             }
	             if (sigue) {
	               records.push(values);
	             }
	             setActivate(false)
	           } 
	             }
	       
	       }).catch(function (error) {
	         setActivate(false);
	         setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	       })
	     } else {
	       
	       setActivate(false)
	      } */
	  };
	
	  var seleccionarCuentaConta = function seleccionarCuentaConta(id) {
	
	    var endpoint = op.conexion + '/api/contabilidad/ctaconta/?idcuentacontable=' + id + '&idefiscal=' + parseInt(idefiscal);
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	
	          setCuentaContable(response.data[0]);
	          setMostrar(true);
	        }
	      }
	    }).catch(function (error) {
	
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarDetalle = function seleccionarDetalle(id) {
	
	    var endpoint = op.conexion + '/api/contabilidad/detalleasiento?idefiscal=' + idefiscal + '&idasiento=' + parseInt(id);
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        if (response.data !== '') {
	
	          var debe = 0;
	          var haber = 0;
	
	          setRecords(response.data);
	          for (var i = 0; i < response.data.length; i++) {
	            debe = parseFloat(debe) + parseFloat(response.data[i].debe.toString());
	            haber = parseFloat(haber) + parseFloat(response.data[i].haber.toString());
	          }
	
	          txtDebe.current.value = (0, _varios.formatMoneda)(debe.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	          txtHaber.current.value = (0, _varios.formatMoneda)(haber.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro(id) {
	
	    setCatalogoAsi(false);
	    var campos = '*';
	    var nomtab = 'asiento';
	    var nomid = 'idasiento';
	    var nomid2 = 'idefiscal';
	
	    /*   let id = txtId.current.value; */
	    var endpoint = op.conexion + '/api/consulta/modeli2?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&nomid2=' + nomid2 + '&id=' + parseInt(id) + '&id2=' + idefiscal;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        if (response.data !== '') {
	
	          setValues(response.data);
	          txtId.current.value = response.data.idasiento;
	          txtDescripcion.current.value = response.data.descripcion;
	          cmbTipoAsiento.current.values = parseInt(response.data.tipo);
	          seleccionarDetalle(response.data.idasiento);
	          setTablaCata(parseInt(response.data.tipo));
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una Cuenta Contable con este Codigo.', icono: 'informacion' });
	          txtDescripcion.current.value = '';
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var validarPlancuenta = function validarPlancuenta(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value !== '') {
	
	        seleccionarRegistro(event.target.value);
	      } else {
	        setValues({
	          tipo: '',
	          codigocuenta: '',
	          descripcion: '',
	          idefiscal: '',
	          cargable: '',
	          naturaleza: '',
	          tipopago: '',
	          tiporecurso: ''
	        });
	      }
	    }
	  };
	
	  var onCatalogoPlanCuenta = function onCatalogoPlanCuenta(value) {
	    setCatalogoCuenta(false);
	    seleccionarRegistro(value.idplancuenta);
	
	    if (!botones.modificar) {
	      setBotones(Object.assign({}, botones, { catalogoBene: false }));
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	
	    var sigue = true;
	
	    if (!botones.incluir || !botones.modificar) {
	
	      if (txtDescripcion.current.value === '') {
	
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar la descripción del Asiento.', icono: 'informacion' });
	        sigue = false;
	        txtDescripcion.current.focus();
	      } else if (records.length < 2) {
	
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar al memos dos Cuentas.', icono: 'informacion' });
	        sigue = false;
	      } else if (parseFloat(txtDebe.current.value) !== parseFloat(txtHaber.current.value)) {
	
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Total del Debe y el Total del Haber deben Coincidir.', icono: 'informacion' });
	        sigue = false;
	      }
	    }
	    if (sigue) {
	
	      var msg = '';
	      if (!botones.incluir) {
	        msg = 'Esta Seguro de Registrar estos Datos.';
	      } else if (!botones.modificar) {
	        msg = 'Esta Seguro de Modificar estos Datos.';
	      } else if (!botones.eliminar) {
	        msg = 'Esta Seguro de Eliminar estos Datos.';
	      }
	
	      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	    }
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	
	      setOperacion(op);
	      e.preventDefault();
	
	      if (op === 1) {
	
	        if (accbtnastcntable && accbtnastcntable.toString().substring(0, 1) === '1') {
	          setVisibleBtn('hidden');
	          setVisibleId('collapse');
	          setTituloHeader('Incluir Asientos Contables.');
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            catalogoBene: false
	          });
	          txtDescripcion.current.removeAttribute("disabled");
	          txtDescripcion.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 2) {
	
	        if (accbtnastcntable && accbtnastcntable.toString().substring(1, 2) === '1') {
	          setTituloHeader('Editar Asientos Contables.');
	          txtId.current.removeAttribute("disabled");
	          setVisibleBtn('hidden');
	          txtId.current.focus();
	          setHabilitado(false);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoBene: true
	          });
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 3) {
	
	        if (accbtnastcntable && accbtnastcntable.toString().substring(3, 4) === '1') {
	          setTituloHeader('Eliminar Asientos Contables.');
	          setVisibleBtn('hidden');
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoBene: true
	          });
	          txtId.current.removeAttribute("disabled");
	          txtId.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 4) {
	
	        if (accbtnastcntable && accbtnastcntable.toString().substring(2, 3) === '1') {
	          setTituloHeader('Consultar Asientos Contables.');
	          setVisibleBtn('hidden');
	          setHabilitado(true);
	          txtId.current.focus();
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            catalogoBene: true
	          });
	          txtId.current.removeAttribute("disabled");
	          txtId.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        setVisibleBtn('visible');
	        blanquear();
	      }
	    };
	  };
	
	  var gestionarCuenta = function gestionarCuenta(op, data) {
	    return function (e) {
	      e.preventDefault();
	      setIdmovi(data.idmovimientocontable);
	      setOperacion(op);
	      if (op === 1) {
	        setMostrar(true);
	      } else {
	        seleccionarCuentaConta(data.idcuentacontable);
	      }
	    };
	  };
	
	  var gestionarCuenta2 = function gestionarCuenta2(op, item) {
	    return function (e) {
	      e.preventDefault();
	
	      var array = [];
	      var array2 = [];
	      setOperacion(op);
	
	      if (parseInt(op) === 2) {
	        for (var i = 0; i < records.length; i++) {
	          if (parseInt(records[i].idplancuenta) === parseInt(item.idplancuenta)) {
	            setCuentaContable(records[i]);
	          } else {
	            array2.push(records[i]);
	          }
	        }
	
	        setRecords(array2);
	        setMostrar(true);
	      } else {
	
	        setMensajesino({ mostrar: true, titulo: 'Notificación.', texto: 'Desea Eliminar Esta Cuenta de la Lista.', icono: 'informacion' });
	        setCuentaContable(item);
	      }
	    };
	  };
	
	  (0, _react.useEffect)(function () {}, []);
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', width: '100%' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'row col-md-12 py-5', style: { margin: 0 } },
	      _react2.default.createElement(
	        'div',
	        { className: 'row col-md-12 py-2', style: { margin: 0 } },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-7 col-lg-7 py-3 mx-auto card shadow ' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 row mx-auto  rounded py-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light justify-content-between' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  tituloHeader
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-3 d-flex justify-content-end' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '/inicio', className: 'text-light ' },
	                  _react2.default.createElement('i', { className: 'fas fa-times mx-2' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'fw-bold' },
	                    'Salir'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row mx-auto border-azul py-3 d-flex justify-content-between rounded', style: { fontSizeAdjust: '0.6' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'p-0 col-md-12 row justify-content-between mx-auto' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm mb-3 col-xl-3 col-lg-4 col-md-6 col-sm-5', style: { visibility: visibleId } },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'CODIGO:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', className: 'form-control fs-6', ref: txtId, name: 'idasiento', 'aria-label': 'Sizing example input', disabled: true, 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: validarPlancuenta, onBlur: validarPlancuenta, onChange: onChange }),
	                  _react2.default.createElement(
	                    'button',
	                    { type: 'button', disabled: botones.catalogo, onClick: function onClick() {
	                        setCatalogoAsi(true);
	                      }, className: 'btn btn-success' },
	                    _react2.default.createElement('i', { className: 'fas fa-search' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm mb-3 col-xl-3 col-lg-4 col-md-5 col-sm-5' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'FECHA:'
	                  ),
	                  _react2.default.createElement('input', { type: 'date', name: 'idcuentabancaria', className: 'form-control fs-6', ref: txtFecha, defaultValue: (0, _moment2.default)(fechasistema).format('YYYY-MM-DD'), disabled: habilitado, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm col-xl-8 col-lg-7  mb-3' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'DESCRIPCION:'
	                ),
	                _react2.default.createElement('input', { type: 'text', className: 'form-control text-uppercase rounded fs-6', ref: txtDescripcion, disabled: habilitado, name: 'descripcion', onChange: onChange })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm col-xl-4 col-lg-5 col-md-12 col-sm-12 mb-3 ' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'TIPO DE ASIENTO:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-select text-uppercase', 'aria-label': 'Default select example', name: 'tipo', disabled: botones.incluir, value: values.tipo.toString(), ref: cmbTipoAsiento, id: 'tipo', onChange: onChange },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '0' },
	                    'Apertura'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '1' },
	                    'Movimiento'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '2' },
	                    'Cierre'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'p-0 col-md-12 row mx-auto justify-content-center' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm mx-auto mb-3 col-xl-4 col-lg-4 col-md-12' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    '#ORDEN DE PAGO:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', name: 'idcuentabancaria', className: 'form-control fs-6', disabled: habilitado, ref: txtOrdenPago, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: validarPlancuenta, onBlur: validarPlancuenta })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm mx-auto mb-3 col-xl-3 col-lg-3 col-md-12' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    '#EGRESO:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', name: 'idcuentabancaria', className: 'form-control fs-6', disabled: habilitado, ref: txtEgreso, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: validarPlancuenta, onBlur: validarPlancuenta })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm mx-auto mb-3 col-xl-5 col-lg-5 col-md-12' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'CODIGO ASIENTO A REVERSAR:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', name: 'idcuentabancaria', className: 'form-control fs-6', disabled: habilitado, ref: txtAsiento, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: validarPlancuenta, onBlur: validarPlancuenta })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12 p-2' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'row col-12 d-flex justify-content-end' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col-3 d-flex justify-content-end' },
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'btn btn-sm btn-primary rounded-circle', disabled: !botones.consultar, onClick: gestionarCuenta(1, '') },
	                      _react2.default.createElement('i', { className: 'fas fa-plus' }),
	                      ' '
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12', style: { margin: "auto" } },
	                _react2.default.createElement(
	                  TblContainer,
	                  null,
	                  _react2.default.createElement(TblHead, null),
	                  _react2.default.createElement(
	                    _core.TableBody,
	                    null,
	                    records && recordsAfterPagingAndSorting().map(function (item, index) {
	                      return _react2.default.createElement(
	                        _core.TableRow,
	                        { key: index, style: { padding: "0", fontSizeAdjust: '0.6' } },
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                          item.codigocuenta
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                          item.descripcion
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                          (0, _varios.formatMoneda)(item.debe.replace(',', '').replace('.', ','), ',', '.', 2)
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                          (0, _varios.formatMoneda)(item.haber.toString().replace(',', '').replace('.', ','), ',', '.', 2)
	                        ),
	                        !botones.incluir ? _react2.default.createElement(
	                          _core.TableCell,
	                          { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                          _react2.default.createElement(
	                            'button',
	                            { onClick: gestionarCuenta2(2, item), className: "btn btn-sm mx-1 btn-warning rounded-circle" },
	                            _react2.default.createElement('i', { className: 'fa fa-edit' }),
	                            ' '
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            { onClick: gestionarCuenta2(3, item), className: "btn btn-sm mx-1 btn-danger rounded-circle" },
	                            _react2.default.createElement('i', { className: 'fa fa-trash' }),
	                            ' '
	                          )
	                        ) : _react2.default.createElement(
	                          _core.TableCell,
	                          { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center' } },
	                          _react2.default.createElement(
	                            'button',
	                            { onClick: gestionarCuenta(4, item), className: "btn btn-sm mx-1 btn-info rounded-circle" },
	                            _react2.default.createElement('i', { className: 'fas fa-eye' }),
	                            ' '
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            { onClick: gestionarCuenta(2, item), disabled: !botones.consultar, className: "btn btn-sm mx-1 btn-warning rounded-circle" },
	                            _react2.default.createElement('i', { className: 'fa fa-edit' }),
	                            ' '
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            { onClick: gestionarCuenta(3, item), disabled: !botones.consultar, className: "btn btn-sm mx-1 btn-danger rounded-circle" },
	                            _react2.default.createElement('i', { className: 'fa fa-trash' }),
	                            ' '
	                          )
	                        )
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(TblPagination, null),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-xl-12 row justify-content-end mt-2 px-0' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-3 col-xl-3 col-lg-4 col-md-6 col-sm-6' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                      'Total Debe:'
	                    ),
	                    _react2.default.createElement('input', { type: 'text', className: 'form-control text-right ', disabled: true, ref: txtDebe, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-3 col-xl-3 col-lg-4 col-md-6 col-sm-6' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                      'Total Haber:'
	                    ),
	                    _react2.default.createElement('input', { type: 'text', className: 'form-control text-right ', disabled: true, ref: txtHaber, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 d-flex justify-content-between mt-2' },
	              visibleBtn === 'visible' ? _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-sm-12 col-lg-12 col-12  justify-content-start' },
	                _react2.default.createElement(
	                  'button',
	                  { disabled: botones.incluir, onClick: onBotones(1), className: 'btn btn-sm mx-1 btn-primary rounded-pill', style: { height: '27px' }, title: 'Incluir Plan Cuenta' },
	                  _react2.default.createElement(
	                    'i',
	                    { style: { fontSize: '9px' }, className: 'fas fa-plus' },
	                    ' Incluir '
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: botones.consultar, onClick: onBotones(4), className: 'btn btn-sm mx-1 btn-info rounded-pill', style: { height: '27px' }, title: 'Consultar Plan Cuenta' },
	                  _react2.default.createElement(
	                    'i',
	                    { style: { fontSize: '9px' }, className: 'fas fa-eye' },
	                    'Consultar'
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: botones.modificar, onClick: onBotones(2), className: 'btn btn-sm mx-1 btn-warning rounded-pill', style: { height: '27px' }, title: 'Modificar Plan Cuenta' },
	                  _react2.default.createElement(
	                    'i',
	                    { style: { fontSize: '9px' }, className: 'fa fa-edit' },
	                    'Modificar'
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: botones.eliminar, onClick: onBotones(3), className: 'btn btn-sm mx-1 btn-danger rounded-pill', style: { height: '27px' }, title: 'Eliminar Plan Cuenta' },
	                  _react2.default.createElement(
	                    'i',
	                    { style: { fontSize: '9px' }, className: 'fa fa-trash' },
	                    'Eliminar'
	                  ),
	                  ' '
	                )
	              ) : '',
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 d-flex justify-content-end', style: { visibility: visibleBtn === 'visible' ? 'collapse' : 'visible' } },
	                _react2.default.createElement(
	                  'button',
	                  { disabled: botones.aceptar, onClick: onBotones(5), ref: btnAcepta, style: { height: '27px' }, className: 'mx-2 btn btn-sm rounded-pill btn-success' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle', style: { fontSize: '9px' } },
	                    '  Aceptar'
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: botones.cancelar, onClick: onBotones(6), ref: btnCancela, style: { height: '27px' }, className: 'mx-2 btn btn-danger btn-sm rounded-pill' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close', style: { fontSize: '9px' } },
	                    ' Cancelar'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_modalIncluirCuentas.ModalIncluirCuenta, {
	      tabla: parseInt(tablaCata),
	      show: mostrar,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar(false);
	      },
	      operacion: operacion,
	      cargarTabla: cargarTabla,
	      cuentaContable: cuentaContable,
	      estadoboton: botones.incluir,
	      idmovi: idmovi,
	      asientoId: values.idasiento ? values.idasiento !== '' ? values.idasiento : 0 : 0,
	      renderizar: seleccionarRegistro
	
	    }),
	    _react2.default.createElement(_catalogoAsientos2.default, {
	
	      show: catalogoAsi,
	      onHideCancelar: function onHideCancelar() {
	        setCatalogoAsi(false);
	      },
	      onHideAceptaCatalogo: seleccionarRegistro
	
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        'cargando...'
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	      } }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	      }, onHideSi: handleCloseSi })
	  );
	};
	exports.default = TablaAsientosContables;

/***/ },
/* 7103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _cartas = __webpack_require__(300);
	
	var _cartas2 = _interopRequireDefault(_cartas);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoPlanCuenta = __webpack_require__(655);
	
	var _catalogoPlanCuenta2 = _interopRequireDefault(_catalogoPlanCuenta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var TablaCatalogoCuentaContable = function TablaCatalogoCuentaContable() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var anio = JSON.parse(sessionStorage.getItem('anioactu'));
	  var inputElement = document.getElementById('codigocuenta');
	
	  var accbtncntcontable = JSON.parse(sessionStorage.getItem('accbtncntcontablec'));
	  var fechaTope = (0, _moment2.default)(JSON.parse(sessionStorage.getItem('fechasistema'))).format('YYYY-MM-DD').replace(anio.toString(), (anio - 18).toString());
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	
	  var txtId = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	  var cmbTipo = (0, _react.useRef)();
	  var txtDeducible = (0, _react.useRef)();
	  var chkPorcen = (0, _react.useRef)();
	  var chkMilPorcen = (0, _react.useRef)();
	  var chkUniTri = (0, _react.useRef)();
	  var chkMontFij = (0, _react.useRef)();
	  var chkOtroPor = (0, _react.useRef)();
	  var txtOtroPorcen = (0, _react.useRef)();
	  var txtIdAgente = (0, _react.useRef)();
	  var txtCuentaContable = (0, _react.useRef)();
	  var cmbNaturaleza = (0, _react.useRef)();
	  var cmbTipoPago = (0, _react.useRef)();
	  var cmbTipoRecurso = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      operacion = _useState2[0],
	      setOperacion = _useState2[1];
	
	  var _useState3 = (0, _react.useState)('visible'),
	      _useState4 = _slicedToArray(_useState3, 2),
	      visibleBtn = _useState4[0],
	      setVisibleBtn = _useState4[1];
	
	  var _useState5 = (0, _react.useState)('visible'),
	      _useState6 = _slicedToArray(_useState5, 2),
	      visibleId = _useState6[0],
	      setVisibleId = _useState6[1];
	
	  var _useState7 = (0, _react.useState)('collapse'),
	      _useState8 = _slicedToArray(_useState7, 2),
	      visibleOtro = _useState8[0],
	      setVisibleOtro = _useState8[1];
	
	  var _useState9 = (0, _react.useState)('hidden'),
	      _useState10 = _slicedToArray(_useState9, 2),
	      visibleISLR = _useState10[0],
	      setVisibleISLR = _useState10[1];
	
	  var _useState11 = (0, _react.useState)('Gestionar Cuentas Contables.'),
	      _useState12 = _slicedToArray(_useState11, 2),
	      tituloHeader = _useState12[0],
	      setTituloHeader = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(true),
	      _useState14 = _slicedToArray(_useState13, 2),
	      habilitado = _useState14[0],
	      setHabilitado = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      catalogoBene = _useState16[0],
	      setCatalogoBene = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      catalogoCuenta = _useState18[0],
	      setCatalogoCuenta = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({
	    idagente: '',
	    nombre: ''
	  }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      tercero = _useState20[0],
	      setTercero = _useState20[1];
	
	  var _useState21 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState22 = _slicedToArray(_useState21, 2),
	      mensaje = _useState22[0],
	      setMensaje = _useState22[1];
	
	  var _useState23 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState24 = _slicedToArray(_useState23, 2),
	      mensajesino = _useState24[0],
	      setMensajesino = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(false),
	      _useState26 = _slicedToArray(_useState25, 2),
	      activate = _useState26[0],
	      setActivate = _useState26[1];
	
	  var _useState27 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    catalogoBene: true
	  }),
	      _useState28 = _slicedToArray(_useState27, 2),
	      botones = _useState28[0],
	      setBotones = _useState28[1];
	
	  var _useState29 = (0, _react.useState)({
	    idplancuenta: '',
	    codigocuenta: '',
	    descripcion: '',
	    idefiscal: '',
	    cargable: '',
	    naturaleza: '',
	    tipopago: '',
	    tiporecurso: ''
	  }),
	      _useState30 = _slicedToArray(_useState29, 2),
	      values = _useState30[0],
	      setValues = _useState30[1];
	
	  var handleInputNumChange = function handleInputNumChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    setValues(Object.assign({}, values, _defineProperty({}, inputElement.name, maskIt('00-000-00-00-000', event.target.value))));
	    txtCuentaContable.current.value = maskIt('00-000-00-00-000', event.target.value);
	
	    if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57 || event.which >= 96 && event.which <= 105) {
	
	      /* if(cod.length == 2 || cod.length == 6 || cod.length == 9 || cod.length == 12 ){
	       
	       num = cod.trim() + '-';
	       txtCuentaContable.current.value = num;
	       
	           }
	      setValues({ ...values, [event.target.name]:num}); */
	
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false; //alert(e.which);
	  };
	
	  var _useState31 = (0, _react.useState)(),
	      _useState32 = _slicedToArray(_useState31, 2),
	      ciudades = _useState32[0],
	      setCiudades = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(true),
	      _useState34 = _slicedToArray(_useState33, 2),
	      habilitadoNU = _useState34[0],
	      setHabilitadoNU = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(0),
	      _useState36 = _slicedToArray(_useState35, 2),
	      operacionPer = _useState36[0],
	      setOperacionPer = _useState36[1];
	
	  var blanquear = function blanquear() {
	
	    txtCuentaContable.current.value = '';
	    txtId.current.setAttribute("disabled", true);
	    setOperacion(0);
	    setTituloHeader('Gestionar Cuentas Contables.');
	    setVisibleISLR('hidden');
	    setVisibleOtro('collapse');
	    setVisibleBtn('visible');
	    setVisibleId('visible');
	
	    setValues({
	      idplancuenta: '',
	      codigocuenta: '',
	      descripcion: '',
	      idefiscal: '',
	      cargable: '',
	      naturaleza: '',
	      tipopago: '',
	      tiporecurso: ''
	    });
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      catalogoBene: true
	    });
	
	    txtId.current.value = '';
	    txtDescripcion.current.value = '';
	
	    cmbTipo.current.value = '';
	
	    setActivate(false);
	    setHabilitado(true);
	    setHabilitadoNU(true);
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + '/api/contabilidad/actualizarplancuenta';
	
	    var body = void 0;
	    var codig = txtCuentaContable.current.value.trim().replace('-', '');
	
	    body = {
	      operacion: ope,
	      nid: values.idplancuenta === '' ? 0 : values.idplancuenta,
	      codigo: codig,
	      descri: values.descripcion.toUpperCase(),
	      carga: parseInt(values.cargable) === 0 ? true : false,
	      idefi: 0,
	      natu: parseInt(values.naturaleza),
	      tippago: parseInt(values.tipopago),
	      tiprecu: parseInt(values.tiporecurso)
	    };
	
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (ope === 1) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
	        } else if (ope === 2) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
	        } else if (ope === 3) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
	        }
	
	        blanquear();
	
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = '';
	      if (error.response === undefined) {
	        mensaje = 'Error de Conexion';
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
	          mensaje = 'Ya existe un Registro';
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    procesarRegistro();
	  };
	
	  var onChange = function onChange(event) {
	
	    if (event.target.name === 'descripcion') {
	      event.target.value = event.target.value;
	      setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value)));
	    } else if (event.target.name === 'unidad') {
	      if (event.target.value === '4') {
	        setVisibleOtro('visible');
	      } else {
	        setVisibleOtro('collapse');
	        txtOtroPorcen.current.value = '';
	      }
	      setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value)));
	    } else if (event.target.name === 'tipo') {
	      if (event.target.value === '1') {
	        setVisibleISLR('visible');
	      } else {
	        setVisibleISLR('hidden');
	        txtDeducible.current.value = '';
	      }
	      setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value)));
	    } else {
	      setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value)));
	    }
	  };
	
	  var seleccionarRegistroPLanCuenta = function seleccionarRegistroPLanCuenta(id) {
	    var campos = '*';
	    var nomtab = 'plancuenta';
	    var nomid = 'idplancuenta';
	    /*   let id = txtId.current.value; */
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + parseInt(id);
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        if (response.data !== '') {
	
	          txtId.current.value = response.data.idplancuenta;
	          txtCuentaContable.current.value = response.data.codigocuenta.substring(0, 2) + '-' + response.data.codigocuenta.substring(2, 5) + '-' + response.data.codigocuenta.substring(5, 7) + '-' + response.data.codigocuenta.substring(7, 9) + '-' + response.data.codigocuenta.substring(9, 12);
	          txtDescripcion.current.value = response.data.descripcion.trim();
	          cmbTipo.current.value = response.data.cargable ? 0 : 1;
	          setValues(response.data);
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una Cuenta Contable con este Codigo.', icono: 'informacion' });
	          txtDescripcion.current.value = '';
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var validarPlancuenta = function validarPlancuenta(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value !== '') {
	
	        seleccionarRegistroPLanCuenta(event.target.value);
	      } else {
	        setValues({
	          idplancuenta: '',
	          codigocuenta: '',
	          descripcion: '',
	          idefiscal: '',
	          cargable: '',
	          naturaleza: '',
	          tipopago: '',
	          tiporecurso: ''
	        });
	        cmbTipo.current.value = '';
	        txtCuentaContable.current.value = '';
	        txtDescripcion.current.value = '';
	      }
	    }
	  };
	
	  var onCatalogoPlanCuenta = function onCatalogoPlanCuenta(value) {
	    setCatalogoCuenta(false);
	    seleccionarRegistroPLanCuenta(value.idplancuenta);
	
	    if (!botones.modificar) {
	      setBotones(Object.assign({}, botones, { catalogoBene: false }));
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	
	    var sigue = true;
	
	    if (!botones.incluir || !botones.modificar) {
	
	      /*   if( !botones.incluir && txtId.current.value === ''){
	             setMensaje({ mostrar: true, titulo: 'Notificación', texto:'Debe el Codigo de Registro.', icono: 'informacion' });
	            sigue = false;
	            txtId.current.focus();
	         } else */if (txtCuentaContable.current.value === '') {
	
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar el Codigo Cuenta Contable.', icono: 'informacion' });
	        sigue = false;
	        txtCuentaContable.current.focus();
	      } else if (txtDescripcion.current.value === '') {
	
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar Una Descripción.', icono: 'informacion' });
	        sigue = false;
	        txtDescripcion.current.focus();
	      } else if (cmbTipo.current.value === '') {
	
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar la Carga.', icono: 'informacion' });
	        sigue = false;
	        cmbTipo.current.focus();
	      } else if (cmbNaturaleza.current.value === '') {
	
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar la Naturaleza.', icono: 'informacion' });
	        sigue = false;
	        cmbNaturaleza.current.focus();
	      } else if (cmbTipoPago.current.value === '') {
	
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar un Tipo de Pago.', icono: 'informacion' });
	        sigue = false;
	        cmbTipoPago.current.focus();
	      } else if (cmbTipoRecurso.current.value === '') {
	
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar un Tipo de Recurso.', icono: 'informacion' });
	        sigue = false;
	        cmbTipoRecurso.current.focus();
	      }
	    }
	    if (sigue) {
	
	      var msg = '';
	      if (!botones.incluir) {
	        msg = 'Esta Seguro de Registrar estos Datos.';
	      } else if (!botones.modificar) {
	        msg = 'Esta Seguro de Modificar estos Datos.';
	      } else if (!botones.eliminar) {
	        msg = 'Esta Seguro de Eliminar estos Datos.';
	      }
	
	      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	    }
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	
	      setOperacion(op);
	      e.preventDefault();
	
	      if (op === 1) {
	
	        if (accbtncntcontable && accbtncntcontable.toString().substring(0, 1) === '1') {
	          setVisibleBtn('hidden');
	          setVisibleId('collapse');
	          setTituloHeader('Incluir Cuentas Contables.');
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            catalogoBene: false
	          });
	          txtCuentaContable.current.removeAttribute("disabled");
	          txtCuentaContable.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 2) {
	
	        if (accbtncntcontable && accbtncntcontable.toString().substring(1, 2) === '1') {
	          setTituloHeader('Editar Cuentas Contables.');
	          setVisibleBtn('hidden');
	          setHabilitado(false);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoBene: true
	          });
	          txtId.current.removeAttribute("disabled");
	          txtId.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 3) {
	
	        if (accbtncntcontable && accbtncntcontable.toString().substring(3, 4) === '1') {
	          setTituloHeader('Eliminar Cuentas Contables.');
	          setVisibleBtn('hidden');
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoBene: true
	          });
	          txtId.current.removeAttribute("disabled");
	          txtId.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 4) {
	
	        if (accbtncntcontable && accbtncntcontable.toString().substring(2, 3) === '1') {
	          setTituloHeader('Consultar Cuentas Contables.');
	          setVisibleBtn('hidden');
	          setHabilitado(true);
	          txtId.current.focus();
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            catalogoBene: true
	          });
	          txtId.current.removeAttribute("disabled");
	          txtId.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        setVisibleBtn('visible');
	        blanquear();
	      }
	    };
	  };
	
	  function numberCharactersPattern(pattern) {
	    var numberChars = 0;
	    for (var i = 0; i < pattern.length; i++) {
	      if (pattern[i] === '0') {
	        numberChars++;
	      }
	    }
	    return numberChars;
	  }
	
	  function maskIt(pattern, value) {
	    var position = 0;
	    var currentChar = 0;
	    var masked = '';
	    while (position < pattern.length && currentChar < value.length) {
	      if (pattern[position] === '0') {
	        masked += value[currentChar];
	        currentChar++;
	      } else {
	        masked += pattern[position];
	      }
	      position++;
	    }
	    return masked;
	  }
	  function isNumeric(char) {
	    return !isNaN(char - parseInt(char));
	  }
	
	  var content = '';
	  var maxChars = numberCharactersPattern('00-000-00-00-000');
	
	  function applyInputMask(mask) {
	
	    inputElement.addEventListener('keydown', function (e) {
	      e.preventDefault();
	      if (isNumeric(e.key) && content.length < maxChars) {
	        content += e.key;
	      }
	      if (e.keyCode == 8) {
	        if (content.length > 0) {
	          content = content.substr(0, content.length - 1);
	        }
	      }
	      setValues(Object.assign({}, values, _defineProperty({}, inputElement.name, maskIt('00-000-00-00-000', content))));
	    });
	  }
	
	  /*   document.addEventListener('DOMContentLoaded', function() { 
	      applyInputMask('00-000-00-00-000');
	    }); */
	
	  /*     useEffect(() => {
	        seleccionarRegistros()
	       
	    }, []);
	     */
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', width: '100%' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'row col-md-12 py-5', style: { margin: 0 } },
	      _react2.default.createElement(
	        'div',
	        { className: 'row col-md-12 py-2', style: { margin: 0 } },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-7 col-lg-9 py-3 mx-auto card shadow ' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 row mx-auto  rounded py-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light justify-content-between' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  tituloHeader
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-3 d-flex justify-content-end' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '/inicio', className: 'text-light ' },
	                  _react2.default.createElement('i', { className: 'fas fa-times mx-2' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'fw-bold' },
	                    'Salir'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row mx-auto border-azul py-3 rounded', style: { fontSizeAdjust: '0.6' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'p-0 col-md-12 ', style: { visibility: visibleId } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm mb-3 col-xl-2 col-lg-3 col-md-5 col-sm-4', style: { visibility: visibleId } },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'CODIGO:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', name: 'idcuentabancaria', className: 'form-control fs-6', disabled: true, ref: txtId, defaultValue: values.idplancuenta !== null || values.idplancuenta !== '' ? values.idplancuenta.trim() : '', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: validarPlancuenta, onBlur: validarPlancuenta }),
	                  _react2.default.createElement(
	                    'button',
	                    { type: 'button', disabled: botones.catalogo, onClick: function onClick() {
	                        setCatalogoCuenta(true);
	                      }, className: 'btn btn-success' },
	                    _react2.default.createElement('i', { className: 'fas fa-search' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm col-xl-4 col-lg-5 col-md-8 col-sm-6 mb-3 ' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'CUENTA CONTABLE:'
	                ),
	                _react2.default.createElement('input', { type: 'text', className: 'form-control rounded col-md-6 fs-6', ref: txtCuentaContable, disabled: habilitado, id: 'codigocuenta', name: 'codigocuenta', maxLength: 16, minLength: 16 /* value={values.codigocuenta} */, onKeyUp: handleInputNumChange, onChange: handleInputNumChange })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm col-xl-8 col-lg-7  mb-3' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'DESCRIPCION:'
	                ),
	                _react2.default.createElement('input', { type: 'text', className: 'form-control text-uppercase rounded fs-6', ref: txtDescripcion, disabled: habilitado, name: 'descripcion', onChange: onChange })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm mb-3 col-pd-230 px-2' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'CARGABLE:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-select text-uppercase text-center', 'aria-label': 'Default select example', name: 'cargable', ref: cmbTipo, id: 'cargable', onChange: onChange, disabled: habilitado },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    ' Seleccione'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '0' },
	                    'Si'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '1' },
	                    'No'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm mb-3 col-pd-340 px-1' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'NATURALEZA DE LA CUENTA:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-select text-uppercase text-center', 'aria-label': 'Default select example', value: values.naturaleza, ref: cmbNaturaleza, name: 'naturaleza', id: 'naturaleza', onChange: onChange, disabled: habilitado },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    ' Seleccione'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '1' },
	                    ' Acredora'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '2' },
	                    'Deudora'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm mb-3 col-pd-250 px-1' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'TIPO PAGO:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-select text-uppercase text-center', 'aria-label': 'Default select example', name: 'tipopago', value: values.tipopago, ref: cmbTipoPago, id: 'tipopago', onChange: onChange, disabled: habilitado },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    ' Seleccione'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '5' },
	                    ' Orden Compra'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '7' },
	                    'Pago de Obra'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '11' },
	                    'Orden Servicio'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '12' },
	                    'Pago Directo'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '13' },
	                    'Pago Nomina'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm mb-3 col-pd-250 px-1' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'TIPO RECURSO:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-select text-uppercase text-center', 'aria-label': 'Default select example', name: 'tiporecurso', value: values.tiporecurso, ref: cmbTipoRecurso, id: 'tiporecurso', onChange: onChange, disabled: habilitado },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    ' Seleccione'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '0' },
	                    ' Normal'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '1' },
	                    'Ordinario'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '2' },
	                    'Fides'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '3' },
	                    'LAE'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '4' },
	                    'Instituci\xF3n'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 d-flex justify-content-between mt-2' },
	              visibleBtn === 'visible' ? _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-sm-12 col-lg-12 col-12  justify-content-start' },
	                _react2.default.createElement(
	                  'button',
	                  { disabled: botones.incluir, onClick: onBotones(1), className: 'btn btn-sm mx-1 btn-primary rounded-pill', style: { height: '27px' }, title: 'Incluir Plan Cuenta' },
	                  _react2.default.createElement(
	                    'i',
	                    { style: { fontSize: '9px' }, className: 'fas fa-plus' },
	                    ' Incluir '
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: botones.consultar, onClick: onBotones(4), className: 'btn btn-sm mx-1 btn-info rounded-pill', style: { height: '27px' }, title: 'Consultar Plan Cuenta' },
	                  _react2.default.createElement(
	                    'i',
	                    { style: { fontSize: '9px' }, className: 'fas fa-eye' },
	                    'Consultar'
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: botones.modificar, onClick: onBotones(2), className: 'btn btn-sm mx-1 btn-warning rounded-pill', style: { height: '27px' }, title: 'Modificar Plan Cuenta' },
	                  _react2.default.createElement(
	                    'i',
	                    { style: { fontSize: '9px' }, className: 'fa fa-edit' },
	                    'Modificar'
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: botones.eliminar, onClick: onBotones(3), className: 'btn btn-sm mx-1 btn-danger rounded-pill', style: { height: '27px' }, title: 'Eliminar Plan Cuenta' },
	                  _react2.default.createElement(
	                    'i',
	                    { style: { fontSize: '9px' }, className: 'fa fa-trash' },
	                    'Eliminar'
	                  ),
	                  ' '
	                )
	              ) : '',
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 d-flex justify-content-end', style: { visibility: visibleBtn === 'visible' ? 'collapse' : 'visible' } },
	                _react2.default.createElement(
	                  'button',
	                  { disabled: botones.aceptar, onClick: onBotones(5), ref: btnAcepta, style: { height: '27px' }, className: 'mx-2 btn btn-sm rounded-pill btn-success' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle', style: { fontSize: '9px' } },
	                    '  Aceptar'
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: botones.cancelar, onClick: onBotones(6), ref: btnCancela, style: { height: '27px' }, className: 'mx-2 btn btn-danger btn-sm rounded-pill' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close', style: { fontSize: '9px' } },
	                    ' Cancelar'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoPlanCuenta2.default, {
	      show: catalogoCuenta,
	      onHideCancelar: function onHideCancelar() {
	        setCatalogoCuenta(false);
	      },
	      onHideAceptaCatalogo: onCatalogoPlanCuenta
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        'cargando...'
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	      } }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	      }, onHideSi: handleCloseSi })
	  );
	};
	exports.default = TablaCatalogoCuentaContable;

/***/ },
/* 7104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IncluirMovimiento = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IncluirMovimiento = exports.IncluirMovimiento = function IncluirMovimiento(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtIdMovimiento = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtReferencia = (0, _react.useRef)();
	  var cmbTipoMovimiento = (0, _react.useRef)();
	  var txtMotivo = (0, _react.useRef)();
	  var txtMonto = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      body = _useState2[0],
	      setBody = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      operacion = _useState4[0],
	      setOperacion = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      activate = _useState6[0],
	      setActivate = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      habilitado = _useState8[0],
	      setHabilitado = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mensaje = _useState10[0],
	      setMensaje = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mensajesino = _useState12[0],
	      setMensajesino = _useState12[1];
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'motivo') {
	      e.target.value = e.target.value;
	    } else {
	      e.target.value = e.target.value;
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	
	    var sigue = true;
	
	    if (cmbTipoMovimiento.current.value === '') {
	      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar el Tipo de Movimiento', icono: 'informacion' });
	      cmbTipoMovimiento.current.focus();
	      sigue = false;
	    } else if (txtFecha.current.value === '') {
	      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar la Fecha', icono: 'informacion' });
	      txtFecha.current.focus();
	      sigue = false;
	    } else if (txtReferencia.current.value === '') {
	      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar la Referencia', icono: 'informacion' });
	      txtReferencia.current.focus();
	      sigue = false;
	    } else if (txtMotivo.current.value === '') {
	      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar el Motivo de Movimiento', icono: 'informacion' });
	      txtMotivo.current.focus();
	      sigue = false;
	    } else if (txtMonto.current.value === '' || txtMonto.current.value === '0,00') {
	      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar el Monto de Movimiento', icono: 'informacion' });
	      txtMonto.current.focus();
	      sigue = false;
	    }
	
	    if (sigue) {
	      var movi = [];
	      movi.push({
	        idmovimientosentransito: txtIdMovimiento.current.value === '' ? 0 : txtIdMovimiento.current.value,
	        idcuentabancaria: props.idcuentabancaria,
	        fecha: txtFecha.current.value,
	        fechasis: fechasistema,
	        referencia: txtReferencia.current.value.toUpperCase(),
	        motivo: txtMotivo.current.value.toUpperCase(),
	        monto: txtMonto.current.value !== '' ? parseFloat(txtMonto.current.value.replace(/\./g, '').replace(',', '.')) : '0.00',
	        tipo: cmbTipoMovimiento.current.value,
	        conciliado: '0'
	      });
	
	      setBody({
	        movimiento: movi
	      });
	
	      var msg = '';
	      if (operacion === 1) {
	        msg = 'Esta Seguro de Registrar estos Datos.';
	      } else if (operacion === 2) {
	        msg = 'Esta Seguro de Modificar estos Datos.';
	      } else if (operacion === 3) {
	        msg = 'Esta Seguro de Eliminar estos Datos.';
	      }
	
	      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + '/api/banco/actualizarmovimientostransito/' + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
	        } else if (operacion === 2) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
	        } else if (operacion === 3) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = '';
	      if (error.response === undefined) {
	        mensaje = 'Error de Conexion';
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
	          mensaje = 'Ya existe un Registro con este rif';
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    procesarRegistro();
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setBody(null);
	    setHabilitado(false);
	
	    //txtIdMovimiento.current.setAttribute("disabled", true);
	    txtIdMovimiento.current.value = '';
	    cmbTipoMovimiento.current.value = '';
	    txtFecha.current.value = '';
	    txtReferencia.current.value = '';
	    txtMotivo.current.value = '';
	    txtMonto.current.value = '';
	  };
	
	  var cancelar = function cancelar() {
	    /*  blanquear(); */
	    props.onHideCancela();
	  };
	
	  var handleInputMontoChange = function handleInputMontoChange(event) {
	    (0, _varios.validaMonto)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
	        event.target.value = '0,00';
	      }
	      event.target.value = (0, _varios.formatoMonto)(event.target.value);
	      var char1 = event.target.value.substring(0, 1);
	      var char2 = event.target.value.substring(1, 2);
	      if (char1 === '0' && char2 !== ',') {
	        event.target.value = event.target.value.substring(1, event.target.value.legth);
	      }
	      if (event.which === 13) {
	        btnAcepta.current.focus();
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	
	      e.preventDefault();
	
	      if (op === 1) {
	        setHabilitado(false);
	        txtIdMovimiento.current.setAttribute("disabled", true);
	        setTimeout(function () {
	          return txtDescripcion.current.focus();
	        }, 200);
	      } else if (op === 2) {
	        txtIdMovimiento.current.removeAttribute("disabled");
	        setHabilitado(false);
	        txtIdMovimiento.current.focus();
	      } else if (op === 3) {
	        setHabilitado(true);
	        txtIdMovimiento.current.removeAttribute("disabled");
	        txtIdMovimiento.current.focus();
	      } else if (op === 4) {
	        setHabilitado(true);
	        txtIdMovimiento.current.removeAttribute("disabled");
	        txtIdMovimiento.current.focus();
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        blanquear();
	      } else if (op === 7) {
	        cancelar();
	      }
	    };
	  };
	
	  var cerrarModal = function cerrarModal() {
	    props.onHideRenderizar();
	    props.onHideCancela();
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    event.preventDefault();
	    if (event.which === 13) {
	      if (event.target.name === 'fechadoc') {
	        event.target.value = (0, _moment2.default)(event.target.value).format('YYYY-MM-DD');
	        txtReferencia.current.focus();
	      } else if (event.target.name === 'refe') {
	        txtMotivo.current.focus();
	      }
	    } else if (typeof event.which === 'undefined') {
	      if (event.target.name === 'fechadoc') {
	        event.target.value = (0, _moment2.default)(event.target.value).format('YYYY-MM-DD');
	      } else if (event.target.name === 'fechaingre') {
	        event.target.value = (0, _moment2.default)(event.target.value).format('YYYY-MM-DD');
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false; //alert(e.which);
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	        setOperacion(props.operacion);
	        setHabilitado(props.habilitado);
	        if (props.operacion === 1) {
	          txtIdMovimiento.current.value = props.idmovimiento;
	          txtIdMovimiento.current.focus();
	        } else {
	          txtIdMovimiento.current.value = props.registro.idmovimientosentransito;
	          cmbTipoMovimiento.current.value = props.registro.tipo;
	
	          txtFecha.current.value = (0, _moment2.default)(props.registro.fecha).format('YYYY-MM-DD');
	          txtReferencia.current.value = props.registro.referencia.trim();
	          txtMotivo.current.value = props.registro.motivo.trim();
	          txtMonto.current.value = (0, _varios.formatMoneda)(props.registro.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	          /*for (let i = 0; i < props.tipoingreso.length; i++) {
	            if (props.tipoingreso[i].descripcion === props.registro.tipomovimiento) {
	              cmbTipoMovimiento.current.selectedIndex = i;//props.tipoingreso[i].idtipo;
	              break;
	            }
	           }*/
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        _Modal2.default.Title,
	        { style: { color: "#fff" } },
	        'Incluir Movimiento.'
	      ),
	      _react2.default.createElement(
	        'button',
	        { ref: btnCancela, className: 'btn', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	        _react2.default.createElement('i', { className: 'far fa-window-close' })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'border-azul col-md-12 py-3 rounded mx-auto' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row col-md-12 rounded mx-auto', style: { fontSizeAdjust: '0.6' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-2 col-md-3' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'Id Movimiento:'
	              ),
	              _react2.default.createElement('input', { type: 'text', disabled: true, className: 'form-control bg-light', ref: txtIdMovimiento, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-2 col-md-4' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'Tipo Movimiento:'
	              ),
	              _react2.default.createElement(
	                'select',
	                { className: 'form-select form-select-sm ', disabled: !habilitado, ref: cmbTipoMovimiento, 'aria-label': '.form-select-sm example' },
	                _react2.default.createElement(
	                  'option',
	                  { value: '' },
	                  '--'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '0' },
	                  'Deposito'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '1' },
	                  'Transferencia'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '2' },
	                  'Nota Credito'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '3' },
	                  'Nota Debito'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: '4' },
	                  'Cheque'
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'col-md-3' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-2 col-md-4' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'Fecha:'
	              ),
	              _react2.default.createElement('input', { type: 'date', className: 'form-control bg-light', disabled: !habilitado, ref: txtFecha, defaultValue: (0, _moment2.default)(fechasistema).format('YYYY-MM-DD'), 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', name: 'fechadoc', onKeyUp: handleInputChange, onBlur: handleInputChange })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-2 col-md-4' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'Referencia:'
	              ),
	              _react2.default.createElement('input', { type: 'text', className: 'form-control bg-light text-uppercase', disabled: !habilitado, ref: txtReferencia, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', name: 'refe', onKeyUp: handleInputChange, onBlur: handleInputChange })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-2 col-md-12' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'Motivo:'
	              ),
	              _react2.default.createElement('textarea', { type: 'area', className: 'form-control text-uppercase bg-light', disabled: !habilitado, ref: txtMotivo, name: 'motivo', onChange: onChange, style: { height: 40 }, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 mx-auto row justify-content-end px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm mb-2 col-md-3' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text bg-transparent border-0', id: 'inputGroup-sizing-sm' },
	                  'Monto:'
	                ),
	                _react2.default.createElement('input', { type: 'text', className: 'form-control bg-light rounded text-right', defaultValue: '0,00', disabled: !habilitado, ref: txtMonto, onFocus: _varios.seleccionarCampo, onKeyUp: handleInputMontoChange, onBlur: handleInputMontoChange, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-5 row m-0 ml-auto' },
	        _react2.default.createElement(
	          'button',
	          { ref: btnAcepta, disabled: operacion === 4 ? true : false, onClick: onBotones(5), style: { height: '27px' }, className: 'btn col mx-1 my-1 btn-sm rounded-pill btn-success ' },
	          _react2.default.createElement(
	            'i',
	            { className: 'fas fa-check-circle', style: { fontSize: '9px' } },
	            '  Aceptar'
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { ref: btnSalir, onClick: onBotones(7), style: { height: '27px' }, className: 'btn col mx-1 my-1 btn-danger btn-sm rounded-pill ' },
	          _react2.default.createElement(
	            'i',
	            { className: 'fas fa-sign-out-alt', style: { fontSize: '9px' } },
	            ' Cancelar'
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalIncluirCuenta = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoAsientosCuentas = __webpack_require__(7021);
	
	var _catalogoAsientosCuentas2 = _interopRequireDefault(_catalogoAsientosCuentas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ModalIncluirCuenta = exports.ModalIncluirCuenta = function ModalIncluirCuenta(props) {
	
	    var token = sessionStorage.getItem('jwtToken');
	    var op = __webpack_require__(8);
	    var anio = JSON.parse(sessionStorage.getItem('anioactu'));
	    var fechasistema = (0, _moment2.default)(JSON.parse(sessionStorage.getItem('fechasistema'))).format('YYYY-MM-DD');
	    var deshabilitado = false;
	
	    var idefiscal = JSON.parse(sessionStorage.getItem('idefiscal'));
	
	    /*  variables de referencias */
	    var txtDebe = (0, _react.useRef)();
	    var txtHaber = (0, _react.useRef)();
	    var txtCuentaContable = (0, _react.useRef)();
	    var txtDescripcion = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	    var btnAcepta = (0, _react.useRef)();
	    var txtCedula = (0, _react.useRef)();
	    var txtNombreRespon = (0, _react.useRef)();
	    var txtObserStatus = (0, _react.useRef)();
	    var txtStatus = (0, _react.useRef)();
	    var txtDireccionRespon = (0, _react.useRef)();
	    var txtMonto = (0, _react.useRef)();
	    var txtCedulaPro = (0, _react.useRef)();
	    var txtNombrePro = (0, _react.useRef)();
	    var txtNumPro = (0, _react.useRef)();
	    var txtDireccionPro = (0, _react.useRef)();
	    var txtId = (0, _react.useRef)();
	    var txtFechaIns = (0, _react.useRef)();
	    var txtApeRespon = (0, _react.useRef)();
	    var txtEmail1 = (0, _react.useRef)();
	    var txtEmail2 = (0, _react.useRef)();
	    var txtFechNac = (0, _react.useRef)();
	    var cmbNacionalidad = (0, _react.useRef)();
	    var txtTipoNac = (0, _react.useRef)();
	    var txtTlf1 = (0, _react.useRef)();
	    var txtTlf2 = (0, _react.useRef)();
	    var chkIn = (0, _react.useRef)();
	    var chkIn1 = (0, _react.useRef)();
	    var chkIn2 = (0, _react.useRef)();
	    var txtCiudad = (0, _react.useRef)();
	    var txtMunicipio = (0, _react.useRef)();
	    var txtResolucion = (0, _react.useRef)();
	    var txtLicencia = (0, _react.useRef)();
	    var cmbSex = (0, _react.useRef)();
	
	    /*  variables de estados */
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState4 = _slicedToArray(_useState3, 2),
	        mensajesino = _useState4[0],
	        setMensajesino = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(false),
	        _useState6 = _slicedToArray(_useState5, 2),
	        mostrar = _useState6[0],
	        setMostrar = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(false),
	        _useState8 = _slicedToArray(_useState7, 2),
	        activate = _useState8[0],
	        setActivate = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(0),
	        _useState10 = _slicedToArray(_useState9, 2),
	        operacion = _useState10[0],
	        setOperacion = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(""),
	        _useState12 = _slicedToArray(_useState11, 2),
	        nacnalidad = _useState12[0],
	        setNacnalidad = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(false),
	        _useState14 = _slicedToArray(_useState13, 2),
	        catalogo = _useState14[0],
	        setCatalogo = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(false),
	        _useState16 = _slicedToArray(_useState15, 2),
	        habilitadoNU = _useState16[0],
	        setHabilitadoNU = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(0),
	        _useState18 = _slicedToArray(_useState17, 2),
	        operacionPer = _useState18[0],
	        setOperacionPer = _useState18[1];
	
	    var _useState19 = (0, _react.useState)('hidden'),
	        _useState20 = _slicedToArray(_useState19, 2),
	        observacion = _useState20[0],
	        setObservacion = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(),
	        _useState22 = _slicedToArray(_useState21, 2),
	        municipios = _useState22[0],
	        setMunicipios = _useState22[1];
	
	    var _useState23 = (0, _react.useState)(),
	        _useState24 = _slicedToArray(_useState23, 2),
	        ciudades = _useState24[0],
	        setCiudades = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(null),
	        _useState26 = _slicedToArray(_useState25, 2),
	        body = _useState26[0],
	        setBody = _useState26[1];
	
	    var _useState27 = (0, _react.useState)({
	        apellidos: "",
	        cedula: "",
	        ciudad: "",
	        correoe: "",
	        credito: "",
	        declara: 0,
	        direccion: "",
	        direccionage: "",
	        direccionresp: "",
	        email: "",
	        exonintereses: false,
	        exonintereses1x500: false,
	        exoninteresesmina: false,
	        exoninteresesproduccion: false,
	        exonmultas: false,
	        exonmultas1x500: false,
	        exonmultasmina: false,
	        exonmultasproduccion: false,
	        exonrecargos: false,
	        exonrecargos1x500: false,
	        exonrecargosmina: false,
	        exonrecargosproduccion: false,
	        fechainscripcion: "",
	        fechainscripcion1x1000: null,
	        fechainscripcionmina: null,
	        fechainscripcionproduccion: null,
	        fnacimiento: "",
	        idagente: "",
	        idtipoagente: "",
	        impuesto1x1000: false,
	        mina: false,
	        municipio: "",
	        nacionalidad: "",
	        nombre: "",
	        nombres: "",
	        nrolicencia: "",
	        nrolicencia1x1000: null,
	        nrolicenciamina: null,
	        nrolicenciaproduccion: null,
	        nroresolucion: "",
	        nroresolucion1x1000: null,
	        nroresolucionmina: null,
	        nroresolucionproduccion: null,
	        observacionstatus: "",
	        observacionstatus1x1000: null,
	        observacionstatusmina: null,
	        observacionstatusproduccion: null,
	        produccion: false,
	        reprelegal: "",
	        rif: '',
	        sexo: '',
	        status: '',
	        status1x1000: null,
	        statusmina: null,
	        statusproduccion: null,
	        telefono: "",
	        tlf1: '',
	        tlf2: ''
	    }),
	        _useState28 = _slicedToArray(_useState27, 2),
	        values = _useState28[0],
	        setValues = _useState28[1];
	
	    var styleInput = {
	        backgroundColor: '#ffff',
	        color: '#444242'
	    };
	
	    var styleInputDirec = {
	        backgroundColor: '#ffff',
	        color: '#444242',
	        height: 50
	
	    };
	
	    var onChange = function onChange(event) {
	        if (event.target.name === 'rif' || event.target.name === 'nombre' || event.target.name === 'direccionage' || event.target.name === 'email' || event.target.name === 'nombrerespo' || event.target.name === 'aperespo' || event.target.name === 'propiEmail' || event.target.name === 'licencia' || event.target.name === 'resolucion') {
	            event.target.value = event.target.value.toUpperCase();
	            setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value.toUpperCase())));
	        } else if (event.target.name === 'exonintereses' || event.target.name === 'exonmultas' || event.target.name === 'exonrecargos') {
	            if (event.target.checked) {
	                setValues(Object.assign({}, values, _defineProperty({}, event.target.name, true)));
	            } else {
	
	                setValues(Object.assign({}, values, _defineProperty({}, event.target.name, false)));
	            }
	        } else if (event.target.name === 'status') {
	            if (event.target.value === '52') {
	                if (observacion === 'hidden') {
	                    setObservacion('visible');
	                } else {
	                    setObservacion('hidden');
	                }
	            } else {
	                setObservacion('hidden');
	                txtObserStatus.current.value = '';
	            }
	            setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value)));
	        } else {
	            setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value)));
	        }
	    };
	
	    var handleInputMontoChange = function handleInputMontoChange(event) {
	        (0, _varios.validaMonto)(event);
	        if (event.which === 13 || typeof event.which === 'undefined') {
	            if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
	                event.target.value = '0,00';
	            }
	            event.target.value = (0, _varios.formatoMonto)(event.target.value);
	            var char1 = event.target.value.substring(0, 1);
	            var char2 = event.target.value.substring(1, 2);
	            if (char1 === '0' && char2 !== ',') {
	                event.target.value = event.target.value.substring(1, event.target.value.legth);
	            }
	        } else if (event.which === 46) {
	            return false;
	        } else if (event.which >= 48 && event.which <= 57) {
	            return true;
	        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	            return true;
	        } else return false;
	    };
	
	    var onChangeValidar = function onChangeValidar(e) {
	        e.preventDefault();
	        var columna = void 0;
	        var sigue = true;
	        if (operacion === 1 || operacion === 2) {
	            if (txtId.current.value.trim() === '') {
	
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar Alguna Cuenta.', icono: 'informacion' });
	                txtId.current.focus();
	                sigue = false;
	            } else if (txtDebe.current.value.trim() === '') {
	
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Ingrese el Monto del Debe.', icono: 'informacion' });
	                txtDebe.current.focus();
	                sigue = false;
	            } else if (txtHaber.current.value.trim() === '') {
	
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Ingrese el Monto del Haber.', icono: 'informacion' });
	                txtHaber.current.focus();
	                sigue = false;
	            } else if (parseInt(txtDebe.current.value.trim()) > 0 && parseInt(txtHaber.current.value.trim()) > 0) {
	
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El Debe o el Haber de ingresarse en 0,00 a comparación del otro.', icono: 'informacion' });
	                txtHaber.current.value = 0;
	                txtHaber.current.focus();
	                sigue = false;
	            }
	        }
	
	        if (parseInt(props.tabla) === 0) {
	            columna = {
	
	                idplancuenta: parseInt(txtId.current.value),
	                codigocuenta: txtCuentaContable.current.value,
	                descripcion: txtDescripcion.current.value,
	                debe: txtDebe.current.value.replace(/\./g, '').replace(',', '.'),
	                haber: txtHaber.current.value.replace(/\./g, '').replace(',', '.')
	
	            };
	        } else {
	            columna = {
	
	                idplancuenta: parseInt(txtId.current.value),
	                codigocuenta: txtCuentaContable.current.value,
	                descripcion: txtDescripcion.current.value,
	                debe: txtDebe.current.value.replace(/\./g, '').replace(',', '.'),
	                haber: txtHaber.current.value.replace(/\./g, '').replace(',', '.'),
	                idcuentacontable: values.idcuentacontable
	
	            };
	        }
	
	        if (sigue && !props.estadoboton) {
	
	            props.cargarTabla(columna);
	        } else if (sigue && props.estadoboton) {
	
	            var msg = '';
	            if (operacion === 1) {
	                msg = 'Esta Seguro de Registrar estos Datos.';
	            } else if (operacion === 2) {
	                msg = 'Esta Seguro de Modificar estos Datos.';
	            } else if (operacion === 3) {
	                msg = 'Esta Seguro de Eliminar estos Datos.';
	            }
	
	            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	        }
	    };
	
	    var procesarRegistro = function procesarRegistro() {
	        setActivate(true);
	        var endpoint = void 0;
	        var body = void 0;
	
	        if (operacion === 1) {
	
	            endpoint = op.conexion + '/api/contabilidad/asientocrear';
	
	            body = {
	
	                cuenta: values.codigocuenta,
	                debe: txtDebe.current.value.replace(/\./g, '').replace(',', '.'),
	                haber: txtHaber.current.value.replace(/\./g, '').replace(',', '.'),
	                efiscal: parseInt(idefiscal),
	                idcuenta: parseInt(props.tabla) === 0 ? parseInt(values.idplancuenta) : parseInt(values.idcuentacontable),
	                fechaMov: fechasistema,
	                idasiento: parseInt(props.asientoId),
	                tipo: parseInt(props.tabla)
	
	            };
	        } else if (operacion === 2) {
	
	            endpoint = op.conexion + '/api/contabilidad/asientomodificar';
	
	            body = {
	
	                cuenta: values.codigocuenta,
	                debe: txtDebe.current.value.replace(/\./g, '').replace(',', '.'),
	                haber: txtHaber.current.value.replace(/\./g, '').replace(',', '.'),
	                efiscal: parseInt(idefiscal),
	                idcuenta: parseInt(props.tabla) === 0 ? parseInt(values.idplancuenta) : parseInt(values.idcuentacontable),
	                fechaMov: fechasistema,
	                idasiento: parseInt(props.asientoId),
	                idmovimiento: parseInt(props.idmovi)
	
	            };
	        } else if (operacion === 3) {
	
	            endpoint = op.conexion + '/api/contabilidad/asientoeliminar';
	
	            body = {
	
	                cuenta: values.codigocuenta,
	                efiscal: parseInt(idefiscal),
	                idcuenta: parseInt(props.tabla) === 0 ? parseInt(values.idplancuenta) : parseInt(values.idcuentacontable),
	                idasiento: parseInt(props.asientoId),
	                idmovi: parseInt(props.idmovi)
	
	            };
	        }
	
	        _axios2.default.post(endpoint, body, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                if (props.operacion === 1) {
	                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
	                } else if (props.operacion === 2) {
	                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
	                } else if (props.operacion === 3) {
	                    setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
	                }
	
	                setActivate(false);
	            }
	        }).catch(function (error) {
	            var mensaje = '';
	            if (error.response === undefined) {
	                mensaje = 'Error de Conexion';
	            } else {
	                if (error.response.data.message === 'duplicate key value violates unique constraint "agente_rif_key"') {
	                    mensaje = 'Ya existe un Registro con este rif';
	                } else if (error.response.data.message === 'duplicate key value violates unique constraint "agente_email_key"') {
	                    mensaje = 'Ya existe un Registro con este correo';
	                } else {
	                    mensaje = error.response.data.message;
	                }
	            }
	            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setActivate(false);
	        setObservacion('hidden');
	        txtId.current.value = '';
	        txtCedula.current.value = '';
	        txtNombreRespon.current.value = '';
	        txtApeRespon.current.value = '';
	        txtDireccionRespon.current.value = '';
	        txtEmail1.current.value = '';
	        txtEmail2.current.value = '';
	        txtFechNac.current.value = '';
	        txtTlf1.current.value = '';
	        txtTlf2.current.value = '';
	        cmbNacionalidad.current.value = '';
	        cmbSex.current.value = '';
	        chkIn.current.checked = false;
	        chkIn2.current.checked = false;
	        chkIn1.current.checked = false;
	        setValues({});
	        setOperacion(0);
	    };
	
	    var handleCloseSi = function handleCloseSi() {
	        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        procesarRegistro();
	    };
	
	    var cancelar = function cancelar(e) {
	        e.preventDefault();
	        var columna = void 0;
	
	        if (props.estadoboton) {
	
	            columna = {
	
	                idplancuenta: parseInt(txtId.current.value),
	                codigocuenta: txtCuentaContable.current.value,
	                descripcion: txtDescripcion.current.value,
	                debe: txtDebe.current.value,
	                haber: txtHaber.current.value,
	                idcuentacontable: values.idcuentacontable ? values.idcuentacontable : ''
	
	            };
	            props.cargarTabla(columna);
	        } else {
	            props.onHideCancelar();
	        }
	    };
	
	    var handleAceptaCatalogoPer = function handleAceptaCatalogoPer(ced, corr, tlf1, tlf2, ape, direc, fcn, nac, nom, sex) {
	        setCatalogo(false);
	        setHabilitadoNU(false);
	        setOperacionPer(0);
	        setValues(Object.assign({}, values, {
	            cedula: ced,
	            correoe: corr !== null ? corr.trim() : '',
	            tlf1: tlf1 !== null ? tlf1.trim() : '',
	            tlf2: tlf2 !== null ? tlf2.trim() : '',
	            apellidos: ape !== null ? ape.trim() : '',
	            direccionresp: direc !== null ? direc.trim() : '',
	            fnacimiento: fcn !== null ? (0, _moment2.default)(fcn).format('YYYY-MM-DD') : '',
	            nacionalidad: nac !== null ? nac.toString().trim() : '',
	            nombres: nom !== null ? nom.trim() : '',
	            sexo: sex !== null ? sex.toString().trim() : ''
	        }));
	    };
	
	    /* valdar buscador por numero cedula */
	    var validarPersona = function validarPersona(event) {
	        event.preventDefault();
	        (0, _varios.validaSoloNumero)(event);
	        if (event.which === 13 || typeof event.which === 'undefined') {
	            if (event.target.value !== '') {
	                datosRes(event.target.value);
	            }
	        }
	    };
	
	    var datosRes = function datosRes(cedula) {
	        var campos = '*';
	        var nomtab = 'persona';
	        var nomid = 'cedula';
	        var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&id=' + cedula + '&nomtab=' + nomtab + '&nomid=' + nomid;
	        setActivate(true);
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                setHabilitadoNU(true);
	                setValues(Object.assign({}, values, {
	                    correoe: '',
	                    tlf1: '',
	                    tlf2: '',
	                    apellidos: '',
	                    direccionresp: '',
	                    fnacimiento: '',
	                    nacionalidad: '',
	                    nombres: '',
	                    sexo: ''
	                }));
	
	                if (response.data !== '') {
	                    setHabilitadoNU(false);
	                    setOperacionPer(0);
	                    setValues(Object.assign({}, values, {
	                        cedula: response.data.cedula,
	                        correoe: response.data.correoe,
	                        tlf1: response.data.tlf1,
	                        tlf2: response.data.tlf2,
	                        apellidos: response.data.apellidos,
	                        direccionresp: response.data.direccion,
	                        fnacimiento: (0, _moment2.default)(response.data.fnacimiento).format('YYYY-MM-DD'),
	                        nacionalidad: response.data.nacionalidad.toString(),
	                        nombres: response.data.nombres,
	                        sexo: response.data.sexo.toString()
	                    }));
	                } else {
	                    setOperacionPer(1);
	                    setHabilitadoNU(true);
	                    txtNombreRespon.current.focus();
	                }
	            }
	            setActivate(false);
	        }).catch(function (error) {
	            setActivate(false);
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	        });
	    };
	
	    var onHideAceptaCatalogo = function onHideAceptaCatalogo(values) {
	        setValues(values);
	        txtId.current.value = values.idplancuenta;
	        txtCuentaContable.current.value = values.codigocuenta;
	        txtDescripcion.current.value = values.descripcion;
	        setMostrar(false);
	    };
	
	    var cerrarModal = function cerrarModal() {
	        props.renderizar(props.asientoId);
	        props.onHideCancelar();
	        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        blanquear();
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'md',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                setOperacion(props.operacion);
	                setHabilitadoNU(false);
	                setOperacionPer(0);
	
	                if (props.operacion !== 1) {
	
	                    setValues(props.cuentaContable);
	                } else {
	                    txtDebe.current.value = '';
	                    txtHaber.current.value = '';
	                    setValues();
	                }
	            }
	
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2 header-modal' },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                { style: { color: "#fff" } },
	                props.operacion === 1 ? 'Agregar Cuenta Contable.' : props.operacion === 2 ? 'Editar Cuenta Contable.' : props.operacion === 3 ? 'Eliminar Cuenta Contable.' : 'Consultar Cuenta Contable.'
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'btn', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            { style: { backgroundColor: "#FFF" } },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'w-100 row mx-auto', style: { fontSizeAdjust: '0.6' } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group input-group-sm mx-auto mb-2 col-md-4' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                            'C\xF3digo:'
	                        ),
	                        _react2.default.createElement('input', { type: 'text', className: 'form-control', ref: txtId, value: values ? values.idplancuenta !== null ? values.idplancuenta : '' : '', 'aria-label': 'Sizing example input', disabled: true, 'aria-describedby': 'inputGroup-sizing-sm' }),
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'button', onClick: function onClick() {
	                                    setMostrar(true);
	                                }, className: 'btn btn-success' },
	                            _react2.default.createElement('i', { className: 'fas fa-search' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group input-group-sm mx-auto mb-2 col-md-8' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                            'Cuenta Contable:'
	                        ),
	                        _react2.default.createElement('input', { type: 'text', className: 'form-control', ref: txtCuentaContable, value: values ? values.codigocuenta !== null ? values.codigocuenta : '' : '', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group input-group-sm mx-auto mb-2 col-md-12' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                            'Descripci\xF3n:'
	                        ),
	                        _react2.default.createElement('input', { type: 'text', className: 'form-control', ref: txtDescripcion, disabled: true, value: values ? values.descripcion !== null ? values.descripcion : '' : '', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group input-group-sm mx-auto mb-2 col-md-6' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                            'Monto Debe:'
	                        ),
	                        _react2.default.createElement('input', { type: 'text', className: 'form-control text-right', disabled: operacion === 4 ? true : operacion === 3 ? true : false, 'aria-label': 'Sizing example input', defaultValue: values ? values.debe !== null ? values.debe : '' : '', ref: txtDebe, 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: handleInputMontoChange, placeholder: '0,00', onBlur: handleInputMontoChange })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'input-group input-group-sm mx-auto mb-2 col-md-6' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                            'Monto Haber:'
	                        ),
	                        _react2.default.createElement('input', { type: 'text', className: 'form-control text-right', disabled: operacion === 4 ? true : operacion === 3 ? true : false, 'aria-label': 'Sizing example input', ref: txtHaber, defaultValue: values ? values.haber !== null ? values.haber : '' : '', 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: handleInputMontoChange, placeholder: '0,00', onBlur: handleInputMontoChange })
	                    )
	                ),
	                _react2.default.createElement(_catalogoAsientosCuentas2.default, {
	                    show: mostrar,
	                    onHideCancelar: function onHideCancelar() {
	                        setMostrar(false);
	                    },
	                    tabla: props.tabla,
	                    onHideAceptaCatalogo: onHideAceptaCatalogo
	                }),
	                _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                    onHide: function onHide() {
	                        mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                    } }),
	                _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	                    onHideNo: function onHideNo() {
	                        return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	                    }, onHideSi: handleCloseSi }),
	                _react2.default.createElement(
	                    _semanticUiReact.Dimmer,
	                    { active: activate, inverted: true },
	                    _react2.default.createElement(
	                        _semanticUiReact.Loader,
	                        { inverted: true },
	                        'cargando...'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { ref: btnAcepta, disabled: operacion === 4 ? true : false, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-success col-md-3' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    '  Aceptar'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill col-md-3' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};

/***/ },
/* 7106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalPermisosUsuariosContabilidad = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTable = __webpack_require__(20);
	
	var _useTable2 = _interopRequireDefault(_useTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalPermisosUsuariosContabilidad = exports.ModalPermisosUsuariosContabilidad = function ModalPermisosUsuariosContabilidad(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
	  var idusuario = JSON.parse(sessionStorage.getItem("idusuario"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtLogin = (0, _react.useRef)();
	  var txtCedula = (0, _react.useRef)();
	  var txtStatus = (0, _react.useRef)();
	  var txtIduser = (0, _react.useRef)();
	
	  var txtuTodos = (0, _react.useRef)();
	  var txtuIncluir = (0, _react.useRef)();
	  var txtuModificar = (0, _react.useRef)();
	  var txtuCosultar = (0, _react.useRef)();
	  var txtuEliminar = (0, _react.useRef)();
	  var txtuImprimir = (0, _react.useRef)();
	
	  var txtdTodos = (0, _react.useRef)();
	  var txtdIncluir = (0, _react.useRef)();
	  var txtdModificar = (0, _react.useRef)();
	  var txtdCosultar = (0, _react.useRef)();
	  var txtdEliminar = (0, _react.useRef)();
	  var txtdImprimir = (0, _react.useRef)();
	
	  var txttTodos = (0, _react.useRef)();
	  var txttIncluir = (0, _react.useRef)();
	  var txttModificar = (0, _react.useRef)();
	  var txttCosultar = (0, _react.useRef)();
	  var txttEliminar = (0, _react.useRef)();
	  var txttImprimir = (0, _react.useRef)();
	
	  var txtcTodos = (0, _react.useRef)();
	  var txtcIncluir = (0, _react.useRef)();
	  var txtcModificar = (0, _react.useRef)();
	  var txtcCosultar = (0, _react.useRef)();
	  var txtcEliminar = (0, _react.useRef)();
	  var txtcImprimir = (0, _react.useRef)();
	
	  var txtcoTodos = (0, _react.useRef)();
	  var txtcoIncluir = (0, _react.useRef)();
	  var txtcoModificar = (0, _react.useRef)();
	  var txtcoCosultar = (0, _react.useRef)();
	  var txtcoEliminar = (0, _react.useRef)();
	  var txtcoImprimir = (0, _react.useRef)();
	
	  var txtsTodos = (0, _react.useRef)();
	  var txtsIncluir = (0, _react.useRef)();
	  var txtsModificar = (0, _react.useRef)();
	  var txtsCosultar = (0, _react.useRef)();
	  var txtsEliminar = (0, _react.useRef)();
	  var txtsImprimir = (0, _react.useRef)();
	
	  var txtsiTodos = (0, _react.useRef)();
	  var txtsiIncluir = (0, _react.useRef)();
	  var txtsiModificar = (0, _react.useRef)();
	  var txtsiCosultar = (0, _react.useRef)();
	  var txtsiEliminar = (0, _react.useRef)();
	  var txtsiImprimir = (0, _react.useRef)();
	
	  var txtoTodos = (0, _react.useRef)();
	  var txtoIncluir = (0, _react.useRef)();
	  var txtoModificar = (0, _react.useRef)();
	  var txtoCosultar = (0, _react.useRef)();
	  var txtoEliminar = (0, _react.useRef)();
	  var txtoImprimir = (0, _react.useRef)();
	
	  var txtnTodos = (0, _react.useRef)();
	  var txtnIncluir = (0, _react.useRef)();
	  var txtnModificar = (0, _react.useRef)();
	  var txtnCosultar = (0, _react.useRef)();
	  var txtnEliminar = (0, _react.useRef)();
	  var txtnImprimir = (0, _react.useRef)();
	
	  var txtdzTodos = (0, _react.useRef)();
	  var txtdzIncluir = (0, _react.useRef)();
	  var txtdzModificar = (0, _react.useRef)();
	  var txtdzCosultar = (0, _react.useRef)();
	  var txtdzEliminar = (0, _react.useRef)();
	  var txtdzImprimir = (0, _react.useRef)();
	
	  var txtocTodos = (0, _react.useRef)();
	  var txtocIncluir = (0, _react.useRef)();
	  var txtocModificar = (0, _react.useRef)();
	  var txtocCosultar = (0, _react.useRef)();
	  var txtocEliminar = (0, _react.useRef)();
	  var txtocImprimir = (0, _react.useRef)();
	
	  var txtReportTodos = (0, _react.useRef)();
	  var txtReport1 = (0, _react.useRef)();
	  var txtReport2 = (0, _react.useRef)();
	  var txtReport3 = (0, _react.useRef)();
	  var txtReport4 = (0, _react.useRef)();
	  var txtReport5 = (0, _react.useRef)();
	  var txtReport6 = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      modu1 = _useState2[0],
	      setModu1 = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      modu2 = _useState4[0],
	      setModu2 = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      modu3 = _useState6[0],
	      setModu3 = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      modu4 = _useState8[0],
	      setModu4 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      modu5 = _useState10[0],
	      setModu5 = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      modu6 = _useState12[0],
	      setModu6 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      modu7 = _useState14[0],
	      setModu7 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      modu8 = _useState16[0],
	      setModu8 = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      modu9 = _useState18[0],
	      setModu9 = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      modu10 = _useState20[0],
	      setModu10 = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      modu11 = _useState22[0],
	      setModu11 = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0),
	      _useState24 = _slicedToArray(_useState23, 2),
	      modu12 = _useState24[0],
	      setModu12 = _useState24[1];
	
	  var _useState25 = (0, _react.useState)({}),
	      _useState26 = _slicedToArray(_useState25, 2),
	      body = _useState26[0],
	      setBody = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      operacion = _useState28[0],
	      setOperacion = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      activate = _useState30[0],
	      setActivate = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(true),
	      _useState32 = _slicedToArray(_useState31, 2),
	      habilitado = _useState32[0],
	      setHabilitado = _useState32[1];
	
	  var _useState33 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState34 = _slicedToArray(_useState33, 2),
	      mensaje = _useState34[0],
	      setMensaje = _useState34[1];
	
	  var _useState35 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState36 = _slicedToArray(_useState35, 2),
	      mensajesino = _useState36[0],
	      setMensajesino = _useState36[1];
	
	  var _useState37 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState38 = _slicedToArray(_useState37, 2),
	      botones = _useState38[0],
	      setBotones = _useState38[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var SelectUsuario = function SelectUsuario(idusuario) {
	    var endpoint = op.conexion + '/api/athos/usuario/getuser?id=' + idusuario;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.idusuario > 0) {
	
	          var para1 = response.data.accbtncntcontable;
	          var para2 = response.data.accbtnastcntable;
	          var para3 = response.data.accbtnvinculacuenta;
	          var para4 = response.data.accbtnmvbancariost;
	          var para5 = response.data.accbtncntreports;
	
	          sessionStorage.setItem("accbtncntcontablec", JSON.stringify(para1));
	          sessionStorage.setItem("accbtnastcntablec", JSON.stringify(para2));
	          sessionStorage.setItem("accbtnvinculacuentac", JSON.stringify(para3));
	          sessionStorage.setItem("accbtnmvbancariostc", JSON.stringify(para4));
	          sessionStorage.setItem("accbtncntreportsc", JSON.stringify(para5));
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "Error al cargar el usuario",
	            icono: "informacion"
	          });
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var parameter1 = "";
	    var parameter2 = "";
	    var parameter3 = "";
	    var parameter4 = "";
	    var parameter5 = "";
	    var parameter6 = "";
	    var parameter7 = "";
	    var parameter8 = "";
	    var parameter9 = "";
	    var parameter10 = "";
	    var reportes = "";
	
	    if (props.usuario.acccontabilidad.toString().substring(0, 1) === '1') {
	
	      var val1 = txtuIncluir.current.checked === true ? "1" : "0";
	      var val2 = txtuModificar.current.checked === true ? "1" : "0";
	      var val3 = txtuCosultar.current.checked === true ? "1" : "0";
	      var val4 = txtuEliminar.current.checked === true ? "1" : "0";
	      var val5 = txtuImprimir.current.checked === true ? "1" : "0";
	
	      parameter1 = val1 + val2 + val3 + val4 + val5;
	    } else {
	
	      parameter1 = '000000';
	    }
	
	    if (props.usuario.acccontabilidad.toString().substring(1, 2) === '1') {
	
	      var _val = txtdIncluir.current.checked === true ? "1" : "0";
	      var _val2 = txtdModificar.current.checked === true ? "1" : "0";
	      var _val3 = txtdCosultar.current.checked === true ? "1" : "0";
	      var _val4 = txtdEliminar.current.checked === true ? "1" : "0";
	      var _val5 = txtdImprimir.current.checked === true ? "1" : "0";
	
	      parameter2 = _val + _val2 + _val3 + _val4 + _val5;
	    } else {
	
	      parameter2 = '000000';
	    }
	
	    if (props.usuario.acccontabilidad.toString().substring(2, 3) === '1') {
	
	      var _val6 = txttIncluir.current.checked === true ? "1" : "0";
	      var _val7 = txttModificar.current.checked === true ? "1" : "0";
	      var _val8 = txttCosultar.current.checked === true ? "1" : "0";
	      var _val9 = txttEliminar.current.checked === true ? "1" : "0";
	      var _val10 = txttImprimir.current.checked === true ? "1" : "0";
	
	      parameter3 = _val6 + _val7 + _val8 + _val9 + _val10;
	    } else {
	
	      parameter3 = '000000';
	    }
	
	    if (props.usuario.acccontabilidad.toString().substring(3, 4) === '1') {
	
	      var _val11 = txtcIncluir.current.checked === true ? "1" : "0";
	      var _val12 = txtcModificar.current.checked === true ? "1" : "0";
	      var _val13 = txtcCosultar.current.checked === true ? "1" : "0";
	      var _val14 = txtcEliminar.current.checked === true ? "1" : "0";
	      var _val15 = txtcImprimir.current.checked === true ? "1" : "0";
	
	      parameter4 = _val11 + _val12 + _val13 + _val14 + _val15;
	    } else {
	
	      parameter4 = '000000';
	    }
	
	    if (props.usuario.acccontabilidad.toString().substring(5, 6) === '1') {
	
	      var _val16 = txtReport1.current.checked === true ? "1" : "0";
	      var _val17 = txtReport2.current.checked === true ? "1" : "0";
	      var _val18 = txtReport3.current.checked === true ? "1" : "0";
	      var _val19 = txtReport4.current.checked === true ? "1" : "0";
	      var _val20 = txtReport5.current.checked === true ? "1" : "0";
	      var val6 = txtReport6.current.checked === true ? "1" : "0";
	
	      reportes = _val16 + _val17 + _val18 + _val19 + _val20 + val6;
	    } else {
	
	      reportes = '000000';
	    }
	
	    var sigue = true;
	    var mensaje = "";
	
	    if (sigue) {
	      var user = [];
	      user.push({
	        idusuario: txtIduser.current.value,
	        login: txtLogin.current.value,
	        persona: txtCedula.current.value,
	        status: txtStatus.current.value === 'ACTIVO' ? 1 : 0,
	        idorganizacion: idorganizacion,
	        accbtncntcontable: parameter1,
	        accbtnastcntable: parameter2,
	        accbtnvinculacuenta: parameter3,
	        accbtnmvbancariost: parameter4,
	        accbtncntreports: reportes
	      });
	
	      var _body = {
	        usu: JSON.stringify(user)
	      };
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	      setBody(_body);
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: mensaje,
	        icono: "informacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    var endpoint = op.conexion + '/api/athos/usuario/actualizar/' + operacion;
	
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setActivate(false);
	
	        if (parseInt(response.data.iduser) > 0) {
	          if (parseInt(response.data.iduser) === parseInt(idusuario)) {
	            SelectUsuario(parseInt(response.data.iduser));
	          }
	        }
	
	        var mensaje = "";
	        if (operacion === 1) {
	          mensaje = "El Usuario " + response.data.iduser + " ha sido registrada de manera satisfactoria.";
	        } else if (operacion === 2) {
	          mensaje = "El Usuario " + response.data.iduser + " ha sido Modificada de manera Satisfactoria.";
	        } else if (operacion === 3) {
	          mensaje = "El usuario " + response.data.iduser + " ha sido eliminada de manera satisfactoria.";
	        }
	
	        setMensaje({
	          mostrar: true,
	          titulo: "Exito.",
	          texto: mensaje,
	          icono: "exito"
	        });
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    procesarRegistro();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    props.onHideCancela();
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var checkBlank = function checkBlank(e) {
	
	    if (modu1 === 1) {
	      if (txtuIncluir.current.checked && txtuModificar.current.checked && txtuCosultar.current.checked && txtuEliminar.current.checked && txtuImprimir.current.checked) {
	        txtuTodos.current.checked = true;
	      } else {
	        txtuTodos.current.checked = false;
	      }
	    }
	
	    if (modu2 === 1) {
	      if (txtdIncluir.current.checked && txtdModificar.current.checked && txtdCosultar.current.checked && txtdEliminar.current.checked && txtdImprimir.current.checked) {
	        txtdTodos.current.checked = true;
	      } else {
	        txtdTodos.current.checked = false;
	      }
	    }
	
	    if (modu3 === 1) {
	      if (txttIncluir.current.checked && txttModificar.current.checked && txttCosultar.current.checked && txttEliminar.current.checked && txttImprimir.current.checked) {
	        txttTodos.current.checked = true;
	      } else {
	        txttTodos.current.checked = false;
	      }
	    }
	
	    if (modu4 === 1) {
	      if (txtcIncluir.current.checked && txtcModificar.current.checked && txtcCosultar.current.checked && txtcEliminar.current.checked && txtcImprimir.current.checked) {
	        txtcTodos.current.checked = true;
	      } else {
	        txtcTodos.current.checked = false;
	      }
	    }
	
	    if (modu5 === 1) {
	      if (txtReport1.current.checked && txtReport2.current.checked && txtReport3.current.checked && txtReport4.current.checked && txtReport5.current.checked && txtReport6.current.checked) {
	        txtReportTodos.current.checked = true;
	      } else {
	        txtReportTodos.current.checked = false;
	      }
	    }
	  };
	
	  var checkTodo = function checkTodo(e) {
	    if (e.target.name === "todos1") {
	      if (txtuTodos.current.checked) {
	        txtuIncluir.current.checked = true;
	        txtuModificar.current.checked = true;
	        txtuCosultar.current.checked = true;
	        txtuEliminar.current.checked = true;
	        txtuImprimir.current.checked = true;
	      } else {
	        txtuIncluir.current.checked = false;
	        txtuModificar.current.checked = false;
	        txtuCosultar.current.checked = false;
	        txtuEliminar.current.checked = false;
	        txtuImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos2") {
	      if (txtdTodos.current.checked) {
	        txtdIncluir.current.checked = true;
	        txtdModificar.current.checked = true;
	        txtdCosultar.current.checked = true;
	        txtdEliminar.current.checked = true;
	        txtdImprimir.current.checked = true;
	      } else {
	        txtdIncluir.current.checked = false;
	        txtdModificar.current.checked = false;
	        txtdCosultar.current.checked = false;
	        txtdEliminar.current.checked = false;
	        txtdImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos3") {
	      if (txttTodos.current.checked) {
	        txttIncluir.current.checked = true;
	        txttModificar.current.checked = true;
	        txttCosultar.current.checked = true;
	        txttEliminar.current.checked = true;
	        txttImprimir.current.checked = true;
	      } else {
	        txttIncluir.current.checked = false;
	        txttModificar.current.checked = false;
	        txttCosultar.current.checked = false;
	        txttEliminar.current.checked = false;
	        txttImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos4") {
	      if (txtcTodos.current.checked) {
	        txtcIncluir.current.checked = true;
	        txtcModificar.current.checked = true;
	        txtcCosultar.current.checked = true;
	        txtcEliminar.current.checked = true;
	        txtcImprimir.current.checked = true;
	      } else {
	        txtcIncluir.current.checked = false;
	        txtcModificar.current.checked = false;
	        txtcCosultar.current.checked = false;
	        txtcEliminar.current.checked = false;
	        txtcImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todosreportes") {
	      if (txtReportTodos.current.checked) {
	        txtReport1.current.checked = true;
	        txtReport2.current.checked = true;
	        txtReport3.current.checked = true;
	        txtReport4.current.checked = true;
	        txtReport5.current.checked = true;
	        txtReport6.current.checked = true;
	      } else {
	        txtReport1.current.checked = false;
	        txtReport2.current.checked = false;
	        txtReport3.current.checked = false;
	        txtReport4.current.checked = false;
	        txtReport5.current.checked = false;
	        txtReport6.current.checked = false;
	      }
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'xl',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.op === 1) {
	          setOperacion(2);
	          if (props.usuario.acccontabilidad.toString().substring(0, 1) === '1') {
	            setModu1(1);
	          } else {
	            setModu1(0);
	          }
	
	          if (props.usuario.acccontabilidad.toString().substring(1, 2) === '1') {
	            setModu2(1);
	          } else {
	            setModu2(0);
	          }
	
	          if (props.usuario.acccontabilidad.toString().substring(2, 3) === '1') {
	            setModu3(1);
	          } else {
	            setModu3(0);
	          }
	
	          if (props.usuario.acccontabilidad.toString().substring(3, 4) === '1') {
	            setModu4(1);
	          } else {
	            setModu4(0);
	          }
	
	          if (props.usuario.acccontabilidad.toString().substring(5, 6) === '1') {
	            setModu5(1);
	          } else {
	            setModu5(0);
	          }
	          setHabilitado(false);
	        } else {
	
	          setHabilitado(true);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Permisos de Usuario (Contabilidad)'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto m-0' },
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1 d-flex justify-content-around', style: { fontSizeAdjust: '0.6' } },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-6 fw-bold' },
	              'Datos del Usuarios'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-200 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'USUARIO:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtLogin, defaultValue: props.usuario && props.usuario.login, className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement('input', { type: 'hidden', ref: txtIduser, defaultValue: props.usuario && props.usuario.idusuario }),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-180 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'CEDULA:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtCedula, defaultValue: props.persona && props.persona.cedula, className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-500 px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'NOMBRES Y APELLIDOS:'
	                ),
	                _react2.default.createElement('input', { type: 'text', defaultValue: props.persona && props.persona.nombres.trim() + " " + props.persona.apellidos.trim(), className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-170 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'ESTATUS:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtStatus, defaultValue: props.usuario && props.usuario.status === '1' ? 'ACTIVO' : 'INACTIVO', className: 'form-control text-uppercase fs-6 text-center', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-5 fw-bold' },
	              'Modulos Autorizados'
	            ),
	            modu1 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Catalogo Cuenta Contable'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuTodos,
	                          defaultChecked: props.usuario.accbtncntcontable.substring(0, 1) === '1' && props.usuario.accbtncntcontable.substring(1, 2) === '1' && props.usuario.accbtncntcontable.substring(2, 3) === '1' && props.usuario.accbtncntcontable.substring(3, 4) === '1' && props.usuario.accbtncntcontable.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos1', id: 'inlineCheckboxu' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuIncluir, defaultChecked: props.usuario.accbtncntcontable.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuModificar, defaultChecked: props.usuario.accbtncntcontable.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuCosultar, defaultChecked: props.usuario.accbtncntcontable.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuEliminar, defaultChecked: props.usuario.accbtncntcontable.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuImprimir, defaultChecked: props.usuario.accbtncntcontable.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu2 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Asientos Contables'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdTodos,
	                          defaultChecked: props.usuario.accbtnastcntable.substring(0, 1) === '1' && props.usuario.accbtnastcntable.substring(1, 2) === '1' && props.usuario.accbtnastcntable.substring(2, 3) === '1' && props.usuario.accbtnastcntable.substring(3, 4) === '1' && props.usuario.accbtnastcntable.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos2', id: 'inlineCheckboxd' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdIncluir, defaultChecked: props.usuario.accbtnastcntable.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdModificar, defaultChecked: props.usuario.accbtnastcntable.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdCosultar, defaultChecked: props.usuario.accbtnastcntable.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdEliminar, defaultChecked: props.usuario.accbtnastcntable.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdImprimir, defaultChecked: props.usuario.accbtnastcntable.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu3 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Vinculaci\xF3n de Cuentas'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttTodos,
	                          defaultChecked: props.usuario.accbtnvinculacuenta.substring(0, 1) === '1' && props.usuario.accbtnvinculacuenta.substring(1, 2) === '1' && props.usuario.accbtnvinculacuenta.substring(2, 3) === '1' && props.usuario.accbtnvinculacuenta.substring(3, 4) === '1' && props.usuario.accbtnvinculacuenta.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos3', id: 'inlineCheckboxt' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttIncluir, defaultChecked: props.usuario.accbtnvinculacuenta.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttModificar, defaultChecked: props.usuario.accbtnvinculacuenta.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttCosultar, defaultChecked: props.usuario.accbtnvinculacuenta.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttEliminar, defaultChecked: props.usuario.accbtnvinculacuenta.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttImprimir, defaultChecked: props.usuario.accbtnvinculacuenta.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu4 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Movimientos Bancarios en Transito'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcTodos,
	                          defaultChecked: props.usuario.accbtnmvbancariost.substring(0, 1) === '1' && props.usuario.accbtnmvbancariost.substring(1, 2) === '1' && props.usuario.accbtnmvbancariost.substring(2, 3) === '1' && props.usuario.accbtnmvbancariost.substring(3, 4) === '1' && props.usuario.accbtnmvbancariost.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos4', id: 'inlineCheckboxc' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcIncluir, defaultChecked: props.usuario.accbtnmvbancariost.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcModificar, defaultChecked: props.usuario.accbtnmvbancariost.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcCosultar, defaultChecked: props.usuario.accbtnmvbancariost.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcEliminar, defaultChecked: props.usuario.accbtnmvbancariost.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcImprimir, defaultChecked: props.usuario.accbtnmvbancariost.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu5 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Reportes'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReportTodos,
	                          defaultChecked: props.usuario.accbtncntreports.substring(0, 1) === '1' && props.usuario.accbtncntreports.substring(1, 2) === '1' && props.usuario.accbtncntreports.substring(2, 3) === '1' && props.usuario.accbtncntreports.substring(3, 4) === '1' && props.usuario.accbtncntreports.substring(4, 5) === '1' && props.usuario.accbtncntreports.substring(5, 6) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todosreportes', id: 'inlineCheckboxr' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport1, defaultChecked: props.usuario.accbtncntreports.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr1' },
	                          '...'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport2, defaultChecked: props.usuario.accbtncntreports.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr2' },
	                          '...'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport3, defaultChecked: props.usuario.accbtncntreports.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr3' },
	                          '...'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport4, defaultChecked: props.usuario.accbtncntreports.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr4' },
	                          '...'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport5, defaultChecked: props.usuario.accbtncntreports.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr5' },
	                          '...'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport6, defaultChecked: props.usuario.accbtncntreports.substring(5, 6) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr6' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr6' },
	                          '...'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : ''
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-4 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: props.usuario && props.usuario.status === '0' ? true : false, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-success' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check-circle' },
	              '  Aceptar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _cartas = __webpack_require__(300);
	
	var _cartas2 = _interopRequireDefault(_cartas);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _catalogoCuentasBancarias = __webpack_require__(156);
	
	var _catalogoCuentasBancarias2 = _interopRequireDefault(_catalogoCuentasBancarias);
	
	var _incluirMovimientosTransito = __webpack_require__(7104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TablaMovimientosTransito = function TablaMovimientosTransito() {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var anio = JSON.parse(sessionStorage.getItem('anioactu'));
	
	  var headCells = [{ id: 'idmovimientosentransito', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'COD.', textAlign: 'center' }, { id: 'tipomov', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'TIPO', textAlign: 'center' }, { id: 'referencia', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'REFERENCIA', textAlign: 'center' }, { id: 'fecha', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'FECHA', textAlign: 'center' }, { id: 'monto', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'MONTO', textAlign: 'center' }, { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }];
	
	  var txtIdCuentaBancaria = (0, _react.useRef)();
	  var txtCuenta = (0, _react.useRef)();
	
	  var txtBuscador = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      operacion = _useState2[0],
	      setOperacion = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      catalogoCuenta = _useState4[0],
	      setCatalogoCuenta = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mostrar = _useState6[0],
	      setMostrar = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      body = _useState8[0],
	      setBody = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      habilitado = _useState10[0],
	      setHabilitado = _useState10[1];
	
	  var _useState11 = (0, _react.useState)('0'),
	      _useState12 = _slicedToArray(_useState11, 2),
	      idMovimiento = _useState12[0],
	      setIdMovimiento = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensaje = _useState14[0],
	      setMensaje = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mensajesino = _useState16[0],
	      setMensajesino = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      activate = _useState18[0],
	      setActivate = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({ fn: function fn(items) {
	      return items;
	    } }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      filterFn = _useState20[0],
	      setFilterFn = _useState20[1];
	
	  var _useState21 = (0, _react.useState)([]),
	      _useState22 = _slicedToArray(_useState21, 2),
	      records = _useState22[0],
	      setRecords = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(),
	      _useState24 = _slicedToArray(_useState23, 2),
	      regDet = _useState24[0],
	      setRegDet = _useState24[1];
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	    var st = '';
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") return items;else return items.filter(function (x) {
	          st = x.status === '51' ? 'activo' : 'inactivo';
	          if (x.idmovimientosentransito.includes(target.value) || x.tipomov.toLowerCase().includes(target.value.toLowerCase()) || x.referencia.toLowerCase().includes(target.value.toLowerCase()) || (0, _moment2.default)(x.fecha).format('DD/MM/YYYY').toLowerCase().includes(target.value.toLowerCase()) || (0, _varios.formatMoneda)(x.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2).toLowerCase().includes(target.value.toLowerCase())) {
	            return x;
	          }
	        });
	      }
	    });
	  };
	
	  var handleInputNumChange = function handleInputNumChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	
	    if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false; //alert(e.which);
	  };
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting,
	      TblPagination = _useTable.TblPagination;
	
	  var seleccionarCuentaBancaria = function seleccionarCuentaBancaria(id) {
	
	    var campos = "*";
	    var nomtab = 'cuentabancaria';
	    var nomid = 'idcuentabancaria';
	
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid + ' ';
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	
	      if (response.status == 200) {
	
	        if (response.data !== '') {
	          txtCuenta.current.value = response.data.nombre.trim() + ' --- ' + response.data.cuentabancaria.trim();
	          seleccionarMovimientos(response.data.idcuentabancaria);
	          setTimeout(function () {
	            return txtBuscador.current.focus();
	          }, 200);
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'ID no existe.', icono: 'informacion' });
	          txtIdCuentaBancaria.current.value = '';
	          txtIdCuentaBancaria.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var seleccionarMovimientos = function seleccionarMovimientos(id) {
	
	    var campos = "*";
	    var nomtab = 'movimientosentransito';
	    var nomid = 'idcuentabancaria';
	    var condic = 'true';
	
	    var endpoint = op.conexion + '/api/consulta/modelicondi?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid + '&condic=' + condic;
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	
	      if (response.status == 200) {
	        setRecords([]);
	        if (response.data.length > 0) {
	          var mov = [];
	          for (var i = 0; i < response.data.length; i++) {
	            mov.push({
	              idmovimientosentransito: response.data[i].idmovimientosentransito,
	              idcuentabancaria: response.data[i].idcuentabancaria,
	              fecha: response.data[i].fecha,
	              fechasis: response.data[i].fechasis,
	              referencia: response.data[i].referencia,
	              motivo: response.data[i].motivo,
	              monto: response.data[i].monto,
	              tipo: response.data[i].tipo,
	              reversado: response.data[i].reversado,
	              conciliado: response.data[i].conciliado,
	              fechareversado: response.data[i].fechareversado,
	              fechaconciliacion: response.data[i].fechaconciliacion,
	              tipomov: response.data[i].tipo === 0 ? 'DEPOSITO' : response.data[i].tipo === 1 ? 'TRANSFERENCIA' : response.data[i].tipo === 2 ? 'NOTA CREDITO' : response.data[i].tipo === 3 ? 'NOTA DEBITO' : 'CHEQUE'
	            });
	          }
	          //setRecords(response.data);
	          setRecords(mov);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var gestionarMovimiento = function gestionarMovimiento(op, id, index) {
	    return function (e) {
	      if (op === 4) {
	        setHabilitado(false);
	        setOperacion(4);
	        var mov = records;
	        var mov = mov.filter(function (mov) {
	          return mov.idmovimientosentransito === id;
	        });
	        setRegDet(mov[0]);
	        setMostrar(true);
	        /*    getExpendedor(id); */
	      } else if (op === 1) {
	        if (txtIdCuentaBancaria.current.value === '' || txtCuenta.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe seleccionar una Cuenta Bancaaria.', icono: 'informacion' });
	          return;
	        }
	        setOperacion(op);
	        setHabilitado(true);
	        setMostrar(true);
	      } else if (op === 2) {
	        setHabilitado(true);
	        setOperacion(op);
	        var mov = records;
	        var mov = mov.filter(function (mov) {
	          return mov.idmovimientosentransito === id;
	        });
	        if (mov[0].conciliado === 1) {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El movimiento no se puede modificar, ya está conciliado.', icono: 'informacion' });
	          return;
	        }
	        setRegDet(mov[0]);
	        setMostrar(true);
	        /*   getExpendedor(id); */
	      } else if (op === 3) {
	        setOperacion(op);
	        setHabilitado(false);
	        var mov = records;
	        var mov = mov.filter(function (mov) {
	          return mov.idmovimientosentransito === id;
	        });
	        if (mov[0].conciliado === 1) {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El movimiento no se puede eliminar, ya está conciliado.', icono: 'informacion' });
	          return;
	        }
	        setRegDet(mov[0]);
	        setMostrar(true);
	      }
	    };
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setBody(null);
	    setRecords([]);
	    setOperacion(0);
	    txtIdCuentaBancaria.current.value = '';
	    txtCuenta.current.value = '';
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var validarCuenta = function validarCuenta(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value !== '') {
	
	        seleccionarCuentaBancaria(event.target.value);
	      } else {
	        txtCuenta.current.value = '';
	      }
	    }
	  };
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'idcuentabancaria') {
	      txtCuenta.current.value = '';
	      setRecords([]);
	    }
	  };
	
	  var onCatalogoCuenta = function onCatalogoCuenta(values) {
	    setCatalogoCuenta(false);
	    txtIdCuentaBancaria.current.value = values.idcuentabancaria;
	    seleccionarCuentaBancaria(values.idcuentabancaria);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', width: '100%' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'row col-md-12 py-3', style: { margin: 0 } },
	      _react2.default.createElement(
	        'div',
	        { className: 'row col-md-6 mx-auto', style: { margin: 0 } },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 py-1 mx-auto card shadow ' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 row mx-auto  rounded py-3' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light justify-content-between' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Gestion de Movimientos Transito'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-3 d-flex justify-content-end' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '/inicio', className: 'text-light ' },
	                  _react2.default.createElement('i', { className: 'fas fa-times mx-2' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'fw-bold' },
	                    'Salir'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 mx-auto', style: { fontSizeAdjust: '0.6' } },
	              _react2.default.createElement(
	                'fieldset',
	                { className: ' row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between' },
	                _react2.default.createElement(
	                  'legend',
	                  { className: 'float-none w-auto fw-bold', style: { fontSize: '16px' } },
	                  'Cuenta Bancaria'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm mb-2 col-xl-3 col-lg-4 col-md-5 col-sm-4' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'CODIGO:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', ref: txtIdCuentaBancaria, name: 'idcuentabancaria', className: 'form-control bg-light fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: validarCuenta, onBlur: validarCuenta, onChange: onChange }),
	                  _react2.default.createElement(
	                    'button',
	                    { type: 'button', onClick: function onClick() {
	                        setCatalogoCuenta(true);
	                      }, className: 'btn btn-success' },
	                    _react2.default.createElement('i', { className: 'fas fa-search' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm mb-2 col-xl-9 col-lg-12' },
	                  _react2.default.createElement('input', { type: 'text', disabled: true, ref: txtCuenta, name: 'cuentabancaria', className: 'form-control bg-light fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 mx-auto mt-2' },
	              _react2.default.createElement(
	                'fieldset',
	                { className: ' row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between' },
	                _react2.default.createElement(
	                  'legend',
	                  { className: 'float-none w-auto fw-bold', style: { fontSize: '15px' } },
	                  'Movimientos'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-12 p-2' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row col-12 d-flex justify-content-between' },
	                    _react2.default.createElement('input', { type: 'text', className: ' col-3 form-control form-control-sm rounded-pill', ref: txtBuscador, onChange: handleSearch, placeholder: 'Buscar' }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-3 d-flex justify-content-end' },
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: gestionarMovimiento(1, ''), style: { marginBottom: "5px" }, className: 'btn btn-sm btn-primary rounded-circle' },
	                        _react2.default.createElement('i', { className: 'fas fa-plus' }),
	                        ' '
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12', style: { margin: "auto" } },
	                  _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                      _core.TableBody,
	                      null,
	                      records && recordsAfterPagingAndSorting().map(function (item, index) {
	                        return _react2.default.createElement(
	                          _core.TableRow,
	                          { key: index, style: { padding: "0", fontSizeAdjust: '0.6' } },
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center', width: '240px' } },
	                            item.idmovimientosentransito
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center', width: '240px' } },
	                            item.tipomov
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center', width: '240px' } },
	                            item.referencia
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center', width: '270px' } },
	                            (0, _moment2.default)(item.fecha).format('DD/MM/YYYY')
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center', width: '270px' } },
	                            (0, _varios.formatMoneda)(item.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2)
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center', width: '330px' } },
	                            _react2.default.createElement(
	                              'button',
	                              { onClick: gestionarMovimiento(4, item.idmovimientosentransito, index), className: 'btn btn-sm mx-1 btn-info rounded-circle' },
	                              _react2.default.createElement('i', { className: 'fas fa-eye' }),
	                              ' '
	                            ),
	                            _react2.default.createElement(
	                              'button',
	                              { onClick: gestionarMovimiento(2, item.idmovimientosentransito, index), className: 'btn btn-sm mx-1 btn-warning rounded-circle' },
	                              _react2.default.createElement('i', { className: 'fa fa-edit' }),
	                              ' '
	                            ),
	                            _react2.default.createElement(
	                              'button',
	                              { onClick: gestionarMovimiento(3, item.idmovimientosentransito, index), className: 'btn btn-sm mx-1 btn-danger rounded-circle' },
	                              _react2.default.createElement('i', { className: 'fa fa-trash' }),
	                              ' '
	                            )
	                          )
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(TblPagination, null)
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_incluirMovimientosTransito.IncluirMovimiento, {
	      show: mostrar,
	      operacion: operacion,
	      idcuentabancaria: txtIdCuentaBancaria.current ? txtIdCuentaBancaria.current.value : '0',
	      idmovimiento: idMovimiento,
	      habilitado: habilitado,
	      registro: regDet,
	      onHideCancela: function onHideCancela() {
	        setMostrar(false);
	      },
	      onHideRenderizar: function onHideRenderizar() {
	        seleccionarMovimientos(txtIdCuentaBancaria.current.value);
	      }
	    }),
	    _react2.default.createElement(_catalogoCuentasBancarias2.default, {
	      show: catalogoCuenta,
	      onHideCancelar: function onHideCancelar() {
	        setCatalogoCuenta(false);
	      },
	      onHideAceptaCatalogo: onCatalogoCuenta
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        'cargando...'
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	      } }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	      }, onHideSi: handleCloseSi })
	  );
	};
	exports.default = TablaMovimientosTransito;

/***/ },
/* 7108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalImprimirRecibosdePago = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTableScroll = __webpack_require__(29);
	
	var _useTableScroll2 = _interopRequireDefault(_useTableScroll);
	
	var _catalogoNotadeCredito = __webpack_require__(157);
	
	var _catalogoNotadeCredito2 = _interopRequireDefault(_catalogoNotadeCredito);
	
	var _catalogoAnticipos = __webpack_require__(122);
	
	var _catalogoAnticipos2 = _interopRequireDefault(_catalogoAnticipos);
	
	var _catalogoRecibosdePagos = __webpack_require__(656);
	
	var _catalogoRecibosdePagos2 = _interopRequireDefault(_catalogoRecibosdePagos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalImprimirRecibosdePago = exports.ModalImprimirRecibosdePago = function ModalImprimirRecibosdePago(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var _useState = (0, _react.useState)(""),
	      _useState2 = _slicedToArray(_useState, 2),
	      searchText = _useState2[0],
	      setSearchText = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isDropdownOpen = _useState4[0],
	      setIsDropdownOpen = _useState4[1];
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtBusqueda = (0, _react.useRef)();
	  var txtNumRecibo = (0, _react.useRef)();
	  var txtFechaPago = (0, _react.useRef)();
	  var txtNombre = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      clientes = _useState6[0],
	      setClientes = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(""),
	      _useState8 = _slicedToArray(_useState7, 2),
	      clienteSeleccionado = _useState8[0],
	      setClienteSeleccionado = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      clienteSeleccionadoObj = _useState10[0],
	      setClienteSeleccionadoObj = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(""),
	      _useState12 = _slicedToArray(_useState11, 2),
	      fechaDesde = _useState12[0],
	      setFechaDesde = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(""),
	      _useState14 = _slicedToArray(_useState13, 2),
	      fechaHasta = _useState14[0],
	      setFechaHasta = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mostrarFiltros = _useState16[0],
	      setMostrarFiltros = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      inputalmacen = _useState18[0],
	      setInputalmacen = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      inputproducto = _useState20[0],
	      setInputproducto = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(null),
	      _useState22 = _slicedToArray(_useState21, 2),
	      tiporif = _useState22[0],
	      setTipofic = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0.00),
	      _useState24 = _slicedToArray(_useState23, 2),
	      valormon = _useState24[0],
	      setValormon = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(null),
	      _useState26 = _slicedToArray(_useState25, 2),
	      mostrar1 = _useState26[0],
	      setMostrar1 = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(null),
	      _useState28 = _slicedToArray(_useState27, 2),
	      mostrar2 = _useState28[0],
	      setMostrar2 = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(''),
	      _useState30 = _slicedToArray(_useState29, 2),
	      parafecha = _useState30[0],
	      setParafecha = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(''),
	      _useState32 = _slicedToArray(_useState31, 2),
	      desde = _useState32[0],
	      setDesde = _useState32[1];
	
	  var _useState33 = (0, _react.useState)([]),
	      _useState34 = _slicedToArray(_useState33, 2),
	      banco = _useState34[0],
	      setBanco = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(''),
	      _useState36 = _slicedToArray(_useState35, 2),
	      disponiblec = _useState36[0],
	      setDisponiblec = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(''),
	      _useState38 = _slicedToArray(_useState37, 2),
	      numnota = _useState38[0],
	      setNumNota = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(''),
	      _useState40 = _slicedToArray(_useState39, 2),
	      idclient = _useState40[0],
	      setIdclient = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(null),
	      _useState42 = _slicedToArray(_useState41, 2),
	      simbol = _useState42[0],
	      setSimbol = _useState42[1];
	
	  var _useState43 = (0, _react.useState)([]),
	      _useState44 = _slicedToArray(_useState43, 2),
	      combomoneda = _useState44[0],
	      setComboMoneda = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(false),
	      _useState46 = _slicedToArray(_useState45, 2),
	      activate = _useState46[0],
	      setActivate = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(0),
	      _useState48 = _slicedToArray(_useState47, 2),
	      idmoney = _useState48[0],
	      setIdmoney = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(""),
	      _useState50 = _slicedToArray(_useState49, 2),
	      tipofactu = _useState50[0],
	      setTipofactu = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(0),
	      _useState52 = _slicedToArray(_useState51, 2),
	      valida = _useState52[0],
	      setValida = _useState52[1];
	
	  var _useState53 = (0, _react.useState)({ fn: function fn(items) {
	      return items;
	    } }),
	      _useState54 = _slicedToArray(_useState53, 2),
	      filterFn = _useState54[0],
	      setFilterFn = _useState54[1];
	
	  var _useState55 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState56 = _slicedToArray(_useState55, 2),
	      mensaje = _useState56[0],
	      setMensaje = _useState56[1];
	
	  var _useState57 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState58 = _slicedToArray(_useState57, 2),
	      mensajesino = _useState58[0],
	      setMensajesino = _useState58[1];
	
	  var _useState59 = (0, _react.useState)(''),
	      _useState60 = _slicedToArray(_useState59, 2),
	      tituid = _useState60[0],
	      setTituid = _useState60[1];
	
	  var _useState61 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState62 = _slicedToArray(_useState61, 2),
	      botones = _useState62[0],
	      setBotones = _useState62[1];
	
	  // Efecto para cerrar dropdown al hacer clic fuera
	
	
	  (0, _react.useEffect)(function () {
	    var handleClickOutside = function handleClickOutside(event) {
	      if (isDropdownOpen && !event.target.closest('.dropdown-container')) {
	        setIsDropdownOpen(false);
	      }
	    };
	
	    document.addEventListener('click', handleClickOutside);
	    return function () {
	      return document.removeEventListener('click', handleClickOutside);
	    };
	  }, [isDropdownOpen]);
	
	  // Efecto para establecer fechas actuales cuando no hay cliente seleccionado
	  (0, _react.useEffect)(function () {
	    if (mostrarFiltros && !clienteSeleccionado) {
	      var hoy = (0, _moment2.default)().format('YYYY-MM-DD');
	      setFechaDesde(hoy);
	      setFechaHasta(hoy);
	    }
	  }, [mostrarFiltros, clienteSeleccionado]);
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setInputalmacen(0);
	    setParafecha('');
	    setDisponiblec('');
	    setNumNota('');
	    setInputproducto(0);
	    setValida(0);
	    setIdclient('');
	    setIdmoney(0);
	    setSimbol(null);
	    setMostrar1(false);
	    setMostrar2(false);
	    setTipofactu("");
	    setFechaDesde("");
	    setFechaHasta("");
	    setClienteSeleccionado("");
	    setClienteSeleccionadoObj(null);
	    setSearchText("");
	    setIsDropdownOpen(false);
	  };
	
	  var handleSearch = function handleSearch(e) {
	    setSearchText(e.target.value);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  // Función para manejar la selección del cliente
	  var handleSelectCliente = function handleSelectCliente(cliente) {
	    if (cliente === null) {
	      setClienteSeleccionado("");
	      setClienteSeleccionadoObj(null);
	      setSearchText("");
	      // Establecer fechas actuales cuando no hay cliente seleccionado
	      var hoy = (0, _moment2.default)().format('YYYY-MM-DD');
	      setFechaDesde(hoy);
	      setFechaHasta(hoy);
	    } else {
	      setClienteSeleccionado(cliente.idagente);
	      setClienteSeleccionadoObj(cliente);
	      setSearchText(cliente.nombre + ' (' + cliente.rif + ')');
	    }
	    setIsDropdownOpen(false);
	  };
	
	  // Filtrar clientes basado en el texto de búsqueda
	  var filteredClientes = clientes.filter(function (cliente) {
	    return cliente.nombre.toLowerCase().includes(searchText.toLowerCase()) || cliente.rif.toLowerCase().includes(searchText.toLowerCase());
	  });
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	    var sigue = true;
	
	    if (props.ope === 1) {
	      if (mostrarFiltros) {
	        // Validar que si no hay cliente seleccionado, se usen las fechas actuales
	        var _desde = fechaDesde;
	        var hasta = fechaHasta;
	
	        if (!clienteSeleccionado) {
	          var hoy = (0, _moment2.default)().format('YYYY-MM-DD');
	          _desde = hoy;
	          hasta = hoy;
	        }
	
	        window.open(op.reportes + "/finanzas?afiliado=" + afiliado + "&reporte=ReporteRecibodePagoVarios" + "&IDCLIENTE=" + clienteSeleccionado + "&desde=" + _desde + "&hasta=" + hasta, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      } else {
	        if (txtNombre.current.value === '' || txtRif.current.value === "" || txtNumRecibo.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: 'Notificación',
	            texto: '¡ Seleccione y/o Introduzca el Número de Recibo !',
	            icono: 'informacion'
	          });
	          txtNumRecibo.current.focus();
	          sigue = false;
	        } else {
	          imprimirRecibo();
	        }
	      }
	    }
	  };
	
	  var imprimirRecibo = function imprimirRecibo() {
	    var reporte = "ReporteRecibodePago";
	    var opera = 2;
	    var condi = "'" + txtNumRecibo.current.value.trim() + "'";
	    var tipo = tipofactu;
	    window.open(op.reportes + "/finanzas?afiliado=" + afiliado + "&reporte=" + reporte + "&NUMPAGO=" + condi + "&OP=" + opera + "&TIPOPAGO=" + tipo, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  var handleAceptaDatosRecibo = function handleAceptaDatosRecibo(values) {
	    setMostrar2(false);
	    txtNombre.current.value = values.nombre;
	    txtRif.current.value = values.rif;
	    txtNumRecibo.current.value = values.numpago;
	    setTipofactu(values.tipo);
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros(num) {
	    var endpoint = "";
	    var tipo = 'porid';
	    endpoint = op.conexion + '/api/consulta/seleccionarrecibodepago?tipo=' + tipo + '&numpago=' + num;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          txtNombre.current.value = response.data[0].nombre.trim();
	          txtRif.current.value = response.data[0].rif;
	          setTipofactu(response.data[0].tipofac.trim());
	        } else {
	          txtNombre.current.value = "";
	          txtRif.current.value = "";
	          txtNumRecibo.current.value = "";
	          setTipofactu("");
	          setMensaje({
	            mostrar: true,
	            titulo: 'Notificación',
	            texto: '¡ Pago y/o N° de Recibo no Existe !',
	            icono: 'informacion'
	          });
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var handleInputNumeroChange = function handleInputNumeroChange(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "recibo") {
	          seleccionarRegistros(event.target.value.toUpperCase());
	        }
	      }
	    }
	  };
	
	  var seleccionarClintes = function seleccionarClintes() {
	    var campos = "idagente, municipio, ciudad, trim(nombre) as nombre, trim(direccion) as direccion, rif, reprelegal, tipoper, idalmacen, celular";
	    var nomtab = "agente";
	    var condi = 'vendedor = false';
	    var orden = "idagente";
	    var endpoint = op.conexion + '/api/consulta/selecionarregistrocondi?campos=' + campos + '&nomtab=' + nomtab + '&condi=' + condi + '&orden=' + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setClientes(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarClintes();
	  }, []);
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'md',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {}
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Imprimir Recibo de Pago'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement('i', { className: 'fas fa-times fa-1x shadow' })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }
	      }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, {
	        mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        },
	        onHideSi: handleCloseSi
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 mx-auto row px-0 mb-2', style: { marginBottom: "10px" } },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement('div', { className: 'input-group col-md-8 input-group-sm mb-3' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-4 d-flex justify-content-end' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check form-switch' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label mr-5', htmlFor: 'filtroSwitch' },
	                  'Filtrar'
	                ),
	                _react2.default.createElement('input', {
	                  className: 'form-check-input mr-3',
	                  type: 'checkbox',
	                  role: 'switch',
	                  id: 'filtroSwitch',
	                  checked: mostrarFiltros,
	                  onChange: function onChange(e) {
	                    setMostrarFiltros(e.target.checked);
	                    if (!e.target.checked) {
	                      // Resetear valores cuando se desactiva el filtro
	                      setClienteSeleccionado("");
	                      setClienteSeleccionadoObj(null);
	                      setSearchText("");
	                    }
	                  }
	                })
	              )
	            )
	          )
	        ),
	        mostrarFiltros ? _react2.default.createElement(
	          'div',
	          { className: 'row mb-2 col-md-12 mx-auto px-0' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 dropdown-container position-relative' },
	            _react2.default.createElement(
	              'label',
	              { className: 'form-label' },
	              'Cliente'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm' },
	              _react2.default.createElement('input', {
	                type: 'text',
	                className: 'form-control',
	                placeholder: 'Buscar cliente por nombre o RIF...',
	                value: searchText,
	                onChange: function onChange(e) {
	                  setSearchText(e.target.value);
	                  setIsDropdownOpen(true);
	                },
	                onFocus: function onFocus() {
	                  return setIsDropdownOpen(true);
	                },
	                onClick: function onClick() {
	                  return setIsDropdownOpen(true);
	                }
	              }),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-outline-secondary',
	                  type: 'button',
	                  onClick: function onClick() {
	                    return setIsDropdownOpen(!isDropdownOpen);
	                  }
	                },
	                _react2.default.createElement('i', { className: 'fas fa-chevron-' + (isDropdownOpen ? 'up' : 'down') })
	              ),
	              clienteSeleccionado && _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn btn-outline-danger',
	                  type: 'button',
	                  onClick: function onClick() {
	                    return handleSelectCliente(null);
	                  },
	                  title: 'Limpiar selecci\xF3n'
	                },
	                _react2.default.createElement('i', { className: 'fas fa-times' })
	              )
	            ),
	            isDropdownOpen && _react2.default.createElement(
	              'div',
	              {
	                className: 'dropdown-menu show w-100',
	                style: {
	                  maxHeight: "200px",
	                  overflowY: "auto",
	                  zIndex: 1000,
	                  position: "absolute",
	                  top: "100%",
	                  left: 0
	                }
	              },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'dropdown-item text-muted',
	                  onClick: function onClick() {
	                    return handleSelectCliente(null);
	                  },
	                  style: { cursor: "pointer" }
	                },
	                _react2.default.createElement(
	                  'small',
	                  null,
	                  _react2.default.createElement('i', { className: 'fas fa-times-circle mr-1' }),
	                  ' Todos los clientes'
	                )
	              ),
	              filteredClientes.length > 0 ? filteredClientes.map(function (cliente) {
	                return _react2.default.createElement(
	                  'div',
	                  {
	                    key: cliente.idagente,
	                    className: 'dropdown-item',
	                    onClick: function onClick() {
	                      return handleSelectCliente(cliente);
	                    },
	                    style: {
	                      cursor: "pointer",
	                      backgroundColor: clienteSeleccionado === cliente.idagente ? "#e9f7fe" : "white",
	                      borderLeft: clienteSeleccionado === cliente.idagente ? "3px solid #007bff" : "3px solid transparent"
	                    }
	                  },
	                  _react2.default.createElement(
	                    'small',
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        cliente.nombre
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'text-muted' },
	                      'RIF: ',
	                      cliente.rif
	                    )
	                  )
	                );
	              }) : _react2.default.createElement(
	                'div',
	                { className: 'dropdown-item text-muted' },
	                _react2.default.createElement(
	                  'small',
	                  null,
	                  'No se encontraron clientes'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 mt-3' },
	            _react2.default.createElement(
	              'label',
	              { className: 'form-label' },
	              'Fecha Desde'
	            ),
	            _react2.default.createElement('input', {
	              type: 'date',
	              className: 'form-control form-control-sm',
	              value: fechaDesde,
	              onChange: function onChange(e) {
	                return setFechaDesde(e.target.value);
	              },
	              disabled: !clienteSeleccionado
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-6 mt-3' },
	            _react2.default.createElement(
	              'label',
	              { className: 'form-label' },
	              'Fecha Hasta'
	            ),
	            _react2.default.createElement('input', {
	              type: 'date',
	              className: 'form-control form-control-sm',
	              value: fechaHasta,
	              onChange: function onChange(e) {
	                return setFechaHasta(e.target.value);
	              },
	              disabled: !clienteSeleccionado
	            })
	          ),
	          !clienteSeleccionado && _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 mt-3' },
	            _react2.default.createElement(
	              'div',
	              { className: 'alert alert-info p-2 mb-0' },
	              _react2.default.createElement(
	                'small',
	                null,
	                _react2.default.createElement('i', { className: 'fas fa-info-circle mr-1' }),
	                'Al no seleccionar un cliente, se imprimir\xE1n todos los recibos de pago para las fechas seleccionadas. Se usar\xE1n las fechas actuales por defecto.'
	              )
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto m-0 border-azul px-1' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 row m-0 px-0 py-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-250 px-0 mb-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'N\xB0 RECIBO: '
	                ),
	                _react2.default.createElement('input', {
	                  autoComplete: 'off',
	                  type: 'text',
	                  disabled: props.ope === 0 ? true : false,
	                  name: 'recibo',
	                  onKeyUp: handleInputNumeroChange,
	                  onBlur: handleInputNumeroChange,
	                  ref: txtNumRecibo,
	                  className: 'form-control bg-transparent fs-6 text-uppercase',
	                  'aria-label': 'Sizing example input',
	                  'aria-describedby': 'inputGroup-sizing-sm'
	                }),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    onClick: function onClick() {
	                      return setMostrar2(true);
	                    },
	                    disabled: props.ope === 0 ? true : false,
	                    className: 'btn btn-success'
	                  },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-210 px-0 mb-1 ml-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'RIF:'
	                ),
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  disabled: true,
	                  ref: txtRif,
	                  name: 'rif',
	                  className: 'form-control fs-6 text-uppercase',
	                  'aria-label': 'Sizing example input',
	                  'aria-describedby': 'inputGroup-sizing-sm'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-480 px-0 mb-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'CLIENTE:'
	                ),
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  disabled: true,
	                  ref: txtNombre,
	                  name: 'nombre',
	                  className: 'form-control fs-6 text-uppercase',
	                  'aria-label': 'Sizing example input',
	                  'aria-describedby': 'inputGroup-sizing-sm'
	                })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-11 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            {
	              ref: btnAcepta,
	              disabled: props.ope !== 0 ? false : true,
	              onClick: onChangeValidar,
	              className: 'btn btn-sm rounded-pill btn-primary mx-1'
	            },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-print' },
	              '  Imprimir'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              ref: btnCancela,
	              onClick: cancelar,
	              className: 'btn btn-danger btn-sm rounded-pill mx-1'
	            },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoRecibosdePagos2.default, {
	      show: mostrar2,
	      tipo: 'AN',
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar2(false);
	      },
	      onHideAceptaCatalogo: handleAceptaDatosRecibo
	    })
	  );
	};

/***/ },
/* 7109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(121);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _registrarPagoNotaEntrega = __webpack_require__(7128);
	
	var _registrarPagoNotaEntrega2 = _interopRequireDefault(_registrarPagoNotaEntrega);
	
	var _registrarPagoFactura = __webpack_require__(671);
	
	var _registrarPagoFactura2 = _interopRequireDefault(_registrarPagoFactura);
	
	var _registrarPagoNotaDebito = __webpack_require__(7127);
	
	var _registrarPagoNotaDebito2 = _interopRequireDefault(_registrarPagoNotaDebito);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GestionCuentasCobrar() {
	  var token = sessionStorage.getItem("jwtToken");
	  var op = __webpack_require__(8);
	  var ncaja = JSON.parse(sessionStorage.getItem("numcaja"));
	  var fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var accbtncntxcobrar = JSON.parse(sessionStorage.getItem("accbtncntxcobrarc"));
	
	  var headCells = [{
	    id: "9",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: _react2.default.createElement("i", { className: "far fa-eye" }),
	    textAlign: "center"
	  }, {
	    id: "1",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "FACTURA N°",
	    textAlign: "center"
	  }, {
	    id: "2",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "FECHA EMISION",
	    textAlign: "center"
	  }, {
	    id: "0",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "FECHA VENCIMIENTO",
	    textAlign: "center"
	  }, {
	    id: "3",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "DIAS (CREDITO)",
	    textAlign: "center"
	  }, {
	    id: "4",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "DIAS (TRANSCURRIDO)",
	    textAlign: "center"
	  }, {
	    id: "5",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "CLIENTE",
	    textAlign: "center"
	  }, {
	    id: "6",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "MONTO",
	    textAlign: "center"
	  }, {
	    id: "7",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "ABONO",
	    textAlign: "center"
	  }, {
	    id: "8",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "SALDO",
	    textAlign: "center"
	  }, {
	    id: "4",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "STATUS",
	    textAlign: "center"
	  }];
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      colorF = _useState4[0],
	      setColorF = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([{
	    color: "#ffc107",
	    nombre: "Total Por Vencer",
	    valor: "0,00"
	  }, {
	    color: "#dc3545",
	    nombre: "Total Vencido",
	    valor: "0,00"
	  }]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      datos = _useState6[0],
	      setDatos = _useState6[1];
	
	  var txtBuscar = (0, _react.useRef)();
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      records = _useState8[0],
	      setRecords = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      activate = _useState10[0],
	      setActivate = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mostrar1 = _useState12[0],
	      setMostrar1 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mostrar2 = _useState14[0],
	      setMostrar2 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mostrar3 = _useState16[0],
	      setMostrar3 = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(),
	      _useState18 = _slicedToArray(_useState17, 2),
	      data = _useState18[0],
	      setData = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      idnot = _useState20[0],
	      setIdnot = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0.0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      abono = _useState22[0],
	      setAbono = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0.0),
	      _useState24 = _slicedToArray(_useState23, 2),
	      anticipo = _useState24[0],
	      setAnticipo = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(0),
	      _useState26 = _slicedToArray(_useState25, 2),
	      idfact = _useState26[0],
	      setIdfact = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(),
	      _useState28 = _slicedToArray(_useState27, 2),
	      options = _useState28[0],
	      setOptions = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(0.0),
	      _useState30 = _slicedToArray(_useState29, 2),
	      totalVentas = _useState30[0],
	      setTotalVentas = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(0.0),
	      _useState32 = _slicedToArray(_useState31, 2),
	      totalCobrado = _useState32[0],
	      setTotalCobrado = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(0.0),
	      _useState34 = _slicedToArray(_useState33, 2),
	      totalPorCobrar = _useState34[0],
	      setTotalPorCobrar = _useState34[1];
	
	  var _useState35 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState36 = _slicedToArray(_useState35, 2),
	      filterFn = _useState36[0],
	      setFilterFn = _useState36[1];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if ((0, _moment2.default)(x.fecha).format("DD-MM-YYYY").toLowerCase().includes(target.value.toLowerCase()) || (0, _moment2.default)(x.fechavencimientof).format("DD-MM-YYYY").toLowerCase().includes(target.value.toLowerCase()) || x.cliente.toLowerCase().includes(target.value.toLowerCase()) || x.numfactura.toLowerCase().includes(target.value.toLowerCase()) || (0, _varios.formatMoneda)(x.totalmonto.toString().replace(",", "").replace(".", ","), ",", ".", 2).toLowerCase().includes(target.value.toLowerCase()) || x.statuscredito.toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarFacturas = function seleccionarFacturas() {
	    var endpoint = op.conexion + "/api/registropago/seleccionarfacturas?&status=0&anio=todos&mes=''";
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          txtBuscar.current.focus();
	          setRecords(response.data);
	          var vnt = 0.0;
	          var cbd = 0.0;
	          var pcb = 0.0;
	
	          var tt = 0.0;
	          var abo = 0.0;
	          var rt = 0.0;
	
	          for (var i = 0; i < response.data.length; i++) {
	            tt = tt + parseFloat(response.data[i].totalmonto);
	            abo = abo + parseFloat(response.data[i].abono);
	          }
	
	          rt = tt - abo;
	
	          for (var _i = 0; _i < response.data.length; _i++) {
	            if (response.data[_i].status === 0) {
	              vnt = vnt + parseFloat(response.data[_i].totalmonto);
	
	              if (response.data[_i].statuscredito === "vencido") {
	                cbd = cbd + parseFloat(response.data[_i].totalmonto);
	              }
	
	              if (response.data[_i].statuscredito === "por vencer") {
	                pcb = pcb + parseFloat(response.data[_i].totalmonto);
	              }
	            }
	          }
	
	          setTotalVentas(vnt);
	          setTotalCobrado(cbd);
	          setTotalPorCobrar(pcb);
	          setDatos([{
	            color: "#ffc107",
	            nombre: "Total Por Vencer",
	            valor: (0, _varios.formatMoneda)(pcb.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	          }, {
	            color: "#dc3545",
	            nombre: "Total Vencido",
	            valor: (0, _varios.formatMoneda)(cbd.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	          }]);
	        } else {
	          setRecords([]);
	          setTotalVentas(0.0);
	          setTotalCobrado(0.0);
	          setTotalPorCobrar(0.0);
	          setDatos([{
	            color: "#ffc107",
	            nombre: "Total Por Vencer",
	            valor: "0,00"
	          }, {
	            color: "#dc3545",
	            nombre: "Total Vencido",
	            valor: "0,00"
	          }]);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onGestionar = function onGestionar(item) {
	    return function (e) {
	      if (ncaja !== "") {
	        if (accbtncntxcobrar && accbtncntxcobrar.toString().substring(0, 1) === "1") {
	          if (item.numfactura.toString().substring(0, 2) === "NE") {
	            setIdnot(item.idfactura);
	            setAbono(item.abono);
	            setAnticipo(item.anticipo);
	            setMostrar1(true);
	          } else if (item.numfactura.toString().substring(0, 2) === "F0") {
	            setIdfact(item.idfactura);
	            setAbono(item.abono);
	            setAnticipo(item.anticipo);
	            setMostrar2(true);
	          } else if (item.numfactura.toString().substring(0, 2) === "ND") {
	            setAbono(item.abono);
	            setAnticipo(item.anticipo);
	            setIdnot(item.idfactura);
	            setMostrar3(true);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación.",
	          texto: "¡No Posee un Número de Caja Asignada!",
	          icono: "error"
	        });
	      }
	    };
	  };
	
	  var dataTorta = {
	    labels: ["Por Vencer", "Vencido"],
	    leyend: true,
	    datasets: [{
	      label: "#",
	      data: [totalPorCobrar.toFixed(2), totalCobrado.toFixed(2)],
	      backgroundColor: ["#ffc107", "#dc3545"],
	      borderColor: ["#ffc107", "#dc3545"],
	      borderWidth: 1,
	      hoverBorderWidth: 15
	    }]
	  };
	
	  var optionsTorta = {
	    responsive: false,
	    legend: {
	      position: "top",
	      display: true
	    },
	    title: {
	      display: true,
	      text: "Monto Total por Cobrar: " + (0, _varios.formatMoneda)(totalVentas.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    var listaclientes = [];
	    var totales = [];
	
	    for (var i = 0; i < records.length; i++) {
	      if (!listaclientes.includes(records[i].cliente)) {
	        listaclientes.push(records[i].cliente);
	        colorF.push("#dc3545");
	      }
	    }
	
	    for (var x = 0; x < listaclientes.length; x++) {
	      var monto = 0.0;
	      for (var _i2 = 0; _i2 < records.length; _i2++) {
	        if (listaclientes[x] === records[_i2].cliente) {
	          monto = monto + parseFloat(records[_i2].totalmonto);
	        }
	      }
	      totales.push(monto.toString());
	    }
	
	    setData({
	      labels: listaclientes,
	      datasets: [{
	        label: "Monto por Cobrar",
	        data: totales,
	        borderColor: colorF,
	        backgroundColor: colorF
	      }]
	    });
	    setOptions({
	      indexAxis: "y",
	      elements: {
	        bar: {
	          borderWidth: 2
	        }
	      },
	      responsive: true,
	      plugins: {
	        legend: {
	          position: "right"
	        },
	        title: {
	          display: true,
	          text: "Chart.js Horizontal Bar Chart"
	        }
	      }
	    });
	  }, [records]);
	
	  (0, _react.useEffect)(function () {
	    seleccionarFacturas();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { className: "col-md-12 mx-auto" },
	    _react2.default.createElement(
	      "div",
	      { className: "col-md-12 mt-2" },
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_mensajes.Mensaje, {
	          mensaje: mensaje,
	          onHide: function onHide() {
	            return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	          }
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "container-fluid px-3 py-2" },
	          _react2.default.createElement(
	            "div",
	            { className: "row col-md-12 card py-3 mx-auto" },
	            _react2.default.createElement(
	              "div",
	              { className: "row col-md-12 mx-auto" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 mx-auto h-100 row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 card row h-100" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-12 row mx-auto" },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "row col-lg-6 col-md-12 h-50 mx-auto justify-content-center",
	                        style: { display: "grid" }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12" },
	                        _react2.default.createElement(_reactChartjs.Pie, {
	                          options: optionsTorta,
	                          height: 300,
	                          width: 300,
	                          data: dataTorta
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12", style: { padding: "10vh" } },
	                        _react2.default.createElement(
	                          "table",
	                          { className: "table tablet-responsive table-striped" },
	                          _react2.default.createElement(
	                            "tbody",
	                            null,
	                            datos && datos.map(function (item, index) {
	                              return _react2.default.createElement(
	                                "tr",
	                                { key: index },
	                                _react2.default.createElement("td", {
	                                  style: {
	                                    backgroundColor: item.color,
	                                    border: "#000000 1px solid",
	                                    width: "20px",
	                                    fontSize: "10px",
	                                    margin: 0,
	                                    padding: 0
	                                  }
	                                }),
	                                _react2.default.createElement(
	                                  "td",
	                                  {
	                                    style: {
	                                      border: "#000000 1px solid",
	                                      fontSize: "10px",
	                                      margin: 0,
	                                      padding: 0,
	                                      paddingLeft: "3px"
	                                    }
	                                  },
	                                  item.nombre
	                                ),
	                                _react2.default.createElement(
	                                  "td",
	                                  {
	                                    style: {
	                                      border: "#000000 1px solid",
	                                      textAlign: "end",
	                                      fontSize: "10px",
	                                      margin: 0,
	                                      padding: 0,
	                                      paddingRight: "3px"
	                                    }
	                                  },
	                                  item.valor
	                                )
	                              );
	                            })
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: " col-lg-6 col-md-12 my-auto bg-light border-azul row h-100 justify-content-center rounded mx-auto px-0" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 h-100 mb-2" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-md-12 bg-primary mt-2 py-5 mx-auto rounded shadow d-flex align-items-center" },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col-md-12 justify-content-center" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "col-md-12 d-flex justify-center mx-auto" },
	                              _react2.default.createElement(
	                                "label",
	                                { className: " text-center fw-bold text-light mx-auto " },
	                                "Datos Estadisticos"
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            className: " btn col-md-12 bg-success mt-2 py-3 mx-auto rounded shadow d-flex align-items-center"
	                            // onClick={blanquear}
	                          },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "input-group input-group-sm justify-content-between" },
	                            _react2.default.createElement(
	                              "span",
	                              {
	                                className: "input-group-text border-0 bg-transparent fw-bold text-light",
	                                id: "inputGroup-sizing-sm"
	                              },
	                              "Total Fact. a Credito:"
	                            ),
	                            _react2.default.createElement("input", {
	                              type: "text",
	                              className: "form-control col-md-6 rounded bg-transparent border-0 fw-bold text-right text-light",
	                              value: (0, _varios.formatMoneda)(totalVentas.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                              disabled: true,
	                              "aria-label": "Sizing example input",
	                              "aria-describedby": "inputGroup-sizing-sm"
	                            })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            className: " btn col-md-12 bg-warning mt-2 py-3 mx-auto rounded shadow d-flex align-items-center"
	                            // onClick={onClickButtons(" ")}
	                          },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "input-group input-group-sm justify-content-between" },
	                            _react2.default.createElement(
	                              "span",
	                              {
	                                className: "input-group-text border-0 bg-transparent fw-bold",
	                                id: "inputGroup-sizing-sm"
	                              },
	                              "Total de Fact. por Vencer :"
	                            ),
	                            _react2.default.createElement("input", {
	                              type: "text",
	                              className: "form-control col-md-6 rounded bg-transparent border-0 fw-bold text-right",
	                              value: (0, _varios.formatMoneda)(totalPorCobrar.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                              disabled: true,
	                              "aria-label": "Sizing example input",
	                              "aria-describedby": "inputGroup-sizing-sm"
	                            })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            className: " btn col-md-12 bg-danger mt-2 py-3 mx-auto rounded shadow d-flex align-items-center"
	                            // onClick={onClickButtons("vencido")}
	                          },
	                          _react2.default.createElement(
	                            "div",
	                            { className: "input-group input-group-sm justify-content-between" },
	                            _react2.default.createElement(
	                              "span",
	                              {
	                                className: "input-group-text border-0 bg-transparent fw-bold text-light",
	                                id: "inputGroup-sizing-sm"
	                              },
	                              "Total de Fact. Vencidas:"
	                            ),
	                            _react2.default.createElement("input", {
	                              type: "text",
	                              className: "form-control col-md-6 rounded bg-transparent border-0 fw-bold text-right text-light",
	                              value: (0, _varios.formatMoneda)(totalCobrado.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                              disabled: true,
	                              "aria-label": "Sizing example input",
	                              "aria-describedby": "inputGroup-sizing-sm"
	                            })
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6 py-2 row mx-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 h-100 my-auto" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row mt-3 py-0 my-0 m-0" },
	                    _react2.default.createElement(
	                      "h5",
	                      {
	                        className: "m-0 titulo-content",
	                        style: { fontSize: 20 }
	                      },
	                      "Listado de Clientes"
	                    ),
	                    _react2.default.createElement("hr", { className: "w-50 my-0" }),
	                    _react2.default.createElement(_reactChartjs.HorizontalBar, { options: options, data: data })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 row h-100" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row col-md-12 mt-3" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group col-md-3 input-group-sm" },
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      onChange: handleSearch,
	                      placeholder: "Buscar",
	                      title: "Buscar Factura",
	                      className: "form-control text-uppercase",
	                      ref: txtBuscar
	                    }),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        className: "btn",
	                        style: {
	                          pointerEvents: "none",
	                          backgroundColor: "rgba(5, 81, 130, 1)",
	                          color: "#FFFFFF"
	                        }
	                      },
	                      _react2.default.createElement("i", { className: "fa fa-search" })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 row mx-auto py-3 justify-content-end" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 h-50 mt-2 px-0 mx-0 rounded" },
	                    _react2.default.createElement(
	                      TblContainer,
	                      {
	                        container: {
	                          height: 220,
	                          width: "100%",
	                          overflow: "auto",
	                          padding: "2px",
	                          fontSizeAdjust: "0.6"
	                        }
	                      },
	                      _react2.default.createElement(TblHead, null),
	                      _react2.default.createElement(
	                        _core.TableBody,
	                        { className: "overflow-hidden table-bordered" },
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                          return _react2.default.createElement(
	                            _core.TableRow,
	                            {
	                              key: index,
	                              style: {
	                                padding: "0",
	                                fontSizeAdjust: "0.6"
	                              }
	                            },
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-baseline bg-light",
	                                style: {
	                                  textAlign: "center",
	                                  width: "40px"
	                                }
	                              },
	                              _react2.default.createElement(
	                                "button",
	                                {
	                                  className: "btn btn-sm btn-primary rounded-circle",
	                                  title: "Gestionar Documento",
	                                  onClick: onGestionar(item)
	                                },
	                                _react2.default.createElement("i", { className: "fas fa-redo-alt" })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-baseBar bg-light",
	                                style: {
	                                  textAlign: "center",
	                                  width: "80px"
	                                }
	                              },
	                              item.numfactura
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-baseline bg-light",
	                                style: {
	                                  textAlign: "center",
	                                  width: "80px"
	                                }
	                              },
	                              (0, _moment2.default)(item.fecha).format("DD-MM-YYYY")
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-baseline bg-light",
	                                style: {
	                                  textAlign: "center",
	                                  width: "80px"
	                                }
	                              },
	                              item.creditof && (0, _moment2.default)(item.fechavencimientof).format("DD-MM-YYYY")
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-baseline bg-light",
	                                style: {
	                                  textAlign: "center",
	                                  width: "50px"
	                                }
	                              },
	                              item.creditof && (0, _moment2.default)(item.fechavencimientof).diff((0, _moment2.default)(item.fecha), "days")
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-baseline bg-light",
	                                style: {
	                                  textAlign: "center",
	                                  width: "50px"
	                                }
	                              },
	                              (0, _moment2.default)(fechaSistema).diff((0, _moment2.default)(item.fecha), "days") > item.diasC ? _react2.default.createElement(
	                                "span",
	                                { className: "fw-bold" },
	                                (0, _moment2.default)(fechaSistema).diff((0, _moment2.default)(item.fecha), "days"),
	                                " "
	                              ) : _react2.default.createElement(
	                                "span",
	                                { className: "fw-bold" },
	                                (0, _moment2.default)(fechaSistema).diff((0, _moment2.default)(item.fecha), "days"),
	                                " "
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-baseline bg-light",
	                                style: {
	                                  textAlign: "left",
	                                  width: "350px"
	                                }
	                              },
	                              item.cliente
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-baseline bg-light",
	                                style: {
	                                  textAlign: "right",
	                                  width: "100px"
	                                }
	                              },
	                              (0, _varios.formatMoneda)(item.totalmonto.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-baseline bg-light",
	                                style: {
	                                  textAlign: "right",
	                                  width: "100px"
	                                }
	                              },
	                              (0, _varios.formatMoneda)(item.abono.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-baseline bg-light",
	                                style: {
	                                  textAlign: "right",
	                                  width: "100px"
	                                }
	                              },
	                              (0, _varios.formatMoneda)((item.totalmonto - item.abono).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-baseline bg-light",
	                                style: {
	                                  textAlign: "center",
	                                  width: "80px"
	                                }
	                              },
	                              _react2.default.createElement(
	                                "span",
	                                {
	                                  className: "fw-bold",
	                                  style: {
	                                    color: item.statuscredito === "por vencer" ? "green" : "red"
	                                  }
	                                },
	                                item.creditof ? item.statuscredito : "Por Pagar"
	                              )
	                            )
	                          );
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(TblPagination, null)
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_registrarPagoNotaEntrega2.default, {
	      show: mostrar1,
	      idnot: idnot,
	      abono: abono,
	      anticipo: anticipo,
	      ope: 1,
	      onRenderizar: seleccionarFacturas,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar1(false);
	      }
	    }),
	    _react2.default.createElement(_registrarPagoFactura2.default, {
	      show: mostrar2,
	      idfactu: idfact,
	      abono: abono,
	      anticipo: anticipo,
	      ope: 1,
	      onRenderizar: seleccionarFacturas,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar2(false);
	      }
	    }),
	    _react2.default.createElement(_registrarPagoNotaDebito2.default, {
	      show: mostrar3,
	      idnot: idnot,
	      abono: abono,
	      anticipo: anticipo,
	      ope: 1,
	      onRenderizar: seleccionarFacturas,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar3(false);
	      }
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    )
	  );
	}
	
	exports.default = GestionCuentasCobrar;

/***/ },
/* 7110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(121);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _chart = __webpack_require__(430);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _graficos = __webpack_require__(301);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _core = __webpack_require__(19);
	
	var _registrarPagoFactura = __webpack_require__(671);
	
	var _registrarPagoFactura2 = _interopRequireDefault(_registrarPagoFactura);
	
	var _semanticUiReact = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GestionCuentasPagar(props) {
	    var headCells = [{
	        id: "8",
	        backgroundColor: "rgba(5, 81, 130, 1)",
	        color: "#ffffff",
	        label: _react2.default.createElement('i', { className: 'far fa-eye' }),
	        textAlign: "center"
	    }, { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'FACTURA N°', textAlign: 'center' }, { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'FECHA', textAlign: 'center' }, { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'PROVEEDOR', textAlign: 'center' }, { id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'MONTO', textAlign: 'center' }, { id: '5', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'ABONO', textAlign: 'center' }, { id: '6', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'SALDO', textAlign: 'center' }, { id: '7', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'STATUS', textAlign: 'center' }];
	
	    var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	        TblContainer = _useTableScroll.TblContainer,
	        TblHead = _useTableScroll.TblHead;
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)([]),
	        _useState4 = _slicedToArray(_useState3, 2),
	        valor = _useState4[0],
	        setValor = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        valoru = _useState6[0],
	        setValoru = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(),
	        _useState8 = _slicedToArray(_useState7, 2),
	        totaLClientes = _useState8[0],
	        setTotalClientes = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(0.00),
	        _useState10 = _slicedToArray(_useState9, 2),
	        total = _useState10[0],
	        setTotal = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(false),
	        _useState12 = _slicedToArray(_useState11, 2),
	        mostrar = _useState12[0],
	        setMostrar = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(0.00),
	        _useState14 = _slicedToArray(_useState13, 2),
	        totalu = _useState14[0],
	        setTotalu = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(0),
	        _useState16 = _slicedToArray(_useState15, 2),
	        idnot = _useState16[0],
	        setIdnot = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(0.00),
	        _useState18 = _slicedToArray(_useState17, 2),
	        menor = _useState18[0],
	        setMenor = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(0.0),
	        _useState20 = _slicedToArray(_useState19, 2),
	        abono = _useState20[0],
	        setAbono = _useState20[1];
	
	    var _useState21 = (0, _react.useState)([]),
	        _useState22 = _slicedToArray(_useState21, 2),
	        colorF = _useState22[0],
	        setColorF = _useState22[1];
	
	    var color = [];
	
	    var _useState23 = (0, _react.useState)([{
	        color: '#0d6efd',
	        nombre: 'Total Cobrado',
	        valor: '545.555,23'
	    }, {
	        color: '#dc3545',
	        nombre: 'Total x Cobrar',
	        valor: '54.445,42'
	    }]),
	        _useState24 = _slicedToArray(_useState23, 2),
	        datos = _useState24[0],
	        setDatos = _useState24[1];
	
	    var _useState25 = (0, _react.useState)([]),
	        _useState26 = _slicedToArray(_useState25, 2),
	        records = _useState26[0],
	        setRecords = _useState26[1];
	
	    var _useState27 = (0, _react.useState)([]),
	        _useState28 = _slicedToArray(_useState27, 2),
	        municipiosData = _useState28[0],
	        setMunicipiosData = _useState28[1];
	
	    var _useState29 = (0, _react.useState)(['#0d6efd', '#dc3545']),
	        _useState30 = _slicedToArray(_useState29, 2),
	        colorG = _useState30[0],
	        setColorG = _useState30[1];
	
	    var _useState31 = (0, _react.useState)({
	        enero: 0.00,
	        febrero: 0.00,
	        marzo: 0.00,
	        abril: 0.00,
	        mayo: 0.00,
	        junio: 0.00,
	        julio: 0.00,
	        agosto: 0.00,
	        septiembre: 0.00,
	        octubre: 0.00,
	        noviembre: 0.00,
	        diciembre: 0.00
	    }),
	        _useState32 = _slicedToArray(_useState31, 2),
	        rm = _useState32[0],
	        setRM = _useState32[1];
	
	    var _useState33 = (0, _react.useState)(false),
	        _useState34 = _slicedToArray(_useState33, 2),
	        activate = _useState34[0],
	        setActivate = _useState34[1];
	
	    var _useState35 = (0, _react.useState)(JSON.parse(sessionStorage.getItem('fechasistema'))),
	        _useState36 = _slicedToArray(_useState35, 2),
	        fechaSistema = _useState36[0],
	        setFechaSistema = _useState36[1];
	
	    var _useState37 = (0, _react.useState)(sessionStorage.getItem('anioactu')),
	        _useState38 = _slicedToArray(_useState37, 2),
	        anioActu = _useState38[0],
	        setAnioActu = _useState38[1];
	
	    var _useState39 = (0, _react.useState)([]),
	        _useState40 = _slicedToArray(_useState39, 2),
	        label = _useState40[0],
	        setLabel = _useState40[1];
	
	    var _useState41 = (0, _react.useState)([]),
	        _useState42 = _slicedToArray(_useState41, 2),
	        labelu = _useState42[0],
	        setLabelu = _useState42[1];
	
	    var _useState43 = (0, _react.useState)(),
	        _useState44 = _slicedToArray(_useState43, 2),
	        data = _useState44[0],
	        setData = _useState44[1];
	
	    var _useState45 = (0, _react.useState)(),
	        _useState46 = _slicedToArray(_useState45, 2),
	        options = _useState46[0],
	        setOptions = _useState46[1];
	
	    var token = sessionStorage.getItem('jwtToken');
	    var op = __webpack_require__(8);
	    var ncaja = JSON.parse(sessionStorage.getItem("numcaja"));
	    var accbtncntxpagarc = JSON.parse(sessionStorage.getItem("accbtncntxpagarc"));
	    var txtMesPetro = (0, _react.useRef)();
	    var txtMesUTE = (0, _react.useRef)();
	
	    var seleccionarFacturas = function seleccionarFacturas(status) {
	        var endpoint = op.conexion + '/api/registropago/seleccionarfacturascompras?&status=' + status;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                "x-access-token": '' + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                } else {
	                    setRecords([]);
	                }
	            }
	        }).catch(function (error) {
	            setMensaje({
	                mostrar: true,
	                titulo: "Error",
	                texto: error.response.data.message,
	                icono: "error"
	            });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var seleccionarValorPetro = function seleccionarValorPetro(m) {
	
	        var a = parseInt(fechaSistema.substring(1, 5));
	
	        var endpoint = op.conexion + '/api/valorpetro/valorpetrofecha?mes=' + m;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status == 200) {
	
	                if (response.data.length > 0) {
	
	                    var to = 0;
	                    var te = 0;
	                    var contar = 0;
	                    var label = [];
	                    var datos = [];
	
	                    for (var i = 0; i < response.data.length; i++) {
	
	                        if (response.data[i].anio === a.toString()) {
	                            contar = contar + 1;
	                            label.push((0, _moment2.default)(response.data[i].fechaaplic).format('DD-MM'));
	                            datos.push(response.data[i].valor);
	                        }
	                    }
	
	                    if (contar > 1) {
	                        to = contar - 2;
	                        te = contar - 1;
	                    }
	
	                    setValor(datos);
	                    setLabel(label);
	
	                    var porcp = 0.00;
	                    var totalpcp = 0.00;
	                    var totalreal = 0.00;
	
	                    if (datos[to] > datos[te]) {
	                        porcp = datos[to] / datos[te] * 100;
	                        totalreal = 100 - porcp;
	                        totalpcp = (0, _varios.formatMoneda)(totalreal.toString().replace('.', ','), ',', '.', 2);
	                        setMenor(totalreal);
	                    } else if (datos[to] < datos[te]) {
	                        porcp = datos[to] / datos[te] * 100;
	                        totalreal = 100 - porcp;
	                        totalpcp = (0, _varios.formatMoneda)(totalreal.toString().replace('.', ','), ',', '.', 2);
	                    }
	                    setTotal(totalpcp);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        });
	    };
	
	    var seleccionarValorUT = function seleccionarValorUT(m) {
	
	        var a = parseInt(fechaSistema.substring(1, 5));
	
	        var endpoint = op.conexion + '/api/valorute/valorutefecha?mes=' + m;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                'x-access-token': '' + token
	            }
	        }).then(function (response) {
	
	            if (response.status == 200) {
	
	                if (response.data.length > 0) {
	
	                    var contar = 0;
	                    var to = 0;
	                    var te = 0;
	                    var label = [];
	                    var datos = [];
	
	                    for (var i = 0; i < response.data.length; i++) {
	
	                        if (response.data[i].anio === a.toString()) {
	                            contar = contar + 1;
	                            label.push((0, _moment2.default)(response.data[i].fechaaplic).format('DD-MM'));
	                            datos.push(response.data[i].valor);
	                        }
	                    }
	
	                    if (contar > 1) {
	                        to = contar - 2;
	                        te = contar - 1;
	                    }
	
	                    setValoru(datos);
	                    setLabelu(label);
	
	                    var porcp = 0.00;
	                    var totalpcp = 0.00;
	                    var totalreal = 0.00;
	                    if (datos[to] > datos[te]) {
	                        porcp = datos[to] / datos[te] * 100;
	                        totalreal = 100 - porcp;
	                        totalpcp = (0, _varios.formatMoneda)(totalreal.toString().replace('.', ','), ',', '.', 2);
	                        setMenor(totalreal);
	                    } else if (datos[to] < datos[te]) {
	                        porcp = datos[to] / datos[te] * 100;
	                        totalreal = 100 - porcp;
	                        totalpcp = (0, _varios.formatMoneda)(totalreal.toString().replace('.', ','), ',', '.', 2);
	                    }
	                    setTotalu(totalpcp);
	                }
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        });
	    };
	
	    var onChange = function onChange(event) {
	
	        if (event.target.name === "mes") {
	            var selectedIndex = event.target.options.selectedIndex;
	            seleccionarValorPetro(selectedIndex);
	            setValor([]);
	            setLabel([]);
	            setMenor([]);
	            setTotal(0.00);
	        } else if (event.target.name === "mesut") {
	            var _selectedIndex = event.target.options.selectedIndex;
	            seleccionarValorUT(_selectedIndex);
	            setValoru([]);
	            setLabelu([]);
	            setMenor([]);
	            setTotalu(0.00);
	        }
	    };
	
	    var blanquear = function blanquear() {
	        setRecords([{
	            numero: 'F0006565',
	            fecha: '2022-10-01',
	            diasC: 10,
	            diasV: 13,
	            cliente: 'PEDRO GALINDEZ',
	            monto: '122,65',
	            status: 0
	        }, {
	            numero: 'F0006566',
	            fecha: '2022-10-01',
	            diasC: 15,
	            diasV: 18,
	            cliente: 'JOSE FREITES',
	            monto: '362,65',
	            status: 0
	        }, {
	            numero: 'F0006569',
	            fecha: '2022-10-01',
	            diasC: 90,
	            diasV: 117,
	            cliente: 'PEDRO GALINDEZ',
	            monto: '52,65',
	            status: 0
	        }, {
	            numero: 'F0006570',
	            fecha: '2022-10-01',
	            diasC: 9,
	            diasV: 8,
	            cliente: 'FELIPE TORREALBA',
	            monto: '982,65',
	            status: 1
	        }, {
	            numero: 'F0016565',
	            fecha: '2022-10-01',
	            diasC: 50,
	            diasV: 101,
	            cliente: 'RODOLFO GUZMAN',
	            monto: '1212,65',
	            status: 0
	        }, {
	            numero: 'F0016566',
	            fecha: '2022-10-01',
	            diasC: 25,
	            diasV: 32,
	            cliente: 'ANTERO VELTRAN',
	            monto: '32,65',
	            status: 0
	        }, {
	            numero: 'F0016569',
	            fecha: '2022-10-03',
	            diasC: 90,
	            diasV: 95,
	            cliente: 'JEAN ROCHA',
	            monto: '522,65',
	            status: 0
	        }, {
	            numero: 'F0016570',
	            fecha: '2022-10-03',
	            diasC: 9,
	            diasV: 17,
	            cliente: 'ANTONIO GALLARDO',
	            monto: '98,65',
	            status: 0
	        }, {
	            numero: 'F0006565',
	            fecha: '2022-10-03',
	            diasC: 39,
	            diasV: 77,
	            cliente: 'JEZER PEREZ',
	            monto: '122,65',
	            status: 0
	        }, {
	            numero: 'F0006566',
	            fecha: '2022-10-03',
	            diasC: 90,
	            diasV: 117,
	            cliente: 'SALAD BEBSAD',
	            monto: '362,65',
	            status: 0
	        }, {
	            numero: 'F0006569',
	            fecha: '2022-10-03',
	            diasC: 89,
	            diasV: 165,
	            cliente: 'ALBERTO PEREIRA',
	            monto: '52,65',
	            status: 0
	        }, {
	            numero: 'F0006570',
	            fecha: '2022-10-03',
	            diasC: 65,
	            diasV: 70,
	            cliente: 'JESUS MEJIAS',
	            monto: '982,65',
	            status: 0
	        }, {
	            numero: 'F0016565',
	            fecha: '2022-10-03',
	            diasC: 90,
	            diasV: 117,
	            cliente: 'FERNAN SIVIRA',
	            monto: '1212,65',
	            status: 0
	        }, {
	            numero: 'F0016566',
	            fecha: '2022-10-05',
	            diasC: 20,
	            diasV: 27,
	            cliente: 'CESAR RATIA',
	            monto: '32,65',
	            status: 0
	        }, {
	            numero: 'F0016569',
	            fecha: '2022-10-05',
	            diasC: 30,
	            diasV: 45,
	            cliente: 'JUNIOR BORJAS',
	            monto: '522,65',
	            status: 0
	        }, {
	            numero: 'F0016570',
	            fecha: '2022-10-05',
	            diasC: 80,
	            diasV: 97,
	            cliente: 'CARLOS RODRIGUEZ',
	            monto: '98,65',
	            status: 0
	        }]);
	        color.slice(0);
	        color.push('#007bff');
	        setIdnot(0);
	    };
	
	    var dataTorta = {
	        labels: ['Pagado', 'Por Pagar'],
	        leyend: true,
	        datasets: [{
	            label: '#',
	            data: [parseFloat(545.555, 23), parseFloat(54.445, 42)],
	            backgroundColor: colorG,
	            borderColor: colorG,
	            borderWidth: 1,
	            hoverBorderWidth: 15
	        }]
	    };
	
	    var optionsTorta = {
	        responsive: true,
	        legend: {
	            position: 'top',
	            display: false
	        },
	        title: {
	            display: true,
	            text: 'Total en Deuda: 600.000,65'
	
	        }
	    };
	
	    var optionss = {
	        plugins: {
	            title: {
	                display: true,
	                text: 'Chart.js Bar Chart - Stacked'
	            }
	        },
	        responsive: true,
	        interaction: {
	            mode: 'index',
	            intersect: false
	        },
	        scales: {
	            x: {
	                stacked: true
	            },
	            y: {
	                stacked: true
	            }
	        }
	    };
	
	    var labelss = ['Timbres Fiscales', 'Impuesto 1x500', 'Impuesto Minas', 'Impuesto Producción'];
	
	    var datas = {
	        labels: labelss,
	        datasets: [{
	            label: 'Meta Presupuestaria',
	            data: ["9", "7", "5", "6"],
	            backgroundColor: 'rgba(53, 162, 235)',
	            stack: 'Stack 1'
	        }, {
	            label: 'Cobrado',
	            data: ["7", "4", "9", "7"],
	            backgroundColor: 'rgba(255, 99, 132)',
	            stack: 'Stack 2'
	        }]
	    };
	
	    var optionsn = {
	        responsive: true,
	        plugins: {
	            legend: {
	                position: 'top'
	            },
	            title: {
	                display: true,
	                text: 'Chart.js Bar Chart'
	            }
	        }
	    };
	
	    /* const labelsn = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']; */
	
	    var datan = {
	        labels: label,
	        datasets: [{
	            label: 'Variacion de la Moneda',
	            data: valor,
	            borderColor: 'rgba(255, 99, 132)'
	
	        }]
	    };
	
	    var optionsnu = {
	        responsive: true,
	        plugins: {
	            legend: {
	                position: 'top'
	            },
	            title: {
	                display: true,
	                text: 'Chart.js Bar Chart'
	            }
	        }
	    };
	
	    /* const labelsn = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']; */
	
	    var datanu = {
	        labels: labelu,
	        datasets: [{
	            label: 'Variación de la Unidad Tributaria Estadal',
	            data: valoru,
	            borderColor: 'rgb(2, 99, 132)'
	
	        }]
	    };
	
	    var chartRef = (0, _react.useRef)();
	
	    var onClick = function onClick(event, index) {
	
	        var elements = [];
	
	        for (var i = 0; i < records.length; i++) {
	
	            if (records[i].cliente.trim() === event.trim()) {
	
	                elements.push({
	
	                    numero: records[i].numero,
	                    fecha: records[i].fecha,
	                    diasC: records[i].diasC,
	                    diasV: records[i].diasV,
	                    cliente: records[i].cliente,
	                    monto: records[i].monto,
	                    status: records[i].status
	
	                });
	            }
	        };
	
	        var color = colorF;
	        for (var l = 0; l < totaLClientes.length; l++) {
	
	            if (l === parseInt(index)) {
	                //azul
	
	                color.splice(l, 1, '#007bff');
	            } else {
	                //rojo
	
	                colorF.splice(l, 1, '#dc3545');
	            }
	        }
	
	        setColorF(color);
	
	        setRecords(elements);
	    };
	
	    var onClickButtons = function onClickButtons(accion) {
	        return function (e) {
	            e.preventDefault();
	            var array = [];
	            blanquear();
	            if (accion === 'vencido') {
	                blanquear();
	                for (var i = 0; i < records.length; i++) {
	                    if ((0, _moment2.default)(fechaSistema).diff((0, _moment2.default)(records[i].fecha), 'days') > records[i].diasC) {
	                        array.push({
	                            numero: records[i].numero,
	                            fecha: records[i].fecha,
	                            diasC: records[i].diasC,
	                            diasV: records[i].diasV,
	                            cliente: records[i].cliente,
	                            monto: records[i].monto,
	                            status: records[i].status
	                        });
	                    }
	                }
	            } else {
	                blanquear();
	                for (var _i = 0; _i < records.length; _i++) {
	                    if ((0, _moment2.default)(fechaSistema).diff((0, _moment2.default)(records[_i].fecha), 'days') <= records[_i].diasC) {
	                        array.push({
	                            numero: records[_i].numero,
	                            fecha: records[_i].fecha,
	                            diasC: records[_i].diasC,
	                            diasV: records[_i].diasV,
	                            cliente: records[_i].cliente,
	                            monto: records[_i].monto,
	                            status: records[_i].status
	                        });
	                    }
	                }
	            }
	            setRecords(array);
	        };
	    };
	
	    (0, _react.useEffect)(function () {
	
	        seleccionarFacturas(0);
	    }, []);
	
	    var onGestionar = function onGestionar(item) {
	        return function (e) {
	            if (ncaja !== "") {
	                if (accbtncntxpagarc && accbtncntxpagarc.toString().substring(0, 1) === "1") {
	
	                    setIdnot(item.idfactura);
	                    setAbono(item.abono);
	                    /* setAnticipo(item.anticipo); */
	                    setMostrar(true);
	                } else {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Notificación.",
	                        texto: "¡No Posee Permiso para Realizar esta Acción!",
	                        icono: "error"
	                    });
	                }
	            } else {
	                setMensaje({
	                    mostrar: true,
	                    titulo: "Notificación.",
	                    texto: "¡No Posee un Número de Caja Asignada!",
	                    icono: "error"
	                });
	            }
	        };
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 mx-auto' },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 mt-2' },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                    onHide: function onHide() {
	                        return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                    } }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container-fluid px-3 py-2' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row col-md-10 card py-3 mx-auto' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row col-md-12 mx-auto' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-6 mx-auto h-100 row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 card row h-100' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-12 row mx-auto py-3 justify-content-end' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-md-6 h-100 mx-auto' },
	                                            _react2.default.createElement(_graficos.Torta, { data: dataTorta, height: 300, options: optionsTorta, datos: datos })
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: ' col-md-6 my-auto bg-light border-azul row h-100 justify-content-center rounded mx-auto px-0' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'col-md-12 h-100 mb-2' },
	                                                _react2.default.createElement(
	                                                    'div',
	                                                    { className: 'col-md-12 bg-primary mt-2 py-5 mx-auto rounded shadow d-flex align-items-center' },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'col-md-12 justify-content-center' },
	                                                        _react2.default.createElement(
	                                                            'div',
	                                                            { className: 'col-md-12 d-flex justify-center mx-auto' },
	                                                            _react2.default.createElement(
	                                                                'label',
	                                                                { 'class': ' text-center fw-bold text-light mx-auto ' },
	                                                                'Datos Estadisticos'
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            'select',
	                                                            { className: 'form-select form-select-sm rounded text-center mx-auto col-md-7 fw-bold text-uppercase text-light', name: 'mes', defaultValue: '', 'aria-label': '.form-select-sm example', onChange: blanquear },
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: 0 },
	                                                                ' - Anual - '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: 1 },
	                                                                ' - Enero - '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: 2 },
	                                                                ' - Febrero - '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: 3 },
	                                                                ' - Marzo - '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: 4 },
	                                                                ' - Abril - '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: 5 },
	                                                                ' - Mayo - '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: 6 },
	                                                                ' - Junio - '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: 7 },
	                                                                ' - Julio - '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: 8 },
	                                                                ' - Agosto - '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: 9 },
	                                                                ' - Septiembre - '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: 10 },
	                                                                ' - Octubre - '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: 11 },
	                                                                ' - Noviembre - '
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'option',
	                                                                { value: 12 },
	                                                                ' - Diciembre - '
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    { className: ' btn col-md-12 bg-success mt-2 py-3 mx-auto rounded shadow d-flex align-items-center', onClick: blanquear },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'input-group input-group-sm justify-content-between' },
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { 'class': 'input-group-text border-0 bg-transparent fw-bold text-light', id: 'inputGroup-sizing-sm' },
	                                                            'Total Fact. a Credito:'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control col-md-6 rounded bg-transparent border-0 fw-bold text-right text-light', value: '600.000,65', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    { className: ' btn col-md-12 bg-warning mt-2 py-3 mx-auto rounded shadow d-flex align-items-center', onClick: onClickButtons(' ') },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'input-group input-group-sm justify-content-between' },
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { 'class': 'input-group-text border-0 bg-transparent fw-bold', id: 'inputGroup-sizing-sm' },
	                                                            'Total de Fact. por Vencer :'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control col-md-6 rounded bg-transparent border-0 fw-bold text-right', value: '10', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    { className: ' btn col-md-12 bg-danger mt-2 py-3 mx-auto rounded shadow d-flex align-items-center', onClick: onClickButtons('vencido') },
	                                                    _react2.default.createElement(
	                                                        'div',
	                                                        { 'class': 'input-group input-group-sm justify-content-between' },
	                                                        _react2.default.createElement(
	                                                            'span',
	                                                            { 'class': 'input-group-text border-0 bg-transparent fw-bold text-light', id: 'inputGroup-sizing-sm' },
	                                                            'Total de Fact. Vencidas:'
	                                                        ),
	                                                        _react2.default.createElement('input', { type: 'text', 'class': 'form-control col-md-6 rounded bg-transparent border-0 fw-bold text-right text-light', value: '6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-6 py-2 row mx-auto' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 h-100 my-auto' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-12 row mx-auto', style: { fontSizeAdjust: '0.6' } },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'input-group input-group-sm mb-2 col-pd-150' },
	                                            _react2.default.createElement(
	                                                'span',
	                                                { 'class': 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                                'A\xD1O:'
	                                            ),
	                                            _react2.default.createElement(
	                                                'select',
	                                                { className: 'form-select form-select-sm fw-bold', 'aria-label': '.form-select-sm example' },
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 0 },
	                                                    '2022'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 1 },
	                                                    '2021'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 2 },
	                                                    '2020'
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'input-group input-group-sm mb-2 col-pd-170' },
	                                            _react2.default.createElement(
	                                                'span',
	                                                { 'class': 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                                'COBRADO:'
	                                            ),
	                                            _react2.default.createElement(
	                                                'select',
	                                                { className: 'form-select form-select-sm text-uppercase fw-bold', 'aria-label': '.form-select-sm example' },
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 0 },
	                                                    'Si'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 1 },
	                                                    'No'
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'class': 'input-group input-group-sm mb-2 col-pd-210 px-1' },
	                                            _react2.default.createElement(
	                                                'span',
	                                                { 'class': 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                                'ESTATUS'
	                                            ),
	                                            _react2.default.createElement(
	                                                'select',
	                                                { className: 'form-select form-select-sm text-uppercase fw-bold', 'aria-label': '.form-select-sm example' },
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 0 },
	                                                    'Todas'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 1 },
	                                                    'Por Vencer'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 2 },
	                                                    'Vencida'
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row mt-3 py-0 my-0 m-0' },
	                                        _react2.default.createElement(
	                                            'h5',
	                                            { className: 'm-0 titulo-content', style: { fontSize: 20 } },
	                                            'Listado de Proveedores'
	                                        ),
	                                        _react2.default.createElement('hr', { className: 'w-50 my-0' }),
	                                        _react2.default.createElement(_reactChartjs.HorizontalBar, { options: options, ref: chartRef, data: data, getElementAtEvent: function getElementAtEvent(d) {
	                                                blanquear();
	                                                onClick(d[0]._model.label, d[0]._index);
	                                            } /*  onElementsClick={() => } */ })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 row h-100' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 row mx-auto py-3 justify-content-end' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-12 h-50 mt-2 px-0 mx-0 rounded' },
	                                        _react2.default.createElement(
	                                            TblContainer,
	                                            { container: { height: 220, width: '100%', overflow: 'auto', padding: '2px', fontSizeAdjust: '0.6' } },
	                                            _react2.default.createElement(TblHead, null),
	                                            _react2.default.createElement(
	                                                _core.TableBody,
	                                                { className: 'overflow-hidden table-bordered' },
	                                                records && records.map(function (item, index) {
	                                                    return _react2.default.createElement(
	                                                        _core.TableRow,
	                                                        { key: index, style: { padding: "0" } },
	                                                        _react2.default.createElement(
	                                                            _core.TableCell,
	                                                            {
	                                                                className: 'align-baseline bg-light',
	                                                                style: {
	                                                                    textAlign: "center",
	                                                                    width: "40px"
	                                                                }
	                                                            },
	                                                            _react2.default.createElement(
	                                                                'button',
	                                                                {
	                                                                    className: 'btn btn-sm btn-primary rounded-circle',
	                                                                    title: 'Gestionar Documento',
	                                                                    onClick: onGestionar(item)
	                                                                },
	                                                                _react2.default.createElement('i', { className: 'fas fa-redo-alt' })
	                                                            )
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _core.TableCell,
	                                                            { className: 'align-baseBar bg-light', style: { textAlign: "center", width: '80px' } },
	                                                            item.numfactura
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _core.TableCell,
	                                                            { className: 'align-baseline bg-light', style: { textAlign: "center", width: '80px' } },
	                                                            (0, _moment2.default)(item.fecha).format('DD-MM-YYYY')
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _core.TableCell,
	                                                            { className: 'align-baseline bg-light', style: { width: '300px' } },
	                                                            item.proveedor
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _core.TableCell,
	                                                            { className: 'align-baseline bg-light', style: { textAlign: "right", width: '50px' } },
	                                                            (0, _varios.formatMoneda)(item.total.toString().replace('.', ','), ',', '.', 2)
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _core.TableCell,
	                                                            { className: 'align-baseline bg-light', style: { textAlign: "right", width: '50px' } },
	                                                            (0, _varios.formatMoneda)(item.abono.toString().replace('.', ','), ',', '.', 2)
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _core.TableCell,
	                                                            { className: 'align-baseline bg-light', style: { textAlign: "right", width: '50px' } },
	                                                            (0, _varios.formatMoneda)(item.montotal.toString().replace('.', ','), ',', '.', 2)
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _core.TableCell,
	                                                            { className: 'align-baseline bg-light', style: { textAlign: "center", width: '80px' } },
	                                                            item.estatus === 'POR PAGAR' ? _react2.default.createElement(
	                                                                'b',
	                                                                { className: 'fw-bold text-danger' },
	                                                                item.estatus
	                                                            ) : item.estatus === 'CANCELADA' ? _react2.default.createElement(
	                                                                'b',
	                                                                { className: 'fw-bold text-success' },
	                                                                item.estatus
	                                                            ) : _react2.default.createElement(
	                                                                'b',
	                                                                { className: 'fw-bold text-warning' },
	                                                                item.estatus
	                                                            )
	                                                        )
	                                                    );
	                                                })
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_registrarPagoFactura2.default, {
	            show: mostrar,
	            idnot: idnot,
	            abono: abono
	            /* anticipo={anticipo} */
	            , ope: 1
	            /* combo={combo} */
	            , onRenderizar: seleccionarFacturas,
	            onHideCancelar: function onHideCancelar() {
	                setMostrar(false);
	            }
	        }),
	        _react2.default.createElement(
	            _semanticUiReact.Dimmer,
	            { active: activate, inverted: true },
	            _react2.default.createElement(
	                _semanticUiReact.Loader,
	                { inverted: true },
	                'cargando...'
	            )
	        )
	    );
	}
	
	exports.default = GestionCuentasPagar;

/***/ },
/* 7111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GestionarBanco = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _useTable = __webpack_require__(20);
	
	var _useTable2 = _interopRequireDefault(_useTable);
	
	var _core = __webpack_require__(19);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoBanco = __webpack_require__(7022);
	
	var _catalogoBanco2 = _interopRequireDefault(_catalogoBanco);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GestionarBanco = exports.GestionarBanco = function GestionarBanco(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var accbtnbancos = JSON.parse(sessionStorage.getItem('accbtnbancosc'));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtIdmarca = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)('visible'),
	      _useState2 = _slicedToArray(_useState, 2),
	      visibleBtn = _useState2[0],
	      setVisibleBtn = _useState2[1];
	
	  var _useState3 = (0, _react.useState)('Gestionar Banco.'),
	      _useState4 = _slicedToArray(_useState3, 2),
	      tituloHeader = _useState4[0],
	      setTituloHeader = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      body = _useState6[0],
	      setBody = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      activate = _useState8[0],
	      setActivate = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(true),
	      _useState10 = _slicedToArray(_useState9, 2),
	      habilitado = _useState10[0],
	      setHabilitado = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mensaje = _useState12[0],
	      setMensaje = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensajesino = _useState14[0],
	      setMensajesino = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      catalogoMarca = _useState16[0],
	      setCatalogoMarca = _useState16[1];
	
	  var _useState17 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState18 = _slicedToArray(_useState17, 2),
	      botones = _useState18[0],
	      setBotones = _useState18[1];
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'descripcion') {
	      e.target.value = e.target.value;
	    } else {
	      e.target.value = e.target.value;
	    }
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = 'idbanco, trim(nombre) as nombre';
	    var nomtab = 'bancos';
	    var nomid = 'idbanco';
	    var id = txtIdmarca.current.value;
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        txtDescripcion.current.value = '';
	
	        if (response.data !== '') {
	
	          txtDescripcion.current.value = response.data.nombre.trim();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una marca con este codigo', icono: 'informacion' });
	          txtDescripcion.current.value = '';
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var validarMarca = function validarMarca(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value !== '') {
	
	        seleccionarRegistro();
	      }
	    }
	  };
	
	  var onCatalogoMarca = function onCatalogoMarca(values) {
	    setCatalogoMarca(false);
	    txtIdmarca.current.value = values.idbanco;
	    txtDescripcion.current.value = values.nombre;
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	
	    var sigue = true;
	    if (!botones.incluir || !botones.modificar) {
	
	      if (txtDescripcion.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar una descripción', icono: 'informacion' });
	        txtDescripcion.current.focus();
	        sigue = false;
	      }
	    }
	
	    if (sigue) {
	
	      /*    var marca = [];
	         marca.push({
	           
	         })
	      */var ope = 0;
	      if (!botones.incluir) {
	        ope = 1;
	      } else if (!botones.modificar) {
	        ope = 2;
	      } else if (!botones.eliminar) {
	        ope = 3;
	      }
	      setBody({
	        operacion: ope,
	        nid: txtIdmarca.current.value === '' ? 0 : txtIdmarca.current.value,
	        nom: txtDescripcion.current.value.toUpperCase().trim()
	      });
	
	      var msg = '';
	      if (!botones.incluir) {
	        msg = 'Esta Seguro de Registrar estos Datos.';
	      } else if (!botones.modificar) {
	        msg = 'Esta Seguro de Modificar estos Datos.';
	      } else if (!botones.eliminar) {
	        msg = 'Esta Seguro de Eliminar estos Datos.';
	      }
	
	      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + '/api/banco/actualizarbanco';
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (ope === 1) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
	        } else if (ope === 2) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
	        } else if (ope === 3) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = '';
	      if (error.response === undefined) {
	        mensaje = 'Error de Conexion';
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
	          mensaje = 'Ya existe un Registro';
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    procesarRegistro();
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setTituloHeader('Gestionar Banco.');
	    setBody(null);
	    setHabilitado(true);
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      salir: false
	    });
	    txtIdmarca.current.setAttribute("disabled", true);
	    txtIdmarca.current.value = '';
	    txtDescripcion.current.value = '';
	    setVisibleBtn('visible');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	
	      e.preventDefault();
	
	      if (op === 1) {
	
	        if (accbtnbancos && accbtnbancos.toString().substring(0, 1) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Incluir Banco.');
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	          txtIdmarca.current.setAttribute("disabled", true);
	          setTimeout(function () {
	            return txtDescripcion.current.focus();
	          }, 200);
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 2) {
	
	        if (accbtnbancos && accbtnbancos.toString().substring(1, 2) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Editar Banco.');
	          txtIdmarca.current.removeAttribute("disabled");
	          setHabilitado(false);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdmarca.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 3) {
	
	        if (accbtnbancos && accbtnbancos.toString().substring(3, 4) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Eliminar Banco.');
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdmarca.current.removeAttribute("disabled");
	          txtIdmarca.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 4) {
	
	        if (accbtnbancos && accbtnbancos.toString().substring(2, 3) === '1') {
	          setVisibleBtn('collapse');
	          setTituloHeader('Concultar Banco.');
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	          txtIdmarca.current.removeAttribute("disabled");
	          txtIdmarca.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        blanquear();
	      } else if (op === 7) {
	        setVisibleBtn('visible');
	        cancelar();
	      }
	    };
	  };
	
	  var cerrarModal = function cerrarModal() {
	    props.onHideRenderizar();
	
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var imprimirBanco = function imprimirBanco() {
	
	    if (accbtnbancos && accbtnbancos.toString().substring(4, 5) === '1') {
	      window.open(op.reportes + "reporte=listBancos", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	    } else {
	      setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	        //setOperacion(props.operacion)
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        _Modal2.default.Title,
	        { style: { color: "#fff" } },
	        tituloHeader,
	        ' '
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: onBotones(7), className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 mx-auto px-0' },
	          _react2.default.createElement(
	            'div',
	            { className: 'mb-3 col-pd-140 ml-auto' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'FECHA: ',
	              _react2.default.createElement(
	                'span',
	                { className: 'fw-bold fs-6' },
	                (0, _moment2.default)(fechasistema).format('DD-MM-YYYY'),
	                ' '
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'border-azul col-md-12 py-3 rounded mx-1', style: { fontSizeAdjust: '0.6' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'row col-md-12 rounded mx-auto' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-2 col-md-3' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'CODIGO:'
	              ),
	              _react2.default.createElement('input', { type: 'text', ref: txtIdmarca, disabled: true, onKeyUp: validarMarca, onBlur: validarMarca, className: 'form-control fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	              _react2.default.createElement(
	                'button',
	                { disabled: botones.catalogo, type: 'button', onClick: function onClick() {
	                    return setCatalogoMarca(true);
	                  }, className: 'btn btn-success' },
	                _react2.default.createElement('i', { className: 'fas fa-search' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-1 ml-auto px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn btn-primary btn-sm rounded ', onClick: imprimirBanco },
	                  _react2.default.createElement('i', { className: 'fas fa-print' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm col-md-12' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'DESCRIPCION:'
	              ),
	              _react2.default.createElement('input', { type: 'text', ref: txtDescripcion, name: 'descripcion', autoComplete: 'off', disabled: habilitado, className: 'form-control text-uppercase fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onChange: onChange })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      visibleBtn === 'visible' ? _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 mx-auto row justify-content-between', style: { visibility: props.llamado === 2 ? 'collapse' : props.llamado !== 2 ? visibleBtn : 'visible' } },
	        _react2.default.createElement(
	          'button',
	          { disabled: botones.incluir, onClick: onBotones(1), className: 'btn btn-sm mx-1 my-1 col btn-primary rounded-pill', title: 'Incluir Medida' },
	          _react2.default.createElement(
	            'i',
	            { className: 'fas fa-plus' },
	            ' Incluir '
	          ),
	          ' '
	        ),
	        _react2.default.createElement(
	          'button',
	          { disabled: botones.consultar, onClick: onBotones(4), className: 'btn btn-sm mx-1 my-1 col btn-info rounded-pill', title: 'Consultar Medida' },
	          _react2.default.createElement(
	            'i',
	            { className: 'fas fa-eye' },
	            'Consultar'
	          ),
	          ' '
	        ),
	        _react2.default.createElement(
	          'button',
	          { disabled: botones.modificar, onClick: onBotones(2), className: 'btn btn-sm mx-1 my-1 col btn-warning rounded-pill', title: 'Modificar Medida' },
	          _react2.default.createElement(
	            'i',
	            { className: 'fa fa-edit' },
	            'Modificar'
	          ),
	          ' '
	        ),
	        _react2.default.createElement(
	          'button',
	          { disabled: botones.eliminar, onClick: onBotones(3), className: 'btn btn-sm mx-1 my-1 col btn-danger rounded-pill', title: 'Eliminar Medida' },
	          _react2.default.createElement(
	            'i',
	            { className: 'fa fa-trash' },
	            'Eliminar'
	          ),
	          ' '
	        )
	      ) : _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto justify-content-end', style: { visibility: visibleBtn === 'visible' ? 'collapse' : 'visible' } },
	        _react2.default.createElement(
	          'button',
	          { ref: btnAcepta, disabled: botones.aceptar, onClick: onBotones(5), className: 'btn col-md-3 mx-1 my-1 btn-sm rounded-pill btn-success ' },
	          _react2.default.createElement(
	            'i',
	            { className: 'fas fa-check-circle' },
	            '  Aceptar'
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          { ref: btnCancela, disabled: botones.cancelar, onClick: onBotones(6), className: 'btn col-md-3 mx-1 my-1 btn-danger btn-sm rounded-pill ' },
	          _react2.default.createElement(
	            'i',
	            { className: 'fas fa-window-close' },
	            ' Cancelar'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoBanco2.default, {
	      show: catalogoMarca,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoMarca(false);
	      },
	      onHideAceptaCatalogo: onCatalogoMarca
	    })
	  );
	};

/***/ },
/* 7112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ImpMovBanLibro = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoCuentasBancarias = __webpack_require__(156);
	
	var _catalogoCuentasBancarias2 = _interopRequireDefault(_catalogoCuentasBancarias);
	
	var _mensajes = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImpMovBanLibro = exports.ImpMovBanLibro = function ImpMovBanLibro(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var post = JSON.parse(sessionStorage.getItem("post"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var idefiscal = JSON.parse(sessionStorage.getItem("idefiscal"));
	  var idusuario = JSON.parse(sessionStorage.getItem("idusuario"));
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var anioefis = JSON.parse(sessionStorage.getItem("efiscalanio"));
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      disabledInput = _useState2[0],
	      setDisabledInput = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(sessionStorage.getItem("espiritu")),
	      _useState4 = _slicedToArray(_useState3, 2),
	      espiritu = _useState4[0],
	      setEspiritu = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      activate = _useState6[0],
	      setActivate = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mostrar5 = _useState8[0],
	      setMostrar5 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(true),
	      _useState10 = _slicedToArray(_useState9, 2),
	      deshabilitado = _useState10[0],
	      setDeshabilitado = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      operacion = _useState12[0],
	      setOperacion = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mostrar4 = _useState14[0],
	      setMostrar4 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(),
	      _useState16 = _slicedToArray(_useState15, 2),
	      cmbAnios = _useState16[0],
	      setCmbAnios = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(),
	      _useState18 = _slicedToArray(_useState17, 2),
	      cmbMeses = _useState18[0],
	      setCmbMeses = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      val = _useState20[0],
	      setVal = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      val2 = _useState22[0],
	      setVal2 = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(true),
	      _useState24 = _slicedToArray(_useState23, 2),
	      activo = _useState24[0],
	      setActivo = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(true),
	      _useState26 = _slicedToArray(_useState25, 2),
	      montoFactu = _useState26[0],
	      setMontoFactu = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      desde = _useState28[0],
	      setDesde = _useState28[1];
	
	  var _useState29 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState30 = _slicedToArray(_useState29, 2),
	      mensaje = _useState30[0],
	      setMensaje = _useState30[1];
	
	  var _useState31 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState32 = _slicedToArray(_useState31, 2),
	      mensajesino = _useState32[0],
	      setMensajesino = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(),
	      _useState34 = _slicedToArray(_useState33, 2),
	      datos = _useState34[0],
	      setDatos = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(0),
	      _useState36 = _slicedToArray(_useState35, 2),
	      idFactxOrden = _useState36[0],
	      setIdFactxOrden = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(),
	      _useState38 = _slicedToArray(_useState37, 2),
	      fechaUD = _useState38[0],
	      setFechaUD = _useState38[1];
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var chkManual = (0, _react.useRef)();
	  var txtNumOperacion = (0, _react.useRef)();
	  var txtNumFactura = (0, _react.useRef)();
	  var txtNumControl = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtSubTotal = (0, _react.useRef)();
	  var txtOtros = (0, _react.useRef)();
	  var txtAjustes = (0, _react.useRef)();
	  var txtExento = (0, _react.useRef)();
	  var txtBaseImponible = (0, _react.useRef)();
	  var txtPorceIva = (0, _react.useRef)();
	  var txtMontoIva = (0, _react.useRef)();
	  var txtTotal = (0, _react.useRef)();
	  var txtIdCuenta = (0, _react.useRef)();
	  var txtNomBanco = (0, _react.useRef)();
	  var txtNumCuenta = (0, _react.useRef)();
	  var txtMotivo = (0, _react.useRef)();
	  var txtIdordenpago = (0, _react.useRef)();
	  var txtFechaConRef = (0, _react.useRef)();
	
	  var cmbMesRef = (0, _react.useRef)();
	  var cmbAnioRef = (0, _react.useRef)();
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setActivo(true);
	    setDeshabilitado(true);
	  };
	
	  var cerrarModal = function cerrarModal() {
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    props.onDatos(datos);
	    props.onHideCancelar();
	    blanquear();
	  };
	  var handleInputNumChange = function handleInputNumChange(event) {
	    event.preventDefault();
	    if (event.target.id === "numoperacion") {
	      (0, _varios.validaSoloNumero)(event);
	    }
	
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.which === 13) {
	        if (event.target.id === "numoperacion") {
	          txtNumFactura.current.focus();
	        } else if (event.target.id === "numfactura") {
	          txtNumControl.current.focus();
	        } else if (event.target.id === "numcontrol") {
	          txtFecha.current.focus();
	        }
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var seleccionarCuentaBancaria = function seleccionarCuentaBancaria(codigo) {
	    var campos = "*";
	    var nomtab = "cuentabancaria";
	    var nomid = "idcuentabancaria";
	
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&id=" + codigo + "&nomtab=" + nomtab + "&nomid=" + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.idcuentabancaria > 0) {
	          txtIdCuenta.current.value = response.data.idcuentabancaria;
	          txtNomBanco.current.value = response.data.nombre;
	          txtNumCuenta.current.value = response.data.cuentabancaria;
	          setDisabledInput(2);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Error.",
	            texto: "¡Código i/o Cuenta Bancaria, No esta Registrado!",
	            icono: "error"
	          });
	          txtIdCuenta.current.value = "";
	          txtNomBanco.current.value = "";
	          txtNumCuenta.current.value = "";
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCuentaBancaria = function handleCuentaBancaria(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        seleccionarCuentaBancaria(event.target.value);
	      }
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	    var sigue = true;
	    if (!txtIdCuenta.current.value) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "Debe ingresar o seleccioanr una cuenta bancaria",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtIdCuenta.current.focus();
	    }
	
	    if (sigue) {
	      var reporte = "LibroAuxMensualA";
	
	      var anio = parseInt(cmbAnioRef.current.value);
	      var ini = cmbMesRef.current.value.length === 2 ? '"' + anio + "-" + cmbMesRef.current.value + '-01"' : '"' + anio + "-0" + cmbMesRef.current.value + '-01"';
	
	      var fechas = cmbMesRef.current.value.length === 2 ? +anio + "-" + cmbMesRef.current.value + '-01' : +anio + "-0" + cmbMesRef.current.value + '-01';
	
	      var prueba = (0, _moment2.default)(fechas.toString()).endOf('month');
	
	      var fin = cmbMesRef.current.value.length === 2 ? '"' + cmbAnioRef.current.value + "-" + cmbMesRef.current.value + '-' + (0, _moment2.default)(prueba).format('DD') + '"' : '"' + parseInt(cmbAnioRef.current.value) + "-0" + cmbMesRef.current.value + '-' + (0, _moment2.default)(prueba).format('DD') + '"';
	
	      var desdec = cmbMesRef.current.value.length === 2 ? "'" + anio + "-" + cmbMesRef.current.value + '-01' + "'" : "'" + anio + "-0" + cmbMesRef.current.value + '-01' + "'";
	
	      var hasctac = cmbMesRef.current.value.length === 2 ? "'" + cmbAnioRef.current.value + "-" + cmbMesRef.current.value + '-' + (0, _moment2.default)(prueba).format('DD') + "'" : "'" + parseInt(cmbAnioRef.current.value) + "-0" + cmbMesRef.current.value + '-' + (0, _moment2.default)(prueba).format('DD') + "'";
	
	      var sql = "(doc_fechae between " + desdec + ' AND ' + hasctac + ")";
	      var sql2 = "DESDE EL '" + ini + "' HASTA EL '" + fin + "'";
	      var sql3 = "c.idcuentabancaria = " + txtIdCuenta.current.value;
	      var sql4 = "AND true";
	      var tit = cmbMesRef.current.value.length < 2 ? "0" + cmbMesRef.current.value + '/' + anio : cmbMesRef.current.value + '/' + anio;
	      var org = post.nombreorg;
	
	      window.open(op.reportes + "/finanzas?afiliado=" + afiliado + "&reporte=" + reporte + "&sql=" + encodeURIComponent(sql) + "&sql3=" + encodeURIComponent(sql3) + "&sql4=" + encodeURIComponent(sql4) + "&ini=" + encodeURIComponent(ini) + "&fin=" + encodeURIComponent(fin) + "&tit=" + encodeURIComponent(tit) + "&org=" + encodeURIComponent(org) + "&ciu=" + encodeURIComponent(' '), "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	    }
	  };
	
	  var seleccionarFactura = function seleccionarFactura() {
	    blanquear();
	    var data = [];
	
	    data.push({
	      idfacturaxorden: idFactxOrden,
	      numoperacion: txtNumOperacion.current.value,
	      numfactura: txtNumFactura.current.value,
	      numcontrol: txtNumControl.current.value,
	      fecfactura: txtFecha.current.value,
	      subtotal: parseFloat(txtSubTotal.current.value.replace(/\./g, "").replace(",", ".")),
	      otros: parseFloat(txtOtros.current.value.replace(/\./g, "").replace(",", ".")),
	      ajuste: parseFloat(txtAjustes.current.value.replace(/\./g, "").replace(",", ".")),
	      exento: parseFloat(txtExento.current.value.replace(/\./g, "").replace(",", ".")),
	      baseimponible: parseFloat(txtBaseImponible.current.value.replace(/\./g, "").replace(",", ".")),
	      porceiva: parseFloat(txtPorceIva.current.value.replace(/\./g, "").replace(",", ".")),
	      total: parseFloat(txtTotal.current.value.replace(/\./g, "").replace(",", "."))
	    });
	    setDatos(data);
	    var msg = "";
	    if (props.operacion === 1) {
	      msg = "registro creado correctamente.";
	    } else if (props.operacion === 2) {
	      msg = "registro modificado correctamente.";
	    } else if (props.operacion === 3) {
	      msg = "registro eliminado correctamente.";
	    }
	    setMensaje({ mostrar: true, titulo: "Exito.", texto: msg, icono: "exito" });
	  };
	
	  var handleCancelaCuentaBancaria = function handleCancelaCuentaBancaria() {
	    setMostrar5(false);
	  };
	
	  var handleAceptarCuentaBancaria = function handleAceptarCuentaBancaria(datos) {
	    setMostrar5(false);
	    setDisabledInput(2);
	    txtIdCuenta.current.value = datos.idcuentabancaria;
	    txtNomBanco.current.value = datos.nombre;
	    txtNumCuenta.current.value = datos.cuentabancaria;
	  };
	
	  var LlenarComboAnio = function LlenarComboAnio() {
	    var n = new Date().getFullYear();
	    var a = [];
	    for (var i = n; i >= 2015; i--) {
	      a.push({ anio: i });
	    }
	    cmbAnioRef.current.value = n;
	    setCmbAnios(a);
	    var meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
	    var m = [];
	    for (var x = 0; x < 12; x++) {
	      m.push({ nummes: x + 1, mes: meses[x] });
	    }
	    cmbMesRef.current.value = 1;
	    setCmbMeses(m);
	  };
	
	  var catalogoCuentaBancaria = function catalogoCuentaBancaria(e) {
	    e.preventDefault();
	    setMostrar5(true);
	  };
	
	  var validarPeriodo = function validarPeriodo(event) {
	    setDesde(0);
	
	    var fecPer = cmbAnioRef.current.value + "-" + cmbMesRef.current.value.toString().padStart(2, 0) + "-01";
	    if (fecPer > (0, _moment2.default)(txtFechaConRef.current.value).format("YYYY-MM-DD")) {
	      /*  setTitulo("Error");
	         setMsg("La fecha de Conciliación no puede ser menor al periodo a conciliar");
	         setMostrar(true); */
	      cmbMesRef.current.value = 1;
	      cmbAnioRef.current.value = new Date(txtFechaConRef.current.value).getFullYear();
	      var fecUD = cmbAnioRef.current.value + "-" + cmbMesRef.current.value.toString().padStart(2, 0) + "-" + new Date(cmbAnioRef.current.value, cmbMesRef.current.value, 0).getDate().toString().padStart(2, 0);
	      setFechaUD(fecUD);
	      return false;
	    } else {
	      var _fecUD = cmbAnioRef.current.value + "-" + cmbMesRef.current.value.toString().padStart(2, 0) + "-" + new Date(cmbAnioRef.current.value, cmbMesRef.current.value, 0).getDate().toString().padStart(2, 0);
	      setFechaUD(_fecUD);
	      return true;
	    }
	  };
	
	  (0, _react.useEffect)(function () {}, []);
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "md",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        setActivo(false);
	        LlenarComboAnio();
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Movimientos Bancarios Seg\xFAn Libros"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12 row mx-auto px-0 border-azul rounded" },
	        _react2.default.createElement(
	          "fieldset",
	          { className: "row px-0 rounded mx-auto mb-2" },
	          _react2.default.createElement(
	            "legend",
	            {
	              className: "float-none m-0 w-auto fw-bold",
	              style: { fontSize: 18 }
	            },
	            "Datos del Banco"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group input-group-sm col-md-5 mb-3" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text fs-6", id: "inputGroup-sizing-sm" },
	              "CODIGO:"
	            ),
	            _react2.default.createElement("input", {
	              type: "text",
	              className: "form-control text-uppercase fs-6 h-100",
	              disabled: disabledInput === 1 ? false : disabledInput === 2 ? false : true,
	              onChange: handleInputNumChange,
	              onKeyUp: handleCuentaBancaria,
	              onBlur: handleInputNumChange
	              /* disabled={habiprov} */, ref: txtIdCuenta,
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm",
	              id: "idcuenta"
	            }),
	            _react2.default.createElement(
	              "button",
	              {
	                /* disabled={habiprov} */onClick: catalogoCuentaBancaria,
	                className: "btn btn-sm  btn-info"
	              },
	              _react2.default.createElement("i", { className: "fa fa-search" }),
	              " "
	            )
	          ),
	          _react2.default.createElement("div", { className: "col-md-7" }),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group input-group-sm col-md-12 mb-3" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text fs-6", id: "inputGroup-sizing-sm" },
	              "BANCO:"
	            ),
	            _react2.default.createElement("input", {
	              type: "text",
	              className: "form-control text-uppercase fs-6 h-100",
	              maxLength: 12,
	              disabled: true,
	              ref: txtNomBanco,
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm",
	              id: "inputDireccion"
	            }),
	            _react2.default.createElement("input", {
	              type: "text",
	              className: "form-control text-uppercase fs-6 h-100 px-1",
	              ref: txtNumCuenta,
	              disabled: true,
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm",
	              id: "inputDireccion"
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group input-group-sm col-md-6" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text fs-6", id: "inputGroup-sizing-sm" },
	              "MES:"
	            ),
	            _react2.default.createElement(
	              "select",
	              {
	                name: "",
	                className: "form-select fs-6 text-uppercase",
	                disabled: disabledInput === 2 ? false : true,
	                ref: cmbMesRef,
	                onChange: validarPeriodo
	              },
	              cmbMeses && cmbMeses.map(function (meses) {
	                return _react2.default.createElement(
	                  "option",
	                  { key: meses.nummes, value: meses.nummes },
	                  meses.mes
	                );
	              }),
	              ";"
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-group input-group-sm col-md-4" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text fs-6", id: "inputGroup-sizing-sm" },
	              "A\xD1O:"
	            ),
	            _react2.default.createElement(
	              "select",
	              {
	                name: "",
	                className: "form-select text-right fs-6",
	                disabled: disabledInput === 2 ? false : true,
	                id: "anio",
	                ref: cmbAnioRef,
	                onChange: validarPeriodo
	              },
	              cmbAnios && cmbAnios.map(function (anios) {
	                return _react2.default.createElement(
	                  "option",
	                  { key: anios.anio, value: anios.anio },
	                  anios.anio
	                );
	              }),
	              ";"
	            )
	          ),
	          _react2.default.createElement("div", { className: "col-md-3" })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          type: "button",
	          ref: btnAcepta,
	          onClick: onChangeValidar,
	          disabled: activo,
	          style: { margin: "1px" },
	          className: "fw-bold btn btn-primary btn-sm rounded-pill"
	        },
	        _react2.default.createElement("i", { className: "far fa-check-circle" }),
	        " Imprimir"
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          type: "button",
	          ref: btnCancela,
	          onClick: cancelar,
	          style: { margin: "1px" },
	          className: "fw-bold btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement("i", { className: "fas fa-window-close" }),
	        " Cancelar"
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_catalogoCuentasBancarias2.default, {
	      show: mostrar5,
	      onHideCancelar: handleCancelaCuentaBancaria,
	      onHideAceptaCatalogo: handleAceptarCuentaBancaria
	    })
	  );
	};

/***/ },
/* 7113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalImprimirIngresos = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalImprimirIngresos = exports.ModalImprimirIngresos = function ModalImprimirIngresos(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtDesde = (0, _react.useRef)();
	  var txtHasta = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      desde = _useState2[0],
	      setDesde = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = _slicedToArray(_useState3, 2),
	      hasta = _useState4[0],
	      setHasta = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      activate = _useState6[0],
	      setActivate = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mensaje = _useState8[0],
	      setMensaje = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mensajesino = _useState10[0],
	      setMensajesino = _useState10[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setDesde('');
	    setHasta('');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope === 1) {
	
	      if (txtDesde.current.value === "" || txtHasta.current.value === "") {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Las Fechas a Consultar no deben ir Vacias !', icono: 'informacion' });
	        txtDesde.current.focus();
	        sigue = false;
	      } else {
	
	        imprimirRecibo();
	      }
	    }
	  };
	
	  var imprimirRecibo = function imprimirRecibo() {
	
	    var reporte;
	    var condi = '';
	    var fechas = "'" + 'and n.fecha between ' + "'" + '||quote_literal(' + "'" + desde + "'" + ')||' + "'" + ' and ' + "'" + '||quote_literal(' + "'" + hasta + "'" + ')';
	
	    if (props.val === "reportelibroventas") {
	      reporte = "libroventas";
	      condi = fechas;
	    } else {
	      reporte = "Ingresos";
	      condi = '';
	    }
	
	    window.open(op.reportes + "/finanzas?afiliado=" + afiliado + "&reporte=" + reporte + "&desde=" + "'" + desde + "'" + "&hasta=" + "'" + hasta + "'" + "&condi=" + condi, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "desde") {
	      var desdec = (0, _moment2.default)(e.target.value).format('DD-MM-YYYY');
	      if (e.target.value > (0, _moment2.default)(fechasistema).format('YYYY-MM-DD')) {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !', icono: 'informacion' });
	        txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        txtDesde.current.focus();
	      } else {
	        setDesde(desdec);
	      }
	    } else if (e.target.name === "hasta") {
	      var hastac = (0, _moment2.default)(e.target.value).format('DD-MM-YYYY');
	      setHasta(hastac);
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'md',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        txtHasta.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        var desdec = (0, _moment2.default)(fechasistema).format('DD-MM-YYYY');
	        var hastac = (0, _moment2.default)(fechasistema).format('DD-MM-YYYY');
	        setDesde(desdec);
	        setHasta(hastac);
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          props.val === "reportelibroventas" ? "Imprimir Libro Ventas" : "Imprimir Ingresos"
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto m-0 border-azul px-1' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-12 row m-0 px-0 py-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-6 px-1 mb-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'DESDE:'
	                ),
	                _react2.default.createElement('input', { type: 'date', ref: txtDesde, name: 'desde', onChange: onChange, className: 'form-control fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-6 px-1 mb-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'HASTA:'
	                ),
	                _react2.default.createElement('input', { type: 'date', ref: txtHasta, name: 'hasta', onChange: onChange, className: 'form-control fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-11 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: props.ope !== 0 ? false : true, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-primary mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-print' },
	              '  Imprimir'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalImprimirRecibosReversados = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalImprimirRecibosReversados = exports.ModalImprimirRecibosReversados = function ModalImprimirRecibosReversados(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtDesde = (0, _react.useRef)();
	  var txtHasta = (0, _react.useRef)();
	  var txtTodosCliente = (0, _react.useRef)();
	  var txtPorCliente = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtCbmrif = (0, _react.useRef)();
	  var txtNombre = (0, _react.useRef)();
	  var txtTodasFechas = (0, _react.useRef)();
	  var txtPorFechas = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      desde = _useState2[0],
	      setDesde = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = _slicedToArray(_useState3, 2),
	      hasta = _useState4[0],
	      setHasta = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mostrar1 = _useState6[0],
	      setMostrar1 = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      activate = _useState8[0],
	      setActivate = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      actfecha = _useState10[0],
	      setActfecha = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      actcliente = _useState12[0],
	      setActcliente = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(''),
	      _useState14 = _slicedToArray(_useState13, 2),
	      clientvende = _useState14[0],
	      setClientvende = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mensaje = _useState16[0],
	      setMensaje = _useState16[1];
	
	  var _useState17 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState18 = _slicedToArray(_useState17, 2),
	      mensajesino = _useState18[0],
	      setMensajesino = _useState18[1];
	
	  var _useState19 = (0, _react.useState)('V'),
	      _useState20 = _slicedToArray(_useState19, 2),
	      tiporif = _useState20[0],
	      setTipofic = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(''),
	      _useState22 = _slicedToArray(_useState21, 2),
	      idclient = _useState22[0],
	      setIdclient = _useState22[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setDesde('');
	    setHasta('');
	    setMostrar1(false);
	    setClientvende('');
	    setTipofic('V');
	    setIdclient('');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope === 1) {
	
	      if (txtPorFechas.current.checked === true && txtPorCliente.current.checked === false) {
	        if (txtDesde.current.value === '' || txtHasta.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione las Fechas a Consultar !', icono: 'informacion' });
	          if (txtDesde.current.value === '' && txtHasta.current.value !== '') {
	            txtDesde.current.focus();
	          } else if (txtHasta.current.value === '' && txtDesde.current.value !== '') {
	            txtHasta.current.focus();
	          }
	          sigue = false;
	        } else {
	          imprimirReverso();
	        }
	      } else if (txtPorFechas.current.checked === false && txtPorCliente.current.checked === true) {
	        if (txtRif.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el RIF del Cliente a Consultar !', icono: 'informacion' });
	          txtRif.current.focus();
	          sigue = false;
	        } else {
	          imprimirReverso();
	        }
	      } else if (txtPorFechas.current.checked === true && txtPorCliente.current.checked === true) {
	        if (txtDesde.current.value === '' || txtHasta.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Las Fechas a Consultar no Deben ir Vacias !', icono: 'informacion' });
	          txtPorFechas.current.focus();
	          sigue = false;
	        } else if (txtRif.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el RIF del Cliente a Consultar !', icono: 'informacion' });
	          txtRif.current.focus();
	          sigue = false;
	        } else {
	          imprimirReverso();
	        }
	      } else {
	        imprimirReverso();
	      }
	    }
	  };
	
	  var imprimirReverso = function imprimirReverso() {
	
	    var reporte = "reportepagosreversados";
	    var fechas = actfecha !== 0 ? ' and n.fecharegistro BETWEEN ' + "'" + '||quote_literal(' + "'" + desde + "'" + ')||' + "'" + ' and ' + "'" + '||quote_literal(' + "'" + hasta + "'" + ')' : '';
	    var client = actcliente !== 0 ? fechas !== '' ? "'" + idclient : "'" + idclient + "'" : '';
	    var valclient = actcliente !== 0 ? '' : "'";
	    var condi = actcliente + actfecha > 0 ? client + valclient + fechas : "''";
	    window.open(op.reportes + "/finanzas?afiliado=" + afiliado + "&reporte=" + reporte + "&condi=" + condi, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === 'nci') {
	      setTipofic(e.target.value);
	    } else if (e.target.name === 'desde') {
	      if (e.target.value > (0, _moment2.default)(fechasistema).format('YYYY-MM-DD')) {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !', icono: 'informacion' });
	        txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        txtDesde.current.focus();
	      } else {
	        setDesde((0, _moment2.default)(e.target.value).format('DD-MM-YYYY'));
	      }
	    } else if (e.target.name === 'hasta') {
	      setHasta((0, _moment2.default)(e.target.value).format('DD-MM-YYYY'));
	    }
	  };
	
	  var onChekval = function onChekval(e) {
	    if (e.target.name === 'fecha') {
	      if (e.target.value === "1") {
	        setActfecha(0);
	        txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        txtHasta.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        setDesde((0, _moment2.default)(fechasistema).format('DD-MM-YYYY'));
	        setHasta((0, _moment2.default)(fechasistema).format('DD-MM-YYYY'));
	      } else {
	        setActfecha(1);
	      }
	    } else if (e.target.name === 'cliente') {
	      if (e.target.value === "1") {
	        setActcliente(0);
	        txtRif.current.value = "";
	        txtNombre.current.value = "";
	      } else {
	        setActcliente(1);
	      }
	    }
	  };
	
	  var handleCliente = function handleCliente(e) {
	    e.preventDefault();
	    if (e.which === 13 || typeof e.which === 'undefined') {
	      if (e.target.value !== '') {
	        selectResponsable(tiporif + e.target.value);
	      }
	    }
	  };
	
	  var handleAceptaCliente = function handleAceptaCliente(values) {
	    setMostrar1(false);
	    if (clientvende === 'cliente') {
	      txtCbmrif.current.value = values.rif.substring(0, 1);
	      txtRif.current.value = values.rif.substring(1, 11);
	      txtNombre.current.value = values.nombre;
	      selectResponsable(values.rif);
	    }
	  };
	
	  var selectResponsable = function selectResponsable(id) {
	
	    var campos = '*';
	    var nomtab = 'agente';
	    var nomid = 'rif';
	    var nomid2 = clientvende;
	    var endpoint = op.conexion + '/api/consulta/modeli2?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id + '&nomid2=' + nomid2 + '&id2=true';
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idagente > 0) {
	          if (clientvende === 'cliente') {
	            txtNombre.current.value = response.data.nombre;
	            txtRif.current.value = response.data.rif;
	            setIdclient(' and n.idcliente = ' + response.data.idagente);
	            btnAcepta.current.focus();
	          }
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ RIF y/o Cliente no Registrado !', icono: 'informacion' });
	          txtRif.current.value = '';
	          txtNombre.current.value = '';
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var catalogoCliente = function catalogoCliente(ope) {
	    return function (e) {
	      e.preventDefault();
	      if (ope === 1) {
	        setClientvende('cliente');
	        setMostrar1(true);
	      }
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        txtHasta.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        var desdec = (0, _moment2.default)(fechasistema).format('DD-MM-YYYY');
	        var hastac = (0, _moment2.default)(fechasistema).format('DD-MM-YYYY');
	        setDesde(desdec);
	        setHasta(hastac);
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Imprimir Recibos de PAGOS Reversados'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto m-0 border-azul px-1' },
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Fecha:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'fecha', value: '1', ref: txtTodasFechas, onChange: onChekval, id: 'fecha', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRadi1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'fecha', value: '2', ref: txtPorFechas, onChange: onChekval, id: 'fecha', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRadi2' },
	                  'Por Fecha'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-7 row m-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'DESDE:'
	                  ),
	                  _react2.default.createElement('input', { type: 'date', ref: txtDesde, disabled: actfecha === 0 ? true : false, name: 'desde', onChange: onChange, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'HASTA:'
	                  ),
	                  _react2.default.createElement('input', { type: 'date', ref: txtHasta, disabled: actfecha === 0 ? true : false, name: 'hasta', onChange: onChange, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Cliente:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'cliente', value: '1', ref: txtTodosCliente, onChange: onChekval, id: 'cliente', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'cliente', value: '2', ref: txtPorCliente, onChange: onChekval, id: 'cliente', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa2' },
	                  'Por Cliente'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-7 mr-auto px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm col-7 px-1 ml-auto' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'RIF:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-select col-3', ref: txtCbmrif, name: 'nci', onChange: onChange, 'aria-label': 'Default select example' },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'V' },
	                    'V'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'E' },
	                    'E'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'J' },
	                    'J'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'P' },
	                    'P'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'G' },
	                    'G'
	                  )
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtRif, disabled: actcliente === 1 ? false : true, onKeyUp: handleCliente, onBlur: handleCliente, className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: actcliente === 1 ? false : true, type: 'button', onClick: catalogoCliente(1), className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 row m-0 py-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'Nombre del Cliente:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', ref: txtNombre, disabled: true, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-11 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: props.ope !== 0 ? false : true, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-primary mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-print' },
	              '  Imprimir'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: mostrar1,
	      nomid: clientvende,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar1(false);
	      },
	      onHideAceptaCatalogo: handleAceptaCliente
	    })
	  );
	};

/***/ },
/* 7115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProcesosMontos = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoNotadeCredito = __webpack_require__(157);
	
	var _catalogoNotadeCredito2 = _interopRequireDefault(_catalogoNotadeCredito);
	
	var _catalogoAnticipos = __webpack_require__(122);
	
	var _catalogoAnticipos2 = _interopRequireDefault(_catalogoAnticipos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProcesosMontos = exports.ProcesosMontos = function ProcesosMontos(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtMonto = (0, _react.useRef)();
	  var txtNumCredito = (0, _react.useRef)();
	  var txtReferencia = (0, _react.useRef)();
	  var txtFechaPago = (0, _react.useRef)();
	  var txtMoneda = (0, _react.useRef)();
	  var txtBanco = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      mostrar1 = _useState2[0],
	      setMostrar1 = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      mostrar2 = _useState4[0],
	      setMostrar2 = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      banco = _useState6[0],
	      setBanco = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(''),
	      _useState8 = _slicedToArray(_useState7, 2),
	      numnota = _useState8[0],
	      setNumNota = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      simbol = _useState10[0],
	      setSimbol = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      combomoneda = _useState12[0],
	      setComboMoneda = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      activate = _useState14[0],
	      setActivate = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      idmoney = _useState16[0],
	      setIdmoney = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0.00),
	      _useState18 = _slicedToArray(_useState17, 2),
	      valormoney = _useState18[0],
	      setValormoney = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      valida = _useState20[0],
	      setValida = _useState20[1];
	
	  var _useState21 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState22 = _slicedToArray(_useState21, 2),
	      mensaje = _useState22[0],
	      setMensaje = _useState22[1];
	
	  var _useState23 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState24 = _slicedToArray(_useState23, 2),
	      mensajesino = _useState24[0],
	      setMensajesino = _useState24[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setNumNota('');
	    setValida(0);
	    setIdmoney(0);
	    setSimbol(null);
	    setMostrar1(false);
	    setMostrar2(false);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope === 1) {
	
	      if (txtFechaPago.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Fechas de Pago !', icono: 'informacion' });
	        txtFechaPago.current.focus();
	        sigue = false;
	      } else if (txtMonto.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Monto!', icono: 'informacion' });
	        txtMonto.current.focus();
	        sigue = false;
	      } else if (sigue === true) {
	
	        Ejecutar();
	      }
	    } else if (props.ope === 2 || props.ope === 3 || props.ope === 4 || props.ope === 5 || props.ope === 6) {
	      if (txtFechaPago.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Fechas de Pago !', icono: 'informacion' });
	        txtFechaPago.current.focus();
	        sigue = false;
	      } else if (txtReferencia.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el N° de Referencia!', icono: 'informacion' });
	        txtReferencia.current.focus();
	        sigue = false;
	      } else if (txtMonto.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Monto!', icono: 'informacion' });
	        txtMonto.current.focus();
	        sigue = false;
	      } else if (sigue === true) {
	
	        Ejecutar();
	      }
	    } else if (props.ope === 7) {
	      if (txtFechaPago.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Fechas de Pago !', icono: 'informacion' });
	        txtFechaPago.current.focus();
	        sigue = false;
	      } else if (txtMoneda.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione el Tipo de Moneda !', icono: 'informacion' });
	        txtMoneda.current.focus();
	        sigue = false;
	      } else if (txtMonto.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Monto!', icono: 'informacion' });
	        txtMonto.current.focus();
	        sigue = false;
	      } else if (sigue === true) {
	
	        Ejecutar();
	      }
	    } else if (props.ope === 8 || props.ope === 9) {
	      if (txtFechaPago.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Fechas de Pago !', icono: 'informacion' });
	        txtFechaPago.current.focus();
	        sigue = false;
	      } else if (txtNumCredito.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ El Campo Crédito no debe ir Vacio !', icono: 'informacion' });
	        txtNumCredito.current.focus();
	        sigue = false;
	      } else if (txtMonto.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Monto!', icono: 'informacion' });
	        txtMonto.current.focus();
	        sigue = false;
	      } else if (sigue === true) {
	
	        Ejecutar();
	      }
	    }
	  };
	
	  var Ejecutar = function Ejecutar() {
	
	    var valorm = props.ope === 7 ? txtMoneda.current.value : props.ope === 8 || props.ope === 9 ? idmoney.toString() : idmoney.toString();
	
	    var i = combomoneda.filter(function (moneda) {
	      return moneda.idmoneda === valorm;
	    });
	
	    var datos = [];
	
	    datos.push({
	      fecha: txtFechaPago.current.value,
	      monto: txtMonto.current.value.replace(/\./g, '').replace(',', '.'),
	      formapago: valida,
	      referencia: valida === 1 || valida === 7 || valida === 8 || valida === 9 ? '' : txtReferencia.current.value.trim(),
	      tipodivisa: i[0].idmoneda,
	      simbolo: i[0].simbolo,
	      notacredito: valida === 8 || valida === 9 ? numnota : '',
	      idbanco: valida === 2 || valida === 3 || valida === 4 || valida === 5 || valida === 6 ? txtBanco.current.value : 0,
	      valormoneda: i[0].valormoneda,
	      codigo: null
	    });
	    props.onHideAceptaData(datos);
	    cancelar();
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var validarCantidad = function validarCantidad(event) {
	    (0, _varios.validaMonto)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	        event.target.value = "0,00";
	      }
	      event.target.value = (0, _varios.formatoMonto)(event.target.value);
	      var char1 = event.target.value.substring(0, 1);
	      var char2 = event.target.value.substring(1, 2);
	      if (char1 === "0" && char2 !== ",") {
	        event.target.value = event.target.value.substring(1, event.target.value.length);
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var handleAceptaDatos = function handleAceptaDatos(values) {
	    setMostrar1(false);
	
	    var limpia = 0;
	
	    if (props.data.length > '') {
	
	      for (var i = 0; i < props.data.length; i++) {
	
	        if (props.data[i].notacredito === values.numnotaentrega) {
	          limpia = 7;
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡Esta Nota de Credito ya Fue Seleccionada!', icono: 'error' });
	        } else {
	          txtNumCredito.current.value = values.numnotaentrega;
	          txtMonto.current.value = (0, _varios.formatMoneda)(values.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	          setNumNota(values.numnotaentrega);
	        }
	      }
	
	      if (limpia === 7) {
	        txtNumCredito.current.value = '';
	        txtMonto.current.value = '0,00';
	        setNumNota('');
	      }
	    } else {
	      txtNumCredito.current.value = values.numnotaentrega;
	      txtMonto.current.value = (0, _varios.formatMoneda)(values.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	      setNumNota(values.numnotaentrega);
	      limpia = 1;
	    }
	  };
	
	  var handleAceptaDatosAnticipos = function handleAceptaDatosAnticipos(values) {
	    setMostrar2(false);
	
	    var limpia = 0;
	
	    if (props.data.length > '') {
	
	      for (var i = 0; i < props.data.length; i++) {
	
	        if (props.data[i].notacredito === values.numpago) {
	          limpia = 7;
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡Este Anticipo ya Fue Seleccionado!', icono: 'error' });
	        } else {
	          txtNumCredito.current.value = values.numpago;
	          txtMonto.current.value = (0, _varios.formatMoneda)(values.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	          setNumNota(values.numpago);
	        }
	      }
	
	      if (limpia === 7) {
	        txtNumCredito.current.value = '';
	        txtMonto.current.value = '0,00';
	        setNumNota('');
	      }
	    } else {
	      txtNumCredito.current.value = values.numpago;
	      txtMonto.current.value = (0, _varios.formatMoneda)(values.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	      setNumNota(values.numpago);
	      limpia = 1;
	    }
	  };
	
	  var seleccionarMonedas = function seleccionarMonedas(ope) {
	    var campos = "*";
	    var nomtab = "moneda";
	    var orden = "idmoneda";
	
	    var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	
	          var data = [];
	          var idmone = 1;
	
	          for (var i = 0; i < response.data.length; i++) {
	
	            if (ope === 7) {
	              if (response.data[i].predeterminada !== true) {
	
	                idmone = response.data[i].idmoneda;
	
	                data.push({
	                  descripcion: response.data[i].descripcion,
	                  idmoneda: response.data[i].idmoneda,
	                  predeterminada: response.data[i].predeterminada,
	                  simbolo: response.data[i].simbolo,
	                  subpredeterminada: response.data[i].subpredeterminada,
	                  valormoneda: response.data[i].valormoneda
	                });
	              }
	            } else if (ope === 8 || ope === 9) {
	
	              if (response.data[i].subpredeterminada === true) {
	
	                idmone = response.data[i].idmoneda;
	
	                data.push({
	                  descripcion: response.data[i].descripcion,
	                  idmoneda: response.data[i].idmoneda,
	                  predeterminada: response.data[i].predeterminada,
	                  simbolo: response.data[i].simbolo,
	                  subpredeterminada: response.data[i].subpredeterminada,
	                  valormoneda: response.data[i].valormoneda
	                });
	              }
	            } else {
	              if (response.data[i].predeterminada !== false) {
	
	                idmone = response.data[i].idmoneda;
	
	                data.push({
	                  descripcion: response.data[i].descripcion,
	                  idmoneda: response.data[i].idmoneda,
	                  predeterminada: response.data[i].predeterminada,
	                  simbolo: response.data[i].simbolo,
	                  subpredeterminada: response.data[i].subpredeterminada,
	                  valormoneda: response.data[i].valormoneda
	                });
	              }
	            }
	          }
	          setComboMoneda(data);
	          setIdmoney(idmone);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChangeMoneda = function onChangeMoneda(e) {
	    var i = combomoneda.filter(function (moneda) {
	      return moneda.idmoneda === e.target.value;
	    });
	
	    if (props.ope === 7) {
	      setIdmoney(e.target.value);
	      setSimbol(i[0].simbolo);
	      setValormoney(i[0].valormoneda);
	    }
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	
	    var campos = '*';
	    var nomtab = 'cuentabancaria';
	    var orden = 'idcuentabancaria';
	
	    var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setBanco(response.data);
	        }
	      }
	    }).catch(function (error) {
	
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: props.ope === 2 || props.ope === 3 || props.ope === 4 || props.ope === 5 || props.ope === 6 ? "md" : "sm",
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.ope === 1) {
	          setValida(1);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 2) {
	          seleccionarRegistros();
	          setValida(2);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 3) {
	          seleccionarRegistros();
	          setValida(3);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 4) {
	          seleccionarRegistros();
	          setValida(4);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 5) {
	          seleccionarRegistros();
	          setValida(5);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 6) {
	          seleccionarRegistros();
	          setValida(6);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 7) {
	          setValida(7);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 8) {
	          setValida(8);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 9) {
	          setValida(9);
	          seleccionarMonedas(props.ope);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          props.ope === 1 ? 'Pago - (Eféctivo)' : props.ope === 2 ? 'Pago - (Tarjeta de Débito)' : props.ope === 3 ? 'Pago - (Tarjera de Crédito)' : props.ope === 4 ? 'Pago - (Movil)' : props.ope === 6 ? 'Pago - (Depósito Bancario)' : props.ope === 5 ? 'Pago - (Transferencia Bancaria)' : props.ope === 7 ? 'Pago - (Divisas)' : props.ope === 8 ? 'Pago - (Saldo a Crédito)' : 'Pago - (Anticipo)'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto m-0 border-azul px-1' },
	          valida === 1 ? _react2.default.createElement(
	            'div',
	            { className: 'col-12 row m-0 px-0 py-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mb-1 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'FECHA DE PAGO:'
	                ),
	                _react2.default.createElement('input', { type: 'date', ref: txtFechaPago, disabled: props.ope === 0 ? true : false, defaultValue: (0, _moment2.default)(fechasistema).format('YYYY-MM-DD'), name: 'fecha', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'MONTO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: props.ope === 0 ? true : false, ref: txtMonto, placeholder: '0,00', onKeyUp: validarCantidad, onBlur: validarCantidad, className: 'form-control bg-transparent fs-6 text-right', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ) : '',
	          valida === 2 || valida === 3 || valida === 4 || valida === 5 || valida === 6 ? _react2.default.createElement(
	            'div',
	            { className: 'col-12 row m-0 px-0 py-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mb-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'FECHA DE PAGO:'
	                ),
	                _react2.default.createElement('input', { type: 'date', ref: txtFechaPago, disabled: props.ope === 0 ? true : false, defaultValue: (0, _moment2.default)(fechasistema).format('YYYY-MM-DD'), name: 'fecha', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'colfull col-pd-500 mb-1 px-0 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  {
	                    className: 'input-group-text',
	                    id: 'inputGroup-sizing-sm'
	                  },
	                  'BANCO:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  {
	                    className: 'form-control form-control-sm fs-6 px-1 fw-bold form-select',
	                    disabled: props.ope === 0 ? true : false,
	                    ref: txtBanco
	                  },
	                  banco && banco.map(function (item, index) {
	                    return _react2.default.createElement(
	                      'option',
	                      { key: index, value: item.idcuentabancaria },
	                      " ",
	                      item.nombre + ' --- ' + item.cuentabancaria,
	                      " "
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-500 px-0 mb-1 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'N\xB0 DE REFERANCIA:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtReferencia, disabled: props.ope === 0 ? true : false, name: 'fecha', className: 'form-control fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'MONTO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: props.ope === 0 ? true : false, ref: txtMonto, placeholder: '0,00', onKeyUp: validarCantidad, onBlur: validarCantidad, className: 'form-control bg-transparent fs-6 text-right', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ) : '',
	          valida === 7 ? _react2.default.createElement(
	            'div',
	            { className: 'col-12 row m-0 px-0 py-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mb-1 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'FECHA DE PAGO:'
	                ),
	                _react2.default.createElement('input', { type: 'date', ref: txtFechaPago, disabled: props.ope === 0 ? true : false, defaultValue: (0, _moment2.default)(fechasistema).format('YYYY-MM-DD'), name: 'fecha', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'colfull col-pd-290 mb-1 px-0 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  {
	                    className: 'input-group-text',
	                    id: 'inputGroup-sizing-sm'
	                  },
	                  'TIPO MONEDA:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  {
	                    className: 'form-control form-control-sm form-select fs-6 px-1 fw-bold',
	                    disabled: props.ope === 0 ? true : false,
	                    ref: txtMoneda,
	                    onChange: onChangeMoneda
	                  },
	                  combomoneda && combomoneda.map(function (item, index) {
	                    return _react2.default.createElement(
	                      'option',
	                      { key: index, value: item.idmoneda },
	                      " ",
	                      item.descripcion + ' ' + item.simbolo,
	                      " "
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'MONTO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: props.ope === 0 ? true : false, ref: txtMonto, placeholder: '0,00', onKeyUp: validarCantidad, onBlur: validarCantidad, className: 'form-control bg-transparent fs-6 text-right', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ) : '',
	          valida === 8 ? _react2.default.createElement(
	            'div',
	            { className: 'col-12 row m-0 px-0 py-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mb-1 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'FECHA DE PAGO:'
	                ),
	                _react2.default.createElement('input', { type: 'date', ref: txtFechaPago, disabled: props.ope === 0 ? true : false, defaultValue: (0, _moment2.default)(fechasistema).format('YYYY-MM-DD'), name: 'fecha', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mb-1 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'N\xB0 CREDITO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: props.ope === 0 ? true : false, ref: txtNumCredito, className: 'form-control bg-transparent fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', onClick: function onClick() {
	                      return setMostrar1(true);
	                    }, disabled: props.ope === 0 ? true : false, className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'MONTO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: true, ref: txtMonto, placeholder: '0,00', onKeyUp: validarCantidad, onBlur: validarCantidad, className: 'form-control bg-transparent fs-6 text-right', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ) : '',
	          valida === 9 ? _react2.default.createElement(
	            'div',
	            { className: 'col-12 row m-0 px-0 py-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mb-1 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'FECHA DE PAGO:'
	                ),
	                _react2.default.createElement('input', { type: 'date', ref: txtFechaPago, disabled: props.ope === 0 ? true : false, defaultValue: (0, _moment2.default)(fechasistema).format('YYYY-MM-DD'), name: 'fecha', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mb-1 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'N\xB0 ANTICIPO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: props.ope === 0 ? true : false, ref: txtNumCredito, className: 'form-control bg-transparent fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', onClick: function onClick() {
	                      return setMostrar2(true);
	                    }, disabled: props.ope === 0 ? true : false, className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'MONTO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: true, ref: txtMonto, placeholder: '0,00', onKeyUp: validarCantidad, onBlur: validarCantidad, className: 'form-control bg-transparent fs-6 text-right', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ) : ''
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: props.ope !== 0 ? false : true, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-success mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check' },
	              '  Registrar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoNotadeCredito2.default, {
	      show: mostrar1,
	      idcliente: props.idclients,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar1(false);
	      },
	      onHideAceptaCatalogo: handleAceptaDatos
	    }),
	    _react2.default.createElement(_catalogoAnticipos2.default, {
	      show: mostrar2,
	      idcliente: props.idclients,
	      tipo: 'AN',
	      estatus: 0,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar2(false);
	      },
	      onHideAceptaCatalogo: handleAceptaDatosAnticipos
	    })
	  );
	};

/***/ },
/* 7116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProcesosMontosAnticipos = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _catalogoNotadeCredito = __webpack_require__(157);
	
	var _catalogoNotadeCredito2 = _interopRequireDefault(_catalogoNotadeCredito);
	
	var _catalogoAnticipos = __webpack_require__(122);
	
	var _catalogoAnticipos2 = _interopRequireDefault(_catalogoAnticipos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProcesosMontosAnticipos = exports.ProcesosMontosAnticipos = function ProcesosMontosAnticipos(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var headCells = [{ label: 'FORMA DE PAGO', textAlign: 'center' }, { label: 'MONTO', textAlign: 'center' }, { label: 'MONTO AL CAMBIO', textAlign: 'center' }];
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtTodasFechas = (0, _react.useRef)();
	  var txtPorFechas = (0, _react.useRef)();
	  var txtTodosDispo = (0, _react.useRef)();
	  var txtCanceladas = (0, _react.useRef)();
	  var txtMonto = (0, _react.useRef)();
	  var txtNumCredito = (0, _react.useRef)();
	  var txtReferencia = (0, _react.useRef)();
	  var txtFechaPago = (0, _react.useRef)();
	  var txtMoneda = (0, _react.useRef)();
	  var txtBanco = (0, _react.useRef)();
	  var txtDesde = (0, _react.useRef)();
	  var txtHasta = (0, _react.useRef)();
	  var txtCbmrif = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      inputalmacen = _useState2[0],
	      setInputalmacen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      inputproducto = _useState4[0],
	      setInputproducto = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      tiporif = _useState6[0],
	      setTipofic = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0.00),
	      _useState8 = _slicedToArray(_useState7, 2),
	      valormon = _useState8[0],
	      setValormon = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mostrar1 = _useState10[0],
	      setMostrar1 = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(null),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mostrar2 = _useState12[0],
	      setMostrar2 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(''),
	      _useState14 = _slicedToArray(_useState13, 2),
	      parafecha = _useState14[0],
	      setParafecha = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(''),
	      _useState16 = _slicedToArray(_useState15, 2),
	      desde = _useState16[0],
	      setDesde = _useState16[1];
	
	  var _useState17 = (0, _react.useState)([]),
	      _useState18 = _slicedToArray(_useState17, 2),
	      banco = _useState18[0],
	      setBanco = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(''),
	      _useState20 = _slicedToArray(_useState19, 2),
	      disponiblec = _useState20[0],
	      setDisponiblec = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(''),
	      _useState22 = _slicedToArray(_useState21, 2),
	      numnota = _useState22[0],
	      setNumNota = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(''),
	      _useState24 = _slicedToArray(_useState23, 2),
	      idclient = _useState24[0],
	      setIdclient = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(null),
	      _useState26 = _slicedToArray(_useState25, 2),
	      simbol = _useState26[0],
	      setSimbol = _useState26[1];
	
	  var _useState27 = (0, _react.useState)([]),
	      _useState28 = _slicedToArray(_useState27, 2),
	      combomoneda = _useState28[0],
	      setComboMoneda = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      activate = _useState30[0],
	      setActivate = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(0),
	      _useState32 = _slicedToArray(_useState31, 2),
	      idmoney = _useState32[0],
	      setIdmoney = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(0.00),
	      _useState34 = _slicedToArray(_useState33, 2),
	      valormoney = _useState34[0],
	      setValormoney = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(0),
	      _useState36 = _slicedToArray(_useState35, 2),
	      valida = _useState36[0],
	      setValida = _useState36[1];
	
	  var _useState37 = (0, _react.useState)({ fn: function fn(items) {
	      return items;
	    } }),
	      _useState38 = _slicedToArray(_useState37, 2),
	      filterFn = _useState38[0],
	      setFilterFn = _useState38[1];
	
	  var _useState39 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState40 = _slicedToArray(_useState39, 2),
	      mensaje = _useState40[0],
	      setMensaje = _useState40[1];
	
	  var _useState41 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState42 = _slicedToArray(_useState41, 2),
	      mensajesino = _useState42[0],
	      setMensajesino = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(''),
	      _useState44 = _slicedToArray(_useState43, 2),
	      tituid = _useState44[0],
	      setTituid = _useState44[1];
	
	  var _useState45 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState46 = _slicedToArray(_useState45, 2),
	      botones = _useState46[0],
	      setBotones = _useState46[1];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells, filterFn),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setInputalmacen(0);
	    setParafecha('');
	    setDisponiblec('');
	    setNumNota('');
	    setInputproducto(0);
	    setValida(0);
	    setIdclient('');
	    setIdmoney(0);
	    setSimbol(null);
	    setMostrar1(false);
	    setMostrar2(false);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope === 1) {
	
	      if (txtFechaPago.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Fechas de Pago !', icono: 'informacion' });
	        txtFechaPago.current.focus();
	        sigue = false;
	      } else if (txtMonto.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Monto!', icono: 'informacion' });
	        txtMonto.current.focus();
	        sigue = false;
	      } else if (sigue === true) {
	
	        Ejecutar();
	      }
	    } else if (props.ope === 2 || props.ope === 3 || props.ope === 4 || props.ope === 5 || props.ope === 6) {
	      if (txtFechaPago.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Fechas de Pago !', icono: 'informacion' });
	        txtFechaPago.current.focus();
	        sigue = false;
	      } else if (txtReferencia.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el N° de Referencia!', icono: 'informacion' });
	        txtReferencia.current.focus();
	        sigue = false;
	      } else if (txtMonto.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Monto!', icono: 'informacion' });
	        txtMonto.current.focus();
	        sigue = false;
	      } else if (sigue === true) {
	
	        Ejecutar();
	      }
	    } else if (props.ope === 7) {
	      if (txtFechaPago.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Fechas de Pago !', icono: 'informacion' });
	        txtFechaPago.current.focus();
	        sigue = false;
	      } else if (txtMoneda.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione el Tipo de Moneda !', icono: 'informacion' });
	        txtMoneda.current.focus();
	        sigue = false;
	      } else if (txtMonto.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Monto!', icono: 'informacion' });
	        txtMonto.current.focus();
	        sigue = false;
	      } else if (sigue === true) {
	
	        Ejecutar();
	      }
	    }
	  };
	
	  var Ejecutar = function Ejecutar() {
	
	    var valorm = props.ope === 7 ? txtMoneda.current.value : idmoney.toString();
	
	    var i = combomoneda.filter(function (moneda) {
	      return moneda.idmoneda === valorm;
	    });
	
	    var datos = [];
	
	    datos.push({
	      fecha: txtFechaPago.current.value,
	      monto: txtMonto.current.value.replace(/\./g, '').replace(',', '.'),
	      formapago: valida,
	      referencia: valida === 1 || valida === 7 ? '' : txtReferencia.current.value.trim(),
	      tipodivisa: valida === 7 ? idmoney : 1,
	      simbolo: i[0].simbolo,
	      notacredito: '',
	      idbanco: valida === 2 || valida === 3 || valida === 4 || valida === 5 || valida === 6 ? txtBanco.current.value : 0,
	      valormoneda: i[0].valormoneda
	    });
	    props.onHideAceptaData(datos);
	    cancelar();
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var validarCantidad = function validarCantidad(event) {
	    (0, _varios.validaMonto)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	        event.target.value = "0,00";
	      }
	      event.target.value = (0, _varios.formatoMonto)(event.target.value);
	      var char1 = event.target.value.substring(0, 1);
	      var char2 = event.target.value.substring(1, 2);
	      if (char1 === "0" && char2 !== ",") {
	        event.target.value = event.target.value.substring(1, event.target.value.length);
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var seleccionarMonedas = function seleccionarMonedas(ope) {
	    var campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	    var nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	    var orden = "m.idmoneda";
	
	    var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	
	          var data = [];
	          var idmone = 1;
	
	          for (var i = 0; i < response.data.length; i++) {
	
	            if (ope === 7) {
	
	              if (response.data[i].idmoneda !== '1') {
	                data.push({
	                  descripcion: response.data[i].descripcion,
	                  idmoneda: response.data[i].idmoneda,
	                  predeterminada: response.data[i].predeterminada,
	                  simbolo: response.data[i].simbolo,
	                  subpredeterminada: response.data[i].subpredeterminada,
	                  valormoneda: response.data[i].valormoneda
	                });
	              }
	
	              if (response.data[i].subpredeterminada === true) {
	                idmone = response.data[i].idmoneda;
	              }
	            } else {
	
	              if (response.data[i].idmoneda !== '') {
	                data.push({
	                  descripcion: response.data[i].descripcion,
	                  idmoneda: response.data[i].idmoneda,
	                  predeterminada: response.data[i].predeterminada,
	                  simbolo: response.data[i].simbolo,
	                  subpredeterminada: response.data[i].subpredeterminada,
	                  valormoneda: response.data[i].valormoneda
	                });
	              }
	            }
	          }
	          setComboMoneda(data);
	          setIdmoney(idmone);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChangeMoneda = function onChangeMoneda(e) {
	    var i = combomoneda.filter(function (moneda) {
	      return moneda.idmoneda === e.target.value;
	    });
	    setIdmoney(e.target.value);
	    setSimbol(i[0].simbolo);
	    setValormoney(i[0].valormoneda);
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	
	    var campos = '*';
	    var nomtab = 'cuentabancaria';
	    var orden = 'idcuentabancaria';
	
	    var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setBanco(response.data);
	        }
	      }
	    }).catch(function (error) {
	
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: props.ope === 2 || props.ope === 3 || props.ope === 4 || props.ope === 5 || props.ope === 6 ? "md" : "sm",
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.ope === 1) {
	          setValida(1);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 2) {
	          seleccionarRegistros();
	          setValida(2);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 3) {
	          seleccionarRegistros();
	          setValida(3);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 4) {
	          seleccionarRegistros();
	          setValida(4);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 5) {
	          seleccionarRegistros();
	          setValida(5);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 6) {
	          seleccionarRegistros();
	          setValida(6);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 7) {
	          setValida(7);
	          seleccionarMonedas(props.ope);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          props.ope === 1 ? 'Pago - (Eféctivo)' : props.ope === 2 ? 'Pago - (Tarjeta de Débito)' : props.ope === 3 ? 'Pago - (Tarjera de Crédito)' : props.ope === 4 ? 'Pago - (Movil)' : props.ope === 6 ? 'Pago - (Depósito Bancario)' : props.ope === 5 ? 'Pago - (Transferencia Bancaria)' : 'Pago - (Divisas)'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto m-0 border-azul px-1' },
	          valida === 1 ? _react2.default.createElement(
	            'div',
	            { className: 'col-12 row m-0 px-0 py-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mb-1 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'FECHA DE PAGO:'
	                ),
	                _react2.default.createElement('input', { type: 'date', ref: txtFechaPago, disabled: props.ope === 0 ? true : false, defaultValue: (0, _moment2.default)(fechasistema).format('YYYY-MM-DD'), name: 'fecha', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'MONTO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: props.ope === 0 ? true : false, ref: txtMonto, placeholder: '0,00', onKeyUp: validarCantidad, onBlur: validarCantidad, className: 'form-control bg-transparent fs-6 text-right', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ) : '',
	          valida === 2 || valida === 3 || valida === 4 || valida === 5 || valida === 6 ? _react2.default.createElement(
	            'div',
	            { className: 'col-12 row m-0 px-0 py-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mb-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'FECHA DE PAGO:'
	                ),
	                _react2.default.createElement('input', { type: 'date', ref: txtFechaPago, disabled: props.ope === 0 ? true : false, defaultValue: (0, _moment2.default)(fechasistema).format('YYYY-MM-DD'), name: 'fecha', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'colfull col-pd-500 mb-1 px-0 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  {
	                    className: 'input-group-text',
	                    id: 'inputGroup-sizing-sm'
	                  },
	                  'BANCO:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  {
	                    className: 'form-control form-control-sm fs-6 form-select px-1 fw-bold',
	                    disabled: props.ope === 0 ? true : false,
	                    ref: txtBanco
	                  },
	                  banco && banco.map(function (item, index) {
	                    return _react2.default.createElement(
	                      'option',
	                      { key: index, value: item.idcuentabancaria },
	                      " ",
	                      item.nombre + ' --- ' + item.cuentabancaria,
	                      " "
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-500 px-0 mb-1 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'N\xB0 DE REFERANCIA:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtReferencia, disabled: props.ope === 0 ? true : false, name: 'fecha', className: 'form-control fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'MONTO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: props.ope === 0 ? true : false, ref: txtMonto, placeholder: '0,00', onKeyUp: validarCantidad, onBlur: validarCantidad, className: 'form-control bg-transparent fs-6 text-right', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ) : '',
	          valida === 7 ? _react2.default.createElement(
	            'div',
	            { className: 'col-12 row m-0 px-0 py-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mb-1 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'FECHA DE PAGO:'
	                ),
	                _react2.default.createElement('input', { type: 'date', ref: txtFechaPago, disabled: props.ope === 0 ? true : false, defaultValue: (0, _moment2.default)(fechasistema).format('YYYY-MM-DD'), name: 'fecha', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'colfull col-pd-290 mb-1 px-0 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  {
	                    className: 'input-group-text',
	                    id: 'inputGroup-sizing-sm'
	                  },
	                  'TIPO MONEDA:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  {
	                    className: 'form-control form-control-sm fs-6 form-select px-1 fw-bold',
	                    disabled: props.ope === 0 ? true : false,
	                    ref: txtMoneda,
	                    onChange: onChangeMoneda
	                  },
	                  combomoneda && combomoneda.map(function (item, index) {
	                    return _react2.default.createElement(
	                      'option',
	                      { key: index, value: item.idmoneda },
	                      " ",
	                      item.descripcion + ' ' + item.simbolo + ' ' + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                      " "
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'MONTO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: props.ope === 0 ? true : false, ref: txtMonto, placeholder: '0,00', onKeyUp: validarCantidad, onBlur: validarCantidad, className: 'form-control bg-transparent fs-6 text-right', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ) : ''
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-11 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: props.ope !== 0 ? false : true, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-success mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check', style: { fontSize: '9px' } },
	              '  Registrar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close', style: { fontSize: '9px' } },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ImagenAnticipo = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagenAnticipo = exports.ImagenAnticipo = function ImagenAnticipo(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var organizacion = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    imagen: op.conexion + '/imagen?img=subir.png'
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      pathImage = _useState2[0],
	      setPathImage = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mensaje = _useState6[0],
	      setMensaje = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mensajesino = _useState8[0],
	      setMensajesino = _useState8[1];
	
	  var blanquear = function blanquear() {
	    setPathImage('...');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    if (props.llamado === 2) {
	      props.onHideCancelar();
	    }
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var getDescargar = function getDescargar() {
	    setActivate(true);
	    var endpoint = op.conexion + '/imagen?img=' + organizacion + '/imagenesanticipo/' + props.imagenanticipo.trim();
	    _axios2.default.get(endpoint, {
	      responseType: "arraybuffer",
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      var url = window.URL.createObjectURL(new Blob([response.data]));
	      var link = document.createElement("a");
	      link.href = url;
	      link.setAttribute("download", '' + props.imagen.trim());
	      document.body.appendChild(link);
	      link.click();
	      document.body.removeChild(link);
	    }).catch(function (error) {
	      console.error(error);
	    }).finally(function () {
	      return setActivate(false);
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	    getDescargar();
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        setPathImage({
	          imagen: op.conexion + '/imagen?img=' + organizacion + '/imagenesanticipo/' + props.imagenanticipo.trim()
	        });
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Imagen Anticipo'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 mx-auto px-0 d-flex justify-content-center' },
	        _react2.default.createElement('img', { src: pathImage.imagen, style: { height: '750px' }, className: 'img-fluid img-thumbnail', alt: '...' })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-4 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-primary mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-download' },
	              '  Descargar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ImagenDivisa = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagenDivisa = exports.ImagenDivisa = function ImagenDivisa(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var organizacion = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    imagen: op.conexion + '/imagen?img=subir.png'
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      pathImage = _useState2[0],
	      setPathImage = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mensaje = _useState6[0],
	      setMensaje = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mensajesino = _useState8[0],
	      setMensajesino = _useState8[1];
	
	  var blanquear = function blanquear() {
	    setPathImage('...');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    if (props.llamado === 2) {
	      props.onHideCancelar();
	    }
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var getDescargar = function getDescargar() {
	    setActivate(true);
	    var endpoint = op.conexion + '/imagen?img=' + organizacion + '/imagenesanticipo/' + props.imagendivisa.trim();
	    _axios2.default.get(endpoint, {
	      responseType: "arraybuffer",
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      var url = window.URL.createObjectURL(new Blob([response.data]));
	      var link = document.createElement("a");
	      link.href = url;
	      link.setAttribute("download", '' + props.imagendivisa.trim());
	      document.body.appendChild(link);
	      link.click();
	      document.body.removeChild(link);
	    }).catch(function (error) {
	      console.error(error);
	    }).finally(function () {
	      return setActivate(false);
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	    getDescargar();
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        setPathImage({
	          imagen: op.conexion + '/imagen?img=' + organizacion + '/imagenesanticipo/' + props.imagendivisa.trim()
	        });
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Imagen Divisa'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 mx-auto px-0 d-flex justify-content-center' },
	        _react2.default.createElement('img', { src: pathImage.imagen, style: { height: '750px' }, className: 'img-fluid img-thumbnail', alt: '...' })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-4 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-primary mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-download' },
	              '  Descargar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ImprimirAnticipos = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImprimirAnticipos = exports.ImprimirAnticipos = function ImprimirAnticipos(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtTodasFechas = (0, _react.useRef)();
	  var txtPorFechas = (0, _react.useRef)();
	  var txtTodosDispo = (0, _react.useRef)();
	  var txtPorConfirmar = (0, _react.useRef)();
	  var txtConfirmada = (0, _react.useRef)();
	  var txtAnuladas = (0, _react.useRef)();
	  var txtTodosCliente = (0, _react.useRef)();
	  var txtPorCliente = (0, _react.useRef)();
	  var txtIdProducto = (0, _react.useRef)();
	  var txtRifrespon = (0, _react.useRef)();
	  var txtNomrespon = (0, _react.useRef)();
	  var txtRifVende = (0, _react.useRef)();
	  var txtNomVende = (0, _react.useRef)();
	  var txtDesde = (0, _react.useRef)();
	  var txtHasta = (0, _react.useRef)();
	  var txtCbmrif = (0, _react.useRef)();
	  var txtCbmrifVende = (0, _react.useRef)();
	  var txtTodosAlmacen = (0, _react.useRef)();
	  var txtAplicada = (0, _react.useRef)();
	  var txtCodigoAlmacen = (0, _react.useRef)();
	  var txtNombreAlmacen = (0, _react.useRef)();
	  var txtOrden = (0, _react.useRef)();
	  var txtTodosVendedores = (0, _react.useRef)();
	  var txtPorVendedor = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      combofecha = _useState2[0],
	      setCombofecha = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      combocliente = _useState4[0],
	      setCombocliente = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      valvende = _useState6[0],
	      setValvende = _useState6[1];
	
	  var _useState7 = (0, _react.useState)('V'),
	      _useState8 = _slicedToArray(_useState7, 2),
	      tiporif = _useState8[0],
	      setTipofic = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(''),
	      _useState10 = _slicedToArray(_useState9, 2),
	      idpag = _useState10[0],
	      setIdpag = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(null),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mostrar1 = _useState12[0],
	      setMostrar1 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(null),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mostrar2 = _useState14[0],
	      setMostrar2 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      comboestatus = _useState16[0],
	      setComboestatus = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(''),
	      _useState18 = _slicedToArray(_useState17, 2),
	      desde = _useState18[0],
	      setDesde = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(''),
	      _useState20 = _slicedToArray(_useState19, 2),
	      hasta = _useState20[0],
	      setHasta = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(''),
	      _useState22 = _slicedToArray(_useState21, 2),
	      ordens = _useState22[0],
	      setOrdens = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(''),
	      _useState24 = _slicedToArray(_useState23, 2),
	      clientvende = _useState24[0],
	      setClientvende = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(''),
	      _useState26 = _slicedToArray(_useState25, 2),
	      disponiblec = _useState26[0],
	      setDisponiblec = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(''),
	      _useState28 = _slicedToArray(_useState27, 2),
	      paracliente = _useState28[0],
	      setParacliente = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(''),
	      _useState30 = _slicedToArray(_useState29, 2),
	      idclient = _useState30[0],
	      setIdclient = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(''),
	      _useState32 = _slicedToArray(_useState31, 2),
	      idvendedr = _useState32[0],
	      setIdvendedr = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(''),
	      _useState34 = _slicedToArray(_useState33, 2),
	      report = _useState34[0],
	      setReport = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(null),
	      _useState36 = _slicedToArray(_useState35, 2),
	      idalmacen = _useState36[0],
	      setIdalmacen = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(null),
	      _useState38 = _slicedToArray(_useState37, 2),
	      valalmacen = _useState38[0],
	      setValalmacen = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(false),
	      _useState40 = _slicedToArray(_useState39, 2),
	      activate = _useState40[0],
	      setActivate = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(true),
	      _useState42 = _slicedToArray(_useState41, 2),
	      habilitado = _useState42[0],
	      setHabilitado = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      mensaje = _useState44[0],
	      setMensaje = _useState44[1];
	
	  var _useState45 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState46 = _slicedToArray(_useState45, 2),
	      mensajesino = _useState46[0],
	      setMensajesino = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(''),
	      _useState48 = _slicedToArray(_useState47, 2),
	      tituid = _useState48[0],
	      setTituid = _useState48[1];
	
	  var _useState49 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState50 = _slicedToArray(_useState49, 2),
	      botones = _useState50[0],
	      setBotones = _useState50[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setCombofecha(0);
	    setComboestatus(0);
	    setDisponiblec('');
	    setParacliente('');
	    setIdalmacen("");
	    setReport('');
	    setIdclient('');
	    setIdvendedr('');
	    setValalmacen(0);
	    setOrdens('');
	    setValvende(0);
	    setIdpag('');
	    setCombocliente(0);
	    setTipofic('V');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope === 1) {
	
	      if (txtPorFechas.current.checked === true && txtPorCliente.current.checked === false) {
	        if (txtDesde.current.value === '' || txtHasta.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione las Fechas a Consultar !', icono: 'informacion' });
	          if (txtDesde.current.value === '' && txtHasta.current.value !== '') {
	            txtDesde.current.focus();
	          } else if (txtHasta.current.value === '' && txtDesde.current.value !== '') {
	            txtHasta.current.focus();
	          }
	          sigue = false;
	        } else {
	          imprimirGeneral();
	        }
	      } else if (txtPorFechas.current.checked === false && txtPorCliente.current.checked === true) {
	        if (txtRifrespon.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el RIF del Cliente a Consultar !', icono: 'informacion' });
	          txtRifrespon.current.focus();
	          sigue = false;
	        } else {
	          imprimirGeneral();
	        }
	      } else if (txtPorFechas.current.checked === true && txtPorCliente.current.checked === true) {
	        if (txtDesde.current.value === '' || txtHasta.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Las Fechas a Consultar no Deben ir Vacias !', icono: 'informacion' });
	          txtPorFechas.current.focus();
	          sigue = false;
	        } else if (txtRifrespon.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el RIF del Cliente a Consultar !', icono: 'informacion' });
	          txtRifrespon.current.focus();
	          sigue = false;
	        } else {
	          imprimirGeneral();
	        }
	      } else {
	        imprimirGeneral();
	      }
	    }
	  };
	
	  var onChekval = function onChekval(e) {
	
	    if (e.target.id === 'fecha') {
	      if (txtTodasFechas.current.checked === true) {
	        setCombofecha(0);
	      } else {
	        setCombofecha(1);
	      }
	    }
	
	    if (e.target.id === 'estatus') {
	      if (txtTodosDispo.current.checked === true) {
	        setDisponiblec('');
	        setComboestatus(0);
	      } else if (txtPorConfirmar.current.checked === true) {
	        setDisponiblec(' and n.status = 0');
	        setComboestatus(1);
	      } else if (txtConfirmada.current.checked === true) {
	        setDisponiblec(' and n.status = 2');
	        setComboestatus(1);
	      } else if (txtAplicada.current.checked === true) {
	        setDisponiblec(' and n.status = 1');
	        setComboestatus(1);
	      } else if (txtAnuladas.current.checked === true) {
	        setDisponiblec(' and n.statusreverso = 1');
	        setComboestatus(1);
	      }
	    }
	
	    if (e.target.id === 'cliente') {
	      if (txtTodosCliente.current.checked === true) {
	        setCombocliente(0);
	        setIdclient('');
	        txtNomrespon.current.value = '';
	        txtCbmrif.current.value = '';
	        txtRifrespon.current.value = '';
	      } else {
	        setCombocliente(1);
	        setClientvende('cliente');
	      }
	    }
	
	    if (e.target.id === 'vendedor') {
	      if (txtTodosVendedores.current.checked === true) {
	        setValvende(0);
	        setIdvendedr('');
	        txtNomVende.current.value = '';
	        txtCbmrifVende.current.value = '';
	        txtRifVende.current.value = '';
	      } else {
	        setValvende(1);
	        setClientvende('vendedor');
	      }
	    }
	  };
	
	  var imprimirGeneral = function imprimirGeneral() {
	
	    var reporte = "ReporteAnticipos";
	
	    var desdec = '';
	    var hastac = '';
	
	    if (combofecha === 1) {
	      desdec = desde;
	      hastac = hasta;
	    } else {
	      desdec = "'" + '01-01-' + (0, _moment2.default)(fechasistema).format('YYYY') + "'";
	      hastac = "'" + (0, _moment2.default)(fechasistema).format('DD-MM-YYYY') + "'";
	    }
	
	    var condi = "'" + idpag + idclient + idvendedr + disponiblec + "'";
	    var orden = txtOrden.current.value === '1' ? ordens : ordens + ", " + txtOrden.current.value;
	
	    var ope = 1;
	    var tipopago = 'AN';
	
	    window.open(op.reportes + "/finanzas?afiliado=" + afiliado + "&reporte=" + reporte + "&NUMPAGO=" + condi + "&OP=" + ope + "&TIPOPAGO=" + tipopago + "&orden=" + orden + "&desde=" + desdec + "&hasta=" + hastac, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    if (props.llamado === 2) {
	      props.onHideRenderizar();
	      props.onHideCancela();
	    }
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var handleAceptaCliente = function handleAceptaCliente(values) {
	    setMostrar1(false);
	    if (clientvende === 'cliente') {
	      txtCbmrif.current.value = values.rif.substring(0, 1);
	      txtRifrespon.current.value = values.rif.substring(1, 11);
	      txtNomrespon.current.value = values.nombre;
	      selectResponsable(values.rif);
	    } else if (clientvende === 'vendedor') {
	      txtCbmrifVende.current.value = values.rif.substring(0, 1);
	      txtRifVende.current.value = values.rif.substring(1, 11);
	      txtNomVende.current.value = values.nombre;
	      selectResponsable(values.rif);
	    }
	  };
	
	  var catalogoProductoc = function catalogoProductoc(ope) {
	    return function (e) {
	      e.preventDefault();
	      if (ope === 1) {
	        setClientvende('cliente');
	        setMostrar1(true);
	      } else {
	        setClientvende('vendedor');
	        setMostrar1(true);
	      }
	    };
	  };
	
	  var selectResponsable = function selectResponsable(id) {
	
	    var campos = '*';
	    var nomtab = 'agente';
	    var nomid = 'rif';
	    var nomid2 = clientvende;
	    var endpoint = op.conexion + '/api/consulta/modeli2?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id + '&nomid2=' + nomid2 + '&id2=true';
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idagente > 0) {
	          if (clientvende === 'cliente') {
	            txtNomrespon.current.value = response.data.nombre;
	            setIdclient(' and n.idcliente = ' + response.data.idagente);
	            btnAcepta.current.focus();
	          } else {
	            txtNomVende.current.value = response.data.nombre;
	            setIdvendedr(' and n.idvendedor = ' + response.data.idagente);
	            btnAcepta.current.focus();
	          }
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ RIF y/o Cliente no Registrado !', icono: 'informacion' });
	          txtRifrespon.current.value = '';
	          txtNomrespon.current.value = '';
	          txtRifVende.current.value = '';
	          txtNomVende.current.value = '';
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'nci') {
	      setTipofic(e.target.value);
	    } else if (e.target.name === 'desde') {
	      if (e.target.value > (0, _moment2.default)(fechasistema).format('YYYY-MM-DD')) {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !', icono: 'informacion' });
	        txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        txtDesde.current.focus();
	      } else {
	        setDesde("'" + (0, _moment2.default)(e.target.value).format('DD-MM-YYYY') + "'");
	      }
	    } else if (e.target.name === 'hasta') {
	      setHasta("'" + (0, _moment2.default)(e.target.value).format('DD-MM-YYYY') + "'");
	    }
	  };
	
	  var handleCliente = function handleCliente(e) {
	    e.preventDefault();
	    if (e.which === 13 || typeof e.which === 'undefined') {
	      if (e.target.value !== '') {
	        selectResponsable(tiporif + e.target.value);
	      }
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.ope === 1) {
	
	          setOrdens('n.fecharegistro, n.idpago');
	          setIdpag('n.idpago > 0');
	
	          txtTodasFechas.current.checked = true;
	          txtTodosCliente.current.checked = true;
	          txtTodosVendedores.current.checked = true;
	          txtTodosDispo.current.checked = true;
	
	          txtPorFechas.current.checked = false;
	          txtPorCliente.current.checked = false;
	          txtPorVendedor.current.checked = false;
	          setHabilitado(false);
	        } else {
	
	          txtTodasFechas.current.checked = false;
	          txtTodosCliente.current.checked = false;
	
	          txtPorCliente.current.checked = false;
	          txtPorFechas.current.checked = false;
	
	          txtTodosVendedores.current.checked = false;
	          txtPorVendedor.current.checked = false;
	
	          setHabilitado(true);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Imprimir Anticipos'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto' },
	          _react2.default.createElement(
	            'div',
	            { className: 'colfull col-pd-300 px-3 ml-auto' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm' },
	              _react2.default.createElement(
	                'label',
	                {
	                  className: 'input-group-text',
	                  id: 'inputGroup-sizing-sm'
	                },
	                'ORDENAR POR:'
	              ),
	              _react2.default.createElement(
	                'select',
	                {
	                  className: 'form-control form-control-sm form-select fs-6 fw-bold',
	                  ref: txtOrden,
	                  name: 'orden'
	                  /* onChange={onChekval} */
	
	                },
	                _react2.default.createElement(
	                  'option',
	                  { value: '1' },
	                  'FECHA'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: 'n.idcliente' },
	                  'CLIENTES'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: 'n.idvendedor' },
	                  'VENDEDOR'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Fecha:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'fecha', value: '1', ref: txtTodasFechas, onChange: onChekval, id: 'fecha', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRadi1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'fecha', value: '2', ref: txtPorFechas, onChange: onChekval, id: 'fecha', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRadi2' },
	                  'Por Fecha'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-7 row m-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'DESDE:'
	                  ),
	                  _react2.default.createElement('input', { type: 'date', ref: txtDesde, disabled: combofecha === 0 ? true : false, name: 'desde', onChange: onChange, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'HASTA:'
	                  ),
	                  _react2.default.createElement('input', { type: 'date', ref: txtHasta, disabled: combofecha === 0 ? true : false, name: 'hasta', onChange: onChange, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 d-flex justify-content-around border-azul rounded mb-1 mx-auto' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Estatus del Pago:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-100' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'estatus', value: '1', ref: txtTodosDispo, onChange: onChekval, id: 'estatus', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-130' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'estatus', value: '2', ref: txtPorConfirmar, onChange: onChekval, id: 'estatus', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai2' },
	                  'Por confirmar'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-130' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'estatus', value: '3', ref: txtConfirmada, onChange: onChekval, id: 'estatus', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai3' },
	                  'Confirmada'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-100' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'estatus', value: '4', ref: txtAplicada, onChange: onChekval, id: 'estatus', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai4' },
	                  'Aplicada'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-100' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'estatus', value: '5', ref: txtAnuladas, onChange: onChekval, id: 'estatus', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai5' },
	                  'Anuladas'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Cliente:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'cliente', value: '1', ref: txtTodosCliente, onChange: onChekval, id: 'cliente', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'cliente', value: '2', ref: txtPorCliente, onChange: onChekval, id: 'cliente', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa2' },
	                  'Por Cliente'
	                )
	              )
	            ),
	            _react2.default.createElement('input', { type: 'hidden', ref: txtIdProducto }),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-7 mr-auto px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm col-7 px-1 ml-auto' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'RIF:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-select col-3', ref: txtCbmrif, name: 'nci', onChange: onChange, 'aria-label': 'Default select example' },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'V' },
	                    'V'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'E' },
	                    'E'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'J' },
	                    'J'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'P' },
	                    'P'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'G' },
	                    'G'
	                  )
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtRifrespon, disabled: combocliente === 1 ? false : true, onKeyUp: handleCliente, onBlur: handleCliente, className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: combocliente === 1 ? false : true, type: 'button', onClick: catalogoProductoc(1), className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 row m-0 py-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'Nombre del Cliente:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', ref: txtNomrespon, disabled: true, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Vendedor:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-140 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'vendedor', value: '1', ref: txtTodosVendedores, onChange: onChekval, id: 'vendedor', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-176' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'vendedor', value: '2', ref: txtPorVendedor, onChange: onChekval, id: 'vendedor', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa2' },
	                  'Por Vendedor'
	                )
	              )
	            ),
	            _react2.default.createElement('input', { type: 'hidden', ref: txtIdProducto }),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-405' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm px-1 col-pd-250 ml-auto' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'RIF:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-select col-3', ref: txtCbmrifVende, name: 'nci', onChange: onChange, 'aria-label': 'Default select example' },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'V' },
	                    'V'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'E' },
	                    'E'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'J' },
	                    'J'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'P' },
	                    'P'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'G' },
	                    'G'
	                  )
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtRifVende, disabled: valvende === 1 ? false : true, onKeyUp: handleCliente, onBlur: handleCliente, className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: valvende === 1 ? false : true, type: 'button', onClick: catalogoProductoc(2), className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 row m-0 py-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'Nombre del Vendedor:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', ref: txtNomVende, disabled: true, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-4 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: habilitado, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-primary mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-print' },
	              '  Imprimir'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: mostrar1,
	      nomid: clientvende,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar1(false);
	      },
	      onHideAceptaCatalogo: handleAceptaCliente
	    })
	  );
	};

/***/ },
/* 7120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ImprimirAnticiposxVendedor = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImprimirAnticiposxVendedor = exports.ImprimirAnticiposxVendedor = function ImprimirAnticiposxVendedor(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtTodasFechas = (0, _react.useRef)();
	  var txtPorFechas = (0, _react.useRef)();
	  var txtTodosDispo = (0, _react.useRef)();
	  var txtPorConfirmar = (0, _react.useRef)();
	  var txtConfirmada = (0, _react.useRef)();
	  var txtAnuladas = (0, _react.useRef)();
	  var txtTodosCliente = (0, _react.useRef)();
	  var txtPorCliente = (0, _react.useRef)();
	  var txtIdProducto = (0, _react.useRef)();
	  var txtRifrespon = (0, _react.useRef)();
	  var txtNomrespon = (0, _react.useRef)();
	  var txtRifVende = (0, _react.useRef)();
	  var txtNomVende = (0, _react.useRef)();
	  var txtDesde = (0, _react.useRef)();
	  var txtHasta = (0, _react.useRef)();
	  var txtCbmrif = (0, _react.useRef)();
	  var txtCbmrifVende = (0, _react.useRef)();
	  var txtTodosAlmacen = (0, _react.useRef)();
	  var txtAplicada = (0, _react.useRef)();
	  var txtCodigoAlmacen = (0, _react.useRef)();
	  var txtNombreAlmacen = (0, _react.useRef)();
	  var txtOrden = (0, _react.useRef)();
	  var txtTodosVendedores = (0, _react.useRef)();
	  var txtPorVendedor = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(""),
	      _useState2 = _slicedToArray(_useState, 2),
	      dataestatus = _useState2[0],
	      setDataestatus = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      combocliente = _useState4[0],
	      setCombocliente = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      valvende = _useState6[0],
	      setValvende = _useState6[1];
	
	  var _useState7 = (0, _react.useState)('V'),
	      _useState8 = _slicedToArray(_useState7, 2),
	      tiporif = _useState8[0],
	      setTipofic = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(''),
	      _useState10 = _slicedToArray(_useState9, 2),
	      idpag = _useState10[0],
	      setIdpag = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(null),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mostrar1 = _useState12[0],
	      setMostrar1 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(null),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mostrar2 = _useState14[0],
	      setMostrar2 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      comboestatus = _useState16[0],
	      setComboestatus = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(''),
	      _useState18 = _slicedToArray(_useState17, 2),
	      desde = _useState18[0],
	      setDesde = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(''),
	      _useState20 = _slicedToArray(_useState19, 2),
	      hasta = _useState20[0],
	      setHasta = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(''),
	      _useState22 = _slicedToArray(_useState21, 2),
	      ordens = _useState22[0],
	      setOrdens = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(''),
	      _useState24 = _slicedToArray(_useState23, 2),
	      clientvende = _useState24[0],
	      setClientvende = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(''),
	      _useState26 = _slicedToArray(_useState25, 2),
	      disponiblec = _useState26[0],
	      setDisponiblec = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(''),
	      _useState28 = _slicedToArray(_useState27, 2),
	      paracliente = _useState28[0],
	      setParacliente = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(''),
	      _useState30 = _slicedToArray(_useState29, 2),
	      idclient = _useState30[0],
	      setIdclient = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(''),
	      _useState32 = _slicedToArray(_useState31, 2),
	      idvendedr = _useState32[0],
	      setIdvendedr = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(''),
	      _useState34 = _slicedToArray(_useState33, 2),
	      report = _useState34[0],
	      setReport = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(null),
	      _useState36 = _slicedToArray(_useState35, 2),
	      idalmacen = _useState36[0],
	      setIdalmacen = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(null),
	      _useState38 = _slicedToArray(_useState37, 2),
	      valalmacen = _useState38[0],
	      setValalmacen = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(false),
	      _useState40 = _slicedToArray(_useState39, 2),
	      activate = _useState40[0],
	      setActivate = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(true),
	      _useState42 = _slicedToArray(_useState41, 2),
	      habilitado = _useState42[0],
	      setHabilitado = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      mensaje = _useState44[0],
	      setMensaje = _useState44[1];
	
	  var _useState45 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState46 = _slicedToArray(_useState45, 2),
	      mensajesino = _useState46[0],
	      setMensajesino = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(''),
	      _useState48 = _slicedToArray(_useState47, 2),
	      tituid = _useState48[0],
	      setTituid = _useState48[1];
	
	  var _useState49 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState50 = _slicedToArray(_useState49, 2),
	      botones = _useState50[0],
	      setBotones = _useState50[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setDataestatus("");
	    setComboestatus(0);
	    setDisponiblec('');
	    setParacliente('');
	    setIdalmacen("");
	    setReport('');
	    setIdclient('');
	    setIdvendedr('');
	    setValalmacen(0);
	    setOrdens('');
	    setValvende(0);
	    setIdpag('');
	    setCombocliente(0);
	    setTipofic('V');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope === 1) {
	
	      if (txtDesde.current.value === '' || txtHasta.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione las Fechas a Consultar !', icono: 'informacion' });
	        if (txtDesde.current.value === '' && txtHasta.current.value !== '') {
	          txtDesde.current.focus();
	        } else if (txtHasta.current.value === '' && txtDesde.current.value !== '') {
	          txtHasta.current.focus();
	        } else {
	          txtDesde.current.focus();
	        }
	        sigue = false;
	      } else if (txtPorCliente.current.checked === true && txtRifrespon.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el RIF del Cliente a Consultar !', icono: 'informacion' });
	        txtRifrespon.current.focus();
	        sigue = false;
	      } else if (txtPorVendedor.current.checked === true && txtRifVende.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el RIF del Vendedor a Consultar !', icono: 'informacion' });
	        txtRifVende.current.focus();
	        sigue = false;
	      } else if (sigue !== false) {
	        imprimirGeneral();
	      }
	    }
	  };
	
	  var onChekval = function onChekval(e) {
	
	    if (e.target.id === 'cliente') {
	      if (txtTodosCliente.current.checked === true) {
	        setCombocliente(0);
	        setIdclient('');
	        txtNomrespon.current.value = '';
	        txtRifrespon.current.value = '';
	        txtCbmrif.current.value = '';
	      } else {
	        setCombocliente(1);
	        setClientvende('cliente');
	      }
	    } else if (e.target.id === 'vendedor') {
	      if (txtTodosVendedores.current.checked === true) {
	        setValvende(0);
	        setIdvendedr('');
	        txtNomVende.current.value = '';
	        txtCbmrifVende.current.value = '';
	        txtRifVende.current.value = '';
	      } else {
	        setValvende(1);
	        setClientvende('vendedor');
	      }
	    } else if (e.target.id === 'estatus') {
	      if (e.target.value === '2') {
	        var data = " and rp.status = 0";
	        setDataestatus(data);
	      } else if (e.target.value === '3') {
	        var _data = " and rp.status = 1";
	        setDataestatus(_data);
	      } else {
	        var _data2 = " and rp.status != 4";
	        setDataestatus(_data2);
	      }
	    }
	  };
	
	  var imprimirGeneral = function imprimirGeneral() {
	
	    var reporte = "AnticiposPorVendedor";
	    var condi = "'" + idvendedr + dataestatus + idclient + "'";
	
	    window.open(op.reportes + "/finanzas?afiliado=" + afiliado + "&reporte=" + reporte + "&condi=" + condi + "&desde=" + desde + "&hasta=" + hasta, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    if (props.llamado === 2) {
	      props.onHideRenderizar();
	      props.onHideCancela();
	    }
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var handleAceptaCliente = function handleAceptaCliente(values) {
	    setMostrar1(false);
	    if (clientvende === 'cliente') {
	      txtCbmrif.current.value = values.rif.substring(0, 1);
	      txtRifrespon.current.value = values.rif.substring(1, 11);
	      txtNomrespon.current.value = values.nombre;
	      selectResponsable(values.rif);
	    } else if (clientvende === 'vendedor') {
	      txtCbmrifVende.current.value = values.rif.substring(0, 1);
	      txtRifVende.current.value = values.rif.substring(1, 11);
	      txtNomVende.current.value = values.nombre;
	      selectResponsable(values.rif);
	    }
	  };
	
	  var catalogoClienteVendedor = function catalogoClienteVendedor(ope) {
	    return function (e) {
	      e.preventDefault();
	      if (ope === 1) {
	        setClientvende('cliente');
	        setMostrar1(true);
	      } else {
	        setClientvende('vendedor');
	        setMostrar1(true);
	      }
	    };
	  };
	
	  var selectResponsable = function selectResponsable(id) {
	
	    var campos = '*';
	    var nomtab = 'agente';
	    var nomid = 'rif';
	    var nomid2 = clientvende;
	    var endpoint = op.conexion + '/api/consulta/modeli2?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id + '&nomid2=' + nomid2 + '&id2=true';
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idagente > 0) {
	          if (clientvende === 'cliente') {
	            txtNomrespon.current.value = response.data.nombre;
	            setIdclient(' and rp.idcliente = ' + response.data.idagente);
	            btnAcepta.current.focus();
	          } else {
	            txtNomVende.current.value = response.data.nombre;
	            setIdvendedr(' and rp.idvendedor = ' + response.data.idagente);
	            btnAcepta.current.focus();
	          }
	        } else {
	          if (clientvende !== 'vendedor') {
	            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ RIF y/o Cliente no Registrado !', icono: 'informacion' });
	            txtRifrespon.current.value = '';
	            txtNomrespon.current.value = '';
	          } else {
	            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ RIF y/o Vendedor no Registrado !', icono: 'informacion' });
	            txtRifVende.current.value = '';
	            txtNomVende.current.value = '';
	          }
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'nci') {
	      setTipofic(e.target.value);
	    } else if (e.target.name === 'desde') {
	      if (e.target.value > (0, _moment2.default)(fechasistema).format('YYYY-MM-DD')) {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !', icono: 'informacion' });
	        txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        txtDesde.current.focus();
	      } else {
	        setDesde("'" + (0, _moment2.default)(e.target.value).format('DD-MM-YYYY') + "'");
	      }
	    } else if (e.target.name === 'hasta') {
	      setHasta("'" + (0, _moment2.default)(e.target.value).format('DD-MM-YYYY') + "'");
	    }
	  };
	
	  var handleCliente = function handleCliente(e) {
	    e.preventDefault();
	    if (e.which === 13 || typeof e.which === 'undefined') {
	      if (e.target.value !== '') {
	        setClientvende('cliente');
	        if (clientvende === 'cliente') {
	          selectResponsable(tiporif + e.target.value);
	        }
	      }
	    }
	  };
	
	  var handleVendedor = function handleVendedor(e) {
	    e.preventDefault();
	    if (e.which === 13 || typeof e.which === 'undefined') {
	      if (e.target.value !== '') {
	        setClientvende('vendedor');
	        if (clientvende === 'vendedor') {
	          selectResponsable(tiporif + e.target.value);
	        }
	      }
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.ope === 1) {
	          txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	          txtHasta.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	          var desdec = (0, _moment2.default)(fechasistema).format('DD-MM-YYYY');
	          var hastac = (0, _moment2.default)(fechasistema).format('DD-MM-YYYY');
	          setDesde("'" + desdec + "'");
	          setHasta("'" + hastac + "'");
	          txtTodosCliente.current.checked = true;
	          txtPorCliente.current.checked = false;
	          txtTodosVendedores.current.checked = true;
	          txtPorVendedor.current.checked = false;
	          txtTodosDispo.current.checked = true;
	          txtPorConfirmar.current.checked = false;
	          txtConfirmada.current.checked = false;
	          setHabilitado(false);
	          var data = " and rp.status != 4";
	          setDataestatus(data);
	        } else {
	          txtTodosCliente.current.checked = false;
	          txtTodosVendedores.current.checked = false;
	          txtPorVendedor.current.checked = false;
	          txtTodosDispo.current.checked = false;
	          setHabilitado(true);
	          setDataestatus("");
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Imprimir Anticipos por Vendedor'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto' },
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Fecha:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-7 row m-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'DESDE:'
	                  ),
	                  _react2.default.createElement('input', { type: 'date', ref: txtDesde /* disabled={combofecha === 0 ? true : false} */, name: 'desde', onChange: onChange, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'HASTA:'
	                  ),
	                  _react2.default.createElement('input', { type: 'date', ref: txtHasta /* disabled={combofecha === 0 ? true : false} */, name: 'hasta', onChange: onChange, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 d-flex justify-content-around border-azul rounded mb-1 mx-auto' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Estatus:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-100' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'estatus', value: '1', ref: txtTodosDispo, onChange: onChekval, id: 'estatus', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-130' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'estatus', value: '2', ref: txtPorConfirmar, onChange: onChekval, id: 'estatus', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai2' },
	                  'Anticipos Por Aplicar'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-130' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'estatus', value: '3', ref: txtConfirmada, onChange: onChekval, id: 'estatus', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai3' },
	                  'Anticipos Aplicados'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Cliente:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'cliente', value: '1', ref: txtTodosCliente, onChange: onChekval, id: 'cliente', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'cliente', value: '2', ref: txtPorCliente, onChange: onChekval, id: 'cliente', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa2' },
	                  'Por Cliente'
	                )
	              )
	            ),
	            _react2.default.createElement('input', { type: 'hidden', ref: txtIdProducto }),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-7 mr-auto px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm col-7 px-1 ml-auto' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'RIF:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-select col-3', ref: txtCbmrif, name: 'nci', onChange: onChange, 'aria-label': 'Default select example' },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'V' },
	                    'V'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'E' },
	                    'E'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'J' },
	                    'J'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'P' },
	                    'P'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'G' },
	                    'G'
	                  )
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtRifrespon, disabled: combocliente === 1 ? false : true, onKeyUp: handleCliente, onBlur: handleCliente, className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: combocliente === 1 ? false : true, type: 'button', onClick: catalogoClienteVendedor(1), className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 row m-0 py-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'Nombre del Cliente:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', ref: txtNomrespon, disabled: true, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Vendedor:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-140 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'vendedor', value: '1', ref: txtTodosVendedores, onChange: onChekval, id: 'vendedor', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-176' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'vendedor', value: '2', ref: txtPorVendedor, onChange: onChekval, id: 'vendedor', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa2' },
	                  'Por Vendedor'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-405' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm px-1 col-pd-250 ml-auto' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'RIF:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-select col-3', ref: txtCbmrifVende, name: 'nci', onChange: onChange, 'aria-label': 'Default select example' },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'V' },
	                    'V'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'E' },
	                    'E'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'J' },
	                    'J'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'P' },
	                    'P'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'G' },
	                    'G'
	                  )
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtRifVende, disabled: valvende === 1 ? false : true, onKeyUp: handleVendedor, onBlur: handleVendedor, className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: valvende === 1 ? false : true, type: 'button', onClick: catalogoClienteVendedor(2), className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 row m-0 py-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'Nombre del Vendedor:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', ref: txtNomVende, disabled: true, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-4 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: habilitado, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-primary mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-print' },
	              '  Imprimir'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: mostrar1,
	      nomid: clientvende,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar1(false);
	      },
	      onHideAceptaCatalogo: handleAceptaCliente
	    })
	  );
	};

/***/ },
/* 7121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ImprimirCuentasxCobrarEstadosCuentas = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoAlmacen = __webpack_require__(51);
	
	var _catalogoAlmacen2 = _interopRequireDefault(_catalogoAlmacen);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImprimirCuentasxCobrarEstadosCuentas = exports.ImprimirCuentasxCobrarEstadosCuentas = function ImprimirCuentasxCobrarEstadosCuentas(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtTodasFechas = (0, _react.useRef)();
	  var txtPorFechas = (0, _react.useRef)();
	  var txtTodosDispo = (0, _react.useRef)();
	  var txtCanceladas = (0, _react.useRef)();
	  var txtDeudas = (0, _react.useRef)();
	  var txtTodosCliente = (0, _react.useRef)();
	  var txtVipCliente = (0, _react.useRef)();
	  var txtRegulares = (0, _react.useRef)();
	  var txtPorCliente = (0, _react.useRef)();
	  var txtIdProducto = (0, _react.useRef)();
	  var txtRifrespon = (0, _react.useRef)();
	  var txtNomrespon = (0, _react.useRef)();
	  var txtDesde = (0, _react.useRef)();
	  var txtHasta = (0, _react.useRef)();
	  var txtCbmrif = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      inputalmacen = _useState2[0],
	      setInputalmacen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      inputproducto = _useState4[0],
	      setInputproducto = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      tiporif = _useState6[0],
	      setTipofic = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(''),
	      _useState8 = _slicedToArray(_useState7, 2),
	      tituloc = _useState8[0],
	      setTituloc = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mostrar1 = _useState10[0],
	      setMostrar1 = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(''),
	      _useState12 = _slicedToArray(_useState11, 2),
	      parafecha = _useState12[0],
	      setParafecha = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(''),
	      _useState14 = _slicedToArray(_useState13, 2),
	      desde = _useState14[0],
	      setDesde = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(''),
	      _useState16 = _slicedToArray(_useState15, 2),
	      hasta = _useState16[0],
	      setHasta = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(''),
	      _useState18 = _slicedToArray(_useState17, 2),
	      disponiblec = _useState18[0],
	      setDisponiblec = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(''),
	      _useState20 = _slicedToArray(_useState19, 2),
	      paracliente = _useState20[0],
	      setParacliente = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(''),
	      _useState22 = _slicedToArray(_useState21, 2),
	      idclient = _useState22[0],
	      setIdclient = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(''),
	      _useState24 = _slicedToArray(_useState23, 2),
	      report = _useState24[0],
	      setReport = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(false),
	      _useState26 = _slicedToArray(_useState25, 2),
	      activate = _useState26[0],
	      setActivate = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(true),
	      _useState28 = _slicedToArray(_useState27, 2),
	      habilitado = _useState28[0],
	      setHabilitado = _useState28[1];
	
	  var _useState29 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState30 = _slicedToArray(_useState29, 2),
	      mensaje = _useState30[0],
	      setMensaje = _useState30[1];
	
	  var _useState31 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState32 = _slicedToArray(_useState31, 2),
	      mensajesino = _useState32[0],
	      setMensajesino = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(''),
	      _useState34 = _slicedToArray(_useState33, 2),
	      tituid = _useState34[0],
	      setTituid = _useState34[1];
	
	  var _useState35 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState36 = _slicedToArray(_useState35, 2),
	      botones = _useState36[0],
	      setBotones = _useState36[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setInputalmacen(0);
	    setParafecha('');
	    setDisponiblec('');
	    setParacliente('');
	    setInputproducto(0);
	    setReport('');
	    setIdclient('');
	    setTituid('');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.op === 1) {
	
	      if (txtPorFechas.current.checked === true && txtPorCliente.current.checked === false) {
	        if (txtDesde.current.value === '' || txtHasta.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione las Fechas a Consultar !', icono: 'informacion' });
	          if (txtDesde.current.value === '' && txtHasta.current.value !== '') {
	            txtDesde.current.focus();
	          } else if (txtHasta.current.value === '' && txtDesde.current.value !== '') {
	            txtHasta.current.focus();
	          }
	          sigue = false;
	        } else {
	          imprimirGeneral();
	        }
	      } else if (txtPorFechas.current.checked === false && txtPorCliente.current.checked === true) {
	        if (txtRifrespon.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el RIF del Cliente a Consultar !', icono: 'informacion' });
	          txtRifrespon.current.focus();
	          sigue = false;
	        } else {
	          imprimirGeneral();
	        }
	      } else if (txtPorFechas.current.checked === true && txtPorCliente.current.checked === true) {
	        if (txtDesde.current.value === '' && txtHasta.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Las Fechas a Consultar no Deben ir Vacias !', icono: 'informacion' });
	          txtPorFechas.current.focus();
	          sigue = false;
	        } else if (txtRifrespon.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el RIF del Cliente a Consultar !', icono: 'informacion' });
	          txtRifrespon.current.focus();
	          sigue = false;
	        } else {
	          imprimirGeneral();
	        }
	      } else {
	        imprimirGeneral();
	      }
	    }
	  };
	
	  var onChekval = function onChekval(e) {
	
	    if (e.target.id === 'tipoalmacen') {
	
	      if (txtTodasFechas.current.checked === true) {
	
	        setInputalmacen(0);
	        setParafecha('');
	        setDesde('');
	        setHasta('');
	        txtDesde.current.value = '';
	        txtHasta.current.value = '';
	      } else if (txtPorFechas.current.checked === true) {
	
	        setInputalmacen(1);
	        setParafecha('and n.fecha between ');
	      }
	    } else if (e.target.id === 'tipodisponible') {
	
	      if (e.target.value === '1') {
	        setDisponiblec('');
	        setTituid('ReporteEstadoCeuntasyPorcobrarDos');
	        setTituloc('LISTADO DE ESTADOS DE CUENTA');
	      } else if (e.target.value === '2') {
	        setDisponiblec('and n.status = 1');
	        setTituid('ReporteEstadoCeuntasyPorcobrarDos');
	        setTituloc('LISTADO DE ESTADOS DE CUENTA (PAGADAS)');
	      } else if (e.target.value === '3') {
	        setDisponiblec('and n.status = 0');
	        setTituid('ReporteEstadoCeuntasyPorcobrar');
	        setTituloc('LISTADO DE CUENTAS POR COBRAR');
	      }
	    } else if (e.target.id === 'tipoproducto') {
	
	      if (txtTodosCliente.current.checked === true) {
	        setInputproducto(0);
	        setParacliente('');
	        setIdclient('');
	        txtNomrespon.current.value = '';
	      } else if (txtPorCliente.current.checked === true) {
	        setInputproducto(1);
	        setParacliente('and n.idcliente = ');
	      } else if (txtVipCliente.current.checked === true) {
	        setInputproducto(2);
	        setParacliente(' and ag.grupcli = ' + "''1''");
	      } else if (txtRegulares.current.checked === true) {
	        setInputproducto(3);
	        setParacliente(' and ag.grupcli = ' + "''2''");
	      }
	    }
	  };
	
	  var imprimirGeneral = function imprimirGeneral() {
	
	    var parameters = void 0;
	
	    if (inputalmacen === 1) {
	      parameters = "'" + '||quote_literal(' + desde + ')||' + "'" + ' and ' + "'" + '||quote_literal(' + hasta + ')';
	    } else {
	      parameters = "'";
	    }
	
	    var reporte = tituid;
	
	    var condi = disponiblec + paracliente + idclient + parafecha + parameters;
	
	    window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&condicion=" + "'" + condi + "&titulo=" + tituloc, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    if (props.llamado === 2) {
	      props.onHideRenderizar();
	      props.onHideCancela();
	    }
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var handleAceptaCliente = function handleAceptaCliente(values) {
	    setMostrar1(false);
	
	    txtCbmrif.current.value = values.rif.substring(0, 1);
	    txtRifrespon.current.value = values.rif.substring(1, 11);
	    txtNomrespon.current.value = values.nombre;
	    selectResponsable(values.rif);
	    setIdclient(values.idagente);
	  };
	
	  var catalogoProductoc = function catalogoProductoc(e) {
	    e.preventDefault();
	    setMostrar1(true);
	  };
	
	  var selectResponsable = function selectResponsable(id) {
	
	    var campos = '*';
	    var nomtab = 'agente';
	    var nomid = 'rif';
	    var nomid2 = 'cliente';
	    var endpoint = op.conexion + '/api/consulta/modeli2?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id + '&nomid2=' + nomid2 + '&id2=true';
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idagente > 0) {
	          txtNomrespon.current.value = response.data.nombre;
	          setIdclient(response.data.idagente);
	          btnAcepta.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ RIF y/o Cliente no Registrado !', icono: 'informacion' });
	          txtRifrespon.current.value = '';
	          txtNomrespon.current.value = '';
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'nci') {
	      setTipofic(e.target.value);
	    } else if (e.target.name === 'desde') {
	      if (e.target.value > (0, _moment2.default)(fechasistema).format('YYYY-MM-DD')) {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !', icono: 'informacion' });
	        txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        txtDesde.current.focus();
	      } else {
	        setDesde("'" + (0, _moment2.default)(e.target.value).format('DD-MM-YYYY') + "'");
	      }
	    } else if (e.target.name === 'hasta') {
	      setHasta("'" + (0, _moment2.default)(e.target.value).format('DD-MM-YYYY') + "'");
	    }
	  };
	
	  var handleCliente = function handleCliente(e) {
	    e.preventDefault();
	    if (e.which === 13 || typeof e.which === 'undefined') {
	      if (e.target.value !== '') {
	        selectResponsable(tiporif + e.target.value);
	      }
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.op === 1) {
	
	          if (props.report === "reporteestadodecuenta") {
	            setTituloc('LISTADO DE ESTADOS DE CUENTA');
	            setDisponiblec('');
	          } else if (props.report === "reportecuentasporcobrar") {
	            setTituloc('LISTADO DE CUENTAS POR COBRAR');
	            setDisponiblec('and n.status = 0');
	          }
	
	          setTituid('ReporteEstadoCeuntasyPorcobrarDos');
	
	          if (props.report !== "reportecuentasporcobrar") {
	            txtTodosDispo.current.checked = true;
	            txtCanceladas.current.checked = false;
	            txtDeudas.current.checked = false;
	          }
	
	          txtTodasFechas.current.checked = true;
	          txtTodosCliente.current.checked = true;
	          txtVipCliente.current.checked = false;
	          txtRegulares.current.checked = false;
	          setParacliente('');
	          setParafecha('');
	          setDesde('');
	          setHasta('');
	          setTipofic('V');
	          txtPorFechas.current.checked = false;
	          txtPorCliente.current.checked = false;
	          setHabilitado(false);
	        } else {
	
	          if (props.report !== "reportecuentasporcobrar") {
	            txtTodosDispo.current.checked = false;
	            txtCanceladas.current.checked = false;
	            txtDeudas.current.checked = false;
	          }
	
	          txtTodasFechas.current.checked = false;
	          txtTodosCliente.current.checked = false;
	          txtVipCliente.current.checked = false;
	          txtRegulares.current.checked = false;
	
	          txtPorCliente.current.checked = false;
	          txtPorFechas.current.checked = false;
	
	          setHabilitado(true);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          props.report === "reporteestadodecuenta" ? 'Imprimir Estados de Cuenta' : 'Imprimir Cuentas por Cobrar'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto' },
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Fecha:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipoalmacen', value: '1', ref: txtTodasFechas, onChange: onChekval, id: 'tipoalmacen', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRadi1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipoalmacen', value: '2', ref: txtPorFechas, onChange: onChekval, id: 'tipoalmacen', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRadi2' },
	                  'Por Fecha'
	                )
	              )
	            ),
	            inputalmacen === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'col-7 row m-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'Desde:'
	                  ),
	                  _react2.default.createElement('input', { type: 'date', ref: txtDesde, disabled: inputalmacen === 0 ? true : false, name: 'desde', onChange: onChange, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'Hasta:'
	                  ),
	                  _react2.default.createElement('input', { type: 'date', ref: txtHasta, disabled: inputalmacen === 0 ? true : false, name: 'hasta', onChange: onChange, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            ) : ''
	          ),
	          props.report !== "reportecuentasporcobrar" ? _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Estatus del Pago:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-1 ml-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '1', ref: txtTodosDispo, onChange: onChekval, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-1 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '2', ref: txtCanceladas, onChange: onChekval, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai2' },
	                  'Canceladas'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-4' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '3', ref: txtDeudas, onChange: onChekval, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai3' },
	                  'Con Deudas'
	                )
	              )
	            )
	          ) : '',
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Cliente:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipoproducto', value: '1', ref: txtTodosCliente, onChange: onChekval, id: 'tipoproducto', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipoproducto', value: '4', ref: txtRegulares, onChange: onChekval, id: 'tipoproducto', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa4' },
	                  'Regulares'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipoproducto', value: '3', ref: txtVipCliente, onChange: onChekval, id: 'tipoproducto', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa3' },
	                  'Clientes VIP'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipoproducto', value: '2', ref: txtPorCliente, onChange: onChekval, id: 'tipoproducto', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa2' },
	                  'Por Cliente'
	                )
	              )
	            ),
	            _react2.default.createElement('input', { type: 'hidden', ref: txtIdProducto }),
	            inputproducto === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'col-12 row m-0 py-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm col-4 ml-auto mb-1 px-1' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'RIF:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-select col-3', ref: txtCbmrif, name: 'nci', onChange: onChange, 'aria-label': 'Default select example' },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'V' },
	                    'V'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'E' },
	                    'E'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'J' },
	                    'J'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'P' },
	                    'P'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'G' },
	                    'G'
	                  )
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtRifrespon, disabled: inputproducto === 1 ? false : true, onKeyUp: handleCliente, onBlur: handleCliente, className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: inputproducto === 1 ? false : true, type: 'button', onClick: catalogoProductoc, className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12 px-1' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'Nombre del Cliente:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', ref: txtNomrespon, disabled: true, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            ) : ''
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-4 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: habilitado, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-primary mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-print' },
	              '  Imprimir'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: mostrar1,
	      nomid: 'cliente',
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar1(false);
	      },
	      onHideAceptaCatalogo: handleAceptaCliente
	    })
	  );
	};

/***/ },
/* 7122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ImprimirDeudasGenerales = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImprimirDeudasGenerales = exports.ImprimirDeudasGenerales = function ImprimirDeudasGenerales(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtDetallado = (0, _react.useRef)();
	  var txtBasico = (0, _react.useRef)();
	  var txtDesglose = (0, _react.useRef)();
	  var txtTodosCliente = (0, _react.useRef)();
	  var txtPorCliente = (0, _react.useRef)();
	  var txtIdProducto = (0, _react.useRef)();
	  var txtRifrespon = (0, _react.useRef)();
	  var txtNomrespon = (0, _react.useRef)();
	  var txtRifVende = (0, _react.useRef)();
	  var txtNomVende = (0, _react.useRef)();
	  var txtDesde = (0, _react.useRef)();
	  var txtHasta = (0, _react.useRef)();
	  var txtCbmrif = (0, _react.useRef)();
	  var txtCbmrifVende = (0, _react.useRef)();
	  var txtTodosVendedores = (0, _react.useRef)();
	  var txtPorVendedor = (0, _react.useRef)();
	  var txtDeuda = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(""),
	      _useState2 = _slicedToArray(_useState, 2),
	      dataestatus = _useState2[0],
	      setDataestatus = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      combocliente = _useState4[0],
	      setCombocliente = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      valvende = _useState6[0],
	      setValvende = _useState6[1];
	
	  var _useState7 = (0, _react.useState)('V'),
	      _useState8 = _slicedToArray(_useState7, 2),
	      tiporif = _useState8[0],
	      setTipofic = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mostrar1 = _useState10[0],
	      setMostrar1 = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      reportval = _useState12[0],
	      setReportval = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(''),
	      _useState14 = _slicedToArray(_useState13, 2),
	      desde = _useState14[0],
	      setDesde = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(''),
	      _useState16 = _slicedToArray(_useState15, 2),
	      hasta = _useState16[0],
	      setHasta = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(''),
	      _useState18 = _slicedToArray(_useState17, 2),
	      clientvende = _useState18[0],
	      setClientvende = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(''),
	      _useState20 = _slicedToArray(_useState19, 2),
	      idclient = _useState20[0],
	      setIdclient = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(''),
	      _useState22 = _slicedToArray(_useState21, 2),
	      idvendedr = _useState22[0],
	      setIdvendedr = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(false),
	      _useState24 = _slicedToArray(_useState23, 2),
	      activate = _useState24[0],
	      setActivate = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(true),
	      _useState26 = _slicedToArray(_useState25, 2),
	      habilitado = _useState26[0],
	      setHabilitado = _useState26[1];
	
	  var _useState27 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState28 = _slicedToArray(_useState27, 2),
	      mensaje = _useState28[0],
	      setMensaje = _useState28[1];
	
	  var _useState29 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState30 = _slicedToArray(_useState29, 2),
	      mensajesino = _useState30[0],
	      setMensajesino = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(1),
	      _useState32 = _slicedToArray(_useState31, 2),
	      oper = _useState32[0],
	      setOper = _useState32[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setDataestatus(" and n.status = 0");
	    setIdclient('');
	    setIdvendedr('');
	    setValvende(0);
	    setCombocliente(0);
	    setTipofic('V');
	    setReportval(0);
	    setOper(1);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope === 1) {
	
	      if (txtDesde.current.value === '' || txtHasta.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione las Fechas a Consultar !', icono: 'informacion' });
	        if (txtDesde.current.value === '' && txtHasta.current.value !== '') {
	          txtDesde.current.focus();
	        } else if (txtHasta.current.value === '' && txtDesde.current.value !== '') {
	          txtHasta.current.focus();
	        } else {
	          txtDesde.current.focus();
	        }
	        sigue = false;
	      } else if (txtPorCliente.current.checked === true && txtRifrespon.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el RIF del Cliente a Consultar !', icono: 'informacion' });
	        txtRifrespon.current.focus();
	        sigue = false;
	      } else if (txtPorVendedor.current.checked === true && txtRifVende.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el RIF del Vendedor a Consultar !', icono: 'informacion' });
	        txtRifVende.current.focus();
	        sigue = false;
	      } else if (sigue !== false) {
	        imprimirGeneral();
	      }
	    }
	  };
	
	  var onChekval = function onChekval(e) {
	    if (e.target.id === 'cliente') {
	      if (txtTodosCliente.current.checked === true) {
	        setCombocliente(0);
	        setIdclient('');
	        txtNomrespon.current.value = '';
	        txtRifrespon.current.value = '';
	        txtCbmrif.current.value = '';
	      } else {
	        setCombocliente(1);
	        setClientvende('cliente');
	      }
	    } else if (e.target.id === 'vendedor') {
	      if (txtTodosVendedores.current.checked === true) {
	        setValvende(0);
	        setIdvendedr('');
	        txtNomVende.current.value = '';
	        txtCbmrifVende.current.value = '';
	        txtRifVende.current.value = '';
	      } else {
	        setValvende(1);
	        setClientvende('vendedor');
	      }
	    } else if (e.target.name === 'detallado') {
	      if (e.target.checked) {
	        setReportval(1);
	      } else {
	        setReportval(0);
	      }
	    } else if (e.target.id === 'detaller') {
	      if (e.target.value !== 2) {
	        setOper(e.target.value);
	      } else {
	        setOper(e.target.value);
	      }
	    } else if (e.target.name === 'deuda') {
	      if (e.target.checked) {
	        setDataestatus(" and n.status = 0");
	      } else {
	        setDataestatus(" and n.status != 4");
	      }
	    }
	  };
	
	  var imprimirGeneral = function imprimirGeneral() {
	    var reporte = reportval !== 1 ? "ReporteGeneralDeudas" : "ReporteGeneralDeudasDetallado";
	    var condi = "'" + idvendedr + idclient + dataestatus + "'";
	    window.open(op.reportes + "/finanzas?afiliado=" + afiliado + "&reporte=" + reporte + "&condi=" + condi + "&desde=" + desde + "&hasta=" + hasta + "&OP=" + oper, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    if (props.llamado === 2) {
	      props.onHideRenderizar();
	      props.onHideCancela();
	    }
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var handleAceptaCliente = function handleAceptaCliente(values) {
	    setMostrar1(false);
	    if (clientvende === 'cliente') {
	      txtCbmrif.current.value = values.rif.substring(0, 1);
	      txtRifrespon.current.value = values.rif.substring(1, 11);
	      txtNomrespon.current.value = values.nombre;
	      selectResponsable(values.rif);
	    } else if (clientvende === 'vendedor') {
	      txtCbmrifVende.current.value = values.rif.substring(0, 1);
	      txtRifVende.current.value = values.rif.substring(1, 11);
	      txtNomVende.current.value = values.nombre;
	      selectResponsable(values.rif);
	    }
	  };
	
	  var catalogoClienteVendedor = function catalogoClienteVendedor(ope) {
	    return function (e) {
	      e.preventDefault();
	      if (ope === 1) {
	        setClientvende('cliente');
	        setMostrar1(true);
	      } else {
	        setClientvende('vendedor');
	        setMostrar1(true);
	      }
	    };
	  };
	
	  var selectResponsable = function selectResponsable(id) {
	    var campos = '*';
	    var nomtab = 'agente';
	    var nomid = 'rif';
	    var nomid2 = clientvende;
	    var endpoint = op.conexion + '/api/consulta/modeli2?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id + '&nomid2=' + nomid2 + '&id2=true';
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idagente > 0) {
	          if (clientvende === 'cliente') {
	            txtNomrespon.current.value = response.data.nombre;
	            setIdclient(' and n.idcliente = ' + response.data.idagente);
	            btnAcepta.current.focus();
	          } else {
	            txtNomVende.current.value = response.data.nombre;
	            setIdvendedr(' and n.idvendedor = ' + response.data.idagente);
	            btnAcepta.current.focus();
	          }
	        } else {
	          if (clientvende !== 'vendedor') {
	            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ RIF y/o Cliente no Registrado !', icono: 'informacion' });
	            txtRifrespon.current.value = '';
	            txtNomrespon.current.value = '';
	          } else {
	            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ RIF y/o Vendedor no Registrado !', icono: 'informacion' });
	            txtRifVende.current.value = '';
	            txtNomVende.current.value = '';
	          }
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === 'nci') {
	      setTipofic(e.target.value);
	    } else if (e.target.name === 'desde') {
	      if (e.target.value > (0, _moment2.default)(fechasistema).format('YYYY-MM-DD')) {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !', icono: 'informacion' });
	        txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        txtDesde.current.focus();
	      } else {
	        setDesde("'" + (0, _moment2.default)(e.target.value).format('DD-MM-YYYY') + "'");
	      }
	    } else if (e.target.name === 'hasta') {
	      setHasta("'" + (0, _moment2.default)(e.target.value).format('DD-MM-YYYY') + "'");
	    }
	  };
	
	  var handleCliente = function handleCliente(e) {
	    e.preventDefault();
	    if (e.which === 13 || typeof e.which === 'undefined') {
	      if (e.target.value !== '') {
	        setClientvende('cliente');
	        if (clientvende === 'cliente') {
	          selectResponsable(tiporif + e.target.value);
	        }
	      }
	    }
	  };
	
	  var handleVendedor = function handleVendedor(e) {
	    e.preventDefault();
	    if (e.which === 13 || typeof e.which === 'undefined') {
	      if (e.target.value !== '') {
	        setClientvende('vendedor');
	        if (clientvende === 'vendedor') {
	          selectResponsable(tiporif + e.target.value);
	        }
	      }
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.ope === 1) {
	          txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	          txtHasta.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	          var desdec = (0, _moment2.default)(fechasistema).format('DD-MM-YYYY');
	          var hastac = (0, _moment2.default)(fechasistema).format('DD-MM-YYYY');
	          setDesde("'" + desdec + "'");
	          setHasta("'" + hastac + "'");
	          txtTodosCliente.current.checked = true;
	          txtPorCliente.current.checked = false;
	          txtTodosVendedores.current.checked = true;
	          txtPorVendedor.current.checked = false;
	          setHabilitado(false);
	          var data = " and n.status = 0";
	          txtDeuda.current.checked = true;
	          setDataestatus(data);
	        } else {
	          txtTodosCliente.current.checked = false;
	          txtTodosVendedores.current.checked = false;
	          txtPorVendedor.current.checked = false;
	          txtPorCliente.current.checked = false;
	          setHabilitado(true);
	          setDataestatus(" and n.status = 0");
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Imprimir Pagos y Deudas Generales'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto' },
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Fecha:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-7 row m-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'DESDE:'
	                  ),
	                  _react2.default.createElement('input', { type: 'date', ref: txtDesde /* disabled={combofecha === 0 ? true : false} */, name: 'desde', onChange: onChange, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'HASTA:'
	                  ),
	                  _react2.default.createElement('input', { type: 'date', ref: txtHasta /* disabled={combofecha === 0 ? true : false} */, name: 'hasta', onChange: onChange, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 ml-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check col ml-auto' },
	                _react2.default.createElement('input', { className: 'form-check-input', ref: txtDeuda, name: 'deuda', onChange: onChekval, type: 'checkbox', value: '', id: 'flexCheckDefault' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'flexCheckDefault' },
	                  'Solo Deuda'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check col ml-auto' },
	                _react2.default.createElement('input', { className: 'form-check-input', ref: txtDetallado, name: 'detallado', onChange: onChekval, type: 'checkbox', value: '', id: 'flexCheckDefault' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'flexCheckDefault' },
	                  'Detallado'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-4 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'detaller', value: 3, disabled: reportval !== 1 ? true : false, ref: txtBasico, onChange: onChekval, id: 'detaller', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa11' },
	                  'Basico'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-4 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'detaller', value: 2, disabled: reportval !== 1 ? true : false, ref: txtDesglose, onChange: onChekval, id: 'detaller', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa22' },
	                  'Con Desglose'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Cliente:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'cliente', value: '1', ref: txtTodosCliente, onChange: onChekval, id: 'cliente', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'cliente', value: '2', ref: txtPorCliente, onChange: onChekval, id: 'cliente', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa2' },
	                  'Por Cliente'
	                )
	              )
	            ),
	            _react2.default.createElement('input', { type: 'hidden', ref: txtIdProducto }),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-7 mr-auto px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm col-7 px-1 ml-auto' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'RIF:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-select col-3', ref: txtCbmrif, name: 'nci', onChange: onChange, 'aria-label': 'Default select example' },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'V' },
	                    'V'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'E' },
	                    'E'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'J' },
	                    'J'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'P' },
	                    'P'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'G' },
	                    'G'
	                  )
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtRifrespon, disabled: combocliente === 1 ? false : true, onKeyUp: handleCliente, onBlur: handleCliente, className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: combocliente === 1 ? false : true, type: 'button', onClick: catalogoClienteVendedor(1), className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 row m-0 py-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'Nombre del Cliente:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', ref: txtNomrespon, disabled: true, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Vendedor:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-140 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'vendedor', value: '1', ref: txtTodosVendedores, onChange: onChekval, id: 'vendedor', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-176' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'vendedor', value: '2', ref: txtPorVendedor, onChange: onChekval, id: 'vendedor', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa2' },
	                  'Por Vendedor'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-405' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm px-1 col-pd-250 ml-auto' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'RIF:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-select col-3', ref: txtCbmrifVende, name: 'nci', onChange: onChange, 'aria-label': 'Default select example' },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'V' },
	                    'V'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'E' },
	                    'E'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'J' },
	                    'J'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'P' },
	                    'P'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'G' },
	                    'G'
	                  )
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtRifVende, disabled: valvende === 1 ? false : true, onKeyUp: handleVendedor, onBlur: handleVendedor, className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: valvende === 1 ? false : true, type: 'button', onClick: catalogoClienteVendedor(2), className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 row m-0 py-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'Nombre del Vendedor:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', ref: txtNomVende, disabled: true, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-4 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: habilitado, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-primary mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-print' },
	              '  Imprimir'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: mostrar1,
	      nomid: clientvende,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar1(false);
	      },
	      onHideAceptaCatalogo: handleAceptaCliente
	    })
	  );
	};

/***/ },
/* 7123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalIncluirRetencion = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoTipoRetenciones = __webpack_require__(294);
	
	var _catalogoTipoRetenciones2 = _interopRequireDefault(_catalogoTipoRetenciones);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ModalIncluirRetencion = exports.ModalIncluirRetencion = function ModalIncluirRetencion(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	    var fechaSistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	
	    var txtBase = (0, _react.useRef)();
	    var txtIva = (0, _react.useRef)();
	    var txtTotal = (0, _react.useRef)();
	    var txtCodigo = (0, _react.useRef)();
	    var txtDescrip = (0, _react.useRef)();
	    var txtFecha = (0, _react.useRef)();
	    var txtMontoIva = (0, _react.useRef)();
	    var txtAlicuota = (0, _react.useRef)();
	    var txtCompromiso = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        activate = _useState2[0],
	        setActivate = _useState2[1];
	
	    var _useState3 = (0, _react.useState)(false),
	        _useState4 = _slicedToArray(_useState3, 2),
	        mostrar = _useState4[0],
	        setMostrar = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        dataf = _useState6[0],
	        setDataf = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(null),
	        _useState8 = _slicedToArray(_useState7, 2),
	        uni = _useState8[0],
	        setUni = _useState8[1];
	
	    var _useState9 = (0, _react.useState)([]),
	        _useState10 = _slicedToArray(_useState9, 2),
	        Datati = _useState10[0],
	        setDatati = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(null),
	        _useState12 = _slicedToArray(_useState11, 2),
	        activo = _useState12[0],
	        setActivo = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(0),
	        _useState14 = _slicedToArray(_useState13, 2),
	        operacion = _useState14[0],
	        setOperacion = _useState14[1];
	
	    var _useState15 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState16 = _slicedToArray(_useState15, 2),
	        mensaje = _useState16[0],
	        setMensaje = _useState16[1];
	
	    var _useState17 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState18 = _slicedToArray(_useState17, 2),
	        mensajesino = _useState18[0],
	        setMensajesino = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(0.00),
	        _useState20 = _slicedToArray(_useState19, 2),
	        totals = _useState20[0],
	        setTotals = _useState20[1];
	
	    var _useState21 = (0, _react.useState)({
	        codigo: 0,
	        alicuota: 0.00,
	        baseimponible: 0.00,
	        descripcion: '',
	        fecha: '',
	        iva: 0.00,
	        montoiva: 0.00,
	        total: 0.00,
	        totalf: 0.00,
	        unidad: 0
	    }),
	        _useState22 = _slicedToArray(_useState21, 2),
	        values = _useState22[0],
	        setValues = _useState22[1];
	
	    var _useState23 = (0, _react.useState)([]),
	        _useState24 = _slicedToArray(_useState23, 2),
	        datos = _useState24[0],
	        setDatos = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(false),
	        _useState26 = _slicedToArray(_useState25, 2),
	        lgShow = _useState26[0],
	        setLgShow = _useState26[1];
	
	    var btnCancela = (0, _react.useRef)();
	    var btnAcepta = (0, _react.useRef)();
	
	    var cancelar = function cancelar() {
	
	        if (props.operacion === 2) {
	            var data = [];
	            var _op = 6;
	            data.push({
	                codigo: txtCodigo.current.value,
	                descripcion: txtDescrip.current.value,
	                baseimponible: txtBase.current.value.trim().replace(/\./g, '').replace(',', '.'),
	                alicuota: txtAlicuota.current.value.trim().replace(/\./g, '').replace(',', '.'),
	                total: txtTotal.current.value.trim().replace(/\./g, '').replace(',', '.'),
	                fecha: txtFecha.current.value,
	                iva: txtIva.current.value,
	                totalf: txtCompromiso.current.value.trim().replace(/\./g, '').replace(',', '.'),
	                montoiva: txtMontoIva.current.value.trim().replace(/\./g, '').replace(',', '.')
	            });
	            props.inf(data, _op);
	            props.onHideCancelar();
	            blanquear();
	        } else {
	            props.onHideCancelar();
	            blanquear();
	        }
	    };
	
	    var blanquear = function blanquear() {
	        setActivate(false);
	        txtCodigo.current.value = '';
	        txtDescrip.current.value = '';
	        txtBase.current.value = '';
	        txtIva.current.value = '';
	        txtMontoIva.current.value = '';
	        txtCompromiso.current.value = '';
	        txtAlicuota.current.value = '';
	        txtTotal.current.value = '';
	        setDatati([]);
	        setActivo(null);
	        setTotals(0.00);
	        setDatos([]);
	    };
	
	    var handleInputNumChange = function handleInputNumChange(event) {
	        event.preventDefault();
	        (0, _varios.validaSoloNumero)(event);
	
	        if (event.which === 13 || typeof event.which === 'undefined') {
	
	            setDatos(Object.assign({}, datos, _defineProperty({}, event.target.name, event.target.value)));
	        } else if (event.which === 46) {
	            return false;
	        } else if (event.which >= 48 && event.which <= 57) {
	            return true;
	        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	            return true;
	        } else return false;
	    };
	
	    var onCalculo = function onCalculo(datos) {
	
	        var data = [];
	        var totaliv = 0.00;
	        var baseimpo = 0.00;
	        var miv = 0.00;
	        var ali = 0.00;
	        var iva = 0.00;
	        var totalfact = 0.00;
	        var totalr = 0.00;
	
	        if (datos.unidad !== 3) {
	
	            miv = txtMontoIva.current.value === '' ? '0.00' : txtMontoIva.current.value.trim().replace(/\./g, '').replace(',', '.');
	            ali = txtAlicuota.current.value === '' ? '0.00' : txtAlicuota.current.value.trim().replace(/\./g, '').replace(',', '.');
	            iva = txtIva.current.value === '' ? '0.00' : txtIva.current.value.trim().replace(/\./g, '').replace(',', '.');
	            totalfact = txtBase.current.value === '' ? '0.00' : txtBase.current.value.trim().replace(/\./g, '').replace(',', '.');
	        } else {
	
	            totalfact = props.monto;
	            baseimpo = props.monto;
	            iva = props.iva;
	            miv = props.montiva;
	            totaliv = txtTotal.current.value.trim().replace(/\./g, '').replace(',', '.');
	        }
	
	        if (datos.idtiporetencion === '1') {
	            totaliv = miv * ali / 100;
	            baseimpo = miv;
	
	            if (totaliv > baseimpo) {
	                setMensaje({
	                    mostrar: true,
	                    titulo: "Notificación",
	                    texto: "¡ El Monto Total no debe ser Mayor a la Base Imponible !",
	                    icono: "informacion"
	                });
	                txtCodigo.current.value = "";
	                txtDescrip.current.value = "";
	                txtAlicuota.current.value = "";
	                txtTotal.current.value = "";
	            } else {
	                txtTotal.current.value = (0, _varios.formatMoneda)(totaliv.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	            }
	        } else if (datos.tipo === 1) {
	            totaliv = totalfact * ali / 100;
	            baseimpo = totalfact;
	
	            if (totaliv > baseimpo) {
	                setMensaje({
	                    mostrar: true,
	                    titulo: "Notificación",
	                    texto: "¡ El Monto Total no debe ser Mayor a la Base Imponible !",
	                    icono: "informacion"
	                });
	                txtCodigo.current.value = "";
	                txtDescrip.current.value = "";
	                txtAlicuota.current.value = "";
	                txtTotal.current.value = "";
	            } else {
	                txtTotal.current.value = (0, _varios.formatMoneda)(totaliv.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	            }
	        } else if (datos.unidad === 4) {
	            totaliv = totalfact / ali;
	            baseimpo = totalfact;
	
	            if (totaliv > baseimpo) {
	                setMensaje({
	                    mostrar: true,
	                    titulo: "Notificación",
	                    texto: "¡ El Monto Total Retención no debe ser Mayor a la Base Imponible !",
	                    icono: "informacion"
	                });
	                txtCodigo.current.value = "";
	                txtDescrip.current.value = "";
	                txtAlicuota.current.value = "";
	                txtTotal.current.value = "";
	                setDatos([]);
	            } else {
	                txtTotal.current.value = (0, _varios.formatMoneda)(totaliv.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	            }
	        }
	
	        if (totaliv <= baseimpo) {
	            data.push({
	                codigo: datos.idtiporetencion,
	                descripcion: datos.descripcion,
	                baseimponible: baseimpo,
	                alicuota: ali,
	                total: totaliv,
	                fecha: txtFecha.current.value,
	                iva: iva,
	                totalf: totalfact,
	                montoiva: props.montiva,
	                unidad: datos.unidad
	            });
	            setDatos(data);
	            setDataf(data);
	            setTotals(totaliv);
	        }
	    };
	
	    var handleInputMontoChange = function handleInputMontoChange(event) {
	        (0, _varios.validaMonto)(event);
	        if (event.which === 13 || typeof event.which === 'undefined') {
	
	            if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
	                event.target.value = '0,00';
	            }
	            event.target.value = (0, _varios.formatoMonto)(event.target.value);
	            var char1 = event.target.value.substring(0, 1);
	            var char2 = event.target.value.substring(1, 2);
	            if (char1 === '0' && char2 !== ',') {
	                event.target.value = event.target.value.substring(1, event.target.value.legth);
	            }
	            if (event.which === 13) {
	                if (event.target.id === 'alicuota') {
	                    onCalculo(Datati);
	                    txtAlicuota.current.focus();
	                } else if (event.target.id === 'total') {
	                    onCalculo(Datati);
	                    setOperacion(1);
	                    btnAcepta.current.focus();
	                }
	            }
	        } else if (event.which === 46) {
	            return false;
	        } else if (event.which >= 48 && event.which <= 57) {
	            return true;
	        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	            return true;
	        } else return false;
	    };
	
	    var cerrarModal = function cerrarModal() {
	        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        props.onHideCancelar();
	        blanquear();
	    };
	
	    var datosFactura = function datosFactura() {
	        if ((0, _varios.round)(totals, 2) <= 0.00) {
	            setMensaje({
	                mostrar: true,
	                titulo: "Notificación",
	                texto: "¡ El Monto Total Retención no debe ser Menor o Igual a 0,00 !",
	                icono: "informacion"
	            });
	            txtCodigo.current.value = "";
	            txtDescrip.current.value = "";
	            txtAlicuota.current.value = "";
	            txtTotal.current.value = "";
	            setDatos([]);
	        } else {
	            props.onHideAceptaCatalogo(datos);
	            setActivo(0);
	        }
	    };
	
	    var onCatalogoCerrar = function onCatalogoCerrar() {
	        setMostrar(false);
	    };
	
	    var onCatalogoTipoRentas = function onCatalogoTipoRentas() {
	        setMostrar(true);
	    };
	
	    var onCatalogoTipoRentasData = function onCatalogoTipoRentasData(infor) {
	        setMostrar(false);
	
	        if (props.valiva === 'ND' && infor.idtiporetencion === '1') {
	            setMensaje({
	                mostrar: true,
	                titulo: "Notificación",
	                texto: "¡ Este Tipo de Retención (IVA) Solo puede ser Aplicada a Montos con IVA !",
	                icono: "informacion"
	            });
	            return;
	        } else {
	
	            txtCodigo.current.value = infor.idtiporetencion;
	            txtDescrip.current.value = infor.descripcion;
	            setDatati(infor);
	            if (infor.idtiporetencion === '1') {
	                var m = 75;
	                txtAlicuota.current.value = (0, _varios.formatMoneda)(m.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	                onCalculo(infor);
	            } else if (parseInt(infor.tipo) === 1) {
	                txtAlicuota.current.value = (0, _varios.formatMoneda)(infor.deducible.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	                onCalculo(infor);
	            } else if (parseInt(infor.unidad) === 3) {
	                setUni(3);
	                setActivo(1);
	                setOperacion(4);
	            } else if (parseInt(infor.unidad) === 4) {
	                txtAlicuota.current.value = (0, _varios.formatMoneda)(infor.otro.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	                onCalculo(infor);
	            }
	        }
	    };
	
	    var onChange = function onChange(e) {
	        if (e.target.name === "fecha") {
	            var _datos = [].concat(_toConsumableArray(dataf));
	            var data = [];
	            data.push({
	                codigo: _datos[0].codigo,
	                descripcion: _datos[0].descripcion,
	                baseimponible: _datos[0].baseimponible,
	                alicuota: _datos[0].alicuota,
	                total: _datos[0].total,
	                fecha: e.target.value,
	                iva: _datos[0].iva,
	                totalf: _datos[0].totalf,
	                montoiva: _datos[0].montoiva,
	                unidad: _datos[0].unidad
	            });
	            setDatos(data);
	        }
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'xl',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            style: { backgroundColor: "rgb(0,0,0,0.5)" },
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	
	                if (props.operacion === 1) {
	                    txtCodigo.current.focus();
	                    setValues(props.data);
	                    txtBase.current.value = (0, _varios.formatMoneda)(props.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	                    txtIva.current.value = (0, _varios.formatMoneda)(props.iva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	                    txtMontoIva.current.value = (0, _varios.formatMoneda)(props.montiva.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	                    txtCompromiso.current.value = (0, _varios.formatMoneda)(props.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	                    txtFecha.current.value = (0, _moment2.default)(fechaSistema).format('YYYY-MM-DD');
	                } else {
	                    txtCodigo.current.value = '';
	                    txtDescrip.current.value = '';
	                    txtBase.current.value = '';
	                    txtIva.current.value = '';
	                    txtMontoIva.current.value = '';
	                    txtCompromiso.current.value = '';
	                    txtAlicuota.current.value = '';
	                    txtTotal.current.value = '';
	                }
	            }
	
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant header-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'fw-bold text-light' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Incluir Retenciones'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { className: 'bg-transparent', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            null,
	            _react2.default.createElement(_catalogoTipoRetenciones2.default, {
	                show: mostrar,
	                onHideCancelar: onCatalogoCerrar,
	                onHideAceptaCatalogo: onCatalogoTipoRentasData
	            }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'container-fluid  rounded row mx-auto' },
	                _react2.default.createElement('div', { className: 'col-md-12 mx-auto' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 mb-2 mx-auto px-0' },
	                    _react2.default.createElement(
	                        'fieldset',
	                        { className: ' row col-sm-12 mx-auto border-azul rounded' },
	                        _react2.default.createElement(
	                            'legend',
	                            { className: 'float-none w-auto fw-bold', style: { fontSize: '15px' } },
	                            'Datos de la Retenci\xF3n'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 row m-0' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'input-group input-group-sm mb-2 col-md-2' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                    'C\xF3digo:'
	                                ),
	                                _react2.default.createElement('input', { type: 'text', ref: txtCodigo, name: 'codigo', id: 'codigo', className: 'form-control', onKeyUp: handleInputNumChange, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                                _react2.default.createElement(
	                                    'button',
	                                    { type: 'button', onClick: function onClick() {
	                                            return onCatalogoTipoRentas();
	                                        }, className: 'btn btn-sm btn-primary' },
	                                    _react2.default.createElement('i', { className: 'fas fa-search' })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'input-group input-group-sm mb-2 col-md-7' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                    'Descripci\xF3n:'
	                                ),
	                                _react2.default.createElement('input', { type: 'text', ref: txtDescrip, name: 'otros', id: 'otros', className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'input-group input-group-sm mb-2 col-md-3' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                    'Fecha de Retenci\xF3n:'
	                                ),
	                                _react2.default.createElement('input', { type: 'date', ref: txtFecha, name: 'fecha', onChange: onChange, className: 'form-control text-right', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'fieldset',
	                            { className: 'row col-sm-12 mx-auto border-azul rounded px-1' },
	                            activo !== 1 ? _react2.default.createElement(
	                                'div',
	                                { className: 'row m-0' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-3' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'input-group input-group-sm mb-2' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                            'Base Imponible:'
	                                        ),
	                                        _react2.default.createElement('input', { type: 'text', ref: txtBase, name: 'base', className: 'form-control text-right', disabled: true, placeholder: '0,00', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'input-group input-group-sm mb-2 col-md-9 mx-auto' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                            '% IVA:'
	                                        ),
	                                        _react2.default.createElement('input', { type: 'text', ref: txtIva, disabled: true, name: 'iva', id: 'iva', className: 'form-control text-center', onKeyUp: handleInputMontoChange, onBlur: handleInputMontoChange, placeholder: '0,00', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'input-group input-group-sm mb-2' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                            'Monto IVA:'
	                                        ),
	                                        _react2.default.createElement('input', { type: 'text', ref: txtMontoIva, name: 'totaliva', disabled: true, className: 'form-control text-right', placeholder: '0,00', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-3' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'input-group input-group-sm mb-2' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                            'Total Factura:'
	                                        ),
	                                        _react2.default.createElement('input', { type: 'text', ref: txtCompromiso, disabled: true, name: 'exento', id: 'exento', className: 'form-control text-right', onKeyUp: handleInputMontoChange, onBlur: handleInputMontoChange, placeholder: '0,00', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'input-group input-group-sm mb-2' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                            'Alicuota:'
	                                        ),
	                                        _react2.default.createElement('input', { type: 'text', ref: txtAlicuota, name: 'alicuota', id: 'alicuota', className: 'form-control text-right', onKeyUp: handleInputMontoChange, onBlur: handleInputMontoChange, placeholder: '0,00', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-3 ml-auto' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'input-group input-group-sm mb-2' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                            'Total Retenci\xF3n:'
	                                        ),
	                                        _react2.default.createElement('input', { type: 'text', ref: txtTotal, disabled: activo !== 1 ? true : false, name: 'exento', id: 'exento', className: 'form-control text-right', onKeyUp: handleInputMontoChange, onBlur: handleInputMontoChange, placeholder: '0,00', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                                    )
	                                )
	                            ) : _react2.default.createElement(
	                                'div',
	                                { className: 'row m-0' },
	                                _react2.default.createElement('input', { type: 'hidden', ref: txtBase, name: 'base' }),
	                                _react2.default.createElement('input', { type: 'hidden', ref: txtIva, name: 'iva' }),
	                                _react2.default.createElement('input', { type: 'hidden', ref: txtMontoIva, name: 'totaliva' }),
	                                _react2.default.createElement('input', { type: 'hidden', ref: txtCompromiso, name: 'exento' }),
	                                _react2.default.createElement('input', { type: 'hidden', ref: txtAlicuota, name: 'alicuota' }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-3 ml-auto' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'input-group input-group-sm mb-2' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                                            'Total Retenci\xF3n:'
	                                        ),
	                                        _react2.default.createElement('input', { type: 'text', ref: txtTotal, disabled: activo !== 1 ? true : false, name: 'total', id: 'total', onBlur: handleInputMontoChange, onKeyUp: handleInputMontoChange, className: 'form-control text-right', placeholder: '0,00', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { type: 'button', ref: btnAcepta, onClick: datosFactura, disabled: operacion === 4 ? true : false, style: { margin: '1px' }, className: ' btn btn-success btn-sm rounded-pill' },
	                _react2.default.createElement('i', { className: 'far fa-check-circle' }),
	                ' Aceptar'
	            ),
	            _react2.default.createElement(
	                'button',
	                { type: 'button', ref: btnCancela, onClick: cancelar, style: { margin: '1px' }, className: ' btn btn-sm btn-danger rounded-pill' },
	                _react2.default.createElement('i', { className: 'fas fa-window-close' }),
	                ' Cancelar'
	            )
	        ),
	        _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	            onHide: function onHide() {
	                mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	            } }),
	        _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	            onHideNo: function onHideNo() {
	                return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	            } })
	    );
	};

/***/ },
/* 7124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalPermisosUsuariosFinanzas = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTable = __webpack_require__(20);
	
	var _useTable2 = _interopRequireDefault(_useTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalPermisosUsuariosFinanzas = exports.ModalPermisosUsuariosFinanzas = function ModalPermisosUsuariosFinanzas(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
	  var idusuario = JSON.parse(sessionStorage.getItem("idusuario"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtLogin = (0, _react.useRef)();
	  var txtCedula = (0, _react.useRef)();
	  var txtStatus = (0, _react.useRef)();
	  var txtIduser = (0, _react.useRef)();
	
	  var txtuTodos = (0, _react.useRef)();
	  var txtuIncluir = (0, _react.useRef)();
	  var txtuModificar = (0, _react.useRef)();
	  var txtuCosultar = (0, _react.useRef)();
	  var txtuEliminar = (0, _react.useRef)();
	  var txtuImprimir = (0, _react.useRef)();
	
	  var txtdTodos = (0, _react.useRef)();
	  var txtdIncluir = (0, _react.useRef)();
	  var txtdModificar = (0, _react.useRef)();
	  var txtdCosultar = (0, _react.useRef)();
	  var txtdEliminar = (0, _react.useRef)();
	  var txtdImprimir = (0, _react.useRef)();
	
	  var txttTodos = (0, _react.useRef)();
	  var txttIncluir = (0, _react.useRef)();
	  var txttModificar = (0, _react.useRef)();
	  var txttCosultar = (0, _react.useRef)();
	  var txttEliminar = (0, _react.useRef)();
	  var txttImprimir = (0, _react.useRef)();
	
	  var txtcTodos = (0, _react.useRef)();
	  var txtcIncluir = (0, _react.useRef)();
	  var txtcModificar = (0, _react.useRef)();
	  var txtcCosultar = (0, _react.useRef)();
	  var txtcEliminar = (0, _react.useRef)();
	  var txtcImprimir = (0, _react.useRef)();
	
	  var txtcoTodos = (0, _react.useRef)();
	  var txtcoIncluir = (0, _react.useRef)();
	  var txtcoModificar = (0, _react.useRef)();
	  var txtcoCosultar = (0, _react.useRef)();
	  var txtcoEliminar = (0, _react.useRef)();
	  var txtcoImprimir = (0, _react.useRef)();
	
	  var txtsTodos = (0, _react.useRef)();
	  var txtsIncluir = (0, _react.useRef)();
	  var txtsModificar = (0, _react.useRef)();
	  var txtsCosultar = (0, _react.useRef)();
	  var txtsEliminar = (0, _react.useRef)();
	  var txtsImprimir = (0, _react.useRef)();
	
	  var txtsiTodos = (0, _react.useRef)();
	  var txtsiIncluir = (0, _react.useRef)();
	  var txtsiModificar = (0, _react.useRef)();
	  var txtsiCosultar = (0, _react.useRef)();
	  var txtsiEliminar = (0, _react.useRef)();
	  var txtsiImprimir = (0, _react.useRef)();
	
	  var txtoTodos = (0, _react.useRef)();
	  var txtoIncluir = (0, _react.useRef)();
	  var txtoModificar = (0, _react.useRef)();
	  var txtoCosultar = (0, _react.useRef)();
	  var txtoEliminar = (0, _react.useRef)();
	  var txtoImprimir = (0, _react.useRef)();
	
	  var txtnTodos = (0, _react.useRef)();
	  var txtnIncluir = (0, _react.useRef)();
	  var txtnModificar = (0, _react.useRef)();
	  var txtnCosultar = (0, _react.useRef)();
	  var txtnEliminar = (0, _react.useRef)();
	  var txtnImprimir = (0, _react.useRef)();
	
	  var txtdzTodos = (0, _react.useRef)();
	  var txtdzIncluir = (0, _react.useRef)();
	  var txtdzModificar = (0, _react.useRef)();
	  var txtdzCosultar = (0, _react.useRef)();
	  var txtdzEliminar = (0, _react.useRef)();
	  var txtdzImprimir = (0, _react.useRef)();
	
	  var txtocTodos = (0, _react.useRef)();
	  var txtocIncluir = (0, _react.useRef)();
	  var txtocModificar = (0, _react.useRef)();
	  var txtocCosultar = (0, _react.useRef)();
	  var txtocEliminar = (0, _react.useRef)();
	  var txtocImprimir = (0, _react.useRef)();
	
	  var txtReportTodos = (0, _react.useRef)();
	  var txtReport1 = (0, _react.useRef)();
	  var txtReport2 = (0, _react.useRef)();
	  var txtReport3 = (0, _react.useRef)();
	  var txtReport4 = (0, _react.useRef)();
	  var txtReport5 = (0, _react.useRef)();
	  var txtReport6 = (0, _react.useRef)();
	  var txtReport7 = (0, _react.useRef)();
	  var txtReport8 = (0, _react.useRef)();
	  var txtReport9 = (0, _react.useRef)();
	  var txtReport10 = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      modu1 = _useState2[0],
	      setModu1 = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      modu2 = _useState4[0],
	      setModu2 = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      modu3 = _useState6[0],
	      setModu3 = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      modu4 = _useState8[0],
	      setModu4 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      modu5 = _useState10[0],
	      setModu5 = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      modu6 = _useState12[0],
	      setModu6 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      modu7 = _useState14[0],
	      setModu7 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      modu8 = _useState16[0],
	      setModu8 = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      modu9 = _useState18[0],
	      setModu9 = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      modu10 = _useState20[0],
	      setModu10 = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      modu11 = _useState22[0],
	      setModu11 = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0),
	      _useState24 = _slicedToArray(_useState23, 2),
	      modu12 = _useState24[0],
	      setModu12 = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(),
	      _useState26 = _slicedToArray(_useState25, 2),
	      datos1 = _useState26[0],
	      setDatos1 = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(),
	      _useState28 = _slicedToArray(_useState27, 2),
	      datos2 = _useState28[0],
	      setDatos2 = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(),
	      _useState30 = _slicedToArray(_useState29, 2),
	      datos3 = _useState30[0],
	      setDatos3 = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(),
	      _useState32 = _slicedToArray(_useState31, 2),
	      datos4 = _useState32[0],
	      setDatos4 = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(),
	      _useState34 = _slicedToArray(_useState33, 2),
	      datos5 = _useState34[0],
	      setDatos5 = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(),
	      _useState36 = _slicedToArray(_useState35, 2),
	      datos6 = _useState36[0],
	      setDatos6 = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(),
	      _useState38 = _slicedToArray(_useState37, 2),
	      datos7 = _useState38[0],
	      setDatos7 = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(),
	      _useState40 = _slicedToArray(_useState39, 2),
	      datos8 = _useState40[0],
	      setDatos8 = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(),
	      _useState42 = _slicedToArray(_useState41, 2),
	      datos9 = _useState42[0],
	      setDatos9 = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(),
	      _useState44 = _slicedToArray(_useState43, 2),
	      datos10 = _useState44[0],
	      setDatos10 = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(),
	      _useState46 = _slicedToArray(_useState45, 2),
	      datos11 = _useState46[0],
	      setDatos11 = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(),
	      _useState48 = _slicedToArray(_useState47, 2),
	      datos12 = _useState48[0],
	      setDatos12 = _useState48[1];
	
	  var _useState49 = (0, _react.useState)({}),
	      _useState50 = _slicedToArray(_useState49, 2),
	      body = _useState50[0],
	      setBody = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(0),
	      _useState52 = _slicedToArray(_useState51, 2),
	      operacion = _useState52[0],
	      setOperacion = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(false),
	      _useState54 = _slicedToArray(_useState53, 2),
	      activate = _useState54[0],
	      setActivate = _useState54[1];
	
	  var _useState55 = (0, _react.useState)(true),
	      _useState56 = _slicedToArray(_useState55, 2),
	      habilitado = _useState56[0],
	      setHabilitado = _useState56[1];
	
	  var _useState57 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState58 = _slicedToArray(_useState57, 2),
	      mensaje = _useState58[0],
	      setMensaje = _useState58[1];
	
	  var _useState59 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState60 = _slicedToArray(_useState59, 2),
	      mensajesino = _useState60[0],
	      setMensajesino = _useState60[1];
	
	  var _useState61 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState62 = _slicedToArray(_useState61, 2),
	      botones = _useState62[0],
	      setBotones = _useState62[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var SelectUsuario = function SelectUsuario(idusuario) {
	    var endpoint = op.conexion + '/api/athos/usuario/getuser?id=' + idusuario;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.idusuario > 0) {
	
	          var para1 = response.data.accbtnbancos;
	          var para2 = response.data.accbtnbeneficiarios;
	          var para3 = response.data.accbtnctsbancarias;
	          var para4 = response.data.accbtnmvbancarios;
	          var para5 = response.data.accbtnmvbancariost;
	          var para6 = response.data.accbtncnciliabancaria;
	          var para7 = response.data.accbtncntxcobrar;
	          var para8 = response.data.accbtncntxpagar;
	          var para9 = response.data.accbtntipretenciones;
	          var reports = response.data.accbtnfreports;
	
	          sessionStorage.setItem("accbtnbancosc", JSON.stringify(para1));
	          sessionStorage.setItem("accbtnbeneficiariosc", JSON.stringify(para2));
	          sessionStorage.setItem("accbtnctsbancariasc", JSON.stringify(para3));
	          sessionStorage.setItem("accbtnmvbancariosc", JSON.stringify(para4));
	          sessionStorage.setItem("accbtnmvbancariostc", JSON.stringify(para5));
	          sessionStorage.setItem("accbtncnciliabancariac", JSON.stringify(para6));
	          sessionStorage.setItem("accbtncntxcobrarc", JSON.stringify(para7));
	          sessionStorage.setItem("accbtncntxpagarc", JSON.stringify(para8));
	          sessionStorage.setItem("accbtntipretencionesc", JSON.stringify(para9));
	          sessionStorage.setItem("accbtnfreportsc", JSON.stringify(reports));
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "Error al cargar el usuario",
	            icono: "informacion"
	          });
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var parameter1 = "";
	    var parameter2 = "";
	    var parameter3 = "";
	    var parameter4 = "";
	    var parameter5 = "";
	    var parameter6 = "";
	    var parameter7 = "";
	    var parameter8 = "";
	    var parameter9 = "";
	    var parameter10 = "";
	    var reportes = "";
	
	    if (props.usuario.accfinanzas.toString().substring(0, 1) === '1') {
	
	      var val1 = txtuIncluir.current.checked === true ? "1" : "0";
	      var val2 = txtuModificar.current.checked === true ? "1" : "0";
	      var val3 = txtuCosultar.current.checked === true ? "1" : "0";
	      var val4 = txtuEliminar.current.checked === true ? "1" : "0";
	      var val5 = txtuImprimir.current.checked === true ? "1" : "0";
	
	      parameter1 = val1 + val2 + val3 + val4 + val5;
	    } else {
	
	      parameter1 = '000000';
	    }
	
	    if (props.usuario.accfinanzas.toString().substring(1, 2) === '1') {
	
	      var _val = txtdIncluir.current.checked === true ? "1" : "0";
	      var _val2 = txtdModificar.current.checked === true ? "1" : "0";
	      var _val3 = txtdCosultar.current.checked === true ? "1" : "0";
	      var _val4 = txtdEliminar.current.checked === true ? "1" : "0";
	      var _val5 = txtdImprimir.current.checked === true ? "1" : "0";
	
	      parameter2 = _val + _val2 + _val3 + _val4 + _val5;
	    } else {
	
	      parameter2 = '000000';
	    }
	
	    if (props.usuario.accfinanzas.toString().substring(2, 3) === '1') {
	
	      var _val6 = txttIncluir.current.checked === true ? "1" : "0";
	      var _val7 = txttModificar.current.checked === true ? "1" : "0";
	      var _val8 = txttCosultar.current.checked === true ? "1" : "0";
	      var _val9 = txttEliminar.current.checked === true ? "1" : "0";
	      var _val10 = txttImprimir.current.checked === true ? "1" : "0";
	
	      parameter3 = _val6 + _val7 + _val8 + _val9 + _val10;
	    } else {
	
	      parameter3 = '000000';
	    }
	
	    if (props.usuario.accfinanzas.toString().substring(3, 4) === '1') {
	
	      var _val11 = txtcIncluir.current.checked === true ? "1" : "0";
	      var _val12 = txtcModificar.current.checked === true ? "1" : "0";
	      var _val13 = txtcCosultar.current.checked === true ? "1" : "0";
	      var _val14 = txtcEliminar.current.checked === true ? "1" : "0";
	      var _val15 = txtcImprimir.current.checked === true ? "1" : "0";
	
	      parameter4 = _val11 + _val12 + _val13 + _val14 + _val15;
	    } else {
	
	      parameter4 = '000000';
	    }
	
	    if (props.usuario.accfinanzas.toString().substring(4, 5) === '1') {
	
	      var _val16 = txtcoIncluir.current.checked === true ? "1" : "0";
	      var _val17 = txtcoModificar.current.checked === true ? "1" : "0";
	      var _val18 = txtcoCosultar.current.checked === true ? "1" : "0";
	      var _val19 = txtcoEliminar.current.checked === true ? "1" : "0";
	      var _val20 = txtcoImprimir.current.checked === true ? "1" : "0";
	
	      parameter5 = _val16 + _val17 + _val18 + _val19 + _val20;
	    } else {
	
	      parameter5 = '000000';
	    }
	
	    if (props.usuario.accfinanzas.toString().substring(5, 6) === '1') {
	
	      var _val21 = txtsIncluir.current.checked === true ? "1" : "0";
	      var _val22 = txtsModificar.current.checked === true ? "1" : "0";
	      var _val23 = txtsCosultar.current.checked === true ? "1" : "0";
	      var _val24 = txtsEliminar.current.checked === true ? "1" : "0";
	      var _val25 = txtsImprimir.current.checked === true ? "1" : "0";
	
	      parameter6 = _val21 + _val22 + _val23 + _val24 + _val25;
	    } else {
	
	      parameter6 = '000000';
	    }
	
	    if (props.usuario.accfinanzas.toString().substring(6, 7) === '1') {
	
	      var _val26 = txtsiIncluir.current.checked === true ? "1" : "0";
	      var _val27 = "0";
	      var _val28 = txtsiCosultar.current.checked === true ? "1" : "0";
	      var _val29 = "0";
	      var _val30 = txtsiImprimir.current.checked === true ? "1" : "0";
	
	      parameter7 = _val26 + _val28 + _val27 + _val29 + _val30;
	    } else {
	
	      parameter7 = '000000';
	    }
	
	    if (props.usuario.accfinanzas.toString().substring(7, 8) === '1') {
	
	      var _val31 = txtoIncluir.current.checked === true ? "1" : "0";
	      var _val32 = txtoModificar.current.checked === true ? "1" : "0";
	      var _val33 = txtoCosultar.current.checked === true ? "1" : "0";
	      var _val34 = txtoEliminar.current.checked === true ? "1" : "0";
	      var _val35 = txtoImprimir.current.checked === true ? "1" : "0";
	
	      parameter8 = _val31 + _val32 + _val33 + _val34 + _val35;
	    } else {
	
	      parameter8 = '000000';
	    }
	
	    if (props.usuario.accfinanzas.toString().substring(8, 9) === '1') {
	
	      var _val36 = txtnIncluir.current.checked === true ? "1" : "0";
	      var _val37 = txtnModificar.current.checked === true ? "1" : "0";
	      var _val38 = txtnCosultar.current.checked === true ? "1" : "0";
	      var _val39 = txtnEliminar.current.checked === true ? "1" : "0";
	      var _val40 = txtnImprimir.current.checked === true ? "1" : "0";
	
	      parameter9 = _val36 + _val37 + _val38 + _val39 + _val40;
	    } else {
	
	      parameter9 = '000000';
	    }
	
	    if (props.usuario.accfinanzas.toString().substring(10, 11) === '1') {
	
	      var _val41 = txtReport1.current.checked === true ? "1" : "0";
	      var _val42 = txtReport2.current.checked === true ? "1" : "0";
	      var _val43 = txtReport3.current.checked === true ? "1" : "0";
	      var _val44 = txtReport4.current.checked === true ? "1" : "0";
	      var _val45 = txtReport5.current.checked === true ? "1" : "0";
	      var val6 = txtReport6.current.checked === true ? "1" : "0";
	      var val7 = txtReport7.current.checked === true ? "1" : "0";
	      var val8 = txtReport8.current.checked === true ? "1" : "0";
	      var val9 = txtReport9.current.checked === true ? "1" : "0";
	      var val10 = txtReport10.current.checked === true ? "1" : "0";
	
	      reportes = _val41 + _val42 + _val43 + _val44 + _val45 + val6 + val7 + val8 + val9 + val10;
	    } else {
	
	      reportes = '0000000000';
	    }
	
	    var sigue = true;
	    var mensaje = "";
	
	    if (sigue) {
	      var user = [];
	      user.push({
	        idusuario: txtIduser.current.value,
	        login: txtLogin.current.value,
	        persona: txtCedula.current.value,
	        status: txtStatus.current.value === 'ACTIVO' ? 1 : 0,
	        idorganizacion: idorganizacion,
	        accbtnbancos: parameter1,
	        accbtnbeneficiarios: parameter2,
	        accbtnctsbancarias: parameter3,
	        accbtnmvbancarios: parameter4,
	        accbtnmvbancariost: parameter5,
	        accbtncnciliabancaria: parameter6,
	        accbtncntxcobrar: parameter7,
	        accbtncntxpagar: parameter8,
	        accbtntipretenciones: parameter9,
	        accbtnfreports: reportes
	      });
	
	      var _body = {
	        usu: JSON.stringify(user)
	      };
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	      setBody(_body);
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: mensaje,
	        icono: "informacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    var endpoint = op.conexion + '/api/athos/usuario/actualizar/' + operacion;
	
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setActivate(false);
	
	        if (parseInt(response.data.iduser) > 0) {
	          if (parseInt(response.data.iduser) === parseInt(idusuario)) {
	            SelectUsuario(parseInt(response.data.iduser));
	          }
	        }
	
	        var mensaje = "";
	        if (operacion === 1) {
	          mensaje = "El Usuario " + response.data.iduser + " ha sido registrada de manera satisfactoria.";
	        } else if (operacion === 2) {
	          mensaje = "El Usuario " + response.data.iduser + " ha sido Modificada de manera Satisfactoria.";
	        } else if (operacion === 3) {
	          mensaje = "El usuario " + response.data.iduser + " ha sido eliminada de manera satisfactoria.";
	        }
	
	        setMensaje({
	          mostrar: true,
	          titulo: "Exito.",
	          texto: mensaje,
	          icono: "exito"
	        });
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    procesarRegistro();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    props.onHideCancela();
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var checkBlank = function checkBlank(e) {
	
	    if (modu1 === 1) {
	      if (txtuIncluir.current.checked && txtuModificar.current.checked && txtuCosultar.current.checked && txtuEliminar.current.checked && txtuImprimir.current.checked) {
	        txtuTodos.current.checked = true;
	      } else {
	        txtuTodos.current.checked = false;
	      }
	    }
	
	    if (modu2 === 1) {
	      if (txtdIncluir.current.checked && txtdModificar.current.checked && txtdCosultar.current.checked && txtdEliminar.current.checked && txtdImprimir.current.checked) {
	        txtdTodos.current.checked = true;
	      } else {
	        txtdTodos.current.checked = false;
	      }
	    }
	
	    if (modu3 === 1) {
	      if (txttIncluir.current.checked && txttModificar.current.checked && txttCosultar.current.checked && txttEliminar.current.checked && txttImprimir.current.checked) {
	        txttTodos.current.checked = true;
	      } else {
	        txttTodos.current.checked = false;
	      }
	    }
	
	    if (modu4 === 1) {
	      if (txtcIncluir.current.checked && txtcModificar.current.checked && txtcCosultar.current.checked && txtcEliminar.current.checked && txtcImprimir.current.checked) {
	        txtcTodos.current.checked = true;
	      } else {
	        txtcTodos.current.checked = false;
	      }
	    }
	
	    if (modu5 === 1) {
	      if (txtcoIncluir.current.checked && txtcoModificar.current.checked && txtcoCosultar.current.checked && txtcoEliminar.current.checked && txtcoImprimir.current.checked) {
	        txtcoTodos.current.checked = true;
	      } else {
	        txtcoTodos.current.checked = false;
	      }
	    }
	
	    if (modu6 === 1) {
	      if (txtsIncluir.current.checked && txtsModificar.current.checked && txtsCosultar.current.checked && txtsEliminar.current.checked && txtsImprimir.current.checked) {
	        txtsTodos.current.checked = true;
	      } else {
	        txtsTodos.current.checked = false;
	      }
	    }
	
	    if (modu7 === 1) {
	      if (txtsiIncluir.current.checked && txtsiCosultar.current.checked && txtsiImprimir.current.checked) {
	        txtsiTodos.current.checked = true;
	      } else {
	        txtsiTodos.current.checked = false;
	      }
	    }
	
	    if (modu8 === 1) {
	      if (txtoIncluir.current.checked && txtoModificar.current.checked && txtoCosultar.current.checked && txtoEliminar.current.checked && txtoImprimir.current.checked) {
	        txtoTodos.current.checked = true;
	      } else {
	        txtoTodos.current.checked = false;
	      }
	    }
	
	    if (modu9 === 1) {
	      if (txtnIncluir.current.checked && txtnModificar.current.checked && txtnCosultar.current.checked && txtnEliminar.current.checked && txtnImprimir.current.checked) {
	        txtnTodos.current.checked = true;
	      } else {
	        txtnTodos.current.checked = false;
	      }
	    }
	
	    if (modu10 === 1) {
	      if (txtReport1.current.checked && txtReport2.current.checked && txtReport3.current.checked && txtReport4.current.checked && txtReport5.current.checked && txtReport6.current.checked && txtReport7.current.checked && txtReport8.current.checked && txtReport9.current.checked && txtReport10.current.checked) {
	        txtReportTodos.current.checked = true;
	      } else {
	        txtReportTodos.current.checked = false;
	      }
	    }
	  };
	
	  var checkTodo = function checkTodo(e) {
	    if (e.target.name === "todos1") {
	      if (txtuTodos.current.checked) {
	        txtuIncluir.current.checked = true;
	        txtuModificar.current.checked = true;
	        txtuCosultar.current.checked = true;
	        txtuEliminar.current.checked = true;
	        txtuImprimir.current.checked = true;
	      } else {
	        txtuIncluir.current.checked = false;
	        txtuModificar.current.checked = false;
	        txtuCosultar.current.checked = false;
	        txtuEliminar.current.checked = false;
	        txtuImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos2") {
	      if (txtdTodos.current.checked) {
	        txtdIncluir.current.checked = true;
	        txtdModificar.current.checked = true;
	        txtdCosultar.current.checked = true;
	        txtdEliminar.current.checked = true;
	        txtdImprimir.current.checked = true;
	      } else {
	        txtdIncluir.current.checked = false;
	        txtdModificar.current.checked = false;
	        txtdCosultar.current.checked = false;
	        txtdEliminar.current.checked = false;
	        txtdImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos3") {
	      if (txttTodos.current.checked) {
	        txttIncluir.current.checked = true;
	        txttModificar.current.checked = true;
	        txttCosultar.current.checked = true;
	        txttEliminar.current.checked = true;
	        txttImprimir.current.checked = true;
	      } else {
	        txttIncluir.current.checked = false;
	        txttModificar.current.checked = false;
	        txttCosultar.current.checked = false;
	        txttEliminar.current.checked = false;
	        txttImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos4") {
	      if (txtcTodos.current.checked) {
	        txtcIncluir.current.checked = true;
	        txtcModificar.current.checked = true;
	        txtcCosultar.current.checked = true;
	        txtcEliminar.current.checked = true;
	        txtcImprimir.current.checked = true;
	      } else {
	        txtcIncluir.current.checked = false;
	        txtcModificar.current.checked = false;
	        txtcCosultar.current.checked = false;
	        txtcEliminar.current.checked = false;
	        txtcImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos5") {
	      if (txtcoTodos.current.checked) {
	        txtcoIncluir.current.checked = true;
	        txtcoModificar.current.checked = true;
	        txtcoCosultar.current.checked = true;
	        txtcoEliminar.current.checked = true;
	        txtcoImprimir.current.checked = true;
	      } else {
	        txtcoIncluir.current.checked = false;
	        txtcoModificar.current.checked = false;
	        txtcoCosultar.current.checked = false;
	        txtcoEliminar.current.checked = false;
	        txtcoImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos6") {
	      if (txtsTodos.current.checked) {
	        txtsIncluir.current.checked = true;
	        txtsModificar.current.checked = true;
	        txtsCosultar.current.checked = true;
	        txtsEliminar.current.checked = true;
	        txtsImprimir.current.checked = true;
	      } else {
	        txtsIncluir.current.checked = false;
	        txtsModificar.current.checked = false;
	        txtsCosultar.current.checked = false;
	        txtsEliminar.current.checked = false;
	        txtsImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos7") {
	      if (txtsiTodos.current.checked) {
	        txtsiIncluir.current.checked = true;
	
	        txtsiCosultar.current.checked = true;
	
	        txtsiImprimir.current.checked = true;
	      } else {
	        txtsiIncluir.current.checked = false;
	
	        txtsiCosultar.current.checked = false;
	
	        txtsiImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos8") {
	      if (txtoTodos.current.checked) {
	        txtoIncluir.current.checked = true;
	        txtoModificar.current.checked = true;
	        txtoCosultar.current.checked = true;
	        txtoEliminar.current.checked = true;
	        txtoImprimir.current.checked = true;
	      } else {
	        txtoIncluir.current.checked = false;
	        txtoModificar.current.checked = false;
	        txtoCosultar.current.checked = false;
	        txtoEliminar.current.checked = false;
	        txtoImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos9") {
	      if (txtnTodos.current.checked) {
	        txtnIncluir.current.checked = true;
	        txtnModificar.current.checked = true;
	        txtnCosultar.current.checked = true;
	        txtnEliminar.current.checked = true;
	        txtnImprimir.current.checked = true;
	      } else {
	        txtnIncluir.current.checked = false;
	        txtnModificar.current.checked = false;
	        txtnCosultar.current.checked = false;
	        txtnEliminar.current.checked = false;
	        txtnImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todoslosreportes") {
	      if (txtReportTodos.current.checked) {
	        txtReport1.current.checked = true;
	        txtReport2.current.checked = true;
	        txtReport3.current.checked = true;
	        txtReport4.current.checked = true;
	        txtReport5.current.checked = true;
	        txtReport6.current.checked = true;
	        txtReport7.current.checked = true;
	        txtReport8.current.checked = true;
	        txtReport9.current.checked = true;
	        txtReport10.current.checked = true;
	      } else {
	        txtReport1.current.checked = false;
	        txtReport2.current.checked = false;
	        txtReport3.current.checked = false;
	        txtReport4.current.checked = false;
	        txtReport5.current.checked = false;
	        txtReport6.current.checked = false;
	        txtReport7.current.checked = false;
	        txtReport8.current.checked = false;
	        txtReport9.current.checked = false;
	        txtReport10.current.checked = false;
	      }
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'xl',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.op === 1) {
	          setOperacion(2);
	          if (props.usuario.accfinanzas.toString().substring(0, 1) === '1') {
	            setModu1(1);
	          } else {
	            setModu1(0);
	          }
	
	          if (props.usuario.accfinanzas.toString().substring(1, 2) === '1') {
	            setModu2(1);
	          } else {
	            setModu2(0);
	          }
	
	          if (props.usuario.accfinanzas.toString().substring(2, 3) === '1') {
	            setModu3(1);
	          } else {
	            setModu3(0);
	          }
	
	          if (props.usuario.accfinanzas.toString().substring(3, 4) === '1') {
	            setModu4(1);
	          } else {
	            setModu4(0);
	          }
	
	          if (props.usuario.accfinanzas.toString().substring(4, 5) === '1') {
	            setModu5(1);
	          } else {
	            setModu5(0);
	          }
	
	          if (props.usuario.accfinanzas.toString().substring(5, 6) === '1') {
	            setModu6(1);
	          } else {
	            setModu6(0);
	          }
	
	          if (props.usuario.accfinanzas.toString().substring(6, 7) === '1') {
	            setModu7(1);
	          } else {
	            setModu7(0);
	          }
	
	          if (props.usuario.accfinanzas.toString().substring(7, 8) === '1') {
	            setModu8(1);
	          } else {
	            setModu8(0);
	          }
	
	          if (props.usuario.accfinanzas.toString().substring(8, 9) === '1') {
	            setModu9(1);
	          } else {
	            setModu9(0);
	          }
	
	          if (props.usuario.accfinanzas.toString().substring(10, 11) === '1') {
	            setModu10(1);
	          } else {
	            setModu10(0);
	          }
	
	          setHabilitado(false);
	        } else {
	          setHabilitado(true);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Permisos de Usuario (Finanzas)'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto m-0' },
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1 d-flex justify-content-around', style: { fontSizeAdjust: '0.6' } },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-6 fw-bold' },
	              'Datos del Usuarios'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-200 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'USUARIO:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtLogin, defaultValue: props.usuario && props.usuario.login, className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement('input', { type: 'hidden', ref: txtIduser, defaultValue: props.usuario && props.usuario.idusuario }),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-180 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'CEDULA:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtCedula, defaultValue: props.persona && props.persona.cedula, className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-500 px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'NOMBRES Y APELLIDOS:'
	                ),
	                _react2.default.createElement('input', { type: 'text', defaultValue: props.persona && props.persona.nombres.trim() + " " + props.persona.apellidos.trim(), className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-170 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'ESTATUS:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtStatus, defaultValue: props.usuario && props.usuario.status === '1' ? 'ACTIVO' : 'INACTIVO', className: 'form-control text-uppercase fs-6 text-center', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-5 fw-bold' },
	              'Modulos Autorizados'
	            ),
	            modu1 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Bancos'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuTodos,
	                          defaultChecked: props.usuario.accbtnbancos.substring(0, 1) === '1' && props.usuario.accbtnbancos.substring(1, 2) === '1' && props.usuario.accbtnbancos.substring(2, 3) === '1' && props.usuario.accbtnbancos.substring(3, 4) === '1' && props.usuario.accbtnbancos.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos1', id: 'inlineCheckboxu' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuIncluir, defaultChecked: props.usuario.accbtnbancos.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuModificar, defaultChecked: props.usuario.accbtnbancos.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuCosultar, defaultChecked: props.usuario.accbtnbancos.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuEliminar, defaultChecked: props.usuario.accbtnbancos.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuImprimir, defaultChecked: props.usuario.accbtnbancos.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu2 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Beneficiarios'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdTodos,
	                          defaultChecked: props.usuario.accbtnbeneficiarios.substring(0, 1) === '1' && props.usuario.accbtnbeneficiarios.substring(1, 2) === '1' && props.usuario.accbtnbeneficiarios.substring(2, 3) === '1' && props.usuario.accbtnbeneficiarios.substring(3, 4) === '1' && props.usuario.accbtnbeneficiarios.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos2', id: 'inlineCheckboxd' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdIncluir, defaultChecked: props.usuario.accbtnbeneficiarios.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdModificar, defaultChecked: props.usuario.accbtnbeneficiarios.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdCosultar, defaultChecked: props.usuario.accbtnbeneficiarios.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdEliminar, defaultChecked: props.usuario.accbtnbeneficiarios.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdImprimir, defaultChecked: props.usuario.accbtnbeneficiarios.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu3 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Cuentas Bancarias'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttTodos,
	                          defaultChecked: props.usuario.accbtnctsbancarias.substring(0, 1) === '1' && props.usuario.accbtnctsbancarias.substring(1, 2) === '1' && props.usuario.accbtnctsbancarias.substring(2, 3) === '1' && props.usuario.accbtnctsbancarias.substring(3, 4) === '1' && props.usuario.accbtnctsbancarias.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos3', id: 'inlineCheckboxt' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttIncluir, defaultChecked: props.usuario.accbtnctsbancarias.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttModificar, defaultChecked: props.usuario.accbtnctsbancarias.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttCosultar, defaultChecked: props.usuario.accbtnctsbancarias.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttEliminar, defaultChecked: props.usuario.accbtnctsbancarias.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttImprimir, defaultChecked: props.usuario.accbtnctsbancarias.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu4 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Movimientos Bancarios'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcTodos,
	                          defaultChecked: props.usuario.accbtnmvbancarios.substring(0, 1) === '1' && props.usuario.accbtnmvbancarios.substring(1, 2) === '1' && props.usuario.accbtnmvbancarios.substring(2, 3) === '1' && props.usuario.accbtnmvbancarios.substring(3, 4) === '1' && props.usuario.accbtnmvbancarios.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos4', id: 'inlineCheckboxc' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcIncluir, defaultChecked: props.usuario.accbtnmvbancarios.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcModificar, defaultChecked: props.usuario.accbtnmvbancarios.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcCosultar, defaultChecked: props.usuario.accbtnmvbancarios.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcEliminar, defaultChecked: props.usuario.accbtnmvbancarios.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcImprimir, defaultChecked: props.usuario.accbtnmvbancarios.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu5 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Movimientos en Transito'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcoTodos,
	                          defaultChecked: props.usuario.accbtnmvbancariost.substring(0, 1) === '1' && props.usuario.accbtnmvbancariost.substring(1, 2) === '1' && props.usuario.accbtnmvbancariost.substring(2, 3) === '1' && props.usuario.accbtnmvbancariost.substring(3, 4) === '1' && props.usuario.accbtnmvbancariost.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos5', id: 'inlineCheckboxco' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxco' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcoIncluir, defaultChecked: props.usuario.accbtnmvbancariost.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxco1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxco1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcoModificar, defaultChecked: props.usuario.accbtnmvbancariost.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxco2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxco2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcoCosultar, defaultChecked: props.usuario.accbtnmvbancariost.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxco3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxco3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcoEliminar, defaultChecked: props.usuario.accbtnmvbancariost.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxco4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxco4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcoImprimir, defaultChecked: props.usuario.accbtnmvbancariost.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxco5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxco5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu6 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Conciliaci\xF3n Bancaria'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsTodos,
	                          defaultChecked: props.usuario.accbtncnciliabancaria.substring(0, 1) === '1' && props.usuario.accbtncnciliabancaria.substring(1, 2) === '1' && props.usuario.accbtncnciliabancaria.substring(2, 3) === '1' && props.usuario.accbtncnciliabancaria.substring(3, 4) === '1' && props.usuario.accbtncnciliabancaria.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos6', id: 'inlineCheckboxs' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxs' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsIncluir, defaultChecked: props.usuario.accbtncnciliabancaria.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxs1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxs1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsModificar, defaultChecked: props.usuario.accbtncnciliabancaria.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxs2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxs2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsCosultar, defaultChecked: props.usuario.accbtncnciliabancaria.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxs3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxs3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsEliminar, defaultChecked: props.usuario.accbtncnciliabancaria.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxs4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxs4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsImprimir, defaultChecked: props.usuario.accbtncnciliabancaria.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxs5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxs5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu7 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Cuentas por Cobrar'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsiTodos,
	                          defaultChecked: props.usuario.accbtncntxcobrar.substring(0, 1) === '1' && props.usuario.accbtncntxcobrar.substring(1, 2) === '1' && props.usuario.accbtncntxcobrar.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos7', id: 'inlineCheckboxsi' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsi' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsiIncluir, defaultChecked: props.usuario.accbtncntxcobrar.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxsi1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsi1' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsiCosultar, defaultChecked: props.usuario.accbtncntxcobrar.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxsi3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsi3' },
	                          'REGISTRAR PAGO'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsiImprimir, defaultChecked: props.usuario.accbtncntxcobrar.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxsi5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsi5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu8 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Cuentas por Pagar'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtoTodos,
	                          defaultChecked: props.usuario.accbtnopinventario.substring(0, 1) === '1' && props.usuario.accbtnopinventario.substring(1, 2) === '1' && props.usuario.accbtnopinventario.substring(2, 3) === '1' && props.usuario.accbtnopinventario.substring(3, 4) === '1' && props.usuario.accbtnopinventario.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos8', id: 'inlineCheckboxo' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxo' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtoIncluir, defaultChecked: props.usuario.accbtnopinventario.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxo1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxo1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtoModificar, defaultChecked: props.usuario.accbtnopinventario.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxo2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxo2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtoCosultar, defaultChecked: props.usuario.accbtnopinventario.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxo3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxo3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtoEliminar, defaultChecked: props.usuario.accbtnopinventario.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxo4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxo4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtoImprimir, defaultChecked: props.usuario.accbtnopinventario.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxo5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxo5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu9 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Tipo de Retenciones'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtnTodos,
	                          defaultChecked: props.usuario.accbtntipretenciones.substring(0, 1) === '1' && props.usuario.accbtntipretenciones.substring(1, 2) === '1' && props.usuario.accbtntipretenciones.substring(2, 3) === '1' && props.usuario.accbtntipretenciones.substring(3, 4) === '1' && props.usuario.accbtntipretenciones.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos9', id: 'inlineCheckboxn' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxn' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtnIncluir, defaultChecked: props.usuario.accbtntipretenciones.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxn1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxn1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtnModificar, defaultChecked: props.usuario.accbtntipretenciones.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxn2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxn2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtnCosultar, defaultChecked: props.usuario.accbtntipretenciones.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxn3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxn3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtnEliminar, defaultChecked: props.usuario.accbtntipretenciones.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxn4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxn4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtnImprimir, defaultChecked: props.usuario.accbtntipretenciones.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxn5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxn5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu10 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Reportes'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReportTodos,
	                          defaultChecked: props.usuario.accbtnfreports.substring(0, 1) === '1' && props.usuario.accbtnfreports.substring(1, 2) === '1' && props.usuario.accbtnfreports.substring(2, 3) === '1' && props.usuario.accbtnfreports.substring(3, 4) === '1' && props.usuario.accbtnfreports.substring(4, 5) === '1' && props.usuario.accbtnfreports.substring(5, 6) === '1' && props.usuario.accbtnfreports.substring(6, 7) === '1' && props.usuario.accbtnfreports.substring(7, 8) === '1' && props.usuario.accbtnfreports.substring(8, 9) === '1' && props.usuario.accbtnfreports.substring(9, 10) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todoslosreportes', id: 'inlineCheckboxr' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport1, defaultChecked: props.usuario.accbtnfreports.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr1' },
	                          'REPORTE DE ESTADOS DE CUENTA'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport2, defaultChecked: props.usuario.accbtnfreports.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr2' },
	                          'REPORTE DE CUENTAS POR COBRAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport3, defaultChecked: props.usuario.accbtnfreports.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr3' },
	                          'IMPRIMIR RECIBOS DE PAGO'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport4, defaultChecked: props.usuario.accbtnfreports.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr4' },
	                          'IMPRIMIR ANTICIPOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport8, defaultChecked: props.usuario.accbtnfreports.substring(7, 8) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr8' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr8' },
	                          'REPORTE ANTICIPOS POR VENDEDOR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport5, defaultChecked: props.usuario.accbtnfreports.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr5' },
	                          'LIBRO AUXILIAR DE BANCO'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport6, defaultChecked: props.usuario.accbtnfreports.substring(5, 6) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr6' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr6' },
	                          'REPORTE DE INGRESOS'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport7, defaultChecked: props.usuario.accbtnfreports.substring(6, 7) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr7' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr7' },
	                          'REPORTE LIBRO DE VENTAS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport9, defaultChecked: props.usuario.accbtnfreports.substring(8, 9) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr9' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr9' },
	                          'REPORTE GENERAL DEUDAS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport10, defaultChecked: props.usuario.accbtnfreports.substring(9, 10) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr10' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr10' },
	                          'REPORTE PAGOS REVERSADOS'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : ''
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-4 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: props.usuario && props.usuario.status === '0' ? true : false, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-success' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check-circle' },
	              '  Aceptar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProcesosMontosCompras = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _catalogoNotadeCredito = __webpack_require__(157);
	
	var _catalogoNotadeCredito2 = _interopRequireDefault(_catalogoNotadeCredito);
	
	var _catalogoAnticipos = __webpack_require__(122);
	
	var _catalogoAnticipos2 = _interopRequireDefault(_catalogoAnticipos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProcesosMontosCompras = exports.ProcesosMontosCompras = function ProcesosMontosCompras(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var headCells = [{ label: 'FORMA DE PAGO', textAlign: 'center' }, { label: 'MONTO', textAlign: 'center' }, { label: 'MONTO AL CAMBIO', textAlign: 'center' }];
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtTotalenCuenta = (0, _react.useRef)();
	  var txtPorFechas = (0, _react.useRef)();
	  var txtTodosDispo = (0, _react.useRef)();
	  var txtCanceladas = (0, _react.useRef)();
	  var txtMonto = (0, _react.useRef)();
	  var txtNumCredito = (0, _react.useRef)();
	  var txtReferencia = (0, _react.useRef)();
	  var txtFechaPago = (0, _react.useRef)();
	  var txtMoneda = (0, _react.useRef)();
	  var txtBanco = (0, _react.useRef)();
	  var txtDesde = (0, _react.useRef)();
	  var txtHasta = (0, _react.useRef)();
	  var txtCbmrif = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      inputalmacen = _useState2[0],
	      setInputalmacen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      inputproducto = _useState4[0],
	      setInputproducto = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      tiporif = _useState6[0],
	      setTipofic = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0.00),
	      _useState8 = _slicedToArray(_useState7, 2),
	      valormon = _useState8[0],
	      setValormon = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mostrar1 = _useState10[0],
	      setMostrar1 = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(null),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mostrar2 = _useState12[0],
	      setMostrar2 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(''),
	      _useState14 = _slicedToArray(_useState13, 2),
	      parafecha = _useState14[0],
	      setParafecha = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(''),
	      _useState16 = _slicedToArray(_useState15, 2),
	      desde = _useState16[0],
	      setDesde = _useState16[1];
	
	  var _useState17 = (0, _react.useState)([]),
	      _useState18 = _slicedToArray(_useState17, 2),
	      banco = _useState18[0],
	      setBanco = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(''),
	      _useState20 = _slicedToArray(_useState19, 2),
	      disponiblec = _useState20[0],
	      setDisponiblec = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(''),
	      _useState22 = _slicedToArray(_useState21, 2),
	      numnota = _useState22[0],
	      setNumNota = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(''),
	      _useState24 = _slicedToArray(_useState23, 2),
	      idclient = _useState24[0],
	      setIdclient = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(null),
	      _useState26 = _slicedToArray(_useState25, 2),
	      simbol = _useState26[0],
	      setSimbol = _useState26[1];
	
	  var _useState27 = (0, _react.useState)([]),
	      _useState28 = _slicedToArray(_useState27, 2),
	      combomoneda = _useState28[0],
	      setComboMoneda = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      activate = _useState30[0],
	      setActivate = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(0),
	      _useState32 = _slicedToArray(_useState31, 2),
	      idmoney = _useState32[0],
	      setIdmoney = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(0.00),
	      _useState34 = _slicedToArray(_useState33, 2),
	      valormoney = _useState34[0],
	      setValormoney = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(0),
	      _useState36 = _slicedToArray(_useState35, 2),
	      valida = _useState36[0],
	      setValida = _useState36[1];
	
	  var _useState37 = (0, _react.useState)({ fn: function fn(items) {
	      return items;
	    } }),
	      _useState38 = _slicedToArray(_useState37, 2),
	      filterFn = _useState38[0],
	      setFilterFn = _useState38[1];
	
	  var _useState39 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState40 = _slicedToArray(_useState39, 2),
	      mensaje = _useState40[0],
	      setMensaje = _useState40[1];
	
	  var _useState41 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState42 = _slicedToArray(_useState41, 2),
	      mensajesino = _useState42[0],
	      setMensajesino = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(''),
	      _useState44 = _slicedToArray(_useState43, 2),
	      tituid = _useState44[0],
	      setTituid = _useState44[1];
	
	  var _useState45 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState46 = _slicedToArray(_useState45, 2),
	      botones = _useState46[0],
	      setBotones = _useState46[1];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells, filterFn),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setInputalmacen(0);
	    setParafecha('');
	    setDisponiblec('');
	    setNumNota('');
	    setInputproducto(0);
	    setValida(0);
	    setIdclient('');
	    setIdmoney(0);
	    setSimbol(null);
	    setMostrar1(false);
	    setMostrar2(false);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope === 1) {
	
	      if (txtFechaPago.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Fechas de Pago !', icono: 'informacion' });
	        txtFechaPago.current.focus();
	        sigue = false;
	      } else if (txtMonto.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Monto!', icono: 'informacion' });
	        txtMonto.current.focus();
	        sigue = false;
	      } else if (sigue === true) {
	
	        Ejecutar();
	      }
	    } else if (props.ope === 2 || props.ope === 3 || props.ope === 4 || props.ope === 5 || props.ope === 6) {
	      if (txtFechaPago.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Fechas de Pago !', icono: 'informacion' });
	        txtFechaPago.current.focus();
	        sigue = false;
	      } else if (txtReferencia.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el N° de Referencia!', icono: 'informacion' });
	        txtReferencia.current.focus();
	        sigue = false;
	      } else if (txtMonto.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Monto!', icono: 'informacion' });
	        txtMonto.current.focus();
	        sigue = false;
	      } else if (sigue === true) {
	
	        Ejecutar();
	      }
	    } else if (props.ope === 7) {
	      if (txtFechaPago.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Fechas de Pago !', icono: 'informacion' });
	        txtFechaPago.current.focus();
	        sigue = false;
	      } else if (txtMoneda.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione el Tipo de Moneda !', icono: 'informacion' });
	        txtMoneda.current.focus();
	        sigue = false;
	      } else if (txtMonto.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Monto!', icono: 'informacion' });
	        txtMonto.current.focus();
	        sigue = false;
	      } else if (sigue === true) {
	
	        Ejecutar();
	      }
	    } else if (props.ope === 8 || props.ope === 9) {
	      if (txtFechaPago.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Fechas de Pago !', icono: 'informacion' });
	        txtFechaPago.current.focus();
	        sigue = false;
	      } else if (txtNumCredito.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ El Campo Crédito no debe ir Vacio !', icono: 'informacion' });
	        txtNumCredito.current.focus();
	        sigue = false;
	      } else if (txtMonto.current.value === '') {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Monto!', icono: 'informacion' });
	        txtMonto.current.focus();
	        sigue = false;
	      } else if (sigue === true) {
	
	        Ejecutar();
	      }
	    }
	  };
	
	  var Ejecutar = function Ejecutar() {
	
	    var valorm = props.ope === 7 ? txtMoneda.current.value : props.ope === 8 || props.ope === 9 ? idmoney.toString() : idmoney.toString();
	
	    var i = combomoneda.filter(function (moneda) {
	      return moneda.idmoneda === valorm;
	    });
	
	    var datos = [];
	
	    datos.push({
	      fecha: txtFechaPago.current.value,
	      monto: txtMonto.current.value.replace(/\./g, '').replace(',', '.'),
	      formapago: valida,
	      referencia: valida === 1 || valida === 7 || valida === 8 || valida === 9 ? '' : txtReferencia.current.value.trim(),
	      tipodivisa: i[0].idmoneda,
	      simbolo: i[0].simbolo,
	      notacredito: valida === 8 || valida === 9 ? numnota : '',
	      idbanco: valida === 2 || valida === 3 || valida === 4 || valida === 5 || valida === 6 ? txtBanco.current.value : 0,
	      valormoneda: i[0].valormoneda
	    });
	    props.onHideAceptaData(datos);
	    cancelar();
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var validarCantidad = function validarCantidad(event) {
	    (0, _varios.validaMonto)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	        event.target.value = "0,00";
	      }
	      event.target.value = (0, _varios.formatoMonto)(event.target.value);
	      var char1 = event.target.value.substring(0, 1);
	      var char2 = event.target.value.substring(1, 2);
	      if (char1 === "0" && char2 !== ",") {
	        event.target.value = event.target.value.substring(1, event.target.value.length);
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var handleAceptaDatos = function handleAceptaDatos(values) {
	    setMostrar1(false);
	
	    var limpia = 0;
	
	    if (props.data.length > '') {
	
	      for (var i = 0; i < props.data.length; i++) {
	
	        if (props.data[i].notacredito === values.numnotaentrega) {
	          limpia = 7;
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡Esta Nota de Credito ya Fue Seleccionada!', icono: 'error' });
	        } else {
	          txtNumCredito.current.value = values.numnotaentrega;
	          txtMonto.current.value = (0, _varios.formatMoneda)(values.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	          setNumNota(values.numnotaentrega);
	        }
	      }
	
	      if (limpia === 7) {
	        txtNumCredito.current.value = '';
	        txtMonto.current.value = '0,00';
	        setNumNota('');
	      }
	    } else {
	      txtNumCredito.current.value = values.numnotaentrega;
	      txtMonto.current.value = (0, _varios.formatMoneda)(values.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	      setNumNota(values.numnotaentrega);
	      limpia = 1;
	    }
	  };
	
	  var handleAceptaDatosAnticipos = function handleAceptaDatosAnticipos(values) {
	    setMostrar2(false);
	
	    var limpia = 0;
	
	    if (props.data.length > '') {
	
	      for (var i = 0; i < props.data.length; i++) {
	
	        if (props.data[i].notacredito === values.numpago) {
	          limpia = 7;
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡Este Anticipo ya Fue Seleccionada!', icono: 'error' });
	        } else {
	          txtNumCredito.current.value = values.numpago;
	          txtMonto.current.value = (0, _varios.formatMoneda)(values.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	          setNumNota(values.numpago);
	        }
	      }
	
	      if (limpia === 7) {
	        txtNumCredito.current.value = '';
	        txtMonto.current.value = '0,00';
	        setNumNota('');
	      }
	    } else {
	      txtNumCredito.current.value = values.numpago;
	      txtMonto.current.value = (0, _varios.formatMoneda)(values.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	      setNumNota(values.numpago);
	      limpia = 1;
	    }
	  };
	
	  var seleccionarMonedas = function seleccionarMonedas(ope) {
	    var campos = "*";
	    var nomtab = "moneda";
	    var orden = "idmoneda";
	
	    var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	
	          var data = [];
	          var idmone = 1;
	
	          for (var i = 0; i < response.data.length; i++) {
	
	            if (ope === 7) {
	              if (response.data[i].predeterminada !== true) {
	
	                idmone = response.data[i].idmoneda;
	
	                data.push({
	                  descripcion: response.data[i].descripcion,
	                  idmoneda: response.data[i].idmoneda,
	                  predeterminada: response.data[i].predeterminada,
	                  simbolo: response.data[i].simbolo,
	                  subpredeterminada: response.data[i].subpredeterminada,
	                  valormoneda: response.data[i].valormoneda
	                });
	              }
	            } else if (ope === 8 || ope === 9) {
	
	              if (response.data[i].subpredeterminada === true) {
	
	                idmone = response.data[i].idmoneda;
	
	                data.push({
	                  descripcion: response.data[i].descripcion,
	                  idmoneda: response.data[i].idmoneda,
	                  predeterminada: response.data[i].predeterminada,
	                  simbolo: response.data[i].simbolo,
	                  subpredeterminada: response.data[i].subpredeterminada,
	                  valormoneda: response.data[i].valormoneda
	                });
	              }
	            } else {
	              if (response.data[i].predeterminada !== false) {
	
	                idmone = response.data[i].idmoneda;
	
	                data.push({
	                  descripcion: response.data[i].descripcion,
	                  idmoneda: response.data[i].idmoneda,
	                  predeterminada: response.data[i].predeterminada,
	                  simbolo: response.data[i].simbolo,
	                  subpredeterminada: response.data[i].subpredeterminada,
	                  valormoneda: response.data[i].valormoneda
	                });
	              }
	            }
	          }
	          setComboMoneda(data);
	          setIdmoney(idmone);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChangeMoneda = function onChangeMoneda(e) {
	    var i = combomoneda.filter(function (moneda) {
	      return moneda.idmoneda === e.target.value;
	    });
	
	    if (props.ope === 7) {
	      setIdmoney(e.target.value);
	      setSimbol(i[0].simbolo);
	      setValormoney(i[0].valormoneda);
	    }
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === 'banco') {
	      var data = banco.filter(function (bancoc) {
	        return bancoc.idcuentabancaria === e.target.value;
	      });
	      txtTotalenCuenta.current.value = (0, _varios.formatMoneda)(data[0].saldolib.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	    }
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	
	    var campos = '*';
	    var nomtab = 'cuentabancaria';
	    var orden = 'idcuentabancaria';
	
	    var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setBanco(response.data);
	          var totalcuenta = 0.00;
	
	          for (var i = 0; i < response.data.length; i++) {
	
	            if (response.data[i].idcuentabancaria === txtBanco.current.value) {
	              totalcuenta = response.data[i].saldolib;
	            }
	          }
	          txtTotalenCuenta.current.value = (0, _varios.formatMoneda)(totalcuenta.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	        }
	      }
	    }).catch(function (error) {
	
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: props.ope === 2 || props.ope === 3 || props.ope === 4 || props.ope === 5 || props.ope === 6 ? "md" : "sm",
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.ope === 1) {
	          setValida(1);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 2) {
	          seleccionarRegistros();
	          setValida(2);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 3) {
	          seleccionarRegistros();
	          setValida(3);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 4) {
	          seleccionarRegistros();
	          setValida(4);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 5) {
	          seleccionarRegistros();
	          setValida(5);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 6) {
	          seleccionarRegistros();
	          setValida(6);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 7) {
	          setValida(7);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 8) {
	          setValida(8);
	          seleccionarMonedas(props.ope);
	        } else if (props.ope === 9) {
	          setValida(9);
	          seleccionarMonedas(props.ope);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          props.ope === 1 ? 'Pago - (Eféctivo)' : props.ope === 2 ? 'Pago - (Tarjeta de Débito)' : props.ope === 3 ? 'Pago - (Tarjera de Crédito)' : props.ope === 4 ? 'Pago - (Movil)' : props.ope === 6 ? 'Pago - (Depósito Bancario)' : props.ope === 5 ? 'Pago - (Transferencia Bancaria)' : props.ope === 7 ? 'Pago - (Divisas)' : props.ope === 8 ? 'Pago - (Saldo a Crédito)' : 'Pago - (Anticipo)'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto m-0 border-azul px-1' },
	          valida === 1 ? _react2.default.createElement(
	            'div',
	            { className: 'col-12 row m-0 px-0 py-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mb-1 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'FECHA DE PAGO:'
	                ),
	                _react2.default.createElement('input', { type: 'date', ref: txtFechaPago, disabled: props.ope === 0 ? true : false, defaultValue: (0, _moment2.default)(fechasistema).format('YYYY-MM-DD'), name: 'fecha', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'MONTO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: props.ope === 0 ? true : false, ref: txtMonto, placeholder: '0,00', onKeyUp: validarCantidad, onBlur: validarCantidad, className: 'form-control bg-transparent fs-6 text-right', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ) : '',
	          valida === 2 || valida === 3 || valida === 4 || valida === 5 || valida === 6 ? _react2.default.createElement(
	            'div',
	            { className: 'col-12 row m-0 px-0 py-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-250 px-0 mb-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'FECHA DE PAGO:'
	                ),
	                _react2.default.createElement('input', { type: 'date', ref: txtFechaPago, disabled: props.ope === 0 ? true : false, defaultValue: (0, _moment2.default)(fechasistema).format('YYYY-MM-DD'), name: 'fecha', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-200 px-0 ml-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'SALDO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: true, ref: txtTotalenCuenta, placeholder: '0,00', onKeyUp: validarCantidad, onBlur: validarCantidad, className: 'form-control bg-transparent fs-6 text-right', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'colfull col-pd-500 mb-1 px-0 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  {
	                    className: 'input-group-text',
	                    id: 'inputGroup-sizing-sm'
	                  },
	                  'BANCO:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  {
	                    className: 'form-control form-control-sm fs-6 px-1 fw-bold form-select',
	                    disabled: props.ope === 0 ? true : false,
	                    ref: txtBanco,
	                    onChange: onChange,
	                    name: 'banco'
	                  },
	                  banco && banco.map(function (item, index) {
	                    return _react2.default.createElement(
	                      'option',
	                      { key: index, value: item.idcuentabancaria },
	                      " ",
	                      item.nombre + ' --- ' + item.cuentabancaria,
	                      " "
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-500 px-0 mb-1 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'N\xB0 DE REFERANCIA:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtReferencia, disabled: props.ope === 0 ? true : false, name: 'fecha', className: 'form-control fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'MONTO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: props.ope === 0 ? true : false, ref: txtMonto, placeholder: '0,00', onKeyUp: validarCantidad, onBlur: validarCantidad, className: 'form-control bg-transparent fs-6 text-right', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ) : '',
	          valida === 7 ? _react2.default.createElement(
	            'div',
	            { className: 'col-12 row m-0 px-0 py-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mb-1 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'FECHA DE PAGO:'
	                ),
	                _react2.default.createElement('input', { type: 'date', ref: txtFechaPago, disabled: props.ope === 0 ? true : false, defaultValue: (0, _moment2.default)(fechasistema).format('YYYY-MM-DD'), name: 'fecha', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'colfull col-pd-290 mb-1 px-0 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  {
	                    className: 'input-group-text',
	                    id: 'inputGroup-sizing-sm'
	                  },
	                  'TIPO MONEDA:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  {
	                    className: 'form-control form-control-sm form-select fs-6 px-1 fw-bold',
	                    disabled: props.ope === 0 ? true : false,
	                    ref: txtMoneda,
	                    onChange: onChangeMoneda
	                  },
	                  combomoneda && combomoneda.map(function (item, index) {
	                    return _react2.default.createElement(
	                      'option',
	                      { key: index, value: item.idmoneda },
	                      " ",
	                      item.descripcion + ' ' + item.simbolo,
	                      " "
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'MONTO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: props.ope === 0 ? true : false, ref: txtMonto, placeholder: '0,00', onKeyUp: validarCantidad, onBlur: validarCantidad, className: 'form-control bg-transparent fs-6 text-right', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ) : '',
	          valida === 8 ? _react2.default.createElement(
	            'div',
	            { className: 'col-12 row m-0 px-0 py-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mb-1 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'FECHA DE PAGO:'
	                ),
	                _react2.default.createElement('input', { type: 'date', ref: txtFechaPago, disabled: props.ope === 0 ? true : false, defaultValue: (0, _moment2.default)(fechasistema).format('YYYY-MM-DD'), name: 'fecha', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mb-1 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'N\xB0 CREDITO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: props.ope === 0 ? true : false, ref: txtNumCredito, className: 'form-control bg-transparent fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', onClick: function onClick() {
	                      return setMostrar1(true);
	                    }, disabled: props.ope === 0 ? true : false, className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'MONTO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: true, ref: txtMonto, placeholder: '0,00', onKeyUp: validarCantidad, onBlur: validarCantidad, className: 'form-control bg-transparent fs-6 text-right', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ) : '',
	          valida === 9 ? _react2.default.createElement(
	            'div',
	            { className: 'col-12 row m-0 px-0 py-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mb-1 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'FECHA DE PAGO:'
	                ),
	                _react2.default.createElement('input', { type: 'date', ref: txtFechaPago, disabled: props.ope === 0 ? true : false, defaultValue: (0, _moment2.default)(fechasistema).format('YYYY-MM-DD'), name: 'fecha', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mb-1 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'N\xB0 ANTICIPO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: props.ope === 0 ? true : false, ref: txtNumCredito, className: 'form-control bg-transparent fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', onClick: function onClick() {
	                      return setMostrar2(true);
	                    }, disabled: props.ope === 0 ? true : false, className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-280 px-0 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'MONTO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: true, ref: txtMonto, placeholder: '0,00', onKeyUp: validarCantidad, onBlur: validarCantidad, className: 'form-control bg-transparent fs-6 text-right', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ) : ''
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-11 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: props.ope !== 0 ? false : true, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-success mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check', style: { fontSize: '9px' } },
	              '  Registrar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close', style: { fontSize: '9px' } },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoNotadeCredito2.default, {
	      show: mostrar1,
	      idcliente: props.idclients,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar1(false);
	      },
	      onHideAceptaCatalogo: handleAceptaDatos
	    }),
	    _react2.default.createElement(_catalogoAnticipos2.default, {
	      show: mostrar2,
	      idcliente: props.idclients,
	      tipo: 'AN',
	      estatus: 0,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar2(false);
	      },
	      onHideAceptaCatalogo: handleAceptaDatosAnticipos
	    })
	  );
	};

/***/ },
/* 7126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RegistrarPagoFCompras = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _catalogoValorMoneda = __webpack_require__(295);
	
	var _catalogoValorMoneda2 = _interopRequireDefault(_catalogoValorMoneda);
	
	var _modalProcesosMontosCompras = __webpack_require__(7125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var RegistrarPagoFCompras = exports.RegistrarPagoFCompras = function RegistrarPagoFCompras(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var ncaja = JSON.parse(sessionStorage.getItem("numcaja"));
	
	  var headCells = [{ label: "FORMA DE PAGO", textAlign: "center" }, { label: "REFERENCIA", textAlign: "center" }, { label: "MONTO", textAlign: "center" }, { label: "MONTO AL CAMBIO", textAlign: "center" }, { label: "", textAlign: "center" }];
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtIndex = (0, _react.useRef)();
	  var txtPorFechas = (0, _react.useRef)();
	  var txtTodosDispo = (0, _react.useRef)();
	  var txtCanceladas = (0, _react.useRef)();
	  var txtDeudas = (0, _react.useRef)();
	  var txtTodosCliente = (0, _react.useRef)();
	  var txtPorCliente = (0, _react.useRef)();
	  var txtFechaPago = (0, _react.useRef)();
	  var txtRifrespon = (0, _react.useRef)();
	  var txtNomrespon = (0, _react.useRef)();
	  var txtDesde = (0, _react.useRef)();
	  var txtHasta = (0, _react.useRef)();
	  var txtCbmrif = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0.0),
	      _useState2 = _slicedToArray(_useState, 2),
	      restabs = _useState2[0],
	      setRestabs = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0.0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      anticipos = _useState4[0],
	      setAnticipos = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0.0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      sobrabs = _useState6[0],
	      setSobrabs = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0.0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      totalresta = _useState8[0],
	      setTotalresta = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0.0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      totalsobra = _useState10[0],
	      setTotalsobra = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0.0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      totaldolares = _useState12[0],
	      setTotaldolares = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0.0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      totalcredito = _useState14[0],
	      setTotalcredito = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0.0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      totales = _useState16[0],
	      setTotales = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0.0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      totaldeuda = _useState18[0],
	      setTotaldeuda = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0.0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      totaldeudabs = _useState20[0],
	      setTotaldeudabs = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0.0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      tasa = _useState22[0],
	      setTasa = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(false),
	      _useState24 = _slicedToArray(_useState23, 2),
	      mostrar1 = _useState24[0],
	      setMostrar1 = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(0),
	      _useState26 = _slicedToArray(_useState25, 2),
	      operacion = _useState26[0],
	      setOperacion = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(""),
	      _useState28 = _slicedToArray(_useState27, 2),
	      numfactu = _useState28[0],
	      setNumfactu = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(0),
	      _useState30 = _slicedToArray(_useState29, 2),
	      idvendedor = _useState30[0],
	      setIdvendedor = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(0),
	      _useState32 = _slicedToArray(_useState31, 2),
	      idfactu = _useState32[0],
	      setIdfactu = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(null),
	      _useState34 = _slicedToArray(_useState33, 2),
	      body = _useState34[0],
	      setBody = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(null),
	      _useState36 = _slicedToArray(_useState35, 2),
	      idmon = _useState36[0],
	      setIdmon = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(""),
	      _useState38 = _slicedToArray(_useState37, 2),
	      paracliente = _useState38[0],
	      setParacliente = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(""),
	      _useState40 = _slicedToArray(_useState39, 2),
	      idclient = _useState40[0],
	      setIdclient = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(""),
	      _useState42 = _slicedToArray(_useState41, 2),
	      report = _useState42[0],
	      setReport = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(false),
	      _useState44 = _slicedToArray(_useState43, 2),
	      activate = _useState44[0],
	      setActivate = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(0),
	      _useState46 = _slicedToArray(_useState45, 2),
	      idmone = _useState46[0],
	      setIdmone = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(0.0),
	      _useState48 = _slicedToArray(_useState47, 2),
	      valormone = _useState48[0],
	      setValormone = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(""),
	      _useState50 = _slicedToArray(_useState49, 2),
	      tiponot = _useState50[0],
	      setTiponot = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(false),
	      _useState52 = _slicedToArray(_useState51, 2),
	      mostrar2 = _useState52[0],
	      setMostrar2 = _useState52[1];
	
	  var _useState53 = (0, _react.useState)([]),
	      _useState54 = _slicedToArray(_useState53, 2),
	      records = _useState54[0],
	      setRecords = _useState54[1];
	
	  var _useState55 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState56 = _slicedToArray(_useState55, 2),
	      filterFn = _useState56[0],
	      setFilterFn = _useState56[1];
	
	  var _useState57 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState58 = _slicedToArray(_useState57, 2),
	      mensaje = _useState58[0],
	      setMensaje = _useState58[1];
	
	  var _useState59 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState60 = _slicedToArray(_useState59, 2),
	      mensajesino = _useState60[0],
	      setMensajesino = _useState60[1];
	
	  var _useState61 = (0, _react.useState)(""),
	      _useState62 = _slicedToArray(_useState61, 2),
	      tituid = _useState62[0],
	      setTituid = _useState62[1];
	
	  var _useState63 = (0, _react.useState)([]),
	      _useState64 = _slicedToArray(_useState63, 2),
	      combomoneda = _useState64[0],
	      setComboMoneda = _useState64[1];
	
	  var _useState65 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState66 = _slicedToArray(_useState65, 2),
	      botones = _useState66[0],
	      setBotones = _useState66[1];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells, filterFn),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setRestabs(0.0);
	    setSobrabs(0.0);
	    setAnticipos(0.0);
	    setIdfactu(0);
	    setIdvendedor(0);
	    setNumfactu("");
	    setIdmon(null);
	    setParacliente("");
	    setTotalresta(0.0);
	    setTotales(0.0);
	    setMostrar2(false);
	    setTotaldolares(0.0);
	    setTotalsobra(0.0);
	    setReport("");
	    setIdclient("");
	    setTotaldeuda(0.0);
	    setRecords([]);
	    setValormone(0.0);
	    setIdmone(0);
	    setTiponot("");
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope === 1) {
	      if (records.length > 0) {
	        sigue = true;
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Introduzca el Pago !",
	          icono: "informacion"
	        });
	        sigue = false;
	      }
	
	      if (sigue) {
	        var pago = [];
	        var pagodetalle = [];
	
	        pago.push({
	          idpago: 0,
	          numpago: "",
	          concepto: props.tipo === "PAGO DE FACTURA N°" + " " + props.numfactu,
	          idcliente: props.idclient,
	          idvendedor: idvendedor,
	          idfactura: idfactu,
	          monto: (0, _varios.round)(totaldolares, 2),
	          descuento: "",
	          iva: props.iva,
	          montoiva: (0, _varios.round)(props.montoiva, 2),
	          abono: props.abono,
	          total: (0, _varios.round)(totaldolares, 2),
	          sobrante: parseFloat(totalsobra),
	          fecharegistro: txtFechaPago.current.value,
	          tipofac: props.tipo === "notaentrega" ? "NE" : props.tipo === "debito" ? "ND" : "FC",
	          numfactura: numfactu,
	          status: (0, _varios.formatMoneda)(totaldolares.toString().replace(",", "").replace(".", ","), ",", ".", 2) === (0, _varios.formatMoneda)(totaldeuda.toString().replace(",", "").replace(".", ","), ",", ".", 2) ? 1 : 0,
	          idmoneda: idmone,
	          valormoneda: valormone,
	          montodeuda: totaldeuda
	        });
	
	        for (var i = 0; i < records.length; i++) {
	          pagodetalle.push({
	            idpago: 0,
	            monto: records[i].tipo === 7 || records[i].tipo === 8 || records[i].tipo === 9 ? records[i].montodefinic : records[i].montos,
	            nroreferencia: records[i].referencia,
	            idmoneda: records[i].tipodivisa,
	            numcredito: records[i].notacredito,
	            factorcambio: records[i].valormoneda,
	            moneda: records[i].simbolo === "$" ? "DOLAR" : records[i].simbolo === "€" ? "EURO" : "BOLIVARES",
	            tipo: records[i].tipo,
	            fechaemision: records[i].fechapago,
	            idcuenta: records[i].idbanco
	          });
	        }
	
	        setBody({
	          pago: pago,
	          pagodeta: pagodetalle,
	          app: false,
	          ncaja: ncaja
	        });
	
	        var msg = "";
	        if (props.ope === 1) {
	          msg = "Esta Seguro de Registrar este Pago.";
	        }
	
	        setMensajesino({
	          mostrar: true,
	          titulo: "Confirmación.",
	          texto: msg,
	          icono: "confirmacion"
	        });
	      }
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/registropago/crearfacturacompra/" + props.ope;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (props.ope === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Pago Registrado Correctamente",
	            icono: "exito"
	          });
	
	          var reporte = "ReporteRecibodePago";
	          var opera = 2;
	          var condi = "'" + response.data.numeropago + "'";
	          var tipo = tiponot;
	
	          window.open(op.reportes + "/finanzas?afiliado=" + afiliado + "&reporte=" + reporte + "&NUMPAGO=" + condi + "&OP=" + opera + "&TIPOPAGO=" + tipo, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	        } else if (props.ope === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Pago Registrado Correctamente",
	            icono: "exito"
	          });
	        }
	        blanquear();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = error.response.data.message;
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    props.onHideCancelar();
	    props.onRenderizar();
	  };
	
	  var seleccionarMonedas = function seleccionarMonedas(fecha) {
	
	    var endpoint = op.conexion + "/api/moneda/selectmonedas?fecha=" + fecha;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idmoneda > 0) {
	          setComboMoneda(response.data);
	          setIdmon(response.data.idmoneda);
	
	          var valormoney = response.data.valor;
	          var total = 0.0;
	          var _idmone = response.data.idmoneda;
	
	          setTasa(valormoney);
	          setValormone(valormoney);
	          setIdmone(_idmone);
	
	          total = (0, _varios.round)(props.monto, 2) * valormoney;
	
	          setTotaldeuda(props.monto);
	          setTotaldeudabs(total);
	          setRestabs(total);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var handleAceptaDatos = function handleAceptaDatos(values) {
	    setMostrar1(false);
	
	    var predeterminada = void 0;
	    var totalm = 0.0;
	    var idmoney = void 0;
	    var valormoney = 0.0;
	    var indx = 0;
	    var credito = 0.0;
	    var credit = 0.0;
	
	    var datos = [].concat(_toConsumableArray(records));
	    var montod = totaldeuda;
	    var montototal = 0.0;
	    var total = 0.0;
	    var calcular = 0.0;
	    var sobrante = 0.0;
	
	    for (var b = 0; b < datos.length; b++) {
	      indx = indx + 1;
	    }
	
	    for (var i = 0; i < values.length; i++) {
	      idmoney = values[i].tipodivisa;
	
	      predeterminada = tasa;
	
	      datos.push({
	        forma: values[i].formapago === 1 ? "Efectivo Bs" : values[i].formapago === 2 ? "Tarjeta(Debito) Bs" : values[i].formapago === 3 ? "Tarjeta(Crédito) Bs" : values[i].formapago === 4 ? "Pago Movil Bs" : values[i].formapago === 5 ? "Deposito Bancario Bs" : values[i].formapago === 6 ? "Transferencia Bancaria Bs" : values[i].formapago === 7 ? "Divisa" + " " + values[i].simbolo : values[i].formapago === 8 ? "Saldo a Credito $" : "Saldo Anticipo $",
	        montos: values[i].monto,
	        fechapago: values[i].fecha,
	        tipo: values[i].formapago,
	        tipodivisa: values[i].tipodivisa,
	        montoalcambio: values[i].formapago === 7 && values[i].tipodivisa === idmon ? values[i].monto * predeterminada : values[i].formapago === 7 && values[i].tipodivisa !== idmon ? values[i].monto * valormoney : values[i].formapago === 8 || values[i].formapago === 9 ? values[i].monto * predeterminada : values[i].monto,
	        montodefinic: values[i].formapago === 7 && values[i].tipodivisa === idmon ? values[i].monto * predeterminada / predeterminada : values[i].formapago === 7 && values[i].tipodivisa !== idmon ? values[i].monto * valormoney / predeterminada : values[i].formapago === 8 || values[i].formapago === 9 ? values[i].monto : values[i].monto / predeterminada,
	        index: indx,
	        notacredito: values[i].formapago === 8 || values[i].formapago === 9 ? values[i].notacredito : "",
	        valormoneda: values[i].formapago === 7 && values[i].tipodivisa !== idmon ? values[i].valormoneda : values[i].formapago === 8 || values[i].formapago === 9 || values[i].formapago === 7 && values[i].tipodivisa === idmon ? predeterminada : values[i].valormoneda,
	        idbanco: values[i].idbanco,
	        referencia: values[i].referencia,
	        simbolo: values[i].simbolo
	      });
	    }
	
	    for (var e = 0; e < datos.length; e++) {
	      montototal = parseFloat(montototal) + parseFloat(datos[e].montodefinic);
	
	      if (datos[e].tipo === 8 || datos[e].tipo === 9) {
	        credito = parseFloat(datos[e].montodefinic);
	      } else {
	        credito = totalcredito;
	      }
	    }
	
	    var totalcredit = 0.0;
	
	    if (values[0].formapago === 8) {
	      credit = parseFloat(totalcredito) - credito;
	    } else {
	      credit = totalcredito;
	    }
	
	    if (values[0].formapago === 9) {
	      credit = parseFloat(anticipos) - credito;
	    } else {
	      credit = anticipos;
	    }
	
	    var tosobrabs = 0.0;
	    var totalanticipo = 0.0;
	    var calcularbs = 0.0;
	    var montbs = 0.0;
	    var montrestabs = 0.0;
	    var restabss = 0.0;
	
	    totalcredit = values[0].formapago === 8 ? credit >= parseFloat(totalcredito) ? "0,00" : credit : totalcredito;
	    totalanticipo = values[0].formapago === 9 ? credit >= parseFloat(anticipos) ? "0,00" : credit : anticipos;
	    total = (0, _varios.round)(montototal, 2) - (0, _varios.round)(montod, 2);
	    calcular = (0, _varios.round)(montototal, 2) > (0, _varios.round)(montod, 2) ? "0,00" : total;
	    sobrante = (0, _varios.round)(montototal, 2) > (0, _varios.round)(montod, 2) ? total : "0,00";
	    totalm = montototal * predeterminada;
	    tosobrabs = sobrante * predeterminada;
	
	    montbs = (0, _varios.round)(montod, 2) * predeterminada;
	    montrestabs = (0, _varios.round)(montod, 2) * predeterminada - totalm;
	    restabss = (0, _varios.round)(montototal, 2) * predeterminada;
	    calcularbs = restabss > montbs ? "0,00" : montrestabs;
	
	    setAnticipos(totalanticipo);
	    setSobrabs(Math.abs(tosobrabs));
	    setRestabs(Math.abs(calcularbs));
	    setTotalcredito(totalcredit);
	    setTotalresta(Math.abs(calcular));
	    setTotalsobra(sobrante);
	    setTotaldolares(montototal);
	    setTotales(totalm);
	    setRecords(datos);
	  };
	
	  var calcularTotales = function calcularTotales(data, datos) {
	    var predeterminada = void 0;
	    var montod = totaldeuda;
	    var montototal = 0.0;
	    var total = 0.0;
	    var calcular = 0.0;
	    var sobrante = 0.0;
	    var totalm = 0.0;
	    var credito = 0.0;
	    var credit = 0.0;
	    var ant = 0.0;
	    var mant = 0.0;
	    var tocredict = totalcredito;
	    var totalanticipo = anticipos;
	
	    predeterminada = tasa;
	
	    for (var e = 0; e < data.length; e++) {
	      for (var c = 0; c < datos.length; c++) {
	        montototal = parseFloat(montototal) + parseFloat(datos[c].montodefinic);
	      }
	
	      if (data[e].tipo === 8) {
	        credito = parseFloat(data[e].montodefinic);
	        credit = parseFloat(tocredict) + credito;
	      } else {
	        credito = tocredict;
	        credit = tocredict;
	      }
	
	      if (data[e].tipo === 9) {
	        ant = parseFloat(data[e].montodefinic);
	        mant = parseFloat(totalanticipo) + ant;
	      } else {
	        ant = totalanticipo;
	        mant = totalanticipo;
	      }
	    }
	
	    var totalcredit = 0.0;
	    var restabs = 0.0;
	    var tosobrabs = 0.0;
	    var toanticipo = 0.0;
	
	    totalcredit = credit;
	    toanticipo = mant;
	
	    total = (0, _varios.round)(montototal, 2) - (0, _varios.round)(montod, 2);
	    calcular = montototal > (0, _varios.round)(montod, 2) ? "0,00" : total;
	    sobrante = montototal > (0, _varios.round)(montod, 2) ? total : "0,00";
	    totalm = (0, _varios.round)(montototal, 2) * predeterminada;
	
	    restabs = calcular * predeterminada;
	    tosobrabs = sobrante * predeterminada;
	
	    setAnticipos(toanticipo);
	    setSobrabs(Math.abs(tosobrabs));
	    setRestabs(Math.abs(restabs));
	    setTotalcredito(totalcredit);
	    setTotalresta(Math.abs(calcular));
	    setTotalsobra(sobrante);
	    setTotaldolares(montototal);
	    setTotales(totalm);
	  };
	
	  var handleAceptaValorMoneda = function handleAceptaValorMoneda(values) {
	    setMostrar2(false);
	
	    setTasa(values.valor);
	    setValormone(values.valor);
	    setIdmone(values.idmoneda);
	
	    var datos = [].concat(_toConsumableArray(records));
	    var montototal = 0.0;
	    var restbs = 0.0;
	    var data = [];
	    var predeterminada = void 0;
	    var montod = totaldeuda;
	    var total = 0.0;
	    var calcular = 0.0;
	    var sobrante = 0.0;
	    var totalm = 0.0;
	    var tosobrabs = 0.0;
	    var monearray = [].concat(_toConsumableArray(combomoneda));
	    var calcularbs = 0.0;
	    var montbs = 0.0;
	    var montrestabs = 0.0;
	    var restabss = 0.0;
	
	    restbs = (0, _varios.round)(totaldeuda, 2) * values.valor;
	    predeterminada = values.valor;
	
	    if (datos.length > 0) {
	      for (var e = 0; e < datos.length; e++) {
	        data.push({
	          forma: datos[e].tipo === 1 ? "Efectivo Bs" : datos[e].tipo === 2 ? "Tarjeta(Debito) Bs" : datos[e].tipo === 3 ? "Tarjeta(Crédito) Bs" : datos[e].tipo === 4 ? "Pago Movil Bs" : datos[e].tipo === 5 ? "Deposito Bancario Bs" : datos[e].tipo === 6 ? "Transferencia Bancaria Bs" : datos[e].tipo === 7 ? "Divisa" + " " + datos[e].simbolo : datos[e].tipo === 8 ? "Saldo a Credito $" : "Saldo Anticipo $",
	          montos: datos[e].montos,
	          index: datos[e].index,
	          fechapago: datos[e].fechapago,
	          tipo: datos[e].tipo,
	          tipodivisa: datos[e].tipodivisa,
	          montoalcambio: datos[e].tipo === 8 || datos[e].tipo === 9 || datos[e].tipo === 7 && datos[e].tipodivisa === idmon ? datos[e].montos * values.valor : datos[e].montoalcambio,
	          montodefinic: datos[e].tipo === 7 && datos[e].tipodivisa !== idmon ? datos[e].montoalcambio / values.valor : datos[e].tipo === 8 || datos[e].tipo === 9 || datos[e].tipo === 7 && datos[e].tipodivisa === idmon ? datos[e].montodefinic * values.valor / values.valor : datos[e].montoalcambio / values.valor,
	          notacredito: datos[e].tipo === 8 || datos[e].tipo === 9 ? datos[e].notacredito : "",
	          valormoneda: datos[e].tipo === 7 && datos[e].tipodivisa !== idmon ? datos[e].valormoneda : datos[e].tipo === 8 || datos[e].tipo === 9 || datos[e].tipo === 7 && datos[e].tipodivisa === idmon ? values.valor : datos[e].valormoneda,
	          idbanco: datos[e].idbanco,
	          referencia: datos[e].referencia,
	          simbolo: datos[e].simbolo
	        });
	      }
	
	      for (var i = 0; i < data.length; i++) {
	        montototal = parseFloat(montototal) + parseFloat(data[i].montodefinic);
	      }
	
	      total = (0, _varios.round)(montototal, 2) - (0, _varios.round)(montod, 2);
	      calcular = (0, _varios.round)(montototal, 2) > (0, _varios.round)(montod, 2) ? "0,00" : total;
	      sobrante = (0, _varios.round)(montototal, 2) > (0, _varios.round)(montod, 2) ? total : "0,00";
	      totalm = montototal * predeterminada;
	      tosobrabs = sobrante * predeterminada;
	
	      montbs = (0, _varios.round)(montod, 2) * predeterminada;
	      montrestabs = (0, _varios.round)(montod, 2) * predeterminada - totalm;
	      restabss = (0, _varios.round)(montototal, 2) * predeterminada;
	      calcularbs = restabss > montbs ? "0,00" : montrestabs;
	
	      setSobrabs(Math.abs(tosobrabs));
	      setRestabs(Math.abs(calcularbs));
	      setTotalresta(Math.abs(calcular));
	      setTotalsobra(sobrante);
	      setTotaldolares(montototal);
	      setTotales(totalm);
	    } else {
	      setRestabs(Math.abs(restbs));
	    }
	
	    setRecords(data);
	    setTotaldeudabs(restbs);
	  };
	
	  var eliminarFila = function eliminarFila(values) {
	    return function (e) {
	      e.preventDefault();
	      var data = [].concat(_toConsumableArray(records));
	      var elementos = [];
	      var eliminado = [];
	
	      for (var i = 0; i < data.length; i++) {
	        if (values !== data[i].index) {
	          elementos.push(data[i]);
	        }
	
	        if (values === data[i].index) {
	          eliminado.push(data[i]);
	        }
	      }
	
	      setRecords(elementos);
	      calcularTotales(eliminado, elementos);
	    };
	  };
	
	  var onGestionar = function onGestionar(op) {
	    return function (e) {
	      if (op === 1) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 2) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 3) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 4) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 5) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 6) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 7) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 8) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 9) {
	        setOperacion(op);
	        setMostrar1(true);
	      }
	    };
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === 'fecha') {
	      seleccionarMonedas(e.target.value);
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "xl",
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        var fech = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        seleccionarMonedas(fech);
	        if (props.ope === 1) {
	          setIdfactu(props.idfactu);
	          setNumfactu(props.numfactu);
	          setIdvendedor(props.idvendedor);
	          setTotalresta(props.monto);
	          txtFechaPago.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	        } else {}
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold", style: { color: "#fff" } },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Registrar Pago - (Factura de Compra)"
	        )
	      ),
	      _react2.default.createElement(
	        "a",
	        {
	          href: "#",
	          ref: btnSalir,
	          disabled: botones.salir,
	          onClick: cancelar,
	          className: "text-light"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-times fa-1x shadow" },
	          " "
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({
	            mostrar: false,
	            titulo: "",
	            texto: "",
	            icono: ""
	          });
	        }
	      }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, {
	        mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	        },
	        onHideSi: handleCloseSi
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12 row mx-auto px-0" },
	        _react2.default.createElement(
	          "div",
	          { className: "row col-md-12 rounded mx-auto" },
	          _react2.default.createElement(
	            "fieldset",
	            {
	              className: "row col-sm-12 mx-auto border-azul rounded mb-1",
	              style: { fontSizeAdjust: "0.6" }
	            },
	            _react2.default.createElement(
	              "legend",
	              { className: "float-none m-0 w-auto fs-4 fw-bold" },
	              "Datos"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-4 row m-0 px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-280 px-1 py-2 mb-2" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA DE PAGO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "date",
	                    ref: txtFechaPago,
	                    disabled: props.ope === 0 ? true : false,
	                    name: "fecha",
	                    onChange: onChange,
	                    className: "form-control fs-6 text-uppercase",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-8 row m-0 px-0 border-azul d-flex align-items-center",
	                style: { background: "#cfe2ff", borderRadius: "3px" }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-5 px-1 row m-0",
	                  style: { fontSizeAdjust: "0.5" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  { className: "col-pd-130 px-1 text-left fs-5" },
	                  "Total a Pagar:",
	                  " "
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "col px-0 fw-bold text-right fs-5" },
	                  "\xA0",
	                  (0, _varios.formatMoneda)(totaldeuda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                  "\xA0$"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-6 px-1 row m-0 ml-auto",
	                  style: { fontSizeAdjust: "0.5" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  { className: "col-pd-180 px-1 text-left fs-5" },
	                  "Total a Pagar Bs:",
	                  " "
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "col px-0 fw-bold text-right fs-5" },
	                  "\xA0",
	                  (0, _varios.formatMoneda)(totaldeudabs.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-4 row m-0 px-0 d-flex justify-content-center border-azul py-2",
	                style: { background: "#cfe2ff", borderRadius: "3px" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 mb-2 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(1),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-money-bill-alt fs-5 mr-2" }),
	                  " Efectivo Bs"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(7),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-dollar-sign fs-5 mr-2" }),
	                  " Divisas"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 mb-2 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(2),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-credit-card fs-5 mr-2" }),
	                  " Tarjeta de Debito"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 mb-2 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(3),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fab fa-cc-visa fw-bold fs-5 mr-2" }),
	                  " Tarjeta de Credito"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 mb-2 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(6),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-money-check fs-5 mr-2" }),
	                  " Deposito Bancario"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 mb-2 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(5),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-laptop fs-5 mr-2" }),
	                  " Transferencia Bancaria"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 mb-2 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(4),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-mobile-alt fs-5 mr-2" }),
	                  " Pago Movil"
	                )
	              ),
	              _react2.default.createElement("div", { className: "col-6 d-flex justify-content-center" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-8 px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-12 px-0" },
	                _react2.default.createElement(
	                  TblContainer,
	                  {
	                    container: {
	                      height: "290px",
	                      width: "100%",
	                      overflow: "auto",
	                      padding: "2px"
	                    }
	                  },
	                  _react2.default.createElement(TblHead, null),
	                  _react2.default.createElement(
	                    _semanticUiReact.TableBody,
	                    { className: "overflow-hidden table-bordered" },
	                    records && records.map(function (item, index) {
	                      return _react2.default.createElement(
	                        _semanticUiReact.TableRow,
	                        {
	                          key: index,
	                          style: { padding: "0", cursor: "pointer" }
	                        },
	                        _react2.default.createElement(
	                          _semanticUiReact.TableCell,
	                          { className: "align-baseline text-center" },
	                          item.forma
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.TableCell,
	                          { className: "align-baseline text-center" },
	                          item.referencia
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.TableCell,
	                          { className: "align-middle text-right" },
	                          (0, _varios.formatMoneda)(item.montos.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.TableCell,
	                          { className: "align-baseline text-right" },
	                          (0, _varios.formatMoneda)(item.montoalcambio.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.TableCell,
	                          { className: "align-baseline text-center" },
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              className: "btn btn-sm mx-1 btn-danger",
	                              onClick: eliminarFila(item.index)
	                            },
	                            _react2.default.createElement("i", { className: "fa fa-trash" }),
	                            " "
	                          )
	                        )
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-12 row m-0 border-azul px-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-5 px-0" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-pd-280 mx-auto mt-2" },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "col-pd-210 row m-0 py-1 mx-auto d-flex align-items-center",
	                        style: { fontSizeAdjust: "0.5" }
	                      },
	                      _react2.default.createElement(
	                        "span",
	                        { className: "col-pd-90 px-1 text-left fs-5 fw-bold" },
	                        "Tasa 1$ =",
	                        " "
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        { className: "col-pd-70 px-0 fw-bold fs-5" },
	                        "\xA0",
	                        tasa && (0, _varios.formatMoneda)(tasa.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        { className: "col-pd-50 px-0" },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            type: "button",
	                            disabled: props.ope === 0 ? true : false,
	                            onClick: function onClick() {
	                              /* setCualCat(2); */
	                              setMostrar2(true);
	                            },
	                            className: "btn btn-primary"
	                          },
	                          _react2.default.createElement("i", { className: "fas fa-search" })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("img", { src: "imagenes/logo.ico", className: "img-fluid" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "col-7 ml-auto px-0 row m-0 d-flex align-items-center border-azul py-2",
	                    style: {
	                      background: "#cfe2ff",
	                      borderRadius: "3px",
	                      fontSizeAdjust: "0.5"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 row m-0 py-1",
	                      style: { fontSizeAdjust: "0.5" }
	                    },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "col-4 px-1 text-left fs-5" },
	                      "Total $:",
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "col px-0 fw-bold text-right fs-5" },
	                      "\xA0",
	                      (0, _varios.formatMoneda)(totaldolares.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 row m-0 py-1",
	                      style: { fontSizeAdjust: "0.5" }
	                    },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "col-4 px-1 text-left fs-5" },
	                      "Total Bs:",
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "col px-0 fw-bold text-right fs-5" },
	                      "\xA0",
	                      (0, _varios.formatMoneda)(totales.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 row m-0 py-1",
	                      style: { fontSizeAdjust: "0.5" }
	                    },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "col-pd-180 px-1 text-left fs-5" },
	                      totalsobra > 0 ? "Sobrante $:" : "Restante a Pagar $:",
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "col px-0 fw-bold text-right fs-5" },
	                      "\xA0",
	                      totalsobra > 0 ? (0, _varios.formatMoneda)(totalsobra.toString().replace(",", "").replace(".", ","), ",", ".", 2) : (0, _varios.formatMoneda)(totalresta.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 px-1 row m-0 py-1",
	                      style: { fontSizeAdjust: "0.5" }
	                    },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "col-pd-200 px-2 text-left fs-5" },
	                      sobrabs > 0 ? "Sobrante Bs:" : "Restante a Pagar Bs:"
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "col px-1 fw-bold text-right fs-5" },
	                      "\xA0",
	                      sobrabs > 0 ? (0, _varios.formatMoneda)(sobrabs.toString().replace(",", "").replace(".", ","), ",", ".", 2) : (0, _varios.formatMoneda)(restabs.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "row m-0 col-md-12 mx-auto" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-4 ml-auto px-0 m-0 d-flex justify-content-end" },
	          _react2.default.createElement(
	            "button",
	            {
	              ref: btnAcepta,
	              disabled: props.ope === 0 ? true : false,
	              onClick: onChangeValidar,
	              className: "btn btn-sm rounded-pill btn-success mx-1"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-sync-alt" },
	              " ",
	              "Procesar Pago"
	            )
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              ref: btnCancela,
	              onClick: cancelar,
	              className: "btn btn-danger btn-sm rounded-pill mx-1"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-window-close" },
	              " ",
	              "Cancelar"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_modalProcesosMontosCompras.ProcesosMontosCompras, {
	      show: mostrar1,
	      ope: operacion,
	      data: records,
	      idclients: props.idclient,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar1(false);
	      },
	      onHideAceptaData: handleAceptaDatos
	    }),
	    _react2.default.createElement(_catalogoValorMoneda2.default, {
	      show: mostrar2,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar2(false);
	      },
	      onHideAceptaCatalogo: handleAceptaValorMoneda
	    })
	  );
	};

/***/ },
/* 7127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _modalRegistrarPago = __webpack_require__(670);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegistrarPagoNotadeDebito = function RegistrarPagoNotadeDebito(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var anioActu = JSON.parse(sessionStorage.getItem("anioactu"));
	  var idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var accbtncntxcobrar = JSON.parse(sessionStorage.getItem("accbtncntxcobrarc"));
	
	  var txtIdNotaEntrega = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtConcepto = (0, _react.useRef)();
	  var txtMontoTotal = (0, _react.useRef)();
	  var txtAbono = (0, _react.useRef)();
	  var txtSaldo = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var cmbMoneda = (0, _react.useRef)();
	  var txtFechaVencimiento = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      actcredit = _useState2[0],
	      setActcredit = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      actanticipo = _useState4[0],
	      setActanticipo = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      operacion = _useState6[0],
	      setOperacion = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mostrar1 = _useState8[0],
	      setMostrar1 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(""),
	      _useState10 = _slicedToArray(_useState9, 2),
	      numNota = _useState10[0],
	      setNumNota = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      idfact = _useState12[0],
	      setIdfact = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(""),
	      _useState14 = _slicedToArray(_useState13, 2),
	      cedRif = _useState14[0],
	      setCedRif = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(""),
	      _useState16 = _slicedToArray(_useState15, 2),
	      nomVendedor = _useState16[0],
	      setNomVendedor = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(null),
	      _useState18 = _slicedToArray(_useState17, 2),
	      idCliente = _useState18[0],
	      setIdCliente = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(""),
	      _useState20 = _slicedToArray(_useState19, 2),
	      nomCliente = _useState20[0],
	      setNomCliente = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(""),
	      _useState22 = _slicedToArray(_useState21, 2),
	      dirCliente = _useState22[0],
	      setDirCliente = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0),
	      _useState24 = _slicedToArray(_useState23, 2),
	      visible = _useState24[0],
	      setVisible = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(0.0),
	      _useState26 = _slicedToArray(_useState25, 2),
	      monto = _useState26[0],
	      setMonto = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      desde = _useState28[0],
	      setDesde = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(0),
	      _useState30 = _slicedToArray(_useState29, 2),
	      esretencion = _useState30[0],
	      setEsretencion = _useState30[1];
	
	  var _useState31 = (0, _react.useState)([]),
	      _useState32 = _slicedToArray(_useState31, 2),
	      combomoneda = _useState32[0],
	      setComboMoneda = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(""),
	      _useState34 = _slicedToArray(_useState33, 2),
	      numfact = _useState34[0],
	      setNumfact = _useState34[1];
	
	  var _useState35 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState36 = _slicedToArray(_useState35, 2),
	      mensaje = _useState36[0],
	      setMensaje = _useState36[1];
	
	  var _useState37 = (0, _react.useState)({
	    idmoneda: "1",
	    descripcion: "BOLIVARES",
	    simbolo: "Bs",
	    predeterminada: true,
	    subpredeterminada: false,
	    valormoneda: 1.0
	  }),
	      _useState38 = _slicedToArray(_useState37, 2),
	      moneda = _useState38[0],
	      setMoneda = _useState38[1];
	
	  var _useState39 = (0, _react.useState)({
	    idmoneda: "2",
	    descripcion: "DOLARES",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 0.0
	  }),
	      _useState40 = _slicedToArray(_useState39, 2),
	      monedaSub = _useState40[0],
	      setMonedaSub = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(false),
	      _useState42 = _slicedToArray(_useState41, 2),
	      activate = _useState42[0],
	      setActivate = _useState42[1];
	
	  var blanquear = function blanquear() {
	    setMonto(0.0);
	    setActivate(false);
	    setOperacion(0);
	    setMostrar1(false);
	    setVisible(0);
	    cmbMoneda.current.selectedIndex = -1;
	    setMoneda({
	      idmoneda: "1",
	      descripcion: "BOLIVARES",
	      simbolo: "Bs",
	      predeterminada: false,
	      valormoneda: 1.0
	    });
	    txtIdNotaEntrega.current.value = "";
	    txtFechaVencimiento.current.value = "";
	    txtIdNotaEntrega.current.setAttribute("disabled", true);
	    cmbRif.current.selectedIndex = -1;
	    txtRif.current.value = "";
	    setNumNota("");
	    setNomCliente("");
	    setDirCliente("");
	    setNomVendedor("");
	    setCedRif("");
	    txtFecha.current.value = "";
	    txtMontoTotal.current.value = "0,00";
	    txtConcepto.current.value = "";
	    setActcredit(0);
	    setActanticipo(0);
	    setDesde(0);
	  };
	
	  var seleccionarCliente = function seleccionarCliente(rif, tecla) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "idagente";
	    var nomid2 = "cliente";
	    var id = rif;
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          if (response.data.agenteretencion === true) {
	            setEsretencion(1);
	          } else {
	            setEsretencion(0);
	          }
	          cmbRif.current.value = response.data.rif.trim().substring(0, 1);
	          txtRif.current.value = response.data.rif.trim().substring(1, 10);
	          setIdCliente(response.data.idagente);
	          setNomCliente(response.data.nombre);
	          setDirCliente(response.data.direccion.trim());
	          if (tecla === 13) {
	            txtFecha.current.focus();
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un cliente con este codigo",
	            icono: "informacion"
	          });
	          txtRif.current.value = "";
	          cmbRif.current.selectedIndex = -1;
	          if (tecla === 13) {
	            txtRif.current.focus();
	          }
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarVendedor = function seleccionarVendedor(idv) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "idagente";
	    var nomid2 = "vendedor";
	    var id = idv === null ? "0" : idv;
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setCedRif(response.data.rif);
	          setNomVendedor(response.data.nombre);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El usuario no tiene un vendedor asociado",
	            icono: "informacion"
	          });
	          blanquear();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarMoneda = function seleccionarMoneda(id) {
	    var campos = "*";
	    var nomtab = "moneda";
	    var nomid = "idmoneda";
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setMoneda(response.data);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro(id) {
	    var campos = "*";
	    var nomtab = "notaentrega";
	    var nomid = "idnotaentrega";
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtIdNotaEntrega.current.value = response.data.idnotaentrega;
	          setIdfact(response.data.idnotaentrega);
	          setNumfact(response.data.numnotaentrega);
	
	          txtIdNotaEntrega.current.setAttribute("disabled", true);
	          setVisible(0);
	
	          txtFecha.current.value = (0, _moment2.default)(response.data.fecha).format("YYYY-MM-DD");
	          txtFechaVencimiento.current.value = (0, _moment2.default)(response.data.fechavencimiento).format("YYYY-MM-DD");
	          setNumNota(response.data.numnotaentrega);
	          cmbMoneda.current.value = response.data.idmoneda;
	          txtConcepto.current.value = response.data.descripcion;
	          txtMontoTotal.current.value = (0, _varios.formatMoneda)(response.data.totalmonto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	          var tosaldo = 0.0;
	          tosaldo = response.data.totalmonto - props.abono;
	
	          txtAbono.current.value = (0, _varios.formatMoneda)(props.abono.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtSaldo.current.value = (0, _varios.formatMoneda)(tosaldo.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	          setMonto(tosaldo);
	          seleccionarCliente(response.data.idcliente, 46);
	          seleccionarVendedor(response.data.idvendedor);
	          seleccionarMoneda(response.data.idmoneda);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "ID no existe.",
	            icono: "informacion"
	          });
	          txtIdNotaEntrega.current.value = "";
	          txtIdNotaEntrega.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarMonedas = function seleccionarMonedas() {
	    var campos = "idmoneda, trim(descripcion) as descripcion, simbolo, predeterminada, valormoneda, subpredeterminada";
	    var nomtab = "moneda";
	    var orden = "idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setComboMoneda(response.data);
	          seleccionarMoneda(response.data[0].idmoneda);
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].subpredeterminada) {
	              setMonedaSub(response.data[i]);
	            }
	          }
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    if (accbtncntxcobrar && accbtncntxcobrar.toString().substring(1, 2) === "1") {
	      seleccionarCredito(idCliente);
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var imprimirNotaDebito = function imprimirNotaDebito() {
	    if (accbtncntxcobrar && accbtncntxcobrar.toString().substring(4, 5) === "1") {
	      var debt = 0;
	      if (txtIdNotaEntrega.current.value !== "") {
	        var idnot = txtIdNotaEntrega.current.value;
	
	        var reporte = "ReportNotaDebito";
	
	        window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&idnota=" + idnot, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Seleccione la nota de Debito !",
	          icono: "informacion"
	        });
	        debt = 1;
	      }
	
	      if (debt === 1) {
	        txtIdNotaEntrega.current.focus();
	      }
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var seleccionarCredito = function seleccionarCredito(id) {
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/seleccionarcredito?idcliente=" + id;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var montototal = 0.0;
	
	          for (var i = 0; i < response.data.length; i++) {
	            montototal = parseFloat(montototal) + parseFloat(response.data[i].totalmonto);
	          }
	
	          if (montototal > 0 && props.anticipo > 0) {
	            setMostrar1(true);
	            setActcredit(1);
	            setActanticipo(1);
	          } else {
	            if (props.anticipo > 0) {
	              setMostrar1(true);
	              setActcredit(0);
	              setActanticipo(1);
	            } else if (montototal > 0) {
	              setMostrar1(true);
	              setActcredit(1);
	              setActanticipo(0);
	            } else {
	              setMostrar1(true);
	              setActcredit(0);
	              setActanticipo(0);
	            }
	          }
	          setActivate(false);
	        } else {
	          if (props.anticipo > 0) {
	            setMostrar1(true);
	            setActcredit(0);
	            setActanticipo(1);
	          } else {
	            setMostrar1(true);
	            setActcredit(0);
	            setActanticipo(0);
	          }
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var renderizar = function renderizar() {
	    props.onRenderizar();
	    props.onHideCancelar();
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      size: "xl",
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        if (props.ope === 1) {
	          seleccionarMonedas();
	          seleccionarRegistro(props.idnot);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Nota de Debito"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 ", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12 row border-azul mx-auto justify-content-between rounded py-1" },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "col-md-12 row mx-auto d-flex justify-content-between mb-1",
	              style: { fontSizeAdjust: "0.6" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "colfull col220 mb-1" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "CODIGO:"
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  disabled: true,
	                  ref: txtIdNotaEntrega,
	                  name: "idnotaentre",
	                  className: "form-control form-control-lg",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "colfull col400 mb-1" },
	              _react2.default.createElement(
	                "label",
	                { className: "text-left" },
	                "NOTA DE DEBITO N\xB0:",
	                " ",
	                _react2.default.createElement(
	                  "span",
	                  { className: "col fw-bold text-danger" },
	                  "\xA0",
	                  numNota
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "col-md-12 row mx-auto d-flex justify-content-between mb-1",
	              style: { fontSizeAdjust: "0.6" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "colfull col-pd-300 mb-3" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "TIPO MONEDA:"
	                ),
	                _react2.default.createElement(
	                  "select",
	                  {
	                    className: "form-control form-control-sm fs-6 text-center fw-bold",
	                    disabled: true,
	                    ref: cmbMoneda
	                  },
	                  combomoneda && combomoneda.map(function (item, index) {
	                    return _react2.default.createElement(
	                      "option",
	                      { key: index, value: item.idmoneda },
	                      " ",
	                      item.descripcion + " " + item.simbolo + " " + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                      " "
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-pd-210 ml-auto" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "FECHA:"
	                ),
	                _react2.default.createElement("input", {
	                  autoComplete: "off",
	                  type: "date",
	                  disabled: true,
	                  ref: txtFecha,
	                  className: "form-control text-uppercase fs-6",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  name: "fecha"
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-pd-330 ml-auto" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "FECHA DE VENCIMIENTO:"
	                ),
	                _react2.default.createElement("input", {
	                  autoComplete: "off",
	                  disabled: true,
	                  type: "date",
	                  ref: txtFechaVencimiento,
	                  className: "form-control text-uppercase fs-6",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  name: "fechav"
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "colfull1070 colfull60p mx-auto mb-1 py-1",
	              style: { fontSizeAdjust: "0.6" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 mx-auto row border-azul rounded py-2" },
	              _react2.default.createElement(
	                "span",
	                { className: "fw-bold mb-1" },
	                "Datos del Cliente"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-1 col-pd-260 px-2" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "CEDULA/RIF:",
	                  " "
	                ),
	                _react2.default.createElement(
	                  "select",
	                  {
	                    ref: cmbRif,
	                    name: "cmbrif",
	                    disabled: true,
	                    className: "form-select form-select-sm col-md-3 text-center ",
	                    "aria-label": ".form-select-sm example"
	                  },
	                  _react2.default.createElement(
	                    "option",
	                    { value: "" },
	                    "--"
	                  ),
	                  _varios.cmbCedula.map(function (item, index) {
	                    return _react2.default.createElement(
	                      "option",
	                      { key: index, value: item.value },
	                      item.value
	                    );
	                  })
	                ),
	                _react2.default.createElement("input", {
	                  ref: txtRif,
	                  autoComplete: "off",
	                  disabled: true,
	                  maxLength: 9,
	                  type: "text",
	                  className: "form-control fs-6",
	                  name: "cedula",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-1 col-pd-340 px-0" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "NOMBRE:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  className: "form-control fs-6",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  defaultValue: nomCliente
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm col-md-12" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "DIRECCION:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  className: "form-control fs-6",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  defaultValue: dirCliente
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            {
	              className: "colfull1070 colfull40p mx-auto mb-1 row py-1",
	              style: { fontSizeAdjust: "0.6" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 mx-auto row border-azul rounded py-2" },
	              _react2.default.createElement(
	                "span",
	                { className: "fw-bold mb-1" },
	                "Datos del Vendedor"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm col-pd-220 px-2" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text",
	                    id: "inputGroup-sizing-sm",
	                    style: { height: "85%" }
	                  },
	                  "CEDULA/RIF:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  className: "form-control fs-6",
	                  style: { height: "85%" },
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  defaultValue: cedRif
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm col-md-12" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text",
	                    id: "inputGroup-sizing-sm",
	                    style: { height: "85%" }
	                  },
	                  "NOMBRE:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  style: { height: "85%" },
	                  className: "form-control fs-6",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  defaultValue: nomVendedor
	                })
	              )
	            ),
	            _react2.default.createElement("div", { className: "col-md-6" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-12 row m-0" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 border-azul rounded p-2 shadow",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-md-12" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "CONCEPTO:"
	                ),
	                _react2.default.createElement("textarea", {
	                  className: "form-control uppercase fs-6",
	                  ref: txtConcepto,
	                  disabled: true,
	                  "aria-label": "With textarea",
	                  style: { minHeight: 50 },
	                  defaultValue: ""
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-4 ml-auto m-0 border-azul rounded",
	                  style: { backgroundColor: "#dbeeff" }
	                },
	                _react2.default.createElement("div", { className: "col-12 mb-2" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 ml-auto" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "MONTO TOTAL ",
	                    moneda.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "text",
	                    ref: txtMontoTotal,
	                    disabled: true,
	                    className: "form-control text-end fs-6 bg-transparent border-0",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: "0,00"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 ml-auto" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "ABONO ",
	                    moneda.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "text",
	                    ref: txtAbono,
	                    disabled: true,
	                    className: "form-control text-end fs-6 bg-transparent border-0",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: "0,00"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 ml-auto" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "SALDO ",
	                    moneda.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "text",
	                    ref: txtSaldo,
	                    disabled: true,
	                    className: "form-control text-end fs-6 bg-transparent border-0",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: "0,00"
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          className: "btn btn-sm btn-success rounded-pill",
	          onClick: onChangeValidar,
	          style: { margin: "5px" }
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Registrar Pago"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          onClick: imprimirNotaDebito,
	          style: { margin: "5px" },
	          className: "btn btn-sm btn-primary rounded-pill",
	          title: "Imprimir Nota de Entrega"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fa fa-print" },
	          " Imprimir"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    ),
	    _react2.default.createElement(_modalRegistrarPago.RegistrarPago, {
	      show: mostrar1,
	      tipo: "debito",
	      abonos: props.abono,
	      esretenedor: esretencion,
	      anticipo: props.anticipo,
	      idvendedor: idVendedor,
	      idfactu: idfact,
	      numfactu: numfact,
	      siescredit: actcredit,
	      siesanticipo: actanticipo,
	      ope: 1,
	      montoiva: "0.00",
	      iva: "0.00",
	      onRenderizar: renderizar,
	      idclient: idCliente,
	      monto: monto,
	      idmoned: moneda.idmoneda,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar1(false);
	      }
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "Cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    })
	  );
	};
	exports.default = RegistrarPagoNotadeDebito;

/***/ },
/* 7128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _core = __webpack_require__(19);
	
	var _modalRegistrarPago = __webpack_require__(670);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegistrarPagoNotadeEntrega = function RegistrarPagoNotadeEntrega(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var anioActu = JSON.parse(sessionStorage.getItem("anioactu"));
	  var idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var accbtncntxcobrar = JSON.parse(sessionStorage.getItem("accbtncntxcobrarc"));
	  var cmbCedula = ["J", "V", "G", "P"];
	  var headCells = [{ label: "COD-PRODUCTO", textAlign: "center", width: "60px" }, { label: "PRODUCTO", textAlign: "center", width: "160px" }, { label: "CANTIDAD", textAlign: "center", width: "20px" }, { label: "PRECIO UNI.", textAlign: "center", width: "50px" }, { label: "UND. ALT.", textAlign: "center", width: "50px" }, { label: "%IVA", textAlign: "center", width: "50px" }, { label: "MONTO IVA", textAlign: "center", width: "50px" }, { label: "SIN IVA", textAlign: "center", width: "50px" }];
	
	  var txtIdNotaEntrega = (0, _react.useRef)();
	  var cmbTipo = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtId = (0, _react.useRef)([]);
	  var txtCantidad = (0, _react.useRef)([]);
	  var txtAbono = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtSaldo = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtSubTotal = (0, _react.useRef)();
	  var txtDescuento = (0, _react.useRef)();
	  var txtTotIva = (0, _react.useRef)();
	  var txtTotal = (0, _react.useRef)();
	  var txtIdPedido = (0, _react.useRef)();
	  var cmbMoneda = (0, _react.useRef)();
	  var txtContado = (0, _react.useRef)();
	  var txtCredito = (0, _react.useRef)();
	  var txtFechaVencimiento = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      actcredit = _useState2[0],
	      setActcredit = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      operacion = _useState4[0],
	      setOperacion = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      selectp = _useState6[0],
	      setSelectp = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(""),
	      _useState8 = _slicedToArray(_useState7, 2),
	      numNota = _useState8[0],
	      setNumNota = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      esretencion = _useState10[0],
	      setEsretencion = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(""),
	      _useState12 = _slicedToArray(_useState11, 2),
	      numPedido = _useState12[0],
	      setNumPedido = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(""),
	      _useState14 = _slicedToArray(_useState13, 2),
	      cedRif = _useState14[0],
	      setCedRif = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(""),
	      _useState16 = _slicedToArray(_useState15, 2),
	      nomVendedor = _useState16[0],
	      setNomVendedor = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      actanticipo = _useState18[0],
	      setActanticipo = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(""),
	      _useState20 = _slicedToArray(_useState19, 2),
	      idCliente = _useState20[0],
	      setIdCliente = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(""),
	      _useState22 = _slicedToArray(_useState21, 2),
	      nomCliente = _useState22[0],
	      setNomCliente = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(""),
	      _useState24 = _slicedToArray(_useState23, 2),
	      dirCliente = _useState24[0],
	      setDirCliente = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(false),
	      _useState26 = _slicedToArray(_useState25, 2),
	      mostrar = _useState26[0],
	      setMostrar = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(""),
	      _useState28 = _slicedToArray(_useState27, 2),
	      numfact = _useState28[0],
	      setNumfact = _useState28[1];
	
	  var _useState29 = (0, _react.useState)([]),
	      _useState30 = _slicedToArray(_useState29, 2),
	      records = _useState30[0],
	      setRecords = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(0),
	      _useState32 = _slicedToArray(_useState31, 2),
	      idfact = _useState32[0],
	      setIdfact = _useState32[1];
	
	  var _useState33 = (0, _react.useState)([]),
	      _useState34 = _slicedToArray(_useState33, 2),
	      combomoneda = _useState34[0],
	      setCombomoneda = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(false),
	      _useState36 = _slicedToArray(_useState35, 2),
	      activate = _useState36[0],
	      setActivate = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(0.0),
	      _useState38 = _slicedToArray(_useState37, 2),
	      xiva = _useState38[0],
	      setXiva = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(0.0),
	      _useState40 = _slicedToArray(_useState39, 2),
	      montoiva = _useState40[0],
	      setMontoiva = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(0.0),
	      _useState42 = _slicedToArray(_useState41, 2),
	      monto = _useState42[0],
	      setMonto = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      mensaje = _useState44[0],
	      setMensaje = _useState44[1];
	
	  var _useState45 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState46 = _slicedToArray(_useState45, 2),
	      mensajesino = _useState46[0],
	      setMensajesino = _useState46[1];
	
	  var _useState47 = (0, _react.useState)({
	    idmoneda: "1",
	    descripcion: "BOLIVARES",
	    simbolo: "Bs",
	    predeterminada: true,
	    subpredeterminada: false,
	    valormoneda: 1.0
	  }),
	      _useState48 = _slicedToArray(_useState47, 2),
	      moneda = _useState48[0],
	      setMoneda = _useState48[1];
	
	  var _useState49 = (0, _react.useState)({
	    subtotal: 0.0,
	    descuento: 0.0,
	    exento: 0.0,
	    sujeto: 0.0,
	    iva: 16.0,
	    totaliva: 0.0,
	    total: 0.0
	  }),
	      _useState50 = _slicedToArray(_useState49, 2),
	      totales = _useState50[0],
	      setTotales = _useState50[1];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var blanquear = function blanquear() {
	    setMostrar(false);
	    setActivate(false);
	    setOperacion(0);
	    setActcredit(0);
	    setActanticipo(0);
	    setSelectp(0);
	    cmbMoneda.current.selectedIndex = -1;
	    txtContado.current.checked = true;
	    setMoneda({
	      idmoneda: "1",
	      descripcion: "BOLIVARES",
	      simbolo: "Bs",
	      predeterminada: false,
	      valormoneda: 1.0
	    });
	    setRecords([]);
	    txtIdNotaEntrega.current.value = "";
	    txtFechaVencimiento.current.value = "";
	    txtIdNotaEntrega.current.setAttribute("disabled", true);
	    cmbTipo.current.selectedIndex = -1;
	    cmbRif.current.selectedIndex = -1;
	    txtRif.current.value = "";
	    setNumPedido("");
	    setNumNota("");
	    setNomCliente("");
	    setDirCliente("");
	    setNomVendedor("");
	    setCedRif("");
	    txtFecha.current.value = "";
	    txtSubTotal.current.value = "";
	    txtTotIva.current.value = "";
	    txtTotal.current.value = "";
	    txtDescuento.current.value = "";
	    txtSaldo.current.value = "";
	    txtAbono.current.value = "";
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var seleccionarCliente = function seleccionarCliente(rif, tecla) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "idagente";
	    var nomid2 = "cliente";
	    var id = rif;
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	
	          if (response.data.agenteretencion === true) {
	            setEsretencion(1);
	          } else {
	            setEsretencion(0);
	          }
	          cmbRif.current.value = response.data.rif.trim().substring(0, 1);
	          txtRif.current.value = response.data.rif.trim().substring(1, 10);
	          setIdCliente(response.data.idagente);
	          setNomCliente(response.data.nombre);
	          setDirCliente(response.data.direccion.trim());
	          if (tecla === 13) {
	            txtFecha.current.focus();
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un cliente con este codigo",
	            icono: "informacion"
	          });
	          txtRif.current.value = "";
	          cmbRif.current.selectedIndex = -1;
	          if (tecla === 13) {
	            txtRif.current.focus();
	          }
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarVendedor = function seleccionarVendedor(idv) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "idagente";
	    var nomid2 = "vendedor";
	    var id = idv === null ? "0" : idv;
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setCedRif(response.data.rif);
	          setNomVendedor(response.data.nombre);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El usuario no tiene un vendedor asociado",
	            icono: "informacion"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarMoneda = function seleccionarMoneda(id) {
	    var campos = "*";
	    var nomtab = "moneda";
	    var nomid = "idmoneda";
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idmoneda > 0) {
	          setMoneda(response.data);
	          var datamoneda = [];
	
	          datamoneda.push({
	            descripcion: response.data.descripcion,
	            idmoneda: response.data.idmoneda,
	            predeterminada: response.data.predeterminada,
	            simbolo: response.data.simbolo,
	            subpredeterminada: response.data.subpredeterminada,
	            valormoneda: response.data.valormoneda
	          });
	
	          setCombomoneda(datamoneda);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro(id) {
	    var campos = "*";
	    var nomtab = "notaentrega";
	    var nomid = "idnotaentrega";
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtIdNotaEntrega.current.value = response.data.idnotaentrega;
	          setIdfact(response.data.idnotaentrega);
	          setNumfact(response.data.numnotaentrega);
	
	          if (response.data.credito !== false) {
	            txtCredito.current.checked = true;
	            txtContado.current.checked = false;
	            txtFechaVencimiento.current.value = (0, _moment2.default)(response.data.fechavencimiento).format("YYYY-MM-DD");
	          } else {
	            txtCredito.current.checked = false;
	            txtContado.current.checked = true;
	          }
	
	          if (response.data.numpedido === "" || response.data.numpedido === null) {
	            if (response.data.tipo === "NE") {
	              cmbTipo.current.value = "1";
	            } else if (response.data.tipo === "NO") {
	              cmbTipo.current.value = "3";
	            }
	          } else {
	            setSelectp(1);
	            cmbTipo.current.value = "2";
	            setNumPedido(response.data.numpedido);
	            txtIdPedido.current.value = response.data.numpedido;
	          }
	
	          txtFecha.current.value = (0, _moment2.default)(response.data.fecha).format("YYYY-MM-DD");
	          setNumNota(response.data.numnotaentrega);
	          setTotales({
	            subtotal: parseFloat(response.data.totalmonto) - parseFloat(response.data.totaliva),
	            descuento: response.data.totaldescuento,
	            exento: response.data.totalexento,
	            sujeto: response.data.totalsujeto,
	            iva: 16.0,
	            totaliva: response.data.totaliva,
	            total: response.data.totalmonto
	          });
	
	          var tosaldo = 0.0;
	          tosaldo = parseFloat(response.data.totalmonto) - parseFloat(props.abono);
	
	          txtAbono.current.value = (0, _varios.formatMoneda)(props.abono.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtSaldo.current.value = (0, _varios.formatMoneda)(tosaldo.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	          setMonto(tosaldo);
	          setXiva(16.0);
	          setMontoiva(response.data.totaliva);
	          seleccionarCliente(response.data.idcliente, 46);
	          seleccionarVendedor(response.data.idvendedor);
	          seleccionarMoneda(response.data.idmoneda);
	          seleccionarDetalle(id);
	          if (operacion === 2) {
	            setTimeout(function () {
	              return txtFecha.current.focus();
	            }, 200);
	          } else {
	            setTimeout(function () {
	              return btnCancela.current.focus();
	            }, 200);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "ID no existe.",
	            icono: "informacion"
	          });
	          txtIdNotaEntrega.current.value = "";
	          txtIdNotaEntrega.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarDetalle = function seleccionarDetalle(id) {
	    var nomtab1 = "notaentregadetalle";
	    var nomtab2 = "notaentrega";
	    var nomid = "idnotaentrega";
	    var endpoint = op.conexion + "/api/inventario/seleccionarnotaentregadetordenes?id=" + id + "&nomtab1=" + nomtab1 + "&nomtab2=" + nomtab2 + "&nomid=" + nomid;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var prod = [];
	          var uni = [];
	          var precio = 0.0;
	          var tasa = 0.0;
	
	          for (var i = 0; i < response.data.length; i++) {
	            if (parseInt(response.data[i].idunidadalterna) === 0 || response.data[i].idunidadalterna === null) {
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].servicio === true ? "SERVICIO" : response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	            } else {
	              if (response.data[i].tipounidad === 0) {
	                uni = [{
	                  idunidad: response.data[i].idunidadmedida,
	                  descripcion: response.data[i].servicio === true ? "SERVICIO" : response.data[i].descripcionuni,
	                  tipo: "medida"
	                }, {
	                  idunidad: response.data[i].idunidadalterna,
	                  descripcion: response.data[i].servicio === true ? "SERVICIO" : response.data[i].descripcionunialt,
	                  tipo: "alterna"
	                }];
	              } else {
	                uni = [{
	                  idunidad: response.data[i].idunidadalterna,
	                  descripcion: response.data[i].servicio === true ? "SERVICIO" : response.data[i].descripcionunialt,
	                  tipo: "alterna"
	                }, {
	                  idunidad: response.data[i].idunidadmedida,
	                  descripcion: response.data[i].servicio === true ? "SERVICIO" : response.data[i].descripcionuni,
	                  tipo: "medida"
	                }];
	              }
	            }
	
	            var _montoiva = response.data[i].punitario * response.data[i].iva / 100;
	            //montoiva = Math.round(montoiva * 100) / 100;
	
	            var cantie = response.data[i].cantidade;
	            var cantiea = 0.0;
	            if (response.data[i].tipounidad === 0) {
	              if (response.data[i].tipofactor === "1") {
	                cantie = parseFloat(response.data[i].cantidade / response.data[i].valorfactor);
	                //cantie = Math.round(cantie * 100) / 100;
	                cantie = Math.trunc(cantie);
	
	                cantiea = parseFloat(response.data[i].cantidad * response.data[i].valorfactor);
	                cantiea = Math.trunc(cantiea);
	              }
	            } else {
	              if (response.data[i].tipofactor === "0") {
	                cantie = parseFloat(response.data[i].cantidade / response.data[i].valorfactor);
	                //cantie = Math.round(cantie * 100) / 100;
	                cantie = Math.trunc(cantie);
	
	                cantiea = parseFloat(response.data[i].cantidad * response.data[i].valorfactor);
	                cantiea = Math.trunc(cantiea);
	              }
	            }
	
	            prod.push({
	              idproducto: response.data[i].idproducto,
	              codigo: response.data[i].codproducto,
	              cantidad: response.data[i].cantidad,
	              cantidadE: parseFloat(cantie) + parseFloat(response.data[i].cantidad),
	              cantidadEA: parseFloat(response.data[i].cantidade) + parseFloat(cantiea),
	              nombrecorto: response.data[i].nombrecorto,
	              precio: response.data[i].punitario,
	              precious: response.data[i].punitario,
	              preciobs: response.data[i].punitariobs,
	              iva: response.data[i].iva,
	              ivaventa: response.data[i].ivaventa,
	              montoiva: response.data[i].cantidad * _montoiva,
	              descuento: response.data[i].descuento,
	              total: response.data[i].cantidad * response.data[i].punitario,
	              unidad: uni,
	              idunidadmedida: response.data[i].idunidadmedida,
	              idunidadalterna: response.data[i].idunidadalterna,
	              costocalculado: response.data[i].costocalculado,
	              costocalculadoalter: response.data[i].costocalculadoalter,
	              utipreciomaxi: response.data[i].utipreciomaxi,
	              utipreciomaxialter: response.data[i].utipreciomaxialter,
	              tipounidad: response.data[i].tipounidad,
	              valormoneda: response.data[i].valormoneda,
	              idmoneda: response.data[i].idmoneda,
	              tipofactor: response.data[i].tipofactor,
	              valorfactor: response.data[i].valorfactor
	            });
	          }
	          setRecords(prod);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    if (accbtncntxcobrar && accbtncntxcobrar.toString().substring(1, 2) === "1") {
	      seleccionarCredito(idCliente);
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var imprimirNotaEntrega = function imprimirNotaEntrega() {
	    if (accbtncntxcobrar && accbtncntxcobrar.toString().substring(4, 5) === "1") {
	      var debt = 0;
	      if (txtIdNotaEntrega.current.value !== "") {
	        var idnot = txtIdNotaEntrega.current.value;
	
	        var nota = JSON.parse(sessionStorage.getItem("tiporepnotaentrega"));
	        var reporte = nota.toString() === 'HOJA' ? "ReportNotaEntrega" : "ReportNotaEntregaMedium";
	
	        window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&idnota=" + idnot, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Seleccione la nota de Entrega !",
	          icono: "informacion"
	        });
	        debt = 1;
	      }
	
	      if (debt === 1) {
	        txtIdNotaEntrega.current.focus();
	      }
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var renderizar = function renderizar() {
	    props.onRenderizar();
	    props.onHideCancelar();
	  };
	
	  var seleccionarCredito = function seleccionarCredito(id) {
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/seleccionarcredito?idcliente=" + id;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var montototal = 0.0;
	
	          for (var i = 0; i < response.data.length; i++) {
	            montototal = parseFloat(montototal) + parseFloat(response.data[i].totalmonto);
	          }
	
	          if (montototal > 0 && props.anticipo > 0) {
	            setMostrar(true);
	            setActcredit(1);
	            setActanticipo(1);
	          } else {
	            if (props.anticipo > 0) {
	              setMostrar(true);
	              setActcredit(0);
	              setActanticipo(1);
	            } else if (montototal > 0) {
	              setMostrar(true);
	              setActcredit(1);
	              setActanticipo(0);
	            } else {
	              setMostrar(true);
	              setActcredit(0);
	              setActanticipo(0);
	            }
	          }
	          setActivate(false);
	        } else {
	          if (props.anticipo > 0) {
	            setMostrar(true);
	            setActcredit(0);
	            setActanticipo(1);
	          } else {
	            setMostrar(true);
	            setActcredit(0);
	            setActanticipo(0);
	          }
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      size: "xl",
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        if (props.ope === 1) {
	          if (cmbTipo) {
	            cmbTipo.current.selectedIndex = -1;
	          }
	          seleccionarRegistro(props.idnot);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Nota de Entrega"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { style: { height: "100%", width: "100%" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row col-md-12", style: { margin: 0 } },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row border-azul mx-auto rounded py-1" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row mx-auto d-flex justify-content-between mb-1" },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col-pd-180 mb-1",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CODIGO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    autoComplete: "off",
	                    ref: txtIdNotaEntrega,
	                    name: "idnotaentre",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col-pd-380 mb-1 px-0",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  { className: "text-left" },
	                  "NOTA ENTREGA N\xB0:",
	                  " ",
	                  _react2.default.createElement(
	                    "span",
	                    { className: "col fw-bold text-danger" },
	                    "\xA0",
	                    numNota
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col-pd-180 mb-1 mr-auto px-1",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      disabled: true,
	                      ref: cmbTipo,
	                      className: "form-select form-select-sm",
	                      "aria-label": ".form-select-sm example",
	                      name: "tipo",
	                      id: "tipo"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "NUEVO"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "2" },
	                      "POR PEDIDO"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "3" },
	                      "OBSEQUIO"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement("input", { type: "hidden", ref: txtIdPedido }),
	              selectp === 1 ? _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col320",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  { className: "text-right" },
	                  "PEDIDO N\xB0:",
	                  " ",
	                  _react2.default.createElement(
	                    "span",
	                    { className: "col fw-bold text-danger" },
	                    "\xA0",
	                    numPedido
	                  )
	                )
	              ) : ""
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 row mx-auto mb-1",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "colfull col-pd-290 mb-3" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO MONEDA:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-control form-control-sm fw-bold text-center",
	                      disabled: true,
	                      ref: cmbMoneda
	                    },
	                    combomoneda && combomoneda.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: index },
	                        " ",
	                        item.descripcion + " " + item.simbolo + " " + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                        " "
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "colfull col270" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "mt-14m mr-auto col-pd-260 px-0" },
	                  _react2.default.createElement(
	                    "fieldset",
	                    { className: "row col-sm-12 border-azul rounded mb-1" },
	                    _react2.default.createElement(
	                      "legend",
	                      {
	                        className: "float-none m-0 w-auto",
	                        style: { fontSize: "14px" }
	                      },
	                      "TIPO VENTA:"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-5 mr-auto" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: true,
	                          name: "contado",
	                          ref: txtContado,
	                          value: "1",
	                          defaultChecked: true,
	                          id: "contado",
	                          type: "radio"
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "form-check-label",
	                            htmlFor: "exampleRadi4"
	                          },
	                          "Contado"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-5 ml-auto" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: true,
	                          name: "contado",
	                          ref: txtCredito,
	                          value: "2",
	                          id: "contado",
	                          type: "radio"
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "form-check-label",
	                            htmlFor: "exampleRadi5"
	                          },
	                          "Cr\xE9dito"
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-300 mr-auto px-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA/VENCIMIENTO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    disabled: true,
	                    type: "date",
	                    ref: txtFechaVencimiento,
	                    className: "form-control text-uppercase fs-6"
	                    //value={moment(fechav).format("YYYY-MM-DD")}
	                    , "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    name: "fechav"
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-200 ml-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA:"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "date",
	                    disabled: true,
	                    ref: txtFecha,
	                    className: "form-control fs-6 text-uppercase",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    name: "fecha"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "colfull1070 colfull60p mx-auto mb-1 ",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row border-azul rounded py-2" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold mb-1" },
	                  "Datos del Cliente"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-260 px-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: cmbRif,
	                      name: "cmbrif",
	                      disabled: true,
	                      className: "form-select form-select-sm col-md-3 text-center",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "--"
	                    ),
	                    cmbCedula && cmbCedula.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item },
	                        item
	                      );
	                    })
	                  ),
	                  _react2.default.createElement("input", {
	                    ref: txtRif,
	                    autoComplete: "off",
	                    disabled: true,
	                    maxLength: 9,
	                    type: "text",
	                    className: "form-control fs-6",
	                    name: "cedula",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-340 px-0" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "NOMBRE:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: nomCliente
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "DIRECCION:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: dirCliente
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "colfull1070 colfull40p mx-auto mb-1 row m-0",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row mb-1 py-2 border-azul rounded " },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold mb-1" },
	                  "Datos del Vendedor"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-230 px-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: cedRif
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "NOMBRE:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: nomVendedor
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 border-azul px-0 rounded",
	                style: { /*height: '230px',*/backgroundColor: "#d5e9ff" }
	              },
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 190,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px",
	                    fontSizeAdjust: "0.6"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden" },
	                  records && records.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      { key: index, style: { padding: "0" } },
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-center p-0 d-flex" },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          style: {
	                            borderBottomRightRadius: 0,
	                            borderTopRightRadius: 0,
	                            height: "37px"
	                          },
	                          disabled: true,
	                          ref: function ref(el) {
	                            return txtId.current[index] = el;
	                          },
	                          className: "form-control text-center form-control-sm bg-light fs-6",
	                          defaultValue: item.codigo
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-start p-0 pl-2",
	                          style: { width: "260px" }
	                        },
	                        item.nombrecorto
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-center p-0",
	                          style: { width: "20px" }
	                        },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control form-control-sm bg-light text-right fs-6",
	                          id: "cantidad",
	                          disabled: true,
	                          defaultValue: (0, _varios.formatMoneda)(item.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtCantidad.current[index] = el;
	                          },
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "70px" }
	                        },
	                        (0, _varios.formatMoneda)(item.precio.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light p-0",
	                          style: { width: 70 }
	                        },
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            className: "form-control form-control-sm fs-6",
	                            style: { width: "100%" },
	                            disabled: true
	                          },
	                          item.unidad && item.unidad.map(function (item2, x) {
	                            return _react2.default.createElement(
	                              "option",
	                              { key: x, value: item2.idunidad },
	                              " ",
	                              item2.descripcion,
	                              " "
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "50px" }
	                        },
	                        (0, _varios.formatMoneda)(item.iva.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "50px" }
	                        },
	                        (0, _varios.formatMoneda)(item.montoiva.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "50px" }
	                        },
	                        (0, _varios.formatMoneda)(item.total.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      )
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row m-0 px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-7 py-1 mt-auto" },
	                _react2.default.createElement("div", { className: "col-pd-botonesd row m-0 ml-auto" })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-md-5 border-azul rounded shadow",
	                  style: { backgroundColor: "#dbeeff" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "SUBTOTAL: ",
	                    moneda.simbolo
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtSubTotal,
	                    value: (0, _varios.formatMoneda)(totales.subtotal.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "DESCUENTO: ",
	                    moneda.simbolo
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtDescuento,
	                    value: (0, _varios.formatMoneda)(totales.descuento.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "TOTAL IVA: ",
	                    moneda.simbolo
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtTotIva,
	                    value: (0, _varios.formatMoneda)(totales.totaliva.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "TOTAL: ",
	                    moneda.simbolo
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtTotal,
	                    value: (0, _varios.formatMoneda)(totales.total.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "ABONO: ",
	                    moneda.simbolo
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtAbono,
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "SALDO: ",
	                    moneda.simbolo
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtSaldo,
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          className: "btn btn-sm btn-success rounded-pill",
	          onClick: onChangeValidar,
	          style: { margin: "5px" }
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Registrar Pago"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          onClick: imprimirNotaEntrega,
	          style: { margin: "5px" },
	          className: "btn btn-sm btn-primary rounded-pill",
	          title: "Imprimir Nota de Entrega"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fa fa-print" },
	          " Imprimir"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    ),
	    _react2.default.createElement(_modalRegistrarPago.RegistrarPago, {
	      show: mostrar,
	      tipo: "notaentrega",
	      abonos: props.abono,
	      esretenedor: esretencion,
	      anticipo: props.anticipo,
	      idvendedor: idVendedor,
	      idfactu: idfact,
	      numfactu: numfact,
	      siescredit: actcredit,
	      siesanticipo: actanticipo,
	      idclient: idCliente,
	      iva: xiva,
	      montoiva: montoiva,
	      ope: 1,
	      monto: monto,
	      idmoned: moneda.idmoneda,
	      onRenderizar: renderizar,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar(false);
	      }
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "Cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = RegistrarPagoNotadeEntrega;

/***/ },
/* 7129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _catalogodePagos = __webpack_require__(7042);
	
	var _catalogodePagos2 = _interopRequireDefault(_catalogodePagos);
	
	var _catalogoSupervisor = __webpack_require__(7038);
	
	var _catalogoSupervisor2 = _interopRequireDefault(_catalogoSupervisor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReversarTransaccion = function ReversarTransaccion() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
	  var accbtnndebito = JSON.parse(sessionStorage.getItem("accbtnndebitoc"));
	  var cmbCedula = ["J", "V", "G", "P"];
	
	  var headCells = [{ label: "FORMA DE PAGO", textAlign: "center" }, { label: "MONTO", textAlign: "center" }, { label: "MONTO AL CAMBIO", textAlign: "center" }];
	
	  var txtFecha = (0, _react.useRef)();
	  var txtConcepto = (0, _react.useRef)();
	  var txtMotivo = (0, _react.useRef)();
	  var btnConsultar = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnProducto = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtNumAnticipo = (0, _react.useRef)();
	  var txtRifVende = (0, _react.useRef)();
	  var txtDias = (0, _react.useRef)();
	  var txtFechaVencimiento = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      idpago = _useState2[0],
	      setIdPago = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      body = _useState4[0],
	      setBody = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      habilitado = _useState6[0],
	      setHabilitado = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(true),
	      _useState8 = _slicedToArray(_useState7, 2),
	      habilitadoAceptar = _useState8[0],
	      setHabilitadoAceptar = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(true),
	      _useState10 = _slicedToArray(_useState9, 2),
	      habilitarCat = _useState10[0],
	      setHabilitarCat = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(true),
	      _useState12 = _slicedToArray(_useState11, 2),
	      habilitadoBot = _useState12[0],
	      setHabilitadoBot = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      habilitadoCli = _useState14[0],
	      setHabilitadoCli = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(""),
	      _useState16 = _slicedToArray(_useState15, 2),
	      numNota = _useState16[0],
	      setNumNota = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(""),
	      _useState18 = _slicedToArray(_useState17, 2),
	      tipoPago = _useState18[0],
	      setTipoPago = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(""),
	      _useState20 = _slicedToArray(_useState19, 2),
	      cedRif = _useState20[0],
	      setCedRif = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(""),
	      _useState22 = _slicedToArray(_useState21, 2),
	      nomVendedor = _useState22[0],
	      setNomVendedor = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(""),
	      _useState24 = _slicedToArray(_useState23, 2),
	      nomCliente = _useState24[0],
	      setNomCliente = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(""),
	      _useState26 = _slicedToArray(_useState25, 2),
	      dirCliente = _useState26[0],
	      setDirCliente = _useState26[1];
	
	  var _useState27 = (0, _react.useState)([]),
	      _useState28 = _slicedToArray(_useState27, 2),
	      combomoneda = _useState28[0],
	      setComboMoneda = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(0.0),
	      _useState30 = _slicedToArray(_useState29, 2),
	      totaldolares = _useState30[0],
	      setTotaldolares = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(0.0),
	      _useState32 = _slicedToArray(_useState31, 2),
	      totales = _useState32[0],
	      setTotales = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(false),
	      _useState34 = _slicedToArray(_useState33, 2),
	      mostrar = _useState34[0],
	      setMostrar = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(false),
	      _useState36 = _slicedToArray(_useState35, 2),
	      mostrar1 = _useState36[0],
	      setMostrar1 = _useState36[1];
	
	  var _useState37 = (0, _react.useState)([]),
	      _useState38 = _slicedToArray(_useState37, 2),
	      records = _useState38[0],
	      setRecords = _useState38[1];
	
	  var _useState39 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState40 = _slicedToArray(_useState39, 2),
	      mensaje = _useState40[0],
	      setMensaje = _useState40[1];
	
	  var _useState41 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState42 = _slicedToArray(_useState41, 2),
	      mensajesino = _useState42[0],
	      setMensajesino = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(false),
	      _useState44 = _slicedToArray(_useState43, 2),
	      activate = _useState44[0],
	      setActivate = _useState44[1];
	
	  var _useState45 = (0, _react.useState)("visible"),
	      _useState46 = _slicedToArray(_useState45, 2),
	      visibleBtn = _useState46[0],
	      setVisibleBtn = _useState46[1];
	
	  var handleInputNumeroChange = function handleInputNumeroChange(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "idnotaentre") {
	          seleccionarAnticipo(event.target.value);
	        }
	      }
	    }
	  };
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells, {
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var blanquear = function blanquear() {
	    cmbRif.current.selectedIndex = -1;
	    txtRif.current.value = "";
	    txtNumAnticipo.current.value = "";
	    txtFecha.current.value = "";
	    txtConcepto.current.value = "";
	    txtMotivo.current.value = "";
	    txtMotivo.current.setAttribute("disabled", "disabled");
	    btnCancela.current.focus();
	    setBody();
	    setActivate(false);
	    setHabilitado(false);
	    setHabilitadoCli(false);
	    setHabilitadoBot(true);
	    setHabilitarCat(true);
	    setHabilitadoAceptar(true);
	    setIdPago(null);
	    setVisibleBtn("visible");
	    setNumNota("");
	    setTipoPago("");
	    setNomCliente("");
	    setDirCliente("");
	    setNomVendedor("");
	    setCedRif("");
	    setRecords([]);
	    setTotaldolares(0.0);
	    setTotales(0.0);
	    setMostrar1(false);
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var handleCloseMensaje = function handleCloseMensaje() {
	    if (mensaje.titulo === "Exito.") {
	      blanquear();
	    }
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var seleccionarCliente = function seleccionarCliente(rif, tecla, ids) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "";
	    var nomid2 = "cliente";
	    var id = void 0;
	    if (rif === 0 && tecla === 0) {
	      nomid = "idagente";
	      id = ids;
	    } else {
	      nomid = "rif";
	      id = rif;
	    }
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          cmbRif.current.value = response.data.rif.trim().substring(0, 1);
	          txtRif.current.value = response.data.rif.trim().substring(1, 10);
	          setNomCliente(response.data.nombre);
	          setDirCliente(response.data.direccion.trim());
	          if (tecla === 13) {
	            txtFecha.current.focus();
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un cliente con este codigo",
	            icono: "informacion"
	          });
	          txtRif.current.value = "";
	          cmbRif.current.selectedIndex = -1;
	          if (tecla === 13) {
	            txtRif.current.focus();
	          }
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarVendedor = function seleccionarVendedor(idv) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "idagente";
	    var nomid2 = "vendedor";
	    var id = idv === null ? "0" : idv;
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setCedRif(response.data.rif);
	          setNomVendedor(response.data.nombre);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El usuario no tiene un vendedor asociado",
	            icono: "informacion"
	          });
	          blanquear();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarDetalle = function seleccionarDetalle(id, vmoney) {
	    var campos = "*";
	    var nomtab = "pagodetalle";
	    var nomid = "idpago";
	    var endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          var datos = [];
	          var idmoney = void 0;
	          var predeterminada = 0.0;
	          var valormoney = 0.0;
	          var simbolo = void 0;
	
	          for (var i = 0; i < response.data.length; i++) {
	            idmoney = response.data[i].idmoneda;
	
	            for (var a = 0; a < combomoneda.length; a++) {
	              if (parseInt(combomoneda[a].idmoneda) === parseInt(idmoney)) {
	                simbolo = combomoneda[a].simbolo;
	
	                if (combomoneda[a].subpredeterminada === true) {
	                  valormoney = response.data[i].factorcambio;
	                  predeterminada = response.data[i].factorcambio;
	                } else {
	                  valormoney = response.data[i].factorcambio;
	                  predeterminada = response.data[i].factorcambio;
	                }
	              }
	            }
	
	            datos.push({
	              forma: response.data[i].tipo === "1" ? "Efectivo Bs" : response.data[i].tipo === "2" ? "Tarjeta(Debito) Bs" : response.data[i].tipo === "3" ? "Tarjeta(Crédito) Bs" : response.data[i].tipo === "4" ? "Pago Movil Bs" : response.data[i].tipo === "5" ? "Deposito Bancario Bs" : response.data[i].tipo === "6" ? "Transferencia Bancaria Bs" : "Divisa" + " " + simbolo,
	              montos: response.data[i].monto,
	              fechapago: response.data[i].fechaemision,
	              tipodivisa: response.data[i].idmoneda,
	              montoalcambio: response.data[i].tipo === "7" ? response.data[i].monto * parseFloat(valormoney) : response.data[i].monto,
	              montodefinic: response.data[i].tipo === "7" ? response.data[i].monto * parseFloat(valormoney) / parseFloat(predeterminada) : response.data[i].monto / parseFloat(predeterminada),
	              notacredito: response.data[i].numcredito,
	              valormoneda: response.data[i].factorcambio,
	              idbanco: response.data[i].idcuenta,
	              referencia: response.data[i].nroreferencia,
	              simbolo: simbolo
	            });
	          }
	
	          var montototal = 0.0;
	
	          for (var e = 0; e < datos.length; e++) {
	            montototal = parseFloat(montototal) + parseFloat(datos[e].montoalcambio);
	          }
	
	          setRecords(datos);
	          setTotales(montototal);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarAnticipo = function seleccionarAnticipo(num) {
	    var campos = "*";
	    var nomtab = "registropago";
	    var nomid = "numpago";
	    var id = num;
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          var montod = 0.0;
	
	          txtFecha.current.value = (0, _moment2.default)(response.data.fecharegistro).format("YYYY-MM-DD");
	          txtConcepto.current.value = response.data.concepto;
	          setIdPago(response.data.idpago);
	          seleccionarCliente(0, 0, response.data.idcliente);
	          seleccionarVendedor(response.data.idvendedor);
	          setNumNota(response.data.numpago);
	          setTipoPago(response.data.tipofac);
	          seleccionarDetalle(response.data.idpago, response.data.valormoneda);
	          montod = response.data.total;
	          setTotaldolares(montod);
	
	          if (response.data.statusreverso === 1) {
	            setHabilitadoAceptar(true);
	            txtMotivo.current.setAttribute("disabled", "disabled");
	            btnCancela.current.focus();
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "Este Pago ya fue Revesado el dia " + (0, _moment2.default)(response.data.fechareverso).format("YYYY-MM-DD"),
	              icono: "informacion"
	            });
	          } else if (response.data.tipofac === "AN" && response.data.status === 1) {
	            setHabilitadoAceptar(true);
	            txtMotivo.current.setAttribute("disabled", "disabled");
	            btnCancela.current.focus();
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "\xA1 Este Anticipo fue Utilizado en la Nota de Entrega N\xB0 " + response.data.numfactura + " !",
	              icono: "informacion"
	            });
	          } else {
	            setHabilitadoAceptar(false);
	            txtMotivo.current.removeAttribute("disabled");
	            setTimeout(function () {
	              return txtMotivo.current.focus();
	            }, 300);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un Pago con este Código",
	            icono: "informacion"
	          });
	          blanquear();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      blanquear();
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarMonedas = function seleccionarMonedas() {
	    var campos = "*";
	    var nomtab = "moneda";
	    var orden = "idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setComboMoneda(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	
	    if (idpago !== null) {
	      if (txtFecha.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Seleccione la Fecha !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtFecha.current.focus();
	      } else if (txtRif.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Seleccione el Cliente !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtRif.current.focus();
	      } else if (txtRifVende.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Los Datos del Vendedor no deben ir Vacios !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtRifVende.current.focus();
	      } else if (txtConcepto.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Describa el Concepto del Pago !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtConcepto.current.focus();
	      } else if (txtMotivo.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Describa el Motivo del reverso !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtMotivo.current.focus();
	      } else if (records.length <= 0) {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Introduzca el Pago !",
	          icono: "informacion"
	        });
	        sigue = false;
	      } else {
	        sigue = true;
	      }
	
	      if (sigue) {
	        setBody({
	          fechareverso: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	          fechapago: txtFecha.current.value,
	          idpago: idpago,
	          idusuario: idVendedor,
	          post: false,
	          motivo: txtMotivo.current.value
	        });
	
	        setMensajesino({
	          mostrar: true,
	          titulo: "Confirmación.",
	          texto: "Esta Seguro de Reversar este Pago.",
	          icono: "confirmacion"
	        });
	      }
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/Caja_Ingreso/reversarpago";
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idcaja === idpago) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "El Pago Fue Reversado Correctamente",
	            icono: "exito"
	          });
	        }
	      }
	    }).catch(function (error) {
	      var mensaje = error.response.data.message;
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    event.preventDefault();
	    if (event.which === 13) {
	      if (event.target.name === "fecha") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	        btnProducto.current.focus();
	      } else if (event.target.name === "dias") {
	        var dias = txtDias.current.value;
	        if (txtDias.current.value > 0) {
	          var fechaV = (0, _moment2.default)(fechasistema).add(dias.toString(), "days").format("YYYY-MM-DD");
	          var cambia = event.target.value;
	          var dd = dias === cambia ? cambia : txtFechaVencimiento.current.value.substring(8, 10);
	
	          if (event.target.value !== dd) {
	            var _fechaV = (0, _moment2.default)(fechasistema).add(dias.toString(), "days").format("YYYY-MM-DD");
	          }
	        }
	      }
	    } else if (typeof event.which === "undefined") {
	      if (event.target.name === "fecha") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var handleAceptaDatosAnticipos = function handleAceptaDatosAnticipos(values) {
	    setMostrar(false);
	
	    txtNumAnticipo.current.value = values.numpago.trim();
	    seleccionarAnticipo(values.numpago);
	  };
	
	  /* const onReversar = (value) => {
	    if (value === "AUTORIZADO") {
	      setHabilitadoBot(false);
	      setVisibleBtn("hidden");
	      setHabilitarCat(false);
	      setHabilitado(false);
	      setHabilitadoCli(false);
	      setTimeout(() => txtNumAnticipo.current.focus(), 300);
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error",
	      });
	    }
	  }; */
	
	  var onReversar = function onReversar(e) {
	    e.preventDefault();
	    if (accbtnndebito && accbtnndebito.toString().substring(2, 3) === "1") {
	      setHabilitadoBot(false);
	      setVisibleBtn("hidden");
	      setHabilitarCat(false);
	      setHabilitado(false);
	      setHabilitadoCli(false);
	      setTimeout(function () {
	        return txtNumAnticipo.current.focus();
	      }, 300);
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarMonedas();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 ", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-11 mx-auto py-2 card shadow h-100" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row border-azul mx-auto justify-content-between rounded py-1" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 row mx-auto d-flex justify-content-between mb-1",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-2 azulGradiant shadow text-light justify-content-between" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-3" },
	                  _react2.default.createElement(
	                    "h3",
	                    null,
	                    "Reversar Pagos"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-2 d-flex justify-content-end" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/inicio", className: "text-light " },
	                    _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "fw-bold" },
	                      "Salir"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "colfull col-pd-300" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "N\xB0 PAGO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: habilitarCat,
	                    ref: txtNumAnticipo,
	                    autoComplete: "off",
	                    name: "idnotaentre",
	                    onChange: function onChange(e) {
	                      return e.target.value = e.target.value.toUpperCase();
	                    },
	                    onKeyUp: handleInputNumeroChange,
	                    onBlur: handleInputNumeroChange,
	                    className: "form-control form-control-lg",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: habilitarCat,
	                      type: "button",
	                      onClick: function onClick() {
	                        return setMostrar(true);
	                      },
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-240 mx-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA:"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "date",
	                    disabled: !habilitado,
	                    ref: txtFecha,
	                    className: "form-control text-uppercase fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    name: "fecha",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "colfull col400" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "text-end" },
	                  "TIPO DE PAGO:",
	                  tipoPago !== "" && _react2.default.createElement(
	                    "span",
	                    { className: "col fw-bold text-danger" },
	                    tipoPago === "AN" ? " ANTICIPO" : "NOTA DE ENTREGA"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "colfull1070 colfull60p mx-auto mb-1",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row border-azul rounded" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold" },
	                  "Datos del Cliente"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-1 col-md-5" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: cmbRif,
	                      name: "cmbrif",
	                      disabled: !habilitadoCli,
	                      className: "form-select form-select-sm col-md-3 text-center ",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "--"
	                    ),
	                    cmbCedula && cmbCedula.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item },
	                        item
	                      );
	                    })
	                  ),
	                  _react2.default.createElement("input", {
	                    ref: txtRif,
	                    autoComplete: "off",
	                    disabled: !habilitadoCli,
	                    maxLength: 9,
	                    type: "text",
	                    className: "form-control fs-6",
	                    name: "cedula",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-1 col-md-7" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "NOMBRE:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: nomCliente
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-1 col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "DIRECCION:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: dirCliente
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "colfull1070 colfull40p mx-auto mb-1 row",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row border-azul rounded" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold" },
	                  "Datos del Vendedor"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm col-pd-240 px-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm",
	                      style: { height: "85%" }
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    ref: txtRifVende,
	                    className: "form-control fs-6",
	                    style: { height: "85%" },
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: cedRif
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm",
	                      style: { height: "85%" }
	                    },
	                    "NOMBRE:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    style: { height: "85%" },
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: nomVendedor
	                  })
	                )
	              ),
	              _react2.default.createElement("div", { className: "col-md-6" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row mx-auto px-0 m-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-1 px-0 border-azul rounded col-md-12" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "CONCEPTO:"
	                ),
	                _react2.default.createElement("textarea", {
	                  className: "form-control uppercase fs-6",
	                  ref: txtConcepto,
	                  disabled: !habilitado,
	                  "aria-label": "With textarea",
	                  style: { minHeight: 50 },
	                  defaultValue: ""
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-12 px-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-12 px-0" },
	                  _react2.default.createElement(
	                    TblContainer,
	                    {
	                      container: {
	                        height: "280px",
	                        width: "100%",
	                        overflow: "auto",
	                        padding: "2px"
	                      }
	                    },
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                      _semanticUiReact.TableBody,
	                      { className: "overflow-hidden table-bordered" },
	                      records && records.map(function (item, index) {
	                        return _react2.default.createElement(
	                          _semanticUiReact.TableRow,
	                          {
	                            key: index,
	                            style: { padding: "0", cursor: "pointer" }
	                          },
	                          _react2.default.createElement(
	                            _semanticUiReact.TableCell,
	                            { className: "align-baseline text-center" },
	                            item.forma
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.TableCell,
	                            { className: "align-middle text-right" },
	                            (0, _varios.formatMoneda)(item.montos.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.TableCell,
	                            { className: "align-baseline text-right" },
	                            (0, _varios.formatMoneda)(item.montoalcambio.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                          )
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "col-12 px-0 row m-0 d-flex align-items-center border-azul",
	                    style: { borderRadius: "3px", fontSizeAdjust: "0.5" }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-12 row m-0 px-0 border-azul" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-8 px-0" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm px-0 border-azul rounded col-md-12" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "MOTIVO REVERSO:"
	                        ),
	                        _react2.default.createElement("textarea", {
	                          className: "form-control uppercase fs-6",
	                          ref: txtMotivo,
	                          disabled: true,
	                          autoComplete: "off",
	                          onChange: function onChange(e) {
	                            return e.target.value = e.target.value.toUpperCase();
	                          },
	                          "aria-label": "With textarea",
	                          style: { minHeight: 70 },
	                          defaultValue: ""
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "col-4 ml-auto px-0 row m-0 d-flex align-items-center border-azul py-2",
	                        style: {
	                          background: "#cfe2ff",
	                          borderRadius: "3px",
	                          fontSizeAdjust: "0.5"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          className: "col-12 row m-0",
	                          style: { fontSizeAdjust: "0.5" }
	                        },
	                        _react2.default.createElement(
	                          "label",
	                          { className: "col-4 px-1 text-left fs-5" },
	                          "Total $:",
	                          " "
	                        ),
	                        _react2.default.createElement(
	                          "span",
	                          { className: "col px-0 fw-bold text-right fs-5" },
	                          "\xA0",
	                          (0, _varios.formatMoneda)(totaldolares.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          className: "col-12 row m-0",
	                          style: { fontSizeAdjust: "0.5" }
	                        },
	                        _react2.default.createElement(
	                          "label",
	                          { className: "col-4 px-1 text-left fs-5" },
	                          "Total Bs:",
	                          " "
	                        ),
	                        _react2.default.createElement(
	                          "span",
	                          { className: "col px-0 fw-bold text-right fs-5" },
	                          "\xA0",
	                          (0, _varios.formatMoneda)(totales.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "colfull40p row m-0" },
	              _react2.default.createElement("div", { className: "col-md-12" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 mt-auto px-0" },
	              visibleBtn === "visible" ? _react2.default.createElement(
	                "div",
	                { className: "col-pd-botones" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-150 row m-0 px-0" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoBot,
	                      ref: btnConsultar,
	                      onClick: onReversar,
	                      className: "btn btn-sm col ml-1 btn-info rounded-pill",
	                      title: "Reversar Pago"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-eye" },
	                      " Reversar"
	                    ),
	                    " "
	                  )
	                )
	              ) : _react2.default.createElement(
	                "div",
	                { className: "col-pd-botonesd row m-0 ml-auto" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta,
	                    disabled: habilitadoAceptar,
	                    onClick: onChangeValidar,
	                    className: "btn btn-sm col ml-1 rounded-pill btn-success"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-check-circle" },
	                    " ACEPTAR"
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnCancela,
	                    disabled: habilitadoBot,
	                    onClick: blanquear,
	                    className: "btn btn-danger col ml-1 btn-sm rounded-pill"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-window-close" },
	                    " Cancelar"
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogodePagos2.default, {
	      show: mostrar,
	      condi: "statusreverso isnull and status != 4",
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar(false);
	      },
	      onHideAceptaCatalogo: handleAceptaDatosAnticipos
	    }),
	    _react2.default.createElement(_catalogoSupervisor2.default, {
	      show: mostrar1,
	      ope: 3,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar1(false);
	      },
	      onHideAceptaCatalogo: onReversar
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje, onHide: handleCloseMensaje }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = ReversarTransaccion;

/***/ },
/* 7130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _modalAgreProcesosMontosAnticipo = __webpack_require__(7116);
	
	var _catalogoAnticipos = __webpack_require__(122);
	
	var _catalogoAnticipos2 = _interopRequireDefault(_catalogoAnticipos);
	
	var _modalImagenAnticipo = __webpack_require__(7117);
	
	var _modalImagenDivisa = __webpack_require__(7118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var TablaAnticipos = function TablaAnticipos() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var accbtnndebito = JSON.parse(sessionStorage.getItem("accbtnndebitoc"));
	  var ncaja = JSON.parse(sessionStorage.getItem("numcaja"));
	  var cmbCedula = ["J", "V", "G", "P"];
	
	  var headCells = [{ label: "FORMA DE PAGO", textAlign: "center" }, { label: "MONTO", textAlign: "center" }, { label: "MONTO AL CAMBIO", textAlign: "center" }, { label: "", textAlign: "center" }];
	
	  var txtFecha = (0, _react.useRef)();
	  var txtConcepto = (0, _react.useRef)();
	  var btnIncluir = (0, _react.useRef)();
	  var btnConsultar = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnProducto = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtNumAnticipo = (0, _react.useRef)();
	  var txtRifVende = (0, _react.useRef)();
	  var txtDias = (0, _react.useRef)();
	  var txtFechaVencimiento = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      body = _useState2[0],
	      setBody = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      operacion = _useState4[0],
	      setOperacion = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      opea = _useState6[0],
	      setOpea = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      habilitado = _useState8[0],
	      setHabilitado = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(true),
	      _useState10 = _slicedToArray(_useState9, 2),
	      habilitarCat = _useState10[0],
	      setHabilitarCat = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(true),
	      _useState12 = _slicedToArray(_useState11, 2),
	      habilitadoBot = _useState12[0],
	      setHabilitadoBot = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      habilitadoCli = _useState14[0],
	      setHabilitadoCli = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(""),
	      _useState16 = _slicedToArray(_useState15, 2),
	      numNota = _useState16[0],
	      setNumNota = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(""),
	      _useState18 = _slicedToArray(_useState17, 2),
	      cedRif = _useState18[0],
	      setCedRif = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(""),
	      _useState20 = _slicedToArray(_useState19, 2),
	      nomVendedor = _useState20[0],
	      setNomVendedor = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      idmone = _useState22[0],
	      setIdmone = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0.0),
	      _useState24 = _slicedToArray(_useState23, 2),
	      valormone = _useState24[0],
	      setValormone = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(""),
	      _useState26 = _slicedToArray(_useState25, 2),
	      idCliente = _useState26[0],
	      setIdCliente = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(""),
	      _useState28 = _slicedToArray(_useState27, 2),
	      nomCliente = _useState28[0],
	      setNomCliente = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(""),
	      _useState30 = _slicedToArray(_useState29, 2),
	      dirCliente = _useState30[0],
	      setDirCliente = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(0),
	      _useState32 = _slicedToArray(_useState31, 2),
	      visible = _useState32[0],
	      setVisible = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(0),
	      _useState34 = _slicedToArray(_useState33, 2),
	      desde = _useState34[0],
	      setDesde = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(false),
	      _useState36 = _slicedToArray(_useState35, 2),
	      habilitarMoneda = _useState36[0],
	      setHabilitarMoneda = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(false),
	      _useState38 = _slicedToArray(_useState37, 2),
	      modalAnticipo = _useState38[0],
	      setModalAnticipo = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(false),
	      _useState40 = _slicedToArray(_useState39, 2),
	      modalDivisa = _useState40[0],
	      setModalDivisa = _useState40[1];
	
	  var _useState41 = (0, _react.useState)([]),
	      _useState42 = _slicedToArray(_useState41, 2),
	      combomoneda = _useState42[0],
	      setComboMoneda = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(null),
	      _useState44 = _slicedToArray(_useState43, 2),
	      imagenanticipo = _useState44[0],
	      setImagenanticipo = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(null),
	      _useState46 = _slicedToArray(_useState45, 2),
	      imagendivisa = _useState46[0],
	      setImagendivisa = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(0),
	      _useState48 = _slicedToArray(_useState47, 2),
	      idvende = _useState48[0],
	      setIdvende = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(""),
	      _useState50 = _slicedToArray(_useState49, 2),
	      numfactu = _useState50[0],
	      setNumfactu = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(0.0),
	      _useState52 = _slicedToArray(_useState51, 2),
	      totalmoneda = _useState52[0],
	      setTotalmoneda = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(0.0),
	      _useState54 = _slicedToArray(_useState53, 2),
	      totaldolares = _useState54[0],
	      setTotaldolares = _useState54[1];
	
	  var _useState55 = (0, _react.useState)(""),
	      _useState56 = _slicedToArray(_useState55, 2),
	      estatusa = _useState56[0],
	      setEstatusa = _useState56[1];
	
	  var _useState57 = (0, _react.useState)(""),
	      _useState58 = _slicedToArray(_useState57, 2),
	      estatusreve = _useState58[0],
	      setEstatusreve = _useState58[1];
	
	  var _useState59 = (0, _react.useState)(0.0),
	      _useState60 = _slicedToArray(_useState59, 2),
	      totales = _useState60[0],
	      setTotales = _useState60[1];
	
	  var _useState61 = (0, _react.useState)(false),
	      _useState62 = _slicedToArray(_useState61, 2),
	      mostrar = _useState62[0],
	      setMostrar = _useState62[1];
	
	  var _useState63 = (0, _react.useState)([]),
	      _useState64 = _slicedToArray(_useState63, 2),
	      records = _useState64[0],
	      setRecords = _useState64[1];
	
	  var _useState65 = (0, _react.useState)("Gestionar Anticipos."),
	      _useState66 = _slicedToArray(_useState65, 2),
	      tituloHeader = _useState66[0],
	      setTituloHeader = _useState66[1];
	
	  var _useState67 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState68 = _slicedToArray(_useState67, 2),
	      mensaje = _useState68[0],
	      setMensaje = _useState68[1];
	
	  var _useState69 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState70 = _slicedToArray(_useState69, 2),
	      mensajesino = _useState70[0],
	      setMensajesino = _useState70[1];
	
	  var _useState71 = (0, _react.useState)({
	    idmoneda: "1",
	    descripcion: "BOLIVARES",
	    simbolo: "Bs",
	    predeterminada: true,
	    subpredeterminada: false,
	    valormoneda: 1.0
	  }),
	      _useState72 = _slicedToArray(_useState71, 2),
	      moneda = _useState72[0],
	      setMoneda = _useState72[1];
	
	  var _useState73 = (0, _react.useState)({
	    idmoneda: "2",
	    descripcion: "DOLARES",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 0.0
	  }),
	      _useState74 = _slicedToArray(_useState73, 2),
	      monedaSub = _useState74[0],
	      setMonedaSub = _useState74[1];
	
	  var _useState75 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState76 = _slicedToArray(_useState75, 2),
	      filterFn = _useState76[0],
	      setFilterFn = _useState76[1];
	
	  var _useState77 = (0, _react.useState)(false),
	      _useState78 = _slicedToArray(_useState77, 2),
	      mostrar1 = _useState78[0],
	      setMostrar1 = _useState78[1];
	
	  var _useState79 = (0, _react.useState)(false),
	      _useState80 = _slicedToArray(_useState79, 2),
	      catalogoCliente = _useState80[0],
	      setCatalogoCliente = _useState80[1];
	
	  var _useState81 = (0, _react.useState)(false),
	      _useState82 = _slicedToArray(_useState81, 2),
	      catalogoNota = _useState82[0],
	      setCatalogoNota = _useState82[1];
	
	  var _useState83 = (0, _react.useState)(false),
	      _useState84 = _slicedToArray(_useState83, 2),
	      activate = _useState84[0],
	      setActivate = _useState84[1];
	
	  var _useState85 = (0, _react.useState)("visible"),
	      _useState86 = _slicedToArray(_useState85, 2),
	      visibleBtn = _useState86[0],
	      setVisibleBtn = _useState86[1];
	
	  var handleInputNumeroChange = function handleInputNumeroChange(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "idnotaentre") {
	          seleccionarAnticipo(event.target.value);
	        }
	      }
	    }
	  };
	
	  var validarCliente = function validarCliente(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (cmbRif.current.value !== "" && event.target.value !== "") {
	        var rif = cmbRif.current.value + event.target.value;
	        seleccionarCliente(rif, event.which);
	      }
	    }
	  };
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells, filterFn),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var blanquear = function blanquear() {
	    setTituloHeader("Gestionar Anticipos.");
	    setBody();
	    setActivate(false);
	    setOperacion(0);
	    setHabilitado(false);
	    setHabilitarMoneda(false);
	    setHabilitadoCli(false);
	    setHabilitadoBot(true);
	    setHabilitarCat(true);
	    setImagenanticipo(null);
	    setImagendivisa(null);
	    setVisible(0);
	    setIdvende(0);
	    setVisibleBtn("visible");
	    setMoneda({
	      idmoneda: "1",
	      descripcion: "BOLIVARES",
	      simbolo: "Bs",
	      predeterminada: false,
	      valormoneda: 1.0
	    });
	    cmbRif.current.selectedIndex = -1;
	    txtRif.current.value = "";
	    txtNumAnticipo.current.value = "";
	    setNumNota("");
	    setNomCliente("");
	    setDirCliente("");
	    setNomVendedor("");
	    setCedRif("");
	    txtFecha.current.value = "";
	    txtConcepto.current.value = "";
	    setRecords([]);
	    setTotaldolares(0.0);
	    setTotales(0.0);
	    setTotalmoneda(0.0);
	    setEstatusa("");
	    setEstatusreve("");
	    setNumfactu("");
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var handleCloseMensaje = function handleCloseMensaje() {
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    if (desde === 3) {
	      setDesde(0);
	      window.location.href = "/inicio";
	    } else if (desde === 4) {
	      setDesde(0);
	    }
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "cedula") {
	      setIdCliente();
	      setNomCliente("");
	      setDirCliente("");
	    }
	  };
	
	  var seleccionarCliente = function seleccionarCliente(rif, tecla, ids) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "";
	    var nomid2 = "cliente";
	    var id = void 0;
	    if (rif === 0 && tecla === 0) {
	      nomid = "idagente";
	      id = ids;
	    } else {
	      nomid = "rif";
	      id = rif;
	    }
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          cmbRif.current.value = response.data.rif.trim().substring(0, 1);
	          txtRif.current.value = response.data.rif.trim().substring(1, 10);
	          setIdCliente(response.data.idagente);
	          setNomCliente(response.data.nombre);
	          setDirCliente(response.data.direccion.trim());
	          if (tecla === 13) {
	            txtFecha.current.focus();
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un cliente con este codigo",
	            icono: "informacion"
	          });
	          txtRif.current.value = "";
	          cmbRif.current.selectedIndex = -1;
	          if (tecla === 13) {
	            txtRif.current.focus();
	          }
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarVendedor = function seleccionarVendedor(idv) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "idagente";
	    var nomid2 = "vendedor";
	    var id = idv === null ? "0" : idv;
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setCedRif(response.data.rif);
	          setNomVendedor(response.data.nombre);
	          setIdvende(response.data.idagente);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El usuario no tiene un vendedor asociado",
	            icono: "informacion"
	          });
	          blanquear();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarDetalle = function seleccionarDetalle(id, vmoney) {
	    var campos = "*";
	    var nomtab = "pagodetalle";
	    var nomid = "idpago";
	    var endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          var datos = [];
	          var idmoney = void 0;
	          var predeterminada = 0.0;
	          var valormoney = 0.0;
	          var simbolo = void 0;
	
	          for (var i = 0; i < response.data.length; i++) {
	            idmoney = response.data[i].idmoneda;
	
	            for (var a = 0; a < combomoneda.length; a++) {
	              if (parseInt(combomoneda[a].idmoneda) === parseInt(idmoney)) {
	                simbolo = combomoneda[a].simbolo;
	
	                if (combomoneda[a].subpredeterminada === true) {
	                  valormoney = response.data[i].factorcambio;
	                  predeterminada = response.data[i].factorcambio;
	                } else {
	                  valormoney = response.data[i].factorcambio;
	                  predeterminada = response.data[i].factorcambio;
	                }
	              }
	            }
	
	            datos.push({
	              forma: response.data[i].tipo === "1" ? "Efectivo Bs" : response.data[i].tipo === "2" ? "Tarjeta(Debito) Bs" : response.data[i].tipo === "3" ? "Tarjeta(Crédito) Bs" : response.data[i].tipo === "4" ? "Pago Movil Bs" : response.data[i].tipo === "5" ? "Deposito Bancario Bs" : response.data[i].tipo === "6" ? "Transferencia Bancaria Bs" : "Divisa" + " " + simbolo,
	              montos: response.data[i].monto,
	              fechapago: response.data[i].fechaemision,
	              tipodivisa: response.data[i].idmoneda,
	              montoalcambio: response.data[i].tipo === "7" ? response.data[i].monto * parseFloat(valormoney) : response.data[i].monto,
	              montodefinic: response.data[i].tipo === "7" ? response.data[i].monto * parseFloat(valormoney) / parseFloat(predeterminada) : response.data[i].monto / parseFloat(predeterminada),
	              notacredito: response.data[i].numcredito,
	              valormoneda: response.data[i].factorcambio,
	              idbanco: response.data[i].idcuenta,
	              referencia: response.data[i].nroreferencia,
	              simbolo: simbolo
	            });
	          }
	
	          var montototal = 0.0;
	
	          for (var e = 0; e < datos.length; e++) {
	            montototal = parseFloat(montototal) + parseFloat(datos[e].montoalcambio);
	          }
	
	          setRecords(datos);
	          setTotales(montototal);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarAnticipo = function seleccionarAnticipo(num) {
	    var campos = "*";
	    var nomtab = "registropago";
	    var nomid = "numpago";
	    var nomid2 = "tipofac";
	    var id = num;
	    var tipo = "AN";
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=" + tipo;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          var montod = 0.0;
	
	          seleccionarCliente(0, 0, response.data.idcliente);
	          seleccionarVendedor(response.data.idvendedor);
	          setNumNota(response.data.numpago);
	
	          setEstatusa(response.data.status);
	          setEstatusreve(response.data.statusreverso);
	
	          setNumfactu(response.data.numfactura);
	          txtFecha.current.value = (0, _moment2.default)(response.data.fecharegistro).format("YYYY-MM-DD");
	          txtConcepto.current.value = response.data.concepto.trim();
	          seleccionarDetalle(response.data.idpago, response.data.valormoneda);
	          setTotalmoneda(parseFloat(response.data.valormoneda));
	
	          if (response.data.imagenanticipo === "subir.png") {
	            setImagenanticipo(null);
	          } else {
	            setImagenanticipo(response.data.imagenanticipo);
	          }
	
	          if (response.data.imagendivisa === "subir.png") {
	            setImagendivisa(null);
	          } else {
	            setImagendivisa(response.data.imagendivisa);
	          }
	
	          montod = response.data.total;
	          setTotaldolares(montod);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un Anticipo con este Código",
	            icono: "informacion"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var onCatalogoCliente = function onCatalogoCliente(values) {
	    setCatalogoCliente(false);
	    cmbRif.current.value = values.rif.substring(0, 1);
	    txtRif.current.value = values.rif.substring(1);
	    setIdCliente(values.idagente);
	    setNomCliente(values.nombre);
	    setDirCliente(values.direccion);
	  };
	
	  var seleccionarMonedas = function seleccionarMonedas() {
	    var campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	    var nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	    var orden = "m.idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setComboMoneda(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	    if (opea === 1) {
	      if (txtFecha.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Seleccione la Fecha !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtFecha.current.focus();
	      } else if (txtRif.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Seleccione el Cliente !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtRif.current.focus();
	      } else if (txtRifVende.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Los Datos del Vendedor no deben ir Vacios !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtRifVende.current.focus();
	      } else if (txtConcepto.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Describa el Concepto del Anticipo !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtConcepto.current.focus();
	      } else if (records.length <= 0) {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Introduzca el Pago !",
	          icono: "informacion"
	        });
	        sigue = false;
	      } else {
	        sigue = true;
	      }
	
	      if (sigue) {
	        var pago = [];
	        var pagodetalle = [];
	        var montosd = "0.00";
	
	        pago.push({
	          idpago: 0,
	          numpago: 0,
	          concepto: txtConcepto.current.value,
	          idcliente: idCliente,
	          idvendedor: idvende,
	          idfactura: "",
	          monto: totaldolares,
	          descuento: "",
	          iva: "",
	          montoiva: montosd,
	          abono: montosd,
	          total: totaldolares,
	          sobrante: montosd,
	          fecharegistro: txtFecha.current.value,
	          tipofac: "AN",
	          numfactura: "",
	          status: 0,
	          idmoneda: idmone,
	          valormoneda: valormone
	        });
	
	        for (var i = 0; i < records.length; i++) {
	          pagodetalle.push({
	            idpago: 0,
	            monto: records[i].montos,
	            nroreferencia: records[i].referencia,
	            idmoneda: records[i].tipodivisa,
	            numcredito: records[i].notacredito,
	            factorcambio: records[i].valormoneda,
	            moneda: records[i].simbolo === "$" ? "DOLAR" : records[i].simbolo === "€" ? "EURO" : "BOLIVARES",
	            tipo: records[i].tipo,
	            fechaemision: records[i].fechapago,
	            idcuenta: records[i].idbanco
	          });
	        }
	
	        setBody({
	          pago: pago,
	          pagodeta: pagodetalle,
	          app: false,
	          ncaja: ncaja
	        });
	
	        var msg = "";
	        if (opea === 1) {
	          msg = "Esta Seguro de Registrar este Pago.";
	        }
	
	        setMensajesino({
	          mostrar: true,
	          titulo: "Confirmación.",
	          texto: msg,
	          icono: "confirmacion"
	        });
	      }
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/registropago/" + opea;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (opea === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Pago Registrado Correctamente",
	            icono: "exito"
	          });
	
	          var reporte = "ReporteAnticipos";
	          var opera = 3;
	          var condi = "'" + response.data.numeropago + "'";
	          var orden = "";
	          var tipo = "AN";
	          var desdec = "'" + "" + "'";
	          var hastac = "'" + "" + "'";
	          window.open(op.reportes + "/finanzas?afiliado=" + afiliado + "&reporte=" + reporte + "&NUMPAGO=" + condi + "&OP=" + opera + "&TIPOPAGO=" + tipo + "&orden=" + orden + "&desde=" + desdec + "&hasta=" + hastac, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	        } else if (opea === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Pago Registrado Correctamente",
	            icono: "exito"
	          });
	        }
	        blanquear();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = error.response.data.message;
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (accbtnndebito && accbtnndebito.toString().substring(0, 1) === "1") {
	          setTituloHeader("Incluir Anticipo.");
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setOpea(op);
	          setHabilitado(true);
	          setHabilitadoCli(true);
	          setHabilitarMoneda(true);
	          seleccionarVendedor(idVendedor);
	          setHabilitarCat(true);
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (accbtnndebito && accbtnndebito.toString().substring(2, 3) === "1") {
	          setTituloHeader("Consultar Anticipo.");
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setOpea(op);
	          setHabilitarCat(false);
	          setHabilitado(false);
	          setHabilitarMoneda(true);
	          setHabilitadoCli(false);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        blanquear();
	      }
	    };
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    event.preventDefault();
	    if (event.which === 13) {
	      if (event.target.name === "fecha") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	        btnProducto.current.focus();
	      } else if (event.target.name === "dias") {
	        var dias = txtDias.current.value;
	        if (txtDias.current.value > 0) {
	          var fechaV = (0, _moment2.default)(fechasistema).add(dias.toString(), "days").format("YYYY-MM-DD");
	          var cambia = event.target.value;
	          var dd = dias === cambia ? cambia : txtFechaVencimiento.current.value.substring(8, 10);
	
	          if (event.target.value !== dd) {
	            var _fechaV = (0, _moment2.default)(fechasistema).add(dias.toString(), "days").format("YYYY-MM-DD");
	          }
	        }
	      }
	    } else if (typeof event.which === "undefined") {
	      if (event.target.name === "fecha") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarMonedas();
	  }, []);
	
	  var handleAceptaDatos = function handleAceptaDatos(values) {
	    setMostrar1(false);
	
	    var predeterminada = void 0;
	    var totalm = 0.0;
	    var idmoney = void 0;
	    var valormoney = 0.0;
	    var indx = 0;
	
	    var datos = [].concat(_toConsumableArray(records));
	    var montototal = 0.0;
	
	    for (var b = 0; b < datos.length; b++) {
	      indx = indx + 1;
	    }
	
	    for (var i = 0; i < values.length; i++) {
	      idmoney = values[i].tipodivisa;
	
	      for (var a = 0; a < combomoneda.length; a++) {
	        if (parseInt(combomoneda[a].idmoneda) === parseInt(idmoney)) {
	          valormoney = combomoneda[a].valormoneda;
	        }
	
	        if (combomoneda[a].subpredeterminada === true) {
	          predeterminada = combomoneda[a].valormoneda;
	          setValormone(combomoneda[a].valormoneda);
	          setIdmone(combomoneda[a].idmoneda);
	        }
	      }
	
	      datos.push({
	        forma: values[i].formapago === 1 ? "Efectivo Bs" : values[i].formapago === 2 ? "Tarjeta(Debito) Bs" : values[i].formapago === 3 ? "Tarjeta(Crédito) Bs" : values[i].formapago === 4 ? "Pago Movil Bs" : values[i].formapago === 5 ? "Deposito Bancario Bs" : values[i].formapago === 6 ? "Transferencia Bancaria Bs" : "Divisa" + " " + values[i].simbolo,
	        montos: values[i].monto,
	        fechapago: values[i].fecha,
	        tipo: values[i].formapago,
	        tipodivisa: values[i].tipodivisa,
	        montoalcambio: values[i].formapago === 7 ? values[i].monto * valormoney : values[i].monto,
	        montodefinic: values[i].formapago === 7 ? values[i].monto * valormoney / predeterminada : values[i].monto / predeterminada,
	        index: indx,
	        notacredito: values[i].notacredito,
	        valormoneda: values[i].valormoneda,
	        idbanco: values[i].idbanco,
	        referencia: values[i].referencia,
	        simbolo: values[i].simbolo
	      });
	    }
	
	    for (var e = 0; e < datos.length; e++) {
	      montototal = parseFloat(montototal) + parseFloat(datos[e].montodefinic);
	    }
	
	    totalm = montototal * predeterminada;
	
	    setTotaldolares(montototal);
	    setTotales(totalm);
	    setRecords(datos);
	  };
	
	  var calcularTotales = function calcularTotales(data, datos) {
	    var predeterminada = void 0;
	    var montototal = 0.0;
	    var totalm = 0.0;
	
	    for (var a = 0; a < combomoneda.length; a++) {
	      if (combomoneda[a].subpredeterminada === true) {
	        predeterminada = combomoneda[a].valormoneda;
	      }
	    }
	
	    for (var e = 0; e < data.length; e++) {
	      for (var c = 0; c < datos.length; c++) {
	        montototal = parseFloat(montototal) + parseFloat(datos[c].montodefinic);
	      }
	    }
	
	    totalm = montototal * predeterminada;
	
	    setTotaldolares(montototal);
	    setTotales(totalm);
	  };
	
	  var eliminarFila = function eliminarFila(values) {
	    return function (e) {
	      e.preventDefault();
	      var data = [].concat(_toConsumableArray(records));
	      var elementos = [];
	      var eliminado = [];
	
	      for (var i = 0; i < data.length; i++) {
	        if (values !== data[i].index) {
	          elementos.push(data[i]);
	        }
	
	        if (values === data[i].index) {
	          eliminado.push(data[i]);
	        }
	      }
	
	      setRecords(elementos);
	      calcularTotales(eliminado, elementos);
	    };
	  };
	
	  var imprimirNotaDebito = function imprimirNotaDebito() {
	    if (accbtnndebito && accbtnndebito.toString().substring(4, 5) === "1") {
	      var debt = 0;
	      if (txtNumAnticipo.current.value !== "") {
	        var reporte = "ReporteAnticipos";
	        var opera = 3;
	        var condi = "'" + numNota + "'";
	        var orden = "";
	        var tipo = "AN";
	        var desdec = "'" + "" + "'";
	        var hastac = "'" + "" + "'";
	        window.open(op.reportes + "/finanzas?afiliado=" + afiliado + "&reporte=" + reporte + "&NUMPAGO=" + condi + "&OP=" + opera + "&TIPOPAGO=" + tipo + "&orden=" + orden + "&desde=" + desdec + "&hasta=" + hastac, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Seleccione el Anticipo a Imprimir !",
	          icono: "informacion"
	        });
	        debt = 1;
	      }
	
	      if (debt === 1) {
	        txtNumAnticipo.current.focus();
	      }
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var onGestionar = function onGestionar(op) {
	    return function (e) {
	      if (op === 1) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 2) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 3) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 4) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 5) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 6) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 7) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 8) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 9) {
	        setOperacion(op);
	        setMostrar1(true);
	      }
	    };
	  };
	
	  var handleAceptaDatosAnticipos = function handleAceptaDatosAnticipos(values) {
	    setMostrar(false);
	
	    txtNumAnticipo.current.value = values.numpago.trim();
	    seleccionarAnticipo(values.numpago);
	  };
	
	  var statusanticipo = function statusanticipo(value, reversado) {
	    var estatus = "¡ Anticipo Disponible !";
	    if (reversado === 1) {
	      estatus = "¡ Este Anticipo fue Reversado !";
	    } else {
	      if (value === 0) {
	        estatus = "¡ Anticipo Disponible !";
	      } else if (value === 1) {
	        estatus = "¡ Este Anticipo fue Utilizado en la Factura N°" + " " + numfactu + " !";
	      } else if (value === 4) {
	        estatus = "¡ Este Anticipo fue Anulado !";
	      } else {
	        estatus = "";
	      }
	    }
	    return estatus;
	  };
	
	  var statuscolor = function statuscolor(value, reversado) {
	    var estatus = "#17FF51";
	    if (reversado === 1) {
	      estatus = "#dc3545";
	    } else {
	      if (value === 0) {
	        estatus = "#17FF51";
	      } else if (value === 1) {
	        estatus = "#F5CC00";
	      } else if (value === 4) {
	        estatus = "#FFF";
	      }
	    }
	    return estatus;
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 ", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-11 mx-auto py-2 card shadow h-100" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row border-azul mx-auto justify-content-between rounded py-1" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 row mx-auto d-flex justify-content-between mb-1",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-2 azulGradiant shadow text-light justify-content-between" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-3" },
	                  _react2.default.createElement(
	                    "h3",
	                    null,
	                    tituloHeader
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-6 mx-auto px-0" },
	                  _react2.default.createElement(
	                    "h4",
	                    {
	                      className: "text-center",
	                      style: {
	                        color: statuscolor(estatusa, estatusreve)
	                      }
	                    },
	                    statusanticipo(estatusa, estatusreve)
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-2 d-flex justify-content-end" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/inicio", className: "text-light " },
	                    _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "fw-bold" },
	                      "Salir"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "colfull col-pd-300" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "N\xB0 Anticipo:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: habilitarCat,
	                    ref: txtNumAnticipo,
	                    name: "idnotaentre",
	                    onKeyUp: handleInputNumeroChange,
	                    onBlur: handleInputNumeroChange,
	                    className: "form-control form-control-lg",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: habilitarCat,
	                      type: "button",
	                      onClick: function onClick() {
	                        return setMostrar(true);
	                      },
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-240 mx-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA:"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "date",
	                    disabled: !habilitado,
	                    ref: txtFecha,
	                    className: "form-control text-uppercase fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    name: "fecha",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "colfull col400" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "text-left" },
	                  "ANTICIPO N\xB0:",
	                  " ",
	                  _react2.default.createElement(
	                    "span",
	                    { className: "col fw-bold text-danger" },
	                    "\xA0",
	                    numNota
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "colfull1070 colfull60p mx-auto mb-1",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row border-azul rounded" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold" },
	                  "Datos del Cliente"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-1 col-md-5" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: cmbRif,
	                      name: "cmbrif",
	                      disabled: !habilitadoCli,
	                      className: "form-select form-select-sm col-md-3 text-center ",
	                      "aria-label": ".form-select-sm example",
	                      onChange: onChange
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "--"
	                    ),
	                    cmbCedula && cmbCedula.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item },
	                        item
	                      );
	                    })
	                  ),
	                  _react2.default.createElement("input", {
	                    ref: txtRif,
	                    autoComplete: "off",
	                    disabled: !habilitadoCli,
	                    maxLength: 9,
	                    type: "text",
	                    className: "form-control fs-6",
	                    name: "cedula",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: validarCliente,
	                    onBlur: validarCliente,
	                    onChange: onChange
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoCli,
	                      type: "button",
	                      onClick: function onClick() {
	                        return setCatalogoCliente(true);
	                      },
	                      className: "btn btn-success",
	                      style: {
	                        visibility: visible === 0 ? "visible" : "hidden"
	                      }
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-1 col-md-7" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "NOMBRE:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: nomCliente
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-1 col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "DIRECCION:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: dirCliente
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "colfull1070 colfull40p mx-auto mb-1 row",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row border-azul rounded" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold" },
	                  "Datos del Vendedor"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm col-pd-240 px-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm",
	                      style: { height: "85%" }
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    ref: txtRifVende,
	                    className: "form-control fs-6",
	                    style: { height: "85%" },
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: cedRif
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm",
	                      style: { height: "85%" }
	                    },
	                    "NOMBRE:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    style: { height: "85%" },
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: nomVendedor
	                  })
	                )
	              ),
	              _react2.default.createElement("div", { className: "col-md-6" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row mx-auto px-0 m-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-1 px-0 border-azul rounded col-md-12" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "CONCEPTO:"
	                ),
	                _react2.default.createElement("textarea", {
	                  className: "form-control uppercase fs-6",
	                  ref: txtConcepto,
	                  disabled: !habilitado,
	                  "aria-label": "With textarea",
	                  style: { minHeight: 50 },
	                  defaultValue: ""
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-3 row m-0 px-0 d-flex justify-content-center border-azul py-2",
	                  style: { background: "#cfe2ff", borderRadius: "3px" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-6 d-flex justify-content-center mb-1" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnAcepta,
	                      disabled: !habilitado,
	                      style: { height: "80px", fontSize: "14px" },
	                      onClick: onGestionar(1),
	                      className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-money-bill-alt fs-5 mr-2" }),
	                    " ",
	                    "Efectivo Bs"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-6 d-flex justify-content-center mb-1" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnAcepta,
	                      disabled: !habilitado,
	                      style: { height: "80px", fontSize: "14px" },
	                      onClick: onGestionar(7),
	                      className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-dollar-sign fs-5 mr-2" }),
	                    " Divisas"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-6 d-flex justify-content-center mb-1" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnAcepta,
	                      disabled: !habilitado,
	                      style: { height: "80px", fontSize: "14px" },
	                      onClick: onGestionar(2),
	                      className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-credit-card fs-5 mr-2" }),
	                    " Tarjeta de Debito"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-6 d-flex justify-content-center mb-1" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnAcepta,
	                      disabled: !habilitado,
	                      style: { height: "80px", fontSize: "14px" },
	                      onClick: onGestionar(3),
	                      className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                    },
	                    _react2.default.createElement("i", { className: "fab fa-cc-visa fw-bold fs-5 mr-2" }),
	                    " ",
	                    "Tarjeta de Credito"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-6 d-flex justify-content-center mb-1" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnAcepta,
	                      disabled: !habilitado,
	                      style: { height: "80px", fontSize: "14px" },
	                      onClick: onGestionar(6),
	                      className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-money-check fs-5 mr-2" }),
	                    " Deposito Bancario"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-6 d-flex justify-content-center mb-1" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnAcepta,
	                      disabled: !habilitado,
	                      style: { height: "80px", fontSize: "14px" },
	                      onClick: onGestionar(5),
	                      className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-laptop fs-5 mr-2" }),
	                    " Transferencia Bancaria"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-6 d-flex justify-content-center" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnAcepta,
	                      disabled: !habilitado,
	                      style: { height: "80px", fontSize: "14px" },
	                      onClick: onGestionar(4),
	                      className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-mobile-alt fs-5 mr-2" }),
	                    " Pago Movil"
	                  )
	                ),
	                _react2.default.createElement("div", { className: "col-6 d-flex justify-content-center" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-9 px-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-12 px-0" },
	                  _react2.default.createElement(
	                    TblContainer,
	                    {
	                      container: {
	                        height: "280px",
	                        width: "100%",
	                        overflow: "auto",
	                        padding: "2px"
	                      }
	                    },
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                      _semanticUiReact.TableBody,
	                      { className: "overflow-hidden table-bordered" },
	                      records && records.map(function (item, index) {
	                        return _react2.default.createElement(
	                          _semanticUiReact.TableRow,
	                          {
	                            key: index,
	                            style: { padding: "0", cursor: "pointer" }
	                          },
	                          _react2.default.createElement(
	                            _semanticUiReact.TableCell,
	                            { className: "align-baseline text-center" },
	                            item.forma
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.TableCell,
	                            { className: "align-middle text-right" },
	                            (0, _varios.formatMoneda)(item.montos.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.TableCell,
	                            { className: "align-baseline text-right" },
	                            (0, _varios.formatMoneda)(item.montoalcambio.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                          ),
	                          _react2.default.createElement(
	                            _semanticUiReact.TableCell,
	                            { className: "align-baseline text-center" },
	                            _react2.default.createElement(
	                              "button",
	                              {
	                                className: "btn btn-sm mx-1 btn-danger",
	                                disabled: !habilitado,
	                                onClick: eliminarFila(item.index)
	                              },
	                              _react2.default.createElement("i", { className: "fa fa-trash" }),
	                              " "
	                            )
	                          )
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "col-12 px-0 row m-0 d-flex align-items-center border-azul",
	                    style: { borderRadius: "3px", fontSizeAdjust: "0.5" }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-12 row m-0 px-0 border-azul" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-6 px-0" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-pd-280 mx-auto" },
	                        _react2.default.createElement("img", { src: "imagenes/logo.ico", className: "img-fluid" })
	                      )
	                    ),
	                    _react2.default.createElement("div", { className: "col-2" }),
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "col-4 ml-auto px-0 row m-0 d-flex align-items-center border-azul py-2",
	                        style: {
	                          background: "#cfe2ff",
	                          borderRadius: "3px",
	                          fontSizeAdjust: "0.5"
	                        }
	                      },
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          className: "col-12 row m-0",
	                          style: { fontSizeAdjust: "0.5" }
	                        },
	                        _react2.default.createElement(
	                          "label",
	                          { className: "col-4 px-1 text-left fs-5" },
	                          "Total $:",
	                          " "
	                        ),
	                        _react2.default.createElement(
	                          "span",
	                          { className: "col px-0 fw-bold text-right fs-5" },
	                          "\xA0",
	                          (0, _varios.formatMoneda)(totaldolares.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        {
	                          className: "col-12 row m-0",
	                          style: { fontSizeAdjust: "0.5" }
	                        },
	                        _react2.default.createElement(
	                          "label",
	                          { className: "col-4 px-1 text-left fs-5" },
	                          "Total Bs:",
	                          " "
	                        ),
	                        _react2.default.createElement(
	                          "span",
	                          { className: "col px-0 fw-bold text-right fs-5" },
	                          "\xA0",
	                          (0, _varios.formatMoneda)(totales.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "colfull40p row m-0" },
	              _react2.default.createElement("div", { className: "col-md-12" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 mt-auto px-0" },
	              visibleBtn === "visible" ? _react2.default.createElement(
	                "div",
	                { className: "col-pd-340" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 row m-0 px-0" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoBot,
	                      ref: btnIncluir,
	                      onClick: onBotones(1),
	                      className: "btn btn-sm col ml-1 btn-primary rounded-pill",
	                      title: "Incluir Nota de Entrega"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-plus" },
	                      " Incluir "
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoBot,
	                      ref: btnConsultar,
	                      onClick: onBotones(4),
	                      className: "btn btn-sm col ml-1 btn-info rounded-pill",
	                      title: "Consultar Nota de Entrega"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-eye" },
	                      " Consultar"
	                    ),
	                    " "
	                  )
	                )
	              ) : _react2.default.createElement(
	                "div",
	                {
	                  className: "" + (imagenanticipo !== null && imagendivisa !== null ? "col-pd-700 row m-0 ml-auto" : imagenanticipo !== null && imagendivisa === null ? "col-pd-530 row m-0 ml-auto" : imagenanticipo === null && imagendivisa !== null ? "col-pd-530 row m-0 ml-auto" : "col-pd-350 row m-0 ml-auto")
	                },
	                opea === 4 && imagenanticipo !== null ? _react2.default.createElement(
	                  "button",
	                  {
	                    onClick: function onClick() {
	                      return setModalAnticipo(true);
	                    },
	                    disabled: opea === 4 ? false : true,
	                    className: "btn btn-sm col ml-1 btn-info rounded-pill",
	                    title: "Visualizar Imagen Anticipo"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-images" },
	                    " Imagen Anticipo"
	                  )
	                ) : "",
	                opea === 4 && imagendivisa !== null ? _react2.default.createElement(
	                  "button",
	                  {
	                    onClick: function onClick() {
	                      return setModalDivisa(true);
	                    },
	                    disabled: opea === 4 ? false : true,
	                    className: "btn btn-sm col ml-1 btn-warning rounded-pill",
	                    title: "Visualizar Imagen Divisa"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-images" },
	                    " Imagen Divisa"
	                  )
	                ) : "",
	                opea === 4 ? _react2.default.createElement(
	                  "button",
	                  {
	                    onClick: imprimirNotaDebito,
	                    disabled: opea === 4 ? false : true,
	                    className: "btn btn-sm col ml-1 btn-primary rounded-pill",
	                    title: "Imprimir Nota de Entrega"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fa fa-print" },
	                    " Imprimir"
	                  )
	                ) : "",
	                opea === 4 ? "" : _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta,
	                    disabled: opea === 4 ? true : habilitadoBot,
	                    onClick: onBotones(5),
	                    className: "btn btn-sm col ml-1 rounded-pill btn-success"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-check-circle" },
	                    " ",
	                    "Procesar Anticipo"
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnCancela,
	                    disabled: habilitadoBot,
	                    onClick: onBotones(6),
	                    className: "btn btn-danger col ml-1 btn-sm rounded-pill"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-window-close" },
	                    " Cancelar"
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: catalogoCliente,
	      nomid: "cliente",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoCliente(false);
	      },
	      onHideAceptaCatalogo: onCatalogoCliente
	    }),
	    _react2.default.createElement(_modalImagenAnticipo.ImagenAnticipo, {
	      show: modalAnticipo,
	      imagenanticipo: imagenanticipo,
	      onHideCancelar: function onHideCancelar() {
	        return setModalAnticipo(false);
	      }
	    }),
	    _react2.default.createElement(_modalImagenDivisa.ImagenDivisa, {
	      show: modalDivisa,
	      imagendivisa: imagendivisa,
	      onHideCancelar: function onHideCancelar() {
	        return setModalDivisa(false);
	      }
	    }),
	    _react2.default.createElement(_catalogoAnticipos2.default, {
	      show: mostrar,
	      idcliente: 0,
	      tipo: "AN",
	      estatus: 0,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar(false);
	      },
	      onHideAceptaCatalogo: handleAceptaDatosAnticipos
	    }),
	    _react2.default.createElement(_modalAgreProcesosMontosAnticipo.ProcesosMontosAnticipos, {
	      show: mostrar1,
	      ope: operacion,
	      data: records,
	      idclients: idCliente,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar1(false);
	      },
	      onHideAceptaData: handleAceptaDatos
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje, onHide: handleCloseMensaje }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = TablaAnticipos;

/***/ },
/* 7131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _catalogoPersona = __webpack_require__(64);
	
	var _catalogoPersona2 = _interopRequireDefault(_catalogoPersona);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TablaBeneficiario = function TablaBeneficiario() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var anio = JSON.parse(sessionStorage.getItem("anioactu"));
	  var registrado = false;
	  var muni = "";
	  var ciu = "";
	  var valrif = 0;
	
	  var accbtnbeneficiarios = JSON.parse(sessionStorage.getItem("accbtnbeneficiariosc"));
	  var fechaTope = (0, _moment2.default)(JSON.parse(sessionStorage.getItem("fechasistema"))).format("YYYY-MM-DD").replace(anio.toString(), (anio - 18).toString());
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var chkNatural = (0, _react.useRef)();
	  var chkJuridico = (0, _react.useRef)();
	  var txtId = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtRazon = (0, _react.useRef)();
	  var txtDirClient = (0, _react.useRef)();
	  var txtEmailClient = (0, _react.useRef)();
	  var txtTlf1Client = (0, _react.useRef)();
	  var txtTlf2Client = (0, _react.useRef)();
	  var txtEstado = (0, _react.useRef)();
	  var txtMunicipio = (0, _react.useRef)();
	  var txtCiudad = (0, _react.useRef)();
	  var txtRetencion = (0, _react.useRef)();
	  var cmbNacionalidad = (0, _react.useRef)();
	  var txtCedRes = (0, _react.useRef)();
	  var cmbSexo = (0, _react.useRef)();
	  var txtFechaNac = (0, _react.useRef)();
	  var txtNomResp = (0, _react.useRef)();
	  var txtApeResp = (0, _react.useRef)();
	  var txtDireccion = (0, _react.useRef)();
	  var txtEmail = (0, _react.useRef)();
	  var txtTlf1 = (0, _react.useRef)();
	  var txtTlf2 = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      body = _useState2[0],
	      setBody = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(true),
	      _useState4 = _slicedToArray(_useState3, 2),
	      habilitado = _useState4[0],
	      setHabilitado = _useState4[1];
	
	  var _useState5 = (0, _react.useState)("Gestionar Beneficiario."),
	      _useState6 = _slicedToArray(_useState5, 2),
	      tituloHeader = _useState6[0],
	      setTituloHeader = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      catalogoPersona = _useState8[0],
	      setCatalogoPersona = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      catalogoCliente = _useState10[0],
	      setCatalogoCliente = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mensaje = _useState12[0],
	      setMensaje = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensajesino = _useState14[0],
	      setMensajesino = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      activate = _useState16[0],
	      setActivate = _useState16[1];
	
	  var _useState17 = (0, _react.useState)("visible"),
	      _useState18 = _slicedToArray(_useState17, 2),
	      visibleBtn = _useState18[0],
	      setVisibleBtn = _useState18[1];
	
	  var _useState19 = (0, _react.useState)("CEDULA:"),
	      _useState20 = _slicedToArray(_useState19, 2),
	      titleCed = _useState20[0],
	      setTitleCed = _useState20[1];
	
	  var _useState21 = (0, _react.useState)([{ value: "V" }, { value: "E" }]),
	      _useState22 = _slicedToArray(_useState21, 2),
	      cmbCedula = _useState22[0],
	      setCmbCedula = _useState22[1];
	
	  var _useState23 = (0, _react.useState)([]),
	      _useState24 = _slicedToArray(_useState23, 2),
	      estados = _useState24[0],
	      setEstados = _useState24[1];
	
	  var _useState25 = (0, _react.useState)([]),
	      _useState26 = _slicedToArray(_useState25, 2),
	      municipios = _useState26[0],
	      setMunicipios = _useState26[1];
	
	  var _useState27 = (0, _react.useState)([]),
	      _useState28 = _slicedToArray(_useState27, 2),
	      ciudades = _useState28[0],
	      setCiudades = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(true),
	      _useState30 = _slicedToArray(_useState29, 2),
	      habilitadoNU = _useState30[0],
	      setHabilitadoNU = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(0),
	      _useState32 = _slicedToArray(_useState31, 2),
	      operacionPer = _useState32[0],
	      setOperacionPer = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(0),
	      _useState34 = _slicedToArray(_useState33, 2),
	      operacion = _useState34[0],
	      setOperacion = _useState34[1];
	
	  var _useState35 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    catalogoper: true
	  }),
	      _useState36 = _slicedToArray(_useState35, 2),
	      botones = _useState36[0],
	      setBotones = _useState36[1];
	
	  var handleInputNumChange = function handleInputNumChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	
	    if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false; //alert(e.which);
	  };
	
	  var datosRes = function datosRes() {
	    var campos = "*";
	    var nomtab = "persona";
	    var nomid = "cedula";
	    var nomid2 = "nacionalidad";
	    var id = txtCedRes.current.value;
	    var id2 = cmbNacionalidad.current.value;
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=" + id2;
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        cmbSexo.current.value = "";
	        txtFechaNac.current.value = "";
	        txtNomResp.current.value = "";
	        txtApeResp.current.value = "";
	        txtDireccion.current.value = "";
	        txtEmail.current.value = "";
	        txtTlf1.current.value = "";
	        txtTlf2.current.value = "";
	
	        if (response.data !== "") {
	          setHabilitadoNU(true);
	          setOperacionPer(0);
	          cmbSexo.current.value = response.data.sexo;
	          txtFechaNac.current.value = (0, _moment2.default)(response.data.fnacimiento).format("YYYY-MM-DD");
	          txtNomResp.current.value = response.data.nombres;
	          txtApeResp.current.value = response.data.apellidos;
	          txtDireccion.current.value = response.data.direccion;
	          txtEmail.current.value = response.data.correoe;
	          txtTlf1.current.value = response.data.tlf1;
	          txtTlf2.current.value = response.data.tlf2;
	          if (!botones.consultar) {
	            btnCancela.current.focus();
	          } else {
	            btnAcepta.current.focus();
	          }
	        } else {
	          txtNomResp.current.focus();
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe una persona con este N° de cedula porfavor registre sus datos",
	            icono: "informacion"
	          });
	          setOperacionPer(1);
	          setHabilitadoNU(false);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "*";
	    var nomtab = "estado";
	    var orden = "idestado";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setEstados(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var selectMunicipios = function selectMunicipios(id) {
	    var campos = "*";
	    var nomtab = "municipio";
	    var nomid = "idestado";
	    var endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&id=" + id + "&nomtab=" + nomtab + "&nomid=" + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setMunicipios(response.data);
	        if (registrado || !botones.consultar || !botones.modificar || !botones.eliminar) {
	          txtMunicipio.current.value = muni;
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var selectCiudad = function selectCiudad(id) {
	    var campos = "*";
	    var nomtab = "ciudad";
	    var nomid = "idmunicipio";
	    var endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&id=" + id + "&nomtab=" + nomtab + "&nomid=" + nomid;
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setCiudades(response.data);
	        if (registrado || !botones.consultar || !botones.modificar || !botones.eliminar) {
	          txtCiudad.current.value = ciu;
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setOperacion(0);
	    setTituloHeader("Gestionar Beneficiario.");
	    setActivate(false);
	    setBody(null);
	    setOperacionPer(0);
	    setHabilitado(true);
	    setHabilitadoNU(true);
	    setMunicipios([]);
	    setCiudades([]);
	    setTitleCed("CEDULA:");
	    setCmbCedula([{ value: "V" }, { value: "E" }]);
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      catalogoper: true
	    });
	    txtRetencion.current.checked = false;
	    chkNatural.current.checked = true;
	    cmbRif.current.value = "";
	    txtRif.current.value = "";
	    txtId.current.value = 0;
	    txtRazon.current.value = "";
	    txtDirClient.current.value = "";
	    txtTlf1Client.current.value = "";
	    txtTlf2Client.current.value = "";
	    txtEmailClient.current.value = "";
	    txtEstado.current.value = "";
	    txtMunicipio.current.value = "";
	    txtCiudad.current.value = "";
	
	    cmbRif.current.setAttribute("disabled", "disabled");
	    txtRif.current.setAttribute("disabled", "disabled");
	    chkNatural.current.setAttribute("disabled", "disabled");
	    chkJuridico.current.setAttribute("disabled", "disabled");
	
	    cmbNacionalidad.current.value = "";
	    txtCedRes.current.value = "";
	    cmbSexo.current.value = "";
	    txtFechaNac.current.value = "";
	    txtNomResp.current.value = "";
	    txtApeResp.current.value = "";
	    txtDireccion.current.value = "";
	    txtEmail.current.value = "";
	    txtTlf1.current.value = "";
	    txtTlf2.current.value = "";
	    setVisibleBtn("visible");
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	    if (!botones.incluir || !botones.modificar) {
	      if (txtCedRes.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Debe ingresar la cedula el responsable",
	          icono: "informacion"
	        });
	        txtCedRes.current.focus();
	        sigue = false;
	      } else if (operacionPer === 1) {
	        if (cmbNacionalidad.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe seleccionar la nacionalidad del responsable",
	            icono: "informacion"
	          });
	          cmbNacionalidad.current.focus();
	          sigue = false;
	        } else if (cmbSexo.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe seleccionar el Sexo del responsable",
	            icono: "informacion"
	          });
	          cmbSexo.current.focus();
	          sigue = false;
	        } else if (txtFechaNac.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar fecha nacimiento del responsable",
	            icono: "informacion"
	          });
	          txtFechaNac.current.focus();
	          sigue = false;
	        } else if (txtNomResp.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar el nombre del responsable",
	            icono: "informacion"
	          });
	          txtNomResp.current.focus();
	          sigue = false;
	        } else if (txtApeResp.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar el apellido del responsable",
	            icono: "informacion"
	          });
	          txtApeResp.current.focus();
	          sigue = false;
	        } else if (txtDireccion.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar la dirección del responsable",
	            icono: "informacion"
	          });
	          txtDireccion.current.focus();
	          sigue = false;
	        } else if (txtEmail.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar el correo del responsable",
	            icono: "informacion"
	          });
	          txtEmail.current.focus();
	          sigue = false;
	        } else if (txtTlf1.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar el Telefono del responsable",
	            icono: "informacion"
	          });
	          txtTlf1.current.focus();
	          sigue = false;
	        } else if (txtTlf2.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar el Celular del responsable",
	            icono: "informacion"
	          });
	          txtTlf2.current.focus();
	          sigue = false;
	        }
	      }
	    }
	
	    if (sigue) {
	      var cliente = [];
	      var repre = [];
	      cliente.push({
	        idagente: txtId.current.value,
	        nombre: txtRazon.current.value.toUpperCase().trim(),
	        direccion: txtDirClient.current.value.toUpperCase().trim(),
	        tipoper: chkNatural.current.checked ? 0 : 1,
	        rif: cmbRif.current.value + txtRif.current.value,
	        reprelegal: cmbNacionalidad.current.value + txtCedRes.current.value,
	        telefono: txtTlf1Client.current.value,
	        celular: txtTlf2Client.current.value,
	        email: txtEmailClient.current.value.toUpperCase().trim(),
	        agenteretencion: txtRetencion.current.checked ? true : false,
	        beneficiario: true,
	        estado: txtEstado.current.value.trim(),
	        municipio: txtMunicipio.current.value.trim(),
	        ciudad: txtCiudad.current.value.trim()
	      });
	      repre.push({
	        cedula: parseInt(txtCedRes.current.value),
	        correoe: txtEmail.current.value.toUpperCase().trim(),
	        tlf1: txtTlf1.current.value.trim(),
	        tlf2: txtTlf2.current.value.trim(),
	        apellidos: txtApeResp.current.value.toUpperCase().trim(),
	        direccion: txtDireccion.current.value.toUpperCase().trim(),
	        fnacimiento: txtFechaNac.current.value.trim(),
	        nacionalidad: cmbNacionalidad.current.value.trim(),
	        nombres: txtNomResp.current.value.toUpperCase().trim(),
	        sexo: cmbSexo.current.value.trim()
	      });
	
	      setBody({
	        operacionper: operacionPer,
	        agente: cliente,
	        repre: repre,
	        client: []
	      });
	
	      var msg = "";
	      if (!botones.incluir) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (!botones.modificar) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (!botones.eliminar) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + "/api/agente/actualizar/" + ope;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (ope === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro creado correctamente",
	            icono: "exito"
	          });
	        } else if (ope === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro modificado correctamente",
	            icono: "exito"
	          });
	        } else if (ope === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro eliminado correctamente",
	            icono: "exito"
	          });
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = "";
	      if (error.response === undefined) {
	        mensaje = "Error de Conexion";
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "agente_rif_key"') {
	          mensaje = "Ya existe un Registro con este rif";
	        } else if (error.response.data.message === 'duplicate key value violates unique constraint "agente_email_key"') {
	          mensaje = "Ya existe un Registro con este correo";
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro(rif) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "rif";
	    var nomid2 = "beneficiario";
	    var id = rif;
	    var endpoint = "";
	
	    if (!botones.incluir) {
	      endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	    } else {
	      endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	    }
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          if (botones.incluir === false && response.data.beneficiario && response.data.rif === valrif) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "¡El Beneficiario con el N° de Cédula o RIF" + " " + response.data.rif + " " + "ya Existe!",
	              icono: "informacion"
	            });
	            txtId.current.value = "";
	            txtRazon.current.value = "";
	            txtDirClient.current.value = "";
	            cmbNacionalidad.current.value = "";
	            txtCedRes.current.value = "";
	            txtTlf1Client.current.value = "";
	            txtTlf2Client.current.value = "";
	            txtEmailClient.current.value = "";
	            txtEstado.current.value = "";
	            txtMunicipio.current.value = "";
	            txtCiudad.current.value = "";
	            txtCedRes.current.value = "";
	            cmbSexo.current.value = "";
	            txtFechaNac.current.value = "";
	            txtNomResp.current.value = "";
	            txtApeResp.current.value = "";
	            txtDireccion.current.value = "";
	            txtEmail.current.value = "";
	            txtTlf1.current.value = "";
	            txtTlf2.current.value = "";
	            txtRif.current.value = "";
	            cmbRif.current.value = "";
	            txtRetencion.current.checked = false;
	          } else {
	            setOperacionPer(0);
	
	            if (!botones.incluir) {
	              registrado = true;
	            } else {
	              registrado = false;
	            }
	
	            txtId.current.value = response.data.idagente;
	            txtRazon.current.value = response.data.nombre.trim();
	            txtDirClient.current.value = response.data.direccion.trim();
	            chkNatural.current.checked = response.data.tipoper === 0 ? true : false;
	            cmbRif.current.value = response.data.rif.trim().substring(0, 1);
	            txtRif.current.value = response.data.rif.trim().substring(1, 10);
	            txtTlf1Client.current.value = response.data.telefono;
	            txtTlf2Client.current.value = response.data.celular;
	            txtEmailClient.current.value = response.data.email.trim();
	            txtEstado.current.value = response.data.estado.trim();
	            txtRetencion.current.checked = response.data.agenteretencion ? true : false;
	            cmbNacionalidad.current.value = response.data.reprelegal.trim().substring(0, 1);
	            txtCedRes.current.value = response.data.reprelegal.trim().substring(1, 9);
	
	            muni = response.data.municipio.trim();
	            ciu = response.data.ciudad.trim();
	
	            selectMunicipios(response.data.estado.trim());
	            selectCiudad(response.data.municipio.trim());
	            datosRes();
	
	            if (!botones.modificar) {
	              setBotones(Object.assign({}, botones, { catalogoper: false }));
	            }
	          }
	        } else {
	          if (botones.consultar === false) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "¡El Beneficiario con el N° de Cédula o RIF" + " " + txtRif.current.value + " " + "No Existe!",
	              icono: "error"
	            });
	            txtRazon.current.focus();
	          }
	
	          txtRazon.current.focus();
	          txtId.current.value = 0;
	          txtRazon.current.value = "";
	          txtDirClient.current.value = "";
	          cmbNacionalidad.current.value = "";
	          txtCedRes.current.value = "";
	          txtTlf1Client.current.value = "";
	          txtTlf2Client.current.value = "";
	          txtEmailClient.current.value = "";
	          txtEstado.current.value = "";
	          txtMunicipio.current.value = "";
	          txtCiudad.current.value = "";
	          txtCedRes.current.value = "";
	          cmbSexo.current.value = "";
	          txtRetencion.current.checked = false;
	          txtFechaNac.current.value = "";
	          txtNomResp.current.value = "";
	          txtApeResp.current.value = "";
	          txtDireccion.current.value = "";
	          txtEmail.current.value = "";
	          txtTlf1.current.value = "";
	          txtTlf2.current.value = "";
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var validarCliente = function validarCliente(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (cmbRif.current.value !== "" && event.target.value !== "") {
	        var rif = cmbRif.current.value + event.target.value;
	        seleccionarRegistro(rif);
	      }
	    }
	  };
	
	  var validarPersona = function validarPersona(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (cmbNacionalidad.current.value !== "") {
	          datosRes();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "debe seleccionar la nacionalidad",
	            icono: "informacion"
	          });
	          cmbNacionalidad.current.focus();
	        }
	      } else {
	        cmbNacionalidad.current.value = "";
	        cmbSexo.current.value = "";
	        txtFechaNac.current.value = "";
	        txtNomResp.current.value = "";
	        txtApeResp.current.value = "";
	        txtDireccion.current.value = "";
	        txtEmail.current.value = "";
	        txtTlf1.current.value = "";
	        txtTlf2.current.value = "";
	        setHabilitadoNU(true);
	      }
	    }
	  };
	
	  var onChangeCliente = function onChangeCliente(e) {
	    if (e.target.name === "estado") {
	      setMunicipios([]);
	      setCiudades([]);
	      if (e.target.value !== "") {
	        selectMunicipios(e.target.value);
	      }
	    } else if (e.target.name === "municipio") {
	      setCiudades([]);
	      if (e.target.value !== "") {
	        selectCiudad(e.target.value);
	      }
	    } else if (e.target.name === "tipoper") {
	      if (parseInt(e.target.value) === 0) {
	        chkNatural.current.checked = true;
	        setTitleCed("CEDULA:");
	        setCmbCedula([{ value: "V" }, { value: "E" }]);
	      } else {
	        chkJuridico.current.checked = true;
	        setTitleCed("R.I.F:");
	        setCmbCedula([{ value: "J" }, { value: "V" }, { value: "G" }, { value: "P" }]);
	      }
	    }
	  };
	
	  var onChange = function onChange(e) {
	    var n = void 0;
	    var r = void 0;
	
	    if (e.target.name === "correoe" || e.target.name === "apellidos" || e.target.name === "direccion" || e.target.name === "nombres" || e.target.name === "descripcion") {
	      e.target.value = e.target.value;
	    } else if (e.target.name === "nacionalidad" && txtCedRes.current.value !== "") {
	      if (e.target.value !== "") {
	        datosRes();
	      } else {
	        txtCedRes.current.value = "";
	        cmbSexo.current.value = "";
	        txtFechaNac.current.value = "";
	        txtNomResp.current.value = "";
	        txtApeResp.current.value = "";
	        txtDireccion.current.value = "";
	        txtEmail.current.value = "";
	        txtTlf1.current.value = "";
	        txtTlf2.current.value = "";
	        setHabilitadoNU(true);
	      }
	    } else if (e.target.name === "cedula") {
	      n = cmbRif.current.value;
	      r = txtRif.current.value;
	    }
	    valrif = n + r;
	  };
	
	  var onCatalogoCliente = function onCatalogoCliente(values) {
	    setCatalogoCliente(false);
	
	    if (parseInt(values.tipoper) === 0) {
	      chkNatural.current.checked = true;
	      setTitleCed("CEDULA:");
	      setCmbCedula([{ value: "V" }, { value: "E" }]);
	    } else {
	      chkJuridico.current.checked = true;
	      setTitleCed("R.I.F:");
	      setCmbCedula([{ value: "J" }, { value: "V" }, { value: "G" }, { value: "P" }]);
	    }
	
	    txtRazon.current.value = values.nombre;
	
	    seleccionarRegistro(values.rif.trim());
	    //datosRes();
	    if (!botones.modificar) {
	      setBotones(Object.assign({}, botones, { catalogoper: false }));
	    }
	  };
	
	  var onCatalogoPersona = function onCatalogoPersona(values) {
	    setCatalogoPersona(false);
	    setHabilitadoNU(true);
	    setOperacionPer(0);
	    cmbNacionalidad.current.value = values.nacPer;
	    txtCedRes.current.value = values.cedPer;
	    cmbSexo.current.value = values.sexoPer;
	    txtFechaNac.current.value = (0, _moment2.default)(values.fnacPer).format("YYYY-MM-DD");
	    txtNomResp.current.value = values.nomPer;
	    txtApeResp.current.value = values.apePer;
	    txtDireccion.current.value = values.direPer;
	    txtEmail.current.value = values.correoPer;
	    txtTlf1.current.value = values.tlf1Per;
	    txtTlf2.current.value = values.tlf2Per;
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      setOperacion(op);
	      e.preventDefault();
	
	      if (op === 1) {
	        if (accbtnbeneficiarios && accbtnbeneficiarios.toString().substring(0, 1) === "1") {
	          setVisibleBtn("hidden");
	          setTituloHeader("Incluir Beneficiario.");
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            catalogoper: false
	          });
	          cmbRif.current.removeAttribute("disabled");
	          txtRif.current.removeAttribute("disabled");
	          chkNatural.current.removeAttribute("disabled");
	          chkJuridico.current.removeAttribute("disabled");
	          txtRif.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (accbtnbeneficiarios && accbtnbeneficiarios.toString().substring(1, 2) === "1") {
	          setTituloHeader("Editar Beneficiario.");
	          setVisibleBtn("hidden");
	          setHabilitado(false);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          cmbRif.current.removeAttribute("disabled");
	          txtRif.current.removeAttribute("disabled");
	          chkNatural.current.removeAttribute("disabled");
	          chkJuridico.current.removeAttribute("disabled");
	          txtRif.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (accbtnbeneficiarios && accbtnbeneficiarios.toString().substring(3, 4) === "1") {
	          setTituloHeader("Eliminar Beneficiario.");
	          setVisibleBtn("hidden");
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          cmbRif.current.removeAttribute("disabled");
	          txtRif.current.removeAttribute("disabled");
	          chkNatural.current.removeAttribute("disabled");
	          chkJuridico.current.removeAttribute("disabled");
	          txtRif.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (accbtnbeneficiarios && accbtnbeneficiarios.toString().substring(2, 3) === "1") {
	          setTituloHeader("Consultar Beneficiario.");
	          setVisibleBtn("hidden");
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          cmbRif.current.removeAttribute("disabled");
	          txtRif.current.removeAttribute("disabled");
	          chkNatural.current.removeAttribute("disabled");
	          chkJuridico.current.removeAttribute("disabled");
	          txtRif.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        setVisibleBtn("visible");
	        blanquear();
	      }
	    };
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarRegistros();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 py-2", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2 m-0" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-8 py-2 mx-auto card shadow " },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row mx-auto  rounded py-2" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 " },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-2 azulGradiant shadow text-light justify-content-between" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-4" },
	                  _react2.default.createElement(
	                    "h3",
	                    null,
	                    tituloHeader
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-3 d-flex justify-content-end" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/inicio", className: "text-light " },
	                    _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "fw-bold" },
	                      "Salir"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "fieldset",
	                {
	                  className: " row col-sm-12 mx-auto border-azul rounded",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "legend",
	                  {
	                    className: "float-none w-auto fw-bold",
	                    style: { fontSize: "15px" }
	                  },
	                  "Datos de Beneficiario"
	                ),
	                _react2.default.createElement("input", {
	                  ref: txtId,
	                  autoComplete: "off",
	                  type: "hidden",
	                  className: "form-control",
	                  name: "idagente",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-270 px-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    titleCed,
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: cmbRif,
	                      name: "cmbrif",
	                      disabled: true,
	                      className: "form-select form-select-sm col-md-3 text-center ",
	                      "aria-label": ".form-select-sm example",
	                      onChange: onChange
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "--"
	                    ),
	                    cmbCedula && cmbCedula.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.value },
	                        " ",
	                        item.value,
	                        " "
	                      );
	                    })
	                  ),
	                  _react2.default.createElement("input", {
	                    ref: txtRif,
	                    autoComplete: "off",
	                    maxLength: 9,
	                    type: "text",
	                    disabled: true,
	                    className: "form-control fs-6",
	                    name: "cedula",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: validarCliente,
	                    onChange: onChange
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: botones.catalogo,
	                      type: "button",
	                      onClick: function onClick() {
	                        return setCatalogoCliente(true);
	                      },
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                ),
	                _react2.default.createElement("div", { className: "col" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-xl-5 col-lg-7 col-md-12 row" },
	                  _react2.default.createElement(
	                    "label",
	                    { className: "col-md-5" },
	                    "TIPO PERSONA: "
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input my-auto fs-6",
	                        disabled: true,
	                        type: "radio",
	                        name: "tipoper",
	                        value: 0,
	                        ref: chkNatural,
	                        defaultChecked: true,
	                        id: "tipoper",
	                        onChange: onChangeCliente
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", htmlFor: "tipoper" },
	                        " ",
	                        "Natural",
	                        " "
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "form-check" },
	                      _react2.default.createElement("input", {
	                        className: "form-check-input my-auto fs-6",
	                        disabled: true,
	                        type: "radio",
	                        name: "tipoper",
	                        value: 1,
	                        ref: chkJuridico,
	                        id: "tipoper",
	                        onChange: onChangeCliente
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        { className: "form-check-label", htmlFor: "tipoper" },
	                        " ",
	                        "Juridica",
	                        " "
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-xl-12 col-lg-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    titleCed === "CEDULA:" ? "NOMBRES Y APELLIDOS" : "NOMBRE/RAZON SOCIAL"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    ref: txtRazon,
	                    disabled: habilitado,
	                    name: "nombres",
	                    className: "form-control text-uppercase fs-6",
	                    onChange: onChange,
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-xl-12 col-lg-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "DIRECCION:"
	                  ),
	                  _react2.default.createElement("textarea", {
	                    type: "area",
	                    autoComplete: "off",
	                    ref: txtDirClient,
	                    disabled: habilitado,
	                    name: "direccion",
	                    className: "form-control text-uppercase fs-6",
	                    onChange: onChange,
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    style: { height: 40 }
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-230 px-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "ESTADO:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: txtEstado,
	                      disabled: habilitado,
	                      onChange: onChangeCliente,
	                      name: "estado",
	                      idciudad: "estado",
	                      className: "form-select form-select-sm text-uppercase",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "seleccione"
	                    ),
	                    estados && estados.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idestado },
	                        item.nombre
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-340 px-1" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "MUNICIPIO:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: txtMunicipio,
	                      disabled: habilitado,
	                      onChange: onChangeCliente,
	                      name: "municipio",
	                      id: "municipio",
	                      className: "form-select form-select-sm text-uppercase",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "seleccione"
	                    ),
	                    municipios && municipios.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idmunicipio },
	                        item.nombre
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-5 px-1" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CIUDAD:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: txtCiudad,
	                      disabled: habilitado,
	                      name: "ciudad",
	                      id: "ciudad",
	                      className: "form-select form-select-sm text-uppercase",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "seleccione"
	                    ),
	                    ciudades && ciudades.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idciudad },
	                        item.nombre
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-xl-4 col-lg-4 col-md-6 col-sm-6" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "EMAIL:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    ref: txtEmailClient,
	                    disabled: habilitado,
	                    className: "form-control text-uppercase fs-6",
	                    name: "correoe",
	                    "aria-label": "Sizing example input",
	                    onChange: onChange,
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-220 px-1" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TELEFONO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    maxLength: 11,
	                    ref: txtTlf1Client,
	                    disabled: habilitado,
	                    className: "form-control fs-6",
	                    name: "tlf1",
	                    "aria-label": "Sizing example input",
	                    onChange: onChange,
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: handleInputNumChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-210 px-1" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CELULAR:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    maxLength: 11,
	                    ref: txtTlf2Client,
	                    disabled: habilitado,
	                    className: "form-control fs-6",
	                    name: "tlf2",
	                    "aria-label": "Sizing example input",
	                    onChange: onChange,
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: handleInputNumChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-210" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-check" },
	                    _react2.default.createElement("input", {
	                      ref: txtRetencion,
	                      disabled: habilitado,
	                      className: "form-check-input",
	                      type: "checkbox",
	                      value: "",
	                      id: "flexCheckDefault"
	                    }),
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "form-check-label",
	                        htmlFor: "flexCheckDefault",
	                        style: { fontSize: "14px" }
	                      },
	                      "Fondo de Terceros"
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12" },
	              _react2.default.createElement(
	                "fieldset",
	                {
	                  className: " row col-sm-12 mx-auto border-azul rounded",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "legend",
	                  {
	                    className: "float-none w-auto fw-bold",
	                    style: { fontSize: "15px" }
	                  },
	                  "Responsable"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-270 px-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CEDULA:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: cmbNacionalidad,
	                      name: "nacionalidad",
	                      className: "form-select form-select-sm col-md-3",
	                      disabled: habilitado,
	                      "aria-label": ".form-select-sm example",
	                      onChange: onChange
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "V" },
	                      "V"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "E" },
	                      "E"
	                    )
	                  ),
	                  _react2.default.createElement("input", {
	                    ref: txtCedRes,
	                    maxLength: 8,
	                    autoComplete: "off",
	                    type: "text",
	                    disabled: habilitado,
	                    className: "form-control fs-6",
	                    name: "cedula",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: validarPersona,
	                    onBlur: validarPersona,
	                    onChange: onChange
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: botones.catalogoper,
	                      type: "button",
	                      onClick: function onClick() {
	                        return setCatalogoPersona(true);
	                      },
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-140 mx-auto" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "SEXO:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: cmbSexo,
	                      className: "form-select form-select-sm",
	                      name: "sexo",
	                      disabled: habilitadoNU,
	                      onChange: onChange,
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "--"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "M" },
	                      "M"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "F" },
	                      "F"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-340 px-2 ml-auto" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA DE NACIMIENTO"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "date",
	                    ref: txtFechaNac,
	                    max: fechaTope,
	                    className: "form-control text-uppercase fs-6",
	                    name: "fnacimiento",
	                    "aria-label": "Sizing example input",
	                    onChange: onChange,
	                    disabled: habilitadoNU,
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-xl-6 col-lg-6" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "NOMBRES:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    ref: txtNomResp,
	                    name: "nombres",
	                    className: "form-control text-uppercase fs-6",
	                    onChange: onChange,
	                    "aria-label": "Sizing example input",
	                    disabled: habilitadoNU,
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-xl-6 col-lg-6" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "APELLIDOS:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    ref: txtApeResp,
	                    name: "apellidos",
	                    className: "form-control text-uppercase fs-6",
	                    onChange: onChange,
	                    "aria-label": "Sizing example input",
	                    disabled: habilitadoNU,
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "DIRECCION:"
	                  ),
	                  _react2.default.createElement("textarea", {
	                    type: "area",
	                    autoComplete: "off",
	                    ref: txtDireccion,
	                    name: "direccion",
	                    className: "form-control text-uppercase fs-6",
	                    onChange: onChange,
	                    "aria-label": "Sizing example input",
	                    disabled: habilitadoNU,
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    style: { height: 40 }
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "EMAIL:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    ref: txtEmail,
	                    className: "form-control text-uppercase fs-6",
	                    name: "correoe",
	                    "aria-label": "Sizing example input",
	                    onChange: onChange,
	                    disabled: habilitadoNU,
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-220 px-1" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TELEFONO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    maxLength: 12,
	                    ref: txtTlf1,
	                    className: "form-control fs-6",
	                    name: "tlf1",
	                    "aria-label": "Sizing example input",
	                    onChange: onChange,
	                    disabled: habilitadoNU,
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: handleInputNumChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-210 px-1" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CELULAR:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    maxLength: 12,
	                    ref: txtTlf2,
	                    className: "form-control fs-6",
	                    name: "tlf2",
	                    "aria-label": "Sizing example input",
	                    onChange: onChange,
	                    disabled: habilitadoNU,
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: handleInputNumChange
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 d-flex justify-content-between mt-2" },
	              visibleBtn === "visible" ? _react2.default.createElement(
	                "div",
	                { className: "col-md-12 col-sm-12 col-lg-12 col-12  justify-content-start" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: botones.incluir,
	                    onClick: onBotones(1),
	                    className: "btn btn-sm mx-1 btn-primary rounded-pill",
	                    title: "Incluir Almacen"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-plus" },
	                    " ",
	                    "Incluir",
	                    " "
	                  ),
	                  " "
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: botones.consultar,
	                    onClick: onBotones(4),
	                    className: "btn btn-sm mx-1 btn-info rounded-pill",
	                    title: "Consultar Almacen"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-eye" },
	                    "Consultar"
	                  ),
	                  " "
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: botones.modificar,
	                    onClick: onBotones(2),
	                    className: "btn btn-sm mx-1 btn-warning rounded-pill",
	                    title: "Modificar Almacen"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fa fa-edit" },
	                    "Modificar"
	                  ),
	                  " "
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: botones.eliminar,
	                    onClick: onBotones(3),
	                    className: "btn btn-sm mx-1 btn-danger rounded-pill",
	                    title: "Eliminar Almacen"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fa fa-trash" },
	                    "Eliminar"
	                  ),
	                  " "
	                )
	              ) : "",
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-md-12 d-flex justify-content-end",
	                  style: {
	                    visibility: visibleBtn === "visible" ? "collapse" : "visible"
	                  }
	                },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: botones.aceptar,
	                    onClick: onBotones(5),
	                    ref: btnAcepta,
	                    className: "mx-2 btn btn-sm rounded-pill btn-success"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    {
	                      className: "fas fa-check-circle"
	                    },
	                    " ",
	                    "Aceptar"
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: botones.cancelar,
	                    onClick: onBotones(6),
	                    ref: btnCancela,
	                    className: "mx-2 btn btn-danger btn-sm rounded-pill"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    {
	                      className: "fas fa-window-close"
	                    },
	                    " ",
	                    "Cancelar"
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: catalogoCliente,
	      nomid: "beneficiario",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoCliente(false);
	      },
	      onHideAceptaCatalogo: onCatalogoCliente
	    }),
	    _react2.default.createElement(_catalogoPersona2.default, {
	      show: catalogoPersona,
	      onHideCancelaCatPer: function onHideCancelaCatPer() {
	        return setCatalogoPersona(false);
	      },
	      onHideAceptaCatPer: onCatalogoPersona
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return mensaje.titulo === "Exito." ? blanquear() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = TablaBeneficiario;

/***/ },
/* 7132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _cartas = __webpack_require__(214);
	
	var _cartas2 = _interopRequireDefault(_cartas);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoCuentasBancarias = __webpack_require__(156);
	
	var _catalogoCuentasBancarias2 = _interopRequireDefault(_catalogoCuentasBancarias);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var TablaConciliacion = function TablaConciliacion() {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var anio = JSON.parse(sessionStorage.getItem('anioactu'));
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	
	  var accbtncnciliabancaria = JSON.parse(sessionStorage.getItem('accbtncnciliabancariac'));
	  var fechaTope = (0, _moment2.default)(JSON.parse(sessionStorage.getItem('fechasistema'))).format('YYYY-MM-DD').replace(anio.toString(), (anio - 18).toString());
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var chkNatural = (0, _react.useRef)();
	  var chkJuridico = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtRazon = (0, _react.useRef)();
	  var txtDirClient = (0, _react.useRef)();
	  var txtEmailClient = (0, _react.useRef)();
	  var txtTlf1Client = (0, _react.useRef)();
	  var txtTlf2Client = (0, _react.useRef)();
	  var txtId = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	  var chkSi = (0, _react.useRef)();
	  var chkNo = (0, _react.useRef)();
	  var chkDepositos = (0, _react.useRef)();
	  var txtNombre = (0, _react.useRef)();
	  var txtNCuenta = (0, _react.useRef)();
	  var txtSucursal = (0, _react.useRef)();
	  var txtPersona = (0, _react.useRef)();
	  var txtTelefono = (0, _react.useRef)();
	  var txtPrepuesto = (0, _react.useRef)();
	  var txtDireccion = (0, _react.useRef)();
	  var txtSaldoCon = (0, _react.useRef)();
	  var txtSaldoLib = (0, _react.useRef)();
	  var txtConcepto = (0, _react.useRef)();
	  var txtPorcenDeb = (0, _react.useRef)();
	  var txtEmision = (0, _react.useRef)();
	  var cmbNacionalidad = (0, _react.useRef)();
	  var txtCedRes = (0, _react.useRef)();
	  var cmbSexo = (0, _react.useRef)();
	  var txtFechaNac = (0, _react.useRef)();
	  var txtNomResp = (0, _react.useRef)();
	  var txtApeResp = (0, _react.useRef)();
	  var txtEmail = (0, _react.useRef)();
	  var txtTlf1 = (0, _react.useRef)();
	  var txtTlf2 = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(1),
	      _useState2 = _slicedToArray(_useState, 2),
	      operacion = _useState2[0],
	      setOperacion = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = _slicedToArray(_useState3, 2),
	      bancos = _useState4[0],
	      setBancos = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(),
	      _useState6 = _slicedToArray(_useState5, 2),
	      idBanco = _useState6[0],
	      setIdBanco = _useState6[1];
	
	  var _useState7 = (0, _react.useState)('visible'),
	      _useState8 = _slicedToArray(_useState7, 2),
	      visibleBtn = _useState8[0],
	      setVisibleBtn = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(true),
	      _useState10 = _slicedToArray(_useState9, 2),
	      habilitado = _useState10[0],
	      setHabilitado = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      catalogoCuenta = _useState12[0],
	      setCatalogoCuenta = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensaje = _useState14[0],
	      setMensaje = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mensajesino = _useState16[0],
	      setMensajesino = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      activate = _useState18[0],
	      setActivate = _useState18[1];
	
	  var _useState19 = (0, _react.useState)('Cédula:'),
	      _useState20 = _slicedToArray(_useState19, 2),
	      titleCed = _useState20[0],
	      setTitleCed = _useState20[1];
	
	  var _useState21 = (0, _react.useState)([{ value: 'V' }, { value: 'E' }]),
	      _useState22 = _slicedToArray(_useState21, 2),
	      cmbCedula = _useState22[0],
	      setCmbCedula = _useState22[1];
	
	  var _useState23 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    catalogoper: true
	  }),
	      _useState24 = _slicedToArray(_useState23, 2),
	      botones = _useState24[0],
	      setBotones = _useState24[1];
	
	  var _useState25 = (0, _react.useState)({
	    idcuentabancaria: '',
	    nombre: '',
	    cuentabancaria: '',
	    sucursal: '',
	    direccion: '',
	    contacto: '',
	    telefono: '',
	    presupuesto: '',
	    saldoconcil: '',
	    saldolib: '',
	    codctacont: '',
	    tipo: '',
	    concepto: '',
	    debitobanc: '',
	    porcentdebito: '',
	    codctadebitobanc: '',
	    idorganizacion: '',
	    idefiscal: '',
	    idbanco: '',
	    caduca: '',
	    idcuentacontable: '',
	    depositoweb: '',
	    activo: ''
	  }),
	      _useState26 = _slicedToArray(_useState25, 2),
	      values = _useState26[0],
	      setValues = _useState26[1];
	
	  var handleInputNumChange = function handleInputNumChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	
	    if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false; //alert(e.which);
	  };
	
	  var _useState27 = (0, _react.useState)(),
	      _useState28 = _slicedToArray(_useState27, 2),
	      ciudades = _useState28[0],
	      setCiudades = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(true),
	      _useState30 = _slicedToArray(_useState29, 2),
	      habilitadoNU = _useState30[0],
	      setHabilitadoNU = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(0),
	      _useState32 = _slicedToArray(_useState31, 2),
	      operacionPer = _useState32[0],
	      setOperacionPer = _useState32[1];
	
	  var datosRes = function datosRes() {
	    var campos = '*';
	    var nomtab = 'persona';
	    var nomid = 'cedula';
	    var nomid2 = 'nacionalidad';
	    var id = txtCedRes.current.value;
	    var id2 = cmbNacionalidad.current.value;
	    var endpoint = op.conexion + '/api/consulta/modeli2?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id + '&nomid2=' + nomid2 + '&id2=' + id2;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        cmbSexo.current.value = '';
	        txtFechaNac.current.value = '';
	        txtNomResp.current.value = '';
	        txtApeResp.current.value = '';
	        txtDireccion.current.value = '';
	        txtEmail.current.value = '';
	        txtTlf1.current.value = '';
	        txtTlf2.current.value = '';
	
	        if (response.data !== '') {
	          setHabilitadoNU(true);
	          setOperacionPer(0);
	          cmbSexo.current.value = response.data.sexo;
	          txtFechaNac.current.value = (0, _moment2.default)(response.data.fnacimiento).format('YYYY-MM-DD');
	          txtNomResp.current.value = response.data.nombres;
	          txtApeResp.current.value = response.data.apellidos;
	          txtDireccion.current.value = response.data.direccion;
	          txtEmail.current.value = response.data.correoe;
	          txtTlf1.current.value = response.data.tlf1;
	          txtTlf2.current.value = response.data.tlf2;
	          if (!botones.consultar) {
	            btnCancela.current.focus();
	          } else {
	            btnAcepta.current.focus();
	          }
	        } else {
	          txtNomResp.current.focus();
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una persona con este N° de cedula porfavor registre sus datos', icono: 'informacion' });
	          setOperacionPer(1);
	          setHabilitadoNU(false);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var selectCiudad = function selectCiudad(id) {
	    var campos = '*';
	    var nomtab = 'ciudad';
	    var nomid = 'idmunicipio';
	    var endpoint = op.conexion + '/api/consulta/modelirows?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid;
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setCiudades(response.data);
	      }
	    }).catch(function (error) {
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var idbancio = function idbancio(id) {
	    return function (e) {
	      e.preventDefault();
	      setIdBanco(id);
	    };
	  };
	  var blanquear = function blanquear() {
	    setOperacionPer(0);
	    setHabilitado(true);
	    setHabilitadoNU(true);
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      catalogoper: true
	    });
	    chkSi.current.checked = false;
	    chkNo.current.checked = false;
	    setValues({
	      idcuentabancaria: '',
	      nombre: '',
	      cuentabancaria: '',
	      sucursal: '',
	      direccion: '',
	      contacto: '',
	      telefono: '',
	      presupuesto: '',
	      saldoconcil: '',
	      saldolib: '',
	      codctacont: '',
	      tipo: '',
	      concepto: '',
	      debitobanc: '',
	      porcentdebito: '',
	      codctadebitobanc: '',
	      idorganizacion: '',
	      idefiscal: '',
	      idbanco: '',
	      caduca: '',
	      idcuentacontable: '',
	      depositoweb: '',
	      activo: ''
	    });
	    txtId.current.value = '';
	    txtDireccion.current.value = '';
	    setVisibleBtn('visible');
	    chkDepositos.current.checked = false;
	    setActivate(false);
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + '/api/banco/actualizarcuentabancaria';
	
	    var body = void 0;
	
	    body = {
	      operacion: ope,
	      nid: values.idcuentabancaria !== '' ? parseInt(values.idcuentabancaria) : 0,
	      nombanc: values.nombre.trim(),
	      nrocuent: values.cuentabancaria.trim(),
	      sucur: values.sucursal.trim(),
	      dir: values.direccion.trim(),
	      cont: values.contacto.trim(),
	      telf: values.telefono.trim(),
	      presu: values.presupuesto.trim(),
	      salconc: txtSaldoCon.current.value !== '' ? parseFloat(txtSaldoCon.current.value.replace(/\./g, '').replace(',', '.')) : '0.00',
	      sallib: txtSaldoLib.current.value !== '' ? parseFloat(txtSaldoLib.current.value.replace(/\./g, '').replace(',', '.')) : '0.00',
	      ctacont: null,
	      tip: null,
	      concep: values.concepto.trim(),
	      impdeb: chkSi.current.checked ? true : false,
	      porc: txtPorcenDeb.current.value !== '' ? parseFloat(txtPorcenDeb.current.value.replace(/\./g, '').replace(',', '.')) : '0.00',
	      ctacontdeb: null,
	      org: operacion === 1 ? 1 : values.idorganizacion.trim(),
	      efis: values.idefiscal !== '' ? values.idefiscal : 1,
	      idban: parseInt(idBanco),
	      cadu: values.caduca === '' ? 60 : parseInt(values.caduca),
	      idcta: null,
	      depweb: chkDepositos.current.checked === true ? true : false,
	      idctanota: null,
	      idctatransfe: null
	    };
	
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (ope === 1) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
	        } else if (ope === 2) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
	        } else if (ope === 3) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
	        }
	        txtNCuenta.current.value = '';
	        txtSucursal.current.value = '';
	        txtPersona.current.value = '';
	        txtTelefono.current.value = '';
	        txtPrepuesto.current.value = '';
	        txtSaldoCon.current.value = '';
	        txtSaldoLib.current.value = '';
	        txtConcepto.current.value = '';
	        txtPorcenDeb.current.value = '';
	        txtEmision.current.value = '';
	        blanquear();
	
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = '';
	      if (error.response === undefined) {
	        mensaje = 'Error de Conexion';
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
	          mensaje = 'Ya existe un Registro';
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	      setActivate(false);
	    });
	  };
	
	  var handleInputMontoChange = function handleInputMontoChange(event) {
	    (0, _varios.validaMonto)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
	        event.target.value = '0,00';
	      }
	      event.target.value = (0, _varios.formatoMonto)(event.target.value);
	      var char1 = event.target.value.substring(0, 1);
	      var char2 = event.target.value.substring(1, 2);
	      if (char1 === '0' && char2 !== ',') {
	        event.target.value = event.target.value.substring(1, event.target.value.legth);
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    procesarRegistro();
	  };
	
	  var onChange = function onChange(e) {
	
	    if (event.target.name === 'direccion' || event.target.name === 'sucursal' || event.target.name === 'contacto' || event.target.name === 'concepto') {
	      event.target.value = event.target.value.toUpperCase();
	      setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value.toUpperCase())));
	    } else {
	      setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value)));
	    }
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = '*';
	    var nomtab = 'cuentabancaria';
	    var nomid = 'idcuentabancaria';
	    var id = txtId.current.value;
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        if (response.data !== '') {
	
	          setValues(response.data);
	          txtDireccion.current.value = response.data.direccion.trim();
	          if (response.data.debitobanc) {
	            chkSi.current.checked = true;
	          } else {
	            chkNo.current.checked = true;
	          }
	          if (response.data.depositoweb) {
	            chkDepositos.current.checked = true;
	          }
	
	          /*        if(response.data) */
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una marca con este codigo', icono: 'informacion' });
	          txtDescripcion.current.value = '';
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var validarCuenta = function validarCuenta(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value !== '') {
	
	        seleccionarRegistro();
	      } else {
	        chkSi.current.checked = false;
	        chkNo.current.checked = false;
	        txtDireccion.current.value = '';
	        setValues({
	          idcuentabancaria: '',
	          nombre: '',
	          cuentabancaria: '',
	          sucursal: '',
	          direccion: '',
	          contacto: '',
	          telefono: '',
	          presupuesto: '',
	          saldoconcil: '',
	          saldolib: '',
	          codctacont: '',
	          tipo: '',
	          concepto: '',
	          debitobanc: '',
	          porcentdebito: '',
	          codctadebitobanc: '',
	          idorganizacion: '',
	          idefiscal: '',
	          idbanco: '',
	          caduca: '',
	          idcuentacontable: '',
	          depositoweb: '',
	          activo: ''
	        });
	        txtId.current.value = '';
	      }
	    }
	  };
	
	  /* 
	    const onCatalogoCliente = (values) => {
	      setCatalogoCliente(false);
	      txtRazon.current.value = values.nombre;
	      cmbRif.current.value = values.rif.substring(0, 1);
	      txtRif.current.value = values.rif.substring(1, 8);
	      datosRes();
	      if (!botones.modificar) {
	        setBotones({ ...botones, catalogoper: false });
	      }
	    } */
	  /* 
	    const onCatalogoPersona = (cedPer, nomPer, apePer, correoPer, tlf1Per,
	      tlf2Per, fnacPer, nacPer, sexoPer, direPer) => {
	      setCatalogoPersona(false);
	      setHabilitadoNU(true);
	      setOperacionPer(0);
	      cmbNacionalidad.current.value = nacPer;
	      txtCedRes.current.value = cedPer;
	      cmbSexo.current.value = sexoPer;
	      txtFechaNac.current.value = moment(fnacPer).format('YYYY-MM-DD');
	      txtNomResp.current.value = nomPer;
	      txtApeResp.current.value = apePer;
	      txtDireccion.current.value = direPer;
	      txtEmail.current.value = correoPer;
	      txtTlf1.current.value = tlf1Per;
	      txtTlf2.current.value = tlf2Per;
	    }
	   */
	  var onChangeValidar = function onChangeValidar() {
	
	    var sigue = true;
	
	    if (!botones.incluir || !botones.modificar) {
	
	      if (txtNombre.current.value === '' || txtNCuenta.current.value === '' || txtSucursal.current.value === '' || txtPersona.current.value === '' || txtTelefono.current.value === '' || txtPrepuesto.current.value === '' || txtDireccion.current.value === '' || txtSaldoCon.current.value === '' || txtSaldoLib.current.value === '' || txtConcepto.current.value === '') {
	
	        var _mensaje = '';
	
	        {
	          txtNombre.current.value === '' ? _mensaje = 'el Nombre' : txtNCuenta.current.value === '' ? _mensaje = 'la Cuenta' : txtSucursal.current.value === '' ? _mensaje = 'la Sucursal' : txtPersona.current.value === '' ? _mensaje = 'la Persona de Contacto' : txtTelefono.current.value === '' ? _mensaje = 'el Telefono' : txtPrepuesto.current.value === '' ? _mensaje = 'si es Presupuesto' : txtDireccion.current.value === '' ? _mensaje = 'la Dirección' : txtSaldoCon.current.value === '' ? _mensaje = 'el Saldo Conciliado' : txtSaldoLib.current.value === '' ? _mensaje = 'Saldo en Libros' : txtConcepto.current.value === '' ? _mensaje = 'Concepto' : '';
	        }
	
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar Correctamente ' + _mensaje + '.', icono: 'informacion' });
	
	        {
	          txtNombre.current.value === '' ? txtNombre.current.focus() : txtNCuenta.current.value === '' ? txtNCuenta.current.focus() : txtSucursal.current.value === '' ? txtSucursal.current.focus() : txtPersona.current.value === '' ? txtPersona.current.focus() : txtTelefono.current.value === '' ? txtTelefono.current.focus() : txtPrepuesto.current.value === '' ? txtPrepuesto.current.focus() : txtDireccion.current.value === '' ? txtDireccion.current.focus() : txtSaldoCon.current.value === '' ? txtSaldoCon.current.focus() : txtSaldoLib.current.value === '' ? txtSaldoLib.current.focus() : txtConcepto.current.value === '' ? txtConcepto.current.focus() : btnAcepta.current.focus();
	        }
	
	        sigue = false;
	      }
	    }
	    if (sigue) {
	
	      var msg = '';
	      if (!botones.incluir) {
	        msg = 'Esta Seguro de Registrar estos Datos.';
	      } else if (!botones.modificar) {
	        msg = 'Esta Seguro de Modificar estos Datos.';
	      } else if (!botones.eliminar) {
	        msg = 'Esta Seguro de Eliminar estos Datos.';
	      }
	
	      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	    }
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	
	    var campos = '*';
	    var nomtab = 'bancos';
	    var orden = 'idbanco';
	
	    var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setBancos(response.data);
	        }
	      }
	    }).catch(function (error) {
	
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onCatalogoCuenta = function onCatalogoCuenta(values) {
	    setCatalogoCuenta(false);
	    chkSi.current.checked = false;
	    chkNo.current.checked = false;
	    setValues({
	      idcuentabancaria: '',
	      nombre: '',
	      cuentabancaria: '',
	      sucursal: '',
	      direccion: '',
	      contacto: '',
	      telefono: '',
	      presupuesto: '',
	      saldoconcil: '',
	      saldolib: '',
	      codctacont: '',
	      tipo: '',
	      concepto: '',
	      debitobanc: '',
	      porcentdebito: '',
	      codctadebitobanc: '',
	      idorganizacion: '',
	      idefiscal: '',
	      idbanco: '',
	      caduca: '',
	      idcuentacontable: '',
	      depositoweb: '',
	      activo: ''
	    });
	    txtId.current.value = '';
	    setValues(values);
	    txtDireccion.current.value = values.direccion;
	    if (values.debitobanc) {
	      chkSi.current.checked = true;
	    } else {
	      chkNo.current.checked = true;
	    }
	    if (values.depositoweb) {
	      chkDepositos.current.checked = true;
	    }
	    txtId.current.value = values.idcuentabancaria;
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	
	      e.preventDefault();
	
	      if (op === 1) {
	
	        if (accbtncnciliabancaria && accbtncnciliabancaria.toString().substring(0, 1) === '1') {
	          setVisibleBtn('hidden');
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            catalogoper: false
	          });
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 2) {
	
	        if (accbtncnciliabancaria && accbtncnciliabancaria.toString().substring(1, 2) === '1') {
	          setVisibleBtn('hidden');
	          setHabilitado(false);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          txtId.current.removeAttribute("disabled");
	          txtId.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 3) {
	
	        if (accbtncnciliabancaria && accbtncnciliabancaria.toString().substring(3, 4) === '1') {
	          setVisibleBtn('hidden');
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          txtId.current.removeAttribute("disabled");
	          txtId.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 4) {
	
	        if (accbtncnciliabancaria && accbtncnciliabancaria.toString().substring(2, 3) === '1') {
	          setVisibleBtn('hidden');
	          setHabilitado(true);
	          txtId.current.focus();
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          txtId.current.removeAttribute("disabled");
	          txtId.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        setVisibleBtn('visible');
	        blanquear();
	      }
	    };
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarRegistros();
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', width: '100%' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'row col-md-12 py-5', style: { margin: 0 } },
	      _react2.default.createElement(
	        'div',
	        { className: 'row col-md-12 py-2', style: { margin: 0 } },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-8 border-azul rounded py-2 row mx-auto azulGradiant shadow text-light justify-content-between' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-6' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Gestion de Conciliaciones Bancarios'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-3 d-flex justify-content-end' },
	            _react2.default.createElement(
	              'a',
	              { href: '/inicio', className: 'text-light ' },
	              _react2.default.createElement('i', { className: 'fas fa-times mx-2' }),
	              _react2.default.createElement(
	                'span',
	                { className: 'fw-bold' },
	                'Salir'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-8 py-3 mx-auto card shadow ' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 row mx-auto  rounded py-2', style: { fontSizeAdjust: '0.6' } },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 mx-auto d-flex justify-content-end' },
	              _react2.default.createElement(
	                'div',
	                { className: ' d-flex justify-content-end col-md-4' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Fecha de Conciliaci\xF3n: ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'fw-bold' },
	                    (0, _moment2.default)(fechasistema).format('YYYY-MM-DD'),
	                    ' '
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 mb-2' },
	                _react2.default.createElement(
	                  'fieldset',
	                  { className: ' row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between' },
	                  _react2.default.createElement(
	                    'legend',
	                    { className: 'float-none w-auto fw-bold', style: { fontSize: '15px' } },
	                    'Datos Bancarios'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-2 col-md-12' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                      'CODIGO:'
	                    ),
	                    _react2.default.createElement('input', { type: 'text', className: 'form-control bg-light col-md-1 fs-6', placeholder: 'Cod.', disabled: true, ref: txtId, defaultValue: values.direccion !== null || values.direccion !== '' ? values.direccion.trim() : '', onKeyUp: validarCuenta, onBlur: validarCuenta, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'button', disabled: botones.catalogo, onClick: function onClick() {
	                          setCatalogoCuenta(true);
	                        }, className: 'btn btn-success' },
	                      _react2.default.createElement('i', { className: 'fas fa-search' })
	                    ),
	                    _react2.default.createElement('input', { type: 'text', className: 'form-control bg-light col-md-3 fs-6', placeholder: '0000-000000-00000000000', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                    _react2.default.createElement('input', { type: 'text', className: 'form-control bg-light fs-6', disabled: true, placeholder: 'Nombre', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 mb-2' },
	                _react2.default.createElement(
	                  'fieldset',
	                  { className: ' row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between' },
	                  _react2.default.createElement(
	                    'legend',
	                    { className: 'float-none w-auto fw-bold', style: { fontSize: '15px' } },
	                    'Periodo a Conciliar'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-2 col-md-2' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                      'MES:'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { className: 'form-select form-select-sm text-uppercase', 'aria-label': '.form-select-sm example', onChange: onChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        '--'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'V' },
	                        'V'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'E' },
	                        'E'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-2 col-md-2' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                      'DIA:'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { className: 'form-select form-select-sm text-uppercase', 'aria-label': '.form-select-sm example', onChange: onChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        '--'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'V' },
	                        'V'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'E' },
	                        'E'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-2 col-md-2' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                      'A\xD1O:'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { className: 'form-select form-select-sm text-uppercase', 'aria-label': '.form-select-sm example', onChange: onChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        '--'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'V' },
	                        'V'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'E' },
	                        'E'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement('div', { className: 'col-md-1' }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-2 col-md-3' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                      'TIPO MOVIMIENTO:'
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      { className: 'form-select form-select-sm text-uppercase', 'aria-label': '.form-select-sm example', onChange: onChange },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        '--'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'V' },
	                        'V'
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: 'E' },
	                        'E'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-2 col justify-content-end' },
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'button', className: 'btn btn-success rounded' },
	                      _react2.default.createElement(
	                        'i',
	                        { className: 'fas fa-search' },
	                        'Buscar'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 mb-2' },
	                _react2.default.createElement(
	                  'fieldset',
	                  { className: ' row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between' },
	                  _react2.default.createElement(
	                    'legend',
	                    { className: 'float-none w-auto fw-bold', style: { fontSize: '15px' } },
	                    'SALDOS EN CUENTA'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-2 col-md-3' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                      'SALDO ANTERIOR:'
	                    ),
	                    _react2.default.createElement('input', { type: 'text', className: 'form-control bg-light text-right fs-6', placeholder: '0,00', disabled: true, ref: txtId, defaultValue: values.direccion !== null || values.direccion !== '' ? values.direccion.trim() : '', onKeyUp: validarCuenta, onBlur: validarCuenta, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-2 col-md-3' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                      'DEBITO:'
	                    ),
	                    _react2.default.createElement('input', { type: 'text', className: 'form-control bg-light text-right fs-6', placeholder: '0,00', disabled: true, ref: txtId, defaultValue: values.direccion !== null || values.direccion !== '' ? values.direccion.trim() : '', onKeyUp: validarCuenta, onBlur: validarCuenta, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-2 col-md-3' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                      'CREDITO:'
	                    ),
	                    _react2.default.createElement('input', { type: 'text', className: 'form-control bg-light text-right fs-6', placeholder: '0,00', disabled: true, ref: txtId, defaultValue: values.direccion !== null || values.direccion !== '' ? values.direccion.trim() : '', onKeyUp: validarCuenta, onBlur: validarCuenta, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-2 col-md-3' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                      'SALDO ACTUAL:'
	                    ),
	                    _react2.default.createElement('input', { type: 'text', className: 'form-control bg-light text-right fs-6', placeholder: '0,00', disabled: true, ref: txtId, defaultValue: values.direccion !== null || values.direccion !== '' ? values.direccion.trim() : '', onKeyUp: validarCuenta, onBlur: validarCuenta, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 mx-auto' },
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'nav mb-2', id: 'ex-with-icons', role: 'tablist' },
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'nav-item', role: 'presentation' },
	                    _react2.default.createElement(
	                      'a',
	                      { style: { pointerEvents: botones.tab1 ? 'none' : 'auto' }, className: 'nav-link text-light bg-blue-100 rounded', id: 'ex-with-icons-tab-1', 'data-mdb-toggle': 'tab', href: '#ex-with-icons-tabs-1', role: 'tab', 'aria-controls': 'ex-with-icons-tabs-1', 'aria-selected': 'true' },
	                      _react2.default.createElement('i', { className: 'fas fa-briefcase fa-fw me-2' }),
	                      'Datos del Vendedor'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'nav-item', role: 'presentation' },
	                    _react2.default.createElement(
	                      'a',
	                      { style: { pointerEvents: botones.tab2 ? 'none' : 'auto' }, className: 'nav-link text-light bg-blue-200 rounded ', id: 'ex-with-icons-tab-2', 'data-mdb-toggle': 'tab', href: '#ex-with-icons-tabs-2', role: 'tab', 'aria-controls': 'ex-with-icons-tabs-2', 'aria-selected': 'false' },
	                      _react2.default.createElement('i', { className: 'fas fa-clipboard fa-fw me-2' }),
	                      'Clientes'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tab-content', id: 'ex-with-icons-content', style: { fontFamily: 'Times New Roman, Times, serif' } },
	                  _react2.default.createElement('div', { className: 'tab-pane fade show active ', id: 'ex-with-icons-tabs-1', role: 'tabpanel', 'aria-labelledby': 'ex-with-icons-tab-1' }),
	                  _react2.default.createElement('div', { className: 'tab-pane fade', id: 'ex-with-icons-tabs-2', role: 'tabpanel', 'aria-labelledby': 'ex-with-icons-tab-2' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 mt-2' },
	              visibleBtn === 'visible' ? _react2.default.createElement(
	                'div',
	                { className: 'col-pd-600' },
	                _react2.default.createElement(
	                  'button',
	                  { disabled: botones.incluir, onClick: onBotones(1), className: 'btn btn-sm mx-1 btn-primary rounded-pill', title: 'Incluir Almacen' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-plus' },
	                    ' Incluir '
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: botones.consultar, onClick: onBotones(4), className: 'btn btn-sm mx-1 btn-info rounded-pill', title: 'Consultar Almacen' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-eye' },
	                    'Consultar'
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: botones.modificar, onClick: onBotones(2), className: 'btn btn-sm mx-1 btn-warning rounded-pill', title: 'Modificar Almacen' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'fa fa-edit' },
	                    'Modificar'
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: botones.eliminar, onClick: onBotones(3), className: 'btn btn-sm mx-1 btn-danger rounded-pill', title: 'Eliminar Almacen' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'fa fa-trash' },
	                    'Eliminar'
	                  ),
	                  ' '
	                )
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'col-pd-340 d-flex justify-content-end mt-2 ml-auto' },
	                _react2.default.createElement(
	                  'button',
	                  { ref: btnAcepta, disabled: botones.aceptar, onClick: onBotones(5), className: 'mx-2 btn btn-sm rounded-pill btn-success' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    '  Aceptar'
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { ref: btnCancela, disabled: botones.cancelar, onClick: onBotones(6), className: 'mx-2 btn btn-danger btn-sm rounded-pill' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoCuentasBancarias2.default, {
	      show: catalogoCuenta,
	      onHideCancelar: function onHideCancelar() {
	        setCatalogoCuenta(false);
	      },
	      onHideAceptaCatalogo: onCatalogoCuenta
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        'cargando...'
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	      } }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	      }, onHideSi: handleCloseSi })
	  );
	};
	exports.default = TablaConciliacion;

/***/ },
/* 7133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _cartas = __webpack_require__(214);
	
	var _cartas2 = _interopRequireDefault(_cartas);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoCuentasBancarias = __webpack_require__(156);
	
	var _catalogoCuentasBancarias2 = _interopRequireDefault(_catalogoCuentasBancarias);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var TablaCuentas = function TablaCuentas() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var anio = JSON.parse(sessionStorage.getItem("anioactu"));
	
	  var accbtnctsbancarias = JSON.parse(sessionStorage.getItem("accbtnctsbancariasc"));
	  var fechaTope = (0, _moment2.default)(JSON.parse(sessionStorage.getItem("fechasistema"))).format("YYYY-MM-DD").replace(anio.toString(), (anio - 18).toString());
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var txtId = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	  var txtNombre = (0, _react.useRef)();
	  var txtNCuenta = (0, _react.useRef)();
	  var txtSucursal = (0, _react.useRef)();
	  var txtPersona = (0, _react.useRef)();
	  var txtTelefono = (0, _react.useRef)();
	  var txtDireccion = (0, _react.useRef)();
	  var txtSaldoCon = (0, _react.useRef)();
	  var txtSaldoLib = (0, _react.useRef)();
	  var txtConcepto = (0, _react.useRef)();
	
	  var cmbNacionalidad = (0, _react.useRef)();
	  var txtCedRes = (0, _react.useRef)();
	  var cmbSexo = (0, _react.useRef)();
	  var txtFechaNac = (0, _react.useRef)();
	  var txtNomResp = (0, _react.useRef)();
	  var txtApeResp = (0, _react.useRef)();
	  var txtEmail = (0, _react.useRef)();
	  var txtTlf1 = (0, _react.useRef)();
	  var txtTlf2 = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(1),
	      _useState2 = _slicedToArray(_useState, 2),
	      operacion = _useState2[0],
	      setOperacion = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = _slicedToArray(_useState3, 2),
	      bancos = _useState4[0],
	      setBancos = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(),
	      _useState6 = _slicedToArray(_useState5, 2),
	      idBanco = _useState6[0],
	      setIdBanco = _useState6[1];
	
	  var _useState7 = (0, _react.useState)("visible"),
	      _useState8 = _slicedToArray(_useState7, 2),
	      visibleBtn = _useState8[0],
	      setVisibleBtn = _useState8[1];
	
	  var _useState9 = (0, _react.useState)("Gestionar Cuentas Bancarias."),
	      _useState10 = _slicedToArray(_useState9, 2),
	      tituloHeader = _useState10[0],
	      setTituloHeader = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(true),
	      _useState12 = _slicedToArray(_useState11, 2),
	      habilitado = _useState12[0],
	      setHabilitado = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      catalogoCuenta = _useState14[0],
	      setCatalogoCuenta = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mensaje = _useState16[0],
	      setMensaje = _useState16[1];
	
	  var _useState17 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState18 = _slicedToArray(_useState17, 2),
	      mensajesino = _useState18[0],
	      setMensajesino = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(false),
	      _useState20 = _slicedToArray(_useState19, 2),
	      activate = _useState20[0],
	      setActivate = _useState20[1];
	
	  var _useState21 = (0, _react.useState)("Cédula:"),
	      _useState22 = _slicedToArray(_useState21, 2),
	      titleCed = _useState22[0],
	      setTitleCed = _useState22[1];
	
	  var _useState23 = (0, _react.useState)([{ value: "V" }, { value: "E" }]),
	      _useState24 = _slicedToArray(_useState23, 2),
	      cmbCedula = _useState24[0],
	      setCmbCedula = _useState24[1];
	
	  var _useState25 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    catalogoper: true
	  }),
	      _useState26 = _slicedToArray(_useState25, 2),
	      botones = _useState26[0],
	      setBotones = _useState26[1];
	
	  var _useState27 = (0, _react.useState)({
	    idcuentabancaria: "",
	    nombre: "",
	    cuentabancaria: "",
	    sucursal: "",
	    direccion: "",
	    contacto: "",
	    telefono: "",
	    presupuesto: "",
	    saldoconcil: "",
	    saldolib: "",
	    codctacont: "",
	    tipo: "",
	    concepto: "",
	    debitobanc: "",
	    porcentdebito: "",
	    codctadebitobanc: "",
	    idorganizacion: "",
	    idefiscal: "",
	    idbanco: "",
	    caduca: "",
	    idcuentacontable: "",
	    depositoweb: "",
	    activo: ""
	  }),
	      _useState28 = _slicedToArray(_useState27, 2),
	      values = _useState28[0],
	      setValues = _useState28[1];
	
	  var handleInputNumChange = function handleInputNumChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	
	    if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false; //alert(e.which);
	  };
	
	  var _useState29 = (0, _react.useState)(),
	      _useState30 = _slicedToArray(_useState29, 2),
	      ciudades = _useState30[0],
	      setCiudades = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(0),
	      _useState32 = _slicedToArray(_useState31, 2),
	      totalCuentas = _useState32[0],
	      setTotalCuentas = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(true),
	      _useState34 = _slicedToArray(_useState33, 2),
	      habilitadoNU = _useState34[0],
	      setHabilitadoNU = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(0),
	      _useState36 = _slicedToArray(_useState35, 2),
	      operacionPer = _useState36[0],
	      setOperacionPer = _useState36[1];
	
	  var datosRes = function datosRes() {
	    var campos = "*";
	    var nomtab = "persona";
	    var nomid = "cedula";
	    var nomid2 = "nacionalidad";
	    var id = txtCedRes.current.value;
	    var id2 = cmbNacionalidad.current.value;
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=" + id2;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        cmbSexo.current.value = "";
	        txtFechaNac.current.value = "";
	        txtNomResp.current.value = "";
	        txtApeResp.current.value = "";
	        txtDireccion.current.value = "";
	        txtEmail.current.value = "";
	        txtTlf1.current.value = "";
	        txtTlf2.current.value = "";
	
	        if (response.data !== "") {
	          setHabilitadoNU(true);
	          setOperacionPer(0);
	          cmbSexo.current.value = response.data.sexo;
	          txtFechaNac.current.value = (0, _moment2.default)(response.data.fnacimiento).format("YYYY-MM-DD");
	          txtNomResp.current.value = response.data.nombres;
	          txtApeResp.current.value = response.data.apellidos;
	          txtDireccion.current.value = response.data.direccion;
	          txtEmail.current.value = response.data.correoe;
	          txtTlf1.current.value = response.data.tlf1;
	          txtTlf2.current.value = response.data.tlf2;
	          if (!botones.consultar) {
	            btnCancela.current.focus();
	          } else {
	            btnAcepta.current.focus();
	          }
	        } else {
	          txtNomResp.current.focus();
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe una persona con este N° de cedula porfavor registre sus datos",
	            icono: "informacion"
	          });
	          setOperacionPer(1);
	          setHabilitadoNU(false);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var selectCiudad = function selectCiudad(id) {
	    var campos = "*";
	    var nomtab = "ciudad";
	    var nomid = "idmunicipio";
	    var endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&id=" + id + "&nomtab=" + nomtab + "&nomid=" + nomid;
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setCiudades(response.data);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var idbancio = function idbancio(id) {
	    return function (e) {
	      e.preventDefault();
	      setIdBanco(id);
	    };
	  };
	  var blanquear = function blanquear() {
	    setTituloHeader("Gestionar Cuentas Bancarias.");
	
	    setValues({
	      idcuentabancaria: "",
	      nombre: "",
	      cuentabancaria: "",
	      sucursal: "",
	      direccion: "",
	      contacto: "",
	      telefono: "",
	      presupuesto: "",
	      saldoconcil: "",
	      saldolib: "",
	      codctacont: "",
	      tipo: "",
	      concepto: "",
	      debitobanc: "",
	      porcentdebito: "",
	      codctadebitobanc: "",
	      idorganizacion: "",
	      idefiscal: "",
	      idbanco: "",
	      caduca: "",
	      idcuentacontable: "",
	      depositoweb: "",
	      activo: ""
	    });
	    txtId.current.value = "";
	    txtDireccion.current.value = "";
	    setVisibleBtn("visible");
	
	    setActivate(false);
	
	    setOperacionPer(0);
	    setHabilitado(true);
	    setHabilitadoNU(true);
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      catalogoper: true
	    });
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + "/api/banco/actualizarcuentabancaria";
	
	    var body = void 0;
	
	    body = {
	      operacion: ope,
	      nid: values.idcuentabancaria !== "" ? parseInt(values.idcuentabancaria) : 0,
	      nombanc: values.nombre.toUpperCase().trim(),
	      nrocuent: values.cuentabancaria.trim(),
	      sucur: values.sucursal.toUpperCase().trim(),
	      dir: values.direccion.toUpperCase().trim(),
	      cont: values.contacto.toUpperCase().trim(),
	      telf: values.telefono.trim(),
	      presu: 0,
	      salconc: txtSaldoCon.current.value !== "" ? parseFloat(txtSaldoCon.current.value.replace(/\./g, "").replace(",", ".")) : "0.00",
	      sallib: txtSaldoLib.current.value !== "" ? parseFloat(txtSaldoLib.current.value.replace(/\./g, "").replace(",", ".")) : "0.00",
	      ctacont: null,
	      tip: null,
	      concep: values.concepto.toUpperCase().trim(),
	      impdeb: false,
	      porc: 0,
	      ctacontdeb: null,
	      org: operacion === 1 ? 1 : values.idorganizacion.trim(),
	      efis: values.idefiscal !== "" ? values.idefiscal : 1,
	      idban: parseInt(idBanco),
	      cadu: values.caduca === "" ? 60 : parseInt(values.caduca),
	      idcta: null,
	      depweb: true,
	      idctanota: null,
	      idctatransfe: null
	    };
	
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (ope === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro creado correctamente",
	            icono: "exito"
	          });
	        } else if (ope === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro modificado correctamente",
	            icono: "exito"
	          });
	        } else if (ope === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro eliminado correctamente",
	            icono: "exito"
	          });
	        }
	        txtNCuenta.current.value = "";
	        txtSucursal.current.value = "";
	        txtPersona.current.value = "";
	        txtTelefono.current.value = "";
	        txtSaldoCon.current.value = "";
	        txtSaldoLib.current.value = "";
	        txtConcepto.current.value = "";
	        blanquear();
	
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = "";
	      if (error.response === undefined) {
	        mensaje = "Error de Conexion";
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
	          mensaje = "Ya existe un Registro";
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleInputMontoChange = function handleInputMontoChange(event) {
	    (0, _varios.validaMonto)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	        event.target.value = "0,00";
	      }
	      event.target.value = (0, _varios.formatoMonto)(event.target.value);
	      var char1 = event.target.value.substring(0, 1);
	      var char2 = event.target.value.substring(1, 2);
	      if (char1 === "0" && char2 !== ",") {
	        event.target.value = event.target.value.substring(1, event.target.value.legth);
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "direccion" || e.target.name === "sucursal" || e.target.name === "contacto" || e.target.name === "concepto") {
	      // e.target.value = e.target.value;
	      setValues(Object.assign({}, values, _defineProperty({}, e.target.name, e.target.value)));
	    } else {
	      setValues(Object.assign({}, values, _defineProperty({}, e.target.name, e.target.value)));
	    }
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = "*";
	    var nomtab = "cuentabancaria";
	    var nomid = "idcuentabancaria";
	    var id = txtId.current.value;
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setValues(response.data);
	          txtDireccion.current.value = response.data.direccion.trim();
	
	          /*        if(response.data) */
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe una marca con este codigo",
	            icono: "informacion"
	          });
	          txtDescripcion.current.value = "";
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var validarCuenta = function validarCuenta(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        seleccionarRegistro();
	      } else {
	        txtDireccion.current.value = "";
	        setValues({
	          idcuentabancaria: "",
	          nombre: "",
	          cuentabancaria: "",
	          sucursal: "",
	          direccion: "",
	          contacto: "",
	          telefono: "",
	          presupuesto: "",
	          saldoconcil: "",
	          saldolib: "",
	          codctacont: "",
	          tipo: "",
	          concepto: "",
	          debitobanc: "",
	          porcentdebito: "",
	          codctadebitobanc: "",
	          idorganizacion: "",
	          idefiscal: "",
	          idbanco: "",
	          caduca: "",
	          idcuentacontable: "",
	          depositoweb: "",
	          activo: ""
	        });
	        txtId.current.value = "";
	      }
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	
	    if (!botones.incluir || !botones.modificar) {
	      if (txtNombre.current.value === "" || txtNCuenta.current.value === "" || txtSucursal.current.value === "" || txtPersona.current.value === "" || txtTelefono.current.value === "" || txtDireccion.current.value === "" || txtSaldoCon.current.value === "" || txtSaldoLib.current.value === "" || txtConcepto.current.value === "") {
	        var _mensaje = "";
	
	        {
	          txtNombre.current.value === "" ? _mensaje = "el Nombre" : txtNCuenta.current.value === "" ? _mensaje = "la Cuenta" : txtSucursal.current.value === "" ? _mensaje = "la Sucursal" : txtPersona.current.value === "" ? _mensaje = "la Persona de Contacto" : txtTelefono.current.value === "" ? _mensaje = "el Telefono" : txtDireccion.current.value === "" ? _mensaje = "la Dirección" : txtSaldoCon.current.value === "" ? _mensaje = "el Saldo Conciliado" : txtSaldoLib.current.value === "" ? _mensaje = "Saldo en Libros" : txtConcepto.current.value === "" ? _mensaje = "Concepto" : "";
	        }
	
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Debe Ingresar Correctamente " + _mensaje + ".",
	          icono: "informacion"
	        });
	
	        {
	          txtNombre.current.value === "" ? txtNombre.current.focus() : txtNCuenta.current.value === "" ? txtNCuenta.current.focus() : txtSucursal.current.value === "" ? txtSucursal.current.focus() : txtPersona.current.value === "" ? txtPersona.current.focus() : txtTelefono.current.value === "" ? txtTelefono.current.focus() : txtDireccion.current.value === "" ? txtDireccion.current.focus() : txtSaldoCon.current.value === "" ? txtSaldoCon.current.focus() : txtSaldoLib.current.value === "" ? txtSaldoLib.current.focus() : txtConcepto.current.value === "" ? txtConcepto.current.focus() : btnAcepta.current.focus();
	        }
	
	        sigue = false;
	      }
	    }
	    if (sigue) {
	      var msg = "";
	      if (!botones.incluir) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (!botones.modificar) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (!botones.eliminar) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "*";
	    var nomtab = "bancos";
	    var orden = "idbanco";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setBancos(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarCuentas = function seleccionarCuentas() {
	    var campos = "idcuentabancaria";
	    var nomtab = "cuentabancaria";
	    var orden = "idcuentabancaria";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setTotalCuentas(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onCatalogoCuenta = function onCatalogoCuenta(values) {
	    setCatalogoCuenta(false);
	
	    setValues({
	      idcuentabancaria: "",
	      nombre: "",
	      cuentabancaria: "",
	      sucursal: "",
	      direccion: "",
	      contacto: "",
	      telefono: "",
	      presupuesto: "",
	      saldoconcil: "",
	      saldolib: "",
	      codctacont: "",
	      tipo: "",
	      concepto: "",
	      debitobanc: "",
	      porcentdebito: "",
	      codctadebitobanc: "",
	      idorganizacion: "",
	      idefiscal: "",
	      idbanco: "",
	      caduca: "",
	      idcuentacontable: "",
	      depositoweb: "",
	      activo: ""
	    });
	    txtId.current.value = "";
	    setValues(values);
	    txtDireccion.current.value = values.direccion;
	    txtId.current.value = values.idcuentabancaria;
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (accbtnctsbancarias && accbtnctsbancarias.toString().substring(0, 1) === "1") {
	          setVisibleBtn("hidden");
	          setTituloHeader("Incluir Cuentas Bancarias.");
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            catalogoper: false
	          });
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (accbtnctsbancarias && accbtnctsbancarias.toString().substring(1, 2) === "1") {
	          setTituloHeader("Editar Cuentas Bancarias.");
	          setVisibleBtn("hidden");
	          setHabilitado(false);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          txtId.current.removeAttribute("disabled");
	          txtId.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (accbtnctsbancarias && accbtnctsbancarias.toString().substring(3, 4) === "1") {
	          setTituloHeader("Eliminar Cuentas Bancarias.");
	          setVisibleBtn("hidden");
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          txtId.current.removeAttribute("disabled");
	          txtId.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (accbtnctsbancarias && accbtnctsbancarias.toString().substring(2, 3) === "1") {
	          setTituloHeader("Consultar Cuentas Bancarias.");
	          setVisibleBtn("hidden");
	          setHabilitado(true);
	          txtId.current.focus();
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          txtId.current.removeAttribute("disabled");
	          txtId.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        setVisibleBtn("visible");
	        blanquear();
	      }
	    };
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarRegistros();
	    seleccionarCuentas();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 py-5", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-8 py-3 mx-auto card shadow " },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row mx-auto  rounded py-2" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light justify-content-between" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-6" },
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  tituloHeader
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 d-flex justify-content-end" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "/inicio", className: "text-light " },
	                  _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "fw-bold" },
	                    "Salir"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "row mx-auto border-azul py-3 rounded",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-md-4 col-lg-3 col-xl-3 col-sm-4" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "CODIGO:"
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  name: "idcuentabancaria",
	                  className: "form-control bg-light fs-6",
	                  disabled: true,
	                  ref: txtId,
	                  defaultValue: values.idcuentabancaria !== null || values.idcuentabancaria !== "" ? values.idcuentabancaria.trim() : "",
	                  onKeyUp: validarCuenta,
	                  onBlur: validarCuenta,
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                }),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    disabled: botones.catalogo,
	                    onClick: function onClick() {
	                      setCatalogoCuenta(true);
	                    },
	                    className: "btn btn-success"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-search" })
	                )
	              ),
	              _react2.default.createElement("div", { className: "col-md-10" }),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-xl-5 col-lg-6 col-md-12 col-sm-12" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "NOMBRE DEL BANCO:"
	                ),
	                _react2.default.createElement(
	                  "select",
	                  {
	                    disabled: habilitado,
	                    ref: txtNombre,
	                    className: "form-select form-select-sm text-uppercase",
	                    name: "nombre",
	                    id: "inputStatus",
	                    onChange: onChange,
	                    value: values && values.nombre.trim()
	                  },
	                  _react2.default.createElement(
	                    "option",
	                    { value: "" },
	                    "Seleccione"
	                  ),
	                  bancos && bancos.map(function (item, index) {
	                    return _react2.default.createElement(
	                      "option",
	                      {
	                        key: index,
	                        value: item.nombre.trim(),
	                        onClick: idbancio(item.idbanco)
	                      },
	                      " ",
	                      item.nombre,
	                      " "
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-xl-4 col-lg-6 col-md-12 col-sm-12" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "N\xB0 DE CUENTA:"
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  name: "cuentabancaria",
	                  className: "form-control bg-light fs-6",
	                  ref: txtNCuenta,
	                  value: values.cuentabancaria !== null || values.cuentabancaria !== "" ? values.cuentabancaria.trim() : "",
	                  disabled: habilitado,
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  onChange: onChange,
	                  onKeyUp: handleInputNumChange,
	                  onBlur: handleInputNumChange
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-xl-3 col-lg-4 col-md-12 col-sm-12" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "SUCURSAL:"
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  name: "sucursal",
	                  ref: txtSucursal,
	                  className: "form-control bg-light text-uppercase fs-6",
	                  value: values.sucursal !== null || values.sucursal !== "" ? values.sucursal : "",
	                  disabled: habilitado,
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  onChange: onChange
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-xl-9  col-lg-8" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "PERSONA DE CONTACTO:"
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  name: "contacto",
	                  className: "form-control bg-light text-uppercase fs-6",
	                  ref: txtPersona,
	                  value: values.contacto !== null || values.contacto !== "" ? values.contacto : "",
	                  disabled: habilitado,
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  onChange: onChange
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-xl-3 col-lg-5 col-md-12" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "TELEFONO:"
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  name: "telefono",
	                  className: "form-control bg-light fs-6",
	                  maxLength: 11,
	                  ref: txtTelefono,
	                  value: values.telefono !== null || values.telefono !== "" ? values.telefono.trim() : "",
	                  disabled: habilitado,
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  onChange: onChange,
	                  onKeyUp: handleInputNumChange,
	                  onBlur: handleInputNumChange
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm col-md-12  mb-2" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "DIRECCION:"
	                ),
	                _react2.default.createElement("textarea", {
	                  type: "area",
	                  className: "form-control rounded bg-light text-uppercase fs-6",
	                  style: { height: 40 },
	                  ref: txtDireccion,
	                  disabled: habilitado,
	                  value: values.direccion !== null || values.direccion !== "" ? values.direccion : "",
	                  "aria-label": "With textarea",
	                  name: "direccion",
	                  onChange: onChange
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-12" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "CONCEPTO:"
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  className: "form-control bg-light text-uppercase fs-6",
	                  name: "concepto",
	                  ref: txtConcepto,
	                  value: values.concepto !== null || values.concepto !== "" ? values.concepto : "",
	                  disabled: habilitado,
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  onChange: onChange
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-4" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "SALDO CONCILIADO:"
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  className: "form-control bg-light text-right fs-6",
	                  name: "saldoconcil",
	                  ref: txtSaldoCon,
	                  value: values.saldoconcil !== null || values.saldoconcil !== "" ? (0, _varios.formatMoneda)(values.saldoconcil.replace(",", "").replace(".", ","), ",", ".", 2) : "0,00",
	                  disabled: habilitado,
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  onChange: onChange,
	                  onKeyUp: handleInputMontoChange,
	                  onBlur: handleInputMontoChange
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-4" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "SALDO EN LIBRO:"
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  className: "form-control bg-light text-right fs-6",
	                  name: "saldolib",
	                  ref: txtSaldoLib,
	                  value: values.saldolib !== null || values.saldolib !== "" ? (0, _varios.formatMoneda)(values.saldolib.replace(",", "").replace(".", ","), ",", ".", 2) : "0,00",
	                  disabled: habilitado,
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  onChange: onChange,
	                  onKeyUp: handleInputMontoChange,
	                  onBlur: handleInputMontoChange
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 d-flex justify-content-between mt-3" },
	              visibleBtn === "visible" ? _react2.default.createElement(
	                "div",
	                {
	                  className: "col-pd-600 d-flex justify-content-start"
	                },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: botones.incluir,
	                    onClick: onBotones(1),
	                    className: "btn btn-sm mx-1 btn-primary rounded-pill",
	                    title: "Incluir Cuenta Bancaria"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-plus" },
	                    " ",
	                    "Incluir",
	                    " "
	                  ),
	                  " "
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: botones.consultar,
	                    onClick: onBotones(4),
	                    className: "btn btn-sm mx-1 btn-info rounded-pill",
	                    title: "Consultar Cuenta Bancaria"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-eye" },
	                    "Consultar"
	                  ),
	                  " "
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: botones.modificar,
	                    onClick: onBotones(2),
	                    className: "btn btn-sm mx-1 btn-warning rounded-pill",
	                    title: "Modificar Cuenta Bancaria"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fa fa-edit" },
	                    "Modificar"
	                  ),
	                  " "
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: botones.eliminar,
	                    onClick: onBotones(3),
	                    className: "btn btn-sm mx-1 btn-danger rounded-pill",
	                    title: "Eliminar Cuenta Bancaria"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fa fa-trash" },
	                    "Eliminar"
	                  ),
	                  " "
	                )
	              ) : _react2.default.createElement(
	                "div",
	                {
	                  className: "col-pd-340 d-flex justify-content-end ml-auto"
	                },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta,
	                    disabled: botones.aceptar,
	                    onClick: onBotones(5),
	                    className: "mx-2 btn btn-sm rounded-pill btn-success"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    {
	                      className: "fas fa-check-circle"
	                    },
	                    " ",
	                    "Aceptar"
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnCancela,
	                    disabled: botones.cancelar,
	                    onClick: onBotones(6),
	                    className: "mx-2 btn btn-danger btn-sm rounded-pill"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    {
	                      className: "fas fa-window-close"
	                    },
	                    " ",
	                    "Cancelar"
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoCuentasBancarias2.default, {
	      show: catalogoCuenta,
	      onHideCancelar: function onHideCancelar() {
	        setCatalogoCuenta(false);
	      },
	      onHideAceptaCatalogo: onCatalogoCuenta
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = TablaCuentas;

/***/ },
/* 7134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _cartas = __webpack_require__(214);
	
	var _cartas2 = _interopRequireDefault(_cartas);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _incluirMovimiento = __webpack_require__(669);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _catalogoCuentasBancarias = __webpack_require__(156);
	
	var _catalogoCuentasBancarias2 = _interopRequireDefault(_catalogoCuentasBancarias);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TablaMovimientosBancos = function TablaMovimientosBancos() {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var anio = JSON.parse(sessionStorage.getItem('anioactu'));
	
	  var headCells = [{ id: 'idmovimientobancario', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'COD.', textAlign: 'center' }, { id: 'tipomov', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'TIPO', textAlign: 'center' }, { id: 'referencia', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'REFERENCIA', textAlign: 'center' }, { id: 'fecha', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'FECHA', textAlign: 'center' }, { id: 'monto', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'MONTO', textAlign: 'center' }, { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }];
	
	  var fechaTope = (0, _moment2.default)(JSON.parse(sessionStorage.getItem('fechasistema'))).format('YYYY-MM-DD').replace(anio.toString(), (anio - 18).toString());
	
	  var txtIdCuentaBancaria = (0, _react.useRef)();
	  var txtCuenta = (0, _react.useRef)();
	
	  var txtBuscador = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      operacion = _useState2[0],
	      setOperacion = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      catalogoCuenta = _useState4[0],
	      setCatalogoCuenta = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mostrar = _useState6[0],
	      setMostrar = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      body = _useState8[0],
	      setBody = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      habilitado = _useState10[0],
	      setHabilitado = _useState10[1];
	
	  var _useState11 = (0, _react.useState)('0'),
	      _useState12 = _slicedToArray(_useState11, 2),
	      idMovimiento = _useState12[0],
	      setIdMovimiento = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensaje = _useState14[0],
	      setMensaje = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mensajesino = _useState16[0],
	      setMensajesino = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      activate = _useState18[0],
	      setActivate = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({ fn: function fn(items) {
	      return items;
	    } }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      filterFn = _useState20[0],
	      setFilterFn = _useState20[1];
	
	  var _useState21 = (0, _react.useState)([]),
	      _useState22 = _slicedToArray(_useState21, 2),
	      records = _useState22[0],
	      setRecords = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(),
	      _useState24 = _slicedToArray(_useState23, 2),
	      regDet = _useState24[0],
	      setRegDet = _useState24[1];
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	    var st = '';
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") return items;else return items.filter(function (x) {
	          st = x.status === '51' ? 'activo' : 'inactivo';
	          if (x.idmovimientobancario.includes(target.value) || x.tipomov.toLowerCase().includes(target.value.toLowerCase()) || x.referencia.toLowerCase().includes(target.value.toLowerCase()) || (0, _moment2.default)(x.fecha).format('DD/MM/YYYY').toLowerCase().includes(target.value.toLowerCase()) || (0, _varios.formatMoneda)(x.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2).toLowerCase().includes(target.value.toLowerCase())) {
	            return x;
	          }
	        });
	      }
	    });
	  };
	
	  var handleInputNumChange = function handleInputNumChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	
	    if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false; //alert(e.which);
	  };
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting,
	      TblPagination = _useTable.TblPagination;
	
	  var seleccionarCuentaBancaria = function seleccionarCuentaBancaria(id) {
	
	    var campos = "*";
	    var nomtab = 'cuentabancaria';
	    var nomid = 'idcuentabancaria';
	
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid + ' ';
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	
	      if (response.status == 200) {
	
	        if (response.data !== '') {
	          txtCuenta.current.value = response.data.nombre.trim() + ' --- ' + response.data.cuentabancaria.trim();
	          seleccionarMovimientos(response.data.idcuentabancaria);
	          setTimeout(function () {
	            return txtBuscador.current.focus();
	          }, 200);
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'ID no existe.', icono: 'informacion' });
	          txtIdCuentaBancaria.current.value = '';
	          txtIdCuentaBancaria.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var seleccionarMovimientos = function seleccionarMovimientos(id) {
	
	    var campos = "*";
	    var nomtab = 'movimientosbancarios';
	    var nomid = 'idcuentabancaria';
	    var condic = 'manual=true';
	
	    var endpoint = op.conexion + '/api/consulta/modelicondi?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid + '&condic=' + condic;
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	
	      if (response.status == 200) {
	        setRecords([]);
	        if (response.data.length > 0) {
	          var mov = [];
	          for (var i = 0; i < response.data.length; i++) {
	            mov.push({
	              idmovimientobancario: response.data[i].idmovimientobancario,
	              idcuentabancaria: response.data[i].idcuentabancaria,
	              fecha: response.data[i].fecha,
	              fechaingreso: response.data[i].fechaingreso,
	              fechareal: response.data[i].fechareal,
	              referencia: response.data[i].referencia,
	              concepto: response.data[i].concepto,
	              monto: response.data[i].monto,
	              tipo: response.data[i].tipo,
	              reversado: response.data[i].reversado,
	              conciliado: response.data[i].conciliado,
	              fechareversado: response.data[i].fechareversado,
	              fechaconciliacion: response.data[i].fechaconciliacion,
	              fechaedocuenta: response.data[i].fechaedocuenta,
	              manual: response.data[i].manual,
	              tipomov: response.data[i].tipo === 0 ? 'DEPOSITO' : response.data[i].tipo === 1 ? 'TRANSFERENCIA' : response.data[i].tipo === 2 ? 'NOTA CREDITO' : response.data[i].tipo === 3 ? 'NOTA DEBITO' : 'CHEQUE'
	            });
	          }
	          //setRecords(response.data);
	          setRecords(mov);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var gestionarMovimiento = function gestionarMovimiento(op, id, index) {
	    return function (e) {
	      if (op === 4) {
	        setHabilitado(false);
	        setOperacion(4);
	        var mov = records;
	        var mov = mov.filter(function (mov) {
	          return mov.idmovimientobancario === id;
	        });
	        setRegDet(mov[0]);
	        setMostrar(true);
	        /*    getExpendedor(id); */
	      } else if (op === 1) {
	        if (txtIdCuentaBancaria.current.value === '' || txtCuenta.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe seleccionar una Cuenta Bancaaria.', icono: 'informacion' });
	          return;
	        }
	        setOperacion(op);
	        setHabilitado(true);
	        setMostrar(true);
	      } else if (op === 2) {
	        setHabilitado(true);
	        setOperacion(op);
	        var mov = records;
	        var mov = mov.filter(function (mov) {
	          return mov.idmovimientobancario === id;
	        });
	        if (mov[0].conciliado === 1) {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El movimiento no se puede modificar, ya está conciliado.', icono: 'informacion' });
	          return;
	        }
	        setRegDet(mov[0]);
	        setMostrar(true);
	        /*   getExpendedor(id); */
	      } else if (op === 3) {
	        setOperacion(op);
	        setHabilitado(false);
	        var mov = records;
	        var mov = mov.filter(function (mov) {
	          return mov.idmovimientobancario === id;
	        });
	        if (mov[0].conciliado === 1) {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'El movimiento no se puede eliminar, ya está conciliado.', icono: 'informacion' });
	          return;
	        }
	        setRegDet(mov[0]);
	        setMostrar(true);
	      }
	    };
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setBody(null);
	    setRecords([]);
	    setOperacion(0);
	    txtIdCuentaBancaria.current.value = '';
	    txtCuenta.current.value = '';
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var validarCuenta = function validarCuenta(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value !== '') {
	
	        seleccionarCuentaBancaria(event.target.value);
	      } else {
	        txtCuenta.current.value = '';
	      }
	    }
	  };
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'idcuentabancaria') {
	      txtCuenta.current.value = '';
	      setRecords([]);
	    }
	  };
	
	  var onCatalogoCuenta = function onCatalogoCuenta(values) {
	    setCatalogoCuenta(false);
	    txtIdCuentaBancaria.current.value = values.idcuentabancaria;
	    seleccionarCuentaBancaria(values.idcuentabancaria);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', width: '100%' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'row col-md-12 py-3', style: { margin: 0 } },
	      _react2.default.createElement(
	        'div',
	        { className: 'row col-md-6 mx-auto', style: { margin: 0 } },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 py-1 mx-auto card shadow ' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 row mx-auto  rounded py-3' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light justify-content-between' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Gestion de Movimientos Bancarios'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-3 d-flex justify-content-end' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '/inicio', className: 'text-light ' },
	                  _react2.default.createElement('i', { className: 'fas fa-times mx-2' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'fw-bold' },
	                    'Salir'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 mx-auto' },
	              _react2.default.createElement(
	                'fieldset',
	                { className: ' row col-sm-12 mx-auto border-azul rounded', style: { fontSizeAdjust: '0.6' } },
	                _react2.default.createElement(
	                  'legend',
	                  { className: 'float-none w-auto fw-bold', style: { fontSize: '15px' } },
	                  'Cuenta Bancaria'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm mb-2 col-xl-3 col-lg-4 col-md-5 col-sm-4' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'CODIGO:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', ref: txtIdCuentaBancaria, name: 'idcuentabancaria', className: 'form-control bg-light fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: validarCuenta, onBlur: validarCuenta, onChange: onChange }),
	                  _react2.default.createElement(
	                    'button',
	                    { type: 'button', onClick: function onClick() {
	                        setCatalogoCuenta(true);
	                      }, className: 'btn btn-success' },
	                    _react2.default.createElement('i', { className: 'fas fa-search' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm mb-2 col-xl-9 col-lg-12' },
	                  _react2.default.createElement('input', { type: 'text', disabled: true, ref: txtCuenta, name: 'cuentabancaria', className: 'form-control bg-light fs-6', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 mx-auto mt-2' },
	              _react2.default.createElement(
	                'fieldset',
	                { className: ' row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between' },
	                _react2.default.createElement(
	                  'legend',
	                  { className: 'float-none w-auto fw-bold', style: { fontSize: '15px' } },
	                  'Movimientos'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-12 p-2' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'row col-12 d-flex justify-content-between' },
	                    _react2.default.createElement('input', { type: 'text', className: ' col-3 form-control form-control-sm rounded-pill', ref: txtBuscador, onChange: handleSearch, placeholder: 'Buscar' }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'col-3 d-flex justify-content-end' },
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: gestionarMovimiento(1, ''), style: { marginBottom: "5px" }, className: 'btn btn-sm btn-primary rounded-circle' },
	                        _react2.default.createElement('i', { className: 'fas fa-plus' }),
	                        ' '
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'col-md-12', style: { margin: "auto" } },
	                  _react2.default.createElement(
	                    TblContainer,
	                    null,
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                      _core.TableBody,
	                      null,
	                      records && recordsAfterPagingAndSorting().map(function (item, index) {
	                        return _react2.default.createElement(
	                          _core.TableRow,
	                          { key: index, style: { padding: "0", fontSizeAdjust: '0.6' } },
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center', width: '240px' } },
	                            item.idmovimientobancario
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center', width: '240px' } },
	                            item.tipomov
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center', width: '240px' } },
	                            item.referencia
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center', width: '270px' } },
	                            (0, _moment2.default)(item.fecha).format('DD/MM/YYYY')
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center', width: '270px' } },
	                            (0, _varios.formatMoneda)(item.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2)
	                          ),
	                          _react2.default.createElement(
	                            _core.TableCell,
	                            { className: 'align-baseline', style: { textAlign: "center", alignItems: 'center', width: '330px' } },
	                            _react2.default.createElement(
	                              'button',
	                              { onClick: gestionarMovimiento(4, item.idmovimientobancario, index), className: 'btn btn-sm mx-1 btn-info rounded-circle' },
	                              _react2.default.createElement('i', { className: 'fas fa-eye' }),
	                              ' '
	                            ),
	                            _react2.default.createElement(
	                              'button',
	                              { onClick: gestionarMovimiento(2, item.idmovimientobancario, index), className: 'btn btn-sm mx-1 btn-warning rounded-circle' },
	                              _react2.default.createElement('i', { className: 'fa fa-edit' }),
	                              ' '
	                            ),
	                            _react2.default.createElement(
	                              'button',
	                              { onClick: gestionarMovimiento(3, item.idmovimientobancario, index), className: 'btn btn-sm mx-1 btn-danger rounded-circle' },
	                              _react2.default.createElement('i', { className: 'fa fa-trash' }),
	                              ' '
	                            )
	                          )
	                        );
	                      })
	                    )
	                  ),
	                  _react2.default.createElement(TblPagination, null)
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_incluirMovimiento.IncluirMovimiento, {
	      show: mostrar,
	      operacion: operacion,
	      idcuentabancaria: txtIdCuentaBancaria.current ? txtIdCuentaBancaria.current.value : '0',
	      idmovimiento: idMovimiento,
	      habilitado: habilitado,
	      registro: regDet,
	      onHideCancela: function onHideCancela() {
	        setMostrar(false);
	      },
	      onHideRenderizar: function onHideRenderizar() {
	        seleccionarMovimientos(txtIdCuentaBancaria.current.value);
	      }
	    }),
	    _react2.default.createElement(_catalogoCuentasBancarias2.default, {
	      show: catalogoCuenta,
	      onHideCancelar: function onHideCancelar() {
	        setCatalogoCuenta(false);
	      },
	      onHideAceptaCatalogo: onCatalogoCuenta
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        'cargando...'
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	      } }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	      }, onHideSi: handleCloseSi })
	  );
	};
	exports.default = TablaMovimientosBancos;

/***/ },
/* 7135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _core = __webpack_require__(19);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _cartas = __webpack_require__(214);
	
	var _cartas2 = _interopRequireDefault(_cartas);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _incluirMovimiento = __webpack_require__(669);
	
	var _useTable = __webpack_require__(20);
	
	var _useTable2 = _interopRequireDefault(_useTable);
	
	var _catalogoBeneficiarios = __webpack_require__(7024);
	
	var _catalogoBeneficiarios2 = _interopRequireDefault(_catalogoBeneficiarios);
	
	var _catalogoTipoRetenciones = __webpack_require__(294);
	
	var _catalogoTipoRetenciones2 = _interopRequireDefault(_catalogoTipoRetenciones);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var TablaTipoRetenciones = function TablaTipoRetenciones() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var anio = JSON.parse(sessionStorage.getItem('anioactu'));
	
	  var accbtntipretenciones = JSON.parse(sessionStorage.getItem('accbtntipretencionesc'));
	  var fechaTope = (0, _moment2.default)(JSON.parse(sessionStorage.getItem('fechasistema'))).format('YYYY-MM-DD').replace(anio.toString(), (anio - 18).toString());
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	
	  var txtId = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	  var cmbTipo = (0, _react.useRef)();
	  var txtDeducible = (0, _react.useRef)();
	  var chkPorcen = (0, _react.useRef)();
	  var chkMilPorcen = (0, _react.useRef)();
	  var chkUniTri = (0, _react.useRef)();
	  var chkMontFij = (0, _react.useRef)();
	  var chkOtroPor = (0, _react.useRef)();
	  var txtOtroPorcen = (0, _react.useRef)();
	  var txtIdAgente = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      operacion = _useState2[0],
	      setOperacion = _useState2[1];
	
	  var _useState3 = (0, _react.useState)('visible'),
	      _useState4 = _slicedToArray(_useState3, 2),
	      visibleBtn = _useState4[0],
	      setVisibleBtn = _useState4[1];
	
	  var _useState5 = (0, _react.useState)('collapse'),
	      _useState6 = _slicedToArray(_useState5, 2),
	      visibleOtro = _useState6[0],
	      setVisibleOtro = _useState6[1];
	
	  var _useState7 = (0, _react.useState)('hidden'),
	      _useState8 = _slicedToArray(_useState7, 2),
	      visibleISLR = _useState8[0],
	      setVisibleISLR = _useState8[1];
	
	  var _useState9 = (0, _react.useState)('Gestionar Tipo de Retenciones.'),
	      _useState10 = _slicedToArray(_useState9, 2),
	      tituloHeader = _useState10[0],
	      setTituloHeader = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(true),
	      _useState12 = _slicedToArray(_useState11, 2),
	      habilitado = _useState12[0],
	      setHabilitado = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      catalogoBene = _useState14[0],
	      setCatalogoBene = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      catalogoTipoReten = _useState16[0],
	      setCatalogoTipoReten = _useState16[1];
	
	  var _useState17 = (0, _react.useState)({
	    idagente: '',
	    nombre: ''
	  }),
	      _useState18 = _slicedToArray(_useState17, 2),
	      tercero = _useState18[0],
	      setTercero = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      mensaje = _useState20[0],
	      setMensaje = _useState20[1];
	
	  var _useState21 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState22 = _slicedToArray(_useState21, 2),
	      mensajesino = _useState22[0],
	      setMensajesino = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(false),
	      _useState24 = _slicedToArray(_useState23, 2),
	      activate = _useState24[0],
	      setActivate = _useState24[1];
	
	  var _useState25 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    catalogoBene: true
	  }),
	      _useState26 = _slicedToArray(_useState25, 2),
	      botones = _useState26[0],
	      setBotones = _useState26[1];
	
	  var _useState27 = (0, _react.useState)({
	    idtiporetencion: '',
	    descripcion: '',
	    unidad: '',
	    idcuentacontable: '',
	    tipo: '',
	    deducible: '',
	    otro: '',
	    idagente: ''
	  }),
	      _useState28 = _slicedToArray(_useState27, 2),
	      values = _useState28[0],
	      setValues = _useState28[1];
	
	  var handleInputNumChange = function handleInputNumChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	
	    if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false; //alert(e.which);
	  };
	
	  var _useState29 = (0, _react.useState)(),
	      _useState30 = _slicedToArray(_useState29, 2),
	      ciudades = _useState30[0],
	      setCiudades = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(true),
	      _useState32 = _slicedToArray(_useState31, 2),
	      habilitadoNU = _useState32[0],
	      setHabilitadoNU = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(0),
	      _useState34 = _slicedToArray(_useState33, 2),
	      operacionPer = _useState34[0],
	      setOperacionPer = _useState34[1];
	
	  /*   const datosRes = () => {
	      let campos = '*';
	      let nomtab = 'persona';
	      let nomid = 'cedula';
	      let nomid2 = 'nacionalidad';
	      let id = txtCedRes.current.value;
	      let id2 = cmbNacionalidad.current.value;
	      let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${id2}`;
	  
	      setActivate(true);
	      axios.get(endpoint, {
	        headers: {
	          'x-access-token': `${token}`
	        }
	      }).then(function (response) {
	        if (response.status === 200) {
	  
	          cmbSexo.current.value = ''
	          txtFechaNac.current.value = ''
	          txtNomResp.current.value = ''
	          txtApeResp.current.value = ''
	          txtDescripcion.current.value = ''
	          txtEmail.current.value = ''
	          txtTlf1.current.value = ''
	          txtTlf2.current.value = ''
	  
	          if (response.data !== '') {
	            setHabilitadoNU(true);
	            setOperacionPer(0);
	            cmbSexo.current.value = response.data.sexo
	            txtFechaNac.current.value = moment(response.data.fnacimiento).format('YYYY-MM-DD')
	            txtNomResp.current.value = response.data.nombres
	            txtApeResp.current.value = response.data.apellidos
	            txtDescripcion.current.value = response.data.direccion
	            txtEmail.current.value = response.data.correoe
	            txtTlf1.current.value = response.data.tlf1
	            txtTlf2.current.value = response.data.tlf2
	            if (!botones.consultar) {
	              btnCancela.current.focus();
	            } else {
	              btnAcepta.current.focus();
	            }
	  
	          } else {
	            txtNomResp.current.focus();
	            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una persona con este N° de cedula porfavor registre sus datos', icono: 'informacion' });
	            setOperacionPer(1);
	            setHabilitadoNU(false);
	  
	          }
	        }
	        setActivate(false);
	      }).catch(function (error) {
	        setActivate(false);
	        setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	      })
	    }; */
	
	  var blanquear = function blanquear() {
	    setOperacion(0);
	    setTituloHeader('Gestionar Tipo de Retenciones.');
	    chkPorcen.current.checked = false;
	    chkMilPorcen.current.checked = false;
	    chkUniTri.current.checked = false;
	    chkMontFij.current.checked = false;
	    chkOtroPor.current.checked = false;
	    txtDeducible.current.value = '';
	    txtOtroPorcen.current.value = '';
	    setVisibleISLR('hidden');
	    setVisibleOtro('collapse');
	    setVisibleBtn('visible');
	    setTercero({
	      idagente: '',
	      nombre: ''
	    });
	    setValues({
	      idtiporetencion: '',
	      descripcion: '',
	      unidad: '',
	      idcuentacontable: '',
	      tipo: '',
	      deducible: '',
	      otro: '',
	      idagente: ''
	    });
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      catalogoBene: true
	    });
	
	    cmbTipo.current.value = '';
	    txtId.current.value = '';
	    txtDescripcion.current.value = '';
	    txtIdAgente.current.value = '';
	
	    setActivate(false);
	    setOperacionPer(0);
	    setHabilitado(true);
	    setHabilitadoNU(true);
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + '/api/retenciones/actualizarretenciones';
	
	    var body = void 0;
	
	    body = {
	      operacion: ope,
	      idtiporete: values.idtiporetencion === '' ? 0 : values.idtiporetencion,
	      descrip: values.descripcion.toUpperCase().trim(),
	      unid: parseInt(values.unidad),
	      idcuentcon: 0,
	      tip: parseInt(values.tipo),
	      deducibl: txtDeducible.current.value === '' ? 0.00 : parseFloat(txtDeducible.current.value.replace(/\./g, '').replace(',', '.')),
	      otr: txtOtroPorcen.current.value === '' ? 0.00 : parseFloat(txtOtroPorcen.current.value.replace(/\./g, '').replace(',', '.')),
	      idagen: parseInt(tercero.idagente)
	    };
	
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (ope === 1) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
	        } else if (ope === 2) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
	        } else if (ope === 3) {
	          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
	        }
	
	        blanquear();
	
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = '';
	      if (error.response === undefined) {
	        mensaje = 'Error de Conexion';
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
	          mensaje = 'Ya existe un Registro';
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
	      setActivate(false);
	    });
	  };
	
	  var handleInputMontoChange = function handleInputMontoChange(event) {
	    (0, _varios.validaMonto)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value === '' || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.00) {
	        event.target.value = '0,00';
	      }
	      event.target.value = (0, _varios.formatoMonto)(event.target.value);
	      var char1 = event.target.value.substring(0, 1);
	      var char2 = event.target.value.substring(1, 2);
	      if (char1 === '0' && char2 !== ',') {
	        event.target.value = event.target.value.substring(1, event.target.value.legth);
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    procesarRegistro();
	  };
	
	  var onChange = function onChange(event) {
	
	    if (event.target.name === 'descripcion') {
	      event.target.value = event.target.value;
	      setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value)));
	    } else if (event.target.name === 'unidad') {
	      if (event.target.value === '4') {
	        setVisibleOtro('visible');
	      } else {
	        setVisibleOtro('collapse');
	        txtOtroPorcen.current.value = '';
	      }
	      setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value)));
	    } else if (event.target.name === 'tipo') {
	      if (event.target.value === '1') {
	        setVisibleISLR('visible');
	      } else {
	        setVisibleISLR('hidden');
	        txtDeducible.current.value = '';
	      }
	      setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value)));
	    } else {
	      setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value)));
	    }
	  };
	
	  var seleccionarRegistroBene = function seleccionarRegistroBene(id) {
	
	    var campos = 'idagente, nombre';
	    var nomtab = 'agente';
	    var condi = "agenteretencion = true and idagente = " + id;
	    var orden = 'idagente';
	
	    var endpoint = op.conexion + '/api/consulta/selecionarregistrocondi?&campos=' + campos + '&nomtab=' + nomtab + '&condi=' + condi + '&orden=' + orden;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        setTercero({
	          idagente: '',
	          nombre: ''
	        });
	
	        if (response.data[0].idagente !== undefined) {
	
	          txtIdAgente.current.value = response.data[0].idagente;
	          setTercero({
	            idagente: response.data[0].idagente,
	            nombre: response.data[0].nombre
	          });
	        } else {}
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe un Fondo de Tercero con este codigo', icono: 'informacion' });
	    });
	  };
	
	  var seleccionarRegistroTipReten = function seleccionarRegistroTipReten() {
	    var campos = '*';
	    var nomtab = 'tiporetencion';
	    var nomid = 'idtiporetencion';
	    var id = txtId.current.value;
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        if (response.data !== '') {
	
	          if (parseInt(response.data.tipo) === 1) {
	            setVisibleISLR('visible');
	            txtDeducible.current.value = (0, _varios.formatMoneda)(response.data.deducible.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	          }
	
	          switch (parseInt(response.data.unidad)) {
	            case 0:
	              chkPorcen.current.checked = true;
	              break;
	            case 1:
	              chkMilPorcen.current.checked = true;
	              break;
	            case 2:
	              chkUniTri.current.checked = true;
	              break;
	            case 3:
	              chkMontFij.current.checked = true;
	              break;
	            case 4:
	              chkOtroPor.current.checked = true;
	              setVisibleOtro('visible');
	              txtOtroPorcen.current.value = (0, _varios.formatMoneda)(response.data.otro.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	              break;
	
	          }
	
	          cmbTipo.current.value = response.data.tipo;
	          txtId.current.value = response.data.idtiporetencion;
	
	          seleccionarRegistroBene(response.data.idagente);
	
	          setValues(response.data);
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe un Tipo de Retención con este codigo', icono: 'informacion' });
	          txtDescripcion.current.value = '';
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	    });
	  };
	
	  var validarTipoReten = function validarTipoReten(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === 'undefined') {
	      if (event.target.value !== '') {
	
	        seleccionarRegistroTipReten();
	      } else {
	        chkPorcen.current.checked = false;
	        chkMilPorcen.current.checked = false;
	        chkUniTri.current.checked = false;
	        chkMontFij.current.checked = false;
	        chkOtroPor.current.checked = false;
	        txtDeducible.current.value = '';
	        txtOtroPorcen.current.value = '';
	        setVisibleISLR('hidden');
	        setVisibleOtro('collapse');
	        setTercero({
	          idagente: '',
	          nombre: ''
	        });
	        setValues({
	          idtiporetencion: '',
	          descripcion: '',
	          unidad: '',
	          idcuentacontable: '',
	          tipo: '',
	          deducible: '',
	          otro: '',
	          idagente: ''
	        });
	        txtId.current.value = '';
	      }
	    }
	  };
	
	  var validarBene = function validarBene(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	
	    if (event.which === 13 || typeof event.which === 'undefined') {
	
	      if (event.target.value !== '') {
	
	        seleccionarRegistroBene(event.target.value);
	      } else {
	        setTercero({
	          idagente: '',
	          nombre: ''
	        });
	        txtIdAgente.current.value = '';
	      }
	    }
	  };
	
	  var onCatalogoBene = function onCatalogoBene(values) {
	    setCatalogoBene(false);
	    setTercero(values);
	    txtIdAgente.current.value = values.idagente;
	    if (!botones.modificar) {
	      setBotones(Object.assign({}, botones, { catalogoBene: false }));
	    }
	  };
	  var onCatalogoTipoRetn = function onCatalogoTipoRetn(value) {
	    setCatalogoTipoReten(false);
	    if (parseInt(value.tipo) === 1) {
	      setVisibleISLR('visible');
	      txtDeducible.current.value = (0, _varios.formatMoneda)(value.deducible.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	    }
	
	    switch (parseInt(value.unidad)) {
	      case 0:
	        chkPorcen.current.checked = true;
	        break;
	      case 1:
	        chkMilPorcen.current.checked = true;
	        break;
	      case 2:
	        chkUniTri.current.checked = true;
	        break;
	      case 3:
	        chkMontFij.current.checked = true;
	        break;
	      case 4:
	        chkOtroPor.current.checked = true;
	        setVisibleOtro('visible');
	        txtOtroPorcen.current.value = (0, _varios.formatMoneda)(value.otro.toString().replace(',', '').replace('.', ','), ',', '.', 2);
	        break;
	
	    }
	
	    cmbTipo.current.value = value.tipo;
	    txtId.current.value = value.idtiporetencion;
	    txtIdAgente.current.value = value.idagente;
	
	    setValues({
	      idtiporetencion: value.idtiporetencion,
	      descripcion: value.descripcion.trim(),
	      unidad: value.unidad,
	      idcuentacontable: value.idcuentacontable,
	      tipo: value.tipo,
	      deducible: value.deducible,
	      otro: value.otro,
	      idagente: value.idagente
	    });
	    setTercero({
	      idagente: value.idagente,
	      nombre: value.nombre
	    });
	
	    if (!botones.modificar) {
	      setBotones(Object.assign({}, botones, { catalogoBene: false }));
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	
	    var sigue = true;
	
	    if (!botones.incluir || !botones.modificar) {
	
	      if (visibleISLR === 'visible' && txtDeducible.current.value === '') {
	
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar el Deducible.', icono: 'informacion' });
	        sigue = false;
	        txtDeducible.current.focus();
	      } else if (txtDescripcion.current.value === '') {
	
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar la Descripción.', icono: 'informacion' });
	        sigue = false;
	        txtDescripcion.current.focus();
	      } else if (values.unidad === '') {
	
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar una Unidad de Retención .', icono: 'informacion' });
	        sigue = false;
	        chkPorcen.current.focus();
	      } else if (parseInt(values.unidad) === 4 && txtOtroPorcen.current.value === '') {
	
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Ingresar un Porcentaje.', icono: 'informacion' });
	        sigue = false;
	        txtOtroPorcen.current.focus();
	      } else if (tercero.idagente === '') {
	
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe Seleccionar un Fondo de Terceros.', icono: 'informacion' });
	        sigue = false;
	        txtIdAgente.current.focus();
	      }
	    }
	    if (sigue) {
	
	      var msg = '';
	      if (!botones.incluir) {
	        msg = 'Esta Seguro de Registrar estos Datos.';
	      } else if (!botones.modificar) {
	        msg = 'Esta Seguro de Modificar estos Datos.';
	      } else if (!botones.eliminar) {
	        msg = 'Esta Seguro de Eliminar estos Datos.';
	      }
	
	      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
	    }
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	
	      setOperacion(op);
	      e.preventDefault();
	
	      if (op === 1) {
	
	        if (accbtntipretenciones && accbtntipretenciones.toString().substring(0, 1) === '1') {
	          setVisibleBtn('hidden');
	          setTituloHeader('Incluir Tipo de Retenciones.');
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            catalogoBene: false
	          });
	          txtDescripcion.current.removeAttribute("disabled");
	          txtDescripcion.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 2) {
	
	        if (accbtntipretenciones && accbtntipretenciones.toString().substring(1, 2) === '1') {
	          setTituloHeader('Editar Tipo de Retenciones.');
	          setVisibleBtn('hidden');
	          setHabilitado(false);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoBene: true
	          });
	          txtId.current.removeAttribute("disabled");
	          txtId.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 3) {
	
	        if (accbtntipretenciones && accbtntipretenciones.toString().substring(3, 4) === '1') {
	          setTituloHeader('Eliminar Tipo de Retenciones.');
	          setVisibleBtn('hidden');
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoBene: true
	          });
	          txtId.current.removeAttribute("disabled");
	          txtId.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 4) {
	
	        if (accbtntipretenciones && accbtntipretenciones.toString().substring(2, 3) === '1') {
	          setTituloHeader('Consultar Tipo de Retenciones.');
	          setVisibleBtn('hidden');
	          setHabilitado(true);
	          txtId.current.focus();
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            catalogoBene: true
	          });
	          txtId.current.removeAttribute("disabled");
	          txtId.current.focus();
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        setVisibleBtn('visible');
	        blanquear();
	      }
	    };
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', width: '100%' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'row col-md-12 py-5', style: { margin: 0 } },
	      _react2.default.createElement(
	        'div',
	        { className: 'row col-md-12 py-2', style: { margin: 0 } },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-8 py-3 mx-auto card shadow ' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 row mx-auto  rounded py-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light justify-content-between' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  tituloHeader
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-3 d-flex justify-content-end' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '/inicio', className: 'text-light ' },
	                  _react2.default.createElement('i', { className: 'fas fa-times mx-2' }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'fw-bold' },
	                    'Salir'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row mx-auto border-azul py-3 rounded', style: { fontSizeAdjust: '0.7' } },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm mb-2 col-md-2 col-xl-3 col-lg-4 col-md-4 col-sm-4', style: { visibility: parseInt(operacion) === 1 ? 'hidden' : 'visible' } },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'CODIGO:'
	                ),
	                _react2.default.createElement('input', { type: 'text', name: 'idcuentabancaria', className: 'form-control fs-6', disabled: true, ref: txtId, defaultValue: values.idtiporetencion !== null || values.idtiporetencion !== '' ? values.idtiporetencion.trim() : '', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: validarTipoReten, onBlur: validarTipoReten }),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', disabled: botones.catalogo, onClick: function onClick() {
	                      setCatalogoTipoReten(true);
	                    }, className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm mb-2 col-xl-4 col-lg-4 col-md-6 col-sm-6' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'TIPO DE PLANILLA:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-select text-uppercase', 'aria-label': 'Default select example', name: 'tipo', ref: cmbTipo, id: 'tipo', onChange: onChange, disabled: habilitado },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    ' Seleccione'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '0' },
	                    ' Planilla IVA'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '1' },
	                    '  Planilla ISLR'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: '2' },
	                    '  Planilla 1 X 500'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm mb-2 col-pd-230 ml-auto px-2', style: { visibility: visibleISLR } },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'DEDUCIBLE:'
	                ),
	                _react2.default.createElement('input', { type: 'text', className: 'form-control col-md-10 nx-auto form-control-sm rounded text-right fs-6', ref: txtDeducible, placeholder: '0,00', name: 'deducible', disabled: habilitado, onKeyUp: handleInputMontoChange, onBlur: handleInputMontoChange })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm col-md-12  mb-2' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'DESCRIPCION:'
	                ),
	                _react2.default.createElement('input', { type: 'text', className: 'form-control rounded text-uppercase fs-6', ref: txtDescripcion, disabled: habilitado, value: values.descripcion !== null || values.descripcion !== '' ? values.descripcion : '', name: 'descripcion', onChange: onChange })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 mt-2 px-0' },
	                _react2.default.createElement(
	                  'fieldset',
	                  { className: ' row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between ' },
	                  _react2.default.createElement(
	                    'legend',
	                    { className: 'float-none w-auto fw-bold', style: { fontSize: '15px' } },
	                    'Unidad de Retenci\xF3n'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col d-flex jsutify-content-center mb-2' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-check mx-auto' },
	                      _react2.default.createElement('input', { className: 'form-check-input my-auto', type: 'radio', name: 'unidad', id: 'unidad', ref: chkPorcen, onChange: onChange, value: 0, disabled: habilitado }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'my-auto form-check-label', 'for': 'flexRadioDefault1', style: { fontSize: '13px' } },
	                        'Porcentaje'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col d-flex jsutify-content-center mb-2' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-check mx-auto' },
	                      _react2.default.createElement('input', { className: 'form-check-input my-auto', type: 'radio', name: 'unidad', id: 'unidad', ref: chkMilPorcen, onChange: onChange, value: 1, disabled: habilitado }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'my-auto form-check-label', 'for': 'flexRadioDefault1', style: { fontSize: '13px' } },
	                        'Mil Porciento'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col d-flex jsutify-content-center mb-2' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-check mx-auto' },
	                      _react2.default.createElement('input', { className: 'form-check-input my-auto', type: 'radio', name: 'unidad', id: 'unidad', ref: chkUniTri, onChange: onChange, value: 2, disabled: habilitado }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'my-auto form-check-label', 'for': 'flexRadioDefault1', style: { fontSize: '13px' } },
	                        'Unidad Tributaria'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col d-flex jsutify-content-center mb-2' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-check mx-auto' },
	                      _react2.default.createElement('input', { className: 'form-check-input my-auto', type: 'radio', name: 'unidad', id: 'unidad', ref: chkMontFij, onChange: onChange, value: 3, disabled: habilitado }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'my-auto form-check-label', 'for': 'flexRadioDefault1', style: { fontSize: '13px' } },
	                        'Monto Fijo'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'col d-flex jsutify-content-center mb-2' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'form-check mx-auto' },
	                      _react2.default.createElement('input', { className: 'form-check-input my-auto', type: 'radio', name: 'unidad', id: 'unidad', ref: chkOtroPor, onChange: onChange, value: 4, disabled: habilitado }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'my-auto form-check-label', 'for': 'flexRadioDefault1', style: { fontSize: '13px' } },
	                        'Otro Porcentaje:'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm col-1  d-flex jsutify-content-center mb-2 px-0', style: { visibility: visibleOtro } },
	                    _react2.default.createElement('input', { type: 'text', className: 'form-control fs-6 px-1 text-right', ref: txtOtroPorcen, maxLength: 6, placeholder: '0,00', name: 'otro', disabled: habilitado, onKeyUp: handleInputMontoChange, onBlur: handleInputMontoChange }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'input-group-text px-1', id: 'inputGroup-sizing-sm' },
	                      '%'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 mt-2 px-0' },
	                _react2.default.createElement(
	                  'fieldset',
	                  { className: ' row col-sm-12 mx-auto border-azul rounded d-flex justify-content-between ' },
	                  _react2.default.createElement(
	                    'legend',
	                    { className: 'float-none w-auto fw-bold', style: { fontSize: '15px' } },
	                    'Fondo de Terceros'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group input-group-sm mb-2 col-md-12 col-lg-12' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                      'CODIGO:'
	                    ),
	                    _react2.default.createElement('input', { type: 'text', ref: txtIdAgente, name: 'idcuentabancaria', className: 'form-control col-md-2 fs-6', disabled: habilitado, defaultValue: tercero.idagente !== null || tercero.idagente !== '' ? tercero.idagente : '', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm', onKeyUp: validarBene }),
	                    _react2.default.createElement(
	                      'button',
	                      { type: 'button', disabled: botones.catalogoBene, onClick: function onClick() {
	                          setCatalogoBene(true);
	                        }, className: 'btn btn-success' },
	                      _react2.default.createElement('i', { className: 'fas fa-search' })
	                    ),
	                    _react2.default.createElement('input', { type: 'text', name: 'idcuentabancaria', disabled: true, className: 'form-control fs-6', defaultValue: tercero.nombre !== null || tercero.nombre !== '' ? tercero.nombre.trim() : '', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-12 d-flex justify-content-between mt-3' },
	              visibleBtn === 'visible' ? _react2.default.createElement(
	                'div',
	                { className: 'col-pd-600 d-flex justify-content-start' },
	                _react2.default.createElement(
	                  'button',
	                  { disabled: botones.incluir, onClick: onBotones(1), className: 'btn btn-sm mx-1 btn-primary rounded-pill', title: 'Incluir Almacen' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-plus' },
	                    ' Incluir '
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: botones.consultar, onClick: onBotones(4), className: 'btn btn-sm mx-1 btn-info rounded-pill', title: 'Consultar Almacen' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-eye' },
	                    'Consultar'
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: botones.modificar, onClick: onBotones(2), className: 'btn btn-sm mx-1 btn-warning rounded-pill', title: 'Modificar Almacen' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'fa fa-edit' },
	                    'Modificar'
	                  ),
	                  ' '
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: botones.eliminar, onClick: onBotones(3), className: 'btn btn-sm mx-1 btn-danger rounded-pill', title: 'Eliminar Almacen' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'fa fa-trash' },
	                    'Eliminar'
	                  ),
	                  ' '
	                )
	              ) : _react2.default.createElement(
	                'div',
	                { className: 'col-md-150 d-flex justify-content-end ml-auto' },
	                _react2.default.createElement(
	                  'button',
	                  { ref: btnAcepta, disabled: botones.aceptar, onClick: onBotones(5), className: 'mx-2 btn btn-sm rounded-pill btn-success' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    '  Aceptar'
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { ref: btnCancela, disabled: botones.cancelar, onClick: onBotones(6), className: 'mx-2 btn btn-danger btn-sm rounded-pill' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoBeneficiarios2.default, {
	      show: catalogoBene,
	      onHideCancelar: function onHideCancelar() {
	        setCatalogoBene(false);
	      },
	      onHideAceptaCatalogo: onCatalogoBene
	    }),
	    _react2.default.createElement(_catalogoTipoRetenciones2.default, {
	      show: catalogoTipoReten,
	      onHideCancelar: function onHideCancelar() {
	        setCatalogoTipoReten(false);
	      },
	      onHideAceptaCatalogo: onCatalogoTipoRetn
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        'cargando...'
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	      } }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	      }, onHideSi: handleCloseSi })
	  );
	};
	exports.default = TablaTipoRetenciones;

/***/ },
/* 7136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _varios = __webpack_require__(14);
	
	var _core = __webpack_require__(19);
	
	var _useTableScrollcesar = __webpack_require__(674);
	
	var _useTableScrollcesar2 = _interopRequireDefault(_useTableScrollcesar);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _icons = __webpack_require__(399);
	
	var _mensajes = __webpack_require__(9);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TablaRetencionesPago = function TablaRetencionesPago(props) {
	
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem('jwtToken');
	
	    var headCells = [{ label: 'Código', textAlign: 'center' }, { label: 'Descripción', textAlign: 'center' }, { label: 'Base Imponible', textAlign: 'center' }, { label: 'Alicuota', textAlign: 'center' }, { label: 'Total Retenido', textAlign: 'center' }];
	
	    var _useTableScroll = (0, _useTableScrollcesar2.default)(headCells),
	        TblContainer = _useTableScroll.TblContainer,
	        TblHead = _useTableScroll.TblHead;
	
	    var _useState = (0, _react.useState)(false),
	        _useState2 = _slicedToArray(_useState, 2),
	        mostrar2 = _useState2[0],
	        setMostrar2 = _useState2[1];
	
	    var _useState3 = (0, _react.useState)([]),
	        _useState4 = _slicedToArray(_useState3, 2),
	        records = _useState4[0],
	        setRecords = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        datos = _useState6[0],
	        setDatos = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(0.00),
	        _useState8 = _slicedToArray(_useState7, 2),
	        tasacambio = _useState8[0],
	        setTasacambio = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(false),
	        _useState10 = _slicedToArray(_useState9, 2),
	        activate = _useState10[0],
	        setActivate = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(null),
	        _useState12 = _slicedToArray(_useState11, 2),
	        itemSelect = _useState12[0],
	        setItemSelect = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(0),
	        _useState14 = _slicedToArray(_useState13, 2),
	        opr = _useState14[0],
	        setOpr = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(null),
	        _useState16 = _slicedToArray(_useState15, 2),
	        idope = _useState16[0],
	        setIdope = _useState16[1];
	
	    var _useState17 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState18 = _slicedToArray(_useState17, 2),
	        mensaje = _useState18[0],
	        setMensaje = _useState18[1];
	
	    var _useState19 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState20 = _slicedToArray(_useState19, 2),
	        mensajesino = _useState20[0],
	        setMensajesino = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(true),
	        _useState22 = _slicedToArray(_useState21, 2),
	        activ = _useState22[0],
	        setActiv = _useState22[1];
	
	    var handleCloseSi = function handleCloseSi() {
	        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    };
	
	    (0, _react.useEffect)(function () {
	
	        if (props.idfact > 0) {
	            seleccionarRetenciones(props.idfact);
	        }
	    }, [props.idfact]);
	
	    var seleccionarRetenciones = function seleccionarRetenciones(id) {
	        var endpoint = op.conexion + '/api/retenciones/seleccionarretenciones?idfacturacompra=' + id;
	
	        setActivate(true);
	        _axios2.default.get(endpoint, {
	            headers: {
	                "x-access-token": '' + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                }
	            }
	            setActivate(false);
	        }).catch(function (error) {
	            setActivate(false);
	            setMensaje({
	                mostrar: true,
	                titulo: "Error",
	                texto: error.response.data.message,
	                icono: "error"
	            });
	        });
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: '' },
	        _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	            onHide: function onHide() {
	                return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	            } }),
	        _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	            onHideNo: function onHideNo() {
	                return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	            }, onHideSi: handleCloseSi }),
	        _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 row m-0 px-0' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 px-0' },
	                _react2.default.createElement(
	                    TblContainer,
	                    { container: { height: 180, width: '100%', overflow: 'auto', padding: '2px', fontSizeAdjust: '0.6' } },
	                    _react2.default.createElement(TblHead, null),
	                    _react2.default.createElement(
	                        _core.TableBody,
	                        { className: 'overflow-hidden table-bordered' },
	                        records && records.map(function (item, index) {
	                            return _react2.default.createElement(
	                                _core.TableRow,
	                                { key: index, style: { padding: "0" } },
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'align-baseBar bg-light', style: { textAlign: "center", width: '80px' } },
	                                    item.codigo
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'align-baseline bg-light', style: { textAlign: "center", width: '80px' } },
	                                    item.descripcion
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'align-baseline bg-light', style: { textAlign: "right", width: '50px' } },
	                                    props.val === 0 ? (0, _varios.formatMoneda)(item.baseimponible.toString().replace('.', ','), ',', '.', 2) : (0, _varios.formatMoneda)((0, _varios.round)(item.baseimponible * props.tasa, 2).toString().replace('.', ','), ',', '.', 2)
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'align-baseline bg-light', style: { textAlign: "right", width: '50px' } },
	                                    (0, _varios.formatMoneda)(item.alicuota.toString().replace('.', ','), ',', '.', 2) + " %"
	                                ),
	                                _react2.default.createElement(
	                                    _core.TableCell,
	                                    { className: 'align-baseline bg-light', style: { textAlign: "right", width: '50px' } },
	                                    props.val === 0 ? (0, _varios.formatMoneda)(item.total.toString().replace('.', ','), ',', '.', 2) : (0, _varios.formatMoneda)((0, _varios.round)(item.total * props.tasa, 2).toString().replace('.', ','), ',', '.', 2)
	                                )
	                            );
	                        })
	                    )
	                )
	            )
	        )
	    );
	};
	exports.default = TablaRetencionesPago;

/***/ },
/* 7137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _core = __webpack_require__(19);
	
	var _modalIncluirRetencion = __webpack_require__(7123);
	
	var _cryptoJs = __webpack_require__(6689);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var TablaRetencionesporCobrar = function TablaRetencionesporCobrar(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var anioActu = JSON.parse(sessionStorage.getItem("anioactu"));
	  var idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var accbtncntxcobrar = JSON.parse(sessionStorage.getItem("accbtncntxcobrarc"));
	  var cmbCedula = ["J", "V", "G", "P"];
	  var headCells = [{ label: "CODIGO", textAlign: "center", width: "50px" }, { label: "DESCRIPCION", textAlign: "center", width: "200px" }, { label: "BASE IMPONIBLE", textAlign: "center", width: "80px" }, { label: "ALICUOTA", textAlign: "center", width: "80px" }, { label: "TOTAL RETENIDO", textAlign: "center", width: "80px" }, { label: "---", textAlign: "center", width: "50px" }];
	
	  var txtCliente = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtDevuelto = (0, _react.useRef)([]);
	  var txtCantidad = (0, _react.useRef)([]);
	  var txtPendientes = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtNotaEntrega = (0, _react.useRef)();
	  var txtMonto = (0, _react.useRef)();
	  var txtIva = (0, _react.useRef)();
	  var txtTMonto = (0, _react.useRef)();
	  var txtTIva = (0, _react.useRef)();
	  var txtTotalRetenido = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      mostrar = _useState2[0],
	      setMostrar = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(""),
	      _useState4 = _slicedToArray(_useState3, 2),
	      valnota = _useState4[0],
	      setValnota = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      records = _useState6[0],
	      setRecords = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      activate = _useState8[0],
	      setActivate = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      body = _useState10[0],
	      setBody = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mensaje = _useState12[0],
	      setMensaje = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensajesino = _useState14[0],
	      setMensajesino = _useState14[1];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var blanquear = function blanquear() {
	    setMostrar(false);
	    setRecords([]);
	    txtRif.current.value = "";
	    cmbRif.current.value = "";
	    txtMonto.current.value = "";
	    txtNotaEntrega.current.value = "";
	    txtCliente.current.value = "";
	    txtTIva.current.value = "";
	    txtTMonto.current.value = "";
	    txtTMonto.current.value = "";
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    props.onHideCancelar();
	    props.onRenderizar();
	  };
	
	  var seleccionarCliente = function seleccionarCliente(id) {
	    var campos = "rif, trim(nombre) as nombre, idagente";
	    var nomtab = "agente";
	    var nomid = "idagente";
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idagente > 0) {
	          cmbRif.current.value = response.data.rif.substring(0, 1);
	          txtRif.current.value = response.data.rif.substring(1, 12);
	          txtCliente.current.value = response.data.nombre;
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Cliente no existe.",
	            icono: "informacion"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var eliminarRetencion = function eliminarRetencion(n) {
	    return function (e) {
	      e.preventDefault();
	      var data = [].concat(_toConsumableArray(records));
	      var elementos = [];
	      var totales = 0.0;
	
	      for (var i = 0; i < data.length; i++) {
	        if (n.codigo !== data[i].codigo) {
	          elementos.push(data[i]);
	          totales = parseFloat(totales) + parseFloat(data[i].total);
	        }
	      }
	
	      txtTotalRetenido.current.value = (0, _varios.formatMoneda)(totales.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	      setRecords(elementos);
	    };
	  };
	
	  var onCatalogoRetenciones = function onCatalogoRetenciones(values) {
	    setMostrar(false);
	
	    var data = [].concat(_toConsumableArray(records));
	    var datos = [];
	    var totalr = 0.00;
	    var totales = 0.00;
	    var recto = 0.00;
	
	    for (var e = 0; e < values.length; e++) {
	      totalr = parseFloat(totalr) + parseFloat((0, _varios.round)(values[e].total, 2));
	    }
	
	    for (var i = 0; i < data.length; i++) {
	
	      if (parseInt(records[i].codigo) === parseInt(values[0].codigo)) {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Este Tipo de Retención ya fue Seleccionada !",
	          icono: "informacion"
	        });
	        return;
	      }
	
	      datos.push({
	        alicuota: data[i].alicuota,
	        baseimponible: data[i].baseimponible,
	        codigo: data[i].codigo,
	        descripcion: data[i].descripcion,
	        fecha: data[i].fecha,
	        iva: data[i].iva,
	        montoiva: data[i].montoiva,
	        total: data[i].total,
	        totalf: data[i].totalf,
	        unidad: data[i].unidad
	      });
	
	      if (data[i].total > 0) {
	        recto = parseFloat(recto) + parseFloat(data[i].total);
	      }
	    }
	
	    datos.push({
	      alicuota: values[0].alicuota,
	      baseimponible: values[0].baseimponible,
	      codigo: values[0].codigo,
	      descripcion: values[0].descripcion,
	      fecha: values[0].fecha,
	      iva: values[0].iva,
	      montoiva: values[0].montoiva,
	      total: values[0].total,
	      totalf: values[0].totalf,
	      unidad: values[0].unidad
	    });
	
	    txtFecha.current.value = (0, _moment2.default)(values[0].fecha).format('DD/MM/YYYY');
	
	    totales = recto > 0 ? recto + totalr : totalr;
	    txtTotalRetenido.current.value = (0, _varios.formatMoneda)(totales.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    setRecords(datos);
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope === 10) {
	      if (records.length > 0) {
	        sigue = true;
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Error de Transacción !",
	          icono: "informacion"
	        });
	        sigue = false;
	      }
	
	      if (sigue === true) {
	        var data = [];
	
	        for (var i = 0; i < records.length; i++) {
	
	          data.push({
	            fecha: records[i].fecha,
	            monto: (0, _varios.round)(records[i].total, 2),
	            formapago: 10,
	            referencia: "",
	            tipodivisa: 0,
	            simbolo: "$",
	            notacredito: "",
	            idbanco: "",
	            valormoneda: 0,
	            descripcion: "Retención (" + records[i].descripcion + ")",
	            codigo: records[i].codigo,
	            porc: records[i].alicuota
	          });
	        }
	
	        if (data.length > 0) {
	          props.onHideAceptaData(data);
	          props.onHideCancelar();
	          blanquear();
	        }
	      }
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      size: "xl",
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        if (props.ope === 10) {
	
	          seleccionarCliente(props.idclient);
	          var numfactu = props.numfact.substring(0, 2);
	          setValnota(numfactu);
	          txtNotaEntrega.current.value = props.numfact;
	          txtMonto.current.value = (0, _varios.formatMoneda)(props.montonota.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtIva.current.value = (0, _varios.formatMoneda)(props.montoiva.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtTMonto.current.value = (0, _varios.formatMoneda)(props.montonota.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtTIva.current.value = (0, _varios.formatMoneda)(props.montoiva.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Gestionar Retenciones"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { style: { height: "100%", width: "100%" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row col-md-12", style: { margin: 0 } },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row border-azul mx-auto rounded py-1" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-pd-350" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 px-1" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  valnota === "NE" ? "N° NOTA DE ENTREGA:" : "N° NOTA DE DEBITO:"
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  className: "form-control fs-6",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  ref: txtNotaEntrega
	                })
	              )
	            ),
	            _react2.default.createElement("input", { type: "hidden", ref: txtFecha }),
	            _react2.default.createElement(
	              "div",
	              { className: "col-pd-350 mx-auto" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 px-1" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  valnota === "NE" ? "MONTO (NOTA DE ENTREGA):" : "MONTO (NOTA DE DEBITO):"
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  className: "form-control fs-6 text-right",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  ref: txtMonto
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-pd-220" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 px-1" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "MONTO IVA:"
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  className: "form-control fs-6 text-right",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  ref: txtIva
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-12 mx-auto mb-1 ",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row border-azul rounded py-2" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold mb-1" },
	                  "Datos del Cliente"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-3 px-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: cmbRif,
	                      name: "cmbrif",
	                      disabled: true,
	                      className: "form-select form-select-sm col-md-3 text-center",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "--"
	                    ),
	                    cmbCedula && cmbCedula.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item },
	                        item
	                      );
	                    })
	                  ),
	                  _react2.default.createElement("input", {
	                    ref: txtRif,
	                    autoComplete: "off",
	                    disabled: true,
	                    maxLength: 12,
	                    type: "text",
	                    className: "form-control fs-6 px-1",
	                    name: "cedula",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-9 px-0" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "NOMBRE:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    ref: txtCliente
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-pd-957 border-azul px-0 rounded",
	                style: { backgroundColor: "#d5e9ff" }
	              },
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 190,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px",
	                    fontSizeAdjust: "0.6"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden" },
	                  records && records.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      { key: index, style: { padding: "0" } },
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-center p-0" },
	                        item.codigo
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light p-0 pl-2",
	                          style: { width: "200px" }
	                        },
	                        item.descripcion
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-right p-0",
	                          style: { width: "80px" }
	                        },
	                        (0, _varios.formatMoneda)(item.baseimponible.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "80px" }
	                        },
	                        (0, _varios.formatMoneda)(item.alicuota.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "80px" }
	                        },
	                        (0, _varios.formatMoneda)(item.total.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light",
	                          style: {
	                            textAlign: "center",
	                            alignItems: "center",
	                            width: "50px"
	                          }
	                        },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            className: "btn btn-sm mx-1 btn-danger rounded",
	                            onClick: eliminarRetencion(item)
	                          },
	                          _react2.default.createElement("i", { className: "fa fa-trash" })
	                        )
	                      )
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-pd-120 border-azul px-0 rounded ml-auto border-4" },
	              _react2.default.createElement("div", { className: "col-pd-100 h-50p" }),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-100 mx-auto mb-2 px-1" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    onClick: function onClick() {
	                      setMostrar(true);
	                    },
	                    className: "btn btn-sm btn-primary rounded h-40p"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-plus" },
	                    " INCLUIR"
	                  ),
	                  " "
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4 border-azul px-0 rounded ml-auto border-4" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm col px-0 ml-auto m-0" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text bg-transparent border-0 fw-bold col-4 text-right",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "TOTAL NOTA:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  className: "form-control fs-5 h-100 text-right",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  ref: txtTMonto
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm col px-0 ml-auto m-0" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text bg-transparent border-0 fw-bold col-4 text-right",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "TOTAL IVA:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  className: "form-control fs-5 h-100 text-right",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  ref: txtTIva
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm col px-0 ml-auto m-0" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text bg-transparent border-0 fw-bold col-4 text-right",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "TOTAL RETENIDO:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  className: "form-control fs-5 h-100 text-right",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  placeholder: "0,00",
	                  ref: txtTotalRetenido
	                })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          className: "btn btn-sm btn-success rounded-pill",
	          onClick: onChangeValidar,
	          ref: btnAcepta,
	          style: { margin: "5px" }
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Procesar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    ),
	    _react2.default.createElement(_modalIncluirRetencion.ModalIncluirRetencion, {
	      show: mostrar,
	      monto: props.montonota,
	      montiva: props.montoiva,
	      iva: props.ivas,
	      operacion: 1,
	      data: records,
	      valiva: valnota,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar(false);
	      },
	      onHideAceptaCatalogo: onCatalogoRetenciones
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "Cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({
	          mostrar: false,
	          titulo: "",
	          texto: "",
	          icono: ""
	        });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = TablaRetencionesporCobrar;

/***/ },
/* 7138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _auth = __webpack_require__(106);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Footers() {
	  var _useContext = (0, _react.useContext)(_auth.AuthContext),
	      user = _useContext.user;
	
	  var fechaSistema = sessionStorage.getItem("fechasistema");
	
	  var footers = user && _react2.default.createElement(
	    "footer",
	    { className: "h-10 m-0 text-center amanecerfooter p-2", id: "gg" },
	    _react2.default.createElement(
	      "strong",
	      null,
	      "Copyright \xA9 ",
	      (0, _moment2.default)(fechaSistema).format("YYYY"),
	      " ",
	      _react2.default.createElement(
	        "a",
	        {
	          className: "bluez-text",
	          href: "http://www.opensiap.com.ve",
	          target: "_blank"
	        },
	        "SYGRECA."
	      ),
	      "Todos los Derechos Reservados."
	    )
	  );
	
	  return footers;
	}
	
	exports.default = Footers;

/***/ },
/* 7139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GestionGerencial = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _reactRouterDom = __webpack_require__(155);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GestionGerencial = exports.GestionGerencial = function GestionGerencial() {
	
	  var location = (0, _reactRouterDom.useLocation)();
	  var searchParams = new URLSearchParams(location.search);
	  var modalValue = searchParams.get("modal");
	
	  var _useState = (0, _react.useState)(true),
	      _useState2 = _slicedToArray(_useState, 2),
	      activate = _useState2[0],
	      setActivate = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(""),
	      _useState4 = _slicedToArray(_useState3, 2),
	      ruta = _useState4[0],
	      setRuta = _useState4[1];
	
	  var actualizarRuta = function actualizarRuta() {
	    var op = __webpack_require__(8);
	    var url = op.iframe;
	    var token = sessionStorage.getItem("jwtToken");
	    var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	    if (modalValue) {
	      if (modalValue === "cliente") {
	        setRuta(url + "/cliente/" + token + "/" + afiliado);
	      } else if (modalValue === "vendedor") {
	        setRuta(url + "/vendedor/" + token + "/" + afiliado);
	      } else if (modalValue === "grafica") {
	        setRuta(url + "/graficos/" + token + "/" + afiliado);
	      } else if (modalValue === "mapaCliente") {
	        setRuta(url + "/mapaCliente/" + token + "/" + afiliado);
	      } else if (modalValue === "mapaAlmacen") {
	        setRuta(url + "/mapaAlmacen/" + token + "/" + afiliado);
	      }
	    }
	  };
	  var handleIframeLoad = function handleIframeLoad() {
	    setActivate(false);
	  };
	  (0, _react.useEffect)(function () {
	    setActivate(true);
	    actualizarRuta();
	  }, []);
	  return _react2.default.createElement(
	    "div",
	    { className: "w-100 h-100" },
	    ruta && ruta !== "" ? _react2.default.createElement("iframe", {
	      src: ruta,
	      width: "100%",
	      onLoad: handleIframeLoad,
	      style: { border: "1px solid #ccc", height: "calc(100vh - 98px)" }
	    }) : _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    )
	  );
	};

/***/ },
/* 7140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _auth = __webpack_require__(106);
	
	var _reactRouterDom = __webpack_require__(155);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _modalCambiarClave = __webpack_require__(299);
	
	var _mensajes = __webpack_require__(9);
	
	var _varios = __webpack_require__(14);
	
	var _useBcv2 = __webpack_require__(676);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Header(props) {
	  _moment2.default.locale("es");
	  var token = sessionStorage.getItem("jwtToken");
	  var op = __webpack_require__(8);
	
	  var _useContext = (0, _react.useContext)(_auth.AuthContext),
	      user = _useContext.user;
	
	  var fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var usuario = JSON.parse(sessionStorage.getItem("login"));
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      mostrar = _useState4[0],
	      setMostrar = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      activate = _useState6[0],
	      setActivate = _useState6[1];
	
	  var _useBcv = (0, _useBcv2.useBcv)(),
	      moneda = _useBcv.moneda;
	
	  var el = void 0;
	  function menuclick() {
	    props.onCambiar("inicio");
	    if (el = document.getElementById("wrapper")) {
	      el.classList.toggle("toggled");
	    }
	  }
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	    var nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	    var orden = "m.idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    //setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].subpredeterminada) {
	              //       setMoneda(response.data[i]);
	            }
	          }
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      //  setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarRegistros();
	  }, []);
	
	  var header = user && _react2.default.createElement(
	    "nav",
	    {
	      className: "h-10 m-0 col-md-12 navbar navbar-expand-lg navbar-light azulGradiant py-2 px-2 d-flex justify-content-between",
	      id: "one"
	    },
	    props.path === "inicio" ? _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "mx-2 d-none d-xl-block" },
	        _react2.default.createElement("i", {
	          className: "fas fa-align-left  text-light fs-4",
	          onClick: menuclick,
	          id: "menu-toggle"
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-1  d-block d-xl-none" },
	        _react2.default.createElement("i", {
	          className: "fas fa-align-left  text-light fs-4",
	          onClick: menuclick,
	          id: "menu-toggle"
	        })
	      )
	    ) : _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "mx-2 d-none d-xl-block" },
	        _react2.default.createElement(
	          _reactRouterDom.Link,
	          { to: "/inicio" },
	          _react2.default.createElement(
	            "button",
	            {
	              onClick: menuclick,
	              className: "btn btn-xs btn-danger p-2 rounded-pill",
	              style: { fontWeight: "bold" }
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "far fa-arrow-alt-circle-left" },
	              " Volver"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-1 d-block d-xl-none" },
	        _react2.default.createElement(
	          _reactRouterDom.Link,
	          { to: "/inicio" },
	          _react2.default.createElement(
	            "button",
	            {
	              onClick: menuclick,
	              className: "btn btn-xs btn-danger p-2 rounded-pill",
	              style: { fontWeight: "bold" }
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "far fa-arrow-alt-circle-left" },
	              " Volver"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "col d-none d-xl-block m-0 px-0" },
	      _react2.default.createElement(
	        "label",
	        { className: "titulo-header" },
	        props.titulo
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "col-4 d-flex justify-content-end " },
	      _react2.default.createElement(
	        "label",
	        { className: "text-warning fw-bold d-none d-xl-block mx-3" },
	        moneda.simbolo + " " + (0, _varios.formatMoneda)(moneda.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	      ),
	      _react2.default.createElement(
	        "label",
	        { className: "text-light fw-bold d-none d-xl-block" },
	        _react2.default.createElement("i", { className: "fas fa-calendar-alt me-2" }),
	        (0, _moment2.default)(fechaSistema).format("L")
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "dropdown " },
	        _react2.default.createElement(
	          "a",
	          {
	            className: " dropdown-toggle text-light fw-bold mx-4",
	            type: "button",
	            id: "dropdownMenuButton",
	            "data-mdb-toggle": "dropdown",
	            "aria-expanded": "false"
	          },
	          _react2.default.createElement("i", { className: "fas fa-user me-2" }),
	          usuario
	        ),
	        _react2.default.createElement(
	          "ul",
	          {
	            className: "dropdown-menu sombras ",
	            "aria-labelledby": "dropdownMenuButton"
	          },
	          _react2.default.createElement(
	            "li",
	            {
	              onClick: function onClick() {
	                setMostrar(true);
	              }
	            },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: "#", className: "dropdown-item ripple bg-light" },
	              _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement("i", { className: "fas fa-key fa-fw me-1" }),
	                "Cambiar Clave"
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_modalCambiarClave.CambiarClave, {
	      usuario: usuario ? usuario : "",
	      show: mostrar,
	      onHide: function onHide() {
	        setMostrar(false);
	      }
	    }),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    )
	  );
	
	  return header;
	}
	
	exports.default = Header;

/***/ },
/* 7141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VerConfiguracion = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _gestionDeMonedas = __webpack_require__(7085);
	
	var _gestionDeMonedas2 = _interopRequireDefault(_gestionDeMonedas);
	
	var _tablaUsuriosApp = __webpack_require__(668);
	
	var _tablaUsuriosApp2 = _interopRequireDefault(_tablaUsuriosApp);
	
	var _tablaUsurios = __webpack_require__(667);
	
	var _tablaUsurios2 = _interopRequireDefault(_tablaUsurios);
	
	var _tablaOrganizacion = __webpack_require__(7099);
	
	var _tablaOrganizacion2 = _interopRequireDefault(_tablaOrganizacion);
	
	var _tablaPersonas = __webpack_require__(7100);
	
	var _tablaPersonas2 = _interopRequireDefault(_tablaPersonas);
	
	var _generarBackup = __webpack_require__(663);
	
	var _generarBackup2 = _interopRequireDefault(_generarBackup);
	
	var _tablaMonedas = __webpack_require__(7098);
	
	var _tablaMonedas2 = _interopRequireDefault(_tablaMonedas);
	
	var _tablaAfiliados = __webpack_require__(666);
	
	var _tablaAfiliados2 = _interopRequireDefault(_tablaAfiliados);
	
	var _tablaAjuste = __webpack_require__(7096);
	
	var _tablaAjuste2 = _interopRequireDefault(_tablaAjuste);
	
	var _reportesConfig = __webpack_require__(7095);
	
	var _reportesConfig2 = _interopRequireDefault(_reportesConfig);
	
	var _auditoria = __webpack_require__(7080);
	
	var _auditoria2 = _interopRequireDefault(_auditoria);
	
	var _varios = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VerConfiguracion = exports.VerConfiguracion = function VerConfiguracion(props) {
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      mostrar = _useState2[0],
	      setMostrar = _useState2[1];
	
	  var _useState3 = (0, _react.useState)("d-flex bluex-bg"),
	      _useState4 = _slicedToArray(_useState3, 2),
	      clase = _useState4[0],
	      setClase = _useState4[1];
	
	  var accconfiggene = JSON.parse(sessionStorage.getItem("accconfiggene"));
	
	  var _useState5 = (0, _react.useState)("Gestionar Organización"),
	      _useState6 = _slicedToArray(_useState5, 2),
	      msg1 = _useState6[0],
	      setMsg1 = _useState6[1];
	  /* la Auditoria solo la pueden ver los usuarios autorizados (ver varios.js) */
	
	
	  var puedeAuditoria = (0, _varios.usuarioAuditoria)();
	
	  var mostrarHomologacion = function mostrarHomologacion() {
	    window.open("https://www.athos.com.ve/api/imagen?img=solicitud_athos.pdf", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  var mostrarManual = function mostrarManual() {
	    window.open("/pdf/Manual_Usuario_Atho_ERP.pdf", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  var mostrarVis = function mostrarVis(vista) {
	    return function (e) {
	      e.preventDefault();
	      setMostrar(vista);
	    };
	  };
	
	  var cancelar = function cancelar() {
	    setMostrar("");
	    setClase("d-flex bluex-bg");
	    props.onHideCancela();
	  };
	
	  var menuclick = function menuclick(titulo) {
	    return function (e) {
	      e.preventDefault();
	      setMsg1(titulo);
	      if (clase === "d-flex bluex-bg") {
	        setClase("d-flex bluex-bg toggled");
	      } else {
	        setClase("d-flex bluex-bg");
	      }
	    };
	  };
	
	  var VISTA = Object.assign({
	    0: "",
	    1: _react2.default.createElement(_tablaOrganizacion2.default, null),
	    2: _react2.default.createElement(_tablaPersonas2.default, null),
	    3: _react2.default.createElement(_tablaUsurios2.default, { menu: "organizacion" }),
	    4: _react2.default.createElement(_tablaUsuriosApp2.default, { menu: "organizacion" }),
	    5: _react2.default.createElement(_tablaMonedas2.default, null),
	    6: _react2.default.createElement(_gestionDeMonedas2.default, null),
	    7: _react2.default.createElement(_generarBackup2.default, { menu: "organizacion" }),
	    8: _react2.default.createElement(_tablaAjuste2.default, null),
	    10: _react2.default.createElement(_reportesConfig2.default, null)
	  }, puedeAuditoria && { 11: _react2.default.createElement(_auditoria2.default, null) });
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "xl",
	      dialogClassName: "modal-config-general",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      backdrop: "static",
	      keyboard: false
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Configuraci\xF3n General"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { className: "conf-modal-body", style: { padding: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: clase + " conf-modal", id: "wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "amanecergris", id: "sidebar-wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "list-group list-group-flush " },
	            _react2.default.createElement(
	              "div",
	              { className: "list-group list-group-flush" },
	              _react2.default.createElement(
	                "ul",
	                { className: "list-group list-group-light" },
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "list-group-item bg-transparent px-0 p-0 btn-primary",
	                    onClick: menuclick("Gestionar Organización")
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      style: {
	                        pointerEvents: accconfiggene && accconfiggene.substring(0, 1) === "0" ? "none" : "cursor",
	                        color: accconfiggene && accconfiggene.substring(0, 1) === "0" ? "rgb(183, 183, 183)" : "#1d0345",
	                        backgroundColor: accconfiggene && accconfiggene.substring(0, 1) === "0" ? "rgba(144, 143, 142, 0.76)" : "transparent"
	                      },
	                      className: "list-group-item list-group-item-action py-3 ripple px-1",
	                      type: "button",
	                      onClick: mostrarVis(1)
	                    },
	                    _react2.default.createElement("i", { className: "  fas fa-sitemap fa-fw me-3 px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: " fw-bold" },
	                      "Organizacion"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "list-group-item bg-transparent px-0 p-0 btn-primary",
	                    onClick: menuclick("Gestionar Ajustes")
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      style: {
	                        pointerEvents: accconfiggene && accconfiggene.substring(6, 7) === "0" ? "none" : "cursor",
	                        color: accconfiggene && accconfiggene.substring(6, 7) === "0" ? "rgb(183, 183, 183)" : "#1d0345",
	                        backgroundColor: accconfiggene && accconfiggene.substring(6, 7) === "0" ? "rgba(144, 143, 142, 0.76)" : "transparent"
	                      },
	                      className: "list-group-item list-group-item-action py-3 ripple px-1",
	                      type: "button",
	                      onClick: mostrarVis(8)
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-wrench fa-fw me-3 px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "fw-bold" },
	                      "Ajustes"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "list-group-item bg-transparent px-0 p-0 btn-primary",
	                    onClick: menuclick("Gestionar Personas")
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      style: {
	                        pointerEvents: accconfiggene && accconfiggene.substring(1, 2) === "0" ? "none" : "cursor",
	                        color: accconfiggene && accconfiggene.substring(1, 2) === "0" ? "rgb(183, 183, 183)" : "#1d0345",
	                        backgroundColor: accconfiggene && accconfiggene.substring(1, 2) === "0" ? "rgba(144, 143, 142, 0.76)" : "transparent"
	                      },
	                      className: "list-group-item list-group-item-action py-3 ripple px-1",
	                      type: "button",
	                      onClick: mostrarVis(2)
	                    },
	                    _react2.default.createElement("i", { className: "  fas fa-user-alt fa-fw me-3  px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: " fw-bold" },
	                      "Personas"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "list-group-item bg-transparent px-0 p-0 btn-primary",
	                    onClick: menuclick("Gestionar Usuarios")
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      style: {
	                        pointerEvents: accconfiggene && accconfiggene.substring(2, 3) === "0" ? "none" : "cursor",
	                        color: accconfiggene && accconfiggene.substring(2, 3) === "0" ? "rgb(183, 183, 183)" : "#1d0345",
	                        backgroundColor: accconfiggene && accconfiggene.substring(2, 3) === "0" ? "rgba(144, 143, 142, 0.76)" : "transparent"
	                      },
	                      className: "list-group-item list-group-item-action py-3 ripple px-1",
	                      type: "button",
	                      onClick: mostrarVis(3)
	                    },
	                    _react2.default.createElement("i", { className: "  fas fa-user-check fa-fw me-3  px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: " fw-bold" },
	                      "Usuarios"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "list-group-item bg-transparent px-0 p-0 btn-primary",
	                    onClick: menuclick("Gestionar Usuarios App")
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      style: {
	                        pointerEvents: accconfiggene && accconfiggene.substring(5, 6) === "0" ? "none" : "cursor",
	                        color: accconfiggene && accconfiggene.substring(5, 6) === "0" ? "rgb(183, 183, 183)" : "#1d0345",
	                        backgroundColor: accconfiggene && accconfiggene.substring(5, 6) === "0" ? "rgba(144, 143, 142, 0.76)" : "transparent"
	                      },
	                      className: "list-group-item list-group-item-action py-3 ripple px-1",
	                      type: "button",
	                      onClick: mostrarVis(4)
	                    },
	                    _react2.default.createElement("i", { className: "  fas fa-user-check fa-fw me-3  px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: " fw-bold" },
	                      "Usuarios App"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "list-group-item bg-transparent px-0 p-0 btn-primary",
	                    onClick: menuclick("Gestionar Monedas")
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      style: {
	                        pointerEvents: accconfiggene && accconfiggene.substring(3, 4) === "0" ? "none" : "cursor",
	                        color: accconfiggene && accconfiggene.substring(3, 4) === "0" ? "rgb(183, 183, 183)" : "#1d0345",
	                        backgroundColor: accconfiggene && accconfiggene.substring(3, 4) === "0" ? "rgba(144, 143, 142, 0.76)" : "transparent"
	                      },
	                      className: "list-group-item list-group-item-action py-3 ripple px-1",
	                      type: "button",
	                      onClick: mostrarVis(5)
	                    },
	                    _react2.default.createElement("i", { className: "  fas fa-money-bill fa-fw me-3 px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: " fw-bold" },
	                      "Monedas"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "list-group-item bg-transparent px-0 p-0 btn-primary",
	                    onClick: menuclick("Gestionar Tasas de Cambio")
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      style: {
	                        pointerEvents: accconfiggene && accconfiggene.substring(3, 4) === "0" ? "none" : "cursor",
	                        color: accconfiggene && accconfiggene.substring(3, 4) === "0" ? "rgb(183, 183, 183)" : "#1d0345",
	                        backgroundColor: accconfiggene && accconfiggene.substring(3, 4) === "0" ? "rgba(144, 143, 142, 0.76)" : "transparent"
	                      },
	                      className: "list-group-item list-group-item-action py-3 ripple px-1",
	                      type: "button",
	                      onClick: mostrarVis(6)
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-chart-line fa-fw me-3 px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: " fw-bold" },
	                      "Tasa de Cambio"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "list-group-item bg-transparent px-0 p-0 btn-primary",
	                    onClick: menuclick("Generar Respaldo")
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      style: {
	                        pointerEvents: accconfiggene && accconfiggene.substring(4, 5) === "0" ? "none" : "cursor",
	                        color: accconfiggene && accconfiggene.substring(4, 5) === "0" ? "rgb(183, 183, 183)" : "#1d0345",
	                        backgroundColor: accconfiggene && accconfiggene.substring(4, 5) === "0" ? "rgba(144, 143, 142, 0.76)" : "transparent"
	                      },
	                      className: "list-group-item list-group-item-action py-3 ripple px-1",
	                      type: "button",
	                      onClick: mostrarVis(7)
	                    },
	                    _react2.default.createElement("i", { className: "  fas fa-database fa-fw me-3 px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "fw-bold" },
	                      "Respaldar"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "list-group-item bg-transparent px-0 p-0 btn-primary",
	                    onClick: menuclick("Impresion de Reportes")
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      style: {
	                        pointerEvents: accconfiggene && accconfiggene.substring(4, 5) === "0" ? "none" : "cursor",
	                        color: accconfiggene && accconfiggene.substring(4, 5) === "0" ? "rgb(183, 183, 183)" : "#1d0345",
	                        backgroundColor: accconfiggene && accconfiggene.substring(4, 5) === "0" ? "rgba(144, 143, 142, 0.76)" : "transparent"
	                      },
	                      className: "list-group-item list-group-item-action py-3 ripple px-1",
	                      type: "button",
	                      onClick: mostrarVis(10)
	                    },
	                    _react2.default.createElement("i", { className: "  fas fa-database fa-fw me-3 px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "fw-bold" },
	                      "Impresion de Reportes"
	                    )
	                  )
	                ),
	                puedeAuditoria && _react2.default.createElement(
	                  "li",
	                  {
	                    className: "list-group-item bg-transparent px-0 p-0 btn-primary",
	                    onClick: menuclick("Gestionar Auditoría")
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      style: {
	                        pointerEvents: "cursor",
	                        color: "#1d0345",
	                        backgroundColor: "transparent"
	                      },
	                      className: "list-group-item list-group-item-action py-3 ripple px-1",
	                      type: "button",
	                      onClick: mostrarVis(11)
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-history fa-fw me-3 px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "fw-bold" },
	                      "Auditor\xEDa"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "list-group-item bg-transparent px-0 p-0 btn-primary" },
	                  _react2.default.createElement(
	                    "btn",
	                    {
	                      style: {
	                        pointerEvents: "cursor",
	                        color: "#1d0345",
	                        backgroundColor: "transparent"
	                      },
	                      className: "list-group-item list-group-item-action py-3 ripple px-1",
	                      type: "button",
	                      onClick: mostrarHomologacion
	                    },
	                    _react2.default.createElement("i", { className: "  fas fa-file fa-fw me-3 px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "fw-bold" },
	                      "Homologaci\xF3n Seniat"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "list-group-item bg-transparent px-0 p-0 btn-primary" },
	                  _react2.default.createElement(
	                    "btn",
	                    {
	                      style: {
	                        pointerEvents: "cursor",
	                        color: "#1d0345",
	                        backgroundColor: "transparent"
	                      },
	                      className: "list-group-item list-group-item-action py-3 ripple px-1",
	                      type: "button",
	                      onClick: mostrarManual
	                    },
	                    _react2.default.createElement("i", { className: "  fas fa-file fa-fw me-3 px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "fw-bold" },
	                      "Manual de Usuario"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement("div", {
	          className: "conf-modal-overlay",
	          onClick: menuclick(msg1),
	          "aria-hidden": "true"
	        }),
	        _react2.default.createElement(
	          "div",
	          { id: "page-content-wrapper" },
	          _react2.default.createElement(
	            "nav",
	            {
	              className: "navbar navbar-expand-lg navbar-light py-2 px-2",
	              id: "one",
	              style: { background: "none" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "d-flex align-items-center" },
	              _react2.default.createElement("i", {
	                className: "fas fa-align-left  text-dark fs-4 me-3",
	                onClick: menuclick(msg1),
	                id: "menu-toggle"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "collapse navbar-collapse dropstart",
	                id: "navbarSupportedContent"
	              },
	              _react2.default.createElement(
	                "ul",
	                { className: "navbar-nav mx-auto text-center" },
	                _react2.default.createElement(
	                  "h4",
	                  { className: "fs-4" },
	                  msg1 === "Valor Petro" ? _react2.default.createElement("i", { className: "fas fa-lg fa-lg px-2 fa-ruble-sign" }) : msg1 === "Valor UTE" ? _react2.default.createElement("i", { className: "  fas fa-chart-line fa-lg px-2 " }) : msg1 === "Gestion de Usuario Web" ? _react2.default.createElement("i", { className: "  fas fa-users-cog fa-lg px-2" }) : msg1 === "Estructura Organizativa" ? _react2.default.createElement("i", { className: "  fas fa-user-tie fa-lg px-2" }) : "",
	                  msg1 === 0 ? "INICIO" : msg1
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "container-fluid mx-auto py-3", id: "scrolty" },
	            VISTA[mostrar]
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VerConfiguracionAthos = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _gestionBaseDatos = __webpack_require__(7082);
	
	var _gestionBaseDatos2 = _interopRequireDefault(_gestionBaseDatos);
	
	var _tablaUsuriosApp = __webpack_require__(668);
	
	var _tablaUsuriosApp2 = _interopRequireDefault(_tablaUsuriosApp);
	
	var _tablaUsurios = __webpack_require__(667);
	
	var _tablaUsurios2 = _interopRequireDefault(_tablaUsurios);
	
	var _tablaAfiliados = __webpack_require__(666);
	
	var _tablaAfiliados2 = _interopRequireDefault(_tablaAfiliados);
	
	var _tablaPersonasAthos = __webpack_require__(7101);
	
	var _tablaPersonasAthos2 = _interopRequireDefault(_tablaPersonasAthos);
	
	var _gestionDataScript = __webpack_require__(7084);
	
	var _gestionDataScript2 = _interopRequireDefault(_gestionDataScript);
	
	var _generarBackup = __webpack_require__(663);
	
	var _generarBackup2 = _interopRequireDefault(_generarBackup);
	
	var _gestionCp = __webpack_require__(7083);
	
	var _gestionCp2 = _interopRequireDefault(_gestionCp);
	
	var _generarVersion = __webpack_require__(7081);
	
	var _generarVersion2 = _interopRequireDefault(_generarVersion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VerConfiguracionAthos = exports.VerConfiguracionAthos = function VerConfiguracionAthos(props) {
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      mostrar = _useState2[0],
	      setMostrar = _useState2[1];
	
	  var _useState3 = (0, _react.useState)("d-flex bluex-bg"),
	      _useState4 = _slicedToArray(_useState3, 2),
	      clase = _useState4[0],
	      setClase = _useState4[1];
	
	  var _useState5 = (0, _react.useState)("Gestionar Afiliados"),
	      _useState6 = _slicedToArray(_useState5, 2),
	      msg1 = _useState6[0],
	      setMsg1 = _useState6[1];
	
	  var mostrarVis = function mostrarVis(vista) {
	    return function (e) {
	      e.preventDefault();
	      setMostrar(vista);
	    };
	  };
	
	  var cancelar = function cancelar() {
	    setMostrar("");
	    setClase("d-flex bluex-bg");
	    props.onHideCancela();
	  };
	
	  var menuclick = function menuclick(titulo) {
	    return function (e) {
	      e.preventDefault();
	      setMsg1(titulo);
	      if (clase === "d-flex bluex-bg") {
	        setClase("d-flex bluex-bg toggled");
	      } else {
	        setClase("d-flex bluex-bg");
	      }
	    };
	  };
	
	  var VISTA = {
	    0: _react2.default.createElement(_tablaAfiliados2.default, { menu: "sistema" }),
	    1: _react2.default.createElement(_tablaPersonasAthos2.default, null),
	    2: _react2.default.createElement(_tablaUsurios2.default, { menu: "sistema" }),
	    3: _react2.default.createElement(_gestionBaseDatos2.default, null),
	    4: _react2.default.createElement(_tablaUsuriosApp2.default, { menu: "sistema" }),
	    5: _react2.default.createElement(_gestionDataScript2.default, null),
	    6: _react2.default.createElement(_generarBackup2.default, { menu: "sistema" }),
	    7: _react2.default.createElement(_gestionCp2.default, { menu: "sistema" }),
	    8: _react2.default.createElement(_generarVersion2.default, { menu: "sistema" })
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "xl",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      backdrop: "static",
	      keyboard: false
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Configuraci\xF3n General del SISTEMA"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { padding: 0 } },
	      _react2.default.createElement(
	        "div",
	        {
	          className: clase,
	          id: "wrapper",
	          style: { overflow: "hidden", maxHeight: "85vh" }
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "amanecergris ", id: "sidebar-wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "list-group list-group-flush " },
	            _react2.default.createElement(
	              "div",
	              { className: "list-group list-group-flush" },
	              _react2.default.createElement(
	                "ul",
	                { className: "list-group list-group-light" },
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "list-group-item bg-transparent px-0 p-0 btn-primary",
	                    onClick: menuclick("Gestionar Afiliados")
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      className: "list-group-item list-group-item-action py-3 ripple bg-transparent px-1",
	                      type: "button",
	                      onClick: mostrarVis(0)
	                    },
	                    _react2.default.createElement("i", { className: "  fas fa-sitemap fa-fw me-3 text-light px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "text-dark text-secondary fw-bold" },
	                      "Afiliados"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "list-group-item bg-transparent px-0 p-0 btn-primary",
	                    onClick: menuclick("Gestionar Personas")
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      className: "list-group-item list-group-item-action py-3 ripple bg-transparent px-1",
	                      type: "button",
	                      onClick: mostrarVis(1)
	                    },
	                    _react2.default.createElement("i", { className: "  fas fa-user-alt fa-fw me-3 text-primary px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "text-dark text-secondary fw-bold" },
	                      "Personas"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "list-group-item bg-transparent px-0 p-0 btn-primary",
	                    onClick: menuclick("Gestionar Usuarios")
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      className: "list-group-item list-group-item-action py-3 ripple bg-transparent px-1",
	                      type: "button",
	                      onClick: mostrarVis(2)
	                    },
	                    _react2.default.createElement("i", { className: "  fas fa-user-check fa-fw me-3 text-success px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "text-dark text-secondary fw-bold" },
	                      "Usuarios"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "list-group-item bg-transparent px-0 p-0 btn-primary",
	                    onClick: menuclick("Gestionar Usuarios App")
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      className: "list-group-item list-group-item-action py-3 ripple bg-transparent px-1",
	                      type: "button",
	                      onClick: mostrarVis(4)
	                    },
	                    _react2.default.createElement("i", { className: "  fas fa-user-check fa-fw me-3 text-success px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "text-dark text-secondary fw-bold" },
	                      "Usuarios App"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "list-group-item bg-transparent px-0 p-0 btn-primary",
	                    onClick: menuclick("Gestionar Bases De Datos")
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      className: "list-group-item list-group-item-action py-3 ripple bg-transparent px-1",
	                      type: "button",
	                      onClick: mostrarVis(3)
	                    },
	                    _react2.default.createElement("i", { className: "  fas fa-database fa-fw me-3 text-primary px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "text-dark text-secondary fw-bold" },
	                      "Bases de Datos"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "list-group-item bg-transparent px-0 p-0 btn-primary",
	                    onClick: menuclick("Gestionar Actualización")
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      className: "list-group-item list-group-item-action py-3 ripple bg-transparent px-1",
	                      type: "button",
	                      onClick: mostrarVis(5)
	                    },
	                    _react2.default.createElement("i", { className: "  fas fa-database fa-fw me-3 text-warning px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "text-dark text-secondary fw-bold" },
	                      "Ejecutar Script"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "list-group-item bg-transparent px-0 p-0 btn-primary",
	                    onClick: menuclick("Generar Respaldo")
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      className: "list-group-item list-group-item-action py-3 ripple bg-transparent px-1",
	                      type: "button",
	                      onClick: mostrarVis(6)
	                    },
	                    _react2.default.createElement("i", { className: "  fas fa-database fa-fw me-3 text-success px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "text-dark text-secondary fw-bold" },
	                      "Respaldar"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "list-group-item bg-transparent px-0 p-0 btn-primary",
	                    onClick: menuclick("Copiar Directorio de Imagenes")
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      className: "list-group-item list-group-item-action py-3 ripple bg-transparent px-1",
	                      type: "button",
	                      onClick: mostrarVis(7)
	                    },
	                    _react2.default.createElement("i", { className: "  fas fa-database fa-fw me-3 text-success px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "text-dark text-secondary fw-bold" },
	                      "CP"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  {
	                    className: "list-group-item bg-transparent px-0 p-0 btn-primary",
	                    onClick: menuclick("Descargar Apk Athos")
	                  },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      className: "list-group-item list-group-item-action py-3 ripple bg-transparent px-1",
	                      type: "button",
	                      onClick: mostrarVis(8)
	                    },
	                    _react2.default.createElement("i", { className: "  fas fa-database fa-fw me-3 text-success px-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "text-dark text-secondary fw-bold" },
	                      "APK"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { id: "page-content-wrapper" },
	          _react2.default.createElement(
	            "nav",
	            {
	              className: "navbar navbar-expand-lg navbar-light py-2 px-2",
	              id: "one",
	              style: { background: "none" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "d-flex align-items-center" },
	              _react2.default.createElement("i", {
	                className: "fas fa-align-left  text-dark fs-4 me-3",
	                onClick: menuclick(msg1),
	                id: "menu-toggle"
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "collapse navbar-collapse dropstart",
	                id: "navbarSupportedContent"
	              },
	              _react2.default.createElement(
	                "ul",
	                { className: "navbar-nav mx-auto text-center" },
	                _react2.default.createElement(
	                  "h4",
	                  { className: "fs-4" },
	                  msg1 === "Gestion de Usuario Web" ? _react2.default.createElement("i", { className: "  fas fa-users-cog fa-lg px-2" }) : msg1 === "Estructura Organizativa" ? _react2.default.createElement("i", { className: "  fas fa-user-tie fa-lg px-2" }) : "",
	                  msg1 === 0 ? "INICIO" : msg1
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "container-fluid mx-auto py-3", id: "scrolty" },
	            VISTA[mostrar]
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _core = __webpack_require__(19);
	
	var _gestionarMoviles = __webpack_require__(672);
	
	var _gestionarMoviles2 = _interopRequireDefault(_gestionarMoviles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VisualizarMoviles = function VisualizarMoviles(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var anioActu = JSON.parse(sessionStorage.getItem("anioactu"));
	  var idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var accbtncntxcobrar = JSON.parse(sessionStorage.getItem("accbtncntxcobrarc"));
	  var cmbCedula = ["J", "V", "G", "P"];
	  var headCells = [{ label: "PLACA", textAlign: "center", width: "50px" }, { label: "MARCA", textAlign: "center", width: "80px" }, { label: "MODELO", textAlign: "center", width: "80px" }, { label: "USO", textAlign: "center", width: "250px" }, { label: "ACCION", textAlign: "center", width: "50px" }];
	
	  var txtCliente = (0, _react.useRef)();
	  var txtDespachado = (0, _react.useRef)();
	  var txtDevuelto = (0, _react.useRef)([]);
	  var txtCantidad = (0, _react.useRef)([]);
	  var txtPendientes = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtNotaEntrega = (0, _react.useRef)();
	  var txtTotalVacios = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      mostrar = _useState2[0],
	      setMostrar = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      clientemoviles = _useState4[0],
	      setClientemoviles = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      records = _useState6[0],
	      setRecords = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      activate = _useState8[0],
	      setActivate = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      opera = _useState10[0],
	      setOpera = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mensaje = _useState12[0],
	      setMensaje = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensajesino = _useState14[0],
	      setMensajesino = _useState14[1];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var blanquear = function blanquear() {
	    setMostrar(false);
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	    if (props.ope !== 1) {
	      props.onRenderizar();
	    }
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    props.onHideCancelar();
	    props.onRenderizar();
	  };
	
	  var seleccionarMoviles = function seleccionarMoviles(id) {
	    var campos = "*";
	    var nomtab = "moviles";
	    var nomid = "placa";
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&id=" + id + "&nomtab=" + nomtab + "&nomid=" + nomid;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idmovil > 0) {
	          setClientemoviles(response.data);
	          setMostrar(true);
	        } else {
	          setClientemoviles([]);
	          setMostrar(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onGestionar = function onGestionar(item, ope) {
	    return function (e) {
	
	      if (ope === 4) {
	        seleccionarMoviles(item.placa);
	        setOpera(ope);
	      } else if (ope === 2) {
	        seleccionarMoviles(item.placa);
	        setOpera(ope);
	      } else {
	        seleccionarMoviles(item.placa);
	        setOpera(ope);
	      }
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      size: "xl",
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        if (props.ope !== 1) {
	
	          setRecords(props.data);
	          cmbRif.current.value = props.data[0].cedularespo.substring(0, 1);
	          txtRif.current.value = props.data[0].cedularespo.substring(1, 12);
	          txtCliente.current.value = props.data[0].nombrerespo;
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          props.ope === 4 ? "Gestion de Moviles (CONSULTA)" : props.ope === 2 ? "Gestion de Moviles (MODIFICAR)" : "Gestion de Moviles (ELIMINAR)"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { style: { height: "100%", width: "100%" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row col-md-12", style: { margin: 0 } },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row border-azul mx-auto rounded py-1" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-12 mx-auto mb-1 px-0",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row border-azul border-4 rounded py-2" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold mb-1" },
	                  "Datos del Cliente"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-3 px-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: cmbRif,
	                      name: "cmbrif",
	                      disabled: true,
	                      className: "form-select form-select-sm col-md-3 text-center",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "--"
	                    ),
	                    cmbCedula && cmbCedula.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item },
	                        item
	                      );
	                    })
	                  ),
	                  _react2.default.createElement("input", {
	                    ref: txtRif,
	                    autoComplete: "off",
	                    disabled: true,
	                    maxLength: 12,
	                    type: "text",
	                    className: "form-control fs-6 px-1",
	                    name: "cedula",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-9 px-0" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "NOMBRE:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    ref: txtCliente
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 border-azul px-0 rounded",
	                style: { backgroundColor: "#d5e9ff" }
	              },
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 190,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px",
	                    fontSizeAdjust: "0.6"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden table-bordered" },
	                  records && records.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      { key: index, style: { padding: "0" } },
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-center p-2" },
	                        item.placa
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-center p-2 pl-2",
	                          style: { width: "100px" }
	                        },
	                        item.marca
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-center p-2",
	                          style: { width: "100px" }
	                        },
	                        item.modelo
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light p-2 pr-2",
	                          style: { width: "500px" }
	                        },
	                        item.uso
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-center p-2 pr-2",
	                          style: { width: "30px" }
	                        },
	                        props.ope === 4 ? _react2.default.createElement(
	                          "button",
	                          {
	                            className: "btn btn-sm btn-info rounded mx-1",
	                            title: "Visualizar Moviles por Cliente",
	                            onClick: onGestionar(item, 4)
	                          },
	                          _react2.default.createElement("i", { className: "fas fa-eye" })
	                        ) : props.ope === 2 ? _react2.default.createElement(
	                          "button",
	                          {
	                            className: "btn btn-sm btn-warning rounded mx-1",
	                            title: "Modificar Movil por Cliente",
	                            onClick: onGestionar(item, 2)
	                          },
	                          _react2.default.createElement("i", { className: "fas fa-pencil-alt" })
	                        ) : _react2.default.createElement(
	                          "button",
	                          {
	                            className: "btn btn-sm btn-danger rounded",
	                            title: "Eliminar Movil por Cliente",
	                            onClick: onGestionar(item, 3)
	                          },
	                          _react2.default.createElement("i", { className: "fa fa-trash" })
	                        )
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    ),
	    _react2.default.createElement(_gestionarMoviles2.default, {
	      show: mostrar,
	      ope: opera,
	      data: clientemoviles,
	      onHideCancelaDos: function onHideCancelaDos() {
	        cancelar();
	      },
	      onHideCancelar: function onHideCancelar() {
	        setMostrar(false);
	      }
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "Cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({
	          mostrar: false,
	          titulo: "",
	          texto: "",
	          icono: ""
	        });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = VisualizarMoviles;

/***/ },
/* 7144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GestionarpServicios = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoProducto = __webpack_require__(104);
	
	var _catalogoProducto2 = _interopRequireDefault(_catalogoProducto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var GestionarpServicios = exports.GestionarpServicios = function GestionarpServicios(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var accgservicios = JSON.parse(sessionStorage.getItem("accgserviciosc"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtIdServicio = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	  var txtIdalmacen = (0, _react.useRef)();
	  var txtIdmoneda = (0, _react.useRef)();
	  var txtIva = (0, _react.useRef)();
	  var txtMonto = (0, _react.useRef)();
	  var txtCodigo = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)("Servicios."),
	      _useState2 = _slicedToArray(_useState, 2),
	      tituloHeader = _useState2[0],
	      setTituloHeader = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({
	    imagen: "subir.png",
	    imagenactual: "subir.png"
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      imagen = _useState4[0],
	      setImagen = _useState4[1];
	
	  var _useState5 = (0, _react.useState)("visible"),
	      _useState6 = _slicedToArray(_useState5, 2),
	      visibleBtn = _useState6[0],
	      setVisibleBtn = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      operacion = _useState8[0],
	      setOperacion = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      body = _useState10[0],
	      setBody = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      activate = _useState12[0],
	      setActivate = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(true),
	      _useState14 = _slicedToArray(_useState13, 2),
	      habilitado = _useState14[0],
	      setHabilitado = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(true),
	      _useState16 = _slicedToArray(_useState15, 2),
	      acepta = _useState16[0],
	      setAcepta = _useState16[1];
	
	  var _useState17 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState18 = _slicedToArray(_useState17, 2),
	      mensaje = _useState18[0],
	      setMensaje = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      mensajesino = _useState20[0],
	      setMensajesino = _useState20[1];
	
	  var _useState21 = (0, _react.useState)([]),
	      _useState22 = _slicedToArray(_useState21, 2),
	      combomoneda = _useState22[0],
	      setComboMoneda = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(false),
	      _useState24 = _slicedToArray(_useState23, 2),
	      catalogoModelo = _useState24[0],
	      setCatalogoModelo = _useState24[1];
	
	  var _useState25 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState26 = _slicedToArray(_useState25, 2),
	      botones = _useState26[0],
	      setBotones = _useState26[1];
	
	  var _useState27 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState28 = _slicedToArray(_useState27, 2),
	      monedaSub = _useState28[0],
	      setMonedaSub = _useState28[1];
	
	  var _useState29 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState30 = _slicedToArray(_useState29, 2),
	      monedaCambio = _useState30[0],
	      setMonedaCambio = _useState30[1];
	
	  var _useState31 = (0, _react.useState)({
	    idmoneda: "1",
	    descripcion: "BOLIVARES",
	    simbolo: "Bs",
	    predeterminada: true,
	    subpredeterminada: false,
	    valormoneda: 1.0
	  }),
	      _useState32 = _slicedToArray(_useState31, 2),
	      moneda = _useState32[0],
	      setMoneda = _useState32[1];
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "descripcion") {
	      if (e.target.value === "") {
	        setBotones(Object.assign({}, botones, { aceptar: true }));
	      } else {
	        setBotones(Object.assign({}, botones, { aceptar: false }));
	      }
	      e.target.value = e.target.value;
	    } else {
	      e.target.value = e.target.value;
	    }
	  };
	
	  var seleccionarCodigo = function seleccionarCodigo() {
	    var campos = "count(idproducto) as codigo";
	    var nomtab = "producto";
	    var nomid = "servicio";
	    var id = true;
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.codigo > 0) {
	          var to = response.data.codigo;
	          to = parseFloat(to) + 1;
	          txtCodigo.current.value = "SERV0000" + to;
	        } else {
	          txtCodigo.current.value = "SERV00001";
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var handleInputMontoChange = function handleInputMontoChange(event) {
	    (0, _varios.validaMonto)(event);
	
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	        event.target.value = "0,00";
	      }
	      event.target.value = (0, _varios.formatoMonto)(event.target.value);
	      var char1 = event.target.value.substring(0, 1);
	      var char2 = event.target.value.substring(1, 2);
	      if (char1 === "0" && char2 !== ",") {
	        event.target.value = event.target.value.substring(1, event.target.value.legth);
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var onCatalogoServicio = function onCatalogoServicio(values) {
	    setCatalogoModelo(false);
	    txtIdServicio.current.value = values.idproducto;
	    txtCodigo.current.value = values.codigo;
	    txtDescripcion.current.value = values.nombre;
	    txtIva.current.value = values.ivaventa;
	    txtMonto.current.value = values.preciomax;
	    if (operacion !== 4) {
	      setAcepta(false);
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	    if (!botones.incluir || !botones.modificar) {
	      if (txtDescripcion.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Debe ingresar una descripción",
	          icono: "informacion"
	        });
	        txtDescripcion.current.focus();
	        sigue = false;
	      } else if (txtMonto.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Introduzca el Monto del Servicio",
	          icono: "informacion"
	        });
	        txtMonto.current.focus();
	        sigue = false;
	      }
	    }
	
	    if (sigue) {
	      var _prod$push;
	
	      var prod = [];
	      prod.push((_prod$push = {
	        idproducto: operacion === 1 ? 0 : txtIdServicio.current.value,
	        codigo: txtCodigo.current.value.toUpperCase(),
	        nombre: txtDescripcion.current.value.toUpperCase(),
	        servicio: true,
	        nombrecorto: txtDescripcion.current.value.toUpperCase(),
	        idtipoproducto: 0,
	        marca: null,
	        modelo: null,
	        referencia: null,
	        diasgarantia: null,
	        idunidadmedida: null,
	        idmoneda: monedaSub.idmoneda,
	        ivacompra: 0,
	        ivaventa: parseFloat(txtIva.current.value.replace(/\./g, "").replace(",", ".")),
	        exento: 0
	      }, _defineProperty(_prod$push, "idtipoproducto", 2), _defineProperty(_prod$push, "tipoprecio", 1), _defineProperty(_prod$push, "almacen", true), _defineProperty(_prod$push, "stockminimo", 1), _defineProperty(_prod$push, "metodocosto", 1), _defineProperty(_prod$push, "costoproveedor", 0), _defineProperty(_prod$push, "costocalculado", parseFloat(txtMonto.current.value.replace(/\./g, "").replace(",", "."))), _defineProperty(_prod$push, "ultimocosto", parseFloat(txtMonto.current.value.replace(/\./g, "").replace(",", "."))), _defineProperty(_prod$push, "costopromedio", parseFloat(txtMonto.current.value.replace(/\./g, "").replace(",", "."))), _defineProperty(_prod$push, "utipreciomaxi", parseFloat(txtMonto.current.value.replace(/\./g, "").replace(",", "."))), _defineProperty(_prod$push, "utiprecioofe", parseFloat(txtMonto.current.value.replace(/\./g, "").replace(",", "."))), _defineProperty(_prod$push, "utipreciomayor", parseFloat(txtMonto.current.value.replace(/\./g, "").replace(",", "."))), _defineProperty(_prod$push, "utipreciomini", parseFloat(txtMonto.current.value.replace(/\./g, "").replace(",", "."))), _defineProperty(_prod$push, "preciomaxi", parseFloat(txtMonto.current.value.replace(/\./g, "").replace(",", "."))), _defineProperty(_prod$push, "precioofe", parseFloat(txtMonto.current.value.replace(/\./g, "").replace(",", "."))), _defineProperty(_prod$push, "preciomayor", parseFloat(txtMonto.current.value.replace(/\./g, "").replace(",", "."))), _defineProperty(_prod$push, "preciomini", parseFloat(txtMonto.current.value.replace(/\./g, "").replace(",", "."))), _defineProperty(_prod$push, "idunidadalterna", "0"), _defineProperty(_prod$push, "idunidadcompra", "0"), _defineProperty(_prod$push, "idunidadventa", "0"), _defineProperty(_prod$push, "valorfactor", "0.00"), _defineProperty(_prod$push, "tipofactor", 1), _defineProperty(_prod$push, "costoproveedoralter", "0.00"), _defineProperty(_prod$push, "costocalculadoalter", "0.00"), _defineProperty(_prod$push, "ultimocostoalter", "0.00"), _defineProperty(_prod$push, "costopromedioalter", "0.00"), _defineProperty(_prod$push, "utipreciomaxialter", "0.00"), _defineProperty(_prod$push, "utiprecioofealter", "0.00"), _defineProperty(_prod$push, "utipreciomayoralter", "0.00"), _defineProperty(_prod$push, "utipreciominialter", "0.00"), _defineProperty(_prod$push, "preciomaxialter", "0.00"), _defineProperty(_prod$push, "precioofealter", "0.00"), _defineProperty(_prod$push, "preciomayoralter", "0.00"), _defineProperty(_prod$push, "preciominialter", "0.00"), _defineProperty(_prod$push, "idtipoingreso", "0"), _defineProperty(_prod$push, "idfabricante", "0"), _prod$push));
	
	      var upload = new FormData();
	      console.log(prod);
	      upload.append("producto", JSON.stringify(prod));
	      upload.append("codigo", txtCodigo.current.value.toUpperCase());
	      upload.append("imagenactual", imagen.imagenactual);
	      upload.append("imagennueva", imagen.imagen);
	
	      setBody(upload);
	
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + "/api/producto/actualizar/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Registro Creado Correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Registro Modificado Correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Registro Eliminado Correctamente",
	            icono: "exito"
	          });
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = "";
	      if (error.response === undefined) {
	        mensaje = "Error de Conexion";
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
	          mensaje = "Ya existe un Registro con este Código";
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    if (mensajesino.texto === "Seguro de Descartar Cambios?" && props.llamado === 2) {
	      cancelar();
	    } else {
	      procesarRegistro();
	    }
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setTituloHeader("Servicios.");
	    setBody(null);
	    setHabilitado(true);
	    setComboMoneda([]);
	    setAcepta(true);
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      salir: false
	    });
	    txtIdServicio.current.setAttribute("disabled", true);
	    txtDescripcion.current.value = "";
	    txtIva.current.value = 0.00;
	    txtMonto.current.value = "";
	    txtCodigo.current.value = "";
	    setVisibleBtn("visible");
	    setMonedaCambio({
	      idmoneda: "4",
	      descripcion: "DOLAR",
	      simbolo: "$",
	      predeterminada: false,
	      subpredeterminada: true,
	      valormoneda: 1.0
	    });
	    for (var i = 0; i < combomoneda.length; i++) {
	      if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
	        txtIdmoneda.current.selectedIndex = i;
	      }
	    }
	  };
	
	  var seleccionarMonedas = function seleccionarMonedas() {
	    var campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	    var nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	    var orden = "m.idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var x = 0;
	        if (response.data.length > 0) {
	          setComboMoneda(response.data);
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].subpredeterminada) {
	              setMonedaSub(response.data[i]);
	              setMonedaCambio({
	                idmoneda: response.data[i].idmoneda,
	                descripcion: response.data[i].descripcion,
	                simbolo: response.data[i].simbolo,
	                predeterminada: response.data[i].predeterminada,
	                subpredeterminada: response.data[i].subpredeterminada,
	                valormoneda: 1.0
	              });
	              x = i;
	            } else if (response.data[i].predeterminada) {
	              setMoneda(response.data[i]);
	            }
	          }
	        }
	        setTimeout(function () {
	          return txtIdmoneda.current.selectedIndex = x;
	        }, 200);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (accgservicios && accgservicios.toString().substring(0, 1) === "1") {
	          setVisibleBtn("collapse");
	          seleccionarMonedas();
	          setTituloHeader("Incluir Servicio.");
	          seleccionarCodigo();
	          setOperacion(op);
	          setHabilitado(false);
	          setAcepta(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	          txtIva.current.value = 0.00;
	          setTimeout(function () {
	            return txtCodigo.current.focus();
	          }, 200);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (accgservicios && accgservicios.toString().substring(1, 2) === "1") {
	          setVisibleBtn("collapse");
	          seleccionarMonedas();
	          setTituloHeader("Editar Servicio.");
	          setOperacion(op);
	          setHabilitado(false);
	          setAcepta(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (accgservicios && accgservicios.toString().substring(3, 4) === "1") {
	          setVisibleBtn("collapse");
	          seleccionarMonedas();
	          setHabilitado(true);
	          setTituloHeader("Eliminar Servicio.");
	          setOperacion(op);
	          setAcepta(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (accgservicios && accgservicios.toString().substring(2, 3) === "1") {
	          setVisibleBtn("collapse");
	          setTituloHeader("Consultar Servicio.");
	          setOperacion(op);
	          seleccionarMonedas();
	          setAcepta(true);
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            salir: true
	          });
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        if (props.llamado === 2) {
	          if (txtDescripcion.current.value === "") {
	            blanquear();
	            props.onHideCancela();
	          } else {
	            setMensajesino({
	              mostrar: true,
	              titulo: "Confirmación.",
	              texto: "Seguro de Descartar Cambios?",
	              icono: "confirmacion"
	            });
	          }
	        } else {
	          blanquear();
	        }
	      } else if (op === 7) {
	        setVisibleBtn("visible");
	        cancelar();
	      }
	    };
	  };
	
	  var cerrarModal = function cerrarModal() {
	    if (props.llamado === 2) {
	      props.onHideRenderizar();
	      props.onHideCancela();
	    }
	    blanquear();
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var imprimirFabricantes = function imprimirFabricantes() {
	    /* window.open(
	      `${op.reportes}/almacen?afiliado=${afiliado}&reporte=ListFabricantes`,
	      "Planilla",
	      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
	    ); */
	  };
	
	  var onChangeMoneda = function onChangeMoneda(e) {
	    var i = e.target.value;
	    var cambio = (0, _varios.onCambioMoneda)({
	      moneda: combomoneda[i],
	      productos: "",
	      monedaPre: moneda,
	      monedaSub: monedaSub
	    });
	    setMonedaCambio(cambio.monedacambio);
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        setHabilitado(true);
	        if (props.llamado === 2) {
	          setOperacion(1);
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: true,
	            salir: true
	          });
	          setTimeout(function () {
	            return txtCodigo.current.focus();
	          }, 200);
	          setVisibleBtn("collapse");
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        _Modal2.default.Title,
	        { style: { color: "#fff" } },
	        tituloHeader,
	        " "
	      ),
	      _react2.default.createElement(
	        "a",
	        {
	          href: "#",
	          ref: btnSalir,
	          disabled: botones.salir,
	          onClick: onBotones(7),
	          className: "text-light"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-times fa-1x shadow" },
	          " "
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({
	            mostrar: false,
	            titulo: "",
	            texto: "",
	            icono: ""
	          });
	        }
	      }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, {
	        mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	        },
	        onHideSi: handleCloseSi
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12 row mx-auto px-0" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12 mx-auto px-0 row m-0" },
	          _react2.default.createElement("input", { type: "hidden", ref: txtIdServicio }),
	          _react2.default.createElement(
	            "div",
	            { className: "col-pd-230 mb-2 px-1" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group input-group-sm px-0" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "CODIGO:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                ref: txtCodigo,
	                disabled: habilitado
	                /* onKeyUp={validarMarca}
	                onBlur={validarMarca} */
	                , className: "form-control fs-6",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-sm"
	              }),
	              _react2.default.createElement(
	                "button",
	                {
	                  disabled: botones.catalogo,
	                  type: "button",
	                  onClick: function onClick() {
	                    return setCatalogoModelo(true);
	                  },
	                  className: "btn btn-success"
	                },
	                _react2.default.createElement("i", { className: "fas fa-search" })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-pd-330 mb-2 mx-auto px-0" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group input-group-sm" },
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "input-group-text",
	                  id: "inputGroup-sizing-sm"
	                },
	                "TIPO DE MONEDA:"
	              ),
	              _react2.default.createElement(
	                "select",
	                {
	                  className: "form-control form-control-sm form-select fw-bold fs-6",
	                  disabled: operacion === 3 || operacion === 0 ? true : false,
	                  ref: txtIdmoneda,
	                  onChange: onChangeMoneda
	                },
	                combomoneda && combomoneda.map(function (item, index) {
	                  return _react2.default.createElement(
	                    "option",
	                    { key: index, value: index },
	                    " ",
	                    item.descripcion + " " + item.simbolo + " " + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    " "
	                  );
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "border-azul col-md-12 py-3 rounded mx-1",
	            style: { fontSizeAdjust: "0.6" }
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "row col-md-12 rounded mx-auto" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group input-group-sm col-md-12 px-0 mb-2" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "DESCRIPCION:"
	              ),
	              _react2.default.createElement("textarea", {
	                type: "text",
	                ref: txtDescripcion,
	                name: "descripcion",
	                autoComplete: "off",
	                disabled: habilitado,
	                style: { height: "45px" },
	                className: "form-control text-uppercase fs-6",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-sm",
	                onChange: onChange
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row m-0 px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-100 px-0 mb-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "IVA:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "text",
	                    disabled: habilitado,
	                    ref: txtIva,
	                    onKeyUp: handleInputMontoChange,
	                    onBlur: handleInputMontoChange,
	                    className: "form-control bg-transparent fs-6 text-right",
	                    "aria-label": "Sizing example input",
	                    placeholder: "0,00",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 mb-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "MONTO:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "text",
	                    onKeyUp: handleInputMontoChange,
	                    onBlur: handleInputMontoChange,
	                    disabled: habilitado,
	                    ref: txtMonto,
	                    className: "form-control bg-transparent fs-6 text-right",
	                    "aria-label": "Sizing example input",
	                    placeholder: "0,00",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12 mx-auto" },
	        visibleBtn === "visible" ? _react2.default.createElement(
	          "div",
	          { className: "col-md-12 mx-auto row justify-content-between px-0" },
	          _react2.default.createElement(
	            "button",
	            {
	              disabled: botones.incluir,
	              onClick: onBotones(1),
	              className: "btn btn-sm mx-1 my-1 col btn-primary rounded-pill",
	              title: "Incluir Modelo"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-plus" },
	              " Incluir "
	            ),
	            " "
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              disabled: botones.consultar,
	              onClick: onBotones(4),
	              className: "btn btn-sm mx-1 my-1 col btn-info rounded-pill",
	              title: "Consultar Modelo"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-eye" },
	              "Consultar"
	            ),
	            " "
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              disabled: botones.modificar,
	              onClick: onBotones(2),
	              className: "btn btn-sm mx-1 my-1 col btn-warning rounded-pill",
	              title: "Modificar Modelo"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fa fa-edit" },
	              "Modificar"
	            ),
	            " "
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              disabled: botones.eliminar,
	              onClick: onBotones(3),
	              className: "btn btn-sm mx-1 my-1 col btn-danger rounded-pill",
	              title: "Eliminar Modelo"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fa fa-trash" },
	              "Eliminar"
	            ),
	            " "
	          )
	        ) : _react2.default.createElement(
	          "div",
	          { className: "col-md-12 row mx-auto justify-content-end px-0" },
	          _react2.default.createElement(
	            "button",
	            {
	              ref: btnAcepta,
	              disabled: acepta,
	              onClick: onBotones(5),
	              className: "btn col-md-3 mx-1 my-1 btn-sm rounded-pill btn-success "
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-check-circle" },
	              " Aceptar"
	            )
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              ref: btnCancela,
	              disabled: botones.cancelar,
	              onClick: onBotones(6),
	              className: "btn col-md-3 mx-1 my-1 btn-danger btn-sm rounded-pill "
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-window-close" },
	              " Cancelar"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoProducto2.default, {
	      show: catalogoModelo,
	      esservicio: "1",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoModelo(false);
	      },
	      onHideAceptaCatalogo: onCatalogoServicio
	    })
	  );
	};

/***/ },
/* 7145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mensajes = __webpack_require__(9);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _core = __webpack_require__(19);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _gestionarMoviles = __webpack_require__(672);
	
	var _gestionarMoviles2 = _interopRequireDefault(_gestionarMoviles);
	
	var _actualizarMoviles = __webpack_require__(7143);
	
	var _actualizarMoviles2 = _interopRequireDefault(_actualizarMoviles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* import RegistrarPagoNotadeEntregaV from './registrarPagoNotaEntrega';
	import ActualizarVacios from './actualizarVacios';
	import GestionarVacios from './gestionarVacios'; */
	
	function GestionMoviles(props) {
	    var headCells = [{ id: '8', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CEDULA/RIF', textAlign: 'center' }, { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'NOMBRE', textAlign: 'center' }, { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DIRECCION', textAlign: 'center' }, { id: '9', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'ACCION', textAlign: 'center' }];
	
	    var txtBuscar = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)([]),
	        _useState4 = _slicedToArray(_useState3, 2),
	        valor = _useState4[0],
	        setValor = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        clientemoviles = _useState6[0],
	        setClientemoviles = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(0.00),
	        _useState8 = _slicedToArray(_useState7, 2),
	        total = _useState8[0],
	        setTotal = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(false),
	        _useState10 = _slicedToArray(_useState9, 2),
	        mostrar = _useState10[0],
	        setMostrar = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(false),
	        _useState12 = _slicedToArray(_useState11, 2),
	        mostrar1 = _useState12[0],
	        setMostrar1 = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(false),
	        _useState14 = _slicedToArray(_useState13, 2),
	        mostrar2 = _useState14[0],
	        setMostrar2 = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(0),
	        _useState16 = _slicedToArray(_useState15, 2),
	        opera = _useState16[0],
	        setOpera = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(0),
	        _useState18 = _slicedToArray(_useState17, 2),
	        idnot = _useState18[0],
	        setIdnot = _useState18[1];
	
	    var _useState19 = (0, _react.useState)([]),
	        _useState20 = _slicedToArray(_useState19, 2),
	        detavacios = _useState20[0],
	        setDetavacios = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(0.0),
	        _useState22 = _slicedToArray(_useState21, 2),
	        abono = _useState22[0],
	        setAbono = _useState22[1];
	
	    var _useState23 = (0, _react.useState)([]),
	        _useState24 = _slicedToArray(_useState23, 2),
	        colorF = _useState24[0],
	        setColorF = _useState24[1];
	
	    var color = [];
	
	    var _useState25 = (0, _react.useState)([{
	        color: '#0d6efd',
	        nombre: 'Total Cobrado',
	        valor: '545.555,23'
	    }, {
	        color: '#dc3545',
	        nombre: 'Total x Cobrar',
	        valor: '54.445,42'
	    }]),
	        _useState26 = _slicedToArray(_useState25, 2),
	        datos = _useState26[0],
	        setDatos = _useState26[1];
	
	    var _useState27 = (0, _react.useState)([]),
	        _useState28 = _slicedToArray(_useState27, 2),
	        records = _useState28[0],
	        setRecords = _useState28[1];
	
	    var _useState29 = (0, _react.useState)([]),
	        _useState30 = _slicedToArray(_useState29, 2),
	        municipiosData = _useState30[0],
	        setMunicipiosData = _useState30[1];
	
	    var _useState31 = (0, _react.useState)(['#0d6efd', '#dc3545']),
	        _useState32 = _slicedToArray(_useState31, 2),
	        colorG = _useState32[0],
	        setColorG = _useState32[1];
	
	    var _useState33 = (0, _react.useState)({
	        enero: 0.00,
	        febrero: 0.00,
	        marzo: 0.00,
	        abril: 0.00,
	        mayo: 0.00,
	        junio: 0.00,
	        julio: 0.00,
	        agosto: 0.00,
	        septiembre: 0.00,
	        octubre: 0.00,
	        noviembre: 0.00,
	        diciembre: 0.00
	    }),
	        _useState34 = _slicedToArray(_useState33, 2),
	        rm = _useState34[0],
	        setRM = _useState34[1];
	
	    var _useState35 = (0, _react.useState)(false),
	        _useState36 = _slicedToArray(_useState35, 2),
	        activate = _useState36[0],
	        setActivate = _useState36[1];
	
	    var _useState37 = (0, _react.useState)(JSON.parse(sessionStorage.getItem('fechasistema'))),
	        _useState38 = _slicedToArray(_useState37, 2),
	        fechaSistema = _useState38[0],
	        setFechaSistema = _useState38[1];
	
	    var _useState39 = (0, _react.useState)(sessionStorage.getItem('anioactu')),
	        _useState40 = _slicedToArray(_useState39, 2),
	        anioActu = _useState40[0],
	        setAnioActu = _useState40[1];
	
	    var _useState41 = (0, _react.useState)([]),
	        _useState42 = _slicedToArray(_useState41, 2),
	        label = _useState42[0],
	        setLabel = _useState42[1];
	
	    var _useState43 = (0, _react.useState)([]),
	        _useState44 = _slicedToArray(_useState43, 2),
	        labelu = _useState44[0],
	        setLabelu = _useState44[1];
	
	    var _useState45 = (0, _react.useState)(),
	        _useState46 = _slicedToArray(_useState45, 2),
	        data = _useState46[0],
	        setData = _useState46[1];
	
	    var _useState47 = (0, _react.useState)(),
	        _useState48 = _slicedToArray(_useState47, 2),
	        options = _useState48[0],
	        setOptions = _useState48[1];
	
	    var token = sessionStorage.getItem('jwtToken');
	    var op = __webpack_require__(8);
	    var ncaja = JSON.parse(sessionStorage.getItem("numcaja"));
	    var accmoviles = JSON.parse(sessionStorage.getItem("accmovilesc"));
	    var txtMesPetro = (0, _react.useRef)();
	    var txtMesUTE = (0, _react.useRef)();
	
	    var _useState49 = (0, _react.useState)({
	        fn: function fn(items) {
	            return items;
	        }
	    }),
	        _useState50 = _slicedToArray(_useState49, 2),
	        filterFn = _useState50[0],
	        setFilterFn = _useState50[1];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.rif.toLowerCase().includes(target.value.toLowerCase()) || x.cliente.toLowerCase().includes(target.value.toLowerCase()) || x.direccion.toLowerCase().includes(target.value.toLowerCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	
	        var endpoint = op.conexion + '/api/servicios/consultaregistromoviles';
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                "x-access-token": '' + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                    txtBuscar.current.focus();
	                }
	            }
	        }).catch(function (error) {
	            setMensaje({
	                mostrar: true,
	                titulo: "Error",
	                texto: error.response.data.message,
	                icono: "error"
	            });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var blanquear = function blanquear() {
	        setIdnot(0);
	    };
	
	    (0, _react.useEffect)(function () {
	        seleccionarRegistros();
	    }, []);
	
	    var seleccionarMoviles = function seleccionarMoviles(id, ope) {
	        var campos = "idmovil, idpropietario, trim(placa) as placa, trim(marca) as marca, trim(modelo) as modelo, trim(uso) as uso, trim(nombrerespo) as nombrerespo, trim(cedularespo) as cedularespo";
	        var nomtab = "moviles";
	        var nomid = "idpropietario";
	        var orden = "idmovil desc";
	        var endpoint = op.conexion + '/api/consulta/modeliorder?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid + '&orden=' + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                "x-access-token": '' + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    if (ope === 5) {
	                        setClientemoviles(response.data);
	                        setMostrar1(true);
	                    } else {
	                        setClientemoviles(response.data);
	                        setMostrar2(true);
	                    }
	                } else {
	                    setClientemoviles([]);
	                    setMostrar2(false);
	                }
	            }
	        }).catch(function (error) {
	            setMensaje({
	                mostrar: true,
	                titulo: "Error",
	                texto: error.response.data.message,
	                icono: "error"
	            });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var onGestionar = function onGestionar(item, ope) {
	        return function (e) {
	
	            if (ope === 1 || ope === 5) {
	                if (accmoviles && accmoviles.toString().substring(0, 1) === "1") {
	                    if (ope === 5) {
	                        seleccionarMoviles(item.idagente, ope);
	                        setOpera(ope);
	                    } else {
	                        setMostrar1(true);
	                        setOpera(ope);
	                    }
	                } else {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Notificación.",
	                        texto: "¡No Posee Permiso para Realizar esta Acción!",
	                        icono: "error"
	                    });
	                }
	            } else if (ope === 2) {
	                if (accmoviles && accmoviles.toString().substring(1, 2) === "1") {
	                    seleccionarMoviles(item.idagente, ope);
	                    setOpera(ope);
	                } else {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Notificación.",
	                        texto: "¡No Posee Permiso para Realizar esta Acción!",
	                        icono: "error"
	                    });
	                }
	            } else if (ope === 3) {
	                if (accmoviles && accmoviles.toString().substring(2, 3) === "1") {
	                    seleccionarMoviles(item.idagente, ope);
	                    setOpera(ope);
	                } else {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Notificación.",
	                        texto: "¡No Posee Permiso para Realizar esta Acción!",
	                        icono: "error"
	                    });
	                }
	            } else {
	                if (accmoviles && accmoviles.toString().substring(3, 4) === "1") {
	                    seleccionarMoviles(item.idagente, ope);
	                    setOpera(ope);
	                } else {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Notificación.",
	                        texto: "¡No Posee Permiso para Realizar esta Acción!",
	                        icono: "error"
	                    });
	                }
	            }
	        };
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 mx-auto' },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 mt-2' },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                    onHide: function onHide() {
	                        return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                    } }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container-fluid px-3 py-2' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row col-md-10 card py-3 mx-auto' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row col-md-12 mx-auto' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 row h-100' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 row mx-auto py-3 m-0' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row col-md-12 m-0 px-0' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'input-group col-md-6 input-group-sm px-0' },
	                                            _react2.default.createElement('input', {
	                                                type: 'text',
	                                                onChange: handleSearch,
	                                                placeholder: 'Buscar',
	                                                title: 'Buscar Clasificador de Vacios',
	                                                className: 'form-control text-uppercase',
	                                                ref: txtBuscar
	                                            }),
	                                            _react2.default.createElement(
	                                                'button',
	                                                {
	                                                    className: 'btn',
	                                                    style: {
	                                                        pointerEvents: "none",
	                                                        backgroundColor: "rgba(5, 81, 130, 1)",
	                                                        color: "#FFFFFF"
	                                                    }
	                                                },
	                                                _react2.default.createElement('i', { className: 'fa fa-search' })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'col-pd-60 ml-auto' },
	                                            _react2.default.createElement(
	                                                'button',
	                                                {
	                                                    onClick: onGestionar('', 1),
	                                                    className: 'btn btn-sm btn-primary rounded-circle mx-1'
	                                                },
	                                                _react2.default.createElement('i', { className: 'fas fa-plus' }),
	                                                " "
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-12 mt-2 px-0 mx-0 rounded' },
	                                        _react2.default.createElement(
	                                            TblContainer,
	                                            { container: { height: 220, width: '100%', overflow: 'auto', padding: '2px', fontSizeAdjust: '0.6' } },
	                                            _react2.default.createElement(TblHead, null),
	                                            _react2.default.createElement(
	                                                _core.TableBody,
	                                                { className: 'overflow-hidden table-bordered' },
	                                                records && recordsAfterPagingAndSorting().map(function (item, index) {
	                                                    return _react2.default.createElement(
	                                                        _core.TableRow,
	                                                        { key: index, style: { padding: "0" } },
	                                                        _react2.default.createElement(
	                                                            _core.TableCell,
	                                                            { className: 'align-middle bg-light', style: { textAlign: "center", width: '80px' } },
	                                                            item.rif
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _core.TableCell,
	                                                            { className: 'align-middle', style: { width: '350px' } },
	                                                            item.cliente
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _core.TableCell,
	                                                            { className: 'align-middle', style: { width: '500px' } },
	                                                            item.direccion
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _core.TableCell,
	                                                            {
	                                                                className: 'align-middle',
	                                                                style: {
	                                                                    textAlign: "center",
	                                                                    width: "120px"
	                                                                }
	                                                            },
	                                                            _react2.default.createElement(
	                                                                'button',
	                                                                {
	                                                                    className: 'btn btn-sm btn-primary rounded mx-1',
	                                                                    title: 'Visualizar Moviles por Cliente',
	                                                                    onClick: onGestionar(item, 5)
	                                                                },
	                                                                _react2.default.createElement('i', { className: 'fas fa-plus' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'button',
	                                                                {
	                                                                    className: 'btn btn-sm btn-info rounded mx-1',
	                                                                    title: 'Visualizar Moviles por Cliente',
	                                                                    onClick: onGestionar(item, 4)
	                                                                },
	                                                                _react2.default.createElement('i', { className: 'fas fa-eye' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'button',
	                                                                {
	                                                                    className: 'btn btn-sm btn-warning rounded mx-1',
	                                                                    title: 'Modificar Movil por Cliente',
	                                                                    onClick: onGestionar(item, 2)
	                                                                },
	                                                                _react2.default.createElement('i', { className: 'fas fa-pencil-alt' })
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                'button',
	                                                                {
	                                                                    className: 'btn btn-sm btn-danger rounded',
	                                                                    title: 'Eliminar Movil por Cliente',
	                                                                    onClick: onGestionar(item, 3)
	                                                                },
	                                                                _react2.default.createElement('i', { className: 'fa fa-trash' })
	                                                            )
	                                                        )
	                                                    );
	                                                })
	                                            )
	                                        ),
	                                        _react2.default.createElement(TblPagination, null)
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_gestionarMoviles2.default, {
	            show: mostrar1,
	            ope: opera,
	            data: clientemoviles,
	            onRenderizar: seleccionarRegistros,
	            onHideCancelar: function onHideCancelar() {
	                setMostrar1(false);
	            }
	        }),
	        _react2.default.createElement(_actualizarMoviles2.default, {
	            show: mostrar2,
	            ope: opera,
	            data: clientemoviles,
	            onRenderizar: seleccionarRegistros,
	            onHideCancelar: function onHideCancelar() {
	                setMostrar2(false);
	            }
	        }),
	        _react2.default.createElement(
	            _semanticUiReact.Dimmer,
	            { active: activate, inverted: true },
	            _react2.default.createElement(
	                _semanticUiReact.Loader,
	                { inverted: true },
	                'cargando...'
	            )
	        )
	    );
	}
	
	exports.default = GestionMoviles;

/***/ },
/* 7146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _core = __webpack_require__(19);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoProductoExistencia = __webpack_require__(105);
	
	var _catalogoProductoExistencia2 = _interopRequireDefault(_catalogoProductoExistencia);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _catalogoNotaEntrega = __webpack_require__(209);
	
	var _catalogoNotaEntrega2 = _interopRequireDefault(_catalogoNotaEntrega);
	
	var _catalogoPedido = __webpack_require__(210);
	
	var _catalogoPedido2 = _interopRequireDefault(_catalogoPedido);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _catalogoOrdenes = __webpack_require__(293);
	
	var _catalogoOrdenes2 = _interopRequireDefault(_catalogoOrdenes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var TablaNotaEntregaServicios = function TablaNotaEntregaServicios() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var accbtnnentrega = JSON.parse(sessionStorage.getItem("accbtnnentregac"));
	
	  var txtNumNotaEntrega = (0, _react.useRef)();
	  var txtStatus = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtId = (0, _react.useRef)([]);
	  var txtIdproducto = (0, _react.useRef)([]);
	  var txtCantidad = (0, _react.useRef)([]);
	  var btnIncluir = (0, _react.useRef)();
	  var btnEditar = (0, _react.useRef)();
	  var btnEliminar = (0, _react.useRef)();
	  var btnConsultar = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtNombreC = (0, _react.useRef)();
	  var txtSubTotal = (0, _react.useRef)();
	  var txtExentoTotal = (0, _react.useRef)();
	  var txtDescuento = (0, _react.useRef)();
	  var txtTotIva = (0, _react.useRef)();
	  var txtTotal = (0, _react.useRef)();
	  var txtNumPedido = (0, _react.useRef)();
	  var cmbMoneda = (0, _react.useRef)();
	  var txtFechaVencimiento = (0, _react.useRef)();
	  var cmbTipoPago = (0, _react.useRef)();
	  var cmbDesde = (0, _react.useRef)();
	  var cmbTipo = (0, _react.useRef)();
	  var txtConcepto = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      body = _useState2[0],
	      setBody = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      operacion = _useState4[0],
	      setOperacion = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      habilitado = _useState6[0],
	      setHabilitado = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(true),
	      _useState8 = _slicedToArray(_useState7, 2),
	      habilitarCat = _useState8[0],
	      setHabilitarCat = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(true),
	      _useState10 = _slicedToArray(_useState9, 2),
	      habilitadoBot = _useState10[0],
	      setHabilitadoBot = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      habilitadoCli = _useState12[0],
	      setHabilitadoCli = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      selectd = _useState14[0],
	      setSelectd = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      selectp = _useState16[0],
	      setSelectp = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      selectpd = _useState18[0],
	      setSelectpd = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(true),
	      _useState20 = _slicedToArray(_useState19, 2),
	      habilitadoProductos = _useState20[0],
	      setHabilitadoProductos = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(false),
	      _useState22 = _slicedToArray(_useState21, 2),
	      habilitadoMod = _useState22[0],
	      setHabilitadoMod = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(false),
	      _useState24 = _slicedToArray(_useState23, 2),
	      habilitadoTip = _useState24[0],
	      setHabilitadoTip = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(null),
	      _useState26 = _slicedToArray(_useState25, 2),
	      indice = _useState26[0],
	      setIndice = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      visible = _useState28[0],
	      setVisible = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      mostrar = _useState30[0],
	      setMostrar = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(false),
	      _useState32 = _slicedToArray(_useState31, 2),
	      habilitarMoneda = _useState32[0],
	      setHabilitarMoneda = _useState32[1];
	
	  var _useState33 = (0, _react.useState)([]),
	      _useState34 = _slicedToArray(_useState33, 2),
	      records = _useState34[0],
	      setRecords = _useState34[1];
	
	  var _useState35 = (0, _react.useState)([]),
	      _useState36 = _slicedToArray(_useState35, 2),
	      combomoneda = _useState36[0],
	      setComboMoneda = _useState36[1];
	
	  var _useState37 = (0, _react.useState)("Gestionar Nota de Entrega."),
	      _useState38 = _slicedToArray(_useState37, 2),
	      tituloHeader = _useState38[0],
	      setTituloHeader = _useState38[1];
	
	  var _useState39 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState40 = _slicedToArray(_useState39, 2),
	      mensaje = _useState40[0],
	      setMensaje = _useState40[1];
	
	  var _useState41 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState42 = _slicedToArray(_useState41, 2),
	      mensajesino = _useState42[0],
	      setMensajesino = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({
	    idmoneda: "1",
	    descripcion: "BOLIVARES",
	    simbolo: "Bs",
	    predeterminada: true,
	    subpredeterminada: false,
	    valormoneda: 1.0
	  }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      moneda = _useState44[0],
	      setMoneda = _useState44[1];
	
	  var _useState45 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState46 = _slicedToArray(_useState45, 2),
	      monedaSub = _useState46[0],
	      setMonedaSub = _useState46[1];
	
	  var _useState47 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState48 = _slicedToArray(_useState47, 2),
	      monedaCambio = _useState48[0],
	      setMonedaCambio = _useState48[1];
	
	  var _useState49 = (0, _react.useState)({
	    subtotal: 0.0,
	    descuento: 0.0,
	    exento: 0.0,
	    sujeto: 0.0,
	    iva: 16.0,
	    totaliva: 0.0,
	    total: 0.0
	  }),
	      _useState50 = _slicedToArray(_useState49, 2),
	      totales = _useState50[0],
	      setTotales = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(false),
	      _useState52 = _slicedToArray(_useState51, 2),
	      catalogoCliente = _useState52[0],
	      setCatalogoCliente = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(false),
	      _useState54 = _slicedToArray(_useState53, 2),
	      catalogoNota = _useState54[0],
	      setCatalogoNota = _useState54[1];
	
	  var _useState55 = (0, _react.useState)(false),
	      _useState56 = _slicedToArray(_useState55, 2),
	      catalogoPedido = _useState56[0],
	      setCatalogoPedido = _useState56[1];
	
	  var _useState57 = (0, _react.useState)(false),
	      _useState58 = _slicedToArray(_useState57, 2),
	      activate = _useState58[0],
	      setActivate = _useState58[1];
	
	  var _useState59 = (0, _react.useState)("visible"),
	      _useState60 = _slicedToArray(_useState59, 2),
	      visibleBtn = _useState60[0],
	      setVisibleBtn = _useState60[1];
	
	  var _useState61 = (0, _react.useState)({
	    idnotaentrega: "0",
	    numnotaentrega: "000000",
	    cedularif: "",
	    descripcion: "NOTA DE ENTREGA DE PRODUCTOS Y SERVICIOS N°",
	    totalmonto: 0.0,
	    totaliva: 0.0,
	    totaldescuento: 0.0,
	    totalexento: 0.0,
	    totalsujeto: 0.0,
	    idcliente: "",
	    idvendedor: "",
	    fecha: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	    status: 0,
	    idalmacen: "",
	    idmoneda: "",
	    idoperacioninventario: "",
	    idpedido: "",
	    numpedido: "",
	    tipo: "NE",
	    credito: false,
	    fechavencimiento: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	    valormoneda: 0.0
	  }),
	      _useState62 = _slicedToArray(_useState61, 2),
	      notaentrega = _useState62[0],
	      setNotaEntrega = _useState62[1];
	
	  var _useState63 = (0, _react.useState)({
	    idcliente: "",
	    tiporif: "J",
	    rif: "",
	    nombre: ""
	  }),
	      _useState64 = _slicedToArray(_useState63, 2),
	      cliente = _useState64[0],
	      setCliente = _useState64[1];
	
	  var _useState65 = (0, _react.useState)({
	    idvendedor: "",
	    tiporif: "",
	    rif: "",
	    nombre: "",
	    idalmacen: ""
	  }),
	      _useState66 = _slicedToArray(_useState65, 2),
	      vendedor = _useState66[0],
	      setVendedor = _useState66[1];
	
	  var nomtabla = void 0;
	
	  if (operacion === 4) {
	    nomtabla = [{ label: "COD-PRODUCTO", textAlign: "center", width: "0px" }, { label: "PRODUCTO", textAlign: "center" }, { label: "CANTIDAD", textAlign: "center" }, { label: "PRECIO UNI.", textAlign: "center" }, { label: "IVA", textAlign: "center" }, { label: "MONTO/IVA", textAlign: "center" }, { label: "UND. ALT.", textAlign: "center" }, { label: "MONTO CON/IVA", textAlign: "center" }];
	  } else {
	    nomtabla = [{ label: "COD-PRODUCTO", textAlign: "center", width: "0px" }, { label: "PRODUCTO", textAlign: "center" }, { label: "EXISTENCIA", textAlign: "center" }, { label: "CANTIDAD", textAlign: "center" }, { label: "PRECIO UNI.", textAlign: "center" }, { label: "IVA", textAlign: "center" }, { label: "MONTO/IVA", textAlign: "center" }, { label: "UND. ALT.", textAlign: "center" }, { label: "MONTO CON/IVA", textAlign: "center" }, {
	      label: _react2.default.createElement("i", { className: "fas fa-trash" }),
	      textAlign: "center",
	      width: "20px"
	    }];
	  }
	
	  var headCells = nomtabla;
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var seleccionarMonedas = function seleccionarMonedas() {
	    var campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	    var nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	    var orden = "m.idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var x = 0;
	        if (response.data.length > 0) {
	          setComboMoneda(response.data);
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].subpredeterminada) {
	              setMonedaSub(response.data[i]);
	              setMonedaCambio({
	                idmoneda: response.data[i].idmoneda,
	                descripcion: response.data[i].descripcion,
	                simbolo: response.data[i].simbolo,
	                predeterminada: response.data[i].predeterminada,
	                subpredeterminada: response.data[i].subpredeterminada,
	                valormoneda: 1.0
	              });
	              x = i;
	            } else if (response.data[i].predeterminada) {
	              setMoneda(response.data[i]);
	            }
	          }
	        }
	        setTimeout(function () {
	          return cmbMoneda.current.selectedIndex = x;
	        }, 200);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarVendedor = function seleccionarVendedor(id) {
	    var campos = "v.idagente, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen";
	    var nomtab = "agente as v";
	    var nomid = "v.idagente";
	    var nomid2 = "v.vendedor";
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setVendedor({
	            idvendedor: response.data.idagente,
	            tiporif: response.data.tiporifv,
	            rif: response.data.rifv,
	            nombre: response.data.nombrev,
	            idalmacen: response.data.idalmacen
	          });
	
	          btnAcepta.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un vendedor con este codigo",
	            icono: "informacion"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarCliente = function seleccionarCliente(rif, tecla) {
	    var campos = "c.idagente, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
	    var nomtab = "agente as c";
	    var nomid = "c.rif";
	    var nomid2 = "c.cliente";
	    var id = rif;
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtNombreC.current.value = response.data.nombrec;
	          setCliente({
	            idcliente: response.data.idagente,
	            tiporif: response.data.tiporifc,
	            rif: response.data.rifc,
	            nombre: response.data.nombrec
	          });
	          if (tecla === 13) {
	            txtFecha.current.focus();
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un cliente con este codigo",
	            icono: "informacion"
	          });
	          txtRif.current.value = "";
	          cmbRif.current.selectedIndex = -1;
	          txtNombreC.current.value = "";
	          if (tecla === 13) {
	            txtRif.current.focus();
	          }
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarProducto = function seleccionarProducto(index, idubi, idprod) {
	    var endpoint = op.conexion + "/api/inventario/seleccionarproductoinv?idproducto='" + idprod.toUpperCase() + "'&idalmacen=" + idubi;
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var data = [].concat(_toConsumableArray(records));
	        if (response.data !== "") {
	          if (response.data.servicio) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "no existe un producto con ese codigo en el almacen.",
	              icono: "error"
	            });
	            txtCantidad.current[records.length - 1].value = "1,00";
	          } else {
	            for (var i = 0; i < records.length; i++) {
	              if (records[i].idproducto === response.data.idproducto) {
	                setActivate(false);
	                setMensaje({
	                  mostrar: true,
	                  titulo: "Notificacion",
	                  texto: "el producto ya ha sido seleccionado.",
	                  icono: "error"
	                });
	                return;
	              }
	            }
	
	            var uni = [];
	            var precio = 0.0;
	            var montoiva = 0.0;
	            var cantie = response.data.cantidad;
	            var tipouni = 0;
	            var tiene_iva = false;
	            var tipoprecio = parseInt(response.data.tipoprecio);
	
	            if (parseFloat(response.data.ivaventa) > 0.0) {
	              tiene_iva = true;
	            }
	
	            if (parseInt(response.data.tipofactor) === 0 || response.data.tipofactor === null) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data.idunidadmedida,
	                descripcion: response.data.descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data.cantidad);
	              cantie = Math.trunc(cantie);
	
	              if (tipoprecio === 1) {
	                precio = parseFloat(response.data.preciomaxi);
	              } else if (tipoprecio === 2) {
	                precio = parseFloat(response.data.precioofe);
	              } else if (tipoprecio === 3) {
	                precio = parseFloat(response.data.preciomayor);
	              } else if (tipoprecio === 4) {
	                precio = parseFloat(response.data.preciomini);
	              }
	
	              /* precio =
	                response.data.costocalculado *
	                (1 + response.data.utipreciomaxi / 100);
	              precio = Math.round(precio * 100) / 100; 
	               montoiva = (precio * response.data.ivaventa) / 100;*/
	            } else {
	              if (response.data.idunidadventa === response.data.idunidadalterna) {
	                tipouni = 1;
	                uni = [{
	                  idunidad: response.data.idunidadalterna,
	                  descripcion: response.data.descripcionunialt,
	                  tipo: "alterna"
	                }, {
	                  idunidad: response.data.idunidadmedida,
	                  descripcion: response.data.descripcionuni,
	                  tipo: "medida"
	                }];
	
	                cantie = parseFloat(response.data.cantidad);
	                cantie = Math.trunc(cantie);
	                if (tipoprecio === 1) {
	                  precio = parseFloat(response.data.preciomaxialter);
	                } else if (tipoprecio === 2) {
	                  precio = parseFloat(response.data.precioofealter);
	                } else if (tipoprecio === 3) {
	                  precio = parseFloat(response.data.preciomayoralter);
	                } else if (tipoprecio === 4) {
	                  precio = parseFloat(response.data.preciominialter);
	                }
	
	                /*                   precio =
	                  response.data.costocalculadoalter *
	                  (1 + response.data.utipreciomaxialter / 100);
	                precio = Math.round(precio * 100) / 100;
	                 montoiva = (precio * response.data.ivaventa) / 100; */
	              } else if (response.data.idunidadventa === response.data.idunidadmedida) {
	                tipouni = 0;
	                uni = [{
	                  idunidad: response.data.idunidadmedida,
	                  descripcion: response.data.descripcionuni,
	                  tipo: "medida"
	                }, {
	                  idunidad: response.data.idunidadalterna,
	                  descripcion: response.data.descripcionunialt,
	                  tipo: "alterna"
	                }];
	
	                cantie = parseFloat(response.data.cantidad / response.data.valorfactor);
	                cantie = Math.trunc(cantie);
	
	                if (tipoprecio === 1) {
	                  precio = parseFloat(response.data.preciomaxi);
	                } else if (tipoprecio === 2) {
	                  precio = parseFloat(response.data.precioofe);
	                } else if (tipoprecio === 3) {
	                  precio = parseFloat(response.data.preciomayor);
	                } else if (tipoprecio === 4) {
	                  precio = parseFloat(response.data.preciomini);
	                }
	
	                /*precio =
	                  response.data.costocalculado *
	                  (1 + response.data.utipreciomaxi / 100);
	                precio = Math.round(precio * 100) / 100;
	                 montoiva = (precio * response.data.ivaventa) / 100; */
	              }
	            }
	
	            if (index !== null) {
	              data[index] = {
	                idproducto: response.data.idproducto,
	                codigo: response.data.codigo,
	                cantidad: 1.0,
	                cantidadE: cantie,
	                cantidadEA: parseFloat(response.data.cantidad),
	                nombrecorto: response.data.nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	                precio: precio,
	                preciobs: 0.0,
	                preciomaxi: response.data.preciomaxi,
	                precioofe: response.data.precioofe,
	                preciomayor: response.data.preciomayor,
	                preciomini: response.data.preciomini,
	                preciomaxialter: response.data.preciomaxialter,
	                precioofealter: response.data.precioofealter,
	                preciomayoralter: response.data.preciomayoralter,
	                preciominialter: response.data.preciominialter,
	                iva: response.data.ivaventa,
	                montoiva: montoiva,
	                descuento: 0.0,
	                total: precio,
	                unidad: uni,
	                idunidadmedida: response.data.idunidadmedida,
	                idunidadalterna: response.data.idunidadalterna,
	                precioconiva: (0, _varios.round)(parseFloat(precio * response.data.ivaventa / 100) + parseFloat(precio), 2),
	                /*                costocalculado: response.data.costocalculado,
	                costocalculadoalter: response.data.costocalculadoalter,
	                utipreciomaxi: response.data.utipreciomaxi,
	                utipreciomaxialter: response.data.utipreciomaxialter, */
	                idmoneda: response.data.idmoneda,
	                valormoneda: monedaCambio.valormoneda,
	                tipounidad: tipouni,
	                tipofactor: response.data.tipofactor,
	                valorfactor: response.data.valorfactor,
	                tipoprecio: response.data.tipoprecio
	              };
	            } else {
	              data.push({
	                idproducto: response.data.idproducto,
	                codigo: response.data.codigo,
	                cantidad: 1.0,
	                cantidadE: cantie,
	                cantidadEA: parseFloat(response.data.cantidad),
	                nombrecorto: response.data.nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	                precio: precio,
	                preciomaxi: response.data.preciomaxi,
	                precioofe: response.data.precioofe,
	                preciomayor: response.data.preciomayor,
	                preciomini: response.data.preciomini,
	                preciomaxialter: response.data.preciomaxialter,
	                precioofealter: response.data.precioofealter,
	                preciomayoralter: response.data.preciomayoralter,
	                preciominialter: response.data.preciominialter,
	                preciobs: 0.0,
	                iva: response.data.ivaventa,
	                montoiva: montoiva,
	                descuento: 0.0,
	                total: precio,
	                unidad: uni,
	                idunidadmedida: response.data.idunidadmedida,
	                idunidadalterna: response.data.idunidadalterna,
	                precioconiva: (0, _varios.round)(parseFloat(precio * response.data.ivaventa / 100) + parseFloat(precio), 2),
	                /* costocalculadoalter: response.data.costocalculadoalter,
	                utipreciomaxi: response.data.utipreciomaxi,
	                utipreciomaxialter: response.data.utipreciomaxialter, */
	                idmoneda: response.data.idmoneda,
	                valormoneda: monedaCambio.valormoneda,
	                tipounidad: tipouni,
	                tipofactor: response.data.tipofactor,
	                valorfactor: response.data.valorfactor,
	                tipoprecio: response.data.tipoprecio
	              });
	            }
	            setRecords(data);
	            setTotales((0, _varios.calcularTotales)(data));
	            setIndice(index);
	
	            if (index !== null) {
	              setTimeout(function () {
	                return txtCantidad.current[index].focus();
	              }, 300);
	            } else {
	              setTimeout(function () {
	                return txtCantidad.current[data.length - 1].focus();
	              }, 300);
	            }
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "no existe un producto con ese codigo en el almacen.",
	            icono: "error"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarPedido = function seleccionarPedido() {
	    var campos = "p.*, p.fecha as fechapedido, m.*, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
	    var nomtab = "ordenes as p inner join agente as v on p.idvendedor=v.idagente inner join agente as c on c.idagente=p.idcliente inner join moneda as m on p.idmoneda=m.idmoneda";
	
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=numorden&id=" + txtNumPedido.current.value.trim();
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          if (response.data.status === 1 && operacion === 1) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "El Pedido ya tiene Nota de Entrega asociada.",
	              icono: "informacion"
	            });
	            setActivate(false);
	            txtNumPedido.current.value = "";
	            txtNumPedido.current.focus();
	            return;
	          } else if (response.data.status === 4) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "El Pedido fue Anulado.",
	              icono: "informacion"
	            });
	            setActivate(false);
	          }
	
	          setHabilitarCat(true);
	
	          if (operacion === 1) {
	            setNotaEntrega(Object.assign({}, notaentrega, {
	              idnotaentrega: "0",
	              numnotaentrega: "0000000",
	              idpedido: response.data.idorden,
	              numpedido: response.data.numorden,
	              cedularif: response.data.cedularif,
	              descripcion: "",
	              totalmonto: response.data.totalmonto,
	              totaliva: response.data.totaliva,
	              totaldescuento: response.data.totaldescuento,
	              totalexento: response.data.totalexento,
	              totalsujeto: response.data.totalsujeto,
	              idcliente: response.data.idcliente,
	              idvendedor: response.data.idvendedor,
	              fecha: (0, _moment2.default)(response.data.fechapedido).format("YYYY-MM-DD"),
	              status: response.data.status,
	              idalmacen: response.data.idalmacen,
	              idmoneda: response.data.idmoneda,
	              idoperacioninventario: response.data.idoperacioninventario,
	              fechavencimiento: (0, _moment2.default)(response.data.fechavencimiento).format("YYYY-MM-DD")
	            }));
	
	            setMoneda({
	              idmoneda: response.data.idmoneda,
	              descripcion: response.data.descripcion,
	              simbolo: response.data.simbolo,
	              valormoneda: response.data.valormoneda,
	              predeterminada: response.data.predeterminada,
	              subpredeterminada: response.data.subpredeterminada
	            });
	
	            setCliente({
	              idcliente: response.data.idcliente,
	              tiporif: response.data.tiporifc,
	              rif: response.data.rifc,
	              nombre: response.data.nombrec
	            });
	            cmbRif.current.value = response.data.tiporifc;
	            txtRif.current.value = response.data.rifc;
	            txtNombreC.current.value = response.data.nombrec;
	
	            setVendedor({
	              idvendedor: response.data.idvendedor,
	              tiporif: response.data.tiporifv,
	              rif: response.data.rifv,
	              nombre: response.data.nombrev,
	              idalmacen: response.data.idalmacen
	            });
	
	            txtNumPedido.current.setAttribute("disabled", true);
	            // txtStatus.current.value = response.data.status;
	            txtFecha.current.value = (0, _moment2.default)(response.data.fechapedido).format("YYYY-MM-DD");
	
	            for (var i = 0; i < combomoneda.length; i++) {
	              if (response.data.idmoneda === combomoneda[i].idmoneda) {
	                cmbMoneda.current.selectedIndex = i;
	                break;
	              }
	            }
	            setHabilitadoTip(true);
	            setHabilitadoMod(false);
	            setTimeout(function () {
	              return btnAcepta.current.focus();
	            }, 200);
	            seleccionarDetallePedido(response.data.idorden);
	            setTotales({
	              subtotal: response.data.totalmonto - response.data.totaliva,
	              descuento: response.data.totaldescuento,
	              exento: response.data.totalexento,
	              sujeto: response.data.totalsujeto,
	              iva: 16.0,
	              totaliva: response.data.totaliva,
	              total: response.data.totalmonto
	            });
	          } else {
	            txtNumPedido.current.setAttribute("disabled", true);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "no existe un pedido con ese codigo.",
	            icono: "informacion"
	          });
	          txtNumPedido.current.value = "";
	          txtNumPedido.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarDetallePedido = function seleccionarDetallePedido(id) {
	
	    var endpoint = op.conexion + "/api/inventario/seleccionarordenesdet?id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var prod = [];
	          var uni = [];
	          var montoiva = 0.0;
	          var cantie = 0.0;
	          var cantiea = 0.0;
	          var tipouni = 0;
	          var tiene_iva = false;
	
	          for (var i = 0; i < response.data.length; i++) {
	            if (parseFloat(response.data[i].iva) > 0.0) {
	              tiene_iva = true;
	            }
	            if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) <= 0.0) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni === 'POR DEFINIR' ? "SERVICIO" : response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantiea = Math.trunc(cantiea);
	            } else if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) > 0.0) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni === 'POR DEFINIR' ? "SERVICIO" : response.data[i].descripcionuni,
	                tipo: "medida"
	              }, {
	                idunidad: response.data[i].idunidadalterna,
	                descripcion: response.data[i].descripcionunialt === 'POR DEFINIR' ? "SERVICIO" : response.data[i].descripcionunialt,
	                tipo: "alterna"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) / parseFloat(response.data[i].valorfactor) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) / parseFloat(response.data[i].valorfactor) + parseFloat(response.data[i].cantidad);
	
	              cantiea = cantiea * parseFloat(response.data[i].valorfactor);
	              cantiea = Math.trunc(cantiea);
	            } else if (response.data[i].tipounidad === 1) {
	              tipouni = 1;
	              uni = [{
	                idunidad: response.data[i].idunidadalterna,
	                descripcion: response.data[i].descripcionunialt === 'POR DEFINIR' ? "SERVICIO" : response.data[i].descripcionunialt,
	                tipo: "alterna"
	              }, {
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni === 'POR DEFINIR' ? "SERVICIO" : response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantiea = Math.trunc(cantiea);
	            }
	
	            montoiva = response.data[i].punitario * response.data[i].iva / 100;
	
	            prod.push({
	              idproducto: response.data[i].idproducto,
	              codigo: response.data[i].codproducto,
	              cantidad: response.data[i].cantidad,
	              cantidadE: parseFloat(cantie),
	              cantidadEA: parseFloat(cantiea),
	              nombrecorto: response.data[i].nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	              precio: response.data[i].punitario,
	              preciobs: response.data[i].punitariobs,
	              iva: response.data[i].iva,
	              montoiva: response.data[i].cantidad * (0, _varios.round)(montoiva),
	              precioconiva: (0, _varios.round)(parseFloat(response.data[i].punitario * response.data[i].iva / 100) + parseFloat(response.data[i].punitario), 2),
	              descuento: response.data[i].descuento,
	              total: response.data[i].cantidad * response.data[i].punitario,
	              unidad: uni,
	              idunidadmedida: response.data[i].idunidadmedida,
	              idunidadalterna: response.data[i].idunidadalterna,
	              tipounidad: tipouni,
	              valormoneda: monedaCambio.valormoneda,
	              idmoneda: response.data[i].idmoneda,
	              tipofactor: response.data[i].tipofactor,
	              valorfactor: response.data[i].valorfactor,
	              tipoprecio: response.data[i].tipopreciodeta,
	              idalmacen: response.data[i].idalmacen,
	              valuni: response.data[i].codproducto.substring(0, 4) === 'SERV' ? 1 : 0,
	              servicio: response.data[i].servicio
	            });
	          }
	          setRecords(prod);
	          setSelectpd(1);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarNotaEntrega = function seleccionarNotaEntrega() {
	    var campos = "p.*, p.descripcion as concepto, p.fecha as fechanota, m.*, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
	    var nomtab = "notaentrega as p inner join agente as v on p.idvendedor=v.idagente inner join agente as c on c.idagente=p.idcliente inner join moneda as m on p.idmoneda=m.idmoneda";
	
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=numnotaentrega&id=" + txtNumNotaEntrega.current.value.trim();
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          if (response.data.status === 1 && (operacion === 2 || operacion === 3)) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La Nota de Entrega ya tiene factura asociada.",
	              icono: "informacion"
	            });
	            setActivate(false);
	            txtNumNotaEntrega.current.value = "";
	            txtNumNotaEntrega.current.focus();
	            return;
	          }
	          txtFecha.current.value = (0, _moment2.default)(response.data.fechanota).format("YYYY-MM-DD");
	          txtStatus.current.value = response.data.status;
	          txtNumNotaEntrega.current.setAttribute("disabled", true);
	          cmbRif.current.value = response.data.tiporifc;
	          txtRif.current.value = response.data.rifc;
	          txtNombreC.current.value = response.data.nombrec;
	          txtConcepto.current.value = response.data.concepto;
	
	          for (var i = 0; i < combomoneda.length; i++) {
	            if (response.data.idmoneda === combomoneda[i].idmoneda) {
	              cmbMoneda.current.selectedIndex = i;
	              break;
	            }
	          }
	
	          if (response.data.credito) {
	            cmbTipoPago.current.value = "2";
	            txtFechaVencimiento.current.value = (0, _moment2.default)(response.data.fechavencimiento).format("YYYY-MM-DD");
	            if (operacion === 2) {
	              setSelectd(1);
	            } else {
	              setSelectd(0);
	            }
	          } else {
	            cmbTipoPago.current.value = "1";
	            txtFechaVencimiento.current.value = "";
	            setSelectd(0);
	          }
	
	          if (response.data.tipo === "NE") {
	            cmbTipo.current.value = "1";
	          } else if (response.data.tipo === "NO") {
	            cmbTipo.current.value = "2";
	          }
	
	          if (response.data.numpedido === "" || response.data.numpedido === null) {
	            cmbDesde.current.value = "1";
	            setVisible(0);
	            if (operacion === 2) {
	              setHabilitadoMod(true);
	              setHabilitadoCli(true);
	              setHabilitadoProductos(false);
	              setHabilitarMoneda(true);
	            } else {
	              setHabilitadoMod(false);
	              setHabilitadoCli(false);
	              setHabilitadoProductos(true);
	            }
	          } else {
	            setSelectp(1);
	            cmbDesde.current.value = "2";
	            txtNumPedido.current.value = response.data.numpedido;
	            setVisible(1);
	            seleccionarPedido();
	            setHabilitadoMod(false);
	            setHabilitadoCli(false);
	          }
	          setHabilitarCat(true);
	          setNotaEntrega({
	            idnotaentrega: response.data.idnotaentrega,
	            numnotaentrega: response.data.numnotaentrega,
	            cedularif: response.data.cedularif,
	            descripcion: response.data.descripcion,
	            totalmonto: response.data.totalmonto,
	            totaliva: response.data.totaliva,
	            totaldescuento: response.data.totaldescuento,
	            totalexento: response.data.totalexento,
	            totalsujeto: response.data.totalsujeto,
	            idcliente: response.data.idcliente,
	            idvendedor: response.data.idvendedor,
	            fecha: (0, _moment2.default)(response.data.fechanota).format("YYYY-MM-DD"),
	            status: response.data.status,
	            idalmacen: response.data.idalmacen,
	            idmoneda: response.data.idmoneda,
	            idoperacioninventario: response.data.idoperacioninventario,
	            idpedido: response.data.idpedido,
	            numpedido: response.data.numpedido,
	            tipo: response.data.tipo,
	            credito: response.data.credito,
	            fechavencimiento: (0, _moment2.default)(response.data.fechavencimiento).format("YYYY-MM-DD"),
	            valormoneda: response.data.valormoneda
	          });
	
	          setMoneda({
	            idmoneda: response.data.idmoneda,
	            descripcion: response.data.descripcion,
	            simbolo: response.data.simbolo,
	            valormoneda: response.data.valormoneda,
	            predeterminada: response.data.predeterminada,
	            subpredeterminada: response.data.subpredeterminada
	          });
	
	          setCliente({
	            idcliente: response.data.idcliente,
	            tiporif: response.data.tiporifc,
	            rif: response.data.rifc,
	            nombre: response.data.nombrec
	          });
	
	          setVendedor({
	            idvendedor: response.data.idvendedor,
	            tiporif: response.data.tiporifv,
	            rif: response.data.rifv,
	            nombre: response.data.nombrev,
	            idalmacen: response.data.idalmacen
	          });
	
	          setTotales({
	            subtotal: response.data.totalmonto - response.data.totaliva,
	            descuento: response.data.totaldescuento,
	            exento: response.data.totalexento,
	            sujeto: response.data.totalsujeto,
	            iva: 16.0,
	            totaliva: response.data.totaliva,
	            total: response.data.totalmonto
	          });
	
	          seleccionarDetalleNotaEntrega(response.data.idnotaentrega);
	          setHabilitadoTip(false);
	          if (operacion === 2) {
	            setHabilitado(true);
	            setTimeout(function () {
	              return txtFecha.current.focus();
	            }, 200);
	          } else {
	            setHabilitado(false);
	            setTimeout(function () {
	              return btnCancela.current.focus();
	            }, 200);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "no existe una nota de entrega con ese codigo.",
	            icono: "informacion"
	          });
	          txtNumNotaEntrega.current.value = "";
	          txtNumNotaEntrega.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarDetalleNotaEntrega = function seleccionarDetalleNotaEntrega(idnotaentrega) {
	
	    var endpoint = op.conexion + "/api/inventario/seleccionarnotaentregadetordenes?id=" + idnotaentrega;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var prod = [];
	          var uni = [];
	          var montoiva = 0.0;
	          var cantie = 0.0;
	          var cantiea = 0.0;
	          var tipouni = 0;
	          var tiene_iva = false;
	
	          for (var i = 0; i < response.data.length; i++) {
	            if (parseFloat(response.data[i].iva) > 0.0) {
	              tiene_iva = true;
	            }
	            if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) <= 0.0) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni === 'POR DEFINIR' ? "SERVICIO" : response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantiea = Math.trunc(cantiea);
	            } else if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) > 0.0) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni === 'POR DEFINIR' ? "SERVICIO" : response.data[i].descripcionuni,
	                tipo: "medida"
	              }, {
	                idunidad: response.data[i].idunidadalterna,
	                descripcion: response.data[i].descripcionunialt === 'POR DEFINIR' ? "SERVICIO" : response.data[i].descripcionunialt,
	                tipo: "alterna"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) / parseFloat(response.data[i].valorfactor) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) / parseFloat(response.data[i].valorfactor) + parseFloat(response.data[i].cantidad);
	
	              cantiea = cantiea * parseFloat(response.data[i].valorfactor);
	              cantiea = Math.trunc(cantiea);
	            } else if (response.data[i].tipounidad === 1) {
	              tipouni = 1;
	              uni = [{
	                idunidad: response.data[i].idunidadalterna,
	                descripcion: response.data[i].descripcionunialt === 'POR DEFINIR' ? "SERVICIO" : response.data[i].descripcionunialt,
	                tipo: "alterna"
	              }, {
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni === 'POR DEFINIR' ? "SERVICIO" : response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantiea = Math.trunc(cantiea);
	            }
	
	            montoiva = parseFloat(response.data[i].punitario) * parseFloat(response.data[i].iva) / 100;
	
	            prod.push({
	              idproducto: response.data[i].idproducto,
	              codigo: response.data[i].codproducto,
	              cantidad: response.data[i].cantidad,
	              cantidadE: parseFloat(cantie),
	              cantidadEA: parseFloat(cantiea),
	              nombrecorto: response.data[i].nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	              precio: response.data[i].punitario,
	              preciobs: response.data[i].punitariobs,
	              preciomaxi: response.data[i].preciomaxi,
	              precioofe: response.data[i].precioofe,
	              preciomayor: response.data[i].preciomayor,
	              preciomini: response.data[i].preciomini,
	              preciomaxialter: response.data[i].preciomaxialter,
	              precioofealter: response.data[i].precioofealter,
	              preciomayoralter: response.data[i].preciomayoralter,
	              preciominialter: response.data[i].preciominialter,
	              iva: response.data[i].iva,
	              ivaventa: response.data[i].ivaventa,
	              montoiva: (0, _varios.round)(montoiva, 2) * response.data[i].cantidad,
	              precioconiva: (0, _varios.round)(parseFloat(response.data[i].punitario * response.data[i].ivaventa / 100) + parseFloat(response.data[i].punitario), 2),
	              descuento: response.data[i].descuento,
	              total: response.data[i].cantidad * response.data[i].punitario,
	              unidad: uni,
	              idunidadmedida: response.data[i].idunidadmedida,
	              idunidadalterna: response.data[i].idunidadalterna,
	              costocalculado: response.data[i].costocalculado,
	              costocalculadoalter: response.data[i].costocalculadoalter,
	              utipreciomaxi: response.data[i].utipreciomaxi,
	              utipreciomaxialter: response.data[i].utipreciomaxialter,
	              tipounidad: tipouni,
	              valormoneda: monedaCambio.valormoneda,
	              idmoneda: response.data[i].idmoneda,
	              tipofactor: response.data[i].tipofactor,
	              valorfactor: response.data[i].valorfactor,
	              tipoprecio: response.data[i].tipopreciodeta
	            });
	          }
	          setRecords(prod);
	          setSelectpd(1);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/inventario/actualizarnotaentrega/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idnotaent + " creado correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idnotaent + " modificado correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idnotaent + " eliminado correctamente",
	            icono: "exito"
	          });
	        }
	      }
	    }).catch(function (error) {
	      var mensaje = error.response.data.message;
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	    }).finally(function () {
	      return setActivate(false);
	    });
	  };
	
	  var validarCliente = function validarCliente(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (cmbRif.current.value !== "" && event.target.value !== "") {
	        var rif = cmbRif.current.value + event.target.value;
	        seleccionarCliente(rif, event.which);
	      }
	    }
	  };
	
	  var validarCantidadP = function validarCantidadP(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        var cantidades = (0, _varios.validarCantidad)({
	          index: index,
	          event: event,
	          productos: records
	        });
	        if (event.which === 13) {
	          if (index < cantidades.data.length - 1) {
	            setTimeout(function () {
	              return txtCantidad.current[index + 1].focus();
	            }, 300);
	          }
	        }
	        setMensaje(cantidades.msm);
	        setRecords(cantidades.data);
	        setTotales(cantidades.totales);
	      }
	    };
	  };
	
	  var validarIdProducto = function validarIdProducto(index) {
	    return function (event) {
	      if (event.which === 13 || typeof event.which === "undefined") {
	        if (event.target.value !== "") {
	          if (vendedor.idalmacen !== "" && vendedor.idalmacen !== null) {
	            seleccionarProducto(index, vendedor.idalmacen, event.target.value);
	          } else {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación.",
	              texto: "debe seleccionar un vendedor.",
	              icono: "informacion"
	            });
	          }
	        }
	      }
	    };
	  };
	
	  var onCatalogoCliente = function onCatalogoCliente(values) {
	    setCatalogoCliente(false);
	    txtNombreC.current.value = values.nombre;
	    cmbRif.current.value = values.rif.substring(0, 1);
	    txtRif.current.value = values.rif.substring(1);
	    setCliente({
	      idcliente: values.idagente,
	      tiporif: values.rif.substring(0, 1),
	      rif: values.rif.substring(1),
	      nombre: values.nombre
	    });
	  };
	
	  var onCatalogoOrdenes = function onCatalogoOrdenes(values) {
	    setCatalogoPedido(false);
	    txtNumPedido.current.value = values.numorden;
	    seleccionarPedido();
	  };
	
	  var onCatalogoNotaEntrega = function onCatalogoNotaEntrega(values) {
	    setCatalogoNota(false);
	    txtNumNotaEntrega.current.value = values.numnotaentrega;
	    seleccionarNotaEntrega();
	  };
	
	  var agregarProducto = function agregarProducto(producto) {
	    seleccionarProducto(indice, vendedor.idalmacen, producto.codigo);
	    setMostrar(false);
	  };
	
	  var seleccionarxIndice = function seleccionarxIndice(index) {
	    return function (e) {
	      e.preventDefault();
	      if (vendedor.idalmacen !== "" && vendedor.idalmacen !== null) {
	        setMostrar(true);
	        setIndice(index);
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación.",
	          texto: "debe seleccionar un vendedor.",
	          icono: "informacion"
	        });
	      }
	    };
	  };
	
	  var eliminarProducto = function eliminarProducto(producto) {
	    return function (e) {
	      e.preventDefault();
	      var data = [].concat(_toConsumableArray(records));
	      var elementos = [];
	
	      for (var i = 0; i < data.length; i++) {
	        if (producto.idproducto !== data[i].idproducto) {
	          elementos.push(data[i]);
	        }
	      }
	      setRecords(elementos);
	      setTotales((0, _varios.calcularTotales)(elementos));
	    };
	  };
	
	  var onChangeMoneda = function onChangeMoneda(e) {
	    var i = e.target.value;
	    var cambio = (0, _varios.onCambioMoneda)({
	      moneda: combomoneda[i],
	      productos: records,
	      monedaPre: moneda,
	      monedaSub: monedaSub
	    });
	    setMonedaCambio(cambio.monedacambio);
	    setRecords(cambio.data);
	  };
	
	  var onChangeUnidad = function onChangeUnidad(i) {
	    return function (e) {
	      var cambiounidad = (0, _varios.onCambioUnidadDos)({
	        idunidad: e.target.value,
	        index: i,
	        productos: records
	      });
	
	      setMensaje(cambiounidad.msm);
	      setRecords(cambiounidad.data);
	      setTotales(cambiounidad.totales);
	    };
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	
	    if (txtNumPedido.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "¡ Seleccione la Orden de Servicio/Venta !",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtNumPedido.current.focus();
	    } else if (cmbRif.current.value === "" || txtRif.current.value.trim() === "" || txtNombreC.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Cliente no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtRif.current.focus();
	    } else if (txtFecha.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtFecha.current.focus();
	    } else if (cmbTipoPago.current.value === "2" && txtFechaVencimiento.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha de Vencimiento no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtFechaVencimiento.current.focus();
	    } else if (txtConcepto.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Concepto no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtConcepto.current.focus();
	    } else if (records.length === 0) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "No hay Producto agregados",
	        icono: "informacion"
	      });
	      sigue = false;
	      btnCancela.current.focus();
	    } else if (records.length > 0 && operacion !== 3) {
	      for (var i = 0; i < records.length; i++) {
	        if (notaentrega.numpedido === "" || notaentrega.numpedido === null) {
	          if (records[i].cantidadE === 0.0) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La  cantidad no debe ser mayor a la cantidad existente",
	              icono: "informacion"
	            });
	            sigue = false;
	            btnCancela.current.focus();
	            break;
	          } else if (records[i].cantidadE < records[i].cantidad) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La  cantidad no debe ser mayor a la cantidad existente",
	              icono: "informacion"
	            });
	            sigue = false;
	            btnCancela.current.focus();
	            break;
	          }
	        }
	      }
	    }
	
	    if (sigue) {
	      var notae = [];
	      var notaedet = [];
	      var opeinv = [];
	      var opeinvdet = [];
	
	      notae.push(Object.assign({
	        idnotaentrega: notaentrega.idnotaentrega,
	        numnotaentrega: notaentrega.numnotaentrega
	      }, notaentrega.numpedido !== "" && notaentrega.numpedido !== null && {
	        numpedido: notaentrega.numpedido
	      }, {
	        descripcion: txtConcepto.current.value.toUpperCase().trim() + ' (N°-' + txtNumPedido.current.value.trim() + ')',
	        cedularif: cliente.tiporif + cliente.rif,
	        tipo: notaentrega.tipo,
	        totalmonto: totales.total,
	        totaliva: totales.totaliva,
	        totalexento: totales.exento,
	        totalsujeto: totales.sujeto,
	        totaldescuento: totales.descuento
	      }, notaentrega.idpedido !== "" && notaentrega.idpedido !== null && { idpedido: notaentrega.idpedido }, {
	        idcliente: cliente.idcliente,
	        idvendedor: vendedor.idvendedor,
	        fecha: txtFecha.current.value,
	        status: notaentrega.tipo === "NO" && operacion === 1 ? 1 : notaentrega.status,
	        idalmacen: vendedor.idalmacen,
	        idmoneda: monedaSub.idmoneda,
	        idoperacioninventario: notaentrega.idoperacioninventario === null || notaentrega.idoperacioninventario === "" ? "" : notaentrega.idoperacioninventario,
	        credito: notaentrega.credito,
	        fechavencimiento: notaentrega.credito ? txtFechaVencimiento.current.value : null
	      }));
	
	      opeinv.push({
	        idoperacioninventario: notaentrega.idoperacioninventario === null || notaentrega.idoperacioninventario === "" ? "0" : notaentrega.idoperacioninventario,
	        tipooperacion: "SALIDA",
	        idalmacenorigen: vendedor.idalmacen,
	        idalmacendestino: "",
	        fecha: txtFecha.current.value,
	        idmoneda: monedaSub.idmoneda,
	        observacion: notaentrega.tipo === "NE" ? "NOTA DE ENTREGA DE PRODUCTOS Y SERVICIOS" : "NOTA DE ENTREGA DE PRODUCTOS OBSEQUIO/DONACION"
	      });
	
	      for (var _i = 0; _i < records.length; _i++) {
	        notaedet.push({
	          idproducto: records[_i].idproducto,
	          cantidad: records[_i].cantidad,
	          punitario: records[_i].precio,
	          descuento: "0.00",
	          iva: records[_i].iva,
	          tipounidad: records[_i].tipounidad,
	          idunidadmedida: records[_i].idunidadmedida,
	          idunidadalterna: records[_i].idunidadalterna,
	          tasa: monedaSub.valormoneda,
	          codproducto: records[_i].codigo,
	          costo: records[_i].costocalculado,
	          utilidad: records[_i].utipreciomaxi,
	          tipopreciodeta: records[_i].tipoprecio
	        });
	
	        if (records[_i].servicio === false) {
	          opeinvdet.push({
	            idproducto: records[_i].idproducto,
	            nombre: records[_i].nombre,
	            cantidad: records[_i].cantidad,
	            precio: records[_i].precio,
	            fechavencimiento: "",
	            tipomovimiento: "VENTA",
	            fechatipomovimiento: txtFecha.current.value,
	            numfactura: notaentrega.numnotaentrega,
	            idalmacen: vendedor.idalmacen,
	            tipounidad: records[_i].tipounidad,
	            idunidadmedida: records[_i].idunidadmedida,
	            idunidadalterna: records[_i].idunidadalterna,
	            tipofactor: records[_i].tipofactor,
	            valorfactor: records[_i].valorfactor,
	            tasa: monedaSub.valormoneda
	          });
	        }
	      }
	
	      setBody({
	        notaentre: notae,
	        notaentredet: notaedet,
	        idtipopeinv: "2",
	        opeinv: opeinv,
	        opeinvdet: opeinvdet
	      });
	
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var blanquear = function blanquear() {
	    setTituloHeader("Gestionar Notas de Entrega.");
	    setBody();
	    setActivate(false);
	    setHabilitado(false);
	    setHabilitadoMod(false);
	    setHabilitadoTip(false);
	    setHabilitarMoneda(false);
	    setHabilitadoCli(false);
	    setHabilitadoBot(true);
	    setHabilitarCat(true);
	    setHabilitadoProductos(true);
	    setVisible(0);
	    setSelectp(0);
	    setSelectd(0);
	    setSelectpd(0);
	    setVisibleBtn("visible");
	    setMoneda({
	      idmoneda: "1",
	      descripcion: "BOLIVARES",
	      simbolo: "Bs",
	      predeterminada: false,
	      valormoneda: 1.0
	    });
	    setMonedaCambio({
	      idmoneda: "4",
	      descripcion: "DOLAR",
	      simbolo: "$",
	      predeterminada: false,
	      subpredeterminada: true,
	      valormoneda: 1.0
	    });
	    setRecords([]);
	    for (var i = 0; i < combomoneda.length; i++) {
	      if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
	        cmbMoneda.current.selectedIndex = i;
	      }
	    }
	    cmbDesde.current.value = "2";
	    cmbTipo.current.value = "1";
	    cmbTipoPago.current.value = "1";
	
	    txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	    txtFechaVencimiento.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	    if (operacion !== 1) {
	      txtNumNotaEntrega.current.value = "";
	      txtNumNotaEntrega.current.setAttribute("disabled", true);
	      txtStatus.current.value = "0";
	    }
	
	    cmbRif.current.value = "J";
	    txtRif.current.value = "";
	    txtNombreC.current.value = "";
	    txtConcepto.current.value = "";
	    txtNumPedido.current.value = "";
	    setCliente({
	      idcliente: "",
	      tiporif: "J",
	      rif: "",
	      nombre: ""
	    });
	    setVendedor({
	      idvendedor: "",
	      tiporif: "",
	      rif: "",
	      nombre: "",
	      idalmacen: ""
	    });
	    setOperacion(0);
	    setNotaEntrega({
	      idnotaentrega: "0",
	      numnotaentrega: "000000",
	      cedularif: "",
	      descripcion: "NOTA ENTREGA DE PRODUCTOS Y SERVICIOS N°",
	      totalmonto: 0.0,
	      totaliva: 0.0,
	      totaldescuento: 0.0,
	      totalexento: 0.0,
	      totalsujeto: 0.0,
	      idcliente: "",
	      idvendedor: "",
	      fecha: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	      status: 0,
	      idalmacen: "",
	      idmoneda: "",
	      idoperacioninventario: "",
	      idpedido: "",
	      numpedido: "",
	      tipo: "NE",
	      credito: false,
	      fechavencimiento: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	      valormoneda: 0.0
	    });
	    setTotales({
	      subtotal: 0.0,
	      descuento: 0.0,
	      exento: 0.0,
	      sujeto: 0.0,
	      iva: 16.0,
	      totaliva: 0.0,
	      total: 0.0
	    });
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var handleInputChangeCodigo = function handleInputChangeCodigo(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "idnotaentre") {
	          seleccionarNotaEntrega();
	        } else if (event.target.name === "idpedi") {
	          seleccionarPedido();
	        }
	      }
	    }
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "tipopago") {
	      if (e.target.value === "1") {
	        setSelectd(0);
	        setNotaEntrega(Object.assign({}, notaentrega, {
	          credito: false,
	          fechavencimiento: ""
	        }));
	        txtFechaVencimiento.current.value = "";
	      } else if (e.target.value === "2") {
	        setSelectd(1);
	        setNotaEntrega(Object.assign({}, notaentrega, {
	          credito: true,
	          fechavencimiento: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD")
	        }));
	        txtFechaVencimiento.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	      }
	    } else if (e.target.name === "desde") {
	      if (e.target.value === "2") {
	        setSelectp(1);
	        setVisible(1);
	        setHabilitadoCli(false);
	        setHabilitadoProductos(true);
	      } else if (e.target.value === "1") {
	        setSelectp(0);
	        setVisible(0);
	        setHabilitadoCli(true);
	        setHabilitadoProductos(false);
	      }
	    } else if (e.target.name === "tipo") {
	      if (e.target.value === "1") {
	        setNotaEntrega(Object.assign({}, notaentrega, { tipo: "NE" }));
	      } else if (e.target.value === "2") {
	        setNotaEntrega(Object.assign({}, notaentrega, { tipo: "NO" }));
	      }
	    } else if (e.target.name === "fecha") {
	      setNotaEntrega(Object.assign({}, notaentrega, { fecha: e.target.value }));
	    } else if (e.target.name === "descripcion") {
	      setNotaEntrega(Object.assign({}, notaentrega, { descripcion: e.target.value }));
	    } else if (e.target.name === "fechavencimiento") {
	      setNotaEntrega(Object.assign({}, notaentrega, { fechavencimiento: e.target.value }));
	    }
	  };
	
	  var imprimirNotaEntrega = function imprimirNotaEntrega() {
	    if (accbtnnentrega && accbtnnentrega.toString().substring(4, 5) === "1") {
	      var debt = 0;
	      if (txtNumNotaEntrega.current.value !== "") {
	        var idnot = notaentrega.idnotaentrega;
	
	        var nota = JSON.parse(sessionStorage.getItem("tiporepnotaentrega"));
	        console.log(nota);
	        var reporte = nota.toString() === 'HOJA' ? "ReportNotaEntrega" : "ReportNotaEntregaMedium";
	
	        window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&idnota=" + idnot, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Seleccione la nota de Entrega !",
	          icono: "informacion"
	        });
	        debt = 1;
	      }
	
	      if (debt === 1) {
	        txtNumNotaEntrega.current.focus();
	      }
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (accbtnnentrega && accbtnnentrega.toString().substring(0, 1) === "1") {
	          setTituloHeader("Incluir Nota de Entrega.");
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          setHabilitadoTip(true);
	          setHabilitadoMod(true);
	          setHabilitado(true);
	          setHabilitadoCli(true);
	          setHabilitadoProductos(false);
	          setHabilitarMoneda(true);
	          setCatalogoPedido(true);
	          seleccionarVendedor(idVendedor);
	          setHabilitarCat(true);
	          cmbTipo.current.selectedIndex = 0;
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          txtConcepto.current.value = "NOTA DE ENTREGA DE PRODUCTOS Y SERVICIOS";
	          setTimeout(function () {
	            return txtRif.current.focus();
	          }, 300);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (accbtnnentrega && accbtnnentrega.toString().substring(1, 2) === "1") {
	          setTituloHeader("Editar Nota de Entrega.");
	          setOperacion(op);
	          txtNumNotaEntrega.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitadoBot(false);
	          setCatalogoPedido(true);
	          setVisibleBtn("hidden");
	          txtNumNotaEntrega.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (accbtnnentrega && accbtnnentrega.toString().substring(3, 4) === "1") {
	          setTituloHeader("Eliminar Nota de Entrega.");
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          txtNumNotaEntrega.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitadoTip(false);
	          setHabilitarMoneda(false);
	          setHabilitadoMod(false);
	          setHabilitado(false);
	          setHabilitadoCli(false);
	          setHabilitadoProductos(true);
	          txtNumNotaEntrega.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (accbtnnentrega && accbtnnentrega.toString().substring(2, 3) === "1") {
	          setTituloHeader("Consultar Nota de Entrega.");
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          txtNumNotaEntrega.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitado(false);
	          setHabilitadoTip(false);
	          setHabilitarMoneda(true);
	          setHabilitadoMod(false);
	          setHabilitadoCli(false);
	          setHabilitadoProductos(true);
	          txtNumNotaEntrega.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        blanquear();
	      }
	    };
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarMonedas();
	  }, []);
	
	  var onCancelaCat = function onCancelaCat() {
	    setCatalogoPedido(false);
	    setTimeout(function () {
	      return txtNumPedido.current.focus();
	    }, 300);
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 ", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-11 mx-auto py-2 card shadow" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row border-azul mx-auto rounded py-1" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-2 azulGradiant shadow text-light justify-content-between" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-4" },
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  tituloHeader
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 d-flex justify-content-end" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "/inicio", className: "text-light " },
	                  _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "fw-bold" },
	                    "Salir"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row mx-auto mb-1" },
	              operacion !== 1 && _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col-pd-290 mb-3 px-1",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CODIGO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    autoComplete: "off",
	                    ref: txtNumNotaEntrega,
	                    name: "idnotaentre",
	                    onKeyUp: handleInputChangeCodigo,
	                    onBlur: handleInputChangeCodigo,
	                    onChange: function onChange(e) {
	                      return e.target.value = e.target.value.toUpperCase();
	                    },
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: habilitarCat,
	                      type: "button",
	                      onClick: function onClick() {
	                        return setCatalogoNota(true);
	                      },
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                )
	              ),
	              operacion !== 1 ? _react2.default.createElement("div", { className: "col-pd-27" }) : "",
	              operacion !== 1 && _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col-pd-230 mb-3 px-1",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "ESTATUS:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: txtStatus,
	                      style: {
	                        fontWeight: "bold",
	                        color: notaentrega.status === 0 ? "#007bff" : notaentrega.status === 1 ? "#28a745" : notaentrega.status === 4 ? "#dc3545" : "#000000"
	                      },
	                      disabled: true,
	                      className: "form-select form-select-sm text-uppercase px-1",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "0" },
	                      "PENDIENTE"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "PROCESADO"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "4" },
	                      "ANULADO"
	                    )
	                  )
	                )
	              ),
	              operacion !== 1 ? _react2.default.createElement("div", { className: "col-pd-88" }) : "",
	              _react2.default.createElement(
	                "div",
	                { className: "colfull col-pd-290 mb-3 px-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSizeAdjust: "0.6" }
	                    },
	                    "TIPO MONEDA:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-control form-control-sm fw-bold text-center",
	                      disabled: !habilitarMoneda,
	                      ref: cmbMoneda,
	                      onChange: onChangeMoneda
	                    },
	                    combomoneda && combomoneda.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: index },
	                        " ",
	                        item.descripcion + " " + item.simbolo + " " + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                        " "
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-220 ml-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSizeAdjust: "0.6" }
	                    },
	                    "FECHA:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "date",
	                    disabled: !habilitado,
	                    ref: txtFecha,
	                    name: "fecha",
	                    onChange: onChange,
	                    className: "form-control fs-6 text-uppercase",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 row mx-auto mb-2",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col-pd-230 mr-auto px-1",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      disabled: !habilitadoTip,
	                      ref: cmbTipo,
	                      onChange: onChange,
	                      className: "form-select form-select-sm fz-06",
	                      "aria-label": ".form-select-sm example",
	                      name: "tipo",
	                      id: "tipo"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "VENTA"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col-pd-300 mr-auto px-1",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "DESDE:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      disabled: !habilitadoTip,
	                      ref: cmbDesde,
	                      onChange: onChange,
	                      className: "form-select form-select-sm fz-06",
	                      "aria-label": ".form-select-sm example",
	                      name: "desde",
	                      id: "desde"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "2" },
	                      "ORDEN-(SERVICIO/VENTA)"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col290 mr-auto px-1",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "ORDEN:"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    disabled: !habilitado,
	                    ref: txtNumPedido,
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    name: "idpedi",
	                    onKeyUp: handleInputChangeCodigo,
	                    onBlur: handleInputChangeCodigo,
	                    onChange: function onChange(e) {
	                      return e.target.value = e.target.value.toUpperCase();
	                    }
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      type: "button",
	                      disabled: !habilitadoTip,
	                      onClick: function onClick() {
	                        return setCatalogoPedido(true);
	                      },
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col-pd-230 mr-auto px-1",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO PAGO:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      disabled: !habilitadoTip,
	                      ref: cmbTipoPago,
	                      onChange: onChange,
	                      className: "form-select form-select-sm fz-06",
	                      "aria-label": ".form-select-sm example",
	                      name: "tipopago",
	                      id: "tipopago"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "CONTADO"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "2" },
	                      "CREDITO"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-340 ml-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA DE VENCIMIENTO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: selectd === 1 ? false : true,
	                    type: "date",
	                    name: "fechavencimiento",
	                    id: "fechavencimiento",
	                    ref: txtFechaVencimiento,
	                    onChange: onChange,
	                    className: "form-control text-uppercase fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "fieldset",
	              {
	                className: "row colfull1070 col-sm-6 mx-auto border-azul rounded mb-1",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "legend",
	                {
	                  className: "float-none m-0 w-auto fw-bold text-black",
	                  style: { fontSize: "1rem" }
	                },
	                "Datos del Cliente"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-pd-320 px-2" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text fw-bold text-black",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "CEDULA/RIF:",
	                  " "
	                ),
	                _react2.default.createElement(
	                  "select",
	                  {
	                    ref: cmbRif,
	                    name: "cmbrif",
	                    disabled: !habilitadoCli,
	                    className: "form-select form-select-sm col-md-3 text-center",
	                    "aria-label": ".form-select-sm example"
	                  },
	                  _varios.cmbCedula.map(function (item, index) {
	                    return _react2.default.createElement(
	                      "option",
	                      { key: index, value: item.value },
	                      item.value
	                    );
	                  })
	                ),
	                _react2.default.createElement("input", {
	                  ref: txtRif,
	                  autoComplete: "off",
	                  disabled: !habilitadoCli,
	                  maxLength: 9,
	                  type: "text",
	                  className: "form-control fs-6",
	                  name: "cedula",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  onKeyUp: validarCliente,
	                  onBlur: validarCliente
	                }),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: !habilitadoCli,
	                    type: "button",
	                    onClick: function onClick() {
	                      return setCatalogoCliente(true);
	                    },
	                    className: "btn btn-success",
	                    style: {
	                      visibility: visible === 0 ? "visible" : "hidden"
	                    }
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-search" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-md-12" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text fw-bold text-black",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "NOMBRE:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  ref: txtNombreC,
	                  className: "form-control fs-6",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "fieldset",
	              {
	                className: "row colfull1070 col-sm-6 mx-auto border-azul rounded mb-1",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "legend",
	                {
	                  className: "float-none m-0 w-auto fw-bold text-black",
	                  style: { fontSize: "1rem" }
	                },
	                "Datos del Vendedor"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-md-5" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text fw-bold text-black",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "CEDULA/RIF:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  className: "form-control fs-6",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  value: vendedor.tiporif + vendedor.rif
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-md-12" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text fw-bold text-black",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "NOMBRE:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  className: "form-control fs-6",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  value: vendedor.nombre
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group input-group-sm mb-2 col-md-12" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "CONCEPTO:"
	              ),
	              _react2.default.createElement("textarea", {
	                className: "form-control uppercase fs-6",
	                ref: txtConcepto,
	                name: "descripcion",
	                onChange: onChange,
	                disabled: !habilitado,
	                "aria-label": "With textarea",
	                style: { minHeight: 50 },
	                defaultValue: ""
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 border-azul px-0 rounded",
	                style: { backgroundColor: "#d5e9ff" }
	              },
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 190,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px",
	                    fontSizeAdjust: "0.6"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden" },
	                  records && records.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      { key: index, style: { padding: "0" } },
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "bg-light d-flex align-items-between px-0",
	                          style: { maxWidth: "500px" }
	                        },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          style: {
	                            borderBottomRightRadius: 0,
	                            borderTopRightRadius: 0
	                          },
	                          disabled: habilitadoProductos,
	                          ref: function ref(el) {
	                            return txtId.current[index] = el;
	                          },
	                          className: "form-control form-control-sm bg-light fs-6 col-pd-110",
	                          defaultValue: item.codigo,
	                          onChange: function onChange(e) {
	                            return e.target.value = e.target.value.toUpperCase();
	                          },
	                          onKeyUp: validarIdProducto(index),
	                          onBlur: validarIdProducto(index)
	                        }),
	                        (operacion === 1 || operacion === 2 || notaentrega.numpedido !== "") && _react2.default.createElement(
	                          "button",
	                          {
	                            type: "button",
	                            style: {
	                              borderBottomLeftRadius: 0,
	                              borderTopLeftRadius: 0
	                            },
	                            disabled: habilitadoProductos,
	                            onClick: seleccionarxIndice(index),
	                            className: "btn btn-sm btn-primary"
	                          },
	                          _react2.default.createElement(
	                            "i",
	                            { className: "fas " },
	                            "-"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-start p-0 pl-2"
	                        },
	                        item.nombrecorto
	                      ),
	                      operacion === 4 ? "" : _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-end p-0 pr-2 col-pd-90" },
	                        (0, _varios.formatMoneda)(item.cantidadE.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-center p-0 col-pd-90" },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control form-control-sm bg-light text-right fs-6",
	                          id: "cantidad",
	                          disabled: !habilitadoMod,
	                          defaultValue: (0, _varios.formatMoneda)(item.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtCantidad.current[index] = el;
	                          },
	                          onFocus: _varios.seleccionarCampo,
	                          onKeyUp: validarCantidadP(index),
	                          onBlur: validarCantidadP(index),
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-end p-0 pr-2 col-pd-110" },
	                        (0, _varios.formatMoneda)((item.precio * item.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-end p-0 pr-2 col-pd-100" },
	                        (0, _varios.formatMoneda)(item.iva.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-end p-0 pr-2 col-pd-120" },
	                        (0, _varios.formatMoneda)((item.montoiva * item.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light p-0 col-pd-100" },
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            className: "form-control form-control-sm fs-6 text-center",
	                            style: { width: "100%" },
	                            disabled: habilitadoProductos === false && item.valuni === 1 ? true : habilitadoProductos,
	                            onChange: onChangeUnidad(index)
	                          },
	                          item.unidad && item.unidad.map(function (item2, x) {
	                            return _react2.default.createElement(
	                              "option",
	                              { key: x, value: item2.idunidad },
	                              " ",
	                              item2.descripcion,
	                              " "
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-end p-0 pr-2 col-pd-130" },
	                        (0, _varios.formatMoneda)((item.total + item.montoiva * item.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      operacion !== 4 && operacion !== 3 && _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-center p-0",
	                          style: { width: "30px" }
	                        },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            disabled: habilitadoProductos,
	                            style: {
	                              visibility: (operacion === 4 || operacion === 3) && "collapse"
	                            },
	                            onClick: eliminarProducto(item),
	                            className: "btn btn-sm btn-danger"
	                          },
	                          _react2.default.createElement("i", { className: "fa fa-trash" }),
	                          " "
	                        )
	                      )
	                    );
	                  }),
	                  selectpd === 1 ? _react2.default.createElement(
	                    _core.TableRow,
	                    {
	                      style: {
	                        padding: "0",
	                        visibility: (operacion === 4 || operacion === 0 || operacion === 3) && "collapse"
	                      }
	                    },
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      {
	                        className: "align-middle bg-light text-center p-0 d-flex",
	                        style: { maxWidth: "500px" }
	                      },
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        disabled: habilitadoProductos,
	                        ref: txtIdproducto,
	                        style: {
	                          borderBottomRightRadius: 0,
	                          borderTopRightRadius: 0
	                        },
	                        className: "form-control form-control-sm bg-light text-right fs-6 col-pd-110",
	                        onChange: function onChange(e) {
	                          return e.target.value = e.target.value.toUpperCase();
	                        },
	                        onKeyUp: validarIdProducto(null),
	                        onBlur: validarIdProducto(null)
	                      }),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          disabled: habilitadoProductos,
	                          style: {
	                            borderBottomLeftRadius: 0,
	                            borderTopLeftRadius: 0
	                          },
	                          onClick: function onClick() {
	                            return setMostrar(true);
	                          },
	                          className: "btn btn-sm btn-primary"
	                        },
	                        _react2.default.createElement(
	                          "i",
	                          { className: "fas " },
	                          "-"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(_core.TableCell, { className: "align-middle bg-light text-start p-0 pl-2" }),
	                    operacion === 4 ? "" : _react2.default.createElement(_core.TableCell, { className: "align-middle bg-light text-end p-0 pr-2 col-pd-90" }),
	                    _react2.default.createElement(_core.TableCell, { className: "align-middle bg-light text-center p-0 col-pd-110" }),
	                    _react2.default.createElement(_core.TableCell, { className: "align-middle bg-light text-end p-0 pr-2 col-pd-110" }),
	                    _react2.default.createElement(_core.TableCell, { className: "align-middle bg-light text-end p-0 pr-2 col-pd-100" }),
	                    _react2.default.createElement(_core.TableCell, { className: "align-middle bg-light p-0 col-pd-120" }),
	                    _react2.default.createElement(_core.TableCell, { className: "align-middle bg-light p-0 col-pd-110" }),
	                    _react2.default.createElement(_core.TableCell, { className: "align-middle bg-light text-end p-0 col-pd-130" }),
	                    operacion === 4 ? "" : _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light text-center p-0",
	                      style: { width: "20px" }
	                    })
	                  ) : ''
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row m-0 px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-8 py-1 mt-auto" },
	                visibleBtn === "visible" ? _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-520" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 row m-0" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: !habilitadoBot,
	                        ref: btnIncluir,
	                        onClick: onBotones(1),
	                        className: "btn btn-sm col ml-1 mb-1 btn-primary rounded-pill",
	                        title: "Incluir Nota de Entrega"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-plus" },
	                        " Incluir "
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: !habilitadoBot,
	                        ref: btnConsultar,
	                        onClick: onBotones(4),
	                        className: "btn btn-sm col ml-1 mb-1 btn-info rounded-pill",
	                        title: "Consultar Nota de Entrega"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-eye" },
	                        " Consultar"
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: !habilitadoBot,
	                        ref: btnEditar,
	                        onClick: onBotones(2),
	                        className: "btn btn-sm col ml-1 mb-1 btn-warning rounded-pill",
	                        title: "Modificar Nota de Entrega"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fa fa-edit" },
	                        " Modificar"
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: !habilitadoBot,
	                        ref: btnEliminar,
	                        onClick: onBotones(3),
	                        className: "btn btn-sm col ml-1 mb-1 btn-danger rounded-pill",
	                        title: "Eliminar Nota de Entrega"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fa fa-trash" },
	                        " Eliminar"
	                      ),
	                      " "
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-350 row m-0 ml-auto" },
	                  operacion === 4 ? _react2.default.createElement(
	                    "button",
	                    {
	                      onClick: imprimirNotaEntrega,
	                      disabled: operacion === 4 ? false : true,
	                      className: "btn btn-sm col ml-1 btn-primary rounded-pill",
	                      title: "Imprimir Nota de Entrega"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-print" },
	                      " Imprimir"
	                    )
	                  ) : _react2.default.createElement("dvi", { className: "col-pd-110" }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnAcepta,
	                      disabled: operacion === 4 ? true : habilitadoBot,
	                      onClick: onBotones(5),
	                      className: "btn btn-sm rounded-pill btn-success col mx-1"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-check-circle" },
	                      " Aceptar"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnCancela,
	                      disabled: habilitadoBot,
	                      onClick: onBotones(6),
	                      className: "btn btn-sm rounded-pill btn-danger col"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-window-close" },
	                      " Cancelar"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-md-4 border-azul rounded shadow",
	                  style: { backgroundColor: "#dbeeff" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "SUBTOTAL ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtSubTotal,
	                    value: (0, _varios.formatMoneda)((totales.subtotal * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "EXENTO ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtExentoTotal,
	                    value: (0, _varios.formatMoneda)((totales.exento * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "DESCUENTO ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtDescuento,
	                    value: (0, _varios.formatMoneda)((totales.descuento * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "IVA Sobre(",
	                    (0, _varios.formatMoneda)(totales.iva.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    "%) ",
	                    monedaCambio.simbolo,
	                    ":",
	                    " ",
	                    (0, _varios.formatMoneda)((totales.sujeto * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtTotIva,
	                    value: (0, _varios.formatMoneda)((totales.totaliva * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "TOTAL ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtTotal,
	                    value: (0, _varios.formatMoneda)((totales.total * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoProductoExistencia2.default, {
	      show: mostrar,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar(false);
	      },
	      onHideAceptaCatalogo: agregarProducto,
	      idalmacen: vendedor.idalmacen
	    }),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: catalogoCliente,
	      nomid: "cliente",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoCliente(false);
	      },
	      onHideAceptaCatalogo: onCatalogoCliente
	    }),
	    _react2.default.createElement(_catalogoNotaEntrega2.default, {
	      show: catalogoNota,
	      nomid: "notaentrega",
	      tip: "NE",
	      val: 'ORDEN',
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoNota(false);
	      },
	      onHideAceptaCatalogo: onCatalogoNotaEntrega,
	      condicion: "true"
	    }),
	    _react2.default.createElement(_catalogoOrdenes2.default, {
	      show: catalogoPedido,
	      onHideCancelar: onCancelaCat,
	      onHideAceptaCatalogo: onCatalogoOrdenes
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return mensaje.titulo === "Exito." ? blanquear() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = TablaNotaEntregaServicios;

/***/ },
/* 7147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _core = __webpack_require__(19);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _catalogoProducto = __webpack_require__(104);
	
	var _catalogoProducto2 = _interopRequireDefault(_catalogoProducto);
	
	var _catalogoOrdenes = __webpack_require__(293);
	
	var _catalogoOrdenes2 = _interopRequireDefault(_catalogoOrdenes);
	
	var _catalogoAgregarClientes = __webpack_require__(7019);
	
	var _catalogoAgregarClientes2 = _interopRequireDefault(_catalogoAgregarClientes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var TablaOrdenServicios = function TablaOrdenServicios() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var organizacion = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var idagente = JSON.parse(sessionStorage.getItem("idagente"));
	  var fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var ordservicios = JSON.parse(sessionStorage.getItem("ordserviciosc"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var txtNombreCliente = (0, _react.useRef)();
	  var txtDescuento = (0, _react.useRef)();
	  var txtSubTotal = (0, _react.useRef)();
	  var txtTotalIva = (0, _react.useRef)();
	  var txtExentoTotal = (0, _react.useRef)();
	  var txtTotal = (0, _react.useRef)();
	  var txtDirClient = (0, _react.useRef)();
	  var txtCedRifv = (0, _react.useRef)();
	  var txtNombreVendedor = (0, _react.useRef)();
	  var txtCantidad = (0, _react.useRef)([]);
	  var txtPrecio = (0, _react.useRef)([]);
	  var txtId = (0, _react.useRef)([]);
	  var txtIdalmacen = (0, _react.useRef)();
	  var txtCedRif = (0, _react.useRef)();
	  var txtCodigo = (0, _react.useRef)();
	  var txtNumPresupuesto = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtFechaVencimiento = (0, _react.useRef)();
	  var txtIdmovil = (0, _react.useRef)();
	  var txtIdmoneda = (0, _react.useRef)();
	  var txtTipoOrdenCompra = (0, _react.useRef)();
	  var txtFormaPago = (0, _react.useRef)();
	  var txtOpeInventario = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(""),
	      _useState2 = _slicedToArray(_useState, 2),
	      idCliente = _useState2[0],
	      setIdCliente = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(""),
	      _useState4 = _slicedToArray(_useState3, 2),
	      idVendedor = _useState4[0],
	      setIdVendedor = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(true),
	      _useState6 = _slicedToArray(_useState5, 2),
	      habilitarCat = _useState6[0],
	      setHabilitarCat = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      desde = _useState8[0],
	      setDesde = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      catalogoPresu = _useState10[0],
	      setCatalogoPresu = _useState10[1];
	
	  var _useState11 = (0, _react.useState)("Orden de Venta."),
	      _useState12 = _slicedToArray(_useState11, 2),
	      tituloHeader = _useState12[0],
	      setTituloHeader = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(""),
	      _useState14 = _slicedToArray(_useState13, 2),
	      numNota = _useState14[0],
	      setNumNota = _useState14[1];
	
	  var _useState15 = (0, _react.useState)("visible"),
	      _useState16 = _slicedToArray(_useState15, 2),
	      visibleBtn = _useState16[0],
	      setVisibleBtn = _useState16[1];
	
	  var _useState17 = (0, _react.useState)("0"),
	      _useState18 = _slicedToArray(_useState17, 2),
	      numval = _useState18[0],
	      setNumval = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(true),
	      _useState20 = _slicedToArray(_useState19, 2),
	      habilitadoProductos = _useState20[0],
	      setHabilitadoProductos = _useState20[1];
	
	  var _useState21 = (0, _react.useState)([]),
	      _useState22 = _slicedToArray(_useState21, 2),
	      records = _useState22[0],
	      setRecords = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(false),
	      _useState24 = _slicedToArray(_useState23, 2),
	      mostrar = _useState24[0],
	      setMostrar = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(true),
	      _useState26 = _slicedToArray(_useState25, 2),
	      habilitado = _useState26[0],
	      setHabilitado = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(null),
	      _useState28 = _slicedToArray(_useState27, 2),
	      indice = _useState28[0],
	      setIndice = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(null),
	      _useState30 = _slicedToArray(_useState29, 2),
	      body = _useState30[0],
	      setBody = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(false),
	      _useState32 = _slicedToArray(_useState31, 2),
	      catregistrarcliente = _useState32[0],
	      setCatregistrarcliente = _useState32[1];
	
	  var _useState33 = (0, _react.useState)([]),
	      _useState34 = _slicedToArray(_useState33, 2),
	      combomoneda = _useState34[0],
	      setComboMoneda = _useState34[1];
	
	  var _useState35 = (0, _react.useState)([]),
	      _useState36 = _slicedToArray(_useState35, 2),
	      almacen = _useState36[0],
	      setAlmacen = _useState36[1];
	
	  var _useState37 = (0, _react.useState)([]),
	      _useState38 = _slicedToArray(_useState37, 2),
	      moviles = _useState38[0],
	      setMoviles = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(false),
	      _useState40 = _slicedToArray(_useState39, 2),
	      catalogoCliente = _useState40[0],
	      setCatalogoCliente = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(""),
	      _useState42 = _slicedToArray(_useState41, 2),
	      valparametro = _useState42[0],
	      setValparametro = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      mensaje = _useState44[0],
	      setMensaje = _useState44[1];
	
	  var _useState45 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState46 = _slicedToArray(_useState45, 2),
	      mensajesino = _useState46[0],
	      setMensajesino = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(0),
	      _useState48 = _slicedToArray(_useState47, 2),
	      fechav = _useState48[0],
	      setFechav = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(false),
	      _useState50 = _slicedToArray(_useState49, 2),
	      activate = _useState50[0],
	      setActivate = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(true),
	      _useState52 = _slicedToArray(_useState51, 2),
	      castabla = _useState52[0],
	      setCastabla = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(true),
	      _useState54 = _slicedToArray(_useState53, 2),
	      esmovil = _useState54[0],
	      setEsmovil = _useState54[1];
	
	  var _useState55 = (0, _react.useState)({
	    idmoneda: "1",
	    descripcion: "BOLIVARES",
	    simbolo: "Bs",
	    predeterminada: true,
	    subpredeterminada: false,
	    valormoneda: 1.0
	  }),
	      _useState56 = _slicedToArray(_useState55, 2),
	      moneda = _useState56[0],
	      setMoneda = _useState56[1];
	
	  var _useState57 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState58 = _slicedToArray(_useState57, 2),
	      monedaSub = _useState58[0],
	      setMonedaSub = _useState58[1];
	
	  var _useState59 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState60 = _slicedToArray(_useState59, 2),
	      monedaCambio = _useState60[0],
	      setMonedaCambio = _useState60[1];
	
	  var _useState61 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    catalogoper: true
	  }),
	      _useState62 = _slicedToArray(_useState61, 2),
	      botones = _useState62[0],
	      setBotones = _useState62[1];
	
	  var _useState63 = (0, _react.useState)(false),
	      _useState64 = _slicedToArray(_useState63, 2),
	      acpt = _useState64[0],
	      setAcpt = _useState64[1];
	
	  var _useState65 = (0, _react.useState)(false),
	      _useState66 = _slicedToArray(_useState65, 2),
	      habilitadoNU = _useState66[0],
	      setHabilitadoNU = _useState66[1];
	
	  var _useState67 = (0, _react.useState)(0),
	      _useState68 = _slicedToArray(_useState67, 2),
	      operacion = _useState68[0],
	      setOperacion = _useState68[1];
	
	  var _useState69 = (0, _react.useState)({
	    idvendedor: "",
	    tiporif: "J",
	    rif: "",
	    nombre: "",
	    idalmacen: ""
	  }),
	      _useState70 = _slicedToArray(_useState69, 2),
	      vendedor = _useState70[0],
	      setVendedor = _useState70[1];
	
	  var _useState71 = (0, _react.useState)({
	    subtotal: 0.0,
	    descuento: 0.0,
	    exento: 0.0,
	    sujeto: 0.0,
	    iva: 16.0,
	    totaliva: 0.0,
	    total: 0.0
	  }),
	      _useState72 = _slicedToArray(_useState71, 2),
	      totales = _useState72[0],
	      setTotales = _useState72[1];
	
	  var nomtabla = void 0;
	
	  if (operacion === 4) {
	    nomtabla = [{ label: "COD-PRODUCTO", textAlign: "center", width: "40px" }, { label: "PRODUCTO", textAlign: "center", width: "100px" }, { label: "CANTIDAD", textAlign: "center", width: "20px" }, { label: "TIPO PRECIO", textAlign: "center", width: "50px" }, { label: "PRECIO UNI.", textAlign: "center", width: "50px" }, { label: "UND. ALT.", textAlign: "center", width: "50px" }, { label: "IVA.", textAlign: "center", width: "50px" }, { label: "MONTO", textAlign: "center", width: "50px" }, {
	      label: "",
	      textAlign: "center",
	      width: "20px"
	    }];
	  } else {
	    nomtabla = [{ label: "COD-PRODUCTO", textAlign: "center", width: "40px" }, { label: "PRODUCTO", textAlign: "center", width: "100px" }, { label: "EXISTENCIA", textAlign: "center", width: "30px" }, { label: "CANTIDAD", textAlign: "center", width: "20px" }, { label: "TIPO PRECIO", textAlign: "center", width: "50px" }, { label: "PRECIO UNI.", textAlign: "center", width: "50px" }, { label: "UND. ALT.", textAlign: "center", width: "50px" }, { label: "IVA.", textAlign: "center", width: "50px" }, { label: "MONTO", textAlign: "center", width: "50px" }, {
	      label: _react2.default.createElement("i", { className: "fas fa-trash" }),
	      textAlign: "center",
	      width: "20px"
	    }];
	  }
	
	  var headCells = nomtabla;
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var seleccionarAgente = function seleccionarAgente() {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "idagente";
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + idagente;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtNombreVendedor.current.value = response.data.nombre;
	          txtCedRifv.current.value = response.data.rif;
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarAlmacen = function seleccionarAlmacen() {
	    var campos = "*";
	    var nomtab = "almacen";
	    var orden = "idalmacen";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setAlmacen(response.data);
	        } else {
	          setAlmacen([]);
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un Almacen de venta",
	            icono: "informacion"
	          });
	          blanquear();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarMoviles = function seleccionarMoviles(id) {
	    var campos = "*";
	    var nomtab = "moviles";
	    var nomid = "idpropietario";
	
	    var endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setMoviles(response.data);
	        } else {
	          setMoviles([]);
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un Almacen de venta",
	            icono: "informacion"
	          });
	          blanquear();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setTituloHeader("Orden de Venta.");
	    setFechav(0);
	    setHabilitadoProductos(true);
	    setAlmacen([]);
	    setMoviles([]);
	    setVendedor({
	      idvendedor: "",
	      tiporif: "J",
	      rif: "",
	      nombre: "",
	      idalmacen: ""
	    });
	    setNumval("0");
	    txtId.current.value = "";
	    txtNombreCliente.current.value = "";
	    txtNombreVendedor.current.value = "";
	    txtCedRif.current.value = "";
	    txtCedRifv.current.value = "";
	    txtDirClient.current.value = "";
	    txtTotal.current.value = "";
	    txtTotalIva.current.value = "";
	    txtSubTotal.current.value = "";
	    txtCodigo.current.value = "";
	    txtFecha.current.value = (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD");
	    txtFormaPago.current.value = "3";
	    txtTipoOrdenCompra.current.value = "1";
	    setActivate(false);
	    setRecords([]);
	    setIndice(null);
	    setAcpt(false);
	    setComboMoneda([]);
	    setHabilitarCat(true);
	    setNumNota("");
	    setVisibleBtn("visible");
	    setCastabla(true);
	    setOperacion(0);
	    setHabilitado(true);
	    setHabilitadoNU(false);
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: false,
	      cancelar: false,
	      catalogo: true,
	      catalogoper: true
	    });
	    setMoneda({
	      idmoneda: "1",
	      descripcion: "BOLIVARES",
	      simbolo: "Bs",
	      predeterminada: false,
	      valormoneda: 1.0
	    });
	    setMonedaCambio({
	      idmoneda: "4",
	      descripcion: "DOLAR",
	      simbolo: "$",
	      predeterminada: false,
	      subpredeterminada: true,
	      valormoneda: 1.0
	    });
	    for (var i = 0; i < combomoneda.length; i++) {
	      if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
	        txtIdmoneda.current.selectedIndex = i;
	      }
	    }
	
	    setTotales({
	      subtotal: 0.0,
	      descuento: 0.0,
	      exento: 0.0,
	      sujeto: 0.0,
	      iva: 16.0,
	      totaliva: 0.0,
	      total: 0.0
	    });
	  };
	
	  var eliminarProducto = function eliminarProducto(producto) {
	    return function (e) {
	      e.preventDefault();
	      var data = [].concat(_toConsumableArray(records));
	      var elementos = [];
	
	      for (var i = 0; i < data.length; i++) {
	        if (producto.idproducto !== data[i].idproducto) {
	          elementos.push(data[i]);
	        }
	      }
	      setRecords(elementos);
	      setTotales((0, _varios.calcularTotales)(elementos));
	    };
	  };
	
	  var onCatalogoCliente = function onCatalogoCliente(values) {
	    setCatalogoCliente(false);
	    if (valparametro === "cliente") {
	      seleccionarProveedor("'" + values.rif + "'", txtNumPresupuesto.current.value.substring(0, 2));
	      setIdCliente(values.idagente);
	    }
	  };
	
	  var onCatalogo = function onCatalogo(val) {
	    if (val === 1) {
	      setValparametro("cliente");
	      setCatalogoCliente(true);
	    }
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	
	    if (txtTipoOrdenCompra.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Tipo de Orden no debe ir Vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtTipoOrdenCompra.current.focus();
	    } else if (txtFormaPago.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Forma de Pago no debe ir Vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtFormaPago.current.focus();
	    } else if (txtCedRif.current.value.trim() === "" || txtNombreCliente.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "Debe seleccionar el Cliente",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtCedRif.current.focus();
	    } /*  else if (txtTipoOrdenCompra.current.value === '2' && txtIdmovil.current.value === "") {
	       setMensaje({
	         mostrar: true,
	         titulo: "Notificación",
	         texto: "¡ Debe seleccionar el Movil !",
	         icono: "informacion",
	       });
	       sigue = false;
	       txtIdmovil.current.focus();
	      } */else if (txtCedRifv.current.value === "" || txtCedRifv.current.value.trim() === "" || txtNombreVendedor.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Debe seleccionar el Vendedor",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtCedRifv.current.focus();
	      } else if (txtFecha.current.value.trim() === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "La Fecha no debe estar vacia",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtFecha.current.focus();
	      } else if (records.length === 0) {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "No hay Producto agregados",
	          icono: "informacion"
	        });
	        sigue = false;
	        btnCancela.current.focus();
	      }
	
	    if (sigue) {
	      var orden = [];
	      var ordendeta = [];
	      var tasa = 0.0;
	      var opeinv = [];
	      var opeinvdet = [];
	
	      tasa = monedaSub.valormoneda;
	
	      orden.push({
	        idorden: operacion === 1 ? 0 : txtCodigo.current.value,
	        numorden: numNota,
	        cedularif: txtCedRif.current.value,
	        descripcion: txtTipoOrdenCompra.current.value === "1" ? "VENTA DE PRODUCTOS" : "ORDEN DE SERVICIO",
	        totalmonto: totales.total,
	        totaliva: totales.totaliva,
	        totaldescuento: totales.descuento,
	        totalsujeto: totales.sujeto,
	        totalexento: totales.exento,
	        idcliente: idCliente,
	        idvendedor: operacion === 1 ? idagente : idVendedor,
	        fecha: txtFecha.current.value,
	        status: 0,
	        idmoneda: monedaSub.idmoneda,
	        idoperacioninventario: operacion === 1 ? 0 : txtOpeInventario.current.value,
	        tipoorden: txtTipoOrdenCompra.current.value,
	        formapago: txtFormaPago.current.value,
	        fechavence: txtFormaPago.current.value === "4" ? txtFechaVencimiento.current.value : null,
	        valormoneda: tasa,
	        idmovil: txtTipoOrdenCompra.current.value === "1" ? null : txtIdmovil.current.value
	      });
	
	      opeinv.push({
	        idoperacioninventario: operacion === 1 ? 0 : txtOpeInventario.current.value,
	        tipooperacion: "SALIDA",
	        idalmacenorigen: txtIdalmacen.current.value === "" ? 0 : txtIdalmacen.current.value,
	        idalmacendestino: "",
	        fecha: txtFecha.current.value,
	        idmoneda: monedaSub.idmoneda,
	        observacion: txtTipoOrdenCompra.current.value === "1" ? "VENTA" : "ORDEN DE SERVICIO"
	      });
	
	      for (var i = 0; i < records.length; i++) {
	        ordendeta.push({
	          idproducto: records[i].idproducto,
	          cantidad: records[i].cantidad,
	          iva: records[i].iva !== null ? records[i].iva : records[i].iva,
	          punitario: records[i].precio,
	          descuento: "0.00",
	          tipounidad: records[i].tipounidad,
	          idunidadmedida: records[i].idunidadmedida,
	          idunidadalterna: records[i].idunidadalterna,
	          tasa: monedaSub.valormoneda,
	          codproducto: records[i].codigo,
	          costo: records[i].costocalculado,
	          utilidad: records[i].utipreciomaxi,
	          tipopreciodeta: records[i].tipoprecio,
	          idalmacen: records[i].idalmacen
	        });
	
	        if (records[i].servicio !== true) {
	          opeinvdet.push({
	            idproducto: records[i].idproducto,
	            nombre: records[i].nombrecorto,
	            cantidad: records[i].cantidad,
	            precio: records[i].precio,
	            fechavencimiento: txtFormaPago.current.value === "4" ? txtFechaVencimiento.current.value : null,
	            tipomovimiento: txtTipoOrdenCompra.current.value === "1" ? "VENTA" : "SERVICIO",
	            fechatipomovimiento: txtFecha.current.value,
	            numfactura: numNota,
	            idalmacen: records[i].idalmacen,
	            tipounidad: records[i].tipounidad,
	            idunidadmedida: records[i].idunidadmedida,
	            idunidadalterna: records[i].idunidadalterna,
	            tipofactor: records[i].tipofactor,
	            valorfactor: records[i].valorfactor,
	            tasa: monedaSub.valormoneda
	          });
	        }
	      }
	
	      setBody({
	        orden: orden,
	        ordendeta: ordendeta,
	        idtipopeinv: "2",
	        opeinv: opeinv,
	        opeinvdet: opeinvdet
	      });
	
	      setDesde(2);
	      var msg = "";
	      if (operacion === 1) {
	        msg = "¿Esta Seguro de Registrar estos Datos?.";
	      } else if (operacion === 2) {
	        msg = "¿Esta Seguro de Modificar estos Datos?.";
	      } else if (operacion === 3) {
	        msg = "¿Esta Seguro de Eliminar estos Datos?.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/servicios/actualizarordenes/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "¡Registro " + response.data.idord + " Creado Correctamente!",
	            icono: "exito"
	          });
	          /* window.open(op.reportes + "reporte=Pedido" + "&CODIGO=" + response.data.idpe, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"); */
	          if (txtFormaPago.current.value === "4") {
	            txtFechaVencimiento.current.value = (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD");
	          }
	        } else if (operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "¡Registro " + response.data.idord + " Modificado Correctamente!",
	            icono: "exito"
	          });
	          if (txtFormaPago.current.value === "4") {
	            txtFechaVencimiento.current.value = (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD");
	          }
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "¡Registro " + response.data.idord + " Eliminado Correctamente!",
	            icono: "exito"
	          });
	        }
	
	        blanquear();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = "";
	      if (error.response === undefined) {
	        mensaje = "Error de Conexion";
	      } else {
	        mensaje = error.response.data.message;
	      }
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    if (desde === 1) {
	      var prod = records;
	      setDesde(0);
	      setRecords(prod);
	    } else if (desde === 2) {
	      setDesde(0);
	      procesarRegistro();
	    }
	  };
	
	  var seleccionarProducto = function seleccionarProducto(index, idubi, idprod) {
	    var endpoint = op.conexion + "/api/inventario/seleccionarproductoinv?idproducto='" + idprod.toUpperCase() + "'&idalmacen=" + idubi;
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var data = [].concat(_toConsumableArray(records));
	        if (response.data !== "") {
	
	          for (var i = 0; i < records.length; i++) {
	            if (records[i].idproducto === response.data.idproducto && records[i].idalmacen !== response.data.idalmacen) {
	              setActivate(false);
	              setMensaje({
	                mostrar: true,
	                titulo: "Notificacion",
	                texto: "El producto ya ha sido seleccionado.",
	                icono: "error"
	              });
	              return;
	            }
	          }
	
	          var uni = [];
	          var precio = 0.0;
	          var montoiva = 0.0;
	          var cantie = response.data.cantidad;
	          var tipouni = 0;
	          var tiene_iva = false;
	          var tipoprecio = parseInt(response.data.tipoprecio);
	
	          if (parseFloat(response.data.ivaventa) > 0.0) {
	            tiene_iva = true;
	          }
	
	          if (parseInt(response.data.tipofactor) === 0 || response.data.tipofactor === null) {
	            tipouni = 0;
	            uni = [{
	              idunidad: response.data.idunidadmedida,
	              descripcion: response.data.descripcionuni,
	              tipo: "medida"
	            }];
	
	            cantie = parseFloat(response.data.cantidad);
	            cantie = Math.trunc(cantie);
	
	            if (tipoprecio === 1) {
	              precio = parseFloat(response.data.preciomaxi);
	            } else if (tipoprecio === 2) {
	              precio = parseFloat(response.data.precioofe);
	            } else if (tipoprecio === 3) {
	              precio = parseFloat(response.data.preciomayor);
	            } else if (tipoprecio === 4) {
	              precio = parseFloat(response.data.preciomini);
	            }
	          } else {
	            if (response.data.idunidadventa === response.data.idunidadalterna) {
	              tipouni = 1;
	              uni = [{
	                idunidad: response.data.idunidadalterna,
	                descripcion: response.data.descripcionunialt,
	                tipo: "alterna"
	              }, {
	                idunidad: response.data.idunidadmedida,
	                descripcion: response.data.descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data.cantidad);
	              cantie = Math.trunc(cantie);
	              if (tipoprecio === 1) {
	                if (response.data.servicio === true) {
	                  precio = parseFloat(response.data.preciomaxi);
	                } else {
	                  precio = parseFloat(response.data.preciomaxialter);
	                }
	              } else if (tipoprecio === 2) {
	                precio = parseFloat(response.data.precioofealter);
	              } else if (tipoprecio === 3) {
	                precio = parseFloat(response.data.preciomayoralter);
	              } else if (tipoprecio === 4) {
	                precio = parseFloat(response.data.preciominialter);
	              }
	            } else if (response.data.idunidadventa === response.data.idunidadmedida) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data.idunidadmedida,
	                descripcion: response.data.descripcionuni,
	                tipo: "medida"
	              }, {
	                idunidad: response.data.idunidadalterna,
	                descripcion: response.data.descripcionunialt,
	                tipo: "alterna"
	              }];
	
	              cantie = parseFloat(response.data.cantidad / response.data.valorfactor);
	              cantie = Math.trunc(cantie);
	
	              if (tipoprecio === 1) {
	                precio = parseFloat(response.data.preciomaxi);
	              } else if (tipoprecio === 2) {
	                precio = parseFloat(response.data.precioofe);
	              } else if (tipoprecio === 3) {
	                precio = parseFloat(response.data.preciomayor);
	              } else if (tipoprecio === 4) {
	                precio = parseFloat(response.data.preciomini);
	              }
	            }
	          }
	
	          if (index !== null) {
	            data[index] = {
	              idproducto: response.data.idproducto,
	              codigo: response.data.codigo,
	              cantidad: 1.0,
	              cantidadE: cantie,
	              cantidadEA: parseFloat(response.data.cantidad),
	              nombrecorto: response.data.nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	              precio: precio,
	              preciobs: 0.0,
	              preciomaxi: response.data.preciomaxi,
	              precioofe: response.data.precioofe,
	              preciomayor: response.data.preciomayor,
	              preciomini: response.data.preciomini,
	              preciomaxialter: response.data.preciomaxialter,
	              precioofealter: response.data.precioofealter,
	              preciomayoralter: response.data.preciomayoralter,
	              preciominialter: response.data.preciominialter,
	              iva: response.data.ivaventa,
	              montoiva: montoiva,
	              descuento: 0.0,
	              total: precio,
	              unidad: uni,
	              idunidadmedida: response.data.idunidadmedida,
	              idunidadalterna: response.data.idunidadalterna,
	              idalmacen: response.data.idalmacen,
	              idmoneda: response.data.idmoneda,
	              valormoneda: monedaCambio.valormoneda,
	              tipounidad: tipouni,
	              tipofactor: response.data.tipofactor,
	              valorfactor: response.data.valorfactor,
	              tipoprecio: response.data.tipoprecio,
	              servicio: response.data.servicio
	            };
	          } else {
	            data.push({
	              idproducto: response.data.idproducto,
	              codigo: response.data.codigo,
	              cantidad: 1.0,
	              cantidadE: cantie,
	              cantidadEA: parseFloat(response.data.cantidad),
	              nombrecorto: response.data.nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	              precio: precio,
	              preciomaxi: response.data.preciomaxi,
	              precioofe: response.data.precioofe,
	              preciomayor: response.data.preciomayor,
	              preciomini: response.data.preciomini,
	              preciomaxialter: response.data.preciomaxialter,
	              precioofealter: response.data.precioofealter,
	              preciomayoralter: response.data.preciomayoralter,
	              preciominialter: response.data.preciominialter,
	              preciobs: 0.0,
	              iva: response.data.ivaventa,
	              montoiva: montoiva,
	              descuento: 0.0,
	              total: precio,
	              unidad: uni,
	              idunidadmedida: response.data.idunidadmedida,
	              idunidadalterna: response.data.idunidadalterna,
	              idalmacen: response.data.idalmacen,
	              idmoneda: response.data.idmoneda,
	              valormoneda: monedaCambio.valormoneda,
	              tipounidad: tipouni,
	              tipofactor: response.data.tipofactor,
	              valorfactor: response.data.valorfactor,
	              tipoprecio: response.data.tipoprecio,
	              servicio: response.data.servicio
	            });
	          }
	          setRecords(data);
	          setTotales((0, _varios.calcularTotales)(data));
	          setIndice(index);
	
	          if (index !== null) {
	            setTimeout(function () {
	              return txtCantidad.current[index].focus();
	            }, 300);
	          } else {
	            setTimeout(function () {
	              return txtCantidad.current[data.length - 1].focus();
	            }, 300);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "no existe un producto con ese codigo en el almacen.",
	            icono: "error"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var validarPrecio = function validarPrecio(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	          event.target.value = "1,00";
	        }
	        event.target.value = (0, _varios.formatoMonto)(event.target.value);
	        var char1 = event.target.value.substring(0, 1);
	        var char2 = event.target.value.substring(1, 2);
	        if (char1 === "0" && char2 !== ",") {
	          event.target.value = event.target.value.substring(1, event.target.value.length);
	        }
	        if (event.target.id === "precio") {
	          var data = [].concat(_toConsumableArray(records));
	          var info = [];
	
	          var preci = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	          var montoiv = (0, _varios.round)(preci * data[index].iva / 100, 2);
	          var ivss = montoiv * data[index].cantidad;
	
	          data[index].precio = preci;
	          //data[index].motoiva = ivss;
	          data[index].total = preci * data[index].cantidad;
	
	          setTotales((0, _varios.calcularTotales)(data));
	          setRecords(data);
	        }
	      } else if (event.which === 46) {
	        return false;
	      } else if (event.which >= 48 && event.which <= 57) {
	        return true;
	      } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	        return true;
	      } else return false;
	    };
	  };
	
	  var seleccionarDetalle = function seleccionarDetalle(idorden) {
	    var nomtab1 = "ordenes_detalle";
	    var nomtab2 = "ordenes";
	    var nomid = "idorden";
	    var endpoint = op.conexion + "/api/servicios/seleccionarordenesdet?id=" + idorden + "&nomtab1=" + nomtab1 + "&nomtab2=" + nomtab2 + "&nomid=" + nomid;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	
	          var prod = [];
	          var uni = [];
	          var montoiva = 0.0;
	          var cantie = 0.0;
	          var cantiea = 0.0;
	          var tipouni = 0;
	          var tiene_iva = false;
	          txtIdalmacen.current.value = response.data[0].idalmacen;
	
	          for (var i = 0; i < response.data.length; i++) {
	            if (parseFloat(response.data[i].iva) > 0.0) {
	              tiene_iva = true;
	            }
	            if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) <= 0.0) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantiea = Math.trunc(cantiea);
	            } else if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) > 0.0) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }, {
	                idunidad: response.data[i].idunidadalterna,
	                descripcion: response.data[i].descripcionunialt,
	                tipo: "alterna"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) / parseFloat(response.data[i].valorfactor) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) / parseFloat(response.data[i].valorfactor) + parseFloat(response.data[i].cantidad);
	
	              cantiea = cantiea * parseFloat(response.data[i].valorfactor);
	              cantiea = Math.trunc(cantiea);
	            } else if (response.data[i].tipounidad === 1) {
	              tipouni = 1;
	              uni = [{
	                idunidad: response.data[i].idunidadalterna,
	                descripcion: response.data[i].descripcionunialt,
	                tipo: "alterna"
	              }, {
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantiea = Math.trunc(cantiea);
	            }
	
	            prod.push({
	              idproducto: response.data[i].idproducto,
	              codigo: response.data[i].codigo,
	              cantidad: response.data[i].cantidad,
	              cantidadE: parseFloat(cantie),
	              cantidadEA: parseFloat(cantiea),
	              nombrecorto: response.data[i].nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	              precio: response.data[i].punitario,
	              preciobs: response.data[i].punitariobs,
	              preciomaxi: response.data[i].preciomaxi,
	              precioofe: response.data[i].precioofe,
	              preciomayor: response.data[i].preciomayor,
	              preciomini: response.data[i].preciomini,
	              preciomaxialter: response.data[i].preciomaxialter,
	              precioofealter: response.data[i].precioofealter,
	              preciomayoralter: response.data[i].preciomayoralter,
	              preciominialter: response.data[i].preciominialter,
	              iva: response.data[i].iva,
	              ivaventa: response.data[i].ivaventa,
	              montoiva: response.data[i].cantidad * montoiva,
	              descuento: response.data[i].descuento,
	              total: response.data[i].cantidad * response.data[i].punitario,
	              unidad: uni,
	              idunidadmedida: response.data[i].idunidadmedida,
	              idunidadalterna: response.data[i].idunidadalterna,
	              costocalculado: response.data[i].costocalculado,
	              costocalculadoalter: response.data[i].costocalculadoalter,
	              utipreciomaxi: response.data[i].utipreciomaxi,
	              utipreciomaxialter: response.data[i].utipreciomaxialter,
	              tipounidad: tipouni,
	              valormoneda: monedaCambio.valormoneda,
	              idmoneda: response.data[i].idmoneda,
	              tipofactor: response.data[i].tipofactor,
	              valorfactor: response.data[i].valorfactor,
	              tipoprecio: response.data[i].tipopreciodeta,
	              servicio: response.data[i].servicio,
	              idalmacen: response.data[i].idalmacen
	            });
	          }
	
	          setRecords(prod);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var agregarProducto = function agregarProducto(producto) {
	    setMostrar(false);
	    var almacenid = numval === "1" ? null : txtIdalmacen.current.value;
	    seleccionarProducto(indice, almacenid, producto.codigo);
	  };
	
	  var editarProducto = function editarProducto(index) {
	    return function (e) {
	      e.preventDefault();
	      setMostrar(true);
	      setIndice(index);
	    };
	  };
	
	  var validarCantidadP = function validarCantidadP(index, it) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        var cantidades = (0, _varios.validarCantidad)({
	          index: index,
	          event: event,
	          productos: records
	        });
	        if (event.which === 13) {
	          if (index < cantidades.data.length - 1) {
	            setTimeout(function () {
	              return txtCantidad.current[index + 1].focus();
	            }, 300);
	          }
	        }
	        setMensaje(cantidades.msm);
	        setRecords(cantidades.data);
	        setTotales(cantidades.totales);
	      }
	    };
	  };
	
	  var validarIdProducto = function validarIdProducto(index) {
	    return function (event) {
	      event.preventDefault();
	      if (event.which === 13 || typeof event.which === "undefined") {
	        if (event.target.value !== "") {
	          seleccionarProducto(index, txtIdalmacen.current.value, event.target.value);
	        }
	      }
	    };
	  };
	
	  var onRegistrarClientes = function onRegistrarClientes(values) {
	    setCatregistrarcliente(false);
	  };
	
	  var seleccionarxIndice = function seleccionarxIndice(index) {
	    return function (e) {
	      e.preventDefault();
	      if (txtIdalmacen.current.value !== "" && txtIdalmacen.current.value !== null) {
	        setMostrar(true);
	        setIndice(index);
	      } else {
	        if (numval === '1') {
	          setMostrar(true);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "Debe Seleccionar el Almacen",
	            icono: "error"
	          });
	        }
	      }
	    };
	  };
	
	  var onChangeTipoPrecio = function onChangeTipoPrecio(i) {
	    return function (e) {
	      var data = [].concat(_toConsumableArray(records));
	      var tipoprecio = parseInt(e.target.value);
	      var tipounidad = data[i].tipounidad;
	      var cantidad = data[i].cantidad;
	      var precio = 0.0;
	      var total = 0.0;
	
	      if (tipounidad === 1) {
	        if (tipoprecio === 1) {
	          precio = parseFloat(data[i].preciomaxialter);
	        } else if (tipoprecio === 2) {
	          precio = parseFloat(data[i].precioofealter);
	        } else if (tipoprecio === 3) {
	          precio = parseFloat(data[i].preciomayoralter);
	        } else if (tipoprecio === 4) {
	          precio = parseFloat(data[i].preciominialter);
	        }
	      } else {
	        if (tipoprecio === 1) {
	          precio = parseFloat(data[i].preciomaxi);
	        } else if (tipoprecio === 2) {
	          precio = parseFloat(data[i].precioofe);
	        } else if (tipoprecio === 3) {
	          precio = parseFloat(data[i].preciomayor);
	        } else if (tipoprecio === 4) {
	          precio = parseFloat(data[i].preciomini);
	        }
	      }
	
	      total = precio * cantidad;
	
	      data[i].tipoprecio = e.target.value;
	      data[i].precio = precio;
	      data[i].total = total;
	
	      setRecords(data);
	      setTotales((0, _varios.calcularTotales)(data));
	    };
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (ordservicios && ordservicios.toString().substring(0, 1) === "1") {
	          setVisibleBtn("hidden");
	          setHabilitadoProductos(false);
	          setTituloHeader("Incluir Orden de Venta.");
	          setHabilitado(false);
	          seleccionarMonedas();
	          seleccionarAgente();
	          seleccionarAlmacen();
	          seleccionarCidgoorden("idorden");
	          setCastabla(false);
	          setOperacion(1);
	          setAcpt(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            catalogoper: false
	          });
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (ordservicios && ordservicios.toString().substring(1, 2) === "1") {
	          setTituloHeader("Editar Orden de Venta.");
	          setVisibleBtn("hidden");
	          setHabilitado(false);
	          seleccionarMonedas();
	          setCatalogoPresu(true);
	          seleccionarAlmacen();
	          setHabilitarCat(false);
	          setCastabla(false);
	          setAcpt(false);
	          setOperacion(2);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (ordservicios && ordservicios.toString().substring(3, 4) === "1") {
	          setTituloHeader("Eliminar Orden de Venta.");
	          setVisibleBtn("hidden");
	          setHabilitado(false);
	          setCatalogoPresu(true);
	          seleccionarMonedas();
	          setAcpt(false);
	          setHabilitarCat(false);
	          setCastabla(true);
	          setOperacion(3);
	          seleccionarAlmacen();
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (ordservicios && ordservicios.toString().substring(2, 3) === "1") {
	          setTituloHeader("Consultar Orden de Venta.");
	          setVisibleBtn("hidden");
	          seleccionarMonedas();
	          setAcpt(true);
	          setHabilitado(true);
	          setCastabla(true);
	          setOperacion(4);
	          setHabilitarCat(false);
	          setHabilitadoNU(true);
	          setDesde(7);
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          setTimeout(function () {
	            return txtCodigo.current.focus();
	          }, 300);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 6) {
	        setVisibleBtn("visible");
	        blanquear();
	      }
	    };
	  };
	
	  var seleccionarMonedas = function seleccionarMonedas() {
	    var campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	    var nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	    var orden = "m.idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var x = 0;
	        if (response.data.length > 0) {
	          setComboMoneda(response.data);
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].subpredeterminada) {
	              setMonedaSub(response.data[i]);
	              setMonedaCambio({
	                idmoneda: response.data[i].idmoneda,
	                descripcion: response.data[i].descripcion,
	                simbolo: response.data[i].simbolo,
	                predeterminada: response.data[i].predeterminada,
	                subpredeterminada: response.data[i].subpredeterminada,
	                valormoneda: 1.0
	              });
	              x = i;
	            } else if (response.data[i].predeterminada) {
	              setMoneda(response.data[i]);
	            }
	          }
	        }
	        setTimeout(function () {
	          return txtIdmoneda.current.selectedIndex = x;
	        }, 200);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarProveedor = function seleccionarProveedor(rif, val) {
	
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/servicios/consultaregistromovilesxclientes?idcliente=" + rif;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	
	          txtCedRif.current.value = response.data.rif;
	          txtNombreCliente.current.value = response.data.nombre;
	          txtDirClient.current.value = response.data.direccion;
	          setIdCliente(response.data.idagente);
	          setEsmovil(response.data.esmovil);
	          if (response.data.esmovil === true && val === "OS") {
	            seleccionarMoviles(response.data.idagente);
	          } else {
	            setMoviles([]);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un cliente con este codigo",
	            icono: "informacion"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarResponsable = function seleccionarResponsable(id) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "idagente";
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtCedRifv.current.value = response.data.rif;
	          txtNombreVendedor.current.value = response.data.nombre;
	          setIdVendedor(response.data.idagente);
	          setVendedor({
	            idvendedor: response.data.idagente,
	            tiporif: response.data.tiporifv,
	            rif: response.data.rifv,
	            nombre: response.data.nombrev,
	            idalmacen: ""
	          });
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un vendedor con este codigo",
	            icono: "informacion"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = "*";
	    var nomtab = "ordenes";
	    var nomid = "idorden";
	    var id = txtCodigo.current.value;
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	
	          txtFecha.current.value = (0, _moment2.default)(response.data.fecha).format("YYYY-MM-DD");
	          setNumNota(response.data.numorden);
	          txtCedRif.current.value = response.data.cedularif;
	          txtOpeInventario.current.value = response.data.idoperacioninventario;
	          txtTipoOrdenCompra.current.value = parseInt(response.data.tipoorden);
	          txtFormaPago.current.value = parseInt(response.data.formapago);
	          if (parseInt(response.data.formapago) === 4) {
	            setFechav(1);
	            txtFechaVencimiento.current.value = (0, _moment2.default)(response.data.fechavence).format("YYYY-MM-DD");
	          } else {
	            setFechav(0);
	          }
	
	          if (response.data.numorden.substring(0, 2) === 'OV') {
	            if (operacion === 1) {
	              setTituloHeader("Incluir Orden de Venta.");
	            } else if (operacion === 2) {
	              setTituloHeader("Modificar Orden de Venta.");
	            } else if (operacion === 3) {
	              setTituloHeader("Eliminar Orden de Venta.");
	            } else {
	              setTituloHeader("Consultar Orden de Venta.");
	            }
	          } else {
	            if (operacion === 1) {
	              setTituloHeader("Incluir Orden de Servicio.");
	            } else if (operacion === 2) {
	              setTituloHeader("Modificar Orden de Servicio.");
	            } else if (operacion === 3) {
	              setTituloHeader("Eliminar Orden de Servicio.");
	            } else {
	              setTituloHeader("Consultar Orden de Servicio.");
	            }
	          }
	
	          seleccionarProveedor("'" + response.data.cedularif + "'", response.data.numorden.substring(0, 2));
	          seleccionarResponsable(response.data.idvendedor);
	          seleccionarDetalle(response.data.idorden);
	
	          setTotales({
	            subtotal: response.data.totalmonto - response.data.totaliva,
	            descuento: response.data.totaldescuento,
	            exento: response.data.totalexento,
	            sujeto: response.data.totalsujeto,
	            iva: 16.0,
	            totaliva: response.data.totaliva,
	            total: response.data.totalmonto
	          });
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "ID no existe.",
	            icono: "informacion"
	          });
	          txtCodigo.current.value = "";
	          txtCodigo.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var handleInputNumeroChange = function handleInputNumeroChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "idordendecompra") {
	          seleccionarRegistro();
	        }
	      }
	    }
	  };
	
	  var seleccionarCidgoorden = function seleccionarCidgoorden(id) {
	    var tabla = "ordenes";
	    var endpoint = op.conexion + "/api/ordencompra/consultacodigos?tabla=" + tabla + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.numeroasignado > 0) {
	          var to = parseFloat(response.data.numeroasignado) + 1;
	          var cerrrou = '000000';
	          var paddedNumber = (0, _varios.lpad)(to.toString(), cerrrou, 6);
	          setNumNota("OV" + paddedNumber);
	        } else {
	          setNumNota("OV000001");
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var onCatalogoPresupuesto = function onCatalogoPresupuesto(values) {
	    setCatalogoPresu(false);
	    txtCodigo.current.value = values.idorden;
	    seleccionarRegistro();
	  };
	
	  var onChangeFecha = function onChangeFecha(e) {
	    if (e.target.name === "formapago") {
	      if (e.target.value === "4") {
	        setFechav(1);
	      } else if (e.target.value === "3") {
	        setFechav(0);
	      }
	    }
	  };
	
	  var onChangeMoneda = function onChangeMoneda(e) {
	    var i = e.target.value;
	    var cambio = (0, _varios.onCambioMoneda)({
	      moneda: combomoneda[i],
	      productos: records,
	      monedaPre: moneda,
	      monedaSub: monedaSub
	    });
	    setMonedaCambio(cambio.monedacambio);
	    setRecords(cambio.data);
	  };
	
	  var onChangeUnidad = function onChangeUnidad(index) {
	    return function (e) {
	      e.preventDefault();
	      var data = [].concat(_toConsumableArray(records));
	      var precio = 0.0;
	      var montoiva = 0.0;
	      var tipounidad = 0;
	
	      if (parseInt(e.target.value) === parseInt(data[index].idunidadalterna)) {
	        tipounidad = 1;
	        precio = parseFloat(data[index].precio) / parseFloat(data[index].valorfactor);
	      } else if (parseInt(e.target.value) === parseInt(data[index].idunidadmedida)) {
	        tipounidad = 0;
	        precio = parseFloat(data[index].precio) * parseFloat(data[index].valorfactor);
	      }
	
	      montoiva = precio * parseFloat(data[index].iva) / 100;
	
	      data[index].tipounidad = tipounidad;
	      data[index].precio = precio;
	      data[index].unidad = data[index].unidad.reverse();
	      data[index].total = precio * data[index].cantidad;
	      data[index].montoiva = montoiva * data[index].cantidad;
	
	      setRecords(data);
	      setTotales((0, _varios.calcularTotales)(data));
	    };
	  };
	
	  var imprimirOrdendeCompra = function imprimirOrdendeCompra() {
	    if (ordservicios && ordservicios.toString().substring(4, 5) === "1") {
	      if (txtCodigo.current.value !== "") {
	        var id = txtCodigo.current.value;
	        window.open(op.reportes + "/pedidos?afiliado=" + organizacion + "&reporte=Ordenes&CODIGO=" + id, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      }
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarMonedas();
	  }, []);
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === "tipoorden") {
	
	      var tipoorden = txtNumPresupuesto.current.value.substring(2, 8);
	
	      if (e.target.value === "1") {
	        var compra = "OV" + tipoorden;
	        setNumNota(compra);
	        setNumval("0");
	        if (operacion === 1) {
	          setTituloHeader("Incluir Orden de Venta.");
	        } else if (operacion === 2) {
	          setTituloHeader("Modificar Orden de Venta.");
	        } else if (operacion === 3) {
	          setTituloHeader("Eliminar Orden de Venta.");
	        } else {
	          setTituloHeader("Consultar Orden de Venta.");
	        }
	      } else {
	        var _compra = "OS" + tipoorden;
	        setNumNota(_compra);
	        setNumval("1");
	        if (operacion === 1) {
	          setTituloHeader("Incluir Orden de Servicio.");
	        } else if (operacion === 2) {
	          setTituloHeader("Modificar Orden de Servicio.");
	        } else if (operacion === 3) {
	          setTituloHeader("Eliminar Orden de Servicio.");
	        } else {
	          setTituloHeader("Consultar Orden de Servicio.");
	        }
	      }
	    }
	
	    if (e.target.name === "almacen") {
	      if (e.target.value > 0) {
	        setNumval("0");
	      } else {
	        setNumval("1");
	      }
	    }
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 ", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-11 mx-auto py-2 card shadow " },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "col-md-12 row border-azul mx-auto justify-content-between rounded py-2",
	              style: { fontSizeAdjust: "0.6" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light d-flex align-items-center" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-5" },
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  tituloHeader
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-450 mx-auto px-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0 fs-6 fw-bold text-light",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    numNota.substring(0, 2) === 'OV' ? 'N° Order de Venta:' : numNota.substring(0, 2) === 'OS' ? 'N° Order de Servicio:' : '',
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "text",
	                    ref: txtNumPresupuesto,
	                    disabled: true,
	                    className: "form-control mt-1 bg-transparent border-0 text-light fw-bold fs-5",
	                    value: numNota,
	                    name: "numpresu",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 d-flex justify-content-end" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "/inicio", className: "text-light " },
	                  _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "fw-bold" },
	                    "Salir"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row px-0 m-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-220 mb-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CODIGO:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "text",
	                    name: "idordendecompra",
	                    onKeyUp: handleInputNumeroChange,
	                    disabled: operacion === 1 || operacion === 0 ? true : false,
	                    ref: txtCodigo,
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      type: "button",
	                      onClick: function onClick() {
	                        return setCatalogoPresu(true);
	                      },
	                      disabled: habilitarCat,
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                )
	              ),
	              _react2.default.createElement("input", { type: "hidden", ref: txtOpeInventario }),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-260 mb-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO DE ORDEN:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-select",
	                      ref: txtTipoOrdenCompra,
	                      onChange: onChange,
	                      name: "tipoorden",
	                      disabled: operacion === 4 || operacion === 3 || operacion === 0 ? true : false,
	                      "aria-label": "Default select example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "VENTA"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "2" },
	                      "SERVICIO"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-270 mb-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO DE PAGO:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-select",
	                      ref: txtFormaPago,
	                      name: "formapago",
	                      onChangeCapture: onChangeFecha,
	                      disabled: operacion === 4 || operacion === 3 || operacion === 0 ? true : false,
	                      "aria-label": "Default select example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "3" },
	                      "CONTADO"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "4" },
	                      "CR\xC9DITO"
	                    )
	                  )
	                )
	              ),
	              fechav === 1 ? _react2.default.createElement(
	                "div",
	                { className: "col-pd-350 mb-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA DE VENCIMIENTO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "date",
	                    disabled: castabla,
	                    className: "form-control text-uppercase fs-6",
	                    ref: txtFechaVencimiento,
	                    "aria-label": "Sizing example input",
	                    defaultValue: (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD"),
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              ) : "",
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-220 ml-auto mb-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA:"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "date",
	                    disabled: castabla,
	                    className: "form-control text-uppercase fs-6",
	                    ref: txtFecha,
	                    "aria-label": "Sizing example input",
	                    defaultValue: (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD"),
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-8 mb-2 py-1" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row border-azul rounded py-2" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold col-md-12" },
	                  "Datos del Cliente",
	                  " ",
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      style: {
	                        pointerEvents: botones.catalogoper === true ? "none" : false,
	                        color: botones.catalogoper ? "rgb(183, 183, 183)" : "#1d0345",
	                        backgroundColor: botones.catalogoper ? "#fff" : "transparent"
	                      },
	                      type: "button",
	                      onClick: function onClick() {
	                        return onCatalogo(1);
	                      },
	                      className: "text-info rounded-circle",
	                      title: "Buscar Proveedor"
	                    },
	                    _react2.default.createElement("i", { className: " fas fa-search" })
	                  ),
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      style: {
	                        pointerEvents: botones.catalogoper === true ? "none" : false,
	                        color: botones.catalogoper ? "rgb(183, 183, 183)" : "#1d0345",
	                        backgroundColor: botones.catalogoper ? "#fff" : "transparent"
	                      },
	                      type: "button",
	                      onClick: function onClick() {
	                        return setCatregistrarcliente(true);
	                      },
	                      className: "text-info rounded-circle ml-2",
	                      title: "Registrar Proveedor"
	                    },
	                    _react2.default.createElement("i", { className: " fas fa-plus" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-3 mb-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "CEDULA/RIF:",
	                      " "
	                    ),
	                    _react2.default.createElement("input", {
	                      autoComplete: "off",
	                      type: "text",
	                      disabled: true,
	                      ref: txtCedRif,
	                      className: "form-control bg-transparent fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-9 mb-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "NOMBRE:",
	                      " "
	                    ),
	                    _react2.default.createElement("input", {
	                      autoComplete: "off",
	                      type: "text",
	                      disabled: true,
	                      ref: txtNombreCliente,
	                      className: "form-control bg-transparent fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 mb-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "DIRECCION:",
	                      " "
	                    ),
	                    _react2.default.createElement("input", {
	                      autoComplete: "off",
	                      type: "text",
	                      disabled: true,
	                      ref: txtDirClient,
	                      className: "form-control bg-transparent fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "MOVIL:"
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        className: "form-control form-control-sm form-select fw-bold fs-6",
	                        disabled: esmovil === true && (operacion === 1 || operacion === 2) && moviles.length > 0 ? false : true,
	                        name: "movil",
	                        ref: txtIdmovil,
	                        onChange: onChange
	                      },
	                      moviles && moviles.map(function (item, index) {
	                        return _react2.default.createElement(
	                          "option",
	                          { key: index, value: item.idmovil },
	                          "MODELO: ",
	                          "" + item.modelo,
	                          "-",
	                          " MARCA: ",
	                          "" + item.marca,
	                          "-",
	                          " PLACA: ",
	                          "" + item.placa
	                        );
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4 mb-2 py-1 row m-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto border-azul rounded row py-2" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold" },
	                  "Datos del Responsable"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-6 py-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "CEDULA/RIF:",
	                      " "
	                    ),
	                    _react2.default.createElement("input", {
	                      autoComplete: "off",
	                      type: "text",
	                      disabled: true,
	                      ref: txtCedRifv,
	                      className: "form-control bg-transparent fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "NOMBRE:",
	                      " "
	                    ),
	                    _react2.default.createElement("input", {
	                      autoComplete: "off",
	                      type: "text",
	                      disabled: true,
	                      ref: txtNombreVendedor,
	                      className: "form-control bg-transparent fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-pd-12 row m-0 px-2" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-430 py-1 px-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "ALMACEN:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-control form-control-sm form-select fw-bold fs-6",
	                      disabled: operacion === 3 || operacion === 0 || operacion === 4 ? true : false,
	                      name: "almacen",
	                      ref: txtIdalmacen,
	                      onChange: onChange
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "-------SELECCIONE-------"
	                    ),
	                    almacen && almacen.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idalmacen },
	                        " ",
	                        "" + item.descripcion,
	                        " "
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-330 py-1 ml-auto px-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO DE MONEDA:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-control form-control-sm form-select fw-bold fs-6",
	                      disabled: operacion === 3 || operacion === 0 ? true : false,
	                      ref: txtIdmoneda,
	                      onChange: onChangeMoneda
	                    },
	                    combomoneda && combomoneda.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: index },
	                        " ",
	                        item.descripcion + " " + item.simbolo + " " + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                        " "
	                      );
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 border-azul rounded px-0",
	                style: { backgroundColor: "#d5e9ff" }
	              },
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 250,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px",
	                    fontSizeAdjust: "0.6"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden" },
	                  records && records.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      { key: index, style: { padding: "0" } },
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "bg-light d-flex align-items-between px-0", style: { height: item.nombrecorto.length >= 50 ? '60px' : 'auto' } },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          style: {
	                            borderBottomRightRadius: 0,
	                            borderTopRightRadius: 0
	                          },
	                          disabled: habilitadoProductos,
	                          ref: function ref(el) {
	                            return txtId.current[index] = el;
	                          },
	                          className: "form-control form-control-sm bg-light fs-6",
	                          defaultValue: item.codigo,
	                          onChange: function onChange(e) {
	                            return e.target.value = e.target.value.toUpperCase();
	                          },
	                          onKeyUp: validarIdProducto(index),
	                          onBlur: validarIdProducto(index)
	                        }),
	                        (operacion === 1 || operacion === 2) && _react2.default.createElement(
	                          "button",
	                          {
	                            type: "button",
	                            style: {
	                              borderBottomLeftRadius: 0,
	                              borderTopLeftRadius: 0,
	                              height: '27px'
	                            },
	                            disabled: habilitadoProductos,
	                            onClick: seleccionarxIndice(index),
	                            className: "btn btn-sm btn-primary"
	                          },
	                          _react2.default.createElement(
	                            "i",
	                            { className: "fas " },
	                            "-"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-start p-0 pl-2",
	                          style: { width: "150px" }
	                        },
	                        item.nombrecorto
	                      ),
	                      operacion === 4 ? "" : _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "30px" }
	                        },
	                        (0, _varios.formatMoneda)(item.cantidadE.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-center p-0" },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control form-control-sm bg-light text-right fs-6 col-pd-90 mx-auto",
	                          id: "cantidad"
	                          //disabled={item.servicio === true ? true : false}
	                          , defaultValue: (0, _varios.formatMoneda)(item.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtCantidad.current[index] = el;
	                          },
	                          onFocus: _varios.seleccionarCampo,
	                          onKeyUp: validarCantidadP(index, item),
	                          onBlur: validarCantidadP(index, item)
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light p-0",
	                          style: { width: 50 }
	                        },
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            className: "form-control form-control-sm fs-6 text-center",
	                            style: { width: "100%" },
	                            disabled: item.servicio === true ? true : habilitadoProductos,
	                            defaultValue: item.tipoprecio,
	                            onChange: onChangeTipoPrecio(index)
	                          },
	                          _varios.comboprecios.map(function (item2, x) {
	                            return _react2.default.createElement(
	                              "option",
	                              { key: x, value: item2.id },
	                              " ",
	                              item2.nombre,
	                              " "
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "50px" }
	                        },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          disabled: habilitado,
	                          onKeyUp: validarPrecio(index),
	                          onBlur: validarPrecio(index),
	                          className: "form-control form-control-sm bg-light text-right fs-6",
	                          id: "precio",
	                          defaultValue: (0, _varios.formatMoneda)((item.precio * item.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtPrecio.current[index] = el;
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light p-0",
	                          style: { width: 50 }
	                        },
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            className: "form-control form-control-sm fs-6 text-center",
	                            style: { width: "100%" },
	                            disabled: item.servicio === true ? true : habilitadoProductos,
	                            onChange: onChangeUnidad(index)
	                          },
	                          item.unidad && item.unidad.map(function (item2, x) {
	                            return _react2.default.createElement(
	                              "option",
	                              { key: x, value: item2.idunidad },
	                              " ",
	                              item.servicio === true ? "SERVICIO" : item2.descripcion,
	                              " "
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0",
	                          style: { width: "50px" }
	                        },
	                        (0, _varios.formatMoneda)((item.iva !== null ? item.iva : 0.00).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0",
	                          style: { width: "50px" }
	                        },
	                        (0, _varios.formatMoneda)((item.precio * item.cantidad * item.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-center p-0",
	                          style: { width: "20px" }
	                        },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            disabled: habilitado,
	                            style: {
	                              visibility: (operacion === 4 || operacion === 3) && "collapse"
	                            },
	                            onClick: eliminarProducto(item),
	                            className: "btn btn-sm btn-danger"
	                          },
	                          _react2.default.createElement("i", { className: "fa fa-trash" }),
	                          " "
	                        )
	                      )
	                    );
	                  }),
	                  _react2.default.createElement(
	                    _core.TableRow,
	                    {
	                      style: {
	                        padding: "0",
	                        visibility: (operacion === 4 || operacion === 0 || operacion === 3) && "collapse"
	                      }
	                    },
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: "align-middle bg-light text-center p-0 d-flex" },
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        disabled: operacion === 4 || operacion === 3 ? true : false,
	                        style: {
	                          borderBottomRightRadius: 0,
	                          borderTopRightRadius: 0
	                        },
	                        className: "form-control form-control-sm bg-light fs-6",
	                        onChange: function onChange(e) {
	                          return e.target.value = e.target.value.toUpperCase();
	                        },
	                        onKeyUp: validarIdProducto(null),
	                        onBlur: validarIdProducto(null)
	                      }),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          disabled: operacion === 4 || operacion === 3 ? true : false,
	                          style: {
	                            borderBottomLeftRadius: 0,
	                            borderTopLeftRadius: 0
	                          },
	                          onClick: seleccionarxIndice(null),
	                          className: "btn btn-sm btn-primary"
	                        },
	                        _react2.default.createElement(
	                          "i",
	                          { className: "fas " },
	                          "-"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light text-start p-0 pl-2",
	                      style: { width: "50px" }
	                    }),
	                    operacion === 4 ? "" : _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light text-end p-0 pr-2",
	                      style: { width: "30px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light text-center p-0",
	                      style: { width: "20px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light p-0",
	                      style: { width: 50 }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light text-end p-0 pr-2",
	                      style: { width: "50px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light p-0",
	                      style: { width: 50 }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light text-end p-0",
	                      style: { width: "50px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light text-end p-0",
	                      style: { width: "50px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light text-center p-0",
	                      style: { width: "20px" }
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row m-0 px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-8 mt-auto" },
	                visibleBtn === "visible" ? _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-botones" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 row m-0" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: botones.incluir,
	                        onClick: onBotones(1),
	                        className: "btn btn-sm col ml-1 mb-1 btn-primary rounded-pill",
	                        title: "Incluir Almacen"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-plus" },
	                        " Incluir "
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: botones.consultar,
	                        onClick: onBotones(4),
	                        className: "btn btn-sm col ml-1 mb-1 btn-info rounded-pill",
	                        title: "Consultar Almacen"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-eye" },
	                        " Consultar"
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: botones.modificar,
	                        onClick: onBotones(2),
	                        className: "btn btn-sm col ml-1 mb-1 btn-warning rounded-pill",
	                        title: "Modificar Almacen"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fa fa-edit" },
	                        " Modificar"
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: botones.eliminar,
	                        onClick: onBotones(3),
	                        className: "btn btn-sm col ml-1 mb-1 btn-danger rounded-pill",
	                        title: "Eliminar Almacen"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fa fa-trash" },
	                        " Eliminar"
	                      ),
	                      " "
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-360 row m-0 ml-auto" },
	                  habilitadoNU === true ? _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnAcepta,
	                      onClick: imprimirOrdendeCompra,
	                      disabled: txtCodigo.current.value !== "" ? false : true,
	                      className: "btn btn-sm rounded-pill col ml-1 btn-primary"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-print" },
	                      " Imprimir"
	                    )
	                  ) : "",
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnAcepta,
	                      disabled: acpt,
	                      onClick: onChangeValidar,
	                      className: "btn btn-sm col ml-1 rounded-pill btn-success"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-check-circle" },
	                      " Aceptar"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnCancela,
	                      onClick: onBotones(6),
	                      className: "btn btn-danger col ml-1 btn-sm rounded-pill"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-window-close" },
	                      " Cancelar"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-lg-4 border-azul rounded shadow",
	                  style: { backgroundColor: "#dbeeff" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "SUBTOTAL ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtSubTotal,
	                    value: (0, _varios.formatMoneda)((totales.subtotal * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "EXENTO ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtExentoTotal,
	                    value: (0, _varios.formatMoneda)((totales.exento * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "DESCUENTO ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtDescuento,
	                    value: (0, _varios.formatMoneda)((totales.descuento * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "IVA Sobre(",
	                    (0, _varios.formatMoneda)(totales.iva.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    "%) ",
	                    monedaCambio.simbolo,
	                    ":",
	                    " ",
	                    (0, _varios.formatMoneda)((totales.sujeto * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtTotalIva,
	                    value: (0, _varios.formatMoneda)((totales.totaliva * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "TOTAL ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtTotal,
	                    value: (0, _varios.formatMoneda)((totales.total * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: catalogoCliente,
	      nomid: valparametro,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoCliente(false);
	      },
	      onHideAceptaCatalogo: onCatalogoCliente
	    }),
	    _react2.default.createElement(_catalogoProducto2.default, {
	      show: mostrar,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar(false);
	      },
	      esservicio: numval,
	      onHideAceptaCatalogo: agregarProducto
	    }),
	    _react2.default.createElement(_catalogoOrdenes2.default, {
	      show: catalogoPresu,
	      ope: operacion,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoPresu(false);
	      },
	      onHideAceptaCatalogo: onCatalogoPresupuesto
	    }),
	    _react2.default.createElement(_catalogoAgregarClientes2.default, {
	      show: catregistrarcliente,
	      op: operacion,
	      onHideCancelar: function onHideCancelar() {
	        return setCatregistrarcliente(false);
	      },
	      onHideAceptaCatalogo: onRegistrarClientes
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = TablaOrdenServicios;

/***/ },
/* 7148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _core = __webpack_require__(19);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _catalogoProducto = __webpack_require__(104);
	
	var _catalogoProducto2 = _interopRequireDefault(_catalogoProducto);
	
	var _catalogoAgregarProveedor = __webpack_require__(291);
	
	var _catalogoAgregarProveedor2 = _interopRequireDefault(_catalogoAgregarProveedor);
	
	var _catalogoOrdenes = __webpack_require__(293);
	
	var _catalogoOrdenes2 = _interopRequireDefault(_catalogoOrdenes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var TablapServicios = function TablapServicios() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var anio = JSON.parse(sessionStorage.getItem("anioactu"));
	  var idagente = JSON.parse(sessionStorage.getItem("idagente"));
	  var fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var accgservicios = JSON.parse(sessionStorage.getItem("accgserviciosc"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var txtNombreCliente = (0, _react.useRef)();
	  var txtDescuento = (0, _react.useRef)();
	  var txtSubTotal = (0, _react.useRef)();
	  var txtTotalIva = (0, _react.useRef)();
	  var txtExentoTotal = (0, _react.useRef)();
	  var txtTotal = (0, _react.useRef)();
	  var txtDirClient = (0, _react.useRef)();
	  var txtCedRifv = (0, _react.useRef)();
	  var txtNombreVendedor = (0, _react.useRef)();
	  var txtCantidad = (0, _react.useRef)([]);
	  var txtPrecio = (0, _react.useRef)([]);
	  var txtId = (0, _react.useRef)([]);
	  var txtIdalmacen = (0, _react.useRef)();
	  var txtCedRif = (0, _react.useRef)();
	  var txtCodigo = (0, _react.useRef)();
	  var txtNumPresupuesto = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtFechaVencimiento = (0, _react.useRef)();
	  var txtIdmovil = (0, _react.useRef)();
	  var txtIdmoneda = (0, _react.useRef)();
	  var txtTipoOrdenCompra = (0, _react.useRef)();
	  var txtFormaPago = (0, _react.useRef)();
	  var txtOpeInventario = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(""),
	      _useState2 = _slicedToArray(_useState, 2),
	      idCliente = _useState2[0],
	      setIdCliente = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(""),
	      _useState4 = _slicedToArray(_useState3, 2),
	      idVendedor = _useState4[0],
	      setIdVendedor = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(true),
	      _useState6 = _slicedToArray(_useState5, 2),
	      habilitarCat = _useState6[0],
	      setHabilitarCat = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      desde = _useState8[0],
	      setDesde = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      catalogoPresu = _useState10[0],
	      setCatalogoPresu = _useState10[1];
	
	  var _useState11 = (0, _react.useState)("Servicios."),
	      _useState12 = _slicedToArray(_useState11, 2),
	      tituloHeader = _useState12[0],
	      setTituloHeader = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(""),
	      _useState14 = _slicedToArray(_useState13, 2),
	      numNota = _useState14[0],
	      setNumNota = _useState14[1];
	
	  var _useState15 = (0, _react.useState)("visible"),
	      _useState16 = _slicedToArray(_useState15, 2),
	      visibleBtn = _useState16[0],
	      setVisibleBtn = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(""),
	      _useState18 = _slicedToArray(_useState17, 2),
	      numval = _useState18[0],
	      setNumval = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(true),
	      _useState20 = _slicedToArray(_useState19, 2),
	      habilitadoProductos = _useState20[0],
	      setHabilitadoProductos = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      tasaor = _useState22[0],
	      setTasaor = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0),
	      _useState24 = _slicedToArray(_useState23, 2),
	      idmoney = _useState24[0],
	      setIdmoney = _useState24[1];
	
	  var _useState25 = (0, _react.useState)([]),
	      _useState26 = _slicedToArray(_useState25, 2),
	      records = _useState26[0],
	      setRecords = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(null),
	      _useState28 = _slicedToArray(_useState27, 2),
	      idalmacen = _useState28[0],
	      setIdalmacen = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      mostrar = _useState30[0],
	      setMostrar = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(true),
	      _useState32 = _slicedToArray(_useState31, 2),
	      habilitado = _useState32[0],
	      setHabilitado = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(null),
	      _useState34 = _slicedToArray(_useState33, 2),
	      indice = _useState34[0],
	      setIndice = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(null),
	      _useState36 = _slicedToArray(_useState35, 2),
	      body = _useState36[0],
	      setBody = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(false),
	      _useState38 = _slicedToArray(_useState37, 2),
	      catregistrarcliente = _useState38[0],
	      setCatregistrarcliente = _useState38[1];
	
	  var _useState39 = (0, _react.useState)([]),
	      _useState40 = _slicedToArray(_useState39, 2),
	      combomoneda = _useState40[0],
	      setComboMoneda = _useState40[1];
	
	  var _useState41 = (0, _react.useState)([]),
	      _useState42 = _slicedToArray(_useState41, 2),
	      almacen = _useState42[0],
	      setAlmacen = _useState42[1];
	
	  var _useState43 = (0, _react.useState)([]),
	      _useState44 = _slicedToArray(_useState43, 2),
	      moviles = _useState44[0],
	      setMoviles = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(false),
	      _useState46 = _slicedToArray(_useState45, 2),
	      catalogoCliente = _useState46[0],
	      setCatalogoCliente = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(""),
	      _useState48 = _slicedToArray(_useState47, 2),
	      valparametro = _useState48[0],
	      setValparametro = _useState48[1];
	
	  var _useState49 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState50 = _slicedToArray(_useState49, 2),
	      mensaje = _useState50[0],
	      setMensaje = _useState50[1];
	
	  var _useState51 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState52 = _slicedToArray(_useState51, 2),
	      mensajesino = _useState52[0],
	      setMensajesino = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(0),
	      _useState54 = _slicedToArray(_useState53, 2),
	      fechav = _useState54[0],
	      setFechav = _useState54[1];
	
	  var _useState55 = (0, _react.useState)(false),
	      _useState56 = _slicedToArray(_useState55, 2),
	      activate = _useState56[0],
	      setActivate = _useState56[1];
	
	  var _useState57 = (0, _react.useState)(true),
	      _useState58 = _slicedToArray(_useState57, 2),
	      castabla = _useState58[0],
	      setCastabla = _useState58[1];
	
	  var _useState59 = (0, _react.useState)(true),
	      _useState60 = _slicedToArray(_useState59, 2),
	      esmovil = _useState60[0],
	      setEsmovil = _useState60[1];
	
	  var _useState61 = (0, _react.useState)({
	    idmoneda: "1",
	    descripcion: "BOLIVARES",
	    simbolo: "Bs",
	    predeterminada: true,
	    subpredeterminada: false,
	    valormoneda: 1.0
	  }),
	      _useState62 = _slicedToArray(_useState61, 2),
	      moneda = _useState62[0],
	      setMoneda = _useState62[1];
	
	  var _useState63 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState64 = _slicedToArray(_useState63, 2),
	      monedaSub = _useState64[0],
	      setMonedaSub = _useState64[1];
	
	  var _useState65 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState66 = _slicedToArray(_useState65, 2),
	      monedaCambio = _useState66[0],
	      setMonedaCambio = _useState66[1];
	
	  var _useState67 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    catalogoper: true
	  }),
	      _useState68 = _slicedToArray(_useState67, 2),
	      botones = _useState68[0],
	      setBotones = _useState68[1];
	
	  var _useState69 = (0, _react.useState)(false),
	      _useState70 = _slicedToArray(_useState69, 2),
	      acpt = _useState70[0],
	      setAcpt = _useState70[1];
	
	  var _useState71 = (0, _react.useState)(false),
	      _useState72 = _slicedToArray(_useState71, 2),
	      habilitadoNU = _useState72[0],
	      setHabilitadoNU = _useState72[1];
	
	  var _useState73 = (0, _react.useState)(0),
	      _useState74 = _slicedToArray(_useState73, 2),
	      operacion = _useState74[0],
	      setOperacion = _useState74[1];
	
	  var _useState75 = (0, _react.useState)({
	    idvendedor: "",
	    tiporif: "J",
	    rif: "",
	    nombre: "",
	    idalmacen: ""
	  }),
	      _useState76 = _slicedToArray(_useState75, 2),
	      vendedor = _useState76[0],
	      setVendedor = _useState76[1];
	
	  var _useState77 = (0, _react.useState)({
	    subtotal: 0.0,
	    descuento: 0.0,
	    exento: 0.0,
	    sujeto: 0.0,
	    iva: 16.0,
	    totaliva: 0.0,
	    total: 0.0
	  }),
	      _useState78 = _slicedToArray(_useState77, 2),
	      totales = _useState78[0],
	      setTotales = _useState78[1];
	
	  var nomtabla = void 0;
	
	  if (operacion === 4) {
	    nomtabla = [{ label: "COD-PRODUCTO", textAlign: "center", width: "40px" }, { label: "PRODUCTO", textAlign: "center", width: "100px" }, { label: "CANTIDAD", textAlign: "center", width: "20px" }, { label: "TIPO PRECIO", textAlign: "center", width: "50px" }, { label: "PRECIO UNI.", textAlign: "center", width: "50px" }, { label: "UND. ALT.", textAlign: "center", width: "50px" }, { label: "IVA.", textAlign: "center", width: "50px" }, { label: "MONTO", textAlign: "center", width: "50px" }, {
	      label: "",
	      textAlign: "center",
	      width: "20px"
	    }];
	  } else {
	    nomtabla = [{ label: "COD-PRODUCTO", textAlign: "center", width: "40px" }, { label: "PRODUCTO", textAlign: "center", width: "100px" }, { label: "EXISTENCIA", textAlign: "center", width: "30px" }, { label: "CANTIDAD", textAlign: "center", width: "20px" }, { label: "TIPO PRECIO", textAlign: "center", width: "50px" }, { label: "PRECIO UNI.", textAlign: "center", width: "50px" }, { label: "UND. ALT.", textAlign: "center", width: "50px" }, { label: "IVA.", textAlign: "center", width: "50px" }, { label: "MONTO", textAlign: "center", width: "50px" }, {
	      label: _react2.default.createElement("i", { className: "fas fa-trash" }),
	      textAlign: "center",
	      width: "20px"
	    }];
	  }
	
	  var headCells = nomtabla;
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var seleccionarAgente = function seleccionarAgente() {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "idagente";
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + idagente;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtNombreVendedor.current.value = response.data.nombre;
	          txtCedRifv.current.value = response.data.rif;
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarAlmacen = function seleccionarAlmacen() {
	    var campos = "*";
	    var nomtab = "almacen";
	    var orden = "idalmacen";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setAlmacen(response.data);
	        } else {
	          setAlmacen([]);
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un Almacen de venta",
	            icono: "informacion"
	          });
	          blanquear();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setTituloHeader("Servicios.");
	    setFechav(0);
	    setTasaor(0);
	    setHabilitadoProductos(true);
	    setAlmacen([]);
	    setMoviles([]);
	    setVendedor({
	      idvendedor: "",
	      tiporif: "J",
	      rif: "",
	      nombre: "",
	      idalmacen: ""
	    });
	    setNumval("");
	    txtId.current.value = "";
	    txtNombreCliente.current.value = "";
	    txtNombreVendedor.current.value = "";
	    txtCedRif.current.value = "";
	    txtCedRifv.current.value = "";
	    txtDirClient.current.value = "";
	    txtTotal.current.value = "";
	    txtTotalIva.current.value = "";
	    txtSubTotal.current.value = "";
	    txtCodigo.current.value = "";
	    txtFecha.current.value = (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD");
	    txtFormaPago.current.value = "3";
	    txtTipoOrdenCompra.current.value = "1";
	    setActivate(false);
	    setRecords([]);
	    setIndice(null);
	    setAcpt(false);
	    setComboMoneda([]);
	    setHabilitarCat(true);
	    setNumNota("");
	    setVisibleBtn("visible");
	    setCastabla(true);
	    setOperacion(0);
	    setHabilitado(true);
	    setHabilitadoNU(false);
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: false,
	      cancelar: false,
	      catalogo: true,
	      catalogoper: true
	    });
	    setMoneda({
	      idmoneda: "1",
	      descripcion: "BOLIVARES",
	      simbolo: "Bs",
	      predeterminada: false,
	      valormoneda: 1.0
	    });
	    setMonedaCambio({
	      idmoneda: "4",
	      descripcion: "DOLAR",
	      simbolo: "$",
	      predeterminada: false,
	      subpredeterminada: true,
	      valormoneda: 1.0
	    });
	    for (var i = 0; i < combomoneda.length; i++) {
	      if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
	        txtIdmoneda.current.selectedIndex = i;
	      }
	    }
	
	    setTotales({
	      subtotal: 0.0,
	      descuento: 0.0,
	      exento: 0.0,
	      sujeto: 0.0,
	      iva: 16.0,
	      totaliva: 0.0,
	      total: 0.0
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	
	    if (txtTipoOrdenCompra.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Tipo de Orden no debe ir Vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtTipoOrdenCompra.current.focus();
	    } else if (txtFormaPago.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Forma de Pago no debe ir Vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtFormaPago.current.focus();
	    } else if (txtCedRif.current.value.trim() === "" || txtNombreCliente.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "Debe seleccionar el Proveedor",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtCedRif.current.focus();
	    } else if (txtCedRifv.current.value === "" || txtCedRifv.current.value.trim() === "" || txtNombreVendedor.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "Debe seleccionar el Vendedor",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtCedRifv.current.focus();
	    } else if (txtFecha.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtFecha.current.focus();
	    } else if (records.length === 0) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "No hay Producto agregados",
	        icono: "informacion"
	      });
	      sigue = false;
	      btnCancela.current.focus();
	    }
	
	    if (sigue) {
	      var orden = [];
	      var ordendeta = [];
	      var tasa = 0.0;
	      var opeinv = [];
	      var opeinvdet = [];
	
	      tasa = monedaSub.valormoneda;
	
	      orden.push({
	        idorden: operacion === 1 ? 0 : txtCodigo.current.value,
	        numorden: numNota,
	        cedularif: txtCedRif.current.value,
	        descripcion: txtTipoOrdenCompra.current.value === "1" ? "VENTA DE PRODUCTOS" : "ORDEN DE SERVICIO",
	        totalmonto: totales.total,
	        totaliva: totales.totaliva,
	        totaldescuento: totales.descuento,
	        totalsujeto: totales.sujeto,
	        totalexento: totales.exento,
	        idcliente: idCliente,
	        idvendedor: operacion === 1 ? idagente : idVendedor,
	        fecha: txtFecha.current.value,
	        status: 0,
	        idmoneda: monedaSub.idmoneda,
	        idoperacioninventario: operacion === 1 ? 0 : txtOpeInventario.current.value,
	        tipoorden: txtTipoOrdenCompra.current.value,
	        formapago: txtFormaPago.current.value,
	        fechavence: txtFormaPago.current.value === "4" ? txtFechaVencimiento.current.value : null,
	        valormoneda: tasa,
	        idmovil: txtTipoOrdenCompra.current.value === "1" ? null : txtIdmovil.current.value
	      });
	
	      opeinv.push({
	        idoperacioninventario: operacion === 1 ? 0 : txtOpeInventario.current.value,
	        tipooperacion: "SALIDA",
	        idalmacenorigen: txtIdalmacen.current.value,
	        idalmacendestino: "",
	        fecha: txtFecha.current.value,
	        idmoneda: monedaSub.idmoneda,
	        observacion: txtTipoOrdenCompra.current.value === "1" ? "VENTA" : "ORDEN DE SERVICIO"
	      });
	
	      for (var i = 0; i < records.length; i++) {
	        ordendeta.push({
	          idproducto: records[i].idproducto,
	          cantidad: records[i].cantidad,
	          iva: records[i].iva,
	          punitario: records[i].precio,
	          descuento: "0.00",
	          tipounidad: records[i].tipounidad,
	          idunidadmedida: records[i].idunidadmedida,
	          idunidadalterna: records[i].idunidadalterna,
	          tasa: monedaSub.valormoneda,
	          codproducto: records[i].codigo,
	          costo: records[i].costocalculado,
	          utilidad: records[i].utipreciomaxi,
	          tipopreciodeta: records[i].tipoprecio,
	          idalmacen: records[i].idalmacen
	        });
	
	        opeinvdet.push({
	          idproducto: records[i].idproducto,
	          nombre: records[i].nombrecorto,
	          cantidad: records[i].cantidad,
	          precio: records[i].precio,
	          fechavencimiento: txtFormaPago.current.value === "4" ? txtFechaVencimiento.current.value : null,
	          tipomovimiento: txtTipoOrdenCompra.current.value === "1" ? "VENTA" : "SERVICIO",
	          fechatipomovimiento: txtFecha.current.value,
	          numfactura: numNota,
	          idalmacen: records[i].idalmacen,
	          tipounidad: records[i].tipounidad,
	          idunidadmedida: records[i].idunidadmedida,
	          idunidadalterna: records[i].idunidadalterna,
	          tipofactor: records[i].tipofactor,
	          valorfactor: records[i].valorfactor,
	          tasa: monedaSub.valormoneda
	        });
	      }
	
	      setBody({
	        orden: orden,
	        ordendeta: ordendeta,
	        idtipopeinv: "2",
	        opeinv: opeinv,
	        opeinvdet: opeinvdet
	      });
	
	      setDesde(2);
	      var msg = "";
	      if (operacion === 1) {
	        msg = "¿Esta Seguro de Registrar estos Datos?.";
	      } else if (operacion === 2) {
	        msg = "¿Esta Seguro de Modificar estos Datos?.";
	      } else if (operacion === 3) {
	        msg = "¿Esta Seguro de Eliminar estos Datos?.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/servicios/actualizarordenes/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "¡Registro " + response.data.idord + " Creado Correctamente!",
	            icono: "exito"
	          });
	          /* window.open(op.reportes + "reporte=Pedido" + "&CODIGO=" + response.data.idpe, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"); */
	          if (txtFormaPago.current.value === "4") {
	            txtFechaVencimiento.current.value = (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD");
	          }
	        } else if (operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "¡Registro " + response.data.idord + " Modificado Correctamente!",
	            icono: "exito"
	          });
	          if (txtFormaPago.current.value === "4") {
	            txtFechaVencimiento.current.value = (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD");
	          }
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "¡Registro " + response.data.idord + " Eliminado Correctamente!",
	            icono: "exito"
	          });
	        }
	
	        blanquear();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = "";
	      if (error.response === undefined) {
	        mensaje = "Error de Conexion";
	      } else {
	        mensaje = error.response.data.message;
	      }
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    if (desde === 1) {
	      var prod = records;
	      setDesde(0);
	      setRecords(prod);
	    } else if (desde === 2) {
	      setDesde(0);
	      procesarRegistro();
	    }
	  };
	
	  var seleccionarProducto = function seleccionarProducto(index, idubi, idprod) {
	    var endpoint = op.conexion + "/api/inventario/seleccionarproductoinv?idproducto='" + idprod.toUpperCase() + "'&idalmacen=" + idubi;
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var data = [].concat(_toConsumableArray(records));
	        if (response.data !== "") {
	          if (response.data.servicio) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "no existe un producto con ese codigo en el almacen.",
	              icono: "error"
	            });
	            txtCantidad.current[records.length - 1].value = "1,00";
	          } else {
	            for (var i = 0; i < records.length; i++) {
	              if (records[i].idproducto === response.data.idproducto) {
	                setActivate(false);
	                setMensaje({
	                  mostrar: true,
	                  titulo: "Notificacion",
	                  texto: "el producto ya ha sido seleccionado.",
	                  icono: "error"
	                });
	                return;
	              }
	            }
	
	            var uni = [];
	            var precio = 0.0;
	            var montoiva = 0.0;
	            var cantie = response.data.cantidad;
	            var tipouni = 0;
	            var tiene_iva = false;
	            var tipoprecio = parseInt(response.data.tipoprecio);
	
	            if (parseFloat(response.data.ivaventa) > 0.0) {
	              tiene_iva = true;
	            }
	
	            if (parseInt(response.data.tipofactor) === 0 || response.data.tipofactor === null) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data.idunidadmedida,
	                descripcion: response.data.descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data.cantidad);
	              cantie = Math.trunc(cantie);
	
	              if (tipoprecio === 1) {
	                precio = parseFloat(response.data.preciomaxi);
	              } else if (tipoprecio === 2) {
	                precio = parseFloat(response.data.precioofe);
	              } else if (tipoprecio === 3) {
	                precio = parseFloat(response.data.preciomayor);
	              } else if (tipoprecio === 4) {
	                precio = parseFloat(response.data.preciomini);
	              }
	
	              /* precio =
	                response.data.costocalculado *
	                (1 + response.data.utipreciomaxi / 100);
	              precio = Math.round(precio * 100) / 100; 
	               montoiva = (precio * response.data.ivaventa) / 100;*/
	            } else {
	              if (response.data.idunidadventa === response.data.idunidadalterna) {
	                tipouni = 1;
	                uni = [{
	                  idunidad: response.data.idunidadalterna,
	                  descripcion: response.data.descripcionunialt,
	                  tipo: "alterna"
	                }, {
	                  idunidad: response.data.idunidadmedida,
	                  descripcion: response.data.descripcionuni,
	                  tipo: "medida"
	                }];
	
	                cantie = parseFloat(response.data.cantidad);
	                cantie = Math.trunc(cantie);
	                if (tipoprecio === 1) {
	                  precio = parseFloat(response.data.preciomaxialter);
	                } else if (tipoprecio === 2) {
	                  precio = parseFloat(response.data.precioofealter);
	                } else if (tipoprecio === 3) {
	                  precio = parseFloat(response.data.preciomayoralter);
	                } else if (tipoprecio === 4) {
	                  precio = parseFloat(response.data.preciominialter);
	                }
	
	                /*                   precio =
	                  response.data.costocalculadoalter *
	                  (1 + response.data.utipreciomaxialter / 100);
	                precio = Math.round(precio * 100) / 100;
	                 montoiva = (precio * response.data.ivaventa) / 100; */
	              } else if (response.data.idunidadventa === response.data.idunidadmedida) {
	                tipouni = 0;
	                uni = [{
	                  idunidad: response.data.idunidadmedida,
	                  descripcion: response.data.descripcionuni,
	                  tipo: "medida"
	                }, {
	                  idunidad: response.data.idunidadalterna,
	                  descripcion: response.data.descripcionunialt,
	                  tipo: "alterna"
	                }];
	
	                cantie = parseFloat(response.data.cantidad / response.data.valorfactor);
	                cantie = Math.trunc(cantie);
	
	                if (tipoprecio === 1) {
	                  precio = parseFloat(response.data.preciomaxi);
	                } else if (tipoprecio === 2) {
	                  precio = parseFloat(response.data.precioofe);
	                } else if (tipoprecio === 3) {
	                  precio = parseFloat(response.data.preciomayor);
	                } else if (tipoprecio === 4) {
	                  precio = parseFloat(response.data.preciomini);
	                }
	
	                /*precio =
	                  response.data.costocalculado *
	                  (1 + response.data.utipreciomaxi / 100);
	                precio = Math.round(precio * 100) / 100;
	                 montoiva = (precio * response.data.ivaventa) / 100; */
	              }
	            }
	
	            if (index !== null) {
	              data[index] = {
	                idproducto: response.data.idproducto,
	                codigo: response.data.codigo,
	                cantidad: 1.0,
	                cantidadE: cantie,
	                cantidadEA: parseFloat(response.data.cantidad),
	                nombrecorto: response.data.nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	                precio: precio,
	                preciobs: 0.0,
	                preciomaxi: response.data.preciomaxi,
	                precioofe: response.data.precioofe,
	                preciomayor: response.data.preciomayor,
	                preciomini: response.data.preciomini,
	                preciomaxialter: response.data.preciomaxialter,
	                precioofealter: response.data.precioofealter,
	                preciomayoralter: response.data.preciomayoralter,
	                preciominialter: response.data.preciominialter,
	                iva: response.data.ivaventa,
	                montoiva: montoiva,
	                descuento: 0.0,
	                total: precio,
	                unidad: uni,
	                idunidadmedida: response.data.idunidadmedida,
	                idunidadalterna: response.data.idunidadalterna,
	                idalmacen: response.data.idalmacen,
	                idmoneda: response.data.idmoneda,
	                valormoneda: monedaCambio.valormoneda,
	                tipounidad: tipouni,
	                tipofactor: response.data.tipofactor,
	                valorfactor: response.data.valorfactor,
	                tipoprecio: response.data.tipoprecio
	              };
	            } else {
	              data.push({
	                idproducto: response.data.idproducto,
	                codigo: response.data.codigo,
	                cantidad: 1.0,
	                cantidadE: cantie,
	                cantidadEA: parseFloat(response.data.cantidad),
	                nombrecorto: response.data.nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	                precio: precio,
	                preciomaxi: response.data.preciomaxi,
	                precioofe: response.data.precioofe,
	                preciomayor: response.data.preciomayor,
	                preciomini: response.data.preciomini,
	                preciomaxialter: response.data.preciomaxialter,
	                precioofealter: response.data.precioofealter,
	                preciomayoralter: response.data.preciomayoralter,
	                preciominialter: response.data.preciominialter,
	                preciobs: 0.0,
	                iva: response.data.ivaventa,
	                montoiva: montoiva,
	                descuento: 0.0,
	                total: precio,
	                unidad: uni,
	                idunidadmedida: response.data.idunidadmedida,
	                idunidadalterna: response.data.idunidadalterna,
	                idalmacen: response.data.idalmacen,
	                idmoneda: response.data.idmoneda,
	                valormoneda: monedaCambio.valormoneda,
	                tipounidad: tipouni,
	                tipofactor: response.data.tipofactor,
	                valorfactor: response.data.valorfactor,
	                tipoprecio: response.data.tipoprecio
	              });
	            }
	
	            setRecords(data);
	            setTotales((0, _varios.calcularTotales)(data));
	            setIndice(index);
	
	            if (index !== null) {
	              setTimeout(function () {
	                return txtCantidad.current[index].focus();
	              }, 300);
	            } else {
	              setTimeout(function () {
	                return txtCantidad.current[data.length - 1].focus();
	              }, 300);
	            }
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "no existe un producto con ese codigo en el almacen.",
	            icono: "error"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarDetalle = function seleccionarDetalle(idorden) {
	    var nomtab1 = "ordenes_detalle";
	    var nomtab2 = "ordenes";
	    var nomid = "idorden";
	    var endpoint = op.conexion + "/api/servicios/seleccionarordenesdet?id=" + idorden + "&nomtab1=" + nomtab1 + "&nomtab2=" + nomtab2 + "&nomid=" + nomid;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	
	          var prod = [];
	          var uni = [];
	          var montoiva = 0.0;
	          var cantie = 0.0;
	          var cantiea = 0.0;
	          var tipouni = 0;
	          var tiene_iva = false;
	
	          for (var i = 0; i < response.data.length; i++) {
	            if (parseFloat(response.data[i].iva) > 0.0) {
	              tiene_iva = true;
	            }
	            if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) <= 0.0) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantiea = Math.trunc(cantiea);
	            } else if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) > 0.0) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }, {
	                idunidad: response.data[i].idunidadalterna,
	                descripcion: response.data[i].descripcionunialt,
	                tipo: "alterna"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) / parseFloat(response.data[i].valorfactor) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) / parseFloat(response.data[i].valorfactor) + parseFloat(response.data[i].cantidad);
	
	              cantiea = cantiea * parseFloat(response.data[i].valorfactor);
	              cantiea = Math.trunc(cantiea);
	            } else if (response.data[i].tipounidad === 1) {
	              tipouni = 1;
	              uni = [{
	                idunidad: response.data[i].idunidadalterna,
	                descripcion: response.data[i].descripcionunialt,
	                tipo: "alterna"
	              }, {
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantiea = Math.trunc(cantiea);
	            }
	
	            prod.push({
	              idproducto: response.data[i].idproducto,
	              codigo: response.data[i].codigo,
	              cantidad: response.data[i].cantidad,
	              cantidadE: parseFloat(cantie),
	              cantidadEA: parseFloat(cantiea),
	              nombrecorto: response.data[i].nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	              precio: response.data[i].punitario,
	              preciobs: response.data[i].punitariobs,
	              preciomaxi: response.data[i].preciomaxi,
	              precioofe: response.data[i].precioofe,
	              preciomayor: response.data[i].preciomayor,
	              preciomini: response.data[i].preciomini,
	              preciomaxialter: response.data[i].preciomaxialter,
	              precioofealter: response.data[i].precioofealter,
	              preciomayoralter: response.data[i].preciomayoralter,
	              preciominialter: response.data[i].preciominialter,
	              iva: response.data[i].iva,
	              ivaventa: response.data[i].ivaventa,
	              montoiva: response.data[i].cantidad * montoiva,
	              descuento: response.data[i].descuento,
	              total: response.data[i].cantidad * response.data[i].punitario,
	              unidad: uni,
	              idunidadmedida: response.data[i].idunidadmedida,
	              idunidadalterna: response.data[i].idunidadalterna,
	              costocalculado: response.data[i].costocalculado,
	              costocalculadoalter: response.data[i].costocalculadoalter,
	              utipreciomaxi: response.data[i].utipreciomaxi,
	              utipreciomaxialter: response.data[i].utipreciomaxialter,
	              tipounidad: tipouni,
	              valormoneda: monedaCambio.valormoneda,
	              idmoneda: response.data[i].idmoneda,
	              tipofactor: response.data[i].tipofactor,
	              valorfactor: response.data[i].valorfactor,
	              tipoprecio: response.data[i].tipopreciodeta
	            });
	          }
	
	          setRecords(prod);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var agregarProducto = function agregarProducto(producto) {
	    setMostrar(false);
	    seleccionarProducto(indice, txtIdalmacen.current.value, producto.codigo);
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (accgservicios && accgservicios.toString().substring(0, 1) === "1") {
	          setVisibleBtn("hidden");
	          setHabilitadoProductos(false);
	          setTituloHeader("Incluir Servicio.");
	          setHabilitado(false);
	          seleccionarMonedas();
	          seleccionarAgente();
	          seleccionarAlmacen();
	          setCastabla(false);
	          setOperacion(1);
	          setAcpt(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            catalogoper: false
	          });
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (accgservicios && accgservicios.toString().substring(1, 2) === "1") {
	          setTituloHeader("Editar Servicio.");
	          setVisibleBtn("hidden");
	          setHabilitado(false);
	          seleccionarMonedas();
	          setCatalogoPresu(true);
	          seleccionarAlmacen();
	          setHabilitarCat(false);
	          setCastabla(false);
	          setAcpt(false);
	          setOperacion(2);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (accgservicios && accgservicios.toString().substring(3, 4) === "1") {
	          setTituloHeader("Eliminar Servicio.");
	          setVisibleBtn("hidden");
	          setHabilitado(false);
	          setCatalogoPresu(true);
	          seleccionarMonedas();
	          setAcpt(false);
	          setHabilitarCat(false);
	          setCastabla(true);
	          setOperacion(3);
	          seleccionarAlmacen();
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (accgservicios && accgservicios.toString().substring(2, 3) === "1") {
	          setTituloHeader("Consultar Servicio.");
	          setVisibleBtn("hidden");
	          seleccionarMonedas();
	          setAcpt(true);
	          setHabilitado(true);
	          setCastabla(true);
	          setOperacion(4);
	          setHabilitarCat(false);
	          setHabilitadoNU(true);
	          setDesde(7);
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 6) {
	        setVisibleBtn("visible");
	        blanquear();
	      }
	    };
	  };
	
	  var seleccionarMonedas = function seleccionarMonedas() {
	    var campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	    var nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	    var orden = "m.idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var x = 0;
	        if (response.data.length > 0) {
	          setComboMoneda(response.data);
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].subpredeterminada) {
	              setMonedaSub(response.data[i]);
	              setIdmoney(response.data[i].idmoneda);
	              setMonedaCambio({
	                idmoneda: response.data[i].idmoneda,
	                descripcion: response.data[i].descripcion,
	                simbolo: response.data[i].simbolo,
	                predeterminada: response.data[i].predeterminada,
	                subpredeterminada: response.data[i].subpredeterminada,
	                valormoneda: 1.0
	              });
	              x = i;
	            } else if (response.data[i].predeterminada) {
	              setMoneda(response.data[i]);
	            }
	          }
	        }
	        setTimeout(function () {
	          return txtIdmoneda.current.selectedIndex = x;
	        }, 200);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = "*";
	    var nomtab = "ordenes";
	    var nomid = "idorden";
	    var id = txtCodigo.current.value;
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setTasaor(response.data.tasa);
	          txtFecha.current.value = (0, _moment2.default)(response.data.fecha).format("YYYY-MM-DD");
	          setNumNota(response.data.numorden);
	          txtCedRif.current.value = response.data.cedularif;
	          txtOpeInventario.current.value = response.data.idoperacioninventario;
	          txtTipoOrdenCompra.current.value = parseInt(response.data.tipoorden);
	          txtFormaPago.current.value = parseInt(response.data.formapago);
	          if (parseInt(response.data.formapago) === 4) {
	            setFechav(1);
	            txtFechaVencimiento.current.value = (0, _moment2.default)(response.data.fechavence).format("YYYY-MM-DD");
	          } else {
	            setFechav(0);
	          }
	
	          //seleccionarMoneda(response.data.idmoneda);
	          seleccionarDetalle(response.data.idorden);
	
	          setTotales({
	            subtotal: response.data.totalmonto - response.data.totaliva,
	            descuento: response.data.totaldescuento,
	            exento: response.data.totalexento,
	            sujeto: response.data.totalsujeto,
	            iva: 16.0,
	            totaliva: response.data.totaliva,
	            total: response.data.totalmonto
	          });
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "ID no existe.",
	            icono: "informacion"
	          });
	          txtCodigo.current.value = "";
	          txtCodigo.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var handleInputNumeroChange = function handleInputNumeroChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "idordendecompra") {
	          seleccionarRegistro();
	        }
	      }
	    }
	  };
	
	  var onCatalogoPresupuesto = function onCatalogoPresupuesto(values) {
	    setCatalogoPresu(false);
	    txtCodigo.current.value = values.idorden;
	    seleccionarRegistro();
	  };
	
	  var onChangeMoneda = function onChangeMoneda(e) {
	    var i = e.target.value;
	    var cambio = (0, _varios.onCambioMoneda)({
	      moneda: combomoneda[i],
	      productos: records,
	      monedaPre: moneda,
	      monedaSub: monedaSub
	    });
	    setMonedaCambio(cambio.monedacambio);
	    setRecords(cambio.data);
	  };
	
	  var imprimirOrdendeCompra = function imprimirOrdendeCompra() {
	    if (accgservicios && accgservicios.toString().substring(4, 5) === "1") {
	      if (txtCodigo.current.value !== "") {
	        var id = txtCodigo.current.value;
	        window.open(op.reportes + "reporte=Ordencompra" + "&CODIGO=" + id, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      }
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarMonedas();
	  }, []);
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === "almacen") {
	      setIdalmacen(e.target.value);
	    }
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 ", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-8 mx-auto py-2 card shadow " },
	          _react2.default.createElement(
	            "div",
	            {
	              className: "col-md-12 row border-azul mx-auto justify-content-between rounded py-2",
	              style: { fontSizeAdjust: "0.6" }
	            },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light d-flex align-items-center" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-5" },
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  tituloHeader
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-1 ml-auto" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "/inicio", className: "text-light " },
	                  _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "fw-bold" },
	                    "Salir"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row px-0 m-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-220 mb-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CODIGO:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "text",
	                    name: "idordendecompra",
	                    onKeyUp: handleInputNumeroChange,
	                    disabled: habilitado,
	                    ref: txtCodigo,
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      type: "button",
	                      onClick: function onClick() {
	                        return setCatalogoPresu(true);
	                      },
	                      disabled: habilitarCat,
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-330 mb-1 mx-auto px-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO DE MONEDA:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-control form-control-sm form-select fw-bold fs-6",
	                      disabled: operacion === 3 || operacion === 0 ? true : false,
	                      ref: txtIdmoneda,
	                      onChange: onChangeMoneda
	                    },
	                    combomoneda && combomoneda.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: index },
	                        " ",
	                        item.descripcion + " " + item.simbolo + " " + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                        " "
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-2 mb-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-control form-control-sm form-select fw-bold fs-6",
	                      disabled: true,
	                      name: "almacen",
	                      ref: txtIdalmacen,
	                      onChange: onChange
	                    },
	                    almacen && almacen.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idalmacen },
	                        " ",
	                        "" + item.descripcion,
	                        " "
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement("input", { type: "hidden", ref: txtOpeInventario }),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-220 ml-auto mb-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA:"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "date",
	                    disabled: castabla,
	                    className: "form-control text-uppercase fs-6",
	                    ref: txtFecha,
	                    "aria-label": "Sizing example input",
	                    defaultValue: (0, _moment2.default)(fechaSistema).format("YYYY-MM-DD"),
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 mb-2 py-1" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row border-azul rounded py-2" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 mb-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "NOMBRE:",
	                      " "
	                    ),
	                    _react2.default.createElement("textarea", {
	                      autoComplete: "off",
	                      type: "text",
	                      disabled: habilitado,
	                      style: { height: '40px' },
	                      ref: txtCedRif,
	                      className: "form-control bg-transparent fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-100 px-2 mb-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "IVA:",
	                      " "
	                    ),
	                    _react2.default.createElement("input", {
	                      autoComplete: "off",
	                      type: "text",
	                      disabled: habilitado,
	                      ref: txtDirClient,
	                      className: "form-control bg-transparent fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-3 mb-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "MONTO:",
	                      " "
	                    ),
	                    _react2.default.createElement("input", {
	                      autoComplete: "off",
	                      type: "text",
	                      disabled: habilitado,
	                      ref: txtDirClient,
	                      className: "form-control bg-transparent fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row m-0 px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-8 mt-auto" },
	                visibleBtn === "visible" ? _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-botones" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 row m-0" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: botones.incluir,
	                        onClick: onBotones(1),
	                        className: "btn btn-sm col ml-1 mb-1 btn-primary rounded-pill",
	                        title: "Incluir Almacen"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-plus" },
	                        " Incluir "
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: botones.consultar,
	                        onClick: onBotones(4),
	                        className: "btn btn-sm col ml-1 mb-1 btn-info rounded-pill",
	                        title: "Consultar Almacen"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-eye" },
	                        " Consultar"
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: botones.modificar,
	                        onClick: onBotones(2),
	                        className: "btn btn-sm col ml-1 mb-1 btn-warning rounded-pill",
	                        title: "Modificar Almacen"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fa fa-edit" },
	                        " Modificar"
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: botones.eliminar,
	                        onClick: onBotones(3),
	                        className: "btn btn-sm col ml-1 mb-1 btn-danger rounded-pill",
	                        title: "Eliminar Almacen"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fa fa-trash" },
	                        " Eliminar"
	                      ),
	                      " "
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-360 row m-0 ml-auto" },
	                  habilitadoNU === true ? _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnAcepta,
	                      onClick: imprimirOrdendeCompra,
	                      disabled: txtCodigo.current.value !== "" ? false : true,
	                      className: "btn btn-sm rounded-pill col ml-1 btn-primary"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-print" },
	                      " Imprimir"
	                    )
	                  ) : "",
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnAcepta,
	                      disabled: acpt,
	                      onClick: onChangeValidar,
	                      className: "btn btn-sm col ml-1 rounded-pill btn-success"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-check-circle" },
	                      " Aceptar"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnCancela,
	                      onClick: onBotones(6),
	                      className: "btn btn-danger col ml-1 btn-sm rounded-pill"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-window-close" },
	                      " Cancelar"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoProducto2.default, {
	      show: mostrar,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar(false);
	      },
	      onHideAceptaCatalogo: agregarProducto
	    }),
	    _react2.default.createElement(_catalogoOrdenes2.default, {
	      show: catalogoPresu,
	      ope: operacion,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoPresu(false);
	      },
	      onHideAceptaCatalogo: onCatalogoPresupuesto
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = TablapServicios;

/***/ },
/* 7149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	/*import { ConfigMina } from './configuracionesDeModulos/modalConfigMinas';
	import { ConfigProduccion } from './configuracionesDeModulos/modalConfigProduc'; */
	
	
	/* Almacen */
	
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _auth = __webpack_require__(106);
	
	var _reactRouterDom = __webpack_require__(155);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _modalVerConfiguracion = __webpack_require__(7141);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _gestionarUnidadMedida = __webpack_require__(213);
	
	var _gestionarDepartamento = __webpack_require__(661);
	
	var _gestionarMarca = __webpack_require__(211);
	
	var _gestionarModelo = __webpack_require__(212);
	
	var _gestionarProducto = __webpack_require__(662);
	
	var _gestionarTipoProducto = __webpack_require__(297);
	
	var _gestionarBanco = __webpack_require__(7111);
	
	var _gestionarUbicacioes = __webpack_require__(7050);
	
	var _modalVerConfiguracionAthos = __webpack_require__(7142);
	
	var _gestionarTipoVacio = __webpack_require__(7049);
	
	var _modalImprimirProductos = __webpack_require__(7058);
	
	var _modalImprimirNDebitos = __webpack_require__(7165);
	
	var _modalImprimirCtasxCobrarEstadoCuenta = __webpack_require__(7121);
	
	var _modalPermisosusuario = __webpack_require__(7043);
	
	var _mensajes = __webpack_require__(9);
	
	var _ImprimirRecibosdePagos = __webpack_require__(7108);
	
	var _ImprimirOpInventarios = __webpack_require__(7046);
	
	var _gestionarFabricante = __webpack_require__(296);
	
	var _ImprimirMovimientosVentas = __webpack_require__(7045);
	
	var _modalImprimirAnticipos = __webpack_require__(7119);
	
	var _impMovBanSegunLibro = __webpack_require__(7112);
	
	var _ImprimirMovimientosVentasP = __webpack_require__(7157);
	
	var _ImprimirCompras = __webpack_require__(7074);
	
	var _gestionarClasificadorVacios = __webpack_require__(302);
	
	var _modalPermisosServicios = __webpack_require__(673);
	
	var _modalImprimirNCredito = __webpack_require__(7164);
	
	var _gestionarServicios = __webpack_require__(7144);
	
	var _imprimirIngresos = __webpack_require__(7113);
	
	var _modalImprimirAnticiposxVendedor = __webpack_require__(7120);
	
	var _modalImprimirDeudaGeneral = __webpack_require__(7122);
	
	var _modalImprimirControlVacios = __webpack_require__(7152);
	
	var _imprimirOpObsequio = __webpack_require__(7051);
	
	var _ImprimirPedidosPendientes = __webpack_require__(7158);
	
	var _imprimirRecibosReversado = __webpack_require__(7114);
	
	var _modalClientes = __webpack_require__(7161);
	
	var _modalReportePicking = __webpack_require__(7168);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Sidebar(props) {
	  _moment2.default.locale("es");
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	
	  var logo = JSON.parse(sessionStorage.getItem("logo"));
	  var rif = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var organizacion = JSON.parse(sessionStorage.getItem("organizacion"));
	  var idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var iduser = JSON.parse(sessionStorage.getItem("idusuario"));
	
	  var txtmodulo = JSON.parse(sessionStorage.getItem("txtmodulo"));
	  var txtfranquicia = JSON.parse(sessionStorage.getItem("txtfranquicia"));
	
	  var permisos = JSON.parse(sessionStorage.getItem("permisos"));
	  var accinventario = JSON.parse(sessionStorage.getItem("accinventarioc"));
	  var accventas = JSON.parse(sessionStorage.getItem("accventasc"));
	  var acccompras = JSON.parse(sessionStorage.getItem("acccomprasc"));
	  var accbtncreports = JSON.parse(sessionStorage.getItem("accbtncreportsc"));
	  var acccontabilidad = JSON.parse(sessionStorage.getItem("acccontabilidadc"));
	  var accfinanzas = JSON.parse(sessionStorage.getItem("accfinanzasc"));
	  var accbtnireports = JSON.parse(sessionStorage.getItem("accbtnireportsc"));
	  var accbtnvreports = JSON.parse(sessionStorage.getItem("accbtnvreportsc"));
	  var accbtnfreports = JSON.parse(sessionStorage.getItem("accbtnfreportsc"));
	  var accvacios = JSON.parse(sessionStorage.getItem("accvaciosc"));
	  var accservicios = JSON.parse(sessionStorage.getItem("accserviciosc"));
	  var btnreportvacios = JSON.parse(sessionStorage.getItem("btnreportvaciosc"));
	  var accpostventas = JSON.parse(sessionStorage.getItem("accpostventasc"));
	  console.log(accfinanzas);
	  /* modals */
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      mostrarMedida = _useState2[0],
	      setMostrarMedida = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      mostrarDepart = _useState4[0],
	      setMostrarDepart = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mostrarMarca = _useState6[0],
	      setMostrarMarca = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mostrarModelo = _useState8[0],
	      setMostrarModelo = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mostrarProducto = _useState10[0],
	      setMostrarProducto = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mostrarTipoProducto = _useState12[0],
	      setMostrarTipoProducto = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mostrarBanco = _useState14[0],
	      setMostrarBanco = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(""),
	      _useState16 = _slicedToArray(_useState15, 2),
	      creport = _useState16[0],
	      setCreport = _useState16[1];
	
	  var _useState17 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState18 = _slicedToArray(_useState17, 2),
	      mensaje = _useState18[0],
	      setMensaje = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(""),
	      _useState20 = _slicedToArray(_useState19, 2),
	      creportestc = _useState20[0],
	      setCreportestc = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(""),
	      _useState22 = _slicedToArray(_useState21, 2),
	      tipopermi = _useState22[0],
	      setTipopermi = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(false),
	      _useState24 = _slicedToArray(_useState23, 2),
	      mostrarUbicaciones = _useState24[0],
	      setMostrarUbicaciones = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(false),
	      _useState26 = _slicedToArray(_useState25, 2),
	      mostrarTipoVacio = _useState26[0],
	      setMostrarTipoVacio = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(false),
	      _useState28 = _slicedToArray(_useState27, 2),
	      mostrarReportProductos = _useState28[0],
	      setMostrarReportProductos = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      mostrarReportNDebitos = _useState30[0],
	      setMostrarReportNDebitos = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(false),
	      _useState32 = _slicedToArray(_useState31, 2),
	      mostrarReportNCredito = _useState32[0],
	      setMostrarReportNCredito = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(false),
	      _useState34 = _slicedToArray(_useState33, 2),
	      mpermisousuarios = _useState34[0],
	      setMpermisousuarios = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(false),
	      _useState36 = _slicedToArray(_useState35, 2),
	      mostrarReportEsc = _useState36[0],
	      setMostrarReportEsc = _useState36[1];
	
	  var _useContext = (0, _react.useContext)(_auth.AuthContext),
	      user = _useContext.user,
	      logout = _useContext.logout;
	
	  var fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	
	  var _useState37 = (0, _react.useState)(""),
	      _useState38 = _slicedToArray(_useState37, 2),
	      valrport = _useState38[0],
	      setValrport = _useState38[1];
	
	  var _useState39 = (0, _react.useState)("Panel de Control"),
	      _useState40 = _slicedToArray(_useState39, 2),
	      tituloNav = _useState40[0],
	      setTituloNav = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(false),
	      _useState42 = _slicedToArray(_useState41, 2),
	      verConfiguracion = _useState42[0],
	      setVerConfiguracion = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(false),
	      _useState44 = _slicedToArray(_useState43, 2),
	      verConfiguAthos = _useState44[0],
	      setVerConfiguAthos = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(false),
	      _useState46 = _slicedToArray(_useState45, 2),
	      mostrar = _useState46[0],
	      setMostrar = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(false),
	      _useState48 = _slicedToArray(_useState47, 2),
	      mostrar1 = _useState48[0],
	      setMostrar1 = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(false),
	      _useState50 = _slicedToArray(_useState49, 2),
	      mostrar2 = _useState50[0],
	      setMostrar2 = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(false),
	      _useState52 = _slicedToArray(_useState51, 2),
	      mostrar3 = _useState52[0],
	      setMostrar3 = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(false),
	      _useState54 = _slicedToArray(_useState53, 2),
	      mostrar4 = _useState54[0],
	      setMostrar4 = _useState54[1];
	
	  var _useState55 = (0, _react.useState)(false),
	      _useState56 = _slicedToArray(_useState55, 2),
	      mostrar5 = _useState56[0],
	      setMostrar5 = _useState56[1];
	
	  var _useState57 = (0, _react.useState)(false),
	      _useState58 = _slicedToArray(_useState57, 2),
	      mostrar6 = _useState58[0],
	      setMostrar6 = _useState58[1];
	
	  var _useState59 = (0, _react.useState)(false),
	      _useState60 = _slicedToArray(_useState59, 2),
	      mostrar7 = _useState60[0],
	      setMostrar7 = _useState60[1];
	
	  var _useState61 = (0, _react.useState)(false),
	      _useState62 = _slicedToArray(_useState61, 2),
	      mostrar8 = _useState62[0],
	      setMostrar8 = _useState62[1];
	
	  var _useState63 = (0, _react.useState)(false),
	      _useState64 = _slicedToArray(_useState63, 2),
	      mostrar9 = _useState64[0],
	      setMostrar9 = _useState64[1];
	
	  var _useState65 = (0, _react.useState)(false),
	      _useState66 = _slicedToArray(_useState65, 2),
	      mostrar10 = _useState66[0],
	      setMostrar10 = _useState66[1];
	
	  var _useState67 = (0, _react.useState)(false),
	      _useState68 = _slicedToArray(_useState67, 2),
	      mostrar11 = _useState68[0],
	      setMostrar11 = _useState68[1];
	
	  var _useState69 = (0, _react.useState)(false),
	      _useState70 = _slicedToArray(_useState69, 2),
	      mostrar12 = _useState70[0],
	      setMostrar12 = _useState70[1];
	
	  var _useState71 = (0, _react.useState)(false),
	      _useState72 = _slicedToArray(_useState71, 2),
	      mostrar13 = _useState72[0],
	      setMostrar13 = _useState72[1];
	
	  var _useState73 = (0, _react.useState)(false),
	      _useState74 = _slicedToArray(_useState73, 2),
	      mostrar14 = _useState74[0],
	      setMostrar14 = _useState74[1];
	
	  var _useState75 = (0, _react.useState)(false),
	      _useState76 = _slicedToArray(_useState75, 2),
	      mostrar15 = _useState76[0],
	      setMostrar15 = _useState76[1];
	
	  var _useState77 = (0, _react.useState)(false),
	      _useState78 = _slicedToArray(_useState77, 2),
	      mostrar16 = _useState78[0],
	      setMostrar16 = _useState78[1];
	
	  var _useState79 = (0, _react.useState)(false),
	      _useState80 = _slicedToArray(_useState79, 2),
	      mostrar17 = _useState80[0],
	      setMostrar17 = _useState80[1];
	
	  var _useState81 = (0, _react.useState)(false),
	      _useState82 = _slicedToArray(_useState81, 2),
	      mostrar18 = _useState82[0],
	      setMostrar18 = _useState82[1];
	
	  var configuracionSistema = function configuracionSistema() {
	    var campos = "*";
	    var nomtab = "configsistema";
	
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=idconfig&id=1";
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        console.log(response.data);
	        sessionStorage.setItem("tiporeppedido", JSON.stringify(response.data.tiporeppedido));
	        sessionStorage.setItem("tiporepnotaentrega", JSON.stringify(response.data.tiporepnotaentrega));
	      }
	    }).catch(function (error) {
	      console.log(error);
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    configuracionSistema();
	  }, []);
	
	  var el = void 0;
	  var ele = void 0;
	  var bloquear = function bloquear(titulo) {
	    return function (e) {
	      e.preventDefault();
	      setTituloNav(titulo);
	      props.onCambiar(titulo);
	      if (el = document.getElementById("wrapper")) {
	        el.classList.toggle("toggled");
	        if (ele = document.getElementById("menu-toggle")) {
	          ele.classList.toggle("bloquear");
	        }
	      }
	    };
	  };
	
	  var cerrarModal = function cerrarModal() {
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var abrirModal = function abrirModal(tipo) {
	    return function (e) {
	      e.preventDefault();
	      el = document.getElementById("wrapper");
	      el.classList.toggle("toggled");
	      if (tipo === "medida") {
	        setMostrarMedida(true);
	      } else if (tipo === "departamento") {
	        setMostrarDepart(true);
	      } else if (tipo === "marca") {
	        setMostrarMarca(true);
	      } else if (tipo === "modelo") {
	        setMostrarModelo(true);
	      } else if (tipo === "fabricante") {
	        setMostrar(true);
	      } else if (tipo === "tipoproducto") {
	        setMostrarTipoProducto(true);
	      } else if (tipo === "producto") {
	        setMostrarProducto(true);
	      } else if (tipo === "banco") {
	        setMostrarBanco(true);
	      } else if (tipo === "ubicacion") {
	        setMostrarUbicaciones(true);
	      } else if (tipo === "tipovacio") {
	        setMostrarTipoVacio(true);
	      } else if (tipo === "reporteproducto") {
	        setMostrarReportProductos(true);
	      } else if (tipo === "reportenotaentrega") {
	        setCreport(tipo);
	        setMostrarReportNDebitos(true);
	      } else if (tipo === "reportenotadebitos") {
	        setCreport(tipo);
	        setMostrarReportNDebitos(true);
	      } else if (tipo === "reporteobsequio") {
	        setCreport(tipo);
	        setMostrarReportNDebitos(true);
	      } else if (tipo === "reportenotascredito") {
	        setCreport(tipo);
	        setMostrarReportNCredito(true);
	      } else if (tipo === "reporteestadodecuenta") {
	        setCreportestc(tipo);
	        setMostrarReportEsc(true);
	      } else if (tipo === "reportecuentasporcobrar") {
	        setCreportestc(tipo);
	        setMostrarReportEsc(true);
	      } else if (tipo === "reportefacturas") {
	        setCreport(tipo);
	        setMostrarReportNDebitos(true);
	      } else if (tipo === "reportepedidos") {
	        setCreport(tipo);
	        setMostrarReportNDebitos(true);
	      } else if (tipo === "Inventario" || tipo === "Ventas" || tipo === "Compras" || tipo === "Contabilidad" || tipo === "Finanzas" || tipo === "Vacios" || tipo === "Servicios") {
	        setTipopermi(tipo);
	        setMpermisousuarios(true);
	      } else if (tipo === "reporterecibodepago") {
	        setCreport(tipo);
	        setMostrar2(true);
	      } else if (tipo === "opinventario") {
	        setMostrar1(true);
	      } else if (tipo === "reporteventasganancias") {
	        setMostrar3(true);
	      } else if (tipo === "reporteanticipos") {
	        setMostrar4(true);
	      } else if (tipo === "reporteanticiposxvendedor") {
	        setMostrar11(true);
	      } else if (tipo === "reportelibrobanco") {
	        setMostrar5(true);
	      } else if (tipo === "reporteventasxproductos") {
	        setMostrar6(true);
	      } else if (tipo === "reportefacturasdecompra") {
	        setMostrar7(true);
	      } else if (tipo === "classvacios") {
	        setMostrar8(true);
	      } else if (tipo === "gestionservicios") {
	        setMostrar9(true);
	      } else if (tipo === "reporteingresos") {
	        setValrport(tipo);
	        setMostrar10(true);
	      } else if (tipo === "reportelibroventas") {
	        setValrport(tipo);
	        setMostrar10(true);
	      } else if (tipo === "repordeudasgen") {
	        setMostrar12(true);
	      } else if (tipo === "reportecontrolvacios") {
	        setMostrar13(true);
	      } else if (tipo === "opinventarioobsequio") {
	        setMostrar14(true);
	      } else if (tipo === "ReporteListaPedidosPendiente") {
	        setMostrar15(true);
	      } else if (tipo === "reporterecibosreversados") {
	        setMostrar16(true);
	      } else if (tipo === "reporteclientes") {
	        setMostrar17(true);
	      } else if (tipo === "ReportePickingList") {
	        setMostrar18(true);
	      }
	      //
	    };
	  };
	
	  /* Ubica el submenu al lado del item y dentro de la ventana, de modo que no
	     caiga hacia abajo ni necesite margenes negativos (mt-222m, mt-200m, etc.) */
	  var ajustarSubmenu = function ajustarSubmenu(e) {
	    var li = e.target && e.target.closest ? e.target.closest("li") : null;
	
	    if (!li || !li.parentElement || !li.parentElement.classList.contains("dropdown-menu")) {
	      return;
	    }
	
	    var submenu = li.querySelector(":scope > .dropdown-submenu");
	
	    if (!submenu) {
	      return;
	    }
	
	    var margen = 8;
	    var display = submenu.style.display;
	    var visibility = submenu.style.visibility;
	
	    /* Se mide el submenu aunque todavia no este visible */
	    submenu.style.display = "block";
	    submenu.style.visibility = "hidden";
	
	    var alto = submenu.offsetHeight;
	    var item = li.getBoundingClientRect();
	
	    /* Vertical: alineado con el item y, si no cabe, ajustado a la ventana */
	    var top = 0;
	
	    if (item.top + alto > window.innerHeight - margen) {
	      top = window.innerHeight - margen - alto - item.top;
	    }
	
	    if (item.top + top < margen) {
	      top = margen - item.top;
	    }
	
	    submenu.style.top = top + "px";
	
	    /* Si el submenu es mas alto que la ventana se limita y se habilita scroll */
	    if (alto > window.innerHeight - margen * 2) {
	      submenu.style.maxHeight = window.innerHeight - margen * 2 + "px";
	      submenu.style.overflowY = "auto";
	    } else {
	      submenu.style.maxHeight = "";
	      submenu.style.overflowY = "";
	    }
	
	    /* Horizontal: se abre a la derecha y, si no cabe, se voltea a la izquierda */
	    if (item.right + submenu.offsetWidth + margen > window.innerWidth) {
	      submenu.classList.add("dropdown-submenu-left");
	    } else {
	      submenu.classList.remove("dropdown-submenu-left");
	    }
	
	    submenu.style.display = display;
	    submenu.style.visibility = visibility;
	  };
	
	  var verConfig = function verConfig() {
	    if (!verConfiguracion) {
	      setVerConfiguracion(true);
	    } else {
	      setVerConfiguracion(false);
	    }
	  };
	
	  var verConfigAthos = function verConfigAthos() {
	    setVerConfiguAthos(true);
	  };
	
	  var sidebar = user && _react2.default.createElement(
	    "div",
	    { className: "amanecergris", id: "sidebar-wrapper" },
	    _react2.default.createElement(
	      "div",
	      { className: "sidebar-heading text-center py-4 bluez-text fs-4 fw-bold text-uppercase border-bottom" },
	      _react2.default.createElement("img", {
	        className: "img-fluid",
	        src: op.conexion + "/imagen?img=athos/organizacion/" + logo,
	        style: { width: "100px" },
	        alt: ""
	      }),
	      _react2.default.createElement(
	        "h5",
	        { className: "m-0 second-text" },
	        rif
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "list-group list-group-flush ", onMouseOver: ajustarSubmenu },
	      _react2.default.createElement(
	        "div",
	        { className: "list-group list-group-flush" },
	        _react2.default.createElement(
	          _reactRouterDom.Link,
	          {
	            to: "/inicio",
	            className: "list-group-item list-group-item-action py-2 ripple active text-center"
	          },
	          _react2.default.createElement(
	            "h3",
	            { className: "H" },
	            organizacion
	          )
	        ),
	        permisos && permisos.substring(0, 1) === "1" ? _react2.default.createElement(
	          "div",
	          { className: "dropdown dropend " },
	          _react2.default.createElement(
	            "a",
	            {
	              className: "btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple px-2",
	              style: {
	                pointerEvents: permisos && permisos.substring(0, 1) === "0" ? "none" : "cursor",
	                color: permisos && permisos.substring(0, 1) === "0" ? "rgb(183, 183, 183)" : "#1d0345",
	                backgroundColor: permisos && permisos.substring(0, 1) === "0" ? "rgba(144, 143, 142, 0.76)" : "transparent"
	              },
	              type: "button",
	              id: "dropdownMenuButton",
	              "data-mdb-toggle": "dropdown",
	              "aria-expanded": "false"
	            },
	            _react2.default.createElement("i", { className: "fas fa-ticket-alt fa-fw me-2" }),
	            _react2.default.createElement(
	              "span",
	              { className: "fw-bold" },
	              "INVENTARIO"
	            )
	          ),
	          _react2.default.createElement(
	            "ul",
	            {
	              className: "dropdown-menu sombras ",
	              "aria-labelledby": "dropdownMenuButton"
	            },
	            accinventario && accinventario.substring(0, 1) === "1" && _react2.default.createElement(
	              "li",
	              { onClick: bloquear("Registro de Almacenes") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/registroalmacen",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-box-open fa-fw me-1" }),
	                  "REGISTRO DE ALMACENES"
	                )
	              )
	            ),
	            accinventario && accinventario.substring(1, 2) === "1" && _react2.default.createElement(
	              "li",
	              { onClick: abrirModal("ubicacion") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "#",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-map-marker-alt fa-fw me-1" }),
	                  "UBICACIONES DE ALMACENES"
	                )
	              )
	            ),
	            accinventario && accinventario.substring(2, 3) === "1" && _react2.default.createElement(
	              "li",
	              { onClick: abrirModal("medida") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "#",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-poll-h fa-fw me-1" }),
	                  "UNIDADES DE MEDIDAS"
	                )
	              )
	            ),
	            accinventario && accinventario.substring(3, 4) === "1" && _react2.default.createElement(
	              "li",
	              { onClick: abrirModal("marca") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "#",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "far fa-bookmark fa-fw me-1" }),
	                  "MARCA"
	                )
	              )
	            ),
	            accinventario && accinventario.substring(4, 5) === "1" && _react2.default.createElement(
	              "li",
	              { onClick: abrirModal("modelo") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "#",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-tag fa-fw me-1" }),
	                  "MODELO"
	                )
	              )
	            ),
	            accinventario && accinventario.substring(4, 5) === "1" && _react2.default.createElement(
	              "li",
	              { onClick: abrirModal("fabricante") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "#",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-signature fa-fw me-1" }),
	                  "FABRICANTE"
	                )
	              )
	            ),
	            accinventario && accinventario.substring(5, 6) === "1" && _react2.default.createElement(
	              "li",
	              { onClick: abrirModal("tipoproducto") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "#",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fab fa-stack-exchange fa-fw me-1" }),
	                  "TIPO DE PRODUCTO"
	                )
	              )
	            ),
	            accinventario && accinventario.substring(6, 7) === "1" && _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/producto",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-boxes fa-fw me-1" }),
	                  "PRODUCTOS"
	                )
	              )
	            ),
	            accinventario && accinventario.substring(7, 8) === "1" && _react2.default.createElement(
	              "li",
	              { onClick: bloquear(" ") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/operacionesinv",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-share-square fa-fw me-1" }),
	                  "OPERACIONES DE INVENTARIO"
	                )
	              )
	            ),
	            accinventario && accinventario.substring(10, 11) === "1" && _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold",
	                  href: "#"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-cog fa-fw me-1" }),
	                  "CONFIGURACION \xBB"
	                )
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "dropdown-menu dropdown-submenu sombras" },
	                _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("Inventario") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { className: "dropdown-item ripple bg-transparent text-dark fw-bold" },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      _react2.default.createElement("i", { className: "fas fa-user-cog fa-fw me-1" }),
	                      "PERMISOS DE USUARIO"
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement("hr", { className: "dropdown-divider" })
	            ),
	            accinventario && accinventario.substring(11, 12) === "1" && _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold",
	                  href: "#"
	                },
	                _react2.default.createElement("i", { className: "fas fa-print fa-fw me-1" }),
	                "REPORTES \xBB"
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "dropdown-menu dropdown-submenu sombras" },
	                accbtnireports && accbtnireports.toString().substring(0, 1) === "1" ? _react2.default.createElement(
	                  "li",
	                  {
	                    onClick: function onClick() {
	                      return window.open(op.reportes + "/productos?afiliado=" + afiliado + "&reporte=ListaProductos", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	                    }
	                  },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Lista de Productos"
	                    )
	                  )
	                ) : "",
	                _react2.default.createElement(
	                  "li",
	                  {
	                    onClick: function onClick() {
	                      return window.open(op.reportes + "/productos?afiliado=" + afiliado + "&reporte=ListProductoExistenciaCatalogo2", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	                    }
	                  },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Catalogo de Productos"
	                    )
	                  )
	                ),
	                accbtnireports && accbtnireports.toString().substring(1, 2) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reporteproducto") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Lista de Productos en Existencia"
	                    )
	                  )
	                ) : "",
	                accbtnireports && accbtnireports.toString().substring(2, 3) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("opinventario") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Operaciones de Inventario"
	                    )
	                  )
	                ) : "",
	                accbtnireports && accbtnireports.toString().substring(3, 4) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("opinventarioobsequio") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Operaciones de Inventario Obsequio/Donaciones"
	                    )
	                  )
	                ) : ""
	              )
	            )
	          )
	        ) : "",
	        permisos && permisos.substring(1, 2) === "1" ? _react2.default.createElement(
	          "div",
	          { className: "dropdown dropend " },
	          _react2.default.createElement(
	            "a",
	            {
	              className: "btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple px-2",
	              style: {
	                pointerEvents: permisos && permisos.substring(1, 2) === "0" ? "none" : "cursor",
	                color: permisos && permisos.substring(1, 2) === "0" ? "rgb(183, 183, 183)" : "#1d0345",
	                backgroundColor: permisos && permisos.substring(1, 2) === "0" ? "rgba(144, 143, 142, 0.76)" : "transparent"
	              },
	              type: "button",
	              id: "dropdownMenuButton",
	              "data-mdb-toggle": "dropdown",
	              "aria-expanded": "false"
	            },
	            _react2.default.createElement("i", { className: "fas fa-cash-register fa-fw me-2" }),
	            _react2.default.createElement(
	              "span",
	              { className: "fw-bold" },
	              "VENTAS"
	            )
	          ),
	          _react2.default.createElement(
	            "ul",
	            {
	              className: "dropdown-menu sombras ",
	              "aria-labelledby": "dropdownMenuButton"
	            },
	            accventas && accventas.substring(0, 1) === "0" ? "" : txtfranquicia && txtfranquicia === "3" ? _react2.default.createElement(
	              "li",
	              { onClick: bloquear("Clientes") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/gestionGerencial?modal=cliente",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-user-tie fa-fw me-1" }),
	                  "CLIENTES"
	                )
	              )
	            ) : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/clientes",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-users fa-fw me-1" }),
	                  "CLIENTES"
	                )
	              )
	            ),
	            accventas && accventas.substring(1, 2) === "0" ? "" : txtfranquicia && txtfranquicia === "3" ? _react2.default.createElement(
	              "li",
	              { onClick: bloquear("Vendedores") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/gestionGerencial?modal=vendedor",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-users fa-fw me-1" }),
	                  "VENDEDORES"
	                )
	              )
	            ) : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/vendedores",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-user-tie fa-fw me-1" }),
	                  "VENDEDORES"
	                )
	              )
	            ),
	            accventas && accventas.substring(2, 3) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/pedidos",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-edit fa-fw me-1" }),
	                  "PEDIDOS"
	                )
	              )
	            ),
	            accventas && accventas.substring(3, 4) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/notaentrega",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-pen-square fa-fw me-1" }),
	                  "NOTAS DE ENTREGA"
	                )
	              )
	            ),
	            accventas && accventas.substring(4, 5) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/notadebito",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-pen-square fa-fw me-1" }),
	                  "NOTAS DE DEBITO"
	                )
	              )
	            ),
	            accventas && accventas.substring(4, 5) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/notacredito",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-pen-square fa-fw me-1" }),
	                  "NOTAS DE CREDITO"
	                )
	              )
	            ),
	            accventas && accventas.substring(5, 6) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("Facturacion") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/factura",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-receipt fa-fw me-1" }),
	                  "FACTURAS"
	                )
	              )
	            ),
	            accventas && accventas.substring(9, 10) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("Facturacion Por Notas de Entrega") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/facturaxnota",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-receipt fa-fw me-1" }),
	                  "FACTURAS POR NOTAS DE ENTREGA"
	                )
	              )
	            ),
	            accventas && accventas.substring(6, 7) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/presupuesto",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-money-check fa-fw me-1" }),
	                  "PRESUPUESTOS"
	                )
	              )
	            ),
	            accventas && accventas.substring(7, 8) === "0" ? "" : _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold",
	                  href: "#"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-cog fa-fw me-1" }),
	                  "CONFIGURACION \xBB"
	                )
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "dropdown-menu dropdown-submenu sombras" },
	                _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("Ventas") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      _react2.default.createElement("i", { className: "fas fa-user-cog fa-fw me-1" }),
	                      "PERMISOS DE USUARIO"
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement("hr", { className: "dropdown-divider" })
	            ),
	            accventas && accventas.substring(8, 9) === "0" ? "" : _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold",
	                  href: "#"
	                },
	                _react2.default.createElement("i", { className: "fas fa-print fa-fw me-1" }),
	                "REPORTES \xBB"
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "dropdown-menu dropdown-submenu sombras" },
	                accbtnvreports && accbtnvreports.substring(0, 1) === "1" ? _react2.default.createElement(
	                  "li",
	                  {
	                    onClick: abrirModal("reporteclientes")
	                  },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      " ",
	                      "Clientes"
	                    )
	                  )
	                ) : "",
	                accbtnvreports && accbtnvreports.substring(1, 2) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reportepedidos") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Reporte de Pedidos Generados"
	                    )
	                  )
	                ) : "",
	                accbtnvreports && accbtnvreports.substring(2, 3) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reportenotaentrega") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Reporte de Notas de Entrega"
	                    )
	                  )
	                ) : "",
	                accbtnvreports && accbtnvreports.substring(3, 4) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reportenotadebitos") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Reporte de Notas de Debito"
	                    )
	                  )
	                ) : "",
	                accbtnvreports && accbtnvreports.substring(3, 4) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reporteobsequio") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Reporte de Obsequios/Donaci\xF3n"
	                    )
	                  )
	                ) : "",
	                accbtnvreports && accbtnvreports.substring(4, 5) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reportenotascredito") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Reporte de Notas de Cr\xE9dito"
	                    )
	                  )
	                ) : "",
	                accbtnvreports && accbtnvreports.substring(5, 6) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reportefacturas") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Reporte de Facturas Generadas"
	                    )
	                  )
	                ) : "",
	                accbtnvreports && accbtnvreports.substring(6, 7) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reporteventasganancias") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Movimientos de Ventas Generadas"
	                    )
	                  )
	                ) : "",
	                accbtnvreports && accbtnvreports.substring(7, 8) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reporteventasxproductos") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Movimientos de Ventas por Productos"
	                    )
	                  )
	                ) : "",
	                _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("ReporteListaPedidosPendiente") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Lista de Pedidos Pendientes"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("ReportePickingList") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Reporte Picking List"
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ) : "",
	        permisos && permisos.substring(8, 9) === "1" ? _react2.default.createElement(
	          "div",
	          { className: "dropdown dropend" },
	          _react2.default.createElement(
	            "a",
	            {
	              className: "btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple px-2",
	              style: {
	                pointerEvents: permisos && permisos.substring(8, 9) === "0" ? "none" : "cursor",
	                color: permisos && permisos.substring(8, 9) === "0" ? "rgb(183, 183, 183)" : "#1d0345",
	                backgroundColor: permisos && permisos.substring(8, 9) === "0" ? "rgba(144, 143, 142, 0.76)" : "transparent"
	              },
	              type: "button",
	              id: "dropdownMenuButton",
	              "data-mdb-toggle": "dropdown",
	              "aria-expanded": "false"
	            },
	            _react2.default.createElement("i", { className: "fas fa-cash-register fa-fw me-2" }),
	            _react2.default.createElement(
	              "span",
	              { className: "fw-bold" },
	              "POST-VENTA"
	            )
	          ),
	          _react2.default.createElement(
	            "ul",
	            {
	              className: "dropdown-menu sombras ",
	              "aria-labelledby": "dropdownMenuButton"
	            },
	            accpostventas && accpostventas.substring(0, 1) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("Post-Venta") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/postventa",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-edit fa-fw me-1" }),
	                  "VENTA"
	                )
	              )
	            ),
	            accpostventas && accpostventas.substring(0, 1) === "1" && _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold",
	                  href: "#"
	                },
	                _react2.default.createElement("i", { className: "fas fa-print fa-fw me-1" }),
	                "REPORTES \xBB"
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "dropdown-menu dropdown-submenu sombras" },
	                accbtnvreports && accbtnvreports.substring(2, 3) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reportenotaentrega") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Reporte de Notas de Entrega"
	                    )
	                  )
	                ) : "",
	                accbtnvreports && accbtnvreports.substring(7, 8) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reporteventasxproductos") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Movimientos de Ventas por Productos"
	                    )
	                  )
	                ) : "",
	                accbtnfreports && accbtnfreports.substring(5, 6) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reporteingresos") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Imprimir Ingresos"
	                    )
	                  )
	                ) : ""
	              )
	            )
	          )
	        ) : "",
	        idorganizacion && idorganizacion === "1" && (iduser && parseInt(iduser) === 1 || parseInt(iduser) === 2 || parseInt(iduser) === 30) && permisos && permisos.substring(7, 8) === "1" ? _react2.default.createElement(
	          "div",
	          { className: "dropdown dropend" },
	          _react2.default.createElement(
	            "a",
	            {
	              className: "btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple px-2",
	              style: {
	                pointerEvents: permisos && permisos.substring(7, 8) === "0" ? "none" : "cursor",
	                color: permisos && permisos.substring(7, 8) === "0" ? "rgb(183, 183, 183)" : "#1d0345",
	                backgroundColor: permisos && permisos.substring(7, 8) === "0" ? "rgba(144, 143, 142, 0.76)" : "transparent"
	              },
	              type: "button",
	              id: "dropdownMenuButton",
	              "data-mdb-toggle": "dropdown",
	              "aria-expanded": "false"
	            },
	            _react2.default.createElement("i", { className: "fas fa-tools fa-fw me-2" }),
	            _react2.default.createElement(
	              "span",
	              { className: "fw-bold" },
	              "SERVICIOS"
	            )
	          ),
	          _react2.default.createElement(
	            "ul",
	            {
	              className: "dropdown-menu sombras ",
	              "aria-labelledby": "dropdownMenuButton"
	            },
	            accservicios && accservicios.substring(2, 3) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: abrirModal("gestionservicios") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "#",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-edit fa-fw me-1" }),
	                  "GESTION DE SERVICIOS"
	                )
	              )
	            ),
	            accservicios && accservicios.substring(1, 2) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/gestionmoviles",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-tractor fa-fw me-1" }),
	                  "GESTI\xD3N DE MOVILES"
	                )
	              )
	            ),
	            accservicios && accservicios.substring(0, 1) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/orderservicio",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-edit fa-fw me-1" }),
	                  "ORDENES DE SERVICIO"
	                )
	              )
	            ),
	            accservicios && accservicios.substring(3, 4) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/notaentregaserv",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-edit fa-fw me-1" }),
	                  "NOTA DE ENTREGA"
	                )
	              )
	            ),
	            accservicios && accservicios.substring(4, 5) === "0" ? "" : _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold",
	                  href: "#"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-cog fa-fw me-1" }),
	                  "CONFIGURACION \xBB"
	                )
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "dropdown-menu dropdown-submenu sombras" },
	                _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("Servicios") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      _react2.default.createElement("i", { className: "fas fa-user-cog fa-fw me-1" }),
	                      "PERMISOS DE USUARIO"
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement("hr", { className: "dropdown-divider" })
	            ),
	            accservicios && accservicios.substring(5, 6) === "0" ? "" : _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold",
	                  href: "#"
	                },
	                _react2.default.createElement("i", { className: "fas fa-print fa-fw me-1" }),
	                "REPORTES \xBB"
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "dropdown-menu dropdown-submenu sombras" },
	                accbtncreports && accbtncreports.substring(0, 1) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reportefacturasdecompra") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Movimientos de Ordenes de Servicio"
	                    )
	                  )
	                ) : ""
	              )
	            )
	          )
	        ) : "",
	        permisos && permisos.substring(2, 3) === "1" ? _react2.default.createElement(
	          "div",
	          { className: "dropdown dropend" },
	          _react2.default.createElement(
	            "a",
	            {
	              className: "btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple px-2",
	              style: {
	                pointerEvents: permisos && permisos.substring(2, 3) === "0" ? "none" : "cursor",
	                color: permisos && permisos.substring(2, 3) === "0" ? "rgb(183, 183, 183)" : "#1d0345",
	                backgroundColor: permisos && permisos.substring(2, 3) === "0" ? "rgba(144, 143, 142, 0.76)" : "transparent"
	              },
	              type: "button",
	              id: "dropdownMenuButton",
	              "data-mdb-toggle": "dropdown",
	              "aria-expanded": "false"
	            },
	            _react2.default.createElement("i", { className: "fas fa-shopping-cart fa-fw me-2" }),
	            _react2.default.createElement(
	              "span",
	              { className: "fw-bold" },
	              "COMPRAS"
	            )
	          ),
	          _react2.default.createElement(
	            "ul",
	            {
	              className: "dropdown-menu sombras ",
	              "aria-labelledby": "dropdownMenuButton"
	            },
	            acccompras && acccompras.substring(0, 1) === "0" ? "" : _react2.default.createElement(
	              "li",
	              {
	                onClick: bloquear("Registro de Contribuyentes por Minas")
	              },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/proveedores",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-portrait fa-fw me-1" }),
	                  "PROVEEDORES"
	                )
	              )
	            ),
	            acccompras && acccompras.substring(1, 2) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/ordencompra",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-edit fa-fw me-1" }),
	                  "ORDENES DE COMPRAS"
	                )
	              )
	            ),
	            acccompras && acccompras.substring(2, 3) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("Facturación de Compras") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/facturarordencompra",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-receipt fa-fw me-1" }),
	                  "FACTURAS DE COMPRAS"
	                )
	              )
	            ),
	            acccompras && acccompras.substring(3, 4) === "0" ? "" : _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold",
	                  href: "#"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-cog fa-fw me-1" }),
	                  "CONFIGURACION \xBB"
	                )
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "dropdown-menu dropdown-submenu sombras" },
	                _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("Compras") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      _react2.default.createElement("i", { className: "fas fa-user-cog fa-fw me-1" }),
	                      "PERMISOS DE USUARIO"
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement("hr", { className: "dropdown-divider" })
	            ),
	            acccompras && acccompras.substring(4, 5) === "0" ? "" : _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold",
	                  href: "#"
	                },
	                _react2.default.createElement("i", { className: "fas fa-print fa-fw me-1" }),
	                "REPORTES \xBB"
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "dropdown-menu dropdown-submenu sombras" },
	                accbtncreports && accbtncreports.substring(0, 1) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reportefacturasdecompra") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Movimientos de Facturas de Compras"
	                    )
	                  )
	                ) : ""
	              )
	            )
	          )
	        ) : "",
	        idorganizacion && idorganizacion === "1" && (iduser && parseInt(iduser) === 1 || parseInt(iduser) === 2 || parseInt(iduser) === 30) && permisos && permisos.substring(3, 4) === "1" ? _react2.default.createElement(
	          "div",
	          { className: "dropdown dropend " },
	          _react2.default.createElement(
	            "a",
	            {
	              className: "btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple px-2",
	              style: {
	                pointerEvents: permisos && permisos.substring(3, 4) === "0" ? "none" : "cursor",
	                color: permisos && permisos.substring(3, 4) === "0" ? "rgb(183, 183, 183)" : "#1d0345",
	                backgroundColor: permisos && permisos.substring(3, 4) === "0" ? "rgba(144, 143, 142, 0.76)" : "transparent"
	              },
	              type: "button",
	              id: "dropdownMenuButton",
	              "data-mdb-toggle": "dropdown",
	              "aria-expanded": "false"
	            },
	            _react2.default.createElement("i", { className: "fas fa-calculator fa-fw me-2" }),
	            _react2.default.createElement(
	              "span",
	              { className: "fw-bold" },
	              "CONTABILIDAD"
	            )
	          ),
	          _react2.default.createElement(
	            "ul",
	            {
	              className: "dropdown-menu sombras ",
	              "aria-labelledby": "dropdownMenuButton"
	            },
	            acccontabilidad && acccontabilidad.substring(0, 1) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/catalogoContable",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-list-alt fa-fw me-1" }),
	                  "CATALOGO CUENTA CONTABLE"
	                )
	              )
	            ),
	            acccontabilidad && acccontabilidad.substring(1, 2) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/asientoscontables",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-pen-square fa-fw me-1" }),
	                  "ASIENTOS CONTABLES"
	                )
	              )
	            ),
	            acccontabilidad && acccontabilidad.substring(2, 3) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("Retención 1x500") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/reten1x500",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-retweet fa-fw me-1" }),
	                  "VINCULACI\xD3N DE CUENTAS"
	                )
	              )
	            ),
	            acccontabilidad && acccontabilidad.substring(3, 4) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/movimientotransi",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-exchange-alt fa-fw me-1" }),
	                  "MOVIMIENTOS BANCARIOS EN TRANSITO"
	                )
	              )
	            ),
	            acccontabilidad && acccontabilidad.substring(4, 5) === "0" ? "" : _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold",
	                  href: "#"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-cog fa-fw me-1" }),
	                  "CONFIGURACION \xBB"
	                )
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "dropdown-menu dropdown-submenu sombras" },
	                _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("Contabilidad") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      _react2.default.createElement("i", { className: "fas fa-user-cog fa-fw me-1" }),
	                      "PERMISOS DE USUARIO"
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement("hr", { className: "dropdown-divider" })
	            ),
	            acccontabilidad && acccontabilidad.substring(5, 6) === "0" ? "" : _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold",
	                  href: "#"
	                },
	                _react2.default.createElement("i", { className: "fas fa-print fa-fw me-1" }),
	                "REPORTES \xBB"
	              ),
	              _react2.default.createElement("ul", { className: "dropdown-menu dropdown-submenu sombras" })
	            )
	          )
	        ) : "",
	        permisos && permisos.substring(4, 5) === "1" ? _react2.default.createElement(
	          "div",
	          { className: "dropdown dropend " },
	          _react2.default.createElement(
	            "a",
	            {
	              className: "btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple px-2",
	              style: {
	                pointerEvents: permisos && permisos.substring(4, 5) === "0" ? "none" : "cursor",
	                color: permisos && permisos.substring(4, 5) === "0" ? "rgb(183, 183, 183)" : "#1d0345",
	                backgroundColor: permisos && permisos.substring(4, 5) === "0" ? "rgba(144, 143, 142, 0.76)" : "transparent"
	              },
	              type: "button",
	              id: "dropdownMenuButton",
	              "data-mdb-toggle": "dropdown",
	              "aria-expanded": "false"
	            },
	            _react2.default.createElement("i", { className: "fas fa-coins fa-fw me-2" }),
	            _react2.default.createElement(
	              "span",
	              { className: "fw-bold" },
	              "FINANZAS"
	            )
	          ),
	          _react2.default.createElement(
	            "ul",
	            {
	              className: "dropdown-menu sombras ",
	              "aria-labelledby": "dropdownMenuButton"
	            },
	            accfinanzas && accfinanzas.substring(0, 1) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/anticipos",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-pager fa-fw me-1" }),
	                  "ANTICIPOS"
	                )
	              )
	            ),
	            accfinanzas && accfinanzas.substring(0, 1) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: abrirModal("banco") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "#",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-landmark fa-fw me-1" }),
	                  "BANCOS"
	                )
	              )
	            ),
	            accfinanzas && accfinanzas.substring(1, 2) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/beneficiarios",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-users fa-fw me-1" }),
	                  "BENEFICIARIOS"
	                )
	              )
	            ),
	            accfinanzas && accfinanzas.substring(2, 3) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/cuentasbancarias",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-list-alt fa-fw me-1" }),
	                  "CUENTAS BANCARIAS"
	                )
	              )
	            ),
	            accfinanzas && accfinanzas.substring(3, 4) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/movimientobanca",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-exchange-alt fa-fw me-1" }),
	                  "MOVIMIENTOS BANCARIOS"
	                )
	              )
	            ),
	            accfinanzas && accfinanzas.substring(4, 5) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/movimientotransi",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-exchange-alt fa-fw me-1" }),
	                  "MOVIMIENTOS EN TRANSITO"
	                )
	              )
	            ),
	            accfinanzas && accfinanzas.substring(5, 6) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/conciliacion",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-chalkboard-teacher fa-fw me-1" }),
	                  "CONCILIACION BANCARIA"
	                )
	              )
	            ),
	            accfinanzas && accfinanzas.substring(6, 7) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/cuentasxcobrar",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-hand-holding-usd fa-fw me-1" }),
	                  "CUENTAS POR COBRAR"
	                )
	              )
	            ),
	            accfinanzas && accfinanzas.substring(11, 12) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/reversarpago",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-undo fa-fw me-1" }),
	                  "REVERSAR PAGO/ANTICIPO"
	                )
	              )
	            ),
	            accfinanzas && accfinanzas.substring(7, 8) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("Asignación de Multas") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/cuentasxpagar",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-money-check-alt fa-fw me-1" }),
	                  "CUENTAS POR PAGAR"
	                )
	              )
	            ),
	            accfinanzas && accfinanzas.substring(8, 9) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/tiporetenciones",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-list fa-fw me-1" }),
	                  "TIPO DE RETENCIONES"
	                )
	              )
	            ),
	            accfinanzas && accfinanzas.substring(9, 10) === "0" ? "" : _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold",
	                  href: "#"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-cog fa-fw me-1" }),
	                  "CONFIGURACION \xBB"
	                )
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "dropdown-menu dropdown-submenu sombras" },
	                _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("Finanzas") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      _react2.default.createElement("i", { className: "fas fa-user-cog fa-fw me-1" }),
	                      "PERMISOS DE USUARIO"
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement("hr", { className: "dropdown-divider" })
	            ),
	            accfinanzas && accfinanzas.substring(10, 11) === "0" ? "" : _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold",
	                  href: "#"
	                },
	                _react2.default.createElement("i", { className: "fas fa-print fa-fw me-1" }),
	                "REPORTES \xBB"
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "dropdown-menu dropdown-submenu sombras" },
	                accbtnfreports && accbtnfreports.substring(0, 1) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reporteestadodecuenta") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Reporte de Estados de Cuenta"
	                    )
	                  )
	                ) : "",
	                accbtnfreports && accbtnfreports.substring(1, 2) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reportecuentasporcobrar") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Reporte de Cuentas por Cobrar"
	                    )
	                  )
	                ) : "",
	                accbtnfreports && accbtnfreports.substring(8, 9) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("repordeudasgen") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Imprimir Deudas y Pagos Generados"
	                    )
	                  )
	                ) : "",
	                accbtnfreports && accbtnfreports.substring(2, 3) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reporterecibodepago") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Imprimir Recibo de Pago"
	                    )
	                  )
	                ) : "",
	                accbtnfreports && accbtnfreports.substring(3, 4) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reporteanticipos") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Imprimir Anticipos"
	                    )
	                  )
	                ) : "",
	                accbtnfreports && accbtnfreports.substring(7, 8) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reporteanticiposxvendedor") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Imprimir Anticipos por Vendedor"
	                    )
	                  )
	                ) : "",
	                accbtnfreports && accbtnfreports.substring(4, 5) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reportelibrobanco") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Imprimir Libro Auxiliar de Banco"
	                    )
	                  )
	                ) : "",
	                accbtnfreports && accbtnfreports.substring(5, 6) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reporteingresos") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Imprimir Ingresos"
	                    )
	                  )
	                ) : "",
	                accbtnfreports && accbtnfreports.substring(6, 7) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reportelibroventas") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Imprimir Libro de Ventas"
	                    )
	                  )
	                ) : "",
	                accbtnfreports && accbtnfreports.substring(9, 10) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reporterecibosreversados") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Imprimir Recibos Reversados"
	                    )
	                  )
	                ) : ""
	              )
	            )
	          )
	        ) : "",
	        permisos && permisos.substring(6, 7) === "1" ? _react2.default.createElement(
	          "div",
	          { className: "dropdown dropend" },
	          _react2.default.createElement(
	            "a",
	            {
	              className: "btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple px-2",
	              style: {
	                pointerEvents: permisos && permisos.substring(6, 7) === "0" ? "none" : "cursor",
	                color: permisos && permisos.substring(6, 7) === "0" ? "rgb(183, 183, 183)" : "#1d0345",
	                backgroundColor: permisos && permisos.substring(6, 7) === "0" ? "rgba(144, 143, 142, 0.76)" : "transparent"
	              },
	              type: "button",
	              id: "dropdownMenuButton",
	              "data-mdb-toggle": "dropdown",
	              "aria-expanded": "false"
	            },
	            _react2.default.createElement("i", { className: "fas fa-box-open fa-fw me-2" }),
	            _react2.default.createElement(
	              "span",
	              { className: "fw-bold" },
	              "GESTION DE VACIOS"
	            )
	          ),
	          _react2.default.createElement(
	            "ul",
	            {
	              className: "dropdown-menu sombras ",
	              "aria-labelledby": "dropdownMenuButton"
	            },
	            accvacios && accvacios.substring(2, 3) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: abrirModal("classvacios") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "#",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-receipt fa-fw me-1" }),
	                  "CLASIFICADOR DE VACIOS"
	                )
	              )
	            ),
	            accvacios && accvacios.substring(0, 1) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/operacionesinvacio",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-exchange-alt fa-fw me-1" }),
	                  "OPERACIONES DE INVENTARIO (VACIOS)"
	                )
	              )
	            ),
	            accvacios && accvacios.substring(1, 2) === "0" ? "" : _react2.default.createElement(
	              "li",
	              { onClick: bloquear("") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/controlvacios",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-edit fa-fw me-1" }),
	                  "CONTROL DE VACIOS"
	                )
	              )
	            ),
	            accvacios && accvacios.substring(3, 4) === "0" ? "" : _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold",
	                  href: "#"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-cog fa-fw me-1" }),
	                  "CONFIGURACION \xBB"
	                )
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "dropdown-menu dropdown-submenu sombras" },
	                _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("Vacios") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      _react2.default.createElement("i", { className: "fas fa-user-cog fa-fw me-1" }),
	                      "PERMISOS DE USUARIO"
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement("hr", { className: "dropdown-divider" })
	            ),
	            accvacios && accvacios.substring(4, 5) === "0" ? "" : _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold",
	                  href: "#"
	                },
	                _react2.default.createElement("i", { className: "fas fa-print fa-fw me-1" }),
	                "REPORTES \xBB"
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "dropdown-menu dropdown-submenu sombras" },
	                btnreportvacios && btnreportvacios.substring(0, 1) === "1" ? _react2.default.createElement(
	                  "li",
	                  { onClick: abrirModal("reportecontrolvacios") },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: "#",
	                      className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "" },
	                      _react2.default.createElement("i", { className: "far fa-file-pdf fa-fw me-1" }),
	                      "Imprimir Control de Vacios"
	                    )
	                  )
	                ) : ""
	              )
	            )
	          )
	        ) : "",
	        _react2.default.createElement(
	          "div",
	          { className: "dropdown dropend" },
	          _react2.default.createElement(
	            "a",
	            {
	              className: "btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple px-2",
	              style: {
	                color: "#1d0345",
	                backgroundColor: "transparent"
	              },
	              type: "button",
	              id: "dropdownMenuButton",
	              "data-mdb-toggle": "dropdown",
	              "aria-expanded": "false"
	            },
	            _react2.default.createElement("i", { className: "fas fa-box-open fa-fw me-2" }),
	            _react2.default.createElement(
	              "span",
	              { className: "fw-bold" },
	              "GESTION GERENCIAL"
	            )
	          ),
	          _react2.default.createElement(
	            "ul",
	            { className: "dropdown-menu", "aria-labelledby": "dropdownMenuButton" },
	            _react2.default.createElement(
	              "li",
	              { onClick: bloquear("INDICADORES DE GESTIÓN") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/gestionGerencial?modal=grafica",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-receipt fa-fw me-1" }),
	                  "INDICADORES DE GESTI\xD3N"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { onClick: bloquear("UBICACIÓN DE CLIENTES") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/gestionGerencial?modal=mapaCliente",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-receipt fa-fw me-1" }),
	                  "UBICACI\xD3N DE CLIENTES"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              { onClick: bloquear("RUTAS DE PEDIDOS") },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                {
	                  to: "/gestionGerencial?modal=mapaAlmacen",
	                  className: "dropdown-item ripple bg-transparent text-dark fw-bold"
	                },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  _react2.default.createElement("i", { className: "fas fa-receipt fa-fw me-1" }),
	                  "RUTAS DE PEDIDOS"
	                )
	              )
	            )
	          )
	        ),
	        permisos && permisos.substring(5, 6) === "1" ? _react2.default.createElement(
	          "a",
	          {
	            onClick: verConfig,
	            className: "btn-primary  list-group-item list-group-item-action py-2 ripple px-2",
	            style: {
	              pointerEvents: permisos && permisos.substring(5, 6) === "0" ? "none" : "cursor",
	              color: permisos && permisos.substring(5, 6) === "0" ? "rgb(183, 183, 183)" : "#1d0345",
	              backgroundColor: permisos && permisos.substring(5, 6) === "0" ? "rgba(144, 143, 142, 0.76)" : "transparent"
	            },
	            type: "button"
	          },
	          _react2.default.createElement("i", { className: "fas fa-cogs fa-fw me-2" }),
	          _react2.default.createElement(
	            "span",
	            { className: "fw-bold" },
	            "CONFIGURACI\xD3N"
	          )
	        ) : "",
	        idorganizacion && idorganizacion === "1" && (iduser && parseInt(iduser) === 1 || parseInt(iduser) === 2 || parseInt(iduser) === 30) ? _react2.default.createElement(
	          "a",
	          {
	            onClick: verConfigAthos,
	            className: "btn-primary  list-group-item list-group-item-action py-2 ripple px-2",
	            style: {
	              pointerEvents: permisos && permisos.substring(5, 6) === "0" ? "none" : "cursor",
	              color: permisos && permisos.substring(5, 6) === "0" ? "rgb(183, 183, 183)" : "#1d0345",
	              backgroundColor: permisos && permisos.substring(5, 6) === "0" ? "rgba(144, 143, 142, 0.76)" : "transparent"
	            },
	            type: "button"
	          },
	          _react2.default.createElement("i", { className: "fas fa-cogs fa-fw me-2" }),
	          _react2.default.createElement(
	            "span",
	            { className: "fw-bold" },
	            "SISTEMA"
	          )
	        ) : "",
	        _react2.default.createElement(
	          "div",
	          { onClick: logout },
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            {
	              to: "/",
	              className: "btn-primary list-group-item list-group-item-action py-2 ripple bg-transparent px-2"
	            },
	            _react2.default.createElement("i", { className: "fas fa-power-off fa-fw me-2 text-danger" }),
	            " ",
	            _react2.default.createElement(
	              "span",
	              { className: "text-danger fw-bold" },
	              "Salir"
	            )
	          )
	        ),
	        _react2.default.createElement("br", null)
	      ),
	      _react2.default.createElement(_gestionarUnidadMedida.GestionarMedida, {
	        show: mostrarMedida,
	        onHideRenderizar: function onHideRenderizar() {},
	        onHideCancela: function onHideCancela() {
	          setMostrarMedida(false);
	        }
	      }),
	      _react2.default.createElement(_gestionarBanco.GestionarBanco, {
	        show: mostrarBanco,
	        onHideRenderizar: function onHideRenderizar() {},
	        onHideCancela: function onHideCancela() {
	          setMostrarBanco(false);
	        }
	      }),
	      _react2.default.createElement(_gestionarProducto.GestionarProducto, {
	        show: mostrarProducto,
	        onHideCancela: function onHideCancela() {
	          setMostrarProducto(false);
	        }
	      }),
	      _react2.default.createElement(_gestionarMarca.GestionarMarca, {
	        show: mostrarMarca,
	        onHideRenderizar: function onHideRenderizar() {},
	        onHideCancela: function onHideCancela() {
	          setMostrarMarca(false);
	        },
	        llamado: 1
	      }),
	      _react2.default.createElement(_gestionarModelo.GestionarModelo, {
	        show: mostrarModelo,
	        onHideRenderizar: function onHideRenderizar() {},
	        onHideCancela: function onHideCancela() {
	          setMostrarModelo(false);
	        },
	        llamado: 1
	      }),
	      _react2.default.createElement(_gestionarFabricante.GestionarFabricantes, {
	        show: mostrar,
	        onHideRenderizar: function onHideRenderizar() {},
	        onHideCancela: function onHideCancela() {
	          setMostrar(false);
	        },
	        llamado: 1
	      }),
	      _react2.default.createElement(_gestionarDepartamento.GestionarDepartamento, {
	        show: mostrarDepart,
	        onHideRenderizar: function onHideRenderizar() {},
	        onHideCancela: function onHideCancela() {
	          setMostrarDepart(false);
	        },
	        llamado: 1
	      }),
	      _react2.default.createElement(_gestionarClasificadorVacios.GestionarClasificadorVacios, {
	        show: mostrar8,
	        onHideRenderizar: function onHideRenderizar() {},
	        onHideCancela: function onHideCancela() {
	          setMostrar8(false);
	        },
	        llamado: 1
	      }),
	      _react2.default.createElement(_gestionarServicios.GestionarpServicios, {
	        show: mostrar9,
	        onHideRenderizar: function onHideRenderizar() {},
	        onHideCancela: function onHideCancela() {
	          setMostrar9(false);
	        },
	        llamado: 1
	      }),
	      _react2.default.createElement(_gestionarTipoProducto.GestionarTipoProducto, {
	        show: mostrarTipoProducto,
	        onHideRenderizar: function onHideRenderizar() {},
	        onHideCancela: function onHideCancela() {
	          setMostrarTipoProducto(false);
	        },
	        llamado: 1
	      }),
	      _react2.default.createElement(_gestionarTipoVacio.GestionarTipoVacio, {
	        show: mostrarTipoVacio,
	        onHideCancela: function onHideCancela() {
	          setMostrarTipoVacio(false);
	        }
	      }),
	      _react2.default.createElement(_modalImprimirProductos.ImprimirProductos, {
	        show: mostrarReportProductos,
	        op: 1,
	        onHideCancela: function onHideCancela() {
	          setMostrarReportProductos(false);
	        }
	      }),
	      _react2.default.createElement(_modalImprimirNDebitos.ImprimirNotasdeDebitos, {
	        show: mostrarReportNDebitos,
	        op: 1,
	        report: creport,
	        onHideCancela: function onHideCancela() {
	          setMostrarReportNDebitos(false);
	        }
	      }),
	      _react2.default.createElement(_modalImprimirNCredito.ImprimirNotasdeCredito, {
	        show: mostrarReportNCredito,
	        op: 1,
	        report: creport,
	        onHideCancela: function onHideCancela() {
	          setMostrarReportNCredito(false);
	        }
	      }),
	      _react2.default.createElement(_modalImprimirCtasxCobrarEstadoCuenta.ImprimirCuentasxCobrarEstadosCuentas, {
	        show: mostrarReportEsc,
	        op: 1,
	        report: creportestc,
	        onHideCancela: function onHideCancela() {
	          setMostrarReportEsc(false);
	        }
	      }),
	      _react2.default.createElement(_modalImprimirDeudaGeneral.ImprimirDeudasGenerales, {
	        show: mostrar12,
	        ope: 1,
	        onHideCancela: function onHideCancela() {
	          setMostrar12(false);
	        }
	      }),
	      _react2.default.createElement(_modalImprimirControlVacios.ImprimirControlVacios, {
	        show: mostrar13,
	        ope: 1,
	        onHideCancela: function onHideCancela() {
	          setMostrar13(false);
	        }
	      }),
	      _react2.default.createElement(_ImprimirRecibosdePagos.ModalImprimirRecibosdePago, {
	        show: mostrar2,
	        ope: 1,
	        report: creportestc,
	        onHideCancelar: function onHideCancelar() {
	          setMostrar2(false);
	        }
	      }),
	      _react2.default.createElement(_modalImprimirAnticipos.ImprimirAnticipos, {
	        show: mostrar4,
	        ope: 1,
	        onHideCancelar: function onHideCancelar() {
	          setMostrar4(false);
	        }
	      }),
	      _react2.default.createElement(_modalImprimirAnticiposxVendedor.ImprimirAnticiposxVendedor, {
	        show: mostrar11,
	        ope: 1,
	        onHideCancelar: function onHideCancelar() {
	          setMostrar11(false);
	        }
	      }),
	      _react2.default.createElement(_imprimirIngresos.ModalImprimirIngresos, {
	        show: mostrar10,
	        ope: 1,
	        val: valrport,
	        onHideCancelar: function onHideCancelar() {
	          setMostrar10(false);
	        }
	      }),
	      _react2.default.createElement(_imprimirOpObsequio.ModalImprimirOpObsequio, {
	        show: mostrar14,
	        ope: 1,
	        onHideCancelar: function onHideCancelar() {
	          setMostrar14(false);
	        }
	      }),
	      _react2.default.createElement(_impMovBanSegunLibro.ImpMovBanLibro, {
	        show: mostrar5,
	        ope: 1,
	        onHideCancelar: function onHideCancelar() {
	          setMostrar5(false);
	        }
	      }),
	      _react2.default.createElement(_ImprimirMovimientosVentasP.ModalVentasxProductos, {
	        show: mostrar6,
	        ope: 1,
	        onHideCancelar: function onHideCancelar() {
	          setMostrar6(false);
	        }
	      }),
	      _react2.default.createElement(_ImprimirCompras.ModalImprimirFacturasCompras, {
	        show: mostrar7,
	        ope: 1,
	        onHideCancelar: function onHideCancelar() {
	          setMostrar7(false);
	        }
	      }),
	      _react2.default.createElement(_ImprimirOpInventarios.ModalOperacionesInventario, {
	        show: mostrar1,
	        ope: 1,
	        report: creportestc,
	        onHideCancelar: function onHideCancelar() {
	          setMostrar1(false);
	        }
	      }),
	      _react2.default.createElement(_ImprimirMovimientosVentas.ModalVentasGanancias, {
	        show: mostrar3,
	        ope: 1,
	        report: creportestc,
	        onHideCancelar: function onHideCancelar() {
	          setMostrar3(false);
	        }
	      }),
	      _react2.default.createElement(_ImprimirPedidosPendientes.ModalPedidosPendientes, {
	        show: mostrar15,
	        ope: 1,
	        report: creportestc,
	        onHideCancelar: function onHideCancelar() {
	          setMostrar15(false);
	        }
	      }),
	      _react2.default.createElement(_imprimirRecibosReversado.ModalImprimirRecibosReversados, {
	        show: mostrar16,
	        ope: 1,
	        report: creportestc,
	        onHideCancelar: function onHideCancelar() {
	          setMostrar16(false);
	        }
	      }),
	      _react2.default.createElement(_modalClientes.ModalClientes, {
	        show: mostrar17,
	        ope: 1,
	        report: creportestc,
	        onHideCancelar: function onHideCancelar() {
	          setMostrar17(false);
	        }
	      }),
	      _react2.default.createElement(_modalReportePicking.ModalPicking, {
	        show: mostrar18,
	        ope: 1,
	        report: creportestc,
	        onHideCancelar: function onHideCancelar() {
	          setMostrar18(false);
	        }
	      }),
	      _react2.default.createElement(_modalPermisosusuario.CatPermisosUsuarios, {
	        show: mpermisousuarios,
	        op: 1,
	        nom: tipopermi,
	        onHideCancela: function onHideCancela() {
	          setMpermisousuarios(false);
	        }
	      }),
	      _react2.default.createElement(_gestionarUbicacioes.GestionarUbicaciones, {
	        show: mostrarUbicaciones,
	        onHideCancela: function onHideCancela() {
	          setMostrarUbicaciones(false);
	        }
	      })
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_modalVerConfiguracion.VerConfiguracion, { show: verConfiguracion, onHideCancela: verConfig }),
	    _react2.default.createElement(_modalVerConfiguracionAthos.VerConfiguracionAthos, {
	      show: verConfiguAthos,
	      onHideCancela: function onHideCancela() {
	        return setVerConfiguAthos(false);
	      }
	    })
	  );
	
	  return sidebar;
	}
	
	exports.default = Sidebar;

/***/ },
/* 7150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _core = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ActualizarVacios = function ActualizarVacios(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	
	  var cmbCedula = ["J", "V", "G", "P"];
	
	  var txtCliente = (0, _react.useRef)();
	  var txtDespachado = (0, _react.useRef)();
	  var txtDevuelto = (0, _react.useRef)([]);
	  var txtCantidad = (0, _react.useRef)([]);
	  var txtPendientes = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtNotaEntrega = (0, _react.useRef)();
	  var txtTotalVacios = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      nota = _useState2[0],
	      setNota = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      esCredit = _useState4[0],
	      setEsCredit = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      valnota = _useState6[0],
	      setValnota = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      records = _useState8[0],
	      setRecords = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      activate = _useState10[0],
	      setActivate = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(null),
	      _useState12 = _slicedToArray(_useState11, 2),
	      body = _useState12[0],
	      setBody = _useState12[1];
	
	  var _useState13 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensaje = _useState14[0],
	      setMensaje = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mensajesino = _useState16[0],
	      setMensajesino = _useState16[1];
	
	  var nomtabla = void 0;
	  if (esCredit !== 0) {
	    nomtabla = [{ label: "TIPO DE VACIO", textAlign: "center", width: "250px" }, { label: "VACIOS PRESTADOS", textAlign: "center", width: "80px" }, { label: "VACIOS RETORNADO", textAlign: "center", width: "80px" }, { label: "VACIOS PENDIENTES", textAlign: "center", width: "80px" }, { label: "RETORNAR", textAlign: "center", width: "80px" }];
	  } else {
	    nomtabla = [{ label: "TIPO DE VACIO", textAlign: "center", width: "250px" }, { label: "VACIOS DESPACHADO", textAlign: "center", width: "80px" }, { label: "VACIOS RETORNADO", textAlign: "center", width: "80px" }, { label: "VACIOS PENDIENTES", textAlign: "center", width: "80px" }, { label: "RETORNAR", textAlign: "center", width: "80px" }];
	  }
	  var headCells = nomtabla;
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var blanquear = function blanquear() {
	    setNota(null);
	    setEsCredit(null);
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope === 1) {
	      if (records.length > 0) {
	        sigue = true;
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Error de Transacción !",
	          icono: "informacion"
	        });
	        sigue = false;
	      }
	
	      if (sigue) {
	        var notaentre = [];
	        var opeinv = [];
	        var notaentredet = [];
	        var opeinvdet = [];
	
	        for (var i = 0; i < records.length; i++) {
	          notaentredet.push({
	            idclasevacio: records[i].idclasevacio,
	            idproducto: records[i].idproducto,
	            despachado: records[i].despachado,
	            devuelto: records[i].devuelto,
	            pendiente: records[i].pendiente
	          });
	
	          if (records[i].cantidad > 0) {
	            if (esCredit !== 0) {
	              opeinvdet.push({
	                idclasevacio: records[i].idclasevacio,
	                cantidad: records[i].cantidad,
	                tipomovimiento: "DESPACHO",
	                fechatipomovimiento: (0, _moment2.default)(fechasistema).format('DD-MM-YYYY'),
	                numfactura: records[i].numnotavacio,
	                idalmacen: records[i].idalmacen
	              });
	            } else {
	              opeinvdet.push({
	                idclasevacio: records[i].idclasevacio,
	                cantidad: records[i].cantidad,
	                tipomovimiento: "RECEPCION",
	                fechatipomovimiento: (0, _moment2.default)(fechasistema).format('DD-MM-YYYY'),
	                numfactura: records[i].numnotavacio,
	                idalmacen: records[i].idalmacen
	              });
	            }
	          }
	        }
	
	        notaentre.push({
	          idnotavacio: props.data[0].idnotavacio,
	          numnotavacio: props.data[0].numnotavacio,
	          descripcion: esCredit !== 1 ? "DESPACHO DE VACIOS" : "CREDITO DE VACIO POR PARTE DEL CLIENTE: " + "CREDITO DE VACIO POR PARTE DEL CLIENTE/PROVEEDOR: " + txtCliente.current.value.toUpperCase().trim(),
	          tipo: props.data[0].tipo,
	          totaldespachado: txtDespachado.current.value,
	          totaldevuelto: txtDevuelto.current.value,
	          totalpendiente: txtPendientes.current.value,
	          idcliente: props.data[0].idcliente,
	          idvendedor: props.data[0].idvendedor,
	          fecha: (0, _moment2.default)(fechasistema).format('DD-MM-YYYY'),
	          status: txtDevuelto.current.value === txtDespachado.current.value ? 1 : 0,
	          idalmacen: props.data[0].idalmacen,
	          notaentredet: notaentredet
	        });
	
	        if (esCredit !== 0) {
	          opeinv.push({
	            idtipopeinv: 2,
	            idoperacioninventario: 0,
	            tipooperacion: "SALIDA",
	            idalmacenorigen: props.data[0].idalmacen,
	            idalmacendestino: "",
	            fecha: (0, _moment2.default)(fechasistema).format('DD-MM-YYYY'),
	            observacion: esCredit !== 1 ? "DESPACHO DE VACIOS" : "CREDITO DE VACIO POR PARTE DEL CLIENTE: " + "CREDITO DE VACIO POR PARTE DEL CLIENTE/PROVEEDOR: " + txtCliente.current.value.toUpperCase().trim(),
	            numnotavacio: props.data[0].numnotavacio.trim(),
	            opeinvdet: opeinvdet
	          });
	        } else {
	          opeinv.push({
	            idtipopeinv: 1,
	            idoperacioninventario: 0,
	            tipooperacion: "INGRESO",
	            idalmacenorigen: props.data[0].idalmacen,
	            idalmacendestino: "",
	            fecha: (0, _moment2.default)(fechasistema).format('DD-MM-YYYY'),
	            observacion: esCredit !== 1 ? "DESPACHO DE VACIOS" : "CREDITO DE VACIO POR PARTE DEL CLIENTE: " + "CREDITO DE VACIO POR PARTE DEL CLIENTE/PROVEEDOR: " + txtCliente.current.value.toUpperCase().trim(),
	            numnotavacio: props.data[0].numnotavacio.trim(),
	            opeinvdet: opeinvdet
	          });
	        }
	
	        setBody({
	          notaentre: notaentre,
	          opeinv: opeinv
	        });
	
	        var msg = "";
	        if (props.opera === 2) {
	          msg = "Esta Seguro de Procesar este Registro.";
	        } else if (props.opera === 4) {
	          msg = "Esta Seguro de Eliminar este Registro.";
	        }
	
	        setMensajesino({
	          mostrar: true,
	          titulo: "Confirmación.",
	          texto: msg,
	          icono: "confirmacion"
	        });
	      }
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/inventariovacio/actualizarnotavacio/" + (props.opera === 4 ? 3 : 2);
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (props.opera === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "N° Control de Vacio Actualizado Correctamente",
	            icono: "exito"
	          });
	        } else if (props.opera === 4) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Control de Vacio Eliminado Correctamente",
	            icono: "exito"
	          });
	        }
	        blanquear();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = error.response.data.message;
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    props.onHideCancelar();
	    props.onRenderizar();
	  };
	
	  var actualizarVacio = function actualizarVacio(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	          event.target.value = "0,00";
	        }
	        event.target.value = (0, _varios.formatoMonto)(event.target.value);
	        var char1 = event.target.value.substring(0, 1);
	        var char2 = event.target.value.substring(1, 2);
	        if (char1 === "0" && char2 !== ",") {
	          event.target.value = event.target.value.substring(1, event.target.value.length);
	        }
	        if (event.target.id === "cantidad") {
	          var cantidades = (0, _varios.validarCantidaddos)({
	            index: index,
	            event: event,
	            vacios: records
	          });
	          if (event.which === 13) {
	            if (index < cantidades.data.length) {
	              setTimeout(function () {
	                return txtCantidad.current[index + 1].focus();
	              }, 300);
	            }
	          }
	
	          var data = [].concat(_toConsumableArray(records));
	
	          var cantvacios = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	          var devu = parseFloat(data[index].devueltoreal);
	          var pendi = data[index].pendientereal;
	          var valto = devu + cantvacios;
	
	          if (parseFloat(valto) > parseFloat(data[index].despachado)) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "¡ La Cantidad de Vacios no Debe ser Mayor a la Cantidad Despachado !",
	              icono: "informacion"
	            });
	            data[index].devuelto = data[index].devueltoreal;
	            data[index].pendiente = data[index].pendientereal;
	            data[index].cantidad = 0.00;
	          } else {
	            data[index].devuelto = cantvacios === 0 ? data[index].devueltoreal : devu + cantvacios;
	            data[index].pendiente = cantvacios === 0 ? data[index].pendientereal : pendi - cantvacios;
	            data[index].cantidad = cantvacios;
	          }
	
	          var totalv = 0.00;
	          var todevu = 0.00;
	          var todespa = 0.00;
	          var topendi = 0.00;
	
	          for (var c = 0; c < data.length; c++) {
	
	            totalv = parseFloat(totalv) + parseFloat(data[c].devuelto);
	            todevu = parseFloat(todevu) + parseFloat(data[c].devuelto);
	            todespa = parseFloat(todespa) + parseFloat(data[c].despachado);
	            topendi = parseFloat(topendi) + parseFloat(data[c].pendiente);
	          }
	
	          txtDespachado.current.value = todespa;
	          txtDevuelto.current.value = todevu;
	          txtPendientes.current.value = topendi;
	
	          txtTotalVacios.current.value = (0, _varios.formatMoneda)(totalv.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	          setRecords(data);
	        }
	      } else if (event.which === 46) {
	        return false;
	      } else if (event.which >= 48 && event.which <= 57) {
	        return true;
	      } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	        return true;
	      } else return false;
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      size: "xl",
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        if (props.ope === 1) {
	
	          cmbRif.current.value = props.data[0].rifcliente.substring(0, 1);
	          txtRif.current.value = props.data[0].rifcliente.substring(1, 12);
	          txtCliente.current.value = props.data[0].cliente;
	          var data = [];
	          var totalv = 0.00;
	
	          if (props.data[0].tipo !== 'NC') {
	            setEsCredit(0);
	          } else {
	            setEsCredit(1);
	          }
	
	          if (props.data[0].numnotaentrega !== null && props.data[0].numnotaentrega !== 'N/S') {
	            setValnota(1);
	            setNota(props.data[0].numnotaentrega);
	          } else {
	            setValnota(0);
	            setNota(props.data[0].numnotavacio);
	          }
	
	          for (var i = 0; i < props.data.length; i++) {
	            data.push({
	              clasevacio: props.data[i].clasevacio,
	              idproducto: props.data[i].idproducto,
	              despachado: props.data[i].despachado,
	              devuelto: props.data[i].devuelto,
	              idalmacen: props.data[i].idalmacen,
	              idcliente: props.data[i].idcliente,
	              idnotavacio: props.data[i].idnotavacio,
	              idoperacioninventariovacio: props.data[i].idoperacioninventariovacio,
	              numnotavacio: props.data[i].numnotavacio,
	              pendiente: props.data[i].pendiente,
	              tipo: props.data[i].tipo,
	              idclasevacio: props.data[i].idclasevacio,
	              cantidad: 0,
	              despachadoreal: props.data[i].despachado,
	              devueltoreal: props.data[i].devuelto,
	              pendientereal: props.data[i].pendiente
	            });
	
	            totalv = parseFloat(totalv) + parseFloat(props.data[i].devuelto);
	          }
	          txtTotalVacios.current.value = (0, _varios.formatMoneda)(totalv.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          setRecords(data);
	          if (data.length > 0) {
	            setTimeout(function () {
	              return txtCantidad.current[0].focus();
	            }, 300);
	          }
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Gestionar Entrega de Vacios"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { style: { height: "100%", width: "100%" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row col-md-12", style: { margin: 0 } },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row border-azul mx-auto rounded py-1" },
	            esCredit !== 0 ? _react2.default.createElement(
	              "div",
	              { className: "col-pd-350 px-1" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 px-1" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text text-primary fw-bold fs-5",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "CREDITO DE VACIO"
	                )
	              )
	            ) : '',
	            _react2.default.createElement(
	              "div",
	              { className: "col-pd-350 ml-auto" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 px-1" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  valnota !== 0 ? "N° NOTA DE ENTREGA:" : "N° NOTA DE VACIO:"
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  className: "form-control fs-6",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  ref: txtNotaEntrega,
	                  defaultValue: nota
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-12 mx-auto mb-1 ",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row border-azul rounded py-2" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold mb-1" },
	                  "Datos del Cliente/Proveedor"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-3 px-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: cmbRif,
	                      name: "cmbrif",
	                      disabled: true,
	                      className: "form-select form-select-sm col-md-3 text-center",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "--"
	                    ),
	                    cmbCedula && cmbCedula.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item },
	                        item
	                      );
	                    })
	                  ),
	                  _react2.default.createElement("input", {
	                    ref: txtRif,
	                    autoComplete: "off",
	                    disabled: true,
	                    maxLength: 12,
	                    type: "text",
	                    className: "form-control fs-6 px-1",
	                    name: "cedula",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-9 px-0" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "NOMBRE:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    ref: txtCliente
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 border-azul px-0 rounded",
	                style: { backgroundColor: "#d5e9ff" }
	              },
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 190,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px",
	                    fontSizeAdjust: "0.6"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden" },
	                  records && records.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      { key: index, style: { padding: "0" } },
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-center p-0" },
	                        item.clasevacio
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-right p-0 pl-2 border-warning",
	                          style: { width: "80px" }
	                        },
	                        (0, _varios.formatMoneda)(item.despachado.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-right p-0 border-success",
	                          style: { width: "80px" }
	                        },
	                        (0, _varios.formatMoneda)(item.devuelto.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2 border-danger",
	                          style: { width: "80px" }
	                        },
	                        (0, _varios.formatMoneda)(item.pendiente.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "80px" }
	                        },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control form-control-sm bg-light text-right fs-6",
	                          id: "cantidad",
	                          defaultValue: (0, _varios.formatMoneda)(item.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          disabled: props.opera === 4 ? true : false,
	                          ref: function ref(el) {
	                            return txtCantidad.current[index] = el;
	                          },
	                          onFocus: _varios.seleccionarCampo,
	                          onKeyUp: actualizarVacio(index),
	                          onBlur: actualizarVacio(index),
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      )
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4 border-azul px-0 rounded ml-auto border-3" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm col px-0 ml-auto m-0" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "TOTAL VACIOS ENTREGADOS:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  className: "form-control fs-5 h-100 text-right",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  ref: txtTotalVacios
	                }),
	                _react2.default.createElement("input", { type: "hidden", ref: txtDespachado }),
	                _react2.default.createElement("input", { type: "hidden", ref: txtDevuelto }),
	                _react2.default.createElement("input", { type: "hidden", ref: txtPendientes })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          className: "btn btn-sm btn-success rounded-pill",
	          onClick: onChangeValidar,
	          ref: btnAcepta,
	          style: { margin: "5px" }
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Procesar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "Cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({
	          mostrar: false,
	          titulo: "",
	          texto: "",
	          icono: ""
	        });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = ActualizarVacios;

/***/ },
/* 7151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _core = __webpack_require__(19);
	
	var _catalogoNotaEntregaVacios = __webpack_require__(7031);
	
	var _catalogoNotaEntregaVacios2 = _interopRequireDefault(_catalogoNotaEntregaVacios);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _catalogoClassVacios = __webpack_require__(292);
	
	var _catalogoClassVacios2 = _interopRequireDefault(_catalogoClassVacios);
	
	var _catalogoAlmacen = __webpack_require__(51);
	
	var _catalogoAlmacen2 = _interopRequireDefault(_catalogoAlmacen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var GestionarVacios = function GestionarVacios(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var cmbCedula = ["J", "V", "G", "P"];
	
	  var txtCliente = (0, _react.useRef)();
	  var txtDespachado = (0, _react.useRef)();
	  var txtDevuelto = (0, _react.useRef)([]);
	  var txtCantidad = (0, _react.useRef)([]);
	  var txtPendientes = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtTipogestion = (0, _react.useRef)();
	  var txtNotaEntrega = (0, _react.useRef)();
	  var txtAlmacen = (0, _react.useRef)();
	  var txtIdalmacen = (0, _react.useRef)();
	  var txtIdcliente = (0, _react.useRef)();
	  var txtDespachadod = (0, _react.useRef)([]);
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      mostrar = _useState2[0],
	      setMostrar = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      mostra2 = _useState4[0],
	      setMostra2 = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mostrar3 = _useState6[0],
	      setMostrar3 = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mostrar4 = _useState8[0],
	      setMostrar4 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)([]),
	      _useState10 = _slicedToArray(_useState9, 2),
	      records = _useState10[0],
	      setRecords = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      activate = _useState12[0],
	      setActivate = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(null),
	      _useState14 = _slicedToArray(_useState13, 2),
	      body = _useState14[0],
	      setBody = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(true),
	      _useState16 = _slicedToArray(_useState15, 2),
	      detavacios = _useState16[0],
	      setDetavacios = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(true),
	      _useState18 = _slicedToArray(_useState17, 2),
	      activ = _useState18[0],
	      setActiv = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(true),
	      _useState20 = _slicedToArray(_useState19, 2),
	      activcliente = _useState20[0],
	      setActivcliente = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      activnota = _useState22[0],
	      setActivnota = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0),
	      _useState24 = _slicedToArray(_useState23, 2),
	      esCredit = _useState24[0],
	      setEsCredit = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(null),
	      _useState26 = _slicedToArray(_useState25, 2),
	      idAlmacen = _useState26[0],
	      setIdAlmacen = _useState26[1];
	
	  var _useState27 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState28 = _slicedToArray(_useState27, 2),
	      mensaje = _useState28[0],
	      setMensaje = _useState28[1];
	
	  var _useState29 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState30 = _slicedToArray(_useState29, 2),
	      mensajesino = _useState30[0],
	      setMensajesino = _useState30[1];
	
	  var _useState31 = (0, _react.useState)({
	    idnotavacio: null,
	    numnotavacio: null,
	    totaldespachado: 0.0,
	    totaldevuelto: 0.0,
	    totalpendiente: 0.0,
	    idcliente: null,
	    idvendedor: null,
	    idoperacioninventariovacio: null,
	    idalmacen: null,
	    fecha: "",
	    hora: "",
	    status: 0,
	    tipo: "",
	    descripcion: "",
	    numnotaentrega: ""
	  }),
	      _useState32 = _slicedToArray(_useState31, 2),
	      notavacio = _useState32[0],
	      setNotaVacio = _useState32[1];
	
	  var nomtabla = void 0;
	  if (esCredit !== 1) {
	    nomtabla = [{ label: "TIPO DE VACIO", textAlign: "center", width: "200px" }, { label: "DESPACHADO", textAlign: "center", width: "80px" }, { label: "RETORNADO", textAlign: "center", width: "80px" }, { label: "PENDIENTES", textAlign: "center", width: "80px" }, { label: "RETORNAR", textAlign: "center", width: "80px" }, { label: "--", textAlign: "center", width: "60px" }];
	  } else {
	    nomtabla = [{ label: "TIPO DE VACIO", textAlign: "center", width: "200px" }, { label: "PRESTADOS", textAlign: "center", width: "80px" }, { label: "RETORNADO", textAlign: "center", width: "80px" }, { label: "PENDIENTES", textAlign: "center", width: "80px" }, { label: "RETORNAR", textAlign: "center", width: "80px" }, { label: "--", textAlign: "center", width: "60px" }];
	  }
	  var headCells = nomtabla;
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var blanquear = function blanquear() {
	    setMostrar(false);
	    setRecords([]);
	    setActivnota(0);
	    setEsCredit(0);
	    setActivcliente(true);
	    setActiv(true);
	    setIdAlmacen(null);
	    setNotaVacio({
	      idnotavacio: null,
	      numnotavacio: null,
	      totaldespachado: 0.0,
	      totaldevuelto: 0.0,
	      totalpendiente: 0.0,
	      idcliente: null,
	      idvendedor: null,
	      idoperacioninventariovacio: null,
	      idalmacen: null,
	      fecha: "",
	      hora: "",
	      status: 0,
	      tipo: "",
	      descripcion: "",
	      numnotaentrega: ""
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var onCatalogoCliente = function onCatalogoCliente(values) {
	    setMostra2(false);
	    txtCliente.current.value = values.nombre;
	    cmbRif.current.value = values.rif.substring(0, 1);
	    txtRif.current.value = values.rif.substring(1);
	    txtIdcliente.current.value = values.idagente;
	    setActiv(false);
	  };
	
	  var onCatalogoAlmacen = function onCatalogoAlmacen(values) {
	    setMostrar4(false);
	    setIdAlmacen(values.idalmacen);
	    txtAlmacen.current.value = values.descripcion;
	    txtIdalmacen.current.value = values.idalmacen;
	  };
	
	  var onCatalogoClassVacios = function onCatalogoClassVacios(values) {
	    setMostrar3(false);
	
	    var data = [].concat(_toConsumableArray(records));
	    var datos = [];
	    var pas = 0;
	
	    for (var i = 0; i < data.length; i++) {
	      if (records[i].idclasevacio === values.idclasevacio) {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Esta Clase de Vacio ya fue Seleccionada !",
	          icono: "informacion"
	        });
	        return;
	      }
	
	      datos.push({
	        clasevacio: data[i].clasevacio,
	        idproducto: data[i].idproducto,
	        despachado: data[i].despachado,
	        devuelto: data[i].devuelto,
	        pendiente: data[i].pendiente,
	        idclasevacio: data[i].idclasevacio,
	        cantidad: data[i].cantidad,
	        despachadoreal: data[i].despachadoreal,
	        devueltoreal: data[i].devueltoreal,
	        pendientereal: data[i].pendientereal,
	        numfactura: ""
	      });
	
	      pas = 1;
	    }
	    datos.push({
	      clasevacio: values.descripcion,
	      idproducto: values.idproducto,
	      despachado: 0.0,
	      devuelto: 0.0,
	      pendiente: 0.0,
	      idclasevacio: values.idclasevacio,
	      cantidad: 0,
	      despachadoreal: 0.0,
	      devueltoreal: 0.0,
	      pendientereal: 0.0,
	      numfactura: ""
	    });
	
	    setRecords(datos);
	    setDetavacios(false);
	
	    if (datos.length > 0) {
	      setTimeout(function () {
	        return txtDespachadod.current[datos.length - 1].focus();
	      }, 300);
	    }
	  };
	
	  var seleccionarNotaEntregaVacios = function seleccionarNotaEntregaVacios(numnota) {
	    var endpoint = op.conexion + "/api/inventariovacio/selecnotaentregavacio?&numnota=" + numnota;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          txtNotaEntrega.current.value = response.data[0].numnotaentrega;
	          cmbRif.current.value = response.data[0].rifcliente.substring(0, 1);
	          txtRif.current.value = response.data[0].rifcliente.substring(1, 11);
	          txtCliente.current.value = response.data[0].cliente;
	          txtIdalmacen.current.value = response.data[0].idalmacen;
	          txtIdcliente.current.value = response.data[0].idcliente;
	
	          var datos = [];
	          for (var i = 0; i < response.data.length; i++) {
	            datos.push({
	              clasevacio: response.data[i].tipovacio,
	              idproducto: response.data[i].idproducto,
	              despachado: response.data[i].cantidad,
	              devuelto: response.data[i].devuelto,
	              pendiente: response.data[i].pendiente > 0 ? response.data[i].pendiente : response.data[i].cantidad,
	              idalmacen: response.data[i].idalmacen,
	              idcliente: response.data[i].idcliente,
	              idclasevacio: response.data[i].idclasevacio,
	              cantidad: 0,
	              despachadoreal: response.data[i].cantidad,
	              devueltoreal: response.data[i].devuelto,
	              pendientereal: response.data[i].pendiente > 0 ? response.data[i].pendiente : response.data[i].cantidad,
	              numfactura: response.data[i].numnotaentrega
	            });
	          }
	          setRecords(datos);
	          setDetavacios(false);
	          setActiv(true);
	          if (datos.length > 0) {
	            setTimeout(function () {
	              return txtCantidad.current[0].focus();
	            }, 300);
	          }
	        } else {
	          setActiv(true);
	          setRecords([]);
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "¡ N° Nota de Entrega no Existe !",
	            icono: "informacion"
	          });
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope === 1) {
	      if (activnota === 2) {
	        if (txtAlmacen.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "¡ Seleccione el Almacen !",
	            icono: "informacion"
	          });
	          sigue = false;
	        } else if (txtCliente.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "¡ Seleccione el Cliente !",
	            icono: "informacion"
	          });
	          sigue = false;
	        } else if (records.length > 0) {
	          if (records[0].despachado > 0) {
	            sigue = true;
	          } else {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "¡ Los Campos de la Tabla no deben ir Vacios !",
	              icono: "informacion"
	            });
	            sigue = false;
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "¡ Error de Transacción !",
	            icono: "informacion"
	          });
	          sigue = false;
	        }
	      } else if (activnota === 1) {
	        if (txtNotaEntrega.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "¡ Introduzca la Nota de Entrega !",
	            icono: "informacion"
	          });
	          sigue = false;
	          txtNotaEntrega.current.focus();
	        } else if (records.length > 0) {
	          sigue = true;
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "¡ Error de Transacción !",
	            icono: "informacion"
	          });
	          sigue = false;
	        }
	      } else {
	        sigue = true;
	      }
	
	      if (sigue === true) {
	        var notaentre = [];
	        var opeinv = [];
	        var notaentredet = [];
	        var opeinvdet = [];
	        var opeinvdetd = [];
	
	        for (var i = 0; i < records.length; i++) {
	          notaentredet.push({
	            idclasevacio: records[i].idclasevacio,
	            idproducto: records[i].idproducto,
	            despachado: records[i].despachado,
	            devuelto: records[i].devuelto,
	            pendiente: records[i].pendiente
	          });
	
	          if (esCredit !== 0) {
	            opeinvdet.push({
	              idclasevacio: records[i].idclasevacio,
	              cantidad: records[i].despachado,
	              tipomovimiento: "RECEPCION",
	              fechatipomovimiento: (0, _moment2.default)(txtFecha.current.value).format("DD-MM-YYYY"),
	              numfactura: "",
	              idalmacen: txtIdalmacen.current.value
	            });
	          } else {
	            opeinvdet.push({
	              idclasevacio: records[i].idclasevacio,
	              cantidad: records[i].despachado,
	              tipomovimiento: "DESPACHO",
	              fechatipomovimiento: (0, _moment2.default)(txtFecha.current.value).format("DD-MM-YYYY"),
	              numfactura: "",
	              idalmacen: txtIdalmacen.current.value
	            });
	          }
	
	          if (records[i].cantidad > 0.0) {
	            if (esCredit !== 0) {
	              opeinvdetd.push({
	                idclasevacio: records[i].idclasevacio,
	                cantidad: records[i].cantidad,
	                tipomovimiento: "DESPACHO",
	                fechatipomovimiento: (0, _moment2.default)(txtFecha.current.value).format("DD-MM-YYYY"),
	                numfactura: "",
	                idalmacen: txtIdalmacen.current.value
	              });
	            } else {
	              opeinvdetd.push({
	                idclasevacio: records[i].idclasevacio,
	                cantidad: records[i].cantidad,
	                tipomovimiento: "RECEPCION",
	                fechatipomovimiento: (0, _moment2.default)(txtFecha.current.value).format("DD-MM-YYYY"),
	                numfactura: "",
	                idalmacen: txtIdalmacen.current.value
	              });
	            }
	          }
	        }
	
	        notaentre.push({
	          app: false,
	          idnotavacio: 0,
	          numnotavacio: 0,
	          descripcion: esCredit !== 1 ? "NOTA DE VACIO" : "CREDITO DE VACIO POR PARTE DEL CLIENTE/PROVEEDOR: " + txtCliente.current.value.toUpperCase().trim(),
	          tipo: activnota === 1 && esCredit !== 1 ? "NE" : esCredit !== 1 ? "NV" : "NC",
	          totaldespachado: notavacio.totaldespachado,
	          totaldevuelto: notavacio.totaldevuelto,
	          totalpendiente: notavacio.totalpendiente,
	          idcliente: txtIdcliente.current.value,
	          idvendedor: idVendedor,
	          fecha: (0, _moment2.default)(txtFecha.current.value).format("DD-MM-YYYY"),
	          status: notavacio.totaldevuelto === notavacio.totaldespachado ? 1 : 0,
	          idalmacen: txtIdalmacen.current.value,
	          numnotaentrega: activnota === 1 ? txtNotaEntrega.current.value : "N/S",
	          notaentredet: notaentredet
	        });
	
	        if (esCredit !== 0) {
	          if (opeinvdetd.length > 0) {
	            opeinv.push({
	              idtipopeinv: 2,
	              idoperacioninventario: 0,
	              tipooperacion: "SALIDA",
	              idalmacenorigen: txtIdalmacen.current.value,
	              idalmacendestino: "",
	              fecha: (0, _moment2.default)(txtFecha.current.value).format("DD-MM-YYYY"),
	              observacion: esCredit !== 1 ? "NOTA DE VACIO" : "CREDITO DE VACIO POR PARTE DEL CLIENTE/PROVEEDOR: " + txtCliente.current.value.toUpperCase().trim(),
	              numnotavacio: '',
	              opeinvdet: opeinvdetd
	            });
	          } else {
	            opeinv.push({
	              idtipopeinv: 1,
	              idoperacioninventario: 0,
	              tipooperacion: "INGRESO",
	              idalmacenorigen: txtIdalmacen.current.value,
	              idalmacendestino: "",
	              fecha: (0, _moment2.default)(txtFecha.current.value).format("DD-MM-YYYY"),
	              observacion: esCredit !== 1 ? "NOTA DE VACIO" : "CREDITO DE VACIO POR PARTE DEL CLIENTE/PROVEEDOR: " + txtCliente.current.value.toUpperCase().trim(),
	              numnotavacio: '',
	              opeinvdet: opeinvdet
	            });
	          }
	        } else {
	          opeinv.push({
	            idtipopeinv: 2,
	            idoperacioninventario: 0,
	            tipooperacion: "SALIDA",
	            idalmacenorigen: txtIdalmacen.current.value,
	            idalmacendestino: "",
	            fecha: (0, _moment2.default)(txtFecha.current.value).format("DD-MM-YYYY"),
	            observacion: esCredit !== 1 ? "NOTA DE VACIO" : "CREDITO DE VACIO POR PARTE DEL CLIENTE/PROVEEDOR: " + txtCliente.current.value.toUpperCase().trim(),
	            numnotavacio: '',
	            opeinvdet: opeinvdet
	          });
	
	          if (opeinvdetd.length > 0) {
	            opeinv.push({
	              idtipopeinv: 1,
	              idoperacioninventario: 0,
	              tipooperacion: "INGRESO",
	              idalmacenorigen: txtIdalmacen.current.value,
	              idalmacendestino: "",
	              fecha: (0, _moment2.default)(txtFecha.current.value).format("DD-MM-YYYY"),
	              observacion: esCredit !== 1 ? "NOTA DE VACIO" : "CREDITO DE VACIO POR PARTE DEL CLIENTE/PROVEEDOR: " + txtCliente.current.value.toUpperCase().trim(),
	              numnotavacio: '',
	              opeinvdet: opeinvdetd
	            });
	          }
	        }
	        setBody({
	          notaentre: notaentre,
	          opeinv: opeinv
	        });
	
	        var msg = "";
	        if (props.ope === 1) {
	          msg = "Esta Seguro de Procesar este Registro.";
	        }
	
	        setMensajesino({
	          mostrar: true,
	          titulo: "Confirmación.",
	          texto: msg,
	          icono: "confirmacion"
	        });
	      }
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/inventariovacio/actualizarnotavacio/1";
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (props.ope === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Control de Vacio Registrado Correctamente",
	            icono: "exito"
	          });
	
	          /* var reporte = "ReporteRecibodePago";
	          let opera = 2;
	          let condi = "'" + response.data.numeropago + "'";
	          let tipo = tiponot; */
	
	          /* window.open(
	            op.reportes +
	            "/finanzas?afiliado=" +
	            afiliado +
	            "&reporte=" +
	            reporte +
	            "&NUMPAGO=" +
	            condi +
	            "&OP=" +
	            opera +
	            "&TIPOPAGO=" +
	            tipo,
	            "Planilla",
	            "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
	          ); */
	        } else if (props.ope === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Pago Registrado Correctamente",
	            icono: "exito"
	          });
	        }
	        blanquear();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = error.response.data.message;
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    setActiv(true);
	    setActivcliente(true);
	    setActivnota(0);
	    props.onHideCancelar();
	    setDetavacios(true);
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    props.onHideCancelar();
	    props.onRenderizar();
	  };
	
	  var actualizarVacio = function actualizarVacio(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	          event.target.value = "0,00";
	        }
	        event.target.value = (0, _varios.formatoMonto)(event.target.value);
	        var char1 = event.target.value.substring(0, 1);
	        var char2 = event.target.value.substring(1, 2);
	        if (char1 === "0" && char2 !== ",") {
	          event.target.value = event.target.value.substring(1, event.target.value.length);
	        }
	        if (event.target.id === "cantidad") {
	          var cantidades = (0, _varios.validarCantidaddos)({
	            index: index,
	            event: event,
	            vacios: records
	          });
	          if (event.which === 13) {
	            if (index < cantidades.data.length) {
	              setTimeout(function () {
	                return txtCantidad.current[index + 1].focus();
	              }, 300);
	            }
	          }
	
	          var data = [].concat(_toConsumableArray(records));
	
	          var cantvacios = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	          var desp = parseFloat(data[index].despachado);
	          var devu = parseFloat(data[index].devueltoreal);
	          var valto = devu + cantvacios;
	          var pendi = desp - valto;
	
	          if (parseFloat(valto) > parseFloat(data[index].despachado)) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "¡ La Cantidad de Vacios no Debe ser Mayor a la Cantidad Despachado !",
	              icono: "informacion"
	            });
	
	            data[index].devuelto = data[index].devueltoreal;
	            data[index].pendiente = data[index].pendientereal;
	            data[index].cantidad = 0.0;
	          } else {
	            data[index].devuelto = cantvacios === 0 ? data[index].devueltoreal : devu + cantvacios;
	            data[index].pendiente = cantvacios === 0 ? data[index].pendientereal : pendi;
	            data[index].cantidad = cantvacios;
	          }
	
	          var totalv = 0.0;
	          var todevu = 0.0;
	          var todespa = 0.0;
	          var topendi = 0.0;
	
	          for (var c = 0; c < data.length; c++) {
	            totalv = parseFloat(totalv) + parseFloat(data[c].devuelto);
	            todevu = parseFloat(todevu) + parseFloat(data[c].devuelto);
	            todespa = parseFloat(todespa) + parseFloat(data[c].despachado);
	            topendi = parseFloat(topendi) + parseFloat(data[c].pendiente);
	          }
	
	          setNotaVacio(Object.assign({}, notavacio, {
	            totaldespachado: todespa,
	            totaldevuelto: todevu,
	            totalpendiente: topendi
	          }));
	
	          setRecords(data);
	        }
	      } else if (event.which === 46) {
	        return false;
	      } else if (event.which >= 48 && event.which <= 57) {
	        return true;
	      } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	        return true;
	      } else return false;
	    };
	  };
	
	  var actualizarVacioDespachado = function actualizarVacioDespachado(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	          event.target.value = "0,00";
	        }
	        event.target.value = (0, _varios.formatoMonto)(event.target.value);
	        var char1 = event.target.value.substring(0, 1);
	        var char2 = event.target.value.substring(1, 2);
	        if (char1 === "0" && char2 !== ",") {
	          event.target.value = event.target.value.substring(1, event.target.value.length);
	        }
	        if (event.target.id === "despachado") {
	          var data = [].concat(_toConsumableArray(records));
	          var cantvacios = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	          var devu = parseFloat(data[index].devuelto);
	
	          data[index].despachado = cantvacios;
	          data[index].despachadoreal = cantvacios;
	          data[index].pendiente = cantvacios - devu;
	
	          var totalv = 0.0;
	          var todevu = 0.0;
	          var topendi = 0.0;
	          var todespa = 0.0;
	
	          for (var i = 0; i < data.length; i++) {
	            todespa = todespa + data[i].despachado;
	            todevu = todevu + data[i].devuelto;
	          }
	
	          topendi = todespa - todevu;
	
	          setNotaVacio(Object.assign({}, notavacio, {
	            totaldespachado: todespa,
	            totaldevuelto: todevu,
	            totalpendiente: topendi
	          }));
	
	          setRecords(data);
	        }
	      } else if (event.which === 46) {
	        return false;
	      } else if (event.which >= 48 && event.which <= 57) {
	        return true;
	      } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	        return true;
	      } else return false;
	    };
	  };
	
	  var eliminarVacio = function eliminarVacio(n) {
	    return function (e) {
	      e.preventDefault();
	      var data = [].concat(_toConsumableArray(records));
	      var elementos = [];
	      var todevu = 0.0;
	      var todespa = 0.0;
	      var topendi = 0.0;
	
	      for (var i = 0; i < data.length; i++) {
	        if (n.idclasevacio !== data[i].idclasevacio) {
	          elementos.push(data[i]);
	          todevu = parseFloat(todevu) + parseFloat(data[i].devuelto);
	          todespa = parseFloat(todespa) + parseFloat(data[i].despachado);
	          topendi = parseFloat(topendi) + parseFloat(data[i].pendiente);
	        }
	      }
	
	      setNotaVacio(Object.assign({}, notavacio, {
	        totaldespachado: todespa,
	        totaldevuelto: todevu,
	        totalpendiente: topendi
	      }));
	
	      setRecords(elementos);
	    };
	  };
	
	  var seleccionarCliente = function seleccionarCliente(rif) {
	    var campos = "c.idagente, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
	    var nomtab = "agente as c";
	    var nomid = "c.rif";
	    var nomid2 = "c.cliente";
	    var id = rif;
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtCliente.current.value = response.data.nombrec;
	          txtRif.current.value = response.data.rifc;
	          cmbRif.current.value = response.data.tiporifc;
	          setActiv(false);
	          //setDetavacios(false);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No Existe un Cliente con este Número de Documento",
	            icono: "informacion"
	          });
	          setActiv(true);
	          txtCliente.current.value = "";
	          txtRif.current.value = "";
	          cmbRif.current.value = "";
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var validarCliente = function validarCliente(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (cmbRif.current.value !== "" && event.target.value !== "") {
	        var rif = cmbRif.current.value + event.target.value;
	        seleccionarCliente(rif, event.which);
	      }
	    }
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "tipo") {
	      setRecords([]);
	      setNotaVacio({
	        idnotavacio: null,
	        numnotavacio: null,
	        totaldespachado: 0.0,
	        totaldevuelto: 0.0,
	        totalpendiente: 0.0,
	        idcliente: null,
	        idvendedor: null,
	        idoperacioninventariovacio: null,
	        idalmacen: null,
	        fecha: "",
	        hora: "",
	        status: 0,
	        tipo: "",
	        descripcion: "",
	        numnotaentrega: ""
	      });
	
	      cmbRif.current.value = "";
	      txtRif.current.value = "";
	      txtCliente.current.value = "";
	
	      if (e.target.value === "1") {
	        setActivcliente(false);
	        setActivnota(2);
	        setEsCredit(0);
	        txtNotaEntrega.current ? txtNotaEntrega.current.value = "" : "";
	      } else if (e.target.value === "2") {
	        setActivcliente(true);
	        setActivnota(1);
	        setEsCredit(0);
	      } else {
	        setEsCredit(1);
	        setActivnota(2);
	        setActivcliente(false);
	      }
	    }
	  };
	
	  var handleNotaEntregaVacio = function handleNotaEntregaVacio(e) {
	    e.preventDefault();
	    if (e.which === 13 || typeof e.which === "undefined") {
	      if (e.target.value !== "") {
	        seleccionarNotaEntregaVacios(e.target.value);
	      }
	    }
	  };
	
	  var onCatalogoNotaEntrega = function onCatalogoNotaEntrega(values) {
	    setMostrar(false);
	    seleccionarNotaEntregaVacios(values.numnotaentrega);
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      size: "xl",
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        if (props.ope === 1) {
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Gestionar Entrega de Vacios"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { style: { height: "100%", width: "100%" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row col-md-12", style: { margin: 0 } },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row border-azul mx-auto rounded py-1" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-12 mx-auto mb-1 px-0",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "fieldset",
	                { className: "col-md-12 mx-auto row border-azul rounded py-2" },
	                _react2.default.createElement(
	                  "legend",
	                  {
	                    className: "float-none m-0 w-auto fw-bold text-black",
	                    style: { fontSize: "1rem" }
	                  },
	                  "Datos"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-330 px-1" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO DE GESTION:",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: txtTipogestion,
	                      name: "tipo",
	                      onChange: onChange,
	                      className: "form-select form-select-sm text-center",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "--Seleccione--"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "POR CLIENTE"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "2" },
	                      "POR NOTA DE ENTREGA"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "3" },
	                      "CREDITO DE VACIO"
	                    )
	                  )
	                ),
	                activnota === 1 ? _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-420 row m-0 px-1 mx-auto" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2 col-pd-420 px-1" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "N\xB0 NOTA DE ENTREGA:",
	                      " "
	                    ),
	                    _react2.default.createElement("input", {
	                      disabled: activnota === 1 ? false : true,
	                      autoComplete: "off",
	                      type: "text",
	                      className: "form-control fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm",
	                      ref: txtNotaEntrega,
	                      onKeyUp: handleNotaEntregaVacio,
	                      onBlur: handleNotaEntregaVacio
	                    }),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        type: "button",
	                        onClick: function onClick() {
	                          return setMostrar(true);
	                        },
	                        className: "btn btn-success"
	                      },
	                      _react2.default.createElement("i", { className: "fas fa-search" })
	                    )
	                  )
	                ) : activnota === 2 ? _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-520 row m-0 px-0 mx-auto" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2 col-pd-520 px-0" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "ALMACEN:",
	                      " "
	                    ),
	                    _react2.default.createElement("input", {
	                      disabled: true,
	                      autoComplete: "off",
	                      type: "text",
	                      className: "form-control fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm",
	                      ref: txtAlmacen
	                    }),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        type: "button",
	                        onClick: function onClick() {
	                          return setMostrar4(true);
	                        },
	                        className: "btn btn-success"
	                      },
	                      _react2.default.createElement("i", { className: "fas fa-search" })
	                    )
	                  )
	                ) : "",
	                _react2.default.createElement("input", { type: "hidden", ref: txtIdalmacen }),
	                _react2.default.createElement("input", { type: "hidden", ref: txtIdcliente }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-210 px-1 ml-auto" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "date",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    ref: txtFecha
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-12 row m-0 px-0" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2 col-pd-310 px-1" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "CEDULA/RIF:",
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        ref: cmbRif,
	                        name: "cmbrif",
	                        disabled: activcliente,
	                        className: "form-select form-select-sm col-md-3 text-center",
	                        "aria-label": ".form-select-sm example"
	                      },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "" },
	                        "--"
	                      ),
	                      cmbCedula && cmbCedula.map(function (item, index) {
	                        return _react2.default.createElement(
	                          "option",
	                          { key: index, value: item },
	                          item
	                        );
	                      })
	                    ),
	                    _react2.default.createElement("input", {
	                      ref: txtRif,
	                      autoComplete: "off",
	                      maxLength: 12,
	                      type: "text",
	                      disabled: activcliente,
	                      className: "form-control fs-6 px-1",
	                      name: "cedula",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm",
	                      onKeyUp: validarCliente,
	                      onBlur: validarCliente
	                    }),
	                    activcliente === true ? "" : _react2.default.createElement(
	                      "button",
	                      {
	                        type: "button",
	                        onClick: function onClick() {
	                          return setMostra2(true);
	                        },
	                        className: "btn btn-success"
	                      },
	                      _react2.default.createElement("i", { className: "fas fa-search" })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2 col-pd-751 px-1" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "NOMBRE:",
	                      " "
	                    ),
	                    _react2.default.createElement("input", {
	                      disabled: true,
	                      autoComplete: "off",
	                      type: "text",
	                      className: "form-control fs-6",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm",
	                      ref: txtCliente
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-pd-957 border-azul px-0 rounded",
	                style: { /*height: '230px',*/backgroundColor: "#d5e9ff" }
	              },
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 190,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px",
	                    fontSizeAdjust: "0.6"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden" },
	                  records && records.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      { key: index, style: { padding: "0" } },
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle text-center p-0" },
	                        item.clasevacio
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle text-right p-0 pl-2",
	                          style: { width: "80px" }
	                        },
	                        activcliente === false ? _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control form-control-sm text-right fs-6",
	                          id: "despachado",
	                          onFocus: _varios.seleccionarCampo,
	                          defaultValue: (0, _varios.formatMoneda)(item.despachado.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtDespachadod.current[index] = el;
	                          },
	                          onKeyUp: actualizarVacioDespachado(index),
	                          onBlur: actualizarVacioDespachado(index),
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        }) : (0, _varios.formatMoneda)(item.despachado.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle text-right p-0",
	                          style: { width: "80px" }
	                        },
	                        activcliente === false ? _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control form-control-sm text-right fs-6",
	                          id: "devuelto",
	                          defaultValue: (0, _varios.formatMoneda)(item.devuelto.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtCantidad.current[index] = el;
	                          },
	                          disabled: true,
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        }) : (0, _varios.formatMoneda)(item.devuelto.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle text-end p-0 pr-2",
	                          style: { width: "80px" }
	                        },
	                        activcliente === false ? _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control form-control-sm text-right fs-6",
	                          id: "pendiente",
	                          defaultValue: (0, _varios.formatMoneda)(item.pendiente.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          disabled: true,
	                          ref: function ref(el) {
	                            return txtCantidad.current[index] = el;
	                          },
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        }) : (0, _varios.formatMoneda)(item.pendiente.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle text-end p-0 pr-2",
	                          style: { width: "80px" }
	                        },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control form-control-sm text-right fs-6",
	                          id: "cantidad",
	                          defaultValue: (0, _varios.formatMoneda)(item.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtCantidad.current[index] = el;
	                          },
	                          onFocus: _varios.seleccionarCampo,
	                          onKeyUp: actualizarVacio(index),
	                          onBlur: actualizarVacio(index),
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-baseline",
	                          style: {
	                            textAlign: "center",
	                            alignItems: "center",
	                            width: "50px"
	                          }
	                        },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            className: "btn btn-sm mx-1 btn-danger rounded",
	                            onClick: eliminarVacio(item)
	                          },
	                          _react2.default.createElement("i", { className: "fa fa-trash" })
	                        )
	                      )
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-pd-120 border-azul px-0 border-4 rounded" },
	              _react2.default.createElement("div", { className: "col-pd-100 h-50p" }),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-100 mx-auto mb-2 px-1" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    onClick: function onClick() {
	                      if (idAlmacen !== null) {
	                        setMostrar3(true);
	                      } else {
	                        setMensaje({
	                          mostrar: true,
	                          titulo: "Notificación",
	                          texto: "¡ Debe seleccionar el almacen !",
	                          icono: "informacion"
	                        });
	                      }
	                    },
	                    className: "btn btn-sm btn-primary rounded h-40p",
	                    disabled: activ
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-plus" },
	                    " INCLUIR"
	                  ),
	                  " "
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4 border-azul px-0 rounded ml-auto border-3" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm col px-0 ml-auto m-0" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "TOTAL VACIOS ENTREGADOS:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  className: "form-control fs-5 h-100 text-right",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  ref: txtDespachado,
	                  value: (0, _varios.formatMoneda)(notavacio.totaldespachado.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm col px-0 ml-auto m-0" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "TOTAL VACIOS RETORNADOS:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  className: "form-control fs-5 h-100 text-right",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  ref: txtDevuelto,
	                  value: (0, _varios.formatMoneda)(notavacio.totaldevuelto.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm col px-0 ml-auto m-0" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "TOTAL VACIOS PENDIENTES:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  className: "form-control fs-5 h-100 text-right",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  ref: txtPendientes,
	                  value: (0, _varios.formatMoneda)(notavacio.totalpendiente.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          className: "btn btn-sm btn-success rounded-pill",
	          onClick: onChangeValidar,
	          ref: btnAcepta,
	          disabled: detavacios,
	          style: { margin: "5px" }
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-check-circle" },
	          " Procesar"
	        ),
	        " "
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoNotaEntregaVacios2.default, {
	      show: mostrar,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar(false);
	      },
	      onHideAceptaCatalogo: onCatalogoNotaEntrega
	    }),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: mostra2,
	      nomid: "vacio",
	      onHideCancelar: function onHideCancelar() {
	        return setMostra2(false);
	      },
	      onHideAceptaCatalogo: onCatalogoCliente
	    }),
	    _react2.default.createElement(_catalogoClassVacios2.default, {
	      show: mostrar3,
	      idalmacen: null,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar3(false);
	      },
	      onHideAceptaCatalogo: onCatalogoClassVacios
	    }),
	    _react2.default.createElement(_catalogoAlmacen2.default, {
	      show: mostrar4,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar4(false);
	      },
	      onHideAceptaCatalogo: onCatalogoAlmacen
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "Cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({
	          mostrar: false,
	          titulo: "",
	          texto: "",
	          icono: ""
	        });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = GestionarVacios;

/***/ },
/* 7152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ImprimirControlVacios = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImprimirControlVacios = exports.ImprimirControlVacios = function ImprimirControlVacios(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var txtDetallado = (0, _react.useRef)(false);
	  var txtGeneral = (0, _react.useRef)(false);
	  var txtBasico = (0, _react.useRef)(false);
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtTodasFechas = (0, _react.useRef)();
	  var txtTodosCliente = (0, _react.useRef)();
	  var txtTodosAlmacenes = (0, _react.useRef)();
	  var txtPorAlamacen = (0, _react.useRef)();
	  var txtAlamacen = (0, _react.useRef)();
	  var txtPorCliente = (0, _react.useRef)();
	  var txtIdProducto = (0, _react.useRef)();
	  var txtRifrespon = (0, _react.useRef)();
	  var txtNomrespon = (0, _react.useRef)();
	  var txtRifVende = (0, _react.useRef)();
	  var txtNomVende = (0, _react.useRef)();
	  var txtTipoVacio = (0, _react.useRef)();
	  var txtDesde = (0, _react.useRef)();
	  var txtHasta = (0, _react.useRef)();
	  var txtCbmrif = (0, _react.useRef)();
	  var txtCbmrifVende = (0, _react.useRef)();
	  var txtTodosVendedores = (0, _react.useRef)();
	  var txtPorVendedor = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(""),
	      _useState2 = _slicedToArray(_useState, 2),
	      idclienteDetalle = _useState2[0],
	      setIdClienteDetalle = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(""),
	      _useState4 = _slicedToArray(_useState3, 2),
	      dataestatus = _useState4[0],
	      setDataestatus = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      combocliente = _useState6[0],
	      setCombocliente = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      valvende = _useState8[0],
	      setValvende = _useState8[1];
	
	  var _useState9 = (0, _react.useState)("V"),
	      _useState10 = _slicedToArray(_useState9, 2),
	      tiporif = _useState10[0],
	      setTipofic = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(null),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mostrar1 = _useState12[0],
	      setMostrar1 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(""),
	      _useState14 = _slicedToArray(_useState13, 2),
	      desde = _useState14[0],
	      setDesde = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(""),
	      _useState16 = _slicedToArray(_useState15, 2),
	      hasta = _useState16[0],
	      setHasta = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(""),
	      _useState18 = _slicedToArray(_useState17, 2),
	      clientvende = _useState18[0],
	      setClientvende = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(""),
	      _useState20 = _slicedToArray(_useState19, 2),
	      idclient = _useState20[0],
	      setIdclient = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(""),
	      _useState22 = _slicedToArray(_useState21, 2),
	      idvendedr = _useState22[0],
	      setIdvendedr = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(""),
	      _useState24 = _slicedToArray(_useState23, 2),
	      datafecha = _useState24[0],
	      setDatafecha = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(false),
	      _useState26 = _slicedToArray(_useState25, 2),
	      activate = _useState26[0],
	      setActivate = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(true),
	      _useState28 = _slicedToArray(_useState27, 2),
	      habilitado = _useState28[0],
	      setHabilitado = _useState28[1];
	
	  var _useState29 = (0, _react.useState)([]),
	      _useState30 = _slicedToArray(_useState29, 2),
	      tipovacio = _useState30[0],
	      setTipovacio = _useState30[1];
	
	  var _useState31 = (0, _react.useState)([]),
	      _useState32 = _slicedToArray(_useState31, 2),
	      almacenes = _useState32[0],
	      setAlmacenes = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(0),
	      _useState34 = _slicedToArray(_useState33, 2),
	      actial = _useState34[0],
	      setActial = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(""),
	      _useState36 = _slicedToArray(_useState35, 2),
	      paraalmacen = _useState36[0],
	      setParaalmacen = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(""),
	      _useState38 = _slicedToArray(_useState37, 2),
	      paratipovacio = _useState38[0],
	      setParatipovacio = _useState38[1];
	
	  var _useState39 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState40 = _slicedToArray(_useState39, 2),
	      mensaje = _useState40[0],
	      setMensaje = _useState40[1];
	
	  var _useState41 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState42 = _slicedToArray(_useState41, 2),
	      mensajesino = _useState42[0],
	      setMensajesino = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(true),
	      _useState44 = _slicedToArray(_useState43, 2),
	      truefecha = _useState44[0],
	      setTruefecha = _useState44[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setDataestatus("");
	    setIdclient("");
	    setIdvendedr("");
	    setDatafecha("");
	    setValvende(0);
	    setCombocliente(0);
	    setTipofic("V");
	    setTruefecha(true);
	    setDesde("");
	    setHasta("");
	    setTipovacio([]);
	    setParatipovacio("");
	    setParaalmacen("");
	    setAlmacenes([]);
	    setActial(0);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope === 1) {
	      if (txtDesde.current.value === "" || txtHasta.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Seleccione las Fechas a Consultar !",
	          icono: "informacion"
	        });
	        if (txtDesde.current.value === "" && txtHasta.current.value !== "") {
	          txtDesde.current.focus();
	        } else if (txtHasta.current.value === "" && txtDesde.current.value !== "") {
	          txtHasta.current.focus();
	        } else {
	          txtDesde.current.focus();
	        }
	        sigue = false;
	      } else if (txtPorCliente.current.checked === true && txtRifrespon.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Introduzca el RIF del Cliente a Consultar !",
	          icono: "informacion"
	        });
	        txtRifrespon.current.focus();
	        sigue = false;
	      } else if (sigue !== false) {
	        if (txtDetallado && txtDetallado.current.checked) {
	          imprimirDetallado();
	        } else if (txtGeneral && txtGeneral.current.checked) {
	          imprimirGeneral();
	        } else {
	          imprimirBasico();
	        }
	      }
	    }
	  };
	
	  var onChekval = function onChekval(e) {
	    if (e.target.id === "cliente") {
	      if (txtTodosCliente.current.checked === true) {
	        setCombocliente(0);
	        setIdclient("");
	        txtNomrespon.current.value = "";
	        txtRifrespon.current.value = "";
	        txtCbmrif.current.value = "";
	      } else {
	        setCombocliente(1);
	        setClientvende("cliente");
	      }
	    } else if (e.target.id === "vendedor") {
	      if (txtTodosVendedores.current.checked === true) {
	        setValvende(0);
	        setIdvendedr("");
	        txtNomVende.current.value = "";
	        txtCbmrifVende.current.value = "";
	        txtRifVende.current.value = "";
	      } else {
	        setValvende(1);
	        setClientvende("vendedor");
	      }
	    } else if (e.target.name === "todasfechas") {
	      if (e.target.checked === false) {
	        var fechas = " and nv.fecha between " + "'";
	        setDatafecha(fechas);
	        setTruefecha(false);
	      } else {
	        txtDesde.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	        setDatafecha("");
	        setTruefecha(true);
	      }
	    } else if (e.target.name === "almacen") {
	      if (txtTodosAlmacenes.current.checked === true) {
	        setActial(0);
	        setAlmacenes([]);
	      } else {
	        setActial(1);
	        seleccionarRegistrosAlmacen();
	      }
	    }
	  };
	
	  var imprimirGeneral = function imprimirGeneral() {
	    var condiciones = [];
	    if (paratipovacio !== '') {
	      condiciones.push("and nd.idclasevacio = " + paratipovacio);
	    }
	    if (paraalmacen !== '') {
	      condiciones.push("and n.idalmacen = " + paraalmacen);
	    }
	    if (!txtTodosCliente.current.checked) {
	      condiciones.push("and n.idcliente = " + idclienteDetalle);
	    }
	    if (!txtTodasFechas.current.checked) {
	      condiciones.push("and n.fecha between " + desde + " AND " + hasta);
	    }
	    var condi = condiciones.join(" ");
	    window.open(op.reportes + ("/almacen?afiliado=" + afiliado + "&reporte=ReporteDeudaVacios&condi=" + condi), "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  var imprimirDetallado = function imprimirDetallado() {
	    var condiciones = [];
	    if (paratipovacio !== '') {
	      condiciones.push("oiv.idclasevacio = " + paratipovacio);
	    }
	    if (paraalmacen !== '') {
	      condiciones.push("n.idalmacen = " + paraalmacen);
	    }
	    if (!txtTodosCliente.current.checked) {
	      condiciones.push("n.idcliente = " + idclienteDetalle + " OR n.idvendedor = " + idclienteDetalle);
	    }
	    if (!txtTodasFechas.current.checked) {
	      condiciones.push("n.fecha between " + desde + " AND " + hasta);
	    }
	    var condi = condiciones.join(" AND ");
	    window.open(op.reportes + ("/almacen?afiliado=" + afiliado + "&reporte=ReporteDiarioVacio&condi=" + condi), "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  var imprimirBasico = function imprimirBasico() {
	    var paratipov = paratipovacio !== '' ? "and nvd.idclasevacio = " + paratipovacio : "";
	    var paraalm = paraalmacen !== '' ? "and nv.idalmacen = " + paraalmacen : "";
	    var reporte = "ReporteControldeVacios";
	    var valcli = datafecha !== "" ? "" : "'";
	    var dfechas = datafecha !== "" ? datafecha + "|| quote_literal(" + desde + ") ||" + "'" + " and " + "'" + "|| quote_literal(" + hasta + ")" : "";
	    var condi = "'" + idclient + paratipov + paraalm + valcli + dfechas;
	    var opera = 2;
	
	    window.open(op.reportes + "/almacen?afiliado=" + afiliado + "&reporte=" + reporte + "&ope=" + opera + "&condi=" + condi, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    if (props.llamado === 2) {
	      props.onHideRenderizar();
	      props.onHideCancela();
	    }
	    blanquear();
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var handleAceptaCliente = function handleAceptaCliente(values) {
	    setMostrar1(false);
	
	    if (clientvende === "cliente") {
	      txtCbmrif.current.value = values.rif.substring(0, 1);
	      txtRifrespon.current.value = values.rif.substring(1, 11);
	      txtNomrespon.current.value = values.nombre;
	      setIdclient(" and nv.idcliente = " + values.idagente);
	      setIdClienteDetalle(values.idagente);
	      // selectResponsable(values.rif);
	    } else if (clientvende === "vendedor") {
	      txtCbmrifVende.current.value = values.rif.substring(0, 1);
	      txtRifVende.current.value = values.rif.substring(1, 11);
	      txtNomVende.current.value = values.nombre;
	      selectResponsable(values.rif);
	    }
	  };
	
	  var catalogoClienteVendedor = function catalogoClienteVendedor(ope) {
	    return function (e) {
	      e.preventDefault();
	      if (ope === 1) {
	        setClientvende("cliente");
	        setMostrar1(true);
	      } else {
	        setClientvende("vendedor");
	        setMostrar1(true);
	      }
	    };
	  };
	
	  var selectResponsable = function selectResponsable(id) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "rif";
	    var nomid2 = clientvende;
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idagente > 0) {
	          setIdClienteDetalle(response.data.idagente);
	          if (clientvende === "cliente") {
	            txtNomrespon.current.value = response.data.nombre;
	            setIdclient(" and nv.idcliente = " + response.data.idagente);
	            btnAcepta.current.focus();
	          } else {
	            txtNomVende.current.value = response.data.nombre;
	            setIdvendedr(" and n.idvendedor = " + response.data.idagente);
	            btnAcepta.current.focus();
	          }
	        } else {
	          if (clientvende !== "vendedor") {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "¡ RIF y/o Cliente no Registrado !",
	              icono: "informacion"
	            });
	            txtRifrespon.current.value = "";
	            txtNomrespon.current.value = "";
	          } else {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "¡ RIF y/o Vendedor no Registrado !",
	              icono: "informacion"
	            });
	            txtRifVende.current.value = "";
	            txtNomVende.current.value = "";
	          }
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "nci") {
	      setTipofic(e.target.value);
	    } else if (e.target.name === "desde") {
	      if (e.target.value > (0, _moment2.default)(fechasistema).format("YYYY-MM-DD")) {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !",
	          icono: "informacion"
	        });
	        txtDesde.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	        txtDesde.current.focus();
	      } else {
	        setDesde("'" + (0, _moment2.default)(e.target.value).format("DD-MM-YYYY") + "'");
	      }
	    } else if (e.target.name === "hasta") {
	      setHasta("'" + (0, _moment2.default)(e.target.value).format("DD-MM-YYYY") + "'");
	    } else if (e.target.name === "tipo") {
	      if (e.target.value === "0") {
	        setParatipovacio("");
	      } else {
	        setParatipovacio(e.target.value);
	      }
	    } else if (e.target.name === "almacen") {
	      if (e.target.value === "0") {
	        setParaalmacen("");
	      } else {
	        setParaalmacen(e.target.value);
	      }
	    }
	  };
	
	  var handleCliente = function handleCliente(e) {
	    e.preventDefault();
	    if (e.which === 13 || typeof e.which === "undefined") {
	      if (e.target.value !== "") {
	        setClientvende("cliente");
	        if (clientvende === "cliente") {
	          selectResponsable(tiporif + e.target.value);
	        }
	      }
	    }
	  };
	
	  var handleVendedor = function handleVendedor(e) {
	    e.preventDefault();
	    if (e.which === 13 || typeof e.which === "undefined") {
	      if (e.target.value !== "") {
	        setClientvende("vendedor");
	        if (clientvende === "vendedor") {
	          selectResponsable(tiporif + e.target.value);
	        }
	      }
	    }
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	
	    var campos = "*";
	    var nomtab = "clasevacio";
	    var condi = '1=1';
	    var orden = "idclasevacio";
	    var endpoint = op.conexion + "/api/consulta/selecionarregistrocondi?campos=" + campos + "&nomtab=" + nomtab + "&condi=" + condi + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setTipovacio(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarRegistrosAlmacen = function seleccionarRegistrosAlmacen() {
	
	    var campos = "*";
	    var nomtab = "almacen";
	    var condi = '1=1';
	    var orden = "idalmacen";
	    var endpoint = op.conexion + "/api/consulta/selecionarregistrocondi?campos=" + campos + "&nomtab=" + nomtab + "&condi=" + condi + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setAlmacenes(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        if (props.ope === 1) {
	          seleccionarRegistros();
	          txtDesde.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          txtHasta.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          var desdec = (0, _moment2.default)(fechasistema).format("DD-MM-YYYY");
	          var hastac = (0, _moment2.default)(fechasistema).format("DD-MM-YYYY");
	          setDesde("'" + desdec + "'");
	          setHasta("'" + hastac + "'");
	          txtTodosCliente.current.checked = true;
	          txtPorCliente.current.checked = false;
	          txtTodasFechas.current.checked = true;
	          setHabilitado(false);
	          var data = " and rp.status != 4";
	          setDataestatus(data);
	          txtBasico.current.checked = true;
	          txtGeneral.current.checked = false;
	          txtDetallado.current.checked = false;
	          txtTodosAlmacenes.current.checked = true;
	          txtPorAlamacen.current.checked = false;
	        } else {
	          txtBasico.current.checked = false;
	          txtGeneral.current.checked = false;
	          txtDetallado.current.checked = false;
	          txtTodosCliente.current.checked = false;
	          txtPorCliente.current.checked = false;
	          txtTodasFechas.current.checked = false;
	          setHabilitado(true);
	          setDataestatus("");
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold", style: { color: "#fff" } },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Imprimir Control de Vacios"
	        )
	      ),
	      _react2.default.createElement(
	        "a",
	        { href: "#", ref: btnSalir, onClick: cancelar, className: "text-light" },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-times fa-1x shadow" },
	          " "
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({
	            mostrar: false,
	            titulo: "",
	            texto: "",
	            icono: ""
	          });
	        }
	      }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, {
	        mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	        },
	        onHideSi: handleCloseSi
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12 row mx-auto px-0" },
	        _react2.default.createElement(
	          "div",
	          { className: "row col-md-12 rounded mx-auto" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-12 mb-2 px-2 d-flex justify-content-end" },
	            _react2.default.createElement(
	              "div",
	              { className: "form-check form-check-inline col-3" },
	              _react2.default.createElement("input", { className: "form-check-input", ref: txtBasico, type: "radio", name: "inlineRadioOptions", id: "inlineRadio1", value: "option1" }),
	              _react2.default.createElement(
	                "label",
	                { className: "form-check-label", "for": "inlineRadio1" },
	                "Basico"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "form-check form-check-inline col-3" },
	              _react2.default.createElement("input", { className: "form-check-input", ref: txtGeneral, type: "radio", name: "inlineRadioOptions", id: "inlineRadio2", value: "option2" }),
	              _react2.default.createElement(
	                "label",
	                { "class": "form-check-label", "for": "inlineRadio2" },
	                "General"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "form-check form-check-inline" },
	              _react2.default.createElement("input", { className: "form-check-input", ref: txtDetallado, type: "radio", name: "inlineRadioOptions", id: "inlineRadio3", value: "option3" }),
	              _react2.default.createElement(
	                "label",
	                { "class": "form-check-label", "for": "inlineRadio3" },
	                "Detallado"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "fieldset",
	            { className: "row col-sm-12 mx-auto border-azul rounded mb-1" },
	            _react2.default.createElement(
	              "legend",
	              { className: "float-none m-0 w-auto fs-4 fw-bold" },
	              "Fecha:"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 d-flex justify-content-center px-0 row m-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-1 px-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "form-check" },
	                  _react2.default.createElement("input", {
	                    className: "form-check-input",
	                    type: "checkbox",
	                    ref: txtTodasFechas,
	                    onChange: onChekval,
	                    name: "todasfechas",
	                    value: "",
	                    id: "flexCheckDefault"
	                  }),
	                  _react2.default.createElement(
	                    "label",
	                    { className: "form-check-label", "for": "flexCheckDefault" },
	                    "Todos"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-3 px-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "DESDE:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "date",
	                    ref: txtDesde,
	                    disabled: truefecha,
	                    name: "desde",
	                    onChange: onChange,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-3 px-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "HASTA:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "date",
	                    ref: txtHasta,
	                    disabled: truefecha,
	                    name: "hasta",
	                    onChange: onChange,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-5 px-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO DE VACIO:",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: txtTipoVacio,
	                      name: "tipo",
	                      onChange: onChange,
	                      className: "form-select form-select-sm text-center",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "0" },
	                      "--TODOS--"
	                    ),
	                    tipovacio.map(function (item2, x) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: x, value: item2.idclasevacio },
	                        " ",
	                        item2.descripcion,
	                        " "
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "fieldset",
	            { className: "row col-sm-12 mx-auto border-azul rounded mb-1" },
	            _react2.default.createElement(
	              "legend",
	              { className: "float-none m-0 w-auto fs-4 fw-bold" },
	              "Cliente:"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2 mx-auto" },
	              _react2.default.createElement(
	                "div",
	                { className: "form-check" },
	                _react2.default.createElement("input", {
	                  className: "form-check-input",
	                  name: "cliente",
	                  value: "1",
	                  ref: txtTodosCliente,
	                  onChange: onChekval,
	                  id: "cliente",
	                  type: "radio"
	                }),
	                _react2.default.createElement(
	                  "label",
	                  { className: "form-check-label", "for": "exampleRa1" },
	                  "Todos"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2 mx-auto" },
	              _react2.default.createElement(
	                "div",
	                { className: "form-check" },
	                _react2.default.createElement("input", {
	                  className: "form-check-input",
	                  name: "cliente",
	                  value: "2",
	                  ref: txtPorCliente,
	                  onChange: onChekval,
	                  id: "cliente",
	                  type: "radio"
	                }),
	                _react2.default.createElement(
	                  "label",
	                  { className: "form-check-label", "for": "exampleRa2" },
	                  "Por Cliente"
	                )
	              )
	            ),
	            _react2.default.createElement("input", { type: "hidden", ref: txtIdProducto }),
	            _react2.default.createElement(
	              "div",
	              { className: "col-7 mr-auto px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm col-7 px-1 ml-auto" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "RIF:"
	                ),
	                _react2.default.createElement(
	                  "select",
	                  {
	                    className: "form-select col-3",
	                    ref: txtCbmrif,
	                    name: "nci",
	                    onChange: onChange,
	                    "aria-label": "Default select example"
	                  },
	                  _react2.default.createElement(
	                    "option",
	                    { value: "V" },
	                    "V"
	                  ),
	                  _react2.default.createElement(
	                    "option",
	                    { value: "E" },
	                    "E"
	                  ),
	                  _react2.default.createElement(
	                    "option",
	                    { value: "J" },
	                    "J"
	                  ),
	                  _react2.default.createElement(
	                    "option",
	                    { value: "P" },
	                    "P"
	                  ),
	                  _react2.default.createElement(
	                    "option",
	                    { value: "G" },
	                    "G"
	                  )
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  ref: txtRifrespon,
	                  disabled: combocliente === 1 ? false : true,
	                  onKeyUp: handleCliente,
	                  onBlur: handleCliente,
	                  className: "form-control text-uppercase",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                }),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: combocliente === 1 ? false : true,
	                    type: "button",
	                    onClick: catalogoClienteVendedor(1),
	                    className: "btn btn-success"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-search" })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 row m-0 py-3" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-12" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "Nombre del Cliente:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    ref: txtNomrespon,
	                    disabled: true,
	                    className: "form-control",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "fieldset",
	            { className: "row col-sm-12 mx-auto border-azul rounded mb-1" },
	            _react2.default.createElement(
	              "legend",
	              { className: "float-none m-0 w-auto fs-4 fw-bold" },
	              "Almac\xE9n:"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2 mx-auto" },
	              _react2.default.createElement(
	                "div",
	                { className: "form-check" },
	                _react2.default.createElement("input", {
	                  className: "form-check-input",
	                  name: "almacen",
	                  value: "1",
	                  ref: txtTodosAlmacenes,
	                  onChange: onChekval,
	                  id: "almacen",
	                  type: "radio"
	                }),
	                _react2.default.createElement(
	                  "label",
	                  { className: "form-check-label", "for": "exampleRaa1" },
	                  "Todos"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-2 mx-auto" },
	              _react2.default.createElement(
	                "div",
	                { className: "form-check" },
	                _react2.default.createElement("input", {
	                  className: "form-check-input",
	                  name: "almacen",
	                  value: "2",
	                  ref: txtPorAlamacen,
	                  onChange: onChekval,
	                  id: "almacen",
	                  type: "radio"
	                }),
	                _react2.default.createElement(
	                  "label",
	                  { className: "form-check-label", "for": "exampleRaa2" },
	                  "Por Almac\xE9n"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-5 px-1" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "ALMAC\xC9N:",
	                  " "
	                ),
	                _react2.default.createElement(
	                  "select",
	                  {
	                    disabled: actial !== 0 ? false : true,
	                    ref: txtAlamacen,
	                    name: "almacen",
	                    onChange: onChange,
	                    className: "form-select form-select-sm text-center",
	                    "aria-label": ".form-select-sm example"
	                  },
	                  _react2.default.createElement(
	                    "option",
	                    { value: "0" },
	                    "--TODOS--"
	                  ),
	                  almacenes.map(function (item2, x) {
	                    return _react2.default.createElement(
	                      "option",
	                      { key: x, value: item2.idalmacen },
	                      " ",
	                      item2.descripcion,
	                      " "
	                    );
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "row m-0 col-md-12 mx-auto" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-4 ml-auto px-0 m-0 d-flex justify-content-end" },
	          _react2.default.createElement(
	            "button",
	            {
	              ref: btnAcepta,
	              disabled: habilitado,
	              onClick: onChangeValidar,
	              className: "btn btn-sm rounded-pill btn-primary mx-1"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-print" },
	              " Imprimir"
	            )
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              ref: btnCancela,
	              onClick: cancelar,
	              className: "btn btn-danger btn-sm rounded-pill mx-1"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-window-close" },
	              " Cancelar"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: mostrar1,
	      nomid: "vacio",
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar1(false);
	      },
	      onHideAceptaCatalogo: handleAceptaCliente
	    })
	  );
	};

/***/ },
/* 7153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalPermisosUsuarisVacios = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTable = __webpack_require__(20);
	
	var _useTable2 = _interopRequireDefault(_useTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalPermisosUsuarisVacios = exports.ModalPermisosUsuarisVacios = function ModalPermisosUsuarisVacios(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
	  var idusuario = JSON.parse(sessionStorage.getItem("idusuario"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtLogin = (0, _react.useRef)();
	  var txtCedula = (0, _react.useRef)();
	  var txtStatus = (0, _react.useRef)();
	  var txtIduser = (0, _react.useRef)();
	
	  var txtuTodos = (0, _react.useRef)();
	  var txtuIncluir = (0, _react.useRef)();
	  var txtuModificar = (0, _react.useRef)();
	  var txtuCosultar = (0, _react.useRef)();
	  var txtuEliminar = (0, _react.useRef)();
	  var txtuImprimir = (0, _react.useRef)();
	
	  var txtdTodos = (0, _react.useRef)();
	  var txtdIncluir = (0, _react.useRef)();
	  var txtdModificar = (0, _react.useRef)();
	  var txtdCosultar = (0, _react.useRef)();
	  var txtdEliminar = (0, _react.useRef)();
	  var txtdImprimir = (0, _react.useRef)();
	
	  var txttTodos = (0, _react.useRef)();
	  var txttIncluir = (0, _react.useRef)();
	  var txttModificar = (0, _react.useRef)();
	  var txttCosultar = (0, _react.useRef)();
	  var txttEliminar = (0, _react.useRef)();
	  var txttImprimir = (0, _react.useRef)();
	
	  var txtcTodos = (0, _react.useRef)();
	  var txtcIncluir = (0, _react.useRef)();
	  var txtcModificar = (0, _react.useRef)();
	  var txtcCosultar = (0, _react.useRef)();
	  var txtcEliminar = (0, _react.useRef)();
	  var txtcImprimir = (0, _react.useRef)();
	
	  var txtcoTodos = (0, _react.useRef)();
	  var txtcoIncluir = (0, _react.useRef)();
	  var txtcoModificar = (0, _react.useRef)();
	  var txtcoCosultar = (0, _react.useRef)();
	  var txtcoEliminar = (0, _react.useRef)();
	  var txtcoImprimir = (0, _react.useRef)();
	
	  var txtsTodos = (0, _react.useRef)();
	  var txtsIncluir = (0, _react.useRef)();
	  var txtsModificar = (0, _react.useRef)();
	  var txtsCosultar = (0, _react.useRef)();
	  var txtsEliminar = (0, _react.useRef)();
	  var txtsImprimir = (0, _react.useRef)();
	
	  var txtsiTodos = (0, _react.useRef)();
	  var txtsiIncluir = (0, _react.useRef)();
	  var txtsiModificar = (0, _react.useRef)();
	  var txtsiCosultar = (0, _react.useRef)();
	  var txtsiEliminar = (0, _react.useRef)();
	  var txtsiImprimir = (0, _react.useRef)();
	
	  var txtoTodos = (0, _react.useRef)();
	  var txtoIncluir = (0, _react.useRef)();
	  var txtoModificar = (0, _react.useRef)();
	  var txtoCosultar = (0, _react.useRef)();
	  var txtoEliminar = (0, _react.useRef)();
	  var txtoImprimir = (0, _react.useRef)();
	
	  var txtnTodos = (0, _react.useRef)();
	  var txtnIncluir = (0, _react.useRef)();
	  var txtnModificar = (0, _react.useRef)();
	  var txtnCosultar = (0, _react.useRef)();
	  var txtnEliminar = (0, _react.useRef)();
	  var txtnImprimir = (0, _react.useRef)();
	
	  var txtdzTodos = (0, _react.useRef)();
	  var txtdzIncluir = (0, _react.useRef)();
	  var txtdzModificar = (0, _react.useRef)();
	  var txtdzCosultar = (0, _react.useRef)();
	  var txtdzEliminar = (0, _react.useRef)();
	  var txtdzImprimir = (0, _react.useRef)();
	
	  var txtocTodos = (0, _react.useRef)();
	  var txtocIncluir = (0, _react.useRef)();
	  var txtocModificar = (0, _react.useRef)();
	  var txtocCosultar = (0, _react.useRef)();
	  var txtocEliminar = (0, _react.useRef)();
	  var txtocImprimir = (0, _react.useRef)();
	
	  var txtReportTodos = (0, _react.useRef)();
	  var txtReport1 = (0, _react.useRef)();
	  var txtReport2 = (0, _react.useRef)();
	  var txtReport3 = (0, _react.useRef)();
	  var txtReport4 = (0, _react.useRef)();
	  var txtReport5 = (0, _react.useRef)();
	  var txtReport6 = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      modu1 = _useState2[0],
	      setModu1 = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      modu2 = _useState4[0],
	      setModu2 = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      modu3 = _useState6[0],
	      setModu3 = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      modu4 = _useState8[0],
	      setModu4 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      modu5 = _useState10[0],
	      setModu5 = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      modu6 = _useState12[0],
	      setModu6 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      modu7 = _useState14[0],
	      setModu7 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      modu8 = _useState16[0],
	      setModu8 = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      modu9 = _useState18[0],
	      setModu9 = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      modu10 = _useState20[0],
	      setModu10 = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      modu11 = _useState22[0],
	      setModu11 = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0),
	      _useState24 = _slicedToArray(_useState23, 2),
	      modu12 = _useState24[0],
	      setModu12 = _useState24[1];
	
	  var _useState25 = (0, _react.useState)({}),
	      _useState26 = _slicedToArray(_useState25, 2),
	      body = _useState26[0],
	      setBody = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      operacion = _useState28[0],
	      setOperacion = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      activate = _useState30[0],
	      setActivate = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(true),
	      _useState32 = _slicedToArray(_useState31, 2),
	      habilitado = _useState32[0],
	      setHabilitado = _useState32[1];
	
	  var _useState33 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState34 = _slicedToArray(_useState33, 2),
	      mensaje = _useState34[0],
	      setMensaje = _useState34[1];
	
	  var _useState35 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState36 = _slicedToArray(_useState35, 2),
	      mensajesino = _useState36[0],
	      setMensajesino = _useState36[1];
	
	  var _useState37 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState38 = _slicedToArray(_useState37, 2),
	      botones = _useState38[0],
	      setBotones = _useState38[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var SelectUsuario = function SelectUsuario(idusuario) {
	    var endpoint = op.conexion + '/api/athos/usuario/getuser?id=' + idusuario;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.idusuario > 0) {
	
	          var para1 = response.data.btnopvacios;
	          var para2 = response.data.btncontvacios;
	          var para3 = response.data.btnclasvacios;
	          var para4 = response.data.btnreportvacios;
	
	          sessionStorage.setItem("btnopvaciosc", JSON.stringify(para1));
	          sessionStorage.setItem("btncontvaciosc", JSON.stringify(para2));
	          sessionStorage.setItem("btnclasvaciosc", JSON.stringify(para3));
	          sessionStorage.setItem("btnreportvaciosc", JSON.stringify(para4));
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "Error al cargar el usuario",
	            icono: "informacion"
	          });
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var parameter1 = "";
	    var parameter2 = "";
	    var parameter3 = "";
	    var parameter4 = "";
	    var parameter5 = "";
	    var parameter6 = "";
	    var parameter7 = "";
	    var parameter8 = "";
	    var parameter9 = "";
	    var parameter10 = "";
	    var reportes = "";
	
	    if (props.usuario.accvacios.toString().substring(0, 1) === '1') {
	
	      var val1 = txtuIncluir.current.checked === true ? "1" : "0";
	      var val2 = txtuModificar.current.checked === true ? "1" : "0";
	      var val3 = txtuCosultar.current.checked === true ? "1" : "0";
	      var val4 = txtuEliminar.current.checked === true ? "1" : "0";
	      var val5 = txtuImprimir.current.checked === true ? "1" : "0";
	
	      parameter1 = val1 + val2 + val3 + val4 + val5;
	    } else {
	
	      parameter1 = '000000';
	    }
	
	    if (props.usuario.accvacios.toString().substring(1, 2) === '1') {
	
	      var _val = txtdIncluir.current.checked === true ? "1" : "0";
	      var _val2 = txtdModificar.current.checked === true ? "1" : "0";
	      var _val3 = txtdCosultar.current.checked === true ? "1" : "0";
	      var _val4 = txtdEliminar.current.checked === true ? "1" : "0";
	      var _val5 = txtdImprimir.current.checked === true ? "1" : "0";
	
	      parameter2 = _val2 + _val3 + _val + _val4 + _val5;
	    } else {
	
	      parameter2 = '000000';
	    }
	
	    if (props.usuario.accvacios.toString().substring(2, 3) === '1') {
	
	      var _val6 = txttIncluir.current.checked === true ? "1" : "0";
	      var _val7 = txttModificar.current.checked === true ? "1" : "0";
	      var _val8 = txttCosultar.current.checked === true ? "1" : "0";
	      var _val9 = txttEliminar.current.checked === true ? "1" : "0";
	      var _val10 = txttImprimir.current.checked === true ? "1" : "0";
	
	      parameter3 = _val6 + _val7 + _val8 + _val9 + _val10;
	    } else {
	
	      parameter3 = '000000';
	    }
	
	    if (props.usuario.accvacios.toString().substring(4, 5) === '1') {
	
	      var _val11 = txtReport1.current.checked === true ? "1" : "0";
	      var _val12 = txtReport2.current.checked === true ? "1" : "0";
	      var _val13 = txtReport3.current.checked === true ? "1" : "0";
	      var _val14 = txtReport4.current.checked === true ? "1" : "0";
	      var _val15 = txtReport5.current.checked === true ? "1" : "0";
	      var val6 = txtReport6.current.checked === true ? "1" : "0";
	
	      reportes = _val11 + _val12 + _val13 + _val14 + _val15 + val6;
	    } else {
	
	      reportes = '000000';
	    }
	
	    var sigue = true;
	    var mensaje = "";
	
	    if (sigue) {
	      var user = [];
	      user.push({
	        idusuario: txtIduser.current.value,
	        login: txtLogin.current.value,
	        persona: txtCedula.current.value,
	        status: txtStatus.current.value === 'ACTIVO' ? 1 : 0,
	        idorganizacion: idorganizacion,
	        btnopvacios: parameter1,
	        btncontvacios: parameter2,
	        btnclasvacios: parameter3,
	        btnreportvacios: reportes
	      });
	
	      var _body = {
	        usu: JSON.stringify(user)
	      };
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	      setBody(_body);
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: mensaje,
	        icono: "informacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    var endpoint = op.conexion + '/api/athos/usuario/actualizar/' + operacion;
	
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setActivate(false);
	
	        if (parseInt(response.data.iduser) > 0) {
	          if (parseInt(response.data.iduser) === parseInt(idusuario)) {
	            SelectUsuario(parseInt(response.data.iduser));
	          }
	        }
	
	        var mensaje = "";
	        if (operacion === 1) {
	          mensaje = "El Usuario " + response.data.iduser + " ha sido registrada de manera satisfactoria.";
	        } else if (operacion === 2) {
	          mensaje = "El Usuario " + response.data.iduser + " ha sido Modificada de manera Satisfactoria.";
	        } else if (operacion === 3) {
	          mensaje = "El usuario " + response.data.iduser + " ha sido eliminada de manera satisfactoria.";
	        }
	
	        setMensaje({
	          mostrar: true,
	          titulo: "Exito.",
	          texto: mensaje,
	          icono: "exito"
	        });
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    procesarRegistro();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    props.onHideCancela();
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var checkBlank = function checkBlank(e) {
	
	    if (modu1 === 1) {
	      if (txtuIncluir.current.checked && txtuModificar.current.checked && txtuCosultar.current.checked && txtuEliminar.current.checked && txtuImprimir.current.checked) {
	        txtuTodos.current.checked = true;
	      } else {
	        txtuTodos.current.checked = false;
	      }
	    }
	
	    if (modu2 === 1) {
	      if (txtdIncluir.current.checked && txtdModificar.current.checked && txtdCosultar.current.checked && txtdEliminar.current.checked && txtdImprimir.current.checked) {
	        txtdTodos.current.checked = true;
	      } else {
	        txtdTodos.current.checked = false;
	      }
	    }
	
	    if (modu3 === 1) {
	      if (txttIncluir.current.checked && txttModificar.current.checked && txttCosultar.current.checked && txttEliminar.current.checked && txttImprimir.current.checked) {
	        txttTodos.current.checked = true;
	      } else {
	        txttTodos.current.checked = false;
	      }
	    }
	
	    if (modu4 === 1) {
	      if (txtReport1.current.checked /* && txtReport2.current.checked && txtReport3.current.checked && txtReport4.current.checked &&
	                                     txtReport5.current.checked && txtReport6.current.checked */) {
	          txtReportTodos.current.checked = true;
	        } else {
	        txtReportTodos.current.checked = false;
	      }
	    }
	  };
	
	  var checkTodo = function checkTodo(e) {
	    if (e.target.name === "todos1") {
	      if (txtuTodos.current.checked) {
	        txtuIncluir.current.checked = true;
	        txtuModificar.current.checked = true;
	        txtuCosultar.current.checked = true;
	        txtuEliminar.current.checked = true;
	        txtuImprimir.current.checked = true;
	      } else {
	        txtuIncluir.current.checked = false;
	        txtuModificar.current.checked = false;
	        txtuCosultar.current.checked = false;
	        txtuEliminar.current.checked = false;
	        txtuImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos2") {
	      if (txtdTodos.current.checked) {
	        txtdIncluir.current.checked = true;
	        txtdModificar.current.checked = true;
	        txtdCosultar.current.checked = true;
	        txtdEliminar.current.checked = true;
	        txtdImprimir.current.checked = true;
	      } else {
	        txtdIncluir.current.checked = false;
	        txtdModificar.current.checked = false;
	        txtdCosultar.current.checked = false;
	        txtdEliminar.current.checked = false;
	        txtdImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos3") {
	      if (txttTodos.current.checked) {
	        txttIncluir.current.checked = true;
	        txttModificar.current.checked = true;
	        txttCosultar.current.checked = true;
	        txttEliminar.current.checked = true;
	        txttImprimir.current.checked = true;
	      } else {
	        txttIncluir.current.checked = false;
	        txttModificar.current.checked = false;
	        txttCosultar.current.checked = false;
	        txttEliminar.current.checked = false;
	        txttImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todosreportes") {
	      if (txtReportTodos.current.checked) {
	        txtReport1.current.checked = true;
	        /*  txtReport2.current.checked = true;
	         txtReport3.current.checked = true;
	         txtReport4.current.checked = true;
	         txtReport5.current.checked = true;
	         txtReport6.current.checked = true; */
	      } else {
	        txtReport1.current.checked = false;
	        /*  txtReport2.current.checked = false;
	         txtReport3.current.checked = false;
	         txtReport4.current.checked = false;
	         txtReport5.current.checked = false;
	         txtReport6.current.checked = false; */
	      }
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'xl',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.op === 1) {
	          setOperacion(2);
	          if (props.usuario.accvacios.toString().substring(0, 1) === '1') {
	            setModu1(1);
	          } else {
	            setModu1(0);
	          }
	
	          if (props.usuario.accvacios.toString().substring(1, 2) === '1') {
	            setModu2(1);
	          } else {
	            setModu2(0);
	          }
	
	          if (props.usuario.accvacios.toString().substring(2, 3) === '1') {
	            setModu3(1);
	          } else {
	            setModu3(0);
	          }
	
	          if (props.usuario.accvacios.toString().substring(4, 5) === '1') {
	            setModu4(1);
	          } else {
	            setModu4(0);
	          }
	          setHabilitado(false);
	        } else {
	
	          setHabilitado(true);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Permisos de Usuario (Gesti\xF3n de Vacios)'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto m-0' },
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1 d-flex justify-content-around', style: { fontSizeAdjust: '0.6' } },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-6 fw-bold' },
	              'Datos del Usuarios'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-200 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'USUARIO:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtLogin, defaultValue: props.usuario && props.usuario.login, className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement('input', { type: 'hidden', ref: txtIduser, defaultValue: props.usuario && props.usuario.idusuario }),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-180 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'CEDULA:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtCedula, defaultValue: props.persona && props.persona.cedula, className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-500 px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'NOMBRES Y APELLIDOS:'
	                ),
	                _react2.default.createElement('input', { type: 'text', defaultValue: props.persona && props.persona.nombres.trim() + " " + props.persona.apellidos.trim(), className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-170 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'ESTATUS:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtStatus, defaultValue: props.usuario && props.usuario.status === '1' ? 'ACTIVO' : 'INACTIVO', className: 'form-control text-uppercase fs-6 text-center', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-5 fw-bold' },
	              'Modulos Autorizados'
	            ),
	            modu1 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Operaciones de Inventario (Vacios)'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuTodos,
	                          defaultChecked: props.usuario.btnopvacios.substring(0, 1) === '1' && props.usuario.btnopvacios.substring(1, 2) === '1' && props.usuario.btnopvacios.substring(2, 3) === '1' && props.usuario.btnopvacios.substring(3, 4) === '1' && props.usuario.btnopvacios.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos1', id: 'inlineCheckboxu' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuIncluir, defaultChecked: props.usuario.btnopvacios.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuModificar, defaultChecked: props.usuario.btnopvacios.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuCosultar, defaultChecked: props.usuario.btnopvacios.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuEliminar, defaultChecked: props.usuario.btnopvacios.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuImprimir, defaultChecked: props.usuario.btnopvacios.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu2 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Control de Vacios'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdTodos,
	                          defaultChecked: props.usuario.btncontvacios.substring(0, 1) === '1' && props.usuario.btncontvacios.substring(1, 2) === '1' && props.usuario.btncontvacios.substring(2, 3) === '1' && props.usuario.btncontvacios.substring(3, 4) === '1' && props.usuario.btncontvacios.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos2', id: 'inlineCheckboxd' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdModificar, defaultChecked: props.usuario.btncontvacios.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd1' },
	                          'ACTUALIZAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdCosultar, defaultChecked: props.usuario.btncontvacios.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd2' },
	                          'MOSTRAR NOTA DE ENTREGA'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdIncluir, defaultChecked: props.usuario.btncontvacios.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd3' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdEliminar, defaultChecked: props.usuario.btncontvacios.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdImprimir, defaultChecked: props.usuario.btncontvacios.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu3 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Clasificador de Vacios'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttTodos,
	                          defaultChecked: props.usuario.btnclasvacios.substring(0, 1) === '1' && props.usuario.btnclasvacios.substring(1, 2) === '1' && props.usuario.btnclasvacios.substring(2, 3) === '1' && props.usuario.btnclasvacios.substring(3, 4) === '1' && props.usuario.btnclasvacios.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos3', id: 'inlineCheckboxt' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttIncluir, defaultChecked: props.usuario.btnclasvacios.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttModificar, defaultChecked: props.usuario.btnclasvacios.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttCosultar, defaultChecked: props.usuario.btnclasvacios.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttEliminar, defaultChecked: props.usuario.btnclasvacios.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttImprimir, defaultChecked: props.usuario.btnclasvacios.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu4 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Reportes'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReportTodos,
	                          defaultChecked: props.usuario.btnreportvacios.substring(0, 1) === '1' /* && props.usuario.btnreportvacios.substring(1, 2) === '1' &&
	                                                                                                props.usuario.btnreportvacios.substring(2, 3) === '1' && props.usuario.btnreportvacios.substring(3, 4) === '1' &&
	                                                                                                props.usuario.btnreportvacios.substring(4, 5) === '1' && props.usuario.btnreportvacios.substring(5, 6) === '1' */ ? true : false,
	                          onChange: checkTodo, name: 'todosreportes', id: 'inlineCheckboxr' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport1, defaultChecked: props.usuario.btnreportvacios.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr1' },
	                          '"REPORTE CONTROL DE VACIOS"'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement('input', { type: 'hidden', ref: txtReport2, value: 'false' }),
	                    _react2.default.createElement('input', { type: 'hidden', ref: txtReport3, value: 'false' }),
	                    _react2.default.createElement('input', { type: 'hidden', ref: txtReport4, value: 'false' }),
	                    _react2.default.createElement('input', { type: 'hidden', ref: txtReport5, value: 'false' }),
	                    _react2.default.createElement('input', { type: 'hidden', ref: txtReport6, value: 'false' })
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : ''
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-4 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: props.usuario && props.usuario.status === '0' ? true : false, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-success' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check-circle' },
	              '  Aceptar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _core = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegistrarPagoNotadeEntregaV = function RegistrarPagoNotadeEntregaV(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var anioActu = JSON.parse(sessionStorage.getItem("anioactu"));
	  var idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var btncontvacios = JSON.parse(sessionStorage.getItem("btncontvaciosc"));
	  var cmbCedula = ["J", "V", "G", "P"];
	  var headCells = [{ label: "COD-PRODUCTO", textAlign: "center", width: "60px" }, { label: "PRODUCTO", textAlign: "center", width: "160px" }, { label: "CANTIDAD", textAlign: "center", width: "20px" }, { label: "PRECIO UNI.", textAlign: "center", width: "50px" }, { label: "UND. ALT.", textAlign: "center", width: "50px" }, { label: "%IVA", textAlign: "center", width: "50px" }, { label: "MONTO IVA", textAlign: "center", width: "50px" }, { label: "SIN IVA", textAlign: "center", width: "50px" }];
	
	  var txtIdNotaEntrega = (0, _react.useRef)();
	  var cmbTipo = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtId = (0, _react.useRef)([]);
	  var txtCantidad = (0, _react.useRef)([]);
	  var txtAbono = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var txtSaldo = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtSubTotal = (0, _react.useRef)();
	  var txtDescuento = (0, _react.useRef)();
	  var txtTotIva = (0, _react.useRef)();
	  var txtTotal = (0, _react.useRef)();
	  var txtIdPedido = (0, _react.useRef)();
	  var cmbMoneda = (0, _react.useRef)();
	  var txtContado = (0, _react.useRef)();
	  var txtCredito = (0, _react.useRef)();
	  var txtFechaVencimiento = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      actcredit = _useState2[0],
	      setActcredit = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      operacion = _useState4[0],
	      setOperacion = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      selectp = _useState6[0],
	      setSelectp = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(""),
	      _useState8 = _slicedToArray(_useState7, 2),
	      numNota = _useState8[0],
	      setNumNota = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(""),
	      _useState10 = _slicedToArray(_useState9, 2),
	      numPedido = _useState10[0],
	      setNumPedido = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(""),
	      _useState12 = _slicedToArray(_useState11, 2),
	      cedRif = _useState12[0],
	      setCedRif = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(""),
	      _useState14 = _slicedToArray(_useState13, 2),
	      nomVendedor = _useState14[0],
	      setNomVendedor = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      actanticipo = _useState16[0],
	      setActanticipo = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(""),
	      _useState18 = _slicedToArray(_useState17, 2),
	      idCliente = _useState18[0],
	      setIdCliente = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(""),
	      _useState20 = _slicedToArray(_useState19, 2),
	      nomCliente = _useState20[0],
	      setNomCliente = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(""),
	      _useState22 = _slicedToArray(_useState21, 2),
	      dirCliente = _useState22[0],
	      setDirCliente = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(false),
	      _useState24 = _slicedToArray(_useState23, 2),
	      mostrar = _useState24[0],
	      setMostrar = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(""),
	      _useState26 = _slicedToArray(_useState25, 2),
	      numfact = _useState26[0],
	      setNumfact = _useState26[1];
	
	  var _useState27 = (0, _react.useState)([]),
	      _useState28 = _slicedToArray(_useState27, 2),
	      records = _useState28[0],
	      setRecords = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(0),
	      _useState30 = _slicedToArray(_useState29, 2),
	      idfact = _useState30[0],
	      setIdfact = _useState30[1];
	
	  var _useState31 = (0, _react.useState)([]),
	      _useState32 = _slicedToArray(_useState31, 2),
	      combomoneda = _useState32[0],
	      setCombomoneda = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(false),
	      _useState34 = _slicedToArray(_useState33, 2),
	      activate = _useState34[0],
	      setActivate = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(0.0),
	      _useState36 = _slicedToArray(_useState35, 2),
	      xiva = _useState36[0],
	      setXiva = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(0.0),
	      _useState38 = _slicedToArray(_useState37, 2),
	      montoiva = _useState38[0],
	      setMontoiva = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(0.0),
	      _useState40 = _slicedToArray(_useState39, 2),
	      monto = _useState40[0],
	      setMonto = _useState40[1];
	
	  var _useState41 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState42 = _slicedToArray(_useState41, 2),
	      mensaje = _useState42[0],
	      setMensaje = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      mensajesino = _useState44[0],
	      setMensajesino = _useState44[1];
	
	  var _useState45 = (0, _react.useState)({
	    idmoneda: "1",
	    descripcion: "BOLIVARES",
	    simbolo: "Bs",
	    predeterminada: true,
	    subpredeterminada: false,
	    valormoneda: 1.0
	  }),
	      _useState46 = _slicedToArray(_useState45, 2),
	      moneda = _useState46[0],
	      setMoneda = _useState46[1];
	
	  var _useState47 = (0, _react.useState)({
	    subtotal: 0.0,
	    descuento: 0.0,
	    exento: 0.0,
	    sujeto: 0.0,
	    iva: 16.0,
	    totaliva: 0.0,
	    total: 0.0
	  }),
	      _useState48 = _slicedToArray(_useState47, 2),
	      totales = _useState48[0],
	      setTotales = _useState48[1];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var blanquear = function blanquear() {
	    setMostrar(false);
	    setActivate(false);
	    setOperacion(0);
	    setActcredit(0);
	    setActanticipo(0);
	    setSelectp(0);
	    cmbMoneda.current.selectedIndex = -1;
	    txtContado.current.checked = true;
	    setMoneda({
	      idmoneda: "1",
	      descripcion: "BOLIVARES",
	      simbolo: "Bs",
	      predeterminada: false,
	      valormoneda: 1.0
	    });
	    setRecords([]);
	    txtIdNotaEntrega.current.value = "";
	    txtFechaVencimiento.current.value = "";
	    txtIdNotaEntrega.current.setAttribute("disabled", true);
	    cmbTipo.current.selectedIndex = -1;
	    cmbRif.current.selectedIndex = -1;
	    txtRif.current.value = "";
	    setNumPedido("");
	    setNumNota("");
	    setNomCliente("");
	    setDirCliente("");
	    setNomVendedor("");
	    setCedRif("");
	    txtFecha.current.value = "";
	    txtSubTotal.current.value = "";
	    txtTotIva.current.value = "";
	    txtTotal.current.value = "";
	    txtDescuento.current.value = "";
	    txtSaldo.current.value = "";
	    txtAbono.current.value = "";
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var seleccionarCliente = function seleccionarCliente(rif, tecla) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "rif";
	    var nomid2 = "cliente";
	    var id = rif;
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          cmbRif.current.value = response.data.rif.trim().substring(0, 1);
	          txtRif.current.value = response.data.rif.trim().substring(1, 10);
	          setIdCliente(response.data.idagente);
	          setNomCliente(response.data.nombre);
	          setDirCliente(response.data.direccion.trim());
	          if (tecla === 13) {
	            txtFecha.current.focus();
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un cliente con este codigo",
	            icono: "informacion"
	          });
	          txtRif.current.value = "";
	          cmbRif.current.selectedIndex = -1;
	          if (tecla === 13) {
	            txtRif.current.focus();
	          }
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarVendedor = function seleccionarVendedor(idv) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "idagente";
	    var nomid2 = "vendedor";
	    var id = idv === null ? "0" : idv;
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setCedRif(response.data.rif);
	          setNomVendedor(response.data.nombre);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El usuario no tiene un vendedor asociado",
	            icono: "informacion"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarMoneda = function seleccionarMoneda(id) {
	    var campos = "*";
	    var nomtab = "moneda";
	    var nomid = "idmoneda";
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idmoneda > 0) {
	          setMoneda(response.data);
	          var datamoneda = [];
	
	          datamoneda.push({
	            descripcion: response.data.descripcion,
	            idmoneda: response.data.idmoneda,
	            predeterminada: response.data.predeterminada,
	            simbolo: response.data.simbolo,
	            subpredeterminada: response.data.subpredeterminada,
	            valormoneda: response.data.valormoneda
	          });
	
	          setCombomoneda(datamoneda);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro(id) {
	    var campos = "*";
	    var nomtab = "notaentrega";
	    var nomid = "numnotaentrega";
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtIdNotaEntrega.current.value = response.data.idnotaentrega;
	          setIdfact(response.data.idnotaentrega);
	          setNumfact(response.data.numnotaentrega);
	
	          if (response.data.credito !== false) {
	            txtCredito.current.checked = true;
	            txtContado.current.checked = false;
	            txtFechaVencimiento.current.value = (0, _moment2.default)(response.data.fechavencimiento).format("YYYY-MM-DD");
	          } else {
	            txtCredito.current.checked = false;
	            txtContado.current.checked = true;
	          }
	
	          if (response.data.numpedido === "" || response.data.numpedido === null) {
	            if (response.data.tipo === "NE") {
	              cmbTipo.current.value = "1";
	            } else if (response.data.tipo === "NO") {
	              cmbTipo.current.value = "3";
	            }
	          } else {
	            setSelectp(1);
	            cmbTipo.current.value = "2";
	            setNumPedido(response.data.numpedido);
	            txtIdPedido.current.value = response.data.numpedido;
	          }
	
	          txtFecha.current.value = (0, _moment2.default)(response.data.fecha).format("YYYY-MM-DD");
	          setNumNota(response.data.numnotaentrega);
	          cmbRif.current.value = response.data.cedularif.trim().substring(0, 1);
	          txtRif.current.value = response.data.cedularif.trim().substring(1, 10);
	          setTotales({
	            subtotal: response.data.totalmonto - response.data.totaliva,
	            descuento: response.data.totaldescuento,
	            exento: response.data.totalexento,
	            sujeto: response.data.totalsujeto,
	            iva: 16.0,
	            totaliva: response.data.totaliva,
	            total: response.data.totalmonto
	          });
	
	          var tosaldo = 0.0;
	          tosaldo = parseFloat(response.data.totalmonto) - parseFloat(props.abono);
	
	          txtAbono.current.value = (0, _varios.formatMoneda)(props.abono.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          txtSaldo.current.value = (0, _varios.formatMoneda)(tosaldo.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	
	          setMonto(tosaldo);
	          setXiva(16.0);
	          setMontoiva(response.data.totaliva);
	
	          seleccionarCliente(response.data.cedularif, 46);
	          seleccionarVendedor(response.data.idvendedor);
	          seleccionarMoneda(response.data.idmoneda);
	          seleccionarDetalle(response.data.idnotaentrega);
	          if (operacion === 2) {
	            setTimeout(function () {
	              return txtFecha.current.focus();
	            }, 200);
	          } else {
	            setTimeout(function () {
	              return btnCancela.current.focus();
	            }, 200);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "ID no existe.",
	            icono: "informacion"
	          });
	          txtIdNotaEntrega.current.value = "";
	          txtIdNotaEntrega.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarDetalle = function seleccionarDetalle(id) {
	    var nomtab1 = "notaentregadetalle";
	    var nomtab2 = "notaentrega";
	    var nomid = "idnotaentrega";
	    var endpoint = op.conexion + "/api/inventario/seleccionarnotaentregadet?id=" + id + "&nomtab1=" + nomtab1 + "&nomtab2=" + nomtab2 + "&nomid=" + nomid;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var prod = [];
	          var uni = [];
	          var precio = 0.0;
	          var tasa = 0.0;
	
	          for (var i = 0; i < response.data.length; i++) {
	            if (parseInt(response.data[i].idunidadalterna) === 0 || response.data[i].idunidadalterna === null) {
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	            } else {
	              if (response.data[i].tipounidad === 0) {
	                uni = [{
	                  idunidad: response.data[i].idunidadmedida,
	                  descripcion: response.data[i].descripcionuni,
	                  tipo: "medida"
	                }, {
	                  idunidad: response.data[i].idunidadalterna,
	                  descripcion: response.data[i].descripcionunialt,
	                  tipo: "alterna"
	                }];
	              } else {
	                uni = [{
	                  idunidad: response.data[i].idunidadalterna,
	                  descripcion: response.data[i].descripcionunialt,
	                  tipo: "alterna"
	                }, {
	                  idunidad: response.data[i].idunidadmedida,
	                  descripcion: response.data[i].descripcionuni,
	                  tipo: "medida"
	                }];
	              }
	            }
	
	            var _montoiva = response.data[i].punitario * response.data[i].iva / 100;
	            //montoiva = Math.round(montoiva * 100) / 100;
	
	            var cantie = response.data[i].cantidade;
	            var cantiea = 0.0;
	            if (response.data[i].tipounidad === 0) {
	              if (response.data[i].tipofactor === "1") {
	                cantie = parseFloat(response.data[i].cantidade / response.data[i].valorfactor);
	                //cantie = Math.round(cantie * 100) / 100;
	                cantie = Math.trunc(cantie);
	
	                cantiea = parseFloat(response.data[i].cantidad * response.data[i].valorfactor);
	                cantiea = Math.trunc(cantiea);
	              }
	            } else {
	              if (response.data[i].tipofactor === "0") {
	                cantie = parseFloat(response.data[i].cantidade / response.data[i].valorfactor);
	                //cantie = Math.round(cantie * 100) / 100;
	                cantie = Math.trunc(cantie);
	
	                cantiea = parseFloat(response.data[i].cantidad * response.data[i].valorfactor);
	                cantiea = Math.trunc(cantiea);
	              }
	            }
	
	            prod.push({
	              idproducto: response.data[i].idproducto,
	              codigo: response.data[i].codigo,
	              cantidad: response.data[i].cantidad,
	              cantidadE: parseFloat(cantie) + parseFloat(response.data[i].cantidad),
	              cantidadEA: parseFloat(response.data[i].cantidade) + parseFloat(cantiea),
	              nombrecorto: response.data[i].nombrecorto,
	              precio: response.data[i].punitario,
	              precious: response.data[i].punitario,
	              preciobs: response.data[i].punitariobs,
	              iva: response.data[i].iva,
	              ivaventa: response.data[i].ivaventa,
	              montoiva: response.data[i].cantidad * _montoiva,
	              descuento: response.data[i].descuento,
	              total: response.data[i].cantidad * response.data[i].punitario,
	              unidad: uni,
	              idunidadmedida: response.data[i].idunidadmedida,
	              idunidadalterna: response.data[i].idunidadalterna,
	              costocalculado: response.data[i].costocalculado,
	              costocalculadoalter: response.data[i].costocalculadoalter,
	              utipreciomaxi: response.data[i].utipreciomaxi,
	              utipreciomaxialter: response.data[i].utipreciomaxialter,
	              tipounidad: response.data[i].tipounidad,
	              valormoneda: response.data[i].valormoneda,
	              idmoneda: response.data[i].idmoneda,
	              tipofactor: response.data[i].tipofactor,
	              valorfactor: response.data[i].valorfactor
	            });
	          }
	          setRecords(prod);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var imprimirNotaEntrega = function imprimirNotaEntrega() {
	    if (btncontvacios && btncontvacios.toString().substring(4, 5) === "1") {
	      var debt = 0;
	      if (txtIdNotaEntrega.current.value !== "") {
	        var idnot = txtIdNotaEntrega.current.value;
	
	        var nota = JSON.parse(sessionStorage.getItem("tiporepnotaentrega"));
	        var reporte = nota.toString() === 'HOJA' ? "ReportNotaEntrega" : "ReportNotaEntregaMedium";
	
	        window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&idnota=" + idnot, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Seleccione la nota de Entrega !",
	          icono: "informacion"
	        });
	        debt = 1;
	      }
	
	      if (debt === 1) {
	        txtIdNotaEntrega.current.focus();
	      }
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var renderizar = function renderizar() {
	    props.onRenderizar();
	    props.onHideCancelar();
	  };
	
	  var seleccionarCredito = function seleccionarCredito(id) {
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/seleccionarcredito?idcliente=" + id;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var montototal = 0.0;
	
	          for (var i = 0; i < response.data.length; i++) {
	            montototal = parseFloat(montototal) + parseFloat(response.data[i].totalmonto);
	          }
	
	          if (montototal > 0 && props.anticipo > 0) {
	            setMostrar(true);
	            setActcredit(1);
	            setActanticipo(1);
	          } else {
	            if (props.anticipo > 0) {
	              setMostrar(true);
	              setActcredit(0);
	              setActanticipo(1);
	            } else if (montototal > 0) {
	              setMostrar(true);
	              setActcredit(1);
	              setActanticipo(0);
	            } else {
	              setMostrar(true);
	              setActcredit(0);
	              setActanticipo(0);
	            }
	          }
	          setActivate(false);
	        } else {
	          if (props.anticipo > 0) {
	            setMostrar(true);
	            setActcredit(0);
	            setActanticipo(1);
	          } else {
	            setMostrar(true);
	            setActcredit(0);
	            setActanticipo(0);
	          }
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      size: "xl",
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        if (props.ope === 1) {
	          if (cmbTipo) {
	            cmbTipo.current.selectedIndex = -1;
	          }
	          seleccionarRegistro(props.numnota);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold text-light" },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Nota de Entrega"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          className: "bg-transparent",
	          style: { border: 0, margin: 0, padding: 0, color: "#ffffff" },
	          onClick: cancelar
	        },
	        _react2.default.createElement("i", { className: "far fa-window-close" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { style: { height: "100%", width: "100%" } },
	        _react2.default.createElement(
	          "div",
	          { className: "row col-md-12", style: { margin: 0 } },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row border-azul mx-auto rounded py-1" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row mx-auto d-flex justify-content-between mb-1" },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col-pd-180 mb-1",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CODIGO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    autoComplete: "off",
	                    ref: txtIdNotaEntrega,
	                    name: "idnotaentre",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col-pd-380 mb-1 px-0",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  { className: "text-left" },
	                  "NOTA ENTREGA N\xB0:",
	                  " ",
	                  _react2.default.createElement(
	                    "span",
	                    { className: "col fw-bold text-danger" },
	                    "\xA0",
	                    numNota
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col-pd-180 mb-1 mr-auto px-1",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      disabled: true,
	                      ref: cmbTipo,
	                      className: "form-select form-select-sm",
	                      "aria-label": ".form-select-sm example",
	                      name: "tipo",
	                      id: "tipo"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "NUEVO"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "2" },
	                      "POR PEDIDO"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "3" },
	                      "OBSEQUIO"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement("input", { type: "hidden", ref: txtIdPedido }),
	              selectp === 1 ? _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col320",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  { className: "text-right" },
	                  "PEDIDO N\xB0:",
	                  " ",
	                  _react2.default.createElement(
	                    "span",
	                    { className: "col fw-bold text-danger" },
	                    "\xA0",
	                    numPedido
	                  )
	                )
	              ) : ""
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 row mx-auto mb-1",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "colfull col-pd-290 mb-3" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO MONEDA:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-control form-control-sm fw-bold text-center",
	                      disabled: true,
	                      ref: cmbMoneda
	                    },
	                    combomoneda && combomoneda.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: index },
	                        " ",
	                        item.descripcion + " " + item.simbolo + " " + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                        " "
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "colfull col270" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "mt-14m mr-auto col-pd-260 px-0" },
	                  _react2.default.createElement(
	                    "fieldset",
	                    { className: "row col-sm-12 border-azul rounded mb-1" },
	                    _react2.default.createElement(
	                      "legend",
	                      {
	                        className: "float-none m-0 w-auto",
	                        style: { fontSize: "14px" }
	                      },
	                      "TIPO VENTA:"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-5 mr-auto" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: true,
	                          name: "contado",
	                          ref: txtContado,
	                          value: "1",
	                          defaultChecked: true,
	                          id: "contado",
	                          type: "radio"
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "form-check-label",
	                            htmlFor: "exampleRadi4"
	                          },
	                          "Contado"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-5 ml-auto" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: true,
	                          name: "contado",
	                          ref: txtCredito,
	                          value: "2",
	                          id: "contado",
	                          type: "radio"
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "form-check-label",
	                            htmlFor: "exampleRadi5"
	                          },
	                          "Cr\xE9dito"
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-300 mr-auto px-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA/VENCIMIENTO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    disabled: true,
	                    type: "date",
	                    ref: txtFechaVencimiento,
	                    className: "form-control text-uppercase fs-6"
	                    //value={moment(fechav).format("YYYY-MM-DD")}
	                    , "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    name: "fechav"
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-200 ml-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA:"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "date",
	                    disabled: true,
	                    ref: txtFecha,
	                    className: "form-control fs-6 text-uppercase",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    name: "fecha"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "colfull1070 colfull60p mx-auto mb-1 ",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row border-azul rounded py-2" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold mb-1" },
	                  "Datos del Cliente"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-260 px-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: cmbRif,
	                      name: "cmbrif",
	                      disabled: true,
	                      className: "form-select form-select-sm col-md-3 text-center",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "--"
	                    ),
	                    cmbCedula && cmbCedula.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item },
	                        item
	                      );
	                    })
	                  ),
	                  _react2.default.createElement("input", {
	                    ref: txtRif,
	                    autoComplete: "off",
	                    disabled: true,
	                    maxLength: 9,
	                    type: "text",
	                    className: "form-control fs-6",
	                    name: "cedula",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-340 px-0" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "NOMBRE:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: nomCliente
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "DIRECCION:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: dirCliente
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "colfull1070 colfull40p mx-auto mb-1 row m-0",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row mb-1 py-2 border-azul rounded " },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold mb-1" },
	                  "Datos del Vendedor"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-230 px-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: cedRif
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "NOMBRE:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: nomVendedor
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 border-azul px-0 rounded",
	                style: { /*height: '230px',*/backgroundColor: "#d5e9ff" }
	              },
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 190,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px",
	                    fontSizeAdjust: "0.6"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden" },
	                  records && records.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      { key: index, style: { padding: "0" } },
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-center p-0 d-flex" },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          style: {
	                            borderBottomRightRadius: 0,
	                            borderTopRightRadius: 0,
	                            height: "37px"
	                          },
	                          disabled: true,
	                          ref: function ref(el) {
	                            return txtId.current[index] = el;
	                          },
	                          className: "form-control text-center form-control-sm bg-light fs-6",
	                          defaultValue: item.codigo
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-start p-0 pl-2",
	                          style: { width: "160px" }
	                        },
	                        item.nombrecorto
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-center p-0",
	                          style: { width: "20px" }
	                        },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control form-control-sm bg-light text-right fs-6",
	                          id: "cantidad",
	                          disabled: true,
	                          defaultValue: (0, _varios.formatMoneda)(item.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtCantidad.current[index] = el;
	                          },
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "50px" }
	                        },
	                        (0, _varios.formatMoneda)(item.precio.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light p-0",
	                          style: { width: 50 }
	                        },
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            className: "form-control form-control-sm fs-6",
	                            style: { width: "100%" },
	                            disabled: true
	                          },
	                          item.unidad && item.unidad.map(function (item2, x) {
	                            return _react2.default.createElement(
	                              "option",
	                              { key: x, value: item2.idunidad },
	                              " ",
	                              item2.descripcion,
	                              " "
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "50px" }
	                        },
	                        (0, _varios.formatMoneda)(item.iva.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "50px" }
	                        },
	                        (0, _varios.formatMoneda)(item.montoiva.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "50px" }
	                        },
	                        (0, _varios.formatMoneda)(item.total.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      )
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row m-0 px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-7 py-1 mt-auto" },
	                _react2.default.createElement("div", { className: "col-pd-botonesd row m-0 ml-auto" })
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-md-5 border-azul rounded shadow",
	                  style: { backgroundColor: "#dbeeff" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "SUBTOTAL: ",
	                    moneda.simbolo
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtSubTotal,
	                    value: (0, _varios.formatMoneda)(totales.subtotal.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "DESCUENTO: ",
	                    moneda.simbolo
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtDescuento,
	                    value: (0, _varios.formatMoneda)(totales.descuento.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "TOTAL IVA: ",
	                    moneda.simbolo
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtTotIva,
	                    value: (0, _varios.formatMoneda)(totales.totaliva.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "TOTAL: ",
	                    moneda.simbolo
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtTotal,
	                    value: (0, _varios.formatMoneda)(totales.total.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "ABONO: ",
	                    moneda.simbolo
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtAbono,
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "SALDO: ",
	                    moneda.simbolo
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtSaldo,
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          onClick: imprimirNotaEntrega,
	          style: { margin: "5px" },
	          className: "btn btn-sm btn-primary rounded-pill",
	          title: "Imprimir Nota de Entrega"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fa fa-print" },
	          " Imprimir"
	        )
	      ),
	      _react2.default.createElement(
	        "button",
	        {
	          ref: btnCancela,
	          onClick: cancelar,
	          className: "btn btn-sm btn-danger rounded-pill"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-window-close" },
	          " Cancelar"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "Cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = RegistrarPagoNotadeEntregaV;

/***/ },
/* 7155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _varios = __webpack_require__(14);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _useTableScroll = __webpack_require__(29);
	
	var _useTableScroll2 = _interopRequireDefault(_useTableScroll);
	
	var _core = __webpack_require__(19);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ClassVacios(props) {
	    var headCells = [{ id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CODIGO', textAlign: 'center' }, { id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCION', textAlign: 'center' }];
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)([]),
	        _useState4 = _slicedToArray(_useState3, 2),
	        valor = _useState4[0],
	        setValor = _useState4[1];
	
	    var _useState5 = (0, _react.useState)([]),
	        _useState6 = _slicedToArray(_useState5, 2),
	        valoru = _useState6[0],
	        setValoru = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(),
	        _useState8 = _slicedToArray(_useState7, 2),
	        totaLClientes = _useState8[0],
	        setTotalClientes = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(0.00),
	        _useState10 = _slicedToArray(_useState9, 2),
	        total = _useState10[0],
	        setTotal = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(false),
	        _useState12 = _slicedToArray(_useState11, 2),
	        mostrar = _useState12[0],
	        setMostrar = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(0.00),
	        _useState14 = _slicedToArray(_useState13, 2),
	        totalu = _useState14[0],
	        setTotalu = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(0),
	        _useState16 = _slicedToArray(_useState15, 2),
	        idnot = _useState16[0],
	        setIdnot = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(0.00),
	        _useState18 = _slicedToArray(_useState17, 2),
	        menor = _useState18[0],
	        setMenor = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(0.0),
	        _useState20 = _slicedToArray(_useState19, 2),
	        abono = _useState20[0],
	        setAbono = _useState20[1];
	
	    var _useState21 = (0, _react.useState)([]),
	        _useState22 = _slicedToArray(_useState21, 2),
	        colorF = _useState22[0],
	        setColorF = _useState22[1];
	
	    var color = [];
	
	    var _useState23 = (0, _react.useState)([{
	        color: '#0d6efd',
	        nombre: 'Total Cobrado',
	        valor: '545.555,23'
	    }, {
	        color: '#dc3545',
	        nombre: 'Total x Cobrar',
	        valor: '54.445,42'
	    }]),
	        _useState24 = _slicedToArray(_useState23, 2),
	        datos = _useState24[0],
	        setDatos = _useState24[1];
	
	    var txtBuscar = (0, _react.useRef)();
	
	    var _useState25 = (0, _react.useState)([]),
	        _useState26 = _slicedToArray(_useState25, 2),
	        records = _useState26[0],
	        setRecords = _useState26[1];
	
	    var _useState27 = (0, _react.useState)([]),
	        _useState28 = _slicedToArray(_useState27, 2),
	        municipiosData = _useState28[0],
	        setMunicipiosData = _useState28[1];
	
	    var _useState29 = (0, _react.useState)(['#0d6efd', '#dc3545']),
	        _useState30 = _slicedToArray(_useState29, 2),
	        colorG = _useState30[0],
	        setColorG = _useState30[1];
	
	    var _useState31 = (0, _react.useState)({
	        enero: 0.00,
	        febrero: 0.00,
	        marzo: 0.00,
	        abril: 0.00,
	        mayo: 0.00,
	        junio: 0.00,
	        julio: 0.00,
	        agosto: 0.00,
	        septiembre: 0.00,
	        octubre: 0.00,
	        noviembre: 0.00,
	        diciembre: 0.00
	    }),
	        _useState32 = _slicedToArray(_useState31, 2),
	        rm = _useState32[0],
	        setRM = _useState32[1];
	
	    var _useState33 = (0, _react.useState)(false),
	        _useState34 = _slicedToArray(_useState33, 2),
	        activate = _useState34[0],
	        setActivate = _useState34[1];
	
	    var _useState35 = (0, _react.useState)(JSON.parse(sessionStorage.getItem('fechasistema'))),
	        _useState36 = _slicedToArray(_useState35, 2),
	        fechaSistema = _useState36[0],
	        setFechaSistema = _useState36[1];
	
	    var _useState37 = (0, _react.useState)(sessionStorage.getItem('anioactu')),
	        _useState38 = _slicedToArray(_useState37, 2),
	        anioActu = _useState38[0],
	        setAnioActu = _useState38[1];
	
	    var _useState39 = (0, _react.useState)([]),
	        _useState40 = _slicedToArray(_useState39, 2),
	        label = _useState40[0],
	        setLabel = _useState40[1];
	
	    var _useState41 = (0, _react.useState)([]),
	        _useState42 = _slicedToArray(_useState41, 2),
	        labelu = _useState42[0],
	        setLabelu = _useState42[1];
	
	    var _useState43 = (0, _react.useState)(),
	        _useState44 = _slicedToArray(_useState43, 2),
	        data = _useState44[0],
	        setData = _useState44[1];
	
	    var _useState45 = (0, _react.useState)(),
	        _useState46 = _slicedToArray(_useState45, 2),
	        options = _useState46[0],
	        setOptions = _useState46[1];
	
	    var _useState47 = (0, _react.useState)({
	        fn: function fn(items) {
	            return items;
	        }
	    }),
	        _useState48 = _slicedToArray(_useState47, 2),
	        filterFn = _useState48[0],
	        setFilterFn = _useState48[1];
	
	    var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	        TblContainer = _useTable.TblContainer,
	        TblHead = _useTable.TblHead,
	        TblPagination = _useTable.TblPagination,
	        recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	    var handleSearch = function handleSearch(e) {
	        var target = e.target;
	
	        setFilterFn({
	            fn: function fn(items) {
	                if (target.value === "") {
	                    return items;
	                } else {
	                    return items.filter(function (x) {
	                        if (x.idclasevacio.includes(target.value) || x.descripcion.toLowerCase().includes(target.value.toLowerCase())) {
	                            return x;
	                        }
	                    });
	                }
	            }
	        });
	    };
	
	    var token = sessionStorage.getItem('jwtToken');
	    var op = __webpack_require__(8);
	    var ncaja = JSON.parse(sessionStorage.getItem("numcaja"));
	    var accbtncntxpagarc = JSON.parse(sessionStorage.getItem("accbtncntxpagarc"));
	    var txtMesPetro = (0, _react.useRef)();
	    var txtMesUTE = (0, _react.useRef)();
	
	    var blanquear = function blanquear() {
	        setIdnot(0);
	    };
	
	    var seleccionarRegistros = function seleccionarRegistros() {
	        var campos = "*";
	        var nomtab = "clasevacio";
	        var orden = "idclasevacio";
	
	        var endpoint = op.conexion + '/api/comun/seleccionaregistros?&campos=' + campos + '&nomtab=' + nomtab + '&orden=' + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                "x-access-token": '' + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    setRecords(response.data);
	                    txtBuscar.current.focus();
	                }
	            }
	        }).catch(function (error) {
	            setMensaje({
	                mostrar: true,
	                titulo: "Error",
	                texto: error.response.data.message,
	                icono: "error"
	            });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    (0, _react.useEffect)(function () {
	        seleccionarRegistros();
	    }, []);
	
	    /* const onGestionar = (item) => (e) => {
	        if (ncaja !== "") {
	            if (
	                accbtncntxpagarc &&
	                accbtncntxpagarc.toString().substring(0, 1) === "1"
	            ) {
	                 setIdnot(item.idfactura);
	                setAbono(item.abono);
	                setMostrar(true);
	             } else {
	                setMensaje({
	                    mostrar: true,
	                    titulo: "Notificación.",
	                    texto: "¡No Posee Permiso para Realizar esta Acción!",
	                    icono: "error",
	                });
	            }
	        } else {
	            setMensaje({
	                mostrar: true,
	                titulo: "Notificación.",
	                texto: "¡No Posee un Número de Caja Asignada!",
	                icono: "error",
	            });
	        }
	    }; */
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 mx-auto' },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 mt-2' },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                    onHide: function onHide() {
	                        return setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                    } }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container-fluid px-3 py-2' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row col-md-10 card py-3 mx-auto' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row col-md-12 mx-auto' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 row h-100' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 row mx-auto py-3 m-0' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'row col-md-12 m-0 px-0' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'input-group col-md-6 input-group-sm px-0' },
	                                            _react2.default.createElement('input', {
	                                                type: 'text',
	                                                onChange: handleSearch,
	                                                placeholder: 'Buscar',
	                                                title: 'Buscar Clasificador de Vacios',
	                                                className: 'form-control text-uppercase',
	                                                ref: txtBuscar
	                                            }),
	                                            _react2.default.createElement(
	                                                'button',
	                                                {
	                                                    className: 'btn',
	                                                    style: {
	                                                        pointerEvents: "none",
	                                                        backgroundColor: "rgba(5, 81, 130, 1)",
	                                                        color: "#FFFFFF"
	                                                    }
	                                                },
	                                                _react2.default.createElement('i', { className: 'fa fa-search' })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-md-12 mt-2 px-0 mx-0 rounded' },
	                                        _react2.default.createElement(
	                                            TblContainer,
	                                            { container: { height: 220, width: '100%', overflow: 'auto', padding: '2px', fontSizeAdjust: '0.6' } },
	                                            _react2.default.createElement(TblHead, null),
	                                            _react2.default.createElement(
	                                                _core.TableBody,
	                                                { className: 'overflow-hidden table-bordered' },
	                                                records && recordsAfterPagingAndSorting().map(function (item, index) {
	                                                    return _react2.default.createElement(
	                                                        _core.TableRow,
	                                                        { key: index, style: { padding: "0" } },
	                                                        _react2.default.createElement(
	                                                            _core.TableCell,
	                                                            { className: 'align-baseBar bg-light', style: { textAlign: "center", width: '50px' } },
	                                                            item.idclasevacio
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            _core.TableCell,
	                                                            { className: 'align-baseline bg-light', style: { width: '400px' } },
	                                                            item.descripcion
	                                                        )
	                                                    );
	                                                })
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _semanticUiReact.Dimmer,
	            { active: activate, inverted: true },
	            _react2.default.createElement(
	                _semanticUiReact.Loader,
	                { inverted: true },
	                'cargando...'
	            )
	        )
	    );
	}
	
	exports.default = ClassVacios;

/***/ },
/* 7156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mensajes = __webpack_require__(9);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _core = __webpack_require__(19);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _registrarPagoNotaEntrega = __webpack_require__(7154);
	
	var _registrarPagoNotaEntrega2 = _interopRequireDefault(_registrarPagoNotaEntrega);
	
	var _actualizarVacios = __webpack_require__(7150);
	
	var _actualizarVacios2 = _interopRequireDefault(_actualizarVacios);
	
	var _gestionarVacios = __webpack_require__(7151);
	
	var _gestionarVacios2 = _interopRequireDefault(_gestionarVacios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GestionVacios(props) {
	  var headCells = [{
	    id: "8",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "CODIGO",
	    textAlign: "center"
	  }, {
	    id: "1",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "N° ENTREGA",
	    textAlign: "center"
	  }, {
	    id: "2",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "FECHA",
	    textAlign: "center"
	  }, {
	    id: "3",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "CLIENTE",
	    textAlign: "center"
	  }, {
	    id: "4",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "TOTAL DESPACHADO",
	    textAlign: "center"
	  }, {
	    id: "5",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "TOTAL RETORNADOS",
	    textAlign: "center"
	  }, {
	    id: "6",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "TOTAL PENDIENTES",
	    textAlign: "center"
	  }, {
	    id: "9",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "ACCION",
	    textAlign: "center"
	  }, {
	    id: "9",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: _react2.default.createElement("i", { className: "fa fa-print" }),
	    textAlign: "center"
	  }, {
	    id: "10",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "--",
	    textAlign: "center"
	  }];
	
	  var txtBuscar = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      mensaje = _useState2[0],
	      setMensaje = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      mostrar = _useState4[0],
	      setMostrar = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mostrar1 = _useState6[0],
	      setMostrar1 = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mostrar2 = _useState8[0],
	      setMostrar2 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      opera = _useState10[0],
	      setOpera = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      idnot = _useState12[0],
	      setIdnot = _useState12[1];
	
	  var _useState13 = (0, _react.useState)([]),
	      _useState14 = _slicedToArray(_useState13, 2),
	      detavacios = _useState14[0],
	      setDetavacios = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0.0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      abono = _useState16[0],
	      setAbono = _useState16[1];
	
	  var _useState17 = (0, _react.useState)([]),
	      _useState18 = _slicedToArray(_useState17, 2),
	      records = _useState18[0],
	      setRecords = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(false),
	      _useState20 = _slicedToArray(_useState19, 2),
	      activate = _useState20[0],
	      setActivate = _useState20[1];
	
	  var token = sessionStorage.getItem("jwtToken");
	  var op = __webpack_require__(8);
	
	  var btncontvacios = JSON.parse(sessionStorage.getItem("btncontvaciosc"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var _useState21 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState22 = _slicedToArray(_useState21, 2),
	      filterFn = _useState22[0],
	      setFilterFn = _useState22[1];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if (x.numnotavacio.toLowerCase().includes(target.value.toLowerCase()) || x.numnotaentrega === null ? x.numnotavacio.toLowerCase().includes(target.value.toLowerCase()) || x.cliente.toLowerCase().includes(target.value.toLowerCase()) || (0, _moment2.default)(x.fecha).format("DD-MM-YYYY").toLowerCase().includes(target.value.toLowerCase()) : x.numnotaentrega.toLowerCase().includes(target.value.toLowerCase()) || x.cliente.toLowerCase().includes(target.value.toLowerCase()) || (0, _moment2.default)(x.fecha).format("DD-MM-YYYY").toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var ope = 2;
	    var condi = "";
	
	    var endpoint = op.conexion + "/api/inventariovacio/seleccontrolvaciosdos?&op=" + ope + "&condi=" + condi;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	          txtBuscar.current.focus();
	        } else {
	          setRecords([]);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarDetalleVacios = function seleccionarDetalleVacios(numvacio) {
	    var ope = 1;
	    var endpoint = op.conexion + "/api/inventariovacio/seleccontrolvacios?&op=" + ope + "&condi=" + numvacio;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        if (response.data.length > 0) {
	          setDetavacios(response.data);
	          setMostrar1(true);
	        } else {
	          setDetavacios([]);
	          setMostrar1(false);
	        }
	      }
	    }).catch(function (error) {
	
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarRegistros();
	  }, []);
	
	  var onGestionar = function onGestionar(item, ope) {
	    return function (e) {
	      if (ope === 2) {
	        if (btncontvacios && btncontvacios.toString().substring(0, 1) === "1") {
	          seleccionarDetalleVacios(item.numnotavacio);
	          setOpera(ope);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (ope === 3) {
	        if (btncontvacios && btncontvacios.toString().substring(2, 3) === "1") {
	          setMostrar2(true);
	          setOpera(ope);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (ope === 4) {
	        if (btncontvacios && btncontvacios.toString().substring(3, 4) === "1") {
	          seleccionarDetalleVacios(item.numnotavacio);
	          setOpera(ope);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (ope === 7) {
	        imprimirNotaVacio(item.numnotavacio);
	      } else {
	        if (btncontvacios && btncontvacios.toString().substring(1, 2) === "1") {
	          setAbono(item.abono);
	          setIdnot(item.numnotaentrega);
	          setMostrar(true);
	          setOpera(ope);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      }
	    };
	  };
	
	  var imprimirNotaVacio = function imprimirNotaVacio(num) {
	    if (btncontvacios && btncontvacios.toString().substring(4, 5) === "1") {
	
	      var oper = 1;
	      var numnotav = "'" + num + "'";
	
	      var reporte = "ReporteControldeVacios";
	
	      window.open(op.reportes + "/almacen?afiliado=" + afiliado + "&reporte=" + reporte + "&ope=" + oper + "&condi=" + numnotav, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: "col-md-12 mx-auto" },
	    _react2.default.createElement(
	      "div",
	      { className: "col-md-12 mt-2" },
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_mensajes.Mensaje, {
	          mensaje: mensaje,
	          onHide: function onHide() {
	            return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	          }
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "container-fluid px-3 py-2" },
	          _react2.default.createElement(
	            "div",
	            { className: "row col-md-10 card py-3 mx-auto" },
	            _react2.default.createElement(
	              "div",
	              { className: "row col-md-12 mx-auto" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 row h-100" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 row mx-auto py-3 m-0" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "row col-md-12 m-0 px-0" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group col-md-6 input-group-sm px-0" },
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        onChange: handleSearch,
	                        placeholder: "Buscar",
	                        title: "Buscar Clasificador de Vacios",
	                        className: "form-control text-uppercase",
	                        ref: txtBuscar
	                      }),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          className: "btn",
	                          style: {
	                            pointerEvents: "none",
	                            backgroundColor: "rgba(5, 81, 130, 1)",
	                            color: "#FFFFFF"
	                          }
	                        },
	                        _react2.default.createElement("i", { className: "fa fa-search" })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-pd-60 ml-auto" },
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          onClick: onGestionar("", 3),
	                          className: "btn btn-sm btn-primary rounded-circle mx-1"
	                        },
	                        _react2.default.createElement("i", { className: "fas fa-plus" }),
	                        " "
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 mt-2 px-0 mx-0 rounded" },
	                    _react2.default.createElement(
	                      TblContainer,
	                      {
	                        container: {
	                          height: 220,
	                          width: "100%",
	                          overflow: "auto",
	                          padding: "2px",
	                          fontSizeAdjust: "0.6"
	                        }
	                      },
	                      _react2.default.createElement(TblHead, null),
	                      _react2.default.createElement(
	                        _core.TableBody,
	                        { className: "overflow-hidden table-bordered" },
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                          return _react2.default.createElement(
	                            _core.TableRow,
	                            { key: index, style: { padding: "0" } },
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-baseline bg-light",
	                                style: {
	                                  textAlign: "center",
	                                  width: "90px"
	                                }
	                              },
	                              item.numnotavacio
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-baseline bg-light",
	                                style: {
	                                  textAlign: "center",
	                                  width: "90px"
	                                }
	                              },
	                              item.numnotaentrega !== null ? _react2.default.createElement(
	                                "button",
	                                {
	                                  className: "btn btn-sm btn-info rounded",
	                                  title: "Visualizar Nota de Entrega",
	                                  onClick: onGestionar(item, 1)
	                                },
	                                item.numnotaentrega
	                              ) : "NO"
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-middle",
	                                style: {
	                                  textAlign: "center",
	                                  width: "80px"
	                                }
	                              },
	                              (0, _moment2.default)(item.fecha).format("DD-MM-YYYY")
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-middle",
	                                style: { width: "350px" }
	                              },
	                              item.cliente
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-middle",
	                                style: {
	                                  textAlign: "right",
	                                  width: "50px"
	                                }
	                              },
	                              (0, _varios.formatMoneda)(item.totaldespachado.toString().replace(".", ","), ",", ".", 2)
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-middle",
	                                style: {
	                                  textAlign: "right",
	                                  width: "50px"
	                                }
	                              },
	                              (0, _varios.formatMoneda)(item.totaldevuelto.toString().replace(".", ","), ",", ".", 2)
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-middle",
	                                style: {
	                                  textAlign: "right",
	                                  width: "50px"
	                                }
	                              },
	                              (0, _varios.formatMoneda)(item.totalpendiente.toString().replace(".", ","), ",", ".", 2)
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-middle",
	                                style: {
	                                  textAlign: "center",
	                                  width: "60px"
	                                }
	                              },
	                              _react2.default.createElement(
	                                "button",
	                                {
	                                  className: "btn btn-sm btn-success rounded",
	                                  title: "Gestionar Control de Vacio",
	                                  onClick: onGestionar(item, 2)
	                                },
	                                "ACTUALIZAR"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-middle",
	                                style: {
	                                  textAlign: "center",
	                                  width: "60px"
	                                }
	                              },
	                              _react2.default.createElement(
	                                "button",
	                                {
	                                  className: "btn btn-sm btn-primary rounded",
	                                  title: "Imprimir",
	                                  onClick: onGestionar(item, 7)
	                                },
	                                _react2.default.createElement("i", { className: "fa fa-print" })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-middle",
	                                style: {
	                                  textAlign: "center",
	                                  width: "50px"
	                                }
	                              },
	                              _react2.default.createElement(
	                                "button",
	                                {
	                                  className: "btn btn-sm btn-danger rounded",
	                                  title: "Eliminar Control de Vacio",
	                                  onClick: onGestionar(item, 4)
	                                },
	                                _react2.default.createElement("i", { className: "fa fa-trash" })
	                              )
	                            )
	                          );
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(TblPagination, null)
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_registrarPagoNotaEntrega2.default, {
	      show: mostrar,
	      numnota: idnot,
	      abono: abono,
	      ope: 1,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar(false);
	      }
	    }),
	    _react2.default.createElement(_actualizarVacios2.default, {
	      show: mostrar1,
	      ope: 1,
	      opera: opera,
	      data: detavacios,
	      onRenderizar: seleccionarRegistros,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar1(false);
	      }
	    }),
	    _react2.default.createElement(_gestionarVacios2.default, {
	      show: mostrar2,
	      ope: 1,
	      onRenderizar: seleccionarRegistros,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar2(false);
	      }
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    )
	  );
	}
	
	exports.default = GestionVacios;

/***/ },
/* 7157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalVentasxProductos = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoProductosExistencias = __webpack_require__(91);
	
	var _catalogoProductosExistencias2 = _interopRequireDefault(_catalogoProductosExistencias);
	
	var _catalogoAlmacen = __webpack_require__(51);
	
	var _catalogoAlmacen2 = _interopRequireDefault(_catalogoAlmacen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalVentasxProductos = exports.ModalVentasxProductos = function ModalVentasxProductos(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtCodigo = (0, _react.useRef)();
	  var txtDesde = (0, _react.useRef)();
	  var txtHasta = (0, _react.useRef)();
	  var txtPorProduct = (0, _react.useRef)();
	  var txtNombreProducto = (0, _react.useRef)();
	  var txtTodosProduct = (0, _react.useRef)();
	  var txtTodosAlmacen = (0, _react.useRef)();
	  var txtPorAlmacen = (0, _react.useRef)();
	  var txtNombreAlmacen = (0, _react.useRef)();
	  var txtCodigoAlmacen = (0, _react.useRef)();
	  var txtNombre = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtCbmrif = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      inputalmacen = _useState2[0],
	      setInputalmacen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      valalmacen = _useState4[0],
	      setValalmacen = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      valproducto = _useState6[0],
	      setValproducto = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      inputproducto = _useState8[0],
	      setInputproducto = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      tiporif = _useState10[0],
	      setTipofic = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(null),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mostrar1 = _useState12[0],
	      setMostrar1 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(null),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mostrar2 = _useState14[0],
	      setMostrar2 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(''),
	      _useState16 = _slicedToArray(_useState15, 2),
	      parafecha = _useState16[0],
	      setParafecha = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(''),
	      _useState18 = _slicedToArray(_useState17, 2),
	      desde = _useState18[0],
	      setDesde = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(''),
	      _useState20 = _slicedToArray(_useState19, 2),
	      hasta = _useState20[0],
	      setHasta = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(''),
	      _useState22 = _slicedToArray(_useState21, 2),
	      disponiblec = _useState22[0],
	      setDisponiblec = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(''),
	      _useState24 = _slicedToArray(_useState23, 2),
	      numnota = _useState24[0],
	      setNumNota = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(''),
	      _useState26 = _slicedToArray(_useState25, 2),
	      idclient = _useState26[0],
	      setIdclient = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(true),
	      _useState28 = _slicedToArray(_useState27, 2),
	      vinpurt = _useState28[0],
	      setVinput = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(0),
	      _useState30 = _slicedToArray(_useState29, 2),
	      valida2 = _useState30[0],
	      setValida2 = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(false),
	      _useState32 = _slicedToArray(_useState31, 2),
	      activate = _useState32[0],
	      setActivate = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(''),
	      _useState34 = _slicedToArray(_useState33, 2),
	      idproduct = _useState34[0],
	      setIdproduct = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(''),
	      _useState36 = _slicedToArray(_useState35, 2),
	      estatus = _useState36[0],
	      setEstatus = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(0),
	      _useState38 = _slicedToArray(_useState37, 2),
	      valida = _useState38[0],
	      setValida = _useState38[1];
	
	  var _useState39 = (0, _react.useState)({ fn: function fn(items) {
	      return items;
	    } }),
	      _useState40 = _slicedToArray(_useState39, 2),
	      filterFn = _useState40[0],
	      setFilterFn = _useState40[1];
	
	  var _useState41 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState42 = _slicedToArray(_useState41, 2),
	      mensaje = _useState42[0],
	      setMensaje = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      mensajesino = _useState44[0],
	      setMensajesino = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(''),
	      _useState46 = _slicedToArray(_useState45, 2),
	      tituid = _useState46[0],
	      setTituid = _useState46[1];
	
	  var _useState47 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState48 = _slicedToArray(_useState47, 2),
	      botones = _useState48[0],
	      setBotones = _useState48[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setInputalmacen('');
	    setParafecha('');
	    setDisponiblec('');
	    setNumNota('');
	    setInputproducto(0);
	    setValida(0);
	    setValida2(0);
	    setIdclient('');
	    setIdproduct('');
	    setVinput(true);
	    setMostrar1(false);
	    setMostrar2(false);
	    setEstatus("");
	    setDesde('');
	    setHasta('');
	    setValalmacen(0);
	    setValproducto(0);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope === 1) {
	
	      if (valida2 === 1 && txtTodosProduct.current.checked === false) {
	        if (txtPorProduct.current.checked === true && txtCodigo.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Código del Producto a Consultar !', icono: 'informacion' });
	          txtCodigo.current.focus();
	          sigue = false;
	        } else if (txtPorProduct.current.checked === false && txtTodosProduct.current.checked === false) {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Operación !', icono: 'informacion' });
	          txtTodosProduct.current.focus();
	          sigue = false;
	        } else {
	          imprimirMovimientosVentas();
	        }
	      } else if (sigue === true) {
	
	        imprimirMovimientosVentas();
	      }
	    }
	  };
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'desde') {
	      if (e.target.value > (0, _moment2.default)(fechasistema).format('YYYY-MM-DD')) {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !', icono: 'informacion' });
	        txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        txtDesde.current.focus();
	      } else {
	        setDesde(e.target.value);
	      }
	    } else if (e.target.name === 'hasta') {
	      setHasta(e.target.value);
	    }
	
	    if (e.target.name === 'inlineRadioOptionst') {
	
	      if (e.target.value === '1') {
	        setValproducto(0);
	        setIdproduct(' and nt.idproducto > 0');
	        txtCodigo.current.value = "";
	        txtNombreProducto.current.value = "";
	      } else {
	        setValproducto(1);
	      }
	    }
	
	    if (e.target.name === 'alamcen') {
	
	      if (e.target.value === '1') {
	        setValalmacen(0);
	        setInputalmacen('');
	        txtCodigoAlmacen.current.value = "";
	        txtNombreAlmacen.current.value = "";
	      } else {
	        setValalmacen(1);
	      }
	    }
	  };
	
	  var imprimirMovimientosVentas = function imprimirMovimientosVentas() {
	
	    var reporte = "";
	    var desdec = "'" + (0, _moment2.default)(desde).format('DD-MM-YYYY') + "'";
	    var hastac = "'" + (0, _moment2.default)(hasta).format('DD-MM-YYYY') + "'";
	    var condicion = void 0;
	    var oper = 0;
	    var val = 0;
	
	    if (inputalmacen !== '') {
	      val = 1;
	    } else {
	      val = 0;
	    }
	
	    condicion = idproduct + inputalmacen;
	    reporte = "ReporteVentasGananciasXProductoDos";
	    oper = 2;
	
	    window.open(op.reportes + "/almacen?afiliado=" + afiliado + "&reporte=" + reporte + "&condi=" + condicion + "&desde=" + desdec + "&hasta=" + hastac + "&valida=" + oper + "&valalmacen=" + val, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  var handleAceptaProducto = function handleAceptaProducto(values) {
	    setMostrar1(false);
	    setVinput(false);
	    txtNombreProducto.current.value = values.nombrecorto;
	    txtCodigo.current.value = values.codigo;
	    setIdproduct(' and nt.idproducto = ' + values.idproducto);
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var seleccionarProducto = function seleccionarProducto(id) {
	    var campos = "idproducto, nombre";
	    var nomtab = "producto";
	    var nomid = "codigo";
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idproducto > 0) {
	          setIdproduct(' and nt.idproducto = ' + response.data.idproducto);
	          txtNombreProducto.current.value = response.data.nombre;
	          setVinput(false);
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Código y/o Producto no Existe !', icono: 'informacion' });
	          setVinput(true);
	          txtCodigo.current.value = "";
	          setIdproduct('');
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var handleInputNumeroChange = function handleInputNumeroChange(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "notaentrega") {
	          seleccionarProducto(event.target.value.toUpperCase());
	        } /* else if (event.target.name === "nalmacen") {
	          seleccionarAlmacen(event.target.value);
	          } */
	      }
	    }
	  };
	
	  var handleAceptaAlmacen = function handleAceptaAlmacen(values) {
	    setMostrar2(false);
	    txtNombreAlmacen.current.value = values.descripcion;
	    txtCodigoAlmacen.current.value = values.idalmacen;
	    setInputalmacen(' and n.idalmacen = ' + values.idalmacen);
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.ope === 1) {
	          txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	          txtHasta.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	          setDesde((0, _moment2.default)(fechasistema).format('YYYY-MM-DD'));
	          setHasta((0, _moment2.default)(fechasistema).format('YYYY-MM-DD'));
	          setVinput(false);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Imprimir Movimientos de Ventas'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0 m-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 row m-0 px-0 py-2' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-pd-220 px-1 mb-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'DESDE:'
	              ),
	              _react2.default.createElement('input', { type: 'date', disabled: props.ope === 0 ? true : false, onChange: onChange, ref: txtDesde, name: 'desde', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-pd-220 px-1 mb-2' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm' },
	              _react2.default.createElement(
	                'label',
	                { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                'HASTA:'
	              ),
	              _react2.default.createElement('input', { type: 'date', disabled: props.ope === 0 ? true : false, onChange: onChange, ref: txtHasta, name: 'hasta', className: 'form-control text-center fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fw-bold', style: { fontSize: '0.8rem' } },
	              'PRODUCTOS:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-400 px-0 mb-2 row m-0 d-flex justify-content-around' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check form-check-inline col-pd-120 mx-2 px-1' },
	                _react2.default.createElement('input', { className: 'form-check-input', type: 'radio', ref: txtTodosProduct, name: 'inlineRadioOptionst', onChange: onChange, id: 'inlineRadiot1', value: '1', defaultChecked: true }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'inlineRadiot1', style: { fontSize: '0.8rem' } },
	                  'TODOS'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check form-check-inline col-pd-160 ml-1 px-1' },
	                _react2.default.createElement('input', { className: 'form-check-input', type: 'radio', ref: txtPorProduct, name: 'inlineRadioOptionst', onChange: onChange, id: 'inlineRadiot2', value: '2' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'inlineRadiot2', style: { fontSize: '0.8rem' } },
	                  'POR PRODUCTO'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-300 px-0 mb-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'CODIGO PRODUCTO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', disabled: valproducto === 1 ? false : true, name: 'notaentrega', onKeyUp: handleInputNumeroChange, onBlur: handleInputNumeroChange, ref: txtCodigo, className: 'form-control bg-transparent fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { type: 'button', onClick: function onClick() {
	                      return setMostrar1(true);
	                    }, disabled: valproducto === 1 ? false : true, className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 px-0 mb-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'NOMBRE PRODUCTO:'
	                ),
	                _react2.default.createElement('textarea', { type: 'text', disabled: true, ref: txtNombreProducto, name: 'nombre', style: { height: idproduct !== '' ? '47px' : '30px' }, className: 'form-control fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fw-bold', style: { fontSize: '0.8rem' } },
	              'ALMACEN:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-400 px-0 mb-2 row m-0 d-flex justify-content-around' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check form-check-inline col-pd-120 mx-2 px-1' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'alamcen', value: '1', ref: txtTodosAlmacen, onChange: onChange, id: 'alamcen', type: 'radio', defaultChecked: true }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa1', style: { fontSize: '0.8rem' } },
	                  'TODOS'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check form-check-inline col-pd-160 ml-1 px-1' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'alamcen', value: '2', ref: txtPorAlmacen, onChange: onChange, id: 'alamcen', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa2', style: { fontSize: '0.8rem' } },
	                  'POR ALMACEN'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-300 px-0 mb-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'CODIGO ALMACEN:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtCodigoAlmacen, disabled: true /* onKeyUp={handleCliente} onBlur={handleCliente} */, className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: valalmacen === 1 ? false : true, type: 'button', onClick: function onClick() {
	                      return setMostrar2(true);
	                    }, className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 px-0 mb-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'NOMBRE DEL ALMACEN:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtNombreAlmacen, disabled: true, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-11 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: vinpurt, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-primary mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-print' },
	              '  Imprimir'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoProductosExistencias2.default, {
	      show: mostrar1,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar1(false);
	      },
	      onHideAceptaCatalogo: handleAceptaProducto
	    }),
	    _react2.default.createElement(_catalogoAlmacen2.default, {
	      show: mostrar2,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar2(false);
	      },
	      onHideAceptaCatalogo: handleAceptaAlmacen
	    })
	  );
	};

/***/ },
/* 7158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalPedidosPendientes = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mensajes = __webpack_require__(9);
	
	var _catalogoAlmacen = __webpack_require__(51);
	
	var _catalogoAlmacen2 = _interopRequireDefault(_catalogoAlmacen);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalPedidosPendientes = exports.ModalPedidosPendientes = function ModalPedidosPendientes(props) {
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var op = __webpack_require__(8);
	
	  var txtDesde = (0, _react.useRef)();
	  var txtHasta = (0, _react.useRef)();
	  var txtpedido = (0, _react.useRef)();
	  var txtproducto = (0, _react.useRef)();
	  var txtNombreAlmacen = (0, _react.useRef)();
	  var txtCodigoAlmacen = (0, _react.useRef)();
	  var txtNombreVendedor = (0, _react.useRef)();
	  var txtRifVendedor = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(""),
	      _useState2 = _slicedToArray(_useState, 2),
	      desde = _useState2[0],
	      setDesde = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(""),
	      _useState4 = _slicedToArray(_useState3, 2),
	      hasta = _useState4[0],
	      setHasta = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(true),
	      _useState6 = _slicedToArray(_useState5, 2),
	      actAlmacen = _useState6[0],
	      setActAlmacen = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(true),
	      _useState8 = _slicedToArray(_useState7, 2),
	      actCliente = _useState8[0],
	      setActCliente = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mostrarAlmacen = _useState10[0],
	      setMostrarAlmacen = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mostrarCliente = _useState12[0],
	      setMostrarCliente = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(""),
	      _useState14 = _slicedToArray(_useState13, 2),
	      idAlmacen = _useState14[0],
	      setIdAlmacen = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(""),
	      _useState16 = _slicedToArray(_useState15, 2),
	      idVendedor = _useState16[0],
	      setIdVendedor = _useState16[1];
	
	  var _useState17 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState18 = _slicedToArray(_useState17, 2),
	      mensaje = _useState18[0],
	      setMensaje = _useState18[1];
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	    imprimir();
	  };
	  var onChange = function onChange(e) {
	    if (e.target.name === "desde") {
	      if (e.target.value > (0, _moment2.default)(new Date()).format("YYYY-MM-DD")) {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !",
	          icono: "informacion"
	        });
	        txtDesde.current.value = (0, _moment2.default)(new Date()).format("YYYY-MM-DD");
	        txtDesde.current.focus();
	      } else {
	        setDesde(e.target.value);
	      }
	    } else if (e.target.name === "hasta") {
	      setHasta(e.target.value);
	    }
	  };
	  var imprimir = function imprimir() {
	    var ope = 0;
	    var condicion = "";
	    var condiciones = [];
	
	    if (idAlmacen !== "" || idVendedor !== "") {
	      if (idVendedor !== "") {
	        condiciones.push("p.idvendedor = " + idVendedor);
	      }
	      if (idAlmacen !== "") {
	        condiciones.push("p.idalmacen = " + idAlmacen);
	      }
	
	      if (condiciones.length > 0) {
	        condicion = " AND " + condiciones.join(" AND ");
	      }
	    }
	    if (txtproducto && txtproducto.current && txtproducto.current.checked) {
	      ope = 1;
	    }
	    window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=ReporteListaPedidosPendiente&desde='" + desde + "'&hasta='" + hasta + "'&ope=" + ope + "&condicion='" + condicion + "'", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	  var handleAceptaAlmacen = function handleAceptaAlmacen(values) {
	    setMostrarAlmacen(false);
	    txtNombreAlmacen.current.value = values.descripcion;
	    txtCodigoAlmacen.current.value = values.idalmacen;
	    setIdAlmacen(values.idalmacen);
	  };
	  var handleAceptaVendedor = function handleAceptaVendedor(values) {
	    setMostrarCliente(false);
	    txtNombreVendedor.current.value = values.nombre;
	    txtRifVendedor.current.value = values.rif;
	    setIdVendedor(values.idagente);
	  };
	  var blanquear = function blanquear() {
	    setMostrarAlmacen(false);
	    setMostrarCliente(false);
	    setIdAlmacen("");
	    setIdVendedor("");
	    setActAlmacen(true);
	    setActCliente(true);
	    txtNombreVendedor.current.value = "";
	    txtRifVendedor.current.value = "";
	    txtNombreAlmacen.current.value = "";
	    txtCodigoAlmacen.current.value = "";
	  };
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "lg",
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        blanquear();
	        txtDesde.current.value = (0, _moment2.default)(new Date()).format("YYYY-MM-DD");
	        txtHasta.current.value = (0, _moment2.default)(new Date()).format("YYYY-MM-DD");
	        setDesde((0, _moment2.default)(new Date()).format("YYYY-MM-DD"));
	        setHasta((0, _moment2.default)(new Date()).format("YYYY-MM-DD"));
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold", style: { color: "#fff" } },
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Imprimir Pedidos Pendientes"
	        )
	      ),
	      _react2.default.createElement(
	        "a",
	        { href: "#", onClick: cancelar, className: "text-light" },
	        _react2.default.createElement("i", { className: "fas fa-times fa-1x shadow" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	        }
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12 row mx-auto px-0 m-0" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-12 row m-0 px-0 py-2" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-6 input-group input-group-sm" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "DESDE:"
	            ),
	            _react2.default.createElement("input", {
	              type: "date",
	              name: "desde",
	              ref: txtDesde,
	              onChange: onChange,
	              className: "form-control text-center fs-6 text-uppercase",
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm"
	            })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-6 input-group input-group-sm" },
	            _react2.default.createElement(
	              "label",
	              { className: "input-group-text", id: "inputGroup-sizing-sm" },
	              "HASTA:"
	            ),
	            _react2.default.createElement("input", {
	              type: "date",
	              ref: txtHasta,
	              name: "hasta",
	              onChange: onChange,
	              className: "form-control text-center fs-6 text-uppercase",
	              "aria-label": "Sizing example input",
	              "aria-describedby": "inputGroup-sizing-sm"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "fieldset",
	          { className: "row col-sm-12 mx-auto border-azul rounded mb-1" },
	          _react2.default.createElement(
	            "legend",
	            {
	              className: "float-none m-0 w-auto fw-bold",
	              style: { fontSize: "0.8rem" }
	            },
	            "AGRUPAR POR:"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-12 row mb-2 m-0 d-flex justify-content-between align-items-center" },
	            _react2.default.createElement(
	              "div",
	              { className: "form-check col-auto" },
	              _react2.default.createElement("input", {
	                className: "form-check-input",
	                type: "radio",
	                name: "radio",
	                id: "inlineRadiot1",
	                value: "1",
	                ref: txtpedido,
	                defaultChecked: true
	              }),
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "form-check-label text-uppercase",
	                  htmlFor: "inlineRadiot1",
	                  style: { fontSize: "0.8rem" }
	                },
	                "Por Pedidos"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "form-check col-auto" },
	              _react2.default.createElement("input", {
	                className: "form-check-input",
	                type: "radio",
	                name: "radio",
	                id: "inlineRadiot2",
	                value: "2",
	                ref: txtproducto
	              }),
	              _react2.default.createElement(
	                "label",
	                {
	                  className: "form-check-label text-uppercase",
	                  htmlFor: "inlineRadiot2",
	                  style: { fontSize: "0.8rem" }
	                },
	                "Por Producto"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "fieldset",
	          { className: "row col-sm-12 mx-auto border-azul rounded mb-1" },
	          _react2.default.createElement(
	            "legend",
	            {
	              className: "float-none m-0 w-auto fw-bold",
	              style: { fontSize: "0.8rem" }
	            },
	            "VENDEDOR"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-2 mx-auto" },
	            _react2.default.createElement(
	              "div",
	              { className: "form-check" },
	              _react2.default.createElement("input", {
	                className: "form-check-input",
	                name: "vendedor",
	                type: "radio",
	                onChange: function onChange() {
	                  setActCliente(true);
	                  setIdVendedor("");
	                  txtNombreVendedor.current.value = "";
	                  txtRifVendedor.current.value = "";
	                },
	                defaultChecked: true
	              }),
	              _react2.default.createElement(
	                "label",
	                { className: "form-check-label", "for": "exampleRa1" },
	                "Todos"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-2 mx-auto" },
	            _react2.default.createElement(
	              "div",
	              { className: "form-check" },
	              _react2.default.createElement("input", {
	                className: "form-check-input",
	                name: "vendedor",
	                type: "radio",
	                onChange: function onChange() {
	                  setActCliente(false);
	                }
	              }),
	              _react2.default.createElement(
	                "label",
	                { className: "form-check-label", "for": "exampleRa2" },
	                "Por Vendedor"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-7 mr-auto px-0" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group input-group-sm col-7 px-1 ml-auto" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "RIF:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                disabled: true,
	                ref: txtRifVendedor,
	                className: "form-control text-uppercase",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-sm"
	              }),
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  className: "btn btn-success",
	                  disabled: actCliente,
	                  onClick: function onClick() {
	                    setMostrarCliente(true);
	                  }
	                },
	                _react2.default.createElement("i", { className: "fas fa-search" })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-12 row m-0 py-3" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "NOMBRE DEL VENDEDOR:"
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  disabled: true,
	                  ref: txtNombreVendedor,
	                  className: "form-control",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "fieldset",
	          { className: "row col-sm-12 mx-auto border-azul rounded mb-1" },
	          _react2.default.createElement(
	            "legend",
	            {
	              className: "float-none m-0 w-auto fw-bold",
	              style: { fontSize: "0.8rem" }
	            },
	            "ALMACEN"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-2 mx-auto" },
	            _react2.default.createElement(
	              "div",
	              { className: "form-check" },
	              _react2.default.createElement("input", {
	                className: "form-check-input",
	                name: "alamcen",
	                type: "radio",
	                onChange: function onChange() {
	                  setActAlmacen(true);
	                  setIdAlmacen("");
	                  txtNombreAlmacen.current.value = "";
	                  txtCodigoAlmacen.current.value = "";
	                },
	                defaultChecked: true
	              }),
	              _react2.default.createElement(
	                "label",
	                { className: "form-check-label", "for": "exampleRa1" },
	                "Todos"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-2 mx-auto" },
	            _react2.default.createElement(
	              "div",
	              { className: "form-check" },
	              _react2.default.createElement("input", {
	                className: "form-check-input",
	                name: "alamcen",
	                type: "radio",
	                onChange: function onChange() {
	                  setActAlmacen(false);
	                }
	              }),
	              _react2.default.createElement(
	                "label",
	                { className: "form-check-label", "for": "exampleRa2" },
	                "Por Almacen"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-7 mr-auto px-0" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group input-group-sm col-7 px-1 ml-auto" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "CODIGO ALMACEN:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                disabled: true,
	                ref: txtCodigoAlmacen,
	                className: "form-control text-uppercase",
	                "aria-label": "Sizing example input",
	                "aria-describedby": "inputGroup-sizing-sm"
	              }),
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "button",
	                  className: "btn btn-success",
	                  disabled: actAlmacen,
	                  onClick: function onClick() {
	                    setMostrarAlmacen(true);
	                  }
	                },
	                _react2.default.createElement("i", { className: "fas fa-search" })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-12 row m-0 py-3" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                  "NOMBRE DEL ALMACEN:"
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  disabled: true,
	                  ref: txtNombreAlmacen,
	                  className: "form-control",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "row m-0 col-md-12 mx-auto" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-11 ml-auto px-0 m-0 d-flex justify-content-end" },
	          _react2.default.createElement(
	            "button",
	            {
	              onClick: onChangeValidar,
	              className: "btn btn-sm rounded-pill btn-primary mx-1"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-print" },
	              " Imprimir"
	            )
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              onClick: cancelar,
	              className: "btn btn-danger btn-sm rounded-pill mx-1"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-window-close" },
	              " Cancelar"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoAlmacen2.default, {
	      show: mostrarAlmacen,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrarAlmacen(false);
	      },
	      onHideAceptaCatalogo: handleAceptaAlmacen
	    }),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: mostrarCliente,
	      nomid: "vendedor",
	      onHideCancelar: function onHideCancelar() {
	        return setMostrarCliente(false);
	      },
	      onHideAceptaCatalogo: handleAceptaVendedor
	    })
	  );
	};

/***/ },
/* 7159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CartasClientes(props) {
	
	  return _react2.default.createElement(
	    "div",
	    { className: "row d-flex justify-content-between" },
	    _react2.default.createElement(
	      "div",
	      { className: "col-xl-4 d-flex justify-content-start col-sm-3 col-12 mb-3" },
	      _react2.default.createElement(
	        "div",
	        { className: "card bg-card-info", style: { height: '98px', width: '80%' } },
	        _react2.default.createElement(
	          "div",
	          { className: "card-header", style: { height: '80%' } },
	          "Almacen"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "card-body bg-light mx-1 mb-1" },
	          _react2.default.createElement("div", { className: "d-flex justify-content-between px-md-1" })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "col-xl-4 d-flex justify-content-center col-sm-3 col-12 mb-3" },
	      _react2.default.createElement(
	        "div",
	        { className: "card bg-card-info", style: { height: '98px', width: '80%' } },
	        _react2.default.createElement(
	          "div",
	          { className: "card-header", style: { height: '80%' } },
	          "Almacen"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "card-body bg-light mx-1 mb-1" },
	          _react2.default.createElement("div", { className: "d-flex justify-content-between px-md-1" })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "col-xl-4 d-flex justify-content-end col-sm-3 col-12 mb-3" },
	      _react2.default.createElement(
	        "div",
	        { className: "card bg-card-info", style: { height: '98px', width: '80%' } },
	        _react2.default.createElement(
	          "div",
	          { className: "card-header", style: { height: '80%' } },
	          "Almacen"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "card-body bg-light mx-1 mb-1" },
	          _react2.default.createElement("div", { className: "d-flex justify-content-between px-md-1" })
	        )
	      )
	    )
	  );
	}
	
	exports.default = CartasClientes;

/***/ },
/* 7160 */
7115,
/* 7161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalClientes = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoProductosExistencias = __webpack_require__(91);
	
	var _catalogoProductosExistencias2 = _interopRequireDefault(_catalogoProductosExistencias);
	
	var _catalogoAlmacen = __webpack_require__(51);
	
	var _catalogoAlmacen2 = _interopRequireDefault(_catalogoAlmacen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalClientes = exports.ModalClientes = function ModalClientes(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtEstado = (0, _react.useRef)();
	  var txtMunicipio = (0, _react.useRef)();
	  var txtCiudad = (0, _react.useRef)();
	  var txtTodosEstados = (0, _react.useRef)();
	  var txtPorEstados = (0, _react.useRef)();
	  var txtTodosDispo = (0, _react.useRef)();
	  var txtActivos = (0, _react.useRef)();
	  var txtInactivos = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      disponiblec = _useState2[0],
	      setDisponiblec = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      valida = _useState6[0],
	      setValida = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mensaje = _useState8[0],
	      setMensaje = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState10 = _slicedToArray(_useState9, 2),
	      mensajesino = _useState10[0],
	      setMensajesino = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      estado = _useState12[0],
	      setEstado = _useState12[1];
	
	  var _useState13 = (0, _react.useState)([]),
	      _useState14 = _slicedToArray(_useState13, 2),
	      municipio = _useState14[0],
	      setMunicipio = _useState14[1];
	
	  var _useState15 = (0, _react.useState)([]),
	      _useState16 = _slicedToArray(_useState15, 2),
	      ciudad = _useState16[0],
	      setCiudad = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(''),
	      _useState18 = _slicedToArray(_useState17, 2),
	      paracliente = _useState18[0],
	      setParacliente = _useState18[1];
	
	  var _useState19 = (0, _react.useState)([]),
	      _useState20 = _slicedToArray(_useState19, 2),
	      idsc = _useState20[0],
	      setIdsc = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      valestado = _useState22[0],
	      setValestado = _useState22[1];
	
	  var blanquear = function blanquear() {
	    setValestado(0);
	    setActivate(false);
	    setDisponiblec('');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	    var sigue = true;
	    if (valestado !== 0 && txtMunicipio.current.value === '') {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "Seleccione un municipio para generar el reporte.",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtMunicipio.current.focus();
	    } else if (valestado !== 0 && txtCiudad.current.value === '') {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "Seleccione una ciudad para generar el reporte.",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtCiudad.current.focus();
	    }
	
	    if (sigue) {
	      var val1 = '';
	      var condi = 'cliente = true' + paracliente + disponiblec;
	
	      window.open(op.reportes + '/clientes?afiliado=' + afiliado + '&reporte=ListaCliente&condicion=' + condi, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	    }
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	    props.onHideCancelar();
	    props.onCerrar();
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === 'estado') {
	      if (txtTodosEstados.current.checked === true) {
	        if (txtMunicipio.current) txtMunicipio.current.value = '';
	        if (txtCiudad.current) txtCiudad.current.value = '';
	        setParacliente('');
	        setValestado(0);
	      } else {
	        setParacliente('');
	        setValestado(1);
	        seleccionarClient();
	      }
	    } else if (e.target.name === 'tipodisponible') {
	      if (txtTodosDispo.current.checked === true) {
	        setParacliente('');
	        setDisponiblec('');
	      } else if (txtActivos.current.checked === true) {
	        setParacliente('');
	        setDisponiblec(' and statuscliente = 51 ');
	      } else if (txtInactivos.current.checked === true) {
	        setParacliente('');
	        setDisponiblec(' and statuscliente != 51 ');
	      }
	    }
	  };
	
	  var handleInputNumeroChange = function handleInputNumeroChange(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "numnota") {
	          btnAcepta.current.focus();
	        }
	      }
	    }
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = "estado,municipio,ciudad";
	    var nomtab = "organizacion";
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=rif&id=' + afiliado;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          var data = response.data;
	          selectEstado(data.estado);
	          selectMunicipios(data.estado, function () {
	            if (txtMunicipio.current) {
	              txtMunicipio.current.value = data.municipio;
	              selectCiudad(data.municipio, function () {
	                if (txtCiudad.current) {
	                  txtCiudad.current.value = data.ciudad;
	                  if (valestado === 1) {
	                    seleccionarClient();
	                  }
	                }
	              });
	            }
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var selectEstado = function selectEstado(id) {
	    var campos = "*";
	    var nomtab = "estado";
	    var nomid = "idestado";
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setEstado([response.data]);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var selectMunicipios = function selectMunicipios(id, callback) {
	    var campos = "*";
	    var nomtab = "municipio";
	    var nomid = "idestado";
	    var endpoint = op.conexion + '/api/consulta/modelirows?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setMunicipio(response.data);
	        if (callback) callback();
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var selectCiudad = function selectCiudad(id, callback) {
	    var campos = "*";
	    var nomtab = "ciudad";
	    var nomid = "idmunicipio";
	    var endpoint = op.conexion + '/api/consulta/modelirows?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setCiudad(response.data);
	        if (callback) callback();
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var handleMunicipioChange = function handleMunicipioChange() {
	    if (txtMunicipio.current && txtMunicipio.current.value && valestado === 1) {
	      var idMunicipio = txtMunicipio.current.value;
	      selectCiudad(idMunicipio, function () {
	        if (txtCiudad.current) {
	          txtCiudad.current.value = '';
	        }
	        setParacliente('');
	      });
	    }
	  };
	
	  var handleCiudadChange = function handleCiudadChange() {
	    if (txtCiudad.current && txtCiudad.current.value && valestado === 1 && txtMunicipio.current && txtMunicipio.current.value) {
	      setParacliente('');
	      seleccionarClient();
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    if (txtMunicipio.current) {
	      var handleChange = function handleChange() {
	        if (valestado === 1) {
	          var idMunicipio = txtMunicipio.current.value;
	          if (idMunicipio) {
	            selectCiudad(idMunicipio, function () {
	              if (txtCiudad.current) {
	                txtCiudad.current.value = '';
	              }
	              setParacliente('');
	            });
	          }
	        }
	      };
	      txtMunicipio.current.addEventListener('change', handleChange);
	      return function () {
	        if (txtMunicipio.current) {
	          txtMunicipio.current.removeEventListener('change', handleChange);
	        }
	      };
	    }
	  }, [valestado, municipio]);
	
	  (0, _react.useEffect)(function () {
	    if (txtCiudad.current) {
	      var handleChange = function handleChange() {
	        if (valestado === 1 && txtCiudad.current.value && txtMunicipio.current && txtMunicipio.current.value) {
	          setParacliente('');
	          seleccionarClient();
	        }
	      };
	
	      txtCiudad.current.addEventListener('change', handleChange);
	      return function () {
	        if (txtCiudad.current) {
	          txtCiudad.current.removeEventListener('change', handleChange);
	        }
	      };
	    }
	  }, [valestado, ciudad]);
	
	  var seleccionarClient = function seleccionarClient() {
	
	    var campos = 'idagente';
	    var nomtab = 'agente';
	    var condi = "cliente = true and municipio = '" + txtMunicipio.current.value + "'" + " and ciudad = '" + txtCiudad.current.value + "'";
	    var orden = 'idagente';
	
	    var endpoint = op.conexion + '/api/consulta/selecionarregistrocondi?&campos=' + campos + '&nomtab=' + nomtab + '&condi=' + condi + '&orden=' + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var ids = [];
	          for (var i = 0; i < response.data.length; i++) {
	            ids.push(parseInt(response.data[i].idagente));
	          }
	          setParacliente(' and idagente in(' + ids + ')');
	          setIdsc(ids);
	        }
	      } else {}
	    }).catch(function (error) {
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'md',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        seleccionarRegistro(afiliado);
	        setValestado(0);
	        txtTodosEstados.current.checked = true;
	        txtPorEstados.current.checked = false;
	        txtTodosDispo.current.checked = true;
	        txtActivos.current.checked = false;
	        txtInactivos.current.checked = false;
	        setDisponiblec('');
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'IMPRIMIR LISTA DE CLIENTES'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0 m-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 row m-0 px-0 py-2' },
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 d-flex justify-content-center border-azul rounded mb-1 mx-auto' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Estatus del Cliente:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '1', ref: txtTodosDispo, onChange: onChange, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '2', ref: txtActivos, onChange: onChange, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai2' },
	                  'Activos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '3', ref: txtInactivos, onChange: onChange, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai3' },
	                  'Inactivos'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Estado:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-3 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'estado', value: '1', ref: txtTodosEstados, onChange: onChange, id: 'estado', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-3 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'estado', value: '2', ref: txtPorEstados, onChange: onChange, id: 'estado', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa2' },
	                  'Por Estado'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 row m-0 py-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12 mr-auto px-1' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'input-group input-group-sm mb-1' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', 'for': 'inputGroupSelect01' },
	                    'ESTADO'
	                  ),
	                  _react2.default.createElement(
	                    'select',
	                    { className: 'form-select', id: 'inputGroupSelect01', ref: txtEstado, disabled: valestado === 1 ? false : true },
	                    estado.map(function (item2, x) {
	                      return _react2.default.createElement(
	                        'option',
	                        { key: x, value: item2.idestado },
	                        " ",
	                        item2.nombre,
	                        " "
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12 mr-auto px-1' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'input-group input-group-sm mb-1' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', 'for': 'inputGroupSelect02' },
	                    'MUNICIPIO'
	                  ),
	                  _react2.default.createElement(
	                    'select',
	                    {
	                      className: 'form-select',
	                      id: 'inputGroupSelect02',
	                      ref: txtMunicipio,
	                      onChange: handleMunicipioChange,
	                      disabled: valestado === 1 ? false : true
	                    },
	                    _react2.default.createElement(
	                      'option',
	                      { value: '' },
	                      'Seleccione un municipio'
	                    ),
	                    municipio.map(function (item2, x) {
	                      return _react2.default.createElement(
	                        'option',
	                        { key: x, value: item2.idmunicipio },
	                        " ",
	                        item2.nombre,
	                        " "
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12 mr-auto px-1' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'input-group input-group-sm mb-1' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', 'for': 'inputGroupSelect03' },
	                    'CIUDAD'
	                  ),
	                  _react2.default.createElement(
	                    'select',
	                    {
	                      className: 'form-select',
	                      id: 'inputGroupSelect03',
	                      ref: txtCiudad,
	                      onChange: handleCiudadChange,
	                      disabled: valestado === 1 ? false : true
	                    },
	                    _react2.default.createElement(
	                      'option',
	                      { value: '' },
	                      'Seleccione una ciudad'
	                    ),
	                    ciudad.map(function (item2, x) {
	                      return _react2.default.createElement(
	                        'option',
	                        { key: x, value: item2.idciudad },
	                        " ",
	                        item2.nombre,
	                        " "
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-11 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-success mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check-circle' },
	              '  Aceptar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EstadosdeCuentaClientes = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EstadosdeCuentaClientes = exports.EstadosdeCuentaClientes = function EstadosdeCuentaClientes(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var accbtnnentrega = JSON.parse(sessionStorage.getItem("accbtnnentregac"));
	  var accbtnndebito = JSON.parse(sessionStorage.getItem("accbtnndebitoc"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtFocus = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      inputalmacen = _useState2[0],
	      setInputalmacen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      inputproducto = _useState4[0],
	      setInputproducto = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(''),
	      _useState6 = _slicedToArray(_useState5, 2),
	      client = _useState6[0],
	      setClient = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0.00),
	      _useState8 = _slicedToArray(_useState7, 2),
	      totaldeuda = _useState8[0],
	      setTotaldeuda = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0.00),
	      _useState10 = _slicedToArray(_useState9, 2),
	      totalanticipos = _useState10[0],
	      setTotalanticipos = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0.00),
	      _useState12 = _slicedToArray(_useState11, 2),
	      totalcredito = _useState12[0],
	      setTotalcredito = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(''),
	      _useState14 = _slicedToArray(_useState13, 2),
	      rifcliente = _useState14[0],
	      setRifcliente = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(''),
	      _useState16 = _slicedToArray(_useState15, 2),
	      ordens = _useState16[0],
	      setOrdens = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(''),
	      _useState18 = _slicedToArray(_useState17, 2),
	      disponiblec = _useState18[0],
	      setDisponiblec = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(''),
	      _useState20 = _slicedToArray(_useState19, 2),
	      paracliente = _useState20[0],
	      setParacliente = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(''),
	      _useState22 = _slicedToArray(_useState21, 2),
	      idclient = _useState22[0],
	      setIdclient = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(''),
	      _useState24 = _slicedToArray(_useState23, 2),
	      idvendedr = _useState24[0],
	      setIdvendedr = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(''),
	      _useState26 = _slicedToArray(_useState25, 2),
	      report = _useState26[0],
	      setReport = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(null),
	      _useState28 = _slicedToArray(_useState27, 2),
	      status = _useState28[0],
	      setStatus = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(null),
	      _useState30 = _slicedToArray(_useState29, 2),
	      valalmacen = _useState30[0],
	      setValalmacen = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(false),
	      _useState32 = _slicedToArray(_useState31, 2),
	      activate = _useState32[0],
	      setActivate = _useState32[1];
	
	  var _useState33 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState34 = _slicedToArray(_useState33, 2),
	      mensaje = _useState34[0],
	      setMensaje = _useState34[1];
	
	  var _useState35 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState36 = _slicedToArray(_useState35, 2),
	      mensajesino = _useState36[0],
	      setMensajesino = _useState36[1];
	
	  var _useState37 = (0, _react.useState)([]),
	      _useState38 = _slicedToArray(_useState37, 2),
	      records = _useState38[0],
	      setRecords = _useState38[1];
	
	  var _useState39 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState40 = _slicedToArray(_useState39, 2),
	      botones = _useState40[0],
	      setBotones = _useState40[1];
	
	  var _useState41 = (0, _react.useState)({ fn: function fn(items) {
	      return items;
	    } }),
	      _useState42 = _slicedToArray(_useState41, 2),
	      filterFn = _useState42[0],
	      setFilterFn = _useState42[1];
	
	  var nomtabla = void 0;
	
	  if (props.op === 3) {
	    nomtabla = [{ label: '', textAlign: 'center' }, { label: 'N° DOCUMENTO', textAlign: 'center' }, { label: 'DESCRIPCION', textAlign: 'center' }, { label: 'FECHA', textAlign: 'center' }, { label: 'MONTO', textAlign: 'center' }, { label: 'ESTATUS', textAlign: 'center' }];
	  } else {
	    nomtabla = [{ label: '', textAlign: 'center' }, { label: 'N° DOCUMENTO', textAlign: 'center' }, { label: 'DESCRIPCION', textAlign: 'center' }, { label: 'FECHA', textAlign: 'center' }, { label: 'MONTO', textAlign: 'center' }];
	  }
	
	  var headCells = nomtabla;
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if ((0, _varios.formatMoneda)(x.totalmonto.toString().replace(",", "").replace(".", ","), ",", ".", 2).includes(target.value) || x.numfactura.toLowerCase().includes(target.value.toLowerCase()) || x.descripcionnota !== null ? x.descripcionnota : ''.toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setInputalmacen(0);
	    setRifcliente('');
	    setDisponiblec('');
	    setParacliente('');
	    setInputproducto(0);
	    setStatus(null);
	    setReport('');
	    setIdclient('');
	    setIdvendedr('');
	    setValalmacen(0);
	    setOrdens('');
	    setClient('');
	    setTotaldeuda(0.00);
	    setTotalanticipos(0.00);
	    setTotalcredito(0.00);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.op === 1 || props.op === 2 || props.op === 3) {
	      imprimirGeneral();
	    }
	  };
	
	  var imprimirGeneral = function imprimirGeneral() {
	
	    var reporte = "";
	    var titulos = "";
	
	    if (props.op === 1) {
	      reporte = 'ReporteEstadoCeuntasyPorcobrar';
	      titulos = 'ESTADOS DE CUENTA (DEUDAS)';
	    } else if (props.op === 3) {
	      reporte = 'ReporteEstadoCeuntasyPorcobrarTres';
	      titulos = 'ESTADOS DE CUENTA (GENERAL)';
	    } else {
	      reporte = 'ReporteEstadoCeuntasyPorcobrarDos';
	      titulos = 'ESTADOS DE CUENTA (PAGADAS)';
	    }
	
	    var condi = "'" + 'and n.status = ' + status + ' and n.idcliente = ' + idclient + "'";
	
	    window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&condicion=" + condi + "&titulo=" + titulos, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    if (props.llamado === 2) {
	      props.onHideCancelar();
	    }
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var seleccionarTotalesClientesPagosDetalle = function seleccionarTotalesClientesPagosDetalle(status, cliente) {
	
	    var endpoint = op.conexion + '/api/agente/totalespagosdetalles?estatus=' + status + '&cliente=' + cliente;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        setRecords(response.data);
	        setClient(response.data[0].cliente);
	        setRifcliente(response.data[0].rifclient);
	
	        var total = 0.00;
	        var toanticipo = response.data[0].totalanticipos !== null ? response.data[0].totalanticipos : 0.00;
	        var tocredito = response.data[0].totalcredito !== null ? response.data[0].totalcredito : 0.00;
	
	        for (var i = 0; i < response.data.length; i++) {
	
	          total = parseFloat(total) + parseFloat(response.data[i].totalmonto);
	        }
	        setTotalanticipos((0, _varios.formatMoneda)(toanticipo.toString().replace(",", "").replace(".", ","), ",", ".", 2));
	        setTotalcredito((0, _varios.formatMoneda)(tocredito.toString().replace(",", "").replace(".", ","), ",", ".", 2));
	        setTotaldeuda((0, _varios.formatMoneda)(total.toString().replace(",", "").replace(".", ","), ",", ".", 2));
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var imprimirNotaEntregaDebito = function imprimirNotaEntregaDebito(ope, data) {
	    return function (e) {
	      e.preventDefault();
	
	      if (data.tipo === 'NE') {
	        if (accbtnnentrega && accbtnnentrega.toString().substring(4, 5) === "1") {
	
	          if (ope === 1) {
	
	            var idnot = data.idfactura;
	
	            var nota = JSON.parse(sessionStorage.getItem("tiporepnotaentrega"));
	            var reporte = nota.toString() === 'HOJA' ? "ReportNotaEntrega" : "ReportNotaEntregaMedium";
	
	            window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&idnota=" + idnot, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	          } else {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "¡ Seleccione la nota de Entrega y/o Debito !",
	              icono: "informacion"
	            });
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else {
	        if (accbtnndebito && accbtnndebito.toString().substring(4, 5) === "1") {
	
	          if (ope === 1) {
	
	            var _idnot = data.numfactura;
	
	            var reporte = "ReportNotaDebito";
	
	            window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&idnota=" + "'" + _idnot + "'", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	          } else {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "¡ Seleccione la nota de Debito !",
	              icono: "informacion"
	            });
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      }
	    };
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'xl',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.op === 1) {
	          seleccionarTotalesClientesPagosDetalle(0, props.client);
	          setStatus(0);
	          setIdclient(props.client);
	          txtFocus.current.focus();
	        } else if (props.op === 2) {
	          seleccionarTotalesClientesPagosDetalle(1, props.client);
	          setStatus(1);
	          setIdclient(props.client);
	          txtFocus.current.focus();
	        } else {
	          seleccionarTotalesClientesPagosDetalle('f.status', props.client);
	          setStatus('n.status');
	          setIdclient(props.client);
	          txtFocus.current.focus();
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          props.op === 1 ? 'Relación de Cuenta (Deudas)' : props.op === 3 ? 'Relación de Cuenta (General)' : 'Relación de Cuenta (Pagadas)'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 row m-0' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 px-0 mb-3' },
	            _react2.default.createElement(
	              'label',
	              { className: 'input-group-text bg-trasnparent border-0 fs-4', id: 'inputGroup-sizing-sm' },
	              'CLIENTE: ',
	              client,
	              ' - RIF: ',
	              rifcliente
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12', style: { marginBottom: "10px" } },
	          _react2.default.createElement(
	            'div',
	            { className: 'row m-0 px-0 col-7' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm mb-1 px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text border-azul', id: 'inputGroup-sizing-sm' },
	                  'BUSCAR:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtFocus, className: 'form-control text-uppercase border-azul', onChange: handleSearch, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          TblContainer,
	          null,
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _semanticUiReact.TableBody,
	            null,
	            records && recordsAfterPagingAndSorting().map(function (item, index) {
	              return _react2.default.createElement(
	                _semanticUiReact.TableRow,
	                { key: index },
	                _react2.default.createElement(
	                  _semanticUiReact.TableCell,
	                  { className: 'py-2' },
	                  _react2.default.createElement(
	                    'button',
	                    { onClick: imprimirNotaEntregaDebito(1, item), className: 'btn btn-sm btn-info' },
	                    _react2.default.createElement('i', { className: 'fas fa-print' }),
	                    " "
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.TableCell,
	                  { className: 'py-2' },
	                  item.numfactura
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.TableCell,
	                  { className: 'py-2' },
	                  item.descripcionnota
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.TableCell,
	                  { className: 'py-2 text-center' },
	                  (0, _moment2.default)(item.fecha).format('DD/MM/YYYY')
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.TableCell,
	                  { className: 'py-2 text-right' },
	                  (0, _varios.formatMoneda)(item.totalmonto.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                ),
	                props.op === 3 ? _react2.default.createElement(
	                  _semanticUiReact.TableCell,
	                  { className: 'py-2 text-center' },
	                  item.status === 0 ? _react2.default.createElement(
	                    'b',
	                    { className: 'fw-bold text-warning' },
	                    'POR PAGAR'
	                  ) : item.status === 1 ? _react2.default.createElement(
	                    'b',
	                    { className: 'fw-bold text-success' },
	                    'PAGADA'
	                  ) : _react2.default.createElement(
	                    'b',
	                    { className: 'fw-bold text-danger' },
	                    'ANULADA'
	                  )
	                ) : ''
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(TblPagination, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-12 row m-0' },
	          props.op === 1 ? _react2.default.createElement(
	            'div',
	            { className: 'col-md-4' },
	            _react2.default.createElement(
	              'label',
	              { className: 'input-group-text border-azul', id: 'inputGroup-sizing-sm' },
	              'ANTICIPO SIN APLICAR: ',
	              _react2.default.createElement(
	                'p',
	                { className: 'fs-5 text-right w-100' },
	                totalanticipos
	              )
	            )
	          ) : '',
	          props.op === 1 ? _react2.default.createElement(
	            'div',
	            { className: 'col-md-4' },
	            _react2.default.createElement(
	              'label',
	              { className: 'input-group-text border-azul', id: 'inputGroup-sizing-sm' },
	              'CREDITO SIN APLICAR: ',
	              _react2.default.createElement(
	                'p',
	                { className: 'fs-5 text-right w-100' },
	                totalcredito
	              )
	            )
	          ) : '',
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-4 ml-auto' },
	            _react2.default.createElement(
	              'label',
	              { className: 'input-group-text border-azul', id: 'inputGroup-sizing-sm' },
	              props.op === 1 ? 'TOTAL DEUDA:' : props.op === 3 ? 'MONTO TOTAL:' : 'TOTAL PAGADO:',
	              ' ',
	              _react2.default.createElement(
	                'p',
	                { className: 'fs-5 text-right w-100' },
	                totaldeuda
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-4 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-primary mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-print' },
	              '  Imprimir'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ImagenNotaEntrega = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagenNotaEntrega = exports.ImagenNotaEntrega = function ImagenNotaEntrega(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var organizacion = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)({
	    imagen: op.conexion + '/imagen?img=subir.png'
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      pathImage = _useState2[0],
	      setPathImage = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      activate = _useState4[0],
	      setActivate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState6 = _slicedToArray(_useState5, 2),
	      mensaje = _useState6[0],
	      setMensaje = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      mensajesino = _useState8[0],
	      setMensajesino = _useState8[1];
	
	  var blanquear = function blanquear() {
	    setPathImage('...');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    if (props.llamado === 2) {
	      props.onHideCancelar();
	    }
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var getDescargar = function getDescargar() {
	    setActivate(true);
	    var endpoint = op.conexion + '/imagen?img=' + organizacion + '/imagenesnotas/' + props.imagen.trim();
	    _axios2.default.get(endpoint, {
	      responseType: "arraybuffer",
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      var url = window.URL.createObjectURL(new Blob([response.data]));
	      var link = document.createElement("a");
	      link.href = url;
	      link.setAttribute("download", '' + props.imagen.trim());
	      document.body.appendChild(link);
	      link.click();
	      document.body.removeChild(link);
	    }).catch(function (error) {
	      console.error(error);
	    }).finally(function () {
	      return setActivate(false);
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	    getDescargar();
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        setPathImage({
	          imagen: op.conexion + '/imagen?img=' + organizacion + '/imagenesnotas/' + props.imagen.trim()
	        });
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Imagen Nota Entrega'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 mx-auto px-0 d-flex justify-content-center' },
	        _react2.default.createElement('img', { src: pathImage.imagen, style: { height: '750px' }, className: 'img-fluid img-thumbnail', alt: '...' })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-4 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-primary mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-download' },
	              '  Descargar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ImprimirNotasdeCredito = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoAlmacen = __webpack_require__(51);
	
	var _catalogoAlmacen2 = _interopRequireDefault(_catalogoAlmacen);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImprimirNotasdeCredito = exports.ImprimirNotasdeCredito = function ImprimirNotasdeCredito(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtTodasFechas = (0, _react.useRef)();
	  var txtPorFechas = (0, _react.useRef)();
	  var txtTodosDispo = (0, _react.useRef)();
	  var txtCanceladas = (0, _react.useRef)();
	  var txtDeudas = (0, _react.useRef)();
	  var txtAnuladas = (0, _react.useRef)();
	  var txtTodosCliente = (0, _react.useRef)();
	  var txtPorCliente = (0, _react.useRef)();
	  var txtIdProducto = (0, _react.useRef)();
	  var txtRifrespon = (0, _react.useRef)();
	  var txtNomrespon = (0, _react.useRef)();
	  var txtRifVende = (0, _react.useRef)();
	  var txtNomVende = (0, _react.useRef)();
	  var txtDesde = (0, _react.useRef)();
	  var txtHasta = (0, _react.useRef)();
	  var txtCbmrif = (0, _react.useRef)();
	  var txtCbmrifVende = (0, _react.useRef)();
	  var txtTodosAlmacen = (0, _react.useRef)();
	  var txtPorAlmacen = (0, _react.useRef)();
	  var txtCodigoAlmacen = (0, _react.useRef)();
	  var txtNombreAlmacen = (0, _react.useRef)();
	  var txtOrden = (0, _react.useRef)();
	  var txtTodosVendedores = (0, _react.useRef)();
	  var txtPorVendedor = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      inputalmacen = _useState2[0],
	      setInputalmacen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      inputproducto = _useState4[0],
	      setInputproducto = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      valvende = _useState6[0],
	      setValvende = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      tiporif = _useState8[0],
	      setTipofic = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(''),
	      _useState10 = _slicedToArray(_useState9, 2),
	      tituloc = _useState10[0],
	      setTituloc = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(null),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mostrar1 = _useState12[0],
	      setMostrar1 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(null),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mostrar2 = _useState14[0],
	      setMostrar2 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(''),
	      _useState16 = _slicedToArray(_useState15, 2),
	      parafecha = _useState16[0],
	      setParafecha = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(''),
	      _useState18 = _slicedToArray(_useState17, 2),
	      desde = _useState18[0],
	      setDesde = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(''),
	      _useState20 = _slicedToArray(_useState19, 2),
	      hasta = _useState20[0],
	      setHasta = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(''),
	      _useState22 = _slicedToArray(_useState21, 2),
	      ordens = _useState22[0],
	      setOrdens = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(''),
	      _useState24 = _slicedToArray(_useState23, 2),
	      clientvende = _useState24[0],
	      setClientvende = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(''),
	      _useState26 = _slicedToArray(_useState25, 2),
	      disponiblec = _useState26[0],
	      setDisponiblec = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(''),
	      _useState28 = _slicedToArray(_useState27, 2),
	      paracliente = _useState28[0],
	      setParacliente = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(''),
	      _useState30 = _slicedToArray(_useState29, 2),
	      idclient = _useState30[0],
	      setIdclient = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(''),
	      _useState32 = _slicedToArray(_useState31, 2),
	      idvendedr = _useState32[0],
	      setIdvendedr = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(''),
	      _useState34 = _slicedToArray(_useState33, 2),
	      report = _useState34[0],
	      setReport = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(null),
	      _useState36 = _slicedToArray(_useState35, 2),
	      idalmacen = _useState36[0],
	      setIdalmacen = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(null),
	      _useState38 = _slicedToArray(_useState37, 2),
	      valalmacen = _useState38[0],
	      setValalmacen = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(false),
	      _useState40 = _slicedToArray(_useState39, 2),
	      activate = _useState40[0],
	      setActivate = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(true),
	      _useState42 = _slicedToArray(_useState41, 2),
	      habilitado = _useState42[0],
	      setHabilitado = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      mensaje = _useState44[0],
	      setMensaje = _useState44[1];
	
	  var _useState45 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState46 = _slicedToArray(_useState45, 2),
	      mensajesino = _useState46[0],
	      setMensajesino = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(''),
	      _useState48 = _slicedToArray(_useState47, 2),
	      tituid = _useState48[0],
	      setTituid = _useState48[1];
	
	  var _useState49 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState50 = _slicedToArray(_useState49, 2),
	      botones = _useState50[0],
	      setBotones = _useState50[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setInputalmacen(0);
	    setParafecha('');
	    setDisponiblec('');
	    setParacliente('');
	    setInputproducto(0);
	    setIdalmacen("");
	    setReport('');
	    setIdclient('');
	    setIdvendedr('');
	    setValalmacen(0);
	    setOrdens('');
	    setValvende(0);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.op === 1) {
	
	      if (txtPorFechas.current.checked === true && txtPorCliente.current.checked === false) {
	        if (txtDesde.current.value === '' || txtHasta.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione las Fechas a Consultar !', icono: 'informacion' });
	          if (txtDesde.current.value === '' && txtHasta.current.value !== '') {
	            txtDesde.current.focus();
	          } else if (txtHasta.current.value === '' && txtDesde.current.value !== '') {
	            txtHasta.current.focus();
	          }
	          sigue = false;
	        } else {
	          imprimirGeneral();
	        }
	      } else if (txtPorFechas.current.checked === false && txtPorCliente.current.checked === true) {
	        if (txtRifrespon.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el RIF del Cliente a Consultar !', icono: 'informacion' });
	          txtRifrespon.current.focus();
	          sigue = false;
	        } else {
	          imprimirGeneral();
	        }
	      } else if (txtPorFechas.current.checked === true && txtPorCliente.current.checked === true) {
	        if (txtDesde.current.value === '' || txtHasta.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Las Fechas a Consultar no Deben ir Vacias !', icono: 'informacion' });
	          txtPorFechas.current.focus();
	          sigue = false;
	        } else if (txtRifrespon.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el RIF del Cliente a Consultar !', icono: 'informacion' });
	          txtRifrespon.current.focus();
	          sigue = false;
	        } else {
	          imprimirGeneral();
	        }
	      } else {
	        imprimirGeneral();
	      }
	    }
	  };
	
	  var onChekval = function onChekval(e) {
	
	    if (e.target.id === 'tipoalmacen') {
	
	      if (txtTodasFechas.current.checked === true) {
	        setInputalmacen(0);
	        setParafecha('');
	        setDesde('');
	        setHasta('');
	        txtDesde.current.value = '';
	        txtHasta.current.value = '';
	      } else if (txtPorFechas.current.checked === true) {
	        setInputalmacen(1);
	        setParafecha("'" + ' and n.fecha between ' + "'");
	      }
	    } else if (e.target.id === 'tipodisponible') {
	
	      if (e.target.value === '1') {
	        setDisponiblec('');
	      } else if (e.target.value === '2') {
	        setDisponiblec("'" + ' and n.status = 1' + "'");
	      } else if (e.target.value === '3') {
	        setDisponiblec("'" + ' and n.status = 0' + "'");
	      } else if (e.target.value === '4') {
	        setDisponiblec("'" + ' and n.status = 4' + "'");
	      }
	    } else if (e.target.id === 'cliente') {
	
	      if (txtTodosCliente.current.checked === true) {
	        setInputproducto(0);
	        setParacliente('');
	        setIdclient('');
	        txtNomrespon.current.value = '';
	        txtCbmrif.current.value = '';
	        txtRifrespon.current.value = '';
	      } else if (txtPorCliente.current.checked === true) {
	        setInputproducto(1);
	        setParacliente("'" + ' and n.cedularif =' + "'");
	      }
	    }
	  };
	
	  var imprimirGeneral = function imprimirGeneral() {
	
	    var parameters = void 0;
	    var validacion = "";
	    var validados = "";
	    var validates = "";
	
	    if (inputalmacen === 1) {
	      parameters = "|| quote_literal(" + desde + ") ||" + "'" + ' and ' + "'" + "|| quote_literal(" + hasta + ")";
	      validacion = disponiblec || idclient !== '' ? '||' : '';
	    } else {
	      parameters = '';
	      validacion = '';
	    }
	
	    if (inputproducto === 1) {
	      validates = paracliente !== '' ? '||' : '';
	    } else {
	      validates = '';
	    }
	
	    if (txtTodosDispo.current.checked === true) {
	      validados = '';
	    } else {
	      validados = disponiblec && paracliente !== '' ? '||' : '';
	    }
	
	    var reporte = "ReporteCreditosGeneral";
	    var numtabla = "n.numnotaentrega";
	
	    var entrada = "";
	
	    if (disponiblec || idclient || parafecha !== "") {
	      entrada = '';
	    } else {
	      entrada = report;
	    }
	
	    var condi = entrada + disponiblec + validados + paracliente + validates + idclient + validacion + parafecha + parameters;
	    var orden = txtOrden.current.value === '1' ? ordens + ", " + numtabla : txtOrden.current.value + ", " + numtabla;
	
	    var ope = 1;
	
	    window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&condicion=" + condi + "&titulo=" + tituloc + "&tiid=" + tituid + "&orden=" + orden + "&ope=" + ope, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    if (props.llamado === 2) {
	      props.onHideRenderizar();
	      props.onHideCancela();
	    }
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var handleAceptaCliente = function handleAceptaCliente(values) {
	    setMostrar1(false);
	    if (clientvende === 'cliente') {
	      txtCbmrif.current.value = values.rif.substring(0, 1);
	      txtRifrespon.current.value = values.rif.substring(2, 9);
	      txtNomrespon.current.value = values.nombre;
	      selectResponsable(values.rif);
	      setIdclient("quoete_literal(" + "'" + values.rif + "'" + ")");
	    } else if (clientvende === 'vendedor') {
	      txtCbmrifVende.current.value = values.rif.substring(0, 1);
	      txtRifVende.current.value = values.rif.substring(2, 9);
	      txtNomVende.current.value = values.nombre;
	      selectResponsable(values.rif);
	      setIdvendedr("'" + 'n.idvendedor = ' + values.idagente + "'");
	    }
	  };
	
	  var catalogoProductoc = function catalogoProductoc(ope) {
	    return function (e) {
	      e.preventDefault();
	      if (ope === 1) {
	        setClientvende('cliente');
	        setMostrar1(true);
	      } else {
	        setClientvende('vendedor');
	        setMostrar1(true);
	      }
	    };
	  };
	
	  var handleAceptaAlmacen = function handleAceptaAlmacen(values) {
	    setMostrar2(false);
	    txtNombreAlmacen.current.value = values.descripcion;
	    txtCodigoAlmacen.current.value = values.idalmacen;
	    setIdalmacen(values.idalmacen);
	  };
	
	  var selectResponsable = function selectResponsable(id) {
	
	    var campos = '*';
	    var nomtab = 'agente';
	    var nomid = 'rif';
	    var nomid2 = clientvende;
	    var endpoint = op.conexion + '/api/consulta/modeli2?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id + '&nomid2=' + nomid2 + '&id2=true';
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idagente > 0) {
	          if (clientvende === 'cliente') {
	            txtNomrespon.current.value = response.data.nombre;
	            setIdclient("quote_literal(" + "'" + response.data.rif + "'" + ")");
	            btnAcepta.current.focus();
	          } else {
	            txtNomVende.current.value = response.data.nombre;
	            setIdvendedr("'" + ' and n.idvendedor = ' + response.data.idagente + "'");
	            btnAcepta.current.focus();
	          }
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ RIF y/o Cliente no Registrado !', icono: 'informacion' });
	          txtRifrespon.current.value = '';
	          txtNomrespon.current.value = '';
	          txtRifVende.current.value = '';
	          txtNomVende.current.value = '';
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'nci') {
	      setTipofic(e.target.value);
	    } else if (e.target.name === 'desde') {
	      if (e.target.value > (0, _moment2.default)(fechasistema).format('YYYY-MM-DD')) {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !', icono: 'informacion' });
	        txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        txtDesde.current.focus();
	      } else {
	        setDesde("'" + (0, _moment2.default)(e.target.value).format('DD-MM-YYYY') + "'");
	      }
	    } else if (e.target.name === 'hasta') {
	      setHasta("'" + (0, _moment2.default)(e.target.value).format('DD-MM-YYYY') + "'");
	    }
	  };
	
	  var handleCliente = function handleCliente(e) {
	    e.preventDefault();
	    if (e.which === 13 || typeof e.which === 'undefined') {
	      if (e.target.value !== '') {
	        selectResponsable(tiporif + e.target.value);
	      }
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.op === 1) {
	          txtTodasFechas.current.checked = true;
	          txtTodosCliente.current.checked = true;
	          var paran = ' and n.idnotaentrega > 0';
	          setReport("'" + paran + "'");
	          setParacliente('');
	          setDisponiblec('');
	          setParafecha('');
	          setDesde('');
	          setHasta('');
	          setTipofic('V');
	          setOrdens('n.idcliente, n.fecha');
	          txtPorFechas.current.checked = false;
	          txtPorCliente.current.checked = false;
	          setHabilitado(false);
	        } else {
	
	          txtTodasFechas.current.checked = false;
	          txtTodosCliente.current.checked = false;
	
	          txtPorCliente.current.checked = false;
	          txtPorFechas.current.checked = false;
	
	          setHabilitado(true);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Imprimir Notas de Cr\xE9dito'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto' },
	          _react2.default.createElement(
	            'div',
	            { className: 'colfull col-pd-300 px-3 ml-auto' },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm' },
	              _react2.default.createElement(
	                'label',
	                {
	                  className: 'input-group-text',
	                  id: 'inputGroup-sizing-sm'
	                },
	                'ORDENAR POR:'
	              ),
	              _react2.default.createElement(
	                'select',
	                {
	                  className: 'form-control form-control-sm form-select fs-6 fw-bold',
	                  ref: txtOrden,
	                  name: 'orden'
	                  /* onChange={onChekval} */
	
	                },
	                _react2.default.createElement(
	                  'option',
	                  { value: '1' },
	                  'FECHA'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: 'n.idcliente' },
	                  'CLIENTES'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Fecha:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipoalmacen', value: '1', ref: txtTodasFechas, onChange: onChekval, id: 'tipoalmacen', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRadi1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipoalmacen', value: '2', ref: txtPorFechas, onChange: onChekval, id: 'tipoalmacen', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRadi2' },
	                  'Por Fecha'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-7 row m-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'DESDE:'
	                  ),
	                  _react2.default.createElement('input', { type: 'date', ref: txtDesde, disabled: inputalmacen === 0 ? true : false, name: 'desde', onChange: onChange, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'HASTA:'
	                  ),
	                  _react2.default.createElement('input', { type: 'date', ref: txtHasta, disabled: inputalmacen === 0 ? true : false, name: 'hasta', onChange: onChange, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            )
	          ),
	          props.report !== "reporteobsequio" ? _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 d-flex justify-content-center border-azul rounded mb-1 mx-auto' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Estatus del Pago:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '1', ref: txtTodosDispo, onChange: onChekval, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '2', ref: txtCanceladas, onChange: onChekval, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai2' },
	                  'Procesadas'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '3', ref: txtDeudas, onChange: onChekval, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai3' },
	                  'Disponibles'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '4', ref: txtAnuladas, onChange: onChekval, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai4' },
	                  'Anuladas'
	                )
	              )
	            )
	          ) : '',
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Cliente:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'cliente', value: '1', ref: txtTodosCliente, onChange: onChekval, id: 'cliente', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'cliente', value: '2', ref: txtPorCliente, onChange: onChekval, id: 'cliente', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa2' },
	                  'Por Cliente'
	                )
	              )
	            ),
	            _react2.default.createElement('input', { type: 'hidden', ref: txtIdProducto }),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-7 mr-auto px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm col-7 px-1 ml-auto' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'RIF:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-select col-3', ref: txtCbmrif, name: 'nci', onChange: onChange, 'aria-label': 'Default select example' },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'V' },
	                    'V'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'E' },
	                    'E'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'J' },
	                    'J'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'P' },
	                    'P'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'G' },
	                    'G'
	                  )
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtRifrespon, disabled: inputproducto === 1 ? false : true, onKeyUp: handleCliente, onBlur: handleCliente, className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: inputproducto === 1 ? false : true, type: 'button', onClick: catalogoProductoc(1), className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 row m-0 py-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'Nombre del Cliente:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', ref: txtNomrespon, disabled: true, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-4 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: habilitado, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-primary mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-print' },
	              '  Imprimir'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: mostrar1,
	      nomid: clientvende,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar1(false);
	      },
	      onHideAceptaCatalogo: handleAceptaCliente
	    }),
	    _react2.default.createElement(_catalogoAlmacen2.default, {
	      show: mostrar2,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar2(false);
	      },
	      onHideAceptaCatalogo: handleAceptaAlmacen
	    })
	  );
	};

/***/ },
/* 7165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ImprimirNotasdeDebitos = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoAlmacen = __webpack_require__(51);
	
	var _catalogoAlmacen2 = _interopRequireDefault(_catalogoAlmacen);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImprimirNotasdeDebitos = exports.ImprimirNotasdeDebitos = function ImprimirNotasdeDebitos(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtTodasFechas = (0, _react.useRef)();
	  var txtPorFechas = (0, _react.useRef)();
	  var txtTodosDispo = (0, _react.useRef)();
	  var txtCanceladas = (0, _react.useRef)();
	  var txtDeudas = (0, _react.useRef)();
	  var txtAnuladas = (0, _react.useRef)();
	  var txtTodosCliente = (0, _react.useRef)();
	  var txtPorCliente = (0, _react.useRef)();
	  var txtIdProducto = (0, _react.useRef)();
	  var txtRifrespon = (0, _react.useRef)();
	  var txtNomrespon = (0, _react.useRef)();
	  var txtRifVende = (0, _react.useRef)();
	  var txtNomVende = (0, _react.useRef)();
	  var txtDesde = (0, _react.useRef)();
	  var txtHasta = (0, _react.useRef)();
	  var txtCbmrif = (0, _react.useRef)();
	  var txtCbmrifVende = (0, _react.useRef)();
	  var txtTodosAlmacen = (0, _react.useRef)();
	  var txtPorAlmacen = (0, _react.useRef)();
	  var txtCodigoAlmacen = (0, _react.useRef)();
	  var txtNombreAlmacen = (0, _react.useRef)();
	  var txtOrden = (0, _react.useRef)();
	  var txtTodosVendedores = (0, _react.useRef)();
	  var txtPorVendedor = (0, _react.useRef)();
	  var txtChekGeneral = (0, _react.useRef)();
	  var txtTodosEstados = (0, _react.useRef)();
	  var txtPorEstados = (0, _react.useRef)();
	  var txtEstado = (0, _react.useRef)();
	  var txtMunicipio = (0, _react.useRef)();
	  var txtCiudad = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      inputalmacen = _useState2[0],
	      setInputalmacen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = _slicedToArray(_useState3, 2),
	      tipon = _useState4[0],
	      setTipon = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      inputproducto = _useState6[0],
	      setInputproducto = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      valvende = _useState8[0],
	      setValvende = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      tiporif = _useState10[0],
	      setTipofic = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(''),
	      _useState12 = _slicedToArray(_useState11, 2),
	      tituloc = _useState12[0],
	      setTituloc = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(null),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mostrar1 = _useState14[0],
	      setMostrar1 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(null),
	      _useState16 = _slicedToArray(_useState15, 2),
	      mostrar2 = _useState16[0],
	      setMostrar2 = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(''),
	      _useState18 = _slicedToArray(_useState17, 2),
	      parafecha = _useState18[0],
	      setParafecha = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(''),
	      _useState20 = _slicedToArray(_useState19, 2),
	      desde = _useState20[0],
	      setDesde = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(''),
	      _useState22 = _slicedToArray(_useState21, 2),
	      hasta = _useState22[0],
	      setHasta = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(''),
	      _useState24 = _slicedToArray(_useState23, 2),
	      ordens = _useState24[0],
	      setOrdens = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(null),
	      _useState26 = _slicedToArray(_useState25, 2),
	      idestadoc = _useState26[0],
	      setIdestadoc = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(null),
	      _useState28 = _slicedToArray(_useState27, 2),
	      idmunicipioc = _useState28[0],
	      setIdmunicipioc = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(null),
	      _useState30 = _slicedToArray(_useState29, 2),
	      idciudadc = _useState30[0],
	      setIdciudadc = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(''),
	      _useState32 = _slicedToArray(_useState31, 2),
	      clientvende = _useState32[0],
	      setClientvende = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(''),
	      _useState34 = _slicedToArray(_useState33, 2),
	      disponiblec = _useState34[0],
	      setDisponiblec = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(''),
	      _useState36 = _slicedToArray(_useState35, 2),
	      paracliente = _useState36[0],
	      setParacliente = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(''),
	      _useState38 = _slicedToArray(_useState37, 2),
	      idclient = _useState38[0],
	      setIdclient = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(0),
	      _useState40 = _slicedToArray(_useState39, 2),
	      valestado = _useState40[0],
	      setValestado = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(''),
	      _useState42 = _slicedToArray(_useState41, 2),
	      idvendedr = _useState42[0],
	      setIdvendedr = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(''),
	      _useState44 = _slicedToArray(_useState43, 2),
	      report = _useState44[0],
	      setReport = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(null),
	      _useState46 = _slicedToArray(_useState45, 2),
	      idalmacen = _useState46[0],
	      setIdalmacen = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(null),
	      _useState48 = _slicedToArray(_useState47, 2),
	      valalmacen = _useState48[0],
	      setValalmacen = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(false),
	      _useState50 = _slicedToArray(_useState49, 2),
	      activate = _useState50[0],
	      setActivate = _useState50[1];
	
	  var _useState51 = (0, _react.useState)([]),
	      _useState52 = _slicedToArray(_useState51, 2),
	      idsc = _useState52[0],
	      setIdsc = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(true),
	      _useState54 = _slicedToArray(_useState53, 2),
	      habilitado = _useState54[0],
	      setHabilitado = _useState54[1];
	
	  var _useState55 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState56 = _slicedToArray(_useState55, 2),
	      mensaje = _useState56[0],
	      setMensaje = _useState56[1];
	
	  var _useState57 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState58 = _slicedToArray(_useState57, 2),
	      mensajesino = _useState58[0],
	      setMensajesino = _useState58[1];
	
	  var _useState59 = (0, _react.useState)(''),
	      _useState60 = _slicedToArray(_useState59, 2),
	      tituid = _useState60[0],
	      setTituid = _useState60[1];
	
	  var _useState61 = (0, _react.useState)([]),
	      _useState62 = _slicedToArray(_useState61, 2),
	      estado = _useState62[0],
	      setEstado = _useState62[1];
	
	  var _useState63 = (0, _react.useState)([]),
	      _useState64 = _slicedToArray(_useState63, 2),
	      municipio = _useState64[0],
	      setMunicipio = _useState64[1];
	
	  var _useState65 = (0, _react.useState)([]),
	      _useState66 = _slicedToArray(_useState65, 2),
	      ciudad = _useState66[0],
	      setCiudad = _useState66[1];
	
	  var _useState67 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState68 = _slicedToArray(_useState67, 2),
	      botones = _useState68[0],
	      setBotones = _useState68[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setInputalmacen(0);
	    setParafecha('');
	    setDisponiblec('');
	    setParacliente('');
	    setInputproducto(0);
	    setIdalmacen("");
	    setReport('');
	    setIdclient('');
	    setIdvendedr('');
	    setValalmacen(0);
	    setOrdens('');
	    setValvende(0);
	    setValestado(0);
	    setTipon('');
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.op === 1) {
	
	      if (txtPorFechas.current.checked === true && txtPorCliente.current.checked === false) {
	        if (txtDesde.current.value === '' || txtHasta.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione las Fechas a Consultar !', icono: 'informacion' });
	          if (txtDesde.current.value === '' && txtHasta.current.value !== '') {
	            txtDesde.current.focus();
	          } else if (txtHasta.current.value === '' && txtDesde.current.value !== '') {
	            txtHasta.current.focus();
	          }
	          sigue = false;
	        } else {
	          imprimirGeneral();
	        }
	      } else if (txtPorFechas.current.checked === false && txtPorCliente.current.checked === true) {
	        if (txtRifrespon.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el RIF del Cliente a Consultar !', icono: 'informacion' });
	          txtRifrespon.current.focus();
	          sigue = false;
	        } else {
	          imprimirGeneral();
	        }
	      } else if (txtPorFechas.current.checked === true && txtPorCliente.current.checked === true) {
	        if (txtDesde.current.value === '' || txtHasta.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Las Fechas a Consultar no Deben ir Vacias !', icono: 'informacion' });
	          txtPorFechas.current.focus();
	          sigue = false;
	        } else if (txtRifrespon.current.value === '') {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el RIF del Cliente a Consultar !', icono: 'informacion' });
	          txtRifrespon.current.focus();
	          sigue = false;
	        } else {
	          imprimirGeneral();
	        }
	      } else {
	        imprimirGeneral();
	      }
	    }
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = "estado,municipio,ciudad";
	    var nomtab = "organizacion";
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=rif&id=' + afiliado;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          var data = response.data;
	          selectEstado(data.estado);
	          selectMunicipios(data.estado, function () {
	            if (txtMunicipio.current) {
	              txtMunicipio.current.value = data.municipio;
	              selectCiudad(data.municipio, function () {
	                if (txtCiudad.current) {
	                  txtCiudad.current.value = data.ciudad;
	                  if (valestado === 1) {
	                    seleccionarClient();
	                  }
	                }
	              });
	            }
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var selectEstado = function selectEstado(id) {
	    var campos = "*";
	    var nomtab = "estado";
	    var nomid = "idestado";
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setEstado([response.data]);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var selectMunicipios = function selectMunicipios(id, callback) {
	    var campos = "*";
	    var nomtab = "municipio";
	    var nomid = "idestado";
	    var endpoint = op.conexion + '/api/consulta/modelirows?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setMunicipio(response.data);
	        if (callback) callback();
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var selectCiudad = function selectCiudad(id, callback) {
	    var campos = "*";
	    var nomtab = "ciudad";
	    var nomid = "idmunicipio";
	    var endpoint = op.conexion + '/api/consulta/modelirows?campos=' + campos + '&id=' + id + '&nomtab=' + nomtab + '&nomid=' + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setCiudad(response.data);
	        if (callback) callback();
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var handleMunicipioChange = function handleMunicipioChange() {
	    if (txtMunicipio.current && txtMunicipio.current.value && valestado === 1) {
	      var idMunicipio = txtMunicipio.current.value;
	      selectCiudad(idMunicipio, function () {
	        if (txtCiudad.current) {
	          txtCiudad.current.value = '';
	        }
	        txtRifrespon.current.value = '';
	        txtNomrespon.current.value = '';
	        setIdclient('');
	        setParacliente('');
	      });
	    }
	  };
	
	  var handleCiudadChange = function handleCiudadChange() {
	    if (txtCiudad.current && txtCiudad.current.value && valestado === 1 && txtMunicipio.current && txtMunicipio.current.value) {
	      txtRifrespon.current.value = '';
	      txtNomrespon.current.value = '';
	      setIdclient('');
	      setParacliente('');
	      seleccionarClient();
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    if (txtMunicipio.current) {
	      var handleChange = function handleChange() {
	        if (valestado === 1) {
	          var idMunicipio = txtMunicipio.current.value;
	          if (idMunicipio) {
	            selectCiudad(idMunicipio, function () {
	              if (txtCiudad.current) {
	                txtCiudad.current.value = '';
	              }
	              txtRifrespon.current.value = '';
	              txtNomrespon.current.value = '';
	              setIdclient('');
	              setParacliente('');
	            });
	          }
	        }
	      };
	      txtMunicipio.current.addEventListener('change', handleChange);
	      return function () {
	        if (txtMunicipio.current) {
	          txtMunicipio.current.removeEventListener('change', handleChange);
	        }
	      };
	    }
	  }, [valestado, municipio]);
	
	  (0, _react.useEffect)(function () {
	    if (txtCiudad.current) {
	      var handleChange = function handleChange() {
	        if (valestado === 1 && txtCiudad.current.value && txtMunicipio.current && txtMunicipio.current.value) {
	          txtRifrespon.current.value = '';
	          txtNomrespon.current.value = '';
	          setIdclient('');
	          setParacliente('');
	          seleccionarClient();
	        }
	      };
	
	      txtCiudad.current.addEventListener('change', handleChange);
	      return function () {
	        if (txtCiudad.current) {
	          txtCiudad.current.removeEventListener('change', handleChange);
	        }
	      };
	    }
	  }, [valestado, ciudad]);
	
	  var onChekval = function onChekval(e) {
	
	    if (e.target.id === 'tipoalmacen') {
	      if (txtTodasFechas.current.checked === true) {
	        setInputalmacen(0);
	        setParafecha('');
	        setDesde('');
	        setHasta('');
	        txtDesde.current.value = '';
	        txtHasta.current.value = '';
	        if (txtTodosCliente.current.checked === true && txtTodosDispo.current.checked === true && txtTodosAlmacen.current.checked === true && txtTodosVendedores.current.checked === true && txtTodosEstados.current.checked === true) {
	          setValestado(0);
	          if (props.report === "reportenotaentrega") {
	            var tipo = 'NE';
	            var paran = 'n.tipo = ';
	            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
	            setTituloc('LISTADO DE NOTAS DE ENTREGA');
	            setTituid(tipo);
	          } else if (props.report === "reportenotadebitos") {
	            var _tipo = 'ND';
	            var _paran = 'n.tipo = ';
	            setReport("'" + _paran + "'" + "|| quote_literal(" + "'" + _tipo + "'" + ")");
	            setTituloc('LISTADO DE NOTAS DE DEBITO');
	            setTituid(_tipo);
	          } else if (props.report === "reporteobsequio") {
	            var _tipo2 = 'NO';
	            var _paran2 = 'n.tipo = ';
	            setReport("'" + _paran2 + "'" + "|| quote_literal(" + "'" + _tipo2 + "'" + ")");
	            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	          } else if (props.report === "reportepedidos") {
	            var _paran3 = 'and n.idcliente > 0';
	            setReport("'" + _paran3 + "'");
	            setTituid('PE');
	            setTituloc('LISTADO DE PEDIDOS GENERADOS');
	          } else if (props.report === "reportefacturas") {
	            setReport("'" + 'n.idfactura > 0 ' + "'");
	          }
	        } else {
	          if (props.report === "reportenotaentrega") {
	            var _tipo3 = 'NE';
	            var _paran4 = 'n.tipo = ';
	            setReport("'" + _paran4 + "'" + "|| quote_literal(" + "'" + _tipo3 + "'" + ") ||");
	            setTituloc('LISTADO DE NOTAS DE ENTREGA');
	            setTituid(_tipo3);
	          } else if (props.report === "reportenotadebitos") {
	            var _tipo4 = 'ND';
	            var _paran5 = 'n.tipo = ';
	            setReport("'" + _paran5 + "'" + "|| quote_literal(" + "'" + _tipo4 + "'" + ") ||");
	            setTituloc('LISTADO DE NOTAS DE DEBITO');
	            setTituid(_tipo4);
	          } else if (props.report === "reporteobsequio") {
	            var _tipo5 = 'NO';
	            var _paran6 = 'n.tipo = ';
	            setReport("'" + _paran6 + "'" + "|| quote_literal(" + "'" + _tipo5 + "'" + ") ||");
	            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	          } else if (props.report === "reportepedidos") {
	            setReport('');
	            setTituid('PE');
	            setTituloc('LISTADO DE PEDIDOS GENERADOS');
	          } else if (props.report === "reportefacturas") {
	            setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
	          }
	        }
	      } else if (txtPorFechas.current.checked === true) {
	        setInputalmacen(1);
	        setParafecha("'" + ' and n.fecha between ' + "'");
	        if (props.report === "reportenotaentrega") {
	          var _tipo6 = 'NE';
	          var _paran7 = 'n.tipo = ';
	          setReport("'" + _paran7 + "'" + "|| quote_literal(" + "'" + _tipo6 + "'" + ") ||");
	          setTituloc('LISTADO DE NOTAS DE ENTREGA');
	          setTituid(_tipo6);
	        } else if (props.report === "reportenotadebitos") {
	          var _tipo7 = 'ND';
	          var _paran8 = 'n.tipo = ';
	          setReport("'" + _paran8 + "'" + "|| quote_literal(" + "'" + _tipo7 + "'" + ") ||");
	          setTituloc('LISTADO DE NOTAS DE DEBITO');
	          setTituid(_tipo7);
	        } else if (props.report === "reporteobsequio") {
	          var _tipo8 = 'NO';
	          var _paran9 = 'n.tipo = ';
	          setReport("'" + _paran9 + "'" + "|| quote_literal(" + "'" + _tipo8 + "'" + ") ||");
	          setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	        } else if (props.report === "reportepedidos") {
	          setReport('');
	          setTituid('PE');
	          setTituloc('LISTADO DE PEDIDOS GENERADOS');
	        } else if (props.report === "reportefacturas") {
	          setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
	        }
	      }
	    } else if (e.target.id === 'tipodisponible') {
	      if (e.target.value === '1') {
	        setDisponiblec('');
	        if (txtTodosCliente.current.checked === true && txtTodasFechas.current.checked === true && txtTodosAlmacen.current.checked === true && txtTodosVendedores.current.checked === true && txtTodosEstados.current.checked === true) {
	          setValestado(0);
	          if (props.report === "reportenotaentrega") {
	            var _tipo9 = 'NE';
	            var _paran10 = 'n.tipo = ';
	            setReport("'" + _paran10 + "'" + "|| quote_literal(" + "'" + _tipo9 + "'" + ")");
	            setTituloc('LISTADO DE NOTAS DE ENTREGA');
	            setTituid(_tipo9);
	          } else if (props.report === "reportenotadebitos") {
	            var _tipo10 = 'ND';
	            var _paran11 = 'n.tipo = ';
	            setReport("'" + _paran11 + "'" + "|| quote_literal(" + "'" + _tipo10 + "'" + ")");
	            setTituloc('LISTADO DE NOTAS DE DEBITO');
	            setTituid(_tipo10);
	          } else if (props.report === "reporteobsequio") {
	            var _tipo11 = 'NO';
	            var _paran12 = 'n.tipo = ';
	            setReport("'" + _paran12 + "'" + "|| quote_literal(" + "'" + _tipo11 + "'" + ")");
	            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	          } else if (props.report === "reportepedidos") {
	            var _paran13 = 'and n.idcliente > 0';
	            setReport("'" + _paran13 + "'");
	            setTituid('PE');
	            setTituloc('LISTADO DE PEDIDOS GENERADOS');
	          } else if (props.report === "reportefacturas") {
	            setReport("'" + 'n.idfactura > 0 ' + "'");
	          }
	        } else {
	          if (props.report === "reportenotaentrega") {
	            var _tipo12 = 'NE';
	            var _paran14 = 'n.tipo = ';
	            setReport("'" + _paran14 + "'" + "|| quote_literal(" + "'" + _tipo12 + "'" + ") ||");
	            setTituloc('LISTADO DE NOTAS DE ENTREGA');
	            setTituid(_tipo12);
	          } else if (props.report === "reportenotadebitos") {
	            var _tipo13 = 'ND';
	            var _paran15 = 'n.tipo = ';
	            setReport("'" + _paran15 + "'" + "|| quote_literal(" + "'" + _tipo13 + "'" + ") ||");
	            setTituloc('LISTADO DE NOTAS DE DEBITO');
	            setTituid(_tipo13);
	          } else if (props.report === "reporteobsequio") {
	            var _tipo14 = 'NO';
	            var _paran16 = 'n.tipo = ';
	            setReport("'" + _paran16 + "'" + "|| quote_literal(" + "'" + _tipo14 + "'" + ") ||");
	            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	          } else if (props.report === "reportepedidos") {
	            setReport('');
	            setTituid('PE');
	            setTituloc('LISTADO DE PEDIDOS GENERADOS');
	          } else if (props.report === "reportefacturas") {
	            setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
	          }
	        }
	      } else if (e.target.value === '2') {
	        setValestado(0);
	        setDisponiblec("'" + ' and n.status = 1' + "'");
	        if (props.report === "reportenotaentrega") {
	          var _tipo15 = 'NE';
	          var _paran17 = 'n.tipo = ';
	          setReport("'" + _paran17 + "'" + "|| quote_literal(" + "'" + _tipo15 + "'" + ") ||");
	          setTituloc('LISTADO DE NOTAS DE ENTREGA');
	          setTituid(_tipo15);
	        } else if (props.report === "reportenotadebitos") {
	          var _tipo16 = 'ND';
	          var _paran18 = 'n.tipo = ';
	          setReport("'" + _paran18 + "'" + "|| quote_literal(" + "'" + _tipo16 + "'" + ") ||");
	          setTituloc('LISTADO DE NOTAS DE DEBITO');
	          setTituid(_tipo16);
	        } else if (props.report === "reporteobsequio") {
	          var _tipo17 = 'NO';
	          var _paran19 = 'n.tipo = ';
	          setReport("'" + _paran19 + "'" + "|| quote_literal(" + "'" + _tipo17 + "'" + ") ||");
	          setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	        } else if (props.report === "reportepedidos") {
	          setReport('');
	          setTituid('PE');
	          setTituloc('LISTADO DE PEDIDOS GENERADOS');
	        } else if (props.report === "reportefacturas") {
	          setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
	        }
	      } else if (e.target.value === '3') {
	        setDisponiblec("'" + ' and n.status = 0' + "'");
	        setValestado(0);
	        if (props.report === "reportenotaentrega") {
	          var _tipo18 = 'NE';
	          var _paran20 = 'n.tipo = ';
	          setReport("'" + _paran20 + "'" + "|| quote_literal(" + "'" + _tipo18 + "'" + ") ||");
	          setTituloc('LISTADO DE NOTAS DE ENTREGA');
	          setTituid(_tipo18);
	        } else if (props.report === "reportenotadebitos") {
	          var _tipo19 = 'ND';
	          var _paran21 = 'n.tipo = ';
	          setReport("'" + _paran21 + "'" + "|| quote_literal(" + "'" + _tipo19 + "'" + ") ||");
	          setTituloc('LISTADO DE NOTAS DE DEBITO');
	          setTituid(_tipo19);
	        } else if (props.report === "reporteobsequio") {
	          var _tipo20 = 'NO';
	          var _paran22 = 'n.tipo = ';
	          setReport("'" + _paran22 + "'" + "|| quote_literal(" + "'" + _tipo20 + "'" + ") ||");
	          setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	        } else if (props.report === "reportepedidos") {
	          setReport('');
	          setTituid('PE');
	          setTituloc('LISTADO DE PEDIDOS GENERADOS');
	        } else if (props.report === "reportefacturas") {
	          setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
	        }
	      } else if (e.target.value === '4') {
	        setValestado(0);
	        setDisponiblec("'" + ' and n.status = 4' + "'");
	        if (props.report === "reportenotaentrega") {
	          var _tipo21 = 'NE';
	          var _paran23 = 'n.tipo = ';
	          setReport("'" + _paran23 + "'" + "|| quote_literal(" + "'" + _tipo21 + "'" + ") ||");
	          setTituloc('LISTADO DE NOTAS DE ENTREGA');
	          setTituid(_tipo21);
	        } else if (props.report === "reportenotadebitos") {
	          var _tipo22 = 'ND';
	          var _paran24 = 'n.tipo = ';
	          setReport("'" + _paran24 + "'" + "|| quote_literal(" + "'" + _tipo22 + "'" + ") ||");
	          setTituloc('LISTADO DE NOTAS DE DEBITO');
	          setTituid(_tipo22);
	        } else if (props.report === "reporteobsequio") {
	          var _tipo23 = 'NO';
	          var _paran25 = 'n.tipo = ';
	          setReport("'" + _paran25 + "'" + "|| quote_literal(" + "'" + _tipo23 + "'" + ") ||");
	          setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	        } else if (props.report === "reportepedidos") {
	          setReport('');
	          setTituid('PE');
	          setTituloc('LISTADO DE PEDIDOS GENERADOS');
	        } else if (props.report === "reportefacturas") {
	          setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
	        }
	      }
	    } else if (e.target.id === 'cliente') {
	      if (txtTodosCliente.current.checked === true) {
	        setInputproducto(0);
	        setParacliente('');
	        setIdclient('');
	        setValestado(0);
	        txtNomrespon.current.value = '';
	        txtCbmrif.current.value = '';
	        txtRifrespon.current.value = '';
	        if (txtTodasFechas.current.checked === true && txtTodosDispo.current.checked === true && txtTodosAlmacen.current.checked === true && txtTodosVendedores.current.value === true) {
	          if (props.report === "reportenotaentrega") {
	            var _tipo24 = 'NE';
	            var _paran26 = 'n.tipo = ';
	            setReport("'" + _paran26 + "'" + "|| quote_literal(" + "'" + _tipo24 + "'" + ")");
	            setTituloc('LISTADO DE NOTAS DE ENTREGA');
	            setTituid(_tipo24);
	          } else if (props.report === "reportenotadebitos") {
	            var _tipo25 = 'ND';
	            var _paran27 = 'n.tipo = ';
	            setReport("'" + _paran27 + "'" + "|| quote_literal(" + "'" + _tipo25 + "'" + ")");
	            setTituloc('LISTADO DE NOTAS DE DEBITO');
	            setTituid(_tipo25);
	          } else if (props.report === "reporteobsequio") {
	            var _tipo26 = 'NO';
	            var _paran28 = 'n.tipo = ';
	            setReport("'" + _paran28 + "'" + "|| quote_literal(" + "'" + _tipo26 + "'" + ")");
	            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	          } else if (props.report === "reportepedidos") {
	            var _paran29 = 'and n.idcliente > 0';
	            setReport("'" + _paran29 + "'");
	            setTituid('PE');
	            setTituloc('LISTADO DE PEDIDOS GENERADOS');
	          } else if (props.report === "reportefacturas") {
	            setReport("'" + 'n.idfactura > 0 ' + "'");
	          }
	        } else {
	          if (props.report === "reportenotaentrega") {
	            var _tipo27 = 'NE';
	            var _paran30 = 'n.tipo = ';
	            setReport("'" + _paran30 + "'" + "|| quote_literal(" + "'" + _tipo27 + "'" + ") ||");
	            setTituloc('LISTADO DE NOTAS DE ENTREGA');
	            setTituid(_tipo27);
	          } else if (props.report === "reportenotadebitos") {
	            var _tipo28 = 'ND';
	            var _paran31 = 'n.tipo = ';
	            setReport("'" + _paran31 + "'" + "|| quote_literal(" + "'" + _tipo28 + "'" + ") ||");
	            setTituloc('LISTADO DE NOTAS DE DEBITO');
	            setTituid(_tipo28);
	          } else if (props.report === "reporteobsequio") {
	            var _tipo29 = 'NO';
	            var _paran32 = 'n.tipo = ';
	            setReport("'" + _paran32 + "'" + "|| quote_literal(" + "'" + _tipo29 + "'" + ") ||");
	            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	          } else if (props.report === "reportepedidos") {
	            setReport('');
	            setTituid('PE');
	            setTituloc('LISTADO DE PEDIDOS GENERADOS');
	          } else if (props.report === "reportefacturas") {
	            setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
	          }
	        }
	      } else if (txtPorCliente.current.checked === true) {
	        setInputproducto(1);
	        setParacliente("'" + ' and n.cedularif =' + "'");
	        setValestado(0);
	        if (props.report === "reportenotaentrega") {
	          var _tipo30 = 'NE';
	          var _paran33 = 'n.tipo = ';
	          setReport("'" + _paran33 + "'" + "|| quote_literal(" + "'" + _tipo30 + "'" + ") ||");
	          setTituloc('LISTADO DE NOTAS DE ENTREGA');
	          setTituid(_tipo30);
	        } else if (props.report === "reportenotadebitos") {
	          var _tipo31 = 'ND';
	          var _paran34 = 'n.tipo = ';
	          setReport("'" + _paran34 + "'" + "|| quote_literal(" + "'" + _tipo31 + "'" + ") ||");
	          setTituloc('LISTADO DE NOTAS DE DEBITO');
	          setTituid(_tipo31);
	        } else if (props.report === "reporteobsequio") {
	          var _tipo32 = 'NO';
	          var _paran35 = 'n.tipo = ';
	          setReport("'" + _paran35 + "'" + "|| quote_literal(" + "'" + _tipo32 + "'" + ") ||");
	          setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	        } else if (props.report === "reportepedidos") {
	          setReport('');
	          setTituid('PE');
	          setTituloc('LISTADO DE PEDIDOS GENERADOS');
	        } else if (props.report === "reportefacturas") {
	          setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
	        }
	      }
	    } else if (e.target.id === 'alamcen') {
	      if (txtTodosAlmacen.current.checked === true) {
	        setValestado(0);
	        txtCodigoAlmacen.current.value = '';
	        txtNombreAlmacen.current.value = '';
	        if (props.report === "reporteobsequio") {
	          if (txtTodasFechas.current.checked === true && txtTodosCliente.current.checked === true && txtTodosVendedores.current.checked === true && txtTodosEstados.current.checked === true) {
	            setValestado(0);
	            if (props.report === "reportenotaentrega") {
	              var _tipo33 = 'NE';
	              var _paran36 = 'n.tipo = ';
	              setReport("'" + _paran36 + "'" + "|| quote_literal(" + "'" + _tipo33 + "'" + ")");
	              setTituloc('LISTADO DE NOTAS DE ENTREGA');
	              setTituid(_tipo33);
	            } else if (props.report === "reportenotadebitos") {
	              var _tipo34 = 'ND';
	              var _paran37 = 'n.tipo = ';
	              setReport("'" + _paran37 + "'" + "|| quote_literal(" + "'" + _tipo34 + "'" + ")");
	              setTituloc('LISTADO DE NOTAS DE DEBITO');
	              setTituid(_tipo34);
	            } else if (props.report === "reporteobsequio") {
	              var _tipo35 = 'NO';
	              var _paran38 = 'n.tipo = ';
	              setReport("'" + _paran38 + "'" + "|| quote_literal(" + "'" + _tipo35 + "'" + ")");
	              setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	            } else if (props.report === "reportepedidos") {
	              var _paran39 = 'and n.idcliente > 0';
	              setReport("'" + _paran39 + "'");
	              setTituid('PE');
	              setTituloc('LISTADO DE PEDIDOS GENERADOS');
	            } else if (props.report === "reportefacturas") {
	              setReport("'" + 'n.idfactura > 0 ' + "'");
	            }
	          } else {
	            if (props.report === "reportenotaentrega") {
	              var _tipo36 = 'NE';
	              var _paran40 = 'n.tipo = ';
	              setReport("'" + _paran40 + "'" + "|| quote_literal(" + "'" + _tipo36 + "'" + ") ||");
	              setTituloc('LISTADO DE NOTAS DE ENTREGA');
	              setTituid(_tipo36);
	            } else if (props.report === "reportenotadebitos") {
	              var _tipo37 = 'ND';
	              var _paran41 = 'n.tipo = ';
	              setReport("'" + _paran41 + "'" + "|| quote_literal(" + "'" + _tipo37 + "'" + ") ||");
	              setTituloc('LISTADO DE NOTAS DE DEBITO');
	              setTituid(_tipo37);
	            } else if (props.report === "reporteobsequio") {
	              var _tipo38 = 'NO';
	              var _paran42 = 'n.tipo = ';
	              setReport("'" + _paran42 + "'" + "|| quote_literal(" + "'" + _tipo38 + "'" + ") ||");
	              setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	            } else if (props.report === "reportepedidos") {
	              setReport('');
	              setTituid('PE');
	              setTituloc('LISTADO DE PEDIDOS GENERADOS');
	            } else if (props.report === "reportefacturas") {
	              setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
	            }
	          }
	        } else {
	          if (txtTodasFechas.current.checked === true && txtTodosDispo.current.checked === true && txtTodosCliente.current.checked === true && txtTodosVendedores.current.checked === true && txtTodosEstados.current.checked === true) {
	            if (props.report === "reportenotaentrega") {
	              var _tipo39 = 'NE';
	              var _paran43 = 'n.tipo = ';
	              setReport("'" + _paran43 + "'" + "|| quote_literal(" + "'" + _tipo39 + "'" + ")");
	              setTituloc('LISTADO DE NOTAS DE ENTREGA');
	              setTituid(_tipo39);
	            } else if (props.report === "reportenotadebitos") {
	              var _tipo40 = 'ND';
	              var _paran44 = 'n.tipo = ';
	              setReport("'" + _paran44 + "'" + "|| quote_literal(" + "'" + _tipo40 + "'" + ")");
	              setTituloc('LISTADO DE NOTAS DE DEBITO');
	              setTituid(_tipo40);
	            } else if (props.report === "reporteobsequio") {
	              var _tipo41 = 'NO';
	              var _paran45 = 'n.tipo = ';
	              setReport("'" + _paran45 + "'" + "|| quote_literal(" + "'" + _tipo41 + "'" + ")");
	              setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	            } else if (props.report === "reportepedidos") {
	              var _paran46 = 'and n.idcliente > 0';
	              setReport("'" + _paran46 + "'");
	              setTituid('PE');
	              setTituloc('LISTADO DE PEDIDOS GENERADOS');
	            } else if (props.report === "reportefacturas") {
	              setReport("'" + 'n.idfactura > 0 ' + "'");
	            }
	          } else {
	            if (props.report === "reportenotaentrega") {
	              var _tipo42 = 'NE';
	              var _paran47 = 'n.tipo = ';
	              setReport("'" + _paran47 + "'" + "|| quote_literal(" + "'" + _tipo42 + "'" + ") ||");
	              setTituloc('LISTADO DE NOTAS DE ENTREGA');
	              setTituid(_tipo42);
	            } else if (props.report === "reportenotadebitos") {
	              var _tipo43 = 'ND';
	              var _paran48 = 'n.tipo = ';
	              setReport("'" + _paran48 + "'" + "|| quote_literal(" + "'" + _tipo43 + "'" + ") ||");
	              setTituloc('LISTADO DE NOTAS DE DEBITO');
	              setTituid(_tipo43);
	            } else if (props.report === "reporteobsequio") {
	              var _tipo44 = 'NO';
	              var _paran49 = 'n.tipo = ';
	              setReport("'" + _paran49 + "'" + "|| quote_literal(" + "'" + _tipo44 + "'" + ") ||");
	              setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	            } else if (props.report === "reportepedidos") {
	              setReport('');
	              setTituid('PE');
	              setTituloc('LISTADO DE PEDIDOS GENERADOS');
	            } else if (props.report === "reportefacturas") {
	              setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
	            }
	          }
	        }
	      } else if (txtPorAlmacen.current.checked === true) {
	        setValalmacen(1);
	        if (props.report === "reportenotaentrega") {
	          var _tipo45 = 'NE';
	          var _paran50 = 'n.tipo = ';
	          setReport("'" + _paran50 + "'" + "|| quote_literal(" + "'" + _tipo45 + "'" + ") ||");
	          setTituloc('LISTADO DE NOTAS DE ENTREGA');
	          setTituid(_tipo45);
	        } else if (props.report === "reportenotadebitos") {
	          var _tipo46 = 'ND';
	          var _paran51 = 'n.tipo = ';
	          setReport("'" + _paran51 + "'" + "|| quote_literal(" + "'" + _tipo46 + "'" + ") ||");
	          setTituloc('LISTADO DE NOTAS DE DEBITO');
	          setTituid(_tipo46);
	        } else if (props.report === "reporteobsequio") {
	          var _tipo47 = 'NO';
	          var _paran52 = 'n.tipo = ';
	          setReport("'" + _paran52 + "'" + "|| quote_literal(" + "'" + _tipo47 + "'" + ") ||");
	          setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	        } else if (props.report === "reportepedidos") {
	          setReport('');
	          setTituid('PE');
	          setTituloc('LISTADO DE PEDIDOS GENERADOS');
	        } else if (props.report === "reportefacturas") {
	          setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
	        }
	      }
	    } else if (e.target.id === 'vendedor') {
	      if (txtTodosVendedores.current.checked === true) {
	        setValvende(0);
	        setIdvendedr('');
	        txtCbmrifVende.current.value = '';
	        txtNomVende.current.value = '';
	        txtRifVende.current.value = '';
	        if (txtTodasFechas.current.checked === true && txtTodosDispo.current.checked === true && txtTodosAlmacen.current.checked === true && txtTodosCliente.current.checked === true && txtTodosEstados.current.checked === true) {
	          setValestado(0);
	          if (props.report === "reportenotaentrega") {
	            var _tipo48 = 'NE';
	            var _paran53 = 'n.tipo = ';
	            setReport("'" + _paran53 + "'" + "|| quote_literal(" + "'" + _tipo48 + "'" + ")");
	            setTituloc('LISTADO DE NOTAS DE ENTREGA');
	            setTituid(_tipo48);
	          } else if (props.report === "reportenotadebitos") {
	            var _tipo49 = 'ND';
	            var _paran54 = 'n.tipo = ';
	            setReport("'" + _paran54 + "'" + "|| quote_literal(" + "'" + _tipo49 + "'" + ")");
	            setTituloc('LISTADO DE NOTAS DE DEBITO');
	            setTituid(_tipo49);
	          } else if (props.report === "reporteobsequio") {
	            var _tipo50 = 'NO';
	            var _paran55 = 'n.tipo = ';
	            setReport("'" + _paran55 + "'" + "|| quote_literal(" + "'" + _tipo50 + "'" + ")");
	            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	          } else if (props.report === "reportepedidos") {
	            var _paran56 = 'and n.idcliente > 0';
	            setReport("'" + _paran56 + "'");
	            setTituid('PE');
	            setTituloc('LISTADO DE PEDIDOS GENERADOS');
	          } else if (props.report === "reportefacturas") {
	            setReport("'" + 'n.idfactura > 0 ' + "'");
	          }
	        } else {
	          if (props.report === "reportenotaentrega") {
	            var _tipo51 = 'NE';
	            var _paran57 = 'n.tipo = ';
	            setReport("'" + _paran57 + "'" + "|| quote_literal(" + "'" + _tipo51 + "'" + ") ||");
	            setTituloc('LISTADO DE NOTAS DE ENTREGA');
	            setTituid(_tipo51);
	          } else if (props.report === "reportenotadebitos") {
	            var _tipo52 = 'ND';
	            var _paran58 = 'n.tipo = ';
	            setReport("'" + _paran58 + "'" + "|| quote_literal(" + "'" + _tipo52 + "'" + ") ||");
	            setTituloc('LISTADO DE NOTAS DE DEBITO');
	            setTituid(_tipo52);
	          } else if (props.report === "reporteobsequio") {
	            var _tipo53 = 'NO';
	            var _paran59 = 'n.tipo = ';
	            setReport("'" + _paran59 + "'" + "|| quote_literal(" + "'" + _tipo53 + "'" + ") ||");
	            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	          } else if (props.report === "reportepedidos") {
	            setReport('');
	            setTituid('PE');
	            setTituloc('LISTADO DE PEDIDOS GENERADOS');
	          } else if (props.report === "reportefacturas") {
	            setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
	          }
	        }
	      } else if (txtPorVendedor.current.checked === true) {
	        setValvende(1);
	        if (props.report === "reportenotaentrega") {
	          var _tipo54 = 'NE';
	          var _paran60 = 'n.tipo = ';
	          setReport("'" + _paran60 + "'" + "|| quote_literal(" + "'" + _tipo54 + "'" + ") ||");
	          setTituloc('LISTADO DE NOTAS DE ENTREGA');
	          setTituid(_tipo54);
	        } else if (props.report === "reportenotadebitos") {
	          var _tipo55 = 'ND';
	          var _paran61 = 'n.tipo = ';
	          setReport("'" + _paran61 + "'" + "|| quote_literal(" + "'" + _tipo55 + "'" + ") ||");
	          setTituloc('LISTADO DE NOTAS DE DEBITO');
	          setTituid(_tipo55);
	        } else if (props.report === "reporteobsequio") {
	          var _tipo56 = 'NO';
	          var _paran62 = 'n.tipo = ';
	          setReport("'" + _paran62 + "'" + "|| quote_literal(" + "'" + _tipo56 + "'" + ") ||");
	          setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	        } else if (props.report === "reportepedidos") {
	          setReport('');
	          setTituid('PE');
	          setTituloc('LISTADO DE PEDIDOS GENERADOS');
	        } else if (props.report === "reportefacturas") {
	          setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
	        }
	      }
	    } else if (e.target.name === 'estado') {
	      if (txtTodosEstados.current.checked === true) {
	        setValestado(0);
	        setParacliente('');
	        if (txtTodasFechas.current.checked === true && txtTodosDispo.current.checked === true && txtTodosAlmacen.current.checked === true && txtTodosVendedores.current.checked === true && txtTodosCliente.current.checked === true) {
	          setInputproducto(0);
	          if (txtMunicipio.current) txtMunicipio.current.value = '';
	          if (txtCiudad.current) txtCiudad.current.value = '';
	          setCiudad([]);
	          if (props.report === "reportenotaentrega") {
	            var _tipo57 = 'NE';
	            var _paran63 = 'n.tipo = ';
	            setReport("'" + _paran63 + "'" + "|| quote_literal(" + "'" + _tipo57 + "'" + ")");
	            setTituloc('LISTADO DE NOTAS DE ENTREGA');
	            setTituid(_tipo57);
	          } else if (props.report === "reportenotadebitos") {
	            var _tipo58 = 'ND';
	            var _paran64 = 'n.tipo = ';
	            setReport("'" + _paran64 + "'" + "|| quote_literal(" + "'" + _tipo58 + "'" + ")");
	            setTituloc('LISTADO DE NOTAS DE DEBITO');
	            setTituid(_tipo58);
	          } else if (props.report === "reporteobsequio") {
	            var _tipo59 = 'NO';
	            var _paran65 = 'n.tipo = ';
	            setReport("'" + _paran65 + "'" + "|| quote_literal(" + "'" + _tipo59 + "'" + ")");
	            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	          } else if (props.report === "reportepedidos") {
	            var _paran66 = 'and n.idcliente > 0';
	            setReport("'" + _paran66 + "'");
	            setTituid('PE');
	            setTituloc('LISTADO DE PEDIDOS GENERADOS');
	          } else if (props.report === "reportefacturas") {
	            setReport("'" + 'n.idfactura > 0 ' + "'");
	          }
	        } else {
	          if (props.report === "reportenotaentrega") {
	            var _tipo60 = 'NE';
	            var _paran67 = 'n.tipo = ';
	            setReport("'" + _paran67 + "'" + "|| quote_literal(" + "'" + _tipo60 + "'" + ") ||");
	            setTituloc('LISTADO DE NOTAS DE ENTREGA');
	            setTituid(_tipo60);
	          } else if (props.report === "reportenotadebitos") {
	            var _tipo61 = 'ND';
	            var _paran68 = 'n.tipo = ';
	            setReport("'" + _paran68 + "'" + "|| quote_literal(" + "'" + _tipo61 + "'" + ") ||");
	            setTituloc('LISTADO DE NOTAS DE DEBITO');
	            setTituid(_tipo61);
	          } else if (props.report === "reporteobsequio") {
	            var _tipo62 = 'NO';
	            var _paran69 = 'n.tipo = ';
	            setReport("'" + _paran69 + "'" + "|| quote_literal(" + "'" + _tipo62 + "'" + ") ||");
	            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	          } else if (props.report === "reportepedidos") {
	            setReport('');
	            setTituid('PE');
	            setTituloc('LISTADO DE PEDIDOS GENERADOS');
	          } else if (props.report === "reportefacturas") {
	            setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
	          }
	        }
	      } else if (txtPorEstados.current.checked === true) {
	        setValestado(1);
	        setInputproducto(0);
	        txtRifrespon.current.value = '';
	        txtNomrespon.current.value = '';
	        setParacliente('');
	        setIdclient('');
	        seleccionarClient();
	        if (props.report === "reportenotaentrega") {
	          var _tipo63 = 'NE';
	          var _paran70 = 'n.tipo = ';
	          setReport("'" + _paran70 + "'" + "|| quote_literal(" + "'" + _tipo63 + "'" + ") ||");
	          setTituloc('LISTADO DE NOTAS DE ENTREGA');
	          setTituid(_tipo63);
	        } else if (props.report === "reportenotadebitos") {
	          var _tipo64 = 'ND';
	          var _paran71 = 'n.tipo = ';
	          setReport("'" + _paran71 + "'" + "|| quote_literal(" + "'" + _tipo64 + "'" + ") ||");
	          setTituloc('LISTADO DE NOTAS DE DEBITO');
	          setTituid(_tipo64);
	        } else if (props.report === "reporteobsequio") {
	          var _tipo65 = 'NO';
	          var _paran72 = 'n.tipo = ';
	          setReport("'" + _paran72 + "'" + "|| quote_literal(" + "'" + _tipo65 + "'" + ") ||");
	          setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	        } else if (props.report === "reportepedidos") {
	          setReport('');
	          setTituid('PE');
	          setTituloc('LISTADO DE PEDIDOS GENERADOS');
	        } else if (props.report === "reportefacturas") {
	          setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
	        }
	      }
	    }
	  };
	
	  var imprimirGeneral = function imprimirGeneral() {
	
	    var parameters = void 0;
	    var validacion = "";
	    var validados = "";
	    var validates = "";
	    var validauno = "";
	    var validacuatro = "";
	    var valstd = paracliente !== '' ? 1 : 0;
	    var valst = valvende && valalmacen !== '' ? 1 : paracliente !== '' ? 1 : 0;
	
	    var almacen = "";
	    if (valalmacen === 1) {
	      if (props.report !== 'reportenotadebitos') {
	        almacen = "'" + 'and n.idalmacen = ' + idalmacen + "'";
	      } else {
	        almacen = '';
	      }
	    } else {
	      almacen = '';
	    }
	
	    if (inputalmacen === 1) {
	      parameters = "|| quote_literal(" + desde + ") ||" + "'" + ' and ' + "'" + "|| quote_literal(" + hasta + ")";
	      validacion = disponiblec || almacen || idclient || idvendedr !== '' ? '||' : '';
	    } else {
	      parameters = '';
	      validacion = '';
	    }
	
	    if (inputproducto === 1) {
	      validates = paracliente !== '' ? '||' : '';
	    } else if (valestado === 1) {
	      validates = valstd === 1 && valst !== 0 && parameters.length > 0 ? '||' : '';
	    } else {
	      validates = '';
	    }
	
	    if (valvende === 1) {
	      validacuatro = paracliente && idclient !== '' ? '||' : '';
	    } else {
	      validacuatro = '';
	    }
	
	    if (props.report !== "reporteobsequio") {
	
	      if (txtTodosDispo.current.checked === true) {
	        validados = '';
	      } else {
	        validados = disponiblec && almacen !== '' || disponiblec && paracliente !== '' || idvendedr !== '' ? '||' : '';
	      }
	
	      if (props.report !== 'reportenotadebitos') {
	        if (txtTodosAlmacen.current.checked === true) {
	          validauno = '';
	        } else {
	          validauno = idvendedr || almacen && paracliente !== '' ? '||' : '';
	        }
	      }
	    }
	
	    var reporte = "";
	    var numtabla = "";
	
	    if (props.report === "reportenotaentrega" || props.report === "reportepedidos") {
	
	      if (txtChekGeneral.current.checked === true) {
	        reporte = "ReporteNEntregaGeneral";
	      } else {
	        reporte = "ReporteDebitos";
	      }
	
	      if (props.report === "reportenotaentrega") {
	        numtabla = 'n.numnotaentrega';
	      } else {
	        numtabla = 'n.numpedido';
	      }
	    } else if (props.report === "reporteobsequio") {
	      reporte = "ReporteObsequioDonacion";
	    } else if (props.report === 'reportefacturas') {
	      reporte = "ReporteFacturasDos";
	      numtabla = 'n.numfactura';
	    } else if (props.report === 'reportenotadebitos') {
	      reporte = "ReporteDebitosDos";
	      numtabla = 'n.numnotaentrega';
	    }
	
	    var condi = valestado !== 1 ? report + disponiblec + validados + almacen + validauno + paracliente + validates + idclient + validacuatro + idvendedr + validacion + parafecha + parameters : report + disponiblec + validados + almacen + validauno + paracliente + validates + validacuatro + idvendedr + validacion + parafecha + parameters;
	    var orden = txtChekGeneral.current.checked === true ? "n.idcliente, n.fecha" : txtOrden.current.value === '1' ? ordens + ", " + numtabla : ordens + ", " + numtabla + ", " + txtOrden.current.value;
	
	    var ope = 0;
	    if (props.report === "reportenotaentrega" || props.report === 'reportenotadebitos') {
	      if (txtChekGeneral.current.checked === true) {
	        ope = 2;
	      } else {
	        ope = 1;
	      }
	    } else if (props.report === "reportepedidos") {
	      ope = 2;
	    } else if (props.report === "reportefacturas") {
	      ope = 3;
	    } else if (props.report === "reporteobsequio") {
	      ope = 1;
	    }
	    window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&condicion=" + condi + "&titulo=" + tituloc + "&tiid=" + tituid + "&orden=" + orden + "&ope=" + ope, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    if (props.llamado === 2) {
	      props.onHideRenderizar();
	      props.onHideCancela();
	    }
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var seleccionarClient = function seleccionarClient() {
	
	    var campos = 'idagente';
	    var nomtab = 'agente';
	    var condi = "cliente = true and municipio = '" + txtMunicipio.current.value + "'" + " and ciudad = '" + txtCiudad.current.value + "'";
	    var orden = 'idagente';
	
	    var endpoint = op.conexion + '/api/consulta/selecionarregistrocondi?&campos=' + campos + '&nomtab=' + nomtab + '&condi=' + condi + '&orden=' + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        'x-access-token': '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var ids = [];
	          for (var i = 0; i < response.data.length; i++) {
	            ids.push(parseInt(response.data[i].idagente));
	          }
	          setParacliente("'" + ' and n.idcliente in(' + ids + ')' + "'");
	          setIdsc(ids);
	        }
	      } else {}
	    }).catch(function (error) {
	      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var handleAceptaCliente = function handleAceptaCliente(values) {
	    setMostrar1(false);
	    if (clientvende === 'cliente') {
	      txtCbmrif.current.value = values.rif.substring(0, 1);
	      txtRifrespon.current.value = values.rif.substring(2, 9);
	      txtNomrespon.current.value = values.nombre;
	      selectResponsable(values.rif);
	      if (txtPorEstados.current.checked) {} else {
	        setIdclient("quoete_literal(" + "'" + values.rif + "'" + ")");
	      }
	    } else if (clientvende === 'vendedor') {
	      txtCbmrifVende.current.value = values.rif.substring(0, 1);
	      txtRifVende.current.value = values.rif.substring(2, 9);
	      txtNomVende.current.value = values.nombre;
	      selectResponsable(values.rif);
	      setIdvendedr("'" + 'n.idvendedor = ' + values.idagente + "'");
	    }
	  };
	
	  var catalogoProductoc = function catalogoProductoc(ope) {
	    return function (e) {
	      e.preventDefault();
	      if (ope === 1) {
	        setClientvende('cliente');
	        setMostrar1(true);
	      } else {
	        setClientvende('vendedor');
	        setMostrar1(true);
	      }
	    };
	  };
	
	  var handleAceptaAlmacen = function handleAceptaAlmacen(values) {
	    setMostrar2(false);
	    txtNombreAlmacen.current.value = values.descripcion;
	    txtCodigoAlmacen.current.value = values.idalmacen;
	    setIdalmacen(values.idalmacen);
	  };
	
	  var selectResponsable = function selectResponsable(id) {
	
	    var campos = '*';
	    var nomtab = 'agente';
	    var nomid = 'rif';
	    var nomid2 = clientvende;
	    var endpoint = op.conexion + '/api/consulta/modeli2?campos=' + campos + '&nomtab=' + nomtab + '&nomid=' + nomid + '&id=' + id + '&nomid2=' + nomid2 + '&id2=true';
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idagente > 0) {
	          if (clientvende === 'cliente') {
	            txtNomrespon.current.value = response.data.nombre;
	            setIdclient("quote_literal(" + "'" + response.data.rif + "'" + ")");
	            btnAcepta.current.focus();
	          } else {
	            txtNomVende.current.value = response.data.nombre;
	            setIdvendedr("'" + ' and n.idvendedor = ' + response.data.idagente + "'");
	            btnAcepta.current.focus();
	          }
	        } else {
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ RIF y/o Cliente no Registrado !', icono: 'informacion' });
	          txtRifrespon.current.value = '';
	          txtNomrespon.current.value = '';
	          txtRifVende.current.value = '';
	          txtNomVende.current.value = '';
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'nci') {
	      setTipofic(e.target.value);
	    } else if (e.target.name === 'desde') {
	      if (e.target.value > (0, _moment2.default)(fechasistema).format('YYYY-MM-DD')) {
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !', icono: 'informacion' });
	        txtDesde.current.value = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	        txtDesde.current.focus();
	      } else {
	        setDesde("'" + (0, _moment2.default)(e.target.value).format('DD-MM-YYYY') + "'");
	      }
	    } else if (e.target.name === 'hasta') {
	      setHasta("'" + (0, _moment2.default)(e.target.value).format('DD-MM-YYYY') + "'");
	    }
	  };
	
	  var handleCliente = function handleCliente(e) {
	    e.preventDefault();
	    if (e.which === 13 || typeof e.which === 'undefined') {
	      if (e.target.value !== '') {
	        selectResponsable(tiporif + e.target.value);
	      }
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.op === 1) {
	
	          if (props.report === "reportenotaentrega") {
	            var tipo = 'NE';
	            var paran = 'n.tipo = ';
	            setTipon(tipo);
	            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
	            setTituloc('LISTADO DE NOTAS DE ENTREGA');
	            setTituid(tipo);
	          } else if (props.report === "reportenotadebitos") {
	            var _tipo66 = 'ND';
	            var _paran73 = 'n.tipo = ';
	            setTipon(_tipo66);
	            setReport("'" + _paran73 + "'" + "|| quote_literal(" + "'" + _tipo66 + "'" + ")");
	            setTituloc('LISTADO DE NOTAS DE DEBITO');
	            setTituid(_tipo66);
	          } else if (props.report === "reporteobsequio") {
	            var _tipo67 = 'NO';
	            var _paran74 = 'n.tipo = ';
	            setTipon(_tipo67);
	            setReport("'" + _paran74 + "'" + "|| quote_literal(" + "'" + _tipo67 + "'" + ")");
	            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
	          } else if (props.report === "reportepedidos") {
	            var _paran75 = 'and n.idcliente > 0';
	            setReport("'" + _paran75 + "'");
	            setTituid('PE');
	            setTipon('PE');
	            setTituloc('LISTADO DE PEDIDOS GENERADOS');
	          } else if (props.report === "reportefacturas") {
	            var _paran76 = 'n.idfactura > 0';
	            setReport("'" + _paran76 + "'");
	          }
	
	          seleccionarRegistro(afiliado);
	          setValestado(0);
	          txtTodosEstados.current.checked = true;
	          txtPorEstados.current.checked = false;
	
	          if (props.report !== "reporteobsequio") {
	            txtTodosDispo.current.checked = true;
	            txtCanceladas.current.checked = false;
	            txtDeudas.current.checked = false;
	          }
	
	          txtTodasFechas.current.checked = true;
	          txtTodosCliente.current.checked = true;
	          txtTodosVendedores.current.checked = true;
	
	          if (props.report !== "reportenotadebitos") {
	            txtTodosAlmacen.current.checked = true;
	            txtPorAlmacen.current.checked = false;
	          }
	
	          setParacliente('');
	          setDisponiblec('');
	          setParafecha('');
	          setDesde('');
	          setHasta('');
	          setTipofic('V');
	          setOrdens('n.fecha');
	          txtPorFechas.current.checked = false;
	          txtPorCliente.current.checked = false;
	          txtPorVendedor.current.checked = false;
	          setHabilitado(false);
	        } else {
	
	          if (props.report !== "reporteobsequio") {
	            txtTodosDispo.current.checked = false;
	            txtCanceladas.current.checked = false;
	            txtDeudas.current.checked = false;
	          }
	
	          txtTodasFechas.current.checked = false;
	          txtTodosCliente.current.checked = false;
	
	          txtPorCliente.current.checked = false;
	          txtPorFechas.current.checked = false;
	
	          txtTodosAlmacen.current.checked = false;
	          txtPorAlmacen.current.checked = false;
	
	          txtTodosVendedores.current.checked = false;
	          txtPorVendedor.current.checked = false;
	
	          setHabilitado(true);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          props.report === 'reportefacturas' ? 'Imprimir Facturas' : props.report === "reportenotaentrega" ? 'Imprimir Notas de Entrega' : props.report === 'reportenotadebitos' ? 'Imprimir Notas de Debito' : props.report === 'reportepedidos' ? 'Imprimir Pedidos' : 'Imprimir Obsequio/Donación'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto' },
	          props.report === "reportenotaentrega" ? _react2.default.createElement(
	            'div',
	            { className: 'colfull col-pd-100 px-1 ml-auto' },
	            _react2.default.createElement(
	              'div',
	              { className: 'form-check' },
	              _react2.default.createElement('input', { className: 'form-check-input', name: 'general', ref: txtChekGeneral, onChange: onChekval, type: 'checkbox', value: '', id: 'flexCheckChecked' }),
	              _react2.default.createElement(
	                'label',
	                { className: 'form-check-label', 'for': 'flexCheckChecked' },
	                'GENERAL'
	              )
	            )
	          ) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('input', { type: 'hidden', ref: txtChekGeneral, value: false })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: '' + (props.report === "reportenotaentrega" ? "colfull col-pd-300 px-3" : "colfull col-pd-300 px-3 ml-auto") },
	            _react2.default.createElement(
	              'div',
	              { className: 'input-group input-group-sm' },
	              _react2.default.createElement(
	                'label',
	                {
	                  className: 'input-group-text',
	                  id: 'inputGroup-sizing-sm'
	                },
	                'ORDENAR POR:'
	              ),
	              _react2.default.createElement(
	                'select',
	                {
	                  className: 'form-control form-control-sm form-select fs-6 fw-bold',
	                  ref: txtOrden,
	                  name: 'orden'
	                  /* onChange={onChekval} */
	
	                },
	                _react2.default.createElement(
	                  'option',
	                  { value: '1' },
	                  'FECHA'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: 'l.idagente' },
	                  'CLIENTES'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: 'n.idvendedor' },
	                  'VENDEDOR'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Fecha:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipoalmacen', value: '1', ref: txtTodasFechas, onChange: onChekval, id: 'tipoalmacen', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRadi1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipoalmacen', value: '2', ref: txtPorFechas, onChange: onChekval, id: 'tipoalmacen', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRadi2' },
	                  'Por Fecha'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-7 row m-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'DESDE:'
	                  ),
	                  _react2.default.createElement('input', { type: 'date', ref: txtDesde, disabled: inputalmacen === 0 ? true : false, name: 'desde', onChange: onChange, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-6' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'HASTA:'
	                  ),
	                  _react2.default.createElement('input', { type: 'date', ref: txtHasta, disabled: inputalmacen === 0 ? true : false, name: 'hasta', onChange: onChange, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            )
	          ),
	          props.report !== "reporteobsequio" ? _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 d-flex justify-content-center border-azul rounded mb-1 mx-auto' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Estatus del Pago:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '1', ref: txtTodosDispo, onChange: onChekval, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '2', ref: txtCanceladas, onChange: onChekval, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai2' },
	                  'Canceladas'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '3', ref: txtDeudas, onChange: onChekval, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai3' },
	                  'Con Deudas'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'tipodisponible', value: '4', ref: txtAnuladas, onChange: onChekval, id: 'tipodisponible', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRai4' },
	                  'Anuladas'
	                )
	              )
	            )
	          ) : '',
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Cliente:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', disabled: valestado === 1 ? true : false, name: 'cliente', value: '1', ref: txtTodosCliente, onChange: onChekval, id: 'cliente', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', disabled: valestado === 1 ? true : false, name: 'cliente', value: '2', ref: txtPorCliente, onChange: onChekval, id: 'cliente', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa2' },
	                  'Por Cliente'
	                )
	              )
	            ),
	            _react2.default.createElement('input', { type: 'hidden', ref: txtIdProducto }),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-7 mr-auto px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm col-7 px-1 ml-auto' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'RIF:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-select col-3', ref: txtCbmrif, name: 'nci', onChange: onChange, 'aria-label': 'Default select example' },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'V' },
	                    'V'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'E' },
	                    'E'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'J' },
	                    'J'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'P' },
	                    'P'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'G' },
	                    'G'
	                  )
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtRifrespon, disabled: inputproducto === 1 ? false : true, onKeyUp: handleCliente, onBlur: handleCliente, className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: inputproducto === 1 ? false : true, type: 'button', onClick: catalogoProductoc(1), className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 row m-0 py-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'Nombre del Cliente:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', ref: txtNomrespon, disabled: true, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Vendedor:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-140 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'vendedor', value: '1', ref: txtTodosVendedores, onChange: onChekval, id: 'vendedor', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-176' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'vendedor', value: '2', ref: txtPorVendedor, onChange: onChekval, id: 'vendedor', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa2' },
	                  'Por Vendedor'
	                )
	              )
	            ),
	            _react2.default.createElement('input', { type: 'hidden', ref: txtIdProducto }),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-405' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm px-1 col-pd-250 ml-auto' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'RIF:'
	                ),
	                _react2.default.createElement(
	                  'select',
	                  { className: 'form-select col-3', ref: txtCbmrifVende, name: 'nci', onChange: onChange, 'aria-label': 'Default select example' },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'V' },
	                    'V'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'E' },
	                    'E'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'J' },
	                    'J'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'P' },
	                    'P'
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 'G' },
	                    'G'
	                  )
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtRifVende, disabled: valvende === 1 ? false : true, onKeyUp: handleCliente, onBlur: handleCliente, className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: valvende === 1 ? false : true, type: 'button', onClick: catalogoProductoc(2), className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 row m-0 py-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'Nombre del Vendedor:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', ref: txtNomVende, disabled: true, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            )
	          ),
	          props.report === "reportenotaentrega" || props.report === "reportepedidos" || props.report === "reportefacturas" || props.report === "reporteobsequio" ? _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Almacen:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'alamcen', value: '1', ref: txtTodosAlmacen, onChange: onChekval, id: 'alamcen', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', name: 'alamcen', value: '2', ref: txtPorAlmacen, onChange: onChekval, id: 'alamcen', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa2' },
	                  'Por Almacen'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-7 mr-auto px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm col-7 px-1 ml-auto' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'CODIGO ALMACEN:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtCodigoAlmacen, disabled: true /* onKeyUp={handleCliente} onBlur={handleCliente} */, className: 'form-control text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  { disabled: valalmacen === 1 ? false : true, type: 'button', onClick: function onClick() {
	                      return setMostrar2(true);
	                    }, className: 'btn btn-success' },
	                  _react2.default.createElement('i', { className: 'fas fa-search' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 row m-0 py-3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-12' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group input-group-sm' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                    'NOMBRE DEL ALMACEN:'
	                  ),
	                  _react2.default.createElement('input', { type: 'text', ref: txtNombreAlmacen, disabled: true, className: 'form-control', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	                )
	              )
	            )
	          ) : '',
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-4 fw-bold' },
	              'Estado:'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', disabled: inputproducto === 1 ? true : false, name: 'estado', value: '1', ref: txtTodosEstados, onChange: onChekval, id: 'estado', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa1' },
	                  'Todos'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-2 mx-auto' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-check' },
	                _react2.default.createElement('input', { className: 'form-check-input', disabled: inputproducto === 1 ? true : false, name: 'estado', value: '2', ref: txtPorEstados, onChange: onChekval, id: 'estado', type: 'radio' }),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'form-check-label', 'for': 'exampleRa2' },
	                  'Por Estado'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-12 row m-0 py-2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-4 mr-auto px-1' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'input-group input-group-sm mb-1' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', 'for': 'inputGroupSelect01' },
	                    'ESTADO'
	                  ),
	                  _react2.default.createElement(
	                    'select',
	                    { className: 'form-select', id: 'inputGroupSelect01', ref: txtEstado, disabled: valestado === 1 ? false : true },
	                    estado.map(function (item2, x) {
	                      return _react2.default.createElement(
	                        'option',
	                        { key: x, value: item2.idestado },
	                        " ",
	                        item2.nombre,
	                        " "
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-4 mr-auto px-1' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'input-group input-group-sm mb-1' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', 'for': 'inputGroupSelect02' },
	                    'MUNICIPIO'
	                  ),
	                  _react2.default.createElement(
	                    'select',
	                    {
	                      className: 'form-select',
	                      id: 'inputGroupSelect02',
	                      ref: txtMunicipio,
	                      disabled: valestado === 1 ? false : true,
	                      onChange: handleMunicipioChange
	                    },
	                    _react2.default.createElement(
	                      'option',
	                      { value: '' },
	                      'Seleccione un municipio'
	                    ),
	                    municipio.map(function (item2, x) {
	                      return _react2.default.createElement(
	                        'option',
	                        { key: x, value: item2.idmunicipio },
	                        " ",
	                        item2.nombre,
	                        " "
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-4 mr-auto px-1' },
	                _react2.default.createElement(
	                  'div',
	                  { 'class': 'input-group input-group-sm mb-1' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-text', 'for': 'inputGroupSelect03' },
	                    'CIUDAD'
	                  ),
	                  _react2.default.createElement(
	                    'select',
	                    {
	                      className: 'form-select',
	                      id: 'inputGroupSelect03',
	                      ref: txtCiudad,
	                      disabled: valestado === 1 ? false : true,
	                      onChange: handleCiudadChange
	                    },
	                    _react2.default.createElement(
	                      'option',
	                      { value: '' },
	                      'Seleccione una ciudad'
	                    ),
	                    ciudad.map(function (item2, x) {
	                      return _react2.default.createElement(
	                        'option',
	                        { key: x, value: item2.idciudad },
	                        " ",
	                        item2.nombre,
	                        " "
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-4 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: habilitado, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-primary mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-print' },
	              '  Imprimir'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: mostrar1,
	      nomid: clientvende,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar1(false);
	      },
	      onHideAceptaCatalogo: handleAceptaCliente
	    }),
	    _react2.default.createElement(_catalogoAlmacen2.default, {
	      show: mostrar2,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar2(false);
	      },
	      onHideAceptaCatalogo: handleAceptaAlmacen
	    })
	  );
	};

/***/ },
/* 7166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalPermisosUsuariosv = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTable = __webpack_require__(20);
	
	var _useTable2 = _interopRequireDefault(_useTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalPermisosUsuariosv = exports.ModalPermisosUsuariosv = function ModalPermisosUsuariosv(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
	  var idusuario = JSON.parse(sessionStorage.getItem("idusuario"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtLogin = (0, _react.useRef)();
	  var txtCedula = (0, _react.useRef)();
	  var txtStatus = (0, _react.useRef)();
	  var txtIduser = (0, _react.useRef)();
	
	  var txtuTodos = (0, _react.useRef)();
	  var txtuIncluir = (0, _react.useRef)();
	  var txtuModificar = (0, _react.useRef)();
	  var txtuCosultar = (0, _react.useRef)();
	  var txtuEliminar = (0, _react.useRef)();
	  var txtuImprimir = (0, _react.useRef)();
	
	  var txtdTodos = (0, _react.useRef)();
	  var txtdIncluir = (0, _react.useRef)();
	  var txtdModificar = (0, _react.useRef)();
	  var txtdCosultar = (0, _react.useRef)();
	  var txtdEliminar = (0, _react.useRef)();
	  var txtdImprimir = (0, _react.useRef)();
	
	  var txttTodos = (0, _react.useRef)();
	  var txttIncluir = (0, _react.useRef)();
	  var txttModificar = (0, _react.useRef)();
	  var txttCosultar = (0, _react.useRef)();
	  var txttEliminar = (0, _react.useRef)();
	  var txttImprimir = (0, _react.useRef)();
	
	  var txtcTodos = (0, _react.useRef)();
	  var txtcIncluir = (0, _react.useRef)();
	  var txtcModificar = (0, _react.useRef)();
	  var txtcCosultar = (0, _react.useRef)();
	  var txtcEliminar = (0, _react.useRef)();
	  var txtcImprimir = (0, _react.useRef)();
	
	  var txtcoTodos = (0, _react.useRef)();
	  var txtcoIncluir = (0, _react.useRef)();
	  var txtcoModificar = (0, _react.useRef)();
	  var txtcoCosultar = (0, _react.useRef)();
	  var txtcoEliminar = (0, _react.useRef)();
	  var txtcoImprimir = (0, _react.useRef)();
	
	  var txtsTodos = (0, _react.useRef)();
	  var txtsIncluir = (0, _react.useRef)();
	  var txtsModificar = (0, _react.useRef)();
	  var txtsCosultar = (0, _react.useRef)();
	  var txtsEliminar = (0, _react.useRef)();
	  var txtsImprimir = (0, _react.useRef)();
	
	  var txtsiTodos = (0, _react.useRef)();
	  var txtsiIncluir = (0, _react.useRef)();
	  var txtsiModificar = (0, _react.useRef)();
	  var txtsiCosultar = (0, _react.useRef)();
	  var txtsiEliminar = (0, _react.useRef)();
	  var txtsiImprimir = (0, _react.useRef)();
	
	  var txtoTodos = (0, _react.useRef)();
	  var txtoIncluir = (0, _react.useRef)();
	  var txtoModificar = (0, _react.useRef)();
	  var txtoCosultar = (0, _react.useRef)();
	  var txtoEliminar = (0, _react.useRef)();
	  var txtoImprimir = (0, _react.useRef)();
	
	  var txtnTodos = (0, _react.useRef)();
	  var txtnIncluir = (0, _react.useRef)();
	  var txtnModificar = (0, _react.useRef)();
	  var txtnCosultar = (0, _react.useRef)();
	  var txtnEliminar = (0, _react.useRef)();
	  var txtnImprimir = (0, _react.useRef)();
	
	  var txtdzTodos = (0, _react.useRef)();
	  var txtdzIncluir = (0, _react.useRef)();
	  var txtdzModificar = (0, _react.useRef)();
	  var txtdzCosultar = (0, _react.useRef)();
	  var txtdzEliminar = (0, _react.useRef)();
	  var txtdzImprimir = (0, _react.useRef)();
	
	  var txtocTodos = (0, _react.useRef)();
	  var txtocIncluir = (0, _react.useRef)();
	  var txtocModificar = (0, _react.useRef)();
	  var txtocCosultar = (0, _react.useRef)();
	  var txtocEliminar = (0, _react.useRef)();
	  var txtocImprimir = (0, _react.useRef)();
	
	  var txtReportTodos = (0, _react.useRef)();
	  var txtReport1 = (0, _react.useRef)();
	  var txtReport2 = (0, _react.useRef)();
	  var txtReport3 = (0, _react.useRef)();
	  var txtReport4 = (0, _react.useRef)();
	  var txtReport5 = (0, _react.useRef)();
	  var txtReport6 = (0, _react.useRef)();
	  var txtReport7 = (0, _react.useRef)();
	  var txtReport8 = (0, _react.useRef)();
	  var txtReport9 = (0, _react.useRef)();
	  var txtReport10 = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      modu1 = _useState2[0],
	      setModu1 = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      modu2 = _useState4[0],
	      setModu2 = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      modu3 = _useState6[0],
	      setModu3 = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      modu4 = _useState8[0],
	      setModu4 = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      modu5 = _useState10[0],
	      setModu5 = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      modu6 = _useState12[0],
	      setModu6 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      modu7 = _useState14[0],
	      setModu7 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      modu8 = _useState16[0],
	      setModu8 = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      modu9 = _useState18[0],
	      setModu9 = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      modu10 = _useState20[0],
	      setModu10 = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      modu11 = _useState22[0],
	      setModu11 = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0),
	      _useState24 = _slicedToArray(_useState23, 2),
	      modu12 = _useState24[0],
	      setModu12 = _useState24[1];
	
	  var _useState25 = (0, _react.useState)({}),
	      _useState26 = _slicedToArray(_useState25, 2),
	      body = _useState26[0],
	      setBody = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      operacion = _useState28[0],
	      setOperacion = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      activate = _useState30[0],
	      setActivate = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(true),
	      _useState32 = _slicedToArray(_useState31, 2),
	      habilitado = _useState32[0],
	      setHabilitado = _useState32[1];
	
	  var _useState33 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState34 = _slicedToArray(_useState33, 2),
	      mensaje = _useState34[0],
	      setMensaje = _useState34[1];
	
	  var _useState35 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState36 = _slicedToArray(_useState35, 2),
	      mensajesino = _useState36[0],
	      setMensajesino = _useState36[1];
	
	  var _useState37 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState38 = _slicedToArray(_useState37, 2),
	      botones = _useState38[0],
	      setBotones = _useState38[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var SelectUsuario = function SelectUsuario(idusuario) {
	    var endpoint = op.conexion + '/api/athos/usuario/getuser?id=' + idusuario;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.idusuario > 0) {
	
	          var para1 = response.data.accbtnclientes;
	          var para2 = response.data.accbtnvendedor;
	          var para3 = response.data.accbtnpedidos;
	          var para4 = response.data.accbtnnentrega;
	          var para5 = response.data.accbtnndebito;
	          var para6 = response.data.accbtnfacturas;
	          var para7 = response.data.accbtnpresupuesto;
	          var para8 = response.data.accbtnvreports;
	          var para9 = response.data.accbtnfacturaxnotas;
	
	          sessionStorage.setItem("accbtnclientesc", JSON.stringify(para1));
	          sessionStorage.setItem("accbtnvendedorc", JSON.stringify(para2));
	          sessionStorage.setItem("accbtnpedidosc", JSON.stringify(para3));
	          sessionStorage.setItem("accbtnnentregac", JSON.stringify(para4));
	          sessionStorage.setItem("accbtnndebitoc", JSON.stringify(para5));
	          sessionStorage.setItem("accbtnfacturasc", JSON.stringify(para6));
	          sessionStorage.setItem("accbtnpresupuestoc", JSON.stringify(para7));
	          sessionStorage.setItem("accbtnvreportsc", JSON.stringify(para8));
	          sessionStorage.setItem("accbtnfacturaxnotasc", JSON.stringify(para9));
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "Error al cargar el usuario",
	            icono: "informacion"
	          });
	          setActivate(false);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var parameter1 = "";
	    var parameter2 = "";
	    var parameter3 = "";
	    var parameter4 = "";
	    var parameter5 = "";
	    var parameter6 = "";
	    var parameter7 = "";
	    var parameter8 = "";
	    var parameter9 = "";
	    var parameter10 = "";
	    var reportes = "";
	
	    if (props.usuario.accventas.toString().substring(0, 1) === '1') {
	
	      var val1 = txtuIncluir.current.checked === true ? "1" : "0";
	      var val2 = txtuModificar.current.checked === true ? "1" : "0";
	      var val3 = txtuCosultar.current.checked === true ? "1" : "0";
	      var val4 = txtuEliminar.current.checked === true ? "1" : "0";
	      var val5 = txtuImprimir.current.checked === true ? "1" : "0";
	
	      parameter1 = val1 + val2 + val3 + val4 + val5;
	    } else {
	
	      parameter1 = '000000';
	    }
	
	    if (props.usuario.accventas.toString().substring(1, 2) === '1') {
	
	      var _val = txtdIncluir.current.checked === true ? "1" : "0";
	      var _val2 = txtdModificar.current.checked === true ? "1" : "0";
	      var _val3 = txtdCosultar.current.checked === true ? "1" : "0";
	      var _val4 = txtdEliminar.current.checked === true ? "1" : "0";
	      var _val5 = txtdImprimir.current.checked === true ? "1" : "0";
	
	      parameter2 = _val + _val2 + _val3 + _val4 + _val5;
	    } else {
	
	      parameter2 = '000000';
	    }
	
	    if (props.usuario.accventas.toString().substring(2, 3) === '1') {
	
	      var _val6 = txttIncluir.current.checked === true ? "1" : "0";
	      var _val7 = txttModificar.current.checked === true ? "1" : "0";
	      var _val8 = txttCosultar.current.checked === true ? "1" : "0";
	      var _val9 = txttEliminar.current.checked === true ? "1" : "0";
	      var _val10 = txttImprimir.current.checked === true ? "1" : "0";
	
	      parameter3 = _val6 + _val7 + _val8 + _val9 + _val10;
	    } else {
	
	      parameter3 = '000000';
	    }
	
	    if (props.usuario.accventas.toString().substring(3, 4) === '1') {
	
	      var _val11 = txtcIncluir.current.checked === true ? "1" : "0";
	      var _val12 = txtcModificar.current.checked === true ? "1" : "0";
	      var _val13 = txtcCosultar.current.checked === true ? "1" : "0";
	      var _val14 = txtcEliminar.current.checked === true ? "1" : "0";
	      var _val15 = txtcImprimir.current.checked === true ? "1" : "0";
	
	      parameter4 = _val11 + _val12 + _val13 + _val14 + _val15;
	    } else {
	
	      parameter4 = '000000';
	    }
	
	    if (props.usuario.accventas.toString().substring(4, 5) === '1') {
	
	      var _val16 = txtcoIncluir.current.checked === true ? "1" : "0";
	      var _val17 = txtcoModificar.current.checked === true ? "1" : "0";
	      var _val18 = txtcoCosultar.current.checked === true ? "1" : "0";
	      var _val19 = txtcoEliminar.current.checked === true ? "1" : "0";
	      var _val20 = txtcoImprimir.current.checked === true ? "1" : "0";
	
	      parameter5 = _val16 + _val17 + _val18 + _val19 + _val20;
	    } else {
	
	      parameter5 = '000000';
	    }
	
	    if (props.usuario.accventas.toString().substring(5, 6) === '1') {
	
	      var _val21 = txtsIncluir.current.checked === true ? "1" : "0";
	      var _val22 = txtsModificar.current.checked === true ? "1" : "0";
	      var _val23 = txtsCosultar.current.checked === true ? "1" : "0";
	      var _val24 = txtsEliminar.current.checked === true ? "1" : "0";
	      var _val25 = txtsImprimir.current.checked === true ? "1" : "0";
	
	      parameter6 = _val21 + _val22 + _val23 + _val24 + _val25;
	    } else {
	
	      parameter6 = '000000';
	    }
	
	    if (props.usuario.accventas.toString().substring(6, 7) === '1') {
	
	      var _val26 = txtsiIncluir.current.checked === true ? "1" : "0";
	      var _val27 = txtsiModificar.current.checked === true ? "1" : "0";
	      var _val28 = txtsiCosultar.current.checked === true ? "1" : "0";
	      var _val29 = txtsiEliminar.current.checked === true ? "1" : "0";
	      var _val30 = txtsiImprimir.current.checked === true ? "1" : "0";
	
	      parameter7 = _val26 + _val27 + _val28 + _val29 + _val30;
	    } else {
	
	      parameter7 = '000000';
	    }
	
	    if (props.usuario.accventas.toString().substring(8, 9) === '1') {
	
	      var _val31 = txtReport1.current.checked === true ? "1" : "0";
	      var _val32 = txtReport2.current.checked === true ? "1" : "0";
	      var _val33 = txtReport3.current.checked === true ? "1" : "0";
	      var _val34 = txtReport4.current.checked === true ? "1" : "0";
	      var _val35 = txtReport5.current.checked === true ? "1" : "0";
	      var val6 = txtReport6.current.checked === true ? "1" : "0";
	      var val7 = txtReport7.current.checked === true ? "1" : "0";
	      var val8 = txtReport8.current.checked === true ? "1" : "0";
	
	      reportes = _val31 + _val32 + _val33 + _val34 + _val35 + val6 + val7 + val8;
	    } else {
	
	      reportes = '0000000000';
	    }
	
	    if (props.usuario.accventas.toString().substring(9, 10) === '1') {
	
	      var _val36 = txtoIncluir.current.checked === true ? "1" : "0";
	      var _val37 = txtoModificar.current.checked === true ? "1" : "0";
	      var _val38 = txtoCosultar.current.checked === true ? "1" : "0";
	      var _val39 = txtoEliminar.current.checked === true ? "1" : "0";
	      var _val40 = txtoImprimir.current.checked === true ? "1" : "0";
	
	      parameter8 = _val36 + _val37 + _val38 + _val39 + _val40;
	    } else {
	
	      parameter8 = '00000';
	    }
	
	    var sigue = true;
	    var mensaje = "";
	
	    if (sigue) {
	      var user = [];
	      user.push({
	        idusuario: txtIduser.current.value,
	        login: txtLogin.current.value,
	        persona: txtCedula.current.value,
	        status: txtStatus.current.value === 'ACTIVO' ? 1 : 0,
	        idorganizacion: idorganizacion,
	        accbtnclientes: parameter1,
	        accbtnvendedor: parameter2,
	        accbtnpedidos: parameter3,
	        accbtnnentrega: parameter4,
	        accbtnndebito: parameter5,
	        accbtnfacturas: parameter6,
	        accbtnpresupuesto: parameter7,
	        accbtnvreports: reportes,
	        accbtnfacturaxnotas: parameter8
	      });
	
	      var _body = {
	        usu: JSON.stringify(user)
	      };
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	      setBody(_body);
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: mensaje,
	        icono: "informacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    var endpoint = op.conexion + '/api/athos/usuario/actualizar/' + operacion;
	
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setActivate(false);
	
	        if (parseInt(response.data.iduser) > 0) {
	          if (parseInt(response.data.iduser) === parseInt(idusuario)) {
	            SelectUsuario(parseInt(response.data.iduser));
	          }
	        }
	
	        var mensaje = "";
	        if (operacion === 1) {
	          mensaje = "El Usuario " + response.data.iduser + " ha sido registrada de manera satisfactoria.";
	        } else if (operacion === 2) {
	          mensaje = "El Usuario " + response.data.iduser + " ha sido Modificada de manera Satisfactoria.";
	        } else if (operacion === 3) {
	          mensaje = "El usuario " + response.data.iduser + " ha sido eliminada de manera satisfactoria.";
	        }
	
	        setMensaje({
	          mostrar: true,
	          titulo: "Exito.",
	          texto: mensaje,
	          icono: "exito"
	        });
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    procesarRegistro();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    props.onHideCancela();
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var checkBlank = function checkBlank(e) {
	
	    if (modu1 === 1) {
	      if (txtuIncluir.current.checked && txtuModificar.current.checked && txtuCosultar.current.checked && txtuEliminar.current.checked && txtuImprimir.current.checked) {
	        txtuTodos.current.checked = true;
	      } else {
	        txtuTodos.current.checked = false;
	      }
	    }
	
	    if (modu2 === 1) {
	      if (txtdIncluir.current.checked && txtdModificar.current.checked && txtdCosultar.current.checked && txtdEliminar.current.checked && txtdImprimir.current.checked) {
	        txtdTodos.current.checked = true;
	      } else {
	        txtdTodos.current.checked = false;
	      }
	    }
	
	    if (modu3 === 1) {
	      if (txttIncluir.current.checked && txttModificar.current.checked && txttCosultar.current.checked && txttEliminar.current.checked && txttImprimir.current.checked) {
	        txttTodos.current.checked = true;
	      } else {
	        txttTodos.current.checked = false;
	      }
	    }
	
	    if (modu4 === 1) {
	      if (txtcIncluir.current.checked && txtcModificar.current.checked && txtcCosultar.current.checked && txtcEliminar.current.checked && txtcImprimir.current.checked) {
	        txtcTodos.current.checked = true;
	      } else {
	        txtcTodos.current.checked = false;
	      }
	    }
	
	    if (modu5 === 1) {
	      if (txtcoIncluir.current.checked && txtcoModificar.current.checked && txtcoCosultar.current.checked && txtcoEliminar.current.checked && txtcoImprimir.current.checked) {
	        txtcoTodos.current.checked = true;
	      } else {
	        txtcoTodos.current.checked = false;
	      }
	    }
	
	    if (modu6 === 1) {
	      if (txtsIncluir.current.checked && txtsModificar.current.checked && txtsCosultar.current.checked && txtsEliminar.current.checked && txtsImprimir.current.checked) {
	        txtsTodos.current.checked = true;
	      } else {
	        txtsTodos.current.checked = false;
	      }
	    }
	
	    if (modu7 === 1) {
	      if (txtsiIncluir.current.checked && txtsiModificar.current.checked && txtsiCosultar.current.checked && txtsiEliminar.current.checked && txtsiImprimir.current.checked) {
	        txtsiTodos.current.checked = true;
	      } else {
	        txtsiTodos.current.checked = false;
	      }
	    }
	
	    if (modu8 === 1) {
	      if (txtReport1.current.checked && txtReport2.current.checked && txtReport3.current.checked && txtReport4.current.checked && txtReport5.current.checked && txtReport6.current.checked && txtReport7.current.checked && txtReport8.current.checked) {
	        txtReportTodos.current.checked = true;
	      } else {
	        txtReportTodos.current.checked = false;
	      }
	    }
	
	    if (modu9 === 1) {
	      if (txtoIncluir.current.checked && txtoModificar.current.checked && txtoCosultar.current.checked && txtoEliminar.current.checked && txtoImprimir.current.checked) {
	        txtoTodos.current.checked = true;
	      } else {
	        txtoTodos.current.checked = false;
	      }
	    }
	  };
	
	  var checkTodo = function checkTodo(e) {
	    if (e.target.name === "todos1") {
	      if (txtuTodos.current.checked) {
	        txtuIncluir.current.checked = true;
	        txtuModificar.current.checked = true;
	        txtuCosultar.current.checked = true;
	        txtuEliminar.current.checked = true;
	        txtuImprimir.current.checked = true;
	      } else {
	        txtuIncluir.current.checked = false;
	        txtuModificar.current.checked = false;
	        txtuCosultar.current.checked = false;
	        txtuEliminar.current.checked = false;
	        txtuImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos2") {
	      if (txtdTodos.current.checked) {
	        txtdIncluir.current.checked = true;
	        txtdModificar.current.checked = true;
	        txtdCosultar.current.checked = true;
	        txtdEliminar.current.checked = true;
	        txtdImprimir.current.checked = true;
	      } else {
	        txtdIncluir.current.checked = false;
	        txtdModificar.current.checked = false;
	        txtdCosultar.current.checked = false;
	        txtdEliminar.current.checked = false;
	        txtdImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos3") {
	      if (txttTodos.current.checked) {
	        txttIncluir.current.checked = true;
	        txttModificar.current.checked = true;
	        txttCosultar.current.checked = true;
	        txttEliminar.current.checked = true;
	        txttImprimir.current.checked = true;
	      } else {
	        txttIncluir.current.checked = false;
	        txttModificar.current.checked = false;
	        txttCosultar.current.checked = false;
	        txttEliminar.current.checked = false;
	        txttImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos4") {
	      if (txtcTodos.current.checked) {
	        txtcIncluir.current.checked = true;
	        txtcModificar.current.checked = true;
	        txtcCosultar.current.checked = true;
	        txtcEliminar.current.checked = true;
	        txtcImprimir.current.checked = true;
	      } else {
	        txtcIncluir.current.checked = false;
	        txtcModificar.current.checked = false;
	        txtcCosultar.current.checked = false;
	        txtcEliminar.current.checked = false;
	        txtcImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos5") {
	      if (txtcoTodos.current.checked) {
	        txtcoIncluir.current.checked = true;
	        txtcoModificar.current.checked = true;
	        txtcoCosultar.current.checked = true;
	        txtcoEliminar.current.checked = true;
	        txtcoImprimir.current.checked = true;
	      } else {
	        txtcoIncluir.current.checked = false;
	        txtcoModificar.current.checked = false;
	        txtcoCosultar.current.checked = false;
	        txtcoEliminar.current.checked = false;
	        txtcoImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos6") {
	      if (txtsTodos.current.checked) {
	        txtsIncluir.current.checked = true;
	        txtsModificar.current.checked = true;
	        txtsCosultar.current.checked = true;
	        txtsEliminar.current.checked = true;
	        txtsImprimir.current.checked = true;
	      } else {
	        txtsIncluir.current.checked = false;
	        txtsModificar.current.checked = false;
	        txtsCosultar.current.checked = false;
	        txtsEliminar.current.checked = false;
	        txtsImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos7") {
	      if (txtsiTodos.current.checked) {
	        txtsiIncluir.current.checked = true;
	        txtsiModificar.current.checked = true;
	        txtsiCosultar.current.checked = true;
	        txtsiEliminar.current.checked = true;
	        txtsiImprimir.current.checked = true;
	      } else {
	        txtsiIncluir.current.checked = false;
	        txtsiModificar.current.checked = false;
	        txtsiCosultar.current.checked = false;
	        txtsiEliminar.current.checked = false;
	        txtsiImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todos9") {
	      if (txtoTodos.current.checked) {
	        txtoIncluir.current.checked = true;
	        txtoModificar.current.checked = true;
	        txtoCosultar.current.checked = true;
	        txtoEliminar.current.checked = true;
	        txtoImprimir.current.checked = true;
	      } else {
	        txtoIncluir.current.checked = false;
	        txtoModificar.current.checked = false;
	        txtoCosultar.current.checked = false;
	        txtoEliminar.current.checked = false;
	        txtoImprimir.current.checked = false;
	      }
	    } else if (e.target.name === "todosreportes") {
	      if (txtReportTodos.current.checked) {
	        txtReport1.current.checked = true;
	        txtReport2.current.checked = true;
	        txtReport3.current.checked = true;
	        txtReport4.current.checked = true;
	        txtReport5.current.checked = true;
	        txtReport6.current.checked = true;
	        txtReport7.current.checked = true;
	        txtReport8.current.checked = true;
	      } else {
	        txtReport1.current.checked = false;
	        txtReport2.current.checked = false;
	        txtReport3.current.checked = false;
	        txtReport4.current.checked = false;
	        txtReport5.current.checked = false;
	        txtReport6.current.checked = false;
	        txtReport7.current.checked = false;
	        txtReport8.current.checked = false;
	      }
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'xl',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.op === 1) {
	          setOperacion(2);
	          if (props.usuario.accventas.toString().substring(0, 1) === '1') {
	            setModu1(1);
	          } else {
	            setModu1(0);
	          }
	
	          if (props.usuario.accventas.toString().substring(1, 2) === '1') {
	            setModu2(1);
	          } else {
	            setModu2(0);
	          }
	
	          if (props.usuario.accventas.toString().substring(2, 3) === '1') {
	            setModu3(1);
	          } else {
	            setModu3(0);
	          }
	
	          if (props.usuario.accventas.toString().substring(3, 4) === '1') {
	            setModu4(1);
	          } else {
	            setModu4(0);
	          }
	
	          if (props.usuario.accventas.toString().substring(4, 5) === '1') {
	            setModu5(1);
	          } else {
	            setModu5(0);
	          }
	
	          if (props.usuario.accventas.toString().substring(5, 6) === '1') {
	            setModu6(1);
	          } else {
	            setModu6(0);
	          }
	
	          if (props.usuario.accventas.toString().substring(6, 7) === '1') {
	            setModu7(1);
	          } else {
	            setModu7(0);
	          }
	
	          if (props.usuario.accventas.toString().substring(8, 9) === '1') {
	            setModu8(1);
	          } else {
	            setModu8(0);
	          }
	
	          if (props.usuario.accventas.toString().substring(9, 10) === '1') {
	            setModu9(1);
	          } else {
	            setModu9(0);
	          }
	
	          setHabilitado(false);
	        } else {
	
	          setHabilitado(true);
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Permisos de Usuario (Ventas)'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row col-md-12 rounded mx-auto m-0' },
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded mb-1 d-flex justify-content-around', style: { fontSizeAdjust: '0.6' } },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-6 fw-bold' },
	              'Datos del Usuarios'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-200 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'USUARIO:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtLogin, defaultValue: props.usuario && props.usuario.login, className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement('input', { type: 'hidden', ref: txtIduser, defaultValue: props.usuario && props.usuario.idusuario }),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-180 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'CEDULA:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtCedula, defaultValue: props.persona && props.persona.cedula, className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-500 px-0' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'NOMBRES Y APELLIDOS:'
	                ),
	                _react2.default.createElement('input', { type: 'text', defaultValue: props.persona && props.persona.nombres.trim() + " " + props.persona.apellidos.trim(), className: 'form-control text-uppercase fs-6', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-pd-170 px-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'ESTATUS:'
	                ),
	                _react2.default.createElement('input', { type: 'text', ref: txtStatus, defaultValue: props.usuario && props.usuario.status === '1' ? 'ACTIVO' : 'INACTIVO', className: 'form-control text-uppercase fs-6 text-center', disabled: true, 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto border-azul rounded' },
	            _react2.default.createElement(
	              'legend',
	              { className: 'float-none m-0 w-auto fs-5 fw-bold' },
	              'Modulos Autorizados'
	            ),
	            modu1 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Clientes'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuTodos,
	                          defaultChecked: props.usuario.accbtnclientes.substring(0, 1) === '1' && props.usuario.accbtnclientes.substring(1, 2) === '1' && props.usuario.accbtnclientes.substring(2, 3) === '1' && props.usuario.accbtnclientes.substring(3, 4) === '1' && props.usuario.accbtnclientes.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos1', id: 'inlineCheckboxu' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuIncluir, defaultChecked: props.usuario.accbtnclientes.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuModificar, defaultChecked: props.usuario.accbtnclientes.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuCosultar, defaultChecked: props.usuario.accbtnclientes.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuEliminar, defaultChecked: props.usuario.accbtnclientes.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtuImprimir, defaultChecked: props.usuario.accbtnclientes.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxu5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxu5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu2 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Vendedores'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdTodos,
	                          defaultChecked: props.usuario.accbtnvendedor.substring(0, 1) === '1' && props.usuario.accbtnvendedor.substring(1, 2) === '1' && props.usuario.accbtnvendedor.substring(2, 3) === '1' && props.usuario.accbtnvendedor.substring(3, 4) === '1' && props.usuario.accbtnvendedor.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos2', id: 'inlineCheckboxd' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdIncluir, defaultChecked: props.usuario.accbtnvendedor.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdModificar, defaultChecked: props.usuario.accbtnvendedor.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdCosultar, defaultChecked: props.usuario.accbtnvendedor.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdEliminar, defaultChecked: props.usuario.accbtnvendedor.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtdImprimir, defaultChecked: props.usuario.accbtnvendedor.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxd5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxd5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu3 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Pedidos'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttTodos,
	                          defaultChecked: props.usuario.accbtnpedidos.substring(0, 1) === '1' && props.usuario.accbtnpedidos.substring(1, 2) === '1' && props.usuario.accbtnpedidos.substring(2, 3) === '1' && props.usuario.accbtnpedidos.substring(3, 4) === '1' && props.usuario.accbtnpedidos.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos3', id: 'inlineCheckboxt' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttIncluir, defaultChecked: props.usuario.accbtnpedidos.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttModificar, defaultChecked: props.usuario.accbtnpedidos.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttCosultar, defaultChecked: props.usuario.accbtnpedidos.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttEliminar, defaultChecked: props.usuario.accbtnpedidos.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txttImprimir, defaultChecked: props.usuario.accbtnpedidos.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxt5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxt5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu4 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Notas de Entrega'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcTodos,
	                          defaultChecked: props.usuario.accbtnnentrega.substring(0, 1) === '1' && props.usuario.accbtnnentrega.substring(1, 2) === '1' && props.usuario.accbtnnentrega.substring(2, 3) === '1' && props.usuario.accbtnnentrega.substring(3, 4) === '1' && props.usuario.accbtnnentrega.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos4', id: 'inlineCheckboxc' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcIncluir, defaultChecked: props.usuario.accbtnnentrega.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcModificar, defaultChecked: props.usuario.accbtnnentrega.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcCosultar, defaultChecked: props.usuario.accbtnnentrega.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcEliminar, defaultChecked: props.usuario.accbtnnentrega.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcImprimir, defaultChecked: props.usuario.accbtnnentrega.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxc5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxc5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu5 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Notas de Debito'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcoTodos,
	                          defaultChecked: props.usuario.accbtnndebito.substring(0, 1) === '1' && props.usuario.accbtnndebito.substring(1, 2) === '1' && props.usuario.accbtnndebito.substring(2, 3) === '1' && props.usuario.accbtnndebito.substring(3, 4) === '1' && props.usuario.accbtnndebito.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos5', id: 'inlineCheckboxco' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxco' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcoIncluir, defaultChecked: props.usuario.accbtnndebito.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxco1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxco1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcoModificar, defaultChecked: props.usuario.accbtnndebito.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxco2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxco2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcoCosultar, defaultChecked: props.usuario.accbtnndebito.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxco3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxco3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcoEliminar, defaultChecked: props.usuario.accbtnndebito.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxco4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxco4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtcoImprimir, defaultChecked: props.usuario.accbtnndebito.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxco5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxco5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu6 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Facturas'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsTodos,
	                          defaultChecked: props.usuario.accbtnfacturas.substring(0, 1) === '1' && props.usuario.accbtnfacturas.substring(1, 2) === '1' && props.usuario.accbtnfacturas.substring(2, 3) === '1' && props.usuario.accbtnfacturas.substring(3, 4) === '1' && props.usuario.accbtnfacturas.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos6', id: 'inlineCheckboxs' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxs' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsIncluir, defaultChecked: props.usuario.accbtnfacturas.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxs1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxs1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsModificar, defaultChecked: props.usuario.accbtnfacturas.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxs2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxs2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsCosultar, defaultChecked: props.usuario.accbtnfacturas.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxs3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxs3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsEliminar, defaultChecked: props.usuario.accbtnfacturas.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxs4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxs4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsImprimir, defaultChecked: props.usuario.accbtnfacturas.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxs5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxs5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu9 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Facturas por Notas de Entrega'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtoTodos,
	                          defaultChecked: props.usuario.accbtnfacturaxnotas.substring(0, 1) === '1' && props.usuario.accbtnfacturaxnotas.substring(1, 2) === '1' && props.usuario.accbtnfacturaxnotas.substring(2, 3) === '1' && props.usuario.accbtnfacturaxnotas.substring(3, 4) === '1' && props.usuario.accbtnfacturaxnotas.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos9', id: 'inlineCheckboxsf' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsf' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtoIncluir, defaultChecked: props.usuario.accbtnfacturaxnotas.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxsf1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsf1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtoModificar, defaultChecked: props.usuario.accbtnfacturaxnotas.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxsf2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsf2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtoCosultar, defaultChecked: props.usuario.accbtnfacturaxnotas.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxsf3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsf3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtoEliminar, defaultChecked: props.usuario.accbtnfacturaxnotas.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxsf4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsf4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtoImprimir, defaultChecked: props.usuario.accbtnfacturaxnotas.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxsf5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsf5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu7 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 mb-1 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Presupuesto'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsiTodos,
	                          defaultChecked: props.usuario.accbtnpresupuesto.substring(0, 1) === '1' && props.usuario.accbtnpresupuesto.substring(1, 2) === '1' && props.usuario.accbtnpresupuesto.substring(2, 3) === '1' && props.usuario.accbtnpresupuesto.substring(3, 4) === '1' && props.usuario.accbtnpresupuesto.substring(4, 5) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todos7', id: 'inlineCheckboxsi' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsi' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsiIncluir, defaultChecked: props.usuario.accbtnpresupuesto.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxsi1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsi1' },
	                          'INCLUIR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsiModificar, defaultChecked: props.usuario.accbtnpresupuesto.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxsi2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsi2' },
	                          'MODIFICAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsiCosultar, defaultChecked: props.usuario.accbtnpresupuesto.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxsi3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsi3' },
	                          'CONSULTAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsiEliminar, defaultChecked: props.usuario.accbtnpresupuesto.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxsi4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsi4' },
	                          'ELIMINAR'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtsiImprimir, defaultChecked: props.usuario.accbtnpresupuesto.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxsi5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxsi5' },
	                          'IMPRIMIR'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : '',
	            modu8 === 1 ? _react2.default.createElement(
	              'div',
	              { className: 'input-group col-sm-12 w-100 px-0 border-azul' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-sm-5 fw-bold' },
	                'Reportes'
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'col-12 table table-sm table-bordered m-0 px-0' },
	                _react2.default.createElement(
	                  'thead',
	                  { className: 'col-12 m-0 px-0' },
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReportTodos,
	                          defaultChecked: props.usuario.accbtnvreports.substring(0, 1) === '1' && props.usuario.accbtnvreports.substring(1, 2) === '1' && props.usuario.accbtnvreports.substring(2, 3) === '1' && props.usuario.accbtnvreports.substring(3, 4) === '1' && props.usuario.accbtnvreports.substring(4, 5) === '1' && props.usuario.accbtnvreports.substring(5, 6) === '1' && props.usuario.accbtnvreports.substring(6, 7) === '1' && props.usuario.accbtnvreports.substring(7, 8) === '1' ? true : false,
	                          onChange: checkTodo, name: 'todosreportes', id: 'inlineCheckboxr' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr' },
	                          'TODOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport1, defaultChecked: props.usuario.accbtnvreports.substring(0, 1) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr1' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr1' },
	                          'CLIENTES'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport2, defaultChecked: props.usuario.accbtnvreports.substring(1, 2) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr2' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr2' },
	                          'PEDIDOS GENERADOS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport3, defaultChecked: props.usuario.accbtnvreports.substring(2, 3) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr3' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr3' },
	                          'NOTAS DE ENTREGA GENERADAS'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport4, defaultChecked: props.usuario.accbtnvreports.substring(3, 4) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr4' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr4' },
	                          'NOTAS DE DEBITO GENERADAS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport5, defaultChecked: props.usuario.accbtnvreports.substring(4, 5) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr5' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr5' },
	                          'NOTAS DE CREDITO GENERADAS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport6, defaultChecked: props.usuario.accbtnvreports.substring(5, 6) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr6' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr6' },
	                          'FACTURAS GENERADAS'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport7, defaultChecked: props.usuario.accbtnvreports.substring(6, 7) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr7' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr7' },
	                          'MOVIMIENTOS DE VENTAS'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      { scope: 'col', className: 'p-1' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'form-check form-check-inline' },
	                        _react2.default.createElement('input', { className: 'form-check-input', type: 'checkbox', ref: txtReport8, defaultChecked: props.usuario.accbtnvreports.substring(7, 8) === '1' ? true : false, onChange: checkBlank, id: 'inlineCheckboxr8' }),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'form-check-label', 'for': 'inlineCheckboxr8' },
	                          'MOVIMIENTOS DE VENTAS POR PRODUCTOS'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null)
	            ) : ''
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-4 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: props.usuario && props.usuario.status === '0' ? true : false, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-success' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check-circle' },
	              '  Aceptar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RegistrarPago = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _modalAgreProcesosMontos = __webpack_require__(7160);
	
	var _catalogoValorMoneda = __webpack_require__(295);
	
	var _catalogoValorMoneda2 = _interopRequireDefault(_catalogoValorMoneda);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	//import TablaRetencionesporCobrar from "./tablaRetencionesxCobrar";
	
	var RegistrarPago = exports.RegistrarPago = function RegistrarPago(props) {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var ncaja = JSON.parse(sessionStorage.getItem("numcaja"));
	
	  var headCells = [{ label: "FORMA DE PAGO", textAlign: "center" }, { label: "REFERENCIA", textAlign: "center" }, { label: "MONTO", textAlign: "center" }, { label: "MONTO AL CAMBIO", textAlign: "center" }, { label: "", textAlign: "center" }];
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtFechaPago = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(0.0),
	      _useState2 = _slicedToArray(_useState, 2),
	      restabs = _useState2[0],
	      setRestabs = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0.0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      anticipos = _useState4[0],
	      setAnticipos = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0.0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      sobrabs = _useState6[0],
	      setSobrabs = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0.0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      totalresta = _useState8[0],
	      setTotalresta = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0.0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      totalsobra = _useState10[0],
	      setTotalsobra = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0.0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      totaldolares = _useState12[0],
	      setTotaldolares = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0.0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      totalcredito = _useState14[0],
	      setTotalcredito = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0.0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      totales = _useState16[0],
	      setTotales = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0.0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      totalesr = _useState18[0],
	      setTotalesr = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0.0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      totalesrb = _useState20[0],
	      setTotalesrb = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0.0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      totaldeuda = _useState22[0],
	      setTotaldeuda = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(0.0),
	      _useState24 = _slicedToArray(_useState23, 2),
	      totaldeudabs = _useState24[0],
	      setTotaldeudabs = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(0.0),
	      _useState26 = _slicedToArray(_useState25, 2),
	      tasa = _useState26[0],
	      setTasa = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(false),
	      _useState28 = _slicedToArray(_useState27, 2),
	      mostrar1 = _useState28[0],
	      setMostrar1 = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(0),
	      _useState30 = _slicedToArray(_useState29, 2),
	      operacion = _useState30[0],
	      setOperacion = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(""),
	      _useState32 = _slicedToArray(_useState31, 2),
	      numfactu = _useState32[0],
	      setNumfactu = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(0),
	      _useState34 = _slicedToArray(_useState33, 2),
	      idvendedor = _useState34[0],
	      setIdvendedor = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(0),
	      _useState36 = _slicedToArray(_useState35, 2),
	      idfactu = _useState36[0],
	      setIdfactu = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(null),
	      _useState38 = _slicedToArray(_useState37, 2),
	      body = _useState38[0],
	      setBody = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(null),
	      _useState40 = _slicedToArray(_useState39, 2),
	      idmon = _useState40[0],
	      setIdmon = _useState40[1];
	
	  var _useState41 = (0, _react.useState)([]),
	      _useState42 = _slicedToArray(_useState41, 2),
	      retencionesid = _useState42[0],
	      setRetencionesid = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(false),
	      _useState44 = _slicedToArray(_useState43, 2),
	      activate = _useState44[0],
	      setActivate = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(0),
	      _useState46 = _slicedToArray(_useState45, 2),
	      idmone = _useState46[0],
	      setIdmone = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(0.0),
	      _useState48 = _slicedToArray(_useState47, 2),
	      valormone = _useState48[0],
	      setValormone = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(""),
	      _useState50 = _slicedToArray(_useState49, 2),
	      tiponot = _useState50[0],
	      setTiponot = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(false),
	      _useState52 = _slicedToArray(_useState51, 2),
	      mostrar2 = _useState52[0],
	      setMostrar2 = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(false),
	      _useState54 = _slicedToArray(_useState53, 2),
	      mostrar3 = _useState54[0],
	      setMostrar3 = _useState54[1];
	
	  var _useState55 = (0, _react.useState)([]),
	      _useState56 = _slicedToArray(_useState55, 2),
	      records = _useState56[0],
	      setRecords = _useState56[1];
	
	  var _useState57 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState58 = _slicedToArray(_useState57, 2),
	      filterFn = _useState58[0],
	      setFilterFn = _useState58[1];
	
	  var _useState59 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState60 = _slicedToArray(_useState59, 2),
	      mensaje = _useState60[0],
	      setMensaje = _useState60[1];
	
	  var _useState61 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState62 = _slicedToArray(_useState61, 2),
	      mensajesino = _useState62[0],
	      setMensajesino = _useState62[1];
	
	  var _useState63 = (0, _react.useState)([]),
	      _useState64 = _slicedToArray(_useState63, 2),
	      combomoneda = _useState64[0],
	      setComboMoneda = _useState64[1];
	
	  var _useState65 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState66 = _slicedToArray(_useState65, 2),
	      botones = _useState66[0],
	      setBotones = _useState66[1];
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells, filterFn),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setRestabs(0.0);
	    setSobrabs(0.0);
	    setAnticipos(0.0);
	    setIdfactu(0);
	    setIdvendedor(0);
	    setNumfactu("");
	    setIdmon(null);
	    setRetencionesid([]);
	    setTotalresta(0.0);
	    setTotales(0.0);
	    setTotalesr(0.0);
	    setTotalesrb(0.0);
	    setMostrar2(false);
	    setTotaldolares(0.0);
	    setTotalsobra(0.0);
	    setTotaldeuda(0.0);
	    setRecords([]);
	    setValormone(0.0);
	    setIdmone(0);
	    setTiponot("");
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	    props.onRenderizar();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    var sigue = true;
	    if (props.ope === 1 || props.ope === 2) {
	      if (records.length > 0) {
	        sigue = true;
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Introduzca el Pago !",
	          icono: "informacion"
	        });
	        sigue = false;
	      }
	
	      if (sigue) {
	        var pago = [];
	        var pagodetalle = [];
	
	        pago.push({
	          idpago: 0,
	          numpago: "",
	          concepto: props.tipo === "notaentrega" ? "PAGO DE NOTA DE ENTREGA N°" + " " + props.numfactu : props.tipo === "debito" ? "PAGO DE NOTA DE DEBITO N°" + " " + props.numfactu : "PAGO DE FACTURA N°" + " " + props.numfactu,
	          idcliente: props.idclient,
	          idvendedor: idvendedor,
	          idfactura: idfactu,
	          monto: totaldolares + totalesr,
	          descuento: 0.00,
	          iva: props.iva,
	          montoiva: props.montoiva,
	          abono: 0.00,
	          total: totaldolares + totalesr,
	          sobrante: parseFloat(totalsobra),
	          fecharegistro: txtFechaPago.current.value,
	          tipofac: props.tipo === "notaentrega" ? "NE" : props.tipo === "debito" ? "ND" : "FA",
	          numfactura: numfactu,
	          status: (0, _varios.formatMoneda)(totaldolares.toString().replace(",", "").replace(".", ","), ",", ".", 2) === (0, _varios.formatMoneda)(totaldeuda.toString().replace(",", "").replace(".", ","), ",", ".", 2) ? 1 : 0,
	          idmoneda: idmone,
	          valormoneda: valormone,
	          montodeuda: totaldeuda
	        });
	
	        for (var i = 0; i < records.length; i++) {
	
	          pagodetalle.push(Object.assign({
	            idpago: 0,
	            monto: records[i].tipo === 7 || records[i].tipo === 8 || records[i].tipo === 9 || records[i].tipo === 10 ? records[i].montodefinic : records[i].montos,
	            nroreferencia: records[i].referencia,
	            idmoneda: records[i].tipodivisa,
	            numcredito: records[i].notacredito,
	            factorcambio: records[i].valormoneda,
	            moneda: records[i].simbolo === "$" ? "DOLAR" : records[i].simbolo === "€" ? "EURO" : "BOLIVARES",
	            tipo: records[i].tipo,
	            fechaemision: records[i].fechapago,
	            idcuenta: records[i].idbanco
	          }, records[i].tipo === 10 && {
	            idretiene: 0,
	            porc_unidad: records[i].porc,
	            idretencion: records[i].tiporeten,
	            idusuario: idvendedor,
	            numorden: numfactu
	          }, {
	            idreten: records[i].tiporeten
	          }));
	        }
	        setBody({
	          notaentre: props.notentraga,
	          notaentredet: props.notaentregadeta,
	          pagos: pago,
	          pagosdeta: pagodetalle,
	          app: false,
	          ncaja: ncaja,
	          fecharev: null,
	          fechapag: null,
	          nidcaja: null,
	          idusu: null,
	          motivo: '',
	          opinv: props.opinvc,
	          opeinvdet: props.opeinvdetc
	        });
	
	        var msg = "";
	        if (props.ope === 1 || props.ope === 2) {
	          msg = "Esta Seguro de Registrar este Pago.";
	        }
	
	        setMensajesino({
	          mostrar: true,
	          titulo: "Confirmación.",
	          texto: msg,
	          icono: "confirmacion"
	        });
	      }
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var operacion = void 0;
	    if (props.notentraga[0].idnotaentrega > 0) {
	      operacion = props.ope;
	    } else {
	      operacion = 1;
	    }
	
	    var endpoint = op.conexion + "/api/inventario/actualizarpostventas/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (props.ope === 1 || props.ope === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Pago Registrado Correctamente",
	            icono: "exito"
	          });
	
	          if (props.tipo === "notaentrega") {
	            if (sessionStorage.getItem("bluetooth") === "true") {
	              props.ticketBluetooth(response.data.idnotaent);
	            } else {
	              imprimirFactura(response.data.idnotaent);
	            }
	          } else {
	            imprimirFactura(response.data.idnotaent);
	          }
	        }
	        blanquear();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = error.response.data.message;
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    props.onHideCancelar();
	    props.onRenderizar();
	  };
	
	  var imprimirFactura = function imprimirFactura(factu) {
	
	    var endpoint = "http://localhost:9000/imprimir?idfactura=" + ("'" + factu + "'") + "&logo1=logo1.png";
	
	    _axios2.default.get(endpoint).then(function (response) {
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarReten = function seleccionarReten(numorden) {
	    var campos = "idretencion";
	    var nomtab = "retiene";
	    var nomid = "numorden";
	    var endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + numorden;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRetencionesid(response.data);
	        } else {
	          setRetencionesid([]);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarMonedas = function seleccionarMonedas(fecha) {
	
	    var endpoint = op.conexion + "/api/moneda/selectmonedas?fecha=" + fecha;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idmoneda > 0) {
	          setComboMoneda(response.data);
	          setIdmon(response.data.idmoneda);
	
	          var valormoney = response.data.valor;
	          var total = 0.0;
	          var _idmone = response.data.idmoneda;
	
	          setTasa(valormoney);
	          setValormone(valormoney);
	          setIdmone(_idmone);
	
	          var datos = [].concat(_toConsumableArray(records));
	          var montototal = 0.0;
	          var restbs = 0.0;
	          var data = [];
	          var predeterminada = void 0;
	          var montod = totaldeuda;
	          var calcular = 0.0;
	          var sobrante = 0.0;
	          var totalm = 0.0;
	          var tosobrabs = 0.0;
	          var calcularbs = 0.0;
	          var montbs = 0.0;
	          var montrestabs = 0.0;
	          var restabss = 0.0;
	          var reten = 0.0;
	          var tore = 0.0;
	
	          restbs = totaldeuda > 0 ? (0, _varios.round)(totaldeuda, 2) * response.data.valor : props.monto * response.data.valor;
	          predeterminada = response.data.valor;
	
	          if (datos.length > 0) {
	            for (var e = 0; e < datos.length; e++) {
	              data.push({
	                forma: datos[e].tipo === 1 ? "Efectivo Bs" : datos[e].tipo === 2 ? "Tarjeta(Debito) Bs" : datos[e].tipo === 3 ? "Tarjeta(Crédito) Bs" : datos[e].tipo === 4 ? "Pago Movil Bs" : datos[e].tipo === 5 ? "Deposito Bancario Bs" : datos[e].tipo === 6 ? "Transferencia Bancaria Bs" : datos[e].tipo === 7 ? "Divisa" + " " + datos[e].simbolo : datos[e].tipo === 8 ? "Saldo a Credito $" : datos[e].tipo === 9 ? "Saldo Anticipo $" : datos[e].forma,
	                montos: datos[e].montos,
	                index: datos[e].index,
	                fechapago: datos[e].fechapago,
	                tipo: datos[e].tipo,
	                tipodivisa: datos[e].tipodivisa,
	                montoalcambio: datos[e].tipo === 8 || datos[e].tipo === 9 || datos[e].tipo === 10 || datos[e].tipo === 7 && datos[e].tipodivisa === idmon ? datos[e].montos * response.data.valor : datos[e].montoalcambio,
	                montodefinic: datos[e].tipo === 7 && datos[e].tipodivisa !== idmon ? datos[e].montoalcambio / response.data.valor : datos[e].tipo === 8 || datos[e].tipo === 9 || datos[e].tipo === 10 || datos[e].tipo === 7 && datos[e].tipodivisa === idmon ? datos[e].montodefinic * response.data.valor / response.data.valor : datos[e].montoalcambio / response.data.valor,
	                notacredito: datos[e].tipo === 8 || datos[e].tipo === 9 ? datos[e].notacredito : "",
	                valormoneda: datos[e].tipo === 7 && datos[e].tipodivisa !== idmon ? datos[e].valormoneda : datos[e].tipo === 8 || datos[e].tipo === 9 || datos[e].tipo === 10 || datos[e].tipo === 7 && datos[e].tipodivisa === idmon ? response.data.valor : datos[e].valormoneda,
	                idbanco: datos[e].idbanco,
	                referencia: datos[e].referencia,
	                simbolo: datos[e].simbolo
	              });
	            }
	
	            for (var i = 0; i < data.length; i++) {
	
	              if (data[i].tipo === 10) {
	                reten = parseFloat(reten) + parseFloat(data[i].montodefinic);
	              } else {
	                montototal = parseFloat(montototal) + parseFloat(data[i].montodefinic);
	              }
	            }
	
	            total = (0, _varios.round)(montod, 2) - (0, _varios.round)(montototal, 2) - (0, _varios.round)(reten, 2);
	            calcular = (0, _varios.round)(montototal, 2) > (0, _varios.round)(montod, 2) ? "0,00" : total;
	            sobrante = (0, _varios.round)(montototal + reten, 2) > (0, _varios.round)(montod, 2) ? Math.abs(total) : "0,00";
	            totalm = montototal * predeterminada;
	            tore = reten * predeterminada;
	            tosobrabs = sobrante * predeterminada;
	
	            montbs = (0, _varios.round)(montod, 2) * predeterminada;
	            montrestabs = (0, _varios.round)(montod, 2) * predeterminada - totalm - tore;
	            restabss = (0, _varios.round)(montototal, 2) * predeterminada;
	            calcularbs = restabss > montbs ? "0,00" : montrestabs;
	
	            setSobrabs(Math.abs(tosobrabs));
	            setRestabs(Math.abs(calcularbs));
	            setTotalresta(Math.abs(calcular));
	            setTotalsobra(sobrante);
	            setTotaldolares(montototal);
	            setTotalesr(reten);
	            setTotalesrb(tore);
	            setTotales(totalm);
	          } else {
	            setRestabs(Math.abs(restbs));
	          }
	          setRecords(data);
	          /* if (totaldeuda <= 0) {
	            setTotaldeuda(props.monto);
	          } */
	          setTotaldeudabs(restbs);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var handleAceptaDatos = function handleAceptaDatos(values) {
	    setMostrar1(false);
	
	    var predeterminada = void 0;
	    var totalm = 0.0;
	    var idmoney = void 0;
	    var valormoney = 0.0;
	    var indx = 0;
	    var credito = 0.0;
	    var credit = 0.0;
	
	    var datos = [].concat(_toConsumableArray(records));
	    var montod = totaldeuda;
	    var montototal = 0.0;
	    var total = 0.0;
	    var calcular = 0.0;
	    var sobrante = 0.0;
	    var reten = 0.0;
	    var tore = 0.0;
	
	    for (var b = 0; b < datos.length; b++) {
	      if (datos[b].index > 0) {
	        indx = datos[b].index + 1;
	      } else {
	        indx = indx + 1;
	      }
	    }
	
	    for (var i = 0; i < values.length; i++) {
	      idmoney = values[i].tipodivisa;
	
	      predeterminada = tasa;
	
	      datos.push({
	        forma: values[i].formapago === 1 ? "Efectivo Bs" : values[i].formapago === 2 ? "Tarjeta(Debito) Bs" : values[i].formapago === 3 ? "Tarjeta(Crédito) Bs" : values[i].formapago === 4 ? "Pago Movil Bs" : values[i].formapago === 5 ? "Deposito Bancario Bs" : values[i].formapago === 6 ? "Transferencia Bancaria Bs" : values[i].formapago === 7 ? "Divisa" + " " + values[i].simbolo : values[i].formapago === 8 ? "Saldo a Credito $" : "Saldo Anticipo $",
	        montos: values[i].monto,
	        fechapago: values[i].fecha,
	        tipo: values[i].formapago,
	        tipodivisa: values[i].tipodivisa,
	        montoalcambio: values[i].formapago === 7 && values[i].tipodivisa === idmon ? values[i].monto * predeterminada : values[i].formapago === 7 && values[i].tipodivisa !== idmon ? values[i].monto * valormoney : values[i].formapago === 8 || values[i].formapago === 9 ? values[i].monto * predeterminada : values[i].monto,
	        montodefinic: values[i].formapago === 7 && values[i].tipodivisa === idmon ? values[i].monto * predeterminada / predeterminada : values[i].formapago === 7 && values[i].tipodivisa !== idmon ? values[i].monto * valormoney / predeterminada : values[i].formapago === 8 || values[i].formapago === 9 ? values[i].monto : values[i].monto / predeterminada,
	        index: indx,
	        notacredito: values[i].formapago === 8 || values[i].formapago === 9 ? values[i].notacredito : "",
	        valormoneda: values[i].formapago === 7 && values[i].tipodivisa !== idmon ? values[i].valormoneda : values[i].formapago === 8 || values[i].formapago === 9 || values[i].formapago === 7 && values[i].tipodivisa === idmon ? predeterminada : values[i].valormoneda,
	        idbanco: values[i].idbanco,
	        referencia: values[i].referencia,
	        simbolo: values[i].simbolo,
	        tiporeten: values[i].codigo,
	        porc: values[i].porc > 0 ? values[i].porc : ""
	      });
	    }
	
	    for (var e = 0; e < datos.length; e++) {
	
	      if (datos[e].tipo === 10) {
	        reten = parseFloat(reten) + parseFloat(datos[e].montodefinic);
	      } else {
	        montototal = parseFloat(montototal) + parseFloat(datos[e].montodefinic);
	      }
	
	      if (datos[e].tipo === 8 || datos[e].tipo === 9) {
	        credito = parseFloat(datos[e].montodefinic);
	      } else {
	        credito = totalcredito;
	      }
	    }
	
	    var totalcredit = 0.0;
	
	    if (values[0].formapago === 8) {
	      credit = parseFloat(totalcredito) - credito;
	    } else {
	      credit = totalcredito;
	    }
	
	    if (values[0].formapago === 9) {
	      credit = parseFloat(anticipos) - credito;
	    } else {
	      credit = anticipos;
	    }
	
	    var tosobrabs = 0.0;
	    var totalanticipo = 0.0;
	    var calcularbs = 0.0;
	    var montbs = 0.0;
	    var montrestabs = 0.0;
	    var restabss = 0.0;
	
	    totalcredit = values[0].formapago === 8 ? credit >= parseFloat(totalcredito) ? "0,00" : credit : totalcredito;
	    totalanticipo = values[0].formapago === 9 ? credit >= parseFloat(anticipos) ? "0,00" : credit : anticipos;
	    total = (0, _varios.round)(montod, 2) - (0, _varios.round)(montototal, 2) - (0, _varios.round)(reten, 2);
	    calcular = (0, _varios.round)(montototal, 2) > (0, _varios.round)(montod, 2) ? "0,00" : total;
	    sobrante = (0, _varios.round)(montototal + reten, 2) > (0, _varios.round)(montod, 2) ? Math.abs(total) : "0,00";
	    totalm = montototal * predeterminada;
	    tore = reten * predeterminada;
	    tosobrabs = sobrante * predeterminada;
	
	    montbs = (0, _varios.round)(montod, 2) * predeterminada;
	    montrestabs = (0, _varios.round)(montod, 2) * predeterminada - totalm - tore;
	    restabss = (0, _varios.round)(montototal, 2) * predeterminada;
	    calcularbs = restabss > montbs ? "0,00" : montrestabs;
	
	    setAnticipos(totalanticipo);
	    setSobrabs(Math.abs(tosobrabs));
	    setRestabs(Math.abs(calcularbs));
	    setTotalcredito(totalcredit);
	    setTotalresta(Math.abs(calcular));
	    setTotalsobra(sobrante);
	    setTotaldolares(montototal);
	    setTotales(totalm);
	    setRecords(datos);
	  };
	
	  var handleAceptaDatosReten = function handleAceptaDatosReten(values) {
	    setMostrar3(false);
	
	    var predeterminada = void 0;
	    var totalm = 0.0;
	    var idmoney = void 0;
	    var indx2 = 0;
	    var indx = 0;
	    var tore = 0.0;
	    var reten = 0.0;
	
	    var datos = [].concat(_toConsumableArray(records));
	    var montod = totaldeuda;
	    var montototal = 0.0;
	    var total = 0.0;
	    var calcular = 0.0;
	    var sobrante = 0.0;
	
	    if (retencionesid.length > 0) {
	      for (var c = 0; c < retencionesid.length; c++) {
	        if (parseInt(retencionesid[c].idretencion) === parseInt(values[0].codigo)) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "¡ Este Tipo de Retención ya fue Procesada !",
	            icono: "informacion"
	          });
	          return;
	        }
	      }
	    } else {
	      for (var b = 0; b < datos.length; b++) {
	
	        if (parseInt(datos[b].tiporeten) === parseInt(values[0].codigo)) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "¡ Este Tipo de Retención ya fue Procesada !",
	            icono: "informacion"
	          });
	          return;
	        }
	
	        indx = indx;
	      }
	    }
	
	    for (var i = 0; i < values.length; i++) {
	
	      idmoney = idmon;
	
	      predeterminada = tasa;
	
	      indx === 0 ? indx2 = indx2 + 1 : indx + 1;
	
	      datos.push({
	        forma: values[i].descripcion,
	        montos: values[i].monto,
	        fechapago: values[i].fecha,
	        tipo: values[i].formapago,
	        tipodivisa: idmoney,
	        montoalcambio: values[i].monto * predeterminada,
	        montodefinic: values[i].monto,
	        index: indx2,
	        notacredito: "",
	        valormoneda: predeterminada,
	        idbanco: values[i].idbanco,
	        referencia: values[i].referencia,
	        simbolo: values[i].simbolo,
	        tiporeten: values[i].codigo,
	        porc: values[i].porc
	      });
	    }
	
	    for (var e = 0; e < datos.length; e++) {
	
	      if (datos[e].tipo === 10) {
	        reten = parseFloat(reten) + parseFloat(datos[e].montodefinic);
	      } else {
	        montototal = parseFloat(montototal) + parseFloat(datos[e].montodefinic);
	      }
	    }
	
	    var tosobrabs = 0.0;
	    var totalanticipo = 0.0;
	    var calcularbs = 0.0;
	    var montbs = 0.0;
	    var montrestabs = 0.0;
	    var restabss = 0.0;
	
	    total = (0, _varios.round)(montod, 2) - (0, _varios.round)(montototal, 2) - (0, _varios.round)(reten, 2);
	    calcular = (0, _varios.round)(montototal, 2) > (0, _varios.round)(montod, 2) ? "0,00" : total;
	    sobrante = (0, _varios.round)(montototal + reten, 2) > (0, _varios.round)(montod, 2) ? Math.abs(total) : "0,00";
	    totalm = montototal * predeterminada;
	    tore = reten * predeterminada;
	    tosobrabs = sobrante * predeterminada;
	
	    montbs = (0, _varios.round)(montod, 2) * predeterminada;
	    montrestabs = (0, _varios.round)(montod, 2) * predeterminada - totalm - tore;
	    restabss = (0, _varios.round)(montototal, 2) * predeterminada;
	    calcularbs = restabss > montbs ? "0,00" : montrestabs;
	
	    setAnticipos(totalanticipo);
	    setSobrabs(Math.abs(tosobrabs));
	    setRestabs(Math.abs(calcularbs));
	    setTotalresta(Math.abs(calcular));
	    setTotalsobra(sobrante);
	    setTotaldolares(montototal);
	    setTotales(totalm);
	    setTotalesr(reten);
	    setTotalesrb(tore);
	    setRecords(datos);
	  };
	
	  var calcularTotales = function calcularTotales(data, datos) {
	    var predeterminada = void 0;
	    var montod = totaldeuda;
	    var montototal = 0.0;
	    var total = 0.0;
	    var calcular = 0.0;
	    var sobrante = 0.0;
	    var totalm = 0.0;
	    var credito = 0.0;
	    var credit = 0.0;
	    var ant = 0.0;
	    var mant = 0.0;
	    var tore = 0.0;
	    var reten = 0.0;
	    var tocredict = totalcredito;
	    var totalanticipo = anticipos;
	
	    predeterminada = tasa;
	
	    for (var e = 0; e < data.length; e++) {
	
	      for (var c = 0; c < datos.length; c++) {
	
	        if (datos[c].tipo === 10) {
	          reten = parseFloat(reten) + parseFloat(datos[c].montodefinic);
	        } else {
	          montototal = parseFloat(montototal) + parseFloat(datos[c].montodefinic);
	        }
	      }
	
	      if (data[e].tipo === 8) {
	        credito = parseFloat(data[e].montodefinic);
	        credit = parseFloat(tocredict) + credito;
	      } else {
	        credito = tocredict;
	        credit = tocredict;
	      }
	
	      if (data[e].tipo === 9) {
	        ant = parseFloat(data[e].montodefinic);
	        mant = parseFloat(totalanticipo) + ant;
	      } else {
	        ant = totalanticipo;
	        mant = totalanticipo;
	      }
	    }
	
	    var totalcredit = 0.0;
	    var restabs = 0.0;
	    var tosobrabs = 0.0;
	    var toanticipo = 0.0;
	
	    totalcredit = credit;
	    toanticipo = mant;
	
	    total = (0, _varios.round)(montod, 2) - (0, _varios.round)(montototal, 2) - (0, _varios.round)(reten, 2);
	    calcular = montototal > (0, _varios.round)(montod, 2) ? "0,00" : total;
	    sobrante = montototal > (0, _varios.round)(montod, 2) ? total : "0,00";
	    totalm = (0, _varios.round)(montototal, 2) * predeterminada;
	    tore = (0, _varios.round)(reten, 2) * predeterminada;
	
	    restabs = calcular * predeterminada;
	    tosobrabs = sobrante * predeterminada;
	
	    setAnticipos(toanticipo);
	    setSobrabs(Math.abs(tosobrabs));
	    setRestabs(Math.abs(restabs));
	    setTotalcredito(totalcredit);
	    setTotalresta(Math.abs(calcular));
	    setTotalsobra(sobrante);
	    setTotalesr(reten);
	    setTotalesrb(tore);
	    setTotaldolares(montototal);
	    setTotales(totalm);
	  };
	
	  var handleAceptaValorMoneda = function handleAceptaValorMoneda(values) {
	    setMostrar2(false);
	
	    setTasa(values.valor);
	    setValormone(values.valor);
	    setIdmone(values.idmoneda);
	
	    var datos = [].concat(_toConsumableArray(records));
	    var montototal = 0.0;
	    var restbs = 0.0;
	    var data = [];
	    var predeterminada = void 0;
	    var montod = totaldeuda;
	    var total = 0.0;
	    var calcular = 0.0;
	    var sobrante = 0.0;
	    var totalm = 0.0;
	    var tosobrabs = 0.0;
	    var calcularbs = 0.0;
	    var montbs = 0.0;
	    var montrestabs = 0.0;
	    var restabss = 0.0;
	    var reten = 0.0;
	    var tore = 0.0;
	
	    restbs = (0, _varios.round)(totaldeuda, 2) * values.valor;
	    predeterminada = values.valor;
	
	    if (datos.length > 0) {
	      for (var e = 0; e < datos.length; e++) {
	        data.push({
	          forma: datos[e].tipo === 1 ? "Efectivo Bs" : datos[e].tipo === 2 ? "Tarjeta(Debito) Bs" : datos[e].tipo === 3 ? "Tarjeta(Crédito) Bs" : datos[e].tipo === 4 ? "Pago Movil Bs" : datos[e].tipo === 5 ? "Deposito Bancario Bs" : datos[e].tipo === 6 ? "Transferencia Bancaria Bs" : datos[e].tipo === 7 ? "Divisa" + " " + datos[e].simbolo : datos[e].tipo === 8 ? "Saldo a Credito $" : datos[e].tipo === 9 ? "Saldo Anticipo $" : datos[e].forma,
	          montos: datos[e].montos,
	          index: datos[e].index,
	          fechapago: datos[e].fechapago,
	          tipo: datos[e].tipo,
	          tipodivisa: datos[e].tipodivisa,
	          montoalcambio: datos[e].tipo === 8 || datos[e].tipo === 9 || datos[e].tipo === 10 || datos[e].tipo === 7 && datos[e].tipodivisa === idmon ? datos[e].montos * values.valor : datos[e].montoalcambio,
	          montodefinic: datos[e].tipo === 7 && datos[e].tipodivisa !== idmon ? datos[e].montoalcambio / values.valor : datos[e].tipo === 8 || datos[e].tipo === 9 || datos[e].tipo === 10 || datos[e].tipo === 7 && datos[e].tipodivisa === idmon ? datos[e].montodefinic * values.valor / values.valor : datos[e].montoalcambio / values.valor,
	          notacredito: datos[e].tipo === 8 || datos[e].tipo === 9 ? datos[e].notacredito : "",
	          valormoneda: datos[e].tipo === 7 && datos[e].tipodivisa !== idmon ? datos[e].valormoneda : datos[e].tipo === 8 || datos[e].tipo === 9 || datos[e].tipo === 10 || datos[e].tipo === 7 && datos[e].tipodivisa === idmon ? values.valor : datos[e].valormoneda,
	          idbanco: datos[e].idbanco,
	          referencia: datos[e].referencia,
	          simbolo: datos[e].simbolo
	        });
	      }
	
	      for (var i = 0; i < data.length; i++) {
	
	        if (data[i].tipo === 10) {
	          reten = parseFloat(reten) + parseFloat(data[i].montodefinic);
	        } else {
	          montototal = parseFloat(montototal) + parseFloat(data[i].montodefinic);
	        }
	      }
	
	      total = (0, _varios.round)(montod, 2) - (0, _varios.round)(montototal, 2) - (0, _varios.round)(reten, 2);
	      calcular = (0, _varios.round)(montototal, 2) > (0, _varios.round)(montod, 2) ? "0,00" : total;
	      sobrante = (0, _varios.round)(montototal + reten, 2) > (0, _varios.round)(montod, 2) ? Math.abs(total) : "0,00";
	      totalm = montototal * predeterminada;
	      tore = reten * predeterminada;
	      tosobrabs = sobrante * predeterminada;
	
	      montbs = (0, _varios.round)(montod, 2) * predeterminada;
	      montrestabs = (0, _varios.round)(montod, 2) * predeterminada - totalm - tore;
	      restabss = (0, _varios.round)(montototal, 2) * predeterminada;
	      calcularbs = restabss > montbs ? "0,00" : montrestabs;
	
	      setSobrabs(Math.abs(tosobrabs));
	      setRestabs(Math.abs(calcularbs));
	      setTotalresta(Math.abs(calcular));
	      setTotalsobra(sobrante);
	      setTotaldolares(montototal);
	      setTotalesr(reten);
	      setTotalesrb(tore);
	      setTotales(totalm);
	    } else {
	      setRestabs(Math.abs(restbs));
	    }
	
	    setRecords(data);
	    setTotaldeudabs(restbs);
	  };
	
	  var eliminarFila = function eliminarFila(values) {
	    return function (e) {
	      e.preventDefault();
	      var data = [].concat(_toConsumableArray(records));
	      var elementos = [];
	      var eliminado = [];
	
	      for (var i = 0; i < data.length; i++) {
	        if (values !== data[i].index) {
	          elementos.push(data[i]);
	        }
	
	        if (values === data[i].index) {
	          eliminado.push(data[i]);
	        }
	      }
	
	      setRecords(elementos);
	      calcularTotales(eliminado, elementos);
	    };
	  };
	
	  var onGestionar = function onGestionar(op) {
	    return function (e) {
	      if (op === 1) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 2) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 3) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 4) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 5) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 6) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 7) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 8) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 9) {
	        setOperacion(op);
	        setMostrar1(true);
	      } else if (op === 10) {
	        setOperacion(op);
	        setMostrar3(true);
	      }
	    };
	  };
	
	  var seleccionarCredito = function seleccionarCredito(id) {
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/seleccionarcredito?idcliente=" + id;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var montototal = 0.0;
	
	          for (var i = 0; i < response.data.length; i++) {
	            montototal = parseFloat(montototal) + parseFloat(response.data[i].totalmonto);
	          }
	
	          setTotalcredito(montototal);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === 'fecha') {
	      seleccionarMonedas(e.target.value);
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: "xl",
	      style: { backgroundColor: "rgb(0,0,0,0.5)" },
	      "aria-labelledby": "contained-modal-title-vcenter",
	      centered: true,
	      backdrop: "static",
	      keyboard: false,
	      onShow: function onShow() {
	        if (props.ope === 1 || props.ope === 2) {
	          setIdvendedor(props.idvendedor);
	          setIdfactu(null);
	          setNumfactu(props.numfactu);
	          setTotaldeuda(props.monto);
	          setTotalresta(props.monto);
	          seleccionarCredito(props.idclient);
	          setAnticipos(0.00);
	          txtFechaPago.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          if (props.tipo === "notaentrega") {
	            setTiponot("NE");
	          } else {
	            setTiponot("ND");
	          }
	
	          var fech = (0, _moment2.default)(fechasistema).format('YYYY-MM-DD');
	          seleccionarMonedas(fech);
	        } else {}
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: "azulGradiant2 header-modal" },
	      _react2.default.createElement(
	        "div",
	        { className: "fw-bold", style: { color: "#fff" } },
	        _react2.default.createElement(
	          "h3",
	          null,
	          props.tipo === "debito" ? "Registrar Pago - (Nota de Debito)" : props.tipo === "notaentrega" ? "Registrar Pago - (Nota de Entrega)" : "Registrar Pago - (Factura)"
	        )
	      ),
	      _react2.default.createElement(
	        "a",
	        {
	          href: "#",
	          ref: btnSalir,
	          disabled: botones.salir,
	          onClick: cancelar,
	          className: "text-light"
	        },
	        _react2.default.createElement(
	          "i",
	          { className: "fas fa-times fa-1x shadow" },
	          " "
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, {
	        mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === "Exito." ? cerrarModal() : setMensaje({
	            mostrar: false,
	            titulo: "",
	            texto: "",
	            icono: ""
	          });
	        }
	      }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, {
	        mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	        },
	        onHideSi: handleCloseSi
	      }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          "cargando..."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12 row mx-auto px-0" },
	        _react2.default.createElement(
	          "div",
	          { className: "row col-md-12 rounded mx-auto" },
	          _react2.default.createElement(
	            "fieldset",
	            {
	              className: "row col-sm-12 mx-auto border-azul rounded mb-1",
	              style: { fontSizeAdjust: "0.6" }
	            },
	            _react2.default.createElement(
	              "legend",
	              { className: "float-none m-0 w-auto fs-4 fw-bold" },
	              "Datos"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4 col-sm-12 row m-0 px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-280 px-1 py-2 mb-2" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA DE PAGO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "date",
	                    ref: txtFechaPago,
	                    disabled: props.ope === 0 ? true : false,
	                    name: "fecha",
	                    onChange: onChange,
	                    className: "form-control fs-6 text-uppercase",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-8 col-sm-12 row m-0 px-0 border-azul d-flex align-items-center",
	                style: { background: "#cfe2ff", borderRadius: "3px" }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-5 px-1 row m-0",
	                  style: { fontSizeAdjust: "0.5" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  { className: "col-pd-130 px-1 text-left fs-5" },
	                  "Total a Pagar:",
	                  " "
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "col px-0 fw-bold text-right fs-5" },
	                  "\xA0",
	                  (0, _varios.formatMoneda)(totaldeuda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                  "\xA0$"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-6 px-1 row m-0 ml-auto",
	                  style: { fontSizeAdjust: "0.5" }
	                },
	                _react2.default.createElement(
	                  "label",
	                  { className: "col-pd-180 px-1 text-left fs-5" },
	                  "Total a Pagar Bs:",
	                  " "
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "col px-0 fw-bold text-right fs-5" },
	                  "\xA0",
	                  (0, _varios.formatMoneda)(totaldeudabs.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-4 col-sm-12 row m-0 px-0 d-flex justify-content-center border-azul py-2",
	                style: { background: "#cfe2ff", borderRadius: "3px" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 mb-2 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(1),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-money-bill-alt fs-5 mr-2" }),
	                  " Efectivo Bs"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(7),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-dollar-sign fs-5 mr-2" }),
	                  " Divisas"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 mb-2 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(2),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-credit-card fs-5 mr-2" }),
	                  " Tarjeta de Debito"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 mb-2 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(3),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fab fa-cc-visa fw-bold fs-5 mr-2" }),
	                  " Tarjeta de Credito"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 mb-2 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(6),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-money-check fs-5 mr-2" }),
	                  " Deposito Bancario"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 mb-2 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(5),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-laptop fs-5 mr-2" }),
	                  " Transferencia Bancaria"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 mb-2 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta
	                    /* disabled={habilitado} */, style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(4),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-mobile-alt fs-5 mr-2" }),
	                  " Pago Movil"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta,
	                    disabled: props.siescredit !== 1 ? true : false,
	                    style: { height: "80px", fontSize: "14px" },
	                    onClick: onGestionar(8),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-money-check-alt fs-5 mr-2" }),
	                  " Saldo a Credito",
	                  " ",
	                  (0, _varios.formatMoneda)(totalcredito.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta,
	                    disabled: props.siesanticipo !== 1 ? true : false,
	                    style: { height: "80px", fontSize: "14px" },
	                    onClick: onGestionar(9),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-pager fs-5 mr-2" }),
	                  " Saldo en Anticipo",
	                  " ",
	                  (0, _varios.formatMoneda)(anticipos.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-6 d-flex justify-content-center" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta,
	                    disabled: props.esretenedor === 1 ? false : true,
	                    style: {
	                      height: "80px",
	                      fontSize: "14px"
	                    },
	                    onClick: onGestionar(10),
	                    className: "btn btn-sm btn-light col-pd-150 p-1 border-3 border-light text-capitalize fw-bold"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-hand-holding-usd fs-5 mr-2" }),
	                  " Retenciones"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-8 col-sm-12 px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-12 px-0" },
	                _react2.default.createElement(
	                  TblContainer,
	                  {
	                    container: {
	                      height: "290px",
	                      width: "100%",
	                      overflow: "auto",
	                      padding: "2px"
	                    }
	                  },
	                  _react2.default.createElement(TblHead, null),
	                  _react2.default.createElement(
	                    _semanticUiReact.TableBody,
	                    { className: "overflow-hidden table-bordered" },
	                    records && records.map(function (item, index) {
	                      return _react2.default.createElement(
	                        _semanticUiReact.TableRow,
	                        {
	                          key: index,
	                          style: { padding: "0", cursor: "pointer" }
	                        },
	                        _react2.default.createElement(
	                          _semanticUiReact.TableCell,
	                          { className: "align-baseline text-center" },
	                          item.forma
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.TableCell,
	                          { className: "align-baseline text-center" },
	                          item.referencia
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.TableCell,
	                          { className: "align-middle text-right" },
	                          (0, _varios.formatMoneda)(item.montos.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.TableCell,
	                          { className: "align-baseline text-right" },
	                          (0, _varios.formatMoneda)(item.montoalcambio.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                        ),
	                        _react2.default.createElement(
	                          _semanticUiReact.TableCell,
	                          { className: "align-baseline text-center" },
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              className: "btn btn-sm mx-1 btn-danger",
	                              onClick: eliminarFila(item.index)
	                            },
	                            _react2.default.createElement("i", { className: "fa fa-trash" }),
	                            " "
	                          )
	                        )
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-12 row m-0 border-azul px-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-5 col-sm-4 px-0" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-pd-280 col-sm-10 col-sm-12 mx-auto mt-2" },
	                    _react2.default.createElement(
	                      "div",
	                      {
	                        className: "col-pd-210 row m-0 py-1 mx-auto d-flex align-items-center",
	                        style: { fontSizeAdjust: "0.5" }
	                      },
	                      _react2.default.createElement(
	                        "span",
	                        { className: "col-pd-90 px-1 text-left fs-5 fw-bold" },
	                        "Tasa 1$ =",
	                        " "
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        { className: "col-pd-70 px-0 fw-bold fs-5" },
	                        "\xA0",
	                        tasa && (0, _varios.formatMoneda)(tasa.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        { className: "col-pd-50 px-0" },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            type: "button",
	                            disabled: props.ope === 0 ? true : false,
	                            onClick: function onClick() {
	                              /* setCualCat(2); */
	                              setMostrar2(true);
	                            },
	                            className: "btn btn-primary"
	                          },
	                          _react2.default.createElement("i", { className: "fas fa-search" })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement("img", { src: "imagenes/logo.ico", className: "img-fluid" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "col-md-7 col-sm-8 ml-auto px-0 row m-0 d-flex align-items-center border-azul py-2",
	                    style: {
	                      background: "#cfe2ff",
	                      borderRadius: "3px",
	                      fontSizeAdjust: "0.5"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 row m-0 py-1",
	                      style: { fontSizeAdjust: "0.5" }
	                    },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "col-4 px-1 text-left fs-5" },
	                      "Total $:",
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "col px-0 fw-bold text-right fs-5" },
	                      "\xA0",
	                      (0, _varios.formatMoneda)(totaldolares.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 row m-0 py-1",
	                      style: { fontSizeAdjust: "0.5" }
	                    },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "col-4 px-1 text-left fs-5" },
	                      "Total Bs:",
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "col px-0 fw-bold text-right fs-5" },
	                      "\xA0",
	                      (0, _varios.formatMoneda)(totales.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 row m-0 py-1",
	                      style: { fontSizeAdjust: "0.5" }
	                    },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "col-pd-200 px-1 text-left fs-5" },
	                      "Total Retenciones $:",
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "col px-0 fw-bold text-right fs-5" },
	                      "\xA0",
	                      (0, _varios.formatMoneda)(totalesr.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 row m-0 py-1",
	                      style: { fontSizeAdjust: "0.5" }
	                    },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "col-pd-200 px-1 text-left fs-5" },
	                      "Total Retenciones Bs:",
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "col px-0 fw-bold text-right fs-5" },
	                      "\xA0",
	                      (0, _varios.formatMoneda)(totalesrb.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 row m-0 py-1",
	                      style: { fontSizeAdjust: "0.5" }
	                    },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "col-pd-180 px-1 text-left fs-5" },
	                      totalsobra > 0 ? "Sobrante $:" : "Restante a Pagar $:",
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "col px-0 fw-bold text-right fs-5" },
	                      "\xA0",
	                      totalsobra > 0 ? (0, _varios.formatMoneda)(totalsobra.toString().replace(",", "").replace(".", ","), ",", ".", 2) : (0, _varios.formatMoneda)(totalresta.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-12 px-1 row m-0 py-1",
	                      style: { fontSizeAdjust: "0.5" }
	                    },
	                    _react2.default.createElement(
	                      "label",
	                      { className: "col-pd-200 px-2 text-left fs-5" },
	                      sobrabs > 0 ? "Sobrante Bs:" : "Restante a Pagar Bs:"
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "col px-1 fw-bold text-right fs-5" },
	                      "\xA0",
	                      sobrabs > 0 ? (0, _varios.formatMoneda)(sobrabs.toString().replace(",", "").replace(".", ","), ",", ".", 2) : (0, _varios.formatMoneda)(restabs.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "row m-0 col-md-12 mx-auto" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-4 ml-auto px-0 m-0 d-flex justify-content-end" },
	          _react2.default.createElement(
	            "button",
	            {
	              ref: btnAcepta,
	              disabled: props.ope === 0 ? true : false,
	              onClick: onChangeValidar,
	              className: "btn btn-sm rounded-pill btn-success mx-1"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-sync-alt" },
	              " ",
	              "Procesar Pago"
	            )
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              ref: btnCancela,
	              onClick: cancelar,
	              className: "btn btn-danger btn-sm rounded-pill mx-1"
	            },
	            _react2.default.createElement(
	              "i",
	              { className: "fas fa-window-close" },
	              " ",
	              "Cancelar"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_modalAgreProcesosMontos.ProcesosMontos, {
	      show: mostrar1,
	      ope: operacion,
	      data: records,
	      idclients: props.idclient,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar1(false);
	      },
	      onHideAceptaData: handleAceptaDatos
	    }),
	    _react2.default.createElement(_catalogoValorMoneda2.default, {
	      show: mostrar2,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrar2(false);
	      },
	      onHideAceptaCatalogo: handleAceptaValorMoneda
	    })
	  );
	};

/***/ },
/* 7168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalPicking = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _reportePickingPDF = __webpack_require__(675);
	
	var _reportePedidoPDF = __webpack_require__(7172);
	
	__webpack_require__(7195);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var TIPO_PEDIDO = '0';
	var TIPO_NOTA = '1';
	var STATUS_POR_DESPACHAR = '0';
	var STATUS_DESPACHADO = '1';
	
	var fechaValida = function fechaValida(valor) {
	  return (/^\d{4}-\d{2}-\d{2}$/.test(String(valor || ''))
	  );
	};
	
	var letraUnidad = function letraUnidad(unidad) {
	  var nombre = String(unidad || '').trim().toUpperCase();
	  if (nombre.indexOf('BULT') >= 0) return 'B';
	  if (nombre.indexOf('CAJ') >= 0) return 'C';
	  if (nombre.indexOf('PAQ') >= 0) return 'P';
	  if (nombre.indexOf('DOCEN') >= 0) return 'D';
	  return nombre === '' ? 'U' : nombre.charAt(0);
	};
	
	/**
	 * Agrupa el detalle de /api/pedido/notasPicking en documentos (pedidos o
	 * notas). La funcion de base de datos devuelve una fila por renglon e incluye
	 * los datos del encabezado, por lo que no se consultan las tablas desde el
	 * cliente.
	 */
	var agruparDocumentos = function agruparDocumentos(filas, esNota) {
	  var documentos = {};
	
	  filas.forEach(function (fila) {
	    var id = esNota ? fila.idnotaentrega : fila.idpedido;
	    var numero = esNota ? fila.numnotaentrega : fila.numpedido;
	
	    if (id === undefined || id === null) return;
	
	    if (!documentos[id]) {
	      documentos[id] = {
	        id: id,
	        numero: numero,
	        cliente: fila.cliente || '',
	        idvendedor: fila.idvendedor !== undefined ? fila.idvendedor : null,
	        idalmacen: fila.idalmacen !== undefined ? fila.idalmacen : null,
	        rif: fila.rif || fila.cedularif || '',
	        fecha: fila.fecha || null,
	        totalmonto: fila.totalmonto !== undefined ? fila.totalmonto : null,
	        filas: []
	      };
	    }
	
	    documentos[id].filas.push(fila);
	  });
	
	  return Object.keys(documentos).map(function (id) {
	    return documentos[id];
	  }).sort(function (a, b) {
	    return Number(a.id) - Number(b.id);
	  });
	};
	
	/**
	 * Convierte las notas de entrega seleccionadas al formato que espera
	 * reportePickingPDF. La existencia real se consulta por almacen porque el
	 * detalle de la nota no la incluye.
	 *
	 * El detalle de la nota guarda cantidad + tipounidad (0 = unidad principal,
	 * 1 = unidad alterna), igual que fn_reporte_picking.
	 */
	var construirPickingNotas = function construirPickingNotas(documentos, existencias, unidades, productosInfo) {
	  var productos = {};
	  var almacenesPorProducto = {};
	  var infoProductos = productosInfo || {};
	
	  documentos.forEach(function (documento) {
	    documento.filas.forEach(function (fila) {
	      var idproducto = fila.idproducto;
	      var info = infoProductos[idproducto] || {};
	      var cantidad = Number(fila.cantidad) || 0;
	
	      if (!productos[idproducto]) {
	        productos[idproducto] = {
	          idproducto: idproducto,
	          codproducto: fila.codproducto || '',
	          nomproducto: fila.nomproducto || info.nombre || '',
	          cantidadPrincipal: 0,
	          cantidadUnidades: 0,
	          factor: Number(info.factor) || 0,
	          unidadPrincipal: unidades[fila.idunidadmedida] || '',
	          unidadAlterna: unidades[fila.idunidadalterna] || '',
	          usaPrincipal: false,
	          usaAlterna: false,
	          observaciones: []
	        };
	      }
	
	      var producto = productos[idproducto];
	
	      // tipounidad = 0: unidad principal (BULTO/CAJA); 1: unidad alterna
	      if (Number(fila.tipounidad) === 0) {
	        producto.cantidadPrincipal += cantidad;
	        producto.usaPrincipal = true;
	      } else {
	        producto.cantidadUnidades += cantidad;
	        producto.usaAlterna = true;
	      }
	
	      if (!producto.nomproducto && info.nombre) producto.nomproducto = info.nombre;
	      if (!producto.factor && Number(info.factor) > 0) producto.factor = Number(info.factor);
	      if (!producto.unidadPrincipal) producto.unidadPrincipal = unidades[fila.idunidadmedida] || '';
	      if (!producto.unidadAlterna) producto.unidadAlterna = unidades[fila.idunidadalterna] || '';
	
	      if (fila.observacion && producto.observaciones.indexOf(fila.observacion) < 0) {
	        producto.observaciones.push(fila.observacion);
	      }
	
	      if (documento.idalmacen !== null && documento.idalmacen !== undefined) {
	        if (!almacenesPorProducto[idproducto]) almacenesPorProducto[idproducto] = [];
	        if (almacenesPorProducto[idproducto].indexOf(documento.idalmacen) < 0) {
	          almacenesPorProducto[idproducto].push(documento.idalmacen);
	        }
	      }
	    });
	  });
	
	  return Object.keys(productos).map(function (id) {
	    return productos[id];
	  }).sort(function (a, b) {
	    var codigoA = String(a.codproducto || '');
	    var codigoB = String(b.codproducto || '');
	    return codigoA < codigoB ? -1 : codigoA > codigoB ? 1 : 0;
	  }).map(function (producto, indice) {
	    var almacenes = almacenesPorProducto[producto.idproducto] || [];
	    var existenciaTotal = 0;
	
	    almacenes.forEach(function (idalmacen) {
	      var existencia = existencias[idalmacen + '|' + producto.idproducto];
	      if (!existencia) return;
	
	      existenciaTotal += Number(existencia.cantidad) || 0;
	
	      if (!producto.factor && Number(existencia.factor) > 0) {
	        producto.factor = Number(existencia.factor);
	      }
	      if (!producto.unidadPrincipal && existencia.descripcionuni) {
	        producto.unidadPrincipal = existencia.descripcionuni;
	      }
	      if (!producto.nomproducto && existencia.nombre) {
	        producto.nomproducto = existencia.nombre;
	      }
	    });
	
	    var letra = letraUnidad(producto.unidadPrincipal);
	    var unidad = producto.usaPrincipal || !producto.usaAlterna ? producto.unidadPrincipal : producto.unidadAlterna;
	    var pedidaPrincipal = Math.trunc(producto.cantidadPrincipal);
	    var pedidaUnidades = Math.trunc(producto.cantidadUnidades);
	    var cantidadTotal = '0';
	
	    if (pedidaPrincipal > 0 && pedidaUnidades > 0) {
	      cantidadTotal = pedidaPrincipal + letra + '-' + pedidaUnidades + 'U';
	    } else if (pedidaPrincipal > 0) {
	      cantidadTotal = pedidaPrincipal + letra;
	    } else if (pedidaUnidades > 0) {
	      cantidadTotal = pedidaUnidades + 'U';
	    }
	
	    // sin factor (producto sin unidad principal) la existencia va en unidades
	    var existenciaPrincipal = producto.factor > 0 ? Math.floor(existenciaTotal / producto.factor) : null;
	    var existenciaUnidades = producto.factor > 0 ? existenciaTotal - existenciaPrincipal * producto.factor : null;
	
	    return {
	      orden_picking: indice + 1,
	      codproducto: producto.codproducto,
	      nomproducto: producto.nomproducto,
	      cantidad_total: cantidadTotal,
	      cantidad_existencia: existenciaTotal,
	      cantidad_principal: existenciaPrincipal,
	      cantidad_unidades: existenciaUnidades,
	      unidadprincipal: letra,
	      unidad: unidad,
	      tipounidad: 0,
	      observacion: producto.observaciones.join(' / ')
	    };
	  });
	};
	
	var mensajeError = function mensajeError(error) {
	  if (error && error.response && error.response.data && error.response.data.message) {
	    return error.response.data.message;
	  }
	  return error && error.message ? error.message : 'Error al consultar los datos';
	};
	
	var ModalPicking = exports.ModalPicking = function ModalPicking(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var usuario = JSON.parse(sessionStorage.getItem("login"));
	
	  var fechaInicial = fechasistema && (0, _moment2.default)(fechasistema).isValid() ? (0, _moment2.default)(fechasistema).format('YYYY-MM-DD') : (0, _moment2.default)().format('YYYY-MM-DD');
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var consultaId = (0, _react.useRef)(0);
	
	  var _useState = (0, _react.useState)(fechaInicial),
	      _useState2 = _slicedToArray(_useState, 2),
	      desde = _useState2[0],
	      setDesde = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(fechaInicial),
	      _useState4 = _slicedToArray(_useState3, 2),
	      hasta = _useState4[0],
	      setHasta = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(TIPO_PEDIDO),
	      _useState6 = _slicedToArray(_useState5, 2),
	      tipo = _useState6[0],
	      setTipo = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(STATUS_POR_DESPACHAR),
	      _useState8 = _slicedToArray(_useState7, 2),
	      statusdespacho = _useState8[0],
	      setStatusdespacho = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      idvendedor = _useState10[0],
	      setIdvendedor = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      vendedores = _useState12[0],
	      setVendedores = _useState12[1];
	
	  var _useState13 = (0, _react.useState)([]),
	      _useState14 = _slicedToArray(_useState13, 2),
	      unidades = _useState14[0],
	      setUnidades = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      activate = _useState16[0],
	      setActivate = _useState16[1];
	
	  var _useState17 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState18 = _slicedToArray(_useState17, 2),
	      mensaje = _useState18[0],
	      setMensaje = _useState18[1];
	
	  var _useState19 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState20 = _slicedToArray(_useState19, 2),
	      mensajesino = _useState20[0],
	      setMensajesino = _useState20[1];
	
	  var _useState21 = (0, _react.useState)([]),
	      _useState22 = _slicedToArray(_useState21, 2),
	      records = _useState22[0],
	      setRecords = _useState22[1];
	
	  var _useState23 = (0, _react.useState)([]),
	      _useState24 = _slicedToArray(_useState23, 2),
	      idseleccionados = _useState24[0],
	      setIdseleccionados = _useState24[1];
	
	  var esNota = Number(tipo) === 1;
	  var todosSeleccionados = records.length > 0 && idseleccionados.length === records.length;
	
	  var unidadPorId = {};
	  unidades.forEach(function (unidad) {
	    unidadPorId[unidad.idunidadmedida] = String(unidad.descripcion || '').trim();
	  });
	
	  var nombreVendedor = function nombreVendedor(id) {
	    if (id === null || id === undefined || id === '') return '';
	    var vendedor = vendedores.find(function (v) {
	      return String(v.idagente) === String(id);
	    });
	    return vendedor ? vendedor.nombre : '';
	  };
	
	  var handleCheckTodos = function handleCheckTodos(e) {
	    if (e.target.checked) {
	      setIdseleccionados(records.map(function (registro) {
	        return registro.id;
	      }));
	    } else {
	      setIdseleccionados([]);
	    }
	  };
	
	  var handleCheckDocumento = function handleCheckDocumento(id) {
	    return function (e) {
	      if (e.target.checked) {
	        setIdseleccionados(function (seleccionados) {
	          return seleccionados.indexOf(id) >= 0 ? seleccionados : seleccionados.concat([id]);
	        });
	      } else {
	        setIdseleccionados(function (seleccionados) {
	          return seleccionados.filter(function (actual) {
	            return actual !== id;
	          });
	        });
	      }
	    };
	  };
	
	  var headCells = [{
	    label: _react2.default.createElement(
	      'div',
	      {
	        className: 'form-check d-flex justify-content-center align-items-center m-0',
	        style: { paddingLeft: 0 }
	      },
	      _react2.default.createElement('input', {
	        className: 'form-check-input',
	        type: 'checkbox',
	        title: 'Seleccionar todos',
	        checked: todosSeleccionados,
	        onChange: handleCheckTodos,
	        style: { position: 'relative', margin: 0, float: 'none' }
	      })
	    ),
	    width: "50px",
	    textAlign: "center"
	  }, { label: esNota ? 'N° NOTA' : 'N° PEDIDO', width: '100px', textAlign: 'center' }, { label: 'CLIENTE', textAlign: 'left' }, { label: 'VENDEDOR', textAlign: 'left' }, { label: 'FECHA', width: '90px', textAlign: 'center' }, { label: 'RENGLONES', width: '80px', textAlign: 'center' }, { label: 'VER', width: '45px', textAlign: 'center' }];
	
	  // La tabla es corta (300px): el encabezado no debe quedar fijo mientras se
	  // revisan las filas seleccionadas ni superponerse con el scroll horizontal.
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells, { stickyHeader: false }),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  /**
	   * Deja el modal como recien abierto: limpia la seleccion, el listado y los
	   * mensajes, y devuelve los filtros a sus valores por defecto para que al
	   * volver a abrirlo se muestren los documentos en su estado actual.
	   */
	
	
	  var blanquear = function blanquear() {
	    consultaId.current++;
	    setActivate(false);
	    setIdseleccionados([]);
	    setRecords([]);
	    setDesde(fechaInicial);
	    setHasta(fechaInicial);
	    setTipo(TIPO_PEDIDO);
	    setStatusdespacho(STATUS_POR_DESPACHAR);
	    setIdvendedor(0);
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var cerrarVentana = function cerrarVentana(ventana) {
	    if (ventana && !ventana.closed) ventana.close();
	  };
	
	  /**
	   * Marca como despachados los documentos seleccionados que se acaban de
	   * imprimir con el boton Imprimir. Se ejecuta solamente despues de que el PDF
	   * se genero correctamente.
	   */
	  var marcarDespachados = function marcarDespachados(idsDocumentos, esNotaDocumento) {
	    // En la vista "DESPACHADOS" los documentos ya estan despachados: no se
	    // vuelve a actualizar su estado para que sigan en la lista al reimprimir.
	    if (Number(statusdespacho) === 1) return Promise.resolve(0);
	
	    var ids = Array.from(new Set((Array.isArray(idsDocumentos) ? idsDocumentos : []).map(function (id) {
	      return String(id).trim();
	    }).filter(function (id) {
	      return (/^\d+$/.test(id)
	      );
	    })));
	
	    if (ids.length === 0) return Promise.resolve(0);
	
	    return _axios2.default.post(op.conexion + '/api/pedido/actualizarstatusdespacho', {
	      por: esNotaDocumento ? 1 : 0,
	      ids: ids
	    }, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      var idsActualizados = new Set((response.data && response.data.ids || []).map(function (id) {
	        return String(id);
	      }));
	
	      if (idsActualizados.size > 0) {
	        setRecords(function (registros) {
	          return registros.filter(function (registro) {
	            return !idsActualizados.has(String(registro.id));
	          });
	        });
	        setIdseleccionados(function (seleccionados) {
	          return seleccionados.filter(function (id) {
	            return !idsActualizados.has(String(id));
	          });
	        });
	      }
	
	      return response.data && response.data.actualizados || 0;
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: 'Error',
	        texto: 'El PDF se generó, pero no se pudo actualizar el estado de despacho: ' + mensajeError(error),
	        icono: 'error'
	      });
	      return 0;
	    });
	  };
	
	  var cambiarDesde = function cambiarDesde(valor) {
	    setDesde(valor);
	    if (valor && hasta && valor > hasta) setHasta(valor);
	  };
	
	  var cambiarHasta = function cambiarHasta(valor) {
	    setHasta(valor);
	    if (valor && desde && valor < desde) setDesde(valor);
	  };
	
	  var selectVendedores = function selectVendedores() {
	    _axios2.default.get(op.conexion + '/api/consulta/modelirows', {
	      params: {
	        campos: 'idagente, nombre',
	        id: true,
	        nomtab: 'agente',
	        nomid: 'vendedor'
	      },
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200 && Array.isArray(response.data)) {
	        var lista = response.data.slice().sort(function (a, b) {
	          return String(a.nombre || '').localeCompare(String(b.nombre || ''), 'es');
	        });
	        setVendedores(lista);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: 'Error',
	        texto: mensajeError(error),
	        icono: 'error'
	      });
	    });
	  };
	
	  var selectUnidades = function selectUnidades() {
	    _axios2.default.get(op.conexion + '/api/consulta/selecionarregistrocondi', {
	      params: {
	        campos: 'idunidadmedida, descripcion',
	        nomtab: 'unidadmedida',
	        condi: '1=1',
	        orden: 'idunidadmedida'
	      },
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200 && Array.isArray(response.data)) {
	        setUnidades(response.data);
	      }
	    }).catch(function () {
	      // el nombre de la unidad solo es informativo en el PDF
	    });
	  };
	
	  /**
	   * La funcion de base de datos es la unica fuente de datos: recibe el
	   * vendedor, el tipo de documento y el rango de fechas, y devuelve tanto los
	   * datos del encabezado como el detalle de cada renglon.
	   */
	  var cargarDocumentos = function cargarDocumentos(fechaDesde, fechaHasta, tipoActual, vendedorActual, statusActual) {
	    var idConsulta = ++consultaId.current;
	
	    if (!fechaValida(fechaDesde) || !fechaValida(fechaHasta)) {
	      setRecords([]);
	      setIdseleccionados([]);
	      setActivate(false);
	      return;
	    }
	
	    var esNotaActual = Number(tipoActual) === 1;
	
	    setActivate(true);
	
	    _axios2.default.get(op.conexion + '/api/pedido/notasPicking', {
	      params: {
	        por: tipoActual,
	        status: Number(statusActual) === 1 ? 1 : 0,
	        esvendedor: Number(vendedorActual) || 0,
	        desde: fechaDesde,
	        hasta: fechaHasta
	      },
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (idConsulta !== consultaId.current) return;
	
	      var filas = Array.isArray(response.data) ? response.data : [];
	      setRecords(agruparDocumentos(filas, esNotaActual));
	      setIdseleccionados([]);
	    }).catch(function (error) {
	      if (idConsulta !== consultaId.current) return;
	      setRecords([]);
	      setIdseleccionados([]);
	      setMensaje({
	        mostrar: true,
	        titulo: 'Error',
	        texto: mensajeError(error),
	        icono: 'error'
	      });
	    }).finally(function () {
	      if (idConsulta === consultaId.current) setActivate(false);
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    if (!props.show) return;
	    if (vendedores.length === 0) selectVendedores();
	    if (unidades.length === 0) selectUnidades();
	    // eslint-disable-next-line react-hooks/exhaustive-deps
	  }, [props.show]);
	
	  (0, _react.useEffect)(function () {
	    if (!props.show) return;
	    cargarDocumentos(desde, hasta, tipo, idvendedor, statusdespacho);
	    // eslint-disable-next-line react-hooks/exhaustive-deps
	  }, [props.show, desde, hasta, tipo, idvendedor, statusdespacho]);
	
	  /**
	   * Muestra / imprime un documento individual (pedido o nota de entrega).
	   * Esta accion es solo de consulta: NO modifica el estado de despacho. El
	   * estado se actualiza unicamente al imprimir los documentos seleccionados
	   * con el boton Imprimir.
	   */
	  var imprimirPedidoSeleccionado = function imprimirPedidoSeleccionado(lineas, numero, ventana, tipoDocumento) {
	
	    setActivate(true);
	
	    (0, _reportePedidoPDF.imprimirPedido)(lineas, {
	      empresa: afiliado,
	      usuario: usuario,
	      numpedido: numero,
	      tipoDocumento: tipoDocumento || 'PEDIDO'
	    }, ventana).catch(function (error) {
	      cerrarVentana(ventana);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.message,
	        icono: "error"
	      });
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var totalDocumento = function totalDocumento(item) {
	    return item.totalmonto !== null && item.totalmonto !== undefined ? Number(item.totalmonto) : item.filas.reduce(function (acumulado, fila) {
	      var cantidad = Number(fila.cantidad) || 0;
	      var precio = Number(fila.punitario) || 0;
	      var iva = Number(fila.iva) || 0;
	      return acumulado + cantidad * precio * (1 + iva / 100);
	    }, 0);
	  };
	
	  var lineasDocumento = function lineasDocumento(item, campoNumero) {
	    return item.filas.map(function (fila) {
	      var _ref;
	
	      var precio = Number(fila.punitario) || 0;
	      var iva = Number(fila.iva) || 0;
	
	      return _ref = {}, _defineProperty(_ref, campoNumero, item.numero), _defineProperty(_ref, 'cliente', item.cliente), _defineProperty(_ref, 'rif', item.rif), _defineProperty(_ref, 'totalmonto', totalDocumento(item)), _defineProperty(_ref, 'codproducto', fila.codproducto), _defineProperty(_ref, 'nomproducto', fila.nomproducto || ''), _defineProperty(_ref, 'cantidad', fila.cantidad), _defineProperty(_ref, 'punitario', fila.punitario), _defineProperty(_ref, 'ivaproducto', precio * iva / 100), _defineProperty(_ref, 'tipounidad', fila.tipounidad), _defineProperty(_ref, 'unidaprincipal', unidadPorId[fila.idunidadmedida] || fila.unidad || ''), _defineProperty(_ref, 'unidadalterna', unidadPorId[fila.idunidadalterna] || ''), _ref;
	    });
	  };
	
	  /**
	   * El detalle y los datos del documento ya vienen de la funcion, por lo que
	   * la impresion no vuelve a consultar pedido/nota ni producto.
	   */
	  var selectPedidos = function selectPedidos(item) {
	    if (!item.filas || item.filas.length === 0) {
	      setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ No se encontraron renglones para el pedido !', icono: 'informacion' });
	      return;
	    }
	
	    var ventana = window.open('', 'PedidoPicking', 'fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700');
	    var lineas = lineasDocumento(item, 'numpedido');
	
	    imprimirPedidoSeleccionado(lineas, item.numero, ventana, 'PEDIDO');
	  };
	
	  var verNotaEntrega = function verNotaEntrega(item) {
	    if (!item.filas || item.filas.length === 0) {
	      setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ No se encontraron renglones para la nota de entrega !', icono: 'informacion' });
	      return;
	    }
	
	    var ventana = window.open('', 'NotaEntregaPicking', 'fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700');
	    var lineas = lineasDocumento(item, 'numnotaentrega');
	
	    imprimirPedidoSeleccionado(lineas, item.numero, ventana, 'NOTA DE ENTREGA');
	  };
	
	  var selectDocumento = function selectDocumento(item) {
	    if (esNota) {
	      verNotaEntrega(item);
	    } else {
	      selectPedidos(item);
	    }
	  };
	
	  var imprimirPicking = function imprimirPicking(datos, ventana, etiquetaDocumentos, numerosDocumentos, esReporteNotas, idsDocumentos) {
	
	    setActivate(true);
	
	    var numeros = Array.isArray(numerosDocumentos) ? numerosDocumentos : records.filter(function (registro) {
	      return idseleccionados.indexOf(registro.id) >= 0;
	    }).map(function (registro) {
	      return registro.numero;
	    });
	
	    var ids = Array.isArray(idsDocumentos) ? idsDocumentos : records.filter(function (registro) {
	      return idseleccionados.indexOf(registro.id) >= 0;
	    }).map(function (registro) {
	      return registro.id;
	    });
	
	    (0, _reportePickingPDF.imprimirReportePicking)(datos, {
	      empresa: afiliado,
	      usuario: usuario,
	      fechasistema: fechasistema ? (0, _moment2.default)(fechasistema).format('DD-MM-YYYY') : '',
	      titulo: 'Reporte Picking List',
	      pedidos: numeros,
	      etiquetaDocumentos: etiquetaDocumentos || 'PEDIDOS',
	      esNota: esReporteNotas === true
	    }, ventana).then(function () {
	      return marcarDespachados(ids, esReporteNotas === true);
	    }).catch(function (error) {
	      cerrarVentana(ventana);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensajeError(error),
	        icono: "error"
	      });
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var imprimirPickingNotas = function imprimirPickingNotas(seleccionados, ventana) {
	    var almacenes = [];
	    var productosInfo = {};
	
	    seleccionados.forEach(function (documento) {
	      if (documento.idalmacen !== null && documento.idalmacen !== undefined && almacenes.indexOf(documento.idalmacen) < 0) {
	        almacenes.push(documento.idalmacen);
	      }
	
	      documento.filas.forEach(function (fila) {
	        if (fila.idproducto !== undefined && fila.idproducto !== null && !productosInfo[fila.idproducto]) {
	          productosInfo[fila.idproducto] = {
	            nombre: fila.nomproducto || '',
	            factor: Number(fila.factor) || 0
	          };
	        }
	      });
	    });
	
	    setActivate(true);
	
	    var peticiones = almacenes.map(function (idalmacen) {
	      return _axios2.default.get(op.conexion + '/api/inventario/productoexisselectubi', {
	        params: { idalmacen: idalmacen },
	        headers: {
	          "x-access-token": '' + token
	        }
	      });
	    });
	
	    Promise.all(peticiones).then(function (respuestas) {
	      var existencias = {};
	
	      respuestas.forEach(function (respuesta, indice) {
	        var idalmacenConsulta = almacenes[indice];
	        var productos = Array.isArray(respuesta.data) ? respuesta.data : [];
	
	        productos.forEach(function (producto) {
	          var idalmacen = producto.idalmacen !== undefined ? producto.idalmacen : idalmacenConsulta;
	          var clave = idalmacen + '|' + producto.idproducto;
	          var actual = existencias[clave] || {
	            cantidad: 0,
	            factor: Number(producto.valorfactor) || 0,
	            descripcionuni: producto.descripcionuni,
	            nombre: producto.nombrecorto || ''
	          };
	
	          actual.cantidad += Number(producto.cantidad) || 0;
	          if (!actual.factor) actual.factor = Number(producto.valorfactor) || 0;
	          if (!actual.descripcionuni) actual.descripcionuni = producto.descripcionuni;
	          if (!actual.nombre) actual.nombre = producto.nombrecorto || '';
	          existencias[clave] = actual;
	        });
	      });
	
	      var datos = construirPickingNotas(seleccionados, existencias, unidadPorId, productosInfo);
	
	      if (datos.length === 0) {
	        cerrarVentana(ventana);
	        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ No se encontraron datos para las notas seleccionadas !', icono: 'informacion' });
	        setActivate(false);
	        return;
	      }
	
	      imprimirPicking(datos, ventana, 'NOTAS DE ENTREGA', seleccionados.map(function (documento) {
	        return documento.numero;
	      }), true, seleccionados.map(function (documento) {
	        return documento.id;
	      }));
	    }).catch(function (error) {
	      cerrarVentana(ventana);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensajeError(error),
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var selectDatos = function selectDatos() {
	
	    var seleccionados = records.filter(function (registro) {
	      return idseleccionados.indexOf(registro.id) >= 0;
	    });
	
	    if (esNota) {
	      var ventanaNotas = window.open('', 'ReportePickingNotas', 'fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700');
	      imprimirPickingNotas(seleccionados, ventanaNotas);
	      return;
	    }
	
	    var ventana = window.open('', 'ReportePicking', 'fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700');
	    var ids = seleccionados.map(function (registro) {
	      return registro.id;
	    });
	    // fn_reporte_picking recibe el estado de despacho (statusr) igual que la
	    // lista, por eso se envia el filtro actual: con statusr=0 fijo la funcion
	    // no devuelve los pedidos ya despachados y no se pueden reimprimir.
	    var statusReporte = Number(statusdespacho) === 1 ? 1 : 0;
	    var endpoint = op.conexion + '/api/pedido/pedidoPicking?statusr=' + statusReporte + '&idpedidos=' + encodeURIComponent(JSON.stringify(ids));
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          return imprimirPicking(response.data, ventana, 'PEDIDOS', seleccionados.map(function (registro) {
	            return registro.numero;
	          }), false, ids);
	        } else {
	          cerrarVentana(ventana);
	          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ No se encontraron datos para los pedidos seleccionados !', icono: 'informacion' });
	        }
	      }
	    }).catch(function (error) {
	      cerrarVentana(ventana);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensajeError(error),
	        icono: "error"
	      });
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	
	    if (idseleccionados.length === 0) {
	      setMensaje({
	        mostrar: true,
	        titulo: 'Notificación',
	        texto: esNota ? '¡ Debe seleccionar al menos una nota de entrega !' : '¡ Debe seleccionar al menos un pedido !',
	        icono: 'informacion'
	      });
	      return;
	    }
	
	    selectDatos();
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    props.onHideCancelar();
	    if (props.onCerrar) props.onCerrar();
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'lg',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'REPORTE PICKING LIST'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0 m-0' },
	        _react2.default.createElement(
	          'fieldset',
	          { className: 'picking-filtros w-100 mx-auto mb-2' },
	          _react2.default.createElement(
	            'legend',
	            { className: 'picking-filtros__leyenda float-none w-auto px-1 m-0' },
	            'Filtros del reporte'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'picking-filtros__grid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'picking-filtros__campo' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'txtDesde', className: 'form-label' },
	                _react2.default.createElement('i', { className: 'far fa-calendar-alt', 'aria-hidden': 'true' }),
	                'Desde'
	              ),
	              _react2.default.createElement('input', {
	                type: 'date',
	                value: desde,
	                onChange: function onChange(e) {
	                  return cambiarDesde(e.target.value);
	                },
	                className: 'form-control',
	                id: 'txtDesde'
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'picking-filtros__campo' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'txtHasta', className: 'form-label' },
	                _react2.default.createElement('i', { className: 'far fa-calendar-check', 'aria-hidden': 'true' }),
	                'Hasta'
	              ),
	              _react2.default.createElement('input', {
	                type: 'date',
	                value: hasta,
	                onChange: function onChange(e) {
	                  return cambiarHasta(e.target.value);
	                },
	                className: 'form-control',
	                id: 'txtHasta'
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'picking-filtros__campo' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'txtPor', className: 'form-label' },
	                _react2.default.createElement('i', { className: 'far fa-file-alt', 'aria-hidden': 'true' }),
	                'Tipo de documento'
	              ),
	              _react2.default.createElement(
	                'select',
	                {
	                  id: 'txtPor',
	                  value: tipo,
	                  onChange: function onChange(e) {
	                    return setTipo(e.target.value);
	                  },
	                  className: 'form-control form-select'
	                },
	                _react2.default.createElement(
	                  'option',
	                  { value: TIPO_PEDIDO },
	                  'Pedidos'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: TIPO_NOTA },
	                  'Notas de entrega'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'picking-filtros__campo' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'txtStatusDespacho', className: 'form-label' },
	                _react2.default.createElement('i', { className: 'fas fa-truck', 'aria-hidden': 'true' }),
	                'Estado de despacho'
	              ),
	              _react2.default.createElement(
	                'select',
	                {
	                  id: 'txtStatusDespacho',
	                  value: statusdespacho,
	                  onChange: function onChange(e) {
	                    return setStatusdespacho(e.target.value);
	                  },
	                  className: 'form-control form-select'
	                },
	                _react2.default.createElement(
	                  'option',
	                  { value: STATUS_POR_DESPACHAR },
	                  'POR DESPACHAR'
	                ),
	                _react2.default.createElement(
	                  'option',
	                  { value: STATUS_DESPACHADO },
	                  'DESPACHADOS'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'picking-filtros__campo picking-filtros__campo--vendedor' },
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'txtVendedor', className: 'form-label' },
	                _react2.default.createElement('i', { className: 'fas fa-user-tie', 'aria-hidden': 'true' }),
	                'Vendedor'
	              ),
	              _react2.default.createElement(
	                'select',
	                {
	                  id: 'txtVendedor',
	                  value: idvendedor,
	                  onChange: function onChange(e) {
	                    return setIdvendedor(e.target.value);
	                  },
	                  className: 'form-control form-select'
	                },
	                _react2.default.createElement(
	                  'option',
	                  { value: 0 },
	                  'Todos los vendedores'
	                ),
	                vendedores.map(function (vendedor) {
	                  return _react2.default.createElement(
	                    'option',
	                    { key: vendedor.idagente, value: vendedor.idagente },
	                    vendedor.nombre
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'picking-filtros__resumen' },
	            _react2.default.createElement(
	              'span',
	              null,
	              records.length,
	              ' documento(s) ',
	              Number(statusdespacho) === 1 ? 'despachado(s)' : 'pendiente(s) por despachar'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              esNota ? 'Notas de entrega' : 'Pedidos',
	              ' del ',
	              desde ? (0, _moment2.default)(desde).format('DD-MM-YYYY') : '--',
	              ' al ',
	              hasta ? (0, _moment2.default)(hasta).format('DD-MM-YYYY') : '--'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          TblContainer,
	          {
	            container: {
	              height: 300,
	              width: "100%",
	              overflow: "auto",
	              padding: "2px",
	              fontSizeAdjust: "0.6"
	            }
	          },
	          _react2.default.createElement(TblHead, null),
	          _react2.default.createElement(
	            _semanticUiReact.TableBody,
	            { className: 'overflow-hidden table-bordered' },
	            records.map(function (item) {
	              return _react2.default.createElement(
	                _semanticUiReact.TableRow,
	                {
	                  key: item.id,
	                  style: { padding: "0", fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  _semanticUiReact.TableCell,
	                  { className: 'bg-light text-center' },
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: 'form-check d-flex justify-content-center align-items-center m-0',
	                      style: { paddingLeft: 0 }
	                    },
	                    _react2.default.createElement('input', {
	                      className: 'form-check-input',
	                      type: 'checkbox',
	                      checked: idseleccionados.indexOf(item.id) >= 0,
	                      onChange: handleCheckDocumento(item.id),
	                      id: "chkdocumento" + item.id,
	                      style: { position: 'relative', margin: 0, float: 'none' }
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.TableCell,
	                  { className: 'bg-light text-center fw-bold' },
	                  item.numero
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.TableCell,
	                  { className: 'align-baseline bg-light', title: item.cliente },
	                  item.cliente
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.TableCell,
	                  { className: 'align-baseline bg-light', title: nombreVendedor(item.idvendedor) },
	                  nombreVendedor(item.idvendedor) || '-'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.TableCell,
	                  { className: 'bg-light text-center' },
	                  item.fecha ? (0, _moment2.default)(item.fecha).format('DD-MM-YYYY') : '-'
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.TableCell,
	                  { className: 'bg-light text-center' },
	                  item.filas.length
	                ),
	                _react2.default.createElement(
	                  _semanticUiReact.TableCell,
	                  { className: 'bg-light text-center' },
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      href: '#',
	                      title: esNota ? "Ver / Imprimir nota de entrega" : "Ver / Imprimir pedido",
	                      className: 'text-primary',
	                      onClick: function onClick(e) {
	                        e.preventDefault();
	                        selectDocumento(item);
	                      }
	                    },
	                    _react2.default.createElement('i', { className: esNota ? "fas fa-file-invoice" : "fas fa-eye" })
	                  )
	                )
	              );
	            }),
	            records.length === 0 && !activate && _react2.default.createElement(
	              _semanticUiReact.TableRow,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.TableCell,
	                { colSpan: headCells.length, className: 'text-center text-muted small py-4' },
	                'No se encontraron documentos para los filtros seleccionados.'
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-11 ml-auto px-0 m-0 d-flex justify-content-end align-items-center' },
	          _react2.default.createElement(
	            'span',
	            { className: 'text-muted small', style: { marginRight: 'auto' } },
	            idseleccionados.length + ' documento(s) seleccionado(s)'
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, onClick: onChangeValidar, disabled: activate, className: 'btn btn-sm rounded-pill btn-success mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check-circle' },
	              '  Imprimir'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalReversarPagos = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoProductosExistencias = __webpack_require__(91);
	
	var _catalogoProductosExistencias2 = _interopRequireDefault(_catalogoProductosExistencias);
	
	var _catalogoAlmacen = __webpack_require__(51);
	
	var _catalogoAlmacen2 = _interopRequireDefault(_catalogoAlmacen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalReversarPagos = exports.ModalReversarPagos = function ModalReversarPagos(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtCodigo = (0, _react.useRef)();
	  var txtCedula = (0, _react.useRef)();
	  var txtNumNota = (0, _react.useRef)();
	  var txtPorProduct = (0, _react.useRef)();
	  var txtNombreProducto = (0, _react.useRef)();
	  var txtTodosProduct = (0, _react.useRef)();
	  var txtTodosAlmacen = (0, _react.useRef)();
	  var txtPorAlmacen = (0, _react.useRef)();
	  var txtNombreAlmacen = (0, _react.useRef)();
	  var txtCodigoAlmacen = (0, _react.useRef)();
	  var txtNombre = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtCbmrif = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      inputalmacen = _useState2[0],
	      setInputalmacen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      valalmacen = _useState4[0],
	      setValalmacen = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      valproducto = _useState6[0],
	      setValproducto = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      inputproducto = _useState8[0],
	      setInputproducto = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      fechare = _useState10[0],
	      setFechare = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(null),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mostrar1 = _useState12[0],
	      setMostrar1 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(null),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mostrar2 = _useState14[0],
	      setMostrar2 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(''),
	      _useState16 = _slicedToArray(_useState15, 2),
	      parafecha = _useState16[0],
	      setParafecha = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(''),
	      _useState18 = _slicedToArray(_useState17, 2),
	      desde = _useState18[0],
	      setDesde = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(''),
	      _useState20 = _slicedToArray(_useState19, 2),
	      hasta = _useState20[0],
	      setHasta = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(''),
	      _useState22 = _slicedToArray(_useState21, 2),
	      disponiblec = _useState22[0],
	      setDisponiblec = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(''),
	      _useState24 = _slicedToArray(_useState23, 2),
	      numnota = _useState24[0],
	      setNumNota = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(''),
	      _useState26 = _slicedToArray(_useState25, 2),
	      idclient = _useState26[0],
	      setIdclient = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(true),
	      _useState28 = _slicedToArray(_useState27, 2),
	      vinpurt = _useState28[0],
	      setVinput = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      mostrarClavesup = _useState30[0],
	      setMostrarClavesup = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(0),
	      _useState32 = _slicedToArray(_useState31, 2),
	      valida2 = _useState32[0],
	      setValida2 = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(false),
	      _useState34 = _slicedToArray(_useState33, 2),
	      activate = _useState34[0],
	      setActivate = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(''),
	      _useState36 = _slicedToArray(_useState35, 2),
	      idproduct = _useState36[0],
	      setIdproduct = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(''),
	      _useState38 = _slicedToArray(_useState37, 2),
	      estatus = _useState38[0],
	      setEstatus = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(0),
	      _useState40 = _slicedToArray(_useState39, 2),
	      valida = _useState40[0],
	      setValida = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(null),
	      _useState42 = _slicedToArray(_useState41, 2),
	      body = _useState42[0],
	      setBody = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      mensaje = _useState44[0],
	      setMensaje = _useState44[1];
	
	  var _useState45 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState46 = _slicedToArray(_useState45, 2),
	      mensajesino = _useState46[0],
	      setMensajesino = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(''),
	      _useState48 = _slicedToArray(_useState47, 2),
	      tituid = _useState48[0],
	      setTituid = _useState48[1];
	
	  var _useState49 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState50 = _slicedToArray(_useState49, 2),
	      botones = _useState50[0],
	      setBotones = _useState50[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setBody(null);
	    setInputalmacen('');
	    setParafecha('');
	    setDisponiblec('');
	    setNumNota('');
	    setInputproducto(0);
	    setValida(0);
	    setValida2(0);
	    setIdclient('');
	    setIdproduct('');
	    setVinput(true);
	    setMostrar1(false);
	    setMostrar2(false);
	    setEstatus("");
	    setDesde('');
	    setHasta('');
	    setValalmacen(0);
	    setValproducto(0);
	    setFechare(null);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancela();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	    var sigue = true;
	    if (props.ope === 3) {
	
	      if (txtNumNota.current.value === '') {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Introduzca el Número de Recibo !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtNumNota.current.focus();
	      }
	
	      if (sigue === true) {
	        var numReci = txtNumNota.current.value;
	        seleccionarNota(numReci);
	      }
	    }
	  };
	
	  var seleccionarNota = function seleccionarNota(numreci) {
	    var campos = "(select p.numpedido from pedido p where p.numpedido = (select n.numpedido from notaentrega n where n.numnotaentrega = numfactura)) as numpedidos, fecharegistro as fecha, numfactura, numpago, idpago, statusreverso";
	    var nomtab = "registropago";
	    var endpoint = op.conexion + '/api/consulta/modeli?campos=' + campos + '&nomtab=' + nomtab + '&nomid=numfactura&id=' + numreci.trim().toUpperCase();
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          if (parseInt(response.data.statusreverso) <= 0 || response.data.statusreverso === null) {
	            setBody({
	              notaentre: [],
	              notaentredet: [],
	              pagos: [],
	              pagosdeta: [],
	              app: false,
	              ncaja: [],
	              fecharev: fechare,
	              fechapag: response.data.fecha,
	              nidcaja: parseInt(response.data.idpago),
	              idusu: parseInt(props.idusuario),
	              post: true,
	              motivo: "REVERSO DE PAGO - NUMERO DE RECIBO N°: " + response.data.numpago + " DE LA NOTA DE ENTREGA N°: " + response.data.numfactura + " DEL PEDIDO N°: " + response.data.numpedidos
	            });
	            var msg = "¿Esta Seguro de Reversar este Pago?.";
	            setMensajesino({
	              mostrar: true,
	              titulo: "Confirmación.",
	              texto: msg,
	              icono: "confirmacion"
	            });
	          } else {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "¡ N° Recibo y/o Pago ya fue Reversado !.",
	              icono: "informacion"
	            });
	            txtNumNota.current.value = '';
	            txtNumNota.current.focus();
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "¡ N° Recibo no Existe !.",
	            icono: "informacion"
	          });
	          txtNumNota.current.value = '';
	          txtNumNota.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var procesarRegistroNota = function procesarRegistroNota(opera) {
	    var endpoint = op.conexion + '/api/inventario/actualizarpostventas/' + opera;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (opera !== 4) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "¡ Pago Reversado Correctamente !",
	            icono: "exito"
	          });
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = error.response.data.message;
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	    procesarRegistroNota(props.ope);
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	    props.onHideCancela();
	    props.onCerrar();
	  };
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'numnota') {
	      if (e.target.value !== '') {
	        setVinput(false);
	      }
	    }
	  };
	
	  var handleInputNumeroChange = function handleInputNumeroChange(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "numnota") {
	          btnAcepta.current.focus();
	        }
	      }
	    }
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'md',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.ope === 3) {
	          var fecha = (0, _moment2.default)(fechasistema).format('DD/MM/YYYY');
	          setFechare(fecha);
	          txtNumNota.current.focus();
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'REVERSAR PAGO'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0 m-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 row m-0 px-0 py-2' },
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto mb-1 px-0' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm mb-2' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'NUMERO DE RECIBO: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', name: 'numnota', ref: txtNumNota, onChange: onChange, onKeyUp: handleInputNumeroChange, className: 'form-control bg-transparent fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-11 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: vinpurt, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-success mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check-circle' },
	              '  Aceptar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    )
	  );
	};

/***/ },
/* 7170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ModalSupervisor = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoProductosExistencias = __webpack_require__(91);
	
	var _catalogoProductosExistencias2 = _interopRequireDefault(_catalogoProductosExistencias);
	
	var _catalogoAlmacen = __webpack_require__(51);
	
	var _catalogoAlmacen2 = _interopRequireDefault(_catalogoAlmacen);
	
	var _modalReversarPago = __webpack_require__(7169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalSupervisor = exports.ModalSupervisor = function ModalSupervisor(props) {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem('jwtToken');
	  var fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnSalir = (0, _react.useRef)();
	  var txtCodigo = (0, _react.useRef)();
	  var txtCedula = (0, _react.useRef)();
	  var txtHasta = (0, _react.useRef)();
	  var txtPorProduct = (0, _react.useRef)();
	  var txtNombreProducto = (0, _react.useRef)();
	  var txtTodosProduct = (0, _react.useRef)();
	  var txtTodosAlmacen = (0, _react.useRef)();
	  var txtPorAlmacen = (0, _react.useRef)();
	  var txtNombreAlmacen = (0, _react.useRef)();
	  var txtCodigoAlmacen = (0, _react.useRef)();
	  var txtNombre = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtCbmrif = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      inputalmacen = _useState2[0],
	      setInputalmacen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      valalmacen = _useState4[0],
	      setValalmacen = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      valproducto = _useState6[0],
	      setValproducto = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      idusu = _useState8[0],
	      setIdusu = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      tiporif = _useState10[0],
	      setTipofic = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(null),
	      _useState12 = _slicedToArray(_useState11, 2),
	      mostrar1 = _useState12[0],
	      setMostrar1 = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(null),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mostrar2 = _useState14[0],
	      setMostrar2 = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(''),
	      _useState16 = _slicedToArray(_useState15, 2),
	      parafecha = _useState16[0],
	      setParafecha = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(''),
	      _useState18 = _slicedToArray(_useState17, 2),
	      desde = _useState18[0],
	      setDesde = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(''),
	      _useState20 = _slicedToArray(_useState19, 2),
	      hasta = _useState20[0],
	      setHasta = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(''),
	      _useState22 = _slicedToArray(_useState21, 2),
	      disponiblec = _useState22[0],
	      setDisponiblec = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(''),
	      _useState24 = _slicedToArray(_useState23, 2),
	      numnota = _useState24[0],
	      setNumNota = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(''),
	      _useState26 = _slicedToArray(_useState25, 2),
	      idclient = _useState26[0],
	      setIdclient = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(true),
	      _useState28 = _slicedToArray(_useState27, 2),
	      vinpurt = _useState28[0],
	      setVinput = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      mostrarClavesup = _useState30[0],
	      setMostrarClavesup = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(0),
	      _useState32 = _slicedToArray(_useState31, 2),
	      valida2 = _useState32[0],
	      setValida2 = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(false),
	      _useState34 = _slicedToArray(_useState33, 2),
	      activate = _useState34[0],
	      setActivate = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(''),
	      _useState36 = _slicedToArray(_useState35, 2),
	      idproduct = _useState36[0],
	      setIdproduct = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(''),
	      _useState38 = _slicedToArray(_useState37, 2),
	      estatus = _useState38[0],
	      setEstatus = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(0),
	      _useState40 = _slicedToArray(_useState39, 2),
	      valida = _useState40[0],
	      setValida = _useState40[1];
	
	  var _useState41 = (0, _react.useState)({ fn: function fn(items) {
	      return items;
	    } }),
	      _useState42 = _slicedToArray(_useState41, 2),
	      filterFn = _useState42[0],
	      setFilterFn = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      mensaje = _useState44[0],
	      setMensaje = _useState44[1];
	
	  var _useState45 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	      _useState46 = _slicedToArray(_useState45, 2),
	      mensajesino = _useState46[0],
	      setMensajesino = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(''),
	      _useState48 = _slicedToArray(_useState47, 2),
	      tituid = _useState48[0],
	      setTituid = _useState48[1];
	
	  var _useState49 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    salir: false
	  }),
	      _useState50 = _slicedToArray(_useState49, 2),
	      botones = _useState50[0],
	      setBotones = _useState50[1];
	
	  var blanquear = function blanquear() {
	    setActivate(false);
	    setInputalmacen('');
	    setParafecha('');
	    setDisponiblec('');
	    setNumNota('');
	    setIdusu(null);
	    setValida(0);
	    setValida2(0);
	    setIdclient('');
	    setIdproduct('');
	    setVinput(true);
	    setMostrar1(false);
	    setMostrar2(false);
	    setEstatus("");
	    setDesde('');
	    setHasta('');
	    setValalmacen(0);
	    setValproducto(0);
	  };
	
	  var cancelar = function cancelar() {
	    blanquear();
	    props.onHideCancelar();
	  };
	
	  var onChangeValidar = function onChangeValidar(e) {
	    e.preventDefault();
	    var sigue = true;
	    if (props.ope === 3) {
	
	      if (txtCedula.current.value === '') {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Introduzca el Número de Cédula del Supervisor !",
	          icono: "informacion"
	        });
	        sigue = false;
	        txtCedula.current.focus();
	      }
	
	      if (sigue === true) {
	        var cedu = txtCedula.current.value.trim();
	        var clav = txtCodigo.current.value.trim();
	        seleccionarAcceso(cedu, clav);
	      }
	    }
	  };
	
	  var seleccionarAcceso = function seleccionarAcceso(cedula, clave) {
	
	    var endpoint = op.conexion + '/api/athos/usuario/supervisor?cedula=' + cedula + '&clave=' + clave;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": '' + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.idusuario > 0) {
	          setIdusu(response.data.idusuario);
	          setMostrar1(true);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "¡ Cédula y/o Clave Incorrecto !",
	            icono: "informacion"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChange = function onChange(e) {
	
	    if (e.target.name === 'clave') {
	      if (e.target.value !== '') {
	        setVinput(false);
	      }
	    }
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var cerrarModal = function cerrarModal() {
	    blanquear();
	    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	  };
	
	  var handleInputNumeroChange = function handleInputNumeroChange(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "cedula") {
	          txtCodigo.current.focus();
	        } else if (event.target.name === "clave") {
	          btnAcepta.current.focus();
	        }
	      }
	    }
	  };
	
	  var mostrarPasswordsup = function mostrarPasswordsup() {
	    return setMostrarClavesup(!mostrarClavesup);
	  };
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    Object.assign({}, props, {
	      size: 'md',
	      'aria-labelledby': 'contained-modal-title-vcenter',
	      centered: true,
	      backdrop: 'static',
	      keyboard: false,
	      onShow: function onShow() {
	
	        if (props.ope === 3) {
	          txtCedula.current.focus();
	        }
	      }
	    }),
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      { className: 'azulGradiant2 header-modal' },
	      _react2.default.createElement(
	        'div',
	        { className: 'fw-bold', style: { color: "#fff" } },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'SUPERVISOR'
	        )
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#', ref: btnSalir, disabled: botones.salir, onClick: cancelar, className: 'text-light' },
	        _react2.default.createElement(
	          'i',
	          { className: 'fas fa-times fa-1x shadow' },
	          ' '
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      { style: { backgroundColor: "#FFF" } },
	      _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	        onHide: function onHide() {
	          mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	        } }),
	      _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	        onHideNo: function onHideNo() {
	          return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	        }, onHideSi: handleCloseSi }),
	      _react2.default.createElement(
	        _semanticUiReact.Dimmer,
	        { active: activate, inverted: true },
	        _react2.default.createElement(
	          _semanticUiReact.Loader,
	          { inverted: true },
	          'cargando...'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 row mx-auto px-0 m-0' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 row m-0 px-0 py-2' },
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'row col-sm-12 mx-auto mb-1 px-0' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col' },
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm mb-2' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'CEDULA: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: 'text', name: 'cedula', ref: txtCedula, onKeyUp: handleInputNumeroChange, onBlur: handleInputNumeroChange, className: 'form-control bg-transparent fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'input-group input-group-sm' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'input-group-text', id: 'inputGroup-sizing-sm' },
	                  'CLAVE DE SUPERVISOR: '
	                ),
	                _react2.default.createElement('input', { autoComplete: 'off', type: mostrarClavesup ? "text" : "password", onChange: onChange, name: 'clave', ref: txtCodigo, onKeyUp: handleInputNumeroChange, className: 'form-control bg-transparent fs-6 text-uppercase', 'aria-label': 'Sizing example input', 'aria-describedby': 'inputGroup-sizing-sm' }),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    style: { textAlign: "center", color: "white" },
	                    onClick: mostrarPasswordsup,
	                    className: 'btn btn-sm btn-info'
	                  },
	                  _react2.default.createElement('i', {
	                    className: 'fa fa-eye-slash'
	                  }),
	                  " "
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Footer,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'row m-0 col-md-12 mx-auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-11 ml-auto px-0 m-0 d-flex justify-content-end' },
	          _react2.default.createElement(
	            'button',
	            { ref: btnAcepta, disabled: vinpurt, onClick: onChangeValidar, className: 'btn btn-sm rounded-pill btn-primary mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-check-circle' },
	              '  Aceptar'
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { ref: btnCancela, onClick: cancelar, className: 'btn btn-danger btn-sm rounded-pill mx-1' },
	            _react2.default.createElement(
	              'i',
	              { className: 'fas fa-window-close' },
	              ' Cancelar'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_modalReversarPago.ModalReversarPagos, {
	      show: mostrar1,
	      ope: props.ope,
	      idusuario: idusu,
	      onCerrar: cancelar,
	      onHideCancela: function onHideCancela() {
	        return setMostrar1(false);
	      }
	    })
	  );
	};

/***/ },
/* 7171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tablaPedidos = __webpack_require__(7179);
	
	var _tablaPedidos2 = _interopRequireDefault(_tablaPedidos);
	
	var _reactChartjs = __webpack_require__(121);
	
	var _cartas = __webpack_require__(7159);
	
	var _cartas2 = _interopRequireDefault(_cartas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PanelPedidos = function PanelPedidos(props) {
	    var _useState = (0, _react.useState)('panel'),
	        _useState2 = _slicedToArray(_useState, 2),
	        vista = _useState2[0],
	        setVista = _useState2[1];
	
	    var options = {
	        responsive: true,
	        plugins: {
	            legend: {
	                position: 'top'
	            },
	            title: {
	                display: true,
	                text: 'Chart.js Line Chart'
	            }
	        }
	    };
	    var data = {
	        labels: labels,
	        datasets: [{
	            label: 'Recaudado',
	            data: ["565", "258", "705", "528", "451", "359", "912", "125", "258", "348", "585", "706"],
	            borderColor: 'rgb(255, 99, 132)'
	
	        }, {
	            label: 'Meta Presupuestaria',
	            data: ["455", "455", "455", "455", "455", "455", "455", "455", "455", "455", "455", "455"],
	            borderColor: 'rgb(2, 99, 132)'
	
	        }]
	    };
	
	    var optionss = {
	        plugins: {
	            title: {
	                display: true,
	                text: 'Chart.js Bar Chart - Stacked'
	            }
	        },
	        responsive: true,
	        interaction: {
	            mode: 'index',
	            intersect: false
	        },
	        scales: {
	            x: {
	                stacked: true
	            },
	            y: {
	                stacked: true
	            }
	        }
	    };
	
	    var labelss = ['Timbres Fiscales', 'Impuesto 1x500', 'Impuesto Minas', 'Impuesto Producción'];
	    var labels = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
	
	    var datas = {
	        labels: labelss,
	        datasets: [{
	            label: 'Meta Presupuestaria',
	            data: ["9", "7", "5", "6"],
	            backgroundColor: 'rgba(53, 162, 235)',
	            stack: 'Stack 1'
	        }, {
	            label: 'Recaudado',
	            data: ["7", "4", "9", "7"],
	            backgroundColor: 'rgba(255, 99, 132)',
	            stack: 'Stack 2'
	        }]
	    };
	
	    (0, _react.useEffect)(function () {}, []);
	
	    return _react2.default.createElement(
	        'div',
	        { style: { height: '100%', width: '100%' } },
	
	        /* vista === 'panel' ?
	        
	        <div className='col-md-12 py-5 row mx-auto'>
	            <div className='col-md-8 row- row mx-auto card py-4 px-3 shadow' >
	               
	                <CartasClientes/>
	                <div className='co-md-12 row mx-auto justify-content-end mb-2 px-4'>
	                    <button type="button" onClick={() => {setVista('tabla')}} style={{ height: '27px' }}  class="btn btn-sm col-md-2 rounded-pill btn-primary"><i style={{ fontSize: '9px' }} class="fas fa-plus">Generar Pedido</i></button>
	                </div>
	                <div className='row'>
	                    <div className="col-md-6 h-25">
	                        <div className="row py-0 my-0 m-0">
	                            <h5 className="m-0 titulo-content" style={{ fontSize: 20 }}>Ingreso General</h5>
	                            <hr className='w-50 my-0' />
	                        </div>
	                        <Line options={options} data={data} />
	                    </div>
	                    <div className="col-md-6 h-25">
	                        <div className="row py-0 my-0 m-0">
	                            <h5 className="m-0 titulo-content" style={{ fontSize: 20 }}>Ingreso por Rubro</h5>
	                            <hr className='w-50 my-0' />
	                        </div>
	                        <Bar options={optionss} data={datas} />
	                    </div>
	                </div>
	            </div>
	        </div>
	         :  */_react2.default.createElement(_tablaPedidos2.default, { onHideCambio: function onHideCambio() {
	                setVista('panel');
	            } })
	    );
	};
	exports.default = PanelPedidos;

/***/ },
/* 7172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.imprimirPedido = exports.crearDocumentoPedido = exports.normalizarPedido = exports.unidadDeFila = exports.formatearMontoIva = exports.formatearMonto = exports.cargarReactPDF = undefined;
	
	var _regenerator = __webpack_require__(69);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/**
	 * Reporte / impresion de un PEDIDO en PDF con react-pdf.
	 *
	 * Los datos vienen de /api/pedido/notasPicking (fn_pedidos_por_statusdespacho
	 * o fn_notasdeentrega_por_statusdespacho):
	 *   numpedido/numnotaentrega, totalmonto, codproducto, nomproducto, cantidad,
	 *   punitario, ivaproducto, cliente, rif
	 *
	 * react-pdf se carga en forma diferida desde public/lib/reactpdf.bundle.js
	 * (ver tools/reactpdf) porque el webpack 1 de react-scripts 0.9.5 no puede
	 * parsear la sintaxis moderna con la que se publica la libreria.
	 */
	
	var RUTA_BUNDLE = (("") || '') + '/lib/reactpdf.bundle.js';
	
	var cargarReactPDF = exports.cargarReactPDF = function cargarReactPDF() {
	  if (typeof window === 'undefined') return Promise.reject(new Error('sin navegador'));
	
	  if (window.ReactPDF) return Promise.resolve(window.ReactPDF);
	
	  // se comparte con los demas reportes para no inyectar el bundle dos veces
	  if (!window.__reactPdfCarga) {
	    window.__reactPdfCarga = new Promise(function (resolve, reject) {
	      var script = document.createElement('script');
	      script.src = RUTA_BUNDLE;
	      script.async = true;
	      script.onload = function () {
	        if (window.ReactPDF) {
	          resolve(window.ReactPDF);
	        } else {
	          window.__reactPdfCarga = null;
	          reject(new Error('No se pudo inicializar react-pdf'));
	        }
	      };
	      script.onerror = function () {
	        window.__reactPdfCarga = null;
	        reject(new Error('No se pudo cargar la libreria de PDF (react-pdf)'));
	      };
	      document.body.appendChild(script);
	    });
	  }
	
	  return window.__reactPdfCarga;
	};
	
	var texto = function texto(valor) {
	  if (valor === undefined || valor === null) return '';
	  if (valor instanceof Date) return (0, _moment2.default)(valor).format('DD-MM-YYYY');
	  if ((typeof valor === 'undefined' ? 'undefined' : _typeof(valor)) === 'object') {
	    try {
	      return JSON.stringify(valor);
	    } catch (e) {
	      return '';
	    }
	  }
	  return String(valor);
	};
	
	var numero = function numero(valor) {
	  if (valor === undefined || valor === null) return null;
	  var n = parseFloat(String(valor).trim());
	  return isNaN(n) ? null : n;
	};
	
	var conValor = function conValor(valor) {
	  return valor !== undefined && valor !== null && String(valor).trim() !== '';
	};
	
	// cantidad sin decimales innecesarios (5.00 -> 5)
	var formatearCantidad = function formatearCantidad(valor) {
	  var n = numero(valor);
	  if (n === null) return '';
	  return n.toFixed(2).replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
	};
	
	// montos en formato 1.234,56
	var formatearMonto = exports.formatearMonto = function formatearMonto(valor) {
	  var n = numero(valor);
	  if (n === null) return '';
	  var partes = Math.abs(n).toFixed(2).split('.');
	  var entero = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
	  return (n < 0 ? '-' : '') + entero + ',' + partes[1];
	};
	
	var formatearMontoIva = exports.formatearMontoIva = function formatearMontoIva(valor) {
	  var n = numero(valor);
	  if (n === null) return '';
	  var partes = Math.abs(n).toFixed(4).split('.');
	  var entero = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
	  return (n < 0 ? '-' : '') + entero + ',' + partes[1];
	};
	
	// el backend puede devolver los campos con prefijo txt
	var sinPrefijo = function sinPrefijo(clave) {
	  return String(clave).toLowerCase().replace(/^txt/, '');
	};
	
	var indexarFila = function indexarFila(fila) {
	  var indice = {};
	  Object.keys(fila).forEach(function (clave) {
	    var normal = sinPrefijo(clave);
	    if (indice[normal] === undefined) indice[normal] = clave;
	  });
	  return indice;
	};
	
	var valorCampo = function valorCampo(fila, indice, claves) {
	  for (var i = 0; i < claves.length; i++) {
	    var clave = claves[i];
	
	    // permite patrones, para tolerar variantes del nombre del campo
	    if (clave instanceof RegExp) {
	      var nombres = Object.keys(indice);
	      for (var j = 0; j < nombres.length; j++) {
	        if (clave.test(nombres[j]) && conValor(fila[indice[nombres[j]]])) {
	          return fila[indice[nombres[j]]];
	        }
	      }
	      continue;
	    }
	
	    var encontrada = indice[clave];
	    if (encontrada !== undefined && conValor(fila[encontrada])) return fila[encontrada];
	  }
	  return null;
	};
	// Campos del API usados por el reporte (con alias por si cambian de nombre)
	var CAMPOS = {
	  numero: ['numpedido', 'numpedidoc', 'numeropedido', 'numnotaentrega', 'numeronotaentrega'],
	  cliente: ['cliente', 'nombrecliente', 'nomcliente'],
	  rif: ['rif', 'rifcliente', 'rifclientec'],
	  codigo: ['codigo', 'codproducto', 'codigoproducto'],
	  nombre: ['nombrecorto', 'nomproducto', 'nombreproducto', 'nombre', 'descripcion'],
	  cantidad: ['cantidad', 'cantidadpedida'],
	  tipoUnidad: ['tipounidad', 'tipo_unidad', /tipo_?unidad/],
	  unidadPrincipal: ['unidadprincipal', 'unidaprincipal', /unida?d?_?principal/, 'unidadmedida', 'descripcionunidad', 'unidad'],
	  unidadAlterna: ['unidadalterna', 'unidad_alterna', /unida?d?_?alterna/],
	  punitario: ['punitario', 'precio', 'preciounitario'],
	  iva: ['ivaproducto', 'iva', 'montoiva'],
	  total: ['totalmonto', 'total', 'montototal']
	};
	
	// si el API manda la letra (B, C, ...) se muestra el nombre de la unidad
	var LETRAS_UNIDAD = {
	  B: 'BULTO',
	  C: 'CAJA',
	  P: 'PAQUETE',
	  D: 'DOCENA',
	  U: 'UNIDAD'
	};
	
	// 15 BULTO -> 15 BULTOS ; 15 UNIDAD -> 15 UNIDADES ; 1 CAJAS -> 1 CAJA
	var concordarUnidad = function concordarUnidad(nombre, cantidad) {
	  var palabra = texto(nombre).trim().toUpperCase();
	  if (palabra === '') return '';
	
	  var n = numero(cantidad);
	  if (n === null) return palabra;
	
	  if (n === 1) {
	    if (/ES$/.test(palabra)) return palabra.substring(0, palabra.length - 2);
	    if (/S$/.test(palabra)) return palabra.substring(0, palabra.length - 1);
	    return palabra;
	  }
	
	  if (/S$/.test(palabra)) return palabra;
	  if (/[AEIOU]$/.test(palabra)) return palabra + 'S';
	  return palabra + 'ES';
	};
	
	/**
	 * Unidad que se muestra en la cantidad:
	 *   tipounidad = 0 -> unidad principal del producto (ej. BULTOS)
	 *   tipounidad = 1 -> unidad alterna (ej. UNIDADES)
	 */
	var unidadDeFila = exports.unidadDeFila = function unidadDeFila(tipounidad, unidadPrincipal, unidadAlterna, cantidad) {
	  var nombre = '';
	
	  if (tipounidad === 1) {
	    nombre = texto(unidadAlterna).trim();
	    if (nombre === '') nombre = 'UNIDAD';
	  } else {
	    nombre = texto(unidadPrincipal).trim();
	  }
	
	  var letra = nombre.toUpperCase();
	  if (nombre.length === 1 && LETRAS_UNIDAD[letra]) nombre = LETRAS_UNIDAD[letra];
	
	  return concordarUnidad(nombre, cantidad);
	};
	
	/**
	 * Normaliza los datos de selectPedidos
	 * (acepta un arreglo de renglones o un solo objeto).
	 */
	var normalizarPedido = exports.normalizarPedido = function normalizarPedido(datos) {
	  var entrada = Array.isArray(datos) ? datos : datos ? [datos] : [];
	  var cabecera = { numero: '', cliente: '', rif: '', total: null };
	  var filas = [];
	
	  entrada.forEach(function (registro) {
	    var fila = registro || {};
	    var indice = indexarFila(fila);
	    var valorDe = function valorDe(claves) {
	      return valorCampo(fila, indice, claves);
	    };
	
	    if (cabecera.numero === '') cabecera.numero = texto(valorDe(CAMPOS.numero));
	    if (cabecera.cliente === '') cabecera.cliente = texto(valorDe(CAMPOS.cliente));
	    if (cabecera.rif === '') cabecera.rif = texto(valorDe(CAMPOS.rif));
	
	    var total = numero(valorDe(CAMPOS.total));
	    if (total !== null) cabecera.total = total;
	
	    var cantidad = valorDe(CAMPOS.cantidad);
	    var unidad = unidadDeFila(numero(valorDe(CAMPOS.tipoUnidad)), valorDe(CAMPOS.unidadPrincipal), valorDe(CAMPOS.unidadAlterna), cantidad);
	    var cantidadTexto = formatearCantidad(cantidad);
	
	    filas.push({
	      codigo: texto(valorDe(CAMPOS.codigo)),
	      nombre: texto(valorDe(CAMPOS.nombre)),
	      cantidad: cantidadTexto === '' || unidad === '' ? cantidadTexto : cantidadTexto + ' ' + unidad,
	      punitario: formatearMonto(valorDe(CAMPOS.punitario)),
	      iva: formatearMontoIva(valorDe(CAMPOS.iva))
	    });
	  });
	
	  return { filas: filas, cabecera: cabecera };
	};
	
	var crearEstilos = function crearEstilos(StyleSheet) {
	  return StyleSheet.create({
	    pagina: {
	      paddingTop: 30,
	      paddingBottom: 34,
	      paddingHorizontal: 24,
	      fontSize: 8,
	      fontFamily: 'Helvetica',
	      color: '#232323'
	    },
	    encabezado: {
	      flexDirection: 'row',
	      justifyContent: 'space-between',
	      alignItems: 'flex-end',
	      borderBottomWidth: 1.5,
	      borderBottomColor: '#0b3d63',
	      paddingBottom: 5
	    },
	    titulo: {
	      fontSize: 15,
	      fontFamily: 'Helvetica-Bold',
	      color: '#0b3d63'
	    },
	    subtitulo: {
	      fontSize: 8,
	      color: '#4d4d4d'
	    },
	    datos: {
	      borderWidth: 1,
	      borderColor: '#d5dee6',
	      backgroundColor: '#f2f6fa',
	      paddingVertical: 4,
	      paddingHorizontal: 6,
	      marginBottom: 8
	    },
	    datosFila: {
	      flexDirection: 'row',
	      justifyContent: 'space-between'
	    },
	    datosTexto: {
	      fontSize: 8,
	      fontFamily: 'Helvetica-Bold',
	      color: '#0b3d63'
	    },
	    datosPie: {
	      fontSize: 7.5,
	      color: '#4d4d4d',
	      marginTop: 2
	    },
	    filaTitulos: {
	      flexDirection: 'row',
	      backgroundColor: '#0b3d63'
	    },
	    tituloColumna: {
	      fontSize: 7.5,
	      fontFamily: 'Helvetica-Bold',
	      color: '#ffffff',
	      paddingVertical: 4,
	      paddingHorizontal: 3
	    },
	    fila: {
	      flexDirection: 'row',
	      borderBottomWidth: 0.5,
	      borderBottomColor: '#dfe6ec'
	    },
	    filaPar: {
	      backgroundColor: '#f7f9fb'
	    },
	    celda: {
	      fontSize: 7.5,
	      paddingVertical: 3,
	      paddingHorizontal: 3
	    },
	    derecha: {
	      textAlign: 'right'
	    },
	    totalCaja: {
	      flexDirection: 'row',
	      justifyContent: 'flex-end',
	      marginTop: 6,
	      paddingRight: 3
	    },
	    totalTexto: {
	      fontSize: 10,
	      fontFamily: 'Helvetica-Bold',
	      color: '#0b3d63'
	    },
	    firmas: {
	      flexDirection: 'row',
	      justifyContent: 'space-between',
	      marginTop: 28
	    },
	    firma: {
	      width: '30%',
	      borderTopWidth: 0.8,
	      borderTopColor: '#8a99a8',
	      paddingTop: 3
	    },
	    firmaTexto: {
	      fontSize: 7,
	      color: '#5c6b7a',
	      textAlign: 'center'
	    },
	    pieFijo: {
	      position: 'absolute',
	      bottom: 14,
	      left: 24,
	      right: 24,
	      flexDirection: 'row',
	      justifyContent: 'space-between',
	      borderTopWidth: 0.5,
	      borderTopColor: '#d5dee6',
	      paddingTop: 3
	    },
	    pieTexto: {
	      fontSize: 7,
	      color: '#6c757d'
	    },
	    sinDatos: {
	      marginTop: 40,
	      textAlign: 'center',
	      fontSize: 10,
	      color: '#6c757d'
	    }
	  });
	};
	/**
	 * Documento react-pdf de un pedido. R = window.ReactPDF
	 *
	 * datos     : filas de /api/pedido/notasPicking
	 * metadatos : { empresa, usuario, numpedido, tipoDocumento }
	 */
	var crearDocumentoPedido = exports.crearDocumentoPedido = function crearDocumentoPedido(R, datos, metadatos) {
	  var Document = R.Document,
	      Page = R.Page,
	      View = R.View,
	      Text = R.Text;
	
	  var estilos = crearEstilos(R.StyleSheet);
	  var info = metadatos || {};
	
	  var _normalizarPedido = normalizarPedido(datos),
	      filas = _normalizarPedido.filas,
	      cabecera = _normalizarPedido.cabecera;
	
	  var numero = cabecera.numero !== '' ? cabecera.numero : texto(info.numpedido);
	  var tipoDocumento = texto(info.tipoDocumento || 'PEDIDO').toUpperCase();
	
	  return _react2.default.createElement(
	    Document,
	    {
	      title: tipoDocumento + ' ' + numero,
	      author: texto(info.empresa),
	      subject: tipoDocumento,
	      creator: 'ATHOS ERP',
	      producer: 'ATHOS ERP'
	    },
	    _react2.default.createElement(
	      Page,
	      { size: 'A4', orientation: 'portrait', style: estilos.pagina },
	      _react2.default.createElement(
	        View,
	        { style: estilos.encabezado, fixed: true },
	        _react2.default.createElement(
	          View,
	          null,
	          _react2.default.createElement(
	            Text,
	            { style: estilos.titulo },
	            tipoDocumento + ' N° ' + numero
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: estilos.subtitulo },
	            texto(info.empresa)
	          )
	        ),
	        _react2.default.createElement(
	          View,
	          null,
	          _react2.default.createElement(
	            Text,
	            { style: estilos.subtitulo },
	            'Emitido: ' + (0, _moment2.default)().format('DD-MM-YYYY hh:mm a')
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: estilos.subtitulo },
	            'Usuario: ' + texto(info.usuario)
	          )
	        )
	      ),
	      _react2.default.createElement(
	        View,
	        { style: estilos.datos },
	        _react2.default.createElement(
	          View,
	          { style: estilos.datosFila },
	          _react2.default.createElement(
	            Text,
	            { style: estilos.datosTexto },
	            'CLIENTE: ' + cabecera.cliente
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: estilos.datosTexto },
	            'RIF: ' + cabecera.rif
	          )
	        ),
	        _react2.default.createElement(
	          Text,
	          { style: estilos.datosPie },
	          'RENGLONES: ' + filas.length
	        )
	      ),
	      _react2.default.createElement(
	        View,
	        { style: estilos.filaTitulos },
	        _react2.default.createElement(
	          Text,
	          { style: [estilos.tituloColumna, { flex: 1.2 }] },
	          'CODIGO'
	        ),
	        _react2.default.createElement(
	          Text,
	          { style: [estilos.tituloColumna, { flex: 4.4 }] },
	          'PRODUCTO'
	        ),
	        _react2.default.createElement(
	          Text,
	          { style: [estilos.tituloColumna, { flex: 1.1 }, estilos.derecha] },
	          'CANTIDAD'
	        ),
	        _react2.default.createElement(
	          Text,
	          { style: [estilos.tituloColumna, { flex: 1.4 }, estilos.derecha] },
	          'P. UNITARIO'
	        ),
	        _react2.default.createElement(
	          Text,
	          { style: [estilos.tituloColumna, { flex: 1.4 }, estilos.derecha] },
	          'IVA'
	        )
	      ),
	      filas.length === 0 && _react2.default.createElement(
	        Text,
	        { style: estilos.sinDatos },
	        'No hay informacion por mostrar'
	      ),
	      filas.map(function (fila, indice) {
	        return _react2.default.createElement(
	          View,
	          {
	            key: indice,
	            style: [estilos.fila, indice % 2 === 1 ? estilos.filaPar : null],
	            wrap: false
	          },
	          _react2.default.createElement(
	            Text,
	            { style: [estilos.celda, { flex: 1.2 }] },
	            fila.codigo
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: [estilos.celda, { flex: 4.4 }] },
	            fila.nombre
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: [estilos.celda, { flex: 1.1 }, estilos.derecha] },
	            fila.cantidad
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: [estilos.celda, { flex: 1.4 }, estilos.derecha] },
	            fila.punitario
	          ),
	          _react2.default.createElement(
	            Text,
	            { style: [estilos.celda, { flex: 1.4 }, estilos.derecha] },
	            fila.iva
	          )
	        );
	      }),
	      cabecera.total !== null && _react2.default.createElement(
	        View,
	        { style: estilos.totalCaja },
	        _react2.default.createElement(
	          Text,
	          { style: estilos.totalTexto },
	          'TOTAL ' + tipoDocumento + ': ' + formatearMonto(cabecera.total)
	        )
	      ),
	      _react2.default.createElement(
	        View,
	        { style: estilos.firmas, wrap: false },
	        _react2.default.createElement(
	          View,
	          { style: estilos.firma },
	          _react2.default.createElement(
	            Text,
	            { style: estilos.firmaTexto },
	            'PREPARADO POR'
	          )
	        ),
	        _react2.default.createElement(
	          View,
	          { style: estilos.firma },
	          _react2.default.createElement(
	            Text,
	            { style: estilos.firmaTexto },
	            'VERIFICADO POR'
	          )
	        ),
	        _react2.default.createElement(
	          View,
	          { style: estilos.firma },
	          _react2.default.createElement(
	            Text,
	            { style: estilos.firmaTexto },
	            'RECIBIDO POR'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        View,
	        { style: estilos.pieFijo, fixed: true },
	        _react2.default.createElement(
	          Text,
	          { style: estilos.pieTexto },
	          tipoDocumento + ' N° ' + numero
	        ),
	        _react2.default.createElement(Text, {
	          style: estilos.pieTexto,
	          render: function render(_ref) {
	            var pageNumber = _ref.pageNumber,
	                totalPages = _ref.totalPages;
	            return 'Pagina ' + pageNumber + ' de ' + totalPages;
	          }
	        })
	      )
	    )
	  );
	};
	
	/**
	 * Genera el PDF del pedido y lo muestra en la ventana indicada
	 * (si no se pudo abrir, lo descarga).
	 */
	var imprimirPedido = exports.imprimirPedido = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(datos, metadatos, ventana) {
	    var R, documento, blob, url, enlace, tipoDocumento, nombreArchivo;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return cargarReactPDF();
	
	          case 2:
	            R = _context.sent;
	            documento = crearDocumentoPedido(R, datos, metadatos);
	            _context.next = 6;
	            return R.pdf(documento).toBlob();
	
	          case 6:
	            blob = _context.sent;
	            url = URL.createObjectURL(blob);
	
	
	            if (ventana && !ventana.closed) {
	              ventana.location.href = url;
	            } else {
	              enlace = document.createElement('a');
	
	              enlace.href = url;
	              tipoDocumento = texto((metadatos || {}).tipoDocumento || 'Pedido');
	              nombreArchivo = tipoDocumento.replace(/[^a-zA-Z0-9]+/g, '-');
	
	              enlace.download = nombreArchivo + '-' + (0, _moment2.default)().format('DD-MM-YYYY-hhmm') + '.pdf';
	              document.body.appendChild(enlace);
	              enlace.click();
	              document.body.removeChild(enlace);
	            }
	
	            setTimeout(function () {
	              return URL.revokeObjectURL(url);
	            }, 120000);
	
	          case 10:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined);
	  }));
	
	  return function imprimirPedido(_x, _x2, _x3) {
	    return _ref2.apply(this, arguments);
	  };
	}();

/***/ },
/* 7173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _catalogoPersona = __webpack_require__(64);
	
	var _catalogoPersona2 = _interopRequireDefault(_catalogoPersona);
	
	var _cartasProveedor = __webpack_require__(303);
	
	var _cartasProveedor2 = _interopRequireDefault(_cartasProveedor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TablaClientes = function TablaClientes() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var anio = JSON.parse(sessionStorage.getItem("anioactu"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var accbtnclientes = JSON.parse(sessionStorage.getItem("accbtnclientesc"));
	  var fechaTope = (0, _moment2.default)(JSON.parse(sessionStorage.getItem("fechasistema"))).format("YYYY-MM-DD").replace(anio.toString(), (anio - 18).toString());
	  var registrado = false;
	  var muni = "";
	  var ciu = "";
	  var valrif = 0;
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var chkNatural = (0, _react.useRef)();
	  var chkJuridico = (0, _react.useRef)();
	  var txtId = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtRazon = (0, _react.useRef)();
	  var txtDirClient = (0, _react.useRef)();
	  var txtEmailClient = (0, _react.useRef)();
	  var txtTlf1Client = (0, _react.useRef)();
	  var txtTlf2Client = (0, _react.useRef)();
	  var txtEstado = (0, _react.useRef)();
	  var txtMunicipio = (0, _react.useRef)();
	  var txtCiudad = (0, _react.useRef)();
	  var txtStatus = (0, _react.useRef)();
	  var txtLimtCredito = (0, _react.useRef)();
	  var txtMontoCredito = (0, _react.useRef)();
	  var txtOFerta = (0, _react.useRef)();
	
	  var cmbNacionalidad = (0, _react.useRef)();
	  var txtCedRes = (0, _react.useRef)();
	  var cmbSexo = (0, _react.useRef)();
	  var txtFechaNac = (0, _react.useRef)();
	  var txtNomResp = (0, _react.useRef)();
	  var txtApeResp = (0, _react.useRef)();
	  var txtDireccion = (0, _react.useRef)();
	  var txtEmail = (0, _react.useRef)();
	  var txtTlf1 = (0, _react.useRef)();
	  var txtTlf2 = (0, _react.useRef)();
	  var txtIrsl = (0, _react.useRef)();
	  var cmbGrupoCliente = (0, _react.useRef)();
	  var txtRetencion = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      body = _useState2[0],
	      setBody = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(true),
	      _useState4 = _slicedToArray(_useState3, 2),
	      habilitado = _useState4[0],
	      setHabilitado = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(),
	      _useState6 = _slicedToArray(_useState5, 2),
	      nacnalidad = _useState6[0],
	      setNacnalidad = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(1),
	      _useState8 = _slicedToArray(_useState7, 2),
	      select = _useState8[0],
	      setSelect = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      totalr = _useState10[0],
	      setTotalr = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      totalact = _useState12[0],
	      setTotalact = _useState12[1];
	
	  var _useState13 = (0, _react.useState)("Gestionar Clientes."),
	      _useState14 = _slicedToArray(_useState13, 2),
	      tituloHeader = _useState14[0],
	      setTituloHeader = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      valoferta = _useState16[0],
	      setValoferta = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      totalinc = _useState18[0],
	      setTotalinc = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(""),
	      _useState20 = _slicedToArray(_useState19, 2),
	      titulo = _useState20[0],
	      setTitulo = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(false),
	      _useState22 = _slicedToArray(_useState21, 2),
	      catalogoPersona = _useState22[0],
	      setCatalogoPersona = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(false),
	      _useState24 = _slicedToArray(_useState23, 2),
	      catalogoCliente = _useState24[0],
	      setCatalogoCliente = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(true),
	      _useState26 = _slicedToArray(_useState25, 2),
	      acept = _useState26[0],
	      setAcept = _useState26[1];
	
	  var _useState27 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState28 = _slicedToArray(_useState27, 2),
	      mensaje = _useState28[0],
	      setMensaje = _useState28[1];
	
	  var _useState29 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState30 = _slicedToArray(_useState29, 2),
	      mensajesino = _useState30[0],
	      setMensajesino = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(0),
	      _useState32 = _slicedToArray(_useState31, 2),
	      valcredt = _useState32[0],
	      setValcredt = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(0),
	      _useState34 = _slicedToArray(_useState33, 2),
	      valorCredito = _useState34[0],
	      setValorCredito = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(false),
	      _useState36 = _slicedToArray(_useState35, 2),
	      activate = _useState36[0],
	      setActivate = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(0),
	      _useState38 = _slicedToArray(_useState37, 2),
	      visibleBtn = _useState38[0],
	      setVisibleBtn = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(0),
	      _useState40 = _slicedToArray(_useState39, 2),
	      ops = _useState40[0],
	      setOps = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(0),
	      _useState42 = _slicedToArray(_useState41, 2),
	      operacion = _useState42[0],
	      setOperacion = _useState42[1];
	
	  var _useState43 = (0, _react.useState)([]),
	      _useState44 = _slicedToArray(_useState43, 2),
	      estados = _useState44[0],
	      setEstados = _useState44[1];
	
	  var _useState45 = (0, _react.useState)([]),
	      _useState46 = _slicedToArray(_useState45, 2),
	      municipios = _useState46[0],
	      setMunicipios = _useState46[1];
	
	  var _useState47 = (0, _react.useState)([]),
	      _useState48 = _slicedToArray(_useState47, 2),
	      ciudades = _useState48[0],
	      setCiudades = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(true),
	      _useState50 = _slicedToArray(_useState49, 2),
	      habilitadoNU = _useState50[0],
	      setHabilitadoNU = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(true),
	      _useState52 = _slicedToArray(_useState51, 2),
	      activo = _useState52[0],
	      setActivo = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(true),
	      _useState54 = _slicedToArray(_useState53, 2),
	      activob = _useState54[0],
	      setActivob = _useState54[1];
	
	  var _useState55 = (0, _react.useState)(0),
	      _useState56 = _slicedToArray(_useState55, 2),
	      buscaclient = _useState56[0],
	      setBuscaclient = _useState56[1];
	
	  var _useState57 = (0, _react.useState)(0),
	      _useState58 = _slicedToArray(_useState57, 2),
	      idclient = _useState58[0],
	      setIdclient = _useState58[1];
	
	  var _useState59 = (0, _react.useState)(null),
	      _useState60 = _slicedToArray(_useState59, 2),
	      rifclient = _useState60[0],
	      setRifclient = _useState60[1];
	
	  var _useState61 = (0, _react.useState)(0),
	      _useState62 = _slicedToArray(_useState61, 2),
	      operacionPer = _useState62[0],
	      setOperacionPer = _useState62[1];
	
	  var _useState63 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    catalogoper: true
	  }),
	      _useState64 = _slicedToArray(_useState63, 2),
	      botones = _useState64[0],
	      setBotones = _useState64[1];
	
	  var imprimir = function imprimir() {
	    if (accbtnclientes && accbtnclientes.toString().substring(4, 5) === "1") {
	      window.open(op.reportes + "/clientes?afiliado=" + afiliado + "&reporte=ListaCliente", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var handleInputNumChange = function handleInputNumChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	
	    if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var handleInputMonChange = function handleInputMonChange(event) {
	    event.preventDefault();
	    (0, _varios.validaMonto)(event);
	
	    if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var datosRes = function datosRes() {
	    var campos = "*";
	    var nomtab = "persona";
	    var nomid = "cedula";
	    var nomid2 = "nacionalidad";
	    var id = txtCedRes.current.value;
	    var id2 = cmbNacionalidad.current.value;
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=" + id2;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        cmbSexo.current.value = "";
	        txtFechaNac.current.value = "";
	        txtNomResp.current.value = "";
	        txtApeResp.current.value = "";
	        txtDireccion.current.value = "";
	        txtEmail.current.value = "";
	        txtTlf1.current.value = "";
	        txtTlf2.current.value = "";
	
	        if (response.data !== "") {
	          if (operacion !== 2) {
	            setHabilitadoNU(true);
	          }
	          setOperacionPer(0);
	          cmbSexo.current.value = response.data.sexo;
	          txtFechaNac.current.value = (0, _moment2.default)(response.data.fnacimiento).format("YYYY-MM-DD");
	          txtNomResp.current.value = response.data.nombres && response.data.nombres.trim();
	          txtApeResp.current.value = response.data.apellidos && response.data.apellidos.trim();
	          txtDireccion.current.value = response.data.direccion && response.data.direccion.trim();
	          txtEmail.current.value = response.data.correoe && response.data.correoe.trim();
	          txtTlf1.current.value = response.data.tlf1 && response.data.tlf1.trim();
	          txtTlf2.current.value = response.data.tlf2 && response.data.tlf2.trim();
	          if (!botones.consultar) {
	            btnCancela.current.focus();
	          } else {
	            btnAcepta.current.focus();
	          }
	        } else {
	          cmbSexo.current.focus();
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe una persona con este N° de cedula porfavor registre sus datos",
	            icono: "informacion"
	          });
	          setOperacionPer(1);
	          setHabilitadoNU(false);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "*";
	    var nomtab = "estado";
	    var orden = "idestado";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setEstados(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var selectMunicipios = function selectMunicipios(id) {
	    var campos = "*";
	    var nomtab = "municipio";
	    var nomid = "idestado";
	    var endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&id=" + id + "&nomtab=" + nomtab + "&nomid=" + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setMunicipios(response.data);
	        if (registrado || !botones.consultar || !botones.modificar || !botones.eliminar) {
	          txtMunicipio.current.value = muni;
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var selectCiudad = function selectCiudad(id) {
	    var campos = "*";
	    var nomtab = "ciudad";
	    var nomid = "idmunicipio";
	    var endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&id=" + id + "&nomtab=" + nomtab + "&nomid=" + nomid;
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setCiudades(response.data);
	        if (registrado || !botones.consultar || !botones.modificar || !botones.eliminar) {
	          txtCiudad.current.value = ciu;
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setValcredt(0);
	    setValorCredito(0);
	    setTituloHeader("Gestionar Clientes.");
	    setBuscaclient(0);
	    setIdclient(0);
	    setValoferta(0);
	    setRifclient(null);
	    setVisibleBtn(0);
	    setActivate(false);
	    setActivo(true);
	    setActivob(true);
	    setBody(null);
	    setOperacionPer(0);
	    setHabilitado(true);
	    setHabilitadoNU(true);
	    setMunicipios([]);
	    setCiudades([]);
	    setAcept(true);
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      catalogoper: true
	    });
	    txtOFerta.current.checked = false;
	    txtLimtCredito.current.checked = false;
	    txtMontoCredito.current.value = "";
	    chkJuridico.current.checked = true;
	    cmbRif.current.value = "";
	    txtRif.current.value = "";
	    txtId.current.value = 0;
	    txtRazon.current.value = "";
	    txtDirClient.current.value = "";
	    txtTlf1Client.current.value = "";
	    txtTlf2Client.current.value = "";
	    txtEmailClient.current.value = "";
	    txtStatus.current.value = "";
	    txtEstado.current.value = "";
	    txtMunicipio.current.value = "";
	    txtCiudad.current.value = "";
	
	    cmbNacionalidad.current.value = "";
	    txtCedRes.current.value = "";
	    cmbSexo.current.value = "";
	    txtFechaNac.current.value = "";
	    txtNomResp.current.value = "";
	    txtApeResp.current.value = "";
	    txtDireccion.current.value = "";
	    txtEmail.current.value = "";
	    txtTlf1.current.value = "";
	    txtTlf2.current.value = "";
	    txtIrsl.current.value = "";
	    cmbGrupoCliente.current.value = "";
	    txtRetencion.current.checked = false;
	
	    setSelect(1);
	    setNacnalidad();
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var valorcredt = txtMontoCredito.current.value.trim() !== "" ? parseFloat(txtMontoCredito.current.value.trim().replace(".", "").replace(",", ".")) : 0.00;
	    var sigue = true;
	    if (!botones.incluir || !botones.modificar) {
	      var nom = void 0;
	      nom = select === 1 ? "Nombre/Razón Social" : "Nombres y Apellidos";
	
	      var ced = void 0;
	      ced = select === 1 ? "R.I.F" : "Cédula";
	
	      if (txtStatus.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Seleccione el Estatus del Proveedor",
	          icono: "informacion"
	        });
	        txtStatus.current.focus();
	        sigue = false;
	      } else if (txtRazon.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "El campo" + " " + nom + " " + "no debe ir Vacio",
	          icono: "informacion"
	        });
	        txtRazon.current.focus();
	        sigue = false;
	      } else if (txtDirClient.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Describa la Dirección del Proveedor",
	          icono: "informacion"
	        });
	        txtDirClient.current.focus();
	        sigue = false;
	      } else if (txtEstado.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Seleccione el Estado del Proveedor",
	          icono: "informacion"
	        });
	        txtEstado.current.focus();
	        sigue = false;
	      } else if (txtMunicipio.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Seleccione el Municipio del Proveedor",
	          icono: "informacion"
	        });
	        txtMunicipio.current.focus();
	        sigue = false;
	      } else if (txtCiudad.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Seleccione la Ciudad del Proveedor",
	          icono: "informacion"
	        });
	        txtCiudad.current.focus();
	        sigue = false;
	      } else if (txtCedRes.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Debe Seleccionar el Responsable",
	          icono: "informacion"
	        });
	        txtCedRes.current.focus();
	        sigue = false;
	      } else if (operacionPer === 1) {
	        if (cmbNacionalidad.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe seleccionar la nacionalidad del responsable",
	            icono: "informacion"
	          });
	          cmbNacionalidad.current.focus();
	          sigue = false;
	        } else if (cmbSexo.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe seleccionar el Sexo del responsable",
	            icono: "informacion"
	          });
	          cmbSexo.current.focus();
	          sigue = false;
	        } else if (txtFechaNac.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar fecha nacimiento del responsable",
	            icono: "informacion"
	          });
	          txtFechaNac.current.focus();
	          sigue = false;
	        } else if (txtNomResp.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar el nombre del responsable",
	            icono: "informacion"
	          });
	          txtNomResp.current.focus();
	          sigue = false;
	        } else if (txtApeResp.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar el apellido del responsable",
	            icono: "informacion"
	          });
	          txtApeResp.current.focus();
	          sigue = false;
	        } else if (txtDireccion.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar la dirección del responsable",
	            icono: "informacion"
	          });
	          txtDireccion.current.focus();
	          sigue = false;
	        }
	      } else if (txtLimtCredito.current.checked !== false && valorcredt <= 0) {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Debe ingresar un monto válido para el Limite crédito",
	          icono: "informacion"
	        });
	        txtMontoCredito.current.focus();
	        sigue = false;
	      }
	    }
	
	    if (sigue) {
	      var cliente = [];
	      var repre = [];
	
	      cliente.push({
	        idagente: operacion === 1 ? 0 : txtId.current.value,
	        nombre: txtRazon.current.value.toUpperCase().trim(),
	        direccion: txtDirClient.current.value.toUpperCase().trim(),
	        tipoper: chkNatural.current.checked ? 0 : 1,
	        rif: nacnalidad + txtRif.current.value,
	        reprelegal: cmbNacionalidad.current.value + txtCedRes.current.value,
	        telefono: txtTlf1Client.current.value,
	        celular: txtTlf2Client.current.value,
	        email: txtEmailClient.current.value.toUpperCase().trim(),
	        cliente: true,
	        statuscliente: txtStatus.current.value.trim(),
	        estado: txtEstado.current.value.trim(),
	        municipio: txtMunicipio.current.value.trim(),
	        ciudad: txtCiudad.current.value.trim(),
	        islr: txtIrsl.current.value.trim(),
	        grupcli: cmbGrupoCliente.current.value.trim(),
	        agenteretencion: txtRetencion.current.checked ? true : false,
	        limitecredito: txtLimtCredito.current.checked ? true : false,
	        montocredito: valorcredt,
	        oferta: valoferta
	      });
	      repre.push({
	        cedula: parseInt(txtCedRes.current.value),
	        correoe: txtEmail.current.value.toUpperCase().trim(),
	        tlf1: txtTlf1.current.value.trim(),
	        tlf2: txtTlf2.current.value.trim(),
	        apellidos: txtApeResp.current.value.toUpperCase().trim(),
	        direccion: txtDireccion.current.value.toUpperCase().trim(),
	        fnacimiento: txtFechaNac.current.value.trim(),
	        nacionalidad: cmbNacionalidad.current.value.trim(),
	        nombres: txtNomResp.current.value.toUpperCase().trim(),
	        sexo: cmbSexo.current.value.trim()
	      });
	      setBody({
	        operacionper: operacionPer,
	        agente: cliente,
	        repre: repre,
	        client: []
	      });
	
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	
	    var endpoint = op.conexion + "/api/agente/actualizar/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro creado correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro modificado correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro eliminado correctamente",
	            icono: "exito"
	          });
	        }
	        seleccionarTotalesClientes();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = "";
	      if (error.response === undefined) {
	        mensaje = "Error de Conexion";
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "agente_rif_key"') {
	          mensaje = "Ya existe un Registro con este rif";
	        } else if (error.response.data.message === 'duplicate key value violates unique constraint "agente_email_key"') {
	          mensaje = "Ya existe un Registro con este correo";
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var datosPro = function datosPro(rif) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "rif";
	    var nomid2 = "cliente";
	    var id = rif;
	    var endpoint = "";
	
	    if (!botones.incluir) {
	      endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	    } else {
	      endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	    }
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data !== "") {
	          if (botones.incluir === false && response.data.cliente && response.data.rif === valrif) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "¡El Cliente con el N° de Cédula o RIF" + " " + response.data.rif + " " + "ya Existe!",
	              icono: "informacion"
	            });
	            txtId.current.value = "";
	            txtStatus.current.value = "";
	            txtRazon.current.value = "";
	            txtDirClient.current.value = "";
	            txtEmailClient.current.value = "";
	            txtTlf1Client.current.value = "";
	            txtTlf2Client.current.value = "";
	            txtEstado.current.value = "";
	            txtMunicipio.current.value = "";
	            txtCiudad.current.value = "";
	            txtRif.current.value = "";
	            cmbRif.current.value = "--";
	
	            cmbNacionalidad.current.value = "";
	            txtCedRes.current.value = "";
	
	            muni = "";
	            ciu = "";
	
	            cmbSexo.current.value = "";
	            txtFechaNac.current.value = "";
	            txtNomResp.current.value = "";
	            txtApeResp.current.value = "";
	            txtDireccion.current.value = "";
	            txtEmail.current.value = "";
	            txtTlf1.current.value = "";
	            txtTlf2.current.value = "";
	          } else {
	            txtId.current.value = response.data.idagente;
	            txtStatus.current.value = response.data.statuscliente;
	            txtRazon.current.value = response.data.nombre && response.data.nombre.trim();
	            txtDirClient.current.value = response.data.direccion && response.data.direccion.trim();
	            txtEmailClient.current.value = response.data.email && response.data.email.trim();
	            txtTlf1Client.current.value = response.data.telefono && response.data.telefono.trim();
	            txtTlf2Client.current.value = response.data.celular && response.data.celular.trim();
	            txtEstado.current.value = response.data.estado;
	            txtMunicipio.current.value = response.data.municipio;
	            txtCiudad.current.value = response.data.ciudad;
	            txtIrsl.current.value = response.data.islr;
	            cmbGrupoCliente.current.value = response.data.grupcli;
	
	            txtRetencion.current.checked = response.data.agenteretencion;
	
	            cmbNacionalidad.current.value = response.data.reprelegal.substring(0, 1);
	            txtCedRes.current.value = response.data.reprelegal.substring(1, 12);
	
	            muni = response.data.municipio.trim();
	            ciu = response.data.ciudad.trim();
	
	            if (response.data.oferta !== 0) {
	              txtOFerta.current.checked = true;
	              setValoferta(response.data.oferta);
	            } else {
	              txtOFerta.current.checked = false;
	              setValoferta(0);
	            }
	
	            selectMunicipios(response.data.estado.trim());
	            selectCiudad(response.data.municipio.trim());
	            datosRes();
	            setNacnalidad(response.data.rif.substring(0, 1));
	
	            var tip = response.data.tipoper;
	            if (tip === 1) {
	              chkJuridico.current.checked = true;
	              chkNatural.current.checked = false;
	            } else {
	              chkNatural.current.checked = true;
	              chkJuridico.current.checked = false;
	            }
	
	            setSelect(response.data.tipoper);
	
	            if (operacion === 4) {
	              setAcept(true);
	              setIdclient(response.data.idagente);
	              setBuscaclient(1);
	              setRifclient(response.data.rif);
	            } else if (operacion === 2 || operacion === 1) {
	              setAcept(false);
	              setOps(2);
	              setHabilitado(false);
	              setHabilitadoNU(false);
	              setBotones(Object.assign({}, botones, { catalogoper: false }));
	              setIdclient(0);
	              setBuscaclient(0);
	              setRifclient(null);
	            } else if (operacion === 3) {
	              setAcept(false);
	            }
	          }
	        } else {
	          if (operacion === 4 || operacion === 3 || operacion === 2) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "¡El Cliente con el N° de Cédula o RIF" + " " + txtRif.current.value + " " + "No Existe!",
	              icono: "error"
	            });
	            txtId.current.value = "";
	            txtStatus.current.value = "";
	            txtRazon.current.value = "";
	            txtDirClient.current.value = "";
	            txtEmailClient.current.value = "";
	            txtTlf1Client.current.value = "";
	            txtTlf2Client.current.value = "";
	            txtEstado.current.value = "";
	            txtMunicipio.current.value = "";
	            txtCiudad.current.value = "";
	            txtRif.current.value = "";
	            cmbRif.current.value = "--";
	
	            cmbNacionalidad.current.value = "";
	            txtCedRes.current.value = "";
	
	            muni = "";
	            ciu = "";
	
	            cmbSexo.current.value = "";
	            txtFechaNac.current.value = "";
	            txtNomResp.current.value = "";
	            txtApeResp.current.value = "";
	            txtDireccion.current.value = "";
	            txtEmail.current.value = "";
	            txtTlf1.current.value = "";
	            txtTlf2.current.value = "";
	            txtOFerta.current.checked = false;
	            setOps(1);
	            setHabilitado(true);
	            setHabilitadoNU(true);
	            setBotones({ catalogoper: true, aceptar: true });
	          }
	
	          txtRazon.current.focus();
	        }
	      }
	
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var validarCliente = function validarCliente(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (cmbRif.current.value !== "") {
	          if (operacion !== 2) {
	            datosPro(nacnalidad + event.target.value);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe Seleccionar el Tipo de Nacionalidad",
	            icono: "informacion"
	          });
	          cmbRif.current.focus();
	        }
	      }
	    }
	  };
	
	  var validarPersona = function validarPersona(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (cmbNacionalidad.current.value !== "") {
	          datosRes();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "debe seleccionar la nacionalidad",
	            icono: "informacion"
	          });
	          cmbNacionalidad.current.focus();
	        }
	      } else {
	        cmbNacionalidad.current.value = "";
	        cmbSexo.current.value = "";
	        txtFechaNac.current.value = "";
	        txtNomResp.current.value = "";
	        txtApeResp.current.value = "";
	        txtDireccion.current.value = "";
	        txtEmail.current.value = "";
	        txtTlf1.current.value = "";
	        txtTlf2.current.value = "";
	      }
	    }
	  };
	
	  var onChangeCliente = function onChangeCliente(e) {
	    if (e.target.name === "estado") {
	      setMunicipios([]);
	      setCiudades([]);
	      if (e.target.value !== "") {
	        selectMunicipios(e.target.value);
	      }
	    } else if (e.target.name === "municipio") {
	      setCiudades([]);
	      if (e.target.value !== "") {
	        selectCiudad(e.target.value);
	      }
	    } else if (e.target.name === "tipoper") {
	      if (chkNatural.current.checked) {
	        setSelect(0);
	      } else if (chkJuridico.current.checked) {
	        setSelect(1);
	      }
	    } else if (e.target.name === "cmbrif") {
	      var nac = cmbRif.current.value;
	      txtRif.current.value = "";
	      txtRif.current.focus();
	      setNacnalidad(nac);
	    }
	  };
	
	  var onChange = function onChange(e) {
	    var n = void 0;
	    var r = void 0;
	
	    if (e.target.name === "correoe" || e.target.name === "apellidos" || e.target.name === "direccion" || e.target.name === "nombres" || e.target.name === "descripcion") {
	      e.target.value = e.target.value;
	    } else if (e.target.name === "nacionalidad" && txtCedRes.current.value !== "") {
	      if (e.target.value !== "") {
	        datosRes();
	      } else {
	        txtCedRes.current.value = "";
	        cmbSexo.current.value = "";
	        txtFechaNac.current.value = "";
	        txtNomResp.current.value = "";
	        txtApeResp.current.value = "";
	        txtDireccion.current.value = "";
	        txtEmail.current.value = "";
	        txtTlf1.current.value = "";
	        txtTlf2.current.value = "";
	        setHabilitadoNU(true);
	      }
	    } else if (e.target.name === "cedula") {
	      n = cmbRif.current.value;
	      r = txtRif.current.value;
	    }
	    valrif = n + r;
	  };
	
	  var onChangeCredit = function onChangeCredit(e) {
	    if (e.target.name === "Credit") {
	      if (e.target.checked) {
	        setValcredt(1);
	      } else {
	        setValcredt(0);
	        txtMontoCredito.current.value = 0.00;
	      }
	    }
	  };
	
	  var onChangeOFerta = function onChangeOFerta(e) {
	    if (e.target.name === "Oferta") {
	      if (e.target.checked) {
	        setValoferta(1);
	      } else {
	        setValoferta(0);
	      }
	    }
	  };
	
	  var onCatalogoCliente = function onCatalogoCliente(values) {
	    setCatalogoCliente(false);
	    var valordelcredto = (0, _varios.formatMoneda)(values.montocredito.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    if (values.limitecredito !== false) {
	      setValcredt(1);
	      setValorCredito(valordelcredto);
	    } else {
	      setValcredt(0);
	      setValorCredito(parseFloat(0));
	    }
	    txtRazon.current.value = values.nombre;
	    cmbRif.current.value = values.rif.substring(0, 1);
	    txtRif.current.value = values.rifs;
	    cmbNacionalidad.current.value = values.reprelegal.substring(0, 1);
	    txtCedRes.current.value = values.repre;
	    txtLimtCredito.current.checked = values.limitecredito;
	    setNacnalidad(values.rif.substring(0, 1));
	    datosPro(values.rif);
	
	    if (operacion === 4) {
	      setIdclient(values.idagente);
	      setBuscaclient(1);
	      setRifclient(values.rif);
	    } else {
	      setIdclient(0);
	      setBuscaclient(0);
	      setRifclient(null);
	    }
	
	    if (!botones.modificar) {
	      setBotones(Object.assign({}, botones, { catalogoper: false }));
	    }
	    txtMontoCredito.current.value = parseFloat(values.montocredito);
	  };
	
	  var onCatalogoPersona = function onCatalogoPersona(values) {
	    setCatalogoPersona(false);
	    setHabilitadoNU(true);
	    setOperacionPer(0);
	    cmbNacionalidad.current.value = values.nacPer;
	    txtCedRes.current.value = values.cedPer;
	    cmbSexo.current.value = values.sexoPer;
	    txtFechaNac.current.value = (0, _moment2.default)(values.fnacPer).format("YYYY-MM-DD");
	    txtNomResp.current.value = values.nomPer;
	    txtApeResp.current.value = values.apePer;
	    txtDireccion.current.value = values.direPer;
	    txtEmail.current.value = values.correoPer;
	    txtTlf1.current.value = values.tlf1Per;
	    txtTlf2.current.value = values.tlf2Per;
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (accbtnclientes && accbtnclientes.toString().substring(0, 1) === "1") {
	          setVisibleBtn(1);
	          setTituloHeader("Incluir Cliente.");
	          setHabilitado(false);
	          setOps(2);
	          setAcept(false);
	          setOperacion(1);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            cancelar: false,
	            catalogo: true,
	            catalogoper: false
	          });
	          setActivo(false);
	          setActivob(true);
	          txtRif.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (accbtnclientes && accbtnclientes.toString().substring(1, 2) === "1") {
	          setVisibleBtn(1);
	          setTituloHeader("Editar Cliente.");
	          setOperacion(2);
	          setOps(1);
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          setActivo(false);
	          setActivob(false);
	          txtRif.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (accbtnclientes && accbtnclientes.toString().substring(3, 4) === "1") {
	          setVisibleBtn(1);
	          setTituloHeader("Eliminar Cliente.");
	          setOperacion(3);
	          setHabilitado(true);
	          setOps(1);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          setActivo(false);
	          setActivob(false);
	          txtRif.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (accbtnclientes && accbtnclientes.toString().substring(2, 3) === "1") {
	          setVisibleBtn(1);
	          setTituloHeader("Consultar Cliente.");
	          setOperacion(4);
	          setHabilitado(true);
	          setOps(1);
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          setActivo(false);
	          setActivob(false);
	          txtRif.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        setVisibleBtn(0);
	        blanquear();
	      }
	    };
	  };
	
	  var seleccionarTotalesClientes = function seleccionarTotalesClientes() {
	    var campos = "idagente, statuscliente as status";
	    var nomtab = "agente";
	    var nomid = "cliente";
	    var orden = "idagente desc";
	    var endpoint = op.conexion + "/api/consulta/modeliorder?campos=" + campos + "&id=true&nomtab=" + nomtab + "&nomid=" + nomid + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var _activo = 0;
	          var inactivo = 0;
	          for (var i = 0; i < response.data.length; i++) {
	            if (parseInt(response.data[i].status) === 51) {
	              _activo = _activo + 1;
	            } else {
	              inactivo = inactivo + 1;
	            }
	          }
	
	          setTitulo("Clientes");
	          setTotalr(response.data.length);
	          setTotalact(_activo);
	          setTotalinc(inactivo);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarRegistros();
	    seleccionarTotalesClientes();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-9 py-1 mx-auto card shadow " },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row mx-auto  rounded" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-3 mt-2 azulGradiant shadow text-light" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-p-3 mb-1" },
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  tituloHeader
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-p-2 mi-auto" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta,
	                    onClick: imprimir,
	                    className: "btn btn-sm col ml-1 rounded-pill btn-info h-25p f-10"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-print" },
	                    " CLIENTES"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-p-1 mi-auto" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "/inicio", className: "text-light" },
	                  _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "fw-bold" },
	                    "Salir"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12", style: { fontSizeAdjust: "0.6" } },
	              _react2.default.createElement(
	                "fieldset",
	                { className: " row col-sm-12 mx-auto border-azul rounded" },
	                _react2.default.createElement(
	                  "legend",
	                  {
	                    className: "float-none w-auto fw-bold m-0",
	                    style: { fontSize: "15px" }
	                  },
	                  "Datos del Cliente"
	                ),
	                _react2.default.createElement("input", {
	                  ref: txtId,
	                  autoComplete: "off",
	                  type: "hidden",
	                  className: "form-control",
	                  name: "idagente",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mb-1 col-pd-260" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      select === 1 ? "R.I.F" : "CEDULA",
	                      " "
	                    ),
	                    select === 1 ? _react2.default.createElement(
	                      "select",
	                      {
	                        disabled: activo,
	                        ref: cmbRif,
	                        name: "cmbrif",
	                        onChange: onChangeCliente,
	                        value: nacnalidad,
	                        className: "col-sm-3 col-3 px-2 form-select form-control-sm"
	                      },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "" },
	                        "-"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { key: "0", value: "V" },
	                        "V"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { key: "1", value: "J" },
	                        "J"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { key: "2", value: "G" },
	                        "G"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { key: "3", value: "P" },
	                        "P"
	                      )
	                    ) : _react2.default.createElement(
	                      "select",
	                      {
	                        disabled: activo,
	                        ref: cmbRif,
	                        name: "cmbrif",
	                        onChange: onChangeCliente,
	                        value: nacnalidad,
	                        className: "col-sm-3 col-3 px-2 form-select form-control-sm"
	                      },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "" },
	                        "-"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { key: "0", value: "V" },
	                        "V"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { key: "1", value: "E" },
	                        "E"
	                      )
	                    ),
	                    _react2.default.createElement("input", {
	                      ref: txtRif,
	                      autoComplete: "off",
	                      maxLength: 9,
	                      type: "text",
	                      disabled: activo,
	                      className: "form-control col-9 px-1 fs-6",
	                      name: "cedula",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm",
	                      onKeyUp: validarCliente,
	                      onBlur: validarCliente,
	                      onChange: onChange
	                    }),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: activob,
	                        type: "button",
	                        onClick: function onClick() {
	                          return setCatalogoCliente(true);
	                        },
	                        className: "btn btn-success"
	                      },
	                      _react2.default.createElement("i", { className: "fas fa-search" })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mt-15m ml-auto col-pd-280" },
	                  _react2.default.createElement(
	                    "fieldset",
	                    { className: "row col-sm-12 mx-auto border-azul rounded mb-1" },
	                    _react2.default.createElement(
	                      "legend",
	                      {
	                        className: "float-none m-0 w-auto",
	                        style: { fontSize: "14px" }
	                      },
	                      "TIPO PERSONA:"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-5 mr-auto" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: ops === 1 ? true : activo,
	                          name: "tipoper",
	                          value: "1",
	                          ref: chkNatural,
	                          onChange: onChangeCliente,
	                          id: "tipoper",
	                          type: "radio"
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "form-check-label",
	                            htmlFor: "exampleRadi4"
	                          },
	                          "Natural"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-5 ml-auto" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: ops === 1 ? true : activo,
	                          name: "tipoper",
	                          value: "2",
	                          ref: chkJuridico,
	                          onChange: onChangeCliente,
	                          id: "tipoper",
	                          defaultChecked: true,
	                          type: "radio"
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "form-check-label",
	                            htmlFor: "exampleRadi5"
	                          },
	                          "Juridico"
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-200 ml-auto mb-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-check" },
	                    _react2.default.createElement("input", {
	                      ref: txtOFerta,
	                      disabled: habilitado,
	                      className: "form-check-input",
	                      type: "checkbox",
	                      name: "Oferta",
	                      onChange: onChangeOFerta,
	                      value: "",
	                      id: "flexCheckDefault3"
	                    }),
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "form-check-label",
	                        htmlFor: "flexCheckDefault3",
	                        style: { fontSize: "13px" }
	                      },
	                      "OFERTA"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-200 ml-auto mb-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "ESTATUS:"
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        ref: txtStatus,
	                        disabled: ops === 1 ? true : activo,
	                        className: "form-select form-select-sm text-uppercase px-1",
	                        "aria-label": ".form-select-sm example"
	                      },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "" },
	                        "Seleccione"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "51" },
	                        "Activo"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "52" },
	                        "Inactivo"
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-1 col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    select === 1 ? "NOMBRE/RAZON SOCIAL" : "NOMBRES Y APELLIDOS"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    ref: txtRazon,
	                    disabled: habilitado,
	                    name: "nombres",
	                    className: "form-control text-uppercase fs-6",
	                    onChange: onChange,
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-1 col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "DIRECCION:"
	                  ),
	                  _react2.default.createElement("textarea", {
	                    type: "area",
	                    autoComplete: "off",
	                    ref: txtDirClient,
	                    disabled: habilitado,
	                    name: "direccion",
	                    className: "form-control text-uppercase fs-6",
	                    onChange: onChange,
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    style: { height: 40 }
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-1 col-pd-250 px-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "ESTADO:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: txtEstado,
	                      disabled: habilitado,
	                      onChange: onChangeCliente,
	                      name: "estado",
	                      idciudad: "estado",
	                      className: "form-select form-select-sm",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "SELECCIONE"
	                    ),
	                    estados && estados.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idestado },
	                        item.nombre
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-1 col-md-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "MUNICIPIO:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: txtMunicipio,
	                      disabled: habilitado,
	                      onChange: onChangeCliente,
	                      name: "municipio",
	                      id: "municipio",
	                      className: "form-select form-select-sm",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "SELECCIONE"
	                    ),
	                    municipios && municipios.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idmunicipio },
	                        item.nombre
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-1 col-md-3" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CIUDAD:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: txtCiudad,
	                      disabled: habilitado,
	                      name: "ciudad",
	                      id: "ciudad",
	                      className: "form-select form-select-sm",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "SELECCIONE"
	                    ),
	                    ciudades && ciudades.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idciudad },
	                        item.nombre
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-1 col-pd-200 px-2 ml-auto" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text px-1",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CELULAR:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    maxLength: 11,
	                    ref: txtTlf2Client,
	                    disabled: habilitado,
	                    className: "form-control px-1 fs-6",
	                    name: "tlf2",
	                    "aria-label": "Sizing example input",
	                    onChange: onChange,
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: handleInputNumChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-1 col-md-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "EMAIL:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    ref: txtEmailClient,
	                    disabled: habilitado,
	                    className: "form-control text-uppercase fs-6",
	                    name: "correoe",
	                    "aria-label": "Sizing example input",
	                    onChange: onChange,
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-1 col-pd-210 px-1" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text px-1",
	                      id: "inputGroup-sizing-sm px-1"
	                    },
	                    "TELEFONO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    maxLength: 11,
	                    ref: txtTlf1Client,
	                    disabled: habilitado,
	                    className: "form-control px-1 fs-6",
	                    name: "tlf1",
	                    "aria-label": "Sizing example input",
	                    onChange: onChange,
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: handleInputNumChange
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12", style: { fontSizeAdjust: "0.6" } },
	              _react2.default.createElement(
	                "fieldset",
	                { className: " row col-sm-12 mx-auto border-azul rounded" },
	                _react2.default.createElement(
	                  "legend",
	                  {
	                    className: "float-none w-auto fw-bold",
	                    style: { fontSize: "15px" }
	                  },
	                  "Responsable"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-270 px-2" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "CEDULA:"
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        ref: cmbNacionalidad,
	                        name: "nacionalidad",
	                        className: "form-select form-select-sm col-3 px-2",
	                        disabled: habilitado,
	                        "aria-label": ".form-select-sm example",
	                        onChange: onChange
	                      },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "" },
	                        "--"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "V" },
	                        "V"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "E" },
	                        "E"
	                      )
	                    ),
	                    _react2.default.createElement("input", {
	                      ref: txtCedRes,
	                      maxLength: 8,
	                      autoComplete: "off",
	                      type: "text",
	                      disabled: habilitado,
	                      className: "form-control col-7 px-1 fs-6",
	                      name: "cedula",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm",
	                      onKeyUp: validarPersona,
	                      onBlur: validarPersona,
	                      onChange: onChange
	                    }),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: botones.catalogoper,
	                        type: "button",
	                        onClick: function onClick() {
	                          return setCatalogoPersona(true);
	                        },
	                        className: "btn btn-success"
	                      },
	                      _react2.default.createElement("i", { className: "fas fa-search" })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-140 ml-auto" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "SEXO:"
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        ref: cmbSexo,
	                        className: "form-select form-select-sm",
	                        name: "sexo",
	                        disabled: habilitadoNU,
	                        onChange: onChange,
	                        "aria-label": ".form-select-sm example"
	                      },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "" },
	                        "--"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "M" },
	                        "M"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "F" },
	                        "F"
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-330 ml-auto px-2" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "FECHA DE NACIMIENTO"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "date",
	                      ref: txtFechaNac,
	                      max: fechaTope,
	                      className: "form-control text-center px-1 text-uppercase fs-6",
	                      name: "fnacimiento",
	                      "aria-label": "Sizing example input",
	                      onChange: onChange,
	                      disabled: habilitadoNU,
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-6" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "NOMBRES:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    ref: txtNomResp,
	                    name: "nombres",
	                    className: "form-control text-uppercase fs-6",
	                    onChange: onChange,
	                    "aria-label": "Sizing example input",
	                    disabled: habilitadoNU,
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-6" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "APELLIDOS:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    ref: txtApeResp,
	                    name: "apellidos",
	                    className: "form-control text-uppercase fs-6",
	                    onChange: onChange,
	                    "aria-label": "Sizing example input",
	                    disabled: habilitadoNU,
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "DIRECCION:"
	                  ),
	                  _react2.default.createElement("textarea", {
	                    type: "area",
	                    autoComplete: "off",
	                    ref: txtDireccion,
	                    name: "direccion",
	                    className: "form-control text-uppercase fs-6",
	                    onChange: onChange,
	                    "aria-label": "Sizing example input",
	                    disabled: habilitadoNU,
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    style: { height: 40 }
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "EMAIL:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    ref: txtEmail,
	                    className: "form-control text-uppercase fs-6",
	                    name: "correoe",
	                    "aria-label": "Sizing example input",
	                    onChange: onChange,
	                    disabled: habilitadoNU,
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-210 px-1" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text px-1",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TELEFONO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    maxLength: 11,
	                    ref: txtTlf1,
	                    className: "form-control px-1 fs-6",
	                    name: "tlf1",
	                    "aria-label": "Sizing example input",
	                    onChange: onChange,
	                    disabled: habilitadoNU,
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: handleInputNumChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-210" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text px-1",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CELULAR:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    maxLength: 11,
	                    ref: txtTlf2,
	                    className: "form-control px-1 fs-6",
	                    name: "tlf2",
	                    "aria-label": "Sizing example input",
	                    onChange: onChange,
	                    disabled: habilitadoNU,
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: handleInputNumChange
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12", style: { fontSizeAdjust: "0.6" } },
	              _react2.default.createElement(
	                "fieldset",
	                { className: " row col-sm-12 mx-auto border-azul rounded" },
	                _react2.default.createElement(
	                  "legend",
	                  {
	                    className: "float-none w-auto fw-bold",
	                    style: { fontSize: "15px" }
	                  },
	                  "Otros Datos"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-230" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "% RETENCION I.S.L.R:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    ref: txtIrsl,
	                    disabled: habilitado,
	                    maxLength: 2,
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-270 px-1" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "GRUPO DE CLIENTE:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: cmbGrupoCliente,
	                      disabled: habilitado,
	                      className: "form-select form-select-sm text-center",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "SELECCIONE"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "VIP"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "2" },
	                      "REGULAR"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-2 ml-2" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-check" },
	                    _react2.default.createElement("input", {
	                      ref: txtRetencion,
	                      disabled: habilitado,
	                      className: "form-check-input",
	                      type: "checkbox",
	                      value: "",
	                      id: "flexCheckDefault"
	                    }),
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "form-check-label",
	                        htmlFor: "flexCheckDefault",
	                        style: { fontSize: "13px" }
	                      },
	                      "CONTRIBUYENTE ESPECIAL"
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-2" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-check" },
	                    _react2.default.createElement("input", {
	                      ref: txtLimtCredito,
	                      disabled: habilitado,
	                      className: "form-check-input",
	                      type: "checkbox",
	                      name: "Credit",
	                      onChange: onChangeCredit,
	                      value: "",
	                      id: "flexCheckDefault2"
	                    }),
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "form-check-label",
	                        htmlFor: "flexCheckDefault2",
	                        style: { fontSize: "13px" }
	                      },
	                      "LIMITE DE CREDITO"
	                    )
	                  )
	                ),
	                valcredt !== 0 ? _react2.default.createElement(
	                  "div",
	                  { className: "col-md-2 px-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2 col" },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "input-group-text text-black text-bold" },
	                      "MONTO:"
	                    ),
	                    _react2.default.createElement("input", { type: "text", className: "form-control fs-6 text-right", ref: txtMontoCredito, disabled: habilitado, defaultValue: valorCredito, maxLength: 15, "aria-label": "Amount (to the nearest dollar)", placeholder: "0,00", onKeyUp: handleInputMonChange, onBlur: handleInputMonChange }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "input-group-text" },
	                      "$"
	                    )
	                  )
	                ) : _react2.default.createElement("input", { type: "hidden", ref: txtMontoCredito, value: 0.00 })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 py-1" },
	              visibleBtn === 0 ? _react2.default.createElement(
	                "div",
	                { className: "col-pd-botones" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 row m-0" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: botones.incluir,
	                      onClick: onBotones(1),
	                      className: "btn btn-sm col ml-1 mb-1 btn-primary rounded-pill",
	                      title: "Incluir Almacen"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-plus" },
	                      " Incluir "
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: botones.consultar,
	                      onClick: onBotones(4),
	                      className: "btn btn-sm col ml-1 mb-1 btn-info rounded-pill",
	                      title: "Consultar Almacen"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-eye" },
	                      " Consultar"
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: botones.modificar,
	                      onClick: onBotones(2),
	                      className: "btn btn-sm col ml-1 mb-1 btn-warning rounded-pill",
	                      title: "Modificar Almacen"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-edit" },
	                      " Modificar"
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: botones.eliminar,
	                      onClick: onBotones(3),
	                      className: "btn btn-sm col ml-1 mb-1 btn-danger rounded-pill",
	                      title: "Eliminar Almacen"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-trash" },
	                      " Eliminar"
	                    ),
	                    " "
	                  )
	                )
	              ) : _react2.default.createElement(
	                "div",
	                { className: "col-pd-botonesd row m-0 ml-auto" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta,
	                    disabled: acept,
	                    onClick: onBotones(5),
	                    className: "btn btn-sm col ml-1 rounded-pill btn-success"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-check-circle" },
	                    " Aceptar"
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnCancela,
	                    disabled: botones.cancelar,
	                    onClick: onBotones(6),
	                    className: "btn btn-danger col ml-1 btn-sm rounded-pill"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-window-close" },
	                    " Cancelar"
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-3 oculto" },
	          _react2.default.createElement(_cartasProveedor2.default, {
	            totalr: totalr,
	            totalact: totalact,
	            totalinc: totalinc,
	            titulo: titulo,
	            idcliente: idclient,
	            valida: buscaclient,
	            rifclient: rifclient
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: catalogoCliente,
	      nomid: "cliente",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoCliente(false);
	      },
	      onHideAceptaCatalogo: onCatalogoCliente
	    }),
	    _react2.default.createElement(_catalogoPersona2.default, {
	      show: catalogoPersona,
	      onHideCancelaCatPer: function onHideCancelaCatPer() {
	        return setCatalogoPersona(false);
	      },
	      onHideAceptaCatPer: onCatalogoPersona
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return mensaje.titulo === "Exito." ? blanquear() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = TablaClientes;

/***/ },
/* 7174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _core = __webpack_require__(19);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _catalogoFactura = __webpack_require__(651);
	
	var _catalogoFactura2 = _interopRequireDefault(_catalogoFactura);
	
	var _catalogoProductoServicios = __webpack_require__(7036);
	
	var _catalogoProductoServicios2 = _interopRequireDefault(_catalogoProductoServicios);
	
	var _catalogoNotaEntregaFactura = __webpack_require__(653);
	
	var _catalogoNotaEntregaFactura2 = _interopRequireDefault(_catalogoNotaEntregaFactura);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _catalogo_servi = __webpack_require__(7041);
	
	var _catalogo_servi2 = _interopRequireDefault(_catalogo_servi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var TablaFactura = function TablaFactura() {
	    var op = __webpack_require__(8);
	    var token = sessionStorage.getItem("jwtToken");
	    var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	    var idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
	    var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	    var accbtnfacturas = JSON.parse(sessionStorage.getItem("accbtnfacturasc"));
	
	    var txtNumFactura = (0, _react.useRef)();
	    var txtStatus = (0, _react.useRef)();
	    var txtFecha = (0, _react.useRef)();
	    var txtId = (0, _react.useRef)([]);
	    var txtIdproducto = (0, _react.useRef)([]);
	    var txtCantidad = (0, _react.useRef)([]);
	    var btnIncluir = (0, _react.useRef)();
	    var btnEliminar = (0, _react.useRef)();
	    var btnConsultar = (0, _react.useRef)();
	    var btnCancela = (0, _react.useRef)();
	    var btnAcepta = (0, _react.useRef)();
	    var cmbRif = (0, _react.useRef)();
	    var txtRif = (0, _react.useRef)();
	    var txtNombreC = (0, _react.useRef)();
	    var txtSubTotal = (0, _react.useRef)();
	    var txtExentoTotal = (0, _react.useRef)();
	    var txtDescuento = (0, _react.useRef)();
	    var txtTotIva = (0, _react.useRef)();
	    var txtTotal = (0, _react.useRef)();
	    var cmbMoneda = (0, _react.useRef)();
	    var txtFechaVencimiento = (0, _react.useRef)();
	    var cmbTipoPago = (0, _react.useRef)();
	    var txtDescripcion = (0, _react.useRef)();
	    var txtPrecio = (0, _react.useRef)([]);
	    var tipoTrans = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)(null),
	        _useState2 = _slicedToArray(_useState, 2),
	        body = _useState2[0],
	        setBody = _useState2[1];
	
	    var _useState3 = (0, _react.useState)({
	        mostrar: false,
	        idfactu: null
	    }),
	        _useState4 = _slicedToArray(_useState3, 2),
	        mostrarPago = _useState4[0],
	        setMostrarPago = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(0),
	        _useState6 = _slicedToArray(_useState5, 2),
	        operacion = _useState6[0],
	        setOperacion = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(false),
	        _useState8 = _slicedToArray(_useState7, 2),
	        mostrarFiscal = _useState8[0],
	        setMostrarFiscal = _useState8[1];
	
	    var _useState9 = (0, _react.useState)(false),
	        _useState10 = _slicedToArray(_useState9, 2),
	        habilitado = _useState10[0],
	        setHabilitado = _useState10[1];
	
	    var _useState11 = (0, _react.useState)(true),
	        _useState12 = _slicedToArray(_useState11, 2),
	        habilitarCat = _useState12[0],
	        setHabilitarCat = _useState12[1];
	
	    var _useState13 = (0, _react.useState)(true),
	        _useState14 = _slicedToArray(_useState13, 2),
	        habilitadoBot = _useState14[0],
	        setHabilitadoBot = _useState14[1];
	
	    var _useState15 = (0, _react.useState)(false),
	        _useState16 = _slicedToArray(_useState15, 2),
	        habilitadoCli = _useState16[0],
	        setHabilitadoCli = _useState16[1];
	
	    var _useState17 = (0, _react.useState)(0),
	        _useState18 = _slicedToArray(_useState17, 2),
	        selectd = _useState18[0],
	        setSelectd = _useState18[1];
	
	    var _useState19 = (0, _react.useState)(0),
	        _useState20 = _slicedToArray(_useState19, 2),
	        selectp = _useState20[0],
	        setSelectp = _useState20[1];
	
	    var _useState21 = (0, _react.useState)(true),
	        _useState22 = _slicedToArray(_useState21, 2),
	        habilitadoProductos = _useState22[0],
	        setHabilitadoProductos = _useState22[1];
	
	    var _useState23 = (0, _react.useState)(false),
	        _useState24 = _slicedToArray(_useState23, 2),
	        habilitadoMod = _useState24[0],
	        setHabilitadoMod = _useState24[1];
	
	    var _useState25 = (0, _react.useState)(false),
	        _useState26 = _slicedToArray(_useState25, 2),
	        habilitadoTip = _useState26[0],
	        setHabilitadoTip = _useState26[1];
	
	    var _useState27 = (0, _react.useState)(null),
	        _useState28 = _slicedToArray(_useState27, 2),
	        indice = _useState28[0],
	        setIndice = _useState28[1];
	
	    var _useState29 = (0, _react.useState)(0),
	        _useState30 = _slicedToArray(_useState29, 2),
	        visible = _useState30[0],
	        setVisible = _useState30[1];
	
	    var _useState31 = (0, _react.useState)(false),
	        _useState32 = _slicedToArray(_useState31, 2),
	        mostrar = _useState32[0],
	        setMostrar = _useState32[1];
	
	    var _useState33 = (0, _react.useState)(false),
	        _useState34 = _slicedToArray(_useState33, 2),
	        habilitarMoneda = _useState34[0],
	        setHabilitarMoneda = _useState34[1];
	
	    var _useState35 = (0, _react.useState)([]),
	        _useState36 = _slicedToArray(_useState35, 2),
	        records = _useState36[0],
	        setRecords = _useState36[1];
	
	    var _useState37 = (0, _react.useState)([]),
	        _useState38 = _slicedToArray(_useState37, 2),
	        combomoneda = _useState38[0],
	        setComboMoneda = _useState38[1];
	
	    var _useState39 = (0, _react.useState)("Gestionar Facturas."),
	        _useState40 = _slicedToArray(_useState39, 2),
	        tituloHeader = _useState40[0],
	        setTituloHeader = _useState40[1];
	
	    var _useState41 = (0, _react.useState)(false),
	        _useState42 = _slicedToArray(_useState41, 2),
	        catalogoFactura = _useState42[0],
	        setCatalogoFactura = _useState42[1];
	
	    var _useState43 = (0, _react.useState)({
	        mostrar: false,
	        titulo: "",
	        texto: "",
	        icono: ""
	    }),
	        _useState44 = _slicedToArray(_useState43, 2),
	        mensaje = _useState44[0],
	        setMensaje = _useState44[1];
	
	    var _useState45 = (0, _react.useState)({
	        mostrar: false,
	        titulo: "",
	        texto: "",
	        icono: ""
	    }),
	        _useState46 = _slicedToArray(_useState45, 2),
	        mensajesino = _useState46[0],
	        setMensajesino = _useState46[1];
	
	    var _useState47 = (0, _react.useState)({
	        idmoneda: "1",
	        descripcion: "BOLIVARES",
	        simbolo: "Bs",
	        predeterminada: true,
	        subpredeterminada: false,
	        valormoneda: 1.0
	    }),
	        _useState48 = _slicedToArray(_useState47, 2),
	        moneda = _useState48[0],
	        setMoneda = _useState48[1];
	
	    var _useState49 = (0, _react.useState)({
	        idmoneda: "4",
	        descripcion: "DOLAR",
	        simbolo: "$",
	        predeterminada: false,
	        subpredeterminada: true,
	        valormoneda: 1.0
	    }),
	        _useState50 = _slicedToArray(_useState49, 2),
	        monedaSub = _useState50[0],
	        setMonedaSub = _useState50[1];
	
	    var _useState51 = (0, _react.useState)({
	        idmoneda: "4",
	        descripcion: "BOLIVARES",
	        simbolo: "$",
	        predeterminada: false,
	        subpredeterminada: true,
	        valormoneda: 1.0
	    }),
	        _useState52 = _slicedToArray(_useState51, 2),
	        monedaCambio = _useState52[0],
	        setMonedaCambio = _useState52[1];
	
	    var _useState53 = (0, _react.useState)({
	        subtotal: 0.0,
	        descuento: 0.0,
	        exento: 0.0,
	        sujeto: 0.0,
	        iva: 16.0,
	        totaliva: 0.0,
	        total: 0.0
	    }),
	        _useState54 = _slicedToArray(_useState53, 2),
	        totales = _useState54[0],
	        setTotales = _useState54[1];
	
	    var _useState55 = (0, _react.useState)(0.00),
	        _useState56 = _slicedToArray(_useState55, 2),
	        valormoney = _useState56[0],
	        setValormoney = _useState56[1];
	
	    var _useState57 = (0, _react.useState)(false),
	        _useState58 = _slicedToArray(_useState57, 2),
	        catalogoNota = _useState58[0],
	        setCatalogoNota = _useState58[1];
	
	    var _useState59 = (0, _react.useState)(0),
	        _useState60 = _slicedToArray(_useState59, 2),
	        newproduct = _useState60[0],
	        setNewproduct = _useState60[1];
	
	    var _useState61 = (0, _react.useState)([]),
	        _useState62 = _slicedToArray(_useState61, 2),
	        idsnotas = _useState62[0],
	        setIdnotas = _useState62[1];
	
	    var _useState63 = (0, _react.useState)("0"),
	        _useState64 = _slicedToArray(_useState63, 2),
	        numval = _useState64[0],
	        setNumval = _useState64[1];
	
	    var _useState65 = (0, _react.useState)(false),
	        _useState66 = _slicedToArray(_useState65, 2),
	        catalogoCliente = _useState66[0],
	        setCatalogoCliente = _useState66[1];
	
	    var _useState67 = (0, _react.useState)(false),
	        _useState68 = _slicedToArray(_useState67, 2),
	        activate = _useState68[0],
	        setActivate = _useState68[1];
	
	    var _useState69 = (0, _react.useState)("visible"),
	        _useState70 = _slicedToArray(_useState69, 2),
	        visibleBtn = _useState70[0],
	        setVisibleBtn = _useState70[1];
	
	    var _useState71 = (0, _react.useState)(1),
	        _useState72 = _slicedToArray(_useState71, 2),
	        validafactu = _useState72[0],
	        setValidafactu = _useState72[1];
	
	    var _useState73 = (0, _react.useState)({
	        idfactura: "0",
	        numfactura: "000000",
	        cedularif: "",
	        descripcion: "FACTURA DE PRODUCTOS",
	        totalmonto: 0.0,
	        totaliva: 0.0,
	        totaldescuento: 0.0,
	        totalexento: 0.0,
	        totalsujeto: 0.0,
	        idcliente: "",
	        idvendedor: "",
	        fecha: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	        status: 0,
	        idalmacen: "",
	        idmoneda: "",
	        idoperacioninventario: "",
	        idnotaentrega: "",
	        numnotaentrega: "",
	        creditof: false,
	        fechavencimientof: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	        valormoneda: 0.0
	    }),
	        _useState74 = _slicedToArray(_useState73, 2),
	        factura = _useState74[0],
	        setFactura = _useState74[1];
	
	    var _useState75 = (0, _react.useState)({
	        idcliente: "",
	        tiporif: "J",
	        rif: "",
	        nombre: ""
	    }),
	        _useState76 = _slicedToArray(_useState75, 2),
	        cliente = _useState76[0],
	        setCliente = _useState76[1];
	
	    var _useState77 = (0, _react.useState)({
	        idvendedor: "",
	        tiporif: "",
	        rif: "",
	        nombre: "",
	        idalmacen: ""
	    }),
	        _useState78 = _slicedToArray(_useState77, 2),
	        vendedor = _useState78[0],
	        setVendedor = _useState78[1];
	
	    var nomtabla = void 0;
	
	    if (operacion !== 1) {
	        nomtabla = [{ label: "COD-PRODUCTO", textAlign: "center", width: "30px" }, { label: "PRODUCTO", textAlign: "center", width: "50px" }, { label: "CANTIDAD", textAlign: "center", width: "20px" }, { label: "TIPO PRECIO", textAlign: "center", width: "50px" }, { label: "PRECIO UNI.", textAlign: "center", width: "50px" }, { label: "UND. ALT.", textAlign: "center", width: "50px" }, { label: "IVA.", textAlign: "center", width: "50px" }, { label: "MONTO TOTAL", textAlign: "center", width: "50px" }];
	    } else {
	        if (selectp !== 1) {
	            nomtabla = [{ label: "COD-PRODUCTO", textAlign: "center", width: "30px" }, { label: "PRODUCTO", textAlign: "center", width: "50px" }, { label: "CANTIDAD", textAlign: "center", width: "20px" }, { label: "TIPO PRECIO", textAlign: "center", width: "50px" }, { label: "PRECIO UNI.", textAlign: "center", width: "50px" }, { label: "UND. ALT.", textAlign: "center", width: "50px" }, { label: "IVA.", textAlign: "center", width: "50px" }, { label: "MONTO TOTAL", textAlign: "center", width: "50px" }, {
	                label: _react2.default.createElement("i", { className: "fas fa-trash" }),
	                textAlign: "center",
	                width: "20px"
	            }];
	        } else {
	            nomtabla = [{ label: "COD-PRODUCTO", textAlign: "center", width: "30px" }, { label: "PRODUCTO", textAlign: "center", width: "50px" }, { label: "EXISTENCIA", textAlign: "center", width: "30px" }, { label: "CANTIDAD", textAlign: "center", width: "20px" }, { label: "TIPO PRECIO", textAlign: "center", width: "50px" }, { label: "PRECIO UNI.", textAlign: "center", width: "50px" }, { label: "UND. ALT.", textAlign: "center", width: "50px" }, { label: "IVA.", textAlign: "center", width: "50px" }, { label: "MONTO TOTAL", textAlign: "center", width: "50px" }, {
	                label: _react2.default.createElement("i", { className: "fas fa-trash" }),
	                textAlign: "center",
	                width: "20px"
	            }];
	        }
	    }
	
	    var headCells = nomtabla;
	
	    var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	        TblContainer = _useTableScroll.TblContainer,
	        TblHead = _useTableScroll.TblHead;
	
	    var seleccionarMonedas = function seleccionarMonedas() {
	        var campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	        var nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	        var orden = "m.idmoneda";
	
	        var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                "x-access-token": "" + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                var x = 0;
	                if (response.data.length > 0) {
	                    setComboMoneda(response.data);
	                    for (var i = 0; i < response.data.length; i++) {
	                        if (response.data[i].subpredeterminada) {
	                            setMonedaSub(response.data[i]);
	                        } else if (response.data[i].predeterminada) {
	                            setMoneda(response.data[i]);
	                            setMonedaCambio({
	                                idmoneda: response.data[i].idmoneda,
	                                descripcion: response.data[i].descripcion,
	                                simbolo: response.data[i].simbolo,
	                                predeterminada: response.data[i].predeterminada,
	                                subpredeterminada: response.data[i].subpredeterminada,
	                                valormoneda: monedaSub.valormoneda
	                            });
	                            x = i;
	                        }
	                    }
	                }
	                setTimeout(function () {
	                    return cmbMoneda.current.selectedIndex = x;
	                }, 200);
	            }
	        }).catch(function (error) {
	            setMensaje({
	                mostrar: true,
	                titulo: "Error",
	                texto: error.response.data.message,
	                icono: "error"
	            });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var seleccionarVendedor = function seleccionarVendedor(id) {
	        var campos = "v.idagente, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen";
	        var nomtab = "agente as v";
	        var nomid = "v.idagente";
	        var nomid2 = "v.vendedor";
	        var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	        setActivate(true);
	        _axios2.default.get(endpoint, {
	            headers: {
	                "x-access-token": "" + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                if (response.data !== "") {
	                    setVendedor({
	                        idvendedor: response.data.idagente,
	                        tiporif: response.data.tiporifv,
	                        rif: response.data.rifv,
	                        nombre: response.data.nombrev,
	                        idalmacen: response.data.idalmacen
	                    });
	
	                    btnAcepta.current.focus();
	                } else {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Notificación",
	                        texto: "No existe un vendedor con este codigo",
	                        icono: "informacion"
	                    });
	                }
	            }
	            setActivate(false);
	        }).catch(function (error) {
	            setActivate(false);
	            setMensaje({
	                mostrar: true,
	                titulo: "Error",
	                texto: error.response.data.message,
	                icono: "error"
	            });
	        });
	    };
	
	    var seleccionarCliente = function seleccionarCliente(rif, tecla) {
	        var campos = "c.idagente, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
	        var nomtab = "agente as c";
	        var nomid = "c.rif";
	        var nomid2 = "c.cliente";
	        var id = rif;
	        var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	        setActivate(true);
	        _axios2.default.get(endpoint, {
	            headers: {
	                "x-access-token": "" + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                if (response.data !== "") {
	                    txtNombreC.current.value = response.data.nombrec;
	                    setCliente({
	                        idcliente: response.data.idagente,
	                        tiporif: response.data.tiporifc,
	                        rif: response.data.rifc,
	                        nombre: response.data.nombrec
	                    });
	                    if (tecla === 13) {
	                        txtFecha.current.focus();
	                    }
	                } else {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Notificación",
	                        texto: "No existe un cliente con este codigo",
	                        icono: "informacion"
	                    });
	                    txtRif.current.value = "";
	                    cmbRif.current.selectedIndex = -1;
	                    txtNombreC.current.value = "";
	                    if (tecla === 13) {
	                        txtRif.current.focus();
	                    }
	                }
	            }
	            setActivate(false);
	        }).catch(function (error) {
	            setActivate(false);
	            setMensaje({
	                mostrar: true,
	                titulo: "Error",
	                texto: error.response.data.message,
	                icono: "error"
	            });
	        });
	    };
	
	    var seleccionarProducto = function seleccionarProducto(index, idubi, idprod) {
	        var endpoint = op.conexion + "/api/inventario/seleccionarproductoinv2?idproducto='" + idprod.toUpperCase() + "'&idalmacen=" + idubi;
	        _axios2.default.get(endpoint, {
	            headers: {
	                "x-access-token": "" + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                var data = [].concat(_toConsumableArray(records));
	                if (response.data !== "") {
	
	                    for (var i = 0; i < records.length; i++) {
	                        if (parseInt(records[i].idproducto) === parseInt(response.data.idproducto)) {
	                            setActivate(false);
	                            setMensaje({
	                                mostrar: true,
	                                titulo: "Notificacion",
	                                texto: "Este Producto ya fue seleccionado.",
	                                icono: "error"
	                            });
	                            return;
	                        }
	                    }
	
	                    var uni = [];
	                    var precio = 0.0;
	                    var montoiva = 0.0;
	                    var cantie = response.data.cantidad;
	                    var tipouni = 0;
	                    var tiene_iva = false;
	                    var tipoprecio = parseInt(response.data.tipoprecio);
	
	                    if (parseFloat(response.data.ivaventa) > 0.0) {
	                        tiene_iva = true;
	                    }
	
	                    if (parseInt(response.data.tipofactor) === 0 || response.data.tipofactor === null) {
	                        tipouni = 0;
	                        uni = [{
	                            idunidad: response.data.idunidadmedida,
	                            descripcion: response.data.descripcionuni,
	                            tipo: "medida"
	                        }];
	
	                        cantie = parseFloat(response.data.cantidad);
	                        cantie = Math.trunc(cantie);
	
	                        if (tipoprecio === 1) {
	                            precio = parseFloat(response.data.preciomaxi) * monedaSub.valormoneda;
	                        } else if (tipoprecio === 2) {
	                            precio = parseFloat(response.data.precioofe) * monedaSub.valormoneda;
	                        } else if (tipoprecio === 3) {
	                            precio = parseFloat(response.data.preciomayor) * monedaSub.valormoneda;
	                        } else if (tipoprecio === 4) {
	                            precio = parseFloat(response.data.preciomini) * monedaSub.valormoneda;
	                        }
	                    } else {
	
	                        if (parseFloat(response.data.cantidad) < parseFloat(response.data.valorfactor)) {
	                            tipouni = 1;
	                            uni = [{
	                                idunidad: response.data.idunidadalterna,
	                                descripcion: response.data.descripcionunialt,
	                                tipo: "alterna"
	                            }, {
	                                idunidad: response.data.idunidadmedida,
	                                descripcion: response.data.descripcionuni,
	                                tipo: "medida"
	                            }];
	
	                            cantie = parseFloat(response.data.cantidad);
	                            cantie = Math.trunc(cantie);
	
	                            if (tipoprecio === 1) {
	                                if (response.data.servicio === true) {
	                                    precio = parseFloat(response.data.preciomaxi) * monedaSub.valormoneda;
	                                } else {
	                                    precio = parseFloat(response.data.preciomaxialter) * monedaSub.valormoneda;
	                                }
	                            } else if (tipoprecio === 2) {
	                                precio = parseFloat(response.data.precioofealter) * monedaSub.valormoneda;
	                            } else if (tipoprecio === 3) {
	                                precio = parseFloat(response.data.preciomayoralter) * monedaSub.valormoneda;
	                            } else if (tipoprecio === 4) {
	                                precio = parseFloat(response.data.preciominialter) * monedaSub.valormoneda;
	                            }
	                        } else if (parseFloat(response.data.cantidad) >= parseFloat(response.data.valorfactor)) {
	                            tipouni = 0;
	                            uni = [{
	                                idunidad: response.data.idunidadmedida,
	                                descripcion: response.data.descripcionuni,
	                                tipo: "medida"
	                            }, {
	                                idunidad: response.data.idunidadalterna,
	                                descripcion: response.data.descripcionunialt,
	                                tipo: "alterna"
	                            }];
	
	                            cantie = parseFloat(response.data.cantidad / response.data.valorfactor);
	                            cantie = Math.trunc(cantie);
	
	                            if (tipoprecio === 1) {
	                                precio = parseFloat(response.data.preciomaxi) * monedaSub.valormoneda;
	                            } else if (tipoprecio === 2) {
	                                precio = parseFloat(response.data.precioofe) * monedaSub.valormoneda;
	                            } else if (tipoprecio === 3) {
	                                precio = parseFloat(response.data.preciomayor) * monedaSub.valormoneda;
	                            } else if (tipoprecio === 4) {
	                                precio = parseFloat(response.data.preciomini) * monedaSub.valormoneda;
	                            }
	                        }
	                    }
	
	                    montoiva = precio * response.data.ivaventa / 100;
	                    montoiva = (0, _varios.round)(montoiva, 2);
	                    if (index !== null) {
	                        data[index] = {
	                            idproducto: response.data.idproducto,
	                            codigo: response.data.codigo,
	                            cantidad: 1.0,
	                            cantidadE: response.data.servicio === true ? 1000 : cantie,
	                            cantidadEA: parseFloat(response.data.cantidad),
	                            nombrecorto: response.data.nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	                            precio: (0, _varios.round)(precio, 2),
	                            precioconiva: (0, _varios.round)(precio + montoiva, 2),
	                            preciobs: 0.0,
	                            preciomaxi: response.data.preciomaxi,
	                            precioofe: response.data.precioofe,
	                            preciomayor: response.data.preciomayor,
	                            preciomini: response.data.preciomini,
	                            preciomaxialter: response.data.preciomaxialter,
	                            precioofealter: response.data.precioofealter,
	                            preciomayoralter: response.data.preciomayoralter,
	                            preciominialter: response.data.preciominialter,
	                            iva: response.data.ivaventa,
	                            montoiva: montoiva,
	                            totalivas: montoiva,
	                            totalsiniva: (0, _varios.round)(precio, 2),
	                            descuento: 0.0,
	                            total: (0, _varios.round)(precio, 2),
	                            totaldos: (0, _varios.round)(precio + montoiva, 2),
	                            totalmonto: (0, _varios.round)(precio + montoiva, 2),
	                            unidad: uni,
	                            idunidadmedida: response.data.idunidadmedida,
	                            idunidadalterna: response.data.idunidadalterna,
	                            idalmacen: response.data.idalmacen,
	                            idmoneda: response.data.idmoneda,
	                            valormoneda: monedaSub.valormoneda,
	                            tipounidad: tipouni,
	                            tipofactor: response.data.tipofactor,
	                            valorfactor: response.data.valorfactor,
	                            tipoprecio: response.data.tipoprecio,
	                            servicio: response.data.servicio,
	                            concepto: 'N/S'.trim().toString(),
	                            new: true
	                        };
	                    } else {
	                        data.push({
	                            idproducto: response.data.idproducto,
	                            codigo: response.data.codigo,
	                            cantidad: 1.0,
	                            cantidadE: response.data.servicio === true ? 1000 : cantie,
	                            cantidadEA: parseFloat(response.data.cantidad),
	                            nombrecorto: response.data.nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	                            precio: (0, _varios.round)(precio, 2),
	                            precioconiva: (0, _varios.round)(precio + montoiva, 2),
	                            preciomaxi: response.data.preciomaxi,
	                            precioofe: response.data.precioofe,
	                            preciomayor: response.data.preciomayor,
	                            preciomini: response.data.preciomini,
	                            preciomaxialter: response.data.preciomaxialter,
	                            precioofealter: response.data.precioofealter,
	                            preciomayoralter: response.data.preciomayoralter,
	                            preciominialter: response.data.preciominialter,
	                            preciobs: 0.0,
	                            iva: response.data.ivaventa,
	                            montoiva: montoiva,
	                            descuento: 0.0,
	                            totalivas: montoiva,
	                            totalsiniva: (0, _varios.round)(precio, 2),
	                            total: (0, _varios.round)(precio, 2),
	                            totaldos: (0, _varios.round)(precio + montoiva, 2),
	                            totalmonto: (0, _varios.round)(precio + montoiva, 2),
	                            unidad: uni,
	                            idunidadmedida: response.data.idunidadmedida,
	                            idunidadalterna: response.data.idunidadalterna,
	                            idalmacen: response.data.idalmacen,
	                            idmoneda: response.data.idmoneda,
	                            valormoneda: monedaSub.valormoneda,
	                            tipounidad: tipouni,
	                            tipofactor: response.data.tipofactor,
	                            valorfactor: response.data.valorfactor,
	                            tipoprecio: response.data.tipoprecio,
	                            servicio: response.data.servicio,
	                            concepto: 'N/S'.trim().toString(),
	                            new: true
	                        });
	                    }
	                    var newProductsCount = data.filter(function (item) {
	                        return item.new === true;
	                    }).length;
	                    setNewproduct(newProductsCount);
	                    setRecords(data);
	                    var subtotaln = 0.00;
	                    var exenton = 0.00;
	                    var totalivan = 0.00;
	                    var totaln = 0.00;
	                    for (var t = 0; t < data.length; t++) {
	                        var base = 0.00;
	                        if (typeof data[t].totalsiniva !== "undefined" && data[t].totalsiniva !== null && !isNaN(parseFloat(data[t].totalsiniva))) {
	                            base = parseFloat(data[t].totalsiniva);
	                        } else {
	                            base = (0, _varios.round)(data[t].precio * data[t].cantidad, 2);
	                        }
	                        if (parseFloat(data[t].iva) > 0) {
	                            subtotaln = subtotaln + base;
	                            if (typeof data[t].totalivas !== "undefined" && data[t].totalivas !== null && !isNaN(parseFloat(data[t].totalivas))) {
	                                totalivan = totalivan + parseFloat(data[t].totalivas);
	                            } else {
	                                totalivan = totalivan + (0, _varios.round)(base * parseFloat(data[t].iva) / 100, 2);
	                            }
	                        } else {
	                            exenton = exenton + base;
	                        }
	                    }
	                    totaln = subtotaln + exenton + totalivan;
	                    setTotales({
	                        subtotal: subtotaln + exenton,
	                        descuento: 0.0,
	                        exento: exenton,
	                        sujeto: subtotaln,
	                        iva: 16.0,
	                        totaliva: (0, _varios.round)(totalivan, 2),
	                        total: (0, _varios.round)(totaln, 2)
	                    });
	                    setIndice(index);
	                    if (index !== null) {
	                        setTimeout(function () {
	                            return txtCantidad.current[index].focus();
	                        }, 300);
	                    } else {
	                        setTimeout(function () {
	                            return txtCantidad.current[data.length - 1].focus();
	                        }, 300);
	                    }
	                } else {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Notificacion",
	                        texto: "no existe un producto con ese codigo en el almacen.",
	                        icono: "error"
	                    });
	                }
	            }
	            setActivate(false);
	        }).catch(function (error) {
	            setActivate(false);
	            setMensaje({
	                mostrar: true,
	                titulo: "Error",
	                texto: error.response.data.message,
	                icono: "error"
	            });
	        });
	    };
	
	    var seleccionarFactura = function seleccionarFactura() {
	        var campos = "p.*, p.descripcion as descripcionfactura, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
	        var nomtab = "factura as p inner join agente as v on p.idvendedor=v.idagente inner join agente as c on c.idagente=p.idcliente";
	
	        var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=numfactura&id=" + txtNumFactura.current.value.trim();
	
	        setActivate(true);
	        _axios2.default.get(endpoint, {
	            headers: {
	                "x-access-token": "" + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                if (response.data !== "") {
	                    if (response.data.status === 1 && operacion === 2) {
	                        setMensaje({
	                            mostrar: true,
	                            titulo: "Notificación",
	                            texto: "La Facturas ya fue pagada.",
	                            icono: "informacion"
	                        });
	                        setActivate(false);
	                        txtNumFactura.current.value = "";
	                        txtNumFactura.current.focus();
	                        return;
	                    }
	                    txtFecha.current.value = (0, _moment2.default)(response.data.fecha).format("YYYY-MM-DD");
	                    if (operacion !== 1) {
	                        txtStatus.current.value = response.data.status;
	                    }
	                    txtNumFactura.current.setAttribute("disabled", true);
	                    cmbRif.current.value = response.data.tiporifc;
	                    txtRif.current.value = response.data.rifc;
	                    txtNombreC.current.value = response.data.nombrec;
	
	                    for (var i = 0; i < combomoneda.length; i++) {
	                        if (response.data.idmoneda === combomoneda[i].idmoneda) {
	                            cmbMoneda.current.selectedIndex = i;
	                            break;
	                        }
	                    }
	
	                    if (response.data.creditof) {
	                        cmbTipoPago.current.value = "2";
	                        txtFechaVencimiento.current.value = (0, _moment2.default)(response.data.fechavencimientof).format("YYYY-MM-DD");
	                        if (operacion === 2) {
	                            setSelectd(1);
	                        } else {
	                            setSelectd(0);
	                        }
	                    } else {
	                        cmbTipoPago.current.value = "1";
	                        txtFechaVencimiento.current.value = "";
	                        setSelectd(0);
	                    }
	
	                    txtNumFactura.current.value = response.data.numfactura.trim();
	                    txtDescripcion.current.value = response.data.descripcionfactura.trim();
	
	                    setHabilitarCat(true);
	                    setFactura({
	                        idfactura: response.data.idfactura,
	                        numfactura: response.data.numfactura,
	                        cedularif: response.data.cedularif,
	                        descripcion: response.data.descripcionfactura,
	                        totalmonto: response.data.totalmonto,
	                        totaliva: response.data.totaliva,
	                        totaldescuento: response.data.totaldescuento,
	                        totalexento: response.data.totalexento,
	                        totalsujeto: response.data.totalsujeto,
	                        idcliente: response.data.idcliente,
	                        idvendedor: response.data.idvendedor,
	                        fecha: (0, _moment2.default)(response.data.fecha).format("YYYY-MM-DD"),
	                        status: response.data.status,
	                        idalmacen: response.data.idalmacen,
	                        idmoneda: response.data.idmoneda,
	                        idoperacioninventario: response.data.idoperacioninventario,
	                        idnotaentrega: response.data.idnotaentrega,
	                        numnotaentrega: response.data.numnotaentrega,
	                        creditof: response.data.creditof,
	                        fechavencimientof: (0, _moment2.default)(response.data.fechavencimientof).format("YYYY-MM-DD"),
	                        valormoneda: response.data.valormoneda
	                    });
	                    setCliente({
	                        idcliente: response.data.idcliente,
	                        tiporif: response.data.tiporifc,
	                        rif: response.data.rifc,
	                        nombre: response.data.nombrec
	                    });
	
	                    setVendedor({
	                        idvendedor: response.data.idvendedor,
	                        tiporif: response.data.tiporifv,
	                        rif: response.data.rifv,
	                        nombre: response.data.nombrev,
	                        idalmacen: response.data.idalmacen
	                    });
	                    setValormoney(response.data.valormoneda);
	                    setTotales({
	                        subtotal: response.data.totalmonto - response.data.totaliva,
	                        descuento: response.data.totaldescuento,
	                        exento: response.data.totalexento,
	                        sujeto: response.data.totalsujeto,
	                        iva: 16.0,
	                        totaliva: response.data.totaliva,
	                        total: response.data.totalmonto
	                    });
	                    setHabilitadoTip(false);
	                    seleccionarDetalleFactura(response.data.idfactura);
	                    if (operacion === 2) {
	                        setHabilitado(true);
	                        setTimeout(function () {
	                            return txtFecha.current.focus();
	                        }, 200);
	                    } else {
	                        setHabilitado(false);
	                        setTimeout(function () {
	                            return btnCancela.current.focus();
	                        }, 200);
	                    }
	                } else {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Notificación",
	                        texto: "no existe una Facturas con ese codigo.",
	                        icono: "informacion"
	                    });
	                    txtNumFactura.current.value = "";
	                    txtNumFactura.current.focus();
	                }
	            }
	        }).catch(function (error) {
	            setActivate(false);
	            setMensaje({
	                mostrar: true,
	                titulo: "Error",
	                texto: error.response.data.message,
	                icono: "error"
	            });
	        });
	    };
	
	    var seleccionarDetalleFactura = function seleccionarDetalleFactura(idfactura) {
	        var nomtab1 = "facturadetalle";
	        var nomtab2 = "factura";
	        var nomid = "idfactura";
	        var endpoint = op.conexion + "/api/inventario/seleccionarfacturadeta?id=" + idfactura + "&nomtab1=" + nomtab1 + "&nomtab2=" + nomtab2 + "&nomid=" + nomid;
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                "x-access-token": "" + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                if (response.data.length > 0) {
	                    var prod = [];
	                    var uni = [];
	                    var montoiva = 0.0;
	                    var totalivasc = 0.0;
	                    var tipouni = 0;
	                    var tiene_iva = false;
	
	                    for (var i = 0; i < response.data.length; i++) {
	                        if (parseFloat(response.data[i].iva) > 0.0) {
	                            tiene_iva = true;
	                        }
	                        if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) <= 0.0) {
	                            tipouni = 0;
	                            uni = [{
	                                idunidad: response.data[i].idunidadmedida,
	                                descripcion: response.data[i].descripcionuni,
	                                tipo: "medida"
	                            }];
	                        } else if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) > 0.0) {
	                            tipouni = 0;
	                            uni = [{
	                                idunidad: response.data[i].idunidadmedida,
	                                descripcion: response.data[i].descripcionuni,
	                                tipo: "medida"
	                            }, {
	                                idunidad: response.data[i].idunidadalterna,
	                                descripcion: response.data[i].descripcionunialt,
	                                tipo: "alterna"
	                            }];
	                        } else if (response.data[i].tipounidad === 1) {
	                            tipouni = 1;
	                            uni = [{
	                                idunidad: response.data[i].idunidadalterna,
	                                descripcion: response.data[i].descripcionunialt,
	                                tipo: "alterna"
	                            }, {
	                                idunidad: response.data[i].idunidadmedida,
	                                descripcion: response.data[i].descripcionuni,
	                                tipo: "medida"
	                            }];
	                        }
	
	                        montoiva = response.data[i].punitariobs * response.data[i].iva / 100;
	                        montoiva = (0, _varios.round)(montoiva, 2);
	
	                        totalivasc = (0, _varios.round)(montoiva * response.data[i].cantidad, 2);
	
	                        prod.push({
	                            idproducto: response.data[i].idproducto,
	                            codigo: response.data[i].codigo,
	                            cantidad: response.data[i].cantidad,
	                            nombrecorto: response.data[i].nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	                            precio: response.data[i].punitariobs,
	                            precioconiva: (0, _varios.round)(parseFloat(response.data[i].punitariobs) + montoiva, 2),
	                            preciobs: 0.0,
	                            montoiva: montoiva,
	                            descuento: 0.0,
	                            iva: response.data[i].iva,
	                            total: (0, _varios.round)(response.data[i].punitariobs * response.data[i].cantidad, 2),
	                            totaldos: (0, _varios.round)(response.data[i].punitariobs * response.data[i].cantidad + totalivasc, 2),
	                            totalsiniva: (0, _varios.round)(response.data[i].punitariobs * response.data[i].cantidad, 2),
	                            totalivas: totalivasc,
	                            totalmonto: (0, _varios.round)(response.data[i].punitariobs * response.data[i].cantidad + totalivasc, 2),
	                            unidad: uni,
	                            idunidadmedida: response.data[i].idunidadmedida,
	                            idunidadalterna: response.data[i].idunidadalterna,
	                            idalmacen: response.data[i].idalmacen,
	                            valormoneda: response.data[i].valormoneda,
	                            tipounidad: tipouni,
	                            tipofactor: response.data[i].tipofactor,
	                            valorfactor: response.data[i].valorfactor,
	                            tipoprecio: response.data[i].tipoprecio,
	                            servicio: response.data[i].servicio,
	                            concepto: response.data[i].concepto !== null ? response.data[i].concepto.trim() : 'N/S'
	                        });
	                    }
	                    setRecords(prod);
	                }
	            }
	            setActivate(false);
	        }).catch(function (error) {
	            setActivate(false);
	            setMensaje({
	                mostrar: true,
	                titulo: "Error",
	                texto: error.response.data.message,
	                icono: "error"
	            });
	        });
	    };
	
	    var procesarRegistro = function procesarRegistro() {
	        setActivate(true);
	        console.log(body);
	        var endpoint = op.conexion + "/api/inventario/actualizarfactura2/" + operacion;
	        _axios2.default.post(endpoint, body, {
	            headers: {
	                "x-access-token": "" + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                setValidafactu(response.data.idord);
	                if (operacion === 1) {
	                    if (response.data.idord < 0) {
	                        setMensajesino({
	                            mostrar: true,
	                            titulo: "Confirmación.",
	                            texto: "¿Este Número " + txtNumFactura.current.value.trim() + " de Factura ya fue Utilizado, Desea Actualizarlo?",
	                            icono: "confirmacion"
	                        });
	                    } else {
	                        if (factura.creditof !== false) {
	                            setMensaje({
	                                mostrar: true,
	                                titulo: "Exito.",
	                                texto: "Registro " + response.data.idord + " Creado Correctamente",
	                                icono: "exito"
	                            });
	                        } else {
	                            setMensaje({
	                                mostrar: true,
	                                titulo: "Exito.",
	                                texto: "Registro " + response.data.idord + " Creado Correctamente",
	                                icono: "exito"
	                            });
	                            var reporte = "Factura";
	
	                            window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&idnota=" + response.data.idord, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	                        }
	                    }
	                } else if (operacion === 2) {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Exito.",
	                        texto: "Registro " + response.data.idord + " Modificado Correctamente",
	                        icono: "exito"
	                    });
	                } else if (operacion === 3) {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Exito.",
	                        texto: "Registro " + response.data.idord + " Anulado Correctamente",
	                        icono: "exito"
	                    });
	                }
	            }
	        }).catch(function (error) {
	            var mensaje = error.response.data.message;
	            setMensaje({
	                mostrar: true,
	                titulo: "Error",
	                texto: mensaje,
	                icono: "error"
	            });
	        }).finally(function () {
	            return setActivate(false);
	        });
	    };
	
	    var procesarRegistro2 = function procesarRegistro2() {
	        setActivate(true);
	        var endpoint = op.conexion + "/api/inventario/actualizarfacturanota_dos/" + operacion;
	        _axios2.default.post(endpoint, body, {
	            headers: {
	                "x-access-token": "" + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                setValidafactu(response.data.idfactur);
	                if (operacion === 1) {
	                    if (response.data.idfactur < 0) {
	                        setMensajesino({
	                            mostrar: true,
	                            titulo: "Confirmación.",
	                            texto: "¿Este Número " + txtNumFactura.current.value.trim() + " de Factura ya fue Utilizado, Desea Actualizarlo?",
	                            icono: "confirmacion"
	                        });
	                    } else {
	                        if (factura.creditof !== false) {
	                            setMensaje({
	                                mostrar: true,
	                                titulo: "Exito.",
	                                texto: "Registro " + response.data.idfactur + " Creado Correctamente",
	                                icono: "exito"
	                            });
	                        } else {
	                            setMensaje({
	                                mostrar: true,
	                                titulo: "Exito.",
	                                texto: "Registro " + response.data.idfactur + " Creado Correctamente",
	                                icono: "exito"
	                            });
	                            var reporte = "Factura";
	
	                            window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&idnota=" + response.data.idfactur, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	                        }
	                    }
	                } else if (operacion === 2) {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Exito.",
	                        texto: "Registro " + response.data.idfactur + " Anulado Correctamente",
	                        icono: "exito"
	                    });
	                } else if (operacion === 3) {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Exito.",
	                        texto: "Registro " + response.data.idfactur + " Anulado correctamente",
	                        icono: "exito"
	                    });
	                }
	            }
	        }).catch(function (error) {
	            var mensaje = error.response.data.message;
	            setMensaje({
	                mostrar: true,
	                titulo: "Error",
	                texto: mensaje,
	                icono: "error"
	            });
	        }).finally(function () {
	            return setActivate(false);
	        });
	    };
	
	    var validarCliente = function validarCliente(event) {
	        event.preventDefault();
	        (0, _varios.validaSoloNumero)(event);
	        if (event.which === 13 || typeof event.which === "undefined") {
	            if (cmbRif.current.value !== "" && event.target.value !== "") {
	                var rif = cmbRif.current.value + event.target.value;
	                seleccionarCliente(rif, event.which);
	            }
	        }
	    };
	
	    var validarCantidadP = function validarCantidadP(index, it) {
	        return function (event) {
	            (0, _varios.validaMonto)(event);
	            if (event.which === 13 || typeof event.which === "undefined") {
	                var cantidades = (0, _varios.validarCantidaDos)({
	                    index: index,
	                    event: event,
	                    productos: records
	                });
	                if (event.which === 13) {
	                    if (index < cantidades.data.length - 1) {
	                        setTimeout(function () {
	                            return txtCantidad.current[index + 1].focus();
	                        }, 300);
	                    }
	                }
	                setMensaje(cantidades.msm);
	                setRecords(cantidades.data);
	                setTotales(cantidades.totales);
	            }
	        };
	    };
	
	    var validarPrecio = function validarPrecio(index) {
	        return function (event) {
	            (0, _varios.validaMonto)(event);
	            if (event.which === 13 || typeof event.which === "undefined") {
	                if (selectp !== 1) {
	                    var montoprecio = (0, _varios.validarPrecioMontos)({
	                        index: index,
	                        event: event,
	                        productos: records
	                    });
	                    if (event.which === 13) {
	                        if (index < montoprecio.data.length - 1) {
	                            setTimeout(function () {
	                                return txtCantidad.current[index + 1].focus();
	                            }, 300);
	                        }
	                    }
	                    setMensaje(montoprecio.msm);
	                    setRecords(montoprecio.data);
	                    setTotales(montoprecio.totales);
	                } else {
	                    if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	                        event.target.value = "1,00";
	                    }
	                    event.target.value = (0, _varios.formatoMonto)(event.target.value);
	                    var char1 = event.target.value.substring(0, 1);
	                    var char2 = event.target.value.substring(1, 2);
	                    if (char1 === "0" && char2 !== ",") {
	                        event.target.value = event.target.value.substring(1, event.target.value.length);
	                    }
	                    if (event.target.id === "precio") {
	                        var data = [].concat(_toConsumableArray(records));
	                        var info = [];
	
	                        var preci = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	                        var montoiv = (0, _varios.round)(preci * data[index].iva / 100, 2);
	
	                        data[index].precio = preci;
	                        data[index].totalsiniva = (0, _varios.round)(preci * data[index].cantidad, 2);
	                        data[index].totalivas = (0, _varios.round)(montoiv * data[index].cantidad, 2);
	                        data[index].totalmonto = (0, _varios.round)(data[index].totalsiniva + data[index].totalivas, 2);
	                        data[index].montoiva = data[index].totalivas;
	                        data[index].total = data[index].totalsiniva;
	                        data[index].totaldos = data[index].totalmonto;
	
	                        setTotales((0, _varios.calcularTotales_Dos)(data));
	                        setRecords(data);
	                    }
	                }
	            } else if (event.which === 46) {
	                return false;
	            } else if (event.which >= 48 && event.which <= 57) {
	                return true;
	            } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	                return true;
	            } else return false;
	        };
	    };
	
	    var validarIdProducto = function validarIdProducto(index) {
	        return function (event) {
	            event.preventDefault();
	            if (event.which === 13 || typeof event.which === "undefined") {
	                if (event.target.value !== "") {
	                    seleccionarProducto(index, vendedor.idalmacen, event.target.value);
	                }
	            }
	        };
	    };
	
	    var onCatalogoCliente = function onCatalogoCliente(values) {
	        setCatalogoCliente(false);
	        txtNombreC.current.value = values.nombre;
	        cmbRif.current.value = values.rif.substring(0, 1);
	        txtRif.current.value = values.rif.substring(1);
	        setCliente({
	            idcliente: values.idagente,
	            tiporif: values.rif.substring(0, 1),
	            rif: values.rif.substring(1),
	            nombre: values.nombre
	        });
	    };
	
	    var onCatalogoFactura = function onCatalogoFactura(values) {
	        setCatalogoFactura(false);
	        txtNumFactura.current.value = values.numfactura;
	        seleccionarFactura();
	    };
	
	    var agregarProducto = function agregarProducto(producto) {
	        seleccionarProducto(indice, vendedor.idalmacen, producto.codigo);
	        setMostrar(false);
	    };
	
	    var agregarDescripServi = function agregarDescripServi(value) {
	        setHabilitadoMod(false);
	        var nuevosRecords = records.map(function (record) {
	            if (record.servicio === true) {
	                return Object.assign({}, record, {
	                    concepto: value.trim()
	                });
	            }
	            return record;
	        });
	        setRecords(nuevosRecords);
	    };
	
	    var seleccionarxIndice = function seleccionarxIndice(index) {
	        return function (e) {
	            e.preventDefault();
	            if (vendedor.idalmacen !== "" && vendedor.idalmacen !== null) {
	                setMostrar(true);
	                setIndice(index);
	            } else {
	                setMensaje({
	                    mostrar: true,
	                    titulo: "Notificación.",
	                    texto: "debe seleccionar un vendedor.",
	                    icono: "informacion"
	                });
	            }
	        };
	    };
	
	    var eliminarProducto = function eliminarProducto(producto) {
	        return function (e) {
	            e.preventDefault();
	
	            var data = [].concat(_toConsumableArray(records));
	            var elementos = [];
	
	            for (var i = 0; i < data.length; i++) {
	                if (producto.idproducto !== data[i].idproducto) {
	                    elementos.push(data[i]);
	                }
	            }
	            var newProductsCount = elementos.filter(function (item) {
	                return item.new === true;
	            }).length;
	            setNewproduct(newProductsCount);
	            setRecords(elementos);
	            setTotales((0, _varios.calcularTotales_Dos)(elementos));
	        };
	    };
	
	    var abrirModalDescrip = function abrirModalDescrip(val) {
	        return function (e) {
	            if (val !== false) {
	                setHabilitadoMod(true);
	            } else {
	                setHabilitadoMod(false);
	            }
	        };
	    };
	
	    var onChangeMoneda = function onChangeMoneda(e) {
	        var i = e.target.value;
	        var cambio = (0, _varios.onCambioMoneda)({
	            moneda: combomoneda[i],
	            productos: records,
	            monedaPre: moneda,
	            monedaSub: monedaSub
	        });
	        setMonedaCambio(cambio.monedacambio);
	        setRecords(cambio.data);
	    };
	
	    var onChangeUnidad = function onChangeUnidad(index) {
	        return function (e) {
	            e.preventDefault();
	            var data = [].concat(_toConsumableArray(records));
	            var precio = 0.0;
	            var montoiva = 0.0;
	            var tipounidad = 0;
	
	            if (parseInt(e.target.value) === parseInt(data[index].idunidadalterna)) {
	                tipounidad = 1;
	                precio = parseFloat(data[index].precio) / parseFloat(data[index].valorfactor);
	            } else if (parseInt(e.target.value) === parseInt(data[index].idunidadmedida)) {
	                tipounidad = 0;
	                precio = parseFloat(data[index].precio) * parseFloat(data[index].valorfactor);
	            }
	
	            montoiva = precio * parseFloat(data[index].iva) / 100;
	
	            data[index].tipounidad = tipounidad;
	            data[index].precio = precio;
	            data[index].unidad = data[index].unidad.reverse();
	            data[index].totalsiniva = (0, _varios.round)(precio * data[index].cantidad, 2);
	            data[index].totalivas = (0, _varios.round)(montoiva * data[index].cantidad, 2);
	            data[index].totalmonto = (0, _varios.round)(data[index].totalsiniva + data[index].totalivas, 2);
	            data[index].montoiva = data[index].totalivas;
	            data[index].total = data[index].totalsiniva;
	            data[index].totaldos = data[index].totalmonto;
	
	            setRecords(data);
	            setTotales((0, _varios.calcularTotales_Dos)(data));
	        };
	    };
	
	    var onChangeTipoPrecio = function onChangeTipoPrecio(i) {
	        return function (e) {
	            var data = [].concat(_toConsumableArray(records));
	            var tipoprecio = parseInt(e.target.value);
	            var tipounidad = data[i].tipounidad;
	            var cantidad = data[i].cantidad;
	            var precio = 0.0;
	            var total = 0.0;
	
	            if (tipounidad === 1) {
	                if (tipoprecio === 1) {
	                    precio = parseFloat(data[i].preciomaxialter) * monedaSub.valormoneda;
	                } else if (tipoprecio === 2) {
	                    precio = parseFloat(data[i].precioofealter) * monedaSub.valormoneda;
	                } else if (tipoprecio === 3) {
	                    precio = parseFloat(data[i].preciomayoralter) * monedaSub.valormoneda;
	                } else if (tipoprecio === 4) {
	                    precio = parseFloat(data[i].preciominialter) * monedaSub.valormoneda;
	                }
	            } else {
	                if (tipoprecio === 1) {
	                    precio = parseFloat(data[i].preciomaxi) * monedaSub.valormoneda;
	                } else if (tipoprecio === 2) {
	                    precio = parseFloat(data[i].precioofe) * monedaSub.valormoneda;
	                } else if (tipoprecio === 3) {
	                    precio = parseFloat(data[i].preciomayor) * monedaSub.valormoneda;
	                } else if (tipoprecio === 4) {
	                    precio = parseFloat(data[i].preciomini) * monedaSub.valormoneda;
	                }
	            }
	
	            total = precio * cantidad;
	
	            data[i].tipoprecio = e.target.value;
	            data[i].precio = precio;
	            data[i].totalsiniva = (0, _varios.round)(total, 2);
	            data[i].totalivas = (0, _varios.round)(total * parseFloat(data[i].iva) / 100, 2);
	            data[i].totalmonto = (0, _varios.round)(data[i].totalsiniva + data[i].totalivas, 2);
	            data[i].montoiva = data[i].totalivas;
	            data[i].total = data[i].totalsiniva;
	            data[i].totaldos = data[i].totalmonto;
	
	            setRecords(data);
	            setTotales((0, _varios.calcularTotales_Dos)(data));
	        };
	    };
	
	    var onChangeValidar = function onChangeValidar() {
	        var sigue = true;
	
	        if (cmbRif.current.value === "" || txtRif.current.value.trim() === "" || txtNombreC.current.value === "") {
	            setMensaje({
	                mostrar: true,
	                titulo: "Notificación",
	                texto: "El Cliente no debe estar vacio",
	                icono: "informacion"
	            });
	            sigue = false;
	            txtRif.current.focus();
	        } else if (txtFecha.current.value.trim() === "") {
	            setMensaje({
	                mostrar: true,
	                titulo: "Notificación",
	                texto: "La Fecha no debe estar vacia",
	                icono: "informacion"
	            });
	            sigue = false;
	            txtFecha.current.focus();
	        } else if (cmbTipoPago.current.value === "2" && txtFechaVencimiento.current.value === "") {
	            setMensaje({
	                mostrar: true,
	                titulo: "Notificación",
	                texto: "La Fecha de Vencimiento no debe estar vacia",
	                icono: "informacion"
	            });
	            sigue = false;
	            txtFechaVencimiento.current.focus();
	        } else if (txtDescripcion.current.value === "") {
	            setMensaje({
	                mostrar: true,
	                titulo: "Notificación",
	                texto: "El campo Descripción no debe ir Vacio",
	                icono: "informacion"
	            });
	            sigue = false;
	            txtDescripcion.current.focus();
	        } else if (records.length === 0) {
	            setMensaje({
	                mostrar: true,
	                titulo: "Notificación",
	                texto: "No hay Producto agregados",
	                icono: "informacion"
	            });
	            sigue = false;
	            btnCancela.current.focus();
	        } else if (records.length > 0 && operacion !== 3) {
	            for (var i = 0; i < records.length; i++) {
	                if (factura.numnotaentrega === "" || factura.numnotaentrega === null) {
	                    if (records[i].cantidadE === 0.0) {
	                        setMensaje({
	                            mostrar: true,
	                            titulo: "Notificación",
	                            texto: "La  cantidad no debe ser mayor a la cantidad existente",
	                            icono: "informacion"
	                        });
	                        sigue = false;
	                        btnCancela.current.focus();
	                        break;
	                    } else if (records[i].cantidadE < records[i].cantidad) {
	                        setMensaje({
	                            mostrar: true,
	                            titulo: "Notificación",
	                            texto: "La  cantidad no debe ser mayor a la cantidad existente",
	                            icono: "informacion"
	                        });
	                        sigue = false;
	                        btnCancela.current.focus();
	                        break;
	                    }
	                }
	            }
	        }
	
	        if (sigue) {
	            var notaentre = [];
	            var notaentredet = [];
	            var fact = [];
	            var factdet = [];
	            var opeinv = [];
	            var opeinvdet = [];
	            var totaln = 0.00;
	            var totalivan = 0.00;
	            var totaldescn = 0.00;
	            var totalsujn = 0.00;
	            var totalexn = 0.00;
	
	            if (newproduct > 0) {
	                for (var _i = 0; _i < records.length; _i++) {
	
	                    if (records[_i].new !== false) {
	                        notaentredet.push({
	                            idproducto: records[_i].idproducto,
	                            cantidad: records[_i].cantidad,
	                            iva: parseFloat(records[_i].iva),
	                            punitario: records[_i].precio / monedaSub.valormoneda,
	                            descuento: "0.00",
	                            tipounidad: records[_i].tipounidad,
	                            idunidadmedida: records[_i].idunidadmedida,
	                            idunidadalterna: records[_i].idunidadalterna,
	                            tasa: parseFloat(monedaSub.valormoneda),
	                            codproducto: records[_i].codigo,
	                            costo: records[_i].costocalculado / monedaSub.valormoneda,
	                            utilidad: records[_i].utipreciomaxi / monedaSub.valormoneda,
	                            tipopreciodeta: records[_i].tipoprecio,
	                            status: 1,
	                            observacion: records[_i].concepto.toUpperCase().trim(),
	                            idtipoimpuesto: parseFloat(records[_i].iva) <= 16 ? 2 : 1
	                        });
	                        if (parseFloat(records[_i].iva) > 0) {
	                            totalsujn = totalsujn + parseFloat(records[_i].precio) * parseFloat(records[_i].cantidad);
	                            totalivan = totalivan + (typeof records[_i].totalivas !== "undefined" && records[_i].totalivas !== null && !isNaN(parseFloat(records[_i].totalivas)) ? parseFloat(records[_i].totalivas) : parseFloat(records[_i].precio) * parseFloat(records[_i].cantidad) * parseFloat(records[_i].iva) / 100);
	                        } else {
	                            totalexn = totalexn + parseFloat(records[_i].precio) * parseFloat(records[_i].cantidad);
	                        }
	                        totaln = totaln + parseFloat(records[_i].precio) * parseFloat(records[_i].cantidad);
	                    }
	
	                    if (records[_i].servicio !== true && records[_i].new !== false) {
	                        opeinvdet.push({
	                            idproducto: records[_i].idproducto,
	                            nombre: records[_i].nombrecorto,
	                            cantidad: records[_i].cantidad,
	                            precio: records[_i].precio / monedaSub.valormoneda,
	                            fechavencimiento: factura.creditof ? txtFechaVencimiento.current.value : null,
	                            tipomovimiento: "VENTA",
	                            fechatipomovimiento: txtFecha.current.value,
	                            numfactura: txtNumFactura.current.value.trim(),
	                            idalmacen: records[_i].idalmacen,
	                            tipounidad: records[_i].tipounidad,
	                            idunidadmedida: records[_i].idunidadmedida,
	                            idunidadalterna: records[_i].idunidadalterna,
	                            tipofactor: records[_i].tipofactor,
	                            valorfactor: records[_i].valorfactor,
	                            tasa: monedaSub.valormoneda
	                        });
	                    }
	                }
	
	                opeinv.push({
	                    idoperacioninventario: operacion === 1 ? 0 : factura.idoperacioninventario,
	                    tipooperacion: "SALIDA",
	                    idalmacenorigen: vendedor.idalmacen,
	                    idalmacendestino: "",
	                    fecha: txtFecha.current.value,
	                    idmoneda: monedaCambio.idmoneda,
	                    observacion: "VENTA",
	                    opeinvdet: opeinvdet,
	                    idtipopeinv: "2"
	                });
	
	                notaentre.push({
	                    indice: 0,
	                    idnotaentrega: 0,
	                    numnotaentrega: '000000',
	                    tipo: "NE",
	                    cedularif: cliente.tiporif + cliente.rif,
	                    descripcion: "PEDIDO DE PRODUCTO",
	                    totalmonto: totaln / monedaSub.valormoneda,
	                    totaliva: (0, _varios.round)(totalivan, 2) / monedaSub.valormoneda,
	                    totaldescuento: totaldescn / monedaSub.valormoneda,
	                    totalsujeto: totalsujn / monedaSub.valormoneda,
	                    totalexento: totalexn / monedaSub.valormoneda,
	                    idcliente: cliente.idcliente,
	                    idvendedor: vendedor.idvendedor,
	                    fecha: txtFecha.current.value,
	                    status: 1,
	                    idalmacen: vendedor.idalmacen,
	                    idmoneda: monedaSub.idmoneda,
	                    valormoneda: monedaSub.valormoneda,
	                    credito: factura.creditof,
	                    fechavencimiento: factura.creditof ? txtFechaVencimiento.current.value : null,
	                    idoperacioninventario: factura.idoperacioninventario,
	                    mesas: [],
	                    notaentredet: notaentredet,
	                    opeinv: opeinv
	                });
	            } else {
	                notaentre = [];
	            }
	
	            if (selectp !== 1) {
	                fact.push(Object.assign({
	                    idfactura: factura.idfactura,
	                    numfactura: txtNumFactura.current.value.trim(),
	                    descripcion: txtDescripcion.current.value.trim().toUpperCase(),
	                    valormoneda: monedaSub.valormoneda,
	                    cedularif: cliente.tiporif + cliente.rif,
	                    totalmonto: totales.total,
	                    totaliva: totales.totaliva,
	                    totalexento: totales.exento,
	                    totalsujeto: totales.sujeto,
	                    totaldescuento: totales.descuento
	                }, factura.idnotaentrega !== "" && factura.idnotaentrega !== null && {
	                    idnotaentrega: factura.idnotaentrega
	                }, {
	                    idcliente: cliente.idcliente,
	                    idvendedor: vendedor.idvendedor,
	                    fecha: txtFecha.current.value,
	                    status: 1,
	                    idalmacen: vendedor.idalmacen,
	                    idmoneda: monedaCambio.idmoneda,
	                    idoperacioninventario: operacion === 1 ? 0 : factura.idoperacioninventario,
	                    creditof: factura.creditof,
	                    fechavencimientof: factura.creditof ? txtFechaVencimiento.current.value : null,
	                    tipofactu: "VENTA"
	                }));
	
	                for (var _i2 = 0; _i2 < records.length; _i2++) {
	                    factdet.push({
	                        idproducto: records[_i2].idproducto,
	                        cantidad: records[_i2].cantidad,
	                        iva: parseFloat(records[_i2].iva),
	                        punitario: records[_i2].precio / monedaSub.valormoneda,
	                        punitariobs: records[_i2].precio,
	                        descuento: 0.00,
	                        tipounidad: records[_i2].tipounidad,
	                        idunidadmedida: records[_i2].idunidadmedida,
	                        idunidadalterna: records[_i2].idunidadalterna,
	                        concepto: records[_i2].concepto.toUpperCase().trim(),
	                        tasa: parseFloat(monedaSub.valormoneda),
	                        codproducto: records[_i2].codigo
	                    });
	                }
	                setBody({
	                    factur: fact,
	                    facturdet: factdet,
	                    idsnotas: idsnotas,
	                    notaentrega: notaentre
	                });
	            } else {
	                fact.push({
	                    idfactura: factura.idfactura,
	                    numfactura: txtNumFactura.current.value.trim(),
	                    cedularif: cliente.tiporif + cliente.rif,
	                    descripcion: txtDescripcion.current.value.trim().toUpperCase(),
	                    valormoneda: monedaSub.valormoneda,
	                    totalmonto: totales.total,
	                    totaliva: totales.totaliva,
	                    totaldescuento: totales.descuento,
	                    totalsujeto: totales.sujeto,
	                    totalexento: totales.exento,
	                    idcliente: cliente.idcliente,
	                    idvendedor: vendedor.idvendedor,
	                    fecha: txtFecha.current.value,
	                    status: 1,
	                    idmoneda: monedaCambio.idmoneda,
	                    idoperacioninventario: operacion === 1 ? 0 : factura.idoperacioninventario,
	                    idalmacen: vendedor.idalmacen,
	                    creditof: factura.creditof,
	                    fechavencimientof: factura.creditof ? txtFechaVencimiento.current.value : null,
	                    tipofactu: "VENTA"
	                });
	
	                for (var _i3 = 0; _i3 < records.length; _i3++) {
	                    factdet.push({
	                        idproducto: records[_i3].idproducto,
	                        cantidad: records[_i3].cantidad,
	                        iva: parseFloat(records[_i3].iva),
	                        punitario: records[_i3].precio / monedaSub.valormoneda,
	                        punitariobs: records[_i3].precio,
	                        descuento: "0.00",
	                        tipounidad: records[_i3].tipounidad,
	                        idunidadmedida: records[_i3].idunidadmedida,
	                        idunidadalterna: records[_i3].idunidadalterna,
	                        concepto: records[_i3].concepto.toUpperCase().trim(),
	                        tasa: monedaSub.valormoneda,
	                        codproducto: records[_i3].codigo,
	                        costo: records[_i3].costocalculado,
	                        utilidad: records[_i3].utipreciomaxi,
	                        tipopreciodeta: records[_i3].tipoprecio,
	                        idalmacen: records[_i3].idalmacen
	                    });
	                }
	                setBody({
	                    factur: fact,
	                    facturdet: factdet,
	                    notaentrega: notaentre
	                });
	            }
	
	            var msg = "";
	            if (operacion === 1) {
	                msg = "Esta Seguro de Registrar estos Datos.";
	            } else if (operacion === 2) {
	                msg = "Esta Seguro de Modificar estos Datos.";
	            } else if (operacion === 3) {
	                msg = "Esta Seguro de Anular estos Datos.";
	            }
	
	            setMensajesino({
	                mostrar: true,
	                titulo: "Confirmación.",
	                texto: msg,
	                icono: "confirmacion"
	            });
	        }
	    };
	
	    var handleCloseSi = function handleCloseSi() {
	        setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	        if (validafactu < 0) {
	            selectnumfactu();
	        } else {
	            if (selectp !== 1) {
	                procesarRegistro2();
	            } else {
	                procesarRegistro();
	            }
	        }
	    };
	
	    var blanquear = function blanquear() {
	        setTituloHeader("Gestionar Facturas.");
	        setBody();
	        setValormoney(0.00);
	        setValidafactu(1);
	        setNewproduct(0);
	        setActivate(false);
	        setMostrarPago({
	            mostrar: false,
	            idfactu: null
	        });
	        txtDescripcion.current.value = "";
	        setHabilitado(false);
	        setHabilitadoMod(false);
	        setHabilitadoTip(false);
	        setHabilitarMoneda(false);
	        setHabilitadoCli(false);
	        setHabilitadoBot(true);
	        setHabilitarCat(true);
	        setHabilitadoProductos(true);
	        setVisible(0);
	        setSelectp(0);
	        setSelectd(0);
	        setVisibleBtn("visible");
	        setMoneda({
	            idmoneda: "1",
	            descripcion: "BOLIVARES",
	            simbolo: "Bs",
	            predeterminada: false,
	            valormoneda: 1.0
	        });
	        setMonedaCambio({
	            idmoneda: "1",
	            descripcion: "BOLIVARES",
	            simbolo: "Bs",
	            predeterminada: true,
	            subpredeterminada: false,
	            valormoneda: 1.0
	        });
	        setRecords([]);
	        for (var i = 0; i < combomoneda.length; i++) {
	            if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
	                cmbMoneda.current.selectedIndex = i;
	            }
	        }
	        cmbTipoPago.current.value = "1";
	        txtNumFactura.current.value = "";
	        tipoTrans.current.value = '1';
	        txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	        txtFechaVencimiento.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	
	        cmbRif.current.value = "J";
	        txtRif.current.value = "";
	        txtNombreC.current.value = "";
	        setCliente({
	            idcliente: "",
	            tiporif: "J",
	            rif: "",
	            nombre: ""
	        });
	        setVendedor({
	            idvendedor: "",
	            tiporif: "",
	            rif: "",
	            nombre: "",
	            idalmacen: ""
	        });
	        setFactura({
	            idfactura: "0",
	            numfactura: "000000",
	            cedularif: "",
	            descripcion: "FACTURAS DE PRODUCTOS",
	            totalmonto: 0.0,
	            totaliva: 0.0,
	            totaldescuento: 0.0,
	            totalexento: 0.0,
	            totalsujeto: 0.0,
	            idcliente: "",
	            idvendedor: "",
	            fecha: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	            status: 0,
	            idalmacen: "",
	            idmoneda: "",
	            idoperacioninventario: "",
	            idnotaentrega: "",
	            numnotaentrega: "",
	            creditof: false,
	            fechavencimientof: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	            valormoneda: 0.0
	        });
	        setTotales({
	            subtotal: 0.0,
	            descuento: 0.0,
	            exento: 0.0,
	            sujeto: 0.0,
	            iva: 16.0,
	            totaliva: 0.0,
	            total: 0.0
	        });
	        setOperacion(0);
	        setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    };
	
	    var blanquear_lmpi = function blanquear_lmpi() {
	        setBody();
	        setTituloHeader("Incluir Facturas.");
	        setHabilitadoBot(false);
	        setVisibleBtn("hidden");
	        setOperacion(1);
	        setHabilitadoTip(true);
	        setHabilitado(true);
	        setHabilitadoCli(true);
	        setHabilitadoProductos(false);
	        setHabilitarMoneda(true);
	        selectnumfactu();
	        seleccionarVendedor(idVendedor);
	        setHabilitarCat(true);
	        txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	        txtDescripcion.current.value = "FACTURA DE PRODUCTOS";
	        setMoneda({
	            idmoneda: "1",
	            descripcion: "BOLIVARES",
	            simbolo: "Bs",
	            predeterminada: false,
	            valormoneda: 1.0
	        });
	        setMonedaCambio({
	            idmoneda: "1",
	            descripcion: "BOLIVARES",
	            simbolo: "Bs",
	            predeterminada: true,
	            subpredeterminada: false,
	            valormoneda: 1.0
	        });
	        setRecords([]);
	        for (var i = 0; i < combomoneda.length; i++) {
	            if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
	                cmbMoneda.current.selectedIndex = i;
	            }
	        }
	        cmbTipoPago.current.value = "1";
	        txtNumFactura.current.value = "";
	        cmbRif.current.value = "J";
	        txtRif.current.value = "";
	        txtNombreC.current.value = "";
	        setCliente({
	            idcliente: "",
	            tiporif: "J",
	            rif: "",
	            nombre: ""
	        });
	        setVendedor({
	            idvendedor: "",
	            tiporif: "",
	            rif: "",
	            nombre: "",
	            idalmacen: ""
	        });
	        setFactura({
	            idfactura: "0",
	            numfactura: "000000",
	            cedularif: "",
	            descripcion: "FACTURAS DE PRODUCTOS",
	            totalmonto: 0.0,
	            totaliva: 0.0,
	            totaldescuento: 0.0,
	            totalexento: 0.0,
	            totalsujeto: 0.0,
	            idcliente: "",
	            idvendedor: "",
	            fecha: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	            status: 0,
	            idalmacen: "",
	            idmoneda: "",
	            idoperacioninventario: "",
	            idnotaentrega: "",
	            numnotaentrega: "",
	            creditof: false,
	            fechavencimientof: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	            valormoneda: 0.0
	        });
	        setTotales({
	            subtotal: 0.0,
	            descuento: 0.0,
	            exento: 0.0,
	            sujeto: 0.0,
	            iva: 16.0,
	            totaliva: 0.0,
	            total: 0.0
	        });
	        setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    };
	
	    var handleInputChangeCodigo = function handleInputChangeCodigo(event) {
	        event.preventDefault();
	        if (event.which === 13 || typeof event.which === "undefined") {
	            if (event.target.value !== "") {
	                if (event.target.name === "numfactura") {
	                    seleccionarFactura();
	                }
	            }
	        }
	    };
	
	    var selectnumfactu = function selectnumfactu() {
	        var tabla = "factura";
	        var id = "idfactura";
	        var idtabla = "idfactura";
	        var endpoint = op.conexion + "/api/inventario/consultacodigos?tabla=" + tabla + "&idtabla=" + idtabla + "&id=" + id;
	
	        setActivate(true);
	
	        _axios2.default.get(endpoint, {
	            headers: {
	                "x-access-token": "" + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	                if (response.data.numeroasignado > 0) {
	                    var to = parseFloat(response.data.numeroasignado) + 1;
	                    var cerrrou = '0000000';
	                    var paddedNumber = (0, _varios.lpad)(to.toString(), cerrrou, 7);
	                    txtNumFactura.current.value = paddedNumber;
	                    if (txtNumFactura.current.value !== '') {
	                        setTimeout(function () {
	                            return txtNumFactura.current.focus();
	                        }, 200);
	                    }
	                } else {
	                    txtNumFactura.current.value = "0000001";
	                    if (txtNumFactura.current.value !== '') {
	                        setTimeout(function () {
	                            return txtNumFactura.current.focus();
	                        }, 200);
	                    }
	                }
	                setValidafactu(1);
	            }
	        }).catch(function (error) {
	            setMensaje({
	                mostrar: true,
	                titulo: "Error",
	                texto: error.response.data.message,
	                icono: "error"
	            });
	            setActivate(false);
	        }).finally(function () {
	            setActivate(false);
	        });
	    };
	
	    var onChange = function onChange(e) {
	        if (e.target.name === "tipopago") {
	            if (e.target.value === "1") {
	                setSelectd(0);
	                setFactura(Object.assign({}, factura, {
	                    creditof: false,
	                    fechavencimientof: ""
	                }));
	                txtFechaVencimiento.current.value = "";
	            } else if (e.target.value === "2") {
	                setSelectd(1);
	                setFactura(Object.assign({}, factura, {
	                    creditof: true,
	                    fechavencimientof: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD")
	                }));
	                txtFechaVencimiento.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	            }
	        } else if (e.target.name === "desde") {
	            if (e.target.value === "2") {
	                setNumval("1");
	            } else if (e.target.value === "1") {
	                setNumval("0");
	            }
	        } else if (e.target.name === "fecha") {
	            setFactura(Object.assign({}, factura, { fecha: e.target.value }));
	        } else if (e.target.name === "fechavencimiento") {
	            setFactura(Object.assign({}, factura, { fechavencimientof: e.target.value }));
	        }
	
	        if (e.target.name === 'tipotrans') {
	            if (e.target.value !== '1') {
	                blanquear_lmpi();
	                tipoTrans.current.value = '2';
	                setSelectp(1);
	            } else {
	                setSelectp(0);
	            }
	        }
	    };
	
	    var imprimirFactura = function imprimirFactura() {
	        if (accbtnfacturas && accbtnfacturas.toString().substring(4, 5) === "1") {
	            var fact = 0;
	            if (txtNumFactura.current.value !== "") {
	                var idnot = factura.idfactura;
	
	                var reporte = "Factura";
	
	                window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&idnota=" + idnot, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	            } else {
	                setMensaje({
	                    mostrar: true,
	                    titulo: "Notificación",
	                    texto: "¡ Seleccione la Factura !",
	                    icono: "informacion"
	                });
	                fact = 1;
	            }
	
	            if (fact === 1) {
	                txtNumFactura.current.focus();
	            }
	        } else {
	            setMensaje({
	                mostrar: true,
	                titulo: "Notificación.",
	                texto: "¡No Posee Permiso para Realizar esta Acción!",
	                icono: "error"
	            });
	        }
	    };
	
	    var onBotones = function onBotones(op) {
	        return function (e) {
	            e.preventDefault();
	
	            if (op === 1) {
	                if (accbtnfacturas && accbtnfacturas.toString().substring(0, 1) === "1") {
	                    setTituloHeader("Incluir Facturas.");
	                    setHabilitadoBot(false);
	                    setVisibleBtn("hidden");
	                    setOperacion(op);
	                    setHabilitadoTip(true);
	                    setHabilitado(true);
	                    setHabilitadoCli(true);
	                    setHabilitadoProductos(false);
	                    setHabilitarMoneda(true);
	                    selectnumfactu();
	                    setSelectp(0);
	                    seleccionarVendedor(idVendedor);
	                    setHabilitarCat(true);
	                    tipoTrans.current.value = '1';
	                    txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	                    txtDescripcion.current.value = "FACTURA DE PRODUCTOS";
	                } else {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Notificación.",
	                        texto: "¡No Posee Permiso para Realizar esta Acción!",
	                        icono: "error"
	                    });
	                }
	            } else if (op === 2) {
	                if (accbtnfacturas && accbtnfacturas.toString().substring(1, 2) === "1") {
	                    setTituloHeader("Editar Facturas.");
	                    setOperacion(op);
	                    setHabilitarCat(false);
	                    setHabilitadoBot(false);
	                    setHabilitadoProductos(false);
	                    setVisibleBtn("hidden");
	                    setTimeout(function () {
	                        return txtNumFactura.current.focus();
	                    }, 200);
	                } else {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Notificación.",
	                        texto: "¡No Posee Permiso para Realizar esta Acción!",
	                        icono: "error"
	                    });
	                }
	            } else if (op === 3) {
	                if (accbtnfacturas && accbtnfacturas.toString().substring(3, 4) === "1") {
	                    setTituloHeader("Eliminar Facturas.");
	                    setHabilitadoBot(false);
	                    setVisibleBtn("hidden");
	                    setOperacion(op);
	                    setHabilitarCat(false);
	                    setHabilitadoTip(false);
	                    setHabilitarMoneda(false);
	                    setHabilitado(false);
	                    setHabilitadoCli(false);
	                    setHabilitadoProductos(true);
	                    setTimeout(function () {
	                        return txtNumFactura.current.focus();
	                    }, 200);
	                } else {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Notificación.",
	                        texto: "¡No Posee Permiso para Realizar esta Acción!",
	                        icono: "error"
	                    });
	                }
	            } else if (op === 4) {
	                if (accbtnfacturas && accbtnfacturas.toString().substring(2, 3) === "1") {
	                    setTituloHeader("Consultar Facturas.");
	                    setHabilitadoBot(false);
	                    setVisibleBtn("hidden");
	                    setOperacion(op);
	                    setHabilitarCat(false);
	                    setHabilitado(false);
	                    setHabilitadoTip(false);
	                    setHabilitarMoneda(true);
	                    setHabilitadoCli(false);
	                    setHabilitadoProductos(true);
	                    setTimeout(function () {
	                        return txtNumFactura.current.focus();
	                    }, 200);
	                } else {
	                    setMensaje({
	                        mostrar: true,
	                        titulo: "Notificación.",
	                        texto: "¡No Posee Permiso para Realizar esta Acción!",
	                        icono: "error"
	                    });
	                }
	            } else if (op === 5) {
	                onChangeValidar();
	            } else if (op === 6) {
	                blanquear();
	            }
	        };
	    };
	
	    (0, _react.useEffect)(function () {
	        seleccionarMonedas();
	    }, []);
	
	    var seleccionarNotaEntrega = function seleccionarNotaEntrega(datos) {
	        var ids = [];
	        var idsnots = [];
	        for (var i = 0; i < datos.length; i++) {
	            ids.push(parseInt(datos[i].idnota));
	            idsnots.push({
	                idnota: parseInt(datos[i].idnota)
	            });
	        }
	        setIdnotas(idsnots);
	        var endpoint = op.conexion + "/api/registropago/selectnotaentregafactuid?ids=" + ids;
	
	        setActivate(true);
	        _axios2.default.get(endpoint, {
	            headers: {
	                "x-access-token": "" + token
	            }
	        }).then(function (response) {
	            if (response.status === 200) {
	
	                var datapropduct = [];
	                var _datos = [];
	
	                for (var _i4 = 0; _i4 < response.data.length; _i4++) {
	
	                    datapropduct.push({
	                        idproducto: response.data[_i4].idproducto,
	                        codigo: response.data[_i4].codigoproductoc,
	                        nombre: response.data[_i4].nombreproducto,
	                        tipounidad: response.data[_i4].tipounidadc,
	                        idunidadmedida: response.data[_i4].idunidadmedida,
	                        idunidadalterna: response.data[_i4].idunidadalterna,
	                        unidadmedida: response.data[_i4].unidadmedida,
	                        iva: response.data[_i4].iva,
	                        precio: parseFloat(response.data[_i4].precios),
	                        montoiva: parseFloat(response.data[_i4].montoivac),
	                        cantidad: parseFloat(response.data[_i4].cantidadc),
	                        cantidadc: parseFloat(response.data[_i4].cantidadcaja),
	                        cantidadunic: parseFloat(response.data[_i4].cantiunidxcaja),
	                        totalsiniva: parseFloat(response.data[_i4].totalsiniva),
	                        totalmonto: parseFloat(response.data[_i4].total),
	                        valorfactor: parseFloat(response.data[_i4].valorfactor),
	                        servicio: response.data[_i4].servicio
	                    });
	                }
	
	                var unificarProductos = [];
	
	                var _loop = function _loop(product) {
	                    var existingProduct = unificarProductos.find(function (p) {
	                        return p.nombre === product.nombre;
	                    });
	                    if (existingProduct) {
	                        existingProduct.totalmonto += parseFloat(product.totalmonto);
	                        existingProduct.cantidad += parseFloat(product.cantidad);
	                        existingProduct.cantidadc += parseFloat(product.cantidadc);
	                        existingProduct.cantidadunic += parseFloat(product.cantidadunic);
	                        existingProduct.totalsiniva += parseFloat(product.totalsiniva);
	                    } else {
	                        unificarProductos.push(Object.assign({}, product));
	                    }
	                };
	
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = datapropduct[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var product = _step.value;
	
	                        _loop(product);
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                var subtotaln = 0.00;
	                var exenton = 0.00;
	                var sujeton = 0.00;
	                var totalivan = 0.00;
	                var totaln = 0.00;
	                var totalv = 0.00;
	                var uni = [];
	
	                for (var e = 0; e < unificarProductos.length; e++) {
	
	                    var precioproduct = 0.00;
	                    var totalcantidad = 0;
	                    var montoconiva = 0.00;
	                    var montototal = 0.00;
	                    var moniva = 0.00;
	                    var totaliva = 0.00;
	                    var totaliva2 = 0.00;
	                    var tipouni = null;
	
	                    if (unificarProductos[e].cantidad > 0 && unificarProductos[e].cantidadc > 0) {
	                        precioproduct = (0, _varios.round)(unificarProductos[e].totalsiniva / (unificarProductos[e].cantidad + unificarProductos[e].cantidadunic), 2);
	                        totalcantidad = unificarProductos[e].cantidad + unificarProductos[e].cantidadunic;
	                        moniva = (0, _varios.round)(precioproduct * unificarProductos[e].iva / 100, 2);
	                        totaliva = moniva;
	                        totaliva2 = (0, _varios.round)(moniva * totalcantidad, 2);
	                        montoconiva = (0, _varios.round)((precioproduct + moniva) * totalcantidad, 2);
	                        montototal = (0, _varios.round)(precioproduct * totalcantidad, 2);
	                        tipouni = 1;
	                    } else if (unificarProductos[e].cantidad > 0 && unificarProductos[e].cantidadc === 0) {
	                        precioproduct = (0, _varios.round)(unificarProductos[e].totalsiniva / unificarProductos[e].cantidad, 2);
	                        totalcantidad = unificarProductos[e].cantidad;
	                        moniva = (0, _varios.round)(precioproduct * unificarProductos[e].iva / 100, 2);
	                        totaliva = moniva;
	                        totaliva2 = (0, _varios.round)(moniva * totalcantidad, 2);
	                        montoconiva = (0, _varios.round)((precioproduct + moniva) * totalcantidad, 2);
	                        montototal = (0, _varios.round)(precioproduct * totalcantidad, 2);
	                        tipouni = 1;
	                    } else {
	                        precioproduct = (0, _varios.round)(unificarProductos[e].totalsiniva / unificarProductos[e].cantidadc, 2);
	                        totalcantidad = unificarProductos[e].cantidadc;
	                        moniva = (0, _varios.round)(precioproduct * unificarProductos[e].iva / 100, 2);
	                        totaliva = moniva;
	                        totaliva2 = (0, _varios.round)(moniva * totalcantidad, 2);
	                        montoconiva = (0, _varios.round)((precioproduct + moniva) * totalcantidad, 2);
	                        montototal = (0, _varios.round)(precioproduct * totalcantidad, 2);
	                        tipouni = 0;
	                    }
	
	                    if (tipouni === 1) {
	                        uni = [{
	                            idunidad: unificarProductos[e].idunidadalterna,
	                            descripcion: "UNIDAD",
	                            tipo: "alterna"
	                        }, {
	                            idunidad: unificarProductos[e].idunidadmedida,
	                            descripcion: unificarProductos[e].unidadmedida,
	                            tipo: "medida"
	                        }];
	                    } else {
	                        uni = [{
	                            idunidad: unificarProductos[e].idunidadmedida,
	                            descripcion: unificarProductos[e].unidadmedida,
	                            tipo: "medida"
	                        }, {
	                            idunidad: unificarProductos[e].idunidadalterna,
	                            descripcion: "UNIDAD",
	                            tipo: "alterna"
	                        }];
	                    }
	
	                    sujeton = sujeton + montototal;
	                    totalivan = totalivan + totaliva2;
	
	                    if (unificarProductos[e].iva > 0) {
	                        subtotaln = subtotaln + montototal;
	                    } else {
	                        exenton = exenton + montototal;
	                    }
	
	                    _datos.push({
	                        idproducto: unificarProductos[e].idproducto,
	                        codigo: unificarProductos[e].codigo,
	                        cantidad: totalcantidad,
	                        nombrecorto: unificarProductos[e].nombre,
	                        precio: precioproduct,
	                        precioconiva: (0, _varios.round)(precioproduct + moniva, 2),
	                        total: 0.00,
	                        totaldos: 0.00,
	                        totalivas: totaliva2,
	                        totalsiniva: montototal,
	                        totalmonto: montoconiva,
	                        preciobs: 0.0,
	                        iva: unificarProductos[e].iva,
	                        montoiva: totaliva,
	                        descuento: 0.0,
	                        unidad: uni,
	                        idunidadmedida: unificarProductos[e].idunidadmedida,
	                        idunidadalterna: unificarProductos[e].idunidadalterna,
	                        valormoneda: monedaSub.valormoneda,
	                        tipounidad: tipouni,
	                        valorfactor: unificarProductos[e].valorfactor,
	                        concepto: 'N/S'.trim().toString(),
	                        new: false,
	                        servicio: unificarProductos[e].servicio
	                    });
	                }
	                totalv = (0, _varios.round)(totalivan, 2);
	                totaln = subtotaln + exenton + totalv;
	                setNewproduct(0);
	                setRecords(_datos);
	                setTotales({
	                    subtotal: (0, _varios.round)(subtotaln + exenton, 2),
	                    descuento: 0.0,
	                    exento: (0, _varios.round)(exenton, 2),
	                    sujeto: (0, _varios.round)(subtotaln, 2),
	                    iva: 16.0,
	                    totaliva: totalv,
	                    total: (0, _varios.round)(totaln, 2)
	                });
	            }
	            setActivate(false);
	        }).catch(function (error) {
	            setActivate(false);
	            setMensaje({
	                mostrar: true,
	                titulo: "Error",
	                texto: error.response.data.message,
	                icono: "error"
	            });
	        });
	    };
	
	    var onCatalogoNotaEntrega = function onCatalogoNotaEntrega(values) {
	        setCatalogoNota(false);
	        setCliente({
	            idcliente: values[0].idcliente,
	            tiporif: values[0].rif.substring(0, 1),
	            rif: values[0].rif.substring(1, 12),
	            nombre: values[0].cliente
	        });
	        cmbRif.current.value = values[0].rif.substring(0, 1);
	        txtRif.current.value = values[0].rif.substring(1, 12);
	        txtNombreC.current.value = values[0].cliente;
	        seleccionarNotaEntrega(values);
	    };
	
	    return _react2.default.createElement(
	        "div",
	        { style: { height: "100%", width: "100%" } },
	        _react2.default.createElement(
	            "div",
	            { className: "row col-md-12 ", style: { margin: 0 } },
	            _react2.default.createElement(
	                "div",
	                { className: "row col-md-12 py-2", style: { margin: 0 } },
	                _react2.default.createElement(
	                    "div",
	                    { className: "col-md-11 mx-auto py-2 card shadow" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 row border-azul mx-auto rounded py-1" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "col-md-12 row mx-auto d-flex justify-content-between mb-1" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-2 azulGradiant shadow text-light justify-content-between" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "col-md-4" },
	                                    _react2.default.createElement(
	                                        "h3",
	                                        null,
	                                        tituloHeader
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "col-md-3 d-flex justify-content-end" },
	                                    _react2.default.createElement(
	                                        "a",
	                                        { href: "/inicio", className: "text-light " },
	                                        _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: "fw-bold" },
	                                            "Salir"
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                {
	                                    className: "colfull col-pd-320 mb-3 px-1",
	                                    style: { fontSizeAdjust: "0.6" }
	                                },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "input-group input-group-sm" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        {
	                                            className: "input-group-text",
	                                            id: "inputGroup-sizing-sm"
	                                        },
	                                        "N\xB0 FACTURA:"
	                                    ),
	                                    _react2.default.createElement("input", {
	                                        type: "text",
	                                        disabled: operacion !== 0 ? false : true,
	                                        autoComplete: "off",
	                                        ref: txtNumFactura,
	                                        name: "numfactura",
	                                        onKeyUp: operacion !== 1 ? handleInputChangeCodigo : null,
	                                        onBlur: operacion !== 1 ? handleInputChangeCodigo : null,
	                                        onChange: function onChange(e) {
	                                            return e.target.value = e.target.value.toUpperCase();
	                                        },
	                                        className: "form-control fs-6",
	                                        "aria-label": "Sizing example input",
	                                        "aria-describedby": "inputGroup-sizing-sm"
	                                    }),
	                                    operacion !== 1 && _react2.default.createElement(
	                                        "button",
	                                        {
	                                            disabled: habilitarCat,
	                                            type: "button",
	                                            onClick: function onClick() {
	                                                return setCatalogoFactura(true);
	                                            },
	                                            className: "btn btn-success"
	                                        },
	                                        _react2.default.createElement("i", { className: "fas fa-search" })
	                                    )
	                                )
	                            ),
	                            operacion !== 1 && _react2.default.createElement(
	                                "div",
	                                {
	                                    className: "colfull col-pd-230 mb-3 mr-auto px-1",
	                                    style: { fontSizeAdjust: "0.6" }
	                                },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "input-group input-group-sm" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        {
	                                            className: "input-group-text",
	                                            id: "inputGroup-sizing-sm"
	                                        },
	                                        "ESTATUS:"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        {
	                                            ref: txtStatus,
	                                            style: {
	                                                fontWeight: "bold",
	                                                color: factura.status === 0 ? "#007bff" : factura.status === 1 ? "#28a745" : factura.status === 4 ? "#dc3545" : "#000000"
	                                            },
	                                            disabled: true,
	                                            className: "form-select form-select-sm text-uppercase px-1",
	                                            "aria-label": ".form-select-sm example"
	                                        },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "0" },
	                                            "PENDIENTE"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "1" },
	                                            "PROCESADO"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "4" },
	                                            "ANULADO"
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "colfull col-pd-290 mb-3" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "input-group input-group-sm" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        {
	                                            className: "input-group-text",
	                                            id: "inputGroup-sizing-sm"
	                                        },
	                                        "TIPO MONEDA:"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        {
	                                            className: "form-control form-control-sm fw-bold text-center",
	                                            disabled: true,
	                                            ref: cmbMoneda,
	                                            onChange: onChangeMoneda
	                                        },
	                                        combomoneda && combomoneda.map(function (item, index) {
	                                            return _react2.default.createElement(
	                                                "option",
	                                                { key: index, value: index },
	                                                " ",
	                                                item.descripcion + " " + item.simbolo + " " + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                                                " "
	                                            );
	                                        })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-pd-250 ml-auto" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "input-group input-group-sm" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        {
	                                            className: "input-group-text",
	                                            id: "inputGroup-sizing-sm"
	                                        },
	                                        "FECHA:"
	                                    ),
	                                    _react2.default.createElement("input", {
	                                        type: "date",
	                                        disabled: !habilitado,
	                                        ref: txtFecha,
	                                        name: "fecha",
	                                        onChange: onChange,
	                                        className: "form-control fs-6 text-uppercase",
	                                        "aria-label": "Sizing example input",
	                                        "aria-describedby": "inputGroup-sizing-sm"
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            {
	                                className: "col-md-12 row mx-auto mb-1",
	                                style: { fontSizeAdjust: "0.6" }
	                            },
	                            _react2.default.createElement(
	                                "div",
	                                {
	                                    className: "colfull col-pd-390 mb-3 mr-auto px-1",
	                                    style: { fontSizeAdjust: "0.6" }
	                                },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "input-group input-group-sm" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        {
	                                            className: "input-group-text",
	                                            id: "inputGroup-sizing-sm"
	                                        },
	                                        "TIPO TRANSACCION:"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        {
	                                            disabled: !habilitadoTip,
	                                            ref: tipoTrans,
	                                            onChange: onChange,
	                                            className: "form-select form-select-sm",
	                                            "aria-label": ".form-select-sm example",
	                                            name: "tipotrans",
	                                            id: "tipotrans"
	                                        },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "1" },
	                                            "POR ORDEN DE ENTREGA"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "2" },
	                                            "GENERAL"
	                                        )
	                                    )
	                                )
	                            ),
	                            selectp !== 1 ? _react2.default.createElement(
	                                "div",
	                                {
	                                    className: "colfull col280 mr-auto mb-3 px-1",
	                                    style: { fontSizeAdjust: "0.6" }
	                                },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "input-group input-group-sm" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        {
	                                            className: "input-group-text",
	                                            id: "inputGroup-sizing-sm"
	                                        },
	                                        "NOTA ENTREGA:"
	                                    ),
	                                    _react2.default.createElement(
	                                        "button",
	                                        {
	                                            type: "button",
	                                            disabled: !habilitadoTip,
	                                            onClick: function onClick() {
	                                                return setCatalogoNota(true);
	                                            },
	                                            className: "btn btn-success"
	                                        },
	                                        _react2.default.createElement("i", { className: "fas fa-search" })
	                                    )
	                                )
	                            ) : '',
	                            _react2.default.createElement(
	                                "div",
	                                {
	                                    className: "colfull col-pd-240 mb-3 mr-auto px-1",
	                                    style: { fontSizeAdjust: "0.6" }
	                                },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "input-group input-group-sm" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        {
	                                            className: "input-group-text",
	                                            id: "inputGroup-sizing-sm"
	                                        },
	                                        "TIPO PAGO:"
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        {
	                                            disabled: !habilitadoTip,
	                                            ref: cmbTipoPago,
	                                            onChange: onChange,
	                                            className: "form-select form-select-sm",
	                                            "aria-label": ".form-select-sm example",
	                                            name: "tipopago",
	                                            id: "tipopago"
	                                        },
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "1" },
	                                            "CONTADO"
	                                        ),
	                                        _react2.default.createElement(
	                                            "option",
	                                            { value: "2" },
	                                            "CREDITO"
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-pd-390 mr-auto" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "input-group input-group-sm" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        {
	                                            className: "input-group-text",
	                                            id: "inputGroup-sizing-sm"
	                                        },
	                                        "FECHA DE VENCIMIENTO:"
	                                    ),
	                                    _react2.default.createElement("input", {
	                                        disabled: selectd === 1 ? false : true,
	                                        type: "date",
	                                        name: "fechavencimiento",
	                                        id: "fechavencimiento",
	                                        ref: txtFechaVencimiento,
	                                        onChange: onChange,
	                                        className: "form-control text-uppercase fs-6",
	                                        "aria-label": "Sizing example input",
	                                        "aria-describedby": "inputGroup-sizing-sm"
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            {
	                                className: "colfull1070 col-sm-6 mx-auto mb-1 row m-0",
	                                style: { fontSizeAdjust: "0.6" }
	                            },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-md-12 mx-auto row mb-1 py-2 border-azul rounded " },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: "fw-bold mb-1" },
	                                    "Datos del Cliente"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "input-group input-group-sm mb-2 col-md-6" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        {
	                                            className: "input-group-text",
	                                            id: "inputGroup-sizing-sm"
	                                        },
	                                        "CEDULA/RIF:",
	                                        " "
	                                    ),
	                                    _react2.default.createElement(
	                                        "select",
	                                        {
	                                            ref: cmbRif,
	                                            name: "cmbrif",
	                                            disabled: selectp !== 1 ? true : !habilitadoCli,
	                                            className: "form-select form-select-sm col-3 text-center",
	                                            "aria-label": ".form-select-sm example"
	                                        },
	                                        _varios.cmbCedula.map(function (item, index) {
	                                            return _react2.default.createElement(
	                                                "option",
	                                                { key: index, value: item.value },
	                                                item.value
	                                            );
	                                        })
	                                    ),
	                                    _react2.default.createElement("input", {
	                                        ref: txtRif,
	                                        autoComplete: "off",
	                                        disabled: selectp !== 1 ? true : !habilitadoCli,
	                                        maxLength: 9,
	                                        type: "text",
	                                        className: "form-control fs-6",
	                                        name: "cedula",
	                                        "aria-label": "Sizing example input",
	                                        "aria-describedby": "inputGroup-sizing-sm",
	                                        onKeyUp: validarCliente,
	                                        onBlur: validarCliente
	                                    }),
	                                    _react2.default.createElement(
	                                        "button",
	                                        {
	                                            disabled: selectp !== 1 ? true : !habilitadoCli,
	                                            type: "button",
	                                            onClick: function onClick() {
	                                                return setCatalogoCliente(true);
	                                            },
	                                            className: "btn btn-success",
	                                            style: {
	                                                visibility: visible === 0 ? "visible" : "hidden"
	                                            }
	                                        },
	                                        _react2.default.createElement("i", { className: "fas fa-search" })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "input-group input-group-sm mb-2 col-md-12" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        {
	                                            className: "input-group-text",
	                                            id: "inputGroup-sizing-sm"
	                                        },
	                                        "NOMBRE:",
	                                        " "
	                                    ),
	                                    _react2.default.createElement("input", {
	                                        disabled: true,
	                                        autoComplete: "off",
	                                        type: "text",
	                                        className: "form-control fs-6",
	                                        "aria-label": "Sizing example input",
	                                        "aria-describedby": "inputGroup-sizing-sm",
	                                        ref: txtNombreC
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            {
	                                className: "colfull1070 col-sm-6 mx-auto mb-1 row m-0",
	                                style: { fontSizeAdjust: "0.6" }
	                            },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-md-12 mx-auto row mb-1 py-2 border-azul rounded " },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: "fw-bold mb-1" },
	                                    "Datos del Vendedor"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "input-group input-group-sm mb-2 col-md-5" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        {
	                                            className: "input-group-text",
	                                            id: "inputGroup-sizing-sm"
	                                        },
	                                        "CEDULA/RIF:",
	                                        " "
	                                    ),
	                                    _react2.default.createElement("input", {
	                                        disabled: true,
	                                        autoComplete: "off",
	                                        type: "text",
	                                        className: "form-control fs-6",
	                                        "aria-label": "Sizing example input",
	                                        "aria-describedby": "inputGroup-sizing-sm",
	                                        value: vendedor.tiporif + vendedor.rif
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "input-group input-group-sm mb-2 col-md-12" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        {
	                                            className: "input-group-text",
	                                            id: "inputGroup-sizing-sm"
	                                        },
	                                        "NOMBRE:",
	                                        " "
	                                    ),
	                                    _react2.default.createElement("input", {
	                                        disabled: true,
	                                        autoComplete: "off",
	                                        type: "text",
	                                        className: "form-control fs-6",
	                                        "aria-label": "Sizing example input",
	                                        "aria-describedby": "inputGroup-sizing-sm",
	                                        value: vendedor.nombre
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            {
	                                className: "colfull1070 col-sm-12 mx-auto mb-1 row m-0",
	                                style: { fontSizeAdjust: "0.6" }
	                            },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-md-12 mx-auto row mb-1 py-2 border-azul rounded " },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "input-group input-group-sm mb-2 col-md-12" },
	                                    _react2.default.createElement(
	                                        "label",
	                                        {
	                                            className: "input-group-text",
	                                            id: "inputGroup-sizing-sm"
	                                        },
	                                        "DESCRIPCION:",
	                                        " "
	                                    ),
	                                    _react2.default.createElement("textarea", {
	                                        disabled: operacion === 1 || operacion === 2 ? false : true,
	                                        autoComplete: "off",
	                                        type: "text",
	                                        ref: txtDescripcion,
	                                        className: "form-control fs-6 text-uppercase",
	                                        "aria-label": "Sizing example input",
	                                        "aria-describedby": "inputGroup-sizing-sm"
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            {
	                                className: "col-md-12 border-azul px-0 rounded",
	                                style: { backgroundColor: "#d5e9ff" }
	                            },
	                            _react2.default.createElement(
	                                TblContainer,
	                                {
	                                    container: {
	                                        height: 190,
	                                        width: "100%",
	                                        overflow: "auto",
	                                        padding: "2px",
	                                        fontSizeAdjust: "0.6"
	                                    }
	                                },
	                                _react2.default.createElement(TblHead, null),
	                                _react2.default.createElement(
	                                    _core.TableBody,
	                                    { className: "overflow-hidden" },
	                                    records && records.map(function (item, index) {
	                                        return _react2.default.createElement(
	                                            _core.TableRow,
	                                            { key: index, style: { padding: "0" } },
	                                            _react2.default.createElement(
	                                                _core.TableCell,
	                                                { className: "bg-light d-flex align-items-between px-0" },
	                                                _react2.default.createElement("input", {
	                                                    type: "text",
	                                                    style: {
	                                                        borderBottomRightRadius: 0,
	                                                        borderTopRightRadius: 0
	                                                    },
	                                                    disabled: item.new !== true ? true : habilitadoProductos,
	                                                    ref: function ref(el) {
	                                                        return txtId.current[index] = el;
	                                                    },
	                                                    className: "form-control form-control-sm bg-light fs-6",
	                                                    defaultValue: item.codigo,
	                                                    onChange: function onChange(e) {
	                                                        return e.target.value = e.target.value.toUpperCase();
	                                                    },
	                                                    onKeyUp: validarIdProducto(index),
	                                                    onBlur: validarIdProducto(index)
	                                                }),
	                                                (operacion === 1 || operacion === 2 || factura.numnotaentrega !== "") && _react2.default.createElement(
	                                                    "button",
	                                                    {
	                                                        type: "button",
	                                                        style: {
	                                                            borderBottomLeftRadius: 0,
	                                                            borderTopLeftRadius: 0
	                                                        },
	                                                        disabled: item.new !== true ? true : habilitadoProductos,
	                                                        onClick: seleccionarxIndice(index),
	                                                        className: "btn btn-sm btn-primary"
	                                                    },
	                                                    _react2.default.createElement(
	                                                        "i",
	                                                        { className: "fas " },
	                                                        "-"
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _core.TableCell,
	                                                {
	                                                    className: "align-middle bg-light text-start p-0 pl-2",
	                                                    style: { width: "300px" }
	                                                },
	                                                item.nombrecorto,
	                                                item.servicio !== true ? '' : _react2.default.createElement(
	                                                    "button",
	                                                    {
	                                                        onClick: abrirModalDescrip(item.servicio),
	                                                        disabled: item.new !== true ? true : false,
	                                                        className: "btn btn-sm btn-info"
	                                                    },
	                                                    _react2.default.createElement("i", { className: "fas fa-edit" })
	                                                )
	                                            ),
	                                            operacion !== 1 || operacion === 1 && selectp !== 1 ? "" : _react2.default.createElement(
	                                                _core.TableCell,
	                                                {
	                                                    className: "align-middle bg-light text-end p-0 pr-2",
	                                                    style: { width: "50px" }
	                                                },
	                                                (0, _varios.formatMoneda)(item.cantidadE.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                                            ),
	                                            _react2.default.createElement(
	                                                _core.TableCell,
	                                                {
	                                                    className: "align-middle bg-light text-center p-0",
	                                                    style: { width: "20px" }
	                                                },
	                                                _react2.default.createElement("input", {
	                                                    type: "text",
	                                                    className: "form-control form-control-sm bg-light text-right fs-6 col-pd-90 mx-auto",
	                                                    id: "cantidad",
	                                                    disabled: item.new !== true ? true : habilitadoProductos,
	                                                    defaultValue: (0, _varios.formatMoneda)(item.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                                                    ref: function ref(el) {
	                                                        return txtCantidad.current[index] = el;
	                                                    },
	                                                    onFocus: _varios.seleccionarCampo,
	                                                    onKeyUp: validarCantidadP(index, item),
	                                                    onBlur: validarCantidadP(index, item)
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                _core.TableCell,
	                                                {
	                                                    className: "align-middle bg-light p-0",
	                                                    style: { width: 50 }
	                                                },
	                                                _react2.default.createElement(
	                                                    "select",
	                                                    {
	                                                        className: "form-control form-control-sm fs-6",
	                                                        style: { width: "100%" },
	                                                        disabled: item.new !== true && item.servicio === true || item.new !== true ? true : habilitadoProductos,
	                                                        defaultValue: item.tipoprecio,
	                                                        onChange: onChangeTipoPrecio(index)
	                                                    },
	                                                    _varios.comboprecios.map(function (item2, x) {
	                                                        return _react2.default.createElement(
	                                                            "option",
	                                                            { key: x, value: item2.id },
	                                                            " ",
	                                                            item2.nombre,
	                                                            " "
	                                                        );
	                                                    })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _core.TableCell,
	                                                {
	                                                    className: "align-middle bg-light text-end p-0 pr-2",
	                                                    style: { width: "50px" }
	                                                },
	                                                _react2.default.createElement("input", {
	                                                    type: "text",
	                                                    disabled: item.new !== true ? true : habilitadoProductos,
	                                                    onKeyUp: validarPrecio(index),
	                                                    onBlur: validarPrecio(index),
	                                                    className: "form-control form-control-sm bg-light text-right fs-6",
	                                                    id: "precio",
	                                                    defaultValue: (0, _varios.formatMoneda)(item.precio.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                                                    ref: function ref(el) {
	                                                        return txtPrecio.current[index] = el;
	                                                    }
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                _core.TableCell,
	                                                {
	                                                    className: "align-middle bg-light p-0",
	                                                    style: { width: 60 }
	                                                },
	                                                _react2.default.createElement(
	                                                    "select",
	                                                    {
	                                                        className: "form-control form-control-sm fs-6",
	                                                        style: { width: "100%" },
	                                                        disabled: item.new !== true && item.servicio === true || item.new !== true ? true : habilitadoProductos,
	                                                        onChange: onChangeUnidad(index)
	                                                    },
	                                                    item.unidad && item.unidad.map(function (item2, x) {
	                                                        return _react2.default.createElement(
	                                                            "option",
	                                                            { key: x, value: item2.idunidad },
	                                                            " ",
	                                                            item.servicio !== false ? "SERVICIO" : item2.descripcion,
	                                                            " "
	                                                        );
	                                                    })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                _core.TableCell,
	                                                {
	                                                    className: "align-middle bg-light text-end p-0 pr-2",
	                                                    style: { width: "50px" }
	                                                },
	                                                (0, _varios.formatMoneda)(item.iva.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                                            ),
	                                            _react2.default.createElement(
	                                                _core.TableCell,
	                                                {
	                                                    className: "align-middle bg-light text-end p-0 pr-2",
	                                                    style: { width: "50px" }
	                                                },
	                                                (0, _varios.formatMoneda)(item.totalmonto.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                                            ),
	                                            operacion !== 4 && operacion !== 3 && _react2.default.createElement(
	                                                _core.TableCell,
	                                                {
	                                                    className: "align-middle bg-light text-center p-0",
	                                                    style: { width: "20px" }
	                                                },
	                                                _react2.default.createElement(
	                                                    "button",
	                                                    {
	                                                        disabled: habilitadoProductos,
	                                                        style: {
	                                                            visibility: (operacion === 4 || operacion === 3) && "collapse"
	                                                        },
	                                                        onClick: eliminarProducto(item),
	                                                        className: "btn btn-sm btn-danger"
	                                                    },
	                                                    _react2.default.createElement("i", { className: "fa fa-trash" }),
	                                                    " "
	                                                )
	                                            )
	                                        );
	                                    }),
	                                    _react2.default.createElement(
	                                        _core.TableRow,
	                                        { style: { padding: "0" } },
	                                        _react2.default.createElement(
	                                            _core.TableCell,
	                                            { className: "bg-light d-flex align-items-between px-0" },
	                                            _react2.default.createElement("input", {
	                                                type: "text",
	                                                disabled: habilitadoProductos,
	                                                ref: txtIdproducto,
	                                                style: {
	                                                    borderBottomRightRadius: 0,
	                                                    borderTopRightRadius: 0
	                                                },
	                                                className: "form-control form-control-sm bg-light text-right",
	                                                onChange: function onChange(e) {
	                                                    return e.target.value = e.target.value.toUpperCase();
	                                                },
	                                                onKeyUp: validarIdProducto(null),
	                                                onBlur: validarIdProducto(null)
	                                            }),
	                                            _react2.default.createElement(
	                                                "button",
	                                                {
	                                                    type: "button",
	                                                    disabled: habilitadoProductos,
	                                                    style: {
	                                                        borderBottomLeftRadius: 0,
	                                                        borderTopLeftRadius: 0
	                                                    },
	                                                    onClick: function onClick() {
	                                                        return setMostrar(true);
	                                                    },
	                                                    className: "btn btn-sm btn-primary"
	                                                },
	                                                _react2.default.createElement(
	                                                    "i",
	                                                    { className: "fas " },
	                                                    "-"
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(_core.TableCell, {
	                                            className: "align-middle bg-light text-start p-0 pl-2",
	                                            style: { width: "150px" }
	                                        }),
	                                        operacion === 1 && selectp !== 1 ? '' : _react2.default.createElement(_core.TableCell, {
	                                            className: "align-middle bg-light text-center p-0",
	                                            style: { width: "20px" }
	                                        }),
	                                        _react2.default.createElement(_core.TableCell, {
	                                            className: "align-middle bg-light p-0",
	                                            style: { width: 50 }
	                                        }),
	                                        _react2.default.createElement(_core.TableCell, {
	                                            className: "align-middle bg-light text-end p-0 pr-2",
	                                            style: { width: "50px" }
	                                        }),
	                                        _react2.default.createElement(_core.TableCell, {
	                                            className: "align-middle bg-light p-0",
	                                            style: { width: 50 }
	                                        }),
	                                        _react2.default.createElement(_core.TableCell, {
	                                            className: "align-middle bg-light text-end p-0 pr-2",
	                                            style: { width: "50px" }
	                                        }),
	                                        _react2.default.createElement(_core.TableCell, {
	                                            className: "align-middle bg-light text-end p-0 pr-2",
	                                            style: { width: "50px" }
	                                        }),
	                                        operacion === 0 || operacion !== 4 && operacion !== 3 && _react2.default.createElement(_core.TableCell, {
	                                            className: "align-middle bg-light text-center p-0",
	                                            style: { width: "20px" }
	                                        }),
	                                        operacion === 0 || operacion !== 4 && operacion !== 3 && _react2.default.createElement(_core.TableCell, {
	                                            className: "align-middle bg-light text-center p-0",
	                                            style: { width: "20px" }
	                                        })
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "col-md-12 row m-0 px-0" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-md-7 py-1 mt-auto" },
	                                visibleBtn === "visible" ? _react2.default.createElement(
	                                    "div",
	                                    { className: "col-pd-600" },
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "col-md-12 row m-0" },
	                                        _react2.default.createElement(
	                                            "button",
	                                            {
	                                                disabled: !habilitadoBot,
	                                                ref: btnIncluir,
	                                                onClick: onBotones(1),
	                                                className: "btn btn-sm col ml-1 mb-1 btn-primary rounded-pill",
	                                                title: "Incluir Factura"
	                                            },
	                                            _react2.default.createElement(
	                                                "i",
	                                                { className: "fas fa-plus" },
	                                                " Incluir "
	                                            ),
	                                            " "
	                                        ),
	                                        _react2.default.createElement(
	                                            "button",
	                                            {
	                                                disabled: !habilitadoBot,
	                                                ref: btnConsultar,
	                                                onClick: onBotones(4),
	                                                className: "btn btn-sm col ml-1 mb-1 btn-info rounded-pill",
	                                                title: "Consultar Factura"
	                                            },
	                                            _react2.default.createElement(
	                                                "i",
	                                                { className: "fas fa-eye" },
	                                                " Consultar"
	                                            ),
	                                            " "
	                                        ),
	                                        _react2.default.createElement(
	                                            "button",
	                                            {
	                                                disabled: !habilitadoBot,
	                                                ref: btnEliminar,
	                                                onClick: onBotones(3),
	                                                className: "btn btn-sm col ml-1 mb-1 btn-danger rounded-pill",
	                                                title: "Anular Factura"
	                                            },
	                                            _react2.default.createElement(
	                                                "i",
	                                                { className: "fas fa-window-close" },
	                                                " Anular"
	                                            ),
	                                            " "
	                                        )
	                                    )
	                                ) : _react2.default.createElement(
	                                    "div",
	                                    { className: "col-pd-400 row m-0 ml-auto" },
	                                    operacion === 4 ? _react2.default.createElement(
	                                        "button",
	                                        {
	                                            onClick: imprimirFactura,
	                                            disabled: operacion === 4 ? false : true,
	                                            className: "btn btn-sm col ml-1 btn-primary rounded-pill",
	                                            title: "Imprimir Factura"
	                                        },
	                                        _react2.default.createElement(
	                                            "i",
	                                            { className: "fa fa-print" },
	                                            " Imprimir"
	                                        )
	                                    ) : "",
	                                    _react2.default.createElement(
	                                        "button",
	                                        {
	                                            ref: btnAcepta,
	                                            disabled: operacion === 4 ? true : habilitadoBot,
	                                            onClick: onBotones(5),
	                                            className: "btn btn-sm col ml-1 rounded-pill btn-success"
	                                        },
	                                        _react2.default.createElement(
	                                            "i",
	                                            { className: "fas fa-check-circle" },
	                                            " Aceptar"
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "button",
	                                        {
	                                            ref: btnCancela,
	                                            disabled: habilitadoBot,
	                                            onClick: onBotones(6),
	                                            className: "btn btn-danger col ml-1 btn-sm rounded-pill"
	                                        },
	                                        _react2.default.createElement(
	                                            "i",
	                                            { className: "fas fa-window-close" },
	                                            " Cancelar"
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                {
	                                    className: "col-md-5 border-azul rounded shadow",
	                                    style: { backgroundColor: "#dbeeff" }
	                                },
	                                _react2.default.createElement(
	                                    "div",
	                                    {
	                                        className: "input-group input-group-sm col-md-12",
	                                        style: { fontSizeAdjust: "0.6" }
	                                    },
	                                    _react2.default.createElement(
	                                        "label",
	                                        {
	                                            className: "input-group-text bg-transparent border-0",
	                                            id: "inputGroup-sizing-sm",
	                                            style: { fontSize: 14 }
	                                        },
	                                        "SUBTOTAL ",
	                                        "Bs",
	                                        ":"
	                                    ),
	                                    _react2.default.createElement("input", {
	                                        type: "text",
	                                        disabled: true,
	                                        ref: txtSubTotal,
	                                        value: (0, _varios.formatMoneda)(totales.subtotal.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                                        className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                                        "aria-label": "Sizing example input",
	                                        "aria-describedby": "inputGroup-sizing-sm"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    {
	                                        className: "input-group input-group-sm col-md-12",
	                                        style: { fontSizeAdjust: "0.6" }
	                                    },
	                                    _react2.default.createElement(
	                                        "label",
	                                        {
	                                            className: "input-group-text bg-transparent border-0",
	                                            id: "inputGroup-sizing-sm",
	                                            style: { fontSize: 14 }
	                                        },
	                                        "EXENTO ",
	                                        "Bs",
	                                        ":"
	                                    ),
	                                    _react2.default.createElement("input", {
	                                        type: "text",
	                                        disabled: true,
	                                        ref: txtExentoTotal,
	                                        value: (0, _varios.formatMoneda)(totales.exento.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                                        className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                                        "aria-label": "Sizing example input",
	                                        "aria-describedby": "inputGroup-sizing-sm"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    {
	                                        className: "input-group input-group-sm  col-md-12",
	                                        style: { fontSizeAdjust: "0.6" }
	                                    },
	                                    _react2.default.createElement(
	                                        "label",
	                                        {
	                                            className: "input-group-text bg-transparent border-0",
	                                            id: "inputGroup-sizing-sm",
	                                            style: { fontSize: 14 }
	                                        },
	                                        "DESCUENTO ",
	                                        "Bs",
	                                        ":"
	                                    ),
	                                    _react2.default.createElement("input", {
	                                        type: "text",
	                                        disabled: true,
	                                        ref: txtDescuento,
	                                        value: (0, _varios.formatMoneda)(totales.descuento.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                                        className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                                        "aria-label": "Sizing example input",
	                                        "aria-describedby": "inputGroup-sizing-sm"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    {
	                                        className: "input-group input-group-sm  col-md-12",
	                                        style: { fontSizeAdjust: "0.6" }
	                                    },
	                                    _react2.default.createElement(
	                                        "label",
	                                        {
	                                            className: "input-group-text bg-transparent border-0",
	                                            id: "inputGroup-sizing-sm",
	                                            style: { fontSize: 14 }
	                                        },
	                                        "IVA ",
	                                        "Bs",
	                                        ":"
	                                    ),
	                                    _react2.default.createElement("input", {
	                                        type: "text",
	                                        disabled: true,
	                                        ref: txtTotIva,
	                                        value: (0, _varios.formatMoneda)(totales.totaliva.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                                        className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                                        "aria-label": "Sizing example input",
	                                        "aria-describedby": "inputGroup-sizing-sm"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    {
	                                        className: "input-group input-group-sm  col-md-12",
	                                        style: { fontSizeAdjust: "0.6" }
	                                    },
	                                    _react2.default.createElement(
	                                        "label",
	                                        {
	                                            className: "input-group-text bg-transparent border-0",
	                                            id: "inputGroup-sizing-sm",
	                                            style: { fontSize: 14 }
	                                        },
	                                        "TOTAL ",
	                                        "Bs",
	                                        ":"
	                                    ),
	                                    _react2.default.createElement("input", {
	                                        type: "text",
	                                        disabled: true,
	                                        ref: txtTotal,
	                                        value: (0, _varios.formatMoneda)(totales.total.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                                        className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                                        "aria-label": "Sizing example input",
	                                        "aria-describedby": "inputGroup-sizing-sm"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    {
	                                        className: "input-group input-group-sm  col-md-12",
	                                        style: { fontSizeAdjust: "0.6" }
	                                    },
	                                    _react2.default.createElement(
	                                        "label",
	                                        {
	                                            className: "input-group-text bg-transparent border-0",
	                                            id: "inputGroup-sizing-sm",
	                                            style: { fontSize: 14 }
	                                        },
	                                        "TOTAL ",
	                                        monedaSub.simbolo,
	                                        ":"
	                                    ),
	                                    _react2.default.createElement("input", {
	                                        type: "text",
	                                        disabled: true,
	                                        ref: txtTotal,
	                                        value: operacion !== 1 ? (0, _varios.formatMoneda)((totales.total / valormoney).toString().replace(",", "").replace(".", ","), ",", ".", 2) : (0, _varios.formatMoneda)((totales.total / monedaSub.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                                        className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                                        "aria-label": "Sizing example input",
	                                        "aria-describedby": "inputGroup-sizing-sm"
	                                    })
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_catalogoProductoServicios2.default, {
	            show: mostrar,
	            onHideCancelar: function onHideCancelar() {
	                setMostrar(false);
	            },
	            onHideAceptaCatalogo: agregarProducto,
	            idalmacen: vendedor.idalmacen
	        }),
	        _react2.default.createElement(_catalogo_servi2.default, {
	            show: habilitadoMod,
	            onHideCancelar: function onHideCancelar() {
	                setHabilitadoMod(false);
	            },
	            onHideAceptaCatalogo: agregarDescripServi
	        }),
	        _react2.default.createElement(_catalogoCliente2.default, {
	            show: catalogoCliente,
	            nomid: "cliente",
	            onHideCancelar: function onHideCancelar() {
	                return setCatalogoCliente(false);
	            },
	            onHideAceptaCatalogo: onCatalogoCliente
	        }),
	        _react2.default.createElement(_catalogoFactura2.default, {
	            show: catalogoFactura,
	            tipofactu: "factuservi",
	            onHideCancelar: function onHideCancelar() {
	                return setCatalogoFactura(false);
	            },
	            onHideAceptaCatalogo: onCatalogoFactura
	        }),
	        _react2.default.createElement(_catalogoNotaEntregaFactura2.default, {
	            show: catalogoNota,
	            nomid: "notaentrega",
	            tip: "FA",
	            tipo: "NE",
	            onHideCancelar: function onHideCancelar() {
	                return setCatalogoNota(false);
	            },
	            onHideAceptaCatalogo: onCatalogoNotaEntrega,
	            condicion: "status != 4"
	        }),
	        _react2.default.createElement(
	            _semanticUiReact.Dimmer,
	            { active: activate, inverted: true },
	            _react2.default.createElement(
	                _semanticUiReact.Loader,
	                { inverted: true },
	                "cargando..."
	            )
	        ),
	        _react2.default.createElement(_mensajes.Mensaje, {
	            mensaje: mensaje,
	            onHide: function onHide() {
	                return mensaje.titulo === "Exito." ? blanquear() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	            }
	        }),
	        _react2.default.createElement(_mensajes.MensajeSiNo, {
	            mensaje: mensajesino,
	            onHideNo: function onHideNo() {
	                return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	            },
	            onHideSi: handleCloseSi
	        })
	    );
	};
	exports.default = TablaFactura;

/***/ },
/* 7175 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _core = __webpack_require__(19);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoProductoExistencia = __webpack_require__(105);
	
	var _catalogoProductoExistencia2 = _interopRequireDefault(_catalogoProductoExistencia);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _catalogoFactura = __webpack_require__(651);
	
	var _catalogoFactura2 = _interopRequireDefault(_catalogoFactura);
	
	var _catalogoNotaEntregaFactura = __webpack_require__(653);
	
	var _catalogoNotaEntregaFactura2 = _interopRequireDefault(_catalogoNotaEntregaFactura);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var TablaFacturaxNota = function TablaFacturaxNota() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var accbtnfacturas = JSON.parse(sessionStorage.getItem("accbtnfacturaxnotasc"));
	
	  var txtNumFactura = (0, _react.useRef)();
	  var txtPrecio = (0, _react.useRef)([]);
	  var txtFecha = (0, _react.useRef)();
	  var txtId = (0, _react.useRef)([]);
	  var txtIdproducto = (0, _react.useRef)([]);
	  var txtCantidad = (0, _react.useRef)([]);
	  var btnIncluir = (0, _react.useRef)();
	  var btnEditar = (0, _react.useRef)();
	  var btnEliminar = (0, _react.useRef)();
	  var btnConsultar = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtNombreC = (0, _react.useRef)();
	  var txtSubTotal = (0, _react.useRef)();
	  var txtExentoTotal = (0, _react.useRef)();
	  var txtDescuento = (0, _react.useRef)();
	  var txtTotIva = (0, _react.useRef)();
	  var txtTotal = (0, _react.useRef)();
	  var cmbMoneda = (0, _react.useRef)();
	  var txtFechaVencimiento = (0, _react.useRef)();
	  var txtDireccioncliente = (0, _react.useRef)();
	  var txtIdcliente = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      body = _useState2[0],
	      setBody = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      operacion = _useState4[0],
	      setOperacion = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      habilitado = _useState6[0],
	      setHabilitado = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(true),
	      _useState8 = _slicedToArray(_useState7, 2),
	      habilitarCat = _useState8[0],
	      setHabilitarCat = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(true),
	      _useState10 = _slicedToArray(_useState9, 2),
	      habilitadoBot = _useState10[0],
	      setHabilitadoBot = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      habilitadoCli = _useState12[0],
	      setHabilitadoCli = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      selectd = _useState14[0],
	      setSelectd = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      selectp = _useState16[0],
	      setSelectp = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(true),
	      _useState18 = _slicedToArray(_useState17, 2),
	      habilitadoProductos = _useState18[0],
	      setHabilitadoProductos = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(false),
	      _useState20 = _slicedToArray(_useState19, 2),
	      habilitadoMod = _useState20[0],
	      setHabilitadoMod = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(false),
	      _useState22 = _slicedToArray(_useState21, 2),
	      habilitadoTip = _useState22[0],
	      setHabilitadoTip = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(null),
	      _useState24 = _slicedToArray(_useState23, 2),
	      indice = _useState24[0],
	      setIndice = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(0),
	      _useState26 = _slicedToArray(_useState25, 2),
	      visible = _useState26[0],
	      setVisible = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(false),
	      _useState28 = _slicedToArray(_useState27, 2),
	      mostrar = _useState28[0],
	      setMostrar = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      habilitarMoneda = _useState30[0],
	      setHabilitarMoneda = _useState30[1];
	
	  var _useState31 = (0, _react.useState)([]),
	      _useState32 = _slicedToArray(_useState31, 2),
	      records = _useState32[0],
	      setRecords = _useState32[1];
	
	  var _useState33 = (0, _react.useState)([]),
	      _useState34 = _slicedToArray(_useState33, 2),
	      combomoneda = _useState34[0],
	      setComboMoneda = _useState34[1];
	
	  var _useState35 = (0, _react.useState)("Gestionar Facturas."),
	      _useState36 = _slicedToArray(_useState35, 2),
	      tituloHeader = _useState36[0],
	      setTituloHeader = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(false),
	      _useState38 = _slicedToArray(_useState37, 2),
	      catalogoFactura = _useState38[0],
	      setCatalogoFactura = _useState38[1];
	
	  var _useState39 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState40 = _slicedToArray(_useState39, 2),
	      mensaje = _useState40[0],
	      setMensaje = _useState40[1];
	
	  var _useState41 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState42 = _slicedToArray(_useState41, 2),
	      mensajesino = _useState42[0],
	      setMensajesino = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({
	    idmoneda: "1",
	    descripcion: "BOLIVARES",
	    simbolo: "Bs",
	    predeterminada: true,
	    subpredeterminada: false,
	    valormoneda: 1.0
	  }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      moneda = _useState44[0],
	      setMoneda = _useState44[1];
	
	  var _useState45 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState46 = _slicedToArray(_useState45, 2),
	      monedaSub = _useState46[0],
	      setMonedaSub = _useState46[1];
	
	  var _useState47 = (0, _react.useState)({
	    idmoneda: "1",
	    descripcion: "BOLIVARES",
	    simbolo: "Bs",
	    predeterminada: true,
	    subpredeterminada: false,
	    valormoneda: 1.0
	  }),
	      _useState48 = _slicedToArray(_useState47, 2),
	      monedaCambio = _useState48[0],
	      setMonedaCambio = _useState48[1];
	
	  var _useState49 = (0, _react.useState)({
	    subtotal: 0.0,
	    descuento: 0.0,
	    exento: 0.0,
	    sujeto: 0.0,
	    iva: 16.0,
	    totaliva: 0.0,
	    total: 0.0
	  }),
	      _useState50 = _slicedToArray(_useState49, 2),
	      totales = _useState50[0],
	      setTotales = _useState50[1];
	
	  var _useState51 = (0, _react.useState)([]),
	      _useState52 = _slicedToArray(_useState51, 2),
	      idsnotas = _useState52[0],
	      setIdnotas = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(false),
	      _useState54 = _slicedToArray(_useState53, 2),
	      catalogoNota = _useState54[0],
	      setCatalogoNota = _useState54[1];
	
	  var _useState55 = (0, _react.useState)(false),
	      _useState56 = _slicedToArray(_useState55, 2),
	      activate = _useState56[0],
	      setActivate = _useState56[1];
	
	  var _useState57 = (0, _react.useState)("visible"),
	      _useState58 = _slicedToArray(_useState57, 2),
	      visibleBtn = _useState58[0],
	      setVisibleBtn = _useState58[1];
	
	  var _useState59 = (0, _react.useState)({
	    idfactura: "0",
	    numfactura: "000000",
	    cedularif: "",
	    descripcion: "FACTURA DE PRODUCTOS",
	    totalmonto: 0.0,
	    totaliva: 0.0,
	    totaldescuento: 0.0,
	    totalexento: 0.0,
	    totalsujeto: 0.0,
	    idcliente: "",
	    idvendedor: "",
	    fecha: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	    status: 0,
	    idalmacen: "",
	    idmoneda: "",
	    idoperacioninventario: "",
	    idnotaentrega: "",
	    numnotaentrega: "",
	    creditof: false,
	    fechavencimientof: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	    valormoneda: 0.0
	  }),
	      _useState60 = _slicedToArray(_useState59, 2),
	      factura = _useState60[0],
	      setFactura = _useState60[1];
	
	  var _useState61 = (0, _react.useState)({
	    idcliente: "",
	    tiporif: "J",
	    rif: "",
	    nombre: ""
	  }),
	      _useState62 = _slicedToArray(_useState61, 2),
	      cliente = _useState62[0],
	      setCliente = _useState62[1];
	
	  var _useState63 = (0, _react.useState)({
	    idvendedor: "",
	    tiporif: "",
	    rif: "",
	    nombre: "",
	    idalmacen: ""
	  }),
	      _useState64 = _slicedToArray(_useState63, 2),
	      vendedor = _useState64[0],
	      setVendedor = _useState64[1];
	
	  var nomtabla = void 0;
	
	  if (operacion === 4 || operacion === 3) {
	    nomtabla = [{ label: "COD-PRODUCTO", textAlign: "center", width: "30px" }, { label: "PRODUCTO", textAlign: "center", width: "250px" }, { label: "CANTIDAD", textAlign: "center", width: "20px" }, { label: "PRECIO", textAlign: "center", width: "50px" }, { label: "IVA.", textAlign: "center", width: "50px" }, { label: "MONTO IVA", textAlign: "center", width: "50px" }, { label: "MONTO TOTAL", textAlign: "center", width: "50px" }];
	  } else {
	    nomtabla = [{ label: "COD-PRODUCTO", textAlign: "center", width: "30px" }, { label: "PRODUCTO", textAlign: "center", width: "250px" }, { label: "CANTIDAD", textAlign: "center", width: "20px" }, { label: "PRECIO", textAlign: "center", width: "50px" }, { label: "IVA.", textAlign: "center", width: "50px" }, { label: "MONTO IVA", textAlign: "center", width: "50px" }, { label: "MONTO TOTAL", textAlign: "center", width: "50px" }, {
	      label: _react2.default.createElement("i", { className: "fas fa-trash" }),
	      textAlign: "center",
	      width: "20px"
	    }];
	  }
	
	  var headCells = nomtabla;
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var seleccionarMonedas = function seleccionarMonedas() {
	    var campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	    var nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	    var orden = "m.idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var x = 0;
	        if (response.data.length > 0) {
	          setComboMoneda(response.data);
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].subpredeterminada) {
	              setMonedaSub(response.data[i]);
	            } else if (response.data[i].predeterminada) {
	              setMoneda(response.data[i]);
	              setMonedaCambio({
	                idmoneda: response.data[i].idmoneda,
	                descripcion: response.data[i].descripcion,
	                simbolo: response.data[i].simbolo,
	                predeterminada: response.data[i].predeterminada,
	                subpredeterminada: response.data[i].subpredeterminada,
	                valormoneda: 1.0
	              });
	              x = i;
	            }
	          }
	        }
	        setTimeout(function () {
	          return cmbMoneda.current.selectedIndex = x;
	        }, 200);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var selectnumfactu = function selectnumfactu() {
	    var tabla = "factura";
	    var id = "idfactura";
	    var idtabla = "idfactura";
	    var endpoint = op.conexion + "/api/inventario/consultacodigos?tabla=" + tabla + "&idtabla=" + idtabla + "&id=" + id;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.numeroasignado > 0) {
	          var to = parseFloat(response.data.numeroasignado) + 1;
	          var cerrrou = '000000';
	          var paddedNumber = (0, _varios.lpad)(to.toString(), cerrrou, 6);
	          txtNumFactura.current.value = "F" + paddedNumber;
	          if (txtNumFactura.current.value !== '') {
	            setTimeout(function () {
	              return txtNumFactura.current.focus();
	            }, 200);
	          }
	        } else {
	          txtNumFactura.current.value = "F000001";
	          if (txtNumFactura.current.value !== '') {
	            setTimeout(function () {
	              return txtNumFactura.current.focus();
	            }, 200);
	          }
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarVendedor = function seleccionarVendedor(id) {
	    var campos = "v.idagente, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen";
	    var nomtab = "agente as v";
	    var nomid = "v.idagente";
	    var nomid2 = "v.vendedor";
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setVendedor({
	            idvendedor: response.data.idagente,
	            tiporif: response.data.tiporifv,
	            rif: response.data.rifv,
	            nombre: response.data.nombrev,
	            idalmacen: response.data.idalmacen
	          });
	
	          btnAcepta.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un vendedor con este codigo",
	            icono: "informacion"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarProducto = function seleccionarProducto(index, idubi, idprod) {
	    var endpoint = op.conexion + "/api/pedido/seleccionarproductoinv?idproducto=" + idprod + "&idalmacen=" + idubi;
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var data = [].concat(_toConsumableArray(records));
	        if (response.data !== "") {
	          if (response.data.servicio) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "no existe un producto con ese codigo en el almacen.",
	              icono: "error"
	            });
	            txtCantidad.current[records.length - 1].value = "1,00";
	          } else {
	            for (var i = 0; i < records.length; i++) {
	              if (records[i].idproducto === response.data.idproducto) {
	                setActivate(false);
	                setMensaje({
	                  mostrar: true,
	                  titulo: "Notificacion",
	                  texto: "el producto ya ha sido seleccionado.",
	                  icono: "error"
	                });
	                return;
	              }
	            }
	
	            var uni = [];
	            var precio = 0.0;
	            var montoiva = 0.0;
	            var cantie = response.data.cantidad;
	            var tipouni = 0;
	            var tiene_iva = false;
	            var tipoprecio = parseInt(response.data.tipoprecio);
	
	            if (parseFloat(response.data.ivaventa) > 0.0) {
	              tiene_iva = true;
	            }
	
	            if (parseInt(response.data.tipofactor) === 0 || response.data.tipofactor === null) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data.idunidadmedida,
	                descripcion: response.data.descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data.cantidad);
	              cantie = Math.trunc(cantie);
	
	              if (tipoprecio === 1) {
	                precio = parseFloat(response.data.preciomaxi) * monedaSub.valormoneda;
	              } else if (tipoprecio === 2) {
	                precio = parseFloat(response.data.precioofe) * monedaSub.valormoneda;
	              } else if (tipoprecio === 3) {
	                precio = parseFloat(response.data.preciomayor) * monedaSub.valormoneda;
	              } else if (tipoprecio === 4) {
	                precio = parseFloat(response.data.preciomini) * monedaSub.valormoneda;
	              }
	            } else {
	              if (response.data.idunidadventa === response.data.idunidadalterna) {
	                tipouni = 1;
	                uni = [{
	                  idunidad: response.data.idunidadalterna,
	                  descripcion: response.data.descripcionunialt,
	                  tipo: "alterna"
	                }, {
	                  idunidad: response.data.idunidadmedida,
	                  descripcion: response.data.descripcionuni,
	                  tipo: "medida"
	                }];
	
	                cantie = parseFloat(response.data.cantidad);
	                cantie = Math.trunc(cantie);
	                if (tipoprecio === 1) {
	                  precio = parseFloat(response.data.preciomaxialter) * monedaSub.valormoneda;
	                } else if (tipoprecio === 2) {
	                  precio = parseFloat(response.data.precioofealter) * monedaSub.valormoneda;
	                } else if (tipoprecio === 3) {
	                  precio = parseFloat(response.data.preciomayoralter) * monedaSub.valormoneda;
	                } else if (tipoprecio === 4) {
	                  precio = parseFloat(response.data.preciominialter) * monedaSub.valormoneda;
	                }
	              } else if (response.data.idunidadventa === response.data.idunidadmedida) {
	                tipouni = 0;
	                uni = [{
	                  idunidad: response.data.idunidadmedida,
	                  descripcion: response.data.descripcionuni,
	                  tipo: "medida"
	                }, {
	                  idunidad: response.data.idunidadalterna,
	                  descripcion: response.data.descripcionunialt,
	                  tipo: "alterna"
	                }];
	
	                cantie = parseFloat(response.data.cantidad / response.data.valorfactor);
	                cantie = Math.trunc(cantie);
	
	                if (tipoprecio === 1) {
	                  precio = parseFloat(response.data.preciomaxi) * monedaSub.valormoneda;
	                } else if (tipoprecio === 2) {
	                  precio = parseFloat(response.data.precioofe) * monedaSub.valormoneda;
	                } else if (tipoprecio === 3) {
	                  precio = parseFloat(response.data.preciomayor) * monedaSub.valormoneda;
	                } else if (tipoprecio === 4) {
	                  precio = parseFloat(response.data.preciomini) * monedaSub.valormoneda;
	                }
	              }
	            }
	
	            montoiva = precio * response.data.ivaventa / 100;
	            montoiva = (0, _varios.round)(montoiva, 2);
	
	            if (index !== null) {
	              data[index] = {
	                idproducto: response.data.idproducto,
	                codigo: response.data.codigo,
	                nombre: response.data.nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	                iva: response.data.ivaventa,
	                precio: precio,
	                cantidad: 1.0,
	                totalivas: montoiva,
	                totalsiniva: precio,
	                totalmonto: precio + montoiva,
	                tipounidad: tipouni,
	                idunidadmedida: response.data.idunidadmedida,
	                idunidadalterna: response.data.idunidadalterna,
	                unidad: uni,
	                valorfactor: response.data.valorfactor
	              };
	            } else {
	              data.push({
	                idproducto: response.data.idproducto,
	                codigo: response.data.codigo,
	                nombre: response.data.nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	                iva: response.data.ivaventa,
	                precio: precio,
	                cantidad: 1.0,
	                totalivas: montoiva,
	                totalsiniva: precio,
	                totalmonto: precio + montoiva,
	                tipounidad: tipouni,
	                idunidadmedida: response.data.idunidadmedida,
	                idunidadalterna: response.data.idunidadalterna,
	                unidad: uni,
	                valorfactor: response.data.valorfactor
	              });
	            }
	
	            setRecords(data);
	            setTotales((0, _varios.calcularTotalesDos)(data));
	            setIndice(index);
	
	            if (index !== null) {
	              setTimeout(function () {
	                return txtCantidad.current[index].focus();
	              }, 300);
	            } else {
	              setTimeout(function () {
	                return txtCantidad.current[data.length - 1].focus();
	              }, 300);
	            }
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "no existe un producto con ese codigo en el almacen.",
	            icono: "error"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarNotaEntrega = function seleccionarNotaEntrega(datos) {
	    var ids = [];
	    var idsnots = [];
	    for (var i = 0; i < datos.length; i++) {
	      ids.push(parseInt(datos[i].idnota));
	      idsnots.push({
	        idnota: parseInt(datos[i].idnota)
	      });
	    }
	    setIdnotas(idsnots);
	    var endpoint = op.conexion + "/api/registropago/selectnotaentregafactuid?ids=" + ids;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	
	        var datapropduct = [];
	        var _datos = [];
	
	        for (var _i = 0; _i < response.data.length; _i++) {
	
	          datapropduct.push({
	            idproducto: response.data[_i].idproducto,
	            codigo: response.data[_i].codigoproductoc,
	            nombre: response.data[_i].nombreproducto,
	            tipounidad: response.data[_i].tipounidadc,
	            idunidadmedida: response.data[_i].idunidadmedida,
	            idunidadalterna: response.data[_i].idunidadalterna,
	            unidadmedida: response.data[_i].unidadmedida,
	            iva: response.data[_i].iva,
	            precio: parseFloat(response.data[_i].precios),
	            montoiva: parseFloat(response.data[_i].montoivac),
	            cantidad: parseFloat(response.data[_i].cantidadc),
	            cantidadc: parseFloat(response.data[_i].cantidadcaja),
	            cantidadunic: parseFloat(response.data[_i].cantiunidxcaja),
	            totalsiniva: parseFloat(response.data[_i].totalsiniva),
	            totalmonto: parseFloat(response.data[_i].total),
	            valorfactor: parseFloat(response.data[_i].valorfactor)
	          });
	        }
	
	        console.log("datapropduct", datapropduct);
	
	        var unificarProductos = [];
	
	        var _loop = function _loop(product) {
	          var existingProduct = unificarProductos.find(function (p) {
	            return p.nombre === product.nombre;
	          });
	          if (existingProduct) {
	            existingProduct.totalmonto += parseFloat(product.totalmonto);
	            existingProduct.cantidad += parseFloat(product.cantidad);
	            existingProduct.cantidadc += parseFloat(product.cantidadc);
	            existingProduct.cantidadunic += parseFloat(product.cantidadunic);
	            existingProduct.totalsiniva += parseFloat(product.totalsiniva);
	          } else {
	            unificarProductos.push(Object.assign({}, product));
	          }
	        };
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = datapropduct[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var product = _step.value;
	
	            _loop(product);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        var subtotaln = 0.00;
	        var exenton = 0.00;
	        var sujeton = 0.00;
	        var totalivan = 0.00;
	        var totaln = 0.00;
	        var uni = [];
	
	        for (var e = 0; e < unificarProductos.length; e++) {
	
	          var precioproduct = 0.00;
	          var totalcantidad = 0;
	          var montoconiva = 0.00;
	          var montototal = 0.00;
	          var moniva = 0.00;
	          var totaliva = 0.00;
	          var tipouni = null;
	
	          if (unificarProductos[e].cantidad > 0 && unificarProductos[e].cantidadc > 0) {
	            precioproduct = (0, _varios.round)(unificarProductos[e].totalsiniva / (unificarProductos[e].cantidad + unificarProductos[e].cantidadunic), 2);
	            totalcantidad = unificarProductos[e].cantidad + unificarProductos[e].cantidadunic;
	            moniva = precioproduct * unificarProductos[e].iva / 100;
	            totaliva = (0, _varios.round)(moniva * totalcantidad, 2);
	            montoconiva = (0, _varios.round)((precioproduct + moniva) * totalcantidad, 2);
	            montototal = (0, _varios.round)(precioproduct * totalcantidad, 2);
	            tipouni = 1;
	          } else if (unificarProductos[e].cantidad > 0 && unificarProductos[e].cantidadc === 0) {
	            precioproduct = (0, _varios.round)(unificarProductos[e].totalsiniva / unificarProductos[e].cantidad, 2);
	            totalcantidad = unificarProductos[e].cantidad;
	            moniva = precioproduct * unificarProductos[e].iva / 100;
	            totaliva = (0, _varios.round)(moniva * totalcantidad, 2);
	            montoconiva = (0, _varios.round)((precioproduct + moniva) * totalcantidad, 2);
	            montototal = (0, _varios.round)(precioproduct * totalcantidad, 2);
	            tipouni = 1;
	          } else {
	            precioproduct = (0, _varios.round)(unificarProductos[e].totalsiniva / unificarProductos[e].cantidadc, 2);
	            totalcantidad = unificarProductos[e].cantidadc;
	            moniva = precioproduct * unificarProductos[e].iva / 100;
	            totaliva = (0, _varios.round)(moniva * totalcantidad, 2);
	            montoconiva = (0, _varios.round)((precioproduct + moniva) * totalcantidad, 2);
	            montototal = (0, _varios.round)(precioproduct * totalcantidad, 2);
	            tipouni = 0;
	          }
	
	          if (tipouni === 1) {
	            uni = [{
	              idunidad: unificarProductos[e].idunidadalterna,
	              descripcion: "UNIDAD",
	              tipo: "alterna"
	            }, {
	              idunidad: unificarProductos[e].idunidadmedida,
	              descripcion: unificarProductos[e].unidadmedida,
	              tipo: "medida"
	            }];
	          } else {
	            uni = [{
	              idunidad: unificarProductos[e].idunidadmedida,
	              descripcion: unificarProductos[e].unidadmedida,
	              tipo: "medida"
	            }, {
	              idunidad: unificarProductos[e].idunidadalterna,
	              descripcion: "UNIDAD",
	              tipo: "alterna"
	            }];
	          }
	
	          totaln = totaln + montoconiva;
	          sujeton = sujeton + totaliva;
	          totalivan = totalivan + totaliva;
	
	          if (unificarProductos[e].iva > 0) {
	            subtotaln = subtotaln + montototal;
	          } else {
	            exenton = exenton + montototal;
	          }
	
	          _datos.push({
	            idproducto: unificarProductos[e].idproducto,
	            codigo: unificarProductos[e].codigo,
	            nombre: unificarProductos[e].nombre,
	            iva: unificarProductos[e].iva,
	            precio: precioproduct,
	            cantidad: totalcantidad,
	            totalivas: totaliva,
	            totalsiniva: montototal,
	            totalmonto: montoconiva,
	            tipounidad: tipouni,
	            idunidadmedida: unificarProductos[e].idunidadmedida,
	            idunidadalterna: unificarProductos[e].idunidadalterna,
	            unidad: uni,
	            valorfactor: unificarProductos[e].valorfactor
	          });
	        }
	        setRecords(_datos);
	        setTotales({
	          subtotal: subtotaln + exenton,
	          descuento: 0.0,
	          exento: exenton,
	          sujeto: subtotaln,
	          iva: 16.0,
	          totaliva: (0, _varios.round)(totalivan, 2),
	          total: totaln
	        });
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarFactura = function seleccionarFactura() {
	    var campos = "p.*, m.*, p.fecha as fechafactura, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc, c.direccion as direccionc";
	    var nomtab = "factura as p inner join agente as v on p.idvendedor=v.idagente inner join agente as c on c.idagente=p.idcliente inner join moneda as m on p.idmoneda=m.idmoneda";
	
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=numfactura&id=" + txtNumFactura.current.value.trim();
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	
	          txtFecha.current.value = (0, _moment2.default)(response.data.fechafactura).format("YYYY-MM-DD");
	          txtNumFactura.current.setAttribute("disabled", true);
	          cmbRif.current.value = response.data.tiporifc;
	          txtRif.current.value = response.data.rifc;
	          txtNombreC.current.value = response.data.nombrec;
	          txtDireccioncliente.current.value = response.data.direccionc;
	          txtIdcliente.current.value = response.data.idcliente;
	
	          for (var i = 0; i < combomoneda.length; i++) {
	            if (response.data.idmoneda === combomoneda[i].idmoneda) {
	              cmbMoneda.current.selectedIndex = i;
	              break;
	            }
	          }
	
	          if (response.data.numnotaentrega === "" || response.data.numnotaentrega === null) {
	            setVisible(0);
	            if (operacion === 2) {
	              setHabilitadoMod(true);
	              setHabilitadoCli(true);
	              setHabilitadoProductos(false);
	              setHabilitarMoneda(true);
	            } else {
	              setHabilitadoMod(false);
	              setHabilitadoCli(false);
	              setHabilitadoProductos(true);
	            }
	          }
	
	          setHabilitarCat(true);
	          setFactura({
	            idfactura: response.data.idfactura,
	            numfactura: response.data.numfactura,
	            cedularif: response.data.cedularif,
	            descripcion: response.data.descripcion,
	            totalmonto: response.data.totalmonto,
	            totaliva: response.data.totaliva,
	            totaldescuento: response.data.totaldescuento,
	            totalexento: response.data.totalexento,
	            totalsujeto: response.data.totalsujeto,
	            idcliente: response.data.idcliente,
	            idvendedor: response.data.idvendedor,
	            fecha: (0, _moment2.default)(response.data.fecha).format("YYYY-MM-DD"),
	            status: response.data.status,
	            idalmacen: response.data.idalmacen,
	            idmoneda: response.data.idmoneda,
	            idoperacioninventario: response.data.idoperacioninventario,
	            idnotaentrega: response.data.idnotaentrega,
	            numnotaentrega: response.data.numnotaentrega,
	            creditof: response.data.creditof,
	            fechavencimientof: (0, _moment2.default)(response.data.fechavencimientof).format("YYYY-MM-DD"),
	            valormoneda: response.data.valormoneda
	          });
	
	          setMoneda({
	            idmoneda: response.data.idmoneda,
	            descripcion: response.data.descripcion,
	            simbolo: response.data.simbolo,
	            valormoneda: response.data.valormoneda,
	            predeterminada: response.data.predeterminada,
	            subpredeterminada: response.data.subpredeterminada
	          });
	
	          setVendedor({
	            idvendedor: response.data.idvendedor,
	            tiporif: response.data.tiporifv,
	            rif: response.data.rifv,
	            nombre: response.data.nombrev,
	            idalmacen: response.data.idalmacen
	          });
	
	          setTotales({
	            subtotal: response.data.totalmonto - response.data.totaliva,
	            descuento: response.data.totaldescuento,
	            exento: response.data.totalexento,
	            sujeto: response.data.totalsujeto,
	            iva: 16.0,
	            totaliva: response.data.totaliva,
	            total: response.data.totalmonto
	          });
	
	          seleccionarDetalleFactura(response.data.idfactura);
	          setHabilitadoTip(false);
	          if (operacion === 2) {
	            setHabilitado(true);
	            setTimeout(function () {
	              return txtFecha.current.focus();
	            }, 200);
	          } else {
	            setHabilitado(false);
	            setTimeout(function () {
	              return btnCancela.current.focus();
	            }, 200);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "no existe una Facturas con ese codigo.",
	            icono: "informacion"
	          });
	          txtNumFactura.current.value = "";
	          txtNumFactura.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarDetalleFactura = function seleccionarDetalleFactura(idfactura) {
	    var nomtab1 = "facturadetalle";
	    var nomtab2 = "factura";
	    var nomid = "idfactura";
	    var endpoint = op.conexion + "/api/inventario/seleccionarfacturadeta?id=" + idfactura + "&nomtab1=" + nomtab1 + "&nomtab2=" + nomtab2 + "&nomid=" + nomid;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var prod = [];
	          var uni = [];
	          var montoiva = 0.0;
	          var totalivasc = 0.0;
	          var tipouni = 0;
	          var tiene_iva = false;
	
	          for (var i = 0; i < response.data.length; i++) {
	            if (parseFloat(response.data[i].iva) > 0.0) {
	              tiene_iva = true;
	            }
	            if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) <= 0.0) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	            } else if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) > 0.0) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }, {
	                idunidad: response.data[i].idunidadalterna,
	                descripcion: response.data[i].descripcionunialt,
	                tipo: "alterna"
	              }];
	            } else if (response.data[i].tipounidad === 1) {
	              tipouni = 1;
	              uni = [{
	                idunidad: response.data[i].idunidadalterna,
	                descripcion: response.data[i].descripcionunialt,
	                tipo: "alterna"
	              }, {
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	            }
	
	            montoiva = response.data[i].punitariobs * response.data[i].iva / 100;
	
	            totalivasc = montoiva * response.data[i].cantidad;
	
	            prod.push({
	              idproducto: response.data[i].idproducto,
	              codigo: response.data[i].codigo,
	              nombre: response.data[i].nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	              iva: response.data[i].iva,
	              precio: response.data[i].punitariobs,
	              cantidad: response.data[i].cantidad,
	              totalivas: totalivasc,
	              totalsiniva: (0, _varios.round)(response.data[i].punitariobs * response.data[i].cantidad, 2),
	              totalmonto: (0, _varios.round)(response.data[i].punitariobs * response.data[i].cantidad + totalivasc, 2),
	              tipounidad: tipouni,
	              idunidadmedida: response.data[i].idunidadmedida,
	              idunidadalterna: response.data[i].idunidadalterna,
	              unidad: uni,
	              valorfactor: response.data[i].valorfactor
	            });
	          }
	          setRecords(prod);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/inventario/actualizarfacturanota/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idfactur + " creado correctamente",
	            icono: "exito"
	          });
	
	          var reporte = "Factura";
	          var idnot = response.data.idfactur;
	
	          window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&idnota=" + idnot, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	        } else if (operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idfactur + " modificado correctamente",
	            icono: "exito"
	          });
	          var reporte = "Factura";
	          var _idnot = response.data.idfactur;
	
	          window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&idnota=" + _idnot, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idfactur + " eliminado correctamente",
	            icono: "exito"
	          });
	        }
	      }
	    }).catch(function (error) {
	      var mensaje = error.response.data.message;
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	    }).finally(function () {
	      return setActivate(false);
	    });
	  };
	
	  var validarCantidadP = function validarCantidadP(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        var cantidades = (0, _varios.validarCantidadTres)({
	          index: index,
	          event: event,
	          productos: records
	        });
	        if (event.which === 13) {
	          if (index < cantidades.data.length - 1) {
	            setTimeout(function () {
	              return txtCantidad.current[index + 1].focus();
	            }, 300);
	          }
	        }
	        setMensaje(cantidades.msm);
	        setRecords(cantidades.data);
	        setTotales(cantidades.totales);
	      }
	    };
	  };
	
	  var validarPrecio = function validarPrecio(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        var montoprecio = (0, _varios.validarPrecioMontos)({
	          index: index,
	          event: event,
	          productos: records
	        });
	        if (event.which === 13) {
	          if (index < montoprecio.data.length - 1) {
	            setTimeout(function () {
	              return txtCantidad.current[index + 1].focus();
	            }, 300);
	          }
	        }
	        setMensaje(montoprecio.msm);
	        setRecords(montoprecio.data);
	        setTotales(montoprecio.totales);
	      }
	    };
	  };
	
	  var validarIdProducto = function validarIdProducto(index) {
	    return function (event) {
	      if (event.which === 13 || typeof event.which === "undefined") {
	        if (event.target.value !== "") {
	          if (vendedor.idalmacen !== "" && vendedor.idalmacen !== null) {
	            seleccionarProducto(index, vendedor.idalmacen, event.target.value);
	          } else {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación.",
	              texto: "debe seleccionar un vendedor.",
	              icono: "informacion"
	            });
	          }
	        }
	      }
	    };
	  };
	
	  var onCatalogoFactura = function onCatalogoFactura(values) {
	    setCatalogoFactura(false);
	    txtNumFactura.current.value = values.numfactura;
	    seleccionarFactura();
	  };
	
	  var onCatalogoNotaEntrega = function onCatalogoNotaEntrega(values) {
	    setCatalogoNota(false);
	    txtIdcliente.current.value = values[0].idcliente;
	    cmbRif.current.value = values[0].rif.substring(0, 1);
	    txtRif.current.value = values[0].rif.substring(1, 12);
	    txtNombreC.current.value = values[0].cliente;
	    txtDireccioncliente.current.value = values[0].direccion;
	    seleccionarNotaEntrega(values);
	  };
	
	  var agregarProducto = function agregarProducto(producto) {
	    seleccionarProducto(indice, vendedor.idalmacen, producto.codigo);
	    setMostrar(false);
	  };
	
	  var seleccionarxIndice = function seleccionarxIndice(index) {
	    return function (e) {
	      e.preventDefault();
	      if (vendedor.idalmacen !== "" && vendedor.idalmacen !== null) {
	        setMostrar(true);
	        setIndice(index);
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación.",
	          texto: "debe seleccionar un vendedor.",
	          icono: "informacion"
	        });
	      }
	    };
	  };
	
	  var eliminarProducto = function eliminarProducto(producto) {
	    return function (e) {
	      e.preventDefault();
	      var data = [].concat(_toConsumableArray(records));
	      var elementos = [];
	
	      for (var i = 0; i < data.length; i++) {
	        if (producto.idproducto !== data[i].idproducto) {
	          elementos.push(data[i]);
	        }
	      }
	      setRecords(elementos);
	      setTotales((0, _varios.calcularTotalesDos)(elementos));
	    };
	  };
	
	  var onChangeMoneda = function onChangeMoneda(e) {
	    var i = e.target.value;
	    var cambio = (0, _varios.onCambioMoneda)({
	      moneda: combomoneda[i],
	      productos: records,
	      monedaPre: moneda,
	      monedaSub: monedaSub
	    });
	    setMonedaCambio(cambio.monedacambio);
	    setRecords(cambio.data);
	  };
	
	  var onChangeUnidad = function onChangeUnidad(i) {
	    return function (e) {
	      var cambiounidad = (0, _varios.onCambioUnidadTres)({
	        idunidad: e.target.value,
	        index: i,
	        productos: records
	      });
	      setMensaje(cambiounidad.msm);
	      setRecords(cambiounidad.data);
	      setTotales(cambiounidad.totales);
	    };
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	
	    if (cmbRif.current.value === "" || txtRif.current.value.trim() === "" || txtNombreC.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Cliente no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtRif.current.focus();
	    } else if (txtFecha.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtFecha.current.focus();
	    } else if (records.length === 0) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "No hay Producto agregados",
	        icono: "informacion"
	      });
	      sigue = false;
	      btnCancela.current.focus();
	    } else if (records.length > 0 && operacion !== 3) {
	      for (var i = 0; i < records.length; i++) {
	        if (factura.numnotaentrega === "" || factura.numnotaentrega === null) {
	          if (records[i].cantidadE === 0.0) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La  cantidad no debe ser mayor a la cantidad existente",
	              icono: "informacion"
	            });
	            sigue = false;
	            btnCancela.current.focus();
	            break;
	          } else if (records[i].cantidadE < records[i].cantidad) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La  cantidad no debe ser mayor a la cantidad existente",
	              icono: "informacion"
	            });
	            sigue = false;
	            btnCancela.current.focus();
	            break;
	          }
	        }
	      }
	    }
	
	    if (sigue) {
	      var fact = [];
	      var factdet = [];
	
	      fact.push(Object.assign({
	        idfactura: factura.idfactura,
	        numfactura: txtNumFactura.current.value.trim(),
	        descripcion: "FACTURA DE PRODUCTOS",
	        cedularif: cmbRif.current.value.trim() + txtRif.current.value.trim(),
	        totalmonto: totales.total,
	        totaliva: totales.totaliva,
	        totalexento: totales.exento,
	        totalsujeto: totales.sujeto,
	        totaldescuento: totales.descuento
	      }, factura.idnotaentrega !== "" && factura.idnotaentrega !== null && {
	        idnotaentrega: factura.idnotaentrega
	      }, {
	        idcliente: txtIdcliente.current.value,
	        idvendedor: idVendedor,
	        fecha: txtFecha.current.value,
	        status: 1,
	        idalmacen: 0,
	        idmoneda: 1,
	        idoperacioninventario: "",
	        creditof: 0.00,
	        fechavencimientof: "",
	        tipofactu: "NO"
	      }));
	
	      for (var _i2 = 0; _i2 < records.length; _i2++) {
	        factdet.push({
	          idproducto: records[_i2].idproducto,
	          cantidad: records[_i2].cantidad,
	          punitario: (0, _varios.round)(records[_i2].precio / monedaSub.valormoneda, 2),
	          punitariobs: records[_i2].precio,
	          descuento: "0.00",
	          iva: records[_i2].iva,
	          tipounidad: records[_i2].tipounidad,
	          idunidadmedida: records[_i2].idunidadmedida,
	          idunidadalterna: records[_i2].idunidadalterna,
	          tasa: monedaSub.valormoneda,
	          codproducto: records[_i2].codigo,
	          costo: records[_i2].precio,
	          utilidad: 0.00,
	          tipopreciodeta: 0
	        });
	      }
	
	      setBody({
	        factur: fact,
	        facturdet: factdet,
	        idtipopeinv: "2",
	        opeinv: [],
	        opeinvdet: [],
	        idsnotas: idsnotas
	      });
	
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var blanquear = function blanquear() {
	    setTituloHeader("Gestionar Facturas.");
	    setBody();
	    setActivate(false);
	    txtNumFactura.current.value = "";
	    setHabilitado(false);
	    setHabilitadoMod(false);
	    setHabilitadoTip(false);
	    setHabilitarMoneda(false);
	    setHabilitadoCli(false);
	    setHabilitadoBot(true);
	    setHabilitarCat(true);
	    setHabilitadoProductos(true);
	    setVisible(0);
	    setSelectp(0);
	    setSelectd(0);
	    setVisibleBtn("visible");
	    setMoneda({
	      idmoneda: "1",
	      descripcion: "BOLIVARES",
	      simbolo: "Bs",
	      predeterminada: false,
	      valormoneda: 1.0
	    });
	    setMonedaCambio({
	      idmoneda: "1",
	      descripcion: "BOLIVARES",
	      simbolo: "Bs",
	      predeterminada: true,
	      subpredeterminada: false,
	      valormoneda: 1.0
	    });
	    setRecords([]);
	    for (var i = 0; i < combomoneda.length; i++) {
	      if (combomoneda[i].idmoneda === moneda.idmoneda) {
	        cmbMoneda.current.selectedIndex = i;
	      }
	    }
	    txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	    cmbRif.current.value = "J";
	    txtRif.current.value = "";
	    txtNombreC.current.value = "";
	    txtDireccioncliente.current.value = "";
	    setCliente({
	      idcliente: "",
	      tiporif: "J",
	      rif: "",
	      nombre: ""
	    });
	    setVendedor({
	      idvendedor: "",
	      tiporif: "",
	      rif: "",
	      nombre: "",
	      idalmacen: ""
	    });
	    setFactura({
	      idfactura: "0",
	      numfactura: "000000",
	      cedularif: "",
	      descripcion: "FACTURAS DE PRODUCTOS",
	      totalmonto: 0.0,
	      totaliva: 0.0,
	      totaldescuento: 0.0,
	      totalexento: 0.0,
	      totalsujeto: 0.0,
	      idcliente: "",
	      idvendedor: "",
	      fecha: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	      status: 0,
	      idalmacen: "",
	      idmoneda: "",
	      idoperacioninventario: "",
	      idnotaentrega: "",
	      numnotaentrega: "",
	      creditof: false,
	      fechavencimientof: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	      valormoneda: 0.0
	    });
	    setTotales({
	      subtotal: 0.0,
	      descuento: 0.0,
	      exento: 0.0,
	      sujeto: 0.0,
	      iva: 16.0,
	      totaliva: 0.0,
	      total: 0.0
	    });
	    setOperacion(0);
	    setIdnotas([]);
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var handleInputChangeCodigo = function handleInputChangeCodigo(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "numnotaentrega") {
	          seleccionarNotaEntrega();
	        } else if (event.target.name === "numfactura") {
	          seleccionarFactura();
	        }
	      }
	    }
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "tipopago") {
	      if (e.target.value === "1") {
	        setSelectd(0);
	        setFactura(Object.assign({}, factura, {
	          creditof: false,
	          fechavencimientof: ""
	        }));
	        txtFechaVencimiento.current.value = "";
	      } else if (e.target.value === "2") {
	        setSelectd(1);
	        setFactura(Object.assign({}, factura, {
	          creditof: true,
	          fechavencimientof: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD")
	        }));
	        txtFechaVencimiento.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	      }
	    } else if (e.target.name === "desde") {
	      if (e.target.value === "2") {
	        setSelectp(1);
	        setVisible(1);
	        setHabilitadoCli(false);
	        setHabilitadoProductos(true);
	      } else if (e.target.value === "1") {
	        setSelectp(0);
	        setVisible(0);
	        setHabilitadoCli(true);
	        setHabilitadoProductos(false);
	      }
	    } else if (e.target.name === "fecha") {
	      setFactura(Object.assign({}, factura, { fecha: e.target.value }));
	    } else if (e.target.name === "fechavencimiento") {
	      setFactura(Object.assign({}, factura, { fechavencimientof: e.target.value }));
	    }
	  };
	
	  var imprimirFactura = function imprimirFactura() {
	    if (accbtnfacturas && accbtnfacturas.toString().substring(4, 5) === "1") {
	      var fact = 0;
	      if (txtNumFactura.current.value !== "") {
	        var idnot = factura.idfactura;
	
	        var reporte = "Factura";
	
	        window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&idnota=" + idnot, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Seleccione la Factura !",
	          icono: "informacion"
	        });
	        fact = 1;
	      }
	
	      if (fact === 1) {
	        txtNumFactura.current.focus();
	      }
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (accbtnfacturas && accbtnfacturas.toString().substring(0, 1) === "1") {
	          setTituloHeader("Incluir Facturas.");
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          setHabilitadoTip(true);
	          setHabilitadoMod(true);
	          setHabilitado(true);
	          setHabilitadoCli(true);
	          setHabilitadoProductos(false);
	          setHabilitarMoneda(true);
	          selectnumfactu();
	          seleccionarVendedor(idVendedor);
	          setHabilitarCat(true);
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (accbtnfacturas && accbtnfacturas.toString().substring(1, 2) === "1") {
	          setTituloHeader("Editar Facturas.");
	          setOperacion(op);
	          //txtNumFactura.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setTimeout(function () {
	            return txtNumFactura.current.focus();
	          }, 200);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (accbtnfacturas && accbtnfacturas.toString().substring(3, 4) === "1") {
	          setTituloHeader("Eliminar Facturas.");
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          setHabilitarCat(false);
	          setHabilitadoTip(false);
	          setHabilitarMoneda(false);
	          setHabilitadoMod(false);
	          setHabilitado(false);
	          setHabilitadoCli(false);
	          setHabilitadoProductos(true);
	          setTimeout(function () {
	            return txtNumFactura.current.focus();
	          }, 200);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (accbtnfacturas && accbtnfacturas.toString().substring(2, 3) === "1") {
	          setTituloHeader("Consultar Facturas.");
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          setHabilitarCat(false);
	          setHabilitado(false);
	          setHabilitadoTip(false);
	          setHabilitarMoneda(true);
	          setHabilitadoMod(false);
	          setHabilitadoCli(false);
	          setHabilitadoProductos(true);
	          setTimeout(function () {
	            return txtNumFactura.current.focus();
	          }, 200);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        blanquear();
	      }
	    };
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarMonedas();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 ", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-11 mx-auto py-2 card shadow" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row border-azul mx-auto rounded py-1" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row mx-auto d-flex justify-content-between mb-1" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-2 azulGradiant shadow text-light justify-content-between" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-4" },
	                  _react2.default.createElement(
	                    "h3",
	                    null,
	                    tituloHeader
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-3 d-flex justify-content-end" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/inicio", className: "text-light " },
	                    _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "fw-bold" },
	                      "Salir"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col-pd-300 mb-3",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "N\xB0 FACTURA:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: operacion !== 0 ? false : true,
	                    autoComplete: "off",
	                    ref: txtNumFactura,
	                    name: "numfactura",
	                    onKeyUp: operacion !== 1 ? handleInputChangeCodigo : null,
	                    onBlur: operacion !== 1 ? handleInputChangeCodigo : null,
	                    onChange: function onChange(e) {
	                      return e.target.value = e.target.value.toUpperCase();
	                    },
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  }),
	                  operacion !== 1 && _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: habilitarCat,
	                      type: "button",
	                      onClick: function onClick() {
	                        return setCatalogoFactura(true);
	                      },
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col280 mr-auto mb-3 px-1",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "NOTA ENTREGA:"
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      type: "button",
	                      disabled: !habilitadoTip,
	                      onClick: function onClick() {
	                        return setCatalogoNota(true);
	                      },
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "colfull col-pd-290 mb-3" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO MONEDA:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-control form-control-sm fw-bold text-center",
	                      disabled: !habilitarMoneda,
	                      ref: cmbMoneda,
	                      onChange: onChangeMoneda
	                    },
	                    combomoneda && combomoneda.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: index },
	                        " ",
	                        item.descripcion + " " + item.simbolo + " " + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                        " "
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-220 ml-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "date",
	                    disabled: !habilitado,
	                    ref: txtFecha,
	                    name: "fecha",
	                    onChange: onChange,
	                    className: "form-control fs-6 text-uppercase",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "colfull1070 col-sm-12 mx-auto mb-1 row m-0",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row border-azul rounded py-2" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold mb-1" },
	                  "Datos del Cliente"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-3 px-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: cmbRif,
	                      name: "cmbrif",
	                      disabled: true,
	                      className: "form-select form-select-sm col-md-3 text-center",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _varios.cmbCedula.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.value },
	                        item.value
	                      );
	                    })
	                  ),
	                  _react2.default.createElement("input", {
	                    ref: txtRif,
	                    autoComplete: "off",
	                    disabled: true,
	                    maxLength: 9,
	                    type: "text",
	                    className: "form-control fs-6",
	                    name: "cedula",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement("input", { type: "hidden", ref: txtIdcliente }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-9" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "NOMBRE:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    ref: txtNombreC,
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "DIRECCI\xD3N:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    ref: txtDireccioncliente,
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 border-azul px-0 rounded",
	                style: { backgroundColor: "#d5e9ff" }
	              },
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 300,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px",
	                    fontSizeAdjust: "0.6"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden" },
	                  records && records.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      { key: index, style: { padding: "0" } },
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "bg-light d-flex align-items-between px-0" },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          style: {
	                            borderBottomRightRadius: 0,
	                            borderTopRightRadius: 0
	                          },
	                          disabled: habilitadoProductos,
	                          ref: function ref(el) {
	                            return txtId.current[index] = el;
	                          },
	                          className: "form-control form-control-sm bg-light fs-6",
	                          defaultValue: item.codigo,
	                          onChange: function onChange(e) {
	                            return e.target.value = e.target.value.toUpperCase();
	                          },
	                          onKeyUp: validarIdProducto(index),
	                          onBlur: validarIdProducto(index)
	                        }),
	                        (operacion === 1 || operacion === 2 || factura.numnotaentrega !== "") && _react2.default.createElement(
	                          "button",
	                          {
	                            type: "button",
	                            style: {
	                              borderBottomLeftRadius: 0,
	                              borderTopLeftRadius: 0
	                            },
	                            disabled: habilitadoProductos,
	                            onClick: seleccionarxIndice(index),
	                            className: "btn btn-sm btn-primary"
	                          },
	                          _react2.default.createElement(
	                            "i",
	                            { className: "fas " },
	                            "-"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-start p-0 pl-2",
	                          style: { width: "250px" }
	                        },
	                        item.nombre
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-center p-0",
	                          style: { width: "20px" }
	                        },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "col-12 row m-0 px-0" },
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control form-control-sm bg-light text-right fs-6 col-6",
	                            id: "cantidad",
	                            disabled: !habilitadoMod,
	                            defaultValue: (0, _varios.formatMoneda)(item.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                            ref: function ref(el) {
	                              return txtCantidad.current[index] = el;
	                            },
	                            onFocus: _varios.seleccionarCampo,
	                            onKeyUp: validarCantidadP(index),
	                            onBlur: validarCantidadP(index),
	                            "aria-label": "Sizing example input",
	                            "aria-describedby": "inputGroup-sizing-sm"
	                          }),
	                          _react2.default.createElement(
	                            "select",
	                            {
	                              className: "form-control form-control-sm fs-6 col-6",
	                              style: { width: "100%" },
	                              disabled: habilitadoProductos,
	                              onChange: onChangeUnidad(index)
	                            },
	                            item.unidad && item.unidad.map(function (item2, x) {
	                              return _react2.default.createElement(
	                                "option",
	                                { key: x, value: item2.idunidad },
	                                " ",
	                                item2.descripcion,
	                                " "
	                              );
	                            })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light p-0 text-right",
	                          style: { width: 50 }
	                        },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          disabled: operacion === 2 || operacion === 1 ? false : true,
	                          onKeyUp: validarPrecio(index),
	                          onBlur: validarPrecio(index),
	                          className: "form-control form-control-sm bg-light text-right fs-6",
	                          id: "precio",
	                          defaultValue: (0, _varios.formatMoneda)(item.precio.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtPrecio.current[index] = el;
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "50px" }
	                        },
	                        (0, _varios.formatMoneda)(item.iva.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "50px" }
	                        },
	                        (0, _varios.formatMoneda)(item.totalivas.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "50px" }
	                        },
	                        (0, _varios.formatMoneda)(item.totalmonto.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      operacion !== 4 && operacion !== 3 && _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-center p-0",
	                          style: { width: "20px" }
	                        },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            disabled: habilitadoProductos,
	                            style: {
	                              visibility: (operacion === 4 || operacion === 3) && "collapse"
	                            },
	                            onClick: eliminarProducto(item),
	                            className: "btn btn-sm btn-danger"
	                          },
	                          _react2.default.createElement("i", { className: "fa fa-trash" }),
	                          " "
	                        )
	                      )
	                    );
	                  }),
	                  _react2.default.createElement(
	                    _core.TableRow,
	                    {
	                      style: {
	                        padding: "0",
	                        visibility: (operacion === 4 || operacion === 0 || operacion === 3) && "collapse"
	                      }
	                    },
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: "align-middle bg-light text-center p-0 d-flex" },
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        disabled: habilitadoProductos,
	                        ref: txtIdproducto,
	                        style: {
	                          borderBottomRightRadius: 0,
	                          borderTopRightRadius: 0
	                        },
	                        className: "form-control form-control-sm bg-light text-right",
	                        onChange: function onChange(e) {
	                          return e.target.value = e.target.value.toUpperCase();
	                        },
	                        onKeyUp: validarIdProducto(null),
	                        onBlur: validarIdProducto(null)
	                      }),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          disabled: habilitadoProductos,
	                          style: {
	                            borderBottomLeftRadius: 0,
	                            borderTopLeftRadius: 0
	                          },
	                          onClick: function onClick() {
	                            return setMostrar(true);
	                          },
	                          className: "btn btn-sm btn-primary"
	                        },
	                        _react2.default.createElement(
	                          "i",
	                          { className: "fas " },
	                          "-"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light text-start p-0 pl-2",
	                      style: { width: "250px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light text-end p-0 pr-2",
	                      style: { width: "50px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light text-end p-0 pr-2",
	                      style: { width: "50px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light p-0",
	                      style: { width: 50 }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light p-0",
	                      style: { width: 50 }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light text-end p-0",
	                      style: { width: "50px" }
	                    }),
	                    operacion === 4 || operacion === 3 ? "" : _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light text-center p-0",
	                      style: { width: "20px" }
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row m-0 px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-7 py-1 mt-auto" },
	                visibleBtn === "visible" ? _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-botones" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 row m-0" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: !habilitadoBot,
	                        ref: btnIncluir,
	                        onClick: onBotones(1),
	                        className: "btn btn-sm col ml-1 mb-1 btn-primary rounded-pill",
	                        title: "Incluir Factura"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-plus" },
	                        " Incluir "
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: !habilitadoBot,
	                        ref: btnConsultar,
	                        onClick: onBotones(4),
	                        className: "btn btn-sm col ml-1 mb-1 btn-info rounded-pill",
	                        title: "Consultar Factura"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-eye" },
	                        " Consultar"
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: !habilitadoBot,
	                        ref: btnEditar,
	                        onClick: onBotones(2),
	                        className: "btn btn-sm col ml-1 mb-1 btn-warning rounded-pill",
	                        title: "Modificar Factura"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fa fa-edit" },
	                        " Modificar"
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: !habilitadoBot,
	                        ref: btnEliminar,
	                        onClick: onBotones(3),
	                        className: "btn btn-sm col ml-1 mb-1 btn-danger rounded-pill",
	                        title: "Eliminar Factura"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fa fa-trash" },
	                        " Eliminar"
	                      ),
	                      " "
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-360 row m-0 ml-auto" },
	                  operacion === 4 ? _react2.default.createElement(
	                    "button",
	                    {
	                      onClick: imprimirFactura,
	                      disabled: operacion === 4 ? false : true,
	                      className: "btn btn-sm col ml-1 btn-primary rounded-pill",
	                      title: "Imprimir Factura"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-print" },
	                      " Imprimir"
	                    )
	                  ) : "",
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnAcepta,
	                      disabled: operacion === 4 ? true : habilitadoBot,
	                      onClick: onBotones(5),
	                      className: "btn btn-sm col ml-1 rounded-pill btn-success"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-check-circle" },
	                      " Aceptar"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnCancela,
	                      disabled: habilitadoBot,
	                      onClick: onBotones(6),
	                      className: "btn btn-danger col ml-1 btn-sm rounded-pill"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-window-close" },
	                      " Cancelar"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-md-5 border-azul rounded shadow",
	                  style: { backgroundColor: "#dbeeff" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "SUBTOTAL ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtSubTotal,
	                    value: (0, _varios.formatMoneda)(totales.subtotal.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "EXENTO ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtExentoTotal,
	                    value: (0, _varios.formatMoneda)(totales.exento.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "DESCUENTO ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtDescuento,
	                    value: (0, _varios.formatMoneda)(totales.descuento.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "IVA ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtTotIva,
	                    value: (0, _varios.formatMoneda)(totales.totaliva.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "TOTAL ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtTotal,
	                    value: (0, _varios.formatMoneda)(totales.total.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoProductoExistencia2.default, {
	      show: mostrar,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar(false);
	      },
	      onHideAceptaCatalogo: agregarProducto,
	      idalmacen: vendedor.idalmacen
	    }),
	    _react2.default.createElement(_catalogoNotaEntregaFactura2.default, {
	      show: catalogoNota,
	      nomid: "notaentrega",
	      tip: "FA",
	      tipo: "NE",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoNota(false);
	      },
	      onHideAceptaCatalogo: onCatalogoNotaEntrega,
	      condicion: "status != 4"
	    }),
	    _react2.default.createElement(_catalogoFactura2.default, {
	      show: catalogoFactura,
	      tipofactu: "factu",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoFactura(false);
	      },
	      onHideAceptaCatalogo: onCatalogoFactura
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return mensaje.titulo === "Exito." ? blanquear() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = TablaFacturaxNota;

/***/ },
/* 7176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _catalogoNotaEntrega = __webpack_require__(209);
	
	var _catalogoNotaEntrega2 = _interopRequireDefault(_catalogoNotaEntrega);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TablaNotaCredito = function TablaNotaCredito() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var accbtnndebito = JSON.parse(sessionStorage.getItem("accbtnndebitoc"));
	
	  var txtIdNotaEntrega = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtConcepto = (0, _react.useRef)();
	  var txtMontoTotal = (0, _react.useRef)();
	  var btnIncluir = (0, _react.useRef)();
	  var btnEditar = (0, _react.useRef)();
	  var btnEliminar = (0, _react.useRef)();
	  var btnConsultar = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnProducto = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtSubTotal = (0, _react.useRef)();
	  var txtDescuento = (0, _react.useRef)();
	  var txtTotIva = (0, _react.useRef)();
	  var txtTotal = (0, _react.useRef)();
	  var txtTotalDivisa = (0, _react.useRef)();
	  var txtIdPedido = (0, _react.useRef)();
	  var cmbMoneda = (0, _react.useRef)();
	  var txtDias = (0, _react.useRef)();
	  var txtFechaVencimiento = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      body = _useState2[0],
	      setBody = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      operacion = _useState4[0],
	      setOperacion = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      habilitado = _useState6[0],
	      setHabilitado = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(true),
	      _useState8 = _slicedToArray(_useState7, 2),
	      habilitarCat = _useState8[0],
	      setHabilitarCat = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(true),
	      _useState10 = _slicedToArray(_useState9, 2),
	      habilitadoBot = _useState10[0],
	      setHabilitadoBot = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      habilitadoCli = _useState12[0],
	      setHabilitadoCli = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(""),
	      _useState14 = _slicedToArray(_useState13, 2),
	      numNota = _useState14[0],
	      setNumNota = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(""),
	      _useState16 = _slicedToArray(_useState15, 2),
	      cedRif = _useState16[0],
	      setCedRif = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(""),
	      _useState18 = _slicedToArray(_useState17, 2),
	      nomVendedor = _useState18[0],
	      setNomVendedor = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(""),
	      _useState20 = _slicedToArray(_useState19, 2),
	      idCliente = _useState20[0],
	      setIdCliente = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(""),
	      _useState22 = _slicedToArray(_useState21, 2),
	      nomCliente = _useState22[0],
	      setNomCliente = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(""),
	      _useState24 = _slicedToArray(_useState23, 2),
	      dirCliente = _useState24[0],
	      setDirCliente = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(0),
	      _useState26 = _slicedToArray(_useState25, 2),
	      visible = _useState26[0],
	      setVisible = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      desde = _useState28[0],
	      setDesde = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      habilitarMoneda = _useState30[0],
	      setHabilitarMoneda = _useState30[1];
	
	  var _useState31 = (0, _react.useState)([]),
	      _useState32 = _slicedToArray(_useState31, 2),
	      combomoneda = _useState32[0],
	      setComboMoneda = _useState32[1];
	
	  var _useState33 = (0, _react.useState)("Gestionar Nota de Credito."),
	      _useState34 = _slicedToArray(_useState33, 2),
	      tituloHeader = _useState34[0],
	      setTituloHeader = _useState34[1];
	
	  var _useState35 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState36 = _slicedToArray(_useState35, 2),
	      mensaje = _useState36[0],
	      setMensaje = _useState36[1];
	
	  var _useState37 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState38 = _slicedToArray(_useState37, 2),
	      mensajesino = _useState38[0],
	      setMensajesino = _useState38[1];
	
	  var _useState39 = (0, _react.useState)({
	    idmoneda: "1",
	    descripcion: "BOLIVARES",
	    simbolo: "Bs",
	    predeterminada: true,
	    subpredeterminada: false,
	    valormoneda: 1.0
	  }),
	      _useState40 = _slicedToArray(_useState39, 2),
	      moneda = _useState40[0],
	      setMoneda = _useState40[1];
	
	  var _useState41 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState42 = _slicedToArray(_useState41, 2),
	      monedaSub = _useState42[0],
	      setMonedaSub = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(false),
	      _useState44 = _slicedToArray(_useState43, 2),
	      catalogoCliente = _useState44[0],
	      setCatalogoCliente = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(false),
	      _useState46 = _slicedToArray(_useState45, 2),
	      catalogoNota = _useState46[0],
	      setCatalogoNota = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(false),
	      _useState48 = _slicedToArray(_useState47, 2),
	      activate = _useState48[0],
	      setActivate = _useState48[1];
	
	  var _useState49 = (0, _react.useState)("visible"),
	      _useState50 = _slicedToArray(_useState49, 2),
	      visibleBtn = _useState50[0],
	      setVisibleBtn = _useState50[1];
	
	  var handleInputNumeroChange = function handleInputNumeroChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "idnotaentre") {
	          seleccionarRegistro();
	        }
	      }
	    }
	  };
	
	  var validarCliente = function validarCliente(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (cmbRif.current.value !== "" && event.target.value !== "") {
	        var rif = cmbRif.current.value + event.target.value;
	        seleccionarCliente(rif, event.which);
	      }
	    }
	  };
	
	  var blanquear = function blanquear() {
	    setTituloHeader("Gestionar Notas de Debito.");
	    setBody();
	    setActivate(false);
	    setOperacion(0);
	    setHabilitado(false);
	    setHabilitarMoneda(false);
	    setHabilitadoCli(false);
	    setHabilitadoBot(true);
	    setHabilitarCat(true);
	    setVisible(0);
	    cmbMoneda.current.selectedIndex = -1;
	    setVisibleBtn("visible");
	    setMoneda({
	      idmoneda: "1",
	      descripcion: "BOLIVARES",
	      simbolo: "Bs",
	      predeterminada: false,
	      valormoneda: 1.0
	    });
	    txtIdNotaEntrega.current.value = "";
	    txtFechaVencimiento.current.value = "";
	    txtIdNotaEntrega.current.setAttribute("disabled", true);
	    cmbRif.current.selectedIndex = -1;
	    txtRif.current.value = "";
	    setNumNota("");
	    setNomCliente("");
	    setDirCliente("");
	    setNomVendedor("");
	    setCedRif("");
	    txtFecha.current.value = "";
	    txtMontoTotal.current.value = "0,00";
	    txtTotalDivisa.current.value = "0,00";
	    txtConcepto.current.value = "";
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/inventario/actualizarnotaentrega/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idnotaent + " creado correctamente",
	            icono: "exito"
	          });
	          window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=ReportNotaCredito&idnota=" + response.data.idnotaent, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	        } else if (operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idnotaent + " modificado correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idnotaent + " eliminado correctamente",
	            icono: "exito"
	          });
	        }
	        blanquear();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = error.response.data.message;
	
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var validarCantidad = function validarCantidad(event) {
	    (0, _varios.validaMonto)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	        event.target.value = "0,00";
	      }
	      event.target.value = (0, _varios.formatoMonto)(event.target.value);
	      var char1 = event.target.value.substring(0, 1);
	      var char2 = event.target.value.substring(1, 2);
	      if (char1 === "0" && char2 !== ",") {
	        event.target.value = event.target.value.substring(1, event.target.value.length);
	      }
	      var precio = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	      precio = precio * moneda.valormoneda;
	      txtMontoTotal.current.value = (0, _varios.formatMoneda)(precio.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var onCambioMoneda = function onCambioMoneda(values) {
	    var totaldivisa = 0.0;
	    var precio = 0.0;
	
	    totaldivisa = parseFloat(txtTotalDivisa.current.value.replace(/\./g, "").replace(",", "."));
	    precio = totaldivisa * parseFloat(values.valormoneda);
	
	    txtMontoTotal.current.value = (0, _varios.formatMoneda)(precio.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    if (desde === 1) {
	      setDesde(0);
	    } else if (desde === 2) {
	      setDesde(0);
	      procesarRegistro();
	    }
	  };
	
	  var handleCloseMensaje = function handleCloseMensaje() {
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    if (desde === 3) {
	      setDesde(0);
	      window.location.href = "/inicio";
	    } else if (desde === 4) {
	      setDesde(0);
	      txtIdNotaEntrega.current.focus();
	    }
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "tipo") {
	      e.target.value = e.target.value.toUpperCase();
	      txtIdPedido.current.value = "";
	      txtRif.current.value = "";
	      cmbRif.current.selectedIndex = -1;
	      cmbMoneda.current.selectedIndex = 0;
	      setIdCliente();
	      setNomCliente("");
	      setDirCliente("");
	      txtSubTotal.current.value = "";
	      txtTotIva.current.value = "";
	      txtTotal.current.value = "";
	      txtDescuento.current.value = "";
	
	      if (e.target.value === "1") {
	        setHabilitadoCli(true);
	
	        setHabilitarMoneda(true);
	      } else {
	        setHabilitadoCli(false);
	
	        setHabilitarMoneda(false);
	      }
	    } else if (e.target.name === "cedula") {
	      setIdCliente();
	      setNomCliente("");
	      setDirCliente("");
	    } else if (e.target.name === "idpedi") {
	      setNomCliente("");
	      setDirCliente("");
	      txtFecha.current.value = "";
	      cmbMoneda.current.selectedIndex = 0;
	    }
	  };
	
	  var seleccionarCliente = function seleccionarCliente(rif, tecla) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "rif";
	    var nomid2 = "cliente";
	    var id = rif;
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          cmbRif.current.value = response.data.rif.trim().substring(0, 1);
	          txtRif.current.value = response.data.rif.trim().substring(1, 10);
	          setIdCliente(response.data.idagente);
	          setNomCliente(response.data.nombre);
	          setDirCliente(response.data.direccion.trim());
	          if (tecla === 13) {
	            txtFecha.current.focus();
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un cliente con este codigo",
	            icono: "informacion"
	          });
	          txtRif.current.value = "";
	          cmbRif.current.selectedIndex = -1;
	          if (tecla === 13) {
	            txtRif.current.focus();
	          }
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarVendedor = function seleccionarVendedor(idv) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "idagente";
	    var nomid2 = "vendedor";
	    var id = idv === null ? "0" : idv;
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setCedRif(response.data.rif);
	          setNomVendedor(response.data.nombre);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El usuario no tiene un vendedor asociado",
	            icono: "informacion"
	          });
	          blanquear();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = "n.*, n.descripcion as concepto, m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor";
	    var nomtab = "notaentrega as n inner join moneda m  on n.idmoneda=m.idmoneda left join monedadetalle as md on m.idmoneda=md.idmoneda";
	    var nomid = "md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda) and idnotaentrega ";
	
	    var id = txtIdNotaEntrega.current.value;
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=tipo&id2=NC";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          if (response.data.status === 1 && (operacion === 2 || operacion === 3)) {
	            setDesde(4);
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La Nota de Entrega ya tiene factura asociada.",
	              icono: "informacion"
	            });
	            setActivate(false);
	            txtIdNotaEntrega.current.value = "";
	            txtIdNotaEntrega.current.focus();
	            return;
	          }
	          txtIdNotaEntrega.current.setAttribute("disabled", true);
	          setHabilitarCat(true);
	          setVisible(0);
	          if (operacion === 2) {
	            setHabilitadoCli(true);
	
	            setHabilitarMoneda(true);
	          } else {
	            setHabilitadoCli(false);
	          }
	
	          txtFecha.current.value = (0, _moment2.default)(response.data.fecha).format("YYYY-MM-DD");
	          txtFechaVencimiento.current.value = (0, _moment2.default)(response.data.fechavencimiento).format("YYYY-MM-DD");
	          setNumNota(response.data.numnotaentrega);
	          cmbRif.current.value = response.data.cedularif.trim().substring(0, 1);
	          txtRif.current.value = response.data.cedularif.trim().substring(1, 10);
	          setMoneda({
	            idmoneda: response.data.idmoneda,
	            descripcion: response.data.descripcion,
	            simbolo: response.data.simbolo,
	            predeterminada: response.data.predeterminada,
	            subpredeterminada: response.data.subpredeterminada,
	            valormoneda: response.data.valor
	          });
	          cmbMoneda.current.value = response.data.idmoneda;
	          txtConcepto.current.value = response.data.concepto;
	          txtTotalDivisa.current.value = (0, _varios.formatMoneda)(response.data.totalmonto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          var tot = response.data.totalmonto * response.data.valor;
	          txtMontoTotal.current.value = (0, _varios.formatMoneda)(tot.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          seleccionarCliente(response.data.cedularif, 46);
	          seleccionarVendedor(response.data.idvendedor);
	          if (operacion === 2) {
	            setHabilitado(true);
	            setTimeout(function () {
	              return txtFecha.current.focus();
	            }, 200);
	          } else {
	            setHabilitado(false);
	            setTimeout(function () {
	              return btnCancela.current.focus();
	            }, 200);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "ID no existe.",
	            icono: "informacion"
	          });
	          txtIdNotaEntrega.current.value = "";
	          txtIdNotaEntrega.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var onCatalogoCliente = function onCatalogoCliente(values) {
	    setCatalogoCliente(false);
	    cmbRif.current.value = values.rif.substring(0, 1);
	    txtRif.current.value = values.rif.substring(1);
	    setIdCliente(values.idagente);
	    setNomCliente(values.nombre);
	    setDirCliente(values.direccion);
	  };
	
	  var onCatalogoNotaEntrega = function onCatalogoNotaEntrega(values) {
	    setCatalogoNota(false);
	    txtIdNotaEntrega.current.value = values.idnotaentrega;
	    seleccionarRegistro();
	  };
	
	  var onChangeMoneda = function onChangeMoneda(e) {
	    var i = combomoneda.filter(function (moneda) {
	      return moneda.idmoneda === e.target.value;
	    });
	
	    setMoneda(i[0]);
	    onCambioMoneda(i[0]);
	  };
	
	  var seleccionarMonedas = function seleccionarMonedas() {
	    var campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	    var nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	    var orden = "m.idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setComboMoneda(response.data);
	          setMoneda(response.data[0]);
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].subpredeterminada) {
	              setMonedaSub(response.data[i]);
	            }
	          }
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	
	    if (txtIdNotaEntrega.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Código no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtIdNotaEntrega.current.focus();
	    } else if (cmbRif.current.value === "" || txtRif.current.value.trim() === "" || nomCliente === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Cliente no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtRif.current.focus();
	    } else if (txtFecha.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtFecha.current.focus();
	    } else if (txtFechaVencimiento.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha de Vencimiento no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtFechaVencimiento.current.focus();
	    } else if (txtMontoTotal.current.value === "" || txtMontoTotal.current.value === "0,00") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Monto no debe estar vacio ni estar en 0,00",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtMontoTotal.current.focus();
	    } else if (txtConcepto.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Concepto no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtConcepto.current.focus();
	    }
	    if (sigue) {
	      var notae = [];
	      notae.push({
	        idnotaentrega: txtIdNotaEntrega.current.value,
	        numnotaentrega: numNota,
	        descripcion: txtConcepto.current.value,
	        tipo: "NC",
	        cedularif: cmbRif.current.value + txtRif.current.value,
	        totalmonto: parseFloat(txtTotalDivisa.current.value.replace(/\./g, "").replace(",", ".")),
	        totaliva: 0.0,
	        totaldescuento: 0.0,
	        idpedido: null,
	        idcliente: idCliente,
	        idvendedor: idVendedor,
	        fecha: txtFecha.current.value,
	        status: "0",
	        idmoneda: monedaSub.idmoneda,
	        idoperacioninventario: "",
	        credito: true,
	        fechavencimiento: txtFechaVencimiento.current.value,
	        valormoneda: monedaSub.valormoneda
	      });
	
	      setBody({
	        notaentre: notae,
	        notaentredet: [],
	        idtipopeinv: "2",
	        opeinv: [],
	        opeinvdet: []
	      });
	
	      setDesde(2);
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (accbtnndebito && accbtnndebito.toString().substring(0, 1) === "1") {
	          setTituloHeader("Incluir Nota de Credito.");
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          setHabilitado(true);
	          setHabilitadoCli(true);
	          setHabilitarMoneda(true);
	          txtIdNotaEntrega.current.setAttribute("disabled", true);
	          seleccionarVendedor(idVendedor);
	          setHabilitarCat(true);
	          cmbMoneda.current.selectedIndex = 0;
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          txtFechaVencimiento.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          txtIdNotaEntrega.current.value = "0";
	          txtIdNotaEntrega.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (accbtnndebito && accbtnndebito.toString().substring(1, 2) === "1") {
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setTituloHeader("Editar Nota de Credito.");
	          setOperacion(op);
	          txtIdNotaEntrega.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          txtIdNotaEntrega.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (accbtnndebito && accbtnndebito.toString().substring(3, 4) === "1") {
	          setTituloHeader("Eliminar Nota de Credito.");
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          txtIdNotaEntrega.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitarMoneda(false);
	          setHabilitado(false);
	          setHabilitadoCli(false);
	          txtIdNotaEntrega.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (accbtnndebito && accbtnndebito.toString().substring(2, 3) === "1") {
	          setTituloHeader("Consultar Nota de Credito.");
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          txtIdNotaEntrega.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitado(false);
	          setHabilitarMoneda(true);
	          setHabilitadoCli(false);
	          txtIdNotaEntrega.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        blanquear();
	      }
	    };
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    event.preventDefault();
	    if (event.which === 13) {
	      if (event.target.name === "fecha") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	        btnProducto.current.focus();
	      } else if (event.target.name === "dias") {
	        var dias = txtDias.current.value;
	        if (txtDias.current.value > 0) {
	          var fechaV = (0, _moment2.default)(fechasistema).add(dias.toString(), "days").format("YYYY-MM-DD");
	          var cambia = event.target.value;
	          var dd = dias === cambia ? cambia : txtFechaVencimiento.current.value.substring(8, 10);
	
	          if (event.target.value !== dd) {
	            var _fechaV = (0, _moment2.default)(fechasistema).add(dias.toString(), "days").format("YYYY-MM-DD");
	          }
	        }
	      }
	    } else if (typeof event.which === "undefined") {
	      if (event.target.name === "fecha") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarMonedas();
	  }, []);
	
	  var imprimirNotaDebito = function imprimirNotaDebito() {
	    if (accbtnndebito && accbtnndebito.toString().substring(4, 5) === "1") {
	      var debt = 0;
	      if (txtIdNotaEntrega.current.value !== "") {
	        var idnot = txtIdNotaEntrega.current.value;
	
	        var reporte = "ReportNotaCredito";
	
	        window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&idnota=" + idnot, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Seleccione la nota de de Credito !",
	          icono: "informacion"
	        });
	        debt = 1;
	      }
	
	      if (debt === 1) {
	        txtIdNotaEntrega.current.focus();
	      }
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 ", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-11 mx-auto py-2 card shadow h-100 mt-5" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row border-azul mx-auto justify-content-between rounded py-1" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 row mx-auto d-flex justify-content-between mb-1",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light justify-content-between" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-4" },
	                  _react2.default.createElement(
	                    "h3",
	                    null,
	                    tituloHeader
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-3 d-flex justify-content-end" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/inicio", className: "text-light " },
	                    _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "fw-bold" },
	                      "Salir"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "colfull col220 mb-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CODIGO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    autoComplete: "off",
	                    ref: txtIdNotaEntrega,
	                    name: "idnotaentre",
	                    onKeyUp: handleInputNumeroChange,
	                    onBlur: handleInputNumeroChange,
	                    className: "form-control form-control-lg",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: habilitarCat,
	                      type: "button",
	                      onClick: function onClick() {
	                        return setCatalogoNota(true);
	                      },
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "colfull col400 mb-1" },
	                _react2.default.createElement(
	                  "label",
	                  { className: "text-left" },
	                  "NOTA DE CREDITO N\xB0:",
	                  " ",
	                  _react2.default.createElement(
	                    "span",
	                    { className: "col fw-bold text-danger" },
	                    "\xA0",
	                    numNota
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 row mx-auto d-flex justify-content-between mb-1",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "colfull col320 mb-3" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO MONEDA:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-control form-control-sm fs-6 text-center fw-bold",
	                      disabled: !habilitarMoneda,
	                      ref: cmbMoneda,
	                      onChange: onChangeMoneda
	                    },
	                    combomoneda && combomoneda.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idmoneda },
	                        " ",
	                        item.descripcion + " " + item.simbolo + " " + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                        " "
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-240 ml-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA:"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "date",
	                    disabled: !habilitado,
	                    ref: txtFecha,
	                    className: "form-control text-uppercase fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    name: "fecha",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-370 ml-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA DE VENCIMIENTO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    disabled: !habilitado,
	                    type: "date",
	                    ref: txtFechaVencimiento,
	                    className: "form-control text-uppercase fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    name: "fechav"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "colfull1070 colfull60p mx-auto mb-1 py-1",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row border-azul rounded py-2" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold mb-1" },
	                  "Datos del Cliente"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-5" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: cmbRif,
	                      name: "cmbrif",
	                      disabled: !habilitadoCli,
	                      className: "form-select form-select-sm col-md-3 text-center ",
	                      "aria-label": ".form-select-sm example",
	                      onChange: onChange
	                    },
	                    _varios.cmbCedula && _varios.cmbCedula.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.value },
	                        item.value
	                      );
	                    })
	                  ),
	                  _react2.default.createElement("input", {
	                    ref: txtRif,
	                    autoComplete: "off",
	                    disabled: !habilitadoCli,
	                    maxLength: 9,
	                    type: "text",
	                    className: "form-control fs-6",
	                    name: "cedula",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: validarCliente,
	                    onBlur: validarCliente,
	                    onChange: onChange
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoCli,
	                      type: "button",
	                      onClick: function onClick() {
	                        return setCatalogoCliente(true);
	                      },
	                      className: "btn btn-success",
	                      style: {
	                        visibility: visible === 0 ? "visible" : "hidden"
	                      }
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-7" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "NOMBRE:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: nomCliente
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "DIRECCION:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: dirCliente
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "colfull1070 colfull40p mx-auto mb-1 row py-1",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row border-azul rounded py-2" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold mb-1" },
	                  "Datos del Vendedor"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm col-pd-240 px-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm",
	                      style: { height: "85%" }
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    style: { height: "85%" },
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: cedRif
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm",
	                      style: { height: "85%" }
	                    },
	                    "NOMBRE:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    style: { height: "85%" },
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: nomVendedor
	                  })
	                )
	              ),
	              _react2.default.createElement("div", { className: "col-md-6" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "colfull60p row m-0" },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-md-12 border-azul rounded p-2 shadow",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CONCEPTO:"
	                  ),
	                  _react2.default.createElement("textarea", {
	                    className: "form-control uppercase fs-6",
	                    ref: txtConcepto,
	                    disabled: !habilitado,
	                    "aria-label": "With textarea",
	                    style: { minHeight: 50 },
	                    defaultValue: ""
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-5 ml-auto" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "MONTO TOTAL ",
	                    moneda.descripcion + " " + moneda.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "text",
	                    ref: txtTotalDivisa,
	                    disabled: !habilitado,
	                    onFocus: _varios.seleccionarCampo,
	                    onKeyUp: validarCantidad,
	                    onBlur: validarCantidad,
	                    className: "form-control text-end fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: "0,00"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-5 ml-auto" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "MONTO TOTAL Bs: "
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "text",
	                    ref: txtMontoTotal,
	                    disabled: true
	                    /*                       disabled={!habilitado}
	                    onFocus={seleccionarCampo}
	                    onKeyUp={validarCantidad}
	                    onBlur={validarCantidad} */
	                    , className: "form-control text-end fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: "0,00"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "colfull40p row m-0" },
	              _react2.default.createElement("div", { className: "col-md-12" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 pt-2 pb-2 mt-auto" },
	              visibleBtn === "visible" ? _react2.default.createElement(
	                "div",
	                { className: "col-pd-botones" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 row m-0" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoBot,
	                      ref: btnIncluir,
	                      onClick: onBotones(1),
	                      className: "btn btn-sm col ml-1 mb-1 btn-primary rounded-pill",
	                      title: "Incluir Nota de Entrega"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-plus" },
	                      " Incluir "
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoBot,
	                      ref: btnConsultar,
	                      onClick: onBotones(4),
	                      className: "btn btn-sm col ml-1 mb-1 btn-info rounded-pill",
	                      title: "Consultar Nota de Entrega"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-eye" },
	                      " Consultar"
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoBot,
	                      ref: btnEditar,
	                      onClick: onBotones(2),
	                      className: "btn btn-sm col ml-1 mb-1 btn-warning rounded-pill",
	                      title: "Modificar Nota de Entrega"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-edit" },
	                      " Modificar"
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoBot,
	                      ref: btnEliminar,
	                      onClick: onBotones(3),
	                      className: "btn btn-sm col ml-1 mb-1 btn-danger rounded-pill",
	                      title: "Eliminar Nota de Entrega"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-trash" },
	                      " Eliminar"
	                    ),
	                    " "
	                  )
	                )
	              ) : _react2.default.createElement(
	                "div",
	                { className: "col-pd-360 row m-0 ml-auto" },
	                operacion === 4 ? _react2.default.createElement(
	                  "button",
	                  {
	                    onClick: imprimirNotaDebito,
	                    disabled: operacion === 4 ? false : true,
	                    className: "btn btn-sm col ml-1 btn-primary rounded-pill",
	                    title: "Imprimir Nota de Entrega"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fa fa-print" },
	                    " Imprimir"
	                  )
	                ) : "",
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta,
	                    disabled: operacion === 4 ? true : habilitadoBot,
	                    onClick: onBotones(5),
	                    className: "btn btn-sm col ml-1 rounded-pill btn-success"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-check-circle" },
	                    " Aceptar"
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnCancela,
	                    disabled: habilitadoBot,
	                    onClick: onBotones(6),
	                    className: "btn btn-danger col ml-1 btn-sm rounded-pill"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-window-close" },
	                    " Cancelar"
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: catalogoCliente,
	      nomid: "cliente",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoCliente(false);
	      },
	      onHideAceptaCatalogo: onCatalogoCliente
	    }),
	    _react2.default.createElement(_catalogoNotaEntrega2.default, {
	      show: catalogoNota,
	      tipo: "NC",
	      tip: "FA",
	      nomid: "notaentrega",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoNota(false);
	      },
	      onHideAceptaCatalogo: onCatalogoNotaEntrega,
	      condicion: "true"
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje, onHide: handleCloseMensaje }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = TablaNotaCredito;

/***/ },
/* 7177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _catalogoNotaEntrega = __webpack_require__(209);
	
	var _catalogoNotaEntrega2 = _interopRequireDefault(_catalogoNotaEntrega);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TablaNotaDebito = function TablaNotaDebito() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var accbtnndebito = JSON.parse(sessionStorage.getItem("accbtnndebitoc"));
	
	  var txtIdNotaEntrega = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtConcepto = (0, _react.useRef)();
	  var txtMontoTotal = (0, _react.useRef)();
	  var btnIncluir = (0, _react.useRef)();
	  var btnEditar = (0, _react.useRef)();
	  var btnEliminar = (0, _react.useRef)();
	  var btnConsultar = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnProducto = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtSubTotal = (0, _react.useRef)();
	  var txtDescuento = (0, _react.useRef)();
	  var txtTotIva = (0, _react.useRef)();
	  var txtTotal = (0, _react.useRef)();
	  var txtTotalDivisa = (0, _react.useRef)();
	  var txtIdPedido = (0, _react.useRef)();
	  var cmbMoneda = (0, _react.useRef)();
	  var txtDias = (0, _react.useRef)();
	  var txtFechaVencimiento = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      body = _useState2[0],
	      setBody = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      operacion = _useState4[0],
	      setOperacion = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      habilitado = _useState6[0],
	      setHabilitado = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(true),
	      _useState8 = _slicedToArray(_useState7, 2),
	      habilitarCat = _useState8[0],
	      setHabilitarCat = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(true),
	      _useState10 = _slicedToArray(_useState9, 2),
	      habilitadoBot = _useState10[0],
	      setHabilitadoBot = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      habilitadoCli = _useState12[0],
	      setHabilitadoCli = _useState12[1];
	
	  var _useState13 = (0, _react.useState)("0"),
	      _useState14 = _slicedToArray(_useState13, 2),
	      idNota = _useState14[0],
	      setIdNota = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(""),
	      _useState16 = _slicedToArray(_useState15, 2),
	      cedRif = _useState16[0],
	      setCedRif = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(""),
	      _useState18 = _slicedToArray(_useState17, 2),
	      nomVendedor = _useState18[0],
	      setNomVendedor = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(""),
	      _useState20 = _slicedToArray(_useState19, 2),
	      idCliente = _useState20[0],
	      setIdCliente = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(""),
	      _useState22 = _slicedToArray(_useState21, 2),
	      nomCliente = _useState22[0],
	      setNomCliente = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(""),
	      _useState24 = _slicedToArray(_useState23, 2),
	      dirCliente = _useState24[0],
	      setDirCliente = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(0),
	      _useState26 = _slicedToArray(_useState25, 2),
	      visible = _useState26[0],
	      setVisible = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      desde = _useState28[0],
	      setDesde = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      habilitarMoneda = _useState30[0],
	      setHabilitarMoneda = _useState30[1];
	
	  var _useState31 = (0, _react.useState)([]),
	      _useState32 = _slicedToArray(_useState31, 2),
	      combomoneda = _useState32[0],
	      setComboMoneda = _useState32[1];
	
	  var _useState33 = (0, _react.useState)("Gestionar Nota de Debito."),
	      _useState34 = _slicedToArray(_useState33, 2),
	      tituloHeader = _useState34[0],
	      setTituloHeader = _useState34[1];
	
	  var _useState35 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState36 = _slicedToArray(_useState35, 2),
	      mensaje = _useState36[0],
	      setMensaje = _useState36[1];
	
	  var _useState37 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState38 = _slicedToArray(_useState37, 2),
	      mensajesino = _useState38[0],
	      setMensajesino = _useState38[1];
	
	  var _useState39 = (0, _react.useState)({
	    idmoneda: "1",
	    descripcion: "BOLIVARES",
	    simbolo: "Bs",
	    predeterminada: true,
	    subpredeterminada: false,
	    valormoneda: 1.0
	  }),
	      _useState40 = _slicedToArray(_useState39, 2),
	      moneda = _useState40[0],
	      setMoneda = _useState40[1];
	
	  var _useState41 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState42 = _slicedToArray(_useState41, 2),
	      monedaSub = _useState42[0],
	      setMonedaSub = _useState42[1];
	  /*   const [notaentrega, setNotaEntrega] = useState({
	    idnotaentrega: "0",
	    numnotaentrega: "000000",
	    cedularif: "",
	    descripcion: "NOTA DE DEBITO",
	    totalmonto: 0.0,
	    totaliva: 0.0,
	    totaldescuento: 0.0,
	    totalexento: 0.0,
	    totalsujeto: 0.0,
	    idcliente: "",
	    idvendedor: "",
	    fecha: moment(fechasistema).format("YYYY-MM-DD"),
	    status: 0,
	    idalmacen: "",
	    idmoneda: "",
	    idoperacioninventario: "",
	    idpedido: "",
	    numpedido: "",
	    tipo: "ND",
	    credito: false,
	    fechavencimiento: moment(fechasistema).format("YYYY-MM-DD"),
	    valormoneda: 0.0,
	  }); */
	
	  var _useState43 = (0, _react.useState)(false),
	      _useState44 = _slicedToArray(_useState43, 2),
	      catalogoCliente = _useState44[0],
	      setCatalogoCliente = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(false),
	      _useState46 = _slicedToArray(_useState45, 2),
	      catalogoNota = _useState46[0],
	      setCatalogoNota = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(false),
	      _useState48 = _slicedToArray(_useState47, 2),
	      activate = _useState48[0],
	      setActivate = _useState48[1];
	
	  var _useState49 = (0, _react.useState)("visible"),
	      _useState50 = _slicedToArray(_useState49, 2),
	      visibleBtn = _useState50[0],
	      setVisibleBtn = _useState50[1];
	
	  var handleInputNumeroChange = function handleInputNumeroChange(event) {
	    event.preventDefault();
	    // validaSoloNumero(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "idnotaentre") {
	          seleccionarRegistro();
	        }
	      }
	    }
	  };
	
	  var validarCliente = function validarCliente(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (cmbRif.current.value !== "" && event.target.value !== "") {
	        var rif = cmbRif.current.value + event.target.value;
	        seleccionarCliente(rif, event.which);
	      }
	    }
	  };
	
	  var blanquear = function blanquear() {
	    setTituloHeader("Gestionar Notas de Debito.");
	    setBody();
	    setActivate(false);
	    setOperacion(0);
	    setHabilitado(false);
	    setHabilitarMoneda(false);
	    setHabilitadoCli(false);
	    setHabilitadoBot(true);
	    setHabilitarCat(true);
	    setVisible(0);
	    setIdNota("0");
	    cmbMoneda.current.selectedIndex = -1;
	    setVisibleBtn("visible");
	    setMoneda({
	      idmoneda: "1",
	      descripcion: "BOLIVARES",
	      simbolo: "Bs",
	      predeterminada: false,
	      valormoneda: 1.0
	    });
	    if (operacion !== 1) {
	      txtIdNotaEntrega.current.value = "";
	      txtIdNotaEntrega.current.setAttribute("disabled", true);
	    }
	
	    txtFechaVencimiento.current.value = "";
	    cmbRif.current.selectedIndex = -1;
	    txtRif.current.value = "";
	    setNomCliente("");
	    setDirCliente("");
	    setNomVendedor("");
	    setCedRif("");
	    /*     setNotaEntrega({
	      idnotaentrega: "0",
	      numnotaentrega: "000000",
	      cedularif: "",
	      descripcion: "NOTA DE DEBITO",
	      totalmonto: 0.0,
	      totaliva: 0.0,
	      totaldescuento: 0.0,
	      totalexento: 0.0,
	      totalsujeto: 0.0,
	      idcliente: "",
	      idvendedor: "",
	      fecha: moment(fechasistema).format("YYYY-MM-DD"),
	      status: 0,
	      idalmacen: "",
	      idmoneda: "",
	      idoperacioninventario: "",
	      idpedido: "",
	      numpedido: "",
	      tipo: "ND",
	      credito: false,
	      fechavencimiento: moment(fechasistema).format("YYYY-MM-DD"),
	      valormoneda: 0.0,
	    }); */
	    txtFecha.current.value = "";
	    txtMontoTotal.current.value = "0,00";
	    txtTotalDivisa.current.value = "0,00";
	    txtConcepto.current.value = "";
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/inventario/actualizarnotaentrega/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idnotaent + " creado correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idnotaent + " modificado correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idnotaent + " eliminado correctamente",
	            icono: "exito"
	          });
	        }
	        blanquear();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = error.response.data.message;
	
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var validarCantidad = function validarCantidad(event) {
	    (0, _varios.validaMonto)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	        event.target.value = "0,00";
	      }
	      event.target.value = (0, _varios.formatoMonto)(event.target.value);
	      var char1 = event.target.value.substring(0, 1);
	      var char2 = event.target.value.substring(1, 2);
	      if (char1 === "0" && char2 !== ",") {
	        event.target.value = event.target.value.substring(1, event.target.value.length);
	      }
	      var precio = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	      precio = precio * moneda.valormoneda;
	      txtMontoTotal.current.value = (0, _varios.formatMoneda)(precio.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var onCambioMoneda = function onCambioMoneda(values) {
	    var totaldivisa = 0.0;
	    var precio = 0.0;
	
	    totaldivisa = parseFloat(txtTotalDivisa.current.value.replace(/\./g, "").replace(",", "."));
	    precio = totaldivisa * parseFloat(values.valormoneda);
	
	    txtMontoTotal.current.value = (0, _varios.formatMoneda)(precio.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    if (desde === 1) {
	      setDesde(0);
	    } else if (desde === 2) {
	      setDesde(0);
	      procesarRegistro();
	    }
	  };
	
	  var handleCloseMensaje = function handleCloseMensaje() {
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    if (desde === 3) {
	      setDesde(0);
	      window.location.href = "/inicio";
	    } else if (desde === 4) {
	      setDesde(0);
	      txtIdNotaEntrega.current.focus();
	    }
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "tipo") {
	      e.target.value = e.target.value.toUpperCase();
	      txtIdPedido.current.value = "";
	      txtRif.current.value = "";
	      cmbRif.current.selectedIndex = -1;
	      cmbMoneda.current.selectedIndex = 0;
	      setIdCliente();
	      setNomCliente("");
	      setDirCliente("");
	      txtSubTotal.current.value = "";
	      txtTotIva.current.value = "";
	      txtTotal.current.value = "";
	      txtDescuento.current.value = "";
	
	      if (e.target.value === "1") {
	        setHabilitadoCli(true);
	
	        setHabilitarMoneda(true);
	      } else {
	        setHabilitadoCli(false);
	
	        setHabilitarMoneda(false);
	      }
	    } else if (e.target.name === "cedula") {
	      setIdCliente();
	      setNomCliente("");
	      setDirCliente("");
	    } else if (e.target.name === "idpedi") {
	      setNomCliente("");
	      setDirCliente("");
	      txtFecha.current.value = "";
	      cmbMoneda.current.selectedIndex = 0;
	    }
	  };
	
	  var seleccionarCliente = function seleccionarCliente(rif, tecla) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "rif";
	    var nomid2 = "cliente";
	    var id = rif;
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          cmbRif.current.value = response.data.rif.trim().substring(0, 1);
	          txtRif.current.value = response.data.rif.trim().substring(1, 10);
	          setIdCliente(response.data.idagente);
	          setNomCliente(response.data.nombre);
	          setDirCliente(response.data.direccion.trim());
	          if (tecla === 13) {
	            txtFecha.current.focus();
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un cliente con este codigo",
	            icono: "informacion"
	          });
	          txtRif.current.value = "";
	          cmbRif.current.selectedIndex = -1;
	          if (tecla === 13) {
	            txtRif.current.focus();
	          }
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarVendedor = function seleccionarVendedor(idv) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "idagente";
	    var nomid2 = "vendedor";
	    var id = idv === null ? "0" : idv;
	    var endpoint = "";
	
	    endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setCedRif(response.data.rif);
	          setNomVendedor(response.data.nombre);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "El usuario no tiene un vendedor asociado",
	            icono: "informacion"
	          });
	          blanquear();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = "n.*, n.descripcion as concepto, m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor";
	    var nomtab = "notaentrega as n inner join moneda m  on n.idmoneda=m.idmoneda left join monedadetalle as md on m.idmoneda=md.idmoneda";
	    var nomid = "md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda) and numnotaentrega ";
	    var id = txtIdNotaEntrega.current.value;
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=tipo&id2=ND";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          if (response.data.status === 1 && (operacion === 2 || operacion === 3)) {
	            setDesde(4);
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La Nota de Entrega ya tiene factura asociada.",
	              icono: "informacion"
	            });
	            setActivate(false);
	            txtIdNotaEntrega.current.value = "";
	            txtIdNotaEntrega.current.focus();
	            return;
	          }
	          txtIdNotaEntrega.current.setAttribute("disabled", true);
	          /*             setNotaEntrega({
	            idnotaentrega: response.data.idnotaentrega,
	            numnotaentrega: response.data.numnotaentrega,
	            cedularif: response.data.cedularif,
	            descripcion: response.data.descripcion,
	            totalmonto: response.data.totalmonto,
	            totaliva: response.data.totaliva,
	            totaldescuento: response.data.totaldescuento,
	            totalexento: response.data.totalexento,
	            totalsujeto: response.data.totalsujeto,
	            idcliente: response.data.idcliente,
	            idvendedor: response.data.idvendedor,
	            fecha: moment(response.data.fecha).format("YYYY-MM-DD"),
	            status: response.data.status,
	            idalmacen: response.data.idalmacen,
	            idmoneda: response.data.idmoneda,
	            idoperacioninventario: response.data.idoperacioninventario,
	            idpedido: response.data.idpedido,
	            numpedido: response.data.numpedido,
	            tipo: response.data.tipo,
	            credito: response.data.credito,
	            fechavencimiento: moment(response.data.fechavencimiento).format(
	              "YYYY-MM-DD"
	            ),
	            valormoneda: response.data.valormoneda,
	          }); */
	          setHabilitarCat(true);
	          setVisible(0);
	          if (operacion === 2) {
	            setHabilitadoCli(true);
	
	            setHabilitarMoneda(true);
	          } else {
	            setHabilitadoCli(false);
	          }
	
	          txtFecha.current.value = (0, _moment2.default)(response.data.fecha).format("YYYY-MM-DD");
	          txtFechaVencimiento.current.value = (0, _moment2.default)(response.data.fechavencimiento).format("YYYY-MM-DD");
	          setIdNota(response.data.idnotaentrega);
	          cmbRif.current.value = response.data.cedularif.trim().substring(0, 1);
	          txtRif.current.value = response.data.cedularif.trim().substring(1, 10);
	          setMoneda({
	            idmoneda: response.data.idmoneda,
	            descripcion: response.data.descripcion,
	            simbolo: response.data.simbolo,
	            predeterminada: response.data.predeterminada,
	            subpredeterminada: response.data.subpredeterminada,
	            valormoneda: response.data.valor
	          });
	          cmbMoneda.current.value = response.data.idmoneda;
	          txtConcepto.current.value = response.data.concepto;
	          txtTotalDivisa.current.value = (0, _varios.formatMoneda)(response.data.totalmonto.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          var tot = response.data.totalmonto * response.data.valor;
	          txtMontoTotal.current.value = (0, _varios.formatMoneda)(tot.toString().replace(",", "").replace(".", ","), ",", ".", 2);
	          seleccionarCliente(response.data.cedularif, 46);
	          seleccionarVendedor(response.data.idvendedor);
	          if (operacion === 2) {
	            setHabilitado(true);
	            setTimeout(function () {
	              return txtFecha.current.focus();
	            }, 200);
	          } else {
	            setHabilitado(false);
	            setTimeout(function () {
	              return btnCancela.current.focus();
	            }, 200);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "no existe una nota de debito con ese codigo.",
	            icono: "informacion"
	          });
	          setIdNota("0");
	          txtIdNotaEntrega.current.value = "";
	          txtIdNotaEntrega.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var onCatalogoCliente = function onCatalogoCliente(values) {
	    setCatalogoCliente(false);
	    cmbRif.current.value = values.rif.substring(0, 1);
	    txtRif.current.value = values.rif.substring(1);
	    setIdCliente(values.idagente);
	    setNomCliente(values.nombre);
	    setDirCliente(values.direccion);
	  };
	
	  var onCatalogoNotaEntrega = function onCatalogoNotaEntrega(values) {
	    setCatalogoNota(false);
	    txtIdNotaEntrega.current.value = values.numnotaentrega;
	    seleccionarRegistro();
	  };
	
	  var onChangeMoneda = function onChangeMoneda(e) {
	    var i = combomoneda.filter(function (moneda) {
	      return moneda.idmoneda === e.target.value;
	    });
	
	    setMoneda(i[0]);
	    onCambioMoneda(i[0]);
	  };
	
	  var seleccionarMonedas = function seleccionarMonedas() {
	    var campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	    var nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	    var orden = "m.idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setComboMoneda(response.data);
	          setMoneda(response.data[0]);
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].subpredeterminada) {
	              setMonedaSub(response.data[i]);
	            }
	          }
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	
	    /* if (txtIdNotaEntrega.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Código no debe estar vacio",
	        icono: "informacion",
	      });
	      sigue = false;
	      txtIdNotaEntrega.current.focus();
	    } else */if (cmbRif.current.value === "" || txtRif.current.value.trim() === "" || nomCliente === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Cliente no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtRif.current.focus();
	    } else if (txtFecha.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtFecha.current.focus();
	    } else if (txtFechaVencimiento.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha de Vencimiento no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtFechaVencimiento.current.focus();
	    } else if (txtMontoTotal.current.value === "" || txtMontoTotal.current.value === "0,00") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Monto no debe estar vacio ni estar en 0,00",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtMontoTotal.current.focus();
	    } else if (txtConcepto.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Concepto no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtConcepto.current.focus();
	    }
	    if (sigue) {
	      var notae = [];
	
	      notae.push({
	        idnotaentrega: idNota,
	        numnotaentrega: operacion !== 1 ? txtIdNotaEntrega.current.value : "",
	        descripcion: txtConcepto.current.value,
	        tipo: "ND",
	        cedularif: cmbRif.current.value + txtRif.current.value,
	        totalmonto: parseFloat(txtTotalDivisa.current.value.replace(/\./g, "").replace(",", ".")),
	        totaliva: 0.0,
	        totaldescuento: 0.0,
	        idpedido: null,
	        idcliente: idCliente,
	        idvendedor: idVendedor,
	        fecha: txtFecha.current.value,
	        status: "0",
	        idmoneda: monedaSub.idmoneda,
	        idoperacioninventario: "",
	        credito: true,
	        fechavencimiento: txtFechaVencimiento.current.value,
	        valormoneda: monedaSub.valormoneda
	      });
	
	      setBody({
	        notaentre: notae,
	        notaentredet: [],
	        idtipopeinv: "2",
	        opeinv: [],
	        opeinvdet: []
	      });
	
	      setDesde(2);
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (accbtnndebito && accbtnndebito.toString().substring(0, 1) === "1") {
	          setTituloHeader("Incluir Nota de Debito.");
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          setHabilitado(true);
	          setHabilitadoCli(true);
	          setHabilitarMoneda(true);
	          //txtIdNotaEntrega.current.setAttribute("disabled", true);
	          seleccionarVendedor(idVendedor);
	          setHabilitarCat(true);
	          cmbMoneda.current.selectedIndex = 0;
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          txtFechaVencimiento.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          //txtIdNotaEntrega.current.value = "0";
	          //txtIdNotaEntrega.current.focus();
	          setTimeout(function () {
	            return txtRif.current.focus();
	          }, 300);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (accbtnndebito && accbtnndebito.toString().substring(1, 2) === "1") {
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setTituloHeader("Editar Nota de Debito.");
	          setOperacion(op);
	          txtIdNotaEntrega.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          txtIdNotaEntrega.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (accbtnndebito && accbtnndebito.toString().substring(3, 4) === "1") {
	          setTituloHeader("Eliminar Nota de Debito.");
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          txtIdNotaEntrega.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitarMoneda(false);
	          setHabilitado(false);
	          setHabilitadoCli(false);
	          txtIdNotaEntrega.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (accbtnndebito && accbtnndebito.toString().substring(2, 3) === "1") {
	          setTituloHeader("Consultar Nota de Debito.");
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          txtIdNotaEntrega.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitado(false);
	          setHabilitarMoneda(true);
	          setHabilitadoCli(false);
	          txtIdNotaEntrega.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        blanquear();
	      }
	    };
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    event.preventDefault();
	    if (event.which === 13) {
	      if (event.target.name === "fecha") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	        btnProducto.current.focus();
	      } else if (event.target.name === "dias") {
	        var dias = txtDias.current.value;
	        if (txtDias.current.value > 0) {
	          var fechaV = (0, _moment2.default)(fechasistema).add(dias.toString(), "days").format("YYYY-MM-DD");
	          var cambia = event.target.value;
	          var dd = dias === cambia ? cambia : txtFechaVencimiento.current.value.substring(8, 10);
	
	          if (event.target.value !== dd) {
	            var _fechaV = (0, _moment2.default)(fechasistema).add(dias.toString(), "days").format("YYYY-MM-DD");
	          }
	        }
	      }
	    } else if (typeof event.which === "undefined") {
	      if (event.target.name === "fecha") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarMonedas();
	  }, []);
	
	  var imprimirNotaDebito = function imprimirNotaDebito() {
	    if (accbtnndebito && accbtnndebito.toString().substring(4, 5) === "1") {
	      var debt = 0;
	      if (txtIdNotaEntrega.current.value !== "") {
	        var idnot = txtIdNotaEntrega.current.value;
	
	        var reporte = "ReportNotaDebito";
	
	        window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&idnota=" + "'" + idnot + "'", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Seleccione la nota de Debito !",
	          icono: "informacion"
	        });
	        debt = 1;
	      }
	
	      if (debt === 1) {
	        txtIdNotaEntrega.current.focus();
	      }
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 ", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-11 mx-auto py-2 card shadow h-100 mt-5" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row border-azul mx-auto justify-content-between rounded py-1" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 row mx-auto d-flex justify-content-between mb-1",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light justify-content-between" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-4" },
	                  _react2.default.createElement(
	                    "h3",
	                    null,
	                    tituloHeader
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-3 d-flex justify-content-end" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/inicio", className: "text-light " },
	                    _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "fw-bold" },
	                      "Salir"
	                    )
	                  )
	                )
	              ),
	              operacion !== 1 && _react2.default.createElement(
	                "div",
	                { className: "colfull col220 mb-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CODIGO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtIdNotaEntrega,
	                    name: "idnotaentre",
	                    onChange: function onChange(e) {
	                      return e.target.value = e.target.value.toUpperCase();
	                    },
	                    onKeyUp: handleInputNumeroChange,
	                    onBlur: handleInputNumeroChange,
	                    className: "form-control form-control-lg",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: habilitarCat,
	                      type: "button",
	                      onClick: function onClick() {
	                        return setCatalogoNota(true);
	                      },
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 row mx-auto d-flex justify-content-between mb-1",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "colfull col320 mb-3" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO MONEDA:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-control form-control-sm fs-6 text-center fw-bold",
	                      disabled: !habilitarMoneda,
	                      ref: cmbMoneda,
	                      onChange: onChangeMoneda
	                    },
	                    combomoneda && combomoneda.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idmoneda },
	                        " ",
	                        item.descripcion + " " + item.simbolo + " " + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                        " "
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-240 ml-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA:"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "date",
	                    disabled: !habilitado,
	                    ref: txtFecha,
	                    className: "form-control text-uppercase fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    name: "fecha",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-370 ml-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA DE VENCIMIENTO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    disabled: !habilitado,
	                    type: "date",
	                    ref: txtFechaVencimiento,
	                    className: "form-control text-uppercase fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    name: "fechav"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "colfull1070 colfull60p mx-auto mb-1 py-1",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row border-azul rounded py-2" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold mb-1" },
	                  "Datos del Cliente"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-5" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: cmbRif,
	                      name: "cmbrif",
	                      disabled: !habilitadoCli,
	                      className: "form-select form-select-sm col-md-3 text-center ",
	                      "aria-label": ".form-select-sm example",
	                      onChange: onChange
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "--"
	                    ),
	                    _varios.cmbCedula && _varios.cmbCedula.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.value },
	                        item.value
	                      );
	                    })
	                  ),
	                  _react2.default.createElement("input", {
	                    ref: txtRif,
	                    autoComplete: "off",
	                    disabled: !habilitadoCli,
	                    maxLength: 9,
	                    type: "text",
	                    className: "form-control fs-6",
	                    name: "cedula",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: validarCliente,
	                    onBlur: validarCliente,
	                    onChange: onChange
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoCli,
	                      type: "button",
	                      onClick: function onClick() {
	                        return setCatalogoCliente(true);
	                      },
	                      className: "btn btn-success",
	                      style: {
	                        visibility: visible === 0 ? "visible" : "hidden"
	                      }
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-7" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "NOMBRE:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: nomCliente
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "DIRECCION:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: dirCliente
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "colfull1070 colfull40p mx-auto mb-1 row py-1",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row border-azul rounded py-2" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold mb-1" },
	                  "Datos del Vendedor"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm col-pd-240 px-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm",
	                      style: { height: "85%" }
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    style: { height: "85%" },
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: cedRif
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm",
	                      style: { height: "85%" }
	                    },
	                    "NOMBRE:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    style: { height: "85%" },
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: nomVendedor
	                  })
	                )
	              ),
	              _react2.default.createElement("div", { className: "col-md-6" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "colfull60p row m-0" },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-md-12 border-azul rounded p-2 shadow",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CONCEPTO:"
	                  ),
	                  _react2.default.createElement("textarea", {
	                    className: "form-control uppercase fs-6",
	                    ref: txtConcepto,
	                    disabled: !habilitado,
	                    "aria-label": "With textarea",
	                    style: { minHeight: 50 },
	                    defaultValue: ""
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-5 ml-auto" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "MONTO TOTAL ",
	                    moneda.descripcion + " " + moneda.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "text",
	                    ref: txtTotalDivisa,
	                    disabled: !habilitado,
	                    onFocus: _varios.seleccionarCampo,
	                    onKeyUp: validarCantidad,
	                    onBlur: validarCantidad,
	                    className: "form-control text-end fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: "0,00"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-5 ml-auto" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "MONTO TOTAL Bs: "
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "text",
	                    ref: txtMontoTotal,
	                    disabled: true
	                    /*                       disabled={!habilitado}
	                    onFocus={seleccionarCampo}
	                    onKeyUp={validarCantidad}
	                    onBlur={validarCantidad} */
	                    , className: "form-control text-end fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    defaultValue: "0,00"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "colfull40p row m-0" },
	              _react2.default.createElement("div", { className: "col-md-12" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 pt-2 pb-2 mt-auto" },
	              visibleBtn === "visible" ? _react2.default.createElement(
	                "div",
	                { className: "col-pd-botones" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 row m-0" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoBot,
	                      ref: btnIncluir,
	                      onClick: onBotones(1),
	                      className: "btn btn-sm col ml-1 mb-1 btn-primary rounded-pill",
	                      title: "Incluir Nota de Entrega"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-plus" },
	                      " Incluir "
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoBot,
	                      ref: btnConsultar,
	                      onClick: onBotones(4),
	                      className: "btn btn-sm col ml-1 mb-1 btn-info rounded-pill",
	                      title: "Consultar Nota de Entrega"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-eye" },
	                      " Consultar"
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoBot,
	                      ref: btnEditar,
	                      onClick: onBotones(2),
	                      className: "btn btn-sm col ml-1 mb-1 btn-warning rounded-pill",
	                      title: "Modificar Nota de Entrega"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-edit" },
	                      " Modificar"
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoBot,
	                      ref: btnEliminar,
	                      onClick: onBotones(3),
	                      className: "btn btn-sm col ml-1 mb-1 btn-danger rounded-pill",
	                      title: "Eliminar Nota de Entrega"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-trash" },
	                      " Eliminar"
	                    ),
	                    " "
	                  )
	                )
	              ) : _react2.default.createElement(
	                "div",
	                { className: "col-pd-360 row m-0 ml-auto" },
	                operacion === 4 ? _react2.default.createElement(
	                  "button",
	                  {
	                    onClick: imprimirNotaDebito,
	                    disabled: operacion === 4 ? false : true,
	                    className: "btn btn-sm col ml-1 btn-primary rounded-pill",
	                    title: "Imprimir Nota de Entrega"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fa fa-print" },
	                    " Imprimir"
	                  )
	                ) : "",
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta,
	                    disabled: operacion === 4 ? true : habilitadoBot,
	                    onClick: onBotones(5),
	                    className: "btn btn-sm col ml-1 rounded-pill btn-success"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-check-circle" },
	                    " Aceptar"
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnCancela,
	                    disabled: habilitadoBot,
	                    onClick: onBotones(6),
	                    className: "btn btn-danger col ml-1 btn-sm rounded-pill"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-window-close" },
	                    " Cancelar"
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: catalogoCliente,
	      nomid: "cliente",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoCliente(false);
	      },
	      onHideAceptaCatalogo: onCatalogoCliente
	    }),
	    _react2.default.createElement(_catalogoNotaEntrega2.default, {
	      show: catalogoNota,
	      tipo: "ND",
	      tip: "ND",
	      nomid: "notaentrega",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoNota(false);
	      },
	      onHideAceptaCatalogo: onCatalogoNotaEntrega,
	      condicion: "true"
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje, onHide: handleCloseMensaje }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = TablaNotaDebito;

/***/ },
/* 7178 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _core = __webpack_require__(19);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoProductoExistencia = __webpack_require__(105);
	
	var _catalogoProductoExistencia2 = _interopRequireDefault(_catalogoProductoExistencia);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _catalogoNotaEntrega = __webpack_require__(209);
	
	var _catalogoNotaEntrega2 = _interopRequireDefault(_catalogoNotaEntrega);
	
	var _catalogoPedido = __webpack_require__(210);
	
	var _catalogoPedido2 = _interopRequireDefault(_catalogoPedido);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _modalImagenNotaEntrega = __webpack_require__(7163);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var TablaNotaEntrega = function TablaNotaEntrega() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var accbtnnentrega = JSON.parse(sessionStorage.getItem("accbtnnentregac"));
	
	  var txtNumNotaEntrega = (0, _react.useRef)();
	  var txtStatus = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtId = (0, _react.useRef)([]);
	  var txtIdproducto = (0, _react.useRef)([]);
	  var txtCantidad = (0, _react.useRef)([]);
	  var btnIncluir = (0, _react.useRef)();
	  var btnEditar = (0, _react.useRef)();
	  var btnEliminar = (0, _react.useRef)();
	  var btnConsultar = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtNombreC = (0, _react.useRef)();
	  var txtSubTotal = (0, _react.useRef)();
	  var txtExentoTotal = (0, _react.useRef)();
	  var txtDescuento = (0, _react.useRef)();
	  var txtTotIva = (0, _react.useRef)();
	  var txtTotal = (0, _react.useRef)();
	  var txtNumPedido = (0, _react.useRef)();
	  var cmbMoneda = (0, _react.useRef)();
	  var txtFechaVencimiento = (0, _react.useRef)();
	  var cmbTipoPago = (0, _react.useRef)();
	  var cmbDesde = (0, _react.useRef)();
	  var cmbTipo = (0, _react.useRef)();
	  var txtConcepto = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      body = _useState2[0],
	      setBody = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      operacion = _useState4[0],
	      setOperacion = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      habilitado = _useState6[0],
	      setHabilitado = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(true),
	      _useState8 = _slicedToArray(_useState7, 2),
	      habilitarCat = _useState8[0],
	      setHabilitarCat = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(true),
	      _useState10 = _slicedToArray(_useState9, 2),
	      habilitadoBot = _useState10[0],
	      setHabilitadoBot = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      habilitadoCli = _useState12[0],
	      setHabilitadoCli = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(0),
	      _useState14 = _slicedToArray(_useState13, 2),
	      selectd = _useState14[0],
	      setSelectd = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      selectp = _useState16[0],
	      setSelectp = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(true),
	      _useState18 = _slicedToArray(_useState17, 2),
	      habilitadoProductos = _useState18[0],
	      setHabilitadoProductos = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(false),
	      _useState20 = _slicedToArray(_useState19, 2),
	      habilitadoMod = _useState20[0],
	      setHabilitadoMod = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(false),
	      _useState22 = _slicedToArray(_useState21, 2),
	      habilitadoTip = _useState22[0],
	      setHabilitadoTip = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(false),
	      _useState24 = _slicedToArray(_useState23, 2),
	      habilitadoTipPrecio = _useState24[0],
	      setHabilitadoTipPrecio = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(null),
	      _useState26 = _slicedToArray(_useState25, 2),
	      indice = _useState26[0],
	      setIndice = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      visible = _useState28[0],
	      setVisible = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      mostrar = _useState30[0],
	      setMostrar = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(false),
	      _useState32 = _slicedToArray(_useState31, 2),
	      habilitarMoneda = _useState32[0],
	      setHabilitarMoneda = _useState32[1];
	
	  var _useState33 = (0, _react.useState)([]),
	      _useState34 = _slicedToArray(_useState33, 2),
	      records = _useState34[0],
	      setRecords = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(null),
	      _useState36 = _slicedToArray(_useState35, 2),
	      sifoto = _useState36[0],
	      setSifoto = _useState36[1];
	
	  var _useState37 = (0, _react.useState)([]),
	      _useState38 = _slicedToArray(_useState37, 2),
	      combomoneda = _useState38[0],
	      setComboMoneda = _useState38[1];
	
	  var _useState39 = (0, _react.useState)("Gestionar Nota de Entrega."),
	      _useState40 = _slicedToArray(_useState39, 2),
	      tituloHeader = _useState40[0],
	      setTituloHeader = _useState40[1];
	
	  var _useState41 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState42 = _slicedToArray(_useState41, 2),
	      mensaje = _useState42[0],
	      setMensaje = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      mensajesino = _useState44[0],
	      setMensajesino = _useState44[1];
	
	  var _useState45 = (0, _react.useState)({
	    idmoneda: "1",
	    descripcion: "BOLIVARES",
	    simbolo: "Bs",
	    predeterminada: true,
	    subpredeterminada: false,
	    valormoneda: 1.0
	  }),
	      _useState46 = _slicedToArray(_useState45, 2),
	      moneda = _useState46[0],
	      setMoneda = _useState46[1];
	
	  var _useState47 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState48 = _slicedToArray(_useState47, 2),
	      monedaSub = _useState48[0],
	      setMonedaSub = _useState48[1];
	
	  var _useState49 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState50 = _slicedToArray(_useState49, 2),
	      monedaCambio = _useState50[0],
	      setMonedaCambio = _useState50[1];
	
	  var _useState51 = (0, _react.useState)({
	    subtotal: 0.0,
	    descuento: 0.0,
	    exento: 0.0,
	    sujeto: 0.0,
	    iva: 16.0,
	    totaliva: 0.0,
	    total: 0.0
	  }),
	      _useState52 = _slicedToArray(_useState51, 2),
	      totales = _useState52[0],
	      setTotales = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(false),
	      _useState54 = _slicedToArray(_useState53, 2),
	      catalogoCliente = _useState54[0],
	      setCatalogoCliente = _useState54[1];
	
	  var _useState55 = (0, _react.useState)(false),
	      _useState56 = _slicedToArray(_useState55, 2),
	      modalImagen = _useState56[0],
	      setModalImagen = _useState56[1];
	
	  var _useState57 = (0, _react.useState)(false),
	      _useState58 = _slicedToArray(_useState57, 2),
	      catalogoNota = _useState58[0],
	      setCatalogoNota = _useState58[1];
	
	  var _useState59 = (0, _react.useState)(false),
	      _useState60 = _slicedToArray(_useState59, 2),
	      catalogoPedido = _useState60[0],
	      setCatalogoPedido = _useState60[1];
	
	  var _useState61 = (0, _react.useState)(false),
	      _useState62 = _slicedToArray(_useState61, 2),
	      activate = _useState62[0],
	      setActivate = _useState62[1];
	
	  var _useState63 = (0, _react.useState)("visible"),
	      _useState64 = _slicedToArray(_useState63, 2),
	      visibleBtn = _useState64[0],
	      setVisibleBtn = _useState64[1];
	
	  var _useState65 = (0, _react.useState)({
	    idnotaentrega: "0",
	    numnotaentrega: "000000",
	    cedularif: "",
	    descripcion: "NOTA DE ENTREGA DE PRODUCTOS",
	    totalmonto: 0.0,
	    totaliva: 0.0,
	    totaldescuento: 0.0,
	    totalexento: 0.0,
	    totalsujeto: 0.0,
	    idcliente: "",
	    idvendedor: "",
	    fecha: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	    status: 0,
	    idalmacen: "",
	    idmoneda: "",
	    idoperacioninventario: "",
	    idpedido: "",
	    numpedido: "",
	    tipo: "NE",
	    credito: false,
	    fechavencimiento: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	    valormoneda: 0.0
	  }),
	      _useState66 = _slicedToArray(_useState65, 2),
	      notaentrega = _useState66[0],
	      setNotaEntrega = _useState66[1];
	
	  var _useState67 = (0, _react.useState)({
	    idcliente: "",
	    tiporif: "J",
	    rif: "",
	    nombre: ""
	  }),
	      _useState68 = _slicedToArray(_useState67, 2),
	      cliente = _useState68[0],
	      setCliente = _useState68[1];
	
	  var _useState69 = (0, _react.useState)({
	    idvendedor: "",
	    tiporif: "",
	    rif: "",
	    nombre: "",
	    idalmacen: ""
	  }),
	      _useState70 = _slicedToArray(_useState69, 2),
	      vendedor = _useState70[0],
	      setVendedor = _useState70[1];
	
	  var nomtabla = void 0;
	
	  if (operacion === 4 || operacion === 3) {
	    nomtabla = [{ label: "COD-PRODUCTO", textAlign: "center", width: "0px" }, { label: "PRODUCTO", textAlign: "center" }, { label: "CANTIDAD", textAlign: "center" }, { label: "TIPO PRECIO", textAlign: "center" }, { label: "PRECIO UNI.", textAlign: "center" }, { label: "IVA %", textAlign: "center" }, { label: "UND. ALT.", textAlign: "center" }, { label: "MONTO IVA", textAlign: "center" }, { label: "MONTO", textAlign: "center" }];
	  } else {
	    nomtabla = [{ label: "COD-PRODUCTO", textAlign: "center", width: "0px" }, { label: "PRODUCTO", textAlign: "center" }, { label: "EXISTENCIA", textAlign: "center" }, { label: "CANTIDAD", textAlign: "center" }, { label: "TIPO PRECIO", textAlign: "center" }, { label: "PRECIO UNI.", textAlign: "center" }, { label: "IVA %", textAlign: "center" }, { label: "UND. ALT.", textAlign: "center" }, { label: "MONTO IVA", textAlign: "center" }, { label: "MONTO", textAlign: "center" }, {
	      label: _react2.default.createElement("i", { className: "fas fa-trash" }),
	      textAlign: "center",
	      width: "20px"
	    }];
	  }
	
	  var headCells = nomtabla;
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var seleccionarMonedas = function seleccionarMonedas() {
	    var campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	    var nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	    var orden = "m.idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var x = 0;
	        if (response.data.length > 0) {
	          setComboMoneda(response.data);
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].subpredeterminada) {
	              setMonedaSub(response.data[i]);
	              setMonedaCambio({
	                idmoneda: response.data[i].idmoneda,
	                descripcion: response.data[i].descripcion,
	                simbolo: response.data[i].simbolo,
	                predeterminada: response.data[i].predeterminada,
	                subpredeterminada: response.data[i].subpredeterminada,
	                valormoneda: 1.0
	              });
	              x = i;
	            } else if (response.data[i].predeterminada) {
	              setMoneda(response.data[i]);
	            }
	          }
	        }
	        setTimeout(function () {
	          return cmbMoneda.current.selectedIndex = x;
	        }, 200);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarVendedor = function seleccionarVendedor(id) {
	    var campos = "v.idagente, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen";
	    var nomtab = "agente as v";
	    var nomid = "v.idagente";
	    var nomid2 = "v.vendedor";
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setVendedor({
	            idvendedor: response.data.idagente,
	            tiporif: response.data.tiporifv,
	            rif: response.data.rifv,
	            nombre: response.data.nombrev,
	            idalmacen: response.data.idalmacen
	          });
	
	          btnAcepta.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un vendedor con este codigo",
	            icono: "informacion"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarCliente = function seleccionarCliente(rif, tecla) {
	    var campos = "c.idagente, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
	    var nomtab = "agente as c";
	    var nomid = "c.rif";
	    var nomid2 = "c.cliente";
	    var id = rif;
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtNombreC.current.value = response.data.nombrec;
	          txtConcepto.current.value = "NOTA DE ENTREGA DE PRODUCTOS PARA EL CLIENTE: " + response.data.rifc.trim() + " - " + response.data.nombrec.trim();
	          setCliente({
	            idcliente: response.data.idagente,
	            tiporif: response.data.tiporifc,
	            rif: response.data.rifc,
	            nombre: response.data.nombrec
	          });
	          if (tecla === 13) {
	            txtFecha.current.focus();
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un cliente con este codigo",
	            icono: "informacion"
	          });
	          txtRif.current.value = "";
	          cmbRif.current.selectedIndex = -1;
	          txtNombreC.current.value = "";
	          if (tecla === 13) {
	            txtRif.current.focus();
	          }
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarProducto = function seleccionarProducto(index, idubi, idprod) {
	    var endpoint = op.conexion + "/api/inventario/seleccionarproductoinv?idproducto='" + idprod.toUpperCase() + "'&idalmacen=" + idubi;
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var data = [].concat(_toConsumableArray(records));
	        if (response.data !== "") {
	          if (response.data.servicio) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "no existe un producto con ese codigo en el almacen.",
	              icono: "error"
	            });
	            txtCantidad.current[records.length - 1].value = "1,00";
	          } else {
	            for (var i = 0; i < records.length; i++) {
	              if (records[i].idproducto === response.data.idproducto) {
	                setActivate(false);
	                setMensaje({
	                  mostrar: true,
	                  titulo: "Notificacion",
	                  texto: "el producto ya ha sido seleccionado.",
	                  icono: "error"
	                });
	                return;
	              }
	            }
	
	            var uni = [];
	            var precio = 0.0;
	            var montoiva = 0.0;
	            var cantie = response.data.cantidad;
	            var tipouni = 0;
	            var tiene_iva = false;
	            var tipoprecio = parseInt(response.data.tipoprecio);
	
	            if (parseFloat(response.data.ivaventa) > 0.0) {
	              tiene_iva = true;
	            }
	
	            if (parseInt(response.data.tipofactor) === 0 || response.data.tipofactor === null) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data.idunidadmedida,
	                descripcion: response.data.descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data.cantidad);
	              cantie = Math.trunc(cantie);
	
	              if (tipoprecio === 1) {
	                precio = parseFloat(response.data.preciomaxi);
	              } else if (tipoprecio === 2) {
	                precio = parseFloat(response.data.precioofe);
	              } else if (tipoprecio === 3) {
	                precio = parseFloat(response.data.preciomayor);
	              } else if (tipoprecio === 4) {
	                precio = parseFloat(response.data.preciomini);
	              }
	            } else {
	              if (response.data.idunidadventa === response.data.idunidadalterna) {
	                tipouni = 1;
	                uni = [{
	                  idunidad: response.data.idunidadalterna,
	                  descripcion: response.data.descripcionunialt,
	                  tipo: "alterna"
	                }, {
	                  idunidad: response.data.idunidadmedida,
	                  descripcion: response.data.descripcionuni,
	                  tipo: "medida"
	                }];
	
	                cantie = parseFloat(response.data.cantidad);
	                cantie = Math.trunc(cantie);
	                if (tipoprecio === 1) {
	                  precio = parseFloat(response.data.preciomaxialter);
	                } else if (tipoprecio === 2) {
	                  precio = parseFloat(response.data.precioofealter);
	                } else if (tipoprecio === 3) {
	                  precio = parseFloat(response.data.preciomayoralter);
	                } else if (tipoprecio === 4) {
	                  precio = parseFloat(response.data.preciominialter);
	                }
	              } else if (response.data.idunidadventa === response.data.idunidadmedida) {
	                tipouni = 0;
	                uni = [{
	                  idunidad: response.data.idunidadmedida,
	                  descripcion: response.data.descripcionuni,
	                  tipo: "medida"
	                }, {
	                  idunidad: response.data.idunidadalterna,
	                  descripcion: response.data.descripcionunialt,
	                  tipo: "alterna"
	                }];
	
	                cantie = parseFloat(response.data.cantidad / response.data.valorfactor);
	                cantie = Math.trunc(cantie);
	
	                if (tipoprecio === 1) {
	                  precio = parseFloat(response.data.preciomaxi);
	                } else if (tipoprecio === 2) {
	                  precio = parseFloat(response.data.precioofe);
	                } else if (tipoprecio === 3) {
	                  precio = parseFloat(response.data.preciomayor);
	                } else if (tipoprecio === 4) {
	                  precio = parseFloat(response.data.preciomini);
	                }
	              }
	            }
	
	            montoiva = precio * response.data.ivaventa / 100;
	
	            if (index !== null) {
	              data[index] = {
	                idproducto: response.data.idproducto,
	                codigo: response.data.codigo,
	                cantidad: 1.0,
	                cantidadE: cantie,
	                cantidadEA: parseFloat(response.data.cantidad),
	                nombrecorto: response.data.nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	                precio: precio,
	                preciobs: 0.0,
	                preciomaxi: response.data.preciomaxi,
	                precioofe: response.data.precioofe,
	                preciomayor: response.data.preciomayor,
	                preciomini: response.data.preciomini,
	                preciomaxialter: response.data.preciomaxialter,
	                precioofealter: response.data.precioofealter,
	                preciomayoralter: response.data.preciomayoralter,
	                preciominialter: response.data.preciominialter,
	                iva: response.data.ivaventa,
	                montoiva: (0, _varios.round)(montoiva, 2),
	                descuento: 0.0,
	                total: precio,
	                unidad: uni,
	                idunidadmedida: response.data.idunidadmedida,
	                idunidadalterna: response.data.idunidadalterna,
	                precioconiva: (0, _varios.round)(precio + montoiva, 2),
	                costoproveedor: response.data.costoproveedor,
	                costoproveedoralter: response.data.costoproveedoralter,
	                idmoneda: response.data.idmoneda,
	                valormoneda: monedaCambio.valormoneda,
	                tipounidad: tipouni,
	                tipofactor: response.data.tipofactor,
	                valorfactor: response.data.valorfactor,
	                tipoprecio: response.data.tipoprecio
	              };
	            } else {
	              data.push({
	                idproducto: response.data.idproducto,
	                codigo: response.data.codigo,
	                cantidad: 1.0,
	                cantidadE: cantie,
	                cantidadEA: parseFloat(response.data.cantidad),
	                nombrecorto: response.data.nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	                precio: precio,
	                preciomaxi: response.data.preciomaxi,
	                precioofe: response.data.precioofe,
	                preciomayor: response.data.preciomayor,
	                preciomini: response.data.preciomini,
	                preciomaxialter: response.data.preciomaxialter,
	                precioofealter: response.data.precioofealter,
	                preciomayoralter: response.data.preciomayoralter,
	                preciominialter: response.data.preciominialter,
	                preciobs: 0.0,
	                iva: response.data.ivaventa,
	                montoiva: (0, _varios.round)(montoiva, 2),
	                descuento: 0.0,
	                total: precio,
	                unidad: uni,
	                idunidadmedida: response.data.idunidadmedida,
	                idunidadalterna: response.data.idunidadalterna,
	                precioconiva: (0, _varios.round)(precio + montoiva, 2),
	                costoproveedor: response.data.costoproveedor,
	                costoproveedoralter: response.data.costoproveedoralter,
	                idmoneda: response.data.idmoneda,
	                valormoneda: monedaCambio.valormoneda,
	                tipounidad: tipouni,
	                tipofactor: response.data.tipofactor,
	                valorfactor: response.data.valorfactor,
	                tipoprecio: response.data.tipoprecio
	              });
	            }
	            setRecords(data);
	            setTotales((0, _varios.calcularTotales)(data));
	            setIndice(index);
	
	            if (index !== null) {
	              setTimeout(function () {
	                return txtCantidad.current[index].focus();
	              }, 300);
	            } else {
	              setTimeout(function () {
	                return txtCantidad.current[data.length - 1].focus();
	              }, 300);
	            }
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "no existe un producto con ese codigo en el almacen.",
	            icono: "error"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarPedido = function seleccionarPedido() {
	    var campos = "p.*, p.fecha as fechapedido, m.*, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
	    var nomtab = "pedido as p inner join agente as v on p.idvendedor=v.idagente inner join agente as c on c.idagente=p.idcliente inner join moneda as m on p.idmoneda=m.idmoneda";
	
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=numpedido&id=" + txtNumPedido.current.value.trim();
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          if (response.data.status === 1 && operacion === 1) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "El Pedido ya tiene Nota de Entrega asociada.",
	              icono: "informacion"
	            });
	            setActivate(false);
	            txtNumPedido.current.value = "";
	            txtNumPedido.current.focus();
	            return;
	          } else if (response.data.status === 4) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "El Pedido fue Anulado.",
	              icono: "informacion"
	            });
	            setActivate(false);
	          }
	
	          setHabilitarCat(true);
	
	          if (operacion === 1) {
	            setNotaEntrega(Object.assign({}, notaentrega, {
	              idnotaentrega: "0",
	              numnotaentrega: "0000000",
	              idpedido: response.data.idpedido,
	              numpedido: response.data.numpedido,
	              cedularif: response.data.cedularif,
	              descripcion: response.data.descripcion,
	              totalmonto: response.data.totalmonto,
	              totaliva: response.data.totaliva,
	              totaldescuento: response.data.totaldescuento,
	              totalexento: response.data.totalexento,
	              totalsujeto: response.data.totalsujeto,
	              idcliente: response.data.idcliente,
	              idvendedor: response.data.idvendedor,
	              fecha: (0, _moment2.default)(response.data.fechapedido).format("YYYY-MM-DD"),
	              status: response.data.status,
	              idalmacen: response.data.idalmacen,
	              idmoneda: response.data.idmoneda,
	              idoperacioninventario: response.data.idoperacioninventario,
	              fechavencimiento: (0, _moment2.default)(response.data.fechavencimiento).format("YYYY-MM-DD")
	            }));
	
	            setMoneda({
	              idmoneda: response.data.idmoneda,
	              descripcion: response.data.descripcion,
	              simbolo: response.data.simbolo,
	              valormoneda: response.data.valormoneda,
	              predeterminada: response.data.predeterminada,
	              subpredeterminada: response.data.subpredeterminada
	            });
	
	            setCliente({
	              idcliente: response.data.idcliente,
	              tiporif: response.data.tiporifc,
	              rif: response.data.rifc,
	              nombre: response.data.nombrec
	            });
	            cmbRif.current.value = response.data.tiporifc;
	            txtRif.current.value = response.data.rifc;
	            txtNombreC.current.value = response.data.nombrec;
	
	            setVendedor({
	              idvendedor: response.data.idvendedor,
	              tiporif: response.data.tiporifv,
	              rif: response.data.rifv,
	              nombre: response.data.nombrev,
	              idalmacen: response.data.idalmacen
	            });
	
	            txtNumPedido.current.setAttribute("disabled", true);
	            txtConcepto.current.value = "NOTA DE ENTREGA DE PRODUCTOS PARA EL CLIENTE: " + response.data.rifc.trim() + " - " + response.data.nombrec.trim();
	            txtFecha.current.value = (0, _moment2.default)(response.data.fechapedido).format("YYYY-MM-DD");
	
	            for (var i = 0; i < combomoneda.length; i++) {
	              if (response.data.idmoneda === combomoneda[i].idmoneda) {
	                cmbMoneda.current.selectedIndex = i;
	                break;
	              }
	            }
	            setHabilitadoTip(true);
	            setHabilitadoMod(false);
	            setHabilitadoTipPrecio(true);
	            setTimeout(function () {
	              return btnAcepta.current.focus();
	            }, 200);
	            seleccionarDetallePedido(response.data.idpedido);
	          } else {
	            txtNumPedido.current.setAttribute("disabled", true);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "no existe un pedido con ese codigo.",
	            icono: "informacion"
	          });
	          txtNumPedido.current.value = "";
	          txtNumPedido.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarDetallePedido = function seleccionarDetallePedido(id) {
	    var nomtab1 = "pedidodetalle";
	    var nomtab2 = "pedido";
	    var nomid = "idpedido";
	    var endpoint = op.conexion + "/api/inventario/seleccionarnotaentregadet?id=" + id + "&nomtab1=" + nomtab1 + "&nomtab2=" + nomtab2 + "&nomid=" + nomid;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var prod = [];
	          var uni = [];
	          var cantie = 0.0;
	          var cantiea = 0.0;
	          var tipouni = 0;
	          var tiene_iva = false;
	
	          for (var i = 0; i < response.data.length; i++) {
	            if (parseFloat(response.data[i].iva) > 0.0) {
	              tiene_iva = true;
	            }
	            if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) <= 0.0) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade);
	              cantiea = Math.trunc(cantiea);
	            } else if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) > 0.0) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }, {
	                idunidad: response.data[i].idunidadalterna,
	                descripcion: response.data[i].descripcionunialt,
	                tipo: "alterna"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) / parseFloat(response.data[i].valorfactor);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) / parseFloat(response.data[i].valorfactor);
	
	              cantiea = cantiea * parseFloat(response.data[i].valorfactor);
	              cantiea = Math.trunc(cantiea);
	            } else if (response.data[i].tipounidad === 1) {
	              tipouni = 1;
	              uni = [{
	                idunidad: response.data[i].idunidadalterna,
	                descripcion: response.data[i].descripcionunialt,
	                tipo: "alterna"
	              }, {
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade);
	              cantiea = Math.trunc(cantiea);
	            }
	
	            var miva = response.data[i].punitario * response.data[i].iva / 100;
	
	            prod.push({
	              idproducto: response.data[i].idproducto,
	              codigo: response.data[i].codigo,
	              cantidad: response.data[i].cantidad,
	              cantidadE: parseFloat(cantie),
	              cantidadEA: parseFloat(cantiea),
	              nombrecorto: response.data[i].nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	              precio: response.data[i].punitario,
	              preciobs: response.data[i].punitariobs,
	              preciomaxi: response.data[i].preciomaxi,
	              precioofe: response.data[i].precioofe,
	              preciomayor: response.data[i].preciomayor,
	              preciomini: response.data[i].preciomini,
	              preciomaxialter: response.data[i].preciomaxialter,
	              precioofealter: response.data[i].precioofealter,
	              preciomayoralter: response.data[i].preciomayoralter,
	              preciominialter: response.data[i].preciominialter,
	              iva: response.data[i].iva,
	              ivaventa: response.data[i].ivaventa,
	              montoiva: (0, _varios.round)(miva * response.data[i].cantidad, 2),
	              precioconiva: (0, _varios.round)(parseFloat(response.data[i].punitario) + parseFloat(miva), 2),
	              descuento: response.data[i].descuento,
	              total: response.data[i].cantidad * response.data[i].punitario,
	              unidad: uni,
	              idunidadmedida: response.data[i].idunidadmedida,
	              idunidadalterna: response.data[i].idunidadalterna,
	              costocalculado: response.data[i].costocalculado,
	              costocalculadoalter: response.data[i].costocalculadoalter,
	              utipreciomaxi: response.data[i].utipreciomaxi,
	              utipreciomaxialter: response.data[i].utipreciomaxialter,
	              tipounidad: tipouni,
	              valormoneda: monedaCambio.valormoneda,
	              idmoneda: response.data[i].idmoneda,
	              tipofactor: response.data[i].tipofactor,
	              valorfactor: response.data[i].valorfactor,
	              tipoprecio: response.data[i].tipopreciodeta,
	              costoproveedor: response.data[i].costoproveedor
	            });
	          }
	          setTotales((0, _varios.calcularTotales)(prod));
	          setRecords(prod);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarNotaEntrega = function seleccionarNotaEntrega() {
	    var campos = "p.*, p.descripcion as concepto, p.fecha as fechanota, m.*, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
	    var nomtab = "notaentrega as p inner join agente as v on p.idvendedor=v.idagente inner join agente as c on c.idagente=p.idcliente inner join moneda as m on p.idmoneda=m.idmoneda";
	
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=numnotaentrega&id=" + txtNumNotaEntrega.current.value.trim();
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          if (response.data.status === 1 && (operacion === 2 || operacion === 3)) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La Nota de Entrega ya tiene factura asociada.",
	              icono: "informacion"
	            });
	            setActivate(false);
	            txtNumNotaEntrega.current.value = "";
	            txtNumNotaEntrega.current.focus();
	            return;
	          }
	          txtFecha.current.value = (0, _moment2.default)(response.data.fechanota).format("YYYY-MM-DD");
	          txtStatus.current.value = response.data.status;
	          txtNumNotaEntrega.current.setAttribute("disabled", true);
	          cmbRif.current.value = response.data.tiporifc;
	          txtRif.current.value = response.data.rifc;
	          txtNombreC.current.value = response.data.nombrec;
	          txtConcepto.current.value = response.data.concepto;
	
	          if (response.data.imagennota === 'subir.png') {
	            setSifoto(null);
	          } else {
	            setSifoto(response.data.imagennota);
	          }
	
	          for (var i = 0; i < combomoneda.length; i++) {
	            if (response.data.idmoneda === combomoneda[i].idmoneda) {
	              cmbMoneda.current.selectedIndex = i;
	              break;
	            }
	          }
	
	          if (response.data.credito) {
	            cmbTipoPago.current.value = "2";
	            txtFechaVencimiento.current.value = (0, _moment2.default)(response.data.fechavencimiento).format("YYYY-MM-DD");
	            if (operacion === 2) {
	              setSelectd(1);
	            } else {
	              setSelectd(0);
	            }
	          } else {
	            cmbTipoPago.current.value = "1";
	            txtFechaVencimiento.current.value = "";
	            setSelectd(0);
	          }
	
	          if (response.data.tipo === "NE") {
	            cmbTipo.current.value = "1";
	          } else if (response.data.tipo === "NO") {
	            cmbTipo.current.value = "2";
	          }
	
	          if (response.data.numpedido === "" || response.data.numpedido === null) {
	            cmbDesde.current.value = "1";
	            setVisible(0);
	            if (operacion === 2) {
	              setHabilitadoMod(true);
	              setHabilitadoCli(true);
	              setHabilitadoProductos(false);
	              setHabilitadoTipPrecio(true);
	              setHabilitarMoneda(true);
	            } else {
	              setHabilitadoMod(false);
	              setHabilitadoCli(false);
	              setHabilitadoProductos(true);
	            }
	          } else {
	            setSelectp(1);
	            cmbDesde.current.value = "2";
	            txtNumPedido.current.value = response.data.numpedido;
	            setVisible(1);
	            seleccionarPedido();
	            setHabilitadoMod(false);
	            setHabilitadoCli(false);
	            if (operacion === 2) {
	              setHabilitadoTipPrecio(true);
	            }
	          }
	          setHabilitarCat(true);
	          setNotaEntrega({
	            idnotaentrega: response.data.idnotaentrega,
	            numnotaentrega: response.data.numnotaentrega,
	            cedularif: response.data.cedularif,
	            descripcion: response.data.descripcion,
	            totalmonto: response.data.totalmonto,
	            totaliva: response.data.totaliva,
	            totaldescuento: response.data.totaldescuento,
	            totalexento: response.data.totalexento,
	            totalsujeto: response.data.totalsujeto,
	            idcliente: response.data.idcliente,
	            idvendedor: response.data.idvendedor,
	            fecha: (0, _moment2.default)(response.data.fechanota).format("YYYY-MM-DD"),
	            status: response.data.status,
	            idalmacen: response.data.idalmacen,
	            idmoneda: response.data.idmoneda,
	            idoperacioninventario: response.data.idoperacioninventario,
	            idpedido: response.data.idpedido,
	            numpedido: response.data.numpedido,
	            tipo: response.data.tipo,
	            credito: response.data.credito,
	            fechavencimiento: (0, _moment2.default)(response.data.fechavencimiento).format("YYYY-MM-DD"),
	            valormoneda: response.data.valormoneda
	          });
	
	          setMoneda({
	            idmoneda: response.data.idmoneda,
	            descripcion: response.data.descripcion,
	            simbolo: response.data.simbolo,
	            valormoneda: response.data.valormoneda,
	            predeterminada: response.data.predeterminada,
	            subpredeterminada: response.data.subpredeterminada
	          });
	
	          setCliente({
	            idcliente: response.data.idcliente,
	            tiporif: response.data.tiporifc,
	            rif: response.data.rifc,
	            nombre: response.data.nombrec
	          });
	
	          setVendedor({
	            idvendedor: response.data.idvendedor,
	            tiporif: response.data.tiporifv,
	            rif: response.data.rifv,
	            nombre: response.data.nombrev,
	            idalmacen: response.data.idalmacen
	          });
	          seleccionarDetalleNotaEntrega(response.data.idnotaentrega);
	          if (operacion === 2) {
	            setHabilitadoTip(true);
	            setHabilitado(true);
	            setTimeout(function () {
	              return txtFecha.current.focus();
	            }, 200);
	          } else {
	            setHabilitadoTip(false);
	            setHabilitado(false);
	            setTimeout(function () {
	              return btnCancela.current.focus();
	            }, 200);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "no existe una nota de entrega con ese codigo.",
	            icono: "informacion"
	          });
	          txtNumNotaEntrega.current.value = "";
	          txtNumNotaEntrega.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarDetalleNotaEntrega = function seleccionarDetalleNotaEntrega(idnotaentrega) {
	    var nomtab1 = "notaentregadetalle";
	    var nomtab2 = "notaentrega";
	    var nomid = "idnotaentrega";
	    var endpoint = op.conexion + "/api/inventario/seleccionarnotaentregadet?id=" + idnotaentrega + "&nomtab1=" + nomtab1 + "&nomtab2=" + nomtab2 + "&nomid=" + nomid;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var prod = [];
	          var uni = [];
	          var montoiva = 0.0;
	          var cantie = 0.0;
	          var cantiea = 0.0;
	          var tipouni = 0;
	          var tiene_iva = false;
	
	          for (var i = 0; i < response.data.length; i++) {
	            if (parseFloat(response.data[i].iva) > 0.0) {
	              tiene_iva = true;
	            }
	            if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) <= 0.0) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantiea = Math.trunc(cantiea);
	            } else if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) > 0.0) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }, {
	                idunidad: response.data[i].idunidadalterna,
	                descripcion: response.data[i].descripcionunialt,
	                tipo: "alterna"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) / parseFloat(response.data[i].valorfactor) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) / parseFloat(response.data[i].valorfactor) + parseFloat(response.data[i].cantidad);
	
	              cantiea = cantiea * parseFloat(response.data[i].valorfactor);
	              cantiea = Math.trunc(cantiea);
	            } else if (response.data[i].tipounidad === 1) {
	              tipouni = 1;
	              uni = [{
	                idunidad: response.data[i].idunidadalterna,
	                descripcion: response.data[i].descripcionunialt,
	                tipo: "alterna"
	              }, {
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantiea = Math.trunc(cantiea);
	            }
	
	            var miva = response.data[i].punitario * response.data[i].iva / 100;
	
	            prod.push({
	              idproducto: response.data[i].idproducto,
	              codigo: response.data[i].codigo,
	              cantidad: response.data[i].cantidad,
	              cantidadE: parseFloat(cantie),
	              cantidadEA: parseFloat(cantiea),
	              nombrecorto: response.data[i].nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	              precio: response.data[i].punitario,
	              preciobs: response.data[i].punitariobs,
	              preciomaxi: response.data[i].preciomaxi,
	              precioofe: response.data[i].precioofe,
	              preciomayor: response.data[i].preciomayor,
	              preciomini: response.data[i].preciomini,
	              preciomaxialter: response.data[i].preciomaxialter,
	              precioofealter: response.data[i].precioofealter,
	              preciomayoralter: response.data[i].preciomayoralter,
	              preciominialter: response.data[i].preciominialter,
	              iva: response.data[i].iva,
	              ivaventa: response.data[i].ivaventa,
	              montoiva: (0, _varios.round)(parseFloat(miva) * parseFloat(response.data[i].cantidad), 2),
	              precioconiva: (0, _varios.round)(parseFloat(response.data[i].punitario) + parseFloat(miva), 2),
	              descuento: response.data[i].descuento,
	              total: response.data[i].cantidad * response.data[i].punitario,
	              unidad: uni,
	              idunidadmedida: response.data[i].idunidadmedida,
	              idunidadalterna: response.data[i].idunidadalterna,
	              costocalculado: response.data[i].costocalculado,
	              costocalculadoalter: response.data[i].costocalculadoalter,
	              utipreciomaxi: response.data[i].utipreciomaxi,
	              utipreciomaxialter: response.data[i].utipreciomaxialter,
	              tipounidad: tipouni,
	              valormoneda: monedaCambio.valormoneda,
	              idmoneda: response.data[i].idmoneda,
	              tipofactor: response.data[i].tipofactor,
	              valorfactor: response.data[i].valorfactor,
	              tipoprecio: response.data[i].tipopreciodeta
	            });
	          }
	          setTotales((0, _varios.calcularTotales)(prod));
	          setRecords(prod);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/inventario/actualizarnotaentrega/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idnotaent + " creado correctamente",
	            icono: "exito"
	          });
	          var idnot = response.data.idnotaent;
	          var nota = JSON.parse(sessionStorage.getItem("tiporepnotaentrega"));
	
	          var reporte = nota.toString() === 'HOJA' ? "ReportNotaEntrega" : "ReportNotaEntregaMedium";
	
	          window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&idnota=" + idnot, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	        } else if (operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idnotaent + " modificado correctamente",
	            icono: "exito"
	          });
	          var _idnot = response.data.idnotaent;
	          var _nota = JSON.parse(sessionStorage.getItem("tiporepnotaentrega"));
	
	          var reporte = _nota.toString() === 'HOJA' ? "ReportNotaEntrega" : "ReportNotaEntregaMedium";
	
	          window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&idnota=" + _idnot, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idnotaent + " eliminado correctamente",
	            icono: "exito"
	          });
	        }
	      }
	    }).catch(function (error) {
	      var mensaje = error.response.data.message;
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	    }).finally(function () {
	      return setActivate(false);
	    });
	  };
	
	  var validarCliente = function validarCliente(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (cmbRif.current.value !== "" && event.target.value !== "") {
	        var rif = cmbRif.current.value + event.target.value;
	        seleccionarCliente(rif, event.which);
	      }
	    }
	  };
	
	  var validarCantidadP = function validarCantidadP(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        var cantidades = (0, _varios.validarCantidad)({
	          index: index,
	          event: event,
	          productos: records
	        });
	        if (event.which === 13) {
	          if (index < cantidades.data.length - 1) {
	            setTimeout(function () {
	              return txtCantidad.current[index + 1].focus();
	            }, 300);
	          }
	        }
	        setMensaje(cantidades.msm);
	        setRecords(cantidades.data);
	        setTotales(cantidades.totales);
	      }
	    };
	  };
	
	  var validarIdProducto = function validarIdProducto(index) {
	    return function (event) {
	      if (event.which === 13 || typeof event.which === "undefined") {
	        if (event.target.value !== "") {
	          if (vendedor.idalmacen !== "" && vendedor.idalmacen !== null) {
	            seleccionarProducto(index, vendedor.idalmacen, event.target.value);
	          } else {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación.",
	              texto: "debe seleccionar un vendedor.",
	              icono: "informacion"
	            });
	          }
	        }
	      }
	    };
	  };
	
	  var onCatalogoCliente = function onCatalogoCliente(values) {
	    setCatalogoCliente(false);
	    txtNombreC.current.value = values.nombre;
	    cmbRif.current.value = values.rif.substring(0, 1);
	    txtRif.current.value = values.rif.substring(1);
	    txtConcepto.current.value = "NOTA DE ENTREGA DE PRODUCTOS PARA EL CLIENTE: " + values.rif.trim() + " - " + values.nombre.trim();
	    setCliente({
	      idcliente: values.idagente,
	      tiporif: values.rif.substring(0, 1),
	      rif: values.rif.substring(1),
	      nombre: values.nombre
	    });
	  };
	
	  var onCatalogoPedido = function onCatalogoPedido(values) {
	    setCatalogoPedido(false);
	    txtNumPedido.current.value = values.numpedido;
	    seleccionarPedido();
	  };
	
	  var onCatalogoNotaEntrega = function onCatalogoNotaEntrega(values) {
	    setCatalogoNota(false);
	    txtNumNotaEntrega.current.value = values.numnotaentrega;
	    seleccionarNotaEntrega();
	  };
	
	  var agregarProducto = function agregarProducto(producto) {
	    seleccionarProducto(indice, vendedor.idalmacen, producto.codigo);
	    setMostrar(false);
	  };
	
	  var seleccionarxIndice = function seleccionarxIndice(index) {
	    return function (e) {
	      e.preventDefault();
	      if (vendedor.idalmacen !== "" && vendedor.idalmacen !== null) {
	        setMostrar(true);
	        setIndice(index);
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación.",
	          texto: "debe seleccionar un vendedor.",
	          icono: "informacion"
	        });
	      }
	    };
	  };
	
	  var eliminarProducto = function eliminarProducto(producto) {
	    return function (e) {
	      e.preventDefault();
	      var data = [].concat(_toConsumableArray(records));
	      var elementos = [];
	
	      for (var i = 0; i < data.length; i++) {
	        if (producto.idproducto !== data[i].idproducto) {
	          elementos.push(data[i]);
	        }
	      }
	      setRecords(elementos);
	      setTotales((0, _varios.calcularTotales)(elementos));
	    };
	  };
	
	  var onChangeMoneda = function onChangeMoneda(e) {
	    var i = e.target.value;
	    var cambio = (0, _varios.onCambioMoneda)({
	      moneda: combomoneda[i],
	      productos: records,
	      monedaPre: moneda,
	      monedaSub: monedaSub
	    });
	    setMonedaCambio(cambio.monedacambio);
	    setRecords(cambio.data);
	  };
	
	  var onChangeUnidad = function onChangeUnidad(i) {
	    return function (e) {
	      var cambiounidad = (0, _varios.onCambioUnidad)({
	        idunidad: e.target.value,
	        index: i,
	        productos: records
	      });
	      setMensaje(cambiounidad.msm);
	      setRecords(cambiounidad.data);
	      setTotales(cambiounidad.totales);
	    };
	  };
	
	  var onChangeTipoPrecio = function onChangeTipoPrecio(i) {
	    return function (e) {
	      var data = [].concat(_toConsumableArray(records));
	      var tipoprecio = parseInt(e.target.value);
	      var tipounidad = data[i].tipounidad;
	      var cantidad = data[i].cantidad;
	      var precio = 0.0;
	      var total = 0.0;
	
	      if (tipounidad === 1) {
	        if (tipoprecio === 1) {
	          precio = parseFloat(data[i].preciomaxialter);
	        } else if (tipoprecio === 2) {
	          precio = parseFloat(data[i].precioofealter);
	        } else if (tipoprecio === 3) {
	          precio = parseFloat(data[i].preciomayoralter);
	        } else if (tipoprecio === 4) {
	          precio = parseFloat(data[i].preciominialter);
	        }
	      } else {
	        if (tipoprecio === 1) {
	          precio = parseFloat(data[i].preciomaxi);
	        } else if (tipoprecio === 2) {
	          precio = parseFloat(data[i].precioofe);
	        } else if (tipoprecio === 3) {
	          precio = parseFloat(data[i].preciomayor);
	        } else if (tipoprecio === 4) {
	          precio = parseFloat(data[i].preciomini);
	        }
	      }
	
	      total = precio * cantidad;
	      var montoiv = parseFloat(precio) * parseFloat(data[i].iva) / 100;
	
	      data[i].tipoprecio = e.target.value;
	      data[i].precio = precio;
	      data[i].montoiva = (0, _varios.round)(montoiv * cantidad, 2);
	      data[i].precioconiva = (0, _varios.round)(parseFloat(precio) + parseFloat(precio) * parseFloat(data[i].iva) / 100, 2);
	      data[i].total = total;
	
	      setRecords(data);
	      setTotales((0, _varios.calcularTotales)(data));
	    };
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	
	    if (cmbDesde.current.value === "2" && txtNumPedido.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El codigo del Pedido no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtNumPedido.current.focus();
	    } else if (cmbRif.current.value === "" || txtRif.current.value.trim() === "" || txtNombreC.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Cliente no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtRif.current.focus();
	    } else if (txtFecha.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtFecha.current.focus();
	    } else if (cmbTipoPago.current.value === "2" && txtFechaVencimiento.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha de Vencimiento no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtFechaVencimiento.current.focus();
	    } else if (txtConcepto.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Concepto no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtConcepto.current.focus();
	    } else if (records.length === 0) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "No hay Producto agregados",
	        icono: "informacion"
	      });
	      sigue = false;
	      btnCancela.current.focus();
	    } else if (records.length > 0 && operacion !== 3) {
	      for (var i = 0; i < records.length; i++) {
	        if (notaentrega.numpedido === "" || notaentrega.numpedido === null) {
	          if (records[i].cantidadE === 0.0) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La  cantidad no debe ser mayor a la cantidad existente",
	              icono: "informacion"
	            });
	            sigue = false;
	            btnCancela.current.focus();
	            break;
	          } else if (records[i].cantidadE < records[i].cantidad) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "La  cantidad no debe ser mayor a la cantidad existente",
	              icono: "informacion"
	            });
	            sigue = false;
	            btnCancela.current.focus();
	            break;
	          }
	        }
	      }
	    }
	
	    if (sigue) {
	      var notae = [];
	      var notaedet = [];
	      var opeinv = [];
	      var opeinvdet = [];
	
	      notae.push(Object.assign({
	        idnotaentrega: notaentrega.idnotaentrega,
	        numnotaentrega: notaentrega.numnotaentrega
	      }, notaentrega.numpedido !== "" && notaentrega.numpedido !== null && {
	        numpedido: notaentrega.numpedido
	      }, {
	        descripcion: txtConcepto.current.value.toUpperCase().trim(),
	        cedularif: cliente.tiporif + cliente.rif,
	        tipo: notaentrega.tipo,
	        totalmonto: totales.total,
	        totaliva: totales.totaliva,
	        totalexento: totales.exento,
	        totalsujeto: totales.sujeto,
	        totaldescuento: totales.descuento
	      }, notaentrega.idpedido !== "" && notaentrega.idpedido !== null && { idpedido: notaentrega.idpedido }, {
	        idcliente: cliente.idcliente,
	        idvendedor: vendedor.idvendedor,
	        fecha: txtFecha.current.value,
	        status: notaentrega.tipo === "NO" && operacion === 1 ? 1 : notaentrega.status,
	        idalmacen: vendedor.idalmacen,
	        idmoneda: monedaSub.idmoneda,
	        idoperacioninventario: notaentrega.idoperacioninventario === null || notaentrega.idoperacioninventario === "" ? "" : notaentrega.idoperacioninventario,
	        credito: notaentrega.credito,
	        fechavencimiento: notaentrega.credito ? txtFechaVencimiento.current.value : null,
	        facturado: 0
	      }));
	
	      opeinv.push({
	        idoperacioninventario: notaentrega.idoperacioninventario === null || notaentrega.idoperacioninventario === "" ? "0" : notaentrega.idoperacioninventario,
	        tipooperacion: "SALIDA",
	        idalmacenorigen: vendedor.idalmacen,
	        idalmacendestino: "",
	        fecha: txtFecha.current.value,
	        idmoneda: monedaSub.idmoneda,
	        observacion: notaentrega.tipo === "NE" ? "NOTA DE ENTREGA DE PRODUCTOS" : "NOTA DE ENTREGA DE PRODUCTOS OBSEQUIO/DONACION"
	      });
	
	      for (var _i = 0; _i < records.length; _i++) {
	        notaedet.push({
	          idproducto: records[_i].idproducto,
	          cantidad: records[_i].cantidad,
	          punitario: records[_i].precio,
	          descuento: "0.00",
	          iva: records[_i].iva,
	          tipounidad: records[_i].tipounidad,
	          idunidadmedida: records[_i].idunidadmedida,
	          idunidadalterna: records[_i].idunidadalterna,
	          tasa: monedaSub.valormoneda,
	          codproducto: records[_i].codigo,
	          costo: records[_i].costoproveedor,
	          utilidad: records[_i].utipreciomaxi,
	          tipopreciodeta: records[_i].tipoprecio
	        });
	
	        opeinvdet.push({
	          idproducto: records[_i].idproducto,
	          nombre: records[_i].nombre,
	          cantidad: records[_i].cantidad,
	          precio: records[_i].precio,
	          fechavencimiento: "",
	          tipomovimiento: "VENTA",
	          fechatipomovimiento: txtFecha.current.value,
	          numfactura: notaentrega.numnotaentrega,
	          idalmacen: vendedor.idalmacen,
	          tipounidad: records[_i].tipounidad,
	          idunidadmedida: records[_i].idunidadmedida,
	          idunidadalterna: records[_i].idunidadalterna,
	          tipofactor: records[_i].tipofactor,
	          valorfactor: records[_i].valorfactor,
	          tasa: monedaSub.valormoneda
	        });
	      }
	
	      setBody({
	        notaentre: notae,
	        notaentredet: notaedet,
	        idtipopeinv: "2",
	        opeinv: opeinv,
	        opeinvdet: opeinvdet
	      });
	
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var blanquear = function blanquear() {
	    setTituloHeader("Gestionar Notas de Entrega.");
	    setBody();
	    setActivate(false);
	    setHabilitado(false);
	    setHabilitadoMod(false);
	    setHabilitadoTip(false);
	    setHabilitadoTipPrecio(false);
	    setHabilitarMoneda(false);
	    setHabilitadoCli(false);
	    setHabilitadoBot(true);
	    setHabilitarCat(true);
	    setSifoto(null);
	    setHabilitadoProductos(true);
	    setVisible(0);
	    setSelectp(0);
	    setSelectd(0);
	    setVisibleBtn("visible");
	    setMoneda({
	      idmoneda: "1",
	      descripcion: "BOLIVARES",
	      simbolo: "Bs",
	      predeterminada: false,
	      valormoneda: 1.0
	    });
	    setMonedaCambio({
	      idmoneda: "4",
	      descripcion: "DOLAR",
	      simbolo: "$",
	      predeterminada: false,
	      subpredeterminada: true,
	      valormoneda: 1.0
	    });
	    setRecords([]);
	    for (var i = 0; i < combomoneda.length; i++) {
	      if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
	        cmbMoneda.current.selectedIndex = i;
	      }
	    }
	    cmbDesde.current.value = "1";
	    cmbTipo.current.value = "1";
	    cmbTipoPago.current.value = "1";
	
	    txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	    txtFechaVencimiento.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	    if (operacion !== 1) {
	      txtNumNotaEntrega.current.value = "";
	      txtNumNotaEntrega.current.setAttribute("disabled", true);
	      txtStatus.current.value = "0";
	    }
	
	    cmbRif.current.value = "J";
	    txtRif.current.value = "";
	    txtNombreC.current.value = "";
	    txtConcepto.current.value = "";
	    setCliente({
	      idcliente: "",
	      tiporif: "J",
	      rif: "",
	      nombre: ""
	    });
	    setVendedor({
	      idvendedor: "",
	      tiporif: "",
	      rif: "",
	      nombre: "",
	      idalmacen: ""
	    });
	    setOperacion(0);
	    setNotaEntrega({
	      idnotaentrega: "0",
	      numnotaentrega: "000000",
	      cedularif: "",
	      descripcion: "NOTA ENTREGA DE PRODUCTOS",
	      totalmonto: 0.0,
	      totaliva: 0.0,
	      totaldescuento: 0.0,
	      totalexento: 0.0,
	      totalsujeto: 0.0,
	      idcliente: "",
	      idvendedor: "",
	      fecha: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	      status: 0,
	      idalmacen: "",
	      idmoneda: "",
	      idoperacioninventario: "",
	      idpedido: "",
	      numpedido: "",
	      tipo: "NE",
	      credito: false,
	      fechavencimiento: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	      valormoneda: 0.0
	    });
	    setTotales({
	      subtotal: 0.0,
	      descuento: 0.0,
	      exento: 0.0,
	      sujeto: 0.0,
	      iva: 16.0,
	      totaliva: 0.0,
	      total: 0.0
	    });
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var handleInputChangeCodigo = function handleInputChangeCodigo(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "idnotaentre") {
	          seleccionarNotaEntrega();
	        } else if (event.target.name === "idpedi") {
	          seleccionarPedido();
	        }
	      }
	    }
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "tipopago") {
	      if (e.target.value === "1") {
	        setSelectd(0);
	        setNotaEntrega(Object.assign({}, notaentrega, {
	          credito: false,
	          fechavencimiento: ""
	        }));
	        txtFechaVencimiento.current.value = "";
	      } else if (e.target.value === "2") {
	        setSelectd(1);
	        setNotaEntrega(Object.assign({}, notaentrega, {
	          credito: true,
	          fechavencimiento: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD")
	        }));
	        txtFechaVencimiento.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	      }
	    } else if (e.target.name === "desde") {
	      if (e.target.value === "2") {
	        setSelectp(1);
	        setVisible(1);
	        setHabilitadoCli(false);
	        setHabilitadoProductos(true);
	        setHabilitadoTipPrecio(true);
	      } else if (e.target.value === "1") {
	        setSelectp(0);
	        setVisible(0);
	        setHabilitadoCli(true);
	        setHabilitadoProductos(false);
	        setHabilitadoTipPrecio(true);
	      }
	    } else if (e.target.name === "tipo") {
	      if (e.target.value === "1") {
	        setNotaEntrega(Object.assign({}, notaentrega, { tipo: "NE" }));
	      } else if (e.target.value === "2") {
	        setNotaEntrega(Object.assign({}, notaentrega, { tipo: "NO" }));
	      }
	    } else if (e.target.name === "fecha") {
	      setNotaEntrega(Object.assign({}, notaentrega, { fecha: e.target.value }));
	    } else if (e.target.name === "descripcion") {
	      setNotaEntrega(Object.assign({}, notaentrega, { descripcion: e.target.value }));
	    } else if (e.target.name === "fechavencimiento") {
	      setNotaEntrega(Object.assign({}, notaentrega, { fechavencimiento: e.target.value }));
	    }
	  };
	
	  var imprimirNotaEntrega = function imprimirNotaEntrega() {
	    if (accbtnnentrega && accbtnnentrega.toString().substring(4, 5) === "1") {
	      var debt = 0;
	      if (txtNumNotaEntrega.current.value !== "") {
	        var idnot = notaentrega.idnotaentrega;
	
	        var nota = JSON.parse(sessionStorage.getItem("tiporepnotaentrega"));
	
	        var reporte = nota.toString() === 'HOJA' ? "ReportNotaEntrega" : "ReportNotaEntregaMedium";
	
	        window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&idnota=" + idnot, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "¡ Seleccione la nota de Entrega !",
	          icono: "informacion"
	        });
	        debt = 1;
	      }
	
	      if (debt === 1) {
	        txtNumNotaEntrega.current.focus();
	      }
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (accbtnnentrega && accbtnnentrega.toString().substring(0, 1) === "1") {
	          setTituloHeader("Incluir Nota de Entrega.");
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          setHabilitadoTip(true);
	          setHabilitadoMod(true);
	          setHabilitado(true);
	          setHabilitadoCli(true);
	          setHabilitadoProductos(false);
	          setHabilitadoTipPrecio(true);
	          setHabilitarMoneda(true);
	          seleccionarVendedor(idVendedor);
	          setHabilitarCat(true);
	          cmbTipo.current.selectedIndex = 0;
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          setTimeout(function () {
	            return txtRif.current.focus();
	          }, 300);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (accbtnnentrega && accbtnnentrega.toString().substring(1, 2) === "1") {
	          setTituloHeader("Editar Nota de Entrega.");
	          setOperacion(op);
	          txtNumNotaEntrega.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          txtNumNotaEntrega.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (accbtnnentrega && accbtnnentrega.toString().substring(3, 4) === "1") {
	          setTituloHeader("Eliminar Nota de Entrega.");
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          txtNumNotaEntrega.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitadoTip(false);
	          setHabilitadoTipPrecio(false);
	          setHabilitarMoneda(false);
	          setHabilitadoMod(false);
	          setHabilitado(false);
	          setHabilitadoCli(false);
	          setHabilitadoProductos(true);
	          txtNumNotaEntrega.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (accbtnnentrega && accbtnnentrega.toString().substring(2, 3) === "1") {
	          setTituloHeader("Consultar Nota de Entrega.");
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          txtNumNotaEntrega.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitado(false);
	          setHabilitadoTip(false);
	          setHabilitadoTipPrecio(false);
	          setHabilitarMoneda(true);
	          setHabilitadoMod(false);
	          setHabilitadoCli(false);
	          setHabilitadoProductos(true);
	          txtNumNotaEntrega.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        blanquear();
	      }
	    };
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarMonedas();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 ", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-11 mx-auto py-2 card shadow" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row border-azul mx-auto rounded py-1" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-2 azulGradiant shadow text-light justify-content-between" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-4" },
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  tituloHeader
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 d-flex justify-content-end" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "/inicio", className: "text-light " },
	                  _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "fw-bold" },
	                    "Salir"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row mx-auto mb-1" },
	              operacion !== 1 && _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col-pd-290 mb-3 px-1",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CODIGO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    autoComplete: "off",
	                    ref: txtNumNotaEntrega,
	                    name: "idnotaentre",
	                    onKeyUp: handleInputChangeCodigo,
	                    onBlur: handleInputChangeCodigo,
	                    onChange: function onChange(e) {
	                      return e.target.value = e.target.value.toUpperCase();
	                    },
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: habilitarCat,
	                      type: "button",
	                      onClick: function onClick() {
	                        return setCatalogoNota(true);
	                      },
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                )
	              ),
	              operacion !== 1 ? _react2.default.createElement("div", { className: "col-pd-27" }) : "",
	              operacion !== 1 && _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col-pd-230 mb-3 px-1",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "ESTATUS:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: txtStatus,
	                      style: {
	                        fontWeight: "bold",
	                        color: notaentrega.status === 0 ? "#007bff" : notaentrega.status === 1 ? "#28a745" : notaentrega.status === 4 ? "#dc3545" : "#000000"
	                      },
	                      disabled: true,
	                      className: "form-select form-select-sm text-uppercase px-1",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "0" },
	                      "PENDIENTE"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "PROCESADO"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "4" },
	                      "ANULADO"
	                    )
	                  )
	                )
	              ),
	              operacion !== 1 ? _react2.default.createElement("div", { className: "col-pd-88" }) : "",
	              _react2.default.createElement(
	                "div",
	                { className: "colfull col-pd-290 mb-3 px-1" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSizeAdjust: "0.6" }
	                    },
	                    "TIPO MONEDA:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-control form-control-sm fw-bold text-center",
	                      disabled: !habilitarMoneda,
	                      ref: cmbMoneda,
	                      onChange: onChangeMoneda
	                    },
	                    combomoneda && combomoneda.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: index },
	                        " ",
	                        item.descripcion + " " + item.simbolo + " " + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                        " "
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-220 ml-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSizeAdjust: "0.6" }
	                    },
	                    "FECHA:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "date",
	                    disabled: !habilitado,
	                    ref: txtFecha,
	                    name: "fecha",
	                    onChange: onChange,
	                    className: "form-control fs-6 text-uppercase",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 row mx-auto mb-1",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col-pd-230 mb-3 mr-auto px-1",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      disabled: !habilitadoTip,
	                      ref: cmbTipo,
	                      onChange: onChange,
	                      className: "form-select form-select-sm fz-06",
	                      "aria-label": ".form-select-sm example",
	                      name: "tipo",
	                      id: "tipo"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "VENTA"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "2" },
	                      "OBSEQUIO/DONACION"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col-pd-230 mb-3 mr-auto px-1",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "DESDE:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      disabled: !habilitadoTip,
	                      ref: cmbDesde,
	                      onChange: onChange,
	                      className: "form-select form-select-sm fz-06",
	                      "aria-label": ".form-select-sm example",
	                      name: "desde",
	                      id: "desde"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "NUEVO"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "2" },
	                      "PEDIDO"
	                    )
	                  )
	                )
	              ),
	              selectp === 1 && _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col290 mr-auto mb-3 px-1",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "PEDIDO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    disabled: !habilitado,
	                    ref: txtNumPedido,
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    name: "idpedi",
	                    onKeyUp: handleInputChangeCodigo,
	                    onBlur: handleInputChangeCodigo,
	                    onChange: function onChange(e) {
	                      return e.target.value = e.target.value.toUpperCase();
	                    }
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      type: "button",
	                      disabled: !habilitadoTip,
	                      onClick: function onClick() {
	                        return setCatalogoPedido(true);
	                      },
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col-pd-230 mb-3 mr-auto px-1",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO PAGO:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      disabled: !habilitadoTip,
	                      ref: cmbTipoPago,
	                      onChange: onChange,
	                      className: "form-select form-select-sm fz-06",
	                      "aria-label": ".form-select-sm example",
	                      name: "tipopago",
	                      id: "tipopago"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "CONTADO"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "2" },
	                      "CREDITO"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-350 ml-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA DE VENCIMIENTO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: selectd === 1 ? false : true,
	                    type: "date",
	                    name: "fechavencimiento",
	                    id: "fechavencimiento",
	                    ref: txtFechaVencimiento,
	                    onChange: onChange,
	                    className: "form-control text-uppercase fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "fieldset",
	              {
	                className: "row colfull1070 col-sm-6 mx-auto border-azul rounded mb-1",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "legend",
	                {
	                  className: "float-none m-0 w-auto fw-bold text-black",
	                  style: { fontSize: "1rem" }
	                },
	                "Datos del Cliente"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-3 col-pd-320 px-2" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text fw-bold text-black",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "CEDULA/RIF:",
	                  " "
	                ),
	                _react2.default.createElement(
	                  "select",
	                  {
	                    ref: cmbRif,
	                    name: "cmbrif",
	                    disabled: !habilitadoCli,
	                    className: "form-select form-select-sm col-md-3 text-center",
	                    "aria-label": ".form-select-sm example"
	                  },
	                  _varios.cmbCedula.map(function (item, index) {
	                    return _react2.default.createElement(
	                      "option",
	                      { key: index, value: item.value },
	                      item.value
	                    );
	                  })
	                ),
	                _react2.default.createElement("input", {
	                  ref: txtRif,
	                  autoComplete: "off",
	                  disabled: !habilitadoCli,
	                  maxLength: 9,
	                  type: "text",
	                  className: "form-control fs-6",
	                  name: "cedula",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  onKeyUp: validarCliente,
	                  onBlur: validarCliente
	                }),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: !habilitadoCli,
	                    type: "button",
	                    onClick: function onClick() {
	                      return setCatalogoCliente(true);
	                    },
	                    className: "btn btn-success",
	                    style: {
	                      visibility: visible === 0 ? "visible" : "hidden"
	                    }
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-search" })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-md-12" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text fw-bold text-black",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "NOMBRE:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  ref: txtNombreC,
	                  className: "form-control fs-6",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "fieldset",
	              {
	                className: "row colfull1070 col-sm-6 mx-auto border-azul rounded mb-1",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "legend",
	                {
	                  className: "float-none m-0 w-auto fw-bold text-black",
	                  style: { fontSize: "1rem" }
	                },
	                "Datos del Vendedor"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-3 col-md-5" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text fw-bold text-black",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "CEDULA/RIF:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  className: "form-control fs-6",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  value: vendedor.tiporif + vendedor.rif
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-md-12" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text fw-bold text-black",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "NOMBRE:",
	                  " "
	                ),
	                _react2.default.createElement("input", {
	                  disabled: true,
	                  autoComplete: "off",
	                  type: "text",
	                  className: "form-control fs-6",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  value: vendedor.nombre
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "input-group input-group-sm mb-2 col-md-12" },
	              _react2.default.createElement(
	                "label",
	                { className: "input-group-text", id: "inputGroup-sizing-sm" },
	                "CONCEPTO:"
	              ),
	              _react2.default.createElement("textarea", {
	                className: "form-control uppercase fs-6",
	                ref: txtConcepto,
	                name: "descripcion",
	                onChange: onChange,
	                disabled: !habilitado,
	                "aria-label": "With textarea",
	                style: { minHeight: 50 },
	                defaultValue: ""
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 border-azul px-0 rounded",
	                style: { backgroundColor: "#d5e9ff" }
	              },
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 190,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px",
	                    fontSizeAdjust: "0.6"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden" },
	                  records && records.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      { key: index, style: { padding: "0" } },
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "bg-light d-flex align-items-between px-0",
	                          style: { maxWidth: "500px" }
	                        },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          style: {
	                            borderBottomRightRadius: 0,
	                            borderTopRightRadius: 0
	                          },
	                          disabled: habilitadoProductos,
	                          ref: function ref(el) {
	                            return txtId.current[index] = el;
	                          },
	                          className: "form-control form-control-sm bg-light fs-6 col-pd-110",
	                          defaultValue: item.codigo,
	                          onChange: function onChange(e) {
	                            return e.target.value = e.target.value.toUpperCase();
	                          },
	                          onKeyUp: validarIdProducto(index),
	                          onBlur: validarIdProducto(index)
	                        }),
	                        (operacion === 1 || operacion === 2 || notaentrega.numpedido !== "") && _react2.default.createElement(
	                          "button",
	                          {
	                            type: "button",
	                            style: {
	                              borderBottomLeftRadius: 0,
	                              borderTopLeftRadius: 0
	                            },
	                            disabled: habilitadoProductos,
	                            onClick: seleccionarxIndice(index),
	                            className: "btn btn-sm btn-primary"
	                          },
	                          _react2.default.createElement(
	                            "i",
	                            { className: "fas " },
	                            "-"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-start p-0 pl-2"
	                        },
	                        item.nombrecorto
	                      ),
	                      operacion === 4 || operacion === 3 ? "" : _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-end p-0 pr-2 col-pd-90" },
	                        (0, _varios.formatMoneda)(item.cantidadE.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-center p-0 col-pd-90" },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control form-control-sm bg-light text-right fs-6",
	                          id: "cantidad",
	                          disabled: !habilitadoMod,
	                          defaultValue: (0, _varios.formatMoneda)(item.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtCantidad.current[index] = el;
	                          },
	                          onFocus: _varios.seleccionarCampo,
	                          onKeyUp: validarCantidadP(index),
	                          onBlur: validarCantidadP(index),
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light p-1 col-pd-110" },
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            className: "form-control form-control-sm fs-6 text-center",
	                            disabled: !habilitadoTipPrecio,
	                            defaultValue: item.tipoprecio,
	                            onChange: onChangeTipoPrecio(index)
	                          },
	                          _varios.comboprecios.map(function (item2, x) {
	                            return _react2.default.createElement(
	                              "option",
	                              { key: x, value: item2.id },
	                              " ",
	                              item2.nombre,
	                              " "
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-end p-0 pr-2 col-pd-110" },
	                        (0, _varios.formatMoneda)((item.precio * item.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-end p-0 pr-2 col-pd-110" },
	                        (0, _varios.formatMoneda)(item.iva.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light p-0 col-pd-100" },
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            className: "form-control form-control-sm fs-6 text-center",
	                            style: { width: "100%" },
	                            disabled: habilitadoProductos,
	                            onChange: onChangeUnidad(index)
	                          },
	                          item.unidad && item.unidad.map(function (item2, x) {
	                            return _react2.default.createElement(
	                              "option",
	                              { key: x, value: item2.idunidad },
	                              " ",
	                              item2.descripcion,
	                              " "
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-end p-0 pr-2 col-pd-100" },
	                        (0, _varios.formatMoneda)((item.montoiva * item.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-end p-0 pr-2 col-pd-110" },
	                        (0, _varios.formatMoneda)((item.precio * item.cantidad * item.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      operacion !== 4 && operacion !== 3 && _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-center p-0",
	                          style: { width: "30px" }
	                        },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            disabled: habilitadoProductos,
	                            style: {
	                              visibility: (operacion === 4 || operacion === 3) && "collapse"
	                            },
	                            onClick: eliminarProducto(item),
	                            className: "btn btn-sm btn-danger"
	                          },
	                          _react2.default.createElement("i", { className: "fa fa-trash" }),
	                          " "
	                        )
	                      )
	                    );
	                  }),
	                  _react2.default.createElement(
	                    _core.TableRow,
	                    {
	                      style: {
	                        padding: "0",
	                        visibility: (operacion === 4 || operacion === 0 || operacion === 3) && "collapse"
	                      }
	                    },
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      {
	                        className: "align-middle bg-light text-center p-0 d-flex",
	                        style: { maxWidth: "500px" }
	                      },
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        disabled: habilitadoProductos,
	                        ref: txtIdproducto,
	                        style: {
	                          borderBottomRightRadius: 0,
	                          borderTopRightRadius: 0
	                        },
	                        className: "form-control form-control-sm bg-light text-right fs-6 col-pd-110",
	                        onChange: function onChange(e) {
	                          return e.target.value = e.target.value.toUpperCase();
	                        },
	                        onKeyUp: validarIdProducto(null),
	                        onBlur: validarIdProducto(null)
	                      }),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          disabled: habilitadoProductos,
	                          style: {
	                            borderBottomLeftRadius: 0,
	                            borderTopLeftRadius: 0
	                          },
	                          onClick: function onClick() {
	                            return setMostrar(true);
	                          },
	                          className: "btn btn-sm btn-primary"
	                        },
	                        _react2.default.createElement(
	                          "i",
	                          { className: "fas " },
	                          "-"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(_core.TableCell, { className: "align-middle bg-light text-start p-0 pl-2" }),
	                    operacion === 4 || operacion === 3 ? "" : _react2.default.createElement(_core.TableCell, { className: "align-middle bg-light text-end p-0 pr-2 col-pd-90" }),
	                    _react2.default.createElement(_core.TableCell, { className: "align-middle bg-light text-center p-0 col-pd-110" }),
	                    _react2.default.createElement(_core.TableCell, { className: "align-middle bg-light text-end p-0 pr-2 col-pd-110" }),
	                    _react2.default.createElement(_core.TableCell, { className: "align-middle bg-light text-end p-0 pr-2 col-pd-100" }),
	                    _react2.default.createElement(_core.TableCell, { className: "align-middle bg-light p-0 col-pd-100" }),
	                    _react2.default.createElement(_core.TableCell, { className: "align-middle bg-light p-0 col-pd-120" }),
	                    _react2.default.createElement(_core.TableCell, { className: "align-middle bg-light p-0 col-pd-110" }),
	                    _react2.default.createElement(_core.TableCell, { className: "align-middle bg-light text-end p-0 col-pd-100" }),
	                    operacion === 4 || operacion === 3 ? "" : _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light text-center p-0",
	                      style: { width: "20px" }
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row m-0 px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-8 py-1 mt-auto" },
	                visibleBtn === "visible" ? _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-520" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 row m-0" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: !habilitadoBot,
	                        ref: btnIncluir,
	                        onClick: onBotones(1),
	                        className: "btn btn-sm col ml-1 mb-1 btn-primary rounded-pill",
	                        title: "Incluir Nota de Entrega"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-plus" },
	                        " Incluir "
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: !habilitadoBot,
	                        ref: btnConsultar,
	                        onClick: onBotones(4),
	                        className: "btn btn-sm col ml-1 mb-1 btn-info rounded-pill",
	                        title: "Consultar Nota de Entrega"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-eye" },
	                        " Consultar"
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: !habilitadoBot,
	                        ref: btnEditar,
	                        onClick: onBotones(2),
	                        className: "btn btn-sm col ml-1 mb-1 btn-warning rounded-pill",
	                        title: "Modificar Nota de Entrega"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fa fa-edit" },
	                        " Modificar"
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: !habilitadoBot,
	                        ref: btnEliminar,
	                        onClick: onBotones(3),
	                        className: "btn btn-sm col ml-1 mb-1 btn-danger rounded-pill",
	                        title: "Eliminar Nota de Entrega"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fa fa-trash" },
	                        " Eliminar"
	                      ),
	                      " "
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-540 row m-0 ml-auto" },
	                  operacion === 4 && sifoto !== null ? _react2.default.createElement(
	                    "button",
	                    {
	                      onClick: function onClick() {
	                        return setModalImagen(true);
	                      },
	                      disabled: operacion === 4 ? false : true,
	                      className: "btn btn-sm col ml-1 btn-info rounded-pill",
	                      title: "Visualizar Imagen de la Nota de Entrega"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-images" },
	                      " Imagen"
	                    )
	                  ) : _react2.default.createElement("dvi", { className: "col-pd-110" }),
	                  operacion === 4 ? _react2.default.createElement(
	                    "button",
	                    {
	                      onClick: imprimirNotaEntrega,
	                      disabled: operacion === 4 ? false : true,
	                      className: "btn btn-sm col ml-1 btn-primary rounded-pill",
	                      title: "Imprimir Nota de Entrega"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-print" },
	                      " Imprimir"
	                    )
	                  ) : _react2.default.createElement("dvi", { className: "col-pd-110" }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnAcepta,
	                      disabled: operacion === 4 ? true : habilitadoBot,
	                      onClick: onBotones(5),
	                      className: "btn btn-sm rounded-pill btn-success col mx-1"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-check-circle" },
	                      " Aceptar"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnCancela,
	                      disabled: habilitadoBot,
	                      onClick: onBotones(6),
	                      className: "btn btn-sm rounded-pill btn-danger col"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-window-close" },
	                      " Cancelar"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-md-4 border-azul rounded shadow",
	                  style: { backgroundColor: "#dbeeff" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "SUBTOTAL ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtSubTotal,
	                    value: (0, _varios.formatMoneda)((totales.subtotal * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "EXENTO ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtExentoTotal,
	                    value: (0, _varios.formatMoneda)((totales.exento * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "DESCUENTO ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtDescuento,
	                    value: (0, _varios.formatMoneda)((totales.descuento * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "IVA ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtTotIva,
	                    value: (0, _varios.formatMoneda)((totales.totaliva * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "TOTAL ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtTotal,
	                    value: (0, _varios.formatMoneda)((totales.total * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoProductoExistencia2.default, {
	      show: mostrar,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar(false);
	      },
	      onHideAceptaCatalogo: agregarProducto,
	      idalmacen: vendedor.idalmacen
	    }),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: catalogoCliente,
	      nomid: "cliente",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoCliente(false);
	      },
	      onHideAceptaCatalogo: onCatalogoCliente
	    }),
	    _react2.default.createElement(_modalImagenNotaEntrega.ImagenNotaEntrega, {
	      show: modalImagen,
	      imagen: sifoto,
	      onHideCancelar: function onHideCancelar() {
	        return setModalImagen(false);
	      }
	    }),
	    _react2.default.createElement(_catalogoNotaEntrega2.default, {
	      show: catalogoNota,
	      nomid: "notaentrega",
	      tip: "NE",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoNota(false);
	      },
	      onHideAceptaCatalogo: onCatalogoNotaEntrega,
	      condicion: "true"
	    }),
	    _react2.default.createElement(_catalogoPedido2.default, {
	      show: catalogoPedido,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoPedido(false);
	      },
	      onHideAceptaCatalogo: onCatalogoPedido,
	      condicion: "status = 0"
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return mensaje.titulo === "Exito." ? blanquear() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = TablaNotaEntrega;

/***/ },
/* 7179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _core = __webpack_require__(19);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoProductoExistencia = __webpack_require__(105);
	
	var _catalogoProductoExistencia2 = _interopRequireDefault(_catalogoProductoExistencia);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _catalogoPedido = __webpack_require__(210);
	
	var _catalogoPedido2 = _interopRequireDefault(_catalogoPedido);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var TablaPedidos = function TablaPedidos() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var organizacion = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var accbtnpedidos = JSON.parse(sessionStorage.getItem("accbtnpedidosc"));
	  var tiporeppedido = JSON.parse(sessionStorage.getItem("tiporeppedido"));
	
	  var reportePedido = tiporeppedido.toString() === 'HOJA' ? 'Pedido' : 'ForPedidoMedium';
	  var txtNumPedido = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtStatus = (0, _react.useRef)();
	  var txtId = (0, _react.useRef)([]);
	  var txtCantidad = (0, _react.useRef)([]);
	  var txtPrecio = (0, _react.useRef)([]);
	  var btnIncluir = (0, _react.useRef)();
	  var btnEditar = (0, _react.useRef)();
	  var btnEliminar = (0, _react.useRef)();
	  var btnConsultar = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnProducto = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var cmbRifV = (0, _react.useRef)();
	  var txtRifV = (0, _react.useRef)();
	  var txtNombreC = (0, _react.useRef)();
	  var txtNombreV = (0, _react.useRef)();
	  var txtSubTotal = (0, _react.useRef)();
	  var txtDescuento = (0, _react.useRef)();
	  var txtExentoTotal = (0, _react.useRef)();
	  var txtTotIva = (0, _react.useRef)();
	  var txtTotal = (0, _react.useRef)();
	  var cmbMoneda = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)("visible"),
	      _useState2 = _slicedToArray(_useState, 2),
	      visibleBtn = _useState2[0],
	      setVisibleBtn = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      body = _useState4[0],
	      setBody = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      operacion = _useState6[0],
	      setOperacion = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      habilitado = _useState8[0],
	      setHabilitado = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(true),
	      _useState10 = _slicedToArray(_useState9, 2),
	      habilitarCat = _useState10[0],
	      setHabilitarCat = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(true),
	      _useState12 = _slicedToArray(_useState11, 2),
	      habilitadoBot = _useState12[0],
	      setHabilitadoBot = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      habilitadoCli = _useState14[0],
	      setHabilitadoCli = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(true),
	      _useState16 = _slicedToArray(_useState15, 2),
	      habilitadoProductos = _useState16[0],
	      setHabilitadoProductos = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      actimprime = _useState18[0],
	      setActimprime = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(false),
	      _useState20 = _slicedToArray(_useState19, 2),
	      mostrar = _useState20[0],
	      setMostrar = _useState20[1];
	
	  var _useState21 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState22 = _slicedToArray(_useState21, 2),
	      mensaje = _useState22[0],
	      setMensaje = _useState22[1];
	
	  var _useState23 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState24 = _slicedToArray(_useState23, 2),
	      mensajesino = _useState24[0],
	      setMensajesino = _useState24[1];
	
	  var _useState25 = (0, _react.useState)({
	    idpedido: "0",
	    numpedido: "000000",
	    cedularif: "",
	    descripcion: "PEDIDO DE PRODUCTO",
	    totalmonto: 0.0,
	    totaliva: 0.0,
	    totaldescuento: 0.0,
	    totalexento: 0.0,
	    totalsujeto: 0.0,
	    idcliente: "",
	    idvendedor: "",
	    fecha: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	    status: 0,
	    idalmacen: "",
	    idmoneda: "",
	    idoperacioninventario: ""
	  }),
	      _useState26 = _slicedToArray(_useState25, 2),
	      pedido = _useState26[0],
	      setPedido = _useState26[1];
	
	  var _useState27 = (0, _react.useState)({
	    idcliente: "",
	    tiporif: "J",
	    rif: "",
	    nombre: ""
	  }),
	      _useState28 = _slicedToArray(_useState27, 2),
	      cliente = _useState28[0],
	      setCliente = _useState28[1];
	
	  var _useState29 = (0, _react.useState)({
	    idvendedor: "",
	    tiporif: "J",
	    rif: "",
	    nombre: "",
	    idalmacen: ""
	  }),
	      _useState30 = _slicedToArray(_useState29, 2),
	      vendedor = _useState30[0],
	      setVendedor = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(""),
	      _useState32 = _slicedToArray(_useState31, 2),
	      tipoAgente = _useState32[0],
	      setTipoAgente = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(false),
	      _useState34 = _slicedToArray(_useState33, 2),
	      habilitarMoneda = _useState34[0],
	      setHabilitarMoneda = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(false),
	      _useState36 = _slicedToArray(_useState35, 2),
	      catalogoCliente = _useState36[0],
	      setCatalogoCliente = _useState36[1];
	
	  var _useState37 = (0, _react.useState)(false),
	      _useState38 = _slicedToArray(_useState37, 2),
	      catalogoPedido = _useState38[0],
	      setCatalogoPedido = _useState38[1];
	
	  var _useState39 = (0, _react.useState)(false),
	      _useState40 = _slicedToArray(_useState39, 2),
	      activate = _useState40[0],
	      setActivate = _useState40[1];
	
	  var _useState41 = (0, _react.useState)(null),
	      _useState42 = _slicedToArray(_useState41, 2),
	      indice = _useState42[0],
	      setIndice = _useState42[1];
	
	  var _useState43 = (0, _react.useState)([]),
	      _useState44 = _slicedToArray(_useState43, 2),
	      records = _useState44[0],
	      setRecords = _useState44[1];
	
	  var _useState45 = (0, _react.useState)([]),
	      _useState46 = _slicedToArray(_useState45, 2),
	      listaProductos = _useState46[0],
	      setListaProductos = _useState46[1];
	
	  var _useState47 = (0, _react.useState)([]),
	      _useState48 = _slicedToArray(_useState47, 2),
	      todosProductos = _useState48[0],
	      setTodosProductos = _useState48[1];
	
	  var _useState49 = (0, _react.useState)("Gestionar Pedidos."),
	      _useState50 = _slicedToArray(_useState49, 2),
	      tituloHeader = _useState50[0],
	      setTituloHeader = _useState50[1];
	
	  var _useState51 = (0, _react.useState)([]),
	      _useState52 = _slicedToArray(_useState51, 2),
	      combomoneda = _useState52[0],
	      setComboMoneda = _useState52[1];
	
	  var _useState53 = (0, _react.useState)({
	    idmoneda: "1",
	    descripcion: "BOLIVARES",
	    simbolo: "Bs",
	    predeterminada: true,
	    subpredeterminada: false,
	    valormoneda: 1.0
	  }),
	      _useState54 = _slicedToArray(_useState53, 2),
	      moneda = _useState54[0],
	      setMoneda = _useState54[1];
	
	  var _useState55 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState56 = _slicedToArray(_useState55, 2),
	      monedaSub = _useState56[0],
	      setMonedaSub = _useState56[1];
	
	  var _useState57 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState58 = _slicedToArray(_useState57, 2),
	      monedaCambio = _useState58[0],
	      setMonedaCambio = _useState58[1];
	
	  var _useState59 = (0, _react.useState)({
	    subtotal: 0.0,
	    descuento: 0.0,
	    exento: 0.0,
	    sujeto: 0.0,
	    iva: 16.0,
	    totaliva: 0.0,
	    total: 0.0
	  }),
	      _useState60 = _slicedToArray(_useState59, 2),
	      totales = _useState60[0],
	      setTotales = _useState60[1];
	
	  var nomtabla = void 0;
	
	  if (operacion === 4) {
	    nomtabla = [{ label: "COD-PRODUCTO", textAlign: "center", width: "40px" }, { label: "PRODUCTO", textAlign: "center", width: "100px" }, { label: "CANTIDAD", textAlign: "center", width: "20px" }, { label: "TIPO PRECIO", textAlign: "center", width: "50px" }, { label: "PRECIO UNI.", textAlign: "center", width: "50px" }, { label: "IVA", textAlign: "center", width: "50px" }, { label: "UND. ALT.", textAlign: "center", width: "50px" }, { label: "MONTO", textAlign: "center", width: "50px" }, {
	      label: "",
	      textAlign: "center",
	      width: "20px"
	    }];
	  } else {
	    nomtabla = [{ label: "COD-PRODUCTO", textAlign: "center", width: "40px" }, { label: "PRODUCTO", textAlign: "center", width: "100px" }, { label: "EXISTENCIA", textAlign: "center", width: "30px" }, { label: "CANTIDAD", textAlign: "center", width: "20px" }, { label: "TIPO PRECIO", textAlign: "center", width: "50px" }, { label: "PRECIO UNI.", textAlign: "center", width: "50px" }, { label: "IVA", textAlign: "center", width: "50px" }, { label: "UND. ALT.", textAlign: "center", width: "50px" }, { label: "MONTO", textAlign: "center", width: "50px" }, {
	      label: _react2.default.createElement("i", { className: "fas fa-trash" }),
	      textAlign: "center",
	      width: "20px"
	    }];
	  }
	
	  var headCells = nomtabla;
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	    var lista = [];
	
	    if (target.value === "") {
	      lista = todosProductos;
	    } else {
	      lista = todosProductos.filter(function (x) {
	        if (x.idproducto.includes(target.value) || x.codigo.toLowerCase().includes(target.value.toLowerCase()) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.descripcion.toLowerCase().includes(target.value.toLowerCase()) || (0, _varios.formatMoneda)(x.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2).toLowerCase().includes(target.value.toLowerCase())) {
	          return x;
	        }
	      });
	    }
	
	    setListaProductos(lista);
	  };
	
	  var validarNumPedido = function validarNumPedido(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "numpedido") {
	          seleccionarRegistro();
	        }
	      }
	    }
	  };
	
	  var validarCliente = function validarCliente(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (cmbRif.current.value !== "" && event.target.value !== "") {
	        var rif = cmbRif.current.value + event.target.value;
	        seleccionarCliente(rif, event.which);
	      }
	    }
	  };
	
	  var validarVendedor = function validarVendedor(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (cmbRifV.current.value !== "" && event.target.value !== "") {
	        var rif = cmbRifV.current.value + event.target.value;
	        seleccionarVendedor(rif);
	      }
	    }
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros(id) {
	    var endpoint = op.conexion + "/api/pedido/productoexisselectubi?idalmacen=" + id;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setListaProductos(response.data);
	          setTodosProductos(response.data);
	          if (operacion === 1) {
	            setTimeout(function () {
	              return txtRif.current.focus();
	            }, 300);
	          }
	        } else {
	          setListaProductos([]);
	          setTodosProductos([]);
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "el almacen no tiene productos!",
	            icono: "informacion"
	          });
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setBody();
	    setTituloHeader("Gestionar Pedidos.");
	    setActivate(false);
	    setActimprime(0);
	
	    setHabilitado(false);
	    setHabilitadoCli(false);
	    setHabilitadoBot(true);
	    setHabilitarCat(true);
	    setHabilitadoProductos(true);
	    setHabilitarMoneda(false);
	    setVisibleBtn("visible");
	    setRecords([]);
	    setListaProductos([]);
	    setTodosProductos([]);
	    setMoneda({
	      idmoneda: "1",
	      descripcion: "BOLIVARES",
	      simbolo: "Bs",
	      predeterminada: false,
	      valormoneda: 1.0
	    });
	    setMonedaCambio({
	      idmoneda: "4",
	      descripcion: "DOLAR",
	      simbolo: "$",
	      predeterminada: false,
	      subpredeterminada: true,
	      valormoneda: 1.0
	    });
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    setCliente({
	      idcliente: "",
	      tiporif: "J",
	      rif: "",
	      nombre: ""
	    });
	    setVendedor({
	      idvendedor: "",
	      tiporif: "J",
	      rif: "",
	      nombre: "",
	      idalmacen: ""
	    });
	    setPedido({
	      idpedido: "0",
	      numpedido: "000000",
	      cedularif: "",
	      descripcion: "PEDIDO DE PRODUCTO",
	      totalmonto: 0.0,
	      totaliva: 0.0,
	      totaldescuento: 0.0,
	      totalexento: 0.0,
	      totalsujeto: 0.0,
	      idcliente: "",
	      idvendedor: "",
	      fecha: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	      status: 0,
	      idalmacen: "",
	      idmoneda: "",
	      idoperacioninventario: ""
	    });
	    setTotales({
	      subtotal: 0.0,
	      descuento: 0.0,
	      exento: 0.0,
	      sujeto: 0.0,
	      iva: 16.0,
	      totaliva: 0.0,
	      total: 0.0
	    });
	    for (var i = 0; i < combomoneda.length; i++) {
	      if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
	        cmbMoneda.current.selectedIndex = i;
	      }
	    }
	
	    if (operacion !== 1) {
	      txtStatus.current.value = "0";
	      txtNumPedido.current.value = "";
	      txtNumPedido.current.setAttribute("disabled", true);
	    }
	
	    setOperacion(0);
	    cmbRif.current.selectedIndex = -1;
	    txtRif.current.value = "";
	    txtNombreC.current.value = "";
	    cmbRifV.current.selectedIndex = -1;
	    txtRifV.current.value = "";
	    txtNombreV.current.value = "";
	    txtFecha.current.value = "";
	  };
	
	  var seleccionarMonedas = function seleccionarMonedas() {
	    var campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	    var nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	    var orden = "m.idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var x = 0;
	        if (response.data.length > 0) {
	          setComboMoneda(response.data);
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].subpredeterminada) {
	              setMonedaSub(response.data[i]);
	              setMonedaCambio({
	                idmoneda: response.data[i].idmoneda,
	                descripcion: response.data[i].descripcion,
	                simbolo: response.data[i].simbolo,
	                predeterminada: response.data[i].predeterminada,
	                subpredeterminada: response.data[i].subpredeterminada,
	                valormoneda: 1.0
	              });
	              x = i;
	            } else if (response.data[i].predeterminada) {
	              setMoneda(response.data[i]);
	            }
	          }
	        }
	        setTimeout(function () {
	          return cmbMoneda.current.selectedIndex = x;
	        }, 200);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/pedido/actualizarnotaentrega/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idpe + " creado correctamente",
	            icono: "exito"
	          });
	          window.open(op.reportes + ("/pedidos?afiliado=" + organizacion + "&reporte=" + reportePedido + "&CODIGO=" + response.data.idpe), "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	        } else if (operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idpe + " modificado correctamente",
	            icono: "exito"
	          });
	          window.open(op.reportes + ("/pedidos?afiliado=" + organizacion + "&reporte=" + reportePedido + "&CODIGO=" + response.data.idpe), "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idpe + " eliminado correctamente",
	            icono: "exito"
	          });
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var validarCantidadP = function validarCantidadP(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        var cantidades = (0, _varios.validarCantidadForPedido)({
	          index: index,
	          event: event,
	          productos: records
	        });
	        if (event.which === 13) {
	          if (index < cantidades.data.length - 1) {
	            setTimeout(function () {
	              return txtCantidad.current[index + 1].focus();
	            }, 300);
	          }
	        }
	        setMensaje(cantidades.msm);
	        setRecords(cantidades.data);
	        setTotales(cantidades.totales);
	      }
	    };
	  };
	
	  var imprimirPedido = function imprimirPedido() {
	    if (accbtnpedidos && accbtnpedidos.toString().substring(4, 5) === "1") {
	      if (txtNumPedido.current.value !== "") {
	        window.open(op.reportes + "/pedidos?afiliado=" + organizacion + "&reporte=" + reportePedido + "&CODIGO=" + pedido.idpedido, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      }
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var seleccionarCliente = function seleccionarCliente(rif, tecla) {
	    var campos = "c.idagente, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
	    var nomtab = "agente as c";
	    var nomid = "c.rif";
	    var nomid2 = "c.cliente";
	    var id = rif;
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtNombreC.current.value = response.data.nombrec;
	          setCliente({
	            idcliente: response.data.idagente,
	            tiporif: response.data.tiporifc,
	            rif: response.data.rifc,
	            nombre: response.data.nombrec
	          });
	          if (tecla === 13) {
	            txtFecha.current.focus();
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un cliente con este codigo",
	            icono: "informacion"
	          });
	          txtRif.current.value = "";
	          cmbRif.current.selectedIndex = -1;
	          if (tecla === 13) {
	            txtRif.current.focus();
	          }
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarVendedor = function seleccionarVendedor(rif) {
	    var campos = "v.idagente, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen";
	    var nomtab = "agente as v";
	    var nomid = "v.rif";
	    var nomid2 = "v.vendedor";
	    var id = rif;
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtNombreV.current.value = response.data.nombrev;
	          setVendedor({
	            idvendedor: response.data.idagente,
	            tiporif: response.data.tiporifv,
	            rif: response.data.rifv,
	            nombre: response.data.nombrev,
	            idalmacen: response.data.idalmacen
	          });
	          if (response.data.idalmacen === null || response.data.idalmacen === "" || response.data.idalmacen === 0) {
	            setListaProductos([]);
	            setTodosProductos([]);
	            setRecords([]);
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "el vendedor no tiene un almacen asociado!",
	              icono: "informacion"
	            });
	          } else {
	            seleccionarRegistros(response.data.idalmacen);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un vendedor con este codigo",
	            icono: "informacion"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	    var campos = "p.*, p.fecha as fechapedido, m.*, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
	    var nomtab = "pedido as p inner join agente as v on p.idvendedor=v.idagente inner join agente as c on c.idagente=p.idcliente inner join moneda as m on p.idmoneda=m.idmoneda";
	
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=numpedido&id=" + txtNumPedido.current.value.trim();
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          if (response.data.status === 1 && (operacion === 2 || operacion === 3)) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "El Pedido ya tiene Nota de Entrega asociada.",
	              icono: "informacion"
	            });
	            setActivate(false);
	            txtNumPedido.current.value = "";
	            txtNumPedido.current.focus();
	            return;
	          } else if (response.data.status === 4 && (operacion === 2 || operacion === 3)) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "El Pedido fue Anulado.",
	              icono: "informacion"
	            });
	            setActivate(false);
	            setOperacion(4);
	          }
	
	          setPedido({
	            idpedido: response.data.idpedido,
	            numpedido: response.data.numpedido,
	            cedularif: response.data.cedularif,
	            descripcion: response.data.descripcion,
	            totalmonto: response.data.totalmonto,
	            totaliva: response.data.totaliva,
	            totaldescuento: response.data.totaldescuento,
	            totalexento: response.data.totalexento,
	            totalsujeto: response.data.totalsujeto,
	            idcliente: response.data.idcliente,
	            idvendedor: response.data.idvendedor,
	            fecha: (0, _moment2.default)(response.data.fechapedido).format("YYYY-MM-DD"),
	            status: response.data.status,
	            idalmacen: response.data.idalmacen,
	            idmoneda: response.data.idmoneda,
	            idoperacioninventario: response.data.idoperacioninventario
	          });
	
	          setMoneda({
	            idmoneda: response.data.idmoneda,
	            descripcion: response.data.descripcion,
	            simbolo: response.data.simbolo,
	            valormoneda: response.data.valormoneda,
	            predeterminada: response.data.predeterminada,
	            subpredeterminada: response.data.subpredeterminada
	          });
	
	          setCliente({
	            idcliente: response.data.idcliente,
	            tiporif: response.data.tiporifc,
	            rif: response.data.rifc,
	            nombre: response.data.nombrec
	          });
	          cmbRif.current.value = response.data.tiporifc;
	          txtRif.current.value = response.data.rifc;
	          txtNombreC.current.value = response.data.nombrec;
	
	          setVendedor({
	            idvendedor: response.data.idvendedor,
	            tiporif: response.data.tiporifv,
	            rif: response.data.rifv,
	            nombre: response.data.nombrev,
	            idalmacen: response.data.idalmacen
	          });
	
	          cmbRifV.current.value = response.data.tiporifv;
	          txtRifV.current.value = response.data.rifv;
	          txtNombreV.current.value = response.data.nombrev;
	
	          if (response.data.idalmacen === null || response.data.idalmacen === "" || response.data.idalmacen === 0) {
	            setListaProductos([]);
	            setTodosProductos([]);
	            setRecords([]);
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "el vendedor no tiene un almacen asociado!",
	              icono: "informacion"
	            });
	          } else {
	            seleccionarRegistros(response.data.idalmacen);
	          }
	
	          txtNumPedido.current.setAttribute("disabled", true);
	          setHabilitarCat(true);
	          txtStatus.current.value = response.data.status;
	          txtFecha.current.value = (0, _moment2.default)(response.data.fechapedido).format("YYYY-MM-DD");
	          for (var i = 0; i < combomoneda.length; i++) {
	            if (response.data.idmoneda === combomoneda[i].idmoneda) {
	              cmbMoneda.current.selectedIndex = i;
	              break;
	            }
	          }
	          seleccionarDetalle(response.data.idpedido);
	
	          if (operacion === 2) {
	            setHabilitado(true);
	            setHabilitarMoneda(true);
	            setHabilitadoCli(true);
	            setTimeout(function () {
	              return txtFecha.current.focus();
	            }, 200);
	          } else {
	            setHabilitado(false);
	            setHabilitadoCli(false);
	            setTimeout(function () {
	              return btnCancela.current.focus();
	            }, 200);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "no existe un pedido con ese codigo.",
	            icono: "informacion"
	          });
	          txtNumPedido.current.value = "";
	          txtNumPedido.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarDetalle = function seleccionarDetalle(idpedido) {
	    var nomtab1 = "pedidodetalle";
	    var nomtab2 = "pedido";
	    var nomid = "idpedido";
	    var endpoint = op.conexion + "/api/inventario/seleccionarnotaentregadet?id=" + idpedido + "&nomtab1=" + nomtab1 + "&nomtab2=" + nomtab2 + "&nomid=" + nomid;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var prod = [];
	          var uni = [];
	          var cantie = 0.0;
	          var cantiea = 0.0;
	          var tipouni = 0;
	          var tiene_iva = false;
	
	          for (var i = 0; i < response.data.length; i++) {
	            if (parseFloat(response.data[i].iva) > 0.0) {
	              tiene_iva = true;
	            }
	            if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) <= 0.0) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantiea = Math.trunc(cantiea);
	            } else if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) > 0.0) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }, {
	                idunidad: response.data[i].idunidadalterna,
	                descripcion: response.data[i].descripcionunialt,
	                tipo: "alterna"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) / parseFloat(response.data[i].valorfactor);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) / parseFloat(response.data[i].valorfactor) + parseFloat(response.data[i].cantidad);
	
	              cantiea = cantiea * parseFloat(response.data[i].valorfactor);
	              cantiea = Math.trunc(cantiea);
	            } else if (response.data[i].tipounidad === 1) {
	              tipouni = 1;
	              uni = [{
	                idunidad: response.data[i].idunidadalterna,
	                descripcion: response.data[i].descripcionunialt,
	                tipo: "alterna"
	              }, {
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantiea = Math.trunc(cantiea);
	            }
	
	            var miva = response.data[i].punitario * response.data[i].iva / 100;
	
	            prod.push({
	              idproducto: response.data[i].idproducto,
	              codigo: response.data[i].codigo,
	              cantidad: response.data[i].cantidad,
	              cantidadE: parseFloat(cantie),
	              cantidadEA: parseFloat(cantiea),
	              nombrecorto: response.data[i].nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	              precio: response.data[i].punitario,
	              preciobs: response.data[i].punitariobs,
	              preciomaxi: response.data[i].preciomaxi,
	              precioofe: response.data[i].precioofe,
	              preciomayor: response.data[i].preciomayor,
	              preciomini: response.data[i].preciomini,
	              preciomaxialter: response.data[i].preciomaxialter,
	              precioofealter: response.data[i].precioofealter,
	              preciomayoralter: response.data[i].preciomayoralter,
	              preciominialter: response.data[i].preciominialter,
	              iva: response.data[i].iva,
	              ivaventa: response.data[i].ivaventa,
	              montoiva: (0, _varios.round)(parseFloat(miva) * parseFloat(response.data[i].cantidad), 2),
	              descuento: response.data[i].descuento,
	              total: response.data[i].cantidad * response.data[i].punitario,
	              unidad: uni,
	              idunidadmedida: response.data[i].idunidadmedida,
	              idunidadalterna: response.data[i].idunidadalterna,
	              costocalculado: response.data[i].costocalculado,
	              costocalculadoalter: response.data[i].costocalculadoalter,
	              utipreciomaxi: response.data[i].utipreciomaxi,
	              utipreciomaxialter: response.data[i].utipreciomaxialter,
	              tipounidad: tipouni,
	              valormoneda: monedaCambio.valormoneda,
	              idmoneda: response.data[i].idmoneda,
	              tipofactor: response.data[i].tipofactor,
	              valorfactor: response.data[i].valorfactor,
	              tipoprecio: response.data[i].tipopreciodeta
	            });
	          }
	          setTotales((0, _varios.calcularTotales)(prod));
	          setRecords(prod);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var onCatalogoCliente = function onCatalogoCliente(values) {
	    setCatalogoCliente(false);
	    if (tipoAgente === "cliente") {
	      cmbRif.current.value = values.rif.substring(0, 1);
	      txtRif.current.value = values.rif.substring(1);
	      txtNombreC.current.value = values.nombre;
	      setCliente({
	        idcliente: values.idagente,
	        tiporif: values.rif.substring(0, 1),
	        rif: values.rif.substring(1),
	        nombre: values.nombre
	      });
	    } else {
	      cmbRifV.current.value = values.rif.substring(0, 1);
	      txtRifV.current.value = values.rif.substring(1);
	      txtNombreV.current.value = values.nombre;
	      setVendedor({
	        idvendedor: values.idagente,
	        tiporif: values.rif.substring(0, 1),
	        rif: values.rif.substring(1),
	        nombre: values.nombre,
	        idalmacen: values.idalmacen
	      });
	      if (values.idalmacen === null || values.idalmacen === "" || values.idalmacen === 0) {
	        setListaProductos([]);
	        setTodosProductos([]);
	        setRecords([]);
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificacion",
	          texto: "el vendedor no tiene un almacen asociado!",
	          icono: "informacion"
	        });
	      } else {
	        seleccionarRegistros(values.idalmacen);
	      }
	    }
	  };
	
	  var oncatalogoPedidoEntrega = function oncatalogoPedidoEntrega(values) {
	    setCatalogoPedido(false);
	    if (values !== "") {
	      txtNumPedido.current.value = values.numpedido;
	      seleccionarRegistro();
	      setActimprime(1);
	    } else {
	      setActimprime(0);
	    }
	  };
	
	  var onChangeMoneda = function onChangeMoneda(e) {
	    var i = e.target.value;
	    var cambio = (0, _varios.onCambioMoneda)({
	      moneda: combomoneda[i],
	      productos: records,
	      monedaPre: moneda,
	      monedaSub: monedaSub
	    });
	    setMonedaCambio(cambio.monedacambio);
	    setRecords(cambio.data);
	  };
	
	  var onChangeUnidad = function onChangeUnidad(i) {
	    return function (e) {
	      var cambiounidad = (0, _varios.onCambioUnidad)({
	        idunidad: e.target.value,
	        index: i,
	        productos: records
	      });
	      setMensaje(cambiounidad.msm);
	      setRecords(cambiounidad.data);
	      setTotales(cambiounidad.totales);
	    };
	  };
	
	  var onChangeTipoPrecio = function onChangeTipoPrecio(i) {
	    return function (e) {
	      var data = [].concat(_toConsumableArray(records));
	      var tipoprecio = parseInt(e.target.value);
	      var tipounidad = data[i].tipounidad;
	      var cantidad = data[i].cantidad;
	      var precio = 0.0;
	      var total = 0.0;
	
	      if (tipounidad === 1) {
	        if (tipoprecio === 1) {
	          precio = parseFloat(data[i].preciomaxialter);
	        } else if (tipoprecio === 2) {
	          precio = parseFloat(data[i].precioofealter);
	        } else if (tipoprecio === 3) {
	          precio = parseFloat(data[i].preciomayoralter);
	        } else if (tipoprecio === 4) {
	          precio = parseFloat(data[i].preciominialter);
	        }
	      } else {
	        if (tipoprecio === 1) {
	          precio = parseFloat(data[i].preciomaxi);
	        } else if (tipoprecio === 2) {
	          precio = parseFloat(data[i].precioofe);
	        } else if (tipoprecio === 3) {
	          precio = parseFloat(data[i].preciomayor);
	        } else if (tipoprecio === 4) {
	          precio = parseFloat(data[i].preciomini);
	        }
	      }
	
	      total = precio * cantidad;
	      var montoiv = parseFloat(precio) * parseFloat(data[i].iva) / 100;
	
	      data[i].tipoprecio = e.target.value;
	      data[i].precio = precio;
	      data[i].total = total;
	      data[i].montoiva = (0, _varios.round)(montoiv * cantidad, 2);
	
	      setRecords(data);
	      setTotales((0, _varios.calcularTotales)(data));
	    };
	  };
	
	  var seleccionarProducto = function seleccionarProducto(index, idubi, idprod) {
	    var endpoint = op.conexion + "/api/inventario/seleccionarproductoinv?idproducto='" + idprod.toUpperCase() + "'&idalmacen=" + idubi;
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var data = [].concat(_toConsumableArray(records));
	        if (response.data !== "") {
	          if (response.data.servicio) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "no existe un producto con ese codigo en el almacen.",
	              icono: "error"
	            });
	            txtCantidad.current[records.length - 1].value = "1,00";
	          } else {
	            for (var i = 0; i < records.length; i++) {
	              if (records[i].idproducto === response.data.idproducto) {
	                setActivate(false);
	                setMensaje({
	                  mostrar: true,
	                  titulo: "Notificacion",
	                  texto: "el producto ya ha sido seleccionado.",
	                  icono: "error"
	                });
	                return;
	              }
	            }
	
	            var uni = [];
	            var precio = 0.0;
	            var montoiva = 0.0;
	            var cantie = response.data.cantidad;
	            var tipouni = 0;
	            var tiene_iva = false;
	            var tipoprecio = parseInt(response.data.tipoprecio);
	
	            if (parseFloat(response.data.ivaventa) > 0.0) {
	              tiene_iva = true;
	            }
	
	            if (parseInt(response.data.tipofactor) === 0 || response.data.tipofactor === null) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data.idunidadmedida,
	                descripcion: response.data.descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data.cantidad);
	              cantie = Math.trunc(cantie);
	
	              if (tipoprecio === 1) {
	                precio = parseFloat(response.data.preciomaxi);
	              } else if (tipoprecio === 2) {
	                precio = parseFloat(response.data.precioofe);
	              } else if (tipoprecio === 3) {
	                precio = parseFloat(response.data.preciomayor);
	              } else if (tipoprecio === 4) {
	                precio = parseFloat(response.data.preciomini);
	              }
	            } else {
	              if (response.data.idunidadventa === response.data.idunidadalterna) {
	                tipouni = 1;
	                uni = [{
	                  idunidad: response.data.idunidadalterna,
	                  descripcion: response.data.descripcionunialt,
	                  tipo: "alterna"
	                }, {
	                  idunidad: response.data.idunidadmedida,
	                  descripcion: response.data.descripcionuni,
	                  tipo: "medida"
	                }];
	
	                cantie = parseFloat(response.data.cantidad);
	                cantie = Math.trunc(cantie);
	                if (tipoprecio === 1) {
	                  precio = parseFloat(response.data.preciomaxialter);
	                } else if (tipoprecio === 2) {
	                  precio = parseFloat(response.data.precioofealter);
	                } else if (tipoprecio === 3) {
	                  precio = parseFloat(response.data.preciomayoralter);
	                } else if (tipoprecio === 4) {
	                  precio = parseFloat(response.data.preciominialter);
	                }
	              } else if (response.data.idunidadventa === response.data.idunidadmedida) {
	                tipouni = 0;
	                uni = [{
	                  idunidad: response.data.idunidadmedida,
	                  descripcion: response.data.descripcionuni,
	                  tipo: "medida"
	                }, {
	                  idunidad: response.data.idunidadalterna,
	                  descripcion: response.data.descripcionunialt,
	                  tipo: "alterna"
	                }];
	
	                cantie = parseFloat(response.data.cantidad / response.data.valorfactor);
	                cantie = Math.trunc(cantie);
	
	                if (tipoprecio === 1) {
	                  precio = parseFloat(response.data.preciomaxi);
	                } else if (tipoprecio === 2) {
	                  precio = parseFloat(response.data.precioofe);
	                } else if (tipoprecio === 3) {
	                  precio = parseFloat(response.data.preciomayor);
	                } else if (tipoprecio === 4) {
	                  precio = parseFloat(response.data.preciomini);
	                }
	              }
	            }
	
	            montoiva = precio * response.data.ivaventa / 100;
	
	            if (index !== null) {
	              data[index] = {
	                idproducto: response.data.idproducto,
	                codigo: response.data.codigo,
	                cantidad: 1.0,
	                cantidadE: cantie,
	                cantidadEA: parseFloat(response.data.cantidad),
	                nombrecorto: response.data.nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	                precio: precio,
	                preciobs: 0.0,
	                preciomaxi: response.data.preciomaxi,
	                precioofe: response.data.precioofe,
	                preciomayor: response.data.preciomayor,
	                preciomini: response.data.preciomini,
	                preciomaxialter: response.data.preciomaxialter,
	                precioofealter: response.data.precioofealter,
	                preciomayoralter: response.data.preciomayoralter,
	                preciominialter: response.data.preciominialter,
	                iva: response.data.ivaventa,
	                montoiva: (0, _varios.round)(montoiva, 2),
	                descuento: 0.0,
	                total: precio,
	                unidad: uni,
	                idunidadmedida: response.data.idunidadmedida,
	                idunidadalterna: response.data.idunidadalterna,
	                idmoneda: response.data.idmoneda,
	                valormoneda: monedaCambio.valormoneda,
	                tipounidad: tipouni,
	                tipofactor: response.data.tipofactor,
	                valorfactor: response.data.valorfactor,
	                tipoprecio: response.data.tipoprecio
	              };
	            } else {
	              data.push({
	                idproducto: response.data.idproducto,
	                codigo: response.data.codigo,
	                cantidad: 1.0,
	                cantidadE: cantie,
	                cantidadEA: parseFloat(response.data.cantidad),
	                nombrecorto: response.data.nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	                precio: precio,
	                preciomaxi: response.data.preciomaxi,
	                precioofe: response.data.precioofe,
	                preciomayor: response.data.preciomayor,
	                preciomini: response.data.preciomini,
	                preciomaxialter: response.data.preciomaxialter,
	                precioofealter: response.data.precioofealter,
	                preciomayoralter: response.data.preciomayoralter,
	                preciominialter: response.data.preciominialter,
	                preciobs: 0.0,
	                iva: response.data.ivaventa,
	                montoiva: (0, _varios.round)(montoiva, 2),
	                descuento: 0.0,
	                total: precio,
	                unidad: uni,
	                idunidadmedida: response.data.idunidadmedida,
	                idunidadalterna: response.data.idunidadalterna,
	                idmoneda: response.data.idmoneda,
	                valormoneda: monedaCambio.valormoneda,
	                tipounidad: tipouni,
	                tipofactor: response.data.tipofactor,
	                valorfactor: response.data.valorfactor,
	                tipoprecio: response.data.tipoprecio
	              });
	            }
	
	            setRecords(data);
	            setTotales((0, _varios.calcularTotales)(data));
	            setIndice(index);
	
	            if (index !== null) {
	              setTimeout(function () {
	                return txtCantidad.current[index].focus();
	              }, 300);
	            } else {
	              setTimeout(function () {
	                return txtCantidad.current[data.length - 1].focus();
	              }, 300);
	            }
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "no existe un producto con ese codigo en el almacen.",
	            icono: "error"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var validarIdProducto = function validarIdProducto(index) {
	    return function (event) {
	      if (event.which === 13 || typeof event.which === "undefined") {
	        if (event.target.value !== "") {
	          if (vendedor.idalmacen !== "" && vendedor.idalmacen !== null) {
	            seleccionarProducto(index, vendedor.idalmacen, event.target.value);
	          } else {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación.",
	              texto: "debe seleccionar un vendedor.",
	              icono: "informacion"
	            });
	            txtRifV.current.focus();
	          }
	        }
	      }
	    };
	  };
	
	  var agregarProducto = function agregarProducto(producto) {
	    seleccionarProducto(indice, vendedor.idalmacen, producto.codigo);
	    setMostrar(false);
	  };
	
	  var eliminarProducto = function eliminarProducto(producto) {
	    return function (e) {
	      e.preventDefault();
	      var data = [].concat(_toConsumableArray(records));
	      var elementos = [];
	
	      for (var i = 0; i < data.length; i++) {
	        if (producto.idproducto !== data[i].idproducto) {
	          elementos.push(data[i]);
	        }
	      }
	      setRecords(elementos);
	      setTotales((0, _varios.calcularTotales)(elementos));
	    };
	  };
	
	  var seleccionarxIndice = function seleccionarxIndice(index) {
	    return function (e) {
	      e.preventDefault();
	      if (vendedor.idalmacen !== "" && vendedor.idalmacen !== null) {
	        setMostrar(true);
	        setIndice(index);
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación.",
	          texto: "debe seleccionar un vendedor.",
	          icono: "informacion"
	        });
	        txtRifV.current.focus();
	      }
	    };
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    event.preventDefault();
	    if (event.which === 13) {
	      if (event.target.name === "fecha") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	        btnProducto.current.focus();
	      }
	    } else if (typeof event.which === "undefined") {
	      if (event.target.name === "fecha") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false; //alert(e.which);
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	
	    if (cmbRif.current.value === "" || txtRif.current.value.trim() === "" || txtNombreC.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Cliente no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtRif.current.focus();
	    } else if (cmbRifV.current.value === "" || txtRifV.current.value.trim() === "" || txtNombreV.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Vendedor no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtRifV.current.focus();
	    } else if (txtFecha.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtFecha.current.focus();
	    } else if (records.length === 0) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "No hay Productos agregados",
	        icono: "informacion"
	      });
	      sigue = false;
	      btnCancela.current.focus();
	    }
	
	    if (sigue) {
	      var pedi = [];
	      var pedidet = [];
	      var opeinv = [];
	      var opeinvdet = [];
	
	      pedi.push({
	        idpedido: pedido.idpedido,
	        numpedido: pedido.numpedido,
	        cedularif: cliente.tiporif + cliente.rif,
	        descripcion: "PEDIDO DE PRODUCTO",
	        totalmonto: totales.total,
	        totaliva: totales.totaliva,
	        totaldescuento: totales.descuento,
	        totalsujeto: totales.sujeto,
	        totalexento: totales.exento,
	        idcliente: cliente.idcliente,
	        idvendedor: vendedor.idvendedor,
	        fecha: txtFecha.current.value,
	        status: pedido.status,
	        idalmacen: vendedor.idalmacen,
	        idmoneda: monedaSub.idmoneda,
	        idoperacioninventario: pedido.idoperacioninventario
	      });
	
	      opeinv.push({
	        idoperacioninventario: pedido.idoperacioninventario === null || pedido.idoperacioninventario === "" ? "0" : pedido.idoperacioninventario,
	        tipooperacion: "SALIDA",
	        idalmacenorigen: vendedor.idalmacen,
	        idalmacendestino: "",
	        fecha: txtFecha.current.value,
	        idmoneda: monedaSub.idmoneda,
	        observacion: "PEDIDO"
	      });
	
	      for (var i = 0; i < records.length; i++) {
	        pedidet.push({
	          idproducto: records[i].idproducto,
	          cantidad: records[i].cantidad,
	          iva: records[i].iva,
	          punitario: records[i].precio,
	          descuento: "0.00",
	          tipounidad: records[i].tipounidad,
	          idunidadmedida: records[i].idunidadmedida,
	          idunidadalterna: records[i].idunidadalterna,
	          tasa: monedaSub.valormoneda,
	          codproducto: records[i].codigo,
	          costo: records[i].costocalculado,
	          utilidad: records[i].utipreciomaxi,
	          tipopreciodeta: records[i].tipoprecio
	        });
	
	        opeinvdet.push({
	          idproducto: records[i].idproducto,
	          nombre: records[i].nombrecorto,
	          cantidad: records[i].cantidad,
	          precio: records[i].precio,
	          fechavencimiento: "",
	          tipomovimiento: "VENTA",
	          fechatipomovimiento: txtFecha.current.value,
	          numfactura: pedido.numpedido,
	          idalmacen: vendedor.idalmacen,
	          tipounidad: records[i].tipounidad,
	          idunidadmedida: records[i].idunidadmedida,
	          idunidadalterna: records[i].idunidadalterna,
	          tipofactor: records[i].tipofactor,
	          valorfactor: records[i].valorfactor,
	          tasa: monedaSub.valormoneda
	        });
	      }
	
	      setBody({
	        notaentre: pedi,
	        notaentredet: pedidet,
	        idtipopeinv: "2",
	        opeinv: opeinv,
	        opeinvdet: opeinvdet
	      });
	
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      if (pedido.status === 1) {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificacion",
	          texto: "el pedido ya fue procesado.",
	          icono: "error"
	        });
	      } else if (pedido.status === 4) {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificacion",
	          texto: "el pedido ya fue anulado",
	          icono: "error"
	        });
	      } else {
	        setMensajesino({
	          mostrar: true,
	          titulo: "Confirmación.",
	          texto: msg,
	          icono: "confirmacion"
	        });
	      }
	    }
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (accbtnpedidos && accbtnpedidos.toString().substring(0, 1) === "1") {
	          setTituloHeader("Incluir Pedido.");
	          setOperacion(op);
	          setHabilitado(true);
	          setHabilitadoCli(true);
	          setHabilitadoProductos(false);
	          setHabilitarMoneda(true);
	          setVisibleBtn("hidden");
	          setHabilitadoBot(false);
	          setHabilitarCat(true);
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          //txtNumPedido.current.value = "0";
	          //txtNumPedido.current.focus();
	
	          setTimeout(function () {
	            return txtRifV.current.focus();
	          }, 300);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (accbtnpedidos && accbtnpedidos.toString().substring(1, 2) === "1") {
	          setTituloHeader("Modificar Pedido.");
	          setOperacion(op);
	          setVisibleBtn("hidden");
	          setHabilitadoBot(false);
	          txtNumPedido.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitado(false);
	          setHabilitadoCli(false);
	          setHabilitadoProductos(false);
	          txtNumPedido.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (accbtnpedidos && accbtnpedidos.toString().substring(3, 4) === "1") {
	          setTituloHeader("Eliminar Pedido.");
	          setVisibleBtn("hidden");
	          setHabilitadoBot(false);
	          setOperacion(op);
	          txtNumPedido.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitado(false);
	          setHabilitadoCli(false);
	          setHabilitadoProductos(true);
	          setHabilitarMoneda(false);
	          txtNumPedido.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (accbtnpedidos && accbtnpedidos.toString().substring(2, 3) === "1") {
	          setTituloHeader("Consultar Pedido.");
	          setVisibleBtn("hidden");
	          setHabilitadoBot(false);
	          setOperacion(op);
	          txtNumPedido.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitado(false);
	          setHabilitadoCli(false);
	          setHabilitadoProductos(true);
	          setHabilitarMoneda(true);
	          txtNumPedido.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        blanquear();
	      }
	    };
	  };
	
	  var validarPrecio = function validarPrecio(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	          event.target.value = "1,00";
	        }
	        event.target.value = (0, _varios.formatoMonto)(event.target.value);
	        var char1 = event.target.value.substring(0, 1);
	        var char2 = event.target.value.substring(1, 2);
	        if (char1 === "0" && char2 !== ",") {
	          event.target.value = event.target.value.substring(1, event.target.value.length);
	        }
	        if (event.target.id === "precio") {
	          var data = [].concat(_toConsumableArray(records));
	          var info = [];
	
	          var preci = parseFloat(event.target.value.replace(/\./g, "").replace(",", "."));
	
	          var montoiv = parseFloat(preci) * parseFloat(data[index].iva) / 100;
	
	          data[index].precio = preci;
	          data[index].total = preci * data[index].cantidad;
	          data[index].montoiva = (0, _varios.round)(montoiv * data[index].cantidad, 2);
	
	          setRecords(data);
	          setTotales((0, _varios.calcularTotales)(data));
	        }
	      } else if (event.which === 46) {
	        return false;
	      } else if (event.which >= 48 && event.which <= 57) {
	        return true;
	      } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	        return true;
	      } else return false;
	    };
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarMonedas();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 ", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12 mx-auto py-2  card shadow " },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row border-azul mx-auto justify-content-between rounded py-2" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-2 azulGradiant shadow text-light justify-content-between" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-4" },
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  tituloHeader
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 d-flex justify-content-end" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "/inicio", className: "text-light " },
	                  _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "fw-bold" },
	                    "Salir"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "row col-md-12 mx-auto mb-1 p-0 m-0 justify-content-between",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              operacion !== 1 && _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-pd-283 px-2" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text fw-bold text-black",
	                    id: "input-id"
	                  },
	                  "CODIGO:"
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  disabled: true,
	                  ref: txtNumPedido,
	                  name: "numpedido",
	                  autoComplete: "off",
	                  onKeyUp: validarNumPedido,
	                  onBlur: validarNumPedido,
	                  onChange: function onChange(e) {
	                    return e.target.value = e.target.value.toUpperCase();
	                  },
	                  className: "form-control fs-6 text-danger",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "input-id"
	                }),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: habilitarCat,
	                    type: "button",
	                    onClick: function onClick() {
	                      return setCatalogoPedido(true);
	                    },
	                    className: "btn btn-success"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-search" })
	                )
	              ),
	              operacion !== 1 && _react2.default.createElement(
	                "div",
	                { className: "mb-2 col-pd-240" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "ESTATUS:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: txtStatus,
	                      style: {
	                        fontWeight: "bold",
	                        color: pedido.status === 0 ? "#007bff" : pedido.status === 1 ? "#28a745" : pedido.status === 4 ? "#dc3545" : "#000000"
	                      },
	                      disabled: true,
	                      className: "form-select form-select-sm text-uppercase px-1",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "0" },
	                      "PENDIENTE"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "PROCESADO"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "4" },
	                      "ANULADO"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-pd-290" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text fw-bold text-black",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "TIPO MONEDA:"
	                ),
	                _react2.default.createElement(
	                  "select",
	                  {
	                    className: "form-control form-control-sm px-1 fw-bold text-center",
	                    disabled: !habilitarMoneda,
	                    ref: cmbMoneda,
	                    onChange: onChangeMoneda
	                  },
	                  combomoneda && combomoneda.map(function (item, index) {
	                    return _react2.default.createElement(
	                      "option",
	                      { key: index, value: index },
	                      " ",
	                      item.descripcion + " " + item.simbolo + " " + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                      " "
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-pd-220 ml-auto" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text fw-bold text-black",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "FECHA:"
	                ),
	                _react2.default.createElement("input", {
	                  autoComplete: "off",
	                  type: "date",
	                  disabled: !habilitado,
	                  ref: txtFecha,
	                  className: "form-control fs-6 text-uppercase",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  name: "fecha",
	                  onKeyUp: handleInputChange,
	                  onBlur: handleInputChange
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row col-12 m-0 p-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-1 col-md-6" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "fw-bold text-black" },
	                      "VENDEDOR"
	                    ),
	                    ":",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: cmbRifV,
	                      name: "cmbrif",
	                      style: { maxWidth: 60 },
	                      disabled: !habilitadoCli,
	                      className: "form-select form-select-sm col-md-3 text-center ",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _varios.cmbCedula && _varios.cmbCedula.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.value },
	                        " ",
	                        item.value,
	                        " "
	                      );
	                    })
	                  ),
	                  _react2.default.createElement("input", {
	                    ref: txtRifV,
	                    autoComplete: "off",
	                    style: { maxWidth: 90 },
	                    disabled: !habilitadoCli,
	                    maxLength: 9,
	                    type: "text",
	                    className: "form-control col-md-4 fs-6",
	                    name: "cedula",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: validarVendedor,
	                    onBlur: validarVendedor
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoCli,
	                      type: "button",
	                      onClick: function onClick() {
	                        setTipoAgente("vendedor");
	                        setCatalogoCliente(true);
	                      },
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    ref: txtNombreV,
	                    autoComplete: "off",
	                    disabled: true,
	                    name: "nombres",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-1 col-md-6" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "fw-bold text-black" },
	                      "CLIENTE"
	                    ),
	                    ":",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: cmbRif,
	                      name: "cmbrif",
	                      style: { maxWidth: 60 },
	                      disabled: !habilitadoCli,
	                      className: "form-select form-select-sm col-md-3 text-center text-uppercase",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _varios.cmbCedula.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.value },
	                        " ",
	                        item.value,
	                        " "
	                      );
	                    })
	                  ),
	                  _react2.default.createElement("input", {
	                    ref: txtRif,
	                    autoComplete: "off",
	                    disabled: !habilitadoCli,
	                    style: { maxWidth: 100 },
	                    maxLength: 9,
	                    type: "text",
	                    className: "form-control col-md-5 fs-6",
	                    name: "cedula",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: validarCliente,
	                    onBlur: validarCliente
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoCli,
	                      type: "button",
	                      onClick: function onClick() {
	                        setTipoAgente("cliente");
	                        setCatalogoCliente(true);
	                      },
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    ref: txtNombreC,
	                    autoComplete: "off",
	                    disabled: true,
	                    name: "nombres",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row col-md-8 p-0 m-0" },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-md-12 border-azul rounded px-0",
	                  style: { backgroundColor: "#d5e9ff" }
	                },
	                _react2.default.createElement(
	                  TblContainer,
	                  {
	                    container: {
	                      height: 300,
	                      width: "100%",
	                      overflow: "auto",
	                      padding: "2px",
	                      fontSizeAdjust: "0.6"
	                    }
	                  },
	                  _react2.default.createElement(TblHead, null),
	                  _react2.default.createElement(
	                    _core.TableBody,
	                    { className: "overflow-hidden" },
	                    records && records.map(function (item, index) {
	                      return _react2.default.createElement(
	                        _core.TableRow,
	                        { key: index, style: { padding: "0" } },
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          { className: "bg-light d-flex align-items-between px-0" },
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            style: {
	                              borderBottomRightRadius: 0,
	                              borderTopRightRadius: 0
	                            },
	                            disabled: habilitadoProductos,
	                            ref: function ref(el) {
	                              return txtId.current[index] = el;
	                            },
	                            className: "form-control form-control-sm bg-light fs-6",
	                            defaultValue: item.codigo,
	                            onChange: function onChange(e) {
	                              return e.target.value = e.target.value.toUpperCase();
	                            },
	                            onKeyUp: validarIdProducto(index),
	                            onBlur: validarIdProducto(index)
	                          }),
	                          (operacion === 1 || operacion === 2) && _react2.default.createElement(
	                            "button",
	                            {
	                              type: "button",
	                              style: {
	                                borderBottomLeftRadius: 0,
	                                borderTopLeftRadius: 0
	                              },
	                              disabled: habilitadoProductos,
	                              onClick: seleccionarxIndice(index),
	                              className: "btn btn-sm btn-primary"
	                            },
	                            _react2.default.createElement(
	                              "i",
	                              { className: "fas " },
	                              "-"
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-middle bg-light text-start p-0 pl-2",
	                            style: { width: "150px" }
	                          },
	                          item.nombrecorto
	                        ),
	                        operacion === 4 ? "" : _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-middle bg-light text-end p-0 pr-2",
	                            style: { width: "30px" }
	                          },
	                          (0, _varios.formatMoneda)(item.cantidadE.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          { className: "align-middle bg-light text-center p-0" },
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control form-control-sm bg-light text-right fs-6 col-pd-90 mx-auto",
	                            id: "cantidad",
	                            disabled: !habilitado,
	                            defaultValue: (0, _varios.formatMoneda)(item.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                            ref: function ref(el) {
	                              return txtCantidad.current[index] = el;
	                            },
	                            onFocus: _varios.seleccionarCampo,
	                            onKeyUp: validarCantidadP(index),
	                            onBlur: validarCantidadP(index)
	                          })
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-middle bg-light p-0",
	                            style: { width: 50 }
	                          },
	                          _react2.default.createElement(
	                            "select",
	                            {
	                              className: "form-control form-control-sm fs-6",
	                              style: { width: "100%" },
	                              disabled: habilitadoProductos,
	                              defaultValue: item.tipoprecio,
	                              onChange: onChangeTipoPrecio(index)
	                            },
	                            _varios.comboprecios.map(function (item2, x) {
	                              return _react2.default.createElement(
	                                "option",
	                                { key: x, value: item2.id },
	                                " ",
	                                item2.nombre,
	                                " "
	                              );
	                            })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-middle bg-light text-end p-0 pr-2",
	                            style: { width: "50px" }
	                          },
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            disabled: !habilitado,
	                            onKeyUp: validarPrecio(index),
	                            onBlur: validarPrecio(index),
	                            className: "form-control form-control-sm bg-light text-right fs-6",
	                            id: "precio",
	                            defaultValue: (0, _varios.formatMoneda)(item.precio.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                            ref: function ref(el) {
	                              return txtPrecio.current[index] = el;
	                            }
	                          })
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-middle bg-light text-end p-0 pr-2",
	                            style: { width: "50px" }
	                          },
	                          (0, _varios.formatMoneda)((item.montoiva * item.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-middle bg-light p-0",
	                            style: { width: 50 }
	                          },
	                          _react2.default.createElement(
	                            "select",
	                            {
	                              className: "form-control form-control-sm fs-6",
	                              style: { width: "100%" },
	                              disabled: habilitadoProductos,
	                              onChange: onChangeUnidad(index)
	                            },
	                            item.unidad && item.unidad.map(function (item2, x) {
	                              return _react2.default.createElement(
	                                "option",
	                                { key: x, value: item2.idunidad },
	                                " ",
	                                item2.descripcion,
	                                " "
	                              );
	                            })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-middle bg-light text-end p-0",
	                            style: { width: "50px" }
	                          },
	                          (0, _varios.formatMoneda)((item.precio * item.cantidad * item.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-middle bg-light text-center p-0",
	                            style: { width: "20px" }
	                          },
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              disabled: !habilitado,
	                              style: {
	                                visibility: (operacion === 4 || operacion === 3) && "collapse"
	                              },
	                              onClick: eliminarProducto(item),
	                              className: "btn btn-sm btn-danger"
	                            },
	                            _react2.default.createElement("i", { className: "fa fa-trash" }),
	                            " "
	                          )
	                        )
	                      );
	                    }),
	                    _react2.default.createElement(
	                      _core.TableRow,
	                      {
	                        style: {
	                          padding: "0",
	                          visibility: (operacion === 4 || operacion === 0 || operacion === 3) && "collapse"
	                        }
	                      },
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-center p-0 d-flex" },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          disabled: habilitadoProductos,
	                          style: {
	                            borderBottomRightRadius: 0,
	                            borderTopRightRadius: 0
	                          },
	                          className: "form-control form-control-sm bg-light text-right",
	                          onChange: function onChange(e) {
	                            return e.target.value = e.target.value.toUpperCase();
	                          },
	                          onKeyUp: validarIdProducto(null),
	                          onBlur: validarIdProducto(null)
	                        }),
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            type: "button",
	                            disabled: habilitadoProductos,
	                            style: {
	                              borderBottomLeftRadius: 0,
	                              borderTopLeftRadius: 0
	                            },
	                            onClick: seleccionarxIndice(null),
	                            className: "btn btn-sm btn-primary"
	                          },
	                          _react2.default.createElement(
	                            "i",
	                            { className: "fas " },
	                            "-"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(_core.TableCell, {
	                        className: "align-middle bg-light text-start p-0 pl-2",
	                        style: { width: "50px" }
	                      }),
	                      operacion === 4 ? "" : _react2.default.createElement(_core.TableCell, {
	                        className: "align-middle bg-light text-end p-0 pr-2",
	                        style: { width: "30px" }
	                      }),
	                      _react2.default.createElement(_core.TableCell, {
	                        className: "align-middle bg-light text-center p-0",
	                        style: { width: "20px" }
	                      }),
	                      _react2.default.createElement(_core.TableCell, {
	                        className: "align-middle bg-light p-0",
	                        style: { width: 50 }
	                      }),
	                      _react2.default.createElement(_core.TableCell, {
	                        className: "align-middle bg-light text-end p-0 pr-2",
	                        style: { width: "50px" }
	                      }),
	                      _react2.default.createElement(_core.TableCell, {
	                        className: "align-middle bg-light text-end p-0 pr-2",
	                        style: { width: "50px" }
	                      }),
	                      _react2.default.createElement(_core.TableCell, {
	                        className: "align-middle bg-light p-0",
	                        style: { width: 50 }
	                      }),
	                      _react2.default.createElement(_core.TableCell, {
	                        className: "align-middle bg-light text-end p-0",
	                        style: { width: "50px" }
	                      }),
	                      _react2.default.createElement(_core.TableCell, {
	                        className: "align-middle bg-light text-center p-0",
	                        style: { width: "20px" }
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "border-table rounded p-2 shadow col-pd-420",
	                    style: {
	                      backgroundColor: "#dbeeff",
	                      borderTop: "none",
	                      fontSizeAdjust: "0.6"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm  col-md-12" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text bg-transparent border-0",
	                        style: { fontSize: 14 },
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "SUBTOTAL: ",
	                      monedaCambio.simbolo
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      disabled: true,
	                      ref: txtSubTotal,
	                      value: (0, _varios.formatMoneda)((totales.subtotal * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                      className: "form-control bg-transparent fw-bold text-right rounded border-0 fs-5",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "input-group input-group-sm col-md-12",
	                      style: { fontSizeAdjust: "0.6" }
	                    },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text bg-transparent border-0",
	                        id: "inputGroup-sizing-sm",
	                        style: { fontSize: 14 }
	                      },
	                      "EXENTO ",
	                      monedaCambio.simbolo,
	                      ":"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      disabled: true,
	                      ref: txtExentoTotal,
	                      value: (0, _varios.formatMoneda)((totales.exento * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                      className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm  col-md-12" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text bg-transparent border-0",
	                        style: { fontSize: 14 },
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "DESCUENTO: ",
	                      monedaCambio.simbolo
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      disabled: true,
	                      ref: txtDescuento,
	                      value: (0, _varios.formatMoneda)((totales.descuento * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                      className: "form-control bg-transparent fw-bold text-right rounded border-0 fs-5",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm  col-md-12" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text bg-transparent border-0",
	                        style: { fontSize: 14 },
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "IVA ",
	                      monedaCambio.simbolo,
	                      ":"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      disabled: true,
	                      ref: txtTotIva,
	                      value: (0, _varios.formatMoneda)((totales.totaliva * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                      className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm  col-md-12" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text bg-transparent border-0",
	                        style: { fontSize: 14 },
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "TOTAL: ",
	                      monedaCambio.simbolo
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      disabled: true,
	                      ref: txtTotal,
	                      value: (0, _varios.formatMoneda)((totales.total * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                      className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4 mx-auto ocultaproductos" },
	              _react2.default.createElement(
	                "div",
	                { className: "row card col-md-12 mx-auto p-3" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 row mx-auto" },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-md-12 row mx-auto azulGradiant rounded py-2",
	                      style: { verticalAlign: "middle" }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm mb-2 col-md-4 my-auto" },
	                      _react2.default.createElement("input", {
	                        autoComplete: "off",
	                        onChange: handleSearch,
	                        type: "text",
	                        placeholder: "BUSCAR",
	                        className: "form-control rounded-pill",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm"
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "h4",
	                      { className: "col-md-6 text-center mx-auto text-light fw-bold" },
	                      "LISTA DE PRODUCTOS"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "row col-md-12 mx-auto overflow-scroll rounded px-2 py-3",
	                      style: {
	                        height: "300px",
	                        backgroundColor: "rgb(230, 238, 249)"
	                      }
	                    },
	                    listaProductos && listaProductos.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "button",
	                        {
	                          key: index,
	                          onClick: function onClick() {
	                            return agregarProducto(item);
	                          },
	                          disabled: habilitadoProductos,
	                          className: "btn zoom hover-overlay col-md-2 bg-gradient p-0 m-0",
	                          style: { minHeight: "50px", maxHeight: "50px" }
	                        },
	                        _react2.default.createElement("img", {
	                          className: "img-fluid h-100 w-100 ",
	                          style: { objectFit: "contain" },
	                          src: op.conexion + "/imagen?img=" + organizacion + "/productos/" + item.imagen
	                        }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "mask rounded p-2" },
	                          _react2.default.createElement(
	                            "div",
	                            {
	                              className: "col-md-12 fixed-bottom py-1 border-top  bg-light",
	                              style: { verticalAlign: "middle" }
	                            },
	                            _react2.default.createElement(
	                              "span",
	                              {
	                                className: "text-center",
	                                style: {
	                                  fontSize: "6px",
	                                  color: "rgb(3, 18, 47)"
	                                }
	                              },
	                              item.nombrecorto.substring(0, 20)
	                            )
	                          )
	                        )
	                      );
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row col-md-12 mx-auto d-flex justify-content-between  align-items-end mt-3" },
	              visibleBtn === "visible" ? _react2.default.createElement(
	                "div",
	                { className: "col-pd-520 px-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 row m-0" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoBot,
	                      ref: btnIncluir,
	                      onClick: onBotones(1),
	                      className: "btn btn-sm ml-1 col mb-1 btn-primary rounded-pill",
	                      title: "Incluir Pedido"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-plus" },
	                      " Incluir "
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoBot,
	                      ref: btnConsultar,
	                      onClick: onBotones(4),
	                      className: "btn btn-sm ml-1 col mb-1 btn-info rounded-pill",
	                      title: "Consultar Pedido"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-eye" },
	                      " Consultar"
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoBot,
	                      ref: btnEditar,
	                      onClick: onBotones(2),
	                      className: "btn btn-sm ml-1 mb-1 col btn-warning rounded-pill",
	                      title: "Modificar Pedido"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-edit" },
	                      " Modificar"
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoBot,
	                      ref: btnEliminar,
	                      onClick: onBotones(3),
	                      className: "btn btn-sm ml-1 mb-1 col btn-danger rounded-pill",
	                      title: "Eliminar Pedido"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-trash" },
	                      " Eliminar"
	                    ),
	                    " "
	                  )
	                )
	              ) : _react2.default.createElement(
	                "div",
	                { className: "col-pd-370 row m-0 ml-auto" },
	                operacion === 4 && actimprime === 1 ? _react2.default.createElement(
	                  "button",
	                  {
	                    onClick: imprimirPedido,
	                    disabled: operacion === 4 ? false : true,
	                    className: "btn btn-sm col ml-1 btn-primary rounded-pill",
	                    title: "Imprimir Nota de Entrega"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fa fa-print" },
	                    " Imprimir"
	                  )
	                ) : _react2.default.createElement("dvi", { className: "col-pd-110" }),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta,
	                    disabled: operacion === 4 ? true : habilitadoBot,
	                    onClick: onBotones(5),
	                    className: "btn btn-sm col ml-1 rounded-pill btn-success"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-check-circle" },
	                    " Aceptar"
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnCancela,
	                    disabled: habilitadoBot,
	                    onClick: onBotones(6),
	                    className: "btn btn-danger col ml-1 btn-sm rounded-pill"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-window-close" },
	                    " Cancelar"
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoProductoExistencia2.default, {
	      show: mostrar,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar(false);
	      },
	      onHideAceptaCatalogo: agregarProducto,
	      idalmacen: vendedor.idalmacen
	    }),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: catalogoCliente,
	      nomid: tipoAgente,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoCliente(false);
	      },
	      onHideAceptaCatalogo: onCatalogoCliente
	    }),
	    _react2.default.createElement(_catalogoPedido2.default, {
	      show: catalogoPedido,
	      nomid: "pedido",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoPedido(false);
	      },
	      onHideAceptaCatalogo: oncatalogoPedidoEntrega,
	      condicion: "true"
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return mensaje.titulo === "Exito." ? blanquear() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = TablaPedidos;

/***/ },
/* 7180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(69);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _core = __webpack_require__(19);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoProductoExistencia = __webpack_require__(105);
	
	var _catalogoProductoExistencia2 = _interopRequireDefault(_catalogoProductoExistencia);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _catalogoPedido = __webpack_require__(210);
	
	var _catalogoPedido2 = _interopRequireDefault(_catalogoPedido);
	
	var _modalRegistrarPago = __webpack_require__(7167);
	
	var _modalSupervisor = __webpack_require__(7170);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var TablaPosVenta = function TablaPosVenta() {
	
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var organizacion = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var accbtnpedidos = JSON.parse(sessionStorage.getItem("accbtnpedidosc"));
	  var idagente = JSON.parse(sessionStorage.getItem("idagente"));
	  var tipopre = JSON.parse(sessionStorage.getItem("post"));
	
	  var txtNumPedido = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtStatus = (0, _react.useRef)();
	  var txtId = (0, _react.useRef)([]);
	  var txtCantidad = (0, _react.useRef)([]);
	  var txtNunnota = (0, _react.useRef)();
	  var btnEditar = (0, _react.useRef)();
	  var txtIdnota = (0, _react.useRef)();
	  var txtIdproducto = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var btnProducto = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtFechaVence = (0, _react.useRef)();
	  var txtCredito = (0, _react.useRef)();
	  var txtNombreC = (0, _react.useRef)();
	  var txtNombreV = (0, _react.useRef)();
	  var txtSubTotal = (0, _react.useRef)();
	  var txtDescuento = (0, _react.useRef)();
	  var txtExentoTotal = (0, _react.useRef)();
	  var txtTotIva = (0, _react.useRef)();
	  var txtTotal = (0, _react.useRef)();
	  var txtTotalBs = (0, _react.useRef)();
	  var cmbMoneda = (0, _react.useRef)();
	
	  // Estados para Bluetooth e impresión
	
	  var _useState = (0, _react.useState)({
	    checked: false,
	    available: false,
	    message: 'Bluetooth no activado',
	    support: false,
	    granted: false,
	    isDesktop: false,
	    platform: '',
	    browser: ''
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      bluetoothStatus = _useState2[0],
	      setBluetoothStatus = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({
	    connected: false,
	    device: null,
	    server: null,
	    name: '',
	    scanning: false,
	    printing: false,
	    statusMessage: 'Conecte una impresora Bluetooth',
	    scannedDevice: null,
	    errorDetails: '',
	    services: [],
	    connectionAttempts: 0,
	    printerType: null, // 'jingpu', 'mp80', 'mtp', 'unknown'
	    characteristic: null,
	    service: null
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      printerStatus = _useState4[0],
	      setPrinterStatus = _useState4[1];
	
	  // BASE DE DATOS DE IMPRESORAS CON SUS CONFIGURACIONES
	
	
	  var PRINTER_DATABASE = {
	    'jingpu': {
	      namePatterns: ['jingpu', 'jp', '58mm'],
	      services: ['00001101-0000-1000-8000-00805f9b34fb'], // SPP
	      characteristics: ['0000ff02-0000-1000-8000-00805f9b34fb'],
	      baudRate: 9600,
	      encoding: 'gbk',
	      needsDelay: true,
	      chunkSize: 20
	    },
	    'mp80': {
	      namePatterns: ['mp80', 'mp-80', 'mp80-04'],
	      services: ['00001101-0000-1000-8000-00805f9b34fb', // SPP
	      '49535343-fe7d-4ae5-8fa9-9fafd205e455' // Servicio chino
	      ],
	      characteristics: ['0000ff02-0000-1000-8000-00805f9b34fb', '0000ff01-0000-1000-8000-00805f9b34fb'],
	      baudRate: 115200,
	      encoding: 'utf-8',
	      needsDelay: false,
	      chunkSize: 40
	    },
	    'mtp': {
	      namePatterns: ['mtp', 'mtp-3', 'mtp3'],
	      services: ['00001101-0000-1000-8000-00805f9b34fb', // SPP
	      '000018f0-0000-1000-8000-00805f9b34fb', // Servicio estándar
	      'e7810a71-73ae-499d-8c15-faa9aef0c3f2' // Servicio específico
	      ],
	      characteristics: ['00002af1-0000-1000-8000-00805f9b34fb', 'bef8d6c9-9c21-4c9e-b632-bd58c1009f9f', 'e7810a71-73ae-499d-8c15-faa9aef0c3f2'],
	      baudRate: 9600,
	      encoding: 'utf-8',
	      needsDelay: true,
	      chunkSize: 10,
	      requiresPairing: true
	    }
	  };
	
	  // Servicios universales para probar
	  var UNIVERSAL_SERVICES = ['00001101-0000-1000-8000-00805f9b34fb', // SPP - MÁS IMPORTANTE
	  '49535343-fe7d-4ae5-8fa9-9fafd205e455', // Servicio chino común
	  '000018f0-0000-1000-8000-00805f9b34fb', // Servicio estándar
	  'e7810a71-73ae-499d-8c15-faa9aef0c3f2', // Servicio específico
	  '0000ff00-0000-1000-8000-00805f9b34fb', // Otro común
	  '0000ae00-0000-1000-8000-00805f9b34fb' // Otro común
	  ];
	
	  var UNIVERSAL_CHARACTERISTICS = ['0000ff02-0000-1000-8000-00805f9b34fb', // Característica común 1
	  '0000ff01-0000-1000-8000-00805f9b34fb', // Característica común 2
	  '00002af1-0000-1000-8000-00805f9b34fb', // Característica estándar
	  'bef8d6c9-9c21-4c9e-b632-bd58c1009f9f', // Característica específica
	  'e7810a71-73ae-499d-8c15-faa9aef0c3f2', // Característica específica
	  '0000ae01-0000-1000-8000-00805f9b34fb' // Otra característica
	  ];
	
	  var checkBluetoothSupport = function checkBluetoothSupport() {
	    var isSupported = 'bluetooth' in navigator;
	    setBluetoothStatus(function (prev) {
	      return Object.assign({}, prev, {
	        support: isSupported,
	        message: isSupported ? 'Web Bluetooth disponible' : 'Web Bluetooth no soportado'
	      });
	    });
	  };
	
	  var handleBluetoothChange = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(e) {
	      var isChecked;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              isChecked = e.target.checked;
	
	              if (!isChecked) {
	                _context.next = 6;
	                break;
	              }
	
	              _context.next = 4;
	              return requestBluetoothPermission();
	
	            case 4:
	              _context.next = 8;
	              break;
	
	            case 6:
	              /* if (printerStatus.connected) {
	                disconnectPrinter();
	              } */
	
	              setBluetoothStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  checked: false,
	                  granted: false,
	                  message: 'Bluetooth desactivado'
	                });
	              });
	
	              setPrinterStatus({
	                connected: false,
	                device: null,
	                server: null,
	                name: '',
	                scanning: false,
	                printing: false,
	                statusMessage: 'Bluetooth desactivado',
	                scannedDevice: null,
	                errorDetails: '',
	                services: [],
	                connectionAttempts: 0,
	                printerType: null,
	                characteristic: null,
	                service: null
	              });
	
	            case 8:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function handleBluetoothChange(_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var requestBluetoothPermission = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      var isAvailable;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              if (bluetoothStatus.support) {
	                _context2.next = 4;
	                break;
	              }
	
	              setMensaje({
	                mostrar: true,
	                titulo: "Web Bluetooth no soportado",
	                texto: "Tu navegador no soporta Web Bluetooth",
	                icono: "error"
	              });
	              setBluetoothStatus(function (prev) {
	                return Object.assign({}, prev, { checked: false });
	              });
	              return _context2.abrupt("return");
	
	            case 4:
	              _context2.prev = 4;
	
	              setBluetoothStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  message: 'Verificando Bluetooth...',
	                  checked: true
	                });
	              });
	
	              isAvailable = false;
	              _context2.prev = 7;
	              _context2.next = 10;
	              return navigator.bluetooth.getAvailability();
	
	            case 10:
	              isAvailable = _context2.sent;
	              _context2.next = 17;
	              break;
	
	            case 13:
	              _context2.prev = 13;
	              _context2.t0 = _context2["catch"](7);
	
	              console.log('Error verificando disponibilidad:', _context2.t0);
	              isAvailable = true; // Asumir disponible
	
	            case 17:
	
	              setBluetoothStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  available: isAvailable,
	                  granted: true,
	                  message: isAvailable ? '✅ Bluetooth disponible' : '❌ Bluetooth no disponible'
	                });
	              });
	
	              _context2.next = 24;
	              break;
	
	            case 20:
	              _context2.prev = 20;
	              _context2.t1 = _context2["catch"](4);
	
	              console.error('Error al solicitar permiso:', _context2.t1);
	              setBluetoothStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  available: false,
	                  granted: false,
	                  checked: false,
	                  message: "Error: " + _context2.t1.message
	                });
	              });
	
	            case 24:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[4, 20], [7, 13]]);
	    }));
	
	    return function requestBluetoothPermission() {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  // Detectar tipo de impresora por nombre
	  var detectPrinterType = function detectPrinterType(deviceName) {
	    if (!deviceName) return 'unknown';
	
	    var nameLower = deviceName.toLowerCase();
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = Object.entries(PRINTER_DATABASE)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var _ref3 = _step.value;
	
	        var _ref4 = _slicedToArray(_ref3, 2);
	
	        var type = _ref4[0];
	        var config = _ref4[1];
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = config.namePatterns[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var pattern = _step2.value;
	
	            if (nameLower.includes(pattern.toLowerCase())) {
	              console.log("\uD83D\uDD0D Impresora detectada: " + type + " (" + deviceName + ")");
	              return type;
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	
	      // Si no coincide con ningún patrón conocido
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    if (nameLower.includes('58') || nameLower.includes('58mm')) {
	      return 'jingpu';
	    } else if (nameLower.includes('80') || nameLower.includes('80mm')) {
	      return 'mp80';
	    } else if (nameLower.includes('mtp')) {
	      return 'mtp';
	    }
	
	    return 'unknown';
	  };
	
	  var scanForBluetoothDevices = function () {
	    var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	      var device, printerType, printerInfo;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              if (bluetoothStatus.checked) {
	                _context3.next = 3;
	                break;
	              }
	
	              setMensaje({
	                mostrar: true,
	                titulo: "Bluetooth requerido",
	                texto: "Active primero el Bluetooth",
	                icono: "informacion"
	              });
	              return _context3.abrupt("return");
	
	            case 3:
	
	              setPrinterStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  scanning: true,
	                  statusMessage: 'Buscando impresoras...',
	                  errorDetails: ''
	                });
	              });
	
	              _context3.prev = 4;
	
	              console.log('🔍 Iniciando búsqueda universal...');
	
	              _context3.next = 8;
	              return navigator.bluetooth.requestDevice({
	                acceptAllDevices: true,
	                optionalServices: UNIVERSAL_SERVICES
	              });
	
	            case 8:
	              device = _context3.sent;
	
	
	              console.log('✅ Dispositivo seleccionado:', device.name);
	
	              // Detectar tipo de impresora
	              printerType = detectPrinterType(device.name);
	
	
	              setPrinterStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  scannedDevice: device,
	                  printerType: printerType,
	                  statusMessage: "\u2705 " + device.name + " (" + printerType + ")"
	                });
	              });
	
	              device.addEventListener('gattserverdisconnected', function () {
	                console.log('⚠️ Dispositivo desconectado.');
	                handleAutoReconnect();
	              });
	
	              // Mostrar mensaje específico según tipo
	              printerInfo = '';
	
	              if (printerType === 'jingpu') {
	                printerInfo = 'Impresora Jingpu 58mm detectada. Esta impresora generalmente funciona bien.';
	              } else if (printerType === 'mp80') {
	                printerInfo = 'Impresora MP80-04 detectada. Puede requerir configuración especial.';
	              } else if (printerType === 'mtp') {
	                printerInfo = 'Impresora MTP-3 detectada. En PC, asegúrese de emparejarla primero en la configuración del sistema.';
	              } else {
	                printerInfo = 'Impresora no identificada. Se intentará conexión universal.';
	              }
	
	              setMensaje({
	                mostrar: true,
	                titulo: "Impresora " + device.name + " detectada",
	                texto: printerInfo,
	                icono: "informacion"
	              });
	
	              _context3.next = 23;
	              break;
	
	            case 18:
	              _context3.prev = 18;
	              _context3.t0 = _context3["catch"](4);
	
	              console.error('❌ Error en búsqueda:', _context3.t0);
	
	              setPrinterStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  statusMessage: '❌ Error de búsqueda',
	                  errorDetails: _context3.t0.toString()
	                });
	              });
	
	              setMensaje({
	                mostrar: true,
	                titulo: "Error de búsqueda",
	                texto: _context3.t0.message,
	                icono: "error"
	              });
	
	            case 23:
	              _context3.prev = 23;
	
	              setPrinterStatus(function (prev) {
	                return Object.assign({}, prev, { scanning: false });
	              });
	              return _context3.finish(23);
	
	            case 26:
	            case "end":
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined, [[4, 18, 23, 26]]);
	    }));
	
	    return function scanForBluetoothDevices() {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	
	  // CONEXIÓN UNIVERSAL MEJORADA
	  var connectToPrinter = function () {
	    var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	      var device, printerType, server, serviceFound, characteristicFound, config, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, serviceUUID, service, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, charUUID, characteristic, services, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, _service, characteristics, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, char, _services, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, _service2, _characteristics, _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, _char, testCommand, solution;
	
	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              if (printerStatus.scannedDevice) {
	                _context4.next = 3;
	                break;
	              }
	
	              setMensaje({
	                mostrar: true,
	                titulo: "Primero busque",
	                texto: "Busque un dispositivo Bluetooth primero",
	                icono: "informacion"
	              });
	              return _context4.abrupt("return");
	
	            case 3:
	              device = printerStatus.scannedDevice;
	              printerType = printerStatus.printerType || 'unknown';
	
	
	              setPrinterStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  scanning: true,
	                  statusMessage: "Conectando a " + device.name + "...",
	                  errorDetails: ''
	                });
	              });
	
	              _context4.prev = 6;
	
	              console.log("\uD83D\uDD17 Conectando a " + device.name + " (Tipo: " + printerType + ")");
	
	              if (device.gatt) {
	                _context4.next = 10;
	                break;
	              }
	
	              throw new Error('Dispositivo no compatible con Bluetooth Low Energy');
	
	            case 10:
	
	              // Configurar desconexión
	              device.addEventListener('gattserverdisconnected', function () {
	                console.log('⚠️ Dispositivo detectó desconexión.');
	
	                // Llamamos a la función de reconexión automática
	                handleAutoReconnect();
	              });
	
	              // Conexión con timeout
	              server = void 0;
	              _context4.prev = 12;
	              _context4.next = 15;
	              return device.gatt.connect();
	
	            case 15:
	              server = _context4.sent;
	
	              console.log('✅ Conexión GATT exitosa');
	              _context4.next = 25;
	              break;
	
	            case 19:
	              _context4.prev = 19;
	              _context4.t0 = _context4["catch"](12);
	
	              console.error('❌ Error en conexión GATT:', _context4.t0);
	
	              // Para MTP en PC, puede necesitar emparejamiento
	
	              if (!(printerType === 'mtp' && bluetoothStatus.isDesktop)) {
	                _context4.next = 24;
	                break;
	              }
	
	              throw new Error('MTP-3 necesita emparejamiento previo en Configuración > Bluetooth');
	
	            case 24:
	              throw _context4.t0;
	
	            case 25:
	
	              // BUSCAR SERVICIO Y CARACTERÍSTICA UNIVERSAL
	              serviceFound = null;
	              characteristicFound = null;
	
	
	              console.log('🔍 Buscando servicio y característica...');
	
	              // Estrategia 1: Usar configuración específica del tipo de impresora
	
	              if (!(printerType !== 'unknown' && PRINTER_DATABASE[printerType])) {
	                _context4.next = 105;
	                break;
	              }
	
	              config = PRINTER_DATABASE[printerType];
	
	              console.log("\uD83D\uDD27 Probando configuraci\xF3n espec\xEDfica para " + printerType);
	
	              _iteratorNormalCompletion3 = true;
	              _didIteratorError3 = false;
	              _iteratorError3 = undefined;
	              _context4.prev = 34;
	              _iterator3 = config.services[Symbol.iterator]();
	
	            case 36:
	              if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
	                _context4.next = 91;
	                break;
	              }
	
	              serviceUUID = _step3.value;
	              _context4.prev = 38;
	              _context4.next = 41;
	              return server.getPrimaryService(serviceUUID);
	
	            case 41:
	              service = _context4.sent;
	
	              console.log("\u2705 Servicio espec\xEDfico encontrado: " + serviceUUID);
	              serviceFound = service;
	
	              // Buscar característica específica
	              _iteratorNormalCompletion4 = true;
	              _didIteratorError4 = false;
	              _iteratorError4 = undefined;
	              _context4.prev = 47;
	              _iterator4 = config.characteristics[Symbol.iterator]();
	
	            case 49:
	              if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
	                _context4.next = 67;
	                break;
	              }
	
	              charUUID = _step4.value;
	              _context4.prev = 51;
	              _context4.next = 54;
	              return service.getCharacteristic(charUUID);
	
	            case 54:
	              characteristic = _context4.sent;
	
	              if (!(characteristic.properties.write || characteristic.properties.writeWithoutResponse)) {
	                _context4.next = 59;
	                break;
	              }
	
	              console.log("\u2705 Caracter\xEDstica espec\xEDfica encontrada: " + charUUID);
	              characteristicFound = characteristic;
	              return _context4.abrupt("break", 67);
	
	            case 59:
	              _context4.next = 64;
	              break;
	
	            case 61:
	              _context4.prev = 61;
	              _context4.t1 = _context4["catch"](51);
	
	              console.log("\u274C Caracter\xEDstica " + charUUID + " no encontrada");
	
	            case 64:
	              _iteratorNormalCompletion4 = true;
	              _context4.next = 49;
	              break;
	
	            case 67:
	              _context4.next = 73;
	              break;
	
	            case 69:
	              _context4.prev = 69;
	              _context4.t2 = _context4["catch"](47);
	              _didIteratorError4 = true;
	              _iteratorError4 = _context4.t2;
	
	            case 73:
	              _context4.prev = 73;
	              _context4.prev = 74;
	
	              if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                _iterator4.return();
	              }
	
	            case 76:
	              _context4.prev = 76;
	
	              if (!_didIteratorError4) {
	                _context4.next = 79;
	                break;
	              }
	
	              throw _iteratorError4;
	
	            case 79:
	              return _context4.finish(76);
	
	            case 80:
	              return _context4.finish(73);
	
	            case 81:
	              if (!characteristicFound) {
	                _context4.next = 83;
	                break;
	              }
	
	              return _context4.abrupt("break", 91);
	
	            case 83:
	              _context4.next = 88;
	              break;
	
	            case 85:
	              _context4.prev = 85;
	              _context4.t3 = _context4["catch"](38);
	
	              console.log("\u274C Servicio " + serviceUUID + " no encontrado");
	
	            case 88:
	              _iteratorNormalCompletion3 = true;
	              _context4.next = 36;
	              break;
	
	            case 91:
	              _context4.next = 97;
	              break;
	
	            case 93:
	              _context4.prev = 93;
	              _context4.t4 = _context4["catch"](34);
	              _didIteratorError3 = true;
	              _iteratorError3 = _context4.t4;
	
	            case 97:
	              _context4.prev = 97;
	              _context4.prev = 98;
	
	              if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	              }
	
	            case 100:
	              _context4.prev = 100;
	
	              if (!_didIteratorError3) {
	                _context4.next = 103;
	                break;
	              }
	
	              throw _iteratorError3;
	
	            case 103:
	              return _context4.finish(100);
	
	            case 104:
	              return _context4.finish(97);
	
	            case 105:
	              if (!(!serviceFound || !characteristicFound)) {
	                _context4.next = 182;
	                break;
	              }
	
	              console.log('🔍 Realizando búsqueda universal...');
	
	              // Obtener todos los servicios
	              _context4.next = 109;
	              return server.getPrimaryServices();
	
	            case 109:
	              services = _context4.sent;
	
	              console.log("\uD83D\uDCF1 " + services.length + " servicios disponibles");
	
	              _iteratorNormalCompletion5 = true;
	              _didIteratorError5 = false;
	              _iteratorError5 = undefined;
	              _context4.prev = 114;
	              _iterator5 = services[Symbol.iterator]();
	
	            case 116:
	              if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
	                _context4.next = 168;
	                break;
	              }
	
	              _service = _step5.value;
	              _context4.prev = 118;
	              _context4.next = 121;
	              return _service.getCharacteristics();
	
	            case 121:
	              characteristics = _context4.sent;
	
	              console.log("\uD83D\uDD0D Servicio " + _service.uuid + ": " + characteristics.length + " caracter\xEDsticas");
	
	              _iteratorNormalCompletion6 = true;
	              _didIteratorError6 = false;
	              _iteratorError6 = undefined;
	              _context4.prev = 126;
	              _iterator6 = characteristics[Symbol.iterator]();
	
	            case 128:
	              if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
	                _context4.next = 144;
	                break;
	              }
	
	              char = _step6.value;
	
	              console.log("   " + char.uuid + " - Write: " + char.properties.write + ", WriteWithoutResponse: " + char.properties.writeWithoutResponse);
	
	              if (!char.properties.writeWithoutResponse) {
	                _context4.next = 136;
	                break;
	              }
	
	              console.log("\u2705 Caracter\xEDstica con writeWithoutResponse encontrada: " + char.uuid);
	              serviceFound = _service;
	              characteristicFound = char;
	              return _context4.abrupt("break", 144);
	
	            case 136:
	              if (!char.properties.write) {
	                _context4.next = 141;
	                break;
	              }
	
	              console.log("\u2705 Caracter\xEDstica con write encontrada: " + char.uuid);
	              serviceFound = _service;
	              characteristicFound = char;
	              return _context4.abrupt("break", 144);
	
	            case 141:
	              _iteratorNormalCompletion6 = true;
	              _context4.next = 128;
	              break;
	
	            case 144:
	              _context4.next = 150;
	              break;
	
	            case 146:
	              _context4.prev = 146;
	              _context4.t5 = _context4["catch"](126);
	              _didIteratorError6 = true;
	              _iteratorError6 = _context4.t5;
	
	            case 150:
	              _context4.prev = 150;
	              _context4.prev = 151;
	
	              if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                _iterator6.return();
	              }
	
	            case 153:
	              _context4.prev = 153;
	
	              if (!_didIteratorError6) {
	                _context4.next = 156;
	                break;
	              }
	
	              throw _iteratorError6;
	
	            case 156:
	              return _context4.finish(153);
	
	            case 157:
	              return _context4.finish(150);
	
	            case 158:
	              if (!characteristicFound) {
	                _context4.next = 160;
	                break;
	              }
	
	              return _context4.abrupt("break", 168);
	
	            case 160:
	              _context4.next = 165;
	              break;
	
	            case 162:
	              _context4.prev = 162;
	              _context4.t6 = _context4["catch"](118);
	
	              console.log("\u26A0\uFE0F Error en servicio " + _service.uuid + ":", _context4.t6.message);
	
	            case 165:
	              _iteratorNormalCompletion5 = true;
	              _context4.next = 116;
	              break;
	
	            case 168:
	              _context4.next = 174;
	              break;
	
	            case 170:
	              _context4.prev = 170;
	              _context4.t7 = _context4["catch"](114);
	              _didIteratorError5 = true;
	              _iteratorError5 = _context4.t7;
	
	            case 174:
	              _context4.prev = 174;
	              _context4.prev = 175;
	
	              if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                _iterator5.return();
	              }
	
	            case 177:
	              _context4.prev = 177;
	
	              if (!_didIteratorError5) {
	                _context4.next = 180;
	                break;
	              }
	
	              throw _iteratorError5;
	
	            case 180:
	              return _context4.finish(177);
	
	            case 181:
	              return _context4.finish(174);
	
	            case 182:
	              if (!(!serviceFound || !characteristicFound)) {
	                _context4.next = 184;
	                break;
	              }
	
	              throw new Error('No se encontró servicio o característica de escritura');
	
	            case 184:
	              if (characteristicFound) {
	                _context4.next = 252;
	                break;
	              }
	
	              console.log('⚠️ Usando cualquier característica con capacidad de escritura...');
	
	              _context4.next = 188;
	              return server.getPrimaryServices();
	
	            case 188:
	              _services = _context4.sent;
	              _iteratorNormalCompletion7 = true;
	              _didIteratorError7 = false;
	              _iteratorError7 = undefined;
	              _context4.prev = 192;
	              _iterator7 = _services[Symbol.iterator]();
	
	            case 194:
	              if (_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done) {
	                _context4.next = 238;
	                break;
	              }
	
	              _service2 = _step7.value;
	              _context4.prev = 196;
	              _context4.next = 199;
	              return _service2.getCharacteristics();
	
	            case 199:
	              _characteristics = _context4.sent;
	              _iteratorNormalCompletion8 = true;
	              _didIteratorError8 = false;
	              _iteratorError8 = undefined;
	              _context4.prev = 203;
	              _iterator8 = _characteristics[Symbol.iterator]();
	
	            case 205:
	              if (_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done) {
	                _context4.next = 215;
	                break;
	              }
	
	              _char = _step8.value;
	
	              if (!_char.properties.write) {
	                _context4.next = 212;
	                break;
	              }
	
	              serviceFound = _service2;
	              characteristicFound = _char;
	              console.log("\u26A0\uFE0F Caracter\xEDstica de escritura encontrada: " + _char.uuid);
	              return _context4.abrupt("break", 215);
	
	            case 212:
	              _iteratorNormalCompletion8 = true;
	              _context4.next = 205;
	              break;
	
	            case 215:
	              _context4.next = 221;
	              break;
	
	            case 217:
	              _context4.prev = 217;
	              _context4.t8 = _context4["catch"](203);
	              _didIteratorError8 = true;
	              _iteratorError8 = _context4.t8;
	
	            case 221:
	              _context4.prev = 221;
	              _context4.prev = 222;
	
	              if (!_iteratorNormalCompletion8 && _iterator8.return) {
	                _iterator8.return();
	              }
	
	            case 224:
	              _context4.prev = 224;
	
	              if (!_didIteratorError8) {
	                _context4.next = 227;
	                break;
	              }
	
	              throw _iteratorError8;
	
	            case 227:
	              return _context4.finish(224);
	
	            case 228:
	              return _context4.finish(221);
	
	            case 229:
	              if (!characteristicFound) {
	                _context4.next = 231;
	                break;
	              }
	
	              return _context4.abrupt("break", 238);
	
	            case 231:
	              _context4.next = 235;
	              break;
	
	            case 233:
	              _context4.prev = 233;
	              _context4.t9 = _context4["catch"](196);
	
	            case 235:
	              _iteratorNormalCompletion7 = true;
	              _context4.next = 194;
	              break;
	
	            case 238:
	              _context4.next = 244;
	              break;
	
	            case 240:
	              _context4.prev = 240;
	              _context4.t10 = _context4["catch"](192);
	              _didIteratorError7 = true;
	              _iteratorError7 = _context4.t10;
	
	            case 244:
	              _context4.prev = 244;
	              _context4.prev = 245;
	
	              if (!_iteratorNormalCompletion7 && _iterator7.return) {
	                _iterator7.return();
	              }
	
	            case 247:
	              _context4.prev = 247;
	
	              if (!_didIteratorError7) {
	                _context4.next = 250;
	                break;
	              }
	
	              throw _iteratorError7;
	
	            case 250:
	              return _context4.finish(247);
	
	            case 251:
	              return _context4.finish(244);
	
	            case 252:
	              if (characteristicFound) {
	                _context4.next = 254;
	                break;
	              }
	
	              throw new Error('No se encontró ninguna característica con capacidad de escritura');
	
	            case 254:
	
	              // Probar la característica con un comando simple
	              console.log('🧪 Probando característica...');
	              _context4.prev = 255;
	
	              // Comando de inicialización ESC @
	              testCommand = new Uint8Array([0x1B, 0x40]);
	
	              if (!characteristicFound.properties.writeWithoutResponse) {
	                _context4.next = 263;
	                break;
	              }
	
	              _context4.next = 260;
	              return characteristicFound.writeValueWithoutResponse(testCommand);
	
	            case 260:
	              console.log('✅ Característica probada con writeWithoutResponse');
	              _context4.next = 267;
	              break;
	
	            case 263:
	              if (!characteristicFound.properties.write) {
	                _context4.next = 267;
	                break;
	              }
	
	              _context4.next = 266;
	              return characteristicFound.writeValue(testCommand);
	
	            case 266:
	              console.log('✅ Característica probada con write');
	
	            case 267:
	              _context4.next = 272;
	              break;
	
	            case 269:
	              _context4.prev = 269;
	              _context4.t11 = _context4["catch"](255);
	
	              console.log('⚠️ Error probando característica:', _context4.t11.message);
	              // Continuar aunque falle la prueba
	
	            case 272:
	
	              // Actualizar estado
	              setPrinterStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  connected: true,
	                  device: device,
	                  server: server,
	                  name: device.name,
	                  service: serviceFound,
	                  characteristic: characteristicFound,
	                  statusMessage: "\u2705 Conectado a " + device.name,
	                  errorDetails: ''
	                });
	              });
	
	              setMensaje({
	                mostrar: true,
	                titulo: "¡Conexión exitosa!",
	                texto: "Conectado a " + device.name + ". Servicio: " + serviceFound.uuid + "\nCaracter\xEDstica: " + characteristicFound.uuid,
	                icono: "exito"
	              });
	
	              _context4.next = 283;
	              break;
	
	            case 276:
	              _context4.prev = 276;
	              _context4.t12 = _context4["catch"](6);
	
	              console.error('❌ ERROR DE CONEXIÓN:', _context4.t12);
	
	              solution = '';
	
	              if (printerType === 'mtp') {
	                solution = '\n\nPara MTP-3 en PC:\n1. Empareje en Configuración > Bluetooth\n2. Reinicie impresora\n3. Intente nuevamente';
	              } else if (printerType === 'mp80') {
	                solution = '\n\nPara MP80-04:\n1. Asegúrese de usar el servicio correcto\n2. Pruebe con diferentes modos de impresión';
	              }
	
	              setPrinterStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  statusMessage: "\u274C Error de conexi\xF3n",
	                  errorDetails: "" + _context4.t12.toString() + solution,
	                  scannedDevice: null
	                });
	              });
	
	              setMensaje({
	                mostrar: true,
	                titulo: "Error de conexión",
	                texto: "No se pudo conectar a " + device.name + ": " + _context4.t12.message + solution,
	                icono: "error"
	              });
	
	            case 283:
	              _context4.prev = 283;
	
	              setPrinterStatus(function (prev) {
	                return Object.assign({}, prev, { scanning: false });
	              });
	              return _context4.finish(283);
	
	            case 286:
	            case "end":
	              return _context4.stop();
	          }
	        }
	      }, _callee4, undefined, [[6, 276, 283, 286], [12, 19], [34, 93, 97, 105], [38, 85], [47, 69, 73, 81], [51, 61], [74,, 76, 80], [98,, 100, 104], [114, 170, 174, 182], [118, 162], [126, 146, 150, 158], [151,, 153, 157], [175,, 177, 181], [192, 240, 244, 252], [196, 233], [203, 217, 221, 229], [222,, 224, 228], [245,, 247, 251], [255, 269]]);
	    }));
	
	    return function connectToPrinter() {
	      return _ref6.apply(this, arguments);
	    };
	  }();
	
	  // NUEVA FUNCIÓN: Reconexión Automática
	  var handleAutoReconnect = function () {
	    var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	      var device, printerType, server, serviceFound, characteristicFound, config, _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, serviceUUID, service, _iteratorNormalCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, charUUID, characteristic, services, _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, _service3, characteristics, _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, char;
	
	      return _regenerator2.default.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              device = printerStatus.scannedDevice;
	              printerType = printerStatus.printerType || 'unknown';
	
	              if (device) {
	                _context5.next = 4;
	                break;
	              }
	
	              return _context5.abrupt("return");
	
	            case 4:
	              if (!(printerStatus.scanning || printerStatus.connected)) {
	                _context5.next = 6;
	                break;
	              }
	
	              return _context5.abrupt("return");
	
	            case 6:
	
	              console.log('⚠️ Impresora desconectada. Iniciando reconexión automática...');
	
	              setPrinterStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  scanning: true, // Usamos scanning para indicar que estamos ocupados
	                  statusMessage: '⚠️ Reconectando...',
	                  connected: false
	                });
	              });
	
	              _context5.prev = 8;
	              _context5.next = 11;
	              return device.gatt.connect();
	
	            case 11:
	              server = _context5.sent;
	
	              console.log('✅ GATT Reconectado');
	
	              // 2. Buscar servicios y características (Lógica similar a connectToPrinter)
	              serviceFound = null;
	              characteristicFound = null;
	
	              // Estrategia: Intentar usar la configuración conocida primero
	
	              if (!(printerType !== 'unknown' && PRINTER_DATABASE[printerType])) {
	                _context5.next = 87;
	                break;
	              }
	
	              config = PRINTER_DATABASE[printerType];
	              _iteratorNormalCompletion9 = true;
	              _didIteratorError9 = false;
	              _iteratorError9 = undefined;
	              _context5.prev = 20;
	              _iterator9 = config.services[Symbol.iterator]();
	
	            case 22:
	              if (_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done) {
	                _context5.next = 73;
	                break;
	              }
	
	              serviceUUID = _step9.value;
	              _context5.prev = 24;
	              _context5.next = 27;
	              return server.getPrimaryService(serviceUUID);
	
	            case 27:
	              service = _context5.sent;
	
	              serviceFound = service;
	              _iteratorNormalCompletion10 = true;
	              _didIteratorError10 = false;
	              _iteratorError10 = undefined;
	              _context5.prev = 32;
	              _iterator10 = config.characteristics[Symbol.iterator]();
	
	            case 34:
	              if (_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done) {
	                _context5.next = 50;
	                break;
	              }
	
	              charUUID = _step10.value;
	              _context5.prev = 36;
	              _context5.next = 39;
	              return service.getCharacteristic(charUUID);
	
	            case 39:
	              characteristic = _context5.sent;
	
	              if (!(characteristic.properties.write || characteristic.properties.writeWithoutResponse)) {
	                _context5.next = 43;
	                break;
	              }
	
	              characteristicFound = characteristic;
	              return _context5.abrupt("break", 50);
	
	            case 43:
	              _context5.next = 47;
	              break;
	
	            case 45:
	              _context5.prev = 45;
	              _context5.t0 = _context5["catch"](36);
	
	            case 47:
	              _iteratorNormalCompletion10 = true;
	              _context5.next = 34;
	              break;
	
	            case 50:
	              _context5.next = 56;
	              break;
	
	            case 52:
	              _context5.prev = 52;
	              _context5.t1 = _context5["catch"](32);
	              _didIteratorError10 = true;
	              _iteratorError10 = _context5.t1;
	
	            case 56:
	              _context5.prev = 56;
	              _context5.prev = 57;
	
	              if (!_iteratorNormalCompletion10 && _iterator10.return) {
	                _iterator10.return();
	              }
	
	            case 59:
	              _context5.prev = 59;
	
	              if (!_didIteratorError10) {
	                _context5.next = 62;
	                break;
	              }
	
	              throw _iteratorError10;
	
	            case 62:
	              return _context5.finish(59);
	
	            case 63:
	              return _context5.finish(56);
	
	            case 64:
	              if (!characteristicFound) {
	                _context5.next = 66;
	                break;
	              }
	
	              return _context5.abrupt("break", 73);
	
	            case 66:
	              _context5.next = 70;
	              break;
	
	            case 68:
	              _context5.prev = 68;
	              _context5.t2 = _context5["catch"](24);
	
	            case 70:
	              _iteratorNormalCompletion9 = true;
	              _context5.next = 22;
	              break;
	
	            case 73:
	              _context5.next = 79;
	              break;
	
	            case 75:
	              _context5.prev = 75;
	              _context5.t3 = _context5["catch"](20);
	              _didIteratorError9 = true;
	              _iteratorError9 = _context5.t3;
	
	            case 79:
	              _context5.prev = 79;
	              _context5.prev = 80;
	
	              if (!_iteratorNormalCompletion9 && _iterator9.return) {
	                _iterator9.return();
	              }
	
	            case 82:
	              _context5.prev = 82;
	
	              if (!_didIteratorError9) {
	                _context5.next = 85;
	                break;
	              }
	
	              throw _iteratorError9;
	
	            case 85:
	              return _context5.finish(82);
	
	            case 86:
	              return _context5.finish(79);
	
	            case 87:
	              if (!(!serviceFound || !characteristicFound)) {
	                _context5.next = 153;
	                break;
	              }
	
	              _context5.next = 90;
	              return server.getPrimaryServices();
	
	            case 90:
	              services = _context5.sent;
	              _iteratorNormalCompletion11 = true;
	              _didIteratorError11 = false;
	              _iteratorError11 = undefined;
	              _context5.prev = 94;
	              _iterator11 = services[Symbol.iterator]();
	
	            case 96:
	              if (_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done) {
	                _context5.next = 139;
	                break;
	              }
	
	              _service3 = _step11.value;
	              _context5.prev = 98;
	              _context5.next = 101;
	              return _service3.getCharacteristics();
	
	            case 101:
	              characteristics = _context5.sent;
	              _iteratorNormalCompletion12 = true;
	              _didIteratorError12 = false;
	              _iteratorError12 = undefined;
	              _context5.prev = 105;
	              _iterator12 = characteristics[Symbol.iterator]();
	
	            case 107:
	              if (_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done) {
	                _context5.next = 116;
	                break;
	              }
	
	              char = _step12.value;
	
	              if (!(char.properties.writeWithoutResponse || char.properties.write)) {
	                _context5.next = 113;
	                break;
	              }
	
	              serviceFound = _service3;
	              characteristicFound = char;
	              return _context5.abrupt("break", 116);
	
	            case 113:
	              _iteratorNormalCompletion12 = true;
	              _context5.next = 107;
	              break;
	
	            case 116:
	              _context5.next = 122;
	              break;
	
	            case 118:
	              _context5.prev = 118;
	              _context5.t4 = _context5["catch"](105);
	              _didIteratorError12 = true;
	              _iteratorError12 = _context5.t4;
	
	            case 122:
	              _context5.prev = 122;
	              _context5.prev = 123;
	
	              if (!_iteratorNormalCompletion12 && _iterator12.return) {
	                _iterator12.return();
	              }
	
	            case 125:
	              _context5.prev = 125;
	
	              if (!_didIteratorError12) {
	                _context5.next = 128;
	                break;
	              }
	
	              throw _iteratorError12;
	
	            case 128:
	              return _context5.finish(125);
	
	            case 129:
	              return _context5.finish(122);
	
	            case 130:
	              if (!characteristicFound) {
	                _context5.next = 132;
	                break;
	              }
	
	              return _context5.abrupt("break", 139);
	
	            case 132:
	              _context5.next = 136;
	              break;
	
	            case 134:
	              _context5.prev = 134;
	              _context5.t5 = _context5["catch"](98);
	
	            case 136:
	              _iteratorNormalCompletion11 = true;
	              _context5.next = 96;
	              break;
	
	            case 139:
	              _context5.next = 145;
	              break;
	
	            case 141:
	              _context5.prev = 141;
	              _context5.t6 = _context5["catch"](94);
	              _didIteratorError11 = true;
	              _iteratorError11 = _context5.t6;
	
	            case 145:
	              _context5.prev = 145;
	              _context5.prev = 146;
	
	              if (!_iteratorNormalCompletion11 && _iterator11.return) {
	                _iterator11.return();
	              }
	
	            case 148:
	              _context5.prev = 148;
	
	              if (!_didIteratorError11) {
	                _context5.next = 151;
	                break;
	              }
	
	              throw _iteratorError11;
	
	            case 151:
	              return _context5.finish(148);
	
	            case 152:
	              return _context5.finish(145);
	
	            case 153:
	              if (!characteristicFound) {
	                _context5.next = 158;
	                break;
	              }
	
	              console.log('✅ Reconexión exitosa. Característica recuperada.');
	              setPrinterStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  connected: true,
	                  server: server,
	                  service: serviceFound,
	                  characteristic: characteristicFound,
	                  scanning: false,
	                  statusMessage: '✅ Reconectado'
	                });
	              });
	              _context5.next = 159;
	              break;
	
	            case 158:
	              throw new Error('No se pudo encontrar la característica al reconectar');
	
	            case 159:
	              _context5.next = 165;
	              break;
	
	            case 161:
	              _context5.prev = 161;
	              _context5.t7 = _context5["catch"](8);
	
	              console.error('❌ Error en reconexión automática:', _context5.t7);
	              setPrinterStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  connected: false,
	                  scanning: false,
	                  statusMessage: '❌ Desconectado. Toque conectar manualmente.'
	                });
	              });
	
	            case 165:
	            case "end":
	              return _context5.stop();
	          }
	        }
	      }, _callee5, undefined, [[8, 161], [20, 75, 79, 87], [24, 68], [32, 52, 56, 64], [36, 45], [57,, 59, 63], [80,, 82, 86], [94, 141, 145, 153], [98, 134], [105, 118, 122, 130], [123,, 125, 129], [146,, 148, 152]]);
	    }));
	
	    return function handleAutoReconnect() {
	      return _ref7.apply(this, arguments);
	    };
	  }();
	
	  var generateTicketWithTable = function () {
	    var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(idFactura) {
	      var ESC, GS, LF, PAPER_WIDTH, cmd, formatoMoneda, crearLineaDoble, crearLineaCuatroColumnas, endpoint, response, _response$data, factura, pagosDetalles, notaentrega, facturaData, pagosData, nombreorg, riforg, numNota, clienteRif, clienteNombre, clienteDireccion, fechaMoment, fechaTxt, horaTxt, _records, totalMonto, tasa, totalBs, ticket;
	
	      return _regenerator2.default.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              console.log('\n🎫 Generando RECIBO (80mm) - Sin Negrita en cabeceras ID:', idFactura);
	              _context6.prev = 1;
	
	              // --- 1. CONFIGURACIÓN COMANDOS ESC/POS ---
	              ESC = '\x1B';
	              GS = '\x1D';
	              LF = '\n';
	
	              // Ancho de papel en caracteres (80mm = aprox 64 caracteres)
	
	              PAPER_WIDTH = 64;
	              cmd = {
	                init: ESC + '@',
	                center: ESC + 'a' + '\x01',
	                left: ESC + 'a' + '\x00',
	                boldOn: ESC + 'E' + '\x01',
	                boldOff: ESC + 'E' + '\x00',
	                doubleSize: ESC + '!' + '\x11',
	                normalSize: ESC + '!' + '\x00',
	                cut: GS + 'V' + '\x00'
	              };
	
	              // --- 2. UTILIDADES (Dentro de la función) ---
	
	              formatoMoneda = function formatoMoneda(val) {
	                return parseFloat(val || 0).toFixed(2).replace('.', ',');
	              };
	
	              crearLineaDoble = function crearLineaDoble(txt1, txt2, ancho) {
	                var espacio = ancho - txt1.length - txt2.length;
	                return txt1 + ' '.repeat(Math.max(0, espacio)) + txt2 + LF;
	              };
	
	              crearLineaCuatroColumnas = function crearLineaCuatroColumnas(col1, col2, col3, col4, ancho) {
	                // Anchos para 80mm
	                var wCant = 8;
	                var wPrec = 14;
	                var wTot = 14;
	                var separadores = 3;
	
	                var maxDesc = ancho - wCant - wPrec - wTot - separadores;
	
	                var desc = col1;
	                if (desc.length > maxDesc) desc = desc.substring(0, maxDesc - 3) + '...';
	
	                var c1 = desc.padEnd(maxDesc, ' ');
	                var c2 = col2.padStart(wCant, ' ');
	                var c3 = col3.padStart(wPrec, ' ');
	                var c4 = col4.padStart(wTot, ' ');
	
	                return c1 + " " + c2 + " " + c3 + " " + c4 + LF;
	              };
	
	              // --- 3. PETICIÓN API ---
	
	
	              endpoint = op.conexion + "/api/ticket/selectfactura?idfactura=" + idFactura;
	
	              setActivate(true);
	
	              _context6.next = 14;
	              return _axios2.default.get(endpoint, { headers: { 'x-access-token': "" + token } });
	
	            case 14:
	              response = _context6.sent;
	
	              if (!(response.status !== 200 || !response.data)) {
	                _context6.next = 17;
	                break;
	              }
	
	              throw new Error('Error API');
	
	            case 17:
	              _response$data = response.data, factura = _response$data.factura, pagosDetalles = _response$data.pagosDetalles, notaentrega = _response$data.notaentrega;
	
	              if (!(!factura || factura.length === 0)) {
	                _context6.next = 20;
	                break;
	              }
	
	              throw new Error('Factura no encontrada');
	
	            case 20:
	              facturaData = factura[0];
	              pagosData = pagosDetalles || [];
	
	              // --- 4. PREPARAR DATOS ---
	
	              nombreorg = (facturaData.nombreorganizacionc || organizacion.nombre || 'MI EMPRESA').trim();
	              riforg = facturaData.riforganizacionc || organizacion.rif || '';
	              numNota = facturaData.numfacturac || '';
	              clienteRif = facturaData.rifclientec || '';
	              clienteNombre = facturaData.clientec || 'CONSUMIDOR FINAL';
	              clienteDireccion = facturaData.direccionclient || 'S/N';
	              fechaMoment = facturaData.txtfecha ? (0, _moment2.default)(facturaData.txtfecha) : (0, _moment2.default)();
	              fechaTxt = fechaMoment.format('DD/MM/YYYY');
	              horaTxt = fechaMoment.format('HH:mm:ss');
	              _records = factura.map(function (item) {
	                return {
	                  nombre: item.nombreproducto || '',
	                  cantidad: parseFloat(item.cantidadn) || 0,
	                  punitario: parseFloat(item.precioconiva) || 0,
	                  unidad: item.unidadmedida || ''
	                };
	              });
	              totalMonto = notaentrega && notaentrega[0] ? parseFloat(notaentrega[0].totalmonto) : 0;
	              tasa = parseFloat(facturaData.tasa) || 1;
	              totalBs = totalMonto * tasa;
	
	              // --- 5. CONSTRUCCIÓN DEL TICKET ---
	
	              ticket = '';
	
	              // 1. Inicializar
	
	              ticket += cmd.init;
	
	              // 2. Encabezado
	              ticket += cmd.center;
	              ticket += nombreorg + LF;
	              ticket += riforg + LF;
	
	              ticket += cmd.doubleSize;
	              ticket += 'RECIBO';
	              ticket += cmd.normalSize;
	              ticket += LF;
	
	              // 3. Información Venta
	              ticket += cmd.left;
	              ticket += crearLineaDoble("NRO: " + numNota, "Fecha: " + fechaTxt, PAPER_WIDTH);
	              ticket += crearLineaDoble("RIF: " + clienteRif, "Hora: " + horaTxt, PAPER_WIDTH);
	
	              ticket += "NOMBRE: " + clienteNombre.substring(0, 40) + LF;
	              ticket += "DIRECCI\xD3N: " + clienteDireccion.substring(0, 40) + LF;
	
	              if (facturaData.txtmesonero) {
	                ticket += "VENDEDOR: " + facturaData.txtmesonero + LF;
	              }
	
	              // 4. TABLA PRODUCTOS
	              ticket += 'DETALLE PRODUCTOS:' + LF;
	              ticket += '-'.repeat(PAPER_WIDTH) + LF;
	
	              // --- TITULOS DE LA TABLA ---
	              // NOTA: Se eliminó cmd.boldOn y cmd.boldOff porque la negrita ensancha las letras
	              // y desalinea las columnas en impresoras térmicas.
	              ticket += crearLineaCuatroColumnas('DESCRIPCION', 'CANT.', 'P-UNIT.', 'TOTAL', PAPER_WIDTH);
	              ticket += '-'.repeat(PAPER_WIDTH) + LF;
	
	              // Items
	              _records.forEach(function (item) {
	                var simboloUnidad = item.unidad ? item.unidad.charAt(0).toUpperCase() : 'U';
	                var totalItem = item.cantidad * item.punitario;
	
	                ticket += crearLineaCuatroColumnas(item.nombre, formatoMoneda(item.cantidad) + " " + simboloUnidad, formatoMoneda(item.punitario), formatoMoneda(totalItem), PAPER_WIDTH);
	              });
	
	              // 5. Totales
	              ticket += '='.repeat(PAPER_WIDTH) + LF;
	              ticket += crearLineaDoble("CANTIDAD ITEMS: " + _records.length, "TOTAL $: " + formatoMoneda(totalMonto), PAPER_WIDTH);
	
	              if (tasa && tasa !== 1) {
	                ticket += crearLineaDoble('', "TOTAL Bs: " + formatoMoneda(totalBs), PAPER_WIDTH);
	              }
	
	              // 6. Formas de Pago
	              if (pagosData && pagosData.length > 0) {
	                ticket += LF;
	                ticket += '-'.repeat(PAPER_WIDTH) + LF;
	                ticket += 'FORMA DE PAGO:' + LF;
	                pagosData.forEach(function (pago) {
	                  var montoPago = formatoMoneda(pago.monto);
	                  var nomPago = (pago.tipopago || 'EFECTIVO').substring(0, 25);
	                  ticket += crearLineaDoble(nomPago, montoPago, PAPER_WIDTH);
	                });
	              }
	
	              // 7. Footer
	              ticket += LF;
	
	              // Texto Legal
	              ticket += cmd.center;
	              ticket += '========== SIN DERECHO A CRÉDITO FISCAL ==========' + LF;
	              ticket += LF + LF + LF;
	
	              // 8. Cortar Papel
	              ticket += cmd.cut;
	
	              setActivate(false);
	              return _context6.abrupt("return", ticket);
	
	            case 68:
	              _context6.prev = 68;
	              _context6.t0 = _context6["catch"](1);
	
	              setActivate(false);
	              console.error('Error generando ticket:', _context6.t0);
	              throw _context6.t0;
	
	            case 73:
	            case "end":
	              return _context6.stop();
	          }
	        }
	      }, _callee6, undefined, [[1, 68]]);
	    }));
	
	    return function generateTicketWithTable(_x2) {
	      return _ref8.apply(this, arguments);
	    };
	  }();
	
	  // USO:
	  // generateTicketWithTable(1694).then(ticket => {
	  //     // Usar el ticket para imprimir
	  // }).catch(error => {
	  //     console.error('Error:', error);
	  // });
	
	  // Función para probar diferentes formatos
	  var printTestFormat = function () {
	    var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	      var formatType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'table';
	      var ticketContent, encoder, data, characteristic, chunkSize, i, chunk;
	      return _regenerator2.default.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              if (printerStatus.connected) {
	                _context7.next = 3;
	                break;
	              }
	
	              setMensaje({
	                mostrar: true,
	                titulo: "No conectado",
	                texto: "Conecte una impresora Bluetooth primero",
	                icono: "informacion"
	              });
	              return _context7.abrupt("return");
	
	            case 3:
	
	              setPrinterStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  printing: true,
	                  statusMessage: "Imprimiendo formato " + formatType + "..."
	                });
	              });
	
	              _context7.prev = 4;
	              ticketContent = '';
	
	              /*   switch (formatType) {
	                  case 'table':
	                    // AGREGAR AWAIT AQUÍ
	                    ticketContent = await generateTicketWithTable(1695);
	                    break;
	                  default:
	                    ticketContent = await generateTicketWithTable(1695);
	                }
	              */
	              // Verificar que tenemos contenido para imprimir
	
	              if (!(!ticketContent || ticketContent.trim() === '')) {
	                _context7.next = 8;
	                break;
	              }
	
	              throw new Error('El ticket está vacío');
	
	            case 8:
	              encoder = new TextEncoder();
	              data = encoder.encode(ticketContent);
	              characteristic = printerStatus.characteristic;
	
	              if (characteristic) {
	                _context7.next = 13;
	                break;
	              }
	
	              throw new Error('No hay característica disponible para escritura');
	
	            case 13:
	
	              // Enviar en chunks pequeños
	              chunkSize = printerStatus.printerType === 'mp80' ? 40 : printerStatus.printerType === 'jingpu' ? 20 : 10;
	
	
	              console.log("\uD83D\uDCE4 Enviando " + data.length + " bytes en chunks de " + chunkSize + "...");
	
	              i = 0;
	
	            case 16:
	              if (!(i < data.length)) {
	                _context7.next = 44;
	                break;
	              }
	
	              chunk = data.slice(i, i + chunkSize);
	              _context7.prev = 18;
	
	              if (!characteristic.properties.writeWithoutResponse) {
	                _context7.next = 25;
	                break;
	              }
	
	              _context7.next = 22;
	              return characteristic.writeValueWithoutResponse(chunk);
	
	            case 22:
	              console.log("\uD83D\uDCE6 Chunk " + i + "/" + data.length + " enviado (writeWithoutResponse)");
	              _context7.next = 32;
	              break;
	
	            case 25:
	              if (!characteristic.properties.write) {
	                _context7.next = 31;
	                break;
	              }
	
	              _context7.next = 28;
	              return characteristic.writeValue(chunk);
	
	            case 28:
	              console.log("\uD83D\uDCE6 Chunk " + i + "/" + data.length + " enviado (write)");
	              _context7.next = 32;
	              break;
	
	            case 31:
	              throw new Error('La característica no tiene capacidad de escritura');
	
	            case 32:
	              _context7.next = 38;
	              break;
	
	            case 34:
	              _context7.prev = 34;
	              _context7.t0 = _context7["catch"](18);
	
	              console.error("\u274C Error enviando chunk " + i + ":", _context7.t0);
	              throw _context7.t0;
	
	            case 38:
	              if (!(i + chunkSize < data.length)) {
	                _context7.next = 41;
	                break;
	              }
	
	              _context7.next = 41;
	              return new Promise(function (resolve) {
	                return setTimeout(resolve, 5);
	              });
	
	            case 41:
	              i += chunkSize;
	              _context7.next = 16;
	              break;
	
	            case 44:
	
	              console.log('✅ Ticket enviado completamente');
	
	              setPrinterStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  statusMessage: "\u2705 Formato " + formatType + " impreso",
	                  printing: false
	                });
	              });
	
	              setMensaje({
	                mostrar: true,
	                titulo: "Impresión exitosa",
	                texto: "Ticket enviado a la impresora " + printerStatus.name,
	                icono: "exito"
	              });
	
	              _context7.next = 54;
	              break;
	
	            case 49:
	              _context7.prev = 49;
	              _context7.t1 = _context7["catch"](4);
	
	              console.error('❌ Error en impresión:', _context7.t1);
	              setPrinterStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  statusMessage: "\u274C Error: " + _context7.t1.message,
	                  printing: false
	                });
	              });
	
	              setMensaje({
	                mostrar: true,
	                titulo: "Error de impresión",
	                texto: _context7.t1.message || 'Error desconocido al imprimir',
	                icono: "error"
	              });
	
	            case 54:
	            case "end":
	              return _context7.stop();
	          }
	        }
	      }, _callee7, undefined, [[4, 49], [18, 34]]);
	    }));
	
	    return function printTestFormat() {
	      return _ref9.apply(this, arguments);
	    };
	  }();
	
	  var disconnectPrinter = function disconnectPrinter() {
	    if (printerStatus.device && printerStatus.device.gatt && printerStatus.device.gatt.connected) {
	      try {
	        printerStatus.device.gatt.disconnect();
	      } catch (error) {
	        console.log('Error al desconectar:', error);
	      }
	    }
	
	    setPrinterStatus(function (prev) {
	      return Object.assign({}, prev, {
	        connected: false,
	        device: null,
	        server: null,
	        name: '',
	        statusMessage: 'Desconectado',
	        scannedDevice: null,
	        errorDetails: '',
	        services: [],
	        printerType: null,
	        characteristic: null,
	        service: null
	      });
	    });
	
	    setMensaje({
	      mostrar: true,
	      titulo: "Desconectado",
	      texto: "Impresora desconectada",
	      icono: "informacion"
	    });
	  };
	
	  // Detectar plataforma
	  (0, _react.useEffect)(function () {
	
	    checkBluetoothSupport();
	  }, []);
	
	  (0, _react.useEffect)(function () {
	
	    sessionStorage.setItem("bluetooth", JSON.stringify(bluetoothStatus.checked));
	  }, [bluetoothStatus]);
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = _slicedToArray(_useState5, 2),
	      visibl = _useState6[0],
	      setVisibl = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = _slicedToArray(_useState7, 2),
	      body = _useState8[0],
	      setBody = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      body2 = _useState10[0],
	      setBody2 = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      notaen = _useState12[0],
	      setNotaen = _useState12[1];
	
	  var _useState13 = (0, _react.useState)([]),
	      _useState14 = _slicedToArray(_useState13, 2),
	      notaedeta = _useState14[0],
	      setNotaedeta = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(1),
	      _useState16 = _slicedToArray(_useState15, 2),
	      operacion = _useState16[0],
	      setOperacion = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      habilitado = _useState18[0],
	      setHabilitado = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      idpedi = _useState20[0],
	      setIdpedi = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(true),
	      _useState22 = _slicedToArray(_useState21, 2),
	      habilitadoBot = _useState22[0],
	      setHabilitadoBot = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(false),
	      _useState24 = _slicedToArray(_useState23, 2),
	      habilitadoCli = _useState24[0],
	      setHabilitadoCli = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(true),
	      _useState26 = _slicedToArray(_useState25, 2),
	      habilitadoProductos = _useState26[0],
	      setHabilitadoProductos = _useState26[1];
	
	  var _useState27 = (0, _react.useState)(0),
	      _useState28 = _slicedToArray(_useState27, 2),
	      actimprime = _useState28[0],
	      setActimprime = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(null),
	      _useState30 = _slicedToArray(_useState29, 2),
	      indexs = _useState30[0],
	      setIndexs = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(false),
	      _useState32 = _slicedToArray(_useState31, 2),
	      mostrar = _useState32[0],
	      setMostrar = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(false),
	      _useState34 = _slicedToArray(_useState33, 2),
	      mostrar1 = _useState34[0],
	      setMostrar1 = _useState34[1];
	
	  var _useState35 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState36 = _slicedToArray(_useState35, 2),
	      mensaje = _useState36[0],
	      setMensaje = _useState36[1];
	
	  var _useState37 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState38 = _slicedToArray(_useState37, 2),
	      mensajesino = _useState38[0],
	      setMensajesino = _useState38[1];
	
	  var _useState39 = (0, _react.useState)({
	    idpedido: "0",
	    numpedido: "000000",
	    cedularif: "",
	    descripcion: "PEDIDO DE PRODUCTO",
	    totalmonto: 0.0,
	    totaliva: 0.0,
	    totaldescuento: 0.0,
	    totalexento: 0.0,
	    totalsujeto: 0.0,
	    idcliente: "",
	    idvendedor: "",
	    fecha: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	    status: 0,
	    idalmacen: "",
	    idmoneda: "",
	    idoperacioninventario: ""
	  }),
	      _useState40 = _slicedToArray(_useState39, 2),
	      pedido = _useState40[0],
	      setPedido = _useState40[1];
	
	  var _useState41 = (0, _react.useState)({
	    idcliente: "",
	    tiporif: "J",
	    rif: "",
	    nombre: ""
	  }),
	      _useState42 = _slicedToArray(_useState41, 2),
	      cliente = _useState42[0],
	      setCliente = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({
	    idvendedor: "",
	    tiporif: "J",
	    rif: "",
	    nombre: "",
	    idalmacen: ""
	  }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      vendedor = _useState44[0],
	      setVendedor = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(""),
	      _useState46 = _slicedToArray(_useState45, 2),
	      tipoAgente = _useState46[0],
	      setTipoAgente = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(""),
	      _useState48 = _slicedToArray(_useState47, 2),
	      numnotaentrega = _useState48[0],
	      setNumnotaentrega = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(0),
	      _useState50 = _slicedToArray(_useState49, 2),
	      numnotaentregae = _useState50[0],
	      setNumnotaentregae = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(false),
	      _useState52 = _slicedToArray(_useState51, 2),
	      habilitarMoneda = _useState52[0],
	      setHabilitarMoneda = _useState52[1];
	
	  var _useState53 = (0, _react.useState)(false),
	      _useState54 = _slicedToArray(_useState53, 2),
	      catalogoCliente = _useState54[0],
	      setCatalogoCliente = _useState54[1];
	
	  var _useState55 = (0, _react.useState)(false),
	      _useState56 = _slicedToArray(_useState55, 2),
	      catalogoPedido = _useState56[0],
	      setCatalogoPedido = _useState56[1];
	
	  var _useState57 = (0, _react.useState)(false),
	      _useState58 = _slicedToArray(_useState57, 2),
	      activate = _useState58[0],
	      setActivate = _useState58[1];
	
	  var _useState59 = (0, _react.useState)(false),
	      _useState60 = _slicedToArray(_useState59, 2),
	      mostratsup = _useState60[0],
	      setMostrarsup = _useState60[1];
	
	  var _useState61 = (0, _react.useState)(null),
	      _useState62 = _slicedToArray(_useState61, 2),
	      indice = _useState62[0],
	      setIndice = _useState62[1];
	
	  var _useState63 = (0, _react.useState)([]),
	      _useState64 = _slicedToArray(_useState63, 2),
	      records = _useState64[0],
	      setRecords = _useState64[1];
	
	  var _useState65 = (0, _react.useState)([]),
	      _useState66 = _slicedToArray(_useState65, 2),
	      listaProductos = _useState66[0],
	      setListaProductos = _useState66[1];
	
	  var _useState67 = (0, _react.useState)([]),
	      _useState68 = _slicedToArray(_useState67, 2),
	      todosProductos = _useState68[0],
	      setTodosProductos = _useState68[1];
	
	  var _useState69 = (0, _react.useState)("Gestionar Venta."),
	      _useState70 = _slicedToArray(_useState69, 2),
	      tituloHeader = _useState70[0],
	      setTituloHeader = _useState70[1];
	
	  var _useState71 = (0, _react.useState)([]),
	      _useState72 = _slicedToArray(_useState71, 2),
	      combomoneda = _useState72[0],
	      setComboMoneda = _useState72[1];
	
	  var _useState73 = (0, _react.useState)([]),
	      _useState74 = _slicedToArray(_useState73, 2),
	      opeinvc = _useState74[0],
	      setOpeinvc = _useState74[1];
	
	  var _useState75 = (0, _react.useState)([]),
	      _useState76 = _slicedToArray(_useState75, 2),
	      opeinvdetc = _useState76[0],
	      setOpeinvdetc = _useState76[1];
	
	  var _useState77 = (0, _react.useState)({
	    idmoneda: "1",
	    descripcion: "BOLIVARES",
	    simbolo: "Bs",
	    predeterminada: true,
	    subpredeterminada: false,
	    valormoneda: 1.0
	  }),
	      _useState78 = _slicedToArray(_useState77, 2),
	      moneda = _useState78[0],
	      setMoneda = _useState78[1];
	
	  var _useState79 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState80 = _slicedToArray(_useState79, 2),
	      monedaSub = _useState80[0],
	      setMonedaSub = _useState80[1];
	
	  var _useState81 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState82 = _slicedToArray(_useState81, 2),
	      monedaCambio = _useState82[0],
	      setMonedaCambio = _useState82[1];
	
	  var _useState83 = (0, _react.useState)({
	    subtotal: 0.0,
	    descuento: 0.0,
	    exento: 0.0,
	    sujeto: 0.0,
	    iva: 16.0,
	    totaliva: 0.0,
	    total: 0.0
	  }),
	      _useState84 = _slicedToArray(_useState83, 2),
	      totales = _useState84[0],
	      setTotales = _useState84[1];
	
	  // Funciones para Bluetooth e impresión
	
	
	  var checkBluetoothStatus = function () {
	    var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	      var isAvailable;
	      return _regenerator2.default.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              _context8.prev = 0;
	
	              if (navigator.bluetooth) {
	                _context8.next = 4;
	                break;
	              }
	
	              setBluetoothStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  available: false,
	                  message: 'Su navegador no soporta Bluetooth. Use Chrome en Android.'
	                });
	              });
	              return _context8.abrupt("return");
	
	            case 4:
	              _context8.next = 6;
	              return navigator.bluetooth.getAvailability();
	
	            case 6:
	              isAvailable = _context8.sent;
	
	
	              if (!isAvailable) {
	                setBluetoothStatus(function (prev) {
	                  return Object.assign({}, prev, {
	                    available: false,
	                    message: 'El Bluetooth está desactivado. Por favor actívelo.'
	                  });
	                });
	              } else {
	                setBluetoothStatus(function (prev) {
	                  return Object.assign({}, prev, {
	                    available: true,
	                    message: 'Bluetooth activado correctamente.'
	                  });
	                });
	                setPrinterStatus(function (prev) {
	                  return Object.assign({}, prev, {
	                    statusMessage: 'Bluetooth activado. Busca una impresora.'
	                  });
	                });
	              }
	              _context8.next = 14;
	              break;
	
	            case 10:
	              _context8.prev = 10;
	              _context8.t0 = _context8["catch"](0);
	
	              console.error('Error al verificar Bluetooth:', _context8.t0);
	              setBluetoothStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  available: false,
	                  message: 'Error al verificar el estado del Bluetooth.'
	                });
	              });
	
	            case 14:
	            case "end":
	              return _context8.stop();
	          }
	        }
	      }, _callee8, undefined, [[0, 10]]);
	    }));
	
	    return function checkBluetoothStatus() {
	      return _ref10.apply(this, arguments);
	    };
	  }();
	
	  var nomtabla = void 0;
	
	  if (operacion === 4) {
	    nomtabla = [{ label: "COD-PRODUCTO", textAlign: "center", width: "40px" }, { label: "PRODUCTO", textAlign: "center", width: "100px" }, { label: "CANTIDAD", textAlign: "center", width: "20px" }, { label: "TIPO PRECIO", textAlign: "center", width: "50px" }, { label: "PRECIO UNI.", textAlign: "center", width: "50px" }, { label: "UND. ALT.", textAlign: "center", width: "50px" }, { label: "MONTO", textAlign: "center", width: "50px" }, {
	      label: "",
	      textAlign: "center",
	      width: "20px"
	    }];
	  } else {
	    nomtabla = [{ label: "COD-PRODUCTO", textAlign: "center", width: "40px" }, { label: "PRODUCTO", textAlign: "center", width: "100px" }, { label: "EXISTENCIA", textAlign: "center", width: "30px" }, { label: "CANTIDAD", textAlign: "center", width: "20px" }, { label: "TIPO PRECIO", textAlign: "center", width: "50px" }, { label: "PRECIO UNI.", textAlign: "center", width: "50px" }, { label: "UND. ALT.", textAlign: "center", width: "50px" }, { label: "MONTO", textAlign: "center", width: "50px" }, {
	      label: _react2.default.createElement("i", { className: "fas fa-trash" }),
	      textAlign: "center",
	      width: "20px"
	    }];
	  }
	
	  var headCells = nomtabla;
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	    var lista = [];
	
	    if (target.value === "") {
	      lista = todosProductos;
	    } else {
	      lista = todosProductos.filter(function (x) {
	        if (x.idproducto.includes(target.value) || x.codigo.toLowerCase().includes(target.value.toLowerCase()) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.descripcion.toLowerCase().includes(target.value.toLowerCase()) || (0, _varios.formatMoneda)(x.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2).toLowerCase().includes(target.value.toLowerCase())) {
	          return x;
	        }
	      });
	    }
	
	    setListaProductos(lista);
	  };
	
	  var validarNumPedido = function validarNumPedido(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "numpedido") {
	          seleccionarRegistro();
	        }
	      }
	    }
	  };
	
	  var validarCliente = function validarCliente(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (cmbRif.current.value !== "" && event.target.value !== "") {
	        var rif = cmbRif.current.value + event.target.value;
	        seleccionarCliente(rif, event.which);
	      }
	    }
	  };
	
	  var onCheke = function onCheke(e) {
	    if (e.target.checked !== false) {
	      setVisibl(1);
	    } else {
	      setVisibl(0);
	    }
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros(id) {
	    var endpoint = op.conexion + "/api/pedido/productoexisselectubi?idalmacen=" + id;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setListaProductos(response.data);
	          setTodosProductos(response.data);
	        } else {
	          setListaProductos([]);
	          setTodosProductos([]);
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "el almacen no tiene productos!",
	            icono: "informacion"
	          });
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setBody();
	    setBody2();
	    setNumnotaentrega("");
	    setNumnotaentregae(0);
	    setTituloHeader("Gestionar Venta.");
	    setActivate(false);
	    setActimprime(0);
	    setHabilitado(false);
	    setHabilitadoCli(false);
	    setHabilitadoBot(false);
	    setIdpedi(0);
	    setHabilitadoProductos(false);
	    setHabilitarMoneda(false);
	    setVisibl(0);
	    setRecords([]);
	    setListaProductos([]);
	    setMoneda({
	      idmoneda: "1",
	      descripcion: "BOLIVARES",
	      simbolo: "Bs",
	      predeterminada: false,
	      valormoneda: 1.0
	    });
	    setMonedaCambio({
	      idmoneda: "4",
	      descripcion: "DOLAR",
	      simbolo: "$",
	      predeterminada: false,
	      subpredeterminada: true,
	      valormoneda: 1.0
	    });
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    setCliente({
	      idcliente: "",
	      tiporif: "J",
	      rif: "",
	      nombre: ""
	    });
	    setPedido({
	      idpedido: "0",
	      numpedido: "000000",
	      cedularif: "",
	      descripcion: "PEDIDO DE PRODUCTO",
	      totalmonto: 0.0,
	      totaliva: 0.0,
	      totaldescuento: 0.0,
	      totalexento: 0.0,
	      totalsujeto: 0.0,
	      idcliente: "",
	      idvendedor: "",
	      fecha: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	      status: 0,
	      idalmacen: "",
	      idmoneda: "",
	      idoperacioninventario: ""
	    });
	    setTotales({
	      subtotal: 0.0,
	      descuento: 0.0,
	      exento: 0.0,
	      sujeto: 0.0,
	      iva: 16.0,
	      totaliva: 0.0,
	      total: 0.0
	    });
	    for (var i = 0; i < combomoneda.length; i++) {
	      if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
	        cmbMoneda.current.selectedIndex = i;
	      }
	    }
	
	    if (operacion !== 1) {
	      txtStatus.current.value = "0";
	    }
	    setOperacion(1);
	    cmbRif.current.selectedIndex = -1;
	    txtRif.current.value = "";
	    txtNombreC.current.value = "";
	    txtFecha.current.value = "";
	    txtNumPedido.current.value = "";
	    txtNumPedido.current.setAttribute("disabled", true);
	    txtCredito.current.checked = false;
	    txtIdnota.current.value = '';
	    txtNunnota.current.value = '';
	
	    seleccionarMonedas();
	    seleccionarVendedor(idagente);
	  };
	
	  var seleccionarMonedas = function seleccionarMonedas() {
	    var campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	    var nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	    var orden = "m.idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var x = 0;
	        if (response.data.length > 0) {
	          setComboMoneda(response.data);
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].subpredeterminada) {
	              setMonedaSub(response.data[i]);
	              setMonedaCambio({
	                idmoneda: response.data[i].idmoneda,
	                descripcion: response.data[i].descripcion,
	                simbolo: response.data[i].simbolo,
	                predeterminada: response.data[i].predeterminada,
	                subpredeterminada: response.data[i].subpredeterminada,
	                valormoneda: 1.0
	              });
	              x = i;
	            } else if (response.data[i].predeterminada) {
	              setMoneda(response.data[i]);
	            }
	          }
	          selectnumfactu();
	          selectnumPedido();
	        }
	        setTimeout(function () {
	          return cmbMoneda.current.selectedIndex = x;
	        }, 200);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/pedido/actualizarnotaentrega/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          if (visibl !== 0) {
	            procesarRegistroNota();
	          } else {
	            setMostrar1(true);
	          }
	        } else if (operacion === 2) {
	          if (visibl !== 0) {
	            procesarRegistroNota();
	          } else {
	            setMostrar1(true);
	          }
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idpe + " eliminado correctamente",
	            icono: "exito"
	          });
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var procesarRegistroNota = function procesarRegistroNota() {
	    var endpoint = op.conexion + "/api/inventario/actualizarpostventas/" + 1;
	    _axios2.default.post(endpoint, body2, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion !== 4) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Venta a Crédito Registrada Correctamente",
	            icono: "exito"
	          });
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = error.response.data.message;
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var validarCantidadP = function validarCantidadP(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        var cantidades = (0, _varios.validarCantidad)({
	          index: index,
	          event: event,
	          productos: records
	        });
	        if (event.which === 13) {
	          txtIdproducto.current.value = '';
	          if (index < cantidades.data.length - 1) {
	            setTimeout(function () {
	              return txtCantidad.current[index + 1].focus();
	            }, 300);
	          } else {
	            setTimeout(function () {
	              return txtIdproducto.current.focus();
	            }, 200);
	          }
	        }
	        setMensaje(cantidades.msm);
	        setRecords(cantidades.data);
	        setTotales(cantidades.totales);
	      }
	    };
	  };
	
	  var generateSimpleTestTicket = function () {
	    var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee9() {
	      var ESC, LF, ticket;
	      return _regenerator2.default.wrap(function _callee9$(_context9) {
	        while (1) {
	          switch (_context9.prev = _context9.next) {
	            case 0:
	              try {
	                console.log('🎫 Enviando ticket de prueba a la impresora...');
	
	                // Esto es lo mínimo que necesitas para hacer imprimir algo
	                ESC = '\x1B';
	                LF = '\n';
	                ticket = '';
	
	                // Inicializar impresora
	
	                ticket += ESC + '@';
	
	                // Texto SUPER simple
	                ticket += '========================' + LF;
	                ticket += '   TICKET DE PRUEBA' + LF;
	                ticket += '========================' + LF + LF;
	                ticket += '🚀 ¡SI IMPRIME ESTO,' + LF;
	                ticket += 'LA IMPRESORA FUNCIONA!' + LF + LF;
	                ticket += 'Fecha: ' + new Date().toLocaleDateString() + LF;
	                ticket += 'Hora: ' + new Date().toLocaleTimeString() + LF + LF;
	                ticket += '========================' + LF;
	
	                // Corte automático (si tu impresora lo soporta)
	                ticket += LF + LF + LF;
	                ticket += ESC + 'i';
	                // O también puedes probar con:
	                // ticket += '\x1D\x56\x00'; // Corte parcial
	
	                console.log('Contenido a imprimir:', ticket);
	
	                // Aquí va la magia - depende de cómo estés conectado a la impresora
	
	                // Si usas WebUSB:
	                // await printViaWebUSB(ticket);
	
	                // Si usas WebSocket:
	                // await printViaWebSocket(ticket);
	
	                // Si usas una API:
	                // await printViaAPI(ticket);
	
	                console.log('✅ Ticket enviado a impresora');
	              } catch (error) {
	                console.error('❌ Error:', error);
	              }
	
	            case 1:
	            case "end":
	              return _context9.stop();
	          }
	        }
	      }, _callee9, undefined);
	    }));
	
	    return function generateSimpleTestTicket() {
	      return _ref11.apply(this, arguments);
	    };
	  }();
	
	  var imprimirPedido = function imprimirPedido() {
	
	    var tiporeppedido = JSON.parse(sessionStorage.getItem("tiporeppedido"));
	
	    var reportePedido = tiporeppedido.toString() === 'HOJA' ? 'Pedido' : 'ForPedidoMedium';
	
	    if (accbtnpedidos && accbtnpedidos.toString().substring(4, 5) === "1") {
	      if (txtNumPedido.current.value !== "") {
	        window.open(op.reportes + "/pedidos?afiliado=" + organizacion + "&reporte=" + reportePedido + "&CODIGO=" + pedido.idpedido, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      }
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var seleccionarCliente = function seleccionarCliente(rif, tecla) {
	    var campos = "c.idagente, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
	    var nomtab = "agente as c";
	    var nomid = "c.rif";
	    var nomid2 = "c.cliente";
	    var id = rif;
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtNombreC.current.value = response.data.nombrec;
	          setCliente({
	            idcliente: response.data.idagente,
	            tiporif: response.data.tiporifc,
	            rif: response.data.rifc,
	            nombre: response.data.nombrec
	          });
	          setTimeout(function () {
	            return txtIdproducto.current.focus();
	          }, 200);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un cliente con este codigo",
	            icono: "informacion"
	          });
	          txtRif.current.value = "";
	          cmbRif.current.selectedIndex = -1;
	          if (tecla === 13) {
	            txtRif.current.focus();
	          }
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarVendedor = function seleccionarVendedor(idage) {
	    var campos = "v.idagente, c.idagente as idagentec, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen, c.nombre as nombrec,substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
	    var nomtab = "agente as v inner join agente c on c.generico = true";
	    var nomid = "v.idagente";
	    var nomid2 = "v.vendedor";
	    var id = idage;
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	
	          if (accbtnpedidos && accbtnpedidos.toString().substring(0, 1) === "1") {
	            setTituloHeader("Incluir Venta.");
	            setHabilitado(true);
	            setHabilitadoCli(true);
	            setHabilitadoProductos(false);
	            setHabilitarMoneda(true);
	            setHabilitadoBot(false);
	            txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          } else {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación.",
	              texto: "¡No Posee Permiso para Realizar Ventas!",
	              icono: "error"
	            });
	          }
	          setVendedor({
	            idvendedor: response.data.idagente,
	            tiporif: response.data.tiporifv,
	            rif: response.data.rifv,
	            nombre: response.data.nombrev,
	            idalmacen: response.data.idalmacen
	          });
	          cmbRif.current.value = response.data.tiporifc;
	          txtRif.current.value = response.data.rifc;
	          txtNombreC.current.value = response.data.nombrec;
	          setCliente({
	            idcliente: response.data.idagentec,
	            tiporif: response.data.tiporifc,
	            rif: response.data.rifc,
	            nombre: response.data.nombrec
	          });
	          if (response.data.idalmacen === null || response.data.idalmacen === "" || response.data.idalmacen === 0) {
	            setListaProductos([]);
	            setTodosProductos([]);
	            setRecords([]);
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "el vendedor no tiene un almacen asociado!",
	              icono: "informacion"
	            });
	          } else {
	            seleccionarRegistros(response.data.idalmacen);
	          }
	          setTimeout(function () {
	            return txtIdproducto.current.focus();
	          }, 300);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un vendedor con este codigo",
	            icono: "informacion"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro() {
	
	    var endpoint = op.conexion + "/api/inventario/seleccionarpedidopost?&numpedido=" + ("'" + txtNumPedido.current.value.trim().toUpperCase() + "'");
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	
	          setPedido({
	            idpedido: response.data.idpedido,
	            numpedido: response.data.numpedido,
	            cedularif: response.data.cedularif,
	            descripcion: response.data.descripcion,
	            totalmonto: response.data.totalmonto,
	            totaliva: response.data.totaliva,
	            totaldescuento: response.data.totaldescuento,
	            totalexento: response.data.totalexento,
	            totalsujeto: response.data.totalsujeto,
	            idcliente: response.data.idcliente,
	            idvendedor: response.data.idvendedor,
	            fecha: (0, _moment2.default)(response.data.fechapedido).format("YYYY-MM-DD"),
	            status: response.data.status,
	            idalmacen: response.data.idalmacen,
	            idmoneda: response.data.idmoneda,
	            idoperacioninventario: response.data.idoperacioninventario
	          });
	
	          setMoneda({
	            idmoneda: response.data.idmoneda,
	            descripcion: response.data.descripcion,
	            simbolo: response.data.simbolo,
	            valormoneda: response.data.valormoneda,
	            predeterminada: response.data.predeterminada,
	            subpredeterminada: response.data.subpredeterminada
	          });
	
	          setCliente({
	            idcliente: response.data.idcliente,
	            tiporif: response.data.tiporifc,
	            rif: response.data.rifc,
	            nombre: response.data.nombrec
	          });
	          cmbRif.current.value = response.data.tiporifc;
	          txtRif.current.value = response.data.rifc;
	          txtNombreC.current.value = response.data.nombrec;
	
	          setVendedor({
	            idvendedor: response.data.idvendedor,
	            tiporif: response.data.tiporifv,
	            rif: response.data.rifv,
	            nombre: response.data.nombrev,
	            idalmacen: response.data.idalmacen
	          });
	
	          if (response.data.idalmacen === null || response.data.idalmacen === "" || response.data.idalmacen === 0) {
	            setListaProductos([]);
	            setTodosProductos([]);
	            setRecords([]);
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "el vendedor no tiene un almacen asociado!",
	              icono: "informacion"
	            });
	          } else {
	            seleccionarRegistros(response.data.idalmacen);
	          }
	          txtNumPedido.current.setAttribute("disabled", true);
	          if (operacion !== 1) {
	            txtStatus.current.value = response.data.status;
	          }
	          txtFecha.current.value = (0, _moment2.default)(response.data.fechapedido).format("YYYY-MM-DD");
	          for (var i = 0; i < combomoneda.length; i++) {
	            if (response.data.idmoneda === combomoneda[i].idmoneda) {
	              cmbMoneda.current.selectedIndex = i;
	              break;
	            }
	          }
	          txtIdnota.current.value = response.data.idnotaentregad;
	          txtNunnota.current.value = response.data.numnotaentregad;
	          seleccionarDetalle(response.data.idpedido);
	          setTotales({
	            subtotal: response.data.totalmonto - response.data.totaliva,
	            descuento: response.data.totaldescuento,
	            exento: response.data.totalexento,
	            sujeto: response.data.totalsujeto,
	            iva: 16.0,
	            totaliva: response.data.totaliva,
	            total: response.data.totalmonto
	          });
	
	          if (operacion === 2) {
	            setHabilitado(true);
	            setHabilitarMoneda(true);
	            setHabilitadoCli(true);
	            setTimeout(function () {
	              return txtIdproducto.current.focus();
	            }, 200);
	          } else {
	            setHabilitado(false);
	            setHabilitadoCli(false);
	            setTimeout(function () {
	              return txtIdproducto.current.focus();
	            }, 200);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "no existe un pedido con ese codigo.",
	            icono: "informacion"
	          });
	          txtNumPedido.current.value = "";
	          txtNumPedido.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      console.log(error);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarDetalle = function seleccionarDetalle(idpedido) {
	    var nomtab1 = "pedidodetalle";
	    var nomtab2 = "pedido";
	    var nomid = "idpedido";
	    var endpoint = op.conexion + "/api/inventario/seleccionarnotaentregadet?id=" + idpedido + "&nomtab1=" + nomtab1 + "&nomtab2=" + nomtab2 + "&nomid=" + nomid;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var prod = [];
	          var uni = [];
	          var montoiva = 0.0;
	          var cantie = 0.0;
	          var cantiea = 0.0;
	          var tipouni = 0;
	          var tiene_iva = false;
	
	          for (var i = 0; i < response.data.length; i++) {
	            if (parseFloat(response.data[i].iva) > 0.0) {
	              tiene_iva = true;
	            }
	            if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) <= 0.0) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantiea = Math.trunc(cantiea);
	            } else if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) > 0.0) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }, {
	                idunidad: response.data[i].idunidadalterna,
	                descripcion: response.data[i].descripcionunialt,
	                tipo: "alterna"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) / parseFloat(response.data[i].valorfactor) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) / parseFloat(response.data[i].valorfactor) + parseFloat(response.data[i].cantidad);
	
	              cantiea = cantiea * parseFloat(response.data[i].valorfactor);
	              cantiea = Math.trunc(cantiea);
	            } else if (response.data[i].tipounidad === 1) {
	              tipouni = 1;
	              uni = [{
	                idunidad: response.data[i].idunidadalterna,
	                descripcion: response.data[i].descripcionunialt,
	                tipo: "alterna"
	              }, {
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantiea = Math.trunc(cantiea);
	            }
	
	            prod.push({
	              idproducto: response.data[i].idproducto,
	              codigo: response.data[i].codigo,
	              cantidad: response.data[i].cantidad,
	              cantidadE: parseFloat(cantie),
	              cantidadEA: parseFloat(cantiea),
	              nombrecorto: response.data[i].nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	              precio: response.data[i].punitario,
	              preciobs: response.data[i].punitariobs,
	              preciomaxi: response.data[i].preciomaxi,
	              precioofe: response.data[i].precioofe,
	              preciomayor: response.data[i].preciomayor,
	              preciomini: response.data[i].preciomini,
	              preciomaxialter: response.data[i].preciomaxialter,
	              precioofealter: response.data[i].precioofealter,
	              preciomayoralter: response.data[i].preciomayoralter,
	              preciominialter: response.data[i].preciominialter,
	              iva: response.data[i].iva,
	              ivaventa: response.data[i].ivaventa,
	              montoiva: response.data[i].cantidad * montoiva,
	              descuento: response.data[i].descuento,
	              total: response.data[i].cantidad * response.data[i].punitario,
	              unidad: uni,
	              idunidadmedida: response.data[i].idunidadmedida,
	              idunidadalterna: response.data[i].idunidadalterna,
	              costocalculado: response.data[i].costocalculado,
	              costocalculadoalter: response.data[i].costocalculadoalter,
	              utipreciomaxi: response.data[i].utipreciomaxi,
	              utipreciomaxialter: response.data[i].utipreciomaxialter,
	              tipounidad: tipouni,
	              valormoneda: monedaCambio.valormoneda,
	              idmoneda: response.data[i].idmoneda,
	              tipofactor: response.data[i].tipofactor,
	              valorfactor: response.data[i].valorfactor,
	              tipoprecio: response.data[i].tipopreciodeta
	            });
	          }
	
	          setRecords(prod);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var onCatalogoCliente = function onCatalogoCliente(values) {
	    setCatalogoCliente(false);
	    if (tipoAgente === "cliente") {
	      cmbRif.current.value = values.rif.substring(0, 1);
	      txtRif.current.value = values.rif.substring(1);
	      seleccionarCliente(values.rif);
	    } else {
	      setVendedor({
	        idvendedor: values.idagente,
	        tiporif: values.rif.substring(0, 1),
	        rif: values.rif.substring(1),
	        nombre: values.nombre,
	        idalmacen: values.idalmacen
	      });
	      if (values.idalmacen === null || values.idalmacen === "" || values.idalmacen === 0) {
	        setListaProductos([]);
	        setTodosProductos([]);
	        setRecords([]);
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificacion",
	          texto: "el vendedor no tiene un almacen asociado!",
	          icono: "informacion"
	        });
	      } else {
	        seleccionarRegistros(values.idalmacen);
	      }
	    }
	  };
	
	  var oncatalogoPedidoEntrega = function oncatalogoPedidoEntrega(values) {
	    setCatalogoPedido(false);
	    if (values !== "") {
	      txtNumPedido.current.value = values.numpedido;
	      seleccionarRegistro();
	      setActimprime(1);
	      setOperacion(2);
	    } else {
	      setActimprime(0);
	    }
	  };
	
	  var onChangeMoneda = function onChangeMoneda(e) {
	    var i = e.target.value;
	    var cambio = (0, _varios.onCambioMoneda)({
	      moneda: combomoneda[i],
	      productos: records,
	      monedaPre: moneda,
	      monedaSub: monedaSub
	    });
	    setMonedaCambio(cambio.monedacambio);
	    setRecords(cambio.data);
	  };
	
	  var onChangeUnidad = function onChangeUnidad(i) {
	    return function (e) {
	      var cambiounidad = (0, _varios.onCambioUnidad)({
	        idunidad: e.target.value,
	        index: i,
	        productos: records
	      });
	      setMensaje(cambiounidad.msm);
	      setRecords(cambiounidad.data);
	      setTotales(cambiounidad.totales);
	    };
	  };
	
	  var onChangeTipoPrecio = function onChangeTipoPrecio(i) {
	    return function (e) {
	      var data = [].concat(_toConsumableArray(records));
	      var tipoprecio = parseInt(e.target.value);
	      var tipounidad = data[i].tipounidad;
	      var cantidad = data[i].cantidad;
	      var precio = 0.0;
	      var total = 0.0;
	
	      if (tipounidad === 1) {
	        if (tipoprecio === 1) {
	          precio = parseFloat(data[i].preciomaxialter);
	        } else if (tipoprecio === 2) {
	          precio = parseFloat(data[i].precioofealter);
	        } else if (tipoprecio === 3) {
	          precio = parseFloat(data[i].preciomayoralter);
	        } else if (tipoprecio === 4) {
	          precio = parseFloat(data[i].preciominialter);
	        }
	      } else {
	        if (tipoprecio === 1) {
	          precio = parseFloat(data[i].preciomaxi);
	        } else if (tipoprecio === 2) {
	          precio = parseFloat(data[i].precioofe);
	        } else if (tipoprecio === 3) {
	          precio = parseFloat(data[i].preciomayor);
	        } else if (tipoprecio === 4) {
	          precio = parseFloat(data[i].preciomini);
	        }
	      }
	
	      total = precio * cantidad;
	
	      data[i].tipoprecio = e.target.value;
	      data[i].precio = precio;
	      data[i].total = total;
	
	      setRecords(data);
	      setTotales((0, _varios.calcularTotales)(data));
	    };
	  };
	
	  var seleccionarProducto = function seleccionarProducto(index, idubi, idprod) {
	    var endpoint = op.conexion + "/api/inventario/seleccionarproductoinv?idproducto='" + idprod.toUpperCase() + "'&idalmacen=" + idubi;
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var data = [].concat(_toConsumableArray(records));
	        if (response.data !== "") {
	
	          for (var e = 0; e < records.length; e++) {
	
	            var valcantidad = parseFloat(response.data.cantidad) <= 0 ? 0 : 1;
	            if (records[e].idproducto === response.data.idproducto && valcantidad <= 0) {
	              setMensaje({
	                mostrar: true,
	                titulo: "Notificacion",
	                texto: "¡Este Producto no Cuenta con Existencia!.",
	                icono: "error"
	              });
	              txtIdproducto.current.value = '';
	              setTimeout(function () {
	                return txtIdproducto.current.focus();
	              }, 200);
	              return;
	            }
	          }
	
	          if (response.data.servicio) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "No existe un Producto con ese Código en el Almacen.",
	              icono: "error"
	            });
	            txtIdproducto.current.value = '';
	            setTimeout(function () {
	              return txtIdproducto.current.focus();
	            }, 200);
	          } else {
	            var unis = [];
	            for (var i = 0; i < records.length; i++) {
	
	              if (records[i].idproducto === response.data.idproducto) {
	                var _valcantidad = parseFloat(records[i].cantidad + 1) > parseFloat(response.data.cantidad) ? 0 : parseFloat(response.data.cantidad) <= 0 ? 0 : 1;
	                if (_valcantidad <= 0) {
	                  setMensaje({
	                    mostrar: true,
	                    titulo: "Notificacion",
	                    texto: "¡Este Producto no Cuenta con Existencia!.",
	                    icono: "error"
	                  });
	                  txtIdproducto.current.value = '';
	                  setTimeout(function () {
	                    return txtIdproducto.current.focus();
	                  }, 200);
	                  return;
	                }
	
	                if (parseInt(response.data.tipofactor) === 0 || response.data.tipofactor === null) {
	                  tipouni = 0;
	                  unis = [{
	                    idunidad: response.data.idunidadmedida,
	                    descripcion: response.data.descripcionuni,
	                    tipo: "medida"
	                  }];
	
	                  cantie = parseFloat(response.data.cantidad);
	                  cantie = Math.trunc(cantie);
	                } else {
	                  tipouni = 1;
	                  unis = [{
	                    idunidad: response.data.idunidadalterna,
	                    descripcion: response.data.descripcionunialt,
	                    tipo: "alterna"
	                  }, {
	                    idunidad: response.data.idunidadmedida,
	                    descripcion: response.data.descripcionuni,
	                    tipo: "medida"
	                  }];
	
	                  cantie = parseFloat(response.data.cantidad);
	                  cantie = Math.trunc(cantie);
	                }
	
	                var tipoprecioActual = tipopre && parseInt(tipopre.tipoprecio) > 0 ? parseInt(tipopre.tipoprecio) : records[i].tipoprecio;
	
	                data[i] = {
	                  idproducto: records[i].idproducto,
	                  codigo: records[i].codigo,
	                  cantidad: records[i].cantidad + 1,
	                  cantidadE: cantie,
	                  cantidadEA: parseFloat(records[i].cantidad),
	                  nombrecorto: records[i].nombrecorto,
	                  precio: records[i].precio,
	                  preciobs: 0.0,
	                  preciomaxi: records[i].preciomaxi,
	                  precioofe: records[i].precioofe,
	                  preciomayor: records[i].preciomayor,
	                  preciomini: records[i].preciomini,
	                  preciomaxialter: records[i].preciomaxialter,
	                  precioofealter: records[i].precioofealter,
	                  preciomayoralter: records[i].preciomayoralter,
	                  preciominialter: records[i].preciominialter,
	                  iva: records[i].iva,
	                  montoiva: records[i].montoiva,
	                  descuento: 0.0,
	                  total: records[i].precio * (records[i].cantidad + 1),
	                  idunidadmedida: records[i].idunidadmedida,
	                  idunidadalterna: records[i].idunidadalterna,
	                  unidad: unis,
	                  idmoneda: records[i].idmoneda,
	                  valormoneda: records[i].valormoneda,
	                  tipounidad: records[i].tipounidad,
	                  tipofactor: records[i].tipofactor,
	                  valorfactor: records[i].valorfactor,
	                  tipoprecio: tipoprecioActual
	                };
	
	                setRecords(data);
	                setTotales((0, _varios.calcularTotales)(data));
	                setIndice(i);
	                if (i !== null) {
	                  txtIdproducto.current.value = '';
	                  setTimeout(function () {
	                    return txtIdproducto.current.focus();
	                  }, 200);
	                } else {
	                  txtIdproducto.current.value = '';
	                  setTimeout(function () {
	                    return txtIdproducto.current.focus();
	                  }, 200);
	                }
	                return;
	              }
	            }
	
	            var uni = [];
	            var precio = 0.0;
	            var montoiva = 0.0;
	            var cantie = response.data.cantidad;
	            var tipouni = 0;
	            var tiene_iva = false;
	
	            var tipoprecio = tipopre && parseInt(tipopre.tipoprecio) > 0 ? parseInt(tipopre.tipoprecio) : parseInt(response.data.tipoprecio);
	
	            if (parseFloat(response.data.ivaventa) > 0.0) {
	              tiene_iva = true;
	            }
	
	            if (parseInt(response.data.tipofactor) === 0 || response.data.tipofactor === null) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data.idunidadmedida,
	                descripcion: response.data.descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data.cantidad);
	              cantie = Math.trunc(cantie);
	
	              if (tipoprecio === 1) {
	                precio = parseFloat(response.data.preciomaxi);
	              } else if (tipoprecio === 2) {
	                precio = parseFloat(response.data.precioofe);
	              } else if (tipoprecio === 3) {
	                precio = parseFloat(response.data.preciomayor);
	              } else if (tipoprecio === 4) {
	                precio = parseFloat(response.data.preciomini);
	              }
	            } else {
	              tipouni = 1;
	              uni = [{
	                idunidad: response.data.idunidadalterna,
	                descripcion: response.data.descripcionunialt,
	                tipo: "alterna"
	              }, {
	                idunidad: response.data.idunidadmedida,
	                descripcion: response.data.descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data.cantidad);
	              cantie = Math.trunc(cantie);
	              if (tipoprecio === 1) {
	                precio = parseFloat(response.data.preciomaxialter);
	              } else if (tipoprecio === 2) {
	                precio = parseFloat(response.data.precioofealter);
	              } else if (tipoprecio === 3) {
	                precio = parseFloat(response.data.preciomayoralter);
	              } else if (tipoprecio === 4) {
	                precio = parseFloat(response.data.preciominialter);
	              }
	            }
	
	            if (index !== null) {
	              data[index] = {
	                idproducto: response.data.idproducto,
	                codigo: response.data.codigo,
	                cantidad: 1.0,
	                cantidadE: cantie,
	                cantidadEA: parseFloat(response.data.cantidad),
	                nombrecorto: response.data.nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	                precio: precio,
	                preciobs: 0.0,
	                preciomaxi: response.data.preciomaxi,
	                precioofe: response.data.precioofe,
	                preciomayor: response.data.preciomayor,
	                preciomini: response.data.preciomini,
	                preciomaxialter: response.data.preciomaxialter,
	                precioofealter: response.data.precioofealter,
	                preciomayoralter: response.data.preciomayoralter,
	                preciominialter: response.data.preciominialter,
	                iva: response.data.ivaventa,
	                montoiva: montoiva,
	                descuento: 0.0,
	                total: precio,
	                unidad: uni,
	                idunidadmedida: response.data.idunidadmedida,
	                idunidadalterna: response.data.idunidadalterna,
	                idunidadventa: response.data.idunidadventa,
	                idmoneda: response.data.idmoneda,
	                valormoneda: monedaCambio.valormoneda,
	                tipounidad: tipouni,
	                tipofactor: response.data.tipofactor,
	                valorfactor: response.data.valorfactor,
	                tipoprecio: tipoprecio.toString()
	              };
	              setRecords(data);
	              setTotales((0, _varios.calcularTotales)(data));
	              setIndice(index);
	
	              if (index !== null) {
	                setIndexs(0);
	                txtIdproducto.current.value = '';
	                setTimeout(function () {
	                  return txtIdproducto.current.focus();
	                }, 200);
	              } else {
	                txtIdproducto.current.value = '';
	                setTimeout(function () {
	                  return txtIdproducto.current.focus();
	                }, 200);
	              }
	            } else {
	              data.push({
	                idproducto: response.data.idproducto,
	                codigo: response.data.codigo,
	                cantidad: 1.0,
	                cantidadE: cantie,
	                cantidadEA: parseFloat(response.data.cantidad),
	                nombrecorto: response.data.nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	                precio: precio,
	                preciomaxi: response.data.preciomaxi,
	                precioofe: response.data.precioofe,
	                preciomayor: response.data.preciomayor,
	                preciomini: response.data.preciomini,
	                preciomaxialter: response.data.preciomaxialter,
	                precioofealter: response.data.precioofealter,
	                preciomayoralter: response.data.preciomayoralter,
	                preciominialter: response.data.preciominialter,
	                preciobs: 0.0,
	                iva: response.data.ivaventa,
	                montoiva: montoiva,
	                descuento: 0.0,
	                total: precio,
	                unidad: uni,
	                idunidadmedida: response.data.idunidadmedida,
	                idunidadalterna: response.data.idunidadalterna,
	                idunidadventa: response.data.idunidadventa,
	                idmoneda: response.data.idmoneda,
	                valormoneda: monedaCambio.valormoneda,
	                tipounidad: tipouni,
	                tipofactor: response.data.tipofactor,
	                valorfactor: response.data.valorfactor,
	                tipoprecio: tipoprecio.toString()
	              });
	              setRecords(data);
	              setTotales((0, _varios.calcularTotales)(data));
	              setIndice(index);
	
	              if (index !== null) {
	                setIndexs(0);
	                txtIdproducto.current.value = '';
	                setTimeout(function () {
	                  return txtIdproducto.current.focus();
	                }, 200);
	              } else {
	                txtIdproducto.current.value = '';
	                setTimeout(function () {
	                  return txtIdproducto.current.focus();
	                }, 200);
	              }
	            }
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "no existe un producto con ese codigo en el almacen.",
	            icono: "error"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var validarIdProducto = function validarIdProducto(index) {
	    return function (event) {
	      if (event.which === 13 || typeof event.which === "undefined") {
	        if (event.target.value !== "") {
	          if (vendedor.idalmacen !== "" && vendedor.idalmacen !== null) {
	            seleccionarProducto(index, vendedor.idalmacen, event.target.value);
	          } else {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación.",
	              texto: "debe seleccionar un vendedor.",
	              icono: "informacion"
	            });
	          }
	        }
	      }
	    };
	  };
	
	  var agregarProducto = function agregarProducto(producto) {
	    seleccionarProducto(indice, vendedor.idalmacen, producto.codigo);
	    setMostrar(false);
	  };
	
	  var eliminarProducto = function eliminarProducto(producto) {
	    return function (e) {
	      e.preventDefault();
	      var data = [].concat(_toConsumableArray(records));
	      var elementos = [];
	
	      for (var i = 0; i < data.length; i++) {
	        if (producto.idproducto !== data[i].idproducto) {
	          elementos.push(data[i]);
	          txtIdproducto.current.value = '';
	          setTimeout(function () {
	            return txtIdproducto.current.focus();
	          }, 200);
	        } else {
	          txtIdproducto.current.value = '';
	          setTimeout(function () {
	            return txtIdproducto.current.focus();
	          }, 200);
	        }
	      }
	      setRecords(elementos);
	      setTotales((0, _varios.calcularTotales)(elementos));
	    };
	  };
	
	  var seleccionarxIndice = function seleccionarxIndice(index) {
	    return function (e) {
	      e.preventDefault();
	      if (vendedor.idalmacen !== "" && vendedor.idalmacen !== null) {
	        setMostrar(true);
	        setIndice(index);
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación.",
	          texto: "debe seleccionar un vendedor.",
	          icono: "informacion"
	        });
	      }
	    };
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    event.preventDefault();
	    if (event.which === 13) {
	      if (event.target.name === "fecha") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	        btnProducto.current.focus();
	      }
	    } else if (typeof event.which === "undefined") {
	      if (event.target.name === "fecha") {
	        event.target.value = (0, _moment2.default)(event.target.value).format("YYYY-MM-DD");
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	
	    if (bluetoothStatus.checked) {
	      // 2. ¿La impresora NO está conectada?
	      if (!printerStatus.connected) {
	        setMensaje({
	          mostrar: true,
	          titulo: "Impresora Requerida",
	          texto: "El sistema detectó que Bluetooth está activo, pero la impresora no está conectada. Por favor conecte la impresora antes de procesar el pago.",
	          icono: "informacion"
	        });
	        sigue = false; // Detenemos el proceso aquí
	      }
	    }
	
	    if (cmbRif.current.value === "" || txtRif.current.value.trim() === "" || txtNombreC.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Cliente no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtRif.current.focus();
	    } else if (txtFecha.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtFecha.current.focus();
	    } else if (records.length === 0) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "No hay Productos agregados",
	        icono: "informacion"
	      });
	      sigue = false;
	      setTimeout(function () {
	        return txtIdproducto.current.focus();
	      }, 200);
	    } else if (records.length > 0 && operacion !== 3) {
	      for (var i = 0; i < records.length; i++) {
	        if (records[i].cantidadE === 0.0) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "La  cantidad no debe ser mayor a la cantidad existente",
	            icono: "informacion"
	          });
	          sigue = false;
	          setTimeout(function () {
	            return txtIdproducto.current.focus();
	          }, 200);
	          break;
	        } else if (records[i].cantidadE < records[i].cantidad) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "La  cantidad no debe ser mayor a la cantidad existente",
	            icono: "informacion"
	          });
	          sigue = false;
	          setTimeout(function () {
	            return txtIdproducto.current.focus();
	          }, 200);
	          break;
	        }
	      }
	    }
	
	    if (sigue) {
	      var pedi = [];
	      var pedidet = [];
	      var opeinv = [];
	      var opeinvdet = [];
	      var notae = [];
	      var notaedet = [];
	
	      pedi.push({
	        idpedido: pedido.idpedido,
	        numpedido: pedido.numpedido,
	        cedularif: cliente.tiporif + cliente.rif,
	        descripcion: "VENTA DE PRODUCTOS",
	        totalmonto: totales.total,
	        totaliva: totales.totaliva,
	        totaldescuento: totales.descuento,
	        totalsujeto: totales.sujeto,
	        totalexento: totales.exento,
	        idcliente: cliente.idcliente,
	        idvendedor: vendedor.idvendedor,
	        fecha: txtFecha.current.value,
	        status: pedido.status,
	        idalmacen: vendedor.idalmacen,
	        idmoneda: monedaSub.idmoneda,
	        idoperacioninventario: pedido.idoperacioninventario
	      });
	
	      opeinv.push({
	        idoperacioninventario: pedido.idoperacioninventario === null || pedido.idoperacioninventario === "" ? "0" : pedido.idoperacioninventario,
	        tipooperacion: "SALIDA",
	        idalmacenorigen: vendedor.idalmacen,
	        idalmacendestino: "",
	        fecha: txtFecha.current.value,
	        idmoneda: monedaSub.idmoneda,
	        observacion: "PEDIDO"
	      });
	
	      notae.push({
	        idnotaentrega: operacion === 2 && txtIdnota.current.value !== '' ? parseInt(txtIdnota.current.value) : 0,
	        numnotaentrega: operacion === 2 && txtNunnota.current.value !== '' ? txtNunnota.current.value : numnotaentrega,
	        numpedido: operacion === 1 ? txtNumPedido.current.value : pedido.numpedido,
	        descripcion: "NOTA DE ENTREGA DE PRODUCTOS",
	        cedularif: cliente.tiporif + cliente.rif,
	        tipo: "NE",
	        totalmonto: totales.total,
	        totaliva: totales.totaliva,
	        totalexento: totales.exento,
	        totalsujeto: totales.sujeto,
	        totaldescuento: totales.descuento,
	        idpedido: operacion === 1 ? idpedi : pedido.idpedido,
	        idcliente: cliente.idcliente,
	        idvendedor: vendedor.idvendedor,
	        fecha: txtFecha.current.value,
	        status: operacion !== 4 && visibl !== 0 ? 0 : 1,
	        idalmacen: vendedor.idalmacen,
	        idmoneda: monedaSub.idmoneda,
	        idoperacioninventario: "",
	        credito: visibl !== 0 ? true : false,
	        fechavencimiento: visibl !== 0 ? txtFechaVence.current.value : null,
	        facturado: 0
	      });
	      setNotaen(notae);
	      var valnot = txtIdnota.current.value !== '' ? 1 : 0;
	      setNumnotaentregae(valnot);
	
	      for (var _i = 0; _i < records.length; _i++) {
	        pedidet.push({
	          idproducto: records[_i].idproducto,
	          cantidad: records[_i].cantidad,
	          iva: records[_i].iva,
	          punitario: records[_i].precio,
	          descuento: "0.00",
	          tipounidad: records[_i].tipounidad,
	          idunidadmedida: records[_i].idunidadmedida,
	          idunidadalterna: records[_i].idunidadalterna,
	          tasa: monedaSub.valormoneda,
	          codproducto: records[_i].codigo,
	          costo: records[_i].costocalculado,
	          utilidad: records[_i].utipreciomaxi,
	          tipopreciodeta: records[_i].tipoprecio
	        });
	
	        opeinvdet.push({
	          idproducto: records[_i].idproducto,
	          nombre: records[_i].nombrecorto,
	          cantidad: records[_i].cantidad,
	          precio: records[_i].precio,
	          fechavencimiento: "",
	          tipomovimiento: "VENTA",
	          fechatipomovimiento: txtFecha.current.value,
	          numfactura: pedido.numpedido,
	          idalmacen: vendedor.idalmacen,
	          tipounidad: records[_i].tipounidad,
	          idunidadmedida: records[_i].idunidadmedida,
	          idunidadalterna: records[_i].idunidadalterna,
	          tipofactor: records[_i].tipofactor,
	          valorfactor: records[_i].valorfactor,
	          tasa: monedaSub.valormoneda
	        });
	
	        notaedet.push({
	          idproducto: records[_i].idproducto,
	          cantidad: records[_i].cantidad,
	          punitario: records[_i].precio,
	          punitariobs: parseFloat(records[_i].precio) * parseFloat(monedaSub.valormoneda),
	          descuento: "0.00",
	          iva: records[_i].iva,
	          tipounidad: records[_i].tipounidad,
	          idunidadmedida: records[_i].idunidadmedida,
	          idunidadalterna: records[_i].idunidadalterna,
	          tasa: monedaSub.valormoneda,
	          codproducto: records[_i].codigo,
	          costo: records[_i].costocalculado,
	          utilidad: records[_i].utipreciomaxi,
	          tipopreciodeta: records[_i].tipoprecio
	        });
	      }
	      setNotaedeta(notaedet);
	      setOpeinvc(opeinv);
	      setOpeinvdetc(opeinvdet);
	      setBody({
	        notaentre: pedi,
	        notaentredet: pedidet,
	        idtipopeinv: 2,
	        opeinv: [],
	        opeinvdet: []
	      });
	      setBody2({
	        notaentre: notae,
	        notaentredet: notaedet,
	        pagos: [],
	        pagosdeta: [],
	        app: false,
	        ncaja: 77,
	        fecharev: null,
	        fechapag: null,
	        nidcaja: null,
	        idusu: null,
	        motivo: '',
	        opinv: opeinv,
	        opeinvdet: opeinvdet
	      });
	
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      if (pedido.status === 4) {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificacion",
	          texto: "El pedido ya fue anulado",
	          icono: "error"
	        });
	      } else {
	        setMensajesino({
	          mostrar: true,
	          titulo: "Confirmación.",
	          texto: msg,
	          icono: "confirmacion"
	        });
	      }
	    }
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 3) {
	        setMostrarsup(true);
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        seleccionarMonedas();
	        seleccionarVendedor(idagente);
	        blanquear();
	      }
	    };
	  };
	
	  var selectnumfactu = function selectnumfactu() {
	    var tabla = "notaentrega";
	    var id = "idnotaentrega";
	    var idtabla = "idnotaentrega";
	    var endpoint = op.conexion + "/api/inventario/consultacodigos?tabla=" + tabla + "&idtabla=" + idtabla + "&id=" + id;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.numeroasignado > 0) {
	          var to = parseFloat(response.data.numeroasignado) + 1;
	          var cerrrou = '000000';
	          var paddedNumber = (0, _varios.lpad)(to.toString(), cerrrou, 7);
	          setNumnotaentrega("NE" + paddedNumber);
	        } else {
	          setNumnotaentrega("NE000001");
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var selectnumPedido = function selectnumPedido() {
	    var tabla = "pedido";
	    var id = "idpedido";
	    var idtabla = "idpedido";
	    var endpoint = op.conexion + "/api/inventario/consultacodigos?tabla=" + tabla + "&idtabla=" + idtabla + "&id=" + id;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.numeroasignado > 0) {
	          var to = parseFloat(response.data.numeroasignado) + 1;
	          var cerrrou = '000000';
	          var paddedNumber = (0, _varios.lpad)(to.toString(), cerrrou, 7);
	          txtNumPedido.current.value = "P" + paddedNumber;
	          setIdpedi(to);
	        } else {
	          txtNumPedido.current.value = "P0000001";
	          setIdpedi(0);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarMonedas();
	    seleccionarVendedor(idagente);
	    var handleKeyDown = function handleKeyDown(evento) {
	      if (evento.key === 'F12') {
	        evento.preventDefault();
	        onChangeValidar();
	      }
	    };
	
	    document.addEventListener('keydown', handleKeyDown);
	
	    return function () {
	      document.removeEventListener('keydown', handleKeyDown);
	    };
	  }, []);
	
	  function toggleFullscreen() {
	    if (!document.fullscreenElement) {
	      document.documentElement.requestFullscreen();
	    } else {
	      document.exitFullscreen();
	    }
	  }
	
	  var imprimirDesdeFacturar = function () {
	    var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(id) {
	      var ticket, encoder, data, characteristic, chunkSize, i, chunk, mensajeError;
	      return _regenerator2.default.wrap(function _callee10$(_context10) {
	        while (1) {
	          switch (_context10.prev = _context10.next) {
	            case 0:
	              console.log('🔍 Iniciando impresión desde facturar para ID:', id);
	
	              // 1. Validaciones básicas
	
	              if (id) {
	                _context10.next = 4;
	                break;
	              }
	
	              setMensaje({
	                mostrar: true,
	                titulo: "Error",
	                texto: "No hay ID de factura para imprimir.",
	                icono: "error"
	              });
	              return _context10.abrupt("return");
	
	            case 4:
	              if (printerStatus.connected) {
	                _context10.next = 7;
	                break;
	              }
	
	              setMensaje({
	                mostrar: true,
	                titulo: "Bluetooth Desconectado",
	                texto: "Por favor, conecte la impresora Bluetooth antes de continuar.",
	                icono: "informacion"
	              });
	              return _context10.abrupt("return");
	
	            case 7:
	
	              // 2. Actualizar estado UI (Mostrando "Imprimiendo...")
	              setPrinterStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  printing: true,
	                  statusMessage: 'Imprimiendo factura...'
	                });
	              });
	
	              _context10.prev = 8;
	              _context10.next = 11;
	              return generateTicketWithTable(id);
	
	            case 11:
	              ticket = _context10.sent;
	
	
	              console.log('✅ Ticket generado correctamente. Enviando a impresora...');
	
	              // 4. Codificar el texto a Bytes (Uint8Array)
	              encoder = new TextEncoder();
	              data = encoder.encode(ticket);
	              characteristic = printerStatus.characteristic;
	
	              if (characteristic) {
	                _context10.next = 18;
	                break;
	              }
	
	              throw new Error('La impresora está conectada pero no se encontró el canal de comunicación (Characteristic). Intente desconectar y conectar de nuevo.');
	
	            case 18:
	
	              // 5. Definir tamaño del paquete (Chunk) según el tipo de impresora detectada
	              chunkSize = printerStatus.printerType === 'mp80' ? 40 : printerStatus.printerType === 'jingpu' ? 20 : 10;
	
	
	              console.log("\uD83D\uDCE4 Enviando " + data.length + " bytes en fragmentos de " + chunkSize + " bytes...");
	
	              // 6. Bucle de envío de datos
	              i = 0;
	
	            case 21:
	              if (!(i < data.length)) {
	                _context10.next = 47;
	                break;
	              }
	
	              chunk = data.slice(i, i + chunkSize);
	              _context10.prev = 23;
	
	              if (!characteristic.properties.writeWithoutResponse) {
	                _context10.next = 29;
	                break;
	              }
	
	              _context10.next = 27;
	              return characteristic.writeValueWithoutResponse(chunk);
	
	            case 27:
	              _context10.next = 35;
	              break;
	
	            case 29:
	              if (!characteristic.properties.write) {
	                _context10.next = 34;
	                break;
	              }
	
	              _context10.next = 32;
	              return characteristic.writeValue(chunk);
	
	            case 32:
	              _context10.next = 35;
	              break;
	
	            case 34:
	              throw new Error('La característica de la impresora no permite escribir datos.');
	
	            case 35:
	              _context10.next = 41;
	              break;
	
	            case 37:
	              _context10.prev = 37;
	              _context10.t0 = _context10["catch"](23);
	
	              console.error("\u274C Error enviando fragmento " + i + ":", _context10.t0);
	              // Si falla un fragmento (ej: impresora desconectó aquí), detenemos todo
	              throw _context10.t0;
	
	            case 41:
	              if (!(i + chunkSize < data.length)) {
	                _context10.next = 44;
	                break;
	              }
	
	              _context10.next = 44;
	              return new Promise(function (resolve) {
	                return setTimeout(resolve, 5);
	              });
	
	            case 44:
	              i += chunkSize;
	              _context10.next = 21;
	              break;
	
	            case 47:
	
	              console.log('✅ Envío de datos finalizado correctamente.');
	
	              // 7. Finalizar estado UI (Éxito)
	              setPrinterStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  printing: false,
	                  statusMessage: 'Listo' // La impresora se mantiene conectada
	                });
	              });
	
	              setMensaje({
	                mostrar: true,
	                titulo: "Impresión Exitosa",
	                texto: "El ticket fue enviado a la impresora.",
	                icono: "exito"
	              });
	
	              _context10.next = 59;
	              break;
	
	            case 52:
	              _context10.prev = 52;
	              _context10.t1 = _context10["catch"](8);
	
	              console.error('❌ Error en imprimirDesdeFacturar:', _context10.t1);
	
	              // 8. Finalizar estado UI (Error)
	              setPrinterStatus(function (prev) {
	                return Object.assign({}, prev, {
	                  printing: false,
	                  statusMessage: 'Error al imprimir' // No desconectamos, pero indicamos fallo
	                });
	              });
	
	              // Si el error es de conexión (la impresora se desconectó sola), el mensaje lo indicará
	              mensajeError = _context10.t1.message || "Ocurrió un error al intentar imprimir.";
	
	              if (_context10.t1.message.includes('disconnected') || _context10.t1.message.includes('Device')) {
	                mensajeError = "La impresora se desconectó inesperadamente. Por favor reconéctela.";
	              }
	
	              setMensaje({
	                mostrar: true,
	                titulo: "Error de Impresión",
	                texto: mensajeError,
	                icono: "error"
	              });
	
	            case 59:
	            case "end":
	              return _context10.stop();
	          }
	        }
	      }, _callee10, undefined, [[8, 52], [23, 37]]);
	    }));
	
	    return function imprimirDesdeFacturar(_x4) {
	      return _ref12.apply(this, arguments);
	    };
	  }();
	  var BluetoothPrintButtons = function BluetoothPrintButtons() {
	    if (!bluetoothStatus.checked) return null;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 mx-auto mb-3 p-3 border rounded bg-light shadow-sm" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-12" },
	        _react2.default.createElement(
	          "div",
	          { className: "d-flex justify-content-between align-items-center mb-2" },
	          _react2.default.createElement(
	            "h5",
	            { className: "fw-bold text-primary mb-0" },
	            _react2.default.createElement("i", { className: "fas fa-print me-2" }),
	            "Impresi\xF3n Bluetooth Universal"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "row align-items-center mb-2" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-5" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group input-group-sm" },
	              _react2.default.createElement(
	                "span",
	                { className: "input-group-text fw-bold" },
	                _react2.default.createElement("i", { className: "fas fa-circle " + (printerStatus.connected ? 'text-success' : printerStatus.scanning ? 'text-warning' : 'text-danger') })
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                className: "form-control fw-bold " + (printerStatus.connected ? 'text-success' : printerStatus.scanning ? 'text-warning' : 'text-danger'),
	                value: printerStatus.statusMessage,
	                readOnly: true,
	                title: printerStatus.errorDetails
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-7 d-flex justify-content-end flex-wrap gap-2" },
	            !printerStatus.scannedDevice ? _react2.default.createElement(
	              "button",
	              {
	                onClick: scanForBluetoothDevices,
	                disabled: printerStatus.scanning,
	                className: "btn btn-sm " + (printerStatus.scanning ? 'btn-warning' : 'btn-info')
	              },
	              printerStatus.scanning ? _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement("span", { className: "spinner-border spinner-border-sm me-2" }),
	                "Buscando..."
	              ) : _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement("i", { className: "fas fa-search me-2" }),
	                "Buscar Impresora"
	              )
	            ) : null,
	            printerStatus.scannedDevice && !printerStatus.connected ? _react2.default.createElement(
	              "button",
	              {
	                onClick: connectToPrinter,
	                disabled: printerStatus.scanning,
	                className: "btn btn-sm " + (printerStatus.scanning ? 'btn-warning' : 'btn-success')
	              },
	              printerStatus.scanning ? _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement("span", { className: "spinner-border spinner-border-sm me-2" }),
	                "Conectando..."
	              ) : _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement("i", { className: "fas fa-plug me-2" }),
	                "Conectar"
	              )
	            ) : null,
	            printerStatus.connected ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "button",
	                {
	                  onClick: disconnectPrinter,
	                  className: "btn btn-sm btn-danger"
	                },
	                _react2.default.createElement("i", { className: "fas fa-power-off me-2" }),
	                "Desconectar"
	              )
	            ) : null
	          )
	        ),
	        printerStatus.errorDetails && _react2.default.createElement(
	          "div",
	          { className: "alert alert-danger p-2 mt-2 small" },
	          _react2.default.createElement("i", { className: "fas fa-exclamation-triangle me-2" }),
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Error:"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "text-muted mt-1 small" },
	            printerStatus.errorDetails
	          )
	        )
	      )
	    );
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 ", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12 mx-auto py-2  card shadow " },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row border-azul mx-auto justify-content-between rounded py-2" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-2 azulGradiant shadow text-light justify-content-between" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-4" },
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  tituloHeader
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 d-flex justify-content-end" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    className: "btn btn-out-line text-white",
	                    onClick: toggleFullscreen
	                  },
	                  "PANTALLA COMPLETA"
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 d-flex justify-content-end" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "/inicio", className: "text-light " },
	                  _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "fw-bold" },
	                    "Salir"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "row col-md-12 mx-auto mb-1 p-0 m-0 justify-content-between",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-pd-283 px-2" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text fw-bold text-black",
	                    id: "input-id"
	                  },
	                  "PEDIDO:"
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  disabled: true,
	                  ref: txtNumPedido,
	                  name: "numpedido",
	                  autoComplete: "off",
	                  onKeyUp: validarNumPedido,
	                  onBlur: validarNumPedido,
	                  onChange: function onChange(e) {
	                    return e.target.value = e.target.value.toUpperCase();
	                  },
	                  className: "form-control fs-6 text-danger",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "input-id"
	                }),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    onClick: function onClick() {
	                      return setCatalogoPedido(true);
	                    },
	                    className: "btn btn-success"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-search" })
	                )
	              ),
	              _react2.default.createElement("input", { type: "hidden", ref: txtIdnota }),
	              _react2.default.createElement("input", { type: "hidden", ref: txtNunnota }),
	              operacion !== 1 && _react2.default.createElement(
	                "div",
	                { className: "mb-2 col-pd-240" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "ESTATUS:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: txtStatus,
	                      style: {
	                        fontWeight: "bold",
	                        color: pedido.status === 0 ? "#007bff" : pedido.status === 1 ? "#28a745" : pedido.status === 4 ? "#dc3545" : "#000000"
	                      },
	                      disabled: true,
	                      className: "form-select form-select-sm text-uppercase px-1",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "0" },
	                      "PENDIENTE"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "PROCESADO"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "4" },
	                      "ANULADO"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-600 mb-1 mx-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "fw-bold text-black fs-6" },
	                      "VENDEDOR"
	                    ),
	                    ":",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    ref: txtNombreV,
	                    autoComplete: "off",
	                    disabled: true,
	                    name: "nombres",
	                    value: vendedor.nombre + '-' + vendedor.rif,
	                    className: "form-control fs-5 bg-transparent border-0",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-2 col-pd-220 ml-auto px-2" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text fw-bold text-black",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  "FECHA:"
	                ),
	                _react2.default.createElement("input", {
	                  autoComplete: "off",
	                  type: "date",
	                  disabled: !habilitado,
	                  ref: txtFecha,
	                  className: "form-control fs-6 text-uppercase",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  name: "fecha",
	                  onKeyUp: handleInputChange,
	                  onBlur: handleInputChange
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group input-group-sm mb-1 col-md-12" },
	                _react2.default.createElement(
	                  "label",
	                  {
	                    className: "input-group-text",
	                    id: "inputGroup-sizing-sm"
	                  },
	                  _react2.default.createElement(
	                    "span",
	                    { className: "fw-bold text-black" },
	                    "CLIENTE"
	                  ),
	                  ":",
	                  " "
	                ),
	                _react2.default.createElement(
	                  "select",
	                  {
	                    ref: cmbRif,
	                    name: "cmbrif",
	                    style: { maxWidth: 60 },
	                    disabled: !habilitadoCli,
	                    className: "form-select form-select-sm col-md-3 text-center text-uppercase",
	                    "aria-label": ".form-select-sm example"
	                  },
	                  _varios.cmbCedula.map(function (item, index) {
	                    return _react2.default.createElement(
	                      "option",
	                      { key: index, value: item.value },
	                      " ",
	                      item.value,
	                      " "
	                    );
	                  })
	                ),
	                _react2.default.createElement("input", {
	                  ref: txtRif,
	                  autoComplete: "off",
	                  disabled: !habilitadoCli,
	                  style: { maxWidth: 100 },
	                  maxLength: 9,
	                  type: "text",
	                  className: "form-control col-md-6 fs-6",
	                  name: "cedula",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm",
	                  onKeyUp: validarCliente,
	                  onBlur: validarCliente
	                }),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: !habilitadoCli,
	                    type: "button",
	                    onClick: function onClick() {
	                      setTipoAgente("cliente");
	                      setCatalogoCliente(true);
	                    },
	                    className: "btn btn-success"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-search" })
	                ),
	                _react2.default.createElement("input", {
	                  type: "text",
	                  ref: txtNombreC,
	                  autoComplete: "off",
	                  disabled: true,
	                  name: "nombres",
	                  className: "form-control fs-6",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row col-12 m-0 p-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "mb-2 col-pd-180 px-2 ml-3" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "form-check" },
	                    _react2.default.createElement("input", { className: "form-check-input", ref: txtCredito, onChange: onCheke, type: "checkbox", value: "", id: "flexCheckDefault" }),
	                    _react2.default.createElement(
	                      "label",
	                      { className: "form-check-label fs-6", "for": "flexCheckDefault" },
	                      "\xBFES CREDITO?"
	                    )
	                  )
	                ),
	                visibl !== 0 ? _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-1 col-pd-320 px-1" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA VENCIMIENTO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    autoComplete: "off",
	                    type: "date",
	                    ref: txtFechaVence,
	                    className: "form-control fs-6 text-uppercase",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    name: "fecha",
	                    onKeyUp: handleInputChange,
	                    onBlur: handleInputChange
	                  })
	                ) : '',
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-1 col-pd-280 ml-auto px-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text fw-bold text-black",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO MONEDA:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-control form-control-sm px-1 fw-bold text-center",
	                      disabled: true,
	                      ref: cmbMoneda,
	                      onChange: onChangeMoneda
	                    },
	                    combomoneda && combomoneda.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: index },
	                        " ",
	                        item.descripcion + " " + item.simbolo + " " + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                        " "
	                      );
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row col-md-8 p-0 m-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-220 px-0 m-0" },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm"
	                  },
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: habilitadoProductos,
	                    ref: txtIdproducto,
	                    placeholder: "CODIGO",
	                    className: "form-control form-control-sm bg-light fs-6 col-pd-110",
	                    onChange: function onChange(e) {
	                      return e.target.value = e.target.value.toUpperCase();
	                    },
	                    onKeyUp: validarIdProducto(null)
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      type: "button",
	                      disabled: habilitadoProductos,
	                      onClick: function onClick() {
	                        return setMostrar(true);
	                      },
	                      className: "btn btn-sm btn-primary"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas " },
	                      "-"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-md-12 border-azul rounded px-0",
	                  style: { backgroundColor: "#d5e9ff" }
	                },
	                _react2.default.createElement(
	                  TblContainer,
	                  {
	                    container: {
	                      height: 300,
	                      width: "100%",
	                      overflow: "auto",
	                      padding: "2px",
	                      fontSizeAdjust: "0.6"
	                    }
	                  },
	                  _react2.default.createElement(TblHead, null),
	                  _react2.default.createElement(
	                    _core.TableBody,
	                    { className: "overflow-hidden" },
	                    records && records.map(function (item, index) {
	                      return _react2.default.createElement(
	                        _core.TableRow,
	                        { key: index, style: { padding: "0" } },
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          { className: "bg-light d-flex align-items-between px-0" },
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            style: {
	                              borderBottomRightRadius: 0,
	                              borderTopRightRadius: 0
	                            },
	                            disabled: habilitadoProductos,
	                            ref: function ref(el) {
	                              return txtId.current[index] = el;
	                            },
	                            className: "form-control form-control-sm bg-light fs-6",
	                            defaultValue: item.codigo,
	                            onChange: function onChange(e) {
	                              return e.target.value = e.target.value.toUpperCase();
	                            },
	                            onKeyUp: validarIdProducto(index),
	                            onBlur: validarIdProducto(index)
	                          }),
	                          (operacion === 1 || operacion === 2) && _react2.default.createElement(
	                            "button",
	                            {
	                              type: "button",
	                              style: {
	                                borderBottomLeftRadius: 0,
	                                borderTopLeftRadius: 0
	                              },
	                              disabled: habilitadoProductos,
	                              onClick: seleccionarxIndice(index),
	                              className: "btn btn-sm btn-primary"
	                            },
	                            _react2.default.createElement(
	                              "i",
	                              { className: "fas " },
	                              "-"
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-middle bg-light text-start p-0 pl-2",
	                            style: { width: "150px" }
	                          },
	                          item.nombrecorto
	                        ),
	                        operacion === 4 ? "" : _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-middle bg-light text-end p-0 pr-2",
	                            style: { width: "30px" }
	                          },
	                          (0, _varios.formatMoneda)(item.cantidadE.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          { className: "align-middle bg-light text-center p-0" },
	                          _react2.default.createElement("input", {
	                            type: "text",
	                            className: "form-control form-control-sm bg-light text-right fs-6 col-pd-90 mx-auto",
	                            id: "cantidad",
	                            disabled: operacion === 1 || operacion === 2 ? false : true,
	                            defaultValue: (0, _varios.formatMoneda)(item.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                            ref: function ref(el) {
	                              return txtCantidad.current[index] = el;
	                            },
	                            onFocus: _varios.seleccionarCampo,
	                            onKeyUp: validarCantidadP(index),
	                            onBlur: validarCantidadP(index)
	                          })
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-middle bg-light p-0",
	                            style: { width: 50 }
	                          },
	                          _react2.default.createElement(
	                            "select",
	                            {
	                              className: "form-control form-control-sm fs-6",
	                              style: { width: "100%" },
	                              disabled: true,
	                              defaultValue: item.tipoprecio,
	                              onChange: onChangeTipoPrecio(index)
	                            },
	                            _varios.comboprecios.map(function (item2, x) {
	                              return _react2.default.createElement(
	                                "option",
	                                { key: x, value: item2.id },
	                                " ",
	                                item2.nombre,
	                                " "
	                              );
	                            })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-middle bg-light text-end p-0 pr-2",
	                            style: { width: "50px" }
	                          },
	                          (0, _varios.formatMoneda)((item.precio * item.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-middle bg-light p-0",
	                            style: { width: 50 }
	                          },
	                          _react2.default.createElement(
	                            "select",
	                            {
	                              className: "form-control form-control-sm fs-6",
	                              style: { width: "100%" },
	                              disabled: habilitadoProductos,
	                              onChange: onChangeUnidad(index)
	                            },
	                            item.unidad && item.unidad.map(function (item2, x) {
	                              return _react2.default.createElement(
	                                "option",
	                                { key: x, value: item2.idunidad },
	                                " ",
	                                item2.descripcion,
	                                " "
	                              );
	                            })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-middle bg-light text-end p-0",
	                            style: { width: "50px" }
	                          },
	                          (0, _varios.formatMoneda)((item.precio * item.cantidad * item.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                        ),
	                        _react2.default.createElement(
	                          _core.TableCell,
	                          {
	                            className: "align-middle bg-light text-center p-0",
	                            style: { width: "20px" }
	                          },
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              disabled: operacion === 4 || operacion === 3 ? true : false,
	                              style: {
	                                visibility: (operacion === 4 || operacion === 3) && "collapse"
	                              },
	                              onClick: eliminarProducto(item),
	                              className: "btn btn-sm btn-danger"
	                            },
	                            _react2.default.createElement("i", { className: "fa fa-trash" }),
	                            " "
	                          )
	                        )
	                      );
	                    }),
	                    _react2.default.createElement(
	                      _core.TableRow,
	                      {
	                        style: {
	                          padding: "0",
	                          visibility: (operacion === 4 || operacion === 0 || operacion === 3) && "collapse"
	                        }
	                      },
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "align-middle bg-light text-center p-0 d-flex" },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          disabled: habilitadoProductos,
	                          style: {
	                            borderBottomRightRadius: 0,
	                            borderTopRightRadius: 0
	                          },
	                          className: "form-control form-control-sm bg-light text-right",
	                          onChange: function onChange(e) {
	                            return e.target.value = e.target.value.toUpperCase();
	                          },
	                          onKeyUp: validarIdProducto(null),
	                          onBlur: validarIdProducto(null)
	                        }),
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            type: "button",
	                            disabled: habilitadoProductos,
	                            style: {
	                              borderBottomLeftRadius: 0,
	                              borderTopLeftRadius: 0
	                            },
	                            onClick: seleccionarxIndice(null),
	                            className: "btn btn-sm btn-primary"
	                          },
	                          _react2.default.createElement(
	                            "i",
	                            { className: "fas " },
	                            "-"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(_core.TableCell, {
	                        className: "align-middle bg-light text-start p-0 pl-2",
	                        style: { width: "50px" }
	                      }),
	                      operacion === 4 ? "" : _react2.default.createElement(_core.TableCell, {
	                        className: "align-middle bg-light text-end p-0 pr-2",
	                        style: { width: "30px" }
	                      }),
	                      _react2.default.createElement(_core.TableCell, {
	                        className: "align-middle bg-light text-center p-0",
	                        style: { width: "20px" }
	                      }),
	                      _react2.default.createElement(_core.TableCell, {
	                        className: "align-middle bg-light p-0",
	                        style: { width: 50 }
	                      }),
	                      _react2.default.createElement(_core.TableCell, {
	                        className: "align-middle bg-light text-end p-0 pr-2",
	                        style: { width: "50px" }
	                      }),
	                      _react2.default.createElement(_core.TableCell, {
	                        className: "align-middle bg-light p-0",
	                        style: { width: 50 }
	                      }),
	                      _react2.default.createElement(_core.TableCell, {
	                        className: "align-middle bg-light text-end p-0",
	                        style: { width: "50px" }
	                      }),
	                      _react2.default.createElement(_core.TableCell, {
	                        className: "align-middle bg-light text-center p-0",
	                        style: { width: "20px" }
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "border-table rounded p-2 shadow col-pd-500",
	                    style: {
	                      backgroundColor: "#dbeeff",
	                      borderTop: "none",
	                      fontSizeAdjust: "0.6"
	                    }
	                  },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm  col-md-12" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text bg-transparent border-0",
	                        style: { fontSize: 14 },
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "SUBTOTAL: ",
	                      monedaCambio.simbolo
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      disabled: true,
	                      ref: txtSubTotal,
	                      value: (0, _varios.formatMoneda)((totales.subtotal * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                      className: "form-control bg-transparent fw-bold text-right rounded border-0 fs-5",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "input-group input-group-sm col-md-12",
	                      style: { fontSizeAdjust: "0.6" }
	                    },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text bg-transparent border-0",
	                        id: "inputGroup-sizing-sm",
	                        style: { fontSize: 14 }
	                      },
	                      "EXENTO ",
	                      monedaCambio.simbolo,
	                      ":"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      disabled: true,
	                      ref: txtExentoTotal,
	                      value: (0, _varios.formatMoneda)((totales.exento * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                      className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm  col-md-12" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text bg-transparent border-0",
	                        style: { fontSize: 14 },
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "DESCUENTO: ",
	                      monedaCambio.simbolo
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      disabled: true,
	                      ref: txtDescuento,
	                      value: (0, _varios.formatMoneda)((totales.descuento * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                      className: "form-control bg-transparent fw-bold text-right rounded border-0 fs-5",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm  col-md-12" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text bg-transparent border-0",
	                        style: { fontSize: 14 },
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "IVA Sobre(",
	                      (0, _varios.formatMoneda)(totales.iva.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                      "%) ",
	                      monedaCambio.simbolo,
	                      ":",
	                      " ",
	                      (0, _varios.formatMoneda)((totales.sujeto * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      disabled: true,
	                      ref: txtTotIva,
	                      value: (0, _varios.formatMoneda)((totales.totaliva * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                      className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm  col-md-12" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text bg-transparent border-0",
	                        style: { fontSize: 14 },
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "TOTAL: ",
	                      monedaCambio.simbolo
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      disabled: true,
	                      ref: txtTotal,
	                      value: (0, _varios.formatMoneda)((totales.total * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                      className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm  col-md-12" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text bg-transparent border-0",
	                        style: { fontSize: 14 },
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "TOTAL BS:"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      disabled: true,
	                      ref: txtTotalBs,
	                      value: (0, _varios.formatMoneda)((totales.total * monedaSub.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                      className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4 mx-auto ocultaproductos" },
	              _react2.default.createElement(
	                "div",
	                { className: "row card col-md-12 mx-auto p-1 m-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 row mx-auto" },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-md-12 row mx-auto azulGradiant rounded py-2",
	                      style: { verticalAlign: "middle" }
	                    },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "input-group input-group-sm mb-2 col-md-4 my-auto" },
	                      _react2.default.createElement("input", {
	                        autoComplete: "off",
	                        onChange: handleSearch,
	                        type: "text",
	                        placeholder: "BUSCAR",
	                        className: "form-control rounded-pill",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm"
	                      })
	                    ),
	                    _react2.default.createElement(
	                      "h4",
	                      { className: "col-md-6 text-center mx-auto text-light fw-bold" },
	                      "LISTA DE PRODUCTOS"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "row col-md-12 mx-auto overflow-scroll rounded px-0 py-1",
	                      style: {
	                        height: "500px",
	                        backgroundColor: "rgb(230, 238, 249)"
	                      }
	                    },
	                    listaProductos && listaProductos.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "button",
	                        {
	                          key: index,
	                          onClick: function onClick() {
	                            return agregarProducto(item);
	                          },
	                          disabled: habilitadoProductos,
	                          className: "btn zoom hover-overlay col-md-2 bg-gradient p-0 m-0",
	                          style: { minHeight: "60px", maxHeight: "60px" }
	                        },
	                        _react2.default.createElement("img", {
	                          className: "img-fluid h-100 w-100 ",
	                          style: { objectFit: "contain" },
	                          src: op.conexion + "/imagen?img=" + organizacion + "/productos/" + item.imagen
	                        }),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "mask rounded p-2" },
	                          _react2.default.createElement(
	                            "div",
	                            {
	                              className: "col-md-12 fixed-bottom py-1 border-top  bg-light",
	                              style: { verticalAlign: "middle" }
	                            },
	                            _react2.default.createElement(
	                              "span",
	                              {
	                                className: "text-center",
	                                style: {
	                                  fontSize: "6px",
	                                  color: "rgb(3, 18, 47)"
	                                }
	                              },
	                              item.nombrecorto.substring(0, 20)
	                            )
	                          )
	                        )
	                      );
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row col-md-12 mx-auto d-flex justify-content-between  align-items-end mt-3" },
	              _react2.default.createElement(
	                "div",
	                { className: "form-check form-switch my-auto" },
	                _react2.default.createElement("input", {
	                  className: "form-check-input my-auto",
	                  type: "checkbox",
	                  role: "switch",
	                  id: "switchCheckDefault",
	                  checked: bluetoothStatus.checked,
	                  onChange: handleBluetoothChange
	                }),
	                _react2.default.createElement(
	                  "label",
	                  { className: "fw-bold form-check-label ml-3 my-auto " + (bluetoothStatus.checked ? 'text-success' : 'text-danger'), htmlFor: "switchCheckDefault" },
	                  bluetoothStatus.checked ? 'Bluetooth Activo' : 'Bluetooth Inactivo'
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-650 row m-0 ml-auto" },
	                operacion === 4 && actimprime === 1 ? _react2.default.createElement(
	                  "button",
	                  {
	                    onClick: imprimirPedido,
	                    disabled: operacion === 4 ? false : true,
	                    className: "btn btn-sm col ml-1 btn-primary rounded-pill",
	                    title: "Imprimir Nota de Entrega"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fa fa-print" },
	                    " Imprimir"
	                  )
	                ) : _react2.default.createElement("dvi", { className: "col-pd-110" }),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    disabled: habilitadoBot,
	                    ref: btnEditar,
	                    onClick: onBotones(3),
	                    className: "btn btn-sm ml-1 col btn-warning rounded-pill",
	                    title: "Reversar Pago"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-undo" },
	                    " Reversar Pago"
	                  ),
	                  " "
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta,
	                    disabled: operacion === 4 ? true : habilitadoBot,
	                    onClick: onBotones(5),
	                    className: "btn btn-sm col ml-1 rounded-pill btn-success"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-check-circle" },
	                    " Aceptar"
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnCancela,
	                    disabled: habilitadoBot,
	                    onClick: onBotones(6),
	                    className: "btn btn-danger col ml-1 btn-sm rounded-pill"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-window-close" },
	                    " Cancelar"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(BluetoothPrintButtons, null)
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoProductoExistencia2.default, {
	      show: mostrar,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar(false);
	      },
	      onHideAceptaCatalogo: agregarProducto,
	      idalmacen: vendedor.idalmacen
	    }),
	    _react2.default.createElement(_modalSupervisor.ModalSupervisor, {
	      show: mostratsup,
	      ope: 3,
	      onHideCancelar: function onHideCancelar() {
	        return setMostrarsup(false);
	      }
	    }),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: catalogoCliente,
	      nomid: tipoAgente,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoCliente(false);
	      },
	      onHideAceptaCatalogo: onCatalogoCliente
	    }),
	    _react2.default.createElement(_catalogoPedido2.default, {
	      show: catalogoPedido,
	      nomid: "pedido",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoPedido(false);
	      },
	      onHideAceptaCatalogo: oncatalogoPedidoEntrega,
	      condicion: "true and status = 0"
	    }),
	    _react2.default.createElement(_modalRegistrarPago.RegistrarPago, {
	      show: mostrar1,
	      onRenderizar: blanquear,
	      ope: numnotaentregae > 0 ? 2 : 1,
	      notentraga: notaen,
	      notaentregadeta: notaedeta,
	      opinvc: opeinvc,
	      opeinvdetc: opeinvdetc,
	      idvendedor: vendedor.idvendedor,
	      idclient: cliente.idcliente,
	      numfactu: numnotaentrega,
	      tipo: "notaentrega",
	      montoiva: totales.totaliva,
	      monto: totales.total,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar1(false);
	      },
	      ticketBluetooth: imprimirDesdeFacturar
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return mensaje.titulo === "Exito." ? blanquear() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = TablaPosVenta;

/***/ },
/* 7181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _core = __webpack_require__(19);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoProductoExistencia = __webpack_require__(105);
	
	var _catalogoProductoExistencia2 = _interopRequireDefault(_catalogoProductoExistencia);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _useTableScroll2 = __webpack_require__(29);
	
	var _useTableScroll3 = _interopRequireDefault(_useTableScroll2);
	
	var _catalogoPresupuesto = __webpack_require__(7035);
	
	var _catalogoPresupuesto2 = _interopRequireDefault(_catalogoPresupuesto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var TablaPresupuesto = function TablaPresupuesto() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
	  var afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
	  var accbtnpresupuesto = JSON.parse(sessionStorage.getItem("accbtnpresupuestoc"));
	
	  var txtCodigoPresupuesto = (0, _react.useRef)();
	  var txtStatus = (0, _react.useRef)();
	  var txtFecha = (0, _react.useRef)();
	  var txtId = (0, _react.useRef)([]);
	  var txtIdproducto = (0, _react.useRef)([]);
	  var txtCantidad = (0, _react.useRef)([]);
	  var btnIncluir = (0, _react.useRef)();
	  var btnEditar = (0, _react.useRef)();
	  var btnEliminar = (0, _react.useRef)();
	  var btnConsultar = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtNombreC = (0, _react.useRef)();
	  var txtSubTotal = (0, _react.useRef)();
	  var txtExentoTotal = (0, _react.useRef)();
	  var txtDescuento = (0, _react.useRef)();
	  var txtTotIva = (0, _react.useRef)();
	  var txtTotal = (0, _react.useRef)();
	  var cmbMoneda = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      body = _useState2[0],
	      setBody = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      operacion = _useState4[0],
	      setOperacion = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      habilitado = _useState6[0],
	      setHabilitado = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(true),
	      _useState8 = _slicedToArray(_useState7, 2),
	      habilitarCat = _useState8[0],
	      setHabilitarCat = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(true),
	      _useState10 = _slicedToArray(_useState9, 2),
	      habilitadoBot = _useState10[0],
	      setHabilitadoBot = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      habilitadoCli = _useState12[0],
	      setHabilitadoCli = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(true),
	      _useState14 = _slicedToArray(_useState13, 2),
	      habilitadoProductos = _useState14[0],
	      setHabilitadoProductos = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      habilitadoMod = _useState16[0],
	      setHabilitadoMod = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(null),
	      _useState18 = _slicedToArray(_useState17, 2),
	      indice = _useState18[0],
	      setIndice = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      visible = _useState20[0],
	      setVisible = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(false),
	      _useState22 = _slicedToArray(_useState21, 2),
	      mostrar = _useState22[0],
	      setMostrar = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(false),
	      _useState24 = _slicedToArray(_useState23, 2),
	      habilitarMoneda = _useState24[0],
	      setHabilitarMoneda = _useState24[1];
	
	  var _useState25 = (0, _react.useState)([]),
	      _useState26 = _slicedToArray(_useState25, 2),
	      records = _useState26[0],
	      setRecords = _useState26[1];
	
	  var _useState27 = (0, _react.useState)([]),
	      _useState28 = _slicedToArray(_useState27, 2),
	      combomoneda = _useState28[0],
	      setComboMoneda = _useState28[1];
	
	  var _useState29 = (0, _react.useState)("Gestionar Presupuesto."),
	      _useState30 = _slicedToArray(_useState29, 2),
	      tituloHeader = _useState30[0],
	      setTituloHeader = _useState30[1];
	
	  var _useState31 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState32 = _slicedToArray(_useState31, 2),
	      mensaje = _useState32[0],
	      setMensaje = _useState32[1];
	
	  var _useState33 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState34 = _slicedToArray(_useState33, 2),
	      mensajesino = _useState34[0],
	      setMensajesino = _useState34[1];
	
	  var _useState35 = (0, _react.useState)({
	    idmoneda: "1",
	    descripcion: "BOLIVARES",
	    simbolo: "Bs",
	    predeterminada: true,
	    subpredeterminada: false,
	    valormoneda: 1.0
	  }),
	      _useState36 = _slicedToArray(_useState35, 2),
	      moneda = _useState36[0],
	      setMoneda = _useState36[1];
	
	  var _useState37 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState38 = _slicedToArray(_useState37, 2),
	      monedaSub = _useState38[0],
	      setMonedaSub = _useState38[1];
	
	  var _useState39 = (0, _react.useState)({
	    idmoneda: "4",
	    descripcion: "DOLAR",
	    simbolo: "$",
	    predeterminada: false,
	    subpredeterminada: true,
	    valormoneda: 1.0
	  }),
	      _useState40 = _slicedToArray(_useState39, 2),
	      monedaCambio = _useState40[0],
	      setMonedaCambio = _useState40[1];
	
	  var _useState41 = (0, _react.useState)({
	    subtotal: 0.0,
	    descuento: 0.0,
	    exento: 0.0,
	    sujeto: 0.0,
	    iva: 16.0,
	    totaliva: 0.0,
	    total: 0.0
	  }),
	      _useState42 = _slicedToArray(_useState41, 2),
	      totales = _useState42[0],
	      setTotales = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(false),
	      _useState44 = _slicedToArray(_useState43, 2),
	      catalogoCliente = _useState44[0],
	      setCatalogoCliente = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(false),
	      _useState46 = _slicedToArray(_useState45, 2),
	      catalogoPresu = _useState46[0],
	      setCatalogoPresu = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(false),
	      _useState48 = _slicedToArray(_useState47, 2),
	      activate = _useState48[0],
	      setActivate = _useState48[1];
	
	  var _useState49 = (0, _react.useState)("visible"),
	      _useState50 = _slicedToArray(_useState49, 2),
	      visibleBtn = _useState50[0],
	      setVisibleBtn = _useState50[1];
	
	  var _useState51 = (0, _react.useState)({
	    idpresupuesto: "0",
	    codigo: "000000",
	    cedularif: "",
	    montototal: 0.0,
	    totaliva: 0.0,
	    totaldescuento: 0.0,
	    totalexento: 0.0,
	    totalsujeto: 0.0,
	    idcliente: "",
	    idvendedor: "",
	    fecha: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	    status: 0,
	    idalmacen: "",
	    idmoneda: "",
	    valormoneda: 0.0
	  }),
	      _useState52 = _slicedToArray(_useState51, 2),
	      presupuesto = _useState52[0],
	      setPresupuesto = _useState52[1];
	
	  var _useState53 = (0, _react.useState)({
	    idcliente: "",
	    tiporif: "J",
	    rif: "",
	    nombre: ""
	  }),
	      _useState54 = _slicedToArray(_useState53, 2),
	      cliente = _useState54[0],
	      setCliente = _useState54[1];
	
	  var _useState55 = (0, _react.useState)({
	    idvendedor: "",
	    tiporif: "",
	    rif: "",
	    nombre: "",
	    idalmacen: ""
	  }),
	      _useState56 = _slicedToArray(_useState55, 2),
	      vendedor = _useState56[0],
	      setVendedor = _useState56[1];
	
	  var nomtabla = void 0;
	
	  if (operacion === 4) {
	    nomtabla = [{ label: "COD-PRODUCTO", textAlign: "center", width: "30px" }, { label: "PRODUCTO", textAlign: "center", width: "50px" }, { label: "CANTIDAD", textAlign: "center", width: "20px" }, { label: "TIPO PRECIO", textAlign: "center", width: "50px" }, { label: "PRECIO UNI.", textAlign: "center", width: "50px" }, { label: "IVA", textAlign: "center", width: "50px" }, { label: "UND. ALT.", textAlign: "center", width: "50px" }, { label: "MONTO IVA", textAlign: "center", width: "50px" }, { label: "MONTO TOTAL", textAlign: "center", width: "50px" }];
	  } else {
	    nomtabla = [{ label: "COD-PRODUCTO", textAlign: "center", width: "30px" }, { label: "PRODUCTO", textAlign: "center", width: "50px" }, { label: "EXISTENCIA", textAlign: "center", width: "30px" }, { label: "CANTIDAD", textAlign: "center", width: "20px" }, { label: "TIPO PRECIO", textAlign: "center", width: "50px" }, { label: "PRECIO UNI.", textAlign: "center", width: "50px" }, { label: "IVA", textAlign: "center", width: "50px" }, { label: "UND. ALT.", textAlign: "center", width: "50px" }, { label: "MONTO IVA", textAlign: "center", width: "50px" }, { label: "MONTO TOTAL", textAlign: "center", width: "50px" }, {
	      label: _react2.default.createElement("i", { className: "fas fa-trash" }),
	      textAlign: "center",
	      width: "20px"
	    }];
	  }
	
	  var headCells = nomtabla;
	
	  var _useTableScroll = (0, _useTableScroll3.default)(headCells),
	      TblContainer = _useTableScroll.TblContainer,
	      TblHead = _useTableScroll.TblHead;
	
	  var seleccionarMonedas = function seleccionarMonedas() {
	    var campos = "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
	    var nomtab = "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
	    var orden = "m.idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var x = 0;
	        if (response.data.length > 0) {
	          setComboMoneda(response.data);
	          for (var i = 0; i < response.data.length; i++) {
	            if (response.data[i].subpredeterminada) {
	              setMonedaSub(response.data[i]);
	              setMonedaCambio({
	                idmoneda: response.data[i].idmoneda,
	                descripcion: response.data[i].descripcion,
	                simbolo: response.data[i].simbolo,
	                predeterminada: response.data[i].predeterminada,
	                subpredeterminada: response.data[i].subpredeterminada,
	                valormoneda: 1.0
	              });
	              x = i;
	            } else if (response.data[i].predeterminada) {
	              setMoneda(response.data[i]);
	            }
	          }
	        }
	        setTimeout(function () {
	          return cmbMoneda.current.selectedIndex = x;
	        }, 200);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarVendedor = function seleccionarVendedor(id) {
	    var campos = "v.idagente, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen";
	    var nomtab = "agente as v";
	    var nomid = "v.idagente";
	    var nomid2 = "v.vendedor";
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          setVendedor({
	            idvendedor: response.data.idagente,
	            tiporif: response.data.tiporifv,
	            rif: response.data.rifv,
	            nombre: response.data.nombrev,
	            idalmacen: response.data.idalmacen
	          });
	
	          btnAcepta.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un vendedor con este codigo",
	            icono: "informacion"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarCliente = function seleccionarCliente(rif, tecla) {
	    var campos = "c.idagente, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
	    var nomtab = "agente as c";
	    var nomid = "c.rif";
	    var nomid2 = "c.cliente";
	    var id = rif;
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          txtNombreC.current.value = response.data.nombrec;
	          setCliente({
	            idcliente: response.data.idagente,
	            tiporif: response.data.tiporifc,
	            rif: response.data.rifc,
	            nombre: response.data.nombrec
	          });
	          if (tecla === 13) {
	            txtFecha.current.focus();
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un cliente con este codigo",
	            icono: "informacion"
	          });
	          txtRif.current.value = "";
	          cmbRif.current.selectedIndex = -1;
	          txtNombreC.current.value = "";
	          if (tecla === 13) {
	            txtRif.current.focus();
	          }
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarProducto = function seleccionarProducto(index, idubi, idprod) {
	    var endpoint = op.conexion + "/api/pedido/seleccionarproductoinv?idproducto=" + idprod + "&idalmacen=" + idubi;
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var data = [].concat(_toConsumableArray(records));
	        if (response.data !== "") {
	          if (response.data.servicio) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificacion",
	              texto: "no existe un producto con ese codigo en el almacen.",
	              icono: "error"
	            });
	            txtCantidad.current[records.length - 1].value = "1,00";
	          } else {
	            for (var i = 0; i < records.length; i++) {
	              if (records[i].idproducto === response.data.idproducto) {
	                setActivate(false);
	                setMensaje({
	                  mostrar: true,
	                  titulo: "Notificacion",
	                  texto: "el producto ya ha sido seleccionado.",
	                  icono: "error"
	                });
	                return;
	              }
	            }
	
	            var uni = [];
	            var precio = 0.0;
	            var montoiva = 0.0;
	            var cantie = response.data.cantidad;
	            var tipouni = 0;
	            var tiene_iva = false;
	            var tipoprecio = parseInt(response.data.tipoprecio);
	
	            if (parseFloat(response.data.ivaventa) > 0.0) {
	              tiene_iva = true;
	            }
	
	            if (parseInt(response.data.tipofactor) === 0 || response.data.tipofactor === null) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data.idunidadmedida,
	                descripcion: response.data.descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data.cantidad);
	              cantie = Math.trunc(cantie);
	
	              if (tipoprecio === 1) {
	                precio = parseFloat(response.data.preciomaxi);
	              } else if (tipoprecio === 2) {
	                precio = parseFloat(response.data.precioofe);
	              } else if (tipoprecio === 3) {
	                precio = parseFloat(response.data.preciomayor);
	              } else if (tipoprecio === 4) {
	                precio = parseFloat(response.data.preciomini);
	              }
	            } else {
	              if (response.data.idunidadventa === response.data.idunidadalterna) {
	                tipouni = 1;
	                uni = [{
	                  idunidad: response.data.idunidadalterna,
	                  descripcion: response.data.descripcionunialt,
	                  tipo: "alterna"
	                }, {
	                  idunidad: response.data.idunidadmedida,
	                  descripcion: response.data.descripcionuni,
	                  tipo: "medida"
	                }];
	
	                cantie = parseFloat(response.data.cantidad);
	                cantie = Math.trunc(cantie);
	                if (tipoprecio === 1) {
	                  precio = parseFloat(response.data.preciomaxialter);
	                } else if (tipoprecio === 2) {
	                  precio = parseFloat(response.data.precioofealter);
	                } else if (tipoprecio === 3) {
	                  precio = parseFloat(response.data.preciomayoralter);
	                } else if (tipoprecio === 4) {
	                  precio = parseFloat(response.data.preciominialter);
	                }
	              } else if (response.data.idunidadventa === response.data.idunidadmedida) {
	                tipouni = 0;
	                uni = [{
	                  idunidad: response.data.idunidadmedida,
	                  descripcion: response.data.descripcionuni,
	                  tipo: "medida"
	                }, {
	                  idunidad: response.data.idunidadalterna,
	                  descripcion: response.data.descripcionunialt,
	                  tipo: "alterna"
	                }];
	
	                cantie = parseFloat(response.data.cantidad / response.data.valorfactor);
	                cantie = Math.trunc(cantie);
	
	                if (tipoprecio === 1) {
	                  precio = parseFloat(response.data.preciomaxi);
	                } else if (tipoprecio === 2) {
	                  precio = parseFloat(response.data.precioofe);
	                } else if (tipoprecio === 3) {
	                  precio = parseFloat(response.data.preciomayor);
	                } else if (tipoprecio === 4) {
	                  precio = parseFloat(response.data.preciomini);
	                }
	              }
	            }
	
	            montoiva = precio * response.data.ivaventa / 100;
	
	            if (index !== null) {
	              data[index] = {
	                idproducto: response.data.idproducto,
	                codigo: response.data.codigo,
	                cantidad: 1.0,
	                cantidadE: cantie,
	                cantidadEA: parseFloat(response.data.cantidad),
	                nombrecorto: response.data.nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	                precio: precio,
	                preciobs: 0.0,
	                preciomaxi: response.data.preciomaxi,
	                precioofe: response.data.precioofe,
	                preciomayor: response.data.preciomayor,
	                preciomini: response.data.preciomini,
	                preciomaxialter: response.data.preciomaxialter,
	                precioofealter: response.data.precioofealter,
	                preciomayoralter: response.data.preciomayoralter,
	                preciominialter: response.data.preciominialter,
	                iva: response.data.ivaventa,
	                montoiva: (0, _varios.round)(montoiva, 2),
	                descuento: 0.0,
	                total: precio,
	                unidad: uni,
	                idunidadmedida: response.data.idunidadmedida,
	                idunidadalterna: response.data.idunidadalterna,
	                idmoneda: response.data.idmoneda,
	                valormoneda: monedaCambio.valormoneda,
	                tipounidad: tipouni,
	                tipofactor: response.data.tipofactor,
	                valorfactor: response.data.valorfactor,
	                tipoprecio: response.data.tipoprecio
	              };
	            } else {
	              data.push({
	                idproducto: response.data.idproducto,
	                codigo: response.data.codigo,
	                cantidad: 1.0,
	                cantidadE: cantie,
	                cantidadEA: parseFloat(response.data.cantidad),
	                nombrecorto: response.data.nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	                precio: precio,
	                preciomaxi: response.data.preciomaxi,
	                precioofe: response.data.precioofe,
	                preciomayor: response.data.preciomayor,
	                preciomini: response.data.preciomini,
	                preciomaxialter: response.data.preciomaxialter,
	                precioofealter: response.data.precioofealter,
	                preciomayoralter: response.data.preciomayoralter,
	                preciominialter: response.data.preciominialter,
	                preciobs: 0.0,
	                iva: response.data.ivaventa,
	                montoiva: (0, _varios.round)(montoiva, 2),
	                descuento: 0.0,
	                total: precio,
	                unidad: uni,
	                idunidadmedida: response.data.idunidadmedida,
	                idunidadalterna: response.data.idunidadalterna,
	                idmoneda: response.data.idmoneda,
	                valormoneda: monedaCambio.valormoneda,
	                tipounidad: tipouni,
	                tipofactor: response.data.tipofactor,
	                valorfactor: response.data.valorfactor,
	                tipoprecio: response.data.tipoprecio
	              });
	            }
	
	            setRecords(data);
	            setTotales((0, _varios.calcularTotales)(data));
	            setIndice(index);
	
	            if (index !== null) {
	              setTimeout(function () {
	                return txtCantidad.current[index].focus();
	              }, 300);
	            } else {
	              setTimeout(function () {
	                return txtCantidad.current[data.length - 1].focus();
	              }, 300);
	            }
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificacion",
	            texto: "no existe un producto con ese codigo en el almacen.",
	            icono: "error"
	          });
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarpresupuesto = function seleccionarpresupuesto() {
	    var campos = "p.*, m.*, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
	    var nomtab = "presupuesto as p inner join agente as v on p.idvendedor=v.idagente inner join agente as c on c.idagente=p.idcliente inner join moneda as m on p.idmoneda=m.idmoneda";
	
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=codigo&id=" + txtCodigoPresupuesto.current.value.trim();
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data !== "") {
	          if (response.data.status === 1 && (operacion === 2 || operacion === 3)) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "El Presupuesto ya tiene factura asociada.",
	              icono: "informacion"
	            });
	            setActivate(false);
	            txtCodigoPresupuesto.current.value = "";
	            txtCodigoPresupuesto.current.focus();
	            return;
	          }
	          txtFecha.current.value = (0, _moment2.default)(response.data.fecha).format("YYYY-MM-DD");
	          txtStatus.current.value = response.data.status;
	          txtCodigoPresupuesto.current.setAttribute("disabled", true);
	          cmbRif.current.value = response.data.tiporifc;
	          txtRif.current.value = response.data.rifc;
	          txtNombreC.current.value = response.data.nombrec;
	
	          for (var i = 0; i < combomoneda.length; i++) {
	            if (response.data.idmoneda === combomoneda[i].idmoneda) {
	              cmbMoneda.current.selectedIndex = i;
	              break;
	            }
	          }
	
	          setHabilitarCat(true);
	          setPresupuesto({
	            idpresupuesto: response.data.idpresupuesto,
	            codigo: response.data.codigo,
	            cedularif: response.data.cedularif,
	            montototal: response.data.montototal,
	            totaliva: response.data.totaliva,
	            totaldescuento: response.data.totaldescuento,
	            totalexento: response.data.totalexento,
	            totalsujeto: response.data.totalsujeto,
	            idcliente: response.data.idcliente,
	            idvendedor: response.data.idvendedor,
	            fecha: (0, _moment2.default)(response.data.fecha).format("YYYY-MM-DD"),
	            status: response.data.status,
	            idalmacen: response.data.idalmacen,
	            idmoneda: response.data.idmoneda,
	            valormoneda: response.data.valormoneda
	          });
	
	          setMoneda({
	            idmoneda: response.data.idmoneda,
	            descripcion: response.data.descripcion,
	            simbolo: response.data.simbolo,
	            valormoneda: response.data.valormoneda,
	            predeterminada: response.data.predeterminada,
	            subpredeterminada: response.data.subpredeterminada
	          });
	
	          setCliente({
	            idcliente: response.data.idcliente,
	            tiporif: response.data.tiporifc,
	            rif: response.data.rifc,
	            nombre: response.data.nombrec
	          });
	
	          setVendedor({
	            idvendedor: response.data.idvendedor,
	            tiporif: response.data.tiporifv,
	            rif: response.data.rifv,
	            nombre: response.data.nombrev,
	            idalmacen: response.data.idalmacen
	          });
	
	          seleccionarDetallepresupuesto(response.data.idpresupuesto);
	          if (operacion === 2) {
	            setHabilitado(true);
	            setHabilitadoProductos(false);
	            setTimeout(function () {
	              return txtFecha.current.focus();
	            }, 200);
	          } else {
	            setHabilitado(false);
	            setTimeout(function () {
	              return btnCancela.current.focus();
	            }, 200);
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "no existe una Presupuesto con ese codigo.",
	            icono: "informacion"
	          });
	          txtCodigoPresupuesto.current.value = "";
	          txtCodigoPresupuesto.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarDetallepresupuesto = function seleccionarDetallepresupuesto(idpresupuesto) {
	    var nomtab1 = "presupuesto_detalle";
	    var nomtab2 = "presupuesto";
	    var nomid = "idpresupuesto";
	    var endpoint = op.conexion + "/api/presupuestos/seleccionarpresupuesto?idpresupuesto=" + idpresupuesto + "&nomtab1=" + nomtab1 + "&nomtab2=" + nomtab2 + "&nomid=" + nomid;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          var prod = [];
	          var uni = [];
	          var montoiva = 0.0;
	          var cantie = 0.0;
	          var cantiea = 0.0;
	          var tipouni = 0;
	          var tiene_iva = false;
	
	          for (var i = 0; i < response.data.length; i++) {
	            if (parseFloat(response.data[i].iva) > 0.0) {
	              tiene_iva = true;
	            }
	            if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) <= 0.0) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantiea = Math.trunc(cantiea);
	            } else if (response.data[i].tipounidad === 0 && parseFloat(response.data[i].valorfactor) > 0.0) {
	              tipouni = 0;
	              uni = [{
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }, {
	                idunidad: response.data[i].idunidadalterna,
	                descripcion: response.data[i].descripcionunialt,
	                tipo: "alterna"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) / parseFloat(response.data[i].valorfactor) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) / parseFloat(response.data[i].valorfactor) + parseFloat(response.data[i].cantidad);
	
	              cantiea = cantiea * parseFloat(response.data[i].valorfactor);
	              cantiea = Math.trunc(cantiea);
	            } else if (response.data[i].tipounidad === 1) {
	              tipouni = 1;
	              uni = [{
	                idunidad: response.data[i].idunidadalterna,
	                descripcion: response.data[i].descripcionunialt,
	                tipo: "alterna"
	              }, {
	                idunidad: response.data[i].idunidadmedida,
	                descripcion: response.data[i].descripcionuni,
	                tipo: "medida"
	              }];
	
	              cantie = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantie = Math.trunc(cantie);
	
	              cantiea = parseFloat(response.data[i].cantidade) + parseFloat(response.data[i].cantidad);
	              cantiea = Math.trunc(cantiea);
	            }
	
	            var miva = response.data[i].punitario * response.data[i].iva / 100;
	
	            prod.push({
	              idproducto: response.data[i].idproducto,
	              codigo: response.data[i].codigo,
	              cantidad: response.data[i].cantidad,
	              cantidadE: parseFloat(cantie),
	              cantidadEA: parseFloat(cantiea),
	              nombrecorto: response.data[i].nombrecorto + " " + (tiene_iva ? "" : " (E)"),
	              precio: response.data[i].punitario,
	              preciobs: response.data[i].punitariobs,
	              preciomaxi: response.data[i].preciomaxi,
	              precioofe: response.data[i].precioofe,
	              preciomayor: response.data[i].preciomayor,
	              preciomini: response.data[i].preciomini,
	              preciomaxialter: response.data[i].preciomaxialter,
	              precioofealter: response.data[i].precioofealter,
	              preciomayoralter: response.data[i].preciomayoralter,
	              preciominialter: response.data[i].preciominialter,
	              iva: response.data[i].iva,
	              ivaventa: response.data[i].ivaventa,
	              montoiva: (0, _varios.round)(parseFloat(miva) * parseFloat(response.data[i].cantidad), 2),
	              descuento: response.data[i].descuento,
	              total: response.data[i].cantidad * response.data[i].punitario,
	              unidad: uni,
	              idunidadmedida: response.data[i].idunidadmedida,
	              idunidadalterna: response.data[i].idunidadalterna,
	              costocalculado: response.data[i].costocalculado,
	              costocalculadoalter: response.data[i].costocalculadoalter,
	              utipreciomaxi: response.data[i].utipreciomaxi,
	              utipreciomaxialter: response.data[i].utipreciomaxialter,
	              tipounidad: tipouni,
	              valormoneda: monedaCambio.valormoneda,
	              idmoneda: response.data[i].idmoneda,
	              tipofactor: response.data[i].tipofactor,
	              valorfactor: response.data[i].valorfactor,
	              tipoprecio: response.data[i].tipopreciodeta
	            });
	          }
	          setTotales((0, _varios.calcularTotales)(prod));
	          setRecords(prod);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var endpoint = op.conexion + "/api/presupuestos/actualizarpresupuesto/" + operacion;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (operacion === 1) {
	          window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=Presupuesto&idnota=" + response.data.idpe, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idpe + " creado correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idpe + " modificado correctamente",
	            icono: "exito"
	          });
	        } else if (operacion === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro " + response.data.idpe + " eliminado correctamente",
	            icono: "exito"
	          });
	        }
	      }
	    }).catch(function (error) {
	      var mensaje = error.response.data.message;
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	    }).finally(function () {
	      return setActivate(false);
	    });
	  };
	
	  var validarCliente = function validarCliente(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (cmbRif.current.value !== "" && event.target.value !== "") {
	        var rif = cmbRif.current.value + event.target.value;
	        seleccionarCliente(rif, event.which);
	      }
	    }
	  };
	
	  var validarCantidadP = function validarCantidadP(index) {
	    return function (event) {
	      (0, _varios.validaMonto)(event);
	      if (event.which === 13 || typeof event.which === "undefined") {
	        var cantidades = (0, _varios.validarCantidadForPedido)({
	          index: index,
	          event: event,
	          productos: records
	        });
	        if (event.which === 13) {
	          if (index < cantidades.data.length - 1) {
	            setTimeout(function () {
	              return txtCantidad.current[index + 1].focus();
	            }, 300);
	          }
	        }
	        setMensaje(cantidades.msm);
	        setRecords(cantidades.data);
	        setTotales(cantidades.totales);
	      }
	    };
	  };
	
	  var validarIdProducto = function validarIdProducto(index) {
	    return function (event) {
	      if (event.which === 13 || typeof event.which === "undefined") {
	        if (event.target.value !== "") {
	          if (vendedor.idalmacen !== "" && vendedor.idalmacen !== null) {
	            seleccionarProducto(index, vendedor.idalmacen, event.target.value);
	          } else {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación.",
	              texto: "debe seleccionar un vendedor.",
	              icono: "informacion"
	            });
	          }
	        }
	      }
	    };
	  };
	
	  var onCatalogoCliente = function onCatalogoCliente(values) {
	    setCatalogoCliente(false);
	    txtNombreC.current.value = values.nombre;
	    cmbRif.current.value = values.rif.substring(0, 1);
	    txtRif.current.value = values.rif.substring(1);
	    setCliente({
	      idcliente: values.idagente,
	      tiporif: values.rif.substring(0, 1),
	      rif: values.rif.substring(1),
	      nombre: values.nombre
	    });
	  };
	
	  var onCatalogopresupuesto = function onCatalogopresupuesto(values) {
	    setCatalogoPresu(false);
	    txtCodigoPresupuesto.current.value = values.codigo;
	    seleccionarpresupuesto();
	  };
	
	  var agregarProducto = function agregarProducto(producto) {
	    seleccionarProducto(indice, vendedor.idalmacen, producto.codigo);
	    setMostrar(false);
	  };
	
	  var seleccionarxIndice = function seleccionarxIndice(index) {
	    return function (e) {
	      e.preventDefault();
	      if (vendedor.idalmacen !== "" && vendedor.idalmacen !== null) {
	        setMostrar(true);
	        setIndice(index);
	      } else {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación.",
	          texto: "debe seleccionar un vendedor.",
	          icono: "informacion"
	        });
	      }
	    };
	  };
	
	  var eliminarProducto = function eliminarProducto(producto) {
	    return function (e) {
	      e.preventDefault();
	      var data = [].concat(_toConsumableArray(records));
	      var elementos = [];
	
	      for (var i = 0; i < data.length; i++) {
	        if (producto.idproducto !== data[i].idproducto) {
	          elementos.push(data[i]);
	        }
	      }
	      setRecords(elementos);
	      setTotales((0, _varios.calcularTotales)(elementos));
	    };
	  };
	
	  var onChangeMoneda = function onChangeMoneda(e) {
	    var i = e.target.value;
	    var cambio = (0, _varios.onCambioMoneda)({
	      moneda: combomoneda[i],
	      productos: records,
	      monedaPre: moneda,
	      monedaSub: monedaSub
	    });
	    setMonedaCambio(cambio.monedacambio);
	    setRecords(cambio.data);
	  };
	
	  var onChangeUnidad = function onChangeUnidad(i) {
	    return function (e) {
	      var cambiounidad = (0, _varios.onCambioUnidad)({
	        idunidad: e.target.value,
	        index: i,
	        productos: records
	      });
	      setMensaje(cambiounidad.msm);
	      setRecords(cambiounidad.data);
	      setTotales(cambiounidad.totales);
	    };
	  };
	
	  var onChangeTipoPrecio = function onChangeTipoPrecio(i) {
	    return function (e) {
	      var data = [].concat(_toConsumableArray(records));
	      var tipoprecio = parseInt(e.target.value);
	      var tipounidad = data[i].tipounidad;
	      var cantidad = data[i].cantidad;
	      var precio = 0.0;
	      var total = 0.0;
	
	      if (tipounidad === 1) {
	        if (tipoprecio === 1) {
	          precio = parseFloat(data[i].preciomaxialter);
	        } else if (tipoprecio === 2) {
	          precio = parseFloat(data[i].precioofealter);
	        } else if (tipoprecio === 3) {
	          precio = parseFloat(data[i].preciomayoralter);
	        } else if (tipoprecio === 4) {
	          precio = parseFloat(data[i].preciominialter);
	        }
	      } else {
	        if (tipoprecio === 1) {
	          precio = parseFloat(data[i].preciomaxi);
	        } else if (tipoprecio === 2) {
	          precio = parseFloat(data[i].precioofe);
	        } else if (tipoprecio === 3) {
	          precio = parseFloat(data[i].preciomayor);
	        } else if (tipoprecio === 4) {
	          precio = parseFloat(data[i].preciomini);
	        }
	      }
	
	      total = precio * cantidad;
	      var montoiv = parseFloat(precio) * parseFloat(data[i].iva) / 100;
	
	      data[i].tipoprecio = e.target.value;
	      data[i].precio = precio;
	      data[i].total = total;
	      data[i].montoiva = (0, _varios.round)(montoiv * cantidad, 2);
	
	      setRecords(data);
	      setTotales((0, _varios.calcularTotales)(data));
	    };
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	
	    if (cmbRif.current.value === "" || txtRif.current.value.trim() === "" || txtNombreC.current.value === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "El Cliente no debe estar vacio",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtRif.current.focus();
	    } else if (txtFecha.current.value.trim() === "") {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "La Fecha no debe estar vacia",
	        icono: "informacion"
	      });
	      sigue = false;
	      txtFecha.current.focus();
	    } else if (records.length === 0) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación",
	        texto: "No hay Producto agregados",
	        icono: "informacion"
	      });
	      sigue = false;
	      btnCancela.current.focus();
	    }
	
	    if (sigue) {
	      var notae = [];
	      var notaedet = [];
	
	      notae.push({
	        idpresupuesto: presupuesto.idpresupuesto,
	        codigo: presupuesto.codigo,
	        cedularif: cliente.tiporif + cliente.rif,
	        montototal: totales.total,
	        totaliva: totales.totaliva,
	        totalexento: totales.exento,
	        totalsujeto: totales.sujeto,
	        totaldescuento: totales.descuento,
	        idcliente: cliente.idcliente,
	        idvendedor: vendedor.idvendedor,
	        fecha: txtFecha.current.value,
	        status: presupuesto.status,
	        idalmacen: vendedor.idalmacen,
	        idmoneda: monedaSub.idmoneda,
	        valormoneda: monedaSub.valormoneda
	      });
	
	      for (var i = 0; i < records.length; i++) {
	        notaedet.push({
	          idproducto: records[i].idproducto,
	          cantidad: records[i].cantidad,
	          punitario: records[i].precio,
	          descuento: "0.00",
	          iva: records[i].iva,
	          tipounidad: records[i].tipounidad,
	          idunidadmedida: records[i].idunidadmedida,
	          idunidadalterna: records[i].idunidadalterna,
	          tasa: monedaSub.valormoneda,
	          codproducto: records[i].codigo,
	          costo: records[i].costocalculado,
	          utilidad: records[i].utipreciomaxi,
	          tipopreciodeta: records[i].tipoprecio
	        });
	      }
	
	      setBody({
	        presu: notae,
	        presudeta: notaedet
	      });
	
	      var msg = "";
	      if (operacion === 1) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (operacion === 2) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (operacion === 3) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var blanquear = function blanquear() {
	    setTituloHeader("Gestionar Presupuestos.");
	    setBody();
	    setActivate(false);
	    setHabilitado(false);
	    setHabilitadoMod(false);
	    setHabilitarMoneda(false);
	    setHabilitadoCli(false);
	    setHabilitadoBot(true);
	    setHabilitarCat(true);
	    setHabilitadoProductos(true);
	    setVisible(0);
	    setVisibleBtn("visible");
	    setMoneda({
	      idmoneda: "1",
	      descripcion: "BOLIVARES",
	      simbolo: "Bs",
	      predeterminada: false,
	      valormoneda: 1.0
	    });
	    setMonedaCambio({
	      idmoneda: "4",
	      descripcion: "DOLAR",
	      simbolo: "$",
	      predeterminada: false,
	      subpredeterminada: true,
	      valormoneda: 1.0
	    });
	    setRecords([]);
	    for (var i = 0; i < combomoneda.length; i++) {
	      if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
	        cmbMoneda.current.selectedIndex = i;
	      }
	    }
	    if (operacion !== 1) {
	      txtCodigoPresupuesto.current.value = "";
	      txtCodigoPresupuesto.current.setAttribute("disabled", true);
	      txtStatus.current.value = "0";
	    }
	
	    txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	    cmbRif.current.value = "J";
	    txtRif.current.value = "";
	    txtNombreC.current.value = "";
	    setCliente({
	      idcliente: "",
	      tiporif: "J",
	      rif: "",
	      nombre: ""
	    });
	    setVendedor({
	      idvendedor: "",
	      tiporif: "",
	      rif: "",
	      nombre: "",
	      idalmacen: ""
	    });
	    setPresupuesto({
	      idpresupuesto: "0",
	      codigo: "000000",
	      cedularif: "",
	      montototal: 0.0,
	      totaliva: 0.0,
	      totaldescuento: 0.0,
	      totalexento: 0.0,
	      totalsujeto: 0.0,
	      idcliente: "",
	      idvendedor: "",
	      fecha: (0, _moment2.default)(fechasistema).format("YYYY-MM-DD"),
	      status: 0,
	      idalmacen: "",
	      idmoneda: "",
	      valormoneda: 0.0
	    });
	    setTotales({
	      subtotal: 0.0,
	      descuento: 0.0,
	      exento: 0.0,
	      sujeto: 0.0,
	      iva: 16.0,
	      totaliva: 0.0,
	      total: 0.0
	    });
	    setOperacion(0);
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	  };
	
	  var handleInputChangeCodigo = function handleInputChangeCodigo(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (event.target.name === "idnotaentre") {
	          seleccionarpresupuesto();
	        }
	      }
	    }
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "fecha") {
	      setPresupuesto(Object.assign({}, presupuesto, { fecha: e.target.value }));
	    }
	  };
	
	  var imprimirpresupuesto = function imprimirpresupuesto() {
	    if (accbtnpresupuesto && accbtnpresupuesto.toString().substring(4, 5) === "1") {
	      if (txtCodigoPresupuesto.current.value !== "") {
	        var id = txtCodigoPresupuesto.current.value;
	        window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=Presupuesto&idnota=" + id, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
	      }
	    } else {
	      setMensaje({
	        mostrar: true,
	        titulo: "Notificación.",
	        texto: "¡No Posee Permiso para Realizar esta Acción!",
	        icono: "error"
	      });
	    }
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (accbtnpresupuesto && accbtnpresupuesto.toString().substring(0, 1) === "1") {
	          setTituloHeader("Incluir Presupuesto.");
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          setHabilitadoMod(true);
	          setHabilitado(true);
	          setHabilitadoCli(true);
	          setHabilitadoProductos(false);
	          setHabilitarMoneda(true);
	          //txtCodigoPresupuesto.current.setAttribute("disabled", true);
	          seleccionarVendedor(idVendedor);
	          setHabilitarCat(true);
	          txtFecha.current.value = (0, _moment2.default)(fechasistema).format("YYYY-MM-DD");
	          setTimeout(function () {
	            return txtRif.current.focus();
	          }, 300);
	          //txtCodigoPresupuesto.current.value = "0";
	          //txtCodigoPresupuesto.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (accbtnpresupuesto && accbtnpresupuesto.toString().substring(1, 2) === "1") {
	          setTituloHeader("Editar Presupuesto.");
	          setOperacion(op);
	          txtCodigoPresupuesto.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          txtCodigoPresupuesto.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (accbtnpresupuesto && accbtnpresupuesto.toString().substring(3, 4) === "1") {
	          setTituloHeader("Eliminar Presupuesto.");
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          txtCodigoPresupuesto.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitarMoneda(false);
	          setHabilitadoMod(false);
	          setHabilitado(false);
	          setHabilitadoCli(false);
	          setHabilitadoProductos(true);
	          txtCodigoPresupuesto.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (accbtnpresupuesto && accbtnpresupuesto.toString().substring(2, 3) === "1") {
	          setTituloHeader("Consultar Presupuesto.");
	          setHabilitadoBot(false);
	          setVisibleBtn("hidden");
	          setOperacion(op);
	          txtCodigoPresupuesto.current.removeAttribute("disabled");
	          setHabilitarCat(false);
	          setHabilitado(false);
	          setHabilitarMoneda(true);
	          setHabilitadoMod(false);
	          setHabilitadoCli(false);
	          setHabilitadoProductos(true);
	          txtCodigoPresupuesto.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        blanquear();
	      }
	    };
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarMonedas();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12 ", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-11 mx-auto py-2 card shadow" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row border-azul mx-auto rounded py-1" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row mx-auto d-flex justify-content-between mb-1" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-2 azulGradiant shadow text-light justify-content-between" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-4" },
	                  _react2.default.createElement(
	                    "h3",
	                    null,
	                    tituloHeader
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-3 d-flex justify-content-end" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "/inicio", className: "text-light " },
	                    _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                    _react2.default.createElement(
	                      "span",
	                      { className: "fw-bold" },
	                      "Salir"
	                    )
	                  )
	                )
	              ),
	              operacion !== 1 && _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col-pd-240 mb-3",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CODIGO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    autoComplete: "off",
	                    ref: txtCodigoPresupuesto,
	                    name: "idnotaentre",
	                    onKeyUp: handleInputChangeCodigo,
	                    onBlur: handleInputChangeCodigo,
	                    onChange: function onChange(e) {
	                      return e.target.value = e.target.value.toUpperCase();
	                    },
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: habilitarCat,
	                      type: "button",
	                      onClick: function onClick() {
	                        return setCatalogoPresu(true);
	                      },
	                      className: "btn btn-success"
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                )
	              ),
	              operacion !== 1 && _react2.default.createElement(
	                "div",
	                {
	                  className: "colfull col-pd-230 mb-3 mr-auto px-1",
	                  style: { fontSizeAdjust: "0.6" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "ESTATUS:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: txtStatus,
	                      style: {
	                        fontWeight: "bold",
	                        color: presupuesto.status === 0 ? "#007bff" : presupuesto.status === 1 ? "#28a745" : presupuesto.status === 4 ? "#dc3545" : "#000000"
	                      },
	                      disabled: true,
	                      className: "form-select form-select-sm text-uppercase px-1",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "0" },
	                      "PENDIENTE"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "1" },
	                      "PROCESADO"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "4" },
	                      "ANULADO"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "colfull col-pd-290 mb-3" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TIPO MONEDA:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-control form-control-sm fw-bold text-center",
	                      disabled: !habilitarMoneda,
	                      ref: cmbMoneda,
	                      onChange: onChangeMoneda
	                    },
	                    combomoneda && combomoneda.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: index },
	                        " ",
	                        item.descripcion + " " + item.simbolo + " " + (0, _varios.formatMoneda)(item.valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                        " "
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-pd-220 ml-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "FECHA:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "date",
	                    disabled: !habilitado,
	                    ref: txtFecha,
	                    name: "fecha",
	                    onChange: onChange,
	                    className: "form-control fs-6 text-uppercase",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "colfull1070 col-sm-6 mx-auto mb-1 row m-0",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row border-azul rounded py-2" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold mb-1" },
	                  "Datos del Cliente"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-3 col-pd-300 px-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: cmbRif,
	                      name: "cmbrif",
	                      disabled: !habilitadoCli,
	                      className: "form-select form-select-sm col-md-3 text-center",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _varios.cmbCedula.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.value },
	                        item.value
	                      );
	                    })
	                  ),
	                  _react2.default.createElement("input", {
	                    ref: txtRif,
	                    autoComplete: "off",
	                    disabled: !habilitadoCli,
	                    maxLength: 9,
	                    type: "text",
	                    className: "form-control fs-6",
	                    name: "cedula",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: validarCliente,
	                    onBlur: validarCliente
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: !habilitadoCli,
	                      type: "button",
	                      onClick: function onClick() {
	                        return setCatalogoCliente(true);
	                      },
	                      className: "btn btn-success",
	                      style: {
	                        visibility: visible === 0 ? "visible" : "hidden"
	                      }
	                    },
	                    _react2.default.createElement("i", { className: "fas fa-search" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "NOMBRE:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    ref: txtNombreC,
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "colfull1070 col-sm-6 mx-auto mb-1 row m-0",
	                style: { fontSizeAdjust: "0.6" }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 mx-auto row mb-1 py-2 border-azul rounded " },
	                _react2.default.createElement(
	                  "span",
	                  { className: "fw-bold mb-1" },
	                  "Datos del Vendedor"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-5" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CEDULA/RIF:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    value: vendedor.tiporif + vendedor.rif
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "NOMBRE:",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    disabled: true,
	                    autoComplete: "off",
	                    type: "text",
	                    className: "form-control fs-6",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    value: vendedor.nombre
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-12 border-azul px-0 rounded",
	                style: { backgroundColor: "#d5e9ff" }
	              },
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 190,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px",
	                    fontSizeAdjust: "0.6"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden" },
	                  records && records.map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      { key: index, style: { padding: "0" } },
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        { className: "bg-light d-flex align-items-between px-0" },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          style: {
	                            borderBottomRightRadius: 0,
	                            borderTopRightRadius: 0
	                          },
	                          disabled: habilitadoProductos,
	                          ref: function ref(el) {
	                            return txtId.current[index] = el;
	                          },
	                          className: "form-control form-control-sm bg-light fs-6",
	                          defaultValue: item.codigo,
	                          onChange: function onChange(e) {
	                            return e.target.value = e.target.value.toUpperCase();
	                          },
	                          onKeyUp: validarIdProducto(index),
	                          onBlur: validarIdProducto(index)
	                        }),
	                        (operacion === 1 || operacion === 2 || presupuesto.numpedido !== "") && _react2.default.createElement(
	                          "button",
	                          {
	                            type: "button",
	                            style: {
	                              borderBottomLeftRadius: 0,
	                              borderTopLeftRadius: 0
	                            },
	                            disabled: habilitadoProductos,
	                            onClick: seleccionarxIndice(index),
	                            className: "btn btn-sm btn-primary"
	                          },
	                          _react2.default.createElement(
	                            "i",
	                            { className: "fas " },
	                            "-"
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-start p-0 pl-2",
	                          style: { width: "150px" }
	                        },
	                        item.nombrecorto
	                      ),
	                      operacion === 4 ? "" : _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "150px" }
	                        },
	                        (0, _varios.formatMoneda)(item.cantidadE.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-center p-0",
	                          style: { width: "20px" }
	                        },
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          className: "form-control form-control-sm bg-light text-right fs-6",
	                          id: "cantidad",
	                          disabled: !habilitadoMod,
	                          defaultValue: (0, _varios.formatMoneda)(item.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                          ref: function ref(el) {
	                            return txtCantidad.current[index] = el;
	                          },
	                          onFocus: _varios.seleccionarCampo,
	                          onKeyUp: validarCantidadP(index),
	                          onBlur: validarCantidadP(index),
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light p-0",
	                          style: { width: 50 }
	                        },
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            className: "form-control form-control-sm fs-6",
	                            style: { width: "100%" },
	                            disabled: habilitadoProductos,
	                            defaultValue: item.tipoprecio,
	                            onChange: onChangeTipoPrecio(index)
	                          },
	                          _varios.comboprecios.map(function (item2, x) {
	                            return _react2.default.createElement(
	                              "option",
	                              { key: x, value: item2.id },
	                              " ",
	                              item2.nombre,
	                              " "
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "50px" }
	                        },
	                        (0, _varios.formatMoneda)((item.precio * item.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "50px" }
	                        },
	                        (0, _varios.formatMoneda)(item.iva.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light p-0",
	                          style: { width: 50 }
	                        },
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            className: "form-control form-control-sm fs-6",
	                            style: { width: "100%" },
	                            disabled: habilitadoProductos,
	                            onChange: onChangeUnidad(index)
	                          },
	                          item.unidad && item.unidad.map(function (item2, x) {
	                            return _react2.default.createElement(
	                              "option",
	                              { key: x, value: item2.idunidad },
	                              " ",
	                              item2.descripcion,
	                              " "
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "50px" }
	                        },
	                        (0, _varios.formatMoneda)((item.montoiva * item.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-end p-0 pr-2",
	                          style: { width: "50px" }
	                        },
	                        (0, _varios.formatMoneda)((item.precio * item.cantidad * item.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      operacion !== 4 && operacion !== 3 && _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-middle bg-light text-center p-0",
	                          style: { width: "20px" }
	                        },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            disabled: habilitadoProductos,
	                            style: {
	                              visibility: (operacion === 4 || operacion === 3) && "collapse"
	                            },
	                            onClick: eliminarProducto(item),
	                            className: "btn btn-sm btn-danger"
	                          },
	                          _react2.default.createElement("i", { className: "fa fa-trash" }),
	                          " "
	                        )
	                      )
	                    );
	                  }),
	                  _react2.default.createElement(
	                    _core.TableRow,
	                    {
	                      style: {
	                        padding: "0",
	                        visibility: (operacion === 4 || operacion === 0 || operacion === 3) && "collapse"
	                      }
	                    },
	                    _react2.default.createElement(
	                      _core.TableCell,
	                      { className: "align-middle bg-light text-center p-0 d-flex" },
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        disabled: habilitadoProductos,
	                        ref: txtIdproducto,
	                        style: {
	                          borderBottomRightRadius: 0,
	                          borderTopRightRadius: 0
	                        },
	                        className: "form-control form-control-sm bg-light text-right",
	                        onChange: function onChange(e) {
	                          return e.target.value = e.target.value.toUpperCase();
	                        },
	                        onKeyUp: validarIdProducto(null),
	                        onBlur: validarIdProducto(null)
	                      }),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          type: "button",
	                          disabled: habilitadoProductos,
	                          style: {
	                            borderBottomLeftRadius: 0,
	                            borderTopLeftRadius: 0
	                          },
	                          onClick: function onClick() {
	                            return setMostrar(true);
	                          },
	                          className: "btn btn-sm btn-primary"
	                        },
	                        _react2.default.createElement(
	                          "i",
	                          { className: "fas " },
	                          "-"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light text-start p-0 pl-2",
	                      style: { width: "150px" }
	                    }),
	                    operacion === 4 ? "" : _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light text-end p-0 pr-2",
	                      style: { width: "30px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light text-center p-0",
	                      style: { width: "20px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light text-end p-0 pr-2",
	                      style: { width: "50px" }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light p-0",
	                      style: { width: 50 }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light p-0",
	                      style: { width: 50 }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light p-0",
	                      style: { width: 50 }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light p-0",
	                      style: { width: 50 }
	                    }),
	                    _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light text-end p-0",
	                      style: { width: "50px" }
	                    }),
	                    operacion === 4 ? "" : _react2.default.createElement(_core.TableCell, {
	                      className: "align-middle bg-light text-center p-0",
	                      style: { width: "20px" }
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 row m-0 px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-9 py-1 mt-auto" },
	                visibleBtn === "visible" ? _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-botones" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 row m-0" },
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: !habilitadoBot,
	                        ref: btnIncluir,
	                        onClick: onBotones(1),
	                        className: "btn btn-sm col ml-1 mb-1 btn-primary rounded-pill",
	                        title: "Incluir Presupuesto"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-plus" },
	                        " Incluir "
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: !habilitadoBot,
	                        ref: btnConsultar,
	                        onClick: onBotones(4),
	                        className: "btn btn-sm col ml-1 mb-1 btn-info rounded-pill",
	                        title: "Consultar Presupuesto"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fas fa-eye" },
	                        " Consultar"
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: !habilitadoBot,
	                        ref: btnEditar,
	                        onClick: onBotones(2),
	                        className: "btn btn-sm col ml-1 mb-1 btn-warning rounded-pill",
	                        title: "Modificar Presupuesto"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fa fa-edit" },
	                        " Modificar"
	                      ),
	                      " "
	                    ),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: !habilitadoBot,
	                        ref: btnEliminar,
	                        onClick: onBotones(3),
	                        className: "btn btn-sm col ml-1 mb-1 btn-danger rounded-pill",
	                        title: "Eliminar Presupuesto"
	                      },
	                      _react2.default.createElement(
	                        "i",
	                        { className: "fa fa-trash" },
	                        " Eliminar"
	                      ),
	                      " "
	                    )
	                  )
	                ) : _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-360 row m-0 ml-auto" },
	                  operacion === 4 ? _react2.default.createElement(
	                    "button",
	                    {
	                      onClick: imprimirpresupuesto,
	                      disabled: operacion === 4 ? false : true,
	                      className: "btn btn-sm col ml-1 btn-primary rounded-pill",
	                      title: "Imprimir Presupuesto"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-print" },
	                      " Imprimir"
	                    )
	                  ) : "",
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnAcepta,
	                      disabled: operacion === 4 ? true : habilitadoBot,
	                      onClick: onBotones(5),
	                      className: "btn btn-sm col ml-1 rounded-pill btn-success"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-check-circle" },
	                      " Aceptar"
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      ref: btnCancela,
	                      disabled: habilitadoBot,
	                      onClick: onBotones(6),
	                      className: "btn btn-danger col ml-1 btn-sm rounded-pill"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-window-close" },
	                      " Cancelar"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-md-3 border-azul rounded shadow",
	                  style: { backgroundColor: "#dbeeff" }
	                },
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "SUBTOTAL ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtSubTotal,
	                    value: (0, _varios.formatMoneda)((totales.subtotal * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "EXENTO ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtExentoTotal,
	                    value: (0, _varios.formatMoneda)((totales.exento * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "DESCUENTO ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtDescuento,
	                    value: (0, _varios.formatMoneda)((totales.descuento * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "IVA Sobre % ",
	                    monedaCambio.simbolo,
	                    ":",
	                    " "
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtTotIva,
	                    value: (0, _varios.formatMoneda)((totales.totaliva * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "input-group input-group-sm  col-md-12",
	                    style: { fontSizeAdjust: "0.6" }
	                  },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text bg-transparent border-0",
	                      id: "inputGroup-sizing-sm",
	                      style: { fontSize: 14 }
	                    },
	                    "TOTAL ",
	                    monedaCambio.simbolo,
	                    ":"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    disabled: true,
	                    ref: txtTotal,
	                    value: (0, _varios.formatMoneda)((totales.total * monedaCambio.valormoneda).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                    className: "form-control bg-transparent text-right fw-bold rounded border-0 fs-5",
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoProductoExistencia2.default, {
	      show: mostrar,
	      onHideCancelar: function onHideCancelar() {
	        setMostrar(false);
	      },
	      onHideAceptaCatalogo: agregarProducto,
	      idalmacen: vendedor.idalmacen
	    }),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: catalogoCliente,
	      nomid: "cliente",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoCliente(false);
	      },
	      onHideAceptaCatalogo: onCatalogoCliente
	    }),
	    _react2.default.createElement(_catalogoPresupuesto2.default, {
	      show: catalogoPresu,
	      nomid: "presupuesto",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoPresu(false);
	      },
	      onHideAceptaCatalogo: onCatalogopresupuesto,
	      condicion: "true"
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return mensaje.titulo === "Exito." ? blanquear() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = TablaPresupuesto;

/***/ },
/* 7182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _catalogoPersona = __webpack_require__(64);
	
	var _catalogoPersona2 = _interopRequireDefault(_catalogoPersona);
	
	var _cartasProveedor = __webpack_require__(303);
	
	var _cartasProveedor2 = _interopRequireDefault(_cartasProveedor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TablaProveedor = function TablaProveedor() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var anio = JSON.parse(sessionStorage.getItem("anioactu"));
	  var registrado = false;
	  var muni = "";
	  var ciu = "";
	  var valrif = 0;
	
	  var accbtnproveedores = JSON.parse(sessionStorage.getItem("accbtnproveedoresc"));
	  var fechaTope = (0, _moment2.default)(JSON.parse(sessionStorage.getItem("fechasistema"))).format("YYYY-MM-DD").replace(anio.toString(), (anio - 18).toString());
	
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var chkNatural = (0, _react.useRef)();
	  var chkJuridico = (0, _react.useRef)();
	  var txtId = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtRazon = (0, _react.useRef)();
	  var txtDirClient = (0, _react.useRef)();
	  var txtEmailClient = (0, _react.useRef)();
	  var txtTlf1Client = (0, _react.useRef)();
	  var txtTlf2Client = (0, _react.useRef)();
	  var txtEstado = (0, _react.useRef)();
	  var txtMunicipio = (0, _react.useRef)();
	  var txtCiudad = (0, _react.useRef)();
	  var txtStatus = (0, _react.useRef)();
	
	  var cmbNacionalidad = (0, _react.useRef)();
	  var txtCedRes = (0, _react.useRef)();
	  var cmbSexo = (0, _react.useRef)();
	  var txtFechaNac = (0, _react.useRef)();
	  var txtNomResp = (0, _react.useRef)();
	  var txtApeResp = (0, _react.useRef)();
	  var txtDireccion = (0, _react.useRef)();
	  var txtEmail = (0, _react.useRef)();
	  var txtTlf1 = (0, _react.useRef)();
	  var txtTlf2 = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      body = _useState2[0],
	      setBody = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(true),
	      _useState4 = _slicedToArray(_useState3, 2),
	      habilitado = _useState4[0],
	      setHabilitado = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(),
	      _useState6 = _slicedToArray(_useState5, 2),
	      nacnalidad = _useState6[0],
	      setNacnalidad = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(1),
	      _useState8 = _slicedToArray(_useState7, 2),
	      select = _useState8[0],
	      setSelect = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(0),
	      _useState10 = _slicedToArray(_useState9, 2),
	      totalr = _useState10[0],
	      setTotalr = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(0),
	      _useState12 = _slicedToArray(_useState11, 2),
	      totalact = _useState12[0],
	      setTotalact = _useState12[1];
	
	  var _useState13 = (0, _react.useState)("Gestionar Proveedores."),
	      _useState14 = _slicedToArray(_useState13, 2),
	      tituloHeader = _useState14[0],
	      setTituloHeader = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(0),
	      _useState16 = _slicedToArray(_useState15, 2),
	      operacion = _useState16[0],
	      setOperacion = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      totalinc = _useState18[0],
	      setTotalinc = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(true),
	      _useState20 = _slicedToArray(_useState19, 2),
	      acept = _useState20[0],
	      setAcept = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(""),
	      _useState22 = _slicedToArray(_useState21, 2),
	      titulo = _useState22[0],
	      setTitulo = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(false),
	      _useState24 = _slicedToArray(_useState23, 2),
	      catalogoPersona = _useState24[0],
	      setCatalogoPersona = _useState24[1];
	
	  var _useState25 = (0, _react.useState)(false),
	      _useState26 = _slicedToArray(_useState25, 2),
	      catalogoCliente = _useState26[0],
	      setCatalogoCliente = _useState26[1];
	
	  var _useState27 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState28 = _slicedToArray(_useState27, 2),
	      mensaje = _useState28[0],
	      setMensaje = _useState28[1];
	
	  var _useState29 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState30 = _slicedToArray(_useState29, 2),
	      mensajesino = _useState30[0],
	      setMensajesino = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(false),
	      _useState32 = _slicedToArray(_useState31, 2),
	      activate = _useState32[0],
	      setActivate = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(0),
	      _useState34 = _slicedToArray(_useState33, 2),
	      visibleBtn = _useState34[0],
	      setVisibleBtn = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(0),
	      _useState36 = _slicedToArray(_useState35, 2),
	      ops = _useState36[0],
	      setOps = _useState36[1];
	
	  var _useState37 = (0, _react.useState)([]),
	      _useState38 = _slicedToArray(_useState37, 2),
	      estados = _useState38[0],
	      setEstados = _useState38[1];
	
	  var _useState39 = (0, _react.useState)([]),
	      _useState40 = _slicedToArray(_useState39, 2),
	      municipios = _useState40[0],
	      setMunicipios = _useState40[1];
	
	  var _useState41 = (0, _react.useState)([]),
	      _useState42 = _slicedToArray(_useState41, 2),
	      ciudades = _useState42[0],
	      setCiudades = _useState42[1];
	
	  var _useState43 = (0, _react.useState)(true),
	      _useState44 = _slicedToArray(_useState43, 2),
	      habilitadoNU = _useState44[0],
	      setHabilitadoNU = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(true),
	      _useState46 = _slicedToArray(_useState45, 2),
	      activo = _useState46[0],
	      setActivo = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(true),
	      _useState48 = _slicedToArray(_useState47, 2),
	      activob = _useState48[0],
	      setActivob = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(0),
	      _useState50 = _slicedToArray(_useState49, 2),
	      operacionPer = _useState50[0],
	      setOperacionPer = _useState50[1];
	
	  var _useState51 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    catalogoper: true
	  }),
	      _useState52 = _slicedToArray(_useState51, 2),
	      botones = _useState52[0],
	      setBotones = _useState52[1];
	
	  var handleInputNumChange = function handleInputNumChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	
	    if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var datosRes = function datosRes() {
	    var campos = "*";
	    var nomtab = "persona";
	    var nomid = "cedula";
	    var nomid2 = "nacionalidad";
	    var id = txtCedRes.current.value;
	    var id2 = cmbNacionalidad.current.value;
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=" + id2;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        cmbSexo.current.value = "";
	        txtFechaNac.current.value = "";
	        txtNomResp.current.value = "";
	        txtApeResp.current.value = "";
	        txtDireccion.current.value = "";
	        txtEmail.current.value = "";
	        txtTlf1.current.value = "";
	        txtTlf2.current.value = "";
	
	        if (response.data !== "") {
	          if (operacion !== 2) {
	            setHabilitadoNU(true);
	          }
	          setOperacionPer(0);
	          cmbSexo.current.value = response.data.sexo;
	          txtFechaNac.current.value = (0, _moment2.default)(response.data.fnacimiento).format("YYYY-MM-DD");
	          txtNomResp.current.value = response.data.nombres.trim();
	          txtApeResp.current.value = response.data.apellidos.trim();
	          txtDireccion.current.value = response.data.direccion.trim();
	          txtEmail.current.value = response.data.correoe.trim();
	          txtTlf1.current.value = response.data.tlf1.trim();
	          txtTlf2.current.value = response.data.tlf2.trim();
	          if (!botones.consultar) {
	            btnCancela.current.focus();
	          } else {
	            btnAcepta.current.focus();
	          }
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe una persona con este N° de cedula porfavor registre sus datos",
	            icono: "informacion"
	          });
	          setOperacionPer(1);
	          setHabilitadoNU(false);
	          cmbSexo.current.focus();
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "*";
	    var nomtab = "estado";
	    var orden = "idestado";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setEstados(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var selectMunicipios = function selectMunicipios(id) {
	    var campos = "*";
	    var nomtab = "municipio";
	    var nomid = "idestado";
	    var endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&id=" + id + "&nomtab=" + nomtab + "&nomid=" + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setMunicipios(response.data);
	        if (registrado || !botones.consultar || !botones.modificar || !botones.eliminar) {
	          txtMunicipio.current.value = muni;
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var selectCiudad = function selectCiudad(id) {
	    var campos = "*";
	    var nomtab = "ciudad";
	    var nomid = "idmunicipio";
	    var endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&id=" + id + "&nomtab=" + nomtab + "&nomid=" + nomid;
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setCiudades(response.data);
	        if (registrado || !botones.consultar || !botones.modificar || !botones.eliminar) {
	          txtCiudad.current.value = ciu;
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setTituloHeader("Gestionar Proveedores.");
	    setAcept(true);
	    setVisibleBtn(0);
	    setActivate(false);
	    setActivo(true);
	    setActivob(true);
	    setBody(null);
	    setOperacionPer(0);
	    setHabilitado(true);
	    setHabilitadoNU(true);
	    setMunicipios([]);
	    setCiudades([]);
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      catalogoper: true
	    });
	    chkJuridico.current.checked = true;
	    cmbRif.current.value = "";
	    txtRif.current.value = "";
	    txtId.current.value = 0;
	    txtRazon.current.value = "";
	    txtDirClient.current.value = "";
	    txtTlf1Client.current.value = "";
	    txtTlf2Client.current.value = "";
	    txtEmailClient.current.value = "";
	    txtStatus.current.value = "";
	    txtEstado.current.value = "";
	    txtMunicipio.current.value = "";
	    txtCiudad.current.value = "";
	
	    cmbNacionalidad.current.value = "";
	    txtCedRes.current.value = "";
	    cmbSexo.current.value = "";
	    txtFechaNac.current.value = "";
	    txtNomResp.current.value = "";
	    txtApeResp.current.value = "";
	    txtDireccion.current.value = "";
	    txtEmail.current.value = "";
	    txtTlf1.current.value = "";
	    txtTlf2.current.value = "";
	
	    setSelect(1);
	    setNacnalidad();
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	    if (!botones.incluir || !botones.modificar) {
	      var nom = void 0;
	      nom = select === 1 ? "Nombre/Razón Social" : "Nombres y Apellidos";
	
	      var ced = void 0;
	      ced = select === 1 ? "R.I.F" : "Cédula";
	
	      if (txtStatus.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Seleccione el Estatus del Proveedor",
	          icono: "informacion"
	        });
	        txtStatus.current.focus();
	        sigue = false;
	      } else if (txtRazon.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "El campo" + " " + nom + " " + "no debe ir Vacio",
	          icono: "informacion"
	        });
	        txtRazon.current.focus();
	        sigue = false;
	      } else if (txtDirClient.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Describa la Dirección del Proveedor",
	          icono: "informacion"
	        });
	        txtDirClient.current.focus();
	        sigue = false;
	      } else if (txtEstado.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Seleccione el Estado del Proveedor",
	          icono: "informacion"
	        });
	        txtEstado.current.focus();
	        sigue = false;
	      } else if (txtMunicipio.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Seleccione el Municipio del Proveedor",
	          icono: "informacion"
	        });
	        txtMunicipio.current.focus();
	        sigue = false;
	      } else if (txtCiudad.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Seleccione la Ciudad del Proveedor",
	          icono: "informacion"
	        });
	        txtCiudad.current.focus();
	        sigue = false;
	      } else if (txtCedRes.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Debe Seleccionar el Responsable",
	          icono: "informacion"
	        });
	        txtCedRes.current.focus();
	        sigue = false;
	      } else if (operacionPer === 1) {
	        if (cmbNacionalidad.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe seleccionar la nacionalidad del responsable",
	            icono: "informacion"
	          });
	          cmbNacionalidad.current.focus();
	          sigue = false;
	        } else if (cmbSexo.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe seleccionar el Sexo del responsable",
	            icono: "informacion"
	          });
	          cmbSexo.current.focus();
	          sigue = false;
	        } else if (txtFechaNac.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar fecha nacimiento del responsable",
	            icono: "informacion"
	          });
	          txtFechaNac.current.focus();
	          sigue = false;
	        } else if (txtNomResp.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar el nombre del responsable",
	            icono: "informacion"
	          });
	          txtNomResp.current.focus();
	          sigue = false;
	        } else if (txtApeResp.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar el apellido del responsable",
	            icono: "informacion"
	          });
	          txtApeResp.current.focus();
	          sigue = false;
	        } else if (txtDireccion.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar la dirección del responsable",
	            icono: "informacion"
	          });
	          txtDireccion.current.focus();
	          sigue = false;
	        }
	      }
	    }
	
	    if (sigue) {
	      var cliente = [];
	      var repre = [];
	      cliente.push({
	        idagente: !botones.incluir ? 0 : txtId.current.value,
	        nombre: txtRazon.current.value.toUpperCase().trim(),
	        direccion: txtDirClient.current.value.toUpperCase().trim(),
	        tipoper: chkNatural.current.checked ? 0 : 1,
	        rif: nacnalidad + txtRif.current.value,
	        reprelegal: cmbNacionalidad.current.value + txtCedRes.current.value,
	        telefono: txtTlf1Client.current.value,
	        celular: txtTlf2Client.current.value,
	        email: txtEmailClient.current.value !== '' ? txtEmailClient.current.value.toUpperCase().trim() : 'N/S',
	        proveedor: true,
	        statusproveedor: txtStatus.current.value.trim(),
	        estado: txtEstado.current.value.trim(),
	        municipio: txtMunicipio.current.value.trim(),
	        ciudad: txtCiudad.current.value.trim()
	      });
	      repre.push({
	        cedula: parseInt(txtCedRes.current.value),
	        correoe: txtEmail.current.value.toUpperCase().trim(),
	        tlf1: txtTlf1.current.value.trim(),
	        tlf2: txtTlf2.current.value.trim(),
	        apellidos: txtApeResp.current.value.toUpperCase().trim(),
	        direccion: txtDireccion.current.value.toUpperCase().trim(),
	        fnacimiento: txtFechaNac.current.value.trim(),
	        nacionalidad: cmbNacionalidad.current.value.trim(),
	        nombres: txtNomResp.current.value.toUpperCase().trim(),
	        sexo: cmbSexo.current.value.trim()
	      });
	
	      setBody({
	        operacionper: operacionPer,
	        agente: cliente,
	        repre: repre,
	        client: []
	      });
	
	      var msg = "";
	      if (!botones.incluir) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (!botones.modificar) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (!botones.eliminar) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + "/api/agente/actualizar/" + ope;
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (ope === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Registro Creado Correctamente",
	            icono: "exito"
	          });
	        } else if (ope === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Registro Modificado Correctamente",
	            icono: "exito"
	          });
	        } else if (ope === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "Registro Eliminado Correctamente",
	            icono: "exito"
	          });
	        }
	        ContarRegistros();
	        seleccionarActivos();
	        seleccionarInactivos();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = "";
	      if (error.response === undefined) {
	        mensaje = "Error de Conexion";
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "agente_rif_key"') {
	          mensaje = "Ya existe un Registro con este rif";
	        } else if (error.response.data.message === 'duplicate key value violates unique constraint "agente_email_key"') {
	          mensaje = "Ya existe un Registro con este correo";
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var datosPro = function datosPro(rif) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "rif";
	    var nomid2 = "proveedor";
	    var id = rif;
	    var endpoint = "";
	
	    if (!botones.incluir) {
	      endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	    } else {
	      endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	    }
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data !== "") {
	          if (botones.incluir === false && response.data.proveedor && response.data.rif === valrif) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "¡El Proveedor con el N° de Cédula o RIF" + " " + response.data.rif + " " + "ya Existe!",
	              icono: "informacion"
	            });
	            txtId.current.value = "";
	            txtStatus.current.value = "";
	            txtRazon.current.value = "";
	            txtDirClient.current.value = "";
	            txtEmailClient.current.value = "";
	            txtTlf1Client.current.value = "";
	            txtTlf2Client.current.value = "";
	            txtEstado.current.value = "";
	            txtMunicipio.current.value = "";
	            txtCiudad.current.value = "";
	            txtRif.current.value = "";
	            cmbRif.current.value = "--";
	
	            cmbNacionalidad.current.value = "";
	            txtCedRes.current.value = "";
	
	            muni = "";
	            ciu = "";
	
	            cmbSexo.current.value = "";
	            txtFechaNac.current.value = "";
	            txtNomResp.current.value = "";
	            txtApeResp.current.value = "";
	            txtDireccion.current.value = "";
	            txtEmail.current.value = "";
	            txtTlf1.current.value = "";
	            txtTlf2.current.value = "";
	          } else {
	            txtId.current.value = response.data.idagente;
	            txtStatus.current.value = response.data.statusproveedor;
	            txtRazon.current.value = response.data.nombre.trim();
	            txtDirClient.current.value = response.data.direccion.trim();
	            txtEmailClient.current.value = response.data.email.trim();
	            txtTlf1Client.current.value = response.data.telefono.trim();
	            txtTlf2Client.current.value = response.data.celular.trim();
	            txtEstado.current.value = response.data.estado;
	            txtMunicipio.current.value = response.data.municipio;
	            txtCiudad.current.value = response.data.ciudad;
	
	            cmbNacionalidad.current.value = response.data.reprelegal.substring(0, 1);
	            txtCedRes.current.value = response.data.reprelegal.substring(1, 12);
	
	            muni = response.data.municipio.trim();
	            ciu = response.data.ciudad.trim();
	
	            selectMunicipios(response.data.estado.trim());
	            selectCiudad(response.data.municipio.trim());
	            datosRes();
	            setNacnalidad(response.data.rif.substring(0, 1));
	
	            var tip = response.data.tipoper;
	            if (tip === 1) {
	              chkJuridico.current.checked = true;
	              chkNatural.current.checked = false;
	            } else {
	              chkNatural.current.checked = true;
	              chkJuridico.current.checked = false;
	            }
	
	            setSelect(response.data.tipoper);
	
	            if (operacion === 4) {
	              setAcept(true);
	            } else if (operacion === 2 || operacion === 1) {
	              setAcept(false);
	              setOps(2);
	              setHabilitado(false);
	              setHabilitadoNU(false);
	              setBotones(Object.assign({}, botones, { catalogoper: false }));
	            } else if (operacion === 3) {
	              setAcept(false);
	            }
	          }
	        } else {
	          if (operacion === 2 || operacion === 3 || operacion === 4) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "¡El Proveedor con el N° de Cédula o RIF" + " " + txtRif.current.value + " " + "No Existe!",
	              icono: "error"
	            });
	            txtRazon.current.focus();
	            txtId.current.value = "";
	            txtStatus.current.value = "";
	            txtRazon.current.value = "";
	            txtDirClient.current.value = "";
	            txtEmailClient.current.value = "";
	            txtTlf1Client.current.value = "";
	            txtTlf2Client.current.value = "";
	            txtEstado.current.value = "";
	            txtMunicipio.current.value = "";
	            txtCiudad.current.value = "";
	            txtRif.current.value = "";
	            cmbRif.current.value = "--";
	
	            cmbNacionalidad.current.value = "";
	            txtCedRes.current.value = "";
	
	            muni = "";
	            ciu = "";
	
	            cmbSexo.current.value = "";
	            txtFechaNac.current.value = "";
	            txtNomResp.current.value = "";
	            txtApeResp.current.value = "";
	            txtDireccion.current.value = "";
	            txtEmail.current.value = "";
	            txtTlf1.current.value = "";
	            txtTlf2.current.value = "";
	            setOps(1);
	            setHabilitado(true);
	            setHabilitadoNU(true);
	            setBotones({ catalogoper: true, aceptar: true });
	          }
	
	          txtRazon.current.focus();
	        }
	      }
	
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var validarCliente = function validarCliente(event) {
	    event.preventDefault();
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (cmbRif.current.value !== "") {
	          datosPro(nacnalidad + event.target.value);
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe Seleccionar el Tipo de Nacionalidad",
	            icono: "informacion"
	          });
	          cmbRif.current.focus();
	        }
	      }
	    }
	  };
	
	  var validarPersona = function validarPersona(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (cmbNacionalidad.current.value !== "") {
	          datosRes();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "debe seleccionar la nacionalidad",
	            icono: "informacion"
	          });
	          cmbNacionalidad.current.focus();
	        }
	      } else {
	        cmbNacionalidad.current.value = "";
	        cmbSexo.current.value = "";
	        txtFechaNac.current.value = "";
	        txtNomResp.current.value = "";
	        txtApeResp.current.value = "";
	        txtDireccion.current.value = "";
	        txtEmail.current.value = "";
	        txtTlf1.current.value = "";
	        txtTlf2.current.value = "";
	        setHabilitadoNU(true);
	      }
	    }
	  };
	
	  var onChangeCliente = function onChangeCliente(e) {
	    if (e.target.name === "estado") {
	      setMunicipios([]);
	      setCiudades([]);
	      if (e.target.value !== "") {
	        selectMunicipios(e.target.value);
	      }
	    } else if (e.target.name === "municipio") {
	      setCiudades([]);
	      if (e.target.value !== "") {
	        selectCiudad(e.target.value);
	      }
	    } else if (e.target.name === "tipoper") {
	      if (chkNatural.current.checked) {
	        setSelect(0);
	      } else if (chkJuridico.current.checked) {
	        setSelect(1);
	      }
	    } else if (e.target.name === "cmbrif") {
	      var nac = cmbRif.current.value;
	      txtRif.current.value = "";
	      txtRif.current.focus();
	      setNacnalidad(nac);
	    }
	  };
	
	  var onChange = function onChange(e) {
	    var n = void 0;
	    var r = void 0;
	
	    if (e.target.name === "correoe" || e.target.name === "apellidos" || e.target.name === "direccion" || e.target.name === "nombres" || e.target.name === "descripcion") {
	      e.target.value = e.target.value;
	    } else if (e.target.name === "nacionalidad" && txtCedRes.current.value !== "") {
	      if (e.target.value !== "") {
	        datosRes();
	      } else {
	        txtCedRes.current.value = "";
	        cmbSexo.current.value = "";
	        txtFechaNac.current.value = "";
	        txtNomResp.current.value = "";
	        txtApeResp.current.value = "";
	        txtDireccion.current.value = "";
	        txtEmail.current.value = "";
	        txtTlf1.current.value = "";
	        txtTlf2.current.value = "";
	        setHabilitadoNU(true);
	      }
	    } else if (e.target.name === "cedula") {
	      n = cmbRif.current.value;
	      r = txtRif.current.value;
	    }
	    valrif = n + r;
	  };
	
	  var onCatalogoCliente = function onCatalogoCliente(values) {
	    setCatalogoCliente(false);
	
	    txtRazon.current.value = values.nombre;
	    cmbRif.current.value = values.rif.substring(0, 1);
	    txtRif.current.value = values.rifs;
	    cmbNacionalidad.current.value = values.reprelegal.substring(0, 1);
	    txtCedRes.current.value = values.repre;
	    setNacnalidad(values.rif.substring(0, 1));
	    datosPro(values.rif);
	    if (!botones.modificar) {
	      setBotones(Object.assign({}, botones, { catalogoper: false }));
	    }
	  };
	
	  var onCatalogoPersona = function onCatalogoPersona(values) {
	    setCatalogoPersona(false);
	    setHabilitadoNU(true);
	    setOperacionPer(0);
	    cmbNacionalidad.current.value = values.nacPer;
	    txtCedRes.current.value = values.cedPer;
	    cmbSexo.current.value = values.sexoPer;
	    txtFechaNac.current.value = (0, _moment2.default)(values.fnacPer).format("YYYY-MM-DD");
	    txtNomResp.current.value = values.nomPer;
	    txtApeResp.current.value = values.apePer;
	    txtDireccion.current.value = values.direPer;
	    txtEmail.current.value = values.correoPer;
	    txtTlf1.current.value = values.tlf1Per;
	    txtTlf2.current.value = values.tlf2Per;
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (accbtnproveedores && accbtnproveedores.toString().substring(0, 1) === "1") {
	          setVisibleBtn(1);
	          setTituloHeader("Incluir Proveedor.");
	          setOperacion(op);
	          setHabilitado(false);
	          setOps(2);
	          setAcept(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            cancelar: false,
	            catalogo: true,
	            catalogoper: false
	          });
	          setActivo(false);
	          setActivob(true);
	          txtRif.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (accbtnproveedores && accbtnproveedores.toString().substring(1, 2) === "1") {
	          setVisibleBtn(1);
	          setTituloHeader("Editar Proveedor.");
	          setOperacion(op);
	          setOps(1);
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          setActivo(false);
	          setActivob(false);
	          txtRif.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (accbtnproveedores && accbtnproveedores.toString().substring(3, 4) === "1") {
	          setVisibleBtn(1);
	          setTituloHeader("Eliminar Proveedor.");
	          setOperacion(op);
	          setHabilitado(true);
	          setOps(1);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          setActivo(false);
	          setActivob(false);
	          txtRif.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (accbtnproveedores && accbtnproveedores.toString().substring(2, 3) === "1") {
	          setVisibleBtn(1);
	          setTituloHeader("Consultar Proveedor.");
	          setOperacion(op);
	          setHabilitado(true);
	          setOps(1);
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true
	          });
	          setActivo(false);
	          setActivob(false);
	          txtRif.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        setVisibleBtn(0);
	        blanquear();
	      }
	    };
	  };
	
	  var ContarRegistros = function ContarRegistros() {
	    var valor = "proveedor";
	    var boleano = true;
	
	    var endpoint = op.conexion + "/api/agente/totalregistros?valor=" + valor + "&boleano=" + boleano;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setTotalr(response.data.total);
	        setTitulo("Proveedores");
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response === undefined ? "Error de Conexion" : error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarActivos = function seleccionarActivos() {
	    var valor = "proveedor";
	    var boleano = true;
	    var status = "statusproveedor";
	    var valstatus = 51;
	
	    var endpoint = op.conexion + "/api/agente/totalregistrosactivosinactivos?valor=" + valor + "&boleano=" + boleano + "&status=" + status + "&valstatus=" + valstatus;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setTotalact(response.data.total);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response === undefined ? "Error de Conexion" : error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarInactivos = function seleccionarInactivos() {
	    var valor = "proveedor";
	    var boleano = true;
	    var status = "statusproveedor";
	    var valstatus = 52;
	
	    var endpoint = op.conexion + "/api/agente/totalregistrosactivosinactivos?valor=" + valor + "&boleano=" + boleano + "&status=" + status + "&valstatus=" + valstatus;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setTotalinc(response.data.total);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response === undefined ? "Error de Conexion" : error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarRegistros();
	    ContarRegistros();
	    seleccionarActivos();
	    seleccionarInactivos();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12 py-2", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-9 py-1 mx-auto card shadow mt-4" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row mx-auto  rounded" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-3 mt-2 azulGradiant shadow text-light" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-p-3 mb-1" },
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  tituloHeader
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-p-1 mi-auto" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "/inicio", className: "text-light" },
	                  _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "fw-bold" },
	                    "Salir"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12", style: { fontSizeAdjust: "0.6" } },
	              _react2.default.createElement(
	                "fieldset",
	                { className: " row col-sm-12 mx-auto border-azul rounded" },
	                _react2.default.createElement(
	                  "legend",
	                  {
	                    className: "float-none w-auto fw-bold m-0",
	                    style: { fontSize: "15px" }
	                  },
	                  "Datos del Proveedor"
	                ),
	                _react2.default.createElement("input", {
	                  ref: txtId,
	                  autoComplete: "off",
	                  type: "hidden",
	                  className: "form-control",
	                  name: "idagente",
	                  "aria-label": "Sizing example input",
	                  "aria-describedby": "inputGroup-sizing-sm"
	                }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mb-3 col-pd-230 px-2" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      select === 1 ? "R.I.F" : "CEDULA",
	                      " "
	                    ),
	                    select === 1 ? _react2.default.createElement(
	                      "select",
	                      {
	                        disabled: activo,
	                        ref: cmbRif,
	                        name: "cmbrif",
	                        onChange: onChangeCliente,
	                        value: nacnalidad,
	                        className: "col-sm-3 col-3 px-2 form-select form-control-sm"
	                      },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "" },
	                        "-"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { key: "0", value: "V" },
	                        "V"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { key: "1", value: "J" },
	                        "J"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { key: "2", value: "G" },
	                        "G"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { key: "3", value: "P" },
	                        "P"
	                      )
	                    ) : _react2.default.createElement(
	                      "select",
	                      {
	                        disabled: activo,
	                        ref: cmbRif,
	                        name: "cmbrif",
	                        onChange: onChangeCliente,
	                        value: nacnalidad,
	                        className: "col-sm-3 col-3 px-2 form-select form-control-sm"
	                      },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "" },
	                        "-"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { key: "0", value: "V" },
	                        "V"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { key: "1", value: "E" },
	                        "E"
	                      )
	                    ),
	                    _react2.default.createElement("input", {
	                      ref: txtRif,
	                      autoComplete: "off",
	                      maxLength: 9,
	                      type: "text",
	                      disabled: activo,
	                      className: "form-control col-9 fs-6 px-1",
	                      name: "cedula",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm",
	                      onKeyUp: validarCliente,
	                      onBlur: validarCliente,
	                      onChange: onChange
	                    }),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: activob,
	                        type: "button",
	                        onClick: function onClick() {
	                          return setCatalogoCliente(true);
	                        },
	                        className: "btn btn-success"
	                      },
	                      _react2.default.createElement("i", { className: "fas fa-search" })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mt-15m ml-auto col-pd-250" },
	                  _react2.default.createElement(
	                    "fieldset",
	                    { className: "row col-sm-12 mx-auto border-azul rounded mb-1" },
	                    _react2.default.createElement(
	                      "legend",
	                      {
	                        className: "float-none m-0 w-auto",
	                        style: { fontSize: "14px" }
	                      },
	                      "TIPO PERSONA:"
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-5 mr-auto" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: ops === 1 ? true : activo,
	                          name: "tipoper",
	                          value: "1",
	                          ref: chkNatural,
	                          onChange: onChangeCliente,
	                          id: "tipoper",
	                          type: "radio"
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "form-check-label",
	                            "for": "exampleRadi4"
	                          },
	                          "Natural"
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "col-5 ml-auto" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "form-check" },
	                        _react2.default.createElement("input", {
	                          className: "form-check-input",
	                          disabled: ops === 1 ? true : activo,
	                          name: "tipoper",
	                          value: "2",
	                          ref: chkJuridico,
	                          onChange: onChangeCliente,
	                          id: "tipoper",
	                          defaultChecked: true,
	                          type: "radio"
	                        }),
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "form-check-label",
	                            "for": "exampleRadi5"
	                          },
	                          "Juridico"
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-210 ml-auto px-2" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "ESTATUS:"
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        ref: txtStatus,
	                        disabled: ops === 1 ? true : activo,
	                        className: "form-select form-select-sm text-center",
	                        "aria-label": ".form-select-sm example"
	                      },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "" },
	                        "SELECCIONE"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "51" },
	                        "ACTIVO"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "52" },
	                        "INACTIVO"
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    select === 1 ? "NOMBRE/RAZON SOCIAL" : "NOMBRES Y APELLIDOS"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    ref: txtRazon,
	                    disabled: habilitado,
	                    name: "nombres",
	                    className: "form-control text-uppercase fs-6",
	                    onChange: onChange,
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "DIRECCION:"
	                  ),
	                  _react2.default.createElement("textarea", {
	                    type: "area",
	                    autoComplete: "off",
	                    ref: txtDirClient,
	                    disabled: habilitado,
	                    name: "direccion",
	                    className: "form-control text-uppercase fs-6",
	                    onChange: onChange,
	                    "aria-label": "Sizing example input",
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    style: { height: 40 }
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-240 px-2" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "ESTADO:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: txtEstado,
	                      disabled: habilitado,
	                      onChange: onChangeCliente,
	                      name: "estado",
	                      idciudad: "estado",
	                      className: "form-select form-select-sm",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "SELECCIONE"
	                    ),
	                    estados && estados.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idestado },
	                        item.nombre
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "MUNICIPIO:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: txtMunicipio,
	                      disabled: habilitado,
	                      onChange: onChangeCliente,
	                      name: "municipio",
	                      id: "municipio",
	                      className: "form-select form-select-sm",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "SELECCIONE"
	                    ),
	                    municipios && municipios.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idmunicipio },
	                        item.nombre
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-3" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CIUDAD:"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: txtCiudad,
	                      disabled: habilitado,
	                      name: "ciudad",
	                      id: "ciudad",
	                      className: "form-select form-select-sm",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "SELECCIONE"
	                    ),
	                    ciudades && ciudades.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idciudad },
	                        item.nombre
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-200 px-2 ml-auto" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text px-1",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CELULAR:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    maxLength: 11,
	                    ref: txtTlf2Client,
	                    disabled: habilitado,
	                    className: "form-control px-1 fs-6",
	                    name: "tlf2",
	                    "aria-label": "Sizing example input",
	                    onChange: onChange,
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: handleInputNumChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "EMAIL:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    ref: txtEmailClient,
	                    disabled: habilitado,
	                    className: "form-control text-uppercase fs-6",
	                    name: "correoe",
	                    "aria-label": "Sizing example input",
	                    onChange: onChange,
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-210 px-1" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text px-1",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TELEFONO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    maxLength: 11,
	                    ref: txtTlf1Client,
	                    disabled: habilitado,
	                    className: "form-control px-1 fs-6",
	                    name: "tlf1",
	                    "aria-label": "Sizing example input",
	                    onChange: onChange,
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: handleInputNumChange
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12", style: { fontSizeAdjust: "0.6" } },
	              _react2.default.createElement(
	                "fieldset",
	                { className: " row col-sm-12 mx-auto border-azul rounded" },
	                _react2.default.createElement(
	                  "legend",
	                  {
	                    className: "float-none w-auto fw-bold",
	                    style: { fontSize: "15px" }
	                  },
	                  "Responsable"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-270 px-2" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "CEDULA:"
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        ref: cmbNacionalidad,
	                        name: "nacionalidad",
	                        className: "form-select form-select-sm col-3 px-2",
	                        disabled: habilitado,
	                        "aria-label": ".form-select-sm example",
	                        onChange: onChange
	                      },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "" },
	                        "--"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "V" },
	                        "V"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "E" },
	                        "E"
	                      )
	                    ),
	                    _react2.default.createElement("input", {
	                      ref: txtCedRes,
	                      maxLength: 8,
	                      autoComplete: "off",
	                      type: "text",
	                      disabled: habilitado,
	                      className: "form-control fs-6 col-7 px-1",
	                      name: "cedula",
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm",
	                      onKeyUp: validarPersona,
	                      onBlur: validarPersona,
	                      onChange: onChange
	                    }),
	                    _react2.default.createElement(
	                      "button",
	                      {
	                        disabled: botones.catalogoper,
	                        type: "button",
	                        onClick: function onClick() {
	                          return setCatalogoPersona(true);
	                        },
	                        className: "btn btn-success"
	                      },
	                      _react2.default.createElement("i", { className: "fas fa-search" })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-140 ml-auto" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "SEXO:"
	                    ),
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        ref: cmbSexo,
	                        className: "form-select form-select-sm",
	                        name: "sexo",
	                        disabled: habilitadoNU,
	                        onChange: onChange,
	                        "aria-label": ".form-select-sm example"
	                      },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "" },
	                        "--"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "M" },
	                        "M"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "F" },
	                        "F"
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-pd-340 ml-auto px-2" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm mb-2" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "input-group-text",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "FECHA DE NACIMIENTO"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "date",
	                      ref: txtFechaNac,
	                      max: fechaTope,
	                      className: "form-control text-center fs-6 px-1 text-uppercase",
	                      name: "fnacimiento",
	                      "aria-label": "Sizing example input",
	                      onChange: onChange,
	                      disabled: habilitadoNU,
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-6" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "NOMBRES:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    ref: txtNomResp,
	                    name: "nombres",
	                    className: "form-control text-uppercase fs-6",
	                    onChange: onChange,
	                    "aria-label": "Sizing example input",
	                    disabled: habilitadoNU,
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-6" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "APELLIDOS:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    ref: txtApeResp,
	                    name: "apellidos",
	                    className: "form-control text-uppercase fs-6",
	                    onChange: onChange,
	                    "aria-label": "Sizing example input",
	                    disabled: habilitadoNU,
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-12" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "DIRECCION:"
	                  ),
	                  _react2.default.createElement("textarea", {
	                    type: "area",
	                    autoComplete: "off",
	                    ref: txtDireccion,
	                    name: "direccion",
	                    className: "form-control text-uppercase fs-6",
	                    onChange: onChange,
	                    "aria-label": "Sizing example input",
	                    disabled: habilitadoNU,
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    style: { height: 40 }
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-md-4" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "EMAIL:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    ref: txtEmail,
	                    className: "form-control text-uppercase fs-6",
	                    name: "correoe",
	                    "aria-label": "Sizing example input",
	                    onChange: onChange,
	                    disabled: habilitadoNU,
	                    "aria-describedby": "inputGroup-sizing-sm"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-210 px-1" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text px-1",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "TELEFONO:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    maxLength: 11,
	                    ref: txtTlf1,
	                    className: "form-control px-1 fs-6",
	                    name: "tlf1",
	                    "aria-label": "Sizing example input",
	                    onChange: onChange,
	                    disabled: habilitadoNU,
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: handleInputNumChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group input-group-sm mb-2 col-pd-210" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "input-group-text px-1",
	                      id: "inputGroup-sizing-sm"
	                    },
	                    "CELULAR:"
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    autoComplete: "off",
	                    maxLength: 11,
	                    ref: txtTlf2,
	                    className: "form-control px-1 fs-6",
	                    name: "tlf2",
	                    "aria-label": "Sizing example input",
	                    onChange: onChange,
	                    disabled: habilitadoNU,
	                    "aria-describedby": "inputGroup-sizing-sm",
	                    onKeyUp: handleInputNumChange
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 py-1" },
	              visibleBtn === 0 ? _react2.default.createElement(
	                "div",
	                { className: "col-pd-botones" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 row m-0" },
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: botones.incluir,
	                      onClick: onBotones(1),
	                      className: "btn btn-sm col ml-1 mb-1 btn-primary rounded-pill",
	                      title: "Incluir Almacen"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-plus" },
	                      " Incluir "
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: botones.consultar,
	                      onClick: onBotones(4),
	                      className: "btn btn-sm col ml-1 mb-1 btn-info rounded-pill",
	                      title: "Consultar Almacen"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fas fa-eye" },
	                      " Consultar"
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: botones.modificar,
	                      onClick: onBotones(2),
	                      className: "btn btn-sm col ml-1 mb-1 btn-warning rounded-pill",
	                      title: "Modificar Almacen"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-edit" },
	                      " Modificar"
	                    ),
	                    " "
	                  ),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      disabled: botones.eliminar,
	                      onClick: onBotones(3),
	                      className: "btn btn-sm col ml-1 mb-1 btn-danger rounded-pill",
	                      title: "Eliminar Almacen"
	                    },
	                    _react2.default.createElement(
	                      "i",
	                      { className: "fa fa-trash" },
	                      " Eliminar"
	                    ),
	                    " "
	                  )
	                )
	              ) : _react2.default.createElement(
	                "div",
	                { className: "col-pd-botonesd row m-0 ml-auto" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnAcepta,
	                    disabled: acept,
	                    onClick: onBotones(5),
	                    className: "btn btn-sm col ml-1 rounded-pill btn-success"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-check-circle" },
	                    " Aceptar"
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    ref: btnCancela,
	                    disabled: botones.cancelar,
	                    onClick: onBotones(6),
	                    className: "btn btn-danger col ml-1 btn-sm rounded-pill"
	                  },
	                  _react2.default.createElement(
	                    "i",
	                    { className: "fas fa-window-close" },
	                    " Cancelar"
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-3 oculto mt-4" },
	          _react2.default.createElement(_cartasProveedor2.default, {
	            totalr: totalr,
	            totalact: totalact,
	            totalinc: totalinc,
	            titulo: titulo
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: catalogoCliente,
	      nomid: "proveedor",
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoCliente(false);
	      },
	      onHideAceptaCatalogo: onCatalogoCliente
	    }),
	    _react2.default.createElement(_catalogoPersona2.default, {
	      show: catalogoPersona,
	      onHideCancelaCatPer: function onHideCancelaCatPer() {
	        return setCatalogoPersona(false);
	      },
	      onHideAceptaCatPer: onCatalogoPersona
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return mensaje.titulo === "Exito." ? blanquear() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = TablaProveedor;

/***/ },
/* 7183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _core = __webpack_require__(19);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _mensajes = __webpack_require__(9);
	
	var _varios = __webpack_require__(14);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _catalogoCliente = __webpack_require__(32);
	
	var _catalogoCliente2 = _interopRequireDefault(_catalogoCliente);
	
	var _catalogoPersona = __webpack_require__(64);
	
	var _catalogoPersona2 = _interopRequireDefault(_catalogoPersona);
	
	var _cartasProveedor = __webpack_require__(303);
	
	var _cartasProveedor2 = _interopRequireDefault(_cartasProveedor);
	
	var _catalogoAlmacen = __webpack_require__(51);
	
	var _catalogoAlmacen2 = _interopRequireDefault(_catalogoAlmacen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TablaVendedores = function TablaVendedores() {
	  var op = __webpack_require__(8);
	  var token = sessionStorage.getItem("jwtToken");
	  var anio = JSON.parse(sessionStorage.getItem("anioactu"));
	  var idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
	  var accbtnvendedor = JSON.parse(sessionStorage.getItem("accbtnvendedorc"));
	  var muni = "";
	  var ciu = "";
	
	  var headCells = [{
	    id: "1",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "CODIGO",
	    textAlign: "center"
	  }, {
	    id: "2",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "NOMBRE",
	    textAlign: "center"
	  }, {
	    id: "3",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: "RIF",
	    textAlign: "center"
	  }, {
	    id: "opciones",
	    backgroundColor: "rgba(5, 81, 130, 1)",
	    color: "#ffffff",
	    label: " OPCIONES",
	    textAlign: "center"
	  }];
	
	  var fechaTope = (0, _moment2.default)(JSON.parse(sessionStorage.getItem("fechasistema"))).format("YYYY-MM-DD").replace(anio.toString(), (anio - 18).toString());
	
	  var txtBuscador = (0, _react.useRef)();
	  var btnCancela = (0, _react.useRef)();
	  var btnAcepta = (0, _react.useRef)();
	  var chkNatural = (0, _react.useRef)();
	  var chkJuridico = (0, _react.useRef)();
	  var txtId = (0, _react.useRef)();
	  var cmbRif = (0, _react.useRef)();
	  var txtRif = (0, _react.useRef)();
	  var txtRazon = (0, _react.useRef)();
	  var txtDirClient = (0, _react.useRef)();
	  var txtEmailClient = (0, _react.useRef)();
	  var txtTlf1Client = (0, _react.useRef)();
	  var txtTlf2Client = (0, _react.useRef)();
	  var txtEstado = (0, _react.useRef)();
	  var txtMunicipio = (0, _react.useRef)();
	  var txtCiudad = (0, _react.useRef)();
	
	  var txtCodAlmacen = (0, _react.useRef)();
	  var txtDescripcion = (0, _react.useRef)();
	
	  var txtpreciomaxventa = (0, _react.useRef)();
	  var txtprecioofventa = (0, _react.useRef)();
	  var txtpreciomayventa = (0, _react.useRef)();
	  var txtpreciominventa = (0, _react.useRef)();
	  var txtdebajominventa = (0, _react.useRef)();
	  var txtpreciomaxservi = (0, _react.useRef)();
	  var txtprecioofservi = (0, _react.useRef)();
	  var txtpreciomayservi = (0, _react.useRef)();
	  var txtpreciominservi = (0, _react.useRef)();
	  var txtdebajominservi = (0, _react.useRef)();
	  var txtpreciomaxcob = (0, _react.useRef)();
	  var txtprecioofcob = (0, _react.useRef)();
	  var txtpreciomaycob = (0, _react.useRef)();
	  var txtdebajomincob = (0, _react.useRef)();
	  var txtservimincob = (0, _react.useRef)();
	  var txtgeneralcob = (0, _react.useRef)();
	
	  var cmbNacionalidad = (0, _react.useRef)();
	  var txtCedRes = (0, _react.useRef)();
	  var cmbSexo = (0, _react.useRef)();
	  var txtFechaNac = (0, _react.useRef)();
	  var txtNomResp = (0, _react.useRef)();
	  var txtApeResp = (0, _react.useRef)();
	  var txtDireccion = (0, _react.useRef)();
	  var txtEmail = (0, _react.useRef)();
	  var txtTlf1 = (0, _react.useRef)();
	  var txtTlf2 = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      body = _useState2[0],
	      setBody = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      registrado = _useState4[0],
	      setRegistrado = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(true),
	      _useState6 = _slicedToArray(_useState5, 2),
	      habilitado = _useState6[0],
	      setHabilitado = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      catalogoPersona = _useState8[0],
	      setCatalogoPersona = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      catalogoCliente = _useState10[0],
	      setCatalogoCliente = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      catalogoUsuario = _useState12[0],
	      setCatalogoUsuario = _useState12[1];
	
	  var _useState13 = (0, _react.useState)("visible"),
	      _useState14 = _slicedToArray(_useState13, 2),
	      visibleBtn = _useState14[0],
	      setVisibleBtn = _useState14[1];
	
	  var _useState15 = (0, _react.useState)("Gestionar Vendedores."),
	      _useState16 = _slicedToArray(_useState15, 2),
	      tituloHeader = _useState16[0],
	      setTituloHeader = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(0),
	      _useState18 = _slicedToArray(_useState17, 2),
	      totalr = _useState18[0],
	      setTotalr = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      totalact = _useState20[0],
	      setTotalact = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(0),
	      _useState22 = _slicedToArray(_useState21, 2),
	      totalinc = _useState22[0],
	      setTotalinc = _useState22[1];
	
	  var _useState23 = (0, _react.useState)(""),
	      _useState24 = _slicedToArray(_useState23, 2),
	      titulo = _useState24[0],
	      setTitulo = _useState24[1];
	
	  var _useState25 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState26 = _slicedToArray(_useState25, 2),
	      mensaje = _useState26[0],
	      setMensaje = _useState26[1];
	
	  var _useState27 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState28 = _slicedToArray(_useState27, 2),
	      mensajesino = _useState28[0],
	      setMensajesino = _useState28[1];
	
	  var _useState29 = (0, _react.useState)(false),
	      _useState30 = _slicedToArray(_useState29, 2),
	      activate = _useState30[0],
	      setActivate = _useState30[1];
	
	  var _useState31 = (0, _react.useState)("Cédula:"),
	      _useState32 = _slicedToArray(_useState31, 2),
	      titleCed = _useState32[0],
	      setTitleCed = _useState32[1];
	
	  var _useState33 = (0, _react.useState)([{ value: "V" }, { value: "E" }]),
	      _useState34 = _slicedToArray(_useState33, 2),
	      cmbCedula = _useState34[0],
	      setCmbCedula = _useState34[1];
	
	  var _useState35 = (0, _react.useState)([]),
	      _useState36 = _slicedToArray(_useState35, 2),
	      estados = _useState36[0],
	      setEstados = _useState36[1];
	
	  var _useState37 = (0, _react.useState)([]),
	      _useState38 = _slicedToArray(_useState37, 2),
	      municipios = _useState38[0],
	      setMunicipios = _useState38[1];
	
	  var _useState39 = (0, _react.useState)([]),
	      _useState40 = _slicedToArray(_useState39, 2),
	      ciudades = _useState40[0],
	      setCiudades = _useState40[1];
	
	  var _useState41 = (0, _react.useState)([]),
	      _useState42 = _slicedToArray(_useState41, 2),
	      records = _useState42[0],
	      setRecords = _useState42[1];
	
	  var _useState43 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState44 = _slicedToArray(_useState43, 2),
	      filterFn = _useState44[0],
	      setFilterFn = _useState44[1];
	
	  var _useState45 = (0, _react.useState)(true),
	      _useState46 = _slicedToArray(_useState45, 2),
	      habilitadoNU = _useState46[0],
	      setHabilitadoNU = _useState46[1];
	
	  var _useState47 = (0, _react.useState)(0),
	      _useState48 = _slicedToArray(_useState47, 2),
	      operacionPer = _useState48[0],
	      setOperacionPer = _useState48[1];
	
	  var _useState49 = (0, _react.useState)(""),
	      _useState50 = _slicedToArray(_useState49, 2),
	      tipoAgente = _useState50[0],
	      setTipoAgente = _useState50[1];
	
	  var _useState51 = (0, _react.useState)(false),
	      _useState52 = _slicedToArray(_useState51, 2),
	      catalogoAlmacen = _useState52[0],
	      setCatalogoAlmacen = _useState52[1];
	
	  var _useState53 = (0, _react.useState)({
	    incluir: false,
	    consultar: false,
	    modificar: false,
	    eliminar: false,
	    aceptar: true,
	    cancelar: true,
	    catalogo: true,
	    catalogoper: true,
	    tab1: true,
	    tab2: true
	  }),
	      _useState54 = _slicedToArray(_useState53, 2),
	      botones = _useState54[0],
	      setBotones = _useState54[1];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting,
	      TblPagination = _useTable.TblPagination;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") return items;else return items.filter(function (x) {
	          if (x.idagente.includes(target.value) || x.nombre.toLowerCase().includes(target.value.toLowerCase()) || x.rif.toLowerCase().includes(target.value.toLowerCase())) {
	            return x;
	          }
	        });
	      }
	    });
	  };
	
	  var handleInputNumChange = function handleInputNumChange(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	
	    if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false; //alert(e.which);
	  };
	
	  var handleInputMontoChange = function handleInputMontoChange(event) {
	    (0, _varios.validaMonto)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
	        event.target.value = "0,00";
	      }
	      event.target.value = (0, _varios.formatoMonto)(event.target.value);
	      var char1 = event.target.value.substring(0, 1);
	      var char2 = event.target.value.substring(1, 2);
	      if (char1 === "0" && char2 !== ",") {
	        event.target.value = event.target.value.substring(1, event.target.value.legth);
	      }
	    } else if (event.which === 46) {
	      return false;
	    } else if (event.which >= 48 && event.which <= 57) {
	      return true;
	    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
	      return true;
	    } else return false;
	  };
	
	  var datosRes = function datosRes() {
	    var campos = "*";
	    var nomtab = "persona";
	    var nomid = "cedula";
	    var nomid2 = "nacionalidad";
	    var id = txtCedRes.current.value;
	    var id2 = cmbNacionalidad.current.value;
	    var endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=" + id2;
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        cmbSexo.current.value = "";
	        txtFechaNac.current.value = "";
	        txtNomResp.current.value = "";
	        txtApeResp.current.value = "";
	        txtDireccion.current.value = "";
	        txtEmail.current.value = "";
	        txtTlf1.current.value = "";
	        txtTlf2.current.value = "";
	
	        if (response.data !== "") {
	          setHabilitadoNU(true);
	          setOperacionPer(0);
	          cmbSexo.current.value = response.data.sexo;
	          txtFechaNac.current.value = (0, _moment2.default)(response.data.fnacimiento).format("YYYY-MM-DD");
	          txtNomResp.current.value = response.data.nombres;
	          txtApeResp.current.value = response.data.apellidos;
	          txtDireccion.current.value = response.data.direccion;
	          txtEmail.current.value = response.data.correoe;
	          txtTlf1.current.value = response.data.tlf1;
	          txtTlf2.current.value = response.data.tlf2;
	          if (!botones.consultar) {
	            btnCancela.current.focus();
	          } else {
	            btnAcepta.current.focus();
	          }
	        } else {
	          txtNomResp.current.focus();
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe una persona con este N° de cedula porfavor registre sus datos",
	            icono: "informacion"
	          });
	          setOperacionPer(1);
	          setHabilitadoNU(false);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "*";
	    var nomtab = "estado";
	    var orden = "idestado";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setEstados(response.data);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var selectMunicipios = function selectMunicipios(id) {
	    var campos = "*";
	    var nomtab = "municipio";
	    var nomid = "idestado";
	    var endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&id=" + id + "&nomtab=" + nomtab + "&nomid=" + nomid;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setMunicipios(response.data);
	        if (registrado || !botones.consultar || !botones.modificar || !botones.eliminar) {
	          txtMunicipio.current.value = muni;
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var selectCiudad = function selectCiudad(id) {
	    var campos = "*";
	    var nomtab = "ciudad";
	    var nomid = "idmunicipio";
	    var endpoint = op.conexion + "/api/consulta/modelirows?campos=" + campos + "&id=" + id + "&nomtab=" + nomtab + "&nomid=" + nomid;
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setCiudades(response.data);
	        if (registrado || !botones.consultar || !botones.modificar || !botones.eliminar) {
	          txtCiudad.current.value = ciu;
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var seleccionarRegistro = function seleccionarRegistro(rif) {
	    var campos = "*";
	    var nomtab = "agente";
	    var nomid = "rif";
	    var nomid2 = "vendedor";
	    var id = rif;
	    var endpoint = "";
	
	    if (!botones.incluir) {
	      endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	    } else {
	      endpoint = op.conexion + "/api/consulta/modeli2?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id + "&nomid2=" + nomid2 + "&id2=true";
	    }
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        txtId.current.value = 0;
	        txtRazon.current.value = "";
	        txtDirClient.current.value = "";
	        cmbNacionalidad.current.value = "";
	        txtCedRes.current.value = "";
	        txtTlf1Client.current.value = "";
	        txtTlf2Client.current.value = "";
	        txtEmailClient.current.value = "";
	        txtEstado.current.value = "";
	        txtMunicipio.current.value = "";
	        txtCiudad.current.value = "";
	        txtpreciomaxventa.current.value = "0,00";
	        txtprecioofventa.current.value = "0,00";
	        txtpreciomayventa.current.value = "0,00";
	        txtpreciominventa.current.value = "0,00";
	        txtdebajominventa.current.value = "0,00";
	        txtpreciomaxservi.current.value = "0,00";
	        txtprecioofservi.current.value = "0,00";
	        txtpreciomayservi.current.value = "0,00";
	        txtpreciominservi.current.value = "0,00";
	        txtdebajominservi.current.value = "0,00";
	        txtpreciomaxcob.current.value = "0,00";
	        txtprecioofcob.current.value = "0,00";
	        txtpreciomaycob.current.value = "0,00";
	        txtdebajomincob.current.value = "0,00";
	        txtservimincob.current.value = "0,00";
	        txtgeneralcob.current.value = "0,00";
	        txtDescripcion.current.value = "";
	
	        txtCedRes.current.value = "";
	        cmbSexo.current.value = "";
	        txtFechaNac.current.value = "";
	        txtNomResp.current.value = "";
	        txtApeResp.current.value = "";
	        txtDireccion.current.value = "";
	        txtEmail.current.value = "";
	        txtTlf1.current.value = "";
	        txtTlf2.current.value = "";
	
	        setRecords([]);
	
	        if (response.data !== "") {
	          setOperacionPer(0);
	
	          if (!botones.incluir) {
	            setRegistrado(true);
	          } else {
	            setRegistrado(false);
	          }
	
	          txtId.current.value = response.data.idagente;
	          txtRazon.current.value = response.data.nombre.trim();
	          txtDirClient.current.value = response.data.direccion.trim();
	          chkNatural.current.checked = response.data.tipoper === 0 ? true : false;
	          cmbRif.current.value = response.data.rif.trim().substring(0, 1);
	          txtRif.current.value = response.data.rif.trim().substring(1, 10);
	          txtTlf1Client.current.value = response.data.telefono;
	          txtTlf2Client.current.value = response.data.celular;
	          txtEmailClient.current.value = response.data.email !== null ? response.data.email.trim() : "";
	          txtEstado.current.value = response.data.estado.trim();
	          txtpreciomaxventa.current.value = (0, _varios.formatMoneda)(response.data.preciomaxventa.toString().replace(".", ","), ",", ".", 2);
	          txtprecioofventa.current.value = (0, _varios.formatMoneda)(response.data.precioofventa.toString().replace(".", ","), ",", ".", 2);
	          txtpreciomayventa.current.value = (0, _varios.formatMoneda)(response.data.preciomayventa.toString().replace(".", ","), ",", ".", 2);
	          txtpreciominventa.current.value = (0, _varios.formatMoneda)(response.data.preciominventa.toString().replace(".", ","), ",", ".", 2);
	          txtdebajominventa.current.value = (0, _varios.formatMoneda)(response.data.debajominventa.toString().replace(".", ","), ",", ".", 2);
	
	          txtpreciomaxservi.current.value = (0, _varios.formatMoneda)(response.data.preciomaxservi.toString().replace(".", ","), ",", ".", 2);
	          txtprecioofservi.current.value = (0, _varios.formatMoneda)(response.data.precioofservi.toString().replace(".", ","), ",", ".", 2);
	          txtpreciomayservi.current.value = (0, _varios.formatMoneda)(response.data.preciomayservi.toString().replace(".", ","), ",", ".", 2);
	          txtpreciominservi.current.value = (0, _varios.formatMoneda)(response.data.preciominservi.toString().replace(".", ","), ",", ".", 2);
	          txtdebajominservi.current.value = (0, _varios.formatMoneda)(response.data.debajominservi.toString().replace(".", ","), ",", ".", 2);
	
	          txtpreciomaxcob.current.value = (0, _varios.formatMoneda)(response.data.preciomaxcob.toString().replace(".", ","), ",", ".", 2);
	          txtprecioofcob.current.value = (0, _varios.formatMoneda)(response.data.precioofcob.toString().replace(".", ","), ",", ".", 2);
	          txtpreciomaycob.current.value = (0, _varios.formatMoneda)(response.data.preciomaycob.toString().replace(".", ","), ",", ".", 2);
	          txtdebajomincob.current.value = (0, _varios.formatMoneda)(response.data.debajomincob.toString().replace(".", ","), ",", ".", 2);
	          txtservimincob.current.value = (0, _varios.formatMoneda)(response.data.servimincob.toString().replace(".", ","), ",", ".", 2);
	          txtgeneralcob.current.value = (0, _varios.formatMoneda)(response.data.generalcob.toString().replace(".", ","), ",", ".", 2);
	
	          cmbNacionalidad.current.value = response.data.reprelegal.trim().substring(0, 1);
	          txtCedRes.current.value = response.data.reprelegal.trim().substring(1, 12);
	          txtCodAlmacen.current.value = response.data.idalmacen;
	
	          muni = response.data.municipio.trim();
	          ciu = response.data.ciudad.trim();
	
	          selectMunicipios(response.data.estado.trim());
	          selectCiudad(response.data.municipio.trim());
	          datosRes();
	          cargarClientes(response.data.idagente);
	          seleccionarAlmacen(response.data.idalmacen);
	
	          if (!botones.modificar) {
	            setBotones(Object.assign({}, botones, { catalogoper: false }));
	          }
	        } else {
	          txtRazon.current.focus();
	          if (botones.incluir) {
	            setMensaje({
	              mostrar: true,
	              titulo: "Notificación",
	              texto: "No existe un vendedor con este codigo",
	              icono: "informacion"
	            });
	          }
	
	          txtId.current.value = 0;
	          txtRazon.current.value = "";
	          txtDirClient.current.value = "";
	          cmbNacionalidad.current.value = "";
	          txtCedRes.current.value = "";
	          txtTlf1Client.current.value = "";
	          txtTlf2Client.current.value = "";
	          txtEmailClient.current.value = "";
	          txtEstado.current.value = "";
	          txtMunicipio.current.value = "";
	          txtCiudad.current.value = "";
	          txtCedRes.current.value = "";
	          cmbSexo.current.value = "";
	          txtFechaNac.current.value = "";
	          txtNomResp.current.value = "";
	          txtApeResp.current.value = "";
	          txtDireccion.current.value = "";
	          txtEmail.current.value = "";
	          txtTlf1.current.value = "";
	          txtTlf2.current.value = "";
	
	          txtpreciomaxventa.current.value = "0,00";
	          txtprecioofventa.current.value = "0,00";
	          txtpreciomayventa.current.value = "0,00";
	          txtpreciominventa.current.value = "0,00";
	          txtdebajominventa.current.value = "0,00";
	          txtpreciomaxservi.current.value = "0,00";
	          txtprecioofservi.current.value = "0,00";
	          txtpreciomayservi.current.value = "0,00";
	          txtpreciominservi.current.value = "0,00";
	          txtdebajominservi.current.value = "0,00";
	          txtpreciomaxcob.current.value = "0,00";
	          txtprecioofcob.current.value = "0,00";
	          txtpreciomaycob.current.value = "0,00";
	          txtdebajomincob.current.value = "0,00";
	          txtservimincob.current.value = "0,00";
	          txtgeneralcob.current.value = "0,00";
	
	          setRecords([]);
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var blanquear = function blanquear() {
	    setTituloHeader("Gestionar Vendedores.");
	    setVisibleBtn("visible");
	    setActivate(false);
	    setBody(null);
	    setRegistrado(false);
	    setOperacionPer(0);
	    setHabilitado(true);
	    setHabilitadoNU(true);
	    setMunicipios([]);
	    setCiudades([]);
	    setRecords([]);
	    setTitleCed("Cédula:");
	    setCmbCedula([{ value: "V" }, { value: "E" }]);
	    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	    setBotones({
	      incluir: false,
	      consultar: false,
	      modificar: false,
	      eliminar: false,
	      aceptar: true,
	      cancelar: true,
	      catalogo: true,
	      catalogoper: true,
	      tab1: true,
	      tab2: true
	    });
	    chkNatural.current.checked = true;
	    cmbRif.current.value = "";
	    txtRif.current.value = "";
	    txtId.current.value = 0;
	    txtRazon.current.value = "";
	    txtDirClient.current.value = "";
	    txtTlf1Client.current.value = "";
	    txtTlf2Client.current.value = "";
	    txtEmailClient.current.value = "";
	    txtEstado.current.value = "";
	    txtMunicipio.current.value = "";
	    txtCiudad.current.value = "";
	    txtpreciomaxventa.current.value = "0,00";
	    txtprecioofventa.current.value = "0,00";
	    txtpreciomayventa.current.value = "0,00";
	    txtpreciominventa.current.value = "0,00";
	    txtdebajominventa.current.value = "0,00";
	    txtpreciomaxservi.current.value = "0,00";
	    txtprecioofservi.current.value = "0,00";
	    txtpreciomayservi.current.value = "0,00";
	    txtpreciominservi.current.value = "0,00";
	    txtdebajominservi.current.value = "0,00";
	    txtpreciomaxcob.current.value = "0,00";
	    txtprecioofcob.current.value = "0,00";
	    txtpreciomaycob.current.value = "0,00";
	    txtdebajomincob.current.value = "0,00";
	    txtservimincob.current.value = "0,00";
	    txtgeneralcob.current.value = "0,00";
	
	    txtCodAlmacen.current.value = "";
	    txtDescripcion.current.value = "";
	
	    cmbRif.current.setAttribute("disabled", "disabled");
	    txtRif.current.setAttribute("disabled", "disabled");
	    chkNatural.current.setAttribute("disabled", "disabled");
	    chkJuridico.current.setAttribute("disabled", "disabled");
	
	    cmbNacionalidad.current.value = "";
	    txtCedRes.current.value = "";
	    cmbSexo.current.value = "";
	    txtFechaNac.current.value = "";
	    txtNomResp.current.value = "";
	    txtApeResp.current.value = "";
	    txtDireccion.current.value = "";
	    txtEmail.current.value = "";
	    txtTlf1.current.value = "";
	    txtTlf2.current.value = "";
	  };
	
	  var onChangeValidar = function onChangeValidar() {
	    var sigue = true;
	    if (!botones.incluir || !botones.modificar) {
	      if (txtCedRes.current.value === "") {
	        setMensaje({
	          mostrar: true,
	          titulo: "Notificación",
	          texto: "Debe ingresar la cedula el responsable",
	          icono: "informacion"
	        });
	        txtCedRes.current.focus();
	        sigue = false;
	      } else if (operacionPer === 1) {
	        if (cmbNacionalidad.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe seleccionar la nacionalidad del responsable",
	            icono: "informacion"
	          });
	          cmbNacionalidad.current.focus();
	          sigue = false;
	        } else if (cmbSexo.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe seleccionar el Sexo del responsable",
	            icono: "informacion"
	          });
	          cmbSexo.current.focus();
	          sigue = false;
	        } else if (txtFechaNac.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar fecha nacimiento del responsable",
	            icono: "informacion"
	          });
	          txtFechaNac.current.focus();
	          sigue = false;
	        } else if (txtNomResp.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar el nombre del responsable",
	            icono: "informacion"
	          });
	          txtNomResp.current.focus();
	          sigue = false;
	        } else if (txtApeResp.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar el apellido del responsable",
	            icono: "informacion"
	          });
	          txtApeResp.current.focus();
	          sigue = false;
	        } else if (txtDireccion.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar la dirección del responsable",
	            icono: "informacion"
	          });
	          txtDireccion.current.focus();
	          sigue = false;
	        } else if (txtEmail.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar el correo del responsable",
	            icono: "informacion"
	          });
	          txtEmail.current.focus();
	          sigue = false;
	        } else if (txtTlf1.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar el Telefono del responsable",
	            icono: "informacion"
	          });
	          txtTlf1.current.focus();
	          sigue = false;
	        } else if (txtTlf2.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar el Celular del responsable",
	            icono: "informacion"
	          });
	          txtTlf2.current.focus();
	          sigue = false;
	        } else if (txtCodAlmacen.current.value === "") {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "Debe ingresar el codigo del almacen",
	            icono: "informacion"
	          });
	          txtCodAlmacen.current.focus();
	          sigue = false;
	        }
	      }
	    }
	
	    var client = [];
	
	    for (var i = 0; i < records.length; i++) {
	      client.push({
	        idcliente: parseInt(records[i].idagente),
	        idvendedor: parseInt(txtId.current.value)
	      });
	    }
	
	    if (sigue) {
	      var cliente = [];
	      var repre = [];
	      cliente.push({
	        idagente: txtId.current.value,
	        nombre: txtRazon.current.value.toUpperCase().trim(),
	        direccion: txtDirClient.current.value.toUpperCase().trim(),
	        tipoper: chkNatural.current.checked ? 0 : 1,
	        rif: cmbRif.current.value + txtRif.current.value,
	        reprelegal: cmbNacionalidad.current.value + txtCedRes.current.value,
	        telefono: txtTlf1Client.current.value,
	        celular: txtTlf2Client.current.value,
	        email: txtEmailClient.current.value.toUpperCase().trim(),
	        vendedor: true,
	        statusvendedor: "51",
	        estado: txtEstado.current.value.trim(),
	        municipio: txtMunicipio.current.value.trim(),
	        idalmacen: txtCodAlmacen.current.value,
	        ciudad: txtCiudad.current.value.trim(),
	
	        preciomaxventa: txtpreciomaxventa.current.value.replace(/\./g, "").replace(",", "."),
	        precioofventa: txtprecioofventa.current.value.replace(/\./g, "").replace(",", "."),
	        preciomayventa: txtpreciomayventa.current.value.replace(/\./g, "").replace(",", "."),
	        preciominventa: txtpreciominventa.current.value.replace(/\./g, "").replace(",", "."),
	        debajominventa: txtdebajominventa.current.value.replace(/\./g, "").replace(",", "."),
	        preciomaxservi: txtpreciomaxservi.current.value.replace(/\./g, "").replace(",", "."),
	        precioofservi: txtprecioofservi.current.value.replace(/\./g, "").replace(",", "."),
	        preciomayservi: txtpreciomayservi.current.value.replace(/\./g, "").replace(",", "."),
	        preciominservi: txtpreciominservi.current.value.replace(/\./g, "").replace(",", "."),
	        debajominservi: txtdebajominservi.current.value.replace(/\./g, "").replace(",", "."),
	        preciomaxcob: txtpreciomaxcob.current.value.replace(/\./g, "").replace(",", "."),
	        precioofcob: txtprecioofcob.current.value.replace(/\./g, "").replace(",", "."),
	        preciomaycob: txtpreciomaycob.current.value.replace(/\./g, "").replace(",", "."),
	        debajomincob: txtdebajomincob.current.value.replace(/\./g, "").replace(",", "."),
	        servimincob: txtservimincob.current.value.replace(/\./g, "").replace(",", "."),
	        generalcob: txtgeneralcob.current.value.replace(/\./g, "").replace(",", ".")
	      });
	      repre.push({
	        cedula: parseInt(txtCedRes.current.value),
	        correoe: txtEmail.current.value.toUpperCase().trim(),
	        tlf1: txtTlf1.current.value.trim(),
	        tlf2: txtTlf2.current.value.trim(),
	        apellidos: txtApeResp.current.value.toUpperCase().trim(),
	        direccion: txtDireccion.current.value.toUpperCase().trim(),
	        fnacimiento: txtFechaNac.current.value.trim(),
	        nacionalidad: cmbNacionalidad.current.value.trim(),
	        nombres: txtNomResp.current.value.toUpperCase().trim(),
	        sexo: cmbSexo.current.value.trim()
	      });
	
	      setBody({
	        operacionper: operacionPer,
	        agente: cliente,
	        repre: repre,
	        client: client
	      });
	
	      var msg = "";
	      if (!botones.incluir) {
	        msg = "Esta Seguro de Registrar estos Datos.";
	      } else if (!botones.modificar) {
	        msg = "Esta Seguro de Modificar estos Datos.";
	      } else if (!botones.eliminar) {
	        msg = "Esta Seguro de Eliminar estos Datos.";
	      }
	
	      setMensajesino({
	        mostrar: true,
	        titulo: "Confirmación.",
	        texto: msg,
	        icono: "confirmacion"
	      });
	    }
	  };
	
	  var procesarRegistro = function procesarRegistro() {
	    setActivate(true);
	    var ope = 0;
	    if (!botones.incluir) {
	      ope = 1;
	    } else if (!botones.modificar) {
	      ope = 2;
	    } else if (!botones.eliminar) {
	      ope = 3;
	    }
	    var endpoint = op.conexion + "/api/agente/actualizar/" + (registrado ? 2 : ope);
	    _axios2.default.post(endpoint, body, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (ope === 1) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro creado correctamente",
	            icono: "exito"
	          });
	        } else if (ope === 2) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro modificado correctamente",
	            icono: "exito"
	          });
	        } else if (ope === 3) {
	          setMensaje({
	            mostrar: true,
	            titulo: "Exito.",
	            texto: "registro eliminado correctamente",
	            icono: "exito"
	          });
	        }
	
	        ContarRegistros();
	        seleccionarActivos();
	        seleccionarInactivos();
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      var mensaje = "";
	      if (error.response === undefined) {
	        mensaje = "Error de Conexion";
	      } else {
	        if (error.response.data.message === 'duplicate key value violates unique constraint "agente_rif_key"') {
	          mensaje = "Ya existe un Registro con este rif";
	        } else if (error.response.data.message === 'duplicate key value violates unique constraint "agente_email_key"') {
	          mensaje = "Ya existe un Registro con este correo";
	        } else {
	          mensaje = error.response.data.message;
	        }
	      }
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: mensaje,
	        icono: "error"
	      });
	      setActivate(false);
	    });
	  };
	
	  var handleCloseSi = function handleCloseSi() {
	    setActivate(false);
	    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	    procesarRegistro();
	  };
	
	  var validarCliente = function validarCliente(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (cmbRif.current.value !== "" && event.target.value !== "") {
	        var rif = cmbRif.current.value + event.target.value;
	
	        seleccionarRegistro(rif);
	      }
	    }
	  };
	
	  var validarPersona = function validarPersona(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        if (cmbNacionalidad.current.value !== "") {
	          datosRes();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "debe seleccionar la nacionalidad",
	            icono: "informacion"
	          });
	          cmbNacionalidad.current.focus();
	        }
	      } else {
	        cmbNacionalidad.current.value = "";
	        cmbSexo.current.value = "";
	        txtFechaNac.current.value = "";
	        txtNomResp.current.value = "";
	        txtApeResp.current.value = "";
	        txtDireccion.current.value = "";
	        txtEmail.current.value = "";
	        txtTlf1.current.value = "";
	        txtTlf2.current.value = "";
	        setHabilitadoNU(true);
	      }
	    }
	  };
	
	  var onChangeCliente = function onChangeCliente(e) {
	    if (e.target.name === "estado") {
	      setMunicipios([]);
	      setCiudades([]);
	      if (e.target.value !== "") {
	        selectMunicipios(e.target.value);
	      }
	    } else if (e.target.name === "municipio") {
	      setCiudades([]);
	      if (e.target.value !== "") {
	        selectCiudad(e.target.value);
	      }
	    } else if (e.target.name === "tipoper") {
	      if (parseInt(e.target.value) === 0) {
	        chkNatural.current.checked = true;
	        setTitleCed("Cédula:");
	        setCmbCedula([{ value: "V" }, { value: "E" }]);
	      } else {
	        chkJuridico.current.checked = true;
	        setTitleCed("R.I.F:");
	        setCmbCedula([{ value: "J" }, { value: "V" }, { value: "G" }, { value: "P" }]);
	      }
	    }
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "correoe" || e.target.name === "apellidos" || e.target.name === "direccion" || e.target.name === "nombres" || e.target.name === "descripcion") {
	      e.target.value = e.target.value;
	    } else if (e.target.name === "nacionalidad" && txtCedRes.current.value !== "") {
	      if (e.target.value !== "") {
	        datosRes();
	      } else {
	        txtCedRes.current.value = "";
	        cmbSexo.current.value = "";
	        txtFechaNac.current.value = "";
	        txtNomResp.current.value = "";
	        txtApeResp.current.value = "";
	        txtDireccion.current.value = "";
	        txtEmail.current.value = "";
	        txtTlf1.current.value = "";
	        txtTlf2.current.value = "";
	        setHabilitadoNU(true);
	      }
	    }
	  };
	
	  var onCatalogoCliente = function onCatalogoCliente(values) {
	    setCatalogoCliente(false);
	
	    if (tipoAgente === "vendedor") {
	      if (parseInt(values.tipoper) === 0) {
	        chkNatural.current.checked = true;
	        setTitleCed("CEDULA:");
	        setCmbCedula([{ value: "V" }, { value: "E" }]);
	      } else {
	        chkJuridico.current.checked = true;
	        setTitleCed("R.I.F:");
	        setCmbCedula([{ value: "J" }, { value: "V" }, { value: "G" }, { value: "P" }]);
	      }
	
	      txtRazon.current.value = values.nombre;
	
	      seleccionarRegistro(values.rif.trim());
	      //datosRes();
	      if (!botones.modificar) {
	        setBotones(Object.assign({}, botones, { catalogoper: false }));
	      }
	    } else if (tipoAgente === "cliente") {
	      var act = [];
	      var seguir = true;
	
	      if (records.length > 0) {
	        for (var i = 0; i < records.length; i++) {
	          act.push(records[i]);
	
	          if (parseInt(values.idagente) === parseInt(records[i].idagente)) {
	            seguir = false;
	          }
	        }
	
	        if (seguir) {
	          act.push({
	            idagente: values.idagente,
	            nombre: values.nombre,
	            rif: values.rif
	          });
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "este cliente ya fue seleccionado.",
	            icono: "informacion"
	          });
	        }
	      } else {
	        act.push({
	          idagente: values.idagente,
	          nombre: values.nombre,
	          rif: values.rif
	        });
	      }
	
	      setRecords(act);
	    }
	  };
	
	  var onCatalogoPersona = function onCatalogoPersona(values) {
	    setCatalogoPersona(false);
	    setHabilitadoNU(true);
	    setOperacionPer(0);
	    cmbNacionalidad.current.value = values.nacPer;
	    txtCedRes.current.value = values.cedPer;
	    cmbSexo.current.value = values.sexoPer;
	    txtFechaNac.current.value = (0, _moment2.default)(values.fnacPer).format("YYYY-MM-DD");
	    txtNomResp.current.value = values.nomPer;
	    txtApeResp.current.value = values.apePer;
	    txtDireccion.current.value = values.direPer;
	    txtEmail.current.value = values.correoPer;
	    txtTlf1.current.value = values.tlf1Per;
	    txtTlf2.current.value = values.tlf2Per;
	  };
	
	  var cargarClientes = function cargarClientes(id) {
	    var campos = "ag.*, cx.*";
	    var nomtab = "clientexvendedor as cx inner join agente as ag on ag.idagente=cx.idcliente";
	    var condi = "cx.idvendedor=" + id;
	    var orden = "ag.idagente";
	    var endpoint = op.conexion + "/api/consulta/selecionarregistrocondi?campos=" + campos + "&condi=" + condi + "&nomtab=" + nomtab + "&orden=" + orden;
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        setRecords(response.data);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var eliminarCliente = function eliminarCliente(item) {
	    return function (e) {
	      var act = [];
	
	      if (records.length > 0) {
	        for (var i = 0; i < records.length; i++) {
	          if (item.idagente !== records[i].idagente) {
	            act.push(records[i]);
	          }
	        }
	      }
	
	      setRecords(act);
	    };
	  };
	
	  var onBotones = function onBotones(op) {
	    return function (e) {
	      e.preventDefault();
	
	      if (op === 1) {
	        if (accbtnvendedor && accbtnvendedor.toString().substring(0, 1) === "1") {
	          setTituloHeader("Incluir Vendedor.");
	          setVisibleBtn("hidden");
	          setHabilitado(false);
	          setBotones({
	            incluir: false,
	            consultar: true,
	            modificar: true,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: true,
	            catalogoper: false,
	            tab1: true,
	            tab2: true
	          });
	          cmbRif.current.removeAttribute("disabled");
	          txtRif.current.removeAttribute("disabled");
	          chkNatural.current.removeAttribute("disabled");
	          chkJuridico.current.removeAttribute("disabled");
	          txtRif.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 2) {
	        if (accbtnvendedor && accbtnvendedor.toString().substring(1, 2) === "1") {
	          setTituloHeader("Editar Vendedor.");
	          setVisibleBtn("hidden");
	          setHabilitado(false);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: false,
	            eliminar: true,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true,
	            tab1: false,
	            tab2: false
	          });
	          cmbRif.current.removeAttribute("disabled");
	          txtRif.current.removeAttribute("disabled");
	          chkNatural.current.removeAttribute("disabled");
	          chkJuridico.current.removeAttribute("disabled");
	          txtRif.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 3) {
	        if (accbtnvendedor && accbtnvendedor.toString().substring(3, 4) === "1") {
	          setTituloHeader("Eliminar Vendedor.");
	          setVisibleBtn("hidden");
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: true,
	            modificar: true,
	            eliminar: false,
	            aceptar: false,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true,
	            tab1: false,
	            tab2: false
	          });
	          cmbRif.current.removeAttribute("disabled");
	          txtRif.current.removeAttribute("disabled");
	          chkNatural.current.removeAttribute("disabled");
	          chkJuridico.current.removeAttribute("disabled");
	          txtRif.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 4) {
	        if (accbtnvendedor && accbtnvendedor.toString().substring(2, 3) === "1") {
	          setTituloHeader("Consultar Vendedor.");
	          setVisibleBtn("hidden");
	          setHabilitado(true);
	          setBotones({
	            incluir: true,
	            consultar: false,
	            modificar: true,
	            eliminar: true,
	            aceptar: true,
	            cancelar: false,
	            catalogo: false,
	            catalogoper: true,
	            tab1: false,
	            tab2: false
	          });
	          cmbRif.current.removeAttribute("disabled");
	          txtRif.current.removeAttribute("disabled");
	          chkNatural.current.removeAttribute("disabled");
	          chkJuridico.current.removeAttribute("disabled");
	          txtRif.current.focus();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación.",
	            texto: "¡No Posee Permiso para Realizar esta Acción!",
	            icono: "error"
	          });
	        }
	      } else if (op === 5) {
	        onChangeValidar();
	      } else if (op === 6) {
	        setVisibleBtn("visible");
	        blanquear();
	      }
	    };
	  };
	
	  var ContarRegistros = function ContarRegistros() {
	    var valor = "vendedor";
	    var boleano = true;
	
	    var endpoint = op.conexion + "/api/agente/totalregistros?valor=" + valor + "&boleano=" + boleano;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setTotalr(response.data.total);
	        setTitulo("Vendedores");
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response === undefined ? "Error de Conexion" : error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarActivos = function seleccionarActivos() {
	    var valor = "vendedor";
	    var boleano = true;
	    var status = "statusvendedor";
	    var valstatus = 51;
	
	    var endpoint = op.conexion + "/api/agente/totalregistrosactivosinactivos?valor=" + valor + "&boleano=" + boleano + "&status=" + status + "&valstatus=" + valstatus;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setTotalact(response.data.total);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response === undefined ? "Error de Conexion" : error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarInactivos = function seleccionarInactivos() {
	    var valor = "vendedor";
	    var boleano = true;
	    var status = "statusvendedor";
	    var valstatus = 52;
	
	    var endpoint = op.conexion + "/api/agente/totalregistrosactivosinactivos?valor=" + valor + "&boleano=" + boleano + "&status=" + status + "&valstatus=" + valstatus;
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        setTotalinc(response.data.total);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response === undefined ? "Error de Conexion" : error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarAlmacen = function seleccionarAlmacen() {
	    var campos = "idalmacen, trim(descripcion) as descripcion";
	    var nomtab = "almacen";
	    var nomid = "idalmacen";
	    var id = txtCodAlmacen.current.value;
	    var endpoint = op.conexion + "/api/consulta/modeli?campos=" + campos + "&nomtab=" + nomtab + "&nomid=" + nomid + "&id=" + id;
	
	    setActivate(true);
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        txtDescripcion.current.value = "";
	        if (response.data !== "") {
	          txtDescripcion.current.value = response.data.descripcion.trim();
	        } else {
	          setMensaje({
	            mostrar: true,
	            titulo: "Notificación",
	            texto: "No existe un almacen con este codigo",
	            icono: "informacion"
	          });
	          txtDescripcion.current.value = "";
	        }
	      }
	      setActivate(false);
	    }).catch(function (error) {
	      setActivate(false);
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	    });
	  };
	
	  var validarAlmacen = function validarAlmacen(event) {
	    event.preventDefault();
	    (0, _varios.validaSoloNumero)(event);
	    if (event.which === 13 || typeof event.which === "undefined") {
	      if (event.target.value !== "") {
	        seleccionarAlmacen();
	      }
	    }
	  };
	
	  var onCatalogoAlmacen = function onCatalogoAlmacen(values) {
	    setCatalogoAlmacen(false);
	    txtCodAlmacen.current.value = values.idalmacen;
	    txtDescripcion.current.value = values.descripcion;
	  };
	
	  (0, _react.useEffect)(function () {
	    seleccionarRegistros();
	    ContarRegistros();
	    seleccionarActivos();
	    seleccionarInactivos();
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { style: { height: "100%", width: "100%" } },
	    _react2.default.createElement(
	      "div",
	      { className: "row col-md-12", style: { margin: 0 } },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-12", style: { margin: 0 } },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-9 py-1 mx-auto mt-2 card shadow rounded" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row mx-auto border-azul rounded pt-2" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 border-azul rounded py-2 row mx-auto mb-1 azulGradiant shadow text-light justify-content-between" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-4" },
	                _react2.default.createElement(
	                  "h3",
	                  null,
	                  tituloHeader
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 d-flex justify-content-end" },
	                _react2.default.createElement(
	                  "a",
	                  { href: "/inicio", className: "text-light " },
	                  _react2.default.createElement("i", { className: "fas fa-times mx-2" }),
	                  _react2.default.createElement(
	                    "span",
	                    { className: "fw-bold" },
	                    "Salirr"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "ul",
	              { className: "nav mb-1", id: "ex-with-icons", role: "tablist" },
	              _react2.default.createElement(
	                "li",
	                { className: "nav-item", role: "presentation" },
	                _react2.default.createElement(
	                  "a",
	                  {
	                    style: { pointerEvents: botones.tab1 ? "none" : "auto" },
	                    className: "nav-link text-light bg-blue-100 rounded",
	                    id: "ex-with-icons-tab-1",
	                    "data-mdb-toggle": "tab",
	                    href: "#ex-with-icons-tabs-1",
	                    role: "tab",
	                    "aria-controls": "ex-with-icons-tabs-1",
	                    "aria-selected": "true"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-briefcase fa-fw me-2" }),
	                  "Datos del Vendedor"
	                )
	              ),
	              _react2.default.createElement(
	                "li",
	                { className: "nav-item", role: "presentation" },
	                _react2.default.createElement(
	                  "a",
	                  {
	                    style: { pointerEvents: botones.tab2 ? "none" : "auto" },
	                    className: "nav-link text-light bg-blue-200 rounded ",
	                    id: "ex-with-icons-tab-2",
	                    "data-mdb-toggle": "tab",
	                    href: "#ex-with-icons-tabs-2",
	                    role: "tab",
	                    "aria-controls": "ex-with-icons-tabs-2",
	                    "aria-selected": "false"
	                  },
	                  _react2.default.createElement("i", { className: "fas fa-clipboard fa-fw me-2" }),
	                  "Clientes"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "tab-content",
	                id: "ex-with-icons-content",
	                style: { fontFamily: "Times New Roman, Times, serif" }
	              },
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "tab-pane fade show active ",
	                  id: "ex-with-icons-tabs-1",
	                  role: "tabpanel",
	                  "aria-labelledby": "ex-with-icons-tab-1"
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 mx-auto row" },
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-md-12 mt-2",
	                      style: { fontSizeAdjust: "0.6" }
	                    },
	                    _react2.default.createElement(
	                      "fieldset",
	                      { className: " row col-sm-12 mx-auto border-azul rounded" },
	                      _react2.default.createElement(
	                        "legend",
	                        {
	                          className: "float-none w-auto fw-bold",
	                          style: { fontSize: "15px" }
	                        },
	                        "Datos del Vendedor"
	                      ),
	                      _react2.default.createElement("input", {
	                        ref: txtId,
	                        autoComplete: "off",
	                        type: "hidden",
	                        className: "form-control",
	                        name: "idagente",
	                        "aria-label": "Sizing example input",
	                        "aria-describedby": "inputGroup-sizing-sm"
	                      }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "mb-1 col-pd-260 px-2" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "input-group input-group-sm" },
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "input-group-text",
	                              id: "inputGroup-sizing-sm"
	                            },
	                            titleCed,
	                            " "
	                          ),
	                          _react2.default.createElement(
	                            "select",
	                            {
	                              ref: cmbRif,
	                              name: "cmbrif",
	                              disabled: true,
	                              className: "form-select form-select-sm text-center col-3",
	                              "aria-label": ".form-select-sm example",
	                              onChange: onChange
	                            },
	                            _react2.default.createElement(
	                              "option",
	                              { value: "" },
	                              "--"
	                            ),
	                            cmbCedula && cmbCedula.map(function (item, index) {
	                              return _react2.default.createElement(
	                                "option",
	                                { key: index, value: item.value },
	                                " ",
	                                item.value,
	                                " "
	                              );
	                            })
	                          ),
	                          _react2.default.createElement("input", {
	                            ref: txtRif,
	                            autoComplete: "off",
	                            disabled: true,
	                            maxLength: 9,
	                            type: "text",
	                            className: "form-control fs-6",
	                            name: "cedula",
	                            "aria-label": "Sizing example input",
	                            "aria-describedby": "inputGroup-sizing-sm",
	                            onKeyUp: validarCliente,
	                            onBlur: validarCliente,
	                            onChange: onChange
	                          }),
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              disabled: botones.catalogo,
	                              type: "button",
	                              onClick: function onClick() {
	                                setTipoAgente("vendedor");
	                                setCatalogoCliente(true);
	                              },
	                              className: "btn btn-success"
	                            },
	                            _react2.default.createElement("i", { className: "fas fa-search" })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-pd-410 mb-1" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row m-0" },
	                          _react2.default.createElement(
	                            "label",
	                            { className: "col-6" },
	                            "TIPO PERSONA: "
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input my-auto",
	                                disabled: true,
	                                type: "radio",
	                                name: "tipoper",
	                                value: 0,
	                                ref: chkNatural,
	                                defaultChecked: true,
	                                id: "tipoper",
	                                onChange: onChangeCliente
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  htmlFor: "tipoper"
	                                },
	                                " ",
	                                "Natural",
	                                " "
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            "div",
	                            { className: "col" },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "form-check" },
	                              _react2.default.createElement("input", {
	                                className: "form-check-input my-auto",
	                                disabled: true,
	                                type: "radio",
	                                name: "tipoper",
	                                value: 1,
	                                ref: chkJuridico,
	                                id: "tipoper",
	                                onChange: onChangeCliente
	                              }),
	                              _react2.default.createElement(
	                                "label",
	                                {
	                                  className: "form-check-label",
	                                  htmlFor: "tipoper"
	                                },
	                                " ",
	                                "Juridica",
	                                " "
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-1 col-md-12" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          titleCed === "CEDULA:" ? "NOMBRES Y APELLIDOS" : "NOMBRE/RAZON SOCIAL"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          autoComplete: "off",
	                          ref: txtRazon,
	                          disabled: habilitado,
	                          name: "nombres",
	                          className: "form-control text-uppercase fs-6",
	                          onChange: onChange,
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-1 col-md-12" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "DIRECCION:"
	                        ),
	                        _react2.default.createElement("textarea", {
	                          type: "area",
	                          autoComplete: "off",
	                          ref: txtDirClient,
	                          disabled: habilitado,
	                          name: "direccion",
	                          className: "form-control text-uppercase fs-6",
	                          onChange: onChange,
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm",
	                          style: { height: 40 }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-1 col-pd-240 px-2" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "ESTADO:"
	                        ),
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            ref: txtEstado,
	                            disabled: habilitado,
	                            onChange: onChangeCliente,
	                            name: "estado",
	                            idciudad: "estado",
	                            className: "form-select form-select-sm",
	                            "aria-label": ".form-select-sm example"
	                          },
	                          _react2.default.createElement(
	                            "option",
	                            { value: "" },
	                            "seleccione"
	                          ),
	                          estados && estados.map(function (item, index) {
	                            return _react2.default.createElement(
	                              "option",
	                              { key: index, value: item.idestado },
	                              item.nombre
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-1 col-md-4" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "MUNICIPIO:"
	                        ),
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            ref: txtMunicipio,
	                            disabled: habilitado,
	                            onChange: onChangeCliente,
	                            name: "municipio",
	                            id: "municipio",
	                            className: "form-select form-select-sm",
	                            "aria-label": ".form-select-sm example"
	                          },
	                          _react2.default.createElement(
	                            "option",
	                            { value: "" },
	                            "seleccione"
	                          ),
	                          municipios && municipios.map(function (item, index) {
	                            return _react2.default.createElement(
	                              "option",
	                              { key: index, value: item.idmunicipio },
	                              item.nombre
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-1 col-md-3" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "CIUDAD:"
	                        ),
	                        _react2.default.createElement(
	                          "select",
	                          {
	                            ref: txtCiudad,
	                            disabled: habilitado,
	                            name: "ciudad",
	                            id: "ciudad",
	                            className: "form-select form-select-sm",
	                            "aria-label": ".form-select-sm example"
	                          },
	                          _react2.default.createElement(
	                            "option",
	                            { value: "" },
	                            "seleccione"
	                          ),
	                          ciudades && ciudades.map(function (item, index) {
	                            return _react2.default.createElement(
	                              "option",
	                              { key: index, value: item.idciudad },
	                              item.nombre
	                            );
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-1 col-pd-200 px-2 ml-auto" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text px-1",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "CELULAR:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          autoComplete: "off",
	                          maxLength: 11,
	                          ref: txtTlf2Client,
	                          disabled: habilitado,
	                          className: "form-control fs-6 px-1",
	                          name: "tlf2",
	                          "aria-label": "Sizing example input",
	                          onChange: onChange,
	                          "aria-describedby": "inputGroup-sizing-sm",
	                          onKeyUp: handleInputNumChange
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-1 col-md-4" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "EMAIL:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          autoComplete: "off",
	                          ref: txtEmailClient,
	                          disabled: habilitado,
	                          className: "form-control text-uppercase fs-6",
	                          name: "correoe",
	                          "aria-label": "Sizing example input",
	                          onChange: onChange,
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-1 col-pd-210 px-1" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text px-1",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "TELEFONO:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          autoComplete: "off",
	                          maxLength: 11,
	                          ref: txtTlf1Client,
	                          disabled: habilitado,
	                          className: "form-control fs-6 px-1",
	                          name: "tlf1",
	                          "aria-label": "Sizing example input",
	                          onChange: onChange,
	                          "aria-describedby": "inputGroup-sizing-sm",
	                          onKeyUp: handleInputNumChange
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-md-12",
	                      style: { fontSizeAdjust: "0.6" }
	                    },
	                    _react2.default.createElement(
	                      "fieldset",
	                      { className: " row col-sm-12 mx-auto border-azul rounded" },
	                      _react2.default.createElement(
	                        "legend",
	                        {
	                          className: "float-none w-auto fw-bold",
	                          style: { fontSize: "15px" }
	                        },
	                        "Responsable"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-pd-270 mb-1 px-2" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "input-group input-group-sm" },
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "input-group-text",
	                              id: "inputGroup-sizing-sm"
	                            },
	                            "CEDULA:"
	                          ),
	                          _react2.default.createElement(
	                            "select",
	                            {
	                              ref: cmbNacionalidad,
	                              name: "nacionalidad",
	                              className: "form-select form-select-sm col-md-3",
	                              disabled: habilitado,
	                              "aria-label": ".form-select-sm example",
	                              onChange: onChange
	                            },
	                            _react2.default.createElement(
	                              "option",
	                              { value: "" },
	                              "--"
	                            ),
	                            _react2.default.createElement(
	                              "option",
	                              { value: "V" },
	                              "V"
	                            ),
	                            _react2.default.createElement(
	                              "option",
	                              { value: "E" },
	                              "E"
	                            )
	                          ),
	                          _react2.default.createElement("input", {
	                            ref: txtCedRes,
	                            maxLength: 8,
	                            autoComplete: "off",
	                            type: "text",
	                            disabled: habilitado,
	                            className: "form-control fs-6",
	                            name: "cedula",
	                            "aria-label": "Sizing example input",
	                            "aria-describedby": "inputGroup-sizing-sm",
	                            onKeyUp: validarPersona,
	                            onBlur: validarPersona,
	                            onChange: onChange
	                          }),
	                          _react2.default.createElement(
	                            "button",
	                            {
	                              disabled: botones.catalogoper,
	                              type: "button",
	                              onClick: function onClick() {
	                                return setCatalogoPersona(true);
	                              },
	                              className: "btn btn-success"
	                            },
	                            _react2.default.createElement("i", { className: "fas fa-search" })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-pd-140 ml-auto mb-1" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "input-group input-group-sm" },
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "input-group-text",
	                              id: "inputGroup-sizing-sm"
	                            },
	                            "SEXO:"
	                          ),
	                          _react2.default.createElement(
	                            "select",
	                            {
	                              ref: cmbSexo,
	                              className: "form-select form-select-sm",
	                              name: "sexo",
	                              disabled: habilitadoNU,
	                              onChange: onChange,
	                              "aria-label": ".form-select-sm example"
	                            },
	                            _react2.default.createElement(
	                              "option",
	                              { value: "" },
	                              "--"
	                            ),
	                            _react2.default.createElement(
	                              "option",
	                              { value: "M" },
	                              "M"
	                            ),
	                            _react2.default.createElement(
	                              "option",
	                              { value: "F" },
	                              "F"
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "mb-1 col-pd-340 ml-auto px-2" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "input-group input-group-sm" },
	                          _react2.default.createElement(
	                            "label",
	                            {
	                              className: "input-group-text",
	                              id: "inputGroup-sizing-sm"
	                            },
	                            "FECHA DE NACIMIENTO"
	                          ),
	                          _react2.default.createElement("input", {
	                            type: "date",
	                            ref: txtFechaNac,
	                            max: fechaTope,
	                            className: "form-control fs-6 text-uppercase",
	                            name: "fnacimiento",
	                            "aria-label": "Sizing example input",
	                            onChange: onChange,
	                            disabled: habilitadoNU,
	                            "aria-describedby": "inputGroup-sizing-sm"
	                          })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-1 col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "NOMBRES:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          autoComplete: "off",
	                          ref: txtNomResp,
	                          name: "nombres",
	                          className: "form-control text-uppercase fs-6",
	                          onChange: onChange,
	                          "aria-label": "Sizing example input",
	                          disabled: habilitadoNU,
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-1 col-md-6" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "APELLIDOS:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          autoComplete: "off",
	                          ref: txtApeResp,
	                          name: "apellidos",
	                          className: "form-control text-uppercase fs-6",
	                          onChange: onChange,
	                          "aria-label": "Sizing example input",
	                          disabled: habilitadoNU,
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-1 col-md-12" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "DIRECCION:"
	                        ),
	                        _react2.default.createElement("textarea", {
	                          type: "area",
	                          autoComplete: "off",
	                          ref: txtDireccion,
	                          name: "direccion",
	                          className: "form-control text-uppercase fs-6",
	                          onChange: onChange,
	                          "aria-label": "Sizing example input",
	                          disabled: habilitadoNU,
	                          "aria-describedby": "inputGroup-sizing-sm",
	                          style: { height: 40 }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-1 col-md-4" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "EMAIL:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          autoComplete: "off",
	                          ref: txtEmail,
	                          className: "form-control text-uppercase fs-6",
	                          name: "correoe",
	                          "aria-label": "Sizing example input",
	                          onChange: onChange,
	                          disabled: habilitadoNU,
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-1 col-pd-210 px-1" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text px-1",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "TELEFONO:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          autoComplete: "off",
	                          maxLength: 11,
	                          ref: txtTlf1,
	                          className: "form-control fs-6 px-1",
	                          name: "tlf1",
	                          "aria-label": "Sizing example input",
	                          onChange: onChange,
	                          disabled: habilitadoNU,
	                          "aria-describedby": "inputGroup-sizing-sm",
	                          onKeyUp: handleInputNumChange
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-1 col-pd-210" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text px-1",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "CELULAR:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          autoComplete: "off",
	                          maxLength: 11,
	                          ref: txtTlf2,
	                          className: "form-control fs-6 px-1",
	                          name: "tlf2",
	                          "aria-label": "Sizing example input",
	                          onChange: onChange,
	                          disabled: habilitadoNU,
	                          "aria-describedby": "inputGroup-sizing-sm",
	                          onKeyUp: handleInputNumChange
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-md-12",
	                      style: { fontSizeAdjust: "0.6" }
	                    },
	                    _react2.default.createElement(
	                      "fieldset",
	                      { className: " row col-sm-12 mx-auto border-azul rounded" },
	                      _react2.default.createElement(
	                        "legend",
	                        {
	                          className: "float-none w-auto fw-bold",
	                          style: { fontSize: "15px" }
	                        },
	                        "Almacen"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-1 col-md-3 col-lg-2 col-sm-4" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "CODIGO:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          autoComplete: "off",
	                          ref: txtCodAlmacen,
	                          disabled: habilitado,
	                          onKeyUp: validarAlmacen,
	                          onBlur: validarAlmacen,
	                          name: "idalmacen",
	                          className: "form-control fs-6",
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        }),
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            disabled: botones.catalogoper,
	                            onClick: function onClick() {
	                              return setCatalogoAlmacen(true);
	                            },
	                            type: "button",
	                            className: "btn btn-success"
	                          },
	                          _react2.default.createElement("i", { className: "fas fa-search" })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-1 col-md-9 col-lg-10 col-sm-8" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            className: "input-group-text",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "DESCRIPCION:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          autoComplete: "off",
	                          disabled: true,
	                          ref: txtDescripcion,
	                          onChange: onChange,
	                          name: "descripcion",
	                          className: "form-control text-uppercase fs-6",
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-pd-350 mb-1",
	                      style: { fontSizeAdjust: "0.6" }
	                    },
	                    _react2.default.createElement(
	                      "fieldset",
	                      { className: " row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between" },
	                      _react2.default.createElement(
	                        "legend",
	                        {
	                          className: "float-none w-auto fw-bold",
	                          style: { fontSize: "15px" }
	                        },
	                        "Comisiones de Venta",
	                        " "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-12 mx-auto" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            style: { fontSize: "12px" },
	                            className: "input-group-text col-md-8 border-0 bg-transparent",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "% Precio M\xE1ximo:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          ref: txtpreciomaxventa,
	                          onFocus: _varios.seleccionarCampo,
	                          disabled: habilitado,
	                          onKeyUp: handleInputMontoChange,
	                          onBlur: handleInputMontoChange,
	                          className: "form-control rounded text-right fs-6",
	                          placeholder: "0,00",
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-12 mx-auto" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            style: { fontSize: "12px" },
	                            className: "input-group-text col-md-8 border-0 bg-transparent",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "% Precio Oferta:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          ref: txtprecioofventa,
	                          onFocus: _varios.seleccionarCampo,
	                          disabled: habilitado,
	                          onKeyUp: handleInputMontoChange,
	                          onBlur: handleInputMontoChange,
	                          className: "form-control rounded text-right fs-6",
	                          placeholder: "0,00",
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-12 mx-auto" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            style: { fontSize: "12px" },
	                            className: "input-group-text col-md-8 border-0 bg-transparent",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "% Precio Mayor:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          ref: txtpreciomayventa,
	                          onFocus: _varios.seleccionarCampo,
	                          disabled: habilitado,
	                          onKeyUp: handleInputMontoChange,
	                          onBlur: handleInputMontoChange,
	                          className: "form-control rounded text-right fs-6",
	                          placeholder: "0,00",
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-12 mx-auto" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            style: { fontSize: "12px" },
	                            className: "input-group-text col-md-8 border-0 bg-transparent",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "% Precio Minimo:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          ref: txtpreciominventa,
	                          onFocus: _varios.seleccionarCampo,
	                          disabled: habilitado,
	                          onKeyUp: handleInputMontoChange,
	                          onBlur: handleInputMontoChange,
	                          className: "form-control rounded text-right fs-6",
	                          placeholder: "0,00",
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-12 mx-auto" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            style: { fontSize: "12px" },
	                            className: "input-group-text col-md-8 border-0 bg-transparent",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "% Por debajo del Minimo:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          ref: txtdebajominventa,
	                          onFocus: _varios.seleccionarCampo,
	                          disabled: habilitado,
	                          onKeyUp: handleInputMontoChange,
	                          onBlur: handleInputMontoChange,
	                          className: "form-control rounded text-right fs-6",
	                          placeholder: "0,00",
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-pd-350 mb-1 mx-auto",
	                      style: { fontSizeAdjust: "0.6" }
	                    },
	                    _react2.default.createElement(
	                      "fieldset",
	                      { className: " row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between" },
	                      _react2.default.createElement(
	                        "legend",
	                        {
	                          className: "float-none w-auto fw-bold",
	                          style: { fontSize: "15px" }
	                        },
	                        "Comisiones de Servicios"
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-12 mx-auto" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            style: { fontSize: "12px" },
	                            className: "input-group-text col-md-8 border-0 bg-transparent",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "% Precio M\xE1ximo:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          ref: txtpreciomaxservi,
	                          onFocus: _varios.seleccionarCampo,
	                          disabled: habilitado,
	                          onKeyUp: handleInputMontoChange,
	                          onBlur: handleInputMontoChange,
	                          className: "form-control rounded text-right fs-6",
	                          placeholder: "0,00",
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-12 mx-auto" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            style: { fontSize: "12px" },
	                            className: "input-group-text col-md-8 border-0 bg-transparent",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "% Precio Oferta:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          ref: txtprecioofservi,
	                          onFocus: _varios.seleccionarCampo,
	                          disabled: habilitado,
	                          onKeyUp: handleInputMontoChange,
	                          onBlur: handleInputMontoChange,
	                          className: "form-control rounded text-right fs-6",
	                          placeholder: "0,00",
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-12 mx-auto" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            style: { fontSize: "12px" },
	                            className: "input-group-text col-md-8 border-0 bg-transparent",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "% Precio Mayor:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          ref: txtpreciomayservi,
	                          onFocus: _varios.seleccionarCampo,
	                          disabled: habilitado,
	                          onKeyUp: handleInputMontoChange,
	                          onBlur: handleInputMontoChange,
	                          className: "form-control rounded text-right fs-6",
	                          placeholder: "0,00",
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-12 mx-auto" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            style: { fontSize: "12px" },
	                            className: "input-group-text col-md-8 border-0 bg-transparent",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "% Precio Minimo:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          ref: txtpreciominservi,
	                          onFocus: _varios.seleccionarCampo,
	                          disabled: habilitado,
	                          onKeyUp: handleInputMontoChange,
	                          onBlur: handleInputMontoChange,
	                          className: "form-control rounded text-right fs-6",
	                          placeholder: "0,00",
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-12 mx-auto" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            style: { fontSize: "12px" },
	                            className: "input-group-text col-md-8 border-0 bg-transparent",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "% Por Debajo del Minimo:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          ref: txtdebajominservi,
	                          onFocus: _varios.seleccionarCampo,
	                          disabled: habilitado,
	                          onKeyUp: handleInputMontoChange,
	                          onBlur: handleInputMontoChange,
	                          className: "form-control rounded text-right fs-6",
	                          placeholder: "0,00",
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    {
	                      className: "col-pd-350 mb-1",
	                      style: { fontSizeAdjust: "0.6" }
	                    },
	                    _react2.default.createElement(
	                      "fieldset",
	                      { className: " row col-sm-12 mx-auto border-azul rounded dlflex justify-content-between" },
	                      _react2.default.createElement(
	                        "legend",
	                        {
	                          className: "float-none w-auto fw-bold",
	                          style: { fontSize: "15px" }
	                        },
	                        "Comisiones de Cobranza",
	                        " "
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-12 mx-auto" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            style: { fontSize: "12px" },
	                            className: "input-group-text col-md-8 border-0 bg-transparent",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "% Precio M\xE1ximo:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          ref: txtpreciomaxcob,
	                          onFocus: _varios.seleccionarCampo,
	                          disabled: habilitado,
	                          onKeyUp: handleInputMontoChange,
	                          onBlur: handleInputMontoChange,
	                          className: "form-control rounded text-right fs-6",
	                          placeholder: "0,00",
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-12 mx-auto" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            style: { fontSize: "12px" },
	                            className: "input-group-text col-md-8 border-0 bg-transparent",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "% Precio Oferta:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          ref: txtprecioofcob,
	                          onFocus: _varios.seleccionarCampo,
	                          disabled: habilitado,
	                          onKeyUp: handleInputMontoChange,
	                          onBlur: handleInputMontoChange,
	                          className: "form-control rounded text-right fs-6",
	                          placeholder: "0,00",
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-12 mx-auto" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            style: { fontSize: "12px" },
	                            className: "input-group-text col-md-8 border-0 bg-transparent",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "% Precio Mayor:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          ref: txtpreciomaycob,
	                          onFocus: _varios.seleccionarCampo,
	                          disabled: habilitado,
	                          onKeyUp: handleInputMontoChange,
	                          onBlur: handleInputMontoChange,
	                          className: "form-control rounded text-right fs-6",
	                          placeholder: "0,00",
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-12 mx-auto" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            style: { fontSize: "12px" },
	                            className: "input-group-text col-md-8 border-0 bg-transparent",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "% Servicio Minimo:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          ref: txtservimincob,
	                          onFocus: _varios.seleccionarCampo,
	                          disabled: habilitado,
	                          onKeyUp: handleInputMontoChange,
	                          onBlur: handleInputMontoChange,
	                          className: "form-control rounded text-right fs-6",
	                          placeholder: "0,00",
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-12 mx-auto" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            style: { fontSize: "12px" },
	                            className: "input-group-text col-md-8 border-0 bg-transparent",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "% Por debajo del M\xEDnimo:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          ref: txtdebajomincob,
	                          onFocus: _varios.seleccionarCampo,
	                          disabled: habilitado,
	                          onKeyUp: handleInputMontoChange,
	                          onBlur: handleInputMontoChange,
	                          className: "form-control rounded text-right fs-6",
	                          placeholder: "0,00",
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      ),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "input-group input-group-sm mb-2 col-md-12 mx-auto" },
	                        _react2.default.createElement(
	                          "label",
	                          {
	                            style: { fontSize: "12px" },
	                            className: "input-group-text col-md-8 border-0 bg-transparent",
	                            id: "inputGroup-sizing-sm"
	                          },
	                          "% General de Cobranza:"
	                        ),
	                        _react2.default.createElement("input", {
	                          type: "text",
	                          ref: txtgeneralcob,
	                          onFocus: _varios.seleccionarCampo,
	                          disabled: habilitado,
	                          onKeyUp: handleInputMontoChange,
	                          onBlur: handleInputMontoChange,
	                          className: "form-control rounded text-right fs-6",
	                          placeholder: "0,00",
	                          "aria-label": "Sizing example input",
	                          "aria-describedby": "inputGroup-sizing-sm"
	                        })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 py-1" },
	                    visibleBtn !== "visible" ? _react2.default.createElement(
	                      "div",
	                      { className: "col-pd-botonesd row m-0 ml-auto" },
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          ref: btnAcepta,
	                          disabled: botones.aceptar,
	                          onClick: onBotones(5),
	                          className: "btn btn-sm col ml-1 rounded-pill btn-success"
	                        },
	                        _react2.default.createElement(
	                          "i",
	                          { className: "fas fa-check-circle" },
	                          " Aceptar"
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "button",
	                        {
	                          ref: btnCancela,
	                          disabled: botones.cancelar,
	                          onClick: onBotones(6),
	                          className: "btn btn-danger col ml-1 btn-sm rounded-pill"
	                        },
	                        _react2.default.createElement(
	                          "i",
	                          { className: "fas fa-window-close" },
	                          " Cancelar"
	                        )
	                      )
	                    ) : _react2.default.createElement(
	                      "div",
	                      { className: "col-pd-botones" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12 row m-0" },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            disabled: botones.incluir,
	                            onClick: onBotones(1),
	                            className: "btn btn-sm col ml-1 mb-1 btn-primary rounded-pill",
	                            title: "Incluir Almacen"
	                          },
	                          _react2.default.createElement(
	                            "i",
	                            { className: "fas fa-plus" },
	                            " Incluir "
	                          ),
	                          " "
	                        ),
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            disabled: botones.consultar,
	                            onClick: onBotones(4),
	                            className: "btn btn-sm col ml-1 mb-1 btn-info rounded-pill",
	                            title: "Consultar Almacen"
	                          },
	                          _react2.default.createElement(
	                            "i",
	                            { className: "fas fa-eye" },
	                            " Consultar"
	                          ),
	                          " "
	                        ),
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            disabled: botones.modificar,
	                            onClick: onBotones(2),
	                            className: "btn btn-sm col ml-1 mb-1 btn-warning rounded-pill",
	                            title: "Modificar Almacen"
	                          },
	                          _react2.default.createElement(
	                            "i",
	                            { className: "fa fa-edit" },
	                            " Modificar"
	                          ),
	                          " "
	                        ),
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            disabled: botones.eliminar,
	                            onClick: onBotones(3),
	                            className: "btn btn-sm col ml-1 mb-1 btn-danger rounded-pill",
	                            title: "Eliminar Almacen"
	                          },
	                          _react2.default.createElement(
	                            "i",
	                            { className: "fa fa-trash" },
	                            " Eliminar"
	                          ),
	                          " "
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "tab-pane fade",
	                  id: "ex-with-icons-tabs-2",
	                  role: "tabpanel",
	                  "aria-labelledby": "ex-with-icons-tab-2"
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 py-1" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-12 p-2" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row col-12 d-flex justify-content-between" },
	                      _react2.default.createElement("input", {
	                        type: "text",
	                        className: " col-3 form-control form-control-sm rounded-pill",
	                        ref: txtBuscador,
	                        onChange: handleSearch,
	                        placeholder: "Buscar"
	                      }),
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-3 d-flex justify-content-end" },
	                        _react2.default.createElement(
	                          "button",
	                          {
	                            onClick: function onClick() {
	                              setTipoAgente("cliente");
	                              setCatalogoCliente(true);
	                            },
	                            className: "btn btn-sm btn-primary rounded-circle"
	                          },
	                          _react2.default.createElement("i", { className: "fas fa-plus" }),
	                          " "
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-12 m-0" },
	                    _react2.default.createElement(
	                      TblContainer,
	                      null,
	                      _react2.default.createElement(TblHead, null),
	                      _react2.default.createElement(
	                        _core.TableBody,
	                        null,
	                        records && recordsAfterPagingAndSorting().map(function (item, index) {
	                          return _react2.default.createElement(
	                            _core.TableRow,
	                            { key: index, style: { padding: "0" } },
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-baseline",
	                                style: {
	                                  textAlign: "center",
	                                  alignItems: "center",
	                                  width: "50px"
	                                }
	                              },
	                              item.idagente
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-baseline",
	                                style: {
	                                  textAlign: "center",
	                                  alignItems: "center",
	                                  width: "350px"
	                                }
	                              },
	                              item.nombre
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-baseline",
	                                style: {
	                                  textAlign: "center",
	                                  alignItems: "center",
	                                  width: "50px"
	                                }
	                              },
	                              item.rif
	                            ),
	                            _react2.default.createElement(
	                              _core.TableCell,
	                              {
	                                className: "align-baseline",
	                                style: {
	                                  textAlign: "center",
	                                  alignItems: "center",
	                                  width: "50px"
	                                }
	                              },
	                              _react2.default.createElement(
	                                "button",
	                                {
	                                  onClick: eliminarCliente(item),
	                                  className: "btn btn-sm mx-1 btn-danger rounded-circle"
	                                },
	                                _react2.default.createElement("i", { className: "fa fa-trash" }),
	                                " "
	                              )
	                            )
	                          );
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(TblPagination, null)
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-3 py-4 ocultodos" },
	          _react2.default.createElement(_cartasProveedor2.default, {
	            totalr: totalr,
	            totalact: totalact,
	            totalinc: totalinc,
	            titulo: titulo
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(_catalogoAlmacen2.default, {
	      show: catalogoAlmacen,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoAlmacen(false);
	      },
	      onHideAceptaCatalogo: onCatalogoAlmacen
	    }),
	    _react2.default.createElement(_catalogoCliente2.default, {
	      show: catalogoCliente,
	      nomid: tipoAgente,
	      onHideCancelar: function onHideCancelar() {
	        return setCatalogoCliente(false);
	      },
	      onHideAceptaCatalogo: onCatalogoCliente
	    }),
	    _react2.default.createElement(_catalogoPersona2.default, {
	      show: catalogoPersona,
	      onHideCancelaCatPer: function onHideCancelaCatPer() {
	        return setCatalogoPersona(false);
	      },
	      onHideAceptaCatPer: onCatalogoPersona
	    }),
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return mensaje.titulo === "Exito." ? blanquear() : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_mensajes.MensajeSiNo, {
	      mensaje: mensajesino,
	      onHideNo: function onHideNo() {
	        return setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
	      },
	      onHideSi: handleCloseSi
	    })
	  );
	};
	exports.default = TablaVendedores;

/***/ },
/* 7184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(45);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _serviceWorker = __webpack_require__(7189);
	
	var serviceWorker = _interopRequireWildcard(_serviceWorker);
	
	var _App = __webpack_require__(7018);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(_App2.default, null), document.getElementById('root'));
	
	// If you want your app to work offline and load faster, you can change
	// unregister() to register() below. Note this comes with some pitfalls.
	// Learn more about service workers: https://bit.ly/CRA-PWA
	
	/* import ApolloProvider from './ApolloProvider'; */
	serviceWorker.unregister();

/***/ },
/* 7185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	/* almacen */
	
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _auth = __webpack_require__(106);
	
	var _foother = __webpack_require__(7138);
	
	var _foother2 = _interopRequireDefault(_foother);
	
	var _AuthRoute = __webpack_require__(7190);
	
	var _AuthRoute2 = _interopRequireDefault(_AuthRoute);
	
	var _inicio = __webpack_require__(7186);
	
	var _inicio2 = _interopRequireDefault(_inicio);
	
	var _header = __webpack_require__(7140);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _sidebar = __webpack_require__(7149);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _mensajes = __webpack_require__(9);
	
	var _tablaBancos = __webpack_require__(7073);
	
	var _tablaBancos2 = _interopRequireDefault(_tablaBancos);
	
	var _nuevaTablaAlmacen = __webpack_require__(7061);
	
	var _nuevaTablaAlmacen2 = _interopRequireDefault(_nuevaTablaAlmacen);
	
	var _nuevaTablaUbicacion = __webpack_require__(7062);
	
	var _nuevaTablaUbicacion2 = _interopRequireDefault(_nuevaTablaUbicacion);
	
	var _tablaUnidadesMedidas = __webpack_require__(7070);
	
	var _tablaUnidadesMedidas2 = _interopRequireDefault(_tablaUnidadesMedidas);
	
	var _tablaDepartamento = __webpack_require__(7063);
	
	var _tablaDepartamento2 = _interopRequireDefault(_tablaDepartamento);
	
	var _tablaMarca = __webpack_require__(7064);
	
	var _tablaMarca2 = _interopRequireDefault(_tablaMarca);
	
	var _tablaModelo = __webpack_require__(7065);
	
	var _tablaModelo2 = _interopRequireDefault(_tablaModelo);
	
	var _tablaTipoProducto = __webpack_require__(7069);
	
	var _tablaTipoProducto2 = _interopRequireDefault(_tablaTipoProducto);
	
	var _tablaProductosTemrinados = __webpack_require__(7068);
	
	var _tablaProductosTemrinados2 = _interopRequireDefault(_tablaProductosTemrinados);
	
	var _tablaClientes = __webpack_require__(7173);
	
	var _tablaClientes2 = _interopRequireDefault(_tablaClientes);
	
	var _tablaOperInventario = __webpack_require__(7066);
	
	var _tablaOperInventario2 = _interopRequireDefault(_tablaOperInventario);
	
	var _tablaOperInventariovacio = __webpack_require__(7067);
	
	var _tablaOperInventariovacio2 = _interopRequireDefault(_tablaOperInventariovacio);
	
	var _tablaVendedores = __webpack_require__(7183);
	
	var _tablaVendedores2 = _interopRequireDefault(_tablaVendedores);
	
	var _tablaProveedor = __webpack_require__(7182);
	
	var _tablaProveedor2 = _interopRequireDefault(_tablaProveedor);
	
	var _tablaBeneficiarios = __webpack_require__(7131);
	
	var _tablaBeneficiarios2 = _interopRequireDefault(_tablaBeneficiarios);
	
	var _tablaCuentasBancarias = __webpack_require__(7133);
	
	var _tablaCuentasBancarias2 = _interopRequireDefault(_tablaCuentasBancarias);
	
	var _panelPedidos = __webpack_require__(7171);
	
	var _panelPedidos2 = _interopRequireDefault(_panelPedidos);
	
	var _tablaMovimientoBancos = __webpack_require__(7134);
	
	var _tablaMovimientoBancos2 = _interopRequireDefault(_tablaMovimientoBancos);
	
	var _tablaMovimientoTransito = __webpack_require__(7107);
	
	var _tablaMovimientoTransito2 = _interopRequireDefault(_tablaMovimientoTransito);
	
	var _tablaOrdenCompra = __webpack_require__(7078);
	
	var _tablaOrdenCompra2 = _interopRequireDefault(_tablaOrdenCompra);
	
	var _tablaNotaEntrega = __webpack_require__(7178);
	
	var _tablaNotaEntrega2 = _interopRequireDefault(_tablaNotaEntrega);
	
	var _tablaFactura = __webpack_require__(7174);
	
	var _tablaFactura2 = _interopRequireDefault(_tablaFactura);
	
	var _tablaPresupuesto = __webpack_require__(7181);
	
	var _tablaPresupuesto2 = _interopRequireDefault(_tablaPresupuesto);
	
	var _tablaConciliacion = __webpack_require__(7132);
	
	var _tablaConciliacion2 = _interopRequireDefault(_tablaConciliacion);
	
	var _gestionCuentasCobrar = __webpack_require__(7109);
	
	var _gestionCuentasCobrar2 = _interopRequireDefault(_gestionCuentasCobrar);
	
	var _archivosExcel = __webpack_require__(7048);
	
	var _archivosExcel2 = _interopRequireDefault(_archivosExcel);
	
	var _gestionCuentasPagar = __webpack_require__(7110);
	
	var _gestionCuentasPagar2 = _interopRequireDefault(_gestionCuentasPagar);
	
	var _tablaFacturaOrdenCompra = __webpack_require__(7077);
	
	var _tablaFacturaOrdenCompra2 = _interopRequireDefault(_tablaFacturaOrdenCompra);
	
	var _tablaRetenciones = __webpack_require__(7135);
	
	var _tablaRetenciones2 = _interopRequireDefault(_tablaRetenciones);
	
	var _catalogoCuentasContable = __webpack_require__(7103);
	
	var _catalogoCuentasContable2 = _interopRequireDefault(_catalogoCuentasContable);
	
	var _asientosContables = __webpack_require__(7102);
	
	var _asientosContables2 = _interopRequireDefault(_asientosContables);
	
	var _tablaNotaDebito = __webpack_require__(7177);
	
	var _tablaNotaDebito2 = _interopRequireDefault(_tablaNotaDebito);
	
	var _tablaNotaCredito = __webpack_require__(7176);
	
	var _tablaNotaCredito2 = _interopRequireDefault(_tablaNotaCredito);
	
	var _tablaAnticipo = __webpack_require__(7130);
	
	var _tablaAnticipo2 = _interopRequireDefault(_tablaAnticipo);
	
	var _reversarPago = __webpack_require__(7129);
	
	var _reversarPago2 = _interopRequireDefault(_reversarPago);
	
	var _archivosExcelCliente = __webpack_require__(659);
	
	var _archivosExcelCliente2 = _interopRequireDefault(_archivosExcelCliente);
	
	var _tablaVacios = __webpack_require__(7156);
	
	var _tablaVacios2 = _interopRequireDefault(_tablaVacios);
	
	var _tablaClassVacios = __webpack_require__(7155);
	
	var _tablaClassVacios2 = _interopRequireDefault(_tablaClassVacios);
	
	var _tablaOrdenServicios = __webpack_require__(7147);
	
	var _tablaOrdenServicios2 = _interopRequireDefault(_tablaOrdenServicios);
	
	var _tablaGestionMoviles = __webpack_require__(7145);
	
	var _tablaGestionMoviles2 = _interopRequireDefault(_tablaGestionMoviles);
	
	var _tablaServicios = __webpack_require__(7148);
	
	var _tablaServicios2 = _interopRequireDefault(_tablaServicios);
	
	var _tablaNotaEntrega3 = __webpack_require__(7146);
	
	var _tablaNotaEntrega4 = _interopRequireDefault(_tablaNotaEntrega3);
	
	var _tablaPostVenta = __webpack_require__(7180);
	
	var _tablaPostVenta2 = _interopRequireDefault(_tablaPostVenta);
	
	var _tablaFacturaxNota = __webpack_require__(7175);
	
	var _tablaFacturaxNota2 = _interopRequireDefault(_tablaFacturaxNota);
	
	var _gestionGerencial = __webpack_require__(7139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MenuImpuestoPP() {
	  var _useContext = (0, _react.useContext)(_auth.AuthContext),
	      user = _useContext.user;
	
	  var pathname = window.location.pathname;
	
	  pathname === "/" ? "login" : pathname.substr(1);
	
	  var _useState = (0, _react.useState)(pathname.substr(1)),
	      _useState2 = _slicedToArray(_useState, 2),
	      path = _useState2[0],
	      setPath = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: ""
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      mensaje = _useState4[0],
	      setMensaje = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(),
	      _useState6 = _slicedToArray(_useState5, 2),
	      titulo = _useState6[0],
	      setTitulo = _useState6[1];
	
	  var cambiar = function cambiar(c) {
	    setPath(c);
	    setTitulo(c);
	  };
	
	  (0, _react.useEffect)(function () {
	    if (pathname === "/inicio") {
	      setTitulo("Inicio");
	    } else if (pathname === "/registroalmacen") {
	      setTitulo("Registro de Almacenes");
	    } else if (pathname === "/ubicacionalmacen") {
	      setTitulo("Ubicaciones de almacén");
	    } else if (pathname === "/unidadmedidas") {
	      setTitulo("Registro Unidades de Medida");
	    } else if (pathname === "/departamento") {
	      setTitulo("Registro de Departamento");
	    } else if (pathname === "/marca") {
	      setTitulo("Registro de Marcas");
	    } else if (pathname === "/modelo") {
	      setTitulo("Registro de Modelos");
	    } else if (pathname === "/vendedores") {
	      setTitulo("Registro de Vendedores");
	    } else if (pathname === "/proveedores") {
	      setTitulo("Registro de Proveedores");
	    } else if (pathname === "/clientes") {
	      setTitulo("Registro de Clientes");
	    } else if (pathname === "/beneficiarios") {
	      setTitulo("Registro de Beneficiarios");
	    } else if (pathname === "/cuentasbancarias") {
	      setTitulo("Registro de Cuentas Bancarias");
	    } else if (pathname === "/movimientobanca") {
	      setTitulo("Movimientos Bancarios");
	    } else if (pathname === "/operacionesinv") {
	      setTitulo("Operaciones de inventario");
	    } else if (pathname === "/movimientotransi") {
	      setTitulo("Movimientos Bancarios en Transito");
	    } else if (pathname === "/producto") {
	      setTitulo("Registro de Producto");
	    } else if (pathname === "/ordencompra") {
	      setTitulo("Ordenes de compra");
	    } else if (pathname === "/pedidos") {
	      setTitulo("Pedidos");
	    } else if (pathname === "/notaentrega") {
	      setTitulo("Notas de Entrega");
	    } else if (pathname === "/notadebito") {
	      setTitulo("Notas de Debito");
	    } else if (pathname === "/notacredito") {
	      setTitulo("Notas de Credito");
	    } else if (pathname === "/factura") {
	      setTitulo("Facturas");
	    } else if (pathname === "/conciliacion") {
	      setTitulo("Conciliación Bancaria");
	    } else if (pathname === "/cuentasxcobrar") {
	      setTitulo("Cuentas por Cobrar");
	    } else if (pathname === "/cuentasxpagar") {
	      setTitulo("Cuentas por Pagar");
	    } else if (pathname === "/excel") {
	      setTitulo("Actualización por Archivo XLSX");
	    } else if (pathname === "/presupuesto") {
	      setTitulo("Modulo de Presupuestos");
	    } else if (pathname === "/facturarordencompra") {
	      setTitulo("Facturación de Compras");
	    } else if (pathname === "/tiporetenciones") {
	      setTitulo("Tipo de Retenciones");
	    } else if (pathname === "/catalogoContable") {
	      setTitulo("Plan de Cuentas Contables");
	    } else if (pathname === "/asientoscontables") {
	      setTitulo("Asientos Contables");
	    } else if (pathname === "/anticipos") {
	      setTitulo("Anticipos");
	    } else if (pathname === "/controlvacios") {
	      setTitulo("Control de Vacios");
	    } else if (pathname === "/classvacios") {
	      setTitulo("Clasificador de Vacios");
	    } else if (pathname === "/orderservicio") {
	      setTitulo("Gestionar Ordenes");
	    } else if (pathname === "/gestionmoviles") {
	      setTitulo("Gestión de Móviles");
	    } else if (pathname === "/gestionservicios") {
	      setTitulo("Getionar Servicios");
	    } else if (pathname === "/notaentregaserv") {
	      setTitulo("Gestionar Notas de Entrega por Ordenes");
	    }
	  }, [pathname]);
	
	  var menu = user && _react2.default.createElement(
	    "div",
	    { className: "h-100 w-100" },
	    _react2.default.createElement(
	      "div",
	      { className: "d-flex bluex-bg h-100 w-100", id: "wrapper" },
	      path === "inicio" && _react2.default.createElement(_sidebar2.default, { onCambiar: cambiar }),
	      _react2.default.createElement(
	        "div",
	        { className: "h-100 w-100", id: "page-content-wrapper" },
	        _react2.default.createElement(_header2.default, { path: path, titulo: titulo, onCambiar: cambiar }),
	        _react2.default.createElement(
	          "div",
	          { className: "w-100 h-90", id: "scrol" },
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/inicio", component: _inicio2.default }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/bancos", component: _tablaBancos2.default }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/gestionGerencial", component: _gestionGerencial.GestionGerencial }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/registroalmacen", component: _nuevaTablaAlmacen2.default }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/ubicacionalmacen",
	            component: _nuevaTablaUbicacion2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/unidadmedidas",
	            component: _tablaUnidadesMedidas2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/departamento",
	            component: _tablaDepartamento2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/marca", component: _tablaMarca2.default }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/modelo", component: _tablaModelo2.default }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/tipoproducto",
	            component: _tablaTipoProducto2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/producto", component: _tablaProductosTemrinados2.default }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/clientes", component: _tablaClientes2.default }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/operacionesinv",
	            component: _tablaOperInventario2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/operacionesinvacio",
	            component: _tablaOperInventariovacio2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/orderservicio",
	            component: _tablaOrdenServicios2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/gestionmoviles",
	            component: _tablaGestionMoviles2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/gestionservicios",
	            component: _tablaServicios2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/vendedores", component: _tablaVendedores2.default }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/proveedores", component: _tablaProveedor2.default }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/beneficiarios",
	            component: _tablaBeneficiarios2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/cuentasbancarias",
	            component: _tablaCuentasBancarias2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/pedidos", component: _panelPedidos2.default }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/movimientobanca",
	            component: _tablaMovimientoBancos2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/movimientotransi",
	            component: _tablaMovimientoTransito2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/ordencompra", component: _tablaOrdenCompra2.default }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/notaentrega", component: _tablaNotaEntrega2.default }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/notadebito", component: _tablaNotaDebito2.default }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/notacredito", component: _tablaNotaCredito2.default }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/factura", component: _tablaFactura2.default }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/facturaxnota",
	            component: _tablaFacturaxNota2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/presupuesto", component: _tablaPresupuesto2.default }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/postventa", component: _tablaPostVenta2.default }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/conciliacion",
	            component: _tablaConciliacion2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/reversarpago",
	            component: _reversarPago2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/cuentasxcobrar",
	            component: _gestionCuentasCobrar2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/excel", component: _archivosExcel2.default }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/excelclientes",
	            component: _archivosExcelCliente2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/cuentasxpagar",
	            component: _gestionCuentasPagar2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/facturarordencompra",
	            component: _tablaFacturaOrdenCompra2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/tiporetenciones",
	            component: _tablaRetenciones2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/catalogoContable",
	            component: _catalogoCuentasContable2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/asientoscontables",
	            component: _asientosContables2.default
	          }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/anticipos", component: _tablaAnticipo2.default }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/controlvacios", component: _tablaVacios2.default }),
	          _react2.default.createElement(_AuthRoute2.default, { exact: true, path: "/classvacios", component: _tablaClassVacios2.default }),
	          _react2.default.createElement(_AuthRoute2.default, {
	            exact: true,
	            path: "/notaentregaserv",
	            component: _tablaNotaEntrega4.default
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(_foother2.default, null),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: "", texto: "" });
	      }
	    })
	  );
	  return menu;
	}
	exports.default = MenuImpuestoPP;

/***/ },
/* 7186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(121);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _moment = __webpack_require__(6);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _varios = __webpack_require__(14);
	
	var _mensajes = __webpack_require__(9);
	
	var _useTable2 = __webpack_require__(20);
	
	var _useTable3 = _interopRequireDefault(_useTable2);
	
	var _core = __webpack_require__(19);
	
	var _useBcv = __webpack_require__(676);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Inicio() {
	  var token = sessionStorage.getItem("jwtToken");
	  var op = __webpack_require__(8);
	  var fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
	  var anioActu = JSON.parse(sessionStorage.getItem("anioactu"));
	  var accinicio = JSON.parse(sessionStorage.getItem("accinicioc"));
	
	  var headCells = [{ label: "FECHA", textAlign: "center" }, { label: "FACTURA N°", textAlign: "center" }, { label: "MONTO", textAlign: "center" }, { label: "STATUS", textAlign: "center" }];
	
	  var txtLogo = (0, _react.useRef)();
	  var txtMoneda = (0, _react.useRef)();
	  var cmbMesEst = (0, _react.useRef)();
	  var txtAnio = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      activate = _useState2[0],
	      setActivate = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      labelMoneda = _useState4[0],
	      setLabelMoneda = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      labelVentas = _useState6[0],
	      setLabelVentas = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      valorVentas = _useState8[0],
	      setValorVentas = _useState8[1];
	
	  var _useState9 = (0, _react.useState)([]),
	      _useState10 = _slicedToArray(_useState9, 2),
	      valorCobrado = _useState10[0],
	      setValorCobrado = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([]),
	      _useState12 = _slicedToArray(_useState11, 2),
	      valorPorCobrado = _useState12[0],
	      setValorPorCobrado = _useState12[1];
	
	  var _useState13 = (0, _react.useState)([]),
	      _useState14 = _slicedToArray(_useState13, 2),
	      valor = _useState14[0],
	      setValor = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(true),
	      _useState16 = _slicedToArray(_useState15, 2),
	      bloqueado = _useState16[0],
	      setBloqueado = _useState16[1];
	
	  var _useState17 = (0, _react.useState)({
	    idmoneda: "",
	    descripcion: "",
	    simbolo: "",
	    predeterminada: "",
	    valormoneda: "",
	    subpredeterminada: true
	  }),
	      _useState18 = _slicedToArray(_useState17, 2),
	      idm = _useState18[0],
	      setIdm = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(0.0),
	      _useState20 = _slicedToArray(_useState19, 2),
	      total = _useState20[0],
	      setTotal = _useState20[1];
	
	  var _useState21 = (0, _react.useState)([]),
	      _useState22 = _slicedToArray(_useState21, 2),
	      tipo = _useState22[0],
	      setTipo = _useState22[1];
	
	  var _useState23 = (0, _react.useState)([]),
	      _useState24 = _slicedToArray(_useState23, 2),
	      datos = _useState24[0],
	      setDatos = _useState24[1];
	
	  var _useState25 = (0, _react.useState)([]),
	      _useState26 = _slicedToArray(_useState25, 2),
	      records = _useState26[0],
	      setRecords = _useState26[1];
	
	  var _useState27 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState28 = _slicedToArray(_useState27, 2),
	      mensaje = _useState28[0],
	      setMensaje = _useState28[1];
	
	  (0, _useBcv.useBcv)();
	
	  var _useState29 = (0, _react.useState)(0.0),
	      _useState30 = _slicedToArray(_useState29, 2),
	      totalVentas = _useState30[0],
	      setTotalVentas = _useState30[1];
	
	  var _useState31 = (0, _react.useState)(0.0),
	      _useState32 = _slicedToArray(_useState31, 2),
	      totalCobrado = _useState32[0],
	      setTotalCobrado = _useState32[1];
	
	  var _useState33 = (0, _react.useState)(0.0),
	      _useState34 = _slicedToArray(_useState33, 2),
	      totalAbAn = _useState34[0],
	      setTotalAbAn = _useState34[1];
	
	  var _useState35 = (0, _react.useState)(0.0),
	      _useState36 = _slicedToArray(_useState35, 2),
	      totalPorCobrar = _useState36[0],
	      setTotalPorCobrar = _useState36[1];
	
	  var _useState37 = (0, _react.useState)([]),
	      _useState38 = _slicedToArray(_useState37, 2),
	      colorG = _useState38[0],
	      setColorG = _useState38[1];
	
	  var _useState39 = (0, _react.useState)({
	    fn: function fn(items) {
	      return items;
	    }
	  }),
	      _useState40 = _slicedToArray(_useState39, 2),
	      filterFn = _useState40[0],
	      setFilterFn = _useState40[1];
	
	  var _useTable = (0, _useTable3.default)(records, headCells, filterFn),
	      TblContainer = _useTable.TblContainer,
	      TblHead = _useTable.TblHead,
	      TblPagination = _useTable.TblPagination,
	      recordsAfterPagingAndSorting = _useTable.recordsAfterPagingAndSorting;
	
	  var handleSearch = function handleSearch(e) {
	    var target = e.target;
	
	    setFilterFn({
	      fn: function fn(items) {
	        if (target.value === "") {
	          return items;
	        } else {
	          return items.filter(function (x) {
	            if ((0, _moment2.default)(x.fecha).format("DD-MM-YYYY").toLowerCase().includes(target.value.toLowerCase()) || x.numfactura.toLowerCase().includes(target.value.toLowerCase()) || (0, _varios.formatMoneda)(x.totalmonto.toString().replace(",", "").replace(".", ","), ",", ".", 2).toLowerCase().includes(target.value.toLowerCase()) || (x.status === 0 ? "Por Cobrar" : "Cobrada").toLowerCase().includes(target.value.toLowerCase())) {
	              return x;
	            }
	          });
	        }
	      }
	    });
	  };
	
	  var seleccionarFacturas = function seleccionarFacturas() {
	    var endpoint = op.conexion + "/api/registropago/seleccionarfacturas?&status=5&anio=" + txtAnio.current.value + "&mes=" + cmbMesEst.current.value;
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        if (response.data.length > 0) {
	          setRecords(response.data);
	          var vnt = 0.0;
	          var cbd = 0.0;
	          var pcb = 0.0;
	          var abono = 0.0;
	          var anticipos = 0.0;
	          var totalxcobrar = 0.0;
	          var totalpagados = 0.0;
	          var clientArray = [];
	
	          for (var i = 0; i < response.data.length; i++) {
	            vnt = parseFloat(response.data[i].totalmonto) > 0 ? parseFloat(vnt) + parseFloat(response.data[i].totalmonto) : parseFloat(vnt);
	            abono = abono + parseFloat(response.data[i].abono);
	
	            if (response.data[i].status === 1) {
	              cbd = cbd + parseFloat(response.data[i].totalmonto);
	            }
	
	            if (response.data[i].status === 0 && parseFloat(response.data[i].totalmonto) > 0) {
	              pcb = pcb + parseFloat(response.data[i].totalmonto);
	            }
	          }
	
	          for (var e = 0; e < response.data.length; e++) {
	
	            if (!clientArray.includes(response.data[e].idaganticipo)) {
	              clientArray.push(response.data[e].idaganticipo);
	              anticipos = anticipos + parseFloat(response.data[e].anticipo);
	            }
	          }
	
	          totalxcobrar = (0, _varios.round)(pcb, 2);
	          totalpagados = (0, _varios.round)(cbd, 2);
	
	          setTotalVentas(vnt);
	          setTotalCobrado(totalpagados);
	          setTotalPorCobrar(totalxcobrar);
	          setTotalAbAn(anticipos + abono);
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarFacturasAnual = function seleccionarFacturasAnual() {
	    var campos = "deudas.mes,\n    sum(deudas.totalpagado) as pagado,\n    sum(deudas.totalventa) as venta,\n    sum(deudas.porpagar) as pagar";
	    var nomtab = "(\n      select sum(totalmonto) as totalventa,  sum(iif(status = 0, totalmonto, 0.00)) as porpagar,  sum(iif(status = 1, totalmonto, 0.00)) as totalpagado, TO_CHAR(fecha,'MM') as mes \n              from notaentrega where status !=4 and tipo!='NO' and tipo!='NC' and idfactura isnull and  TO_CHAR(fecha,'YYYY') = " + txtAnio.current.value + "::text group by mes) deudas group by mes";
	    var orden = "mes asc";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var lb = [];
	        var dt = [];
	        var cb = [];
	        var vpc = [];
	
	        if (response.data.length > 0) {
	          console.log('si pase', response.data);
	          for (var i = 0; i < response.data.length; i++) {
	            dt.push(response.data[i].venta);
	            cb.push(response.data[i].pagado);
	            vpc.push(response.data[i].pagar);
	            lb.push((0, _varios.cmes)(parseInt(response.data[i].mes)));
	          }
	        }
	        console.log('si pase', dt, cb, vpc, lb);
	        setLabelVentas(lb);
	        setValorVentas(dt);
	        setValorCobrado(cb);
	        setValorPorCobrado(vpc);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var onChange = function onChange(e) {
	    if (e.target.name === "mesEst") {
	      setTotalVentas(0.0);
	      setTotalCobrado(0.0);
	      setTotalPorCobrar(0.0);
	      setRecords([]);
	      seleccionarFacturas();
	    }
	
	    if (e.target.name === "anio") {
	      setTotalVentas(0.0);
	      setTotalCobrado(0.0);
	      setTotalPorCobrar(0.0);
	      setRecords([]);
	      seleccionarFacturas();
	      seleccionarFacturasAnual();
	    }
	
	    if (e.target.name === "mes") {
	      seleccionarMesMoneda(e.target.value, txtLogo.current.value, (0, _moment2.default)(fechaSistema).format("YYYY"));
	      setValor([]);
	      setLabelMoneda([]);
	      setTotal(0.0);
	    }
	
	    if (e.target.name === "logo") {
	      var val = e.target.value;
	      setIdm(tipo[e.target.options.selectedIndex]);
	      txtMoneda.current.value = "";
	      setValor([]);
	      setLabelMoneda([]);
	
	      if (val > 0) {
	        setBloqueado(false);
	        txtMoneda.current.focus();
	      } else {
	        setBloqueado(true);
	      }
	    }
	  };
	
	  var seleccionarRegistros = function seleccionarRegistros() {
	    var campos = "*";
	    var nomtab = "moneda";
	    var orden = "idmoneda";
	
	    var endpoint = op.conexion + "/api/comun/seleccionaregistros?&campos=" + campos + "&nomtab=" + nomtab + "&orden=" + orden;
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status === 200) {
	        var element = [];
	        var color = [];
	        var monedasub = {
	          idmoneda: "",
	          descripcion: "",
	          simbolo: "",
	          predeterminada: "",
	          valormoneda: "",
	          subpredeterminada: true
	        };
	
	        if (response.data.length > 0) {
	          setTipo(response.data);
	
	          for (var i = 0; i < response.data.length; i++) {
	            color.push(_varios.colores[i]);
	            element.push({
	              nombre: response.data[i].descripcion,
	              valor: (0, _varios.formatMoneda)(response.data[i].valormoneda.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	              color: _varios.colores[i]
	            });
	            if (response.data[i].subpredeterminada) {
	              monedasub = response.data[i];
	            }
	          }
	
	          setColorG(color);
	          setDatos(element);
	          setIdm(monedasub);
	          txtLogo.current.value = monedasub.idmoneda;
	          txtMoneda.current.value = (0, _moment2.default)(fechaSistema).format("MM");
	          setBloqueado(false);
	          seleccionarMesMoneda((0, _moment2.default)(fechaSistema).format("MM"), monedasub.idmoneda, (0, _moment2.default)(fechaSistema).format("YYYY"));
	        }
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var seleccionarMesMoneda = function seleccionarMesMoneda(m, id, a) {
	    var endpoint = op.conexion + "/api/moneda/seleccionarmoneda?m=" + m.toString() + "&id=" + id + "&a=" + a.toString();
	
	    setActivate(true);
	
	    _axios2.default.get(endpoint, {
	      headers: {
	        "x-access-token": "" + token
	      }
	    }).then(function (response) {
	      if (response.status == 200) {
	        if (response.data.length > 0) {
	          var to = 0;
	          var te = 0;
	          var contar = 0;
	          var label = [];
	          var datos = [];
	
	          for (var i = 0; i < response.data.length; i++) {
	            contar = contar + 1;
	            label.push((0, _moment2.default)(response.data[i].fecha).format("DD-MM"));
	            datos.push(response.data[i].valor);
	          }
	
	          if (contar > 1) {
	            to = contar - 2;
	            te = contar - 1;
	          }
	
	          setValor(datos);
	          setLabelMoneda(label);
	
	          var porcp = 0.0;
	          var totalpcp = 0.0;
	          var totalreal = 0.0;
	
	          if (datos[to] > datos[te]) {
	            porcp = datos[to] / datos[te] * 100;
	            totalreal = 100 - porcp;
	            totalpcp = (0, _varios.formatMoneda)(totalreal.toString().replace(".", ","), ",", ".", 2);
	            setTotal(totalpcp);
	          } else if (datos[to] < datos[te]) {
	            porcp = datos[to] / datos[te] * 100;
	            totalreal = 100 - porcp;
	            totalpcp = (0, _varios.formatMoneda)(totalreal.toString().replace(".", ","), ",", ".", 2);
	            setTotal(totalpcp);
	          }
	        } else {
	          setValor([]);
	          setLabelMoneda([]);
	          setTotal(0.0);
	        }
	        setActivate(false);
	      }
	    }).catch(function (error) {
	      setMensaje({
	        mostrar: true,
	        titulo: "Error",
	        texto: error.response.data.message,
	        icono: "error"
	      });
	      setActivate(false);
	    }).finally(function () {
	      setActivate(false);
	    });
	  };
	
	  var options = {
	    responsive: false,
	    legend: {
	      position: "top"
	    },
	    title: {
	      display: true,
	      text: "Ventas Anuales"
	    }
	  };
	
	  var data = {
	    labels: labelVentas,
	    datasets: [{
	      label: "Ventas",
	      data: valorVentas,
	      borderColor: "#28a745",
	      backgroundColor: "#28a745"
	    }, {
	      label: "Cobrado",
	      data: valorCobrado,
	      borderColor: "#ffc107",
	      backgroundColor: "#ffc107"
	    }, {
	      label: "Por Cobrar",
	      data: valorPorCobrado,
	      borderColor: "#dc3545",
	      backgroundColor: "#dc3545"
	    }]
	  };
	
	  var dataTorta = {
	    labels: ["Cobrado", "Abonos/Anticipos", "Por Cobrar"],
	    leyend: true,
	    datasets: [{
	      label: "#",
	      data: [totalCobrado.toFixed(2), totalAbAn.toFixed(2), (totalPorCobrar - totalAbAn).toFixed(2)],
	      backgroundColor: ["#ffc107", "#17a2b8", "#dc3545"],
	      borderColor: ["#ffc107", "#17a2b8", "#dc3545"],
	      borderWidth: 1,
	      hoverBorderWidth: 15
	    }]
	  };
	
	  var optionsTorta = {
	    responsive: false,
	    legend: {
	      position: "top",
	      display: true
	    },
	    title: {
	      display: true,
	      text: "Total en Ventas: " + (0, _varios.formatMoneda)(totalVentas.toString().replace(",", "").replace(".", ","), ",", ".", 2)
	    }
	  };
	
	  var optionsMoneda = {
	    responsive: false,
	    title: {
	      display: true,
	      text: "Variación de la Moneda"
	    },
	    legend: {
	      position: "top",
	      display: true
	    }
	  };
	
	  var dataMoneda = {
	    labels: labelMoneda,
	    datasets: [{
	      label: idm.descripcion + " " + idm.simbolo,
	      data: valor,
	      borderColor: "rgba(0, 98, 204)"
	    }]
	  };
	
	  (0, _react.useEffect)(function () {
	    if (accinicio && accinicio.substring(0, 1) === "1") {
	      seleccionarRegistros();
	      seleccionarFacturas();
	      seleccionarFacturasAnual();
	    } else {
	      seleccionarRegistros();
	    }
	  }, []);
	
	  return _react2.default.createElement(
	    "div",
	    { className: "col-md-12 d-flex justify-content-center container-fluid p-2 m-0 h-100" },
	    _react2.default.createElement(
	      _semanticUiReact.Dimmer,
	      { active: activate, inverted: true },
	      _react2.default.createElement(
	        _semanticUiReact.Loader,
	        { inverted: true },
	        "cargando..."
	      )
	    ),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    accinicio && accinicio.substring(0, 1) === "1" ? _react2.default.createElement(
	      "div",
	      { className: "row h-100 col-md-12 p-0 m-0" },
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-6 mx-auto h-100" },
	        _react2.default.createElement(
	          "div",
	          {
	            className: "card p-0 mb-1 col-md-12 h-50 justify-content-center",
	            style: { display: "grid" }
	          },
	          _react2.default.createElement(_reactChartjs.Bar, { options: options, height: 300, width: 500, data: data })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "card col-md-12 h-50 p-0" },
	          _react2.default.createElement(
	            "div",
	            { className: "card-body row p-0" },
	            _react2.default.createElement(
	              "div",
	              { className: "p-0 m-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "card-body row m-0 p-0" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-4 ml-auto" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-10 ml-auto mt-3" },
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        ref: txtLogo,
	                        name: "logo",
	                        onChange: onChange,
	                        className: "form-select form-select-sm",
	                        "aria-label": ".form-select-sm example"
	                      },
	                      tipo && tipo.map(function (item, index) {
	                        return _react2.default.createElement(
	                          "option",
	                          { key: index, value: item.idmoneda },
	                          item.simbolo,
	                          ".",
	                          item.descripcion
	                        );
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-4 ml-auto" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-10 text-center ml-auto mt-3" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "d-flex justify-content-center" },
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        total.toString().includes("-") ? _react2.default.createElement("i", { className: "fas fa-arrow-down text-danger me-2" }) : _react2.default.createElement("i", { className: "fas fa-arrow-up text-success me-2" })
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        {
	                          style: {
	                            color: total.toString().includes("-") ? "#F93154" : "#00B74A"
	                          },
	                          className: "fw-bold"
	                        },
	                        total
	                      ),
	                      _react2.default.createElement(
	                        "span",
	                        null,
	                        total.toString().includes("-") ? _react2.default.createElement("i", { className: "fas fa-percent text-danger" }) : _react2.default.createElement("i", { className: "fas fa-percent text-success" })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-4 ml-auto" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-md-7 ml-auto mt-3" },
	                    _react2.default.createElement(
	                      "select",
	                      {
	                        className: "form-select form-select-sm text-uppercase",
	                        disabled: bloqueado,
	                        ref: txtMoneda,
	                        defaultValue: (0, _moment2.default)(fechaSistema).format("MM"),
	                        name: "mes",
	                        "aria-label": ".form-select-sm example",
	                        onChange: onChange
	                      },
	                      _react2.default.createElement(
	                        "option",
	                        { value: "" },
	                        "Mes"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "01" },
	                        "Enero"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "02" },
	                        "Febrero"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "03" },
	                        "Marzo"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "04" },
	                        "Abril"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "05" },
	                        "Mayo"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "06" },
	                        "Junio"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "07" },
	                        "Julio"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "08" },
	                        "Agosto"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "09" },
	                        "Septiembre"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "10" },
	                        "Octubre"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "11" },
	                        "Noviembre"
	                      ),
	                      _react2.default.createElement(
	                        "option",
	                        { value: "12" },
	                        "Diciembre"
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  {
	                    className: "col-md-12 justify-content-center",
	                    style: { display: "grid" }
	                  },
	                  _react2.default.createElement(_reactChartjs.Line, {
	                    options: optionsMoneda,
	                    height: 300,
	                    width: 500,
	                    data: dataMoneda
	                  })
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row col-md-6 mx-auto h-100" },
	        _react2.default.createElement(
	          "div",
	          { className: "row col-md-12 card h-100" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12 row mx-auto py-3 justify-content-end" },
	            _react2.default.createElement(
	              "div",
	              { className: " col-md-6 bg-light border-azul row h-50 justify-content-center rounded mx-auto px-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 py-2 ", style: { height: "40%" } },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row col-md-12 bg-primary text-center rounded p-2 shadow h-100 mx-auto" },
	                  _react2.default.createElement(
	                    "label",
	                    { className: "text- mt-3 col-12" },
	                    "Datos Estadisticos"
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-select form-select-sm rounded mx-auto col-md-6 text-center fw-bold text-uppercase",
	                      name: "mesEst",
	                      ref: cmbMesEst,
	                      "aria-label": ".form-select-sm example",
	                      onChange: onChange
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "anual" },
	                      " - Anual - "
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "01" },
	                      " - Enero - "
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "02" },
	                      " - Febrero - "
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "03" },
	                      " - Marzo - "
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "04" },
	                      " - Abril - "
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "05" },
	                      " - Mayo - "
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "06" },
	                      " - Junio - "
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "07" },
	                      " - Julio - "
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "08" },
	                      " - Agosto - "
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "09" },
	                      " - Septiembre - "
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "10" },
	                      " - Octubre - "
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "11" },
	                      " - Noviembre - "
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "12" },
	                      " - Diciembre - "
	                    )
	                  ),
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "col-md-5 form-select form-select-sm text-center fw-bold  text-uppercase",
	                      ref: txtAnio,
	                      defaultValue: anioActu,
	                      name: "anio",
	                      onChange: onChange,
	                      "aria-label": ".form-select-sm example"
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: anioActu },
	                      anioActu
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: anioActu - 1 },
	                      anioActu - 1
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: anioActu - 2 },
	                      anioActu - 2
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-12 h-100 mb-2" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 bg-success mt-2 py-2 mx-auto rounded shadow d-flex align-items-center" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm justify-content-between" },
	                    _react2.default.createElement(
	                      "span",
	                      {
	                        className: "input-group-text border-0 bg-transparent fw-bold text-light fs-6",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "Total en Ventas:"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control col-md-6 rounded bg-transparent border-0 fw-bold text-right text-light",
	                      style: { fontSize: "0.9rem" },
	                      value: (0, _varios.formatMoneda)(totalVentas.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                      disabled: true,
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 bg-warning mt-2 py-2 mx-auto rounded shadow d-flex align-items-center" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm justify-content-between" },
	                    _react2.default.createElement(
	                      "span",
	                      {
	                        className: "input-group-text border-0 bg-transparent fw-bold fs-6",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "Total Cobrado:"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control col-md-6 rounded bg-transparent border-0 fw-bold text-right",
	                      style: { fontSize: "0.9rem" },
	                      value: (0, _varios.formatMoneda)(totalCobrado.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                      disabled: true,
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 bg-info mt-2 py-2 mx-auto rounded shadow d-flex align-items-center" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm justify-content-between" },
	                    _react2.default.createElement(
	                      "span",
	                      {
	                        className: "input-group-text border-0 bg-transparent fw-bold fs-6",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "Total Abonos/Anticipos:"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control col-md-6 rounded bg-transparent border-0 fw-bold text-right",
	                      style: { fontSize: "0.9rem" },
	                      value: (0, _varios.formatMoneda)(totalAbAn.toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                      disabled: true,
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12 bg-danger mt-2 py-2 mx-auto rounded shadow d-flex align-items-center" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group input-group-sm justify-content-between" },
	                    _react2.default.createElement(
	                      "span",
	                      {
	                        className: "input-group-text border-0 bg-transparent fw-bold text-light fs-6",
	                        id: "inputGroup-sizing-sm"
	                      },
	                      "Total por Cobrar:"
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      className: "form-control col-md-6 rounded bg-transparent border-0 fw-bold text-right text-light",
	                      style: { fontSize: "0.9rem" },
	                      value: (0, _varios.formatMoneda)((totalPorCobrar - totalAbAn).toString().replace(",", "").replace(".", ","), ",", ".", 2),
	                      disabled: true,
	                      "aria-label": "Sizing example input",
	                      "aria-describedby": "inputGroup-sizing-sm"
	                    })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-6 h-50 mx-auto justify-content-center",
	                style: { display: "grid" }
	              },
	              _react2.default.createElement(_reactChartjs.Pie, {
	                options: optionsTorta,
	                height: 300,
	                width: 300,
	                data: dataTorta
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "row col-md-12 mt-5" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group col-md-3 input-group-sm" },
	                _react2.default.createElement("input", {
	                  type: "text",
	                  onChange: handleSearch,
	                  placeholder: "Buscar",
	                  title: "Buscar Factura",
	                  className: "form-control"
	                }),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    className: "btn",
	                    style: {
	                      pointerEvents: "none",
	                      backgroundColor: "rgba(5, 81, 130, 1)",
	                      color: "#FFFFFF"
	                    }
	                  },
	                  _react2.default.createElement("i", { className: "fa fa-search" })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12 h-50 mt-3 px-0 mx-0 rounded" },
	              _react2.default.createElement(
	                TblContainer,
	                {
	                  container: {
	                    height: 310,
	                    width: "100%",
	                    overflow: "auto",
	                    padding: "2px"
	                  }
	                },
	                _react2.default.createElement(TblHead, null),
	                _react2.default.createElement(
	                  _core.TableBody,
	                  { className: "overflow-hidden table-bordered" },
	                  records && recordsAfterPagingAndSorting().map(function (item, index) {
	                    return _react2.default.createElement(
	                      _core.TableRow,
	                      {
	                        key: index,
	                        style: { padding: "0", fontSizeAdjust: "0.6" }
	                      },
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-baseline bg-light",
	                          style: { textAlign: "center", width: "180px" }
	                        },
	                        (0, _moment2.default)(item.fecha).format("DD-MM-YYYY")
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-baseline bg-light",
	                          style: { textAlign: "center", width: "180px" }
	                        },
	                        item.numfactura
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-baseline bg-light",
	                          style: { textAlign: "center", width: "180px" }
	                        },
	                        (0, _varios.formatMoneda)((item.totalmonto - item.abono).toString().replace(",", "").replace(".", ","), ",", ".", 2)
	                      ),
	                      _react2.default.createElement(
	                        _core.TableCell,
	                        {
	                          className: "align-baseline bg-light",
	                          style: { textAlign: "center", width: "180px" }
	                        },
	                        item.status === 0 ? _react2.default.createElement(
	                          "span",
	                          { className: "text-danger fw-bold" },
	                          "Por Cobrar"
	                        ) : _react2.default.createElement(
	                          "span",
	                          { className: "text-success fw-bold" },
	                          "Cobrada"
	                        )
	                      )
	                    );
	                  })
	                )
	              ),
	              _react2.default.createElement(TblPagination, null)
	            )
	          )
	        )
	      )
	    ) : _react2.default.createElement(
	      "div",
	      { className: "row h-100 col-md-12 p-0 m-0" },
	      _react2.default.createElement(
	        "div",
	        { className: "card col-md-12 h-50 p-0" },
	        _react2.default.createElement(
	          "div",
	          { className: "card-body row p-0" },
	          _react2.default.createElement(
	            "div",
	            { className: "p-0 m-0" },
	            _react2.default.createElement(
	              "div",
	              { className: "card-body row m-0 p-0" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-2" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-10 ml-auto mt-3" },
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      ref: txtLogo,
	                      name: "logo",
	                      onChange: onChange,
	                      className: "form-select form-select-sm",
	                      "aria-label": ".form-select-sm example"
	                    },
	                    tipo && tipo.map(function (item, index) {
	                      return _react2.default.createElement(
	                        "option",
	                        { key: index, value: item.idmoneda },
	                        item.simbolo,
	                        ".",
	                        item.descripcion
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-4 mx-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-10 text-center ml-auto mt-3" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "d-flex justify-content-center" },
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      total.toString().includes("-") ? _react2.default.createElement("i", { className: "fas fa-arrow-down text-danger me-2" }) : _react2.default.createElement("i", { className: "fas fa-arrow-up text-success me-2" })
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      {
	                        style: {
	                          color: total.toString().includes("-") ? "#F93154" : "#00B74A"
	                        },
	                        className: "fw-bold"
	                      },
	                      total
	                    ),
	                    _react2.default.createElement(
	                      "span",
	                      null,
	                      total.toString().includes("-") ? _react2.default.createElement("i", { className: "fas fa-percent text-danger" }) : _react2.default.createElement("i", { className: "fas fa-percent text-success" })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-2 ml-auto" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-7 ml-auto mt-3" },
	                  _react2.default.createElement(
	                    "select",
	                    {
	                      className: "form-select form-select-sm text-uppercase",
	                      disabled: bloqueado,
	                      ref: txtMoneda,
	                      defaultValue: (0, _moment2.default)(fechaSistema).format("MM"),
	                      name: "mes",
	                      "aria-label": ".form-select-sm example",
	                      onChange: onChange
	                    },
	                    _react2.default.createElement(
	                      "option",
	                      { value: "" },
	                      "Mes"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "01" },
	                      "Enero"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "02" },
	                      "Febrero"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "03" },
	                      "Marzo"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "04" },
	                      "Abril"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "05" },
	                      "Mayo"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "06" },
	                      "Junio"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "07" },
	                      "Julio"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "08" },
	                      "Agosto"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "09" },
	                      "Septiembre"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "10" },
	                      "Octubre"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "11" },
	                      "Noviembre"
	                    ),
	                    _react2.default.createElement(
	                      "option",
	                      { value: "12" },
	                      "Diciembre"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                {
	                  className: "col-md-12 justify-content-center",
	                  style: { display: "grid" }
	                },
	                _react2.default.createElement(_reactChartjs.Line, {
	                  options: optionsMoneda,
	                  height: 600,
	                  width: 900,
	                  data: dataMoneda
	                })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	exports.default = Inicio;

/***/ },
/* 7187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(69);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _auth = __webpack_require__(106);
	
	var _hooks = __webpack_require__(7192);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _mensajes = __webpack_require__(9);
	
	var _Fade = __webpack_require__(7007);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _Zoom = __webpack_require__(7009);
	
	var _Zoom2 = _interopRequireDefault(_Zoom);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _recuperarClave = __webpack_require__(7188);
	
	__webpack_require__(7196);
	
	var _catalogoSistema = __webpack_require__(7044);
	
	var _catalogoSistema2 = _interopRequireDefault(_catalogoSistema);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function Login(props) {
	  var _this = this;
	
	  var loginUserCallback = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              if (!(values.username === "sistema" || values.username === "sistema2" || values.username === "bimbo")) {
	                _context2.next = 4;
	                break;
	              }
	
	              setModalSistema({
	                mostrar: true,
	                idfranquicia: values.username === "bimbo" ? 3 : 5
	              });
	              _context2.next = 6;
	              break;
	
	            case 4:
	              _context2.next = 6;
	              return sinIgn();
	
	            case 6:
	            case "end":
	              return _context2.stop();
	          }
	        }
	      }, _callee2, this);
	    }));
	
	    return function loginUserCallback() {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      loading = _useState2[0],
	      setLoading = _useState2[1];
	
	  var op = __webpack_require__(8);
	
	  var context = (0, _react.useContext)(_auth.AuthContext);
	
	  var _useForm = (0, _hooks.useForm)(loginUserCallback, {
	    username: "",
	    password: ""
	  }),
	      onChange = _useForm.onChange,
	      onSubmit = _useForm.onSubmit,
	      values = _useForm.values;
	
	  var _useState3 = (0, _react.useState)("password"),
	      _useState4 = _slicedToArray(_useState3, 2),
	      tipoInput = _useState4[0],
	      setTipoInput = _useState4[1];
	
	  var _useState5 = (0, _react.useState)("fas fa-eye"),
	      _useState6 = _slicedToArray(_useState5, 2),
	      iconeye = _useState6[0],
	      setIconEye = _useState6[1];
	  // Bloquea el autocompletado/guardado de clave del navegador. El campo inicia
	  // readonly y se libera al tocarlo: onTouchStart/onPointerDown se disparan en
	  // móvil ANTES de que aparezca el teclado, por lo que sí funciona en móvil.
	
	
	  var _useState7 = (0, _react.useState)(true),
	      _useState8 = _slicedToArray(_useState7, 2),
	      bloqueoPass = _useState8[0],
	      setBloqueoPass = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      modalClave = _useState10[0],
	      setModalClave = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({
	    mostrar: false,
	    idfranquicia: null
	  }),
	      _useState12 = _slicedToArray(_useState11, 2),
	      modalSistema = _useState12[0],
	      setModalSistema = _useState12[1];
	
	  var txtUserName = (0, _react.useRef)(null);
	  var txtPassword = (0, _react.useRef)(null);
	
	  var _useState13 = (0, _react.useState)({
	    mostrar: false,
	    titulo: "",
	    texto: "",
	    icono: ""
	  }),
	      _useState14 = _slicedToArray(_useState13, 2),
	      mensaje = _useState14[0],
	      setMensaje = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(true),
	      _useState16 = _slicedToArray(_useState15, 2),
	      activo = _useState16[0],
	      setActivo = _useState16[1];
	
	  var verificar = function verificar() {
	    var endpoint = op.validar + "/api/athos/sistema/verificar/5";
	    _axios2.default.post(endpoint).then(function (response) {
	      if (response.status === 200) {
	        setActivo(response.data.activo);
	      }
	    }).catch(function (error) {
	      console.log(error);
	    });
	  };
	
	  var sinIgn = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var idorg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	      var endpoint, login, passwd;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              setLoading(true);
	              endpoint = op.conexion + "/api/athos/auth/signin";
	              login = values.username;
	              passwd = values.password;
	
	
	              _axios2.default.post(endpoint, {
	                login: login,
	                passwd: passwd,
	                idorg: idorg
	              }).then(function (response) {
	                if (response.status === 200) {
	                  context.login(response.data.token);
	                  if (response.data.token === null) {
	                    props.history.push("/");
	                  } else {
	                    sessionStorage.setItem("txtmodulo", JSON.stringify(response.data.txtmodulo));
	                    sessionStorage.setItem("txtfranquicia", JSON.stringify(response.data.txtfranquicia));
	                    sessionStorage.setItem("idusuario", JSON.stringify(response.data.idusuario));
	                    sessionStorage.setItem("idagente", JSON.stringify(response.data.idagente));
	                    sessionStorage.setItem("numcaja", JSON.stringify(response.data.numcaja));
	                    sessionStorage.setItem("login", JSON.stringify(response.data.login));
	                    sessionStorage.setItem("fechasistema", JSON.stringify(response.data.fechasistema));
	                    sessionStorage.setItem("anioactu", JSON.stringify(response.data.anioactu));
	                    sessionStorage.setItem("idorganizacion", JSON.stringify(response.data.idorganizacion));
	                    sessionStorage.setItem("permisos", JSON.stringify(response.data.permisos));
	                    sessionStorage.setItem("accconfiggene", JSON.stringify(response.data.accconfiggene));
	                    sessionStorage.setItem("accopbd", JSON.stringify(response.data.accopbd));
	                    sessionStorage.setItem("accinventarioc", JSON.stringify(response.data.accinventarioc));
	                    sessionStorage.setItem("accventasc", JSON.stringify(response.data.accventasc));
	                    sessionStorage.setItem("acccomprasc", JSON.stringify(response.data.acccomprasc));
	                    sessionStorage.setItem("acccontabilidadc", JSON.stringify(response.data.acccontabilidadc));
	                    sessionStorage.setItem("accfinanzasc", JSON.stringify(response.data.accfinanzasc));
	                    sessionStorage.setItem("accbtnregalmacenc", JSON.stringify(response.data.accbtnregalmacenc));
	                    sessionStorage.setItem("accbtnubialmacenc", JSON.stringify(response.data.accbtnubialmacenc));
	                    sessionStorage.setItem("accbtnumedidac", JSON.stringify(response.data.accbtnumedidac));
	                    sessionStorage.setItem("accbtnmarcac", JSON.stringify(response.data.accbtnmarcac));
	                    sessionStorage.setItem("accbtnmodeloc", JSON.stringify(response.data.accbtnmodeloc));
	                    sessionStorage.setItem("accbtntproductoc", JSON.stringify(response.data.accbtntproductoc));
	                    sessionStorage.setItem("accbtnproductoc", JSON.stringify(response.data.accbtnproductoc));
	                    sessionStorage.setItem("accbtnopinventarioc", JSON.stringify(response.data.accbtnopinventarioc));
	                    sessionStorage.setItem("accbtnactxlsxc", JSON.stringify(response.data.accbtnactxlsxc));
	                    sessionStorage.setItem("accbtntvaciosc", JSON.stringify(response.data.accbtntvaciosc));
	                    sessionStorage.setItem("accbtnireportsc", JSON.stringify(response.data.accbtnireportsc));
	                    sessionStorage.setItem("accbtnclientesc", JSON.stringify(response.data.accbtnclientesc));
	                    sessionStorage.setItem("accbtnvendedorc", JSON.stringify(response.data.accbtnvendedorc));
	                    sessionStorage.setItem("accbtnpedidosc", JSON.stringify(response.data.accbtnpedidosc));
	                    sessionStorage.setItem("accbtnnentregac", JSON.stringify(response.data.accbtnnentregac));
	                    sessionStorage.setItem("accbtnndebitoc", JSON.stringify(response.data.accbtnndebitoc));
	                    sessionStorage.setItem("accbtnfacturasc", JSON.stringify(response.data.accbtnfacturasc));
	                    sessionStorage.setItem("accbtnpresupuestoc", JSON.stringify(response.data.accbtnpresupuestoc));
	                    sessionStorage.setItem("accbtnvreportsc", JSON.stringify(response.data.accbtnvreportsc));
	                    sessionStorage.setItem("accbtnproveedoresc", JSON.stringify(response.data.accbtnproveedoresc));
	                    sessionStorage.setItem("accbtnordencomprac", JSON.stringify(response.data.accbtnordencomprac));
	                    sessionStorage.setItem("accbtnfactucomprac", JSON.stringify(response.data.accbtnfactucomprac));
	                    sessionStorage.setItem("accbtncreportsc", JSON.stringify(response.data.accbtncreportsc));
	                    sessionStorage.setItem("accbtncntcontablec", JSON.stringify(response.data.accbtncntcontablec));
	                    sessionStorage.setItem("accbtnastcntablec", JSON.stringify(response.data.accbtnastcntablec));
	                    sessionStorage.setItem("accbtnmvbancariosc", JSON.stringify(response.data.accbtnmvbancariosc));
	                    sessionStorage.setItem("accbtnmvbancariostc", JSON.stringify(response.data.accbtnmvbancariostc));
	                    sessionStorage.setItem("accbtnvinculacuentac", JSON.stringify(response.data.accbtnvinculacuentac));
	                    sessionStorage.setItem("accbtncntreportsc", JSON.stringify(response.data.accbtncntreportsc));
	                    sessionStorage.setItem("accbtnbancosc", JSON.stringify(response.data.accbtnbancosc));
	                    sessionStorage.setItem("accbtnbeneficiariosc", JSON.stringify(response.data.accbtnbeneficiariosc));
	                    sessionStorage.setItem("accbtnctsbancariasc", JSON.stringify(response.data.accbtnctsbancariasc));
	                    sessionStorage.setItem("accbtncnciliabancariac", JSON.stringify(response.data.accbtncnciliabancariac));
	                    sessionStorage.setItem("accbtncntxcobrarc", JSON.stringify(response.data.accbtncntxcobrarc));
	                    sessionStorage.setItem("accbtncntxpagarc", JSON.stringify(response.data.accbtncntxpagarc));
	                    sessionStorage.setItem("accbtntipretencionesc", JSON.stringify(response.data.accbtntipretencionesc));
	                    sessionStorage.setItem("accbtnfreportsc", JSON.stringify(response.data.accbtnfreportsc));
	                    sessionStorage.setItem("accopuserc", JSON.stringify(response.data.accopuserc));
	                    sessionStorage.setItem("accopuserappc", JSON.stringify(response.data.accopuserappc));
	                    sessionStorage.setItem("accvaciosc", JSON.stringify(response.data.accvaciosc));
	                    sessionStorage.setItem("btnopvaciosc", JSON.stringify(response.data.btnopvaciosc));
	                    sessionStorage.setItem("btncontvaciosc", JSON.stringify(response.data.btncontvaciosc));
	                    sessionStorage.setItem("btnclasvaciosc", JSON.stringify(response.data.btnclasvaciosc));
	                    sessionStorage.setItem("btnreportvaciosc", JSON.stringify(response.data.btnreportvaciosc));
	                    sessionStorage.setItem("accserviciosc", JSON.stringify(response.data.accserviciosc));
	                    sessionStorage.setItem("btnreportservc", JSON.stringify(response.data.btnreportservc));
	                    sessionStorage.setItem("ordserviciosc", JSON.stringify(response.data.ordserviciosc));
	                    sessionStorage.setItem("accmovilesc", JSON.stringify(response.data.accmovilesc));
	                    sessionStorage.setItem("accgserviciosc", JSON.stringify(response.data.accgserviciosc));
	
	                    sessionStorage.setItem("accpostventasc", JSON.stringify(response.data.accpostventasc));
	                    sessionStorage.setItem("postventac", JSON.stringify(response.data.postventac));
	                    sessionStorage.setItem("accinicioc", JSON.stringify(response.data.accinicioc));
	                    sessionStorage.setItem("accbtnfacturaxnotasc", JSON.stringify(response.data.accbtnfacturaxnotasc));
	                    sessionStorage.setItem("post", JSON.stringify(response.data));
	                    sessionStorage.setItem("logo", JSON.stringify(response.data.logo));
	                    sessionStorage.setItem("organizacion", JSON.stringify(response.data.organizacion));
	                    sessionStorage.setItem("riforganizacion", JSON.stringify(response.data.riforganizacion));
	                    sessionStorage.setItem("idefiscal", 1);
	                    window.location.href = "/inicio";
	                  }
	                }
	              }).catch(function (error) {
	                if (error.response) {
	                  setMensaje({
	                    mostrar: true,
	                    titulo: "Error",
	                    texto: error.response.data.message,
	                    icono: "error"
	                  });
	                }
	              }).finally(function () {
	                setLoading(false);
	              });
	
	            case 5:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    return function sinIgn() {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var onHideSistema = function onHideSistema(value) {
	    setModalSistema({
	      mostrar: false,
	      idfranquicia: null
	    });
	
	    if (value) {
	      sinIgn(value.idorganizacion);
	    }
	  };
	
	  var mostrarClave = function mostrarClave() {
	    if (tipoInput === "password") {
	      setTipoInput("text");
	      setIconEye("fas fa-eye-slash");
	    } else {
	      setTipoInput("password");
	      setIconEye("fas fa-eye");
	    }
	  };
	
	  // Libera el campo de contraseña (quita readonly) al interactuar con él.
	  // Idempotente: no importa cuántas veces se dispare.
	  var desbloquearPassword = function desbloquearPassword(e) {
	    e.currentTarget.removeAttribute("readonly");
	    setBloqueoPass(false);
	  };
	
	  (0, _react.useEffect)(function () {
	    verificar();
	  }, []);
	
	  return activo ? _react2.default.createElement(
	    "div",
	    { className: "contenedor" },
	    _react2.default.createElement(
	      "section",
	      { className: "baner", style: { margin: 0, pading: 0 } },
	      _react2.default.createElement("img", {
	        className: "img-fluid d-none d-sm-block",
	        style: { width: "100%", height: "100%" },
	        src: "imagenes/almacen2.png"
	      }),
	      _react2.default.createElement("img", {
	        className: "img-fluid d-sm-none",
	        style: { width: "100%", height: "100%" },
	        src: "imagenes/almacen2.png"
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "baner-content" },
	        _react2.default.createElement(
	          _Fade2.default,
	          { top: true },
	          _react2.default.createElement(
	            "div",
	            { className: "navh fixed d-none d-xl-block" },
	            _react2.default.createElement(
	              "div",
	              { className: "container mx-auto justify-content-between" },
	              _react2.default.createElement(
	                _Fade2.default,
	                { left: true },
	                _react2.default.createElement(
	                  "div",
	                  { className: "navLogo d-flex " },
	                  _react2.default.createElement("img", {
	                    className: "img-fluid logoSygre",
	                    src: "imagenes/im4.png"
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "container-fluid text-center d-none d-sm-block contenedor-label" },
	                  _react2.default.createElement("br", null)
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Zoom2.default,
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "boder text-center d-none d-sm-block col align-self-center" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-12 user-img" },
	              _react2.default.createElement("img", { className: "img-fluid", src: "imagenes/prue.jpg" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "sistemad" },
	              _react2.default.createElement(
	                "h1",
	                null,
	                _react2.default.createElement(
	                  "span",
	                  { className: "span1" },
	                  _react2.default.createElement(
	                    "strong",
	                    null,
	                    "ATHOS-"
	                  )
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "span2" },
	                  "ERP"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { overflow: "auto", height: "50vh" } },
	              _react2.default.createElement(
	                "form",
	                { onSubmit: onSubmit, className: "mb-5", autoComplete: "off" },
	                _react2.default.createElement(
	                  _semanticUiReact.Dimmer,
	                  { active: loading, inverted: true },
	                  _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    "cargando..."
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mt-5" },
	                  _react2.default.createElement("input", {
	                    autoFocus: true,
	                    ref: txtUserName,
	                    type: "text",
	                    autoComplete: "username",
	                    "data-lpignore": "true",
	                    className: "form-control input2",
	                    required: true,
	                    placeholder: "Usuario:",
	                    name: "username",
	                    value: values.username,
	                    onKeyPress: function onKeyPress(event) {
	                      if (event.which === 13) {
	                        txtPassword.current.focus();
	                      }
	                    },
	                    onChange: onChange
	                  })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mt-3" },
	                  _react2.default.createElement("input", {
	                    ref: txtPassword,
	                    type: tipoInput,
	                    autoComplete: "new-password",
	                    "data-lpignore": "true",
	                    readOnly: bloqueoPass,
	                    onTouchStart: desbloquearPassword,
	                    onPointerDown: desbloquearPassword,
	                    onFocus: desbloquearPassword,
	                    className: "form-control input2",
	                    required: true,
	                    placeholder: "Contrase\xF1a:",
	                    name: "password",
	                    value: values.password,
	                    onChange: onChange
	                  }),
	                  _react2.default.createElement(
	                    "button",
	                    {
	                      type: "button",
	                      style: { border: "none" },
	                      onClick: mostrarClave,
	                      className: "text-light rounded bg-transparent border-bottom border-light"
	                    },
	                    _react2.default.createElement("i", { className: iconeye }),
	                    " "
	                  )
	                ),
	                _react2.default.createElement(
	                  "button",
	                  { type: "submit", className: "boton rounded-pill" },
	                  _react2.default.createElement("i", { className: "fas fa-sign-in-alt" }),
	                  " Ingresar"
	                )
	              ),
	              _react2.default.createElement(
	                "button",
	                {
	                  onClick: function onClick() {
	                    return setModalClave(true);
	                  },
	                  className: " btn col-12 btn-link btn-sm my-1"
	                },
	                _react2.default.createElement("i", { className: "fas fa-lock" }),
	                " recuperar Contrase\xF1a"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "container boder2 text-center d-sm-none " },
	          _react2.default.createElement(
	            "div",
	            { className: "col-12 user-img2 " },
	            _react2.default.createElement("img", { className: "img-fluid", src: "imagenes/prue.jpg" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "sistemad" },
	            _react2.default.createElement(
	              "h1",
	              null,
	              _react2.default.createElement(
	                "span",
	                { className: "span1" },
	                _react2.default.createElement(
	                  "strong",
	                  null,
	                  "ATHOS-"
	                )
	              ),
	              _react2.default.createElement(
	                "span",
	                { className: "span2" },
	                "ERP"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "login-form-box" },
	            _react2.default.createElement(
	              "form",
	              { onSubmit: onSubmit, autoComplete: "off" },
	              _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: loading, inverted: true },
	                _react2.default.createElement(
	                  _semanticUiReact.Loader,
	                  { inverted: true },
	                  "cargando..."
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group mt-4" },
	                _react2.default.createElement("input", {
	                  type: "text",
	                  autoComplete: "username",
	                  "data-lpignore": "true",
	                  className: "inpt form-control",
	                  required: true,
	                  placeholder: "Usuario:",
	                  name: "username",
	                  value: values.username,
	                  onChange: onChange
	                })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "input-group mt-4" },
	                _react2.default.createElement("input", {
	                  type: tipoInput,
	                  autoComplete: "new-password",
	                  "data-lpignore": "true",
	                  readOnly: bloqueoPass,
	                  onTouchStart: desbloquearPassword,
	                  onPointerDown: desbloquearPassword,
	                  onFocus: desbloquearPassword,
	                  className: "inpt form-control",
	                  required: true,
	                  placeholder: "Contrase\xF1a:",
	                  name: "password",
	                  value: values.password,
	                  onChange: onChange
	                }),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    type: "button",
	                    style: { border: "none" },
	                    onClick: mostrarClave,
	                    className: "text-light rounded bg-transparent border-bottom border-light"
	                  },
	                  _react2.default.createElement("i", { className: iconeye }),
	                  " "
	                )
	              ),
	              _react2.default.createElement(
	                "button",
	                { type: "submit", className: "boton rounded-pill" },
	                _react2.default.createElement("i", { className: "fas fa-sign-in-alt" }),
	                " Ingresar"
	              )
	            ),
	            _react2.default.createElement(
	              "button",
	              {
	                onClick: function onClick() {
	                  return setModalClave(true);
	                },
	                className: " btn col-12 btn-link btn-sm my-1"
	              },
	              _react2.default.createElement("i", { className: "fas fa-lock" }),
	              " recuperar Contrase\xF1a"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "footer",
	        { className: "footer fixed-bottom text-center text-light" },
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Copyright \xA9 2023 ",
	          _react2.default.createElement(
	            "a",
	            { href: "#" },
	            "Sygreca"
	          ),
	          "."
	        ),
	        "Todos los Derechos Reservados."
	      )
	    ),
	    _react2.default.createElement(_recuperarClave.MensajeOlvidarClave, {
	      show: modalClave,
	      onHide: function onHide() {
	        return setModalClave(false);
	      }
	    }),
	    _react2.default.createElement(_mensajes.Mensaje, {
	      mensaje: mensaje,
	      onHide: function onHide() {
	        return setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
	      }
	    }),
	    _react2.default.createElement(_catalogoSistema2.default, {
	      show: modalSistema.mostrar,
	      idfranquicia: modalSistema.idfranquicia,
	      onHide: onHideSistema
	    })
	  ) : _react2.default.createElement(
	    "div",
	    { className: "coverPage" },
	    _react2.default.createElement(
	      "div",
	      { className: "__coverPage-content" },
	      _react2.default.createElement(
	        "h1",
	        null,
	        _react2.default.createElement(
	          "strong",
	          null,
	          "ATHOS-"
	        ),
	        "ERP"
	      ),
	      _react2.default.createElement(
	        "h3",
	        null,
	        "Estamos construyendo algo ",
	        _react2.default.createElement(
	          "span",
	          null,
	          "FANTASTICO!"
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "www.sygreca.com.ve"
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "socialMedia" },
	        _react2.default.createElement(
	          "a",
	          { className: "socialIcon", href: "#" },
	          _react2.default.createElement("i", { className: "fas fa-envelope" })
	        ),
	        _react2.default.createElement(
	          "a",
	          { className: "socialIcon", href: "#" },
	          _react2.default.createElement("i", { className: "fab fa-facebook-f" })
	        ),
	        _react2.default.createElement(
	          "a",
	          { className: "socialIcon", href: "#" },
	          _react2.default.createElement("i", { className: "fab fa-instagram" })
	        )
	      )
	    )
	  );
	}
	
	exports.default = Login;

/***/ },
/* 7188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MensajeOlvidarClave = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(15);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _mensajes = __webpack_require__(9);
	
	var _semanticUiReact = __webpack_require__(11);
	
	var _Md = __webpack_require__(7191);
	
	var _axios = __webpack_require__(10);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var MensajeOlvidarClave = exports.MensajeOlvidarClave = function MensajeOlvidarClave(props) {
	
	    /*  variables de estados */
	
	    var btnCancela = (0, _react.useRef)();
	    var btnEnviar = (0, _react.useRef)();
	
	    var _useState = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState2 = _slicedToArray(_useState, 2),
	        mensaje = _useState2[0],
	        setMensaje = _useState2[1];
	
	    var _useState3 = (0, _react.useState)({ mostrar: false, titulo: '', texto: '', icono: '' }),
	        _useState4 = _slicedToArray(_useState3, 2),
	        mensajesino = _useState4[0],
	        setMensajesino = _useState4[1];
	
	    var _useState5 = (0, _react.useState)(''),
	        _useState6 = _slicedToArray(_useState5, 2),
	        password = _useState6[0],
	        setPassword = _useState6[1];
	
	    var _useState7 = (0, _react.useState)(false),
	        _useState8 = _slicedToArray(_useState7, 2),
	        activate = _useState8[0],
	        setActivate = _useState8[1];
	
	    var _useState9 = (0, _react.useState)({ txtEmail: '', passwd: '', txtCedula: '' }),
	        _useState10 = _slicedToArray(_useState9, 2),
	        values = _useState10[0],
	        setValues = _useState10[1];
	
	    var op = __webpack_require__(8);
	
	    /* metodo para restablecer los valores  a su estado inicial */
	
	    var blanquear = function blanquear() {
	        setPassword('');
	        setActivate(false);
	        setValues({ txtEmail: '', passwd: '', txtCedula: '' });
	    };
	
	    /*  metodo para modificar la variable de estado values  */
	
	    var onChange = function onChange(event) {
	        setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value)));
	    };
	
	    var handleInputChange = function handleInputChange(event) {
	        if (event.which === 13) {
	            if (event.target.name === 'txtCedula') {
	                btnEnviar.current.focus();
	            }
	        }
	    };
	
	    /* metodo para validar que el email este registrado */
	
	    var validarUsuario = function validarUsuario() {
	
	        var endpoint = op.conexion + '/api/athos/auth/forgotpassword?cedula=' + values.txtCedula;
	
	        _axios2.default.get(endpoint).then(function (response) {
	
	            if (response.status == 200) {
	                if (response.data !== '') {
	                    setValues(Object.assign({}, values, { txtEmail: response.data.email, passwd: pass2 }));
	                    setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Esta seguro de recuperar la clave?', icono: 'confirmacion' });
	                } else {
	                    setMensaje({ mostrar: true, titulo: 'Error', texto: 'no tiene un correo registrado o no existe un usuario con esta cedula.', icono: 'error' });
	                }
	            }
	        }).catch(function (error) {
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        });
	    };
	
	    /*  metodo para actualizar la contraseña */
	
	    var datosUsuario = function datosUsuario() {
	
	        var body = {
	            cedula: values.txtCedula,
	            passwd: (0, _Md.hex_md5)(password)
	        };
	
	        var endpoint = op.conexion + '/api/athos/auth/recoverpassword';
	        _axios2.default.post(endpoint, body).then(function (response) {
	
	            if (response.status == 200) {
	
	                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'su contraseña fue enviada al ' + values.txtEmail, icono: 'exito' });
	                blanquear();
	            }
	        }).catch(function (error) {
	
	            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
	            setActivate(false);
	        });
	    };
	
	    /*  metodo para enviar la contraseña al email */
	
	    var onEnviar = function onEnviar(event) {
	        if (values.txtCedula === '') {
	            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Introduzca una cedula Valida.', icono: 'informacion' });
	        } else {
	            validarUsuario();
	        }
	    };
	
	    /* metodo para confirmar la recuperacion */
	
	    var handleCloseSi = function handleCloseSi() {
	
	        setMensajesino({ mostrar: false, titulo: 'Confirmación.', texto: '', icono: 'confirmacion' });
	
	        setActivate(true);
	
	        var endpoint = op.email + "/send-email";
	        _axios2.default.post(endpoint, {
	            email: values.txtEmail,
	            name: values.txtEmail,
	            passwd: password,
	            message: ''
	        }).then(function (response) {
	            if (response.status == 200) {
	                datosUsuario();
	            } else if (response.status == 204) {
	                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'correo no encontrado', icono: 'informacion' });
	            }
	        }).catch(function (error) {
	            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Error interno de Conexión.', icono: 'informacion' });
	        }).then(function () {
	            setActivate(false);
	        });
	    };
	
	    /*  metodo para generar la nueva contraseña */
	
	    var generar = function generar(longitud) {
	        var long = parseInt(longitud);
	        var caracteres = "abcdefghijkmnpqrtuvwxyzABCDEFGHIJKLMNPQRTUVWXYZ2346789";
	        var contraseña = "";
	        for (var i = 0; i < long; i++) {
	            contraseña += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
	        }return contraseña;
	    };
	
	    (0, _react.useEffect)(function () {
	        setPassword(generar(6).toString());
	    }, []);
	
	    var pass2 = (0, _Md.hex_md5)(password);
	
	    var cancelar = function cancelar() {
	        blanquear();
	        props.onHide();
	    };
	
	    var cerrarModal = function cerrarModal() {
	        props.onHide();
	        blanquear();
	        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	    };
	
	    return _react2.default.createElement(
	        _Modal2.default,
	        Object.assign({}, props, {
	            size: 'md',
	            'aria-labelledby': 'contained-modal-title-vcenter',
	            centered: true,
	            backdrop: 'static',
	            keyboard: false,
	            onShow: function onShow() {
	                btnCancela.current.focus();
	            }
	        }),
	        _react2.default.createElement(
	            _Modal2.default.Header,
	            { className: 'azulGradiant2' },
	            _react2.default.createElement(
	                _Modal2.default.Title,
	                { style: { color: "#fff" } },
	                'Recuperar Contrase\xF1a.'
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, className: 'btn', style: { border: 0, margin: 0, padding: 0, color: "#ffffff" }, onClick: cancelar },
	                _react2.default.createElement('i', { className: 'far fa-window-close' })
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Body,
	            { className: 'amanecergris' },
	            _react2.default.createElement(_mensajes.Mensaje, { mensaje: mensaje,
	                onHide: function onHide() {
	                    mensaje.titulo === 'Exito.' ? cerrarModal() : setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
	                } }),
	            _react2.default.createElement(_mensajes.MensajeSiNo, { mensaje: mensajesino,
	                onHideNo: function onHideNo() {
	                    return setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
	                }, onHideSi: handleCloseSi }),
	            _react2.default.createElement(
	                _semanticUiReact.Dimmer,
	                { active: activate, inverted: true },
	                _react2.default.createElement(
	                    _semanticUiReact.Loader,
	                    { inverted: true },
	                    'cargando...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    _semanticUiReact.Table,
	                    { style: { backgroundColor: 'transparent', border: 'none' } },
	                    _react2.default.createElement(
	                        _semanticUiReact.Table.Body,
	                        null,
	                        _react2.default.createElement(
	                            _semanticUiReact.Table.Row,
	                            null,
	                            _react2.default.createElement(
	                                _semanticUiReact.Table.Cell,
	                                { align: 'center' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { id: 'wizard', className: 'swMain', style: { padding: 10 } },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'stepContainer' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { id: 'step-1' },
	                                            _react2.default.createElement(
	                                                'h2',
	                                                { className: 'StepTitle', style: { textAlign: "center" } },
	                                                ' Ingrese la Cedula del Usuario'
	                                            ),
	                                            _react2.default.createElement(
	                                                'table',
	                                                { className: 'col-12', align: 'center' },
	                                                _react2.default.createElement(
	                                                    'tbody',
	                                                    null,
	                                                    _react2.default.createElement(
	                                                        'tr',
	                                                        { align: 'center' },
	                                                        _react2.default.createElement(
	                                                            'td',
	                                                            null,
	                                                            _react2.default.createElement('input', { name: 'txtCedula', autoComplete: 'off', value: values.txtCedula, onKeyUp: handleInputChange, onChange: onChange, type: 'text', placeholder: '1234567890', className: 'form-control col-md-10', id: 'txtCedula' })
	                                                        )
	                                                    )
	                                                )
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Modal2.default.Footer,
	            null,
	            _react2.default.createElement(
	                'button',
	                { className: 'btn btn-sm  btn-success', ref: btnEnviar, style: { color: "#fff", border: "none" }, onClick: onEnviar },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-check-circle' },
	                    ' Aceptar'
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: btnCancela, onClick: cancelar, className: 'btn btn-sm btn-secondary' },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'fas fa-window-close' },
	                    ' Cancelar'
	                )
	            )
	        )
	    );
	};

/***/ },
/* 7189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.register = register;
	exports.unregister = unregister;
	// This optional code is used to register a service worker.
	// register() is not called by default.
	
	// This lets the app load faster on subsequent visits in production, and gives
	// it offline capabilities. However, it also means that developers (and users)
	// will only see deployed updates on subsequent visits to a page, after all the
	// existing tabs open on the page have been closed, since previously cached
	// resources are updated in the background.
	
	// To learn more about the benefits of this model and instructions on how to
	// opt-in, read https://bit.ly/CRA-PWA
	
	var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
	// [::1] is the IPv6 localhost address.
	window.location.hostname === '[::1]' ||
	// 127.0.0.1/8 is considered localhost for IPv4.
	window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
	
	function register(config) {
	  if (("production") === 'production' && 'serviceWorker' in navigator) {
	    // The URL constructor is available in all browsers that support SW.
	    var publicUrl = new URL((""), window.location.href);
	    if (publicUrl.origin !== window.location.origin) {
	      // Our service worker won't work if PUBLIC_URL is on a different origin
	      // from what our page is served on. This might happen if a CDN is used to
	      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
	      return;
	    }
	
	    window.addEventListener('load', function () {
	      var swUrl = ("") + '/service-worker.js';
	
	      if (isLocalhost) {
	        // This is running on localhost. Let's check if a service worker still exists or not.
	        checkValidServiceWorker(swUrl, config);
	
	        // Add some additional logging to localhost, pointing developers to the
	        // service worker/PWA documentation.
	        navigator.serviceWorker.ready.then(function () {
	          console.log('This web app is being served cache-first by a service ' + 'worker. To learn more, visit https://bit.ly/CRA-PWA');
	        });
	      } else {
	        // Is not localhost. Just register service worker
	        registerValidSW(swUrl, config);
	      }
	    });
	  }
	}
	
	function registerValidSW(swUrl, config) {
	  navigator.serviceWorker.register(swUrl).then(function (registration) {
	    registration.onupdatefound = function () {
	      var installingWorker = registration.installing;
	      if (installingWorker == null) {
	        return;
	      }
	      installingWorker.onstatechange = function () {
	        if (installingWorker.state === 'installed') {
	          if (navigator.serviceWorker.controller) {
	            // At this point, the updated precached content has been fetched,
	            // but the previous service worker will still serve the older
	            // content until all client tabs are closed.
	            console.log('New content is available and will be used when all ' + 'tabs for this page are closed. See https://bit.ly/CRA-PWA.');
	
	            // Execute callback
	            if (config && config.onUpdate) {
	              config.onUpdate(registration);
	            }
	          } else {
	            // At this point, everything has been precached.
	            // It's the perfect time to display a
	            // "Content is cached for offline use." message.
	            console.log('Content is cached for offline use.');
	
	            // Execute callback
	            if (config && config.onSuccess) {
	              config.onSuccess(registration);
	            }
	          }
	        }
	      };
	    };
	  }).catch(function (error) {
	    console.error('Error during service worker registration:', error);
	  });
	}
	
	function checkValidServiceWorker(swUrl, config) {
	  // Check if the service worker can be found. If it can't reload the page.
	  fetch(swUrl).then(function (response) {
	    // Ensure service worker exists, and that we really are getting a JS file.
	    var contentType = response.headers.get('content-type');
	    if (response.status === 404 || contentType != null && contentType.indexOf('javascript') === -1) {
	      // No service worker found. Probably a different app. Reload the page.
	      navigator.serviceWorker.ready.then(function (registration) {
	        registration.unregister().then(function () {
	          window.location.reload();
	        });
	      });
	    } else {
	      // Service worker found. Proceed as normal.
	      registerValidSW(swUrl, config);
	    }
	  }).catch(function () {
	    console.log('No internet connection found. App is running in offline mode.');
	  });
	}
	
	function unregister() {
	  if ('serviceWorker' in navigator) {
	    navigator.serviceWorker.ready.then(function (registration) {
	      registration.unregister();
	    });
	  }
	}

/***/ },
/* 7190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(155);
	
	var _auth = __webpack_require__(106);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function AuthRoute(_ref) {
	  var Component = _ref.component,
	      rest = _objectWithoutProperties(_ref, ['component']);
	
	  var _useContext = (0, _react.useContext)(_auth.AuthContext),
	      user = _useContext.user;
	
	  return _react2.default.createElement(_reactRouterDom.Route, Object.assign({}, rest, {
	    render: function render(props) {
	      return user ? _react2.default.createElement(Component, props) : _react2.default.createElement(_reactRouterDom.Redirect, { to: '/login' });
	    }
	  }));
	}
	
	exports.default = AuthRoute;

/***/ },
/* 7191 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	/*
	 * Configurable variables. You may need to tweak these to be compatible with
	 * the server-side, but the defaults work in most cases.
	 */
	var hexcase = 0; /* hex output format. 0 - lowercase; 1 - uppercase        */
	var b64pad = ""; /* base-64 pad character. "=" for strict RFC compliance   */
	
	/*
	 * These are the export const s you'll usually want to call
	 * They take string arguments and return either hex or base-64 encoded strings
	 */
	var hex_md5 = exports.hex_md5 = function hex_md5(s) {
	  return rstr2hex(rstr_md5(str2rstr_utf8(s)));
	};
	var b64_md5 = exports.b64_md5 = function b64_md5(s) {
	  return rstr2b64(rstr_md5(str2rstr_utf8(s)));
	};
	var any_md5 = exports.any_md5 = function any_md5(s, e) {
	  return rstr2any(rstr_md5(str2rstr_utf8(s)), e);
	};
	var hex_hmac_md5 = exports.hex_hmac_md5 = function hex_hmac_md5(k, d) {
	  return rstr2hex(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)));
	};
	var b64_hmac_md5 = exports.b64_hmac_md5 = function b64_hmac_md5(k, d) {
	  return rstr2b64(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)));
	};
	var any_hmac_md5 = exports.any_hmac_md5 = function any_hmac_md5(k, d, e) {
	  return rstr2any(rstr_hmac_md5(str2rstr_utf8(k), str2rstr_utf8(d)), e);
	};
	
	/*
	 * Perform a simple self-test to see if the VM is working
	 */
	var md5_vm_test = exports.md5_vm_test = function md5_vm_test() {
	  return hex_md5("abc").toLowerCase() == "900150983cd24fb0d6963f7d28e17f72";
	};
	
	/*
	 * Calculate the MD5 of a raw string
	 */
	var rstr_md5 = exports.rstr_md5 = function rstr_md5(s) {
	  return binl2rstr(binl_md5(rstr2binl(s), s.length * 8));
	};
	
	/*
	 * Calculate the HMAC-MD5, of a key and some data (raw strings)
	 */
	var rstr_hmac_md5 = exports.rstr_hmac_md5 = function rstr_hmac_md5(key, data) {
	  var bkey = rstr2binl(key);
	  if (bkey.length > 16) bkey = binl_md5(bkey, key.length * 8);
	
	  var ipad = Array(16),
	      opad = Array(16);
	  for (var i = 0; i < 16; i++) {
	    ipad[i] = bkey[i] ^ 0x36363636;
	    opad[i] = bkey[i] ^ 0x5C5C5C5C;
	  }
	
	  var hash = binl_md5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
	  return binl2rstr(binl_md5(opad.concat(hash), 512 + 128));
	};
	
	/*
	 * Convert a raw string to a hex string
	 */
	var rstr2hex = exports.rstr2hex = function rstr2hex(input) {
	  try {
	    hexcase;
	  } catch (e) {
	    hexcase = 0;
	  }
	  var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
	  var output = "";
	  var x;
	  for (var i = 0; i < input.length; i++) {
	    x = input.charCodeAt(i);
	    output += hex_tab.charAt(x >>> 4 & 0x0F) + hex_tab.charAt(x & 0x0F);
	  }
	  return output;
	};
	
	/*
	 * Convert a raw string to a base-64 string
	 */
	var rstr2b64 = exports.rstr2b64 = function rstr2b64(input) {
	  try {
	    b64pad;
	  } catch (e) {
	    b64pad = '';
	  }
	  var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	  var output = "";
	  var len = input.length;
	  for (var i = 0; i < len; i += 3) {
	    var triplet = input.charCodeAt(i) << 16 | (i + 1 < len ? input.charCodeAt(i + 1) << 8 : 0) | (i + 2 < len ? input.charCodeAt(i + 2) : 0);
	    for (var j = 0; j < 4; j++) {
	      if (i * 8 + j * 6 > input.length * 8) output += b64pad;else output += tab.charAt(triplet >>> 6 * (3 - j) & 0x3F);
	    }
	  }
	  return output;
	};
	
	/*
	 * Convert a raw string to an arbitrary string encoding
	 */
	var rstr2any = exports.rstr2any = function rstr2any(input, encoding) {
	  var divisor = encoding.length;
	  var i, j, q, x, quotient;
	
	  /* Convert to an array of 16-bit big-endian values, forming the dividend */
	  var dividend = Array(Math.ceil(input.length / 2));
	  for (i = 0; i < dividend.length; i++) {
	    dividend[i] = input.charCodeAt(i * 2) << 8 | input.charCodeAt(i * 2 + 1);
	  }
	
	  /*
	   * Repeatedly perform a long division. The binary array forms the dividend,
	   * the length of the encoding is the divisor. Once computed, the quotient
	   * forms the dividend for the next step. All remainders are stored for later
	   * use.
	   */
	  var full_length = Math.ceil(input.length * 8 / (Math.log(encoding.length) / Math.log(2)));
	  var remainders = Array(full_length);
	  for (j = 0; j < full_length; j++) {
	    quotient = Array();
	    x = 0;
	    for (i = 0; i < dividend.length; i++) {
	      x = (x << 16) + dividend[i];
	      q = Math.floor(x / divisor);
	      x -= q * divisor;
	      if (quotient.length > 0 || q > 0) quotient[quotient.length] = q;
	    }
	    remainders[j] = x;
	    dividend = quotient;
	  }
	
	  /* Convert the remainders to the output string */
	  var output = "";
	  for (i = remainders.length - 1; i >= 0; i--) {
	    output += encoding.charAt(remainders[i]);
	  }return output;
	};
	
	/*
	 * Encode a string as utf-8.
	 * For efficiency, this assumes the input is valid utf-16.
	 */
	var str2rstr_utf8 = exports.str2rstr_utf8 = function str2rstr_utf8(input) {
	  var output = "";
	  var i = -1;
	  var x, y;
	
	  while (++i < input.length) {
	    /* Decode utf-16 surrogate pairs */
	    x = input.charCodeAt(i);
	    y = i + 1 < input.length ? input.charCodeAt(i + 1) : 0;
	    if (0xD800 <= x && x <= 0xDBFF && 0xDC00 <= y && y <= 0xDFFF) {
	      x = 0x10000 + ((x & 0x03FF) << 10) + (y & 0x03FF);
	      i++;
	    }
	
	    /* Encode output as utf-8 */
	    if (x <= 0x7F) output += String.fromCharCode(x);else if (x <= 0x7FF) output += String.fromCharCode(0xC0 | x >>> 6 & 0x1F, 0x80 | x & 0x3F);else if (x <= 0xFFFF) output += String.fromCharCode(0xE0 | x >>> 12 & 0x0F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);else if (x <= 0x1FFFFF) output += String.fromCharCode(0xF0 | x >>> 18 & 0x07, 0x80 | x >>> 12 & 0x3F, 0x80 | x >>> 6 & 0x3F, 0x80 | x & 0x3F);
	  }
	  return output;
	};
	
	/*
	 * Encode a string as utf-16
	 */
	var str2rstr_utf16le = exports.str2rstr_utf16le = function str2rstr_utf16le(input) {
	  var output = "";
	  for (var i = 0; i < input.length; i++) {
	    output += String.fromCharCode(input.charCodeAt(i) & 0xFF, input.charCodeAt(i) >>> 8 & 0xFF);
	  }return output;
	};
	
	var str2rstr_utf16be = exports.str2rstr_utf16be = function str2rstr_utf16be(input) {
	  var output = "";
	  for (var i = 0; i < input.length; i++) {
	    output += String.fromCharCode(input.charCodeAt(i) >>> 8 & 0xFF, input.charCodeAt(i) & 0xFF);
	  }return output;
	};
	
	/*
	 * Convert a raw string to an array of little-endian words
	 * Characters >255 have their high-byte silently ignored.
	 */
	var rstr2binl = exports.rstr2binl = function rstr2binl(input) {
	  var output = Array(input.length >> 2);
	  for (var i = 0; i < output.length; i++) {
	    output[i] = 0;
	  }for (var i = 0; i < input.length * 8; i += 8) {
	    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << i % 32;
	  }return output;
	};
	
	/*
	 * Convert an array of little-endian words to a string
	 */
	var binl2rstr = exports.binl2rstr = function binl2rstr(input) {
	  var output = "";
	  for (var i = 0; i < input.length * 32; i += 8) {
	    output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xFF);
	  }return output;
	};
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length.
	 */
	var binl_md5 = exports.binl_md5 = function binl_md5(x, len) {
	  /* append padding */
	  x[len >> 5] |= 0x80 << len % 32;
	  x[(len + 64 >>> 9 << 4) + 14] = len;
	
	  var a = 1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d = 271733878;
	
	  for (var i = 0; i < x.length; i += 16) {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
	    d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
	    b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
	    d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
	    c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
	    d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
	    d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);
	
	    a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
	    d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
	    c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
	    b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
	    d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
	    c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
	    d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
	    c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
	    a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
	    d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
	    c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
	    b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
	    d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
	    b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
	    d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
	    c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
	    d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
	    a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
	    d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
	    b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
	    d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
	    c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
	    d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
	    d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
	    a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
	    d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
	    b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	};
	
	/*
	 * These export const s implement the four basic operations the algorithm uses.
	 */
	var md5_cmn = exports.md5_cmn = function md5_cmn(q, a, b, x, s, t) {
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
	};
	var md5_ff = exports.md5_ff = function md5_ff(a, b, c, d, x, s, t) {
	  return md5_cmn(b & c | ~b & d, a, b, x, s, t);
	};
	var md5_gg = exports.md5_gg = function md5_gg(a, b, c, d, x, s, t) {
	  return md5_cmn(b & d | c & ~d, a, b, x, s, t);
	};
	var md5_hh = exports.md5_hh = function md5_hh(a, b, c, d, x, s, t) {
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	};
	var md5_ii = exports.md5_ii = function md5_ii(a, b, c, d, x, s, t) {
	  return md5_cmn(c ^ (b | ~d), a, b, x, s, t);
	};
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	var safe_add = exports.safe_add = function safe_add(x, y) {
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return msw << 16 | lsw & 0xFFFF;
	};
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	var bit_rol = exports.bit_rol = function bit_rol(num, cnt) {
	  return num << cnt | num >>> 32 - cnt;
	};

/***/ },
/* 7192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useForm = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var useForm = exports.useForm = function useForm(callback) {
	  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var _useState = (0, _react.useState)(initialState),
	      _useState2 = _slicedToArray(_useState, 2),
	      values = _useState2[0],
	      setValues = _useState2[1];
	
	  var onChange = function onChange(event) {
	    setValues(Object.assign({}, values, _defineProperty({}, event.target.name, event.target.value)));
	  };
	
	  var onSubmit = function onSubmit(event) {
	    event.preventDefault();
	    callback();
	  };
	
	  return {
	    onChange: onChange,
	    onSubmit: onSubmit,
	    values: values
	  };
	};

/***/ },
/* 7193 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 7194 */
7193,
/* 7195 */
7193,
/* 7196 */
7193,
/* 7197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(677);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 7198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(677);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 7199 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 7200 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _addClass2 = _interopRequireDefault(__webpack_require__(434));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(437));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _Transition = _interopRequireDefault(__webpack_require__(216));
	
	var _PropTypes = __webpack_require__(680);
	
	var _reflow = __webpack_require__(681);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var _addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
	 * use it if you're using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**, so it's
	 * important to add `transition` declaration only to them, otherwise transitions
	 * might not behave as intended! This might not be obvious when the transitions
	 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
	 * the example above (minus `transition`), but it becomes apparent in more
	 * complex transitions.
	 *
	 * **Note**: If you're using the
	 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
	 * prop, make sure to define styles for `.appear-*` classes as well.
	 */
	
	
	var CSSTransition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.appliedClasses = {
	      appear: {},
	      enter: {},
	      exit: {}
	    };
	
	    _this.onEnter = function (maybeNode, maybeAppearing) {
	      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
	          node = _this$resolveArgument[0],
	          appearing = _this$resolveArgument[1];
	
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(maybeNode, maybeAppearing);
	      }
	    };
	
	    _this.onEntering = function (maybeNode, maybeAppearing) {
	      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
	          node = _this$resolveArgument2[0],
	          appearing = _this$resolveArgument2[1];
	
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.addClass(node, type, 'active');
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(maybeNode, maybeAppearing);
	      }
	    };
	
	    _this.onEntered = function (maybeNode, maybeAppearing) {
	      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
	          node = _this$resolveArgument3[0],
	          appearing = _this$resolveArgument3[1];
	
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.removeClasses(node, type);
	
	      _this.addClass(node, type, 'done');
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(maybeNode, maybeAppearing);
	      }
	    };
	
	    _this.onExit = function (maybeNode) {
	      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
	          node = _this$resolveArgument4[0];
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      _this.addClass(node, 'exit', 'base');
	
	      if (_this.props.onExit) {
	        _this.props.onExit(maybeNode);
	      }
	    };
	
	    _this.onExiting = function (maybeNode) {
	      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
	          node = _this$resolveArgument5[0];
	
	      _this.addClass(node, 'exit', 'active');
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(maybeNode);
	      }
	    };
	
	    _this.onExited = function (maybeNode) {
	      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
	          node = _this$resolveArgument6[0];
	
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, 'exit', 'done');
	
	      if (_this.props.onExited) {
	        _this.props.onExited(maybeNode);
	      }
	    };
	
	    _this.resolveArguments = function (maybeNode, maybeAppearing) {
	      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
	      : [maybeNode, maybeAppearing];
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
	      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
	      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
	      return {
	        baseClassName: baseClassName,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.addClass = function addClass(node, type, phase) {
	    var className = this.getClassNames(type)[phase + "ClassName"];
	
	    var _this$getClassNames = this.getClassNames('enter'),
	        doneClassName = _this$getClassNames.doneClassName;
	
	    if (type === 'appear' && phase === 'done' && doneClassName) {
	      className += " " + doneClassName;
	    } // This is to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	
	
	    if (phase === 'active') {
	      if (node) (0, _reflow.forceReflow)(node);
	    }
	
	    if (className) {
	      this.appliedClasses[type][phase] = className;
	
	      _addClass(node, className);
	    }
	  };
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$appliedClasses$ = this.appliedClasses[type],
	        baseClassName = _this$appliedClasses$.base,
	        activeClassName = _this$appliedClasses$.active,
	        doneClassName = _this$appliedClasses$.done;
	    this.appliedClasses[type] = {};
	
	    if (baseClassName) {
	      removeClass(node, baseClassName);
	    }
	
	    if (activeClassName) {
	      removeClass(node, activeClassName);
	    }
	
	    if (doneClassName) {
	      removeClass(node, doneClassName);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _ = _this$props.classNames,
	        props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);
	
	    return /*#__PURE__*/_react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it appears, enters,
	   * exits or has finished the transition. A single name can be provided, which
	   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
	   *
	   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
	   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
	   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
	   *
	   * A few details to note about how these classes are applied:
	   *
	   * 1. They are _joined_ with the ones that are already defined on the child
	   *    component, so if you want to add some base styles, you can use
	   *    `className` without worrying that it will be overridden.
	   *
	   * 2. If the transition component mounts with `in={false}`, no classes are
	   *    applied yet. You might be expecting `*-exit-done`, but if you think
	   *    about it, a component cannot finish exiting if it hasn't entered yet.
	   *
	   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
	   *    allows you to define different behavior for when appearing is done and
	   *    when regular entering is done, using selectors like
	   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
	   *    an epic entrance animation when element first appears in the DOM using
	   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   *    simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * **Note**: when `nodeRef` prop is passed, `node` is not passed
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: _propTypes.default.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 7201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(45));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(678));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	
	    if (this.props[handler]) {
	      var maybeNode = child.props.nodeRef ? undefined : _reactDom.default.findDOMNode(this);
	      this.props[handler](maybeNode);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return /*#__PURE__*/_react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 7202 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.modes = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _Transition = __webpack_require__(216);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(304));
	
	var _leaveRenders, _enterRenders;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function areChildrenDifferent(oldChildren, newChildren) {
	  if (oldChildren === newChildren) return false;
	
	  if (_react.default.isValidElement(oldChildren) && _react.default.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
	    return false;
	  }
	
	  return true;
	}
	/**
	 * Enum of modes for SwitchTransition component
	 * @enum { string }
	 */
	
	
	var modes = {
	  out: 'out-in',
	  in: 'in-out'
	};
	exports.modes = modes;
	
	var callHook = function callHook(element, name, cb) {
	  return function () {
	    var _element$props;
	
	    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
	    cb();
	  };
	};
	
	var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
	  var current = _ref.current,
	      changeState = _ref.changeState;
	  return _react.default.cloneElement(current, {
	    in: false,
	    onExited: callHook(current, 'onExited', function () {
	      changeState(_Transition.ENTERING, null);
	    })
	  });
	}, _leaveRenders[modes.in] = function (_ref2) {
	  var current = _ref2.current,
	      changeState = _ref2.changeState,
	      children = _ref2.children;
	  return [current, _react.default.cloneElement(children, {
	    in: true,
	    onEntered: callHook(children, 'onEntered', function () {
	      changeState(_Transition.ENTERING);
	    })
	  })];
	}, _leaveRenders);
	var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
	  var children = _ref3.children,
	      changeState = _ref3.changeState;
	  return _react.default.cloneElement(children, {
	    in: true,
	    onEntered: callHook(children, 'onEntered', function () {
	      changeState(_Transition.ENTERED, _react.default.cloneElement(children, {
	        in: true
	      }));
	    })
	  });
	}, _enterRenders[modes.in] = function (_ref4) {
	  var current = _ref4.current,
	      children = _ref4.children,
	      changeState = _ref4.changeState;
	  return [_react.default.cloneElement(current, {
	    in: false,
	    onExited: callHook(current, 'onExited', function () {
	      changeState(_Transition.ENTERED, _react.default.cloneElement(children, {
	        in: true
	      }));
	    })
	  }), _react.default.cloneElement(children, {
	    in: true
	  })];
	}, _enterRenders);
	/**
	 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
	 * You can use it when you want to control the render between state transitions.
	 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
	 *
	 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
	 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
	 *
	 * **Note**: If you want the animation to happen simultaneously
	 * (that is, to have the old child removed and a new child inserted **at the same time**),
	 * you should use
	 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
	 * instead.
	 *
	 * ```jsx
	 * function App() {
	 *  const [state, setState] = useState(false);
	 *  return (
	 *    <SwitchTransition>
	 *      <CSSTransition
	 *        key={state ? "Goodbye, world!" : "Hello, world!"}
	 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
	 *        classNames='fade'
	 *      >
	 *        <button onClick={() => setState(state => !state)}>
	 *          {state ? "Goodbye, world!" : "Hello, world!"}
	 *        </button>
	 *      </CSSTransition>
	 *    </SwitchTransition>
	 *  );
	 * }
	 * ```
	 *
	 * ```css
	 * .fade-enter{
	 *    opacity: 0;
	 * }
	 * .fade-exit{
	 *    opacity: 1;
	 * }
	 * .fade-enter-active{
	 *    opacity: 1;
	 * }
	 * .fade-exit-active{
	 *    opacity: 0;
	 * }
	 * .fade-enter-active,
	 * .fade-exit-active{
	 *    transition: opacity 500ms;
	 * }
	 * ```
	 */
	
	var SwitchTransition = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose(SwitchTransition, _React$Component);
	
	  function SwitchTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.state = {
	      status: _Transition.ENTERED,
	      current: null
	    };
	    _this.appeared = false;
	
	    _this.changeState = function (status, current) {
	      if (current === void 0) {
	        current = _this.state.current;
	      }
	
	      _this.setState({
	        status: status,
	        current: current
	      });
	    };
	
	    return _this;
	  }
	
	  var _proto = SwitchTransition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    if (props.children == null) {
	      return {
	        current: null
	      };
	    }
	
	    if (state.status === _Transition.ENTERING && props.mode === modes.in) {
	      return {
	        status: _Transition.ENTERING
	      };
	    }
	
	    if (state.current && areChildrenDifferent(state.current, props.children)) {
	      return {
	        status: _Transition.EXITING
	      };
	    }
	
	    return {
	      current: _react.default.cloneElement(props.children, {
	        in: true
	      })
	    };
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        mode = _this$props.mode,
	        _this$state = this.state,
	        status = _this$state.status,
	        current = _this$state.current;
	    var data = {
	      children: children,
	      current: current,
	      changeState: this.changeState,
	      status: status
	    };
	    var component;
	
	    switch (status) {
	      case _Transition.ENTERING:
	        component = enterRenders[mode](data);
	        break;
	
	      case _Transition.EXITING:
	        component = leaveRenders[mode](data);
	        break;
	
	      case _Transition.ENTERED:
	        component = current;
	    }
	
	    return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: {
	        isMounting: !this.appeared
	      }
	    }, component);
	  };
	
	  return SwitchTransition;
	}(_react.default.Component);
	
	SwitchTransition.propTypes =  false ? {
	  /**
	   * Transition modes.
	   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
	   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
	   *
	   * @type {'out-in'|'in-out'}
	   */
	  mode: _propTypes.default.oneOf([modes.in, modes.out]),
	
	  /**
	   * Any `Transition` or `CSSTransition` component.
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.element.isRequired])
	} : {};
	SwitchTransition.defaultProps = {
	  mode: modes.out
	};
	var _default = SwitchTransition;
	exports.default = _default;

/***/ },
/* 7203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(2);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = (key in prevChildMapping);
	    var hasNext = (key in nextChildMapping);
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ },
/* 7204 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.13.1
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(287),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.13.1";


/***/ },
/* 7205 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(107);


/***/ },
/* 7206 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(683);
	
	/*<replacement>*/
	var util = Object.create(__webpack_require__(133));
	util.inherits = __webpack_require__(76);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ },
/* 7207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(217).Buffer;
	var util = __webpack_require__(7342);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ },
/* 7208 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(306).PassThrough


/***/ },
/* 7209 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(306).Transform


/***/ },
/* 7210 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(305);


/***/ },
/* 7211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(134);
	var callBind = __webpack_require__(428);
	
	var implementation = __webpack_require__(686);
	var getPolyfill = __webpack_require__(687);
	var shim = __webpack_require__(7212);
	
	var flagsBound = callBind(getPolyfill());
	
	define(flagsBound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = flagsBound;


/***/ },
/* 7212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var supportsDescriptors = __webpack_require__(134).supportsDescriptors;
	var getPolyfill = __webpack_require__(687);
	var gOPD = __webpack_require__(115);
	var defineProperty = Object.defineProperty;
	var $TypeError = __webpack_require__(439);
	var getProto = __webpack_require__(445);
	var regex = /a/;
	
	module.exports = function shimFlags() {
		if (!supportsDescriptors || !getProto) {
			throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		var polyfill = getPolyfill();
		var proto = getProto(regex);
		var descriptor = gOPD(proto, 'flags');
		if (!descriptor || descriptor.get !== polyfill) {
			defineProperty(proto, 'flags', {
				configurable: true,
				enumerable: false,
				get: polyfill
			});
		}
		return polyfill;
	};


/***/ },
/* 7213 */
/***/ function(module, exports) {

	"use strict";function isAbsolute(e){return"/"===e.charAt(0)}function spliceOne(e,t){for(var s=t,n=s+1,i=e.length;n<i;s+=1,n+=1)e[s]=e[n];e.pop()}function resolvePathname(e,t){void 0===t&&(t="");var s,n=e&&e.split("/")||[],i=t&&t.split("/")||[],l=e&&isAbsolute(e),r=t&&isAbsolute(t),o=l||r;if(e&&isAbsolute(e)?i=n:n.length&&(i.pop(),i=i.concat(n)),!i.length)return"/";if(i.length){var u=i[i.length-1];s="."===u||".."===u||""===u}else s=!1;for(var a=0,c=i.length;0<=c;c--){var f=i[c];"."===f?spliceOne(i,c):".."===f?(spliceOne(i,c),a++):a&&(spliceOne(i,c),a--)}if(!o)for(;a--;a)i.unshift("..");!o||""===i[0]||i[0]&&isAbsolute(i[0])||i.unshift("");var h=i.join("/");return s&&"/"!==h.substr(-1)&&(h+="/"),h}module.exports=resolvePathname;


/***/ },
/* 7214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(7213);
	} else {
	  module.exports = require('./cjs/resolve-pathname.js');
	}


/***/ },
/* 7215 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = ripemd160
	
	
	
	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.
	
	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	// Constants table
	var zl = [
	    0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	    7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	    3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	    1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	    4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13];
	var zr = [
	    5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	    6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	    15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	    8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	    12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11];
	var sl = [
	     11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	    7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	    11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	      11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	    9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ];
	var sr = [
	    8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	    9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	    9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	    15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	    8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ];
	
	var hl =  [ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
	var hr =  [ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];
	
	var bytesToWords = function (bytes) {
	  var words = [];
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << (24 - b % 32);
	  }
	  return words;
	};
	
	var wordsToBytes = function (words) {
	  var bytes = [];
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	  }
	  return bytes;
	};
	
	var processBlock = function (H, M, offset) {
	
	  // Swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i;
	    var M_offset_i = M[offset_i];
	
	    // Swap
	    M[offset_i] = (
	        (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	        (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	    );
	  }
	
	  // Working variables
	  var al, bl, cl, dl, el;
	  var ar, br, cr, dr, er;
	
	  ar = al = H[0];
	  br = bl = H[1];
	  cr = cl = H[2];
	  dr = dl = H[3];
	  er = el = H[4];
	  // Computation
	  var t;
	  for (var i = 0; i < 80; i += 1) {
	    t = (al +  M[offset+zl[i]])|0;
	    if (i<16){
	        t +=  f1(bl,cl,dl) + hl[0];
	    } else if (i<32) {
	        t +=  f2(bl,cl,dl) + hl[1];
	    } else if (i<48) {
	        t +=  f3(bl,cl,dl) + hl[2];
	    } else if (i<64) {
	        t +=  f4(bl,cl,dl) + hl[3];
	    } else {// if (i<80) {
	        t +=  f5(bl,cl,dl) + hl[4];
	    }
	    t = t|0;
	    t =  rotl(t,sl[i]);
	    t = (t+el)|0;
	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = t;
	
	    t = (ar + M[offset+zr[i]])|0;
	    if (i<16){
	        t +=  f5(br,cr,dr) + hr[0];
	    } else if (i<32) {
	        t +=  f4(br,cr,dr) + hr[1];
	    } else if (i<48) {
	        t +=  f3(br,cr,dr) + hr[2];
	    } else if (i<64) {
	        t +=  f2(br,cr,dr) + hr[3];
	    } else {// if (i<80) {
	        t +=  f1(br,cr,dr) + hr[4];
	    }
	    t = t|0;
	    t =  rotl(t,sr[i]) ;
	    t = (t+er)|0;
	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = t;
	  }
	  // Intermediate hash value
	  t    = (H[1] + cl + dr)|0;
	  H[1] = (H[2] + dl + er)|0;
	  H[2] = (H[3] + el + ar)|0;
	  H[3] = (H[4] + al + br)|0;
	  H[4] = (H[0] + bl + cr)|0;
	  H[0] =  t;
	};
	
	function f1(x, y, z) {
	  return ((x) ^ (y) ^ (z));
	}
	
	function f2(x, y, z) {
	  return (((x)&(y)) | ((~x)&(z)));
	}
	
	function f3(x, y, z) {
	  return (((x) | (~(y))) ^ (z));
	}
	
	function f4(x, y, z) {
	  return (((x) & (z)) | ((y)&(~(z))));
	}
	
	function f5(x, y, z) {
	  return ((x) ^ ((y) |(~(z))));
	}
	
	function rotl(x,n) {
	  return (x<<n) | (x>>>(32-n));
	}
	
	function ripemd160(message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];
	
	  if (typeof message == 'string')
	    message = new Buffer(message, 'utf8');
	
	  var m = bytesToWords(message);
	
	  var nBitsLeft = message.length * 8;
	  var nBitsTotal = message.length * 8;
	
	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	      (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	      (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	  );
	
	  for (var i=0 ; i<m.length; i += 16) {
	    processBlock(H, m, i);
	  }
	
	  // Swap endian
	  for (var i = 0; i < 5; i++) {
	      // Shortcut
	    var H_i = H[i];
	
	    // Swap
	    H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	          (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	  }
	
	  var digestbytes = wordsToBytes(H);
	  return new Buffer(digestbytes);
	}
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39).Buffer))

/***/ },
/* 7216 */
/***/ function(module, exports) {

	/** @license React v0.19.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ },
/* 7217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(7216);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 7218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _has2 = _interopRequireDefault(__webpack_require__(119));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Button = _interopRequireDefault(__webpack_require__(219));
	
	var _Modal = _interopRequireDefault(__webpack_require__(755));
	
	/**
	 * A Confirm modal gives the user a choice to confirm or cancel an action/
	 * @see Modal
	 */
	var Confirm =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Confirm, _Component);
	
	  function Confirm() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Confirm);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Confirm)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleCancel", function (e) {
	      (0, _invoke2["default"])(_this.props, 'onCancel', e, _this.props);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleCancelOverrides", function (predefinedProps) {
	      return {
	        onClick: function onClick(e, buttonProps) {
	          (0, _invoke2["default"])(predefinedProps, 'onClick', e, buttonProps);
	
	          _this.handleCancel(e);
	        }
	      };
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleConfirmOverrides", function (predefinedProps) {
	      return {
	        onClick: function onClick(e, buttonProps) {
	          (0, _invoke2["default"])(predefinedProps, 'onClick', e, buttonProps);
	          (0, _invoke2["default"])(_this.props, 'onConfirm', e, _this.props);
	        }
	      };
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Confirm, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          cancelButton = _this$props.cancelButton,
	          confirmButton = _this$props.confirmButton,
	          content = _this$props.content,
	          header = _this$props.header,
	          open = _this$props.open,
	          size = _this$props.size;
	      var rest = (0, _lib.getUnhandledProps)(Confirm, this.props); // `open` is auto controlled by the Modal
	      // It cannot be present (even undefined) with `defaultOpen`
	      // only apply it if the user provided an open prop
	
	      var openProp = {};
	      if ((0, _has2["default"])(this.props, 'open')) openProp.open = open;
	      return _react["default"].createElement(_Modal["default"], (0, _extends2["default"])({}, rest, openProp, {
	        size: size,
	        onClose: this.handleCancel
	      }), _Modal["default"].Header.create(header, {
	        autoGenerateKey: false
	      }), _Modal["default"].Content.create(content, {
	        autoGenerateKey: false
	      }), _react["default"].createElement(_Modal["default"].Actions, null, _Button["default"].create(cancelButton, {
	        autoGenerateKey: false,
	        overrideProps: this.handleCancelOverrides
	      }), _Button["default"].create(confirmButton, {
	        autoGenerateKey: false,
	        defaultProps: {
	          primary: true
	        },
	        overrideProps: this.handleConfirmOverrides
	      })));
	    }
	  }]);
	  return Confirm;
	}(_react.Component);
	
	(0, _defineProperty2["default"])(Confirm, "defaultProps", {
	  cancelButton: 'Cancel',
	  confirmButton: 'OK',
	  content: 'Are you sure?',
	  size: 'small'
	});
	(0, _defineProperty2["default"])(Confirm, "handledProps", ["cancelButton", "confirmButton", "content", "header", "onCancel", "onConfirm", "open", "size"]);
	Confirm.propTypes =  false ? {
	  /** The cancel button text. */
	  cancelButton: _lib.customPropTypes.itemShorthand,
	
	  /** The OK button text. */
	  confirmButton: _lib.customPropTypes.itemShorthand,
	
	  /** The ModalContent text. */
	  content: _lib.customPropTypes.itemShorthand,
	
	  /** The ModalHeader text. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /**
	   * Called when the Modal is closed without clicking confirm.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onCancel: _propTypes["default"].func,
	
	  /**
	   * Called when the OK button is clicked.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onConfirm: _propTypes["default"].func,
	
	  /** Whether or not the modal is visible. */
	  open: _propTypes["default"].bool,
	
	  /** A Confirm can vary in size */
	  size: _propTypes["default"].oneOf(['mini', 'tiny', 'small', 'large', 'fullscreen'])
	} : {};
	var _default = Confirm;
	exports["default"] = _default;

/***/ },
/* 7219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Confirm["default"];
	  }
	});
	
	var _Confirm = _interopRequireDefault(__webpack_require__(7218));

/***/ },
/* 7220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(26));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = __webpack_require__(2);
	
	var _lib = __webpack_require__(12);
	
	var _getNodeRefFromProps = _interopRequireDefault(__webpack_require__(7224));
	
	var _handleClassNamesChange = _interopRequireDefault(__webpack_require__(7225));
	
	var _NodeRegistry = _interopRequireDefault(__webpack_require__(7221));
	
	var nodeRegistry = new _NodeRegistry["default"]();
	/**
	 * A component that allows to manage classNames on a DOM node in declarative manner.
	 */
	
	var MountNode =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(MountNode, _Component);
	
	  function MountNode() {
	    (0, _classCallCheck2["default"])(this, MountNode);
	    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MountNode).apply(this, arguments));
	  }
	
	  (0, _createClass2["default"])(MountNode, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(_ref) {
	      var nextClassName = _ref.className;
	      var currentClassName = this.props.className;
	      return nextClassName !== currentClassName;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var nodeRef = (0, _getNodeRefFromProps["default"])(this.props);
	      nodeRegistry.add(nodeRef, this);
	      nodeRegistry.emit(nodeRef, _handleClassNamesChange["default"]);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      nodeRegistry.emit((0, _getNodeRefFromProps["default"])(this.props), _handleClassNamesChange["default"]);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var nodeRef = (0, _getNodeRefFromProps["default"])(this.props);
	      nodeRegistry.del(nodeRef, this);
	      nodeRegistry.emit(nodeRef, _handleClassNamesChange["default"]);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	  return MountNode;
	}(_react.Component);
	
	exports["default"] = MountNode;
	(0, _defineProperty2["default"])(MountNode, "handledProps", ["className", "node"]);
	MountNode.propTypes =  false ? {
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** The DOM node where we will apply class names. Defaults to document.body. */
	  node: _propTypes["default"].oneOfType([_lib.customPropTypes.domNode, _lib.customPropTypes.refObject])
	} : {};

/***/ },
/* 7221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var NodeRegistry = function NodeRegistry() {
	  var _this = this;
	
	  (0, _classCallCheck2["default"])(this, NodeRegistry);
	  (0, _defineProperty2["default"])(this, "add", function (nodeRef, component) {
	    if (_this.nodes.has(nodeRef)) {
	      var set = _this.nodes.get(nodeRef);
	
	      set.add(component);
	      return;
	    }
	
	    _this.nodes.set(nodeRef, new Set([component]));
	  });
	  (0, _defineProperty2["default"])(this, "del", function (nodeRef, component) {
	    if (!_this.nodes.has(nodeRef)) return;
	
	    var set = _this.nodes.get(nodeRef);
	
	    if (set.size === 1) {
	      _this.nodes["delete"](nodeRef);
	
	      return;
	    }
	
	    set["delete"](component);
	  });
	  (0, _defineProperty2["default"])(this, "emit", function (nodeRef, callback) {
	    callback(nodeRef, _this.nodes.get(nodeRef));
	  });
	  this.nodes = new Map();
	};
	
	exports["default"] = NodeRegistry;

/***/ },
/* 7222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _uniq2 = _interopRequireDefault(__webpack_require__(6914));
	
	var _identity2 = _interopRequireDefault(__webpack_require__(6899));
	
	var _filter2 = _interopRequireDefault(__webpack_require__(6897));
	
	var _split2 = _interopRequireDefault(__webpack_require__(6909));
	
	var _flatMap2 = _interopRequireDefault(__webpack_require__(6898));
	
	var _map2 = _interopRequireDefault(__webpack_require__(510));
	
	var _toArray2 = _interopRequireDefault(__webpack_require__(6912));
	
	var _flow2 = _interopRequireDefault(__webpack_require__(509));
	
	var computeClassNames = (0, _flow2["default"])(_toArray2["default"], (0, _map2["default"])('props.className'), (0, _flatMap2["default"])((0, _split2["default"])(/\s+/)), (0, _filter2["default"])(_identity2["default"]), _uniq2["default"]);
	var _default = computeClassNames;
	exports["default"] = _default;

/***/ },
/* 7223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _difference2 = _interopRequireDefault(__webpack_require__(279));
	
	var computeClassNamesDifference = function computeClassNamesDifference(prevClassNames, currentClassNames) {
	  return [(0, _difference2["default"])(currentClassNames, prevClassNames), (0, _difference2["default"])(prevClassNames, currentClassNames)];
	};
	
	var _default = computeClassNamesDifference;
	exports["default"] = _default;

/***/ },
/* 7224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(43));
	
	var _reactComponentRef = __webpack_require__(52);
	
	var _lib = __webpack_require__(12);
	
	/**
	 * Given `this.props`, return a `node` value or undefined.
	 *
	 * @param {object|React.RefObject} props Component's props
	 * @return {React.RefObject|undefined}
	 */
	var getNodeRefFromProps = function getNodeRefFromProps(props) {
	  var node = props.node;
	
	  if ((0, _lib.isBrowser)()) {
	    if ((0, _reactComponentRef.isRefObject)(node)) return node;
	    return (0, _isNil2["default"])(node) ? (0, _reactComponentRef.toRefObject)(document.body) : (0, _reactComponentRef.toRefObject)(node);
	  }
	};
	
	var _default = getNodeRefFromProps;
	exports["default"] = _default;

/***/ },
/* 7225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
	
	var _forEach2 = _interopRequireDefault(__webpack_require__(118));
	
	var _computeClassNames = _interopRequireDefault(__webpack_require__(7222));
	
	var _computeClassNamesDifference = _interopRequireDefault(__webpack_require__(7223));
	
	var prevClassNames = new Map();
	/**
	 * @param {React.RefObject} nodeRef
	 * @param {Object[]} components
	 */
	
	var handleClassNamesChange = function handleClassNamesChange(nodeRef, components) {
	  var currentClassNames = (0, _computeClassNames["default"])(components);
	
	  var _computeClassNamesDif = (0, _computeClassNamesDifference["default"])(prevClassNames.get(nodeRef), currentClassNames),
	      _computeClassNamesDif2 = (0, _slicedToArray2["default"])(_computeClassNamesDif, 2),
	      forAdd = _computeClassNamesDif2[0],
	      forRemoval = _computeClassNamesDif2[1];
	
	  if (nodeRef.current) {
	    (0, _forEach2["default"])(forAdd, function (className) {
	      return nodeRef.current.classList.add(className);
	    });
	    (0, _forEach2["default"])(forRemoval, function (className) {
	      return nodeRef.current.classList.remove(className);
	    });
	  }
	
	  prevClassNames.set(nodeRef, currentClassNames);
	};
	
	var _default = handleClassNamesChange;
	exports["default"] = _default;

/***/ },
/* 7226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _map2 = _interopRequireDefault(__webpack_require__(41));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(43));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Menu = _interopRequireDefault(__webpack_require__(708));
	
	var _PaginationItem = _interopRequireDefault(__webpack_require__(689));
	
	/**
	 * A component to render a pagination.
	 */
	var Pagination =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Pagination, _Component);
	
	  function Pagination() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Pagination);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Pagination)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleItemClick", function (e, _ref) {
	      var nextActivePage = _ref.value;
	      var prevActivePage = _this.state.activePage; // Heads up! We need the cast to the "number" type there, as `activePage` can be a string
	
	      if (+prevActivePage === +nextActivePage) return;
	
	      _this.trySetState({
	        activePage: nextActivePage
	      });
	
	      (0, _invoke2["default"])(_this.props, 'onPageChange', e, (0, _objectSpread2["default"])({}, _this.props, {
	        activePage: nextActivePage
	      }));
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleItemOverrides", function (active, type, value) {
	      return function (predefinedProps) {
	        return {
	          active: active,
	          type: type,
	          key: "".concat(type, "-").concat(value),
	          onClick: function onClick(e, itemProps) {
	            (0, _invoke2["default"])(predefinedProps, 'onClick', e, itemProps);
	            if (itemProps.type !== 'ellipsisItem') _this.handleItemClick(e, itemProps);
	          }
	        };
	      };
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Pagination, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          ariaLabel = _this$props['aria-label'],
	          boundaryRange = _this$props.boundaryRange,
	          disabled = _this$props.disabled,
	          ellipsisItem = _this$props.ellipsisItem,
	          siblingRange = _this$props.siblingRange,
	          totalPages = _this$props.totalPages;
	      var activePage = this.state.activePage;
	      var items = (0, _lib.createPaginationItems)({
	        activePage: activePage,
	        boundaryRange: boundaryRange,
	        hideEllipsis: (0, _isNil2["default"])(ellipsisItem),
	        siblingRange: siblingRange,
	        totalPages: totalPages
	      });
	      var rest = (0, _lib.getUnhandledProps)(Pagination, this.props);
	      return _react["default"].createElement(_Menu["default"], (0, _extends2["default"])({}, rest, {
	        "aria-label": ariaLabel,
	        pagination: true,
	        role: "navigation"
	      }), (0, _map2["default"])(items, function (_ref2) {
	        var active = _ref2.active,
	            type = _ref2.type,
	            value = _ref2.value;
	        return _PaginationItem["default"].create(_this2.props[type], {
	          defaultProps: {
	            content: value,
	            disabled: disabled,
	            value: value
	          },
	          overrideProps: _this2.handleItemOverrides(active, type, value)
	        });
	      }));
	    }
	  }]);
	  return Pagination;
	}(_lib.AutoControlledComponent);
	
	exports["default"] = Pagination;
	(0, _defineProperty2["default"])(Pagination, "autoControlledProps", ['activePage']);
	(0, _defineProperty2["default"])(Pagination, "defaultProps", {
	  'aria-label': 'Pagination Navigation',
	  boundaryRange: 1,
	  ellipsisItem: '...',
	  firstItem: {
	    'aria-label': 'First item',
	    content: '«'
	  },
	  lastItem: {
	    'aria-label': 'Last item',
	    content: '»'
	  },
	  nextItem: {
	    'aria-label': 'Next item',
	    content: '⟩'
	  },
	  pageItem: {},
	  prevItem: {
	    'aria-label': 'Previous item',
	    content: '⟨'
	  },
	  siblingRange: 1
	});
	(0, _defineProperty2["default"])(Pagination, "Item", _PaginationItem["default"]);
	(0, _defineProperty2["default"])(Pagination, "handledProps", ["activePage", "aria-label", "boundaryRange", "defaultActivePage", "disabled", "ellipsisItem", "firstItem", "lastItem", "nextItem", "onPageChange", "pageItem", "prevItem", "siblingRange", "totalPages"]);
	Pagination.propTypes =  false ? {
	  /** A pagination item can have an aria label. */
	  'aria-label': _propTypes["default"].string,
	
	  /** Initial activePage value. */
	  defaultActivePage: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /** Index of the currently active page. */
	  activePage: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /** Number of always visible pages at the beginning and end. */
	  boundaryRange: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /** A pagination can be disabled. */
	  disabled: _propTypes["default"].bool,
	
	  /** A shorthand for PaginationItem. */
	  ellipsisItem: _lib.customPropTypes.itemShorthand,
	
	  /** A shorthand for PaginationItem. */
	  firstItem: _lib.customPropTypes.itemShorthand,
	
	  /** A shorthand for PaginationItem. */
	  lastItem: _lib.customPropTypes.itemShorthand,
	
	  /** A shorthand for PaginationItem. */
	  nextItem: _lib.customPropTypes.itemShorthand,
	
	  /** A shorthand for PaginationItem. */
	  pageItem: _lib.customPropTypes.itemShorthand,
	
	  /** A shorthand for PaginationItem. */
	  prevItem: _lib.customPropTypes.itemShorthand,
	
	  /**
	   * Called on change of an active page.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onPageChange: _propTypes["default"].func,
	
	  /** Number of always visible pages before and after the current one. */
	  siblingRange: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /** Total number of pages. */
	  totalPages: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired
	} : {};

/***/ },
/* 7227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Pagination["default"];
	  }
	});
	
	var _Pagination = _interopRequireDefault(__webpack_require__(7226));

/***/ },
/* 7228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _eventStack = _interopRequireDefault(__webpack_require__(172));
	
	var _reactComponentRef = __webpack_require__(52);
	
	var _keyboardKey = _interopRequireDefault(__webpack_require__(138));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _PortalInner = _interopRequireDefault(__webpack_require__(690));
	
	/**
	 * A component that allows you to render children outside their parent.
	 * @see Modal
	 * @see Popup
	 * @see Dimmer
	 * @see Confirm
	 */
	var Portal =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Portal, _Component);
	
	  function Portal() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Portal);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Portal)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "contentRef", (0, _react.createRef)());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "triggerRef", (0, _react.createRef)());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "latestDocumentMouseDownEvent", null);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleDocumentMouseDown", function (e) {
	      _this.latestDocumentMouseDownEvent = e;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleDocumentClick", function (e) {
	      var closeOnDocumentClick = _this.props.closeOnDocumentClick;
	      var currentMouseDownEvent = _this.latestDocumentMouseDownEvent;
	      _this.latestDocumentMouseDownEvent = null;
	
	      if (!_this.contentRef.current || // no portal
	      (0, _lib.doesNodeContainClick)(_this.triggerRef.current, e) || // event happened in trigger (delegate to trigger handlers)
	      currentMouseDownEvent && (0, _lib.doesNodeContainClick)(_this.contentRef.current, currentMouseDownEvent) || // event originated in the portal but was ended outside
	      (0, _lib.doesNodeContainClick)(_this.contentRef.current, e) // event happened in the portal
	      ) {
	          return;
	        } // ignore the click
	
	
	      if (closeOnDocumentClick) {
	        _this.close(e);
	      }
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleEscape", function (e) {
	      if (!_this.props.closeOnEscape) return;
	      if (_keyboardKey["default"].getCode(e) !== _keyboardKey["default"].Escape) return;
	
	      _this.close(e);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handlePortalMouseLeave", function (e) {
	      var _this$props = _this.props,
	          closeOnPortalMouseLeave = _this$props.closeOnPortalMouseLeave,
	          mouseLeaveDelay = _this$props.mouseLeaveDelay;
	      if (!closeOnPortalMouseLeave) return; // Do not close the portal when 'mouseleave' is triggered by children
	
	      if (e.target !== _this.contentRef.current) return;
	      _this.mouseLeaveTimer = _this.closeWithTimeout(e, mouseLeaveDelay);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handlePortalMouseEnter", function () {
	      // In order to enable mousing from the trigger to the portal, we need to
	      // clear the mouseleave timer that was set when leaving the trigger.
	      var closeOnPortalMouseLeave = _this.props.closeOnPortalMouseLeave;
	      if (!closeOnPortalMouseLeave) return;
	      clearTimeout(_this.mouseLeaveTimer);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTriggerBlur", function (e) {
	      var _this$props2 = _this.props,
	          trigger = _this$props2.trigger,
	          closeOnTriggerBlur = _this$props2.closeOnTriggerBlur; // Call original event handler
	
	      for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        rest[_key2 - 1] = arguments[_key2];
	      }
	
	      _invoke2["default"].apply(void 0, [trigger, 'props.onBlur', e].concat(rest)); // IE 11 doesn't work with relatedTarget in blur events
	
	
	      var target = e.relatedTarget || document.activeElement; // do not close if focus is given to the portal
	
	      var didFocusPortal = (0, _invoke2["default"])(_this.contentRef.current, 'contains', target);
	      if (!closeOnTriggerBlur || didFocusPortal) return;
	
	      _this.close(e);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTriggerClick", function (e) {
	      var _this$props3 = _this.props,
	          trigger = _this$props3.trigger,
	          closeOnTriggerClick = _this$props3.closeOnTriggerClick,
	          openOnTriggerClick = _this$props3.openOnTriggerClick;
	      var open = _this.state.open; // Call original event handler
	
	      for (var _len3 = arguments.length, rest = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	        rest[_key3 - 1] = arguments[_key3];
	      }
	
	      _invoke2["default"].apply(void 0, [trigger, 'props.onClick', e].concat(rest));
	
	      if (open && closeOnTriggerClick) {
	        _this.close(e);
	      } else if (!open && openOnTriggerClick) {
	        _this.open(e);
	      }
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTriggerFocus", function (e) {
	      var _this$props4 = _this.props,
	          trigger = _this$props4.trigger,
	          openOnTriggerFocus = _this$props4.openOnTriggerFocus; // Call original event handler
	
	      for (var _len4 = arguments.length, rest = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	        rest[_key4 - 1] = arguments[_key4];
	      }
	
	      _invoke2["default"].apply(void 0, [trigger, 'props.onFocus', e].concat(rest));
	
	      if (!openOnTriggerFocus) return;
	
	      _this.open(e);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTriggerMouseLeave", function (e) {
	      clearTimeout(_this.mouseEnterTimer);
	      var _this$props5 = _this.props,
	          trigger = _this$props5.trigger,
	          closeOnTriggerMouseLeave = _this$props5.closeOnTriggerMouseLeave,
	          mouseLeaveDelay = _this$props5.mouseLeaveDelay; // Call original event handler
	
	      for (var _len5 = arguments.length, rest = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	        rest[_key5 - 1] = arguments[_key5];
	      }
	
	      _invoke2["default"].apply(void 0, [trigger, 'props.onMouseLeave', e].concat(rest));
	
	      if (!closeOnTriggerMouseLeave) return;
	      _this.mouseLeaveTimer = _this.closeWithTimeout(e, mouseLeaveDelay);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTriggerMouseEnter", function (e) {
	      clearTimeout(_this.mouseLeaveTimer);
	      var _this$props6 = _this.props,
	          trigger = _this$props6.trigger,
	          mouseEnterDelay = _this$props6.mouseEnterDelay,
	          openOnTriggerMouseEnter = _this$props6.openOnTriggerMouseEnter; // Call original event handler
	
	      for (var _len6 = arguments.length, rest = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	        rest[_key6 - 1] = arguments[_key6];
	      }
	
	      _invoke2["default"].apply(void 0, [trigger, 'props.onMouseEnter', e].concat(rest));
	
	      if (!openOnTriggerMouseEnter) return;
	      _this.mouseEnterTimer = _this.openWithTimeout(e, mouseEnterDelay);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "open", function (e) {
	      var onOpen = _this.props.onOpen;
	      if (onOpen) onOpen(e, _this.props);
	
	      _this.trySetState({
	        open: true
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "openWithTimeout", function (e, delay) {
	      // React wipes the entire event object and suggests using e.persist() if
	      // you need the event for async access. However, even with e.persist
	      // certain required props (e.g. currentTarget) are null so we're forced to clone.
	      var eventClone = (0, _objectSpread2["default"])({}, e);
	      return setTimeout(function () {
	        return _this.open(eventClone);
	      }, delay || 0);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "close", function (e) {
	      var onClose = _this.props.onClose;
	      if (onClose) onClose(e, _this.props);
	
	      _this.trySetState({
	        open: false
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closeWithTimeout", function (e, delay) {
	      // React wipes the entire event object and suggests using e.persist() if
	      // you need the event for async access. However, even with e.persist
	      // certain required props (e.g. currentTarget) are null so we're forced to clone.
	      var eventClone = (0, _objectSpread2["default"])({}, e);
	      return setTimeout(function () {
	        return _this.close(eventClone);
	      }, delay || 0);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleMount", function () {
	      (0, _invoke2["default"])(_this.props, 'onMount', null, _this.props);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleUnmount", function () {
	      (0, _invoke2["default"])(_this.props, 'onUnmount', null, _this.props);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTriggerRef", function (c) {
	      _this.triggerRef.current = c;
	      (0, _reactComponentRef.handleRef)(_this.props.triggerRef, c);
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Portal, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      // Clean up timers
	      clearTimeout(this.mouseEnterTimer);
	      clearTimeout(this.mouseLeaveTimer);
	    } // ----------------------------------------
	    // Document Event Handlers
	    // ----------------------------------------
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props7 = this.props,
	          children = _this$props7.children,
	          eventPool = _this$props7.eventPool,
	          mountNode = _this$props7.mountNode,
	          trigger = _this$props7.trigger;
	      var open = this.state.open;
	      return _react["default"].createElement(_react.Fragment, null, open && _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_PortalInner["default"], {
	        innerRef: this.contentRef,
	        mountNode: mountNode,
	        onMount: this.handleMount,
	        onUnmount: this.handleUnmount
	      }, children), _react["default"].createElement(_eventStack["default"], {
	        name: "mouseleave",
	        on: this.handlePortalMouseLeave,
	        pool: eventPool,
	        target: this.contentRef
	      }), _react["default"].createElement(_eventStack["default"], {
	        name: "mouseenter",
	        on: this.handlePortalMouseEnter,
	        pool: eventPool,
	        target: this.contentRef
	      }), _react["default"].createElement(_eventStack["default"], {
	        name: "mousedown",
	        on: this.handleDocumentMouseDown,
	        pool: eventPool
	      }), _react["default"].createElement(_eventStack["default"], {
	        name: "click",
	        on: this.handleDocumentClick,
	        pool: eventPool
	      }), _react["default"].createElement(_eventStack["default"], {
	        name: "keydown",
	        on: this.handleEscape,
	        pool: eventPool
	      })), trigger && _react["default"].createElement(_reactComponentRef.Ref, {
	        innerRef: this.handleTriggerRef
	      }, (0, _react.cloneElement)(trigger, {
	        onBlur: this.handleTriggerBlur,
	        onClick: this.handleTriggerClick,
	        onFocus: this.handleTriggerFocus,
	        onMouseLeave: this.handleTriggerMouseLeave,
	        onMouseEnter: this.handleTriggerMouseEnter
	      })));
	    }
	  }]);
	  return Portal;
	}(_lib.AutoControlledComponent);
	
	(0, _defineProperty2["default"])(Portal, "defaultProps", {
	  closeOnDocumentClick: true,
	  closeOnEscape: true,
	  eventPool: 'default',
	  openOnTriggerClick: true
	});
	(0, _defineProperty2["default"])(Portal, "autoControlledProps", ['open']);
	(0, _defineProperty2["default"])(Portal, "Inner", _PortalInner["default"]);
	(0, _defineProperty2["default"])(Portal, "handledProps", ["children", "closeOnDocumentClick", "closeOnEscape", "closeOnPortalMouseLeave", "closeOnTriggerBlur", "closeOnTriggerClick", "closeOnTriggerMouseLeave", "defaultOpen", "eventPool", "mountNode", "mouseEnterDelay", "mouseLeaveDelay", "onClose", "onMount", "onOpen", "onUnmount", "open", "openOnTriggerClick", "openOnTriggerFocus", "openOnTriggerMouseEnter", "trigger", "triggerRef"]);
	Portal.propTypes =  false ? {
	  /** Primary content. */
	  children: _propTypes["default"].node.isRequired,
	
	  /** Controls whether or not the portal should close when the document is clicked. */
	  closeOnDocumentClick: _propTypes["default"].bool,
	
	  /** Controls whether or not the portal should close when escape is pressed is displayed. */
	  closeOnEscape: _propTypes["default"].bool,
	
	  /**
	   * Controls whether or not the portal should close when mousing out of the portal.
	   * NOTE: This will prevent `closeOnTriggerMouseLeave` when mousing over the
	   * gap from the trigger to the portal.
	   */
	  closeOnPortalMouseLeave: _propTypes["default"].bool,
	
	  /** Controls whether or not the portal should close on blur of the trigger. */
	  closeOnTriggerBlur: _propTypes["default"].bool,
	
	  /** Controls whether or not the portal should close on click of the trigger. */
	  closeOnTriggerClick: _propTypes["default"].bool,
	
	  /** Controls whether or not the portal should close when mousing out of the trigger. */
	  closeOnTriggerMouseLeave: _propTypes["default"].bool,
	
	  /** Initial value of open. */
	  defaultOpen: _propTypes["default"].bool,
	
	  /** Event pool namespace that is used to handle component events */
	  eventPool: _propTypes["default"].string,
	
	  /** The node where the portal should mount. */
	  mountNode: _propTypes["default"].any,
	
	  /** Milliseconds to wait before opening on mouse over */
	  mouseEnterDelay: _propTypes["default"].number,
	
	  /** Milliseconds to wait before closing on mouse leave */
	  mouseLeaveDelay: _propTypes["default"].number,
	
	  /**
	   * Called when a close event happens
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClose: _propTypes["default"].func,
	
	  /**
	   * Called when the portal is mounted on the DOM.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onMount: _propTypes["default"].func,
	
	  /**
	   * Called when an open event happens
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onOpen: _propTypes["default"].func,
	
	  /**
	   * Called when the portal is unmounted from the DOM.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onUnmount: _propTypes["default"].func,
	
	  /** Controls whether or not the portal is displayed. */
	  open: _propTypes["default"].bool,
	
	  /** Controls whether or not the portal should open when the trigger is clicked. */
	  openOnTriggerClick: _propTypes["default"].bool,
	
	  /** Controls whether or not the portal should open on focus of the trigger. */
	  openOnTriggerFocus: _propTypes["default"].bool,
	
	  /** Controls whether or not the portal should open when mousing over the trigger. */
	  openOnTriggerMouseEnter: _propTypes["default"].bool,
	
	  /** Element to be rendered in-place where the portal is defined. */
	  trigger: _propTypes["default"].node,
	
	  /** Called with a ref to the trigger node. */
	  triggerRef: _lib.customPropTypes.ref
	} : {};
	var _default = Portal;
	exports["default"] = _default;

/***/ },
/* 7229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(223));
	
	/**
	 * A Radio is sugar for <Checkbox radio />.
	 * Useful for exclusive groups of sliders or toggles.
	 * @see Checkbox
	 * @see Form
	 */
	function Radio(props) {
	  var slider = props.slider,
	      toggle = props.toggle,
	      type = props.type;
	  var rest = (0, _lib.getUnhandledProps)(Radio, props); // const ElementType = getElementType(Radio, props)
	  // radio, slider, toggle are exclusive
	  // use an undefined radio if slider or toggle are present
	
	  var radio = !(slider || toggle) || undefined;
	  return _react["default"].createElement(_Checkbox["default"], (0, _extends2["default"])({}, rest, {
	    type: type,
	    radio: radio,
	    slider: slider,
	    toggle: toggle
	  }));
	}
	
	Radio.handledProps = ["slider", "toggle", "type"];
	Radio.propTypes =  false ? {
	  /** Format to emphasize the current selection state. */
	  slider: _Checkbox["default"].propTypes.slider,
	
	  /** Format to show an on or off choice. */
	  toggle: _Checkbox["default"].propTypes.toggle,
	
	  /** HTML input type, either checkbox or radio. */
	  type: _Checkbox["default"].propTypes.type
	} : {};
	Radio.defaultProps = {
	  type: 'radio'
	};
	var _default = Radio;
	exports["default"] = _default;

/***/ },
/* 7230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _isVisible = _interopRequireDefault(__webpack_require__(7232));
	
	/**
	 * Responsive can control visibility of content.
	 */
	var Responsive =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Responsive, _Component);
	
	  function Responsive() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Responsive);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Responsive)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
	      visible: true
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleResize", function (e) {
	      if (_this.ticking) return;
	      _this.ticking = true;
	      _this.frameId = requestAnimationFrame(function () {
	        return _this.handleUpdate(e);
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleUpdate", function (e) {
	      _this.ticking = false;
	      var visible = _this.state.visible;
	      var width = (0, _invoke2["default"])(_this.props, 'getWidth');
	      var nextVisible = (0, _isVisible["default"])(width, _this.props);
	      if (visible !== nextVisible) _this.setState({
	        visible: nextVisible
	      });
	      (0, _invoke2["default"])(_this.props, 'onUpdate', e, (0, _objectSpread2["default"])({}, _this.props, {
	        width: width
	      }));
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Responsive, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var fireOnMount = this.props.fireOnMount;
	
	      _lib.eventStack.sub('resize', this.handleResize, {
	        target: 'window'
	      });
	
	      if (fireOnMount) this.handleUpdate();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _lib.eventStack.unsub('resize', this.handleResize, {
	        target: 'window'
	      });
	
	      cancelAnimationFrame(this.frameId);
	    } // ----------------------------------------
	    // Event handlers
	    // ----------------------------------------
	
	  }, {
	    key: "render",
	    // ----------------------------------------
	    // Render
	    // ----------------------------------------
	    value: function render() {
	      var children = this.props.children;
	      var visible = this.state.visible;
	      var ElementType = (0, _lib.getElementType)(Responsive, this.props);
	      var rest = (0, _lib.getUnhandledProps)(Responsive, this.props);
	      if (visible) return _react["default"].createElement(ElementType, rest, children);
	      return null;
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(props) {
	      var width = (0, _invoke2["default"])(props, 'getWidth');
	      var visible = (0, _isVisible["default"])(width, props);
	      return {
	        visible: visible
	      };
	    }
	  }]);
	  return Responsive;
	}(_react.Component);
	
	exports["default"] = Responsive;
	(0, _defineProperty2["default"])(Responsive, "defaultProps", {
	  getWidth: function getWidth() {
	    return (0, _lib.isBrowser)() ? window.innerWidth : 0;
	  }
	});
	(0, _defineProperty2["default"])(Responsive, "onlyMobile", {
	  minWidth: 320,
	  maxWidth: 767
	});
	(0, _defineProperty2["default"])(Responsive, "onlyTablet", {
	  minWidth: 768,
	  maxWidth: 991
	});
	(0, _defineProperty2["default"])(Responsive, "onlyComputer", {
	  minWidth: 992
	});
	(0, _defineProperty2["default"])(Responsive, "onlyLargeScreen", {
	  minWidth: 1200,
	  maxWidth: 1919
	});
	(0, _defineProperty2["default"])(Responsive, "onlyWidescreen", {
	  minWidth: 1920
	});
	(0, _defineProperty2["default"])(Responsive, "handledProps", ["as", "children", "fireOnMount", "getWidth", "maxWidth", "minWidth", "onUpdate"]);
	Responsive.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Fires callbacks immediately after mount. */
	  fireOnMount: _propTypes["default"].bool,
	
	  /**
	   * Called to get width of screen. Defaults to using `window.innerWidth` when in a browser;
	   * otherwise, assumes a width of 0.
	   */
	  getWidth: _propTypes["default"].func,
	
	  /** The maximum width at which content will be displayed. */
	  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /** The minimum width at which content will be displayed. */
	  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /**
	   * Called on update.
	   *
	   * @param {SyntheticEvent} event - The React SyntheticEvent object
	   * @param {object} data - All props and the event value.
	   */
	  onUpdate: _propTypes["default"].func
	} : {};

/***/ },
/* 7231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Responsive["default"];
	  }
	});
	
	var _Responsive = _interopRequireDefault(__webpack_require__(7230));

/***/ },
/* 7232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(43));
	
	var fitsMaxWidth = function fitsMaxWidth(width, maxWidth) {
	  return (0, _isNil2["default"])(maxWidth) ? true : width <= maxWidth;
	};
	
	var fitsMinWidth = function fitsMinWidth(width, minWidth) {
	  return (0, _isNil2["default"])(minWidth) ? true : width >= minWidth;
	};
	
	var isVisible = function isVisible(width, _ref) {
	  var maxWidth = _ref.maxWidth,
	      minWidth = _ref.minWidth;
	  return fitsMinWidth(width, minWidth) && fitsMaxWidth(width, maxWidth);
	};
	
	var _default = isVisible;
	exports["default"] = _default;

/***/ },
/* 7233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _Dropdown = _interopRequireDefault(__webpack_require__(224));
	
	/**
	 * A Select is sugar for <Dropdown selection />.
	 * @see Dropdown
	 * @see Form
	 */
	function Select(props) {
	  return _react["default"].createElement(_Dropdown["default"], (0, _extends2["default"])({}, props, {
	    selection: true
	  }));
	}
	
	Select.handledProps = ["options"];
	Select.propTypes =  false ? {
	  /** Array of Dropdown.Item props e.g. `{ text: '', value: '' }` */
	  options: _propTypes["default"].arrayOf(_propTypes["default"].shape(_Dropdown["default"].Item.propTypes)).isRequired
	} : {};
	Select.Divider = _Dropdown["default"].Divider;
	Select.Header = _Dropdown["default"].Header;
	Select.Item = _Dropdown["default"].Item;
	Select.Menu = _Dropdown["default"].Menu;
	var _default = Select;
	exports["default"] = _default;

/***/ },
/* 7234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _get2 = _interopRequireDefault(__webpack_require__(72));
	
	var _reactComponentRef = __webpack_require__(52);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A TextArea can be used to allow for extended user input.
	 * @see Form
	 */
	var TextArea =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(TextArea, _Component);
	
	  function TextArea() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, TextArea);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(TextArea)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "ref", (0, _react.createRef)());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focus", function () {
	      return _this.ref.current.focus();
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleChange", function (e) {
	      var value = (0, _get2["default"])(e, 'target.value');
	      (0, _invoke2["default"])(_this.props, 'onChange', e, (0, _objectSpread2["default"])({}, _this.props, {
	        value: value
	      }));
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleInput", function (e) {
	      var value = (0, _get2["default"])(e, 'target.value');
	      (0, _invoke2["default"])(_this.props, 'onInput', e, (0, _objectSpread2["default"])({}, _this.props, {
	        value: value
	      }));
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(TextArea, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          rows = _this$props.rows,
	          value = _this$props.value;
	      var rest = (0, _lib.getUnhandledProps)(TextArea, this.props);
	      var ElementType = (0, _lib.getElementType)(TextArea, this.props);
	      return _react["default"].createElement(_reactComponentRef.Ref, {
	        innerRef: this.ref
	      }, _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        onChange: this.handleChange,
	        onInput: this.handleInput,
	        rows: rows,
	        value: value
	      })));
	    }
	  }]);
	  return TextArea;
	}(_react.Component);
	
	(0, _defineProperty2["default"])(TextArea, "defaultProps", {
	  as: 'textarea',
	  rows: 3
	});
	(0, _defineProperty2["default"])(TextArea, "handledProps", ["as", "onChange", "onInput", "rows", "value"]);
	TextArea.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /**
	   * Called on change.
	   * @param {SyntheticEvent} event - The React SyntheticEvent object
	   * @param {object} data - All props and the event value.
	   */
	  onChange: _propTypes["default"].func,
	
	  /**
	   * Called on input.
	   * @param {SyntheticEvent} event - The React SyntheticEvent object
	   * @param {object} data - All props and the event value.
	   */
	  onInput: _propTypes["default"].func,
	
	  /** Indicates row count for a TextArea. */
	  rows: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /** The value of the textarea. */
	  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	} : {};
	var _default = TextArea;
	exports["default"] = _default;

/***/ },
/* 7235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _Portal = _interopRequireDefault(__webpack_require__(158));
	
	var _Transition = _interopRequireDefault(__webpack_require__(767));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A sugar for `Portal` and `Transition`.
	 * @see Portal
	 * @see Transition
	 */
	var TransitionablePortal =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(TransitionablePortal, _Component);
	
	  function TransitionablePortal(props) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, TransitionablePortal);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(TransitionablePortal).call(this, props));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handlePortalClose", function () {
	      _this.setState({
	        portalOpen: false
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handlePortalOpen", function () {
	      _this.setState({
	        portalOpen: true
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTransitionHide", function (nothing, data) {
	      var portalOpen = _this.state.portalOpen;
	
	      _this.setState({
	        transitionVisible: false
	      });
	
	      (0, _invoke2["default"])(_this.props, 'onClose', null, (0, _objectSpread2["default"])({}, data, {
	        portalOpen: false,
	        transitionVisible: false
	      }));
	      (0, _invoke2["default"])(_this.props, 'onHide', null, (0, _objectSpread2["default"])({}, data, {
	        portalOpen: portalOpen,
	        transitionVisible: false
	      }));
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTransitionStart", function (nothing, data) {
	      var portalOpen = _this.state.portalOpen;
	      var status = data.status;
	      var transitionVisible = status === _Transition["default"].ENTERING;
	      (0, _invoke2["default"])(_this.props, 'onStart', null, (0, _objectSpread2["default"])({}, data, {
	        portalOpen: portalOpen,
	        transitionVisible: transitionVisible
	      })); // Heads up! TransitionablePortal fires onOpen callback on the start of transition animation
	
	      if (!transitionVisible) return;
	
	      _this.setState({
	        transitionVisible: transitionVisible
	      });
	
	      (0, _invoke2["default"])(_this.props, 'onOpen', null, (0, _objectSpread2["default"])({}, data, {
	        transitionVisible: transitionVisible,
	        portalOpen: true
	      }));
	    });
	    _this.state = {
	      portalOpen: props.open
	    };
	    return _this;
	  } // ----------------------------------------
	  // Lifecycle
	  // ----------------------------------------
	  // eslint-disable-next-line camelcase
	
	
	  (0, _createClass2["default"])(TransitionablePortal, [{
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(_ref) {
	      var open = _ref.open;
	      this.setState({
	        portalOpen: open
	      });
	    } // ----------------------------------------
	    // Callback handling
	    // ----------------------------------------
	
	  }, {
	    key: "render",
	    // ----------------------------------------
	    // Render
	    // ----------------------------------------
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          transition = _this$props.transition;
	      var _this$state = this.state,
	          portalOpen = _this$state.portalOpen,
	          transitionVisible = _this$state.transitionVisible;
	      var open = portalOpen || transitionVisible;
	      var rest = (0, _lib.getUnhandledProps)(TransitionablePortal, this.props);
	      return _react["default"].createElement(_Portal["default"], (0, _extends2["default"])({}, rest, {
	        open: open,
	        onOpen: this.handlePortalOpen,
	        onClose: this.handlePortalClose
	      }), _react["default"].createElement(_Transition["default"], (0, _extends2["default"])({}, transition, {
	        transitionOnMount: true,
	        onStart: this.handleTransitionStart,
	        onHide: this.handleTransitionHide,
	        visible: portalOpen
	      }), children));
	    }
	  }]);
	  return TransitionablePortal;
	}(_react.Component);
	
	exports["default"] = TransitionablePortal;
	(0, _defineProperty2["default"])(TransitionablePortal, "defaultProps", {
	  transition: {
	    animation: 'scale',
	    duration: 400
	  }
	});
	(0, _defineProperty2["default"])(TransitionablePortal, "handledProps", ["children", "onClose", "onHide", "onOpen", "onStart", "open", "transition"]);
	TransitionablePortal.propTypes =  false ? {
	  /** Primary content. */
	  children: _propTypes["default"].node.isRequired,
	
	  /**
	   * Called when a close event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and internal state.
	   */
	  onClose: _propTypes["default"].func,
	
	  /**
	   * Callback on each transition that changes visibility to hidden.
	   *
	   * @param {null}
	   * @param {object} data - All props with transition status and internal state.
	   */
	  onHide: _propTypes["default"].func,
	
	  /**
	   * Called when an open event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and internal state.
	   */
	  onOpen: _propTypes["default"].func,
	
	  /**
	   * Callback on animation start.
	   *
	   * @param {null}
	   * @param {object} data - All props with transition status and internal state.
	   */
	  onStart: _propTypes["default"].func,
	
	  /** Controls whether or not the portal is displayed. */
	  open: _propTypes["default"].bool,
	
	  /** Transition props. */
	  transition: _propTypes["default"].object
	} : {};

/***/ },
/* 7236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TransitionablePortal["default"];
	  }
	});
	
	var _TransitionablePortal = _interopRequireDefault(__webpack_require__(7235));

/***/ },
/* 7237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _forEach2 = _interopRequireDefault(__webpack_require__(118));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _includes2 = _interopRequireDefault(__webpack_require__(88));
	
	var _reactComponentRef = __webpack_require__(52);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * Visibility provides a set of callbacks for when a content appears in the viewport.
	 */
	var Visibility =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Visibility, _Component);
	
	  function Visibility() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Visibility);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Visibility)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "calculations", {
	      bottomPassed: false,
	      bottomVisible: false,
	      fits: false,
	      passing: false,
	      offScreen: false,
	      onScreen: false,
	      topPassed: false,
	      topVisible: false
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "firedCallbacks", []);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "ref", (0, _react.createRef)());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "fire", function (_ref, value) {
	      var callback = _ref.callback,
	          name = _ref.name;
	      var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var _this$props = _this.props,
	          continuous = _this$props.continuous,
	          once = _this$props.once; // Heads up! For the execution is required:
	      // - current value correspond to the fired direction
	      // - `continuous` is true or calculation values are different
	
	      var matchesDirection = _this.calculations[value] !== reverse;
	      var executionPossible = continuous || _this.calculations[value] !== _this.oldCalculations[value];
	      if (matchesDirection && executionPossible) _this.execute(callback, name); // Heads up! We should remove callback from the happened when it's not `once`
	
	      if (!once) _this.firedCallbacks = (0, _without2["default"])(_this.firedCallbacks, name);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleUpdate", function () {
	      if (_this.ticking) return;
	      _this.ticking = true;
	      _this.frameId = requestAnimationFrame(_this.update);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "update", function () {
	      if (!_this.mounted) return;
	      _this.ticking = false;
	      _this.oldCalculations = _this.calculations;
	      _this.calculations = _this.computeCalculations();
	      _this.pageYOffset = _this.getPageYOffset();
	      var _this$props2 = _this.props,
	          onBottomPassed = _this$props2.onBottomPassed,
	          onBottomPassedReverse = _this$props2.onBottomPassedReverse,
	          onBottomVisible = _this$props2.onBottomVisible,
	          onBottomVisibleReverse = _this$props2.onBottomVisibleReverse,
	          onPassing = _this$props2.onPassing,
	          onPassingReverse = _this$props2.onPassingReverse,
	          onTopPassed = _this$props2.onTopPassed,
	          onTopPassedReverse = _this$props2.onTopPassedReverse,
	          onTopVisible = _this$props2.onTopVisible,
	          onTopVisibleReverse = _this$props2.onTopVisibleReverse,
	          onOffScreen = _this$props2.onOffScreen,
	          onOnScreen = _this$props2.onOnScreen,
	          updateOn = _this$props2.updateOn;
	      var forward = {
	        bottomPassed: {
	          callback: onBottomPassed,
	          name: 'onBottomPassed'
	        },
	        bottomVisible: {
	          callback: onBottomVisible,
	          name: 'onBottomVisible'
	        },
	        passing: {
	          callback: onPassing,
	          name: 'onPassing'
	        },
	        offScreen: {
	          callback: onOffScreen,
	          name: 'onOffScreen'
	        },
	        onScreen: {
	          callback: onOnScreen,
	          name: 'onOnScreen'
	        },
	        topPassed: {
	          callback: onTopPassed,
	          name: 'onTopPassed'
	        },
	        topVisible: {
	          callback: onTopVisible,
	          name: 'onTopVisible'
	        }
	      };
	      var reverse = {
	        bottomPassed: {
	          callback: onBottomPassedReverse,
	          name: 'onBottomPassedReverse'
	        },
	        bottomVisible: {
	          callback: onBottomVisibleReverse,
	          name: 'onBottomVisibleReverse'
	        },
	        passing: {
	          callback: onPassingReverse,
	          name: 'onPassingReverse'
	        },
	        topPassed: {
	          callback: onTopPassedReverse,
	          name: 'onTopPassedReverse'
	        },
	        topVisible: {
	          callback: onTopVisibleReverse,
	          name: 'onTopVisibleReverse'
	        }
	      };
	      (0, _invoke2["default"])(_this.props, 'onUpdate', null, (0, _objectSpread2["default"])({}, _this.props, {
	        calculations: _this.calculations
	      }));
	
	      _this.fireOnPassed(); // Heads up! Reverse callbacks should be fired first
	
	
	      (0, _forEach2["default"])(reverse, function (data, value) {
	        return _this.fire(data, value, true);
	      });
	      (0, _forEach2["default"])(forward, function (data, value) {
	        return _this.fire(data, value);
	      });
	      if (updateOn === 'repaint') _this.handleUpdate();
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Visibility, [{
	    key: "UNSAFE_componentWillReceiveProps",
	    // ----------------------------------------
	    // Lifecycle
	    // ----------------------------------------
	    // eslint-disable-next-line camelcase
	    value: function UNSAFE_componentWillReceiveProps(_ref2) {
	      var continuous = _ref2.continuous,
	          once = _ref2.once,
	          context = _ref2.context,
	          updateOn = _ref2.updateOn;
	      var cleanHappened = continuous !== this.props.continuous || once !== this.props.once || updateOn !== this.props.updateOn; // Heads up! We should clean up array of happened callbacks, if values of these props are changed
	
	      if (cleanHappened) this.firedCallbacks = [];
	
	      if (context !== this.props.context || updateOn !== this.props.updateOn) {
	        this.unattachHandlers(this.props.context);
	        this.attachHandlers(context, updateOn);
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	      if (!(0, _lib.isBrowser)()) return;
	      var _this$props3 = this.props,
	          context = _this$props3.context,
	          fireOnMount = _this$props3.fireOnMount,
	          updateOn = _this$props3.updateOn;
	      this.pageYOffset = this.getPageYOffset();
	      this.attachHandlers(context, updateOn);
	      if (fireOnMount) this.update();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var context = this.props.context;
	      this.unattachHandlers(context);
	      this.mounted = false;
	    }
	  }, {
	    key: "attachHandlers",
	    value: function attachHandlers(context, updateOn) {
	      if (updateOn === 'events') {
	        if (context) {
	          _lib.eventStack.sub('resize', this.handleUpdate, {
	            target: context
	          });
	
	          _lib.eventStack.sub('scroll', this.handleUpdate, {
	            target: context
	          });
	        }
	
	        return;
	      } // Heads up!
	      // We will deal with `repaint` there
	
	
	      this.handleUpdate();
	    }
	  }, {
	    key: "unattachHandlers",
	    value: function unattachHandlers(context) {
	      if (context) {
	        _lib.eventStack.unsub('resize', this.handleUpdate, {
	          target: context
	        });
	
	        _lib.eventStack.unsub('scroll', this.handleUpdate, {
	          target: context
	        });
	      }
	
	      if (this.frameId) cancelAnimationFrame(this.frameId);
	    } // ----------------------------------------
	    // Callback handling
	    // ----------------------------------------
	
	  }, {
	    key: "execute",
	    value: function execute(callback, name) {
	      var continuous = this.props.continuous;
	      if (!callback) return; // Heads up! When `continuous` is true, callback will be fired always
	
	      if (!continuous && (0, _includes2["default"])(this.firedCallbacks, name)) return;
	      callback(null, (0, _objectSpread2["default"])({}, this.props, {
	        calculations: this.calculations
	      }));
	      this.firedCallbacks.push(name);
	    }
	  }, {
	    key: "fireOnPassed",
	    value: function fireOnPassed() {
	      var _this2 = this;
	
	      var _this$calculations = this.calculations,
	          percentagePassed = _this$calculations.percentagePassed,
	          pixelsPassed = _this$calculations.pixelsPassed;
	      var onPassed = this.props.onPassed;
	      (0, _forEach2["default"])(onPassed, function (callback, passed) {
	        var pixelsValue = Number(passed);
	
	        if (pixelsValue && pixelsPassed >= pixelsValue) {
	          _this2.execute(callback, passed);
	
	          return;
	        }
	
	        var matchPercentage = "".concat(passed).match(/^(\d+)%$/);
	        if (!matchPercentage) return;
	        var percentageValue = Number(matchPercentage[1]) / 100;
	        if (percentagePassed >= percentageValue) _this2.execute(callback, passed);
	      });
	    }
	  }, {
	    key: "computeCalculations",
	    // ----------------------------------------
	    // Helpers
	    // ----------------------------------------
	    value: function computeCalculations() {
	      var offset = this.props.offset;
	
	      var _this$ref$current$get = this.ref.current.getBoundingClientRect(),
	          bottom = _this$ref$current$get.bottom,
	          height = _this$ref$current$get.height,
	          top = _this$ref$current$get.top,
	          width = _this$ref$current$get.width;
	
	      var _normalizeOffset = (0, _lib.normalizeOffset)(offset),
	          _normalizeOffset2 = (0, _slicedToArray2["default"])(_normalizeOffset, 2),
	          topOffset = _normalizeOffset2[0],
	          bottomOffset = _normalizeOffset2[1];
	
	      var newOffset = this.getPageYOffset();
	      var direction = newOffset > this.pageYOffset ? 'down' : 'up';
	      var topPassed = top < topOffset;
	      var bottomPassed = bottom < bottomOffset;
	      var pixelsPassed = bottomPassed ? 0 : Math.max(top * -1, 0);
	      var percentagePassed = pixelsPassed / height;
	      var bottomVisible = bottom >= bottomOffset && bottom <= window.innerHeight;
	      var topVisible = top >= topOffset && top <= window.innerHeight;
	      var fits = topVisible && bottomVisible;
	      var passing = topPassed && !bottomPassed;
	      var onScreen = (topVisible || topPassed) && !bottomPassed;
	      var offScreen = !onScreen;
	      return {
	        bottomPassed: bottomPassed,
	        bottomVisible: bottomVisible,
	        direction: direction,
	        fits: fits,
	        height: height,
	        passing: passing,
	        percentagePassed: percentagePassed,
	        pixelsPassed: pixelsPassed,
	        offScreen: offScreen,
	        onScreen: onScreen,
	        topPassed: topPassed,
	        topVisible: topVisible,
	        width: width
	      };
	    }
	  }, {
	    key: "getPageYOffset",
	    value: function getPageYOffset() {
	      var context = this.props.context;
	
	      if (context) {
	        // Heads up! `window` doesn't have `pageYOffset` property
	        return context === window ? window.pageYOffset : context.scrollTop;
	      }
	
	      return 0;
	    } // ----------------------------------------
	    // Render
	    // ----------------------------------------
	
	  }, {
	    key: "render",
	    value: function render() {
	      var children = this.props.children;
	      var ElementType = (0, _lib.getElementType)(Visibility, this.props);
	      var rest = (0, _lib.getUnhandledProps)(Visibility, this.props);
	      return _react["default"].createElement(_reactComponentRef.Ref, {
	        innerRef: this.ref
	      }, _react["default"].createElement(ElementType, rest, children));
	    }
	  }]);
	  return Visibility;
	}(_react.Component);
	
	exports["default"] = Visibility;
	(0, _defineProperty2["default"])(Visibility, "defaultProps", {
	  context: (0, _lib.isBrowser)() ? window : null,
	  continuous: false,
	  offset: [0, 0],
	  once: true,
	  updateOn: 'events'
	});
	(0, _defineProperty2["default"])(Visibility, "handledProps", ["as", "children", "context", "continuous", "fireOnMount", "offset", "onBottomPassed", "onBottomPassedReverse", "onBottomVisible", "onBottomVisibleReverse", "onOffScreen", "onOnScreen", "onPassed", "onPassing", "onPassingReverse", "onTopPassed", "onTopPassedReverse", "onTopVisible", "onTopVisibleReverse", "onUpdate", "once", "updateOn"]);
	Visibility.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Context which visibility should attach onscroll events. */
	  context: _propTypes["default"].object,
	
	  /**
	   * When set to true a callback will occur anytime an element passes a condition not just immediately after the
	   * threshold is met.
	   */
	  continuous: _propTypes["default"].bool,
	
	  /** Fires callbacks immediately after mount. */
	  fireOnMount: _propTypes["default"].bool,
	
	  /**
	   * Element's bottom edge has passed top of screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onBottomPassed: _propTypes["default"].func,
	
	  /**
	   * Element's bottom edge has not passed top of screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onBottomPassedReverse: _propTypes["default"].func,
	
	  /**
	   * Element's bottom edge has passed bottom of screen
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onBottomVisible: _propTypes["default"].func,
	
	  /**
	   * Element's bottom edge has not passed bottom of screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onBottomVisibleReverse: _propTypes["default"].func,
	
	  /**
	   * Value that context should be adjusted in pixels. Useful for making content appear below content fixed to the
	   * page.
	   */
	  offset: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]))]),
	
	  /** When set to false a callback will occur each time an element passes the threshold for a condition. */
	  once: _propTypes["default"].bool,
	
	  /** Element is not visible on the screen. */
	  onPassed: _propTypes["default"].object,
	
	  /**
	   * Any part of an element is visible on screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onPassing: _propTypes["default"].func,
	
	  /**
	   * Element's top has not passed top of screen but bottom has.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onPassingReverse: _propTypes["default"].func,
	
	  /**
	   * Element is not visible on the screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onOffScreen: _propTypes["default"].func,
	
	  /**
	   * Element is visible on the screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onOnScreen: _propTypes["default"].func,
	
	  /**
	   * Element's top edge has passed top of the screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onTopPassed: _propTypes["default"].func,
	
	  /**
	   * Element's top edge has not passed top of the screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onTopPassedReverse: _propTypes["default"].func,
	
	  /**
	   * Element's top edge has passed bottom of screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onTopVisible: _propTypes["default"].func,
	
	  /**
	   * Element's top edge has not passed bottom of screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onTopVisibleReverse: _propTypes["default"].func,
	
	  /**
	   * Element's top edge has passed bottom of screen.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onUpdate: _propTypes["default"].func,
	
	  /**
	   * Allows to choose the mode of the position calculations:
	   * - `events` - (default) update and fire callbacks only on scroll/resize events
	   * - `repaint` - update and fire callbacks on browser repaint (animation frames)
	   */
	  updateOn: _propTypes["default"].oneOf(['events', 'repaint'])
	} : {};

/***/ },
/* 7238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Visibility["default"];
	  }
	});
	
	var _Visibility = _interopRequireDefault(__webpack_require__(7237));

/***/ },
/* 7239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _each2 = _interopRequireDefault(__webpack_require__(506));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _BreadcrumbDivider = _interopRequireDefault(__webpack_require__(693));
	
	var _BreadcrumbSection = _interopRequireDefault(__webpack_require__(694));
	
	/**
	 * A breadcrumb is used to show hierarchy between content.
	 */
	function Breadcrumb(props) {
	  var children = props.children,
	      className = props.className,
	      divider = props.divider,
	      icon = props.icon,
	      sections = props.sections,
	      size = props.size;
	  var classes = (0, _classnames["default"])('ui', size, 'breadcrumb', className);
	  var rest = (0, _lib.getUnhandledProps)(Breadcrumb, props);
	  var ElementType = (0, _lib.getElementType)(Breadcrumb, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  var childElements = [];
	  (0, _each2["default"])(sections, function (section, index) {
	    // section
	    var breadcrumbElement = _BreadcrumbSection["default"].create(section);
	
	    childElements.push(breadcrumbElement); // divider
	
	    if (index !== sections.length - 1) {
	      var key = "".concat(breadcrumbElement.key, "_divider") || JSON.stringify(section);
	      childElements.push(_BreadcrumbDivider["default"].create({
	        content: divider,
	        icon: icon,
	        key: key
	      }));
	    }
	  });
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), childElements);
	}
	
	Breadcrumb.handledProps = ["as", "children", "className", "divider", "icon", "sections", "size"];
	Breadcrumb.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content of the Breadcrumb.Divider. */
	  divider: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['icon']), _lib.customPropTypes.contentShorthand]),
	
	  /** For use with the sections prop. Render as an `Icon` component with `divider` class instead of a `div` in
	   *  Breadcrumb.Divider. */
	  icon: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['divider']), _lib.customPropTypes.itemShorthand]),
	
	  /** Shorthand array of props for Breadcrumb.Section. */
	  sections: _lib.customPropTypes.collectionShorthand,
	
	  /** Size of Breadcrumb. */
	  size: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.SIZES, 'medium'))
	} : {};
	Breadcrumb.Divider = _BreadcrumbDivider["default"];
	Breadcrumb.Section = _BreadcrumbSection["default"];
	var _default = Breadcrumb;
	exports["default"] = _default;

/***/ },
/* 7240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Breadcrumb["default"];
	  }
	});
	
	var _Breadcrumb = _interopRequireDefault(__webpack_require__(7239));

/***/ },
/* 7241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _FormButton = _interopRequireDefault(__webpack_require__(695));
	
	var _FormCheckbox = _interopRequireDefault(__webpack_require__(696));
	
	var _FormDropdown = _interopRequireDefault(__webpack_require__(697));
	
	var _FormField = _interopRequireDefault(__webpack_require__(84));
	
	var _FormGroup = _interopRequireDefault(__webpack_require__(698));
	
	var _FormInput = _interopRequireDefault(__webpack_require__(699));
	
	var _FormRadio = _interopRequireDefault(__webpack_require__(700));
	
	var _FormSelect = _interopRequireDefault(__webpack_require__(701));
	
	var _FormTextArea = _interopRequireDefault(__webpack_require__(702));
	
	/**
	 * A Form displays a set of related user input fields in a structured way.
	 * @see Button
	 * @see Checkbox
	 * @see Dropdown
	 * @see Input
	 * @see Message
	 * @see Radio
	 * @see Select
	 * @see Visibility
	 */
	var Form =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Form, _Component);
	
	  function Form() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Form);
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Form)).call.apply(_getPrototypeOf2, [this].concat(_args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleSubmit", function (e) {
	      var action = _this.props.action; // Heads up! Third party libs can pass own data as first argument, we need to check that it has preventDefault()
	      // method.
	
	      if (typeof action !== 'string') (0, _invoke2["default"])(e, 'preventDefault');
	
	      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      _invoke2["default"].apply(void 0, [_this.props, 'onSubmit', e, _this.props].concat(args));
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Form, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          action = _this$props.action,
	          children = _this$props.children,
	          className = _this$props.className,
	          error = _this$props.error,
	          inverted = _this$props.inverted,
	          loading = _this$props.loading,
	          reply = _this$props.reply,
	          size = _this$props.size,
	          success = _this$props.success,
	          unstackable = _this$props.unstackable,
	          warning = _this$props.warning,
	          widths = _this$props.widths;
	      var classes = (0, _classnames["default"])('ui', size, (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useKeyOnly)(reply, 'reply'), (0, _lib.useKeyOnly)(success, 'success'), (0, _lib.useKeyOnly)(unstackable, 'unstackable'), (0, _lib.useKeyOnly)(warning, 'warning'), (0, _lib.useWidthProp)(widths, null, true), 'form', className);
	      var rest = (0, _lib.getUnhandledProps)(Form, this.props);
	      var ElementType = (0, _lib.getElementType)(Form, this.props);
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        action: action,
	        className: classes,
	        onSubmit: this.handleSubmit
	      }), children);
	    }
	  }]);
	  return Form;
	}(_react.Component);
	
	(0, _defineProperty2["default"])(Form, "defaultProps", {
	  as: 'form'
	});
	(0, _defineProperty2["default"])(Form, "Field", _FormField["default"]);
	(0, _defineProperty2["default"])(Form, "Button", _FormButton["default"]);
	(0, _defineProperty2["default"])(Form, "Checkbox", _FormCheckbox["default"]);
	(0, _defineProperty2["default"])(Form, "Dropdown", _FormDropdown["default"]);
	(0, _defineProperty2["default"])(Form, "Group", _FormGroup["default"]);
	(0, _defineProperty2["default"])(Form, "Input", _FormInput["default"]);
	(0, _defineProperty2["default"])(Form, "Radio", _FormRadio["default"]);
	(0, _defineProperty2["default"])(Form, "Select", _FormSelect["default"]);
	(0, _defineProperty2["default"])(Form, "TextArea", _FormTextArea["default"]);
	(0, _defineProperty2["default"])(Form, "handledProps", ["action", "as", "children", "className", "error", "inverted", "loading", "onSubmit", "reply", "size", "success", "unstackable", "warning", "widths"]);
	Form.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** The HTML form action */
	  action: _propTypes["default"].string,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Automatically show any error Message children. */
	  error: _propTypes["default"].bool,
	
	  /** A form can have its color inverted for contrast. */
	  inverted: _propTypes["default"].bool,
	
	  /** Automatically show a loading indicator. */
	  loading: _propTypes["default"].bool,
	
	  /** The HTML form submit handler. */
	  onSubmit: _propTypes["default"].func,
	
	  /** A comment can contain a form to reply to a comment. This may have arbitrary content. */
	  reply: _propTypes["default"].bool,
	
	  /** A form can vary in size. */
	  size: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.SIZES, 'medium')),
	
	  /** Automatically show any success Message children. */
	  success: _propTypes["default"].bool,
	
	  /** A form can prevent itself from stacking on mobile. */
	  unstackable: _propTypes["default"].bool,
	
	  /** Automatically show any warning Message children. */
	  warning: _propTypes["default"].bool,
	
	  /** Forms can automatically divide fields to be equal width. */
	  widths: _propTypes["default"].oneOf(['equal'])
	} : {};
	var _default = Form;
	exports["default"] = _default;

/***/ },
/* 7242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Form["default"];
	  }
	});
	
	var _Form = _interopRequireDefault(__webpack_require__(7241));

/***/ },
/* 7243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Grid["default"];
	  }
	});
	
	var _Grid = _interopRequireDefault(__webpack_require__(703));

/***/ },
/* 7244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(43));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Icon = _interopRequireDefault(__webpack_require__(54));
	
	var _MessageContent = _interopRequireDefault(__webpack_require__(709));
	
	var _MessageHeader = _interopRequireDefault(__webpack_require__(710));
	
	var _MessageList = _interopRequireDefault(__webpack_require__(711));
	
	var _MessageItem = _interopRequireDefault(__webpack_require__(310));
	
	/**
	 * A message displays information that explains nearby content.
	 * @see Form
	 */
	var Message =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Message, _Component);
	
	  function Message() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Message);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Message)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleDismiss", function (e) {
	      var onDismiss = _this.props.onDismiss;
	      if (onDismiss) onDismiss(e, _this.props);
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Message, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          attached = _this$props.attached,
	          children = _this$props.children,
	          className = _this$props.className,
	          color = _this$props.color,
	          compact = _this$props.compact,
	          content = _this$props.content,
	          error = _this$props.error,
	          floating = _this$props.floating,
	          header = _this$props.header,
	          hidden = _this$props.hidden,
	          icon = _this$props.icon,
	          info = _this$props.info,
	          list = _this$props.list,
	          negative = _this$props.negative,
	          onDismiss = _this$props.onDismiss,
	          positive = _this$props.positive,
	          size = _this$props.size,
	          success = _this$props.success,
	          visible = _this$props.visible,
	          warning = _this$props.warning;
	      var classes = (0, _classnames["default"])('ui', color, size, (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(floating, 'floating'), (0, _lib.useKeyOnly)(hidden, 'hidden'), (0, _lib.useKeyOnly)(icon, 'icon'), (0, _lib.useKeyOnly)(info, 'info'), (0, _lib.useKeyOnly)(negative, 'negative'), (0, _lib.useKeyOnly)(positive, 'positive'), (0, _lib.useKeyOnly)(success, 'success'), (0, _lib.useKeyOnly)(visible, 'visible'), (0, _lib.useKeyOnly)(warning, 'warning'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), 'message', className);
	
	      var dismissIcon = onDismiss && _react["default"].createElement(_Icon["default"], {
	        name: "close",
	        onClick: this.handleDismiss
	      });
	
	      var rest = (0, _lib.getUnhandledProps)(Message, this.props);
	      var ElementType = (0, _lib.getElementType)(Message, this.props);
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	          className: classes
	        }), dismissIcon, children);
	      }
	
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes
	      }), dismissIcon, _Icon["default"].create(icon, {
	        autoGenerateKey: false
	      }), (!(0, _isNil2["default"])(header) || !(0, _isNil2["default"])(content) || !(0, _isNil2["default"])(list)) && _react["default"].createElement(_MessageContent["default"], null, _MessageHeader["default"].create(header, {
	        autoGenerateKey: false
	      }), _MessageList["default"].create(list, {
	        autoGenerateKey: false
	      }), (0, _lib.createHTMLParagraph)(content, {
	        autoGenerateKey: false
	      })));
	    }
	  }]);
	  return Message;
	}(_react.Component);
	
	exports["default"] = Message;
	(0, _defineProperty2["default"])(Message, "Content", _MessageContent["default"]);
	(0, _defineProperty2["default"])(Message, "Header", _MessageHeader["default"]);
	(0, _defineProperty2["default"])(Message, "List", _MessageList["default"]);
	(0, _defineProperty2["default"])(Message, "Item", _MessageItem["default"]);
	(0, _defineProperty2["default"])(Message, "handledProps", ["as", "attached", "children", "className", "color", "compact", "content", "error", "floating", "header", "hidden", "icon", "info", "list", "negative", "onDismiss", "positive", "size", "success", "visible", "warning"]);
	Message.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A message can be formatted to attach itself to other content. */
	  attached: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['bottom', 'top'])]),
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** A message can be formatted to be different colors. */
	  color: _propTypes["default"].oneOf(_lib.SUI.COLORS),
	
	  /** A message can only take up the width of its content. */
	  compact: _propTypes["default"].bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A message may be formatted to display a negative message. Same as `negative`. */
	  error: _propTypes["default"].bool,
	
	  /** A message can float above content that it is related to. */
	  floating: _propTypes["default"].bool,
	
	  /** Shorthand for MessageHeader. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** A message can be hidden. */
	  hidden: _propTypes["default"].bool,
	
	  /** A message can contain an icon. */
	  icon: _propTypes["default"].oneOfType([_lib.customPropTypes.itemShorthand, _propTypes["default"].bool]),
	
	  /** A message may be formatted to display information. */
	  info: _propTypes["default"].bool,
	
	  /** Array shorthand items for the MessageList. Mutually exclusive with children. */
	  list: _lib.customPropTypes.collectionShorthand,
	
	  /** A message may be formatted to display a negative message. Same as `error`. */
	  negative: _propTypes["default"].bool,
	
	  /**
	   * A message that the user can choose to hide.
	   * Called when the user clicks the "x" icon. This also adds the "x" icon.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onDismiss: _propTypes["default"].func,
	
	  /** A message may be formatted to display a positive message.  Same as `success`. */
	  positive: _propTypes["default"].bool,
	
	  /** A message can have different sizes. */
	  size: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.SIZES, 'medium')),
	
	  /** A message may be formatted to display a positive message.  Same as `positive`. */
	  success: _propTypes["default"].bool,
	
	  /** A message can be set to visible to force itself to be shown. */
	  visible: _propTypes["default"].bool,
	
	  /** A message may be formatted to display warning messages. */
	  warning: _propTypes["default"].bool
	} : {};

/***/ },
/* 7245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Message["default"];
	  }
	});
	
	var _Message = _interopRequireDefault(__webpack_require__(7244));

/***/ },
/* 7246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _map2 = _interopRequireDefault(__webpack_require__(41));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _TableBody = _interopRequireDefault(__webpack_require__(712));
	
	var _TableCell = _interopRequireDefault(__webpack_require__(218));
	
	var _TableFooter = _interopRequireDefault(__webpack_require__(713));
	
	var _TableHeader = _interopRequireDefault(__webpack_require__(311));
	
	var _TableHeaderCell = _interopRequireDefault(__webpack_require__(714));
	
	var _TableRow = _interopRequireDefault(__webpack_require__(715));
	
	/**
	 * A table displays a collections of data grouped into rows.
	 */
	function Table(props) {
	  var attached = props.attached,
	      basic = props.basic,
	      celled = props.celled,
	      children = props.children,
	      className = props.className,
	      collapsing = props.collapsing,
	      color = props.color,
	      columns = props.columns,
	      compact = props.compact,
	      definition = props.definition,
	      fixed = props.fixed,
	      footerRow = props.footerRow,
	      headerRow = props.headerRow,
	      headerRows = props.headerRows,
	      inverted = props.inverted,
	      padded = props.padded,
	      renderBodyRow = props.renderBodyRow,
	      selectable = props.selectable,
	      singleLine = props.singleLine,
	      size = props.size,
	      sortable = props.sortable,
	      stackable = props.stackable,
	      striped = props.striped,
	      structured = props.structured,
	      tableData = props.tableData,
	      textAlign = props.textAlign,
	      unstackable = props.unstackable,
	      verticalAlign = props.verticalAlign;
	  var classes = (0, _classnames["default"])('ui', color, size, (0, _lib.useKeyOnly)(celled, 'celled'), (0, _lib.useKeyOnly)(collapsing, 'collapsing'), (0, _lib.useKeyOnly)(definition, 'definition'), (0, _lib.useKeyOnly)(fixed, 'fixed'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(selectable, 'selectable'), (0, _lib.useKeyOnly)(singleLine, 'single line'), (0, _lib.useKeyOnly)(sortable, 'sortable'), (0, _lib.useKeyOnly)(stackable, 'stackable'), (0, _lib.useKeyOnly)(striped, 'striped'), (0, _lib.useKeyOnly)(structured, 'structured'), (0, _lib.useKeyOnly)(unstackable, 'unstackable'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), (0, _lib.useKeyOrValueAndKey)(basic, 'basic'), (0, _lib.useKeyOrValueAndKey)(compact, 'compact'), (0, _lib.useKeyOrValueAndKey)(padded, 'padded'), (0, _lib.useTextAlignProp)(textAlign), (0, _lib.useVerticalAlignProp)(verticalAlign), (0, _lib.useWidthProp)(columns, 'column'), 'table', className);
	  var rest = (0, _lib.getUnhandledProps)(Table, props);
	  var ElementType = (0, _lib.getElementType)(Table, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  var hasHeaderRows = headerRow || headerRows;
	  var headerShorthandOptions = {
	    defaultProps: {
	      cellAs: 'th'
	    }
	  };
	
	  var headerElement = hasHeaderRows && _react["default"].createElement(_TableHeader["default"], null, _TableRow["default"].create(headerRow, headerShorthandOptions), (0, _map2["default"])(headerRows, function (data) {
	    return _TableRow["default"].create(data, headerShorthandOptions);
	  }));
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), headerElement, _react["default"].createElement(_TableBody["default"], null, renderBodyRow && (0, _map2["default"])(tableData, function (data, index) {
	    return _TableRow["default"].create(renderBodyRow(data, index));
	  })), footerRow && _react["default"].createElement(_TableFooter["default"], null, _TableRow["default"].create(footerRow)));
	}
	
	Table.handledProps = ["as", "attached", "basic", "celled", "children", "className", "collapsing", "color", "columns", "compact", "definition", "fixed", "footerRow", "headerRow", "headerRows", "inverted", "padded", "renderBodyRow", "selectable", "singleLine", "size", "sortable", "stackable", "striped", "structured", "tableData", "textAlign", "unstackable", "verticalAlign"];
	Table.defaultProps = {
	  as: 'table'
	};
	Table.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Attach table to other content */
	  attached: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['top', 'bottom'])]),
	
	  /** A table can reduce its complexity to increase readability. */
	  basic: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['very']), _propTypes["default"].bool]),
	
	  /** A table may be divided each row into separate cells. */
	  celled: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** A table can be collapsing, taking up only as much space as its rows. */
	  collapsing: _propTypes["default"].bool,
	
	  /** A table can be given a color to distinguish it from other tables. */
	  color: _propTypes["default"].oneOf(_lib.SUI.COLORS),
	
	  /** A table can specify its column count to divide its content evenly. */
	  columns: _propTypes["default"].oneOf(_lib.SUI.WIDTHS),
	
	  /** A table may sometimes need to be more compact to make more rows visible at a time. */
	  compact: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['very'])]),
	
	  /** A table may be formatted to emphasize a first column that defines a rows content. */
	  definition: _propTypes["default"].bool,
	
	  /**
	   * A table can use fixed a special faster form of table rendering that does not resize table cells based on content
	   */
	  fixed: _propTypes["default"].bool,
	
	  /** Shorthand for a TableRow to be placed within Table.Footer. */
	  footerRow: _lib.customPropTypes.itemShorthand,
	
	  /** Shorthand for a TableRow to be placed within Table.Header. */
	  headerRow: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['headerRows']), _lib.customPropTypes.itemShorthand]),
	
	  /** Shorthand for multiple TableRows to be placed within Table.Header. */
	  headerRows: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['headerRow']), _lib.customPropTypes.collectionShorthand]),
	
	  /** A table's colors can be inverted. */
	  inverted: _propTypes["default"].bool,
	
	  /** A table may sometimes need to be more padded for legibility. */
	  padded: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['very'])]),
	
	  /**
	   * Mapped over `tableData` and should return shorthand for each Table.Row to be placed within Table.Body.
	   *
	   * @param {*} data - An element in the `tableData` array.
	   * @param {number} index - The index of the current element in `tableData`.
	   * @returns {*} Shorthand for a Table.Row.
	   */
	  renderBodyRow: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _lib.customPropTypes.demand(['tableData']), _propTypes["default"].func]),
	
	  /** A table can have its rows appear selectable. */
	  selectable: _propTypes["default"].bool,
	
	  /** A table can specify that its cell contents should remain on a single line and not wrap. */
	  singleLine: _propTypes["default"].bool,
	
	  /** A table can also be small or large. */
	  size: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.SIZES, 'mini', 'tiny', 'medium', 'big', 'huge', 'massive')),
	
	  /** A table may allow a user to sort contents by clicking on a table header. */
	  sortable: _propTypes["default"].bool,
	
	  /** A table can specify how it stacks table content responsively. */
	  stackable: _propTypes["default"].bool,
	
	  /** A table can stripe alternate rows of content with a darker color to increase contrast. */
	  striped: _propTypes["default"].bool,
	
	  /** A table can be formatted to display complex structured data. */
	  structured: _propTypes["default"].bool,
	
	  /** Data to be passed to the renderBodyRow function. */
	  tableData: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _lib.customPropTypes.demand(['renderBodyRow']), _propTypes["default"].array]),
	
	  /** A table can adjust its text alignment. */
	  textAlign: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.TEXT_ALIGNMENTS, 'justified')),
	
	  /** A table can specify how it stacks table content responsively. */
	  unstackable: _propTypes["default"].bool,
	
	  /** A table can adjust its text alignment. */
	  verticalAlign: _propTypes["default"].oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : {};
	Table.Body = _TableBody["default"];
	Table.Cell = _TableCell["default"];
	Table.Footer = _TableFooter["default"];
	Table.Header = _TableHeader["default"];
	Table.HeaderCell = _TableHeaderCell["default"];
	Table.Row = _TableRow["default"];
	var _default = Table;
	exports["default"] = _default;

/***/ },
/* 7247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Table["default"];
	  }
	});
	
	var _Table = _interopRequireDefault(__webpack_require__(7246));

/***/ },
/* 7248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A container limits content to a maximum width.
	 */
	function Container(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      fluid = props.fluid,
	      text = props.text,
	      textAlign = props.textAlign;
	  var classes = (0, _classnames["default"])('ui', (0, _lib.useKeyOnly)(text, 'text'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useTextAlignProp)(textAlign), 'container', className);
	  var rest = (0, _lib.getUnhandledProps)(Container, props);
	  var ElementType = (0, _lib.getElementType)(Container, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	Container.handledProps = ["as", "children", "className", "content", "fluid", "text", "textAlign"];
	Container.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Container has no maximum width. */
	  fluid: _propTypes["default"].bool,
	
	  /** Reduce maximum width to more naturally accommodate text. */
	  text: _propTypes["default"].bool,
	
	  /** Align container text. */
	  textAlign: _propTypes["default"].oneOf(_lib.SUI.TEXT_ALIGNMENTS)
	} : {};
	var _default = Container;
	exports["default"] = _default;

/***/ },
/* 7249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Container["default"];
	  }
	});
	
	var _Container = _interopRequireDefault(__webpack_require__(7248));

/***/ },
/* 7250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A divider visually segments content into groups.
	 */
	function Divider(props) {
	  var children = props.children,
	      className = props.className,
	      clearing = props.clearing,
	      content = props.content,
	      fitted = props.fitted,
	      hidden = props.hidden,
	      horizontal = props.horizontal,
	      inverted = props.inverted,
	      section = props.section,
	      vertical = props.vertical;
	  var classes = (0, _classnames["default"])('ui', (0, _lib.useKeyOnly)(clearing, 'clearing'), (0, _lib.useKeyOnly)(fitted, 'fitted'), (0, _lib.useKeyOnly)(hidden, 'hidden'), (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(section, 'section'), (0, _lib.useKeyOnly)(vertical, 'vertical'), 'divider', className);
	  var rest = (0, _lib.getUnhandledProps)(Divider, props);
	  var ElementType = (0, _lib.getElementType)(Divider, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	Divider.handledProps = ["as", "children", "className", "clearing", "content", "fitted", "hidden", "horizontal", "inverted", "section", "vertical"];
	Divider.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Divider can clear the content above it. */
	  clearing: _propTypes["default"].bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Divider can be fitted without any space above or below it. */
	  fitted: _propTypes["default"].bool,
	
	  /** Divider can divide content without creating a dividing line. */
	  hidden: _propTypes["default"].bool,
	
	  /** Divider can segment content horizontally. */
	  horizontal: _propTypes["default"].bool,
	
	  /** Divider can have its colours inverted. */
	  inverted: _propTypes["default"].bool,
	
	  /** Divider can provide greater margins to divide sections of content. */
	  section: _propTypes["default"].bool,
	
	  /** Divider can segment content vertically. */
	  vertical: _propTypes["default"].bool
	} : {};
	var _default = Divider;
	exports["default"] = _default;

/***/ },
/* 7251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Divider["default"];
	  }
	});
	
	var _Divider = _interopRequireDefault(__webpack_require__(7250));

/***/ },
/* 7252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.names = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(26));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var names = ['ad', 'andorra', 'ae', 'united arab emirates', 'uae', 'af', 'afghanistan', 'ag', 'antigua', 'ai', 'anguilla', 'al', 'albania', 'am', 'armenia', 'an', 'netherlands antilles', 'ao', 'angola', 'ar', 'argentina', 'as', 'american samoa', 'at', 'austria', 'au', 'australia', 'aw', 'aruba', 'ax', 'aland islands', 'az', 'azerbaijan', 'ba', 'bosnia', 'bb', 'barbados', 'bd', 'bangladesh', 'be', 'belgium', 'bf', 'burkina faso', 'bg', 'bulgaria', 'bh', 'bahrain', 'bi', 'burundi', 'bj', 'benin', 'bm', 'bermuda', 'bn', 'brunei', 'bo', 'bolivia', 'br', 'brazil', 'bs', 'bahamas', 'bt', 'bhutan', 'bv', 'bouvet island', 'bw', 'botswana', 'by', 'belarus', 'bz', 'belize', 'ca', 'canada', 'cc', 'cocos islands', 'cd', 'congo', 'cf', 'central african republic', 'cg', 'congo brazzaville', 'ch', 'switzerland', 'ci', 'cote divoire', 'ck', 'cook islands', 'cl', 'chile', 'cm', 'cameroon', 'cn', 'china', 'co', 'colombia', 'cr', 'costa rica', 'cs', 'cu', 'cuba', 'cv', 'cape verde', 'cx', 'christmas island', 'cy', 'cyprus', 'cz', 'czech republic', 'de', 'germany', 'dj', 'djibouti', 'dk', 'denmark', 'dm', 'dominica', 'do', 'dominican republic', 'dz', 'algeria', 'ec', 'ecuador', 'ee', 'estonia', 'eg', 'egypt', 'eh', 'western sahara', 'er', 'eritrea', 'es', 'spain', 'et', 'ethiopia', 'eu', 'european union', 'fi', 'finland', 'fj', 'fiji', 'fk', 'falkland islands', 'fm', 'micronesia', 'fo', 'faroe islands', 'fr', 'france', 'ga', 'gabon', 'gb', 'uk', 'united kingdom', 'gd', 'grenada', 'ge', 'georgia', 'gf', 'french guiana', 'gh', 'ghana', 'gi', 'gibraltar', 'gl', 'greenland', 'gm', 'gambia', 'gn', 'guinea', 'gp', 'guadeloupe', 'gq', 'equatorial guinea', 'gr', 'greece', 'gs', 'sandwich islands', 'gt', 'guatemala', 'gu', 'guam', 'gw', 'guinea-bissau', 'gy', 'guyana', 'hk', 'hong kong', 'hm', 'heard island', 'hn', 'honduras', 'hr', 'croatia', 'ht', 'haiti', 'hu', 'hungary', 'id', 'indonesia', 'ie', 'ireland', 'il', 'israel', 'in', 'india', 'io', 'indian ocean territory', 'iq', 'iraq', 'ir', 'iran', 'is', 'iceland', 'it', 'italy', 'jm', 'jamaica', 'jo', 'jordan', 'jp', 'japan', 'ke', 'kenya', 'kg', 'kyrgyzstan', 'kh', 'cambodia', 'ki', 'kiribati', 'km', 'comoros', 'kn', 'saint kitts and nevis', 'kp', 'north korea', 'kr', 'south korea', 'kw', 'kuwait', 'ky', 'cayman islands', 'kz', 'kazakhstan', 'la', 'laos', 'lb', 'lebanon', 'lc', 'saint lucia', 'li', 'liechtenstein', 'lk', 'sri lanka', 'lr', 'liberia', 'ls', 'lesotho', 'lt', 'lithuania', 'lu', 'luxembourg', 'lv', 'latvia', 'ly', 'libya', 'ma', 'morocco', 'mc', 'monaco', 'md', 'moldova', 'me', 'montenegro', 'mg', 'madagascar', 'mh', 'marshall islands', 'mk', 'macedonia', 'ml', 'mali', 'mm', 'myanmar', 'burma', 'mn', 'mongolia', 'mo', 'macau', 'mp', 'northern mariana islands', 'mq', 'martinique', 'mr', 'mauritania', 'ms', 'montserrat', 'mt', 'malta', 'mu', 'mauritius', 'mv', 'maldives', 'mw', 'malawi', 'mx', 'mexico', 'my', 'malaysia', 'mz', 'mozambique', 'na', 'namibia', 'nc', 'new caledonia', 'ne', 'niger', 'nf', 'norfolk island', 'ng', 'nigeria', 'ni', 'nicaragua', 'nl', 'netherlands', 'no', 'norway', 'np', 'nepal', 'nr', 'nauru', 'nu', 'niue', 'nz', 'new zealand', 'om', 'oman', 'pa', 'panama', 'pe', 'peru', 'pf', 'french polynesia', 'pg', 'new guinea', 'ph', 'philippines', 'pk', 'pakistan', 'pl', 'poland', 'pm', 'saint pierre', 'pn', 'pitcairn islands', 'pr', 'puerto rico', 'ps', 'palestine', 'pt', 'portugal', 'pw', 'palau', 'py', 'paraguay', 'qa', 'qatar', 're', 'reunion', 'ro', 'romania', 'rs', 'serbia', 'ru', 'russia', 'rw', 'rwanda', 'sa', 'saudi arabia', 'sb', 'solomon islands', 'sc', 'seychelles', 'gb sct', 'scotland', 'sd', 'sudan', 'se', 'sweden', 'sg', 'singapore', 'sh', 'saint helena', 'si', 'slovenia', 'sj', 'svalbard', 'jan mayen', 'sk', 'slovakia', 'sl', 'sierra leone', 'sm', 'san marino', 'sn', 'senegal', 'so', 'somalia', 'sr', 'suriname', 'st', 'sao tome', 'sv', 'el salvador', 'sy', 'syria', 'sz', 'swaziland', 'tc', 'caicos islands', 'td', 'chad', 'tf', 'french territories', 'tg', 'togo', 'th', 'thailand', 'tj', 'tajikistan', 'tk', 'tokelau', 'tl', 'timorleste', 'tm', 'turkmenistan', 'tn', 'tunisia', 'to', 'tonga', 'tr', 'turkey', 'tt', 'trinidad', 'tv', 'tuvalu', 'tw', 'taiwan', 'tz', 'tanzania', 'ua', 'ukraine', 'ug', 'uganda', 'um', 'us minor islands', 'us', 'america', 'united states', 'uy', 'uruguay', 'uz', 'uzbekistan', 'va', 'vatican city', 'vc', 'saint vincent', 've', 'venezuela', 'vg', 'british virgin islands', 'vi', 'us virgin islands', 'vn', 'vietnam', 'vu', 'vanuatu', 'gb wls', 'wales', 'wf', 'wallis and futuna', 'ws', 'samoa', 'ye', 'yemen', 'yt', 'mayotte', 'za', 'south africa', 'zm', 'zambia', 'zw', 'zimbabwe'];
	/**
	 * A flag is is used to represent a political state.
	 */
	
	exports.names = names;
	
	var Flag =
	/*#__PURE__*/
	function (_PureComponent) {
	  (0, _inherits2["default"])(Flag, _PureComponent);
	
	  function Flag() {
	    (0, _classCallCheck2["default"])(this, Flag);
	    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Flag).apply(this, arguments));
	  }
	
	  (0, _createClass2["default"])(Flag, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          className = _this$props.className,
	          name = _this$props.name;
	      var classes = (0, _classnames["default"])(name, 'flag', className);
	      var rest = (0, _lib.getUnhandledProps)(Flag, this.props);
	      var ElementType = (0, _lib.getElementType)(Flag, this.props);
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes
	      }));
	    }
	  }]);
	  return Flag;
	}(_react.PureComponent);
	
	(0, _defineProperty2["default"])(Flag, "defaultProps", {
	  as: 'i'
	});
	(0, _defineProperty2["default"])(Flag, "handledProps", ["as", "className", "name"]);
	Flag.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Flag name, can use the two digit country code, the full name, or a common alias. */
	  name: _lib.customPropTypes.suggest(names)
	} : {};
	Flag.create = (0, _lib.createShorthandFactory)(Flag, function (value) {
	  return {
	    name: value
	  };
	});
	var _default = Flag;
	exports["default"] = _default;

/***/ },
/* 7253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Icon = _interopRequireDefault(__webpack_require__(54));
	
	var _Image = _interopRequireDefault(__webpack_require__(124));
	
	var _HeaderSubheader = _interopRequireDefault(__webpack_require__(721));
	
	var _HeaderContent = _interopRequireDefault(__webpack_require__(720));
	
	/**
	 * A header provides a short summary of content
	 */
	function Header(props) {
	  var attached = props.attached,
	      block = props.block,
	      children = props.children,
	      className = props.className,
	      color = props.color,
	      content = props.content,
	      disabled = props.disabled,
	      dividing = props.dividing,
	      floated = props.floated,
	      icon = props.icon,
	      image = props.image,
	      inverted = props.inverted,
	      size = props.size,
	      sub = props.sub,
	      subheader = props.subheader,
	      textAlign = props.textAlign;
	  var classes = (0, _classnames["default"])('ui', color, size, (0, _lib.useKeyOnly)(block, 'block'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(dividing, 'dividing'), (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useKeyOnly)(icon === true, 'icon'), (0, _lib.useKeyOnly)(image === true, 'image'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(sub, 'sub'), (0, _lib.useKeyOrValueAndKey)(attached, 'attached'), (0, _lib.useTextAlignProp)(textAlign), 'header', className);
	  var rest = (0, _lib.getUnhandledProps)(Header, props);
	  var ElementType = (0, _lib.getElementType)(Header, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  var iconElement = _Icon["default"].create(icon, {
	    autoGenerateKey: false
	  });
	
	  var imageElement = _Image["default"].create(image, {
	    autoGenerateKey: false
	  });
	
	  var subheaderElement = _HeaderSubheader["default"].create(subheader, {
	    autoGenerateKey: false
	  });
	
	  if (iconElement || imageElement) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), iconElement || imageElement, (content || subheaderElement) && _react["default"].createElement(_HeaderContent["default"], null, content, subheaderElement));
	  }
	
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), content, subheaderElement);
	}
	
	Header.handledProps = ["as", "attached", "block", "children", "className", "color", "content", "disabled", "dividing", "floated", "icon", "image", "inverted", "size", "sub", "subheader", "textAlign"];
	Header.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Attach header  to other content, like a segment. */
	  attached: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['top', 'bottom'])]),
	
	  /** Format header to appear inside a content block. */
	  block: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Color of the header. */
	  color: _propTypes["default"].oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Show that the header is inactive. */
	  disabled: _propTypes["default"].bool,
	
	  /** Divide header from the content below it. */
	  dividing: _propTypes["default"].bool,
	
	  /** Header can sit to the left or right of other content. */
	  floated: _propTypes["default"].oneOf(_lib.SUI.FLOATS),
	
	  /** Add an icon by icon name or pass an Icon. */
	  icon: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['image']), _propTypes["default"].oneOfType([_propTypes["default"].bool, _lib.customPropTypes.itemShorthand])]),
	
	  /** Add an image by img src or pass an Image. */
	  image: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['icon']), _propTypes["default"].oneOfType([_propTypes["default"].bool, _lib.customPropTypes.itemShorthand])]),
	
	  /** Inverts the color of the header for dark backgrounds. */
	  inverted: _propTypes["default"].bool,
	
	  /** Content headings are sized with em and are based on the font-size of their container. */
	  size: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.SIZES, 'big', 'massive', 'mini')),
	
	  /** Headers may be formatted to label smaller or de-emphasized content. */
	  sub: _propTypes["default"].bool,
	
	  /** Shorthand for Header.Subheader. */
	  subheader: _lib.customPropTypes.itemShorthand,
	
	  /** Align header content. */
	  textAlign: _propTypes["default"].oneOf(_lib.SUI.TEXT_ALIGNMENTS)
	} : {};
	Header.Content = _HeaderContent["default"];
	Header.Subheader = _HeaderSubheader["default"];
	var _default = Header;
	exports["default"] = _default;

/***/ },
/* 7254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Header["default"];
	  }
	});
	
	var _Header = _interopRequireDefault(__webpack_require__(7253));

/***/ },
/* 7255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _includes2 = _interopRequireDefault(__webpack_require__(88));
	
	var _map2 = _interopRequireDefault(__webpack_require__(41));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _get2 = _interopRequireDefault(__webpack_require__(72));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(43));
	
	var _reactComponentRef = __webpack_require__(52);
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Button = _interopRequireDefault(__webpack_require__(219));
	
	var _Icon = _interopRequireDefault(__webpack_require__(54));
	
	var _Label = _interopRequireDefault(__webpack_require__(159));
	
	/**
	 * An Input is a field used to elicit a response from a user.
	 * @see Button
	 * @see Form
	 * @see Icon
	 * @see Label
	 */
	var Input =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Input, _Component);
	
	  function Input() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Input);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Input)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "inputRef", (0, _react.createRef)());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "computeIcon", function () {
	      var _this$props = _this.props,
	          loading = _this$props.loading,
	          icon = _this$props.icon;
	      if (!(0, _isNil2["default"])(icon)) return icon;
	      if (loading) return 'spinner';
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "computeTabIndex", function () {
	      var _this$props2 = _this.props,
	          disabled = _this$props2.disabled,
	          tabIndex = _this$props2.tabIndex;
	      if (!(0, _isNil2["default"])(tabIndex)) return tabIndex;
	      if (disabled) return -1;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focus", function () {
	      return _this.inputRef.current.focus();
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "select", function () {
	      return _this.inputRef.current.select();
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleChange", function (e) {
	      var value = (0, _get2["default"])(e, 'target.value');
	      (0, _invoke2["default"])(_this.props, 'onChange', e, (0, _objectSpread2["default"])({}, _this.props, {
	        value: value
	      }));
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleChildOverrides", function (child, defaultProps) {
	      return (0, _objectSpread2["default"])({}, defaultProps, child.props, {
	        ref: function ref(c) {
	          (0, _reactComponentRef.handleRef)(child.ref, c);
	          _this.inputRef.current = c;
	        }
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "partitionProps", function () {
	      var _this$props3 = _this.props,
	          disabled = _this$props3.disabled,
	          type = _this$props3.type;
	
	      var tabIndex = _this.computeTabIndex();
	
	      var unhandled = (0, _lib.getUnhandledProps)(Input, _this.props);
	
	      var _partitionHTMLProps = (0, _lib.partitionHTMLProps)(unhandled),
	          _partitionHTMLProps2 = (0, _slicedToArray2["default"])(_partitionHTMLProps, 2),
	          htmlInputProps = _partitionHTMLProps2[0],
	          rest = _partitionHTMLProps2[1];
	
	      return [(0, _objectSpread2["default"])({}, htmlInputProps, {
	        disabled: disabled,
	        type: type,
	        tabIndex: tabIndex,
	        onChange: _this.handleChange,
	        ref: _this.inputRef
	      }), rest];
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Input, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props4 = this.props,
	          action = _this$props4.action,
	          actionPosition = _this$props4.actionPosition,
	          children = _this$props4.children,
	          className = _this$props4.className,
	          disabled = _this$props4.disabled,
	          error = _this$props4.error,
	          fluid = _this$props4.fluid,
	          focus = _this$props4.focus,
	          icon = _this$props4.icon,
	          iconPosition = _this$props4.iconPosition,
	          input = _this$props4.input,
	          inverted = _this$props4.inverted,
	          label = _this$props4.label,
	          labelPosition = _this$props4.labelPosition,
	          loading = _this$props4.loading,
	          size = _this$props4.size,
	          transparent = _this$props4.transparent,
	          type = _this$props4.type;
	      var classes = (0, _classnames["default"])('ui', size, (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(focus, 'focus'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useKeyOnly)(transparent, 'transparent'), (0, _lib.useValueAndKey)(actionPosition, 'action') || (0, _lib.useKeyOnly)(action, 'action'), (0, _lib.useValueAndKey)(iconPosition, 'icon') || (0, _lib.useKeyOnly)(icon || loading, 'icon'), (0, _lib.useValueAndKey)(labelPosition, 'labeled') || (0, _lib.useKeyOnly)(label, 'labeled'), 'input', className);
	      var ElementType = (0, _lib.getElementType)(Input, this.props);
	
	      var _this$partitionProps = this.partitionProps(),
	          _this$partitionProps2 = (0, _slicedToArray2["default"])(_this$partitionProps, 2),
	          htmlInputProps = _this$partitionProps2[0],
	          rest = _this$partitionProps2[1]; // Render with children
	      // ----------------------------------------
	
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        // add htmlInputProps to the `<input />` child
	        var childElements = (0, _map2["default"])(_react.Children.toArray(children), function (child) {
	          if (child.type !== 'input') return child;
	          return (0, _react.cloneElement)(child, _this2.handleChildOverrides(child, htmlInputProps));
	        });
	        return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	          className: classes
	        }), childElements);
	      } // Render Shorthand
	      // ----------------------------------------
	
	
	      var actionElement = _Button["default"].create(action, {
	        autoGenerateKey: false
	      });
	
	      var labelElement = _Label["default"].create(label, {
	        defaultProps: {
	          className: (0, _classnames["default"])('label', // add 'left|right corner'
	          (0, _includes2["default"])(labelPosition, 'corner') && labelPosition)
	        },
	        autoGenerateKey: false
	      });
	
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes
	      }), actionPosition === 'left' && actionElement, labelPosition !== 'right' && labelElement, (0, _lib.createHTMLInput)(input || type, {
	        defaultProps: htmlInputProps,
	        autoGenerateKey: false
	      }), _Icon["default"].create(this.computeIcon(), {
	        autoGenerateKey: false
	      }), actionPosition !== 'left' && actionElement, labelPosition === 'right' && labelElement);
	    }
	  }]);
	  return Input;
	}(_react.Component);
	
	(0, _defineProperty2["default"])(Input, "defaultProps", {
	  type: 'text'
	});
	(0, _defineProperty2["default"])(Input, "handledProps", ["action", "actionPosition", "as", "children", "className", "disabled", "error", "fluid", "focus", "icon", "iconPosition", "input", "inverted", "label", "labelPosition", "loading", "onChange", "size", "tabIndex", "transparent", "type"]);
	Input.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** An Input can be formatted to alert the user to an action they may perform. */
	  action: _propTypes["default"].oneOfType([_propTypes["default"].bool, _lib.customPropTypes.itemShorthand]),
	
	  /** An action can appear along side an Input on the left or right. */
	  actionPosition: _propTypes["default"].oneOf(['left']),
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** An Input field can show that it is disabled. */
	  disabled: _propTypes["default"].bool,
	
	  /** An Input field can show the data contains errors. */
	  error: _propTypes["default"].bool,
	
	  /** Take on the size of its container. */
	  fluid: _propTypes["default"].bool,
	
	  /** An Input field can show a user is currently interacting with it. */
	  focus: _propTypes["default"].bool,
	
	  /** Optional Icon to display inside the Input. */
	  icon: _propTypes["default"].oneOfType([_propTypes["default"].bool, _lib.customPropTypes.itemShorthand]),
	
	  /** An Icon can appear inside an Input on the left or right. */
	  iconPosition: _propTypes["default"].oneOf(['left']),
	
	  /** Shorthand for creating the HTML Input. */
	  input: _lib.customPropTypes.itemShorthand,
	
	  /** Format to appear on dark backgrounds. */
	  inverted: _propTypes["default"].bool,
	
	  /** Optional Label to display along side the Input. */
	  label: _lib.customPropTypes.itemShorthand,
	
	  /** A Label can appear outside an Input on the left or right. */
	  labelPosition: _propTypes["default"].oneOf(['left', 'right', 'left corner', 'right corner']),
	
	  /** An Icon Input field can show that it is currently loading data. */
	  loading: _propTypes["default"].bool,
	
	  /**
	   * Called on change.
	   *
	   * @param {ChangeEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and a proposed value.
	   */
	  onChange: _propTypes["default"].func,
	
	  /** An Input can vary in size. */
	  size: _propTypes["default"].oneOf(['mini', 'small', 'large', 'big', 'huge', 'massive']),
	
	  /** An Input can receive focus. */
	  tabIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /** Transparent Input has no background. */
	  transparent: _propTypes["default"].bool,
	
	  /** The HTML input type. */
	  type: _propTypes["default"].string
	} : {};
	Input.create = (0, _lib.createShorthandFactory)(Input, function (type) {
	  return {
	    type: type
	  };
	});
	var _default = Input;
	exports["default"] = _default;

/***/ },
/* 7256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _map2 = _interopRequireDefault(__webpack_require__(41));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _ListContent = _interopRequireDefault(__webpack_require__(315));
	
	var _ListDescription = _interopRequireDefault(__webpack_require__(221));
	
	var _ListHeader = _interopRequireDefault(__webpack_require__(222));
	
	var _ListIcon = _interopRequireDefault(__webpack_require__(316));
	
	var _ListItem = _interopRequireDefault(__webpack_require__(727));
	
	var _ListList = _interopRequireDefault(__webpack_require__(728));
	
	/**
	 * A list groups related content.
	 */
	var List =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(List, _Component);
	
	  function List() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, List);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(List)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleItemOverrides", function (predefinedProps) {
	      return {
	        onClick: function onClick(e, itemProps) {
	          (0, _invoke2["default"])(predefinedProps, 'onClick', e, itemProps);
	          (0, _invoke2["default"])(_this.props, 'onItemClick', e, itemProps);
	        }
	      };
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(List, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          animated = _this$props.animated,
	          bulleted = _this$props.bulleted,
	          celled = _this$props.celled,
	          children = _this$props.children,
	          className = _this$props.className,
	          content = _this$props.content,
	          divided = _this$props.divided,
	          floated = _this$props.floated,
	          horizontal = _this$props.horizontal,
	          inverted = _this$props.inverted,
	          items = _this$props.items,
	          link = _this$props.link,
	          ordered = _this$props.ordered,
	          relaxed = _this$props.relaxed,
	          selection = _this$props.selection,
	          size = _this$props.size,
	          verticalAlign = _this$props.verticalAlign;
	      var classes = (0, _classnames["default"])('ui', size, (0, _lib.useKeyOnly)(animated, 'animated'), (0, _lib.useKeyOnly)(bulleted, 'bulleted'), (0, _lib.useKeyOnly)(celled, 'celled'), (0, _lib.useKeyOnly)(divided, 'divided'), (0, _lib.useKeyOnly)(horizontal, 'horizontal'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(link, 'link'), (0, _lib.useKeyOnly)(ordered, 'ordered'), (0, _lib.useKeyOnly)(selection, 'selection'), (0, _lib.useKeyOrValueAndKey)(relaxed, 'relaxed'), (0, _lib.useValueAndKey)(floated, 'floated'), (0, _lib.useVerticalAlignProp)(verticalAlign), 'list', className);
	      var rest = (0, _lib.getUnhandledProps)(List, this.props);
	      var ElementType = (0, _lib.getElementType)(List, this.props);
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        return _react["default"].createElement(ElementType, (0, _extends2["default"])({
	          role: "list",
	          className: classes
	        }, rest), children);
	      }
	
	      if (!_lib.childrenUtils.isNil(content)) {
	        return _react["default"].createElement(ElementType, (0, _extends2["default"])({
	          role: "list",
	          className: classes
	        }, rest), content);
	      }
	
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({
	        role: "list",
	        className: classes
	      }, rest), (0, _map2["default"])(items, function (item) {
	        return _ListItem["default"].create(item, {
	          overrideProps: _this2.handleItemOverrides
	        });
	      }));
	    }
	  }]);
	  return List;
	}(_react.Component);
	
	(0, _defineProperty2["default"])(List, "Content", _ListContent["default"]);
	(0, _defineProperty2["default"])(List, "Description", _ListDescription["default"]);
	(0, _defineProperty2["default"])(List, "Header", _ListHeader["default"]);
	(0, _defineProperty2["default"])(List, "Icon", _ListIcon["default"]);
	(0, _defineProperty2["default"])(List, "Item", _ListItem["default"]);
	(0, _defineProperty2["default"])(List, "List", _ListList["default"]);
	(0, _defineProperty2["default"])(List, "handledProps", ["animated", "as", "bulleted", "celled", "children", "className", "content", "divided", "floated", "horizontal", "inverted", "items", "link", "onItemClick", "ordered", "relaxed", "selection", "size", "verticalAlign"]);
	List.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A list can animate to set the current item apart from the list. */
	  animated: _propTypes["default"].bool,
	
	  /** A list can mark items with a bullet. */
	  bulleted: _propTypes["default"].bool,
	
	  /** A list can divide its items into cells. */
	  celled: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A list can show divisions between content. */
	  divided: _propTypes["default"].bool,
	
	  /** An list can be floated left or right. */
	  floated: _propTypes["default"].oneOf(_lib.SUI.FLOATS),
	
	  /** A list can be formatted to have items appear horizontally. */
	  horizontal: _propTypes["default"].bool,
	
	  /** A list can be inverted to appear on a dark background. */
	  inverted: _propTypes["default"].bool,
	
	  /** Shorthand array of props for ListItem. */
	  items: _lib.customPropTypes.collectionShorthand,
	
	  /** A list can be specially formatted for navigation links. */
	  link: _propTypes["default"].bool,
	
	  /**
	   * onClick handler for ListItem. Mutually exclusive with children.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All item props.
	   */
	  onItemClick: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _propTypes["default"].func]),
	
	  /** A list can be ordered numerically. */
	  ordered: _propTypes["default"].bool,
	
	  /** A list can relax its padding to provide more negative space. */
	  relaxed: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['very'])]),
	
	  /** A selection list formats list items as possible choices. */
	  selection: _propTypes["default"].bool,
	
	  /** A list can vary in size. */
	  size: _propTypes["default"].oneOf(_lib.SUI.SIZES),
	
	  /** An element inside a list can be vertically aligned. */
	  verticalAlign: _propTypes["default"].oneOf(_lib.SUI.VERTICAL_ALIGNMENTS)
	} : {};
	var _default = List;
	exports["default"] = _default;

/***/ },
/* 7257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _List["default"];
	  }
	});
	
	var _List = _interopRequireDefault(__webpack_require__(7256));

/***/ },
/* 7258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A loader alerts a user to wait for an activity to complete.
	 * @see Dimmer
	 */
	function Loader(props) {
	  var active = props.active,
	      children = props.children,
	      className = props.className,
	      content = props.content,
	      disabled = props.disabled,
	      indeterminate = props.indeterminate,
	      inline = props.inline,
	      inverted = props.inverted,
	      size = props.size;
	  var classes = (0, _classnames["default"])('ui', size, (0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(indeterminate, 'indeterminate'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(children || content, 'text'), (0, _lib.useKeyOrValueAndKey)(inline, 'inline'), 'loader', className);
	  var rest = (0, _lib.getUnhandledProps)(Loader, props);
	  var ElementType = (0, _lib.getElementType)(Loader, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	Loader.handledProps = ["active", "as", "children", "className", "content", "disabled", "indeterminate", "inline", "inverted", "size"];
	Loader.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A loader can be active or visible. */
	  active: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A loader can be disabled or hidden. */
	  disabled: _propTypes["default"].bool,
	
	  /** A loader can show it's unsure of how long a task will take. */
	  indeterminate: _propTypes["default"].bool,
	
	  /** Loaders can appear inline with content. */
	  inline: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['centered'])]),
	
	  /** Loaders can have their colors inverted. */
	  inverted: _propTypes["default"].bool,
	
	  /** Loaders can have different sizes. */
	  size: _propTypes["default"].oneOf(_lib.SUI.SIZES)
	} : {};
	var _default = Loader;
	exports["default"] = _default;

/***/ },
/* 7259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Loader["default"];
	  }
	});
	
	var _Loader = _interopRequireDefault(__webpack_require__(7258));

/***/ },
/* 7260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _PlaceholderHeader = _interopRequireDefault(__webpack_require__(729));
	
	var _PlaceholderImage = _interopRequireDefault(__webpack_require__(730));
	
	var _PlaceholderLine = _interopRequireDefault(__webpack_require__(731));
	
	var _PlaceholderParagraph = _interopRequireDefault(__webpack_require__(732));
	
	/**
	 * A placeholder is used to reserve splace for content that soon will appear in a layout.
	 */
	function Placeholder(props) {
	  var children = props.children,
	      className = props.className,
	      content = props.content,
	      fluid = props.fluid,
	      inverted = props.inverted;
	  var classes = (0, _classnames["default"])('ui', (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(inverted, 'inverted'), 'placeholder', className);
	  var rest = (0, _lib.getUnhandledProps)(Placeholder, props);
	  var ElementType = (0, _lib.getElementType)(Placeholder, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	Placeholder.handledProps = ["as", "children", "className", "content", "fluid", "inverted"];
	Placeholder.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A fluid placeholder takes up the width of its container. */
	  fluid: _propTypes["default"].bool,
	
	  /** A placeholder can have their colors inverted. */
	  inverted: _propTypes["default"].bool
	} : {};
	Placeholder.Header = _PlaceholderHeader["default"];
	Placeholder.Image = _PlaceholderImage["default"];
	Placeholder.Line = _PlaceholderLine["default"];
	Placeholder.Paragraph = _PlaceholderParagraph["default"];
	var _default = Placeholder;
	exports["default"] = _default;

/***/ },
/* 7261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Placeholder["default"];
	  }
	});
	
	var _Placeholder = _interopRequireDefault(__webpack_require__(7260));

/***/ },
/* 7262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A rail is used to show accompanying content outside the boundaries of the main view of a site.
	 */
	function Rail(props) {
	  var attached = props.attached,
	      children = props.children,
	      className = props.className,
	      close = props.close,
	      content = props.content,
	      dividing = props.dividing,
	      internal = props.internal,
	      position = props.position,
	      size = props.size;
	  var classes = (0, _classnames["default"])('ui', position, size, (0, _lib.useKeyOnly)(attached, 'attached'), (0, _lib.useKeyOnly)(dividing, 'dividing'), (0, _lib.useKeyOnly)(internal, 'internal'), (0, _lib.useKeyOrValueAndKey)(close, 'close'), 'rail', className);
	  var rest = (0, _lib.getUnhandledProps)(Rail, props);
	  var ElementType = (0, _lib.getElementType)(Rail, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	Rail.handledProps = ["as", "attached", "children", "className", "close", "content", "dividing", "internal", "position", "size"];
	Rail.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A rail can appear attached to the main viewport. */
	  attached: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** A rail can appear closer to the main viewport. */
	  close: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['very'])]),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A rail can create a division between itself and a container. */
	  dividing: _propTypes["default"].bool,
	
	  /** A rail can attach itself to the inside of a container. */
	  internal: _propTypes["default"].bool,
	
	  /** A rail can be presented on the left or right side of a container. */
	  position: _propTypes["default"].oneOf(_lib.SUI.FLOATS).isRequired,
	
	  /** A rail can have different sizes. */
	  size: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.SIZES, 'medium'))
	} : {};
	var _default = Rail;
	exports["default"] = _default;

/***/ },
/* 7263 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Rail["default"];
	  }
	});
	
	var _Rail = _interopRequireDefault(__webpack_require__(7262));

/***/ },
/* 7264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _RevealContent = _interopRequireDefault(__webpack_require__(733));
	
	/**
	 * A reveal displays additional content in place of previous content when activated.
	 */
	function Reveal(props) {
	  var active = props.active,
	      animated = props.animated,
	      children = props.children,
	      className = props.className,
	      content = props.content,
	      disabled = props.disabled,
	      instant = props.instant;
	  var classes = (0, _classnames["default"])('ui', animated, (0, _lib.useKeyOnly)(active, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(instant, 'instant'), 'reveal', className);
	  var rest = (0, _lib.getUnhandledProps)(Reveal, props);
	  var ElementType = (0, _lib.getElementType)(Reveal, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	Reveal.handledProps = ["active", "animated", "as", "children", "className", "content", "disabled", "instant"];
	Reveal.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** An active reveal displays its hidden content. */
	  active: _propTypes["default"].bool,
	
	  /** An animation name that will be applied to Reveal. */
	  animated: _propTypes["default"].oneOf(['fade', 'small fade', 'move', 'move right', 'move up', 'move down', 'rotate', 'rotate left']),
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A disabled reveal will not animate when hovered. */
	  disabled: _propTypes["default"].bool,
	
	  /** An element can show its content without delay. */
	  instant: _propTypes["default"].bool
	} : {};
	Reveal.Content = _RevealContent["default"];
	var _default = Reveal;
	exports["default"] = _default;

/***/ },
/* 7265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Reveal["default"];
	  }
	});
	
	var _Reveal = _interopRequireDefault(__webpack_require__(7264));

/***/ },
/* 7266 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Segment["default"];
	  }
	});
	
	var _Segment = _interopRequireDefault(__webpack_require__(734));

/***/ },
/* 7267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Step["default"];
	  }
	});
	
	var _Step = _interopRequireDefault(__webpack_require__(737));

/***/ },
/* 7268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.getAutoControlledStateValue = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _isUndefined2 = _interopRequireDefault(__webpack_require__(204));
	
	var _startsWith2 = _interopRequireDefault(__webpack_require__(6941));
	
	var _filter2 = _interopRequireDefault(__webpack_require__(201));
	
	var _isEmpty2 = _interopRequireDefault(__webpack_require__(202));
	
	var _keys2 = _interopRequireDefault(__webpack_require__(63));
	
	var _intersection2 = _interopRequireDefault(__webpack_require__(6916));
	
	var _has2 = _interopRequireDefault(__webpack_require__(119));
	
	var _each2 = _interopRequireDefault(__webpack_require__(506));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _react = __webpack_require__(2);
	
	var getDefaultPropName = function getDefaultPropName(prop) {
	  return "default".concat(prop[0].toUpperCase() + prop.slice(1));
	};
	/**
	 * Return the auto controlled state value for a give prop. The initial value is chosen in this order:
	 *  - regular props
	 *  - then, default props
	 *  - then, initial state
	 *  - then, `checked` defaults to false
	 *  - then, `value` defaults to '' or [] if props.multiple
	 *  - else, undefined
	 *
	 *  @param {string} propName A prop name
	 *  @param {object} [props] A props object
	 *  @param {object} [state] A state object
	 *  @param {boolean} [includeDefaults=false] Whether or not to heed the default props or initial state
	 */
	
	
	var getAutoControlledStateValue = function getAutoControlledStateValue(propName, props, state) {
	  var includeDefaults = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	  // regular props
	  var propValue = props[propName];
	  if (propValue !== undefined) return propValue;
	
	  if (includeDefaults) {
	    // defaultProps
	    var defaultProp = props[getDefaultPropName(propName)];
	    if (defaultProp !== undefined) return defaultProp; // initial state - state may be null or undefined
	
	    if (state) {
	      var initialState = state[propName];
	      if (initialState !== undefined) return initialState;
	    }
	  } // React doesn't allow changing from uncontrolled to controlled components,
	  // default checked/value if they were not present.
	
	
	  if (propName === 'checked') return false;
	  if (propName === 'value') return props.multiple ? [] : ''; // otherwise, undefined
	};
	
	exports.getAutoControlledStateValue = getAutoControlledStateValue;
	
	var AutoControlledComponent =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(AutoControlledComponent, _Component);
	
	  function AutoControlledComponent() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, AutoControlledComponent);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(AutoControlledComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "trySetState", function (state, callback) {
	      var newState = Object.keys(state).reduce(function (acc, prop) {
	        // ignore props defined by the parent
	        if (_this.props[prop] !== undefined) return acc;
	        acc[prop] = state[prop];
	        return acc;
	      }, {});
	      if (Object.keys(newState).length > 0) _this.setState(newState, callback);
	    });
	    var autoControlledProps = _this.constructor.autoControlledProps;
	
	    var _state = (0, _invoke2["default"])((0, _assertThisInitialized2["default"])(_this), 'getInitialAutoControlledState', _this.props) || {};
	
	    if (false) {
	      var _this$constructor = _this.constructor,
	          defaultProps = _this$constructor.defaultProps,
	          name = _this$constructor.name,
	          propTypes = _this$constructor.propTypes; // require static autoControlledProps
	
	      if (!autoControlledProps) {
	        console.error("Auto controlled ".concat(name, " must specify a static autoControlledProps array."));
	      } // require propTypes
	
	
	      (0, _each2["default"])(autoControlledProps, function (prop) {
	        var defaultProp = getDefaultPropName(prop); // regular prop
	
	        if (!(0, _has2["default"])(propTypes, defaultProp)) {
	          console.error("".concat(name, " is missing \"").concat(defaultProp, "\" propTypes validation for auto controlled prop \"").concat(prop, "\"."));
	        } // its default prop
	
	
	        if (!(0, _has2["default"])(propTypes, prop)) {
	          console.error("".concat(name, " is missing propTypes validation for auto controlled prop \"").concat(prop, "\"."));
	        }
	      }); // prevent autoControlledProps in defaultProps
	      //
	      // When setting state, auto controlled props values always win (so the parent can manage them).
	      // It is not reasonable to decipher the difference between props from the parent and defaultProps.
	      // Allowing defaultProps results in trySetState always deferring to the defaultProp value.
	      // Auto controlled props also listed in defaultProps can never be updated.
	      //
	      // To set defaults for an AutoControlled prop, you can set the initial state in the
	      // constructor or by using an ES7 property initializer:
	      // https://babeljs.io/blog/2015/06/07/react-on-es6-plus#property-initializers
	
	      var illegalDefaults = (0, _intersection2["default"])(autoControlledProps, (0, _keys2["default"])(defaultProps));
	
	      if (!(0, _isEmpty2["default"])(illegalDefaults)) {
	        console.error(['Do not set defaultProps for autoControlledProps. You can set defaults by', 'setting state in the constructor or using an ES7 property initializer', '(https://babeljs.io/blog/2015/06/07/react-on-es6-plus#property-initializers)', "See ".concat(name, " props: \"").concat(illegalDefaults, "\".")].join(' '));
	      } // prevent listing defaultProps in autoControlledProps
	      //
	      // Default props are automatically handled.
	      // Listing defaults in autoControlledProps would result in allowing defaultDefaultValue props.
	
	
	      var illegalAutoControlled = (0, _filter2["default"])(autoControlledProps, function (prop) {
	        return (0, _startsWith2["default"])(prop, 'default');
	      });
	
	      if (!(0, _isEmpty2["default"])(illegalAutoControlled)) {
	        console.error(['Do not add default props to autoControlledProps.', 'Default props are automatically handled.', "See ".concat(name, " autoControlledProps: \"").concat(illegalAutoControlled, "\".")].join(' '));
	      }
	    } // Auto controlled props are copied to state.
	    // Set initial state by copying auto controlled props to state.
	    // Also look for the default prop for any auto controlled props (foo => defaultFoo)
	    // so we can set initial values from defaults.
	
	
	    var initialAutoControlledState = autoControlledProps.reduce(function (acc, prop) {
	      acc[prop] = getAutoControlledStateValue(prop, _this.props, _state, true);
	
	      if (false) {
	        var defaultPropName = getDefaultPropName(prop);
	        var _name = _this.constructor.name; // prevent defaultFoo={} along side foo={}
	
	        if (!(0, _isUndefined2["default"])(_this.props[defaultPropName]) && !(0, _isUndefined2["default"])(_this.props[prop])) {
	          console.error("".concat(_name, " prop \"").concat(prop, "\" is auto controlled. Specify either ").concat(defaultPropName, " or ").concat(prop, ", but not both."));
	        }
	      }
	
	      return acc;
	    }, {});
	    _this.state = (0, _objectSpread2["default"])({}, _state, initialAutoControlledState);
	    return _this;
	  } // eslint-disable-next-line camelcase
	
	
	  (0, _createClass2["default"])(AutoControlledComponent, [{
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      var autoControlledProps = this.constructor.autoControlledProps; // Solve the next state for autoControlledProps
	
	      var newState = autoControlledProps.reduce(function (acc, prop) {
	        var isNextDefined = !(0, _isUndefined2["default"])(nextProps[prop]); // if next is defined then use its value
	
	        if (isNextDefined) acc[prop] = nextProps[prop];
	        return acc;
	      }, {});
	      if (Object.keys(newState).length > 0) this.setState(newState);
	    }
	    /**
	     * Safely attempt to set state for props that might be controlled by the user.
	     * Second argument is a state object that is always passed to setState.
	     * @param {object} state State that corresponds to controlled props.
	     * @param {function} [callback] Callback which is called after setState applied.
	     */
	
	  }]);
	  return AutoControlledComponent;
	}(_react.Component);
	
	exports["default"] = AutoControlledComponent;

/***/ },
/* 7269 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ALL_ICONS_IN_ALL_CONTEXTS = exports.COMPONENT_CONTEXT_SPECIFIC_ICONS = exports.ICONS_AND_ALIASES = exports.ICON_ALIASES = exports.ICONS = exports.BRANDS = exports.WRITING = exports.VEHICLES = exports.USERS_PEOPLE = exports.STATUS = exports.SPORTS = exports.SPINNERS = exports.SHAPES = exports.PAYMENTS_SHOPPING = exports.OBJECTS = exports.MEDICAL = exports.MAPS = exports.LOGISTICS = exports.INTERFACES = exports.IMAGES = exports.HEALTH = exports.HANDS_GESTURES = exports.GENDERS = exports.FILES = exports.EDITORS = exports.DESIGN = exports.DATE_TIME = exports.CURRENCY = exports.COMPUTERS = exports.COMMUNICATION = exports.CODE = exports.CHESS = exports.BUSINESS = exports.AUDIO_VIDEO = exports.ARROWS = exports.ACCESSIBILITY = exports.TRANSITIONS = exports.STATIC_TRANSITIONS = exports.DIRECTIONAL_TRANSITIONS = exports.WIDTHS = exports.VISIBILITY = exports.VERTICAL_ALIGNMENTS = exports.TEXT_ALIGNMENTS = exports.SIZES = exports.FLOATS = exports.COLORS = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(46));
	
	var _uniq2 = _interopRequireDefault(__webpack_require__(286));
	
	var _values2 = _interopRequireDefault(__webpack_require__(153));
	
	var _keys2 = _interopRequireDefault(__webpack_require__(63));
	
	var _numberToWord = __webpack_require__(319);
	
	var COLORS = ['red', 'orange', 'yellow', 'olive', 'green', 'teal', 'blue', 'violet', 'purple', 'pink', 'brown', 'grey', 'black'];
	exports.COLORS = COLORS;
	var FLOATS = ['left', 'right'];
	exports.FLOATS = FLOATS;
	var SIZES = ['mini', 'tiny', 'small', 'medium', 'large', 'big', 'huge', 'massive'];
	exports.SIZES = SIZES;
	var TEXT_ALIGNMENTS = ['left', 'center', 'right', 'justified'];
	exports.TEXT_ALIGNMENTS = TEXT_ALIGNMENTS;
	var VERTICAL_ALIGNMENTS = ['bottom', 'middle', 'top'];
	exports.VERTICAL_ALIGNMENTS = VERTICAL_ALIGNMENTS;
	var VISIBILITY = ['mobile', 'tablet', 'computer', 'large screen', 'widescreen'];
	exports.VISIBILITY = VISIBILITY;
	var WIDTHS = [].concat((0, _toConsumableArray2["default"])((0, _keys2["default"])(_numberToWord.numberToWordMap)), (0, _toConsumableArray2["default"])((0, _keys2["default"])(_numberToWord.numberToWordMap).map(Number)), (0, _toConsumableArray2["default"])((0, _values2["default"])(_numberToWord.numberToWordMap)));
	exports.WIDTHS = WIDTHS;
	var DIRECTIONAL_TRANSITIONS = ['browse', 'browse right', 'drop', 'fade', 'fade up', 'fade down', 'fade left', 'fade right', 'fly up', 'fly down', 'fly left', 'fly right', 'horizontal flip', 'vertical flip', 'scale', 'slide up', 'slide down', 'slide left', 'slide right', 'swing up', 'swing down', 'swing left', 'swing right', 'zoom'];
	exports.DIRECTIONAL_TRANSITIONS = DIRECTIONAL_TRANSITIONS;
	var STATIC_TRANSITIONS = ['jiggle', 'flash', 'shake', 'pulse', 'tada', 'bounce', 'glow'];
	exports.STATIC_TRANSITIONS = STATIC_TRANSITIONS;
	var TRANSITIONS = [].concat(DIRECTIONAL_TRANSITIONS, STATIC_TRANSITIONS); // Generated from:
	// https://github.com/Semantic-Org/Semantic-UI/blob/master/dist/components/icon.css
	
	exports.TRANSITIONS = TRANSITIONS;
	var ACCESSIBILITY = ['american sign language interpreting', 'assistive listening systems', 'audio description', 'blind', 'braille', 'closed captioning', 'closed captioning outline', 'deaf', 'low vision', 'phone volume', 'question circle', 'question circle outline', 'sign language', 'tty', 'universal access', 'wheelchair'];
	exports.ACCESSIBILITY = ACCESSIBILITY;
	var ARROWS = ['angle double down', 'angle double left', 'angle double right', 'angle double up', 'angle down', 'angle left', 'angle right', 'angle up', 'arrow alternate circle down', 'arrow alternate circle down outline', 'arrow alternate circle left', 'arrow alternate circle left outline', 'arrow alternate circle right', 'arrow alternate circle right outline', 'arrow alternate circle up', 'arrow alternate circle up outline', 'arrow circle down', 'arrow circle left', 'arrow circle right', 'arrow circle up', 'arrow down', 'arrow left', 'arrow right', 'arrow up', 'arrows alternate', 'arrows alternate horizontal', 'arrows alternate vertical', 'caret down', 'caret left', 'caret right', 'caret square down', 'caret square down outline', 'caret square left', 'caret square left outline', 'caret square right', 'caret square right outline', 'caret square up', 'caret square up outline', 'caret up', 'cart arrow down', 'chart line', 'chevron circle down', 'chevron circle left', 'chevron circle right', 'chevron circle up', 'chevron down', 'chevron left', 'chevron right', 'chevron up', 'cloud download', 'cloud upload', 'download', 'exchange', 'expand arrows alternate', 'external alternate', 'external square alternate', 'hand point down', 'hand point down outline', 'hand point left', 'hand point left outline', 'hand point right', 'hand point right outline', 'hand point up', 'hand point up outline', 'hand pointer', 'hand pointer outline', 'history', 'level down alternate', 'level up alternate', 'location arrow', 'long arrow alternate down', 'long arrow alternate left', 'long arrow alternate right', 'long arrow alternate up', 'mouse pointer', 'play', 'random', 'recycle', 'redo', 'redo alternate', 'reply', 'reply all', 'retweet', 'share', 'share square', 'share square outline', 'sign-in', 'sign-out', 'sign-in alternate', 'sign-out alternate', 'sort', 'sort alphabet down', 'sort alphabet up', 'sort amount down', 'sort amount up', 'sort down', 'sort numeric down', 'sort numeric up', 'sort up', 'sync', 'sync alternate', 'text height', 'text width', 'undo', 'undo alternate', 'upload', 'zoom-in', 'zoom-out'];
	exports.ARROWS = ARROWS;
	var AUDIO_VIDEO = ['audio description', 'backward', 'circle', 'circle outline', 'closed captioning', 'closed captioning outline', 'compress', 'eject', 'expand', 'expand arrows alternate', 'fast backward', 'fast forward', 'file audio', 'file audio outline', 'file video', 'file video outline', 'film', 'forward', 'headphones', 'microphone', 'microphone slash', 'music', 'pause', 'pause circle', 'pause circle outline', 'phone volume', 'play', 'play circle', 'play circle outline', 'podcast', 'random', 'redo', 'redo alternate', 'rss', 'rss square', 'step backward', 'step forward', 'stop', 'stop circle', 'stop circle outline', 'sync', 'sync alternate', 'undo', 'undo alternate', 'video', 'volume down', 'volume off', 'volume up'];
	exports.AUDIO_VIDEO = AUDIO_VIDEO;
	var BUSINESS = ['address book', 'address book outline', 'address card', 'address card outline', 'archive', 'balance scale', 'birthday cake', 'book', 'briefcase', 'building', 'building outline', 'bullhorn', 'bullseye', 'calculator', 'calendar', 'calendar outline', 'calendar alternate', 'calendar alternate outline', 'certificate', 'chart area', 'chart bar', 'chart bar outline', 'chart line', 'chart pie', 'clipboard', 'clipboard outline', 'coffee', 'columns', 'compass', 'compass outline', 'copy', 'copy outline', 'copyright', 'copyright outline', 'cut', 'edit', 'edit outline', 'envelope', 'envelope outline', 'envelope open', 'envelope open outline', 'envelope square', 'eraser', 'fax', 'file', 'file outline', 'file alternate', 'file alternate outline', 'folder', 'folder outline', 'folder open', 'folder open outline', 'globe', 'industry', 'paperclip', 'paste', 'pen square', 'pencil alternate', 'percent', 'phone', 'phone square', 'phone volume', 'registered', 'registered outline', 'save', 'save outline', 'sitemap', 'sticky note', 'sticky note outline', 'suitcase', 'table', 'tag', 'tags', 'tasks', 'thumbtack', 'trademark'];
	exports.BUSINESS = BUSINESS;
	var CHESS = ['chess', 'chess bishop', 'chess board', 'chess king', 'chess knight', 'chess pawn', 'chess queen', 'chess rook', 'square full'];
	exports.CHESS = CHESS;
	var CODE = ['archive', 'barcode', 'bath', 'bug', 'code', 'code branch', 'coffee', 'file', 'file outline', 'file alternate', 'file alternate outline', 'file code', 'file code outline', 'filter', 'fire extinguisher', 'folder', 'folder outline', 'folder open', 'folder open outline', 'keyboard', 'keyboard outline', 'microchip', 'qrcode', 'shield alternate', 'sitemap', 'terminal', 'user secret', 'window close', 'window close outline', 'window maximize', 'window maximize outline', 'window minimize', 'window minimize outline', 'window restore', 'window restore outline'];
	exports.CODE = CODE;
	var COMMUNICATION = ['address book', 'address book outline', 'address card', 'address card outline', 'american sign language interpreting', 'assistive listening systems', 'at', 'bell', 'bell outline', 'bell slash', 'bell slash outline', 'bullhorn', 'comment', 'comment outline', 'comment alternate', 'comment alternate outline', 'comments', 'comments outline', 'envelope', 'envelope outline', 'envelope open', 'envelope open outline', 'envelope square', 'fax', 'inbox', 'language', 'microphone', 'microphone slash', 'mobile', 'mobile alternate', 'paper plane', 'paper plane outline', 'phone', 'phone square', 'phone volume', 'rss', 'rss square', 'tty', 'wifi'];
	exports.COMMUNICATION = COMMUNICATION;
	var COMPUTERS = ['desktop', 'download', 'hdd', 'hdd outline', 'headphones', 'keyboard', 'keyboard outline', 'laptop', 'microchip', 'mobile', 'mobile alternate', 'plug', 'power off', 'print', 'save', 'save outline', 'server', 'tablet', 'tablet alternate', 'tv', 'upload'];
	exports.COMPUTERS = COMPUTERS;
	var CURRENCY = ['dollar sign', 'euro sign', 'lira sign', 'money bill alternate', 'money bill alternate outline', 'pound sign', 'ruble sign', 'rupee sign', 'shekel sign', 'won sign', 'yen sign'];
	exports.CURRENCY = CURRENCY;
	var DATE_TIME = ['bell', 'bell outline', 'bell slash', 'bell slash outline', 'calendar', 'calendar outline', 'calendar alternate', 'calendar alternate outline', 'calendar check', 'calendar check outline', 'calendar minus', 'calendar minus outline', 'calendar plus', 'calendar plus outline', 'calendar times', 'calendar times outline', 'clock', 'clock outline', 'hourglass', 'hourglass outline', 'hourglass end', 'hourglass half', 'hourglass start', 'stopwatch'];
	exports.DATE_TIME = DATE_TIME;
	var DESIGN = ['adjust', 'clone', 'clone outline', 'copy', 'copy outline', 'crop', 'crosshairs', 'cut', 'edit', 'edit outline', 'eraser', 'eye', 'eye dropper', 'eye slash', 'eye slash outline', 'object group', 'object group outline', 'object ungroup', 'object ungroup outline', 'paint brush', 'paste', 'pencil alternate', 'save', 'save outline', 'tint'];
	exports.DESIGN = DESIGN;
	var EDITORS = ['align center', 'align justify', 'align left', 'align right', 'bold', 'clipboard', 'clipboard outline', 'clone', 'clone outline', 'columns', 'copy', 'copy outline', 'cut', 'edit', 'edit outline', 'eraser', 'file', 'file outline', 'file alternate', 'file alternate outline', 'font', 'heading', 'i cursor', 'indent', 'italic', 'linkify', 'list', 'list alternate', 'list alternate outline', 'list ol', 'list ul', 'outdent', 'paper plane', 'paper plane outline', 'paperclip', 'paragraph', 'paste', 'pencil alternate', 'print', 'quote left', 'quote right', 'redo', 'redo alternate', 'reply', 'reply all', 'share', 'strikethrough', 'subscript', 'superscript', 'sync', 'sync alternate', 'table', 'tasks', 'text height', 'text width', 'th', 'th large', 'th list', 'trash', 'trash alternate', 'trash alternate outline', 'underline', 'undo', 'undo alternate', 'unlink'];
	exports.EDITORS = EDITORS;
	var FILES = ['archive', 'clone', 'clone outline', 'copy', 'copy outline', 'cut', 'file', 'file outline', 'file alternate', 'file alternate outline', 'file archive', 'file archive outline', 'file audio', 'file audio outline', 'file code', 'file code outline', 'file excel', 'file excel outline', 'file image', 'file image outline', 'file pdf', 'file pdf outline', 'file powerpoint', 'file powerpoint outline', 'file video', 'file video outline', 'file word', 'file word outline', 'folder', 'folder outline', 'folder open', 'folder open outline', 'paste', 'save', 'save outline', 'sticky note', 'sticky note outline'];
	exports.FILES = FILES;
	var GENDERS = ['genderless', 'mars', 'mars double', 'mars stroke', 'mars stroke horizontal', 'mars stroke vertical', 'mercury', 'neuter', 'transgender', 'transgender alternate', 'venus', 'venus double', 'venus mars'];
	exports.GENDERS = GENDERS;
	var HANDS_GESTURES = ['hand lizard', 'hand lizard outline', 'hand paper', 'hand paper outline', 'hand peace', 'hand peace outline', 'hand point down', 'hand point down outline', 'hand point left', 'hand point left outline', 'hand point right', 'hand point right outline', 'hand point up', 'hand point up outline', 'hand pointer', 'hand pointer outline', 'hand rock', 'hand rock outline', 'hand scissors', 'hand scissors outline', 'hand spock', 'hand spock outline', 'handshake', 'handshake outline', 'thumbs down', 'thumbs down outline', 'thumbs up', 'thumbs up outline'];
	exports.HANDS_GESTURES = HANDS_GESTURES;
	var HEALTH = ['ambulance', 'h square', 'heart', 'heart outline', 'heartbeat', 'hospital', 'hospital outline', 'medkit', 'plus square', 'plus square outline', 'stethoscope', 'user md', 'wheelchair'];
	exports.HEALTH = HEALTH;
	var IMAGES = ['adjust', 'bolt', 'camera', 'camera retro', 'clone', 'clone outline', 'compress', 'expand', 'eye', 'eye dropper', 'eye slash', 'eye slash outline', 'file image', 'file image outline', 'film', 'id badge', 'id badge outline', 'id card', 'id card outline', 'image', 'image outline', 'images', 'images outline', 'sliders horizontal', 'tint'];
	exports.IMAGES = IMAGES;
	var INTERFACES = ['ban', 'barcode', 'bars', 'beer', 'bell', 'bell outline', 'bell slash', 'bell slash outline', 'bug', 'bullhorn', 'bullseye', 'calculator', 'calendar', 'calendar outline', 'calendar alternate', 'calendar alternate outline', 'calendar check', 'calendar check outline', 'calendar minus', 'calendar minus outline', 'calendar plus', 'calendar plus outline', 'calendar times', 'calendar times outline', 'certificate', 'check', 'check circle', 'check circle outline', 'check square', 'check square outline', 'circle', 'circle outline', 'clipboard', 'clipboard outline', 'clone', 'clone outline', 'cloud', 'cloud download', 'cloud upload', 'coffee', 'cog', 'cogs', 'copy', 'copy outline', 'cut', 'database', 'dot circle', 'dot circle outline', 'download', 'edit', 'edit outline', 'ellipsis horizontal', 'ellipsis vertical', 'envelope', 'envelope outline', 'envelope open', 'envelope open outline', 'eraser', 'exclamation', 'exclamation circle', 'exclamation triangle', 'external alternate', 'external square alternate', 'eye', 'eye slash', 'eye slash outline', 'file', 'file outline', 'file alternate', 'file alternate outline', 'filter', 'flag', 'flag outline', 'flag checkered', 'folder', 'folder outline', 'folder open', 'folder open outline', 'frown', 'frown outline', 'hashtag', 'heart', 'heart outline', 'history', 'home', 'i cursor', 'info', 'info circle', 'language', 'magic', 'meh', 'meh outline', 'microphone', 'microphone slash', 'minus', 'minus circle', 'minus square', 'minus square outline', 'paste', 'pencil alternate', 'plus', 'plus circle', 'plus square', 'plus square outline', 'qrcode', 'question', 'question circle', 'question circle outline', 'quote left', 'quote right', 'redo', 'redo alternate', 'reply', 'reply all', 'rss', 'rss square', 'save', 'save outline', 'search', 'search minus', 'search plus', 'share', 'share alternate', 'share alternate square', 'share square', 'share square outline', 'shield alternate', 'sign-in', 'sign-out', 'signal', 'sitemap', 'sliders horizontal', 'smile', 'smile outline', 'sort', 'sort alphabet down', 'sort alphabet up', 'sort amount down', 'sort amount up', 'sort down', 'sort numeric down', 'sort numeric up', 'sort up', 'star', 'star outline', 'star half', 'star half outline', 'sync', 'sync alternate', 'thumbs down', 'thumbs down outline', 'thumbs up', 'thumbs up outline', 'times', 'times circle', 'times circle outline', 'toggle off', 'toggle on', 'trash', 'trash alternate', 'trash alternate outline', 'trophy', 'undo', 'undo alternate', 'upload', 'user', 'user outline', 'user circle', 'user circle outline', 'wifi'];
	exports.INTERFACES = INTERFACES;
	var LOGISTICS = ['box', 'boxes', 'clipboard check', 'clipboard list', 'dolly', 'dolly flatbed', 'pallet', 'shipping fast', 'truck', 'warehouse'];
	exports.LOGISTICS = LOGISTICS;
	var MAPS = ['ambulance', 'anchor', 'balance scale', 'bath', 'bed', 'beer', 'bell', 'bell outline', 'bell slash', 'bell slash outline', 'bicycle', 'binoculars', 'birthday cake', 'blind', 'bomb', 'book', 'bookmark', 'bookmark outline', 'briefcase', 'building', 'building outline', 'car', 'coffee', 'crosshairs', 'dollar sign', 'eye', 'eye slash', 'eye slash outline', 'fighter jet', 'fire', 'fire extinguisher', 'flag', 'flag outline', 'flag checkered', 'flask', 'gamepad', 'gavel', 'gift', 'glass martini', 'globe', 'graduation cap', 'h square', 'heart', 'heart outline', 'heartbeat', 'home', 'hospital', 'hospital outline', 'image', 'image outline', 'images', 'images outline', 'industry', 'info', 'info circle', 'key', 'leaf', 'lemon', 'lemon outline', 'life ring', 'life ring outline', 'lightbulb', 'lightbulb outline', 'location arrow', 'low vision', 'magnet', 'male', 'map', 'map outline', 'map marker', 'map marker alternate', 'map pin', 'map signs', 'medkit', 'money bill alternate', 'money bill alternate outline', 'motorcycle', 'music', 'newspaper', 'newspaper outline', 'paw', 'phone', 'phone square', 'phone volume', 'plane', 'plug', 'plus', 'plus square', 'plus square outline', 'print', 'recycle', 'road', 'rocket', 'search', 'search minus', 'search plus', 'ship', 'shopping bag', 'shopping basket', 'shopping cart', 'shower', 'street view', 'subway', 'suitcase', 'tag', 'tags', 'taxi', 'thumbtack', 'ticket alternate', 'tint', 'train', 'tree', 'trophy', 'truck', 'tty', 'umbrella', 'university', 'utensil spoon', 'utensils', 'wheelchair', 'wifi', 'wrench'];
	exports.MAPS = MAPS;
	var MEDICAL = ['ambulance', 'band aid', 'dna', 'first aid', 'heart', 'heart outline', 'heartbeat', 'hospital', 'hospital outline', 'hospital symbol', 'pills', 'plus', 'stethoscope', 'syringe', 'thermometer', 'user md', 'weight'];
	exports.MEDICAL = MEDICAL;
	var OBJECTS = ['ambulance', 'anchor', 'archive', 'balance scale', 'bath', 'bed', 'beer', 'bell', 'bell outline', 'bicycle', 'binoculars', 'birthday cake', 'bomb', 'book', 'bookmark', 'bookmark outline', 'briefcase', 'bug', 'building', 'building outline', 'bullhorn', 'bullseye', 'bus', 'calculator', 'calendar', 'calendar outline', 'calendar alternate', 'calendar alternate outline', 'camera', 'camera retro', 'car', 'clipboard', 'clipboard outline', 'cloud', 'coffee', 'cog', 'cogs', 'compass', 'compass outline', 'copy', 'copy outline', 'cube', 'cubes', 'cut', 'envelope', 'envelope outline', 'envelope open', 'envelope open outline', 'eraser', 'eye', 'eye dropper', 'fax', 'fighter jet', 'file', 'file outline', 'file alternate', 'file alternate outline', 'film', 'fire', 'fire extinguisher', 'flag', 'flag outline', 'flag checkered', 'flask', 'futbol', 'futbol outline', 'gamepad', 'gavel', 'gem', 'gem outline', 'gift', 'glass martini', 'globe', 'graduation cap', 'hdd', 'hdd outline', 'headphones', 'heart', 'heart outline', 'home', 'hospital', 'hospital outline', 'hourglass', 'hourglass outline', 'image', 'image outline', 'images', 'images outline', 'industry', 'key', 'keyboard', 'keyboard outline', 'laptop', 'leaf', 'lemon', 'lemon outline', 'life ring', 'life ring outline', 'lightbulb', 'lightbulb outline', 'lock', 'lock open', 'magic', 'magnet', 'map', 'map outline', 'map marker', 'map marker alternate', 'map pin', 'map signs', 'medkit', 'microchip', 'microphone', 'mobile', 'mobile alternate', 'money bill alternate', 'money bill alternate outline', 'moon', 'moon outline', 'motorcycle', 'newspaper', 'newspaper outline', 'paint brush', 'paper plane', 'paper plane outline', 'paperclip', 'paste', 'paw', 'pencil alternate', 'phone', 'plane', 'plug', 'print', 'puzzle piece', 'road', 'rocket', 'save', 'save outline', 'search', 'shield alternate', 'shopping bag', 'shopping basket', 'shopping cart', 'shower', 'snowflake', 'snowflake outline', 'space shuttle', 'star', 'star outline', 'sticky note', 'sticky note outline', 'stopwatch', 'subway', 'suitcase', 'sun', 'sun outline', 'tablet', 'tablet alternate', 'tachometer alternate', 'tag', 'tags', 'taxi', 'thumbtack', 'ticket alternate', 'train', 'trash', 'trash alternate', 'trash alternate outline', 'tree', 'trophy', 'truck', 'tv', 'umbrella', 'university', 'unlock', 'unlock alternate', 'utensil spoon', 'utensils', 'wheelchair', 'wrench'];
	exports.OBJECTS = OBJECTS;
	var PAYMENTS_SHOPPING = ['bell', 'bell outline', 'bookmark', 'bookmark outline', 'bullhorn', 'camera', 'camera retro', 'cart arrow down', 'cart plus', 'certificate', 'credit card', 'credit card outline', 'gem', 'gem outline', 'gift', 'handshake', 'handshake outline', 'heart', 'heart outline', 'key', 'shopping bag', 'shopping basket', 'shopping cart', 'star', 'star outline', 'tag', 'tags', 'thumbs down', 'thumbs down outline', 'thumbs up', 'thumbs up outline', 'trophy'];
	exports.PAYMENTS_SHOPPING = PAYMENTS_SHOPPING;
	var SHAPES = ['bookmark', 'bookmark outline', 'calendar', 'calendar outline', 'certificate', 'circle', 'circle outline', 'cloud', 'comment', 'comment outline', 'file', 'file outline', 'folder', 'folder outline', 'heart', 'heart outline', 'map marker', 'play', 'square', 'square outline', 'star', 'star outline'];
	exports.SHAPES = SHAPES;
	var SPINNERS = ['asterisk', 'certificate', 'circle notch', 'cog', 'compass', 'compass outline', 'crosshairs', 'life ring', 'life ring outline', 'snowflake', 'snowflake outline', 'spinner', 'sun', 'sun outline', 'sync'];
	exports.SPINNERS = SPINNERS;
	var SPORTS = ['baseball ball', 'basketball ball', 'bowling ball', 'football ball', 'futbol', 'futbol outline', 'golf ball', 'hockey puck', 'quidditch', 'table tennis', 'volleyball ball'];
	exports.SPORTS = SPORTS;
	var STATUS = ['ban', 'battery empty', 'battery full', 'battery half', 'battery quarter', 'battery three quarters', 'bell', 'bell outline', 'bell slash', 'bell slash outline', 'calendar', 'calendar outline', 'calendar alternate', 'calendar alternate outline', 'calendar check', 'calendar check outline', 'calendar minus', 'calendar minus outline', 'calendar plus', 'calendar plus outline', 'calendar times', 'calendar times outline', 'cart arrow down', 'cart plus', 'exclamation', 'exclamation circle', 'exclamation triangle', 'eye', 'eye slash', 'eye slash outline', 'file', 'file outline', 'file alternate', 'file alternate outline', 'folder', 'folder outline', 'folder open', 'folder open outline', 'info', 'info circle', 'lock', 'lock open', 'minus', 'minus circle', 'minus square', 'minus square outline', 'plus', 'plus circle', 'plus square', 'plus square outline', 'question', 'question circle', 'question circle outline', 'shield alternate', 'shopping cart', 'sign in alternate', 'sign out alternate', 'thermometer empty', 'thermometer full', 'thermometer half', 'thermometer quarter', 'thermometer three quarters', 'thumbs down', 'thumbs down outline', 'thumbs up', 'thumbs up outline', 'toggle off', 'toggle on', 'unlock', 'unlock alternate'];
	exports.STATUS = STATUS;
	var USERS_PEOPLE = ['address book', 'address book outline', 'address card', 'address card outline', 'bed', 'blind', 'child', 'female', 'frown', 'frown outline', 'id badge', 'id badge outline', 'id card', 'id card outline', 'male', 'meh', 'meh outline', 'power off', 'smile', 'smile outline', 'street view', 'user', 'user outline', 'user circle', 'user circle outline', 'user md', 'user plus', 'user secret', 'user times', 'users', 'wheelchair'];
	exports.USERS_PEOPLE = USERS_PEOPLE;
	var VEHICLES = ['ambulance', 'bicycle', 'bus', 'car', 'fighter jet', 'motorcycle', 'paper plane', 'paper plane outline', 'plane', 'rocket', 'ship', 'shopping cart', 'space shuttle', 'subway', 'taxi', 'train', 'truck', 'wheelchair'];
	exports.VEHICLES = VEHICLES;
	var WRITING = ['archive', 'book', 'bookmark', 'bookmark outline', 'edit', 'edit outline', 'envelope', 'envelope outline', 'envelope open', 'envelope open outline', 'eraser', 'file', 'file outline', 'file alternate', 'file alternate outline', 'folder', 'folder outline', 'folder open', 'folder open outline', 'keyboard', 'keyboard outline', 'newspaper', 'newspaper outline', 'paper plane', 'paper plane outline', 'paperclip', 'paragraph', 'pen square', 'pencil alternate', 'quote left', 'quote right', 'sticky note', 'sticky note outline', 'thumbtack'];
	exports.WRITING = WRITING;
	var BRANDS = ['500px', 'accessible', 'accusoft', 'adn', 'adversal', 'affiliatetheme', 'algolia', 'amazon', 'amazon pay', 'amilia', 'android', 'angellist', 'angrycreative', 'angular', 'app store', 'app store ios', 'apper', 'apple', 'apple pay', 'asymmetrik', 'audible', 'autoprefixer', 'avianex', 'aviato', 'aws', 'bandcamp', 'behance', 'behance square', 'bimobject', 'bitbucket', 'bitcoin', 'bity', 'black tie', 'blackberry', 'blogger', 'blogger b', 'bluetooth', 'bluetooth b', 'btc', 'buromobelexperte', 'buysellads', 'cc amazon pay', 'cc amex', 'cc apple pay', 'cc diners club', 'cc discover', 'cc jcb', 'cc mastercard', 'cc paypal', 'cc stripe', 'cc visa', 'centercode', 'chrome', 'cloudscale', 'cloudsmith', 'cloudversify', 'codepen', 'codiepie', 'connectdevelop', 'contao', 'cpanel', 'creative commons', 'css3', 'css3 alternate', 'cuttlefish', 'd and d', 'dashcube', 'delicious', 'deploydog', 'deskpro', 'deviantart', 'digg', 'digital ocean', 'discord', 'discourse', 'dochub', 'docker', 'draft2digital', 'dribbble', 'dribbble square', 'dropbox', 'drupal', 'dyalog', 'earlybirds', 'edge', 'elementor', 'ember', 'empire', 'envira', 'erlang', 'ethereum', 'etsy', 'expeditedssl', 'facebook', 'facebook f', 'facebook messenger', 'facebook square', 'firefox', 'first order', 'firstdraft', 'flickr', 'flipboard', 'fly', 'font awesome', 'font awesome alternate', 'font awesome flag', 'fonticons', 'fonticons fi', 'fort awesome', 'fort awesome alternate', 'forumbee', 'foursquare', 'free code camp', 'freebsd', 'get pocket', 'gg', 'gg circle', 'git', 'git square', 'github', 'github alternate', 'github square', 'gitkraken', 'gitlab', 'gitter', 'glide', 'glide g', 'gofore', 'goodreads', 'goodreads g', 'google', 'google drive', 'google play', 'google plus', 'google plus g', 'google plus square', 'google wallet', 'gratipay', 'grav', 'gripfire', 'grunt', 'gulp', 'hacker news', 'hacker news square', 'hips', 'hire a helper', 'hooli', 'hotjar', 'houzz', 'html5', 'hubspot', 'imdb', 'instagram', 'internet explorer', 'ioxhost', 'itunes', 'itunes note', 'jenkins', 'joget', 'joomla', 'js', 'js square', 'jsfiddle', 'keycdn', 'kickstarter', 'kickstarter k', 'korvue', 'laravel', 'lastfm', 'lastfm square', 'leanpub', 'less', 'linechat', 'linkedin', 'linkedin alternate', 'linode', 'linux', 'lyft', 'magento', 'maxcdn', 'medapps', 'medium', 'medium m', 'medrt', 'meetup', 'microsoft', 'mix', 'mixcloud', 'mizuni', 'modx', 'monero', 'napster', 'nintendo switch', 'node', 'node js', 'npm', 'ns8', 'nutritionix', 'odnoklassniki', 'odnoklassniki square', 'opencart', 'openid', 'opera', 'optin monster', 'osi', 'page4', 'pagelines', 'palfed', 'patreon', 'paypal', 'periscope', 'phabricator', 'phoenix framework', 'php', 'pied piper', 'pied piper alternate', 'pied piper pp', 'pinterest', 'pinterest p', 'pinterest square', 'playstation', 'product hunt', 'pushed', 'python', 'qq', 'quinscape', 'quora', 'ravelry', 'react', 'rebel', 'redriver', 'reddit', 'reddit alien', 'reddit square', 'rendact', 'renren', 'replyd', 'resolving', 'rocketchat', 'rockrms', 'safari', 'sass', 'schlix', 'scribd', 'searchengin', 'sellcast', 'sellsy', 'servicestack', 'shirtsinbulk', 'simplybuilt', 'sistrix', 'skyatlas', 'skype', 'slack', 'slack hash', 'slideshare', 'snapchat', 'snapchat ghost', 'snapchat square', 'soundcloud', 'speakap', 'spotify', 'stack exchange', 'stack overflow', 'staylinked', 'steam', 'steam square', 'steam symbol', 'sticker mule', 'strava', 'stripe', 'stripe s', 'studiovinari', 'stumbleupon', 'stumbleupon circle', 'superpowers', 'supple', 'telegram', 'telegram plane', 'tencent weibo', 'themeisle', 'trello', 'tripadvisor', 'tumblr', 'tumblr square', 'twitch', 'twitter', 'twitter square', 'typo3', 'uber', 'uikit', 'uniregistry', 'untappd', 'usb', 'ussunnah', 'vaadin', 'viacoin', 'viadeo', 'viadeo square', 'viber', 'vimeo', 'vimeo square', 'vimeo v', 'vine', 'vk', 'vnv', 'vuejs', 'wechat', 'weibo', 'weixin', 'whatsapp', 'whatsapp square', 'whmcs', 'wikipedia w', 'windows', 'wordpress', 'wordpress simple', 'wpbeginner', 'wpexplorer', 'wpforms', 'xbox', 'xing', 'xing square', 'y combinator', 'yahoo', 'yandex', 'yandex international', 'yelp', 'yoast', 'youtube', 'youtube square'];
	exports.BRANDS = BRANDS;
	var ICONS = (0, _uniq2["default"])([].concat(ACCESSIBILITY, ARROWS, AUDIO_VIDEO, BUSINESS, CHESS, CODE, COMMUNICATION, COMPUTERS, CURRENCY, DATE_TIME, DESIGN, EDITORS, FILES, GENDERS, HANDS_GESTURES, HEALTH, IMAGES, INTERFACES, LOGISTICS, MAPS, MEDICAL, OBJECTS, PAYMENTS_SHOPPING, SHAPES, SPINNERS, SPORTS, STATUS, USERS_PEOPLE, VEHICLES, WRITING, BRANDS));
	exports.ICONS = ICONS;
	var ICON_ALIASES = ['chess rock', 'ordered list', 'unordered list', 'user doctor', 'shield', 'puzzle', 'add circle', 'add square', 'add to calendar', 'add to cart', 'add user', 'add', 'alarm mute', 'alarm', 'ald', 'als', 'announcement', 'area chart', 'area graph', 'arrow down cart', 'asexual', 'asl interpreting', 'asl', 'assistive listening devices', 'attach', 'attention', 'balance', 'bar', 'bathtub', 'battery four', 'battery high', 'battery low', 'battery one', 'battery three', 'battery two', 'battery zero', 'birthday', 'block layout', 'bluetooth alternative', 'broken chain', 'browser', 'call square', 'call', 'cancel', 'cart', 'cc', 'chain', 'chat', 'checked calendar', 'checkmark', 'circle notched', 'close', 'cny', 'cocktail', 'commenting', 'computer', 'configure', 'content', 'deafness', 'delete calendar', 'delete', 'detective', 'discussions', 'doctor', 'dollar', 'dont', 'drivers license', 'dropdown', 'emergency', 'envira gallery', 'erase', 'eur', 'euro', 'eyedropper', 'factory', 'favorite', 'feed', 'female homosexual', 'file text', 'file text outline', 'find', 'first aid', 'fork', 'game', 'gay', 'gbp', 'google plus circle', 'google plus official', 'grab', 'graduation', 'grid layout', 'group', 'h', 'hand victory', 'handicap', 'hard of hearing', 'header', 'help circle', 'help', 'heterosexual', 'hide', 'hotel', 'hourglass four', 'hourglass full', 'hourglass one', 'hourglass three', 'hourglass two', 'idea', 'ils', 'in cart', 'inr', 'intergender', 'intersex', 'jpy', 'krw', 'lab', 'law', 'legal', 'lesbian', 'lightning', 'like', 'line graph', 'linkedin square', 'linkify', 'lira', 'list layout', 'magnify', 'mail forward', 'mail outline', 'mail square', 'mail', 'male homosexual', 'man', 'marker', 'mars alternate', 'mars horizontal', 'mars vertical', 'microsoft edge', 'military', 'ms edge', 'mute', 'new pied piper', 'non binary transgender', 'numbered list', 'options', 'other gender horizontal', 'other gender vertical', 'other gender', 'payment', 'paypal card', 'pencil square', 'photo', 'picture', 'pie chart', 'pie graph', 'pied piper hat', 'pin', 'plus cart', 'point', 'pointing down', 'pointing left', 'pointing right', 'pointing up', 'pound', 'power cord', 'power', 'privacy', 'r circle', 'rain', 'record', 'refresh', 'remove circle', 'remove from calendar', 'remove user', 'remove', 'repeat', 'rmb', 'rouble', 'rub', 'ruble', 'rupee', 's15', 'selected radio', 'send', 'setting', 'settings', 'shekel', 'sheqel', 'shipping', 'shop', 'shuffle', 'shutdown', 'sidebar', 'signing', 'signup', 'sliders', 'soccer', 'sort alphabet ascending', 'sort alphabet descending', 'sort ascending', 'sort content ascending', 'sort content descending', 'sort descending', 'sort numeric ascending', 'sort numeric descending', 'sound', 'spy', 'stripe card', 'student', 'talk', 'target', 'teletype', 'television', 'text cursor', 'text telephone', 'theme', 'thermometer', 'thumb tack', 'time', 'tm', 'toggle down', 'toggle left', 'toggle right', 'toggle up', 'translate', 'travel', 'treatment', 'triangle down', 'triangle left', 'triangle right', 'triangle up', 'try', 'unhide', 'unlinkify', 'unmute', 'usd', 'user cancel', 'user close', 'user delete', 'user x', 'vcard', 'video camera', 'video play', 'volume control phone', 'wait', 'warning circle', 'warning sign', 'warning', 'wi-fi', 'winner', 'wizard', 'woman', 'won', 'wordpress beginner', 'wordpress forms', 'world', 'write square', 'x', 'yen', 'zip', 'zoom in', 'zoom out', 'zoom', 'bitbucket square', 'checkmark box', 'circle thin', 'cloud download', 'cloud upload', 'compose', 'conversation', 'credit card alternative', 'currency', 'dashboard', 'diamond', 'disk', 'exchange', 'external share', 'external square', 'external', 'facebook official', 'food', 'hourglass zero', 'level down', 'level up', 'log out', 'meanpath', 'money', 'move', 'pencil', 'protect', 'radio', 'remove bookmark', 'resize horizontal', 'resize vertical', 'sign in', 'sign out', 'spoon', 'star half empty', 'star half full', 'ticket', 'times rectangle', 'write', 'youtube play'];
	exports.ICON_ALIASES = ICON_ALIASES;
	var ICONS_AND_ALIASES = (0, _uniq2["default"])([].concat((0, _toConsumableArray2["default"])(ICONS), ICON_ALIASES)); // Some icon names are not part of icons.css.
	// These are only valid as children of other components.
	// Their CSS rules are defined by a specific component's CSS.
	// We don't want to show name warnings for those usages so we add them as valid names here.
	
	exports.ICONS_AND_ALIASES = ICONS_AND_ALIASES;
	var COMPONENT_CONTEXT_SPECIFIC_ICONS = ['left dropdown'];
	exports.COMPONENT_CONTEXT_SPECIFIC_ICONS = COMPONENT_CONTEXT_SPECIFIC_ICONS;
	var ALL_ICONS_IN_ALL_CONTEXTS = (0, _uniq2["default"])([].concat((0, _toConsumableArray2["default"])(ICONS_AND_ALIASES), COMPONENT_CONTEXT_SPECIFIC_ICONS));
	exports.ALL_ICONS_IN_ALL_CONTEXTS = ALL_ICONS_IN_ALL_CONTEXTS;

/***/ },
/* 7270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mergeChildMappings = exports.getChildMapping = void 0;
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
	
	var _has2 = _interopRequireDefault(__webpack_require__(119));
	
	var _keys2 = _interopRequireDefault(__webpack_require__(63));
	
	var _forEach2 = _interopRequireDefault(__webpack_require__(118));
	
	var _filter2 = _interopRequireDefault(__webpack_require__(201));
	
	var _keyBy2 = _interopRequireDefault(__webpack_require__(513));
	
	var _react = __webpack_require__(2);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {object} children Element's children
	 * @return {object} Mapping of key to child
	 */
	var getChildMapping = function getChildMapping(children) {
	  return (0, _keyBy2["default"])((0, _filter2["default"])(_react.Children.toArray(children), _react.isValidElement), 'key');
	};
	
	exports.getChildMapping = getChildMapping;
	
	var getPendingKeys = function getPendingKeys(prev, next) {
	  var nextKeysPending = {};
	  var pendingKeys = [];
	  (0, _forEach2["default"])((0, _keys2["default"])(prev), function (prevKey) {
	    if (!(0, _has2["default"])(next, prevKey)) {
	      pendingKeys.push(prevKey);
	      return;
	    }
	
	    if (pendingKeys.length) {
	      nextKeysPending[prevKey] = pendingKeys;
	      pendingKeys = [];
	    }
	  });
	  return [nextKeysPending, pendingKeys];
	};
	
	var getValue = function getValue(key, prev, next) {
	  return (0, _has2["default"])(next, key) ? next[key] : prev[key];
	};
	/**
	 * When you're adding or removing children some may be added or removed in the same render pass. We want to show *both*
	 * since we want to simultaneously animate elements in and out. This function takes a previous set of keys and a new set
	 * of keys and merges them with its best guess of the correct ordering.
	 *
	 * @param {object} prev Prev children as returned from `getChildMapping()`
	 * @param {object} next Next children as returned from `getChildMapping()`
	 * @return {object} A key set that contains all keys in `prev` and all keys in `next` in a reasonable order
	 */
	
	
	var mergeChildMappings = function mergeChildMappings() {
	  var prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var childMapping = {};
	
	  var _getPendingKeys = getPendingKeys(prev, next),
	      _getPendingKeys2 = (0, _slicedToArray2["default"])(_getPendingKeys, 2),
	      nextKeysPending = _getPendingKeys2[0],
	      pendingKeys = _getPendingKeys2[1];
	
	  (0, _forEach2["default"])((0, _keys2["default"])(next), function (nextKey) {
	    if ((0, _has2["default"])(nextKeysPending, nextKey)) {
	      (0, _forEach2["default"])(nextKeysPending[nextKey], function (pendingKey) {
	        childMapping[pendingKey] = getValue(pendingKey, prev, next);
	      });
	    }
	
	    childMapping[nextKey] = getValue(nextKey, prev, next);
	  });
	  (0, _forEach2["default"])(pendingKeys, function (pendingKey) {
	    childMapping[pendingKey] = getValue(pendingKey, prev, next);
	  });
	  return childMapping;
	};
	
	exports.mergeChildMappings = mergeChildMappings;

/***/ },
/* 7271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isNil = exports.findByType = exports.someByType = void 0;
	
	var _find2 = _interopRequireDefault(__webpack_require__(507));
	
	var _some2 = _interopRequireDefault(__webpack_require__(284));
	
	var _react = __webpack_require__(2);
	
	/**
	 * Determine if child by type exists in children.
	 * @param {Object} children The children prop of a component.
	 * @param {string|Function} type An html tag name string or React component.
	 * @returns {Boolean}
	 */
	var someByType = function someByType(children, type) {
	  return (0, _some2["default"])(_react.Children.toArray(children), {
	    type: type
	  });
	};
	/**
	 * Find child by type.
	 * @param {Object} children The children prop of a component.
	 * @param {string|Function} type An html tag name string or React component.
	 * @returns {undefined|Object}
	 */
	
	
	exports.someByType = someByType;
	
	var findByType = function findByType(children, type) {
	  return (0, _find2["default"])(_react.Children.toArray(children), {
	    type: type
	  });
	};
	/**
	 * Tests if children are nil in React and Preact.
	 * @param {Object} children The children prop of a component.
	 * @returns {Boolean}
	 */
	
	
	exports.findByType = findByType;
	
	var isNil = function isNil(children) {
	  return children === null || children === undefined || Array.isArray(children) && children.length === 0;
	};
	
	exports.isNil = isNil;

/***/ },
/* 7272 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useWidthProp = exports.useVerticalAlignProp = exports.useTextAlignProp = exports.useMultipleProp = exports.useKeyOrValueAndKey = exports.useValueAndKey = exports.useKeyOnly = void 0;
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(55));
	
	var _numberToWord = __webpack_require__(319);
	
	/*
	 * There are 3 prop patterns used to build up the className for a component.
	 * Each utility here is meant for use in a classnames() argument.
	 *
	 * There is no util for valueOnly() because it would simply return val.
	 * Use the prop value inline instead.
	 *   <Label size='big' />
	 *   <div class="ui big label"></div>
	 */
	
	/**
	 * Props where only the prop key is used in the className.
	 * @param {*} val A props value
	 * @param {string} key A props key
	 *
	 * @example
	 * <Label tag />
	 * <div class="ui tag label"></div>
	 */
	var useKeyOnly = function useKeyOnly(val, key) {
	  return val && key;
	};
	/**
	 * Props that require both a key and value to create a className.
	 * @param {*} val A props value
	 * @param {string} key A props key
	 *
	 * @example
	 * <Label corner='left' />
	 * <div class="ui left corner label"></div>
	 */
	
	
	exports.useKeyOnly = useKeyOnly;
	
	var useValueAndKey = function useValueAndKey(val, key) {
	  return val && val !== true && "".concat(val, " ").concat(key);
	};
	/**
	 * Props whose key will be used in className, or value and key.
	 * @param {*} val A props value
	 * @param {string} key A props key
	 *
	 * @example Key Only
	 * <Label pointing />
	 * <div class="ui pointing label"></div>
	 *
	 * @example Key and Value
	 * <Label pointing='left' />
	 * <div class="ui left pointing label"></div>
	 */
	
	
	exports.useValueAndKey = useValueAndKey;
	
	var useKeyOrValueAndKey = function useKeyOrValueAndKey(val, key) {
	  return val && (val === true ? key : "".concat(val, " ").concat(key));
	}; //
	// Prop to className exceptions
	//
	
	/**
	 * The "multiple" prop implements control of visibility and reserved classes for Grid subcomponents.
	 *
	 * @param {*} val The value of the "multiple" prop
	 * @param {*} key A props key
	 *
	 * @example
	 * <Grid.Row only='mobile' />
	 * <Grid.Row only='mobile tablet' />
	 * <div class="mobile only row"></div>
	 * <div class="mobile only tablet only row"></div>
	 */
	
	
	exports.useKeyOrValueAndKey = useKeyOrValueAndKey;
	
	var useMultipleProp = function useMultipleProp(val, key) {
	  if (!val || val === true) return null;
	  return val.replace('large screen', 'large-screen').replace(/ vertically/g, '-vertically').split(' ').map(function (prop) {
	    return "".concat(prop.replace('-', ' '), " ").concat(key);
	  }).join(' ');
	};
	/**
	 * The "textAlign" prop follows the useValueAndKey except when the value is "justified'.
	 * In this case, only the class "justified" is used, ignoring the "aligned" class.
	 * @param {*} val The value of the "textAlign" prop
	 *
	 * @example
	 * <Container textAlign='justified' />
	 * <div class="ui justified container"></div>
	 *
	 * @example
	 * <Container textAlign='left' />
	 * <div class="ui left aligned container"></div>
	 */
	
	
	exports.useMultipleProp = useMultipleProp;
	
	var useTextAlignProp = function useTextAlignProp(val) {
	  return val === 'justified' ? 'justified' : useValueAndKey(val, 'aligned');
	};
	/**
	 * The "verticalAlign" prop follows the useValueAndKey.
	 *
	 * @param {*} val The value of the "verticalAlign" prop
	 *
	 * @example
	 * <Grid verticalAlign='middle' />
	 * <div class="ui middle aligned grid"></div>
	 */
	
	
	exports.useTextAlignProp = useTextAlignProp;
	
	var useVerticalAlignProp = function useVerticalAlignProp(val) {
	  return useValueAndKey(val, 'aligned');
	};
	/**
	 * Create "X", "X wide" and "equal width" classNames.
	 * "X" is a numberToWord value and "wide" is configurable.
	 * @param {*} val The prop value
	 * @param {string} [widthClass=''] The class
	 * @param {boolean} [canEqual=false] Flag that indicates possibility of "equal" value
	 *
	 * @example
	 * <Grid columns='equal' />
	 * <div class="ui equal width grid"></div>
	 *
	 * <Form widths='equal' />
	 * <div class="ui equal width form"></div>
	 *
	 * <FieldGroup widths='equal' />
	 * <div class="equal width fields"></div>
	 *
	 * @example
	 * <Grid columns={4} />
	 * <div class="ui four column grid"></div>
	 */
	
	
	exports.useVerticalAlignProp = useVerticalAlignProp;
	
	var useWidthProp = function useWidthProp(val) {
	  var widthClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var canEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (canEqual && val === 'equal') {
	    return 'equal width';
	  }
	
	  var valType = (0, _typeof2["default"])(val);
	
	  if ((valType === 'string' || valType === 'number') && widthClass) {
	    return "".concat((0, _numberToWord.numberToWord)(val), " ").concat(widthClass);
	  }
	
	  return (0, _numberToWord.numberToWord)(val);
	};
	
	exports.useWidthProp = useWidthProp;

/***/ },
/* 7273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(46));
	
	var _itemFactories = __webpack_require__(740);
	
	var _rangeFactories = __webpack_require__(7276);
	
	var _paginationUtils = __webpack_require__(7275);
	
	/**
	 * @param {object} rawOptions
	 * @param {number|string} rawOptions.activePage
	 * @param {number|string} rawOptions.boundaryRange Number of always visible pages at the beginning and end.
	 * @param {boolean} rawOptions.hideEllipsis Marks if ellipsis should be hidden.
	 * @param {number|string} rawOptions.siblingRange Number of always visible pages before and after the current one.
	 * @param {number|string} rawOptions.totalPages Total number of pages.
	 */
	var createPaginationItems = function createPaginationItems(rawOptions) {
	  var options = (0, _paginationUtils.typifyOptions)(rawOptions);
	  var activePage = options.activePage,
	      totalPages = options.totalPages;
	  var pageFactory = (0, _itemFactories.createPageFactory)(activePage);
	  var innerRange = (0, _paginationUtils.isSimplePagination)(options) ? (0, _rangeFactories.createSimpleRange)(1, totalPages, pageFactory) : (0, _rangeFactories.createComplexRange)(options, pageFactory);
	  return [(0, _itemFactories.createFirstPage)(), (0, _itemFactories.createPrevItem)(activePage)].concat((0, _toConsumableArray2["default"])(innerRange), [(0, _itemFactories.createNextItem)(activePage, totalPages), (0, _itemFactories.createLastItem)(totalPages)]);
	};
	
	var _default = createPaginationItems;
	exports["default"] = _default;

/***/ },
/* 7274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _createPaginationItems["default"];
	  }
	});
	
	var _createPaginationItems = _interopRequireDefault(__webpack_require__(7273));

/***/ },
/* 7275 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.typifyOptions = exports.isSimplePagination = void 0;
	
	/**
	 * Checks the possibility of using simple range generation, if number of generated pages is equal
	 * or greater than total pages to show.
	 *
	 * @param {object} options
	 * @param {number} options.boundaryRange Number of always visible pages at the beginning and end.
	 * @param {number} options.siblingRange Number of always visible pages before and after the current one.
	 * @param {number} options.totalPages Total number of pages.
	 * @return {boolean}
	 */
	var isSimplePagination = function isSimplePagination(_ref) {
	  var boundaryRange = _ref.boundaryRange,
	      hideEllipsis = _ref.hideEllipsis,
	      siblingRange = _ref.siblingRange,
	      totalPages = _ref.totalPages;
	  var boundaryRangeSize = 2 * boundaryRange;
	  var ellipsisSize = hideEllipsis ? 0 : 2;
	  var siblingRangeSize = 2 * siblingRange;
	  return 1 + ellipsisSize + siblingRangeSize + boundaryRangeSize >= totalPages;
	};
	
	exports.isSimplePagination = isSimplePagination;
	
	var typifyOptions = function typifyOptions(_ref2) {
	  var activePage = _ref2.activePage,
	      boundaryRange = _ref2.boundaryRange,
	      hideEllipsis = _ref2.hideEllipsis,
	      siblingRange = _ref2.siblingRange,
	      totalPages = _ref2.totalPages;
	  return {
	    activePage: +activePage,
	    boundaryRange: +boundaryRange,
	    hideEllipsis: !!hideEllipsis,
	    siblingRange: +siblingRange,
	    totalPages: +totalPages
	  };
	};
	
	exports.typifyOptions = typifyOptions;

/***/ },
/* 7276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createComplexRange = exports.createSimpleRange = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(46));
	
	var _range2 = _interopRequireDefault(__webpack_require__(6933));
	
	var _map2 = _interopRequireDefault(__webpack_require__(41));
	
	var _suffixFactories = __webpack_require__(7277);
	
	var createSimpleRange = function createSimpleRange(start, end, pageFactory) {
	  return (0, _map2["default"])((0, _range2["default"])(start, end + 1), pageFactory);
	};
	
	exports.createSimpleRange = createSimpleRange;
	
	var createComplexRange = function createComplexRange(options, pageFactory) {
	  var activePage = options.activePage,
	      boundaryRange = options.boundaryRange,
	      hideEllipsis = options.hideEllipsis,
	      siblingRange = options.siblingRange,
	      totalPages = options.totalPages;
	  var ellipsisSize = hideEllipsis ? 0 : 1;
	  var firstGroupEnd = boundaryRange;
	  var firstGroup = createSimpleRange(1, firstGroupEnd, pageFactory);
	  var lastGroupStart = totalPages + 1 - boundaryRange;
	  var lastGroup = createSimpleRange(lastGroupStart, totalPages, pageFactory);
	  var innerGroupStart = Math.min(Math.max(activePage - siblingRange, firstGroupEnd + ellipsisSize + 1), lastGroupStart - ellipsisSize - 2 * siblingRange - 1);
	  var innerGroupEnd = innerGroupStart + 2 * siblingRange;
	  var innerGroup = createSimpleRange(innerGroupStart, innerGroupEnd, pageFactory);
	  return [].concat((0, _toConsumableArray2["default"])(firstGroup), [!hideEllipsis && (0, _suffixFactories.createInnerPrefix)(firstGroupEnd, innerGroupStart, pageFactory)], (0, _toConsumableArray2["default"])(innerGroup), [!hideEllipsis && (0, _suffixFactories.createInnerSuffix)(innerGroupEnd, lastGroupStart, pageFactory)], (0, _toConsumableArray2["default"])(lastGroup)).filter(Boolean);
	};
	
	exports.createComplexRange = createComplexRange;

/***/ },
/* 7277 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createInnerSuffix = exports.createInnerPrefix = void 0;
	
	var _itemFactories = __webpack_require__(740);
	
	var createInnerPrefix = function createInnerPrefix(firstGroupEnd, innerGroupStart, pageFactory) {
	  var prefixPage = innerGroupStart - 1;
	  var showEllipsis = prefixPage !== firstGroupEnd + 1;
	  var prefixFactory = showEllipsis ? _itemFactories.createEllipsisItem : pageFactory;
	  return prefixFactory(prefixPage);
	};
	
	exports.createInnerPrefix = createInnerPrefix;
	
	var createInnerSuffix = function createInnerSuffix(innerGroupEnd, lastGroupStart, pageFactory) {
	  var suffixPage = innerGroupEnd + 1;
	  var showEllipsis = suffixPage !== lastGroupStart - 1;
	  var suffixFactory = showEllipsis ? _itemFactories.createEllipsisItem : pageFactory;
	  return suffixFactory(suffixPage);
	};
	
	exports.createInnerSuffix = createInnerSuffix;

/***/ },
/* 7278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ref = exports.refObject = exports.deprecate = exports.collectionShorthand = exports.itemShorthand = exports.contentShorthand = exports.multipleProp = exports.demand = exports.givenProps = exports.some = exports.every = exports.disallow = exports.suggest = exports.domNode = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(46));
	
	var _difference2 = _interopRequireDefault(__webpack_require__(6896));
	
	var _trim2 = _interopRequireDefault(__webpack_require__(6913));
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(6902));
	
	var _pick2 = _interopRequireDefault(__webpack_require__(6907));
	
	var _keys2 = _interopRequireDefault(__webpack_require__(6904));
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(6903));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(6900));
	
	var _compact2 = _interopRequireDefault(__webpack_require__(6895));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(6901));
	
	var _take2 = _interopRequireDefault(__webpack_require__(6911));
	
	var _sortBy2 = _interopRequireDefault(__webpack_require__(6908));
	
	var _sum2 = _interopRequireDefault(__webpack_require__(6910));
	
	var _min2 = _interopRequireDefault(__webpack_require__(6906));
	
	var _map2 = _interopRequireDefault(__webpack_require__(510));
	
	var _flow2 = _interopRequireDefault(__webpack_require__(509));
	
	var _memoize2 = _interopRequireDefault(__webpack_require__(6905));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _leven = _interopRequireDefault(__webpack_require__(741));
	
	var typeOf = function typeOf() {
	  var _Object$prototype$toS;
	
	  return (_Object$prototype$toS = Object.prototype.toString).call.apply(_Object$prototype$toS, arguments);
	};
	/**
	 * Ensure a prop is a valid DOM node.
	 */
	
	
	var domNode = function domNode(props, propName) {
	  // skip if prop is undefined
	  if (props[propName] === undefined) return; // skip if prop is valid
	
	  if (props[propName] instanceof Element) return;
	  return new Error("Invalid prop \"".concat(propName, "\" supplied, expected a DOM node."));
	};
	/**
	 * Similar to PropTypes.oneOf but shows closest matches.
	 * Word order is ignored allowing `left chevron` to match `chevron left`.
	 * Useful for very large lists of options (e.g. Icon name, Flag name, etc.)
	 * @param {string[]} suggestions An array of allowed values.
	 */
	
	
	exports.domNode = domNode;
	
	var suggest = function suggest(suggestions) {
	  if (!Array.isArray(suggestions)) {
	    throw new Error('Invalid argument supplied to suggest, expected an instance of array.');
	  }
	  /* eslint-disable max-nested-callbacks */
	
	
	  var findBestSuggestions = (0, _memoize2["default"])(function (str) {
	    var propValueWords = str.split(' ');
	    return (0, _flow2["default"])((0, _map2["default"])(function (suggestion) {
	      var suggestionWords = suggestion.split(' ');
	      var propValueScore = (0, _flow2["default"])((0, _map2["default"])(function (x) {
	        return (0, _map2["default"])(function (y) {
	          return (0, _leven["default"])(x, y);
	        }, suggestionWords);
	      }), (0, _map2["default"])(_min2["default"]), _sum2["default"])(propValueWords);
	      var suggestionScore = (0, _flow2["default"])((0, _map2["default"])(function (x) {
	        return (0, _map2["default"])(function (y) {
	          return (0, _leven["default"])(x, y);
	        }, propValueWords);
	      }), (0, _map2["default"])(_min2["default"]), _sum2["default"])(suggestionWords);
	      return {
	        suggestion: suggestion,
	        score: propValueScore + suggestionScore
	      };
	    }), (0, _sortBy2["default"])(['score', 'suggestion']), (0, _take2["default"])(3))(suggestions);
	  });
	  /* eslint-enable max-nested-callbacks */
	  // Convert the suggestions list into a hash map for O(n) lookup times. Ensure
	  // the words in each key are sorted alphabetically so that we have a consistent
	  // way of looking up a value in the map, i.e. we can sort the words in the
	  // incoming propValue and look that up without having to check all permutations.
	
	  var suggestionsLookup = suggestions.reduce(function (acc, key) {
	    acc[key.split(' ').sort().join(' ')] = true;
	    return acc;
	  }, {});
	  return function (props, propName, componentName) {
	    var propValue = props[propName]; // skip if prop is undefined or is included in the suggestions
	
	    if (!propValue || suggestionsLookup[propValue]) return; // check if the words were correct but ordered differently.
	    // Since we're matching for classNames we need to allow any word order
	    // to pass validation, e.g. `left chevron` vs `chevron left`.
	
	    var propValueSorted = propValue.split(' ').sort().join(' ');
	    if (suggestionsLookup[propValueSorted]) return; // find best suggestions
	
	    var bestMatches = findBestSuggestions(propValue); // skip if a match scored 0
	
	    if (bestMatches.some(function (x) {
	      return x.score === 0;
	    })) return;
	    return new Error(["Invalid prop `".concat(propName, "` of value `").concat(propValue, "` supplied to `").concat(componentName, "`."), "\n\nInstead of `".concat(propValue, "`, did you mean:"), bestMatches.map(function (x) {
	      return "\n  - ".concat(x.suggestion);
	    }).join(''), '\n'].join(''));
	  };
	};
	/**
	 * Disallow other props from being defined with this prop.
	 * @param {string[]} disallowedProps An array of props that cannot be used with this prop.
	 */
	
	
	exports.suggest = suggest;
	
	var disallow = function disallow(disallowedProps) {
	  return function (props, propName, componentName) {
	    if (!Array.isArray(disallowedProps)) {
	      throw new Error(['Invalid argument supplied to disallow, expected an instance of array.', " See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(''));
	    } // skip if prop is undefined
	
	
	    if ((0, _isNil2["default"])(props[propName]) || props[propName] === false) return; // find disallowed props with values
	
	    var disallowed = disallowedProps.reduce(function (acc, disallowedProp) {
	      if (!(0, _isNil2["default"])(props[disallowedProp]) && props[disallowedProp] !== false) {
	        return [].concat((0, _toConsumableArray2["default"])(acc), [disallowedProp]);
	      }
	
	      return acc;
	    }, []);
	
	    if (disallowed.length > 0) {
	      return new Error(["Prop `".concat(propName, "` in `").concat(componentName, "` conflicts with props: `").concat(disallowed.join('`, `'), "`."), 'They cannot be defined together, choose one or the other.'].join(' '));
	    }
	  };
	};
	/**
	 * Ensure a prop adherers to multiple prop type validators.
	 * @param {function[]} validators An array of propType functions.
	 */
	
	
	exports.disallow = disallow;
	
	var every = function every(validators) {
	  return function (props, propName, componentName) {
	    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      rest[_key - 3] = arguments[_key];
	    }
	
	    if (!Array.isArray(validators)) {
	      throw new Error(['Invalid argument supplied to every, expected an instance of array.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
	    }
	
	    var errors = (0, _flow2["default"])((0, _map2["default"])(function (validator) {
	      if (typeof validator !== 'function') {
	        throw new Error("every() argument \"validators\" should contain functions, found: ".concat(typeOf(validator), "."));
	      }
	
	      return validator.apply(void 0, [props, propName, componentName].concat(rest));
	    }), _compact2["default"])(validators); // we can only return one error at a time
	
	    return errors[0];
	  };
	};
	/**
	 * Ensure a prop adherers to at least one of the given prop type validators.
	 * @param {function[]} validators An array of propType functions.
	 */
	
	
	exports.every = every;
	
	var some = function some(validators) {
	  return function (props, propName, componentName) {
	    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	      rest[_key2 - 3] = arguments[_key2];
	    }
	
	    if (!Array.isArray(validators)) {
	      throw new Error(['Invalid argument supplied to some, expected an instance of array.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
	    }
	
	    var errors = (0, _compact2["default"])((0, _map2["default"])(validators, function (validator) {
	      if (!(0, _isFunction2["default"])(validator)) {
	        throw new Error("some() argument \"validators\" should contain functions, found: ".concat(typeOf(validator), "."));
	      }
	
	      return validator.apply(void 0, [props, propName, componentName].concat(rest));
	    })); // fail only if all validators failed
	
	    if (errors.length === validators.length) {
	      var error = new Error('One of these validators must pass:');
	      error.message += "\n".concat((0, _map2["default"])(errors, function (err, i) {
	        return "[".concat(i + 1, "]: ").concat(err.message);
	      }).join('\n'));
	      return error;
	    }
	  };
	};
	/**
	 * Ensure a validator passes only when a component has a given propsShape.
	 * @param {object} propsShape An object describing the prop shape.
	 * @param {function} validator A propType function.
	 */
	
	
	exports.some = some;
	
	var givenProps = function givenProps(propsShape, validator) {
	  return function (props, propName, componentName) {
	    for (var _len3 = arguments.length, rest = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
	      rest[_key3 - 3] = arguments[_key3];
	    }
	
	    if (!(0, _isPlainObject2["default"])(propsShape)) {
	      throw new Error(['Invalid argument supplied to givenProps, expected an object.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
	    }
	
	    if (typeof validator !== 'function') {
	      throw new Error(['Invalid argument supplied to givenProps, expected a function.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
	    }
	
	    var shouldValidate = (0, _keys2["default"])(propsShape).every(function (key) {
	      var val = propsShape[key]; // require propShape validators to pass or prop values to match
	
	      return typeof val === 'function' ? !val.apply(void 0, [props, key, componentName].concat(rest)) : val === props[propName];
	    });
	    if (!shouldValidate) return;
	    var error = validator.apply(void 0, [props, propName, componentName].concat(rest));
	
	    if (error) {
	      // poor mans shallow pretty print, prevents JSON circular reference errors
	      var prettyProps = "{ ".concat((0, _keys2["default"])((0, _pick2["default"])((0, _keys2["default"])(propsShape), props)).map(function (key) {
	        var val = props[key];
	        var renderedValue = val;
	        if (typeof val === 'string') renderedValue = "\"".concat(val, "\"");else if (Array.isArray(val)) renderedValue = "[".concat(val.join(', '), "]");else if ((0, _isObject2["default"])(val)) renderedValue = '{...}';
	        return "".concat(key, ": ").concat(renderedValue);
	      }).join(', '), " }");
	      error.message = "Given props ".concat(prettyProps, ": ").concat(error.message);
	      return error;
	    }
	  };
	};
	/**
	 * Define prop dependencies by requiring other props.
	 * @param {string[]} requiredProps An array of required prop names.
	 */
	
	
	exports.givenProps = givenProps;
	
	var demand = function demand(requiredProps) {
	  return function (props, propName, componentName) {
	    if (!Array.isArray(requiredProps)) {
	      throw new Error(['Invalid `requiredProps` argument supplied to require, expected an instance of array.', " See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(''));
	    } // skip if prop is undefined
	
	
	    if (props[propName] === undefined) return;
	    var missingRequired = requiredProps.filter(function (requiredProp) {
	      return props[requiredProp] === undefined;
	    });
	
	    if (missingRequired.length > 0) {
	      return new Error("`".concat(propName, "` prop in `").concat(componentName, "` requires props: `").concat(missingRequired.join('`, `'), "`."));
	    }
	  };
	};
	/**
	 * Ensure an multiple prop contains a string with only possible values.
	 * @param {string[]} possible An array of possible values to prop.
	 */
	
	
	exports.demand = demand;
	
	var multipleProp = function multipleProp(possible) {
	  return function (props, propName, componentName) {
	    if (!Array.isArray(possible)) {
	      throw new Error(['Invalid argument supplied to some, expected an instance of array.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
	    }
	
	    var propValue = props[propName]; // skip if prop is undefined
	
	    if ((0, _isNil2["default"])(propValue) || propValue === false) return;
	    var values = propValue.replace('large screen', 'large-screen').replace(/ vertically/g, '-vertically').split(' ').map(function (val) {
	      return (0, _trim2["default"])(val).replace('-', ' ');
	    });
	    var invalid = (0, _difference2["default"])(values, possible); // fail only if there are invalid values
	
	    if (invalid.length > 0) {
	      return new Error("`".concat(propName, "` prop in `").concat(componentName, "` has invalid values: `").concat(invalid.join('`, `'), "`."));
	    }
	  };
	};
	/**
	 * Ensure a component can render as a node passed as a prop value in place of children.
	 */
	
	
	exports.multipleProp = multipleProp;
	
	var contentShorthand = function contentShorthand() {
	  return every([disallow(['children']), _propTypes["default"].node]).apply(void 0, arguments);
	};
	/**
	 * Item shorthand is a description of a component that can be a literal,
	 * a props object, or an element.
	 */
	
	
	exports.contentShorthand = contentShorthand;
	
	var itemShorthand = function itemShorthand() {
	  return every([disallow(['children']), _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node, _propTypes["default"].object, _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].object]))])]).apply(void 0, arguments);
	};
	/**
	 * Collection shorthand ensures a prop is an array of item shorthand.
	 */
	
	
	exports.itemShorthand = itemShorthand;
	
	var collectionShorthand = function collectionShorthand() {
	  return every([disallow(['children']), _propTypes["default"].arrayOf(itemShorthand)]).apply(void 0, arguments);
	};
	/**
	 * Show a deprecated warning for component props with a help message and optional validator.
	 * @param {string} help A help message to display with the deprecation warning.
	 * @param {function} [validator] A propType function.
	 */
	
	
	exports.collectionShorthand = collectionShorthand;
	
	var deprecate = function deprecate(help, validator) {
	  return function (props, propName, componentName) {
	    if (typeof help !== 'string') {
	      throw new Error(['Invalid `help` argument supplied to deprecate, expected a string.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
	    } // skip if prop is undefined
	
	
	    if (props[propName] === undefined) return; // deprecation error and help
	
	    var error = new Error("The `".concat(propName, "` prop in `").concat(componentName, "` is deprecated."));
	    if (help) error.message += " ".concat(help); // add optional validation error message
	
	    if (validator) {
	      if (typeof validator === 'function') {
	        for (var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
	          args[_key4 - 3] = arguments[_key4];
	        }
	
	        var validationError = validator.apply(void 0, [props, propName, componentName].concat(args));
	
	        if (validationError) {
	          error.message = "".concat(error.message, " ").concat(validationError.message);
	        }
	      } else {
	        throw new Error(['Invalid argument supplied to deprecate, expected a function.', "See `".concat(propName, "` prop in `").concat(componentName, "`.")].join(' '));
	      }
	    }
	
	    return error;
	  };
	};
	/** A checker that matches the React.RefObject type. */
	
	
	exports.deprecate = deprecate;
	
	var refObject = _propTypes["default"].shape({
	  current: _propTypes["default"].object
	});
	/** A checker that matches the React.Ref type. */
	
	
	exports.refObject = refObject;
	
	var ref = _propTypes["default"].oneOfType([_propTypes["default"].func, refObject]);
	
	exports.ref = ref;

/***/ },
/* 7279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _inRange2 = _interopRequireDefault(__webpack_require__(512));
	
	var _first3 = _interopRequireDefault(__webpack_require__(6888));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(43));
	
	var _some2 = _interopRequireDefault(__webpack_require__(284));
	
	/**
	 * Determines if a click's coordinates are within the bounds of a node.
	 *
	 * @see https://github.com/Semantic-Org/Semantic-UI-React/pull/2384
	 *
	 * @param {object} node - A DOM node.
	 * @param {object} e - A SyntheticEvent or DOM Event.
	 * @returns {boolean}
	 */
	var doesNodeContainClick = function doesNodeContainClick(node, e) {
	  if ((0, _some2["default"])([e, node], _isNil2["default"])) return false; // if there is an e.target and it is in the document, use a simple node.contains() check
	
	  if (e.target) {
	    (0, _invoke2["default"])(e.target, 'setAttribute', 'data-suir-click-target', true);
	
	    if (document.querySelector('[data-suir-click-target=true]')) {
	      (0, _invoke2["default"])(e.target, 'removeAttribute', 'data-suir-click-target');
	      return node.contains(e.target);
	    }
	  } // Below logic handles cases where the e.target is no longer in the document.
	  // The result of the click likely has removed the e.target node.
	  // Instead of node.contains(), we'll identify the click by X/Y position.
	  // return early if the event properties aren't available
	  // prevent measuring the node and repainting if we don't need to
	
	
	  var clientX = e.clientX,
	      clientY = e.clientY;
	  if ((0, _some2["default"])([clientX, clientY], _isNil2["default"])) return false; // false if the node is not visible
	
	  var clientRects = node.getClientRects(); // Heads Up!
	  // getClientRects returns a DOMRectList, not an array nor a plain object
	  // We explicitly avoid _.isEmpty and check .length to cover all possible shapes
	
	  if (!node.offsetWidth || !node.offsetHeight || !clientRects || !clientRects.length) return false; // false if the node doesn't have a valid bounding rect
	
	  var _first2 = (0, _first3["default"])(clientRects),
	      top = _first2.top,
	      bottom = _first2.bottom,
	      left = _first2.left,
	      right = _first2.right;
	
	  if ((0, _some2["default"])([top, bottom, left, right], _isNil2["default"])) return false; // we add a small decimal to the upper bound just to make it inclusive
	  // don't add an whole pixel (1) as the event/node values may be decimal sensitive
	
	  return (0, _inRange2["default"])(clientY, top, bottom + 0.001) && (0, _inRange2["default"])(clientX, left, right + 0.001);
	};
	
	var _default = doesNodeContainClick;
	exports["default"] = _default;

/***/ },
/* 7280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _eventStack = __webpack_require__(172);
	
	var _default = _eventStack.instance;
	exports["default"] = _default;

/***/ },
/* 7281 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createShorthand = createShorthand;
	exports.createShorthandFactory = createShorthandFactory;
	exports.createHTMLParagraph = exports.createHTMLLabel = exports.createHTMLInput = exports.createHTMLImage = exports.createHTMLIframe = exports.createHTMLDivision = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(55));
	
	var _uniq2 = _interopRequireDefault(__webpack_require__(286));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(35));
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(150));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(89));
	
	var _isNumber2 = _interopRequireDefault(__webpack_require__(6921));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(203));
	
	var _isBoolean2 = _interopRequireDefault(__webpack_require__(6918));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(43));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	// ============================================================
	// Factories
	// ============================================================
	
	/**
	 * A more robust React.createElement. It can create elements from primitive values.
	 *
	 * @param {function|string} Component A ReactClass or string
	 * @param {function} mapValueToProps A function that maps a primitive value to the Component props
	 * @param {string|object|function} val The value to create a ReactElement from
	 * @param {Object} [options={}]
	 * @param {object} [options.defaultProps={}] Default props object
	 * @param {object|function} [options.overrideProps={}] Override props object or function (called with regular props)
	 * @param {boolean} [options.autoGenerateKey=true] Whether or not automatic key generation is allowed
	 * @returns {object|null}
	 */
	function createShorthand(Component, mapValueToProps, val) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  if (typeof Component !== 'function' && typeof Component !== 'string') {
	    throw new Error('createShorthand() Component must be a string or function.');
	  } // short circuit noop values
	
	
	  if ((0, _isNil2["default"])(val) || (0, _isBoolean2["default"])(val)) return null;
	  var valIsString = (0, _isString2["default"])(val);
	  var valIsNumber = (0, _isNumber2["default"])(val);
	  var valIsFunction = (0, _isFunction2["default"])(val);
	  var valIsReactElement = (0, _react.isValidElement)(val);
	  var valIsPropsObject = (0, _isPlainObject2["default"])(val);
	  var valIsPrimitiveValue = valIsString || valIsNumber || (0, _isArray2["default"])(val); // unhandled type return null
	
	  /* eslint-disable no-console */
	
	  if (!valIsFunction && !valIsReactElement && !valIsPropsObject && !valIsPrimitiveValue) {
	    if (false) {
	      console.error(['Shorthand value must be a string|number|array|object|ReactElement|function.', ' Use null|undefined|boolean for none', " Received ".concat((0, _typeof2["default"])(val), ".")].join(''));
	    }
	
	    return null;
	  }
	  /* eslint-enable no-console */
	  // ----------------------------------------
	  // Build up props
	  // ----------------------------------------
	
	
	  var _options$defaultProps = options.defaultProps,
	      defaultProps = _options$defaultProps === void 0 ? {} : _options$defaultProps; // User's props
	
	  var usersProps = valIsReactElement && val.props || valIsPropsObject && val || valIsPrimitiveValue && mapValueToProps(val); // Override props
	
	  var _options$overrideProp = options.overrideProps,
	      overrideProps = _options$overrideProp === void 0 ? {} : _options$overrideProp;
	  overrideProps = (0, _isFunction2["default"])(overrideProps) ? overrideProps((0, _objectSpread2["default"])({}, defaultProps, usersProps)) : overrideProps; // Merge props
	
	  /* eslint-disable react/prop-types */
	
	  var props = (0, _objectSpread2["default"])({}, defaultProps, usersProps, overrideProps); // Merge className
	
	  if (defaultProps.className || overrideProps.className || usersProps.className) {
	    var mergedClassesNames = (0, _classnames["default"])(defaultProps.className, overrideProps.className, usersProps.className);
	    props.className = (0, _uniq2["default"])(mergedClassesNames.split(' ')).join(' ');
	  } // Merge style
	
	
	  if (defaultProps.style || overrideProps.style || usersProps.style) {
	    props.style = (0, _objectSpread2["default"])({}, defaultProps.style, usersProps.style, overrideProps.style);
	  } // ----------------------------------------
	  // Get key
	  // ----------------------------------------
	  // Use key, childKey, or generate key
	
	
	  if ((0, _isNil2["default"])(props.key)) {
	    var childKey = props.childKey;
	    var _options$autoGenerate = options.autoGenerateKey,
	        autoGenerateKey = _options$autoGenerate === void 0 ? true : _options$autoGenerate;
	
	    if (!(0, _isNil2["default"])(childKey)) {
	      // apply and consume the childKey
	      props.key = typeof childKey === 'function' ? childKey(props) : childKey;
	      delete props.childKey;
	    } else if (autoGenerateKey && (valIsString || valIsNumber)) {
	      // use string/number shorthand values as the key
	      props.key = val;
	    }
	  } // ----------------------------------------
	  // Create Element
	  // ----------------------------------------
	  // Clone ReactElements
	
	
	  if (valIsReactElement) return (0, _react.cloneElement)(val, props); // Create ReactElements from built up props
	
	  if (valIsPrimitiveValue || valIsPropsObject) return _react["default"].createElement(Component, props); // Call functions with args similar to createElement()
	
	  if (valIsFunction) return val(Component, props, props.children);
	  /* eslint-enable react/prop-types */
	} // ============================================================
	// Factory Creators
	// ============================================================
	
	/**
	 * Creates a `createShorthand` function that is waiting for a value and options.
	 *
	 * @param {function|string} Component A ReactClass or string
	 * @param {function} mapValueToProps A function that maps a primitive value to the Component props
	 * @returns {function} A shorthand factory function waiting for `val` and `defaultProps`.
	 */
	
	
	createShorthand.handledProps = [];
	
	function createShorthandFactory(Component, mapValueToProps) {
	  if (typeof Component !== 'function' && typeof Component !== 'string') {
	    throw new Error('createShorthandFactory() Component must be a string or function.');
	  }
	
	  return function (val, options) {
	    return createShorthand(Component, mapValueToProps, val, options);
	  };
	} // ============================================================
	// HTML Factories
	// ============================================================
	
	
	var createHTMLDivision = createShorthandFactory('div', function (val) {
	  return {
	    children: val
	  };
	});
	exports.createHTMLDivision = createHTMLDivision;
	var createHTMLIframe = createShorthandFactory('iframe', function (src) {
	  return {
	    src: src
	  };
	});
	exports.createHTMLIframe = createHTMLIframe;
	var createHTMLImage = createShorthandFactory('img', function (val) {
	  return {
	    src: val
	  };
	});
	exports.createHTMLImage = createHTMLImage;
	var createHTMLInput = createShorthandFactory('input', function (val) {
	  return {
	    type: val
	  };
	});
	exports.createHTMLInput = createHTMLInput;
	var createHTMLLabel = createShorthandFactory('label', function (val) {
	  return {
	    children: val
	  };
	});
	exports.createHTMLLabel = createHTMLLabel;
	var createHTMLParagraph = createShorthandFactory('p', function (val) {
	  return {
	    children: val
	  };
	});
	exports.createHTMLParagraph = createHTMLParagraph;

/***/ },
/* 7282 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	/**
	 * Returns a createElement() type based on the props of the Component.
	 * Useful for calculating what type a component should render as.
	 *
	 * @param {function} Component A function or ReactClass.
	 * @param {object} props A ReactElement props object
	 * @param {function} [getDefault] A function that returns a default element type.
	 * @returns {string|function} A ReactElement type
	 */
	function getElementType(Component, props, getDefault) {
	  var _Component$defaultPro = Component.defaultProps,
	      defaultProps = _Component$defaultPro === void 0 ? {} : _Component$defaultPro; // ----------------------------------------
	  // user defined "as" element type
	
	  if (props.as && props.as !== defaultProps.as) return props.as; // ----------------------------------------
	  // computed default element type
	
	  if (getDefault) {
	    var computedDefault = getDefault();
	    if (computedDefault) return computedDefault;
	  } // ----------------------------------------
	  // infer anchor links
	
	
	  if (props.href) return 'a'; // ----------------------------------------
	  // use defaultProp or 'div'
	
	  return defaultProps.as || 'div';
	}
	
	var _default = getElementType;
	exports["default"] = _default;

/***/ },
/* 7283 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	/**
	 * Returns an object consisting of props beyond the scope of the Component.
	 * Useful for getting and spreading unknown props from the user.
	 * @param {function} Component A function or ReactClass.
	 * @param {object} props A ReactElement props object
	 * @returns {{}} A shallow copy of the prop object
	 */
	var getUnhandledProps = function getUnhandledProps(Component, props) {
	  // Note that `handledProps` are generated automatically during build with `babel-plugin-transform-react-handled-props`
	  var _Component$handledPro = Component.handledProps,
	      handledProps = _Component$handledPro === void 0 ? [] : _Component$handledPro;
	  return Object.keys(props).reduce(function (acc, prop) {
	    if (prop === 'childKey') return acc;
	    if (handledProps.indexOf(prop) === -1) acc[prop] = props[prop];
	    return acc;
	  }, {});
	};
	
	var _default = getUnhandledProps;
	exports["default"] = _default;

/***/ },
/* 7284 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.partitionHTMLProps = exports.htmlImageProps = exports.htmlInputProps = exports.htmlInputEvents = exports.htmlInputAttrs = void 0;
	
	var _includes2 = _interopRequireDefault(__webpack_require__(88));
	
	var _forEach2 = _interopRequireDefault(__webpack_require__(118));
	
	var htmlInputAttrs = [// REACT
	'selected', 'defaultValue', 'defaultChecked', // LIMITED HTML PROPS
	'accept', 'autoCapitalize', 'autoComplete', 'autoCorrect', 'autoFocus', 'checked', 'disabled', 'form', 'id', 'lang', 'list', 'max', 'maxLength', 'min', 'minLength', 'multiple', 'name', 'pattern', 'placeholder', 'readOnly', 'required', 'step', 'title', 'type', 'value'];
	exports.htmlInputAttrs = htmlInputAttrs;
	var htmlInputEvents = [// EVENTS
	// keyboard
	'onKeyDown', 'onKeyPress', 'onKeyUp', // focus
	'onFocus', 'onBlur', // form
	'onChange', 'onInput', // mouse
	'onClick', 'onContextMenu', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', // selection
	'onSelect', // touch
	'onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart'];
	exports.htmlInputEvents = htmlInputEvents;
	var htmlInputProps = [].concat(htmlInputAttrs, htmlInputEvents);
	exports.htmlInputProps = htmlInputProps;
	var htmlImageProps = ['alt', 'height', 'src', 'srcSet', 'width'];
	/**
	 * Returns an array of objects consisting of: props of html input element and rest.
	 * @param {object} props A ReactElement props object
	 * @param {Object} [options={}]
	 * @param {Array} [options.htmlProps] An array of html input props
	 * @param {boolean} [options.includeAria] Includes all input props that starts with "aria-"
	 * @returns {[{}, {}]} An array of objects
	 */
	
	exports.htmlImageProps = htmlImageProps;
	
	var partitionHTMLProps = function partitionHTMLProps(props) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$htmlProps = options.htmlProps,
	      htmlProps = _options$htmlProps === void 0 ? htmlInputProps : _options$htmlProps,
	      _options$includeAria = options.includeAria,
	      includeAria = _options$includeAria === void 0 ? true : _options$includeAria;
	  var inputProps = {};
	  var rest = {};
	  (0, _forEach2["default"])(props, function (val, prop) {
	    var possibleAria = includeAria && (/^aria-.*$/.test(prop) || prop === 'role');
	    var target = (0, _includes2["default"])(htmlProps, prop) || possibleAria ? inputProps : rest;
	    target[prop] = val;
	  });
	  return [inputProps, rest];
	};
	
	exports.partitionHTMLProps = partitionHTMLProps;

/***/ },
/* 7285 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(55));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(43));
	
	var hasDocument = (typeof document === "undefined" ? "undefined" : (0, _typeof2["default"])(document)) === 'object' && document !== null;
	var hasWindow = (typeof window === "undefined" ? "undefined" : (0, _typeof2["default"])(window)) === 'object' && window !== null && window.self === window; // eslint-disable-next-line no-confusing-arrow
	
	var isBrowser = function isBrowser() {
	  return !(0, _isNil2["default"])(isBrowser.override) ? isBrowser.override : hasDocument && hasWindow;
	};
	
	var _default = isBrowser;
	exports["default"] = _default;

/***/ },
/* 7286 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	/**
	 * Normalizes the offset value.
	 * @param {number|array} value The value to normalize.
	 * @returns {number}
	 */
	var _default = function _default(value) {
	  return typeof value === 'number' || typeof value === 'string' ? [value, value] : value;
	};
	
	exports["default"] = _default;

/***/ },
/* 7287 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	/**
	 * Normalizes the duration of a transition.
	 * @param {number|object} duration The value to normalize.
	 * @param {'hide'|'show'} type The type of transition.
	 * @returns {number}
	 */
	var _default = function _default(duration, type) {
	  return typeof duration === 'number' || typeof duration === 'string' ? duration : duration[type];
	};
	
	exports["default"] = _default;

/***/ },
/* 7288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(280));
	
	var _has2 = _interopRequireDefault(__webpack_require__(119));
	
	var _transform2 = _interopRequireDefault(__webpack_require__(6949));
	
	/**
	 * Naive and inefficient object difference, intended for development / debugging use only.
	 * Deleted keys are shown as [DELETED].
	 * @param {{}} source The source object
	 * @param {{}} target The target object.
	 * @returns {{}} A new object containing new/modified/deleted keys.
	 * @example
	 * import { objectDiff } from 'src/lib'
	 *
	 * const a = { key: 'val', foo: 'bar' }
	 * const b = { key: 'val', foo: 'baz' }
	 *
	 * objectDiff(a, b)
	 * //=> { foo: 'baz' }
	 */
	var _default = function _default(source, target) {
	  return (0, _transform2["default"])(source, function (res, val, key) {
	    // deleted keys
	    if (!(0, _has2["default"])(target, key)) res[key] = '[DELETED]'; // new keys / changed values
	    // Note, we tolerate isEqual here as this is a dev only utility and not included in production code
	    else if (!(0, _isEqual2["default"])(val, target[key])) res[key] = target[key];
	  }, {});
	};
	
	exports["default"] = _default;

/***/ },
/* 7289 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _AccordionAccordion = _interopRequireDefault(__webpack_require__(742));
	
	var _AccordionContent = _interopRequireDefault(__webpack_require__(320));
	
	var _AccordionPanel = _interopRequireDefault(__webpack_require__(321));
	
	var _AccordionTitle = _interopRequireDefault(__webpack_require__(322));
	
	/**
	 * An accordion allows users to toggle the display of sections of content.
	 */
	function Accordion(props) {
	  var className = props.className,
	      fluid = props.fluid,
	      inverted = props.inverted,
	      styled = props.styled;
	  var classes = (0, _classnames["default"])('ui', (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(styled, 'styled'), className);
	  var rest = (0, _lib.getUnhandledProps)(Accordion, props);
	  return _react["default"].createElement(_AccordionAccordion["default"], (0, _extends2["default"])({}, rest, {
	    className: classes
	  }));
	}
	
	Accordion.handledProps = ["className", "fluid", "inverted", "styled"];
	Accordion.propTypes =  false ? {
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Format to take up the width of its container. */
	  fluid: _propTypes["default"].bool,
	
	  /** Format for dark backgrounds. */
	  inverted: _propTypes["default"].bool,
	
	  /** Adds some basic styling to accordion panels. */
	  styled: _propTypes["default"].bool
	} : {};
	Accordion.Accordion = _AccordionAccordion["default"];
	Accordion.Content = _AccordionContent["default"];
	Accordion.Panel = _AccordionPanel["default"];
	Accordion.Title = _AccordionTitle["default"];
	var _default = Accordion;
	exports["default"] = _default;

/***/ },
/* 7290 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _set2 = _interopRequireDefault(__webpack_require__(6936));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _get2 = _interopRequireDefault(__webpack_require__(72));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(43));
	
	var _reactComponentRef = __webpack_require__(52);
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A checkbox allows a user to select a value from a small set of options, often binary.
	 * @see Form
	 * @see Radio
	 */
	var Checkbox =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Checkbox, _Component);
	
	  function Checkbox() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Checkbox);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Checkbox)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "inputRef", (0, _react.createRef)());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "labelRef", (0, _react.createRef)());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "canToggle", function () {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          radio = _this$props.radio,
	          readOnly = _this$props.readOnly;
	      var checked = _this.state.checked;
	      return !disabled && !readOnly && !(radio && checked);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "computeTabIndex", function () {
	      var _this$props2 = _this.props,
	          disabled = _this$props2.disabled,
	          tabIndex = _this$props2.tabIndex;
	      if (!(0, _isNil2["default"])(tabIndex)) return tabIndex;
	      return disabled ? -1 : 0;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (e) {
	      var id = _this.props.id;
	      var _this$state = _this.state,
	          checked = _this$state.checked,
	          indeterminate = _this$state.indeterminate;
	      var isInputClick = (0, _invoke2["default"])(_this.inputRef.current, 'contains', e.target);
	      var isLabelClick = (0, _invoke2["default"])(_this.labelRef.current, 'contains', e.target);
	      var isRootClick = !isLabelClick && !isInputClick;
	      var hasId = !(0, _isNil2["default"])(id);
	      var isLabelClickAndForwardedToInput = isLabelClick && hasId; // https://github.com/Semantic-Org/Semantic-UI-React/pull/3351
	
	      if (!isLabelClickAndForwardedToInput) {
	        (0, _invoke2["default"])(_this.props, 'onClick', e, (0, _objectSpread2["default"])({}, _this.props, {
	          checked: !checked,
	          indeterminate: !!indeterminate
	        }));
	      }
	
	      if (_this.isClickFromMouse) {
	        _this.isClickFromMouse = false;
	
	        if (isLabelClick && !hasId) {
	          _this.handleChange(e);
	        } // Changes should be triggered for the slider variation
	
	
	        if (isRootClick) {
	          _this.handleChange(e);
	        }
	
	        if (isLabelClick && hasId) {
	          // To prevent two clicks from being fired from the component we have to stop the propagation
	          // from the "input" click: https://github.com/Semantic-Org/Semantic-UI-React/issues/3433
	          e.stopPropagation();
	        }
	      }
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleChange", function (e) {
	      var checked = _this.state.checked;
	      if (!_this.canToggle()) return;
	      (0, _invoke2["default"])(_this.props, 'onChange', e, (0, _objectSpread2["default"])({}, _this.props, {
	        checked: !checked,
	        indeterminate: false
	      }));
	
	      _this.trySetState({
	        checked: !checked,
	        indeterminate: false
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleMouseDown", function (e) {
	      var _this$state2 = _this.state,
	          checked = _this$state2.checked,
	          indeterminate = _this$state2.indeterminate;
	      (0, _invoke2["default"])(_this.props, 'onMouseDown', e, (0, _objectSpread2["default"])({}, _this.props, {
	        checked: !!checked,
	        indeterminate: !!indeterminate
	      }));
	
	      if (!e.defaultPrevented) {
	        (0, _invoke2["default"])(_this.inputRef.current, 'focus');
	      } // Heads up!
	      // We need to call "preventDefault" to keep element focused.
	
	
	      e.preventDefault();
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleMouseUp", function (e) {
	      var _this$state3 = _this.state,
	          checked = _this$state3.checked,
	          indeterminate = _this$state3.indeterminate;
	      _this.isClickFromMouse = true;
	      (0, _invoke2["default"])(_this.props, 'onMouseUp', e, (0, _objectSpread2["default"])({}, _this.props, {
	        checked: !!checked,
	        indeterminate: !!indeterminate
	      }));
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setIndeterminate", function () {
	      var indeterminate = _this.state.indeterminate;
	      (0, _set2["default"])(_this.inputRef, 'current.indeterminate', !!indeterminate);
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Checkbox, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setIndeterminate();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.setIndeterminate();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props3 = this.props,
	          className = _this$props3.className,
	          disabled = _this$props3.disabled,
	          label = _this$props3.label,
	          id = _this$props3.id,
	          name = _this$props3.name,
	          radio = _this$props3.radio,
	          readOnly = _this$props3.readOnly,
	          slider = _this$props3.slider,
	          toggle = _this$props3.toggle,
	          type = _this$props3.type,
	          value = _this$props3.value;
	      var _this$state4 = this.state,
	          checked = _this$state4.checked,
	          indeterminate = _this$state4.indeterminate;
	      var classes = (0, _classnames["default"])('ui', (0, _lib.useKeyOnly)(checked, 'checked'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(indeterminate, 'indeterminate'), // auto apply fitted class to compact white space when there is no label
	      // https://semantic-ui.com/modules/checkbox.html#fitted
	      (0, _lib.useKeyOnly)((0, _isNil2["default"])(label), 'fitted'), (0, _lib.useKeyOnly)(radio, 'radio'), (0, _lib.useKeyOnly)(readOnly, 'read-only'), (0, _lib.useKeyOnly)(slider, 'slider'), (0, _lib.useKeyOnly)(toggle, 'toggle'), 'checkbox', className);
	      var unhandled = (0, _lib.getUnhandledProps)(Checkbox, this.props);
	      var ElementType = (0, _lib.getElementType)(Checkbox, this.props);
	
	      var _partitionHTMLProps = (0, _lib.partitionHTMLProps)(unhandled, {
	        htmlProps: _lib.htmlInputAttrs
	      }),
	          _partitionHTMLProps2 = (0, _slicedToArray2["default"])(_partitionHTMLProps, 2),
	          htmlInputProps = _partitionHTMLProps2[0],
	          rest = _partitionHTMLProps2[1]; // Heads Up!
	      // Do not remove empty labels, they are required by SUI CSS
	
	
	      var labelElement = (0, _lib.createHTMLLabel)(label, {
	        defaultProps: {
	          htmlFor: id
	        },
	        autoGenerateKey: false
	      }) || _react["default"].createElement("label", {
	        htmlFor: id
	      });
	
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes,
	        onClick: this.handleClick,
	        onChange: this.handleChange,
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp
	      }), _react["default"].createElement(_reactComponentRef.Ref, {
	        innerRef: this.inputRef
	      }, _react["default"].createElement("input", (0, _extends2["default"])({}, htmlInputProps, {
	        checked: checked,
	        className: "hidden",
	        disabled: disabled,
	        id: id,
	        name: name,
	        readOnly: true,
	        tabIndex: this.computeTabIndex(),
	        type: type,
	        value: value
	      }))), _react["default"].createElement(_reactComponentRef.Ref, {
	        innerRef: this.labelRef
	      }, labelElement));
	    }
	  }]);
	  return Checkbox;
	}(_lib.AutoControlledComponent);
	
	exports["default"] = Checkbox;
	(0, _defineProperty2["default"])(Checkbox, "defaultProps", {
	  type: 'checkbox'
	});
	(0, _defineProperty2["default"])(Checkbox, "autoControlledProps", ['checked', 'indeterminate']);
	(0, _defineProperty2["default"])(Checkbox, "handledProps", ["as", "checked", "className", "defaultChecked", "defaultIndeterminate", "disabled", "fitted", "id", "indeterminate", "label", "name", "onChange", "onClick", "onMouseDown", "onMouseUp", "radio", "readOnly", "slider", "tabIndex", "toggle", "type", "value"]);
	Checkbox.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Whether or not checkbox is checked. */
	  checked: _propTypes["default"].bool,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** The initial value of checked. */
	  defaultChecked: _propTypes["default"].bool,
	
	  /** Whether or not checkbox is indeterminate. */
	  defaultIndeterminate: _propTypes["default"].bool,
	
	  /** A checkbox can appear disabled and be unable to change states */
	  disabled: _propTypes["default"].bool,
	
	  /** Removes padding for a label. Auto applied when there is no label. */
	  fitted: _propTypes["default"].bool,
	
	  /** A unique identifier. */
	  id: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /** Whether or not checkbox is indeterminate. */
	  indeterminate: _propTypes["default"].bool,
	
	  /** The text of the associated label element. */
	  label: _lib.customPropTypes.itemShorthand,
	
	  /** The HTML input name. */
	  name: _propTypes["default"].string,
	
	  /**
	   * Called when the user attempts to change the checked state.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and proposed checked/indeterminate state.
	   */
	  onChange: _propTypes["default"].func,
	
	  /**
	   * Called when the checkbox or label is clicked.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and current checked/indeterminate state.
	   */
	  onClick: _propTypes["default"].func,
	
	  /**
	   * Called when the user presses down on the mouse.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and current checked/indeterminate state.
	   */
	  onMouseDown: _propTypes["default"].func,
	
	  /**
	   * Called when the user releases the mouse.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and current checked/indeterminate state.
	   */
	  onMouseUp: _propTypes["default"].func,
	
	  /** Format as a radio element. This means it is an exclusive option. */
	  radio: _lib.customPropTypes.every([_propTypes["default"].bool, _lib.customPropTypes.disallow(['slider', 'toggle'])]),
	
	  /** A checkbox can be read-only and unable to change states. */
	  readOnly: _propTypes["default"].bool,
	
	  /** Format to emphasize the current selection state. */
	  slider: _lib.customPropTypes.every([_propTypes["default"].bool, _lib.customPropTypes.disallow(['radio', 'toggle'])]),
	
	  /** A checkbox can receive focus. */
	  tabIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /** Format to show an on or off choice. */
	  toggle: _lib.customPropTypes.every([_propTypes["default"].bool, _lib.customPropTypes.disallow(['radio', 'slider'])]),
	
	  /** HTML input type, either checkbox or radio. */
	  type: _propTypes["default"].oneOf(['checkbox', 'radio']),
	
	  /** The HTML input value. */
	  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
	} : {};

/***/ },
/* 7291 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Portal = _interopRequireDefault(__webpack_require__(158));
	
	var _DimmerDimmable = _interopRequireDefault(__webpack_require__(743));
	
	var _DimmerInner = _interopRequireDefault(__webpack_require__(744));
	
	/**
	 * A dimmer hides distractions to focus attention on particular content.
	 */
	var Dimmer =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Dimmer, _Component);
	
	  function Dimmer() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Dimmer);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Dimmer)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handlePortalMount", function () {
	      if (!(0, _lib.isBrowser)()) return; // Heads up, IE doesn't support second argument in add()
	
	      document.body.classList.add('dimmed');
	      document.body.classList.add('dimmable');
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handlePortalUnmount", function () {
	      if (!(0, _lib.isBrowser)()) return; // Heads up, IE doesn't support second argument in add()
	
	      document.body.classList.remove('dimmed');
	      document.body.classList.remove('dimmable');
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Dimmer, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          active = _this$props.active,
	          page = _this$props.page;
	      var rest = (0, _lib.getUnhandledProps)(Dimmer, this.props);
	
	      if (page) {
	        return _react["default"].createElement(_Portal["default"], {
	          closeOnEscape: false,
	          closeOnDocumentClick: false,
	          onMount: this.handlePortalMount,
	          onUnmount: this.handlePortalUnmount,
	          open: active,
	          openOnTriggerClick: false
	        }, _react["default"].createElement(_DimmerInner["default"], (0, _extends2["default"])({}, rest, {
	          active: active,
	          page: page
	        })));
	      }
	
	      return _react["default"].createElement(_DimmerInner["default"], (0, _extends2["default"])({}, rest, {
	        active: active,
	        page: page
	      }));
	    }
	  }]);
	  return Dimmer;
	}(_react.Component);
	
	exports["default"] = Dimmer;
	(0, _defineProperty2["default"])(Dimmer, "Dimmable", _DimmerDimmable["default"]);
	(0, _defineProperty2["default"])(Dimmer, "Inner", _DimmerInner["default"]);
	(0, _defineProperty2["default"])(Dimmer, "handledProps", ["active", "page"]);
	Dimmer.propTypes =  false ? {
	  /** An active dimmer will dim its parent container. */
	  active: _propTypes["default"].bool,
	
	  /** A dimmer can be formatted to be fixed to the page. */
	  page: _propTypes["default"].bool
	} : {};
	Dimmer.create = (0, _lib.createShorthandFactory)(Dimmer, function (value) {
	  return {
	    content: value
	  };
	});

/***/ },
/* 7292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _get3 = _interopRequireDefault(__webpack_require__(342));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _compact2 = _interopRequireDefault(__webpack_require__(503));
	
	var _map2 = _interopRequireDefault(__webpack_require__(41));
	
	var _every2 = _interopRequireDefault(__webpack_require__(6887));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _findIndex2 = _interopRequireDefault(__webpack_require__(508));
	
	var _find2 = _interopRequireDefault(__webpack_require__(507));
	
	var _reduce2 = _interopRequireDefault(__webpack_require__(206));
	
	var _some2 = _interopRequireDefault(__webpack_require__(284));
	
	var _escapeRegExp2 = _interopRequireDefault(__webpack_require__(6886));
	
	var _deburr2 = _interopRequireDefault(__webpack_require__(505));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(89));
	
	var _filter2 = _interopRequireDefault(__webpack_require__(201));
	
	var _pick2 = _interopRequireDefault(__webpack_require__(205));
	
	var _dropRight2 = _interopRequireDefault(__webpack_require__(6885));
	
	var _isEmpty2 = _interopRequireDefault(__webpack_require__(202));
	
	var _size2 = _interopRequireDefault(__webpack_require__(6937));
	
	var _difference2 = _interopRequireDefault(__webpack_require__(279));
	
	var _union2 = _interopRequireDefault(__webpack_require__(6951));
	
	var _get4 = _interopRequireDefault(__webpack_require__(72));
	
	var _includes2 = _interopRequireDefault(__webpack_require__(88));
	
	var _noop2 = _interopRequireDefault(__webpack_require__(283));
	
	var _isUndefined2 = _interopRequireDefault(__webpack_require__(204));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(280));
	
	var _has2 = _interopRequireDefault(__webpack_require__(119));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(43));
	
	var _eventStack = _interopRequireDefault(__webpack_require__(172));
	
	var _reactComponentRef = __webpack_require__(52);
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _keyboardKey = _interopRequireDefault(__webpack_require__(138));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(226));
	
	var _lib = __webpack_require__(12);
	
	var _Icon = _interopRequireDefault(__webpack_require__(54));
	
	var _Label = _interopRequireDefault(__webpack_require__(159));
	
	var _DropdownDivider = _interopRequireDefault(__webpack_require__(746));
	
	var _DropdownItem = _interopRequireDefault(__webpack_require__(748));
	
	var _DropdownHeader = _interopRequireDefault(__webpack_require__(747));
	
	var _DropdownMenu = _interopRequireDefault(__webpack_require__(749));
	
	var _DropdownSearchInput = _interopRequireDefault(__webpack_require__(750));
	
	var getKeyOrValue = function getKeyOrValue(key, value) {
	  return (0, _isNil2["default"])(key) ? value : key;
	};
	/**
	 * A dropdown allows a user to select a value from a series of options.
	 * @see Form
	 * @see Select
	 * @see Menu
	 */
	
	
	var Dropdown =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Dropdown, _Component);
	
	  function Dropdown() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Dropdown);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Dropdown)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "searchRef", (0, _react.createRef)());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "sizerRef", (0, _react.createRef)());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "ref", (0, _react.createRef)());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleChange", function (e, value) {
	      (0, _invoke2["default"])(_this.props, 'onChange', e, (0, _objectSpread2["default"])({}, _this.props, {
	        value: value
	      }));
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closeOnChange", function (e) {
	      var _this$props = _this.props,
	          closeOnChange = _this$props.closeOnChange,
	          multiple = _this$props.multiple;
	      var shouldClose = (0, _isUndefined2["default"])(closeOnChange) ? !multiple : closeOnChange;
	      if (shouldClose) _this.close(e, _noop2["default"]);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closeOnEscape", function (e) {
	      if (!_this.props.closeOnEscape) return;
	      if (_keyboardKey["default"].getCode(e) !== _keyboardKey["default"].Escape) return;
	      e.preventDefault();
	
	      _this.close(e);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "moveSelectionOnKeyDown", function (e) {
	      var _moves;
	
	      var _this$props2 = _this.props,
	          multiple = _this$props2.multiple,
	          selectOnNavigation = _this$props2.selectOnNavigation;
	      var moves = (_moves = {}, (0, _defineProperty2["default"])(_moves, _keyboardKey["default"].ArrowDown, 1), (0, _defineProperty2["default"])(_moves, _keyboardKey["default"].ArrowUp, -1), _moves);
	
	      var move = moves[_keyboardKey["default"].getCode(e)];
	
	      if (move === undefined) return;
	      e.preventDefault();
	
	      _this.moveSelectionBy(move);
	
	      if (!multiple && selectOnNavigation) _this.makeSelectedItemActive(e);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "openOnSpace", function (e) {
	      if (_keyboardKey["default"].getCode(e) !== _keyboardKey["default"].Spacebar) return;
	      e.preventDefault();
	
	      _this.open(e);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "openOnArrow", function (e) {
	      var code = _keyboardKey["default"].getCode(e);
	
	      if (!(0, _includes2["default"])([_keyboardKey["default"].ArrowDown, _keyboardKey["default"].ArrowUp], code)) return;
	      if (_this.state.open) return;
	      e.preventDefault();
	
	      _this.open(e);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "makeSelectedItemActive", function (e) {
	      var _this$state = _this.state,
	          open = _this$state.open,
	          value = _this$state.value;
	      var multiple = _this.props.multiple;
	
	      var item = _this.getSelectedItem();
	
	      var selectedValue = (0, _get4["default"])(item, 'value'); // prevent selecting null if there was no selected item value
	      // prevent selecting duplicate items when the dropdown is closed
	
	      if ((0, _isNil2["default"])(selectedValue) || !open) return; // state value may be undefined
	
	      var newValue = multiple ? (0, _union2["default"])(_this.state.value, [selectedValue]) : selectedValue;
	      var valueHasChanged = multiple ? !!(0, _difference2["default"])(newValue, value).length : newValue !== value;
	
	      if (valueHasChanged) {
	        // notify the onChange prop that the user is trying to change value
	        _this.setValue(newValue);
	
	        _this.setSelectedIndex(newValue);
	
	        _this.handleChange(e, newValue); // Heads up! This event handler should be called after `onChange`
	        // Notify the onAddItem prop if this is a new value
	
	
	        if (item['data-additional']) {
	          (0, _invoke2["default"])(_this.props, 'onAddItem', e, (0, _objectSpread2["default"])({}, _this.props, {
	            value: selectedValue
	          }));
	        }
	      }
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "selectItemOnEnter", function (e) {
	      var search = _this.props.search;
	
	      var shouldSelect = _keyboardKey["default"].getCode(e) === _keyboardKey["default"].Enter || // https://github.com/Semantic-Org/Semantic-UI-React/pull/3766
	      !search && _keyboardKey["default"].getCode(e) === _keyboardKey["default"].Spacebar;
	
	      if (!shouldSelect) return;
	      e.preventDefault();
	      var optionSize = (0, _size2["default"])(_this.getMenuOptions());
	      if (search && optionSize === 0) return;
	
	      _this.makeSelectedItemActive(e);
	
	      _this.closeOnChange(e);
	
	      _this.clearSearchQuery();
	
	      if (search) (0, _invoke2["default"])(_this.searchRef.current, 'focus');
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "removeItemOnBackspace", function (e) {
	      var _this$props3 = _this.props,
	          multiple = _this$props3.multiple,
	          search = _this$props3.search;
	      var _this$state2 = _this.state,
	          searchQuery = _this$state2.searchQuery,
	          value = _this$state2.value;
	      if (_keyboardKey["default"].getCode(e) !== _keyboardKey["default"].Backspace) return;
	      if (searchQuery || !search || !multiple || (0, _isEmpty2["default"])(value)) return;
	      e.preventDefault(); // remove most recent value
	
	      var newValue = (0, _dropRight2["default"])(value);
	
	      _this.setValue(newValue);
	
	      _this.setSelectedIndex(newValue);
	
	      _this.handleChange(e, newValue);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closeOnDocumentClick", function (e) {
	      if (!_this.props.closeOnBlur) return; // If event happened in the dropdown, ignore it
	
	      if (_this.ref.current && (0, _lib.doesNodeContainClick)(_this.ref.current, e)) return;
	
	      _this.close();
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleMouseDown", function (e) {
	      _this.isMouseDown = true;
	      (0, _invoke2["default"])(_this.props, 'onMouseDown', e, _this.props);
	      document.addEventListener('mouseup', _this.handleDocumentMouseUp);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleDocumentMouseUp", function () {
	      _this.isMouseDown = false;
	      document.removeEventListener('mouseup', _this.handleDocumentMouseUp);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (e) {
	      var _this$props4 = _this.props,
	          minCharacters = _this$props4.minCharacters,
	          search = _this$props4.search;
	      var _this$state3 = _this.state,
	          open = _this$state3.open,
	          searchQuery = _this$state3.searchQuery;
	      (0, _invoke2["default"])(_this.props, 'onClick', e, _this.props); // prevent closeOnDocumentClick()
	
	      e.stopPropagation();
	      if (!search) return _this.toggle(e);
	
	      if (open) {
	        (0, _invoke2["default"])(_this.searchRef.current, 'focus');
	        return;
	      }
	
	      if (searchQuery.length >= minCharacters || minCharacters === 1) {
	        _this.open(e);
	
	        return;
	      }
	
	      (0, _invoke2["default"])(_this.searchRef.current, 'focus');
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleIconClick", function (e) {
	      var clearable = _this.props.clearable;
	
	      var hasValue = _this.hasValue();
	
	      (0, _invoke2["default"])(_this.props, 'onClick', e, _this.props); // prevent handleClick()
	
	      e.stopPropagation();
	
	      if (clearable && hasValue) {
	        _this.clearValue(e);
	      } else {
	        _this.toggle(e);
	      }
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleItemClick", function (e, item) {
	      var _this$props5 = _this.props,
	          multiple = _this$props5.multiple,
	          search = _this$props5.search;
	      var currentValue = _this.state.value;
	      var value = item.value; // prevent toggle() in handleClick()
	
	      e.stopPropagation(); // prevent closeOnDocumentClick() if multiple or item is disabled
	
	      if (multiple || item.disabled) e.nativeEvent.stopImmediatePropagation();
	      if (item.disabled) return;
	      var isAdditionItem = item['data-additional'];
	      var newValue = multiple ? (0, _union2["default"])(_this.state.value, [value]) : value;
	      var valueHasChanged = multiple ? !!(0, _difference2["default"])(newValue, currentValue).length : newValue !== currentValue; // notify the onChange prop that the user is trying to change value
	
	      if (valueHasChanged) {
	        _this.setValue(newValue);
	
	        _this.setSelectedIndex(value);
	
	        _this.handleChange(e, newValue);
	      }
	
	      _this.clearSearchQuery(value);
	
	      if (search) {
	        (0, _invoke2["default"])(_this.searchRef.current, 'focus');
	      } else {
	        (0, _invoke2["default"])(_this.ref.current, 'focus');
	      }
	
	      _this.closeOnChange(e); // Heads up! This event handler should be called after `onChange`
	      // Notify the onAddItem prop if this is a new value
	
	
	      if (isAdditionItem) (0, _invoke2["default"])(_this.props, 'onAddItem', e, (0, _objectSpread2["default"])({}, _this.props, {
	        value: value
	      }));
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleFocus", function (e) {
	      var focus = _this.state.focus;
	      if (focus) return;
	      (0, _invoke2["default"])(_this.props, 'onFocus', e, _this.props);
	
	      _this.setState({
	        focus: true
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleBlur", function (e) {
	      // Heads up! Don't remove this.
	      // https://github.com/Semantic-Org/Semantic-UI-React/issues/1315
	      var currentTarget = (0, _get4["default"])(e, 'currentTarget');
	      if (currentTarget && currentTarget.contains(document.activeElement)) return;
	      var _this$props6 = _this.props,
	          closeOnBlur = _this$props6.closeOnBlur,
	          multiple = _this$props6.multiple,
	          selectOnBlur = _this$props6.selectOnBlur; // do not "blur" when the mouse is down inside of the Dropdown
	
	      if (_this.isMouseDown) return;
	      (0, _invoke2["default"])(_this.props, 'onBlur', e, _this.props);
	
	      if (selectOnBlur && !multiple) {
	        _this.makeSelectedItemActive(e);
	
	        if (closeOnBlur) _this.close();
	      }
	
	      _this.setState({
	        focus: false
	      });
	
	      _this.clearSearchQuery();
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleSearchChange", function (e, _ref) {
	      var value = _ref.value;
	      // prevent propagating to this.props.onChange()
	      e.stopPropagation();
	      var minCharacters = _this.props.minCharacters;
	      var open = _this.state.open;
	      var newQuery = value;
	      (0, _invoke2["default"])(_this.props, 'onSearchChange', e, (0, _objectSpread2["default"])({}, _this.props, {
	        searchQuery: newQuery
	      }));
	
	      _this.trySetState({
	        searchQuery: newQuery,
	        selectedIndex: 0
	      }); // open search dropdown on search query
	
	
	      if (!open && newQuery.length >= minCharacters) {
	        _this.open();
	
	        return;
	      } // close search dropdown if search query is too small
	
	
	      if (open && minCharacters !== 1 && newQuery.length < minCharacters) _this.close();
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getKeyAndValues", function (options) {
	      return options ? options.map(function (option) {
	        return (0, _pick2["default"])(option, ['key', 'value']);
	      }) : options;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getMenuOptions", function () {
	      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.options;
	      var searchQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.state.searchQuery;
	      var _this$props7 = _this.props,
	          additionLabel = _this$props7.additionLabel,
	          additionPosition = _this$props7.additionPosition,
	          allowAdditions = _this$props7.allowAdditions,
	          deburr = _this$props7.deburr,
	          multiple = _this$props7.multiple,
	          search = _this$props7.search;
	      var filteredOptions = options; // filter out active options
	
	      if (multiple) {
	        filteredOptions = (0, _filter2["default"])(filteredOptions, function (opt) {
	          return !(0, _includes2["default"])(value, opt.value);
	        });
	      } // filter by search query
	
	
	      if (search && searchQuery) {
	        if ((0, _isFunction2["default"])(search)) {
	          filteredOptions = search(filteredOptions, searchQuery);
	        } else {
	          // remove diacritics on search input and options, if deburr prop is set
	          var strippedQuery = deburr ? (0, _deburr2["default"])(searchQuery) : searchQuery;
	          var re = new RegExp((0, _escapeRegExp2["default"])(strippedQuery), 'i');
	          filteredOptions = (0, _filter2["default"])(filteredOptions, function (opt) {
	            return re.test(deburr ? (0, _deburr2["default"])(opt.text) : opt.text);
	          });
	        }
	      } // insert the "add" item
	
	
	      if (allowAdditions && search && searchQuery && !(0, _some2["default"])(filteredOptions, {
	        text: searchQuery
	      })) {
	        var additionLabelElement = _react["default"].isValidElement(additionLabel) ? _react["default"].cloneElement(additionLabel, {
	          key: 'addition-label'
	        }) : additionLabel || '';
	        var addItem = {
	          key: 'addition',
	          // by using an array, we can pass multiple elements, but when doing so
	          // we must specify a `key` for React to know which one is which
	          text: [additionLabelElement, _react["default"].createElement("b", {
	            key: "addition-query"
	          }, searchQuery)],
	          value: searchQuery,
	          className: 'addition',
	          'data-additional': true
	        };
	        if (additionPosition === 'top') filteredOptions.unshift(addItem);else filteredOptions.push(addItem);
	      }
	
	      return filteredOptions;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getSelectedItem", function () {
	      var selectedIndex = _this.state.selectedIndex;
	
	      var options = _this.getMenuOptions();
	
	      return (0, _get4["default"])(options, "[".concat(selectedIndex, "]"));
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getEnabledIndices", function (givenOptions) {
	      var options = givenOptions || _this.getMenuOptions();
	
	      return (0, _reduce2["default"])(options, function (memo, item, index) {
	        if (!item.disabled) memo.push(index);
	        return memo;
	      }, []);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getItemByValue", function (value) {
	      var options = _this.props.options;
	      return (0, _find2["default"])(options, {
	        value: value
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getMenuItemIndexByValue", function (value, givenOptions) {
	      var options = givenOptions || _this.getMenuOptions();
	
	      return (0, _findIndex2["default"])(options, ['value', value]);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getDropdownAriaOptions", function () {
	      var _this$props8 = _this.props,
	          loading = _this$props8.loading,
	          disabled = _this$props8.disabled,
	          search = _this$props8.search,
	          multiple = _this$props8.multiple;
	      var open = _this.state.open;
	      var ariaOptions = {
	        role: search ? 'combobox' : 'listbox',
	        'aria-busy': loading,
	        'aria-disabled': disabled,
	        'aria-expanded': !!open
	      };
	
	      if (ariaOptions.role === 'listbox') {
	        ariaOptions['aria-multiselectable'] = multiple;
	      }
	
	      return ariaOptions;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clearSearchQuery", function (value) {
	      var searchQuery = _this.state.searchQuery;
	      if (searchQuery === undefined || searchQuery === '') return;
	
	      _this.trySetState({
	        searchQuery: ''
	      });
	
	      _this.setSelectedIndex(value, undefined, '');
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setValue", function (value) {
	      _this.trySetState({
	        value: value
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setSelectedIndex", function () {
	      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
	      var optionsProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.options;
	      var searchQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.state.searchQuery;
	      var multiple = _this.props.multiple;
	      var selectedIndex = _this.state.selectedIndex;
	
	      var options = _this.getMenuOptions(value, optionsProps, searchQuery);
	
	      var enabledIndicies = _this.getEnabledIndices(options);
	
	      var newSelectedIndex; // update the selected index
	
	      if (!selectedIndex || selectedIndex < 0) {
	        var firstIndex = enabledIndicies[0]; // Select the currently active item, if none, use the first item.
	        // Multiple selects remove active items from the list,
	        // their initial selected index should be 0.
	
	        newSelectedIndex = multiple ? firstIndex : _this.getMenuItemIndexByValue(value, options) || enabledIndicies[0];
	      } else if (multiple) {
	        // multiple selects remove options from the menu as they are made active
	        // keep the selected index within range of the remaining items
	        if (selectedIndex >= options.length - 1) {
	          newSelectedIndex = enabledIndicies[enabledIndicies.length - 1];
	        }
	      } else {
	        var activeIndex = _this.getMenuItemIndexByValue(value, options); // regular selects can only have one active item
	        // set the selected index to the currently active item
	
	
	        newSelectedIndex = (0, _includes2["default"])(enabledIndicies, activeIndex) ? activeIndex : undefined;
	      }
	
	      if (!newSelectedIndex || newSelectedIndex < 0) {
	        newSelectedIndex = enabledIndicies[0];
	      }
	
	      _this.setState({
	        selectedIndex: newSelectedIndex
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleLabelClick", function (e, labelProps) {
	      // prevent focusing search input on click
	      e.stopPropagation();
	
	      _this.setState({
	        selectedLabel: labelProps.value
	      });
	
	      (0, _invoke2["default"])(_this.props, 'onLabelClick', e, labelProps);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleLabelRemove", function (e, labelProps) {
	      // prevent focusing search input on click
	      e.stopPropagation();
	      var value = _this.state.value;
	      var newValue = (0, _without2["default"])(value, labelProps.value);
	
	      _this.setValue(newValue);
	
	      _this.setSelectedIndex(newValue);
	
	      _this.handleChange(e, newValue);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "moveSelectionBy", function (offset) {
	      var startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.selectedIndex;
	
	      var options = _this.getMenuOptions(); // Prevent infinite loop
	      // TODO: remove left part of condition after children API will be removed
	
	
	      if (options === undefined || (0, _every2["default"])(options, 'disabled')) return;
	      var lastIndex = options.length - 1;
	      var wrapSelection = _this.props.wrapSelection; // next is after last, wrap to beginning
	      // next is before first, wrap to end
	
	      var nextIndex = startIndex + offset; // if 'wrapSelection' is set to false and selection is after last or before first, it just does not change
	
	      if (!wrapSelection && (nextIndex > lastIndex || nextIndex < 0)) {
	        nextIndex = startIndex;
	      } else if (nextIndex > lastIndex) nextIndex = 0;else if (nextIndex < 0) nextIndex = lastIndex;
	
	      if (options[nextIndex].disabled) {
	        _this.moveSelectionBy(offset, nextIndex);
	
	        return;
	      }
	
	      _this.setState({
	        selectedIndex: nextIndex
	      });
	
	      _this.scrollSelectedItemIntoView();
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleIconOverrides", function (predefinedProps) {
	      var clearable = _this.props.clearable;
	      var classes = (0, _classnames["default"])(clearable && _this.hasValue() && 'clear', predefinedProps.className);
	      return {
	        className: classes,
	        onClick: function onClick(e) {
	          (0, _invoke2["default"])(predefinedProps, 'onClick', e, predefinedProps);
	
	          _this.handleIconClick(e);
	        }
	      };
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "clearValue", function (e) {
	      var multiple = _this.props.multiple;
	      var newValue = multiple ? [] : '';
	
	      _this.setValue(newValue);
	
	      _this.setSelectedIndex(newValue);
	
	      _this.handleChange(e, newValue);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "computeSearchInputTabIndex", function () {
	      var _this$props9 = _this.props,
	          disabled = _this$props9.disabled,
	          tabIndex = _this$props9.tabIndex;
	      if (!(0, _isNil2["default"])(tabIndex)) return tabIndex;
	      return disabled ? -1 : 0;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "computeSearchInputWidth", function () {
	      var searchQuery = _this.state.searchQuery;
	
	      if (_this.sizerRef.current && searchQuery) {
	        // resize the search input, temporarily show the sizer so we can measure it
	        _this.sizerRef.current.style.display = 'inline';
	        _this.sizerRef.current.textContent = searchQuery;
	        var searchWidth = Math.ceil(_this.sizerRef.current.getBoundingClientRect().width);
	
	        _this.sizerRef.current.style.removeProperty('display');
	
	        return searchWidth;
	      }
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "computeTabIndex", function () {
	      var _this$props10 = _this.props,
	          disabled = _this$props10.disabled,
	          search = _this$props10.search,
	          tabIndex = _this$props10.tabIndex; // don't set a root node tabIndex as the search input has its own tabIndex
	
	      if (search) return undefined;
	      if (disabled) return -1;
	      return (0, _isNil2["default"])(tabIndex) ? 0 : tabIndex;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleSearchInputOverrides", function (predefinedProps) {
	      return {
	        onChange: function onChange(e, inputProps) {
	          (0, _invoke2["default"])(predefinedProps, 'onChange', e, inputProps);
	
	          _this.handleSearchChange(e, inputProps);
	        }
	      };
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "hasValue", function () {
	      var multiple = _this.props.multiple;
	      var value = _this.state.value;
	      return multiple ? !(0, _isEmpty2["default"])(value) : !(0, _isNil2["default"])(value) && value !== '';
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollSelectedItemIntoView", function () {
	      if (!_this.ref.current) return;
	
	      var menu = _this.ref.current.querySelector('.menu.visible');
	
	      if (!menu) return;
	      var item = menu.querySelector('.item.selected');
	      if (!item) return;
	      var isOutOfUpperView = item.offsetTop < menu.scrollTop;
	      var isOutOfLowerView = item.offsetTop + item.clientHeight > menu.scrollTop + menu.clientHeight;
	
	      if (isOutOfUpperView) {
	        menu.scrollTop = item.offsetTop;
	      } else if (isOutOfLowerView) {
	        // eslint-disable-next-line no-mixed-operators
	        menu.scrollTop = item.offsetTop + item.clientHeight - menu.clientHeight;
	      }
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setOpenDirection", function () {
	      if (!_this.ref.current) return;
	
	      var menu = _this.ref.current.querySelector('.menu.visible');
	
	      if (!menu) return;
	
	      var dropdownRect = _this.ref.current.getBoundingClientRect();
	
	      var menuHeight = menu.clientHeight;
	      var spaceAtTheBottom = document.documentElement.clientHeight - dropdownRect.top - dropdownRect.height - menuHeight;
	      var spaceAtTheTop = dropdownRect.top - menuHeight;
	      var upward = spaceAtTheBottom < 0 && spaceAtTheTop > spaceAtTheBottom; // set state only if there's a relevant difference
	
	      if (!upward !== !_this.state.upward) {
	        _this.trySetState({
	          upward: upward
	        });
	      }
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "open", function (e) {
	      var _this$props11 = _this.props,
	          disabled = _this$props11.disabled,
	          open = _this$props11.open,
	          search = _this$props11.search;
	      if (disabled) return;
	      if (search) (0, _invoke2["default"])(_this.searchRef.current, 'focus');
	      (0, _invoke2["default"])(_this.props, 'onOpen', e, _this.props);
	
	      _this.trySetState({
	        open: true
	      });
	
	      _this.scrollSelectedItemIntoView();
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "close", function (e) {
	      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.handleClose;
	      var open = _this.state.open;
	
	      if (open) {
	        (0, _invoke2["default"])(_this.props, 'onClose', e, _this.props);
	
	        _this.trySetState({
	          open: false
	        }, callback);
	      }
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClose", function () {
	      var hasSearchFocus = document.activeElement === _this.searchRef.current; // https://github.com/Semantic-Org/Semantic-UI-React/issues/627
	      // Blur the Dropdown on close so it is blurred after selecting an item.
	      // This is to prevent it from re-opening when switching tabs after selecting an item.
	
	      if (!hasSearchFocus && _this.ref.current) {
	        _this.ref.current.blur();
	      }
	
	      var hasDropdownFocus = document.activeElement === _this.ref.current;
	      var hasFocus = hasSearchFocus || hasDropdownFocus; // We need to keep the virtual model in sync with the browser focus change
	      // https://github.com/Semantic-Org/Semantic-UI-React/issues/692
	
	      _this.setState({
	        focus: hasFocus
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toggle", function (e) {
	      return _this.state.open ? _this.close(e) : _this.open(e);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderText", function () {
	      var _this$props12 = _this.props,
	          multiple = _this$props12.multiple,
	          placeholder = _this$props12.placeholder,
	          search = _this$props12.search,
	          text = _this$props12.text;
	      var _this$state4 = _this.state,
	          searchQuery = _this$state4.searchQuery,
	          value = _this$state4.value,
	          open = _this$state4.open;
	
	      var hasValue = _this.hasValue();
	
	      var classes = (0, _classnames["default"])(placeholder && !hasValue && 'default', 'text', search && searchQuery && 'filtered');
	      var _text = placeholder;
	
	      if (text) {
	        _text = text;
	      } else if (open && !multiple) {
	        _text = (0, _get4["default"])(_this.getSelectedItem(), 'text');
	      } else if (hasValue) {
	        _text = (0, _get4["default"])(_this.getItemByValue(value), 'text');
	      }
	
	      return _react["default"].createElement("div", {
	        className: classes,
	        role: "alert",
	        "aria-live": "polite",
	        "aria-atomic": true
	      }, _text);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderSearchInput", function () {
	      var _this$props13 = _this.props,
	          search = _this$props13.search,
	          searchInput = _this$props13.searchInput;
	      var searchQuery = _this.state.searchQuery;
	      return search && _react["default"].createElement(_reactComponentRef.Ref, {
	        innerRef: _this.searchRef
	      }, _DropdownSearchInput["default"].create(searchInput, {
	        defaultProps: {
	          style: {
	            width: _this.computeSearchInputWidth()
	          },
	          tabIndex: _this.computeSearchInputTabIndex(),
	          value: searchQuery
	        },
	        overrideProps: _this.handleSearchInputOverrides
	      }));
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderSearchSizer", function () {
	      var _this$props14 = _this.props,
	          search = _this$props14.search,
	          multiple = _this$props14.multiple;
	      return search && multiple && _react["default"].createElement("span", {
	        className: "sizer",
	        ref: _this.sizerRef
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderLabels", function () {
	      var _this$props15 = _this.props,
	          multiple = _this$props15.multiple,
	          renderLabel = _this$props15.renderLabel;
	      var _this$state5 = _this.state,
	          selectedLabel = _this$state5.selectedLabel,
	          value = _this$state5.value;
	
	      if (!multiple || (0, _isEmpty2["default"])(value)) {
	        return;
	      }
	
	      var selectedItems = (0, _map2["default"])(value, _this.getItemByValue);
	      // if no item could be found for a given state value the selected item will be undefined
	      // compact the selectedItems so we only have actual objects left
	      return (0, _map2["default"])((0, _compact2["default"])(selectedItems), function (item, index) {
	        var defaultProps = {
	          active: item.value === selectedLabel,
	          as: 'a',
	          key: getKeyOrValue(item.key, item.value),
	          onClick: _this.handleLabelClick,
	          onRemove: _this.handleLabelRemove,
	          value: item.value
	        };
	        return _Label["default"].create(renderLabel(item, index, defaultProps), {
	          defaultProps: defaultProps
	        });
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderOptions", function () {
	      var _this$props16 = _this.props,
	          lazyLoad = _this$props16.lazyLoad,
	          multiple = _this$props16.multiple,
	          search = _this$props16.search,
	          noResultsMessage = _this$props16.noResultsMessage;
	      var _this$state6 = _this.state,
	          open = _this$state6.open,
	          selectedIndex = _this$state6.selectedIndex,
	          value = _this$state6.value; // lazy load, only render options when open
	
	      if (lazyLoad && !open) return null;
	
	      var options = _this.getMenuOptions();
	
	      if (noResultsMessage !== null && search && (0, _isEmpty2["default"])(options)) {
	        return _react["default"].createElement("div", {
	          className: "message"
	        }, noResultsMessage);
	      }
	
	      var isActive = multiple ? function (optValue) {
	        return (0, _includes2["default"])(value, optValue);
	      } : function (optValue) {
	        return optValue === value;
	      };
	      return (0, _map2["default"])(options, function (opt, i) {
	        return _DropdownItem["default"].create((0, _objectSpread2["default"])({
	          active: isActive(opt.value),
	          onClick: _this.handleItemClick,
	          selected: selectedIndex === i
	        }, opt, {
	          key: getKeyOrValue(opt.key, opt.value),
	          // Needed for handling click events on disabled items
	          style: (0, _objectSpread2["default"])({}, opt.style, {
	            pointerEvents: 'all'
	          })
	        }));
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderMenu", function () {
	      var _this$props17 = _this.props,
	          children = _this$props17.children,
	          direction = _this$props17.direction,
	          header = _this$props17.header;
	      var open = _this.state.open;
	
	      var ariaOptions = _this.getDropdownMenuAriaOptions(); // single menu child
	
	
	      if (!_lib.childrenUtils.isNil(children)) {
	        var menuChild = _react.Children.only(children);
	
	        var className = (0, _classnames["default"])(direction, (0, _lib.useKeyOnly)(open, 'visible'), menuChild.props.className);
	        return (0, _react.cloneElement)(menuChild, (0, _objectSpread2["default"])({
	          className: className
	        }, ariaOptions));
	      }
	
	      return _react["default"].createElement(_DropdownMenu["default"], (0, _extends2["default"])({}, ariaOptions, {
	        direction: direction,
	        open: open
	      }), _DropdownHeader["default"].create(header, {
	        autoGenerateKey: false
	      }), _this.renderOptions());
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Dropdown, [{
	    key: "getInitialAutoControlledState",
	    value: function getInitialAutoControlledState() {
	      return {
	        focus: false,
	        searchQuery: ''
	      };
	    } // eslint-disable-next-line camelcase
	
	  }, {
	    key: "UNSAFE_componentWillMount",
	    value: function UNSAFE_componentWillMount() {
	      var _this$state7 = this.state,
	          open = _this$state7.open,
	          value = _this$state7.value;
	      this.setValue(value);
	      this.setSelectedIndex(value);
	
	      if (open) {
	        this.open();
	      }
	    } // eslint-disable-next-line camelcase
	
	  }, {
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      (0, _get3["default"])((0, _getPrototypeOf3["default"])(Dropdown.prototype), "UNSAFE_componentWillReceiveProps", this).call(this, nextProps);
	
	      /* eslint-disable no-console */
	      if (false) {
	        // in development, validate value type matches dropdown type
	        var isNextValueArray = Array.isArray(nextProps.value);
	        var hasValue = (0, _has2["default"])(nextProps, 'value');
	
	        if (hasValue && nextProps.multiple && !isNextValueArray) {
	          console.error('Dropdown `value` must be an array when `multiple` is set.' + " Received type: `".concat(Object.prototype.toString.call(nextProps.value), "`."));
	        } else if (hasValue && !nextProps.multiple && isNextValueArray) {
	          console.error('Dropdown `value` must not be an array when `multiple` is not set.' + ' Either set `multiple={true}` or use a string or number value.');
	        }
	      }
	      /* eslint-enable no-console */
	
	
	      if (!(0, _shallowequal["default"])(nextProps.value, this.props.value)) {
	        this.setValue(nextProps.value);
	        this.setSelectedIndex(nextProps.value);
	      } // The selected index is only dependent on option keys/values.
	      // We only check those properties to avoid recursive performance impacts.
	      // https://github.com/Semantic-Org/Semantic-UI-React/issues/3000
	
	
	      if (!(0, _isEqual2["default"])(this.getKeyAndValues(nextProps.options), this.getKeyAndValues(this.props.options))) {
	        this.setSelectedIndex(undefined, nextProps.options);
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowequal["default"])(nextProps, this.props) || !(0, _shallowequal["default"])(nextState, this.state);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      // eslint-disable-line complexity
	      var _this$props18 = this.props,
	          closeOnBlur = _this$props18.closeOnBlur,
	          minCharacters = _this$props18.minCharacters,
	          openOnFocus = _this$props18.openOnFocus,
	          search = _this$props18.search; // focused / blurred
	
	      if (!prevState.focus && this.state.focus) {
	        if (!this.isMouseDown) {
	          var openable = !search || search && minCharacters === 1 && !this.state.open;
	          if (openOnFocus && openable) this.open();
	        }
	      } else if (prevState.focus && !this.state.focus) {
	        if (!this.isMouseDown && closeOnBlur) {
	          this.close();
	        }
	      } // opened / closed
	
	
	      if (!prevState.open && this.state.open) {
	        this.setOpenDirection();
	        this.scrollSelectedItemIntoView();
	      } else if (prevState.open && !this.state.open) {}
	    } // ----------------------------------------
	    // Document Event Handlers
	    // ----------------------------------------
	    // onChange needs to receive a value
	    // can't rely on props.value if we are controlled
	
	  }, {
	    key: "getDropdownMenuAriaOptions",
	    value: function getDropdownMenuAriaOptions() {
	      var _this$props19 = this.props,
	          search = _this$props19.search,
	          multiple = _this$props19.multiple;
	      var ariaOptions = {};
	
	      if (search) {
	        ariaOptions['aria-multiselectable'] = multiple;
	        ariaOptions.role = 'listbox';
	      }
	
	      return ariaOptions;
	    } // ----------------------------------------
	    // Setters
	    // ----------------------------------------
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props20 = this.props,
	          basic = _this$props20.basic,
	          button = _this$props20.button,
	          className = _this$props20.className,
	          compact = _this$props20.compact,
	          disabled = _this$props20.disabled,
	          error = _this$props20.error,
	          fluid = _this$props20.fluid,
	          floating = _this$props20.floating,
	          icon = _this$props20.icon,
	          inline = _this$props20.inline,
	          item = _this$props20.item,
	          labeled = _this$props20.labeled,
	          loading = _this$props20.loading,
	          multiple = _this$props20.multiple,
	          pointing = _this$props20.pointing,
	          search = _this$props20.search,
	          selection = _this$props20.selection,
	          scrolling = _this$props20.scrolling,
	          simple = _this$props20.simple,
	          trigger = _this$props20.trigger;
	      var _this$state8 = this.state,
	          focus = _this$state8.focus,
	          open = _this$state8.open,
	          upward = _this$state8.upward; // Classes
	
	      var classes = (0, _classnames["default"])('ui', (0, _lib.useKeyOnly)(open, 'active visible'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(button, 'button'), (0, _lib.useKeyOnly)(compact, 'compact'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(floating, 'floating'), (0, _lib.useKeyOnly)(inline, 'inline'), // TODO: consider augmentation to render Dropdowns as Button/Menu, solves icon/link item issues
	      // https://github.com/Semantic-Org/Semantic-UI-React/issues/401#issuecomment-240487229
	      // TODO: the icon class is only required when a dropdown is a button
	      // useKeyOnly(icon, 'icon'),
	      (0, _lib.useKeyOnly)(labeled, 'labeled'), (0, _lib.useKeyOnly)(item, 'item'), (0, _lib.useKeyOnly)(multiple, 'multiple'), (0, _lib.useKeyOnly)(search, 'search'), (0, _lib.useKeyOnly)(selection, 'selection'), (0, _lib.useKeyOnly)(simple, 'simple'), (0, _lib.useKeyOnly)(scrolling, 'scrolling'), (0, _lib.useKeyOnly)(upward, 'upward'), (0, _lib.useKeyOrValueAndKey)(pointing, 'pointing'), 'dropdown', className);
	      var rest = (0, _lib.getUnhandledProps)(Dropdown, this.props);
	      var ElementType = (0, _lib.getElementType)(Dropdown, this.props);
	      var ariaOptions = this.getDropdownAriaOptions(ElementType, this.props);
	      return _react["default"].createElement(_reactComponentRef.Ref, {
	        innerRef: this.ref
	      }, _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, ariaOptions, {
	        className: classes,
	        onBlur: this.handleBlur,
	        onClick: this.handleClick,
	        onMouseDown: this.handleMouseDown,
	        onFocus: this.handleFocus,
	        onChange: this.handleChange,
	        tabIndex: this.computeTabIndex()
	      }), this.renderLabels(), this.renderSearchInput(), this.renderSearchSizer(), trigger || this.renderText(), _Icon["default"].create(icon, {
	        overrideProps: this.handleIconOverrides,
	        autoGenerateKey: false
	      }), this.renderMenu(), open && _react["default"].createElement(_eventStack["default"], {
	        name: "keydown",
	        on: this.closeOnEscape
	      }), open && _react["default"].createElement(_eventStack["default"], {
	        name: "keydown",
	        on: this.moveSelectionOnKeyDown
	      }), open && _react["default"].createElement(_eventStack["default"], {
	        name: "click",
	        on: this.closeOnDocumentClick
	      }), open && _react["default"].createElement(_eventStack["default"], {
	        name: "keydown",
	        on: this.selectItemOnEnter
	      }), focus && _react["default"].createElement(_eventStack["default"], {
	        name: "keydown",
	        on: this.removeItemOnBackspace
	      }), focus && !open && _react["default"].createElement(_eventStack["default"], {
	        name: "keydown",
	        on: this.openOnArrow
	      }), focus && !open && _react["default"].createElement(_eventStack["default"], {
	        name: "keydown",
	        on: this.openOnSpace
	      })));
	    }
	  }]);
	  return Dropdown;
	}(_lib.AutoControlledComponent);
	
	exports["default"] = Dropdown;
	(0, _defineProperty2["default"])(Dropdown, "defaultProps", {
	  additionLabel: 'Add ',
	  additionPosition: 'top',
	  closeOnBlur: true,
	  closeOnEscape: true,
	  deburr: false,
	  icon: 'dropdown',
	  minCharacters: 1,
	  noResultsMessage: 'No results found.',
	  openOnFocus: true,
	  renderLabel: function renderLabel(_ref2) {
	    var text = _ref2.text;
	    return text;
	  },
	  searchInput: 'text',
	  selectOnBlur: true,
	  selectOnNavigation: true,
	  wrapSelection: true
	});
	(0, _defineProperty2["default"])(Dropdown, "autoControlledProps", ['open', 'searchQuery', 'selectedLabel', 'value', 'upward']);
	(0, _defineProperty2["default"])(Dropdown, "Divider", _DropdownDivider["default"]);
	(0, _defineProperty2["default"])(Dropdown, "Header", _DropdownHeader["default"]);
	(0, _defineProperty2["default"])(Dropdown, "Item", _DropdownItem["default"]);
	(0, _defineProperty2["default"])(Dropdown, "Menu", _DropdownMenu["default"]);
	(0, _defineProperty2["default"])(Dropdown, "SearchInput", _DropdownSearchInput["default"]);
	(0, _defineProperty2["default"])(Dropdown, "handledProps", ["additionLabel", "additionPosition", "allowAdditions", "as", "basic", "button", "children", "className", "clearable", "closeOnBlur", "closeOnChange", "closeOnEscape", "compact", "deburr", "defaultOpen", "defaultSearchQuery", "defaultSelectedLabel", "defaultUpward", "defaultValue", "direction", "disabled", "error", "floating", "fluid", "header", "icon", "inline", "item", "labeled", "lazyLoad", "loading", "minCharacters", "multiple", "noResultsMessage", "onAddItem", "onBlur", "onChange", "onClick", "onClose", "onFocus", "onLabelClick", "onMouseDown", "onOpen", "onSearchChange", "open", "openOnFocus", "options", "placeholder", "pointing", "renderLabel", "scrolling", "search", "searchInput", "searchQuery", "selectOnBlur", "selectOnNavigation", "selectedLabel", "selection", "simple", "tabIndex", "text", "trigger", "upward", "value", "wrapSelection"]);
	Dropdown.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Label prefixed to an option added by a user. */
	  additionLabel: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string]),
	
	  /** Position of the `Add: ...` option in the dropdown list ('top' or 'bottom'). */
	  additionPosition: _propTypes["default"].oneOf(['top', 'bottom']),
	
	  /**
	   * Allow user additions to the list of options (boolean).
	   * Requires the use of `selection`, `options` and `search`.
	   */
	  allowAdditions: _lib.customPropTypes.every([_lib.customPropTypes.demand(['options', 'selection', 'search']), _propTypes["default"].bool]),
	
	  /** A Dropdown can reduce its complexity. */
	  basic: _propTypes["default"].bool,
	
	  /** Format the Dropdown to appear as a button. */
	  button: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['options', 'selection']), _lib.customPropTypes.givenProps({
	    children: _propTypes["default"].any.isRequired
	  }, _propTypes["default"].element.isRequired)]),
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Using the clearable setting will let users remove their selection from a dropdown. */
	  clearable: _propTypes["default"].bool,
	
	  /** Whether or not the menu should close when the dropdown is blurred. */
	  closeOnBlur: _propTypes["default"].bool,
	
	  /** Whether or not the dropdown should close when the escape key is pressed. */
	  closeOnEscape: _propTypes["default"].bool,
	
	  /**
	   * Whether or not the menu should close when a value is selected from the dropdown.
	   * By default, multiple selection dropdowns will remain open on change, while single
	   * selection dropdowns will close on change.
	   */
	  closeOnChange: _propTypes["default"].bool,
	
	  /** A compact dropdown has no minimum width. */
	  compact: _propTypes["default"].bool,
	
	  /** Whether or not the dropdown should strip diacritics in options and input search */
	  deburr: _propTypes["default"].bool,
	
	  /** Initial value of open. */
	  defaultOpen: _propTypes["default"].bool,
	
	  /** Initial value of searchQuery. */
	  defaultSearchQuery: _propTypes["default"].string,
	
	  /** Currently selected label in multi-select. */
	  defaultSelectedLabel: _lib.customPropTypes.every([_lib.customPropTypes.demand(['multiple']), _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])]),
	
	  /** Initial value of upward. */
	  defaultUpward: _propTypes["default"].bool,
	
	  /** Initial value or value array if multiple. */
	  defaultValue: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].bool, _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool]))]),
	
	  /** A dropdown menu can open to the left or to the right. */
	  direction: _propTypes["default"].oneOf(['left', 'right']),
	
	  /** A disabled dropdown menu or item does not allow user interaction. */
	  disabled: _propTypes["default"].bool,
	
	  /** An errored dropdown can alert a user to a problem. */
	  error: _propTypes["default"].bool,
	
	  /** A dropdown menu can contain floated content. */
	  floating: _propTypes["default"].bool,
	
	  /** A dropdown can take the full width of its parent */
	  fluid: _propTypes["default"].bool,
	
	  /** A dropdown menu can contain a header. */
	  header: _propTypes["default"].node,
	
	  /** Shorthand for Icon. */
	  icon: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].object]),
	
	  /** A dropdown can be formatted to appear inline in other content. */
	  inline: _propTypes["default"].bool,
	
	  /** A dropdown can be formatted as a Menu item. */
	  item: _propTypes["default"].bool,
	
	  /** A dropdown can be labeled. */
	  labeled: _propTypes["default"].bool,
	
	  /** A dropdown can defer rendering its options until it is open. */
	  lazyLoad: _propTypes["default"].bool,
	
	  /** A dropdown can show that it is currently loading data. */
	  loading: _propTypes["default"].bool,
	
	  /** The minimum characters for a search to begin showing results. */
	  minCharacters: _propTypes["default"].number,
	
	  /** A selection dropdown can allow multiple selections. */
	  multiple: _propTypes["default"].bool,
	
	  /** Message to display when there are no results. */
	  noResultsMessage: _propTypes["default"].node,
	
	  /**
	   * Called when a user adds a new item. Use this to update the options list.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and the new item's value.
	   */
	  onAddItem: _propTypes["default"].func,
	
	  /**
	   * Called on blur.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onBlur: _propTypes["default"].func,
	
	  /**
	   * Called when the user attempts to change the value.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and proposed value.
	   */
	  onChange: _propTypes["default"].func,
	
	  /**
	   * Called on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClick: _propTypes["default"].func,
	
	  /**
	   * Called when a close event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClose: _propTypes["default"].func,
	
	  /**
	   * Called on focus.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onFocus: _propTypes["default"].func,
	
	  /**
	   * Called when a multi-select label is clicked.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All label props.
	   */
	  onLabelClick: _propTypes["default"].func,
	
	  /**
	   * Called on mousedown.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onMouseDown: _propTypes["default"].func,
	
	  /**
	   * Called when an open event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onOpen: _propTypes["default"].func,
	
	  /**
	   * Called on search input change.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props, includes current value of searchQuery.
	   */
	  onSearchChange: _propTypes["default"].func,
	
	  /** Controls whether or not the dropdown menu is displayed. */
	  open: _propTypes["default"].bool,
	
	  /** Whether or not the menu should open when the dropdown is focused. */
	  openOnFocus: _propTypes["default"].bool,
	
	  /** Array of Dropdown.Item props e.g. `{ text: '', value: '' }` */
	  options: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _propTypes["default"].arrayOf(_propTypes["default"].shape(_DropdownItem["default"].propTypes))]),
	
	  /** Placeholder text. */
	  placeholder: _propTypes["default"].string,
	
	  /** A dropdown can be formatted so that its menu is pointing. */
	  pointing: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['left', 'right', 'top', 'top left', 'top right', 'bottom', 'bottom left', 'bottom right'])]),
	
	  /**
	   * Mapped over the active items and returns shorthand for the active item Labels.
	   * Only applies to `multiple` Dropdowns.
	   *
	   * @param {object} item - A currently active dropdown item.
	   * @param {number} index - The current index.
	   * @param {object} defaultLabelProps - The default props for an active item Label.
	   * @returns {*} Shorthand for a Label.
	   */
	  renderLabel: _propTypes["default"].func,
	
	  /** A dropdown can have its menu scroll. */
	  scrolling: _propTypes["default"].bool,
	
	  /**
	   * A selection dropdown can allow a user to search through a large list of choices.
	   * Pass a function here to replace the default search.
	   */
	  search: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func]),
	
	  /** A shorthand for a search input. */
	  searchInput: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].node, _propTypes["default"].object]),
	
	  /** Current value of searchQuery. Creates a controlled component. */
	  searchQuery: _propTypes["default"].string,
	  // TODO 'searchInMenu' or 'search='in menu' or ???  How to handle this markup and functionality?
	
	  /** Define whether the highlighted item should be selected on blur. */
	  selectOnBlur: _propTypes["default"].bool,
	
	  /**
	   * Whether or not to change the value when navigating the menu using arrow keys.
	   * Setting to false will require enter or left click to confirm a choice.
	   */
	  selectOnNavigation: _propTypes["default"].bool,
	
	  /** Currently selected label in multi-select. */
	  selectedLabel: _lib.customPropTypes.every([_lib.customPropTypes.demand(['multiple']), _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])]),
	
	  /** A dropdown can be used to select between choices in a form. */
	  selection: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['children']), _lib.customPropTypes.demand(['options']), _propTypes["default"].bool]),
	
	  /** A simple dropdown can open without Javascript. */
	  simple: _propTypes["default"].bool,
	
	  /** A dropdown can receive focus. */
	  tabIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /** The text displayed in the dropdown, usually for the active item. */
	  text: _propTypes["default"].string,
	
	  /** Custom element to trigger the menu to become visible. Takes place of 'text'. */
	  trigger: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['selection', 'text']), _propTypes["default"].node]),
	
	  /** Current value or value array if multiple. Creates a controlled component. */
	  value: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string, _propTypes["default"].number]))]),
	
	  /** Controls whether the dropdown will open upward. */
	  upward: _propTypes["default"].bool,
	
	  /**
	   * A dropdown will go to the last element when ArrowUp is pressed on the first,
	   * or go to the first when ArrowDown is pressed on the last( aka infinite selection )
	   */
	  wrapSelection: _propTypes["default"].bool
	} : {};

/***/ },
/* 7293 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Icon = _interopRequireDefault(__webpack_require__(54));
	
	/**
	 * An embed displays content from other websites like YouTube videos or Google Maps.
	 */
	var Embed =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Embed, _Component);
	
	  function Embed() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Embed);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Embed)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClick", function (e) {
	      var onClick = _this.props.onClick;
	      var active = _this.state.active;
	      if (onClick) onClick(e, (0, _objectSpread2["default"])({}, _this.props, {
	        active: true
	      }));
	      if (!active) _this.trySetState({
	        active: true
	      });
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Embed, [{
	    key: "getSrc",
	    value: function getSrc() {
	      var _this$props = this.props,
	          _this$props$autoplay = _this$props.autoplay,
	          autoplay = _this$props$autoplay === void 0 ? true : _this$props$autoplay,
	          _this$props$brandedUI = _this$props.brandedUI,
	          brandedUI = _this$props$brandedUI === void 0 ? false : _this$props$brandedUI,
	          _this$props$color = _this$props.color,
	          color = _this$props$color === void 0 ? '#444444' : _this$props$color,
	          _this$props$hd = _this$props.hd,
	          hd = _this$props$hd === void 0 ? true : _this$props$hd,
	          id = _this$props.id,
	          source = _this$props.source,
	          url = _this$props.url;
	
	      if (source === 'youtube') {
	        return ["//www.youtube.com/embed/".concat(id), '?autohide=true', "&amp;autoplay=".concat(autoplay), "&amp;color=".concat(encodeURIComponent(color)), "&amp;hq=".concat(hd), '&amp;jsapi=false', "&amp;modestbranding=".concat(brandedUI), "&amp;rel=".concat(brandedUI ? 0 : 1)].join('');
	      }
	
	      if (source === 'vimeo') {
	        return ["//player.vimeo.com/video/".concat(id), '?api=false', "&amp;autoplay=".concat(autoplay), '&amp;byline=false', "&amp;color=".concat(encodeURIComponent(color)), '&amp;portrait=false', '&amp;title=false'].join('');
	      }
	
	      return url;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          aspectRatio = _this$props2.aspectRatio,
	          className = _this$props2.className,
	          icon = _this$props2.icon,
	          placeholder = _this$props2.placeholder;
	      var active = this.state.active;
	      var classes = (0, _classnames["default"])('ui', aspectRatio, (0, _lib.useKeyOnly)(active, 'active'), 'embed', className);
	      var rest = (0, _lib.getUnhandledProps)(Embed, this.props);
	      var ElementType = (0, _lib.getElementType)(Embed, this.props);
	      var iconShorthand = icon !== undefined ? icon : 'video play';
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes,
	        onClick: this.handleClick
	      }), _Icon["default"].create(iconShorthand, {
	        autoGenerateKey: false
	      }), placeholder && _react["default"].createElement("img", {
	        className: "placeholder",
	        src: placeholder
	      }), this.renderEmbed());
	    }
	  }, {
	    key: "renderEmbed",
	    value: function renderEmbed() {
	      var _this$props3 = this.props,
	          children = _this$props3.children,
	          content = _this$props3.content,
	          iframe = _this$props3.iframe,
	          source = _this$props3.source;
	      var active = this.state.active;
	      if (!active) return null;
	      if (!_lib.childrenUtils.isNil(children)) return _react["default"].createElement("div", {
	        className: "embed"
	      }, children);
	      if (!_lib.childrenUtils.isNil(content)) return _react["default"].createElement("div", {
	        className: "embed"
	      }, content);
	      return _react["default"].createElement("div", {
	        className: "embed"
	      }, (0, _lib.createHTMLIframe)(_lib.childrenUtils.isNil(iframe) ? this.getSrc() : iframe, {
	        defaultProps: {
	          allowFullScreen: false,
	          frameBorder: 0,
	          height: '100%',
	          scrolling: 'no',
	          src: this.getSrc(),
	          title: "Embedded content from ".concat(source, "."),
	          width: '100%'
	        },
	        autoGenerateKey: false
	      }));
	    }
	  }]);
	  return Embed;
	}(_lib.AutoControlledComponent);
	
	exports["default"] = Embed;
	(0, _defineProperty2["default"])(Embed, "autoControlledProps", ['active']);
	(0, _defineProperty2["default"])(Embed, "handledProps", ["active", "as", "aspectRatio", "autoplay", "brandedUI", "children", "className", "color", "content", "defaultActive", "hd", "icon", "id", "iframe", "onClick", "placeholder", "source", "url"]);
	Embed.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** An embed can be active. */
	  active: _propTypes["default"].bool,
	
	  /** An embed can specify an alternative aspect ratio. */
	  aspectRatio: _propTypes["default"].oneOf(['4:3', '16:9', '21:9']),
	
	  /** Setting to true or false will force autoplay. */
	  autoplay: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _propTypes["default"].bool]),
	
	  /** Whether to show networks branded UI like title cards, or after video calls to action. */
	  brandedUI: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _propTypes["default"].bool]),
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Specifies a default chrome color with Vimeo or YouTube. */
	  color: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _propTypes["default"].string]),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Initial value of active. */
	  defaultActive: _propTypes["default"].bool,
	
	  /** Whether to prefer HD content. */
	  hd: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _propTypes["default"].bool]),
	
	  /** Specifies an icon to use with placeholder content. */
	  icon: _lib.customPropTypes.itemShorthand,
	
	  /** Specifies an id for source. */
	  id: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _propTypes["default"].string]),
	
	  /** Shorthand for HTML iframe. */
	  iframe: _lib.customPropTypes.every([_lib.customPropTypes.demand(['source']), _lib.customPropTypes.itemShorthand]),
	
	  /**
	   * Сalled on click.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and proposed value.
	   */
	  onClick: _propTypes["default"].func,
	
	  /** A placeholder image for embed. */
	  placeholder: _propTypes["default"].string,
	
	  /** Specifies a source to use. */
	  source: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['sourceUrl']), _propTypes["default"].oneOf(['youtube', 'vimeo'])]),
	
	  /** Specifies a url to use for embed. */
	  url: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['source']), _propTypes["default"].string])
	} : {};

/***/ },
/* 7294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Embed["default"];
	  }
	});
	
	var _Embed = _interopRequireDefault(__webpack_require__(7293));

/***/ },
/* 7295 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _pick2 = _interopRequireDefault(__webpack_require__(205));
	
	var _includes2 = _interopRequireDefault(__webpack_require__(88));
	
	var _reduce2 = _interopRequireDefault(__webpack_require__(206));
	
	var _isEmpty2 = _interopRequireDefault(__webpack_require__(202));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _reactComponentRef = __webpack_require__(52);
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(226));
	
	var _lib = __webpack_require__(12);
	
	var _Icon = _interopRequireDefault(__webpack_require__(54));
	
	var _MountNode = _interopRequireDefault(__webpack_require__(688));
	
	var _Portal = _interopRequireDefault(__webpack_require__(158));
	
	var _ModalHeader = _interopRequireDefault(__webpack_require__(754));
	
	var _ModalContent = _interopRequireDefault(__webpack_require__(752));
	
	var _ModalActions = _interopRequireDefault(__webpack_require__(751));
	
	var _ModalDescription = _interopRequireDefault(__webpack_require__(753));
	
	var _utils = __webpack_require__(7296);
	
	/**
	 * A modal displays content that temporarily blocks interactions with the main view of a site.
	 * @see Confirm
	 * @see Portal
	 */
	var Modal =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Modal, _Component);
	
	  function Modal() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Modal);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "legacy", (0, _lib.isBrowser)() && (0, _utils.isLegacy)());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "ref", (0, _react.createRef)());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "dimmerRef", (0, _react.createRef)());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "latestDocumentMouseDownEvent", null);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getMountNode", function () {
	      return (0, _lib.isBrowser)() ? _this.props.mountNode || document.body : null;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleActionsOverrides", function (predefinedProps) {
	      return {
	        onActionClick: function onActionClick(e, actionProps) {
	          (0, _invoke2["default"])(predefinedProps, 'onActionClick', e, actionProps);
	          (0, _invoke2["default"])(_this.props, 'onActionClick', e, _this.props);
	
	          _this.handleClose(e);
	        }
	      };
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClose", function (e) {
	      (0, _invoke2["default"])(_this.props, 'onClose', e, _this.props);
	
	      _this.trySetState({
	        open: false
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleDocumentMouseDown", function (e) {
	      _this.latestDocumentMouseDownEvent = e;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleDocumentClick", function (e) {
	      var closeOnDimmerClick = _this.props.closeOnDimmerClick;
	      var currentDocumentMouseDownEvent = _this.latestDocumentMouseDownEvent;
	      _this.latestDocumentMouseDownEvent = null;
	      if (!closeOnDimmerClick || (0, _lib.doesNodeContainClick)(_this.ref.current, currentDocumentMouseDownEvent) || (0, _lib.doesNodeContainClick)(_this.ref.current, e)) return;
	      (0, _invoke2["default"])(_this.props, 'onClose', e, _this.props);
	
	      _this.trySetState({
	        open: false
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleIconOverrides", function (predefinedProps) {
	      return {
	        onClick: function onClick(e) {
	          (0, _invoke2["default"])(predefinedProps, 'onClick', e);
	
	          _this.handleClose(e);
	        }
	      };
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleOpen", function (e) {
	      (0, _invoke2["default"])(_this.props, 'onOpen', e, _this.props);
	
	      _this.trySetState({
	        open: true
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handlePortalMount", function (e) {
	      var eventPool = _this.props.eventPool;
	
	      _this.setState({
	        scrolling: false
	      });
	
	      _this.setPositionAndClassNames();
	
	      _lib.eventStack.sub('mousedown', _this.handleDocumentMouseDown, {
	        pool: eventPool,
	        target: _this.dimmerRef.current
	      });
	
	      _lib.eventStack.sub('click', _this.handleDocumentClick, {
	        pool: eventPool,
	        target: _this.dimmerRef.current
	      });
	
	      (0, _invoke2["default"])(_this.props, 'onMount', e, _this.props);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handlePortalUnmount", function (e) {
	      var eventPool = _this.props.eventPool;
	      cancelAnimationFrame(_this.animationRequestId);
	
	      _lib.eventStack.unsub('mousedown', _this.handleDocumentMouseDown, {
	        pool: eventPool,
	        target: _this.dimmerRef.current
	      });
	
	      _lib.eventStack.unsub('click', _this.handleDocumentClick, {
	        pool: eventPool,
	        target: _this.dimmerRef.current
	      });
	
	      (0, _invoke2["default"])(_this.props, 'onUnmount', e, _this.props);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setDimmerNodeStyle", function () {
	      var current = _this.dimmerRef.current;
	
	      if (current && current.style && current.style.display !== 'flex') {
	        current.style.setProperty('display', 'flex', 'important');
	      }
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setPositionAndClassNames", function () {
	      var _this$props = _this.props,
	          centered = _this$props.centered,
	          dimmer = _this$props.dimmer;
	      var scrolling;
	      var newState = {};
	
	      if (_this.ref.current) {
	        var rect = _this.ref.current.getBoundingClientRect();
	
	        var isFitted = (0, _utils.canFit)(rect);
	        scrolling = !isFitted; // Styles should be computed for IE11
	
	        var legacyStyles = _this.legacy ? (0, _utils.getLegacyStyles)(isFitted, centered, rect) : {};
	
	        if (!(0, _shallowequal["default"])(_this.state.legacyStyles, legacyStyles)) {
	          newState.legacyStyles = legacyStyles;
	        }
	
	        if (_this.state.scrolling !== scrolling) {
	          newState.scrolling = scrolling;
	        }
	      }
	
	      var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(dimmer, 'dimmable dimmed'), (0, _lib.useKeyOnly)(dimmer === 'blurring', ' blurring'), (0, _lib.useKeyOnly)(scrolling, ' scrolling'));
	      if (_this.state.mountClasses !== classes) newState.mountClasses = classes;
	      if (!(0, _isEmpty2["default"])(newState)) _this.setState(newState);
	      _this.animationRequestId = requestAnimationFrame(_this.setPositionAndClassNames);
	
	      _this.setDimmerNodeStyle();
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderContent", function (rest) {
	      var _this$props2 = _this.props,
	          actions = _this$props2.actions,
	          basic = _this$props2.basic,
	          children = _this$props2.children,
	          className = _this$props2.className,
	          closeIcon = _this$props2.closeIcon,
	          content = _this$props2.content,
	          header = _this$props2.header,
	          mountNode = _this$props2.mountNode,
	          size = _this$props2.size,
	          style = _this$props2.style;
	      var _this$state = _this.state,
	          legacyStyles = _this$state.legacyStyles,
	          mountClasses = _this$state.mountClasses,
	          scrolling = _this$state.scrolling;
	      var classes = (0, _classnames["default"])('ui', size, (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(_this.legacy, 'legacy'), (0, _lib.useKeyOnly)(scrolling, 'scrolling'), 'modal transition visible active', className);
	      var ElementType = (0, _lib.getElementType)(Modal, _this.props);
	      var closeIconName = closeIcon === true ? 'close' : closeIcon;
	
	      var closeIconJSX = _Icon["default"].create(closeIconName, {
	        overrideProps: _this.handleIconOverrides
	      });
	
	      return _react["default"].createElement(_reactComponentRef.Ref, {
	        innerRef: _this.ref
	      }, _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes,
	        style: (0, _objectSpread2["default"])({}, legacyStyles, style)
	      }), _react["default"].createElement(_MountNode["default"], {
	        className: mountClasses,
	        node: mountNode
	      }), closeIconJSX, _lib.childrenUtils.isNil(children) ? _react["default"].createElement(_react.Fragment, null, _ModalHeader["default"].create(header, {
	        autoGenerateKey: false
	      }), _ModalContent["default"].create(content, {
	        autoGenerateKey: false
	      }), _ModalActions["default"].create(actions, {
	        overrideProps: _this.handleActionsOverrides
	      })) : children));
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Modal, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.handlePortalUnmount();
	    } // Do not access document when server side rendering
	
	  }, {
	    key: "render",
	    value: function render() {
	      var open = this.state.open;
	      var _this$props3 = this.props,
	          centered = _this$props3.centered,
	          closeOnDocumentClick = _this$props3.closeOnDocumentClick,
	          dimmer = _this$props3.dimmer,
	          eventPool = _this$props3.eventPool,
	          trigger = _this$props3.trigger;
	      var mountNode = this.getMountNode(); // Short circuit when server side rendering
	
	      if (!(0, _lib.isBrowser)()) {
	        return (0, _react.isValidElement)(trigger) ? trigger : null;
	      }
	
	      var unhandled = (0, _lib.getUnhandledProps)(Modal, this.props);
	      var portalPropNames = _Portal["default"].handledProps;
	      var rest = (0, _reduce2["default"])(unhandled, function (acc, val, key) {
	        if (!(0, _includes2["default"])(portalPropNames, key)) acc[key] = val;
	        return acc;
	      }, {});
	      var portalProps = (0, _pick2["default"])(unhandled, portalPropNames); // wrap dimmer modals
	
	      var dimmerClasses = (0, _classnames["default"])('ui', dimmer === 'inverted' && 'inverted', !centered && 'top aligned', 'page modals dimmer transition visible active'); // Heads up!
	      //
	      // The SUI CSS selector to prevent the modal itself from blurring requires an immediate .dimmer child:
	      // .blurring.dimmed.dimmable>:not(.dimmer) { ... }
	      //
	      // The .blurring.dimmed.dimmable is the body, so that all body content inside is blurred.
	      // We need the immediate child to be the dimmer to :not() blur the modal itself!
	      // Otherwise, the portal div is also blurred, blurring the modal.
	      //
	      // We cannot them wrap the modalJSX in an actual <Dimmer /> instead, we apply the dimmer classes to the <Portal />.
	
	      return _react["default"].createElement(_Portal["default"], (0, _extends2["default"])({
	        closeOnDocumentClick: closeOnDocumentClick
	      }, portalProps, {
	        trigger: trigger,
	        eventPool: eventPool,
	        mountNode: mountNode,
	        open: open,
	        onClose: this.handleClose,
	        onMount: this.handlePortalMount,
	        onOpen: this.handleOpen,
	        onUnmount: this.handlePortalUnmount
	      }), _react["default"].createElement("div", {
	        className: dimmerClasses,
	        ref: this.dimmerRef
	      }, this.renderContent(rest)));
	    }
	  }]);
	  return Modal;
	}(_lib.AutoControlledComponent);
	
	(0, _defineProperty2["default"])(Modal, "defaultProps", {
	  centered: true,
	  dimmer: true,
	  closeOnDimmerClick: true,
	  closeOnDocumentClick: false,
	  eventPool: 'Modal'
	});
	(0, _defineProperty2["default"])(Modal, "autoControlledProps", ['open']);
	(0, _defineProperty2["default"])(Modal, "Header", _ModalHeader["default"]);
	(0, _defineProperty2["default"])(Modal, "Content", _ModalContent["default"]);
	(0, _defineProperty2["default"])(Modal, "Description", _ModalDescription["default"]);
	(0, _defineProperty2["default"])(Modal, "Actions", _ModalActions["default"]);
	(0, _defineProperty2["default"])(Modal, "handledProps", ["actions", "as", "basic", "centered", "children", "className", "closeIcon", "closeOnDimmerClick", "closeOnDocumentClick", "content", "defaultOpen", "dimmer", "eventPool", "header", "mountNode", "onActionClick", "onClose", "onMount", "onOpen", "onUnmount", "open", "size", "style", "trigger"]);
	Modal.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Shorthand for Modal.Actions. Typically an array of button shorthand. */
	  actions: _lib.customPropTypes.itemShorthand,
	
	  /** A modal can reduce its complexity */
	  basic: _propTypes["default"].bool,
	
	  /** A modal can be vertically centered in the viewport */
	  centered: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for the close icon. Closes the modal on click. */
	  closeIcon: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].object, _propTypes["default"].bool]),
	
	  /** Whether or not the Modal should close when the dimmer is clicked. */
	  closeOnDimmerClick: _propTypes["default"].bool,
	
	  /** Whether or not the Modal should close when the document is clicked. */
	  closeOnDocumentClick: _propTypes["default"].bool,
	
	  /** Simple text content for the Modal. */
	  content: _lib.customPropTypes.itemShorthand,
	
	  /** Initial value of open. */
	  defaultOpen: _propTypes["default"].bool,
	
	  /** A Modal can appear in a dimmer. */
	  dimmer: _propTypes["default"].oneOf([true, 'inverted', 'blurring']),
	
	  /** Event pool namespace that is used to handle component events */
	  eventPool: _propTypes["default"].string,
	
	  /** Modal displayed above the content in bold. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** The node where the modal should mount. Defaults to document.body. */
	  mountNode: _propTypes["default"].any,
	
	  /**
	   * Action onClick handler when using shorthand `actions`.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onActionClick: _propTypes["default"].func,
	
	  /**
	   * Called when a close event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClose: _propTypes["default"].func,
	
	  /**
	   * Called when the portal is mounted on the DOM.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onMount: _propTypes["default"].func,
	
	  /**
	   * Called when an open event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onOpen: _propTypes["default"].func,
	
	  /**
	   * Called when the portal is unmounted from the DOM.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onUnmount: _propTypes["default"].func,
	
	  /** Controls whether or not the Modal is displayed. */
	  open: _propTypes["default"].bool,
	
	  /** A modal can vary in size */
	  size: _propTypes["default"].oneOf(['mini', 'tiny', 'small', 'large', 'fullscreen']),
	
	  /** Custom styles. */
	  style: _propTypes["default"].object,
	
	  /** Element to be rendered in-place where the portal is defined. */
	  trigger: _propTypes["default"].node
	  /**
	   * NOTE: Any unhandled props that are defined in Portal are passed-through
	   * to the wrapping Portal.
	   */
	
	} : {};
	var _default = Modal;
	exports["default"] = _default;

/***/ },
/* 7296 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isLegacy = exports.getLegacyStyles = exports.canFit = void 0;
	// https://github.com/Semantic-Org/Semantic-UI/blob/2.4.1/src/definitions/modules/modal.js#L956
	var OFFSET = 0; // https://github.com/Semantic-Org/Semantic-UI/blob/2.4.1/src/definitions/modules/modal.js#L990
	
	var PADDING = 50;
	/**
	 * Ensures that modal can fit viewport without scroll.
	 *
	 * @param modalRect {DOMRect}
	 *
	 * @see https://github.com/Semantic-Org/Semantic-UI/blob/2.4.1/src/definitions/modules/modal.js#L608
	 */
	
	var canFit = function canFit(modalRect) {
	  // original: scrollHeight = $module.prop('scrollHeight'),
	  // is replaced by .height because scrollHeight provides integer which produces glitches
	  // https://github.com/Semantic-Org/Semantic-UI-React/issues/2221
	  var scrollHeight = modalRect.height + OFFSET; // $module.outerHeight() + settings.offset
	
	  var height = modalRect.height + OFFSET; // original: $(window).height()
	
	  var contextHeight = window.innerHeight;
	  var verticalCenter = contextHeight / 2;
	  var topOffset = -(height / 2); // padding with edge of page
	
	  var paddingHeight = PADDING;
	  var startPosition = verticalCenter + topOffset; // 0
	  // original: scrollHeight > height
	  //     ? startPosition + scrollHeight + paddingHeight < contextHeight
	  //     : height + paddingHeight * 2 < contextHeight
	
	  return startPosition + scrollHeight + paddingHeight < contextHeight;
	};
	/**
	 * Creates legacy styles for IE11.
	 *
	 * @param isFitted {Boolean}
	 * @param centered {Boolean}
	 * @param modalRect {DOMRect}
	 *
	 * @see https://github.com/Semantic-Org/Semantic-UI/blob/2.4.1/src/definitions/modules/modal.js#L718
	 */
	
	
	exports.canFit = canFit;
	
	var getLegacyStyles = function getLegacyStyles(isFitted, centered, modalRect) {
	  var marginTop = centered && isFitted ? -(modalRect.height / 2) : 0;
	  var marginLeft = -(modalRect.width / 2);
	  return {
	    marginLeft: marginLeft,
	    marginTop: marginTop
	  };
	}; // https://github.com/Semantic-Org/Semantic-UI/blob/2.4.1/src/definitions/modules/modal.js#L631
	
	/* istanbul ignore next */
	
	
	exports.getLegacyStyles = getLegacyStyles;
	
	var isLegacy = function isLegacy() {
	  return !window.ActiveXObject && 'ActiveXObject' in window;
	};
	
	exports.isLegacy = isLegacy;

/***/ },
/* 7297 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(43));
	
	var _merge2 = _interopRequireDefault(__webpack_require__(6928));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(35));
	
	var _pick2 = _interopRequireDefault(__webpack_require__(205));
	
	var _includes2 = _interopRequireDefault(__webpack_require__(88));
	
	var _reduce2 = _interopRequireDefault(__webpack_require__(206));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _eventStack = _interopRequireDefault(__webpack_require__(172));
	
	var _reactComponentRef = __webpack_require__(52);
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactPopper = __webpack_require__(7323);
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(226));
	
	var _lib = __webpack_require__(12);
	
	var _Portal = _interopRequireDefault(__webpack_require__(158));
	
	var _positions = __webpack_require__(7300);
	
	var _createReferenceProxy = _interopRequireDefault(__webpack_require__(7299));
	
	var _PopupContent = _interopRequireDefault(__webpack_require__(756));
	
	var _PopupHeader = _interopRequireDefault(__webpack_require__(757));
	
	/**
	 * A Popup displays additional information on top of a page.
	 */
	var Popup =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Popup, _Component);
	
	  function Popup() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Popup);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Popup)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {});
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "open", false);
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "triggerRef", (0, _react.createRef)());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getPortalProps", function () {
	      var portalProps = {};
	      var _this$props = _this.props,
	          on = _this$props.on,
	          hoverable = _this$props.hoverable;
	      var normalizedOn = (0, _isArray2["default"])(on) ? on : [on];
	
	      if (hoverable) {
	        portalProps.closeOnPortalMouseLeave = true;
	        portalProps.mouseLeaveDelay = 300;
	      }
	
	      if ((0, _includes2["default"])(normalizedOn, 'hover')) {
	        portalProps.openOnTriggerClick = false;
	        portalProps.closeOnTriggerClick = false;
	        portalProps.openOnTriggerMouseEnter = true;
	        portalProps.closeOnTriggerMouseLeave = true; // Taken from SUI: https://git.io/vPmCm
	
	        portalProps.mouseLeaveDelay = 70;
	        portalProps.mouseEnterDelay = 50;
	      }
	
	      if ((0, _includes2["default"])(normalizedOn, 'click')) {
	        portalProps.openOnTriggerClick = true;
	        portalProps.closeOnTriggerClick = true;
	        portalProps.closeOnDocumentClick = true;
	      }
	
	      if ((0, _includes2["default"])(normalizedOn, 'focus')) {
	        portalProps.openOnTriggerFocus = true;
	        portalProps.closeOnTriggerBlur = true;
	      }
	
	      return portalProps;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "hideOnScroll", function (e) {
	      _this.setState({
	        closed: true
	      });
	
	      _lib.eventStack.unsub('scroll', _this.hideOnScroll, {
	        target: window
	      });
	
	      _this.timeoutId = setTimeout(function () {
	        _this.setState({
	          closed: false
	        });
	      }, 50);
	
	      _this.handleClose(e);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClose", function (e) {
	      (0, _invoke2["default"])(_this.props, 'onClose', e, _this.props);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleOpen", function (e) {
	      (0, _invoke2["default"])(_this.props, 'onOpen', e, _this.props);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handlePortalMount", function (e) {
	      (0, _invoke2["default"])(_this.props, 'onMount', e, _this.props);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handlePortalUnmount", function (e) {
	      _this.positionUpdate = null;
	      (0, _invoke2["default"])(_this.props, 'onUnmount', e, _this.props);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderContent", function (_ref) {
	      var popperPlacement = _ref.placement,
	          popperRef = _ref.ref,
	          scheduleUpdate = _ref.scheduleUpdate,
	          popperStyle = _ref.style;
	      var _this$props2 = _this.props,
	          basic = _this$props2.basic,
	          children = _this$props2.children,
	          className = _this$props2.className,
	          content = _this$props2.content,
	          hideOnScroll = _this$props2.hideOnScroll,
	          flowing = _this$props2.flowing,
	          header = _this$props2.header,
	          inverted = _this$props2.inverted,
	          size = _this$props2.size,
	          style = _this$props2.style,
	          wide = _this$props2.wide;
	      var contentRestProps = _this.state.contentRestProps;
	      _this.positionUpdate = scheduleUpdate;
	      var classes = (0, _classnames["default"])('ui', _positions.placementMapping[popperPlacement], size, (0, _lib.useKeyOrValueAndKey)(wide, 'wide'), (0, _lib.useKeyOnly)(basic, 'basic'), (0, _lib.useKeyOnly)(flowing, 'flowing'), (0, _lib.useKeyOnly)(inverted, 'inverted'), 'popup transition visible', className);
	      var ElementType = (0, _lib.getElementType)(Popup, _this.props);
	      var styles = (0, _objectSpread2["default"])({
	        // Heads up! We need default styles to get working correctly `flowing`
	        left: 'auto',
	        right: 'auto'
	      }, popperStyle, style);
	      return _react["default"].createElement(_reactComponentRef.Ref, {
	        innerRef: popperRef
	      }, _react["default"].createElement(ElementType, (0, _extends2["default"])({}, contentRestProps, {
	        className: classes,
	        style: styles
	      }), _lib.childrenUtils.isNil(children) ? _react["default"].createElement(_react["default"].Fragment, null, _PopupHeader["default"].create(header, {
	        autoGenerateKey: false
	      }), _PopupContent["default"].create(content, {
	        autoGenerateKey: false
	      })) : children, hideOnScroll && _react["default"].createElement(_eventStack["default"], {
	        on: _this.hideOnScroll,
	        name: "scroll",
	        target: "window"
	      })));
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Popup, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var depsEqual = (0, _shallowequal["default"])(this.props.popperDependencies, prevProps.popperDependencies);
	
	      if (!depsEqual) {
	        this.handleUpdate();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeoutId);
	    }
	  }, {
	    key: "handleUpdate",
	    value: function handleUpdate() {
	      if (this.positionUpdate) this.positionUpdate();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props3 = this.props,
	          context = _this$props3.context,
	          disabled = _this$props3.disabled,
	          eventsEnabled = _this$props3.eventsEnabled,
	          offset = _this$props3.offset,
	          pinned = _this$props3.pinned,
	          popperModifiers = _this$props3.popperModifiers,
	          position = _this$props3.position,
	          positionFixed = _this$props3.positionFixed,
	          trigger = _this$props3.trigger;
	      var _this$state = this.state,
	          closed = _this$state.closed,
	          portalRestProps = _this$state.portalRestProps;
	      if (closed || disabled) return trigger;
	      var modifiers = (0, _merge2["default"])({
	        arrow: {
	          enabled: false
	        },
	        flip: {
	          enabled: !pinned
	        },
	        // There are issues with `keepTogether` and `offset`
	        // https://github.com/FezVrasta/popper.js/issues/557
	        keepTogether: {
	          enabled: !!offset
	        },
	        offset: {
	          offset: offset
	        }
	      }, popperModifiers);
	      var referenceElement = (0, _createReferenceProxy["default"])((0, _isNil2["default"])(context) ? this.triggerRef : context);
	      var mergedPortalProps = (0, _objectSpread2["default"])({}, this.getPortalProps(), portalRestProps);
	      return _react["default"].createElement(_Portal["default"], (0, _extends2["default"])({}, mergedPortalProps, {
	        onClose: this.handleClose,
	        onMount: this.handlePortalMount,
	        onOpen: this.handleOpen,
	        onUnmount: this.handlePortalUnmount,
	        trigger: trigger,
	        triggerRef: this.triggerRef
	      }), _react["default"].createElement(_reactPopper.Popper, {
	        eventsEnabled: eventsEnabled,
	        modifiers: modifiers,
	        placement: _positions.positionsMapping[position],
	        positionFixed: positionFixed,
	        referenceElement: referenceElement
	      }, this.renderContent));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(props, state) {
	      if (state.closed || state.disabled) return {};
	      var unhandledProps = (0, _lib.getUnhandledProps)(Popup, props);
	      var contentRestProps = (0, _reduce2["default"])(unhandledProps, function (acc, val, key) {
	        if (!(0, _includes2["default"])(_Portal["default"].handledProps, key)) acc[key] = val;
	        return acc;
	      }, {});
	      var portalRestProps = (0, _pick2["default"])(unhandledProps, _Portal["default"].handledProps);
	      return {
	        contentRestProps: contentRestProps,
	        portalRestProps: portalRestProps
	      };
	    }
	  }]);
	  return Popup;
	}(_react.Component);
	
	exports["default"] = Popup;
	(0, _defineProperty2["default"])(Popup, "defaultProps", {
	  disabled: false,
	  eventsEnabled: true,
	  offset: 0,
	  on: ['click', 'hover'],
	  pinned: false,
	  position: 'top left'
	});
	(0, _defineProperty2["default"])(Popup, "Content", _PopupContent["default"]);
	(0, _defineProperty2["default"])(Popup, "Header", _PopupHeader["default"]);
	(0, _defineProperty2["default"])(Popup, "handledProps", ["as", "basic", "children", "className", "content", "context", "disabled", "eventsEnabled", "flowing", "header", "hideOnScroll", "hoverable", "inverted", "offset", "on", "onClose", "onMount", "onOpen", "onUnmount", "pinned", "popperDependencies", "popperModifiers", "position", "positionFixed", "size", "style", "trigger", "wide"]);
	Popup.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Display the popup without the pointing arrow. */
	  basic: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Simple text content for the popover. */
	  content: _lib.customPropTypes.itemShorthand,
	
	  /** Existing element the pop-up should be bound to. */
	  context: _propTypes["default"].oneOfType([_propTypes["default"].object, _lib.customPropTypes.refObject]),
	
	  /** A disabled popup only renders its trigger. */
	  disabled: _propTypes["default"].bool,
	
	  /** Enables the Popper.js event listeners. */
	  eventsEnabled: _propTypes["default"].bool,
	
	  /** A flowing Popup has no maximum width and continues to flow to fit its content. */
	  flowing: _propTypes["default"].bool,
	
	  /** Takes up the entire width of its offset container. */
	  // TODO: implement the Popup fluid layout
	  // fluid: PropTypes.bool,
	
	  /** Header displayed above the content in bold. */
	  header: _lib.customPropTypes.itemShorthand,
	
	  /** Hide the Popup when scrolling the window. */
	  hideOnScroll: _propTypes["default"].bool,
	
	  /** Whether the popup should not close on hover. */
	  hoverable: _propTypes["default"].bool,
	
	  /** Invert the colors of the Popup. */
	  inverted: _propTypes["default"].bool,
	
	  /** Offset value to apply to rendered popup. Accepts the following units:
	   * - px or unit-less, interpreted as pixels
	   * - %, percentage relative to the length of the trigger element
	   * - %p, percentage relative to the length of the popup element
	   * - vw, CSS viewport width unit
	   * - vh, CSS viewport height unit
	   */
	  offset: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /** Events triggering the popup. */
	  on: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['hover', 'click', 'focus']), _propTypes["default"].arrayOf(_propTypes["default"].oneOf(['hover', 'click', 'focus']))]),
	
	  /**
	   * Called when a close event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onClose: _propTypes["default"].func,
	
	  /**
	   * Called when the portal is mounted on the DOM.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onMount: _propTypes["default"].func,
	
	  /**
	   * Called when an open event happens.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onOpen: _propTypes["default"].func,
	
	  /**
	   * Called when the portal is unmounted from the DOM.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onUnmount: _propTypes["default"].func,
	
	  /** Disables automatic repositioning of the component, it will always be placed according to the position value. */
	  pinned: _propTypes["default"].bool,
	
	  /** Position for the popover. */
	  position: _propTypes["default"].oneOf(_positions.positions),
	
	  /** Tells `Popper.js` to use the `position: fixed` strategy to position the popover. */
	  positionFixed: _propTypes["default"].bool,
	
	  /** An object containing custom settings for the Popper.js modifiers. */
	  popperModifiers: _propTypes["default"].object,
	
	  /** A popup can have dependencies which update will schedule a position update. */
	  popperDependencies: _propTypes["default"].array,
	
	  /** Popup size. */
	  size: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.SIZES, 'medium', 'big', 'massive')),
	
	  /** Custom Popup style. */
	  style: _propTypes["default"].object,
	
	  /** Element to be rendered in-place where the popup is defined. */
	  trigger: _propTypes["default"].node,
	
	  /** Popup width. */
	  wide: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['very'])])
	} : {};

/***/ },
/* 7298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Popup["default"];
	  }
	});
	
	var _Popup = _interopRequireDefault(__webpack_require__(7297));

/***/ },
/* 7299 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _memoize2 = _interopRequireDefault(__webpack_require__(282));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _reactComponentRef = __webpack_require__(52);
	
	var ReferenceProxy =
	/*#__PURE__*/
	function () {
	  function ReferenceProxy(refObject) {
	    (0, _classCallCheck2["default"])(this, ReferenceProxy);
	    this.ref = refObject;
	  }
	
	  (0, _createClass2["default"])(ReferenceProxy, [{
	    key: "getBoundingClientRect",
	    value: function getBoundingClientRect() {
	      return (0, _invoke2["default"])(this.ref.current, 'getBoundingClientRect', {});
	    }
	  }, {
	    key: "clientWidth",
	    get: function get() {
	      return this.getBoundingClientRect().width;
	    }
	  }, {
	    key: "clientHeight",
	    get: function get() {
	      return this.getBoundingClientRect().height;
	    }
	  }, {
	    key: "parentNode",
	    get: function get() {
	      return this.ref.current ? this.ref.current.parentNode : undefined;
	    }
	  }]);
	  return ReferenceProxy;
	}();
	/**
	 * Popper.js does not support ref objects from `createRef()` as referenceElement. If we will pass
	 * directly `ref`, `ref.current` will be `null` at the render process. We use memoize to keep the
	 * same reference between renders.
	 *
	 * @see https://popper.js.org/popper-documentation.html#referenceObject
	 */
	
	
	var createReferenceProxy = (0, _memoize2["default"])(function (reference) {
	  return new ReferenceProxy((0, _reactComponentRef.isRefObject)(reference) ? reference : (0, _reactComponentRef.toRefObject)(reference));
	});
	var _default = createReferenceProxy;
	exports["default"] = _default;

/***/ },
/* 7300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.placementMapping = exports.positions = exports.positionsMapping = void 0;
	
	var _invert2 = _interopRequireDefault(__webpack_require__(6917));
	
	var _keys2 = _interopRequireDefault(__webpack_require__(63));
	
	var positionsMapping = {
	  'top center': 'top',
	  'top left': 'top-start',
	  'top right': 'top-end',
	  'bottom center': 'bottom',
	  'bottom left': 'bottom-start',
	  'bottom right': 'bottom-end',
	  'right center': 'right',
	  'left center': 'left'
	};
	exports.positionsMapping = positionsMapping;
	var positions = (0, _keys2["default"])(positionsMapping);
	exports.positions = positions;
	var placementMapping = (0, _invert2["default"])(positionsMapping);
	exports.placementMapping = placementMapping;

/***/ },
/* 7301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _round2 = _interopRequireDefault(__webpack_require__(6935));
	
	var _clamp2 = _interopRequireDefault(__webpack_require__(6882));
	
	var _isUndefined2 = _interopRequireDefault(__webpack_require__(204));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * A progress bar shows the progression of a task.
	 */
	var Progress =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Progress, _Component);
	
	  function Progress() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Progress);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Progress)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "calculatePercent", function () {
	      var _this$props = _this.props,
	          percent = _this$props.percent,
	          total = _this$props.total,
	          value = _this$props.value;
	      if (!(0, _isUndefined2["default"])(percent)) return percent;
	      if (!(0, _isUndefined2["default"])(total) && !(0, _isUndefined2["default"])(value)) return value / total * 100;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "computeValueText", function (percent) {
	      var _this$props2 = _this.props,
	          progress = _this$props2.progress,
	          total = _this$props2.total,
	          value = _this$props2.value;
	      if (progress === 'value') return value;
	      if (progress === 'ratio') return "".concat(value, "/").concat(total);
	      return "".concat(percent, "%");
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getPercent", function () {
	      var _this$props3 = _this.props,
	          precision = _this$props3.precision,
	          progress = _this$props3.progress,
	          total = _this$props3.total,
	          value = _this$props3.value;
	      var percent = (0, _clamp2["default"])(_this.calculatePercent(), 0, 100);
	
	      if (!(0, _isUndefined2["default"])(total) && !(0, _isUndefined2["default"])(value) && progress === 'value') {
	        return value / total * 100;
	      }
	
	      if (progress === 'value') return value;
	      if ((0, _isUndefined2["default"])(precision)) return percent;
	      return (0, _round2["default"])(percent, precision);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isAutoSuccess", function () {
	      var _this$props4 = _this.props,
	          autoSuccess = _this$props4.autoSuccess,
	          percent = _this$props4.percent,
	          total = _this$props4.total,
	          value = _this$props4.value;
	      return autoSuccess && (percent >= 100 || value >= total);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderLabel", function () {
	      var _this$props5 = _this.props,
	          children = _this$props5.children,
	          content = _this$props5.content,
	          label = _this$props5.label;
	      if (!_lib.childrenUtils.isNil(children)) return _react["default"].createElement("div", {
	        className: "label"
	      }, children);
	      if (!_lib.childrenUtils.isNil(content)) return _react["default"].createElement("div", {
	        className: "label"
	      }, content);
	      return (0, _lib.createHTMLDivision)(label, {
	        autoGenerateKey: false,
	        defaultProps: {
	          className: 'label'
	        }
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderProgress", function (percent) {
	      var _this$props6 = _this.props,
	          precision = _this$props6.precision,
	          progress = _this$props6.progress;
	      if (!progress && (0, _isUndefined2["default"])(precision)) return;
	      return _react["default"].createElement("div", {
	        className: "progress"
	      }, _this.computeValueText(percent));
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Progress, [{
	    key: "render",
	    value: function render() {
	      var _this$props7 = this.props,
	          active = _this$props7.active,
	          attached = _this$props7.attached,
	          className = _this$props7.className,
	          color = _this$props7.color,
	          disabled = _this$props7.disabled,
	          error = _this$props7.error,
	          indicating = _this$props7.indicating,
	          inverted = _this$props7.inverted,
	          size = _this$props7.size,
	          success = _this$props7.success,
	          warning = _this$props7.warning;
	      var classes = (0, _classnames["default"])('ui', color, size, (0, _lib.useKeyOnly)(active || indicating, 'active'), (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(error, 'error'), (0, _lib.useKeyOnly)(indicating, 'indicating'), (0, _lib.useKeyOnly)(inverted, 'inverted'), (0, _lib.useKeyOnly)(success || this.isAutoSuccess(), 'success'), (0, _lib.useKeyOnly)(warning, 'warning'), (0, _lib.useValueAndKey)(attached, 'attached'), 'progress', className);
	      var rest = (0, _lib.getUnhandledProps)(Progress, this.props);
	      var ElementType = (0, _lib.getElementType)(Progress, this.props);
	      var percent = this.getPercent() || 0;
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes,
	        "data-percent": Math.floor(percent)
	      }), _react["default"].createElement("div", {
	        className: "bar",
	        style: {
	          width: "".concat(percent, "%")
	        }
	      }, this.renderProgress(percent)), this.renderLabel());
	    }
	  }]);
	  return Progress;
	}(_react.Component);
	
	(0, _defineProperty2["default"])(Progress, "handledProps", ["active", "as", "attached", "autoSuccess", "children", "className", "color", "content", "disabled", "error", "indicating", "inverted", "label", "percent", "precision", "progress", "size", "success", "total", "value", "warning"]);
	Progress.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A progress bar can show activity. */
	  active: _propTypes["default"].bool,
	
	  /** A progress bar can attach to and show the progress of an element (i.e. Card or Segment). */
	  attached: _propTypes["default"].oneOf(['top', 'bottom']),
	
	  /** Whether success state should automatically trigger when progress completes. */
	  autoSuccess: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** A progress bar can have different colors. */
	  color: _propTypes["default"].oneOf(_lib.SUI.COLORS),
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** A progress bar be disabled. */
	  disabled: _propTypes["default"].bool,
	
	  /** A progress bar can show a error state. */
	  error: _propTypes["default"].bool,
	
	  /** An indicating progress bar visually indicates the current level of progress of a task. */
	  indicating: _propTypes["default"].bool,
	
	  /** A progress bar can have its colors inverted. */
	  inverted: _propTypes["default"].bool,
	
	  /** Can be set to either to display progress as percent or ratio. */
	  label: _lib.customPropTypes.itemShorthand,
	
	  /** Current percent complete. */
	  percent: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['total', 'value']), _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])]),
	
	  /** Decimal point precision for calculated progress. */
	  precision: _propTypes["default"].number,
	
	  /** A progress bar can contain a text value indicating current progress. */
	  progress: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['percent', 'ratio', 'value'])]),
	
	  /** A progress bar can vary in size. */
	  size: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.SIZES, 'mini', 'huge', 'massive')),
	
	  /** A progress bar can show a success state. */
	  success: _propTypes["default"].bool,
	
	  /** For use with value. Together, these will calculate the percent. Mutually excludes percent. */
	  total: _lib.customPropTypes.every([_lib.customPropTypes.demand(['value']), _lib.customPropTypes.disallow(['percent']), _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])]),
	
	  /** For use with total. Together, these will calculate the percent. Mutually excludes percent. */
	  value: _lib.customPropTypes.every([_lib.customPropTypes.disallow(['percent']), _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])]),
	
	  /** A progress bar can show a warning state. */
	  warning: _propTypes["default"].bool
	} : {};
	var _default = Progress;
	exports["default"] = _default;

/***/ },
/* 7302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Progress["default"];
	  }
	});
	
	var _Progress = _interopRequireDefault(__webpack_require__(7301));

/***/ },
/* 7303 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _times2 = _interopRequireDefault(__webpack_require__(6945));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _RatingIcon = _interopRequireDefault(__webpack_require__(758));
	
	/**
	 * A rating indicates user interest in content.
	 */
	var Rating =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Rating, _Component);
	
	  function Rating() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Rating);
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Rating)).call.apply(_getPrototypeOf2, [this].concat(_args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleIconClick", function (e, _ref) {
	      var index = _ref.index;
	      var _this$props = _this.props,
	          clearable = _this$props.clearable,
	          disabled = _this$props.disabled,
	          maxRating = _this$props.maxRating,
	          onRate = _this$props.onRate;
	      var rating = _this.state.rating;
	      if (disabled) return; // default newRating is the clicked icon
	      // allow toggling a binary rating
	      // allow clearing ratings
	
	      var newRating = index + 1;
	
	      if (clearable === 'auto' && maxRating === 1) {
	        newRating = +!rating;
	      } else if (clearable === true && newRating === rating) {
	        newRating = 0;
	      } // set rating
	
	
	      _this.trySetState({
	        rating: newRating,
	        isSelecting: false
	      });
	
	      if (onRate) onRate(e, (0, _objectSpread2["default"])({}, _this.props, {
	        rating: newRating
	      }));
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleIconMouseEnter", function (e, _ref2) {
	      var index = _ref2.index;
	      if (_this.props.disabled) return;
	
	      _this.setState({
	        selectedIndex: index,
	        isSelecting: true
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleMouseLeave", function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      _invoke2["default"].apply(void 0, [_this.props, 'onMouseLeave'].concat(args));
	
	      if (_this.props.disabled) return;
	
	      _this.setState({
	        selectedIndex: -1,
	        isSelecting: false
	      });
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Rating, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          className = _this$props2.className,
	          disabled = _this$props2.disabled,
	          icon = _this$props2.icon,
	          maxRating = _this$props2.maxRating,
	          size = _this$props2.size;
	      var _this$state = this.state,
	          rating = _this$state.rating,
	          selectedIndex = _this$state.selectedIndex,
	          isSelecting = _this$state.isSelecting;
	      var classes = (0, _classnames["default"])('ui', icon, size, (0, _lib.useKeyOnly)(disabled, 'disabled'), (0, _lib.useKeyOnly)(isSelecting && !disabled && selectedIndex >= 0, 'selected'), 'rating', className);
	      var rest = (0, _lib.getUnhandledProps)(Rating, this.props);
	      var ElementType = (0, _lib.getElementType)(Rating, this.props);
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes,
	        role: "radiogroup",
	        onMouseLeave: this.handleMouseLeave,
	        tabIndex: disabled ? 0 : -1
	      }), (0, _times2["default"])(maxRating, function (i) {
	        return _react["default"].createElement(_RatingIcon["default"], {
	          tabIndex: disabled ? -1 : 0,
	          active: rating >= i + 1,
	          "aria-checked": rating === i + 1,
	          "aria-posinset": i + 1,
	          "aria-setsize": maxRating,
	          index: i,
	          key: i,
	          onClick: _this2.handleIconClick,
	          onMouseEnter: _this2.handleIconMouseEnter,
	          selected: selectedIndex >= i && isSelecting
	        });
	      }));
	    }
	  }]);
	  return Rating;
	}(_lib.AutoControlledComponent);
	
	exports["default"] = Rating;
	(0, _defineProperty2["default"])(Rating, "autoControlledProps", ['rating']);
	(0, _defineProperty2["default"])(Rating, "defaultProps", {
	  clearable: 'auto',
	  maxRating: 1
	});
	(0, _defineProperty2["default"])(Rating, "Icon", _RatingIcon["default"]);
	(0, _defineProperty2["default"])(Rating, "handledProps", ["as", "className", "clearable", "defaultRating", "disabled", "icon", "maxRating", "onRate", "rating", "size"]);
	Rating.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /**
	   * You can clear the rating by clicking on the current start rating.
	   * By default a rating will be only clearable if there is 1 icon.
	   * Setting to `true`/`false` will allow or disallow a user to clear their rating.
	   */
	  clearable: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(['auto'])]),
	
	  /** The initial rating value. */
	  defaultRating: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /** You can disable or enable interactive rating.  Makes a read-only rating. */
	  disabled: _propTypes["default"].bool,
	
	  /** A rating can use a set of star or heart icons. */
	  icon: _propTypes["default"].oneOf(['star', 'heart']),
	
	  /** The total number of icons. */
	  maxRating: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /**
	   * Called after user selects a new rating.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and proposed rating.
	   */
	  onRate: _propTypes["default"].func,
	
	  /** The current number of active icons. */
	  rating: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /** A progress bar can vary in size. */
	  size: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.SIZES, 'medium', 'big'))
	} : {};

/***/ },
/* 7304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Rating["default"];
	  }
	});
	
	var _Rating = _interopRequireDefault(__webpack_require__(7303));

/***/ },
/* 7305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(44));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _get3 = _interopRequireDefault(__webpack_require__(342));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _isEmpty2 = _interopRequireDefault(__webpack_require__(202));
	
	var _partialRight2 = _interopRequireDefault(__webpack_require__(6930));
	
	var _inRange2 = _interopRequireDefault(__webpack_require__(512));
	
	var _map2 = _interopRequireDefault(__webpack_require__(41));
	
	var _get4 = _interopRequireDefault(__webpack_require__(72));
	
	var _reduce2 = _interopRequireDefault(__webpack_require__(206));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _keyboardKey = _interopRequireDefault(__webpack_require__(138));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(226));
	
	var _lib = __webpack_require__(12);
	
	var _Input = _interopRequireDefault(__webpack_require__(313));
	
	var _SearchCategory = _interopRequireDefault(__webpack_require__(759));
	
	var _SearchResult = _interopRequireDefault(__webpack_require__(760));
	
	var _SearchResults = _interopRequireDefault(__webpack_require__(761));
	
	/**
	 * A search module allows a user to query for results from a selection of data
	 */
	var Search =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Search, _Component);
	
	  function Search() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Search);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Search)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleResultSelect", function (e, result) {
	      (0, _invoke2["default"])(_this.props, 'onResultSelect', e, (0, _objectSpread2["default"])({}, _this.props, {
	        result: result
	      }));
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleSelectionChange", function (e) {
	      var result = _this.getSelectedResult();
	
	      (0, _invoke2["default"])(_this.props, 'onSelectionChange', e, (0, _objectSpread2["default"])({}, _this.props, {
	        result: result
	      }));
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closeOnEscape", function (e) {
	      if (_keyboardKey["default"].getCode(e) !== _keyboardKey["default"].Escape) return;
	      e.preventDefault();
	
	      _this.close();
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "moveSelectionOnKeyDown", function (e) {
	      switch (_keyboardKey["default"].getCode(e)) {
	        case _keyboardKey["default"].ArrowDown:
	          e.preventDefault();
	
	          _this.moveSelectionBy(e, 1);
	
	          break;
	
	        case _keyboardKey["default"].ArrowUp:
	          e.preventDefault();
	
	          _this.moveSelectionBy(e, -1);
	
	          break;
	
	        default:
	          break;
	      }
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "selectItemOnEnter", function (e) {
	      if (_keyboardKey["default"].getCode(e) !== _keyboardKey["default"].Enter) return;
	
	      var result = _this.getSelectedResult(); // prevent selecting null if there was no selected item value
	
	
	      if (!result) return;
	      e.preventDefault(); // notify the onResultSelect prop that the user is trying to change value
	
	      _this.setValue(result.title);
	
	      _this.handleResultSelect(e, result);
	
	      _this.close();
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closeOnDocumentClick", function (e) {
	      _this.close();
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleMouseDown", function (e) {
	      _this.isMouseDown = true;
	      (0, _invoke2["default"])(_this.props, 'onMouseDown', e, _this.props);
	
	      _lib.eventStack.sub('mouseup', _this.handleDocumentMouseUp);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleDocumentMouseUp", function () {
	      _this.isMouseDown = false;
	
	      _lib.eventStack.unsub('mouseup', _this.handleDocumentMouseUp);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleInputClick", function (e) {
	      // prevent closeOnDocumentClick()
	      e.nativeEvent.stopImmediatePropagation();
	
	      _this.tryOpen();
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleItemClick", function (e, _ref) {
	      var id = _ref.id;
	
	      var result = _this.getSelectedResult(id); // prevent closeOnDocumentClick()
	
	
	      e.nativeEvent.stopImmediatePropagation(); // notify the onResultSelect prop that the user is trying to change value
	
	      _this.setValue(result.title);
	
	      _this.handleResultSelect(e, result);
	
	      _this.close();
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleItemMouseDown", function (e) {
	      // Heads up! We should prevent default to prevent blur events.
	      // https://github.com/Semantic-Org/Semantic-UI-React/issues/3298
	      e.preventDefault();
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleFocus", function (e) {
	      (0, _invoke2["default"])(_this.props, 'onFocus', e, _this.props);
	
	      _this.setState({
	        focus: true
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleBlur", function (e) {
	      (0, _invoke2["default"])(_this.props, 'onBlur', e, _this.props);
	
	      _this.setState({
	        focus: false
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleSearchChange", function (e) {
	      // prevent propagating to this.props.onChange()
	      e.stopPropagation();
	      var minCharacters = _this.props.minCharacters;
	      var open = _this.state.open;
	      var newQuery = e.target.value;
	      (0, _invoke2["default"])(_this.props, 'onSearchChange', e, (0, _objectSpread2["default"])({}, _this.props, {
	        value: newQuery
	      })); // open search dropdown on search query
	
	      if (newQuery.length < minCharacters) {
	        _this.close();
	      } else if (!open) {
	        _this.tryOpen(newQuery);
	      }
	
	      _this.setValue(newQuery);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getFlattenedResults", function () {
	      var _this$props = _this.props,
	          category = _this$props.category,
	          results = _this$props.results;
	      return !category ? results : (0, _reduce2["default"])(results, function (memo, categoryData) {
	        return memo.concat(categoryData.results);
	      }, []);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getSelectedResult", function () {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.selectedIndex;
	
	      var results = _this.getFlattenedResults();
	
	      return (0, _get4["default"])(results, index);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setValue", function (value) {
	      var selectFirstResult = _this.props.selectFirstResult;
	
	      _this.trySetState({
	        value: value,
	        selectedIndex: selectFirstResult ? 0 : -1
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "moveSelectionBy", function (e, offset) {
	      var selectedIndex = _this.state.selectedIndex;
	
	      var results = _this.getFlattenedResults();
	
	      var lastIndex = results.length - 1; // next is after last, wrap to beginning
	      // next is before first, wrap to end
	
	      var nextIndex = selectedIndex + offset;
	      if (nextIndex > lastIndex) nextIndex = 0;else if (nextIndex < 0) nextIndex = lastIndex;
	
	      _this.setState({
	        selectedIndex: nextIndex
	      });
	
	      _this.scrollSelectedItemIntoView();
	
	      _this.handleSelectionChange(e);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollSelectedItemIntoView", function () {
	      // Do not access document when server side rendering
	      if (!(0, _lib.isBrowser)()) return;
	      var menu = document.querySelector('.ui.search.active.visible .results.visible');
	      var item = menu.querySelector('.result.active');
	      if (!item) return;
	      var isOutOfUpperView = item.offsetTop < menu.scrollTop;
	      var isOutOfLowerView = item.offsetTop + item.clientHeight > menu.scrollTop + menu.clientHeight;
	
	      if (isOutOfUpperView) {
	        menu.scrollTop = item.offsetTop;
	      } else if (isOutOfLowerView) {
	        menu.scrollTop = item.offsetTop + item.clientHeight - menu.clientHeight;
	      }
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "tryOpen", function () {
	      var currentValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
	      var minCharacters = _this.props.minCharacters;
	      if (currentValue.length < minCharacters) return;
	
	      _this.open();
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "open", function () {
	      _this.trySetState({
	        open: true
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "close", function () {
	      _this.trySetState({
	        open: false
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderSearchInput", function (rest) {
	      var _this$props2 = _this.props,
	          icon = _this$props2.icon,
	          input = _this$props2.input;
	      var value = _this.state.value;
	      return _Input["default"].create(input, {
	        autoGenerateKey: false,
	        defaultProps: (0, _objectSpread2["default"])({}, rest, {
	          icon: icon,
	          input: {
	            className: 'prompt',
	            tabIndex: '0',
	            autoComplete: 'off'
	          },
	          onChange: _this.handleSearchChange,
	          onClick: _this.handleInputClick,
	          value: value
	        })
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderNoResults", function () {
	      var _this$props3 = _this.props,
	          noResultsDescription = _this$props3.noResultsDescription,
	          noResultsMessage = _this$props3.noResultsMessage;
	      return _react["default"].createElement("div", {
	        className: "message empty"
	      }, _react["default"].createElement("div", {
	        className: "header"
	      }, noResultsMessage), noResultsDescription && _react["default"].createElement("div", {
	        className: "description"
	      }, noResultsDescription));
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderResult", function (_ref2, index, _array) {
	      var childKey = _ref2.childKey,
	          result = (0, _objectWithoutProperties2["default"])(_ref2, ["childKey"]);
	      var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	      var resultRenderer = _this.props.resultRenderer;
	      var selectedIndex = _this.state.selectedIndex;
	      var offsetIndex = index + offset;
	      return _react["default"].createElement(_SearchResult["default"], (0, _extends2["default"])({
	        key: childKey || result.title,
	        active: selectedIndex === offsetIndex,
	        onClick: _this.handleItemClick,
	        onMouseDown: _this.handleItemMouseDown,
	        renderer: resultRenderer
	      }, result, {
	        id: offsetIndex // Used to lookup the result on item click
	
	      }));
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderResults", function () {
	      var results = _this.props.results;
	      return (0, _map2["default"])(results, _this.renderResult);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderCategories", function () {
	      var _this$props4 = _this.props,
	          categoryRenderer = _this$props4.categoryRenderer,
	          categories = _this$props4.results;
	      var selectedIndex = _this.state.selectedIndex;
	      var count = 0;
	      return (0, _map2["default"])(categories, function (_ref3) {
	        var childKey = _ref3.childKey,
	            category = (0, _objectWithoutProperties2["default"])(_ref3, ["childKey"]);
	        var categoryProps = (0, _objectSpread2["default"])({
	          key: childKey || category.name,
	          active: (0, _inRange2["default"])(selectedIndex, count, count + category.results.length),
	          renderer: categoryRenderer
	        }, category);
	        var renderFn = (0, _partialRight2["default"])(_this.renderResult, count);
	        count += category.results.length;
	        return _react["default"].createElement(_SearchCategory["default"], categoryProps, category.results.map(renderFn));
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderMenuContent", function () {
	      var _this$props5 = _this.props,
	          category = _this$props5.category,
	          showNoResults = _this$props5.showNoResults,
	          results = _this$props5.results;
	
	      if ((0, _isEmpty2["default"])(results)) {
	        return showNoResults ? _this.renderNoResults() : null;
	      }
	
	      return category ? _this.renderCategories() : _this.renderResults();
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderResultsMenu", function () {
	      var open = _this.state.open;
	      var resultsClasses = open ? 'visible' : '';
	
	      var menuContent = _this.renderMenuContent();
	
	      if (!menuContent) return;
	      return _react["default"].createElement(_SearchResults["default"], {
	        className: resultsClasses
	      }, menuContent);
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Search, [{
	    key: "UNSAFE_componentWillMount",
	    // eslint-disable-next-line camelcase
	    value: function UNSAFE_componentWillMount() {
	      var _this$state = this.state,
	          open = _this$state.open,
	          value = _this$state.value;
	      this.setValue(value);
	      if (open) this.open();
	    } // eslint-disable-next-line camelcase
	
	  }, {
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      (0, _get3["default"])((0, _getPrototypeOf3["default"])(Search.prototype), "UNSAFE_componentWillReceiveProps", this).call(this, nextProps);
	
	      if (!(0, _shallowequal["default"])(nextProps.value, this.props.value)) {
	        this.setValue(nextProps.value);
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowequal["default"])(nextProps, this.props) || !(0, _shallowequal["default"])(nextState, this.state);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      // eslint-disable-line complexity
	      // focused / blurred
	      if (!prevState.focus && this.state.focus) {
	        if (!this.isMouseDown) {
	          this.tryOpen();
	        }
	
	        if (this.state.open) {
	          _lib.eventStack.sub('keydown', [this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
	        }
	      } else if (prevState.focus && !this.state.focus) {
	        if (!this.isMouseDown) {
	          this.close();
	        }
	
	        _lib.eventStack.unsub('keydown', [this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
	      } // opened / closed
	
	
	      if (!prevState.open && this.state.open) {
	        this.open();
	
	        _lib.eventStack.sub('click', this.closeOnDocumentClick);
	
	        _lib.eventStack.sub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
	      } else if (prevState.open && !this.state.open) {
	        this.close();
	
	        _lib.eventStack.unsub('click', this.closeOnDocumentClick);
	
	        _lib.eventStack.unsub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _lib.eventStack.unsub('click', this.closeOnDocumentClick);
	
	      _lib.eventStack.unsub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
	    } // ----------------------------------------
	    // Document Event Handlers
	    // ----------------------------------------
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$state2 = this.state,
	          searchClasses = _this$state2.searchClasses,
	          focus = _this$state2.focus,
	          open = _this$state2.open;
	      var _this$props6 = this.props,
	          aligned = _this$props6.aligned,
	          category = _this$props6.category,
	          className = _this$props6.className,
	          fluid = _this$props6.fluid,
	          loading = _this$props6.loading,
	          size = _this$props6.size; // Classes
	
	      var classes = (0, _classnames["default"])('ui', open && 'active visible', size, searchClasses, (0, _lib.useKeyOnly)(category, 'category'), (0, _lib.useKeyOnly)(focus, 'focus'), (0, _lib.useKeyOnly)(fluid, 'fluid'), (0, _lib.useKeyOnly)(loading, 'loading'), (0, _lib.useValueAndKey)(aligned, 'aligned'), 'search', className);
	      var unhandled = (0, _lib.getUnhandledProps)(Search, this.props);
	      var ElementType = (0, _lib.getElementType)(Search, this.props);
	
	      var _partitionHTMLProps = (0, _lib.partitionHTMLProps)(unhandled, {
	        htmlProps: _lib.htmlInputAttrs
	      }),
	          _partitionHTMLProps2 = (0, _slicedToArray2["default"])(_partitionHTMLProps, 2),
	          htmlInputProps = _partitionHTMLProps2[0],
	          rest = _partitionHTMLProps2[1];
	
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onMouseDown: this.handleMouseDown
	      }), this.renderSearchInput(htmlInputProps), this.renderResultsMenu());
	    }
	  }]);
	  return Search;
	}(_lib.AutoControlledComponent);
	
	exports["default"] = Search;
	(0, _defineProperty2["default"])(Search, "defaultProps", {
	  icon: 'search',
	  input: 'text',
	  minCharacters: 1,
	  noResultsMessage: 'No results found.',
	  showNoResults: true
	});
	(0, _defineProperty2["default"])(Search, "autoControlledProps", ['open', 'value']);
	(0, _defineProperty2["default"])(Search, "Category", _SearchCategory["default"]);
	(0, _defineProperty2["default"])(Search, "Result", _SearchResult["default"]);
	(0, _defineProperty2["default"])(Search, "Results", _SearchResults["default"]);
	(0, _defineProperty2["default"])(Search, "handledProps", ["aligned", "as", "category", "categoryRenderer", "className", "defaultOpen", "defaultValue", "fluid", "icon", "input", "loading", "minCharacters", "noResultsDescription", "noResultsMessage", "onBlur", "onFocus", "onMouseDown", "onResultSelect", "onSearchChange", "onSelectionChange", "open", "resultRenderer", "results", "selectFirstResult", "showNoResults", "size", "value"]);
	Search.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	  // ------------------------------------
	  // Behavior
	  // ------------------------------------
	
	  /** Initial value of open. */
	  defaultOpen: _propTypes["default"].bool,
	
	  /** Initial value. */
	  defaultValue: _propTypes["default"].string,
	
	  /** Shorthand for Icon. */
	  icon: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].object]),
	
	  /** Minimum characters to query for results */
	  minCharacters: _propTypes["default"].number,
	
	  /** Additional text for "No Results" message with less emphasis. */
	  noResultsDescription: _propTypes["default"].node,
	
	  /** Message to display when there are no results. */
	  noResultsMessage: _propTypes["default"].node,
	
	  /** Controls whether or not the results menu is displayed. */
	  open: _propTypes["default"].bool,
	
	  /**
	   * One of:
	   * - array of Search.Result props e.g. `{ title: '', description: '' }` or
	   * - object of categories e.g. `{ name: '', results: [{ title: '', description: '' }]`
	   */
	  results: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].shape(_SearchResult["default"].propTypes)), _propTypes["default"].shape(_SearchCategory["default"].propTypes)]),
	
	  /** Whether the search should automatically select the first result after searching. */
	  selectFirstResult: _propTypes["default"].bool,
	
	  /** Whether a "no results" message should be shown if no results are found. */
	  showNoResults: _propTypes["default"].bool,
	
	  /** Current value of the search input. Creates a controlled component. */
	  value: _propTypes["default"].string,
	  // ------------------------------------
	  // Rendering
	  // ------------------------------------
	
	  /**
	   * Renders the SearchCategory contents.
	   *
	   * @param {object} props - The SearchCategory props object.
	   * @returns {*} - Renderable SearchCategory contents.
	   */
	  categoryRenderer: _propTypes["default"].func,
	
	  /**
	   * Renders the SearchResult contents.
	   *
	   * @param {object} props - The SearchResult props object.
	   * @returns {*} - Renderable SearchResult contents.
	   */
	  resultRenderer: _propTypes["default"].func,
	  // ------------------------------------
	  // Callbacks
	  // ------------------------------------
	
	  /**
	   * Called on blur.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onBlur: _propTypes["default"].func,
	
	  /**
	   * Called on focus.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onFocus: _propTypes["default"].func,
	
	  /**
	   * Called on mousedown.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onMouseDown: _propTypes["default"].func,
	
	  /**
	   * Called when a result is selected.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onResultSelect: _propTypes["default"].func,
	
	  /**
	   * Called on search input change.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props, includes current value of search input.
	   */
	  onSearchChange: _propTypes["default"].func,
	
	  /**
	   * Called when the active selection index is changed.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onSelectionChange: _propTypes["default"].func,
	  // ------------------------------------
	  // Style
	  // ------------------------------------
	
	  /** A search can have its results aligned to its left or right container edge. */
	  aligned: _propTypes["default"].string,
	
	  /** A search can display results from remote content ordered by categories. */
	  category: _propTypes["default"].bool,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** A search can have its results take up the width of its container. */
	  fluid: _propTypes["default"].bool,
	
	  /** Shorthand for input element. */
	  input: _lib.customPropTypes.itemShorthand,
	
	  /** A search can show a loading indicator. */
	  loading: _propTypes["default"].bool,
	
	  /** A search can have different sizes. */
	  size: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.SIZES, 'medium'))
	} : {};

/***/ },
/* 7306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Search["default"];
	  }
	});
	
	var _Search = _interopRequireDefault(__webpack_require__(7305));

/***/ },
/* 7307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _reactComponentEventListener = __webpack_require__(6648);
	
	var _reactComponentRef = __webpack_require__(52);
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _SidebarPushable = _interopRequireDefault(__webpack_require__(762));
	
	var _SidebarPusher = _interopRequireDefault(__webpack_require__(763));
	
	/**
	 * A sidebar hides additional content beside a page.
	 */
	var Sidebar =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Sidebar, _Component);
	
	  function Sidebar(props) {
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Sidebar);
	    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Sidebar).call(this, props));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "ref", (0, _react.createRef)());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleAnimationStart", function () {
	      var visible = _this.props.visible;
	      var callback = visible ? 'onVisible' : 'onHide';
	      clearTimeout(_this.animationTimer);
	      _this.animationTimer = setTimeout(_this.handleAnimationEnd, Sidebar.animationDuration);
	
	      if (_this.skipNextCallback) {
	        _this.skipNextCallback = false;
	        return;
	      }
	
	      (0, _invoke2["default"])(_this.props, callback, null, _this.props);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleAnimationEnd", function () {
	      var visible = _this.props.visible;
	      var callback = visible ? 'onShow' : 'onHidden';
	
	      _this.setState({
	        animationTick: 0
	      });
	
	      (0, _invoke2["default"])(_this.props, callback, null, _this.props);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleDocumentClick", function (e) {
	      if (!(0, _lib.doesNodeContainClick)(_this.ref.current, e)) {
	        _this.skipNextCallback = true;
	        (0, _invoke2["default"])(_this.props, 'onHide', e, (0, _objectSpread2["default"])({}, _this.props, {
	          visible: false
	        }));
	      }
	    });
	    _this.state = {
	      animationTick: 0,
	      visible: props.visible
	    };
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Sidebar, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.state.animationTick > prevState.animationTick) {
	        this.handleAnimationStart();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.animationTimer);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          animation = _this$props.animation,
	          className = _this$props.className,
	          children = _this$props.children,
	          content = _this$props.content,
	          direction = _this$props.direction,
	          target = _this$props.target,
	          visible = _this$props.visible,
	          width = _this$props.width;
	      var animationTick = this.state.animationTick;
	      var classes = (0, _classnames["default"])('ui', animation, direction, width, (0, _lib.useKeyOnly)(animationTick > 0, 'animating'), (0, _lib.useKeyOnly)(visible, 'visible'), 'sidebar', className);
	      var rest = (0, _lib.getUnhandledProps)(Sidebar, this.props);
	      var ElementType = (0, _lib.getElementType)(Sidebar, this.props);
	      var targetRef = (0, _reactComponentRef.isRefObject)(target) ? target : (0, _reactComponentRef.toRefObject)(target);
	      return _react["default"].createElement(_reactComponentRef.Ref, {
	        innerRef: this.ref
	      }, _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: classes
	      }), _lib.childrenUtils.isNil(children) ? content : children, visible && _react["default"].createElement(_reactComponentEventListener.EventListener, {
	        listener: this.handleDocumentClick,
	        targetRef: targetRef,
	        type: "click"
	      })));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(props, state) {
	      // We use `animationTick` to understand when an animation should be scheduled
	      var tickIncrement = !!props.visible === !!state.visible ? 0 : 1;
	      return {
	        animationTick: state.animationTick + tickIncrement,
	        visible: props.visible
	      };
	    }
	  }]);
	  return Sidebar;
	}(_react.Component);
	
	(0, _defineProperty2["default"])(Sidebar, "defaultProps", {
	  direction: 'left',
	  target: _reactComponentEventListener.documentRef,
	  visible: false
	});
	(0, _defineProperty2["default"])(Sidebar, "animationDuration", 500);
	(0, _defineProperty2["default"])(Sidebar, "autoControlledProps", ['visible']);
	(0, _defineProperty2["default"])(Sidebar, "Pushable", _SidebarPushable["default"]);
	(0, _defineProperty2["default"])(Sidebar, "Pusher", _SidebarPusher["default"]);
	(0, _defineProperty2["default"])(Sidebar, "handledProps", ["animation", "as", "children", "className", "content", "direction", "onHidden", "onHide", "onShow", "onVisible", "target", "visible", "width"]);
	Sidebar.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Animation style. */
	  animation: _propTypes["default"].oneOf(['overlay', 'push', 'scale down', 'uncover', 'slide out', 'slide along']),
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Direction the sidebar should appear on. */
	  direction: _propTypes["default"].oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * Called before a sidebar begins to animate out.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onHide: _propTypes["default"].func,
	
	  /**
	   * Called after a sidebar has finished animating out.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onHidden: _propTypes["default"].func,
	
	  /**
	   * Called when a sidebar has finished animating in.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onShow: _propTypes["default"].func,
	
	  /**
	   * Called when a sidebar begins animating in.
	   *
	   * @param {null}
	   * @param {object} data - All props.
	   */
	  onVisible: _propTypes["default"].func,
	
	  /** A sidebar can handle clicks on the passed element. */
	  target: _propTypes["default"].oneOfType([_lib.customPropTypes.domNode, _lib.customPropTypes.refObject]),
	
	  /** Controls whether or not the sidebar is visible on the page. */
	  visible: _propTypes["default"].bool,
	
	  /** Sidebar width. */
	  width: _propTypes["default"].oneOf(['very thin', 'thin', 'wide', 'very wide'])
	} : {};
	var _default = Sidebar;
	exports["default"] = _default;

/***/ },
/* 7308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Sidebar["default"];
	  }
	});
	
	var _Sidebar = _interopRequireDefault(__webpack_require__(7307));

/***/ },
/* 7309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _reactComponentRef = __webpack_require__(52);
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireWildcard(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * Sticky content stays fixed to the browser viewport while another column of content is visible on the page.
	 */
	var Sticky =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Sticky, _Component);
	
	  function Sticky() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Sticky);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Sticky)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
	      sticky: false
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "stickyRef", (0, _react.createRef)());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "triggerRef", (0, _react.createRef)());
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "addListeners", function (props) {
	      var scrollContext = props.scrollContext;
	      var scrollContextNode = (0, _reactComponentRef.isRefObject)(scrollContext) ? scrollContext.current : scrollContext;
	
	      if (scrollContextNode) {
	        _lib.eventStack.sub('resize', _this.handleUpdate, {
	          target: scrollContextNode
	        });
	
	        _lib.eventStack.sub('scroll', _this.handleUpdate, {
	          target: scrollContextNode
	        });
	      }
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "removeListeners", function () {
	      var scrollContext = _this.props.scrollContext;
	      var scrollContextNode = (0, _reactComponentRef.isRefObject)(scrollContext) ? scrollContext.current : scrollContext;
	
	      if (scrollContextNode) {
	        _lib.eventStack.unsub('resize', _this.handleUpdate, {
	          target: scrollContextNode
	        });
	
	        _lib.eventStack.unsub('scroll', _this.handleUpdate, {
	          target: scrollContextNode
	        });
	      }
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "update", function (e) {
	      var pushing = _this.state.pushing;
	      _this.ticking = false;
	
	      _this.assignRects();
	
	      if (pushing) {
	        if (_this.didReachStartingPoint()) return _this.stickToContextTop(e);
	        if (_this.didTouchScreenBottom()) return _this.stickToScreenBottom(e);
	        return _this.stickToContextBottom(e);
	      }
	
	      if (_this.isOversized()) {
	        if (_this.contextRect.top > 0) return _this.stickToContextTop(e);
	        if (_this.contextRect.bottom < window.innerHeight) return _this.stickToContextBottom(e);
	      }
	
	      if (_this.didTouchScreenTop()) {
	        if (_this.didReachContextBottom()) return _this.stickToContextBottom(e);
	        return _this.stickToScreenTop(e);
	      }
	
	      return _this.stickToContextTop(e);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleUpdate", function (e) {
	      if (!_this.ticking) {
	        _this.ticking = true;
	        _this.frameId = requestAnimationFrame(function () {
	          return _this.update(e);
	        });
	      }
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "assignRects", function () {
	      var context = _this.props.context;
	      var contextNode = (0, _reactComponentRef.isRefObject)(context) ? context.current : context || document.body;
	      _this.triggerRect = _this.triggerRef.current.getBoundingClientRect();
	      _this.contextRect = contextNode.getBoundingClientRect();
	      _this.stickyRect = _this.stickyRef.current.getBoundingClientRect();
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "didReachContextBottom", function () {
	      var offset = _this.props.offset;
	      return _this.stickyRect.height + offset >= _this.contextRect.bottom;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "didReachStartingPoint", function () {
	      return _this.stickyRect.top <= _this.triggerRect.top;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "didTouchScreenTop", function () {
	      return _this.triggerRect.top < _this.props.offset;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "didTouchScreenBottom", function () {
	      var bottomOffset = _this.props.bottomOffset;
	      return _this.contextRect.bottom + bottomOffset > window.innerHeight;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isOversized", function () {
	      return _this.stickyRect.height > window.innerHeight;
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "pushing", function (pushing) {
	      var possible = _this.props.pushing;
	      if (possible) _this.setState({
	        pushing: pushing
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "stick", function (e, bound) {
	      _this.setState({
	        bound: bound,
	        sticky: true
	      });
	
	      (0, _invoke2["default"])(_this.props, 'onStick', e, _this.props);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "unstick", function (e, bound) {
	      _this.setState({
	        bound: bound,
	        sticky: false
	      });
	
	      (0, _invoke2["default"])(_this.props, 'onUnstick', e, _this.props);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "stickToContextBottom", function (e) {
	      (0, _invoke2["default"])(_this.props, 'onBottom', e, _this.props);
	
	      _this.stick(e, true);
	
	      _this.pushing(true);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "stickToContextTop", function (e) {
	      (0, _invoke2["default"])(_this.props, 'onTop', e, _this.props);
	
	      _this.unstick(e, false);
	
	      _this.pushing(false);
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "stickToScreenBottom", function (e) {
	      var bottom = _this.props.bottomOffset;
	
	      _this.stick(e, false);
	
	      _this.setState({
	        bottom: bottom,
	        top: null
	      });
	    });
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "stickToScreenTop", function (e) {
	      var top = _this.props.offset;
	
	      _this.stick(e, false);
	
	      _this.setState({
	        top: top,
	        bottom: null
	      });
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Sticky, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!(0, _lib.isBrowser)()) return;
	      var active = this.props.active;
	
	      if (active) {
	        this.handleUpdate();
	        this.addListeners(this.props);
	      }
	    } // eslint-disable-next-line camelcase
	
	  }, {
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          current = _this$props.active,
	          currentScrollContext = _this$props.scrollContext;
	      var next = nextProps.active,
	          nextScrollContext = nextProps.scrollContext;
	
	      if (current === next) {
	        if (currentScrollContext !== nextScrollContext) {
	          this.removeListeners();
	          this.addListeners(nextProps);
	        }
	
	        return;
	      }
	
	      if (next) {
	        this.handleUpdate();
	        this.addListeners(nextProps);
	        return;
	      }
	
	      this.removeListeners();
	      this.setState({
	        sticky: false
	      });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (!(0, _lib.isBrowser)()) return;
	      var active = this.props.active;
	
	      if (active) {
	        this.removeListeners();
	        cancelAnimationFrame(this.frameId);
	      }
	    } // ----------------------------------------
	    // Events
	    // ----------------------------------------
	
	  }, {
	    key: "computeStyle",
	    value: function computeStyle() {
	      var styleElement = this.props.styleElement;
	      var _this$state = this.state,
	          bottom = _this$state.bottom,
	          bound = _this$state.bound,
	          sticky = _this$state.sticky,
	          top = _this$state.top;
	      if (!sticky) return styleElement;
	      return (0, _objectSpread2["default"])({
	        bottom: bound ? 0 : bottom,
	        top: bound ? undefined : top,
	        width: this.triggerRect.width
	      }, styleElement);
	    } // Return true when the component reached the bottom of the context
	
	  }, {
	    key: "render",
	    // ----------------------------------------
	    // Render
	    // ----------------------------------------
	    value: function render() {
	      var _this$props2 = this.props,
	          children = _this$props2.children,
	          className = _this$props2.className;
	      var _this$state2 = this.state,
	          bottom = _this$state2.bottom,
	          bound = _this$state2.bound,
	          sticky = _this$state2.sticky;
	      var rest = (0, _lib.getUnhandledProps)(Sticky, this.props);
	      var ElementType = (0, _lib.getElementType)(Sticky, this.props);
	      var containerClasses = (0, _classnames["default"])(sticky && 'ui', sticky && 'stuck-container', sticky && (bound ? 'bound-container' : 'fixed-container'), className);
	      var elementClasses = (0, _classnames["default"])('ui', sticky && (bound ? 'bound bottom' : 'fixed'), sticky && !bound && (bottom === null ? 'top' : 'bottom'), 'sticky');
	      var triggerStyles = sticky && this.stickyRect ? {
	        height: this.stickyRect.height
	      } : {};
	      return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	        className: containerClasses
	      }), _react["default"].createElement("div", {
	        ref: this.triggerRef,
	        style: triggerStyles
	      }), _react["default"].createElement("div", {
	        className: elementClasses,
	        ref: this.stickyRef,
	        style: this.computeStyle()
	      }, children));
	    }
	  }]);
	  return Sticky;
	}(_react.Component);
	
	exports["default"] = Sticky;
	(0, _defineProperty2["default"])(Sticky, "defaultProps", {
	  active: true,
	  bottomOffset: 0,
	  offset: 0,
	  scrollContext: (0, _lib.isBrowser)() ? window : null
	});
	(0, _defineProperty2["default"])(Sticky, "handledProps", ["active", "as", "bottomOffset", "children", "className", "context", "offset", "onBottom", "onStick", "onTop", "onUnstick", "pushing", "scrollContext", "styleElement"]);
	Sticky.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** A Sticky can be active. */
	  active: _propTypes["default"].bool,
	
	  /** Offset in pixels from the bottom of the screen when fixing element to viewport. */
	  bottomOffset: _propTypes["default"].number,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Context which sticky element should stick to. */
	  context: _propTypes["default"].oneOfType([_lib.customPropTypes.domNode, _lib.customPropTypes.refObject]),
	
	  /** Offset in pixels from the top of the screen when fixing element to viewport. */
	  offset: _propTypes["default"].number,
	
	  /**
	   * Callback when element is bound to bottom of parent container.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onBottom: _propTypes["default"].func,
	
	  /**
	   * Callback when element is fixed to page.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onStick: _propTypes["default"].func,
	
	  /**
	   * Callback when element is bound to top of parent container.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onTop: _propTypes["default"].func,
	
	  /**
	   * Callback when element is unfixed from page.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props.
	   */
	  onUnstick: _propTypes["default"].func,
	
	  /** Whether element should be "pushed" by the viewport, attaching to the bottom of the screen when scrolling up. */
	  pushing: _propTypes["default"].bool,
	
	  /** Context which sticky should attach onscroll events. */
	  scrollContext: _propTypes["default"].oneOfType([_lib.customPropTypes.domNode, _lib.customPropTypes.refObject]),
	
	  /** Custom style for sticky element. */
	  styleElement: _propTypes["default"].object
	} : {};

/***/ },
/* 7310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Sticky["default"];
	  }
	});
	
	var _Sticky = _interopRequireDefault(__webpack_require__(7309));

/***/ },
/* 7311 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(37));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(23));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(24));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(28));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(26));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(27));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _map2 = _interopRequireDefault(__webpack_require__(41));
	
	var _get2 = _interopRequireDefault(__webpack_require__(72));
	
	var _invoke2 = _interopRequireDefault(__webpack_require__(30));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _Grid = _interopRequireDefault(__webpack_require__(703));
	
	var _GridColumn = _interopRequireDefault(__webpack_require__(308));
	
	var _Menu = _interopRequireDefault(__webpack_require__(705));
	
	var _TabPane = _interopRequireDefault(__webpack_require__(764));
	
	/**
	 * A Tab is a hidden section of content activated by a Menu.
	 * @see Menu
	 * @see Segment
	 */
	var Tab =
	/*#__PURE__*/
	function (_Component) {
	  (0, _inherits2["default"])(Tab, _Component);
	
	  function Tab() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2["default"])(this, Tab);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Tab)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleItemClick", function (e, _ref) {
	      var index = _ref.index;
	      (0, _invoke2["default"])(_this.props, 'onTabChange', e, (0, _objectSpread2["default"])({}, _this.props, {
	        activeIndex: index
	      }));
	
	      _this.trySetState({
	        activeIndex: index
	      });
	    });
	    return _this;
	  }
	
	  (0, _createClass2["default"])(Tab, [{
	    key: "getInitialAutoControlledState",
	    value: function getInitialAutoControlledState() {
	      return {
	        activeIndex: 0
	      };
	    }
	  }, {
	    key: "renderItems",
	    value: function renderItems() {
	      var _this$props = this.props,
	          panes = _this$props.panes,
	          renderActiveOnly = _this$props.renderActiveOnly;
	      var activeIndex = this.state.activeIndex;
	      if (renderActiveOnly) return (0, _invoke2["default"])((0, _get2["default"])(panes, "[".concat(activeIndex, "]")), 'render', this.props);
	      return (0, _map2["default"])(panes, function (_ref2, index) {
	        var pane = _ref2.pane;
	        return _TabPane["default"].create(pane, {
	          overrideProps: {
	            active: index === activeIndex
	          }
	        });
	      });
	    }
	  }, {
	    key: "renderMenu",
	    value: function renderMenu() {
	      var _this$props2 = this.props,
	          menu = _this$props2.menu,
	          panes = _this$props2.panes,
	          menuPosition = _this$props2.menuPosition;
	      var activeIndex = this.state.activeIndex;
	
	      if (menu.tabular === true && menuPosition === 'right') {
	        menu.tabular = 'right';
	      }
	
	      return _Menu["default"].create(menu, {
	        autoGenerateKey: false,
	        overrideProps: {
	          items: (0, _map2["default"])(panes, 'menuItem'),
	          onItemClick: this.handleItemClick,
	          activeIndex: activeIndex
	        }
	      });
	    }
	  }, {
	    key: "renderVertical",
	    value: function renderVertical(menu) {
	      var _this$props3 = this.props,
	          grid = _this$props3.grid,
	          menuPosition = _this$props3.menuPosition;
	      var paneWidth = grid.paneWidth,
	          tabWidth = grid.tabWidth,
	          gridProps = (0, _objectWithoutProperties2["default"])(grid, ["paneWidth", "tabWidth"]);
	      var position = menuPosition || menu.props.tabular === 'right' && 'right' || 'left';
	      return _react["default"].createElement(_Grid["default"], gridProps, position === 'left' && _GridColumn["default"].create({
	        width: tabWidth,
	        children: menu
	      }, {
	        autoGenerateKey: false
	      }), _GridColumn["default"].create({
	        width: paneWidth,
	        children: this.renderItems(),
	        stretched: true
	      }, {
	        autoGenerateKey: false
	      }), position === 'right' && _GridColumn["default"].create({
	        width: tabWidth,
	        children: menu
	      }, {
	        autoGenerateKey: false
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var menu = this.renderMenu();
	      var rest = (0, _lib.getUnhandledProps)(Tab, this.props);
	      var ElementType = (0, _lib.getElementType)(Tab, this.props);
	
	      if (menu.props.vertical) {
	        return _react["default"].createElement(ElementType, rest, this.renderVertical(menu));
	      }
	
	      return _react["default"].createElement(ElementType, rest, menu.props.attached !== 'bottom' && menu, this.renderItems(), menu.props.attached === 'bottom' && menu);
	    }
	  }]);
	  return Tab;
	}(_lib.AutoControlledComponent);
	
	(0, _defineProperty2["default"])(Tab, "autoControlledProps", ['activeIndex']);
	(0, _defineProperty2["default"])(Tab, "defaultProps", {
	  grid: {
	    paneWidth: 12,
	    tabWidth: 4
	  },
	  menu: {
	    attached: true,
	    tabular: true
	  },
	  renderActiveOnly: true
	});
	(0, _defineProperty2["default"])(Tab, "Pane", _TabPane["default"]);
	(0, _defineProperty2["default"])(Tab, "handledProps", ["activeIndex", "as", "defaultActiveIndex", "grid", "menu", "menuPosition", "onTabChange", "panes", "renderActiveOnly"]);
	Tab.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** The initial activeIndex. */
	  defaultActiveIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /** Index of the currently active tab. */
	  activeIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	
	  /**
	   * Shorthand props for the Menu.
	   * tabular, if true, will derive final value from `menuPosition`, otherwise set 'left' or 'right' explicitly.
	   */
	  menu: _propTypes["default"].object,
	
	  /** Align vertical menu */
	  menuPosition: _propTypes["default"].oneOf(['left', 'right']),
	
	  /** Shorthand props for the Grid. */
	  grid: _propTypes["default"].object,
	
	  /**
	   * Called on tab change.
	   *
	   * @param {SyntheticEvent} event - React's original SyntheticEvent.
	   * @param {object} data - All props and proposed new activeIndex.
	   * @param {object} data.activeIndex - The new proposed activeIndex.
	   */
	  onTabChange: _propTypes["default"].func,
	
	  /**
	   * Array of objects describing each Menu.Item and Tab.Pane:
	   * { menuItem: 'Home', render: () => <Tab.Pane /> }
	   * or
	   * { menuItem: 'Home', pane: 'Welcome' }
	   */
	  panes: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    menuItem: _lib.customPropTypes.itemShorthand,
	    pane: _lib.customPropTypes.itemShorthand,
	    render: _propTypes["default"].func
	  })),
	
	  /** A Tab can render only active pane. */
	  renderActiveOnly: _propTypes["default"].bool
	} : {};
	var _default = Tab;
	exports["default"] = _default;

/***/ },
/* 7312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Tab["default"];
	  }
	});
	
	var _Tab = _interopRequireDefault(__webpack_require__(7311));

/***/ },
/* 7313 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	/**
	 * An ad displays third-party promotional content.
	 */
	function Advertisement(props) {
	  var centered = props.centered,
	      children = props.children,
	      className = props.className,
	      content = props.content,
	      test = props.test,
	      unit = props.unit;
	  var classes = (0, _classnames["default"])('ui', unit, (0, _lib.useKeyOnly)(centered, 'centered'), (0, _lib.useKeyOnly)(test, 'test'), 'ad', className);
	  var rest = (0, _lib.getUnhandledProps)(Advertisement, props);
	  var ElementType = (0, _lib.getElementType)(Advertisement, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes,
	    "data-text": test
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	Advertisement.handledProps = ["as", "centered", "children", "className", "content", "test", "unit"];
	Advertisement.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Center the advertisement. */
	  centered: _propTypes["default"].bool,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand,
	
	  /** Text to be displayed on the advertisement. */
	  test: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].number, _propTypes["default"].string]),
	
	  /** Varies the size of the advertisement. */
	  unit: _propTypes["default"].oneOf(['medium rectangle', 'large rectangle', 'vertical rectangle', 'small rectangle', 'mobile banner', 'banner', 'vertical banner', 'top banner', 'half banner', 'button', 'square button', 'small button', 'skyscraper', 'wide skyscraper', 'leaderboard', 'large leaderboard', 'mobile leaderboard', 'billboard', 'panorama', 'netboard', 'half page', 'square', 'small square']).isRequired
	} : {};
	var _default = Advertisement;
	exports["default"] = _default;

/***/ },
/* 7314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Advertisement["default"];
	  }
	});
	
	var _Advertisement = _interopRequireDefault(__webpack_require__(7313));

/***/ },
/* 7315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _CommentAction = _interopRequireDefault(__webpack_require__(771));
	
	var _CommentActions = _interopRequireDefault(__webpack_require__(772));
	
	var _CommentAuthor = _interopRequireDefault(__webpack_require__(773));
	
	var _CommentAvatar = _interopRequireDefault(__webpack_require__(774));
	
	var _CommentContent = _interopRequireDefault(__webpack_require__(775));
	
	var _CommentGroup = _interopRequireDefault(__webpack_require__(776));
	
	var _CommentMetadata = _interopRequireDefault(__webpack_require__(777));
	
	var _CommentText = _interopRequireDefault(__webpack_require__(778));
	
	/**
	 * A comment displays user feedback to site content.
	 */
	function Comment(props) {
	  var className = props.className,
	      children = props.children,
	      collapsed = props.collapsed,
	      content = props.content;
	  var classes = (0, _classnames["default"])((0, _lib.useKeyOnly)(collapsed, 'collapsed'), 'comment', className);
	  var rest = (0, _lib.getUnhandledProps)(Comment, props);
	  var ElementType = (0, _lib.getElementType)(Comment, props);
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), _lib.childrenUtils.isNil(children) ? content : children);
	}
	
	Comment.handledProps = ["as", "children", "className", "collapsed", "content"];
	Comment.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Comment can be collapsed, or hidden from view. */
	  collapsed: _propTypes["default"].bool,
	
	  /** Shorthand for primary content. */
	  content: _lib.customPropTypes.contentShorthand
	} : {};
	Comment.Author = _CommentAuthor["default"];
	Comment.Action = _CommentAction["default"];
	Comment.Actions = _CommentActions["default"];
	Comment.Avatar = _CommentAvatar["default"];
	Comment.Content = _CommentContent["default"];
	Comment.Group = _CommentGroup["default"];
	Comment.Metadata = _CommentMetadata["default"];
	Comment.Text = _CommentText["default"];
	var _default = Comment;
	exports["default"] = _default;

/***/ },
/* 7316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Comment["default"];
	  }
	});
	
	var _Comment = _interopRequireDefault(__webpack_require__(7315));

/***/ },
/* 7317 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(16));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _without2 = _interopRequireDefault(__webpack_require__(34));
	
	var _map2 = _interopRequireDefault(__webpack_require__(41));
	
	var _classnames = _interopRequireDefault(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _lib = __webpack_require__(12);
	
	var _FeedContent = _interopRequireDefault(__webpack_require__(326));
	
	var _FeedDate = _interopRequireDefault(__webpack_require__(225));
	
	var _FeedEvent = _interopRequireDefault(__webpack_require__(779));
	
	var _FeedExtra = _interopRequireDefault(__webpack_require__(327));
	
	var _FeedLabel = _interopRequireDefault(__webpack_require__(328));
	
	var _FeedLike = _interopRequireDefault(__webpack_require__(329));
	
	var _FeedMeta = _interopRequireDefault(__webpack_require__(330));
	
	var _FeedSummary = _interopRequireDefault(__webpack_require__(331));
	
	var _FeedUser = _interopRequireDefault(__webpack_require__(332));
	
	/**
	 * A feed presents user activity chronologically.
	 */
	function Feed(props) {
	  var children = props.children,
	      className = props.className,
	      events = props.events,
	      size = props.size;
	  var classes = (0, _classnames["default"])('ui', size, 'feed', className);
	  var rest = (0, _lib.getUnhandledProps)(Feed, props);
	  var ElementType = (0, _lib.getElementType)(Feed, props);
	
	  if (!_lib.childrenUtils.isNil(children)) {
	    return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	      className: classes
	    }), children);
	  }
	
	  var eventElements = (0, _map2["default"])(events, function (eventProps) {
	    var childKey = eventProps.childKey,
	        date = eventProps.date,
	        meta = eventProps.meta,
	        summary = eventProps.summary,
	        eventData = (0, _objectWithoutProperties2["default"])(eventProps, ["childKey", "date", "meta", "summary"]);
	    var finalKey = childKey || [date, meta, summary].join('-');
	    return _react["default"].createElement(_FeedEvent["default"], (0, _extends2["default"])({
	      date: date,
	      key: finalKey,
	      meta: meta,
	      summary: summary
	    }, eventData));
	  });
	  return _react["default"].createElement(ElementType, (0, _extends2["default"])({}, rest, {
	    className: classes
	  }), eventElements);
	}
	
	Feed.handledProps = ["as", "children", "className", "events", "size"];
	Feed.propTypes =  false ? {
	  /** An element type to render as (string or function). */
	  as: _propTypes["default"].elementType,
	
	  /** Primary content. */
	  children: _propTypes["default"].node,
	
	  /** Additional classes. */
	  className: _propTypes["default"].string,
	
	  /** Shorthand array of props for FeedEvent. */
	  events: _lib.customPropTypes.collectionShorthand,
	
	  /** A feed can have different sizes. */
	  size: _propTypes["default"].oneOf((0, _without2["default"])(_lib.SUI.SIZES, 'mini', 'tiny', 'medium', 'big', 'huge', 'massive'))
	} : {};
	Feed.Content = _FeedContent["default"];
	Feed.Date = _FeedDate["default"];
	Feed.Event = _FeedEvent["default"];
	Feed.Extra = _FeedExtra["default"];
	Feed.Label = _FeedLabel["default"];
	Feed.Like = _FeedLike["default"];
	Feed.Meta = _FeedMeta["default"];
	Feed.Summary = _FeedSummary["default"];
	Feed.User = _FeedUser["default"];
	var _default = Feed;
	exports["default"] = _default;

/***/ },
/* 7318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Feed["default"];
	  }
	});
	
	var _Feed = _interopRequireDefault(__webpack_require__(7317));

/***/ },
/* 7319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Item["default"];
	  }
	});
	
	var _Item = _interopRequireDefault(__webpack_require__(780));

/***/ },
/* 7320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Statistic["default"];
	  }
	});
	
	var _Statistic = _interopRequireDefault(__webpack_require__(784));

/***/ },
/* 7321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Popper;
	exports.placements = exports.InnerPopper = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(36));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(92));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var _deepEqual = _interopRequireDefault(__webpack_require__(6711));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _popper = _interopRequireDefault(__webpack_require__(6969));
	
	var _Manager = __webpack_require__(337);
	
	var _utils = __webpack_require__(788);
	
	var initialStyle = {
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  opacity: 0,
	  pointerEvents: 'none'
	};
	var initialArrowStyle = {};
	
	var InnerPopper =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerPopper, _React$Component);
	
	  function InnerPopper() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
	      data: undefined,
	      placement: undefined
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "popperInstance", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "popperNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "arrowNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setPopperNode", function (popperNode) {
	      if (!popperNode || _this.popperNode === popperNode) return;
	      (0, _utils.setRef)(_this.props.innerRef, popperNode);
	      _this.popperNode = popperNode;
	
	      _this.updatePopperInstance();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setArrowNode", function (arrowNode) {
	      _this.arrowNode = arrowNode;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "updateStateModifier", {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        var placement = data.placement;
	
	        _this.setState({
	          data: data,
	          placement: placement
	        });
	
	        return data;
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getOptions", function () {
	      return {
	        placement: _this.props.placement,
	        eventsEnabled: _this.props.eventsEnabled,
	        positionFixed: _this.props.positionFixed,
	        modifiers: (0, _extends2.default)({}, _this.props.modifiers, {
	          arrow: (0, _extends2.default)({}, _this.props.modifiers && _this.props.modifiers.arrow, {
	            enabled: !!_this.arrowNode,
	            element: _this.arrowNode
	          }),
	          applyStyle: {
	            enabled: false
	          },
	          updateStateModifier: _this.updateStateModifier
	        })
	      };
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getPopperStyle", function () {
	      return !_this.popperNode || !_this.state.data ? initialStyle : (0, _extends2.default)({
	        position: _this.state.data.offsets.popper.position
	      }, _this.state.data.styles);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getPopperPlacement", function () {
	      return !_this.state.data ? undefined : _this.state.placement;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getArrowStyle", function () {
	      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getOutOfBoundariesState", function () {
	      return _this.state.data ? _this.state.data.hide : undefined;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "destroyPopperInstance", function () {
	      if (!_this.popperInstance) return;
	
	      _this.popperInstance.destroy();
	
	      _this.popperInstance = null;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "updatePopperInstance", function () {
	      _this.destroyPopperInstance();
	
	      var _assertThisInitialize = (0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)),
	          popperNode = _assertThisInitialize.popperNode;
	
	      var referenceElement = _this.props.referenceElement;
	      if (!referenceElement || !popperNode) return;
	      _this.popperInstance = new _popper.default(referenceElement, popperNode, _this.getOptions());
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "scheduleUpdate", function () {
	      if (_this.popperInstance) {
	        _this.popperInstance.scheduleUpdate();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = InnerPopper.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    // If the Popper.js options have changed, update the instance (destroy + create)
	    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !(0, _deepEqual.default)(this.props.modifiers, prevProps.modifiers, {
	      strict: true
	    })) {
	      // develop only check that modifiers isn't being updated needlessly
	      if (false) {
	        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && (0, _utils.shallowEqual)(this.props.modifiers, prevProps.modifiers)) {
	          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
	        }
	      }
	
	      this.updatePopperInstance();
	    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
	      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
	    } // A placement difference in state means popper determined a new placement
	    // apart from the props value. By the time the popper element is rendered with
	    // the new position Popper has already measured it, if the place change triggers
	    // a size change it will result in a misaligned popper. So we schedule an update to be sure.
	
	
	    if (prevState.placement !== this.state.placement) {
	      this.scheduleUpdate();
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.setRef)(this.props.innerRef, null);
	    this.destroyPopperInstance();
	  };
	
	  _proto.render = function render() {
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.setPopperNode,
	      style: this.getPopperStyle(),
	      placement: this.getPopperPlacement(),
	      outOfBoundaries: this.getOutOfBoundariesState(),
	      scheduleUpdate: this.scheduleUpdate,
	      arrowProps: {
	        ref: this.setArrowNode,
	        style: this.getArrowStyle()
	      }
	    });
	  };
	
	  return InnerPopper;
	}(React.Component);
	
	exports.InnerPopper = InnerPopper;
	(0, _defineProperty2.default)(InnerPopper, "defaultProps", {
	  placement: 'bottom',
	  eventsEnabled: true,
	  referenceElement: undefined,
	  positionFixed: false
	});
	var placements = _popper.default.placements;
	exports.placements = placements;
	
	function Popper(_ref) {
	  var referenceElement = _ref.referenceElement,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["referenceElement"]);
	  return React.createElement(_Manager.ManagerReferenceNodeContext.Consumer, null, function (referenceNode) {
	    return React.createElement(InnerPopper, (0, _extends2.default)({
	      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
	    }, props));
	  });
	}

/***/ },
/* 7322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Reference;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(4));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(92));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(25));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(21));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _warning = _interopRequireDefault(__webpack_require__(227));
	
	var _Manager = __webpack_require__(337);
	
	var _utils = __webpack_require__(788);
	
	var InnerReference =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerReference, _React$Component);
	
	  function InnerReference() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "refHandler", function (node) {
	      (0, _utils.setRef)(_this.props.innerRef, node);
	      (0, _utils.safeInvoke)(_this.props.setReferenceNode, node);
	    });
	    return _this;
	  }
	
	  var _proto = InnerReference.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.setRef)(this.props.innerRef, null);
	  };
	
	  _proto.render = function render() {
	    (0, _warning.default)(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.refHandler
	    });
	  };
	
	  return InnerReference;
	}(React.Component);
	
	function Reference(props) {
	  return React.createElement(_Manager.ManagerReferenceNodeSetterContext.Consumer, null, function (setReferenceNode) {
	    return React.createElement(InnerReference, (0, _extends2.default)({
	      setReferenceNode: setReferenceNode
	    }, props));
	  });
	}

/***/ },
/* 7323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(7);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Popper", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	Object.defineProperty(exports, "placements", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.placements;
	  }
	});
	Object.defineProperty(exports, "Manager", {
	  enumerable: true,
	  get: function get() {
	    return _Manager.default;
	  }
	});
	Object.defineProperty(exports, "Reference", {
	  enumerable: true,
	  get: function get() {
	    return _Reference.default;
	  }
	});
	
	var _Popper = _interopRequireWildcard(__webpack_require__(7321));
	
	var _Manager = _interopRequireDefault(__webpack_require__(337));
	
	var _Reference = _interopRequireDefault(__webpack_require__(7322));

/***/ },
/* 7324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(442);
	var define = __webpack_require__(256);
	var hasDescriptors = __webpack_require__(260)();
	var gOPD = __webpack_require__(115);
	
	var $TypeError = __webpack_require__(114);
	var $floor = GetIntrinsic('%Math.floor%');
	
	/** @type {import('.')} */
	module.exports = function setFunctionLength(fn, length) {
		if (typeof fn !== 'function') {
			throw new $TypeError('`fn` is not a function');
		}
		if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
			throw new $TypeError('`length` must be a positive 32-bit integer');
		}
	
		var loose = arguments.length > 2 && !!arguments[2];
	
		var functionLengthIsConfigurable = true;
		var functionLengthIsWritable = true;
		if ('length' in fn && gOPD) {
			var desc = gOPD(fn, 'length');
			if (desc && !desc.configurable) {
				functionLengthIsConfigurable = false;
			}
			if (desc && !desc.writable) {
				functionLengthIsWritable = false;
			}
		}
	
		if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
			if (hasDescriptors) {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
			} else {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
			}
		}
		return fn;
	};


/***/ },
/* 7325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(256);
	var hasDescriptors = __webpack_require__(260)();
	var functionsHaveConfigurableNames = __webpack_require__(6733).functionsHaveConfigurableNames();
	
	var $TypeError = __webpack_require__(114);
	
	/** @type {import('.')} */
	module.exports = function setFunctionName(fn, name) {
		if (typeof fn !== 'function') {
			throw new $TypeError('`fn` is not a function');
		}
		var loose = arguments.length > 2 && !!arguments[2];
		if (!loose || functionsHaveConfigurableNames) {
			if (hasDescriptors) {
				define(/** @type {Parameters<define>[0]} */ (fn), 'name', name, true, true);
			} else {
				define(/** @type {Parameters<define>[0]} */ (fn), 'name', name);
			}
		}
		return fn;
	};


/***/ },
/* 7326 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(90)))

/***/ },
/* 7327 */
/***/ function(module, exports) {

	module.exports = function (Buffer) {
	
	  //prototype class for hash functions
	  function Hash (blockSize, finalSize) {
	    this._block = new Buffer(blockSize) //new Uint32Array(blockSize/4)
	    this._finalSize = finalSize
	    this._blockSize = blockSize
	    this._len = 0
	    this._s = 0
	  }
	
	  Hash.prototype.init = function () {
	    this._s = 0
	    this._len = 0
	  }
	
	  Hash.prototype.update = function (data, enc) {
	    if ("string" === typeof data) {
	      enc = enc || "utf8"
	      data = new Buffer(data, enc)
	    }
	
	    var l = this._len += data.length
	    var s = this._s = (this._s || 0)
	    var f = 0
	    var buffer = this._block
	
	    while (s < l) {
	      var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
	      var ch = (t - f)
	
	      for (var i = 0; i < ch; i++) {
	        buffer[(s % this._blockSize) + i] = data[i + f]
	      }
	
	      s += ch
	      f += ch
	
	      if ((s % this._blockSize) === 0) {
	        this._update(buffer)
	      }
	    }
	    this._s = s
	
	    return this
	  }
	
	  Hash.prototype.digest = function (enc) {
	    // Suppose the length of the message M, in bits, is l
	    var l = this._len * 8
	
	    // Append the bit 1 to the end of the message
	    this._block[this._len % this._blockSize] = 0x80
	
	    // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	    this._block.fill(0, this._len % this._blockSize + 1)
	
	    if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	      this._update(this._block)
	      this._block.fill(0)
	    }
	
	    // to this append the block which is equal to the number l written in binary
	    // TODO: handle case where l is > Math.pow(2, 29)
	    this._block.writeInt32BE(l, this._blockSize - 4)
	
	    var hash = this._update(this._block) || this._hash()
	
	    return enc ? hash.toString(enc) : hash
	  }
	
	  Hash.prototype._update = function () {
	    throw new Error('_update must be implemented by subclass')
	  }
	
	  return Hash
	}


/***/ },
/* 7328 */
/***/ function(module, exports, __webpack_require__) {

	var exports = module.exports = function (alg) {
	  var Alg = exports[alg]
	  if(!Alg) throw new Error(alg + ' is not supported (we accept pull requests)')
	  return new Alg()
	}
	
	var Buffer = __webpack_require__(39).Buffer
	var Hash   = __webpack_require__(7327)(Buffer)
	
	exports.sha1 = __webpack_require__(7329)(Buffer, Hash)
	exports.sha256 = __webpack_require__(7330)(Buffer, Hash)
	exports.sha512 = __webpack_require__(7331)(Buffer, Hash)


/***/ },
/* 7329 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(339).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var A = 0|0
	  var B = 4|0
	  var C = 8|0
	  var D = 12|0
	  var E = 16|0
	
	  var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80)
	
	  var POOL = []
	
	  function Sha1 () {
	    if(POOL.length)
	      return POOL.pop().init()
	
	    if(!(this instanceof Sha1)) return new Sha1()
	    this._w = W
	    Hash.call(this, 16*4, 14*4)
	
	    this._h = null
	    this.init()
	  }
	
	  inherits(Sha1, Hash)
	
	  Sha1.prototype.init = function () {
	    this._a = 0x67452301
	    this._b = 0xefcdab89
	    this._c = 0x98badcfe
	    this._d = 0x10325476
	    this._e = 0xc3d2e1f0
	
	    Hash.prototype.init.call(this)
	    return this
	  }
	
	  Sha1.prototype._POOL = POOL
	  Sha1.prototype._update = function (X) {
	
	    var a, b, c, d, e, _a, _b, _c, _d, _e
	
	    a = _a = this._a
	    b = _b = this._b
	    c = _c = this._c
	    d = _d = this._d
	    e = _e = this._e
	
	    var w = this._w
	
	    for(var j = 0; j < 80; j++) {
	      var W = w[j] = j < 16 ? X.readInt32BE(j*4)
	        : rol(w[j - 3] ^ w[j -  8] ^ w[j - 14] ^ w[j - 16], 1)
	
	      var t = add(
	        add(rol(a, 5), sha1_ft(j, b, c, d)),
	        add(add(e, W), sha1_kt(j))
	      )
	
	      e = d
	      d = c
	      c = rol(b, 30)
	      b = a
	      a = t
	    }
	
	    this._a = add(a, _a)
	    this._b = add(b, _b)
	    this._c = add(c, _c)
	    this._d = add(d, _d)
	    this._e = add(e, _e)
	  }
	
	  Sha1.prototype._hash = function () {
	    if(POOL.length < 100) POOL.push(this)
	    var H = new Buffer(20)
	    //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
	    H.writeInt32BE(this._a|0, A)
	    H.writeInt32BE(this._b|0, B)
	    H.writeInt32BE(this._c|0, C)
	    H.writeInt32BE(this._d|0, D)
	    H.writeInt32BE(this._e|0, E)
	    return H
	  }
	
	  /*
	   * Perform the appropriate triplet combination function for the current
	   * iteration
	   */
	  function sha1_ft(t, b, c, d) {
	    if(t < 20) return (b & c) | ((~b) & d);
	    if(t < 40) return b ^ c ^ d;
	    if(t < 60) return (b & c) | (b & d) | (c & d);
	    return b ^ c ^ d;
	  }
	
	  /*
	   * Determine the appropriate additive constant for the current iteration
	   */
	  function sha1_kt(t) {
	    return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
	           (t < 60) ? -1894007588 : -899497514;
	  }
	
	  /*
	   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	   * to work around bugs in some JS interpreters.
	   * //dominictarr: this is 10 years old, so maybe this can be dropped?)
	   *
	   */
	  function add(x, y) {
	    return (x + y ) | 0
	  //lets see how this goes on testling.
	  //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  //  return (msw << 16) | (lsw & 0xFFFF);
	  }
	
	  /*
	   * Bitwise rotate a 32-bit number to the left.
	   */
	  function rol(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt));
	  }
	
	  return Sha1
	}


/***/ },
/* 7330 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(339).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var K = [
	      0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	      0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	      0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	      0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	      0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	      0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	      0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	      0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	      0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	      0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	      0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	      0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	      0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	      0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	      0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	      0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	    ]
	
	  var W = new Array(64)
	
	  function Sha256() {
	    this.init()
	
	    this._w = W //new Array(64)
	
	    Hash.call(this, 16*4, 14*4)
	  }
	
	  inherits(Sha256, Hash)
	
	  Sha256.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, n) {
	    return (X >>> n) | (X << (32 - n));
	  }
	
	  function R (X, n) {
	    return (X >>> n);
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  function Sigma0256 (x) {
	    return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
	  }
	
	  function Sigma1256 (x) {
	    return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
	  }
	
	  function Gamma0256 (x) {
	    return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
	  }
	
	  function Gamma1256 (x) {
	    return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
	  }
	
	  Sha256.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var T1, T2
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    for (var j = 0; j < 64; j++) {
	      var w = W[j] = j < 16
	        ? M.readInt32BE(j * 4)
	        : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16]
	
	      T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w
	
	      T2 = Sigma0256(a) + Maj(a, b, c);
	      h = g; g = f; f = e; e = d + T1; d = c; c = b; b = a; a = T1 + T2;
	    }
	
	    this._a = (a + this._a) | 0
	    this._b = (b + this._b) | 0
	    this._c = (c + this._c) | 0
	    this._d = (d + this._d) | 0
	    this._e = (e + this._e) | 0
	    this._f = (f + this._f) | 0
	    this._g = (g + this._g) | 0
	    this._h = (h + this._h) | 0
	
	  };
	
	  Sha256.prototype._hash = function () {
	    var H = new Buffer(32)
	
	    H.writeInt32BE(this._a,  0)
	    H.writeInt32BE(this._b,  4)
	    H.writeInt32BE(this._c,  8)
	    H.writeInt32BE(this._d, 12)
	    H.writeInt32BE(this._e, 16)
	    H.writeInt32BE(this._f, 20)
	    H.writeInt32BE(this._g, 24)
	    H.writeInt32BE(this._h, 28)
	
	    return H
	  }
	
	  return Sha256
	
	}


/***/ },
/* 7331 */
/***/ function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(339).inherits
	
	module.exports = function (Buffer, Hash) {
	  var K = [
	    0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	    0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	    0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	    0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	    0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	    0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	    0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	    0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	    0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	    0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	    0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	    0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	    0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	    0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	    0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	    0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	    0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	    0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	    0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	    0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	    0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	    0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	    0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	    0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	    0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	    0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	    0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	    0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	    0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	    0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	    0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	    0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	    0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	    0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	    0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	    0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	    0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	    0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	    0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	    0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	  ]
	
	  var W = new Array(160)
	
	  function Sha512() {
	    this.init()
	    this._w = W
	
	    Hash.call(this, 128, 112)
	  }
	
	  inherits(Sha512, Hash)
	
	  Sha512.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._al = 0xf3bcc908|0
	    this._bl = 0x84caa73b|0
	    this._cl = 0xfe94f82b|0
	    this._dl = 0x5f1d36f1|0
	    this._el = 0xade682d1|0
	    this._fl = 0x2b3e6c1f|0
	    this._gl = 0xfb41bd6b|0
	    this._hl = 0x137e2179|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, Xl, n) {
	    return (X >>> n) | (Xl << (32 - n))
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  Sha512.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var al, bl, cl, dl, el, fl, gl, hl
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    al = this._al | 0
	    bl = this._bl | 0
	    cl = this._cl | 0
	    dl = this._dl | 0
	    el = this._el | 0
	    fl = this._fl | 0
	    gl = this._gl | 0
	    hl = this._hl | 0
	
	    for (var i = 0; i < 80; i++) {
	      var j = i * 2
	
	      var Wi, Wil
	
	      if (i < 16) {
	        Wi = W[j] = M.readInt32BE(j * 4)
	        Wil = W[j + 1] = M.readInt32BE(j * 4 + 4)
	
	      } else {
	        var x  = W[j - 15*2]
	        var xl = W[j - 15*2 + 1]
	        var gamma0  = S(x, xl, 1) ^ S(x, xl, 8) ^ (x >>> 7)
	        var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7)
	
	        x  = W[j - 2*2]
	        xl = W[j - 2*2 + 1]
	        var gamma1  = S(x, xl, 19) ^ S(xl, x, 29) ^ (x >>> 6)
	        var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6)
	
	        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	        var Wi7  = W[j - 7*2]
	        var Wi7l = W[j - 7*2 + 1]
	
	        var Wi16  = W[j - 16*2]
	        var Wi16l = W[j - 16*2 + 1]
	
	        Wil = gamma0l + Wi7l
	        Wi  = gamma0  + Wi7 + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0)
	        Wil = Wil + gamma1l
	        Wi  = Wi  + gamma1  + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0)
	        Wil = Wil + Wi16l
	        Wi  = Wi  + Wi16 + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0)
	
	        W[j] = Wi
	        W[j + 1] = Wil
	      }
	
	      var maj = Maj(a, b, c)
	      var majl = Maj(al, bl, cl)
	
	      var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7)
	      var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7)
	      var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9)
	      var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9)
	
	      // t1 = h + sigma1 + ch + K[i] + W[i]
	      var Ki = K[j]
	      var Kil = K[j + 1]
	
	      var ch = Ch(e, f, g)
	      var chl = Ch(el, fl, gl)
	
	      var t1l = hl + sigma1l
	      var t1 = h + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0)
	      t1l = t1l + chl
	      t1 = t1 + ch + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0)
	      t1l = t1l + Kil
	      t1 = t1 + Ki + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0)
	      t1l = t1l + Wil
	      t1 = t1 + Wi + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0)
	
	      // t2 = sigma0 + maj
	      var t2l = sigma0l + majl
	      var t2 = sigma0h + maj + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0)
	
	      h  = g
	      hl = gl
	      g  = f
	      gl = fl
	      f  = e
	      fl = el
	      el = (dl + t1l) | 0
	      e  = (d + t1 + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	      d  = c
	      dl = cl
	      c  = b
	      cl = bl
	      b  = a
	      bl = al
	      al = (t1l + t2l) | 0
	      a  = (t1 + t2 + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0
	    }
	
	    this._al = (this._al + al) | 0
	    this._bl = (this._bl + bl) | 0
	    this._cl = (this._cl + cl) | 0
	    this._dl = (this._dl + dl) | 0
	    this._el = (this._el + el) | 0
	    this._fl = (this._fl + fl) | 0
	    this._gl = (this._gl + gl) | 0
	    this._hl = (this._hl + hl) | 0
	
	    this._a = (this._a + a + ((this._al >>> 0) < (al >>> 0) ? 1 : 0)) | 0
	    this._b = (this._b + b + ((this._bl >>> 0) < (bl >>> 0) ? 1 : 0)) | 0
	    this._c = (this._c + c + ((this._cl >>> 0) < (cl >>> 0) ? 1 : 0)) | 0
	    this._d = (this._d + d + ((this._dl >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	    this._e = (this._e + e + ((this._el >>> 0) < (el >>> 0) ? 1 : 0)) | 0
	    this._f = (this._f + f + ((this._fl >>> 0) < (fl >>> 0) ? 1 : 0)) | 0
	    this._g = (this._g + g + ((this._gl >>> 0) < (gl >>> 0) ? 1 : 0)) | 0
	    this._h = (this._h + h + ((this._hl >>> 0) < (hl >>> 0) ? 1 : 0)) | 0
	  }
	
	  Sha512.prototype._hash = function () {
	    var H = new Buffer(64)
	
	    function writeInt64BE(h, l, offset) {
	      H.writeInt32BE(h, offset)
	      H.writeInt32BE(l, offset + 4)
	    }
	
	    writeInt64BE(this._a, this._al, 0)
	    writeInt64BE(this._b, this._bl, 8)
	    writeInt64BE(this._c, this._cl, 16)
	    writeInt64BE(this._d, this._dl, 24)
	    writeInt64BE(this._e, this._el, 32)
	    writeInt64BE(this._f, this._fl, 40)
	    writeInt64BE(this._g, this._gl, 48)
	    writeInt64BE(this._h, this._hl, 56)
	
	    return H
	  }
	
	  return Sha512
	
	}


/***/ },
/* 7332 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(259).EventEmitter;
	var inherits = __webpack_require__(76);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(306);
	Stream.Writable = __webpack_require__(7210);
	Stream.Duplex = __webpack_require__(7205);
	Stream.Transform = __webpack_require__(7209);
	Stream.PassThrough = __webpack_require__(7208);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ },
/* 7333 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(7326);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 7334 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 7335 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 7336 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 7337 */
/***/ function(module, exports) {

	"use strict";function valueOf(e){return e.valueOf?e.valueOf():Object.prototype.valueOf.call(e)}function valueEqual(u,r){if(u===r)return!0;if(null==u||null==r)return!1;if(Array.isArray(u))return Array.isArray(r)&&u.length===r.length&&u.every(function(e,u){return valueEqual(e,r[u])});if("object"!=typeof u&&"object"!=typeof r)return!1;var e=valueOf(u),t=valueOf(r);return e!==u||t!==r?valueEqual(e,t):Object.keys(Object.assign({},u,r)).every(function(e){return valueEqual(u[e],r[e])})}module.exports=valueEqual;


/***/ },
/* 7338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(7337);
	} else {
	  module.exports = require('./cjs/value-equal.js');
	}


/***/ },
/* 7339 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*! cpexcel.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/*jshint -W100 */
	var cptable = {version:"1.15.0"};
	cptable[437] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[620] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàąçêëèïîćÄĄĘęłôöĆûùŚÖÜ¢Ł¥śƒŹŻóÓńŃźż¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[737] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[850] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[852] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[857] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[861] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[865] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[866] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[874] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[895] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ČüéďäĎŤčěĚĹÍľǪÄÁÉžŽôöÓůÚýÖÜŠĽÝŘťáíóúňŇŮÔšřŕŔ¼§«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[932] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ��������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "����������������������������������������������������������������　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×�÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓�����������∈∋⊆⊇⊂⊃∪∩��������∧∨￢⇒⇔∀∃�����������∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬�������Å‰♯♭♪†‡¶����◯���".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "�������������������������������������������������������������������������������０１２３４５６７８９�������ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ�������ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ����ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん��������������".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "����������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミ�ムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ��������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�����������������������������������������".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "����������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмн�опрстуфхцчшщъыьэюя�������������─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂�����������������������������������������������������������������".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[135] = "����������������������������������������������������������������①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡��������㍻�〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪���������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭���".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "����������������������������������������������������������������院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円�園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改���".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "����������������������������������������������������������������魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫�橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄���".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "����������������������������������������������������������������機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救�朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈���".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "����������������������������������������������������������������掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨�劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向���".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "����������������������������������������������������������������后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降�項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷���".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "����������������������������������������������������������������察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止�死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周���".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "����������������������������������������������������������������宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳�準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾���".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "����������������������������������������������������������������拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨�逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線���".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "����������������������������������������������������������������繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻�操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只���".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "����������������������������������������������������������������叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄�逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓���".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "����������������������������������������������������������������邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬�凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入���".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "����������������������������������������������������������������如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅�楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美���".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "����������������������������������������������������������������鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷�斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋���".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "����������������������������������������������������������������法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆�摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒���".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "����������������������������������������������������������������諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲�沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯���".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "����������������������������������������������������������������蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕��������������������������������������������弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲���".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "����������������������������������������������������������������僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭�凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨���".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "����������������������������������������������������������������咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸�噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩���".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "����������������������������������������������������������������奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀�它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏���".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "����������������������������������������������������������������廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠�怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛���".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "����������������������������������������������������������������戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫�捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼���".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "����������������������������������������������������������������曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎�梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣���".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "����������������������������������������������������������������檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯�麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌���".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[224] = "����������������������������������������������������������������漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝�烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱���".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿�痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬���".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰�窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆���".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷�縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋���".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤�艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈���".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬�蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞���".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧�諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊���".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜�轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮���".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙�閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰���".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃�騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈���".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯�黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙�������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[237] = "����������������������������������������������������������������纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏�塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱���".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙�蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑��ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ￢￤＇＂���".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[250] = "����������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊�兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯���".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "����������������������������������������������������������������涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神�祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙���".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "����������������������������������������������������������������髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑������������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	return {"enc": e, "dec": d }; })();
	cptable[936] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "����������������������������������������������������������������丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪乫乬乭乮乯乲乴乵乶乷乸乹乺乻乼乽乿亀亁亂亃亄亅亇亊�亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂伃伄伅伆伇伈伋伌伒伓伔伕伖伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾伿佀佁佂佄佅佇佈佉佊佋佌佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢�".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "����������������������������������������������������������������侤侫侭侰侱侲侳侴侶侷侸侹侺侻侼侽侾俀俁係俆俇俈俉俋俌俍俒俓俔俕俖俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿倀倁倂倃倄倅倆倇倈倉倊�個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯倰倱倲倳倴倵倶倷倸倹倻倽倿偀偁偂偄偅偆偉偊偋偍偐偑偒偓偔偖偗偘偙偛偝偞偟偠偡偢偣偤偦偧偨偩偪偫偭偮偯偰偱偲偳側偵偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎傏傐傑傒傓傔傕傖傗傘備傚傛傜傝傞傟傠傡傢傤傦傪傫傭傮傯傰傱傳傴債傶傷傸傹傼�".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "����������������������������������������������������������������傽傾傿僀僁僂僃僄僅僆僇僈僉僊僋僌働僎僐僑僒僓僔僕僗僘僙僛僜僝僞僟僠僡僢僣僤僥僨僩僪僫僯僰僱僲僴僶僷僸價僺僼僽僾僿儀儁儂儃億儅儈�儉儊儌儍儎儏儐儑儓儔儕儖儗儘儙儚儛儜儝儞償儠儢儣儤儥儦儧儨儩優儫儬儭儮儯儰儱儲儳儴儵儶儷儸儹儺儻儼儽儾兂兇兊兌兎兏児兒兓兗兘兙兛兝兞兟兠兡兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦冧冨冩冪冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒凓凔凕凖凗�".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "����������������������������������������������������������������凘凙凚凜凞凟凢凣凥処凧凨凩凪凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄剅剆則剈剉剋剎剏剒剓剕剗剘�剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳剴創剶剷剸剹剺剻剼剾劀劃劄劅劆劇劉劊劋劌劍劎劏劑劒劔劕劖劗劘劙劚劜劤劥劦劧劮劯劰労劵劶劷劸効劺劻劼劽勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務勚勛勜勝勞勠勡勢勣勥勦勧勨勩勪勫勬勭勮勯勱勲勳勴勵勶勷勸勻勼勽匁匂匃匄匇匉匊匋匌匎�".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[133] = "����������������������������������������������������������������匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯匰匱匲匳匴匵匶匷匸匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏�厐厑厒厓厔厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯厰厱厲厳厴厵厷厸厹厺厼厽厾叀參叄叅叆叇収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝呞呟呠呡呣呥呧呩呪呫呬呭呮呯呰呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡�".split("");
	for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
	D[134] = "����������������������������������������������������������������咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠員哢哣哤哫哬哯哰哱哴哵哶哷哸哹哻哾唀唂唃唄唅唈唊唋唌唍唎唒唓唕唖唗唘唙唚唜唝唞唟唡唥唦�唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋啌啍啎問啑啒啓啔啗啘啙啚啛啝啞啟啠啢啣啨啩啫啯啰啱啲啳啴啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠喡喢喣喤喥喦喨喩喪喫喬喭單喯喰喲喴営喸喺喼喿嗀嗁嗂嗃嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗嗘嗙嗚嗛嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸嗹嗺嗻嗼嗿嘂嘃嘄嘅�".split("");
	for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
	D[135] = "����������������������������������������������������������������嘆嘇嘊嘋嘍嘐嘑嘒嘓嘔嘕嘖嘗嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀噁噂噃噄噅噆噇噈噉噊噋噏噐噑噒噓噕噖噚噛噝噞噟噠噡�噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽噾噿嚀嚁嚂嚃嚄嚇嚈嚉嚊嚋嚌嚍嚐嚑嚒嚔嚕嚖嚗嚘嚙嚚嚛嚜嚝嚞嚟嚠嚡嚢嚤嚥嚦嚧嚨嚩嚪嚫嚬嚭嚮嚰嚱嚲嚳嚴嚵嚶嚸嚹嚺嚻嚽嚾嚿囀囁囂囃囄囅囆囇囈囉囋囌囍囎囏囐囑囒囓囕囖囘囙囜団囥囦囧囨囩囪囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國圌圍圎圏圐圑�".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "����������������������������������������������������������������園圓圔圕圖圗團圙圚圛圝圞圠圡圢圤圥圦圧圫圱圲圴圵圶圷圸圼圽圿坁坃坄坅坆坈坉坋坒坓坔坕坖坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀�垁垇垈垉垊垍垎垏垐垑垔垕垖垗垘垙垚垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹垺垻垼垽垾垿埀埁埄埅埆埇埈埉埊埌埍埐埑埓埖埗埛埜埞埡埢埣埥埦埧埨埩埪埫埬埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥堦堧堨堩堫堬堭堮堯報堲堳場堶堷堸堹堺堻堼堽�".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "����������������������������������������������������������������堾堿塀塁塂塃塅塆塇塈塉塊塋塎塏塐塒塓塕塖塗塙塚塛塜塝塟塠塡塢塣塤塦塧塨塩塪塭塮塯塰塱塲塳塴塵塶塷塸塹塺塻塼塽塿墂墄墆墇墈墊墋墌�墍墎墏墐墑墔墕墖増墘墛墜墝墠墡墢墣墤墥墦墧墪墫墬墭墮墯墰墱墲墳墴墵墶墷墸墹墺墻墽墾墿壀壂壃壄壆壇壈壉壊壋壌壍壎壏壐壒壓壔壖壗壘壙壚壛壜壝壞壟壠壡壢壣壥壦壧壨壩壪壭壯壱売壴壵壷壸壺壻壼壽壾壿夀夁夃夅夆夈変夊夋夌夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻�".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "����������������������������������������������������������������夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛奜奝奞奟奡奣奤奦奧奨奩奪奫奬奭奮奯奰奱奲奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦�妧妬妭妰妱妳妴妵妶妷妸妺妼妽妿姀姁姂姃姄姅姇姈姉姌姍姎姏姕姖姙姛姞姟姠姡姢姤姦姧姩姪姫姭姮姯姰姱姲姳姴姵姶姷姸姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪娫娬娭娮娯娰娳娵娷娸娹娺娻娽娾娿婁婂婃婄婅婇婈婋婌婍婎婏婐婑婒婓婔婖婗婘婙婛婜婝婞婟婠�".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "����������������������������������������������������������������婡婣婤婥婦婨婩婫婬婭婮婯婰婱婲婳婸婹婻婼婽婾媀媁媂媃媄媅媆媇媈媉媊媋媌媍媎媏媐媑媓媔媕媖媗媘媙媜媝媞媟媠媡媢媣媤媥媦媧媨媩媫媬�媭媮媯媰媱媴媶媷媹媺媻媼媽媿嫀嫃嫄嫅嫆嫇嫈嫊嫋嫍嫎嫏嫐嫑嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬嫭嫮嫯嫰嫲嫳嫴嫵嫶嫷嫸嫹嫺嫻嫼嫽嫾嫿嬀嬁嬂嬃嬄嬅嬆嬇嬈嬊嬋嬌嬍嬎嬏嬐嬑嬒嬓嬔嬕嬘嬙嬚嬛嬜嬝嬞嬟嬠嬡嬢嬣嬤嬥嬦嬧嬨嬩嬪嬫嬬嬭嬮嬯嬰嬱嬳嬵嬶嬸嬹嬺嬻嬼嬽嬾嬿孁孂孃孄孅孆孇�".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "����������������������������������������������������������������孈孉孊孋孌孍孎孏孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏�寑寔寕寖寗寘寙寚寛寜寠寢寣實寧審寪寫寬寭寯寱寲寳寴寵寶寷寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧屨屩屪屫屬屭屰屲屳屴屵屶屷屸屻屼屽屾岀岃岄岅岆岇岉岊岋岎岏岒岓岕岝岞岟岠岡岤岥岦岧岨�".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "����������������������������������������������������������������岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅峆峇峈峉峊峌峍峎峏峐峑峓峔峕峖峗峘峚峛峜峝峞峟峠峢峣峧峩峫峬峮峯峱峲峳峴峵島峷峸峹峺峼峽峾峿崀�崁崄崅崈崉崊崋崌崍崏崐崑崒崓崕崗崘崙崚崜崝崟崠崡崢崣崥崨崪崫崬崯崰崱崲崳崵崶崷崸崹崺崻崼崿嵀嵁嵂嵃嵄嵅嵆嵈嵉嵍嵎嵏嵐嵑嵒嵓嵔嵕嵖嵗嵙嵚嵜嵞嵟嵠嵡嵢嵣嵤嵥嵦嵧嵨嵪嵭嵮嵰嵱嵲嵳嵵嵶嵷嵸嵹嵺嵻嵼嵽嵾嵿嶀嶁嶃嶄嶅嶆嶇嶈嶉嶊嶋嶌嶍嶎嶏嶐嶑嶒嶓嶔嶕嶖嶗嶘嶚嶛嶜嶞嶟嶠�".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "����������������������������������������������������������������嶡嶢嶣嶤嶥嶦嶧嶨嶩嶪嶫嶬嶭嶮嶯嶰嶱嶲嶳嶴嶵嶶嶸嶹嶺嶻嶼嶽嶾嶿巀巁巂巃巄巆巇巈巉巊巋巌巎巏巐巑巒巓巔巕巖巗巘巙巚巜巟巠巣巤巪巬巭�巰巵巶巸巹巺巻巼巿帀帄帇帉帊帋帍帎帒帓帗帞帟帠帡帢帣帤帥帨帩帪師帬帯帰帲帳帴帵帶帹帺帾帿幀幁幃幆幇幈幉幊幋幍幎幏幐幑幒幓幖幗幘幙幚幜幝幟幠幣幤幥幦幧幨幩幪幫幬幭幮幯幰幱幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨庩庪庫庬庮庯庰庱庲庴庺庻庼庽庿廀廁廂廃廄廅�".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "����������������������������������������������������������������廆廇廈廋廌廍廎廏廐廔廕廗廘廙廚廜廝廞廟廠廡廢廣廤廥廦廧廩廫廬廭廮廯廰廱廲廳廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤�弨弫弬弮弰弲弳弴張弶強弸弻弽弾弿彁彂彃彄彅彆彇彈彉彊彋彌彍彎彏彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢徣徤徥徦徧復徫徬徯徰徱徲徳徴徶徸徹徺徻徾徿忀忁忂忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇�".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "����������������������������������������������������������������怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰怱怲怳怴怶怷怸怹怺怽怾恀恄恅恆恇恈恉恊恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀�悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽悾悿惀惁惂惃惄惇惈惉惌惍惎惏惐惒惓惔惖惗惙惛惞惡惢惣惤惥惪惱惲惵惷惸惻惼惽惾惿愂愃愄愅愇愊愋愌愐愑愒愓愔愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬愭愮愯愰愱愲愳愴愵愶愷愸愹愺愻愼愽愾慀慁慂慃慄慅慆�".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "����������������������������������������������������������������慇慉態慍慏慐慒慓慔慖慗慘慙慚慛慜慞慟慠慡慣慤慥慦慩慪慫慬慭慮慯慱慲慳慴慶慸慹慺慻慼慽慾慿憀憁憂憃憄憅憆憇憈憉憊憌憍憏憐憑憒憓憕�憖憗憘憙憚憛憜憞憟憠憡憢憣憤憥憦憪憫憭憮憯憰憱憲憳憴憵憶憸憹憺憻憼憽憿懀懁懃懄懅懆懇應懌懍懎懏懐懓懕懖懗懘懙懚懛懜懝懞懟懠懡懢懣懤懥懧懨懩懪懫懬懭懮懯懰懱懲懳懴懶懷懸懹懺懻懼懽懾戀戁戂戃戄戅戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸戹戺戻戼扂扄扅扆扊�".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "����������������������������������������������������������������扏扐払扖扗扙扚扜扝扞扟扠扡扢扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋抌抍抎抏抐抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁�拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳挴挵挶挷挸挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖捗捘捙捚捛捜捝捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙掚掛掜掝掞掟採掤掦掫掯掱掲掵掶掹掻掽掿揀�".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "����������������������������������������������������������������揁揂揃揅揇揈揊揋揌揑揓揔揕揗揘揙揚換揜揝揟揢揤揥揦揧揨揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆搇搈搉搊損搎搑搒搕搖搗搘搙搚搝搟搢搣搤�搥搧搨搩搫搮搯搰搱搲搳搵搶搷搸搹搻搼搾摀摂摃摉摋摌摍摎摏摐摑摓摕摖摗摙摚摛摜摝摟摠摡摢摣摤摥摦摨摪摫摬摮摯摰摱摲摳摴摵摶摷摻摼摽摾摿撀撁撃撆撈撉撊撋撌撍撎撏撐撓撔撗撘撚撛撜撝撟撠撡撢撣撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆擇擈擉擊擋擌擏擑擓擔擕擖擙據�".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "����������������������������������������������������������������擛擜擝擟擠擡擣擥擧擨擩擪擫擬擭擮擯擰擱擲擳擴擵擶擷擸擹擺擻擼擽擾擿攁攂攃攄攅攆攇攈攊攋攌攍攎攏攐攑攓攔攕攖攗攙攚攛攜攝攞攟攠攡�攢攣攤攦攧攨攩攪攬攭攰攱攲攳攷攺攼攽敀敁敂敃敄敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數敹敺敻敼敽敾敿斀斁斂斃斄斅斆斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱斲斳斴斵斶斷斸斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘旙旚旛旜旝旞旟旡旣旤旪旫�".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "����������������������������������������������������������������旲旳旴旵旸旹旻旼旽旾旿昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷昸昹昺昻昽昿晀時晄晅晆晇晈晉晊晍晎晐晑晘�晙晛晜晝晞晠晢晣晥晧晩晪晫晬晭晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘暙暚暛暜暞暟暠暡暢暣暤暥暦暩暪暫暬暭暯暰暱暲暳暵暶暷暸暺暻暼暽暿曀曁曂曃曄曅曆曇曈曉曊曋曌曍曎曏曐曑曒曓曔曕曖曗曘曚曞曟曠曡曢曣曤曥曧曨曪曫曬曭曮曯曱曵曶書曺曻曽朁朂會�".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "����������������������������������������������������������������朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠朡朢朣朤朥朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗杘杙杚杛杝杢杣杤杦杧杫杬杮東杴杶�杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹枺枻枼枽枾枿柀柂柅柆柇柈柉柊柋柌柍柎柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵柶柷柸柹柺査柼柾栁栂栃栄栆栍栐栒栔栕栘栙栚栛栜栞栟栠栢栣栤栥栦栧栨栫栬栭栮栯栰栱栴栵栶栺栻栿桇桋桍桏桒桖桗桘桙桚桛�".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "����������������������������������������������������������������桜桝桞桟桪桬桭桮桯桰桱桲桳桵桸桹桺桻桼桽桾桿梀梂梄梇梈梉梊梋梌梍梎梐梑梒梔梕梖梘梙梚梛梜條梞梟梠梡梣梤梥梩梪梫梬梮梱梲梴梶梷梸�梹梺梻梼梽梾梿棁棃棄棅棆棇棈棊棌棎棏棐棑棓棔棖棗棙棛棜棝棞棟棡棢棤棥棦棧棨棩棪棫棬棭棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆椇椈椉椊椌椏椑椓椔椕椖椗椘椙椚椛検椝椞椡椢椣椥椦椧椨椩椪椫椬椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃楄楅楆楇楈楉楊楋楌楍楎楏楐楑楒楓楕楖楘楙楛楜楟�".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "����������������������������������������������������������������楡楢楤楥楧楨楩楪楬業楯楰楲楳楴極楶楺楻楽楾楿榁榃榅榊榋榌榎榏榐榑榒榓榖榗榙榚榝榞榟榠榡榢榣榤榥榦榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽�榾榿槀槂槃槄槅槆槇槈槉構槍槏槑槒槓槕槖槗様槙槚槜槝槞槡槢槣槤槥槦槧槨槩槪槫槬槮槯槰槱槳槴槵槶槷槸槹槺槻槼槾樀樁樂樃樄樅樆樇樈樉樋樌樍樎樏樐樑樒樓樔樕樖標樚樛樜樝樞樠樢樣樤樥樦樧権樫樬樭樮樰樲樳樴樶樷樸樹樺樻樼樿橀橁橂橃橅橆橈橉橊橋橌橍橎橏橑橒橓橔橕橖橗橚�".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "����������������������������������������������������������������橜橝橞機橠橢橣橤橦橧橨橩橪橫橬橭橮橯橰橲橳橴橵橶橷橸橺橻橽橾橿檁檂檃檅檆檇檈檉檊檋檌檍檏檒檓檔檕檖檘檙檚檛檜檝檞檟檡檢檣檤檥檦�檧檨檪檭檮檯檰檱檲檳檴檵檶檷檸檹檺檻檼檽檾檿櫀櫁櫂櫃櫄櫅櫆櫇櫈櫉櫊櫋櫌櫍櫎櫏櫐櫑櫒櫓櫔櫕櫖櫗櫘櫙櫚櫛櫜櫝櫞櫟櫠櫡櫢櫣櫤櫥櫦櫧櫨櫩櫪櫫櫬櫭櫮櫯櫰櫱櫲櫳櫴櫵櫶櫷櫸櫹櫺櫻櫼櫽櫾櫿欀欁欂欃欄欅欆欇欈欉權欋欌欍欎欏欐欑欒欓欔欕欖欗欘欙欚欛欜欝欞欟欥欦欨欩欪欫欬欭欮�".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "����������������������������������������������������������������欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍歎歏歐歑歒歓歔歕歖歗歘歚歛歜歝歞歟歠歡歨歩歫歬歭歮歯歰歱歲歳歴歵歶歷歸歺歽歾歿殀殅殈�殌殎殏殐殑殔殕殗殘殙殜殝殞殟殠殢殣殤殥殦殧殨殩殫殬殭殮殯殰殱殲殶殸殹殺殻殼殽殾毀毃毄毆毇毈毉毊毌毎毐毑毘毚毜毝毞毟毠毢毣毤毥毦毧毨毩毬毭毮毰毱毲毴毶毷毸毺毻毼毾毿氀氁氂氃氄氈氉氊氋氌氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋汌汍汎汏汑汒汓汖汘�".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "����������������������������������������������������������������汙汚汢汣汥汦汧汫汬汭汮汯汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘�泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟洠洡洢洣洤洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽浾浿涀涁涃涄涆涇涊涋涍涏涐涒涖涗涘涙涚涜涢涥涬涭涰涱涳涴涶涷涹涺涻涼涽涾淁淂淃淈淉淊�".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "����������������������������������������������������������������淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽淾淿渀渁渂渃渄渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵�渶渷渹渻渼渽渾渿湀湁湂湅湆湇湈湉湊湋湌湏湐湑湒湕湗湙湚湜湝湞湠湡湢湣湤湥湦湧湨湩湪湬湭湯湰湱湲湳湴湵湶湷湸湹湺湻湼湽満溁溂溄溇溈溊溋溌溍溎溑溒溓溔溕準溗溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪滫滬滭滮滯�".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "����������������������������������������������������������������滰滱滲滳滵滶滷滸滺滻滼滽滾滿漀漁漃漄漅漇漈漊漋漌漍漎漐漑漒漖漗漘漙漚漛漜漝漞漟漡漢漣漥漦漧漨漬漮漰漲漴漵漷漸漹漺漻漼漽漿潀潁潂�潃潄潅潈潉潊潌潎潏潐潑潒潓潔潕潖潗潙潚潛潝潟潠潡潣潤潥潧潨潩潪潫潬潯潰潱潳潵潶潷潹潻潽潾潿澀澁澂澃澅澆澇澊澋澏澐澑澒澓澔澕澖澗澘澙澚澛澝澞澟澠澢澣澤澥澦澨澩澪澫澬澭澮澯澰澱澲澴澵澷澸澺澻澼澽澾澿濁濃濄濅濆濇濈濊濋濌濍濎濏濐濓濔濕濖濗濘濙濚濛濜濝濟濢濣濤濥�".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "����������������������������������������������������������������濦濧濨濩濪濫濬濭濰濱濲濳濴濵濶濷濸濹濺濻濼濽濾濿瀀瀁瀂瀃瀄瀅瀆瀇瀈瀉瀊瀋瀌瀍瀎瀏瀐瀒瀓瀔瀕瀖瀗瀘瀙瀜瀝瀞瀟瀠瀡瀢瀤瀥瀦瀧瀨瀩瀪�瀫瀬瀭瀮瀯瀰瀱瀲瀳瀴瀶瀷瀸瀺瀻瀼瀽瀾瀿灀灁灂灃灄灅灆灇灈灉灊灋灍灎灐灑灒灓灔灕灖灗灘灙灚灛灜灝灟灠灡灢灣灤灥灦灧灨灩灪灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞炟炠炡炢炣炤炥炦炧炨炩炪炰炲炴炵炶為炾炿烄烅烆烇烉烋烌烍烎烏烐烑烒烓烔烕烖烗烚�".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "����������������������������������������������������������������烜烝烞烠烡烢烣烥烪烮烰烱烲烳烴烵烶烸烺烻烼烾烿焀焁焂焃焄焅焆焇焈焋焌焍焎焏焑焒焔焗焛焜焝焞焟焠無焢焣焤焥焧焨焩焪焫焬焭焮焲焳焴�焵焷焸焹焺焻焼焽焾焿煀煁煂煃煄煆煇煈煉煋煍煏煐煑煒煓煔煕煖煗煘煙煚煛煝煟煠煡煢煣煥煩煪煫煬煭煯煰煱煴煵煶煷煹煻煼煾煿熀熁熂熃熅熆熇熈熉熋熌熍熎熐熑熒熓熕熖熗熚熛熜熝熞熡熢熣熤熥熦熧熩熪熫熭熮熯熰熱熲熴熶熷熸熺熻熼熽熾熿燀燁燂燄燅燆燇燈燉燊燋燌燍燏燐燑燒燓�".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[160] = "����������������������������������������������������������������燖燗燘燙燚燛燜燝燞營燡燢燣燤燦燨燩燪燫燬燭燯燰燱燲燳燴燵燶燷燸燺燻燼燽燾燿爀爁爂爃爄爅爇爈爉爊爋爌爍爎爏爐爑爒爓爔爕爖爗爘爙爚�爛爜爞爟爠爡爢爣爤爥爦爧爩爫爭爮爯爲爳爴爺爼爾牀牁牂牃牄牅牆牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅犆犇犈犉犌犎犐犑犓犔犕犖犗犘犙犚犛犜犝犞犠犡犢犣犤犥犦犧犨犩犪犫犮犱犲犳犵犺犻犼犽犾犿狀狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛�".split("");
	for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
	D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������︵︶︹︺︿﹀︽︾﹁﹂﹃﹄��︻︼︷︸︱�︳︴����������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "����������������������������������������������������������������ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬╭╮╯╰╱╲╳▁▂▃▄▅▆▇�█▉▊▋▌▍▎▏▓▔▕▼▽◢◣◤◥☉⊕〒〝〞�����������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ�ńň�ɡ����ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "����������������������������������������������������������������〡〢〣〤〥〦〧〨〩㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤�℡㈱�‐���ー゛゜ヽヾ〆ゝゞ﹉﹊﹋﹌﹍﹎﹏﹐﹑﹒﹔﹕﹖﹗﹙﹚﹛﹜﹝﹞﹟﹠﹡�﹢﹣﹤﹥﹦﹨﹩﹪﹫�������������〇�������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "����������������������������������������������������������������狜狝狟狢狣狤狥狦狧狪狫狵狶狹狽狾狿猀猂猄猅猆猇猈猉猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀獁獂獃獄獅獆獇獈�獉獊獋獌獎獏獑獓獔獕獖獘獙獚獛獜獝獞獟獡獢獣獤獥獦獧獨獩獪獫獮獰獱�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "����������������������������������������������������������������獲獳獴獵獶獷獸獹獺獻獼獽獿玀玁玂玃玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣玤玥玦玧玨玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃珄珅珆珇�珋珌珎珒珓珔珕珖珗珘珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳珴珵珶珷�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "����������������������������������������������������������������珸珹珺珻珼珽現珿琀琁琂琄琇琈琋琌琍琎琑琒琓琔琕琖琗琘琙琜琝琞琟琠琡琣琤琧琩琫琭琯琱琲琷琸琹琺琻琽琾琿瑀瑂瑃瑄瑅瑆瑇瑈瑉瑊瑋瑌瑍�瑎瑏瑐瑑瑒瑓瑔瑖瑘瑝瑠瑡瑢瑣瑤瑥瑦瑧瑨瑩瑪瑫瑬瑮瑯瑱瑲瑳瑴瑵瑸瑹瑺�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "����������������������������������������������������������������瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑璒璓璔璕璖璗璘璙璚璛璝璟璠璡璢璣璤璥璦璪璫璬璭璮璯環璱璲璳璴璵璶璷璸璹璻璼璽璾璿瓀瓁瓂瓃瓄瓅瓆瓇�瓈瓉瓊瓋瓌瓍瓎瓏瓐瓑瓓瓔瓕瓖瓗瓘瓙瓚瓛瓝瓟瓡瓥瓧瓨瓩瓪瓫瓬瓭瓰瓱瓲�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "����������������������������������������������������������������瓳瓵瓸瓹瓺瓻瓼瓽瓾甀甁甂甃甅甆甇甈甉甊甋甌甎甐甒甔甕甖甗甛甝甞甠甡產産甤甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘�畝畞畟畠畡畢畣畤畧畨畩畫畬畭畮畯異畱畳畵當畷畺畻畼畽畾疀疁疂疄疅疇�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "����������������������������������������������������������������疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦疧疨疩疪疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇�瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "����������������������������������������������������������������癅癆癇癈癉癊癋癎癏癐癑癒癓癕癗癘癙癚癛癝癟癠癡癢癤癥癦癧癨癩癪癬癭癮癰癱癲癳癴癵癶癷癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛�皜皝皞皟皠皡皢皣皥皦皧皨皩皪皫皬皭皯皰皳皵皶皷皸皹皺皻皼皽皾盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "����������������������������������������������������������������盄盇盉盋盌盓盕盙盚盜盝盞盠盡盢監盤盦盧盨盩盪盫盬盭盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎眏眐眑眒眓眔眕眖眗眘眛眜眝眞眡眣眤眥眧眪眫�眬眮眰眱眲眳眴眹眻眽眾眿睂睄睅睆睈睉睊睋睌睍睎睏睒睓睔睕睖睗睘睙睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "����������������������������������������������������������������睝睞睟睠睤睧睩睪睭睮睯睰睱睲睳睴睵睶睷睸睺睻睼瞁瞂瞃瞆瞇瞈瞉瞊瞋瞏瞐瞓瞔瞕瞖瞗瞘瞙瞚瞛瞜瞝瞞瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶瞷瞸瞹瞺�瞼瞾矀矁矂矃矄矅矆矇矈矉矊矋矌矎矏矐矑矒矓矔矕矖矘矙矚矝矞矟矠矡矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "����������������������������������������������������������������矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃砄砅砆砇砈砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚�硛硜硞硟硠硡硢硣硤硥硦硧硨硩硯硰硱硲硳硴硵硶硸硹硺硻硽硾硿碀碁碂碃场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "����������������������������������������������������������������碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨碩碪碫碬碭碮碯碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚磛磜磝磞磟磠磡磢磣�磤磥磦磧磩磪磫磭磮磯磰磱磳磵磶磸磹磻磼磽磾磿礀礂礃礄礆礇礈礉礊礋礌础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "����������������������������������������������������������������礍礎礏礐礑礒礔礕礖礗礘礙礚礛礜礝礟礠礡礢礣礥礦礧礨礩礪礫礬礭礮礯礰礱礲礳礵礶礷礸礹礽礿祂祃祄祅祇祊祋祌祍祎祏祐祑祒祔祕祘祙祡祣�祤祦祩祪祫祬祮祰祱祲祳祴祵祶祹祻祼祽祾祿禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "����������������������������������������������������������������禓禔禕禖禗禘禙禛禜禝禞禟禠禡禢禣禤禥禦禨禩禪禫禬禭禮禯禰禱禲禴禵禶禷禸禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙秚秛秜秝秞秠秡秢秥秨秪�秬秮秱秲秳秴秵秶秷秹秺秼秾秿稁稄稅稇稈稉稊稌稏稐稑稒稓稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "����������������������������������������������������������������稝稟稡稢稤稥稦稧稨稩稪稫稬稭種稯稰稱稲稴稵稶稸稺稾穀穁穂穃穄穅穇穈穉穊穋穌積穎穏穐穒穓穔穕穖穘穙穚穛穜穝穞穟穠穡穢穣穤穥穦穧穨�穩穪穫穬穭穮穯穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "����������������������������������������������������������������窣窤窧窩窪窫窮窯窰窱窲窴窵窶窷窸窹窺窻窼窽窾竀竁竂竃竄竅竆竇竈竉竊竌竍竎竏竐竑竒竓竔竕竗竘竚竛竜竝竡竢竤竧竨竩竪竫竬竮竰竱竲竳�竴竵競竷竸竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "����������������������������������������������������������������笯笰笲笴笵笶笷笹笻笽笿筀筁筂筃筄筆筈筊筍筎筓筕筗筙筜筞筟筡筣筤筥筦筧筨筩筪筫筬筭筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆箇箈箉箊箋箌箎箏�箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹箺箻箼箽箾箿節篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "����������������������������������������������������������������篅篈築篊篋篍篎篏篐篒篔篕篖篗篘篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲篳篴篵篶篸篹篺篻篽篿簀簁簂簃簄簅簆簈簉簊簍簎簐簑簒簓簔簕簗簘簙�簚簛簜簝簞簠簡簢簣簤簥簨簩簫簬簭簮簯簰簱簲簳簴簵簶簷簹簺簻簼簽簾籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "����������������������������������������������������������������籃籄籅籆籇籈籉籊籋籌籎籏籐籑籒籓籔籕籖籗籘籙籚籛籜籝籞籟籠籡籢籣籤籥籦籧籨籩籪籫籬籭籮籯籰籱籲籵籶籷籸籹籺籾籿粀粁粂粃粄粅粆粇�粈粊粋粌粍粎粏粐粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴粵粶粷粸粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "����������������������������������������������������������������粿糀糂糃糄糆糉糋糎糏糐糑糒糓糔糘糚糛糝糞糡糢糣糤糥糦糧糩糪糫糬糭糮糰糱糲糳糴糵糶糷糹糺糼糽糾糿紀紁紂紃約紅紆紇紈紉紋紌納紎紏紐�紑紒紓純紕紖紗紘紙級紛紜紝紞紟紡紣紤紥紦紨紩紪紬紭紮細紱紲紳紴紵紶肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "����������������������������������������������������������������紷紸紹紺紻紼紽紾紿絀絁終絃組絅絆絇絈絉絊絋経絍絎絏結絑絒絓絔絕絖絗絘絙絚絛絜絝絞絟絠絡絢絣絤絥給絧絨絩絪絫絬絭絯絰統絲絳絴絵絶�絸絹絺絻絼絽絾絿綀綁綂綃綄綅綆綇綈綉綊綋綌綍綎綏綐綑綒經綔綕綖綗綘健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "����������������������������������������������������������������継続綛綜綝綞綟綠綡綢綣綤綥綧綨綩綪綫綬維綯綰綱網綳綴綵綶綷綸綹綺綻綼綽綾綿緀緁緂緃緄緅緆緇緈緉緊緋緌緍緎総緐緑緒緓緔緕緖緗緘緙�線緛緜緝緞緟締緡緢緣緤緥緦緧編緩緪緫緬緭緮緯緰緱緲緳練緵緶緷緸緹緺尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "����������������������������������������������������������������緻緼緽緾緿縀縁縂縃縄縅縆縇縈縉縊縋縌縍縎縏縐縑縒縓縔縕縖縗縘縙縚縛縜縝縞縟縠縡縢縣縤縥縦縧縨縩縪縫縬縭縮縯縰縱縲縳縴縵縶縷縸縹�縺縼總績縿繀繂繃繄繅繆繈繉繊繋繌繍繎繏繐繑繒繓織繕繖繗繘繙繚繛繜繝俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "����������������������������������������������������������������繞繟繠繡繢繣繤繥繦繧繨繩繪繫繬繭繮繯繰繱繲繳繴繵繶繷繸繹繺繻繼繽繾繿纀纁纃纄纅纆纇纈纉纊纋續纍纎纏纐纑纒纓纔纕纖纗纘纙纚纜纝纞�纮纴纻纼绖绤绬绹缊缐缞缷缹缻缼缽缾缿罀罁罃罆罇罈罉罊罋罌罍罎罏罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "����������������������������������������������������������������罖罙罛罜罝罞罠罣罤罥罦罧罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂羃羄羅羆羇羈羉羋羍羏羐羑羒羓羕羖羗羘羙羛羜羠羢羣羥羦羨義羪羫羬羭羮羱�羳羴羵羶羷羺羻羾翀翂翃翄翆翇翈翉翋翍翏翐翑習翓翖翗翙翚翛翜翝翞翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "����������������������������������������������������������������翤翧翨翪翫翬翭翯翲翴翵翶翷翸翹翺翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫耬耭耮耯耰耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗�聙聛聜聝聞聟聠聡聢聣聤聥聦聧聨聫聬聭聮聯聰聲聳聴聵聶職聸聹聺聻聼聽隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "����������������������������������������������������������������聾肁肂肅肈肊肍肎肏肐肑肒肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇胈胉胊胋胏胐胑胒胓胔胕胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋�脌脕脗脙脛脜脝脟脠脡脢脣脤脥脦脧脨脩脪脫脭脮脰脳脴脵脷脹脺脻脼脽脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "����������������������������������������������������������������腀腁腂腃腄腅腇腉腍腎腏腒腖腗腘腛腜腝腞腟腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃膄膅膆膇膉膋膌膍膎膐膒膓膔膕膖膗膙膚膞膟膠膡膢膤膥�膧膩膫膬膭膮膯膰膱膲膴膵膶膷膸膹膼膽膾膿臄臅臇臈臉臋臍臎臏臐臑臒臓摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "����������������������������������������������������������������臔臕臖臗臘臙臚臛臜臝臞臟臠臡臢臤臥臦臨臩臫臮臯臰臱臲臵臶臷臸臹臺臽臿舃與興舉舊舋舎舏舑舓舕舖舗舘舙舚舝舠舤舥舦舧舩舮舲舺舼舽舿�艀艁艂艃艅艆艈艊艌艍艎艐艑艒艓艔艕艖艗艙艛艜艝艞艠艡艢艣艤艥艦艧艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "����������������������������������������������������������������艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸�苺苼苽苾苿茀茊茋茍茐茒茓茖茘茙茝茞茟茠茡茢茣茤茥茦茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "����������������������������������������������������������������茾茿荁荂荄荅荈荊荋荌荍荎荓荕荖荗荘荙荝荢荰荱荲荳荴荵荶荹荺荾荿莀莁莂莃莄莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡莢莣莤莥莦莧莬莭莮�莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "����������������������������������������������������������������菮華菳菴菵菶菷菺菻菼菾菿萀萂萅萇萈萉萊萐萒萓萔萕萖萗萙萚萛萞萟萠萡萢萣萩萪萫萬萭萮萯萰萲萳萴萵萶萷萹萺萻萾萿葀葁葂葃葄葅葇葈葉�葊葋葌葍葎葏葐葒葓葔葕葖葘葝葞葟葠葢葤葥葦葧葨葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[201] = "����������������������������������������������������������������葽葾葿蒀蒁蒃蒄蒅蒆蒊蒍蒏蒐蒑蒒蒓蒔蒕蒖蒘蒚蒛蒝蒞蒟蒠蒢蒣蒤蒥蒦蒧蒨蒩蒪蒫蒬蒭蒮蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗�蓘蓙蓚蓛蓜蓞蓡蓢蓤蓧蓨蓩蓪蓫蓭蓮蓯蓱蓲蓳蓴蓵蓶蓷蓸蓹蓺蓻蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "����������������������������������������������������������������蔃蔄蔅蔆蔇蔈蔉蔊蔋蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢蔣蔤蔥蔦蔧蔨蔩蔪蔭蔮蔯蔰蔱蔲蔳蔴蔵蔶蔾蔿蕀蕁蕂蕄蕅蕆蕇蕋蕌蕍蕎蕏蕐蕑蕒蕓蕔蕕�蕗蕘蕚蕛蕜蕝蕟蕠蕡蕢蕣蕥蕦蕧蕩蕪蕫蕬蕭蕮蕯蕰蕱蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "����������������������������������������������������������������薂薃薆薈薉薊薋薌薍薎薐薑薒薓薔薕薖薗薘薙薚薝薞薟薠薡薢薣薥薦薧薩薫薬薭薱薲薳薴薵薶薸薺薻薼薽薾薿藀藂藃藄藅藆藇藈藊藋藌藍藎藑藒�藔藖藗藘藙藚藛藝藞藟藠藡藢藣藥藦藧藨藪藫藬藭藮藯藰藱藲藳藴藵藶藷藸恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "����������������������������������������������������������������藹藺藼藽藾蘀蘁蘂蘃蘄蘆蘇蘈蘉蘊蘋蘌蘍蘎蘏蘐蘒蘓蘔蘕蘗蘘蘙蘚蘛蘜蘝蘞蘟蘠蘡蘢蘣蘤蘥蘦蘨蘪蘫蘬蘭蘮蘯蘰蘱蘲蘳蘴蘵蘶蘷蘹蘺蘻蘽蘾蘿虀�虁虂虃虄虅虆虇虈虉虊虋虌虒虓處虖虗虘虙虛虜虝號虠虡虣虤虥虦虧虨虩虪獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "����������������������������������������������������������������虭虯虰虲虳虴虵虶虷虸蚃蚄蚅蚆蚇蚈蚉蚎蚏蚐蚑蚒蚔蚖蚗蚘蚙蚚蚛蚞蚟蚠蚡蚢蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻蚼蚽蚾蚿蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜�蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "����������������������������������������������������������������蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀蝁蝂蝃蝄蝅蝆蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚蝛蝜蝝蝞蝟蝡蝢蝦蝧蝨蝩蝪蝫蝬蝭蝯蝱蝲蝳蝵�蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎螏螐螑螒螔螕螖螘螙螚螛螜螝螞螠螡螢螣螤巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "����������������������������������������������������������������螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁蟂蟃蟄蟅蟇蟈蟉蟌蟍蟎蟏蟐蟔蟕蟖蟗蟘蟙蟚蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯蟰蟱蟲蟳蟴蟵蟶蟷蟸�蟺蟻蟼蟽蟿蠀蠁蠂蠄蠅蠆蠇蠈蠉蠋蠌蠍蠎蠏蠐蠑蠒蠔蠗蠘蠙蠚蠜蠝蠞蠟蠠蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "����������������������������������������������������������������蠤蠥蠦蠧蠨蠩蠪蠫蠬蠭蠮蠯蠰蠱蠳蠴蠵蠶蠷蠸蠺蠻蠽蠾蠿衁衂衃衆衇衈衉衊衋衎衏衐衑衒術衕衖衘衚衛衜衝衞衟衠衦衧衪衭衯衱衳衴衵衶衸衹衺�衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗袘袙袚袛袝袞袟袠袡袣袥袦袧袨袩袪小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "����������������������������������������������������������������袬袮袯袰袲袳袴袵袶袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚裛補裝裞裠裡裦裧裩裪裫裬裭裮裯裲裵裶裷裺裻製裿褀褁褃褄褅褆複褈�褉褋褌褍褎褏褑褔褕褖褗褘褜褝褞褟褠褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "����������������������������������������������������������������褸褹褺褻褼褽褾褿襀襂襃襅襆襇襈襉襊襋襌襍襎襏襐襑襒襓襔襕襖襗襘襙襚襛襜襝襠襡襢襣襤襥襧襨襩襪襫襬襭襮襯襰襱襲襳襴襵襶襷襸襹襺襼�襽襾覀覂覄覅覇覈覉覊見覌覍覎規覐覑覒覓覔覕視覗覘覙覚覛覜覝覞覟覠覡摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "����������������������������������������������������������������覢覣覤覥覦覧覨覩親覫覬覭覮覯覰覱覲観覴覵覶覷覸覹覺覻覼覽覾覿觀觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴觵觶觷觸觹觺�觻觼觽觾觿訁訂訃訄訅訆計訉訊訋訌訍討訏訐訑訒訓訔訕訖託記訙訚訛訜訝印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "����������������������������������������������������������������訞訟訠訡訢訣訤訥訦訧訨訩訪訫訬設訮訯訰許訲訳訴訵訶訷訸訹診註証訽訿詀詁詂詃詄詅詆詇詉詊詋詌詍詎詏詐詑詒詓詔評詖詗詘詙詚詛詜詝詞�詟詠詡詢詣詤詥試詧詨詩詪詫詬詭詮詯詰話該詳詴詵詶詷詸詺詻詼詽詾詿誀浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "����������������������������������������������������������������誁誂誃誄誅誆誇誈誋誌認誎誏誐誑誒誔誕誖誗誘誙誚誛誜誝語誟誠誡誢誣誤誥誦誧誨誩說誫説読誮誯誰誱課誳誴誵誶誷誸誹誺誻誼誽誾調諀諁諂�諃諄諅諆談諈諉諊請諌諍諎諏諐諑諒諓諔諕論諗諘諙諚諛諜諝諞諟諠諡諢諣铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "����������������������������������������������������������������諤諥諦諧諨諩諪諫諬諭諮諯諰諱諲諳諴諵諶諷諸諹諺諻諼諽諾諿謀謁謂謃謄謅謆謈謉謊謋謌謍謎謏謐謑謒謓謔謕謖謗謘謙謚講謜謝謞謟謠謡謢謣�謤謥謧謨謩謪謫謬謭謮謯謰謱謲謳謴謵謶謷謸謹謺謻謼謽謾謿譀譁譂譃譄譅帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "����������������������������������������������������������������譆譇譈證譊譋譌譍譎譏譐譑譒譓譔譕譖譗識譙譚譛譜譝譞譟譠譡譢譣譤譥譧譨譩譪譫譭譮譯議譱譲譳譴譵譶護譸譹譺譻譼譽譾譿讀讁讂讃讄讅讆�讇讈讉變讋讌讍讎讏讐讑讒讓讔讕讖讗讘讙讚讛讜讝讞讟讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "����������������������������������������������������������������谸谹谺谻谼谽谾谿豀豂豃豄豅豈豊豋豍豎豏豐豑豒豓豔豖豗豘豙豛豜豝豞豟豠豣豤豥豦豧豨豩豬豭豮豯豰豱豲豴豵豶豷豻豼豽豾豿貀貁貃貄貆貇�貈貋貍貎貏貐貑貒貓貕貖貗貙貚貛貜貝貞貟負財貢貣貤貥貦貧貨販貪貫責貭亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "����������������������������������������������������������������貮貯貰貱貲貳貴貵貶買貸貹貺費貼貽貾貿賀賁賂賃賄賅賆資賈賉賊賋賌賍賎賏賐賑賒賓賔賕賖賗賘賙賚賛賜賝賞賟賠賡賢賣賤賥賦賧賨賩質賫賬�賭賮賯賰賱賲賳賴賵賶賷賸賹賺賻購賽賾賿贀贁贂贃贄贅贆贇贈贉贊贋贌贍佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "����������������������������������������������������������������贎贏贐贑贒贓贔贕贖贗贘贙贚贛贜贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸赹赺赻赼赽赾赿趀趂趃趆趇趈趉趌趍趎趏趐趒趓趕趖趗趘趙趚趛趜趝趞趠趡�趢趤趥趦趧趨趩趪趫趬趭趮趯趰趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "����������������������������������������������������������������跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾跿踀踁踂踃踄踆踇踈踋踍踎踐踑踒踓踕踖踗踘踙踚踛踜踠踡踤踥踦踧踨踫踭踰踲踳踴踶踷踸踻踼踾�踿蹃蹅蹆蹌蹍蹎蹏蹐蹓蹔蹕蹖蹗蹘蹚蹛蹜蹝蹞蹟蹠蹡蹢蹣蹤蹥蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "����������������������������������������������������������������蹳蹵蹷蹸蹹蹺蹻蹽蹾躀躂躃躄躆躈躉躊躋躌躍躎躑躒躓躕躖躗躘躙躚躛躝躟躠躡躢躣躤躥躦躧躨躩躪躭躮躰躱躳躴躵躶躷躸躹躻躼躽躾躿軀軁軂�軃軄軅軆軇軈軉車軋軌軍軏軐軑軒軓軔軕軖軗軘軙軚軛軜軝軞軟軠軡転軣軤堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "����������������������������������������������������������������軥軦軧軨軩軪軫軬軭軮軯軰軱軲軳軴軵軶軷軸軹軺軻軼軽軾軿輀輁輂較輄輅輆輇輈載輊輋輌輍輎輏輐輑輒輓輔輕輖輗輘輙輚輛輜輝輞輟輠輡輢輣�輤輥輦輧輨輩輪輫輬輭輮輯輰輱輲輳輴輵輶輷輸輹輺輻輼輽輾輿轀轁轂轃轄荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "����������������������������������������������������������������轅轆轇轈轉轊轋轌轍轎轏轐轑轒轓轔轕轖轗轘轙轚轛轜轝轞轟轠轡轢轣轤轥轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆�迉迊迋迌迍迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "����������������������������������������������������������������這逜連逤逥逧逨逩逪逫逬逰週進逳逴逷逹逺逽逿遀遃遅遆遈遉遊運遌過達違遖遙遚遜遝遞遟遠遡遤遦遧適遪遫遬遯遰遱遲遳遶遷選遹遺遻遼遾邁�還邅邆邇邉邊邌邍邎邏邐邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "����������������������������������������������������������������郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅鄆鄇鄈鄉鄊鄋鄌鄍鄎鄏鄐鄑鄒鄓鄔鄕鄖鄗鄘鄚鄛鄜�鄝鄟鄠鄡鄤鄥鄦鄧鄨鄩鄪鄫鄬鄭鄮鄰鄲鄳鄴鄵鄶鄷鄸鄺鄻鄼鄽鄾鄿酀酁酂酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀醁醂醃醄醆醈醊醎醏醓醔醕醖醗醘醙醜醝醞醟醠醡醤醥醦醧醨醩醫醬醰醱醲醳醶醷醸醹醻�醼醽醾醿釀釁釂釃釄釅釆釈釋釐釒釓釔釕釖釗釘釙釚釛針釞釟釠釡釢釣釤釥帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������釦釧釨釩釪釫釬釭釮釯釰釱釲釳釴釵釶釷釸釹釺釻釼釽釾釿鈀鈁鈂鈃鈄鈅鈆鈇鈈鈉鈊鈋鈌鈍鈎鈏鈐鈑鈒鈓鈔鈕鈖鈗鈘鈙鈚鈛鈜鈝鈞鈟鈠鈡鈢鈣鈤�鈥鈦鈧鈨鈩鈪鈫鈬鈭鈮鈯鈰鈱鈲鈳鈴鈵鈶鈷鈸鈹鈺鈻鈼鈽鈾鈿鉀鉁鉂鉃鉄鉅狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������鉆鉇鉈鉉鉊鉋鉌鉍鉎鉏鉐鉑鉒鉓鉔鉕鉖鉗鉘鉙鉚鉛鉜鉝鉞鉟鉠鉡鉢鉣鉤鉥鉦鉧鉨鉩鉪鉫鉬鉭鉮鉯鉰鉱鉲鉳鉵鉶鉷鉸鉹鉺鉻鉼鉽鉾鉿銀銁銂銃銄銅�銆銇銈銉銊銋銌銍銏銐銑銒銓銔銕銖銗銘銙銚銛銜銝銞銟銠銡銢銣銤銥銦銧恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������銨銩銪銫銬銭銯銰銱銲銳銴銵銶銷銸銹銺銻銼銽銾銿鋀鋁鋂鋃鋄鋅鋆鋇鋉鋊鋋鋌鋍鋎鋏鋐鋑鋒鋓鋔鋕鋖鋗鋘鋙鋚鋛鋜鋝鋞鋟鋠鋡鋢鋣鋤鋥鋦鋧鋨�鋩鋪鋫鋬鋭鋮鋯鋰鋱鋲鋳鋴鋵鋶鋷鋸鋹鋺鋻鋼鋽鋾鋿錀錁錂錃錄錅錆錇錈錉洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������錊錋錌錍錎錏錐錑錒錓錔錕錖錗錘錙錚錛錜錝錞錟錠錡錢錣錤錥錦錧錨錩錪錫錬錭錮錯錰錱録錳錴錵錶錷錸錹錺錻錼錽錿鍀鍁鍂鍃鍄鍅鍆鍇鍈鍉�鍊鍋鍌鍍鍎鍏鍐鍑鍒鍓鍔鍕鍖鍗鍘鍙鍚鍛鍜鍝鍞鍟鍠鍡鍢鍣鍤鍥鍦鍧鍨鍩鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������鍬鍭鍮鍯鍰鍱鍲鍳鍴鍵鍶鍷鍸鍹鍺鍻鍼鍽鍾鍿鎀鎁鎂鎃鎄鎅鎆鎇鎈鎉鎊鎋鎌鎍鎎鎐鎑鎒鎓鎔鎕鎖鎗鎘鎙鎚鎛鎜鎝鎞鎟鎠鎡鎢鎣鎤鎥鎦鎧鎨鎩鎪鎫�鎬鎭鎮鎯鎰鎱鎲鎳鎴鎵鎶鎷鎸鎹鎺鎻鎼鎽鎾鎿鏀鏁鏂鏃鏄鏅鏆鏇鏈鏉鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������鏎鏏鏐鏑鏒鏓鏔鏕鏗鏘鏙鏚鏛鏜鏝鏞鏟鏠鏡鏢鏣鏤鏥鏦鏧鏨鏩鏪鏫鏬鏭鏮鏯鏰鏱鏲鏳鏴鏵鏶鏷鏸鏹鏺鏻鏼鏽鏾鏿鐀鐁鐂鐃鐄鐅鐆鐇鐈鐉鐊鐋鐌鐍�鐎鐏鐐鐑鐒鐓鐔鐕鐖鐗鐘鐙鐚鐛鐜鐝鐞鐟鐠鐡鐢鐣鐤鐥鐦鐧鐨鐩鐪鐫鐬鐭鐮纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������鐯鐰鐱鐲鐳鐴鐵鐶鐷鐸鐹鐺鐻鐼鐽鐿鑀鑁鑂鑃鑄鑅鑆鑇鑈鑉鑊鑋鑌鑍鑎鑏鑐鑑鑒鑓鑔鑕鑖鑗鑘鑙鑚鑛鑜鑝鑞鑟鑠鑡鑢鑣鑤鑥鑦鑧鑨鑩鑪鑬鑭鑮鑯�鑰鑱鑲鑳鑴鑵鑶鑷鑸鑹鑺鑻鑼鑽鑾鑿钀钁钂钃钄钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������锧锳锽镃镈镋镕镚镠镮镴镵長镸镹镺镻镼镽镾門閁閂閃閄閅閆閇閈閉閊開閌閍閎閏閐閑閒間閔閕閖閗閘閙閚閛閜閝閞閟閠閡関閣閤閥閦閧閨閩閪�閫閬閭閮閯閰閱閲閳閴閵閶閷閸閹閺閻閼閽閾閿闀闁闂闃闄闅闆闇闈闉闊闋椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������闌闍闎闏闐闑闒闓闔闕闖闗闘闙闚闛關闝闞闟闠闡闢闣闤闥闦闧闬闿阇阓阘阛阞阠阣阤阥阦阧阨阩阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗�陘陙陚陜陝陞陠陣陥陦陫陭陮陯陰陱陳陸陹険陻陼陽陾陿隀隁隂隃隄隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "����������������������������������������������������������������隌階隑隒隓隕隖隚際隝隞隟隠隡隢隣隤隥隦隨隩險隫隬隭隮隯隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖雗雘雙雚雛雜雝雞雟雡離難雤雥雦雧雫�雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗霘霙霚霛霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "����������������������������������������������������������������霡霢霣霤霥霦霧霨霩霫霬霮霯霱霳霴霵霶霷霺霻霼霽霿靀靁靂靃靄靅靆靇靈靉靊靋靌靍靎靏靐靑靔靕靗靘靚靜靝靟靣靤靦靧靨靪靫靬靭靮靯靰靱�靲靵靷靸靹靺靻靽靾靿鞀鞁鞂鞃鞄鞆鞇鞈鞉鞊鞌鞎鞏鞐鞓鞕鞖鞗鞙鞚鞛鞜鞝臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "����������������������������������������������������������������鞞鞟鞡鞢鞤鞥鞦鞧鞨鞩鞪鞬鞮鞰鞱鞳鞵鞶鞷鞸鞹鞺鞻鞼鞽鞾鞿韀韁韂韃韄韅韆韇韈韉韊韋韌韍韎韏韐韑韒韓韔韕韖韗韘韙韚韛韜韝韞韟韠韡韢韣�韤韥韨韮韯韰韱韲韴韷韸韹韺韻韼韽韾響頀頁頂頃頄項順頇須頉頊頋頌頍頎怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������頏預頑頒頓頔頕頖頗領頙頚頛頜頝頞頟頠頡頢頣頤頥頦頧頨頩頪頫頬頭頮頯頰頱頲頳頴頵頶頷頸頹頺頻頼頽頾頿顀顁顂顃顄顅顆顇顈顉顊顋題額�顎顏顐顑顒顓顔顕顖顗願顙顚顛顜顝類顟顠顡顢顣顤顥顦顧顨顩顪顫顬顭顮睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "����������������������������������������������������������������顯顰顱顲顳顴颋颎颒颕颙颣風颩颪颫颬颭颮颯颰颱颲颳颴颵颶颷颸颹颺颻颼颽颾颿飀飁飂飃飄飅飆飇飈飉飊飋飌飍飏飐飔飖飗飛飜飝飠飡飢飣飤�飥飦飩飪飫飬飭飮飯飰飱飲飳飴飵飶飷飸飹飺飻飼飽飾飿餀餁餂餃餄餅餆餇铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "����������������������������������������������������������������餈餉養餋餌餎餏餑餒餓餔餕餖餗餘餙餚餛餜餝餞餟餠餡餢餣餤餥餦餧館餩餪餫餬餭餯餰餱餲餳餴餵餶餷餸餹餺餻餼餽餾餿饀饁饂饃饄饅饆饇饈饉�饊饋饌饍饎饏饐饑饒饓饖饗饘饙饚饛饜饝饞饟饠饡饢饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "����������������������������������������������������������������馌馎馚馛馜馝馞馟馠馡馢馣馤馦馧馩馪馫馬馭馮馯馰馱馲馳馴馵馶馷馸馹馺馻馼馽馾馿駀駁駂駃駄駅駆駇駈駉駊駋駌駍駎駏駐駑駒駓駔駕駖駗駘�駙駚駛駜駝駞駟駠駡駢駣駤駥駦駧駨駩駪駫駬駭駮駯駰駱駲駳駴駵駶駷駸駹瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "����������������������������������������������������������������駺駻駼駽駾駿騀騁騂騃騄騅騆騇騈騉騊騋騌騍騎騏騐騑騒験騔騕騖騗騘騙騚騛騜騝騞騟騠騡騢騣騤騥騦騧騨騩騪騫騬騭騮騯騰騱騲騳騴騵騶騷騸�騹騺騻騼騽騾騿驀驁驂驃驄驅驆驇驈驉驊驋驌驍驎驏驐驑驒驓驔驕驖驗驘驙颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "����������������������������������������������������������������驚驛驜驝驞驟驠驡驢驣驤驥驦驧驨驩驪驫驲骃骉骍骎骔骕骙骦骩骪骫骬骭骮骯骲骳骴骵骹骻骽骾骿髃髄髆髇髈髉髊髍髎髏髐髒體髕髖髗髙髚髛髜�髝髞髠髢髣髤髥髧髨髩髪髬髮髰髱髲髳髴髵髶髷髸髺髼髽髾髿鬀鬁鬂鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "����������������������������������������������������������������鬇鬉鬊鬋鬌鬍鬎鬐鬑鬒鬔鬕鬖鬗鬘鬙鬚鬛鬜鬝鬞鬠鬡鬢鬤鬥鬦鬧鬨鬩鬪鬫鬬鬭鬮鬰鬱鬳鬴鬵鬶鬷鬸鬹鬺鬽鬾鬿魀魆魊魋魌魎魐魒魓魕魖魗魘魙魚�魛魜魝魞魟魠魡魢魣魤魥魦魧魨魩魪魫魬魭魮魯魰魱魲魳魴魵魶魷魸魹魺魻簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "����������������������������������������������������������������魼魽魾魿鮀鮁鮂鮃鮄鮅鮆鮇鮈鮉鮊鮋鮌鮍鮎鮏鮐鮑鮒鮓鮔鮕鮖鮗鮘鮙鮚鮛鮜鮝鮞鮟鮠鮡鮢鮣鮤鮥鮦鮧鮨鮩鮪鮫鮬鮭鮮鮯鮰鮱鮲鮳鮴鮵鮶鮷鮸鮹鮺�鮻鮼鮽鮾鮿鯀鯁鯂鯃鯄鯅鯆鯇鯈鯉鯊鯋鯌鯍鯎鯏鯐鯑鯒鯓鯔鯕鯖鯗鯘鯙鯚鯛酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "����������������������������������������������������������������鯜鯝鯞鯟鯠鯡鯢鯣鯤鯥鯦鯧鯨鯩鯪鯫鯬鯭鯮鯯鯰鯱鯲鯳鯴鯵鯶鯷鯸鯹鯺鯻鯼鯽鯾鯿鰀鰁鰂鰃鰄鰅鰆鰇鰈鰉鰊鰋鰌鰍鰎鰏鰐鰑鰒鰓鰔鰕鰖鰗鰘鰙鰚�鰛鰜鰝鰞鰟鰠鰡鰢鰣鰤鰥鰦鰧鰨鰩鰪鰫鰬鰭鰮鰯鰰鰱鰲鰳鰴鰵鰶鰷鰸鰹鰺鰻觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "����������������������������������������������������������������鰼鰽鰾鰿鱀鱁鱂鱃鱄鱅鱆鱇鱈鱉鱊鱋鱌鱍鱎鱏鱐鱑鱒鱓鱔鱕鱖鱗鱘鱙鱚鱛鱜鱝鱞鱟鱠鱡鱢鱣鱤鱥鱦鱧鱨鱩鱪鱫鱬鱭鱮鱯鱰鱱鱲鱳鱴鱵鱶鱷鱸鱹鱺�鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾鲿鳀鳁鳂鳈鳉鳑鳒鳚鳛鳠鳡鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "����������������������������������������������������������������鳣鳤鳥鳦鳧鳨鳩鳪鳫鳬鳭鳮鳯鳰鳱鳲鳳鳴鳵鳶鳷鳸鳹鳺鳻鳼鳽鳾鳿鴀鴁鴂鴃鴄鴅鴆鴇鴈鴉鴊鴋鴌鴍鴎鴏鴐鴑鴒鴓鴔鴕鴖鴗鴘鴙鴚鴛鴜鴝鴞鴟鴠鴡�鴢鴣鴤鴥鴦鴧鴨鴩鴪鴫鴬鴭鴮鴯鴰鴱鴲鴳鴴鴵鴶鴷鴸鴹鴺鴻鴼鴽鴾鴿鵀鵁鵂�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "����������������������������������������������������������������鵃鵄鵅鵆鵇鵈鵉鵊鵋鵌鵍鵎鵏鵐鵑鵒鵓鵔鵕鵖鵗鵘鵙鵚鵛鵜鵝鵞鵟鵠鵡鵢鵣鵤鵥鵦鵧鵨鵩鵪鵫鵬鵭鵮鵯鵰鵱鵲鵳鵴鵵鵶鵷鵸鵹鵺鵻鵼鵽鵾鵿鶀鶁�鶂鶃鶄鶅鶆鶇鶈鶉鶊鶋鶌鶍鶎鶏鶐鶑鶒鶓鶔鶕鶖鶗鶘鶙鶚鶛鶜鶝鶞鶟鶠鶡鶢�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	D[250] = "����������������������������������������������������������������鶣鶤鶥鶦鶧鶨鶩鶪鶫鶬鶭鶮鶯鶰鶱鶲鶳鶴鶵鶶鶷鶸鶹鶺鶻鶼鶽鶾鶿鷀鷁鷂鷃鷄鷅鷆鷇鷈鷉鷊鷋鷌鷍鷎鷏鷐鷑鷒鷓鷔鷕鷖鷗鷘鷙鷚鷛鷜鷝鷞鷟鷠鷡�鷢鷣鷤鷥鷦鷧鷨鷩鷪鷫鷬鷭鷮鷯鷰鷱鷲鷳鷴鷵鷶鷷鷸鷹鷺鷻鷼鷽鷾鷿鸀鸁鸂�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "����������������������������������������������������������������鸃鸄鸅鸆鸇鸈鸉鸊鸋鸌鸍鸎鸏鸐鸑鸒鸓鸔鸕鸖鸗鸘鸙鸚鸛鸜鸝鸞鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴鹵鹶鹷鹸鹹鹺鹻鹼鹽麀�麁麃麄麅麆麉麊麌麍麎麏麐麑麔麕麖麗麘麙麚麛麜麞麠麡麢麣麤麥麧麨麩麪�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "����������������������������������������������������������������麫麬麭麮麯麰麱麲麳麵麶麷麹麺麼麿黀黁黂黃黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰黱黲黳黴黵黶黷黸黺黽黿鼀鼁鼂鼃鼄鼅�鼆鼇鼈鼉鼊鼌鼏鼑鼒鼔鼕鼖鼘鼚鼛鼜鼝鼞鼟鼡鼣鼤鼥鼦鼧鼨鼩鼪鼫鼭鼮鼰鼱�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	D[253] = "����������������������������������������������������������������鼲鼳鼴鼵鼶鼸鼺鼼鼿齀齁齂齃齅齆齇齈齉齊齋齌齍齎齏齒齓齔齕齖齗齘齙齚齛齜齝齞齟齠齡齢齣齤齥齦齧齨齩齪齫齬齭齮齯齰齱齲齳齴齵齶齷齸�齹齺齻齼齽齾龁龂龍龎龏龐龑龒龓龔龕龖龗龘龜龝龞龡龢龣龤龥郎凉秊裏隣�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
	D[254] = "����������������������������������������������������������������兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩��������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[254].length; ++j) if(D[254][j].charCodeAt(0) !== 0xFFFD) { e[D[254][j]] = 65024 + j; d[65024 + j] = D[254][j];}
	return {"enc": e, "dec": d }; })();
	cptable[949] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "�����������������������������������������������������������������갂갃갅갆갋갌갍갎갏갘갞갟갡갢갣갥갦갧갨갩갪갫갮갲갳갴������갵갶갷갺갻갽갾갿걁걂걃걄걅걆걇걈걉걊걌걎걏걐걑걒걓걕������걖걗걙걚걛걝걞걟걠걡걢걣걤걥걦걧걨걩걪걫걬걭걮걯걲걳걵걶걹걻걼걽걾걿겂겇겈겍겎겏겑겒겓겕겖겗겘겙겚겛겞겢겣겤겥겦겧겫겭겮겱겲겳겴겵겶겷겺겾겿곀곂곃곅곆곇곉곊곋곍곎곏곐곑곒곓곔곖곘곙곚곛곜곝곞곟곢곣곥곦곩곫곭곮곲곴곷곸곹곺곻곾곿괁괂괃괅괇괈괉괊괋괎괐괒괓�".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "�����������������������������������������������������������������괔괕괖괗괙괚괛괝괞괟괡괢괣괤괥괦괧괨괪괫괮괯괰괱괲괳������괶괷괹괺괻괽괾괿굀굁굂굃굆굈굊굋굌굍굎굏굑굒굓굕굖굗������굙굚굛굜굝굞굟굠굢굤굥굦굧굨굩굪굫굮굯굱굲굷굸굹굺굾궀궃궄궅궆궇궊궋궍궎궏궑궒궓궔궕궖궗궘궙궚궛궞궟궠궡궢궣궥궦궧궨궩궪궫궬궭궮궯궰궱궲궳궴궵궶궸궹궺궻궼궽궾궿귂귃귅귆귇귉귊귋귌귍귎귏귒귔귕귖귗귘귙귚귛귝귞귟귡귢귣귥귦귧귨귩귪귫귬귭귮귯귰귱귲귳귴귵귶귷�".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "�����������������������������������������������������������������귺귻귽귾긂긃긄긅긆긇긊긌긎긏긐긑긒긓긕긖긗긘긙긚긛긜������긝긞긟긠긡긢긣긤긥긦긧긨긩긪긫긬긭긮긯긲긳긵긶긹긻긼������긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗깘깙깚깛깞깢깣깤깦깧깪깫깭깮깯깱깲깳깴깵깶깷깺깾깿꺀꺁꺂꺃꺆꺇꺈꺉꺊꺋꺍꺎꺏꺐꺑꺒꺓꺔꺕꺖꺗꺘꺙꺚꺛꺜꺝꺞꺟꺠꺡꺢꺣꺤꺥꺦꺧꺨꺩꺪꺫꺬꺭꺮꺯꺰꺱꺲꺳꺴꺵꺶꺷꺸꺹꺺꺻꺿껁껂껃껅껆껇껈껉껊껋껎껒껓껔껕껖껗껚껛껝껞껟껠껡껢껣껤껥�".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "�����������������������������������������������������������������껦껧껩껪껬껮껯껰껱껲껳껵껶껷껹껺껻껽껾껿꼀꼁꼂꼃꼄꼅������꼆꼉꼊꼋꼌꼎꼏꼑꼒꼓꼔꼕꼖꼗꼘꼙꼚꼛꼜꼝꼞꼟꼠꼡꼢꼣������꼤꼥꼦꼧꼨꼩꼪꼫꼮꼯꼱꼳꼵꼶꼷꼸꼹꼺꼻꼾꽀꽄꽅꽆꽇꽊꽋꽌꽍꽎꽏꽑꽒꽓꽔꽕꽖꽗꽘꽙꽚꽛꽞꽟꽠꽡꽢꽣꽦꽧꽨꽩꽪꽫꽬꽭꽮꽯꽰꽱꽲꽳꽴꽵꽶꽷꽸꽺꽻꽼꽽꽾꽿꾁꾂꾃꾅꾆꾇꾉꾊꾋꾌꾍꾎꾏꾒꾓꾔꾖꾗꾘꾙꾚꾛꾝꾞꾟꾠꾡꾢꾣꾤꾥꾦꾧꾨꾩꾪꾫꾬꾭꾮꾯꾰꾱꾲꾳꾴꾵꾶꾷꾺꾻꾽꾾�".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[133] = "�����������������������������������������������������������������꾿꿁꿂꿃꿄꿅꿆꿊꿌꿏꿐꿑꿒꿓꿕꿖꿗꿘꿙꿚꿛꿝꿞꿟꿠꿡������꿢꿣꿤꿥꿦꿧꿪꿫꿬꿭꿮꿯꿲꿳꿵꿶꿷꿹꿺꿻꿼꿽꿾꿿뀂뀃������뀅뀆뀇뀈뀉뀊뀋뀍뀎뀏뀑뀒뀓뀕뀖뀗뀘뀙뀚뀛뀞뀟뀠뀡뀢뀣뀤뀥뀦뀧뀩뀪뀫뀬뀭뀮뀯뀰뀱뀲뀳뀴뀵뀶뀷뀸뀹뀺뀻뀼뀽뀾뀿끀끁끂끃끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞끟끠끡끢끣끤끥끦끧끨끩끪끫끬끭끮끯끰끱끲끳끴끵끶끷끸끹끺끻끾끿낁낂낃낅낆낇낈낉낊낋낎낐낒낓낔낕낖낗낛낝낞낣낤�".split("");
	for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
	D[134] = "�����������������������������������������������������������������낥낦낧낪낰낲낶낷낹낺낻낽낾낿냀냁냂냃냆냊냋냌냍냎냏냒������냓냕냖냗냙냚냛냜냝냞냟냡냢냣냤냦냧냨냩냪냫냬냭냮냯냰������냱냲냳냴냵냶냷냸냹냺냻냼냽냾냿넀넁넂넃넄넅넆넇넊넍넎넏넑넔넕넖넗넚넞넟넠넡넢넦넧넩넪넫넭넮넯넰넱넲넳넶넺넻넼넽넾넿녂녃녅녆녇녉녊녋녌녍녎녏녒녓녖녗녙녚녛녝녞녟녡녢녣녤녥녦녧녨녩녪녫녬녭녮녯녰녱녲녳녴녵녶녷녺녻녽녾녿놁놃놄놅놆놇놊놌놎놏놐놑놕놖놗놙놚놛놝�".split("");
	for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
	D[135] = "�����������������������������������������������������������������놞놟놠놡놢놣놤놥놦놧놩놪놫놬놭놮놯놰놱놲놳놴놵놶놷놸������놹놺놻놼놽놾놿뇀뇁뇂뇃뇄뇅뇆뇇뇈뇉뇊뇋뇍뇎뇏뇑뇒뇓뇕������뇖뇗뇘뇙뇚뇛뇞뇠뇡뇢뇣뇤뇥뇦뇧뇪뇫뇭뇮뇯뇱뇲뇳뇴뇵뇶뇷뇸뇺뇼뇾뇿눀눁눂눃눆눇눉눊눍눎눏눐눑눒눓눖눘눚눛눜눝눞눟눡눢눣눤눥눦눧눨눩눪눫눬눭눮눯눰눱눲눳눵눶눷눸눹눺눻눽눾눿뉀뉁뉂뉃뉄뉅뉆뉇뉈뉉뉊뉋뉌뉍뉎뉏뉐뉑뉒뉓뉔뉕뉖뉗뉙뉚뉛뉝뉞뉟뉡뉢뉣뉤뉥뉦뉧뉪뉫뉬뉭뉮�".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "�����������������������������������������������������������������뉯뉰뉱뉲뉳뉶뉷뉸뉹뉺뉻뉽뉾뉿늀늁늂늃늆늇늈늊늋늌늍늎������늏늒늓늕늖늗늛늜늝늞늟늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷������늸늹늺늻늼늽늾늿닀닁닂닃닄닅닆닇닊닋닍닎닏닑닓닔닕닖닗닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉댊댋댌댍댎댏댒댖댗댘댙댚댛댝댞댟댠댡댢댣댤댥댦댧댨댩댪댫댬댭댮댯댰댱댲댳댴댵댶댷댸댹댺댻댼댽댾댿덀덁덂덃덄덅덆덇덈덉덊덋덌덍덎덏덐덑덒덓덗덙덚덝덠덡덢덣�".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "�����������������������������������������������������������������덦덨덪덬덭덯덲덳덵덶덷덹덺덻덼덽덾덿뎂뎆뎇뎈뎉뎊뎋뎍������뎎뎏뎑뎒뎓뎕뎖뎗뎘뎙뎚뎛뎜뎝뎞뎟뎢뎣뎤뎥뎦뎧뎩뎪뎫뎭������뎮뎯뎰뎱뎲뎳뎴뎵뎶뎷뎸뎹뎺뎻뎼뎽뎾뎿돀돁돂돃돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩돪돫돬돭돮돯돰돱돲돳돴돵돶돷돸돹돺돻돽돾돿됀됁됂됃됄됅됆됇됈됉됊됋됌됍됎됏됑됒됓됔됕됖됗됙됚됛됝됞됟됡됢됣됤됥됦됧됪됬됭됮됯됰됱됲됳됵됶됷됸됹됺됻됼됽됾됿둀둁둂둃둄�".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "�����������������������������������������������������������������둅둆둇둈둉둊둋둌둍둎둏둒둓둕둖둗둙둚둛둜둝둞둟둢둤둦������둧둨둩둪둫둭둮둯둰둱둲둳둴둵둶둷둸둹둺둻둼둽둾둿뒁뒂������뒃뒄뒅뒆뒇뒉뒊뒋뒌뒍뒎뒏뒐뒑뒒뒓뒔뒕뒖뒗뒘뒙뒚뒛뒜뒞뒟뒠뒡뒢뒣뒥뒦뒧뒩뒪뒫뒭뒮뒯뒰뒱뒲뒳뒴뒶뒸뒺뒻뒼뒽뒾뒿듁듂듃듅듆듇듉듊듋듌듍듎듏듑듒듓듔듖듗듘듙듚듛듞듟듡듢듥듧듨듩듪듫듮듰듲듳듴듵듶듷듹듺듻듼듽듾듿딀딁딂딃딄딅딆딇딈딉딊딋딌딍딎딏딐딑딒딓딖딗딙딚딝�".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "�����������������������������������������������������������������딞딟딠딡딢딣딦딫딬딭딮딯딲딳딵딶딷딹딺딻딼딽딾딿땂땆������땇땈땉땊땎땏땑땒땓땕땖땗땘땙땚땛땞땢땣땤땥땦땧땨땩땪������땫땬땭땮땯땰땱땲땳땴땵땶땷땸땹땺땻땼땽땾땿떀떁떂떃떄떅떆떇떈떉떊떋떌떍떎떏떐떑떒떓떔떕떖떗떘떙떚떛떜떝떞떟떢떣떥떦떧떩떬떭떮떯떲떶떷떸떹떺떾떿뗁뗂뗃뗅뗆뗇뗈뗉뗊뗋뗎뗒뗓뗔뗕뗖뗗뗙뗚뗛뗜뗝뗞뗟뗠뗡뗢뗣뗤뗥뗦뗧뗨뗩뗪뗫뗭뗮뗯뗰뗱뗲뗳뗴뗵뗶뗷뗸뗹뗺뗻뗼뗽뗾뗿�".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "�����������������������������������������������������������������똀똁똂똃똄똅똆똇똈똉똊똋똌똍똎똏똒똓똕똖똗똙똚똛똜똝������똞똟똠똡똢똣똤똦똧똨똩똪똫똭똮똯똰똱똲똳똵똶똷똸똹똺������똻똼똽똾똿뙀뙁뙂뙃뙄뙅뙆뙇뙉뙊뙋뙌뙍뙎뙏뙐뙑뙒뙓뙔뙕뙖뙗뙘뙙뙚뙛뙜뙝뙞뙟뙠뙡뙢뙣뙥뙦뙧뙩뙪뙫뙬뙭뙮뙯뙰뙱뙲뙳뙴뙵뙶뙷뙸뙹뙺뙻뙼뙽뙾뙿뚀뚁뚂뚃뚄뚅뚆뚇뚈뚉뚊뚋뚌뚍뚎뚏뚐뚑뚒뚓뚔뚕뚖뚗뚘뚙뚚뚛뚞뚟뚡뚢뚣뚥뚦뚧뚨뚩뚪뚭뚮뚯뚰뚲뚳뚴뚵뚶뚷뚸뚹뚺뚻뚼뚽뚾뚿뛀뛁뛂�".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "�����������������������������������������������������������������뛃뛄뛅뛆뛇뛈뛉뛊뛋뛌뛍뛎뛏뛐뛑뛒뛓뛕뛖뛗뛘뛙뛚뛛뛜뛝������뛞뛟뛠뛡뛢뛣뛤뛥뛦뛧뛨뛩뛪뛫뛬뛭뛮뛯뛱뛲뛳뛵뛶뛷뛹뛺������뛻뛼뛽뛾뛿뜂뜃뜄뜆뜇뜈뜉뜊뜋뜌뜍뜎뜏뜐뜑뜒뜓뜔뜕뜖뜗뜘뜙뜚뜛뜜뜝뜞뜟뜠뜡뜢뜣뜤뜥뜦뜧뜪뜫뜭뜮뜱뜲뜳뜴뜵뜶뜷뜺뜼뜽뜾뜿띀띁띂띃띅띆띇띉띊띋띍띎띏띐띑띒띓띖띗띘띙띚띛띜띝띞띟띡띢띣띥띦띧띩띪띫띬띭띮띯띲띴띶띷띸띹띺띻띾띿랁랂랃랅랆랇랈랉랊랋랎랓랔랕랚랛랝랞�".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "�����������������������������������������������������������������랟랡랢랣랤랥랦랧랪랮랯랰랱랲랳랶랷랹랺랻랼랽랾랿럀럁������럂럃럄럅럆럈럊럋럌럍럎럏럐럑럒럓럔럕럖럗럘럙럚럛럜럝������럞럟럠럡럢럣럤럥럦럧럨럩럪럫럮럯럱럲럳럵럶럷럸럹럺럻럾렂렃렄렅렆렊렋렍렎렏렑렒렓렔렕렖렗렚렜렞렟렠렡렢렣렦렧렩렪렫렭렮렯렰렱렲렳렶렺렻렼렽렾렿롁롂롃롅롆롇롈롉롊롋롌롍롎롏롐롒롔롕롖롗롘롙롚롛롞롟롡롢롣롥롦롧롨롩롪롫롮롰롲롳롴롵롶롷롹롺롻롽롾롿뢀뢁뢂뢃뢄�".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "�����������������������������������������������������������������뢅뢆뢇뢈뢉뢊뢋뢌뢎뢏뢐뢑뢒뢓뢔뢕뢖뢗뢘뢙뢚뢛뢜뢝뢞뢟������뢠뢡뢢뢣뢤뢥뢦뢧뢩뢪뢫뢬뢭뢮뢯뢱뢲뢳뢵뢶뢷뢹뢺뢻뢼뢽������뢾뢿룂룄룆룇룈룉룊룋룍룎룏룑룒룓룕룖룗룘룙룚룛룜룞룠룢룣룤룥룦룧룪룫룭룮룯룱룲룳룴룵룶룷룺룼룾룿뤀뤁뤂뤃뤅뤆뤇뤈뤉뤊뤋뤌뤍뤎뤏뤐뤑뤒뤓뤔뤕뤖뤗뤙뤚뤛뤜뤝뤞뤟뤡뤢뤣뤤뤥뤦뤧뤨뤩뤪뤫뤬뤭뤮뤯뤰뤱뤲뤳뤴뤵뤶뤷뤸뤹뤺뤻뤾뤿륁륂륃륅륆륇륈륉륊륋륍륎륐륒륓륔륕륖륗�".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "�����������������������������������������������������������������륚륛륝륞륟륡륢륣륤륥륦륧륪륬륮륯륰륱륲륳륶륷륹륺륻륽������륾륿릀릁릂릃릆릈릋릌릏릐릑릒릓릔릕릖릗릘릙릚릛릜릝릞������릟릠릡릢릣릤릥릦릧릨릩릪릫릮릯릱릲릳릵릶릷릸릹릺릻릾맀맂맃맄맅맆맇맊맋맍맓맔맕맖맗맚맜맟맠맢맦맧맩맪맫맭맮맯맰맱맲맳맶맻맼맽맾맿먂먃먄먅먆먇먉먊먋먌먍먎먏먐먑먒먓먔먖먗먘먙먚먛먜먝먞먟먠먡먢먣먤먥먦먧먨먩먪먫먬먭먮먯먰먱먲먳먴먵먶먷먺먻먽먾먿멁멃멄멅멆�".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "�����������������������������������������������������������������멇멊멌멏멐멑멒멖멗멙멚멛멝멞멟멠멡멢멣멦멪멫멬멭멮멯������멲멳멵멶멷멹멺멻멼멽멾멿몀몁몂몆몈몉몊몋몍몎몏몐몑몒������몓몔몕몖몗몘몙몚몛몜몝몞몟몠몡몢몣몤몥몦몧몪몭몮몯몱몳몴몵몶몷몺몼몾몿뫀뫁뫂뫃뫅뫆뫇뫉뫊뫋뫌뫍뫎뫏뫐뫑뫒뫓뫔뫕뫖뫗뫚뫛뫜뫝뫞뫟뫠뫡뫢뫣뫤뫥뫦뫧뫨뫩뫪뫫뫬뫭뫮뫯뫰뫱뫲뫳뫴뫵뫶뫷뫸뫹뫺뫻뫽뫾뫿묁묂묃묅묆묇묈묉묊묋묌묎묐묒묓묔묕묖묗묙묚묛묝묞묟묡묢묣묤묥묦묧�".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "�����������������������������������������������������������������묨묪묬묭묮묯묰묱묲묳묷묹묺묿뭀뭁뭂뭃뭆뭈뭊뭋뭌뭎뭑뭒������뭓뭕뭖뭗뭙뭚뭛뭜뭝뭞뭟뭠뭢뭤뭥뭦뭧뭨뭩뭪뭫뭭뭮뭯뭰뭱������뭲뭳뭴뭵뭶뭷뭸뭹뭺뭻뭼뭽뭾뭿뮀뮁뮂뮃뮄뮅뮆뮇뮉뮊뮋뮍뮎뮏뮑뮒뮓뮔뮕뮖뮗뮘뮙뮚뮛뮜뮝뮞뮟뮠뮡뮢뮣뮥뮦뮧뮩뮪뮫뮭뮮뮯뮰뮱뮲뮳뮵뮶뮸뮹뮺뮻뮼뮽뮾뮿믁믂믃믅믆믇믉믊믋믌믍믎믏믑믒믔믕믖믗믘믙믚믛믜믝믞믟믠믡믢믣믤믥믦믧믨믩믪믫믬믭믮믯믰믱믲믳믴믵믶믷믺믻믽믾밁�".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "�����������������������������������������������������������������밃밄밅밆밇밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵������밶밷밹밺밻밼밽밾밿뱂뱆뱇뱈뱊뱋뱎뱏뱑뱒뱓뱔뱕뱖뱗뱘뱙������뱚뱛뱜뱞뱟뱠뱡뱢뱣뱤뱥뱦뱧뱨뱩뱪뱫뱬뱭뱮뱯뱰뱱뱲뱳뱴뱵뱶뱷뱸뱹뱺뱻뱼뱽뱾뱿벀벁벂벃벆벇벉벊벍벏벐벑벒벓벖벘벛벜벝벞벟벢벣벥벦벩벪벫벬벭벮벯벲벶벷벸벹벺벻벾벿볁볂볃볅볆볇볈볉볊볋볌볎볒볓볔볖볗볙볚볛볝볞볟볠볡볢볣볤볥볦볧볨볩볪볫볬볭볮볯볰볱볲볳볷볹볺볻볽�".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "�����������������������������������������������������������������볾볿봀봁봂봃봆봈봊봋봌봍봎봏봑봒봓봕봖봗봘봙봚봛봜봝������봞봟봠봡봢봣봥봦봧봨봩봪봫봭봮봯봰봱봲봳봴봵봶봷봸봹������봺봻봼봽봾봿뵁뵂뵃뵄뵅뵆뵇뵊뵋뵍뵎뵏뵑뵒뵓뵔뵕뵖뵗뵚뵛뵜뵝뵞뵟뵠뵡뵢뵣뵥뵦뵧뵩뵪뵫뵬뵭뵮뵯뵰뵱뵲뵳뵴뵵뵶뵷뵸뵹뵺뵻뵼뵽뵾뵿붂붃붅붆붋붌붍붎붏붒붔붖붗붘붛붝붞붟붠붡붢붣붥붦붧붨붩붪붫붬붭붮붯붱붲붳붴붵붶붷붹붺붻붼붽붾붿뷀뷁뷂뷃뷄뷅뷆뷇뷈뷉뷊뷋뷌뷍뷎뷏뷐뷑�".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "�����������������������������������������������������������������뷒뷓뷖뷗뷙뷚뷛뷝뷞뷟뷠뷡뷢뷣뷤뷥뷦뷧뷨뷪뷫뷬뷭뷮뷯뷱������뷲뷳뷵뷶뷷뷹뷺뷻뷼뷽뷾뷿븁븂븄븆븇븈븉븊븋븎븏븑븒븓������븕븖븗븘븙븚븛븞븠븡븢븣븤븥븦븧븨븩븪븫븬븭븮븯븰븱븲븳븴븵븶븷븸븹븺븻븼븽븾븿빀빁빂빃빆빇빉빊빋빍빏빐빑빒빓빖빘빜빝빞빟빢빣빥빦빧빩빫빬빭빮빯빲빶빷빸빹빺빾빿뺁뺂뺃뺅뺆뺇뺈뺉뺊뺋뺎뺒뺓뺔뺕뺖뺗뺚뺛뺜뺝뺞뺟뺠뺡뺢뺣뺤뺥뺦뺧뺩뺪뺫뺬뺭뺮뺯뺰뺱뺲뺳뺴뺵뺶뺷�".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "�����������������������������������������������������������������뺸뺹뺺뺻뺼뺽뺾뺿뻀뻁뻂뻃뻄뻅뻆뻇뻈뻉뻊뻋뻌뻍뻎뻏뻒뻓������뻕뻖뻙뻚뻛뻜뻝뻞뻟뻡뻢뻦뻧뻨뻩뻪뻫뻭뻮뻯뻰뻱뻲뻳뻴뻵������뻶뻷뻸뻹뻺뻻뻼뻽뻾뻿뼀뼂뼃뼄뼅뼆뼇뼊뼋뼌뼍뼎뼏뼐뼑뼒뼓뼔뼕뼖뼗뼚뼞뼟뼠뼡뼢뼣뼤뼥뼦뼧뼨뼩뼪뼫뼬뼭뼮뼯뼰뼱뼲뼳뼴뼵뼶뼷뼸뼹뼺뼻뼼뼽뼾뼿뽂뽃뽅뽆뽇뽉뽊뽋뽌뽍뽎뽏뽒뽓뽔뽖뽗뽘뽙뽚뽛뽜뽝뽞뽟뽠뽡뽢뽣뽤뽥뽦뽧뽨뽩뽪뽫뽬뽭뽮뽯뽰뽱뽲뽳뽴뽵뽶뽷뽸뽹뽺뽻뽼뽽뽾뽿뾀뾁뾂�".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "�����������������������������������������������������������������뾃뾄뾅뾆뾇뾈뾉뾊뾋뾌뾍뾎뾏뾐뾑뾒뾓뾕뾖뾗뾘뾙뾚뾛뾜뾝������뾞뾟뾠뾡뾢뾣뾤뾥뾦뾧뾨뾩뾪뾫뾬뾭뾮뾯뾱뾲뾳뾴뾵뾶뾷뾸������뾹뾺뾻뾼뾽뾾뾿뿀뿁뿂뿃뿄뿆뿇뿈뿉뿊뿋뿎뿏뿑뿒뿓뿕뿖뿗뿘뿙뿚뿛뿝뿞뿠뿢뿣뿤뿥뿦뿧뿨뿩뿪뿫뿬뿭뿮뿯뿰뿱뿲뿳뿴뿵뿶뿷뿸뿹뿺뿻뿼뿽뿾뿿쀀쀁쀂쀃쀄쀅쀆쀇쀈쀉쀊쀋쀌쀍쀎쀏쀐쀑쀒쀓쀔쀕쀖쀗쀘쀙쀚쀛쀜쀝쀞쀟쀠쀡쀢쀣쀤쀥쀦쀧쀨쀩쀪쀫쀬쀭쀮쀯쀰쀱쀲쀳쀴쀵쀶쀷쀸쀹쀺쀻쀽쀾쀿�".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "�����������������������������������������������������������������쁀쁁쁂쁃쁄쁅쁆쁇쁈쁉쁊쁋쁌쁍쁎쁏쁐쁒쁓쁔쁕쁖쁗쁙쁚쁛������쁝쁞쁟쁡쁢쁣쁤쁥쁦쁧쁪쁫쁬쁭쁮쁯쁰쁱쁲쁳쁴쁵쁶쁷쁸쁹������쁺쁻쁼쁽쁾쁿삀삁삂삃삄삅삆삇삈삉삊삋삌삍삎삏삒삓삕삖삗삙삚삛삜삝삞삟삢삤삦삧삨삩삪삫삮삱삲삷삸삹삺삻삾샂샃샄샆샇샊샋샍샎샏샑샒샓샔샕샖샗샚샞샟샠샡샢샣샦샧샩샪샫샭샮샯샰샱샲샳샶샸샺샻샼샽샾샿섁섂섃섅섆섇섉섊섋섌섍섎섏섑섒섓섔섖섗섘섙섚섛섡섢섥섨섩섪섫섮�".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "�����������������������������������������������������������������섲섳섴섵섷섺섻섽섾섿셁셂셃셄셅셆셇셊셎셏셐셑셒셓셖셗������셙셚셛셝셞셟셠셡셢셣셦셪셫셬셭셮셯셱셲셳셵셶셷셹셺셻������셼셽셾셿솀솁솂솃솄솆솇솈솉솊솋솏솑솒솓솕솗솘솙솚솛솞솠솢솣솤솦솧솪솫솭솮솯솱솲솳솴솵솶솷솸솹솺솻솼솾솿쇀쇁쇂쇃쇅쇆쇇쇉쇊쇋쇍쇎쇏쇐쇑쇒쇓쇕쇖쇙쇚쇛쇜쇝쇞쇟쇡쇢쇣쇥쇦쇧쇩쇪쇫쇬쇭쇮쇯쇲쇴쇵쇶쇷쇸쇹쇺쇻쇾쇿숁숂숃숅숆숇숈숉숊숋숎숐숒숓숔숕숖숗숚숛숝숞숡숢숣�".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "�����������������������������������������������������������������숤숥숦숧숪숬숮숰숳숵숶숷숸숹숺숻숼숽숾숿쉀쉁쉂쉃쉄쉅������쉆쉇쉉쉊쉋쉌쉍쉎쉏쉒쉓쉕쉖쉗쉙쉚쉛쉜쉝쉞쉟쉡쉢쉣쉤쉦������쉧쉨쉩쉪쉫쉮쉯쉱쉲쉳쉵쉶쉷쉸쉹쉺쉻쉾슀슂슃슄슅슆슇슊슋슌슍슎슏슑슒슓슔슕슖슗슙슚슜슞슟슠슡슢슣슦슧슩슪슫슮슯슰슱슲슳슶슸슺슻슼슽슾슿싀싁싂싃싄싅싆싇싈싉싊싋싌싍싎싏싐싑싒싓싔싕싖싗싘싙싚싛싞싟싡싢싥싦싧싨싩싪싮싰싲싳싴싵싷싺싽싾싿쌁쌂쌃쌄쌅쌆쌇쌊쌋쌎쌏�".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "�����������������������������������������������������������������쌐쌑쌒쌖쌗쌙쌚쌛쌝쌞쌟쌠쌡쌢쌣쌦쌧쌪쌫쌬쌭쌮쌯쌰쌱쌲������쌳쌴쌵쌶쌷쌸쌹쌺쌻쌼쌽쌾쌿썀썁썂썃썄썆썇썈썉썊썋썌썍������썎썏썐썑썒썓썔썕썖썗썘썙썚썛썜썝썞썟썠썡썢썣썤썥썦썧썪썫썭썮썯썱썳썴썵썶썷썺썻썾썿쎀쎁쎂쎃쎅쎆쎇쎉쎊쎋쎍쎎쎏쎐쎑쎒쎓쎔쎕쎖쎗쎘쎙쎚쎛쎜쎝쎞쎟쎠쎡쎢쎣쎤쎥쎦쎧쎨쎩쎪쎫쎬쎭쎮쎯쎰쎱쎲쎳쎴쎵쎶쎷쎸쎹쎺쎻쎼쎽쎾쎿쏁쏂쏃쏄쏅쏆쏇쏈쏉쏊쏋쏌쏍쏎쏏쏐쏑쏒쏓쏔쏕쏖쏗쏚�".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "�����������������������������������������������������������������쏛쏝쏞쏡쏣쏤쏥쏦쏧쏪쏫쏬쏮쏯쏰쏱쏲쏳쏶쏷쏹쏺쏻쏼쏽쏾������쏿쐀쐁쐂쐃쐄쐅쐆쐇쐉쐊쐋쐌쐍쐎쐏쐑쐒쐓쐔쐕쐖쐗쐘쐙쐚������쐛쐜쐝쐞쐟쐠쐡쐢쐣쐥쐦쐧쐨쐩쐪쐫쐭쐮쐯쐱쐲쐳쐵쐶쐷쐸쐹쐺쐻쐾쐿쑀쑁쑂쑃쑄쑅쑆쑇쑉쑊쑋쑌쑍쑎쑏쑐쑑쑒쑓쑔쑕쑖쑗쑘쑙쑚쑛쑜쑝쑞쑟쑠쑡쑢쑣쑦쑧쑩쑪쑫쑭쑮쑯쑰쑱쑲쑳쑶쑷쑸쑺쑻쑼쑽쑾쑿쒁쒂쒃쒄쒅쒆쒇쒈쒉쒊쒋쒌쒍쒎쒏쒐쒑쒒쒓쒕쒖쒗쒘쒙쒚쒛쒝쒞쒟쒠쒡쒢쒣쒤쒥쒦쒧쒨쒩�".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "�����������������������������������������������������������������쒪쒫쒬쒭쒮쒯쒰쒱쒲쒳쒴쒵쒶쒷쒹쒺쒻쒽쒾쒿쓀쓁쓂쓃쓄쓅������쓆쓇쓈쓉쓊쓋쓌쓍쓎쓏쓐쓑쓒쓓쓔쓕쓖쓗쓘쓙쓚쓛쓜쓝쓞쓟������쓠쓡쓢쓣쓤쓥쓦쓧쓨쓪쓫쓬쓭쓮쓯쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂씃씄씅씆씇씈씉씊씋씍씎씏씑씒씓씕씖씗씘씙씚씛씝씞씟씠씡씢씣씤씥씦씧씪씫씭씮씯씱씲씳씴씵씶씷씺씼씾씿앀앁앂앃앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩앪앫앬앭앮앯앲앶앷앸앹앺앻앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔�".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "�����������������������������������������������������������������얖얙얚얛얝얞얟얡얢얣얤얥얦얧얨얪얫얬얭얮얯얰얱얲얳얶������얷얺얿엀엁엂엃엋엍엏엒엓엕엖엗엙엚엛엜엝엞엟엢엤엦엧������엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑옒옓옔옕옖옗옚옝옞옟옠옡옢옣옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉왊왋왌왍왎왏왒왖왗왘왙왚왛왞왟왡왢왣왤왥왦왧왨왩왪왫왭왮왰왲왳왴왵왶왷왺왻왽왾왿욁욂욃욄욅욆욇욊욌욎욏욐욑욒욓욖욗욙욚욛욝욞욟욠욡욢욣욦�".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "�����������������������������������������������������������������욨욪욫욬욭욮욯욲욳욵욶욷욻욼욽욾욿웂웄웆웇웈웉웊웋웎������웏웑웒웓웕웖웗웘웙웚웛웞웟웢웣웤웥웦웧웪웫웭웮웯웱웲������웳웴웵웶웷웺웻웼웾웿윀윁윂윃윆윇윉윊윋윍윎윏윐윑윒윓윖윘윚윛윜윝윞윟윢윣윥윦윧윩윪윫윬윭윮윯윲윴윶윸윹윺윻윾윿읁읂읃읅읆읇읈읉읋읎읐읙읚읛읝읞읟읡읢읣읤읥읦읧읩읪읬읭읮읯읰읱읲읳읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛잜잝잞잟잢잧잨잩잪잫잮잯잱잲잳잵잶잷�".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[160] = "�����������������������������������������������������������������잸잹잺잻잾쟂쟃쟄쟅쟆쟇쟊쟋쟍쟏쟑쟒쟓쟔쟕쟖쟗쟙쟚쟛쟜������쟞쟟쟠쟡쟢쟣쟥쟦쟧쟩쟪쟫쟭쟮쟯쟰쟱쟲쟳쟴쟵쟶쟷쟸쟹쟺������쟻쟼쟽쟾쟿젂젃젅젆젇젉젋젌젍젎젏젒젔젗젘젙젚젛젞젟젡젢젣젥젦젧젨젩젪젫젮젰젲젳젴젵젶젷젹젺젻젽젾젿졁졂졃졄졅졆졇졊졋졎졏졐졑졒졓졕졖졗졘졙졚졛졜졝졞졟졠졡졢졣졤졥졦졧졨졩졪졫졬졭졮졯졲졳졵졶졷졹졻졼졽졾졿좂좄좈좉좊좎좏좐좑좒좓좕좖좗좘좙좚좛좜좞좠좢좣좤�".split("");
	for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
	D[161] = "�����������������������������������������������������������������좥좦좧좩좪좫좬좭좮좯좰좱좲좳좴좵좶좷좸좹좺좻좾좿죀죁������죂죃죅죆죇죉죊죋죍죎죏죐죑죒죓죖죘죚죛죜죝죞죟죢죣죥������죦죧죨죩죪죫죬죭죮죯죰죱죲죳죴죶죷죸죹죺죻죾죿줁줂줃줇줈줉줊줋줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈〉《》「」『』【】±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "�����������������������������������������������������������������줐줒줓줔줕줖줗줙줚줛줜줝줞줟줠줡줢줣줤줥줦줧줨줩줪줫������줭줮줯줰줱줲줳줵줶줷줸줹줺줻줼줽줾줿쥀쥁쥂쥃쥄쥅쥆쥇������쥈쥉쥊쥋쥌쥍쥎쥏쥒쥓쥕쥖쥗쥙쥚쥛쥜쥝쥞쥟쥢쥤쥥쥦쥧쥨쥩쥪쥫쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®������������������������".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������쥱쥲쥳쥵쥶쥷쥸쥹쥺쥻쥽쥾쥿즀즁즂즃즄즅즆즇즊즋즍즎즏������즑즒즓즔즕즖즗즚즜즞즟즠즡즢즣즤즥즦즧즨즩즪즫즬즭즮������즯즰즱즲즳즴즵즶즷즸즹즺즻즼즽즾즿짂짃짅짆짉짋짌짍짎짏짒짔짗짘짛！＂＃＄％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［￦］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������짞짟짡짣짥짦짨짩짪짫짮짲짳짴짵짶짷짺짻짽짾짿쨁쨂쨃쨄������쨅쨆쨇쨊쨎쨏쨐쨑쨒쨓쨕쨖쨗쨙쨚쨛쨜쨝쨞쨟쨠쨡쨢쨣쨤쨥������쨦쨧쨨쨪쨫쨬쨭쨮쨯쨰쨱쨲쨳쨴쨵쨶쨷쨸쨹쨺쨻쨼쨽쨾쨿쩀쩁쩂쩃쩄쩅쩆ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣㅤㅥㅦㅧㅨㅩㅪㅫㅬㅭㅮㅯㅰㅱㅲㅳㅴㅵㅶㅷㅸㅹㅺㅻㅼㅽㅾㅿㆀㆁㆂㆃㆄㆅㆆㆇㆈㆉㆊㆋㆌㆍㆎ�".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������쩇쩈쩉쩊쩋쩎쩏쩑쩒쩓쩕쩖쩗쩘쩙쩚쩛쩞쩢쩣쩤쩥쩦쩧쩩쩪������쩫쩬쩭쩮쩯쩰쩱쩲쩳쩴쩵쩶쩷쩸쩹쩺쩻쩼쩾쩿쪀쪁쪂쪃쪅쪆������쪇쪈쪉쪊쪋쪌쪍쪎쪏쪐쪑쪒쪓쪔쪕쪖쪗쪙쪚쪛쪜쪝쪞쪟쪠쪡쪢쪣쪤쪥쪦쪧ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ�����ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������쪨쪩쪪쪫쪬쪭쪮쪯쪰쪱쪲쪳쪴쪵쪶쪷쪸쪹쪺쪻쪾쪿쫁쫂쫃쫅������쫆쫇쫈쫉쫊쫋쫎쫐쫒쫔쫕쫖쫗쫚쫛쫜쫝쫞쫟쫡쫢쫣쫤쫥쫦쫧������쫨쫩쫪쫫쫭쫮쫯쫰쫱쫲쫳쫵쫶쫷쫸쫹쫺쫻쫼쫽쫾쫿쬀쬁쬂쬃쬄쬅쬆쬇쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃╄╅╆╇╈╉╊���������������������������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������쬋쬌쬍쬎쬏쬑쬒쬓쬕쬖쬗쬙쬚쬛쬜쬝쬞쬟쬢쬣쬤쬥쬦쬧쬨쬩������쬪쬫쬬쬭쬮쬯쬰쬱쬲쬳쬴쬵쬶쬷쬸쬹쬺쬻쬼쬽쬾쬿쭀쭂쭃쭄������쭅쭆쭇쭊쭋쭍쭎쭏쭑쭒쭓쭔쭕쭖쭗쭚쭛쭜쭞쭟쭠쭡쭢쭣쭥쭦쭧쭨쭩쭪쭫쭬㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙㎚㎛㎜㎝㎞㎟㎠㎡㎢㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰㎱㎲㎳㎴㎵㎶㎷㎸㎹㎀㎁㎂㎃㎄㎺㎻㎼㎽㎾㎿㎐㎑㎒㎓㎔Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆����������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "�����������������������������������������������������������������쭭쭮쭯쭰쭱쭲쭳쭴쭵쭶쭷쭺쭻쭼쭽쭾쭿쮀쮁쮂쮃쮄쮅쮆쮇쮈������쮉쮊쮋쮌쮍쮎쮏쮐쮑쮒쮓쮔쮕쮖쮗쮘쮙쮚쮛쮝쮞쮟쮠쮡쮢쮣������쮤쮥쮦쮧쮨쮩쮪쮫쮬쮭쮮쮯쮰쮱쮲쮳쮴쮵쮶쮷쮹쮺쮻쮼쮽쮾쮿쯀쯁쯂쯃쯄ÆÐªĦ�Ĳ�ĿŁØŒºÞŦŊ�㉠㉡㉢㉣㉤㉥㉦㉧㉨㉩㉪㉫㉬㉭㉮㉯㉰㉱㉲㉳㉴㉵㉶㉷㉸㉹㉺㉻ⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮½⅓⅔¼¾⅛⅜⅝⅞�".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "�����������������������������������������������������������������쯅쯆쯇쯈쯉쯊쯋쯌쯍쯎쯏쯐쯑쯒쯓쯕쯖쯗쯘쯙쯚쯛쯜쯝쯞쯟������쯠쯡쯢쯣쯥쯦쯨쯪쯫쯬쯭쯮쯯쯰쯱쯲쯳쯴쯵쯶쯷쯸쯹쯺쯻쯼������쯽쯾쯿찀찁찂찃찄찅찆찇찈찉찊찋찎찏찑찒찓찕찖찗찘찙찚찛찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀㈁㈂㈃㈄㈅㈆㈇㈈㈉㈊㈋㈌㈍㈎㈏㈐㈑㈒㈓㈔㈕㈖㈗㈘㈙㈚㈛⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂¹²³⁴ⁿ₁₂₃₄�".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "�����������������������������������������������������������������찥찦찪찫찭찯찱찲찳찴찵찶찷찺찿챀챁챂챃챆챇챉챊챋챍챎������챏챐챑챒챓챖챚챛챜챝챞챟챡챢챣챥챧챩챪챫챬챭챮챯챱챲������챳챴챶챷챸챹챺챻챼챽챾챿첀첁첂첃첄첅첆첇첈첉첊첋첌첍첎첏첐첑첒첓ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "�����������������������������������������������������������������첔첕첖첗첚첛첝첞첟첡첢첣첤첥첦첧첪첮첯첰첱첲첳첶첷첹������첺첻첽첾첿쳀쳁쳂쳃쳆쳈쳊쳋쳌쳍쳎쳏쳑쳒쳓쳕쳖쳗쳘쳙쳚������쳛쳜쳝쳞쳟쳠쳡쳢쳣쳥쳦쳧쳨쳩쳪쳫쳭쳮쳯쳱쳲쳳쳴쳵쳶쳷쳸쳹쳺쳻쳼쳽ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "�����������������������������������������������������������������쳾쳿촀촂촃촄촅촆촇촊촋촍촎촏촑촒촓촔촕촖촗촚촜촞촟촠������촡촢촣촥촦촧촩촪촫촭촮촯촰촱촲촳촴촵촶촷촸촺촻촼촽촾������촿쵀쵁쵂쵃쵄쵅쵆쵇쵈쵉쵊쵋쵌쵍쵎쵏쵐쵑쵒쵓쵔쵕쵖쵗쵘쵙쵚쵛쵝쵞쵟АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "�����������������������������������������������������������������쵡쵢쵣쵥쵦쵧쵨쵩쵪쵫쵮쵰쵲쵳쵴쵵쵶쵷쵹쵺쵻쵼쵽쵾쵿춀������춁춂춃춄춅춆춇춉춊춋춌춍춎춏춐춑춒춓춖춗춙춚춛춝춞춟������춠춡춢춣춦춨춪춫춬춭춮춯춱춲춳춴춵춶춷춸춹춺춻춼춽춾춿췀췁췂췃췅�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "�����������������������������������������������������������������췆췇췈췉췊췋췍췎췏췑췒췓췔췕췖췗췘췙췚췛췜췝췞췟췠췡������췢췣췤췥췦췧췩췪췫췭췮췯췱췲췳췴췵췶췷췺췼췾췿츀츁츂������츃츅츆츇츉츊츋츍츎츏츐츑츒츓츕츖츗츘츚츛츜츝츞츟츢츣츥츦츧츩츪츫�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "�����������������������������������������������������������������츬츭츮츯츲츴츶츷츸츹츺츻츼츽츾츿칀칁칂칃칄칅칆칇칈칉������칊칋칌칍칎칏칐칑칒칓칔칕칖칗칚칛칝칞칢칣칤칥칦칧칪칬������칮칯칰칱칲칳칶칷칹칺칻칽칾칿캀캁캂캃캆캈캊캋캌캍캎캏캒캓캕캖캗캙�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "�����������������������������������������������������������������캚캛캜캝캞캟캢캦캧캨캩캪캫캮캯캰캱캲캳캴캵캶캷캸캹캺������캻캼캽캾캿컀컂컃컄컅컆컇컈컉컊컋컌컍컎컏컐컑컒컓컔컕������컖컗컘컙컚컛컜컝컞컟컠컡컢컣컦컧컩컪컭컮컯컰컱컲컳컶컺컻컼컽컾컿가각간갇갈갉갊감갑값갓갔강갖갗같갚갛개객갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "�����������������������������������������������������������������켂켃켅켆켇켉켊켋켌켍켎켏켒켔켖켗켘켙켚켛켝켞켟켡켢켣������켥켦켧켨켩켪켫켮켲켳켴켵켶켷켹켺켻켼켽켾켿콀콁콂콃콄������콅콆콇콈콉콊콋콌콍콎콏콐콑콒콓콖콗콙콚콛콝콞콟콠콡콢콣콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "�����������������������������������������������������������������콭콮콯콲콳콵콶콷콹콺콻콼콽콾콿쾁쾂쾃쾄쾆쾇쾈쾉쾊쾋쾍������쾎쾏쾐쾑쾒쾓쾔쾕쾖쾗쾘쾙쾚쾛쾜쾝쾞쾟쾠쾢쾣쾤쾥쾦쾧쾩������쾪쾫쾬쾭쾮쾯쾱쾲쾳쾴쾵쾶쾷쾸쾹쾺쾻쾼쾽쾾쾿쿀쿁쿂쿃쿅쿆쿇쿈쿉쿊쿋깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "�����������������������������������������������������������������쿌쿍쿎쿏쿐쿑쿒쿓쿔쿕쿖쿗쿘쿙쿚쿛쿜쿝쿞쿟쿢쿣쿥쿦쿧쿩������쿪쿫쿬쿭쿮쿯쿲쿴쿶쿷쿸쿹쿺쿻쿽쿾쿿퀁퀂퀃퀅퀆퀇퀈퀉퀊������퀋퀌퀍퀎퀏퀐퀒퀓퀔퀕퀖퀗퀙퀚퀛퀜퀝퀞퀟퀠퀡퀢퀣퀤퀥퀦퀧퀨퀩퀪퀫퀬끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫났낭낮낯낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "�����������������������������������������������������������������퀮퀯퀰퀱퀲퀳퀶퀷퀹퀺퀻퀽퀾퀿큀큁큂큃큆큈큊큋큌큍큎큏������큑큒큓큕큖큗큙큚큛큜큝큞큟큡큢큣큤큥큦큧큨큩큪큫큮큯������큱큲큳큵큶큷큸큹큺큻큾큿킀킂킃킄킅킆킇킈킉킊킋킌킍킎킏킐킑킒킓킔뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫달닭닮닯닳담답닷닸당닺닻닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "�����������������������������������������������������������������킕킖킗킘킙킚킛킜킝킞킟킠킡킢킣킦킧킩킪킫킭킮킯킰킱킲������킳킶킸킺킻킼킽킾킿탂탃탅탆탇탊탋탌탍탎탏탒탖탗탘탙탚������탛탞탟탡탢탣탥탦탧탨탩탪탫탮탲탳탴탵탶탷탹탺탻탼탽탾탿턀턁턂턃턄덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "�����������������������������������������������������������������턅턆턇턈턉턊턋턌턎턏턐턑턒턓턔턕턖턗턘턙턚턛턜턝턞턟������턠턡턢턣턤턥턦턧턨턩턪턫턬턭턮턯턲턳턵턶턷턹턻턼턽턾������턿텂텆텇텈텉텊텋텎텏텑텒텓텕텖텗텘텙텚텛텞텠텢텣텤텥텦텧텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "�����������������������������������������������������������������텮텯텰텱텲텳텴텵텶텷텸텹텺텻텽텾텿톀톁톂톃톅톆톇톉톊������톋톌톍톎톏톐톑톒톓톔톕톖톗톘톙톚톛톜톝톞톟톢톣톥톦톧������톩톪톫톬톭톮톯톲톴톶톷톸톹톻톽톾톿퇁퇂퇃퇄퇅퇆퇇퇈퇉퇊퇋퇌퇍퇎퇏래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "�����������������������������������������������������������������퇐퇑퇒퇓퇔퇕퇖퇗퇙퇚퇛퇜퇝퇞퇟퇠퇡퇢퇣퇤퇥퇦퇧퇨퇩퇪������퇫퇬퇭퇮퇯퇰퇱퇲퇳퇵퇶퇷퇹퇺퇻퇼퇽퇾퇿툀툁툂툃툄툅툆������툈툊툋툌툍툎툏툑툒툓툔툕툖툗툘툙툚툛툜툝툞툟툠툡툢툣툤툥툦툧툨툩륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많맏말맑맒맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "�����������������������������������������������������������������툪툫툮툯툱툲툳툵툶툷툸툹툺툻툾퉀퉂퉃퉄퉅퉆퉇퉉퉊퉋퉌������퉍퉎퉏퉐퉑퉒퉓퉔퉕퉖퉗퉘퉙퉚퉛퉝퉞퉟퉠퉡퉢퉣퉥퉦퉧퉨������퉩퉪퉫퉬퉭퉮퉯퉰퉱퉲퉳퉴퉵퉶퉷퉸퉹퉺퉻퉼퉽퉾퉿튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바박밖밗반받발밝밞밟밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "�����������������������������������������������������������������튍튎튏튒튓튔튖튗튘튙튚튛튝튞튟튡튢튣튥튦튧튨튩튪튫튭������튮튯튰튲튳튴튵튶튷튺튻튽튾틁틃틄틅틆틇틊틌틍틎틏틐틑������틒틓틕틖틗틙틚틛틝틞틟틠틡틢틣틦틧틨틩틪틫틬틭틮틯틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "�����������������������������������������������������������������틻틼틽틾틿팂팄팆팇팈팉팊팋팏팑팒팓팕팗팘팙팚팛팞팢팣������팤팦팧팪팫팭팮팯팱팲팳팴팵팶팷팺팾팿퍀퍁퍂퍃퍆퍇퍈퍉������퍊퍋퍌퍍퍎퍏퍐퍑퍒퍓퍔퍕퍖퍗퍘퍙퍚퍛퍜퍝퍞퍟퍠퍡퍢퍣퍤퍥퍦퍧퍨퍩빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "�����������������������������������������������������������������퍪퍫퍬퍭퍮퍯퍰퍱퍲퍳퍴퍵퍶퍷퍸퍹퍺퍻퍾퍿펁펂펃펅펆펇������펈펉펊펋펎펒펓펔펕펖펗펚펛펝펞펟펡펢펣펤펥펦펧펪펬펮������펯펰펱펲펳펵펶펷펹펺펻펽펾펿폀폁폂폃폆폇폊폋폌폍폎폏폑폒폓폔폕폖샥샨샬샴샵샷샹섀섄섈섐섕서석섞섟선섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "�����������������������������������������������������������������폗폙폚폛폜폝폞폟폠폢폤폥폦폧폨폩폪폫폮폯폱폲폳폵폶폷������폸폹폺폻폾퐀퐂퐃퐄퐅퐆퐇퐉퐊퐋퐌퐍퐎퐏퐐퐑퐒퐓퐔퐕퐖������퐗퐘퐙퐚퐛퐜퐞퐟퐠퐡퐢퐣퐤퐥퐦퐧퐨퐩퐪퐫퐬퐭퐮퐯퐰퐱퐲퐳퐴퐵퐶퐷숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "�����������������������������������������������������������������퐸퐹퐺퐻퐼퐽퐾퐿푁푂푃푅푆푇푈푉푊푋푌푍푎푏푐푑푒푓������푔푕푖푗푘푙푚푛푝푞푟푡푢푣푥푦푧푨푩푪푫푬푮푰푱푲������푳푴푵푶푷푺푻푽푾풁풃풄풅풆풇풊풌풎풏풐풑풒풓풕풖풗풘풙풚풛풜풝쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄업없엇었엉엊엌엎�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "�����������������������������������������������������������������풞풟풠풡풢풣풤풥풦풧풨풪풫풬풭풮풯풰풱풲풳풴풵풶풷풸������풹풺풻풼풽풾풿퓀퓁퓂퓃퓄퓅퓆퓇퓈퓉퓊퓋퓍퓎퓏퓑퓒퓓퓕������퓖퓗퓘퓙퓚퓛퓝퓞퓠퓡퓢퓣퓤퓥퓦퓧퓩퓪퓫퓭퓮퓯퓱퓲퓳퓴퓵퓶퓷퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염엽엾엿였영옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "�����������������������������������������������������������������퓾퓿픀픁픂픃픅픆픇픉픊픋픍픎픏픐픑픒픓픖픘픙픚픛픜픝������픞픟픠픡픢픣픤픥픦픧픨픩픪픫픬픭픮픯픰픱픲픳픴픵픶픷������픸픹픺픻픾픿핁핂핃핅핆핇핈핉핊핋핎핐핒핓핔핕핖핗핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응읒읓읔읕읖읗의읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "�����������������������������������������������������������������핤핦핧핪핬핮핯핰핱핲핳핶핷핹핺핻핽핾핿햀햁햂햃햆햊햋������햌햍햎햏햑햒햓햔햕햖햗햘햙햚햛햜햝햞햟햠햡햢햣햤햦햧������햨햩햪햫햬햭햮햯햰햱햲햳햴햵햶햷햸햹햺햻햼햽햾햿헀헁헂헃헄헅헆헇점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "�����������������������������������������������������������������헊헋헍헎헏헑헓헔헕헖헗헚헜헞헟헠헡헢헣헦헧헩헪헫헭헮������헯헰헱헲헳헶헸헺헻헼헽헾헿혂혃혅혆혇혉혊혋혌혍혎혏혒������혖혗혘혙혚혛혝혞혟혡혢혣혥혦혧혨혩혪혫혬혮혯혰혱혲혳혴혵혶혷혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "�����������������������������������������������������������������혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝홞홟홠홡������홢홣홤홥홦홨홪홫홬홭홮홯홲홳홵홶홷홸홹홺홻홼홽홾홿횀������횁횂횄횆횇횈횉횊횋횎횏횑횒횓횕횖횗횘횙횚횛횜횞횠횢횣횤횥횦횧횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "�����������������������������������������������������������������횫횭횮횯횱횲횳횴횵횶횷횸횺횼횽횾횿훀훁훂훃훆훇훉훊훋������훍훎훏훐훒훓훕훖훘훚훛훜훝훞훟훡훢훣훥훦훧훩훪훫훬훭������훮훯훱훲훳훴훶훷훸훹훺훻훾훿휁휂휃휅휆휇휈휉휊휋휌휍휎휏휐휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "�����������������������������������������������������������������휕휖휗휚휛휝휞휟휡휢휣휤휥휦휧휪휬휮휯휰휱휲휳휶휷휹������휺휻휽휾휿흀흁흂흃흅흆흈흊흋흌흍흎흏흒흓흕흚흛흜흝흞������흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵흶흷흸흹흺흻흾흿힀힂힃힄힅힆힇힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "�����������������������������������������������������������������힍힎힏힑힒힓힔힕힖힗힚힜힞힟힠힡힢힣������������������������������������������������������������������������������퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩羅蘿螺裸邏那樂洛烙珞落諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������納臘蠟衲囊娘廊朗浪狼郎乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧老蘆虜路露駑魯鷺碌祿綠菉錄鹿論壟弄濃籠聾膿農惱牢磊腦賂雷尿壘屢樓淚漏累縷陋嫩訥杻紐勒肋凜凌稜綾能菱陵尼泥匿溺多茶�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬�".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃�".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航�".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	D[250] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型�".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵�".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆�".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	D[253] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰�".split("");
	for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
	return {"enc": e, "dec": d }; })();
	cptable[950] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[161] = "����������������������������������������������������������������　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚����������������������������������﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢﹣﹤﹥﹦～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "����������������������������������������������������������������＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁▂▃▄▅▆▇█▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭����������������������������������╮╰╯═╞╪╡◢◣◥◤╱╲╳０１２３４５６７８９ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ〡〢〣〤〥〦〧〨〩十卄卅ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖ�".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "����������������������������������������������������������������ｗｘｙｚΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏ����������������������������������ㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ˙ˉˊˇˋ���������������������������������€������������������������������".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "����������������������������������������������������������������一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才����������������������������������丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙�".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "����������������������������������������������������������������世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外����������������������������������央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全�".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "����������������������������������������������������������������共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年����������������������������������式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣�".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "����������������������������������������������������������������作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍����������������������������������均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠�".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "����������������������������������������������������������������杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒����������������������������������芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵�".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "����������������������������������������������������������������咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居����������������������������������屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊�".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "����������������������������������������������������������������昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠����������������������������������炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附�".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "����������������������������������������������������������������陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品����������������������������������哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷�".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "����������������������������������������������������������������拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗����������������������������������活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄�".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "����������������������������������������������������������������耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥����������������������������������迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪�".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "����������������������������������������������������������������哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙����������������������������������恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓�".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "����������������������������������������������������������������浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷����������������������������������砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃�".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "����������������������������������������������������������������虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡����������������������������������陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "����������������������������������������������������������������娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽����������������������������������情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "����������������������������������������������������������������毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶����������������������������������瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "����������������������������������������������������������������莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途����������������������������������部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "����������������������������������������������������������������婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍����������������������������������插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "����������������������������������������������������������������溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘����������������������������������窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "����������������������������������������������������������������詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑����������������������������������間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "����������������������������������������������������������������媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業����������������������������������楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "����������������������������������������������������������������睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫����������������������������������腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "����������������������������������������������������������������辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴����������������������������������飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "����������������������������������������������������������������愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢����������������������������������滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "����������������������������������������������������������������罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤����������������������������������說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "����������������������������������������������������������������劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂����������������������������������慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "����������������������������������������������������������������瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯����������������������������������翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "����������������������������������������������������������������輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉����������������������������������鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "����������������������������������������������������������������濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊����������������������������������縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "����������������������������������������������������������������錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇����������������������������������嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "����������������������������������������������������������������瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪����������������������������������薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "����������������������������������������������������������������駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘����������������������������������癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "����������������������������������������������������������������鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸����������������������������������獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "����������������������������������������������������������������願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼����������������������������������纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "����������������������������������������������������������������護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬����������������������������������禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "����������������������������������������������������������������讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲���������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[201] = "����������������������������������������������������������������乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕����������������������������������氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "����������������������������������������������������������������汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘����������������������������������吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "����������������������������������������������������������������杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓����������������������������������芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "����������������������������������������������������������������坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋����������������������������������怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "����������������������������������������������������������������泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺����������������������������������矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "����������������������������������������������������������������哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛����������������������������������峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "����������������������������������������������������������������柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂����������������������������������洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "����������������������������������������������������������������穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪����������������������������������苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "����������������������������������������������������������������唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧����������������������������������恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "����������������������������������������������������������������毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸����������������������������������牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "����������������������������������������������������������������笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢����������������������������������荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "����������������������������������������������������������������酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅����������������������������������唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "����������������������������������������������������������������崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟����������������������������������捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "����������������������������������������������������������������淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏����������������������������������痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "����������������������������������������������������������������耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷����������������������������������蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪�".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "����������������������������������������������������������������釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷����������������������������������堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "����������������������������������������������������������������惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒����������������������������������晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "����������������������������������������������������������������湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖����������������������������������琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "����������������������������������������������������������������罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳����������������������������������菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "����������������������������������������������������������������軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈����������������������������������隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "����������������������������������������������������������������媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤����������������������������������搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "����������������������������������������������������������������毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓����������������������������������煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "����������������������������������������������������������������稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯����������������������������������腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "����������������������������������������������������������������觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿����������������������������������遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠����������������������������������寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊����������������������������������漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞����������������������������������耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍����������������������������������銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉����������������������������������憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙����������������������������������獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢����������������������������������蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓����������������������������������銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺����������������������������������憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙����������������������������������瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "����������������������������������������������������������������蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠����������������������������������諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "����������������������������������������������������������������錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕����������������������������������魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "����������������������������������������������������������������檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶����������������������������������瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞����������������������������������謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "����������������������������������������������������������������鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰����������������������������������鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "����������������������������������������������������������������璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒����������������������������������臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "����������������������������������������������������������������蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪����������������������������������鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "����������������������������������������������������������������徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛����������������������������������礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "����������������������������������������������������������������譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦����������������������������������鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "����������������������������������������������������������������嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩����������������������������������禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "����������������������������������������������������������������鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛����������������������������������鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "����������������������������������������������������������������蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺����������������������������������騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "����������������������������������������������������������������糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊����������������������������������驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "����������������������������������������������������������������讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏����������������������������������齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚�".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "����������������������������������������������������������������纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊����������������������������������龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓�".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	return {"enc": e, "dec": d }; })();
	cptable[1250] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1251] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1252] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1253] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1254] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1255] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹ�ֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1256] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1257] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1258] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10000] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10006] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10007] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10008] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。・ˉˇ¨〃々―～�…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������������������������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω���������������������������������������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüê����������ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "��������������������������������������������������������������������������������������������������������������������������������������������������������������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[176] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[201] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	return {"enc": e, "dec": d }; })();
	cptable[10029] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10079] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10081] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[28591] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	// eslint-disable-next-line no-undef
	if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = cptable;
	/*! cputils.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ft=javascript: */
	/*jshint newcap: false */
	(function(root, factory) {
	  /*jshint ignore:start */
	  /*eslint-disable */
	  "use strict";
	  if(typeof cptable === "undefined") {
	    if(true){
	      var cpt = cptable;
	      if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = factory(cpt);
	      else root.cptable = factory(cpt);
	    } else throw new Error("cptable not found");
	  } else cptable = factory(cptable);
	  /*eslint-enable */
	  /*jshint ignore:end */
	}(this, function(cpt){
	  "use strict";
	  /*global module, Buffer */
	  var magic = {
	    "1200":"utf16le",
	    "1201":"utf16be",
	    "12000":"utf32le",
	    "12001":"utf32be",
	    "16969":"utf64le",
	    "20127":"ascii",
	    "65000":"utf7",
	    "65001":"utf8"
	  };
	
	  var sbcs_cache = [874,1250,1251,1252,1253,1254,1255,1256,10000];
	  var dbcs_cache = [932,936,949,950];
	  var magic_cache = [65001];
	  var magic_decode = {};
	  var magic_encode = {};
	  var cpdcache = {};
	  var cpecache = {};
	
	  var sfcc = function sfcc(x) { return String.fromCharCode(x); };
	  var cca = function cca(x) { return x.charCodeAt(0); };
	
	  var has_buf = (typeof Buffer !== 'undefined');
	  var Buffer_from = function(){};
	  if(has_buf) {
	    var nbfs = !Buffer.from;
	    if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
	    Buffer_from = nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
	    // $FlowIgnore
	    if(!Buffer.allocUnsafe) Buffer.allocUnsafe = function(n) { return new Buffer(n); };
	
	    var mdl = 1024, mdb = Buffer.allocUnsafe(mdl);
	    var make_EE = function make_EE(E){
	      var EE = Buffer.allocUnsafe(65536);
	      for(var i = 0; i < 65536;++i) EE[i] = 0;
	      var keys = Object.keys(E), len = keys.length;
	      for(var ee = 0, e = keys[ee]; ee < len; ++ee) {
	        if(!(e = keys[ee])) continue;
	        EE[e.charCodeAt(0)] = E[e];
	      }
	      return EE;
	    };
	    var sbcs_encode = function make_sbcs_encode(cp) {
	      var EE = make_EE(cpt[cp].enc);
	      return function sbcs_e(data, ofmt) {
	        var len = data.length;
	        var out, i=0, j=0, D=0, w=0;
	        if(typeof data === 'string') {
	          out = Buffer.allocUnsafe(len);
	          for(i = 0; i < len; ++i) out[i] = EE[data.charCodeAt(i)];
	        } else if(Buffer.isBuffer(data)) {
	          out = Buffer.allocUnsafe(2*len);
	          j = 0;
	          for(i = 0; i < len; ++i) {
	            D = data[i];
	            if(D < 128) out[j++] = EE[D];
	            else if(D < 224) { out[j++] = EE[((D&31)<<6)+(data[i+1]&63)]; ++i; }
	            else if(D < 240) { out[j++] = EE[((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63)]; i+=2; }
	            else {
	              w = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3;
	              if(w < 65536) out[j++] = EE[w];
	              else { w -= 65536; out[j++] = EE[0xD800 + ((w>>10)&1023)]; out[j++] = EE[0xDC00 + (w&1023)]; }
	            }
	          }
	          out = out.slice(0,j);
	        } else {
	          out = Buffer.allocUnsafe(len);
	          for(i = 0; i < len; ++i) out[i] = EE[data[i].charCodeAt(0)];
	        }
	        if(!ofmt || ofmt === 'buf') return out;
	        if(ofmt !== 'arr') return out.toString('binary');
	        return [].slice.call(out);
	      };
	    };
	    var sbcs_decode = function make_sbcs_decode(cp) {
	      var D = cpt[cp].dec;
	      var DD = Buffer.allocUnsafe(131072), d=0, c="";
	      for(d=0;d<D.length;++d) {
	        if(!(c=D[d])) continue;
	        var w = c.charCodeAt(0);
	        DD[2*d] = w&255; DD[2*d+1] = w>>8;
	      }
	      return function sbcs_d(data) {
	        var len = data.length, i=0, j=0;
	        if(2 * len > mdl) { mdl = 2 * len; mdb = Buffer.allocUnsafe(mdl); }
	        if(Buffer.isBuffer(data)) {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        } else if(typeof data === "string") {
	          for(i = 0; i < len; i++) {
	            j = 2*data.charCodeAt(i);
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        } else {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        }
	        return mdb.slice(0, 2 * len).toString('ucs2');
	      };
	    };
	    var dbcs_encode = function make_dbcs_encode(cp) {
	      var E = cpt[cp].enc;
	      var EE = Buffer.allocUnsafe(131072);
	      for(var i = 0; i < 131072; ++i) EE[i] = 0;
	      var keys = Object.keys(E);
	      for(var ee = 0, e = keys[ee]; ee < keys.length; ++ee) {
	        if(!(e = keys[ee])) continue;
	        var f = e.charCodeAt(0);
	        EE[2*f] = E[e] & 255; EE[2*f+1] = E[e]>>8;
	      }
	      return function dbcs_e(data, ofmt) {
	        var len = data.length, out = Buffer.allocUnsafe(2*len), i=0, j=0, jj=0, k=0, D=0;
	        if(typeof data === 'string') {
	          for(i = k = 0; i < len; ++i) {
	            j = data.charCodeAt(i)*2;
	            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	          }
	          out = out.slice(0,k);
	        } else if(Buffer.isBuffer(data)) {
	          for(i = k = 0; i < len; ++i) {
	            D = data[i];
	            if(D < 128) j = D;
	            else if(D < 224) { j = ((D&31)<<6)+(data[i+1]&63); ++i; }
	            else if(D < 240) { j = ((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63); i+=2; }
	            else { j = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3; }
	            if(j<65536) { j*=2; out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j]; }
	            else { jj = j-65536;
	              j=2*(0xD800 + ((jj>>10)&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	              j=2*(0xDC00 + (jj&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	            }
	          }
	          out = out.slice(0,k);
	        } else {
	          for(i = k = 0; i < len; i++) {
	            j = data[i].charCodeAt(0)*2;
	            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	          }
	        }
	        if(!ofmt || ofmt === 'buf') return out;
	        if(ofmt !== 'arr') return out.toString('binary');
	        return [].slice.call(out);
	      };
	    };
	    var dbcs_decode = function make_dbcs_decode(cp) {
	      var D = cpt[cp].dec;
	      var DD = Buffer.allocUnsafe(131072), d=0, c, w=0, j=0, i=0;
	      for(i = 0; i < 65536; ++i) { DD[2*i] = 0xFF; DD[2*i+1] = 0xFD;}
	      for(d = 0; d < D.length; ++d) {
	        if(!(c=D[d])) continue;
	        w = c.charCodeAt(0);
	        j = 2*d;
	        DD[j] = w&255; DD[j+1] = w>>8;
	      }
	      return function dbcs_d(data) {
	        var len = data.length, out = Buffer.allocUnsafe(2*len), i=0, j=0, k=0;
	        if(Buffer.isBuffer(data)) {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        } else if(typeof data === "string") {
	          for(i = 0; i < len; i++) {
	            j = 2*data.charCodeAt(i);
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data.charCodeAt(i)<<8)+data.charCodeAt(i+1)); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        } else {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        }
	        return out.slice(0,k).toString('ucs2');
	      };
	    };
	    magic_decode[65001] = function utf8_d(data) {
	      if(typeof data === "string") return utf8_d(data.split("").map(cca));
	      var len = data.length, w = 0, ww = 0;
	      if(4 * len > mdl) { mdl = 4 * len; mdb = Buffer.allocUnsafe(mdl); }
	      var i = 0;
	      if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
	      for(var j = 1, k = 0, D = 0; i < len; i+=j) {
	        j = 1; D = data[i];
	        if(D < 128) w = D;
	        else if(D < 224) { w=(D&31)*64+(data[i+1]&63); j=2; }
	        else if(D < 240) { w=((D&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
	        else { w=(D&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
	        if(w < 65536) { mdb[k++] = w&255; mdb[k++] = w>>8; }
	        else {
	          w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
	          mdb[k++] = ww&255; mdb[k++] = ww>>>8; mdb[k++] = w&255; mdb[k++] = (w>>>8)&255;
	        }
	      }
	      return mdb.slice(0,k).toString('ucs2');
	    };
	    magic_encode[65001] = function utf8_e(data, ofmt) {
	      if(has_buf && Buffer.isBuffer(data)) {
	        if(!ofmt || ofmt === 'buf') return data;
	        if(ofmt !== 'arr') return data.toString('binary');
	        return [].slice.call(data);
	      }
	      var len = data.length, w = 0, ww = 0, j = 0;
	      var direct = typeof data === "string";
	      if(4 * len > mdl) { mdl = 4 * len; mdb = Buffer.allocUnsafe(mdl); }
	      for(var i = 0; i < len; ++i) {
	        w = direct ? data.charCodeAt(i) : data[i].charCodeAt(0);
	        if(w <= 0x007F) mdb[j++] = w;
	        else if(w <= 0x07FF) {
	          mdb[j++] = 192 + (w >> 6);
	          mdb[j++] = 128 + (w&63);
	        } else if(w >= 0xD800 && w <= 0xDFFF) {
	          w -= 0xD800; ++i;
	          ww = (direct ? data.charCodeAt(i) : data[i].charCodeAt(0)) - 0xDC00 + (w << 10);
	          mdb[j++] = 240 + ((ww>>>18) & 0x07);
	          mdb[j++] = 144 + ((ww>>>12) & 0x3F);
	          mdb[j++] = 128 + ((ww>>>6) & 0x3F);
	          mdb[j++] = 128 + (ww & 0x3F);
	        } else {
	          mdb[j++] = 224 + (w >> 12);
	          mdb[j++] = 128 + ((w >> 6)&63);
	          mdb[j++] = 128 + (w&63);
	        }
	      }
	      if(!ofmt || ofmt === 'buf') return mdb.slice(0,j);
	      if(ofmt !== 'arr') return mdb.slice(0,j).toString('binary');
	      return [].slice.call(mdb, 0, j);
	    };
	  }
	
	  var encache = function encache() {
	    if(has_buf) {
	      if(cpdcache[sbcs_cache[0]]) return;
	      var i=0, s=0;
	      for(i = 0; i < sbcs_cache.length; ++i) {
	        s = sbcs_cache[i];
	        if(cpt[s]) {
	          cpdcache[s] = sbcs_decode(s);
	          cpecache[s] = sbcs_encode(s);
	        }
	      }
	      for(i = 0; i < dbcs_cache.length; ++i) {
	        s = dbcs_cache[i];
	        if(cpt[s]) {
	          cpdcache[s] = dbcs_decode(s);
	          cpecache[s] = dbcs_encode(s);
	        }
	      }
	      for(i = 0; i < magic_cache.length; ++i) {
	        s = magic_cache[i];
	        if(magic_decode[s]) cpdcache[s] = magic_decode[s];
	        if(magic_encode[s]) cpecache[s] = magic_encode[s];
	      }
	    }
	  };
	  var null_enc = function(data, ofmt) { void ofmt; return ""; };
	  var cp_decache = function cp_decache(cp) { delete cpdcache[cp]; delete cpecache[cp]; };
	  var decache = function decache() {
	    if(has_buf) {
	      if(!cpdcache[sbcs_cache[0]]) return;
	      sbcs_cache.forEach(cp_decache);
	      dbcs_cache.forEach(cp_decache);
	      magic_cache.forEach(cp_decache);
	    }
	    last_enc = null_enc; last_cp = 0;
	  };
	  var cache = {
	    encache: encache,
	    decache: decache,
	    sbcs: sbcs_cache,
	    dbcs: dbcs_cache
	  };
	
	  encache();
	
	  var BM = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	  var SetD = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?";
	  var last_enc = null_enc, last_cp = 0;
	  var encode = function encode(cp, data, ofmt) {
	    if(cp === last_cp && last_enc) { return last_enc(data, ofmt); }
	    if(cpecache[cp]) { last_enc = cpecache[last_cp=cp]; return last_enc(data, ofmt); }
	    if(has_buf && Buffer.isBuffer(data)) data = data.toString('utf8');
	    var len = data.length;
	    var out = has_buf ? Buffer.allocUnsafe(4*len) : [], w=0, i=0, j = 0, ww=0;
	    var C = cpt[cp], E, M = "";
	    var isstr = typeof data === 'string';
	    if(C && (E=C.enc)) for(i = 0; i < len; ++i, ++j) {
	      w = E[isstr? data.charAt(i) : data[i]];
	      if(w > 255) {
	        out[j] = w>>8;
	        out[++j] = w&255;
	      } else out[j] = w&255;
	    }
	    else if((M=magic[cp])) switch(M) {
	      case "utf8":
	        if(has_buf && isstr) { out = Buffer_from(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i, ++j) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w <= 0x007F) out[j] = w;
	          else if(w <= 0x07FF) {
	            out[j]   = 192 + (w >> 6);
	            out[++j] = 128 + (w&63);
	          } else if(w >= 0xD800 && w <= 0xDFFF) {
	            w -= 0xD800;
	            ww = (isstr ? data.charCodeAt(++i) : data[++i].charCodeAt(0)) - 0xDC00 + (w << 10);
	            out[j]   = 240 + ((ww>>>18) & 0x07);
	            out[++j] = 144 + ((ww>>>12) & 0x3F);
	            out[++j] = 128 + ((ww>>>6) & 0x3F);
	            out[++j] = 128 + (ww & 0x3F);
	          } else {
	            out[j]   = 224 + (w >> 12);
	            out[++j] = 128 + ((w >> 6)&63);
	            out[++j] = 128 + (w&63);
	          }
	        }
	        break;
	      case "ascii":
	        if(has_buf && typeof data === "string") { out = Buffer_from(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i, ++j) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w <= 0x007F) out[j] = w;
	          else throw new Error("bad ascii " + w);
	        }
	        break;
	      case "utf16le":
	        if(has_buf && typeof data === "string") { out = Buffer_from(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          out[j++] = w&255;
	          out[j++] = w>>8;
	        }
	        break;
	      case "utf16be":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          out[j++] = w>>8;
	          out[j++] = w&255;
	        }
	        break;
	      case "utf32le":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255;
	        }
	        break;
	      case "utf32be":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
	          out[j+3] = w&255; w >>= 8;
	          out[j+2] = w&255; w >>= 8;
	          out[j+1] = w&255; w >>= 8;
	          out[j] = w&255;
	          j+=4;
	        }
	        break;
	      case "utf7":
	        for(i = 0; i < len; i++) {
	          var c = isstr ? data.charAt(i) : data[i].charAt(0);
	          if(c === "+") { out[j++] = 0x2b; out[j++] = 0x2d; continue; }
	          if(SetD.indexOf(c) > -1) { out[j++] = c.charCodeAt(0); continue; }
	          var tt = encode(1201, c);
	          out[j++] = 0x2b;
	          out[j++] = BM.charCodeAt(tt[0]>>2);
	          out[j++] = BM.charCodeAt(((tt[0]&0x03)<<4) + ((tt[1]||0)>>4));
	          out[j++] = BM.charCodeAt(((tt[1]&0x0F)<<2) + ((tt[2]||0)>>6));
	          out[j++] = 0x2d;
	        }
	        break;
	      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
	    }
	    else throw new Error("Unrecognized CP: " + cp);
	    out = out.slice(0,j);
	    if(!has_buf) return (ofmt == 'str') ? (out).map(sfcc).join("") : out;
	    if(!ofmt || ofmt === 'buf') return out;
	    if(ofmt !== 'arr') return out.toString('binary');
	    return [].slice.call(out);
	  };
	  var decode = function decode(cp, data) {
	    var F; if((F=cpdcache[cp])) return F(data);
	    if(typeof data === "string") return decode(cp, data.split("").map(cca));
	    var len = data.length, out = new Array(len), s="", w=0, i=0, j=1, k=0, ww=0;
	    var C = cpt[cp], D, M="";
	    if(C && (D=C.dec)) {
	      for(i = 0; i < len; i+=j) {
	        j = 2;
	        s = D[(data[i]<<8)+ data[i+1]];
	        if(!s) {
	          j = 1;
	          s = D[data[i]];
	        }
	        if(!s) throw new Error('Unrecognized code: ' + data[i] + ' ' + data[i+j-1] + ' ' + i + ' ' + j + ' ' + D[data[i]]);
	        out[k++] = s;
	      }
	    }
	    else if((M=magic[cp])) switch(M) {
	      case "utf8":
	        if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
	        for(; i < len; i+=j) {
	          j = 1;
	          if(data[i] < 128) w = data[i];
	          else if(data[i] < 224) { w=(data[i]&31)*64+(data[i+1]&63); j=2; }
	          else if(data[i] < 240) { w=((data[i]&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
	          else { w=(data[i]&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
	          if(w < 65536) { out[k++] = String.fromCharCode(w); }
	          else {
	            w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
	            out[k++] = String.fromCharCode(ww); out[k++] = String.fromCharCode(w);
	          }
	        }
	        break;
	      case "ascii":
	        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
	        for(i = 0; i < len; i++) out[i] = String.fromCharCode(data[i]);
	        k = len; break;
	      case "utf16le":
	        if(len >= 2 && data[0] == 0xFF) if(data[1] == 0xFE) i = 2;
	        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
	        j = 2;
	        for(; i+1 < len; i+=j) {
	          out[k++] = String.fromCharCode((data[i+1]<<8) + data[i]);
	        }
	        break;
	      case "utf16be":
	        if(len >= 2 && data[0] == 0xFE) if(data[1] == 0xFF) i = 2;
	        j = 2;
	        for(; i+1 < len; i+=j) {
	          out[k++] = String.fromCharCode((data[i]<<8) + data[i+1]);
	        }
	        break;
	      case "utf32le":
	        if(len >= 4 && data[0] == 0xFF) if(data[1] == 0xFE && data[2] === 0 && data[3] === 0) i = 4;
	        j = 4;
	        for(; i < len; i+=j) {
	          w = (data[i+3]<<24) + (data[i+2]<<16) + (data[i+1]<<8) + (data[i]);
	          if(w > 0xFFFF) {
	            w -= 0x10000;
	            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
	            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
	          }
	          else out[k++] = String.fromCharCode(w);
	        }
	        break;
	      case "utf32be":
	        if(len >= 4 && data[3] == 0xFF) if(data[2] == 0xFE && data[1] === 0 && data[0] === 0) i = 4;
	        j = 4;
	        for(; i < len; i+=j) {
	          w = (data[i]<<24) + (data[i+1]<<16) + (data[i+2]<<8) + (data[i+3]);
	          if(w > 0xFFFF) {
	            w -= 0x10000;
	            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
	            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
	          }
	          else out[k++] = String.fromCharCode(w);
	        }
	        break;
	      case "utf7":
	        if(len >= 4 && data[0] == 0x2B && data[1] == 0x2F && data[2] == 0x76) {
	          if(len >= 5 && data[3] == 0x38 && data[4] == 0x2D) i = 5;
	          else if(data[3] == 0x38 || data[3] == 0x39 || data[3] == 0x2B || data[3] == 0x2F) i = 4;
	        }
	        for(; i < len; i+=j) {
	          if(data[i] !== 0x2b) { j=1; out[k++] = String.fromCharCode(data[i]); continue; }
	          j=1;
	          if(data[i+1] === 0x2d) { j = 2; out[k++] = "+"; continue; }
	          // eslint-disable-next-line no-useless-escape
	          while(String.fromCharCode(data[i+j]).match(/[A-Za-z0-9+\/]/)) j++;
	          var dash = 0;
	          if(data[i+j] === 0x2d) { ++j; dash=1; }
	          var tt = [];
	          var o64 = "";
	          var c1=0, c2=0, c3=0;
	          var e1=0, e2=0, e3=0, e4=0;
	          for(var l = 1; l < j - dash;) {
	            e1 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            e2 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            c1 = e1 << 2 | e2 >> 4;
	            tt.push(c1);
	            e3 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            if(e3 === -1) break;
	            c2 = (e2 & 15) << 4 | e3 >> 2;
	            tt.push(c2);
	            e4 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            if(e4 === -1) break;
	            c3 = (e3 & 3) << 6 | e4;
	            if(e4 < 64) tt.push(c3);
	          }
	          o64 = decode(1201, tt);
	          for(l = 0; l < o64.length; ++l) out[k++] = o64.charAt(l);
	        }
	        break;
	      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
	    }
	    else throw new Error("Unrecognized CP: " + cp);
	    return out.slice(0,k).join("");
	  };
	  var hascp = function hascp(cp) { return !!(cpt[cp] || magic[cp]); };
	  cpt.utils = { decode: decode, encode: encode, hascp: hascp, magic: magic, cache:cache };
	  return cpt;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39).Buffer))

/***/ },
/* 7340 */
790,
/* 7341 */
790,
/* 7342 */
790,
/* 7343 */
790,
/* 7344 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.81883ace.js